/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1);
	module.exports = __webpack_require__(298);


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	__webpack_require__(2);
	
	__webpack_require__(293);
	
	__webpack_require__(295);
	
	/* eslint max-len: 0 */
	
	if (global._babelPolyfill) {
	  throw new Error("only one instance of babel-polyfill is allowed");
	}
	global._babelPolyfill = true;
	
	// Should be removed in the next major release:
	
	var DEFINE_PROPERTY = "defineProperty";
	function define(O, key, value) {
	  O[key] || Object[DEFINE_PROPERTY](O, key, {
	    writable: true,
	    configurable: true,
	    value: value
	  });
	}
	
	define(String.prototype, "padLeft", "".padStart);
	define(String.prototype, "padRight", "".padEnd);
	
	"pop,reverse,shift,keys,values,entries,indexOf,every,some,forEach,map,filter,find,findIndex,includes,join,slice,concat,push,splice,unshift,sort,lastIndexOf,reduce,reduceRight,copyWithin,fill".split(",").forEach(function (key) {
	  [][key] && define(Array, key, Function.call.bind([][key]));
	});
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(3);
	__webpack_require__(52);
	__webpack_require__(53);
	__webpack_require__(54);
	__webpack_require__(55);
	__webpack_require__(57);
	__webpack_require__(60);
	__webpack_require__(61);
	__webpack_require__(62);
	__webpack_require__(63);
	__webpack_require__(64);
	__webpack_require__(65);
	__webpack_require__(66);
	__webpack_require__(67);
	__webpack_require__(68);
	__webpack_require__(70);
	__webpack_require__(72);
	__webpack_require__(74);
	__webpack_require__(76);
	__webpack_require__(79);
	__webpack_require__(80);
	__webpack_require__(81);
	__webpack_require__(85);
	__webpack_require__(87);
	__webpack_require__(89);
	__webpack_require__(92);
	__webpack_require__(93);
	__webpack_require__(94);
	__webpack_require__(95);
	__webpack_require__(97);
	__webpack_require__(98);
	__webpack_require__(99);
	__webpack_require__(100);
	__webpack_require__(101);
	__webpack_require__(102);
	__webpack_require__(103);
	__webpack_require__(105);
	__webpack_require__(106);
	__webpack_require__(107);
	__webpack_require__(109);
	__webpack_require__(110);
	__webpack_require__(111);
	__webpack_require__(113);
	__webpack_require__(114);
	__webpack_require__(115);
	__webpack_require__(116);
	__webpack_require__(117);
	__webpack_require__(118);
	__webpack_require__(119);
	__webpack_require__(120);
	__webpack_require__(121);
	__webpack_require__(122);
	__webpack_require__(123);
	__webpack_require__(124);
	__webpack_require__(125);
	__webpack_require__(126);
	__webpack_require__(131);
	__webpack_require__(132);
	__webpack_require__(136);
	__webpack_require__(137);
	__webpack_require__(138);
	__webpack_require__(139);
	__webpack_require__(141);
	__webpack_require__(142);
	__webpack_require__(143);
	__webpack_require__(144);
	__webpack_require__(145);
	__webpack_require__(146);
	__webpack_require__(147);
	__webpack_require__(148);
	__webpack_require__(149);
	__webpack_require__(150);
	__webpack_require__(151);
	__webpack_require__(152);
	__webpack_require__(153);
	__webpack_require__(154);
	__webpack_require__(155);
	__webpack_require__(156);
	__webpack_require__(157);
	__webpack_require__(159);
	__webpack_require__(160);
	__webpack_require__(166);
	__webpack_require__(167);
	__webpack_require__(169);
	__webpack_require__(170);
	__webpack_require__(171);
	__webpack_require__(175);
	__webpack_require__(176);
	__webpack_require__(177);
	__webpack_require__(178);
	__webpack_require__(179);
	__webpack_require__(181);
	__webpack_require__(182);
	__webpack_require__(183);
	__webpack_require__(184);
	__webpack_require__(187);
	__webpack_require__(189);
	__webpack_require__(190);
	__webpack_require__(191);
	__webpack_require__(193);
	__webpack_require__(195);
	__webpack_require__(197);
	__webpack_require__(198);
	__webpack_require__(199);
	__webpack_require__(201);
	__webpack_require__(202);
	__webpack_require__(203);
	__webpack_require__(204);
	__webpack_require__(211);
	__webpack_require__(214);
	__webpack_require__(215);
	__webpack_require__(217);
	__webpack_require__(218);
	__webpack_require__(221);
	__webpack_require__(222);
	__webpack_require__(224);
	__webpack_require__(225);
	__webpack_require__(226);
	__webpack_require__(227);
	__webpack_require__(228);
	__webpack_require__(229);
	__webpack_require__(230);
	__webpack_require__(231);
	__webpack_require__(232);
	__webpack_require__(233);
	__webpack_require__(234);
	__webpack_require__(235);
	__webpack_require__(236);
	__webpack_require__(237);
	__webpack_require__(238);
	__webpack_require__(239);
	__webpack_require__(240);
	__webpack_require__(241);
	__webpack_require__(242);
	__webpack_require__(244);
	__webpack_require__(245);
	__webpack_require__(246);
	__webpack_require__(247);
	__webpack_require__(248);
	__webpack_require__(249);
	__webpack_require__(251);
	__webpack_require__(252);
	__webpack_require__(253);
	__webpack_require__(254);
	__webpack_require__(255);
	__webpack_require__(256);
	__webpack_require__(257);
	__webpack_require__(258);
	__webpack_require__(260);
	__webpack_require__(261);
	__webpack_require__(263);
	__webpack_require__(264);
	__webpack_require__(265);
	__webpack_require__(266);
	__webpack_require__(269);
	__webpack_require__(270);
	__webpack_require__(271);
	__webpack_require__(272);
	__webpack_require__(273);
	__webpack_require__(274);
	__webpack_require__(275);
	__webpack_require__(276);
	__webpack_require__(278);
	__webpack_require__(279);
	__webpack_require__(280);
	__webpack_require__(281);
	__webpack_require__(282);
	__webpack_require__(283);
	__webpack_require__(284);
	__webpack_require__(285);
	__webpack_require__(286);
	__webpack_require__(287);
	__webpack_require__(288);
	__webpack_require__(291);
	__webpack_require__(292);
	module.exports = __webpack_require__(9);

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// ECMAScript 6 symbols shim
	var global         = __webpack_require__(4)
	  , has            = __webpack_require__(5)
	  , DESCRIPTORS    = __webpack_require__(6)
	  , $export        = __webpack_require__(8)
	  , redefine       = __webpack_require__(18)
	  , META           = __webpack_require__(22).KEY
	  , $fails         = __webpack_require__(7)
	  , shared         = __webpack_require__(23)
	  , setToStringTag = __webpack_require__(24)
	  , uid            = __webpack_require__(19)
	  , wks            = __webpack_require__(25)
	  , wksExt         = __webpack_require__(26)
	  , wksDefine      = __webpack_require__(27)
	  , keyOf          = __webpack_require__(29)
	  , enumKeys       = __webpack_require__(42)
	  , isArray        = __webpack_require__(45)
	  , anObject       = __webpack_require__(12)
	  , toIObject      = __webpack_require__(32)
	  , toPrimitive    = __webpack_require__(16)
	  , createDesc     = __webpack_require__(17)
	  , _create        = __webpack_require__(46)
	  , gOPNExt        = __webpack_require__(49)
	  , $GOPD          = __webpack_require__(51)
	  , $DP            = __webpack_require__(11)
	  , $keys          = __webpack_require__(30)
	  , gOPD           = $GOPD.f
	  , dP             = $DP.f
	  , gOPN           = gOPNExt.f
	  , $Symbol        = global.Symbol
	  , $JSON          = global.JSON
	  , _stringify     = $JSON && $JSON.stringify
	  , PROTOTYPE      = 'prototype'
	  , HIDDEN         = wks('_hidden')
	  , TO_PRIMITIVE   = wks('toPrimitive')
	  , isEnum         = {}.propertyIsEnumerable
	  , SymbolRegistry = shared('symbol-registry')
	  , AllSymbols     = shared('symbols')
	  , OPSymbols      = shared('op-symbols')
	  , ObjectProto    = Object[PROTOTYPE]
	  , USE_NATIVE     = typeof $Symbol == 'function'
	  , QObject        = global.QObject;
	// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
	var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;
	
	// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
	var setSymbolDesc = DESCRIPTORS && $fails(function(){
	  return _create(dP({}, 'a', {
	    get: function(){ return dP(this, 'a', {value: 7}).a; }
	  })).a != 7;
	}) ? function(it, key, D){
	  var protoDesc = gOPD(ObjectProto, key);
	  if(protoDesc)delete ObjectProto[key];
	  dP(it, key, D);
	  if(protoDesc && it !== ObjectProto)dP(ObjectProto, key, protoDesc);
	} : dP;
	
	var wrap = function(tag){
	  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
	  sym._k = tag;
	  return sym;
	};
	
	var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function(it){
	  return typeof it == 'symbol';
	} : function(it){
	  return it instanceof $Symbol;
	};
	
	var $defineProperty = function defineProperty(it, key, D){
	  if(it === ObjectProto)$defineProperty(OPSymbols, key, D);
	  anObject(it);
	  key = toPrimitive(key, true);
	  anObject(D);
	  if(has(AllSymbols, key)){
	    if(!D.enumerable){
	      if(!has(it, HIDDEN))dP(it, HIDDEN, createDesc(1, {}));
	      it[HIDDEN][key] = true;
	    } else {
	      if(has(it, HIDDEN) && it[HIDDEN][key])it[HIDDEN][key] = false;
	      D = _create(D, {enumerable: createDesc(0, false)});
	    } return setSymbolDesc(it, key, D);
	  } return dP(it, key, D);
	};
	var $defineProperties = function defineProperties(it, P){
	  anObject(it);
	  var keys = enumKeys(P = toIObject(P))
	    , i    = 0
	    , l = keys.length
	    , key;
	  while(l > i)$defineProperty(it, key = keys[i++], P[key]);
	  return it;
	};
	var $create = function create(it, P){
	  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
	};
	var $propertyIsEnumerable = function propertyIsEnumerable(key){
	  var E = isEnum.call(this, key = toPrimitive(key, true));
	  if(this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key))return false;
	  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
	};
	var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key){
	  it  = toIObject(it);
	  key = toPrimitive(key, true);
	  if(it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key))return;
	  var D = gOPD(it, key);
	  if(D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key]))D.enumerable = true;
	  return D;
	};
	var $getOwnPropertyNames = function getOwnPropertyNames(it){
	  var names  = gOPN(toIObject(it))
	    , result = []
	    , i      = 0
	    , key;
	  while(names.length > i){
	    if(!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META)result.push(key);
	  } return result;
	};
	var $getOwnPropertySymbols = function getOwnPropertySymbols(it){
	  var IS_OP  = it === ObjectProto
	    , names  = gOPN(IS_OP ? OPSymbols : toIObject(it))
	    , result = []
	    , i      = 0
	    , key;
	  while(names.length > i){
	    if(has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true))result.push(AllSymbols[key]);
	  } return result;
	};
	
	// 19.4.1.1 Symbol([description])
	if(!USE_NATIVE){
	  $Symbol = function Symbol(){
	    if(this instanceof $Symbol)throw TypeError('Symbol is not a constructor!');
	    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
	    var $set = function(value){
	      if(this === ObjectProto)$set.call(OPSymbols, value);
	      if(has(this, HIDDEN) && has(this[HIDDEN], tag))this[HIDDEN][tag] = false;
	      setSymbolDesc(this, tag, createDesc(1, value));
	    };
	    if(DESCRIPTORS && setter)setSymbolDesc(ObjectProto, tag, {configurable: true, set: $set});
	    return wrap(tag);
	  };
	  redefine($Symbol[PROTOTYPE], 'toString', function toString(){
	    return this._k;
	  });
	
	  $GOPD.f = $getOwnPropertyDescriptor;
	  $DP.f   = $defineProperty;
	  __webpack_require__(50).f = gOPNExt.f = $getOwnPropertyNames;
	  __webpack_require__(44).f  = $propertyIsEnumerable;
	  __webpack_require__(43).f = $getOwnPropertySymbols;
	
	  if(DESCRIPTORS && !__webpack_require__(28)){
	    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
	  }
	
	  wksExt.f = function(name){
	    return wrap(wks(name));
	  }
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, {Symbol: $Symbol});
	
	for(var symbols = (
	  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
	  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
	).split(','), i = 0; symbols.length > i; )wks(symbols[i++]);
	
	for(var symbols = $keys(wks.store), i = 0; symbols.length > i; )wksDefine(symbols[i++]);
	
	$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
	  // 19.4.2.1 Symbol.for(key)
	  'for': function(key){
	    return has(SymbolRegistry, key += '')
	      ? SymbolRegistry[key]
	      : SymbolRegistry[key] = $Symbol(key);
	  },
	  // 19.4.2.5 Symbol.keyFor(sym)
	  keyFor: function keyFor(key){
	    if(isSymbol(key))return keyOf(SymbolRegistry, key);
	    throw TypeError(key + ' is not a symbol!');
	  },
	  useSetter: function(){ setter = true; },
	  useSimple: function(){ setter = false; }
	});
	
	$export($export.S + $export.F * !USE_NATIVE, 'Object', {
	  // 19.1.2.2 Object.create(O [, Properties])
	  create: $create,
	  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
	  defineProperty: $defineProperty,
	  // 19.1.2.3 Object.defineProperties(O, Properties)
	  defineProperties: $defineProperties,
	  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
	  // 19.1.2.7 Object.getOwnPropertyNames(O)
	  getOwnPropertyNames: $getOwnPropertyNames,
	  // 19.1.2.8 Object.getOwnPropertySymbols(O)
	  getOwnPropertySymbols: $getOwnPropertySymbols
	});
	
	// 24.3.2 JSON.stringify(value [, replacer [, space]])
	$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function(){
	  var S = $Symbol();
	  // MS Edge converts symbol values to JSON as {}
	  // WebKit converts symbol values to JSON as null
	  // V8 throws on boxed symbols
	  return _stringify([S]) != '[null]' || _stringify({a: S}) != '{}' || _stringify(Object(S)) != '{}';
	})), 'JSON', {
	  stringify: function stringify(it){
	    if(it === undefined || isSymbol(it))return; // IE8 returns string on undefined
	    var args = [it]
	      , i    = 1
	      , replacer, $replacer;
	    while(arguments.length > i)args.push(arguments[i++]);
	    replacer = args[1];
	    if(typeof replacer == 'function')$replacer = replacer;
	    if($replacer || !isArray(replacer))replacer = function(key, value){
	      if($replacer)value = $replacer.call(this, key, value);
	      if(!isSymbol(value))return value;
	    };
	    args[1] = replacer;
	    return _stringify.apply($JSON, args);
	  }
	});
	
	// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
	$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(10)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
	// 19.4.3.5 Symbol.prototype[@@toStringTag]
	setToStringTag($Symbol, 'Symbol');
	// 20.2.1.9 Math[@@toStringTag]
	setToStringTag(Math, 'Math', true);
	// 24.3.3 JSON[@@toStringTag]
	setToStringTag(global.JSON, 'JSON', true);

/***/ }),
/* 4 */
/***/ (function(module, exports) {

	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global = module.exports = typeof window != 'undefined' && window.Math == Math
	  ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')();
	if(typeof __g == 'number')__g = global; // eslint-disable-line no-undef

/***/ }),
/* 5 */
/***/ (function(module, exports) {

	var hasOwnProperty = {}.hasOwnProperty;
	module.exports = function(it, key){
	  return hasOwnProperty.call(it, key);
	};

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

	// Thank's IE8 for his funny defineProperty
	module.exports = !__webpack_require__(7)(function(){
	  return Object.defineProperty({}, 'a', {get: function(){ return 7; }}).a != 7;
	});

/***/ }),
/* 7 */
/***/ (function(module, exports) {

	module.exports = function(exec){
	  try {
	    return !!exec();
	  } catch(e){
	    return true;
	  }
	};

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

	var global    = __webpack_require__(4)
	  , core      = __webpack_require__(9)
	  , hide      = __webpack_require__(10)
	  , redefine  = __webpack_require__(18)
	  , ctx       = __webpack_require__(20)
	  , PROTOTYPE = 'prototype';
	
	var $export = function(type, name, source){
	  var IS_FORCED = type & $export.F
	    , IS_GLOBAL = type & $export.G
	    , IS_STATIC = type & $export.S
	    , IS_PROTO  = type & $export.P
	    , IS_BIND   = type & $export.B
	    , target    = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE]
	    , exports   = IS_GLOBAL ? core : core[name] || (core[name] = {})
	    , expProto  = exports[PROTOTYPE] || (exports[PROTOTYPE] = {})
	    , key, own, out, exp;
	  if(IS_GLOBAL)source = name;
	  for(key in source){
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    // export native or passed
	    out = (own ? target : source)[key];
	    // bind timers to global for call from export context
	    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // extend global
	    if(target)redefine(target, key, out, type & $export.U);
	    // export
	    if(exports[key] != out)hide(exports, key, exp);
	    if(IS_PROTO && expProto[key] != out)expProto[key] = out;
	  }
	};
	global.core = core;
	// type bitmap
	$export.F = 1;   // forced
	$export.G = 2;   // global
	$export.S = 4;   // static
	$export.P = 8;   // proto
	$export.B = 16;  // bind
	$export.W = 32;  // wrap
	$export.U = 64;  // safe
	$export.R = 128; // real proto method for `library` 
	module.exports = $export;

/***/ }),
/* 9 */
/***/ (function(module, exports) {

	var core = module.exports = {version: '2.4.0'};
	if(typeof __e == 'number')__e = core; // eslint-disable-line no-undef

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

	var dP         = __webpack_require__(11)
	  , createDesc = __webpack_require__(17);
	module.exports = __webpack_require__(6) ? function(object, key, value){
	  return dP.f(object, key, createDesc(1, value));
	} : function(object, key, value){
	  object[key] = value;
	  return object;
	};

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

	var anObject       = __webpack_require__(12)
	  , IE8_DOM_DEFINE = __webpack_require__(14)
	  , toPrimitive    = __webpack_require__(16)
	  , dP             = Object.defineProperty;
	
	exports.f = __webpack_require__(6) ? Object.defineProperty : function defineProperty(O, P, Attributes){
	  anObject(O);
	  P = toPrimitive(P, true);
	  anObject(Attributes);
	  if(IE8_DOM_DEFINE)try {
	    return dP(O, P, Attributes);
	  } catch(e){ /* empty */ }
	  if('get' in Attributes || 'set' in Attributes)throw TypeError('Accessors not supported!');
	  if('value' in Attributes)O[P] = Attributes.value;
	  return O;
	};

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(13);
	module.exports = function(it){
	  if(!isObject(it))throw TypeError(it + ' is not an object!');
	  return it;
	};

/***/ }),
/* 13 */
/***/ (function(module, exports) {

	module.exports = function(it){
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = !__webpack_require__(6) && !__webpack_require__(7)(function(){
	  return Object.defineProperty(__webpack_require__(15)('div'), 'a', {get: function(){ return 7; }}).a != 7;
	});

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(13)
	  , document = __webpack_require__(4).document
	  // in old IE typeof document.createElement is 'object'
	  , is = isObject(document) && isObject(document.createElement);
	module.exports = function(it){
	  return is ? document.createElement(it) : {};
	};

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.1 ToPrimitive(input [, PreferredType])
	var isObject = __webpack_require__(13);
	// instead of the ES6 spec version, we didn't implement @@toPrimitive case
	// and the second argument - flag - preferred type is a string
	module.exports = function(it, S){
	  if(!isObject(it))return it;
	  var fn, val;
	  if(S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it)))return val;
	  if(typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it)))return val;
	  if(!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it)))return val;
	  throw TypeError("Can't convert object to primitive value");
	};

/***/ }),
/* 17 */
/***/ (function(module, exports) {

	module.exports = function(bitmap, value){
	  return {
	    enumerable  : !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable    : !(bitmap & 4),
	    value       : value
	  };
	};

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

	var global    = __webpack_require__(4)
	  , hide      = __webpack_require__(10)
	  , has       = __webpack_require__(5)
	  , SRC       = __webpack_require__(19)('src')
	  , TO_STRING = 'toString'
	  , $toString = Function[TO_STRING]
	  , TPL       = ('' + $toString).split(TO_STRING);
	
	__webpack_require__(9).inspectSource = function(it){
	  return $toString.call(it);
	};
	
	(module.exports = function(O, key, val, safe){
	  var isFunction = typeof val == 'function';
	  if(isFunction)has(val, 'name') || hide(val, 'name', key);
	  if(O[key] === val)return;
	  if(isFunction)has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
	  if(O === global){
	    O[key] = val;
	  } else {
	    if(!safe){
	      delete O[key];
	      hide(O, key, val);
	    } else {
	      if(O[key])O[key] = val;
	      else hide(O, key, val);
	    }
	  }
	// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
	})(Function.prototype, TO_STRING, function toString(){
	  return typeof this == 'function' && this[SRC] || $toString.call(this);
	});

/***/ }),
/* 19 */
/***/ (function(module, exports) {

	var id = 0
	  , px = Math.random();
	module.exports = function(key){
	  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
	};

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

	// optional / simple context binding
	var aFunction = __webpack_require__(21);
	module.exports = function(fn, that, length){
	  aFunction(fn);
	  if(that === undefined)return fn;
	  switch(length){
	    case 1: return function(a){
	      return fn.call(that, a);
	    };
	    case 2: return function(a, b){
	      return fn.call(that, a, b);
	    };
	    case 3: return function(a, b, c){
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function(/* ...args */){
	    return fn.apply(that, arguments);
	  };
	};

/***/ }),
/* 21 */
/***/ (function(module, exports) {

	module.exports = function(it){
	  if(typeof it != 'function')throw TypeError(it + ' is not a function!');
	  return it;
	};

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

	var META     = __webpack_require__(19)('meta')
	  , isObject = __webpack_require__(13)
	  , has      = __webpack_require__(5)
	  , setDesc  = __webpack_require__(11).f
	  , id       = 0;
	var isExtensible = Object.isExtensible || function(){
	  return true;
	};
	var FREEZE = !__webpack_require__(7)(function(){
	  return isExtensible(Object.preventExtensions({}));
	});
	var setMeta = function(it){
	  setDesc(it, META, {value: {
	    i: 'O' + ++id, // object ID
	    w: {}          // weak collections IDs
	  }});
	};
	var fastKey = function(it, create){
	  // return primitive with prefix
	  if(!isObject(it))return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
	  if(!has(it, META)){
	    // can't set metadata to uncaught frozen object
	    if(!isExtensible(it))return 'F';
	    // not necessary to add metadata
	    if(!create)return 'E';
	    // add missing metadata
	    setMeta(it);
	  // return object ID
	  } return it[META].i;
	};
	var getWeak = function(it, create){
	  if(!has(it, META)){
	    // can't set metadata to uncaught frozen object
	    if(!isExtensible(it))return true;
	    // not necessary to add metadata
	    if(!create)return false;
	    // add missing metadata
	    setMeta(it);
	  // return hash weak collections IDs
	  } return it[META].w;
	};
	// add metadata on freeze-family methods calling
	var onFreeze = function(it){
	  if(FREEZE && meta.NEED && isExtensible(it) && !has(it, META))setMeta(it);
	  return it;
	};
	var meta = module.exports = {
	  KEY:      META,
	  NEED:     false,
	  fastKey:  fastKey,
	  getWeak:  getWeak,
	  onFreeze: onFreeze
	};

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(4)
	  , SHARED = '__core-js_shared__'
	  , store  = global[SHARED] || (global[SHARED] = {});
	module.exports = function(key){
	  return store[key] || (store[key] = {});
	};

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

	var def = __webpack_require__(11).f
	  , has = __webpack_require__(5)
	  , TAG = __webpack_require__(25)('toStringTag');
	
	module.exports = function(it, tag, stat){
	  if(it && !has(it = stat ? it : it.prototype, TAG))def(it, TAG, {configurable: true, value: tag});
	};

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

	var store      = __webpack_require__(23)('wks')
	  , uid        = __webpack_require__(19)
	  , Symbol     = __webpack_require__(4).Symbol
	  , USE_SYMBOL = typeof Symbol == 'function';
	
	var $exports = module.exports = function(name){
	  return store[name] || (store[name] =
	    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
	};
	
	$exports.store = store;

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

	exports.f = __webpack_require__(25);

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

	var global         = __webpack_require__(4)
	  , core           = __webpack_require__(9)
	  , LIBRARY        = __webpack_require__(28)
	  , wksExt         = __webpack_require__(26)
	  , defineProperty = __webpack_require__(11).f;
	module.exports = function(name){
	  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
	  if(name.charAt(0) != '_' && !(name in $Symbol))defineProperty($Symbol, name, {value: wksExt.f(name)});
	};

/***/ }),
/* 28 */
/***/ (function(module, exports) {

	module.exports = false;

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

	var getKeys   = __webpack_require__(30)
	  , toIObject = __webpack_require__(32);
	module.exports = function(object, el){
	  var O      = toIObject(object)
	    , keys   = getKeys(O)
	    , length = keys.length
	    , index  = 0
	    , key;
	  while(length > index)if(O[key = keys[index++]] === el)return key;
	};

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.14 / 15.2.3.14 Object.keys(O)
	var $keys       = __webpack_require__(31)
	  , enumBugKeys = __webpack_require__(41);
	
	module.exports = Object.keys || function keys(O){
	  return $keys(O, enumBugKeys);
	};

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

	var has          = __webpack_require__(5)
	  , toIObject    = __webpack_require__(32)
	  , arrayIndexOf = __webpack_require__(36)(false)
	  , IE_PROTO     = __webpack_require__(40)('IE_PROTO');
	
	module.exports = function(object, names){
	  var O      = toIObject(object)
	    , i      = 0
	    , result = []
	    , key;
	  for(key in O)if(key != IE_PROTO)has(O, key) && result.push(key);
	  // Don't enum bug & hidden keys
	  while(names.length > i)if(has(O, key = names[i++])){
	    ~arrayIndexOf(result, key) || result.push(key);
	  }
	  return result;
	};

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

	// to indexed object, toObject with fallback for non-array-like ES3 strings
	var IObject = __webpack_require__(33)
	  , defined = __webpack_require__(35);
	module.exports = function(it){
	  return IObject(defined(it));
	};

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

	// fallback for non-array-like ES3 and non-enumerable old V8 strings
	var cof = __webpack_require__(34);
	module.exports = Object('z').propertyIsEnumerable(0) ? Object : function(it){
	  return cof(it) == 'String' ? it.split('') : Object(it);
	};

/***/ }),
/* 34 */
/***/ (function(module, exports) {

	var toString = {}.toString;
	
	module.exports = function(it){
	  return toString.call(it).slice(8, -1);
	};

/***/ }),
/* 35 */
/***/ (function(module, exports) {

	// 7.2.1 RequireObjectCoercible(argument)
	module.exports = function(it){
	  if(it == undefined)throw TypeError("Can't call method on  " + it);
	  return it;
	};

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

	// false -> Array#indexOf
	// true  -> Array#includes
	var toIObject = __webpack_require__(32)
	  , toLength  = __webpack_require__(37)
	  , toIndex   = __webpack_require__(39);
	module.exports = function(IS_INCLUDES){
	  return function($this, el, fromIndex){
	    var O      = toIObject($this)
	      , length = toLength(O.length)
	      , index  = toIndex(fromIndex, length)
	      , value;
	    // Array#includes uses SameValueZero equality algorithm
	    if(IS_INCLUDES && el != el)while(length > index){
	      value = O[index++];
	      if(value != value)return true;
	    // Array#toIndex ignores holes, Array#includes - not
	    } else for(;length > index; index++)if(IS_INCLUDES || index in O){
	      if(O[index] === el)return IS_INCLUDES || index || 0;
	    } return !IS_INCLUDES && -1;
	  };
	};

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.15 ToLength
	var toInteger = __webpack_require__(38)
	  , min       = Math.min;
	module.exports = function(it){
	  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
	};

/***/ }),
/* 38 */
/***/ (function(module, exports) {

	// 7.1.4 ToInteger
	var ceil  = Math.ceil
	  , floor = Math.floor;
	module.exports = function(it){
	  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
	};

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(38)
	  , max       = Math.max
	  , min       = Math.min;
	module.exports = function(index, length){
	  index = toInteger(index);
	  return index < 0 ? max(index + length, 0) : min(index, length);
	};

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

	var shared = __webpack_require__(23)('keys')
	  , uid    = __webpack_require__(19);
	module.exports = function(key){
	  return shared[key] || (shared[key] = uid(key));
	};

/***/ }),
/* 41 */
/***/ (function(module, exports) {

	// IE 8- don't enum bug keys
	module.exports = (
	  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
	).split(',');

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

	// all enumerable object keys, includes symbols
	var getKeys = __webpack_require__(30)
	  , gOPS    = __webpack_require__(43)
	  , pIE     = __webpack_require__(44);
	module.exports = function(it){
	  var result     = getKeys(it)
	    , getSymbols = gOPS.f;
	  if(getSymbols){
	    var symbols = getSymbols(it)
	      , isEnum  = pIE.f
	      , i       = 0
	      , key;
	    while(symbols.length > i)if(isEnum.call(it, key = symbols[i++]))result.push(key);
	  } return result;
	};

/***/ }),
/* 43 */
/***/ (function(module, exports) {

	exports.f = Object.getOwnPropertySymbols;

/***/ }),
/* 44 */
/***/ (function(module, exports) {

	exports.f = {}.propertyIsEnumerable;

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.2.2 IsArray(argument)
	var cof = __webpack_require__(34);
	module.exports = Array.isArray || function isArray(arg){
	  return cof(arg) == 'Array';
	};

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	var anObject    = __webpack_require__(12)
	  , dPs         = __webpack_require__(47)
	  , enumBugKeys = __webpack_require__(41)
	  , IE_PROTO    = __webpack_require__(40)('IE_PROTO')
	  , Empty       = function(){ /* empty */ }
	  , PROTOTYPE   = 'prototype';
	
	// Create object with fake `null` prototype: use iframe Object with cleared prototype
	var createDict = function(){
	  // Thrash, waste and sodomy: IE GC bug
	  var iframe = __webpack_require__(15)('iframe')
	    , i      = enumBugKeys.length
	    , lt     = '<'
	    , gt     = '>'
	    , iframeDocument;
	  iframe.style.display = 'none';
	  __webpack_require__(48).appendChild(iframe);
	  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
	  // createDict = iframe.contentWindow.Object;
	  // html.removeChild(iframe);
	  iframeDocument = iframe.contentWindow.document;
	  iframeDocument.open();
	  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
	  iframeDocument.close();
	  createDict = iframeDocument.F;
	  while(i--)delete createDict[PROTOTYPE][enumBugKeys[i]];
	  return createDict();
	};
	
	module.exports = Object.create || function create(O, Properties){
	  var result;
	  if(O !== null){
	    Empty[PROTOTYPE] = anObject(O);
	    result = new Empty;
	    Empty[PROTOTYPE] = null;
	    // add "__proto__" for Object.getPrototypeOf polyfill
	    result[IE_PROTO] = O;
	  } else result = createDict();
	  return Properties === undefined ? result : dPs(result, Properties);
	};


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

	var dP       = __webpack_require__(11)
	  , anObject = __webpack_require__(12)
	  , getKeys  = __webpack_require__(30);
	
	module.exports = __webpack_require__(6) ? Object.defineProperties : function defineProperties(O, Properties){
	  anObject(O);
	  var keys   = getKeys(Properties)
	    , length = keys.length
	    , i = 0
	    , P;
	  while(length > i)dP.f(O, P = keys[i++], Properties[P]);
	  return O;
	};

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(4).document && document.documentElement;

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

	// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
	var toIObject = __webpack_require__(32)
	  , gOPN      = __webpack_require__(50).f
	  , toString  = {}.toString;
	
	var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
	  ? Object.getOwnPropertyNames(window) : [];
	
	var getWindowNames = function(it){
	  try {
	    return gOPN(it);
	  } catch(e){
	    return windowNames.slice();
	  }
	};
	
	module.exports.f = function getOwnPropertyNames(it){
	  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
	};


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
	var $keys      = __webpack_require__(31)
	  , hiddenKeys = __webpack_require__(41).concat('length', 'prototype');
	
	exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O){
	  return $keys(O, hiddenKeys);
	};

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

	var pIE            = __webpack_require__(44)
	  , createDesc     = __webpack_require__(17)
	  , toIObject      = __webpack_require__(32)
	  , toPrimitive    = __webpack_require__(16)
	  , has            = __webpack_require__(5)
	  , IE8_DOM_DEFINE = __webpack_require__(14)
	  , gOPD           = Object.getOwnPropertyDescriptor;
	
	exports.f = __webpack_require__(6) ? gOPD : function getOwnPropertyDescriptor(O, P){
	  O = toIObject(O);
	  P = toPrimitive(P, true);
	  if(IE8_DOM_DEFINE)try {
	    return gOPD(O, P);
	  } catch(e){ /* empty */ }
	  if(has(O, P))return createDesc(!pIE.f.call(O, P), O[P]);
	};

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(8)
	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	$export($export.S, 'Object', {create: __webpack_require__(46)});

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(8);
	// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
	$export($export.S + $export.F * !__webpack_require__(6), 'Object', {defineProperty: __webpack_require__(11).f});

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(8);
	// 19.1.2.3 / 15.2.3.7 Object.defineProperties(O, Properties)
	$export($export.S + $export.F * !__webpack_require__(6), 'Object', {defineProperties: __webpack_require__(47)});

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	var toIObject                 = __webpack_require__(32)
	  , $getOwnPropertyDescriptor = __webpack_require__(51).f;
	
	__webpack_require__(56)('getOwnPropertyDescriptor', function(){
	  return function getOwnPropertyDescriptor(it, key){
	    return $getOwnPropertyDescriptor(toIObject(it), key);
	  };
	});

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

	// most Object methods by ES6 should accept primitives
	var $export = __webpack_require__(8)
	  , core    = __webpack_require__(9)
	  , fails   = __webpack_require__(7);
	module.exports = function(KEY, exec){
	  var fn  = (core.Object || {})[KEY] || Object[KEY]
	    , exp = {};
	  exp[KEY] = exec(fn);
	  $export($export.S + $export.F * fails(function(){ fn(1); }), 'Object', exp);
	};

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.9 Object.getPrototypeOf(O)
	var toObject        = __webpack_require__(58)
	  , $getPrototypeOf = __webpack_require__(59);
	
	__webpack_require__(56)('getPrototypeOf', function(){
	  return function getPrototypeOf(it){
	    return $getPrototypeOf(toObject(it));
	  };
	});

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.13 ToObject(argument)
	var defined = __webpack_require__(35);
	module.exports = function(it){
	  return Object(defined(it));
	};

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
	var has         = __webpack_require__(5)
	  , toObject    = __webpack_require__(58)
	  , IE_PROTO    = __webpack_require__(40)('IE_PROTO')
	  , ObjectProto = Object.prototype;
	
	module.exports = Object.getPrototypeOf || function(O){
	  O = toObject(O);
	  if(has(O, IE_PROTO))return O[IE_PROTO];
	  if(typeof O.constructor == 'function' && O instanceof O.constructor){
	    return O.constructor.prototype;
	  } return O instanceof Object ? ObjectProto : null;
	};

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.14 Object.keys(O)
	var toObject = __webpack_require__(58)
	  , $keys    = __webpack_require__(30);
	
	__webpack_require__(56)('keys', function(){
	  return function keys(it){
	    return $keys(toObject(it));
	  };
	});

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.7 Object.getOwnPropertyNames(O)
	__webpack_require__(56)('getOwnPropertyNames', function(){
	  return __webpack_require__(49).f;
	});

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.5 Object.freeze(O)
	var isObject = __webpack_require__(13)
	  , meta     = __webpack_require__(22).onFreeze;
	
	__webpack_require__(56)('freeze', function($freeze){
	  return function freeze(it){
	    return $freeze && isObject(it) ? $freeze(meta(it)) : it;
	  };
	});

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.17 Object.seal(O)
	var isObject = __webpack_require__(13)
	  , meta     = __webpack_require__(22).onFreeze;
	
	__webpack_require__(56)('seal', function($seal){
	  return function seal(it){
	    return $seal && isObject(it) ? $seal(meta(it)) : it;
	  };
	});

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.15 Object.preventExtensions(O)
	var isObject = __webpack_require__(13)
	  , meta     = __webpack_require__(22).onFreeze;
	
	__webpack_require__(56)('preventExtensions', function($preventExtensions){
	  return function preventExtensions(it){
	    return $preventExtensions && isObject(it) ? $preventExtensions(meta(it)) : it;
	  };
	});

/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.12 Object.isFrozen(O)
	var isObject = __webpack_require__(13);
	
	__webpack_require__(56)('isFrozen', function($isFrozen){
	  return function isFrozen(it){
	    return isObject(it) ? $isFrozen ? $isFrozen(it) : false : true;
	  };
	});

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.13 Object.isSealed(O)
	var isObject = __webpack_require__(13);
	
	__webpack_require__(56)('isSealed', function($isSealed){
	  return function isSealed(it){
	    return isObject(it) ? $isSealed ? $isSealed(it) : false : true;
	  };
	});

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.11 Object.isExtensible(O)
	var isObject = __webpack_require__(13);
	
	__webpack_require__(56)('isExtensible', function($isExtensible){
	  return function isExtensible(it){
	    return isObject(it) ? $isExtensible ? $isExtensible(it) : true : false;
	  };
	});

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.3.1 Object.assign(target, source)
	var $export = __webpack_require__(8);
	
	$export($export.S + $export.F, 'Object', {assign: __webpack_require__(69)});

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.2.1 Object.assign(target, source, ...)
	var getKeys  = __webpack_require__(30)
	  , gOPS     = __webpack_require__(43)
	  , pIE      = __webpack_require__(44)
	  , toObject = __webpack_require__(58)
	  , IObject  = __webpack_require__(33)
	  , $assign  = Object.assign;
	
	// should work with symbols and should have deterministic property order (V8 bug)
	module.exports = !$assign || __webpack_require__(7)(function(){
	  var A = {}
	    , B = {}
	    , S = Symbol()
	    , K = 'abcdefghijklmnopqrst';
	  A[S] = 7;
	  K.split('').forEach(function(k){ B[k] = k; });
	  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
	}) ? function assign(target, source){ // eslint-disable-line no-unused-vars
	  var T     = toObject(target)
	    , aLen  = arguments.length
	    , index = 1
	    , getSymbols = gOPS.f
	    , isEnum     = pIE.f;
	  while(aLen > index){
	    var S      = IObject(arguments[index++])
	      , keys   = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S)
	      , length = keys.length
	      , j      = 0
	      , key;
	    while(length > j)if(isEnum.call(S, key = keys[j++]))T[key] = S[key];
	  } return T;
	} : $assign;

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.3.10 Object.is(value1, value2)
	var $export = __webpack_require__(8);
	$export($export.S, 'Object', {is: __webpack_require__(71)});

/***/ }),
/* 71 */
/***/ (function(module, exports) {

	// 7.2.9 SameValue(x, y)
	module.exports = Object.is || function is(x, y){
	  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
	};

/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.3.19 Object.setPrototypeOf(O, proto)
	var $export = __webpack_require__(8);
	$export($export.S, 'Object', {setPrototypeOf: __webpack_require__(73).set});

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

	// Works with __proto__ only. Old v8 can't work with null proto objects.
	/* eslint-disable no-proto */
	var isObject = __webpack_require__(13)
	  , anObject = __webpack_require__(12);
	var check = function(O, proto){
	  anObject(O);
	  if(!isObject(proto) && proto !== null)throw TypeError(proto + ": can't set as prototype!");
	};
	module.exports = {
	  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
	    function(test, buggy, set){
	      try {
	        set = __webpack_require__(20)(Function.call, __webpack_require__(51).f(Object.prototype, '__proto__').set, 2);
	        set(test, []);
	        buggy = !(test instanceof Array);
	      } catch(e){ buggy = true; }
	      return function setPrototypeOf(O, proto){
	        check(O, proto);
	        if(buggy)O.__proto__ = proto;
	        else set(O, proto);
	        return O;
	      };
	    }({}, false) : undefined),
	  check: check
	};

/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.3.6 Object.prototype.toString()
	var classof = __webpack_require__(75)
	  , test    = {};
	test[__webpack_require__(25)('toStringTag')] = 'z';
	if(test + '' != '[object z]'){
	  __webpack_require__(18)(Object.prototype, 'toString', function toString(){
	    return '[object ' + classof(this) + ']';
	  }, true);
	}

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

	// getting tag from 19.1.3.6 Object.prototype.toString()
	var cof = __webpack_require__(34)
	  , TAG = __webpack_require__(25)('toStringTag')
	  // ES3 wrong here
	  , ARG = cof(function(){ return arguments; }()) == 'Arguments';
	
	// fallback for IE11 Script Access Denied error
	var tryGet = function(it, key){
	  try {
	    return it[key];
	  } catch(e){ /* empty */ }
	};
	
	module.exports = function(it){
	  var O, T, B;
	  return it === undefined ? 'Undefined' : it === null ? 'Null'
	    // @@toStringTag case
	    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
	    // builtinTag case
	    : ARG ? cof(O)
	    // ES3 arguments fallback
	    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
	};

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.2.3.2 / 15.3.4.5 Function.prototype.bind(thisArg, args...)
	var $export = __webpack_require__(8);
	
	$export($export.P, 'Function', {bind: __webpack_require__(77)});

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var aFunction  = __webpack_require__(21)
	  , isObject   = __webpack_require__(13)
	  , invoke     = __webpack_require__(78)
	  , arraySlice = [].slice
	  , factories  = {};
	
	var construct = function(F, len, args){
	  if(!(len in factories)){
	    for(var n = [], i = 0; i < len; i++)n[i] = 'a[' + i + ']';
	    factories[len] = Function('F,a', 'return new F(' + n.join(',') + ')');
	  } return factories[len](F, args);
	};
	
	module.exports = Function.bind || function bind(that /*, args... */){
	  var fn       = aFunction(this)
	    , partArgs = arraySlice.call(arguments, 1);
	  var bound = function(/* args... */){
	    var args = partArgs.concat(arraySlice.call(arguments));
	    return this instanceof bound ? construct(fn, args.length, args) : invoke(fn, args, that);
	  };
	  if(isObject(fn.prototype))bound.prototype = fn.prototype;
	  return bound;
	};

/***/ }),
/* 78 */
/***/ (function(module, exports) {

	// fast apply, http://jsperf.lnkit.com/fast-apply/5
	module.exports = function(fn, args, that){
	  var un = that === undefined;
	  switch(args.length){
	    case 0: return un ? fn()
	                      : fn.call(that);
	    case 1: return un ? fn(args[0])
	                      : fn.call(that, args[0]);
	    case 2: return un ? fn(args[0], args[1])
	                      : fn.call(that, args[0], args[1]);
	    case 3: return un ? fn(args[0], args[1], args[2])
	                      : fn.call(that, args[0], args[1], args[2]);
	    case 4: return un ? fn(args[0], args[1], args[2], args[3])
	                      : fn.call(that, args[0], args[1], args[2], args[3]);
	  } return              fn.apply(that, args);
	};

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

	var dP         = __webpack_require__(11).f
	  , createDesc = __webpack_require__(17)
	  , has        = __webpack_require__(5)
	  , FProto     = Function.prototype
	  , nameRE     = /^\s*function ([^ (]*)/
	  , NAME       = 'name';
	
	var isExtensible = Object.isExtensible || function(){
	  return true;
	};
	
	// 19.2.4.2 name
	NAME in FProto || __webpack_require__(6) && dP(FProto, NAME, {
	  configurable: true,
	  get: function(){
	    try {
	      var that = this
	        , name = ('' + that).match(nameRE)[1];
	      has(that, NAME) || !isExtensible(that) || dP(that, NAME, createDesc(5, name));
	      return name;
	    } catch(e){
	      return '';
	    }
	  }
	});

/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var isObject       = __webpack_require__(13)
	  , getPrototypeOf = __webpack_require__(59)
	  , HAS_INSTANCE   = __webpack_require__(25)('hasInstance')
	  , FunctionProto  = Function.prototype;
	// 19.2.3.6 Function.prototype[@@hasInstance](V)
	if(!(HAS_INSTANCE in FunctionProto))__webpack_require__(11).f(FunctionProto, HAS_INSTANCE, {value: function(O){
	  if(typeof this != 'function' || !isObject(O))return false;
	  if(!isObject(this.prototype))return O instanceof this;
	  // for environment w/o native `@@hasInstance` logic enough `instanceof`, but add this:
	  while(O = getPrototypeOf(O))if(this.prototype === O)return true;
	  return false;
	}});

/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

	var $export   = __webpack_require__(8)
	  , $parseInt = __webpack_require__(82);
	// 18.2.5 parseInt(string, radix)
	$export($export.G + $export.F * (parseInt != $parseInt), {parseInt: $parseInt});

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

	var $parseInt = __webpack_require__(4).parseInt
	  , $trim     = __webpack_require__(83).trim
	  , ws        = __webpack_require__(84)
	  , hex       = /^[\-+]?0[xX]/;
	
	module.exports = $parseInt(ws + '08') !== 8 || $parseInt(ws + '0x16') !== 22 ? function parseInt(str, radix){
	  var string = $trim(String(str), 3);
	  return $parseInt(string, (radix >>> 0) || (hex.test(string) ? 16 : 10));
	} : $parseInt;

/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(8)
	  , defined = __webpack_require__(35)
	  , fails   = __webpack_require__(7)
	  , spaces  = __webpack_require__(84)
	  , space   = '[' + spaces + ']'
	  , non     = '\u200b\u0085'
	  , ltrim   = RegExp('^' + space + space + '*')
	  , rtrim   = RegExp(space + space + '*$');
	
	var exporter = function(KEY, exec, ALIAS){
	  var exp   = {};
	  var FORCE = fails(function(){
	    return !!spaces[KEY]() || non[KEY]() != non;
	  });
	  var fn = exp[KEY] = FORCE ? exec(trim) : spaces[KEY];
	  if(ALIAS)exp[ALIAS] = fn;
	  $export($export.P + $export.F * FORCE, 'String', exp);
	};
	
	// 1 -> String#trimLeft
	// 2 -> String#trimRight
	// 3 -> String#trim
	var trim = exporter.trim = function(string, TYPE){
	  string = String(defined(string));
	  if(TYPE & 1)string = string.replace(ltrim, '');
	  if(TYPE & 2)string = string.replace(rtrim, '');
	  return string;
	};
	
	module.exports = exporter;

/***/ }),
/* 84 */
/***/ (function(module, exports) {

	module.exports = '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003' +
	  '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

	var $export     = __webpack_require__(8)
	  , $parseFloat = __webpack_require__(86);
	// 18.2.4 parseFloat(string)
	$export($export.G + $export.F * (parseFloat != $parseFloat), {parseFloat: $parseFloat});

/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

	var $parseFloat = __webpack_require__(4).parseFloat
	  , $trim       = __webpack_require__(83).trim;
	
	module.exports = 1 / $parseFloat(__webpack_require__(84) + '-0') !== -Infinity ? function parseFloat(str){
	  var string = $trim(String(str), 3)
	    , result = $parseFloat(string);
	  return result === 0 && string.charAt(0) == '-' ? -0 : result;
	} : $parseFloat;

/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var global            = __webpack_require__(4)
	  , has               = __webpack_require__(5)
	  , cof               = __webpack_require__(34)
	  , inheritIfRequired = __webpack_require__(88)
	  , toPrimitive       = __webpack_require__(16)
	  , fails             = __webpack_require__(7)
	  , gOPN              = __webpack_require__(50).f
	  , gOPD              = __webpack_require__(51).f
	  , dP                = __webpack_require__(11).f
	  , $trim             = __webpack_require__(83).trim
	  , NUMBER            = 'Number'
	  , $Number           = global[NUMBER]
	  , Base              = $Number
	  , proto             = $Number.prototype
	  // Opera ~12 has broken Object#toString
	  , BROKEN_COF        = cof(__webpack_require__(46)(proto)) == NUMBER
	  , TRIM              = 'trim' in String.prototype;
	
	// 7.1.3 ToNumber(argument)
	var toNumber = function(argument){
	  var it = toPrimitive(argument, false);
	  if(typeof it == 'string' && it.length > 2){
	    it = TRIM ? it.trim() : $trim(it, 3);
	    var first = it.charCodeAt(0)
	      , third, radix, maxCode;
	    if(first === 43 || first === 45){
	      third = it.charCodeAt(2);
	      if(third === 88 || third === 120)return NaN; // Number('+0x1') should be NaN, old V8 fix
	    } else if(first === 48){
	      switch(it.charCodeAt(1)){
	        case 66 : case 98  : radix = 2; maxCode = 49; break; // fast equal /^0b[01]+$/i
	        case 79 : case 111 : radix = 8; maxCode = 55; break; // fast equal /^0o[0-7]+$/i
	        default : return +it;
	      }
	      for(var digits = it.slice(2), i = 0, l = digits.length, code; i < l; i++){
	        code = digits.charCodeAt(i);
	        // parseInt parses a string to a first unavailable symbol
	        // but ToNumber should return NaN if a string contains unavailable symbols
	        if(code < 48 || code > maxCode)return NaN;
	      } return parseInt(digits, radix);
	    }
	  } return +it;
	};
	
	if(!$Number(' 0o1') || !$Number('0b1') || $Number('+0x1')){
	  $Number = function Number(value){
	    var it = arguments.length < 1 ? 0 : value
	      , that = this;
	    return that instanceof $Number
	      // check on 1..constructor(foo) case
	      && (BROKEN_COF ? fails(function(){ proto.valueOf.call(that); }) : cof(that) != NUMBER)
	        ? inheritIfRequired(new Base(toNumber(it)), that, $Number) : toNumber(it);
	  };
	  for(var keys = __webpack_require__(6) ? gOPN(Base) : (
	    // ES3:
	    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
	    // ES6 (in case, if modules with ES6 Number statics required before):
	    'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' +
	    'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger'
	  ).split(','), j = 0, key; keys.length > j; j++){
	    if(has(Base, key = keys[j]) && !has($Number, key)){
	      dP($Number, key, gOPD(Base, key));
	    }
	  }
	  $Number.prototype = proto;
	  proto.constructor = $Number;
	  __webpack_require__(18)(global, NUMBER, $Number);
	}

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject       = __webpack_require__(13)
	  , setPrototypeOf = __webpack_require__(73).set;
	module.exports = function(that, target, C){
	  var P, S = target.constructor;
	  if(S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && isObject(P) && setPrototypeOf){
	    setPrototypeOf(that, P);
	  } return that;
	};

/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export      = __webpack_require__(8)
	  , toInteger    = __webpack_require__(38)
	  , aNumberValue = __webpack_require__(90)
	  , repeat       = __webpack_require__(91)
	  , $toFixed     = 1..toFixed
	  , floor        = Math.floor
	  , data         = [0, 0, 0, 0, 0, 0]
	  , ERROR        = 'Number.toFixed: incorrect invocation!'
	  , ZERO         = '0';
	
	var multiply = function(n, c){
	  var i  = -1
	    , c2 = c;
	  while(++i < 6){
	    c2 += n * data[i];
	    data[i] = c2 % 1e7;
	    c2 = floor(c2 / 1e7);
	  }
	};
	var divide = function(n){
	  var i = 6
	    , c = 0;
	  while(--i >= 0){
	    c += data[i];
	    data[i] = floor(c / n);
	    c = (c % n) * 1e7;
	  }
	};
	var numToString = function(){
	  var i = 6
	    , s = '';
	  while(--i >= 0){
	    if(s !== '' || i === 0 || data[i] !== 0){
	      var t = String(data[i]);
	      s = s === '' ? t : s + repeat.call(ZERO, 7 - t.length) + t;
	    }
	  } return s;
	};
	var pow = function(x, n, acc){
	  return n === 0 ? acc : n % 2 === 1 ? pow(x, n - 1, acc * x) : pow(x * x, n / 2, acc);
	};
	var log = function(x){
	  var n  = 0
	    , x2 = x;
	  while(x2 >= 4096){
	    n += 12;
	    x2 /= 4096;
	  }
	  while(x2 >= 2){
	    n  += 1;
	    x2 /= 2;
	  } return n;
	};
	
	$export($export.P + $export.F * (!!$toFixed && (
	  0.00008.toFixed(3) !== '0.000' ||
	  0.9.toFixed(0) !== '1' ||
	  1.255.toFixed(2) !== '1.25' ||
	  1000000000000000128..toFixed(0) !== '1000000000000000128'
	) || !__webpack_require__(7)(function(){
	  // V8 ~ Android 4.3-
	  $toFixed.call({});
	})), 'Number', {
	  toFixed: function toFixed(fractionDigits){
	    var x = aNumberValue(this, ERROR)
	      , f = toInteger(fractionDigits)
	      , s = ''
	      , m = ZERO
	      , e, z, j, k;
	    if(f < 0 || f > 20)throw RangeError(ERROR);
	    if(x != x)return 'NaN';
	    if(x <= -1e21 || x >= 1e21)return String(x);
	    if(x < 0){
	      s = '-';
	      x = -x;
	    }
	    if(x > 1e-21){
	      e = log(x * pow(2, 69, 1)) - 69;
	      z = e < 0 ? x * pow(2, -e, 1) : x / pow(2, e, 1);
	      z *= 0x10000000000000;
	      e = 52 - e;
	      if(e > 0){
	        multiply(0, z);
	        j = f;
	        while(j >= 7){
	          multiply(1e7, 0);
	          j -= 7;
	        }
	        multiply(pow(10, j, 1), 0);
	        j = e - 1;
	        while(j >= 23){
	          divide(1 << 23);
	          j -= 23;
	        }
	        divide(1 << j);
	        multiply(1, 1);
	        divide(2);
	        m = numToString();
	      } else {
	        multiply(0, z);
	        multiply(1 << -e, 0);
	        m = numToString() + repeat.call(ZERO, f);
	      }
	    }
	    if(f > 0){
	      k = m.length;
	      m = s + (k <= f ? '0.' + repeat.call(ZERO, f - k) + m : m.slice(0, k - f) + '.' + m.slice(k - f));
	    } else {
	      m = s + m;
	    } return m;
	  }
	});

/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

	var cof = __webpack_require__(34);
	module.exports = function(it, msg){
	  if(typeof it != 'number' && cof(it) != 'Number')throw TypeError(msg);
	  return +it;
	};

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var toInteger = __webpack_require__(38)
	  , defined   = __webpack_require__(35);
	
	module.exports = function repeat(count){
	  var str = String(defined(this))
	    , res = ''
	    , n   = toInteger(count);
	  if(n < 0 || n == Infinity)throw RangeError("Count can't be negative");
	  for(;n > 0; (n >>>= 1) && (str += str))if(n & 1)res += str;
	  return res;
	};

/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export      = __webpack_require__(8)
	  , $fails       = __webpack_require__(7)
	  , aNumberValue = __webpack_require__(90)
	  , $toPrecision = 1..toPrecision;
	
	$export($export.P + $export.F * ($fails(function(){
	  // IE7-
	  return $toPrecision.call(1, undefined) !== '1';
	}) || !$fails(function(){
	  // V8 ~ Android 4.3-
	  $toPrecision.call({});
	})), 'Number', {
	  toPrecision: function toPrecision(precision){
	    var that = aNumberValue(this, 'Number#toPrecision: incorrect invocation!');
	    return precision === undefined ? $toPrecision.call(that) : $toPrecision.call(that, precision); 
	  }
	});

/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.1 Number.EPSILON
	var $export = __webpack_require__(8);
	
	$export($export.S, 'Number', {EPSILON: Math.pow(2, -52)});

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.2 Number.isFinite(number)
	var $export   = __webpack_require__(8)
	  , _isFinite = __webpack_require__(4).isFinite;
	
	$export($export.S, 'Number', {
	  isFinite: function isFinite(it){
	    return typeof it == 'number' && _isFinite(it);
	  }
	});

/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.3 Number.isInteger(number)
	var $export = __webpack_require__(8);
	
	$export($export.S, 'Number', {isInteger: __webpack_require__(96)});

/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.3 Number.isInteger(number)
	var isObject = __webpack_require__(13)
	  , floor    = Math.floor;
	module.exports = function isInteger(it){
	  return !isObject(it) && isFinite(it) && floor(it) === it;
	};

/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.4 Number.isNaN(number)
	var $export = __webpack_require__(8);
	
	$export($export.S, 'Number', {
	  isNaN: function isNaN(number){
	    return number != number;
	  }
	});

/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.5 Number.isSafeInteger(number)
	var $export   = __webpack_require__(8)
	  , isInteger = __webpack_require__(96)
	  , abs       = Math.abs;
	
	$export($export.S, 'Number', {
	  isSafeInteger: function isSafeInteger(number){
	    return isInteger(number) && abs(number) <= 0x1fffffffffffff;
	  }
	});

/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.6 Number.MAX_SAFE_INTEGER
	var $export = __webpack_require__(8);
	
	$export($export.S, 'Number', {MAX_SAFE_INTEGER: 0x1fffffffffffff});

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.10 Number.MIN_SAFE_INTEGER
	var $export = __webpack_require__(8);
	
	$export($export.S, 'Number', {MIN_SAFE_INTEGER: -0x1fffffffffffff});

/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

	var $export     = __webpack_require__(8)
	  , $parseFloat = __webpack_require__(86);
	// 20.1.2.12 Number.parseFloat(string)
	$export($export.S + $export.F * (Number.parseFloat != $parseFloat), 'Number', {parseFloat: $parseFloat});

/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

	var $export   = __webpack_require__(8)
	  , $parseInt = __webpack_require__(82);
	// 20.1.2.13 Number.parseInt(string, radix)
	$export($export.S + $export.F * (Number.parseInt != $parseInt), 'Number', {parseInt: $parseInt});

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.3 Math.acosh(x)
	var $export = __webpack_require__(8)
	  , log1p   = __webpack_require__(104)
	  , sqrt    = Math.sqrt
	  , $acosh  = Math.acosh;
	
	$export($export.S + $export.F * !($acosh
	  // V8 bug: https://code.google.com/p/v8/issues/detail?id=3509
	  && Math.floor($acosh(Number.MAX_VALUE)) == 710
	  // Tor Browser bug: Math.acosh(Infinity) -> NaN 
	  && $acosh(Infinity) == Infinity
	), 'Math', {
	  acosh: function acosh(x){
	    return (x = +x) < 1 ? NaN : x > 94906265.62425156
	      ? Math.log(x) + Math.LN2
	      : log1p(x - 1 + sqrt(x - 1) * sqrt(x + 1));
	  }
	});

/***/ }),
/* 104 */
/***/ (function(module, exports) {

	// 20.2.2.20 Math.log1p(x)
	module.exports = Math.log1p || function log1p(x){
	  return (x = +x) > -1e-8 && x < 1e-8 ? x - x * x / 2 : Math.log(1 + x);
	};

/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.5 Math.asinh(x)
	var $export = __webpack_require__(8)
	  , $asinh  = Math.asinh;
	
	function asinh(x){
	  return !isFinite(x = +x) || x == 0 ? x : x < 0 ? -asinh(-x) : Math.log(x + Math.sqrt(x * x + 1));
	}
	
	// Tor Browser bug: Math.asinh(0) -> -0 
	$export($export.S + $export.F * !($asinh && 1 / $asinh(0) > 0), 'Math', {asinh: asinh});

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.7 Math.atanh(x)
	var $export = __webpack_require__(8)
	  , $atanh  = Math.atanh;
	
	// Tor Browser bug: Math.atanh(-0) -> 0 
	$export($export.S + $export.F * !($atanh && 1 / $atanh(-0) < 0), 'Math', {
	  atanh: function atanh(x){
	    return (x = +x) == 0 ? x : Math.log((1 + x) / (1 - x)) / 2;
	  }
	});

/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.9 Math.cbrt(x)
	var $export = __webpack_require__(8)
	  , sign    = __webpack_require__(108);
	
	$export($export.S, 'Math', {
	  cbrt: function cbrt(x){
	    return sign(x = +x) * Math.pow(Math.abs(x), 1 / 3);
	  }
	});

/***/ }),
/* 108 */
/***/ (function(module, exports) {

	// 20.2.2.28 Math.sign(x)
	module.exports = Math.sign || function sign(x){
	  return (x = +x) == 0 || x != x ? x : x < 0 ? -1 : 1;
	};

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.11 Math.clz32(x)
	var $export = __webpack_require__(8);
	
	$export($export.S, 'Math', {
	  clz32: function clz32(x){
	    return (x >>>= 0) ? 31 - Math.floor(Math.log(x + 0.5) * Math.LOG2E) : 32;
	  }
	});

/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.12 Math.cosh(x)
	var $export = __webpack_require__(8)
	  , exp     = Math.exp;
	
	$export($export.S, 'Math', {
	  cosh: function cosh(x){
	    return (exp(x = +x) + exp(-x)) / 2;
	  }
	});

/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.14 Math.expm1(x)
	var $export = __webpack_require__(8)
	  , $expm1  = __webpack_require__(112);
	
	$export($export.S + $export.F * ($expm1 != Math.expm1), 'Math', {expm1: $expm1});

/***/ }),
/* 112 */
/***/ (function(module, exports) {

	// 20.2.2.14 Math.expm1(x)
	var $expm1 = Math.expm1;
	module.exports = (!$expm1
	  // Old FF bug
	  || $expm1(10) > 22025.465794806719 || $expm1(10) < 22025.4657948067165168
	  // Tor Browser bug
	  || $expm1(-2e-17) != -2e-17
	) ? function expm1(x){
	  return (x = +x) == 0 ? x : x > -1e-6 && x < 1e-6 ? x + x * x / 2 : Math.exp(x) - 1;
	} : $expm1;

/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.16 Math.fround(x)
	var $export   = __webpack_require__(8)
	  , sign      = __webpack_require__(108)
	  , pow       = Math.pow
	  , EPSILON   = pow(2, -52)
	  , EPSILON32 = pow(2, -23)
	  , MAX32     = pow(2, 127) * (2 - EPSILON32)
	  , MIN32     = pow(2, -126);
	
	var roundTiesToEven = function(n){
	  return n + 1 / EPSILON - 1 / EPSILON;
	};
	
	
	$export($export.S, 'Math', {
	  fround: function fround(x){
	    var $abs  = Math.abs(x)
	      , $sign = sign(x)
	      , a, result;
	    if($abs < MIN32)return $sign * roundTiesToEven($abs / MIN32 / EPSILON32) * MIN32 * EPSILON32;
	    a = (1 + EPSILON32 / EPSILON) * $abs;
	    result = a - (a - $abs);
	    if(result > MAX32 || result != result)return $sign * Infinity;
	    return $sign * result;
	  }
	});

/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.17 Math.hypot([value1[, value2[, … ]]])
	var $export = __webpack_require__(8)
	  , abs     = Math.abs;
	
	$export($export.S, 'Math', {
	  hypot: function hypot(value1, value2){ // eslint-disable-line no-unused-vars
	    var sum  = 0
	      , i    = 0
	      , aLen = arguments.length
	      , larg = 0
	      , arg, div;
	    while(i < aLen){
	      arg = abs(arguments[i++]);
	      if(larg < arg){
	        div  = larg / arg;
	        sum  = sum * div * div + 1;
	        larg = arg;
	      } else if(arg > 0){
	        div  = arg / larg;
	        sum += div * div;
	      } else sum += arg;
	    }
	    return larg === Infinity ? Infinity : larg * Math.sqrt(sum);
	  }
	});

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.18 Math.imul(x, y)
	var $export = __webpack_require__(8)
	  , $imul   = Math.imul;
	
	// some WebKit versions fails with big numbers, some has wrong arity
	$export($export.S + $export.F * __webpack_require__(7)(function(){
	  return $imul(0xffffffff, 5) != -5 || $imul.length != 2;
	}), 'Math', {
	  imul: function imul(x, y){
	    var UINT16 = 0xffff
	      , xn = +x
	      , yn = +y
	      , xl = UINT16 & xn
	      , yl = UINT16 & yn;
	    return 0 | xl * yl + ((UINT16 & xn >>> 16) * yl + xl * (UINT16 & yn >>> 16) << 16 >>> 0);
	  }
	});

/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.21 Math.log10(x)
	var $export = __webpack_require__(8);
	
	$export($export.S, 'Math', {
	  log10: function log10(x){
	    return Math.log(x) / Math.LN10;
	  }
	});

/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.20 Math.log1p(x)
	var $export = __webpack_require__(8);
	
	$export($export.S, 'Math', {log1p: __webpack_require__(104)});

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.22 Math.log2(x)
	var $export = __webpack_require__(8);
	
	$export($export.S, 'Math', {
	  log2: function log2(x){
	    return Math.log(x) / Math.LN2;
	  }
	});

/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.28 Math.sign(x)
	var $export = __webpack_require__(8);
	
	$export($export.S, 'Math', {sign: __webpack_require__(108)});

/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.30 Math.sinh(x)
	var $export = __webpack_require__(8)
	  , expm1   = __webpack_require__(112)
	  , exp     = Math.exp;
	
	// V8 near Chromium 38 has a problem with very small numbers
	$export($export.S + $export.F * __webpack_require__(7)(function(){
	  return !Math.sinh(-2e-17) != -2e-17;
	}), 'Math', {
	  sinh: function sinh(x){
	    return Math.abs(x = +x) < 1
	      ? (expm1(x) - expm1(-x)) / 2
	      : (exp(x - 1) - exp(-x - 1)) * (Math.E / 2);
	  }
	});

/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.33 Math.tanh(x)
	var $export = __webpack_require__(8)
	  , expm1   = __webpack_require__(112)
	  , exp     = Math.exp;
	
	$export($export.S, 'Math', {
	  tanh: function tanh(x){
	    var a = expm1(x = +x)
	      , b = expm1(-x);
	    return a == Infinity ? 1 : b == Infinity ? -1 : (a - b) / (exp(x) + exp(-x));
	  }
	});

/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.34 Math.trunc(x)
	var $export = __webpack_require__(8);
	
	$export($export.S, 'Math', {
	  trunc: function trunc(it){
	    return (it > 0 ? Math.floor : Math.ceil)(it);
	  }
	});

/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

	var $export        = __webpack_require__(8)
	  , toIndex        = __webpack_require__(39)
	  , fromCharCode   = String.fromCharCode
	  , $fromCodePoint = String.fromCodePoint;
	
	// length should be 1, old FF problem
	$export($export.S + $export.F * (!!$fromCodePoint && $fromCodePoint.length != 1), 'String', {
	  // 21.1.2.2 String.fromCodePoint(...codePoints)
	  fromCodePoint: function fromCodePoint(x){ // eslint-disable-line no-unused-vars
	    var res  = []
	      , aLen = arguments.length
	      , i    = 0
	      , code;
	    while(aLen > i){
	      code = +arguments[i++];
	      if(toIndex(code, 0x10ffff) !== code)throw RangeError(code + ' is not a valid code point');
	      res.push(code < 0x10000
	        ? fromCharCode(code)
	        : fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00)
	      );
	    } return res.join('');
	  }
	});

/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

	var $export   = __webpack_require__(8)
	  , toIObject = __webpack_require__(32)
	  , toLength  = __webpack_require__(37);
	
	$export($export.S, 'String', {
	  // 21.1.2.4 String.raw(callSite, ...substitutions)
	  raw: function raw(callSite){
	    var tpl  = toIObject(callSite.raw)
	      , len  = toLength(tpl.length)
	      , aLen = arguments.length
	      , res  = []
	      , i    = 0;
	    while(len > i){
	      res.push(String(tpl[i++]));
	      if(i < aLen)res.push(String(arguments[i]));
	    } return res.join('');
	  }
	});

/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 21.1.3.25 String.prototype.trim()
	__webpack_require__(83)('trim', function($trim){
	  return function trim(){
	    return $trim(this, 3);
	  };
	});

/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $at  = __webpack_require__(127)(true);
	
	// 21.1.3.27 String.prototype[@@iterator]()
	__webpack_require__(128)(String, 'String', function(iterated){
	  this._t = String(iterated); // target
	  this._i = 0;                // next index
	// 21.1.5.2.1 %StringIteratorPrototype%.next()
	}, function(){
	  var O     = this._t
	    , index = this._i
	    , point;
	  if(index >= O.length)return {value: undefined, done: true};
	  point = $at(O, index);
	  this._i += point.length;
	  return {value: point, done: false};
	});

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(38)
	  , defined   = __webpack_require__(35);
	// true  -> String#at
	// false -> String#codePointAt
	module.exports = function(TO_STRING){
	  return function(that, pos){
	    var s = String(defined(that))
	      , i = toInteger(pos)
	      , l = s.length
	      , a, b;
	    if(i < 0 || i >= l)return TO_STRING ? '' : undefined;
	    a = s.charCodeAt(i);
	    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
	      ? TO_STRING ? s.charAt(i) : a
	      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
	  };
	};

/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY        = __webpack_require__(28)
	  , $export        = __webpack_require__(8)
	  , redefine       = __webpack_require__(18)
	  , hide           = __webpack_require__(10)
	  , has            = __webpack_require__(5)
	  , Iterators      = __webpack_require__(129)
	  , $iterCreate    = __webpack_require__(130)
	  , setToStringTag = __webpack_require__(24)
	  , getPrototypeOf = __webpack_require__(59)
	  , ITERATOR       = __webpack_require__(25)('iterator')
	  , BUGGY          = !([].keys && 'next' in [].keys()) // Safari has buggy iterators w/o `next`
	  , FF_ITERATOR    = '@@iterator'
	  , KEYS           = 'keys'
	  , VALUES         = 'values';
	
	var returnThis = function(){ return this; };
	
	module.exports = function(Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED){
	  $iterCreate(Constructor, NAME, next);
	  var getMethod = function(kind){
	    if(!BUGGY && kind in proto)return proto[kind];
	    switch(kind){
	      case KEYS: return function keys(){ return new Constructor(this, kind); };
	      case VALUES: return function values(){ return new Constructor(this, kind); };
	    } return function entries(){ return new Constructor(this, kind); };
	  };
	  var TAG        = NAME + ' Iterator'
	    , DEF_VALUES = DEFAULT == VALUES
	    , VALUES_BUG = false
	    , proto      = Base.prototype
	    , $native    = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT]
	    , $default   = $native || getMethod(DEFAULT)
	    , $entries   = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined
	    , $anyNative = NAME == 'Array' ? proto.entries || $native : $native
	    , methods, key, IteratorPrototype;
	  // Fix native
	  if($anyNative){
	    IteratorPrototype = getPrototypeOf($anyNative.call(new Base));
	    if(IteratorPrototype !== Object.prototype){
	      // Set @@toStringTag to native iterators
	      setToStringTag(IteratorPrototype, TAG, true);
	      // fix for some old engines
	      if(!LIBRARY && !has(IteratorPrototype, ITERATOR))hide(IteratorPrototype, ITERATOR, returnThis);
	    }
	  }
	  // fix Array#{values, @@iterator}.name in V8 / FF
	  if(DEF_VALUES && $native && $native.name !== VALUES){
	    VALUES_BUG = true;
	    $default = function values(){ return $native.call(this); };
	  }
	  // Define iterator
	  if((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])){
	    hide(proto, ITERATOR, $default);
	  }
	  // Plug for library
	  Iterators[NAME] = $default;
	  Iterators[TAG]  = returnThis;
	  if(DEFAULT){
	    methods = {
	      values:  DEF_VALUES ? $default : getMethod(VALUES),
	      keys:    IS_SET     ? $default : getMethod(KEYS),
	      entries: $entries
	    };
	    if(FORCED)for(key in methods){
	      if(!(key in proto))redefine(proto, key, methods[key]);
	    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
	  }
	  return methods;
	};

/***/ }),
/* 129 */
/***/ (function(module, exports) {

	module.exports = {};

/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var create         = __webpack_require__(46)
	  , descriptor     = __webpack_require__(17)
	  , setToStringTag = __webpack_require__(24)
	  , IteratorPrototype = {};
	
	// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
	__webpack_require__(10)(IteratorPrototype, __webpack_require__(25)('iterator'), function(){ return this; });
	
	module.exports = function(Constructor, NAME, next){
	  Constructor.prototype = create(IteratorPrototype, {next: descriptor(1, next)});
	  setToStringTag(Constructor, NAME + ' Iterator');
	};

/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(8)
	  , $at     = __webpack_require__(127)(false);
	$export($export.P, 'String', {
	  // 21.1.3.3 String.prototype.codePointAt(pos)
	  codePointAt: function codePointAt(pos){
	    return $at(this, pos);
	  }
	});

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

	// 21.1.3.6 String.prototype.endsWith(searchString [, endPosition])
	'use strict';
	var $export   = __webpack_require__(8)
	  , toLength  = __webpack_require__(37)
	  , context   = __webpack_require__(133)
	  , ENDS_WITH = 'endsWith'
	  , $endsWith = ''[ENDS_WITH];
	
	$export($export.P + $export.F * __webpack_require__(135)(ENDS_WITH), 'String', {
	  endsWith: function endsWith(searchString /*, endPosition = @length */){
	    var that = context(this, searchString, ENDS_WITH)
	      , endPosition = arguments.length > 1 ? arguments[1] : undefined
	      , len    = toLength(that.length)
	      , end    = endPosition === undefined ? len : Math.min(toLength(endPosition), len)
	      , search = String(searchString);
	    return $endsWith
	      ? $endsWith.call(that, search, end)
	      : that.slice(end - search.length, end) === search;
	  }
	});

/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

	// helper for String#{startsWith, endsWith, includes}
	var isRegExp = __webpack_require__(134)
	  , defined  = __webpack_require__(35);
	
	module.exports = function(that, searchString, NAME){
	  if(isRegExp(searchString))throw TypeError('String#' + NAME + " doesn't accept regex!");
	  return String(defined(that));
	};

/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.2.8 IsRegExp(argument)
	var isObject = __webpack_require__(13)
	  , cof      = __webpack_require__(34)
	  , MATCH    = __webpack_require__(25)('match');
	module.exports = function(it){
	  var isRegExp;
	  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : cof(it) == 'RegExp');
	};

/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

	var MATCH = __webpack_require__(25)('match');
	module.exports = function(KEY){
	  var re = /./;
	  try {
	    '/./'[KEY](re);
	  } catch(e){
	    try {
	      re[MATCH] = false;
	      return !'/./'[KEY](re);
	    } catch(f){ /* empty */ }
	  } return true;
	};

/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

	// 21.1.3.7 String.prototype.includes(searchString, position = 0)
	'use strict';
	var $export  = __webpack_require__(8)
	  , context  = __webpack_require__(133)
	  , INCLUDES = 'includes';
	
	$export($export.P + $export.F * __webpack_require__(135)(INCLUDES), 'String', {
	  includes: function includes(searchString /*, position = 0 */){
	    return !!~context(this, searchString, INCLUDES)
	      .indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});

/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(8);
	
	$export($export.P, 'String', {
	  // 21.1.3.13 String.prototype.repeat(count)
	  repeat: __webpack_require__(91)
	});

/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

	// 21.1.3.18 String.prototype.startsWith(searchString [, position ])
	'use strict';
	var $export     = __webpack_require__(8)
	  , toLength    = __webpack_require__(37)
	  , context     = __webpack_require__(133)
	  , STARTS_WITH = 'startsWith'
	  , $startsWith = ''[STARTS_WITH];
	
	$export($export.P + $export.F * __webpack_require__(135)(STARTS_WITH), 'String', {
	  startsWith: function startsWith(searchString /*, position = 0 */){
	    var that   = context(this, searchString, STARTS_WITH)
	      , index  = toLength(Math.min(arguments.length > 1 ? arguments[1] : undefined, that.length))
	      , search = String(searchString);
	    return $startsWith
	      ? $startsWith.call(that, search, index)
	      : that.slice(index, index + search.length) === search;
	  }
	});

/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.2 String.prototype.anchor(name)
	__webpack_require__(140)('anchor', function(createHTML){
	  return function anchor(name){
	    return createHTML(this, 'a', 'name', name);
	  }
	});

/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(8)
	  , fails   = __webpack_require__(7)
	  , defined = __webpack_require__(35)
	  , quot    = /"/g;
	// B.2.3.2.1 CreateHTML(string, tag, attribute, value)
	var createHTML = function(string, tag, attribute, value) {
	  var S  = String(defined(string))
	    , p1 = '<' + tag;
	  if(attribute !== '')p1 += ' ' + attribute + '="' + String(value).replace(quot, '&quot;') + '"';
	  return p1 + '>' + S + '</' + tag + '>';
	};
	module.exports = function(NAME, exec){
	  var O = {};
	  O[NAME] = exec(createHTML);
	  $export($export.P + $export.F * fails(function(){
	    var test = ''[NAME]('"');
	    return test !== test.toLowerCase() || test.split('"').length > 3;
	  }), 'String', O);
	};

/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.3 String.prototype.big()
	__webpack_require__(140)('big', function(createHTML){
	  return function big(){
	    return createHTML(this, 'big', '', '');
	  }
	});

/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.4 String.prototype.blink()
	__webpack_require__(140)('blink', function(createHTML){
	  return function blink(){
	    return createHTML(this, 'blink', '', '');
	  }
	});

/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.5 String.prototype.bold()
	__webpack_require__(140)('bold', function(createHTML){
	  return function bold(){
	    return createHTML(this, 'b', '', '');
	  }
	});

/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.6 String.prototype.fixed()
	__webpack_require__(140)('fixed', function(createHTML){
	  return function fixed(){
	    return createHTML(this, 'tt', '', '');
	  }
	});

/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.7 String.prototype.fontcolor(color)
	__webpack_require__(140)('fontcolor', function(createHTML){
	  return function fontcolor(color){
	    return createHTML(this, 'font', 'color', color);
	  }
	});

/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.8 String.prototype.fontsize(size)
	__webpack_require__(140)('fontsize', function(createHTML){
	  return function fontsize(size){
	    return createHTML(this, 'font', 'size', size);
	  }
	});

/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.9 String.prototype.italics()
	__webpack_require__(140)('italics', function(createHTML){
	  return function italics(){
	    return createHTML(this, 'i', '', '');
	  }
	});

/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.10 String.prototype.link(url)
	__webpack_require__(140)('link', function(createHTML){
	  return function link(url){
	    return createHTML(this, 'a', 'href', url);
	  }
	});

/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.11 String.prototype.small()
	__webpack_require__(140)('small', function(createHTML){
	  return function small(){
	    return createHTML(this, 'small', '', '');
	  }
	});

/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.12 String.prototype.strike()
	__webpack_require__(140)('strike', function(createHTML){
	  return function strike(){
	    return createHTML(this, 'strike', '', '');
	  }
	});

/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.13 String.prototype.sub()
	__webpack_require__(140)('sub', function(createHTML){
	  return function sub(){
	    return createHTML(this, 'sub', '', '');
	  }
	});

/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.14 String.prototype.sup()
	__webpack_require__(140)('sup', function(createHTML){
	  return function sup(){
	    return createHTML(this, 'sup', '', '');
	  }
	});

/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.3.3.1 / 15.9.4.4 Date.now()
	var $export = __webpack_require__(8);
	
	$export($export.S, 'Date', {now: function(){ return new Date().getTime(); }});

/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export     = __webpack_require__(8)
	  , toObject    = __webpack_require__(58)
	  , toPrimitive = __webpack_require__(16);
	
	$export($export.P + $export.F * __webpack_require__(7)(function(){
	  return new Date(NaN).toJSON() !== null || Date.prototype.toJSON.call({toISOString: function(){ return 1; }}) !== 1;
	}), 'Date', {
	  toJSON: function toJSON(key){
	    var O  = toObject(this)
	      , pv = toPrimitive(O);
	    return typeof pv == 'number' && !isFinite(pv) ? null : O.toISOString();
	  }
	});

/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
	var $export = __webpack_require__(8)
	  , fails   = __webpack_require__(7)
	  , getTime = Date.prototype.getTime;
	
	var lz = function(num){
	  return num > 9 ? num : '0' + num;
	};
	
	// PhantomJS / old WebKit has a broken implementations
	$export($export.P + $export.F * (fails(function(){
	  return new Date(-5e13 - 1).toISOString() != '0385-07-25T07:06:39.999Z';
	}) || !fails(function(){
	  new Date(NaN).toISOString();
	})), 'Date', {
	  toISOString: function toISOString(){
	    if(!isFinite(getTime.call(this)))throw RangeError('Invalid time value');
	    var d = this
	      , y = d.getUTCFullYear()
	      , m = d.getUTCMilliseconds()
	      , s = y < 0 ? '-' : y > 9999 ? '+' : '';
	    return s + ('00000' + Math.abs(y)).slice(s ? -6 : -4) +
	      '-' + lz(d.getUTCMonth() + 1) + '-' + lz(d.getUTCDate()) +
	      'T' + lz(d.getUTCHours()) + ':' + lz(d.getUTCMinutes()) +
	      ':' + lz(d.getUTCSeconds()) + '.' + (m > 99 ? m : '0' + lz(m)) + 'Z';
	  }
	});

/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

	var DateProto    = Date.prototype
	  , INVALID_DATE = 'Invalid Date'
	  , TO_STRING    = 'toString'
	  , $toString    = DateProto[TO_STRING]
	  , getTime      = DateProto.getTime;
	if(new Date(NaN) + '' != INVALID_DATE){
	  __webpack_require__(18)(DateProto, TO_STRING, function toString(){
	    var value = getTime.call(this);
	    return value === value ? $toString.call(this) : INVALID_DATE;
	  });
	}

/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

	var TO_PRIMITIVE = __webpack_require__(25)('toPrimitive')
	  , proto        = Date.prototype;
	
	if(!(TO_PRIMITIVE in proto))__webpack_require__(10)(proto, TO_PRIMITIVE, __webpack_require__(158));

/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var anObject    = __webpack_require__(12)
	  , toPrimitive = __webpack_require__(16)
	  , NUMBER      = 'number';
	
	module.exports = function(hint){
	  if(hint !== 'string' && hint !== NUMBER && hint !== 'default')throw TypeError('Incorrect hint');
	  return toPrimitive(anObject(this), hint != NUMBER);
	};

/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

	// 22.1.2.2 / 15.4.3.2 Array.isArray(arg)
	var $export = __webpack_require__(8);
	
	$export($export.S, 'Array', {isArray: __webpack_require__(45)});

/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var ctx            = __webpack_require__(20)
	  , $export        = __webpack_require__(8)
	  , toObject       = __webpack_require__(58)
	  , call           = __webpack_require__(161)
	  , isArrayIter    = __webpack_require__(162)
	  , toLength       = __webpack_require__(37)
	  , createProperty = __webpack_require__(163)
	  , getIterFn      = __webpack_require__(164);
	
	$export($export.S + $export.F * !__webpack_require__(165)(function(iter){ Array.from(iter); }), 'Array', {
	  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
	  from: function from(arrayLike/*, mapfn = undefined, thisArg = undefined*/){
	    var O       = toObject(arrayLike)
	      , C       = typeof this == 'function' ? this : Array
	      , aLen    = arguments.length
	      , mapfn   = aLen > 1 ? arguments[1] : undefined
	      , mapping = mapfn !== undefined
	      , index   = 0
	      , iterFn  = getIterFn(O)
	      , length, result, step, iterator;
	    if(mapping)mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
	    // if object isn't iterable or it's array with default iterator - use simple case
	    if(iterFn != undefined && !(C == Array && isArrayIter(iterFn))){
	      for(iterator = iterFn.call(O), result = new C; !(step = iterator.next()).done; index++){
	        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
	      }
	    } else {
	      length = toLength(O.length);
	      for(result = new C(length); length > index; index++){
	        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
	      }
	    }
	    result.length = index;
	    return result;
	  }
	});


/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

	// call something on iterator step with safe closing on error
	var anObject = __webpack_require__(12);
	module.exports = function(iterator, fn, value, entries){
	  try {
	    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
	  // 7.4.6 IteratorClose(iterator, completion)
	  } catch(e){
	    var ret = iterator['return'];
	    if(ret !== undefined)anObject(ret.call(iterator));
	    throw e;
	  }
	};

/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

	// check on default Array iterator
	var Iterators  = __webpack_require__(129)
	  , ITERATOR   = __webpack_require__(25)('iterator')
	  , ArrayProto = Array.prototype;
	
	module.exports = function(it){
	  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
	};

/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $defineProperty = __webpack_require__(11)
	  , createDesc      = __webpack_require__(17);
	
	module.exports = function(object, index, value){
	  if(index in object)$defineProperty.f(object, index, createDesc(0, value));
	  else object[index] = value;
	};

/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

	var classof   = __webpack_require__(75)
	  , ITERATOR  = __webpack_require__(25)('iterator')
	  , Iterators = __webpack_require__(129);
	module.exports = __webpack_require__(9).getIteratorMethod = function(it){
	  if(it != undefined)return it[ITERATOR]
	    || it['@@iterator']
	    || Iterators[classof(it)];
	};

/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

	var ITERATOR     = __webpack_require__(25)('iterator')
	  , SAFE_CLOSING = false;
	
	try {
	  var riter = [7][ITERATOR]();
	  riter['return'] = function(){ SAFE_CLOSING = true; };
	  Array.from(riter, function(){ throw 2; });
	} catch(e){ /* empty */ }
	
	module.exports = function(exec, skipClosing){
	  if(!skipClosing && !SAFE_CLOSING)return false;
	  var safe = false;
	  try {
	    var arr  = [7]
	      , iter = arr[ITERATOR]();
	    iter.next = function(){ return {done: safe = true}; };
	    arr[ITERATOR] = function(){ return iter; };
	    exec(arr);
	  } catch(e){ /* empty */ }
	  return safe;
	};

/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export        = __webpack_require__(8)
	  , createProperty = __webpack_require__(163);
	
	// WebKit Array.of isn't generic
	$export($export.S + $export.F * __webpack_require__(7)(function(){
	  function F(){}
	  return !(Array.of.call(F) instanceof F);
	}), 'Array', {
	  // 22.1.2.3 Array.of( ...items)
	  of: function of(/* ...args */){
	    var index  = 0
	      , aLen   = arguments.length
	      , result = new (typeof this == 'function' ? this : Array)(aLen);
	    while(aLen > index)createProperty(result, index, arguments[index++]);
	    result.length = aLen;
	    return result;
	  }
	});

/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 22.1.3.13 Array.prototype.join(separator)
	var $export   = __webpack_require__(8)
	  , toIObject = __webpack_require__(32)
	  , arrayJoin = [].join;
	
	// fallback for not array-like strings
	$export($export.P + $export.F * (__webpack_require__(33) != Object || !__webpack_require__(168)(arrayJoin)), 'Array', {
	  join: function join(separator){
	    return arrayJoin.call(toIObject(this), separator === undefined ? ',' : separator);
	  }
	});

/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

	var fails = __webpack_require__(7);
	
	module.exports = function(method, arg){
	  return !!method && fails(function(){
	    arg ? method.call(null, function(){}, 1) : method.call(null);
	  });
	};

/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export    = __webpack_require__(8)
	  , html       = __webpack_require__(48)
	  , cof        = __webpack_require__(34)
	  , toIndex    = __webpack_require__(39)
	  , toLength   = __webpack_require__(37)
	  , arraySlice = [].slice;
	
	// fallback for not array-like ES3 strings and DOM objects
	$export($export.P + $export.F * __webpack_require__(7)(function(){
	  if(html)arraySlice.call(html);
	}), 'Array', {
	  slice: function slice(begin, end){
	    var len   = toLength(this.length)
	      , klass = cof(this);
	    end = end === undefined ? len : end;
	    if(klass == 'Array')return arraySlice.call(this, begin, end);
	    var start  = toIndex(begin, len)
	      , upTo   = toIndex(end, len)
	      , size   = toLength(upTo - start)
	      , cloned = Array(size)
	      , i      = 0;
	    for(; i < size; i++)cloned[i] = klass == 'String'
	      ? this.charAt(start + i)
	      : this[start + i];
	    return cloned;
	  }
	});

/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export   = __webpack_require__(8)
	  , aFunction = __webpack_require__(21)
	  , toObject  = __webpack_require__(58)
	  , fails     = __webpack_require__(7)
	  , $sort     = [].sort
	  , test      = [1, 2, 3];
	
	$export($export.P + $export.F * (fails(function(){
	  // IE8-
	  test.sort(undefined);
	}) || !fails(function(){
	  // V8 bug
	  test.sort(null);
	  // Old WebKit
	}) || !__webpack_require__(168)($sort)), 'Array', {
	  // 22.1.3.25 Array.prototype.sort(comparefn)
	  sort: function sort(comparefn){
	    return comparefn === undefined
	      ? $sort.call(toObject(this))
	      : $sort.call(toObject(this), aFunction(comparefn));
	  }
	});

/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export  = __webpack_require__(8)
	  , $forEach = __webpack_require__(172)(0)
	  , STRICT   = __webpack_require__(168)([].forEach, true);
	
	$export($export.P + $export.F * !STRICT, 'Array', {
	  // 22.1.3.10 / 15.4.4.18 Array.prototype.forEach(callbackfn [, thisArg])
	  forEach: function forEach(callbackfn /* , thisArg */){
	    return $forEach(this, callbackfn, arguments[1]);
	  }
	});

/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

	// 0 -> Array#forEach
	// 1 -> Array#map
	// 2 -> Array#filter
	// 3 -> Array#some
	// 4 -> Array#every
	// 5 -> Array#find
	// 6 -> Array#findIndex
	var ctx      = __webpack_require__(20)
	  , IObject  = __webpack_require__(33)
	  , toObject = __webpack_require__(58)
	  , toLength = __webpack_require__(37)
	  , asc      = __webpack_require__(173);
	module.exports = function(TYPE, $create){
	  var IS_MAP        = TYPE == 1
	    , IS_FILTER     = TYPE == 2
	    , IS_SOME       = TYPE == 3
	    , IS_EVERY      = TYPE == 4
	    , IS_FIND_INDEX = TYPE == 6
	    , NO_HOLES      = TYPE == 5 || IS_FIND_INDEX
	    , create        = $create || asc;
	  return function($this, callbackfn, that){
	    var O      = toObject($this)
	      , self   = IObject(O)
	      , f      = ctx(callbackfn, that, 3)
	      , length = toLength(self.length)
	      , index  = 0
	      , result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined
	      , val, res;
	    for(;length > index; index++)if(NO_HOLES || index in self){
	      val = self[index];
	      res = f(val, index, O);
	      if(TYPE){
	        if(IS_MAP)result[index] = res;            // map
	        else if(res)switch(TYPE){
	          case 3: return true;                    // some
	          case 5: return val;                     // find
	          case 6: return index;                   // findIndex
	          case 2: result.push(val);               // filter
	        } else if(IS_EVERY)return false;          // every
	      }
	    }
	    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
	  };
	};

/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

	// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
	var speciesConstructor = __webpack_require__(174);
	
	module.exports = function(original, length){
	  return new (speciesConstructor(original))(length);
	};

/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(13)
	  , isArray  = __webpack_require__(45)
	  , SPECIES  = __webpack_require__(25)('species');
	
	module.exports = function(original){
	  var C;
	  if(isArray(original)){
	    C = original.constructor;
	    // cross-realm fallback
	    if(typeof C == 'function' && (C === Array || isArray(C.prototype)))C = undefined;
	    if(isObject(C)){
	      C = C[SPECIES];
	      if(C === null)C = undefined;
	    }
	  } return C === undefined ? Array : C;
	};

/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(8)
	  , $map    = __webpack_require__(172)(1);
	
	$export($export.P + $export.F * !__webpack_require__(168)([].map, true), 'Array', {
	  // 22.1.3.15 / 15.4.4.19 Array.prototype.map(callbackfn [, thisArg])
	  map: function map(callbackfn /* , thisArg */){
	    return $map(this, callbackfn, arguments[1]);
	  }
	});

/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(8)
	  , $filter = __webpack_require__(172)(2);
	
	$export($export.P + $export.F * !__webpack_require__(168)([].filter, true), 'Array', {
	  // 22.1.3.7 / 15.4.4.20 Array.prototype.filter(callbackfn [, thisArg])
	  filter: function filter(callbackfn /* , thisArg */){
	    return $filter(this, callbackfn, arguments[1]);
	  }
	});

/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(8)
	  , $some   = __webpack_require__(172)(3);
	
	$export($export.P + $export.F * !__webpack_require__(168)([].some, true), 'Array', {
	  // 22.1.3.23 / 15.4.4.17 Array.prototype.some(callbackfn [, thisArg])
	  some: function some(callbackfn /* , thisArg */){
	    return $some(this, callbackfn, arguments[1]);
	  }
	});

/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(8)
	  , $every  = __webpack_require__(172)(4);
	
	$export($export.P + $export.F * !__webpack_require__(168)([].every, true), 'Array', {
	  // 22.1.3.5 / 15.4.4.16 Array.prototype.every(callbackfn [, thisArg])
	  every: function every(callbackfn /* , thisArg */){
	    return $every(this, callbackfn, arguments[1]);
	  }
	});

/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(8)
	  , $reduce = __webpack_require__(180);
	
	$export($export.P + $export.F * !__webpack_require__(168)([].reduce, true), 'Array', {
	  // 22.1.3.18 / 15.4.4.21 Array.prototype.reduce(callbackfn [, initialValue])
	  reduce: function reduce(callbackfn /* , initialValue */){
	    return $reduce(this, callbackfn, arguments.length, arguments[1], false);
	  }
	});

/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

	var aFunction = __webpack_require__(21)
	  , toObject  = __webpack_require__(58)
	  , IObject   = __webpack_require__(33)
	  , toLength  = __webpack_require__(37);
	
	module.exports = function(that, callbackfn, aLen, memo, isRight){
	  aFunction(callbackfn);
	  var O      = toObject(that)
	    , self   = IObject(O)
	    , length = toLength(O.length)
	    , index  = isRight ? length - 1 : 0
	    , i      = isRight ? -1 : 1;
	  if(aLen < 2)for(;;){
	    if(index in self){
	      memo = self[index];
	      index += i;
	      break;
	    }
	    index += i;
	    if(isRight ? index < 0 : length <= index){
	      throw TypeError('Reduce of empty array with no initial value');
	    }
	  }
	  for(;isRight ? index >= 0 : length > index; index += i)if(index in self){
	    memo = callbackfn(memo, self[index], index, O);
	  }
	  return memo;
	};

/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(8)
	  , $reduce = __webpack_require__(180);
	
	$export($export.P + $export.F * !__webpack_require__(168)([].reduceRight, true), 'Array', {
	  // 22.1.3.19 / 15.4.4.22 Array.prototype.reduceRight(callbackfn [, initialValue])
	  reduceRight: function reduceRight(callbackfn /* , initialValue */){
	    return $reduce(this, callbackfn, arguments.length, arguments[1], true);
	  }
	});

/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export       = __webpack_require__(8)
	  , $indexOf      = __webpack_require__(36)(false)
	  , $native       = [].indexOf
	  , NEGATIVE_ZERO = !!$native && 1 / [1].indexOf(1, -0) < 0;
	
	$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(168)($native)), 'Array', {
	  // 22.1.3.11 / 15.4.4.14 Array.prototype.indexOf(searchElement [, fromIndex])
	  indexOf: function indexOf(searchElement /*, fromIndex = 0 */){
	    return NEGATIVE_ZERO
	      // convert -0 to +0
	      ? $native.apply(this, arguments) || 0
	      : $indexOf(this, searchElement, arguments[1]);
	  }
	});

/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export       = __webpack_require__(8)
	  , toIObject     = __webpack_require__(32)
	  , toInteger     = __webpack_require__(38)
	  , toLength      = __webpack_require__(37)
	  , $native       = [].lastIndexOf
	  , NEGATIVE_ZERO = !!$native && 1 / [1].lastIndexOf(1, -0) < 0;
	
	$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(168)($native)), 'Array', {
	  // 22.1.3.14 / 15.4.4.15 Array.prototype.lastIndexOf(searchElement [, fromIndex])
	  lastIndexOf: function lastIndexOf(searchElement /*, fromIndex = @[*-1] */){
	    // convert -0 to +0
	    if(NEGATIVE_ZERO)return $native.apply(this, arguments) || 0;
	    var O      = toIObject(this)
	      , length = toLength(O.length)
	      , index  = length - 1;
	    if(arguments.length > 1)index = Math.min(index, toInteger(arguments[1]));
	    if(index < 0)index = length + index;
	    for(;index >= 0; index--)if(index in O)if(O[index] === searchElement)return index || 0;
	    return -1;
	  }
	});

/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

	// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
	var $export = __webpack_require__(8);
	
	$export($export.P, 'Array', {copyWithin: __webpack_require__(185)});
	
	__webpack_require__(186)('copyWithin');

/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

	// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
	'use strict';
	var toObject = __webpack_require__(58)
	  , toIndex  = __webpack_require__(39)
	  , toLength = __webpack_require__(37);
	
	module.exports = [].copyWithin || function copyWithin(target/*= 0*/, start/*= 0, end = @length*/){
	  var O     = toObject(this)
	    , len   = toLength(O.length)
	    , to    = toIndex(target, len)
	    , from  = toIndex(start, len)
	    , end   = arguments.length > 2 ? arguments[2] : undefined
	    , count = Math.min((end === undefined ? len : toIndex(end, len)) - from, len - to)
	    , inc   = 1;
	  if(from < to && to < from + count){
	    inc  = -1;
	    from += count - 1;
	    to   += count - 1;
	  }
	  while(count-- > 0){
	    if(from in O)O[to] = O[from];
	    else delete O[to];
	    to   += inc;
	    from += inc;
	  } return O;
	};

/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

	// 22.1.3.31 Array.prototype[@@unscopables]
	var UNSCOPABLES = __webpack_require__(25)('unscopables')
	  , ArrayProto  = Array.prototype;
	if(ArrayProto[UNSCOPABLES] == undefined)__webpack_require__(10)(ArrayProto, UNSCOPABLES, {});
	module.exports = function(key){
	  ArrayProto[UNSCOPABLES][key] = true;
	};

/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

	// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
	var $export = __webpack_require__(8);
	
	$export($export.P, 'Array', {fill: __webpack_require__(188)});
	
	__webpack_require__(186)('fill');

/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

	// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
	'use strict';
	var toObject = __webpack_require__(58)
	  , toIndex  = __webpack_require__(39)
	  , toLength = __webpack_require__(37);
	module.exports = function fill(value /*, start = 0, end = @length */){
	  var O      = toObject(this)
	    , length = toLength(O.length)
	    , aLen   = arguments.length
	    , index  = toIndex(aLen > 1 ? arguments[1] : undefined, length)
	    , end    = aLen > 2 ? arguments[2] : undefined
	    , endPos = end === undefined ? length : toIndex(end, length);
	  while(endPos > index)O[index++] = value;
	  return O;
	};

/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)
	var $export = __webpack_require__(8)
	  , $find   = __webpack_require__(172)(5)
	  , KEY     = 'find'
	  , forced  = true;
	// Shouldn't skip holes
	if(KEY in [])Array(1)[KEY](function(){ forced = false; });
	$export($export.P + $export.F * forced, 'Array', {
	  find: function find(callbackfn/*, that = undefined */){
	    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	__webpack_require__(186)(KEY);

/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 22.1.3.9 Array.prototype.findIndex(predicate, thisArg = undefined)
	var $export = __webpack_require__(8)
	  , $find   = __webpack_require__(172)(6)
	  , KEY     = 'findIndex'
	  , forced  = true;
	// Shouldn't skip holes
	if(KEY in [])Array(1)[KEY](function(){ forced = false; });
	$export($export.P + $export.F * forced, 'Array', {
	  findIndex: function findIndex(callbackfn/*, that = undefined */){
	    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	__webpack_require__(186)(KEY);

/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(192)('Array');

/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var global      = __webpack_require__(4)
	  , dP          = __webpack_require__(11)
	  , DESCRIPTORS = __webpack_require__(6)
	  , SPECIES     = __webpack_require__(25)('species');
	
	module.exports = function(KEY){
	  var C = global[KEY];
	  if(DESCRIPTORS && C && !C[SPECIES])dP.f(C, SPECIES, {
	    configurable: true,
	    get: function(){ return this; }
	  });
	};

/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var addToUnscopables = __webpack_require__(186)
	  , step             = __webpack_require__(194)
	  , Iterators        = __webpack_require__(129)
	  , toIObject        = __webpack_require__(32);
	
	// 22.1.3.4 Array.prototype.entries()
	// 22.1.3.13 Array.prototype.keys()
	// 22.1.3.29 Array.prototype.values()
	// 22.1.3.30 Array.prototype[@@iterator]()
	module.exports = __webpack_require__(128)(Array, 'Array', function(iterated, kind){
	  this._t = toIObject(iterated); // target
	  this._i = 0;                   // next index
	  this._k = kind;                // kind
	// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
	}, function(){
	  var O     = this._t
	    , kind  = this._k
	    , index = this._i++;
	  if(!O || index >= O.length){
	    this._t = undefined;
	    return step(1);
	  }
	  if(kind == 'keys'  )return step(0, index);
	  if(kind == 'values')return step(0, O[index]);
	  return step(0, [index, O[index]]);
	}, 'values');
	
	// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
	Iterators.Arguments = Iterators.Array;
	
	addToUnscopables('keys');
	addToUnscopables('values');
	addToUnscopables('entries');

/***/ }),
/* 194 */
/***/ (function(module, exports) {

	module.exports = function(done, value){
	  return {value: value, done: !!done};
	};

/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

	var global            = __webpack_require__(4)
	  , inheritIfRequired = __webpack_require__(88)
	  , dP                = __webpack_require__(11).f
	  , gOPN              = __webpack_require__(50).f
	  , isRegExp          = __webpack_require__(134)
	  , $flags            = __webpack_require__(196)
	  , $RegExp           = global.RegExp
	  , Base              = $RegExp
	  , proto             = $RegExp.prototype
	  , re1               = /a/g
	  , re2               = /a/g
	  // "new" creates a new object, old webkit buggy here
	  , CORRECT_NEW       = new $RegExp(re1) !== re1;
	
	if(__webpack_require__(6) && (!CORRECT_NEW || __webpack_require__(7)(function(){
	  re2[__webpack_require__(25)('match')] = false;
	  // RegExp constructor can alter flags and IsRegExp works correct with @@match
	  return $RegExp(re1) != re1 || $RegExp(re2) == re2 || $RegExp(re1, 'i') != '/a/i';
	}))){
	  $RegExp = function RegExp(p, f){
	    var tiRE = this instanceof $RegExp
	      , piRE = isRegExp(p)
	      , fiU  = f === undefined;
	    return !tiRE && piRE && p.constructor === $RegExp && fiU ? p
	      : inheritIfRequired(CORRECT_NEW
	        ? new Base(piRE && !fiU ? p.source : p, f)
	        : Base((piRE = p instanceof $RegExp) ? p.source : p, piRE && fiU ? $flags.call(p) : f)
	      , tiRE ? this : proto, $RegExp);
	  };
	  var proxy = function(key){
	    key in $RegExp || dP($RegExp, key, {
	      configurable: true,
	      get: function(){ return Base[key]; },
	      set: function(it){ Base[key] = it; }
	    });
	  };
	  for(var keys = gOPN(Base), i = 0; keys.length > i; )proxy(keys[i++]);
	  proto.constructor = $RegExp;
	  $RegExp.prototype = proto;
	  __webpack_require__(18)(global, 'RegExp', $RegExp);
	}
	
	__webpack_require__(192)('RegExp');

/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 21.2.5.3 get RegExp.prototype.flags
	var anObject = __webpack_require__(12);
	module.exports = function(){
	  var that   = anObject(this)
	    , result = '';
	  if(that.global)     result += 'g';
	  if(that.ignoreCase) result += 'i';
	  if(that.multiline)  result += 'm';
	  if(that.unicode)    result += 'u';
	  if(that.sticky)     result += 'y';
	  return result;
	};

/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	__webpack_require__(198);
	var anObject    = __webpack_require__(12)
	  , $flags      = __webpack_require__(196)
	  , DESCRIPTORS = __webpack_require__(6)
	  , TO_STRING   = 'toString'
	  , $toString   = /./[TO_STRING];
	
	var define = function(fn){
	  __webpack_require__(18)(RegExp.prototype, TO_STRING, fn, true);
	};
	
	// 21.2.5.14 RegExp.prototype.toString()
	if(__webpack_require__(7)(function(){ return $toString.call({source: 'a', flags: 'b'}) != '/a/b'; })){
	  define(function toString(){
	    var R = anObject(this);
	    return '/'.concat(R.source, '/',
	      'flags' in R ? R.flags : !DESCRIPTORS && R instanceof RegExp ? $flags.call(R) : undefined);
	  });
	// FF44- RegExp#toString has a wrong name
	} else if($toString.name != TO_STRING){
	  define(function toString(){
	    return $toString.call(this);
	  });
	}

/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

	// 21.2.5.3 get RegExp.prototype.flags()
	if(__webpack_require__(6) && /./g.flags != 'g')__webpack_require__(11).f(RegExp.prototype, 'flags', {
	  configurable: true,
	  get: __webpack_require__(196)
	});

/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

	// @@match logic
	__webpack_require__(200)('match', 1, function(defined, MATCH, $match){
	  // 21.1.3.11 String.prototype.match(regexp)
	  return [function match(regexp){
	    'use strict';
	    var O  = defined(this)
	      , fn = regexp == undefined ? undefined : regexp[MATCH];
	    return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
	  }, $match];
	});

/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var hide     = __webpack_require__(10)
	  , redefine = __webpack_require__(18)
	  , fails    = __webpack_require__(7)
	  , defined  = __webpack_require__(35)
	  , wks      = __webpack_require__(25);
	
	module.exports = function(KEY, length, exec){
	  var SYMBOL   = wks(KEY)
	    , fns      = exec(defined, SYMBOL, ''[KEY])
	    , strfn    = fns[0]
	    , rxfn     = fns[1];
	  if(fails(function(){
	    var O = {};
	    O[SYMBOL] = function(){ return 7; };
	    return ''[KEY](O) != 7;
	  })){
	    redefine(String.prototype, KEY, strfn);
	    hide(RegExp.prototype, SYMBOL, length == 2
	      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
	      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
	      ? function(string, arg){ return rxfn.call(string, this, arg); }
	      // 21.2.5.6 RegExp.prototype[@@match](string)
	      // 21.2.5.9 RegExp.prototype[@@search](string)
	      : function(string){ return rxfn.call(string, this); }
	    );
	  }
	};

/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

	// @@replace logic
	__webpack_require__(200)('replace', 2, function(defined, REPLACE, $replace){
	  // 21.1.3.14 String.prototype.replace(searchValue, replaceValue)
	  return [function replace(searchValue, replaceValue){
	    'use strict';
	    var O  = defined(this)
	      , fn = searchValue == undefined ? undefined : searchValue[REPLACE];
	    return fn !== undefined
	      ? fn.call(searchValue, O, replaceValue)
	      : $replace.call(String(O), searchValue, replaceValue);
	  }, $replace];
	});

/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

	// @@search logic
	__webpack_require__(200)('search', 1, function(defined, SEARCH, $search){
	  // 21.1.3.15 String.prototype.search(regexp)
	  return [function search(regexp){
	    'use strict';
	    var O  = defined(this)
	      , fn = regexp == undefined ? undefined : regexp[SEARCH];
	    return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[SEARCH](String(O));
	  }, $search];
	});

/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

	// @@split logic
	__webpack_require__(200)('split', 2, function(defined, SPLIT, $split){
	  'use strict';
	  var isRegExp   = __webpack_require__(134)
	    , _split     = $split
	    , $push      = [].push
	    , $SPLIT     = 'split'
	    , LENGTH     = 'length'
	    , LAST_INDEX = 'lastIndex';
	  if(
	    'abbc'[$SPLIT](/(b)*/)[1] == 'c' ||
	    'test'[$SPLIT](/(?:)/, -1)[LENGTH] != 4 ||
	    'ab'[$SPLIT](/(?:ab)*/)[LENGTH] != 2 ||
	    '.'[$SPLIT](/(.?)(.?)/)[LENGTH] != 4 ||
	    '.'[$SPLIT](/()()/)[LENGTH] > 1 ||
	    ''[$SPLIT](/.?/)[LENGTH]
	  ){
	    var NPCG = /()??/.exec('')[1] === undefined; // nonparticipating capturing group
	    // based on es5-shim implementation, need to rework it
	    $split = function(separator, limit){
	      var string = String(this);
	      if(separator === undefined && limit === 0)return [];
	      // If `separator` is not a regex, use native split
	      if(!isRegExp(separator))return _split.call(string, separator, limit);
	      var output = [];
	      var flags = (separator.ignoreCase ? 'i' : '') +
	                  (separator.multiline ? 'm' : '') +
	                  (separator.unicode ? 'u' : '') +
	                  (separator.sticky ? 'y' : '');
	      var lastLastIndex = 0;
	      var splitLimit = limit === undefined ? 4294967295 : limit >>> 0;
	      // Make `global` and avoid `lastIndex` issues by working with a copy
	      var separatorCopy = new RegExp(separator.source, flags + 'g');
	      var separator2, match, lastIndex, lastLength, i;
	      // Doesn't need flags gy, but they don't hurt
	      if(!NPCG)separator2 = new RegExp('^' + separatorCopy.source + '$(?!\\s)', flags);
	      while(match = separatorCopy.exec(string)){
	        // `separatorCopy.lastIndex` is not reliable cross-browser
	        lastIndex = match.index + match[0][LENGTH];
	        if(lastIndex > lastLastIndex){
	          output.push(string.slice(lastLastIndex, match.index));
	          // Fix browsers whose `exec` methods don't consistently return `undefined` for NPCG
	          if(!NPCG && match[LENGTH] > 1)match[0].replace(separator2, function(){
	            for(i = 1; i < arguments[LENGTH] - 2; i++)if(arguments[i] === undefined)match[i] = undefined;
	          });
	          if(match[LENGTH] > 1 && match.index < string[LENGTH])$push.apply(output, match.slice(1));
	          lastLength = match[0][LENGTH];
	          lastLastIndex = lastIndex;
	          if(output[LENGTH] >= splitLimit)break;
	        }
	        if(separatorCopy[LAST_INDEX] === match.index)separatorCopy[LAST_INDEX]++; // Avoid an infinite loop
	      }
	      if(lastLastIndex === string[LENGTH]){
	        if(lastLength || !separatorCopy.test(''))output.push('');
	      } else output.push(string.slice(lastLastIndex));
	      return output[LENGTH] > splitLimit ? output.slice(0, splitLimit) : output;
	    };
	  // Chakra, V8
	  } else if('0'[$SPLIT](undefined, 0)[LENGTH]){
	    $split = function(separator, limit){
	      return separator === undefined && limit === 0 ? [] : _split.call(this, separator, limit);
	    };
	  }
	  // 21.1.3.17 String.prototype.split(separator, limit)
	  return [function split(separator, limit){
	    var O  = defined(this)
	      , fn = separator == undefined ? undefined : separator[SPLIT];
	    return fn !== undefined ? fn.call(separator, O, limit) : $split.call(String(O), separator, limit);
	  }, $split];
	});

/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY            = __webpack_require__(28)
	  , global             = __webpack_require__(4)
	  , ctx                = __webpack_require__(20)
	  , classof            = __webpack_require__(75)
	  , $export            = __webpack_require__(8)
	  , isObject           = __webpack_require__(13)
	  , aFunction          = __webpack_require__(21)
	  , anInstance         = __webpack_require__(205)
	  , forOf              = __webpack_require__(206)
	  , speciesConstructor = __webpack_require__(207)
	  , task               = __webpack_require__(208).set
	  , microtask          = __webpack_require__(209)()
	  , PROMISE            = 'Promise'
	  , TypeError          = global.TypeError
	  , process            = global.process
	  , $Promise           = global[PROMISE]
	  , process            = global.process
	  , isNode             = classof(process) == 'process'
	  , empty              = function(){ /* empty */ }
	  , Internal, GenericPromiseCapability, Wrapper;
	
	var USE_NATIVE = !!function(){
	  try {
	    // correct subclassing with @@species support
	    var promise     = $Promise.resolve(1)
	      , FakePromise = (promise.constructor = {})[__webpack_require__(25)('species')] = function(exec){ exec(empty, empty); };
	    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
	    return (isNode || typeof PromiseRejectionEvent == 'function') && promise.then(empty) instanceof FakePromise;
	  } catch(e){ /* empty */ }
	}();
	
	// helpers
	var sameConstructor = function(a, b){
	  // with library wrapper special case
	  return a === b || a === $Promise && b === Wrapper;
	};
	var isThenable = function(it){
	  var then;
	  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
	};
	var newPromiseCapability = function(C){
	  return sameConstructor($Promise, C)
	    ? new PromiseCapability(C)
	    : new GenericPromiseCapability(C);
	};
	var PromiseCapability = GenericPromiseCapability = function(C){
	  var resolve, reject;
	  this.promise = new C(function($$resolve, $$reject){
	    if(resolve !== undefined || reject !== undefined)throw TypeError('Bad Promise constructor');
	    resolve = $$resolve;
	    reject  = $$reject;
	  });
	  this.resolve = aFunction(resolve);
	  this.reject  = aFunction(reject);
	};
	var perform = function(exec){
	  try {
	    exec();
	  } catch(e){
	    return {error: e};
	  }
	};
	var notify = function(promise, isReject){
	  if(promise._n)return;
	  promise._n = true;
	  var chain = promise._c;
	  microtask(function(){
	    var value = promise._v
	      , ok    = promise._s == 1
	      , i     = 0;
	    var run = function(reaction){
	      var handler = ok ? reaction.ok : reaction.fail
	        , resolve = reaction.resolve
	        , reject  = reaction.reject
	        , domain  = reaction.domain
	        , result, then;
	      try {
	        if(handler){
	          if(!ok){
	            if(promise._h == 2)onHandleUnhandled(promise);
	            promise._h = 1;
	          }
	          if(handler === true)result = value;
	          else {
	            if(domain)domain.enter();
	            result = handler(value);
	            if(domain)domain.exit();
	          }
	          if(result === reaction.promise){
	            reject(TypeError('Promise-chain cycle'));
	          } else if(then = isThenable(result)){
	            then.call(result, resolve, reject);
	          } else resolve(result);
	        } else reject(value);
	      } catch(e){
	        reject(e);
	      }
	    };
	    while(chain.length > i)run(chain[i++]); // variable length - can't use forEach
	    promise._c = [];
	    promise._n = false;
	    if(isReject && !promise._h)onUnhandled(promise);
	  });
	};
	var onUnhandled = function(promise){
	  task.call(global, function(){
	    var value = promise._v
	      , abrupt, handler, console;
	    if(isUnhandled(promise)){
	      abrupt = perform(function(){
	        if(isNode){
	          process.emit('unhandledRejection', value, promise);
	        } else if(handler = global.onunhandledrejection){
	          handler({promise: promise, reason: value});
	        } else if((console = global.console) && console.error){
	          console.error('Unhandled promise rejection', value);
	        }
	      });
	      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
	      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
	    } promise._a = undefined;
	    if(abrupt)throw abrupt.error;
	  });
	};
	var isUnhandled = function(promise){
	  if(promise._h == 1)return false;
	  var chain = promise._a || promise._c
	    , i     = 0
	    , reaction;
	  while(chain.length > i){
	    reaction = chain[i++];
	    if(reaction.fail || !isUnhandled(reaction.promise))return false;
	  } return true;
	};
	var onHandleUnhandled = function(promise){
	  task.call(global, function(){
	    var handler;
	    if(isNode){
	      process.emit('rejectionHandled', promise);
	    } else if(handler = global.onrejectionhandled){
	      handler({promise: promise, reason: promise._v});
	    }
	  });
	};
	var $reject = function(value){
	  var promise = this;
	  if(promise._d)return;
	  promise._d = true;
	  promise = promise._w || promise; // unwrap
	  promise._v = value;
	  promise._s = 2;
	  if(!promise._a)promise._a = promise._c.slice();
	  notify(promise, true);
	};
	var $resolve = function(value){
	  var promise = this
	    , then;
	  if(promise._d)return;
	  promise._d = true;
	  promise = promise._w || promise; // unwrap
	  try {
	    if(promise === value)throw TypeError("Promise can't be resolved itself");
	    if(then = isThenable(value)){
	      microtask(function(){
	        var wrapper = {_w: promise, _d: false}; // wrap
	        try {
	          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
	        } catch(e){
	          $reject.call(wrapper, e);
	        }
	      });
	    } else {
	      promise._v = value;
	      promise._s = 1;
	      notify(promise, false);
	    }
	  } catch(e){
	    $reject.call({_w: promise, _d: false}, e); // wrap
	  }
	};
	
	// constructor polyfill
	if(!USE_NATIVE){
	  // 25.4.3.1 Promise(executor)
	  $Promise = function Promise(executor){
	    anInstance(this, $Promise, PROMISE, '_h');
	    aFunction(executor);
	    Internal.call(this);
	    try {
	      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
	    } catch(err){
	      $reject.call(this, err);
	    }
	  };
	  Internal = function Promise(executor){
	    this._c = [];             // <- awaiting reactions
	    this._a = undefined;      // <- checked in isUnhandled reactions
	    this._s = 0;              // <- state
	    this._d = false;          // <- done
	    this._v = undefined;      // <- value
	    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
	    this._n = false;          // <- notify
	  };
	  Internal.prototype = __webpack_require__(210)($Promise.prototype, {
	    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
	    then: function then(onFulfilled, onRejected){
	      var reaction    = newPromiseCapability(speciesConstructor(this, $Promise));
	      reaction.ok     = typeof onFulfilled == 'function' ? onFulfilled : true;
	      reaction.fail   = typeof onRejected == 'function' && onRejected;
	      reaction.domain = isNode ? process.domain : undefined;
	      this._c.push(reaction);
	      if(this._a)this._a.push(reaction);
	      if(this._s)notify(this, false);
	      return reaction.promise;
	    },
	    // 25.4.5.1 Promise.prototype.catch(onRejected)
	    'catch': function(onRejected){
	      return this.then(undefined, onRejected);
	    }
	  });
	  PromiseCapability = function(){
	    var promise  = new Internal;
	    this.promise = promise;
	    this.resolve = ctx($resolve, promise, 1);
	    this.reject  = ctx($reject, promise, 1);
	  };
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, {Promise: $Promise});
	__webpack_require__(24)($Promise, PROMISE);
	__webpack_require__(192)(PROMISE);
	Wrapper = __webpack_require__(9)[PROMISE];
	
	// statics
	$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
	  // 25.4.4.5 Promise.reject(r)
	  reject: function reject(r){
	    var capability = newPromiseCapability(this)
	      , $$reject   = capability.reject;
	    $$reject(r);
	    return capability.promise;
	  }
	});
	$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
	  // 25.4.4.6 Promise.resolve(x)
	  resolve: function resolve(x){
	    // instanceof instead of internal slot check because we should fix it without replacement native Promise core
	    if(x instanceof $Promise && sameConstructor(x.constructor, this))return x;
	    var capability = newPromiseCapability(this)
	      , $$resolve  = capability.resolve;
	    $$resolve(x);
	    return capability.promise;
	  }
	});
	$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(165)(function(iter){
	  $Promise.all(iter)['catch'](empty);
	})), PROMISE, {
	  // 25.4.4.1 Promise.all(iterable)
	  all: function all(iterable){
	    var C          = this
	      , capability = newPromiseCapability(C)
	      , resolve    = capability.resolve
	      , reject     = capability.reject;
	    var abrupt = perform(function(){
	      var values    = []
	        , index     = 0
	        , remaining = 1;
	      forOf(iterable, false, function(promise){
	        var $index        = index++
	          , alreadyCalled = false;
	        values.push(undefined);
	        remaining++;
	        C.resolve(promise).then(function(value){
	          if(alreadyCalled)return;
	          alreadyCalled  = true;
	          values[$index] = value;
	          --remaining || resolve(values);
	        }, reject);
	      });
	      --remaining || resolve(values);
	    });
	    if(abrupt)reject(abrupt.error);
	    return capability.promise;
	  },
	  // 25.4.4.4 Promise.race(iterable)
	  race: function race(iterable){
	    var C          = this
	      , capability = newPromiseCapability(C)
	      , reject     = capability.reject;
	    var abrupt = perform(function(){
	      forOf(iterable, false, function(promise){
	        C.resolve(promise).then(capability.resolve, reject);
	      });
	    });
	    if(abrupt)reject(abrupt.error);
	    return capability.promise;
	  }
	});

/***/ }),
/* 205 */
/***/ (function(module, exports) {

	module.exports = function(it, Constructor, name, forbiddenField){
	  if(!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)){
	    throw TypeError(name + ': incorrect invocation!');
	  } return it;
	};

/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

	var ctx         = __webpack_require__(20)
	  , call        = __webpack_require__(161)
	  , isArrayIter = __webpack_require__(162)
	  , anObject    = __webpack_require__(12)
	  , toLength    = __webpack_require__(37)
	  , getIterFn   = __webpack_require__(164)
	  , BREAK       = {}
	  , RETURN      = {};
	var exports = module.exports = function(iterable, entries, fn, that, ITERATOR){
	  var iterFn = ITERATOR ? function(){ return iterable; } : getIterFn(iterable)
	    , f      = ctx(fn, that, entries ? 2 : 1)
	    , index  = 0
	    , length, step, iterator, result;
	  if(typeof iterFn != 'function')throw TypeError(iterable + ' is not iterable!');
	  // fast case for arrays with default iterator
	  if(isArrayIter(iterFn))for(length = toLength(iterable.length); length > index; index++){
	    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
	    if(result === BREAK || result === RETURN)return result;
	  } else for(iterator = iterFn.call(iterable); !(step = iterator.next()).done; ){
	    result = call(iterator, f, step.value, entries);
	    if(result === BREAK || result === RETURN)return result;
	  }
	};
	exports.BREAK  = BREAK;
	exports.RETURN = RETURN;

/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.3.20 SpeciesConstructor(O, defaultConstructor)
	var anObject  = __webpack_require__(12)
	  , aFunction = __webpack_require__(21)
	  , SPECIES   = __webpack_require__(25)('species');
	module.exports = function(O, D){
	  var C = anObject(O).constructor, S;
	  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
	};

/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

	var ctx                = __webpack_require__(20)
	  , invoke             = __webpack_require__(78)
	  , html               = __webpack_require__(48)
	  , cel                = __webpack_require__(15)
	  , global             = __webpack_require__(4)
	  , process            = global.process
	  , setTask            = global.setImmediate
	  , clearTask          = global.clearImmediate
	  , MessageChannel     = global.MessageChannel
	  , counter            = 0
	  , queue              = {}
	  , ONREADYSTATECHANGE = 'onreadystatechange'
	  , defer, channel, port;
	var run = function(){
	  var id = +this;
	  if(queue.hasOwnProperty(id)){
	    var fn = queue[id];
	    delete queue[id];
	    fn();
	  }
	};
	var listener = function(event){
	  run.call(event.data);
	};
	// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
	if(!setTask || !clearTask){
	  setTask = function setImmediate(fn){
	    var args = [], i = 1;
	    while(arguments.length > i)args.push(arguments[i++]);
	    queue[++counter] = function(){
	      invoke(typeof fn == 'function' ? fn : Function(fn), args);
	    };
	    defer(counter);
	    return counter;
	  };
	  clearTask = function clearImmediate(id){
	    delete queue[id];
	  };
	  // Node.js 0.8-
	  if(__webpack_require__(34)(process) == 'process'){
	    defer = function(id){
	      process.nextTick(ctx(run, id, 1));
	    };
	  // Browsers with MessageChannel, includes WebWorkers
	  } else if(MessageChannel){
	    channel = new MessageChannel;
	    port    = channel.port2;
	    channel.port1.onmessage = listener;
	    defer = ctx(port.postMessage, port, 1);
	  // Browsers with postMessage, skip WebWorkers
	  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
	  } else if(global.addEventListener && typeof postMessage == 'function' && !global.importScripts){
	    defer = function(id){
	      global.postMessage(id + '', '*');
	    };
	    global.addEventListener('message', listener, false);
	  // IE8-
	  } else if(ONREADYSTATECHANGE in cel('script')){
	    defer = function(id){
	      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function(){
	        html.removeChild(this);
	        run.call(id);
	      };
	    };
	  // Rest old browsers
	  } else {
	    defer = function(id){
	      setTimeout(ctx(run, id, 1), 0);
	    };
	  }
	}
	module.exports = {
	  set:   setTask,
	  clear: clearTask
	};

/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

	var global    = __webpack_require__(4)
	  , macrotask = __webpack_require__(208).set
	  , Observer  = global.MutationObserver || global.WebKitMutationObserver
	  , process   = global.process
	  , Promise   = global.Promise
	  , isNode    = __webpack_require__(34)(process) == 'process';
	
	module.exports = function(){
	  var head, last, notify;
	
	  var flush = function(){
	    var parent, fn;
	    if(isNode && (parent = process.domain))parent.exit();
	    while(head){
	      fn   = head.fn;
	      head = head.next;
	      try {
	        fn();
	      } catch(e){
	        if(head)notify();
	        else last = undefined;
	        throw e;
	      }
	    } last = undefined;
	    if(parent)parent.enter();
	  };
	
	  // Node.js
	  if(isNode){
	    notify = function(){
	      process.nextTick(flush);
	    };
	  // browsers with MutationObserver
	  } else if(Observer){
	    var toggle = true
	      , node   = document.createTextNode('');
	    new Observer(flush).observe(node, {characterData: true}); // eslint-disable-line no-new
	    notify = function(){
	      node.data = toggle = !toggle;
	    };
	  // environments with maybe non-completely correct, but existent Promise
	  } else if(Promise && Promise.resolve){
	    var promise = Promise.resolve();
	    notify = function(){
	      promise.then(flush);
	    };
	  // for other environments - macrotask based on:
	  // - setImmediate
	  // - MessageChannel
	  // - window.postMessag
	  // - onreadystatechange
	  // - setTimeout
	  } else {
	    notify = function(){
	      // strange IE + webpack dev server bug - use .call(global)
	      macrotask.call(global, flush);
	    };
	  }
	
	  return function(fn){
	    var task = {fn: fn, next: undefined};
	    if(last)last.next = task;
	    if(!head){
	      head = task;
	      notify();
	    } last = task;
	  };
	};

/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

	var redefine = __webpack_require__(18);
	module.exports = function(target, src, safe){
	  for(var key in src)redefine(target, key, src[key], safe);
	  return target;
	};

/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var strong = __webpack_require__(212);
	
	// 23.1 Map Objects
	module.exports = __webpack_require__(213)('Map', function(get){
	  return function Map(){ return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.1.3.6 Map.prototype.get(key)
	  get: function get(key){
	    var entry = strong.getEntry(this, key);
	    return entry && entry.v;
	  },
	  // 23.1.3.9 Map.prototype.set(key, value)
	  set: function set(key, value){
	    return strong.def(this, key === 0 ? 0 : key, value);
	  }
	}, strong, true);

/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var dP          = __webpack_require__(11).f
	  , create      = __webpack_require__(46)
	  , redefineAll = __webpack_require__(210)
	  , ctx         = __webpack_require__(20)
	  , anInstance  = __webpack_require__(205)
	  , defined     = __webpack_require__(35)
	  , forOf       = __webpack_require__(206)
	  , $iterDefine = __webpack_require__(128)
	  , step        = __webpack_require__(194)
	  , setSpecies  = __webpack_require__(192)
	  , DESCRIPTORS = __webpack_require__(6)
	  , fastKey     = __webpack_require__(22).fastKey
	  , SIZE        = DESCRIPTORS ? '_s' : 'size';
	
	var getEntry = function(that, key){
	  // fast case
	  var index = fastKey(key), entry;
	  if(index !== 'F')return that._i[index];
	  // frozen object case
	  for(entry = that._f; entry; entry = entry.n){
	    if(entry.k == key)return entry;
	  }
	};
	
	module.exports = {
	  getConstructor: function(wrapper, NAME, IS_MAP, ADDER){
	    var C = wrapper(function(that, iterable){
	      anInstance(that, C, NAME, '_i');
	      that._i = create(null); // index
	      that._f = undefined;    // first entry
	      that._l = undefined;    // last entry
	      that[SIZE] = 0;         // size
	      if(iterable != undefined)forOf(iterable, IS_MAP, that[ADDER], that);
	    });
	    redefineAll(C.prototype, {
	      // 23.1.3.1 Map.prototype.clear()
	      // 23.2.3.2 Set.prototype.clear()
	      clear: function clear(){
	        for(var that = this, data = that._i, entry = that._f; entry; entry = entry.n){
	          entry.r = true;
	          if(entry.p)entry.p = entry.p.n = undefined;
	          delete data[entry.i];
	        }
	        that._f = that._l = undefined;
	        that[SIZE] = 0;
	      },
	      // 23.1.3.3 Map.prototype.delete(key)
	      // 23.2.3.4 Set.prototype.delete(value)
	      'delete': function(key){
	        var that  = this
	          , entry = getEntry(that, key);
	        if(entry){
	          var next = entry.n
	            , prev = entry.p;
	          delete that._i[entry.i];
	          entry.r = true;
	          if(prev)prev.n = next;
	          if(next)next.p = prev;
	          if(that._f == entry)that._f = next;
	          if(that._l == entry)that._l = prev;
	          that[SIZE]--;
	        } return !!entry;
	      },
	      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
	      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
	      forEach: function forEach(callbackfn /*, that = undefined */){
	        anInstance(this, C, 'forEach');
	        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3)
	          , entry;
	        while(entry = entry ? entry.n : this._f){
	          f(entry.v, entry.k, this);
	          // revert to the last existing entry
	          while(entry && entry.r)entry = entry.p;
	        }
	      },
	      // 23.1.3.7 Map.prototype.has(key)
	      // 23.2.3.7 Set.prototype.has(value)
	      has: function has(key){
	        return !!getEntry(this, key);
	      }
	    });
	    if(DESCRIPTORS)dP(C.prototype, 'size', {
	      get: function(){
	        return defined(this[SIZE]);
	      }
	    });
	    return C;
	  },
	  def: function(that, key, value){
	    var entry = getEntry(that, key)
	      , prev, index;
	    // change existing entry
	    if(entry){
	      entry.v = value;
	    // create new entry
	    } else {
	      that._l = entry = {
	        i: index = fastKey(key, true), // <- index
	        k: key,                        // <- key
	        v: value,                      // <- value
	        p: prev = that._l,             // <- previous entry
	        n: undefined,                  // <- next entry
	        r: false                       // <- removed
	      };
	      if(!that._f)that._f = entry;
	      if(prev)prev.n = entry;
	      that[SIZE]++;
	      // add to index
	      if(index !== 'F')that._i[index] = entry;
	    } return that;
	  },
	  getEntry: getEntry,
	  setStrong: function(C, NAME, IS_MAP){
	    // add .keys, .values, .entries, [@@iterator]
	    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
	    $iterDefine(C, NAME, function(iterated, kind){
	      this._t = iterated;  // target
	      this._k = kind;      // kind
	      this._l = undefined; // previous
	    }, function(){
	      var that  = this
	        , kind  = that._k
	        , entry = that._l;
	      // revert to the last existing entry
	      while(entry && entry.r)entry = entry.p;
	      // get next entry
	      if(!that._t || !(that._l = entry = entry ? entry.n : that._t._f)){
	        // or finish the iteration
	        that._t = undefined;
	        return step(1);
	      }
	      // return step by kind
	      if(kind == 'keys'  )return step(0, entry.k);
	      if(kind == 'values')return step(0, entry.v);
	      return step(0, [entry.k, entry.v]);
	    }, IS_MAP ? 'entries' : 'values' , !IS_MAP, true);
	
	    // add [@@species], 23.1.2.2, 23.2.2.2
	    setSpecies(NAME);
	  }
	};

/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var global            = __webpack_require__(4)
	  , $export           = __webpack_require__(8)
	  , redefine          = __webpack_require__(18)
	  , redefineAll       = __webpack_require__(210)
	  , meta              = __webpack_require__(22)
	  , forOf             = __webpack_require__(206)
	  , anInstance        = __webpack_require__(205)
	  , isObject          = __webpack_require__(13)
	  , fails             = __webpack_require__(7)
	  , $iterDetect       = __webpack_require__(165)
	  , setToStringTag    = __webpack_require__(24)
	  , inheritIfRequired = __webpack_require__(88);
	
	module.exports = function(NAME, wrapper, methods, common, IS_MAP, IS_WEAK){
	  var Base  = global[NAME]
	    , C     = Base
	    , ADDER = IS_MAP ? 'set' : 'add'
	    , proto = C && C.prototype
	    , O     = {};
	  var fixMethod = function(KEY){
	    var fn = proto[KEY];
	    redefine(proto, KEY,
	      KEY == 'delete' ? function(a){
	        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'has' ? function has(a){
	        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'get' ? function get(a){
	        return IS_WEAK && !isObject(a) ? undefined : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'add' ? function add(a){ fn.call(this, a === 0 ? 0 : a); return this; }
	        : function set(a, b){ fn.call(this, a === 0 ? 0 : a, b); return this; }
	    );
	  };
	  if(typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function(){
	    new C().entries().next();
	  }))){
	    // create collection constructor
	    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
	    redefineAll(C.prototype, methods);
	    meta.NEED = true;
	  } else {
	    var instance             = new C
	      // early implementations not supports chaining
	      , HASNT_CHAINING       = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance
	      // V8 ~  Chromium 40- weak-collections throws on primitives, but should return false
	      , THROWS_ON_PRIMITIVES = fails(function(){ instance.has(1); })
	      // most early implementations doesn't supports iterables, most modern - not close it correctly
	      , ACCEPT_ITERABLES     = $iterDetect(function(iter){ new C(iter); }) // eslint-disable-line no-new
	      // for early implementations -0 and +0 not the same
	      , BUGGY_ZERO = !IS_WEAK && fails(function(){
	        // V8 ~ Chromium 42- fails only with 5+ elements
	        var $instance = new C()
	          , index     = 5;
	        while(index--)$instance[ADDER](index, index);
	        return !$instance.has(-0);
	      });
	    if(!ACCEPT_ITERABLES){ 
	      C = wrapper(function(target, iterable){
	        anInstance(target, C, NAME);
	        var that = inheritIfRequired(new Base, target, C);
	        if(iterable != undefined)forOf(iterable, IS_MAP, that[ADDER], that);
	        return that;
	      });
	      C.prototype = proto;
	      proto.constructor = C;
	    }
	    if(THROWS_ON_PRIMITIVES || BUGGY_ZERO){
	      fixMethod('delete');
	      fixMethod('has');
	      IS_MAP && fixMethod('get');
	    }
	    if(BUGGY_ZERO || HASNT_CHAINING)fixMethod(ADDER);
	    // weak collections should not contains .clear method
	    if(IS_WEAK && proto.clear)delete proto.clear;
	  }
	
	  setToStringTag(C, NAME);
	
	  O[NAME] = C;
	  $export($export.G + $export.W + $export.F * (C != Base), O);
	
	  if(!IS_WEAK)common.setStrong(C, NAME, IS_MAP);
	
	  return C;
	};

/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var strong = __webpack_require__(212);
	
	// 23.2 Set Objects
	module.exports = __webpack_require__(213)('Set', function(get){
	  return function Set(){ return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.2.3.1 Set.prototype.add(value)
	  add: function add(value){
	    return strong.def(this, value = value === 0 ? 0 : value, value);
	  }
	}, strong);

/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var each         = __webpack_require__(172)(0)
	  , redefine     = __webpack_require__(18)
	  , meta         = __webpack_require__(22)
	  , assign       = __webpack_require__(69)
	  , weak         = __webpack_require__(216)
	  , isObject     = __webpack_require__(13)
	  , getWeak      = meta.getWeak
	  , isExtensible = Object.isExtensible
	  , uncaughtFrozenStore = weak.ufstore
	  , tmp          = {}
	  , InternalMap;
	
	var wrapper = function(get){
	  return function WeakMap(){
	    return get(this, arguments.length > 0 ? arguments[0] : undefined);
	  };
	};
	
	var methods = {
	  // 23.3.3.3 WeakMap.prototype.get(key)
	  get: function get(key){
	    if(isObject(key)){
	      var data = getWeak(key);
	      if(data === true)return uncaughtFrozenStore(this).get(key);
	      return data ? data[this._i] : undefined;
	    }
	  },
	  // 23.3.3.5 WeakMap.prototype.set(key, value)
	  set: function set(key, value){
	    return weak.def(this, key, value);
	  }
	};
	
	// 23.3 WeakMap Objects
	var $WeakMap = module.exports = __webpack_require__(213)('WeakMap', wrapper, methods, weak, true, true);
	
	// IE11 WeakMap frozen keys fix
	if(new $WeakMap().set((Object.freeze || Object)(tmp), 7).get(tmp) != 7){
	  InternalMap = weak.getConstructor(wrapper);
	  assign(InternalMap.prototype, methods);
	  meta.NEED = true;
	  each(['delete', 'has', 'get', 'set'], function(key){
	    var proto  = $WeakMap.prototype
	      , method = proto[key];
	    redefine(proto, key, function(a, b){
	      // store frozen objects on internal weakmap shim
	      if(isObject(a) && !isExtensible(a)){
	        if(!this._f)this._f = new InternalMap;
	        var result = this._f[key](a, b);
	        return key == 'set' ? this : result;
	      // store all the rest on native weakmap
	      } return method.call(this, a, b);
	    });
	  });
	}

/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var redefineAll       = __webpack_require__(210)
	  , getWeak           = __webpack_require__(22).getWeak
	  , anObject          = __webpack_require__(12)
	  , isObject          = __webpack_require__(13)
	  , anInstance        = __webpack_require__(205)
	  , forOf             = __webpack_require__(206)
	  , createArrayMethod = __webpack_require__(172)
	  , $has              = __webpack_require__(5)
	  , arrayFind         = createArrayMethod(5)
	  , arrayFindIndex    = createArrayMethod(6)
	  , id                = 0;
	
	// fallback for uncaught frozen keys
	var uncaughtFrozenStore = function(that){
	  return that._l || (that._l = new UncaughtFrozenStore);
	};
	var UncaughtFrozenStore = function(){
	  this.a = [];
	};
	var findUncaughtFrozen = function(store, key){
	  return arrayFind(store.a, function(it){
	    return it[0] === key;
	  });
	};
	UncaughtFrozenStore.prototype = {
	  get: function(key){
	    var entry = findUncaughtFrozen(this, key);
	    if(entry)return entry[1];
	  },
	  has: function(key){
	    return !!findUncaughtFrozen(this, key);
	  },
	  set: function(key, value){
	    var entry = findUncaughtFrozen(this, key);
	    if(entry)entry[1] = value;
	    else this.a.push([key, value]);
	  },
	  'delete': function(key){
	    var index = arrayFindIndex(this.a, function(it){
	      return it[0] === key;
	    });
	    if(~index)this.a.splice(index, 1);
	    return !!~index;
	  }
	};
	
	module.exports = {
	  getConstructor: function(wrapper, NAME, IS_MAP, ADDER){
	    var C = wrapper(function(that, iterable){
	      anInstance(that, C, NAME, '_i');
	      that._i = id++;      // collection id
	      that._l = undefined; // leak store for uncaught frozen objects
	      if(iterable != undefined)forOf(iterable, IS_MAP, that[ADDER], that);
	    });
	    redefineAll(C.prototype, {
	      // 23.3.3.2 WeakMap.prototype.delete(key)
	      // 23.4.3.3 WeakSet.prototype.delete(value)
	      'delete': function(key){
	        if(!isObject(key))return false;
	        var data = getWeak(key);
	        if(data === true)return uncaughtFrozenStore(this)['delete'](key);
	        return data && $has(data, this._i) && delete data[this._i];
	      },
	      // 23.3.3.4 WeakMap.prototype.has(key)
	      // 23.4.3.4 WeakSet.prototype.has(value)
	      has: function has(key){
	        if(!isObject(key))return false;
	        var data = getWeak(key);
	        if(data === true)return uncaughtFrozenStore(this).has(key);
	        return data && $has(data, this._i);
	      }
	    });
	    return C;
	  },
	  def: function(that, key, value){
	    var data = getWeak(anObject(key), true);
	    if(data === true)uncaughtFrozenStore(that).set(key, value);
	    else data[that._i] = value;
	    return that;
	  },
	  ufstore: uncaughtFrozenStore
	};

/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var weak = __webpack_require__(216);
	
	// 23.4 WeakSet Objects
	__webpack_require__(213)('WeakSet', function(get){
	  return function WeakSet(){ return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.4.3.1 WeakSet.prototype.add(value)
	  add: function add(value){
	    return weak.def(this, value, true);
	  }
	}, weak, false, true);

/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export      = __webpack_require__(8)
	  , $typed       = __webpack_require__(219)
	  , buffer       = __webpack_require__(220)
	  , anObject     = __webpack_require__(12)
	  , toIndex      = __webpack_require__(39)
	  , toLength     = __webpack_require__(37)
	  , isObject     = __webpack_require__(13)
	  , ArrayBuffer  = __webpack_require__(4).ArrayBuffer
	  , speciesConstructor = __webpack_require__(207)
	  , $ArrayBuffer = buffer.ArrayBuffer
	  , $DataView    = buffer.DataView
	  , $isView      = $typed.ABV && ArrayBuffer.isView
	  , $slice       = $ArrayBuffer.prototype.slice
	  , VIEW         = $typed.VIEW
	  , ARRAY_BUFFER = 'ArrayBuffer';
	
	$export($export.G + $export.W + $export.F * (ArrayBuffer !== $ArrayBuffer), {ArrayBuffer: $ArrayBuffer});
	
	$export($export.S + $export.F * !$typed.CONSTR, ARRAY_BUFFER, {
	  // 24.1.3.1 ArrayBuffer.isView(arg)
	  isView: function isView(it){
	    return $isView && $isView(it) || isObject(it) && VIEW in it;
	  }
	});
	
	$export($export.P + $export.U + $export.F * __webpack_require__(7)(function(){
	  return !new $ArrayBuffer(2).slice(1, undefined).byteLength;
	}), ARRAY_BUFFER, {
	  // 24.1.4.3 ArrayBuffer.prototype.slice(start, end)
	  slice: function slice(start, end){
	    if($slice !== undefined && end === undefined)return $slice.call(anObject(this), start); // FF fix
	    var len    = anObject(this).byteLength
	      , first  = toIndex(start, len)
	      , final  = toIndex(end === undefined ? len : end, len)
	      , result = new (speciesConstructor(this, $ArrayBuffer))(toLength(final - first))
	      , viewS  = new $DataView(this)
	      , viewT  = new $DataView(result)
	      , index  = 0;
	    while(first < final){
	      viewT.setUint8(index++, viewS.getUint8(first++));
	    } return result;
	  }
	});
	
	__webpack_require__(192)(ARRAY_BUFFER);

/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(4)
	  , hide   = __webpack_require__(10)
	  , uid    = __webpack_require__(19)
	  , TYPED  = uid('typed_array')
	  , VIEW   = uid('view')
	  , ABV    = !!(global.ArrayBuffer && global.DataView)
	  , CONSTR = ABV
	  , i = 0, l = 9, Typed;
	
	var TypedArrayConstructors = (
	  'Int8Array,Uint8Array,Uint8ClampedArray,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array'
	).split(',');
	
	while(i < l){
	  if(Typed = global[TypedArrayConstructors[i++]]){
	    hide(Typed.prototype, TYPED, true);
	    hide(Typed.prototype, VIEW, true);
	  } else CONSTR = false;
	}
	
	module.exports = {
	  ABV:    ABV,
	  CONSTR: CONSTR,
	  TYPED:  TYPED,
	  VIEW:   VIEW
	};

/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var global         = __webpack_require__(4)
	  , DESCRIPTORS    = __webpack_require__(6)
	  , LIBRARY        = __webpack_require__(28)
	  , $typed         = __webpack_require__(219)
	  , hide           = __webpack_require__(10)
	  , redefineAll    = __webpack_require__(210)
	  , fails          = __webpack_require__(7)
	  , anInstance     = __webpack_require__(205)
	  , toInteger      = __webpack_require__(38)
	  , toLength       = __webpack_require__(37)
	  , gOPN           = __webpack_require__(50).f
	  , dP             = __webpack_require__(11).f
	  , arrayFill      = __webpack_require__(188)
	  , setToStringTag = __webpack_require__(24)
	  , ARRAY_BUFFER   = 'ArrayBuffer'
	  , DATA_VIEW      = 'DataView'
	  , PROTOTYPE      = 'prototype'
	  , WRONG_LENGTH   = 'Wrong length!'
	  , WRONG_INDEX    = 'Wrong index!'
	  , $ArrayBuffer   = global[ARRAY_BUFFER]
	  , $DataView      = global[DATA_VIEW]
	  , Math           = global.Math
	  , RangeError     = global.RangeError
	  , Infinity       = global.Infinity
	  , BaseBuffer     = $ArrayBuffer
	  , abs            = Math.abs
	  , pow            = Math.pow
	  , floor          = Math.floor
	  , log            = Math.log
	  , LN2            = Math.LN2
	  , BUFFER         = 'buffer'
	  , BYTE_LENGTH    = 'byteLength'
	  , BYTE_OFFSET    = 'byteOffset'
	  , $BUFFER        = DESCRIPTORS ? '_b' : BUFFER
	  , $LENGTH        = DESCRIPTORS ? '_l' : BYTE_LENGTH
	  , $OFFSET        = DESCRIPTORS ? '_o' : BYTE_OFFSET;
	
	// IEEE754 conversions based on https://github.com/feross/ieee754
	var packIEEE754 = function(value, mLen, nBytes){
	  var buffer = Array(nBytes)
	    , eLen   = nBytes * 8 - mLen - 1
	    , eMax   = (1 << eLen) - 1
	    , eBias  = eMax >> 1
	    , rt     = mLen === 23 ? pow(2, -24) - pow(2, -77) : 0
	    , i      = 0
	    , s      = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0
	    , e, m, c;
	  value = abs(value)
	  if(value != value || value === Infinity){
	    m = value != value ? 1 : 0;
	    e = eMax;
	  } else {
	    e = floor(log(value) / LN2);
	    if(value * (c = pow(2, -e)) < 1){
	      e--;
	      c *= 2;
	    }
	    if(e + eBias >= 1){
	      value += rt / c;
	    } else {
	      value += rt * pow(2, 1 - eBias);
	    }
	    if(value * c >= 2){
	      e++;
	      c /= 2;
	    }
	    if(e + eBias >= eMax){
	      m = 0;
	      e = eMax;
	    } else if(e + eBias >= 1){
	      m = (value * c - 1) * pow(2, mLen);
	      e = e + eBias;
	    } else {
	      m = value * pow(2, eBias - 1) * pow(2, mLen);
	      e = 0;
	    }
	  }
	  for(; mLen >= 8; buffer[i++] = m & 255, m /= 256, mLen -= 8);
	  e = e << mLen | m;
	  eLen += mLen;
	  for(; eLen > 0; buffer[i++] = e & 255, e /= 256, eLen -= 8);
	  buffer[--i] |= s * 128;
	  return buffer;
	};
	var unpackIEEE754 = function(buffer, mLen, nBytes){
	  var eLen  = nBytes * 8 - mLen - 1
	    , eMax  = (1 << eLen) - 1
	    , eBias = eMax >> 1
	    , nBits = eLen - 7
	    , i     = nBytes - 1
	    , s     = buffer[i--]
	    , e     = s & 127
	    , m;
	  s >>= 7;
	  for(; nBits > 0; e = e * 256 + buffer[i], i--, nBits -= 8);
	  m = e & (1 << -nBits) - 1;
	  e >>= -nBits;
	  nBits += mLen;
	  for(; nBits > 0; m = m * 256 + buffer[i], i--, nBits -= 8);
	  if(e === 0){
	    e = 1 - eBias;
	  } else if(e === eMax){
	    return m ? NaN : s ? -Infinity : Infinity;
	  } else {
	    m = m + pow(2, mLen);
	    e = e - eBias;
	  } return (s ? -1 : 1) * m * pow(2, e - mLen);
	};
	
	var unpackI32 = function(bytes){
	  return bytes[3] << 24 | bytes[2] << 16 | bytes[1] << 8 | bytes[0];
	};
	var packI8 = function(it){
	  return [it & 0xff];
	};
	var packI16 = function(it){
	  return [it & 0xff, it >> 8 & 0xff];
	};
	var packI32 = function(it){
	  return [it & 0xff, it >> 8 & 0xff, it >> 16 & 0xff, it >> 24 & 0xff];
	};
	var packF64 = function(it){
	  return packIEEE754(it, 52, 8);
	};
	var packF32 = function(it){
	  return packIEEE754(it, 23, 4);
	};
	
	var addGetter = function(C, key, internal){
	  dP(C[PROTOTYPE], key, {get: function(){ return this[internal]; }});
	};
	
	var get = function(view, bytes, index, isLittleEndian){
	  var numIndex = +index
	    , intIndex = toInteger(numIndex);
	  if(numIndex != intIndex || intIndex < 0 || intIndex + bytes > view[$LENGTH])throw RangeError(WRONG_INDEX);
	  var store = view[$BUFFER]._b
	    , start = intIndex + view[$OFFSET]
	    , pack  = store.slice(start, start + bytes);
	  return isLittleEndian ? pack : pack.reverse();
	};
	var set = function(view, bytes, index, conversion, value, isLittleEndian){
	  var numIndex = +index
	    , intIndex = toInteger(numIndex);
	  if(numIndex != intIndex || intIndex < 0 || intIndex + bytes > view[$LENGTH])throw RangeError(WRONG_INDEX);
	  var store = view[$BUFFER]._b
	    , start = intIndex + view[$OFFSET]
	    , pack  = conversion(+value);
	  for(var i = 0; i < bytes; i++)store[start + i] = pack[isLittleEndian ? i : bytes - i - 1];
	};
	
	var validateArrayBufferArguments = function(that, length){
	  anInstance(that, $ArrayBuffer, ARRAY_BUFFER);
	  var numberLength = +length
	    , byteLength   = toLength(numberLength);
	  if(numberLength != byteLength)throw RangeError(WRONG_LENGTH);
	  return byteLength;
	};
	
	if(!$typed.ABV){
	  $ArrayBuffer = function ArrayBuffer(length){
	    var byteLength = validateArrayBufferArguments(this, length);
	    this._b       = arrayFill.call(Array(byteLength), 0);
	    this[$LENGTH] = byteLength;
	  };
	
	  $DataView = function DataView(buffer, byteOffset, byteLength){
	    anInstance(this, $DataView, DATA_VIEW);
	    anInstance(buffer, $ArrayBuffer, DATA_VIEW);
	    var bufferLength = buffer[$LENGTH]
	      , offset       = toInteger(byteOffset);
	    if(offset < 0 || offset > bufferLength)throw RangeError('Wrong offset!');
	    byteLength = byteLength === undefined ? bufferLength - offset : toLength(byteLength);
	    if(offset + byteLength > bufferLength)throw RangeError(WRONG_LENGTH);
	    this[$BUFFER] = buffer;
	    this[$OFFSET] = offset;
	    this[$LENGTH] = byteLength;
	  };
	
	  if(DESCRIPTORS){
	    addGetter($ArrayBuffer, BYTE_LENGTH, '_l');
	    addGetter($DataView, BUFFER, '_b');
	    addGetter($DataView, BYTE_LENGTH, '_l');
	    addGetter($DataView, BYTE_OFFSET, '_o');
	  }
	
	  redefineAll($DataView[PROTOTYPE], {
	    getInt8: function getInt8(byteOffset){
	      return get(this, 1, byteOffset)[0] << 24 >> 24;
	    },
	    getUint8: function getUint8(byteOffset){
	      return get(this, 1, byteOffset)[0];
	    },
	    getInt16: function getInt16(byteOffset /*, littleEndian */){
	      var bytes = get(this, 2, byteOffset, arguments[1]);
	      return (bytes[1] << 8 | bytes[0]) << 16 >> 16;
	    },
	    getUint16: function getUint16(byteOffset /*, littleEndian */){
	      var bytes = get(this, 2, byteOffset, arguments[1]);
	      return bytes[1] << 8 | bytes[0];
	    },
	    getInt32: function getInt32(byteOffset /*, littleEndian */){
	      return unpackI32(get(this, 4, byteOffset, arguments[1]));
	    },
	    getUint32: function getUint32(byteOffset /*, littleEndian */){
	      return unpackI32(get(this, 4, byteOffset, arguments[1])) >>> 0;
	    },
	    getFloat32: function getFloat32(byteOffset /*, littleEndian */){
	      return unpackIEEE754(get(this, 4, byteOffset, arguments[1]), 23, 4);
	    },
	    getFloat64: function getFloat64(byteOffset /*, littleEndian */){
	      return unpackIEEE754(get(this, 8, byteOffset, arguments[1]), 52, 8);
	    },
	    setInt8: function setInt8(byteOffset, value){
	      set(this, 1, byteOffset, packI8, value);
	    },
	    setUint8: function setUint8(byteOffset, value){
	      set(this, 1, byteOffset, packI8, value);
	    },
	    setInt16: function setInt16(byteOffset, value /*, littleEndian */){
	      set(this, 2, byteOffset, packI16, value, arguments[2]);
	    },
	    setUint16: function setUint16(byteOffset, value /*, littleEndian */){
	      set(this, 2, byteOffset, packI16, value, arguments[2]);
	    },
	    setInt32: function setInt32(byteOffset, value /*, littleEndian */){
	      set(this, 4, byteOffset, packI32, value, arguments[2]);
	    },
	    setUint32: function setUint32(byteOffset, value /*, littleEndian */){
	      set(this, 4, byteOffset, packI32, value, arguments[2]);
	    },
	    setFloat32: function setFloat32(byteOffset, value /*, littleEndian */){
	      set(this, 4, byteOffset, packF32, value, arguments[2]);
	    },
	    setFloat64: function setFloat64(byteOffset, value /*, littleEndian */){
	      set(this, 8, byteOffset, packF64, value, arguments[2]);
	    }
	  });
	} else {
	  if(!fails(function(){
	    new $ArrayBuffer;     // eslint-disable-line no-new
	  }) || !fails(function(){
	    new $ArrayBuffer(.5); // eslint-disable-line no-new
	  })){
	    $ArrayBuffer = function ArrayBuffer(length){
	      return new BaseBuffer(validateArrayBufferArguments(this, length));
	    };
	    var ArrayBufferProto = $ArrayBuffer[PROTOTYPE] = BaseBuffer[PROTOTYPE];
	    for(var keys = gOPN(BaseBuffer), j = 0, key; keys.length > j; ){
	      if(!((key = keys[j++]) in $ArrayBuffer))hide($ArrayBuffer, key, BaseBuffer[key]);
	    };
	    if(!LIBRARY)ArrayBufferProto.constructor = $ArrayBuffer;
	  }
	  // iOS Safari 7.x bug
	  var view = new $DataView(new $ArrayBuffer(2))
	    , $setInt8 = $DataView[PROTOTYPE].setInt8;
	  view.setInt8(0, 2147483648);
	  view.setInt8(1, 2147483649);
	  if(view.getInt8(0) || !view.getInt8(1))redefineAll($DataView[PROTOTYPE], {
	    setInt8: function setInt8(byteOffset, value){
	      $setInt8.call(this, byteOffset, value << 24 >> 24);
	    },
	    setUint8: function setUint8(byteOffset, value){
	      $setInt8.call(this, byteOffset, value << 24 >> 24);
	    }
	  }, true);
	}
	setToStringTag($ArrayBuffer, ARRAY_BUFFER);
	setToStringTag($DataView, DATA_VIEW);
	hide($DataView[PROTOTYPE], $typed.VIEW, true);
	exports[ARRAY_BUFFER] = $ArrayBuffer;
	exports[DATA_VIEW] = $DataView;

/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(8);
	$export($export.G + $export.W + $export.F * !__webpack_require__(219).ABV, {
	  DataView: __webpack_require__(220).DataView
	});

/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(223)('Int8', 1, function(init){
	  return function Int8Array(data, byteOffset, length){
	    return init(this, data, byteOffset, length);
	  };
	});

/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	if(__webpack_require__(6)){
	  var LIBRARY             = __webpack_require__(28)
	    , global              = __webpack_require__(4)
	    , fails               = __webpack_require__(7)
	    , $export             = __webpack_require__(8)
	    , $typed              = __webpack_require__(219)
	    , $buffer             = __webpack_require__(220)
	    , ctx                 = __webpack_require__(20)
	    , anInstance          = __webpack_require__(205)
	    , propertyDesc        = __webpack_require__(17)
	    , hide                = __webpack_require__(10)
	    , redefineAll         = __webpack_require__(210)
	    , toInteger           = __webpack_require__(38)
	    , toLength            = __webpack_require__(37)
	    , toIndex             = __webpack_require__(39)
	    , toPrimitive         = __webpack_require__(16)
	    , has                 = __webpack_require__(5)
	    , same                = __webpack_require__(71)
	    , classof             = __webpack_require__(75)
	    , isObject            = __webpack_require__(13)
	    , toObject            = __webpack_require__(58)
	    , isArrayIter         = __webpack_require__(162)
	    , create              = __webpack_require__(46)
	    , getPrototypeOf      = __webpack_require__(59)
	    , gOPN                = __webpack_require__(50).f
	    , getIterFn           = __webpack_require__(164)
	    , uid                 = __webpack_require__(19)
	    , wks                 = __webpack_require__(25)
	    , createArrayMethod   = __webpack_require__(172)
	    , createArrayIncludes = __webpack_require__(36)
	    , speciesConstructor  = __webpack_require__(207)
	    , ArrayIterators      = __webpack_require__(193)
	    , Iterators           = __webpack_require__(129)
	    , $iterDetect         = __webpack_require__(165)
	    , setSpecies          = __webpack_require__(192)
	    , arrayFill           = __webpack_require__(188)
	    , arrayCopyWithin     = __webpack_require__(185)
	    , $DP                 = __webpack_require__(11)
	    , $GOPD               = __webpack_require__(51)
	    , dP                  = $DP.f
	    , gOPD                = $GOPD.f
	    , RangeError          = global.RangeError
	    , TypeError           = global.TypeError
	    , Uint8Array          = global.Uint8Array
	    , ARRAY_BUFFER        = 'ArrayBuffer'
	    , SHARED_BUFFER       = 'Shared' + ARRAY_BUFFER
	    , BYTES_PER_ELEMENT   = 'BYTES_PER_ELEMENT'
	    , PROTOTYPE           = 'prototype'
	    , ArrayProto          = Array[PROTOTYPE]
	    , $ArrayBuffer        = $buffer.ArrayBuffer
	    , $DataView           = $buffer.DataView
	    , arrayForEach        = createArrayMethod(0)
	    , arrayFilter         = createArrayMethod(2)
	    , arraySome           = createArrayMethod(3)
	    , arrayEvery          = createArrayMethod(4)
	    , arrayFind           = createArrayMethod(5)
	    , arrayFindIndex      = createArrayMethod(6)
	    , arrayIncludes       = createArrayIncludes(true)
	    , arrayIndexOf        = createArrayIncludes(false)
	    , arrayValues         = ArrayIterators.values
	    , arrayKeys           = ArrayIterators.keys
	    , arrayEntries        = ArrayIterators.entries
	    , arrayLastIndexOf    = ArrayProto.lastIndexOf
	    , arrayReduce         = ArrayProto.reduce
	    , arrayReduceRight    = ArrayProto.reduceRight
	    , arrayJoin           = ArrayProto.join
	    , arraySort           = ArrayProto.sort
	    , arraySlice          = ArrayProto.slice
	    , arrayToString       = ArrayProto.toString
	    , arrayToLocaleString = ArrayProto.toLocaleString
	    , ITERATOR            = wks('iterator')
	    , TAG                 = wks('toStringTag')
	    , TYPED_CONSTRUCTOR   = uid('typed_constructor')
	    , DEF_CONSTRUCTOR     = uid('def_constructor')
	    , ALL_CONSTRUCTORS    = $typed.CONSTR
	    , TYPED_ARRAY         = $typed.TYPED
	    , VIEW                = $typed.VIEW
	    , WRONG_LENGTH        = 'Wrong length!';
	
	  var $map = createArrayMethod(1, function(O, length){
	    return allocate(speciesConstructor(O, O[DEF_CONSTRUCTOR]), length);
	  });
	
	  var LITTLE_ENDIAN = fails(function(){
	    return new Uint8Array(new Uint16Array([1]).buffer)[0] === 1;
	  });
	
	  var FORCED_SET = !!Uint8Array && !!Uint8Array[PROTOTYPE].set && fails(function(){
	    new Uint8Array(1).set({});
	  });
	
	  var strictToLength = function(it, SAME){
	    if(it === undefined)throw TypeError(WRONG_LENGTH);
	    var number = +it
	      , length = toLength(it);
	    if(SAME && !same(number, length))throw RangeError(WRONG_LENGTH);
	    return length;
	  };
	
	  var toOffset = function(it, BYTES){
	    var offset = toInteger(it);
	    if(offset < 0 || offset % BYTES)throw RangeError('Wrong offset!');
	    return offset;
	  };
	
	  var validate = function(it){
	    if(isObject(it) && TYPED_ARRAY in it)return it;
	    throw TypeError(it + ' is not a typed array!');
	  };
	
	  var allocate = function(C, length){
	    if(!(isObject(C) && TYPED_CONSTRUCTOR in C)){
	      throw TypeError('It is not a typed array constructor!');
	    } return new C(length);
	  };
	
	  var speciesFromList = function(O, list){
	    return fromList(speciesConstructor(O, O[DEF_CONSTRUCTOR]), list);
	  };
	
	  var fromList = function(C, list){
	    var index  = 0
	      , length = list.length
	      , result = allocate(C, length);
	    while(length > index)result[index] = list[index++];
	    return result;
	  };
	
	  var addGetter = function(it, key, internal){
	    dP(it, key, {get: function(){ return this._d[internal]; }});
	  };
	
	  var $from = function from(source /*, mapfn, thisArg */){
	    var O       = toObject(source)
	      , aLen    = arguments.length
	      , mapfn   = aLen > 1 ? arguments[1] : undefined
	      , mapping = mapfn !== undefined
	      , iterFn  = getIterFn(O)
	      , i, length, values, result, step, iterator;
	    if(iterFn != undefined && !isArrayIter(iterFn)){
	      for(iterator = iterFn.call(O), values = [], i = 0; !(step = iterator.next()).done; i++){
	        values.push(step.value);
	      } O = values;
	    }
	    if(mapping && aLen > 2)mapfn = ctx(mapfn, arguments[2], 2);
	    for(i = 0, length = toLength(O.length), result = allocate(this, length); length > i; i++){
	      result[i] = mapping ? mapfn(O[i], i) : O[i];
	    }
	    return result;
	  };
	
	  var $of = function of(/*...items*/){
	    var index  = 0
	      , length = arguments.length
	      , result = allocate(this, length);
	    while(length > index)result[index] = arguments[index++];
	    return result;
	  };
	
	  // iOS Safari 6.x fails here
	  var TO_LOCALE_BUG = !!Uint8Array && fails(function(){ arrayToLocaleString.call(new Uint8Array(1)); });
	
	  var $toLocaleString = function toLocaleString(){
	    return arrayToLocaleString.apply(TO_LOCALE_BUG ? arraySlice.call(validate(this)) : validate(this), arguments);
	  };
	
	  var proto = {
	    copyWithin: function copyWithin(target, start /*, end */){
	      return arrayCopyWithin.call(validate(this), target, start, arguments.length > 2 ? arguments[2] : undefined);
	    },
	    every: function every(callbackfn /*, thisArg */){
	      return arrayEvery(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    fill: function fill(value /*, start, end */){ // eslint-disable-line no-unused-vars
	      return arrayFill.apply(validate(this), arguments);
	    },
	    filter: function filter(callbackfn /*, thisArg */){
	      return speciesFromList(this, arrayFilter(validate(this), callbackfn,
	        arguments.length > 1 ? arguments[1] : undefined));
	    },
	    find: function find(predicate /*, thisArg */){
	      return arrayFind(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    findIndex: function findIndex(predicate /*, thisArg */){
	      return arrayFindIndex(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    forEach: function forEach(callbackfn /*, thisArg */){
	      arrayForEach(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    indexOf: function indexOf(searchElement /*, fromIndex */){
	      return arrayIndexOf(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    includes: function includes(searchElement /*, fromIndex */){
	      return arrayIncludes(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    join: function join(separator){ // eslint-disable-line no-unused-vars
	      return arrayJoin.apply(validate(this), arguments);
	    },
	    lastIndexOf: function lastIndexOf(searchElement /*, fromIndex */){ // eslint-disable-line no-unused-vars
	      return arrayLastIndexOf.apply(validate(this), arguments);
	    },
	    map: function map(mapfn /*, thisArg */){
	      return $map(validate(this), mapfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    reduce: function reduce(callbackfn /*, initialValue */){ // eslint-disable-line no-unused-vars
	      return arrayReduce.apply(validate(this), arguments);
	    },
	    reduceRight: function reduceRight(callbackfn /*, initialValue */){ // eslint-disable-line no-unused-vars
	      return arrayReduceRight.apply(validate(this), arguments);
	    },
	    reverse: function reverse(){
	      var that   = this
	        , length = validate(that).length
	        , middle = Math.floor(length / 2)
	        , index  = 0
	        , value;
	      while(index < middle){
	        value         = that[index];
	        that[index++] = that[--length];
	        that[length]  = value;
	      } return that;
	    },
	    some: function some(callbackfn /*, thisArg */){
	      return arraySome(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    sort: function sort(comparefn){
	      return arraySort.call(validate(this), comparefn);
	    },
	    subarray: function subarray(begin, end){
	      var O      = validate(this)
	        , length = O.length
	        , $begin = toIndex(begin, length);
	      return new (speciesConstructor(O, O[DEF_CONSTRUCTOR]))(
	        O.buffer,
	        O.byteOffset + $begin * O.BYTES_PER_ELEMENT,
	        toLength((end === undefined ? length : toIndex(end, length)) - $begin)
	      );
	    }
	  };
	
	  var $slice = function slice(start, end){
	    return speciesFromList(this, arraySlice.call(validate(this), start, end));
	  };
	
	  var $set = function set(arrayLike /*, offset */){
	    validate(this);
	    var offset = toOffset(arguments[1], 1)
	      , length = this.length
	      , src    = toObject(arrayLike)
	      , len    = toLength(src.length)
	      , index  = 0;
	    if(len + offset > length)throw RangeError(WRONG_LENGTH);
	    while(index < len)this[offset + index] = src[index++];
	  };
	
	  var $iterators = {
	    entries: function entries(){
	      return arrayEntries.call(validate(this));
	    },
	    keys: function keys(){
	      return arrayKeys.call(validate(this));
	    },
	    values: function values(){
	      return arrayValues.call(validate(this));
	    }
	  };
	
	  var isTAIndex = function(target, key){
	    return isObject(target)
	      && target[TYPED_ARRAY]
	      && typeof key != 'symbol'
	      && key in target
	      && String(+key) == String(key);
	  };
	  var $getDesc = function getOwnPropertyDescriptor(target, key){
	    return isTAIndex(target, key = toPrimitive(key, true))
	      ? propertyDesc(2, target[key])
	      : gOPD(target, key);
	  };
	  var $setDesc = function defineProperty(target, key, desc){
	    if(isTAIndex(target, key = toPrimitive(key, true))
	      && isObject(desc)
	      && has(desc, 'value')
	      && !has(desc, 'get')
	      && !has(desc, 'set')
	      // TODO: add validation descriptor w/o calling accessors
	      && !desc.configurable
	      && (!has(desc, 'writable') || desc.writable)
	      && (!has(desc, 'enumerable') || desc.enumerable)
	    ){
	      target[key] = desc.value;
	      return target;
	    } else return dP(target, key, desc);
	  };
	
	  if(!ALL_CONSTRUCTORS){
	    $GOPD.f = $getDesc;
	    $DP.f   = $setDesc;
	  }
	
	  $export($export.S + $export.F * !ALL_CONSTRUCTORS, 'Object', {
	    getOwnPropertyDescriptor: $getDesc,
	    defineProperty:           $setDesc
	  });
	
	  if(fails(function(){ arrayToString.call({}); })){
	    arrayToString = arrayToLocaleString = function toString(){
	      return arrayJoin.call(this);
	    }
	  }
	
	  var $TypedArrayPrototype$ = redefineAll({}, proto);
	  redefineAll($TypedArrayPrototype$, $iterators);
	  hide($TypedArrayPrototype$, ITERATOR, $iterators.values);
	  redefineAll($TypedArrayPrototype$, {
	    slice:          $slice,
	    set:            $set,
	    constructor:    function(){ /* noop */ },
	    toString:       arrayToString,
	    toLocaleString: $toLocaleString
	  });
	  addGetter($TypedArrayPrototype$, 'buffer', 'b');
	  addGetter($TypedArrayPrototype$, 'byteOffset', 'o');
	  addGetter($TypedArrayPrototype$, 'byteLength', 'l');
	  addGetter($TypedArrayPrototype$, 'length', 'e');
	  dP($TypedArrayPrototype$, TAG, {
	    get: function(){ return this[TYPED_ARRAY]; }
	  });
	
	  module.exports = function(KEY, BYTES, wrapper, CLAMPED){
	    CLAMPED = !!CLAMPED;
	    var NAME       = KEY + (CLAMPED ? 'Clamped' : '') + 'Array'
	      , ISNT_UINT8 = NAME != 'Uint8Array'
	      , GETTER     = 'get' + KEY
	      , SETTER     = 'set' + KEY
	      , TypedArray = global[NAME]
	      , Base       = TypedArray || {}
	      , TAC        = TypedArray && getPrototypeOf(TypedArray)
	      , FORCED     = !TypedArray || !$typed.ABV
	      , O          = {}
	      , TypedArrayPrototype = TypedArray && TypedArray[PROTOTYPE];
	    var getter = function(that, index){
	      var data = that._d;
	      return data.v[GETTER](index * BYTES + data.o, LITTLE_ENDIAN);
	    };
	    var setter = function(that, index, value){
	      var data = that._d;
	      if(CLAMPED)value = (value = Math.round(value)) < 0 ? 0 : value > 0xff ? 0xff : value & 0xff;
	      data.v[SETTER](index * BYTES + data.o, value, LITTLE_ENDIAN);
	    };
	    var addElement = function(that, index){
	      dP(that, index, {
	        get: function(){
	          return getter(this, index);
	        },
	        set: function(value){
	          return setter(this, index, value);
	        },
	        enumerable: true
	      });
	    };
	    if(FORCED){
	      TypedArray = wrapper(function(that, data, $offset, $length){
	        anInstance(that, TypedArray, NAME, '_d');
	        var index  = 0
	          , offset = 0
	          , buffer, byteLength, length, klass;
	        if(!isObject(data)){
	          length     = strictToLength(data, true)
	          byteLength = length * BYTES;
	          buffer     = new $ArrayBuffer(byteLength);
	        } else if(data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER){
	          buffer = data;
	          offset = toOffset($offset, BYTES);
	          var $len = data.byteLength;
	          if($length === undefined){
	            if($len % BYTES)throw RangeError(WRONG_LENGTH);
	            byteLength = $len - offset;
	            if(byteLength < 0)throw RangeError(WRONG_LENGTH);
	          } else {
	            byteLength = toLength($length) * BYTES;
	            if(byteLength + offset > $len)throw RangeError(WRONG_LENGTH);
	          }
	          length = byteLength / BYTES;
	        } else if(TYPED_ARRAY in data){
	          return fromList(TypedArray, data);
	        } else {
	          return $from.call(TypedArray, data);
	        }
	        hide(that, '_d', {
	          b: buffer,
	          o: offset,
	          l: byteLength,
	          e: length,
	          v: new $DataView(buffer)
	        });
	        while(index < length)addElement(that, index++);
	      });
	      TypedArrayPrototype = TypedArray[PROTOTYPE] = create($TypedArrayPrototype$);
	      hide(TypedArrayPrototype, 'constructor', TypedArray);
	    } else if(!$iterDetect(function(iter){
	      // V8 works with iterators, but fails in many other cases
	      // https://code.google.com/p/v8/issues/detail?id=4552
	      new TypedArray(null); // eslint-disable-line no-new
	      new TypedArray(iter); // eslint-disable-line no-new
	    }, true)){
	      TypedArray = wrapper(function(that, data, $offset, $length){
	        anInstance(that, TypedArray, NAME);
	        var klass;
	        // `ws` module bug, temporarily remove validation length for Uint8Array
	        // https://github.com/websockets/ws/pull/645
	        if(!isObject(data))return new Base(strictToLength(data, ISNT_UINT8));
	        if(data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER){
	          return $length !== undefined
	            ? new Base(data, toOffset($offset, BYTES), $length)
	            : $offset !== undefined
	              ? new Base(data, toOffset($offset, BYTES))
	              : new Base(data);
	        }
	        if(TYPED_ARRAY in data)return fromList(TypedArray, data);
	        return $from.call(TypedArray, data);
	      });
	      arrayForEach(TAC !== Function.prototype ? gOPN(Base).concat(gOPN(TAC)) : gOPN(Base), function(key){
	        if(!(key in TypedArray))hide(TypedArray, key, Base[key]);
	      });
	      TypedArray[PROTOTYPE] = TypedArrayPrototype;
	      if(!LIBRARY)TypedArrayPrototype.constructor = TypedArray;
	    }
	    var $nativeIterator   = TypedArrayPrototype[ITERATOR]
	      , CORRECT_ITER_NAME = !!$nativeIterator && ($nativeIterator.name == 'values' || $nativeIterator.name == undefined)
	      , $iterator         = $iterators.values;
	    hide(TypedArray, TYPED_CONSTRUCTOR, true);
	    hide(TypedArrayPrototype, TYPED_ARRAY, NAME);
	    hide(TypedArrayPrototype, VIEW, true);
	    hide(TypedArrayPrototype, DEF_CONSTRUCTOR, TypedArray);
	
	    if(CLAMPED ? new TypedArray(1)[TAG] != NAME : !(TAG in TypedArrayPrototype)){
	      dP(TypedArrayPrototype, TAG, {
	        get: function(){ return NAME; }
	      });
	    }
	
	    O[NAME] = TypedArray;
	
	    $export($export.G + $export.W + $export.F * (TypedArray != Base), O);
	
	    $export($export.S, NAME, {
	      BYTES_PER_ELEMENT: BYTES,
	      from: $from,
	      of: $of
	    });
	
	    if(!(BYTES_PER_ELEMENT in TypedArrayPrototype))hide(TypedArrayPrototype, BYTES_PER_ELEMENT, BYTES);
	
	    $export($export.P, NAME, proto);
	
	    setSpecies(NAME);
	
	    $export($export.P + $export.F * FORCED_SET, NAME, {set: $set});
	
	    $export($export.P + $export.F * !CORRECT_ITER_NAME, NAME, $iterators);
	
	    $export($export.P + $export.F * (TypedArrayPrototype.toString != arrayToString), NAME, {toString: arrayToString});
	
	    $export($export.P + $export.F * fails(function(){
	      new TypedArray(1).slice();
	    }), NAME, {slice: $slice});
	
	    $export($export.P + $export.F * (fails(function(){
	      return [1, 2].toLocaleString() != new TypedArray([1, 2]).toLocaleString()
	    }) || !fails(function(){
	      TypedArrayPrototype.toLocaleString.call([1, 2]);
	    })), NAME, {toLocaleString: $toLocaleString});
	
	    Iterators[NAME] = CORRECT_ITER_NAME ? $nativeIterator : $iterator;
	    if(!LIBRARY && !CORRECT_ITER_NAME)hide(TypedArrayPrototype, ITERATOR, $iterator);
	  };
	} else module.exports = function(){ /* empty */ };

/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(223)('Uint8', 1, function(init){
	  return function Uint8Array(data, byteOffset, length){
	    return init(this, data, byteOffset, length);
	  };
	});

/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(223)('Uint8', 1, function(init){
	  return function Uint8ClampedArray(data, byteOffset, length){
	    return init(this, data, byteOffset, length);
	  };
	}, true);

/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(223)('Int16', 2, function(init){
	  return function Int16Array(data, byteOffset, length){
	    return init(this, data, byteOffset, length);
	  };
	});

/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(223)('Uint16', 2, function(init){
	  return function Uint16Array(data, byteOffset, length){
	    return init(this, data, byteOffset, length);
	  };
	});

/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(223)('Int32', 4, function(init){
	  return function Int32Array(data, byteOffset, length){
	    return init(this, data, byteOffset, length);
	  };
	});

/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(223)('Uint32', 4, function(init){
	  return function Uint32Array(data, byteOffset, length){
	    return init(this, data, byteOffset, length);
	  };
	});

/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(223)('Float32', 4, function(init){
	  return function Float32Array(data, byteOffset, length){
	    return init(this, data, byteOffset, length);
	  };
	});

/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(223)('Float64', 8, function(init){
	  return function Float64Array(data, byteOffset, length){
	    return init(this, data, byteOffset, length);
	  };
	});

/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.1 Reflect.apply(target, thisArgument, argumentsList)
	var $export   = __webpack_require__(8)
	  , aFunction = __webpack_require__(21)
	  , anObject  = __webpack_require__(12)
	  , rApply    = (__webpack_require__(4).Reflect || {}).apply
	  , fApply    = Function.apply;
	// MS Edge argumentsList argument is optional
	$export($export.S + $export.F * !__webpack_require__(7)(function(){
	  rApply(function(){});
	}), 'Reflect', {
	  apply: function apply(target, thisArgument, argumentsList){
	    var T = aFunction(target)
	      , L = anObject(argumentsList);
	    return rApply ? rApply(T, thisArgument, L) : fApply.call(T, thisArgument, L);
	  }
	});

/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.2 Reflect.construct(target, argumentsList [, newTarget])
	var $export    = __webpack_require__(8)
	  , create     = __webpack_require__(46)
	  , aFunction  = __webpack_require__(21)
	  , anObject   = __webpack_require__(12)
	  , isObject   = __webpack_require__(13)
	  , fails      = __webpack_require__(7)
	  , bind       = __webpack_require__(77)
	  , rConstruct = (__webpack_require__(4).Reflect || {}).construct;
	
	// MS Edge supports only 2 arguments and argumentsList argument is optional
	// FF Nightly sets third argument as `new.target`, but does not create `this` from it
	var NEW_TARGET_BUG = fails(function(){
	  function F(){}
	  return !(rConstruct(function(){}, [], F) instanceof F);
	});
	var ARGS_BUG = !fails(function(){
	  rConstruct(function(){});
	});
	
	$export($export.S + $export.F * (NEW_TARGET_BUG || ARGS_BUG), 'Reflect', {
	  construct: function construct(Target, args /*, newTarget*/){
	    aFunction(Target);
	    anObject(args);
	    var newTarget = arguments.length < 3 ? Target : aFunction(arguments[2]);
	    if(ARGS_BUG && !NEW_TARGET_BUG)return rConstruct(Target, args, newTarget);
	    if(Target == newTarget){
	      // w/o altered newTarget, optimization for 0-4 arguments
	      switch(args.length){
	        case 0: return new Target;
	        case 1: return new Target(args[0]);
	        case 2: return new Target(args[0], args[1]);
	        case 3: return new Target(args[0], args[1], args[2]);
	        case 4: return new Target(args[0], args[1], args[2], args[3]);
	      }
	      // w/o altered newTarget, lot of arguments case
	      var $args = [null];
	      $args.push.apply($args, args);
	      return new (bind.apply(Target, $args));
	    }
	    // with altered newTarget, not support built-in constructors
	    var proto    = newTarget.prototype
	      , instance = create(isObject(proto) ? proto : Object.prototype)
	      , result   = Function.apply.call(Target, instance, args);
	    return isObject(result) ? result : instance;
	  }
	});

/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.3 Reflect.defineProperty(target, propertyKey, attributes)
	var dP          = __webpack_require__(11)
	  , $export     = __webpack_require__(8)
	  , anObject    = __webpack_require__(12)
	  , toPrimitive = __webpack_require__(16);
	
	// MS Edge has broken Reflect.defineProperty - throwing instead of returning false
	$export($export.S + $export.F * __webpack_require__(7)(function(){
	  Reflect.defineProperty(dP.f({}, 1, {value: 1}), 1, {value: 2});
	}), 'Reflect', {
	  defineProperty: function defineProperty(target, propertyKey, attributes){
	    anObject(target);
	    propertyKey = toPrimitive(propertyKey, true);
	    anObject(attributes);
	    try {
	      dP.f(target, propertyKey, attributes);
	      return true;
	    } catch(e){
	      return false;
	    }
	  }
	});

/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.4 Reflect.deleteProperty(target, propertyKey)
	var $export  = __webpack_require__(8)
	  , gOPD     = __webpack_require__(51).f
	  , anObject = __webpack_require__(12);
	
	$export($export.S, 'Reflect', {
	  deleteProperty: function deleteProperty(target, propertyKey){
	    var desc = gOPD(anObject(target), propertyKey);
	    return desc && !desc.configurable ? false : delete target[propertyKey];
	  }
	});

/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 26.1.5 Reflect.enumerate(target)
	var $export  = __webpack_require__(8)
	  , anObject = __webpack_require__(12);
	var Enumerate = function(iterated){
	  this._t = anObject(iterated); // target
	  this._i = 0;                  // next index
	  var keys = this._k = []       // keys
	    , key;
	  for(key in iterated)keys.push(key);
	};
	__webpack_require__(130)(Enumerate, 'Object', function(){
	  var that = this
	    , keys = that._k
	    , key;
	  do {
	    if(that._i >= keys.length)return {value: undefined, done: true};
	  } while(!((key = keys[that._i++]) in that._t));
	  return {value: key, done: false};
	});
	
	$export($export.S, 'Reflect', {
	  enumerate: function enumerate(target){
	    return new Enumerate(target);
	  }
	});

/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.6 Reflect.get(target, propertyKey [, receiver])
	var gOPD           = __webpack_require__(51)
	  , getPrototypeOf = __webpack_require__(59)
	  , has            = __webpack_require__(5)
	  , $export        = __webpack_require__(8)
	  , isObject       = __webpack_require__(13)
	  , anObject       = __webpack_require__(12);
	
	function get(target, propertyKey/*, receiver*/){
	  var receiver = arguments.length < 3 ? target : arguments[2]
	    , desc, proto;
	  if(anObject(target) === receiver)return target[propertyKey];
	  if(desc = gOPD.f(target, propertyKey))return has(desc, 'value')
	    ? desc.value
	    : desc.get !== undefined
	      ? desc.get.call(receiver)
	      : undefined;
	  if(isObject(proto = getPrototypeOf(target)))return get(proto, propertyKey, receiver);
	}
	
	$export($export.S, 'Reflect', {get: get});

/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.7 Reflect.getOwnPropertyDescriptor(target, propertyKey)
	var gOPD     = __webpack_require__(51)
	  , $export  = __webpack_require__(8)
	  , anObject = __webpack_require__(12);
	
	$export($export.S, 'Reflect', {
	  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(target, propertyKey){
	    return gOPD.f(anObject(target), propertyKey);
	  }
	});

/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.8 Reflect.getPrototypeOf(target)
	var $export  = __webpack_require__(8)
	  , getProto = __webpack_require__(59)
	  , anObject = __webpack_require__(12);
	
	$export($export.S, 'Reflect', {
	  getPrototypeOf: function getPrototypeOf(target){
	    return getProto(anObject(target));
	  }
	});

/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.9 Reflect.has(target, propertyKey)
	var $export = __webpack_require__(8);
	
	$export($export.S, 'Reflect', {
	  has: function has(target, propertyKey){
	    return propertyKey in target;
	  }
	});

/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.10 Reflect.isExtensible(target)
	var $export       = __webpack_require__(8)
	  , anObject      = __webpack_require__(12)
	  , $isExtensible = Object.isExtensible;
	
	$export($export.S, 'Reflect', {
	  isExtensible: function isExtensible(target){
	    anObject(target);
	    return $isExtensible ? $isExtensible(target) : true;
	  }
	});

/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.11 Reflect.ownKeys(target)
	var $export = __webpack_require__(8);
	
	$export($export.S, 'Reflect', {ownKeys: __webpack_require__(243)});

/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

	// all object keys, includes non-enumerable and symbols
	var gOPN     = __webpack_require__(50)
	  , gOPS     = __webpack_require__(43)
	  , anObject = __webpack_require__(12)
	  , Reflect  = __webpack_require__(4).Reflect;
	module.exports = Reflect && Reflect.ownKeys || function ownKeys(it){
	  var keys       = gOPN.f(anObject(it))
	    , getSymbols = gOPS.f;
	  return getSymbols ? keys.concat(getSymbols(it)) : keys;
	};

/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.12 Reflect.preventExtensions(target)
	var $export            = __webpack_require__(8)
	  , anObject           = __webpack_require__(12)
	  , $preventExtensions = Object.preventExtensions;
	
	$export($export.S, 'Reflect', {
	  preventExtensions: function preventExtensions(target){
	    anObject(target);
	    try {
	      if($preventExtensions)$preventExtensions(target);
	      return true;
	    } catch(e){
	      return false;
	    }
	  }
	});

/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.13 Reflect.set(target, propertyKey, V [, receiver])
	var dP             = __webpack_require__(11)
	  , gOPD           = __webpack_require__(51)
	  , getPrototypeOf = __webpack_require__(59)
	  , has            = __webpack_require__(5)
	  , $export        = __webpack_require__(8)
	  , createDesc     = __webpack_require__(17)
	  , anObject       = __webpack_require__(12)
	  , isObject       = __webpack_require__(13);
	
	function set(target, propertyKey, V/*, receiver*/){
	  var receiver = arguments.length < 4 ? target : arguments[3]
	    , ownDesc  = gOPD.f(anObject(target), propertyKey)
	    , existingDescriptor, proto;
	  if(!ownDesc){
	    if(isObject(proto = getPrototypeOf(target))){
	      return set(proto, propertyKey, V, receiver);
	    }
	    ownDesc = createDesc(0);
	  }
	  if(has(ownDesc, 'value')){
	    if(ownDesc.writable === false || !isObject(receiver))return false;
	    existingDescriptor = gOPD.f(receiver, propertyKey) || createDesc(0);
	    existingDescriptor.value = V;
	    dP.f(receiver, propertyKey, existingDescriptor);
	    return true;
	  }
	  return ownDesc.set === undefined ? false : (ownDesc.set.call(receiver, V), true);
	}
	
	$export($export.S, 'Reflect', {set: set});

/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.14 Reflect.setPrototypeOf(target, proto)
	var $export  = __webpack_require__(8)
	  , setProto = __webpack_require__(73);
	
	if(setProto)$export($export.S, 'Reflect', {
	  setPrototypeOf: function setPrototypeOf(target, proto){
	    setProto.check(target, proto);
	    try {
	      setProto.set(target, proto);
	      return true;
	    } catch(e){
	      return false;
	    }
	  }
	});

/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/Array.prototype.includes
	var $export   = __webpack_require__(8)
	  , $includes = __webpack_require__(36)(true);
	
	$export($export.P, 'Array', {
	  includes: function includes(el /*, fromIndex = 0 */){
	    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	
	__webpack_require__(186)('includes');

/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/mathiasbynens/String.prototype.at
	var $export = __webpack_require__(8)
	  , $at     = __webpack_require__(127)(true);
	
	$export($export.P, 'String', {
	  at: function at(pos){
	    return $at(this, pos);
	  }
	});

/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/proposal-string-pad-start-end
	var $export = __webpack_require__(8)
	  , $pad    = __webpack_require__(250);
	
	$export($export.P, 'String', {
	  padStart: function padStart(maxLength /*, fillString = ' ' */){
	    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, true);
	  }
	});

/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-string-pad-start-end
	var toLength = __webpack_require__(37)
	  , repeat   = __webpack_require__(91)
	  , defined  = __webpack_require__(35);
	
	module.exports = function(that, maxLength, fillString, left){
	  var S            = String(defined(that))
	    , stringLength = S.length
	    , fillStr      = fillString === undefined ? ' ' : String(fillString)
	    , intMaxLength = toLength(maxLength);
	  if(intMaxLength <= stringLength || fillStr == '')return S;
	  var fillLen = intMaxLength - stringLength
	    , stringFiller = repeat.call(fillStr, Math.ceil(fillLen / fillStr.length));
	  if(stringFiller.length > fillLen)stringFiller = stringFiller.slice(0, fillLen);
	  return left ? stringFiller + S : S + stringFiller;
	};


/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/proposal-string-pad-start-end
	var $export = __webpack_require__(8)
	  , $pad    = __webpack_require__(250);
	
	$export($export.P, 'String', {
	  padEnd: function padEnd(maxLength /*, fillString = ' ' */){
	    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, false);
	  }
	});

/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
	__webpack_require__(83)('trimLeft', function($trim){
	  return function trimLeft(){
	    return $trim(this, 1);
	  };
	}, 'trimStart');

/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
	__webpack_require__(83)('trimRight', function($trim){
	  return function trimRight(){
	    return $trim(this, 2);
	  };
	}, 'trimEnd');

/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/String.prototype.matchAll/
	var $export     = __webpack_require__(8)
	  , defined     = __webpack_require__(35)
	  , toLength    = __webpack_require__(37)
	  , isRegExp    = __webpack_require__(134)
	  , getFlags    = __webpack_require__(196)
	  , RegExpProto = RegExp.prototype;
	
	var $RegExpStringIterator = function(regexp, string){
	  this._r = regexp;
	  this._s = string;
	};
	
	__webpack_require__(130)($RegExpStringIterator, 'RegExp String', function next(){
	  var match = this._r.exec(this._s);
	  return {value: match, done: match === null};
	});
	
	$export($export.P, 'String', {
	  matchAll: function matchAll(regexp){
	    defined(this);
	    if(!isRegExp(regexp))throw TypeError(regexp + ' is not a regexp!');
	    var S     = String(this)
	      , flags = 'flags' in RegExpProto ? String(regexp.flags) : getFlags.call(regexp)
	      , rx    = new RegExp(regexp.source, ~flags.indexOf('g') ? flags : 'g' + flags);
	    rx.lastIndex = toLength(regexp.lastIndex);
	    return new $RegExpStringIterator(rx, S);
	  }
	});

/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(27)('asyncIterator');

/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(27)('observable');

/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-object-getownpropertydescriptors
	var $export        = __webpack_require__(8)
	  , ownKeys        = __webpack_require__(243)
	  , toIObject      = __webpack_require__(32)
	  , gOPD           = __webpack_require__(51)
	  , createProperty = __webpack_require__(163);
	
	$export($export.S, 'Object', {
	  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object){
	    var O       = toIObject(object)
	      , getDesc = gOPD.f
	      , keys    = ownKeys(O)
	      , result  = {}
	      , i       = 0
	      , key;
	    while(keys.length > i)createProperty(result, key = keys[i++], getDesc(O, key));
	    return result;
	  }
	});

/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-object-values-entries
	var $export = __webpack_require__(8)
	  , $values = __webpack_require__(259)(false);
	
	$export($export.S, 'Object', {
	  values: function values(it){
	    return $values(it);
	  }
	});

/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

	var getKeys   = __webpack_require__(30)
	  , toIObject = __webpack_require__(32)
	  , isEnum    = __webpack_require__(44).f;
	module.exports = function(isEntries){
	  return function(it){
	    var O      = toIObject(it)
	      , keys   = getKeys(O)
	      , length = keys.length
	      , i      = 0
	      , result = []
	      , key;
	    while(length > i)if(isEnum.call(O, key = keys[i++])){
	      result.push(isEntries ? [key, O[key]] : O[key]);
	    } return result;
	  };
	};

/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-object-values-entries
	var $export  = __webpack_require__(8)
	  , $entries = __webpack_require__(259)(true);
	
	$export($export.S, 'Object', {
	  entries: function entries(it){
	    return $entries(it);
	  }
	});

/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export         = __webpack_require__(8)
	  , toObject        = __webpack_require__(58)
	  , aFunction       = __webpack_require__(21)
	  , $defineProperty = __webpack_require__(11);
	
	// B.2.2.2 Object.prototype.__defineGetter__(P, getter)
	__webpack_require__(6) && $export($export.P + __webpack_require__(262), 'Object', {
	  __defineGetter__: function __defineGetter__(P, getter){
	    $defineProperty.f(toObject(this), P, {get: aFunction(getter), enumerable: true, configurable: true});
	  }
	});

/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

	// Forced replacement prototype accessors methods
	module.exports = __webpack_require__(28)|| !__webpack_require__(7)(function(){
	  var K = Math.random();
	  // In FF throws only define methods
	  __defineSetter__.call(null, K, function(){ /* empty */});
	  delete __webpack_require__(4)[K];
	});

/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export         = __webpack_require__(8)
	  , toObject        = __webpack_require__(58)
	  , aFunction       = __webpack_require__(21)
	  , $defineProperty = __webpack_require__(11);
	
	// B.2.2.3 Object.prototype.__defineSetter__(P, setter)
	__webpack_require__(6) && $export($export.P + __webpack_require__(262), 'Object', {
	  __defineSetter__: function __defineSetter__(P, setter){
	    $defineProperty.f(toObject(this), P, {set: aFunction(setter), enumerable: true, configurable: true});
	  }
	});

/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export                  = __webpack_require__(8)
	  , toObject                 = __webpack_require__(58)
	  , toPrimitive              = __webpack_require__(16)
	  , getPrototypeOf           = __webpack_require__(59)
	  , getOwnPropertyDescriptor = __webpack_require__(51).f;
	
	// B.2.2.4 Object.prototype.__lookupGetter__(P)
	__webpack_require__(6) && $export($export.P + __webpack_require__(262), 'Object', {
	  __lookupGetter__: function __lookupGetter__(P){
	    var O = toObject(this)
	      , K = toPrimitive(P, true)
	      , D;
	    do {
	      if(D = getOwnPropertyDescriptor(O, K))return D.get;
	    } while(O = getPrototypeOf(O));
	  }
	});

/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export                  = __webpack_require__(8)
	  , toObject                 = __webpack_require__(58)
	  , toPrimitive              = __webpack_require__(16)
	  , getPrototypeOf           = __webpack_require__(59)
	  , getOwnPropertyDescriptor = __webpack_require__(51).f;
	
	// B.2.2.5 Object.prototype.__lookupSetter__(P)
	__webpack_require__(6) && $export($export.P + __webpack_require__(262), 'Object', {
	  __lookupSetter__: function __lookupSetter__(P){
	    var O = toObject(this)
	      , K = toPrimitive(P, true)
	      , D;
	    do {
	      if(D = getOwnPropertyDescriptor(O, K))return D.set;
	    } while(O = getPrototypeOf(O));
	  }
	});

/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var $export  = __webpack_require__(8);
	
	$export($export.P + $export.R, 'Map', {toJSON: __webpack_require__(267)('Map')});

/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var classof = __webpack_require__(75)
	  , from    = __webpack_require__(268);
	module.exports = function(NAME){
	  return function toJSON(){
	    if(classof(this) != NAME)throw TypeError(NAME + "#toJSON isn't generic");
	    return from(this);
	  };
	};

/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

	var forOf = __webpack_require__(206);
	
	module.exports = function(iter, ITERATOR){
	  var result = [];
	  forOf(iter, false, result.push, result, ITERATOR);
	  return result;
	};


/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var $export  = __webpack_require__(8);
	
	$export($export.P + $export.R, 'Set', {toJSON: __webpack_require__(267)('Set')});

/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/ljharb/proposal-global
	var $export = __webpack_require__(8);
	
	$export($export.S, 'System', {global: __webpack_require__(4)});

/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/ljharb/proposal-is-error
	var $export = __webpack_require__(8)
	  , cof     = __webpack_require__(34);
	
	$export($export.S, 'Error', {
	  isError: function isError(it){
	    return cof(it) === 'Error';
	  }
	});

/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(8);
	
	$export($export.S, 'Math', {
	  iaddh: function iaddh(x0, x1, y0, y1){
	    var $x0 = x0 >>> 0
	      , $x1 = x1 >>> 0
	      , $y0 = y0 >>> 0;
	    return $x1 + (y1 >>> 0) + (($x0 & $y0 | ($x0 | $y0) & ~($x0 + $y0 >>> 0)) >>> 31) | 0;
	  }
	});

/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(8);
	
	$export($export.S, 'Math', {
	  isubh: function isubh(x0, x1, y0, y1){
	    var $x0 = x0 >>> 0
	      , $x1 = x1 >>> 0
	      , $y0 = y0 >>> 0;
	    return $x1 - (y1 >>> 0) - ((~$x0 & $y0 | ~($x0 ^ $y0) & $x0 - $y0 >>> 0) >>> 31) | 0;
	  }
	});

/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(8);
	
	$export($export.S, 'Math', {
	  imulh: function imulh(u, v){
	    var UINT16 = 0xffff
	      , $u = +u
	      , $v = +v
	      , u0 = $u & UINT16
	      , v0 = $v & UINT16
	      , u1 = $u >> 16
	      , v1 = $v >> 16
	      , t  = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
	    return u1 * v1 + (t >> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >> 16);
	  }
	});

/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(8);
	
	$export($export.S, 'Math', {
	  umulh: function umulh(u, v){
	    var UINT16 = 0xffff
	      , $u = +u
	      , $v = +v
	      , u0 = $u & UINT16
	      , v0 = $v & UINT16
	      , u1 = $u >>> 16
	      , v1 = $v >>> 16
	      , t  = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
	    return u1 * v1 + (t >>> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >>> 16);
	  }
	});

/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

	var metadata                  = __webpack_require__(277)
	  , anObject                  = __webpack_require__(12)
	  , toMetaKey                 = metadata.key
	  , ordinaryDefineOwnMetadata = metadata.set;
	
	metadata.exp({defineMetadata: function defineMetadata(metadataKey, metadataValue, target, targetKey){
	  ordinaryDefineOwnMetadata(metadataKey, metadataValue, anObject(target), toMetaKey(targetKey));
	}});

/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

	var Map     = __webpack_require__(211)
	  , $export = __webpack_require__(8)
	  , shared  = __webpack_require__(23)('metadata')
	  , store   = shared.store || (shared.store = new (__webpack_require__(215)));
	
	var getOrCreateMetadataMap = function(target, targetKey, create){
	  var targetMetadata = store.get(target);
	  if(!targetMetadata){
	    if(!create)return undefined;
	    store.set(target, targetMetadata = new Map);
	  }
	  var keyMetadata = targetMetadata.get(targetKey);
	  if(!keyMetadata){
	    if(!create)return undefined;
	    targetMetadata.set(targetKey, keyMetadata = new Map);
	  } return keyMetadata;
	};
	var ordinaryHasOwnMetadata = function(MetadataKey, O, P){
	  var metadataMap = getOrCreateMetadataMap(O, P, false);
	  return metadataMap === undefined ? false : metadataMap.has(MetadataKey);
	};
	var ordinaryGetOwnMetadata = function(MetadataKey, O, P){
	  var metadataMap = getOrCreateMetadataMap(O, P, false);
	  return metadataMap === undefined ? undefined : metadataMap.get(MetadataKey);
	};
	var ordinaryDefineOwnMetadata = function(MetadataKey, MetadataValue, O, P){
	  getOrCreateMetadataMap(O, P, true).set(MetadataKey, MetadataValue);
	};
	var ordinaryOwnMetadataKeys = function(target, targetKey){
	  var metadataMap = getOrCreateMetadataMap(target, targetKey, false)
	    , keys        = [];
	  if(metadataMap)metadataMap.forEach(function(_, key){ keys.push(key); });
	  return keys;
	};
	var toMetaKey = function(it){
	  return it === undefined || typeof it == 'symbol' ? it : String(it);
	};
	var exp = function(O){
	  $export($export.S, 'Reflect', O);
	};
	
	module.exports = {
	  store: store,
	  map: getOrCreateMetadataMap,
	  has: ordinaryHasOwnMetadata,
	  get: ordinaryGetOwnMetadata,
	  set: ordinaryDefineOwnMetadata,
	  keys: ordinaryOwnMetadataKeys,
	  key: toMetaKey,
	  exp: exp
	};

/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

	var metadata               = __webpack_require__(277)
	  , anObject               = __webpack_require__(12)
	  , toMetaKey              = metadata.key
	  , getOrCreateMetadataMap = metadata.map
	  , store                  = metadata.store;
	
	metadata.exp({deleteMetadata: function deleteMetadata(metadataKey, target /*, targetKey */){
	  var targetKey   = arguments.length < 3 ? undefined : toMetaKey(arguments[2])
	    , metadataMap = getOrCreateMetadataMap(anObject(target), targetKey, false);
	  if(metadataMap === undefined || !metadataMap['delete'](metadataKey))return false;
	  if(metadataMap.size)return true;
	  var targetMetadata = store.get(target);
	  targetMetadata['delete'](targetKey);
	  return !!targetMetadata.size || store['delete'](target);
	}});

/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

	var metadata               = __webpack_require__(277)
	  , anObject               = __webpack_require__(12)
	  , getPrototypeOf         = __webpack_require__(59)
	  , ordinaryHasOwnMetadata = metadata.has
	  , ordinaryGetOwnMetadata = metadata.get
	  , toMetaKey              = metadata.key;
	
	var ordinaryGetMetadata = function(MetadataKey, O, P){
	  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
	  if(hasOwn)return ordinaryGetOwnMetadata(MetadataKey, O, P);
	  var parent = getPrototypeOf(O);
	  return parent !== null ? ordinaryGetMetadata(MetadataKey, parent, P) : undefined;
	};
	
	metadata.exp({getMetadata: function getMetadata(metadataKey, target /*, targetKey */){
	  return ordinaryGetMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	}});

/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

	var Set                     = __webpack_require__(214)
	  , from                    = __webpack_require__(268)
	  , metadata                = __webpack_require__(277)
	  , anObject                = __webpack_require__(12)
	  , getPrototypeOf          = __webpack_require__(59)
	  , ordinaryOwnMetadataKeys = metadata.keys
	  , toMetaKey               = metadata.key;
	
	var ordinaryMetadataKeys = function(O, P){
	  var oKeys  = ordinaryOwnMetadataKeys(O, P)
	    , parent = getPrototypeOf(O);
	  if(parent === null)return oKeys;
	  var pKeys  = ordinaryMetadataKeys(parent, P);
	  return pKeys.length ? oKeys.length ? from(new Set(oKeys.concat(pKeys))) : pKeys : oKeys;
	};
	
	metadata.exp({getMetadataKeys: function getMetadataKeys(target /*, targetKey */){
	  return ordinaryMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
	}});

/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

	var metadata               = __webpack_require__(277)
	  , anObject               = __webpack_require__(12)
	  , ordinaryGetOwnMetadata = metadata.get
	  , toMetaKey              = metadata.key;
	
	metadata.exp({getOwnMetadata: function getOwnMetadata(metadataKey, target /*, targetKey */){
	  return ordinaryGetOwnMetadata(metadataKey, anObject(target)
	    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	}});

/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

	var metadata                = __webpack_require__(277)
	  , anObject                = __webpack_require__(12)
	  , ordinaryOwnMetadataKeys = metadata.keys
	  , toMetaKey               = metadata.key;
	
	metadata.exp({getOwnMetadataKeys: function getOwnMetadataKeys(target /*, targetKey */){
	  return ordinaryOwnMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
	}});

/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

	var metadata               = __webpack_require__(277)
	  , anObject               = __webpack_require__(12)
	  , getPrototypeOf         = __webpack_require__(59)
	  , ordinaryHasOwnMetadata = metadata.has
	  , toMetaKey              = metadata.key;
	
	var ordinaryHasMetadata = function(MetadataKey, O, P){
	  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
	  if(hasOwn)return true;
	  var parent = getPrototypeOf(O);
	  return parent !== null ? ordinaryHasMetadata(MetadataKey, parent, P) : false;
	};
	
	metadata.exp({hasMetadata: function hasMetadata(metadataKey, target /*, targetKey */){
	  return ordinaryHasMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	}});

/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

	var metadata               = __webpack_require__(277)
	  , anObject               = __webpack_require__(12)
	  , ordinaryHasOwnMetadata = metadata.has
	  , toMetaKey              = metadata.key;
	
	metadata.exp({hasOwnMetadata: function hasOwnMetadata(metadataKey, target /*, targetKey */){
	  return ordinaryHasOwnMetadata(metadataKey, anObject(target)
	    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	}});

/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

	var metadata                  = __webpack_require__(277)
	  , anObject                  = __webpack_require__(12)
	  , aFunction                 = __webpack_require__(21)
	  , toMetaKey                 = metadata.key
	  , ordinaryDefineOwnMetadata = metadata.set;
	
	metadata.exp({metadata: function metadata(metadataKey, metadataValue){
	  return function decorator(target, targetKey){
	    ordinaryDefineOwnMetadata(
	      metadataKey, metadataValue,
	      (targetKey !== undefined ? anObject : aFunction)(target),
	      toMetaKey(targetKey)
	    );
	  };
	}});

/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/rwaldron/tc39-notes/blob/master/es6/2014-09/sept-25.md#510-globalasap-for-enqueuing-a-microtask
	var $export   = __webpack_require__(8)
	  , microtask = __webpack_require__(209)()
	  , process   = __webpack_require__(4).process
	  , isNode    = __webpack_require__(34)(process) == 'process';
	
	$export($export.G, {
	  asap: function asap(fn){
	    var domain = isNode && process.domain;
	    microtask(domain ? domain.bind(fn) : fn);
	  }
	});

/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/zenparsing/es-observable
	var $export     = __webpack_require__(8)
	  , global      = __webpack_require__(4)
	  , core        = __webpack_require__(9)
	  , microtask   = __webpack_require__(209)()
	  , OBSERVABLE  = __webpack_require__(25)('observable')
	  , aFunction   = __webpack_require__(21)
	  , anObject    = __webpack_require__(12)
	  , anInstance  = __webpack_require__(205)
	  , redefineAll = __webpack_require__(210)
	  , hide        = __webpack_require__(10)
	  , forOf       = __webpack_require__(206)
	  , RETURN      = forOf.RETURN;
	
	var getMethod = function(fn){
	  return fn == null ? undefined : aFunction(fn);
	};
	
	var cleanupSubscription = function(subscription){
	  var cleanup = subscription._c;
	  if(cleanup){
	    subscription._c = undefined;
	    cleanup();
	  }
	};
	
	var subscriptionClosed = function(subscription){
	  return subscription._o === undefined;
	};
	
	var closeSubscription = function(subscription){
	  if(!subscriptionClosed(subscription)){
	    subscription._o = undefined;
	    cleanupSubscription(subscription);
	  }
	};
	
	var Subscription = function(observer, subscriber){
	  anObject(observer);
	  this._c = undefined;
	  this._o = observer;
	  observer = new SubscriptionObserver(this);
	  try {
	    var cleanup      = subscriber(observer)
	      , subscription = cleanup;
	    if(cleanup != null){
	      if(typeof cleanup.unsubscribe === 'function')cleanup = function(){ subscription.unsubscribe(); };
	      else aFunction(cleanup);
	      this._c = cleanup;
	    }
	  } catch(e){
	    observer.error(e);
	    return;
	  } if(subscriptionClosed(this))cleanupSubscription(this);
	};
	
	Subscription.prototype = redefineAll({}, {
	  unsubscribe: function unsubscribe(){ closeSubscription(this); }
	});
	
	var SubscriptionObserver = function(subscription){
	  this._s = subscription;
	};
	
	SubscriptionObserver.prototype = redefineAll({}, {
	  next: function next(value){
	    var subscription = this._s;
	    if(!subscriptionClosed(subscription)){
	      var observer = subscription._o;
	      try {
	        var m = getMethod(observer.next);
	        if(m)return m.call(observer, value);
	      } catch(e){
	        try {
	          closeSubscription(subscription);
	        } finally {
	          throw e;
	        }
	      }
	    }
	  },
	  error: function error(value){
	    var subscription = this._s;
	    if(subscriptionClosed(subscription))throw value;
	    var observer = subscription._o;
	    subscription._o = undefined;
	    try {
	      var m = getMethod(observer.error);
	      if(!m)throw value;
	      value = m.call(observer, value);
	    } catch(e){
	      try {
	        cleanupSubscription(subscription);
	      } finally {
	        throw e;
	      }
	    } cleanupSubscription(subscription);
	    return value;
	  },
	  complete: function complete(value){
	    var subscription = this._s;
	    if(!subscriptionClosed(subscription)){
	      var observer = subscription._o;
	      subscription._o = undefined;
	      try {
	        var m = getMethod(observer.complete);
	        value = m ? m.call(observer, value) : undefined;
	      } catch(e){
	        try {
	          cleanupSubscription(subscription);
	        } finally {
	          throw e;
	        }
	      } cleanupSubscription(subscription);
	      return value;
	    }
	  }
	});
	
	var $Observable = function Observable(subscriber){
	  anInstance(this, $Observable, 'Observable', '_f')._f = aFunction(subscriber);
	};
	
	redefineAll($Observable.prototype, {
	  subscribe: function subscribe(observer){
	    return new Subscription(observer, this._f);
	  },
	  forEach: function forEach(fn){
	    var that = this;
	    return new (core.Promise || global.Promise)(function(resolve, reject){
	      aFunction(fn);
	      var subscription = that.subscribe({
	        next : function(value){
	          try {
	            return fn(value);
	          } catch(e){
	            reject(e);
	            subscription.unsubscribe();
	          }
	        },
	        error: reject,
	        complete: resolve
	      });
	    });
	  }
	});
	
	redefineAll($Observable, {
	  from: function from(x){
	    var C = typeof this === 'function' ? this : $Observable;
	    var method = getMethod(anObject(x)[OBSERVABLE]);
	    if(method){
	      var observable = anObject(method.call(x));
	      return observable.constructor === C ? observable : new C(function(observer){
	        return observable.subscribe(observer);
	      });
	    }
	    return new C(function(observer){
	      var done = false;
	      microtask(function(){
	        if(!done){
	          try {
	            if(forOf(x, false, function(it){
	              observer.next(it);
	              if(done)return RETURN;
	            }) === RETURN)return;
	          } catch(e){
	            if(done)throw e;
	            observer.error(e);
	            return;
	          } observer.complete();
	        }
	      });
	      return function(){ done = true; };
	    });
	  },
	  of: function of(){
	    for(var i = 0, l = arguments.length, items = Array(l); i < l;)items[i] = arguments[i++];
	    return new (typeof this === 'function' ? this : $Observable)(function(observer){
	      var done = false;
	      microtask(function(){
	        if(!done){
	          for(var i = 0; i < items.length; ++i){
	            observer.next(items[i]);
	            if(done)return;
	          } observer.complete();
	        }
	      });
	      return function(){ done = true; };
	    });
	  }
	});
	
	hide($Observable.prototype, OBSERVABLE, function(){ return this; });
	
	$export($export.G, {Observable: $Observable});
	
	__webpack_require__(192)('Observable');

/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

	// ie9- setTimeout & setInterval additional parameters fix
	var global     = __webpack_require__(4)
	  , $export    = __webpack_require__(8)
	  , invoke     = __webpack_require__(78)
	  , partial    = __webpack_require__(289)
	  , navigator  = global.navigator
	  , MSIE       = !!navigator && /MSIE .\./.test(navigator.userAgent); // <- dirty ie9- check
	var wrap = function(set){
	  return MSIE ? function(fn, time /*, ...args */){
	    return set(invoke(
	      partial,
	      [].slice.call(arguments, 2),
	      typeof fn == 'function' ? fn : Function(fn)
	    ), time);
	  } : set;
	};
	$export($export.G + $export.B + $export.F * MSIE, {
	  setTimeout:  wrap(global.setTimeout),
	  setInterval: wrap(global.setInterval)
	});

/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var path      = __webpack_require__(290)
	  , invoke    = __webpack_require__(78)
	  , aFunction = __webpack_require__(21);
	module.exports = function(/* ...pargs */){
	  var fn     = aFunction(this)
	    , length = arguments.length
	    , pargs  = Array(length)
	    , i      = 0
	    , _      = path._
	    , holder = false;
	  while(length > i)if((pargs[i] = arguments[i++]) === _)holder = true;
	  return function(/* ...args */){
	    var that = this
	      , aLen = arguments.length
	      , j = 0, k = 0, args;
	    if(!holder && !aLen)return invoke(fn, pargs, that);
	    args = pargs.slice();
	    if(holder)for(;length > j; j++)if(args[j] === _)args[j] = arguments[k++];
	    while(aLen > k)args.push(arguments[k++]);
	    return invoke(fn, args, that);
	  };
	};

/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(4);

/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(8)
	  , $task   = __webpack_require__(208);
	$export($export.G + $export.B, {
	  setImmediate:   $task.set,
	  clearImmediate: $task.clear
	});

/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

	var $iterators    = __webpack_require__(193)
	  , redefine      = __webpack_require__(18)
	  , global        = __webpack_require__(4)
	  , hide          = __webpack_require__(10)
	  , Iterators     = __webpack_require__(129)
	  , wks           = __webpack_require__(25)
	  , ITERATOR      = wks('iterator')
	  , TO_STRING_TAG = wks('toStringTag')
	  , ArrayValues   = Iterators.Array;
	
	for(var collections = ['NodeList', 'DOMTokenList', 'MediaList', 'StyleSheetList', 'CSSRuleList'], i = 0; i < 5; i++){
	  var NAME       = collections[i]
	    , Collection = global[NAME]
	    , proto      = Collection && Collection.prototype
	    , key;
	  if(proto){
	    if(!proto[ITERATOR])hide(proto, ITERATOR, ArrayValues);
	    if(!proto[TO_STRING_TAG])hide(proto, TO_STRING_TAG, NAME);
	    Iterators[NAME] = ArrayValues;
	    for(key in $iterators)if(!proto[key])redefine(proto, key, $iterators[key], true);
	  }
	}

/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {/**
	 * Copyright (c) 2014, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
	 * additional grant of patent rights can be found in the PATENTS file in
	 * the same directory.
	 */
	
	!(function(global) {
	  "use strict";
	
	  var hasOwn = Object.prototype.hasOwnProperty;
	  var undefined; // More compressible than void 0.
	  var $Symbol = typeof Symbol === "function" ? Symbol : {};
	  var iteratorSymbol = $Symbol.iterator || "@@iterator";
	  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
	
	  var inModule = typeof module === "object";
	  var runtime = global.regeneratorRuntime;
	  if (runtime) {
	    if (inModule) {
	      // If regeneratorRuntime is defined globally and we're in a module,
	      // make the exports object identical to regeneratorRuntime.
	      module.exports = runtime;
	    }
	    // Don't bother evaluating the rest of this file if the runtime was
	    // already defined globally.
	    return;
	  }
	
	  // Define the runtime globally (as expected by generated code) as either
	  // module.exports (if we're in a module) or a new, empty object.
	  runtime = global.regeneratorRuntime = inModule ? module.exports : {};
	
	  function wrap(innerFn, outerFn, self, tryLocsList) {
	    // If outerFn provided, then outerFn.prototype instanceof Generator.
	    var generator = Object.create((outerFn || Generator).prototype);
	    var context = new Context(tryLocsList || []);
	
	    // The ._invoke method unifies the implementations of the .next,
	    // .throw, and .return methods.
	    generator._invoke = makeInvokeMethod(innerFn, self, context);
	
	    return generator;
	  }
	  runtime.wrap = wrap;
	
	  // Try/catch helper to minimize deoptimizations. Returns a completion
	  // record like context.tryEntries[i].completion. This interface could
	  // have been (and was previously) designed to take a closure to be
	  // invoked without arguments, but in all the cases we care about we
	  // already have an existing method we want to call, so there's no need
	  // to create a new function object. We can even get away with assuming
	  // the method takes exactly one argument, since that happens to be true
	  // in every case, so we don't have to touch the arguments object. The
	  // only additional allocation required is the completion record, which
	  // has a stable shape and so hopefully should be cheap to allocate.
	  function tryCatch(fn, obj, arg) {
	    try {
	      return { type: "normal", arg: fn.call(obj, arg) };
	    } catch (err) {
	      return { type: "throw", arg: err };
	    }
	  }
	
	  var GenStateSuspendedStart = "suspendedStart";
	  var GenStateSuspendedYield = "suspendedYield";
	  var GenStateExecuting = "executing";
	  var GenStateCompleted = "completed";
	
	  // Returning this object from the innerFn has the same effect as
	  // breaking out of the dispatch switch statement.
	  var ContinueSentinel = {};
	
	  // Dummy constructor functions that we use as the .constructor and
	  // .constructor.prototype properties for functions that return Generator
	  // objects. For full spec compliance, you may wish to configure your
	  // minifier not to mangle the names of these two functions.
	  function Generator() {}
	  function GeneratorFunction() {}
	  function GeneratorFunctionPrototype() {}
	
	  var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype;
	  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
	  GeneratorFunctionPrototype.constructor = GeneratorFunction;
	  GeneratorFunctionPrototype[toStringTagSymbol] = GeneratorFunction.displayName = "GeneratorFunction";
	
	  // Helper for defining the .next, .throw, and .return methods of the
	  // Iterator interface in terms of a single ._invoke method.
	  function defineIteratorMethods(prototype) {
	    ["next", "throw", "return"].forEach(function(method) {
	      prototype[method] = function(arg) {
	        return this._invoke(method, arg);
	      };
	    });
	  }
	
	  runtime.isGeneratorFunction = function(genFun) {
	    var ctor = typeof genFun === "function" && genFun.constructor;
	    return ctor
	      ? ctor === GeneratorFunction ||
	        // For the native GeneratorFunction constructor, the best we can
	        // do is to check its .name property.
	        (ctor.displayName || ctor.name) === "GeneratorFunction"
	      : false;
	  };
	
	  runtime.mark = function(genFun) {
	    if (Object.setPrototypeOf) {
	      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
	    } else {
	      genFun.__proto__ = GeneratorFunctionPrototype;
	      if (!(toStringTagSymbol in genFun)) {
	        genFun[toStringTagSymbol] = "GeneratorFunction";
	      }
	    }
	    genFun.prototype = Object.create(Gp);
	    return genFun;
	  };
	
	  // Within the body of any async function, `await x` is transformed to
	  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
	  // `value instanceof AwaitArgument` to determine if the yielded value is
	  // meant to be awaited. Some may consider the name of this method too
	  // cutesy, but they are curmudgeons.
	  runtime.awrap = function(arg) {
	    return new AwaitArgument(arg);
	  };
	
	  function AwaitArgument(arg) {
	    this.arg = arg;
	  }
	
	  function AsyncIterator(generator) {
	    function invoke(method, arg, resolve, reject) {
	      var record = tryCatch(generator[method], generator, arg);
	      if (record.type === "throw") {
	        reject(record.arg);
	      } else {
	        var result = record.arg;
	        var value = result.value;
	        if (value instanceof AwaitArgument) {
	          return Promise.resolve(value.arg).then(function(value) {
	            invoke("next", value, resolve, reject);
	          }, function(err) {
	            invoke("throw", err, resolve, reject);
	          });
	        }
	
	        return Promise.resolve(value).then(function(unwrapped) {
	          // When a yielded Promise is resolved, its final value becomes
	          // the .value of the Promise<{value,done}> result for the
	          // current iteration. If the Promise is rejected, however, the
	          // result for this iteration will be rejected with the same
	          // reason. Note that rejections of yielded Promises are not
	          // thrown back into the generator function, as is the case
	          // when an awaited Promise is rejected. This difference in
	          // behavior between yield and await is important, because it
	          // allows the consumer to decide what to do with the yielded
	          // rejection (swallow it and continue, manually .throw it back
	          // into the generator, abandon iteration, whatever). With
	          // await, by contrast, there is no opportunity to examine the
	          // rejection reason outside the generator function, so the
	          // only option is to throw it from the await expression, and
	          // let the generator function handle the exception.
	          result.value = unwrapped;
	          resolve(result);
	        }, reject);
	      }
	    }
	
	    if (typeof process === "object" && process.domain) {
	      invoke = process.domain.bind(invoke);
	    }
	
	    var previousPromise;
	
	    function enqueue(method, arg) {
	      function callInvokeWithMethodAndArg() {
	        return new Promise(function(resolve, reject) {
	          invoke(method, arg, resolve, reject);
	        });
	      }
	
	      return previousPromise =
	        // If enqueue has been called before, then we want to wait until
	        // all previous Promises have been resolved before calling invoke,
	        // so that results are always delivered in the correct order. If
	        // enqueue has not been called before, then it is important to
	        // call invoke immediately, without waiting on a callback to fire,
	        // so that the async generator function has the opportunity to do
	        // any necessary setup in a predictable way. This predictability
	        // is why the Promise constructor synchronously invokes its
	        // executor callback, and why async functions synchronously
	        // execute code before the first await. Since we implement simple
	        // async functions in terms of async generators, it is especially
	        // important to get this right, even though it requires care.
	        previousPromise ? previousPromise.then(
	          callInvokeWithMethodAndArg,
	          // Avoid propagating failures to Promises returned by later
	          // invocations of the iterator.
	          callInvokeWithMethodAndArg
	        ) : callInvokeWithMethodAndArg();
	    }
	
	    // Define the unified helper method that is used to implement .next,
	    // .throw, and .return (see defineIteratorMethods).
	    this._invoke = enqueue;
	  }
	
	  defineIteratorMethods(AsyncIterator.prototype);
	
	  // Note that simple async functions are implemented on top of
	  // AsyncIterator objects; they just return a Promise for the value of
	  // the final result produced by the iterator.
	  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
	    var iter = new AsyncIterator(
	      wrap(innerFn, outerFn, self, tryLocsList)
	    );
	
	    return runtime.isGeneratorFunction(outerFn)
	      ? iter // If outerFn is a generator, return the full iterator.
	      : iter.next().then(function(result) {
	          return result.done ? result.value : iter.next();
	        });
	  };
	
	  function makeInvokeMethod(innerFn, self, context) {
	    var state = GenStateSuspendedStart;
	
	    return function invoke(method, arg) {
	      if (state === GenStateExecuting) {
	        throw new Error("Generator is already running");
	      }
	
	      if (state === GenStateCompleted) {
	        if (method === "throw") {
	          throw arg;
	        }
	
	        // Be forgiving, per 25.3.3.3.3 of the spec:
	        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
	        return doneResult();
	      }
	
	      while (true) {
	        var delegate = context.delegate;
	        if (delegate) {
	          if (method === "return" ||
	              (method === "throw" && delegate.iterator[method] === undefined)) {
	            // A return or throw (when the delegate iterator has no throw
	            // method) always terminates the yield* loop.
	            context.delegate = null;
	
	            // If the delegate iterator has a return method, give it a
	            // chance to clean up.
	            var returnMethod = delegate.iterator["return"];
	            if (returnMethod) {
	              var record = tryCatch(returnMethod, delegate.iterator, arg);
	              if (record.type === "throw") {
	                // If the return method threw an exception, let that
	                // exception prevail over the original return or throw.
	                method = "throw";
	                arg = record.arg;
	                continue;
	              }
	            }
	
	            if (method === "return") {
	              // Continue with the outer return, now that the delegate
	              // iterator has been terminated.
	              continue;
	            }
	          }
	
	          var record = tryCatch(
	            delegate.iterator[method],
	            delegate.iterator,
	            arg
	          );
	
	          if (record.type === "throw") {
	            context.delegate = null;
	
	            // Like returning generator.throw(uncaught), but without the
	            // overhead of an extra function call.
	            method = "throw";
	            arg = record.arg;
	            continue;
	          }
	
	          // Delegate generator ran and handled its own exceptions so
	          // regardless of what the method was, we continue as if it is
	          // "next" with an undefined arg.
	          method = "next";
	          arg = undefined;
	
	          var info = record.arg;
	          if (info.done) {
	            context[delegate.resultName] = info.value;
	            context.next = delegate.nextLoc;
	          } else {
	            state = GenStateSuspendedYield;
	            return info;
	          }
	
	          context.delegate = null;
	        }
	
	        if (method === "next") {
	          // Setting context._sent for legacy support of Babel's
	          // function.sent implementation.
	          context.sent = context._sent = arg;
	
	        } else if (method === "throw") {
	          if (state === GenStateSuspendedStart) {
	            state = GenStateCompleted;
	            throw arg;
	          }
	
	          if (context.dispatchException(arg)) {
	            // If the dispatched exception was caught by a catch block,
	            // then let that catch block handle the exception normally.
	            method = "next";
	            arg = undefined;
	          }
	
	        } else if (method === "return") {
	          context.abrupt("return", arg);
	        }
	
	        state = GenStateExecuting;
	
	        var record = tryCatch(innerFn, self, context);
	        if (record.type === "normal") {
	          // If an exception is thrown from innerFn, we leave state ===
	          // GenStateExecuting and loop back for another invocation.
	          state = context.done
	            ? GenStateCompleted
	            : GenStateSuspendedYield;
	
	          var info = {
	            value: record.arg,
	            done: context.done
	          };
	
	          if (record.arg === ContinueSentinel) {
	            if (context.delegate && method === "next") {
	              // Deliberately forget the last sent value so that we don't
	              // accidentally pass it on to the delegate.
	              arg = undefined;
	            }
	          } else {
	            return info;
	          }
	
	        } else if (record.type === "throw") {
	          state = GenStateCompleted;
	          // Dispatch the exception by looping back around to the
	          // context.dispatchException(arg) call above.
	          method = "throw";
	          arg = record.arg;
	        }
	      }
	    };
	  }
	
	  // Define Generator.prototype.{next,throw,return} in terms of the
	  // unified ._invoke helper method.
	  defineIteratorMethods(Gp);
	
	  Gp[iteratorSymbol] = function() {
	    return this;
	  };
	
	  Gp[toStringTagSymbol] = "Generator";
	
	  Gp.toString = function() {
	    return "[object Generator]";
	  };
	
	  function pushTryEntry(locs) {
	    var entry = { tryLoc: locs[0] };
	
	    if (1 in locs) {
	      entry.catchLoc = locs[1];
	    }
	
	    if (2 in locs) {
	      entry.finallyLoc = locs[2];
	      entry.afterLoc = locs[3];
	    }
	
	    this.tryEntries.push(entry);
	  }
	
	  function resetTryEntry(entry) {
	    var record = entry.completion || {};
	    record.type = "normal";
	    delete record.arg;
	    entry.completion = record;
	  }
	
	  function Context(tryLocsList) {
	    // The root entry object (effectively a try statement without a catch
	    // or a finally block) gives us a place to store values thrown from
	    // locations where there is no enclosing try statement.
	    this.tryEntries = [{ tryLoc: "root" }];
	    tryLocsList.forEach(pushTryEntry, this);
	    this.reset(true);
	  }
	
	  runtime.keys = function(object) {
	    var keys = [];
	    for (var key in object) {
	      keys.push(key);
	    }
	    keys.reverse();
	
	    // Rather than returning an object with a next method, we keep
	    // things simple and return the next function itself.
	    return function next() {
	      while (keys.length) {
	        var key = keys.pop();
	        if (key in object) {
	          next.value = key;
	          next.done = false;
	          return next;
	        }
	      }
	
	      // To avoid creating an additional object, we just hang the .value
	      // and .done properties off the next function object itself. This
	      // also ensures that the minifier will not anonymize the function.
	      next.done = true;
	      return next;
	    };
	  };
	
	  function values(iterable) {
	    if (iterable) {
	      var iteratorMethod = iterable[iteratorSymbol];
	      if (iteratorMethod) {
	        return iteratorMethod.call(iterable);
	      }
	
	      if (typeof iterable.next === "function") {
	        return iterable;
	      }
	
	      if (!isNaN(iterable.length)) {
	        var i = -1, next = function next() {
	          while (++i < iterable.length) {
	            if (hasOwn.call(iterable, i)) {
	              next.value = iterable[i];
	              next.done = false;
	              return next;
	            }
	          }
	
	          next.value = undefined;
	          next.done = true;
	
	          return next;
	        };
	
	        return next.next = next;
	      }
	    }
	
	    // Return an iterator with no values.
	    return { next: doneResult };
	  }
	  runtime.values = values;
	
	  function doneResult() {
	    return { value: undefined, done: true };
	  }
	
	  Context.prototype = {
	    constructor: Context,
	
	    reset: function(skipTempReset) {
	      this.prev = 0;
	      this.next = 0;
	      // Resetting context._sent for legacy support of Babel's
	      // function.sent implementation.
	      this.sent = this._sent = undefined;
	      this.done = false;
	      this.delegate = null;
	
	      this.tryEntries.forEach(resetTryEntry);
	
	      if (!skipTempReset) {
	        for (var name in this) {
	          // Not sure about the optimal order of these conditions:
	          if (name.charAt(0) === "t" &&
	              hasOwn.call(this, name) &&
	              !isNaN(+name.slice(1))) {
	            this[name] = undefined;
	          }
	        }
	      }
	    },
	
	    stop: function() {
	      this.done = true;
	
	      var rootEntry = this.tryEntries[0];
	      var rootRecord = rootEntry.completion;
	      if (rootRecord.type === "throw") {
	        throw rootRecord.arg;
	      }
	
	      return this.rval;
	    },
	
	    dispatchException: function(exception) {
	      if (this.done) {
	        throw exception;
	      }
	
	      var context = this;
	      function handle(loc, caught) {
	        record.type = "throw";
	        record.arg = exception;
	        context.next = loc;
	        return !!caught;
	      }
	
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        var record = entry.completion;
	
	        if (entry.tryLoc === "root") {
	          // Exception thrown outside of any try block that could handle
	          // it, so set the completion value of the entire function to
	          // throw the exception.
	          return handle("end");
	        }
	
	        if (entry.tryLoc <= this.prev) {
	          var hasCatch = hasOwn.call(entry, "catchLoc");
	          var hasFinally = hasOwn.call(entry, "finallyLoc");
	
	          if (hasCatch && hasFinally) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            } else if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else if (hasCatch) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            }
	
	          } else if (hasFinally) {
	            if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else {
	            throw new Error("try statement without catch or finally");
	          }
	        }
	      }
	    },
	
	    abrupt: function(type, arg) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc <= this.prev &&
	            hasOwn.call(entry, "finallyLoc") &&
	            this.prev < entry.finallyLoc) {
	          var finallyEntry = entry;
	          break;
	        }
	      }
	
	      if (finallyEntry &&
	          (type === "break" ||
	           type === "continue") &&
	          finallyEntry.tryLoc <= arg &&
	          arg <= finallyEntry.finallyLoc) {
	        // Ignore the finally entry if control is not jumping to a
	        // location outside the try/catch block.
	        finallyEntry = null;
	      }
	
	      var record = finallyEntry ? finallyEntry.completion : {};
	      record.type = type;
	      record.arg = arg;
	
	      if (finallyEntry) {
	        this.next = finallyEntry.finallyLoc;
	      } else {
	        this.complete(record);
	      }
	
	      return ContinueSentinel;
	    },
	
	    complete: function(record, afterLoc) {
	      if (record.type === "throw") {
	        throw record.arg;
	      }
	
	      if (record.type === "break" ||
	          record.type === "continue") {
	        this.next = record.arg;
	      } else if (record.type === "return") {
	        this.rval = record.arg;
	        this.next = "end";
	      } else if (record.type === "normal" && afterLoc) {
	        this.next = afterLoc;
	      }
	    },
	
	    finish: function(finallyLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.finallyLoc === finallyLoc) {
	          this.complete(entry.completion, entry.afterLoc);
	          resetTryEntry(entry);
	          return ContinueSentinel;
	        }
	      }
	    },
	
	    "catch": function(tryLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc === tryLoc) {
	          var record = entry.completion;
	          if (record.type === "throw") {
	            var thrown = record.arg;
	            resetTryEntry(entry);
	          }
	          return thrown;
	        }
	      }
	
	      // The context.catch method must only be called with a location
	      // argument that corresponds to a known catch block.
	      throw new Error("illegal catch attempt");
	    },
	
	    delegateYield: function(iterable, resultName, nextLoc) {
	      this.delegate = {
	        iterator: values(iterable),
	        resultName: resultName,
	        nextLoc: nextLoc
	      };
	
	      return ContinueSentinel;
	    }
	  };
	})(
	  // Among the various tricks for obtaining a reference to the global
	  // object, this seems to be the most reliable technique that does not
	  // use indirect eval (which violates Content Security Policy).
	  typeof global === "object" ? global :
	  typeof window === "object" ? window :
	  typeof self === "object" ? self : this
	);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(294)))

/***/ }),
/* 294 */
/***/ (function(module, exports) {

	// shim for using process in browser
	
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	(function () {
	  try {
	    cachedSetTimeout = setTimeout;
	  } catch (e) {
	    cachedSetTimeout = function () {
	      throw new Error('setTimeout is not defined');
	    }
	  }
	  try {
	    cachedClearTimeout = clearTimeout;
	  } catch (e) {
	    cachedClearTimeout = function () {
	      throw new Error('clearTimeout is not defined');
	    }
	  }
	} ())
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = cachedSetTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    cachedClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        cachedSetTimeout(drainQueue, 0);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(296);
	module.exports = __webpack_require__(9).RegExp.escape;

/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/benjamingr/RexExp.escape
	var $export = __webpack_require__(8)
	  , $re     = __webpack_require__(297)(/[\\^$*+?.()|[\]{}]/g, '\\$&');
	
	$export($export.S, 'RegExp', {escape: function escape(it){ return $re(it); }});


/***/ }),
/* 297 */
/***/ (function(module, exports) {

	module.exports = function(regExp, replace){
	  var replacer = replace === Object(replace) ? function(part){
	    return replace[part];
	  } : replace;
	  return function(it){
	    return String(it).replace(regExp, replacer);
	  };
	};

/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	__webpack_require__(1);
	
	__webpack_require__(299);
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(332);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reactTapEventPlugin = __webpack_require__(477);
	
	var _reactTapEventPlugin2 = _interopRequireDefault(_reactTapEventPlugin);
	
	var _appRoot = __webpack_require__(484);
	
	var _appRoot2 = _interopRequireDefault(_appRoot);
	
	__webpack_require__(2952);
	
	__webpack_require__(1174);
	
	var _moment = __webpack_require__(1021);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	__webpack_require__(2965).default = __webpack_require__(2976); // Polyfill
	
	__webpack_require__(2977).shim();
	
	// Styling for required modules
	
	
	// Logging
	
	
	// Moment setup
	
	_moment2.default.locale("en");
	
	// Moment two-digit year parsing setup
	var centuryCutoff = new Date().getFullYear() % 1000 + 5;
	_moment2.default.parseTwoDigitYear = function (yearString) {
	  return parseInt(yearString) + (parseInt(yearString) > centuryCutoff ? 1900 : 2000);
	};
	
	// Disable scrolling on number fields
	document.addEventListener("wheel", function (e) {
	  if (e.target.tagName.toLowerCase() === "input" && e.target.type === "number" && e.target === document.activeElement && !e.target.readOnly) {
	    e.target.readOnly = true;
	    setTimeout(function () {
	      e.target.readOnly = false;
	    }, 0);
	  }
	});
	
	// Stripe setup
	if (!window.Stripe) {
	  window.Stripe = { setPublishableKey: function setPublishableKey() {} };
	}
	Stripe.setPublishableKey(("pk_live_eJT66VZXGTM9EDfGfSD9XsmB"));
	
	// Heap setup
	heap.load(("2225581345"));
	
	//Needed for React Developer Tools
	window.React = _react2.default;
	
	//Needed for onTouchTap
	//https://github.com/zilverline/react-tap-event-plugin
	(0, _reactTapEventPlugin2.default)();
	
	_reactDom2.default.render(_react2.default.createElement(_appRoot2.default, null), document.getElementById("app"));
	
	// Hide loader
	document.getElementById("loader").style.display = "none";

/***/ }),
/* 299 */
/***/ (function(module, exports) {

	(function(self) {
	  'use strict';
	
	  if (self.fetch) {
	    return
	  }
	
	  var support = {
	    searchParams: 'URLSearchParams' in self,
	    iterable: 'Symbol' in self && 'iterator' in Symbol,
	    blob: 'FileReader' in self && 'Blob' in self && (function() {
	      try {
	        new Blob()
	        return true
	      } catch(e) {
	        return false
	      }
	    })(),
	    formData: 'FormData' in self,
	    arrayBuffer: 'ArrayBuffer' in self
	  }
	
	  if (support.arrayBuffer) {
	    var viewClasses = [
	      '[object Int8Array]',
	      '[object Uint8Array]',
	      '[object Uint8ClampedArray]',
	      '[object Int16Array]',
	      '[object Uint16Array]',
	      '[object Int32Array]',
	      '[object Uint32Array]',
	      '[object Float32Array]',
	      '[object Float64Array]'
	    ]
	
	    var isDataView = function(obj) {
	      return obj && DataView.prototype.isPrototypeOf(obj)
	    }
	
	    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
	      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
	    }
	  }
	
	  function normalizeName(name) {
	    if (typeof name !== 'string') {
	      name = String(name)
	    }
	    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
	      throw new TypeError('Invalid character in header field name')
	    }
	    return name.toLowerCase()
	  }
	
	  function normalizeValue(value) {
	    if (typeof value !== 'string') {
	      value = String(value)
	    }
	    return value
	  }
	
	  // Build a destructive iterator for the value list
	  function iteratorFor(items) {
	    var iterator = {
	      next: function() {
	        var value = items.shift()
	        return {done: value === undefined, value: value}
	      }
	    }
	
	    if (support.iterable) {
	      iterator[Symbol.iterator] = function() {
	        return iterator
	      }
	    }
	
	    return iterator
	  }
	
	  function Headers(headers) {
	    this.map = {}
	
	    if (headers instanceof Headers) {
	      headers.forEach(function(value, name) {
	        this.append(name, value)
	      }, this)
	    } else if (Array.isArray(headers)) {
	      headers.forEach(function(header) {
	        this.append(header[0], header[1])
	      }, this)
	    } else if (headers) {
	      Object.getOwnPropertyNames(headers).forEach(function(name) {
	        this.append(name, headers[name])
	      }, this)
	    }
	  }
	
	  Headers.prototype.append = function(name, value) {
	    name = normalizeName(name)
	    value = normalizeValue(value)
	    var oldValue = this.map[name]
	    this.map[name] = oldValue ? oldValue+','+value : value
	  }
	
	  Headers.prototype['delete'] = function(name) {
	    delete this.map[normalizeName(name)]
	  }
	
	  Headers.prototype.get = function(name) {
	    name = normalizeName(name)
	    return this.has(name) ? this.map[name] : null
	  }
	
	  Headers.prototype.has = function(name) {
	    return this.map.hasOwnProperty(normalizeName(name))
	  }
	
	  Headers.prototype.set = function(name, value) {
	    this.map[normalizeName(name)] = normalizeValue(value)
	  }
	
	  Headers.prototype.forEach = function(callback, thisArg) {
	    for (var name in this.map) {
	      if (this.map.hasOwnProperty(name)) {
	        callback.call(thisArg, this.map[name], name, this)
	      }
	    }
	  }
	
	  Headers.prototype.keys = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push(name) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.values = function() {
	    var items = []
	    this.forEach(function(value) { items.push(value) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.entries = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push([name, value]) })
	    return iteratorFor(items)
	  }
	
	  if (support.iterable) {
	    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
	  }
	
	  function consumed(body) {
	    if (body.bodyUsed) {
	      return Promise.reject(new TypeError('Already read'))
	    }
	    body.bodyUsed = true
	  }
	
	  function fileReaderReady(reader) {
	    return new Promise(function(resolve, reject) {
	      reader.onload = function() {
	        resolve(reader.result)
	      }
	      reader.onerror = function() {
	        reject(reader.error)
	      }
	    })
	  }
	
	  function readBlobAsArrayBuffer(blob) {
	    var reader = new FileReader()
	    var promise = fileReaderReady(reader)
	    reader.readAsArrayBuffer(blob)
	    return promise
	  }
	
	  function readBlobAsText(blob) {
	    var reader = new FileReader()
	    var promise = fileReaderReady(reader)
	    reader.readAsText(blob)
	    return promise
	  }
	
	  function readArrayBufferAsText(buf) {
	    var view = new Uint8Array(buf)
	    var chars = new Array(view.length)
	
	    for (var i = 0; i < view.length; i++) {
	      chars[i] = String.fromCharCode(view[i])
	    }
	    return chars.join('')
	  }
	
	  function bufferClone(buf) {
	    if (buf.slice) {
	      return buf.slice(0)
	    } else {
	      var view = new Uint8Array(buf.byteLength)
	      view.set(new Uint8Array(buf))
	      return view.buffer
	    }
	  }
	
	  function Body() {
	    this.bodyUsed = false
	
	    this._initBody = function(body) {
	      this._bodyInit = body
	      if (!body) {
	        this._bodyText = ''
	      } else if (typeof body === 'string') {
	        this._bodyText = body
	      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
	        this._bodyBlob = body
	      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
	        this._bodyFormData = body
	      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	        this._bodyText = body.toString()
	      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
	        this._bodyArrayBuffer = bufferClone(body.buffer)
	        // IE 10-11 can't handle a DataView body.
	        this._bodyInit = new Blob([this._bodyArrayBuffer])
	      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
	        this._bodyArrayBuffer = bufferClone(body)
	      } else {
	        throw new Error('unsupported BodyInit type')
	      }
	
	      if (!this.headers.get('content-type')) {
	        if (typeof body === 'string') {
	          this.headers.set('content-type', 'text/plain;charset=UTF-8')
	        } else if (this._bodyBlob && this._bodyBlob.type) {
	          this.headers.set('content-type', this._bodyBlob.type)
	        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
	        }
	      }
	    }
	
	    if (support.blob) {
	      this.blob = function() {
	        var rejected = consumed(this)
	        if (rejected) {
	          return rejected
	        }
	
	        if (this._bodyBlob) {
	          return Promise.resolve(this._bodyBlob)
	        } else if (this._bodyArrayBuffer) {
	          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
	        } else if (this._bodyFormData) {
	          throw new Error('could not read FormData body as blob')
	        } else {
	          return Promise.resolve(new Blob([this._bodyText]))
	        }
	      }
	
	      this.arrayBuffer = function() {
	        if (this._bodyArrayBuffer) {
	          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
	        } else {
	          return this.blob().then(readBlobAsArrayBuffer)
	        }
	      }
	    }
	
	    this.text = function() {
	      var rejected = consumed(this)
	      if (rejected) {
	        return rejected
	      }
	
	      if (this._bodyBlob) {
	        return readBlobAsText(this._bodyBlob)
	      } else if (this._bodyArrayBuffer) {
	        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
	      } else if (this._bodyFormData) {
	        throw new Error('could not read FormData body as text')
	      } else {
	        return Promise.resolve(this._bodyText)
	      }
	    }
	
	    if (support.formData) {
	      this.formData = function() {
	        return this.text().then(decode)
	      }
	    }
	
	    this.json = function() {
	      return this.text().then(JSON.parse)
	    }
	
	    return this
	  }
	
	  // HTTP methods whose capitalization should be normalized
	  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']
	
	  function normalizeMethod(method) {
	    var upcased = method.toUpperCase()
	    return (methods.indexOf(upcased) > -1) ? upcased : method
	  }
	
	  function Request(input, options) {
	    options = options || {}
	    var body = options.body
	
	    if (input instanceof Request) {
	      if (input.bodyUsed) {
	        throw new TypeError('Already read')
	      }
	      this.url = input.url
	      this.credentials = input.credentials
	      if (!options.headers) {
	        this.headers = new Headers(input.headers)
	      }
	      this.method = input.method
	      this.mode = input.mode
	      if (!body && input._bodyInit != null) {
	        body = input._bodyInit
	        input.bodyUsed = true
	      }
	    } else {
	      this.url = String(input)
	    }
	
	    this.credentials = options.credentials || this.credentials || 'omit'
	    if (options.headers || !this.headers) {
	      this.headers = new Headers(options.headers)
	    }
	    this.method = normalizeMethod(options.method || this.method || 'GET')
	    this.mode = options.mode || this.mode || null
	    this.referrer = null
	
	    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
	      throw new TypeError('Body not allowed for GET or HEAD requests')
	    }
	    this._initBody(body)
	  }
	
	  Request.prototype.clone = function() {
	    return new Request(this, { body: this._bodyInit })
	  }
	
	  function decode(body) {
	    var form = new FormData()
	    body.trim().split('&').forEach(function(bytes) {
	      if (bytes) {
	        var split = bytes.split('=')
	        var name = split.shift().replace(/\+/g, ' ')
	        var value = split.join('=').replace(/\+/g, ' ')
	        form.append(decodeURIComponent(name), decodeURIComponent(value))
	      }
	    })
	    return form
	  }
	
	  function parseHeaders(rawHeaders) {
	    var headers = new Headers()
	    // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
	    // https://tools.ietf.org/html/rfc7230#section-3.2
	    var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, ' ')
	    preProcessedHeaders.split(/\r?\n/).forEach(function(line) {
	      var parts = line.split(':')
	      var key = parts.shift().trim()
	      if (key) {
	        var value = parts.join(':').trim()
	        headers.append(key, value)
	      }
	    })
	    return headers
	  }
	
	  Body.call(Request.prototype)
	
	  function Response(bodyInit, options) {
	    if (!options) {
	      options = {}
	    }
	
	    this.type = 'default'
	    this.status = options.status === undefined ? 200 : options.status
	    this.ok = this.status >= 200 && this.status < 300
	    this.statusText = 'statusText' in options ? options.statusText : 'OK'
	    this.headers = new Headers(options.headers)
	    this.url = options.url || ''
	    this._initBody(bodyInit)
	  }
	
	  Body.call(Response.prototype)
	
	  Response.prototype.clone = function() {
	    return new Response(this._bodyInit, {
	      status: this.status,
	      statusText: this.statusText,
	      headers: new Headers(this.headers),
	      url: this.url
	    })
	  }
	
	  Response.error = function() {
	    var response = new Response(null, {status: 0, statusText: ''})
	    response.type = 'error'
	    return response
	  }
	
	  var redirectStatuses = [301, 302, 303, 307, 308]
	
	  Response.redirect = function(url, status) {
	    if (redirectStatuses.indexOf(status) === -1) {
	      throw new RangeError('Invalid status code')
	    }
	
	    return new Response(null, {status: status, headers: {location: url}})
	  }
	
	  self.Headers = Headers
	  self.Request = Request
	  self.Response = Response
	
	  self.fetch = function(input, init) {
	    return new Promise(function(resolve, reject) {
	      var request = new Request(input, init)
	      var xhr = new XMLHttpRequest()
	
	      xhr.onload = function() {
	        var options = {
	          status: xhr.status,
	          statusText: xhr.statusText,
	          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
	        }
	        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
	        var body = 'response' in xhr ? xhr.response : xhr.responseText
	        resolve(new Response(body, options))
	      }
	
	      xhr.onerror = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.ontimeout = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.open(request.method, request.url, true)
	
	      if (request.credentials === 'include') {
	        xhr.withCredentials = true
	      } else if (request.credentials === 'omit') {
	        xhr.withCredentials = false
	      }
	
	      if ('responseType' in xhr && support.blob) {
	        xhr.responseType = 'blob'
	      }
	
	      request.headers.forEach(function(value, name) {
	        xhr.setRequestHeader(name, value)
	      })
	
	      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
	    })
	  }
	  self.fetch.polyfill = true
	})(typeof self !== 'undefined' ? self : this);


/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(301);


/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(302);
	
	var ReactChildren = __webpack_require__(303);
	var ReactComponent = __webpack_require__(316);
	var ReactPureComponent = __webpack_require__(319);
	var ReactClass = __webpack_require__(320);
	var ReactDOMFactories = __webpack_require__(322);
	var ReactElement = __webpack_require__(307);
	var ReactPropTypes = __webpack_require__(323);
	var ReactVersion = __webpack_require__(330);
	
	var onlyChild = __webpack_require__(331);
	var warning = __webpack_require__(309);
	
	var createElement = ReactElement.createElement;
	var createFactory = ReactElement.createFactory;
	var cloneElement = ReactElement.cloneElement;
	
	if (false) {
	  var canDefineProperty = require('./canDefineProperty');
	  var ReactElementValidator = require('./ReactElementValidator');
	  var didWarnPropTypesDeprecated = false;
	  createElement = ReactElementValidator.createElement;
	  createFactory = ReactElementValidator.createFactory;
	  cloneElement = ReactElementValidator.cloneElement;
	}
	
	var __spread = _assign;
	
	if (false) {
	  var warned = false;
	  __spread = function () {
	    process.env.NODE_ENV !== 'production' ? warning(warned, 'React.__spread is deprecated and should not be used. Use ' + 'Object.assign directly or another helper function with similar ' + 'semantics. You may be seeing this warning due to your compiler. ' + 'See https://fb.me/react-spread-deprecation for more details.') : void 0;
	    warned = true;
	    return _assign.apply(null, arguments);
	  };
	}
	
	var React = {
	
	  // Modern
	
	  Children: {
	    map: ReactChildren.map,
	    forEach: ReactChildren.forEach,
	    count: ReactChildren.count,
	    toArray: ReactChildren.toArray,
	    only: onlyChild
	  },
	
	  Component: ReactComponent,
	  PureComponent: ReactPureComponent,
	
	  createElement: createElement,
	  cloneElement: cloneElement,
	  isValidElement: ReactElement.isValidElement,
	
	  // Classic
	
	  PropTypes: ReactPropTypes,
	  createClass: ReactClass.createClass,
	  createFactory: createFactory,
	  createMixin: function (mixin) {
	    // Currently a noop. Will be used to validate and trace mixins.
	    return mixin;
	  },
	
	  // This looks DOM specific but these are actually isomorphic helpers
	  // since they are just generating DOM strings.
	  DOM: ReactDOMFactories,
	
	  version: ReactVersion,
	
	  // Deprecated hook for JSX spread, don't use this for anything.
	  __spread: __spread
	};
	
	// TODO: Fix tests so that this deprecation warning doesn't cause failures.
	if (false) {
	  if (canDefineProperty) {
	    Object.defineProperty(React, 'PropTypes', {
	      get: function () {
	        process.env.NODE_ENV !== 'production' ? warning(didWarnPropTypesDeprecated, 'Accessing PropTypes via the main React package is deprecated. Use ' + 'the prop-types package from npm instead.') : void 0;
	        didWarnPropTypesDeprecated = true;
	        return ReactPropTypes;
	      }
	    });
	  }
	}
	
	module.exports = React;

/***/ }),
/* 302 */
/***/ (function(module, exports) {

	/*
	object-assign
	(c) Sindre Sorhus
	@license MIT
	*/
	
	'use strict';
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var PooledClass = __webpack_require__(304);
	var ReactElement = __webpack_require__(307);
	
	var emptyFunction = __webpack_require__(310);
	var traverseAllChildren = __webpack_require__(313);
	
	var twoArgumentPooler = PooledClass.twoArgumentPooler;
	var fourArgumentPooler = PooledClass.fourArgumentPooler;
	
	var userProvidedKeyEscapeRegex = /\/+/g;
	function escapeUserProvidedKey(text) {
	  return ('' + text).replace(userProvidedKeyEscapeRegex, '$&/');
	}
	
	/**
	 * PooledClass representing the bookkeeping associated with performing a child
	 * traversal. Allows avoiding binding callbacks.
	 *
	 * @constructor ForEachBookKeeping
	 * @param {!function} forEachFunction Function to perform traversal with.
	 * @param {?*} forEachContext Context to perform context with.
	 */
	function ForEachBookKeeping(forEachFunction, forEachContext) {
	  this.func = forEachFunction;
	  this.context = forEachContext;
	  this.count = 0;
	}
	ForEachBookKeeping.prototype.destructor = function () {
	  this.func = null;
	  this.context = null;
	  this.count = 0;
	};
	PooledClass.addPoolingTo(ForEachBookKeeping, twoArgumentPooler);
	
	function forEachSingleChild(bookKeeping, child, name) {
	  var func = bookKeeping.func,
	      context = bookKeeping.context;
	
	  func.call(context, child, bookKeeping.count++);
	}
	
	/**
	 * Iterates through children that are typically specified as `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.foreach
	 *
	 * The provided forEachFunc(child, index) will be called for each
	 * leaf child.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} forEachFunc
	 * @param {*} forEachContext Context for forEachContext.
	 */
	function forEachChildren(children, forEachFunc, forEachContext) {
	  if (children == null) {
	    return children;
	  }
	  var traverseContext = ForEachBookKeeping.getPooled(forEachFunc, forEachContext);
	  traverseAllChildren(children, forEachSingleChild, traverseContext);
	  ForEachBookKeeping.release(traverseContext);
	}
	
	/**
	 * PooledClass representing the bookkeeping associated with performing a child
	 * mapping. Allows avoiding binding callbacks.
	 *
	 * @constructor MapBookKeeping
	 * @param {!*} mapResult Object containing the ordered map of results.
	 * @param {!function} mapFunction Function to perform mapping with.
	 * @param {?*} mapContext Context to perform mapping with.
	 */
	function MapBookKeeping(mapResult, keyPrefix, mapFunction, mapContext) {
	  this.result = mapResult;
	  this.keyPrefix = keyPrefix;
	  this.func = mapFunction;
	  this.context = mapContext;
	  this.count = 0;
	}
	MapBookKeeping.prototype.destructor = function () {
	  this.result = null;
	  this.keyPrefix = null;
	  this.func = null;
	  this.context = null;
	  this.count = 0;
	};
	PooledClass.addPoolingTo(MapBookKeeping, fourArgumentPooler);
	
	function mapSingleChildIntoContext(bookKeeping, child, childKey) {
	  var result = bookKeeping.result,
	      keyPrefix = bookKeeping.keyPrefix,
	      func = bookKeeping.func,
	      context = bookKeeping.context;
	
	
	  var mappedChild = func.call(context, child, bookKeeping.count++);
	  if (Array.isArray(mappedChild)) {
	    mapIntoWithKeyPrefixInternal(mappedChild, result, childKey, emptyFunction.thatReturnsArgument);
	  } else if (mappedChild != null) {
	    if (ReactElement.isValidElement(mappedChild)) {
	      mappedChild = ReactElement.cloneAndReplaceKey(mappedChild,
	      // Keep both the (mapped) and old keys if they differ, just as
	      // traverseAllChildren used to do for objects as children
	      keyPrefix + (mappedChild.key && (!child || child.key !== mappedChild.key) ? escapeUserProvidedKey(mappedChild.key) + '/' : '') + childKey);
	    }
	    result.push(mappedChild);
	  }
	}
	
	function mapIntoWithKeyPrefixInternal(children, array, prefix, func, context) {
	  var escapedPrefix = '';
	  if (prefix != null) {
	    escapedPrefix = escapeUserProvidedKey(prefix) + '/';
	  }
	  var traverseContext = MapBookKeeping.getPooled(array, escapedPrefix, func, context);
	  traverseAllChildren(children, mapSingleChildIntoContext, traverseContext);
	  MapBookKeeping.release(traverseContext);
	}
	
	/**
	 * Maps children that are typically specified as `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.map
	 *
	 * The provided mapFunction(child, key, index) will be called for each
	 * leaf child.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} func The map function.
	 * @param {*} context Context for mapFunction.
	 * @return {object} Object containing the ordered map of results.
	 */
	function mapChildren(children, func, context) {
	  if (children == null) {
	    return children;
	  }
	  var result = [];
	  mapIntoWithKeyPrefixInternal(children, result, null, func, context);
	  return result;
	}
	
	function forEachSingleChildDummy(traverseContext, child, name) {
	  return null;
	}
	
	/**
	 * Count the number of children that are typically specified as
	 * `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.count
	 *
	 * @param {?*} children Children tree container.
	 * @return {number} The number of children.
	 */
	function countChildren(children, context) {
	  return traverseAllChildren(children, forEachSingleChildDummy, null);
	}
	
	/**
	 * Flatten a children object (typically specified as `props.children`) and
	 * return an array with appropriately re-keyed children.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.toarray
	 */
	function toArray(children) {
	  var result = [];
	  mapIntoWithKeyPrefixInternal(children, result, null, emptyFunction.thatReturnsArgument);
	  return result;
	}
	
	var ReactChildren = {
	  forEach: forEachChildren,
	  map: mapChildren,
	  mapIntoWithKeyPrefixInternal: mapIntoWithKeyPrefixInternal,
	  count: countChildren,
	  toArray: toArray
	};
	
	module.exports = ReactChildren;

/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(305);
	
	var invariant = __webpack_require__(306);
	
	/**
	 * Static poolers. Several custom versions for each potential number of
	 * arguments. A completely generic pooler is easy to implement, but would
	 * require accessing the `arguments` object. In each of these, `this` refers to
	 * the Class itself, not an instance. If any others are needed, simply add them
	 * here, or in their own files.
	 */
	var oneArgumentPooler = function (copyFieldsFrom) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, copyFieldsFrom);
	    return instance;
	  } else {
	    return new Klass(copyFieldsFrom);
	  }
	};
	
	var twoArgumentPooler = function (a1, a2) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2);
	    return instance;
	  } else {
	    return new Klass(a1, a2);
	  }
	};
	
	var threeArgumentPooler = function (a1, a2, a3) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3);
	  }
	};
	
	var fourArgumentPooler = function (a1, a2, a3, a4) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3, a4);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3, a4);
	  }
	};
	
	var standardReleaser = function (instance) {
	  var Klass = this;
	  !(instance instanceof Klass) ?  false ? invariant(false, 'Trying to release an instance into a pool of a different type.') : _prodInvariant('25') : void 0;
	  instance.destructor();
	  if (Klass.instancePool.length < Klass.poolSize) {
	    Klass.instancePool.push(instance);
	  }
	};
	
	var DEFAULT_POOL_SIZE = 10;
	var DEFAULT_POOLER = oneArgumentPooler;
	
	/**
	 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
	 * itself (statically) not adding any prototypical fields. Any CopyConstructor
	 * you give this may have a `poolSize` property, and will look for a
	 * prototypical `destructor` on instances.
	 *
	 * @param {Function} CopyConstructor Constructor that can be used to reset.
	 * @param {Function} pooler Customizable pooler.
	 */
	var addPoolingTo = function (CopyConstructor, pooler) {
	  // Casting as any so that flow ignores the actual implementation and trusts
	  // it to match the type we declared
	  var NewKlass = CopyConstructor;
	  NewKlass.instancePool = [];
	  NewKlass.getPooled = pooler || DEFAULT_POOLER;
	  if (!NewKlass.poolSize) {
	    NewKlass.poolSize = DEFAULT_POOL_SIZE;
	  }
	  NewKlass.release = standardReleaser;
	  return NewKlass;
	};
	
	var PooledClass = {
	  addPoolingTo: addPoolingTo,
	  oneArgumentPooler: oneArgumentPooler,
	  twoArgumentPooler: twoArgumentPooler,
	  threeArgumentPooler: threeArgumentPooler,
	  fourArgumentPooler: fourArgumentPooler
	};
	
	module.exports = PooledClass;

/***/ }),
/* 305 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	'use strict';
	
	/**
	 * WARNING: DO NOT manually require this module.
	 * This is a replacement for `invariant(...)` used by the error code system
	 * and will _only_ be required by the corresponding babel pass.
	 * It always throws.
	 */
	
	function reactProdInvariant(code) {
	  var argCount = arguments.length - 1;
	
	  var message = 'Minified React error #' + code + '; visit ' + 'http://facebook.github.io/react/docs/error-decoder.html?invariant=' + code;
	
	  for (var argIdx = 0; argIdx < argCount; argIdx++) {
	    message += '&args[]=' + encodeURIComponent(arguments[argIdx + 1]);
	  }
	
	  message += ' for the full message or use the non-minified dev environment' + ' for full errors and additional helpful warnings.';
	
	  var error = new Error(message);
	  error.name = 'Invariant Violation';
	  error.framesToPop = 1; // we don't care about reactProdInvariant's own frame
	
	  throw error;
	}
	
	module.exports = reactProdInvariant;

/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var validateFormat = function validateFormat(format) {};
	
	if (false) {
	  validateFormat = function validateFormat(format) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  };
	}
	
	function invariant(condition, format, a, b, c, d, e, f) {
	  validateFormat(format);
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(format.replace(/%s/g, function () {
	        return args[argIndex++];
	      }));
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	}
	
	module.exports = invariant;

/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(302);
	
	var ReactCurrentOwner = __webpack_require__(308);
	
	var warning = __webpack_require__(309);
	var canDefineProperty = __webpack_require__(311);
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	var REACT_ELEMENT_TYPE = __webpack_require__(312);
	
	var RESERVED_PROPS = {
	  key: true,
	  ref: true,
	  __self: true,
	  __source: true
	};
	
	var specialPropKeyWarningShown, specialPropRefWarningShown;
	
	function hasValidRef(config) {
	  if (false) {
	    if (hasOwnProperty.call(config, 'ref')) {
	      var getter = Object.getOwnPropertyDescriptor(config, 'ref').get;
	      if (getter && getter.isReactWarning) {
	        return false;
	      }
	    }
	  }
	  return config.ref !== undefined;
	}
	
	function hasValidKey(config) {
	  if (false) {
	    if (hasOwnProperty.call(config, 'key')) {
	      var getter = Object.getOwnPropertyDescriptor(config, 'key').get;
	      if (getter && getter.isReactWarning) {
	        return false;
	      }
	    }
	  }
	  return config.key !== undefined;
	}
	
	function defineKeyPropWarningGetter(props, displayName) {
	  var warnAboutAccessingKey = function () {
	    if (!specialPropKeyWarningShown) {
	      specialPropKeyWarningShown = true;
	       false ? warning(false, '%s: `key` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
	    }
	  };
	  warnAboutAccessingKey.isReactWarning = true;
	  Object.defineProperty(props, 'key', {
	    get: warnAboutAccessingKey,
	    configurable: true
	  });
	}
	
	function defineRefPropWarningGetter(props, displayName) {
	  var warnAboutAccessingRef = function () {
	    if (!specialPropRefWarningShown) {
	      specialPropRefWarningShown = true;
	       false ? warning(false, '%s: `ref` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
	    }
	  };
	  warnAboutAccessingRef.isReactWarning = true;
	  Object.defineProperty(props, 'ref', {
	    get: warnAboutAccessingRef,
	    configurable: true
	  });
	}
	
	/**
	 * Factory method to create a new React element. This no longer adheres to
	 * the class pattern, so do not use new to call it. Also, no instanceof check
	 * will work. Instead test $$typeof field against Symbol.for('react.element') to check
	 * if something is a React Element.
	 *
	 * @param {*} type
	 * @param {*} key
	 * @param {string|object} ref
	 * @param {*} self A *temporary* helper to detect places where `this` is
	 * different from the `owner` when React.createElement is called, so that we
	 * can warn. We want to get rid of owner and replace string `ref`s with arrow
	 * functions, and as long as `this` and owner are the same, there will be no
	 * change in behavior.
	 * @param {*} source An annotation object (added by a transpiler or otherwise)
	 * indicating filename, line number, and/or other information.
	 * @param {*} owner
	 * @param {*} props
	 * @internal
	 */
	var ReactElement = function (type, key, ref, self, source, owner, props) {
	  var element = {
	    // This tag allow us to uniquely identify this as a React Element
	    $$typeof: REACT_ELEMENT_TYPE,
	
	    // Built-in properties that belong on the element
	    type: type,
	    key: key,
	    ref: ref,
	    props: props,
	
	    // Record the component responsible for creating this element.
	    _owner: owner
	  };
	
	  if (false) {
	    // The validation flag is currently mutative. We put it on
	    // an external backing store so that we can freeze the whole object.
	    // This can be replaced with a WeakMap once they are implemented in
	    // commonly used development environments.
	    element._store = {};
	
	    // To make comparing ReactElements easier for testing purposes, we make
	    // the validation flag non-enumerable (where possible, which should
	    // include every environment we run tests in), so the test framework
	    // ignores it.
	    if (canDefineProperty) {
	      Object.defineProperty(element._store, 'validated', {
	        configurable: false,
	        enumerable: false,
	        writable: true,
	        value: false
	      });
	      // self and source are DEV only properties.
	      Object.defineProperty(element, '_self', {
	        configurable: false,
	        enumerable: false,
	        writable: false,
	        value: self
	      });
	      // Two elements created in two different places should be considered
	      // equal for testing purposes and therefore we hide it from enumeration.
	      Object.defineProperty(element, '_source', {
	        configurable: false,
	        enumerable: false,
	        writable: false,
	        value: source
	      });
	    } else {
	      element._store.validated = false;
	      element._self = self;
	      element._source = source;
	    }
	    if (Object.freeze) {
	      Object.freeze(element.props);
	      Object.freeze(element);
	    }
	  }
	
	  return element;
	};
	
	/**
	 * Create and return a new ReactElement of the given type.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.createelement
	 */
	ReactElement.createElement = function (type, config, children) {
	  var propName;
	
	  // Reserved names are extracted
	  var props = {};
	
	  var key = null;
	  var ref = null;
	  var self = null;
	  var source = null;
	
	  if (config != null) {
	    if (hasValidRef(config)) {
	      ref = config.ref;
	    }
	    if (hasValidKey(config)) {
	      key = '' + config.key;
	    }
	
	    self = config.__self === undefined ? null : config.__self;
	    source = config.__source === undefined ? null : config.__source;
	    // Remaining properties are added to a new props object
	    for (propName in config) {
	      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
	        props[propName] = config[propName];
	      }
	    }
	  }
	
	  // Children can be more than one argument, and those are transferred onto
	  // the newly allocated props object.
	  var childrenLength = arguments.length - 2;
	  if (childrenLength === 1) {
	    props.children = children;
	  } else if (childrenLength > 1) {
	    var childArray = Array(childrenLength);
	    for (var i = 0; i < childrenLength; i++) {
	      childArray[i] = arguments[i + 2];
	    }
	    if (false) {
	      if (Object.freeze) {
	        Object.freeze(childArray);
	      }
	    }
	    props.children = childArray;
	  }
	
	  // Resolve default props
	  if (type && type.defaultProps) {
	    var defaultProps = type.defaultProps;
	    for (propName in defaultProps) {
	      if (props[propName] === undefined) {
	        props[propName] = defaultProps[propName];
	      }
	    }
	  }
	  if (false) {
	    if (key || ref) {
	      if (typeof props.$$typeof === 'undefined' || props.$$typeof !== REACT_ELEMENT_TYPE) {
	        var displayName = typeof type === 'function' ? type.displayName || type.name || 'Unknown' : type;
	        if (key) {
	          defineKeyPropWarningGetter(props, displayName);
	        }
	        if (ref) {
	          defineRefPropWarningGetter(props, displayName);
	        }
	      }
	    }
	  }
	  return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
	};
	
	/**
	 * Return a function that produces ReactElements of a given type.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.createfactory
	 */
	ReactElement.createFactory = function (type) {
	  var factory = ReactElement.createElement.bind(null, type);
	  // Expose the type on the factory and the prototype so that it can be
	  // easily accessed on elements. E.g. `<Foo />.type === Foo`.
	  // This should not be named `constructor` since this may not be the function
	  // that created the element, and it may not even be a constructor.
	  // Legacy hook TODO: Warn if this is accessed
	  factory.type = type;
	  return factory;
	};
	
	ReactElement.cloneAndReplaceKey = function (oldElement, newKey) {
	  var newElement = ReactElement(oldElement.type, newKey, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, oldElement.props);
	
	  return newElement;
	};
	
	/**
	 * Clone and return a new ReactElement using element as the starting point.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.cloneelement
	 */
	ReactElement.cloneElement = function (element, config, children) {
	  var propName;
	
	  // Original props are copied
	  var props = _assign({}, element.props);
	
	  // Reserved names are extracted
	  var key = element.key;
	  var ref = element.ref;
	  // Self is preserved since the owner is preserved.
	  var self = element._self;
	  // Source is preserved since cloneElement is unlikely to be targeted by a
	  // transpiler, and the original source is probably a better indicator of the
	  // true owner.
	  var source = element._source;
	
	  // Owner will be preserved, unless ref is overridden
	  var owner = element._owner;
	
	  if (config != null) {
	    if (hasValidRef(config)) {
	      // Silently steal the ref from the parent.
	      ref = config.ref;
	      owner = ReactCurrentOwner.current;
	    }
	    if (hasValidKey(config)) {
	      key = '' + config.key;
	    }
	
	    // Remaining properties override existing props
	    var defaultProps;
	    if (element.type && element.type.defaultProps) {
	      defaultProps = element.type.defaultProps;
	    }
	    for (propName in config) {
	      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
	        if (config[propName] === undefined && defaultProps !== undefined) {
	          // Resolve default props
	          props[propName] = defaultProps[propName];
	        } else {
	          props[propName] = config[propName];
	        }
	      }
	    }
	  }
	
	  // Children can be more than one argument, and those are transferred onto
	  // the newly allocated props object.
	  var childrenLength = arguments.length - 2;
	  if (childrenLength === 1) {
	    props.children = children;
	  } else if (childrenLength > 1) {
	    var childArray = Array(childrenLength);
	    for (var i = 0; i < childrenLength; i++) {
	      childArray[i] = arguments[i + 2];
	    }
	    props.children = childArray;
	  }
	
	  return ReactElement(element.type, key, ref, self, source, owner, props);
	};
	
	/**
	 * Verifies the object is a ReactElement.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.isvalidelement
	 * @param {?object} object
	 * @return {boolean} True if `object` is a valid component.
	 * @final
	 */
	ReactElement.isValidElement = function (object) {
	  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
	};
	
	module.exports = ReactElement;

/***/ }),
/* 308 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * Keeps track of the current owner.
	 *
	 * The current owner is the component who should own any components that are
	 * currently being constructed.
	 */
	var ReactCurrentOwner = {
	
	  /**
	   * @internal
	   * @type {ReactComponent}
	   */
	  current: null
	
	};
	
	module.exports = ReactCurrentOwner;

/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(310);
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = emptyFunction;
	
	if (false) {
	  var printWarning = function printWarning(format) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    var argIndex = 0;
	    var message = 'Warning: ' + format.replace(/%s/g, function () {
	      return args[argIndex++];
	    });
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	
	  warning = function warning(condition, format) {
	    if (format === undefined) {
	      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
	    }
	
	    if (format.indexOf('Failed Composite propType: ') === 0) {
	      return; // Ignore CompositeComponent proptype check.
	    }
	
	    if (!condition) {
	      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	        args[_key2 - 2] = arguments[_key2];
	      }
	
	      printWarning.apply(undefined, [format].concat(args));
	    }
	  };
	}
	
	module.exports = warning;

/***/ }),
/* 310 */
/***/ (function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	function makeEmptyFunction(arg) {
	  return function () {
	    return arg;
	  };
	}
	
	/**
	 * This function accepts and discards inputs; it has no side effects. This is
	 * primarily useful idiomatically for overridable function endpoints which
	 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
	 */
	var emptyFunction = function emptyFunction() {};
	
	emptyFunction.thatReturns = makeEmptyFunction;
	emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
	emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
	emptyFunction.thatReturnsNull = makeEmptyFunction(null);
	emptyFunction.thatReturnsThis = function () {
	  return this;
	};
	emptyFunction.thatReturnsArgument = function (arg) {
	  return arg;
	};
	
	module.exports = emptyFunction;

/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var canDefineProperty = false;
	if (false) {
	  try {
	    // $FlowFixMe https://github.com/facebook/flow/issues/285
	    Object.defineProperty({}, 'x', { get: function () {} });
	    canDefineProperty = true;
	  } catch (x) {
	    // IE will fail on defineProperty
	  }
	}
	
	module.exports = canDefineProperty;

/***/ }),
/* 312 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	// The Symbol used to tag the ReactElement type. If there is no native Symbol
	// nor polyfill, then a plain number is used for performance.
	
	var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;
	
	module.exports = REACT_ELEMENT_TYPE;

/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(305);
	
	var ReactCurrentOwner = __webpack_require__(308);
	var REACT_ELEMENT_TYPE = __webpack_require__(312);
	
	var getIteratorFn = __webpack_require__(314);
	var invariant = __webpack_require__(306);
	var KeyEscapeUtils = __webpack_require__(315);
	var warning = __webpack_require__(309);
	
	var SEPARATOR = '.';
	var SUBSEPARATOR = ':';
	
	/**
	 * This is inlined from ReactElement since this file is shared between
	 * isomorphic and renderers. We could extract this to a
	 *
	 */
	
	/**
	 * TODO: Test that a single child and an array with one item have the same key
	 * pattern.
	 */
	
	var didWarnAboutMaps = false;
	
	/**
	 * Generate a key string that identifies a component within a set.
	 *
	 * @param {*} component A component that could contain a manual key.
	 * @param {number} index Index that is used if a manual key is not provided.
	 * @return {string}
	 */
	function getComponentKey(component, index) {
	  // Do some typechecking here since we call this blindly. We want to ensure
	  // that we don't block potential future ES APIs.
	  if (component && typeof component === 'object' && component.key != null) {
	    // Explicit key
	    return KeyEscapeUtils.escape(component.key);
	  }
	  // Implicit key determined by the index in the set
	  return index.toString(36);
	}
	
	/**
	 * @param {?*} children Children tree container.
	 * @param {!string} nameSoFar Name of the key path so far.
	 * @param {!function} callback Callback to invoke with each child found.
	 * @param {?*} traverseContext Used to pass information throughout the traversal
	 * process.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
	  var type = typeof children;
	
	  if (type === 'undefined' || type === 'boolean') {
	    // All of the above are perceived as null.
	    children = null;
	  }
	
	  if (children === null || type === 'string' || type === 'number' ||
	  // The following is inlined from ReactElement. This means we can optimize
	  // some checks. React Fiber also inlines this logic for similar purposes.
	  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
	    callback(traverseContext, children,
	    // If it's the only child, treat the name as if it was wrapped in an array
	    // so that it's consistent if the number of children grows.
	    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
	    return 1;
	  }
	
	  var child;
	  var nextName;
	  var subtreeCount = 0; // Count of children found in the current subtree.
	  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;
	
	  if (Array.isArray(children)) {
	    for (var i = 0; i < children.length; i++) {
	      child = children[i];
	      nextName = nextNamePrefix + getComponentKey(child, i);
	      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	    }
	  } else {
	    var iteratorFn = getIteratorFn(children);
	    if (iteratorFn) {
	      var iterator = iteratorFn.call(children);
	      var step;
	      if (iteratorFn !== children.entries) {
	        var ii = 0;
	        while (!(step = iterator.next()).done) {
	          child = step.value;
	          nextName = nextNamePrefix + getComponentKey(child, ii++);
	          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	        }
	      } else {
	        if (false) {
	          var mapsAsChildrenAddendum = '';
	          if (ReactCurrentOwner.current) {
	            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
	            if (mapsAsChildrenOwnerName) {
	              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
	            }
	          }
	          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
	          didWarnAboutMaps = true;
	        }
	        // Iterator will provide entry [k,v] tuples rather than values.
	        while (!(step = iterator.next()).done) {
	          var entry = step.value;
	          if (entry) {
	            child = entry[1];
	            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
	            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	          }
	        }
	      }
	    } else if (type === 'object') {
	      var addendum = '';
	      if (false) {
	        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
	        if (children._isReactElement) {
	          addendum = ' It looks like you\'re using an element created by a different ' + 'version of React. Make sure to use only one copy of React.';
	        }
	        if (ReactCurrentOwner.current) {
	          var name = ReactCurrentOwner.current.getName();
	          if (name) {
	            addendum += ' Check the render method of `' + name + '`.';
	          }
	        }
	      }
	      var childrenString = String(children);
	       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
	    }
	  }
	
	  return subtreeCount;
	}
	
	/**
	 * Traverses children that are typically specified as `props.children`, but
	 * might also be specified through attributes:
	 *
	 * - `traverseAllChildren(this.props.children, ...)`
	 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
	 *
	 * The `traverseContext` is an optional argument that is passed through the
	 * entire traversal. It can be used to store accumulations or anything else that
	 * the callback might find relevant.
	 *
	 * @param {?*} children Children tree object.
	 * @param {!function} callback To invoke upon traversing each child.
	 * @param {?*} traverseContext Context for traversal.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildren(children, callback, traverseContext) {
	  if (children == null) {
	    return 0;
	  }
	
	  return traverseAllChildrenImpl(children, '', callback, traverseContext);
	}
	
	module.exports = traverseAllChildren;

/***/ }),
/* 314 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	/* global Symbol */
	
	var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	/**
	 * Returns the iterator method function contained on the iterable object.
	 *
	 * Be sure to invoke the function with the iterable as context:
	 *
	 *     var iteratorFn = getIteratorFn(myIterable);
	 *     if (iteratorFn) {
	 *       var iterator = iteratorFn.call(myIterable);
	 *       ...
	 *     }
	 *
	 * @param {?object} maybeIterable
	 * @return {?function}
	 */
	function getIteratorFn(maybeIterable) {
	  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	  if (typeof iteratorFn === 'function') {
	    return iteratorFn;
	  }
	}
	
	module.exports = getIteratorFn;

/***/ }),
/* 315 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * Escape and wrap key so it is safe to use as a reactid
	 *
	 * @param {string} key to be escaped.
	 * @return {string} the escaped key.
	 */
	
	function escape(key) {
	  var escapeRegex = /[=:]/g;
	  var escaperLookup = {
	    '=': '=0',
	    ':': '=2'
	  };
	  var escapedString = ('' + key).replace(escapeRegex, function (match) {
	    return escaperLookup[match];
	  });
	
	  return '$' + escapedString;
	}
	
	/**
	 * Unescape and unwrap key for human-readable display
	 *
	 * @param {string} key to unescape.
	 * @return {string} the unescaped key.
	 */
	function unescape(key) {
	  var unescapeRegex = /(=0|=2)/g;
	  var unescaperLookup = {
	    '=0': '=',
	    '=2': ':'
	  };
	  var keySubstring = key[0] === '.' && key[1] === '$' ? key.substring(2) : key.substring(1);
	
	  return ('' + keySubstring).replace(unescapeRegex, function (match) {
	    return unescaperLookup[match];
	  });
	}
	
	var KeyEscapeUtils = {
	  escape: escape,
	  unescape: unescape
	};
	
	module.exports = KeyEscapeUtils;

/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(305);
	
	var ReactNoopUpdateQueue = __webpack_require__(317);
	
	var canDefineProperty = __webpack_require__(311);
	var emptyObject = __webpack_require__(318);
	var invariant = __webpack_require__(306);
	var warning = __webpack_require__(309);
	
	/**
	 * Base class helpers for the updating state of a component.
	 */
	function ReactComponent(props, context, updater) {
	  this.props = props;
	  this.context = context;
	  this.refs = emptyObject;
	  // We initialize the default updater but the real one gets injected by the
	  // renderer.
	  this.updater = updater || ReactNoopUpdateQueue;
	}
	
	ReactComponent.prototype.isReactComponent = {};
	
	/**
	 * Sets a subset of the state. Always use this to mutate
	 * state. You should treat `this.state` as immutable.
	 *
	 * There is no guarantee that `this.state` will be immediately updated, so
	 * accessing `this.state` after calling this method may return the old value.
	 *
	 * There is no guarantee that calls to `setState` will run synchronously,
	 * as they may eventually be batched together.  You can provide an optional
	 * callback that will be executed when the call to setState is actually
	 * completed.
	 *
	 * When a function is provided to setState, it will be called at some point in
	 * the future (not synchronously). It will be called with the up to date
	 * component arguments (state, props, context). These values can be different
	 * from this.* because your function may be called after receiveProps but before
	 * shouldComponentUpdate, and this new state, props, and context will not yet be
	 * assigned to this.
	 *
	 * @param {object|function} partialState Next partial state or function to
	 *        produce next partial state to be merged with current state.
	 * @param {?function} callback Called after state is updated.
	 * @final
	 * @protected
	 */
	ReactComponent.prototype.setState = function (partialState, callback) {
	  !(typeof partialState === 'object' || typeof partialState === 'function' || partialState == null) ?  false ? invariant(false, 'setState(...): takes an object of state variables to update or a function which returns an object of state variables.') : _prodInvariant('85') : void 0;
	  this.updater.enqueueSetState(this, partialState);
	  if (callback) {
	    this.updater.enqueueCallback(this, callback, 'setState');
	  }
	};
	
	/**
	 * Forces an update. This should only be invoked when it is known with
	 * certainty that we are **not** in a DOM transaction.
	 *
	 * You may want to call this when you know that some deeper aspect of the
	 * component's state has changed but `setState` was not called.
	 *
	 * This will not invoke `shouldComponentUpdate`, but it will invoke
	 * `componentWillUpdate` and `componentDidUpdate`.
	 *
	 * @param {?function} callback Called after update is complete.
	 * @final
	 * @protected
	 */
	ReactComponent.prototype.forceUpdate = function (callback) {
	  this.updater.enqueueForceUpdate(this);
	  if (callback) {
	    this.updater.enqueueCallback(this, callback, 'forceUpdate');
	  }
	};
	
	/**
	 * Deprecated APIs. These APIs used to exist on classic React classes but since
	 * we would like to deprecate them, we're not going to move them over to this
	 * modern base class. Instead, we define a getter that warns if it's accessed.
	 */
	if (false) {
	  var deprecatedAPIs = {
	    isMounted: ['isMounted', 'Instead, make sure to clean up subscriptions and pending requests in ' + 'componentWillUnmount to prevent memory leaks.'],
	    replaceState: ['replaceState', 'Refactor your code to use setState instead (see ' + 'https://github.com/facebook/react/issues/3236).']
	  };
	  var defineDeprecationWarning = function (methodName, info) {
	    if (canDefineProperty) {
	      Object.defineProperty(ReactComponent.prototype, methodName, {
	        get: function () {
	          process.env.NODE_ENV !== 'production' ? warning(false, '%s(...) is deprecated in plain JavaScript React classes. %s', info[0], info[1]) : void 0;
	          return undefined;
	        }
	      });
	    }
	  };
	  for (var fnName in deprecatedAPIs) {
	    if (deprecatedAPIs.hasOwnProperty(fnName)) {
	      defineDeprecationWarning(fnName, deprecatedAPIs[fnName]);
	    }
	  }
	}
	
	module.exports = ReactComponent;

/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var warning = __webpack_require__(309);
	
	function warnNoop(publicInstance, callerName) {
	  if (false) {
	    var constructor = publicInstance.constructor;
	    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
	  }
	}
	
	/**
	 * This is the abstract API for an update queue.
	 */
	var ReactNoopUpdateQueue = {
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function (publicInstance) {
	    return false;
	  },
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @internal
	   */
	  enqueueCallback: function (publicInstance, callback) {},
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	  enqueueForceUpdate: function (publicInstance) {
	    warnNoop(publicInstance, 'forceUpdate');
	  },
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} completeState Next state.
	   * @internal
	   */
	  enqueueReplaceState: function (publicInstance, completeState) {
	    warnNoop(publicInstance, 'replaceState');
	  },
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialState Next partial state to be merged with state.
	   * @internal
	   */
	  enqueueSetState: function (publicInstance, partialState) {
	    warnNoop(publicInstance, 'setState');
	  }
	};
	
	module.exports = ReactNoopUpdateQueue;

/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var emptyObject = {};
	
	if (false) {
	  Object.freeze(emptyObject);
	}
	
	module.exports = emptyObject;

/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(302);
	
	var ReactComponent = __webpack_require__(316);
	var ReactNoopUpdateQueue = __webpack_require__(317);
	
	var emptyObject = __webpack_require__(318);
	
	/**
	 * Base class helpers for the updating state of a component.
	 */
	function ReactPureComponent(props, context, updater) {
	  // Duplicated from ReactComponent.
	  this.props = props;
	  this.context = context;
	  this.refs = emptyObject;
	  // We initialize the default updater but the real one gets injected by the
	  // renderer.
	  this.updater = updater || ReactNoopUpdateQueue;
	}
	
	function ComponentDummy() {}
	ComponentDummy.prototype = ReactComponent.prototype;
	ReactPureComponent.prototype = new ComponentDummy();
	ReactPureComponent.prototype.constructor = ReactPureComponent;
	// Avoid an extra prototype jump for these methods.
	_assign(ReactPureComponent.prototype, ReactComponent.prototype);
	ReactPureComponent.prototype.isPureReactComponent = true;
	
	module.exports = ReactPureComponent;

/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(305),
	    _assign = __webpack_require__(302);
	
	var ReactComponent = __webpack_require__(316);
	var ReactElement = __webpack_require__(307);
	var ReactPropTypeLocationNames = __webpack_require__(321);
	var ReactNoopUpdateQueue = __webpack_require__(317);
	
	var emptyObject = __webpack_require__(318);
	var invariant = __webpack_require__(306);
	var warning = __webpack_require__(309);
	
	var MIXINS_KEY = 'mixins';
	
	// Helper function to allow the creation of anonymous functions which do not
	// have .name set to the name of the variable being assigned to.
	function identity(fn) {
	  return fn;
	}
	
	/**
	 * Policies that describe methods in `ReactClassInterface`.
	 */
	
	
	var injectedMixins = [];
	
	/**
	 * Composite components are higher-level components that compose other composite
	 * or host components.
	 *
	 * To create a new type of `ReactClass`, pass a specification of
	 * your new class to `React.createClass`. The only requirement of your class
	 * specification is that you implement a `render` method.
	 *
	 *   var MyComponent = React.createClass({
	 *     render: function() {
	 *       return <div>Hello World</div>;
	 *     }
	 *   });
	 *
	 * The class specification supports a specific protocol of methods that have
	 * special meaning (e.g. `render`). See `ReactClassInterface` for
	 * more the comprehensive protocol. Any other properties and methods in the
	 * class specification will be available on the prototype.
	 *
	 * @interface ReactClassInterface
	 * @internal
	 */
	var ReactClassInterface = {
	
	  /**
	   * An array of Mixin objects to include when defining your component.
	   *
	   * @type {array}
	   * @optional
	   */
	  mixins: 'DEFINE_MANY',
	
	  /**
	   * An object containing properties and methods that should be defined on
	   * the component's constructor instead of its prototype (static methods).
	   *
	   * @type {object}
	   * @optional
	   */
	  statics: 'DEFINE_MANY',
	
	  /**
	   * Definition of prop types for this component.
	   *
	   * @type {object}
	   * @optional
	   */
	  propTypes: 'DEFINE_MANY',
	
	  /**
	   * Definition of context types for this component.
	   *
	   * @type {object}
	   * @optional
	   */
	  contextTypes: 'DEFINE_MANY',
	
	  /**
	   * Definition of context types this component sets for its children.
	   *
	   * @type {object}
	   * @optional
	   */
	  childContextTypes: 'DEFINE_MANY',
	
	  // ==== Definition methods ====
	
	  /**
	   * Invoked when the component is mounted. Values in the mapping will be set on
	   * `this.props` if that prop is not specified (i.e. using an `in` check).
	   *
	   * This method is invoked before `getInitialState` and therefore cannot rely
	   * on `this.state` or use `this.setState`.
	   *
	   * @return {object}
	   * @optional
	   */
	  getDefaultProps: 'DEFINE_MANY_MERGED',
	
	  /**
	   * Invoked once before the component is mounted. The return value will be used
	   * as the initial value of `this.state`.
	   *
	   *   getInitialState: function() {
	   *     return {
	   *       isOn: false,
	   *       fooBaz: new BazFoo()
	   *     }
	   *   }
	   *
	   * @return {object}
	   * @optional
	   */
	  getInitialState: 'DEFINE_MANY_MERGED',
	
	  /**
	   * @return {object}
	   * @optional
	   */
	  getChildContext: 'DEFINE_MANY_MERGED',
	
	  /**
	   * Uses props from `this.props` and state from `this.state` to render the
	   * structure of the component.
	   *
	   * No guarantees are made about when or how often this method is invoked, so
	   * it must not have side effects.
	   *
	   *   render: function() {
	   *     var name = this.props.name;
	   *     return <div>Hello, {name}!</div>;
	   *   }
	   *
	   * @return {ReactComponent}
	   * @required
	   */
	  render: 'DEFINE_ONCE',
	
	  // ==== Delegate methods ====
	
	  /**
	   * Invoked when the component is initially created and about to be mounted.
	   * This may have side effects, but any external subscriptions or data created
	   * by this method must be cleaned up in `componentWillUnmount`.
	   *
	   * @optional
	   */
	  componentWillMount: 'DEFINE_MANY',
	
	  /**
	   * Invoked when the component has been mounted and has a DOM representation.
	   * However, there is no guarantee that the DOM node is in the document.
	   *
	   * Use this as an opportunity to operate on the DOM when the component has
	   * been mounted (initialized and rendered) for the first time.
	   *
	   * @param {DOMElement} rootNode DOM element representing the component.
	   * @optional
	   */
	  componentDidMount: 'DEFINE_MANY',
	
	  /**
	   * Invoked before the component receives new props.
	   *
	   * Use this as an opportunity to react to a prop transition by updating the
	   * state using `this.setState`. Current props are accessed via `this.props`.
	   *
	   *   componentWillReceiveProps: function(nextProps, nextContext) {
	   *     this.setState({
	   *       likesIncreasing: nextProps.likeCount > this.props.likeCount
	   *     });
	   *   }
	   *
	   * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
	   * transition may cause a state change, but the opposite is not true. If you
	   * need it, you are probably looking for `componentWillUpdate`.
	   *
	   * @param {object} nextProps
	   * @optional
	   */
	  componentWillReceiveProps: 'DEFINE_MANY',
	
	  /**
	   * Invoked while deciding if the component should be updated as a result of
	   * receiving new props, state and/or context.
	   *
	   * Use this as an opportunity to `return false` when you're certain that the
	   * transition to the new props/state/context will not require a component
	   * update.
	   *
	   *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
	   *     return !equal(nextProps, this.props) ||
	   *       !equal(nextState, this.state) ||
	   *       !equal(nextContext, this.context);
	   *   }
	   *
	   * @param {object} nextProps
	   * @param {?object} nextState
	   * @param {?object} nextContext
	   * @return {boolean} True if the component should update.
	   * @optional
	   */
	  shouldComponentUpdate: 'DEFINE_ONCE',
	
	  /**
	   * Invoked when the component is about to update due to a transition from
	   * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
	   * and `nextContext`.
	   *
	   * Use this as an opportunity to perform preparation before an update occurs.
	   *
	   * NOTE: You **cannot** use `this.setState()` in this method.
	   *
	   * @param {object} nextProps
	   * @param {?object} nextState
	   * @param {?object} nextContext
	   * @param {ReactReconcileTransaction} transaction
	   * @optional
	   */
	  componentWillUpdate: 'DEFINE_MANY',
	
	  /**
	   * Invoked when the component's DOM representation has been updated.
	   *
	   * Use this as an opportunity to operate on the DOM when the component has
	   * been updated.
	   *
	   * @param {object} prevProps
	   * @param {?object} prevState
	   * @param {?object} prevContext
	   * @param {DOMElement} rootNode DOM element representing the component.
	   * @optional
	   */
	  componentDidUpdate: 'DEFINE_MANY',
	
	  /**
	   * Invoked when the component is about to be removed from its parent and have
	   * its DOM representation destroyed.
	   *
	   * Use this as an opportunity to deallocate any external resources.
	   *
	   * NOTE: There is no `componentDidUnmount` since your component will have been
	   * destroyed by that point.
	   *
	   * @optional
	   */
	  componentWillUnmount: 'DEFINE_MANY',
	
	  // ==== Advanced methods ====
	
	  /**
	   * Updates the component's currently mounted DOM representation.
	   *
	   * By default, this implements React's rendering and reconciliation algorithm.
	   * Sophisticated clients may wish to override this.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   * @overridable
	   */
	  updateComponent: 'OVERRIDE_BASE'
	
	};
	
	/**
	 * Mapping from class specification keys to special processing functions.
	 *
	 * Although these are declared like instance properties in the specification
	 * when defining classes using `React.createClass`, they are actually static
	 * and are accessible on the constructor instead of the prototype. Despite
	 * being static, they must be defined outside of the "statics" key under
	 * which all other static methods are defined.
	 */
	var RESERVED_SPEC_KEYS = {
	  displayName: function (Constructor, displayName) {
	    Constructor.displayName = displayName;
	  },
	  mixins: function (Constructor, mixins) {
	    if (mixins) {
	      for (var i = 0; i < mixins.length; i++) {
	        mixSpecIntoComponent(Constructor, mixins[i]);
	      }
	    }
	  },
	  childContextTypes: function (Constructor, childContextTypes) {
	    if (false) {
	      validateTypeDef(Constructor, childContextTypes, 'childContext');
	    }
	    Constructor.childContextTypes = _assign({}, Constructor.childContextTypes, childContextTypes);
	  },
	  contextTypes: function (Constructor, contextTypes) {
	    if (false) {
	      validateTypeDef(Constructor, contextTypes, 'context');
	    }
	    Constructor.contextTypes = _assign({}, Constructor.contextTypes, contextTypes);
	  },
	  /**
	   * Special case getDefaultProps which should move into statics but requires
	   * automatic merging.
	   */
	  getDefaultProps: function (Constructor, getDefaultProps) {
	    if (Constructor.getDefaultProps) {
	      Constructor.getDefaultProps = createMergedResultFunction(Constructor.getDefaultProps, getDefaultProps);
	    } else {
	      Constructor.getDefaultProps = getDefaultProps;
	    }
	  },
	  propTypes: function (Constructor, propTypes) {
	    if (false) {
	      validateTypeDef(Constructor, propTypes, 'prop');
	    }
	    Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
	  },
	  statics: function (Constructor, statics) {
	    mixStaticSpecIntoComponent(Constructor, statics);
	  },
	  autobind: function () {} };
	
	function validateTypeDef(Constructor, typeDef, location) {
	  for (var propName in typeDef) {
	    if (typeDef.hasOwnProperty(propName)) {
	      // use a warning instead of an invariant so components
	      // don't show up in prod but only in __DEV__
	       false ? warning(typeof typeDef[propName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'React.PropTypes.', Constructor.displayName || 'ReactClass', ReactPropTypeLocationNames[location], propName) : void 0;
	    }
	  }
	}
	
	function validateMethodOverride(isAlreadyDefined, name) {
	  var specPolicy = ReactClassInterface.hasOwnProperty(name) ? ReactClassInterface[name] : null;
	
	  // Disallow overriding of base class methods unless explicitly allowed.
	  if (ReactClassMixin.hasOwnProperty(name)) {
	    !(specPolicy === 'OVERRIDE_BASE') ?  false ? invariant(false, 'ReactClassInterface: You are attempting to override `%s` from your class specification. Ensure that your method names do not overlap with React methods.', name) : _prodInvariant('73', name) : void 0;
	  }
	
	  // Disallow defining methods more than once unless explicitly allowed.
	  if (isAlreadyDefined) {
	    !(specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED') ?  false ? invariant(false, 'ReactClassInterface: You are attempting to define `%s` on your component more than once. This conflict may be due to a mixin.', name) : _prodInvariant('74', name) : void 0;
	  }
	}
	
	/**
	 * Mixin helper which handles policy validation and reserved
	 * specification keys when building React classes.
	 */
	function mixSpecIntoComponent(Constructor, spec) {
	  if (!spec) {
	    if (false) {
	      var typeofSpec = typeof spec;
	      var isMixinValid = typeofSpec === 'object' && spec !== null;
	
	      process.env.NODE_ENV !== 'production' ? warning(isMixinValid, '%s: You\'re attempting to include a mixin that is either null ' + 'or not an object. Check the mixins included by the component, ' + 'as well as any mixins they include themselves. ' + 'Expected object but got %s.', Constructor.displayName || 'ReactClass', spec === null ? null : typeofSpec) : void 0;
	    }
	
	    return;
	  }
	
	  !(typeof spec !== 'function') ?  false ? invariant(false, 'ReactClass: You\'re attempting to use a component class or function as a mixin. Instead, just use a regular object.') : _prodInvariant('75') : void 0;
	  !!ReactElement.isValidElement(spec) ?  false ? invariant(false, 'ReactClass: You\'re attempting to use a component as a mixin. Instead, just use a regular object.') : _prodInvariant('76') : void 0;
	
	  var proto = Constructor.prototype;
	  var autoBindPairs = proto.__reactAutoBindPairs;
	
	  // By handling mixins before any other properties, we ensure the same
	  // chaining order is applied to methods with DEFINE_MANY policy, whether
	  // mixins are listed before or after these methods in the spec.
	  if (spec.hasOwnProperty(MIXINS_KEY)) {
	    RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
	  }
	
	  for (var name in spec) {
	    if (!spec.hasOwnProperty(name)) {
	      continue;
	    }
	
	    if (name === MIXINS_KEY) {
	      // We have already handled mixins in a special case above.
	      continue;
	    }
	
	    var property = spec[name];
	    var isAlreadyDefined = proto.hasOwnProperty(name);
	    validateMethodOverride(isAlreadyDefined, name);
	
	    if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
	      RESERVED_SPEC_KEYS[name](Constructor, property);
	    } else {
	      // Setup methods on prototype:
	      // The following member methods should not be automatically bound:
	      // 1. Expected ReactClass methods (in the "interface").
	      // 2. Overridden methods (that were mixed in).
	      var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
	      var isFunction = typeof property === 'function';
	      var shouldAutoBind = isFunction && !isReactClassMethod && !isAlreadyDefined && spec.autobind !== false;
	
	      if (shouldAutoBind) {
	        autoBindPairs.push(name, property);
	        proto[name] = property;
	      } else {
	        if (isAlreadyDefined) {
	          var specPolicy = ReactClassInterface[name];
	
	          // These cases should already be caught by validateMethodOverride.
	          !(isReactClassMethod && (specPolicy === 'DEFINE_MANY_MERGED' || specPolicy === 'DEFINE_MANY')) ?  false ? invariant(false, 'ReactClass: Unexpected spec policy %s for key %s when mixing in component specs.', specPolicy, name) : _prodInvariant('77', specPolicy, name) : void 0;
	
	          // For methods which are defined more than once, call the existing
	          // methods before calling the new property, merging if appropriate.
	          if (specPolicy === 'DEFINE_MANY_MERGED') {
	            proto[name] = createMergedResultFunction(proto[name], property);
	          } else if (specPolicy === 'DEFINE_MANY') {
	            proto[name] = createChainedFunction(proto[name], property);
	          }
	        } else {
	          proto[name] = property;
	          if (false) {
	            // Add verbose displayName to the function, which helps when looking
	            // at profiling tools.
	            if (typeof property === 'function' && spec.displayName) {
	              proto[name].displayName = spec.displayName + '_' + name;
	            }
	          }
	        }
	      }
	    }
	  }
	}
	
	function mixStaticSpecIntoComponent(Constructor, statics) {
	  if (!statics) {
	    return;
	  }
	  for (var name in statics) {
	    var property = statics[name];
	    if (!statics.hasOwnProperty(name)) {
	      continue;
	    }
	
	    var isReserved = name in RESERVED_SPEC_KEYS;
	    !!isReserved ?  false ? invariant(false, 'ReactClass: You are attempting to define a reserved property, `%s`, that shouldn\'t be on the "statics" key. Define it as an instance property instead; it will still be accessible on the constructor.', name) : _prodInvariant('78', name) : void 0;
	
	    var isInherited = name in Constructor;
	    !!isInherited ?  false ? invariant(false, 'ReactClass: You are attempting to define `%s` on your component more than once. This conflict may be due to a mixin.', name) : _prodInvariant('79', name) : void 0;
	    Constructor[name] = property;
	  }
	}
	
	/**
	 * Merge two objects, but throw if both contain the same key.
	 *
	 * @param {object} one The first object, which is mutated.
	 * @param {object} two The second object
	 * @return {object} one after it has been mutated to contain everything in two.
	 */
	function mergeIntoWithNoDuplicateKeys(one, two) {
	  !(one && two && typeof one === 'object' && typeof two === 'object') ?  false ? invariant(false, 'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.') : _prodInvariant('80') : void 0;
	
	  for (var key in two) {
	    if (two.hasOwnProperty(key)) {
	      !(one[key] === undefined) ?  false ? invariant(false, 'mergeIntoWithNoDuplicateKeys(): Tried to merge two objects with the same key: `%s`. This conflict may be due to a mixin; in particular, this may be caused by two getInitialState() or getDefaultProps() methods returning objects with clashing keys.', key) : _prodInvariant('81', key) : void 0;
	      one[key] = two[key];
	    }
	  }
	  return one;
	}
	
	/**
	 * Creates a function that invokes two functions and merges their return values.
	 *
	 * @param {function} one Function to invoke first.
	 * @param {function} two Function to invoke second.
	 * @return {function} Function that invokes the two argument functions.
	 * @private
	 */
	function createMergedResultFunction(one, two) {
	  return function mergedResult() {
	    var a = one.apply(this, arguments);
	    var b = two.apply(this, arguments);
	    if (a == null) {
	      return b;
	    } else if (b == null) {
	      return a;
	    }
	    var c = {};
	    mergeIntoWithNoDuplicateKeys(c, a);
	    mergeIntoWithNoDuplicateKeys(c, b);
	    return c;
	  };
	}
	
	/**
	 * Creates a function that invokes two functions and ignores their return vales.
	 *
	 * @param {function} one Function to invoke first.
	 * @param {function} two Function to invoke second.
	 * @return {function} Function that invokes the two argument functions.
	 * @private
	 */
	function createChainedFunction(one, two) {
	  return function chainedFunction() {
	    one.apply(this, arguments);
	    two.apply(this, arguments);
	  };
	}
	
	/**
	 * Binds a method to the component.
	 *
	 * @param {object} component Component whose method is going to be bound.
	 * @param {function} method Method to be bound.
	 * @return {function} The bound method.
	 */
	function bindAutoBindMethod(component, method) {
	  var boundMethod = method.bind(component);
	  if (false) {
	    boundMethod.__reactBoundContext = component;
	    boundMethod.__reactBoundMethod = method;
	    boundMethod.__reactBoundArguments = null;
	    var componentName = component.constructor.displayName;
	    var _bind = boundMethod.bind;
	    boundMethod.bind = function (newThis) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      // User is trying to bind() an autobound method; we effectively will
	      // ignore the value of "this" that the user is trying to use, so
	      // let's warn.
	      if (newThis !== component && newThis !== null) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'bind(): React component methods may only be bound to the ' + 'component instance. See %s', componentName) : void 0;
	      } else if (!args.length) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'bind(): You are binding a component method to the component. ' + 'React does this for you automatically in a high-performance ' + 'way, so you can safely remove this call. See %s', componentName) : void 0;
	        return boundMethod;
	      }
	      var reboundMethod = _bind.apply(boundMethod, arguments);
	      reboundMethod.__reactBoundContext = component;
	      reboundMethod.__reactBoundMethod = method;
	      reboundMethod.__reactBoundArguments = args;
	      return reboundMethod;
	    };
	  }
	  return boundMethod;
	}
	
	/**
	 * Binds all auto-bound methods in a component.
	 *
	 * @param {object} component Component whose method is going to be bound.
	 */
	function bindAutoBindMethods(component) {
	  var pairs = component.__reactAutoBindPairs;
	  for (var i = 0; i < pairs.length; i += 2) {
	    var autoBindKey = pairs[i];
	    var method = pairs[i + 1];
	    component[autoBindKey] = bindAutoBindMethod(component, method);
	  }
	}
	
	/**
	 * Add more to the ReactClass base class. These are all legacy features and
	 * therefore not already part of the modern ReactComponent.
	 */
	var ReactClassMixin = {
	
	  /**
	   * TODO: This will be deprecated because state should always keep a consistent
	   * type signature and the only use case for this, is to avoid that.
	   */
	  replaceState: function (newState, callback) {
	    this.updater.enqueueReplaceState(this, newState);
	    if (callback) {
	      this.updater.enqueueCallback(this, callback, 'replaceState');
	    }
	  },
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function () {
	    return this.updater.isMounted(this);
	  }
	};
	
	var ReactClassComponent = function () {};
	_assign(ReactClassComponent.prototype, ReactComponent.prototype, ReactClassMixin);
	
	var didWarnDeprecated = false;
	
	/**
	 * Module for creating composite components.
	 *
	 * @class ReactClass
	 */
	var ReactClass = {
	
	  /**
	   * Creates a composite component class given a class specification.
	   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
	   *
	   * @param {object} spec Class specification (which must define `render`).
	   * @return {function} Component constructor function.
	   * @public
	   */
	  createClass: function (spec) {
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(didWarnDeprecated, '%s: React.createClass is deprecated and will be removed in version 16. ' + 'Use plain JavaScript classes instead. If you\'re not yet ready to ' + 'migrate, create-react-class is available on npm as a ' + 'drop-in replacement.', spec && spec.displayName || 'A Component') : void 0;
	      didWarnDeprecated = true;
	    }
	
	    // To keep our warnings more understandable, we'll use a little hack here to
	    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
	    // unnecessarily identify a class without displayName as 'Constructor'.
	    var Constructor = identity(function (props, context, updater) {
	      // This constructor gets overridden by mocks. The argument is used
	      // by mocks to assert on what gets mounted.
	
	      if (false) {
	        process.env.NODE_ENV !== 'production' ? warning(this instanceof Constructor, 'Something is calling a React component directly. Use a factory or ' + 'JSX instead. See: https://fb.me/react-legacyfactory') : void 0;
	      }
	
	      // Wire up auto-binding
	      if (this.__reactAutoBindPairs.length) {
	        bindAutoBindMethods(this);
	      }
	
	      this.props = props;
	      this.context = context;
	      this.refs = emptyObject;
	      this.updater = updater || ReactNoopUpdateQueue;
	
	      this.state = null;
	
	      // ReactClasses doesn't have constructors. Instead, they use the
	      // getInitialState and componentWillMount methods for initialization.
	
	      var initialState = this.getInitialState ? this.getInitialState() : null;
	      if (false) {
	        // We allow auto-mocks to proceed as if they're returning null.
	        if (initialState === undefined && this.getInitialState._isMockFunction) {
	          // This is probably bad practice. Consider warning here and
	          // deprecating this convenience.
	          initialState = null;
	        }
	      }
	      !(typeof initialState === 'object' && !Array.isArray(initialState)) ?  false ? invariant(false, '%s.getInitialState(): must return an object or null', Constructor.displayName || 'ReactCompositeComponent') : _prodInvariant('82', Constructor.displayName || 'ReactCompositeComponent') : void 0;
	
	      this.state = initialState;
	    });
	    Constructor.prototype = new ReactClassComponent();
	    Constructor.prototype.constructor = Constructor;
	    Constructor.prototype.__reactAutoBindPairs = [];
	
	    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));
	
	    mixSpecIntoComponent(Constructor, spec);
	
	    // Initialize the defaultProps property after all mixins have been merged.
	    if (Constructor.getDefaultProps) {
	      Constructor.defaultProps = Constructor.getDefaultProps();
	    }
	
	    if (false) {
	      // This is a tag to indicate that the use of these method names is ok,
	      // since it's used with createClass. If it's not, then it's likely a
	      // mistake so we'll warn you to use the static property, property
	      // initializer or constructor respectively.
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps.isReactClassApproved = {};
	      }
	      if (Constructor.prototype.getInitialState) {
	        Constructor.prototype.getInitialState.isReactClassApproved = {};
	      }
	    }
	
	    !Constructor.prototype.render ?  false ? invariant(false, 'createClass(...): Class specification must implement a `render` method.') : _prodInvariant('83') : void 0;
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(!Constructor.prototype.componentShouldUpdate, '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', spec.displayName || 'A component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!Constructor.prototype.componentWillRecieveProps, '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', spec.displayName || 'A component') : void 0;
	    }
	
	    // Reduce time spent doing lookups by setting these on the prototype.
	    for (var methodName in ReactClassInterface) {
	      if (!Constructor.prototype[methodName]) {
	        Constructor.prototype[methodName] = null;
	      }
	    }
	
	    return Constructor;
	  },
	
	  injection: {
	    injectMixin: function (mixin) {
	      injectedMixins.push(mixin);
	    }
	  }
	
	};
	
	module.exports = ReactClass;

/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactPropTypeLocationNames = {};
	
	if (false) {
	  ReactPropTypeLocationNames = {
	    prop: 'prop',
	    context: 'context',
	    childContext: 'child context'
	  };
	}
	
	module.exports = ReactPropTypeLocationNames;

/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactElement = __webpack_require__(307);
	
	/**
	 * Create a factory that creates HTML tag elements.
	 *
	 * @private
	 */
	var createDOMFactory = ReactElement.createFactory;
	if (false) {
	  var ReactElementValidator = require('./ReactElementValidator');
	  createDOMFactory = ReactElementValidator.createFactory;
	}
	
	/**
	 * Creates a mapping from supported HTML tags to `ReactDOMComponent` classes.
	 * This is also accessible via `React.DOM`.
	 *
	 * @public
	 */
	var ReactDOMFactories = {
	  a: createDOMFactory('a'),
	  abbr: createDOMFactory('abbr'),
	  address: createDOMFactory('address'),
	  area: createDOMFactory('area'),
	  article: createDOMFactory('article'),
	  aside: createDOMFactory('aside'),
	  audio: createDOMFactory('audio'),
	  b: createDOMFactory('b'),
	  base: createDOMFactory('base'),
	  bdi: createDOMFactory('bdi'),
	  bdo: createDOMFactory('bdo'),
	  big: createDOMFactory('big'),
	  blockquote: createDOMFactory('blockquote'),
	  body: createDOMFactory('body'),
	  br: createDOMFactory('br'),
	  button: createDOMFactory('button'),
	  canvas: createDOMFactory('canvas'),
	  caption: createDOMFactory('caption'),
	  cite: createDOMFactory('cite'),
	  code: createDOMFactory('code'),
	  col: createDOMFactory('col'),
	  colgroup: createDOMFactory('colgroup'),
	  data: createDOMFactory('data'),
	  datalist: createDOMFactory('datalist'),
	  dd: createDOMFactory('dd'),
	  del: createDOMFactory('del'),
	  details: createDOMFactory('details'),
	  dfn: createDOMFactory('dfn'),
	  dialog: createDOMFactory('dialog'),
	  div: createDOMFactory('div'),
	  dl: createDOMFactory('dl'),
	  dt: createDOMFactory('dt'),
	  em: createDOMFactory('em'),
	  embed: createDOMFactory('embed'),
	  fieldset: createDOMFactory('fieldset'),
	  figcaption: createDOMFactory('figcaption'),
	  figure: createDOMFactory('figure'),
	  footer: createDOMFactory('footer'),
	  form: createDOMFactory('form'),
	  h1: createDOMFactory('h1'),
	  h2: createDOMFactory('h2'),
	  h3: createDOMFactory('h3'),
	  h4: createDOMFactory('h4'),
	  h5: createDOMFactory('h5'),
	  h6: createDOMFactory('h6'),
	  head: createDOMFactory('head'),
	  header: createDOMFactory('header'),
	  hgroup: createDOMFactory('hgroup'),
	  hr: createDOMFactory('hr'),
	  html: createDOMFactory('html'),
	  i: createDOMFactory('i'),
	  iframe: createDOMFactory('iframe'),
	  img: createDOMFactory('img'),
	  input: createDOMFactory('input'),
	  ins: createDOMFactory('ins'),
	  kbd: createDOMFactory('kbd'),
	  keygen: createDOMFactory('keygen'),
	  label: createDOMFactory('label'),
	  legend: createDOMFactory('legend'),
	  li: createDOMFactory('li'),
	  link: createDOMFactory('link'),
	  main: createDOMFactory('main'),
	  map: createDOMFactory('map'),
	  mark: createDOMFactory('mark'),
	  menu: createDOMFactory('menu'),
	  menuitem: createDOMFactory('menuitem'),
	  meta: createDOMFactory('meta'),
	  meter: createDOMFactory('meter'),
	  nav: createDOMFactory('nav'),
	  noscript: createDOMFactory('noscript'),
	  object: createDOMFactory('object'),
	  ol: createDOMFactory('ol'),
	  optgroup: createDOMFactory('optgroup'),
	  option: createDOMFactory('option'),
	  output: createDOMFactory('output'),
	  p: createDOMFactory('p'),
	  param: createDOMFactory('param'),
	  picture: createDOMFactory('picture'),
	  pre: createDOMFactory('pre'),
	  progress: createDOMFactory('progress'),
	  q: createDOMFactory('q'),
	  rp: createDOMFactory('rp'),
	  rt: createDOMFactory('rt'),
	  ruby: createDOMFactory('ruby'),
	  s: createDOMFactory('s'),
	  samp: createDOMFactory('samp'),
	  script: createDOMFactory('script'),
	  section: createDOMFactory('section'),
	  select: createDOMFactory('select'),
	  small: createDOMFactory('small'),
	  source: createDOMFactory('source'),
	  span: createDOMFactory('span'),
	  strong: createDOMFactory('strong'),
	  style: createDOMFactory('style'),
	  sub: createDOMFactory('sub'),
	  summary: createDOMFactory('summary'),
	  sup: createDOMFactory('sup'),
	  table: createDOMFactory('table'),
	  tbody: createDOMFactory('tbody'),
	  td: createDOMFactory('td'),
	  textarea: createDOMFactory('textarea'),
	  tfoot: createDOMFactory('tfoot'),
	  th: createDOMFactory('th'),
	  thead: createDOMFactory('thead'),
	  time: createDOMFactory('time'),
	  title: createDOMFactory('title'),
	  tr: createDOMFactory('tr'),
	  track: createDOMFactory('track'),
	  u: createDOMFactory('u'),
	  ul: createDOMFactory('ul'),
	  'var': createDOMFactory('var'),
	  video: createDOMFactory('video'),
	  wbr: createDOMFactory('wbr'),
	
	  // SVG
	  circle: createDOMFactory('circle'),
	  clipPath: createDOMFactory('clipPath'),
	  defs: createDOMFactory('defs'),
	  ellipse: createDOMFactory('ellipse'),
	  g: createDOMFactory('g'),
	  image: createDOMFactory('image'),
	  line: createDOMFactory('line'),
	  linearGradient: createDOMFactory('linearGradient'),
	  mask: createDOMFactory('mask'),
	  path: createDOMFactory('path'),
	  pattern: createDOMFactory('pattern'),
	  polygon: createDOMFactory('polygon'),
	  polyline: createDOMFactory('polyline'),
	  radialGradient: createDOMFactory('radialGradient'),
	  rect: createDOMFactory('rect'),
	  stop: createDOMFactory('stop'),
	  svg: createDOMFactory('svg'),
	  text: createDOMFactory('text'),
	  tspan: createDOMFactory('tspan')
	};
	
	module.exports = ReactDOMFactories;

/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _require = __webpack_require__(307),
	    isValidElement = _require.isValidElement;
	
	var factory = __webpack_require__(324);
	
	module.exports = factory(isValidElement);

/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	// React 15.5 references this module, and assumes PropTypes are still callable in production.
	// Therefore we re-export development-only version with all the PropTypes checks here.
	// However if one is migrating to the `prop-types` npm library, they will go through the
	// `index.js` entry point, and it will branch depending on the environment.
	var factory = __webpack_require__(325);
	module.exports = function(isValidElement) {
	  // It is still allowed in 15.5.
	  var throwOnDirectAccess = false;
	  return factory(isValidElement, throwOnDirectAccess);
	};


/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactIs = __webpack_require__(326);
	var assign = __webpack_require__(302);
	
	var ReactPropTypesSecret = __webpack_require__(328);
	var checkPropTypes = __webpack_require__(329);
	
	var has = Function.call.bind(Object.prototype.hasOwnProperty);
	var printWarning = function() {};
	
	if (false) {
	  printWarning = function(text) {
	    var message = 'Warning: ' + text;
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	}
	
	function emptyFunctionThatReturnsNull() {
	  return null;
	}
	
	module.exports = function(isValidElement, throwOnDirectAccess) {
	  /* global Symbol */
	  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	  /**
	   * Returns the iterator method function contained on the iterable object.
	   *
	   * Be sure to invoke the function with the iterable as context:
	   *
	   *     var iteratorFn = getIteratorFn(myIterable);
	   *     if (iteratorFn) {
	   *       var iterator = iteratorFn.call(myIterable);
	   *       ...
	   *     }
	   *
	   * @param {?object} maybeIterable
	   * @return {?function}
	   */
	  function getIteratorFn(maybeIterable) {
	    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	    if (typeof iteratorFn === 'function') {
	      return iteratorFn;
	    }
	  }
	
	  /**
	   * Collection of methods that allow declaration and validation of props that are
	   * supplied to React components. Example usage:
	   *
	   *   var Props = require('ReactPropTypes');
	   *   var MyArticle = React.createClass({
	   *     propTypes: {
	   *       // An optional string prop named "description".
	   *       description: Props.string,
	   *
	   *       // A required enum prop named "category".
	   *       category: Props.oneOf(['News','Photos']).isRequired,
	   *
	   *       // A prop named "dialog" that requires an instance of Dialog.
	   *       dialog: Props.instanceOf(Dialog).isRequired
	   *     },
	   *     render: function() { ... }
	   *   });
	   *
	   * A more formal specification of how these methods are used:
	   *
	   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
	   *   decl := ReactPropTypes.{type}(.isRequired)?
	   *
	   * Each and every declaration produces a function with the same signature. This
	   * allows the creation of custom validation functions. For example:
	   *
	   *  var MyLink = React.createClass({
	   *    propTypes: {
	   *      // An optional string or URI prop named "href".
	   *      href: function(props, propName, componentName) {
	   *        var propValue = props[propName];
	   *        if (propValue != null && typeof propValue !== 'string' &&
	   *            !(propValue instanceof URI)) {
	   *          return new Error(
	   *            'Expected a string or an URI for ' + propName + ' in ' +
	   *            componentName
	   *          );
	   *        }
	   *      }
	   *    },
	   *    render: function() {...}
	   *  });
	   *
	   * @internal
	   */
	
	  var ANONYMOUS = '<<anonymous>>';
	
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
	  var ReactPropTypes = {
	    array: createPrimitiveTypeChecker('array'),
	    bool: createPrimitiveTypeChecker('boolean'),
	    func: createPrimitiveTypeChecker('function'),
	    number: createPrimitiveTypeChecker('number'),
	    object: createPrimitiveTypeChecker('object'),
	    string: createPrimitiveTypeChecker('string'),
	    symbol: createPrimitiveTypeChecker('symbol'),
	
	    any: createAnyTypeChecker(),
	    arrayOf: createArrayOfTypeChecker,
	    element: createElementTypeChecker(),
	    elementType: createElementTypeTypeChecker(),
	    instanceOf: createInstanceTypeChecker,
	    node: createNodeChecker(),
	    objectOf: createObjectOfTypeChecker,
	    oneOf: createEnumTypeChecker,
	    oneOfType: createUnionTypeChecker,
	    shape: createShapeTypeChecker,
	    exact: createStrictShapeTypeChecker,
	  };
	
	  /**
	   * inlined Object.is polyfill to avoid requiring consumers ship their own
	   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	   */
	  /*eslint-disable no-self-compare*/
	  function is(x, y) {
	    // SameValue algorithm
	    if (x === y) {
	      // Steps 1-5, 7-10
	      // Steps 6.b-6.e: +0 != -0
	      return x !== 0 || 1 / x === 1 / y;
	    } else {
	      // Step 6.a: NaN == NaN
	      return x !== x && y !== y;
	    }
	  }
	  /*eslint-enable no-self-compare*/
	
	  /**
	   * We use an Error-like object for backward compatibility as people may call
	   * PropTypes directly and inspect their output. However, we don't use real
	   * Errors anymore. We don't inspect their stack anyway, and creating them
	   * is prohibitively expensive if they are created too often, such as what
	   * happens in oneOfType() for any type before the one that matched.
	   */
	  function PropTypeError(message) {
	    this.message = message;
	    this.stack = '';
	  }
	  // Make `instanceof Error` still work for returned errors.
	  PropTypeError.prototype = Error.prototype;
	
	  function createChainableTypeChecker(validate) {
	    if (false) {
	      var manualPropTypeCallCache = {};
	      var manualPropTypeWarningCount = 0;
	    }
	    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
	      componentName = componentName || ANONYMOUS;
	      propFullName = propFullName || propName;
	
	      if (secret !== ReactPropTypesSecret) {
	        if (throwOnDirectAccess) {
	          // New behavior only for users of `prop-types` package
	          var err = new Error(
	            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	            'Use `PropTypes.checkPropTypes()` to call them. ' +
	            'Read more at http://fb.me/use-check-prop-types'
	          );
	          err.name = 'Invariant Violation';
	          throw err;
	        } else if (false) {
	          // Old behavior for people using React.PropTypes
	          var cacheKey = componentName + ':' + propName;
	          if (
	            !manualPropTypeCallCache[cacheKey] &&
	            // Avoid spamming the console because they are often not actionable except for lib authors
	            manualPropTypeWarningCount < 3
	          ) {
	            printWarning(
	              'You are manually calling a React.PropTypes validation ' +
	              'function for the `' + propFullName + '` prop on `' + componentName  + '`. This is deprecated ' +
	              'and will throw in the standalone `prop-types` package. ' +
	              'You may be seeing this warning due to a third-party PropTypes ' +
	              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.'
	            );
	            manualPropTypeCallCache[cacheKey] = true;
	            manualPropTypeWarningCount++;
	          }
	        }
	      }
	      if (props[propName] == null) {
	        if (isRequired) {
	          if (props[propName] === null) {
	            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
	          }
	          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
	        }
	        return null;
	      } else {
	        return validate(props, propName, componentName, location, propFullName);
	      }
	    }
	
	    var chainedCheckType = checkType.bind(null, false);
	    chainedCheckType.isRequired = checkType.bind(null, true);
	
	    return chainedCheckType;
	  }
	
	  function createPrimitiveTypeChecker(expectedType) {
	    function validate(props, propName, componentName, location, propFullName, secret) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== expectedType) {
	        // `propValue` being instance of, say, date/regexp, pass the 'object'
	        // check, but we can offer a more precise error message here rather than
	        // 'of type `object`'.
	        var preciseType = getPreciseType(propValue);
	
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createAnyTypeChecker() {
	    return createChainableTypeChecker(emptyFunctionThatReturnsNull);
	  }
	
	  function createArrayOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
	      }
	      var propValue = props[propName];
	      if (!Array.isArray(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
	      }
	      for (var i = 0; i < propValue.length; i++) {
	        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
	        if (error instanceof Error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createElementTypeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      if (!isValidElement(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createElementTypeTypeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      if (!ReactIs.isValidElementType(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createInstanceTypeChecker(expectedClass) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!(props[propName] instanceof expectedClass)) {
	        var expectedClassName = expectedClass.name || ANONYMOUS;
	        var actualClassName = getClassName(props[propName]);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createEnumTypeChecker(expectedValues) {
	    if (!Array.isArray(expectedValues)) {
	      if (false) {
	        if (arguments.length > 1) {
	          printWarning(
	            'Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' +
	            'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).'
	          );
	        } else {
	          printWarning('Invalid argument supplied to oneOf, expected an array.');
	        }
	      }
	      return emptyFunctionThatReturnsNull;
	    }
	
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      for (var i = 0; i < expectedValues.length; i++) {
	        if (is(propValue, expectedValues[i])) {
	          return null;
	        }
	      }
	
	      var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
	        var type = getPreciseType(value);
	        if (type === 'symbol') {
	          return String(value);
	        }
	        return value;
	      });
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createObjectOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
	      }
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
	      }
	      for (var key in propValue) {
	        if (has(propValue, key)) {
	          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	          if (error instanceof Error) {
	            return error;
	          }
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createUnionTypeChecker(arrayOfTypeCheckers) {
	    if (!Array.isArray(arrayOfTypeCheckers)) {
	       false ? printWarning('Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
	      return emptyFunctionThatReturnsNull;
	    }
	
	    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	      var checker = arrayOfTypeCheckers[i];
	      if (typeof checker !== 'function') {
	        printWarning(
	          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
	          'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.'
	        );
	        return emptyFunctionThatReturnsNull;
	      }
	    }
	
	    function validate(props, propName, componentName, location, propFullName) {
	      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	        var checker = arrayOfTypeCheckers[i];
	        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret) == null) {
	          return null;
	        }
	      }
	
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createNodeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!isNode(props[propName])) {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      for (var key in shapeTypes) {
	        var checker = shapeTypes[key];
	        if (!checker) {
	          continue;
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createStrictShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      // We need to check all keys in case some are required but missing from
	      // props.
	      var allKeys = assign({}, props[propName], shapeTypes);
	      for (var key in allKeys) {
	        var checker = shapeTypes[key];
	        if (!checker) {
	          return new PropTypeError(
	            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
	            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
	            '\nValid keys: ' +  JSON.stringify(Object.keys(shapeTypes), null, '  ')
	          );
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }
	
	    return createChainableTypeChecker(validate);
	  }
	
	  function isNode(propValue) {
	    switch (typeof propValue) {
	      case 'number':
	      case 'string':
	      case 'undefined':
	        return true;
	      case 'boolean':
	        return !propValue;
	      case 'object':
	        if (Array.isArray(propValue)) {
	          return propValue.every(isNode);
	        }
	        if (propValue === null || isValidElement(propValue)) {
	          return true;
	        }
	
	        var iteratorFn = getIteratorFn(propValue);
	        if (iteratorFn) {
	          var iterator = iteratorFn.call(propValue);
	          var step;
	          if (iteratorFn !== propValue.entries) {
	            while (!(step = iterator.next()).done) {
	              if (!isNode(step.value)) {
	                return false;
	              }
	            }
	          } else {
	            // Iterator will provide entry [k,v] tuples rather than values.
	            while (!(step = iterator.next()).done) {
	              var entry = step.value;
	              if (entry) {
	                if (!isNode(entry[1])) {
	                  return false;
	                }
	              }
	            }
	          }
	        } else {
	          return false;
	        }
	
	        return true;
	      default:
	        return false;
	    }
	  }
	
	  function isSymbol(propType, propValue) {
	    // Native Symbol.
	    if (propType === 'symbol') {
	      return true;
	    }
	
	    // falsy value can't be a Symbol
	    if (!propValue) {
	      return false;
	    }
	
	    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
	    if (propValue['@@toStringTag'] === 'Symbol') {
	      return true;
	    }
	
	    // Fallback for non-spec compliant Symbols which are polyfilled.
	    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
	      return true;
	    }
	
	    return false;
	  }
	
	  // Equivalent of `typeof` but with special handling for array and regexp.
	  function getPropType(propValue) {
	    var propType = typeof propValue;
	    if (Array.isArray(propValue)) {
	      return 'array';
	    }
	    if (propValue instanceof RegExp) {
	      // Old webkits (at least until Android 4.0) return 'function' rather than
	      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
	      // passes PropTypes.object.
	      return 'object';
	    }
	    if (isSymbol(propType, propValue)) {
	      return 'symbol';
	    }
	    return propType;
	  }
	
	  // This handles more types than `getPropType`. Only used for error messages.
	  // See `createPrimitiveTypeChecker`.
	  function getPreciseType(propValue) {
	    if (typeof propValue === 'undefined' || propValue === null) {
	      return '' + propValue;
	    }
	    var propType = getPropType(propValue);
	    if (propType === 'object') {
	      if (propValue instanceof Date) {
	        return 'date';
	      } else if (propValue instanceof RegExp) {
	        return 'regexp';
	      }
	    }
	    return propType;
	  }
	
	  // Returns a string that is postfixed to a warning about an invalid type.
	  // For example, "undefined" or "of type array"
	  function getPostfixForTypeWarning(value) {
	    var type = getPreciseType(value);
	    switch (type) {
	      case 'array':
	      case 'object':
	        return 'an ' + type;
	      case 'boolean':
	      case 'date':
	      case 'regexp':
	        return 'a ' + type;
	      default:
	        return type;
	    }
	  }
	
	  // Returns class name of the object, if any.
	  function getClassName(propValue) {
	    if (!propValue.constructor || !propValue.constructor.name) {
	      return ANONYMOUS;
	    }
	    return propValue.constructor.name;
	  }
	
	  ReactPropTypes.checkPropTypes = checkPropTypes;
	  ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache;
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(327);
	} else {
	  module.exports = require('./cjs/react-is.development.js');
	}


/***/ }),
/* 327 */
/***/ (function(module, exports) {

	/** @license React v16.8.6
	 * react-is.production.min.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';Object.defineProperty(exports,"__esModule",{value:!0});
	var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?Symbol.for("react.memo"):
	60115,r=b?Symbol.for("react.lazy"):60116;function t(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case h:return a;default:return u}}case r:case q:case d:return u}}}function v(a){return t(a)===m}exports.typeOf=t;exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;
	exports.Fragment=e;exports.Lazy=r;exports.Memo=q;exports.Portal=d;exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||"object"===typeof a&&null!==a&&(a.$$typeof===r||a.$$typeof===q||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n)};exports.isAsyncMode=function(a){return v(a)||t(a)===l};exports.isConcurrentMode=v;exports.isContextConsumer=function(a){return t(a)===k};
	exports.isContextProvider=function(a){return t(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return t(a)===n};exports.isFragment=function(a){return t(a)===e};exports.isLazy=function(a){return t(a)===r};exports.isMemo=function(a){return t(a)===q};exports.isPortal=function(a){return t(a)===d};exports.isProfiler=function(a){return t(a)===g};exports.isStrictMode=function(a){return t(a)===f};
	exports.isSuspense=function(a){return t(a)===p};


/***/ }),
/* 328 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;


/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var printWarning = function() {};
	
	if (false) {
	  var ReactPropTypesSecret = require('./lib/ReactPropTypesSecret');
	  var loggedTypeFailures = {};
	  var has = Function.call.bind(Object.prototype.hasOwnProperty);
	
	  printWarning = function(text) {
	    var message = 'Warning: ' + text;
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	}
	
	/**
	 * Assert that the values match with the type specs.
	 * Error messages are memorized and will only be shown once.
	 *
	 * @param {object} typeSpecs Map of name to a ReactPropType
	 * @param {object} values Runtime values that need to be type-checked
	 * @param {string} location e.g. "prop", "context", "child context"
	 * @param {string} componentName Name of the component for error messages.
	 * @param {?Function} getStack Returns the component stack.
	 * @private
	 */
	function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
	  if (false) {
	    for (var typeSpecName in typeSpecs) {
	      if (has(typeSpecs, typeSpecName)) {
	        var error;
	        // Prop type validation may throw. In case they do, we don't want to
	        // fail the render phase where it didn't fail before. So we log it.
	        // After these have been cleaned up, we'll let them throw.
	        try {
	          // This is intentionally an invariant that gets caught. It's the same
	          // behavior as without this statement except with a better message.
	          if (typeof typeSpecs[typeSpecName] !== 'function') {
	            var err = Error(
	              (componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' +
	              'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.'
	            );
	            err.name = 'Invariant Violation';
	            throw err;
	          }
	          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
	        } catch (ex) {
	          error = ex;
	        }
	        if (error && !(error instanceof Error)) {
	          printWarning(
	            (componentName || 'React class') + ': type specification of ' +
	            location + ' `' + typeSpecName + '` is invalid; the type checker ' +
	            'function must return `null` or an `Error` but returned a ' + typeof error + '. ' +
	            'You may have forgotten to pass an argument to the type checker ' +
	            'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' +
	            'shape all require an argument).'
	          );
	        }
	        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	          // Only monitor this failure once because there tends to be a lot of the
	          // same error.
	          loggedTypeFailures[error.message] = true;
	
	          var stack = getStack ? getStack() : '';
	
	          printWarning(
	            'Failed ' + location + ' type: ' + error.message + (stack != null ? stack : '')
	          );
	        }
	      }
	    }
	  }
	}
	
	/**
	 * Resets warning cache when testing.
	 *
	 * @private
	 */
	checkPropTypes.resetWarningCache = function() {
	  if (false) {
	    loggedTypeFailures = {};
	  }
	}
	
	module.exports = checkPropTypes;


/***/ }),
/* 330 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	module.exports = '15.5.4';

/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	'use strict';
	
	var _prodInvariant = __webpack_require__(305);
	
	var ReactElement = __webpack_require__(307);
	
	var invariant = __webpack_require__(306);
	
	/**
	 * Returns the first child in a collection of children and verifies that there
	 * is only one child in the collection.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.only
	 *
	 * The current implementation of this function assumes that a single child gets
	 * passed without a wrapper, but the purpose of this helper function is to
	 * abstract away the particular structure of children.
	 *
	 * @param {?object} children Child collection structure.
	 * @return {ReactElement} The first and only `ReactElement` contained in the
	 * structure.
	 */
	function onlyChild(children) {
	  !ReactElement.isValidElement(children) ?  false ? invariant(false, 'React.Children.only expected to receive a single React element child.') : _prodInvariant('143') : void 0;
	  return children;
	}
	
	module.exports = onlyChild;

/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(333);


/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	/* globals __REACT_DEVTOOLS_GLOBAL_HOOK__*/
	
	'use strict';
	
	var ReactDOMComponentTree = __webpack_require__(334);
	var ReactDefaultInjection = __webpack_require__(339);
	var ReactMount = __webpack_require__(468);
	var ReactReconciler = __webpack_require__(362);
	var ReactUpdates = __webpack_require__(359);
	var ReactVersion = __webpack_require__(473);
	
	var findDOMNode = __webpack_require__(474);
	var getHostComponentFromComposite = __webpack_require__(475);
	var renderSubtreeIntoContainer = __webpack_require__(476);
	var warning = __webpack_require__(347);
	
	ReactDefaultInjection.inject();
	
	var ReactDOM = {
	  findDOMNode: findDOMNode,
	  render: ReactMount.render,
	  unmountComponentAtNode: ReactMount.unmountComponentAtNode,
	  version: ReactVersion,
	
	  /* eslint-disable camelcase */
	  unstable_batchedUpdates: ReactUpdates.batchedUpdates,
	  unstable_renderSubtreeIntoContainer: renderSubtreeIntoContainer
	};
	
	// Inject the runtime into a devtools global hook regardless of browser.
	// Allows for debugging when the hook is injected on the page.
	if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.inject === 'function') {
	  __REACT_DEVTOOLS_GLOBAL_HOOK__.inject({
	    ComponentTree: {
	      getClosestInstanceFromNode: ReactDOMComponentTree.getClosestInstanceFromNode,
	      getNodeFromInstance: function (inst) {
	        // inst is an internal instance (but could be a composite)
	        if (inst._renderedComponent) {
	          inst = getHostComponentFromComposite(inst);
	        }
	        if (inst) {
	          return ReactDOMComponentTree.getNodeFromInstance(inst);
	        } else {
	          return null;
	        }
	      }
	    },
	    Mount: ReactMount,
	    Reconciler: ReactReconciler
	  });
	}
	
	if (false) {
	  var ExecutionEnvironment = require('fbjs/lib/ExecutionEnvironment');
	  if (ExecutionEnvironment.canUseDOM && window.top === window.self) {
	
	    // First check if devtools is not installed
	    if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined') {
	      // If we're in Chrome or Firefox, provide a download link if not installed.
	      if (navigator.userAgent.indexOf('Chrome') > -1 && navigator.userAgent.indexOf('Edge') === -1 || navigator.userAgent.indexOf('Firefox') > -1) {
	        // Firefox does not have the issue with devtools loaded over file://
	        var showFileUrlMessage = window.location.protocol.indexOf('http') === -1 && navigator.userAgent.indexOf('Firefox') === -1;
	        console.debug('Download the React DevTools ' + (showFileUrlMessage ? 'and use an HTTP server (instead of a file: URL) ' : '') + 'for a better development experience: ' + 'https://fb.me/react-devtools');
	      }
	    }
	
	    var testFunc = function testFn() {};
	    process.env.NODE_ENV !== 'production' ? warning((testFunc.name || testFunc.toString()).indexOf('testFn') !== -1, 'It looks like you\'re using a minified copy of the development build ' + 'of React. When deploying React apps to production, make sure to use ' + 'the production build which skips development warnings and is faster. ' + 'See https://fb.me/react-minification for more details.') : void 0;
	
	    // If we're in IE8, check to see if we are in compatibility mode and provide
	    // information on preventing compatibility mode
	    var ieCompatibilityMode = document.documentMode && document.documentMode < 8;
	
	    process.env.NODE_ENV !== 'production' ? warning(!ieCompatibilityMode, 'Internet Explorer is running in compatibility mode; please add the ' + 'following tag to your HTML to prevent this from happening: ' + '<meta http-equiv="X-UA-Compatible" content="IE=edge" />') : void 0;
	
	    var expectedFeatures = [
	    // shims
	    Array.isArray, Array.prototype.every, Array.prototype.forEach, Array.prototype.indexOf, Array.prototype.map, Date.now, Function.prototype.bind, Object.keys, String.prototype.trim];
	
	    for (var i = 0; i < expectedFeatures.length; i++) {
	      if (!expectedFeatures[i]) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'One or more ES5 shims expected by React are not available: ' + 'https://fb.me/react-warning-polyfills') : void 0;
	        break;
	      }
	    }
	  }
	}
	
	if (false) {
	  var ReactInstrumentation = require('./ReactInstrumentation');
	  var ReactDOMUnknownPropertyHook = require('./ReactDOMUnknownPropertyHook');
	  var ReactDOMNullInputValuePropHook = require('./ReactDOMNullInputValuePropHook');
	  var ReactDOMInvalidARIAHook = require('./ReactDOMInvalidARIAHook');
	
	  ReactInstrumentation.debugTool.addHook(ReactDOMUnknownPropertyHook);
	  ReactInstrumentation.debugTool.addHook(ReactDOMNullInputValuePropHook);
	  ReactInstrumentation.debugTool.addHook(ReactDOMInvalidARIAHook);
	}
	
	module.exports = ReactDOM;

/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(335);
	
	var DOMProperty = __webpack_require__(336);
	var ReactDOMComponentFlags = __webpack_require__(338);
	
	var invariant = __webpack_require__(337);
	
	var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
	var Flags = ReactDOMComponentFlags;
	
	var internalInstanceKey = '__reactInternalInstance$' + Math.random().toString(36).slice(2);
	
	/**
	 * Check if a given node should be cached.
	 */
	function shouldPrecacheNode(node, nodeID) {
	  return node.nodeType === 1 && node.getAttribute(ATTR_NAME) === String(nodeID) || node.nodeType === 8 && node.nodeValue === ' react-text: ' + nodeID + ' ' || node.nodeType === 8 && node.nodeValue === ' react-empty: ' + nodeID + ' ';
	}
	
	/**
	 * Drill down (through composites and empty components) until we get a host or
	 * host text component.
	 *
	 * This is pretty polymorphic but unavoidable with the current structure we have
	 * for `_renderedChildren`.
	 */
	function getRenderedHostOrTextFromComponent(component) {
	  var rendered;
	  while (rendered = component._renderedComponent) {
	    component = rendered;
	  }
	  return component;
	}
	
	/**
	 * Populate `_hostNode` on the rendered host/text component with the given
	 * DOM node. The passed `inst` can be a composite.
	 */
	function precacheNode(inst, node) {
	  var hostInst = getRenderedHostOrTextFromComponent(inst);
	  hostInst._hostNode = node;
	  node[internalInstanceKey] = hostInst;
	}
	
	function uncacheNode(inst) {
	  var node = inst._hostNode;
	  if (node) {
	    delete node[internalInstanceKey];
	    inst._hostNode = null;
	  }
	}
	
	/**
	 * Populate `_hostNode` on each child of `inst`, assuming that the children
	 * match up with the DOM (element) children of `node`.
	 *
	 * We cache entire levels at once to avoid an n^2 problem where we access the
	 * children of a node sequentially and have to walk from the start to our target
	 * node every time.
	 *
	 * Since we update `_renderedChildren` and the actual DOM at (slightly)
	 * different times, we could race here and see a newer `_renderedChildren` than
	 * the DOM nodes we see. To avoid this, ReactMultiChild calls
	 * `prepareToManageChildren` before we change `_renderedChildren`, at which
	 * time the container's child nodes are always cached (until it unmounts).
	 */
	function precacheChildNodes(inst, node) {
	  if (inst._flags & Flags.hasCachedChildNodes) {
	    return;
	  }
	  var children = inst._renderedChildren;
	  var childNode = node.firstChild;
	  outer: for (var name in children) {
	    if (!children.hasOwnProperty(name)) {
	      continue;
	    }
	    var childInst = children[name];
	    var childID = getRenderedHostOrTextFromComponent(childInst)._domID;
	    if (childID === 0) {
	      // We're currently unmounting this child in ReactMultiChild; skip it.
	      continue;
	    }
	    // We assume the child nodes are in the same order as the child instances.
	    for (; childNode !== null; childNode = childNode.nextSibling) {
	      if (shouldPrecacheNode(childNode, childID)) {
	        precacheNode(childInst, childNode);
	        continue outer;
	      }
	    }
	    // We reached the end of the DOM children without finding an ID match.
	     true ?  false ? invariant(false, 'Unable to find element with ID %s.', childID) : _prodInvariant('32', childID) : void 0;
	  }
	  inst._flags |= Flags.hasCachedChildNodes;
	}
	
	/**
	 * Given a DOM node, return the closest ReactDOMComponent or
	 * ReactDOMTextComponent instance ancestor.
	 */
	function getClosestInstanceFromNode(node) {
	  if (node[internalInstanceKey]) {
	    return node[internalInstanceKey];
	  }
	
	  // Walk up the tree until we find an ancestor whose instance we have cached.
	  var parents = [];
	  while (!node[internalInstanceKey]) {
	    parents.push(node);
	    if (node.parentNode) {
	      node = node.parentNode;
	    } else {
	      // Top of the tree. This node must not be part of a React tree (or is
	      // unmounted, potentially).
	      return null;
	    }
	  }
	
	  var closest;
	  var inst;
	  for (; node && (inst = node[internalInstanceKey]); node = parents.pop()) {
	    closest = inst;
	    if (parents.length) {
	      precacheChildNodes(inst, node);
	    }
	  }
	
	  return closest;
	}
	
	/**
	 * Given a DOM node, return the ReactDOMComponent or ReactDOMTextComponent
	 * instance, or null if the node was not rendered by this React.
	 */
	function getInstanceFromNode(node) {
	  var inst = getClosestInstanceFromNode(node);
	  if (inst != null && inst._hostNode === node) {
	    return inst;
	  } else {
	    return null;
	  }
	}
	
	/**
	 * Given a ReactDOMComponent or ReactDOMTextComponent, return the corresponding
	 * DOM node.
	 */
	function getNodeFromInstance(inst) {
	  // Without this first invariant, passing a non-DOM-component triggers the next
	  // invariant for a missing parent, which is super confusing.
	  !(inst._hostNode !== undefined) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	
	  if (inst._hostNode) {
	    return inst._hostNode;
	  }
	
	  // Walk up the tree until we find an ancestor whose DOM node we have cached.
	  var parents = [];
	  while (!inst._hostNode) {
	    parents.push(inst);
	    !inst._hostParent ?  false ? invariant(false, 'React DOM tree root should always have a node reference.') : _prodInvariant('34') : void 0;
	    inst = inst._hostParent;
	  }
	
	  // Now parents contains each ancestor that does *not* have a cached native
	  // node, and `inst` is the deepest ancestor that does.
	  for (; parents.length; inst = parents.pop()) {
	    precacheChildNodes(inst, inst._hostNode);
	  }
	
	  return inst._hostNode;
	}
	
	var ReactDOMComponentTree = {
	  getClosestInstanceFromNode: getClosestInstanceFromNode,
	  getInstanceFromNode: getInstanceFromNode,
	  getNodeFromInstance: getNodeFromInstance,
	  precacheChildNodes: precacheChildNodes,
	  precacheNode: precacheNode,
	  uncacheNode: uncacheNode
	};
	
	module.exports = ReactDOMComponentTree;

/***/ }),
/* 335 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	'use strict';
	
	/**
	 * WARNING: DO NOT manually require this module.
	 * This is a replacement for `invariant(...)` used by the error code system
	 * and will _only_ be required by the corresponding babel pass.
	 * It always throws.
	 */
	
	function reactProdInvariant(code) {
	  var argCount = arguments.length - 1;
	
	  var message = 'Minified React error #' + code + '; visit ' + 'http://facebook.github.io/react/docs/error-decoder.html?invariant=' + code;
	
	  for (var argIdx = 0; argIdx < argCount; argIdx++) {
	    message += '&args[]=' + encodeURIComponent(arguments[argIdx + 1]);
	  }
	
	  message += ' for the full message or use the non-minified dev environment' + ' for full errors and additional helpful warnings.';
	
	  var error = new Error(message);
	  error.name = 'Invariant Violation';
	  error.framesToPop = 1; // we don't care about reactProdInvariant's own frame
	
	  throw error;
	}
	
	module.exports = reactProdInvariant;

/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(335);
	
	var invariant = __webpack_require__(337);
	
	function checkMask(value, bitmask) {
	  return (value & bitmask) === bitmask;
	}
	
	var DOMPropertyInjection = {
	  /**
	   * Mapping from normalized, camelcased property names to a configuration that
	   * specifies how the associated DOM property should be accessed or rendered.
	   */
	  MUST_USE_PROPERTY: 0x1,
	  HAS_BOOLEAN_VALUE: 0x4,
	  HAS_NUMERIC_VALUE: 0x8,
	  HAS_POSITIVE_NUMERIC_VALUE: 0x10 | 0x8,
	  HAS_OVERLOADED_BOOLEAN_VALUE: 0x20,
	
	  /**
	   * Inject some specialized knowledge about the DOM. This takes a config object
	   * with the following properties:
	   *
	   * isCustomAttribute: function that given an attribute name will return true
	   * if it can be inserted into the DOM verbatim. Useful for data-* or aria-*
	   * attributes where it's impossible to enumerate all of the possible
	   * attribute names,
	   *
	   * Properties: object mapping DOM property name to one of the
	   * DOMPropertyInjection constants or null. If your attribute isn't in here,
	   * it won't get written to the DOM.
	   *
	   * DOMAttributeNames: object mapping React attribute name to the DOM
	   * attribute name. Attribute names not specified use the **lowercase**
	   * normalized name.
	   *
	   * DOMAttributeNamespaces: object mapping React attribute name to the DOM
	   * attribute namespace URL. (Attribute names not specified use no namespace.)
	   *
	   * DOMPropertyNames: similar to DOMAttributeNames but for DOM properties.
	   * Property names not specified use the normalized name.
	   *
	   * DOMMutationMethods: Properties that require special mutation methods. If
	   * `value` is undefined, the mutation method should unset the property.
	   *
	   * @param {object} domPropertyConfig the config as described above.
	   */
	  injectDOMPropertyConfig: function (domPropertyConfig) {
	    var Injection = DOMPropertyInjection;
	    var Properties = domPropertyConfig.Properties || {};
	    var DOMAttributeNamespaces = domPropertyConfig.DOMAttributeNamespaces || {};
	    var DOMAttributeNames = domPropertyConfig.DOMAttributeNames || {};
	    var DOMPropertyNames = domPropertyConfig.DOMPropertyNames || {};
	    var DOMMutationMethods = domPropertyConfig.DOMMutationMethods || {};
	
	    if (domPropertyConfig.isCustomAttribute) {
	      DOMProperty._isCustomAttributeFunctions.push(domPropertyConfig.isCustomAttribute);
	    }
	
	    for (var propName in Properties) {
	      !!DOMProperty.properties.hasOwnProperty(propName) ?  false ? invariant(false, 'injectDOMPropertyConfig(...): You\'re trying to inject DOM property \'%s\' which has already been injected. You may be accidentally injecting the same DOM property config twice, or you may be injecting two configs that have conflicting property names.', propName) : _prodInvariant('48', propName) : void 0;
	
	      var lowerCased = propName.toLowerCase();
	      var propConfig = Properties[propName];
	
	      var propertyInfo = {
	        attributeName: lowerCased,
	        attributeNamespace: null,
	        propertyName: propName,
	        mutationMethod: null,
	
	        mustUseProperty: checkMask(propConfig, Injection.MUST_USE_PROPERTY),
	        hasBooleanValue: checkMask(propConfig, Injection.HAS_BOOLEAN_VALUE),
	        hasNumericValue: checkMask(propConfig, Injection.HAS_NUMERIC_VALUE),
	        hasPositiveNumericValue: checkMask(propConfig, Injection.HAS_POSITIVE_NUMERIC_VALUE),
	        hasOverloadedBooleanValue: checkMask(propConfig, Injection.HAS_OVERLOADED_BOOLEAN_VALUE)
	      };
	      !(propertyInfo.hasBooleanValue + propertyInfo.hasNumericValue + propertyInfo.hasOverloadedBooleanValue <= 1) ?  false ? invariant(false, 'DOMProperty: Value can be one of boolean, overloaded boolean, or numeric value, but not a combination: %s', propName) : _prodInvariant('50', propName) : void 0;
	
	      if (false) {
	        DOMProperty.getPossibleStandardName[lowerCased] = propName;
	      }
	
	      if (DOMAttributeNames.hasOwnProperty(propName)) {
	        var attributeName = DOMAttributeNames[propName];
	        propertyInfo.attributeName = attributeName;
	        if (false) {
	          DOMProperty.getPossibleStandardName[attributeName] = propName;
	        }
	      }
	
	      if (DOMAttributeNamespaces.hasOwnProperty(propName)) {
	        propertyInfo.attributeNamespace = DOMAttributeNamespaces[propName];
	      }
	
	      if (DOMPropertyNames.hasOwnProperty(propName)) {
	        propertyInfo.propertyName = DOMPropertyNames[propName];
	      }
	
	      if (DOMMutationMethods.hasOwnProperty(propName)) {
	        propertyInfo.mutationMethod = DOMMutationMethods[propName];
	      }
	
	      DOMProperty.properties[propName] = propertyInfo;
	    }
	  }
	};
	
	/* eslint-disable max-len */
	var ATTRIBUTE_NAME_START_CHAR = ':A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD';
	/* eslint-enable max-len */
	
	/**
	 * DOMProperty exports lookup objects that can be used like functions:
	 *
	 *   > DOMProperty.isValid['id']
	 *   true
	 *   > DOMProperty.isValid['foobar']
	 *   undefined
	 *
	 * Although this may be confusing, it performs better in general.
	 *
	 * @see http://jsperf.com/key-exists
	 * @see http://jsperf.com/key-missing
	 */
	var DOMProperty = {
	
	  ID_ATTRIBUTE_NAME: 'data-reactid',
	  ROOT_ATTRIBUTE_NAME: 'data-reactroot',
	
	  ATTRIBUTE_NAME_START_CHAR: ATTRIBUTE_NAME_START_CHAR,
	  ATTRIBUTE_NAME_CHAR: ATTRIBUTE_NAME_START_CHAR + '\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040',
	
	  /**
	   * Map from property "standard name" to an object with info about how to set
	   * the property in the DOM. Each object contains:
	   *
	   * attributeName:
	   *   Used when rendering markup or with `*Attribute()`.
	   * attributeNamespace
	   * propertyName:
	   *   Used on DOM node instances. (This includes properties that mutate due to
	   *   external factors.)
	   * mutationMethod:
	   *   If non-null, used instead of the property or `setAttribute()` after
	   *   initial render.
	   * mustUseProperty:
	   *   Whether the property must be accessed and mutated as an object property.
	   * hasBooleanValue:
	   *   Whether the property should be removed when set to a falsey value.
	   * hasNumericValue:
	   *   Whether the property must be numeric or parse as a numeric and should be
	   *   removed when set to a falsey value.
	   * hasPositiveNumericValue:
	   *   Whether the property must be positive numeric or parse as a positive
	   *   numeric and should be removed when set to a falsey value.
	   * hasOverloadedBooleanValue:
	   *   Whether the property can be used as a flag as well as with a value.
	   *   Removed when strictly equal to false; present without a value when
	   *   strictly equal to true; present with a value otherwise.
	   */
	  properties: {},
	
	  /**
	   * Mapping from lowercase property names to the properly cased version, used
	   * to warn in the case of missing properties. Available only in __DEV__.
	   *
	   * autofocus is predefined, because adding it to the property whitelist
	   * causes unintended side effects.
	   *
	   * @type {Object}
	   */
	  getPossibleStandardName:  false ? { autofocus: 'autoFocus' } : null,
	
	  /**
	   * All of the isCustomAttribute() functions that have been injected.
	   */
	  _isCustomAttributeFunctions: [],
	
	  /**
	   * Checks whether a property name is a custom attribute.
	   * @method
	   */
	  isCustomAttribute: function (attributeName) {
	    for (var i = 0; i < DOMProperty._isCustomAttributeFunctions.length; i++) {
	      var isCustomAttributeFn = DOMProperty._isCustomAttributeFunctions[i];
	      if (isCustomAttributeFn(attributeName)) {
	        return true;
	      }
	    }
	    return false;
	  },
	
	  injection: DOMPropertyInjection
	};
	
	module.exports = DOMProperty;

/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var validateFormat = function validateFormat(format) {};
	
	if (false) {
	  validateFormat = function validateFormat(format) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  };
	}
	
	function invariant(condition, format, a, b, c, d, e, f) {
	  validateFormat(format);
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(format.replace(/%s/g, function () {
	        return args[argIndex++];
	      }));
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	}
	
	module.exports = invariant;

/***/ }),
/* 338 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactDOMComponentFlags = {
	  hasCachedChildNodes: 1 << 0
	};
	
	module.exports = ReactDOMComponentFlags;

/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ARIADOMPropertyConfig = __webpack_require__(340);
	var BeforeInputEventPlugin = __webpack_require__(341);
	var ChangeEventPlugin = __webpack_require__(358);
	var DefaultEventPluginOrder = __webpack_require__(370);
	var EnterLeaveEventPlugin = __webpack_require__(371);
	var HTMLDOMPropertyConfig = __webpack_require__(376);
	var ReactComponentBrowserEnvironment = __webpack_require__(377);
	var ReactDOMComponent = __webpack_require__(390);
	var ReactDOMComponentTree = __webpack_require__(334);
	var ReactDOMEmptyComponent = __webpack_require__(439);
	var ReactDOMTreeTraversal = __webpack_require__(440);
	var ReactDOMTextComponent = __webpack_require__(441);
	var ReactDefaultBatchingStrategy = __webpack_require__(442);
	var ReactEventListener = __webpack_require__(443);
	var ReactInjection = __webpack_require__(446);
	var ReactReconcileTransaction = __webpack_require__(447);
	var SVGDOMPropertyConfig = __webpack_require__(455);
	var SelectEventPlugin = __webpack_require__(456);
	var SimpleEventPlugin = __webpack_require__(457);
	
	var alreadyInjected = false;
	
	function inject() {
	  if (alreadyInjected) {
	    // TODO: This is currently true because these injections are shared between
	    // the client and the server package. They should be built independently
	    // and not share any injection state. Then this problem will be solved.
	    return;
	  }
	  alreadyInjected = true;
	
	  ReactInjection.EventEmitter.injectReactEventListener(ReactEventListener);
	
	  /**
	   * Inject modules for resolving DOM hierarchy and plugin ordering.
	   */
	  ReactInjection.EventPluginHub.injectEventPluginOrder(DefaultEventPluginOrder);
	  ReactInjection.EventPluginUtils.injectComponentTree(ReactDOMComponentTree);
	  ReactInjection.EventPluginUtils.injectTreeTraversal(ReactDOMTreeTraversal);
	
	  /**
	   * Some important event plugins included by default (without having to require
	   * them).
	   */
	  ReactInjection.EventPluginHub.injectEventPluginsByName({
	    SimpleEventPlugin: SimpleEventPlugin,
	    EnterLeaveEventPlugin: EnterLeaveEventPlugin,
	    ChangeEventPlugin: ChangeEventPlugin,
	    SelectEventPlugin: SelectEventPlugin,
	    BeforeInputEventPlugin: BeforeInputEventPlugin
	  });
	
	  ReactInjection.HostComponent.injectGenericComponentClass(ReactDOMComponent);
	
	  ReactInjection.HostComponent.injectTextComponentClass(ReactDOMTextComponent);
	
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(ARIADOMPropertyConfig);
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(HTMLDOMPropertyConfig);
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(SVGDOMPropertyConfig);
	
	  ReactInjection.EmptyComponent.injectEmptyComponentFactory(function (instantiate) {
	    return new ReactDOMEmptyComponent(instantiate);
	  });
	
	  ReactInjection.Updates.injectReconcileTransaction(ReactReconcileTransaction);
	  ReactInjection.Updates.injectBatchingStrategy(ReactDefaultBatchingStrategy);
	
	  ReactInjection.Component.injectEnvironment(ReactComponentBrowserEnvironment);
	}
	
	module.exports = {
	  inject: inject
	};

/***/ }),
/* 340 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ARIADOMPropertyConfig = {
	  Properties: {
	    // Global States and Properties
	    'aria-current': 0, // state
	    'aria-details': 0,
	    'aria-disabled': 0, // state
	    'aria-hidden': 0, // state
	    'aria-invalid': 0, // state
	    'aria-keyshortcuts': 0,
	    'aria-label': 0,
	    'aria-roledescription': 0,
	    // Widget Attributes
	    'aria-autocomplete': 0,
	    'aria-checked': 0,
	    'aria-expanded': 0,
	    'aria-haspopup': 0,
	    'aria-level': 0,
	    'aria-modal': 0,
	    'aria-multiline': 0,
	    'aria-multiselectable': 0,
	    'aria-orientation': 0,
	    'aria-placeholder': 0,
	    'aria-pressed': 0,
	    'aria-readonly': 0,
	    'aria-required': 0,
	    'aria-selected': 0,
	    'aria-sort': 0,
	    'aria-valuemax': 0,
	    'aria-valuemin': 0,
	    'aria-valuenow': 0,
	    'aria-valuetext': 0,
	    // Live Region Attributes
	    'aria-atomic': 0,
	    'aria-busy': 0,
	    'aria-live': 0,
	    'aria-relevant': 0,
	    // Drag-and-Drop Attributes
	    'aria-dropeffect': 0,
	    'aria-grabbed': 0,
	    // Relationship Attributes
	    'aria-activedescendant': 0,
	    'aria-colcount': 0,
	    'aria-colindex': 0,
	    'aria-colspan': 0,
	    'aria-controls': 0,
	    'aria-describedby': 0,
	    'aria-errormessage': 0,
	    'aria-flowto': 0,
	    'aria-labelledby': 0,
	    'aria-owns': 0,
	    'aria-posinset': 0,
	    'aria-rowcount': 0,
	    'aria-rowindex': 0,
	    'aria-rowspan': 0,
	    'aria-setsize': 0
	  },
	  DOMAttributeNames: {},
	  DOMPropertyNames: {}
	};
	
	module.exports = ARIADOMPropertyConfig;

/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var EventPropagators = __webpack_require__(342);
	var ExecutionEnvironment = __webpack_require__(351);
	var FallbackCompositionState = __webpack_require__(352);
	var SyntheticCompositionEvent = __webpack_require__(355);
	var SyntheticInputEvent = __webpack_require__(357);
	
	var END_KEYCODES = [9, 13, 27, 32]; // Tab, Return, Esc, Space
	var START_KEYCODE = 229;
	
	var canUseCompositionEvent = ExecutionEnvironment.canUseDOM && 'CompositionEvent' in window;
	
	var documentMode = null;
	if (ExecutionEnvironment.canUseDOM && 'documentMode' in document) {
	  documentMode = document.documentMode;
	}
	
	// Webkit offers a very useful `textInput` event that can be used to
	// directly represent `beforeInput`. The IE `textinput` event is not as
	// useful, so we don't use it.
	var canUseTextInputEvent = ExecutionEnvironment.canUseDOM && 'TextEvent' in window && !documentMode && !isPresto();
	
	// In IE9+, we have access to composition events, but the data supplied
	// by the native compositionend event may be incorrect. Japanese ideographic
	// spaces, for instance (\u3000) are not recorded correctly.
	var useFallbackCompositionData = ExecutionEnvironment.canUseDOM && (!canUseCompositionEvent || documentMode && documentMode > 8 && documentMode <= 11);
	
	/**
	 * Opera <= 12 includes TextEvent in window, but does not fire
	 * text input events. Rely on keypress instead.
	 */
	function isPresto() {
	  var opera = window.opera;
	  return typeof opera === 'object' && typeof opera.version === 'function' && parseInt(opera.version(), 10) <= 12;
	}
	
	var SPACEBAR_CODE = 32;
	var SPACEBAR_CHAR = String.fromCharCode(SPACEBAR_CODE);
	
	// Events and their corresponding property names.
	var eventTypes = {
	  beforeInput: {
	    phasedRegistrationNames: {
	      bubbled: 'onBeforeInput',
	      captured: 'onBeforeInputCapture'
	    },
	    dependencies: ['topCompositionEnd', 'topKeyPress', 'topTextInput', 'topPaste']
	  },
	  compositionEnd: {
	    phasedRegistrationNames: {
	      bubbled: 'onCompositionEnd',
	      captured: 'onCompositionEndCapture'
	    },
	    dependencies: ['topBlur', 'topCompositionEnd', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
	  },
	  compositionStart: {
	    phasedRegistrationNames: {
	      bubbled: 'onCompositionStart',
	      captured: 'onCompositionStartCapture'
	    },
	    dependencies: ['topBlur', 'topCompositionStart', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
	  },
	  compositionUpdate: {
	    phasedRegistrationNames: {
	      bubbled: 'onCompositionUpdate',
	      captured: 'onCompositionUpdateCapture'
	    },
	    dependencies: ['topBlur', 'topCompositionUpdate', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
	  }
	};
	
	// Track whether we've ever handled a keypress on the space key.
	var hasSpaceKeypress = false;
	
	/**
	 * Return whether a native keypress event is assumed to be a command.
	 * This is required because Firefox fires `keypress` events for key commands
	 * (cut, copy, select-all, etc.) even though no character is inserted.
	 */
	function isKeypressCommand(nativeEvent) {
	  return (nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) &&
	  // ctrlKey && altKey is equivalent to AltGr, and is not a command.
	  !(nativeEvent.ctrlKey && nativeEvent.altKey);
	}
	
	/**
	 * Translate native top level events into event types.
	 *
	 * @param {string} topLevelType
	 * @return {object}
	 */
	function getCompositionEventType(topLevelType) {
	  switch (topLevelType) {
	    case 'topCompositionStart':
	      return eventTypes.compositionStart;
	    case 'topCompositionEnd':
	      return eventTypes.compositionEnd;
	    case 'topCompositionUpdate':
	      return eventTypes.compositionUpdate;
	  }
	}
	
	/**
	 * Does our fallback best-guess model think this event signifies that
	 * composition has begun?
	 *
	 * @param {string} topLevelType
	 * @param {object} nativeEvent
	 * @return {boolean}
	 */
	function isFallbackCompositionStart(topLevelType, nativeEvent) {
	  return topLevelType === 'topKeyDown' && nativeEvent.keyCode === START_KEYCODE;
	}
	
	/**
	 * Does our fallback mode think that this event is the end of composition?
	 *
	 * @param {string} topLevelType
	 * @param {object} nativeEvent
	 * @return {boolean}
	 */
	function isFallbackCompositionEnd(topLevelType, nativeEvent) {
	  switch (topLevelType) {
	    case 'topKeyUp':
	      // Command keys insert or clear IME input.
	      return END_KEYCODES.indexOf(nativeEvent.keyCode) !== -1;
	    case 'topKeyDown':
	      // Expect IME keyCode on each keydown. If we get any other
	      // code we must have exited earlier.
	      return nativeEvent.keyCode !== START_KEYCODE;
	    case 'topKeyPress':
	    case 'topMouseDown':
	    case 'topBlur':
	      // Events are not possible without cancelling IME.
	      return true;
	    default:
	      return false;
	  }
	}
	
	/**
	 * Google Input Tools provides composition data via a CustomEvent,
	 * with the `data` property populated in the `detail` object. If this
	 * is available on the event object, use it. If not, this is a plain
	 * composition event and we have nothing special to extract.
	 *
	 * @param {object} nativeEvent
	 * @return {?string}
	 */
	function getDataFromCustomEvent(nativeEvent) {
	  var detail = nativeEvent.detail;
	  if (typeof detail === 'object' && 'data' in detail) {
	    return detail.data;
	  }
	  return null;
	}
	
	// Track the current IME composition fallback object, if any.
	var currentComposition = null;
	
	/**
	 * @return {?object} A SyntheticCompositionEvent.
	 */
	function extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	  var eventType;
	  var fallbackData;
	
	  if (canUseCompositionEvent) {
	    eventType = getCompositionEventType(topLevelType);
	  } else if (!currentComposition) {
	    if (isFallbackCompositionStart(topLevelType, nativeEvent)) {
	      eventType = eventTypes.compositionStart;
	    }
	  } else if (isFallbackCompositionEnd(topLevelType, nativeEvent)) {
	    eventType = eventTypes.compositionEnd;
	  }
	
	  if (!eventType) {
	    return null;
	  }
	
	  if (useFallbackCompositionData) {
	    // The current composition is stored statically and must not be
	    // overwritten while composition continues.
	    if (!currentComposition && eventType === eventTypes.compositionStart) {
	      currentComposition = FallbackCompositionState.getPooled(nativeEventTarget);
	    } else if (eventType === eventTypes.compositionEnd) {
	      if (currentComposition) {
	        fallbackData = currentComposition.getData();
	      }
	    }
	  }
	
	  var event = SyntheticCompositionEvent.getPooled(eventType, targetInst, nativeEvent, nativeEventTarget);
	
	  if (fallbackData) {
	    // Inject data generated from fallback path into the synthetic event.
	    // This matches the property of native CompositionEventInterface.
	    event.data = fallbackData;
	  } else {
	    var customData = getDataFromCustomEvent(nativeEvent);
	    if (customData !== null) {
	      event.data = customData;
	    }
	  }
	
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	
	/**
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?string} The string corresponding to this `beforeInput` event.
	 */
	function getNativeBeforeInputChars(topLevelType, nativeEvent) {
	  switch (topLevelType) {
	    case 'topCompositionEnd':
	      return getDataFromCustomEvent(nativeEvent);
	    case 'topKeyPress':
	      /**
	       * If native `textInput` events are available, our goal is to make
	       * use of them. However, there is a special case: the spacebar key.
	       * In Webkit, preventing default on a spacebar `textInput` event
	       * cancels character insertion, but it *also* causes the browser
	       * to fall back to its default spacebar behavior of scrolling the
	       * page.
	       *
	       * Tracking at:
	       * https://code.google.com/p/chromium/issues/detail?id=355103
	       *
	       * To avoid this issue, use the keypress event as if no `textInput`
	       * event is available.
	       */
	      var which = nativeEvent.which;
	      if (which !== SPACEBAR_CODE) {
	        return null;
	      }
	
	      hasSpaceKeypress = true;
	      return SPACEBAR_CHAR;
	
	    case 'topTextInput':
	      // Record the characters to be added to the DOM.
	      var chars = nativeEvent.data;
	
	      // If it's a spacebar character, assume that we have already handled
	      // it at the keypress level and bail immediately. Android Chrome
	      // doesn't give us keycodes, so we need to blacklist it.
	      if (chars === SPACEBAR_CHAR && hasSpaceKeypress) {
	        return null;
	      }
	
	      return chars;
	
	    default:
	      // For other native event types, do nothing.
	      return null;
	  }
	}
	
	/**
	 * For browsers that do not provide the `textInput` event, extract the
	 * appropriate string to use for SyntheticInputEvent.
	 *
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?string} The fallback string for this `beforeInput` event.
	 */
	function getFallbackBeforeInputChars(topLevelType, nativeEvent) {
	  // If we are currently composing (IME) and using a fallback to do so,
	  // try to extract the composed characters from the fallback object.
	  // If composition event is available, we extract a string only at
	  // compositionevent, otherwise extract it at fallback events.
	  if (currentComposition) {
	    if (topLevelType === 'topCompositionEnd' || !canUseCompositionEvent && isFallbackCompositionEnd(topLevelType, nativeEvent)) {
	      var chars = currentComposition.getData();
	      FallbackCompositionState.release(currentComposition);
	      currentComposition = null;
	      return chars;
	    }
	    return null;
	  }
	
	  switch (topLevelType) {
	    case 'topPaste':
	      // If a paste event occurs after a keypress, throw out the input
	      // chars. Paste events should not lead to BeforeInput events.
	      return null;
	    case 'topKeyPress':
	      /**
	       * As of v27, Firefox may fire keypress events even when no character
	       * will be inserted. A few possibilities:
	       *
	       * - `which` is `0`. Arrow keys, Esc key, etc.
	       *
	       * - `which` is the pressed key code, but no char is available.
	       *   Ex: 'AltGr + d` in Polish. There is no modified character for
	       *   this key combination and no character is inserted into the
	       *   document, but FF fires the keypress for char code `100` anyway.
	       *   No `input` event will occur.
	       *
	       * - `which` is the pressed key code, but a command combination is
	       *   being used. Ex: `Cmd+C`. No character is inserted, and no
	       *   `input` event will occur.
	       */
	      if (nativeEvent.which && !isKeypressCommand(nativeEvent)) {
	        return String.fromCharCode(nativeEvent.which);
	      }
	      return null;
	    case 'topCompositionEnd':
	      return useFallbackCompositionData ? null : nativeEvent.data;
	    default:
	      return null;
	  }
	}
	
	/**
	 * Extract a SyntheticInputEvent for `beforeInput`, based on either native
	 * `textInput` or fallback behavior.
	 *
	 * @return {?object} A SyntheticInputEvent.
	 */
	function extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	  var chars;
	
	  if (canUseTextInputEvent) {
	    chars = getNativeBeforeInputChars(topLevelType, nativeEvent);
	  } else {
	    chars = getFallbackBeforeInputChars(topLevelType, nativeEvent);
	  }
	
	  // If no characters are being inserted, no BeforeInput event should
	  // be fired.
	  if (!chars) {
	    return null;
	  }
	
	  var event = SyntheticInputEvent.getPooled(eventTypes.beforeInput, targetInst, nativeEvent, nativeEventTarget);
	
	  event.data = chars;
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	
	/**
	 * Create an `onBeforeInput` event to match
	 * http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105/#events-inputevents.
	 *
	 * This event plugin is based on the native `textInput` event
	 * available in Chrome, Safari, Opera, and IE. This event fires after
	 * `onKeyPress` and `onCompositionEnd`, but before `onInput`.
	 *
	 * `beforeInput` is spec'd but not implemented in any browsers, and
	 * the `input` event does not provide any useful information about what has
	 * actually been added, contrary to the spec. Thus, `textInput` is the best
	 * available event to identify the characters that have actually been inserted
	 * into the target node.
	 *
	 * This plugin is also responsible for emitting `composition` events, thus
	 * allowing us to share composition fallback code for both `beforeInput` and
	 * `composition` event types.
	 */
	var BeforeInputEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    return [extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget), extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget)];
	  }
	};
	
	module.exports = BeforeInputEventPlugin;

/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(343);
	var EventPluginUtils = __webpack_require__(345);
	
	var accumulateInto = __webpack_require__(349);
	var forEachAccumulated = __webpack_require__(350);
	var warning = __webpack_require__(347);
	
	var getListener = EventPluginHub.getListener;
	
	/**
	 * Some event types have a notion of different registration names for different
	 * "phases" of propagation. This finds listeners by a given phase.
	 */
	function listenerAtPhase(inst, event, propagationPhase) {
	  var registrationName = event.dispatchConfig.phasedRegistrationNames[propagationPhase];
	  return getListener(inst, registrationName);
	}
	
	/**
	 * Tags a `SyntheticEvent` with dispatched listeners. Creating this function
	 * here, allows us to not have to bind or create functions for each event.
	 * Mutating the event's members allows us to not have to create a wrapping
	 * "dispatch" object that pairs the event with the listener.
	 */
	function accumulateDirectionalDispatches(inst, phase, event) {
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(inst, 'Dispatching inst must not be null') : void 0;
	  }
	  var listener = listenerAtPhase(inst, event, phase);
	  if (listener) {
	    event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
	    event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
	  }
	}
	
	/**
	 * Collect dispatches (must be entirely collected before dispatching - see unit
	 * tests). Lazily allocate the array to conserve memory.  We must loop through
	 * each event and perform the traversal for each one. We cannot perform a
	 * single traversal for the entire collection of events because each event may
	 * have a different target.
	 */
	function accumulateTwoPhaseDispatchesSingle(event) {
	  if (event && event.dispatchConfig.phasedRegistrationNames) {
	    EventPluginUtils.traverseTwoPhase(event._targetInst, accumulateDirectionalDispatches, event);
	  }
	}
	
	/**
	 * Same as `accumulateTwoPhaseDispatchesSingle`, but skips over the targetID.
	 */
	function accumulateTwoPhaseDispatchesSingleSkipTarget(event) {
	  if (event && event.dispatchConfig.phasedRegistrationNames) {
	    var targetInst = event._targetInst;
	    var parentInst = targetInst ? EventPluginUtils.getParentInstance(targetInst) : null;
	    EventPluginUtils.traverseTwoPhase(parentInst, accumulateDirectionalDispatches, event);
	  }
	}
	
	/**
	 * Accumulates without regard to direction, does not look for phased
	 * registration names. Same as `accumulateDirectDispatchesSingle` but without
	 * requiring that the `dispatchMarker` be the same as the dispatched ID.
	 */
	function accumulateDispatches(inst, ignoredDirection, event) {
	  if (event && event.dispatchConfig.registrationName) {
	    var registrationName = event.dispatchConfig.registrationName;
	    var listener = getListener(inst, registrationName);
	    if (listener) {
	      event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
	      event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
	    }
	  }
	}
	
	/**
	 * Accumulates dispatches on an `SyntheticEvent`, but only for the
	 * `dispatchMarker`.
	 * @param {SyntheticEvent} event
	 */
	function accumulateDirectDispatchesSingle(event) {
	  if (event && event.dispatchConfig.registrationName) {
	    accumulateDispatches(event._targetInst, null, event);
	  }
	}
	
	function accumulateTwoPhaseDispatches(events) {
	  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingle);
	}
	
	function accumulateTwoPhaseDispatchesSkipTarget(events) {
	  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingleSkipTarget);
	}
	
	function accumulateEnterLeaveDispatches(leave, enter, from, to) {
	  EventPluginUtils.traverseEnterLeave(from, to, accumulateDispatches, leave, enter);
	}
	
	function accumulateDirectDispatches(events) {
	  forEachAccumulated(events, accumulateDirectDispatchesSingle);
	}
	
	/**
	 * A small set of propagation patterns, each of which will accept a small amount
	 * of information, and generate a set of "dispatch ready event objects" - which
	 * are sets of events that have already been annotated with a set of dispatched
	 * listener functions/ids. The API is designed this way to discourage these
	 * propagation strategies from actually executing the dispatches, since we
	 * always want to collect the entire set of dispatches before executing event a
	 * single one.
	 *
	 * @constructor EventPropagators
	 */
	var EventPropagators = {
	  accumulateTwoPhaseDispatches: accumulateTwoPhaseDispatches,
	  accumulateTwoPhaseDispatchesSkipTarget: accumulateTwoPhaseDispatchesSkipTarget,
	  accumulateDirectDispatches: accumulateDirectDispatches,
	  accumulateEnterLeaveDispatches: accumulateEnterLeaveDispatches
	};
	
	module.exports = EventPropagators;

/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(335);
	
	var EventPluginRegistry = __webpack_require__(344);
	var EventPluginUtils = __webpack_require__(345);
	var ReactErrorUtils = __webpack_require__(346);
	
	var accumulateInto = __webpack_require__(349);
	var forEachAccumulated = __webpack_require__(350);
	var invariant = __webpack_require__(337);
	
	/**
	 * Internal store for event listeners
	 */
	var listenerBank = {};
	
	/**
	 * Internal queue of events that have accumulated their dispatches and are
	 * waiting to have their dispatches executed.
	 */
	var eventQueue = null;
	
	/**
	 * Dispatches an event and releases it back into the pool, unless persistent.
	 *
	 * @param {?object} event Synthetic event to be dispatched.
	 * @param {boolean} simulated If the event is simulated (changes exn behavior)
	 * @private
	 */
	var executeDispatchesAndRelease = function (event, simulated) {
	  if (event) {
	    EventPluginUtils.executeDispatchesInOrder(event, simulated);
	
	    if (!event.isPersistent()) {
	      event.constructor.release(event);
	    }
	  }
	};
	var executeDispatchesAndReleaseSimulated = function (e) {
	  return executeDispatchesAndRelease(e, true);
	};
	var executeDispatchesAndReleaseTopLevel = function (e) {
	  return executeDispatchesAndRelease(e, false);
	};
	
	var getDictionaryKey = function (inst) {
	  // Prevents V8 performance issue:
	  // https://github.com/facebook/react/pull/7232
	  return '.' + inst._rootNodeID;
	};
	
	function isInteractive(tag) {
	  return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
	}
	
	function shouldPreventMouseEvent(name, type, props) {
	  switch (name) {
	    case 'onClick':
	    case 'onClickCapture':
	    case 'onDoubleClick':
	    case 'onDoubleClickCapture':
	    case 'onMouseDown':
	    case 'onMouseDownCapture':
	    case 'onMouseMove':
	    case 'onMouseMoveCapture':
	    case 'onMouseUp':
	    case 'onMouseUpCapture':
	      return !!(props.disabled && isInteractive(type));
	    default:
	      return false;
	  }
	}
	
	/**
	 * This is a unified interface for event plugins to be installed and configured.
	 *
	 * Event plugins can implement the following properties:
	 *
	 *   `extractEvents` {function(string, DOMEventTarget, string, object): *}
	 *     Required. When a top-level event is fired, this method is expected to
	 *     extract synthetic events that will in turn be queued and dispatched.
	 *
	 *   `eventTypes` {object}
	 *     Optional, plugins that fire events must publish a mapping of registration
	 *     names that are used to register listeners. Values of this mapping must
	 *     be objects that contain `registrationName` or `phasedRegistrationNames`.
	 *
	 *   `executeDispatch` {function(object, function, string)}
	 *     Optional, allows plugins to override how an event gets dispatched. By
	 *     default, the listener is simply invoked.
	 *
	 * Each plugin that is injected into `EventsPluginHub` is immediately operable.
	 *
	 * @public
	 */
	var EventPluginHub = {
	
	  /**
	   * Methods for injecting dependencies.
	   */
	  injection: {
	
	    /**
	     * @param {array} InjectedEventPluginOrder
	     * @public
	     */
	    injectEventPluginOrder: EventPluginRegistry.injectEventPluginOrder,
	
	    /**
	     * @param {object} injectedNamesToPlugins Map from names to plugin modules.
	     */
	    injectEventPluginsByName: EventPluginRegistry.injectEventPluginsByName
	
	  },
	
	  /**
	   * Stores `listener` at `listenerBank[registrationName][key]`. Is idempotent.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @param {function} listener The callback to store.
	   */
	  putListener: function (inst, registrationName, listener) {
	    !(typeof listener === 'function') ?  false ? invariant(false, 'Expected %s listener to be a function, instead got type %s', registrationName, typeof listener) : _prodInvariant('94', registrationName, typeof listener) : void 0;
	
	    var key = getDictionaryKey(inst);
	    var bankForRegistrationName = listenerBank[registrationName] || (listenerBank[registrationName] = {});
	    bankForRegistrationName[key] = listener;
	
	    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	    if (PluginModule && PluginModule.didPutListener) {
	      PluginModule.didPutListener(inst, registrationName, listener);
	    }
	  },
	
	  /**
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @return {?function} The stored callback.
	   */
	  getListener: function (inst, registrationName) {
	    // TODO: shouldPreventMouseEvent is DOM-specific and definitely should not
	    // live here; needs to be moved to a better place soon
	    var bankForRegistrationName = listenerBank[registrationName];
	    if (shouldPreventMouseEvent(registrationName, inst._currentElement.type, inst._currentElement.props)) {
	      return null;
	    }
	    var key = getDictionaryKey(inst);
	    return bankForRegistrationName && bankForRegistrationName[key];
	  },
	
	  /**
	   * Deletes a listener from the registration bank.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   */
	  deleteListener: function (inst, registrationName) {
	    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	    if (PluginModule && PluginModule.willDeleteListener) {
	      PluginModule.willDeleteListener(inst, registrationName);
	    }
	
	    var bankForRegistrationName = listenerBank[registrationName];
	    // TODO: This should never be null -- when is it?
	    if (bankForRegistrationName) {
	      var key = getDictionaryKey(inst);
	      delete bankForRegistrationName[key];
	    }
	  },
	
	  /**
	   * Deletes all listeners for the DOM element with the supplied ID.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   */
	  deleteAllListeners: function (inst) {
	    var key = getDictionaryKey(inst);
	    for (var registrationName in listenerBank) {
	      if (!listenerBank.hasOwnProperty(registrationName)) {
	        continue;
	      }
	
	      if (!listenerBank[registrationName][key]) {
	        continue;
	      }
	
	      var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	      if (PluginModule && PluginModule.willDeleteListener) {
	        PluginModule.willDeleteListener(inst, registrationName);
	      }
	
	      delete listenerBank[registrationName][key];
	    }
	  },
	
	  /**
	   * Allows registered plugins an opportunity to extract events from top-level
	   * native browser events.
	   *
	   * @return {*} An accumulation of synthetic events.
	   * @internal
	   */
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var events;
	    var plugins = EventPluginRegistry.plugins;
	    for (var i = 0; i < plugins.length; i++) {
	      // Not every plugin in the ordering may be loaded at runtime.
	      var possiblePlugin = plugins[i];
	      if (possiblePlugin) {
	        var extractedEvents = possiblePlugin.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
	        if (extractedEvents) {
	          events = accumulateInto(events, extractedEvents);
	        }
	      }
	    }
	    return events;
	  },
	
	  /**
	   * Enqueues a synthetic event that should be dispatched when
	   * `processEventQueue` is invoked.
	   *
	   * @param {*} events An accumulation of synthetic events.
	   * @internal
	   */
	  enqueueEvents: function (events) {
	    if (events) {
	      eventQueue = accumulateInto(eventQueue, events);
	    }
	  },
	
	  /**
	   * Dispatches all synthetic events on the event queue.
	   *
	   * @internal
	   */
	  processEventQueue: function (simulated) {
	    // Set `eventQueue` to null before processing it so that we can tell if more
	    // events get enqueued while processing.
	    var processingEventQueue = eventQueue;
	    eventQueue = null;
	    if (simulated) {
	      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseSimulated);
	    } else {
	      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseTopLevel);
	    }
	    !!eventQueue ?  false ? invariant(false, 'processEventQueue(): Additional events were enqueued while processing an event queue. Support for this has not yet been implemented.') : _prodInvariant('95') : void 0;
	    // This would be a good time to rethrow if any of the event handlers threw.
	    ReactErrorUtils.rethrowCaughtError();
	  },
	
	  /**
	   * These are needed for tests only. Do not use!
	   */
	  __purge: function () {
	    listenerBank = {};
	  },
	
	  __getListenerBank: function () {
	    return listenerBank;
	  }
	
	};
	
	module.exports = EventPluginHub;

/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(335);
	
	var invariant = __webpack_require__(337);
	
	/**
	 * Injectable ordering of event plugins.
	 */
	var eventPluginOrder = null;
	
	/**
	 * Injectable mapping from names to event plugin modules.
	 */
	var namesToPlugins = {};
	
	/**
	 * Recomputes the plugin list using the injected plugins and plugin ordering.
	 *
	 * @private
	 */
	function recomputePluginOrdering() {
	  if (!eventPluginOrder) {
	    // Wait until an `eventPluginOrder` is injected.
	    return;
	  }
	  for (var pluginName in namesToPlugins) {
	    var pluginModule = namesToPlugins[pluginName];
	    var pluginIndex = eventPluginOrder.indexOf(pluginName);
	    !(pluginIndex > -1) ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugins that do not exist in the plugin ordering, `%s`.', pluginName) : _prodInvariant('96', pluginName) : void 0;
	    if (EventPluginRegistry.plugins[pluginIndex]) {
	      continue;
	    }
	    !pluginModule.extractEvents ?  false ? invariant(false, 'EventPluginRegistry: Event plugins must implement an `extractEvents` method, but `%s` does not.', pluginName) : _prodInvariant('97', pluginName) : void 0;
	    EventPluginRegistry.plugins[pluginIndex] = pluginModule;
	    var publishedEvents = pluginModule.eventTypes;
	    for (var eventName in publishedEvents) {
	      !publishEventForPlugin(publishedEvents[eventName], pluginModule, eventName) ?  false ? invariant(false, 'EventPluginRegistry: Failed to publish event `%s` for plugin `%s`.', eventName, pluginName) : _prodInvariant('98', eventName, pluginName) : void 0;
	    }
	  }
	}
	
	/**
	 * Publishes an event so that it can be dispatched by the supplied plugin.
	 *
	 * @param {object} dispatchConfig Dispatch configuration for the event.
	 * @param {object} PluginModule Plugin publishing the event.
	 * @return {boolean} True if the event was successfully published.
	 * @private
	 */
	function publishEventForPlugin(dispatchConfig, pluginModule, eventName) {
	  !!EventPluginRegistry.eventNameDispatchConfigs.hasOwnProperty(eventName) ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same event name, `%s`.', eventName) : _prodInvariant('99', eventName) : void 0;
	  EventPluginRegistry.eventNameDispatchConfigs[eventName] = dispatchConfig;
	
	  var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
	  if (phasedRegistrationNames) {
	    for (var phaseName in phasedRegistrationNames) {
	      if (phasedRegistrationNames.hasOwnProperty(phaseName)) {
	        var phasedRegistrationName = phasedRegistrationNames[phaseName];
	        publishRegistrationName(phasedRegistrationName, pluginModule, eventName);
	      }
	    }
	    return true;
	  } else if (dispatchConfig.registrationName) {
	    publishRegistrationName(dispatchConfig.registrationName, pluginModule, eventName);
	    return true;
	  }
	  return false;
	}
	
	/**
	 * Publishes a registration name that is used to identify dispatched events and
	 * can be used with `EventPluginHub.putListener` to register listeners.
	 *
	 * @param {string} registrationName Registration name to add.
	 * @param {object} PluginModule Plugin publishing the event.
	 * @private
	 */
	function publishRegistrationName(registrationName, pluginModule, eventName) {
	  !!EventPluginRegistry.registrationNameModules[registrationName] ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same registration name, `%s`.', registrationName) : _prodInvariant('100', registrationName) : void 0;
	  EventPluginRegistry.registrationNameModules[registrationName] = pluginModule;
	  EventPluginRegistry.registrationNameDependencies[registrationName] = pluginModule.eventTypes[eventName].dependencies;
	
	  if (false) {
	    var lowerCasedName = registrationName.toLowerCase();
	    EventPluginRegistry.possibleRegistrationNames[lowerCasedName] = registrationName;
	
	    if (registrationName === 'onDoubleClick') {
	      EventPluginRegistry.possibleRegistrationNames.ondblclick = registrationName;
	    }
	  }
	}
	
	/**
	 * Registers plugins so that they can extract and dispatch events.
	 *
	 * @see {EventPluginHub}
	 */
	var EventPluginRegistry = {
	
	  /**
	   * Ordered list of injected plugins.
	   */
	  plugins: [],
	
	  /**
	   * Mapping from event name to dispatch config
	   */
	  eventNameDispatchConfigs: {},
	
	  /**
	   * Mapping from registration name to plugin module
	   */
	  registrationNameModules: {},
	
	  /**
	   * Mapping from registration name to event name
	   */
	  registrationNameDependencies: {},
	
	  /**
	   * Mapping from lowercase registration names to the properly cased version,
	   * used to warn in the case of missing event handlers. Available
	   * only in __DEV__.
	   * @type {Object}
	   */
	  possibleRegistrationNames:  false ? {} : null,
	  // Trust the developer to only use possibleRegistrationNames in __DEV__
	
	  /**
	   * Injects an ordering of plugins (by plugin name). This allows the ordering
	   * to be decoupled from injection of the actual plugins so that ordering is
	   * always deterministic regardless of packaging, on-the-fly injection, etc.
	   *
	   * @param {array} InjectedEventPluginOrder
	   * @internal
	   * @see {EventPluginHub.injection.injectEventPluginOrder}
	   */
	  injectEventPluginOrder: function (injectedEventPluginOrder) {
	    !!eventPluginOrder ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugin ordering more than once. You are likely trying to load more than one copy of React.') : _prodInvariant('101') : void 0;
	    // Clone the ordering so it cannot be dynamically mutated.
	    eventPluginOrder = Array.prototype.slice.call(injectedEventPluginOrder);
	    recomputePluginOrdering();
	  },
	
	  /**
	   * Injects plugins to be used by `EventPluginHub`. The plugin names must be
	   * in the ordering injected by `injectEventPluginOrder`.
	   *
	   * Plugins can be injected as part of page initialization or on-the-fly.
	   *
	   * @param {object} injectedNamesToPlugins Map from names to plugin modules.
	   * @internal
	   * @see {EventPluginHub.injection.injectEventPluginsByName}
	   */
	  injectEventPluginsByName: function (injectedNamesToPlugins) {
	    var isOrderingDirty = false;
	    for (var pluginName in injectedNamesToPlugins) {
	      if (!injectedNamesToPlugins.hasOwnProperty(pluginName)) {
	        continue;
	      }
	      var pluginModule = injectedNamesToPlugins[pluginName];
	      if (!namesToPlugins.hasOwnProperty(pluginName) || namesToPlugins[pluginName] !== pluginModule) {
	        !!namesToPlugins[pluginName] ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject two different event plugins using the same name, `%s`.', pluginName) : _prodInvariant('102', pluginName) : void 0;
	        namesToPlugins[pluginName] = pluginModule;
	        isOrderingDirty = true;
	      }
	    }
	    if (isOrderingDirty) {
	      recomputePluginOrdering();
	    }
	  },
	
	  /**
	   * Looks up the plugin for the supplied event.
	   *
	   * @param {object} event A synthetic event.
	   * @return {?object} The plugin that created the supplied event.
	   * @internal
	   */
	  getPluginModuleForEvent: function (event) {
	    var dispatchConfig = event.dispatchConfig;
	    if (dispatchConfig.registrationName) {
	      return EventPluginRegistry.registrationNameModules[dispatchConfig.registrationName] || null;
	    }
	    if (dispatchConfig.phasedRegistrationNames !== undefined) {
	      // pulling phasedRegistrationNames out of dispatchConfig helps Flow see
	      // that it is not undefined.
	      var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
	
	      for (var phase in phasedRegistrationNames) {
	        if (!phasedRegistrationNames.hasOwnProperty(phase)) {
	          continue;
	        }
	        var pluginModule = EventPluginRegistry.registrationNameModules[phasedRegistrationNames[phase]];
	        if (pluginModule) {
	          return pluginModule;
	        }
	      }
	    }
	    return null;
	  },
	
	  /**
	   * Exposed for unit testing.
	   * @private
	   */
	  _resetEventPlugins: function () {
	    eventPluginOrder = null;
	    for (var pluginName in namesToPlugins) {
	      if (namesToPlugins.hasOwnProperty(pluginName)) {
	        delete namesToPlugins[pluginName];
	      }
	    }
	    EventPluginRegistry.plugins.length = 0;
	
	    var eventNameDispatchConfigs = EventPluginRegistry.eventNameDispatchConfigs;
	    for (var eventName in eventNameDispatchConfigs) {
	      if (eventNameDispatchConfigs.hasOwnProperty(eventName)) {
	        delete eventNameDispatchConfigs[eventName];
	      }
	    }
	
	    var registrationNameModules = EventPluginRegistry.registrationNameModules;
	    for (var registrationName in registrationNameModules) {
	      if (registrationNameModules.hasOwnProperty(registrationName)) {
	        delete registrationNameModules[registrationName];
	      }
	    }
	
	    if (false) {
	      var possibleRegistrationNames = EventPluginRegistry.possibleRegistrationNames;
	      for (var lowerCasedName in possibleRegistrationNames) {
	        if (possibleRegistrationNames.hasOwnProperty(lowerCasedName)) {
	          delete possibleRegistrationNames[lowerCasedName];
	        }
	      }
	    }
	  }
	
	};
	
	module.exports = EventPluginRegistry;

/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(335);
	
	var ReactErrorUtils = __webpack_require__(346);
	
	var invariant = __webpack_require__(337);
	var warning = __webpack_require__(347);
	
	/**
	 * Injected dependencies:
	 */
	
	/**
	 * - `ComponentTree`: [required] Module that can convert between React instances
	 *   and actual node references.
	 */
	var ComponentTree;
	var TreeTraversal;
	var injection = {
	  injectComponentTree: function (Injected) {
	    ComponentTree = Injected;
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.getNodeFromInstance && Injected.getInstanceFromNode, 'EventPluginUtils.injection.injectComponentTree(...): Injected ' + 'module is missing getNodeFromInstance or getInstanceFromNode.') : void 0;
	    }
	  },
	  injectTreeTraversal: function (Injected) {
	    TreeTraversal = Injected;
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.isAncestor && Injected.getLowestCommonAncestor, 'EventPluginUtils.injection.injectTreeTraversal(...): Injected ' + 'module is missing isAncestor or getLowestCommonAncestor.') : void 0;
	    }
	  }
	};
	
	function isEndish(topLevelType) {
	  return topLevelType === 'topMouseUp' || topLevelType === 'topTouchEnd' || topLevelType === 'topTouchCancel';
	}
	
	function isMoveish(topLevelType) {
	  return topLevelType === 'topMouseMove' || topLevelType === 'topTouchMove';
	}
	function isStartish(topLevelType) {
	  return topLevelType === 'topMouseDown' || topLevelType === 'topTouchStart';
	}
	
	var validateEventDispatches;
	if (false) {
	  validateEventDispatches = function (event) {
	    var dispatchListeners = event._dispatchListeners;
	    var dispatchInstances = event._dispatchInstances;
	
	    var listenersIsArr = Array.isArray(dispatchListeners);
	    var listenersLen = listenersIsArr ? dispatchListeners.length : dispatchListeners ? 1 : 0;
	
	    var instancesIsArr = Array.isArray(dispatchInstances);
	    var instancesLen = instancesIsArr ? dispatchInstances.length : dispatchInstances ? 1 : 0;
	
	    process.env.NODE_ENV !== 'production' ? warning(instancesIsArr === listenersIsArr && instancesLen === listenersLen, 'EventPluginUtils: Invalid `event`.') : void 0;
	  };
	}
	
	/**
	 * Dispatch the event to the listener.
	 * @param {SyntheticEvent} event SyntheticEvent to handle
	 * @param {boolean} simulated If the event is simulated (changes exn behavior)
	 * @param {function} listener Application-level callback
	 * @param {*} inst Internal component instance
	 */
	function executeDispatch(event, simulated, listener, inst) {
	  var type = event.type || 'unknown-event';
	  event.currentTarget = EventPluginUtils.getNodeFromInstance(inst);
	  if (simulated) {
	    ReactErrorUtils.invokeGuardedCallbackWithCatch(type, listener, event);
	  } else {
	    ReactErrorUtils.invokeGuardedCallback(type, listener, event);
	  }
	  event.currentTarget = null;
	}
	
	/**
	 * Standard/simple iteration through an event's collected dispatches.
	 */
	function executeDispatchesInOrder(event, simulated) {
	  var dispatchListeners = event._dispatchListeners;
	  var dispatchInstances = event._dispatchInstances;
	  if (false) {
	    validateEventDispatches(event);
	  }
	  if (Array.isArray(dispatchListeners)) {
	    for (var i = 0; i < dispatchListeners.length; i++) {
	      if (event.isPropagationStopped()) {
	        break;
	      }
	      // Listeners and Instances are two parallel arrays that are always in sync.
	      executeDispatch(event, simulated, dispatchListeners[i], dispatchInstances[i]);
	    }
	  } else if (dispatchListeners) {
	    executeDispatch(event, simulated, dispatchListeners, dispatchInstances);
	  }
	  event._dispatchListeners = null;
	  event._dispatchInstances = null;
	}
	
	/**
	 * Standard/simple iteration through an event's collected dispatches, but stops
	 * at the first dispatch execution returning true, and returns that id.
	 *
	 * @return {?string} id of the first dispatch execution who's listener returns
	 * true, or null if no listener returned true.
	 */
	function executeDispatchesInOrderStopAtTrueImpl(event) {
	  var dispatchListeners = event._dispatchListeners;
	  var dispatchInstances = event._dispatchInstances;
	  if (false) {
	    validateEventDispatches(event);
	  }
	  if (Array.isArray(dispatchListeners)) {
	    for (var i = 0; i < dispatchListeners.length; i++) {
	      if (event.isPropagationStopped()) {
	        break;
	      }
	      // Listeners and Instances are two parallel arrays that are always in sync.
	      if (dispatchListeners[i](event, dispatchInstances[i])) {
	        return dispatchInstances[i];
	      }
	    }
	  } else if (dispatchListeners) {
	    if (dispatchListeners(event, dispatchInstances)) {
	      return dispatchInstances;
	    }
	  }
	  return null;
	}
	
	/**
	 * @see executeDispatchesInOrderStopAtTrueImpl
	 */
	function executeDispatchesInOrderStopAtTrue(event) {
	  var ret = executeDispatchesInOrderStopAtTrueImpl(event);
	  event._dispatchInstances = null;
	  event._dispatchListeners = null;
	  return ret;
	}
	
	/**
	 * Execution of a "direct" dispatch - there must be at most one dispatch
	 * accumulated on the event or it is considered an error. It doesn't really make
	 * sense for an event with multiple dispatches (bubbled) to keep track of the
	 * return values at each dispatch execution, but it does tend to make sense when
	 * dealing with "direct" dispatches.
	 *
	 * @return {*} The return value of executing the single dispatch.
	 */
	function executeDirectDispatch(event) {
	  if (false) {
	    validateEventDispatches(event);
	  }
	  var dispatchListener = event._dispatchListeners;
	  var dispatchInstance = event._dispatchInstances;
	  !!Array.isArray(dispatchListener) ?  false ? invariant(false, 'executeDirectDispatch(...): Invalid `event`.') : _prodInvariant('103') : void 0;
	  event.currentTarget = dispatchListener ? EventPluginUtils.getNodeFromInstance(dispatchInstance) : null;
	  var res = dispatchListener ? dispatchListener(event) : null;
	  event.currentTarget = null;
	  event._dispatchListeners = null;
	  event._dispatchInstances = null;
	  return res;
	}
	
	/**
	 * @param {SyntheticEvent} event
	 * @return {boolean} True iff number of dispatches accumulated is greater than 0.
	 */
	function hasDispatches(event) {
	  return !!event._dispatchListeners;
	}
	
	/**
	 * General utilities that are useful in creating custom Event Plugins.
	 */
	var EventPluginUtils = {
	  isEndish: isEndish,
	  isMoveish: isMoveish,
	  isStartish: isStartish,
	
	  executeDirectDispatch: executeDirectDispatch,
	  executeDispatchesInOrder: executeDispatchesInOrder,
	  executeDispatchesInOrderStopAtTrue: executeDispatchesInOrderStopAtTrue,
	  hasDispatches: hasDispatches,
	
	  getInstanceFromNode: function (node) {
	    return ComponentTree.getInstanceFromNode(node);
	  },
	  getNodeFromInstance: function (node) {
	    return ComponentTree.getNodeFromInstance(node);
	  },
	  isAncestor: function (a, b) {
	    return TreeTraversal.isAncestor(a, b);
	  },
	  getLowestCommonAncestor: function (a, b) {
	    return TreeTraversal.getLowestCommonAncestor(a, b);
	  },
	  getParentInstance: function (inst) {
	    return TreeTraversal.getParentInstance(inst);
	  },
	  traverseTwoPhase: function (target, fn, arg) {
	    return TreeTraversal.traverseTwoPhase(target, fn, arg);
	  },
	  traverseEnterLeave: function (from, to, fn, argFrom, argTo) {
	    return TreeTraversal.traverseEnterLeave(from, to, fn, argFrom, argTo);
	  },
	
	  injection: injection
	};
	
	module.exports = EventPluginUtils;

/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var caughtError = null;
	
	/**
	 * Call a function while guarding against errors that happens within it.
	 *
	 * @param {String} name of the guard to use for logging or debugging
	 * @param {Function} func The function to invoke
	 * @param {*} a First argument
	 * @param {*} b Second argument
	 */
	function invokeGuardedCallback(name, func, a) {
	  try {
	    func(a);
	  } catch (x) {
	    if (caughtError === null) {
	      caughtError = x;
	    }
	  }
	}
	
	var ReactErrorUtils = {
	  invokeGuardedCallback: invokeGuardedCallback,
	
	  /**
	   * Invoked by ReactTestUtils.Simulate so that any errors thrown by the event
	   * handler are sure to be rethrown by rethrowCaughtError.
	   */
	  invokeGuardedCallbackWithCatch: invokeGuardedCallback,
	
	  /**
	   * During execution of guarded functions we will capture the first error which
	   * we will rethrow to be handled by the top level error handler.
	   */
	  rethrowCaughtError: function () {
	    if (caughtError) {
	      var error = caughtError;
	      caughtError = null;
	      throw error;
	    }
	  }
	};
	
	if (false) {
	  /**
	   * To help development we can get better devtools integration by simulating a
	   * real browser event.
	   */
	  if (typeof window !== 'undefined' && typeof window.dispatchEvent === 'function' && typeof document !== 'undefined' && typeof document.createEvent === 'function') {
	    var fakeNode = document.createElement('react');
	    ReactErrorUtils.invokeGuardedCallback = function (name, func, a) {
	      var boundFunc = func.bind(null, a);
	      var evtType = 'react-' + name;
	      fakeNode.addEventListener(evtType, boundFunc, false);
	      var evt = document.createEvent('Event');
	      evt.initEvent(evtType, false, false);
	      fakeNode.dispatchEvent(evt);
	      fakeNode.removeEventListener(evtType, boundFunc, false);
	    };
	  }
	}
	
	module.exports = ReactErrorUtils;

/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(348);
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = emptyFunction;
	
	if (false) {
	  var printWarning = function printWarning(format) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    var argIndex = 0;
	    var message = 'Warning: ' + format.replace(/%s/g, function () {
	      return args[argIndex++];
	    });
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	
	  warning = function warning(condition, format) {
	    if (format === undefined) {
	      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
	    }
	
	    if (format.indexOf('Failed Composite propType: ') === 0) {
	      return; // Ignore CompositeComponent proptype check.
	    }
	
	    if (!condition) {
	      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	        args[_key2 - 2] = arguments[_key2];
	      }
	
	      printWarning.apply(undefined, [format].concat(args));
	    }
	  };
	}
	
	module.exports = warning;

/***/ }),
/* 348 */
/***/ (function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	function makeEmptyFunction(arg) {
	  return function () {
	    return arg;
	  };
	}
	
	/**
	 * This function accepts and discards inputs; it has no side effects. This is
	 * primarily useful idiomatically for overridable function endpoints which
	 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
	 */
	var emptyFunction = function emptyFunction() {};
	
	emptyFunction.thatReturns = makeEmptyFunction;
	emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
	emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
	emptyFunction.thatReturnsNull = makeEmptyFunction(null);
	emptyFunction.thatReturnsThis = function () {
	  return this;
	};
	emptyFunction.thatReturnsArgument = function (arg) {
	  return arg;
	};
	
	module.exports = emptyFunction;

/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(335);
	
	var invariant = __webpack_require__(337);
	
	/**
	 * Accumulates items that must not be null or undefined into the first one. This
	 * is used to conserve memory by avoiding array allocations, and thus sacrifices
	 * API cleanness. Since `current` can be null before being passed in and not
	 * null after this function, make sure to assign it back to `current`:
	 *
	 * `a = accumulateInto(a, b);`
	 *
	 * This API should be sparingly used. Try `accumulate` for something cleaner.
	 *
	 * @return {*|array<*>} An accumulation of items.
	 */
	
	function accumulateInto(current, next) {
	  !(next != null) ?  false ? invariant(false, 'accumulateInto(...): Accumulated items must not be null or undefined.') : _prodInvariant('30') : void 0;
	
	  if (current == null) {
	    return next;
	  }
	
	  // Both are not empty. Warning: Never call x.concat(y) when you are not
	  // certain that x is an Array (x could be a string with concat method).
	  if (Array.isArray(current)) {
	    if (Array.isArray(next)) {
	      current.push.apply(current, next);
	      return current;
	    }
	    current.push(next);
	    return current;
	  }
	
	  if (Array.isArray(next)) {
	    // A bit too dangerous to mutate `next`.
	    return [current].concat(next);
	  }
	
	  return [current, next];
	}
	
	module.exports = accumulateInto;

/***/ }),
/* 350 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * @param {array} arr an "accumulation" of items which is either an Array or
	 * a single item. Useful when paired with the `accumulate` module. This is a
	 * simple utility that allows us to reason about a collection of items, but
	 * handling the case when there is exactly one item (and we do not need to
	 * allocate an array).
	 */
	
	function forEachAccumulated(arr, cb, scope) {
	  if (Array.isArray(arr)) {
	    arr.forEach(cb, scope);
	  } else if (arr) {
	    cb.call(scope, arr);
	  }
	}
	
	module.exports = forEachAccumulated;

/***/ }),
/* 351 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	/**
	 * Simple, lightweight module assisting with the detection and context of
	 * Worker. Helps avoid circular dependencies and allows code to reason about
	 * whether or not they are in a Worker, even if they never include the main
	 * `ReactWorker` dependency.
	 */
	var ExecutionEnvironment = {
	
	  canUseDOM: canUseDOM,
	
	  canUseWorkers: typeof Worker !== 'undefined',
	
	  canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),
	
	  canUseViewport: canUseDOM && !!window.screen,
	
	  isInWorker: !canUseDOM // For now, this is true - might change in the future.
	
	};
	
	module.exports = ExecutionEnvironment;

/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(302);
	
	var PooledClass = __webpack_require__(353);
	
	var getTextContentAccessor = __webpack_require__(354);
	
	/**
	 * This helper class stores information about text content of a target node,
	 * allowing comparison of content before and after a given event.
	 *
	 * Identify the node where selection currently begins, then observe
	 * both its text content and its current position in the DOM. Since the
	 * browser may natively replace the target node during composition, we can
	 * use its position to find its replacement.
	 *
	 * @param {DOMEventTarget} root
	 */
	function FallbackCompositionState(root) {
	  this._root = root;
	  this._startText = this.getText();
	  this._fallbackText = null;
	}
	
	_assign(FallbackCompositionState.prototype, {
	  destructor: function () {
	    this._root = null;
	    this._startText = null;
	    this._fallbackText = null;
	  },
	
	  /**
	   * Get current text of input.
	   *
	   * @return {string}
	   */
	  getText: function () {
	    if ('value' in this._root) {
	      return this._root.value;
	    }
	    return this._root[getTextContentAccessor()];
	  },
	
	  /**
	   * Determine the differing substring between the initially stored
	   * text content and the current content.
	   *
	   * @return {string}
	   */
	  getData: function () {
	    if (this._fallbackText) {
	      return this._fallbackText;
	    }
	
	    var start;
	    var startValue = this._startText;
	    var startLength = startValue.length;
	    var end;
	    var endValue = this.getText();
	    var endLength = endValue.length;
	
	    for (start = 0; start < startLength; start++) {
	      if (startValue[start] !== endValue[start]) {
	        break;
	      }
	    }
	
	    var minEnd = startLength - start;
	    for (end = 1; end <= minEnd; end++) {
	      if (startValue[startLength - end] !== endValue[endLength - end]) {
	        break;
	      }
	    }
	
	    var sliceTail = end > 1 ? 1 - end : undefined;
	    this._fallbackText = endValue.slice(start, sliceTail);
	    return this._fallbackText;
	  }
	});
	
	PooledClass.addPoolingTo(FallbackCompositionState);
	
	module.exports = FallbackCompositionState;

/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(335);
	
	var invariant = __webpack_require__(337);
	
	/**
	 * Static poolers. Several custom versions for each potential number of
	 * arguments. A completely generic pooler is easy to implement, but would
	 * require accessing the `arguments` object. In each of these, `this` refers to
	 * the Class itself, not an instance. If any others are needed, simply add them
	 * here, or in their own files.
	 */
	var oneArgumentPooler = function (copyFieldsFrom) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, copyFieldsFrom);
	    return instance;
	  } else {
	    return new Klass(copyFieldsFrom);
	  }
	};
	
	var twoArgumentPooler = function (a1, a2) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2);
	    return instance;
	  } else {
	    return new Klass(a1, a2);
	  }
	};
	
	var threeArgumentPooler = function (a1, a2, a3) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3);
	  }
	};
	
	var fourArgumentPooler = function (a1, a2, a3, a4) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3, a4);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3, a4);
	  }
	};
	
	var standardReleaser = function (instance) {
	  var Klass = this;
	  !(instance instanceof Klass) ?  false ? invariant(false, 'Trying to release an instance into a pool of a different type.') : _prodInvariant('25') : void 0;
	  instance.destructor();
	  if (Klass.instancePool.length < Klass.poolSize) {
	    Klass.instancePool.push(instance);
	  }
	};
	
	var DEFAULT_POOL_SIZE = 10;
	var DEFAULT_POOLER = oneArgumentPooler;
	
	/**
	 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
	 * itself (statically) not adding any prototypical fields. Any CopyConstructor
	 * you give this may have a `poolSize` property, and will look for a
	 * prototypical `destructor` on instances.
	 *
	 * @param {Function} CopyConstructor Constructor that can be used to reset.
	 * @param {Function} pooler Customizable pooler.
	 */
	var addPoolingTo = function (CopyConstructor, pooler) {
	  // Casting as any so that flow ignores the actual implementation and trusts
	  // it to match the type we declared
	  var NewKlass = CopyConstructor;
	  NewKlass.instancePool = [];
	  NewKlass.getPooled = pooler || DEFAULT_POOLER;
	  if (!NewKlass.poolSize) {
	    NewKlass.poolSize = DEFAULT_POOL_SIZE;
	  }
	  NewKlass.release = standardReleaser;
	  return NewKlass;
	};
	
	var PooledClass = {
	  addPoolingTo: addPoolingTo,
	  oneArgumentPooler: oneArgumentPooler,
	  twoArgumentPooler: twoArgumentPooler,
	  threeArgumentPooler: threeArgumentPooler,
	  fourArgumentPooler: fourArgumentPooler
	};
	
	module.exports = PooledClass;

/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(351);
	
	var contentKey = null;
	
	/**
	 * Gets the key used to access text content on a DOM node.
	 *
	 * @return {?string} Key used to access text content.
	 * @internal
	 */
	function getTextContentAccessor() {
	  if (!contentKey && ExecutionEnvironment.canUseDOM) {
	    // Prefer textContent to innerText because many browsers support both but
	    // SVG <text> elements don't support innerText even when <div> does.
	    contentKey = 'textContent' in document.documentElement ? 'textContent' : 'innerText';
	  }
	  return contentKey;
	}
	
	module.exports = getTextContentAccessor;

/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(356);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/#events-compositionevents
	 */
	var CompositionEventInterface = {
	  data: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticCompositionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticCompositionEvent, CompositionEventInterface);
	
	module.exports = SyntheticCompositionEvent;

/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(302);
	
	var PooledClass = __webpack_require__(353);
	
	var emptyFunction = __webpack_require__(348);
	var warning = __webpack_require__(347);
	
	var didWarnForAddedNewProperty = false;
	var isProxySupported = typeof Proxy === 'function';
	
	var shouldBeReleasedProperties = ['dispatchConfig', '_targetInst', 'nativeEvent', 'isDefaultPrevented', 'isPropagationStopped', '_dispatchListeners', '_dispatchInstances'];
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var EventInterface = {
	  type: null,
	  target: null,
	  // currentTarget is set when dispatching; no use in copying it here
	  currentTarget: emptyFunction.thatReturnsNull,
	  eventPhase: null,
	  bubbles: null,
	  cancelable: null,
	  timeStamp: function (event) {
	    return event.timeStamp || Date.now();
	  },
	  defaultPrevented: null,
	  isTrusted: null
	};
	
	/**
	 * Synthetic events are dispatched by event plugins, typically in response to a
	 * top-level event delegation handler.
	 *
	 * These systems should generally use pooling to reduce the frequency of garbage
	 * collection. The system should check `isPersistent` to determine whether the
	 * event should be released into the pool after being dispatched. Users that
	 * need a persisted event should invoke `persist`.
	 *
	 * Synthetic events (and subclasses) implement the DOM Level 3 Events API by
	 * normalizing browser quirks. Subclasses do not necessarily have to implement a
	 * DOM interface; custom application-specific events can also subclass this.
	 *
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {*} targetInst Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @param {DOMEventTarget} nativeEventTarget Target node.
	 */
	function SyntheticEvent(dispatchConfig, targetInst, nativeEvent, nativeEventTarget) {
	  if (false) {
	    // these have a getter/setter for warnings
	    delete this.nativeEvent;
	    delete this.preventDefault;
	    delete this.stopPropagation;
	  }
	
	  this.dispatchConfig = dispatchConfig;
	  this._targetInst = targetInst;
	  this.nativeEvent = nativeEvent;
	
	  var Interface = this.constructor.Interface;
	  for (var propName in Interface) {
	    if (!Interface.hasOwnProperty(propName)) {
	      continue;
	    }
	    if (false) {
	      delete this[propName]; // this has a getter/setter for warnings
	    }
	    var normalize = Interface[propName];
	    if (normalize) {
	      this[propName] = normalize(nativeEvent);
	    } else {
	      if (propName === 'target') {
	        this.target = nativeEventTarget;
	      } else {
	        this[propName] = nativeEvent[propName];
	      }
	    }
	  }
	
	  var defaultPrevented = nativeEvent.defaultPrevented != null ? nativeEvent.defaultPrevented : nativeEvent.returnValue === false;
	  if (defaultPrevented) {
	    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
	  } else {
	    this.isDefaultPrevented = emptyFunction.thatReturnsFalse;
	  }
	  this.isPropagationStopped = emptyFunction.thatReturnsFalse;
	  return this;
	}
	
	_assign(SyntheticEvent.prototype, {
	
	  preventDefault: function () {
	    this.defaultPrevented = true;
	    var event = this.nativeEvent;
	    if (!event) {
	      return;
	    }
	
	    if (event.preventDefault) {
	      event.preventDefault();
	    } else if (typeof event.returnValue !== 'unknown') {
	      // eslint-disable-line valid-typeof
	      event.returnValue = false;
	    }
	    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
	  },
	
	  stopPropagation: function () {
	    var event = this.nativeEvent;
	    if (!event) {
	      return;
	    }
	
	    if (event.stopPropagation) {
	      event.stopPropagation();
	    } else if (typeof event.cancelBubble !== 'unknown') {
	      // eslint-disable-line valid-typeof
	      // The ChangeEventPlugin registers a "propertychange" event for
	      // IE. This event does not support bubbling or cancelling, and
	      // any references to cancelBubble throw "Member not found".  A
	      // typeof check of "unknown" circumvents this issue (and is also
	      // IE specific).
	      event.cancelBubble = true;
	    }
	
	    this.isPropagationStopped = emptyFunction.thatReturnsTrue;
	  },
	
	  /**
	   * We release all dispatched `SyntheticEvent`s after each event loop, adding
	   * them back into the pool. This allows a way to hold onto a reference that
	   * won't be added back into the pool.
	   */
	  persist: function () {
	    this.isPersistent = emptyFunction.thatReturnsTrue;
	  },
	
	  /**
	   * Checks if this event should be released back into the pool.
	   *
	   * @return {boolean} True if this should not be released, false otherwise.
	   */
	  isPersistent: emptyFunction.thatReturnsFalse,
	
	  /**
	   * `PooledClass` looks for `destructor` on each instance it releases.
	   */
	  destructor: function () {
	    var Interface = this.constructor.Interface;
	    for (var propName in Interface) {
	      if (false) {
	        Object.defineProperty(this, propName, getPooledWarningPropertyDefinition(propName, Interface[propName]));
	      } else {
	        this[propName] = null;
	      }
	    }
	    for (var i = 0; i < shouldBeReleasedProperties.length; i++) {
	      this[shouldBeReleasedProperties[i]] = null;
	    }
	    if (false) {
	      Object.defineProperty(this, 'nativeEvent', getPooledWarningPropertyDefinition('nativeEvent', null));
	      Object.defineProperty(this, 'preventDefault', getPooledWarningPropertyDefinition('preventDefault', emptyFunction));
	      Object.defineProperty(this, 'stopPropagation', getPooledWarningPropertyDefinition('stopPropagation', emptyFunction));
	    }
	  }
	
	});
	
	SyntheticEvent.Interface = EventInterface;
	
	if (false) {
	  if (isProxySupported) {
	    /*eslint-disable no-func-assign */
	    SyntheticEvent = new Proxy(SyntheticEvent, {
	      construct: function (target, args) {
	        return this.apply(target, Object.create(target.prototype), args);
	      },
	      apply: function (constructor, that, args) {
	        return new Proxy(constructor.apply(that, args), {
	          set: function (target, prop, value) {
	            if (prop !== 'isPersistent' && !target.constructor.Interface.hasOwnProperty(prop) && shouldBeReleasedProperties.indexOf(prop) === -1) {
	              process.env.NODE_ENV !== 'production' ? warning(didWarnForAddedNewProperty || target.isPersistent(), 'This synthetic event is reused for performance reasons. If you\'re ' + 'seeing this, you\'re adding a new property in the synthetic event object. ' + 'The property is never released. See ' + 'https://fb.me/react-event-pooling for more information.') : void 0;
	              didWarnForAddedNewProperty = true;
	            }
	            target[prop] = value;
	            return true;
	          }
	        });
	      }
	    });
	    /*eslint-enable no-func-assign */
	  }
	}
	/**
	 * Helper to reduce boilerplate when creating subclasses.
	 *
	 * @param {function} Class
	 * @param {?object} Interface
	 */
	SyntheticEvent.augmentClass = function (Class, Interface) {
	  var Super = this;
	
	  var E = function () {};
	  E.prototype = Super.prototype;
	  var prototype = new E();
	
	  _assign(prototype, Class.prototype);
	  Class.prototype = prototype;
	  Class.prototype.constructor = Class;
	
	  Class.Interface = _assign({}, Super.Interface, Interface);
	  Class.augmentClass = Super.augmentClass;
	
	  PooledClass.addPoolingTo(Class, PooledClass.fourArgumentPooler);
	};
	
	PooledClass.addPoolingTo(SyntheticEvent, PooledClass.fourArgumentPooler);
	
	module.exports = SyntheticEvent;
	
	/**
	  * Helper to nullify syntheticEvent instance properties when destructing
	  *
	  * @param {object} SyntheticEvent
	  * @param {String} propName
	  * @return {object} defineProperty object
	  */
	function getPooledWarningPropertyDefinition(propName, getVal) {
	  var isFunction = typeof getVal === 'function';
	  return {
	    configurable: true,
	    set: set,
	    get: get
	  };
	
	  function set(val) {
	    var action = isFunction ? 'setting the method' : 'setting the property';
	    warn(action, 'This is effectively a no-op');
	    return val;
	  }
	
	  function get() {
	    var action = isFunction ? 'accessing the method' : 'accessing the property';
	    var result = isFunction ? 'This is a no-op function' : 'This is set to null';
	    warn(action, result);
	    return getVal;
	  }
	
	  function warn(action, result) {
	    var warningCondition = false;
	     false ? warning(warningCondition, 'This synthetic event is reused for performance reasons. If you\'re seeing this, ' + 'you\'re %s `%s` on a released/nullified synthetic event. %s. ' + 'If you must keep the original synthetic event around, use event.persist(). ' + 'See https://fb.me/react-event-pooling for more information.', action, propName, result) : void 0;
	  }
	}

/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(356);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105
	 *      /#events-inputevents
	 */
	var InputEventInterface = {
	  data: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticInputEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticInputEvent, InputEventInterface);
	
	module.exports = SyntheticInputEvent;

/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(343);
	var EventPropagators = __webpack_require__(342);
	var ExecutionEnvironment = __webpack_require__(351);
	var ReactDOMComponentTree = __webpack_require__(334);
	var ReactUpdates = __webpack_require__(359);
	var SyntheticEvent = __webpack_require__(356);
	
	var getEventTarget = __webpack_require__(367);
	var isEventSupported = __webpack_require__(368);
	var isTextInputElement = __webpack_require__(369);
	
	var eventTypes = {
	  change: {
	    phasedRegistrationNames: {
	      bubbled: 'onChange',
	      captured: 'onChangeCapture'
	    },
	    dependencies: ['topBlur', 'topChange', 'topClick', 'topFocus', 'topInput', 'topKeyDown', 'topKeyUp', 'topSelectionChange']
	  }
	};
	
	/**
	 * For IE shims
	 */
	var activeElement = null;
	var activeElementInst = null;
	var activeElementValue = null;
	var activeElementValueProp = null;
	
	/**
	 * SECTION: handle `change` event
	 */
	function shouldUseChangeEvent(elem) {
	  var nodeName = elem.nodeName && elem.nodeName.toLowerCase();
	  return nodeName === 'select' || nodeName === 'input' && elem.type === 'file';
	}
	
	var doesChangeEventBubble = false;
	if (ExecutionEnvironment.canUseDOM) {
	  // See `handleChange` comment below
	  doesChangeEventBubble = isEventSupported('change') && (!document.documentMode || document.documentMode > 8);
	}
	
	function manualDispatchChangeEvent(nativeEvent) {
	  var event = SyntheticEvent.getPooled(eventTypes.change, activeElementInst, nativeEvent, getEventTarget(nativeEvent));
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	
	  // If change and propertychange bubbled, we'd just bind to it like all the
	  // other events and have it go through ReactBrowserEventEmitter. Since it
	  // doesn't, we manually listen for the events and so we have to enqueue and
	  // process the abstract event manually.
	  //
	  // Batching is necessary here in order to ensure that all event handlers run
	  // before the next rerender (including event handlers attached to ancestor
	  // elements instead of directly on the input). Without this, controlled
	  // components don't work properly in conjunction with event bubbling because
	  // the component is rerendered and the value reverted before all the event
	  // handlers can run. See https://github.com/facebook/react/issues/708.
	  ReactUpdates.batchedUpdates(runEventInBatch, event);
	}
	
	function runEventInBatch(event) {
	  EventPluginHub.enqueueEvents(event);
	  EventPluginHub.processEventQueue(false);
	}
	
	function startWatchingForChangeEventIE8(target, targetInst) {
	  activeElement = target;
	  activeElementInst = targetInst;
	  activeElement.attachEvent('onchange', manualDispatchChangeEvent);
	}
	
	function stopWatchingForChangeEventIE8() {
	  if (!activeElement) {
	    return;
	  }
	  activeElement.detachEvent('onchange', manualDispatchChangeEvent);
	  activeElement = null;
	  activeElementInst = null;
	}
	
	function getTargetInstForChangeEvent(topLevelType, targetInst) {
	  if (topLevelType === 'topChange') {
	    return targetInst;
	  }
	}
	function handleEventsForChangeEventIE8(topLevelType, target, targetInst) {
	  if (topLevelType === 'topFocus') {
	    // stopWatching() should be a noop here but we call it just in case we
	    // missed a blur event somehow.
	    stopWatchingForChangeEventIE8();
	    startWatchingForChangeEventIE8(target, targetInst);
	  } else if (topLevelType === 'topBlur') {
	    stopWatchingForChangeEventIE8();
	  }
	}
	
	/**
	 * SECTION: handle `input` event
	 */
	var isInputEventSupported = false;
	if (ExecutionEnvironment.canUseDOM) {
	  // IE9 claims to support the input event but fails to trigger it when
	  // deleting text, so we ignore its input events.
	  // IE10+ fire input events to often, such when a placeholder
	  // changes or when an input with a placeholder is focused.
	  isInputEventSupported = isEventSupported('input') && (!document.documentMode || document.documentMode > 11);
	}
	
	/**
	 * (For IE <=11) Replacement getter/setter for the `value` property that gets
	 * set on the active element.
	 */
	var newValueProp = {
	  get: function () {
	    return activeElementValueProp.get.call(this);
	  },
	  set: function (val) {
	    // Cast to a string so we can do equality checks.
	    activeElementValue = '' + val;
	    activeElementValueProp.set.call(this, val);
	  }
	};
	
	/**
	 * (For IE <=11) Starts tracking propertychange events on the passed-in element
	 * and override the value property so that we can distinguish user events from
	 * value changes in JS.
	 */
	function startWatchingForValueChange(target, targetInst) {
	  activeElement = target;
	  activeElementInst = targetInst;
	  activeElementValue = target.value;
	  activeElementValueProp = Object.getOwnPropertyDescriptor(target.constructor.prototype, 'value');
	
	  // Not guarded in a canDefineProperty check: IE8 supports defineProperty only
	  // on DOM elements
	  Object.defineProperty(activeElement, 'value', newValueProp);
	  if (activeElement.attachEvent) {
	    activeElement.attachEvent('onpropertychange', handlePropertyChange);
	  } else {
	    activeElement.addEventListener('propertychange', handlePropertyChange, false);
	  }
	}
	
	/**
	 * (For IE <=11) Removes the event listeners from the currently-tracked element,
	 * if any exists.
	 */
	function stopWatchingForValueChange() {
	  if (!activeElement) {
	    return;
	  }
	
	  // delete restores the original property definition
	  delete activeElement.value;
	
	  if (activeElement.detachEvent) {
	    activeElement.detachEvent('onpropertychange', handlePropertyChange);
	  } else {
	    activeElement.removeEventListener('propertychange', handlePropertyChange, false);
	  }
	
	  activeElement = null;
	  activeElementInst = null;
	  activeElementValue = null;
	  activeElementValueProp = null;
	}
	
	/**
	 * (For IE <=11) Handles a propertychange event, sending a `change` event if
	 * the value of the active element has changed.
	 */
	function handlePropertyChange(nativeEvent) {
	  if (nativeEvent.propertyName !== 'value') {
	    return;
	  }
	  var value = nativeEvent.srcElement.value;
	  if (value === activeElementValue) {
	    return;
	  }
	  activeElementValue = value;
	
	  manualDispatchChangeEvent(nativeEvent);
	}
	
	/**
	 * If a `change` event should be fired, returns the target's ID.
	 */
	function getTargetInstForInputEvent(topLevelType, targetInst) {
	  if (topLevelType === 'topInput') {
	    // In modern browsers (i.e., not IE8 or IE9), the input event is exactly
	    // what we want so fall through here and trigger an abstract event
	    return targetInst;
	  }
	}
	
	function handleEventsForInputEventIE(topLevelType, target, targetInst) {
	  if (topLevelType === 'topFocus') {
	    // In IE8, we can capture almost all .value changes by adding a
	    // propertychange handler and looking for events with propertyName
	    // equal to 'value'
	    // In IE9-11, propertychange fires for most input events but is buggy and
	    // doesn't fire when text is deleted, but conveniently, selectionchange
	    // appears to fire in all of the remaining cases so we catch those and
	    // forward the event if the value has changed
	    // In either case, we don't want to call the event handler if the value
	    // is changed from JS so we redefine a setter for `.value` that updates
	    // our activeElementValue variable, allowing us to ignore those changes
	    //
	    // stopWatching() should be a noop here but we call it just in case we
	    // missed a blur event somehow.
	    stopWatchingForValueChange();
	    startWatchingForValueChange(target, targetInst);
	  } else if (topLevelType === 'topBlur') {
	    stopWatchingForValueChange();
	  }
	}
	
	// For IE8 and IE9.
	function getTargetInstForInputEventIE(topLevelType, targetInst) {
	  if (topLevelType === 'topSelectionChange' || topLevelType === 'topKeyUp' || topLevelType === 'topKeyDown') {
	    // On the selectionchange event, the target is just document which isn't
	    // helpful for us so just check activeElement instead.
	    //
	    // 99% of the time, keydown and keyup aren't necessary. IE8 fails to fire
	    // propertychange on the first input event after setting `value` from a
	    // script and fires only keydown, keypress, keyup. Catching keyup usually
	    // gets it and catching keydown lets us fire an event for the first
	    // keystroke if user does a key repeat (it'll be a little delayed: right
	    // before the second keystroke). Other input methods (e.g., paste) seem to
	    // fire selectionchange normally.
	    if (activeElement && activeElement.value !== activeElementValue) {
	      activeElementValue = activeElement.value;
	      return activeElementInst;
	    }
	  }
	}
	
	/**
	 * SECTION: handle `click` event
	 */
	function shouldUseClickEvent(elem) {
	  // Use the `click` event to detect changes to checkbox and radio inputs.
	  // This approach works across all browsers, whereas `change` does not fire
	  // until `blur` in IE8.
	  return elem.nodeName && elem.nodeName.toLowerCase() === 'input' && (elem.type === 'checkbox' || elem.type === 'radio');
	}
	
	function getTargetInstForClickEvent(topLevelType, targetInst) {
	  if (topLevelType === 'topClick') {
	    return targetInst;
	  }
	}
	
	function handleControlledInputBlur(inst, node) {
	  // TODO: In IE, inst is occasionally null. Why?
	  if (inst == null) {
	    return;
	  }
	
	  // Fiber and ReactDOM keep wrapper state in separate places
	  var state = inst._wrapperState || node._wrapperState;
	
	  if (!state || !state.controlled || node.type !== 'number') {
	    return;
	  }
	
	  // If controlled, assign the value attribute to the current value on blur
	  var value = '' + node.value;
	  if (node.getAttribute('value') !== value) {
	    node.setAttribute('value', value);
	  }
	}
	
	/**
	 * This plugin creates an `onChange` event that normalizes change events
	 * across form elements. This event fires at a time when it's possible to
	 * change the element's value without seeing a flicker.
	 *
	 * Supported elements are:
	 * - input (see `isTextInputElement`)
	 * - textarea
	 * - select
	 */
	var ChangeEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;
	
	    var getTargetInstFunc, handleEventFunc;
	    if (shouldUseChangeEvent(targetNode)) {
	      if (doesChangeEventBubble) {
	        getTargetInstFunc = getTargetInstForChangeEvent;
	      } else {
	        handleEventFunc = handleEventsForChangeEventIE8;
	      }
	    } else if (isTextInputElement(targetNode)) {
	      if (isInputEventSupported) {
	        getTargetInstFunc = getTargetInstForInputEvent;
	      } else {
	        getTargetInstFunc = getTargetInstForInputEventIE;
	        handleEventFunc = handleEventsForInputEventIE;
	      }
	    } else if (shouldUseClickEvent(targetNode)) {
	      getTargetInstFunc = getTargetInstForClickEvent;
	    }
	
	    if (getTargetInstFunc) {
	      var inst = getTargetInstFunc(topLevelType, targetInst);
	      if (inst) {
	        var event = SyntheticEvent.getPooled(eventTypes.change, inst, nativeEvent, nativeEventTarget);
	        event.type = 'change';
	        EventPropagators.accumulateTwoPhaseDispatches(event);
	        return event;
	      }
	    }
	
	    if (handleEventFunc) {
	      handleEventFunc(topLevelType, targetNode, targetInst);
	    }
	
	    // When blurring, set the value attribute for number inputs
	    if (topLevelType === 'topBlur') {
	      handleControlledInputBlur(targetInst, targetNode);
	    }
	  }
	
	};
	
	module.exports = ChangeEventPlugin;

/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(335),
	    _assign = __webpack_require__(302);
	
	var CallbackQueue = __webpack_require__(360);
	var PooledClass = __webpack_require__(353);
	var ReactFeatureFlags = __webpack_require__(361);
	var ReactReconciler = __webpack_require__(362);
	var Transaction = __webpack_require__(366);
	
	var invariant = __webpack_require__(337);
	
	var dirtyComponents = [];
	var updateBatchNumber = 0;
	var asapCallbackQueue = CallbackQueue.getPooled();
	var asapEnqueued = false;
	
	var batchingStrategy = null;
	
	function ensureInjected() {
	  !(ReactUpdates.ReactReconcileTransaction && batchingStrategy) ?  false ? invariant(false, 'ReactUpdates: must inject a reconcile transaction class and batching strategy') : _prodInvariant('123') : void 0;
	}
	
	var NESTED_UPDATES = {
	  initialize: function () {
	    this.dirtyComponentsLength = dirtyComponents.length;
	  },
	  close: function () {
	    if (this.dirtyComponentsLength !== dirtyComponents.length) {
	      // Additional updates were enqueued by componentDidUpdate handlers or
	      // similar; before our own UPDATE_QUEUEING wrapper closes, we want to run
	      // these new updates so that if A's componentDidUpdate calls setState on
	      // B, B will update before the callback A's updater provided when calling
	      // setState.
	      dirtyComponents.splice(0, this.dirtyComponentsLength);
	      flushBatchedUpdates();
	    } else {
	      dirtyComponents.length = 0;
	    }
	  }
	};
	
	var UPDATE_QUEUEING = {
	  initialize: function () {
	    this.callbackQueue.reset();
	  },
	  close: function () {
	    this.callbackQueue.notifyAll();
	  }
	};
	
	var TRANSACTION_WRAPPERS = [NESTED_UPDATES, UPDATE_QUEUEING];
	
	function ReactUpdatesFlushTransaction() {
	  this.reinitializeTransaction();
	  this.dirtyComponentsLength = null;
	  this.callbackQueue = CallbackQueue.getPooled();
	  this.reconcileTransaction = ReactUpdates.ReactReconcileTransaction.getPooled(
	  /* useCreateElement */true);
	}
	
	_assign(ReactUpdatesFlushTransaction.prototype, Transaction, {
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  destructor: function () {
	    this.dirtyComponentsLength = null;
	    CallbackQueue.release(this.callbackQueue);
	    this.callbackQueue = null;
	    ReactUpdates.ReactReconcileTransaction.release(this.reconcileTransaction);
	    this.reconcileTransaction = null;
	  },
	
	  perform: function (method, scope, a) {
	    // Essentially calls `this.reconcileTransaction.perform(method, scope, a)`
	    // with this transaction's wrappers around it.
	    return Transaction.perform.call(this, this.reconcileTransaction.perform, this.reconcileTransaction, method, scope, a);
	  }
	});
	
	PooledClass.addPoolingTo(ReactUpdatesFlushTransaction);
	
	function batchedUpdates(callback, a, b, c, d, e) {
	  ensureInjected();
	  return batchingStrategy.batchedUpdates(callback, a, b, c, d, e);
	}
	
	/**
	 * Array comparator for ReactComponents by mount ordering.
	 *
	 * @param {ReactComponent} c1 first component you're comparing
	 * @param {ReactComponent} c2 second component you're comparing
	 * @return {number} Return value usable by Array.prototype.sort().
	 */
	function mountOrderComparator(c1, c2) {
	  return c1._mountOrder - c2._mountOrder;
	}
	
	function runBatchedUpdates(transaction) {
	  var len = transaction.dirtyComponentsLength;
	  !(len === dirtyComponents.length) ?  false ? invariant(false, 'Expected flush transaction\'s stored dirty-components length (%s) to match dirty-components array length (%s).', len, dirtyComponents.length) : _prodInvariant('124', len, dirtyComponents.length) : void 0;
	
	  // Since reconciling a component higher in the owner hierarchy usually (not
	  // always -- see shouldComponentUpdate()) will reconcile children, reconcile
	  // them before their children by sorting the array.
	  dirtyComponents.sort(mountOrderComparator);
	
	  // Any updates enqueued while reconciling must be performed after this entire
	  // batch. Otherwise, if dirtyComponents is [A, B] where A has children B and
	  // C, B could update twice in a single batch if C's render enqueues an update
	  // to B (since B would have already updated, we should skip it, and the only
	  // way we can know to do so is by checking the batch counter).
	  updateBatchNumber++;
	
	  for (var i = 0; i < len; i++) {
	    // If a component is unmounted before pending changes apply, it will still
	    // be here, but we assume that it has cleared its _pendingCallbacks and
	    // that performUpdateIfNecessary is a noop.
	    var component = dirtyComponents[i];
	
	    // If performUpdateIfNecessary happens to enqueue any new updates, we
	    // shouldn't execute the callbacks until the next render happens, so
	    // stash the callbacks first
	    var callbacks = component._pendingCallbacks;
	    component._pendingCallbacks = null;
	
	    var markerName;
	    if (ReactFeatureFlags.logTopLevelRenders) {
	      var namedComponent = component;
	      // Duck type TopLevelWrapper. This is probably always true.
	      if (component._currentElement.type.isReactTopLevelWrapper) {
	        namedComponent = component._renderedComponent;
	      }
	      markerName = 'React update: ' + namedComponent.getName();
	      console.time(markerName);
	    }
	
	    ReactReconciler.performUpdateIfNecessary(component, transaction.reconcileTransaction, updateBatchNumber);
	
	    if (markerName) {
	      console.timeEnd(markerName);
	    }
	
	    if (callbacks) {
	      for (var j = 0; j < callbacks.length; j++) {
	        transaction.callbackQueue.enqueue(callbacks[j], component.getPublicInstance());
	      }
	    }
	  }
	}
	
	var flushBatchedUpdates = function () {
	  // ReactUpdatesFlushTransaction's wrappers will clear the dirtyComponents
	  // array and perform any updates enqueued by mount-ready handlers (i.e.,
	  // componentDidUpdate) but we need to check here too in order to catch
	  // updates enqueued by setState callbacks and asap calls.
	  while (dirtyComponents.length || asapEnqueued) {
	    if (dirtyComponents.length) {
	      var transaction = ReactUpdatesFlushTransaction.getPooled();
	      transaction.perform(runBatchedUpdates, null, transaction);
	      ReactUpdatesFlushTransaction.release(transaction);
	    }
	
	    if (asapEnqueued) {
	      asapEnqueued = false;
	      var queue = asapCallbackQueue;
	      asapCallbackQueue = CallbackQueue.getPooled();
	      queue.notifyAll();
	      CallbackQueue.release(queue);
	    }
	  }
	};
	
	/**
	 * Mark a component as needing a rerender, adding an optional callback to a
	 * list of functions which will be executed once the rerender occurs.
	 */
	function enqueueUpdate(component) {
	  ensureInjected();
	
	  // Various parts of our code (such as ReactCompositeComponent's
	  // _renderValidatedComponent) assume that calls to render aren't nested;
	  // verify that that's the case. (This is called by each top-level update
	  // function, like setState, forceUpdate, etc.; creation and
	  // destruction of top-level components is guarded in ReactMount.)
	
	  if (!batchingStrategy.isBatchingUpdates) {
	    batchingStrategy.batchedUpdates(enqueueUpdate, component);
	    return;
	  }
	
	  dirtyComponents.push(component);
	  if (component._updateBatchNumber == null) {
	    component._updateBatchNumber = updateBatchNumber + 1;
	  }
	}
	
	/**
	 * Enqueue a callback to be run at the end of the current batching cycle. Throws
	 * if no updates are currently being performed.
	 */
	function asap(callback, context) {
	  !batchingStrategy.isBatchingUpdates ?  false ? invariant(false, 'ReactUpdates.asap: Can\'t enqueue an asap callback in a context whereupdates are not being batched.') : _prodInvariant('125') : void 0;
	  asapCallbackQueue.enqueue(callback, context);
	  asapEnqueued = true;
	}
	
	var ReactUpdatesInjection = {
	  injectReconcileTransaction: function (ReconcileTransaction) {
	    !ReconcileTransaction ?  false ? invariant(false, 'ReactUpdates: must provide a reconcile transaction class') : _prodInvariant('126') : void 0;
	    ReactUpdates.ReactReconcileTransaction = ReconcileTransaction;
	  },
	
	  injectBatchingStrategy: function (_batchingStrategy) {
	    !_batchingStrategy ?  false ? invariant(false, 'ReactUpdates: must provide a batching strategy') : _prodInvariant('127') : void 0;
	    !(typeof _batchingStrategy.batchedUpdates === 'function') ?  false ? invariant(false, 'ReactUpdates: must provide a batchedUpdates() function') : _prodInvariant('128') : void 0;
	    !(typeof _batchingStrategy.isBatchingUpdates === 'boolean') ?  false ? invariant(false, 'ReactUpdates: must provide an isBatchingUpdates boolean attribute') : _prodInvariant('129') : void 0;
	    batchingStrategy = _batchingStrategy;
	  }
	};
	
	var ReactUpdates = {
	  /**
	   * React references `ReactReconcileTransaction` using this property in order
	   * to allow dependency injection.
	   *
	   * @internal
	   */
	  ReactReconcileTransaction: null,
	
	  batchedUpdates: batchedUpdates,
	  enqueueUpdate: enqueueUpdate,
	  flushBatchedUpdates: flushBatchedUpdates,
	  injection: ReactUpdatesInjection,
	  asap: asap
	};
	
	module.exports = ReactUpdates;

/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(335);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var PooledClass = __webpack_require__(353);
	
	var invariant = __webpack_require__(337);
	
	/**
	 * A specialized pseudo-event module to help keep track of components waiting to
	 * be notified when their DOM representations are available for use.
	 *
	 * This implements `PooledClass`, so you should never need to instantiate this.
	 * Instead, use `CallbackQueue.getPooled()`.
	 *
	 * @class ReactMountReady
	 * @implements PooledClass
	 * @internal
	 */
	
	var CallbackQueue = function () {
	  function CallbackQueue(arg) {
	    _classCallCheck(this, CallbackQueue);
	
	    this._callbacks = null;
	    this._contexts = null;
	    this._arg = arg;
	  }
	
	  /**
	   * Enqueues a callback to be invoked when `notifyAll` is invoked.
	   *
	   * @param {function} callback Invoked when `notifyAll` is invoked.
	   * @param {?object} context Context to call `callback` with.
	   * @internal
	   */
	
	
	  CallbackQueue.prototype.enqueue = function enqueue(callback, context) {
	    this._callbacks = this._callbacks || [];
	    this._callbacks.push(callback);
	    this._contexts = this._contexts || [];
	    this._contexts.push(context);
	  };
	
	  /**
	   * Invokes all enqueued callbacks and clears the queue. This is invoked after
	   * the DOM representation of a component has been created or updated.
	   *
	   * @internal
	   */
	
	
	  CallbackQueue.prototype.notifyAll = function notifyAll() {
	    var callbacks = this._callbacks;
	    var contexts = this._contexts;
	    var arg = this._arg;
	    if (callbacks && contexts) {
	      !(callbacks.length === contexts.length) ?  false ? invariant(false, 'Mismatched list of contexts in callback queue') : _prodInvariant('24') : void 0;
	      this._callbacks = null;
	      this._contexts = null;
	      for (var i = 0; i < callbacks.length; i++) {
	        callbacks[i].call(contexts[i], arg);
	      }
	      callbacks.length = 0;
	      contexts.length = 0;
	    }
	  };
	
	  CallbackQueue.prototype.checkpoint = function checkpoint() {
	    return this._callbacks ? this._callbacks.length : 0;
	  };
	
	  CallbackQueue.prototype.rollback = function rollback(len) {
	    if (this._callbacks && this._contexts) {
	      this._callbacks.length = len;
	      this._contexts.length = len;
	    }
	  };
	
	  /**
	   * Resets the internal queue.
	   *
	   * @internal
	   */
	
	
	  CallbackQueue.prototype.reset = function reset() {
	    this._callbacks = null;
	    this._contexts = null;
	  };
	
	  /**
	   * `PooledClass` looks for this.
	   */
	
	
	  CallbackQueue.prototype.destructor = function destructor() {
	    this.reset();
	  };
	
	  return CallbackQueue;
	}();
	
	module.exports = PooledClass.addPoolingTo(CallbackQueue);

/***/ }),
/* 361 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactFeatureFlags = {
	  // When true, call console.time() before and .timeEnd() after each top-level
	  // render (both initial renders and updates). Useful when looking at prod-mode
	  // timeline profiles in Chrome, for example.
	  logTopLevelRenders: false
	};
	
	module.exports = ReactFeatureFlags;

/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactRef = __webpack_require__(363);
	var ReactInstrumentation = __webpack_require__(365);
	
	var warning = __webpack_require__(347);
	
	/**
	 * Helper to call ReactRef.attachRefs with this composite component, split out
	 * to avoid allocations in the transaction mount-ready queue.
	 */
	function attachRefs() {
	  ReactRef.attachRefs(this, this._currentElement);
	}
	
	var ReactReconciler = {
	
	  /**
	   * Initializes the component, renders markup, and registers event listeners.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?object} the containing host component instance
	   * @param {?object} info about the host container
	   * @return {?string} Rendered markup to be inserted into the DOM.
	   * @final
	   * @internal
	   */
	  mountComponent: function (internalInstance, transaction, hostParent, hostContainerInfo, context, parentDebugID // 0 in production and for roots
	  ) {
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeMountComponent(internalInstance._debugID, internalInstance._currentElement, parentDebugID);
	      }
	    }
	    var markup = internalInstance.mountComponent(transaction, hostParent, hostContainerInfo, context, parentDebugID);
	    if (internalInstance._currentElement && internalInstance._currentElement.ref != null) {
	      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
	    }
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onMountComponent(internalInstance._debugID);
	      }
	    }
	    return markup;
	  },
	
	  /**
	   * Returns a value that can be passed to
	   * ReactComponentEnvironment.replaceNodeWithMarkup.
	   */
	  getHostNode: function (internalInstance) {
	    return internalInstance.getHostNode();
	  },
	
	  /**
	   * Releases any resources allocated by `mountComponent`.
	   *
	   * @final
	   * @internal
	   */
	  unmountComponent: function (internalInstance, safely) {
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUnmountComponent(internalInstance._debugID);
	      }
	    }
	    ReactRef.detachRefs(internalInstance, internalInstance._currentElement);
	    internalInstance.unmountComponent(safely);
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUnmountComponent(internalInstance._debugID);
	      }
	    }
	  },
	
	  /**
	   * Update a component using a new element.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactElement} nextElement
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   * @internal
	   */
	  receiveComponent: function (internalInstance, nextElement, transaction, context) {
	    var prevElement = internalInstance._currentElement;
	
	    if (nextElement === prevElement && context === internalInstance._context) {
	      // Since elements are immutable after the owner is rendered,
	      // we can do a cheap identity compare here to determine if this is a
	      // superfluous reconcile. It's possible for state to be mutable but such
	      // change should trigger an update of the owner which would recreate
	      // the element. We explicitly check for the existence of an owner since
	      // it's possible for an element created outside a composite to be
	      // deeply mutated and reused.
	
	      // TODO: Bailing out early is just a perf optimization right?
	      // TODO: Removing the return statement should affect correctness?
	      return;
	    }
	
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, nextElement);
	      }
	    }
	
	    var refsChanged = ReactRef.shouldUpdateRefs(prevElement, nextElement);
	
	    if (refsChanged) {
	      ReactRef.detachRefs(internalInstance, prevElement);
	    }
	
	    internalInstance.receiveComponent(nextElement, transaction, context);
	
	    if (refsChanged && internalInstance._currentElement && internalInstance._currentElement.ref != null) {
	      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
	    }
	
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
	      }
	    }
	  },
	
	  /**
	   * Flush any dirty changes in a component.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  performUpdateIfNecessary: function (internalInstance, transaction, updateBatchNumber) {
	    if (internalInstance._updateBatchNumber !== updateBatchNumber) {
	      // The component's enqueued batch number should always be the current
	      // batch or the following one.
	       false ? warning(internalInstance._updateBatchNumber == null || internalInstance._updateBatchNumber === updateBatchNumber + 1, 'performUpdateIfNecessary: Unexpected batch number (current %s, ' + 'pending %s)', updateBatchNumber, internalInstance._updateBatchNumber) : void 0;
	      return;
	    }
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, internalInstance._currentElement);
	      }
	    }
	    internalInstance.performUpdateIfNecessary(transaction);
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
	      }
	    }
	  }
	
	};
	
	module.exports = ReactReconciler;

/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactOwner = __webpack_require__(364);
	
	var ReactRef = {};
	
	function attachRef(ref, component, owner) {
	  if (typeof ref === 'function') {
	    ref(component.getPublicInstance());
	  } else {
	    // Legacy ref
	    ReactOwner.addComponentAsRefTo(component, ref, owner);
	  }
	}
	
	function detachRef(ref, component, owner) {
	  if (typeof ref === 'function') {
	    ref(null);
	  } else {
	    // Legacy ref
	    ReactOwner.removeComponentAsRefFrom(component, ref, owner);
	  }
	}
	
	ReactRef.attachRefs = function (instance, element) {
	  if (element === null || typeof element !== 'object') {
	    return;
	  }
	  var ref = element.ref;
	  if (ref != null) {
	    attachRef(ref, instance, element._owner);
	  }
	};
	
	ReactRef.shouldUpdateRefs = function (prevElement, nextElement) {
	  // If either the owner or a `ref` has changed, make sure the newest owner
	  // has stored a reference to `this`, and the previous owner (if different)
	  // has forgotten the reference to `this`. We use the element instead
	  // of the public this.props because the post processing cannot determine
	  // a ref. The ref conceptually lives on the element.
	
	  // TODO: Should this even be possible? The owner cannot change because
	  // it's forbidden by shouldUpdateReactComponent. The ref can change
	  // if you swap the keys of but not the refs. Reconsider where this check
	  // is made. It probably belongs where the key checking and
	  // instantiateReactComponent is done.
	
	  var prevRef = null;
	  var prevOwner = null;
	  if (prevElement !== null && typeof prevElement === 'object') {
	    prevRef = prevElement.ref;
	    prevOwner = prevElement._owner;
	  }
	
	  var nextRef = null;
	  var nextOwner = null;
	  if (nextElement !== null && typeof nextElement === 'object') {
	    nextRef = nextElement.ref;
	    nextOwner = nextElement._owner;
	  }
	
	  return prevRef !== nextRef ||
	  // If owner changes but we have an unchanged function ref, don't update refs
	  typeof nextRef === 'string' && nextOwner !== prevOwner;
	};
	
	ReactRef.detachRefs = function (instance, element) {
	  if (element === null || typeof element !== 'object') {
	    return;
	  }
	  var ref = element.ref;
	  if (ref != null) {
	    detachRef(ref, instance, element._owner);
	  }
	};
	
	module.exports = ReactRef;

/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(335);
	
	var invariant = __webpack_require__(337);
	
	/**
	 * @param {?object} object
	 * @return {boolean} True if `object` is a valid owner.
	 * @final
	 */
	function isValidOwner(object) {
	  return !!(object && typeof object.attachRef === 'function' && typeof object.detachRef === 'function');
	}
	
	/**
	 * ReactOwners are capable of storing references to owned components.
	 *
	 * All components are capable of //being// referenced by owner components, but
	 * only ReactOwner components are capable of //referencing// owned components.
	 * The named reference is known as a "ref".
	 *
	 * Refs are available when mounted and updated during reconciliation.
	 *
	 *   var MyComponent = React.createClass({
	 *     render: function() {
	 *       return (
	 *         <div onClick={this.handleClick}>
	 *           <CustomComponent ref="custom" />
	 *         </div>
	 *       );
	 *     },
	 *     handleClick: function() {
	 *       this.refs.custom.handleClick();
	 *     },
	 *     componentDidMount: function() {
	 *       this.refs.custom.initialize();
	 *     }
	 *   });
	 *
	 * Refs should rarely be used. When refs are used, they should only be done to
	 * control data that is not handled by React's data flow.
	 *
	 * @class ReactOwner
	 */
	var ReactOwner = {
	  /**
	   * Adds a component by ref to an owner component.
	   *
	   * @param {ReactComponent} component Component to reference.
	   * @param {string} ref Name by which to refer to the component.
	   * @param {ReactOwner} owner Component on which to record the ref.
	   * @final
	   * @internal
	   */
	  addComponentAsRefTo: function (component, ref, owner) {
	    !isValidOwner(owner) ?  false ? invariant(false, 'addComponentAsRefTo(...): Only a ReactOwner can have refs. You might be adding a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('119') : void 0;
	    owner.attachRef(ref, component);
	  },
	
	  /**
	   * Removes a component by ref from an owner component.
	   *
	   * @param {ReactComponent} component Component to dereference.
	   * @param {string} ref Name of the ref to remove.
	   * @param {ReactOwner} owner Component on which the ref is recorded.
	   * @final
	   * @internal
	   */
	  removeComponentAsRefFrom: function (component, ref, owner) {
	    !isValidOwner(owner) ?  false ? invariant(false, 'removeComponentAsRefFrom(...): Only a ReactOwner can have refs. You might be removing a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('120') : void 0;
	    var ownerPublicInstance = owner.getPublicInstance();
	    // Check that `component`'s owner is still alive and that `component` is still the current ref
	    // because we do not want to detach the ref if another component stole it.
	    if (ownerPublicInstance && ownerPublicInstance.refs[ref] === component.getPublicInstance()) {
	      owner.detachRef(ref);
	    }
	  }
	
	};
	
	module.exports = ReactOwner;

/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2016-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	// Trust the developer to only use ReactInstrumentation with a __DEV__ check
	
	var debugTool = null;
	
	if (false) {
	  var ReactDebugTool = require('./ReactDebugTool');
	  debugTool = ReactDebugTool;
	}
	
	module.exports = { debugTool: debugTool };

/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(335);
	
	var invariant = __webpack_require__(337);
	
	var OBSERVED_ERROR = {};
	
	/**
	 * `Transaction` creates a black box that is able to wrap any method such that
	 * certain invariants are maintained before and after the method is invoked
	 * (Even if an exception is thrown while invoking the wrapped method). Whoever
	 * instantiates a transaction can provide enforcers of the invariants at
	 * creation time. The `Transaction` class itself will supply one additional
	 * automatic invariant for you - the invariant that any transaction instance
	 * should not be run while it is already being run. You would typically create a
	 * single instance of a `Transaction` for reuse multiple times, that potentially
	 * is used to wrap several different methods. Wrappers are extremely simple -
	 * they only require implementing two methods.
	 *
	 * <pre>
	 *                       wrappers (injected at creation time)
	 *                                      +        +
	 *                                      |        |
	 *                    +-----------------|--------|--------------+
	 *                    |                 v        |              |
	 *                    |      +---------------+   |              |
	 *                    |   +--|    wrapper1   |---|----+         |
	 *                    |   |  +---------------+   v    |         |
	 *                    |   |          +-------------+  |         |
	 *                    |   |     +----|   wrapper2  |--------+   |
	 *                    |   |     |    +-------------+  |     |   |
	 *                    |   |     |                     |     |   |
	 *                    |   v     v                     v     v   | wrapper
	 *                    | +---+ +---+   +---------+   +---+ +---+ | invariants
	 * perform(anyMethod) | |   | |   |   |         |   |   | |   | | maintained
	 * +----------------->|-|---|-|---|-->|anyMethod|---|---|-|---|-|-------->
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | +---+ +---+   +---------+   +---+ +---+ |
	 *                    |  initialize                    close    |
	 *                    +-----------------------------------------+
	 * </pre>
	 *
	 * Use cases:
	 * - Preserving the input selection ranges before/after reconciliation.
	 *   Restoring selection even in the event of an unexpected error.
	 * - Deactivating events while rearranging the DOM, preventing blurs/focuses,
	 *   while guaranteeing that afterwards, the event system is reactivated.
	 * - Flushing a queue of collected DOM mutations to the main UI thread after a
	 *   reconciliation takes place in a worker thread.
	 * - Invoking any collected `componentDidUpdate` callbacks after rendering new
	 *   content.
	 * - (Future use case): Wrapping particular flushes of the `ReactWorker` queue
	 *   to preserve the `scrollTop` (an automatic scroll aware DOM).
	 * - (Future use case): Layout calculations before and after DOM updates.
	 *
	 * Transactional plugin API:
	 * - A module that has an `initialize` method that returns any precomputation.
	 * - and a `close` method that accepts the precomputation. `close` is invoked
	 *   when the wrapped process is completed, or has failed.
	 *
	 * @param {Array<TransactionalWrapper>} transactionWrapper Wrapper modules
	 * that implement `initialize` and `close`.
	 * @return {Transaction} Single transaction for reuse in thread.
	 *
	 * @class Transaction
	 */
	var TransactionImpl = {
	  /**
	   * Sets up this instance so that it is prepared for collecting metrics. Does
	   * so such that this setup method may be used on an instance that is already
	   * initialized, in a way that does not consume additional memory upon reuse.
	   * That can be useful if you decide to make your subclass of this mixin a
	   * "PooledClass".
	   */
	  reinitializeTransaction: function () {
	    this.transactionWrappers = this.getTransactionWrappers();
	    if (this.wrapperInitData) {
	      this.wrapperInitData.length = 0;
	    } else {
	      this.wrapperInitData = [];
	    }
	    this._isInTransaction = false;
	  },
	
	  _isInTransaction: false,
	
	  /**
	   * @abstract
	   * @return {Array<TransactionWrapper>} Array of transaction wrappers.
	   */
	  getTransactionWrappers: null,
	
	  isInTransaction: function () {
	    return !!this._isInTransaction;
	  },
	
	  /**
	   * Executes the function within a safety window. Use this for the top level
	   * methods that result in large amounts of computation/mutations that would
	   * need to be safety checked. The optional arguments helps prevent the need
	   * to bind in many cases.
	   *
	   * @param {function} method Member of scope to call.
	   * @param {Object} scope Scope to invoke from.
	   * @param {Object?=} a Argument to pass to the method.
	   * @param {Object?=} b Argument to pass to the method.
	   * @param {Object?=} c Argument to pass to the method.
	   * @param {Object?=} d Argument to pass to the method.
	   * @param {Object?=} e Argument to pass to the method.
	   * @param {Object?=} f Argument to pass to the method.
	   *
	   * @return {*} Return value from `method`.
	   */
	  perform: function (method, scope, a, b, c, d, e, f) {
	    !!this.isInTransaction() ?  false ? invariant(false, 'Transaction.perform(...): Cannot initialize a transaction when there is already an outstanding transaction.') : _prodInvariant('27') : void 0;
	    var errorThrown;
	    var ret;
	    try {
	      this._isInTransaction = true;
	      // Catching errors makes debugging more difficult, so we start with
	      // errorThrown set to true before setting it to false after calling
	      // close -- if it's still set to true in the finally block, it means
	      // one of these calls threw.
	      errorThrown = true;
	      this.initializeAll(0);
	      ret = method.call(scope, a, b, c, d, e, f);
	      errorThrown = false;
	    } finally {
	      try {
	        if (errorThrown) {
	          // If `method` throws, prefer to show that stack trace over any thrown
	          // by invoking `closeAll`.
	          try {
	            this.closeAll(0);
	          } catch (err) {}
	        } else {
	          // Since `method` didn't throw, we don't want to silence the exception
	          // here.
	          this.closeAll(0);
	        }
	      } finally {
	        this._isInTransaction = false;
	      }
	    }
	    return ret;
	  },
	
	  initializeAll: function (startIndex) {
	    var transactionWrappers = this.transactionWrappers;
	    for (var i = startIndex; i < transactionWrappers.length; i++) {
	      var wrapper = transactionWrappers[i];
	      try {
	        // Catching errors makes debugging more difficult, so we start with the
	        // OBSERVED_ERROR state before overwriting it with the real return value
	        // of initialize -- if it's still set to OBSERVED_ERROR in the finally
	        // block, it means wrapper.initialize threw.
	        this.wrapperInitData[i] = OBSERVED_ERROR;
	        this.wrapperInitData[i] = wrapper.initialize ? wrapper.initialize.call(this) : null;
	      } finally {
	        if (this.wrapperInitData[i] === OBSERVED_ERROR) {
	          // The initializer for wrapper i threw an error; initialize the
	          // remaining wrappers but silence any exceptions from them to ensure
	          // that the first error is the one to bubble up.
	          try {
	            this.initializeAll(i + 1);
	          } catch (err) {}
	        }
	      }
	    }
	  },
	
	  /**
	   * Invokes each of `this.transactionWrappers.close[i]` functions, passing into
	   * them the respective return values of `this.transactionWrappers.init[i]`
	   * (`close`rs that correspond to initializers that failed will not be
	   * invoked).
	   */
	  closeAll: function (startIndex) {
	    !this.isInTransaction() ?  false ? invariant(false, 'Transaction.closeAll(): Cannot close transaction when none are open.') : _prodInvariant('28') : void 0;
	    var transactionWrappers = this.transactionWrappers;
	    for (var i = startIndex; i < transactionWrappers.length; i++) {
	      var wrapper = transactionWrappers[i];
	      var initData = this.wrapperInitData[i];
	      var errorThrown;
	      try {
	        // Catching errors makes debugging more difficult, so we start with
	        // errorThrown set to true before setting it to false after calling
	        // close -- if it's still set to true in the finally block, it means
	        // wrapper.close threw.
	        errorThrown = true;
	        if (initData !== OBSERVED_ERROR && wrapper.close) {
	          wrapper.close.call(this, initData);
	        }
	        errorThrown = false;
	      } finally {
	        if (errorThrown) {
	          // The closer for wrapper i threw an error; close the remaining
	          // wrappers but silence any exceptions from them to ensure that the
	          // first error is the one to bubble up.
	          try {
	            this.closeAll(i + 1);
	          } catch (e) {}
	        }
	      }
	    }
	    this.wrapperInitData.length = 0;
	  }
	};
	
	module.exports = TransactionImpl;

/***/ }),
/* 367 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Gets the target node from a native browser event by accounting for
	 * inconsistencies in browser DOM APIs.
	 *
	 * @param {object} nativeEvent Native browser event.
	 * @return {DOMEventTarget} Target node.
	 */
	
	function getEventTarget(nativeEvent) {
	  var target = nativeEvent.target || nativeEvent.srcElement || window;
	
	  // Normalize SVG <use> element events #4963
	  if (target.correspondingUseElement) {
	    target = target.correspondingUseElement;
	  }
	
	  // Safari may fire events on text nodes (Node.TEXT_NODE is 3).
	  // @see http://www.quirksmode.org/js/events_properties.html
	  return target.nodeType === 3 ? target.parentNode : target;
	}
	
	module.exports = getEventTarget;

/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(351);
	
	var useHasFeature;
	if (ExecutionEnvironment.canUseDOM) {
	  useHasFeature = document.implementation && document.implementation.hasFeature &&
	  // always returns true in newer browsers as per the standard.
	  // @see http://dom.spec.whatwg.org/#dom-domimplementation-hasfeature
	  document.implementation.hasFeature('', '') !== true;
	}
	
	/**
	 * Checks if an event is supported in the current execution environment.
	 *
	 * NOTE: This will not work correctly for non-generic events such as `change`,
	 * `reset`, `load`, `error`, and `select`.
	 *
	 * Borrows from Modernizr.
	 *
	 * @param {string} eventNameSuffix Event name, e.g. "click".
	 * @param {?boolean} capture Check if the capture phase is supported.
	 * @return {boolean} True if the event is supported.
	 * @internal
	 * @license Modernizr 3.0.0pre (Custom Build) | MIT
	 */
	function isEventSupported(eventNameSuffix, capture) {
	  if (!ExecutionEnvironment.canUseDOM || capture && !('addEventListener' in document)) {
	    return false;
	  }
	
	  var eventName = 'on' + eventNameSuffix;
	  var isSupported = eventName in document;
	
	  if (!isSupported) {
	    var element = document.createElement('div');
	    element.setAttribute(eventName, 'return;');
	    isSupported = typeof element[eventName] === 'function';
	  }
	
	  if (!isSupported && useHasFeature && eventNameSuffix === 'wheel') {
	    // This is the only way to test support for the `wheel` event in IE9+.
	    isSupported = document.implementation.hasFeature('Events.wheel', '3.0');
	  }
	
	  return isSupported;
	}
	
	module.exports = isEventSupported;

/***/ }),
/* 369 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * @see http://www.whatwg.org/specs/web-apps/current-work/multipage/the-input-element.html#input-type-attr-summary
	 */
	
	var supportedInputTypes = {
	  'color': true,
	  'date': true,
	  'datetime': true,
	  'datetime-local': true,
	  'email': true,
	  'month': true,
	  'number': true,
	  'password': true,
	  'range': true,
	  'search': true,
	  'tel': true,
	  'text': true,
	  'time': true,
	  'url': true,
	  'week': true
	};
	
	function isTextInputElement(elem) {
	  var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
	
	  if (nodeName === 'input') {
	    return !!supportedInputTypes[elem.type];
	  }
	
	  if (nodeName === 'textarea') {
	    return true;
	  }
	
	  return false;
	}
	
	module.exports = isTextInputElement;

/***/ }),
/* 370 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Module that is injectable into `EventPluginHub`, that specifies a
	 * deterministic ordering of `EventPlugin`s. A convenient way to reason about
	 * plugins, without having to package every one of them. This is better than
	 * having plugins be ordered in the same order that they are injected because
	 * that ordering would be influenced by the packaging order.
	 * `ResponderEventPlugin` must occur before `SimpleEventPlugin` so that
	 * preventing default on events is convenient in `SimpleEventPlugin` handlers.
	 */
	
	var DefaultEventPluginOrder = ['ResponderEventPlugin', 'SimpleEventPlugin', 'TapEventPlugin', 'EnterLeaveEventPlugin', 'ChangeEventPlugin', 'SelectEventPlugin', 'BeforeInputEventPlugin'];
	
	module.exports = DefaultEventPluginOrder;

/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var EventPropagators = __webpack_require__(342);
	var ReactDOMComponentTree = __webpack_require__(334);
	var SyntheticMouseEvent = __webpack_require__(372);
	
	var eventTypes = {
	  mouseEnter: {
	    registrationName: 'onMouseEnter',
	    dependencies: ['topMouseOut', 'topMouseOver']
	  },
	  mouseLeave: {
	    registrationName: 'onMouseLeave',
	    dependencies: ['topMouseOut', 'topMouseOver']
	  }
	};
	
	var EnterLeaveEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  /**
	   * For almost every interaction we care about, there will be both a top-level
	   * `mouseover` and `mouseout` event that occurs. Only use `mouseout` so that
	   * we do not extract duplicate events. However, moving the mouse into the
	   * browser from outside will not fire a `mouseout` event. In this case, we use
	   * the `mouseover` top-level event.
	   */
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    if (topLevelType === 'topMouseOver' && (nativeEvent.relatedTarget || nativeEvent.fromElement)) {
	      return null;
	    }
	    if (topLevelType !== 'topMouseOut' && topLevelType !== 'topMouseOver') {
	      // Must not be a mouse in or mouse out - ignoring.
	      return null;
	    }
	
	    var win;
	    if (nativeEventTarget.window === nativeEventTarget) {
	      // `nativeEventTarget` is probably a window object.
	      win = nativeEventTarget;
	    } else {
	      // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
	      var doc = nativeEventTarget.ownerDocument;
	      if (doc) {
	        win = doc.defaultView || doc.parentWindow;
	      } else {
	        win = window;
	      }
	    }
	
	    var from;
	    var to;
	    if (topLevelType === 'topMouseOut') {
	      from = targetInst;
	      var related = nativeEvent.relatedTarget || nativeEvent.toElement;
	      to = related ? ReactDOMComponentTree.getClosestInstanceFromNode(related) : null;
	    } else {
	      // Moving to a node from outside the window.
	      from = null;
	      to = targetInst;
	    }
	
	    if (from === to) {
	      // Nothing pertains to our managed components.
	      return null;
	    }
	
	    var fromNode = from == null ? win : ReactDOMComponentTree.getNodeFromInstance(from);
	    var toNode = to == null ? win : ReactDOMComponentTree.getNodeFromInstance(to);
	
	    var leave = SyntheticMouseEvent.getPooled(eventTypes.mouseLeave, from, nativeEvent, nativeEventTarget);
	    leave.type = 'mouseleave';
	    leave.target = fromNode;
	    leave.relatedTarget = toNode;
	
	    var enter = SyntheticMouseEvent.getPooled(eventTypes.mouseEnter, to, nativeEvent, nativeEventTarget);
	    enter.type = 'mouseenter';
	    enter.target = toNode;
	    enter.relatedTarget = fromNode;
	
	    EventPropagators.accumulateEnterLeaveDispatches(leave, enter, from, to);
	
	    return [leave, enter];
	  }
	
	};
	
	module.exports = EnterLeaveEventPlugin;

/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(373);
	var ViewportMetrics = __webpack_require__(374);
	
	var getEventModifierState = __webpack_require__(375);
	
	/**
	 * @interface MouseEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var MouseEventInterface = {
	  screenX: null,
	  screenY: null,
	  clientX: null,
	  clientY: null,
	  ctrlKey: null,
	  shiftKey: null,
	  altKey: null,
	  metaKey: null,
	  getModifierState: getEventModifierState,
	  button: function (event) {
	    // Webkit, Firefox, IE9+
	    // which:  1 2 3
	    // button: 0 1 2 (standard)
	    var button = event.button;
	    if ('which' in event) {
	      return button;
	    }
	    // IE<9
	    // which:  undefined
	    // button: 0 0 0
	    // button: 1 4 2 (onmouseup)
	    return button === 2 ? 2 : button === 4 ? 1 : 0;
	  },
	  buttons: null,
	  relatedTarget: function (event) {
	    return event.relatedTarget || (event.fromElement === event.srcElement ? event.toElement : event.fromElement);
	  },
	  // "Proprietary" Interface.
	  pageX: function (event) {
	    return 'pageX' in event ? event.pageX : event.clientX + ViewportMetrics.currentScrollLeft;
	  },
	  pageY: function (event) {
	    return 'pageY' in event ? event.pageY : event.clientY + ViewportMetrics.currentScrollTop;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticMouseEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticMouseEvent, MouseEventInterface);
	
	module.exports = SyntheticMouseEvent;

/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(356);
	
	var getEventTarget = __webpack_require__(367);
	
	/**
	 * @interface UIEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var UIEventInterface = {
	  view: function (event) {
	    if (event.view) {
	      return event.view;
	    }
	
	    var target = getEventTarget(event);
	    if (target.window === target) {
	      // target is a window object
	      return target;
	    }
	
	    var doc = target.ownerDocument;
	    // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
	    if (doc) {
	      return doc.defaultView || doc.parentWindow;
	    } else {
	      return window;
	    }
	  },
	  detail: function (event) {
	    return event.detail || 0;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticUIEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticUIEvent, UIEventInterface);
	
	module.exports = SyntheticUIEvent;

/***/ }),
/* 374 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ViewportMetrics = {
	
	  currentScrollLeft: 0,
	
	  currentScrollTop: 0,
	
	  refreshScrollValues: function (scrollPosition) {
	    ViewportMetrics.currentScrollLeft = scrollPosition.x;
	    ViewportMetrics.currentScrollTop = scrollPosition.y;
	  }
	
	};
	
	module.exports = ViewportMetrics;

/***/ }),
/* 375 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Translation from modifier key to the associated property in the event.
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/#keys-Modifiers
	 */
	
	var modifierKeyToProp = {
	  'Alt': 'altKey',
	  'Control': 'ctrlKey',
	  'Meta': 'metaKey',
	  'Shift': 'shiftKey'
	};
	
	// IE8 does not implement getModifierState so we simply map it to the only
	// modifier keys exposed by the event itself, does not support Lock-keys.
	// Currently, all major browsers except Chrome seems to support Lock-keys.
	function modifierStateGetter(keyArg) {
	  var syntheticEvent = this;
	  var nativeEvent = syntheticEvent.nativeEvent;
	  if (nativeEvent.getModifierState) {
	    return nativeEvent.getModifierState(keyArg);
	  }
	  var keyProp = modifierKeyToProp[keyArg];
	  return keyProp ? !!nativeEvent[keyProp] : false;
	}
	
	function getEventModifierState(nativeEvent) {
	  return modifierStateGetter;
	}
	
	module.exports = getEventModifierState;

/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(336);
	
	var MUST_USE_PROPERTY = DOMProperty.injection.MUST_USE_PROPERTY;
	var HAS_BOOLEAN_VALUE = DOMProperty.injection.HAS_BOOLEAN_VALUE;
	var HAS_NUMERIC_VALUE = DOMProperty.injection.HAS_NUMERIC_VALUE;
	var HAS_POSITIVE_NUMERIC_VALUE = DOMProperty.injection.HAS_POSITIVE_NUMERIC_VALUE;
	var HAS_OVERLOADED_BOOLEAN_VALUE = DOMProperty.injection.HAS_OVERLOADED_BOOLEAN_VALUE;
	
	var HTMLDOMPropertyConfig = {
	  isCustomAttribute: RegExp.prototype.test.bind(new RegExp('^(data|aria)-[' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$')),
	  Properties: {
	    /**
	     * Standard Properties
	     */
	    accept: 0,
	    acceptCharset: 0,
	    accessKey: 0,
	    action: 0,
	    allowFullScreen: HAS_BOOLEAN_VALUE,
	    allowTransparency: 0,
	    alt: 0,
	    // specifies target context for links with `preload` type
	    as: 0,
	    async: HAS_BOOLEAN_VALUE,
	    autoComplete: 0,
	    // autoFocus is polyfilled/normalized by AutoFocusUtils
	    // autoFocus: HAS_BOOLEAN_VALUE,
	    autoPlay: HAS_BOOLEAN_VALUE,
	    capture: HAS_BOOLEAN_VALUE,
	    cellPadding: 0,
	    cellSpacing: 0,
	    charSet: 0,
	    challenge: 0,
	    checked: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    cite: 0,
	    classID: 0,
	    className: 0,
	    cols: HAS_POSITIVE_NUMERIC_VALUE,
	    colSpan: 0,
	    content: 0,
	    contentEditable: 0,
	    contextMenu: 0,
	    controls: HAS_BOOLEAN_VALUE,
	    coords: 0,
	    crossOrigin: 0,
	    data: 0, // For `<object />` acts as `src`.
	    dateTime: 0,
	    'default': HAS_BOOLEAN_VALUE,
	    defer: HAS_BOOLEAN_VALUE,
	    dir: 0,
	    disabled: HAS_BOOLEAN_VALUE,
	    download: HAS_OVERLOADED_BOOLEAN_VALUE,
	    draggable: 0,
	    encType: 0,
	    form: 0,
	    formAction: 0,
	    formEncType: 0,
	    formMethod: 0,
	    formNoValidate: HAS_BOOLEAN_VALUE,
	    formTarget: 0,
	    frameBorder: 0,
	    headers: 0,
	    height: 0,
	    hidden: HAS_BOOLEAN_VALUE,
	    high: 0,
	    href: 0,
	    hrefLang: 0,
	    htmlFor: 0,
	    httpEquiv: 0,
	    icon: 0,
	    id: 0,
	    inputMode: 0,
	    integrity: 0,
	    is: 0,
	    keyParams: 0,
	    keyType: 0,
	    kind: 0,
	    label: 0,
	    lang: 0,
	    list: 0,
	    loop: HAS_BOOLEAN_VALUE,
	    low: 0,
	    manifest: 0,
	    marginHeight: 0,
	    marginWidth: 0,
	    max: 0,
	    maxLength: 0,
	    media: 0,
	    mediaGroup: 0,
	    method: 0,
	    min: 0,
	    minLength: 0,
	    // Caution; `option.selected` is not updated if `select.multiple` is
	    // disabled with `removeAttribute`.
	    multiple: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    muted: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    name: 0,
	    nonce: 0,
	    noValidate: HAS_BOOLEAN_VALUE,
	    open: HAS_BOOLEAN_VALUE,
	    optimum: 0,
	    pattern: 0,
	    placeholder: 0,
	    playsInline: HAS_BOOLEAN_VALUE,
	    poster: 0,
	    preload: 0,
	    profile: 0,
	    radioGroup: 0,
	    readOnly: HAS_BOOLEAN_VALUE,
	    referrerPolicy: 0,
	    rel: 0,
	    required: HAS_BOOLEAN_VALUE,
	    reversed: HAS_BOOLEAN_VALUE,
	    role: 0,
	    rows: HAS_POSITIVE_NUMERIC_VALUE,
	    rowSpan: HAS_NUMERIC_VALUE,
	    sandbox: 0,
	    scope: 0,
	    scoped: HAS_BOOLEAN_VALUE,
	    scrolling: 0,
	    seamless: HAS_BOOLEAN_VALUE,
	    selected: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    shape: 0,
	    size: HAS_POSITIVE_NUMERIC_VALUE,
	    sizes: 0,
	    span: HAS_POSITIVE_NUMERIC_VALUE,
	    spellCheck: 0,
	    src: 0,
	    srcDoc: 0,
	    srcLang: 0,
	    srcSet: 0,
	    start: HAS_NUMERIC_VALUE,
	    step: 0,
	    style: 0,
	    summary: 0,
	    tabIndex: 0,
	    target: 0,
	    title: 0,
	    // Setting .type throws on non-<input> tags
	    type: 0,
	    useMap: 0,
	    value: 0,
	    width: 0,
	    wmode: 0,
	    wrap: 0,
	
	    /**
	     * RDFa Properties
	     */
	    about: 0,
	    datatype: 0,
	    inlist: 0,
	    prefix: 0,
	    // property is also supported for OpenGraph in meta tags.
	    property: 0,
	    resource: 0,
	    'typeof': 0,
	    vocab: 0,
	
	    /**
	     * Non-standard Properties
	     */
	    // autoCapitalize and autoCorrect are supported in Mobile Safari for
	    // keyboard hints.
	    autoCapitalize: 0,
	    autoCorrect: 0,
	    // autoSave allows WebKit/Blink to persist values of input fields on page reloads
	    autoSave: 0,
	    // color is for Safari mask-icon link
	    color: 0,
	    // itemProp, itemScope, itemType are for
	    // Microdata support. See http://schema.org/docs/gs.html
	    itemProp: 0,
	    itemScope: HAS_BOOLEAN_VALUE,
	    itemType: 0,
	    // itemID and itemRef are for Microdata support as well but
	    // only specified in the WHATWG spec document. See
	    // https://html.spec.whatwg.org/multipage/microdata.html#microdata-dom-api
	    itemID: 0,
	    itemRef: 0,
	    // results show looking glass icon and recent searches on input
	    // search fields in WebKit/Blink
	    results: 0,
	    // IE-only attribute that specifies security restrictions on an iframe
	    // as an alternative to the sandbox attribute on IE<10
	    security: 0,
	    // IE-only attribute that controls focus behavior
	    unselectable: 0
	  },
	  DOMAttributeNames: {
	    acceptCharset: 'accept-charset',
	    className: 'class',
	    htmlFor: 'for',
	    httpEquiv: 'http-equiv'
	  },
	  DOMPropertyNames: {},
	  DOMMutationMethods: {
	    value: function (node, value) {
	      if (value == null) {
	        return node.removeAttribute('value');
	      }
	
	      // Number inputs get special treatment due to some edge cases in
	      // Chrome. Let everything else assign the value attribute as normal.
	      // https://github.com/facebook/react/issues/7253#issuecomment-236074326
	      if (node.type !== 'number' || node.hasAttribute('value') === false) {
	        node.setAttribute('value', '' + value);
	      } else if (node.validity && !node.validity.badInput && node.ownerDocument.activeElement !== node) {
	        // Don't assign an attribute if validation reports bad
	        // input. Chrome will clear the value. Additionally, don't
	        // operate on inputs that have focus, otherwise Chrome might
	        // strip off trailing decimal places and cause the user's
	        // cursor position to jump to the beginning of the input.
	        //
	        // In ReactDOMInput, we have an onBlur event that will trigger
	        // this function again when focus is lost.
	        node.setAttribute('value', '' + value);
	      }
	    }
	  }
	};
	
	module.exports = HTMLDOMPropertyConfig;

/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMChildrenOperations = __webpack_require__(378);
	var ReactDOMIDOperations = __webpack_require__(389);
	
	/**
	 * Abstracts away all functionality of the reconciler that requires knowledge of
	 * the browser context. TODO: These callers should be refactored to avoid the
	 * need for this injection.
	 */
	var ReactComponentBrowserEnvironment = {
	
	  processChildrenUpdates: ReactDOMIDOperations.dangerouslyProcessChildrenUpdates,
	
	  replaceNodeWithMarkup: DOMChildrenOperations.dangerouslyReplaceNodeWithMarkup
	
	};
	
	module.exports = ReactComponentBrowserEnvironment;

/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMLazyTree = __webpack_require__(379);
	var Danger = __webpack_require__(385);
	var ReactDOMComponentTree = __webpack_require__(334);
	var ReactInstrumentation = __webpack_require__(365);
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(382);
	var setInnerHTML = __webpack_require__(381);
	var setTextContent = __webpack_require__(383);
	
	function getNodeAfter(parentNode, node) {
	  // Special case for text components, which return [open, close] comments
	  // from getHostNode.
	  if (Array.isArray(node)) {
	    node = node[1];
	  }
	  return node ? node.nextSibling : parentNode.firstChild;
	}
	
	/**
	 * Inserts `childNode` as a child of `parentNode` at the `index`.
	 *
	 * @param {DOMElement} parentNode Parent node in which to insert.
	 * @param {DOMElement} childNode Child node to insert.
	 * @param {number} index Index at which to insert the child.
	 * @internal
	 */
	var insertChildAt = createMicrosoftUnsafeLocalFunction(function (parentNode, childNode, referenceNode) {
	  // We rely exclusively on `insertBefore(node, null)` instead of also using
	  // `appendChild(node)`. (Using `undefined` is not allowed by all browsers so
	  // we are careful to use `null`.)
	  parentNode.insertBefore(childNode, referenceNode);
	});
	
	function insertLazyTreeChildAt(parentNode, childTree, referenceNode) {
	  DOMLazyTree.insertTreeBefore(parentNode, childTree, referenceNode);
	}
	
	function moveChild(parentNode, childNode, referenceNode) {
	  if (Array.isArray(childNode)) {
	    moveDelimitedText(parentNode, childNode[0], childNode[1], referenceNode);
	  } else {
	    insertChildAt(parentNode, childNode, referenceNode);
	  }
	}
	
	function removeChild(parentNode, childNode) {
	  if (Array.isArray(childNode)) {
	    var closingComment = childNode[1];
	    childNode = childNode[0];
	    removeDelimitedText(parentNode, childNode, closingComment);
	    parentNode.removeChild(closingComment);
	  }
	  parentNode.removeChild(childNode);
	}
	
	function moveDelimitedText(parentNode, openingComment, closingComment, referenceNode) {
	  var node = openingComment;
	  while (true) {
	    var nextNode = node.nextSibling;
	    insertChildAt(parentNode, node, referenceNode);
	    if (node === closingComment) {
	      break;
	    }
	    node = nextNode;
	  }
	}
	
	function removeDelimitedText(parentNode, startNode, closingComment) {
	  while (true) {
	    var node = startNode.nextSibling;
	    if (node === closingComment) {
	      // The closing comment is removed by ReactMultiChild.
	      break;
	    } else {
	      parentNode.removeChild(node);
	    }
	  }
	}
	
	function replaceDelimitedText(openingComment, closingComment, stringText) {
	  var parentNode = openingComment.parentNode;
	  var nodeAfterComment = openingComment.nextSibling;
	  if (nodeAfterComment === closingComment) {
	    // There are no text nodes between the opening and closing comments; insert
	    // a new one if stringText isn't empty.
	    if (stringText) {
	      insertChildAt(parentNode, document.createTextNode(stringText), nodeAfterComment);
	    }
	  } else {
	    if (stringText) {
	      // Set the text content of the first node after the opening comment, and
	      // remove all following nodes up until the closing comment.
	      setTextContent(nodeAfterComment, stringText);
	      removeDelimitedText(parentNode, nodeAfterComment, closingComment);
	    } else {
	      removeDelimitedText(parentNode, openingComment, closingComment);
	    }
	  }
	
	  if (false) {
	    ReactInstrumentation.debugTool.onHostOperation({
	      instanceID: ReactDOMComponentTree.getInstanceFromNode(openingComment)._debugID,
	      type: 'replace text',
	      payload: stringText
	    });
	  }
	}
	
	var dangerouslyReplaceNodeWithMarkup = Danger.dangerouslyReplaceNodeWithMarkup;
	if (false) {
	  dangerouslyReplaceNodeWithMarkup = function (oldChild, markup, prevInstance) {
	    Danger.dangerouslyReplaceNodeWithMarkup(oldChild, markup);
	    if (prevInstance._debugID !== 0) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: prevInstance._debugID,
	        type: 'replace with',
	        payload: markup.toString()
	      });
	    } else {
	      var nextInstance = ReactDOMComponentTree.getInstanceFromNode(markup.node);
	      if (nextInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onHostOperation({
	          instanceID: nextInstance._debugID,
	          type: 'mount',
	          payload: markup.toString()
	        });
	      }
	    }
	  };
	}
	
	/**
	 * Operations for updating with DOM children.
	 */
	var DOMChildrenOperations = {
	
	  dangerouslyReplaceNodeWithMarkup: dangerouslyReplaceNodeWithMarkup,
	
	  replaceDelimitedText: replaceDelimitedText,
	
	  /**
	   * Updates a component's children by processing a series of updates. The
	   * update configurations are each expected to have a `parentNode` property.
	   *
	   * @param {array<object>} updates List of update configurations.
	   * @internal
	   */
	  processUpdates: function (parentNode, updates) {
	    if (false) {
	      var parentNodeDebugID = ReactDOMComponentTree.getInstanceFromNode(parentNode)._debugID;
	    }
	
	    for (var k = 0; k < updates.length; k++) {
	      var update = updates[k];
	      switch (update.type) {
	        case 'INSERT_MARKUP':
	          insertLazyTreeChildAt(parentNode, update.content, getNodeAfter(parentNode, update.afterNode));
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'insert child',
	              payload: { toIndex: update.toIndex, content: update.content.toString() }
	            });
	          }
	          break;
	        case 'MOVE_EXISTING':
	          moveChild(parentNode, update.fromNode, getNodeAfter(parentNode, update.afterNode));
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'move child',
	              payload: { fromIndex: update.fromIndex, toIndex: update.toIndex }
	            });
	          }
	          break;
	        case 'SET_MARKUP':
	          setInnerHTML(parentNode, update.content);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'replace children',
	              payload: update.content.toString()
	            });
	          }
	          break;
	        case 'TEXT_CONTENT':
	          setTextContent(parentNode, update.content);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'replace text',
	              payload: update.content.toString()
	            });
	          }
	          break;
	        case 'REMOVE_NODE':
	          removeChild(parentNode, update.fromNode);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'remove child',
	              payload: { fromIndex: update.fromIndex }
	            });
	          }
	          break;
	      }
	    }
	  }
	
	};
	
	module.exports = DOMChildrenOperations;

/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMNamespaces = __webpack_require__(380);
	var setInnerHTML = __webpack_require__(381);
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(382);
	var setTextContent = __webpack_require__(383);
	
	var ELEMENT_NODE_TYPE = 1;
	var DOCUMENT_FRAGMENT_NODE_TYPE = 11;
	
	/**
	 * In IE (8-11) and Edge, appending nodes with no children is dramatically
	 * faster than appending a full subtree, so we essentially queue up the
	 * .appendChild calls here and apply them so each node is added to its parent
	 * before any children are added.
	 *
	 * In other browsers, doing so is slower or neutral compared to the other order
	 * (in Firefox, twice as slow) so we only do this inversion in IE.
	 *
	 * See https://github.com/spicyj/innerhtml-vs-createelement-vs-clonenode.
	 */
	var enableLazy = typeof document !== 'undefined' && typeof document.documentMode === 'number' || typeof navigator !== 'undefined' && typeof navigator.userAgent === 'string' && /\bEdge\/\d/.test(navigator.userAgent);
	
	function insertTreeChildren(tree) {
	  if (!enableLazy) {
	    return;
	  }
	  var node = tree.node;
	  var children = tree.children;
	  if (children.length) {
	    for (var i = 0; i < children.length; i++) {
	      insertTreeBefore(node, children[i], null);
	    }
	  } else if (tree.html != null) {
	    setInnerHTML(node, tree.html);
	  } else if (tree.text != null) {
	    setTextContent(node, tree.text);
	  }
	}
	
	var insertTreeBefore = createMicrosoftUnsafeLocalFunction(function (parentNode, tree, referenceNode) {
	  // DocumentFragments aren't actually part of the DOM after insertion so
	  // appending children won't update the DOM. We need to ensure the fragment
	  // is properly populated first, breaking out of our lazy approach for just
	  // this level. Also, some <object> plugins (like Flash Player) will read
	  // <param> nodes immediately upon insertion into the DOM, so <object>
	  // must also be populated prior to insertion into the DOM.
	  if (tree.node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE || tree.node.nodeType === ELEMENT_NODE_TYPE && tree.node.nodeName.toLowerCase() === 'object' && (tree.node.namespaceURI == null || tree.node.namespaceURI === DOMNamespaces.html)) {
	    insertTreeChildren(tree);
	    parentNode.insertBefore(tree.node, referenceNode);
	  } else {
	    parentNode.insertBefore(tree.node, referenceNode);
	    insertTreeChildren(tree);
	  }
	});
	
	function replaceChildWithTree(oldNode, newTree) {
	  oldNode.parentNode.replaceChild(newTree.node, oldNode);
	  insertTreeChildren(newTree);
	}
	
	function queueChild(parentTree, childTree) {
	  if (enableLazy) {
	    parentTree.children.push(childTree);
	  } else {
	    parentTree.node.appendChild(childTree.node);
	  }
	}
	
	function queueHTML(tree, html) {
	  if (enableLazy) {
	    tree.html = html;
	  } else {
	    setInnerHTML(tree.node, html);
	  }
	}
	
	function queueText(tree, text) {
	  if (enableLazy) {
	    tree.text = text;
	  } else {
	    setTextContent(tree.node, text);
	  }
	}
	
	function toString() {
	  return this.node.nodeName;
	}
	
	function DOMLazyTree(node) {
	  return {
	    node: node,
	    children: [],
	    html: null,
	    text: null,
	    toString: toString
	  };
	}
	
	DOMLazyTree.insertTreeBefore = insertTreeBefore;
	DOMLazyTree.replaceChildWithTree = replaceChildWithTree;
	DOMLazyTree.queueChild = queueChild;
	DOMLazyTree.queueHTML = queueHTML;
	DOMLazyTree.queueText = queueText;
	
	module.exports = DOMLazyTree;

/***/ }),
/* 380 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMNamespaces = {
	  html: 'http://www.w3.org/1999/xhtml',
	  mathml: 'http://www.w3.org/1998/Math/MathML',
	  svg: 'http://www.w3.org/2000/svg'
	};
	
	module.exports = DOMNamespaces;

/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(351);
	var DOMNamespaces = __webpack_require__(380);
	
	var WHITESPACE_TEST = /^[ \r\n\t\f]/;
	var NONVISIBLE_TEST = /<(!--|link|noscript|meta|script|style)[ \r\n\t\f\/>]/;
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(382);
	
	// SVG temp container for IE lacking innerHTML
	var reusableSVGContainer;
	
	/**
	 * Set the innerHTML property of a node, ensuring that whitespace is preserved
	 * even in IE8.
	 *
	 * @param {DOMElement} node
	 * @param {string} html
	 * @internal
	 */
	var setInnerHTML = createMicrosoftUnsafeLocalFunction(function (node, html) {
	  // IE does not have innerHTML for SVG nodes, so instead we inject the
	  // new markup in a temp node and then move the child nodes across into
	  // the target node
	  if (node.namespaceURI === DOMNamespaces.svg && !('innerHTML' in node)) {
	    reusableSVGContainer = reusableSVGContainer || document.createElement('div');
	    reusableSVGContainer.innerHTML = '<svg>' + html + '</svg>';
	    var svgNode = reusableSVGContainer.firstChild;
	    while (svgNode.firstChild) {
	      node.appendChild(svgNode.firstChild);
	    }
	  } else {
	    node.innerHTML = html;
	  }
	});
	
	if (ExecutionEnvironment.canUseDOM) {
	  // IE8: When updating a just created node with innerHTML only leading
	  // whitespace is removed. When updating an existing node with innerHTML
	  // whitespace in root TextNodes is also collapsed.
	  // @see quirksmode.org/bugreports/archives/2004/11/innerhtml_and_t.html
	
	  // Feature detection; only IE8 is known to behave improperly like this.
	  var testElement = document.createElement('div');
	  testElement.innerHTML = ' ';
	  if (testElement.innerHTML === '') {
	    setInnerHTML = function (node, html) {
	      // Magic theory: IE8 supposedly differentiates between added and updated
	      // nodes when processing innerHTML, innerHTML on updated nodes suffers
	      // from worse whitespace behavior. Re-adding a node like this triggers
	      // the initial and more favorable whitespace behavior.
	      // TODO: What to do on a detached node?
	      if (node.parentNode) {
	        node.parentNode.replaceChild(node, node);
	      }
	
	      // We also implement a workaround for non-visible tags disappearing into
	      // thin air on IE8, this only happens if there is no visible text
	      // in-front of the non-visible tags. Piggyback on the whitespace fix
	      // and simply check if any non-visible tags appear in the source.
	      if (WHITESPACE_TEST.test(html) || html[0] === '<' && NONVISIBLE_TEST.test(html)) {
	        // Recover leading whitespace by temporarily prepending any character.
	        // \uFEFF has the potential advantage of being zero-width/invisible.
	        // UglifyJS drops U+FEFF chars when parsing, so use String.fromCharCode
	        // in hopes that this is preserved even if "\uFEFF" is transformed to
	        // the actual Unicode character (by Babel, for example).
	        // https://github.com/mishoo/UglifyJS2/blob/v2.4.20/lib/parse.js#L216
	        node.innerHTML = String.fromCharCode(0xFEFF) + html;
	
	        // deleteData leaves an empty `TextNode` which offsets the index of all
	        // children. Definitely want to avoid this.
	        var textNode = node.firstChild;
	        if (textNode.data.length === 1) {
	          node.removeChild(textNode);
	        } else {
	          textNode.deleteData(0, 1);
	        }
	      } else {
	        node.innerHTML = html;
	      }
	    };
	  }
	  testElement = null;
	}
	
	module.exports = setInnerHTML;

/***/ }),
/* 382 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	/* globals MSApp */
	
	'use strict';
	
	/**
	 * Create a function which has 'unsafe' privileges (required by windows8 apps)
	 */
	
	var createMicrosoftUnsafeLocalFunction = function (func) {
	  if (typeof MSApp !== 'undefined' && MSApp.execUnsafeLocalFunction) {
	    return function (arg0, arg1, arg2, arg3) {
	      MSApp.execUnsafeLocalFunction(function () {
	        return func(arg0, arg1, arg2, arg3);
	      });
	    };
	  } else {
	    return func;
	  }
	};
	
	module.exports = createMicrosoftUnsafeLocalFunction;

/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(351);
	var escapeTextContentForBrowser = __webpack_require__(384);
	var setInnerHTML = __webpack_require__(381);
	
	/**
	 * Set the textContent property of a node, ensuring that whitespace is preserved
	 * even in IE8. innerText is a poor substitute for textContent and, among many
	 * issues, inserts <br> instead of the literal newline chars. innerHTML behaves
	 * as it should.
	 *
	 * @param {DOMElement} node
	 * @param {string} text
	 * @internal
	 */
	var setTextContent = function (node, text) {
	  if (text) {
	    var firstChild = node.firstChild;
	
	    if (firstChild && firstChild === node.lastChild && firstChild.nodeType === 3) {
	      firstChild.nodeValue = text;
	      return;
	    }
	  }
	  node.textContent = text;
	};
	
	if (ExecutionEnvironment.canUseDOM) {
	  if (!('textContent' in document.documentElement)) {
	    setTextContent = function (node, text) {
	      if (node.nodeType === 3) {
	        node.nodeValue = text;
	        return;
	      }
	      setInnerHTML(node, escapeTextContentForBrowser(text));
	    };
	  }
	}
	
	module.exports = setTextContent;

/***/ }),
/* 384 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2016-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * Based on the escape-html library, which is used under the MIT License below:
	 *
	 * Copyright (c) 2012-2013 TJ Holowaychuk
	 * Copyright (c) 2015 Andreas Lubbe
	 * Copyright (c) 2015 Tiancheng "Timothy" Gu
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining
	 * a copy of this software and associated documentation files (the
	 * 'Software'), to deal in the Software without restriction, including
	 * without limitation the rights to use, copy, modify, merge, publish,
	 * distribute, sublicense, and/or sell copies of the Software, and to
	 * permit persons to whom the Software is furnished to do so, subject to
	 * the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be
	 * included in all copies or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND,
	 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
	 * IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
	 * CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
	 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
	 * SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
	 *
	 */
	
	'use strict';
	
	// code copied and modified from escape-html
	/**
	 * Module variables.
	 * @private
	 */
	
	var matchHtmlRegExp = /["'&<>]/;
	
	/**
	 * Escape special characters in the given string of html.
	 *
	 * @param  {string} string The string to escape for inserting into HTML
	 * @return {string}
	 * @public
	 */
	
	function escapeHtml(string) {
	  var str = '' + string;
	  var match = matchHtmlRegExp.exec(str);
	
	  if (!match) {
	    return str;
	  }
	
	  var escape;
	  var html = '';
	  var index = 0;
	  var lastIndex = 0;
	
	  for (index = match.index; index < str.length; index++) {
	    switch (str.charCodeAt(index)) {
	      case 34:
	        // "
	        escape = '&quot;';
	        break;
	      case 38:
	        // &
	        escape = '&amp;';
	        break;
	      case 39:
	        // '
	        escape = '&#x27;'; // modified from escape-html; used to be '&#39'
	        break;
	      case 60:
	        // <
	        escape = '&lt;';
	        break;
	      case 62:
	        // >
	        escape = '&gt;';
	        break;
	      default:
	        continue;
	    }
	
	    if (lastIndex !== index) {
	      html += str.substring(lastIndex, index);
	    }
	
	    lastIndex = index + 1;
	    html += escape;
	  }
	
	  return lastIndex !== index ? html + str.substring(lastIndex, index) : html;
	}
	// end code copied and modified from escape-html
	
	
	/**
	 * Escapes text to prevent scripting attacks.
	 *
	 * @param {*} text Text value to escape.
	 * @return {string} An escaped string.
	 */
	function escapeTextContentForBrowser(text) {
	  if (typeof text === 'boolean' || typeof text === 'number') {
	    // this shortcircuit helps perf for types that we know will never have
	    // special characters, especially given that this function is used often
	    // for numeric dom ids.
	    return '' + text;
	  }
	  return escapeHtml(text);
	}
	
	module.exports = escapeTextContentForBrowser;

/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(335);
	
	var DOMLazyTree = __webpack_require__(379);
	var ExecutionEnvironment = __webpack_require__(351);
	
	var createNodesFromMarkup = __webpack_require__(386);
	var emptyFunction = __webpack_require__(348);
	var invariant = __webpack_require__(337);
	
	var Danger = {
	
	  /**
	   * Replaces a node with a string of markup at its current position within its
	   * parent. The markup must render into a single root node.
	   *
	   * @param {DOMElement} oldChild Child node to replace.
	   * @param {string} markup Markup to render in place of the child node.
	   * @internal
	   */
	  dangerouslyReplaceNodeWithMarkup: function (oldChild, markup) {
	    !ExecutionEnvironment.canUseDOM ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot render markup in a worker thread. Make sure `window` and `document` are available globally before requiring React when unit testing or use ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('56') : void 0;
	    !markup ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Missing markup.') : _prodInvariant('57') : void 0;
	    !(oldChild.nodeName !== 'HTML') ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot replace markup of the <html> node. This is because browser quirks make this unreliable and/or slow. If you want to render to the root you must use server rendering. See ReactDOMServer.renderToString().') : _prodInvariant('58') : void 0;
	
	    if (typeof markup === 'string') {
	      var newChild = createNodesFromMarkup(markup, emptyFunction)[0];
	      oldChild.parentNode.replaceChild(newChild, oldChild);
	    } else {
	      DOMLazyTree.replaceChildWithTree(oldChild, markup);
	    }
	  }
	
	};
	
	module.exports = Danger;

/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	/*eslint-disable fb-www/unsafe-html*/
	
	var ExecutionEnvironment = __webpack_require__(351);
	
	var createArrayFromMixed = __webpack_require__(387);
	var getMarkupWrap = __webpack_require__(388);
	var invariant = __webpack_require__(337);
	
	/**
	 * Dummy container used to render all markup.
	 */
	var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;
	
	/**
	 * Pattern used by `getNodeName`.
	 */
	var nodeNamePattern = /^\s*<(\w+)/;
	
	/**
	 * Extracts the `nodeName` of the first element in a string of markup.
	 *
	 * @param {string} markup String of markup.
	 * @return {?string} Node name of the supplied markup.
	 */
	function getNodeName(markup) {
	  var nodeNameMatch = markup.match(nodeNamePattern);
	  return nodeNameMatch && nodeNameMatch[1].toLowerCase();
	}
	
	/**
	 * Creates an array containing the nodes rendered from the supplied markup. The
	 * optionally supplied `handleScript` function will be invoked once for each
	 * <script> element that is rendered. If no `handleScript` function is supplied,
	 * an exception is thrown if any <script> elements are rendered.
	 *
	 * @param {string} markup A string of valid HTML markup.
	 * @param {?function} handleScript Invoked once for each rendered <script>.
	 * @return {array<DOMElement|DOMTextNode>} An array of rendered nodes.
	 */
	function createNodesFromMarkup(markup, handleScript) {
	  var node = dummyNode;
	  !!!dummyNode ?  false ? invariant(false, 'createNodesFromMarkup dummy not initialized') : invariant(false) : void 0;
	  var nodeName = getNodeName(markup);
	
	  var wrap = nodeName && getMarkupWrap(nodeName);
	  if (wrap) {
	    node.innerHTML = wrap[1] + markup + wrap[2];
	
	    var wrapDepth = wrap[0];
	    while (wrapDepth--) {
	      node = node.lastChild;
	    }
	  } else {
	    node.innerHTML = markup;
	  }
	
	  var scripts = node.getElementsByTagName('script');
	  if (scripts.length) {
	    !handleScript ?  false ? invariant(false, 'createNodesFromMarkup(...): Unexpected <script> element rendered.') : invariant(false) : void 0;
	    createArrayFromMixed(scripts).forEach(handleScript);
	  }
	
	  var nodes = Array.from(node.childNodes);
	  while (node.lastChild) {
	    node.removeChild(node.lastChild);
	  }
	  return nodes;
	}
	
	module.exports = createNodesFromMarkup;

/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var invariant = __webpack_require__(337);
	
	/**
	 * Convert array-like objects to arrays.
	 *
	 * This API assumes the caller knows the contents of the data type. For less
	 * well defined inputs use createArrayFromMixed.
	 *
	 * @param {object|function|filelist} obj
	 * @return {array}
	 */
	function toArray(obj) {
	  var length = obj.length;
	
	  // Some browsers builtin objects can report typeof 'function' (e.g. NodeList
	  // in old versions of Safari).
	  !(!Array.isArray(obj) && (typeof obj === 'object' || typeof obj === 'function')) ?  false ? invariant(false, 'toArray: Array-like object expected') : invariant(false) : void 0;
	
	  !(typeof length === 'number') ?  false ? invariant(false, 'toArray: Object needs a length property') : invariant(false) : void 0;
	
	  !(length === 0 || length - 1 in obj) ?  false ? invariant(false, 'toArray: Object should have keys for indices') : invariant(false) : void 0;
	
	  !(typeof obj.callee !== 'function') ?  false ? invariant(false, 'toArray: Object can\'t be `arguments`. Use rest params ' + '(function(...args) {}) or Array.from() instead.') : invariant(false) : void 0;
	
	  // Old IE doesn't give collections access to hasOwnProperty. Assume inputs
	  // without method will throw during the slice call and skip straight to the
	  // fallback.
	  if (obj.hasOwnProperty) {
	    try {
	      return Array.prototype.slice.call(obj);
	    } catch (e) {
	      // IE < 9 does not support Array#slice on collections objects
	    }
	  }
	
	  // Fall back to copying key by key. This assumes all keys have a value,
	  // so will not preserve sparsely populated inputs.
	  var ret = Array(length);
	  for (var ii = 0; ii < length; ii++) {
	    ret[ii] = obj[ii];
	  }
	  return ret;
	}
	
	/**
	 * Perform a heuristic test to determine if an object is "array-like".
	 *
	 *   A monk asked Joshu, a Zen master, "Has a dog Buddha nature?"
	 *   Joshu replied: "Mu."
	 *
	 * This function determines if its argument has "array nature": it returns
	 * true if the argument is an actual array, an `arguments' object, or an
	 * HTMLCollection (e.g. node.childNodes or node.getElementsByTagName()).
	 *
	 * It will return false for other array-like objects like Filelist.
	 *
	 * @param {*} obj
	 * @return {boolean}
	 */
	function hasArrayNature(obj) {
	  return (
	    // not null/false
	    !!obj && (
	    // arrays are objects, NodeLists are functions in Safari
	    typeof obj == 'object' || typeof obj == 'function') &&
	    // quacks like an array
	    'length' in obj &&
	    // not window
	    !('setInterval' in obj) &&
	    // no DOM node should be considered an array-like
	    // a 'select' element has 'length' and 'item' properties on IE8
	    typeof obj.nodeType != 'number' && (
	    // a real array
	    Array.isArray(obj) ||
	    // arguments
	    'callee' in obj ||
	    // HTMLCollection/NodeList
	    'item' in obj)
	  );
	}
	
	/**
	 * Ensure that the argument is an array by wrapping it in an array if it is not.
	 * Creates a copy of the argument if it is already an array.
	 *
	 * This is mostly useful idiomatically:
	 *
	 *   var createArrayFromMixed = require('createArrayFromMixed');
	 *
	 *   function takesOneOrMoreThings(things) {
	 *     things = createArrayFromMixed(things);
	 *     ...
	 *   }
	 *
	 * This allows you to treat `things' as an array, but accept scalars in the API.
	 *
	 * If you need to convert an array-like object, like `arguments`, into an array
	 * use toArray instead.
	 *
	 * @param {*} obj
	 * @return {array}
	 */
	function createArrayFromMixed(obj) {
	  if (!hasArrayNature(obj)) {
	    return [obj];
	  } else if (Array.isArray(obj)) {
	    return obj.slice();
	  } else {
	    return toArray(obj);
	  }
	}
	
	module.exports = createArrayFromMixed;

/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	/*eslint-disable fb-www/unsafe-html */
	
	var ExecutionEnvironment = __webpack_require__(351);
	
	var invariant = __webpack_require__(337);
	
	/**
	 * Dummy container used to detect which wraps are necessary.
	 */
	var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;
	
	/**
	 * Some browsers cannot use `innerHTML` to render certain elements standalone,
	 * so we wrap them, render the wrapped nodes, then extract the desired node.
	 *
	 * In IE8, certain elements cannot render alone, so wrap all elements ('*').
	 */
	
	var shouldWrap = {};
	
	var selectWrap = [1, '<select multiple="true">', '</select>'];
	var tableWrap = [1, '<table>', '</table>'];
	var trWrap = [3, '<table><tbody><tr>', '</tr></tbody></table>'];
	
	var svgWrap = [1, '<svg xmlns="http://www.w3.org/2000/svg">', '</svg>'];
	
	var markupWrap = {
	  '*': [1, '?<div>', '</div>'],
	
	  'area': [1, '<map>', '</map>'],
	  'col': [2, '<table><tbody></tbody><colgroup>', '</colgroup></table>'],
	  'legend': [1, '<fieldset>', '</fieldset>'],
	  'param': [1, '<object>', '</object>'],
	  'tr': [2, '<table><tbody>', '</tbody></table>'],
	
	  'optgroup': selectWrap,
	  'option': selectWrap,
	
	  'caption': tableWrap,
	  'colgroup': tableWrap,
	  'tbody': tableWrap,
	  'tfoot': tableWrap,
	  'thead': tableWrap,
	
	  'td': trWrap,
	  'th': trWrap
	};
	
	// Initialize the SVG elements since we know they'll always need to be wrapped
	// consistently. If they are created inside a <div> they will be initialized in
	// the wrong namespace (and will not display).
	var svgElements = ['circle', 'clipPath', 'defs', 'ellipse', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'text', 'tspan'];
	svgElements.forEach(function (nodeName) {
	  markupWrap[nodeName] = svgWrap;
	  shouldWrap[nodeName] = true;
	});
	
	/**
	 * Gets the markup wrap configuration for the supplied `nodeName`.
	 *
	 * NOTE: This lazily detects which wraps are necessary for the current browser.
	 *
	 * @param {string} nodeName Lowercase `nodeName`.
	 * @return {?array} Markup wrap configuration, if applicable.
	 */
	function getMarkupWrap(nodeName) {
	  !!!dummyNode ?  false ? invariant(false, 'Markup wrapping node not initialized') : invariant(false) : void 0;
	  if (!markupWrap.hasOwnProperty(nodeName)) {
	    nodeName = '*';
	  }
	  if (!shouldWrap.hasOwnProperty(nodeName)) {
	    if (nodeName === '*') {
	      dummyNode.innerHTML = '<link />';
	    } else {
	      dummyNode.innerHTML = '<' + nodeName + '></' + nodeName + '>';
	    }
	    shouldWrap[nodeName] = !dummyNode.firstChild;
	  }
	  return shouldWrap[nodeName] ? markupWrap[nodeName] : null;
	}
	
	module.exports = getMarkupWrap;

/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMChildrenOperations = __webpack_require__(378);
	var ReactDOMComponentTree = __webpack_require__(334);
	
	/**
	 * Operations used to process updates to DOM nodes.
	 */
	var ReactDOMIDOperations = {
	
	  /**
	   * Updates a component's children by processing a series of updates.
	   *
	   * @param {array<object>} updates List of update configurations.
	   * @internal
	   */
	  dangerouslyProcessChildrenUpdates: function (parentInst, updates) {
	    var node = ReactDOMComponentTree.getNodeFromInstance(parentInst);
	    DOMChildrenOperations.processUpdates(node, updates);
	  }
	};
	
	module.exports = ReactDOMIDOperations;

/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	/* global hasOwnProperty:true */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(335),
	    _assign = __webpack_require__(302);
	
	var AutoFocusUtils = __webpack_require__(391);
	var CSSPropertyOperations = __webpack_require__(393);
	var DOMLazyTree = __webpack_require__(379);
	var DOMNamespaces = __webpack_require__(380);
	var DOMProperty = __webpack_require__(336);
	var DOMPropertyOperations = __webpack_require__(401);
	var EventPluginHub = __webpack_require__(343);
	var EventPluginRegistry = __webpack_require__(344);
	var ReactBrowserEventEmitter = __webpack_require__(403);
	var ReactDOMComponentFlags = __webpack_require__(338);
	var ReactDOMComponentTree = __webpack_require__(334);
	var ReactDOMInput = __webpack_require__(406);
	var ReactDOMOption = __webpack_require__(413);
	var ReactDOMSelect = __webpack_require__(414);
	var ReactDOMTextarea = __webpack_require__(415);
	var ReactInstrumentation = __webpack_require__(365);
	var ReactMultiChild = __webpack_require__(416);
	var ReactServerRenderingTransaction = __webpack_require__(435);
	
	var emptyFunction = __webpack_require__(348);
	var escapeTextContentForBrowser = __webpack_require__(384);
	var invariant = __webpack_require__(337);
	var isEventSupported = __webpack_require__(368);
	var shallowEqual = __webpack_require__(424);
	var validateDOMNesting = __webpack_require__(438);
	var warning = __webpack_require__(347);
	
	var Flags = ReactDOMComponentFlags;
	var deleteListener = EventPluginHub.deleteListener;
	var getNode = ReactDOMComponentTree.getNodeFromInstance;
	var listenTo = ReactBrowserEventEmitter.listenTo;
	var registrationNameModules = EventPluginRegistry.registrationNameModules;
	
	// For quickly matching children type, to test if can be treated as content.
	var CONTENT_TYPES = { 'string': true, 'number': true };
	
	var STYLE = 'style';
	var HTML = '__html';
	var RESERVED_PROPS = {
	  children: null,
	  dangerouslySetInnerHTML: null,
	  suppressContentEditableWarning: null
	};
	
	// Node type for document fragments (Node.DOCUMENT_FRAGMENT_NODE).
	var DOC_FRAGMENT_TYPE = 11;
	
	function getDeclarationErrorAddendum(internalInstance) {
	  if (internalInstance) {
	    var owner = internalInstance._currentElement._owner || null;
	    if (owner) {
	      var name = owner.getName();
	      if (name) {
	        return ' This DOM node was rendered by `' + name + '`.';
	      }
	    }
	  }
	  return '';
	}
	
	function friendlyStringify(obj) {
	  if (typeof obj === 'object') {
	    if (Array.isArray(obj)) {
	      return '[' + obj.map(friendlyStringify).join(', ') + ']';
	    } else {
	      var pairs = [];
	      for (var key in obj) {
	        if (Object.prototype.hasOwnProperty.call(obj, key)) {
	          var keyEscaped = /^[a-z$_][\w$_]*$/i.test(key) ? key : JSON.stringify(key);
	          pairs.push(keyEscaped + ': ' + friendlyStringify(obj[key]));
	        }
	      }
	      return '{' + pairs.join(', ') + '}';
	    }
	  } else if (typeof obj === 'string') {
	    return JSON.stringify(obj);
	  } else if (typeof obj === 'function') {
	    return '[function object]';
	  }
	  // Differs from JSON.stringify in that undefined because undefined and that
	  // inf and nan don't become null
	  return String(obj);
	}
	
	var styleMutationWarning = {};
	
	function checkAndWarnForMutatedStyle(style1, style2, component) {
	  if (style1 == null || style2 == null) {
	    return;
	  }
	  if (shallowEqual(style1, style2)) {
	    return;
	  }
	
	  var componentName = component._tag;
	  var owner = component._currentElement._owner;
	  var ownerName;
	  if (owner) {
	    ownerName = owner.getName();
	  }
	
	  var hash = ownerName + '|' + componentName;
	
	  if (styleMutationWarning.hasOwnProperty(hash)) {
	    return;
	  }
	
	  styleMutationWarning[hash] = true;
	
	   false ? warning(false, '`%s` was passed a style object that has previously been mutated. ' + 'Mutating `style` is deprecated. Consider cloning it beforehand. Check ' + 'the `render` %s. Previous style: %s. Mutated style: %s.', componentName, owner ? 'of `' + ownerName + '`' : 'using <' + componentName + '>', friendlyStringify(style1), friendlyStringify(style2)) : void 0;
	}
	
	/**
	 * @param {object} component
	 * @param {?object} props
	 */
	function assertValidProps(component, props) {
	  if (!props) {
	    return;
	  }
	  // Note the use of `==` which checks for null or undefined.
	  if (voidElementTags[component._tag]) {
	    !(props.children == null && props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '%s is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`.%s', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : _prodInvariant('137', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : void 0;
	  }
	  if (props.dangerouslySetInnerHTML != null) {
	    !(props.children == null) ?  false ? invariant(false, 'Can only set one of `children` or `props.dangerouslySetInnerHTML`.') : _prodInvariant('60') : void 0;
	    !(typeof props.dangerouslySetInnerHTML === 'object' && HTML in props.dangerouslySetInnerHTML) ?  false ? invariant(false, '`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://fb.me/react-invariant-dangerously-set-inner-html for more information.') : _prodInvariant('61') : void 0;
	  }
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(props.innerHTML == null, 'Directly setting property `innerHTML` is not permitted. ' + 'For more information, lookup documentation on `dangerouslySetInnerHTML`.') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(props.suppressContentEditableWarning || !props.contentEditable || props.children == null, 'A component is `contentEditable` and contains `children` managed by ' + 'React. It is now your responsibility to guarantee that none of ' + 'those nodes are unexpectedly modified or duplicated. This is ' + 'probably not intentional.') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(props.onFocusIn == null && props.onFocusOut == null, 'React uses onFocus and onBlur instead of onFocusIn and onFocusOut. ' + 'All React events are normalized to bubble, so onFocusIn and onFocusOut ' + 'are not needed/supported by React.') : void 0;
	  }
	  !(props.style == null || typeof props.style === 'object') ?  false ? invariant(false, 'The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + \'em\'}} when using JSX.%s', getDeclarationErrorAddendum(component)) : _prodInvariant('62', getDeclarationErrorAddendum(component)) : void 0;
	}
	
	function enqueuePutListener(inst, registrationName, listener, transaction) {
	  if (transaction instanceof ReactServerRenderingTransaction) {
	    return;
	  }
	  if (false) {
	    // IE8 has no API for event capturing and the `onScroll` event doesn't
	    // bubble.
	    process.env.NODE_ENV !== 'production' ? warning(registrationName !== 'onScroll' || isEventSupported('scroll', true), 'This browser doesn\'t support the `onScroll` event') : void 0;
	  }
	  var containerInfo = inst._hostContainerInfo;
	  var isDocumentFragment = containerInfo._node && containerInfo._node.nodeType === DOC_FRAGMENT_TYPE;
	  var doc = isDocumentFragment ? containerInfo._node : containerInfo._ownerDocument;
	  listenTo(registrationName, doc);
	  transaction.getReactMountReady().enqueue(putListener, {
	    inst: inst,
	    registrationName: registrationName,
	    listener: listener
	  });
	}
	
	function putListener() {
	  var listenerToPut = this;
	  EventPluginHub.putListener(listenerToPut.inst, listenerToPut.registrationName, listenerToPut.listener);
	}
	
	function inputPostMount() {
	  var inst = this;
	  ReactDOMInput.postMountWrapper(inst);
	}
	
	function textareaPostMount() {
	  var inst = this;
	  ReactDOMTextarea.postMountWrapper(inst);
	}
	
	function optionPostMount() {
	  var inst = this;
	  ReactDOMOption.postMountWrapper(inst);
	}
	
	var setAndValidateContentChildDev = emptyFunction;
	if (false) {
	  setAndValidateContentChildDev = function (content) {
	    var hasExistingContent = this._contentDebugID != null;
	    var debugID = this._debugID;
	    // This ID represents the inlined child that has no backing instance:
	    var contentDebugID = -debugID;
	
	    if (content == null) {
	      if (hasExistingContent) {
	        ReactInstrumentation.debugTool.onUnmountComponent(this._contentDebugID);
	      }
	      this._contentDebugID = null;
	      return;
	    }
	
	    validateDOMNesting(null, String(content), this, this._ancestorInfo);
	    this._contentDebugID = contentDebugID;
	    if (hasExistingContent) {
	      ReactInstrumentation.debugTool.onBeforeUpdateComponent(contentDebugID, content);
	      ReactInstrumentation.debugTool.onUpdateComponent(contentDebugID);
	    } else {
	      ReactInstrumentation.debugTool.onBeforeMountComponent(contentDebugID, content, debugID);
	      ReactInstrumentation.debugTool.onMountComponent(contentDebugID);
	      ReactInstrumentation.debugTool.onSetChildren(debugID, [contentDebugID]);
	    }
	  };
	}
	
	// There are so many media events, it makes sense to just
	// maintain a list rather than create a `trapBubbledEvent` for each
	var mediaEvents = {
	  topAbort: 'abort',
	  topCanPlay: 'canplay',
	  topCanPlayThrough: 'canplaythrough',
	  topDurationChange: 'durationchange',
	  topEmptied: 'emptied',
	  topEncrypted: 'encrypted',
	  topEnded: 'ended',
	  topError: 'error',
	  topLoadedData: 'loadeddata',
	  topLoadedMetadata: 'loadedmetadata',
	  topLoadStart: 'loadstart',
	  topPause: 'pause',
	  topPlay: 'play',
	  topPlaying: 'playing',
	  topProgress: 'progress',
	  topRateChange: 'ratechange',
	  topSeeked: 'seeked',
	  topSeeking: 'seeking',
	  topStalled: 'stalled',
	  topSuspend: 'suspend',
	  topTimeUpdate: 'timeupdate',
	  topVolumeChange: 'volumechange',
	  topWaiting: 'waiting'
	};
	
	function trapBubbledEventsLocal() {
	  var inst = this;
	  // If a component renders to null or if another component fatals and causes
	  // the state of the tree to be corrupted, `node` here can be null.
	  !inst._rootNodeID ?  false ? invariant(false, 'Must be mounted to trap events') : _prodInvariant('63') : void 0;
	  var node = getNode(inst);
	  !node ?  false ? invariant(false, 'trapBubbledEvent(...): Requires node to be rendered.') : _prodInvariant('64') : void 0;
	
	  switch (inst._tag) {
	    case 'iframe':
	    case 'object':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topLoad', 'load', node)];
	      break;
	    case 'video':
	    case 'audio':
	
	      inst._wrapperState.listeners = [];
	      // Create listener for each media event
	      for (var event in mediaEvents) {
	        if (mediaEvents.hasOwnProperty(event)) {
	          inst._wrapperState.listeners.push(ReactBrowserEventEmitter.trapBubbledEvent(event, mediaEvents[event], node));
	        }
	      }
	      break;
	    case 'source':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topError', 'error', node)];
	      break;
	    case 'img':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topError', 'error', node), ReactBrowserEventEmitter.trapBubbledEvent('topLoad', 'load', node)];
	      break;
	    case 'form':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topReset', 'reset', node), ReactBrowserEventEmitter.trapBubbledEvent('topSubmit', 'submit', node)];
	      break;
	    case 'input':
	    case 'select':
	    case 'textarea':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topInvalid', 'invalid', node)];
	      break;
	  }
	}
	
	function postUpdateSelectWrapper() {
	  ReactDOMSelect.postUpdateWrapper(this);
	}
	
	// For HTML, certain tags should omit their close tag. We keep a whitelist for
	// those special-case tags.
	
	var omittedCloseTags = {
	  'area': true,
	  'base': true,
	  'br': true,
	  'col': true,
	  'embed': true,
	  'hr': true,
	  'img': true,
	  'input': true,
	  'keygen': true,
	  'link': true,
	  'meta': true,
	  'param': true,
	  'source': true,
	  'track': true,
	  'wbr': true
	};
	
	var newlineEatingTags = {
	  'listing': true,
	  'pre': true,
	  'textarea': true
	};
	
	// For HTML, certain tags cannot have children. This has the same purpose as
	// `omittedCloseTags` except that `menuitem` should still have its closing tag.
	
	var voidElementTags = _assign({
	  'menuitem': true
	}, omittedCloseTags);
	
	// We accept any tag to be rendered but since this gets injected into arbitrary
	// HTML, we want to make sure that it's a safe tag.
	// http://www.w3.org/TR/REC-xml/#NT-Name
	
	var VALID_TAG_REGEX = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/; // Simplified subset
	var validatedTagCache = {};
	var hasOwnProperty = {}.hasOwnProperty;
	
	function validateDangerousTag(tag) {
	  if (!hasOwnProperty.call(validatedTagCache, tag)) {
	    !VALID_TAG_REGEX.test(tag) ?  false ? invariant(false, 'Invalid tag: %s', tag) : _prodInvariant('65', tag) : void 0;
	    validatedTagCache[tag] = true;
	  }
	}
	
	function isCustomComponent(tagName, props) {
	  return tagName.indexOf('-') >= 0 || props.is != null;
	}
	
	var globalIdCounter = 1;
	
	/**
	 * Creates a new React class that is idempotent and capable of containing other
	 * React components. It accepts event listeners and DOM properties that are
	 * valid according to `DOMProperty`.
	 *
	 *  - Event listeners: `onClick`, `onMouseDown`, etc.
	 *  - DOM properties: `className`, `name`, `title`, etc.
	 *
	 * The `style` property functions differently from the DOM API. It accepts an
	 * object mapping of style properties to values.
	 *
	 * @constructor ReactDOMComponent
	 * @extends ReactMultiChild
	 */
	function ReactDOMComponent(element) {
	  var tag = element.type;
	  validateDangerousTag(tag);
	  this._currentElement = element;
	  this._tag = tag.toLowerCase();
	  this._namespaceURI = null;
	  this._renderedChildren = null;
	  this._previousStyle = null;
	  this._previousStyleCopy = null;
	  this._hostNode = null;
	  this._hostParent = null;
	  this._rootNodeID = 0;
	  this._domID = 0;
	  this._hostContainerInfo = null;
	  this._wrapperState = null;
	  this._topLevelWrapper = null;
	  this._flags = 0;
	  if (false) {
	    this._ancestorInfo = null;
	    setAndValidateContentChildDev.call(this, null);
	  }
	}
	
	ReactDOMComponent.displayName = 'ReactDOMComponent';
	
	ReactDOMComponent.Mixin = {
	
	  /**
	   * Generates root tag markup then recurses. This method has side effects and
	   * is not idempotent.
	   *
	   * @internal
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?ReactDOMComponent} the parent component instance
	   * @param {?object} info about the host container
	   * @param {object} context
	   * @return {string} The computed markup.
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    this._rootNodeID = globalIdCounter++;
	    this._domID = hostContainerInfo._idCounter++;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var props = this._currentElement.props;
	
	    switch (this._tag) {
	      case 'audio':
	      case 'form':
	      case 'iframe':
	      case 'img':
	      case 'link':
	      case 'object':
	      case 'source':
	      case 'video':
	        this._wrapperState = {
	          listeners: null
	        };
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'input':
	        ReactDOMInput.mountWrapper(this, props, hostParent);
	        props = ReactDOMInput.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'option':
	        ReactDOMOption.mountWrapper(this, props, hostParent);
	        props = ReactDOMOption.getHostProps(this, props);
	        break;
	      case 'select':
	        ReactDOMSelect.mountWrapper(this, props, hostParent);
	        props = ReactDOMSelect.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'textarea':
	        ReactDOMTextarea.mountWrapper(this, props, hostParent);
	        props = ReactDOMTextarea.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	    }
	
	    assertValidProps(this, props);
	
	    // We create tags in the namespace of their parent container, except HTML
	    // tags get no namespace.
	    var namespaceURI;
	    var parentTag;
	    if (hostParent != null) {
	      namespaceURI = hostParent._namespaceURI;
	      parentTag = hostParent._tag;
	    } else if (hostContainerInfo._tag) {
	      namespaceURI = hostContainerInfo._namespaceURI;
	      parentTag = hostContainerInfo._tag;
	    }
	    if (namespaceURI == null || namespaceURI === DOMNamespaces.svg && parentTag === 'foreignobject') {
	      namespaceURI = DOMNamespaces.html;
	    }
	    if (namespaceURI === DOMNamespaces.html) {
	      if (this._tag === 'svg') {
	        namespaceURI = DOMNamespaces.svg;
	      } else if (this._tag === 'math') {
	        namespaceURI = DOMNamespaces.mathml;
	      }
	    }
	    this._namespaceURI = namespaceURI;
	
	    if (false) {
	      var parentInfo;
	      if (hostParent != null) {
	        parentInfo = hostParent._ancestorInfo;
	      } else if (hostContainerInfo._tag) {
	        parentInfo = hostContainerInfo._ancestorInfo;
	      }
	      if (parentInfo) {
	        // parentInfo should always be present except for the top-level
	        // component when server rendering
	        validateDOMNesting(this._tag, null, this, parentInfo);
	      }
	      this._ancestorInfo = validateDOMNesting.updatedAncestorInfo(parentInfo, this._tag, this);
	    }
	
	    var mountImage;
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var el;
	      if (namespaceURI === DOMNamespaces.html) {
	        if (this._tag === 'script') {
	          // Create the script via .innerHTML so its "parser-inserted" flag is
	          // set to true and it does not execute
	          var div = ownerDocument.createElement('div');
	          var type = this._currentElement.type;
	          div.innerHTML = '<' + type + '></' + type + '>';
	          el = div.removeChild(div.firstChild);
	        } else if (props.is) {
	          el = ownerDocument.createElement(this._currentElement.type, props.is);
	        } else {
	          // Separate else branch instead of using `props.is || undefined` above becuase of a Firefox bug.
	          // See discussion in https://github.com/facebook/react/pull/6896
	          // and discussion in https://bugzilla.mozilla.org/show_bug.cgi?id=1276240
	          el = ownerDocument.createElement(this._currentElement.type);
	        }
	      } else {
	        el = ownerDocument.createElementNS(namespaceURI, this._currentElement.type);
	      }
	      ReactDOMComponentTree.precacheNode(this, el);
	      this._flags |= Flags.hasCachedChildNodes;
	      if (!this._hostParent) {
	        DOMPropertyOperations.setAttributeForRoot(el);
	      }
	      this._updateDOMProperties(null, props, transaction);
	      var lazyTree = DOMLazyTree(el);
	      this._createInitialChildren(transaction, props, context, lazyTree);
	      mountImage = lazyTree;
	    } else {
	      var tagOpen = this._createOpenTagMarkupAndPutListeners(transaction, props);
	      var tagContent = this._createContentMarkup(transaction, props, context);
	      if (!tagContent && omittedCloseTags[this._tag]) {
	        mountImage = tagOpen + '/>';
	      } else {
	        mountImage = tagOpen + '>' + tagContent + '</' + this._currentElement.type + '>';
	      }
	    }
	
	    switch (this._tag) {
	      case 'input':
	        transaction.getReactMountReady().enqueue(inputPostMount, this);
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'textarea':
	        transaction.getReactMountReady().enqueue(textareaPostMount, this);
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'select':
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'button':
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'option':
	        transaction.getReactMountReady().enqueue(optionPostMount, this);
	        break;
	    }
	
	    return mountImage;
	  },
	
	  /**
	   * Creates markup for the open tag and all attributes.
	   *
	   * This method has side effects because events get registered.
	   *
	   * Iterating over object properties is faster than iterating over arrays.
	   * @see http://jsperf.com/obj-vs-arr-iteration
	   *
	   * @private
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} props
	   * @return {string} Markup of opening tag.
	   */
	  _createOpenTagMarkupAndPutListeners: function (transaction, props) {
	    var ret = '<' + this._currentElement.type;
	
	    for (var propKey in props) {
	      if (!props.hasOwnProperty(propKey)) {
	        continue;
	      }
	      var propValue = props[propKey];
	      if (propValue == null) {
	        continue;
	      }
	      if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (propValue) {
	          enqueuePutListener(this, propKey, propValue, transaction);
	        }
	      } else {
	        if (propKey === STYLE) {
	          if (propValue) {
	            if (false) {
	              // See `_updateDOMProperties`. style block
	              this._previousStyle = propValue;
	            }
	            propValue = this._previousStyleCopy = _assign({}, props.style);
	          }
	          propValue = CSSPropertyOperations.createMarkupForStyles(propValue, this);
	        }
	        var markup = null;
	        if (this._tag != null && isCustomComponent(this._tag, props)) {
	          if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	            markup = DOMPropertyOperations.createMarkupForCustomAttribute(propKey, propValue);
	          }
	        } else {
	          markup = DOMPropertyOperations.createMarkupForProperty(propKey, propValue);
	        }
	        if (markup) {
	          ret += ' ' + markup;
	        }
	      }
	    }
	
	    // For static pages, no need to put React ID and checksum. Saves lots of
	    // bytes.
	    if (transaction.renderToStaticMarkup) {
	      return ret;
	    }
	
	    if (!this._hostParent) {
	      ret += ' ' + DOMPropertyOperations.createMarkupForRoot();
	    }
	    ret += ' ' + DOMPropertyOperations.createMarkupForID(this._domID);
	    return ret;
	  },
	
	  /**
	   * Creates markup for the content between the tags.
	   *
	   * @private
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} props
	   * @param {object} context
	   * @return {string} Content markup.
	   */
	  _createContentMarkup: function (transaction, props, context) {
	    var ret = '';
	
	    // Intentional use of != to avoid catching zero/false.
	    var innerHTML = props.dangerouslySetInnerHTML;
	    if (innerHTML != null) {
	      if (innerHTML.__html != null) {
	        ret = innerHTML.__html;
	      }
	    } else {
	      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
	      var childrenToUse = contentToUse != null ? null : props.children;
	      if (contentToUse != null) {
	        // TODO: Validate that text is allowed as a child of this node
	        ret = escapeTextContentForBrowser(contentToUse);
	        if (false) {
	          setAndValidateContentChildDev.call(this, contentToUse);
	        }
	      } else if (childrenToUse != null) {
	        var mountImages = this.mountChildren(childrenToUse, transaction, context);
	        ret = mountImages.join('');
	      }
	    }
	    if (newlineEatingTags[this._tag] && ret.charAt(0) === '\n') {
	      // text/html ignores the first character in these tags if it's a newline
	      // Prefer to break application/xml over text/html (for now) by adding
	      // a newline specifically to get eaten by the parser. (Alternately for
	      // textareas, replacing "^\n" with "\r\n" doesn't get eaten, and the first
	      // \r is normalized out by HTMLTextAreaElement#value.)
	      // See: <http://www.w3.org/TR/html-polyglot/#newlines-in-textarea-and-pre>
	      // See: <http://www.w3.org/TR/html5/syntax.html#element-restrictions>
	      // See: <http://www.w3.org/TR/html5/syntax.html#newlines>
	      // See: Parsing of "textarea" "listing" and "pre" elements
	      //  from <http://www.w3.org/TR/html5/syntax.html#parsing-main-inbody>
	      return '\n' + ret;
	    } else {
	      return ret;
	    }
	  },
	
	  _createInitialChildren: function (transaction, props, context, lazyTree) {
	    // Intentional use of != to avoid catching zero/false.
	    var innerHTML = props.dangerouslySetInnerHTML;
	    if (innerHTML != null) {
	      if (innerHTML.__html != null) {
	        DOMLazyTree.queueHTML(lazyTree, innerHTML.__html);
	      }
	    } else {
	      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
	      var childrenToUse = contentToUse != null ? null : props.children;
	      // TODO: Validate that text is allowed as a child of this node
	      if (contentToUse != null) {
	        // Avoid setting textContent when the text is empty. In IE11 setting
	        // textContent on a text area will cause the placeholder to not
	        // show within the textarea until it has been focused and blurred again.
	        // https://github.com/facebook/react/issues/6731#issuecomment-254874553
	        if (contentToUse !== '') {
	          if (false) {
	            setAndValidateContentChildDev.call(this, contentToUse);
	          }
	          DOMLazyTree.queueText(lazyTree, contentToUse);
	        }
	      } else if (childrenToUse != null) {
	        var mountImages = this.mountChildren(childrenToUse, transaction, context);
	        for (var i = 0; i < mountImages.length; i++) {
	          DOMLazyTree.queueChild(lazyTree, mountImages[i]);
	        }
	      }
	    }
	  },
	
	  /**
	   * Receives a next element and updates the component.
	   *
	   * @internal
	   * @param {ReactElement} nextElement
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} context
	   */
	  receiveComponent: function (nextElement, transaction, context) {
	    var prevElement = this._currentElement;
	    this._currentElement = nextElement;
	    this.updateComponent(transaction, prevElement, nextElement, context);
	  },
	
	  /**
	   * Updates a DOM component after it has already been allocated and
	   * attached to the DOM. Reconciles the root DOM node, then recurses.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @param {ReactElement} prevElement
	   * @param {ReactElement} nextElement
	   * @internal
	   * @overridable
	   */
	  updateComponent: function (transaction, prevElement, nextElement, context) {
	    var lastProps = prevElement.props;
	    var nextProps = this._currentElement.props;
	
	    switch (this._tag) {
	      case 'input':
	        lastProps = ReactDOMInput.getHostProps(this, lastProps);
	        nextProps = ReactDOMInput.getHostProps(this, nextProps);
	        break;
	      case 'option':
	        lastProps = ReactDOMOption.getHostProps(this, lastProps);
	        nextProps = ReactDOMOption.getHostProps(this, nextProps);
	        break;
	      case 'select':
	        lastProps = ReactDOMSelect.getHostProps(this, lastProps);
	        nextProps = ReactDOMSelect.getHostProps(this, nextProps);
	        break;
	      case 'textarea':
	        lastProps = ReactDOMTextarea.getHostProps(this, lastProps);
	        nextProps = ReactDOMTextarea.getHostProps(this, nextProps);
	        break;
	    }
	
	    assertValidProps(this, nextProps);
	    this._updateDOMProperties(lastProps, nextProps, transaction);
	    this._updateDOMChildren(lastProps, nextProps, transaction, context);
	
	    switch (this._tag) {
	      case 'input':
	        // Update the wrapper around inputs *after* updating props. This has to
	        // happen after `_updateDOMProperties`. Otherwise HTML5 input validations
	        // raise warnings and prevent the new value from being assigned.
	        ReactDOMInput.updateWrapper(this);
	        break;
	      case 'textarea':
	        ReactDOMTextarea.updateWrapper(this);
	        break;
	      case 'select':
	        // <select> value update needs to occur after <option> children
	        // reconciliation
	        transaction.getReactMountReady().enqueue(postUpdateSelectWrapper, this);
	        break;
	    }
	  },
	
	  /**
	   * Reconciles the properties by detecting differences in property values and
	   * updating the DOM as necessary. This function is probably the single most
	   * critical path for performance optimization.
	   *
	   * TODO: Benchmark whether checking for changed values in memory actually
	   *       improves performance (especially statically positioned elements).
	   * TODO: Benchmark the effects of putting this at the top since 99% of props
	   *       do not change for a given reconciliation.
	   * TODO: Benchmark areas that can be improved with caching.
	   *
	   * @private
	   * @param {object} lastProps
	   * @param {object} nextProps
	   * @param {?DOMElement} node
	   */
	  _updateDOMProperties: function (lastProps, nextProps, transaction) {
	    var propKey;
	    var styleName;
	    var styleUpdates;
	    for (propKey in lastProps) {
	      if (nextProps.hasOwnProperty(propKey) || !lastProps.hasOwnProperty(propKey) || lastProps[propKey] == null) {
	        continue;
	      }
	      if (propKey === STYLE) {
	        var lastStyle = this._previousStyleCopy;
	        for (styleName in lastStyle) {
	          if (lastStyle.hasOwnProperty(styleName)) {
	            styleUpdates = styleUpdates || {};
	            styleUpdates[styleName] = '';
	          }
	        }
	        this._previousStyleCopy = null;
	      } else if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (lastProps[propKey]) {
	          // Only call deleteListener if there was a listener previously or
	          // else willDeleteListener gets called when there wasn't actually a
	          // listener (e.g., onClick={null})
	          deleteListener(this, propKey);
	        }
	      } else if (isCustomComponent(this._tag, lastProps)) {
	        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	          DOMPropertyOperations.deleteValueForAttribute(getNode(this), propKey);
	        }
	      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
	        DOMPropertyOperations.deleteValueForProperty(getNode(this), propKey);
	      }
	    }
	    for (propKey in nextProps) {
	      var nextProp = nextProps[propKey];
	      var lastProp = propKey === STYLE ? this._previousStyleCopy : lastProps != null ? lastProps[propKey] : undefined;
	      if (!nextProps.hasOwnProperty(propKey) || nextProp === lastProp || nextProp == null && lastProp == null) {
	        continue;
	      }
	      if (propKey === STYLE) {
	        if (nextProp) {
	          if (false) {
	            checkAndWarnForMutatedStyle(this._previousStyleCopy, this._previousStyle, this);
	            this._previousStyle = nextProp;
	          }
	          nextProp = this._previousStyleCopy = _assign({}, nextProp);
	        } else {
	          this._previousStyleCopy = null;
	        }
	        if (lastProp) {
	          // Unset styles on `lastProp` but not on `nextProp`.
	          for (styleName in lastProp) {
	            if (lastProp.hasOwnProperty(styleName) && (!nextProp || !nextProp.hasOwnProperty(styleName))) {
	              styleUpdates = styleUpdates || {};
	              styleUpdates[styleName] = '';
	            }
	          }
	          // Update styles that changed since `lastProp`.
	          for (styleName in nextProp) {
	            if (nextProp.hasOwnProperty(styleName) && lastProp[styleName] !== nextProp[styleName]) {
	              styleUpdates = styleUpdates || {};
	              styleUpdates[styleName] = nextProp[styleName];
	            }
	          }
	        } else {
	          // Relies on `updateStylesByID` not mutating `styleUpdates`.
	          styleUpdates = nextProp;
	        }
	      } else if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (nextProp) {
	          enqueuePutListener(this, propKey, nextProp, transaction);
	        } else if (lastProp) {
	          deleteListener(this, propKey);
	        }
	      } else if (isCustomComponent(this._tag, nextProps)) {
	        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	          DOMPropertyOperations.setValueForAttribute(getNode(this), propKey, nextProp);
	        }
	      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
	        var node = getNode(this);
	        // If we're updating to null or undefined, we should remove the property
	        // from the DOM node instead of inadvertently setting to a string. This
	        // brings us in line with the same behavior we have on initial render.
	        if (nextProp != null) {
	          DOMPropertyOperations.setValueForProperty(node, propKey, nextProp);
	        } else {
	          DOMPropertyOperations.deleteValueForProperty(node, propKey);
	        }
	      }
	    }
	    if (styleUpdates) {
	      CSSPropertyOperations.setValueForStyles(getNode(this), styleUpdates, this);
	    }
	  },
	
	  /**
	   * Reconciles the children with the various properties that affect the
	   * children content.
	   *
	   * @param {object} lastProps
	   * @param {object} nextProps
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   */
	  _updateDOMChildren: function (lastProps, nextProps, transaction, context) {
	    var lastContent = CONTENT_TYPES[typeof lastProps.children] ? lastProps.children : null;
	    var nextContent = CONTENT_TYPES[typeof nextProps.children] ? nextProps.children : null;
	
	    var lastHtml = lastProps.dangerouslySetInnerHTML && lastProps.dangerouslySetInnerHTML.__html;
	    var nextHtml = nextProps.dangerouslySetInnerHTML && nextProps.dangerouslySetInnerHTML.__html;
	
	    // Note the use of `!=` which checks for null or undefined.
	    var lastChildren = lastContent != null ? null : lastProps.children;
	    var nextChildren = nextContent != null ? null : nextProps.children;
	
	    // If we're switching from children to content/html or vice versa, remove
	    // the old content
	    var lastHasContentOrHtml = lastContent != null || lastHtml != null;
	    var nextHasContentOrHtml = nextContent != null || nextHtml != null;
	    if (lastChildren != null && nextChildren == null) {
	      this.updateChildren(null, transaction, context);
	    } else if (lastHasContentOrHtml && !nextHasContentOrHtml) {
	      this.updateTextContent('');
	      if (false) {
	        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
	      }
	    }
	
	    if (nextContent != null) {
	      if (lastContent !== nextContent) {
	        this.updateTextContent('' + nextContent);
	        if (false) {
	          setAndValidateContentChildDev.call(this, nextContent);
	        }
	      }
	    } else if (nextHtml != null) {
	      if (lastHtml !== nextHtml) {
	        this.updateMarkup('' + nextHtml);
	      }
	      if (false) {
	        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
	      }
	    } else if (nextChildren != null) {
	      if (false) {
	        setAndValidateContentChildDev.call(this, null);
	      }
	
	      this.updateChildren(nextChildren, transaction, context);
	    }
	  },
	
	  getHostNode: function () {
	    return getNode(this);
	  },
	
	  /**
	   * Destroys all event registrations for this instance. Does not remove from
	   * the DOM. That must be done by the parent.
	   *
	   * @internal
	   */
	  unmountComponent: function (safely) {
	    switch (this._tag) {
	      case 'audio':
	      case 'form':
	      case 'iframe':
	      case 'img':
	      case 'link':
	      case 'object':
	      case 'source':
	      case 'video':
	        var listeners = this._wrapperState.listeners;
	        if (listeners) {
	          for (var i = 0; i < listeners.length; i++) {
	            listeners[i].remove();
	          }
	        }
	        break;
	      case 'html':
	      case 'head':
	      case 'body':
	        /**
	         * Components like <html> <head> and <body> can't be removed or added
	         * easily in a cross-browser way, however it's valuable to be able to
	         * take advantage of React's reconciliation for styling and <title>
	         * management. So we just document it and throw in dangerous cases.
	         */
	         true ?  false ? invariant(false, '<%s> tried to unmount. Because of cross-browser quirks it is impossible to unmount some top-level components (eg <html>, <head>, and <body>) reliably and efficiently. To fix this, have a single top-level component that never unmounts render these elements.', this._tag) : _prodInvariant('66', this._tag) : void 0;
	        break;
	    }
	
	    this.unmountChildren(safely);
	    ReactDOMComponentTree.uncacheNode(this);
	    EventPluginHub.deleteAllListeners(this);
	    this._rootNodeID = 0;
	    this._domID = 0;
	    this._wrapperState = null;
	
	    if (false) {
	      setAndValidateContentChildDev.call(this, null);
	    }
	  },
	
	  getPublicInstance: function () {
	    return getNode(this);
	  }
	
	};
	
	_assign(ReactDOMComponent.prototype, ReactDOMComponent.Mixin, ReactMultiChild.Mixin);
	
	module.exports = ReactDOMComponent;

/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactDOMComponentTree = __webpack_require__(334);
	
	var focusNode = __webpack_require__(392);
	
	var AutoFocusUtils = {
	  focusDOMComponent: function () {
	    focusNode(ReactDOMComponentTree.getNodeFromInstance(this));
	  }
	};
	
	module.exports = AutoFocusUtils;

/***/ }),
/* 392 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * @param {DOMElement} node input/textarea to focus
	 */
	
	function focusNode(node) {
	  // IE8 can throw "Can't move focus to the control because it is invisible,
	  // not enabled, or of a type that does not accept the focus." for all kinds of
	  // reasons that are too expensive and fragile to test.
	  try {
	    node.focus();
	  } catch (e) {}
	}
	
	module.exports = focusNode;

/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var CSSProperty = __webpack_require__(394);
	var ExecutionEnvironment = __webpack_require__(351);
	var ReactInstrumentation = __webpack_require__(365);
	
	var camelizeStyleName = __webpack_require__(395);
	var dangerousStyleValue = __webpack_require__(397);
	var hyphenateStyleName = __webpack_require__(398);
	var memoizeStringOnly = __webpack_require__(400);
	var warning = __webpack_require__(347);
	
	var processStyleName = memoizeStringOnly(function (styleName) {
	  return hyphenateStyleName(styleName);
	});
	
	var hasShorthandPropertyBug = false;
	var styleFloatAccessor = 'cssFloat';
	if (ExecutionEnvironment.canUseDOM) {
	  var tempStyle = document.createElement('div').style;
	  try {
	    // IE8 throws "Invalid argument." if resetting shorthand style properties.
	    tempStyle.font = '';
	  } catch (e) {
	    hasShorthandPropertyBug = true;
	  }
	  // IE8 only supports accessing cssFloat (standard) as styleFloat
	  if (document.documentElement.style.cssFloat === undefined) {
	    styleFloatAccessor = 'styleFloat';
	  }
	}
	
	if (false) {
	  // 'msTransform' is correct, but the other prefixes should be capitalized
	  var badVendoredStyleNamePattern = /^(?:webkit|moz|o)[A-Z]/;
	
	  // style values shouldn't contain a semicolon
	  var badStyleValueWithSemicolonPattern = /;\s*$/;
	
	  var warnedStyleNames = {};
	  var warnedStyleValues = {};
	  var warnedForNaNValue = false;
	
	  var warnHyphenatedStyleName = function (name, owner) {
	    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
	      return;
	    }
	
	    warnedStyleNames[name] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported style property %s. Did you mean %s?%s', name, camelizeStyleName(name), checkRenderMessage(owner)) : void 0;
	  };
	
	  var warnBadVendoredStyleName = function (name, owner) {
	    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
	      return;
	    }
	
	    warnedStyleNames[name] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported vendor-prefixed style property %s. Did you mean %s?%s', name, name.charAt(0).toUpperCase() + name.slice(1), checkRenderMessage(owner)) : void 0;
	  };
	
	  var warnStyleValueWithSemicolon = function (name, value, owner) {
	    if (warnedStyleValues.hasOwnProperty(value) && warnedStyleValues[value]) {
	      return;
	    }
	
	    warnedStyleValues[value] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Style property values shouldn\'t contain a semicolon.%s ' + 'Try "%s: %s" instead.', checkRenderMessage(owner), name, value.replace(badStyleValueWithSemicolonPattern, '')) : void 0;
	  };
	
	  var warnStyleValueIsNaN = function (name, value, owner) {
	    if (warnedForNaNValue) {
	      return;
	    }
	
	    warnedForNaNValue = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, '`NaN` is an invalid value for the `%s` css style property.%s', name, checkRenderMessage(owner)) : void 0;
	  };
	
	  var checkRenderMessage = function (owner) {
	    if (owner) {
	      var name = owner.getName();
	      if (name) {
	        return ' Check the render method of `' + name + '`.';
	      }
	    }
	    return '';
	  };
	
	  /**
	   * @param {string} name
	   * @param {*} value
	   * @param {ReactDOMComponent} component
	   */
	  var warnValidStyle = function (name, value, component) {
	    var owner;
	    if (component) {
	      owner = component._currentElement._owner;
	    }
	    if (name.indexOf('-') > -1) {
	      warnHyphenatedStyleName(name, owner);
	    } else if (badVendoredStyleNamePattern.test(name)) {
	      warnBadVendoredStyleName(name, owner);
	    } else if (badStyleValueWithSemicolonPattern.test(value)) {
	      warnStyleValueWithSemicolon(name, value, owner);
	    }
	
	    if (typeof value === 'number' && isNaN(value)) {
	      warnStyleValueIsNaN(name, value, owner);
	    }
	  };
	}
	
	/**
	 * Operations for dealing with CSS properties.
	 */
	var CSSPropertyOperations = {
	
	  /**
	   * Serializes a mapping of style properties for use as inline styles:
	   *
	   *   > createMarkupForStyles({width: '200px', height: 0})
	   *   "width:200px;height:0;"
	   *
	   * Undefined values are ignored so that declarative programming is easier.
	   * The result should be HTML-escaped before insertion into the DOM.
	   *
	   * @param {object} styles
	   * @param {ReactDOMComponent} component
	   * @return {?string}
	   */
	  createMarkupForStyles: function (styles, component) {
	    var serialized = '';
	    for (var styleName in styles) {
	      if (!styles.hasOwnProperty(styleName)) {
	        continue;
	      }
	      var styleValue = styles[styleName];
	      if (false) {
	        warnValidStyle(styleName, styleValue, component);
	      }
	      if (styleValue != null) {
	        serialized += processStyleName(styleName) + ':';
	        serialized += dangerousStyleValue(styleName, styleValue, component) + ';';
	      }
	    }
	    return serialized || null;
	  },
	
	  /**
	   * Sets the value for multiple styles on a node.  If a value is specified as
	   * '' (empty string), the corresponding style property will be unset.
	   *
	   * @param {DOMElement} node
	   * @param {object} styles
	   * @param {ReactDOMComponent} component
	   */
	  setValueForStyles: function (node, styles, component) {
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: component._debugID,
	        type: 'update styles',
	        payload: styles
	      });
	    }
	
	    var style = node.style;
	    for (var styleName in styles) {
	      if (!styles.hasOwnProperty(styleName)) {
	        continue;
	      }
	      if (false) {
	        warnValidStyle(styleName, styles[styleName], component);
	      }
	      var styleValue = dangerousStyleValue(styleName, styles[styleName], component);
	      if (styleName === 'float' || styleName === 'cssFloat') {
	        styleName = styleFloatAccessor;
	      }
	      if (styleValue) {
	        style[styleName] = styleValue;
	      } else {
	        var expansion = hasShorthandPropertyBug && CSSProperty.shorthandPropertyExpansions[styleName];
	        if (expansion) {
	          // Shorthand property that IE8 won't like unsetting, so unset each
	          // component to placate it
	          for (var individualStyleName in expansion) {
	            style[individualStyleName] = '';
	          }
	        } else {
	          style[styleName] = '';
	        }
	      }
	    }
	  }
	
	};
	
	module.exports = CSSPropertyOperations;

/***/ }),
/* 394 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * CSS properties which accept numbers but are not in units of "px".
	 */
	
	var isUnitlessNumber = {
	  animationIterationCount: true,
	  borderImageOutset: true,
	  borderImageSlice: true,
	  borderImageWidth: true,
	  boxFlex: true,
	  boxFlexGroup: true,
	  boxOrdinalGroup: true,
	  columnCount: true,
	  flex: true,
	  flexGrow: true,
	  flexPositive: true,
	  flexShrink: true,
	  flexNegative: true,
	  flexOrder: true,
	  gridRow: true,
	  gridColumn: true,
	  fontWeight: true,
	  lineClamp: true,
	  lineHeight: true,
	  opacity: true,
	  order: true,
	  orphans: true,
	  tabSize: true,
	  widows: true,
	  zIndex: true,
	  zoom: true,
	
	  // SVG-related properties
	  fillOpacity: true,
	  floodOpacity: true,
	  stopOpacity: true,
	  strokeDasharray: true,
	  strokeDashoffset: true,
	  strokeMiterlimit: true,
	  strokeOpacity: true,
	  strokeWidth: true
	};
	
	/**
	 * @param {string} prefix vendor-specific prefix, eg: Webkit
	 * @param {string} key style name, eg: transitionDuration
	 * @return {string} style name prefixed with `prefix`, properly camelCased, eg:
	 * WebkitTransitionDuration
	 */
	function prefixKey(prefix, key) {
	  return prefix + key.charAt(0).toUpperCase() + key.substring(1);
	}
	
	/**
	 * Support style names that may come passed in prefixed by adding permutations
	 * of vendor prefixes.
	 */
	var prefixes = ['Webkit', 'ms', 'Moz', 'O'];
	
	// Using Object.keys here, or else the vanilla for-in loop makes IE8 go into an
	// infinite loop, because it iterates over the newly added props too.
	Object.keys(isUnitlessNumber).forEach(function (prop) {
	  prefixes.forEach(function (prefix) {
	    isUnitlessNumber[prefixKey(prefix, prop)] = isUnitlessNumber[prop];
	  });
	});
	
	/**
	 * Most style properties can be unset by doing .style[prop] = '' but IE8
	 * doesn't like doing that with shorthand properties so for the properties that
	 * IE8 breaks on, which are listed here, we instead unset each of the
	 * individual properties. See http://bugs.jquery.com/ticket/12385.
	 * The 4-value 'clock' properties like margin, padding, border-width seem to
	 * behave without any problems. Curiously, list-style works too without any
	 * special prodding.
	 */
	var shorthandPropertyExpansions = {
	  background: {
	    backgroundAttachment: true,
	    backgroundColor: true,
	    backgroundImage: true,
	    backgroundPositionX: true,
	    backgroundPositionY: true,
	    backgroundRepeat: true
	  },
	  backgroundPosition: {
	    backgroundPositionX: true,
	    backgroundPositionY: true
	  },
	  border: {
	    borderWidth: true,
	    borderStyle: true,
	    borderColor: true
	  },
	  borderBottom: {
	    borderBottomWidth: true,
	    borderBottomStyle: true,
	    borderBottomColor: true
	  },
	  borderLeft: {
	    borderLeftWidth: true,
	    borderLeftStyle: true,
	    borderLeftColor: true
	  },
	  borderRight: {
	    borderRightWidth: true,
	    borderRightStyle: true,
	    borderRightColor: true
	  },
	  borderTop: {
	    borderTopWidth: true,
	    borderTopStyle: true,
	    borderTopColor: true
	  },
	  font: {
	    fontStyle: true,
	    fontVariant: true,
	    fontWeight: true,
	    fontSize: true,
	    lineHeight: true,
	    fontFamily: true
	  },
	  outline: {
	    outlineWidth: true,
	    outlineStyle: true,
	    outlineColor: true
	  }
	};
	
	var CSSProperty = {
	  isUnitlessNumber: isUnitlessNumber,
	  shorthandPropertyExpansions: shorthandPropertyExpansions
	};
	
	module.exports = CSSProperty;

/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	var camelize = __webpack_require__(396);
	
	var msPattern = /^-ms-/;
	
	/**
	 * Camelcases a hyphenated CSS property name, for example:
	 *
	 *   > camelizeStyleName('background-color')
	 *   < "backgroundColor"
	 *   > camelizeStyleName('-moz-transition')
	 *   < "MozTransition"
	 *   > camelizeStyleName('-ms-transition')
	 *   < "msTransition"
	 *
	 * As Andi Smith suggests
	 * (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
	 * is converted to lowercase `ms`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function camelizeStyleName(string) {
	  return camelize(string.replace(msPattern, 'ms-'));
	}
	
	module.exports = camelizeStyleName;

/***/ }),
/* 396 */
/***/ (function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var _hyphenPattern = /-(.)/g;
	
	/**
	 * Camelcases a hyphenated string, for example:
	 *
	 *   > camelize('background-color')
	 *   < "backgroundColor"
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function camelize(string) {
	  return string.replace(_hyphenPattern, function (_, character) {
	    return character.toUpperCase();
	  });
	}
	
	module.exports = camelize;

/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var CSSProperty = __webpack_require__(394);
	var warning = __webpack_require__(347);
	
	var isUnitlessNumber = CSSProperty.isUnitlessNumber;
	var styleWarnings = {};
	
	/**
	 * Convert a value into the proper css writable value. The style name `name`
	 * should be logical (no hyphens), as specified
	 * in `CSSProperty.isUnitlessNumber`.
	 *
	 * @param {string} name CSS property name such as `topMargin`.
	 * @param {*} value CSS property value such as `10px`.
	 * @param {ReactDOMComponent} component
	 * @return {string} Normalized style value with dimensions applied.
	 */
	function dangerousStyleValue(name, value, component) {
	  // Note that we've removed escapeTextForBrowser() calls here since the
	  // whole string will be escaped when the attribute is injected into
	  // the markup. If you provide unsafe user data here they can inject
	  // arbitrary CSS which may be problematic (I couldn't repro this):
	  // https://www.owasp.org/index.php/XSS_Filter_Evasion_Cheat_Sheet
	  // http://www.thespanner.co.uk/2007/11/26/ultimate-xss-css-injection/
	  // This is not an XSS hole but instead a potential CSS injection issue
	  // which has lead to a greater discussion about how we're going to
	  // trust URLs moving forward. See #2115901
	
	  var isEmpty = value == null || typeof value === 'boolean' || value === '';
	  if (isEmpty) {
	    return '';
	  }
	
	  var isNonNumeric = isNaN(value);
	  if (isNonNumeric || value === 0 || isUnitlessNumber.hasOwnProperty(name) && isUnitlessNumber[name]) {
	    return '' + value; // cast to string
	  }
	
	  if (typeof value === 'string') {
	    if (false) {
	      // Allow '0' to pass through without warning. 0 is already special and
	      // doesn't require units, so we don't need to warn about it.
	      if (component && value !== '0') {
	        var owner = component._currentElement._owner;
	        var ownerName = owner ? owner.getName() : null;
	        if (ownerName && !styleWarnings[ownerName]) {
	          styleWarnings[ownerName] = {};
	        }
	        var warned = false;
	        if (ownerName) {
	          var warnings = styleWarnings[ownerName];
	          warned = warnings[name];
	          if (!warned) {
	            warnings[name] = true;
	          }
	        }
	        if (!warned) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'a `%s` tag (owner: `%s`) was passed a numeric string value ' + 'for CSS property `%s` (value: `%s`) which will be treated ' + 'as a unitless number in a future version of React.', component._currentElement.type, ownerName || 'unknown', name, value) : void 0;
	        }
	      }
	    }
	    value = value.trim();
	  }
	  return value + 'px';
	}
	
	module.exports = dangerousStyleValue;

/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	var hyphenate = __webpack_require__(399);
	
	var msPattern = /^ms-/;
	
	/**
	 * Hyphenates a camelcased CSS property name, for example:
	 *
	 *   > hyphenateStyleName('backgroundColor')
	 *   < "background-color"
	 *   > hyphenateStyleName('MozTransition')
	 *   < "-moz-transition"
	 *   > hyphenateStyleName('msTransition')
	 *   < "-ms-transition"
	 *
	 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
	 * is converted to `-ms-`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function hyphenateStyleName(string) {
	  return hyphenate(string).replace(msPattern, '-ms-');
	}
	
	module.exports = hyphenateStyleName;

/***/ }),
/* 399 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var _uppercasePattern = /([A-Z])/g;
	
	/**
	 * Hyphenates a camelcased string, for example:
	 *
	 *   > hyphenate('backgroundColor')
	 *   < "background-color"
	 *
	 * For CSS style names, use `hyphenateStyleName` instead which works properly
	 * with all vendor prefixes, including `ms`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function hyphenate(string) {
	  return string.replace(_uppercasePattern, '-$1').toLowerCase();
	}
	
	module.exports = hyphenate;

/***/ }),
/* 400 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 * @typechecks static-only
	 */
	
	'use strict';
	
	/**
	 * Memoizes the return value of a function that accepts one string argument.
	 */
	
	function memoizeStringOnly(callback) {
	  var cache = {};
	  return function (string) {
	    if (!cache.hasOwnProperty(string)) {
	      cache[string] = callback.call(this, string);
	    }
	    return cache[string];
	  };
	}
	
	module.exports = memoizeStringOnly;

/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(336);
	var ReactDOMComponentTree = __webpack_require__(334);
	var ReactInstrumentation = __webpack_require__(365);
	
	var quoteAttributeValueForBrowser = __webpack_require__(402);
	var warning = __webpack_require__(347);
	
	var VALID_ATTRIBUTE_NAME_REGEX = new RegExp('^[' + DOMProperty.ATTRIBUTE_NAME_START_CHAR + '][' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$');
	var illegalAttributeNameCache = {};
	var validatedAttributeNameCache = {};
	
	function isAttributeNameSafe(attributeName) {
	  if (validatedAttributeNameCache.hasOwnProperty(attributeName)) {
	    return true;
	  }
	  if (illegalAttributeNameCache.hasOwnProperty(attributeName)) {
	    return false;
	  }
	  if (VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) {
	    validatedAttributeNameCache[attributeName] = true;
	    return true;
	  }
	  illegalAttributeNameCache[attributeName] = true;
	   false ? warning(false, 'Invalid attribute name: `%s`', attributeName) : void 0;
	  return false;
	}
	
	function shouldIgnoreValue(propertyInfo, value) {
	  return value == null || propertyInfo.hasBooleanValue && !value || propertyInfo.hasNumericValue && isNaN(value) || propertyInfo.hasPositiveNumericValue && value < 1 || propertyInfo.hasOverloadedBooleanValue && value === false;
	}
	
	/**
	 * Operations for dealing with DOM properties.
	 */
	var DOMPropertyOperations = {
	
	  /**
	   * Creates markup for the ID property.
	   *
	   * @param {string} id Unescaped ID.
	   * @return {string} Markup string.
	   */
	  createMarkupForID: function (id) {
	    return DOMProperty.ID_ATTRIBUTE_NAME + '=' + quoteAttributeValueForBrowser(id);
	  },
	
	  setAttributeForID: function (node, id) {
	    node.setAttribute(DOMProperty.ID_ATTRIBUTE_NAME, id);
	  },
	
	  createMarkupForRoot: function () {
	    return DOMProperty.ROOT_ATTRIBUTE_NAME + '=""';
	  },
	
	  setAttributeForRoot: function (node) {
	    node.setAttribute(DOMProperty.ROOT_ATTRIBUTE_NAME, '');
	  },
	
	  /**
	   * Creates markup for a property.
	   *
	   * @param {string} name
	   * @param {*} value
	   * @return {?string} Markup string, or null if the property was invalid.
	   */
	  createMarkupForProperty: function (name, value) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      if (shouldIgnoreValue(propertyInfo, value)) {
	        return '';
	      }
	      var attributeName = propertyInfo.attributeName;
	      if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
	        return attributeName + '=""';
	      }
	      return attributeName + '=' + quoteAttributeValueForBrowser(value);
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      if (value == null) {
	        return '';
	      }
	      return name + '=' + quoteAttributeValueForBrowser(value);
	    }
	    return null;
	  },
	
	  /**
	   * Creates markup for a custom property.
	   *
	   * @param {string} name
	   * @param {*} value
	   * @return {string} Markup string, or empty string if the property was invalid.
	   */
	  createMarkupForCustomAttribute: function (name, value) {
	    if (!isAttributeNameSafe(name) || value == null) {
	      return '';
	    }
	    return name + '=' + quoteAttributeValueForBrowser(value);
	  },
	
	  /**
	   * Sets the value for a property on a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   * @param {*} value
	   */
	  setValueForProperty: function (node, name, value) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      var mutationMethod = propertyInfo.mutationMethod;
	      if (mutationMethod) {
	        mutationMethod(node, value);
	      } else if (shouldIgnoreValue(propertyInfo, value)) {
	        this.deleteValueForProperty(node, name);
	        return;
	      } else if (propertyInfo.mustUseProperty) {
	        // Contrary to `setAttribute`, object properties are properly
	        // `toString`ed by IE8/9.
	        node[propertyInfo.propertyName] = value;
	      } else {
	        var attributeName = propertyInfo.attributeName;
	        var namespace = propertyInfo.attributeNamespace;
	        // `setAttribute` with objects becomes only `[object]` in IE8/9,
	        // ('' + value) makes it output the correct toString()-value.
	        if (namespace) {
	          node.setAttributeNS(namespace, attributeName, '' + value);
	        } else if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
	          node.setAttribute(attributeName, '');
	        } else {
	          node.setAttribute(attributeName, '' + value);
	        }
	      }
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      DOMPropertyOperations.setValueForAttribute(node, name, value);
	      return;
	    }
	
	    if (false) {
	      var payload = {};
	      payload[name] = value;
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'update attribute',
	        payload: payload
	      });
	    }
	  },
	
	  setValueForAttribute: function (node, name, value) {
	    if (!isAttributeNameSafe(name)) {
	      return;
	    }
	    if (value == null) {
	      node.removeAttribute(name);
	    } else {
	      node.setAttribute(name, '' + value);
	    }
	
	    if (false) {
	      var payload = {};
	      payload[name] = value;
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'update attribute',
	        payload: payload
	      });
	    }
	  },
	
	  /**
	   * Deletes an attributes from a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   */
	  deleteValueForAttribute: function (node, name) {
	    node.removeAttribute(name);
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'remove attribute',
	        payload: name
	      });
	    }
	  },
	
	  /**
	   * Deletes the value for a property on a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   */
	  deleteValueForProperty: function (node, name) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      var mutationMethod = propertyInfo.mutationMethod;
	      if (mutationMethod) {
	        mutationMethod(node, undefined);
	      } else if (propertyInfo.mustUseProperty) {
	        var propName = propertyInfo.propertyName;
	        if (propertyInfo.hasBooleanValue) {
	          node[propName] = false;
	        } else {
	          node[propName] = '';
	        }
	      } else {
	        node.removeAttribute(propertyInfo.attributeName);
	      }
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      node.removeAttribute(name);
	    }
	
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'remove attribute',
	        payload: name
	      });
	    }
	  }
	
	};
	
	module.exports = DOMPropertyOperations;

/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var escapeTextContentForBrowser = __webpack_require__(384);
	
	/**
	 * Escapes attribute value to prevent scripting attacks.
	 *
	 * @param {*} value Value to escape.
	 * @return {string} An escaped string.
	 */
	function quoteAttributeValueForBrowser(value) {
	  return '"' + escapeTextContentForBrowser(value) + '"';
	}
	
	module.exports = quoteAttributeValueForBrowser;

/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(302);
	
	var EventPluginRegistry = __webpack_require__(344);
	var ReactEventEmitterMixin = __webpack_require__(404);
	var ViewportMetrics = __webpack_require__(374);
	
	var getVendorPrefixedEventName = __webpack_require__(405);
	var isEventSupported = __webpack_require__(368);
	
	/**
	 * Summary of `ReactBrowserEventEmitter` event handling:
	 *
	 *  - Top-level delegation is used to trap most native browser events. This
	 *    may only occur in the main thread and is the responsibility of
	 *    ReactEventListener, which is injected and can therefore support pluggable
	 *    event sources. This is the only work that occurs in the main thread.
	 *
	 *  - We normalize and de-duplicate events to account for browser quirks. This
	 *    may be done in the worker thread.
	 *
	 *  - Forward these native events (with the associated top-level type used to
	 *    trap it) to `EventPluginHub`, which in turn will ask plugins if they want
	 *    to extract any synthetic events.
	 *
	 *  - The `EventPluginHub` will then process each event by annotating them with
	 *    "dispatches", a sequence of listeners and IDs that care about that event.
	 *
	 *  - The `EventPluginHub` then dispatches the events.
	 *
	 * Overview of React and the event system:
	 *
	 * +------------+    .
	 * |    DOM     |    .
	 * +------------+    .
	 *       |           .
	 *       v           .
	 * +------------+    .
	 * | ReactEvent |    .
	 * |  Listener  |    .
	 * +------------+    .                         +-----------+
	 *       |           .               +--------+|SimpleEvent|
	 *       |           .               |         |Plugin     |
	 * +-----|------+    .               v         +-----------+
	 * |     |      |    .    +--------------+                    +------------+
	 * |     +-----------.--->|EventPluginHub|                    |    Event   |
	 * |            |    .    |              |     +-----------+  | Propagators|
	 * | ReactEvent |    .    |              |     |TapEvent   |  |------------|
	 * |  Emitter   |    .    |              |<---+|Plugin     |  |other plugin|
	 * |            |    .    |              |     +-----------+  |  utilities |
	 * |     +-----------.--->|              |                    +------------+
	 * |     |      |    .    +--------------+
	 * +-----|------+    .                ^        +-----------+
	 *       |           .                |        |Enter/Leave|
	 *       +           .                +-------+|Plugin     |
	 * +-------------+   .                         +-----------+
	 * | application |   .
	 * |-------------|   .
	 * |             |   .
	 * |             |   .
	 * +-------------+   .
	 *                   .
	 *    React Core     .  General Purpose Event Plugin System
	 */
	
	var hasEventPageXY;
	var alreadyListeningTo = {};
	var isMonitoringScrollValue = false;
	var reactTopListenersCounter = 0;
	
	// For events like 'submit' which don't consistently bubble (which we trap at a
	// lower node than `document`), binding at `document` would cause duplicate
	// events so we don't include them here
	var topEventMapping = {
	  topAbort: 'abort',
	  topAnimationEnd: getVendorPrefixedEventName('animationend') || 'animationend',
	  topAnimationIteration: getVendorPrefixedEventName('animationiteration') || 'animationiteration',
	  topAnimationStart: getVendorPrefixedEventName('animationstart') || 'animationstart',
	  topBlur: 'blur',
	  topCanPlay: 'canplay',
	  topCanPlayThrough: 'canplaythrough',
	  topChange: 'change',
	  topClick: 'click',
	  topCompositionEnd: 'compositionend',
	  topCompositionStart: 'compositionstart',
	  topCompositionUpdate: 'compositionupdate',
	  topContextMenu: 'contextmenu',
	  topCopy: 'copy',
	  topCut: 'cut',
	  topDoubleClick: 'dblclick',
	  topDrag: 'drag',
	  topDragEnd: 'dragend',
	  topDragEnter: 'dragenter',
	  topDragExit: 'dragexit',
	  topDragLeave: 'dragleave',
	  topDragOver: 'dragover',
	  topDragStart: 'dragstart',
	  topDrop: 'drop',
	  topDurationChange: 'durationchange',
	  topEmptied: 'emptied',
	  topEncrypted: 'encrypted',
	  topEnded: 'ended',
	  topError: 'error',
	  topFocus: 'focus',
	  topInput: 'input',
	  topKeyDown: 'keydown',
	  topKeyPress: 'keypress',
	  topKeyUp: 'keyup',
	  topLoadedData: 'loadeddata',
	  topLoadedMetadata: 'loadedmetadata',
	  topLoadStart: 'loadstart',
	  topMouseDown: 'mousedown',
	  topMouseMove: 'mousemove',
	  topMouseOut: 'mouseout',
	  topMouseOver: 'mouseover',
	  topMouseUp: 'mouseup',
	  topPaste: 'paste',
	  topPause: 'pause',
	  topPlay: 'play',
	  topPlaying: 'playing',
	  topProgress: 'progress',
	  topRateChange: 'ratechange',
	  topScroll: 'scroll',
	  topSeeked: 'seeked',
	  topSeeking: 'seeking',
	  topSelectionChange: 'selectionchange',
	  topStalled: 'stalled',
	  topSuspend: 'suspend',
	  topTextInput: 'textInput',
	  topTimeUpdate: 'timeupdate',
	  topTouchCancel: 'touchcancel',
	  topTouchEnd: 'touchend',
	  topTouchMove: 'touchmove',
	  topTouchStart: 'touchstart',
	  topTransitionEnd: getVendorPrefixedEventName('transitionend') || 'transitionend',
	  topVolumeChange: 'volumechange',
	  topWaiting: 'waiting',
	  topWheel: 'wheel'
	};
	
	/**
	 * To ensure no conflicts with other potential React instances on the page
	 */
	var topListenersIDKey = '_reactListenersID' + String(Math.random()).slice(2);
	
	function getListeningForDocument(mountAt) {
	  // In IE8, `mountAt` is a host object and doesn't have `hasOwnProperty`
	  // directly.
	  if (!Object.prototype.hasOwnProperty.call(mountAt, topListenersIDKey)) {
	    mountAt[topListenersIDKey] = reactTopListenersCounter++;
	    alreadyListeningTo[mountAt[topListenersIDKey]] = {};
	  }
	  return alreadyListeningTo[mountAt[topListenersIDKey]];
	}
	
	/**
	 * `ReactBrowserEventEmitter` is used to attach top-level event listeners. For
	 * example:
	 *
	 *   EventPluginHub.putListener('myID', 'onClick', myFunction);
	 *
	 * This would allocate a "registration" of `('onClick', myFunction)` on 'myID'.
	 *
	 * @internal
	 */
	var ReactBrowserEventEmitter = _assign({}, ReactEventEmitterMixin, {
	
	  /**
	   * Injectable event backend
	   */
	  ReactEventListener: null,
	
	  injection: {
	    /**
	     * @param {object} ReactEventListener
	     */
	    injectReactEventListener: function (ReactEventListener) {
	      ReactEventListener.setHandleTopLevel(ReactBrowserEventEmitter.handleTopLevel);
	      ReactBrowserEventEmitter.ReactEventListener = ReactEventListener;
	    }
	  },
	
	  /**
	   * Sets whether or not any created callbacks should be enabled.
	   *
	   * @param {boolean} enabled True if callbacks should be enabled.
	   */
	  setEnabled: function (enabled) {
	    if (ReactBrowserEventEmitter.ReactEventListener) {
	      ReactBrowserEventEmitter.ReactEventListener.setEnabled(enabled);
	    }
	  },
	
	  /**
	   * @return {boolean} True if callbacks are enabled.
	   */
	  isEnabled: function () {
	    return !!(ReactBrowserEventEmitter.ReactEventListener && ReactBrowserEventEmitter.ReactEventListener.isEnabled());
	  },
	
	  /**
	   * We listen for bubbled touch events on the document object.
	   *
	   * Firefox v8.01 (and possibly others) exhibited strange behavior when
	   * mounting `onmousemove` events at some node that was not the document
	   * element. The symptoms were that if your mouse is not moving over something
	   * contained within that mount point (for example on the background) the
	   * top-level listeners for `onmousemove` won't be called. However, if you
	   * register the `mousemove` on the document object, then it will of course
	   * catch all `mousemove`s. This along with iOS quirks, justifies restricting
	   * top-level listeners to the document object only, at least for these
	   * movement types of events and possibly all events.
	   *
	   * @see http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
	   *
	   * Also, `keyup`/`keypress`/`keydown` do not bubble to the window on IE, but
	   * they bubble to document.
	   *
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @param {object} contentDocumentHandle Document which owns the container
	   */
	  listenTo: function (registrationName, contentDocumentHandle) {
	    var mountAt = contentDocumentHandle;
	    var isListening = getListeningForDocument(mountAt);
	    var dependencies = EventPluginRegistry.registrationNameDependencies[registrationName];
	
	    for (var i = 0; i < dependencies.length; i++) {
	      var dependency = dependencies[i];
	      if (!(isListening.hasOwnProperty(dependency) && isListening[dependency])) {
	        if (dependency === 'topWheel') {
	          if (isEventSupported('wheel')) {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'wheel', mountAt);
	          } else if (isEventSupported('mousewheel')) {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'mousewheel', mountAt);
	          } else {
	            // Firefox needs to capture a different mouse scroll event.
	            // @see http://www.quirksmode.org/dom/events/tests/scroll.html
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'DOMMouseScroll', mountAt);
	          }
	        } else if (dependency === 'topScroll') {
	
	          if (isEventSupported('scroll', true)) {
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topScroll', 'scroll', mountAt);
	          } else {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topScroll', 'scroll', ReactBrowserEventEmitter.ReactEventListener.WINDOW_HANDLE);
	          }
	        } else if (dependency === 'topFocus' || dependency === 'topBlur') {
	
	          if (isEventSupported('focus', true)) {
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topFocus', 'focus', mountAt);
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topBlur', 'blur', mountAt);
	          } else if (isEventSupported('focusin')) {
	            // IE has `focusin` and `focusout` events which bubble.
	            // @see http://www.quirksmode.org/blog/archives/2008/04/delegating_the.html
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topFocus', 'focusin', mountAt);
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topBlur', 'focusout', mountAt);
	          }
	
	          // to make sure blur and focus event listeners are only attached once
	          isListening.topBlur = true;
	          isListening.topFocus = true;
	        } else if (topEventMapping.hasOwnProperty(dependency)) {
	          ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(dependency, topEventMapping[dependency], mountAt);
	        }
	
	        isListening[dependency] = true;
	      }
	    }
	  },
	
	  trapBubbledEvent: function (topLevelType, handlerBaseName, handle) {
	    return ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelType, handlerBaseName, handle);
	  },
	
	  trapCapturedEvent: function (topLevelType, handlerBaseName, handle) {
	    return ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelType, handlerBaseName, handle);
	  },
	
	  /**
	   * Protect against document.createEvent() returning null
	   * Some popup blocker extensions appear to do this:
	   * https://github.com/facebook/react/issues/6887
	   */
	  supportsEventPageXY: function () {
	    if (!document.createEvent) {
	      return false;
	    }
	    var ev = document.createEvent('MouseEvent');
	    return ev != null && 'pageX' in ev;
	  },
	
	  /**
	   * Listens to window scroll and resize events. We cache scroll values so that
	   * application code can access them without triggering reflows.
	   *
	   * ViewportMetrics is only used by SyntheticMouse/TouchEvent and only when
	   * pageX/pageY isn't supported (legacy browsers).
	   *
	   * NOTE: Scroll events do not bubble.
	   *
	   * @see http://www.quirksmode.org/dom/events/scroll.html
	   */
	  ensureScrollValueMonitoring: function () {
	    if (hasEventPageXY === undefined) {
	      hasEventPageXY = ReactBrowserEventEmitter.supportsEventPageXY();
	    }
	    if (!hasEventPageXY && !isMonitoringScrollValue) {
	      var refresh = ViewportMetrics.refreshScrollValues;
	      ReactBrowserEventEmitter.ReactEventListener.monitorScrollValue(refresh);
	      isMonitoringScrollValue = true;
	    }
	  }
	
	});
	
	module.exports = ReactBrowserEventEmitter;

/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(343);
	
	function runEventQueueInBatch(events) {
	  EventPluginHub.enqueueEvents(events);
	  EventPluginHub.processEventQueue(false);
	}
	
	var ReactEventEmitterMixin = {
	
	  /**
	   * Streams a fired top-level event to `EventPluginHub` where plugins have the
	   * opportunity to create `ReactEvent`s to be dispatched.
	   */
	  handleTopLevel: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var events = EventPluginHub.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
	    runEventQueueInBatch(events);
	  }
	};
	
	module.exports = ReactEventEmitterMixin;

/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(351);
	
	/**
	 * Generate a mapping of standard vendor prefixes using the defined style property and event name.
	 *
	 * @param {string} styleProp
	 * @param {string} eventName
	 * @returns {object}
	 */
	function makePrefixMap(styleProp, eventName) {
	  var prefixes = {};
	
	  prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
	  prefixes['Webkit' + styleProp] = 'webkit' + eventName;
	  prefixes['Moz' + styleProp] = 'moz' + eventName;
	  prefixes['ms' + styleProp] = 'MS' + eventName;
	  prefixes['O' + styleProp] = 'o' + eventName.toLowerCase();
	
	  return prefixes;
	}
	
	/**
	 * A list of event names to a configurable list of vendor prefixes.
	 */
	var vendorPrefixes = {
	  animationend: makePrefixMap('Animation', 'AnimationEnd'),
	  animationiteration: makePrefixMap('Animation', 'AnimationIteration'),
	  animationstart: makePrefixMap('Animation', 'AnimationStart'),
	  transitionend: makePrefixMap('Transition', 'TransitionEnd')
	};
	
	/**
	 * Event names that have already been detected and prefixed (if applicable).
	 */
	var prefixedEventNames = {};
	
	/**
	 * Element to check for prefixes on.
	 */
	var style = {};
	
	/**
	 * Bootstrap if a DOM exists.
	 */
	if (ExecutionEnvironment.canUseDOM) {
	  style = document.createElement('div').style;
	
	  // On some platforms, in particular some releases of Android 4.x,
	  // the un-prefixed "animation" and "transition" properties are defined on the
	  // style object but the events that fire will still be prefixed, so we need
	  // to check if the un-prefixed events are usable, and if not remove them from the map.
	  if (!('AnimationEvent' in window)) {
	    delete vendorPrefixes.animationend.animation;
	    delete vendorPrefixes.animationiteration.animation;
	    delete vendorPrefixes.animationstart.animation;
	  }
	
	  // Same as above
	  if (!('TransitionEvent' in window)) {
	    delete vendorPrefixes.transitionend.transition;
	  }
	}
	
	/**
	 * Attempts to determine the correct vendor prefixed event name.
	 *
	 * @param {string} eventName
	 * @returns {string}
	 */
	function getVendorPrefixedEventName(eventName) {
	  if (prefixedEventNames[eventName]) {
	    return prefixedEventNames[eventName];
	  } else if (!vendorPrefixes[eventName]) {
	    return eventName;
	  }
	
	  var prefixMap = vendorPrefixes[eventName];
	
	  for (var styleProp in prefixMap) {
	    if (prefixMap.hasOwnProperty(styleProp) && styleProp in style) {
	      return prefixedEventNames[eventName] = prefixMap[styleProp];
	    }
	  }
	
	  return '';
	}
	
	module.exports = getVendorPrefixedEventName;

/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(335),
	    _assign = __webpack_require__(302);
	
	var DOMPropertyOperations = __webpack_require__(401);
	var LinkedValueUtils = __webpack_require__(407);
	var ReactDOMComponentTree = __webpack_require__(334);
	var ReactUpdates = __webpack_require__(359);
	
	var invariant = __webpack_require__(337);
	var warning = __webpack_require__(347);
	
	var didWarnValueLink = false;
	var didWarnCheckedLink = false;
	var didWarnValueDefaultValue = false;
	var didWarnCheckedDefaultChecked = false;
	var didWarnControlledToUncontrolled = false;
	var didWarnUncontrolledToControlled = false;
	
	function forceUpdateIfMounted() {
	  if (this._rootNodeID) {
	    // DOM component is still mounted; update
	    ReactDOMInput.updateWrapper(this);
	  }
	}
	
	function isControlled(props) {
	  var usesChecked = props.type === 'checkbox' || props.type === 'radio';
	  return usesChecked ? props.checked != null : props.value != null;
	}
	
	/**
	 * Implements an <input> host component that allows setting these optional
	 * props: `checked`, `value`, `defaultChecked`, and `defaultValue`.
	 *
	 * If `checked` or `value` are not supplied (or null/undefined), user actions
	 * that affect the checked state or value will trigger updates to the element.
	 *
	 * If they are supplied (and not null/undefined), the rendered element will not
	 * trigger updates to the element. Instead, the props must change in order for
	 * the rendered element to be updated.
	 *
	 * The rendered element will be initialized as unchecked (or `defaultChecked`)
	 * with an empty value (or `defaultValue`).
	 *
	 * @see http://www.w3.org/TR/2012/WD-html5-20121025/the-input-element.html
	 */
	var ReactDOMInput = {
	  getHostProps: function (inst, props) {
	    var value = LinkedValueUtils.getValue(props);
	    var checked = LinkedValueUtils.getChecked(props);
	
	    var hostProps = _assign({
	      // Make sure we set .type before any other properties (setting .value
	      // before .type means .value is lost in IE11 and below)
	      type: undefined,
	      // Make sure we set .step before .value (setting .value before .step
	      // means .value is rounded on mount, based upon step precision)
	      step: undefined,
	      // Make sure we set .min & .max before .value (to ensure proper order
	      // in corner cases such as min or max deriving from value, e.g. Issue #7170)
	      min: undefined,
	      max: undefined
	    }, props, {
	      defaultChecked: undefined,
	      defaultValue: undefined,
	      value: value != null ? value : inst._wrapperState.initialValue,
	      checked: checked != null ? checked : inst._wrapperState.initialChecked,
	      onChange: inst._wrapperState.onChange
	    });
	
	    return hostProps;
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      LinkedValueUtils.checkPropTypes('input', props, inst._currentElement._owner);
	
	      var owner = inst._currentElement._owner;
	
	      if (props.valueLink !== undefined && !didWarnValueLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnValueLink = true;
	      }
	      if (props.checkedLink !== undefined && !didWarnCheckedLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`checkedLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnCheckedLink = true;
	      }
	      if (props.checked !== undefined && props.defaultChecked !== undefined && !didWarnCheckedDefaultChecked) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both checked and defaultChecked props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the checked prop, or the defaultChecked prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnCheckedDefaultChecked = true;
	      }
	      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both value and defaultValue props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnValueDefaultValue = true;
	      }
	    }
	
	    var defaultValue = props.defaultValue;
	    inst._wrapperState = {
	      initialChecked: props.checked != null ? props.checked : props.defaultChecked,
	      initialValue: props.value != null ? props.value : defaultValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst),
	      controlled: isControlled(props)
	    };
	  },
	
	  updateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    if (false) {
	      var controlled = isControlled(props);
	      var owner = inst._currentElement._owner;
	
	      if (!inst._wrapperState.controlled && controlled && !didWarnUncontrolledToControlled) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing an uncontrolled input of type %s to be controlled. ' + 'Input elements should not switch from uncontrolled to controlled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnUncontrolledToControlled = true;
	      }
	      if (inst._wrapperState.controlled && !controlled && !didWarnControlledToUncontrolled) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing a controlled input of type %s to be uncontrolled. ' + 'Input elements should not switch from controlled to uncontrolled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnControlledToUncontrolled = true;
	      }
	    }
	
	    // TODO: Shouldn't this be getChecked(props)?
	    var checked = props.checked;
	    if (checked != null) {
	      DOMPropertyOperations.setValueForProperty(ReactDOMComponentTree.getNodeFromInstance(inst), 'checked', checked || false);
	    }
	
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      if (value === 0 && node.value === '') {
	        node.value = '0';
	        // Note: IE9 reports a number inputs as 'text', so check props instead.
	      } else if (props.type === 'number') {
	        // Simulate `input.valueAsNumber`. IE9 does not support it
	        var valueAsNumber = parseFloat(node.value, 10) || 0;
	
	        // eslint-disable-next-line
	        if (value != valueAsNumber) {
	          // Cast `value` to a string to ensure the value is set correctly. While
	          // browsers typically do this as necessary, jsdom doesn't.
	          node.value = '' + value;
	        }
	        // eslint-disable-next-line
	      } else if (value != node.value) {
	        // Cast `value` to a string to ensure the value is set correctly. While
	        // browsers typically do this as necessary, jsdom doesn't.
	        node.value = '' + value;
	      }
	    } else {
	      if (props.value == null && props.defaultValue != null) {
	        // In Chrome, assigning defaultValue to certain input types triggers input validation.
	        // For number inputs, the display value loses trailing decimal points. For email inputs,
	        // Chrome raises "The specified value <x> is not a valid email address".
	        //
	        // Here we check to see if the defaultValue has actually changed, avoiding these problems
	        // when the user is inputting text
	        //
	        // https://github.com/facebook/react/issues/7253
	        if (node.defaultValue !== '' + props.defaultValue) {
	          node.defaultValue = '' + props.defaultValue;
	        }
	      }
	      if (props.checked == null && props.defaultChecked != null) {
	        node.defaultChecked = !!props.defaultChecked;
	      }
	    }
	  },
	
	  postMountWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    // This is in postMount because we need access to the DOM node, which is not
	    // available until after the component has mounted.
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	
	    // Detach value from defaultValue. We won't do anything if we're working on
	    // submit or reset inputs as those values & defaultValues are linked. They
	    // are not resetable nodes so this operation doesn't matter and actually
	    // removes browser-default values (eg "Submit Query") when no value is
	    // provided.
	
	    switch (props.type) {
	      case 'submit':
	      case 'reset':
	        break;
	      case 'color':
	      case 'date':
	      case 'datetime':
	      case 'datetime-local':
	      case 'month':
	      case 'time':
	      case 'week':
	        // This fixes the no-show issue on iOS Safari and Android Chrome:
	        // https://github.com/facebook/react/issues/7233
	        node.value = '';
	        node.value = node.defaultValue;
	        break;
	      default:
	        node.value = node.value;
	        break;
	    }
	
	    // Normally, we'd just do `node.checked = node.checked` upon initial mount, less this bug
	    // this is needed to work around a chrome bug where setting defaultChecked
	    // will sometimes influence the value of checked (even after detachment).
	    // Reference: https://bugs.chromium.org/p/chromium/issues/detail?id=608416
	    // We need to temporarily unset name to avoid disrupting radio button groups.
	    var name = node.name;
	    if (name !== '') {
	      node.name = '';
	    }
	    node.defaultChecked = !node.defaultChecked;
	    node.defaultChecked = !node.defaultChecked;
	    if (name !== '') {
	      node.name = name;
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	
	  // Here we use asap to wait until all updates have propagated, which
	  // is important when using controlled components within layers:
	  // https://github.com/facebook/react/issues/1698
	  ReactUpdates.asap(forceUpdateIfMounted, this);
	
	  var name = props.name;
	  if (props.type === 'radio' && name != null) {
	    var rootNode = ReactDOMComponentTree.getNodeFromInstance(this);
	    var queryRoot = rootNode;
	
	    while (queryRoot.parentNode) {
	      queryRoot = queryRoot.parentNode;
	    }
	
	    // If `rootNode.form` was non-null, then we could try `form.elements`,
	    // but that sometimes behaves strangely in IE8. We could also try using
	    // `form.getElementsByName`, but that will only return direct children
	    // and won't include inputs that use the HTML5 `form=` attribute. Since
	    // the input might not even be in a form, let's just use the global
	    // `querySelectorAll` to ensure we don't miss anything.
	    var group = queryRoot.querySelectorAll('input[name=' + JSON.stringify('' + name) + '][type="radio"]');
	
	    for (var i = 0; i < group.length; i++) {
	      var otherNode = group[i];
	      if (otherNode === rootNode || otherNode.form !== rootNode.form) {
	        continue;
	      }
	      // This will throw if radio buttons rendered by different copies of React
	      // and the same name are rendered into the same form (same as #1939).
	      // That's probably okay; we don't support it just as we don't support
	      // mixing React radio buttons with non-React ones.
	      var otherInstance = ReactDOMComponentTree.getInstanceFromNode(otherNode);
	      !otherInstance ?  false ? invariant(false, 'ReactDOMInput: Mixing React and non-React radio inputs with the same `name` is not supported.') : _prodInvariant('90') : void 0;
	      // If this is a controlled radio button group, forcing the input that
	      // was previously checked to update will cause it to be come re-checked
	      // as appropriate.
	      ReactUpdates.asap(forceUpdateIfMounted, otherInstance);
	    }
	  }
	
	  return returnValue;
	}
	
	module.exports = ReactDOMInput;

/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(335);
	
	var ReactPropTypesSecret = __webpack_require__(408);
	var propTypesFactory = __webpack_require__(409);
	
	var React = __webpack_require__(301);
	var PropTypes = propTypesFactory(React.isValidElement);
	
	var invariant = __webpack_require__(337);
	var warning = __webpack_require__(347);
	
	var hasReadOnlyValue = {
	  'button': true,
	  'checkbox': true,
	  'image': true,
	  'hidden': true,
	  'radio': true,
	  'reset': true,
	  'submit': true
	};
	
	function _assertSingleLink(inputProps) {
	  !(inputProps.checkedLink == null || inputProps.valueLink == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a valueLink. If you want to use checkedLink, you probably don\'t want to use valueLink and vice versa.') : _prodInvariant('87') : void 0;
	}
	function _assertValueLink(inputProps) {
	  _assertSingleLink(inputProps);
	  !(inputProps.value == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a valueLink and a value or onChange event. If you want to use value or onChange, you probably don\'t want to use valueLink.') : _prodInvariant('88') : void 0;
	}
	
	function _assertCheckedLink(inputProps) {
	  _assertSingleLink(inputProps);
	  !(inputProps.checked == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a checked property or onChange event. If you want to use checked or onChange, you probably don\'t want to use checkedLink') : _prodInvariant('89') : void 0;
	}
	
	var propTypes = {
	  value: function (props, propName, componentName) {
	    if (!props[propName] || hasReadOnlyValue[props.type] || props.onChange || props.readOnly || props.disabled) {
	      return null;
	    }
	    return new Error('You provided a `value` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultValue`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
	  },
	  checked: function (props, propName, componentName) {
	    if (!props[propName] || props.onChange || props.readOnly || props.disabled) {
	      return null;
	    }
	    return new Error('You provided a `checked` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultChecked`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
	  },
	  onChange: PropTypes.func
	};
	
	var loggedTypeFailures = {};
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	/**
	 * Provide a linked `value` attribute for controlled forms. You should not use
	 * this outside of the ReactDOM controlled form components.
	 */
	var LinkedValueUtils = {
	  checkPropTypes: function (tagName, props, owner) {
	    for (var propName in propTypes) {
	      if (propTypes.hasOwnProperty(propName)) {
	        var error = propTypes[propName](props, propName, tagName, 'prop', null, ReactPropTypesSecret);
	      }
	      if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	        // Only monitor this failure once because there tends to be a lot of the
	        // same error.
	        loggedTypeFailures[error.message] = true;
	
	        var addendum = getDeclarationErrorAddendum(owner);
	         false ? warning(false, 'Failed form propType: %s%s', error.message, addendum) : void 0;
	      }
	    }
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @return {*} current value of the input either from value prop or link.
	   */
	  getValue: function (inputProps) {
	    if (inputProps.valueLink) {
	      _assertValueLink(inputProps);
	      return inputProps.valueLink.value;
	    }
	    return inputProps.value;
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @return {*} current checked status of the input either from checked prop
	   *             or link.
	   */
	  getChecked: function (inputProps) {
	    if (inputProps.checkedLink) {
	      _assertCheckedLink(inputProps);
	      return inputProps.checkedLink.value;
	    }
	    return inputProps.checked;
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @param {SyntheticEvent} event change event to handle
	   */
	  executeOnChange: function (inputProps, event) {
	    if (inputProps.valueLink) {
	      _assertValueLink(inputProps);
	      return inputProps.valueLink.requestChange(event.target.value);
	    } else if (inputProps.checkedLink) {
	      _assertCheckedLink(inputProps);
	      return inputProps.checkedLink.requestChange(event.target.checked);
	    } else if (inputProps.onChange) {
	      return inputProps.onChange.call(undefined, event);
	    }
	  }
	};
	
	module.exports = LinkedValueUtils;

/***/ }),
/* 408 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;

/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	// React 15.5 references this module, and assumes PropTypes are still callable in production.
	// Therefore we re-export development-only version with all the PropTypes checks here.
	// However if one is migrating to the `prop-types` npm library, they will go through the
	// `index.js` entry point, and it will branch depending on the environment.
	var factory = __webpack_require__(410);
	module.exports = function(isValidElement) {
	  // It is still allowed in 15.5.
	  var throwOnDirectAccess = false;
	  return factory(isValidElement, throwOnDirectAccess);
	};


/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(348);
	var invariant = __webpack_require__(337);
	var warning = __webpack_require__(347);
	
	var ReactPropTypesSecret = __webpack_require__(411);
	var checkPropTypes = __webpack_require__(412);
	
	module.exports = function(isValidElement, throwOnDirectAccess) {
	  /* global Symbol */
	  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	  /**
	   * Returns the iterator method function contained on the iterable object.
	   *
	   * Be sure to invoke the function with the iterable as context:
	   *
	   *     var iteratorFn = getIteratorFn(myIterable);
	   *     if (iteratorFn) {
	   *       var iterator = iteratorFn.call(myIterable);
	   *       ...
	   *     }
	   *
	   * @param {?object} maybeIterable
	   * @return {?function}
	   */
	  function getIteratorFn(maybeIterable) {
	    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	    if (typeof iteratorFn === 'function') {
	      return iteratorFn;
	    }
	  }
	
	  /**
	   * Collection of methods that allow declaration and validation of props that are
	   * supplied to React components. Example usage:
	   *
	   *   var Props = require('ReactPropTypes');
	   *   var MyArticle = React.createClass({
	   *     propTypes: {
	   *       // An optional string prop named "description".
	   *       description: Props.string,
	   *
	   *       // A required enum prop named "category".
	   *       category: Props.oneOf(['News','Photos']).isRequired,
	   *
	   *       // A prop named "dialog" that requires an instance of Dialog.
	   *       dialog: Props.instanceOf(Dialog).isRequired
	   *     },
	   *     render: function() { ... }
	   *   });
	   *
	   * A more formal specification of how these methods are used:
	   *
	   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
	   *   decl := ReactPropTypes.{type}(.isRequired)?
	   *
	   * Each and every declaration produces a function with the same signature. This
	   * allows the creation of custom validation functions. For example:
	   *
	   *  var MyLink = React.createClass({
	   *    propTypes: {
	   *      // An optional string or URI prop named "href".
	   *      href: function(props, propName, componentName) {
	   *        var propValue = props[propName];
	   *        if (propValue != null && typeof propValue !== 'string' &&
	   *            !(propValue instanceof URI)) {
	   *          return new Error(
	   *            'Expected a string or an URI for ' + propName + ' in ' +
	   *            componentName
	   *          );
	   *        }
	   *      }
	   *    },
	   *    render: function() {...}
	   *  });
	   *
	   * @internal
	   */
	
	  var ANONYMOUS = '<<anonymous>>';
	
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
	  var ReactPropTypes = {
	    array: createPrimitiveTypeChecker('array'),
	    bool: createPrimitiveTypeChecker('boolean'),
	    func: createPrimitiveTypeChecker('function'),
	    number: createPrimitiveTypeChecker('number'),
	    object: createPrimitiveTypeChecker('object'),
	    string: createPrimitiveTypeChecker('string'),
	    symbol: createPrimitiveTypeChecker('symbol'),
	
	    any: createAnyTypeChecker(),
	    arrayOf: createArrayOfTypeChecker,
	    element: createElementTypeChecker(),
	    instanceOf: createInstanceTypeChecker,
	    node: createNodeChecker(),
	    objectOf: createObjectOfTypeChecker,
	    oneOf: createEnumTypeChecker,
	    oneOfType: createUnionTypeChecker,
	    shape: createShapeTypeChecker
	  };
	
	  /**
	   * inlined Object.is polyfill to avoid requiring consumers ship their own
	   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	   */
	  /*eslint-disable no-self-compare*/
	  function is(x, y) {
	    // SameValue algorithm
	    if (x === y) {
	      // Steps 1-5, 7-10
	      // Steps 6.b-6.e: +0 != -0
	      return x !== 0 || 1 / x === 1 / y;
	    } else {
	      // Step 6.a: NaN == NaN
	      return x !== x && y !== y;
	    }
	  }
	  /*eslint-enable no-self-compare*/
	
	  /**
	   * We use an Error-like object for backward compatibility as people may call
	   * PropTypes directly and inspect their output. However, we don't use real
	   * Errors anymore. We don't inspect their stack anyway, and creating them
	   * is prohibitively expensive if they are created too often, such as what
	   * happens in oneOfType() for any type before the one that matched.
	   */
	  function PropTypeError(message) {
	    this.message = message;
	    this.stack = '';
	  }
	  // Make `instanceof Error` still work for returned errors.
	  PropTypeError.prototype = Error.prototype;
	
	  function createChainableTypeChecker(validate) {
	    if (false) {
	      var manualPropTypeCallCache = {};
	      var manualPropTypeWarningCount = 0;
	    }
	    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
	      componentName = componentName || ANONYMOUS;
	      propFullName = propFullName || propName;
	
	      if (secret !== ReactPropTypesSecret) {
	        if (throwOnDirectAccess) {
	          // New behavior only for users of `prop-types` package
	          invariant(
	            false,
	            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	            'Use `PropTypes.checkPropTypes()` to call them. ' +
	            'Read more at http://fb.me/use-check-prop-types'
	          );
	        } else if (false) {
	          // Old behavior for people using React.PropTypes
	          var cacheKey = componentName + ':' + propName;
	          if (
	            !manualPropTypeCallCache[cacheKey] &&
	            // Avoid spamming the console because they are often not actionable except for lib authors
	            manualPropTypeWarningCount < 3
	          ) {
	            warning(
	              false,
	              'You are manually calling a React.PropTypes validation ' +
	              'function for the `%s` prop on `%s`. This is deprecated ' +
	              'and will throw in the standalone `prop-types` package. ' +
	              'You may be seeing this warning due to a third-party PropTypes ' +
	              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.',
	              propFullName,
	              componentName
	            );
	            manualPropTypeCallCache[cacheKey] = true;
	            manualPropTypeWarningCount++;
	          }
	        }
	      }
	      if (props[propName] == null) {
	        if (isRequired) {
	          if (props[propName] === null) {
	            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
	          }
	          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
	        }
	        return null;
	      } else {
	        return validate(props, propName, componentName, location, propFullName);
	      }
	    }
	
	    var chainedCheckType = checkType.bind(null, false);
	    chainedCheckType.isRequired = checkType.bind(null, true);
	
	    return chainedCheckType;
	  }
	
	  function createPrimitiveTypeChecker(expectedType) {
	    function validate(props, propName, componentName, location, propFullName, secret) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== expectedType) {
	        // `propValue` being instance of, say, date/regexp, pass the 'object'
	        // check, but we can offer a more precise error message here rather than
	        // 'of type `object`'.
	        var preciseType = getPreciseType(propValue);
	
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createAnyTypeChecker() {
	    return createChainableTypeChecker(emptyFunction.thatReturnsNull);
	  }
	
	  function createArrayOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
	      }
	      var propValue = props[propName];
	      if (!Array.isArray(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
	      }
	      for (var i = 0; i < propValue.length; i++) {
	        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
	        if (error instanceof Error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createElementTypeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      if (!isValidElement(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createInstanceTypeChecker(expectedClass) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!(props[propName] instanceof expectedClass)) {
	        var expectedClassName = expectedClass.name || ANONYMOUS;
	        var actualClassName = getClassName(props[propName]);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createEnumTypeChecker(expectedValues) {
	    if (!Array.isArray(expectedValues)) {
	       false ? warning(false, 'Invalid argument supplied to oneOf, expected an instance of array.') : void 0;
	      return emptyFunction.thatReturnsNull;
	    }
	
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      for (var i = 0; i < expectedValues.length; i++) {
	        if (is(propValue, expectedValues[i])) {
	          return null;
	        }
	      }
	
	      var valuesString = JSON.stringify(expectedValues);
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createObjectOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
	      }
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
	      }
	      for (var key in propValue) {
	        if (propValue.hasOwnProperty(key)) {
	          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	          if (error instanceof Error) {
	            return error;
	          }
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createUnionTypeChecker(arrayOfTypeCheckers) {
	    if (!Array.isArray(arrayOfTypeCheckers)) {
	       false ? warning(false, 'Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
	      return emptyFunction.thatReturnsNull;
	    }
	
	    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	      var checker = arrayOfTypeCheckers[i];
	      if (typeof checker !== 'function') {
	        warning(
	          false,
	          'Invalid argument supplid to oneOfType. Expected an array of check functions, but ' +
	          'received %s at index %s.',
	          getPostfixForTypeWarning(checker),
	          i
	        );
	        return emptyFunction.thatReturnsNull;
	      }
	    }
	
	    function validate(props, propName, componentName, location, propFullName) {
	      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	        var checker = arrayOfTypeCheckers[i];
	        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret) == null) {
	          return null;
	        }
	      }
	
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createNodeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!isNode(props[propName])) {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      for (var key in shapeTypes) {
	        var checker = shapeTypes[key];
	        if (!checker) {
	          continue;
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function isNode(propValue) {
	    switch (typeof propValue) {
	      case 'number':
	      case 'string':
	      case 'undefined':
	        return true;
	      case 'boolean':
	        return !propValue;
	      case 'object':
	        if (Array.isArray(propValue)) {
	          return propValue.every(isNode);
	        }
	        if (propValue === null || isValidElement(propValue)) {
	          return true;
	        }
	
	        var iteratorFn = getIteratorFn(propValue);
	        if (iteratorFn) {
	          var iterator = iteratorFn.call(propValue);
	          var step;
	          if (iteratorFn !== propValue.entries) {
	            while (!(step = iterator.next()).done) {
	              if (!isNode(step.value)) {
	                return false;
	              }
	            }
	          } else {
	            // Iterator will provide entry [k,v] tuples rather than values.
	            while (!(step = iterator.next()).done) {
	              var entry = step.value;
	              if (entry) {
	                if (!isNode(entry[1])) {
	                  return false;
	                }
	              }
	            }
	          }
	        } else {
	          return false;
	        }
	
	        return true;
	      default:
	        return false;
	    }
	  }
	
	  function isSymbol(propType, propValue) {
	    // Native Symbol.
	    if (propType === 'symbol') {
	      return true;
	    }
	
	    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
	    if (propValue['@@toStringTag'] === 'Symbol') {
	      return true;
	    }
	
	    // Fallback for non-spec compliant Symbols which are polyfilled.
	    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
	      return true;
	    }
	
	    return false;
	  }
	
	  // Equivalent of `typeof` but with special handling for array and regexp.
	  function getPropType(propValue) {
	    var propType = typeof propValue;
	    if (Array.isArray(propValue)) {
	      return 'array';
	    }
	    if (propValue instanceof RegExp) {
	      // Old webkits (at least until Android 4.0) return 'function' rather than
	      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
	      // passes PropTypes.object.
	      return 'object';
	    }
	    if (isSymbol(propType, propValue)) {
	      return 'symbol';
	    }
	    return propType;
	  }
	
	  // This handles more types than `getPropType`. Only used for error messages.
	  // See `createPrimitiveTypeChecker`.
	  function getPreciseType(propValue) {
	    if (typeof propValue === 'undefined' || propValue === null) {
	      return '' + propValue;
	    }
	    var propType = getPropType(propValue);
	    if (propType === 'object') {
	      if (propValue instanceof Date) {
	        return 'date';
	      } else if (propValue instanceof RegExp) {
	        return 'regexp';
	      }
	    }
	    return propType;
	  }
	
	  // Returns a string that is postfixed to a warning about an invalid type.
	  // For example, "undefined" or "of type array"
	  function getPostfixForTypeWarning(value) {
	    var type = getPreciseType(value);
	    switch (type) {
	      case 'array':
	      case 'object':
	        return 'an ' + type;
	      case 'boolean':
	      case 'date':
	      case 'regexp':
	        return 'a ' + type;
	      default:
	        return type;
	    }
	  }
	
	  // Returns class name of the object, if any.
	  function getClassName(propValue) {
	    if (!propValue.constructor || !propValue.constructor.name) {
	      return ANONYMOUS;
	    }
	    return propValue.constructor.name;
	  }
	
	  ReactPropTypes.checkPropTypes = checkPropTypes;
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ }),
/* 411 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;


/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	if (false) {
	  var invariant = require('fbjs/lib/invariant');
	  var warning = require('fbjs/lib/warning');
	  var ReactPropTypesSecret = require('./lib/ReactPropTypesSecret');
	  var loggedTypeFailures = {};
	}
	
	/**
	 * Assert that the values match with the type specs.
	 * Error messages are memorized and will only be shown once.
	 *
	 * @param {object} typeSpecs Map of name to a ReactPropType
	 * @param {object} values Runtime values that need to be type-checked
	 * @param {string} location e.g. "prop", "context", "child context"
	 * @param {string} componentName Name of the component for error messages.
	 * @param {?Function} getStack Returns the component stack.
	 * @private
	 */
	function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
	  if (false) {
	    for (var typeSpecName in typeSpecs) {
	      if (typeSpecs.hasOwnProperty(typeSpecName)) {
	        var error;
	        // Prop type validation may throw. In case they do, we don't want to
	        // fail the render phase where it didn't fail before. So we log it.
	        // After these have been cleaned up, we'll let them throw.
	        try {
	          // This is intentionally an invariant that gets caught. It's the same
	          // behavior as without this statement except with a better message.
	          invariant(typeof typeSpecs[typeSpecName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'React.PropTypes.', componentName || 'React class', location, typeSpecName);
	          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
	        } catch (ex) {
	          error = ex;
	        }
	        warning(!error || error instanceof Error, '%s: type specification of %s `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', location, typeSpecName, typeof error);
	        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	          // Only monitor this failure once because there tends to be a lot of the
	          // same error.
	          loggedTypeFailures[error.message] = true;
	
	          var stack = getStack ? getStack() : '';
	
	          warning(false, 'Failed %s type: %s%s', location, error.message, stack != null ? stack : '');
	        }
	      }
	    }
	  }
	}
	
	module.exports = checkPropTypes;


/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(302);
	
	var React = __webpack_require__(301);
	var ReactDOMComponentTree = __webpack_require__(334);
	var ReactDOMSelect = __webpack_require__(414);
	
	var warning = __webpack_require__(347);
	var didWarnInvalidOptionChildren = false;
	
	function flattenChildren(children) {
	  var content = '';
	
	  // Flatten children and warn if they aren't strings or numbers;
	  // invalid types are ignored.
	  React.Children.forEach(children, function (child) {
	    if (child == null) {
	      return;
	    }
	    if (typeof child === 'string' || typeof child === 'number') {
	      content += child;
	    } else if (!didWarnInvalidOptionChildren) {
	      didWarnInvalidOptionChildren = true;
	       false ? warning(false, 'Only strings and numbers are supported as <option> children.') : void 0;
	    }
	  });
	
	  return content;
	}
	
	/**
	 * Implements an <option> host component that warns when `selected` is set.
	 */
	var ReactDOMOption = {
	  mountWrapper: function (inst, props, hostParent) {
	    // TODO (yungsters): Remove support for `selected` in <option>.
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(props.selected == null, 'Use the `defaultValue` or `value` props on <select> instead of ' + 'setting `selected` on <option>.') : void 0;
	    }
	
	    // Look up whether this option is 'selected'
	    var selectValue = null;
	    if (hostParent != null) {
	      var selectParent = hostParent;
	
	      if (selectParent._tag === 'optgroup') {
	        selectParent = selectParent._hostParent;
	      }
	
	      if (selectParent != null && selectParent._tag === 'select') {
	        selectValue = ReactDOMSelect.getSelectValueContext(selectParent);
	      }
	    }
	
	    // If the value is null (e.g., no specified value or after initial mount)
	    // or missing (e.g., for <datalist>), we don't change props.selected
	    var selected = null;
	    if (selectValue != null) {
	      var value;
	      if (props.value != null) {
	        value = props.value + '';
	      } else {
	        value = flattenChildren(props.children);
	      }
	      selected = false;
	      if (Array.isArray(selectValue)) {
	        // multiple
	        for (var i = 0; i < selectValue.length; i++) {
	          if ('' + selectValue[i] === value) {
	            selected = true;
	            break;
	          }
	        }
	      } else {
	        selected = '' + selectValue === value;
	      }
	    }
	
	    inst._wrapperState = { selected: selected };
	  },
	
	  postMountWrapper: function (inst) {
	    // value="" should make a value attribute (#6219)
	    var props = inst._currentElement.props;
	    if (props.value != null) {
	      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	      node.setAttribute('value', props.value);
	    }
	  },
	
	  getHostProps: function (inst, props) {
	    var hostProps = _assign({ selected: undefined, children: undefined }, props);
	
	    // Read state only from initial mount because <select> updates value
	    // manually; we need the initial state only for server rendering
	    if (inst._wrapperState.selected != null) {
	      hostProps.selected = inst._wrapperState.selected;
	    }
	
	    var content = flattenChildren(props.children);
	
	    if (content) {
	      hostProps.children = content;
	    }
	
	    return hostProps;
	  }
	
	};
	
	module.exports = ReactDOMOption;

/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(302);
	
	var LinkedValueUtils = __webpack_require__(407);
	var ReactDOMComponentTree = __webpack_require__(334);
	var ReactUpdates = __webpack_require__(359);
	
	var warning = __webpack_require__(347);
	
	var didWarnValueLink = false;
	var didWarnValueDefaultValue = false;
	
	function updateOptionsIfPendingUpdateAndMounted() {
	  if (this._rootNodeID && this._wrapperState.pendingUpdate) {
	    this._wrapperState.pendingUpdate = false;
	
	    var props = this._currentElement.props;
	    var value = LinkedValueUtils.getValue(props);
	
	    if (value != null) {
	      updateOptions(this, Boolean(props.multiple), value);
	    }
	  }
	}
	
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	var valuePropNames = ['value', 'defaultValue'];
	
	/**
	 * Validation function for `value` and `defaultValue`.
	 * @private
	 */
	function checkSelectPropTypes(inst, props) {
	  var owner = inst._currentElement._owner;
	  LinkedValueUtils.checkPropTypes('select', props, owner);
	
	  if (props.valueLink !== undefined && !didWarnValueLink) {
	     false ? warning(false, '`valueLink` prop on `select` is deprecated; set `value` and `onChange` instead.') : void 0;
	    didWarnValueLink = true;
	  }
	
	  for (var i = 0; i < valuePropNames.length; i++) {
	    var propName = valuePropNames[i];
	    if (props[propName] == null) {
	      continue;
	    }
	    var isArray = Array.isArray(props[propName]);
	    if (props.multiple && !isArray) {
	       false ? warning(false, 'The `%s` prop supplied to <select> must be an array if ' + '`multiple` is true.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
	    } else if (!props.multiple && isArray) {
	       false ? warning(false, 'The `%s` prop supplied to <select> must be a scalar ' + 'value if `multiple` is false.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
	    }
	  }
	}
	
	/**
	 * @param {ReactDOMComponent} inst
	 * @param {boolean} multiple
	 * @param {*} propValue A stringable (with `multiple`, a list of stringables).
	 * @private
	 */
	function updateOptions(inst, multiple, propValue) {
	  var selectedValue, i;
	  var options = ReactDOMComponentTree.getNodeFromInstance(inst).options;
	
	  if (multiple) {
	    selectedValue = {};
	    for (i = 0; i < propValue.length; i++) {
	      selectedValue['' + propValue[i]] = true;
	    }
	    for (i = 0; i < options.length; i++) {
	      var selected = selectedValue.hasOwnProperty(options[i].value);
	      if (options[i].selected !== selected) {
	        options[i].selected = selected;
	      }
	    }
	  } else {
	    // Do not set `select.value` as exact behavior isn't consistent across all
	    // browsers for all cases.
	    selectedValue = '' + propValue;
	    for (i = 0; i < options.length; i++) {
	      if (options[i].value === selectedValue) {
	        options[i].selected = true;
	        return;
	      }
	    }
	    if (options.length) {
	      options[0].selected = true;
	    }
	  }
	}
	
	/**
	 * Implements a <select> host component that allows optionally setting the
	 * props `value` and `defaultValue`. If `multiple` is false, the prop must be a
	 * stringable. If `multiple` is true, the prop must be an array of stringables.
	 *
	 * If `value` is not supplied (or null/undefined), user actions that change the
	 * selected option will trigger updates to the rendered options.
	 *
	 * If it is supplied (and not null/undefined), the rendered options will not
	 * update in response to user actions. Instead, the `value` prop must change in
	 * order for the rendered options to update.
	 *
	 * If `defaultValue` is provided, any options with the supplied values will be
	 * selected.
	 */
	var ReactDOMSelect = {
	  getHostProps: function (inst, props) {
	    return _assign({}, props, {
	      onChange: inst._wrapperState.onChange,
	      value: undefined
	    });
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      checkSelectPropTypes(inst, props);
	    }
	
	    var value = LinkedValueUtils.getValue(props);
	    inst._wrapperState = {
	      pendingUpdate: false,
	      initialValue: value != null ? value : props.defaultValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst),
	      wasMultiple: Boolean(props.multiple)
	    };
	
	    if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
	       false ? warning(false, 'Select elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled select ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
	      didWarnValueDefaultValue = true;
	    }
	  },
	
	  getSelectValueContext: function (inst) {
	    // ReactDOMOption looks at this initial value so the initial generated
	    // markup has correct `selected` attributes
	    return inst._wrapperState.initialValue;
	  },
	
	  postUpdateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    // After the initial mount, we control selected-ness manually so don't pass
	    // this value down
	    inst._wrapperState.initialValue = undefined;
	
	    var wasMultiple = inst._wrapperState.wasMultiple;
	    inst._wrapperState.wasMultiple = Boolean(props.multiple);
	
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      inst._wrapperState.pendingUpdate = false;
	      updateOptions(inst, Boolean(props.multiple), value);
	    } else if (wasMultiple !== Boolean(props.multiple)) {
	      // For simplicity, reapply `defaultValue` if `multiple` is toggled.
	      if (props.defaultValue != null) {
	        updateOptions(inst, Boolean(props.multiple), props.defaultValue);
	      } else {
	        // Revert the select back to its default unselected state.
	        updateOptions(inst, Boolean(props.multiple), props.multiple ? [] : '');
	      }
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	
	  if (this._rootNodeID) {
	    this._wrapperState.pendingUpdate = true;
	  }
	  ReactUpdates.asap(updateOptionsIfPendingUpdateAndMounted, this);
	  return returnValue;
	}
	
	module.exports = ReactDOMSelect;

/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(335),
	    _assign = __webpack_require__(302);
	
	var LinkedValueUtils = __webpack_require__(407);
	var ReactDOMComponentTree = __webpack_require__(334);
	var ReactUpdates = __webpack_require__(359);
	
	var invariant = __webpack_require__(337);
	var warning = __webpack_require__(347);
	
	var didWarnValueLink = false;
	var didWarnValDefaultVal = false;
	
	function forceUpdateIfMounted() {
	  if (this._rootNodeID) {
	    // DOM component is still mounted; update
	    ReactDOMTextarea.updateWrapper(this);
	  }
	}
	
	/**
	 * Implements a <textarea> host component that allows setting `value`, and
	 * `defaultValue`. This differs from the traditional DOM API because value is
	 * usually set as PCDATA children.
	 *
	 * If `value` is not supplied (or null/undefined), user actions that affect the
	 * value will trigger updates to the element.
	 *
	 * If `value` is supplied (and not null/undefined), the rendered element will
	 * not trigger updates to the element. Instead, the `value` prop must change in
	 * order for the rendered element to be updated.
	 *
	 * The rendered element will be initialized with an empty value, the prop
	 * `defaultValue` if specified, or the children content (deprecated).
	 */
	var ReactDOMTextarea = {
	  getHostProps: function (inst, props) {
	    !(props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '`dangerouslySetInnerHTML` does not make sense on <textarea>.') : _prodInvariant('91') : void 0;
	
	    // Always set children to the same thing. In IE9, the selection range will
	    // get reset if `textContent` is mutated.  We could add a check in setTextContent
	    // to only set the value if/when the value differs from the node value (which would
	    // completely solve this IE9 bug), but Sebastian+Ben seemed to like this solution.
	    // The value can be a boolean or object so that's why it's forced to be a string.
	    var hostProps = _assign({}, props, {
	      value: undefined,
	      defaultValue: undefined,
	      children: '' + inst._wrapperState.initialValue,
	      onChange: inst._wrapperState.onChange
	    });
	
	    return hostProps;
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      LinkedValueUtils.checkPropTypes('textarea', props, inst._currentElement._owner);
	      if (props.valueLink !== undefined && !didWarnValueLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `textarea` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnValueLink = true;
	      }
	      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValDefaultVal) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'Textarea elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled textarea ' + 'and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
	        didWarnValDefaultVal = true;
	      }
	    }
	
	    var value = LinkedValueUtils.getValue(props);
	    var initialValue = value;
	
	    // Only bother fetching default value if we're going to use it
	    if (value == null) {
	      var defaultValue = props.defaultValue;
	      // TODO (yungsters): Remove support for children content in <textarea>.
	      var children = props.children;
	      if (children != null) {
	        if (false) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'Use the `defaultValue` or `value` props instead of setting ' + 'children on <textarea>.') : void 0;
	        }
	        !(defaultValue == null) ?  false ? invariant(false, 'If you supply `defaultValue` on a <textarea>, do not pass children.') : _prodInvariant('92') : void 0;
	        if (Array.isArray(children)) {
	          !(children.length <= 1) ?  false ? invariant(false, '<textarea> can only have at most one child.') : _prodInvariant('93') : void 0;
	          children = children[0];
	        }
	
	        defaultValue = '' + children;
	      }
	      if (defaultValue == null) {
	        defaultValue = '';
	      }
	      initialValue = defaultValue;
	    }
	
	    inst._wrapperState = {
	      initialValue: '' + initialValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst)
	    };
	  },
	
	  updateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      // Cast `value` to a string to ensure the value is set correctly. While
	      // browsers typically do this as necessary, jsdom doesn't.
	      var newValue = '' + value;
	
	      // To avoid side effects (such as losing text selection), only set value if changed
	      if (newValue !== node.value) {
	        node.value = newValue;
	      }
	      if (props.defaultValue == null) {
	        node.defaultValue = newValue;
	      }
	    }
	    if (props.defaultValue != null) {
	      node.defaultValue = props.defaultValue;
	    }
	  },
	
	  postMountWrapper: function (inst) {
	    // This is in postMount because we need access to the DOM node, which is not
	    // available until after the component has mounted.
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var textContent = node.textContent;
	
	    // Only set node.value if textContent is equal to the expected
	    // initial value. In IE10/IE11 there is a bug where the placeholder attribute
	    // will populate textContent as well.
	    // https://developer.microsoft.com/microsoft-edge/platform/issues/101525/
	    if (textContent === inst._wrapperState.initialValue) {
	      node.value = textContent;
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	  ReactUpdates.asap(forceUpdateIfMounted, this);
	  return returnValue;
	}
	
	module.exports = ReactDOMTextarea;

/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(335);
	
	var ReactComponentEnvironment = __webpack_require__(417);
	var ReactInstanceMap = __webpack_require__(418);
	var ReactInstrumentation = __webpack_require__(365);
	
	var ReactCurrentOwner = __webpack_require__(308);
	var ReactReconciler = __webpack_require__(362);
	var ReactChildReconciler = __webpack_require__(419);
	
	var emptyFunction = __webpack_require__(348);
	var flattenChildren = __webpack_require__(434);
	var invariant = __webpack_require__(337);
	
	/**
	 * Make an update for markup to be rendered and inserted at a supplied index.
	 *
	 * @param {string} markup Markup that renders into an element.
	 * @param {number} toIndex Destination index.
	 * @private
	 */
	function makeInsertMarkup(markup, afterNode, toIndex) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'INSERT_MARKUP',
	    content: markup,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: toIndex,
	    afterNode: afterNode
	  };
	}
	
	/**
	 * Make an update for moving an existing element to another index.
	 *
	 * @param {number} fromIndex Source index of the existing element.
	 * @param {number} toIndex Destination index of the element.
	 * @private
	 */
	function makeMove(child, afterNode, toIndex) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'MOVE_EXISTING',
	    content: null,
	    fromIndex: child._mountIndex,
	    fromNode: ReactReconciler.getHostNode(child),
	    toIndex: toIndex,
	    afterNode: afterNode
	  };
	}
	
	/**
	 * Make an update for removing an element at an index.
	 *
	 * @param {number} fromIndex Index of the element to remove.
	 * @private
	 */
	function makeRemove(child, node) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'REMOVE_NODE',
	    content: null,
	    fromIndex: child._mountIndex,
	    fromNode: node,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Make an update for setting the markup of a node.
	 *
	 * @param {string} markup Markup that renders into an element.
	 * @private
	 */
	function makeSetMarkup(markup) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'SET_MARKUP',
	    content: markup,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Make an update for setting the text content.
	 *
	 * @param {string} textContent Text content to set.
	 * @private
	 */
	function makeTextContent(textContent) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'TEXT_CONTENT',
	    content: textContent,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Push an update, if any, onto the queue. Creates a new queue if none is
	 * passed and always returns the queue. Mutative.
	 */
	function enqueue(queue, update) {
	  if (update) {
	    queue = queue || [];
	    queue.push(update);
	  }
	  return queue;
	}
	
	/**
	 * Processes any enqueued updates.
	 *
	 * @private
	 */
	function processQueue(inst, updateQueue) {
	  ReactComponentEnvironment.processChildrenUpdates(inst, updateQueue);
	}
	
	var setChildrenForInstrumentation = emptyFunction;
	if (false) {
	  var getDebugID = function (inst) {
	    if (!inst._debugID) {
	      // Check for ART-like instances. TODO: This is silly/gross.
	      var internal;
	      if (internal = ReactInstanceMap.get(inst)) {
	        inst = internal;
	      }
	    }
	    return inst._debugID;
	  };
	  setChildrenForInstrumentation = function (children) {
	    var debugID = getDebugID(this);
	    // TODO: React Native empty components are also multichild.
	    // This means they still get into this method but don't have _debugID.
	    if (debugID !== 0) {
	      ReactInstrumentation.debugTool.onSetChildren(debugID, children ? Object.keys(children).map(function (key) {
	        return children[key]._debugID;
	      }) : []);
	    }
	  };
	}
	
	/**
	 * ReactMultiChild are capable of reconciling multiple children.
	 *
	 * @class ReactMultiChild
	 * @internal
	 */
	var ReactMultiChild = {
	
	  /**
	   * Provides common functionality for components that must reconcile multiple
	   * children. This is used by `ReactDOMComponent` to mount, update, and
	   * unmount child components.
	   *
	   * @lends {ReactMultiChild.prototype}
	   */
	  Mixin: {
	
	    _reconcilerInstantiateChildren: function (nestedChildren, transaction, context) {
	      if (false) {
	        var selfDebugID = getDebugID(this);
	        if (this._currentElement) {
	          try {
	            ReactCurrentOwner.current = this._currentElement._owner;
	            return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context, selfDebugID);
	          } finally {
	            ReactCurrentOwner.current = null;
	          }
	        }
	      }
	      return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context);
	    },
	
	    _reconcilerUpdateChildren: function (prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context) {
	      var nextChildren;
	      var selfDebugID = 0;
	      if (false) {
	        selfDebugID = getDebugID(this);
	        if (this._currentElement) {
	          try {
	            ReactCurrentOwner.current = this._currentElement._owner;
	            nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
	          } finally {
	            ReactCurrentOwner.current = null;
	          }
	          ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
	          return nextChildren;
	        }
	      }
	      nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
	      ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
	      return nextChildren;
	    },
	
	    /**
	     * Generates a "mount image" for each of the supplied children. In the case
	     * of `ReactDOMComponent`, a mount image is a string of markup.
	     *
	     * @param {?object} nestedChildren Nested child maps.
	     * @return {array} An array of mounted representations.
	     * @internal
	     */
	    mountChildren: function (nestedChildren, transaction, context) {
	      var children = this._reconcilerInstantiateChildren(nestedChildren, transaction, context);
	      this._renderedChildren = children;
	
	      var mountImages = [];
	      var index = 0;
	      for (var name in children) {
	        if (children.hasOwnProperty(name)) {
	          var child = children[name];
	          var selfDebugID = 0;
	          if (false) {
	            selfDebugID = getDebugID(this);
	          }
	          var mountImage = ReactReconciler.mountComponent(child, transaction, this, this._hostContainerInfo, context, selfDebugID);
	          child._mountIndex = index++;
	          mountImages.push(mountImage);
	        }
	      }
	
	      if (false) {
	        setChildrenForInstrumentation.call(this, children);
	      }
	
	      return mountImages;
	    },
	
	    /**
	     * Replaces any rendered children with a text content string.
	     *
	     * @param {string} nextContent String of content.
	     * @internal
	     */
	    updateTextContent: function (nextContent) {
	      var prevChildren = this._renderedChildren;
	      // Remove any rendered children.
	      ReactChildReconciler.unmountChildren(prevChildren, false);
	      for (var name in prevChildren) {
	        if (prevChildren.hasOwnProperty(name)) {
	           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
	        }
	      }
	      // Set new text content.
	      var updates = [makeTextContent(nextContent)];
	      processQueue(this, updates);
	    },
	
	    /**
	     * Replaces any rendered children with a markup string.
	     *
	     * @param {string} nextMarkup String of markup.
	     * @internal
	     */
	    updateMarkup: function (nextMarkup) {
	      var prevChildren = this._renderedChildren;
	      // Remove any rendered children.
	      ReactChildReconciler.unmountChildren(prevChildren, false);
	      for (var name in prevChildren) {
	        if (prevChildren.hasOwnProperty(name)) {
	           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
	        }
	      }
	      var updates = [makeSetMarkup(nextMarkup)];
	      processQueue(this, updates);
	    },
	
	    /**
	     * Updates the rendered children with new children.
	     *
	     * @param {?object} nextNestedChildrenElements Nested child element maps.
	     * @param {ReactReconcileTransaction} transaction
	     * @internal
	     */
	    updateChildren: function (nextNestedChildrenElements, transaction, context) {
	      // Hook used by React ART
	      this._updateChildren(nextNestedChildrenElements, transaction, context);
	    },
	
	    /**
	     * @param {?object} nextNestedChildrenElements Nested child element maps.
	     * @param {ReactReconcileTransaction} transaction
	     * @final
	     * @protected
	     */
	    _updateChildren: function (nextNestedChildrenElements, transaction, context) {
	      var prevChildren = this._renderedChildren;
	      var removedNodes = {};
	      var mountImages = [];
	      var nextChildren = this._reconcilerUpdateChildren(prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context);
	      if (!nextChildren && !prevChildren) {
	        return;
	      }
	      var updates = null;
	      var name;
	      // `nextIndex` will increment for each child in `nextChildren`, but
	      // `lastIndex` will be the last index visited in `prevChildren`.
	      var nextIndex = 0;
	      var lastIndex = 0;
	      // `nextMountIndex` will increment for each newly mounted child.
	      var nextMountIndex = 0;
	      var lastPlacedNode = null;
	      for (name in nextChildren) {
	        if (!nextChildren.hasOwnProperty(name)) {
	          continue;
	        }
	        var prevChild = prevChildren && prevChildren[name];
	        var nextChild = nextChildren[name];
	        if (prevChild === nextChild) {
	          updates = enqueue(updates, this.moveChild(prevChild, lastPlacedNode, nextIndex, lastIndex));
	          lastIndex = Math.max(prevChild._mountIndex, lastIndex);
	          prevChild._mountIndex = nextIndex;
	        } else {
	          if (prevChild) {
	            // Update `lastIndex` before `_mountIndex` gets unset by unmounting.
	            lastIndex = Math.max(prevChild._mountIndex, lastIndex);
	            // The `removedNodes` loop below will actually remove the child.
	          }
	          // The child must be instantiated before it's mounted.
	          updates = enqueue(updates, this._mountChildAtIndex(nextChild, mountImages[nextMountIndex], lastPlacedNode, nextIndex, transaction, context));
	          nextMountIndex++;
	        }
	        nextIndex++;
	        lastPlacedNode = ReactReconciler.getHostNode(nextChild);
	      }
	      // Remove children that are no longer present.
	      for (name in removedNodes) {
	        if (removedNodes.hasOwnProperty(name)) {
	          updates = enqueue(updates, this._unmountChild(prevChildren[name], removedNodes[name]));
	        }
	      }
	      if (updates) {
	        processQueue(this, updates);
	      }
	      this._renderedChildren = nextChildren;
	
	      if (false) {
	        setChildrenForInstrumentation.call(this, nextChildren);
	      }
	    },
	
	    /**
	     * Unmounts all rendered children. This should be used to clean up children
	     * when this component is unmounted. It does not actually perform any
	     * backend operations.
	     *
	     * @internal
	     */
	    unmountChildren: function (safely) {
	      var renderedChildren = this._renderedChildren;
	      ReactChildReconciler.unmountChildren(renderedChildren, safely);
	      this._renderedChildren = null;
	    },
	
	    /**
	     * Moves a child component to the supplied index.
	     *
	     * @param {ReactComponent} child Component to move.
	     * @param {number} toIndex Destination index of the element.
	     * @param {number} lastIndex Last index visited of the siblings of `child`.
	     * @protected
	     */
	    moveChild: function (child, afterNode, toIndex, lastIndex) {
	      // If the index of `child` is less than `lastIndex`, then it needs to
	      // be moved. Otherwise, we do not need to move it because a child will be
	      // inserted or moved before `child`.
	      if (child._mountIndex < lastIndex) {
	        return makeMove(child, afterNode, toIndex);
	      }
	    },
	
	    /**
	     * Creates a child component.
	     *
	     * @param {ReactComponent} child Component to create.
	     * @param {string} mountImage Markup to insert.
	     * @protected
	     */
	    createChild: function (child, afterNode, mountImage) {
	      return makeInsertMarkup(mountImage, afterNode, child._mountIndex);
	    },
	
	    /**
	     * Removes a child component.
	     *
	     * @param {ReactComponent} child Child to remove.
	     * @protected
	     */
	    removeChild: function (child, node) {
	      return makeRemove(child, node);
	    },
	
	    /**
	     * Mounts a child with the supplied name.
	     *
	     * NOTE: This is part of `updateChildren` and is here for readability.
	     *
	     * @param {ReactComponent} child Component to mount.
	     * @param {string} name Name of the child.
	     * @param {number} index Index at which to insert the child.
	     * @param {ReactReconcileTransaction} transaction
	     * @private
	     */
	    _mountChildAtIndex: function (child, mountImage, afterNode, index, transaction, context) {
	      child._mountIndex = index;
	      return this.createChild(child, afterNode, mountImage);
	    },
	
	    /**
	     * Unmounts a rendered child.
	     *
	     * NOTE: This is part of `updateChildren` and is here for readability.
	     *
	     * @param {ReactComponent} child Component to unmount.
	     * @private
	     */
	    _unmountChild: function (child, node) {
	      var update = this.removeChild(child, node);
	      child._mountIndex = null;
	      return update;
	    }
	
	  }
	
	};
	
	module.exports = ReactMultiChild;

/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(335);
	
	var invariant = __webpack_require__(337);
	
	var injected = false;
	
	var ReactComponentEnvironment = {
	
	  /**
	   * Optionally injectable hook for swapping out mount images in the middle of
	   * the tree.
	   */
	  replaceNodeWithMarkup: null,
	
	  /**
	   * Optionally injectable hook for processing a queue of child updates. Will
	   * later move into MultiChildComponents.
	   */
	  processChildrenUpdates: null,
	
	  injection: {
	    injectEnvironment: function (environment) {
	      !!injected ?  false ? invariant(false, 'ReactCompositeComponent: injectEnvironment() can only be called once.') : _prodInvariant('104') : void 0;
	      ReactComponentEnvironment.replaceNodeWithMarkup = environment.replaceNodeWithMarkup;
	      ReactComponentEnvironment.processChildrenUpdates = environment.processChildrenUpdates;
	      injected = true;
	    }
	  }
	
	};
	
	module.exports = ReactComponentEnvironment;

/***/ }),
/* 418 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * `ReactInstanceMap` maintains a mapping from a public facing stateful
	 * instance (key) and the internal representation (value). This allows public
	 * methods to accept the user facing instance as an argument and map them back
	 * to internal methods.
	 */
	
	// TODO: Replace this with ES6: var ReactInstanceMap = new Map();
	
	var ReactInstanceMap = {
	
	  /**
	   * This API should be called `delete` but we'd have to make sure to always
	   * transform these to strings for IE support. When this transform is fully
	   * supported we can rename it.
	   */
	  remove: function (key) {
	    key._reactInternalInstance = undefined;
	  },
	
	  get: function (key) {
	    return key._reactInternalInstance;
	  },
	
	  has: function (key) {
	    return key._reactInternalInstance !== undefined;
	  },
	
	  set: function (key, value) {
	    key._reactInternalInstance = value;
	  }
	
	};
	
	module.exports = ReactInstanceMap;

/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactReconciler = __webpack_require__(362);
	
	var instantiateReactComponent = __webpack_require__(420);
	var KeyEscapeUtils = __webpack_require__(429);
	var shouldUpdateReactComponent = __webpack_require__(425);
	var traverseAllChildren = __webpack_require__(430);
	var warning = __webpack_require__(347);
	
	var ReactComponentTreeHook;
	
	if (typeof process !== 'undefined' && process.env && ("production") === 'test') {
	  // Temporary hack.
	  // Inline requires don't work well with Jest:
	  // https://github.com/facebook/react/issues/7240
	  // Remove the inline requires when we don't need them anymore:
	  // https://github.com/facebook/react/pull/7178
	  ReactComponentTreeHook = __webpack_require__(433);
	}
	
	function instantiateChild(childInstances, child, name, selfDebugID) {
	  // We found a component instance.
	  var keyUnique = childInstances[name] === undefined;
	  if (false) {
	    if (!ReactComponentTreeHook) {
	      ReactComponentTreeHook = require('react/lib/ReactComponentTreeHook');
	    }
	    if (!keyUnique) {
	      process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
	    }
	  }
	  if (child != null && keyUnique) {
	    childInstances[name] = instantiateReactComponent(child, true);
	  }
	}
	
	/**
	 * ReactChildReconciler provides helpers for initializing or updating a set of
	 * children. Its output is suitable for passing it onto ReactMultiChild which
	 * does diffed reordering and insertion.
	 */
	var ReactChildReconciler = {
	  /**
	   * Generates a "mount image" for each of the supplied children. In the case
	   * of `ReactDOMComponent`, a mount image is a string of markup.
	   *
	   * @param {?object} nestedChildNodes Nested child maps.
	   * @return {?object} A set of child instances.
	   * @internal
	   */
	  instantiateChildren: function (nestedChildNodes, transaction, context, selfDebugID // 0 in production and for roots
	  ) {
	    if (nestedChildNodes == null) {
	      return null;
	    }
	    var childInstances = {};
	
	    if (false) {
	      traverseAllChildren(nestedChildNodes, function (childInsts, child, name) {
	        return instantiateChild(childInsts, child, name, selfDebugID);
	      }, childInstances);
	    } else {
	      traverseAllChildren(nestedChildNodes, instantiateChild, childInstances);
	    }
	    return childInstances;
	  },
	
	  /**
	   * Updates the rendered children and returns a new set of children.
	   *
	   * @param {?object} prevChildren Previously initialized set of children.
	   * @param {?object} nextChildren Flat child element maps.
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   * @return {?object} A new set of child instances.
	   * @internal
	   */
	  updateChildren: function (prevChildren, nextChildren, mountImages, removedNodes, transaction, hostParent, hostContainerInfo, context, selfDebugID // 0 in production and for roots
	  ) {
	    // We currently don't have a way to track moves here but if we use iterators
	    // instead of for..in we can zip the iterators and check if an item has
	    // moved.
	    // TODO: If nothing has changed, return the prevChildren object so that we
	    // can quickly bailout if nothing has changed.
	    if (!nextChildren && !prevChildren) {
	      return;
	    }
	    var name;
	    var prevChild;
	    for (name in nextChildren) {
	      if (!nextChildren.hasOwnProperty(name)) {
	        continue;
	      }
	      prevChild = prevChildren && prevChildren[name];
	      var prevElement = prevChild && prevChild._currentElement;
	      var nextElement = nextChildren[name];
	      if (prevChild != null && shouldUpdateReactComponent(prevElement, nextElement)) {
	        ReactReconciler.receiveComponent(prevChild, nextElement, transaction, context);
	        nextChildren[name] = prevChild;
	      } else {
	        if (prevChild) {
	          removedNodes[name] = ReactReconciler.getHostNode(prevChild);
	          ReactReconciler.unmountComponent(prevChild, false);
	        }
	        // The child must be instantiated before it's mounted.
	        var nextChildInstance = instantiateReactComponent(nextElement, true);
	        nextChildren[name] = nextChildInstance;
	        // Creating mount image now ensures refs are resolved in right order
	        // (see https://github.com/facebook/react/pull/7101 for explanation).
	        var nextChildMountImage = ReactReconciler.mountComponent(nextChildInstance, transaction, hostParent, hostContainerInfo, context, selfDebugID);
	        mountImages.push(nextChildMountImage);
	      }
	    }
	    // Unmount children that are no longer present.
	    for (name in prevChildren) {
	      if (prevChildren.hasOwnProperty(name) && !(nextChildren && nextChildren.hasOwnProperty(name))) {
	        prevChild = prevChildren[name];
	        removedNodes[name] = ReactReconciler.getHostNode(prevChild);
	        ReactReconciler.unmountComponent(prevChild, false);
	      }
	    }
	  },
	
	  /**
	   * Unmounts all rendered children. This should be used to clean up children
	   * when this component is unmounted.
	   *
	   * @param {?object} renderedChildren Previously initialized set of children.
	   * @internal
	   */
	  unmountChildren: function (renderedChildren, safely) {
	    for (var name in renderedChildren) {
	      if (renderedChildren.hasOwnProperty(name)) {
	        var renderedChild = renderedChildren[name];
	        ReactReconciler.unmountComponent(renderedChild, safely);
	      }
	    }
	  }
	
	};
	
	module.exports = ReactChildReconciler;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(294)))

/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(335),
	    _assign = __webpack_require__(302);
	
	var ReactCompositeComponent = __webpack_require__(421);
	var ReactEmptyComponent = __webpack_require__(426);
	var ReactHostComponent = __webpack_require__(427);
	
	var getNextDebugID = __webpack_require__(428);
	var invariant = __webpack_require__(337);
	var warning = __webpack_require__(347);
	
	// To avoid a cyclic dependency, we create the final class in this module
	var ReactCompositeComponentWrapper = function (element) {
	  this.construct(element);
	};
	
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	/**
	 * Check if the type reference is a known internal type. I.e. not a user
	 * provided composite type.
	 *
	 * @param {function} type
	 * @return {boolean} Returns true if this is a valid internal type.
	 */
	function isInternalComponentType(type) {
	  return typeof type === 'function' && typeof type.prototype !== 'undefined' && typeof type.prototype.mountComponent === 'function' && typeof type.prototype.receiveComponent === 'function';
	}
	
	/**
	 * Given a ReactNode, create an instance that will actually be mounted.
	 *
	 * @param {ReactNode} node
	 * @param {boolean} shouldHaveDebugID
	 * @return {object} A new instance of the element's constructor.
	 * @protected
	 */
	function instantiateReactComponent(node, shouldHaveDebugID) {
	  var instance;
	
	  if (node === null || node === false) {
	    instance = ReactEmptyComponent.create(instantiateReactComponent);
	  } else if (typeof node === 'object') {
	    var element = node;
	    var type = element.type;
	    if (typeof type !== 'function' && typeof type !== 'string') {
	      var info = '';
	      if (false) {
	        if (type === undefined || typeof type === 'object' && type !== null && Object.keys(type).length === 0) {
	          info += ' You likely forgot to export your component from the file ' + 'it\'s defined in.';
	        }
	      }
	      info += getDeclarationErrorAddendum(element._owner);
	       true ?  false ? invariant(false, 'Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s', type == null ? type : typeof type, info) : _prodInvariant('130', type == null ? type : typeof type, info) : void 0;
	    }
	
	    // Special case string values
	    if (typeof element.type === 'string') {
	      instance = ReactHostComponent.createInternalComponent(element);
	    } else if (isInternalComponentType(element.type)) {
	      // This is temporarily available for custom components that are not string
	      // representations. I.e. ART. Once those are updated to use the string
	      // representation, we can drop this code path.
	      instance = new element.type(element);
	
	      // We renamed this. Allow the old name for compat. :(
	      if (!instance.getHostNode) {
	        instance.getHostNode = instance.getNativeNode;
	      }
	    } else {
	      instance = new ReactCompositeComponentWrapper(element);
	    }
	  } else if (typeof node === 'string' || typeof node === 'number') {
	    instance = ReactHostComponent.createInstanceForText(node);
	  } else {
	     true ?  false ? invariant(false, 'Encountered invalid React node of type %s', typeof node) : _prodInvariant('131', typeof node) : void 0;
	  }
	
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(typeof instance.mountComponent === 'function' && typeof instance.receiveComponent === 'function' && typeof instance.getHostNode === 'function' && typeof instance.unmountComponent === 'function', 'Only React Components can be mounted.') : void 0;
	  }
	
	  // These two fields are used by the DOM and ART diffing algorithms
	  // respectively. Instead of using expandos on components, we should be
	  // storing the state needed by the diffing algorithms elsewhere.
	  instance._mountIndex = 0;
	  instance._mountImage = null;
	
	  if (false) {
	    instance._debugID = shouldHaveDebugID ? getNextDebugID() : 0;
	  }
	
	  // Internal instances should fully constructed at this point, so they should
	  // not get any new fields added to them at this point.
	  if (false) {
	    if (Object.preventExtensions) {
	      Object.preventExtensions(instance);
	    }
	  }
	
	  return instance;
	}
	
	_assign(ReactCompositeComponentWrapper.prototype, ReactCompositeComponent, {
	  _instantiateReactComponent: instantiateReactComponent
	});
	
	module.exports = instantiateReactComponent;

/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(335),
	    _assign = __webpack_require__(302);
	
	var React = __webpack_require__(301);
	var ReactComponentEnvironment = __webpack_require__(417);
	var ReactCurrentOwner = __webpack_require__(308);
	var ReactErrorUtils = __webpack_require__(346);
	var ReactInstanceMap = __webpack_require__(418);
	var ReactInstrumentation = __webpack_require__(365);
	var ReactNodeTypes = __webpack_require__(422);
	var ReactReconciler = __webpack_require__(362);
	
	if (false) {
	  var checkReactTypeSpec = require('./checkReactTypeSpec');
	}
	
	var emptyObject = __webpack_require__(423);
	var invariant = __webpack_require__(337);
	var shallowEqual = __webpack_require__(424);
	var shouldUpdateReactComponent = __webpack_require__(425);
	var warning = __webpack_require__(347);
	
	var CompositeTypes = {
	  ImpureClass: 0,
	  PureClass: 1,
	  StatelessFunctional: 2
	};
	
	function StatelessComponent(Component) {}
	StatelessComponent.prototype.render = function () {
	  var Component = ReactInstanceMap.get(this)._currentElement.type;
	  var element = Component(this.props, this.context, this.updater);
	  warnIfInvalidElement(Component, element);
	  return element;
	};
	
	function warnIfInvalidElement(Component, element) {
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(element === null || element === false || React.isValidElement(element), '%s(...): A valid React element (or null) must be returned. You may have ' + 'returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(!Component.childContextTypes, '%s(...): childContextTypes cannot be defined on a functional component.', Component.displayName || Component.name || 'Component') : void 0;
	  }
	}
	
	function shouldConstruct(Component) {
	  return !!(Component.prototype && Component.prototype.isReactComponent);
	}
	
	function isPureComponent(Component) {
	  return !!(Component.prototype && Component.prototype.isPureReactComponent);
	}
	
	// Separated into a function to contain deoptimizations caused by try/finally.
	function measureLifeCyclePerf(fn, debugID, timerType) {
	  if (debugID === 0) {
	    // Top-level wrappers (see ReactMount) and empty components (see
	    // ReactDOMEmptyComponent) are invisible to hooks and devtools.
	    // Both are implementation details that should go away in the future.
	    return fn();
	  }
	
	  ReactInstrumentation.debugTool.onBeginLifeCycleTimer(debugID, timerType);
	  try {
	    return fn();
	  } finally {
	    ReactInstrumentation.debugTool.onEndLifeCycleTimer(debugID, timerType);
	  }
	}
	
	/**
	 * ------------------ The Life-Cycle of a Composite Component ------------------
	 *
	 * - constructor: Initialization of state. The instance is now retained.
	 *   - componentWillMount
	 *   - render
	 *   - [children's constructors]
	 *     - [children's componentWillMount and render]
	 *     - [children's componentDidMount]
	 *     - componentDidMount
	 *
	 *       Update Phases:
	 *       - componentWillReceiveProps (only called if parent updated)
	 *       - shouldComponentUpdate
	 *         - componentWillUpdate
	 *           - render
	 *           - [children's constructors or receive props phases]
	 *         - componentDidUpdate
	 *
	 *     - componentWillUnmount
	 *     - [children's componentWillUnmount]
	 *   - [children destroyed]
	 * - (destroyed): The instance is now blank, released by React and ready for GC.
	 *
	 * -----------------------------------------------------------------------------
	 */
	
	/**
	 * An incrementing ID assigned to each component when it is mounted. This is
	 * used to enforce the order in which `ReactUpdates` updates dirty components.
	 *
	 * @private
	 */
	var nextMountID = 1;
	
	/**
	 * @lends {ReactCompositeComponent.prototype}
	 */
	var ReactCompositeComponent = {
	
	  /**
	   * Base constructor for all composite component.
	   *
	   * @param {ReactElement} element
	   * @final
	   * @internal
	   */
	  construct: function (element) {
	    this._currentElement = element;
	    this._rootNodeID = 0;
	    this._compositeType = null;
	    this._instance = null;
	    this._hostParent = null;
	    this._hostContainerInfo = null;
	
	    // See ReactUpdateQueue
	    this._updateBatchNumber = null;
	    this._pendingElement = null;
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	
	    this._renderedNodeType = null;
	    this._renderedComponent = null;
	    this._context = null;
	    this._mountOrder = 0;
	    this._topLevelWrapper = null;
	
	    // See ReactUpdates and ReactUpdateQueue.
	    this._pendingCallbacks = null;
	
	    // ComponentWillUnmount shall only be called once
	    this._calledComponentWillUnmount = false;
	
	    if (false) {
	      this._warnedAboutRefsInRender = false;
	    }
	  },
	
	  /**
	   * Initializes the component, renders markup, and registers event listeners.
	   *
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?object} hostParent
	   * @param {?object} hostContainerInfo
	   * @param {?object} context
	   * @return {?string} Rendered markup to be inserted into the DOM.
	   * @final
	   * @internal
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    var _this = this;
	
	    this._context = context;
	    this._mountOrder = nextMountID++;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var publicProps = this._currentElement.props;
	    var publicContext = this._processContext(context);
	
	    var Component = this._currentElement.type;
	
	    var updateQueue = transaction.getUpdateQueue();
	
	    // Initialize the public class
	    var doConstruct = shouldConstruct(Component);
	    var inst = this._constructComponent(doConstruct, publicProps, publicContext, updateQueue);
	    var renderedElement;
	
	    // Support functional components
	    if (!doConstruct && (inst == null || inst.render == null)) {
	      renderedElement = inst;
	      warnIfInvalidElement(Component, renderedElement);
	      !(inst === null || inst === false || React.isValidElement(inst)) ?  false ? invariant(false, '%s(...): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : _prodInvariant('105', Component.displayName || Component.name || 'Component') : void 0;
	      inst = new StatelessComponent(Component);
	      this._compositeType = CompositeTypes.StatelessFunctional;
	    } else {
	      if (isPureComponent(Component)) {
	        this._compositeType = CompositeTypes.PureClass;
	      } else {
	        this._compositeType = CompositeTypes.ImpureClass;
	      }
	    }
	
	    if (false) {
	      // This will throw later in _renderValidatedComponent, but add an early
	      // warning now to help debugging
	      if (inst.render == null) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): No `render` method found on the returned component ' + 'instance: you may have forgotten to define `render`.', Component.displayName || Component.name || 'Component') : void 0;
	      }
	
	      var propsMutated = inst.props !== publicProps;
	      var componentName = Component.displayName || Component.name || 'Component';
	
	      process.env.NODE_ENV !== 'production' ? warning(inst.props === undefined || !propsMutated, '%s(...): When calling super() in `%s`, make sure to pass ' + 'up the same props that your component\'s constructor was passed.', componentName, componentName) : void 0;
	    }
	
	    // These should be set up in the constructor, but as a convenience for
	    // simpler class abstractions, we set them up after the fact.
	    inst.props = publicProps;
	    inst.context = publicContext;
	    inst.refs = emptyObject;
	    inst.updater = updateQueue;
	
	    this._instance = inst;
	
	    // Store a reference from the instance back to the internal representation
	    ReactInstanceMap.set(inst, this);
	
	    if (false) {
	      // Since plain JS classes are defined without any special initialization
	      // logic, we can not catch common errors early. Therefore, we have to
	      // catch them here, at initialization time, instead.
	      process.env.NODE_ENV !== 'production' ? warning(!inst.getInitialState || inst.getInitialState.isReactClassApproved || inst.state, 'getInitialState was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Did you mean to define a state property instead?', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.getDefaultProps || inst.getDefaultProps.isReactClassApproved, 'getDefaultProps was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Use a static property to define defaultProps instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.propTypes, 'propTypes was defined as an instance property on %s. Use a static ' + 'property to define propTypes instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.contextTypes, 'contextTypes was defined as an instance property on %s. Use a ' + 'static property to define contextTypes instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentShouldUpdate !== 'function', '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', this.getName() || 'A component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentDidUnmount !== 'function', '%s has a method called ' + 'componentDidUnmount(). But there is no such lifecycle method. ' + 'Did you mean componentWillUnmount()?', this.getName() || 'A component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentWillRecieveProps !== 'function', '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', this.getName() || 'A component') : void 0;
	    }
	
	    var initialState = inst.state;
	    if (initialState === undefined) {
	      inst.state = initialState = null;
	    }
	    !(typeof initialState === 'object' && !Array.isArray(initialState)) ?  false ? invariant(false, '%s.state: must be set to an object or null', this.getName() || 'ReactCompositeComponent') : _prodInvariant('106', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	
	    var markup;
	    if (inst.unstable_handleError) {
	      markup = this.performInitialMountWithErrorHandling(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    } else {
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    }
	
	    if (inst.componentDidMount) {
	      if (false) {
	        transaction.getReactMountReady().enqueue(function () {
	          measureLifeCyclePerf(function () {
	            return inst.componentDidMount();
	          }, _this._debugID, 'componentDidMount');
	        });
	      } else {
	        transaction.getReactMountReady().enqueue(inst.componentDidMount, inst);
	      }
	    }
	
	    return markup;
	  },
	
	  _constructComponent: function (doConstruct, publicProps, publicContext, updateQueue) {
	    if (false) {
	      ReactCurrentOwner.current = this;
	      try {
	        return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
	      } finally {
	        ReactCurrentOwner.current = null;
	      }
	    } else {
	      return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
	    }
	  },
	
	  _constructComponentWithoutOwner: function (doConstruct, publicProps, publicContext, updateQueue) {
	    var Component = this._currentElement.type;
	
	    if (doConstruct) {
	      if (false) {
	        return measureLifeCyclePerf(function () {
	          return new Component(publicProps, publicContext, updateQueue);
	        }, this._debugID, 'ctor');
	      } else {
	        return new Component(publicProps, publicContext, updateQueue);
	      }
	    }
	
	    // This can still be an instance in case of factory components
	    // but we'll count this as time spent rendering as the more common case.
	    if (false) {
	      return measureLifeCyclePerf(function () {
	        return Component(publicProps, publicContext, updateQueue);
	      }, this._debugID, 'render');
	    } else {
	      return Component(publicProps, publicContext, updateQueue);
	    }
	  },
	
	  performInitialMountWithErrorHandling: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
	    var markup;
	    var checkpoint = transaction.checkpoint();
	    try {
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    } catch (e) {
	      // Roll back to checkpoint, handle error (which may add items to the transaction), and take a new checkpoint
	      transaction.rollback(checkpoint);
	      this._instance.unstable_handleError(e);
	      if (this._pendingStateQueue) {
	        this._instance.state = this._processPendingState(this._instance.props, this._instance.context);
	      }
	      checkpoint = transaction.checkpoint();
	
	      this._renderedComponent.unmountComponent(true);
	      transaction.rollback(checkpoint);
	
	      // Try again - we've informed the component about the error, so they can render an error message this time.
	      // If this throws again, the error will bubble up (and can be caught by a higher error boundary).
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    }
	    return markup;
	  },
	
	  performInitialMount: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
	    var inst = this._instance;
	
	    var debugID = 0;
	    if (false) {
	      debugID = this._debugID;
	    }
	
	    if (inst.componentWillMount) {
	      if (false) {
	        measureLifeCyclePerf(function () {
	          return inst.componentWillMount();
	        }, debugID, 'componentWillMount');
	      } else {
	        inst.componentWillMount();
	      }
	      // When mounting, calls to `setState` by `componentWillMount` will set
	      // `this._pendingStateQueue` without triggering a re-render.
	      if (this._pendingStateQueue) {
	        inst.state = this._processPendingState(inst.props, inst.context);
	      }
	    }
	
	    // If not a stateless component, we now render
	    if (renderedElement === undefined) {
	      renderedElement = this._renderValidatedComponent();
	    }
	
	    var nodeType = ReactNodeTypes.getType(renderedElement);
	    this._renderedNodeType = nodeType;
	    var child = this._instantiateReactComponent(renderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
	    );
	    this._renderedComponent = child;
	
	    var markup = ReactReconciler.mountComponent(child, transaction, hostParent, hostContainerInfo, this._processChildContext(context), debugID);
	
	    if (false) {
	      if (debugID !== 0) {
	        var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
	        ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
	      }
	    }
	
	    return markup;
	  },
	
	  getHostNode: function () {
	    return ReactReconciler.getHostNode(this._renderedComponent);
	  },
	
	  /**
	   * Releases any resources allocated by `mountComponent`.
	   *
	   * @final
	   * @internal
	   */
	  unmountComponent: function (safely) {
	    if (!this._renderedComponent) {
	      return;
	    }
	
	    var inst = this._instance;
	
	    if (inst.componentWillUnmount && !inst._calledComponentWillUnmount) {
	      inst._calledComponentWillUnmount = true;
	
	      if (safely) {
	        var name = this.getName() + '.componentWillUnmount()';
	        ReactErrorUtils.invokeGuardedCallback(name, inst.componentWillUnmount.bind(inst));
	      } else {
	        if (false) {
	          measureLifeCyclePerf(function () {
	            return inst.componentWillUnmount();
	          }, this._debugID, 'componentWillUnmount');
	        } else {
	          inst.componentWillUnmount();
	        }
	      }
	    }
	
	    if (this._renderedComponent) {
	      ReactReconciler.unmountComponent(this._renderedComponent, safely);
	      this._renderedNodeType = null;
	      this._renderedComponent = null;
	      this._instance = null;
	    }
	
	    // Reset pending fields
	    // Even if this component is scheduled for another update in ReactUpdates,
	    // it would still be ignored because these fields are reset.
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	    this._pendingCallbacks = null;
	    this._pendingElement = null;
	
	    // These fields do not really need to be reset since this object is no
	    // longer accessible.
	    this._context = null;
	    this._rootNodeID = 0;
	    this._topLevelWrapper = null;
	
	    // Delete the reference from the instance to this internal representation
	    // which allow the internals to be properly cleaned up even if the user
	    // leaks a reference to the public instance.
	    ReactInstanceMap.remove(inst);
	
	    // Some existing components rely on inst.props even after they've been
	    // destroyed (in event handlers).
	    // TODO: inst.props = null;
	    // TODO: inst.state = null;
	    // TODO: inst.context = null;
	  },
	
	  /**
	   * Filters the context object to only contain keys specified in
	   * `contextTypes`
	   *
	   * @param {object} context
	   * @return {?object}
	   * @private
	   */
	  _maskContext: function (context) {
	    var Component = this._currentElement.type;
	    var contextTypes = Component.contextTypes;
	    if (!contextTypes) {
	      return emptyObject;
	    }
	    var maskedContext = {};
	    for (var contextName in contextTypes) {
	      maskedContext[contextName] = context[contextName];
	    }
	    return maskedContext;
	  },
	
	  /**
	   * Filters the context object to only contain keys specified in
	   * `contextTypes`, and asserts that they are valid.
	   *
	   * @param {object} context
	   * @return {?object}
	   * @private
	   */
	  _processContext: function (context) {
	    var maskedContext = this._maskContext(context);
	    if (false) {
	      var Component = this._currentElement.type;
	      if (Component.contextTypes) {
	        this._checkContextTypes(Component.contextTypes, maskedContext, 'context');
	      }
	    }
	    return maskedContext;
	  },
	
	  /**
	   * @param {object} currentContext
	   * @return {object}
	   * @private
	   */
	  _processChildContext: function (currentContext) {
	    var Component = this._currentElement.type;
	    var inst = this._instance;
	    var childContext;
	
	    if (inst.getChildContext) {
	      if (false) {
	        ReactInstrumentation.debugTool.onBeginProcessingChildContext();
	        try {
	          childContext = inst.getChildContext();
	        } finally {
	          ReactInstrumentation.debugTool.onEndProcessingChildContext();
	        }
	      } else {
	        childContext = inst.getChildContext();
	      }
	    }
	
	    if (childContext) {
	      !(typeof Component.childContextTypes === 'object') ?  false ? invariant(false, '%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().', this.getName() || 'ReactCompositeComponent') : _prodInvariant('107', this.getName() || 'ReactCompositeComponent') : void 0;
	      if (false) {
	        this._checkContextTypes(Component.childContextTypes, childContext, 'child context');
	      }
	      for (var name in childContext) {
	        !(name in Component.childContextTypes) ?  false ? invariant(false, '%s.getChildContext(): key "%s" is not defined in childContextTypes.', this.getName() || 'ReactCompositeComponent', name) : _prodInvariant('108', this.getName() || 'ReactCompositeComponent', name) : void 0;
	      }
	      return _assign({}, currentContext, childContext);
	    }
	    return currentContext;
	  },
	
	  /**
	   * Assert that the context types are valid
	   *
	   * @param {object} typeSpecs Map of context field to a ReactPropType
	   * @param {object} values Runtime values that need to be type-checked
	   * @param {string} location e.g. "prop", "context", "child context"
	   * @private
	   */
	  _checkContextTypes: function (typeSpecs, values, location) {
	    if (false) {
	      checkReactTypeSpec(typeSpecs, values, location, this.getName(), null, this._debugID);
	    }
	  },
	
	  receiveComponent: function (nextElement, transaction, nextContext) {
	    var prevElement = this._currentElement;
	    var prevContext = this._context;
	
	    this._pendingElement = null;
	
	    this.updateComponent(transaction, prevElement, nextElement, prevContext, nextContext);
	  },
	
	  /**
	   * If any of `_pendingElement`, `_pendingStateQueue`, or `_pendingForceUpdate`
	   * is set, update the component.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  performUpdateIfNecessary: function (transaction) {
	    if (this._pendingElement != null) {
	      ReactReconciler.receiveComponent(this, this._pendingElement, transaction, this._context);
	    } else if (this._pendingStateQueue !== null || this._pendingForceUpdate) {
	      this.updateComponent(transaction, this._currentElement, this._currentElement, this._context, this._context);
	    } else {
	      this._updateBatchNumber = null;
	    }
	  },
	
	  /**
	   * Perform an update to a mounted component. The componentWillReceiveProps and
	   * shouldComponentUpdate methods are called, then (assuming the update isn't
	   * skipped) the remaining update lifecycle methods are called and the DOM
	   * representation is updated.
	   *
	   * By default, this implements React's rendering and reconciliation algorithm.
	   * Sophisticated clients may wish to override this.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @param {ReactElement} prevParentElement
	   * @param {ReactElement} nextParentElement
	   * @internal
	   * @overridable
	   */
	  updateComponent: function (transaction, prevParentElement, nextParentElement, prevUnmaskedContext, nextUnmaskedContext) {
	    var inst = this._instance;
	    !(inst != null) ?  false ? invariant(false, 'Attempted to update component `%s` that has already been unmounted (or failed to mount).', this.getName() || 'ReactCompositeComponent') : _prodInvariant('136', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    var willReceive = false;
	    var nextContext;
	
	    // Determine if the context has changed or not
	    if (this._context === nextUnmaskedContext) {
	      nextContext = inst.context;
	    } else {
	      nextContext = this._processContext(nextUnmaskedContext);
	      willReceive = true;
	    }
	
	    var prevProps = prevParentElement.props;
	    var nextProps = nextParentElement.props;
	
	    // Not a simple state update but a props update
	    if (prevParentElement !== nextParentElement) {
	      willReceive = true;
	    }
	
	    // An update here will schedule an update but immediately set
	    // _pendingStateQueue which will ensure that any state updates gets
	    // immediately reconciled instead of waiting for the next batch.
	    if (willReceive && inst.componentWillReceiveProps) {
	      if (false) {
	        measureLifeCyclePerf(function () {
	          return inst.componentWillReceiveProps(nextProps, nextContext);
	        }, this._debugID, 'componentWillReceiveProps');
	      } else {
	        inst.componentWillReceiveProps(nextProps, nextContext);
	      }
	    }
	
	    var nextState = this._processPendingState(nextProps, nextContext);
	    var shouldUpdate = true;
	
	    if (!this._pendingForceUpdate) {
	      if (inst.shouldComponentUpdate) {
	        if (false) {
	          shouldUpdate = measureLifeCyclePerf(function () {
	            return inst.shouldComponentUpdate(nextProps, nextState, nextContext);
	          }, this._debugID, 'shouldComponentUpdate');
	        } else {
	          shouldUpdate = inst.shouldComponentUpdate(nextProps, nextState, nextContext);
	        }
	      } else {
	        if (this._compositeType === CompositeTypes.PureClass) {
	          shouldUpdate = !shallowEqual(prevProps, nextProps) || !shallowEqual(inst.state, nextState);
	        }
	      }
	    }
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(shouldUpdate !== undefined, '%s.shouldComponentUpdate(): Returned undefined instead of a ' + 'boolean value. Make sure to return true or false.', this.getName() || 'ReactCompositeComponent') : void 0;
	    }
	
	    this._updateBatchNumber = null;
	    if (shouldUpdate) {
	      this._pendingForceUpdate = false;
	      // Will set `this.props`, `this.state` and `this.context`.
	      this._performComponentUpdate(nextParentElement, nextProps, nextState, nextContext, transaction, nextUnmaskedContext);
	    } else {
	      // If it's determined that a component should not update, we still want
	      // to set props and state but we shortcut the rest of the update.
	      this._currentElement = nextParentElement;
	      this._context = nextUnmaskedContext;
	      inst.props = nextProps;
	      inst.state = nextState;
	      inst.context = nextContext;
	    }
	  },
	
	  _processPendingState: function (props, context) {
	    var inst = this._instance;
	    var queue = this._pendingStateQueue;
	    var replace = this._pendingReplaceState;
	    this._pendingReplaceState = false;
	    this._pendingStateQueue = null;
	
	    if (!queue) {
	      return inst.state;
	    }
	
	    if (replace && queue.length === 1) {
	      return queue[0];
	    }
	
	    var nextState = _assign({}, replace ? queue[0] : inst.state);
	    for (var i = replace ? 1 : 0; i < queue.length; i++) {
	      var partial = queue[i];
	      _assign(nextState, typeof partial === 'function' ? partial.call(inst, nextState, props, context) : partial);
	    }
	
	    return nextState;
	  },
	
	  /**
	   * Merges new props and state, notifies delegate methods of update and
	   * performs update.
	   *
	   * @param {ReactElement} nextElement Next element
	   * @param {object} nextProps Next public object to set as properties.
	   * @param {?object} nextState Next object to set as state.
	   * @param {?object} nextContext Next public object to set as context.
	   * @param {ReactReconcileTransaction} transaction
	   * @param {?object} unmaskedContext
	   * @private
	   */
	  _performComponentUpdate: function (nextElement, nextProps, nextState, nextContext, transaction, unmaskedContext) {
	    var _this2 = this;
	
	    var inst = this._instance;
	
	    var hasComponentDidUpdate = Boolean(inst.componentDidUpdate);
	    var prevProps;
	    var prevState;
	    var prevContext;
	    if (hasComponentDidUpdate) {
	      prevProps = inst.props;
	      prevState = inst.state;
	      prevContext = inst.context;
	    }
	
	    if (inst.componentWillUpdate) {
	      if (false) {
	        measureLifeCyclePerf(function () {
	          return inst.componentWillUpdate(nextProps, nextState, nextContext);
	        }, this._debugID, 'componentWillUpdate');
	      } else {
	        inst.componentWillUpdate(nextProps, nextState, nextContext);
	      }
	    }
	
	    this._currentElement = nextElement;
	    this._context = unmaskedContext;
	    inst.props = nextProps;
	    inst.state = nextState;
	    inst.context = nextContext;
	
	    this._updateRenderedComponent(transaction, unmaskedContext);
	
	    if (hasComponentDidUpdate) {
	      if (false) {
	        transaction.getReactMountReady().enqueue(function () {
	          measureLifeCyclePerf(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), _this2._debugID, 'componentDidUpdate');
	        });
	      } else {
	        transaction.getReactMountReady().enqueue(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), inst);
	      }
	    }
	  },
	
	  /**
	   * Call the component's `render` method and update the DOM accordingly.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  _updateRenderedComponent: function (transaction, context) {
	    var prevComponentInstance = this._renderedComponent;
	    var prevRenderedElement = prevComponentInstance._currentElement;
	    var nextRenderedElement = this._renderValidatedComponent();
	
	    var debugID = 0;
	    if (false) {
	      debugID = this._debugID;
	    }
	
	    if (shouldUpdateReactComponent(prevRenderedElement, nextRenderedElement)) {
	      ReactReconciler.receiveComponent(prevComponentInstance, nextRenderedElement, transaction, this._processChildContext(context));
	    } else {
	      var oldHostNode = ReactReconciler.getHostNode(prevComponentInstance);
	      ReactReconciler.unmountComponent(prevComponentInstance, false);
	
	      var nodeType = ReactNodeTypes.getType(nextRenderedElement);
	      this._renderedNodeType = nodeType;
	      var child = this._instantiateReactComponent(nextRenderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
	      );
	      this._renderedComponent = child;
	
	      var nextMarkup = ReactReconciler.mountComponent(child, transaction, this._hostParent, this._hostContainerInfo, this._processChildContext(context), debugID);
	
	      if (false) {
	        if (debugID !== 0) {
	          var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
	          ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
	        }
	      }
	
	      this._replaceNodeWithMarkup(oldHostNode, nextMarkup, prevComponentInstance);
	    }
	  },
	
	  /**
	   * Overridden in shallow rendering.
	   *
	   * @protected
	   */
	  _replaceNodeWithMarkup: function (oldHostNode, nextMarkup, prevInstance) {
	    ReactComponentEnvironment.replaceNodeWithMarkup(oldHostNode, nextMarkup, prevInstance);
	  },
	
	  /**
	   * @protected
	   */
	  _renderValidatedComponentWithoutOwnerOrContext: function () {
	    var inst = this._instance;
	    var renderedElement;
	
	    if (false) {
	      renderedElement = measureLifeCyclePerf(function () {
	        return inst.render();
	      }, this._debugID, 'render');
	    } else {
	      renderedElement = inst.render();
	    }
	
	    if (false) {
	      // We allow auto-mocks to proceed as if they're returning null.
	      if (renderedElement === undefined && inst.render._isMockFunction) {
	        // This is probably bad practice. Consider warning here and
	        // deprecating this convenience.
	        renderedElement = null;
	      }
	    }
	
	    return renderedElement;
	  },
	
	  /**
	   * @private
	   */
	  _renderValidatedComponent: function () {
	    var renderedElement;
	    if (("production") !== 'production' || this._compositeType !== CompositeTypes.StatelessFunctional) {
	      ReactCurrentOwner.current = this;
	      try {
	        renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
	      } finally {
	        ReactCurrentOwner.current = null;
	      }
	    } else {
	      renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
	    }
	    !(
	    // TODO: An `isValidNode` function would probably be more appropriate
	    renderedElement === null || renderedElement === false || React.isValidElement(renderedElement)) ?  false ? invariant(false, '%s.render(): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', this.getName() || 'ReactCompositeComponent') : _prodInvariant('109', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    return renderedElement;
	  },
	
	  /**
	   * Lazily allocates the refs object and stores `component` as `ref`.
	   *
	   * @param {string} ref Reference name.
	   * @param {component} component Component to store as `ref`.
	   * @final
	   * @private
	   */
	  attachRef: function (ref, component) {
	    var inst = this.getPublicInstance();
	    !(inst != null) ?  false ? invariant(false, 'Stateless function components cannot have refs.') : _prodInvariant('110') : void 0;
	    var publicComponentInstance = component.getPublicInstance();
	    if (false) {
	      var componentName = component && component.getName ? component.getName() : 'a component';
	      process.env.NODE_ENV !== 'production' ? warning(publicComponentInstance != null || component._compositeType !== CompositeTypes.StatelessFunctional, 'Stateless function components cannot be given refs ' + '(See ref "%s" in %s created by %s). ' + 'Attempts to access this ref will fail.', ref, componentName, this.getName()) : void 0;
	    }
	    var refs = inst.refs === emptyObject ? inst.refs = {} : inst.refs;
	    refs[ref] = publicComponentInstance;
	  },
	
	  /**
	   * Detaches a reference name.
	   *
	   * @param {string} ref Name to dereference.
	   * @final
	   * @private
	   */
	  detachRef: function (ref) {
	    var refs = this.getPublicInstance().refs;
	    delete refs[ref];
	  },
	
	  /**
	   * Get a text description of the component that can be used to identify it
	   * in error messages.
	   * @return {string} The name or null.
	   * @internal
	   */
	  getName: function () {
	    var type = this._currentElement.type;
	    var constructor = this._instance && this._instance.constructor;
	    return type.displayName || constructor && constructor.displayName || type.name || constructor && constructor.name || null;
	  },
	
	  /**
	   * Get the publicly accessible representation of this component - i.e. what
	   * is exposed by refs and returned by render. Can be null for stateless
	   * components.
	   *
	   * @return {ReactComponent} the public component instance.
	   * @internal
	   */
	  getPublicInstance: function () {
	    var inst = this._instance;
	    if (this._compositeType === CompositeTypes.StatelessFunctional) {
	      return null;
	    }
	    return inst;
	  },
	
	  // Stub
	  _instantiateReactComponent: null
	
	};
	
	module.exports = ReactCompositeComponent;

/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(335);
	
	var React = __webpack_require__(301);
	
	var invariant = __webpack_require__(337);
	
	var ReactNodeTypes = {
	  HOST: 0,
	  COMPOSITE: 1,
	  EMPTY: 2,
	
	  getType: function (node) {
	    if (node === null || node === false) {
	      return ReactNodeTypes.EMPTY;
	    } else if (React.isValidElement(node)) {
	      if (typeof node.type === 'function') {
	        return ReactNodeTypes.COMPOSITE;
	      } else {
	        return ReactNodeTypes.HOST;
	      }
	    }
	     true ?  false ? invariant(false, 'Unexpected node: %s', node) : _prodInvariant('26', node) : void 0;
	  }
	};
	
	module.exports = ReactNodeTypes;

/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var emptyObject = {};
	
	if (false) {
	  Object.freeze(emptyObject);
	}
	
	module.exports = emptyObject;

/***/ }),
/* 424 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 * 
	 */
	
	/*eslint-disable no-self-compare */
	
	'use strict';
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	/**
	 * inlined Object.is polyfill to avoid requiring consumers ship their own
	 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	 */
	function is(x, y) {
	  // SameValue algorithm
	  if (x === y) {
	    // Steps 1-5, 7-10
	    // Steps 6.b-6.e: +0 != -0
	    // Added the nonzero y check to make Flow happy, but it is redundant
	    return x !== 0 || y !== 0 || 1 / x === 1 / y;
	  } else {
	    // Step 6.a: NaN == NaN
	    return x !== x && y !== y;
	  }
	}
	
	/**
	 * Performs equality by iterating through keys on an object and returning false
	 * when any key has values which are not strictly equal between the arguments.
	 * Returns true when the values of all keys are strictly equal.
	 */
	function shallowEqual(objA, objB) {
	  if (is(objA, objB)) {
	    return true;
	  }
	
	  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  // Test for A's keys different from B.
	  for (var i = 0; i < keysA.length; i++) {
	    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	module.exports = shallowEqual;

/***/ }),
/* 425 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Given a `prevElement` and `nextElement`, determines if the existing
	 * instance should be updated as opposed to being destroyed or replaced by a new
	 * instance. Both arguments are elements. This ensures that this logic can
	 * operate on stateless trees without any backing instance.
	 *
	 * @param {?object} prevElement
	 * @param {?object} nextElement
	 * @return {boolean} True if the existing instance should be updated.
	 * @protected
	 */
	
	function shouldUpdateReactComponent(prevElement, nextElement) {
	  var prevEmpty = prevElement === null || prevElement === false;
	  var nextEmpty = nextElement === null || nextElement === false;
	  if (prevEmpty || nextEmpty) {
	    return prevEmpty === nextEmpty;
	  }
	
	  var prevType = typeof prevElement;
	  var nextType = typeof nextElement;
	  if (prevType === 'string' || prevType === 'number') {
	    return nextType === 'string' || nextType === 'number';
	  } else {
	    return nextType === 'object' && prevElement.type === nextElement.type && prevElement.key === nextElement.key;
	  }
	}
	
	module.exports = shouldUpdateReactComponent;

/***/ }),
/* 426 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var emptyComponentFactory;
	
	var ReactEmptyComponentInjection = {
	  injectEmptyComponentFactory: function (factory) {
	    emptyComponentFactory = factory;
	  }
	};
	
	var ReactEmptyComponent = {
	  create: function (instantiate) {
	    return emptyComponentFactory(instantiate);
	  }
	};
	
	ReactEmptyComponent.injection = ReactEmptyComponentInjection;
	
	module.exports = ReactEmptyComponent;

/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(335);
	
	var invariant = __webpack_require__(337);
	
	var genericComponentClass = null;
	var textComponentClass = null;
	
	var ReactHostComponentInjection = {
	  // This accepts a class that receives the tag string. This is a catch all
	  // that can render any kind of tag.
	  injectGenericComponentClass: function (componentClass) {
	    genericComponentClass = componentClass;
	  },
	  // This accepts a text component class that takes the text string to be
	  // rendered as props.
	  injectTextComponentClass: function (componentClass) {
	    textComponentClass = componentClass;
	  }
	};
	
	/**
	 * Get a host internal component class for a specific tag.
	 *
	 * @param {ReactElement} element The element to create.
	 * @return {function} The internal class constructor function.
	 */
	function createInternalComponent(element) {
	  !genericComponentClass ?  false ? invariant(false, 'There is no registered component for the tag %s', element.type) : _prodInvariant('111', element.type) : void 0;
	  return new genericComponentClass(element);
	}
	
	/**
	 * @param {ReactText} text
	 * @return {ReactComponent}
	 */
	function createInstanceForText(text) {
	  return new textComponentClass(text);
	}
	
	/**
	 * @param {ReactComponent} component
	 * @return {boolean}
	 */
	function isTextComponent(component) {
	  return component instanceof textComponentClass;
	}
	
	var ReactHostComponent = {
	  createInternalComponent: createInternalComponent,
	  createInstanceForText: createInstanceForText,
	  isTextComponent: isTextComponent,
	  injection: ReactHostComponentInjection
	};
	
	module.exports = ReactHostComponent;

/***/ }),
/* 428 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var nextDebugID = 1;
	
	function getNextDebugID() {
	  return nextDebugID++;
	}
	
	module.exports = getNextDebugID;

/***/ }),
/* 429 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * Escape and wrap key so it is safe to use as a reactid
	 *
	 * @param {string} key to be escaped.
	 * @return {string} the escaped key.
	 */
	
	function escape(key) {
	  var escapeRegex = /[=:]/g;
	  var escaperLookup = {
	    '=': '=0',
	    ':': '=2'
	  };
	  var escapedString = ('' + key).replace(escapeRegex, function (match) {
	    return escaperLookup[match];
	  });
	
	  return '$' + escapedString;
	}
	
	/**
	 * Unescape and unwrap key for human-readable display
	 *
	 * @param {string} key to unescape.
	 * @return {string} the unescaped key.
	 */
	function unescape(key) {
	  var unescapeRegex = /(=0|=2)/g;
	  var unescaperLookup = {
	    '=0': '=',
	    '=2': ':'
	  };
	  var keySubstring = key[0] === '.' && key[1] === '$' ? key.substring(2) : key.substring(1);
	
	  return ('' + keySubstring).replace(unescapeRegex, function (match) {
	    return unescaperLookup[match];
	  });
	}
	
	var KeyEscapeUtils = {
	  escape: escape,
	  unescape: unescape
	};
	
	module.exports = KeyEscapeUtils;

/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(335);
	
	var ReactCurrentOwner = __webpack_require__(308);
	var REACT_ELEMENT_TYPE = __webpack_require__(431);
	
	var getIteratorFn = __webpack_require__(432);
	var invariant = __webpack_require__(337);
	var KeyEscapeUtils = __webpack_require__(429);
	var warning = __webpack_require__(347);
	
	var SEPARATOR = '.';
	var SUBSEPARATOR = ':';
	
	/**
	 * This is inlined from ReactElement since this file is shared between
	 * isomorphic and renderers. We could extract this to a
	 *
	 */
	
	/**
	 * TODO: Test that a single child and an array with one item have the same key
	 * pattern.
	 */
	
	var didWarnAboutMaps = false;
	
	/**
	 * Generate a key string that identifies a component within a set.
	 *
	 * @param {*} component A component that could contain a manual key.
	 * @param {number} index Index that is used if a manual key is not provided.
	 * @return {string}
	 */
	function getComponentKey(component, index) {
	  // Do some typechecking here since we call this blindly. We want to ensure
	  // that we don't block potential future ES APIs.
	  if (component && typeof component === 'object' && component.key != null) {
	    // Explicit key
	    return KeyEscapeUtils.escape(component.key);
	  }
	  // Implicit key determined by the index in the set
	  return index.toString(36);
	}
	
	/**
	 * @param {?*} children Children tree container.
	 * @param {!string} nameSoFar Name of the key path so far.
	 * @param {!function} callback Callback to invoke with each child found.
	 * @param {?*} traverseContext Used to pass information throughout the traversal
	 * process.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
	  var type = typeof children;
	
	  if (type === 'undefined' || type === 'boolean') {
	    // All of the above are perceived as null.
	    children = null;
	  }
	
	  if (children === null || type === 'string' || type === 'number' ||
	  // The following is inlined from ReactElement. This means we can optimize
	  // some checks. React Fiber also inlines this logic for similar purposes.
	  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
	    callback(traverseContext, children,
	    // If it's the only child, treat the name as if it was wrapped in an array
	    // so that it's consistent if the number of children grows.
	    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
	    return 1;
	  }
	
	  var child;
	  var nextName;
	  var subtreeCount = 0; // Count of children found in the current subtree.
	  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;
	
	  if (Array.isArray(children)) {
	    for (var i = 0; i < children.length; i++) {
	      child = children[i];
	      nextName = nextNamePrefix + getComponentKey(child, i);
	      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	    }
	  } else {
	    var iteratorFn = getIteratorFn(children);
	    if (iteratorFn) {
	      var iterator = iteratorFn.call(children);
	      var step;
	      if (iteratorFn !== children.entries) {
	        var ii = 0;
	        while (!(step = iterator.next()).done) {
	          child = step.value;
	          nextName = nextNamePrefix + getComponentKey(child, ii++);
	          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	        }
	      } else {
	        if (false) {
	          var mapsAsChildrenAddendum = '';
	          if (ReactCurrentOwner.current) {
	            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
	            if (mapsAsChildrenOwnerName) {
	              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
	            }
	          }
	          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
	          didWarnAboutMaps = true;
	        }
	        // Iterator will provide entry [k,v] tuples rather than values.
	        while (!(step = iterator.next()).done) {
	          var entry = step.value;
	          if (entry) {
	            child = entry[1];
	            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
	            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	          }
	        }
	      }
	    } else if (type === 'object') {
	      var addendum = '';
	      if (false) {
	        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
	        if (children._isReactElement) {
	          addendum = ' It looks like you\'re using an element created by a different ' + 'version of React. Make sure to use only one copy of React.';
	        }
	        if (ReactCurrentOwner.current) {
	          var name = ReactCurrentOwner.current.getName();
	          if (name) {
	            addendum += ' Check the render method of `' + name + '`.';
	          }
	        }
	      }
	      var childrenString = String(children);
	       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
	    }
	  }
	
	  return subtreeCount;
	}
	
	/**
	 * Traverses children that are typically specified as `props.children`, but
	 * might also be specified through attributes:
	 *
	 * - `traverseAllChildren(this.props.children, ...)`
	 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
	 *
	 * The `traverseContext` is an optional argument that is passed through the
	 * entire traversal. It can be used to store accumulations or anything else that
	 * the callback might find relevant.
	 *
	 * @param {?*} children Children tree object.
	 * @param {!function} callback To invoke upon traversing each child.
	 * @param {?*} traverseContext Context for traversal.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildren(children, callback, traverseContext) {
	  if (children == null) {
	    return 0;
	  }
	
	  return traverseAllChildrenImpl(children, '', callback, traverseContext);
	}
	
	module.exports = traverseAllChildren;

/***/ }),
/* 431 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	// The Symbol used to tag the ReactElement type. If there is no native Symbol
	// nor polyfill, then a plain number is used for performance.
	
	var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;
	
	module.exports = REACT_ELEMENT_TYPE;

/***/ }),
/* 432 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	/* global Symbol */
	
	var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	/**
	 * Returns the iterator method function contained on the iterable object.
	 *
	 * Be sure to invoke the function with the iterable as context:
	 *
	 *     var iteratorFn = getIteratorFn(myIterable);
	 *     if (iteratorFn) {
	 *       var iterator = iteratorFn.call(myIterable);
	 *       ...
	 *     }
	 *
	 * @param {?object} maybeIterable
	 * @return {?function}
	 */
	function getIteratorFn(maybeIterable) {
	  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	  if (typeof iteratorFn === 'function') {
	    return iteratorFn;
	  }
	}
	
	module.exports = getIteratorFn;

/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2016-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(305);
	
	var ReactCurrentOwner = __webpack_require__(308);
	
	var invariant = __webpack_require__(306);
	var warning = __webpack_require__(309);
	
	function isNative(fn) {
	  // Based on isNative() from Lodash
	  var funcToString = Function.prototype.toString;
	  var hasOwnProperty = Object.prototype.hasOwnProperty;
	  var reIsNative = RegExp('^' + funcToString
	  // Take an example native function source for comparison
	  .call(hasOwnProperty)
	  // Strip regex characters so we can use it for regex
	  .replace(/[\\^$.*+?()[\]{}|]/g, '\\$&')
	  // Remove hasOwnProperty from the template to make it generic
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
	  try {
	    var source = funcToString.call(fn);
	    return reIsNative.test(source);
	  } catch (err) {
	    return false;
	  }
	}
	
	var canUseCollections =
	// Array.from
	typeof Array.from === 'function' &&
	// Map
	typeof Map === 'function' && isNative(Map) &&
	// Map.prototype.keys
	Map.prototype != null && typeof Map.prototype.keys === 'function' && isNative(Map.prototype.keys) &&
	// Set
	typeof Set === 'function' && isNative(Set) &&
	// Set.prototype.keys
	Set.prototype != null && typeof Set.prototype.keys === 'function' && isNative(Set.prototype.keys);
	
	var setItem;
	var getItem;
	var removeItem;
	var getItemIDs;
	var addRoot;
	var removeRoot;
	var getRootIDs;
	
	if (canUseCollections) {
	  var itemMap = new Map();
	  var rootIDSet = new Set();
	
	  setItem = function (id, item) {
	    itemMap.set(id, item);
	  };
	  getItem = function (id) {
	    return itemMap.get(id);
	  };
	  removeItem = function (id) {
	    itemMap['delete'](id);
	  };
	  getItemIDs = function () {
	    return Array.from(itemMap.keys());
	  };
	
	  addRoot = function (id) {
	    rootIDSet.add(id);
	  };
	  removeRoot = function (id) {
	    rootIDSet['delete'](id);
	  };
	  getRootIDs = function () {
	    return Array.from(rootIDSet.keys());
	  };
	} else {
	  var itemByKey = {};
	  var rootByKey = {};
	
	  // Use non-numeric keys to prevent V8 performance issues:
	  // https://github.com/facebook/react/pull/7232
	  var getKeyFromID = function (id) {
	    return '.' + id;
	  };
	  var getIDFromKey = function (key) {
	    return parseInt(key.substr(1), 10);
	  };
	
	  setItem = function (id, item) {
	    var key = getKeyFromID(id);
	    itemByKey[key] = item;
	  };
	  getItem = function (id) {
	    var key = getKeyFromID(id);
	    return itemByKey[key];
	  };
	  removeItem = function (id) {
	    var key = getKeyFromID(id);
	    delete itemByKey[key];
	  };
	  getItemIDs = function () {
	    return Object.keys(itemByKey).map(getIDFromKey);
	  };
	
	  addRoot = function (id) {
	    var key = getKeyFromID(id);
	    rootByKey[key] = true;
	  };
	  removeRoot = function (id) {
	    var key = getKeyFromID(id);
	    delete rootByKey[key];
	  };
	  getRootIDs = function () {
	    return Object.keys(rootByKey).map(getIDFromKey);
	  };
	}
	
	var unmountedIDs = [];
	
	function purgeDeep(id) {
	  var item = getItem(id);
	  if (item) {
	    var childIDs = item.childIDs;
	
	    removeItem(id);
	    childIDs.forEach(purgeDeep);
	  }
	}
	
	function describeComponentFrame(name, source, ownerName) {
	  return '\n    in ' + (name || 'Unknown') + (source ? ' (at ' + source.fileName.replace(/^.*[\\\/]/, '') + ':' + source.lineNumber + ')' : ownerName ? ' (created by ' + ownerName + ')' : '');
	}
	
	function getDisplayName(element) {
	  if (element == null) {
	    return '#empty';
	  } else if (typeof element === 'string' || typeof element === 'number') {
	    return '#text';
	  } else if (typeof element.type === 'string') {
	    return element.type;
	  } else {
	    return element.type.displayName || element.type.name || 'Unknown';
	  }
	}
	
	function describeID(id) {
	  var name = ReactComponentTreeHook.getDisplayName(id);
	  var element = ReactComponentTreeHook.getElement(id);
	  var ownerID = ReactComponentTreeHook.getOwnerID(id);
	  var ownerName;
	  if (ownerID) {
	    ownerName = ReactComponentTreeHook.getDisplayName(ownerID);
	  }
	   false ? warning(element, 'ReactComponentTreeHook: Missing React element for debugID %s when ' + 'building stack', id) : void 0;
	  return describeComponentFrame(name, element && element._source, ownerName);
	}
	
	var ReactComponentTreeHook = {
	  onSetChildren: function (id, nextChildIDs) {
	    var item = getItem(id);
	    !item ?  false ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
	    item.childIDs = nextChildIDs;
	
	    for (var i = 0; i < nextChildIDs.length; i++) {
	      var nextChildID = nextChildIDs[i];
	      var nextChild = getItem(nextChildID);
	      !nextChild ?  false ? invariant(false, 'Expected hook events to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('140') : void 0;
	      !(nextChild.childIDs != null || typeof nextChild.element !== 'object' || nextChild.element == null) ?  false ? invariant(false, 'Expected onSetChildren() to fire for a container child before its parent includes it in onSetChildren().') : _prodInvariant('141') : void 0;
	      !nextChild.isMounted ?  false ? invariant(false, 'Expected onMountComponent() to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('71') : void 0;
	      if (nextChild.parentID == null) {
	        nextChild.parentID = id;
	        // TODO: This shouldn't be necessary but mounting a new root during in
	        // componentWillMount currently causes not-yet-mounted components to
	        // be purged from our tree data so their parent id is missing.
	      }
	      !(nextChild.parentID === id) ?  false ? invariant(false, 'Expected onBeforeMountComponent() parent and onSetChildren() to be consistent (%s has parents %s and %s).', nextChildID, nextChild.parentID, id) : _prodInvariant('142', nextChildID, nextChild.parentID, id) : void 0;
	    }
	  },
	  onBeforeMountComponent: function (id, element, parentID) {
	    var item = {
	      element: element,
	      parentID: parentID,
	      text: null,
	      childIDs: [],
	      isMounted: false,
	      updateCount: 0
	    };
	    setItem(id, item);
	  },
	  onBeforeUpdateComponent: function (id, element) {
	    var item = getItem(id);
	    if (!item || !item.isMounted) {
	      // We may end up here as a result of setState() in componentWillUnmount().
	      // In this case, ignore the element.
	      return;
	    }
	    item.element = element;
	  },
	  onMountComponent: function (id) {
	    var item = getItem(id);
	    !item ?  false ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
	    item.isMounted = true;
	    var isRoot = item.parentID === 0;
	    if (isRoot) {
	      addRoot(id);
	    }
	  },
	  onUpdateComponent: function (id) {
	    var item = getItem(id);
	    if (!item || !item.isMounted) {
	      // We may end up here as a result of setState() in componentWillUnmount().
	      // In this case, ignore the element.
	      return;
	    }
	    item.updateCount++;
	  },
	  onUnmountComponent: function (id) {
	    var item = getItem(id);
	    if (item) {
	      // We need to check if it exists.
	      // `item` might not exist if it is inside an error boundary, and a sibling
	      // error boundary child threw while mounting. Then this instance never
	      // got a chance to mount, but it still gets an unmounting event during
	      // the error boundary cleanup.
	      item.isMounted = false;
	      var isRoot = item.parentID === 0;
	      if (isRoot) {
	        removeRoot(id);
	      }
	    }
	    unmountedIDs.push(id);
	  },
	  purgeUnmountedComponents: function () {
	    if (ReactComponentTreeHook._preventPurging) {
	      // Should only be used for testing.
	      return;
	    }
	
	    for (var i = 0; i < unmountedIDs.length; i++) {
	      var id = unmountedIDs[i];
	      purgeDeep(id);
	    }
	    unmountedIDs.length = 0;
	  },
	  isMounted: function (id) {
	    var item = getItem(id);
	    return item ? item.isMounted : false;
	  },
	  getCurrentStackAddendum: function (topElement) {
	    var info = '';
	    if (topElement) {
	      var name = getDisplayName(topElement);
	      var owner = topElement._owner;
	      info += describeComponentFrame(name, topElement._source, owner && owner.getName());
	    }
	
	    var currentOwner = ReactCurrentOwner.current;
	    var id = currentOwner && currentOwner._debugID;
	
	    info += ReactComponentTreeHook.getStackAddendumByID(id);
	    return info;
	  },
	  getStackAddendumByID: function (id) {
	    var info = '';
	    while (id) {
	      info += describeID(id);
	      id = ReactComponentTreeHook.getParentID(id);
	    }
	    return info;
	  },
	  getChildIDs: function (id) {
	    var item = getItem(id);
	    return item ? item.childIDs : [];
	  },
	  getDisplayName: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (!element) {
	      return null;
	    }
	    return getDisplayName(element);
	  },
	  getElement: function (id) {
	    var item = getItem(id);
	    return item ? item.element : null;
	  },
	  getOwnerID: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (!element || !element._owner) {
	      return null;
	    }
	    return element._owner._debugID;
	  },
	  getParentID: function (id) {
	    var item = getItem(id);
	    return item ? item.parentID : null;
	  },
	  getSource: function (id) {
	    var item = getItem(id);
	    var element = item ? item.element : null;
	    var source = element != null ? element._source : null;
	    return source;
	  },
	  getText: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (typeof element === 'string') {
	      return element;
	    } else if (typeof element === 'number') {
	      return '' + element;
	    } else {
	      return null;
	    }
	  },
	  getUpdateCount: function (id) {
	    var item = getItem(id);
	    return item ? item.updateCount : 0;
	  },
	
	
	  getRootIDs: getRootIDs,
	  getRegisteredIDs: getItemIDs
	};
	
	module.exports = ReactComponentTreeHook;

/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var KeyEscapeUtils = __webpack_require__(429);
	var traverseAllChildren = __webpack_require__(430);
	var warning = __webpack_require__(347);
	
	var ReactComponentTreeHook;
	
	if (typeof process !== 'undefined' && process.env && ("production") === 'test') {
	  // Temporary hack.
	  // Inline requires don't work well with Jest:
	  // https://github.com/facebook/react/issues/7240
	  // Remove the inline requires when we don't need them anymore:
	  // https://github.com/facebook/react/pull/7178
	  ReactComponentTreeHook = __webpack_require__(433);
	}
	
	/**
	 * @param {function} traverseContext Context passed through traversal.
	 * @param {?ReactComponent} child React child component.
	 * @param {!string} name String name of key path to child.
	 * @param {number=} selfDebugID Optional debugID of the current internal instance.
	 */
	function flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID) {
	  // We found a component instance.
	  if (traverseContext && typeof traverseContext === 'object') {
	    var result = traverseContext;
	    var keyUnique = result[name] === undefined;
	    if (false) {
	      if (!ReactComponentTreeHook) {
	        ReactComponentTreeHook = require('react/lib/ReactComponentTreeHook');
	      }
	      if (!keyUnique) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
	      }
	    }
	    if (keyUnique && child != null) {
	      result[name] = child;
	    }
	  }
	}
	
	/**
	 * Flattens children that are typically specified as `props.children`. Any null
	 * children will not be included in the resulting object.
	 * @return {!object} flattened children keyed by name.
	 */
	function flattenChildren(children, selfDebugID) {
	  if (children == null) {
	    return children;
	  }
	  var result = {};
	
	  if (false) {
	    traverseAllChildren(children, function (traverseContext, child, name) {
	      return flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID);
	    }, result);
	  } else {
	    traverseAllChildren(children, flattenSingleChildIntoContext, result);
	  }
	  return result;
	}
	
	module.exports = flattenChildren;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(294)))

/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(302);
	
	var PooledClass = __webpack_require__(353);
	var Transaction = __webpack_require__(366);
	var ReactInstrumentation = __webpack_require__(365);
	var ReactServerUpdateQueue = __webpack_require__(436);
	
	/**
	 * Executed within the scope of the `Transaction` instance. Consider these as
	 * being member methods, but with an implied ordering while being isolated from
	 * each other.
	 */
	var TRANSACTION_WRAPPERS = [];
	
	if (false) {
	  TRANSACTION_WRAPPERS.push({
	    initialize: ReactInstrumentation.debugTool.onBeginFlush,
	    close: ReactInstrumentation.debugTool.onEndFlush
	  });
	}
	
	var noopCallbackQueue = {
	  enqueue: function () {}
	};
	
	/**
	 * @class ReactServerRenderingTransaction
	 * @param {boolean} renderToStaticMarkup
	 */
	function ReactServerRenderingTransaction(renderToStaticMarkup) {
	  this.reinitializeTransaction();
	  this.renderToStaticMarkup = renderToStaticMarkup;
	  this.useCreateElement = false;
	  this.updateQueue = new ReactServerUpdateQueue(this);
	}
	
	var Mixin = {
	  /**
	   * @see Transaction
	   * @abstract
	   * @final
	   * @return {array} Empty list of operation wrap procedures.
	   */
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  /**
	   * @return {object} The queue to collect `onDOMReady` callbacks with.
	   */
	  getReactMountReady: function () {
	    return noopCallbackQueue;
	  },
	
	  /**
	   * @return {object} The queue to collect React async events.
	   */
	  getUpdateQueue: function () {
	    return this.updateQueue;
	  },
	
	  /**
	   * `PooledClass` looks for this, and will invoke this before allowing this
	   * instance to be reused.
	   */
	  destructor: function () {},
	
	  checkpoint: function () {},
	
	  rollback: function () {}
	};
	
	_assign(ReactServerRenderingTransaction.prototype, Transaction, Mixin);
	
	PooledClass.addPoolingTo(ReactServerRenderingTransaction);
	
	module.exports = ReactServerRenderingTransaction;

/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ReactUpdateQueue = __webpack_require__(437);
	
	var warning = __webpack_require__(347);
	
	function warnNoop(publicInstance, callerName) {
	  if (false) {
	    var constructor = publicInstance.constructor;
	    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounting component. ' + 'This usually means you called %s() outside componentWillMount() on the server. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
	  }
	}
	
	/**
	 * This is the update queue used for server rendering.
	 * It delegates to ReactUpdateQueue while server rendering is in progress and
	 * switches to ReactNoopUpdateQueue after the transaction has completed.
	 * @class ReactServerUpdateQueue
	 * @param {Transaction} transaction
	 */
	
	var ReactServerUpdateQueue = function () {
	  function ReactServerUpdateQueue(transaction) {
	    _classCallCheck(this, ReactServerUpdateQueue);
	
	    this.transaction = transaction;
	  }
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	
	
	  ReactServerUpdateQueue.prototype.isMounted = function isMounted(publicInstance) {
	    return false;
	  };
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueCallback = function enqueueCallback(publicInstance, callback, callerName) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueCallback(publicInstance, callback, callerName);
	    }
	  };
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueForceUpdate = function enqueueForceUpdate(publicInstance) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueForceUpdate(publicInstance);
	    } else {
	      warnNoop(publicInstance, 'forceUpdate');
	    }
	  };
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object|function} completeState Next state.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueReplaceState = function enqueueReplaceState(publicInstance, completeState) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueReplaceState(publicInstance, completeState);
	    } else {
	      warnNoop(publicInstance, 'replaceState');
	    }
	  };
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object|function} partialState Next partial state to be merged with state.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueSetState = function enqueueSetState(publicInstance, partialState) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueSetState(publicInstance, partialState);
	    } else {
	      warnNoop(publicInstance, 'setState');
	    }
	  };
	
	  return ReactServerUpdateQueue;
	}();
	
	module.exports = ReactServerUpdateQueue;

/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(335);
	
	var ReactCurrentOwner = __webpack_require__(308);
	var ReactInstanceMap = __webpack_require__(418);
	var ReactInstrumentation = __webpack_require__(365);
	var ReactUpdates = __webpack_require__(359);
	
	var invariant = __webpack_require__(337);
	var warning = __webpack_require__(347);
	
	function enqueueUpdate(internalInstance) {
	  ReactUpdates.enqueueUpdate(internalInstance);
	}
	
	function formatUnexpectedArgument(arg) {
	  var type = typeof arg;
	  if (type !== 'object') {
	    return type;
	  }
	  var displayName = arg.constructor && arg.constructor.name || type;
	  var keys = Object.keys(arg);
	  if (keys.length > 0 && keys.length < 20) {
	    return displayName + ' (keys: ' + keys.join(', ') + ')';
	  }
	  return displayName;
	}
	
	function getInternalInstanceReadyForUpdate(publicInstance, callerName) {
	  var internalInstance = ReactInstanceMap.get(publicInstance);
	  if (!internalInstance) {
	    if (false) {
	      var ctor = publicInstance.constructor;
	      // Only warn when we have a callerName. Otherwise we should be silent.
	      // We're probably calling from enqueueCallback. We don't want to warn
	      // there because we already warned for the corresponding lifecycle method.
	      process.env.NODE_ENV !== 'production' ? warning(!callerName, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, ctor && (ctor.displayName || ctor.name) || 'ReactClass') : void 0;
	    }
	    return null;
	  }
	
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(ReactCurrentOwner.current == null, '%s(...): Cannot update during an existing state transition (such as ' + 'within `render` or another component\'s constructor). Render methods ' + 'should be a pure function of props and state; constructor ' + 'side-effects are an anti-pattern, but can be moved to ' + '`componentWillMount`.', callerName) : void 0;
	  }
	
	  return internalInstance;
	}
	
	/**
	 * ReactUpdateQueue allows for state updates to be scheduled into a later
	 * reconciliation step.
	 */
	var ReactUpdateQueue = {
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function (publicInstance) {
	    if (false) {
	      var owner = ReactCurrentOwner.current;
	      if (owner !== null) {
	        process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing isMounted inside its render() function. ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
	        owner._warnedAboutRefsInRender = true;
	      }
	    }
	    var internalInstance = ReactInstanceMap.get(publicInstance);
	    if (internalInstance) {
	      // During componentWillMount and render this will still be null but after
	      // that will always render to something. At least for now. So we can use
	      // this hack.
	      return !!internalInstance._renderedComponent;
	    } else {
	      return false;
	    }
	  },
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @param {string} callerName Name of the calling function in the public API.
	   * @internal
	   */
	  enqueueCallback: function (publicInstance, callback, callerName) {
	    ReactUpdateQueue.validateCallback(callback, callerName);
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance);
	
	    // Previously we would throw an error if we didn't have an internal
	    // instance. Since we want to make it a no-op instead, we mirror the same
	    // behavior we have in other enqueue* methods.
	    // We also need to ignore callbacks in componentWillMount. See
	    // enqueueUpdates.
	    if (!internalInstance) {
	      return null;
	    }
	
	    if (internalInstance._pendingCallbacks) {
	      internalInstance._pendingCallbacks.push(callback);
	    } else {
	      internalInstance._pendingCallbacks = [callback];
	    }
	    // TODO: The callback here is ignored when setState is called from
	    // componentWillMount. Either fix it or disallow doing so completely in
	    // favor of getInitialState. Alternatively, we can disallow
	    // componentWillMount during server-side rendering.
	    enqueueUpdate(internalInstance);
	  },
	
	  enqueueCallbackInternal: function (internalInstance, callback) {
	    if (internalInstance._pendingCallbacks) {
	      internalInstance._pendingCallbacks.push(callback);
	    } else {
	      internalInstance._pendingCallbacks = [callback];
	    }
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	  enqueueForceUpdate: function (publicInstance) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'forceUpdate');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    internalInstance._pendingForceUpdate = true;
	
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} completeState Next state.
	   * @internal
	   */
	  enqueueReplaceState: function (publicInstance, completeState, callback) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'replaceState');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    internalInstance._pendingStateQueue = [completeState];
	    internalInstance._pendingReplaceState = true;
	
	    // Future-proof 15.5
	    if (callback !== undefined && callback !== null) {
	      ReactUpdateQueue.validateCallback(callback, 'replaceState');
	      if (internalInstance._pendingCallbacks) {
	        internalInstance._pendingCallbacks.push(callback);
	      } else {
	        internalInstance._pendingCallbacks = [callback];
	      }
	    }
	
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialState Next partial state to be merged with state.
	   * @internal
	   */
	  enqueueSetState: function (publicInstance, partialState) {
	    if (false) {
	      ReactInstrumentation.debugTool.onSetState();
	      process.env.NODE_ENV !== 'production' ? warning(partialState != null, 'setState(...): You passed an undefined or null state object; ' + 'instead, use forceUpdate().') : void 0;
	    }
	
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'setState');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    var queue = internalInstance._pendingStateQueue || (internalInstance._pendingStateQueue = []);
	    queue.push(partialState);
	
	    enqueueUpdate(internalInstance);
	  },
	
	  enqueueElementInternal: function (internalInstance, nextElement, nextContext) {
	    internalInstance._pendingElement = nextElement;
	    // TODO: introduce _pendingContext instead of setting it directly.
	    internalInstance._context = nextContext;
	    enqueueUpdate(internalInstance);
	  },
	
	  validateCallback: function (callback, callerName) {
	    !(!callback || typeof callback === 'function') ?  false ? invariant(false, '%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.', callerName, formatUnexpectedArgument(callback)) : _prodInvariant('122', callerName, formatUnexpectedArgument(callback)) : void 0;
	  }
	
	};
	
	module.exports = ReactUpdateQueue;

/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(302);
	
	var emptyFunction = __webpack_require__(348);
	var warning = __webpack_require__(347);
	
	var validateDOMNesting = emptyFunction;
	
	if (false) {
	  // This validation code was written based on the HTML5 parsing spec:
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
	  //
	  // Note: this does not catch all invalid nesting, nor does it try to (as it's
	  // not clear what practical benefit doing so provides); instead, we warn only
	  // for cases where the parser will give a parse tree differing from what React
	  // intended. For example, <b><div></div></b> is invalid but we don't warn
	  // because it still parses correctly; we do warn for other cases like nested
	  // <p> tags where the beginning of the second element implicitly closes the
	  // first, causing a confusing mess.
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#special
	  var specialTags = ['address', 'applet', 'area', 'article', 'aside', 'base', 'basefont', 'bgsound', 'blockquote', 'body', 'br', 'button', 'caption', 'center', 'col', 'colgroup', 'dd', 'details', 'dir', 'div', 'dl', 'dt', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'frame', 'frameset', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'iframe', 'img', 'input', 'isindex', 'li', 'link', 'listing', 'main', 'marquee', 'menu', 'menuitem', 'meta', 'nav', 'noembed', 'noframes', 'noscript', 'object', 'ol', 'p', 'param', 'plaintext', 'pre', 'script', 'section', 'select', 'source', 'style', 'summary', 'table', 'tbody', 'td', 'template', 'textarea', 'tfoot', 'th', 'thead', 'title', 'tr', 'track', 'ul', 'wbr', 'xmp'];
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
	  var inScopeTags = ['applet', 'caption', 'html', 'table', 'td', 'th', 'marquee', 'object', 'template',
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#html-integration-point
	  // TODO: Distinguish by namespace here -- for <title>, including it here
	  // errs on the side of fewer warnings
	  'foreignObject', 'desc', 'title'];
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-button-scope
	  var buttonScopeTags = inScopeTags.concat(['button']);
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#generate-implied-end-tags
	  var impliedEndTags = ['dd', 'dt', 'li', 'option', 'optgroup', 'p', 'rp', 'rt'];
	
	  var emptyAncestorInfo = {
	    current: null,
	
	    formTag: null,
	    aTagInScope: null,
	    buttonTagInScope: null,
	    nobrTagInScope: null,
	    pTagInButtonScope: null,
	
	    listItemTagAutoclosing: null,
	    dlItemTagAutoclosing: null
	  };
	
	  var updatedAncestorInfo = function (oldInfo, tag, instance) {
	    var ancestorInfo = _assign({}, oldInfo || emptyAncestorInfo);
	    var info = { tag: tag, instance: instance };
	
	    if (inScopeTags.indexOf(tag) !== -1) {
	      ancestorInfo.aTagInScope = null;
	      ancestorInfo.buttonTagInScope = null;
	      ancestorInfo.nobrTagInScope = null;
	    }
	    if (buttonScopeTags.indexOf(tag) !== -1) {
	      ancestorInfo.pTagInButtonScope = null;
	    }
	
	    // See rules for 'li', 'dd', 'dt' start tags in
	    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
	    if (specialTags.indexOf(tag) !== -1 && tag !== 'address' && tag !== 'div' && tag !== 'p') {
	      ancestorInfo.listItemTagAutoclosing = null;
	      ancestorInfo.dlItemTagAutoclosing = null;
	    }
	
	    ancestorInfo.current = info;
	
	    if (tag === 'form') {
	      ancestorInfo.formTag = info;
	    }
	    if (tag === 'a') {
	      ancestorInfo.aTagInScope = info;
	    }
	    if (tag === 'button') {
	      ancestorInfo.buttonTagInScope = info;
	    }
	    if (tag === 'nobr') {
	      ancestorInfo.nobrTagInScope = info;
	    }
	    if (tag === 'p') {
	      ancestorInfo.pTagInButtonScope = info;
	    }
	    if (tag === 'li') {
	      ancestorInfo.listItemTagAutoclosing = info;
	    }
	    if (tag === 'dd' || tag === 'dt') {
	      ancestorInfo.dlItemTagAutoclosing = info;
	    }
	
	    return ancestorInfo;
	  };
	
	  /**
	   * Returns whether
	   */
	  var isTagValidWithParent = function (tag, parentTag) {
	    // First, let's check if we're in an unusual parsing mode...
	    switch (parentTag) {
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inselect
	      case 'select':
	        return tag === 'option' || tag === 'optgroup' || tag === '#text';
	      case 'optgroup':
	        return tag === 'option' || tag === '#text';
	      // Strictly speaking, seeing an <option> doesn't mean we're in a <select>
	      // but
	      case 'option':
	        return tag === '#text';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intd
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incaption
	      // No special behavior since these rules fall back to "in body" mode for
	      // all except special table nodes which cause bad parsing behavior anyway.
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intr
	      case 'tr':
	        return tag === 'th' || tag === 'td' || tag === 'style' || tag === 'script' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intbody
	      case 'tbody':
	      case 'thead':
	      case 'tfoot':
	        return tag === 'tr' || tag === 'style' || tag === 'script' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incolgroup
	      case 'colgroup':
	        return tag === 'col' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intable
	      case 'table':
	        return tag === 'caption' || tag === 'colgroup' || tag === 'tbody' || tag === 'tfoot' || tag === 'thead' || tag === 'style' || tag === 'script' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inhead
	      case 'head':
	        return tag === 'base' || tag === 'basefont' || tag === 'bgsound' || tag === 'link' || tag === 'meta' || tag === 'title' || tag === 'noscript' || tag === 'noframes' || tag === 'style' || tag === 'script' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/semantics.html#the-html-element
	      case 'html':
	        return tag === 'head' || tag === 'body';
	      case '#document':
	        return tag === 'html';
	    }
	
	    // Probably in the "in body" parsing mode, so we outlaw only tag combos
	    // where the parsing rules cause implicit opens or closes to be added.
	    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
	    switch (tag) {
	      case 'h1':
	      case 'h2':
	      case 'h3':
	      case 'h4':
	      case 'h5':
	      case 'h6':
	        return parentTag !== 'h1' && parentTag !== 'h2' && parentTag !== 'h3' && parentTag !== 'h4' && parentTag !== 'h5' && parentTag !== 'h6';
	
	      case 'rp':
	      case 'rt':
	        return impliedEndTags.indexOf(parentTag) === -1;
	
	      case 'body':
	      case 'caption':
	      case 'col':
	      case 'colgroup':
	      case 'frame':
	      case 'head':
	      case 'html':
	      case 'tbody':
	      case 'td':
	      case 'tfoot':
	      case 'th':
	      case 'thead':
	      case 'tr':
	        // These tags are only valid with a few parents that have special child
	        // parsing rules -- if we're down here, then none of those matched and
	        // so we allow it only if we don't know what the parent is, as all other
	        // cases are invalid.
	        return parentTag == null;
	    }
	
	    return true;
	  };
	
	  /**
	   * Returns whether
	   */
	  var findInvalidAncestorForTag = function (tag, ancestorInfo) {
	    switch (tag) {
	      case 'address':
	      case 'article':
	      case 'aside':
	      case 'blockquote':
	      case 'center':
	      case 'details':
	      case 'dialog':
	      case 'dir':
	      case 'div':
	      case 'dl':
	      case 'fieldset':
	      case 'figcaption':
	      case 'figure':
	      case 'footer':
	      case 'header':
	      case 'hgroup':
	      case 'main':
	      case 'menu':
	      case 'nav':
	      case 'ol':
	      case 'p':
	      case 'section':
	      case 'summary':
	      case 'ul':
	      case 'pre':
	      case 'listing':
	      case 'table':
	      case 'hr':
	      case 'xmp':
	      case 'h1':
	      case 'h2':
	      case 'h3':
	      case 'h4':
	      case 'h5':
	      case 'h6':
	        return ancestorInfo.pTagInButtonScope;
	
	      case 'form':
	        return ancestorInfo.formTag || ancestorInfo.pTagInButtonScope;
	
	      case 'li':
	        return ancestorInfo.listItemTagAutoclosing;
	
	      case 'dd':
	      case 'dt':
	        return ancestorInfo.dlItemTagAutoclosing;
	
	      case 'button':
	        return ancestorInfo.buttonTagInScope;
	
	      case 'a':
	        // Spec says something about storing a list of markers, but it sounds
	        // equivalent to this check.
	        return ancestorInfo.aTagInScope;
	
	      case 'nobr':
	        return ancestorInfo.nobrTagInScope;
	    }
	
	    return null;
	  };
	
	  /**
	   * Given a ReactCompositeComponent instance, return a list of its recursive
	   * owners, starting at the root and ending with the instance itself.
	   */
	  var findOwnerStack = function (instance) {
	    if (!instance) {
	      return [];
	    }
	
	    var stack = [];
	    do {
	      stack.push(instance);
	    } while (instance = instance._currentElement._owner);
	    stack.reverse();
	    return stack;
	  };
	
	  var didWarn = {};
	
	  validateDOMNesting = function (childTag, childText, childInstance, ancestorInfo) {
	    ancestorInfo = ancestorInfo || emptyAncestorInfo;
	    var parentInfo = ancestorInfo.current;
	    var parentTag = parentInfo && parentInfo.tag;
	
	    if (childText != null) {
	      process.env.NODE_ENV !== 'production' ? warning(childTag == null, 'validateDOMNesting: when childText is passed, childTag should be null') : void 0;
	      childTag = '#text';
	    }
	
	    var invalidParent = isTagValidWithParent(childTag, parentTag) ? null : parentInfo;
	    var invalidAncestor = invalidParent ? null : findInvalidAncestorForTag(childTag, ancestorInfo);
	    var problematic = invalidParent || invalidAncestor;
	
	    if (problematic) {
	      var ancestorTag = problematic.tag;
	      var ancestorInstance = problematic.instance;
	
	      var childOwner = childInstance && childInstance._currentElement._owner;
	      var ancestorOwner = ancestorInstance && ancestorInstance._currentElement._owner;
	
	      var childOwners = findOwnerStack(childOwner);
	      var ancestorOwners = findOwnerStack(ancestorOwner);
	
	      var minStackLen = Math.min(childOwners.length, ancestorOwners.length);
	      var i;
	
	      var deepestCommon = -1;
	      for (i = 0; i < minStackLen; i++) {
	        if (childOwners[i] === ancestorOwners[i]) {
	          deepestCommon = i;
	        } else {
	          break;
	        }
	      }
	
	      var UNKNOWN = '(unknown)';
	      var childOwnerNames = childOwners.slice(deepestCommon + 1).map(function (inst) {
	        return inst.getName() || UNKNOWN;
	      });
	      var ancestorOwnerNames = ancestorOwners.slice(deepestCommon + 1).map(function (inst) {
	        return inst.getName() || UNKNOWN;
	      });
	      var ownerInfo = [].concat(
	      // If the parent and child instances have a common owner ancestor, start
	      // with that -- otherwise we just start with the parent's owners.
	      deepestCommon !== -1 ? childOwners[deepestCommon].getName() || UNKNOWN : [], ancestorOwnerNames, ancestorTag,
	      // If we're warning about an invalid (non-parent) ancestry, add '...'
	      invalidAncestor ? ['...'] : [], childOwnerNames, childTag).join(' > ');
	
	      var warnKey = !!invalidParent + '|' + childTag + '|' + ancestorTag + '|' + ownerInfo;
	      if (didWarn[warnKey]) {
	        return;
	      }
	      didWarn[warnKey] = true;
	
	      var tagDisplayName = childTag;
	      var whitespaceInfo = '';
	      if (childTag === '#text') {
	        if (/\S/.test(childText)) {
	          tagDisplayName = 'Text nodes';
	        } else {
	          tagDisplayName = 'Whitespace text nodes';
	          whitespaceInfo = ' Make sure you don\'t have any extra whitespace between tags on ' + 'each line of your source code.';
	        }
	      } else {
	        tagDisplayName = '<' + childTag + '>';
	      }
	
	      if (invalidParent) {
	        var info = '';
	        if (ancestorTag === 'table' && childTag === 'tr') {
	          info += ' Add a <tbody> to your code to match the DOM tree generated by ' + 'the browser.';
	        }
	        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a child of <%s>.%s ' + 'See %s.%s', tagDisplayName, ancestorTag, whitespaceInfo, ownerInfo, info) : void 0;
	      } else {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a descendant of ' + '<%s>. See %s.', tagDisplayName, ancestorTag, ownerInfo) : void 0;
	      }
	    }
	  };
	
	  validateDOMNesting.updatedAncestorInfo = updatedAncestorInfo;
	
	  // For testing
	  validateDOMNesting.isTagValidInContext = function (tag, ancestorInfo) {
	    ancestorInfo = ancestorInfo || emptyAncestorInfo;
	    var parentInfo = ancestorInfo.current;
	    var parentTag = parentInfo && parentInfo.tag;
	    return isTagValidWithParent(tag, parentTag) && !findInvalidAncestorForTag(tag, ancestorInfo);
	  };
	}
	
	module.exports = validateDOMNesting;

/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(302);
	
	var DOMLazyTree = __webpack_require__(379);
	var ReactDOMComponentTree = __webpack_require__(334);
	
	var ReactDOMEmptyComponent = function (instantiate) {
	  // ReactCompositeComponent uses this:
	  this._currentElement = null;
	  // ReactDOMComponentTree uses these:
	  this._hostNode = null;
	  this._hostParent = null;
	  this._hostContainerInfo = null;
	  this._domID = 0;
	};
	_assign(ReactDOMEmptyComponent.prototype, {
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    var domID = hostContainerInfo._idCounter++;
	    this._domID = domID;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var nodeValue = ' react-empty: ' + this._domID + ' ';
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var node = ownerDocument.createComment(nodeValue);
	      ReactDOMComponentTree.precacheNode(this, node);
	      return DOMLazyTree(node);
	    } else {
	      if (transaction.renderToStaticMarkup) {
	        // Normally we'd insert a comment node, but since this is a situation
	        // where React won't take over (static pages), we can simply return
	        // nothing.
	        return '';
	      }
	      return '<!--' + nodeValue + '-->';
	    }
	  },
	  receiveComponent: function () {},
	  getHostNode: function () {
	    return ReactDOMComponentTree.getNodeFromInstance(this);
	  },
	  unmountComponent: function () {
	    ReactDOMComponentTree.uncacheNode(this);
	  }
	});
	
	module.exports = ReactDOMEmptyComponent;

/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(335);
	
	var invariant = __webpack_require__(337);
	
	/**
	 * Return the lowest common ancestor of A and B, or null if they are in
	 * different trees.
	 */
	function getLowestCommonAncestor(instA, instB) {
	  !('_hostNode' in instA) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	  !('_hostNode' in instB) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	
	  var depthA = 0;
	  for (var tempA = instA; tempA; tempA = tempA._hostParent) {
	    depthA++;
	  }
	  var depthB = 0;
	  for (var tempB = instB; tempB; tempB = tempB._hostParent) {
	    depthB++;
	  }
	
	  // If A is deeper, crawl up.
	  while (depthA - depthB > 0) {
	    instA = instA._hostParent;
	    depthA--;
	  }
	
	  // If B is deeper, crawl up.
	  while (depthB - depthA > 0) {
	    instB = instB._hostParent;
	    depthB--;
	  }
	
	  // Walk in lockstep until we find a match.
	  var depth = depthA;
	  while (depth--) {
	    if (instA === instB) {
	      return instA;
	    }
	    instA = instA._hostParent;
	    instB = instB._hostParent;
	  }
	  return null;
	}
	
	/**
	 * Return if A is an ancestor of B.
	 */
	function isAncestor(instA, instB) {
	  !('_hostNode' in instA) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;
	  !('_hostNode' in instB) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;
	
	  while (instB) {
	    if (instB === instA) {
	      return true;
	    }
	    instB = instB._hostParent;
	  }
	  return false;
	}
	
	/**
	 * Return the parent instance of the passed-in instance.
	 */
	function getParentInstance(inst) {
	  !('_hostNode' in inst) ?  false ? invariant(false, 'getParentInstance: Invalid argument.') : _prodInvariant('36') : void 0;
	
	  return inst._hostParent;
	}
	
	/**
	 * Simulates the traversal of a two-phase, capture/bubble event dispatch.
	 */
	function traverseTwoPhase(inst, fn, arg) {
	  var path = [];
	  while (inst) {
	    path.push(inst);
	    inst = inst._hostParent;
	  }
	  var i;
	  for (i = path.length; i-- > 0;) {
	    fn(path[i], 'captured', arg);
	  }
	  for (i = 0; i < path.length; i++) {
	    fn(path[i], 'bubbled', arg);
	  }
	}
	
	/**
	 * Traverses the ID hierarchy and invokes the supplied `cb` on any IDs that
	 * should would receive a `mouseEnter` or `mouseLeave` event.
	 *
	 * Does not invoke the callback on the nearest common ancestor because nothing
	 * "entered" or "left" that element.
	 */
	function traverseEnterLeave(from, to, fn, argFrom, argTo) {
	  var common = from && to ? getLowestCommonAncestor(from, to) : null;
	  var pathFrom = [];
	  while (from && from !== common) {
	    pathFrom.push(from);
	    from = from._hostParent;
	  }
	  var pathTo = [];
	  while (to && to !== common) {
	    pathTo.push(to);
	    to = to._hostParent;
	  }
	  var i;
	  for (i = 0; i < pathFrom.length; i++) {
	    fn(pathFrom[i], 'bubbled', argFrom);
	  }
	  for (i = pathTo.length; i-- > 0;) {
	    fn(pathTo[i], 'captured', argTo);
	  }
	}
	
	module.exports = {
	  isAncestor: isAncestor,
	  getLowestCommonAncestor: getLowestCommonAncestor,
	  getParentInstance: getParentInstance,
	  traverseTwoPhase: traverseTwoPhase,
	  traverseEnterLeave: traverseEnterLeave
	};

/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(335),
	    _assign = __webpack_require__(302);
	
	var DOMChildrenOperations = __webpack_require__(378);
	var DOMLazyTree = __webpack_require__(379);
	var ReactDOMComponentTree = __webpack_require__(334);
	
	var escapeTextContentForBrowser = __webpack_require__(384);
	var invariant = __webpack_require__(337);
	var validateDOMNesting = __webpack_require__(438);
	
	/**
	 * Text nodes violate a couple assumptions that React makes about components:
	 *
	 *  - When mounting text into the DOM, adjacent text nodes are merged.
	 *  - Text nodes cannot be assigned a React root ID.
	 *
	 * This component is used to wrap strings between comment nodes so that they
	 * can undergo the same reconciliation that is applied to elements.
	 *
	 * TODO: Investigate representing React components in the DOM with text nodes.
	 *
	 * @class ReactDOMTextComponent
	 * @extends ReactComponent
	 * @internal
	 */
	var ReactDOMTextComponent = function (text) {
	  // TODO: This is really a ReactText (ReactNode), not a ReactElement
	  this._currentElement = text;
	  this._stringText = '' + text;
	  // ReactDOMComponentTree uses these:
	  this._hostNode = null;
	  this._hostParent = null;
	
	  // Properties
	  this._domID = 0;
	  this._mountIndex = 0;
	  this._closingComment = null;
	  this._commentNodes = null;
	};
	
	_assign(ReactDOMTextComponent.prototype, {
	
	  /**
	   * Creates the markup for this text node. This node is not intended to have
	   * any features besides containing text content.
	   *
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @return {string} Markup for this text node.
	   * @internal
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    if (false) {
	      var parentInfo;
	      if (hostParent != null) {
	        parentInfo = hostParent._ancestorInfo;
	      } else if (hostContainerInfo != null) {
	        parentInfo = hostContainerInfo._ancestorInfo;
	      }
	      if (parentInfo) {
	        // parentInfo should always be present except for the top-level
	        // component when server rendering
	        validateDOMNesting(null, this._stringText, this, parentInfo);
	      }
	    }
	
	    var domID = hostContainerInfo._idCounter++;
	    var openingValue = ' react-text: ' + domID + ' ';
	    var closingValue = ' /react-text ';
	    this._domID = domID;
	    this._hostParent = hostParent;
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var openingComment = ownerDocument.createComment(openingValue);
	      var closingComment = ownerDocument.createComment(closingValue);
	      var lazyTree = DOMLazyTree(ownerDocument.createDocumentFragment());
	      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(openingComment));
	      if (this._stringText) {
	        DOMLazyTree.queueChild(lazyTree, DOMLazyTree(ownerDocument.createTextNode(this._stringText)));
	      }
	      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(closingComment));
	      ReactDOMComponentTree.precacheNode(this, openingComment);
	      this._closingComment = closingComment;
	      return lazyTree;
	    } else {
	      var escapedText = escapeTextContentForBrowser(this._stringText);
	
	      if (transaction.renderToStaticMarkup) {
	        // Normally we'd wrap this between comment nodes for the reasons stated
	        // above, but since this is a situation where React won't take over
	        // (static pages), we can simply return the text as it is.
	        return escapedText;
	      }
	
	      return '<!--' + openingValue + '-->' + escapedText + '<!--' + closingValue + '-->';
	    }
	  },
	
	  /**
	   * Updates this component by updating the text content.
	   *
	   * @param {ReactText} nextText The next text content
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  receiveComponent: function (nextText, transaction) {
	    if (nextText !== this._currentElement) {
	      this._currentElement = nextText;
	      var nextStringText = '' + nextText;
	      if (nextStringText !== this._stringText) {
	        // TODO: Save this as pending props and use performUpdateIfNecessary
	        // and/or updateComponent to do the actual update for consistency with
	        // other component types?
	        this._stringText = nextStringText;
	        var commentNodes = this.getHostNode();
	        DOMChildrenOperations.replaceDelimitedText(commentNodes[0], commentNodes[1], nextStringText);
	      }
	    }
	  },
	
	  getHostNode: function () {
	    var hostNode = this._commentNodes;
	    if (hostNode) {
	      return hostNode;
	    }
	    if (!this._closingComment) {
	      var openingComment = ReactDOMComponentTree.getNodeFromInstance(this);
	      var node = openingComment.nextSibling;
	      while (true) {
	        !(node != null) ?  false ? invariant(false, 'Missing closing comment for text component %s', this._domID) : _prodInvariant('67', this._domID) : void 0;
	        if (node.nodeType === 8 && node.nodeValue === ' /react-text ') {
	          this._closingComment = node;
	          break;
	        }
	        node = node.nextSibling;
	      }
	    }
	    hostNode = [this._hostNode, this._closingComment];
	    this._commentNodes = hostNode;
	    return hostNode;
	  },
	
	  unmountComponent: function () {
	    this._closingComment = null;
	    this._commentNodes = null;
	    ReactDOMComponentTree.uncacheNode(this);
	  }
	
	});
	
	module.exports = ReactDOMTextComponent;

/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(302);
	
	var ReactUpdates = __webpack_require__(359);
	var Transaction = __webpack_require__(366);
	
	var emptyFunction = __webpack_require__(348);
	
	var RESET_BATCHED_UPDATES = {
	  initialize: emptyFunction,
	  close: function () {
	    ReactDefaultBatchingStrategy.isBatchingUpdates = false;
	  }
	};
	
	var FLUSH_BATCHED_UPDATES = {
	  initialize: emptyFunction,
	  close: ReactUpdates.flushBatchedUpdates.bind(ReactUpdates)
	};
	
	var TRANSACTION_WRAPPERS = [FLUSH_BATCHED_UPDATES, RESET_BATCHED_UPDATES];
	
	function ReactDefaultBatchingStrategyTransaction() {
	  this.reinitializeTransaction();
	}
	
	_assign(ReactDefaultBatchingStrategyTransaction.prototype, Transaction, {
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  }
	});
	
	var transaction = new ReactDefaultBatchingStrategyTransaction();
	
	var ReactDefaultBatchingStrategy = {
	  isBatchingUpdates: false,
	
	  /**
	   * Call the provided function in a context within which calls to `setState`
	   * and friends are batched such that components aren't updated unnecessarily.
	   */
	  batchedUpdates: function (callback, a, b, c, d, e) {
	    var alreadyBatchingUpdates = ReactDefaultBatchingStrategy.isBatchingUpdates;
	
	    ReactDefaultBatchingStrategy.isBatchingUpdates = true;
	
	    // The code is written this way to avoid extra allocations
	    if (alreadyBatchingUpdates) {
	      return callback(a, b, c, d, e);
	    } else {
	      return transaction.perform(callback, null, a, b, c, d, e);
	    }
	  }
	};
	
	module.exports = ReactDefaultBatchingStrategy;

/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(302);
	
	var EventListener = __webpack_require__(444);
	var ExecutionEnvironment = __webpack_require__(351);
	var PooledClass = __webpack_require__(353);
	var ReactDOMComponentTree = __webpack_require__(334);
	var ReactUpdates = __webpack_require__(359);
	
	var getEventTarget = __webpack_require__(367);
	var getUnboundedScrollPosition = __webpack_require__(445);
	
	/**
	 * Find the deepest React component completely containing the root of the
	 * passed-in instance (for use when entire React trees are nested within each
	 * other). If React trees are not nested, returns null.
	 */
	function findParent(inst) {
	  // TODO: It may be a good idea to cache this to prevent unnecessary DOM
	  // traversal, but caching is difficult to do correctly without using a
	  // mutation observer to listen for all DOM changes.
	  while (inst._hostParent) {
	    inst = inst._hostParent;
	  }
	  var rootNode = ReactDOMComponentTree.getNodeFromInstance(inst);
	  var container = rootNode.parentNode;
	  return ReactDOMComponentTree.getClosestInstanceFromNode(container);
	}
	
	// Used to store ancestor hierarchy in top level callback
	function TopLevelCallbackBookKeeping(topLevelType, nativeEvent) {
	  this.topLevelType = topLevelType;
	  this.nativeEvent = nativeEvent;
	  this.ancestors = [];
	}
	_assign(TopLevelCallbackBookKeeping.prototype, {
	  destructor: function () {
	    this.topLevelType = null;
	    this.nativeEvent = null;
	    this.ancestors.length = 0;
	  }
	});
	PooledClass.addPoolingTo(TopLevelCallbackBookKeeping, PooledClass.twoArgumentPooler);
	
	function handleTopLevelImpl(bookKeeping) {
	  var nativeEventTarget = getEventTarget(bookKeeping.nativeEvent);
	  var targetInst = ReactDOMComponentTree.getClosestInstanceFromNode(nativeEventTarget);
	
	  // Loop through the hierarchy, in case there's any nested components.
	  // It's important that we build the array of ancestors before calling any
	  // event handlers, because event handlers can modify the DOM, leading to
	  // inconsistencies with ReactMount's node cache. See #1105.
	  var ancestor = targetInst;
	  do {
	    bookKeeping.ancestors.push(ancestor);
	    ancestor = ancestor && findParent(ancestor);
	  } while (ancestor);
	
	  for (var i = 0; i < bookKeeping.ancestors.length; i++) {
	    targetInst = bookKeeping.ancestors[i];
	    ReactEventListener._handleTopLevel(bookKeeping.topLevelType, targetInst, bookKeeping.nativeEvent, getEventTarget(bookKeeping.nativeEvent));
	  }
	}
	
	function scrollValueMonitor(cb) {
	  var scrollPosition = getUnboundedScrollPosition(window);
	  cb(scrollPosition);
	}
	
	var ReactEventListener = {
	  _enabled: true,
	  _handleTopLevel: null,
	
	  WINDOW_HANDLE: ExecutionEnvironment.canUseDOM ? window : null,
	
	  setHandleTopLevel: function (handleTopLevel) {
	    ReactEventListener._handleTopLevel = handleTopLevel;
	  },
	
	  setEnabled: function (enabled) {
	    ReactEventListener._enabled = !!enabled;
	  },
	
	  isEnabled: function () {
	    return ReactEventListener._enabled;
	  },
	
	  /**
	   * Traps top-level events by using event bubbling.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {string} handlerBaseName Event name (e.g. "click").
	   * @param {object} element Element on which to attach listener.
	   * @return {?object} An object with a remove function which will forcefully
	   *                  remove the listener.
	   * @internal
	   */
	  trapBubbledEvent: function (topLevelType, handlerBaseName, element) {
	    if (!element) {
	      return null;
	    }
	    return EventListener.listen(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
	  },
	
	  /**
	   * Traps a top-level event by using event capturing.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {string} handlerBaseName Event name (e.g. "click").
	   * @param {object} element Element on which to attach listener.
	   * @return {?object} An object with a remove function which will forcefully
	   *                  remove the listener.
	   * @internal
	   */
	  trapCapturedEvent: function (topLevelType, handlerBaseName, element) {
	    if (!element) {
	      return null;
	    }
	    return EventListener.capture(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
	  },
	
	  monitorScrollValue: function (refresh) {
	    var callback = scrollValueMonitor.bind(null, refresh);
	    EventListener.listen(window, 'scroll', callback);
	  },
	
	  dispatchEvent: function (topLevelType, nativeEvent) {
	    if (!ReactEventListener._enabled) {
	      return;
	    }
	
	    var bookKeeping = TopLevelCallbackBookKeeping.getPooled(topLevelType, nativeEvent);
	    try {
	      // Event queue being processed in the same cycle allows
	      // `preventDefault`.
	      ReactUpdates.batchedUpdates(handleTopLevelImpl, bookKeeping);
	    } finally {
	      TopLevelCallbackBookKeeping.release(bookKeeping);
	    }
	  }
	};
	
	module.exports = ReactEventListener;

/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var emptyFunction = __webpack_require__(348);
	
	/**
	 * Upstream version of event listener. Does not take into account specific
	 * nature of platform.
	 */
	var EventListener = {
	  /**
	   * Listen to DOM events during the bubble phase.
	   *
	   * @param {DOMEventTarget} target DOM element to register listener on.
	   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
	   * @param {function} callback Callback function.
	   * @return {object} Object with a `remove` method.
	   */
	  listen: function listen(target, eventType, callback) {
	    if (target.addEventListener) {
	      target.addEventListener(eventType, callback, false);
	      return {
	        remove: function remove() {
	          target.removeEventListener(eventType, callback, false);
	        }
	      };
	    } else if (target.attachEvent) {
	      target.attachEvent('on' + eventType, callback);
	      return {
	        remove: function remove() {
	          target.detachEvent('on' + eventType, callback);
	        }
	      };
	    }
	  },
	
	  /**
	   * Listen to DOM events during the capture phase.
	   *
	   * @param {DOMEventTarget} target DOM element to register listener on.
	   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
	   * @param {function} callback Callback function.
	   * @return {object} Object with a `remove` method.
	   */
	  capture: function capture(target, eventType, callback) {
	    if (target.addEventListener) {
	      target.addEventListener(eventType, callback, true);
	      return {
	        remove: function remove() {
	          target.removeEventListener(eventType, callback, true);
	        }
	      };
	    } else {
	      if (false) {
	        console.error('Attempted to listen to events during the capture phase on a ' + 'browser that does not support the capture phase. Your application ' + 'will not receive some events.');
	      }
	      return {
	        remove: emptyFunction
	      };
	    }
	  },
	
	  registerDefault: function registerDefault() {}
	};
	
	module.exports = EventListener;

/***/ }),
/* 445 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	/**
	 * Gets the scroll position of the supplied element or window.
	 *
	 * The return values are unbounded, unlike `getScrollPosition`. This means they
	 * may be negative or exceed the element boundaries (which is possible using
	 * inertial scrolling).
	 *
	 * @param {DOMWindow|DOMElement} scrollable
	 * @return {object} Map with `x` and `y` keys.
	 */
	
	function getUnboundedScrollPosition(scrollable) {
	  if (scrollable.Window && scrollable instanceof scrollable.Window) {
	    return {
	      x: scrollable.pageXOffset || scrollable.document.documentElement.scrollLeft,
	      y: scrollable.pageYOffset || scrollable.document.documentElement.scrollTop
	    };
	  }
	  return {
	    x: scrollable.scrollLeft,
	    y: scrollable.scrollTop
	  };
	}
	
	module.exports = getUnboundedScrollPosition;

/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(336);
	var EventPluginHub = __webpack_require__(343);
	var EventPluginUtils = __webpack_require__(345);
	var ReactComponentEnvironment = __webpack_require__(417);
	var ReactEmptyComponent = __webpack_require__(426);
	var ReactBrowserEventEmitter = __webpack_require__(403);
	var ReactHostComponent = __webpack_require__(427);
	var ReactUpdates = __webpack_require__(359);
	
	var ReactInjection = {
	  Component: ReactComponentEnvironment.injection,
	  DOMProperty: DOMProperty.injection,
	  EmptyComponent: ReactEmptyComponent.injection,
	  EventPluginHub: EventPluginHub.injection,
	  EventPluginUtils: EventPluginUtils.injection,
	  EventEmitter: ReactBrowserEventEmitter.injection,
	  HostComponent: ReactHostComponent.injection,
	  Updates: ReactUpdates.injection
	};
	
	module.exports = ReactInjection;

/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(302);
	
	var CallbackQueue = __webpack_require__(360);
	var PooledClass = __webpack_require__(353);
	var ReactBrowserEventEmitter = __webpack_require__(403);
	var ReactInputSelection = __webpack_require__(448);
	var ReactInstrumentation = __webpack_require__(365);
	var Transaction = __webpack_require__(366);
	var ReactUpdateQueue = __webpack_require__(437);
	
	/**
	 * Ensures that, when possible, the selection range (currently selected text
	 * input) is not disturbed by performing the transaction.
	 */
	var SELECTION_RESTORATION = {
	  /**
	   * @return {Selection} Selection information.
	   */
	  initialize: ReactInputSelection.getSelectionInformation,
	  /**
	   * @param {Selection} sel Selection information returned from `initialize`.
	   */
	  close: ReactInputSelection.restoreSelection
	};
	
	/**
	 * Suppresses events (blur/focus) that could be inadvertently dispatched due to
	 * high level DOM manipulations (like temporarily removing a text input from the
	 * DOM).
	 */
	var EVENT_SUPPRESSION = {
	  /**
	   * @return {boolean} The enabled status of `ReactBrowserEventEmitter` before
	   * the reconciliation.
	   */
	  initialize: function () {
	    var currentlyEnabled = ReactBrowserEventEmitter.isEnabled();
	    ReactBrowserEventEmitter.setEnabled(false);
	    return currentlyEnabled;
	  },
	
	  /**
	   * @param {boolean} previouslyEnabled Enabled status of
	   *   `ReactBrowserEventEmitter` before the reconciliation occurred. `close`
	   *   restores the previous value.
	   */
	  close: function (previouslyEnabled) {
	    ReactBrowserEventEmitter.setEnabled(previouslyEnabled);
	  }
	};
	
	/**
	 * Provides a queue for collecting `componentDidMount` and
	 * `componentDidUpdate` callbacks during the transaction.
	 */
	var ON_DOM_READY_QUEUEING = {
	  /**
	   * Initializes the internal `onDOMReady` queue.
	   */
	  initialize: function () {
	    this.reactMountReady.reset();
	  },
	
	  /**
	   * After DOM is flushed, invoke all registered `onDOMReady` callbacks.
	   */
	  close: function () {
	    this.reactMountReady.notifyAll();
	  }
	};
	
	/**
	 * Executed within the scope of the `Transaction` instance. Consider these as
	 * being member methods, but with an implied ordering while being isolated from
	 * each other.
	 */
	var TRANSACTION_WRAPPERS = [SELECTION_RESTORATION, EVENT_SUPPRESSION, ON_DOM_READY_QUEUEING];
	
	if (false) {
	  TRANSACTION_WRAPPERS.push({
	    initialize: ReactInstrumentation.debugTool.onBeginFlush,
	    close: ReactInstrumentation.debugTool.onEndFlush
	  });
	}
	
	/**
	 * Currently:
	 * - The order that these are listed in the transaction is critical:
	 * - Suppresses events.
	 * - Restores selection range.
	 *
	 * Future:
	 * - Restore document/overflow scroll positions that were unintentionally
	 *   modified via DOM insertions above the top viewport boundary.
	 * - Implement/integrate with customized constraint based layout system and keep
	 *   track of which dimensions must be remeasured.
	 *
	 * @class ReactReconcileTransaction
	 */
	function ReactReconcileTransaction(useCreateElement) {
	  this.reinitializeTransaction();
	  // Only server-side rendering really needs this option (see
	  // `ReactServerRendering`), but server-side uses
	  // `ReactServerRenderingTransaction` instead. This option is here so that it's
	  // accessible and defaults to false when `ReactDOMComponent` and
	  // `ReactDOMTextComponent` checks it in `mountComponent`.`
	  this.renderToStaticMarkup = false;
	  this.reactMountReady = CallbackQueue.getPooled(null);
	  this.useCreateElement = useCreateElement;
	}
	
	var Mixin = {
	  /**
	   * @see Transaction
	   * @abstract
	   * @final
	   * @return {array<object>} List of operation wrap procedures.
	   *   TODO: convert to array<TransactionWrapper>
	   */
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  /**
	   * @return {object} The queue to collect `onDOMReady` callbacks with.
	   */
	  getReactMountReady: function () {
	    return this.reactMountReady;
	  },
	
	  /**
	   * @return {object} The queue to collect React async events.
	   */
	  getUpdateQueue: function () {
	    return ReactUpdateQueue;
	  },
	
	  /**
	   * Save current transaction state -- if the return value from this method is
	   * passed to `rollback`, the transaction will be reset to that state.
	   */
	  checkpoint: function () {
	    // reactMountReady is the our only stateful wrapper
	    return this.reactMountReady.checkpoint();
	  },
	
	  rollback: function (checkpoint) {
	    this.reactMountReady.rollback(checkpoint);
	  },
	
	  /**
	   * `PooledClass` looks for this, and will invoke this before allowing this
	   * instance to be reused.
	   */
	  destructor: function () {
	    CallbackQueue.release(this.reactMountReady);
	    this.reactMountReady = null;
	  }
	};
	
	_assign(ReactReconcileTransaction.prototype, Transaction, Mixin);
	
	PooledClass.addPoolingTo(ReactReconcileTransaction);
	
	module.exports = ReactReconcileTransaction;

/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactDOMSelection = __webpack_require__(449);
	
	var containsNode = __webpack_require__(451);
	var focusNode = __webpack_require__(392);
	var getActiveElement = __webpack_require__(454);
	
	function isInDocument(node) {
	  return containsNode(document.documentElement, node);
	}
	
	/**
	 * @ReactInputSelection: React input selection module. Based on Selection.js,
	 * but modified to be suitable for react and has a couple of bug fixes (doesn't
	 * assume buttons have range selections allowed).
	 * Input selection module for React.
	 */
	var ReactInputSelection = {
	
	  hasSelectionCapabilities: function (elem) {
	    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
	    return nodeName && (nodeName === 'input' && elem.type === 'text' || nodeName === 'textarea' || elem.contentEditable === 'true');
	  },
	
	  getSelectionInformation: function () {
	    var focusedElem = getActiveElement();
	    return {
	      focusedElem: focusedElem,
	      selectionRange: ReactInputSelection.hasSelectionCapabilities(focusedElem) ? ReactInputSelection.getSelection(focusedElem) : null
	    };
	  },
	
	  /**
	   * @restoreSelection: If any selection information was potentially lost,
	   * restore it. This is useful when performing operations that could remove dom
	   * nodes and place them back in, resulting in focus being lost.
	   */
	  restoreSelection: function (priorSelectionInformation) {
	    var curFocusedElem = getActiveElement();
	    var priorFocusedElem = priorSelectionInformation.focusedElem;
	    var priorSelectionRange = priorSelectionInformation.selectionRange;
	    if (curFocusedElem !== priorFocusedElem && isInDocument(priorFocusedElem)) {
	      if (ReactInputSelection.hasSelectionCapabilities(priorFocusedElem)) {
	        ReactInputSelection.setSelection(priorFocusedElem, priorSelectionRange);
	      }
	      focusNode(priorFocusedElem);
	    }
	  },
	
	  /**
	   * @getSelection: Gets the selection bounds of a focused textarea, input or
	   * contentEditable node.
	   * -@input: Look up selection bounds of this input
	   * -@return {start: selectionStart, end: selectionEnd}
	   */
	  getSelection: function (input) {
	    var selection;
	
	    if ('selectionStart' in input) {
	      // Modern browser with input or textarea.
	      selection = {
	        start: input.selectionStart,
	        end: input.selectionEnd
	      };
	    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
	      // IE8 input.
	      var range = document.selection.createRange();
	      // There can only be one selection per document in IE, so it must
	      // be in our element.
	      if (range.parentElement() === input) {
	        selection = {
	          start: -range.moveStart('character', -input.value.length),
	          end: -range.moveEnd('character', -input.value.length)
	        };
	      }
	    } else {
	      // Content editable or old IE textarea.
	      selection = ReactDOMSelection.getOffsets(input);
	    }
	
	    return selection || { start: 0, end: 0 };
	  },
	
	  /**
	   * @setSelection: Sets the selection bounds of a textarea or input and focuses
	   * the input.
	   * -@input     Set selection bounds of this input or textarea
	   * -@offsets   Object of same form that is returned from get*
	   */
	  setSelection: function (input, offsets) {
	    var start = offsets.start;
	    var end = offsets.end;
	    if (end === undefined) {
	      end = start;
	    }
	
	    if ('selectionStart' in input) {
	      input.selectionStart = start;
	      input.selectionEnd = Math.min(end, input.value.length);
	    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
	      var range = input.createTextRange();
	      range.collapse(true);
	      range.moveStart('character', start);
	      range.moveEnd('character', end - start);
	      range.select();
	    } else {
	      ReactDOMSelection.setOffsets(input, offsets);
	    }
	  }
	};
	
	module.exports = ReactInputSelection;

/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(351);
	
	var getNodeForCharacterOffset = __webpack_require__(450);
	var getTextContentAccessor = __webpack_require__(354);
	
	/**
	 * While `isCollapsed` is available on the Selection object and `collapsed`
	 * is available on the Range object, IE11 sometimes gets them wrong.
	 * If the anchor/focus nodes and offsets are the same, the range is collapsed.
	 */
	function isCollapsed(anchorNode, anchorOffset, focusNode, focusOffset) {
	  return anchorNode === focusNode && anchorOffset === focusOffset;
	}
	
	/**
	 * Get the appropriate anchor and focus node/offset pairs for IE.
	 *
	 * The catch here is that IE's selection API doesn't provide information
	 * about whether the selection is forward or backward, so we have to
	 * behave as though it's always forward.
	 *
	 * IE text differs from modern selection in that it behaves as though
	 * block elements end with a new line. This means character offsets will
	 * differ between the two APIs.
	 *
	 * @param {DOMElement} node
	 * @return {object}
	 */
	function getIEOffsets(node) {
	  var selection = document.selection;
	  var selectedRange = selection.createRange();
	  var selectedLength = selectedRange.text.length;
	
	  // Duplicate selection so we can move range without breaking user selection.
	  var fromStart = selectedRange.duplicate();
	  fromStart.moveToElementText(node);
	  fromStart.setEndPoint('EndToStart', selectedRange);
	
	  var startOffset = fromStart.text.length;
	  var endOffset = startOffset + selectedLength;
	
	  return {
	    start: startOffset,
	    end: endOffset
	  };
	}
	
	/**
	 * @param {DOMElement} node
	 * @return {?object}
	 */
	function getModernOffsets(node) {
	  var selection = window.getSelection && window.getSelection();
	
	  if (!selection || selection.rangeCount === 0) {
	    return null;
	  }
	
	  var anchorNode = selection.anchorNode;
	  var anchorOffset = selection.anchorOffset;
	  var focusNode = selection.focusNode;
	  var focusOffset = selection.focusOffset;
	
	  var currentRange = selection.getRangeAt(0);
	
	  // In Firefox, range.startContainer and range.endContainer can be "anonymous
	  // divs", e.g. the up/down buttons on an <input type="number">. Anonymous
	  // divs do not seem to expose properties, triggering a "Permission denied
	  // error" if any of its properties are accessed. The only seemingly possible
	  // way to avoid erroring is to access a property that typically works for
	  // non-anonymous divs and catch any error that may otherwise arise. See
	  // https://bugzilla.mozilla.org/show_bug.cgi?id=208427
	  try {
	    /* eslint-disable no-unused-expressions */
	    currentRange.startContainer.nodeType;
	    currentRange.endContainer.nodeType;
	    /* eslint-enable no-unused-expressions */
	  } catch (e) {
	    return null;
	  }
	
	  // If the node and offset values are the same, the selection is collapsed.
	  // `Selection.isCollapsed` is available natively, but IE sometimes gets
	  // this value wrong.
	  var isSelectionCollapsed = isCollapsed(selection.anchorNode, selection.anchorOffset, selection.focusNode, selection.focusOffset);
	
	  var rangeLength = isSelectionCollapsed ? 0 : currentRange.toString().length;
	
	  var tempRange = currentRange.cloneRange();
	  tempRange.selectNodeContents(node);
	  tempRange.setEnd(currentRange.startContainer, currentRange.startOffset);
	
	  var isTempRangeCollapsed = isCollapsed(tempRange.startContainer, tempRange.startOffset, tempRange.endContainer, tempRange.endOffset);
	
	  var start = isTempRangeCollapsed ? 0 : tempRange.toString().length;
	  var end = start + rangeLength;
	
	  // Detect whether the selection is backward.
	  var detectionRange = document.createRange();
	  detectionRange.setStart(anchorNode, anchorOffset);
	  detectionRange.setEnd(focusNode, focusOffset);
	  var isBackward = detectionRange.collapsed;
	
	  return {
	    start: isBackward ? end : start,
	    end: isBackward ? start : end
	  };
	}
	
	/**
	 * @param {DOMElement|DOMTextNode} node
	 * @param {object} offsets
	 */
	function setIEOffsets(node, offsets) {
	  var range = document.selection.createRange().duplicate();
	  var start, end;
	
	  if (offsets.end === undefined) {
	    start = offsets.start;
	    end = start;
	  } else if (offsets.start > offsets.end) {
	    start = offsets.end;
	    end = offsets.start;
	  } else {
	    start = offsets.start;
	    end = offsets.end;
	  }
	
	  range.moveToElementText(node);
	  range.moveStart('character', start);
	  range.setEndPoint('EndToStart', range);
	  range.moveEnd('character', end - start);
	  range.select();
	}
	
	/**
	 * In modern non-IE browsers, we can support both forward and backward
	 * selections.
	 *
	 * Note: IE10+ supports the Selection object, but it does not support
	 * the `extend` method, which means that even in modern IE, it's not possible
	 * to programmatically create a backward selection. Thus, for all IE
	 * versions, we use the old IE API to create our selections.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @param {object} offsets
	 */
	function setModernOffsets(node, offsets) {
	  if (!window.getSelection) {
	    return;
	  }
	
	  var selection = window.getSelection();
	  var length = node[getTextContentAccessor()].length;
	  var start = Math.min(offsets.start, length);
	  var end = offsets.end === undefined ? start : Math.min(offsets.end, length);
	
	  // IE 11 uses modern selection, but doesn't support the extend method.
	  // Flip backward selections, so we can set with a single range.
	  if (!selection.extend && start > end) {
	    var temp = end;
	    end = start;
	    start = temp;
	  }
	
	  var startMarker = getNodeForCharacterOffset(node, start);
	  var endMarker = getNodeForCharacterOffset(node, end);
	
	  if (startMarker && endMarker) {
	    var range = document.createRange();
	    range.setStart(startMarker.node, startMarker.offset);
	    selection.removeAllRanges();
	
	    if (start > end) {
	      selection.addRange(range);
	      selection.extend(endMarker.node, endMarker.offset);
	    } else {
	      range.setEnd(endMarker.node, endMarker.offset);
	      selection.addRange(range);
	    }
	  }
	}
	
	var useIEOffsets = ExecutionEnvironment.canUseDOM && 'selection' in document && !('getSelection' in window);
	
	var ReactDOMSelection = {
	  /**
	   * @param {DOMElement} node
	   */
	  getOffsets: useIEOffsets ? getIEOffsets : getModernOffsets,
	
	  /**
	   * @param {DOMElement|DOMTextNode} node
	   * @param {object} offsets
	   */
	  setOffsets: useIEOffsets ? setIEOffsets : setModernOffsets
	};
	
	module.exports = ReactDOMSelection;

/***/ }),
/* 450 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Given any node return the first leaf node without children.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @return {DOMElement|DOMTextNode}
	 */
	
	function getLeafNode(node) {
	  while (node && node.firstChild) {
	    node = node.firstChild;
	  }
	  return node;
	}
	
	/**
	 * Get the next sibling within a container. This will walk up the
	 * DOM if a node's siblings have been exhausted.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @return {?DOMElement|DOMTextNode}
	 */
	function getSiblingNode(node) {
	  while (node) {
	    if (node.nextSibling) {
	      return node.nextSibling;
	    }
	    node = node.parentNode;
	  }
	}
	
	/**
	 * Get object describing the nodes which contain characters at offset.
	 *
	 * @param {DOMElement|DOMTextNode} root
	 * @param {number} offset
	 * @return {?object}
	 */
	function getNodeForCharacterOffset(root, offset) {
	  var node = getLeafNode(root);
	  var nodeStart = 0;
	  var nodeEnd = 0;
	
	  while (node) {
	    if (node.nodeType === 3) {
	      nodeEnd = nodeStart + node.textContent.length;
	
	      if (nodeStart <= offset && nodeEnd >= offset) {
	        return {
	          node: node,
	          offset: offset - nodeStart
	        };
	      }
	
	      nodeStart = nodeEnd;
	    }
	
	    node = getLeafNode(getSiblingNode(node));
	  }
	}
	
	module.exports = getNodeForCharacterOffset;

/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	var isTextNode = __webpack_require__(452);
	
	/*eslint-disable no-bitwise */
	
	/**
	 * Checks if a given DOM node contains or is another DOM node.
	 */
	function containsNode(outerNode, innerNode) {
	  if (!outerNode || !innerNode) {
	    return false;
	  } else if (outerNode === innerNode) {
	    return true;
	  } else if (isTextNode(outerNode)) {
	    return false;
	  } else if (isTextNode(innerNode)) {
	    return containsNode(outerNode, innerNode.parentNode);
	  } else if ('contains' in outerNode) {
	    return outerNode.contains(innerNode);
	  } else if (outerNode.compareDocumentPosition) {
	    return !!(outerNode.compareDocumentPosition(innerNode) & 16);
	  } else {
	    return false;
	  }
	}
	
	module.exports = containsNode;

/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var isNode = __webpack_require__(453);
	
	/**
	 * @param {*} object The object to check.
	 * @return {boolean} Whether or not the object is a DOM text node.
	 */
	function isTextNode(object) {
	  return isNode(object) && object.nodeType == 3;
	}
	
	module.exports = isTextNode;

/***/ }),
/* 453 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	/**
	 * @param {*} object The object to check.
	 * @return {boolean} Whether or not the object is a DOM node.
	 */
	function isNode(object) {
	  var doc = object ? object.ownerDocument || object : document;
	  var defaultView = doc.defaultView || window;
	  return !!(object && (typeof defaultView.Node === 'function' ? object instanceof defaultView.Node : typeof object === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string'));
	}
	
	module.exports = isNode;

/***/ }),
/* 454 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	/* eslint-disable fb-www/typeof-undefined */
	
	/**
	 * Same as document.activeElement but wraps in a try-catch block. In IE it is
	 * not safe to call document.activeElement if there is nothing focused.
	 *
	 * The activeElement will be null only if the document or document body is not
	 * yet defined.
	 *
	 * @param {?DOMDocument} doc Defaults to current document.
	 * @return {?DOMElement}
	 */
	function getActiveElement(doc) /*?DOMElement*/{
	  doc = doc || (typeof document !== 'undefined' ? document : undefined);
	  if (typeof doc === 'undefined') {
	    return null;
	  }
	  try {
	    return doc.activeElement || doc.body;
	  } catch (e) {
	    return doc.body;
	  }
	}
	
	module.exports = getActiveElement;

/***/ }),
/* 455 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var NS = {
	  xlink: 'http://www.w3.org/1999/xlink',
	  xml: 'http://www.w3.org/XML/1998/namespace'
	};
	
	// We use attributes for everything SVG so let's avoid some duplication and run
	// code instead.
	// The following are all specified in the HTML config already so we exclude here.
	// - class (as className)
	// - color
	// - height
	// - id
	// - lang
	// - max
	// - media
	// - method
	// - min
	// - name
	// - style
	// - target
	// - type
	// - width
	var ATTRS = {
	  accentHeight: 'accent-height',
	  accumulate: 0,
	  additive: 0,
	  alignmentBaseline: 'alignment-baseline',
	  allowReorder: 'allowReorder',
	  alphabetic: 0,
	  amplitude: 0,
	  arabicForm: 'arabic-form',
	  ascent: 0,
	  attributeName: 'attributeName',
	  attributeType: 'attributeType',
	  autoReverse: 'autoReverse',
	  azimuth: 0,
	  baseFrequency: 'baseFrequency',
	  baseProfile: 'baseProfile',
	  baselineShift: 'baseline-shift',
	  bbox: 0,
	  begin: 0,
	  bias: 0,
	  by: 0,
	  calcMode: 'calcMode',
	  capHeight: 'cap-height',
	  clip: 0,
	  clipPath: 'clip-path',
	  clipRule: 'clip-rule',
	  clipPathUnits: 'clipPathUnits',
	  colorInterpolation: 'color-interpolation',
	  colorInterpolationFilters: 'color-interpolation-filters',
	  colorProfile: 'color-profile',
	  colorRendering: 'color-rendering',
	  contentScriptType: 'contentScriptType',
	  contentStyleType: 'contentStyleType',
	  cursor: 0,
	  cx: 0,
	  cy: 0,
	  d: 0,
	  decelerate: 0,
	  descent: 0,
	  diffuseConstant: 'diffuseConstant',
	  direction: 0,
	  display: 0,
	  divisor: 0,
	  dominantBaseline: 'dominant-baseline',
	  dur: 0,
	  dx: 0,
	  dy: 0,
	  edgeMode: 'edgeMode',
	  elevation: 0,
	  enableBackground: 'enable-background',
	  end: 0,
	  exponent: 0,
	  externalResourcesRequired: 'externalResourcesRequired',
	  fill: 0,
	  fillOpacity: 'fill-opacity',
	  fillRule: 'fill-rule',
	  filter: 0,
	  filterRes: 'filterRes',
	  filterUnits: 'filterUnits',
	  floodColor: 'flood-color',
	  floodOpacity: 'flood-opacity',
	  focusable: 0,
	  fontFamily: 'font-family',
	  fontSize: 'font-size',
	  fontSizeAdjust: 'font-size-adjust',
	  fontStretch: 'font-stretch',
	  fontStyle: 'font-style',
	  fontVariant: 'font-variant',
	  fontWeight: 'font-weight',
	  format: 0,
	  from: 0,
	  fx: 0,
	  fy: 0,
	  g1: 0,
	  g2: 0,
	  glyphName: 'glyph-name',
	  glyphOrientationHorizontal: 'glyph-orientation-horizontal',
	  glyphOrientationVertical: 'glyph-orientation-vertical',
	  glyphRef: 'glyphRef',
	  gradientTransform: 'gradientTransform',
	  gradientUnits: 'gradientUnits',
	  hanging: 0,
	  horizAdvX: 'horiz-adv-x',
	  horizOriginX: 'horiz-origin-x',
	  ideographic: 0,
	  imageRendering: 'image-rendering',
	  'in': 0,
	  in2: 0,
	  intercept: 0,
	  k: 0,
	  k1: 0,
	  k2: 0,
	  k3: 0,
	  k4: 0,
	  kernelMatrix: 'kernelMatrix',
	  kernelUnitLength: 'kernelUnitLength',
	  kerning: 0,
	  keyPoints: 'keyPoints',
	  keySplines: 'keySplines',
	  keyTimes: 'keyTimes',
	  lengthAdjust: 'lengthAdjust',
	  letterSpacing: 'letter-spacing',
	  lightingColor: 'lighting-color',
	  limitingConeAngle: 'limitingConeAngle',
	  local: 0,
	  markerEnd: 'marker-end',
	  markerMid: 'marker-mid',
	  markerStart: 'marker-start',
	  markerHeight: 'markerHeight',
	  markerUnits: 'markerUnits',
	  markerWidth: 'markerWidth',
	  mask: 0,
	  maskContentUnits: 'maskContentUnits',
	  maskUnits: 'maskUnits',
	  mathematical: 0,
	  mode: 0,
	  numOctaves: 'numOctaves',
	  offset: 0,
	  opacity: 0,
	  operator: 0,
	  order: 0,
	  orient: 0,
	  orientation: 0,
	  origin: 0,
	  overflow: 0,
	  overlinePosition: 'overline-position',
	  overlineThickness: 'overline-thickness',
	  paintOrder: 'paint-order',
	  panose1: 'panose-1',
	  pathLength: 'pathLength',
	  patternContentUnits: 'patternContentUnits',
	  patternTransform: 'patternTransform',
	  patternUnits: 'patternUnits',
	  pointerEvents: 'pointer-events',
	  points: 0,
	  pointsAtX: 'pointsAtX',
	  pointsAtY: 'pointsAtY',
	  pointsAtZ: 'pointsAtZ',
	  preserveAlpha: 'preserveAlpha',
	  preserveAspectRatio: 'preserveAspectRatio',
	  primitiveUnits: 'primitiveUnits',
	  r: 0,
	  radius: 0,
	  refX: 'refX',
	  refY: 'refY',
	  renderingIntent: 'rendering-intent',
	  repeatCount: 'repeatCount',
	  repeatDur: 'repeatDur',
	  requiredExtensions: 'requiredExtensions',
	  requiredFeatures: 'requiredFeatures',
	  restart: 0,
	  result: 0,
	  rotate: 0,
	  rx: 0,
	  ry: 0,
	  scale: 0,
	  seed: 0,
	  shapeRendering: 'shape-rendering',
	  slope: 0,
	  spacing: 0,
	  specularConstant: 'specularConstant',
	  specularExponent: 'specularExponent',
	  speed: 0,
	  spreadMethod: 'spreadMethod',
	  startOffset: 'startOffset',
	  stdDeviation: 'stdDeviation',
	  stemh: 0,
	  stemv: 0,
	  stitchTiles: 'stitchTiles',
	  stopColor: 'stop-color',
	  stopOpacity: 'stop-opacity',
	  strikethroughPosition: 'strikethrough-position',
	  strikethroughThickness: 'strikethrough-thickness',
	  string: 0,
	  stroke: 0,
	  strokeDasharray: 'stroke-dasharray',
	  strokeDashoffset: 'stroke-dashoffset',
	  strokeLinecap: 'stroke-linecap',
	  strokeLinejoin: 'stroke-linejoin',
	  strokeMiterlimit: 'stroke-miterlimit',
	  strokeOpacity: 'stroke-opacity',
	  strokeWidth: 'stroke-width',
	  surfaceScale: 'surfaceScale',
	  systemLanguage: 'systemLanguage',
	  tableValues: 'tableValues',
	  targetX: 'targetX',
	  targetY: 'targetY',
	  textAnchor: 'text-anchor',
	  textDecoration: 'text-decoration',
	  textRendering: 'text-rendering',
	  textLength: 'textLength',
	  to: 0,
	  transform: 0,
	  u1: 0,
	  u2: 0,
	  underlinePosition: 'underline-position',
	  underlineThickness: 'underline-thickness',
	  unicode: 0,
	  unicodeBidi: 'unicode-bidi',
	  unicodeRange: 'unicode-range',
	  unitsPerEm: 'units-per-em',
	  vAlphabetic: 'v-alphabetic',
	  vHanging: 'v-hanging',
	  vIdeographic: 'v-ideographic',
	  vMathematical: 'v-mathematical',
	  values: 0,
	  vectorEffect: 'vector-effect',
	  version: 0,
	  vertAdvY: 'vert-adv-y',
	  vertOriginX: 'vert-origin-x',
	  vertOriginY: 'vert-origin-y',
	  viewBox: 'viewBox',
	  viewTarget: 'viewTarget',
	  visibility: 0,
	  widths: 0,
	  wordSpacing: 'word-spacing',
	  writingMode: 'writing-mode',
	  x: 0,
	  xHeight: 'x-height',
	  x1: 0,
	  x2: 0,
	  xChannelSelector: 'xChannelSelector',
	  xlinkActuate: 'xlink:actuate',
	  xlinkArcrole: 'xlink:arcrole',
	  xlinkHref: 'xlink:href',
	  xlinkRole: 'xlink:role',
	  xlinkShow: 'xlink:show',
	  xlinkTitle: 'xlink:title',
	  xlinkType: 'xlink:type',
	  xmlBase: 'xml:base',
	  xmlns: 0,
	  xmlnsXlink: 'xmlns:xlink',
	  xmlLang: 'xml:lang',
	  xmlSpace: 'xml:space',
	  y: 0,
	  y1: 0,
	  y2: 0,
	  yChannelSelector: 'yChannelSelector',
	  z: 0,
	  zoomAndPan: 'zoomAndPan'
	};
	
	var SVGDOMPropertyConfig = {
	  Properties: {},
	  DOMAttributeNamespaces: {
	    xlinkActuate: NS.xlink,
	    xlinkArcrole: NS.xlink,
	    xlinkHref: NS.xlink,
	    xlinkRole: NS.xlink,
	    xlinkShow: NS.xlink,
	    xlinkTitle: NS.xlink,
	    xlinkType: NS.xlink,
	    xmlBase: NS.xml,
	    xmlLang: NS.xml,
	    xmlSpace: NS.xml
	  },
	  DOMAttributeNames: {}
	};
	
	Object.keys(ATTRS).forEach(function (key) {
	  SVGDOMPropertyConfig.Properties[key] = 0;
	  if (ATTRS[key]) {
	    SVGDOMPropertyConfig.DOMAttributeNames[key] = ATTRS[key];
	  }
	});
	
	module.exports = SVGDOMPropertyConfig;

/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var EventPropagators = __webpack_require__(342);
	var ExecutionEnvironment = __webpack_require__(351);
	var ReactDOMComponentTree = __webpack_require__(334);
	var ReactInputSelection = __webpack_require__(448);
	var SyntheticEvent = __webpack_require__(356);
	
	var getActiveElement = __webpack_require__(454);
	var isTextInputElement = __webpack_require__(369);
	var shallowEqual = __webpack_require__(424);
	
	var skipSelectionChangeEvent = ExecutionEnvironment.canUseDOM && 'documentMode' in document && document.documentMode <= 11;
	
	var eventTypes = {
	  select: {
	    phasedRegistrationNames: {
	      bubbled: 'onSelect',
	      captured: 'onSelectCapture'
	    },
	    dependencies: ['topBlur', 'topContextMenu', 'topFocus', 'topKeyDown', 'topKeyUp', 'topMouseDown', 'topMouseUp', 'topSelectionChange']
	  }
	};
	
	var activeElement = null;
	var activeElementInst = null;
	var lastSelection = null;
	var mouseDown = false;
	
	// Track whether a listener exists for this plugin. If none exist, we do
	// not extract events. See #3639.
	var hasListener = false;
	
	/**
	 * Get an object which is a unique representation of the current selection.
	 *
	 * The return value will not be consistent across nodes or browsers, but
	 * two identical selections on the same node will return identical objects.
	 *
	 * @param {DOMElement} node
	 * @return {object}
	 */
	function getSelection(node) {
	  if ('selectionStart' in node && ReactInputSelection.hasSelectionCapabilities(node)) {
	    return {
	      start: node.selectionStart,
	      end: node.selectionEnd
	    };
	  } else if (window.getSelection) {
	    var selection = window.getSelection();
	    return {
	      anchorNode: selection.anchorNode,
	      anchorOffset: selection.anchorOffset,
	      focusNode: selection.focusNode,
	      focusOffset: selection.focusOffset
	    };
	  } else if (document.selection) {
	    var range = document.selection.createRange();
	    return {
	      parentElement: range.parentElement(),
	      text: range.text,
	      top: range.boundingTop,
	      left: range.boundingLeft
	    };
	  }
	}
	
	/**
	 * Poll selection to see whether it's changed.
	 *
	 * @param {object} nativeEvent
	 * @return {?SyntheticEvent}
	 */
	function constructSelectEvent(nativeEvent, nativeEventTarget) {
	  // Ensure we have the right element, and that the user is not dragging a
	  // selection (this matches native `select` event behavior). In HTML5, select
	  // fires only on input and textarea thus if there's no focused element we
	  // won't dispatch.
	  if (mouseDown || activeElement == null || activeElement !== getActiveElement()) {
	    return null;
	  }
	
	  // Only fire when selection has actually changed.
	  var currentSelection = getSelection(activeElement);
	  if (!lastSelection || !shallowEqual(lastSelection, currentSelection)) {
	    lastSelection = currentSelection;
	
	    var syntheticEvent = SyntheticEvent.getPooled(eventTypes.select, activeElementInst, nativeEvent, nativeEventTarget);
	
	    syntheticEvent.type = 'select';
	    syntheticEvent.target = activeElement;
	
	    EventPropagators.accumulateTwoPhaseDispatches(syntheticEvent);
	
	    return syntheticEvent;
	  }
	
	  return null;
	}
	
	/**
	 * This plugin creates an `onSelect` event that normalizes select events
	 * across form elements.
	 *
	 * Supported elements are:
	 * - input (see `isTextInputElement`)
	 * - textarea
	 * - contentEditable
	 *
	 * This differs from native browser implementations in the following ways:
	 * - Fires on contentEditable fields as well as inputs.
	 * - Fires for collapsed selection.
	 * - Fires after user input.
	 */
	var SelectEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    if (!hasListener) {
	      return null;
	    }
	
	    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;
	
	    switch (topLevelType) {
	      // Track the input node that has focus.
	      case 'topFocus':
	        if (isTextInputElement(targetNode) || targetNode.contentEditable === 'true') {
	          activeElement = targetNode;
	          activeElementInst = targetInst;
	          lastSelection = null;
	        }
	        break;
	      case 'topBlur':
	        activeElement = null;
	        activeElementInst = null;
	        lastSelection = null;
	        break;
	
	      // Don't fire the event while the user is dragging. This matches the
	      // semantics of the native select event.
	      case 'topMouseDown':
	        mouseDown = true;
	        break;
	      case 'topContextMenu':
	      case 'topMouseUp':
	        mouseDown = false;
	        return constructSelectEvent(nativeEvent, nativeEventTarget);
	
	      // Chrome and IE fire non-standard event when selection is changed (and
	      // sometimes when it hasn't). IE's event fires out of order with respect
	      // to key and input events on deletion, so we discard it.
	      //
	      // Firefox doesn't support selectionchange, so check selection status
	      // after each key entry. The selection changes after keydown and before
	      // keyup, but we check on keydown as well in the case of holding down a
	      // key, when multiple keydown events are fired but only one keyup is.
	      // This is also our approach for IE handling, for the reason above.
	      case 'topSelectionChange':
	        if (skipSelectionChangeEvent) {
	          break;
	        }
	      // falls through
	      case 'topKeyDown':
	      case 'topKeyUp':
	        return constructSelectEvent(nativeEvent, nativeEventTarget);
	    }
	
	    return null;
	  },
	
	  didPutListener: function (inst, registrationName, listener) {
	    if (registrationName === 'onSelect') {
	      hasListener = true;
	    }
	  }
	};
	
	module.exports = SelectEventPlugin;

/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(335);
	
	var EventListener = __webpack_require__(444);
	var EventPropagators = __webpack_require__(342);
	var ReactDOMComponentTree = __webpack_require__(334);
	var SyntheticAnimationEvent = __webpack_require__(458);
	var SyntheticClipboardEvent = __webpack_require__(459);
	var SyntheticEvent = __webpack_require__(356);
	var SyntheticFocusEvent = __webpack_require__(460);
	var SyntheticKeyboardEvent = __webpack_require__(461);
	var SyntheticMouseEvent = __webpack_require__(372);
	var SyntheticDragEvent = __webpack_require__(464);
	var SyntheticTouchEvent = __webpack_require__(465);
	var SyntheticTransitionEvent = __webpack_require__(466);
	var SyntheticUIEvent = __webpack_require__(373);
	var SyntheticWheelEvent = __webpack_require__(467);
	
	var emptyFunction = __webpack_require__(348);
	var getEventCharCode = __webpack_require__(462);
	var invariant = __webpack_require__(337);
	
	/**
	 * Turns
	 * ['abort', ...]
	 * into
	 * eventTypes = {
	 *   'abort': {
	 *     phasedRegistrationNames: {
	 *       bubbled: 'onAbort',
	 *       captured: 'onAbortCapture',
	 *     },
	 *     dependencies: ['topAbort'],
	 *   },
	 *   ...
	 * };
	 * topLevelEventsToDispatchConfig = {
	 *   'topAbort': { sameConfig }
	 * };
	 */
	var eventTypes = {};
	var topLevelEventsToDispatchConfig = {};
	['abort', 'animationEnd', 'animationIteration', 'animationStart', 'blur', 'canPlay', 'canPlayThrough', 'click', 'contextMenu', 'copy', 'cut', 'doubleClick', 'drag', 'dragEnd', 'dragEnter', 'dragExit', 'dragLeave', 'dragOver', 'dragStart', 'drop', 'durationChange', 'emptied', 'encrypted', 'ended', 'error', 'focus', 'input', 'invalid', 'keyDown', 'keyPress', 'keyUp', 'load', 'loadedData', 'loadedMetadata', 'loadStart', 'mouseDown', 'mouseMove', 'mouseOut', 'mouseOver', 'mouseUp', 'paste', 'pause', 'play', 'playing', 'progress', 'rateChange', 'reset', 'scroll', 'seeked', 'seeking', 'stalled', 'submit', 'suspend', 'timeUpdate', 'touchCancel', 'touchEnd', 'touchMove', 'touchStart', 'transitionEnd', 'volumeChange', 'waiting', 'wheel'].forEach(function (event) {
	  var capitalizedEvent = event[0].toUpperCase() + event.slice(1);
	  var onEvent = 'on' + capitalizedEvent;
	  var topEvent = 'top' + capitalizedEvent;
	
	  var type = {
	    phasedRegistrationNames: {
	      bubbled: onEvent,
	      captured: onEvent + 'Capture'
	    },
	    dependencies: [topEvent]
	  };
	  eventTypes[event] = type;
	  topLevelEventsToDispatchConfig[topEvent] = type;
	});
	
	var onClickListeners = {};
	
	function getDictionaryKey(inst) {
	  // Prevents V8 performance issue:
	  // https://github.com/facebook/react/pull/7232
	  return '.' + inst._rootNodeID;
	}
	
	function isInteractive(tag) {
	  return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
	}
	
	var SimpleEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var dispatchConfig = topLevelEventsToDispatchConfig[topLevelType];
	    if (!dispatchConfig) {
	      return null;
	    }
	    var EventConstructor;
	    switch (topLevelType) {
	      case 'topAbort':
	      case 'topCanPlay':
	      case 'topCanPlayThrough':
	      case 'topDurationChange':
	      case 'topEmptied':
	      case 'topEncrypted':
	      case 'topEnded':
	      case 'topError':
	      case 'topInput':
	      case 'topInvalid':
	      case 'topLoad':
	      case 'topLoadedData':
	      case 'topLoadedMetadata':
	      case 'topLoadStart':
	      case 'topPause':
	      case 'topPlay':
	      case 'topPlaying':
	      case 'topProgress':
	      case 'topRateChange':
	      case 'topReset':
	      case 'topSeeked':
	      case 'topSeeking':
	      case 'topStalled':
	      case 'topSubmit':
	      case 'topSuspend':
	      case 'topTimeUpdate':
	      case 'topVolumeChange':
	      case 'topWaiting':
	        // HTML Events
	        // @see http://www.w3.org/TR/html5/index.html#events-0
	        EventConstructor = SyntheticEvent;
	        break;
	      case 'topKeyPress':
	        // Firefox creates a keypress event for function keys too. This removes
	        // the unwanted keypress events. Enter is however both printable and
	        // non-printable. One would expect Tab to be as well (but it isn't).
	        if (getEventCharCode(nativeEvent) === 0) {
	          return null;
	        }
	      /* falls through */
	      case 'topKeyDown':
	      case 'topKeyUp':
	        EventConstructor = SyntheticKeyboardEvent;
	        break;
	      case 'topBlur':
	      case 'topFocus':
	        EventConstructor = SyntheticFocusEvent;
	        break;
	      case 'topClick':
	        // Firefox creates a click event on right mouse clicks. This removes the
	        // unwanted click events.
	        if (nativeEvent.button === 2) {
	          return null;
	        }
	      /* falls through */
	      case 'topDoubleClick':
	      case 'topMouseDown':
	      case 'topMouseMove':
	      case 'topMouseUp':
	      // TODO: Disabled elements should not respond to mouse events
	      /* falls through */
	      case 'topMouseOut':
	      case 'topMouseOver':
	      case 'topContextMenu':
	        EventConstructor = SyntheticMouseEvent;
	        break;
	      case 'topDrag':
	      case 'topDragEnd':
	      case 'topDragEnter':
	      case 'topDragExit':
	      case 'topDragLeave':
	      case 'topDragOver':
	      case 'topDragStart':
	      case 'topDrop':
	        EventConstructor = SyntheticDragEvent;
	        break;
	      case 'topTouchCancel':
	      case 'topTouchEnd':
	      case 'topTouchMove':
	      case 'topTouchStart':
	        EventConstructor = SyntheticTouchEvent;
	        break;
	      case 'topAnimationEnd':
	      case 'topAnimationIteration':
	      case 'topAnimationStart':
	        EventConstructor = SyntheticAnimationEvent;
	        break;
	      case 'topTransitionEnd':
	        EventConstructor = SyntheticTransitionEvent;
	        break;
	      case 'topScroll':
	        EventConstructor = SyntheticUIEvent;
	        break;
	      case 'topWheel':
	        EventConstructor = SyntheticWheelEvent;
	        break;
	      case 'topCopy':
	      case 'topCut':
	      case 'topPaste':
	        EventConstructor = SyntheticClipboardEvent;
	        break;
	    }
	    !EventConstructor ?  false ? invariant(false, 'SimpleEventPlugin: Unhandled event type, `%s`.', topLevelType) : _prodInvariant('86', topLevelType) : void 0;
	    var event = EventConstructor.getPooled(dispatchConfig, targetInst, nativeEvent, nativeEventTarget);
	    EventPropagators.accumulateTwoPhaseDispatches(event);
	    return event;
	  },
	
	  didPutListener: function (inst, registrationName, listener) {
	    // Mobile Safari does not fire properly bubble click events on
	    // non-interactive elements, which means delegated click listeners do not
	    // fire. The workaround for this bug involves attaching an empty click
	    // listener on the target node.
	    // http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
	    if (registrationName === 'onClick' && !isInteractive(inst._tag)) {
	      var key = getDictionaryKey(inst);
	      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	      if (!onClickListeners[key]) {
	        onClickListeners[key] = EventListener.listen(node, 'click', emptyFunction);
	      }
	    }
	  },
	
	  willDeleteListener: function (inst, registrationName) {
	    if (registrationName === 'onClick' && !isInteractive(inst._tag)) {
	      var key = getDictionaryKey(inst);
	      onClickListeners[key].remove();
	      delete onClickListeners[key];
	    }
	  }
	
	};
	
	module.exports = SimpleEventPlugin;

/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(356);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/css3-animations/#AnimationEvent-interface
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/AnimationEvent
	 */
	var AnimationEventInterface = {
	  animationName: null,
	  elapsedTime: null,
	  pseudoElement: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticAnimationEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticAnimationEvent, AnimationEventInterface);
	
	module.exports = SyntheticAnimationEvent;

/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(356);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/clipboard-apis/
	 */
	var ClipboardEventInterface = {
	  clipboardData: function (event) {
	    return 'clipboardData' in event ? event.clipboardData : window.clipboardData;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticClipboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticClipboardEvent, ClipboardEventInterface);
	
	module.exports = SyntheticClipboardEvent;

/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(373);
	
	/**
	 * @interface FocusEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var FocusEventInterface = {
	  relatedTarget: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticFocusEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticFocusEvent, FocusEventInterface);
	
	module.exports = SyntheticFocusEvent;

/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(373);
	
	var getEventCharCode = __webpack_require__(462);
	var getEventKey = __webpack_require__(463);
	var getEventModifierState = __webpack_require__(375);
	
	/**
	 * @interface KeyboardEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var KeyboardEventInterface = {
	  key: getEventKey,
	  location: null,
	  ctrlKey: null,
	  shiftKey: null,
	  altKey: null,
	  metaKey: null,
	  repeat: null,
	  locale: null,
	  getModifierState: getEventModifierState,
	  // Legacy Interface
	  charCode: function (event) {
	    // `charCode` is the result of a KeyPress event and represents the value of
	    // the actual printable character.
	
	    // KeyPress is deprecated, but its replacement is not yet final and not
	    // implemented in any major browser. Only KeyPress has charCode.
	    if (event.type === 'keypress') {
	      return getEventCharCode(event);
	    }
	    return 0;
	  },
	  keyCode: function (event) {
	    // `keyCode` is the result of a KeyDown/Up event and represents the value of
	    // physical keyboard key.
	
	    // The actual meaning of the value depends on the users' keyboard layout
	    // which cannot be detected. Assuming that it is a US keyboard layout
	    // provides a surprisingly accurate mapping for US and European users.
	    // Due to this, it is left to the user to implement at this time.
	    if (event.type === 'keydown' || event.type === 'keyup') {
	      return event.keyCode;
	    }
	    return 0;
	  },
	  which: function (event) {
	    // `which` is an alias for either `keyCode` or `charCode` depending on the
	    // type of the event.
	    if (event.type === 'keypress') {
	      return getEventCharCode(event);
	    }
	    if (event.type === 'keydown' || event.type === 'keyup') {
	      return event.keyCode;
	    }
	    return 0;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticKeyboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticKeyboardEvent, KeyboardEventInterface);
	
	module.exports = SyntheticKeyboardEvent;

/***/ }),
/* 462 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * `charCode` represents the actual "character code" and is safe to use with
	 * `String.fromCharCode`. As such, only keys that correspond to printable
	 * characters produce a valid `charCode`, the only exception to this is Enter.
	 * The Tab-key is considered non-printable and does not have a `charCode`,
	 * presumably because it does not produce a tab-character in browsers.
	 *
	 * @param {object} nativeEvent Native browser event.
	 * @return {number} Normalized `charCode` property.
	 */
	
	function getEventCharCode(nativeEvent) {
	  var charCode;
	  var keyCode = nativeEvent.keyCode;
	
	  if ('charCode' in nativeEvent) {
	    charCode = nativeEvent.charCode;
	
	    // FF does not set `charCode` for the Enter-key, check against `keyCode`.
	    if (charCode === 0 && keyCode === 13) {
	      charCode = 13;
	    }
	  } else {
	    // IE8 does not implement `charCode`, but `keyCode` has the correct value.
	    charCode = keyCode;
	  }
	
	  // Some non-printable keys are reported in `charCode`/`keyCode`, discard them.
	  // Must not discard the (non-)printable Enter-key.
	  if (charCode >= 32 || charCode === 13) {
	    return charCode;
	  }
	
	  return 0;
	}
	
	module.exports = getEventCharCode;

/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var getEventCharCode = __webpack_require__(462);
	
	/**
	 * Normalization of deprecated HTML5 `key` values
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
	 */
	var normalizeKey = {
	  'Esc': 'Escape',
	  'Spacebar': ' ',
	  'Left': 'ArrowLeft',
	  'Up': 'ArrowUp',
	  'Right': 'ArrowRight',
	  'Down': 'ArrowDown',
	  'Del': 'Delete',
	  'Win': 'OS',
	  'Menu': 'ContextMenu',
	  'Apps': 'ContextMenu',
	  'Scroll': 'ScrollLock',
	  'MozPrintableKey': 'Unidentified'
	};
	
	/**
	 * Translation from legacy `keyCode` to HTML5 `key`
	 * Only special keys supported, all others depend on keyboard layout or browser
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
	 */
	var translateToKey = {
	  8: 'Backspace',
	  9: 'Tab',
	  12: 'Clear',
	  13: 'Enter',
	  16: 'Shift',
	  17: 'Control',
	  18: 'Alt',
	  19: 'Pause',
	  20: 'CapsLock',
	  27: 'Escape',
	  32: ' ',
	  33: 'PageUp',
	  34: 'PageDown',
	  35: 'End',
	  36: 'Home',
	  37: 'ArrowLeft',
	  38: 'ArrowUp',
	  39: 'ArrowRight',
	  40: 'ArrowDown',
	  45: 'Insert',
	  46: 'Delete',
	  112: 'F1', 113: 'F2', 114: 'F3', 115: 'F4', 116: 'F5', 117: 'F6',
	  118: 'F7', 119: 'F8', 120: 'F9', 121: 'F10', 122: 'F11', 123: 'F12',
	  144: 'NumLock',
	  145: 'ScrollLock',
	  224: 'Meta'
	};
	
	/**
	 * @param {object} nativeEvent Native browser event.
	 * @return {string} Normalized `key` property.
	 */
	function getEventKey(nativeEvent) {
	  if (nativeEvent.key) {
	    // Normalize inconsistent values reported by browsers due to
	    // implementations of a working draft specification.
	
	    // FireFox implements `key` but returns `MozPrintableKey` for all
	    // printable characters (normalized to `Unidentified`), ignore it.
	    var key = normalizeKey[nativeEvent.key] || nativeEvent.key;
	    if (key !== 'Unidentified') {
	      return key;
	    }
	  }
	
	  // Browser does not implement `key`, polyfill as much of it as we can.
	  if (nativeEvent.type === 'keypress') {
	    var charCode = getEventCharCode(nativeEvent);
	
	    // The enter-key is technically both printable and non-printable and can
	    // thus be captured by `keypress`, no other non-printable key should.
	    return charCode === 13 ? 'Enter' : String.fromCharCode(charCode);
	  }
	  if (nativeEvent.type === 'keydown' || nativeEvent.type === 'keyup') {
	    // While user keyboard layout determines the actual meaning of each
	    // `keyCode` value, almost all function keys have a universal value.
	    return translateToKey[nativeEvent.keyCode] || 'Unidentified';
	  }
	  return '';
	}
	
	module.exports = getEventKey;

/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticMouseEvent = __webpack_require__(372);
	
	/**
	 * @interface DragEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var DragEventInterface = {
	  dataTransfer: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticDragEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticMouseEvent.augmentClass(SyntheticDragEvent, DragEventInterface);
	
	module.exports = SyntheticDragEvent;

/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(373);
	
	var getEventModifierState = __webpack_require__(375);
	
	/**
	 * @interface TouchEvent
	 * @see http://www.w3.org/TR/touch-events/
	 */
	var TouchEventInterface = {
	  touches: null,
	  targetTouches: null,
	  changedTouches: null,
	  altKey: null,
	  metaKey: null,
	  ctrlKey: null,
	  shiftKey: null,
	  getModifierState: getEventModifierState
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticTouchEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticTouchEvent, TouchEventInterface);
	
	module.exports = SyntheticTouchEvent;

/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(356);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/2009/WD-css3-transitions-20090320/#transition-events-
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/TransitionEvent
	 */
	var TransitionEventInterface = {
	  propertyName: null,
	  elapsedTime: null,
	  pseudoElement: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticTransitionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticTransitionEvent, TransitionEventInterface);
	
	module.exports = SyntheticTransitionEvent;

/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticMouseEvent = __webpack_require__(372);
	
	/**
	 * @interface WheelEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var WheelEventInterface = {
	  deltaX: function (event) {
	    return 'deltaX' in event ? event.deltaX :
	    // Fallback to `wheelDeltaX` for Webkit and normalize (right is positive).
	    'wheelDeltaX' in event ? -event.wheelDeltaX : 0;
	  },
	  deltaY: function (event) {
	    return 'deltaY' in event ? event.deltaY :
	    // Fallback to `wheelDeltaY` for Webkit and normalize (down is positive).
	    'wheelDeltaY' in event ? -event.wheelDeltaY :
	    // Fallback to `wheelDelta` for IE<9 and normalize (down is positive).
	    'wheelDelta' in event ? -event.wheelDelta : 0;
	  },
	  deltaZ: null,
	
	  // Browsers without "deltaMode" is reporting in raw wheel delta where one
	  // notch on the scroll is always +/- 120, roughly equivalent to pixels.
	  // A good approximation of DOM_DELTA_LINE (1) is 5% of viewport size or
	  // ~40 pixels, for DOM_DELTA_SCREEN (2) it is 87.5% of viewport size.
	  deltaMode: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticMouseEvent}
	 */
	function SyntheticWheelEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticMouseEvent.augmentClass(SyntheticWheelEvent, WheelEventInterface);
	
	module.exports = SyntheticWheelEvent;

/***/ }),
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(335);
	
	var DOMLazyTree = __webpack_require__(379);
	var DOMProperty = __webpack_require__(336);
	var React = __webpack_require__(301);
	var ReactBrowserEventEmitter = __webpack_require__(403);
	var ReactCurrentOwner = __webpack_require__(308);
	var ReactDOMComponentTree = __webpack_require__(334);
	var ReactDOMContainerInfo = __webpack_require__(469);
	var ReactDOMFeatureFlags = __webpack_require__(470);
	var ReactFeatureFlags = __webpack_require__(361);
	var ReactInstanceMap = __webpack_require__(418);
	var ReactInstrumentation = __webpack_require__(365);
	var ReactMarkupChecksum = __webpack_require__(471);
	var ReactReconciler = __webpack_require__(362);
	var ReactUpdateQueue = __webpack_require__(437);
	var ReactUpdates = __webpack_require__(359);
	
	var emptyObject = __webpack_require__(423);
	var instantiateReactComponent = __webpack_require__(420);
	var invariant = __webpack_require__(337);
	var setInnerHTML = __webpack_require__(381);
	var shouldUpdateReactComponent = __webpack_require__(425);
	var warning = __webpack_require__(347);
	
	var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
	var ROOT_ATTR_NAME = DOMProperty.ROOT_ATTRIBUTE_NAME;
	
	var ELEMENT_NODE_TYPE = 1;
	var DOC_NODE_TYPE = 9;
	var DOCUMENT_FRAGMENT_NODE_TYPE = 11;
	
	var instancesByReactRootID = {};
	
	/**
	 * Finds the index of the first character
	 * that's not common between the two given strings.
	 *
	 * @return {number} the index of the character where the strings diverge
	 */
	function firstDifferenceIndex(string1, string2) {
	  var minLen = Math.min(string1.length, string2.length);
	  for (var i = 0; i < minLen; i++) {
	    if (string1.charAt(i) !== string2.charAt(i)) {
	      return i;
	    }
	  }
	  return string1.length === string2.length ? -1 : minLen;
	}
	
	/**
	 * @param {DOMElement|DOMDocument} container DOM element that may contain
	 * a React component
	 * @return {?*} DOM element that may have the reactRoot ID, or null.
	 */
	function getReactRootElementInContainer(container) {
	  if (!container) {
	    return null;
	  }
	
	  if (container.nodeType === DOC_NODE_TYPE) {
	    return container.documentElement;
	  } else {
	    return container.firstChild;
	  }
	}
	
	function internalGetID(node) {
	  // If node is something like a window, document, or text node, none of
	  // which support attributes or a .getAttribute method, gracefully return
	  // the empty string, as if the attribute were missing.
	  return node.getAttribute && node.getAttribute(ATTR_NAME) || '';
	}
	
	/**
	 * Mounts this component and inserts it into the DOM.
	 *
	 * @param {ReactComponent} componentInstance The instance to mount.
	 * @param {DOMElement} container DOM element to mount into.
	 * @param {ReactReconcileTransaction} transaction
	 * @param {boolean} shouldReuseMarkup If true, do not insert markup
	 */
	function mountComponentIntoNode(wrapperInstance, container, transaction, shouldReuseMarkup, context) {
	  var markerName;
	  if (ReactFeatureFlags.logTopLevelRenders) {
	    var wrappedElement = wrapperInstance._currentElement.props.child;
	    var type = wrappedElement.type;
	    markerName = 'React mount: ' + (typeof type === 'string' ? type : type.displayName || type.name);
	    console.time(markerName);
	  }
	
	  var markup = ReactReconciler.mountComponent(wrapperInstance, transaction, null, ReactDOMContainerInfo(wrapperInstance, container), context, 0 /* parentDebugID */
	  );
	
	  if (markerName) {
	    console.timeEnd(markerName);
	  }
	
	  wrapperInstance._renderedComponent._topLevelWrapper = wrapperInstance;
	  ReactMount._mountImageIntoNode(markup, container, wrapperInstance, shouldReuseMarkup, transaction);
	}
	
	/**
	 * Batched mount.
	 *
	 * @param {ReactComponent} componentInstance The instance to mount.
	 * @param {DOMElement} container DOM element to mount into.
	 * @param {boolean} shouldReuseMarkup If true, do not insert markup
	 */
	function batchedMountComponentIntoNode(componentInstance, container, shouldReuseMarkup, context) {
	  var transaction = ReactUpdates.ReactReconcileTransaction.getPooled(
	  /* useCreateElement */
	  !shouldReuseMarkup && ReactDOMFeatureFlags.useCreateElement);
	  transaction.perform(mountComponentIntoNode, null, componentInstance, container, transaction, shouldReuseMarkup, context);
	  ReactUpdates.ReactReconcileTransaction.release(transaction);
	}
	
	/**
	 * Unmounts a component and removes it from the DOM.
	 *
	 * @param {ReactComponent} instance React component instance.
	 * @param {DOMElement} container DOM element to unmount from.
	 * @final
	 * @internal
	 * @see {ReactMount.unmountComponentAtNode}
	 */
	function unmountComponentFromNode(instance, container, safely) {
	  if (false) {
	    ReactInstrumentation.debugTool.onBeginFlush();
	  }
	  ReactReconciler.unmountComponent(instance, safely);
	  if (false) {
	    ReactInstrumentation.debugTool.onEndFlush();
	  }
	
	  if (container.nodeType === DOC_NODE_TYPE) {
	    container = container.documentElement;
	  }
	
	  // http://jsperf.com/emptying-a-node
	  while (container.lastChild) {
	    container.removeChild(container.lastChild);
	  }
	}
	
	/**
	 * True if the supplied DOM node has a direct React-rendered child that is
	 * not a React root element. Useful for warning in `render`,
	 * `unmountComponentAtNode`, etc.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM element contains a direct child that was
	 * rendered by React but is not a root element.
	 * @internal
	 */
	function hasNonRootReactChild(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  if (rootEl) {
	    var inst = ReactDOMComponentTree.getInstanceFromNode(rootEl);
	    return !!(inst && inst._hostParent);
	  }
	}
	
	/**
	 * True if the supplied DOM node is a React DOM element and
	 * it has been rendered by another copy of React.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM has been rendered by another copy of React
	 * @internal
	 */
	function nodeIsRenderedByOtherInstance(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  return !!(rootEl && isReactNode(rootEl) && !ReactDOMComponentTree.getInstanceFromNode(rootEl));
	}
	
	/**
	 * True if the supplied DOM node is a valid node element.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM is a valid DOM node.
	 * @internal
	 */
	function isValidContainer(node) {
	  return !!(node && (node.nodeType === ELEMENT_NODE_TYPE || node.nodeType === DOC_NODE_TYPE || node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE));
	}
	
	/**
	 * True if the supplied DOM node is a valid React node element.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM is a valid React DOM node.
	 * @internal
	 */
	function isReactNode(node) {
	  return isValidContainer(node) && (node.hasAttribute(ROOT_ATTR_NAME) || node.hasAttribute(ATTR_NAME));
	}
	
	function getHostRootInstanceInContainer(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  var prevHostInstance = rootEl && ReactDOMComponentTree.getInstanceFromNode(rootEl);
	  return prevHostInstance && !prevHostInstance._hostParent ? prevHostInstance : null;
	}
	
	function getTopLevelWrapperInContainer(container) {
	  var root = getHostRootInstanceInContainer(container);
	  return root ? root._hostContainerInfo._topLevelWrapper : null;
	}
	
	/**
	 * Temporary (?) hack so that we can store all top-level pending updates on
	 * composites instead of having to worry about different types of components
	 * here.
	 */
	var topLevelRootCounter = 1;
	var TopLevelWrapper = function () {
	  this.rootID = topLevelRootCounter++;
	};
	TopLevelWrapper.prototype.isReactComponent = {};
	if (false) {
	  TopLevelWrapper.displayName = 'TopLevelWrapper';
	}
	TopLevelWrapper.prototype.render = function () {
	  return this.props.child;
	};
	TopLevelWrapper.isReactTopLevelWrapper = true;
	
	/**
	 * Mounting is the process of initializing a React component by creating its
	 * representative DOM elements and inserting them into a supplied `container`.
	 * Any prior content inside `container` is destroyed in the process.
	 *
	 *   ReactMount.render(
	 *     component,
	 *     document.getElementById('container')
	 *   );
	 *
	 *   <div id="container">                   <-- Supplied `container`.
	 *     <div data-reactid=".3">              <-- Rendered reactRoot of React
	 *       // ...                                 component.
	 *     </div>
	 *   </div>
	 *
	 * Inside of `container`, the first element rendered is the "reactRoot".
	 */
	var ReactMount = {
	
	  TopLevelWrapper: TopLevelWrapper,
	
	  /**
	   * Used by devtools. The keys are not important.
	   */
	  _instancesByReactRootID: instancesByReactRootID,
	
	  /**
	   * This is a hook provided to support rendering React components while
	   * ensuring that the apparent scroll position of its `container` does not
	   * change.
	   *
	   * @param {DOMElement} container The `container` being rendered into.
	   * @param {function} renderCallback This must be called once to do the render.
	   */
	  scrollMonitor: function (container, renderCallback) {
	    renderCallback();
	  },
	
	  /**
	   * Take a component that's already mounted into the DOM and replace its props
	   * @param {ReactComponent} prevComponent component instance already in the DOM
	   * @param {ReactElement} nextElement component instance to render
	   * @param {DOMElement} container container to render into
	   * @param {?function} callback function triggered on completion
	   */
	  _updateRootComponent: function (prevComponent, nextElement, nextContext, container, callback) {
	    ReactMount.scrollMonitor(container, function () {
	      ReactUpdateQueue.enqueueElementInternal(prevComponent, nextElement, nextContext);
	      if (callback) {
	        ReactUpdateQueue.enqueueCallbackInternal(prevComponent, callback);
	      }
	    });
	
	    return prevComponent;
	  },
	
	  /**
	   * Render a new component into the DOM. Hooked by hooks!
	   *
	   * @param {ReactElement} nextElement element to render
	   * @param {DOMElement} container container to render into
	   * @param {boolean} shouldReuseMarkup if we should skip the markup insertion
	   * @return {ReactComponent} nextComponent
	   */
	  _renderNewRootComponent: function (nextElement, container, shouldReuseMarkup, context) {
	    // Various parts of our code (such as ReactCompositeComponent's
	    // _renderValidatedComponent) assume that calls to render aren't nested;
	    // verify that that's the case.
	     false ? warning(ReactCurrentOwner.current == null, '_renderNewRootComponent(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from ' + 'render is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;
	
	    !isValidContainer(container) ?  false ? invariant(false, '_registerComponent(...): Target container is not a DOM element.') : _prodInvariant('37') : void 0;
	
	    ReactBrowserEventEmitter.ensureScrollValueMonitoring();
	    var componentInstance = instantiateReactComponent(nextElement, false);
	
	    // The initial render is synchronous but any updates that happen during
	    // rendering, in componentWillMount or componentDidMount, will be batched
	    // according to the current batching strategy.
	
	    ReactUpdates.batchedUpdates(batchedMountComponentIntoNode, componentInstance, container, shouldReuseMarkup, context);
	
	    var wrapperID = componentInstance._instance.rootID;
	    instancesByReactRootID[wrapperID] = componentInstance;
	
	    return componentInstance;
	  },
	
	  /**
	   * Renders a React component into the DOM in the supplied `container`.
	   *
	   * If the React component was previously rendered into `container`, this will
	   * perform an update on it and only mutate the DOM as necessary to reflect the
	   * latest React component.
	   *
	   * @param {ReactComponent} parentComponent The conceptual parent of this render tree.
	   * @param {ReactElement} nextElement Component element to render.
	   * @param {DOMElement} container DOM element to render into.
	   * @param {?function} callback function triggered on completion
	   * @return {ReactComponent} Component instance rendered in `container`.
	   */
	  renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
	    !(parentComponent != null && ReactInstanceMap.has(parentComponent)) ?  false ? invariant(false, 'parentComponent must be a valid React Component') : _prodInvariant('38') : void 0;
	    return ReactMount._renderSubtreeIntoContainer(parentComponent, nextElement, container, callback);
	  },
	
	  _renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
	    ReactUpdateQueue.validateCallback(callback, 'ReactDOM.render');
	    !React.isValidElement(nextElement) ?  false ? invariant(false, 'ReactDOM.render(): Invalid component element.%s', typeof nextElement === 'string' ? ' Instead of passing a string like \'div\', pass ' + 'React.createElement(\'div\') or <div />.' : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' :
	    // Check if it quacks like an element
	    nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : _prodInvariant('39', typeof nextElement === 'string' ? ' Instead of passing a string like \'div\', pass ' + 'React.createElement(\'div\') or <div />.' : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' : nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : void 0;
	
	     false ? warning(!container || !container.tagName || container.tagName.toUpperCase() !== 'BODY', 'render(): Rendering components directly into document.body is ' + 'discouraged, since its children are often manipulated by third-party ' + 'scripts and browser extensions. This may lead to subtle ' + 'reconciliation issues. Try rendering into a container element created ' + 'for your app.') : void 0;
	
	    var nextWrappedElement = React.createElement(TopLevelWrapper, { child: nextElement });
	
	    var nextContext;
	    if (parentComponent) {
	      var parentInst = ReactInstanceMap.get(parentComponent);
	      nextContext = parentInst._processChildContext(parentInst._context);
	    } else {
	      nextContext = emptyObject;
	    }
	
	    var prevComponent = getTopLevelWrapperInContainer(container);
	
	    if (prevComponent) {
	      var prevWrappedElement = prevComponent._currentElement;
	      var prevElement = prevWrappedElement.props.child;
	      if (shouldUpdateReactComponent(prevElement, nextElement)) {
	        var publicInst = prevComponent._renderedComponent.getPublicInstance();
	        var updatedCallback = callback && function () {
	          callback.call(publicInst);
	        };
	        ReactMount._updateRootComponent(prevComponent, nextWrappedElement, nextContext, container, updatedCallback);
	        return publicInst;
	      } else {
	        ReactMount.unmountComponentAtNode(container);
	      }
	    }
	
	    var reactRootElement = getReactRootElementInContainer(container);
	    var containerHasReactMarkup = reactRootElement && !!internalGetID(reactRootElement);
	    var containerHasNonRootReactChild = hasNonRootReactChild(container);
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, 'render(...): Replacing React-rendered children with a new root ' + 'component. If you intended to update the children of this node, ' + 'you should instead have the existing children update their state ' + 'and render the new components instead of calling ReactDOM.render.') : void 0;
	
	      if (!containerHasReactMarkup || reactRootElement.nextSibling) {
	        var rootElementSibling = reactRootElement;
	        while (rootElementSibling) {
	          if (internalGetID(rootElementSibling)) {
	            process.env.NODE_ENV !== 'production' ? warning(false, 'render(): Target node has markup rendered by React, but there ' + 'are unrelated nodes as well. This is most commonly caused by ' + 'white-space inserted around server-rendered markup.') : void 0;
	            break;
	          }
	          rootElementSibling = rootElementSibling.nextSibling;
	        }
	      }
	    }
	
	    var shouldReuseMarkup = containerHasReactMarkup && !prevComponent && !containerHasNonRootReactChild;
	    var component = ReactMount._renderNewRootComponent(nextWrappedElement, container, shouldReuseMarkup, nextContext)._renderedComponent.getPublicInstance();
	    if (callback) {
	      callback.call(component);
	    }
	    return component;
	  },
	
	  /**
	   * Renders a React component into the DOM in the supplied `container`.
	   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.render
	   *
	   * If the React component was previously rendered into `container`, this will
	   * perform an update on it and only mutate the DOM as necessary to reflect the
	   * latest React component.
	   *
	   * @param {ReactElement} nextElement Component element to render.
	   * @param {DOMElement} container DOM element to render into.
	   * @param {?function} callback function triggered on completion
	   * @return {ReactComponent} Component instance rendered in `container`.
	   */
	  render: function (nextElement, container, callback) {
	    return ReactMount._renderSubtreeIntoContainer(null, nextElement, container, callback);
	  },
	
	  /**
	   * Unmounts and destroys the React component rendered in the `container`.
	   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.unmountcomponentatnode
	   *
	   * @param {DOMElement} container DOM element containing a React component.
	   * @return {boolean} True if a component was found in and unmounted from
	   *                   `container`
	   */
	  unmountComponentAtNode: function (container) {
	    // Various parts of our code (such as ReactCompositeComponent's
	    // _renderValidatedComponent) assume that calls to render aren't nested;
	    // verify that that's the case. (Strictly speaking, unmounting won't cause a
	    // render but we still don't expect to be in a render call here.)
	     false ? warning(ReactCurrentOwner.current == null, 'unmountComponentAtNode(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from render ' + 'is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;
	
	    !isValidContainer(container) ?  false ? invariant(false, 'unmountComponentAtNode(...): Target container is not a DOM element.') : _prodInvariant('40') : void 0;
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(!nodeIsRenderedByOtherInstance(container), 'unmountComponentAtNode(): The node you\'re attempting to unmount ' + 'was rendered by another copy of React.') : void 0;
	    }
	
	    var prevComponent = getTopLevelWrapperInContainer(container);
	    if (!prevComponent) {
	      // Check if the node being unmounted was rendered by React, but isn't a
	      // root node.
	      var containerHasNonRootReactChild = hasNonRootReactChild(container);
	
	      // Check if the container itself is a React root node.
	      var isContainerReactRoot = container.nodeType === 1 && container.hasAttribute(ROOT_ATTR_NAME);
	
	      if (false) {
	        process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, 'unmountComponentAtNode(): The node you\'re attempting to unmount ' + 'was rendered by React and is not a top-level container. %s', isContainerReactRoot ? 'You may have accidentally passed in a React root node instead ' + 'of its container.' : 'Instead, have the parent component update its state and ' + 'rerender in order to remove this component.') : void 0;
	      }
	
	      return false;
	    }
	    delete instancesByReactRootID[prevComponent._instance.rootID];
	    ReactUpdates.batchedUpdates(unmountComponentFromNode, prevComponent, container, false);
	    return true;
	  },
	
	  _mountImageIntoNode: function (markup, container, instance, shouldReuseMarkup, transaction) {
	    !isValidContainer(container) ?  false ? invariant(false, 'mountComponentIntoNode(...): Target container is not valid.') : _prodInvariant('41') : void 0;
	
	    if (shouldReuseMarkup) {
	      var rootElement = getReactRootElementInContainer(container);
	      if (ReactMarkupChecksum.canReuseMarkup(markup, rootElement)) {
	        ReactDOMComponentTree.precacheNode(instance, rootElement);
	        return;
	      } else {
	        var checksum = rootElement.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	        rootElement.removeAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	
	        var rootMarkup = rootElement.outerHTML;
	        rootElement.setAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME, checksum);
	
	        var normalizedMarkup = markup;
	        if (false) {
	          // because rootMarkup is retrieved from the DOM, various normalizations
	          // will have occurred which will not be present in `markup`. Here,
	          // insert markup into a <div> or <iframe> depending on the container
	          // type to perform the same normalizations before comparing.
	          var normalizer;
	          if (container.nodeType === ELEMENT_NODE_TYPE) {
	            normalizer = document.createElement('div');
	            normalizer.innerHTML = markup;
	            normalizedMarkup = normalizer.innerHTML;
	          } else {
	            normalizer = document.createElement('iframe');
	            document.body.appendChild(normalizer);
	            normalizer.contentDocument.write(markup);
	            normalizedMarkup = normalizer.contentDocument.documentElement.outerHTML;
	            document.body.removeChild(normalizer);
	          }
	        }
	
	        var diffIndex = firstDifferenceIndex(normalizedMarkup, rootMarkup);
	        var difference = ' (client) ' + normalizedMarkup.substring(diffIndex - 20, diffIndex + 20) + '\n (server) ' + rootMarkup.substring(diffIndex - 20, diffIndex + 20);
	
	        !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document using server rendering but the checksum was invalid. This usually means you rendered a different component type or props on the client from the one on the server, or your render() methods are impure. React cannot handle this case due to cross-browser quirks by rendering at the document root. You should look for environment dependent code in your components and ensure the props are the same client and server side:\n%s', difference) : _prodInvariant('42', difference) : void 0;
	
	        if (false) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'React attempted to reuse markup in a container but the ' + 'checksum was invalid. This generally means that you are ' + 'using server rendering and the markup generated on the ' + 'server was not what the client was expecting. React injected ' + 'new markup to compensate which works but you have lost many ' + 'of the benefits of server rendering. Instead, figure out ' + 'why the markup being generated is different on the client ' + 'or server:\n%s', difference) : void 0;
	        }
	      }
	    }
	
	    !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document but you didn\'t use server rendering. We can\'t do this without using server rendering due to cross-browser quirks. See ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('43') : void 0;
	
	    if (transaction.useCreateElement) {
	      while (container.lastChild) {
	        container.removeChild(container.lastChild);
	      }
	      DOMLazyTree.insertTreeBefore(container, markup, null);
	    } else {
	      setInnerHTML(container, markup);
	      ReactDOMComponentTree.precacheNode(instance, container.firstChild);
	    }
	
	    if (false) {
	      var hostNode = ReactDOMComponentTree.getInstanceFromNode(container.firstChild);
	      if (hostNode._debugID !== 0) {
	        ReactInstrumentation.debugTool.onHostOperation({
	          instanceID: hostNode._debugID,
	          type: 'mount',
	          payload: markup.toString()
	        });
	      }
	    }
	  }
	};
	
	module.exports = ReactMount;

/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var validateDOMNesting = __webpack_require__(438);
	
	var DOC_NODE_TYPE = 9;
	
	function ReactDOMContainerInfo(topLevelWrapper, node) {
	  var info = {
	    _topLevelWrapper: topLevelWrapper,
	    _idCounter: 1,
	    _ownerDocument: node ? node.nodeType === DOC_NODE_TYPE ? node : node.ownerDocument : null,
	    _node: node,
	    _tag: node ? node.nodeName.toLowerCase() : null,
	    _namespaceURI: node ? node.namespaceURI : null
	  };
	  if (false) {
	    info._ancestorInfo = node ? validateDOMNesting.updatedAncestorInfo(null, info._tag, null) : null;
	  }
	  return info;
	}
	
	module.exports = ReactDOMContainerInfo;

/***/ }),
/* 470 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactDOMFeatureFlags = {
	  useCreateElement: true,
	  useFiber: false
	};
	
	module.exports = ReactDOMFeatureFlags;

/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var adler32 = __webpack_require__(472);
	
	var TAG_END = /\/?>/;
	var COMMENT_START = /^<\!\-\-/;
	
	var ReactMarkupChecksum = {
	  CHECKSUM_ATTR_NAME: 'data-react-checksum',
	
	  /**
	   * @param {string} markup Markup string
	   * @return {string} Markup string with checksum attribute attached
	   */
	  addChecksumToMarkup: function (markup) {
	    var checksum = adler32(markup);
	
	    // Add checksum (handle both parent tags, comments and self-closing tags)
	    if (COMMENT_START.test(markup)) {
	      return markup;
	    } else {
	      return markup.replace(TAG_END, ' ' + ReactMarkupChecksum.CHECKSUM_ATTR_NAME + '="' + checksum + '"$&');
	    }
	  },
	
	  /**
	   * @param {string} markup to use
	   * @param {DOMElement} element root React element
	   * @returns {boolean} whether or not the markup is the same
	   */
	  canReuseMarkup: function (markup, element) {
	    var existingChecksum = element.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	    existingChecksum = existingChecksum && parseInt(existingChecksum, 10);
	    var markupChecksum = adler32(markup);
	    return markupChecksum === existingChecksum;
	  }
	};
	
	module.exports = ReactMarkupChecksum;

/***/ }),
/* 472 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var MOD = 65521;
	
	// adler32 is not cryptographically strong, and is only used to sanity check that
	// markup generated on the server matches the markup generated on the client.
	// This implementation (a modified version of the SheetJS version) has been optimized
	// for our use case, at the expense of conforming to the adler32 specification
	// for non-ascii inputs.
	function adler32(data) {
	  var a = 1;
	  var b = 0;
	  var i = 0;
	  var l = data.length;
	  var m = l & ~0x3;
	  while (i < m) {
	    var n = Math.min(i + 4096, m);
	    for (; i < n; i += 4) {
	      b += (a += data.charCodeAt(i)) + (a += data.charCodeAt(i + 1)) + (a += data.charCodeAt(i + 2)) + (a += data.charCodeAt(i + 3));
	    }
	    a %= MOD;
	    b %= MOD;
	  }
	  for (; i < l; i++) {
	    b += a += data.charCodeAt(i);
	  }
	  a %= MOD;
	  b %= MOD;
	  return a | b << 16;
	}
	
	module.exports = adler32;

/***/ }),
/* 473 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	module.exports = '15.5.4';

/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(335);
	
	var ReactCurrentOwner = __webpack_require__(308);
	var ReactDOMComponentTree = __webpack_require__(334);
	var ReactInstanceMap = __webpack_require__(418);
	
	var getHostComponentFromComposite = __webpack_require__(475);
	var invariant = __webpack_require__(337);
	var warning = __webpack_require__(347);
	
	/**
	 * Returns the DOM node rendered by this element.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.finddomnode
	 *
	 * @param {ReactComponent|DOMElement} componentOrElement
	 * @return {?DOMElement} The root node of this element.
	 */
	function findDOMNode(componentOrElement) {
	  if (false) {
	    var owner = ReactCurrentOwner.current;
	    if (owner !== null) {
	      process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing findDOMNode inside its render(). ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
	      owner._warnedAboutRefsInRender = true;
	    }
	  }
	  if (componentOrElement == null) {
	    return null;
	  }
	  if (componentOrElement.nodeType === 1) {
	    return componentOrElement;
	  }
	
	  var inst = ReactInstanceMap.get(componentOrElement);
	  if (inst) {
	    inst = getHostComponentFromComposite(inst);
	    return inst ? ReactDOMComponentTree.getNodeFromInstance(inst) : null;
	  }
	
	  if (typeof componentOrElement.render === 'function') {
	     true ?  false ? invariant(false, 'findDOMNode was called on an unmounted component.') : _prodInvariant('44') : void 0;
	  } else {
	     true ?  false ? invariant(false, 'Element appears to be neither ReactComponent nor DOMNode (keys: %s)', Object.keys(componentOrElement)) : _prodInvariant('45', Object.keys(componentOrElement)) : void 0;
	  }
	}
	
	module.exports = findDOMNode;

/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactNodeTypes = __webpack_require__(422);
	
	function getHostComponentFromComposite(inst) {
	  var type;
	
	  while ((type = inst._renderedNodeType) === ReactNodeTypes.COMPOSITE) {
	    inst = inst._renderedComponent;
	  }
	
	  if (type === ReactNodeTypes.HOST) {
	    return inst._renderedComponent;
	  } else if (type === ReactNodeTypes.EMPTY) {
	    return null;
	  }
	}
	
	module.exports = getHostComponentFromComposite;

/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactMount = __webpack_require__(468);
	
	module.exports = ReactMount.renderSubtreeIntoContainer;

/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

	var invariant = __webpack_require__(478);
	var defaultClickRejectionStrategy = __webpack_require__(479);
	
	var alreadyInjected = false;
	
	module.exports = function injectTapEventPlugin (strategyOverrides) {
	  strategyOverrides = strategyOverrides || {}
	  var shouldRejectClick = strategyOverrides.shouldRejectClick || defaultClickRejectionStrategy;
	
	  if (false) {
	    invariant(
	      !alreadyInjected,
	      'injectTapEventPlugin(): Can only be called once per application lifecycle.\n\n\
	It is recommended to call injectTapEventPlugin() just before you call \
	ReactDOM.render(). If you are using an external library which calls injectTapEventPlugin() \
	itself, please contact the maintainer as it shouldn\'t be called in library code and \
	should be injected by the application.'
	    )
	  }
	
	  alreadyInjected = true;
	
	  __webpack_require__(343).injection.injectEventPluginsByName({
	    'TapEventPlugin':       __webpack_require__(480)(shouldRejectClick)
	  });
	};


/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var validateFormat = function validateFormat(format) {};
	
	if (false) {
	  validateFormat = function validateFormat(format) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  };
	}
	
	function invariant(condition, format, a, b, c, d, e, f) {
	  validateFormat(format);
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(format.replace(/%s/g, function () {
	        return args[argIndex++];
	      }));
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	}
	
	module.exports = invariant;

/***/ }),
/* 479 */
/***/ (function(module, exports) {

	module.exports = function(lastTouchEvent, clickTimestamp) {
	  if (lastTouchEvent && (clickTimestamp - lastTouchEvent) < 750) {
	    return true;
	  }
	};


/***/ }),
/* 480 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2014 Facebook, Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @providesModule TapEventPlugin
	 * @typechecks static-only
	 */
	
	"use strict";
	
	var EventConstants = __webpack_require__(481);
	var EventPluginUtils = __webpack_require__(345);
	var EventPropagators = __webpack_require__(342);
	var SyntheticUIEvent = __webpack_require__(373);
	var TouchEventUtils = __webpack_require__(482);
	var ViewportMetrics = __webpack_require__(374);
	
	var keyOf = __webpack_require__(483);
	var topLevelTypes = EventConstants.topLevelTypes;
	
	var isStartish = EventPluginUtils.isStartish;
	var isEndish = EventPluginUtils.isEndish;
	
	var isTouch = function(topLevelType) {
	  var touchTypes = [
	    'topTouchCancel',
	    'topTouchEnd',
	    'topTouchStart',
	    'topTouchMove'
	  ];
	  return touchTypes.indexOf(topLevelType) >= 0;
	}
	
	/**
	 * Number of pixels that are tolerated in between a `touchStart` and `touchEnd`
	 * in order to still be considered a 'tap' event.
	 */
	var tapMoveThreshold = 10;
	var ignoreMouseThreshold = 750;
	var startCoords = {x: null, y: null};
	var lastTouchEvent = null;
	
	var Axis = {
	  x: {page: 'pageX', client: 'clientX', envScroll: 'currentPageScrollLeft'},
	  y: {page: 'pageY', client: 'clientY', envScroll: 'currentPageScrollTop'}
	};
	
	function getAxisCoordOfEvent(axis, nativeEvent) {
	  var singleTouch = TouchEventUtils.extractSingleTouch(nativeEvent);
	  if (singleTouch) {
	    return singleTouch[axis.page];
	  }
	  return axis.page in nativeEvent ?
	    nativeEvent[axis.page] :
	    nativeEvent[axis.client] + ViewportMetrics[axis.envScroll];
	}
	
	function getDistance(coords, nativeEvent) {
	  var pageX = getAxisCoordOfEvent(Axis.x, nativeEvent);
	  var pageY = getAxisCoordOfEvent(Axis.y, nativeEvent);
	  return Math.pow(
	    Math.pow(pageX - coords.x, 2) + Math.pow(pageY - coords.y, 2),
	    0.5
	  );
	}
	
	var touchEvents = [
	  'topTouchStart',
	  'topTouchCancel',
	  'topTouchEnd',
	  'topTouchMove',
	];
	
	var dependencies = [
	  'topMouseDown',
	  'topMouseMove',
	  'topMouseUp',
	].concat(touchEvents);
	
	var eventTypes = {
	  touchTap: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({onTouchTap: null}),
	      captured: keyOf({onTouchTapCapture: null})
	    },
	    dependencies: dependencies
	  }
	};
	
	var now = (function() {
	  if (Date.now) {
	    return Date.now;
	  } else {
	    // IE8 support: http://stackoverflow.com/questions/9430357/please-explain-why-and-how-new-date-works-as-workaround-for-date-now-in
	    return function () {
	      return +new Date;
	    }
	  }
	})();
	
	function createTapEventPlugin(shouldRejectClick) {
	  return {
	
	    tapMoveThreshold: tapMoveThreshold,
	
	    ignoreMouseThreshold: ignoreMouseThreshold,
	
	    eventTypes: eventTypes,
	
	    /**
	     * @param {string} topLevelType Record from `EventConstants`.
	     * @param {DOMEventTarget} targetInst The listening component root node.
	     * @param {object} nativeEvent Native browser event.
	     * @return {*} An accumulation of synthetic events.
	     * @see {EventPluginHub.extractEvents}
	     */
	    extractEvents: function(
	      topLevelType,
	      targetInst,
	      nativeEvent,
	      nativeEventTarget
	    ) {
	
	      if (!isStartish(topLevelType) && !isEndish(topLevelType)) {
	        return null;
	      }
	
	      if (isTouch(topLevelType)) {
	        lastTouchEvent = now();
	      } else {
	        if (shouldRejectClick(lastTouchEvent, now())) {
	          return null;
	        }
	      }
	
	      var event = null;
	      var distance = getDistance(startCoords, nativeEvent);
	      if (isEndish(topLevelType) && distance < tapMoveThreshold) {
	        event = SyntheticUIEvent.getPooled(
	          eventTypes.touchTap,
	          targetInst,
	          nativeEvent,
	          nativeEventTarget
	        );
	      }
	      if (isStartish(topLevelType)) {
	        startCoords.x = getAxisCoordOfEvent(Axis.x, nativeEvent);
	        startCoords.y = getAxisCoordOfEvent(Axis.y, nativeEvent);
	      } else if (isEndish(topLevelType)) {
	        startCoords.x = 0;
	        startCoords.y = 0;
	      }
	      EventPropagators.accumulateTwoPhaseDispatches(event);
	      return event;
	    }
	
	  };
	}
	
	module.exports = createTapEventPlugin;


/***/ }),
/* 481 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Types of raw signals from the browser caught at the top level.
	 */
	var topLevelTypes = {
	  topAbort: null,
	  topAnimationEnd: null,
	  topAnimationIteration: null,
	  topAnimationStart: null,
	  topBlur: null,
	  topCanPlay: null,
	  topCanPlayThrough: null,
	  topChange: null,
	  topClick: null,
	  topCompositionEnd: null,
	  topCompositionStart: null,
	  topCompositionUpdate: null,
	  topContextMenu: null,
	  topCopy: null,
	  topCut: null,
	  topDoubleClick: null,
	  topDrag: null,
	  topDragEnd: null,
	  topDragEnter: null,
	  topDragExit: null,
	  topDragLeave: null,
	  topDragOver: null,
	  topDragStart: null,
	  topDrop: null,
	  topDurationChange: null,
	  topEmptied: null,
	  topEncrypted: null,
	  topEnded: null,
	  topError: null,
	  topFocus: null,
	  topInput: null,
	  topInvalid: null,
	  topKeyDown: null,
	  topKeyPress: null,
	  topKeyUp: null,
	  topLoad: null,
	  topLoadedData: null,
	  topLoadedMetadata: null,
	  topLoadStart: null,
	  topMouseDown: null,
	  topMouseMove: null,
	  topMouseOut: null,
	  topMouseOver: null,
	  topMouseUp: null,
	  topPaste: null,
	  topPause: null,
	  topPlay: null,
	  topPlaying: null,
	  topProgress: null,
	  topRateChange: null,
	  topReset: null,
	  topScroll: null,
	  topSeeked: null,
	  topSeeking: null,
	  topSelectionChange: null,
	  topStalled: null,
	  topSubmit: null,
	  topSuspend: null,
	  topTextInput: null,
	  topTimeUpdate: null,
	  topTouchCancel: null,
	  topTouchEnd: null,
	  topTouchMove: null,
	  topTouchStart: null,
	  topTransitionEnd: null,
	  topVolumeChange: null,
	  topWaiting: null,
	  topWheel: null
	};
	
	var EventConstants = {
	  topLevelTypes: topLevelTypes
	};
	
	module.exports = EventConstants;

/***/ }),
/* 482 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-2014 Facebook, Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @providesModule TouchEventUtils
	 */
	
	var TouchEventUtils = {
	  /**
	   * Utility function for common case of extracting out the primary touch from a
	   * touch event.
	   * - `touchEnd` events usually do not have the `touches` property.
	   *   http://stackoverflow.com/questions/3666929/
	   *   mobile-sarai-touchend-event-not-firing-when-last-touch-is-removed
	   *
	   * @param {Event} nativeEvent Native event that may or may not be a touch.
	   * @return {TouchesObject?} an object with pageX and pageY or null.
	   */
	  extractSingleTouch: function(nativeEvent) {
	    var touches = nativeEvent.touches;
	    var changedTouches = nativeEvent.changedTouches;
	    var hasTouches = touches && touches.length > 0;
	    var hasChangedTouches = changedTouches && changedTouches.length > 0;
	
	    return !hasTouches && hasChangedTouches ? changedTouches[0] :
	           hasTouches ? touches[0] :
	           nativeEvent;
	  }
	};
	
	module.exports = TouchEventUtils;


/***/ }),
/* 483 */
/***/ (function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	/**
	 * Allows extraction of a minified key. Let's the build system minify keys
	 * without losing the ability to dynamically use key strings as values
	 * themselves. Pass in an object with a single key/val pair and it will return
	 * you the string key of that single record. Suppose you want to grab the
	 * value for a key 'className' inside of an object. Key/val minification may
	 * have aliased that key to be 'xa12'. keyOf({className: null}) will return
	 * 'xa12' in that case. Resolve keys you want to use once at startup time, then
	 * reuse those resolutions.
	 */
	var keyOf = function keyOf(oneKeyObj) {
	  var key;
	  for (key in oneKeyObj) {
	    if (!oneKeyObj.hasOwnProperty(key)) {
	      continue;
	    }
	    return key;
	  }
	  return null;
	};
	
	module.exports = keyOf;

/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _reactRouter = __webpack_require__(486);
	
	var _reactRouterScroll = __webpack_require__(549);
	
	var _reactHotLoader = __webpack_require__(561);
	
	var _appRoutes = __webpack_require__(563);
	
	var _appRoutes2 = _interopRequireDefault(_appRoutes);
	
	var _util = __webpack_require__(1183);
	
	var _UserStore = __webpack_require__(974);
	
	var _UserStore2 = _interopRequireDefault(_UserStore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var scrollMiddleware = (0, _reactRouterScroll.useScroll)(function (prevRouterProps, _ref) {
	  var routes = _ref.routes;
	  var location = _ref.location;
	
	  if (location.state && location.state.ignoreScrollBehavior && location.action !== "POP") {
	    // Ignore ignoreScrollBehavior for a "back" action (i.e. going back always restores scroll)
	    return false;
	  }
	
	  if (routes.some(function (route) {
	    return route.ignoreScrollBehavior;
	  })) {
	    return false;
	  }
	
	  if (routes.some(function (route) {
	    return route.scrollToTop;
	  })) {
	    return [0, 0];
	  }
	
	  return true;
	});
	
	var AppRoot = function (_Component) {
	  _inherits(AppRoot, _Component);
	
	  function AppRoot(props) {
	    _classCallCheck(this, AppRoot);
	
	    // Fire intercom URL change event
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(AppRoot).call(this, props));
	
	    _util.history.listen(function () {
	      window.Intercom("update", {
	        email: _UserStore2.default.getAccount() && _UserStore2.default.getAccount().email,
	        user_id: _UserStore2.default.getAccount() && _UserStore2.default.getAccount().id,
	        last_request_at: parseInt(new Date().getTime() / 1000)
	      });
	    });
	    return _this;
	  }
	
	  _createClass(AppRoot, [{
	    key: "render",
	    value: function render() {
	      return React.createElement(_reactRouter.Router, {
	        routes: _appRoutes2.default,
	        history: _util.history,
	        render: (0, _reactRouter.applyRouterMiddleware)(scrollMiddleware)
	      });
	    }
	  }]);
	
	  return AppRoot;
	}(_react.Component);
	
	exports.default = (0, _reactHotLoader.hot)(module)(AppRoot);
	module.exports = exports["default"];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(485)(module)))

/***/ }),
/* 485 */
/***/ (function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ }),
/* 486 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.createMemoryHistory = exports.hashHistory = exports.browserHistory = exports.applyRouterMiddleware = exports.formatPattern = exports.useRouterHistory = exports.match = exports.routerShape = exports.locationShape = exports.PropTypes = exports.RoutingContext = exports.RouterContext = exports.createRoutes = exports.useRoutes = exports.RouteContext = exports.Lifecycle = exports.History = exports.Route = exports.Redirect = exports.IndexRoute = exports.IndexRedirect = exports.withRouter = exports.IndexLink = exports.Link = exports.Router = undefined;
	
	var _RouteUtils = __webpack_require__(487);
	
	Object.defineProperty(exports, 'createRoutes', {
	  enumerable: true,
	  get: function get() {
	    return _RouteUtils.createRoutes;
	  }
	});
	
	var _PropTypes2 = __webpack_require__(488);
	
	Object.defineProperty(exports, 'locationShape', {
	  enumerable: true,
	  get: function get() {
	    return _PropTypes2.locationShape;
	  }
	});
	Object.defineProperty(exports, 'routerShape', {
	  enumerable: true,
	  get: function get() {
	    return _PropTypes2.routerShape;
	  }
	});
	
	var _PatternUtils = __webpack_require__(493);
	
	Object.defineProperty(exports, 'formatPattern', {
	  enumerable: true,
	  get: function get() {
	    return _PatternUtils.formatPattern;
	  }
	});
	
	var _Router2 = __webpack_require__(495);
	
	var _Router3 = _interopRequireDefault(_Router2);
	
	var _Link2 = __webpack_require__(526);
	
	var _Link3 = _interopRequireDefault(_Link2);
	
	var _IndexLink2 = __webpack_require__(527);
	
	var _IndexLink3 = _interopRequireDefault(_IndexLink2);
	
	var _withRouter2 = __webpack_require__(528);
	
	var _withRouter3 = _interopRequireDefault(_withRouter2);
	
	var _IndexRedirect2 = __webpack_require__(530);
	
	var _IndexRedirect3 = _interopRequireDefault(_IndexRedirect2);
	
	var _IndexRoute2 = __webpack_require__(532);
	
	var _IndexRoute3 = _interopRequireDefault(_IndexRoute2);
	
	var _Redirect2 = __webpack_require__(531);
	
	var _Redirect3 = _interopRequireDefault(_Redirect2);
	
	var _Route2 = __webpack_require__(533);
	
	var _Route3 = _interopRequireDefault(_Route2);
	
	var _History2 = __webpack_require__(534);
	
	var _History3 = _interopRequireDefault(_History2);
	
	var _Lifecycle2 = __webpack_require__(535);
	
	var _Lifecycle3 = _interopRequireDefault(_Lifecycle2);
	
	var _RouteContext2 = __webpack_require__(536);
	
	var _RouteContext3 = _interopRequireDefault(_RouteContext2);
	
	var _useRoutes2 = __webpack_require__(537);
	
	var _useRoutes3 = _interopRequireDefault(_useRoutes2);
	
	var _RouterContext2 = __webpack_require__(523);
	
	var _RouterContext3 = _interopRequireDefault(_RouterContext2);
	
	var _RoutingContext2 = __webpack_require__(538);
	
	var _RoutingContext3 = _interopRequireDefault(_RoutingContext2);
	
	var _PropTypes3 = _interopRequireDefault(_PropTypes2);
	
	var _match2 = __webpack_require__(539);
	
	var _match3 = _interopRequireDefault(_match2);
	
	var _useRouterHistory2 = __webpack_require__(543);
	
	var _useRouterHistory3 = _interopRequireDefault(_useRouterHistory2);
	
	var _applyRouterMiddleware2 = __webpack_require__(544);
	
	var _applyRouterMiddleware3 = _interopRequireDefault(_applyRouterMiddleware2);
	
	var _browserHistory2 = __webpack_require__(545);
	
	var _browserHistory3 = _interopRequireDefault(_browserHistory2);
	
	var _hashHistory2 = __webpack_require__(548);
	
	var _hashHistory3 = _interopRequireDefault(_hashHistory2);
	
	var _createMemoryHistory2 = __webpack_require__(540);
	
	var _createMemoryHistory3 = _interopRequireDefault(_createMemoryHistory2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Router = _Router3.default; /* components */
	
	exports.Link = _Link3.default;
	exports.IndexLink = _IndexLink3.default;
	exports.withRouter = _withRouter3.default;
	
	/* components (configuration) */
	
	exports.IndexRedirect = _IndexRedirect3.default;
	exports.IndexRoute = _IndexRoute3.default;
	exports.Redirect = _Redirect3.default;
	exports.Route = _Route3.default;
	
	/* mixins */
	
	exports.History = _History3.default;
	exports.Lifecycle = _Lifecycle3.default;
	exports.RouteContext = _RouteContext3.default;
	
	/* utils */
	
	exports.useRoutes = _useRoutes3.default;
	exports.RouterContext = _RouterContext3.default;
	exports.RoutingContext = _RoutingContext3.default;
	exports.PropTypes = _PropTypes3.default;
	exports.match = _match3.default;
	exports.useRouterHistory = _useRouterHistory3.default;
	exports.applyRouterMiddleware = _applyRouterMiddleware3.default;
	
	/* histories */
	
	exports.browserHistory = _browserHistory3.default;
	exports.hashHistory = _hashHistory3.default;
	exports.createMemoryHistory = _createMemoryHistory3.default;

/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.isReactChildren = isReactChildren;
	exports.createRouteFromReactElement = createRouteFromReactElement;
	exports.createRoutesFromReactChildren = createRoutesFromReactChildren;
	exports.createRoutes = createRoutes;
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isValidChild(object) {
	  return object == null || _react2.default.isValidElement(object);
	}
	
	function isReactChildren(object) {
	  return isValidChild(object) || Array.isArray(object) && object.every(isValidChild);
	}
	
	function createRoute(defaultProps, props) {
	  return _extends({}, defaultProps, props);
	}
	
	function createRouteFromReactElement(element) {
	  var type = element.type;
	  var route = createRoute(type.defaultProps, element.props);
	
	  if (route.children) {
	    var childRoutes = createRoutesFromReactChildren(route.children, route);
	
	    if (childRoutes.length) route.childRoutes = childRoutes;
	
	    delete route.children;
	  }
	
	  return route;
	}
	
	/**
	 * Creates and returns a routes object from the given ReactChildren. JSX
	 * provides a convenient way to visualize how routes in the hierarchy are
	 * nested.
	 *
	 *   import { Route, createRoutesFromReactChildren } from 'react-router'
	 *
	 *   const routes = createRoutesFromReactChildren(
	 *     <Route component={App}>
	 *       <Route path="home" component={Dashboard}/>
	 *       <Route path="news" component={NewsFeed}/>
	 *     </Route>
	 *   )
	 *
	 * Note: This method is automatically used when you provide <Route> children
	 * to a <Router> component.
	 */
	function createRoutesFromReactChildren(children, parentRoute) {
	  var routes = [];
	
	  _react2.default.Children.forEach(children, function (element) {
	    if (_react2.default.isValidElement(element)) {
	      // Component classes may have a static create* method.
	      if (element.type.createRouteFromReactElement) {
	        var route = element.type.createRouteFromReactElement(element, parentRoute);
	
	        if (route) routes.push(route);
	      } else {
	        routes.push(createRouteFromReactElement(element));
	      }
	    }
	  });
	
	  return routes;
	}
	
	/**
	 * Creates and returns an array of routes from the given object which
	 * may be a JSX route, a plain object route, or an array of either.
	 */
	function createRoutes(routes) {
	  if (isReactChildren(routes)) {
	    routes = createRoutesFromReactChildren(routes);
	  } else if (routes && !Array.isArray(routes)) {
	    routes = [routes];
	  }
	
	  return routes;
	}

/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.router = exports.routes = exports.route = exports.components = exports.component = exports.location = exports.history = exports.falsy = exports.locationShape = exports.routerShape = undefined;
	
	var _react = __webpack_require__(300);
	
	var _deprecateObjectProperties = __webpack_require__(489);
	
	var _deprecateObjectProperties2 = _interopRequireDefault(_deprecateObjectProperties);
	
	var _InternalPropTypes = __webpack_require__(492);
	
	var InternalPropTypes = _interopRequireWildcard(_InternalPropTypes);
	
	var _routerWarning = __webpack_require__(490);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var func = _react.PropTypes.func;
	var object = _react.PropTypes.object;
	var shape = _react.PropTypes.shape;
	var string = _react.PropTypes.string;
	var routerShape = exports.routerShape = shape({
	  push: func.isRequired,
	  replace: func.isRequired,
	  go: func.isRequired,
	  goBack: func.isRequired,
	  goForward: func.isRequired,
	  setRouteLeaveHook: func.isRequired,
	  isActive: func.isRequired
	});
	
	var locationShape = exports.locationShape = shape({
	  pathname: string.isRequired,
	  search: string.isRequired,
	  state: object,
	  action: string.isRequired,
	  key: string
	});
	
	// Deprecated stuff below:
	
	var falsy = exports.falsy = InternalPropTypes.falsy;
	var history = exports.history = InternalPropTypes.history;
	var location = exports.location = locationShape;
	var component = exports.component = InternalPropTypes.component;
	var components = exports.components = InternalPropTypes.components;
	var route = exports.route = InternalPropTypes.route;
	var routes = exports.routes = InternalPropTypes.routes;
	var router = exports.router = routerShape;
	
	if (false) {
	  (function () {
	    var deprecatePropType = function deprecatePropType(propType, message) {
	      return function () {
	        process.env.NODE_ENV !== 'production' ? (0, _routerWarning2.default)(false, message) : void 0;
	        return propType.apply(undefined, arguments);
	      };
	    };
	
	    var deprecateInternalPropType = function deprecateInternalPropType(propType) {
	      return deprecatePropType(propType, 'This prop type is not intended for external use, and was previously exported by mistake. These internal prop types are deprecated for external use, and will be removed in a later version.');
	    };
	
	    var deprecateRenamedPropType = function deprecateRenamedPropType(propType, name) {
	      return deprecatePropType(propType, 'The `' + name + '` prop type is now exported as `' + name + 'Shape` to avoid name conflicts. This export is deprecated and will be removed in a later version.');
	    };
	
	    exports.falsy = falsy = deprecateInternalPropType(falsy);
	    exports.history = history = deprecateInternalPropType(history);
	    exports.component = component = deprecateInternalPropType(component);
	    exports.components = components = deprecateInternalPropType(components);
	    exports.route = route = deprecateInternalPropType(route);
	    exports.routes = routes = deprecateInternalPropType(routes);
	
	    exports.location = location = deprecateRenamedPropType(location, 'location');
	    exports.router = router = deprecateRenamedPropType(router, 'router');
	  })();
	}
	
	var defaultExport = {
	  falsy: falsy,
	  history: history,
	  location: location,
	  component: component,
	  components: components,
	  route: route,
	  // For some reason, routes was never here.
	  router: router
	};
	
	if (false) {
	  defaultExport = (0, _deprecateObjectProperties2.default)(defaultExport, 'The default export from `react-router/lib/PropTypes` is deprecated. Please use the named exports instead.');
	}
	
	exports.default = defaultExport;

/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.canUseMembrane = undefined;
	
	var _routerWarning = __webpack_require__(490);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var canUseMembrane = exports.canUseMembrane = false;
	
	// No-op by default.
	var deprecateObjectProperties = function deprecateObjectProperties(object) {
	  return object;
	};
	
	if (false) {
	  try {
	    if (Object.defineProperty({}, 'x', {
	      get: function get() {
	        return true;
	      }
	    }).x) {
	      exports.canUseMembrane = canUseMembrane = true;
	    }
	    /* eslint-disable no-empty */
	  } catch (e) {}
	  /* eslint-enable no-empty */
	
	  if (canUseMembrane) {
	    deprecateObjectProperties = function deprecateObjectProperties(object, message) {
	      // Wrap the deprecated object in a membrane to warn on property access.
	      var membrane = {};
	
	      var _loop = function _loop(prop) {
	        if (!Object.prototype.hasOwnProperty.call(object, prop)) {
	          return 'continue';
	        }
	
	        if (typeof object[prop] === 'function') {
	          // Can't use fat arrow here because of use of arguments below.
	          membrane[prop] = function () {
	            process.env.NODE_ENV !== 'production' ? (0, _routerWarning2.default)(false, message) : void 0;
	            return object[prop].apply(object, arguments);
	          };
	          return 'continue';
	        }
	
	        // These properties are non-enumerable to prevent React dev tools from
	        // seeing them and causing spurious warnings when accessing them. In
	        // principle this could be done with a proxy, but support for the
	        // ownKeys trap on proxies is not universal, even among browsers that
	        // otherwise support proxies.
	        Object.defineProperty(membrane, prop, {
	          get: function get() {
	            process.env.NODE_ENV !== 'production' ? (0, _routerWarning2.default)(false, message) : void 0;
	            return object[prop];
	          }
	        });
	      };
	
	      for (var prop in object) {
	        var _ret = _loop(prop);
	
	        if (_ret === 'continue') continue;
	      }
	
	      return membrane;
	    };
	  }
	}
	
	exports.default = deprecateObjectProperties;

/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = routerWarning;
	exports._resetWarned = _resetWarned;
	
	var _warning = __webpack_require__(491);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var warned = {};
	
	function routerWarning(falseToWarn, message) {
	  // Only issue deprecation warnings once.
	  if (message.indexOf('deprecated') !== -1) {
	    if (warned[message]) {
	      return;
	    }
	
	    warned[message] = true;
	  }
	
	  message = '[react-router] ' + message;
	
	  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
	    args[_key - 2] = arguments[_key];
	  }
	
	  _warning2.default.apply(undefined, [falseToWarn, message].concat(args));
	}
	
	function _resetWarned() {
	  warned = {};
	}

/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = function() {};
	
	if (false) {
	  warning = function(condition, format, args) {
	    var len = arguments.length;
	    args = new Array(len > 2 ? len - 2 : 0);
	    for (var key = 2; key < len; key++) {
	      args[key - 2] = arguments[key];
	    }
	    if (format === undefined) {
	      throw new Error(
	        '`warning(condition, format, ...args)` requires a warning ' +
	        'message argument'
	      );
	    }
	
	    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
	      throw new Error(
	        'The warning format should be able to uniquely identify this ' +
	        'warning. Please, use a more descriptive format than: ' + format
	      );
	    }
	
	    if (!condition) {
	      var argIndex = 0;
	      var message = 'Warning: ' +
	        format.replace(/%s/g, function() {
	          return args[argIndex++];
	        });
	      if (typeof console !== 'undefined') {
	        console.error(message);
	      }
	      try {
	        // This error was thrown as a convenience so that you can use this stack
	        // to find the callsite that caused this warning to fire.
	        throw new Error(message);
	      } catch(x) {}
	    }
	  };
	}
	
	module.exports = warning;


/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.routes = exports.route = exports.components = exports.component = exports.history = undefined;
	exports.falsy = falsy;
	
	var _react = __webpack_require__(300);
	
	var func = _react.PropTypes.func;
	var object = _react.PropTypes.object;
	var arrayOf = _react.PropTypes.arrayOf;
	var oneOfType = _react.PropTypes.oneOfType;
	var element = _react.PropTypes.element;
	var shape = _react.PropTypes.shape;
	var string = _react.PropTypes.string;
	function falsy(props, propName, componentName) {
	  if (props[propName]) return new Error('<' + componentName + '> should not have a "' + propName + '" prop');
	}
	
	var history = exports.history = shape({
	  listen: func.isRequired,
	  push: func.isRequired,
	  replace: func.isRequired,
	  go: func.isRequired,
	  goBack: func.isRequired,
	  goForward: func.isRequired
	});
	
	var component = exports.component = oneOfType([func, string]);
	var components = exports.components = oneOfType([component, object]);
	var route = exports.route = oneOfType([object, element]);
	var routes = exports.routes = oneOfType([route, arrayOf(route)]);

/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.compilePattern = compilePattern;
	exports.matchPattern = matchPattern;
	exports.getParamNames = getParamNames;
	exports.getParams = getParams;
	exports.formatPattern = formatPattern;
	
	var _invariant = __webpack_require__(494);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function escapeRegExp(string) {
	  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
	}
	
	function _compilePattern(pattern) {
	  var regexpSource = '';
	  var paramNames = [];
	  var tokens = [];
	
	  var match = void 0,
	      lastIndex = 0,
	      matcher = /:([a-zA-Z_$][a-zA-Z0-9_$]*)|\*\*|\*|\(|\)/g;
	  while (match = matcher.exec(pattern)) {
	    if (match.index !== lastIndex) {
	      tokens.push(pattern.slice(lastIndex, match.index));
	      regexpSource += escapeRegExp(pattern.slice(lastIndex, match.index));
	    }
	
	    if (match[1]) {
	      regexpSource += '([^/]+)';
	      paramNames.push(match[1]);
	    } else if (match[0] === '**') {
	      regexpSource += '(.*)';
	      paramNames.push('splat');
	    } else if (match[0] === '*') {
	      regexpSource += '(.*?)';
	      paramNames.push('splat');
	    } else if (match[0] === '(') {
	      regexpSource += '(?:';
	    } else if (match[0] === ')') {
	      regexpSource += ')?';
	    }
	
	    tokens.push(match[0]);
	
	    lastIndex = matcher.lastIndex;
	  }
	
	  if (lastIndex !== pattern.length) {
	    tokens.push(pattern.slice(lastIndex, pattern.length));
	    regexpSource += escapeRegExp(pattern.slice(lastIndex, pattern.length));
	  }
	
	  return {
	    pattern: pattern,
	    regexpSource: regexpSource,
	    paramNames: paramNames,
	    tokens: tokens
	  };
	}
	
	var CompiledPatternsCache = Object.create(null);
	
	function compilePattern(pattern) {
	  if (!CompiledPatternsCache[pattern]) CompiledPatternsCache[pattern] = _compilePattern(pattern);
	
	  return CompiledPatternsCache[pattern];
	}
	
	/**
	 * Attempts to match a pattern on the given pathname. Patterns may use
	 * the following special characters:
	 *
	 * - :paramName     Matches a URL segment up to the next /, ?, or #. The
	 *                  captured string is considered a "param"
	 * - ()             Wraps a segment of the URL that is optional
	 * - *              Consumes (non-greedy) all characters up to the next
	 *                  character in the pattern, or to the end of the URL if
	 *                  there is none
	 * - **             Consumes (greedy) all characters up to the next character
	 *                  in the pattern, or to the end of the URL if there is none
	 *
	 *  The function calls callback(error, matched) when finished.
	 * The return value is an object with the following properties:
	 *
	 * - remainingPathname
	 * - paramNames
	 * - paramValues
	 */
	function matchPattern(pattern, pathname) {
	  // Ensure pattern starts with leading slash for consistency with pathname.
	  if (pattern.charAt(0) !== '/') {
	    pattern = '/' + pattern;
	  }
	
	  var _compilePattern2 = compilePattern(pattern);
	
	  var regexpSource = _compilePattern2.regexpSource;
	  var paramNames = _compilePattern2.paramNames;
	  var tokens = _compilePattern2.tokens;
	
	
	  if (pattern.charAt(pattern.length - 1) !== '/') {
	    regexpSource += '/?'; // Allow optional path separator at end.
	  }
	
	  // Special-case patterns like '*' for catch-all routes.
	  if (tokens[tokens.length - 1] === '*') {
	    regexpSource += '$';
	  }
	
	  var match = pathname.match(new RegExp('^' + regexpSource, 'i'));
	  if (match == null) {
	    return null;
	  }
	
	  var matchedPath = match[0];
	  var remainingPathname = pathname.substr(matchedPath.length);
	
	  if (remainingPathname) {
	    // Require that the match ends at a path separator, if we didn't match
	    // the full path, so any remaining pathname is a new path segment.
	    if (matchedPath.charAt(matchedPath.length - 1) !== '/') {
	      return null;
	    }
	
	    // If there is a remaining pathname, treat the path separator as part of
	    // the remaining pathname for properly continuing the match.
	    remainingPathname = '/' + remainingPathname;
	  }
	
	  return {
	    remainingPathname: remainingPathname,
	    paramNames: paramNames,
	    paramValues: match.slice(1).map(function (v) {
	      return v && decodeURIComponent(v);
	    })
	  };
	}
	
	function getParamNames(pattern) {
	  return compilePattern(pattern).paramNames;
	}
	
	function getParams(pattern, pathname) {
	  var match = matchPattern(pattern, pathname);
	  if (!match) {
	    return null;
	  }
	
	  var paramNames = match.paramNames;
	  var paramValues = match.paramValues;
	
	  var params = {};
	
	  paramNames.forEach(function (paramName, index) {
	    params[paramName] = paramValues[index];
	  });
	
	  return params;
	}
	
	/**
	 * Returns a version of the given pattern with params interpolated. Throws
	 * if there is a dynamic segment of the pattern for which there is no param.
	 */
	function formatPattern(pattern, params) {
	  params = params || {};
	
	  var _compilePattern3 = compilePattern(pattern);
	
	  var tokens = _compilePattern3.tokens;
	
	  var parenCount = 0,
	      pathname = '',
	      splatIndex = 0;
	
	  var token = void 0,
	      paramName = void 0,
	      paramValue = void 0;
	  for (var i = 0, len = tokens.length; i < len; ++i) {
	    token = tokens[i];
	
	    if (token === '*' || token === '**') {
	      paramValue = Array.isArray(params.splat) ? params.splat[splatIndex++] : params.splat;
	
	      !(paramValue != null || parenCount > 0) ?  false ? (0, _invariant2.default)(false, 'Missing splat #%s for path "%s"', splatIndex, pattern) : (0, _invariant2.default)(false) : void 0;
	
	      if (paramValue != null) pathname += encodeURI(paramValue);
	    } else if (token === '(') {
	      parenCount += 1;
	    } else if (token === ')') {
	      parenCount -= 1;
	    } else if (token.charAt(0) === ':') {
	      paramName = token.substring(1);
	      paramValue = params[paramName];
	
	      !(paramValue != null || parenCount > 0) ?  false ? (0, _invariant2.default)(false, 'Missing "%s" parameter for path "%s"', paramName, pattern) : (0, _invariant2.default)(false) : void 0;
	
	      if (paramValue != null) pathname += encodeURIComponent(paramValue);
	    } else {
	      pathname += token;
	    }
	  }
	
	  return pathname.replace(/\/+/g, '/');
	}

/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var invariant = function(condition, format, a, b, c, d, e, f) {
	  if (false) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  }
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error(
	        'Minified exception occurred; use the non-minified dev environment ' +
	        'for the full error message and additional helpful warnings.'
	      );
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(
	        format.replace(/%s/g, function() { return args[argIndex++]; })
	      );
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	};
	
	module.exports = invariant;


/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createHashHistory = __webpack_require__(496);
	
	var _createHashHistory2 = _interopRequireDefault(_createHashHistory);
	
	var _useQueries = __webpack_require__(512);
	
	var _useQueries2 = _interopRequireDefault(_useQueries);
	
	var _invariant = __webpack_require__(494);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createTransitionManager = __webpack_require__(515);
	
	var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);
	
	var _InternalPropTypes = __webpack_require__(492);
	
	var _RouterContext = __webpack_require__(523);
	
	var _RouterContext2 = _interopRequireDefault(_RouterContext);
	
	var _RouteUtils = __webpack_require__(487);
	
	var _RouterUtils = __webpack_require__(525);
	
	var _routerWarning = __webpack_require__(490);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function isDeprecatedHistory(history) {
	  return !history || !history.__v2_compatible__;
	}
	
	/* istanbul ignore next: sanity check */
	function isUnsupportedHistory(history) {
	  // v3 histories expose getCurrentLocation, but aren't currently supported.
	  return history && history.getCurrentLocation;
	}
	
	var _React$PropTypes = _react2.default.PropTypes;
	var func = _React$PropTypes.func;
	var object = _React$PropTypes.object;
	
	/**
	 * A <Router> is a high-level API for automatically setting up
	 * a router that renders a <RouterContext> with all the props
	 * it needs each time the URL changes.
	 */
	
	var Router = _react2.default.createClass({
	  displayName: 'Router',
	
	
	  propTypes: {
	    history: object,
	    children: _InternalPropTypes.routes,
	    routes: _InternalPropTypes.routes, // alias for children
	    render: func,
	    createElement: func,
	    onError: func,
	    onUpdate: func,
	
	    // Deprecated:
	    parseQueryString: func,
	    stringifyQuery: func,
	
	    // PRIVATE: For client-side rehydration of server match.
	    matchContext: object
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      render: function render(props) {
	        return _react2.default.createElement(_RouterContext2.default, props);
	      }
	    };
	  },
	  getInitialState: function getInitialState() {
	    return {
	      location: null,
	      routes: null,
	      params: null,
	      components: null
	    };
	  },
	  handleError: function handleError(error) {
	    if (this.props.onError) {
	      this.props.onError.call(this, error);
	    } else {
	      // Throw errors by default so we don't silently swallow them!
	      throw error; // This error probably occurred in getChildRoutes or getComponents.
	    }
	  },
	  componentWillMount: function componentWillMount() {
	    var _this = this;
	
	    var _props = this.props;
	    var parseQueryString = _props.parseQueryString;
	    var stringifyQuery = _props.stringifyQuery;
	
	     false ? (0, _routerWarning2.default)(!(parseQueryString || stringifyQuery), '`parseQueryString` and `stringifyQuery` are deprecated. Please create a custom history. http://tiny.cc/router-customquerystring') : void 0;
	
	    var _createRouterObjects = this.createRouterObjects();
	
	    var history = _createRouterObjects.history;
	    var transitionManager = _createRouterObjects.transitionManager;
	    var router = _createRouterObjects.router;
	
	
	    this._unlisten = transitionManager.listen(function (error, state) {
	      if (error) {
	        _this.handleError(error);
	      } else {
	        _this.setState(state, _this.props.onUpdate);
	      }
	    });
	
	    this.history = history;
	    this.router = router;
	  },
	  createRouterObjects: function createRouterObjects() {
	    var matchContext = this.props.matchContext;
	
	    if (matchContext) {
	      return matchContext;
	    }
	
	    var history = this.props.history;
	    var _props2 = this.props;
	    var routes = _props2.routes;
	    var children = _props2.children;
	
	
	    !!isUnsupportedHistory(history) ?  false ? (0, _invariant2.default)(false, 'You have provided a history object created with history v3.x. ' + 'This version of React Router is not compatible with v3 history ' + 'objects. Please use history v2.x instead.') : (0, _invariant2.default)(false) : void 0;
	
	    if (isDeprecatedHistory(history)) {
	      history = this.wrapDeprecatedHistory(history);
	    }
	
	    var transitionManager = (0, _createTransitionManager2.default)(history, (0, _RouteUtils.createRoutes)(routes || children));
	    var router = (0, _RouterUtils.createRouterObject)(history, transitionManager);
	    var routingHistory = (0, _RouterUtils.createRoutingHistory)(history, transitionManager);
	
	    return { history: routingHistory, transitionManager: transitionManager, router: router };
	  },
	  wrapDeprecatedHistory: function wrapDeprecatedHistory(history) {
	    var _props3 = this.props;
	    var parseQueryString = _props3.parseQueryString;
	    var stringifyQuery = _props3.stringifyQuery;
	
	
	    var createHistory = void 0;
	    if (history) {
	       false ? (0, _routerWarning2.default)(false, 'It appears you have provided a deprecated history object to `<Router/>`, please use a history provided by ' + 'React Router with `import { browserHistory } from \'react-router\'` or `import { hashHistory } from \'react-router\'`. ' + 'If you are using a custom history please create it with `useRouterHistory`, see http://tiny.cc/router-usinghistory for details.') : void 0;
	      createHistory = function createHistory() {
	        return history;
	      };
	    } else {
	       false ? (0, _routerWarning2.default)(false, '`Router` no longer defaults the history prop to hash history. Please use the `hashHistory` singleton instead. http://tiny.cc/router-defaulthistory') : void 0;
	      createHistory = _createHashHistory2.default;
	    }
	
	    return (0, _useQueries2.default)(createHistory)({ parseQueryString: parseQueryString, stringifyQuery: stringifyQuery });
	  },
	
	
	  /* istanbul ignore next: sanity check */
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	     false ? (0, _routerWarning2.default)(nextProps.history === this.props.history, 'You cannot change <Router history>; it will be ignored') : void 0;
	
	     false ? (0, _routerWarning2.default)((nextProps.routes || nextProps.children) === (this.props.routes || this.props.children), 'You cannot change <Router routes>; it will be ignored') : void 0;
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    if (this._unlisten) this._unlisten();
	  },
	  render: function render() {
	    var _state = this.state;
	    var location = _state.location;
	    var routes = _state.routes;
	    var params = _state.params;
	    var components = _state.components;
	    var _props4 = this.props;
	    var createElement = _props4.createElement;
	    var render = _props4.render;
	
	    var props = _objectWithoutProperties(_props4, ['createElement', 'render']);
	
	    if (location == null) return null; // Async match
	
	    // Only forward non-Router-specific props to routing context, as those are
	    // the only ones that might be custom routing context props.
	    Object.keys(Router.propTypes).forEach(function (propType) {
	      return delete props[propType];
	    });
	
	    return render(_extends({}, props, {
	      history: this.history,
	      router: this.router,
	      location: location,
	      routes: routes,
	      params: params,
	      components: components,
	      createElement: createElement
	    }));
	  }
	});
	
	exports.default = Router;
	module.exports = exports['default'];

/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(497);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(494);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _Actions = __webpack_require__(498);
	
	var _PathUtils = __webpack_require__(499);
	
	var _ExecutionEnvironment = __webpack_require__(500);
	
	var _DOMUtils = __webpack_require__(501);
	
	var _DOMStateStorage = __webpack_require__(502);
	
	var _createDOMHistory = __webpack_require__(503);
	
	var _createDOMHistory2 = _interopRequireDefault(_createDOMHistory);
	
	function isAbsolutePath(path) {
	  return typeof path === 'string' && path.charAt(0) === '/';
	}
	
	function ensureSlash() {
	  var path = _DOMUtils.getHashPath();
	
	  if (isAbsolutePath(path)) return true;
	
	  _DOMUtils.replaceHashPath('/' + path);
	
	  return false;
	}
	
	function addQueryStringValueToPath(path, key, value) {
	  return path + (path.indexOf('?') === -1 ? '?' : '&') + (key + '=' + value);
	}
	
	function stripQueryStringValueFromPath(path, key) {
	  return path.replace(new RegExp('[?&]?' + key + '=[a-zA-Z0-9]+'), '');
	}
	
	function getQueryStringValueFromPath(path, key) {
	  var match = path.match(new RegExp('\\?.*?\\b' + key + '=(.+?)\\b'));
	  return match && match[1];
	}
	
	var DefaultQueryKey = '_k';
	
	function createHashHistory() {
	  var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	  !_ExecutionEnvironment.canUseDOM ?  false ? _invariant2['default'](false, 'Hash history needs a DOM') : _invariant2['default'](false) : undefined;
	
	  var queryKey = options.queryKey;
	
	  if (queryKey === undefined || !!queryKey) queryKey = typeof queryKey === 'string' ? queryKey : DefaultQueryKey;
	
	  function getCurrentLocation() {
	    var path = _DOMUtils.getHashPath();
	
	    var key = undefined,
	        state = undefined;
	    if (queryKey) {
	      key = getQueryStringValueFromPath(path, queryKey);
	      path = stripQueryStringValueFromPath(path, queryKey);
	
	      if (key) {
	        state = _DOMStateStorage.readState(key);
	      } else {
	        state = null;
	        key = history.createKey();
	        _DOMUtils.replaceHashPath(addQueryStringValueToPath(path, queryKey, key));
	      }
	    } else {
	      key = state = null;
	    }
	
	    var location = _PathUtils.parsePath(path);
	
	    return history.createLocation(_extends({}, location, { state: state }), undefined, key);
	  }
	
	  function startHashChangeListener(_ref) {
	    var transitionTo = _ref.transitionTo;
	
	    function hashChangeListener() {
	      if (!ensureSlash()) return; // Always make sure hashes are preceeded with a /.
	
	      transitionTo(getCurrentLocation());
	    }
	
	    ensureSlash();
	    _DOMUtils.addEventListener(window, 'hashchange', hashChangeListener);
	
	    return function () {
	      _DOMUtils.removeEventListener(window, 'hashchange', hashChangeListener);
	    };
	  }
	
	  function finishTransition(location) {
	    var basename = location.basename;
	    var pathname = location.pathname;
	    var search = location.search;
	    var state = location.state;
	    var action = location.action;
	    var key = location.key;
	
	    if (action === _Actions.POP) return; // Nothing to do.
	
	    var path = (basename || '') + pathname + search;
	
	    if (queryKey) {
	      path = addQueryStringValueToPath(path, queryKey, key);
	      _DOMStateStorage.saveState(key, state);
	    } else {
	      // Drop key and state.
	      location.key = location.state = null;
	    }
	
	    var currentHash = _DOMUtils.getHashPath();
	
	    if (action === _Actions.PUSH) {
	      if (currentHash !== path) {
	        window.location.hash = path;
	      } else {
	         false ? _warning2['default'](false, 'You cannot PUSH the same path using hash history') : undefined;
	      }
	    } else if (currentHash !== path) {
	      // REPLACE
	      _DOMUtils.replaceHashPath(path);
	    }
	  }
	
	  var history = _createDOMHistory2['default'](_extends({}, options, {
	    getCurrentLocation: getCurrentLocation,
	    finishTransition: finishTransition,
	    saveState: _DOMStateStorage.saveState
	  }));
	
	  var listenerCount = 0,
	      stopHashChangeListener = undefined;
	
	  function listenBefore(listener) {
	    if (++listenerCount === 1) stopHashChangeListener = startHashChangeListener(history);
	
	    var unlisten = history.listenBefore(listener);
	
	    return function () {
	      unlisten();
	
	      if (--listenerCount === 0) stopHashChangeListener();
	    };
	  }
	
	  function listen(listener) {
	    if (++listenerCount === 1) stopHashChangeListener = startHashChangeListener(history);
	
	    var unlisten = history.listen(listener);
	
	    return function () {
	      unlisten();
	
	      if (--listenerCount === 0) stopHashChangeListener();
	    };
	  }
	
	  function push(location) {
	     false ? _warning2['default'](queryKey || location.state == null, 'You cannot use state without a queryKey it will be dropped') : undefined;
	
	    history.push(location);
	  }
	
	  function replace(location) {
	     false ? _warning2['default'](queryKey || location.state == null, 'You cannot use state without a queryKey it will be dropped') : undefined;
	
	    history.replace(location);
	  }
	
	  var goIsSupportedWithoutReload = _DOMUtils.supportsGoWithoutReloadUsingHash();
	
	  function go(n) {
	     false ? _warning2['default'](goIsSupportedWithoutReload, 'Hash history go(n) causes a full page reload in this browser') : undefined;
	
	    history.go(n);
	  }
	
	  function createHref(path) {
	    return '#' + history.createHref(path);
	  }
	
	  // deprecated
	  function registerTransitionHook(hook) {
	    if (++listenerCount === 1) stopHashChangeListener = startHashChangeListener(history);
	
	    history.registerTransitionHook(hook);
	  }
	
	  // deprecated
	  function unregisterTransitionHook(hook) {
	    history.unregisterTransitionHook(hook);
	
	    if (--listenerCount === 0) stopHashChangeListener();
	  }
	
	  // deprecated
	  function pushState(state, path) {
	     false ? _warning2['default'](queryKey || state == null, 'You cannot use state without a queryKey it will be dropped') : undefined;
	
	    history.pushState(state, path);
	  }
	
	  // deprecated
	  function replaceState(state, path) {
	     false ? _warning2['default'](queryKey || state == null, 'You cannot use state without a queryKey it will be dropped') : undefined;
	
	    history.replaceState(state, path);
	  }
	
	  return _extends({}, history, {
	    listenBefore: listenBefore,
	    listen: listen,
	    push: push,
	    replace: replace,
	    go: go,
	    createHref: createHref,
	
	    registerTransitionHook: registerTransitionHook, // deprecated - warning is in createHistory
	    unregisterTransitionHook: unregisterTransitionHook, // deprecated - warning is in createHistory
	    pushState: pushState, // deprecated - warning is in createHistory
	    replaceState: replaceState // deprecated - warning is in createHistory
	  });
	}
	
	exports['default'] = createHashHistory;
	module.exports = exports['default'];

/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = function() {};
	
	if (false) {
	  warning = function(condition, format, args) {
	    var len = arguments.length;
	    args = new Array(len > 2 ? len - 2 : 0);
	    for (var key = 2; key < len; key++) {
	      args[key - 2] = arguments[key];
	    }
	    if (format === undefined) {
	      throw new Error(
	        '`warning(condition, format, ...args)` requires a warning ' +
	        'message argument'
	      );
	    }
	
	    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
	      throw new Error(
	        'The warning format should be able to uniquely identify this ' +
	        'warning. Please, use a more descriptive format than: ' + format
	      );
	    }
	
	    if (!condition) {
	      var argIndex = 0;
	      var message = 'Warning: ' +
	        format.replace(/%s/g, function() {
	          return args[argIndex++];
	        });
	      if (typeof console !== 'undefined') {
	        console.error(message);
	      }
	      try {
	        // This error was thrown as a convenience so that you can use this stack
	        // to find the callsite that caused this warning to fire.
	        throw new Error(message);
	      } catch(x) {}
	    }
	  };
	}
	
	module.exports = warning;


/***/ }),
/* 498 */
/***/ (function(module, exports) {

	/**
	 * Indicates that navigation was caused by a call to history.push.
	 */
	'use strict';
	
	exports.__esModule = true;
	var PUSH = 'PUSH';
	
	exports.PUSH = PUSH;
	/**
	 * Indicates that navigation was caused by a call to history.replace.
	 */
	var REPLACE = 'REPLACE';
	
	exports.REPLACE = REPLACE;
	/**
	 * Indicates that navigation was caused by some other action such
	 * as using a browser's back/forward buttons and/or manually manipulating
	 * the URL in a browser's location bar. This is the default.
	 *
	 * See https://developer.mozilla.org/en-US/docs/Web/API/WindowEventHandlers/onpopstate
	 * for more information.
	 */
	var POP = 'POP';
	
	exports.POP = POP;
	exports['default'] = {
	  PUSH: PUSH,
	  REPLACE: REPLACE,
	  POP: POP
	};

/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.extractPath = extractPath;
	exports.parsePath = parsePath;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(497);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function extractPath(string) {
	  var match = string.match(/^https?:\/\/[^\/]*/);
	
	  if (match == null) return string;
	
	  return string.substring(match[0].length);
	}
	
	function parsePath(path) {
	  var pathname = extractPath(path);
	  var search = '';
	  var hash = '';
	
	   false ? _warning2['default'](path === pathname, 'A path must be pathname + search + hash only, not a fully qualified URL like "%s"', path) : undefined;
	
	  var hashIndex = pathname.indexOf('#');
	  if (hashIndex !== -1) {
	    hash = pathname.substring(hashIndex);
	    pathname = pathname.substring(0, hashIndex);
	  }
	
	  var searchIndex = pathname.indexOf('?');
	  if (searchIndex !== -1) {
	    search = pathname.substring(searchIndex);
	    pathname = pathname.substring(0, searchIndex);
	  }
	
	  if (pathname === '') pathname = '/';
	
	  return {
	    pathname: pathname,
	    search: search,
	    hash: hash
	  };
	}

/***/ }),
/* 500 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	exports.canUseDOM = canUseDOM;

/***/ }),
/* 501 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.addEventListener = addEventListener;
	exports.removeEventListener = removeEventListener;
	exports.getHashPath = getHashPath;
	exports.replaceHashPath = replaceHashPath;
	exports.getWindowPath = getWindowPath;
	exports.go = go;
	exports.getUserConfirmation = getUserConfirmation;
	exports.supportsHistory = supportsHistory;
	exports.supportsGoWithoutReloadUsingHash = supportsGoWithoutReloadUsingHash;
	
	function addEventListener(node, event, listener) {
	  if (node.addEventListener) {
	    node.addEventListener(event, listener, false);
	  } else {
	    node.attachEvent('on' + event, listener);
	  }
	}
	
	function removeEventListener(node, event, listener) {
	  if (node.removeEventListener) {
	    node.removeEventListener(event, listener, false);
	  } else {
	    node.detachEvent('on' + event, listener);
	  }
	}
	
	function getHashPath() {
	  // We can't use window.location.hash here because it's not
	  // consistent across browsers - Firefox will pre-decode it!
	  return window.location.href.split('#')[1] || '';
	}
	
	function replaceHashPath(path) {
	  window.location.replace(window.location.pathname + window.location.search + '#' + path);
	}
	
	function getWindowPath() {
	  return window.location.pathname + window.location.search + window.location.hash;
	}
	
	function go(n) {
	  if (n) window.history.go(n);
	}
	
	function getUserConfirmation(message, callback) {
	  callback(window.confirm(message));
	}
	
	/**
	 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
	 *
	 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
	 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
	 * changed to avoid false negatives for Windows Phones: https://github.com/rackt/react-router/issues/586
	 */
	
	function supportsHistory() {
	  var ua = navigator.userAgent;
	  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) {
	    return false;
	  }
	  return window.history && 'pushState' in window.history;
	}
	
	/**
	 * Returns false if using go(n) with hash history causes a full page reload.
	 */
	
	function supportsGoWithoutReloadUsingHash() {
	  var ua = navigator.userAgent;
	  return ua.indexOf('Firefox') === -1;
	}

/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

	/*eslint-disable no-empty */
	'use strict';
	
	exports.__esModule = true;
	exports.saveState = saveState;
	exports.readState = readState;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(497);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var KeyPrefix = '@@History/';
	var QuotaExceededErrors = ['QuotaExceededError', 'QUOTA_EXCEEDED_ERR'];
	
	var SecurityError = 'SecurityError';
	
	function createKey(key) {
	  return KeyPrefix + key;
	}
	
	function saveState(key, state) {
	  try {
	    if (state == null) {
	      window.sessionStorage.removeItem(createKey(key));
	    } else {
	      window.sessionStorage.setItem(createKey(key), JSON.stringify(state));
	    }
	  } catch (error) {
	    if (error.name === SecurityError) {
	      // Blocking cookies in Chrome/Firefox/Safari throws SecurityError on any
	      // attempt to access window.sessionStorage.
	       false ? _warning2['default'](false, '[history] Unable to save state; sessionStorage is not available due to security settings') : undefined;
	
	      return;
	    }
	
	    if (QuotaExceededErrors.indexOf(error.name) >= 0 && window.sessionStorage.length === 0) {
	      // Safari "private mode" throws QuotaExceededError.
	       false ? _warning2['default'](false, '[history] Unable to save state; sessionStorage is not available in Safari private mode') : undefined;
	
	      return;
	    }
	
	    throw error;
	  }
	}
	
	function readState(key) {
	  var json = undefined;
	  try {
	    json = window.sessionStorage.getItem(createKey(key));
	  } catch (error) {
	    if (error.name === SecurityError) {
	      // Blocking cookies in Chrome/Firefox/Safari throws SecurityError on any
	      // attempt to access window.sessionStorage.
	       false ? _warning2['default'](false, '[history] Unable to read state; sessionStorage is not available due to security settings') : undefined;
	
	      return null;
	    }
	  }
	
	  if (json) {
	    try {
	      return JSON.parse(json);
	    } catch (error) {
	      // Ignore invalid JSON.
	    }
	  }
	
	  return null;
	}

/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _invariant = __webpack_require__(494);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _ExecutionEnvironment = __webpack_require__(500);
	
	var _DOMUtils = __webpack_require__(501);
	
	var _createHistory = __webpack_require__(504);
	
	var _createHistory2 = _interopRequireDefault(_createHistory);
	
	function createDOMHistory(options) {
	  var history = _createHistory2['default'](_extends({
	    getUserConfirmation: _DOMUtils.getUserConfirmation
	  }, options, {
	    go: _DOMUtils.go
	  }));
	
	  function listen(listener) {
	    !_ExecutionEnvironment.canUseDOM ?  false ? _invariant2['default'](false, 'DOM history needs a DOM') : _invariant2['default'](false) : undefined;
	
	    return history.listen(listener);
	  }
	
	  return _extends({}, history, {
	    listen: listen
	  });
	}
	
	exports['default'] = createDOMHistory;
	module.exports = exports['default'];

/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(497);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _deepEqual = __webpack_require__(505);
	
	var _deepEqual2 = _interopRequireDefault(_deepEqual);
	
	var _PathUtils = __webpack_require__(499);
	
	var _AsyncUtils = __webpack_require__(508);
	
	var _Actions = __webpack_require__(498);
	
	var _createLocation2 = __webpack_require__(509);
	
	var _createLocation3 = _interopRequireDefault(_createLocation2);
	
	var _runTransitionHook = __webpack_require__(510);
	
	var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);
	
	var _deprecate = __webpack_require__(511);
	
	var _deprecate2 = _interopRequireDefault(_deprecate);
	
	function createRandomKey(length) {
	  return Math.random().toString(36).substr(2, length);
	}
	
	function locationsAreEqual(a, b) {
	  return a.pathname === b.pathname && a.search === b.search &&
	  //a.action === b.action && // Different action !== location change.
	  a.key === b.key && _deepEqual2['default'](a.state, b.state);
	}
	
	var DefaultKeyLength = 6;
	
	function createHistory() {
	  var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	  var getCurrentLocation = options.getCurrentLocation;
	  var finishTransition = options.finishTransition;
	  var saveState = options.saveState;
	  var go = options.go;
	  var getUserConfirmation = options.getUserConfirmation;
	  var keyLength = options.keyLength;
	
	  if (typeof keyLength !== 'number') keyLength = DefaultKeyLength;
	
	  var transitionHooks = [];
	
	  function listenBefore(hook) {
	    transitionHooks.push(hook);
	
	    return function () {
	      transitionHooks = transitionHooks.filter(function (item) {
	        return item !== hook;
	      });
	    };
	  }
	
	  var allKeys = [];
	  var changeListeners = [];
	  var location = undefined;
	
	  function getCurrent() {
	    if (pendingLocation && pendingLocation.action === _Actions.POP) {
	      return allKeys.indexOf(pendingLocation.key);
	    } else if (location) {
	      return allKeys.indexOf(location.key);
	    } else {
	      return -1;
	    }
	  }
	
	  function updateLocation(newLocation) {
	    var current = getCurrent();
	
	    location = newLocation;
	
	    if (location.action === _Actions.PUSH) {
	      allKeys = [].concat(allKeys.slice(0, current + 1), [location.key]);
	    } else if (location.action === _Actions.REPLACE) {
	      allKeys[current] = location.key;
	    }
	
	    changeListeners.forEach(function (listener) {
	      listener(location);
	    });
	  }
	
	  function listen(listener) {
	    changeListeners.push(listener);
	
	    if (location) {
	      listener(location);
	    } else {
	      var _location = getCurrentLocation();
	      allKeys = [_location.key];
	      updateLocation(_location);
	    }
	
	    return function () {
	      changeListeners = changeListeners.filter(function (item) {
	        return item !== listener;
	      });
	    };
	  }
	
	  function confirmTransitionTo(location, callback) {
	    _AsyncUtils.loopAsync(transitionHooks.length, function (index, next, done) {
	      _runTransitionHook2['default'](transitionHooks[index], location, function (result) {
	        if (result != null) {
	          done(result);
	        } else {
	          next();
	        }
	      });
	    }, function (message) {
	      if (getUserConfirmation && typeof message === 'string') {
	        getUserConfirmation(message, function (ok) {
	          callback(ok !== false);
	        });
	      } else {
	        callback(message !== false);
	      }
	    });
	  }
	
	  var pendingLocation = undefined;
	
	  function transitionTo(nextLocation) {
	    if (location && locationsAreEqual(location, nextLocation)) return; // Nothing to do.
	
	    pendingLocation = nextLocation;
	
	    confirmTransitionTo(nextLocation, function (ok) {
	      if (pendingLocation !== nextLocation) return; // Transition was interrupted.
	
	      if (ok) {
	        // treat PUSH to current path like REPLACE to be consistent with browsers
	        if (nextLocation.action === _Actions.PUSH) {
	          var prevPath = createPath(location);
	          var nextPath = createPath(nextLocation);
	
	          if (nextPath === prevPath && _deepEqual2['default'](location.state, nextLocation.state)) nextLocation.action = _Actions.REPLACE;
	        }
	
	        if (finishTransition(nextLocation) !== false) updateLocation(nextLocation);
	      } else if (location && nextLocation.action === _Actions.POP) {
	        var prevIndex = allKeys.indexOf(location.key);
	        var nextIndex = allKeys.indexOf(nextLocation.key);
	
	        if (prevIndex !== -1 && nextIndex !== -1) go(prevIndex - nextIndex); // Restore the URL.
	      }
	    });
	  }
	
	  function push(location) {
	    transitionTo(createLocation(location, _Actions.PUSH, createKey()));
	  }
	
	  function replace(location) {
	    transitionTo(createLocation(location, _Actions.REPLACE, createKey()));
	  }
	
	  function goBack() {
	    go(-1);
	  }
	
	  function goForward() {
	    go(1);
	  }
	
	  function createKey() {
	    return createRandomKey(keyLength);
	  }
	
	  function createPath(location) {
	    if (location == null || typeof location === 'string') return location;
	
	    var pathname = location.pathname;
	    var search = location.search;
	    var hash = location.hash;
	
	    var result = pathname;
	
	    if (search) result += search;
	
	    if (hash) result += hash;
	
	    return result;
	  }
	
	  function createHref(location) {
	    return createPath(location);
	  }
	
	  function createLocation(location, action) {
	    var key = arguments.length <= 2 || arguments[2] === undefined ? createKey() : arguments[2];
	
	    if (typeof action === 'object') {
	       false ? _warning2['default'](false, 'The state (2nd) argument to history.createLocation is deprecated; use a ' + 'location descriptor instead') : undefined;
	
	      if (typeof location === 'string') location = _PathUtils.parsePath(location);
	
	      location = _extends({}, location, { state: action });
	
	      action = key;
	      key = arguments[3] || createKey();
	    }
	
	    return _createLocation3['default'](location, action, key);
	  }
	
	  // deprecated
	  function setState(state) {
	    if (location) {
	      updateLocationState(location, state);
	      updateLocation(location);
	    } else {
	      updateLocationState(getCurrentLocation(), state);
	    }
	  }
	
	  function updateLocationState(location, state) {
	    location.state = _extends({}, location.state, state);
	    saveState(location.key, location.state);
	  }
	
	  // deprecated
	  function registerTransitionHook(hook) {
	    if (transitionHooks.indexOf(hook) === -1) transitionHooks.push(hook);
	  }
	
	  // deprecated
	  function unregisterTransitionHook(hook) {
	    transitionHooks = transitionHooks.filter(function (item) {
	      return item !== hook;
	    });
	  }
	
	  // deprecated
	  function pushState(state, path) {
	    if (typeof path === 'string') path = _PathUtils.parsePath(path);
	
	    push(_extends({ state: state }, path));
	  }
	
	  // deprecated
	  function replaceState(state, path) {
	    if (typeof path === 'string') path = _PathUtils.parsePath(path);
	
	    replace(_extends({ state: state }, path));
	  }
	
	  return {
	    listenBefore: listenBefore,
	    listen: listen,
	    transitionTo: transitionTo,
	    push: push,
	    replace: replace,
	    go: go,
	    goBack: goBack,
	    goForward: goForward,
	    createKey: createKey,
	    createPath: createPath,
	    createHref: createHref,
	    createLocation: createLocation,
	
	    setState: _deprecate2['default'](setState, 'setState is deprecated; use location.key to save state instead'),
	    registerTransitionHook: _deprecate2['default'](registerTransitionHook, 'registerTransitionHook is deprecated; use listenBefore instead'),
	    unregisterTransitionHook: _deprecate2['default'](unregisterTransitionHook, 'unregisterTransitionHook is deprecated; use the callback returned from listenBefore instead'),
	    pushState: _deprecate2['default'](pushState, 'pushState is deprecated; use push instead'),
	    replaceState: _deprecate2['default'](replaceState, 'replaceState is deprecated; use replace instead')
	  };
	}
	
	exports['default'] = createHistory;
	module.exports = exports['default'];

/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {

	var pSlice = Array.prototype.slice;
	var objectKeys = __webpack_require__(506);
	var isArguments = __webpack_require__(507);
	
	var deepEqual = module.exports = function (actual, expected, opts) {
	  if (!opts) opts = {};
	  // 7.1. All identical values are equivalent, as determined by ===.
	  if (actual === expected) {
	    return true;
	
	  } else if (actual instanceof Date && expected instanceof Date) {
	    return actual.getTime() === expected.getTime();
	
	  // 7.3. Other pairs that do not both pass typeof value == 'object',
	  // equivalence is determined by ==.
	  } else if (!actual || !expected || typeof actual != 'object' && typeof expected != 'object') {
	    return opts.strict ? actual === expected : actual == expected;
	
	  // 7.4. For all other Object pairs, including Array objects, equivalence is
	  // determined by having the same number of owned properties (as verified
	  // with Object.prototype.hasOwnProperty.call), the same set of keys
	  // (although not necessarily the same order), equivalent values for every
	  // corresponding key, and an identical 'prototype' property. Note: this
	  // accounts for both named and indexed properties on Arrays.
	  } else {
	    return objEquiv(actual, expected, opts);
	  }
	}
	
	function isUndefinedOrNull(value) {
	  return value === null || value === undefined;
	}
	
	function isBuffer (x) {
	  if (!x || typeof x !== 'object' || typeof x.length !== 'number') return false;
	  if (typeof x.copy !== 'function' || typeof x.slice !== 'function') {
	    return false;
	  }
	  if (x.length > 0 && typeof x[0] !== 'number') return false;
	  return true;
	}
	
	function objEquiv(a, b, opts) {
	  var i, key;
	  if (isUndefinedOrNull(a) || isUndefinedOrNull(b))
	    return false;
	  // an identical 'prototype' property.
	  if (a.prototype !== b.prototype) return false;
	  //~~~I've managed to break Object.keys through screwy arguments passing.
	  //   Converting to array solves the problem.
	  if (isArguments(a)) {
	    if (!isArguments(b)) {
	      return false;
	    }
	    a = pSlice.call(a);
	    b = pSlice.call(b);
	    return deepEqual(a, b, opts);
	  }
	  if (isBuffer(a)) {
	    if (!isBuffer(b)) {
	      return false;
	    }
	    if (a.length !== b.length) return false;
	    for (i = 0; i < a.length; i++) {
	      if (a[i] !== b[i]) return false;
	    }
	    return true;
	  }
	  try {
	    var ka = objectKeys(a),
	        kb = objectKeys(b);
	  } catch (e) {//happens when one is a string literal and the other isn't
	    return false;
	  }
	  // having the same number of owned properties (keys incorporates
	  // hasOwnProperty)
	  if (ka.length != kb.length)
	    return false;
	  //the same set of keys (although not necessarily the same order),
	  ka.sort();
	  kb.sort();
	  //~~~cheap key test
	  for (i = ka.length - 1; i >= 0; i--) {
	    if (ka[i] != kb[i])
	      return false;
	  }
	  //equivalent values for every corresponding key, and
	  //~~~possibly expensive deep test
	  for (i = ka.length - 1; i >= 0; i--) {
	    key = ka[i];
	    if (!deepEqual(a[key], b[key], opts)) return false;
	  }
	  return typeof a === typeof b;
	}


/***/ }),
/* 506 */
/***/ (function(module, exports) {

	exports = module.exports = typeof Object.keys === 'function'
	  ? Object.keys : shim;
	
	exports.shim = shim;
	function shim (obj) {
	  var keys = [];
	  for (var key in obj) keys.push(key);
	  return keys;
	}


/***/ }),
/* 507 */
/***/ (function(module, exports) {

	var supportsArgumentsClass = (function(){
	  return Object.prototype.toString.call(arguments)
	})() == '[object Arguments]';
	
	exports = module.exports = supportsArgumentsClass ? supported : unsupported;
	
	exports.supported = supported;
	function supported(object) {
	  return Object.prototype.toString.call(object) == '[object Arguments]';
	};
	
	exports.unsupported = unsupported;
	function unsupported(object){
	  return object &&
	    typeof object == 'object' &&
	    typeof object.length == 'number' &&
	    Object.prototype.hasOwnProperty.call(object, 'callee') &&
	    !Object.prototype.propertyIsEnumerable.call(object, 'callee') ||
	    false;
	};


/***/ }),
/* 508 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	var _slice = Array.prototype.slice;
	exports.loopAsync = loopAsync;
	
	function loopAsync(turns, work, callback) {
	  var currentTurn = 0,
	      isDone = false;
	  var sync = false,
	      hasNext = false,
	      doneArgs = undefined;
	
	  function done() {
	    isDone = true;
	    if (sync) {
	      // Iterate instead of recursing if possible.
	      doneArgs = [].concat(_slice.call(arguments));
	      return;
	    }
	
	    callback.apply(this, arguments);
	  }
	
	  function next() {
	    if (isDone) {
	      return;
	    }
	
	    hasNext = true;
	    if (sync) {
	      // Iterate instead of recursing if possible.
	      return;
	    }
	
	    sync = true;
	
	    while (!isDone && currentTurn < turns && hasNext) {
	      hasNext = false;
	      work.call(this, currentTurn++, next, done);
	    }
	
	    sync = false;
	
	    if (isDone) {
	      // This means the loop finished synchronously.
	      callback.apply(this, doneArgs);
	      return;
	    }
	
	    if (currentTurn >= turns && hasNext) {
	      isDone = true;
	      callback();
	    }
	  }
	
	  next();
	}

/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(497);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _Actions = __webpack_require__(498);
	
	var _PathUtils = __webpack_require__(499);
	
	function createLocation() {
	  var location = arguments.length <= 0 || arguments[0] === undefined ? '/' : arguments[0];
	  var action = arguments.length <= 1 || arguments[1] === undefined ? _Actions.POP : arguments[1];
	  var key = arguments.length <= 2 || arguments[2] === undefined ? null : arguments[2];
	
	  var _fourthArg = arguments.length <= 3 || arguments[3] === undefined ? null : arguments[3];
	
	  if (typeof location === 'string') location = _PathUtils.parsePath(location);
	
	  if (typeof action === 'object') {
	     false ? _warning2['default'](false, 'The state (2nd) argument to createLocation is deprecated; use a ' + 'location descriptor instead') : undefined;
	
	    location = _extends({}, location, { state: action });
	
	    action = key || _Actions.POP;
	    key = _fourthArg;
	  }
	
	  var pathname = location.pathname || '/';
	  var search = location.search || '';
	  var hash = location.hash || '';
	  var state = location.state || null;
	
	  return {
	    pathname: pathname,
	    search: search,
	    hash: hash,
	    state: state,
	    action: action,
	    key: key
	  };
	}
	
	exports['default'] = createLocation;
	module.exports = exports['default'];

/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(497);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function runTransitionHook(hook, location, callback) {
	  var result = hook(location, callback);
	
	  if (hook.length < 2) {
	    // Assume the hook runs synchronously and automatically
	    // call the callback with the return value.
	    callback(result);
	  } else {
	     false ? _warning2['default'](result === undefined, 'You should not "return" in a transition hook with a callback argument; call the callback instead') : undefined;
	  }
	}
	
	exports['default'] = runTransitionHook;
	module.exports = exports['default'];

/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(497);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function deprecate(fn, message) {
	  return function () {
	     false ? _warning2['default'](false, '[history] ' + message) : undefined;
	    return fn.apply(this, arguments);
	  };
	}
	
	exports['default'] = deprecate;
	module.exports = exports['default'];

/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(497);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _queryString = __webpack_require__(513);
	
	var _runTransitionHook = __webpack_require__(510);
	
	var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);
	
	var _PathUtils = __webpack_require__(499);
	
	var _deprecate = __webpack_require__(511);
	
	var _deprecate2 = _interopRequireDefault(_deprecate);
	
	var SEARCH_BASE_KEY = '$searchBase';
	
	function defaultStringifyQuery(query) {
	  return _queryString.stringify(query).replace(/%20/g, '+');
	}
	
	var defaultParseQueryString = _queryString.parse;
	
	function isNestedObject(object) {
	  for (var p in object) {
	    if (Object.prototype.hasOwnProperty.call(object, p) && typeof object[p] === 'object' && !Array.isArray(object[p]) && object[p] !== null) return true;
	  }return false;
	}
	
	/**
	 * Returns a new createHistory function that may be used to create
	 * history objects that know how to handle URL queries.
	 */
	function useQueries(createHistory) {
	  return function () {
	    var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	    var history = createHistory(options);
	
	    var stringifyQuery = options.stringifyQuery;
	    var parseQueryString = options.parseQueryString;
	
	    if (typeof stringifyQuery !== 'function') stringifyQuery = defaultStringifyQuery;
	
	    if (typeof parseQueryString !== 'function') parseQueryString = defaultParseQueryString;
	
	    function addQuery(location) {
	      if (location.query == null) {
	        var search = location.search;
	
	        location.query = parseQueryString(search.substring(1));
	        location[SEARCH_BASE_KEY] = { search: search, searchBase: '' };
	      }
	
	      // TODO: Instead of all the book-keeping here, this should just strip the
	      // stringified query from the search.
	
	      return location;
	    }
	
	    function appendQuery(location, query) {
	      var _extends2;
	
	      var searchBaseSpec = location[SEARCH_BASE_KEY];
	      var queryString = query ? stringifyQuery(query) : '';
	      if (!searchBaseSpec && !queryString) {
	        return location;
	      }
	
	       false ? _warning2['default'](stringifyQuery !== defaultStringifyQuery || !isNestedObject(query), 'useQueries does not stringify nested query objects by default; ' + 'use a custom stringifyQuery function') : undefined;
	
	      if (typeof location === 'string') location = _PathUtils.parsePath(location);
	
	      var searchBase = undefined;
	      if (searchBaseSpec && location.search === searchBaseSpec.search) {
	        searchBase = searchBaseSpec.searchBase;
	      } else {
	        searchBase = location.search || '';
	      }
	
	      var search = searchBase;
	      if (queryString) {
	        search += (search ? '&' : '?') + queryString;
	      }
	
	      return _extends({}, location, (_extends2 = {
	        search: search
	      }, _extends2[SEARCH_BASE_KEY] = { search: search, searchBase: searchBase }, _extends2));
	    }
	
	    // Override all read methods with query-aware versions.
	    function listenBefore(hook) {
	      return history.listenBefore(function (location, callback) {
	        _runTransitionHook2['default'](hook, addQuery(location), callback);
	      });
	    }
	
	    function listen(listener) {
	      return history.listen(function (location) {
	        listener(addQuery(location));
	      });
	    }
	
	    // Override all write methods with query-aware versions.
	    function push(location) {
	      history.push(appendQuery(location, location.query));
	    }
	
	    function replace(location) {
	      history.replace(appendQuery(location, location.query));
	    }
	
	    function createPath(location, query) {
	       false ? _warning2['default'](!query, 'the query argument to createPath is deprecated; use a location descriptor instead') : undefined;
	
	      return history.createPath(appendQuery(location, query || location.query));
	    }
	
	    function createHref(location, query) {
	       false ? _warning2['default'](!query, 'the query argument to createHref is deprecated; use a location descriptor instead') : undefined;
	
	      return history.createHref(appendQuery(location, query || location.query));
	    }
	
	    function createLocation(location) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      var fullLocation = history.createLocation.apply(history, [appendQuery(location, location.query)].concat(args));
	      if (location.query) {
	        fullLocation.query = location.query;
	      }
	      return addQuery(fullLocation);
	    }
	
	    // deprecated
	    function pushState(state, path, query) {
	      if (typeof path === 'string') path = _PathUtils.parsePath(path);
	
	      push(_extends({ state: state }, path, { query: query }));
	    }
	
	    // deprecated
	    function replaceState(state, path, query) {
	      if (typeof path === 'string') path = _PathUtils.parsePath(path);
	
	      replace(_extends({ state: state }, path, { query: query }));
	    }
	
	    return _extends({}, history, {
	      listenBefore: listenBefore,
	      listen: listen,
	      push: push,
	      replace: replace,
	      createPath: createPath,
	      createHref: createHref,
	      createLocation: createLocation,
	
	      pushState: _deprecate2['default'](pushState, 'pushState is deprecated; use push instead'),
	      replaceState: _deprecate2['default'](replaceState, 'replaceState is deprecated; use replace instead')
	    });
	  };
	}
	
	exports['default'] = useQueries;
	module.exports = exports['default'];

/***/ }),
/* 513 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var strictUriEncode = __webpack_require__(514);
	
	exports.extract = function (str) {
		return str.split('?')[1] || '';
	};
	
	exports.parse = function (str) {
		if (typeof str !== 'string') {
			return {};
		}
	
		str = str.trim().replace(/^(\?|#|&)/, '');
	
		if (!str) {
			return {};
		}
	
		return str.split('&').reduce(function (ret, param) {
			var parts = param.replace(/\+/g, ' ').split('=');
			// Firefox (pre 40) decodes `%3D` to `=`
			// https://github.com/sindresorhus/query-string/pull/37
			var key = parts.shift();
			var val = parts.length > 0 ? parts.join('=') : undefined;
	
			key = decodeURIComponent(key);
	
			// missing `=` should be `null`:
			// http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
			val = val === undefined ? null : decodeURIComponent(val);
	
			if (!ret.hasOwnProperty(key)) {
				ret[key] = val;
			} else if (Array.isArray(ret[key])) {
				ret[key].push(val);
			} else {
				ret[key] = [ret[key], val];
			}
	
			return ret;
		}, {});
	};
	
	exports.stringify = function (obj) {
		return obj ? Object.keys(obj).sort().map(function (key) {
			var val = obj[key];
	
			if (val === undefined) {
				return '';
			}
	
			if (val === null) {
				return key;
			}
	
			if (Array.isArray(val)) {
				return val.slice().sort().map(function (val2) {
					return strictUriEncode(key) + '=' + strictUriEncode(val2);
				}).join('&');
			}
	
			return strictUriEncode(key) + '=' + strictUriEncode(val);
		}).filter(function (x) {
			return x.length > 0;
		}).join('&') : '';
	};


/***/ }),
/* 514 */
/***/ (function(module, exports) {

	'use strict';
	module.exports = function (str) {
		return encodeURIComponent(str).replace(/[!'()*]/g, function (c) {
			return '%' + c.charCodeAt(0).toString(16).toUpperCase();
		});
	};


/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = createTransitionManager;
	
	var _routerWarning = __webpack_require__(490);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _Actions = __webpack_require__(498);
	
	var _computeChangedRoutes2 = __webpack_require__(516);
	
	var _computeChangedRoutes3 = _interopRequireDefault(_computeChangedRoutes2);
	
	var _TransitionUtils = __webpack_require__(517);
	
	var _isActive2 = __webpack_require__(519);
	
	var _isActive3 = _interopRequireDefault(_isActive2);
	
	var _getComponents = __webpack_require__(520);
	
	var _getComponents2 = _interopRequireDefault(_getComponents);
	
	var _matchRoutes = __webpack_require__(522);
	
	var _matchRoutes2 = _interopRequireDefault(_matchRoutes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function hasAnyProperties(object) {
	  for (var p in object) {
	    if (Object.prototype.hasOwnProperty.call(object, p)) return true;
	  }return false;
	}
	
	function createTransitionManager(history, routes) {
	  var state = {};
	
	  // Signature should be (location, indexOnly), but needs to support (path,
	  // query, indexOnly)
	  function isActive(location) {
	    var indexOnlyOrDeprecatedQuery = arguments.length <= 1 || arguments[1] === undefined ? false : arguments[1];
	    var deprecatedIndexOnly = arguments.length <= 2 || arguments[2] === undefined ? null : arguments[2];
	
	    var indexOnly = void 0;
	    if (indexOnlyOrDeprecatedQuery && indexOnlyOrDeprecatedQuery !== true || deprecatedIndexOnly !== null) {
	       false ? (0, _routerWarning2.default)(false, '`isActive(pathname, query, indexOnly) is deprecated; use `isActive(location, indexOnly)` with a location descriptor instead. http://tiny.cc/router-isActivedeprecated') : void 0;
	      location = { pathname: location, query: indexOnlyOrDeprecatedQuery };
	      indexOnly = deprecatedIndexOnly || false;
	    } else {
	      location = history.createLocation(location);
	      indexOnly = indexOnlyOrDeprecatedQuery;
	    }
	
	    return (0, _isActive3.default)(location, indexOnly, state.location, state.routes, state.params);
	  }
	
	  function createLocationFromRedirectInfo(location) {
	    return history.createLocation(location, _Actions.REPLACE);
	  }
	
	  var partialNextState = void 0;
	
	  function match(location, callback) {
	    if (partialNextState && partialNextState.location === location) {
	      // Continue from where we left off.
	      finishMatch(partialNextState, callback);
	    } else {
	      (0, _matchRoutes2.default)(routes, location, function (error, nextState) {
	        if (error) {
	          callback(error);
	        } else if (nextState) {
	          finishMatch(_extends({}, nextState, { location: location }), callback);
	        } else {
	          callback();
	        }
	      });
	    }
	  }
	
	  function finishMatch(nextState, callback) {
	    var _computeChangedRoutes = (0, _computeChangedRoutes3.default)(state, nextState);
	
	    var leaveRoutes = _computeChangedRoutes.leaveRoutes;
	    var changeRoutes = _computeChangedRoutes.changeRoutes;
	    var enterRoutes = _computeChangedRoutes.enterRoutes;
	
	
	    (0, _TransitionUtils.runLeaveHooks)(leaveRoutes, state);
	
	    // Tear down confirmation hooks for left routes
	    leaveRoutes.filter(function (route) {
	      return enterRoutes.indexOf(route) === -1;
	    }).forEach(removeListenBeforeHooksForRoute);
	
	    // change and enter hooks are run in series
	    (0, _TransitionUtils.runChangeHooks)(changeRoutes, state, nextState, function (error, redirectInfo) {
	      if (error || redirectInfo) return handleErrorOrRedirect(error, redirectInfo);
	
	      (0, _TransitionUtils.runEnterHooks)(enterRoutes, nextState, finishEnterHooks);
	    });
	
	    function finishEnterHooks(error, redirectInfo) {
	      if (error || redirectInfo) return handleErrorOrRedirect(error, redirectInfo);
	
	      // TODO: Fetch components after state is updated.
	      (0, _getComponents2.default)(nextState, function (error, components) {
	        if (error) {
	          callback(error);
	        } else {
	          // TODO: Make match a pure function and have some other API
	          // for "match and update state".
	          callback(null, null, state = _extends({}, nextState, { components: components }));
	        }
	      });
	    }
	
	    function handleErrorOrRedirect(error, redirectInfo) {
	      if (error) callback(error);else callback(null, createLocationFromRedirectInfo(redirectInfo));
	    }
	  }
	
	  var RouteGuid = 1;
	
	  function getRouteID(route) {
	    var create = arguments.length <= 1 || arguments[1] === undefined ? true : arguments[1];
	
	    return route.__id__ || create && (route.__id__ = RouteGuid++);
	  }
	
	  var RouteHooks = Object.create(null);
	
	  function getRouteHooksForRoutes(routes) {
	    return routes.reduce(function (hooks, route) {
	      hooks.push.apply(hooks, RouteHooks[getRouteID(route)]);
	      return hooks;
	    }, []);
	  }
	
	  function transitionHook(location, callback) {
	    (0, _matchRoutes2.default)(routes, location, function (error, nextState) {
	      if (nextState == null) {
	        // TODO: We didn't actually match anything, but hang
	        // onto error/nextState so we don't have to matchRoutes
	        // again in the listen callback.
	        callback();
	        return;
	      }
	
	      // Cache some state here so we don't have to
	      // matchRoutes() again in the listen callback.
	      partialNextState = _extends({}, nextState, { location: location });
	
	      var hooks = getRouteHooksForRoutes((0, _computeChangedRoutes3.default)(state, partialNextState).leaveRoutes);
	
	      var result = void 0;
	      for (var i = 0, len = hooks.length; result == null && i < len; ++i) {
	        // Passing the location arg here indicates to
	        // the user that this is a transition hook.
	        result = hooks[i](location);
	      }
	
	      callback(result);
	    });
	  }
	
	  /* istanbul ignore next: untestable with Karma */
	  function beforeUnloadHook() {
	    // Synchronously check to see if any route hooks want
	    // to prevent the current window/tab from closing.
	    if (state.routes) {
	      var hooks = getRouteHooksForRoutes(state.routes);
	
	      var message = void 0;
	      for (var i = 0, len = hooks.length; typeof message !== 'string' && i < len; ++i) {
	        // Passing no args indicates to the user that this is a
	        // beforeunload hook. We don't know the next location.
	        message = hooks[i]();
	      }
	
	      return message;
	    }
	  }
	
	  var unlistenBefore = void 0,
	      unlistenBeforeUnload = void 0;
	
	  function removeListenBeforeHooksForRoute(route) {
	    var routeID = getRouteID(route, false);
	    if (!routeID) {
	      return;
	    }
	
	    delete RouteHooks[routeID];
	
	    if (!hasAnyProperties(RouteHooks)) {
	      // teardown transition & beforeunload hooks
	      if (unlistenBefore) {
	        unlistenBefore();
	        unlistenBefore = null;
	      }
	
	      if (unlistenBeforeUnload) {
	        unlistenBeforeUnload();
	        unlistenBeforeUnload = null;
	      }
	    }
	  }
	
	  /**
	   * Registers the given hook function to run before leaving the given route.
	   *
	   * During a normal transition, the hook function receives the next location
	   * as its only argument and can return either a prompt message (string) to show the user,
	   * to make sure they want to leave the page; or `false`, to prevent the transition.
	   * Any other return value will have no effect.
	   *
	   * During the beforeunload event (in browsers) the hook receives no arguments.
	   * In this case it must return a prompt message to prevent the transition.
	   *
	   * Returns a function that may be used to unbind the listener.
	   */
	  function listenBeforeLeavingRoute(route, hook) {
	    // TODO: Warn if they register for a route that isn't currently
	    // active. They're probably doing something wrong, like re-creating
	    // route objects on every location change.
	    var routeID = getRouteID(route);
	    var hooks = RouteHooks[routeID];
	
	    if (!hooks) {
	      var thereWereNoRouteHooks = !hasAnyProperties(RouteHooks);
	
	      RouteHooks[routeID] = [hook];
	
	      if (thereWereNoRouteHooks) {
	        // setup transition & beforeunload hooks
	        unlistenBefore = history.listenBefore(transitionHook);
	
	        if (history.listenBeforeUnload) unlistenBeforeUnload = history.listenBeforeUnload(beforeUnloadHook);
	      }
	    } else {
	      if (hooks.indexOf(hook) === -1) {
	         false ? (0, _routerWarning2.default)(false, 'adding multiple leave hooks for the same route is deprecated; manage multiple confirmations in your own code instead') : void 0;
	
	        hooks.push(hook);
	      }
	    }
	
	    return function () {
	      var hooks = RouteHooks[routeID];
	
	      if (hooks) {
	        var newHooks = hooks.filter(function (item) {
	          return item !== hook;
	        });
	
	        if (newHooks.length === 0) {
	          removeListenBeforeHooksForRoute(route);
	        } else {
	          RouteHooks[routeID] = newHooks;
	        }
	      }
	    };
	  }
	
	  /**
	   * This is the API for stateful environments. As the location
	   * changes, we update state and call the listener. We can also
	   * gracefully handle errors and redirects.
	   */
	  function listen(listener) {
	    // TODO: Only use a single history listener. Otherwise we'll
	    // end up with multiple concurrent calls to match.
	    return history.listen(function (location) {
	      if (state.location === location) {
	        listener(null, state);
	      } else {
	        match(location, function (error, redirectLocation, nextState) {
	          if (error) {
	            listener(error);
	          } else if (redirectLocation) {
	            history.transitionTo(redirectLocation);
	          } else if (nextState) {
	            listener(null, nextState);
	          } else {
	             false ? (0, _routerWarning2.default)(false, 'Location "%s" did not match any routes', location.pathname + location.search + location.hash) : void 0;
	          }
	        });
	      }
	    });
	  }
	
	  return {
	    isActive: isActive,
	    match: match,
	    listenBeforeLeavingRoute: listenBeforeLeavingRoute,
	    listen: listen
	  };
	}
	
	//export default useRoutes
	
	module.exports = exports['default'];

/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _PatternUtils = __webpack_require__(493);
	
	function routeParamsChanged(route, prevState, nextState) {
	  if (!route.path) return false;
	
	  var paramNames = (0, _PatternUtils.getParamNames)(route.path);
	
	  return paramNames.some(function (paramName) {
	    return prevState.params[paramName] !== nextState.params[paramName];
	  });
	}
	
	/**
	 * Returns an object of { leaveRoutes, changeRoutes, enterRoutes } determined by
	 * the change from prevState to nextState. We leave routes if either
	 * 1) they are not in the next state or 2) they are in the next state
	 * but their params have changed (i.e. /users/123 => /users/456).
	 *
	 * leaveRoutes are ordered starting at the leaf route of the tree
	 * we're leaving up to the common parent route. enterRoutes are ordered
	 * from the top of the tree we're entering down to the leaf route.
	 *
	 * changeRoutes are any routes that didn't leave or enter during
	 * the transition.
	 */
	function computeChangedRoutes(prevState, nextState) {
	  var prevRoutes = prevState && prevState.routes;
	  var nextRoutes = nextState.routes;
	
	  var leaveRoutes = void 0,
	      changeRoutes = void 0,
	      enterRoutes = void 0;
	  if (prevRoutes) {
	    (function () {
	      var parentIsLeaving = false;
	      leaveRoutes = prevRoutes.filter(function (route) {
	        if (parentIsLeaving) {
	          return true;
	        } else {
	          var isLeaving = nextRoutes.indexOf(route) === -1 || routeParamsChanged(route, prevState, nextState);
	          if (isLeaving) parentIsLeaving = true;
	          return isLeaving;
	        }
	      });
	
	      // onLeave hooks start at the leaf route.
	      leaveRoutes.reverse();
	
	      enterRoutes = [];
	      changeRoutes = [];
	
	      nextRoutes.forEach(function (route) {
	        var isNew = prevRoutes.indexOf(route) === -1;
	        var paramsChanged = leaveRoutes.indexOf(route) !== -1;
	
	        if (isNew || paramsChanged) enterRoutes.push(route);else changeRoutes.push(route);
	      });
	    })();
	  } else {
	    leaveRoutes = [];
	    changeRoutes = [];
	    enterRoutes = nextRoutes;
	  }
	
	  return {
	    leaveRoutes: leaveRoutes,
	    changeRoutes: changeRoutes,
	    enterRoutes: enterRoutes
	  };
	}
	
	exports.default = computeChangedRoutes;
	module.exports = exports['default'];

/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.runEnterHooks = runEnterHooks;
	exports.runChangeHooks = runChangeHooks;
	exports.runLeaveHooks = runLeaveHooks;
	
	var _AsyncUtils = __webpack_require__(518);
	
	var _routerWarning = __webpack_require__(490);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function createTransitionHook(hook, route, asyncArity) {
	  return function () {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    hook.apply(route, args);
	
	    if (hook.length < asyncArity) {
	      var callback = args[args.length - 1];
	      // Assume hook executes synchronously and
	      // automatically call the callback.
	      callback();
	    }
	  };
	}
	
	function getEnterHooks(routes) {
	  return routes.reduce(function (hooks, route) {
	    if (route.onEnter) hooks.push(createTransitionHook(route.onEnter, route, 3));
	
	    return hooks;
	  }, []);
	}
	
	function getChangeHooks(routes) {
	  return routes.reduce(function (hooks, route) {
	    if (route.onChange) hooks.push(createTransitionHook(route.onChange, route, 4));
	    return hooks;
	  }, []);
	}
	
	function runTransitionHooks(length, iter, callback) {
	  if (!length) {
	    callback();
	    return;
	  }
	
	  var redirectInfo = void 0;
	  function replace(location, deprecatedPathname, deprecatedQuery) {
	    if (deprecatedPathname) {
	       false ? (0, _routerWarning2.default)(false, '`replaceState(state, pathname, query) is deprecated; use `replace(location)` with a location descriptor instead. http://tiny.cc/router-isActivedeprecated') : void 0;
	      redirectInfo = {
	        pathname: deprecatedPathname,
	        query: deprecatedQuery,
	        state: location
	      };
	
	      return;
	    }
	
	    redirectInfo = location;
	  }
	
	  (0, _AsyncUtils.loopAsync)(length, function (index, next, done) {
	    iter(index, replace, function (error) {
	      if (error || redirectInfo) {
	        done(error, redirectInfo); // No need to continue.
	      } else {
	        next();
	      }
	    });
	  }, callback);
	}
	
	/**
	 * Runs all onEnter hooks in the given array of routes in order
	 * with onEnter(nextState, replace, callback) and calls
	 * callback(error, redirectInfo) when finished. The first hook
	 * to use replace short-circuits the loop.
	 *
	 * If a hook needs to run asynchronously, it may use the callback
	 * function. However, doing so will cause the transition to pause,
	 * which could lead to a non-responsive UI if the hook is slow.
	 */
	function runEnterHooks(routes, nextState, callback) {
	  var hooks = getEnterHooks(routes);
	  return runTransitionHooks(hooks.length, function (index, replace, next) {
	    hooks[index](nextState, replace, next);
	  }, callback);
	}
	
	/**
	 * Runs all onChange hooks in the given array of routes in order
	 * with onChange(prevState, nextState, replace, callback) and calls
	 * callback(error, redirectInfo) when finished. The first hook
	 * to use replace short-circuits the loop.
	 *
	 * If a hook needs to run asynchronously, it may use the callback
	 * function. However, doing so will cause the transition to pause,
	 * which could lead to a non-responsive UI if the hook is slow.
	 */
	function runChangeHooks(routes, state, nextState, callback) {
	  var hooks = getChangeHooks(routes);
	  return runTransitionHooks(hooks.length, function (index, replace, next) {
	    hooks[index](state, nextState, replace, next);
	  }, callback);
	}
	
	/**
	 * Runs all onLeave hooks in the given array of routes in order.
	 */
	function runLeaveHooks(routes, prevState) {
	  for (var i = 0, len = routes.length; i < len; ++i) {
	    if (routes[i].onLeave) routes[i].onLeave.call(routes[i], prevState);
	  }
	}

/***/ }),
/* 518 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.loopAsync = loopAsync;
	exports.mapAsync = mapAsync;
	function loopAsync(turns, work, callback) {
	  var currentTurn = 0,
	      isDone = false;
	  var sync = false,
	      hasNext = false,
	      doneArgs = void 0;
	
	  function done() {
	    isDone = true;
	    if (sync) {
	      // Iterate instead of recursing if possible.
	      doneArgs = [].concat(Array.prototype.slice.call(arguments));
	      return;
	    }
	
	    callback.apply(this, arguments);
	  }
	
	  function next() {
	    if (isDone) {
	      return;
	    }
	
	    hasNext = true;
	    if (sync) {
	      // Iterate instead of recursing if possible.
	      return;
	    }
	
	    sync = true;
	
	    while (!isDone && currentTurn < turns && hasNext) {
	      hasNext = false;
	      work.call(this, currentTurn++, next, done);
	    }
	
	    sync = false;
	
	    if (isDone) {
	      // This means the loop finished synchronously.
	      callback.apply(this, doneArgs);
	      return;
	    }
	
	    if (currentTurn >= turns && hasNext) {
	      isDone = true;
	      callback();
	    }
	  }
	
	  next();
	}
	
	function mapAsync(array, work, callback) {
	  var length = array.length;
	  var values = [];
	
	  if (length === 0) return callback(null, values);
	
	  var isDone = false,
	      doneCount = 0;
	
	  function done(index, error, value) {
	    if (isDone) return;
	
	    if (error) {
	      isDone = true;
	      callback(error);
	    } else {
	      values[index] = value;
	
	      isDone = ++doneCount === length;
	
	      if (isDone) callback(null, values);
	    }
	  }
	
	  array.forEach(function (item, index) {
	    work(item, index, function (error, value) {
	      done(index, error, value);
	    });
	  });
	}

/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	exports.default = isActive;
	
	var _PatternUtils = __webpack_require__(493);
	
	function deepEqual(a, b) {
	  if (a == b) return true;
	
	  if (a == null || b == null) return false;
	
	  if (Array.isArray(a)) {
	    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
	      return deepEqual(item, b[index]);
	    });
	  }
	
	  if ((typeof a === 'undefined' ? 'undefined' : _typeof(a)) === 'object') {
	    for (var p in a) {
	      if (!Object.prototype.hasOwnProperty.call(a, p)) {
	        continue;
	      }
	
	      if (a[p] === undefined) {
	        if (b[p] !== undefined) {
	          return false;
	        }
	      } else if (!Object.prototype.hasOwnProperty.call(b, p)) {
	        return false;
	      } else if (!deepEqual(a[p], b[p])) {
	        return false;
	      }
	    }
	
	    return true;
	  }
	
	  return String(a) === String(b);
	}
	
	/**
	 * Returns true if the current pathname matches the supplied one, net of
	 * leading and trailing slash normalization. This is sufficient for an
	 * indexOnly route match.
	 */
	function pathIsActive(pathname, currentPathname) {
	  // Normalize leading slash for consistency. Leading slash on pathname has
	  // already been normalized in isActive. See caveat there.
	  if (currentPathname.charAt(0) !== '/') {
	    currentPathname = '/' + currentPathname;
	  }
	
	  // Normalize the end of both path names too. Maybe `/foo/` shouldn't show
	  // `/foo` as active, but in this case, we would already have failed the
	  // match.
	  if (pathname.charAt(pathname.length - 1) !== '/') {
	    pathname += '/';
	  }
	  if (currentPathname.charAt(currentPathname.length - 1) !== '/') {
	    currentPathname += '/';
	  }
	
	  return currentPathname === pathname;
	}
	
	/**
	 * Returns true if the given pathname matches the active routes and params.
	 */
	function routeIsActive(pathname, routes, params) {
	  var remainingPathname = pathname,
	      paramNames = [],
	      paramValues = [];
	
	  // for...of would work here but it's probably slower post-transpilation.
	  for (var i = 0, len = routes.length; i < len; ++i) {
	    var route = routes[i];
	    var pattern = route.path || '';
	
	    if (pattern.charAt(0) === '/') {
	      remainingPathname = pathname;
	      paramNames = [];
	      paramValues = [];
	    }
	
	    if (remainingPathname !== null && pattern) {
	      var matched = (0, _PatternUtils.matchPattern)(pattern, remainingPathname);
	      if (matched) {
	        remainingPathname = matched.remainingPathname;
	        paramNames = [].concat(paramNames, matched.paramNames);
	        paramValues = [].concat(paramValues, matched.paramValues);
	      } else {
	        remainingPathname = null;
	      }
	
	      if (remainingPathname === '') {
	        // We have an exact match on the route. Just check that all the params
	        // match.
	        // FIXME: This doesn't work on repeated params.
	        return paramNames.every(function (paramName, index) {
	          return String(paramValues[index]) === String(params[paramName]);
	        });
	      }
	    }
	  }
	
	  return false;
	}
	
	/**
	 * Returns true if all key/value pairs in the given query are
	 * currently active.
	 */
	function queryIsActive(query, activeQuery) {
	  if (activeQuery == null) return query == null;
	
	  if (query == null) return true;
	
	  return deepEqual(query, activeQuery);
	}
	
	/**
	 * Returns true if a <Link> to the given pathname/query combination is
	 * currently active.
	 */
	function isActive(_ref, indexOnly, currentLocation, routes, params) {
	  var pathname = _ref.pathname;
	  var query = _ref.query;
	
	  if (currentLocation == null) return false;
	
	  // TODO: This is a bit ugly. It keeps around support for treating pathnames
	  // without preceding slashes as absolute paths, but possibly also works
	  // around the same quirks with basenames as in matchRoutes.
	  if (pathname.charAt(0) !== '/') {
	    pathname = '/' + pathname;
	  }
	
	  if (!pathIsActive(pathname, currentLocation.pathname)) {
	    // The path check is necessary and sufficient for indexOnly, but otherwise
	    // we still need to check the routes.
	    if (indexOnly || !routeIsActive(pathname, routes, params)) {
	      return false;
	    }
	  }
	
	  return queryIsActive(query, currentLocation.query);
	}
	module.exports = exports['default'];

/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _AsyncUtils = __webpack_require__(518);
	
	var _makeStateWithLocation = __webpack_require__(521);
	
	var _makeStateWithLocation2 = _interopRequireDefault(_makeStateWithLocation);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getComponentsForRoute(nextState, route, callback) {
	  if (route.component || route.components) {
	    callback(null, route.component || route.components);
	    return;
	  }
	
	  var getComponent = route.getComponent || route.getComponents;
	  if (!getComponent) {
	    callback();
	    return;
	  }
	
	  var location = nextState.location;
	
	  var nextStateWithLocation = (0, _makeStateWithLocation2.default)(nextState, location);
	
	  getComponent.call(route, nextStateWithLocation, callback);
	}
	
	/**
	 * Asynchronously fetches all components needed for the given router
	 * state and calls callback(error, components) when finished.
	 *
	 * Note: This operation may finish synchronously if no routes have an
	 * asynchronous getComponents method.
	 */
	function getComponents(nextState, callback) {
	  (0, _AsyncUtils.mapAsync)(nextState.routes, function (route, index, callback) {
	    getComponentsForRoute(nextState, route, callback);
	  }, callback);
	}
	
	exports.default = getComponents;
	module.exports = exports['default'];

/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = makeStateWithLocation;
	
	var _deprecateObjectProperties = __webpack_require__(489);
	
	var _routerWarning = __webpack_require__(490);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function makeStateWithLocation(state, location) {
	  if (false) {
	    var stateWithLocation = _extends({}, state);
	
	    // I don't use deprecateObjectProperties here because I want to keep the
	    // same code path between development and production, in that we just
	    // assign extra properties to the copy of the state object in both cases.
	
	    var _loop = function _loop(prop) {
	      if (!Object.prototype.hasOwnProperty.call(location, prop)) {
	        return 'continue';
	      }
	
	      Object.defineProperty(stateWithLocation, prop, {
	        get: function get() {
	          process.env.NODE_ENV !== 'production' ? (0, _routerWarning2.default)(false, 'Accessing location properties directly from the first argument to `getComponent`, `getComponents`, `getChildRoutes`, and `getIndexRoute` is deprecated. That argument is now the router state (`nextState` or `partialNextState`) rather than the location. To access the location, use `nextState.location` or `partialNextState.location`.') : void 0;
	          return location[prop];
	        }
	      });
	    };
	
	    for (var prop in location) {
	      var _ret = _loop(prop);
	
	      if (_ret === 'continue') continue;
	    }
	
	    return stateWithLocation;
	  }
	
	  return _extends({}, state, location);
	}
	module.exports = exports['default'];

/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	exports.default = matchRoutes;
	
	var _AsyncUtils = __webpack_require__(518);
	
	var _makeStateWithLocation = __webpack_require__(521);
	
	var _makeStateWithLocation2 = _interopRequireDefault(_makeStateWithLocation);
	
	var _PatternUtils = __webpack_require__(493);
	
	var _routerWarning = __webpack_require__(490);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _RouteUtils = __webpack_require__(487);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getChildRoutes(route, location, paramNames, paramValues, callback) {
	  if (route.childRoutes) {
	    return [null, route.childRoutes];
	  }
	  if (!route.getChildRoutes) {
	    return [];
	  }
	
	  var sync = true,
	      result = void 0;
	
	  var partialNextState = {
	    location: location,
	    params: createParams(paramNames, paramValues)
	  };
	
	  var partialNextStateWithLocation = (0, _makeStateWithLocation2.default)(partialNextState, location);
	
	  route.getChildRoutes(partialNextStateWithLocation, function (error, childRoutes) {
	    childRoutes = !error && (0, _RouteUtils.createRoutes)(childRoutes);
	    if (sync) {
	      result = [error, childRoutes];
	      return;
	    }
	
	    callback(error, childRoutes);
	  });
	
	  sync = false;
	  return result; // Might be undefined.
	}
	
	function getIndexRoute(route, location, paramNames, paramValues, callback) {
	  if (route.indexRoute) {
	    callback(null, route.indexRoute);
	  } else if (route.getIndexRoute) {
	    var partialNextState = {
	      location: location,
	      params: createParams(paramNames, paramValues)
	    };
	
	    var partialNextStateWithLocation = (0, _makeStateWithLocation2.default)(partialNextState, location);
	
	    route.getIndexRoute(partialNextStateWithLocation, function (error, indexRoute) {
	      callback(error, !error && (0, _RouteUtils.createRoutes)(indexRoute)[0]);
	    });
	  } else if (route.childRoutes) {
	    (function () {
	      var pathless = route.childRoutes.filter(function (childRoute) {
	        return !childRoute.path;
	      });
	
	      (0, _AsyncUtils.loopAsync)(pathless.length, function (index, next, done) {
	        getIndexRoute(pathless[index], location, paramNames, paramValues, function (error, indexRoute) {
	          if (error || indexRoute) {
	            var routes = [pathless[index]].concat(Array.isArray(indexRoute) ? indexRoute : [indexRoute]);
	            done(error, routes);
	          } else {
	            next();
	          }
	        });
	      }, function (err, routes) {
	        callback(null, routes);
	      });
	    })();
	  } else {
	    callback();
	  }
	}
	
	function assignParams(params, paramNames, paramValues) {
	  return paramNames.reduce(function (params, paramName, index) {
	    var paramValue = paramValues && paramValues[index];
	
	    if (Array.isArray(params[paramName])) {
	      params[paramName].push(paramValue);
	    } else if (paramName in params) {
	      params[paramName] = [params[paramName], paramValue];
	    } else {
	      params[paramName] = paramValue;
	    }
	
	    return params;
	  }, params);
	}
	
	function createParams(paramNames, paramValues) {
	  return assignParams({}, paramNames, paramValues);
	}
	
	function matchRouteDeep(route, location, remainingPathname, paramNames, paramValues, callback) {
	  var pattern = route.path || '';
	
	  if (pattern.charAt(0) === '/') {
	    remainingPathname = location.pathname;
	    paramNames = [];
	    paramValues = [];
	  }
	
	  // Only try to match the path if the route actually has a pattern, and if
	  // we're not just searching for potential nested absolute paths.
	  if (remainingPathname !== null && pattern) {
	    try {
	      var matched = (0, _PatternUtils.matchPattern)(pattern, remainingPathname);
	      if (matched) {
	        remainingPathname = matched.remainingPathname;
	        paramNames = [].concat(paramNames, matched.paramNames);
	        paramValues = [].concat(paramValues, matched.paramValues);
	      } else {
	        remainingPathname = null;
	      }
	    } catch (error) {
	      callback(error);
	    }
	
	    // By assumption, pattern is non-empty here, which is the prerequisite for
	    // actually terminating a match.
	    if (remainingPathname === '') {
	      var _ret2 = function () {
	        var match = {
	          routes: [route],
	          params: createParams(paramNames, paramValues)
	        };
	
	        getIndexRoute(route, location, paramNames, paramValues, function (error, indexRoute) {
	          if (error) {
	            callback(error);
	          } else {
	            if (Array.isArray(indexRoute)) {
	              var _match$routes;
	
	               false ? (0, _routerWarning2.default)(indexRoute.every(function (route) {
	                return !route.path;
	              }), 'Index routes should not have paths') : void 0;
	              (_match$routes = match.routes).push.apply(_match$routes, indexRoute);
	            } else if (indexRoute) {
	               false ? (0, _routerWarning2.default)(!indexRoute.path, 'Index routes should not have paths') : void 0;
	              match.routes.push(indexRoute);
	            }
	
	            callback(null, match);
	          }
	        });
	
	        return {
	          v: void 0
	        };
	      }();
	
	      if ((typeof _ret2 === 'undefined' ? 'undefined' : _typeof(_ret2)) === "object") return _ret2.v;
	    }
	  }
	
	  if (remainingPathname != null || route.childRoutes) {
	    // Either a) this route matched at least some of the path or b)
	    // we don't have to load this route's children asynchronously. In
	    // either case continue checking for matches in the subtree.
	    var onChildRoutes = function onChildRoutes(error, childRoutes) {
	      if (error) {
	        callback(error);
	      } else if (childRoutes) {
	        // Check the child routes to see if any of them match.
	        matchRoutes(childRoutes, location, function (error, match) {
	          if (error) {
	            callback(error);
	          } else if (match) {
	            // A child route matched! Augment the match and pass it up the stack.
	            match.routes.unshift(route);
	            callback(null, match);
	          } else {
	            callback();
	          }
	        }, remainingPathname, paramNames, paramValues);
	      } else {
	        callback();
	      }
	    };
	
	    var result = getChildRoutes(route, location, paramNames, paramValues, onChildRoutes);
	    if (result) {
	      onChildRoutes.apply(undefined, result);
	    }
	  } else {
	    callback();
	  }
	}
	
	/**
	 * Asynchronously matches the given location to a set of routes and calls
	 * callback(error, state) when finished. The state object will have the
	 * following properties:
	 *
	 * - routes       An array of routes that matched, in hierarchical order
	 * - params       An object of URL parameters
	 *
	 * Note: This operation may finish synchronously if no routes have an
	 * asynchronous getChildRoutes method.
	 */
	function matchRoutes(routes, location, callback, remainingPathname) {
	  var paramNames = arguments.length <= 4 || arguments[4] === undefined ? [] : arguments[4];
	  var paramValues = arguments.length <= 5 || arguments[5] === undefined ? [] : arguments[5];
	
	  if (remainingPathname === undefined) {
	    // TODO: This is a little bit ugly, but it works around a quirk in history
	    // that strips the leading slash from pathnames when using basenames with
	    // trailing slashes.
	    if (location.pathname.charAt(0) !== '/') {
	      location = _extends({}, location, {
	        pathname: '/' + location.pathname
	      });
	    }
	    remainingPathname = location.pathname;
	  }
	
	  (0, _AsyncUtils.loopAsync)(routes.length, function (index, next, done) {
	    matchRouteDeep(routes[index], location, remainingPathname, paramNames, paramValues, function (error, match) {
	      if (error || match) {
	        done(error, match);
	      } else {
	        next();
	      }
	    });
	  }, callback);
	}
	module.exports = exports['default'];

/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _invariant = __webpack_require__(494);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _deprecateObjectProperties = __webpack_require__(489);
	
	var _deprecateObjectProperties2 = _interopRequireDefault(_deprecateObjectProperties);
	
	var _getRouteParams = __webpack_require__(524);
	
	var _getRouteParams2 = _interopRequireDefault(_getRouteParams);
	
	var _RouteUtils = __webpack_require__(487);
	
	var _routerWarning = __webpack_require__(490);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _React$PropTypes = _react2.default.PropTypes;
	var array = _React$PropTypes.array;
	var func = _React$PropTypes.func;
	var object = _React$PropTypes.object;
	
	/**
	 * A <RouterContext> renders the component tree for a given router state
	 * and sets the history object and the current location in context.
	 */
	
	var RouterContext = _react2.default.createClass({
	  displayName: 'RouterContext',
	
	
	  propTypes: {
	    history: object,
	    router: object.isRequired,
	    location: object.isRequired,
	    routes: array.isRequired,
	    params: object.isRequired,
	    components: array.isRequired,
	    createElement: func.isRequired
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      createElement: _react2.default.createElement
	    };
	  },
	
	
	  childContextTypes: {
	    history: object,
	    location: object.isRequired,
	    router: object.isRequired
	  },
	
	  getChildContext: function getChildContext() {
	    var _props = this.props;
	    var router = _props.router;
	    var history = _props.history;
	    var location = _props.location;
	
	    if (!router) {
	       false ? (0, _routerWarning2.default)(false, '`<RouterContext>` expects a `router` rather than a `history`') : void 0;
	
	      router = _extends({}, history, {
	        setRouteLeaveHook: history.listenBeforeLeavingRoute
	      });
	      delete router.listenBeforeLeavingRoute;
	    }
	
	    if (false) {
	      location = (0, _deprecateObjectProperties2.default)(location, '`context.location` is deprecated, please use a route component\'s `props.location` instead. http://tiny.cc/router-accessinglocation');
	    }
	
	    return { history: history, location: location, router: router };
	  },
	  createElement: function createElement(component, props) {
	    return component == null ? null : this.props.createElement(component, props);
	  },
	  render: function render() {
	    var _this = this;
	
	    var _props2 = this.props;
	    var history = _props2.history;
	    var location = _props2.location;
	    var routes = _props2.routes;
	    var params = _props2.params;
	    var components = _props2.components;
	
	    var element = null;
	
	    if (components) {
	      element = components.reduceRight(function (element, components, index) {
	        if (components == null) return element; // Don't create new children; use the grandchildren.
	
	        var route = routes[index];
	        var routeParams = (0, _getRouteParams2.default)(route, params);
	        var props = {
	          history: history,
	          location: location,
	          params: params,
	          route: route,
	          routeParams: routeParams,
	          routes: routes
	        };
	
	        if ((0, _RouteUtils.isReactChildren)(element)) {
	          props.children = element;
	        } else if (element) {
	          for (var prop in element) {
	            if (Object.prototype.hasOwnProperty.call(element, prop)) props[prop] = element[prop];
	          }
	        }
	
	        if ((typeof components === 'undefined' ? 'undefined' : _typeof(components)) === 'object') {
	          var elements = {};
	
	          for (var key in components) {
	            if (Object.prototype.hasOwnProperty.call(components, key)) {
	              // Pass through the key as a prop to createElement to allow
	              // custom createElement functions to know which named component
	              // they're rendering, for e.g. matching up to fetched data.
	              elements[key] = _this.createElement(components[key], _extends({
	                key: key }, props));
	            }
	          }
	
	          return elements;
	        }
	
	        return _this.createElement(components, props);
	      }, element);
	    }
	
	    !(element === null || element === false || _react2.default.isValidElement(element)) ?  false ? (0, _invariant2.default)(false, 'The root route must render a single element') : (0, _invariant2.default)(false) : void 0;
	
	    return element;
	  }
	});
	
	exports.default = RouterContext;
	module.exports = exports['default'];

/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _PatternUtils = __webpack_require__(493);
	
	/**
	 * Extracts an object of params the given route cares about from
	 * the given params object.
	 */
	function getRouteParams(route, params) {
	  var routeParams = {};
	
	  if (!route.path) return routeParams;
	
	  (0, _PatternUtils.getParamNames)(route.path).forEach(function (p) {
	    if (Object.prototype.hasOwnProperty.call(params, p)) {
	      routeParams[p] = params[p];
	    }
	  });
	
	  return routeParams;
	}
	
	exports.default = getRouteParams;
	module.exports = exports['default'];

/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.createRouterObject = createRouterObject;
	exports.createRoutingHistory = createRoutingHistory;
	
	var _deprecateObjectProperties = __webpack_require__(489);
	
	var _deprecateObjectProperties2 = _interopRequireDefault(_deprecateObjectProperties);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function createRouterObject(history, transitionManager) {
	  return _extends({}, history, {
	    setRouteLeaveHook: transitionManager.listenBeforeLeavingRoute,
	    isActive: transitionManager.isActive
	  });
	}
	
	// deprecated
	function createRoutingHistory(history, transitionManager) {
	  history = _extends({}, history, transitionManager);
	
	  if (false) {
	    history = (0, _deprecateObjectProperties2.default)(history, '`props.history` and `context.history` are deprecated. Please use `context.router`. http://tiny.cc/router-contextchanges');
	  }
	
	  return history;
	}

/***/ }),
/* 526 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _routerWarning = __webpack_require__(490);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _invariant = __webpack_require__(494);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _PropTypes = __webpack_require__(488);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var _React$PropTypes = _react2.default.PropTypes;
	var bool = _React$PropTypes.bool;
	var object = _React$PropTypes.object;
	var string = _React$PropTypes.string;
	var func = _React$PropTypes.func;
	var oneOfType = _React$PropTypes.oneOfType;
	
	
	function isLeftClickEvent(event) {
	  return event.button === 0;
	}
	
	function isModifiedEvent(event) {
	  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
	}
	
	// TODO: De-duplicate against hasAnyProperties in createTransitionManager.
	function isEmptyObject(object) {
	  for (var p in object) {
	    if (Object.prototype.hasOwnProperty.call(object, p)) return false;
	  }return true;
	}
	
	function createLocationDescriptor(to, _ref) {
	  var query = _ref.query;
	  var hash = _ref.hash;
	  var state = _ref.state;
	
	  if (query || hash || state) {
	    return { pathname: to, query: query, hash: hash, state: state };
	  }
	
	  return to;
	}
	
	/**
	 * A <Link> is used to create an <a> element that links to a route.
	 * When that route is active, the link gets the value of its
	 * activeClassName prop.
	 *
	 * For example, assuming you have the following route:
	 *
	 *   <Route path="/posts/:postID" component={Post} />
	 *
	 * You could use the following component to link to that route:
	 *
	 *   <Link to={`/posts/${post.id}`} />
	 *
	 * Links may pass along location state and/or query string parameters
	 * in the state/query props, respectively.
	 *
	 *   <Link ... query={{ show: true }} state={{ the: 'state' }} />
	 */
	var Link = _react2.default.createClass({
	  displayName: 'Link',
	
	
	  contextTypes: {
	    router: _PropTypes.routerShape
	  },
	
	  propTypes: {
	    to: oneOfType([string, object]).isRequired,
	    query: object,
	    hash: string,
	    state: object,
	    activeStyle: object,
	    activeClassName: string,
	    onlyActiveOnIndex: bool.isRequired,
	    onClick: func,
	    target: string
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      onlyActiveOnIndex: false,
	      style: {}
	    };
	  },
	  handleClick: function handleClick(event) {
	    if (this.props.onClick) this.props.onClick(event);
	
	    if (event.defaultPrevented) return;
	
	    !this.context.router ?  false ? (0, _invariant2.default)(false, '<Link>s rendered outside of a router context cannot navigate.') : (0, _invariant2.default)(false) : void 0;
	
	    if (isModifiedEvent(event) || !isLeftClickEvent(event)) return;
	
	    // If target prop is set (e.g. to "_blank"), let browser handle link.
	    /* istanbul ignore if: untestable with Karma */
	    if (this.props.target) return;
	
	    event.preventDefault();
	
	    var _props = this.props;
	    var to = _props.to;
	    var query = _props.query;
	    var hash = _props.hash;
	    var state = _props.state;
	
	    var location = createLocationDescriptor(to, { query: query, hash: hash, state: state });
	
	    this.context.router.push(location);
	  },
	  render: function render() {
	    var _props2 = this.props;
	    var to = _props2.to;
	    var query = _props2.query;
	    var hash = _props2.hash;
	    var state = _props2.state;
	    var activeClassName = _props2.activeClassName;
	    var activeStyle = _props2.activeStyle;
	    var onlyActiveOnIndex = _props2.onlyActiveOnIndex;
	
	    var props = _objectWithoutProperties(_props2, ['to', 'query', 'hash', 'state', 'activeClassName', 'activeStyle', 'onlyActiveOnIndex']);
	
	     false ? (0, _routerWarning2.default)(!(query || hash || state), 'the `query`, `hash`, and `state` props on `<Link>` are deprecated, use `<Link to={{ pathname, query, hash, state }}/>. http://tiny.cc/router-isActivedeprecated') : void 0;
	
	    // Ignore if rendered outside the context of router, simplifies unit testing.
	    var router = this.context.router;
	
	
	    if (router) {
	      var location = createLocationDescriptor(to, { query: query, hash: hash, state: state });
	      props.href = router.createHref(location);
	
	      if (activeClassName || activeStyle != null && !isEmptyObject(activeStyle)) {
	        if (router.isActive(location, onlyActiveOnIndex)) {
	          if (activeClassName) {
	            if (props.className) {
	              props.className += ' ' + activeClassName;
	            } else {
	              props.className = activeClassName;
	            }
	          }
	
	          if (activeStyle) props.style = _extends({}, props.style, activeStyle);
	        }
	      }
	    }
	
	    return _react2.default.createElement('a', _extends({}, props, { onClick: this.handleClick }));
	  }
	});
	
	exports.default = Link;
	module.exports = exports['default'];

/***/ }),
/* 527 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Link = __webpack_require__(526);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * An <IndexLink> is used to link to an <IndexRoute>.
	 */
	var IndexLink = _react2.default.createClass({
	  displayName: 'IndexLink',
	  render: function render() {
	    return _react2.default.createElement(_Link2.default, _extends({}, this.props, { onlyActiveOnIndex: true }));
	  }
	});
	
	exports.default = IndexLink;
	module.exports = exports['default'];

/***/ }),
/* 528 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = withRouter;
	
	var _invariant = __webpack_require__(494);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _hoistNonReactStatics = __webpack_require__(529);
	
	var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);
	
	var _PropTypes = __webpack_require__(488);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getDisplayName(WrappedComponent) {
	  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	}
	
	function withRouter(WrappedComponent, options) {
	  var withRef = options && options.withRef;
	
	  var WithRouter = _react2.default.createClass({
	    displayName: 'WithRouter',
	
	    contextTypes: { router: _PropTypes.routerShape },
	    propTypes: { router: _PropTypes.routerShape },
	
	    getWrappedInstance: function getWrappedInstance() {
	      !withRef ?  false ? (0, _invariant2.default)(false, 'To access the wrapped instance, you need to specify ' + '`{ withRef: true }` as the second argument of the withRouter() call.') : (0, _invariant2.default)(false) : void 0;
	
	      return this.wrappedInstance;
	    },
	    render: function render() {
	      var _this = this;
	
	      var router = this.props.router || this.context.router;
	      var props = _extends({}, this.props, { router: router });
	
	      if (withRef) {
	        props.ref = function (c) {
	          _this.wrappedInstance = c;
	        };
	      }
	
	      return _react2.default.createElement(WrappedComponent, props);
	    }
	  });
	
	  WithRouter.displayName = 'withRouter(' + getDisplayName(WrappedComponent) + ')';
	  WithRouter.WrappedComponent = WrappedComponent;
	
	  return (0, _hoistNonReactStatics2.default)(WithRouter, WrappedComponent);
	}
	module.exports = exports['default'];

/***/ }),
/* 529 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	'use strict';
	
	var REACT_STATICS = {
	    childContextTypes: true,
	    contextTypes: true,
	    defaultProps: true,
	    displayName: true,
	    getDefaultProps: true,
	    mixins: true,
	    propTypes: true,
	    type: true
	};
	
	var KNOWN_STATICS = {
	    name: true,
	    length: true,
	    prototype: true,
	    caller: true,
	    arguments: true,
	    arity: true
	};
	
	var isGetOwnPropertySymbolsAvailable = typeof Object.getOwnPropertySymbols === 'function';
	
	module.exports = function hoistNonReactStatics(targetComponent, sourceComponent, customStatics) {
	    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
	        var keys = Object.getOwnPropertyNames(sourceComponent);
	
	        /* istanbul ignore else */
	        if (isGetOwnPropertySymbolsAvailable) {
	            keys = keys.concat(Object.getOwnPropertySymbols(sourceComponent));
	        }
	
	        for (var i = 0; i < keys.length; ++i) {
	            if (!REACT_STATICS[keys[i]] && !KNOWN_STATICS[keys[i]] && (!customStatics || !customStatics[keys[i]])) {
	                try {
	                    targetComponent[keys[i]] = sourceComponent[keys[i]];
	                } catch (error) {
	
	                }
	            }
	        }
	    }
	
	    return targetComponent;
	};


/***/ }),
/* 530 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _routerWarning = __webpack_require__(490);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _invariant = __webpack_require__(494);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _Redirect = __webpack_require__(531);
	
	var _Redirect2 = _interopRequireDefault(_Redirect);
	
	var _InternalPropTypes = __webpack_require__(492);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _React$PropTypes = _react2.default.PropTypes;
	var string = _React$PropTypes.string;
	var object = _React$PropTypes.object;
	
	/**
	 * An <IndexRedirect> is used to redirect from an indexRoute.
	 */
	
	var IndexRedirect = _react2.default.createClass({
	  displayName: 'IndexRedirect',
	
	
	  statics: {
	    createRouteFromReactElement: function createRouteFromReactElement(element, parentRoute) {
	      /* istanbul ignore else: sanity check */
	      if (parentRoute) {
	        parentRoute.indexRoute = _Redirect2.default.createRouteFromReactElement(element);
	      } else {
	         false ? (0, _routerWarning2.default)(false, 'An <IndexRedirect> does not make sense at the root of your route config') : void 0;
	      }
	    }
	  },
	
	  propTypes: {
	    to: string.isRequired,
	    query: object,
	    state: object,
	    onEnter: _InternalPropTypes.falsy,
	    children: _InternalPropTypes.falsy
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ?  false ? (0, _invariant2.default)(false, '<IndexRedirect> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
	  }
	});
	
	exports.default = IndexRedirect;
	module.exports = exports['default'];

/***/ }),
/* 531 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _invariant = __webpack_require__(494);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _RouteUtils = __webpack_require__(487);
	
	var _PatternUtils = __webpack_require__(493);
	
	var _InternalPropTypes = __webpack_require__(492);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _React$PropTypes = _react2.default.PropTypes;
	var string = _React$PropTypes.string;
	var object = _React$PropTypes.object;
	
	/**
	 * A <Redirect> is used to declare another URL path a client should
	 * be sent to when they request a given URL.
	 *
	 * Redirects are placed alongside routes in the route configuration
	 * and are traversed in the same manner.
	 */
	
	var Redirect = _react2.default.createClass({
	  displayName: 'Redirect',
	
	
	  statics: {
	    createRouteFromReactElement: function createRouteFromReactElement(element) {
	      var route = (0, _RouteUtils.createRouteFromReactElement)(element);
	
	      if (route.from) route.path = route.from;
	
	      route.onEnter = function (nextState, replace) {
	        var location = nextState.location;
	        var params = nextState.params;
	
	
	        var pathname = void 0;
	        if (route.to.charAt(0) === '/') {
	          pathname = (0, _PatternUtils.formatPattern)(route.to, params);
	        } else if (!route.to) {
	          pathname = location.pathname;
	        } else {
	          var routeIndex = nextState.routes.indexOf(route);
	          var parentPattern = Redirect.getRoutePattern(nextState.routes, routeIndex - 1);
	          var pattern = parentPattern.replace(/\/*$/, '/') + route.to;
	          pathname = (0, _PatternUtils.formatPattern)(pattern, params);
	        }
	
	        replace({
	          pathname: pathname,
	          query: route.query || location.query,
	          state: route.state || location.state
	        });
	      };
	
	      return route;
	    },
	    getRoutePattern: function getRoutePattern(routes, routeIndex) {
	      var parentPattern = '';
	
	      for (var i = routeIndex; i >= 0; i--) {
	        var route = routes[i];
	        var pattern = route.path || '';
	
	        parentPattern = pattern.replace(/\/*$/, '/') + parentPattern;
	
	        if (pattern.indexOf('/') === 0) break;
	      }
	
	      return '/' + parentPattern;
	    }
	  },
	
	  propTypes: {
	    path: string,
	    from: string, // Alias for path
	    to: string.isRequired,
	    query: object,
	    state: object,
	    onEnter: _InternalPropTypes.falsy,
	    children: _InternalPropTypes.falsy
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ?  false ? (0, _invariant2.default)(false, '<Redirect> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
	  }
	});
	
	exports.default = Redirect;
	module.exports = exports['default'];

/***/ }),
/* 532 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _routerWarning = __webpack_require__(490);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _invariant = __webpack_require__(494);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _RouteUtils = __webpack_require__(487);
	
	var _InternalPropTypes = __webpack_require__(492);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var func = _react2.default.PropTypes.func;
	
	/**
	 * An <IndexRoute> is used to specify its parent's <Route indexRoute> in
	 * a JSX route config.
	 */
	
	var IndexRoute = _react2.default.createClass({
	  displayName: 'IndexRoute',
	
	
	  statics: {
	    createRouteFromReactElement: function createRouteFromReactElement(element, parentRoute) {
	      /* istanbul ignore else: sanity check */
	      if (parentRoute) {
	        parentRoute.indexRoute = (0, _RouteUtils.createRouteFromReactElement)(element);
	      } else {
	         false ? (0, _routerWarning2.default)(false, 'An <IndexRoute> does not make sense at the root of your route config') : void 0;
	      }
	    }
	  },
	
	  propTypes: {
	    path: _InternalPropTypes.falsy,
	    component: _InternalPropTypes.component,
	    components: _InternalPropTypes.components,
	    getComponent: func,
	    getComponents: func
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ?  false ? (0, _invariant2.default)(false, '<IndexRoute> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
	  }
	});
	
	exports.default = IndexRoute;
	module.exports = exports['default'];

/***/ }),
/* 533 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _invariant = __webpack_require__(494);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _RouteUtils = __webpack_require__(487);
	
	var _InternalPropTypes = __webpack_require__(492);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _React$PropTypes = _react2.default.PropTypes;
	var string = _React$PropTypes.string;
	var func = _React$PropTypes.func;
	
	/**
	 * A <Route> is used to declare which components are rendered to the
	 * page when the URL matches a given pattern.
	 *
	 * Routes are arranged in a nested tree structure. When a new URL is
	 * requested, the tree is searched depth-first to find a route whose
	 * path matches the URL.  When one is found, all routes in the tree
	 * that lead to it are considered "active" and their components are
	 * rendered into the DOM, nested in the same order as in the tree.
	 */
	
	var Route = _react2.default.createClass({
	  displayName: 'Route',
	
	
	  statics: {
	    createRouteFromReactElement: _RouteUtils.createRouteFromReactElement
	  },
	
	  propTypes: {
	    path: string,
	    component: _InternalPropTypes.component,
	    components: _InternalPropTypes.components,
	    getComponent: func,
	    getComponents: func
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ?  false ? (0, _invariant2.default)(false, '<Route> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
	  }
	});
	
	exports.default = Route;
	module.exports = exports['default'];

/***/ }),
/* 534 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _routerWarning = __webpack_require__(490);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _InternalPropTypes = __webpack_require__(492);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A mixin that adds the "history" instance variable to components.
	 */
	var History = {
	
	  contextTypes: {
	    history: _InternalPropTypes.history
	  },
	
	  componentWillMount: function componentWillMount() {
	     false ? (0, _routerWarning2.default)(false, 'the `History` mixin is deprecated, please access `context.router` with your own `contextTypes`. http://tiny.cc/router-historymixin') : void 0;
	    this.history = this.context.history;
	  }
	};
	
	exports.default = History;
	module.exports = exports['default'];

/***/ }),
/* 535 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _routerWarning = __webpack_require__(490);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _invariant = __webpack_require__(494);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var object = _react2.default.PropTypes.object;
	
	/**
	 * The Lifecycle mixin adds the routerWillLeave lifecycle method to a
	 * component that may be used to cancel a transition or prompt the user
	 * for confirmation.
	 *
	 * On standard transitions, routerWillLeave receives a single argument: the
	 * location we're transitioning to. To cancel the transition, return false.
	 * To prompt the user for confirmation, return a prompt message (string).
	 *
	 * During the beforeunload event (assuming you're using the useBeforeUnload
	 * history enhancer), routerWillLeave does not receive a location object
	 * because it isn't possible for us to know the location we're transitioning
	 * to. In this case routerWillLeave must return a prompt message to prevent
	 * the user from closing the window/tab.
	 */
	
	var Lifecycle = {
	
	  contextTypes: {
	    history: object.isRequired,
	    // Nested children receive the route as context, either
	    // set by the route component using the RouteContext mixin
	    // or by some other ancestor.
	    route: object
	  },
	
	  propTypes: {
	    // Route components receive the route object as a prop.
	    route: object
	  },
	
	  componentDidMount: function componentDidMount() {
	     false ? (0, _routerWarning2.default)(false, 'the `Lifecycle` mixin is deprecated, please use `context.router.setRouteLeaveHook(route, hook)`. http://tiny.cc/router-lifecyclemixin') : void 0;
	    !this.routerWillLeave ?  false ? (0, _invariant2.default)(false, 'The Lifecycle mixin requires you to define a routerWillLeave method') : (0, _invariant2.default)(false) : void 0;
	
	    var route = this.props.route || this.context.route;
	
	    !route ?  false ? (0, _invariant2.default)(false, 'The Lifecycle mixin must be used on either a) a <Route component> or ' + 'b) a descendant of a <Route component> that uses the RouteContext mixin') : (0, _invariant2.default)(false) : void 0;
	
	    this._unlistenBeforeLeavingRoute = this.context.history.listenBeforeLeavingRoute(route, this.routerWillLeave);
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    if (this._unlistenBeforeLeavingRoute) this._unlistenBeforeLeavingRoute();
	  }
	};
	
	exports.default = Lifecycle;
	module.exports = exports['default'];

/***/ }),
/* 536 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _routerWarning = __webpack_require__(490);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var object = _react2.default.PropTypes.object;
	
	/**
	 * The RouteContext mixin provides a convenient way for route
	 * components to set the route in context. This is needed for
	 * routes that render elements that want to use the Lifecycle
	 * mixin to prevent transitions.
	 */
	
	var RouteContext = {
	
	  propTypes: {
	    route: object.isRequired
	  },
	
	  childContextTypes: {
	    route: object.isRequired
	  },
	
	  getChildContext: function getChildContext() {
	    return {
	      route: this.props.route
	    };
	  },
	  componentWillMount: function componentWillMount() {
	     false ? (0, _routerWarning2.default)(false, 'The `RouteContext` mixin is deprecated. You can provide `this.props.route` on context with your own `contextTypes`. http://tiny.cc/router-routecontextmixin') : void 0;
	  }
	};
	
	exports.default = RouteContext;
	module.exports = exports['default'];

/***/ }),
/* 537 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _useQueries = __webpack_require__(512);
	
	var _useQueries2 = _interopRequireDefault(_useQueries);
	
	var _createTransitionManager = __webpack_require__(515);
	
	var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);
	
	var _routerWarning = __webpack_require__(490);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	/**
	 * Returns a new createHistory function that may be used to create
	 * history objects that know about routing.
	 *
	 * Enhances history objects with the following methods:
	 *
	 * - listen((error, nextState) => {})
	 * - listenBeforeLeavingRoute(route, (nextLocation) => {})
	 * - match(location, (error, redirectLocation, nextState) => {})
	 * - isActive(pathname, query, indexOnly=false)
	 */
	function useRoutes(createHistory) {
	   false ? (0, _routerWarning2.default)(false, '`useRoutes` is deprecated. Please use `createTransitionManager` instead.') : void 0;
	
	  return function () {
	    var _ref = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	    var routes = _ref.routes;
	
	    var options = _objectWithoutProperties(_ref, ['routes']);
	
	    var history = (0, _useQueries2.default)(createHistory)(options);
	    var transitionManager = (0, _createTransitionManager2.default)(history, routes);
	    return _extends({}, history, transitionManager);
	  };
	}
	
	exports.default = useRoutes;
	module.exports = exports['default'];

/***/ }),
/* 538 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _RouterContext = __webpack_require__(523);
	
	var _RouterContext2 = _interopRequireDefault(_RouterContext);
	
	var _routerWarning = __webpack_require__(490);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RoutingContext = _react2.default.createClass({
	  displayName: 'RoutingContext',
	  componentWillMount: function componentWillMount() {
	     false ? (0, _routerWarning2.default)(false, '`RoutingContext` has been renamed to `RouterContext`. Please use `import { RouterContext } from \'react-router\'`. http://tiny.cc/router-routercontext') : void 0;
	  },
	  render: function render() {
	    return _react2.default.createElement(_RouterContext2.default, this.props);
	  }
	});
	
	exports.default = RoutingContext;
	module.exports = exports['default'];

/***/ }),
/* 539 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _invariant = __webpack_require__(494);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _createMemoryHistory = __webpack_require__(540);
	
	var _createMemoryHistory2 = _interopRequireDefault(_createMemoryHistory);
	
	var _createTransitionManager = __webpack_require__(515);
	
	var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);
	
	var _RouteUtils = __webpack_require__(487);
	
	var _RouterUtils = __webpack_require__(525);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	/**
	 * A high-level API to be used for server-side rendering.
	 *
	 * This function matches a location to a set of routes and calls
	 * callback(error, redirectLocation, renderProps) when finished.
	 *
	 * Note: You probably don't want to use this in a browser unless you're using
	 * server-side rendering with async routes.
	 */
	function match(_ref, callback) {
	  var history = _ref.history;
	  var routes = _ref.routes;
	  var location = _ref.location;
	
	  var options = _objectWithoutProperties(_ref, ['history', 'routes', 'location']);
	
	  !(history || location) ?  false ? (0, _invariant2.default)(false, 'match needs a history or a location') : (0, _invariant2.default)(false) : void 0;
	
	  history = history ? history : (0, _createMemoryHistory2.default)(options);
	  var transitionManager = (0, _createTransitionManager2.default)(history, (0, _RouteUtils.createRoutes)(routes));
	
	  var unlisten = void 0;
	
	  if (location) {
	    // Allow match({ location: '/the/path', ... })
	    location = history.createLocation(location);
	  } else {
	    // Pick up the location from the history via synchronous history.listen
	    // call if needed.
	    unlisten = history.listen(function (historyLocation) {
	      location = historyLocation;
	    });
	  }
	
	  var router = (0, _RouterUtils.createRouterObject)(history, transitionManager);
	  history = (0, _RouterUtils.createRoutingHistory)(history, transitionManager);
	
	  transitionManager.match(location, function (error, redirectLocation, nextState) {
	    callback(error, redirectLocation, nextState && _extends({}, nextState, {
	      history: history,
	      router: router,
	      matchContext: { history: history, transitionManager: transitionManager, router: router }
	    }));
	
	    // Defer removing the listener to here to prevent DOM histories from having
	    // to unwind DOM event listeners unnecessarily, in case callback renders a
	    // <Router> and attaches another history listener.
	    if (unlisten) {
	      unlisten();
	    }
	  });
	}
	
	exports.default = match;
	module.exports = exports['default'];

/***/ }),
/* 540 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = createMemoryHistory;
	
	var _useQueries = __webpack_require__(512);
	
	var _useQueries2 = _interopRequireDefault(_useQueries);
	
	var _useBasename = __webpack_require__(541);
	
	var _useBasename2 = _interopRequireDefault(_useBasename);
	
	var _createMemoryHistory = __webpack_require__(542);
	
	var _createMemoryHistory2 = _interopRequireDefault(_createMemoryHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function createMemoryHistory(options) {
	  // signatures and type checking differ between `useRoutes` and
	  // `createMemoryHistory`, have to create `memoryHistory` first because
	  // `useQueries` doesn't understand the signature
	  var memoryHistory = (0, _createMemoryHistory2.default)(options);
	  var createHistory = function createHistory() {
	    return memoryHistory;
	  };
	  var history = (0, _useQueries2.default)((0, _useBasename2.default)(createHistory))(options);
	  history.__v2_compatible__ = true;
	  return history;
	}
	module.exports = exports['default'];

/***/ }),
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(497);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _ExecutionEnvironment = __webpack_require__(500);
	
	var _PathUtils = __webpack_require__(499);
	
	var _runTransitionHook = __webpack_require__(510);
	
	var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);
	
	var _deprecate = __webpack_require__(511);
	
	var _deprecate2 = _interopRequireDefault(_deprecate);
	
	function useBasename(createHistory) {
	  return function () {
	    var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	    var history = createHistory(options);
	
	    var basename = options.basename;
	
	    var checkedBaseHref = false;
	
	    function checkBaseHref() {
	      if (checkedBaseHref) {
	        return;
	      }
	
	      // Automatically use the value of <base href> in HTML
	      // documents as basename if it's not explicitly given.
	      if (basename == null && _ExecutionEnvironment.canUseDOM) {
	        var base = document.getElementsByTagName('base')[0];
	        var baseHref = base && base.getAttribute('href');
	
	        if (baseHref != null) {
	          basename = baseHref;
	
	           false ? _warning2['default'](false, 'Automatically setting basename using <base href> is deprecated and will ' + 'be removed in the next major release. The semantics of <base href> are ' + 'subtly different from basename. Please pass the basename explicitly in ' + 'the options to createHistory') : undefined;
	        }
	      }
	
	      checkedBaseHref = true;
	    }
	
	    function addBasename(location) {
	      checkBaseHref();
	
	      if (basename && location.basename == null) {
	        if (location.pathname.indexOf(basename) === 0) {
	          location.pathname = location.pathname.substring(basename.length);
	          location.basename = basename;
	
	          if (location.pathname === '') location.pathname = '/';
	        } else {
	          location.basename = '';
	        }
	      }
	
	      return location;
	    }
	
	    function prependBasename(location) {
	      checkBaseHref();
	
	      if (!basename) return location;
	
	      if (typeof location === 'string') location = _PathUtils.parsePath(location);
	
	      var pname = location.pathname;
	      var normalizedBasename = basename.slice(-1) === '/' ? basename : basename + '/';
	      var normalizedPathname = pname.charAt(0) === '/' ? pname.slice(1) : pname;
	      var pathname = normalizedBasename + normalizedPathname;
	
	      return _extends({}, location, {
	        pathname: pathname
	      });
	    }
	
	    // Override all read methods with basename-aware versions.
	    function listenBefore(hook) {
	      return history.listenBefore(function (location, callback) {
	        _runTransitionHook2['default'](hook, addBasename(location), callback);
	      });
	    }
	
	    function listen(listener) {
	      return history.listen(function (location) {
	        listener(addBasename(location));
	      });
	    }
	
	    // Override all write methods with basename-aware versions.
	    function push(location) {
	      history.push(prependBasename(location));
	    }
	
	    function replace(location) {
	      history.replace(prependBasename(location));
	    }
	
	    function createPath(location) {
	      return history.createPath(prependBasename(location));
	    }
	
	    function createHref(location) {
	      return history.createHref(prependBasename(location));
	    }
	
	    function createLocation(location) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      return addBasename(history.createLocation.apply(history, [prependBasename(location)].concat(args)));
	    }
	
	    // deprecated
	    function pushState(state, path) {
	      if (typeof path === 'string') path = _PathUtils.parsePath(path);
	
	      push(_extends({ state: state }, path));
	    }
	
	    // deprecated
	    function replaceState(state, path) {
	      if (typeof path === 'string') path = _PathUtils.parsePath(path);
	
	      replace(_extends({ state: state }, path));
	    }
	
	    return _extends({}, history, {
	      listenBefore: listenBefore,
	      listen: listen,
	      push: push,
	      replace: replace,
	      createPath: createPath,
	      createHref: createHref,
	      createLocation: createLocation,
	
	      pushState: _deprecate2['default'](pushState, 'pushState is deprecated; use push instead'),
	      replaceState: _deprecate2['default'](replaceState, 'replaceState is deprecated; use replace instead')
	    });
	  };
	}
	
	exports['default'] = useBasename;
	module.exports = exports['default'];

/***/ }),
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(497);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(494);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _PathUtils = __webpack_require__(499);
	
	var _Actions = __webpack_require__(498);
	
	var _createHistory = __webpack_require__(504);
	
	var _createHistory2 = _interopRequireDefault(_createHistory);
	
	function createStateStorage(entries) {
	  return entries.filter(function (entry) {
	    return entry.state;
	  }).reduce(function (memo, entry) {
	    memo[entry.key] = entry.state;
	    return memo;
	  }, {});
	}
	
	function createMemoryHistory() {
	  var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	  if (Array.isArray(options)) {
	    options = { entries: options };
	  } else if (typeof options === 'string') {
	    options = { entries: [options] };
	  }
	
	  var history = _createHistory2['default'](_extends({}, options, {
	    getCurrentLocation: getCurrentLocation,
	    finishTransition: finishTransition,
	    saveState: saveState,
	    go: go
	  }));
	
	  var _options = options;
	  var entries = _options.entries;
	  var current = _options.current;
	
	  if (typeof entries === 'string') {
	    entries = [entries];
	  } else if (!Array.isArray(entries)) {
	    entries = ['/'];
	  }
	
	  entries = entries.map(function (entry) {
	    var key = history.createKey();
	
	    if (typeof entry === 'string') return { pathname: entry, key: key };
	
	    if (typeof entry === 'object' && entry) return _extends({}, entry, { key: key });
	
	     true ?  false ? _invariant2['default'](false, 'Unable to create history entry from %s', entry) : _invariant2['default'](false) : undefined;
	  });
	
	  if (current == null) {
	    current = entries.length - 1;
	  } else {
	    !(current >= 0 && current < entries.length) ?  false ? _invariant2['default'](false, 'Current index must be >= 0 and < %s, was %s', entries.length, current) : _invariant2['default'](false) : undefined;
	  }
	
	  var storage = createStateStorage(entries);
	
	  function saveState(key, state) {
	    storage[key] = state;
	  }
	
	  function readState(key) {
	    return storage[key];
	  }
	
	  function getCurrentLocation() {
	    var entry = entries[current];
	    var basename = entry.basename;
	    var pathname = entry.pathname;
	    var search = entry.search;
	
	    var path = (basename || '') + pathname + (search || '');
	
	    var key = undefined,
	        state = undefined;
	    if (entry.key) {
	      key = entry.key;
	      state = readState(key);
	    } else {
	      key = history.createKey();
	      state = null;
	      entry.key = key;
	    }
	
	    var location = _PathUtils.parsePath(path);
	
	    return history.createLocation(_extends({}, location, { state: state }), undefined, key);
	  }
	
	  function canGo(n) {
	    var index = current + n;
	    return index >= 0 && index < entries.length;
	  }
	
	  function go(n) {
	    if (n) {
	      if (!canGo(n)) {
	         false ? _warning2['default'](false, 'Cannot go(%s) there is not enough history', n) : undefined;
	        return;
	      }
	
	      current += n;
	
	      var currentLocation = getCurrentLocation();
	
	      // change action to POP
	      history.transitionTo(_extends({}, currentLocation, { action: _Actions.POP }));
	    }
	  }
	
	  function finishTransition(location) {
	    switch (location.action) {
	      case _Actions.PUSH:
	        current += 1;
	
	        // if we are not on the top of stack
	        // remove rest and push new
	        if (current < entries.length) entries.splice(current);
	
	        entries.push(location);
	        saveState(location.key, location.state);
	        break;
	      case _Actions.REPLACE:
	        entries[current] = location;
	        saveState(location.key, location.state);
	        break;
	    }
	  }
	
	  return history;
	}
	
	exports['default'] = createMemoryHistory;
	module.exports = exports['default'];

/***/ }),
/* 543 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = useRouterHistory;
	
	var _useQueries = __webpack_require__(512);
	
	var _useQueries2 = _interopRequireDefault(_useQueries);
	
	var _useBasename = __webpack_require__(541);
	
	var _useBasename2 = _interopRequireDefault(_useBasename);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function useRouterHistory(createHistory) {
	  return function (options) {
	    var history = (0, _useQueries2.default)((0, _useBasename2.default)(createHistory))(options);
	    history.__v2_compatible__ = true;
	    return history;
	  };
	}
	module.exports = exports['default'];

/***/ }),
/* 544 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _RouterContext = __webpack_require__(523);
	
	var _RouterContext2 = _interopRequireDefault(_RouterContext);
	
	var _routerWarning = __webpack_require__(490);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
	    middlewares[_key] = arguments[_key];
	  }
	
	  if (false) {
	    middlewares.forEach(function (middleware, index) {
	      process.env.NODE_ENV !== 'production' ? (0, _routerWarning2.default)(middleware.renderRouterContext || middleware.renderRouteComponent, 'The middleware specified at index ' + index + ' does not appear to be ' + 'a valid React Router middleware.') : void 0;
	    });
	  }
	
	  var withContext = middlewares.map(function (middleware) {
	    return middleware.renderRouterContext;
	  }).filter(Boolean);
	  var withComponent = middlewares.map(function (middleware) {
	    return middleware.renderRouteComponent;
	  }).filter(Boolean);
	
	  var makeCreateElement = function makeCreateElement() {
	    var baseCreateElement = arguments.length <= 0 || arguments[0] === undefined ? _react.createElement : arguments[0];
	    return function (Component, props) {
	      return withComponent.reduceRight(function (previous, renderRouteComponent) {
	        return renderRouteComponent(previous, props);
	      }, baseCreateElement(Component, props));
	    };
	  };
	
	  return function (renderProps) {
	    return withContext.reduceRight(function (previous, renderRouterContext) {
	      return renderRouterContext(previous, renderProps);
	    }, _react2.default.createElement(_RouterContext2.default, _extends({}, renderProps, {
	      createElement: makeCreateElement(renderProps.createElement)
	    })));
	  };
	};
	
	module.exports = exports['default'];

/***/ }),
/* 545 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createBrowserHistory = __webpack_require__(546);
	
	var _createBrowserHistory2 = _interopRequireDefault(_createBrowserHistory);
	
	var _createRouterHistory = __webpack_require__(547);
	
	var _createRouterHistory2 = _interopRequireDefault(_createRouterHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _createRouterHistory2.default)(_createBrowserHistory2.default);
	module.exports = exports['default'];

/***/ }),
/* 546 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _invariant = __webpack_require__(494);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _Actions = __webpack_require__(498);
	
	var _PathUtils = __webpack_require__(499);
	
	var _ExecutionEnvironment = __webpack_require__(500);
	
	var _DOMUtils = __webpack_require__(501);
	
	var _DOMStateStorage = __webpack_require__(502);
	
	var _createDOMHistory = __webpack_require__(503);
	
	var _createDOMHistory2 = _interopRequireDefault(_createDOMHistory);
	
	/**
	 * Creates and returns a history object that uses HTML5's history API
	 * (pushState, replaceState, and the popstate event) to manage history.
	 * This is the recommended method of managing history in browsers because
	 * it provides the cleanest URLs.
	 *
	 * Note: In browsers that do not support the HTML5 history API full
	 * page reloads will be used to preserve URLs.
	 */
	function createBrowserHistory() {
	  var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	  !_ExecutionEnvironment.canUseDOM ?  false ? _invariant2['default'](false, 'Browser history needs a DOM') : _invariant2['default'](false) : undefined;
	
	  var forceRefresh = options.forceRefresh;
	
	  var isSupported = _DOMUtils.supportsHistory();
	  var useRefresh = !isSupported || forceRefresh;
	
	  function getCurrentLocation(historyState) {
	    try {
	      historyState = historyState || window.history.state || {};
	    } catch (e) {
	      historyState = {};
	    }
	
	    var path = _DOMUtils.getWindowPath();
	    var _historyState = historyState;
	    var key = _historyState.key;
	
	    var state = undefined;
	    if (key) {
	      state = _DOMStateStorage.readState(key);
	    } else {
	      state = null;
	      key = history.createKey();
	
	      if (isSupported) window.history.replaceState(_extends({}, historyState, { key: key }), null);
	    }
	
	    var location = _PathUtils.parsePath(path);
	
	    return history.createLocation(_extends({}, location, { state: state }), undefined, key);
	  }
	
	  function startPopStateListener(_ref) {
	    var transitionTo = _ref.transitionTo;
	
	    function popStateListener(event) {
	      if (event.state === undefined) return; // Ignore extraneous popstate events in WebKit.
	
	      transitionTo(getCurrentLocation(event.state));
	    }
	
	    _DOMUtils.addEventListener(window, 'popstate', popStateListener);
	
	    return function () {
	      _DOMUtils.removeEventListener(window, 'popstate', popStateListener);
	    };
	  }
	
	  function finishTransition(location) {
	    var basename = location.basename;
	    var pathname = location.pathname;
	    var search = location.search;
	    var hash = location.hash;
	    var state = location.state;
	    var action = location.action;
	    var key = location.key;
	
	    if (action === _Actions.POP) return; // Nothing to do.
	
	    _DOMStateStorage.saveState(key, state);
	
	    var path = (basename || '') + pathname + search + hash;
	    var historyState = {
	      key: key
	    };
	
	    if (action === _Actions.PUSH) {
	      if (useRefresh) {
	        window.location.href = path;
	        return false; // Prevent location update.
	      } else {
	          window.history.pushState(historyState, null, path);
	        }
	    } else {
	      // REPLACE
	      if (useRefresh) {
	        window.location.replace(path);
	        return false; // Prevent location update.
	      } else {
	          window.history.replaceState(historyState, null, path);
	        }
	    }
	  }
	
	  var history = _createDOMHistory2['default'](_extends({}, options, {
	    getCurrentLocation: getCurrentLocation,
	    finishTransition: finishTransition,
	    saveState: _DOMStateStorage.saveState
	  }));
	
	  var listenerCount = 0,
	      stopPopStateListener = undefined;
	
	  function listenBefore(listener) {
	    if (++listenerCount === 1) stopPopStateListener = startPopStateListener(history);
	
	    var unlisten = history.listenBefore(listener);
	
	    return function () {
	      unlisten();
	
	      if (--listenerCount === 0) stopPopStateListener();
	    };
	  }
	
	  function listen(listener) {
	    if (++listenerCount === 1) stopPopStateListener = startPopStateListener(history);
	
	    var unlisten = history.listen(listener);
	
	    return function () {
	      unlisten();
	
	      if (--listenerCount === 0) stopPopStateListener();
	    };
	  }
	
	  // deprecated
	  function registerTransitionHook(hook) {
	    if (++listenerCount === 1) stopPopStateListener = startPopStateListener(history);
	
	    history.registerTransitionHook(hook);
	  }
	
	  // deprecated
	  function unregisterTransitionHook(hook) {
	    history.unregisterTransitionHook(hook);
	
	    if (--listenerCount === 0) stopPopStateListener();
	  }
	
	  return _extends({}, history, {
	    listenBefore: listenBefore,
	    listen: listen,
	    registerTransitionHook: registerTransitionHook,
	    unregisterTransitionHook: unregisterTransitionHook
	  });
	}
	
	exports['default'] = createBrowserHistory;
	module.exports = exports['default'];

/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	exports.default = function (createHistory) {
	  var history = void 0;
	  if (canUseDOM) history = (0, _useRouterHistory2.default)(createHistory)();
	  return history;
	};
	
	var _useRouterHistory = __webpack_require__(543);
	
	var _useRouterHistory2 = _interopRequireDefault(_useRouterHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	module.exports = exports['default'];

/***/ }),
/* 548 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createHashHistory = __webpack_require__(496);
	
	var _createHashHistory2 = _interopRequireDefault(_createHashHistory);
	
	var _createRouterHistory = __webpack_require__(547);
	
	var _createRouterHistory2 = _interopRequireDefault(_createRouterHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _createRouterHistory2.default)(_createHashHistory2.default);
	module.exports = exports['default'];

/***/ }),
/* 549 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.useScroll = exports.ScrollContainer = undefined;
	
	var _ScrollContainer2 = __webpack_require__(550);
	
	var _ScrollContainer3 = _interopRequireDefault(_ScrollContainer2);
	
	var _useScroll2 = __webpack_require__(551);
	
	var _useScroll3 = _interopRequireDefault(_useScroll2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.ScrollContainer = _ScrollContainer3.default;
	exports.useScroll = _useScroll3.default;

/***/ }),
/* 550 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(332);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _warning = __webpack_require__(491);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
	  scrollKey: _react2.default.PropTypes.string.isRequired,
	  shouldUpdateScroll: _react2.default.PropTypes.func,
	  children: _react2.default.PropTypes.element.isRequired
	};
	
	var contextTypes = {
	  // This is necessary when rendering on the client. However, when rendering on
	  // the server, this container will do nothing, and thus does not require the
	  // scroll behavior context.
	  scrollBehavior: _react2.default.PropTypes.object
	};
	
	var ScrollContainer = function (_React$Component) {
	  _inherits(ScrollContainer, _React$Component);
	
	  function ScrollContainer(props, context) {
	    _classCallCheck(this, ScrollContainer);
	
	    // We don't re-register if the scroll key changes, so make sure we
	    // unregister with the initial scroll key just in case the user changes it.
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));
	
	    _this.shouldUpdateScroll = function (prevRouterProps, routerProps) {
	      var shouldUpdateScroll = _this.props.shouldUpdateScroll;
	
	      if (!shouldUpdateScroll) {
	        return true;
	      }
	
	      // Hack to allow accessing scrollBehavior.readPosition().
	      return shouldUpdateScroll.call(_this.context.scrollBehavior.scrollBehavior, prevRouterProps, routerProps);
	    };
	
	    _this.scrollKey = props.scrollKey;
	    return _this;
	  }
	
	  ScrollContainer.prototype.componentDidMount = function componentDidMount() {
	    this.context.scrollBehavior.registerElement(this.props.scrollKey, _reactDom2.default.findDOMNode(this), this.shouldUpdateScroll);
	
	    // Only keep around the current DOM node in development, as this is only
	    // for emitting the appropriate warning.
	    if (false) {
	      this.domNode = _reactDom2.default.findDOMNode(this);
	    }
	  };
	
	  ScrollContainer.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	     false ? (0, _warning2.default)(nextProps.scrollKey === this.props.scrollKey, 'ScrollContainer: <ScrollContainer> does not support changing scrollKey.') : void 0;
	  };
	
	  ScrollContainer.prototype.componentDidUpdate = function componentDidUpdate() {
	    if (false) {
	      var prevDomNode = this.domNode;
	      this.domNode = _reactDom2.default.findDOMNode(this);
	
	      process.env.NODE_ENV !== 'production' ? (0, _warning2.default)(this.domNode === prevDomNode, 'ScrollContainer: <ScrollContainer> does not support changing DOM ' + 'node.') : void 0;
	    }
	  };
	
	  ScrollContainer.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.context.scrollBehavior.unregisterElement(this.scrollKey);
	  };
	
	  ScrollContainer.prototype.render = function render() {
	    return this.props.children;
	  };
	
	  return ScrollContainer;
	}(_react2.default.Component);
	
	ScrollContainer.propTypes = propTypes;
	ScrollContainer.contextTypes = contextTypes;
	
	exports.default = ScrollContainer;
	module.exports = exports['default'];

/***/ }),
/* 551 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = useScroll;
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ScrollBehaviorContext = __webpack_require__(552);
	
	var _ScrollBehaviorContext2 = _interopRequireDefault(_ScrollBehaviorContext);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function useScroll(shouldUpdateScroll) {
	  return {
	    renderRouterContext: function renderRouterContext(child, props) {
	      return _react2.default.createElement(
	        _ScrollBehaviorContext2.default,
	        {
	          shouldUpdateScroll: shouldUpdateScroll,
	          routerProps: props
	        },
	        child
	      );
	    }
	  };
	}
	module.exports = exports['default'];

/***/ }),
/* 552 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ScrollBehavior = __webpack_require__(553);
	
	var _ScrollBehavior2 = _interopRequireDefault(_ScrollBehavior);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
	  shouldUpdateScroll: _react2.default.PropTypes.func,
	  routerProps: _react2.default.PropTypes.object.isRequired,
	  children: _react2.default.PropTypes.element.isRequired
	};
	
	var childContextTypes = {
	  scrollBehavior: _react2.default.PropTypes.object.isRequired
	};
	
	var ScrollBehaviorContext = function (_React$Component) {
	  _inherits(ScrollBehaviorContext, _React$Component);
	
	  function ScrollBehaviorContext(props, context) {
	    _classCallCheck(this, ScrollBehaviorContext);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));
	
	    _initialiseProps.call(_this);
	
	    var routerProps = props.routerProps;
	
	
	    _this.scrollBehavior = new _ScrollBehavior2.default(routerProps.router, function () {
	      return _this.props.routerProps.location;
	    }, _this.shouldUpdateScroll);
	
	    _this.scrollBehavior.updateScroll(null, routerProps);
	    return _this;
	  }
	
	  ScrollBehaviorContext.prototype.getChildContext = function getChildContext() {
	    return {
	      scrollBehavior: this
	    };
	  };
	
	  ScrollBehaviorContext.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
	    var routerProps = this.props.routerProps;
	
	    var prevRouterProps = prevProps.routerProps;
	
	    if (routerProps.location === prevRouterProps.location) {
	      return;
	    }
	
	    this.scrollBehavior.updateScroll(prevRouterProps, routerProps);
	  };
	
	  ScrollBehaviorContext.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.scrollBehavior.stop();
	  };
	
	  ScrollBehaviorContext.prototype.render = function render() {
	    return this.props.children;
	  };
	
	  return ScrollBehaviorContext;
	}(_react2.default.Component);
	
	var _initialiseProps = function _initialiseProps() {
	  var _this2 = this;
	
	  this.shouldUpdateScroll = function (prevRouterProps, routerProps) {
	    var shouldUpdateScroll = _this2.props.shouldUpdateScroll;
	
	    if (!shouldUpdateScroll) {
	      return true;
	    }
	
	    // Hack to allow accessing scrollBehavior.readPosition().
	    return shouldUpdateScroll.call(_this2.scrollBehavior, prevRouterProps, routerProps);
	  };
	
	  this.registerElement = function (key, element, shouldUpdateScroll) {
	    _this2.scrollBehavior.registerElement(key, element, shouldUpdateScroll, _this2.props.routerProps);
	  };
	
	  this.unregisterElement = function (key) {
	    _this2.scrollBehavior.unregisterElement(key);
	  };
	};
	
	ScrollBehaviorContext.propTypes = propTypes;
	ScrollBehaviorContext.childContextTypes = childContextTypes;
	
	exports.default = ScrollBehaviorContext;
	module.exports = exports['default'];

/***/ }),
/* 553 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _off = __webpack_require__(554);
	
	var _off2 = _interopRequireDefault(_off);
	
	var _on = __webpack_require__(556);
	
	var _on2 = _interopRequireDefault(_on);
	
	var _scrollLeft = __webpack_require__(557);
	
	var _scrollLeft2 = _interopRequireDefault(_scrollLeft);
	
	var _scrollTop = __webpack_require__(559);
	
	var _scrollTop2 = _interopRequireDefault(_scrollTop);
	
	var _requestAnimationFrame = __webpack_require__(560);
	
	var _requestAnimationFrame2 = _interopRequireDefault(_requestAnimationFrame);
	
	var _Actions = __webpack_require__(498);
	
	var _DOMStateStorage = __webpack_require__(502);
	
	var _invariant = __webpack_require__(494);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } } /* eslint-disable no-underscore-dangle */
	
	// FIXME: Stop using this gross hack. This won't collide with any actual
	// history location keys, but it's dirty to sneakily use the same storage here.
	var KEY_PREFIX = 's/';
	
	// Try at most this many times to scroll, to avoid getting stuck.
	var MAX_SCROLL_ATTEMPTS = 2;
	
	var ScrollBehavior = function () {
	  function ScrollBehavior(history, getCurrentLocation, shouldUpdateScroll) {
	    var _this = this;
	
	    _classCallCheck(this, ScrollBehavior);
	
	    this._onWindowScroll = function () {
	      // It's possible that this scroll operation was triggered by what will be a
	      // `POP` transition. Instead of updating the saved location immediately, we
	      // have to enqueue the update, then potentially cancel it if we observe a
	      // location update.
	      if (_this._saveWindowPositionHandle === null) {
	        _this._saveWindowPositionHandle = (0, _requestAnimationFrame2.default)(_this._saveWindowPosition);
	      }
	
	      if (_this._windowScrollTarget) {
	        var _windowScrollTarget = _this._windowScrollTarget;
	        var xTarget = _windowScrollTarget[0];
	        var yTarget = _windowScrollTarget[1];
	
	        var x = (0, _scrollLeft2.default)(window);
	        var y = (0, _scrollTop2.default)(window);
	
	        if (x === xTarget && y === yTarget) {
	          _this._windowScrollTarget = null;
	          _this._cancelCheckWindowScroll();
	        }
	      }
	    };
	
	    this._saveWindowPosition = function () {
	      _this._saveWindowPositionHandle = null;
	
	      _this._savePosition(null, window);
	    };
	
	    this._checkWindowScrollPosition = function () {
	      _this._checkWindowScrollHandle = null;
	
	      // We can only get here if scrollTarget is set. Every code path that unsets
	      // scroll target also cancels the handle to avoid calling this handler.
	      // Still, check anyway just in case.
	      /* istanbul ignore if: paranoid guard */
	      if (!_this._windowScrollTarget) {
	        return;
	      }
	
	      var _windowScrollTarget2 = _this._windowScrollTarget;
	      var x = _windowScrollTarget2[0];
	      var y = _windowScrollTarget2[1];
	
	      window.scrollTo(x, y);
	
	      ++_this._numWindowScrollAttempts;
	
	      /* istanbul ignore if: paranoid guard */
	      if (_this._numWindowScrollAttempts >= MAX_SCROLL_ATTEMPTS) {
	        _this._windowScrollTarget = null;
	        return;
	      }
	
	      _this._checkWindowScrollHandle = (0, _requestAnimationFrame2.default)(_this._checkWindowScrollPosition);
	    };
	
	    this._history = history;
	    this._getCurrentLocation = getCurrentLocation;
	    this._shouldUpdateScroll = shouldUpdateScroll;
	
	    // This helps avoid some jankiness in fighting against the browser's
	    // default scroll behavior on `POP` transitions.
	    /* istanbul ignore if: not supported by any browsers on Travis */
	    if ('scrollRestoration' in window.history) {
	      this._oldScrollRestoration = window.history.scrollRestoration;
	      window.history.scrollRestoration = 'manual';
	    } else {
	      this._oldScrollRestoration = null;
	    }
	
	    this._saveWindowPositionHandle = null;
	    this._checkWindowScrollHandle = null;
	    this._windowScrollTarget = null;
	    this._numWindowScrollAttempts = 0;
	
	    this._scrollElements = {};
	
	    // We have to listen to each window scroll update rather than to just
	    // location updates, because some browsers will update scroll position
	    // before emitting the location change.
	    (0, _on2.default)(window, 'scroll', this._onWindowScroll);
	
	    this._unlistenBefore = history.listenBefore(function () {
	      if (_this._saveWindowPositionHandle !== null) {
	        _requestAnimationFrame2.default.cancel(_this._saveWindowPositionHandle);
	        _this._saveWindowPositionHandle = null;
	      }
	
	      // It's fine to save element scroll positions here, though; the browser
	      // won't modify them.
	      Object.keys(_this._scrollElements).forEach(function (key) {
	        _this._saveElementPosition(key);
	      });
	    });
	  }
	
	  ScrollBehavior.prototype.stop = function stop() {
	    /* istanbul ignore if: not supported by any browsers on Travis */
	    if (this._oldScrollRestoration) {
	      window.history.scrollRestoration = this._oldScrollRestoration;
	    }
	
	    (0, _off2.default)(window, 'scroll', this._onWindowScroll);
	    this._cancelCheckWindowScroll();
	
	    this._unlistenBefore();
	  };
	
	  ScrollBehavior.prototype.registerElement = function registerElement(key, element, shouldUpdateScroll, context) {
	    !!this._scrollElements[key] ?  false ? (0, _invariant2.default)(false, 'ScrollBehavior: There is already an element registered for `%s`.', key) : (0, _invariant2.default)(false) : void 0;
	
	    this._scrollElements[key] = { element: element, shouldUpdateScroll: shouldUpdateScroll };
	    this._updateElementScroll(key, null, context);
	  };
	
	  ScrollBehavior.prototype.unregisterElement = function unregisterElement(key) {
	    !this._scrollElements[key] ?  false ? (0, _invariant2.default)(false, 'ScrollBehavior: There is no element registered for `%s`.', key) : (0, _invariant2.default)(false) : void 0;
	
	    delete this._scrollElements[key];
	  };
	
	  ScrollBehavior.prototype.updateScroll = function updateScroll(prevContext, context) {
	    var _this2 = this;
	
	    this._updateWindowScroll(prevContext, context);
	
	    Object.keys(this._scrollElements).forEach(function (key) {
	      _this2._updateElementScroll(key, prevContext, context);
	    });
	  };
	
	  ScrollBehavior.prototype.readPosition = function readPosition(location, key) {
	    return (0, _DOMStateStorage.readState)(this._getKey(location, key));
	  };
	
	  ScrollBehavior.prototype._cancelCheckWindowScroll = function _cancelCheckWindowScroll() {
	    if (this._checkWindowScrollHandle !== null) {
	      _requestAnimationFrame2.default.cancel(this._checkWindowScrollHandle);
	      this._checkWindowScrollHandle = null;
	    }
	  };
	
	  ScrollBehavior.prototype._saveElementPosition = function _saveElementPosition(key) {
	    var element = this._scrollElements[key].element;
	
	
	    this._savePosition(key, element);
	  };
	
	  ScrollBehavior.prototype._savePosition = function _savePosition(key, element) {
	    // We have to directly update `DOMStateStorage`, because actually updating
	    // the location could cause e.g. React Router to re-render the entire page,
	    // which would lead to observably bad scroll performance.
	    (0, _DOMStateStorage.saveState)(this._getKey(this._getCurrentLocation(), key), [(0, _scrollLeft2.default)(element), (0, _scrollTop2.default)(element)]);
	  };
	
	  ScrollBehavior.prototype._getKey = function _getKey(location, key) {
	    // Use fallback location key when actual location key is unavailable.
	    var locationKey = location.key || this._history.createPath(location);
	
	    return key == null ? '' + KEY_PREFIX + locationKey : '' + KEY_PREFIX + key + '/' + locationKey;
	  };
	
	  ScrollBehavior.prototype._updateWindowScroll = function _updateWindowScroll(prevContext, context) {
	    // Whatever we were doing before isn't relevant any more.
	    this._cancelCheckWindowScroll();
	
	    this._windowScrollTarget = this._getScrollTarget(null, this._shouldUpdateScroll, prevContext, context);
	
	    // Check the scroll position to see if we even need to scroll. This call
	    // will unset _windowScrollTarget if the current scroll position matches
	    // the target.
	    this._onWindowScroll();
	
	    if (!this._windowScrollTarget) {
	      return;
	    }
	
	    // Updating the window scroll position is really flaky. Just trying to
	    // scroll it isn't enough. Instead, try to scroll a few times until it
	    // works.
	    this._numWindowScrollAttempts = 0;
	    this._checkWindowScrollPosition();
	  };
	
	  ScrollBehavior.prototype._updateElementScroll = function _updateElementScroll(key, prevContext, context) {
	    var _scrollElements$key = this._scrollElements[key];
	    var element = _scrollElements$key.element;
	    var shouldUpdateScroll = _scrollElements$key.shouldUpdateScroll;
	
	
	    var scrollTarget = this._getScrollTarget(key, shouldUpdateScroll, prevContext, context);
	    if (!scrollTarget) {
	      return;
	    }
	
	    // Unlike with the window, there shouldn't be any flakiness to deal with
	    // here.
	    var x = scrollTarget[0];
	    var y = scrollTarget[1];
	
	    (0, _scrollLeft2.default)(element, x);
	    (0, _scrollTop2.default)(element, y);
	  };
	
	  ScrollBehavior.prototype._getScrollTarget = function _getScrollTarget(key, shouldUpdateScroll, prevContext, context) {
	    var scrollTarget = shouldUpdateScroll ? shouldUpdateScroll.call(this, prevContext, context) : true;
	
	    if (!scrollTarget || Array.isArray(scrollTarget)) {
	      return scrollTarget;
	    }
	
	    var location = this._getCurrentLocation();
	    if (location.action === _Actions.PUSH) {
	      return [0, 0];
	    }
	
	    return this.readPosition(location, key) || [0, 0];
	  };
	
	  return ScrollBehavior;
	}();
	
	exports.default = ScrollBehavior;
	module.exports = exports['default'];

/***/ }),
/* 554 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var canUseDOM = __webpack_require__(555);
	var off = function off() {};
	
	if (canUseDOM) {
	
	  off = (function () {
	
	    if (document.addEventListener) return function (node, eventName, handler, capture) {
	      return node.removeEventListener(eventName, handler, capture || false);
	    };else if (document.attachEvent) return function (node, eventName, handler) {
	      return node.detachEvent('on' + eventName, handler);
	    };
	  })();
	}
	
	module.exports = off;

/***/ }),
/* 555 */
/***/ (function(module, exports) {

	'use strict';
	module.exports = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

/***/ }),
/* 556 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var canUseDOM = __webpack_require__(555);
	var on = function on() {};
	
	if (canUseDOM) {
	  on = (function () {
	
	    if (document.addEventListener) return function (node, eventName, handler, capture) {
	      return node.addEventListener(eventName, handler, capture || false);
	    };else if (document.attachEvent) return function (node, eventName, handler) {
	      return node.attachEvent('on' + eventName, handler);
	    };
	  })();
	}
	
	module.exports = on;

/***/ }),
/* 557 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var getWindow = __webpack_require__(558);
	
	module.exports = function scrollTop(node, val) {
	  var win = getWindow(node);
	
	  if (val === undefined) return win ? 'pageXOffset' in win ? win.pageXOffset : win.document.documentElement.scrollLeft : node.scrollLeft;
	
	  if (win) win.scrollTo(val, 'pageYOffset' in win ? win.pageYOffset : win.document.documentElement.scrollTop);else node.scrollLeft = val;
	};

/***/ }),
/* 558 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function getWindow(node) {
	  return node === node.window ? node : node.nodeType === 9 ? node.defaultView || node.parentWindow : false;
	};

/***/ }),
/* 559 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var getWindow = __webpack_require__(558);
	
	module.exports = function scrollTop(node, val) {
	  var win = getWindow(node);
	
	  if (val === undefined) return win ? 'pageYOffset' in win ? win.pageYOffset : win.document.documentElement.scrollTop : node.scrollTop;
	
	  if (win) win.scrollTo('pageXOffset' in win ? win.pageXOffset : win.document.documentElement.scrollLeft, val);else node.scrollTop = val;
	};

/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var canUseDOM = __webpack_require__(555);
	
	var vendors = ['', 'webkit', 'moz', 'o', 'ms'],
	    cancel = 'clearTimeout',
	    raf = fallback,
	    compatRaf;
	
	var getKey = function getKey(vendor, k) {
	  return vendor + (!vendor ? k : k[0].toUpperCase() + k.substr(1)) + 'AnimationFrame';
	};
	
	if (canUseDOM) {
	  vendors.some(function (vendor) {
	    var rafKey = getKey(vendor, 'request');
	
	    if (rafKey in window) {
	      cancel = getKey(vendor, 'cancel');
	      return raf = function (cb) {
	        return window[rafKey](cb);
	      };
	    }
	  });
	}
	
	/* https://github.com/component/raf */
	var prev = new Date().getTime();
	
	function fallback(fn) {
	  var curr = new Date().getTime(),
	      ms = Math.max(0, 16 - (curr - prev)),
	      req = setTimeout(fn, ms);
	
	  prev = curr;
	  return req;
	}
	
	compatRaf = function (cb) {
	  return raf(cb);
	};
	compatRaf.cancel = function (id) {
	  return window[cancel](id);
	};
	
	module.exports = compatRaf;

/***/ }),
/* 561 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict'
	
	if (true) {
	  module.exports = __webpack_require__(562);
	} else {
	  module.exports = require('./dist/react-hot-loader.development.js');
	}


/***/ }),
/* 562 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";function _interopDefault(e){return e&&"object"==typeof e&&"default"in e?e.default:e}Object.defineProperty(exports,"__esModule",{value:!0});var React=_interopDefault(__webpack_require__(300)),classCallCheck=function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")},inherits=function(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)},possibleConstructorReturn=function(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t},AppContainer=function(e){function t(){return classCallCheck(this,t),possibleConstructorReturn(this,e.apply(this,arguments))}return inherits(t,e),t.prototype.render=function(){return React.Children.only(this.props.children)},t}(React.Component),hot_prod=function(){return function(e){return e}},areComponentsEqual=function(e,t){return e===t},setConfig=function(){};exports.AppContainer=AppContainer,exports.hot=hot_prod,exports.areComponentsEqual=areComponentsEqual,exports.setConfig=setConfig;


/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(486);
	
	var _app = __webpack_require__(564);
	
	var _app2 = _interopRequireDefault(_app);
	
	var _login = __webpack_require__(1598);
	
	var _login2 = _interopRequireDefault(_login);
	
	var _activate = __webpack_require__(1662);
	
	var _activate2 = _interopRequireDefault(_activate);
	
	var _acceptCreatorInvite = __webpack_require__(1663);
	
	var _acceptCreatorInvite2 = _interopRequireDefault(_acceptCreatorInvite);
	
	var _acceptRevenueSharingInvite = __webpack_require__(1668);
	
	var _acceptRevenueSharingInvite2 = _interopRequireDefault(_acceptRevenueSharingInvite);
	
	var _forgot = __webpack_require__(1669);
	
	var _forgot2 = _interopRequireDefault(_forgot);
	
	var _reset = __webpack_require__(1670);
	
	var _reset2 = _interopRequireDefault(_reset);
	
	var _dashboard = __webpack_require__(1671);
	
	var _dashboard2 = _interopRequireDefault(_dashboard);
	
	var _welcome = __webpack_require__(1675);
	
	var _welcome2 = _interopRequireDefault(_welcome);
	
	var _unauthorized = __webpack_require__(1680);
	
	var _unauthorized2 = _interopRequireDefault(_unauthorized);
	
	var _account = __webpack_require__(1681);
	
	var _account2 = _interopRequireDefault(_account);
	
	var _revenueSharing = __webpack_require__(1684);
	
	var _revenueSharing2 = _interopRequireDefault(_revenueSharing);
	
	var _sso = __webpack_require__(1708);
	
	var _sso2 = _interopRequireDefault(_sso);
	
	var _organization = __webpack_require__(1709);
	
	var _organization2 = _interopRequireDefault(_organization);
	
	var _balance = __webpack_require__(1739);
	
	var _balance2 = _interopRequireDefault(_balance);
	
	var _billing = __webpack_require__(1745);
	
	var _billing2 = _interopRequireDefault(_billing);
	
	var _scannerSetup = __webpack_require__(1757);
	
	var _scannerSetup2 = _interopRequireDefault(_scannerSetup);
	
	var _feedback = __webpack_require__(1758);
	
	var _feedback2 = _interopRequireDefault(_feedback);
	
	var _shop = __webpack_require__(1759);
	
	var _shop2 = _interopRequireDefault(_shop);
	
	var _apiSetup = __webpack_require__(1760);
	
	var _apiSetup2 = _interopRequireDefault(_apiSetup);
	
	var _creatorHub = __webpack_require__(1761);
	
	var _creatorHub2 = _interopRequireDefault(_creatorHub);
	
	var _creatorFilm = __webpack_require__(1770);
	
	var _creatorFilm2 = _interopRequireDefault(_creatorFilm);
	
	var _creatorVirtualContent = __webpack_require__(1779);
	
	var _creatorVirtualContent2 = _interopRequireDefault(_creatorVirtualContent);
	
	var _creatorTitleDelivery = __webpack_require__(1782);
	
	var _creatorTitleDelivery2 = _interopRequireDefault(_creatorTitleDelivery);
	
	var _eventBucket = __webpack_require__(1783);
	
	var _eventBucket2 = _interopRequireDefault(_eventBucket);
	
	var _newEventBucket = __webpack_require__(1870);
	
	var _newEventBucket2 = _interopRequireDefault(_newEventBucket);
	
	var _eventBucketSettings = __webpack_require__(1871);
	
	var _eventBucketSettings2 = _interopRequireDefault(_eventBucketSettings);
	
	var _eventBucketConfigurator = __webpack_require__(2105);
	
	var _eventBucketConfigurator2 = _interopRequireDefault(_eventBucketConfigurator);
	
	var _eventBucketEmbed = __webpack_require__(2192);
	
	var _eventBucketEmbed2 = _interopRequireDefault(_eventBucketEmbed);
	
	var _eventBucketDuplicate = __webpack_require__(2194);
	
	var _eventBucketDuplicate2 = _interopRequireDefault(_eventBucketDuplicate);
	
	var _eventBucketEverywhere = __webpack_require__(2195);
	
	var _eventBucketEverywhere2 = _interopRequireDefault(_eventBucketEverywhere);
	
	var _scheduler = __webpack_require__(2196);
	
	var _scheduler2 = _interopRequireDefault(_scheduler);
	
	var _checkIn = __webpack_require__(2266);
	
	var _checkIn2 = _interopRequireDefault(_checkIn);
	
	var _balloting = __webpack_require__(2275);
	
	var _balloting2 = _interopRequireDefault(_balloting);
	
	var _ballotingSetup = __webpack_require__(2284);
	
	var _ballotingSetup2 = _interopRequireDefault(_ballotingSetup);
	
	var _ballotingApp = __webpack_require__(2285);
	
	var _ballotingApp2 = _interopRequireDefault(_ballotingApp);
	
	var _ballotingPrint = __webpack_require__(2286);
	
	var _ballotingPrint2 = _interopRequireDefault(_ballotingPrint);
	
	var _ballotingRecord = __webpack_require__(2287);
	
	var _ballotingRecord2 = _interopRequireDefault(_ballotingRecord);
	
	var _ballotingTabulate = __webpack_require__(2289);
	
	var _ballotingTabulate2 = _interopRequireDefault(_ballotingTabulate);
	
	var _ballotingConsolidatedAudit = __webpack_require__(2290);
	
	var _ballotingConsolidatedAudit2 = _interopRequireDefault(_ballotingConsolidatedAudit);
	
	var _analytics = __webpack_require__(2291);
	
	var _analytics2 = _interopRequireDefault(_analytics);
	
	var _passAnalytics = __webpack_require__(2292);
	
	var _passAnalytics2 = _interopRequireDefault(_passAnalytics);
	
	var _attendeeAnalytics = __webpack_require__(2297);
	
	var _attendeeAnalytics2 = _interopRequireDefault(_attendeeAnalytics);
	
	var _geoAnalytics = __webpack_require__(2299);
	
	var _geoAnalytics2 = _interopRequireDefault(_geoAnalytics);
	
	var _eventTicketAnalytics = __webpack_require__(2301);
	
	var _eventTicketAnalytics2 = _interopRequireDefault(_eventTicketAnalytics);
	
	var _eventSalesAnalytics = __webpack_require__(2302);
	
	var _eventSalesAnalytics2 = _interopRequireDefault(_eventSalesAnalytics);
	
	var _eventPassesAnalytics = __webpack_require__(2304);
	
	var _eventPassesAnalytics2 = _interopRequireDefault(_eventPassesAnalytics);
	
	var _streamingAnalytics = __webpack_require__(2306);
	
	var _streamingAnalytics2 = _interopRequireDefault(_streamingAnalytics);
	
	var _salesAnalytics = __webpack_require__(2313);
	
	var _salesAnalytics2 = _interopRequireDefault(_salesAnalytics);
	
	var _ledgerAnalytics = __webpack_require__(2314);
	
	var _ledgerAnalytics2 = _interopRequireDefault(_ledgerAnalytics);
	
	var _recurringPassAnalytics = __webpack_require__(2619);
	
	var _recurringPassAnalytics2 = _interopRequireDefault(_recurringPassAnalytics);
	
	var _ledgerBoxOfficeReport = __webpack_require__(2621);
	
	var _ledgerBoxOfficeReport2 = _interopRequireDefault(_ledgerBoxOfficeReport);
	
	var _boxOffice = __webpack_require__(2623);
	
	var _boxOffice2 = _interopRequireDefault(_boxOffice);
	
	var _films = __webpack_require__(2667);
	
	var _films2 = _interopRequireDefault(_films);
	
	var _filmEditor = __webpack_require__(2670);
	
	var _filmEditor2 = _interopRequireDefault(_filmEditor);
	
	var _newFilm = __webpack_require__(2678);
	
	var _newFilm2 = _interopRequireDefault(_newFilm);
	
	var _virtualFestival = __webpack_require__(2679);
	
	var _virtualFestival2 = _interopRequireDefault(_virtualFestival);
	
	var _virtualFestivalLivestreamingHub = __webpack_require__(2681);
	
	var _virtualFestivalLivestreamingHub2 = _interopRequireDefault(_virtualFestivalLivestreamingHub);
	
	var _virtualFestivalLivestreamingHubFilm = __webpack_require__(2682);
	
	var _virtualFestivalLivestreamingHubFilm2 = _interopRequireDefault(_virtualFestivalLivestreamingHubFilm);
	
	var _bulkImportFilms = __webpack_require__(2687);
	
	var _bulkImportFilms2 = _interopRequireDefault(_bulkImportFilms);
	
	var _events = __webpack_require__(2691);
	
	var _events2 = _interopRequireDefault(_events);
	
	var _event = __webpack_require__(2692);
	
	var _event2 = _interopRequireDefault(_event);
	
	var _eventEditor = __webpack_require__(2708);
	
	var _eventEditor2 = _interopRequireDefault(_eventEditor);
	
	var _newEvent = __webpack_require__(2735);
	
	var _newEvent2 = _interopRequireDefault(_newEvent);
	
	var _bulkImportEvents = __webpack_require__(2736);
	
	var _bulkImportEvents2 = _interopRequireDefault(_bulkImportEvents);
	
	var _passBucket = __webpack_require__(2737);
	
	var _passBucket2 = _interopRequireDefault(_passBucket);
	
	var _passBucketEditor = __webpack_require__(2743);
	
	var _passBucketEditor2 = _interopRequireDefault(_passBucketEditor);
	
	var _newPassBucket = __webpack_require__(2750);
	
	var _newPassBucket2 = _interopRequireDefault(_newPassBucket);
	
	var _passLabelPrinter = __webpack_require__(2751);
	
	var _passLabelPrinter2 = _interopRequireDefault(_passLabelPrinter);
	
	var _bulkImportPasses = __webpack_require__(2752);
	
	var _bulkImportPasses2 = _interopRequireDefault(_bulkImportPasses);
	
	var _passBuckets = __webpack_require__(2753);
	
	var _passBuckets2 = _interopRequireDefault(_passBuckets);
	
	var _itemBucket = __webpack_require__(2754);
	
	var _itemBucket2 = _interopRequireDefault(_itemBucket);
	
	var _itemBucketEditor = __webpack_require__(2759);
	
	var _itemBucketEditor2 = _interopRequireDefault(_itemBucketEditor);
	
	var _newItemBucket = __webpack_require__(2760);
	
	var _newItemBucket2 = _interopRequireDefault(_newItemBucket);
	
	var _itemBuckets = __webpack_require__(2761);
	
	var _itemBuckets2 = _interopRequireDefault(_itemBuckets);
	
	var _coupons = __webpack_require__(2762);
	
	var _coupons2 = _interopRequireDefault(_coupons);
	
	var _coupon = __webpack_require__(2763);
	
	var _coupon2 = _interopRequireDefault(_coupon);
	
	var _couponEditor = __webpack_require__(2765);
	
	var _couponEditor2 = _interopRequireDefault(_couponEditor);
	
	var _newCoupon = __webpack_require__(2767);
	
	var _newCoupon2 = _interopRequireDefault(_newCoupon);
	
	var _venues = __webpack_require__(2768);
	
	var _venues2 = _interopRequireDefault(_venues);
	
	var _venue = __webpack_require__(2769);
	
	var _venue2 = _interopRequireDefault(_venue);
	
	var _venueEditor = __webpack_require__(2771);
	
	var _venueEditor2 = _interopRequireDefault(_venueEditor);
	
	var _venueSeatmapEditor = __webpack_require__(2826);
	
	var _venueSeatmapEditor2 = _interopRequireDefault(_venueSeatmapEditor);
	
	var _newVenue = __webpack_require__(2827);
	
	var _newVenue2 = _interopRequireDefault(_newVenue);
	
	var _tags = __webpack_require__(2828);
	
	var _tags2 = _interopRequireDefault(_tags);
	
	var _tagEditor = __webpack_require__(2829);
	
	var _tagEditor2 = _interopRequireDefault(_tagEditor);
	
	var _newTag = __webpack_require__(2830);
	
	var _newTag2 = _interopRequireDefault(_newTag);
	
	var _kiosks = __webpack_require__(2831);
	
	var _kiosks2 = _interopRequireDefault(_kiosks);
	
	var _kiosk = __webpack_require__(2835);
	
	var _kiosk2 = _interopRequireDefault(_kiosk);
	
	var _newKiosk = __webpack_require__(2836);
	
	var _newKiosk2 = _interopRequireDefault(_newKiosk);
	
	var _mailings = __webpack_require__(2837);
	
	var _mailings2 = _interopRequireDefault(_mailings);
	
	var _mailing = __webpack_require__(2841);
	
	var _mailing2 = _interopRequireDefault(_mailing);
	
	var _mailingPreview = __webpack_require__(2844);
	
	var _mailingPreview2 = _interopRequireDefault(_mailingPreview);
	
	var _newMailing = __webpack_require__(2845);
	
	var _newMailing2 = _interopRequireDefault(_newMailing);
	
	var _externalSyncs = __webpack_require__(2846);
	
	var _externalSyncs2 = _interopRequireDefault(_externalSyncs);
	
	var _externalSync = __webpack_require__(2850);
	
	var _externalSync2 = _interopRequireDefault(_externalSync);
	
	var _newExternalSync = __webpack_require__(2851);
	
	var _newExternalSync2 = _interopRequireDefault(_newExternalSync);
	
	var _people = __webpack_require__(2852);
	
	var _people2 = _interopRequireDefault(_people);
	
	var _bulkImportPeople = __webpack_require__(2854);
	
	var _bulkImportPeople2 = _interopRequireDefault(_bulkImportPeople);
	
	var _person = __webpack_require__(2855);
	
	var _person2 = _interopRequireDefault(_person);
	
	var _orders = __webpack_require__(2897);
	
	var _orders2 = _interopRequireDefault(_orders);
	
	var _order = __webpack_require__(2898);
	
	var _order2 = _interopRequireDefault(_order);
	
	var _giftCards = __webpack_require__(2900);
	
	var _giftCards2 = _interopRequireDefault(_giftCards);
	
	var _reports = __webpack_require__(2903);
	
	var _reports2 = _interopRequireDefault(_reports);
	
	var _reportScheduler = __webpack_require__(2904);
	
	var _reportScheduler2 = _interopRequireDefault(_reportScheduler);
	
	var _crossEventBucketReports = __webpack_require__(2916);
	
	var _crossEventBucketReports2 = _interopRequireDefault(_crossEventBucketReports);
	
	var _ticket = __webpack_require__(2917);
	
	var _ticket2 = _interopRequireDefault(_ticket);
	
	var _pass = __webpack_require__(2918);
	
	var _pass2 = _interopRequireDefault(_pass);
	
	var _passHistory = __webpack_require__(2919);
	
	var _passHistory2 = _interopRequireDefault(_passHistory);
	
	var _ticketHistory = __webpack_require__(2931);
	
	var _ticketHistory2 = _interopRequireDefault(_ticketHistory);
	
	var _auditLog = __webpack_require__(2932);
	
	var _auditLog2 = _interopRequireDefault(_auditLog);
	
	var _godUsers = __webpack_require__(2934);
	
	var _godUsers2 = _interopRequireDefault(_godUsers);
	
	var _godAutoCreateUserModal = __webpack_require__(2936);
	
	var _godAutoCreateUserModal2 = _interopRequireDefault(_godAutoCreateUserModal);
	
	var _godRevenue = __webpack_require__(2940);
	
	var _godRevenue2 = _interopRequireDefault(_godRevenue);
	
	var _godUpcomingEvents = __webpack_require__(2942);
	
	var _godUpcomingEvents2 = _interopRequireDefault(_godUpcomingEvents);
	
	var _godStreams = __webpack_require__(2943);
	
	var _godStreams2 = _interopRequireDefault(_godStreams);
	
	var _godLookup = __webpack_require__(2944);
	
	var _godLookup2 = _interopRequireDefault(_godLookup);
	
	var _godInvoicingHub = __webpack_require__(2945);
	
	var _godInvoicingHub2 = _interopRequireDefault(_godInvoicingHub);
	
	var _godOrganizationHealth = __webpack_require__(2946);
	
	var _godOrganizationHealth2 = _interopRequireDefault(_godOrganizationHealth);
	
	var _checkPass = __webpack_require__(2948);
	
	var _checkPass2 = _interopRequireDefault(_checkPass);
	
	var _tag = __webpack_require__(2949);
	
	var _tag2 = _interopRequireDefault(_tag);
	
	var _UserStore = __webpack_require__(974);
	
	var _UserStore2 = _interopRequireDefault(_UserStore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// import CloneMailing from "./components/clone-mailing.jsx";
	function onDashboardEnter(nextState, replace) {
	  // If not logged in, we'll catch them on the `App` componentWillMount
	  if (!_UserStore2.default.getState().isLoggedIn) {
	    return;
	  }
	
	  var missingPermissions = [],
	      permitted = nextState.routes.every(function (r) {
	    if (!r.permission) {
	      return true;
	    }
	    var permissions = r.permission.split(/\s*,\s*/g);
	    return permissions.some(function (p) {
	      if (_UserStore2.default.hasPermission(p)) {
	        return true;
	      } else {
	        missingPermissions.push(p);
	        return false;
	      }
	    });
	  });
	
	  if (!permitted) {
	    replace({
	      pathname: "/unauthorized",
	      state: {
	        missing: missingPermissions
	      }
	    });
	  }
	}
	
	function onDashboardChange(prevState, nextState, replace) {
	  return onDashboardEnter(nextState, replace);
	}
	
	var AppRoutes = _react2.default.createElement(
	  _reactRouter.Route,
	  { name: "root", path: "/", component: _app2.default },
	  _react2.default.createElement(_reactRouter.Route, { name: "login", path: "login", component: _login2.default }),
	  _react2.default.createElement(_reactRouter.Route, { name: "activate", path: "activate", component: _activate2.default }),
	  _react2.default.createElement(_reactRouter.Route, { name: "forgot", path: "forgot", component: _forgot2.default }),
	  _react2.default.createElement(_reactRouter.Route, { name: "reset", path: "reset", component: _reset2.default }),
	  _react2.default.createElement(_reactRouter.Route, { name: "sso", path: "sso", component: _sso2.default }),
	  _react2.default.createElement(_reactRouter.Route, {
	    name: "accept_creator_invite",
	    path: "accept_creator_invite",
	    component: _acceptCreatorInvite2.default
	  }),
	  _react2.default.createElement(_reactRouter.Route, {
	    name: "accept_revenue_sharing_invite",
	    path: "accept_revenue_sharing_invite",
	    component: _acceptRevenueSharingInvite2.default
	  }),
	  _react2.default.createElement(
	    _reactRouter.Route,
	    {
	      name: "dashboard",
	      onEnter: onDashboardEnter,
	      onChange: onDashboardChange,
	      path: "",
	      component: _dashboard2.default
	    },
	    _react2.default.createElement(_reactRouter.Route, { name: "welcome", path: "welcome", component: _welcome2.default }),
	    _react2.default.createElement(_reactRouter.Route, { name: "unauthorized", path: "unauthorized", component: _unauthorized2.default }),
	    _react2.default.createElement(_reactRouter.Route, { name: "account", path: "account", component: _account2.default }),
	    _react2.default.createElement(_reactRouter.Route, {
	      name: "organization",
	      permission: "manage_organization",
	      path: "organization",
	      component: _organization2.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      name: "billing",
	      permission: "manage_billing",
	      path: "billing",
	      component: _billing2.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      name: "balance",
	      permission: "manage_balance",
	      path: "balance",
	      component: _balance2.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      name: "revenue_sharing",
	      path: "revenue_sharing",
	      component: _revenueSharing2.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      name: "revenue_sharing-event",
	      path: "revenue_sharing/:eventId(/:tab)",
	      component: _event2.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      name: "scanner-setup",
	      permission: "manage_scanner,setup_scanner",
	      path: "account/scanner",
	      component: _scannerSetup2.default
	    }),
	    _react2.default.createElement(
	      _reactRouter.Route,
	      { name: "feedback", path: "feedback" },
	      _react2.default.createElement(_reactRouter.IndexRoute, { component: _feedback2.default }),
	      _react2.default.createElement(_reactRouter.Route, { path: "*", component: _feedback2.default })
	    ),
	    _react2.default.createElement(
	      _reactRouter.Route,
	      { name: "shop", path: "shop" },
	      _react2.default.createElement(_reactRouter.IndexRoute, { component: _shop2.default }),
	      _react2.default.createElement(_reactRouter.Route, { path: "*", component: _shop2.default })
	    ),
	    _react2.default.createElement(_reactRouter.Route, {
	      name: "api-setup",
	      permission: "manage_organization",
	      path: "organization/api",
	      component: _apiSetup2.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, { name: "creator-hub", path: "creator_hub", component: _creatorHub2.default }),
	    _react2.default.createElement(_reactRouter.Route, {
	      name: "creator-film",
	      path: "creator_hub/films/:filmId",
	      component: _creatorFilm2.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      name: "creator-virtual-content",
	      path: "creator_hub/virtual_content/:virtualContentId",
	      component: _creatorVirtualContent2.default
	    }),
	    _react2.default.createElement(_reactRouter.Redirect, { from: "titles", to: "creator_hub", exact: true }),
	    _react2.default.createElement(_reactRouter.Route, {
	      name: "creator-title-delivery",
	      path: "titles/:titleId/deliveries/:titleDeliveryId",
	      component: _creatorTitleDelivery2.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      name: "new-event-bucket",
	      permission: "edit_event_bucket",
	      path: "event_buckets/new",
	      component: _newEventBucket2.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      name: "event-bucket",
	      permission: "view_event_bucket,manage_configurator,manage_embed_wizard",
	      path: "event_buckets/:eventBucketId",
	      component: _eventBucket2.default
	    }),
	    _react2.default.createElement(
	      _reactRouter.Route,
	      {
	        name: "event-bucket-settings",
	        permission: "edit_event_bucket,manage_configurator,manage_embed_wizard",
	        path: "event_buckets/:eventBucketId/settings",
	        component: _eventBucketSettings2.default,
	        ignoreScrollBehavior: true
	      },
	      _react2.default.createElement(_reactRouter.Route, {
	        name: "event-bucket-configurator",
	        permission: "edit_event_bucket,manage_configurator",
	        path: "/event_buckets/:eventBucketId/settings/configurator(/:tab)",
	        component: _eventBucketConfigurator2.default
	      }),
	      _react2.default.createElement(_reactRouter.Route, {
	        name: "event-bucket-embed",
	        permission: "edit_event_bucket,manage_embed_wizard",
	        path: "/event_buckets/:eventBucketId/settings/embed",
	        component: _eventBucketEmbed2.default
	      }),
	      _react2.default.createElement(_reactRouter.Route, {
	        name: "event-bucket-duplicate",
	        permission: "edit_event_bucket",
	        path: "/event_buckets/:eventBucketId/settings/duplicate",
	        component: _eventBucketDuplicate2.default
	      }),
	      _react2.default.createElement(_reactRouter.Route, {
	        name: "event-bucket-everywhere",
	        permission: "edit_event_bucket",
	        path: "/event_buckets/:eventBucketId/settings/everywhere",
	        component: _eventBucketEverywhere2.default
	      })
	    ),
	    _react2.default.createElement(_reactRouter.Route, {
	      name: "bulk-import-events",
	      permission: "bulk_import_events",
	      path: "event_buckets/:eventBucketId/bulk_import_events",
	      component: _bulkImportEvents2.default
	    }),
	    _react2.default.createElement(
	      _reactRouter.Route,
	      {
	        name: "balloting",
	        permission: "setup_balloting,app_balloting,print_balloting,record_balloting,tabulate_balloting,manage_balloting",
	        path: "event_buckets/:eventBucketId/balloting",
	        component: _balloting2.default
	      },
	      _react2.default.createElement(_reactRouter.Route, {
	        name: "balloting-setup",
	        permission: "manage_balloting,setup_balloting",
	        path: "/event_buckets/:eventBucketId/balloting/setup",
	        component: _ballotingSetup2.default
	      }),
	      _react2.default.createElement(_reactRouter.Route, {
	        name: "balloting-app",
	        permission: "manage_balloting,app_balloting",
	        path: "/event_buckets/:eventBucketId/balloting/app",
	        component: _ballotingApp2.default
	      }),
	      _react2.default.createElement(_reactRouter.Route, {
	        name: "balloting-print",
	        permission: "manage_balloting,print_balloting",
	        path: "/event_buckets/:eventBucketId/balloting/print",
	        component: _ballotingPrint2.default
	      }),
	      _react2.default.createElement(_reactRouter.Route, {
	        name: "balloting-record",
	        permission: "manage_balloting,record_balloting",
	        path: "/event_buckets/:eventBucketId/balloting/record",
	        component: _ballotingRecord2.default
	      }),
	      _react2.default.createElement(_reactRouter.Route, {
	        name: "balloting-tabulate",
	        permission: "manage_balloting,tabulate_balloting",
	        path: "/event_buckets/:eventBucketId/balloting/tabulate",
	        component: _ballotingTabulate2.default
	      }),
	      _react2.default.createElement(_reactRouter.Route, {
	        name: "balloting-consolidated-audit",
	        permission: "manage_balloting,tabulate_balloting",
	        path: "/event_buckets/:eventBucketId/balloting/consolidated_audit",
	        component: _ballotingConsolidatedAudit2.default
	      })
	    ),
	    _react2.default.createElement(_reactRouter.Route, {
	      name: "analytics",
	      permission: "view_analytics_list",
	      path: "event_buckets/:eventBucketId/analytics",
	      component: _analytics2.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      name: "pass-analytics",
	      permission: "view_analytics,view_pass_sales_analytics",
	      path: "event_buckets/:eventBucketId/analytics/passes",
	      component: _passAnalytics2.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      name: "membership-analytics",
	      permission: "view_analytics,view_pass_sales_analytics",
	      path: "event_buckets/:eventBucketId/analytics/memberships",
	      component: _passAnalytics2.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      name: "attendee-analytics",
	      permission: "view_analytics,view_attendee_analytics",
	      path: "event_buckets/:eventBucketId/analytics/attendees",
	      component: _attendeeAnalytics2.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      name: "geo-analytics",
	      permission: "view_analytics,view_geo_analytics",
	      path: "event_buckets/:eventBucketId/analytics/geo",
	      component: _geoAnalytics2.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      name: "event-ticket-analytics",
	      permission: "view_analytics,view_event_analytics",
	      path: "event_buckets/:eventBucketId/analytics/events",
	      component: _eventTicketAnalytics2.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      name: "event-sales-analytics",
	      permission: "view_analytics,view_standalone_ticket_analytics",
	      path: "event_buckets/:eventBucketId/analytics/event_sales",
	      component: _eventSalesAnalytics2.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      name: "event-passes-analytics",
	      permission: "view_analytics,view_pass_ticket_analytics",
	      path: "event_buckets/:eventBucketId/analytics/event_passes",
	      component: _eventPassesAnalytics2.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      name: "event-memberships-analytics",
	      permission: "view_analytics,view_pass_ticket_analytics",
	      path: "event_buckets/:eventBucketId/analytics/event_memberships",
	      component: _eventPassesAnalytics2.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      name: "streaming-analytics",
	      permission: "view_analytics,view_streaming_analytics",
	      path: "event_buckets/:eventBucketId/analytics/streaming",
	      component: _streamingAnalytics2.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      name: "sales-analytics",
	      permission: "view_analytics,view_sales_analytics",
	      path: "event_buckets/:eventBucketId/analytics/sales",
	      component: _salesAnalytics2.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      name: "recurring-pass-analytics",
	      permission: "view_analytics,view_recurring_pass_analytics",
	      path: "event_buckets/:eventBucketId/analytics/recurring_pass",
	      component: _recurringPassAnalytics2.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      name: "recurring-membership-analytics",
	      permission: "view_analytics,view_recurring_pass_analytics",
	      path: "event_buckets/:eventBucketId/analytics/recurring_membership",
	      component: _recurringPassAnalytics2.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      name: "ledger-analytics",
	      permission: "view_analytics",
	      path: "/analytics/ledger",
	      component: _ledgerAnalytics2.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      name: "ledger-box-office-report",
	      permission: "view_analytics",
	      path: "/analytics/box_office_report",
	      component: _ledgerBoxOfficeReport2.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      name: "box-office",
	      permission: "box_office",
	      path: "event_buckets/:eventBucketId/box_office",
	      component: _boxOffice2.default
	    }),
	    _react2.default.createElement(_reactRouter.Redirect, {
	      from: "event_buckets/:eventBucketId/box_office/passes",
	      to: "event_buckets/:eventBucketId/box_office"
	    }),
	    _react2.default.createElement(_reactRouter.Redirect, {
	      from: "event_buckets/:eventBucketId/box_office/tickets",
	      to: "event_buckets/:eventBucketId/box_office"
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      name: "new-film",
	      permission: "manage_films,edit_film",
	      path: "event_buckets/:eventBucketId/films/new",
	      component: _newFilm2.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      name: "film-editor",
	      permission: "manage_films,preview_virtual_screening,edit_film,view_film",
	      path: "event_buckets/:eventBucketId/films/:filmId/edit",
	      component: _filmEditor2.default
	    }),
	    _react2.default.createElement(_reactRouter.Redirect, {
	      from: "event_buckets/:eventBucketId/films/:filmId",
	      to: "/event_buckets/:eventBucketId/films/:filmId/edit"
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      name: "films",
	      permission: "manage_films,preview_virtual_screening,view_film_list",
	      path: "event_buckets/:eventBucketId/films",
	      component: _films2.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      name: "bulk-import-films",
	      permission: "bulk_import_films",
	      path: "event_buckets/:eventBucketId/bulk_import_films",
	      component: _bulkImportFilms2.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      name: "scheduler",
	      permission: "edit_physical_event",
	      path: "event_buckets/:eventBucketId/scheduler",
	      component: _scheduler2.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      name: "check-in",
	      permission: "box_office",
	      path: "event_buckets/:eventBucketId/check_in",
	      component: _checkIn2.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      name: "pass-bucket-check-in",
	      permission: "box_office",
	      path: "event_buckets/:eventBucketId/pass_buckets/check_in",
	      component: _checkIn2.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      name: "membership-check-in",
	      permission: "box_office",
	      path: "event_buckets/:eventBucketId/memberships/check_in",
	      component: _checkIn2.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      name: "new-event",
	      permission: "edit_physical_event,edit_virtual_event",
	      path: "event_buckets/:eventBucketId/events/new",
	      component: _newEvent2.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      name: "event-editor",
	      permission: "edit_physical_event,edit_virtual_event",
	      path: "event_buckets/:eventBucketId/events/:eventId/edit",
	      component: _eventEditor2.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      name: "event",
	      permission: "view_physical_event,view_virtual_event",
	      path: "event_buckets/:eventBucketId/events/:eventId(/:tab)",
	      component: _event2.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      name: "events",
	      permission: "view_physical_event_list",
	      path: "event_buckets/:eventBucketId/events",
	      component: _events2.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      name: "virtual-festival-event-editor",
	      permission: "manage_virtual_festival,edit_virtual_event",
	      path: "event_buckets/:eventBucketId/virtual_festival/events/:eventId/edit",
	      component: _eventEditor2.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      name: "virtual-festival-event",
	      permission: "manage_virtual_festival,preview_virtual_screening,view_virtual_event",
	      path: "event_buckets/:eventBucketId/virtual_festival/events/:eventId(/:tab)",
	      component: _event2.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      name: "virtual-festival",
	      permission: "manage_virtual_festival,edit_virtual_event",
	      path: "event_buckets/:eventBucketId/virtual_festival/live",
	      component: _virtualFestivalLivestreamingHub2.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      name: "virtual-festival",
	      permission: "manage_virtual_festival,edit_virtual_event",
	      path: "event_buckets/:eventBucketId/virtual_festival/live/:filmId",
	      component: _virtualFestivalLivestreamingHubFilm2.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      name: "virtual-festival",
	      permission: "manage_virtual_festival,view_virtual_event_list",
	      path: "event_buckets/:eventBucketId/virtual_festival",
	      component: _virtualFestival2.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      name: "virtual-festival-bulk-import-events",
	      permission: "manage_virtual_festival,bulk_import_events",
	      path: "event_buckets/:eventBucketId/virtual_festival/bulk_import_events",
	      component: _bulkImportEvents2.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      name: "new-pass-bucket",
	      permission: "edit_pass_bucket",
	      path: "event_buckets/:eventBucketId/pass_buckets/new",
	      component: _newPassBucket2.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      name: "pass-bucket",
	      permission: "view_pass_bucket",
	      path: "event_buckets/:eventBucketId/pass_buckets/:passBucketId",
	      component: _passBucket2.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      name: "pass-bucket-editor",
	      permission: "edit_pass_bucket,view_pass_bucket",
	      path: "event_buckets/:eventBucketId/pass_buckets/:passBucketId/edit(/:tab)",
	      component: _passBucketEditor2.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      name: "pass-label-printer",
	      permission: "print_pass_labels",
	      path: "event_buckets/:eventBucketId/pass_label_printer",
	      component: _passLabelPrinter2.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      name: "bulk-import-passes",
	      permission: "bulk_import_passes",
	      path: "event_buckets/:eventBucketId/bulk_import_passes",
	      component: _bulkImportPasses2.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      name: "pass-buckets",
	      permission: "view_pass_bucket_list",
	      path: "event_buckets/:eventBucketId/pass_buckets",
	      component: _passBuckets2.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      name: "memberships",
	      permission: "view_pass_bucket_list",
	      path: "event_buckets/:eventBucketId/memberships",
	      component: _passBuckets2.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      name: "new-membership",
	      permission: "edit_pass_bucket",
	      path: "event_buckets/:eventBucketId/memberships/new",
	      component: _newPassBucket2.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      name: "membership",
	      permission: "view_pass_bucket",
	      path: "event_buckets/:eventBucketId/memberships/:passBucketId",
	      component: _passBucket2.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      name: "membership-editor",
	      permission: "edit_pass_bucket,view_pass_bucket",
	      path: "event_buckets/:eventBucketId/memberships/:passBucketId/edit(/:tab)",
	      component: _passBucketEditor2.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      name: "bulk-import-memberships",
	      permission: "bulk_import_passes",
	      path: "event_buckets/:eventBucketId/bulk_import_memberships",
	      component: _bulkImportPasses2.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      name: "membership-label-printer",
	      permission: "print_pass_labels",
	      path: "event_buckets/:eventBucketId/membership_label_printer",
	      component: _passLabelPrinter2.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      name: "pass-history",
	      permission: "view_pass_bucket",
	      path: "event_buckets/:eventBucketId/passes/:passId/history",
	      component: _passHistory2.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      name: "new-item-bucket",
	      permission: "edit_item_bucket",
	      path: "event_buckets/:eventBucketId/item_buckets/new",
	      component: _newItemBucket2.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      name: "item-bucket",
	      permission: "view_item_bucket",
	      path: "event_buckets/:eventBucketId/item_buckets/:itemBucketId",
	      component: _itemBucket2.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      name: "item-bucket-editor",
	      permission: "edit_item_bucket",
	      path: "event_buckets/:eventBucketId/item_buckets/:itemBucketId/edit",
	      component: _itemBucketEditor2.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      name: "item-buckets",
	      permission: "view_item_bucket_list",
	      path: "event_buckets/:eventBucketId/item_buckets",
	      component: _itemBuckets2.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      name: "new-coupon",
	      permission: "edit_coupon",
	      path: "event_buckets/:eventBucketId/coupons/new",
	      component: _newCoupon2.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      name: "coupon",
	      permission: "edit_coupon,view_coupon",
	      path: "event_buckets/:eventBucketId/coupons/:couponId",
	      component: _coupon2.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      name: "coupon-editor",
	      permission: "edit_coupon,view_coupon",
	      path: "event_buckets/:eventBucketId/coupons/:couponId/edit",
	      component: _couponEditor2.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      name: "coupons",
	      permission: "view_coupon_list",
	      path: "event_buckets/:eventBucketId/coupons",
	      component: _coupons2.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      name: "new-venue",
	      permission: "manage_venues",
	      path: "event_buckets/:eventBucketId/venues/new",
	      component: _newVenue2.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      name: "venue",
	      permission: "manage_venues",
	      path: "event_buckets/:eventBucketId/venues/:venueId",
	      component: _venue2.default
	    }),
	    _react2.default.createElement(
	      _reactRouter.Route,
	      {
	        name: "venue-editor",
	        permission: "manage_venues",
	        path: "event_buckets/:eventBucketId/venues/:venueId/edit",
	        component: _venueEditor2.default
	      },
	      _react2.default.createElement(_reactRouter.Route, {
	        name: "venue-seatmap-editor",
	        permission: "manage_venues",
	        path: "/event_buckets/:eventBucketId/venues/:venueId/edit/seatmap",
	        component: _venueSeatmapEditor2.default
	      })
	    ),
	    _react2.default.createElement(_reactRouter.Route, {
	      name: "venues",
	      permission: "manage_venues",
	      path: "event_buckets/:eventBucketId/venues",
	      component: _venues2.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      name: "new-tag",
	      permission: "manage_tags",
	      path: "event_buckets/:eventBucketId/tags/new",
	      component: _newTag2.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      name: "tag-editor",
	      permission: "manage_tags",
	      path: "event_buckets/:eventBucketId/tags/:tagId/edit",
	      component: _tagEditor2.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      name: "tag",
	      permission: "manage_tags",
	      path: "event_buckets/:eventBucketId/tags/:tagId",
	      component: _tag2.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      name: "tags",
	      permission: "manage_tags",
	      path: "event_buckets/:eventBucketId/tags",
	      component: _tags2.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      name: "new-kiosk",
	      permission: "manage_kiosks",
	      path: "event_buckets/:eventBucketId/kiosks/new",
	      component: _newKiosk2.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      name: "kiosk",
	      permission: "manage_kiosks",
	      path: "event_buckets/:eventBucketId/kiosks/:kioskId",
	      component: _kiosk2.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      name: "kiosks",
	      permission: "manage_kiosks",
	      path: "event_buckets/:eventBucketId/kiosks",
	      component: _kiosks2.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      name: "new-mailing",
	      permission: "manage_mailings",
	      path: "event_buckets/:eventBucketId/mailings/new",
	      component: _newMailing2.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      name: "mailing",
	      permission: "manage_mailings",
	      path: "event_buckets/:eventBucketId/mailings/:mailingId",
	      component: _mailing2.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      name: "mailing-preview",
	      permission: "manage_mailings",
	      path: "event_buckets/:eventBucketId/mailings/:mailingId/preview",
	      component: _mailingPreview2.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      name: "mailings",
	      permission: "manage_mailings",
	      path: "event_buckets/:eventBucketId/mailings",
	      component: _mailings2.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      name: "new-external-sync",
	      permission: "manage_external_syncs",
	      path: "event_buckets/:eventBucketId/external_syncs/new",
	      component: _newExternalSync2.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      name: "external-sync",
	      permission: "manage_external_syncs",
	      path: "event_buckets/:eventBucketId/external_syncs/:externalSyncId",
	      component: _externalSync2.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      name: "external-syncs",
	      permission: "manage_external_syncs",
	      path: "event_buckets/:eventBucketId/external_syncs",
	      component: _externalSyncs2.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      name: "event-bucket-people",
	      permission: "manage_people,view_people",
	      path: "event_buckets/:eventBucketId/people",
	      component: _people2.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      name: "people",
	      permission: "manage_people,view_people",
	      path: "people",
	      component: _people2.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      name: "person",
	      permission: "manage_people,view_people",
	      path: "people/:personId",
	      component: _person2.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      name: "event-bucket-person",
	      permission: "manage_people,view_people",
	      path: "event_buckets/:eventBucketId/people/:personId",
	      component: _person2.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      name: "bulk-import-people",
	      permission: "bulk_import_people",
	      path: "/bulk_import_people",
	      component: _bulkImportPeople2.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      name: "event-bucket-orders",
	      permission: "manage_orders,view_orders",
	      path: "event_buckets/:eventBucketId/orders",
	      component: _orders2.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      name: "orders",
	      permission: "manage_orders,view_orders",
	      path: "orders",
	      component: _orders2.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      name: "order",
	      permission: "manage_orders,view_orders,view_order",
	      path: "orders/:orderId",
	      component: _order2.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      name: "event-bucket-order",
	      permission: "manage_orders,view_orders,view_order",
	      path: "event_buckets/:eventBucketId/orders/:orderId",
	      component: _order2.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      name: "gift-cards",
	      permission: "manage_gift_cards",
	      path: "gift_cards",
	      component: _giftCards2.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      name: "reports",
	      permission: "view_analytics",
	      path: "reports",
	      component: _reports2.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      name: "scheduled-reports",
	      permission: "view_analytics",
	      path: "scheduled_reports",
	      component: _reportScheduler2.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      name: "cross-event-bucket-reports",
	      permission: "view_analytics",
	      path: "reports/cross_event_bucket",
	      component: _crossEventBucketReports2.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      name: "audit-log",
	      permission: "manage_organization",
	      path: "/audit_log",
	      component: _auditLog2.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      name: "god-users",
	      permission: "god",
	      path: "/god",
	      component: _godUsers2.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      name: "god-auto-create",
	      permission: "god",
	      path: "/god/auto_create",
	      component: _godAutoCreateUserModal2.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      name: "god-orders",
	      permission: "god",
	      path: "/god_orders",
	      component: _orders2.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      name: "god-streams",
	      permission: "god",
	      path: "/god/streams",
	      component: _godStreams2.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      name: "god-lookup",
	      permission: "god",
	      path: "/god/lookup",
	      component: _godLookup2.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      name: "god-invoicing-hub",
	      permission: "god",
	      path: "/god/invoicing_hub",
	      component: _godInvoicingHub2.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      name: "god-revenue",
	      permission: "god",
	      path: "/god/revenue",
	      component: _godRevenue2.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      name: "god-upcoming-events",
	      permission: "god",
	      path: "/god/upcoming_events",
	      component: _godUpcomingEvents2.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      name: "god-orgnaization-health",
	      permission: "god",
	      path: "/organization_health",
	      component: _godOrganizationHealth2.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, { name: "ticket", path: "tickets/:ticketId", component: _ticket2.default }),
	    _react2.default.createElement(_reactRouter.Route, {
	      name: "event-bucket-ticket",
	      path: "event_buckets/:eventBucketId/tickets/:ticketId",
	      component: _ticket2.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      name: "ticket-history",
	      permission: "view_pass_bucket",
	      path: "event_buckets/:eventBucketId/tickets/:ticketId/history",
	      component: _ticketHistory2.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, { name: "pass", path: "passes/:passId", component: _pass2.default }),
	    _react2.default.createElement(_reactRouter.Route, {
	      name: "event-bucket-pass",
	      path: "event_buckets/:eventBucketId/passes/:passId",
	      component: _pass2.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, { name: "check-pass", path: "check_pass", component: _checkPass2.default }),
	    _react2.default.createElement(_reactRouter.Route, { name: "blank", path: "blank", component: function component() {
	        return _react2.default.createElement("div", null);
	      } }),
	    _react2.default.createElement(_reactRouter.Redirect, { from: "*", to: "/welcome" })
	  )
	);
	
	exports.default = AppRoutes;
	module.exports = exports["default"];

/***/ }),
/* 564 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactMixin = __webpack_require__(565);
	
	var _reactMixin2 = _interopRequireDefault(_reactMixin);
	
	var _reactGa = __webpack_require__(567);
	
	var _reactGa2 = _interopRequireDefault(_reactGa);
	
	var _reactIntercom = __webpack_require__(571);
	
	var _reactIntercom2 = _interopRequireDefault(_reactIntercom);
	
	var _reactRouter = __webpack_require__(486);
	
	var _materialUi = __webpack_require__(576);
	
	var _withWidth = __webpack_require__(886);
	
	var _withWidth2 = _interopRequireDefault(_withWidth);
	
	var _styles = __webpack_require__(917);
	
	var _MuiThemeProvider = __webpack_require__(730);
	
	var _MuiThemeProvider2 = _interopRequireDefault(_MuiThemeProvider);
	
	var _getMuiTheme = __webpack_require__(731);
	
	var _getMuiTheme2 = _interopRequireDefault(_getMuiTheme);
	
	var _assign = __webpack_require__(920);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _isEqual = __webpack_require__(924);
	
	var _isEqual2 = _interopRequireDefault(_isEqual);
	
	var _error = __webpack_require__(948);
	
	var _error2 = _interopRequireDefault(_error);
	
	var _fullWidthSection = __webpack_require__(949);
	
	var _fullWidthSection2 = _interopRequireDefault(_fullWidthSection);
	
	var _accountAppBarItem = __webpack_require__(950);
	
	var _accountAppBarItem2 = _interopRequireDefault(_accountAppBarItem);
	
	var _globalSearch = __webpack_require__(1228);
	
	var _globalSearch2 = _interopRequireDefault(_globalSearch);
	
	var _connectToStores = __webpack_require__(1226);
	
	var _connectToStores2 = _interopRequireDefault(_connectToStores);
	
	var _UserStore = __webpack_require__(974);
	
	var _UserStore2 = _interopRequireDefault(_UserStore);
	
	var _EventBucketStore = __webpack_require__(1593);
	
	var _EventBucketStore2 = _interopRequireDefault(_EventBucketStore);
	
	var _GlobalNotificationStore = __webpack_require__(1596);
	
	var _GlobalNotificationStore2 = _interopRequireDefault(_GlobalNotificationStore);
	
	var _GlobalNotificationActions = __webpack_require__(1182);
	
	var _GlobalNotificationActions2 = _interopRequireDefault(_GlobalNotificationActions);
	
	var _app = __webpack_require__(1597);
	
	var _app2 = _interopRequireDefault(_app);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var muiTheme = (0, _getMuiTheme2.default)({
	  fontFamily: '"Inter", sans-serif',
	  palette: {
	    primary1Color: _styles.colors.lightBlue700,
	    primary2Color: _styles.colors.grey500,
	    primary3Color: _styles.colors.lightBlue100,
	    accent1Color: _styles.colors.lightBlue500,
	    accent2Color: _styles.colors.grey300,
	    accent3Color: _styles.colors.grey100,
	    textColor: _styles.colors.grey900,
	    canvasColor: _styles.colors.white,
	    borderColor: _styles.colors.grey300,
	    disabledColor: _styles.colors.grey500
	  },
	  flatButton: {
	    color: _styles.colors.white,
	    fontWeight: 600
	  },
	  button: {
	    minWidth: 5,
	    fontWeight: 600
	  },
	  raisedButton: {
	    fontWeight: 600
	  }
	});
	
	var App = function (_React$Component) {
	  _inherits(App, _React$Component);
	
	  function App() {
	    _classCallCheck(this, App);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(App).call(this));
	
	    _this.state = {
	      hasNewVersion: false
	    };
	
	    _this.checkVersion = _this.checkVersion.bind(_this);
	
	    _this._onLeftIconButtonTouchTap = _this._onLeftIconButtonTouchTap.bind(_this);
	    _this.welcome = _this.welcome.bind(_this);
	    return _this;
	  }
	
	  _createClass(App, [{
	    key: "getChildContext",
	    value: function getChildContext() {
	      return {
	        router: this.context.router,
	        isLarge: this.props.width === _withWidth.LARGE,
	        isMedium: this.props.width === _withWidth.MEDIUM,
	        isSmall: this.props.width === _withWidth.SMALL
	      };
	    }
	  }, {
	    key: "_updateHeap",
	    value: function _updateHeap(userData) {
	      var newData = {
	        email: userData.email,
	        name: userData.name,
	        created_at: userData.created_at,
	        company_id: userData.owner.id,
	        company_name: userData.owner.organization
	      };
	
	      // Don't push if no data changed
	      if ((0, _isEqual2.default)(this.lastHeap, newData)) {
	        return;
	      }
	
	      this.lastHeap = newData;
	
	      window.heap.identify(userData.id);
	      window.heap.addUserProperties(newData);
	    }
	  }, {
	    key: "componentWillMount",
	    value: function componentWillMount() {
	      // Handle redirecting based on login status
	      var isRootOrLogin = ["/", "/login"].indexOf(this.props.location.pathname) !== -1,
	          isUnauthenticatedRoute = ["/forgot", "/reset", "/activate", "/accept_creator_invite", "/accept_revenue_sharing_invite", "/sso"].indexOf(this.props.location.pathname) !== -1;
	
	      if (this.props.location.pathname === "/login" && this.props.location.query.feedback) {
	        // fall through - canny login
	      } else if (this.props.isLoggedIn) {
	        if (isRootOrLogin) {
	          this.context.router.replace("/welcome");
	        } else {
	          // fall through - continue to their request page
	        }
	      } else {
	        if (!isUnauthenticatedRoute) {
	          this.context.router.replace({
	            pathname: "/login",
	            query: isRootOrLogin ? {} : { next: this.props.location.pathname }
	          });
	        } else {
	          // fall through - allow to forgot/reset flow
	        }
	      }
	
	      if (true) {
	        _reactGa2.default.initialize(("G-E63L6V2Y38"));
	        _reactGa2.default.send("pageview");
	
	        this.unlisten = this.context.router.listen(function () {
	          _reactGa2.default.send("pageview");
	        });
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      if (!this.unlisten) return;
	
	      this.unlisten();
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(props) {
	      if (props.isLoggedIn && window.heap) {
	        this._updateHeap(props.userData);
	      }
	    }
	  }, {
	    key: "checkVersion",
	    value: function checkVersion() {
	      var _this2 = this;
	
	      _app2.default.checkIfLatestVersion().then(function (isLatest) {
	        if (!isLatest) {
	          _this2.setState({ hasNewVersion: true });
	        }
	      });
	    }
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      // Check for new version every 5 minutes.
	      this.versionCheckInterval = setInterval(this.checkVersion, 1000 * 60 * 5);
	      this.checkVersion();
	
	      // Initialize changelog inject
	      if (window.Canny) {
	        window.Canny("initChangelog", {
	          appID: "5ca03fa696cc92037d9ac47e",
	          position: "bottom",
	          align: "left"
	        });
	      }
	    }
	  }, {
	    key: "getStyles",
	    value: function getStyles() {
	      return {
	        canvas: {
	          height: "100%",
	          backgroundColor: muiTheme.palette.canvasColor,
	          WebkitFontSmoothing: "antialiased",
	          display: "flex",
	          minHeight: "100vh",
	          flexDirection: "column"
	        },
	        bar: {
	          position: "fixed",
	          flex: "none"
	          //textAlign: 'center'
	        },
	        footer: {
	          backgroundColor: _styles.colors.grey900,
	          textAlign: "center",
	          color: _styles.colors.white,
	          flex: "none",
	          zIndex: 1
	        },
	        img: {
	          height: "80px"
	        },
	        content: {
	          flex: "1 0 auto",
	          padding: _styles.spacing.desktopKeylineIncrement + "px 0 0",
	          margin: "0 auto",
	          width: "100%"
	        },
	        contentWhenMedium: {
	          padding: "64px 20px",
	          boxSizing: "border-box"
	        },
	        footerWhenMedium: {
	          marginLeft: 256
	        },
	        notice: muiTheme.prepareStyles({
	          borderRadius: 10,
	          padding: "0.5em 1em",
	          marginTop: 32,
	          marginLeft: 20,
	          marginRight: 20,
	          marginBottom: -12,
	          border: "1px solid #ffeb3b",
	          backgroundColor: "#fff8bd",
	          display: "flex",
	          alignItems: "center"
	        }),
	        noticeWhenMedium: {
	          marginLeft: 256 + 20
	        },
	        noticeIcon: {
	          minWidth: 20,
	          height: 20,
	          verticalAlign: "-5px",
	          marginRight: "1em",
	          color: "#f9a825"
	        },
	        footerLink: {
	          textDecoration: "none",
	          color: _styles.colors.white
	        },
	        eventiveLogo: {
	          width: 75,
	          marginLeft: 2
	        }
	      };
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var styles = this.getStyles(),
	          isSmall = this.props.width === _withWidth.SMALL,
	          title = _react2.default.createElement(
	        "span",
	        { className: "eventive-title" + (isSmall ? "-small" : "") },
	        _react2.default.createElement(
	          "span",
	          { style: { cursor: "pointer" }, onTouchTap: this.welcome },
	          isSmall ? _react2.default.createElement("img", {
	            src: "https://storage.googleapis.com/eventive-co/EventiveMark.png",
	            style: { width: 24, height: 29, verticalAlign: "text-top" }
	          }) : "Eventive Dashboard"
	        ),
	        !isSmall ? _react2.default.createElement(
	          "span",
	          {
	            "data-canny-changelog": true,
	            style: {
	              fontSize: 12,
	              marginLeft: 10,
	              cursor: "pointer",
	              verticalAlign: "middle",
	              padding: "2px 8px",
	              borderRadius: 5,
	              border: "1px solid " + _styles.colors.lightBlue500,
	              backgroundColor: _styles.colors.lightBlue600,
	              fontWeight: "bold"
	            }
	          },
	          "What's new",
	          _react2.default.createElement(
	            "svg",
	            {
	              xmlns: "http://www.w3.org/2000/svg",
	              viewBox: "0 0 20 20",
	              fill: "currentColor",
	              style: {
	                width: 14,
	                height: 14,
	                verticalAlign: -3,
	                marginLeft: 2,
	                marginRight: -5
	              }
	            },
	            _react2.default.createElement("path", {
	              fillRule: "evenodd",
	              d: "M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z",
	              clipRule: "evenodd"
	            })
	          ),
	          _react2.default.createElement(
	            "style",
	            null,
	            "\n                #canny-changelog-iframe { position: fixed !important; }\n                .Canny_BadgeContainer { top: -4px !important; right: -4px !important; }\n              "
	          )
	        ) : null
	      );
	
	      // Intercom data
	      var _props = this.props;
	      var userData = _props.userData;
	      var eventBuckets = _props.eventBuckets;
	      var intercomData = userData && {
	        email: userData.email,
	        name: userData.name,
	        user_id: userData.id,
	        user_hash: userData.hash,
	        created_at: userData.created_at,
	        eventive_role: userData.role,
	        company: {
	          id: userData.owner.id,
	          name: userData.owner.organization,
	          type: userData.owner.type,
	          eventive_organization_id: userData.owner.id
	        }
	      };
	      if (intercomData && !_UserStore2.default.isGod()) {
	        Object.assign(intercomData.company, {
	          event_buckets: eventBuckets.length,
	          events: eventBuckets.map(function (b) {
	            return b.events.length;
	          }).reduce(function (a, b) {
	            return a + b;
	          }, 0),
	          pass_buckets: eventBuckets.map(function (b) {
	            return b.pass_buckets.length;
	          }).reduce(function (a, b) {
	            return a + b;
	          }, 0),
	          coupons: eventBuckets.map(function (b) {
	            return b.coupons.length;
	          }).reduce(function (a, b) {
	            return a + b;
	          }, 0),
	          venues: eventBuckets.map(function (b) {
	            return b.venues.length;
	          }).reduce(function (a, b) {
	            return a + b;
	          }, 0)
	        });
	      }
	
	      var notice = void 0,
	          noticeIcon = void 0,
	          isDashboard = this.props.routes.some(function (r) {
	        return r.name === "dashboard";
	      }),
	          user = _UserStore2.default.getUser();
	
	      if (user && user.virtual_festival_plan_status === "active" && user.virtual_festival_plan_payment_due_at) {
	        var isBillingHub = this.context.router.isActive({
	          pathname: "/billing"
	        });
	        noticeIcon = _react2.default.createElement(_error2.default, { style: styles.noticeIcon });
	        notice = _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement(
	            "strong",
	            null,
	            "Renewal notice"
	          ),
	          ": Your Eventive Virtual annual subscription payment is due. Please",
	          " ",
	          isBillingHub ? "renew your subscription below" : _react2.default.createElement(
	            _reactRouter.Link,
	            { to: "/billing" },
	            "renew your subscription"
	          ),
	          " ",
	          "to avoid losing access to Eventive Virtual."
	        );
	      } else if (user && user.needs_stripe && user.type !== "content_creator" && isDashboard) {
	        var isOrganization = this.context.router.isActive({
	          pathname: "/organization"
	        });
	        noticeIcon = _react2.default.createElement(_error2.default, { style: styles.noticeIcon });
	        notice = _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement(
	            "strong",
	            null,
	            "Unable to accept payments"
	          ),
	          ": Until you",
	          " ",
	          isOrganization ? "connect a bank account below" : _react2.default.createElement(
	            _reactRouter.Link,
	            { to: "/organization" },
	            "connect a bank account"
	          ),
	          " ",
	          "via Stripe, ",
	          user.organization,
	          " will not be able to accept credit card payments.",
	          " ",
	          _react2.default.createElement(
	            "a",
	            {
	              target: "_blank",
	              href: "https://help.eventive.org/getting-started/connect-your-bank-account"
	            },
	            "Need\xA0help?"
	          )
	        );
	      }
	
	      return _react2.default.createElement(
	        _MuiThemeProvider2.default,
	        { muiTheme: muiTheme },
	        _react2.default.createElement(
	          "div",
	          { style: (0, _assign2.default)({}, styles.canvas) },
	          _react2.default.createElement(_materialUi.Snackbar, {
	            message: "A new version of the Eventive Dashboard is available.",
	            action: "update",
	            open: this.state.hasNewVersion,
	            style: { left: 20, bottom: 20, right: "initial" },
	            onActionTouchTap: function onActionTouchTap() {
	              return window.location.reload(true);
	            },
	            onRequestClose: function onRequestClose() {}
	          }),
	          _react2.default.createElement(_materialUi.Snackbar, {
	            autoHideDuration: 5000,
	            message: this.props.globalNotification.message,
	            open: this.props.globalNotification.open,
	            bodyStyle: {
	              height: "auto",
	              lineHeight: "24px",
	              padding: "12px 24px",
	              whiteSpace: "pre-line"
	            },
	            onRequestClose: function onRequestClose() {
	              return _GlobalNotificationActions2.default.close();
	            }
	          }),
	          _react2.default.createElement(
	            _materialUi.AppBar,
	            {
	              showMenuIconButton: false,
	              title: title,
	              iconStyleRight: { marginTop: 13 },
	              iconElementRight: _react2.default.createElement(_accountAppBarItem2.default, { compact: isSmall }),
	              style: (0, _assign2.default)({}, styles.bar),
	              zDepth: 2,
	              className: "no-print",
	              id: "eventive-app-bar"
	            },
	            user && user.type !== "content_creator" && !this.context.router.isActive({
	              pathname: "/god/lookup"
	            }) ? _react2.default.createElement(_globalSearch2.default, { compact: isSmall }) : null
	          ),
	          _react2.default.createElement(
	            "div",
	            {
	              style: (0, _assign2.default)({}, styles.content, styles.contentWhenMedium),
	              className: "print-reset-main"
	            },
	            notice && _react2.default.createElement(
	              "div",
	              {
	                style: (0, _assign2.default)({}, styles.notice, !isSmall && styles.noticeWhenMedium)
	              },
	              noticeIcon,
	              notice
	            ),
	            this.props.children
	          ),
	          _react2.default.createElement(
	            _fullWidthSection2.default,
	            {
	              className: "no-print",
	              style: (0, _assign2.default)({ transition: "margin 0.2s ease-in-out" }, styles.footer, !isSmall && this.props.routes.some(function (r) {
	                return r.name === "dashboard";
	              }) && !window.__eventiveSidebarCollapsed && styles.footerWhenMedium)
	            },
	            _react2.default.createElement(
	              "div",
	              null,
	              _react2.default.createElement(
	                "div",
	                null,
	                _react2.default.createElement(
	                  "a",
	                  { style: styles.footerLink, href: "https://eventive.org" },
	                  "Powered by",
	                  " ",
	                  _react2.default.createElement("img", { style: styles.eventiveLogo, src: "/img/eventive.png" })
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                null,
	                _react2.default.createElement(
	                  "a",
	                  {
	                    style: styles.footerLink,
	                    href: "https://eventive.org/terms",
	                    target: "_blank"
	                  },
	                  "Terms"
	                ),
	                " ",
	                "\xB7",
	                " ",
	                _react2.default.createElement(
	                  "a",
	                  {
	                    style: styles.footerLink,
	                    href: "https://eventive.org/privacy",
	                    target: "_blank"
	                  },
	                  "Privacy"
	                ),
	                " ",
	                "\xB7",
	                " ",
	                _react2.default.createElement(
	                  "a",
	                  {
	                    style: styles.footerLink,
	                    href: "https://status.eventive.org/",
	                    target: "_blank"
	                  },
	                  "System Status"
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(_reactIntercom2.default, _extends({ appID: ("oj5vkp3b") }, intercomData))
	        )
	      );
	    }
	  }, {
	    key: "_onLeftIconButtonTouchTap",
	    value: function _onLeftIconButtonTouchTap() {
	      this.refs.leftNav.toggle();
	    }
	  }, {
	    key: "welcome",
	    value: function welcome() {
	      this.context.router.push("/welcome");
	    }
	  }], [{
	    key: "getStores",
	    value: function getStores() {
	      return [_UserStore2.default, _EventBucketStore2.default, _GlobalNotificationStore2.default];
	    }
	  }, {
	    key: "getPropsFromStores",
	    value: function getPropsFromStores() {
	      var _UserStore$getState = _UserStore2.default.getState();
	
	      var isLoggedIn = _UserStore$getState.isLoggedIn;
	      var data = _UserStore$getState.data;
	
	
	      return {
	        isLoggedIn: isLoggedIn,
	        userData: data,
	        eventBuckets: _EventBucketStore2.default.getEventBuckets(),
	        globalNotification: _GlobalNotificationStore2.default.getState()
	      };
	    }
	  }]);
	
	  return App;
	}(_react2.default.Component);
	
	App.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	App.childContextTypes = {
	  router: _react2.default.PropTypes.object,
	  isLarge: _react2.default.PropTypes.bool,
	  isMedium: _react2.default.PropTypes.bool,
	  isSmall: _react2.default.PropTypes.bool
	};
	exports.default = (0, _withWidth2.default)()((0, _connectToStores2.default)(App));
	module.exports = exports["default"];

/***/ }),
/* 565 */
/***/ (function(module, exports, __webpack_require__) {

	var mixin = __webpack_require__(566);
	var assign = __webpack_require__(302);
	
	var mixinProto = mixin({
	  // lifecycle stuff is as you'd expect
	  componentDidMount: mixin.MANY,
	  componentWillMount: mixin.MANY,
	  componentWillReceiveProps: mixin.MANY,
	  shouldComponentUpdate: mixin.ONCE,
	  componentWillUpdate: mixin.MANY,
	  componentDidUpdate: mixin.MANY,
	  componentWillUnmount: mixin.MANY,
	  getChildContext: mixin.MANY_MERGED
	});
	
	function setDefaultProps(reactMixin) {
	  var getDefaultProps = reactMixin.getDefaultProps;
	
	  if (getDefaultProps) {
	    reactMixin.defaultProps = getDefaultProps();
	
	    delete reactMixin.getDefaultProps;
	  }
	}
	
	function setInitialState(reactMixin) {
	  var getInitialState = reactMixin.getInitialState;
	  var componentWillMount = reactMixin.componentWillMount;
	
	  function applyInitialState(instance) {
	    var state = instance.state || {};
	    assign(state, getInitialState.call(instance));
	    instance.state = state;
	  }
	
	  if (getInitialState) {
	    if (!componentWillMount) {
	      reactMixin.componentWillMount = function() {
	        applyInitialState(this);
	      };
	    } else {
	      reactMixin.componentWillMount = function() {
	        applyInitialState(this);
	        componentWillMount.call(this);
	      };
	    }
	
	    delete reactMixin.getInitialState;
	  }
	}
	
	function mixinClass(reactClass, reactMixin) {
	  setDefaultProps(reactMixin);
	  setInitialState(reactMixin);
	
	  var prototypeMethods = {};
	  var staticProps = {};
	
	  Object.keys(reactMixin).forEach(function(key) {
	    if (key === 'mixins') {
	      return; // Handled below to ensure proper order regardless of property iteration order
	    }
	    if (key === 'statics') {
	      return; // gets special handling
	    } else if (typeof reactMixin[key] === 'function') {
	      prototypeMethods[key] = reactMixin[key];
	    } else {
	      staticProps[key] = reactMixin[key];
	    }
	  });
	
	  mixinProto(reactClass.prototype, prototypeMethods);
	
	  var mergePropTypes = function(left, right, key) {
	    if (!left) return right;
	    if (!right) return left;
	
	    var result = {};
	    Object.keys(left).forEach(function(leftKey) {
	      if (!right[leftKey]) {
	        result[leftKey] = left[leftKey];
	      }
	    });
	
	    Object.keys(right).forEach(function(rightKey) {
	      if (left[rightKey]) {
	        result[rightKey] = function checkBothContextTypes() {
	          return right[rightKey].apply(this, arguments) && left[rightKey].apply(this, arguments);
	        };
	      } else {
	        result[rightKey] = right[rightKey];
	      }
	    });
	
	    return result;
	  };
	
	  mixin({
	    childContextTypes: mergePropTypes,
	    contextTypes: mergePropTypes,
	    propTypes: mixin.MANY_MERGED_LOOSE,
	    defaultProps: mixin.MANY_MERGED_LOOSE
	  })(reactClass, staticProps);
	
	  // statics is a special case because it merges directly onto the class
	  if (reactMixin.statics) {
	    Object.getOwnPropertyNames(reactMixin.statics).forEach(function(key) {
	      var left = reactClass[key];
	      var right = reactMixin.statics[key];
	
	      if (left !== undefined && right !== undefined) {
	        throw new TypeError('Cannot mixin statics because statics.' + key + ' and Component.' + key + ' are defined.');
	      }
	
	      reactClass[key] = left !== undefined ? left : right;
	    });
	  }
	
	  // If more mixins are defined, they need to run. This emulate's react's behavior.
	  // See behavior in code at:
	  // https://github.com/facebook/react/blob/41aa3496aa632634f650edbe10d617799922d265/src/isomorphic/classic/class/ReactClass.js#L468
	  // Note the .reverse(). In React, a fresh constructor is created, then all mixins are mixed in recursively,
	  // then the actual spec is mixed in last.
	  //
	  // With ES6 classes, the properties are already there, so smart-mixin mixes functions (a, b) -> b()a(), which is
	  // the opposite of how React does it. If we reverse this array, we basically do the whole logic in reverse,
	  // which makes the result the same. See the test for more.
	  // See also:
	  // https://github.com/facebook/react/blob/41aa3496aa632634f650edbe10d617799922d265/src/isomorphic/classic/class/ReactClass.js#L853
	  if (reactMixin.mixins) {
	    reactMixin.mixins.reverse().forEach(mixinClass.bind(null, reactClass));
	  }
	
	  return reactClass;
	}
	
	module.exports = (function() {
	  var reactMixin = mixinProto;
	
	  reactMixin.onClass = function(reactClass, mixin) {
	    // we mutate the mixin so let's clone it
	    mixin = assign({}, mixin);
	    return mixinClass(reactClass, mixin);
	  };
	
	  reactMixin.decorate = function(mixin) {
	    return function(reactClass) {
	      return reactMixin.onClass(reactClass, mixin);
	    };
	  };
	
	  return reactMixin;
	})();


/***/ }),
/* 566 */
/***/ (function(module, exports) {

	function objToStr(x){ return Object.prototype.toString.call(x); };
	
	function returner(x) { return x; }
	
	function wrapIfFunction(thing){
	    return typeof thing !== "function" ? thing
	    : function(){
	        return thing.apply(this, arguments);
	    };
	}
	
	function setNonEnumerable(target, key, value){
	    if (key in target){
	        target[key] = value;
	    }
	    else {
	        Object.defineProperty(target, key, {
	            value: value,
	            writable: true,
	            configurable: true
	        });
	    }
	}
	
	function defaultNonFunctionProperty(left, right, key){
	    if (left !== undefined && right !== undefined) {
	        var getTypeName = function(obj){
	            if (obj && obj.constructor && obj.constructor.name) {
	                return obj.constructor.name;
	            }
	            else {
	                return objToStr(obj).slice(8, -1);
	            }
	        };
	        throw new TypeError('Cannot mixin key ' + key + ' because it is provided by multiple sources, '
	                + 'and the types are ' + getTypeName(left) + ' and ' + getTypeName(right));
	    }
	    return left === undefined ? right : left;
	};
	
	function assertObject(obj, obj2){
	    var type = objToStr(obj);
	    if (type !== '[object Object]') {
	        var displayType = obj.constructor ? obj.constructor.name : 'Unknown';
	        var displayType2 = obj2.constructor ? obj2.constructor.name : 'Unknown';
	        throw new Error('cannot merge returned value of type ' + displayType + ' with an ' + displayType2);
	    }
	};
	
	
	var mixins = module.exports = function makeMixinFunction(rules, _opts){
	    var opts = _opts || {};
	
	    if (!opts.unknownFunction) {
	        opts.unknownFunction = mixins.ONCE;
	    }
	
	    if (!opts.nonFunctionProperty) {
	        opts.nonFunctionProperty = defaultNonFunctionProperty;
	    }
	
	    return function applyMixin(source, mixin){
	        Object.keys(mixin).forEach(function(key){
	            var left = source[key], right = mixin[key], rule = rules[key];
	
	            // this is just a weird case where the key was defined, but there's no value
	            // behave like the key wasn't defined
	            if (left === undefined && right === undefined) return;
	
	            // do we have a rule for this key?
	            if (rule) {
	                // may throw here
	                var fn = rule(left, right, key);
	                setNonEnumerable(source, key, wrapIfFunction(fn));
	                return;
	            }
	
	            var leftIsFn = typeof left === "function";
	            var rightIsFn = typeof right === "function";
	
	            // check to see if they're some combination of functions or undefined
	            // we already know there's no rule, so use the unknown function behavior
	            if (leftIsFn && right === undefined
	             || rightIsFn && left === undefined
	             || leftIsFn && rightIsFn) {
	                // may throw, the default is ONCE so if both are functions
	                // the default is to throw
	                setNonEnumerable(source, key, wrapIfFunction(opts.unknownFunction(left, right, key)));
	                return;
	            }
	
	            // we have no rule for them, one may be a function but one or both aren't
	            // our default is MANY_MERGED_LOOSE which will merge objects, concat arrays
	            // and throw if there's a type mismatch or both are primitives (how do you merge 3, and "foo"?)
	            source[key] = opts.nonFunctionProperty(left, right, key);
	        });
	    };
	};
	
	mixins._mergeObjects = function(obj1, obj2) {
	    if (Array.isArray(obj1) && Array.isArray(obj2)) {
	        return obj1.concat(obj2);
	    }
	
	    assertObject(obj1, obj2);
	    assertObject(obj2, obj1);
	
	    var result = {};
	    Object.keys(obj1).forEach(function(k){
	        if (Object.prototype.hasOwnProperty.call(obj2, k)) {
	            throw new Error('cannot merge returns because both have the ' + JSON.stringify(k) + ' key');
	        }
	        result[k] = obj1[k];
	    });
	
	    Object.keys(obj2).forEach(function(k){
	        // we can skip the conflict check because all conflicts would already be found
	        result[k] = obj2[k];
	    });
	    return result;
	};
	
	// define our built-in mixin types
	mixins.ONCE = function(left, right, key){
	    if (left && right) {
	        throw new TypeError('Cannot mixin ' + key + ' because it has a unique constraint.');
	    }
	    return left || right;
	};
	
	mixins.MANY = function(left, right, key){
	    return function(){
	        if (right) right.apply(this, arguments);
	        return left ? left.apply(this, arguments) : undefined;
	    };
	};
	
	mixins.MANY_MERGED_LOOSE = function(left, right, key) {
	    if (left && right) {
	        return mixins._mergeObjects(left, right);
	    }
	    return left || right;
	};
	
	mixins.MANY_MERGED = function(left, right, key){
	    return function(){
	        var res1 = right && right.apply(this, arguments);
	        var res2 = left && left.apply(this, arguments);
	        if (res1 && res2) {
	            return mixins._mergeObjects(res1, res2)
	        }
	        return res2 || res1;
	    };
	};
	
	mixins.REDUCE_LEFT = function(_left, _right, key){
	    var left = _left || returner;
	    var right = _right || returner;
	    return function(){
	        return right.call(this, left.apply(this, arguments));
	    };
	};
	
	mixins.REDUCE_RIGHT = function(_left, _right, key){
	    var left = _left || returner;
	    var right = _right || returner;
	    return function(){
	        return left.call(this, right.apply(this, arguments));
	    };
	};
	


/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = exports.ReactGAImplementation = void 0;
	var _ga = _interopRequireWildcard(__webpack_require__(568));
	function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
	function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	var ReactGAImplementation = _ga.GA4;
	exports.ReactGAImplementation = ReactGAImplementation;
	var _default = _ga["default"];
	exports["default"] = _default;

/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = exports.GA4 = void 0;
	var _gtag = _interopRequireDefault(__webpack_require__(569));
	var _format = _interopRequireDefault(__webpack_require__(570));
	var _excluded = ["eventCategory", "eventAction", "eventLabel", "eventValue", "hitType"],
	  _excluded2 = ["title", "location"],
	  _excluded3 = ["page", "hitType"];
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
	function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
	function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
	function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
	function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
	function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
	function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
	function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
	function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
	function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
	function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
	function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
	function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
	/*
	Links
	https://developers.google.com/gtagjs/reference/api
	https://developers.google.com/tag-platform/gtagjs/reference
	*/
	/**
	 * @typedef GaOptions
	 * @type {Object}
	 * @property {boolean} [cookieUpdate=true]
	 * @property {number} [cookieExpires=63072000] Default two years
	 * @property {string} [cookieDomain="auto"]
	 * @property {string} [cookieFlags]
	 * @property {string} [userId]
	 * @property {string} [clientId]
	 * @property {boolean} [anonymizeIp]
	 * @property {string} [contentGroup1]
	 * @property {string} [contentGroup2]
	 * @property {string} [contentGroup3]
	 * @property {string} [contentGroup4]
	 * @property {string} [contentGroup5]
	 * @property {boolean} [allowAdFeatures=true]
	 * @property {boolean} [allowAdPersonalizationSignals]
	 * @property {boolean} [nonInteraction]
	 * @property {string} [page]
	 */
	/**
	 * @typedef UaEventOptions
	 * @type {Object}
	 * @property {string} action
	 * @property {string} category
	 * @property {string} [label]
	 * @property {number} [value]
	 * @property {boolean} [nonInteraction]
	 * @property {('beacon'|'xhr'|'image')} [transport]
	 */
	/**
	 * @typedef InitOptions
	 * @type {Object}
	 * @property {string} trackingId
	 * @property {GaOptions|any} [gaOptions]
	 * @property {Object} [gtagOptions] New parameter
	 */
	var GA4 = /*#__PURE__*/function () {
	  function GA4() {
	    var _this = this;
	    _classCallCheck(this, GA4);
	    _defineProperty(this, "reset", function () {
	      _this.isInitialized = false;
	      _this._testMode = false;
	      _this._currentMeasurementId;
	      _this._hasLoadedGA = false;
	      _this._isQueuing = false;
	      _this._queueGtag = [];
	    });
	    _defineProperty(this, "_gtag", function () {
	      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	      if (!_this._testMode) {
	        if (_this._isQueuing) {
	          _this._queueGtag.push(args);
	        } else {
	          _gtag["default"].apply(void 0, args);
	        }
	      } else {
	        _this._queueGtag.push(args);
	      }
	    });
	    _defineProperty(this, "_loadGA", function (GA_MEASUREMENT_ID, nonce) {
	      var gtagUrl = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "https://www.googletagmanager.com/gtag/js";
	      if (typeof window === "undefined" || typeof document === "undefined") {
	        return;
	      }
	      if (!_this._hasLoadedGA) {
	        // Global Site Tag (gtag.js) - Google Analytics
	        var script = document.createElement("script");
	        script.async = true;
	        script.src = "".concat(gtagUrl, "?id=").concat(GA_MEASUREMENT_ID);
	        if (nonce) {
	          script.setAttribute("nonce", nonce);
	        }
	        document.body.appendChild(script);
	        window.dataLayer = window.dataLayer || [];
	        window.gtag = function gtag() {
	          window.dataLayer.push(arguments);
	        };
	        _this._hasLoadedGA = true;
	      }
	    });
	    _defineProperty(this, "_toGtagOptions", function (gaOptions) {
	      if (!gaOptions) {
	        return;
	      }
	      var mapFields = {
	        // Old https://developers.google.com/analytics/devguides/collection/analyticsjs/field-reference#cookieUpdate
	        // New https://developers.google.com/analytics/devguides/collection/gtagjs/cookies-user-id#cookie_update
	        cookieUpdate: "cookie_update",
	        cookieExpires: "cookie_expires",
	        cookieDomain: "cookie_domain",
	        cookieFlags: "cookie_flags",
	        // must be in set method?
	        userId: "user_id",
	        clientId: "client_id",
	        anonymizeIp: "anonymize_ip",
	        // https://support.google.com/analytics/answer/2853546?hl=en#zippy=%2Cin-this-article
	        contentGroup1: "content_group1",
	        contentGroup2: "content_group2",
	        contentGroup3: "content_group3",
	        contentGroup4: "content_group4",
	        contentGroup5: "content_group5",
	        // https://support.google.com/analytics/answer/9050852?hl=en
	        allowAdFeatures: "allow_google_signals",
	        allowAdPersonalizationSignals: "allow_ad_personalization_signals",
	        nonInteraction: "non_interaction",
	        page: "page_path",
	        hitCallback: "event_callback"
	      };
	      var gtagOptions = Object.entries(gaOptions).reduce(function (prev, _ref) {
	        var _ref2 = _slicedToArray(_ref, 2),
	          key = _ref2[0],
	          value = _ref2[1];
	        if (mapFields[key]) {
	          prev[mapFields[key]] = value;
	        } else {
	          prev[key] = value;
	        }
	        return prev;
	      }, {});
	      return gtagOptions;
	    });
	    _defineProperty(this, "initialize", function (GA_MEASUREMENT_ID) {
	      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	      if (!GA_MEASUREMENT_ID) {
	        throw new Error("Require GA_MEASUREMENT_ID");
	      }
	      var initConfigs = typeof GA_MEASUREMENT_ID === "string" ? [{
	        trackingId: GA_MEASUREMENT_ID
	      }] : GA_MEASUREMENT_ID;
	      _this._currentMeasurementId = initConfigs[0].trackingId;
	      var gaOptions = options.gaOptions,
	        gtagOptions = options.gtagOptions,
	        nonce = options.nonce,
	        _options$testMode = options.testMode,
	        testMode = _options$testMode === void 0 ? false : _options$testMode,
	        gtagUrl = options.gtagUrl;
	      _this._testMode = testMode;
	      if (!testMode) {
	        _this._loadGA(_this._currentMeasurementId, nonce, gtagUrl);
	      }
	      if (!_this.isInitialized) {
	        _this._gtag("js", new Date());
	        initConfigs.forEach(function (config) {
	          var mergedGtagOptions = _objectSpread(_objectSpread(_objectSpread({}, _this._toGtagOptions(_objectSpread(_objectSpread({}, gaOptions), config.gaOptions))), gtagOptions), config.gtagOptions);
	          if (Object.keys(mergedGtagOptions).length) {
	            _this._gtag("config", config.trackingId, mergedGtagOptions);
	          } else {
	            _this._gtag("config", config.trackingId);
	          }
	        });
	      }
	      _this.isInitialized = true;
	      if (!testMode) {
	        var queues = _toConsumableArray(_this._queueGtag);
	        _this._queueGtag = [];
	        _this._isQueuing = false;
	        while (queues.length) {
	          var queue = queues.shift();
	          _this._gtag.apply(_this, _toConsumableArray(queue));
	          if (queue[0] === "get") {
	            _this._isQueuing = true;
	          }
	        }
	      }
	    });
	    _defineProperty(this, "set", function (fieldsObject) {
	      if (!fieldsObject) {
	        console.warn("`fieldsObject` is required in .set()");
	        return;
	      }
	      if (_typeof(fieldsObject) !== "object") {
	        console.warn("Expected `fieldsObject` arg to be an Object");
	        return;
	      }
	      if (Object.keys(fieldsObject).length === 0) {
	        console.warn("empty `fieldsObject` given to .set()");
	      }
	      _this._gaCommand("set", fieldsObject);
	    });
	    _defineProperty(this, "_gaCommandSendEvent", function (eventCategory, eventAction, eventLabel, eventValue, fieldsObject) {
	      _this._gtag("event", eventAction, _objectSpread(_objectSpread({
	        event_category: eventCategory,
	        event_label: eventLabel,
	        value: eventValue
	      }, fieldsObject && {
	        non_interaction: fieldsObject.nonInteraction
	      }), _this._toGtagOptions(fieldsObject)));
	    });
	    _defineProperty(this, "_gaCommandSendEventParameters", function () {
	      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	        args[_key2] = arguments[_key2];
	      }
	      if (typeof args[0] === "string") {
	        _this._gaCommandSendEvent.apply(_this, _toConsumableArray(args.slice(1)));
	      } else {
	        var _args$ = args[0],
	          eventCategory = _args$.eventCategory,
	          eventAction = _args$.eventAction,
	          eventLabel = _args$.eventLabel,
	          eventValue = _args$.eventValue,
	          hitType = _args$.hitType,
	          rest = _objectWithoutProperties(_args$, _excluded);
	        _this._gaCommandSendEvent(eventCategory, eventAction, eventLabel, eventValue, rest);
	      }
	    });
	    _defineProperty(this, "_gaCommandSendTiming", function (timingCategory, timingVar, timingValue, timingLabel) {
	      _this._gtag("event", "timing_complete", {
	        name: timingVar,
	        value: timingValue,
	        event_category: timingCategory,
	        event_label: timingLabel
	      });
	    });
	    _defineProperty(this, "_gaCommandSendPageview", function (page, fieldsObject) {
	      if (fieldsObject && Object.keys(fieldsObject).length) {
	        var _this$_toGtagOptions = _this._toGtagOptions(fieldsObject),
	          title = _this$_toGtagOptions.title,
	          location = _this$_toGtagOptions.location,
	          rest = _objectWithoutProperties(_this$_toGtagOptions, _excluded2);
	        _this._gtag("event", "page_view", _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, page && {
	          page_path: page
	        }), title && {
	          page_title: title
	        }), location && {
	          page_location: location
	        }), rest));
	      } else if (page) {
	        _this._gtag("event", "page_view", {
	          page_path: page
	        });
	      } else {
	        _this._gtag("event", "page_view");
	      }
	    });
	    _defineProperty(this, "_gaCommandSendPageviewParameters", function () {
	      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
	        args[_key3] = arguments[_key3];
	      }
	      if (typeof args[0] === "string") {
	        _this._gaCommandSendPageview.apply(_this, _toConsumableArray(args.slice(1)));
	      } else {
	        var _args$2 = args[0],
	          page = _args$2.page,
	          hitType = _args$2.hitType,
	          rest = _objectWithoutProperties(_args$2, _excluded3);
	        _this._gaCommandSendPageview(page, rest);
	      }
	    });
	    _defineProperty(this, "_gaCommandSend", function () {
	      for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
	        args[_key4] = arguments[_key4];
	      }
	      var hitType = typeof args[0] === "string" ? args[0] : args[0].hitType;
	      switch (hitType) {
	        case "event":
	          _this._gaCommandSendEventParameters.apply(_this, args);
	          break;
	        case "pageview":
	          _this._gaCommandSendPageviewParameters.apply(_this, args);
	          break;
	        case "timing":
	          _this._gaCommandSendTiming.apply(_this, _toConsumableArray(args.slice(1)));
	          break;
	        case "screenview":
	        case "transaction":
	        case "item":
	        case "social":
	        case "exception":
	          console.warn("Unsupported send command: ".concat(hitType));
	          break;
	        default:
	          console.warn("Send command doesn't exist: ".concat(hitType));
	      }
	    });
	    _defineProperty(this, "_gaCommandSet", function () {
	      for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
	        args[_key5] = arguments[_key5];
	      }
	      if (typeof args[0] === "string") {
	        args[0] = _defineProperty({}, args[0], args[1]);
	      }
	      _this._gtag("set", _this._toGtagOptions(args[0]));
	    });
	    _defineProperty(this, "_gaCommand", function (command) {
	      for (var _len6 = arguments.length, args = new Array(_len6 > 1 ? _len6 - 1 : 0), _key6 = 1; _key6 < _len6; _key6++) {
	        args[_key6 - 1] = arguments[_key6];
	      }
	      switch (command) {
	        case "send":
	          _this._gaCommandSend.apply(_this, args);
	          break;
	        case "set":
	          _this._gaCommandSet.apply(_this, args);
	          break;
	        default:
	          console.warn("Command doesn't exist: ".concat(command));
	      }
	    });
	    _defineProperty(this, "ga", function () {
	      for (var _len7 = arguments.length, args = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
	        args[_key7] = arguments[_key7];
	      }
	      if (typeof args[0] === "string") {
	        _this._gaCommand.apply(_this, args);
	      } else {
	        var readyCallback = args[0];
	        _this._gtag("get", _this._currentMeasurementId, "client_id", function (clientId) {
	          _this._isQueuing = false;
	          var queues = _this._queueGtag;
	          readyCallback({
	            get: function get(property) {
	              return property === "clientId" ? clientId : property === "trackingId" ? _this._currentMeasurementId : property === "apiVersion" ? "1" : undefined;
	            }
	          });
	          while (queues.length) {
	            var queue = queues.shift();
	            _this._gtag.apply(_this, _toConsumableArray(queue));
	          }
	        });
	        _this._isQueuing = true;
	      }
	      return _this.ga;
	    });
	    _defineProperty(this, "event", function (optionsOrName, params) {
	      if (typeof optionsOrName === "string") {
	        _this._gtag("event", optionsOrName, _this._toGtagOptions(params));
	      } else {
	        var action = optionsOrName.action,
	          category = optionsOrName.category,
	          label = optionsOrName.label,
	          value = optionsOrName.value,
	          nonInteraction = optionsOrName.nonInteraction,
	          transport = optionsOrName.transport;
	        if (!category || !action) {
	          console.warn("args.category AND args.action are required in event()");
	          return;
	        }
	
	        // Required Fields
	        var fieldObject = {
	          hitType: "event",
	          eventCategory: (0, _format["default"])(category),
	          eventAction: (0, _format["default"])(action)
	        };
	
	        // Optional Fields
	        if (label) {
	          fieldObject.eventLabel = (0, _format["default"])(label);
	        }
	        if (typeof value !== "undefined") {
	          if (typeof value !== "number") {
	            console.warn("Expected `args.value` arg to be a Number.");
	          } else {
	            fieldObject.eventValue = value;
	          }
	        }
	        if (typeof nonInteraction !== "undefined") {
	          if (typeof nonInteraction !== "boolean") {
	            console.warn("`args.nonInteraction` must be a boolean.");
	          } else {
	            fieldObject.nonInteraction = nonInteraction;
	          }
	        }
	        if (typeof transport !== "undefined") {
	          if (typeof transport !== "string") {
	            console.warn("`args.transport` must be a string.");
	          } else {
	            if (["beacon", "xhr", "image"].indexOf(transport) === -1) {
	              console.warn("`args.transport` must be either one of these values: `beacon`, `xhr` or `image`");
	            }
	            fieldObject.transport = transport;
	          }
	        }
	        _this._gaCommand("send", fieldObject);
	      }
	    });
	    _defineProperty(this, "send", function (fieldObject) {
	      _this._gaCommand("send", fieldObject);
	    });
	    this.reset();
	  }
	  _createClass(GA4, [{
	    key: "gtag",
	    value: function gtag() {
	      this._gtag.apply(this, arguments);
	    }
	  }]);
	  return GA4;
	}();
	exports.GA4 = GA4;
	var _default = new GA4();
	exports["default"] = _default;

/***/ }),
/* 569 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	var gtag = function gtag() {
	  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	    args[_key] = arguments[_key];
	  }
	  if (typeof window !== "undefined") {
	    var _window;
	    if (typeof window.gtag === "undefined") {
	      window.dataLayer = window.dataLayer || [];
	      window.gtag = function gtag() {
	        window.dataLayer.push(arguments);
	      };
	    }
	    (_window = window).gtag.apply(_window, args);
	  }
	};
	var _default = gtag;
	exports["default"] = _default;

/***/ }),
/* 570 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = format;
	var smallWords = /^(a|an|and|as|at|but|by|en|for|if|in|nor|of|on|or|per|the|to|vs?\.?|via)$/i;
	function toTitleCase(string) {
	  return string.toString().trim().replace(/[A-Za-z0-9\u00C0-\u00FF]+[^\s-]*/g, function (match, index, title) {
	    if (index > 0 && index + match.length !== title.length && match.search(smallWords) > -1 && title.charAt(index - 2) !== ":" && (title.charAt(index + match.length) !== "-" || title.charAt(index - 1) === "-") && title.charAt(index - 1).search(/[^\s-]/) < 0) {
	      return match.toLowerCase();
	    }
	    if (match.substr(1).search(/[A-Z]|\../) > -1) {
	      return match;
	    }
	    return match.charAt(0).toUpperCase() + match.substr(1);
	  });
	}
	
	// See if s could be an email address. We don't want to send personal data like email.
	// https://support.google.com/analytics/answer/2795983?hl=en
	function mightBeEmail(s) {
	  // There's no point trying to validate rfc822 fully, just look for ...@...
	  return typeof s === "string" && s.indexOf("@") !== -1;
	}
	var redacted = "REDACTED (Potential Email Address)";
	function redactEmail(string) {
	  if (mightBeEmail(string)) {
	    console.warn("This arg looks like an email address, redacting.");
	    return redacted;
	  }
	  return string;
	}
	function format() {
	  var s = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
	  var titleCase = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	  var redactingEmail = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
	  var _str = s || "";
	  if (titleCase) {
	    _str = toTitleCase(s);
	  }
	  if (redactingEmail) {
	    _str = redactEmail(_str);
	  }
	  return _str;
	}

/***/ }),
/* 571 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.IntercomAPI = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(572);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	var IntercomAPI = exports.IntercomAPI = function IntercomAPI() {
	  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	    args[_key] = arguments[_key];
	  }
	
	  if (canUseDOM && window.Intercom) {
	    window.Intercom.apply(null, args);
	  } else {
	    console.warn('Intercom not initialized yet');
	  }
	};
	
	var Intercom = function (_Component) {
	  _inherits(Intercom, _Component);
	
	  function Intercom(props) {
	    _classCallCheck(this, Intercom);
	
	    var _this = _possibleConstructorReturn(this, (Intercom.__proto__ || Object.getPrototypeOf(Intercom)).call(this, props));
	
	    var appID = props.appID,
	        otherProps = _objectWithoutProperties(props, ['appID']);
	
	    if (!appID || !canUseDOM) {
	      return _possibleConstructorReturn(_this);
	    }
	
	    if (!window.Intercom) {
	      (function (w, d, id, s, x) {
	        function i() {
	          i.c(arguments);
	        }
	        i.q = [];
	        i.c = function (args) {
	          i.q.push(args);
	        };
	        w.Intercom = i;
	        s = d.createElement('script');
	        s.async = 1;
	        s.src = 'https://widget.intercom.io/widget/' + id;
	        x = d.getElementsByTagName('script')[0];
	        x.parentNode.insertBefore(s, x);
	      })(window, document, appID);
	    }
	
	    window.intercomSettings = _extends({}, otherProps, { app_id: appID });
	
	    if (window.Intercom) {
	      window.Intercom('boot', otherProps);
	    }
	    return _this;
	  }
	
	  _createClass(Intercom, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var appID = nextProps.appID,
	          otherProps = _objectWithoutProperties(nextProps, ['appID']);
	
	      if (!canUseDOM) return;
	
	      window.intercomSettings = _extends({}, otherProps, { app_id: appID });
	      window.Intercom('update', otherProps);
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate() {
	      return false;
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (!canUseDOM) return false;
	
	      window.Intercom('shutdown');
	
	      delete window.Intercom;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return false;
	    }
	  }]);
	
	  return Intercom;
	}(_react.Component);
	
	Intercom.propTypes = {
	  appID: _propTypes2.default.string,
	  app_id: _propTypes2.default.string
	};
	Intercom.displayName = 'Intercom';
	exports.default = Intercom;

/***/ }),
/* 572 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	if (false) {
	  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
	    Symbol.for &&
	    Symbol.for('react.element')) ||
	    0xeac7;
	
	  var isValidElement = function(object) {
	    return typeof object === 'object' &&
	      object !== null &&
	      object.$$typeof === REACT_ELEMENT_TYPE;
	  };
	
	  // By explicitly using `prop-types` you are opting into new development behavior.
	  // http://fb.me/prop-types-in-prod
	  var throwOnDirectAccess = true;
	  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
	} else {
	  // By explicitly using `prop-types` you are opting into new production behavior.
	  // http://fb.me/prop-types-in-prod
	  module.exports = __webpack_require__(573)();
	}


/***/ }),
/* 573 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(574);
	var invariant = __webpack_require__(575);
	
	module.exports = function() {
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
	  function shim() {
	    invariant(
	      false,
	      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	      'Use PropTypes.checkPropTypes() to call them. ' +
	      'Read more at http://fb.me/use-check-prop-types'
	    );
	  };
	  shim.isRequired = shim;
	  function getShim() {
	    return shim;
	  };
	  var ReactPropTypes = {
	    array: shim,
	    bool: shim,
	    func: shim,
	    number: shim,
	    object: shim,
	    string: shim,
	    symbol: shim,
	
	    any: shim,
	    arrayOf: getShim,
	    element: shim,
	    instanceOf: getShim,
	    node: shim,
	    objectOf: getShim,
	    oneOf: getShim,
	    oneOfType: getShim,
	    shape: getShim
	  };
	
	  ReactPropTypes.checkPropTypes = emptyFunction;
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ }),
/* 574 */
/***/ (function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	function makeEmptyFunction(arg) {
	  return function () {
	    return arg;
	  };
	}
	
	/**
	 * This function accepts and discards inputs; it has no side effects. This is
	 * primarily useful idiomatically for overridable function endpoints which
	 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
	 */
	var emptyFunction = function emptyFunction() {};
	
	emptyFunction.thatReturns = makeEmptyFunction;
	emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
	emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
	emptyFunction.thatReturnsNull = makeEmptyFunction(null);
	emptyFunction.thatReturnsThis = function () {
	  return this;
	};
	emptyFunction.thatReturnsArgument = function (arg) {
	  return arg;
	};
	
	module.exports = emptyFunction;

/***/ }),
/* 575 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var validateFormat = function validateFormat(format) {};
	
	if (false) {
	  validateFormat = function validateFormat(format) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  };
	}
	
	function invariant(condition, format, a, b, c, d, e, f) {
	  validateFormat(format);
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(format.replace(/%s/g, function () {
	        return args[argIndex++];
	      }));
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	}
	
	module.exports = invariant;

/***/ }),
/* 576 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ToolbarTitle = exports.ToolbarSeparator = exports.ToolbarGroup = exports.Toolbar = exports.Toggle = exports.TimePicker = exports.TextField = exports.TableRowColumn = exports.TableRow = exports.TableHeaderColumn = exports.TableHeader = exports.TableFooter = exports.TableBody = exports.Table = exports.Tab = exports.Tabs = exports.Snackbar = exports.Stepper = exports.StepLabel = exports.StepContent = exports.StepButton = exports.Step = exports.SvgIcon = exports.Subheader = exports.Slider = exports.SelectField = exports.RefreshIndicator = exports.RaisedButton = exports.RadioButtonGroup = exports.RadioButton = exports.Popover = exports.Paper = exports.MuiThemeProvider = exports.MenuItem = exports.Menu = exports.MakeSelectable = exports.ListItem = exports.List = exports.LinearProgress = exports.IconMenu = exports.IconButton = exports.GridTile = exports.GridList = exports.FontIcon = exports.FloatingActionButton = exports.FlatButton = exports.DropDownMenu = exports.Drawer = exports.Divider = exports.Dialog = exports.DatePicker = exports.CircularProgress = exports.Chip = exports.Checkbox = exports.CardText = exports.CardTitle = exports.CardMedia = exports.CardHeader = exports.CardActions = exports.Card = exports.Badge = exports.Avatar = exports.AutoComplete = exports.AppBar = undefined;
	
	var _AppBar2 = __webpack_require__(577);
	
	var _AppBar3 = _interopRequireDefault(_AppBar2);
	
	var _AutoComplete2 = __webpack_require__(619);
	
	var _AutoComplete3 = _interopRequireDefault(_AutoComplete2);
	
	var _Avatar2 = __webpack_require__(664);
	
	var _Avatar3 = _interopRequireDefault(_Avatar2);
	
	var _Badge2 = __webpack_require__(666);
	
	var _Badge3 = _interopRequireDefault(_Badge2);
	
	var _Card2 = __webpack_require__(668);
	
	var _Card3 = _interopRequireDefault(_Card2);
	
	var _CardActions2 = __webpack_require__(677);
	
	var _CardActions3 = _interopRequireDefault(_CardActions2);
	
	var _CardHeader2 = __webpack_require__(673);
	
	var _CardHeader3 = _interopRequireDefault(_CardHeader2);
	
	var _CardMedia2 = __webpack_require__(675);
	
	var _CardMedia3 = _interopRequireDefault(_CardMedia2);
	
	var _CardTitle2 = __webpack_require__(674);
	
	var _CardTitle3 = _interopRequireDefault(_CardTitle2);
	
	var _CardText2 = __webpack_require__(676);
	
	var _CardText3 = _interopRequireDefault(_CardText2);
	
	var _Checkbox2 = __webpack_require__(678);
	
	var _Checkbox3 = _interopRequireDefault(_Checkbox2);
	
	var _Chip2 = __webpack_require__(683);
	
	var _Chip3 = _interopRequireDefault(_Chip2);
	
	var _CircularProgress2 = __webpack_require__(686);
	
	var _CircularProgress3 = _interopRequireDefault(_CircularProgress2);
	
	var _DatePicker2 = __webpack_require__(688);
	
	var _DatePicker3 = _interopRequireDefault(_DatePicker2);
	
	var _Dialog2 = __webpack_require__(707);
	
	var _Dialog3 = _interopRequireDefault(_Dialog2);
	
	var _Divider2 = __webpack_require__(662);
	
	var _Divider3 = _interopRequireDefault(_Divider2);
	
	var _Drawer2 = __webpack_require__(712);
	
	var _Drawer3 = _interopRequireDefault(_Drawer2);
	
	var _DropDownMenu2 = __webpack_require__(714);
	
	var _DropDownMenu3 = _interopRequireDefault(_DropDownMenu2);
	
	var _FlatButton2 = __webpack_require__(694);
	
	var _FlatButton3 = _interopRequireDefault(_FlatButton2);
	
	var _FloatingActionButton2 = __webpack_require__(719);
	
	var _FloatingActionButton3 = _interopRequireDefault(_FloatingActionButton2);
	
	var _FontIcon2 = __webpack_require__(604);
	
	var _FontIcon3 = _interopRequireDefault(_FontIcon2);
	
	var _GridList2 = __webpack_require__(721);
	
	var _GridList3 = _interopRequireDefault(_GridList2);
	
	var _GridTile2 = __webpack_require__(723);
	
	var _GridTile3 = _interopRequireDefault(_GridTile2);
	
	var _IconButton2 = __webpack_require__(580);
	
	var _IconButton3 = _interopRequireDefault(_IconButton2);
	
	var _IconMenu2 = __webpack_require__(724);
	
	var _IconMenu3 = _interopRequireDefault(_IconMenu2);
	
	var _LinearProgress2 = __webpack_require__(726);
	
	var _LinearProgress3 = _interopRequireDefault(_LinearProgress2);
	
	var _List2 = __webpack_require__(728);
	
	var _List3 = _interopRequireDefault(_List2);
	
	var _ListItem2 = __webpack_require__(658);
	
	var _ListItem3 = _interopRequireDefault(_ListItem2);
	
	var _MakeSelectable2 = __webpack_require__(729);
	
	var _MakeSelectable3 = _interopRequireDefault(_MakeSelectable2);
	
	var _Menu2 = __webpack_require__(630);
	
	var _Menu3 = _interopRequireDefault(_Menu2);
	
	var _MenuItem2 = __webpack_require__(637);
	
	var _MenuItem3 = _interopRequireDefault(_MenuItem2);
	
	var _MuiThemeProvider2 = __webpack_require__(730);
	
	var _MuiThemeProvider3 = _interopRequireDefault(_MuiThemeProvider2);
	
	var _Paper2 = __webpack_require__(617);
	
	var _Paper3 = _interopRequireDefault(_Paper2);
	
	var _Popover2 = __webpack_require__(860);
	
	var _Popover3 = _interopRequireDefault(_Popover2);
	
	var _RadioButton2 = __webpack_require__(861);
	
	var _RadioButton3 = _interopRequireDefault(_RadioButton2);
	
	var _RadioButtonGroup2 = __webpack_require__(865);
	
	var _RadioButtonGroup3 = _interopRequireDefault(_RadioButtonGroup2);
	
	var _RaisedButton2 = __webpack_require__(866);
	
	var _RaisedButton3 = _interopRequireDefault(_RaisedButton2);
	
	var _RefreshIndicator2 = __webpack_require__(868);
	
	var _RefreshIndicator3 = _interopRequireDefault(_RefreshIndicator2);
	
	var _SelectField2 = __webpack_require__(870);
	
	var _SelectField3 = _interopRequireDefault(_SelectField2);
	
	var _Slider2 = __webpack_require__(872);
	
	var _Slider3 = _interopRequireDefault(_Slider2);
	
	var _Subheader2 = __webpack_require__(634);
	
	var _Subheader3 = _interopRequireDefault(_Subheader2);
	
	var _SvgIcon2 = __webpack_require__(615);
	
	var _SvgIcon3 = _interopRequireDefault(_SvgIcon2);
	
	var _Step2 = __webpack_require__(874);
	
	var _Step3 = _interopRequireDefault(_Step2);
	
	var _StepButton2 = __webpack_require__(875);
	
	var _StepButton3 = _interopRequireDefault(_StepButton2);
	
	var _StepContent2 = __webpack_require__(878);
	
	var _StepContent3 = _interopRequireDefault(_StepContent2);
	
	var _StepLabel2 = __webpack_require__(876);
	
	var _StepLabel3 = _interopRequireDefault(_StepLabel2);
	
	var _Stepper2 = __webpack_require__(881);
	
	var _Stepper3 = _interopRequireDefault(_Stepper2);
	
	var _Snackbar2 = __webpack_require__(883);
	
	var _Snackbar3 = _interopRequireDefault(_Snackbar2);
	
	var _Tabs2 = __webpack_require__(887);
	
	var _Tabs3 = _interopRequireDefault(_Tabs2);
	
	var _Tab2 = __webpack_require__(888);
	
	var _Tab3 = _interopRequireDefault(_Tab2);
	
	var _Table2 = __webpack_require__(892);
	
	var _Table3 = _interopRequireDefault(_Table2);
	
	var _TableBody2 = __webpack_require__(894);
	
	var _TableBody3 = _interopRequireDefault(_TableBody2);
	
	var _TableFooter2 = __webpack_require__(896);
	
	var _TableFooter3 = _interopRequireDefault(_TableFooter2);
	
	var _TableHeader2 = __webpack_require__(897);
	
	var _TableHeader3 = _interopRequireDefault(_TableHeader2);
	
	var _TableHeaderColumn2 = __webpack_require__(898);
	
	var _TableHeaderColumn3 = _interopRequireDefault(_TableHeaderColumn2);
	
	var _TableRow2 = __webpack_require__(899);
	
	var _TableRow3 = _interopRequireDefault(_TableRow2);
	
	var _TableRowColumn2 = __webpack_require__(895);
	
	var _TableRowColumn3 = _interopRequireDefault(_TableRowColumn2);
	
	var _TextField2 = __webpack_require__(621);
	
	var _TextField3 = _interopRequireDefault(_TextField2);
	
	var _TimePicker2 = __webpack_require__(900);
	
	var _TimePicker3 = _interopRequireDefault(_TimePicker2);
	
	var _Toggle2 = __webpack_require__(910);
	
	var _Toggle3 = _interopRequireDefault(_Toggle2);
	
	var _Toolbar2 = __webpack_require__(912);
	
	var _Toolbar3 = _interopRequireDefault(_Toolbar2);
	
	var _ToolbarGroup2 = __webpack_require__(914);
	
	var _ToolbarGroup3 = _interopRequireDefault(_ToolbarGroup2);
	
	var _ToolbarSeparator2 = __webpack_require__(915);
	
	var _ToolbarSeparator3 = _interopRequireDefault(_ToolbarSeparator2);
	
	var _ToolbarTitle2 = __webpack_require__(916);
	
	var _ToolbarTitle3 = _interopRequireDefault(_ToolbarTitle2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.AppBar = _AppBar3.default;
	exports.AutoComplete = _AutoComplete3.default;
	exports.Avatar = _Avatar3.default;
	exports.Badge = _Badge3.default;
	exports.Card = _Card3.default;
	exports.CardActions = _CardActions3.default;
	exports.CardHeader = _CardHeader3.default;
	exports.CardMedia = _CardMedia3.default;
	exports.CardTitle = _CardTitle3.default;
	exports.CardText = _CardText3.default;
	exports.Checkbox = _Checkbox3.default;
	exports.Chip = _Chip3.default;
	exports.CircularProgress = _CircularProgress3.default;
	exports.DatePicker = _DatePicker3.default;
	exports.Dialog = _Dialog3.default;
	exports.Divider = _Divider3.default;
	exports.Drawer = _Drawer3.default;
	exports.DropDownMenu = _DropDownMenu3.default;
	exports.FlatButton = _FlatButton3.default;
	exports.FloatingActionButton = _FloatingActionButton3.default;
	exports.FontIcon = _FontIcon3.default;
	exports.GridList = _GridList3.default;
	exports.GridTile = _GridTile3.default;
	exports.IconButton = _IconButton3.default;
	exports.IconMenu = _IconMenu3.default;
	exports.LinearProgress = _LinearProgress3.default;
	exports.List = _List3.default;
	exports.ListItem = _ListItem3.default;
	exports.MakeSelectable = _MakeSelectable3.default;
	exports.Menu = _Menu3.default;
	exports.MenuItem = _MenuItem3.default;
	exports.MuiThemeProvider = _MuiThemeProvider3.default;
	exports.Paper = _Paper3.default;
	exports.Popover = _Popover3.default;
	exports.RadioButton = _RadioButton3.default;
	exports.RadioButtonGroup = _RadioButtonGroup3.default;
	exports.RaisedButton = _RaisedButton3.default;
	exports.RefreshIndicator = _RefreshIndicator3.default;
	exports.SelectField = _SelectField3.default;
	exports.Slider = _Slider3.default;
	exports.Subheader = _Subheader3.default;
	exports.SvgIcon = _SvgIcon3.default;
	exports.Step = _Step3.default;
	exports.StepButton = _StepButton3.default;
	exports.StepContent = _StepContent3.default;
	exports.StepLabel = _StepLabel3.default;
	exports.Stepper = _Stepper3.default;
	exports.Snackbar = _Snackbar3.default;
	exports.Tabs = _Tabs3.default;
	exports.Tab = _Tab3.default;
	exports.Table = _Table3.default;
	exports.TableBody = _TableBody3.default;
	exports.TableFooter = _TableFooter3.default;
	exports.TableHeader = _TableHeader3.default;
	exports.TableHeaderColumn = _TableHeaderColumn3.default;
	exports.TableRow = _TableRow3.default;
	exports.TableRowColumn = _TableRowColumn3.default;
	exports.TextField = _TextField3.default;
	exports.TimePicker = _TimePicker3.default;
	exports.Toggle = _Toggle3.default;
	exports.Toolbar = _Toolbar3.default;
	exports.ToolbarGroup = _ToolbarGroup3.default;
	exports.ToolbarSeparator = _ToolbarSeparator3.default;
	exports.ToolbarTitle = _ToolbarTitle3.default;

/***/ }),
/* 577 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _AppBar = __webpack_require__(578);
	
	var _AppBar2 = _interopRequireDefault(_AppBar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _AppBar2.default;

/***/ }),
/* 578 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.getStyles = getStyles;
	
	var _simpleAssign = __webpack_require__(579);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _IconButton = __webpack_require__(580);
	
	var _IconButton2 = _interopRequireDefault(_IconButton);
	
	var _menu = __webpack_require__(607);
	
	var _menu2 = _interopRequireDefault(_menu);
	
	var _Paper = __webpack_require__(617);
	
	var _Paper2 = _interopRequireDefault(_Paper);
	
	var _propTypes = __webpack_require__(583);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _warning = __webpack_require__(491);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function getStyles(props, context) {
	  var _context$muiTheme = context.muiTheme;
	  var appBar = _context$muiTheme.appBar;
	  var iconButtonSize = _context$muiTheme.button.iconButtonSize;
	  var zIndex = _context$muiTheme.zIndex;
	
	
	  var flatButtonSize = 36;
	
	  var styles = {
	    root: {
	      position: 'relative',
	      zIndex: zIndex.appBar,
	      width: '100%',
	      display: 'flex',
	      backgroundColor: appBar.color,
	      paddingLeft: appBar.padding,
	      paddingRight: appBar.padding
	    },
	    title: {
	      whiteSpace: 'nowrap',
	      overflow: 'hidden',
	      textOverflow: 'ellipsis',
	      margin: 0,
	      paddingTop: 0,
	      letterSpacing: 0,
	      fontSize: 24,
	      fontWeight: appBar.titleFontWeight,
	      color: appBar.textColor,
	      height: appBar.height,
	      lineHeight: appBar.height + 'px'
	    },
	    mainElement: {
	      boxFlex: 1,
	      flex: '1'
	    },
	    iconButtonStyle: {
	      marginTop: (appBar.height - iconButtonSize) / 2,
	      marginRight: 8,
	      marginLeft: -16
	    },
	    iconButtonIconStyle: {
	      fill: appBar.textColor,
	      color: appBar.textColor
	    },
	    flatButton: {
	      color: appBar.textColor,
	      marginTop: (iconButtonSize - flatButtonSize) / 2 + 1
	    }
	  };
	
	  return styles;
	}
	
	var AppBar = function (_Component) {
	  _inherits(AppBar, _Component);
	
	  function AppBar() {
	    var _Object$getPrototypeO;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, AppBar);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_Object$getPrototypeO = Object.getPrototypeOf(AppBar)).call.apply(_Object$getPrototypeO, [this].concat(args))), _this), _this.handleTouchTapLeftIconButton = function (event) {
	      if (_this.props.onLeftIconButtonTouchTap) {
	        _this.props.onLeftIconButtonTouchTap(event);
	      }
	    }, _this.handleTouchTapRightIconButton = function (event) {
	      if (_this.props.onRightIconButtonTouchTap) {
	        _this.props.onRightIconButtonTouchTap(event);
	      }
	    }, _this.handleTitleTouchTap = function (event) {
	      if (_this.props.onTitleTouchTap) {
	        _this.props.onTitleTouchTap(event);
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(AppBar, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	       false ? (0, _warning2.default)(!this.props.iconElementLeft || !this.props.iconClassNameLeft, 'Properties iconElementLeft\n      and iconClassNameLeft cannot be simultaneously defined. Please use one or the other.') : void 0;
	
	       false ? (0, _warning2.default)(!this.props.iconElementRight || !this.props.iconClassNameRight, 'Properties iconElementRight\n      and iconClassNameRight cannot be simultaneously defined. Please use one or the other.') : void 0;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var title = _props.title;
	      var titleStyle = _props.titleStyle;
	      var iconStyleLeft = _props.iconStyleLeft;
	      var iconStyleRight = _props.iconStyleRight;
	      var onTitleTouchTap = _props.onTitleTouchTap;
	      var showMenuIconButton = _props.showMenuIconButton;
	      var iconElementLeft = _props.iconElementLeft;
	      var iconElementRight = _props.iconElementRight;
	      var iconClassNameLeft = _props.iconClassNameLeft;
	      var iconClassNameRight = _props.iconClassNameRight;
	      var onLeftIconButtonTouchTap = _props.onLeftIconButtonTouchTap;
	      var className = _props.className;
	      var style = _props.style;
	      var zDepth = _props.zDepth;
	      var children = _props.children;
	
	      var other = _objectWithoutProperties(_props, ['title', 'titleStyle', 'iconStyleLeft', 'iconStyleRight', 'onTitleTouchTap', 'showMenuIconButton', 'iconElementLeft', 'iconElementRight', 'iconClassNameLeft', 'iconClassNameRight', 'onLeftIconButtonTouchTap', 'className', 'style', 'zDepth', 'children']);
	
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      var menuElementLeft = void 0;
	      var menuElementRight = void 0;
	
	      // If the title is a string, wrap in an h1 tag.
	      // If not, wrap in a div tag.
	      var titleComponent = typeof title === 'string' || title instanceof String ? 'h1' : 'div';
	
	      var titleElement = _react2.default.createElement(titleComponent, {
	        onTouchTap: this.handleTitleTouchTap,
	        style: prepareStyles((0, _simpleAssign2.default)(styles.title, styles.mainElement, titleStyle))
	      }, title);
	
	      var iconLeftStyle = (0, _simpleAssign2.default)({}, styles.iconButtonStyle, iconStyleLeft);
	
	      if (showMenuIconButton) {
	        var iconElementLeftNode = iconElementLeft;
	
	        if (iconElementLeft) {
	          if (iconElementLeft.type.muiName === 'IconButton') {
	            var iconElemLeftChildren = iconElementLeft.props.children;
	            var iconButtonIconStyle = !(iconElemLeftChildren && iconElemLeftChildren.props && iconElemLeftChildren.props.color) ? styles.iconButtonIconStyle : null;
	
	            iconElementLeftNode = _react2.default.cloneElement(iconElementLeft, {
	              iconStyle: (0, _simpleAssign2.default)({}, iconButtonIconStyle, iconElementLeft.props.iconStyle)
	            });
	          }
	
	          menuElementLeft = _react2.default.createElement(
	            'div',
	            { style: prepareStyles(iconLeftStyle) },
	            iconElementLeftNode
	          );
	        } else {
	          var child = iconClassNameLeft ? '' : _react2.default.createElement(_menu2.default, { style: (0, _simpleAssign2.default)({}, styles.iconButtonIconStyle) });
	          menuElementLeft = _react2.default.createElement(
	            _IconButton2.default,
	            {
	              style: iconLeftStyle,
	              iconStyle: styles.iconButtonIconStyle,
	              iconClassName: iconClassNameLeft,
	              onTouchTap: this.handleTouchTapLeftIconButton
	            },
	            child
	          );
	        }
	      }
	
	      var iconRightStyle = (0, _simpleAssign2.default)({}, styles.iconButtonStyle, {
	        marginRight: -16,
	        marginLeft: 'auto'
	      }, iconStyleRight);
	
	      if (iconElementRight) {
	        var iconElementRightNode = iconElementRight;
	
	        switch (iconElementRight.type.muiName) {
	          case 'IconMenu':
	          case 'IconButton':
	            var iconElemRightChildren = iconElementRight.props.children;
	            var _iconButtonIconStyle = !(iconElemRightChildren && iconElemRightChildren.props && iconElemRightChildren.props.color) ? styles.iconButtonIconStyle : null;
	
	            iconElementRightNode = _react2.default.cloneElement(iconElementRight, {
	              iconStyle: (0, _simpleAssign2.default)({}, _iconButtonIconStyle, iconElementRight.props.iconStyle)
	            });
	            break;
	
	          case 'FlatButton':
	            iconElementRightNode = _react2.default.cloneElement(iconElementRight, {
	              style: (0, _simpleAssign2.default)({}, styles.flatButton, iconElementRight.props.style)
	            });
	            break;
	
	          default:
	        }
	
	        menuElementRight = _react2.default.createElement(
	          'div',
	          { style: prepareStyles(iconRightStyle) },
	          iconElementRightNode
	        );
	      } else if (iconClassNameRight) {
	        menuElementRight = _react2.default.createElement(_IconButton2.default, {
	          style: iconRightStyle,
	          iconStyle: styles.iconButtonIconStyle,
	          iconClassName: iconClassNameRight,
	          onTouchTap: this.handleTouchTapRightIconButton
	        });
	      }
	
	      return _react2.default.createElement(
	        _Paper2.default,
	        _extends({}, other, {
	          rounded: false,
	          className: className,
	          style: (0, _simpleAssign2.default)({}, styles.root, style),
	          zDepth: zDepth
	        }),
	        menuElementLeft,
	        titleElement,
	        menuElementRight,
	        children
	      );
	    }
	  }]);
	
	  return AppBar;
	}(_react.Component);
	
	AppBar.muiName = 'AppBar';
	AppBar.propTypes = {
	  /**
	   * Can be used to render a tab inside an app bar for instance.
	   */
	  children: _react.PropTypes.node,
	  /**
	   * Applied to the app bar's root element.
	   */
	  className: _react.PropTypes.string,
	  /**
	   * The classname of the icon on the left of the app bar.
	   * If you are using a stylesheet for your icons, enter the class name for the icon to be used here.
	   */
	  iconClassNameLeft: _react.PropTypes.string,
	  /**
	   * Similiar to the iconClassNameLeft prop except that
	   * it applies to the icon displayed on the right of the app bar.
	   */
	  iconClassNameRight: _react.PropTypes.string,
	  /**
	   * The custom element to be displayed on the left side of the
	   * app bar such as an SvgIcon.
	   */
	  iconElementLeft: _react.PropTypes.element,
	  /**
	   * Similiar to the iconElementLeft prop except that this element is displayed on the right of the app bar.
	   */
	  iconElementRight: _react.PropTypes.element,
	  /**
	   * Override the inline-styles of the element displayed on the left side of the app bar.
	   */
	  iconStyleLeft: _react.PropTypes.object,
	  /**
	   * Override the inline-styles of the element displayed on the right side of the app bar.
	   */
	  iconStyleRight: _react.PropTypes.object,
	  /**
	   * Callback function for when the left icon is selected via a touch tap.
	   *
	   * @param {object} event TouchTap event targeting the left `IconButton`.
	   */
	  onLeftIconButtonTouchTap: _react.PropTypes.func,
	  /**
	   * Callback function for when the right icon is selected via a touch tap.
	   *
	   * @param {object} event TouchTap event targeting the right `IconButton`.
	   */
	  onRightIconButtonTouchTap: _react.PropTypes.func,
	  /**
	   * Callback function for when the title text is selected via a touch tap.
	   *
	   * @param {object} event TouchTap event targeting the `title` node.
	   */
	  onTitleTouchTap: _react.PropTypes.func,
	  /**
	   * Determines whether or not to display the Menu icon next to the title.
	   * Setting this prop to false will hide the icon.
	   */
	  showMenuIconButton: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object,
	  /**
	   * The title to display on the app bar.
	   */
	  title: _react.PropTypes.node,
	  /**
	   * Override the inline-styles of the app bar's title element.
	   */
	  titleStyle: _react.PropTypes.object,
	  /**
	   * The zDepth of the component.
	   * The shadow of the app bar is also dependent on this property.
	   */
	  zDepth: _propTypes2.default.zDepth
	};
	AppBar.defaultProps = {
	  showMenuIconButton: true,
	  title: '',
	  zDepth: 1
	};
	AppBar.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	exports.default = AppBar;

/***/ }),
/* 579 */
/***/ (function(module, exports) {

	module.exports = function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	  return target;
	};


/***/ }),
/* 580 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _IconButton = __webpack_require__(581);
	
	var _IconButton2 = _interopRequireDefault(_IconButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _IconButton2.default;

/***/ }),
/* 581 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _simpleAssign = __webpack_require__(579);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _transitions = __webpack_require__(582);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _propTypes = __webpack_require__(583);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _EnhancedButton = __webpack_require__(584);
	
	var _EnhancedButton2 = _interopRequireDefault(_EnhancedButton);
	
	var _FontIcon = __webpack_require__(604);
	
	var _FontIcon2 = _interopRequireDefault(_FontIcon);
	
	var _Tooltip = __webpack_require__(606);
	
	var _Tooltip2 = _interopRequireDefault(_Tooltip);
	
	var _childUtils = __webpack_require__(585);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function getStyles(props, context) {
	  var baseTheme = context.muiTheme.baseTheme;
	
	
	  return {
	    root: {
	      position: 'relative',
	      boxSizing: 'border-box',
	      overflow: 'visible',
	      transition: _transitions2.default.easeOut(),
	      padding: baseTheme.spacing.iconSize / 2,
	      width: baseTheme.spacing.iconSize * 2,
	      height: baseTheme.spacing.iconSize * 2,
	      fontSize: 0
	    },
	    tooltip: {
	      boxSizing: 'border-box'
	    },
	    overlay: {
	      position: 'relative',
	      top: 0,
	      width: '100%',
	      height: '100%',
	      background: baseTheme.palette.disabledColor
	    },
	    disabled: {
	      color: baseTheme.palette.disabledColor,
	      fill: baseTheme.palette.disabledColor,
	      cursor: 'not-allowed'
	    }
	  };
	}
	
	var IconButton = function (_Component) {
	  _inherits(IconButton, _Component);
	
	  function IconButton() {
	    var _Object$getPrototypeO;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, IconButton);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_Object$getPrototypeO = Object.getPrototypeOf(IconButton)).call.apply(_Object$getPrototypeO, [this].concat(args))), _this), _this.state = {
	      tooltipShown: false
	    }, _this.handleBlur = function (event) {
	      _this.hideTooltip();
	      if (_this.props.onBlur) _this.props.onBlur(event);
	    }, _this.handleFocus = function (event) {
	      _this.showTooltip();
	      if (_this.props.onFocus) _this.props.onFocus(event);
	    }, _this.handleMouseLeave = function (event) {
	      if (!_this.refs.button.isKeyboardFocused()) _this.hideTooltip();
	      if (_this.props.onMouseLeave) _this.props.onMouseLeave(event);
	    }, _this.handleMouseOut = function (event) {
	      if (_this.props.disabled) _this.hideTooltip();
	      if (_this.props.onMouseOut) _this.props.onMouseOut(event);
	    }, _this.handleMouseEnter = function (event) {
	      _this.showTooltip();
	      if (_this.props.onMouseEnter) _this.props.onMouseEnter(event);
	    }, _this.handleKeyboardFocus = function (event, keyboardFocused) {
	      if (keyboardFocused && !_this.props.disabled) {
	        _this.showTooltip();
	        if (_this.props.onFocus) _this.props.onFocus(event);
	      } else if (!_this.state.hovered) {
	        _this.hideTooltip();
	        if (_this.props.onBlur) _this.props.onBlur(event);
	      }
	
	      if (_this.props.onKeyboardFocus) {
	        _this.props.onKeyboardFocus(event, keyboardFocused);
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(IconButton, [{
	    key: 'setKeyboardFocus',
	    value: function setKeyboardFocus() {
	      this.refs.button.setKeyboardFocus();
	    }
	  }, {
	    key: 'showTooltip',
	    value: function showTooltip() {
	      if (this.props.tooltip) {
	        this.setState({ tooltipShown: true });
	      }
	    }
	  }, {
	    key: 'hideTooltip',
	    value: function hideTooltip() {
	      if (this.props.tooltip) this.setState({ tooltipShown: false });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var disabled = _props.disabled;
	      var disableTouchRipple = _props.disableTouchRipple;
	      var children = _props.children;
	      var iconClassName = _props.iconClassName;
	      var onKeyboardFocus = _props.onKeyboardFocus;
	      var tooltip = _props.tooltip;
	      var tooltipPositionProp = _props.tooltipPosition;
	      var tooltipStyles = _props.tooltipStyles;
	      var touch = _props.touch;
	      var iconStyle = _props.iconStyle;
	
	      var other = _objectWithoutProperties(_props, ['disabled', 'disableTouchRipple', 'children', 'iconClassName', 'onKeyboardFocus', 'tooltip', 'tooltipPosition', 'tooltipStyles', 'touch', 'iconStyle']);
	
	      var fonticon = void 0;
	
	      var styles = getStyles(this.props, this.context);
	      var tooltipPosition = tooltipPositionProp.split('-');
	
	      var tooltipElement = tooltip ? _react2.default.createElement(_Tooltip2.default, {
	        ref: 'tooltip',
	        label: tooltip,
	        show: this.state.tooltipShown,
	        touch: touch,
	        style: (0, _simpleAssign2.default)(styles.tooltip, tooltipStyles),
	        verticalPosition: tooltipPosition[0],
	        horizontalPosition: tooltipPosition[1]
	      }) : null;
	
	      if (iconClassName) {
	        var iconHoverColor = iconStyle.iconHoverColor;
	
	        var iconStyleFontIcon = _objectWithoutProperties(iconStyle, ['iconHoverColor']);
	
	        fonticon = _react2.default.createElement(
	          _FontIcon2.default,
	          {
	            className: iconClassName,
	            hoverColor: disabled ? null : iconHoverColor,
	            style: (0, _simpleAssign2.default)({}, disabled && styles.disabled, iconStyleFontIcon),
	            color: this.context.muiTheme.baseTheme.palette.textColor
	          },
	          children
	        );
	      }
	
	      var childrenStyle = disabled ? (0, _simpleAssign2.default)({}, iconStyle, styles.disabled) : iconStyle;
	
	      return _react2.default.createElement(
	        _EnhancedButton2.default,
	        _extends({}, other, {
	          ref: 'button',
	          centerRipple: true,
	          disabled: disabled,
	          style: (0, _simpleAssign2.default)(styles.root, this.props.style),
	          disableTouchRipple: disableTouchRipple,
	          onBlur: this.handleBlur,
	          onFocus: this.handleFocus,
	          onMouseLeave: this.handleMouseLeave,
	          onMouseEnter: this.handleMouseEnter,
	          onMouseOut: this.handleMouseOut,
	          onKeyboardFocus: this.handleKeyboardFocus
	        }),
	        tooltipElement,
	        fonticon,
	        (0, _childUtils.extendChildren)(children, {
	          style: childrenStyle
	        })
	      );
	    }
	  }]);
	
	  return IconButton;
	}(_react.Component);
	
	IconButton.muiName = 'IconButton';
	IconButton.propTypes = {
	  /**
	   * Can be used to pass a `FontIcon` element as the icon for the button.
	   */
	  children: _react.PropTypes.node,
	  /**
	   * The CSS class name of the root element.
	   */
	  className: _react.PropTypes.string,
	  /**
	   * If true, the element's ripple effect will be disabled.
	   */
	  disableTouchRipple: _react.PropTypes.bool,
	  /**
	   * If true, the element will be disabled.
	   */
	  disabled: _react.PropTypes.bool,
	  /**
	   * The URL to link to when the button is clicked.
	   */
	  href: _react.PropTypes.string,
	  /**
	   * The CSS class name of the icon. Used for setting the icon with a stylesheet.
	   */
	  iconClassName: _react.PropTypes.string,
	  /**
	   * Override the inline-styles of the icon element.
	   */
	  iconStyle: _react.PropTypes.object,
	  /** @ignore */
	  onBlur: _react.PropTypes.func,
	  /** @ignore */
	  onFocus: _react.PropTypes.func,
	  /**
	   * Callback function fired when the element is focused or blurred by the keyboard.
	   *
	   * @param {object} event `focus` or `blur` event targeting the element.
	   * @param {boolean} keyboardFocused Indicates whether the element is focused.
	   */
	  onKeyboardFocus: _react.PropTypes.func,
	  /** @ignore */
	  onMouseEnter: _react.PropTypes.func,
	  /** @ignore */
	  onMouseLeave: _react.PropTypes.func,
	  /** @ignore */
	  onMouseOut: _react.PropTypes.func,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object,
	  /**
	   * The text to supply to the element's tooltip.
	   */
	  tooltip: _react.PropTypes.node,
	  /**
	   * The vertical and horizontal positions, respectively, of the element's tooltip.
	   * Possible values are: "bottom-center", "top-center", "bottom-right", "top-right",
	   * "bottom-left", and "top-left".
	   */
	  tooltipPosition: _propTypes2.default.cornersAndCenter,
	  /**
	   * Override the inline-styles of the tooltip element.
	   */
	  tooltipStyles: _react.PropTypes.object,
	  /**
	   * If true, increase the tooltip element's size.  Useful for increasing tooltip
	   * readability on mobile devices.
	   */
	  touch: _react.PropTypes.bool
	};
	IconButton.defaultProps = {
	  disabled: false,
	  disableTouchRipple: false,
	  iconStyle: {},
	  tooltipPosition: 'bottom-center',
	  touch: false
	};
	IconButton.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	exports.default = IconButton;

/***/ }),
/* 582 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	
	  easeOutFunction: 'cubic-bezier(0.23, 1, 0.32, 1)',
	  easeInOutFunction: 'cubic-bezier(0.445, 0.05, 0.55, 0.95)',
	
	  easeOut: function easeOut(duration, property, delay, easeFunction) {
	    easeFunction = easeFunction || this.easeOutFunction;
	
	    if (property && Object.prototype.toString.call(property) === '[object Array]') {
	      var transitions = '';
	      for (var i = 0; i < property.length; i++) {
	        if (transitions) transitions += ',';
	        transitions += this.create(duration, property[i], delay, easeFunction);
	      }
	
	      return transitions;
	    } else {
	      return this.create(duration, property, delay, easeFunction);
	    }
	  },
	  create: function create(duration, property, delay, easeFunction) {
	    duration = duration || '450ms';
	    property = property || 'all';
	    delay = delay || '0ms';
	    easeFunction = easeFunction || 'linear';
	
	    return property + ' ' + duration + ' ' + easeFunction + ' ' + delay;
	  }
	};

/***/ }),
/* 583 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(300);
	
	var horizontal = _react.PropTypes.oneOf(['left', 'middle', 'right']);
	var vertical = _react.PropTypes.oneOf(['top', 'center', 'bottom']);
	
	exports.default = {
	
	  corners: _react.PropTypes.oneOf(['bottom-left', 'bottom-right', 'top-left', 'top-right']),
	
	  horizontal: horizontal,
	
	  vertical: vertical,
	
	  origin: _react.PropTypes.shape({
	    horizontal: horizontal,
	    vertical: vertical
	  }),
	
	  cornersAndCenter: _react.PropTypes.oneOf(['bottom-center', 'bottom-left', 'bottom-right', 'top-center', 'top-left', 'top-right']),
	
	  stringOrNumber: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.number]),
	
	  zDepth: _react.PropTypes.oneOf([0, 1, 2, 3, 4, 5])
	
	};

/***/ }),
/* 584 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _simpleAssign = __webpack_require__(579);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _childUtils = __webpack_require__(585);
	
	var _events = __webpack_require__(588);
	
	var _events2 = _interopRequireDefault(_events);
	
	var _keycode = __webpack_require__(589);
	
	var _keycode2 = _interopRequireDefault(_keycode);
	
	var _FocusRipple = __webpack_require__(590);
	
	var _FocusRipple2 = _interopRequireDefault(_FocusRipple);
	
	var _TouchRipple = __webpack_require__(600);
	
	var _TouchRipple2 = _interopRequireDefault(_TouchRipple);
	
	var _deprecatedPropType = __webpack_require__(603);
	
	var _deprecatedPropType2 = _interopRequireDefault(_deprecatedPropType);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var styleInjected = false;
	var listening = false;
	var tabPressed = false;
	
	function injectStyle() {
	  if (!styleInjected) {
	    // Remove inner padding and border in Firefox 4+.
	    var style = document.createElement('style');
	    style.innerHTML = '\n      button::-moz-focus-inner,\n      input::-moz-focus-inner {\n        border: 0;\n        padding: 0;\n      }\n    ';
	
	    document.body.appendChild(style);
	    styleInjected = true;
	  }
	}
	
	function listenForTabPresses() {
	  if (!listening) {
	    _events2.default.on(window, 'keydown', function (event) {
	      tabPressed = (0, _keycode2.default)(event) === 'tab';
	    });
	    listening = true;
	  }
	}
	
	var EnhancedButton = function (_Component) {
	  _inherits(EnhancedButton, _Component);
	
	  function EnhancedButton() {
	    var _Object$getPrototypeO;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, EnhancedButton);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_Object$getPrototypeO = Object.getPrototypeOf(EnhancedButton)).call.apply(_Object$getPrototypeO, [this].concat(args))), _this), _this.state = { isKeyboardFocused: false }, _this.handleKeyDown = function (event) {
	      if (!_this.props.disabled && !_this.props.disableKeyboardFocus) {
	        if ((0, _keycode2.default)(event) === 'enter' && _this.state.isKeyboardFocused) {
	          _this.handleTouchTap(event);
	        }
	        if ((0, _keycode2.default)(event) === 'esc' && _this.state.isKeyboardFocused) {
	          _this.removeKeyboardFocus(event);
	        }
	      }
	      _this.props.onKeyDown(event);
	    }, _this.handleKeyUp = function (event) {
	      if (!_this.props.disabled && !_this.props.disableKeyboardFocus) {
	        if ((0, _keycode2.default)(event) === 'space' && _this.state.isKeyboardFocused) {
	          _this.handleTouchTap(event);
	        }
	      }
	      _this.props.onKeyUp(event);
	    }, _this.handleBlur = function (event) {
	      _this.cancelFocusTimeout();
	      _this.removeKeyboardFocus(event);
	      _this.props.onBlur(event);
	    }, _this.handleFocus = function (event) {
	      if (event) event.persist();
	      if (!_this.props.disabled && !_this.props.disableKeyboardFocus) {
	        // setTimeout is needed because the focus event fires first
	        // Wait so that we can capture if this was a keyboard focus
	        // or touch focus
	        _this.focusTimeout = setTimeout(function () {
	          if (tabPressed) {
	            _this.setKeyboardFocus(event);
	            tabPressed = false;
	          }
	        }, 150);
	
	        _this.props.onFocus(event);
	      }
	    }, _this.handleClick = function (event) {
	      if (!_this.props.disabled) {
	        tabPressed = false;
	        _this.props.onClick(event);
	      }
	    }, _this.handleTouchTap = function (event) {
	      _this.cancelFocusTimeout();
	      if (!_this.props.disabled) {
	        tabPressed = false;
	        _this.removeKeyboardFocus(event);
	        _this.props.onTouchTap(event);
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(EnhancedButton, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _props = this.props;
	      var disabled = _props.disabled;
	      var disableKeyboardFocus = _props.disableKeyboardFocus;
	      var keyboardFocused = _props.keyboardFocused;
	
	      if (!disabled && keyboardFocused && !disableKeyboardFocus) {
	        this.setState({ isKeyboardFocused: true });
	      }
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      injectStyle();
	      listenForTabPresses();
	      if (this.state.isKeyboardFocused) {
	        this.refs.enhancedButton.focus();
	        this.props.onKeyboardFocus(null, true);
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if ((nextProps.disabled || nextProps.disableKeyboardFocus) && this.state.isKeyboardFocused) {
	        this.setState({ isKeyboardFocused: false });
	        if (nextProps.onKeyboardFocus) {
	          nextProps.onKeyboardFocus(null, false);
	        }
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      clearTimeout(this.focusTimeout);
	    }
	  }, {
	    key: 'isKeyboardFocused',
	    value: function isKeyboardFocused() {
	      return this.state.isKeyboardFocused;
	    }
	  }, {
	    key: 'removeKeyboardFocus',
	    value: function removeKeyboardFocus(event) {
	      if (this.state.isKeyboardFocused) {
	        this.setState({ isKeyboardFocused: false });
	        this.props.onKeyboardFocus(event, false);
	      }
	    }
	  }, {
	    key: 'setKeyboardFocus',
	    value: function setKeyboardFocus(event) {
	      if (!this.state.isKeyboardFocused) {
	        this.setState({ isKeyboardFocused: true });
	        this.props.onKeyboardFocus(event, true);
	      }
	    }
	  }, {
	    key: 'cancelFocusTimeout',
	    value: function cancelFocusTimeout() {
	      if (this.focusTimeout) {
	        clearTimeout(this.focusTimeout);
	        this.focusTimeout = null;
	      }
	    }
	  }, {
	    key: 'createButtonChildren',
	    value: function createButtonChildren() {
	      var _props2 = this.props;
	      var centerRipple = _props2.centerRipple;
	      var children = _props2.children;
	      var disabled = _props2.disabled;
	      var disableFocusRipple = _props2.disableFocusRipple;
	      var disableKeyboardFocus = _props2.disableKeyboardFocus;
	      var disableTouchRipple = _props2.disableTouchRipple;
	      var focusRippleColor = _props2.focusRippleColor;
	      var focusRippleOpacity = _props2.focusRippleOpacity;
	      var touchRippleColor = _props2.touchRippleColor;
	      var touchRippleOpacity = _props2.touchRippleOpacity;
	      var isKeyboardFocused = this.state.isKeyboardFocused;
	
	      // Focus Ripple
	
	      var focusRipple = isKeyboardFocused && !disabled && !disableFocusRipple && !disableKeyboardFocus ? _react2.default.createElement(_FocusRipple2.default, {
	        color: focusRippleColor,
	        opacity: focusRippleOpacity,
	        show: isKeyboardFocused
	      }) : undefined;
	
	      // Touch Ripple
	      var touchRipple = !disabled && !disableTouchRipple ? _react2.default.createElement(
	        _TouchRipple2.default,
	        {
	          centerRipple: centerRipple,
	          color: touchRippleColor,
	          opacity: touchRippleOpacity
	        },
	        children
	      ) : undefined;
	
	      return (0, _childUtils.createChildFragment)({
	        focusRipple: focusRipple,
	        touchRipple: touchRipple,
	        children: touchRipple ? undefined : children
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props3 = this.props;
	      var centerRipple = _props3.centerRipple;
	      var children = _props3.children;
	      var containerElement = _props3.containerElement;
	      var disabled = _props3.disabled;
	      var disableFocusRipple = _props3.disableFocusRipple;
	      var disableKeyboardFocus = _props3.disableKeyboardFocus;
	      var disableTouchRipple = _props3.disableTouchRipple;
	      var focusRippleColor = _props3.focusRippleColor;
	      var focusRippleOpacity = _props3.focusRippleOpacity;
	      var href = _props3.href;
	      var keyboardFocused = _props3.keyboardFocused;
	      var linkButton = _props3.linkButton;
	      var touchRippleColor = _props3.touchRippleColor;
	      var touchRippleOpacity = _props3.touchRippleOpacity;
	      var onBlur = _props3.onBlur;
	      var onClick = _props3.onClick;
	      var onFocus = _props3.onFocus;
	      var onKeyUp = _props3.onKeyUp;
	      var onKeyDown = _props3.onKeyDown;
	      var onKeyboardFocus = _props3.onKeyboardFocus;
	      var onTouchTap = _props3.onTouchTap;
	      var style = _props3.style;
	      var tabIndex = _props3.tabIndex;
	      var type = _props3.type;
	
	      var other = _objectWithoutProperties(_props3, ['centerRipple', 'children', 'containerElement', 'disabled', 'disableFocusRipple', 'disableKeyboardFocus', 'disableTouchRipple', 'focusRippleColor', 'focusRippleOpacity', 'href', 'keyboardFocused', 'linkButton', 'touchRippleColor', 'touchRippleOpacity', 'onBlur', 'onClick', 'onFocus', 'onKeyUp', 'onKeyDown', 'onKeyboardFocus', 'onTouchTap', 'style', 'tabIndex', 'type']);
	
	      var _context$muiTheme = this.context.muiTheme;
	      var prepareStyles = _context$muiTheme.prepareStyles;
	      var enhancedButton = _context$muiTheme.enhancedButton;
	
	
	      var mergedStyles = (0, _simpleAssign2.default)({
	        border: 10,
	        boxSizing: 'border-box',
	        display: 'inline-block',
	        fontFamily: this.context.muiTheme.baseTheme.fontFamily,
	        WebkitTapHighlightColor: enhancedButton.tapHighlightColor, // Remove mobile color flashing (deprecated)
	        cursor: disabled ? 'default' : 'pointer',
	        textDecoration: 'none',
	        margin: 0,
	        padding: 0,
	        outline: 'none',
	        fontSize: 'inherit',
	        fontWeight: 'inherit',
	        /**
	         * This is needed so that ripples do not bleed
	         * past border radius.
	         * See: http://stackoverflow.com/questions/17298739/
	         * css-overflow-hidden-not-working-in-chrome-when-parent-has-border-radius-and-chil
	         */
	        transform: disableTouchRipple && disableFocusRipple ? null : 'translate(0, 0)',
	        verticalAlign: href ? 'middle' : null
	      }, style);
	
	      // Passing both background:none & backgroundColor can break due to object iteration order
	      if (!mergedStyles.backgroundColor && !mergedStyles.background) {
	        mergedStyles.background = 'none';
	      }
	
	      if (disabled && href) {
	        return _react2.default.createElement(
	          'span',
	          _extends({}, other, {
	            style: mergedStyles
	          }),
	          children
	        );
	      }
	
	      var buttonProps = _extends({}, other, {
	        style: prepareStyles(mergedStyles),
	        ref: 'enhancedButton',
	        disabled: disabled,
	        href: href,
	        onBlur: this.handleBlur,
	        onClick: this.handleClick,
	        onFocus: this.handleFocus,
	        onKeyUp: this.handleKeyUp,
	        onKeyDown: this.handleKeyDown,
	        onTouchTap: this.handleTouchTap,
	        tabIndex: tabIndex,
	        type: type
	      });
	      var buttonChildren = this.createButtonChildren();
	
	      if (_react2.default.isValidElement(containerElement)) {
	        return _react2.default.cloneElement(containerElement, buttonProps, buttonChildren);
	      }
	
	      return _react2.default.createElement(href ? 'a' : containerElement, buttonProps, buttonChildren);
	    }
	  }]);
	
	  return EnhancedButton;
	}(_react.Component);
	
	EnhancedButton.propTypes = {
	  centerRipple: _react.PropTypes.bool,
	  children: _react.PropTypes.node,
	  containerElement: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.element]),
	  disableFocusRipple: _react.PropTypes.bool,
	  disableKeyboardFocus: _react.PropTypes.bool,
	  disableTouchRipple: _react.PropTypes.bool,
	  disabled: _react.PropTypes.bool,
	  focusRippleColor: _react.PropTypes.string,
	  focusRippleOpacity: _react.PropTypes.number,
	  href: _react.PropTypes.string,
	  keyboardFocused: _react.PropTypes.bool,
	  linkButton: (0, _deprecatedPropType2.default)(_react.PropTypes.bool, 'LinkButton is no longer required when the `href` property is provided.\n      It will be removed with v0.16.0.'),
	  onBlur: _react.PropTypes.func,
	  onClick: _react.PropTypes.func,
	  onFocus: _react.PropTypes.func,
	  onKeyDown: _react.PropTypes.func,
	  onKeyUp: _react.PropTypes.func,
	  onKeyboardFocus: _react.PropTypes.func,
	  onMouseDown: _react.PropTypes.func,
	  onMouseEnter: _react.PropTypes.func,
	  onMouseLeave: _react.PropTypes.func,
	  onMouseUp: _react.PropTypes.func,
	  onTouchEnd: _react.PropTypes.func,
	  onTouchStart: _react.PropTypes.func,
	  onTouchTap: _react.PropTypes.func,
	  style: _react.PropTypes.object,
	  tabIndex: _react.PropTypes.number,
	  touchRippleColor: _react.PropTypes.string,
	  touchRippleOpacity: _react.PropTypes.number,
	  type: _react.PropTypes.string
	};
	EnhancedButton.defaultProps = {
	  containerElement: 'button',
	  onBlur: function onBlur() {},
	  onClick: function onClick() {},
	  onFocus: function onFocus() {},
	  onKeyDown: function onKeyDown() {},
	  onKeyUp: function onKeyUp() {},
	  onKeyboardFocus: function onKeyboardFocus() {},
	  onMouseDown: function onMouseDown() {},
	  onMouseEnter: function onMouseEnter() {},
	  onMouseLeave: function onMouseLeave() {},
	  onMouseUp: function onMouseUp() {},
	  onTouchEnd: function onTouchEnd() {},
	  onTouchStart: function onTouchStart() {},
	  onTouchTap: function onTouchTap() {},
	  tabIndex: 0,
	  type: 'button'
	};
	EnhancedButton.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	exports.default = EnhancedButton;

/***/ }),
/* 585 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.createChildFragment = createChildFragment;
	exports.extendChildren = extendChildren;
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactAddonsCreateFragment = __webpack_require__(586);
	
	var _reactAddonsCreateFragment2 = _interopRequireDefault(_reactAddonsCreateFragment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function createChildFragment(fragments) {
	  var newFragments = {};
	  var validChildrenCount = 0;
	  var firstKey = void 0;
	
	  // Only create non-empty key fragments
	  for (var key in fragments) {
	    var currentChild = fragments[key];
	
	    if (currentChild) {
	      if (validChildrenCount === 0) firstKey = key;
	      newFragments[key] = currentChild;
	      validChildrenCount++;
	    }
	  }
	
	  if (validChildrenCount === 0) return undefined;
	  if (validChildrenCount === 1) return newFragments[firstKey];
	  return (0, _reactAddonsCreateFragment2.default)(newFragments);
	}
	
	function extendChildren(children, extendedProps, extendedChildren) {
	  return _react2.default.isValidElement(children) ? _react2.default.Children.map(children, function (child) {
	    var newProps = typeof extendedProps === 'function' ? extendedProps(child) : extendedProps;
	
	    var newChildren = typeof extendedChildren === 'function' ? extendedChildren(child) : extendedChildren ? extendedChildren : child.props.children;
	
	    return _react2.default.cloneElement(child, newProps, newChildren);
	  }) : children;
	}

/***/ }),
/* 586 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(587).create;

/***/ }),
/* 587 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(305);
	
	var ReactChildren = __webpack_require__(303);
	var ReactElement = __webpack_require__(307);
	
	var emptyFunction = __webpack_require__(310);
	var invariant = __webpack_require__(306);
	var warning = __webpack_require__(309);
	
	/**
	 * We used to allow keyed objects to serve as a collection of ReactElements,
	 * or nested sets. This allowed us a way to explicitly key a set or fragment of
	 * components. This is now being replaced with an opaque data structure.
	 * The upgrade path is to call React.addons.createFragment({ key: value }) to
	 * create a keyed fragment. The resulting data structure is an array.
	 */
	
	var numericPropertyRegex = /^\d+$/;
	
	var warnedAboutNumeric = false;
	
	var ReactFragment = {
	  /**
	   * Wrap a keyed object in an opaque proxy that warns you if you access any
	   * of its properties.
	   * See https://facebook.github.io/react/docs/create-fragment.html
	   */
	  create: function (object) {
	    if (typeof object !== 'object' || !object || Array.isArray(object)) {
	       false ? warning(false, 'React.addons.createFragment only accepts a single object. Got: %s', object) : void 0;
	      return object;
	    }
	    if (ReactElement.isValidElement(object)) {
	       false ? warning(false, 'React.addons.createFragment does not accept a ReactElement ' + 'without a wrapper object.') : void 0;
	      return object;
	    }
	
	    !(object.nodeType !== 1) ?  false ? invariant(false, 'React.addons.createFragment(...): Encountered an invalid child; DOM elements are not valid children of React components.') : _prodInvariant('0') : void 0;
	
	    var result = [];
	
	    for (var key in object) {
	      if (false) {
	        if (!warnedAboutNumeric && numericPropertyRegex.test(key)) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'React.addons.createFragment(...): Child objects should have ' + 'non-numeric keys so ordering is preserved.') : void 0;
	          warnedAboutNumeric = true;
	        }
	      }
	      ReactChildren.mapIntoWithKeyPrefixInternal(object[key], result, key, emptyFunction.thatReturnsArgument);
	    }
	
	    return result;
	  }
	};
	
	module.exports = ReactFragment;

/***/ }),
/* 588 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  once: function once(el, type, callback) {
	    var typeArray = type ? type.split(' ') : [];
	    var recursiveFunction = function recursiveFunction(event) {
	      event.target.removeEventListener(event.type, recursiveFunction);
	      return callback(event);
	    };
	
	    for (var i = typeArray.length - 1; i >= 0; i--) {
	      this.on(el, typeArray[i], recursiveFunction);
	    }
	  },
	  on: function on(el, type, callback) {
	    if (el.addEventListener) {
	      el.addEventListener(type, callback);
	    } else {
	      // IE8+ Support
	      el.attachEvent('on' + type, function () {
	        callback.call(el);
	      });
	    }
	  },
	  off: function off(el, type, callback) {
	    if (el.removeEventListener) {
	      el.removeEventListener(type, callback);
	    } else {
	      // IE8+ Support
	      el.detachEvent('on' + type, callback);
	    }
	  },
	  isKeyboard: function isKeyboard(event) {
	    return ['keydown', 'keypress', 'keyup'].indexOf(event.type) !== -1;
	  }
	};

/***/ }),
/* 589 */
/***/ (function(module, exports) {

	// Source: http://jsfiddle.net/vWx8V/
	// http://stackoverflow.com/questions/5603195/full-list-of-javascript-keycodes
	
	/**
	 * Conenience method returns corresponding value for given keyName or keyCode.
	 *
	 * @param {Mixed} keyCode {Number} or keyName {String}
	 * @return {Mixed}
	 * @api public
	 */
	
	exports = module.exports = function(searchInput) {
	  // Keyboard Events
	  if (searchInput && 'object' === typeof searchInput) {
	    var hasKeyCode = searchInput.which || searchInput.keyCode || searchInput.charCode
	    if (hasKeyCode) searchInput = hasKeyCode
	  }
	
	  // Numbers
	  if ('number' === typeof searchInput) return names[searchInput]
	
	  // Everything else (cast to string)
	  var search = String(searchInput)
	
	  // check codes
	  var foundNamedKey = codes[search.toLowerCase()]
	  if (foundNamedKey) return foundNamedKey
	
	  // check aliases
	  var foundNamedKey = aliases[search.toLowerCase()]
	  if (foundNamedKey) return foundNamedKey
	
	  // weird character?
	  if (search.length === 1) return search.charCodeAt(0)
	
	  return undefined
	}
	
	/**
	 * Get by name
	 *
	 *   exports.code['enter'] // => 13
	 */
	
	var codes = exports.code = exports.codes = {
	  'backspace': 8,
	  'tab': 9,
	  'enter': 13,
	  'shift': 16,
	  'ctrl': 17,
	  'alt': 18,
	  'pause/break': 19,
	  'caps lock': 20,
	  'esc': 27,
	  'space': 32,
	  'page up': 33,
	  'page down': 34,
	  'end': 35,
	  'home': 36,
	  'left': 37,
	  'up': 38,
	  'right': 39,
	  'down': 40,
	  'insert': 45,
	  'delete': 46,
	  'command': 91,
	  'left command': 91,
	  'right command': 93,
	  'numpad *': 106,
	  'numpad +': 107,
	  'numpad -': 109,
	  'numpad .': 110,
	  'numpad /': 111,
	  'num lock': 144,
	  'scroll lock': 145,
	  'my computer': 182,
	  'my calculator': 183,
	  ';': 186,
	  '=': 187,
	  ',': 188,
	  '-': 189,
	  '.': 190,
	  '/': 191,
	  '`': 192,
	  '[': 219,
	  '\\': 220,
	  ']': 221,
	  "'": 222
	}
	
	// Helper aliases
	
	var aliases = exports.aliases = {
	  'windows': 91,
	  '⇧': 16,
	  '⌥': 18,
	  '⌃': 17,
	  '⌘': 91,
	  'ctl': 17,
	  'control': 17,
	  'option': 18,
	  'pause': 19,
	  'break': 19,
	  'caps': 20,
	  'return': 13,
	  'escape': 27,
	  'spc': 32,
	  'pgup': 33,
	  'pgdn': 34,
	  'ins': 45,
	  'del': 46,
	  'cmd': 91
	}
	
	
	/*!
	 * Programatically add the following
	 */
	
	// lower case chars
	for (i = 97; i < 123; i++) codes[String.fromCharCode(i)] = i - 32
	
	// numbers
	for (var i = 48; i < 58; i++) codes[i - 48] = i
	
	// function keys
	for (i = 1; i < 13; i++) codes['f'+i] = i + 111
	
	// numpad keys
	for (i = 0; i < 10; i++) codes['numpad '+i] = i + 96
	
	/**
	 * Get by code
	 *
	 *   exports.name[13] // => 'Enter'
	 */
	
	var names = exports.names = exports.title = {} // title for backward compat
	
	// Create reverse mapping
	for (i in codes) names[codes[i]] = i
	
	// Add aliases
	for (var alias in aliases) {
	  codes[alias] = aliases[alias]
	}


/***/ }),
/* 590 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _simpleAssign = __webpack_require__(579);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(332);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _shallowEqual = __webpack_require__(591);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	var _autoPrefix = __webpack_require__(593);
	
	var _autoPrefix2 = _interopRequireDefault(_autoPrefix);
	
	var _transitions = __webpack_require__(582);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _ScaleIn = __webpack_require__(594);
	
	var _ScaleIn2 = _interopRequireDefault(_ScaleIn);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var pulsateDuration = 750;
	
	var FocusRipple = function (_Component) {
	  _inherits(FocusRipple, _Component);
	
	  function FocusRipple() {
	    var _Object$getPrototypeO;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, FocusRipple);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_Object$getPrototypeO = Object.getPrototypeOf(FocusRipple)).call.apply(_Object$getPrototypeO, [this].concat(args))), _this), _this.pulsate = function () {
	      var innerCircle = _reactDom2.default.findDOMNode(_this.refs.innerCircle);
	      if (!innerCircle) return;
	
	      var startScale = 'scale(1)';
	      var endScale = 'scale(0.85)';
	      var currentScale = innerCircle.style.transform || startScale;
	      var nextScale = currentScale === startScale ? endScale : startScale;
	
	      _autoPrefix2.default.set(innerCircle.style, 'transform', nextScale);
	      _this.timeout = setTimeout(_this.pulsate, pulsateDuration);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(FocusRipple, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (this.props.show) {
	        this.setRippleSize();
	        this.pulsate();
	      }
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      return !(0, _shallowEqual2.default)(this.props, nextProps) || !(0, _shallowEqual2.default)(this.state, nextState);
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      if (this.props.show) {
	        this.setRippleSize();
	        this.pulsate();
	      } else {
	        if (this.timeout) clearTimeout(this.timeout);
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      clearTimeout(this.timeout);
	    }
	  }, {
	    key: 'getRippleElement',
	    value: function getRippleElement(props) {
	      var color = props.color;
	      var innerStyle = props.innerStyle;
	      var opacity = props.opacity;
	      var _context$muiTheme = this.context.muiTheme;
	      var prepareStyles = _context$muiTheme.prepareStyles;
	      var ripple = _context$muiTheme.ripple;
	
	
	      var innerStyles = (0, _simpleAssign2.default)({
	        position: 'absolute',
	        height: '100%',
	        width: '100%',
	        borderRadius: '50%',
	        opacity: opacity ? opacity : 0.16,
	        backgroundColor: color || ripple.color,
	        transition: _transitions2.default.easeOut(pulsateDuration + 'ms', 'transform', null, _transitions2.default.easeInOutFunction)
	      }, innerStyle);
	
	      return _react2.default.createElement('div', { ref: 'innerCircle', style: prepareStyles((0, _simpleAssign2.default)({}, innerStyles)) });
	    }
	  }, {
	    key: 'setRippleSize',
	    value: function setRippleSize() {
	      var el = _reactDom2.default.findDOMNode(this.refs.innerCircle);
	      var height = el.offsetHeight;
	      var width = el.offsetWidth;
	      var size = Math.max(height, width);
	
	      var oldTop = 0;
	      // For browsers that don't support endsWith()
	      if (el.style.top.indexOf('px', el.style.top.length - 2) !== -1) {
	        oldTop = parseInt(el.style.top);
	      }
	      el.style.height = size + 'px';
	      el.style.top = height / 2 - size / 2 + oldTop + 'px';
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var show = _props.show;
	      var style = _props.style;
	
	
	      var mergedRootStyles = (0, _simpleAssign2.default)({
	        height: '100%',
	        width: '100%',
	        position: 'absolute',
	        top: 0,
	        left: 0
	      }, style);
	
	      var ripple = show ? this.getRippleElement(this.props) : null;
	
	      return _react2.default.createElement(
	        _ScaleIn2.default,
	        {
	          maxScale: 0.85,
	          style: mergedRootStyles
	        },
	        ripple
	      );
	    }
	  }]);
	
	  return FocusRipple;
	}(_react.Component);
	
	FocusRipple.propTypes = {
	  color: _react.PropTypes.string,
	  innerStyle: _react.PropTypes.object,
	  opacity: _react.PropTypes.number,
	  show: _react.PropTypes.bool,
	  style: _react.PropTypes.object
	};
	FocusRipple.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	exports.default = FocusRipple;

/***/ }),
/* 591 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _shallowEqual = __webpack_require__(592);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _shallowEqual2.default;

/***/ }),
/* 592 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 * 
	 */
	
	/*eslint-disable no-self-compare */
	
	'use strict';
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	/**
	 * inlined Object.is polyfill to avoid requiring consumers ship their own
	 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	 */
	function is(x, y) {
	  // SameValue algorithm
	  if (x === y) {
	    // Steps 1-5, 7-10
	    // Steps 6.b-6.e: +0 != -0
	    return x !== 0 || 1 / x === 1 / y;
	  } else {
	    // Step 6.a: NaN == NaN
	    return x !== x && y !== y;
	  }
	}
	
	/**
	 * Performs equality by iterating through keys on an object and returning false
	 * when any key has values which are not strictly equal between the arguments.
	 * Returns true when the values of all keys are strictly equal.
	 */
	function shallowEqual(objA, objB) {
	  if (is(objA, objB)) {
	    return true;
	  }
	
	  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  // Test for A's keys different from B.
	  for (var i = 0; i < keysA.length; i++) {
	    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	module.exports = shallowEqual;

/***/ }),
/* 593 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  set: function set(style, key, value) {
	    style[key] = value;
	  }
	};

/***/ }),
/* 594 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _simpleAssign = __webpack_require__(579);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactAddonsTransitionGroup = __webpack_require__(595);
	
	var _reactAddonsTransitionGroup2 = _interopRequireDefault(_reactAddonsTransitionGroup);
	
	var _ScaleInChild = __webpack_require__(599);
	
	var _ScaleInChild2 = _interopRequireDefault(_ScaleInChild);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ScaleIn = function (_Component) {
	  _inherits(ScaleIn, _Component);
	
	  function ScaleIn() {
	    _classCallCheck(this, ScaleIn);
	
	    return _possibleConstructorReturn(this, Object.getPrototypeOf(ScaleIn).apply(this, arguments));
	  }
	
	  _createClass(ScaleIn, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var children = _props.children;
	      var childStyle = _props.childStyle;
	      var enterDelay = _props.enterDelay;
	      var maxScale = _props.maxScale;
	      var minScale = _props.minScale;
	      var style = _props.style;
	
	      var other = _objectWithoutProperties(_props, ['children', 'childStyle', 'enterDelay', 'maxScale', 'minScale', 'style']);
	
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	
	      var mergedRootStyles = (0, _simpleAssign2.default)({}, {
	        position: 'relative',
	        overflow: 'hidden',
	        height: '100%'
	      }, style);
	
	      var newChildren = _react2.default.Children.map(children, function (child) {
	        return _react2.default.createElement(
	          _ScaleInChild2.default,
	          {
	            key: child.key,
	            enterDelay: enterDelay,
	            maxScale: maxScale,
	            minScale: minScale,
	            style: childStyle
	          },
	          child
	        );
	      });
	
	      return _react2.default.createElement(
	        _reactAddonsTransitionGroup2.default,
	        _extends({}, other, {
	          style: prepareStyles(mergedRootStyles),
	          component: 'div'
	        }),
	        newChildren
	      );
	    }
	  }]);
	
	  return ScaleIn;
	}(_react.Component);
	
	ScaleIn.propTypes = {
	  childStyle: _react.PropTypes.object,
	  children: _react.PropTypes.node,
	  enterDelay: _react.PropTypes.number,
	  maxScale: _react.PropTypes.number,
	  minScale: _react.PropTypes.number,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object
	};
	ScaleIn.defaultProps = {
	  enterDelay: 0
	};
	ScaleIn.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	exports.default = ScaleIn;

/***/ }),
/* 595 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(596);

/***/ }),
/* 596 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(302);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var React = __webpack_require__(301);
	var ReactTransitionChildMapping = __webpack_require__(597);
	
	var propTypesFactory = __webpack_require__(324);
	var PropTypes = propTypesFactory(React.isValidElement);
	
	var emptyFunction = __webpack_require__(310);
	
	/**
	 * A basis for animations. When children are declaratively added or removed,
	 * special lifecycle hooks are called.
	 * See https://facebook.github.io/react/docs/animation.html#low-level-api-reacttransitiongroup
	 */
	
	var ReactTransitionGroup = function (_React$Component) {
	  _inherits(ReactTransitionGroup, _React$Component);
	
	  function ReactTransitionGroup() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ReactTransitionGroup);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
	      // TODO: can we get useful debug information to show at this point?
	      children: ReactTransitionChildMapping.getChildMapping(_this.props.children)
	    }, _this.performAppear = function (key) {
	      _this.currentlyTransitioningKeys[key] = true;
	
	      var component = _this.refs[key];
	
	      if (component.componentWillAppear) {
	        component.componentWillAppear(_this._handleDoneAppearing.bind(_this, key));
	      } else {
	        _this._handleDoneAppearing(key);
	      }
	    }, _this._handleDoneAppearing = function (key) {
	      var component = _this.refs[key];
	      if (component.componentDidAppear) {
	        component.componentDidAppear();
	      }
	
	      delete _this.currentlyTransitioningKeys[key];
	
	      var currentChildMapping = ReactTransitionChildMapping.getChildMapping(_this.props.children);
	
	      if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) {
	        // This was removed before it had fully appeared. Remove it.
	        _this.performLeave(key);
	      }
	    }, _this.performEnter = function (key) {
	      _this.currentlyTransitioningKeys[key] = true;
	
	      var component = _this.refs[key];
	
	      if (component.componentWillEnter) {
	        component.componentWillEnter(_this._handleDoneEntering.bind(_this, key));
	      } else {
	        _this._handleDoneEntering(key);
	      }
	    }, _this._handleDoneEntering = function (key) {
	      var component = _this.refs[key];
	      if (component.componentDidEnter) {
	        component.componentDidEnter();
	      }
	
	      delete _this.currentlyTransitioningKeys[key];
	
	      var currentChildMapping = ReactTransitionChildMapping.getChildMapping(_this.props.children);
	
	      if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) {
	        // This was removed before it had fully entered. Remove it.
	        _this.performLeave(key);
	      }
	    }, _this.performLeave = function (key) {
	      _this.currentlyTransitioningKeys[key] = true;
	
	      var component = _this.refs[key];
	      if (component.componentWillLeave) {
	        component.componentWillLeave(_this._handleDoneLeaving.bind(_this, key));
	      } else {
	        // Note that this is somewhat dangerous b/c it calls setState()
	        // again, effectively mutating the component before all the work
	        // is done.
	        _this._handleDoneLeaving(key);
	      }
	    }, _this._handleDoneLeaving = function (key) {
	      var component = _this.refs[key];
	
	      if (component.componentDidLeave) {
	        component.componentDidLeave();
	      }
	
	      delete _this.currentlyTransitioningKeys[key];
	
	      var currentChildMapping = ReactTransitionChildMapping.getChildMapping(_this.props.children);
	
	      if (currentChildMapping && currentChildMapping.hasOwnProperty(key)) {
	        // This entered again before it fully left. Add it again.
	        _this.performEnter(key);
	      } else {
	        _this.setState(function (state) {
	          var newChildren = _assign({}, state.children);
	          delete newChildren[key];
	          return { children: newChildren };
	        });
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  ReactTransitionGroup.prototype.componentWillMount = function componentWillMount() {
	    this.currentlyTransitioningKeys = {};
	    this.keysToEnter = [];
	    this.keysToLeave = [];
	  };
	
	  ReactTransitionGroup.prototype.componentDidMount = function componentDidMount() {
	    var initialChildMapping = this.state.children;
	    for (var key in initialChildMapping) {
	      if (initialChildMapping[key]) {
	        this.performAppear(key);
	      }
	    }
	  };
	
	  ReactTransitionGroup.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    var nextChildMapping = ReactTransitionChildMapping.getChildMapping(nextProps.children);
	    var prevChildMapping = this.state.children;
	
	    this.setState({
	      children: ReactTransitionChildMapping.mergeChildMappings(prevChildMapping, nextChildMapping)
	    });
	
	    var key;
	
	    for (key in nextChildMapping) {
	      var hasPrev = prevChildMapping && prevChildMapping.hasOwnProperty(key);
	      if (nextChildMapping[key] && !hasPrev && !this.currentlyTransitioningKeys[key]) {
	        this.keysToEnter.push(key);
	      }
	    }
	
	    for (key in prevChildMapping) {
	      var hasNext = nextChildMapping && nextChildMapping.hasOwnProperty(key);
	      if (prevChildMapping[key] && !hasNext && !this.currentlyTransitioningKeys[key]) {
	        this.keysToLeave.push(key);
	      }
	    }
	
	    // If we want to someday check for reordering, we could do it here.
	  };
	
	  ReactTransitionGroup.prototype.componentDidUpdate = function componentDidUpdate() {
	    var keysToEnter = this.keysToEnter;
	    this.keysToEnter = [];
	    keysToEnter.forEach(this.performEnter);
	
	    var keysToLeave = this.keysToLeave;
	    this.keysToLeave = [];
	    keysToLeave.forEach(this.performLeave);
	  };
	
	  ReactTransitionGroup.prototype.render = function render() {
	    // TODO: we could get rid of the need for the wrapper node
	    // by cloning a single child
	    var childrenToRender = [];
	    for (var key in this.state.children) {
	      var child = this.state.children[key];
	      if (child) {
	        // You may need to apply reactive updates to a child as it is leaving.
	        // The normal React way to do it won't work since the child will have
	        // already been removed. In case you need this behavior you can provide
	        // a childFactory function to wrap every child, even the ones that are
	        // leaving.
	        childrenToRender.push(React.cloneElement(this.props.childFactory(child), { ref: key, key: key }));
	      }
	    }
	
	    // Do not forward ReactTransitionGroup props to primitive DOM nodes
	    var props = _assign({}, this.props);
	    delete props.transitionLeave;
	    delete props.transitionName;
	    delete props.transitionAppear;
	    delete props.transitionEnter;
	    delete props.childFactory;
	    delete props.transitionLeaveTimeout;
	    delete props.transitionEnterTimeout;
	    delete props.transitionAppearTimeout;
	    delete props.component;
	
	    return React.createElement(this.props.component, props, childrenToRender);
	  };
	
	  return ReactTransitionGroup;
	}(React.Component);
	
	ReactTransitionGroup.displayName = 'ReactTransitionGroup';
	ReactTransitionGroup.propTypes = {
	  component: PropTypes.any,
	  childFactory: PropTypes.func
	};
	ReactTransitionGroup.defaultProps = {
	  component: 'span',
	  childFactory: emptyFunction.thatReturnsArgument
	};
	
	
	module.exports = ReactTransitionGroup;

/***/ }),
/* 597 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var flattenChildren = __webpack_require__(598);
	
	var ReactTransitionChildMapping = {
	  /**
	   * Given `this.props.children`, return an object mapping key to child. Just
	   * simple syntactic sugar around flattenChildren().
	   *
	   * @param {*} children `this.props.children`
	   * @param {number=} selfDebugID Optional debugID of the current internal instance.
	   * @return {object} Mapping of key to child
	   */
	  getChildMapping: function (children, selfDebugID) {
	    if (!children) {
	      return children;
	    }
	
	    if (false) {
	      return flattenChildren(children, selfDebugID);
	    }
	
	    return flattenChildren(children);
	  },
	
	  /**
	   * When you're adding or removing children some may be added or removed in the
	   * same render pass. We want to show *both* since we want to simultaneously
	   * animate elements in and out. This function takes a previous set of keys
	   * and a new set of keys and merges them with its best guess of the correct
	   * ordering. In the future we may expose some of the utilities in
	   * ReactMultiChild to make this easy, but for now React itself does not
	   * directly have this concept of the union of prevChildren and nextChildren
	   * so we implement it here.
	   *
	   * @param {object} prev prev children as returned from
	   * `ReactTransitionChildMapping.getChildMapping()`.
	   * @param {object} next next children as returned from
	   * `ReactTransitionChildMapping.getChildMapping()`.
	   * @return {object} a key set that contains all keys in `prev` and all keys
	   * in `next` in a reasonable order.
	   */
	  mergeChildMappings: function (prev, next) {
	    prev = prev || {};
	    next = next || {};
	
	    function getValueForKey(key) {
	      if (next.hasOwnProperty(key)) {
	        return next[key];
	      } else {
	        return prev[key];
	      }
	    }
	
	    // For each key of `next`, the list of keys to insert before that key in
	    // the combined list
	    var nextKeysPending = {};
	
	    var pendingKeys = [];
	    for (var prevKey in prev) {
	      if (next.hasOwnProperty(prevKey)) {
	        if (pendingKeys.length) {
	          nextKeysPending[prevKey] = pendingKeys;
	          pendingKeys = [];
	        }
	      } else {
	        pendingKeys.push(prevKey);
	      }
	    }
	
	    var i;
	    var childMapping = {};
	    for (var nextKey in next) {
	      if (nextKeysPending.hasOwnProperty(nextKey)) {
	        for (i = 0; i < nextKeysPending[nextKey].length; i++) {
	          var pendingNextKey = nextKeysPending[nextKey][i];
	          childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
	        }
	      }
	      childMapping[nextKey] = getValueForKey(nextKey);
	    }
	
	    // Finally, add the keys which didn't appear before any key in `next`
	    for (i = 0; i < pendingKeys.length; i++) {
	      childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
	    }
	
	    return childMapping;
	  }
	};
	
	module.exports = ReactTransitionChildMapping;

/***/ }),
/* 598 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var KeyEscapeUtils = __webpack_require__(315);
	var traverseAllChildren = __webpack_require__(313);
	var warning = __webpack_require__(309);
	
	var ReactComponentTreeHook;
	
	if (typeof process !== 'undefined' && process.env && ("production") === 'test') {
	  // Temporary hack.
	  // Inline requires don't work well with Jest:
	  // https://github.com/facebook/react/issues/7240
	  // Remove the inline requires when we don't need them anymore:
	  // https://github.com/facebook/react/pull/7178
	  ReactComponentTreeHook = __webpack_require__(433);
	}
	
	/**
	 * @param {function} traverseContext Context passed through traversal.
	 * @param {?ReactComponent} child React child component.
	 * @param {!string} name String name of key path to child.
	 * @param {number=} selfDebugID Optional debugID of the current internal instance.
	 */
	function flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID) {
	  // We found a component instance.
	  if (traverseContext && typeof traverseContext === 'object') {
	    var result = traverseContext;
	    var keyUnique = result[name] === undefined;
	    if (false) {
	      if (!ReactComponentTreeHook) {
	        ReactComponentTreeHook = require('./ReactComponentTreeHook');
	      }
	      if (!keyUnique) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
	      }
	    }
	    if (keyUnique && child != null) {
	      result[name] = child;
	    }
	  }
	}
	
	/**
	 * Flattens children that are typically specified as `props.children`. Any null
	 * children will not be included in the resulting object.
	 * @return {!object} flattened children keyed by name.
	 */
	function flattenChildren(children, selfDebugID) {
	  if (children == null) {
	    return children;
	  }
	  var result = {};
	
	  if (false) {
	    traverseAllChildren(children, function (traverseContext, child, name) {
	      return flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID);
	    }, result);
	  } else {
	    traverseAllChildren(children, flattenSingleChildIntoContext, result);
	  }
	  return result;
	}
	
	module.exports = flattenChildren;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(294)))

/***/ }),
/* 599 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _simpleAssign = __webpack_require__(579);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(332);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _autoPrefix = __webpack_require__(593);
	
	var _autoPrefix2 = _interopRequireDefault(_autoPrefix);
	
	var _transitions = __webpack_require__(582);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ScaleInChild = function (_Component) {
	  _inherits(ScaleInChild, _Component);
	
	  function ScaleInChild() {
	    _classCallCheck(this, ScaleInChild);
	
	    return _possibleConstructorReturn(this, Object.getPrototypeOf(ScaleInChild).apply(this, arguments));
	  }
	
	  _createClass(ScaleInChild, [{
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      clearTimeout(this.enterTimer);
	      clearTimeout(this.leaveTimer);
	    }
	  }, {
	    key: 'componentWillAppear',
	    value: function componentWillAppear(callback) {
	      this.initializeAnimation(callback);
	    }
	  }, {
	    key: 'componentWillEnter',
	    value: function componentWillEnter(callback) {
	      this.initializeAnimation(callback);
	    }
	  }, {
	    key: 'componentDidAppear',
	    value: function componentDidAppear() {
	      this.animate();
	    }
	  }, {
	    key: 'componentDidEnter',
	    value: function componentDidEnter() {
	      this.animate();
	    }
	  }, {
	    key: 'componentWillLeave',
	    value: function componentWillLeave(callback) {
	      var style = _reactDom2.default.findDOMNode(this).style;
	
	      style.opacity = '0';
	      _autoPrefix2.default.set(style, 'transform', 'scale(' + this.props.minScale + ')');
	
	      this.leaveTimer = setTimeout(callback, 450);
	    }
	  }, {
	    key: 'animate',
	    value: function animate() {
	      var style = _reactDom2.default.findDOMNode(this).style;
	
	      style.opacity = '1';
	      _autoPrefix2.default.set(style, 'transform', 'scale(' + this.props.maxScale + ')');
	    }
	  }, {
	    key: 'initializeAnimation',
	    value: function initializeAnimation(callback) {
	      var style = _reactDom2.default.findDOMNode(this).style;
	
	      style.opacity = '0';
	      _autoPrefix2.default.set(style, 'transform', 'scale(0)');
	
	      this.enterTimer = setTimeout(callback, this.props.enterDelay);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var children = _props.children;
	      var enterDelay = _props.enterDelay;
	      var maxScale = _props.maxScale;
	      var minScale = _props.minScale;
	      var style = _props.style;
	
	      var other = _objectWithoutProperties(_props, ['children', 'enterDelay', 'maxScale', 'minScale', 'style']);
	
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	
	      var mergedRootStyles = (0, _simpleAssign2.default)({}, {
	        position: 'absolute',
	        height: '100%',
	        width: '100%',
	        top: 0,
	        left: 0,
	        transition: _transitions2.default.easeOut(null, ['transform', 'opacity'])
	      }, style);
	
	      return _react2.default.createElement(
	        'div',
	        _extends({}, other, { style: prepareStyles(mergedRootStyles) }),
	        children
	      );
	    }
	  }]);
	
	  return ScaleInChild;
	}(_react.Component);
	
	ScaleInChild.propTypes = {
	  children: _react.PropTypes.node,
	  enterDelay: _react.PropTypes.number,
	  maxScale: _react.PropTypes.number,
	  minScale: _react.PropTypes.number,
	  style: _react.PropTypes.object
	};
	ScaleInChild.defaultProps = {
	  enterDelay: 0,
	  maxScale: 1,
	  minScale: 0
	};
	ScaleInChild.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	exports.default = ScaleInChild;

/***/ }),
/* 600 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _simpleAssign = __webpack_require__(579);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(332);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reactAddonsTransitionGroup = __webpack_require__(595);
	
	var _reactAddonsTransitionGroup2 = _interopRequireDefault(_reactAddonsTransitionGroup);
	
	var _dom = __webpack_require__(601);
	
	var _dom2 = _interopRequireDefault(_dom);
	
	var _CircleRipple = __webpack_require__(602);
	
	var _CircleRipple2 = _interopRequireDefault(_CircleRipple);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _toArray(arr) { return Array.isArray(arr) ? arr : Array.from(arr); }
	
	// Remove the first element of the array
	var shift = function shift(_ref) {
	  var _ref2 = _toArray(_ref);
	
	  var newArray = _ref2.slice(1);
	
	  return newArray;
	};
	
	var TouchRipple = function (_Component) {
	  _inherits(TouchRipple, _Component);
	
	  function TouchRipple(props, context) {
	    _classCallCheck(this, TouchRipple);
	
	    // Touch start produces a mouse down event for compat reasons. To avoid
	    // showing ripples twice we skip showing a ripple for the first mouse down
	    // after a touch start. Note we don't store ignoreNextMouseDown in this.state
	    // to avoid re-rendering when we change it.
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(TouchRipple).call(this, props, context));
	
	    _this.handleMouseDown = function (event) {
	      // only listen to left clicks
	      if (event.button === 0) {
	        _this.start(event, false);
	      }
	    };
	
	    _this.handleMouseUp = function () {
	      _this.end();
	    };
	
	    _this.handleMouseLeave = function () {
	      _this.end();
	    };
	
	    _this.handleTouchStart = function (event) {
	      event.stopPropagation();
	      // If the user is swiping (not just tapping), save the position so we can
	      // abort ripples if the user appears to be scrolling.
	      if (_this.props.abortOnScroll && event.touches) {
	        _this.startListeningForScrollAbort(event);
	        _this.startTime = Date.now();
	      }
	      _this.start(event, true);
	    };
	
	    _this.handleTouchEnd = function () {
	      _this.end();
	    };
	
	    _this.handleTouchMove = function (event) {
	      // Stop trying to abort if we're already 300ms into the animation
	      var timeSinceStart = Math.abs(Date.now() - _this.startTime);
	      if (timeSinceStart > 300) {
	        _this.stopListeningForScrollAbort();
	        return;
	      }
	
	      // If the user is scrolling...
	      var deltaY = Math.abs(event.touches[0].clientY - _this.firstTouchY);
	      var deltaX = Math.abs(event.touches[0].clientX - _this.firstTouchX);
	      // Call it a scroll after an arbitrary 6px (feels reasonable in testing)
	      if (deltaY > 6 || deltaX > 6) {
	        var currentRipples = _this.state.ripples;
	        var ripple = currentRipples[0];
	        // This clone will replace the ripple in ReactTransitionGroup with a
	        // version that will disappear immediately when removed from the DOM
	        var abortedRipple = _react2.default.cloneElement(ripple, { aborted: true });
	        // Remove the old ripple and replace it with the new updated one
	        currentRipples = shift(currentRipples);
	        currentRipples = [].concat(_toConsumableArray(currentRipples), [abortedRipple]);
	        _this.setState({ ripples: currentRipples }, function () {
	          // Call end after we've set the ripple to abort otherwise the setState
	          // in end() merges with this and the ripple abort fails
	          _this.end();
	        });
	      }
	    };
	
	    _this.ignoreNextMouseDown = false;
	
	    _this.state = {
	      // This prop allows us to only render the ReactTransitionGroup
	      // on the first click of the component, making the inital render faster.
	      hasRipples: false,
	      nextKey: 0,
	      ripples: []
	    };
	    return _this;
	  }
	
	  _createClass(TouchRipple, [{
	    key: 'start',
	    value: function start(event, isRippleTouchGenerated) {
	      var theme = this.context.muiTheme.ripple;
	
	      if (this.ignoreNextMouseDown && !isRippleTouchGenerated) {
	        this.ignoreNextMouseDown = false;
	        return;
	      }
	
	      var ripples = this.state.ripples;
	
	      // Add a ripple to the ripples array
	      ripples = [].concat(_toConsumableArray(ripples), [_react2.default.createElement(_CircleRipple2.default, {
	        key: this.state.nextKey,
	        style: !this.props.centerRipple ? this.getRippleStyle(event) : {},
	        color: this.props.color || theme.color,
	        opacity: this.props.opacity,
	        touchGenerated: isRippleTouchGenerated
	      })]);
	
	      this.ignoreNextMouseDown = isRippleTouchGenerated;
	      this.setState({
	        hasRipples: true,
	        nextKey: this.state.nextKey + 1,
	        ripples: ripples
	      });
	    }
	  }, {
	    key: 'end',
	    value: function end() {
	      var currentRipples = this.state.ripples;
	      this.setState({
	        ripples: shift(currentRipples)
	      });
	      if (this.props.abortOnScroll) {
	        this.stopListeningForScrollAbort();
	      }
	    }
	
	    // Check if the user seems to be scrolling and abort the animation if so
	
	  }, {
	    key: 'startListeningForScrollAbort',
	    value: function startListeningForScrollAbort(event) {
	      this.firstTouchY = event.touches[0].clientY;
	      this.firstTouchX = event.touches[0].clientX;
	      // Note that when scolling Chrome throttles this event to every 200ms
	      // Also note we don't listen for scroll events directly as there's no general
	      // way to cover cases like scrolling within containers on the page
	      document.body.addEventListener('touchmove', this.handleTouchMove);
	    }
	  }, {
	    key: 'stopListeningForScrollAbort',
	    value: function stopListeningForScrollAbort() {
	      document.body.removeEventListener('touchmove', this.handleTouchMove);
	    }
	  }, {
	    key: 'getRippleStyle',
	    value: function getRippleStyle(event) {
	      var style = {};
	      var el = _reactDom2.default.findDOMNode(this);
	      var elHeight = el.offsetHeight;
	      var elWidth = el.offsetWidth;
	      var offset = _dom2.default.offset(el);
	      var isTouchEvent = event.touches && event.touches.length;
	      var pageX = isTouchEvent ? event.touches[0].pageX : event.pageX;
	      var pageY = isTouchEvent ? event.touches[0].pageY : event.pageY;
	      var pointerX = pageX - offset.left;
	      var pointerY = pageY - offset.top;
	      var topLeftDiag = this.calcDiag(pointerX, pointerY);
	      var topRightDiag = this.calcDiag(elWidth - pointerX, pointerY);
	      var botRightDiag = this.calcDiag(elWidth - pointerX, elHeight - pointerY);
	      var botLeftDiag = this.calcDiag(pointerX, elHeight - pointerY);
	      var rippleRadius = Math.max(topLeftDiag, topRightDiag, botRightDiag, botLeftDiag);
	      var rippleSize = rippleRadius * 2;
	      var left = pointerX - rippleRadius;
	      var top = pointerY - rippleRadius;
	
	      style.height = rippleSize + 'px';
	      style.width = rippleSize + 'px';
	      style.top = top + 'px';
	      style.left = left + 'px';
	
	      return style;
	    }
	  }, {
	    key: 'calcDiag',
	    value: function calcDiag(a, b) {
	      return Math.sqrt(a * a + b * b);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var children = _props.children;
	      var style = _props.style;
	      var _state = this.state;
	      var hasRipples = _state.hasRipples;
	      var ripples = _state.ripples;
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	
	      var rippleGroup = void 0;
	
	      if (hasRipples) {
	        var mergedStyles = (0, _simpleAssign2.default)({
	          height: '100%',
	          width: '100%',
	          position: 'absolute',
	          top: 0,
	          left: 0,
	          overflow: 'hidden'
	        }, style);
	
	        rippleGroup = _react2.default.createElement(
	          _reactAddonsTransitionGroup2.default,
	          { style: prepareStyles(mergedStyles) },
	          ripples
	        );
	      }
	
	      return _react2.default.createElement(
	        'div',
	        {
	          onMouseUp: this.handleMouseUp,
	          onMouseDown: this.handleMouseDown,
	          onMouseLeave: this.handleMouseLeave,
	          onTouchStart: this.handleTouchStart,
	          onTouchEnd: this.handleTouchEnd
	        },
	        rippleGroup,
	        children
	      );
	    }
	  }]);
	
	  return TouchRipple;
	}(_react.Component);
	
	TouchRipple.propTypes = {
	  abortOnScroll: _react.PropTypes.bool,
	  centerRipple: _react.PropTypes.bool,
	  children: _react.PropTypes.node,
	  color: _react.PropTypes.string,
	  opacity: _react.PropTypes.number,
	  style: _react.PropTypes.object
	};
	TouchRipple.defaultProps = {
	  abortOnScroll: true
	};
	TouchRipple.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	exports.default = TouchRipple;

/***/ }),
/* 601 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  isDescendant: function isDescendant(parent, child) {
	    var node = child.parentNode;
	
	    while (node !== null) {
	      if (node === parent) return true;
	      node = node.parentNode;
	    }
	
	    return false;
	  },
	  offset: function offset(el) {
	    var rect = el.getBoundingClientRect();
	    return {
	      top: rect.top + document.body.scrollTop,
	      left: rect.left + document.body.scrollLeft
	    };
	  }
	};

/***/ }),
/* 602 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _simpleAssign = __webpack_require__(579);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(332);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _shallowEqual = __webpack_require__(591);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	var _autoPrefix = __webpack_require__(593);
	
	var _autoPrefix2 = _interopRequireDefault(_autoPrefix);
	
	var _transitions = __webpack_require__(582);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CircleRipple = function (_Component) {
	  _inherits(CircleRipple, _Component);
	
	  function CircleRipple() {
	    _classCallCheck(this, CircleRipple);
	
	    return _possibleConstructorReturn(this, Object.getPrototypeOf(CircleRipple).apply(this, arguments));
	  }
	
	  _createClass(CircleRipple, [{
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps) {
	      return !(0, _shallowEqual2.default)(this.props, nextProps);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      clearTimeout(this.enterTimer);
	      clearTimeout(this.leaveTimer);
	    }
	  }, {
	    key: 'componentWillAppear',
	    value: function componentWillAppear(callback) {
	      this.initializeAnimation(callback);
	    }
	  }, {
	    key: 'componentWillEnter',
	    value: function componentWillEnter(callback) {
	      this.initializeAnimation(callback);
	    }
	  }, {
	    key: 'componentDidAppear',
	    value: function componentDidAppear() {
	      this.animate();
	    }
	  }, {
	    key: 'componentDidEnter',
	    value: function componentDidEnter() {
	      this.animate();
	    }
	  }, {
	    key: 'componentWillLeave',
	    value: function componentWillLeave(callback) {
	      var style = _reactDom2.default.findDOMNode(this).style;
	      style.opacity = 0;
	      // If the animation is aborted, remove from the DOM immediately
	      var removeAfter = this.props.aborted ? 0 : 2000;
	      this.enterTimer = setTimeout(callback, removeAfter);
	    }
	  }, {
	    key: 'animate',
	    value: function animate() {
	      var style = _reactDom2.default.findDOMNode(this).style;
	      var transitionValue = _transitions2.default.easeOut('2s', 'opacity') + ', ' + _transitions2.default.easeOut('1s', 'transform');
	      _autoPrefix2.default.set(style, 'transition', transitionValue);
	      _autoPrefix2.default.set(style, 'transform', 'scale(1)');
	    }
	  }, {
	    key: 'initializeAnimation',
	    value: function initializeAnimation(callback) {
	      var style = _reactDom2.default.findDOMNode(this).style;
	      style.opacity = this.props.opacity;
	      _autoPrefix2.default.set(style, 'transform', 'scale(0)');
	      this.leaveTimer = setTimeout(callback, 0);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var aborted = _props.aborted;
	      var color = _props.color;
	      var opacity = _props.opacity;
	      var style = _props.style;
	      var touchGenerated = _props.touchGenerated;
	
	      var other = _objectWithoutProperties(_props, ['aborted', 'color', 'opacity', 'style', 'touchGenerated']);
	
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	
	      var mergedStyles = (0, _simpleAssign2.default)({
	        position: 'absolute',
	        top: 0,
	        left: 0,
	        height: '100%',
	        width: '100%',
	        borderRadius: '50%',
	        backgroundColor: color
	      }, style);
	
	      return _react2.default.createElement('div', _extends({}, other, { style: prepareStyles(mergedStyles) }));
	    }
	  }]);
	
	  return CircleRipple;
	}(_react.Component);
	
	CircleRipple.propTypes = {
	  aborted: _react.PropTypes.bool,
	  color: _react.PropTypes.string,
	  opacity: _react.PropTypes.number,
	  style: _react.PropTypes.object,
	  touchGenerated: _react.PropTypes.bool
	};
	CircleRipple.defaultProps = {
	  opacity: 0.1,
	  aborted: false
	};
	CircleRipple.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	exports.default = CircleRipple;

/***/ }),
/* 603 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = deprecated;
	
	var _warning = __webpack_require__(491);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var warned = {}; /**
	                  * This module is taken from https://github.com/react-bootstrap/react-prop-types.
	                  * It's not a dependency to reduce build size / install time.
	                  * It should be pretty stable.
	                  */
	function deprecated(validator, reason) {
	  return function validate(props, propName, componentName, location, propFullName) {
	    var componentNameSafe = componentName || '<<anonymous>>';
	    var propFullNameSafe = propFullName || propName;
	
	    if (props[propName] != null) {
	      var messageKey = componentName + '.' + propName;
	
	       false ? (0, _warning2.default)(warned[messageKey], 'The ' + location + ' `' + propFullNameSafe + '` of ' + ('`' + componentNameSafe + '` is deprecated. ' + reason)) : void 0;
	
	      warned[messageKey] = true;
	    }
	
	    for (var _len = arguments.length, args = Array(_len > 5 ? _len - 5 : 0), _key = 5; _key < _len; _key++) {
	      args[_key - 5] = arguments[_key];
	    }
	
	    return validator.apply(undefined, [props, propName, componentName, location, propFullName].concat(args));
	  };
	}

/***/ }),
/* 604 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _FontIcon = __webpack_require__(605);
	
	var _FontIcon2 = _interopRequireDefault(_FontIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _FontIcon2.default;

/***/ }),
/* 605 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _simpleAssign = __webpack_require__(579);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _transitions = __webpack_require__(582);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function getStyles(props, context, state) {
	  var color = props.color;
	  var hoverColor = props.hoverColor;
	  var baseTheme = context.muiTheme.baseTheme;
	
	  var offColor = color || baseTheme.palette.textColor;
	  var onColor = hoverColor || offColor;
	
	  return {
	    root: {
	      color: state.hovered ? onColor : offColor,
	      position: 'relative',
	      fontSize: baseTheme.spacing.iconSize,
	      display: 'inline-block',
	      userSelect: 'none',
	      transition: _transitions2.default.easeOut()
	    }
	  };
	}
	
	var FontIcon = function (_Component) {
	  _inherits(FontIcon, _Component);
	
	  function FontIcon() {
	    var _Object$getPrototypeO;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, FontIcon);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_Object$getPrototypeO = Object.getPrototypeOf(FontIcon)).call.apply(_Object$getPrototypeO, [this].concat(args))), _this), _this.state = {
	      hovered: false
	    }, _this.handleMouseLeave = function (event) {
	      // hover is needed only when a hoverColor is defined
	      if (_this.props.hoverColor !== undefined) {
	        _this.setState({ hovered: false });
	      }
	      if (_this.props.onMouseLeave) {
	        _this.props.onMouseLeave(event);
	      }
	    }, _this.handleMouseEnter = function (event) {
	      // hover is needed only when a hoverColor is defined
	      if (_this.props.hoverColor !== undefined) {
	        _this.setState({ hovered: true });
	      }
	      if (_this.props.onMouseEnter) {
	        _this.props.onMouseEnter(event);
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(FontIcon, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var hoverColor = _props.hoverColor;
	      var onMouseLeave = _props.onMouseLeave;
	      var onMouseEnter = _props.onMouseEnter;
	      var style = _props.style;
	
	      var other = _objectWithoutProperties(_props, ['hoverColor', 'onMouseLeave', 'onMouseEnter', 'style']);
	
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context, this.state);
	
	      return _react2.default.createElement('span', _extends({}, other, {
	        onMouseLeave: this.handleMouseLeave,
	        onMouseEnter: this.handleMouseEnter,
	        style: prepareStyles((0, _simpleAssign2.default)(styles.root, style))
	      }));
	    }
	  }]);
	
	  return FontIcon;
	}(_react.Component);
	
	FontIcon.muiName = 'FontIcon';
	FontIcon.propTypes = {
	  /**
	   * This is the font color of the font icon. If not specified,
	   * this component will default to muiTheme.palette.textColor.
	   */
	  color: _react.PropTypes.string,
	  /**
	   * This is the icon color when the mouse hovers over the icon.
	   */
	  hoverColor: _react.PropTypes.string,
	  /** @ignore */
	  onMouseEnter: _react.PropTypes.func,
	  /** @ignore */
	  onMouseLeave: _react.PropTypes.func,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object
	};
	FontIcon.defaultProps = {
	  onMouseEnter: function onMouseEnter() {},
	  onMouseLeave: function onMouseLeave() {}
	};
	FontIcon.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	exports.default = FontIcon;

/***/ }),
/* 606 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _simpleAssign = __webpack_require__(579);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _transitions = __webpack_require__(582);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function getStyles(props, context, state) {
	  var verticalPosition = props.verticalPosition;
	  var horizontalPosition = props.horizontalPosition;
	  var touchMarginOffset = props.touch ? 10 : 0;
	  var touchOffsetTop = props.touch ? -20 : -10;
	  var offset = verticalPosition === 'bottom' ? 14 + touchMarginOffset : -14 - touchMarginOffset;
	
	  var _context$muiTheme = context.muiTheme;
	  var baseTheme = _context$muiTheme.baseTheme;
	  var zIndex = _context$muiTheme.zIndex;
	  var tooltip = _context$muiTheme.tooltip;
	
	
	  var styles = {
	    root: {
	      position: 'absolute',
	      fontFamily: baseTheme.fontFamily,
	      fontSize: '10px',
	      lineHeight: '22px',
	      padding: '0 8px',
	      zIndex: zIndex.tooltip,
	      color: tooltip.color,
	      overflow: 'hidden',
	      top: -10000,
	      borderRadius: 2,
	      userSelect: 'none',
	      opacity: 0,
	      right: horizontalPosition === 'left' ? 12 : null,
	      left: horizontalPosition === 'center' ? (state.offsetWidth - 48) / 2 * -1 : null,
	      transition: _transitions2.default.easeOut('0ms', 'top', '450ms') + ', ' + _transitions2.default.easeOut('450ms', 'transform', '0ms') + ', ' + _transitions2.default.easeOut('450ms', 'opacity', '0ms')
	    },
	    label: {
	      position: 'relative',
	      whiteSpace: 'nowrap'
	    },
	    ripple: {
	      position: 'absolute',
	      left: horizontalPosition === 'center' ? '50%' : horizontalPosition === 'left' ? '100%' : '0%',
	      top: verticalPosition === 'bottom' ? 0 : '100%',
	      transform: 'translate(-50%, -50%)',
	      borderRadius: '50%',
	      backgroundColor: 'transparent',
	      transition: _transitions2.default.easeOut('0ms', 'width', '450ms') + ', ' + _transitions2.default.easeOut('0ms', 'height', '450ms') + ', ' + _transitions2.default.easeOut('450ms', 'backgroundColor', '0ms')
	    },
	    rootWhenShown: {
	      top: verticalPosition === 'top' ? touchOffsetTop : 36,
	      opacity: 0.9,
	      transform: 'translate(0px, ' + offset + 'px)',
	      transition: _transitions2.default.easeOut('0ms', 'top', '0ms') + ', ' + _transitions2.default.easeOut('450ms', 'transform', '0ms') + ', ' + _transitions2.default.easeOut('450ms', 'opacity', '0ms')
	    },
	    rootWhenTouched: {
	      fontSize: '14px',
	      lineHeight: '32px',
	      padding: '0 16px'
	    },
	    rippleWhenShown: {
	      backgroundColor: tooltip.rippleBackgroundColor,
	      transition: _transitions2.default.easeOut('450ms', 'width', '0ms') + ', ' + _transitions2.default.easeOut('450ms', 'height', '0ms') + ', ' + _transitions2.default.easeOut('450ms', 'backgroundColor', '0ms')
	    }
	  };
	
	  return styles;
	}
	
	var Tooltip = function (_Component) {
	  _inherits(Tooltip, _Component);
	
	  function Tooltip() {
	    var _Object$getPrototypeO;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Tooltip);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_Object$getPrototypeO = Object.getPrototypeOf(Tooltip)).call.apply(_Object$getPrototypeO, [this].concat(args))), _this), _this.state = {
	      offsetWidth: null
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Tooltip, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.setRippleSize();
	      this.setTooltipPosition();
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps() {
	      this.setTooltipPosition();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this.setRippleSize();
	    }
	  }, {
	    key: 'setRippleSize',
	    value: function setRippleSize() {
	      var ripple = this.refs.ripple;
	      var tooltip = this.refs.tooltip;
	      var tooltipWidth = parseInt(tooltip.offsetWidth, 10) / (this.props.horizontalPosition === 'center' ? 2 : 1);
	      var tooltipHeight = parseInt(tooltip.offsetHeight, 10);
	
	      var rippleDiameter = Math.ceil(Math.sqrt(Math.pow(tooltipHeight, 2) + Math.pow(tooltipWidth, 2)) * 2);
	      if (this.props.show) {
	        ripple.style.height = rippleDiameter + 'px';
	        ripple.style.width = rippleDiameter + 'px';
	      } else {
	        ripple.style.width = '0px';
	        ripple.style.height = '0px';
	      }
	    }
	  }, {
	    key: 'setTooltipPosition',
	    value: function setTooltipPosition() {
	      this.setState({ offsetWidth: this.refs.tooltip.offsetWidth });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var horizontalPosition = _props.horizontalPosition;
	      var label = _props.label;
	      var show = _props.show;
	      var touch = _props.touch;
	      var verticalPosition = _props.verticalPosition;
	
	      var other = _objectWithoutProperties(_props, ['horizontalPosition', 'label', 'show', 'touch', 'verticalPosition']);
	
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context, this.state);
	
	      return _react2.default.createElement(
	        'div',
	        _extends({}, other, {
	          ref: 'tooltip',
	          style: prepareStyles((0, _simpleAssign2.default)(styles.root, this.props.show && styles.rootWhenShown, this.props.touch && styles.rootWhenTouched, this.props.style))
	        }),
	        _react2.default.createElement('div', {
	          ref: 'ripple',
	          style: prepareStyles((0, _simpleAssign2.default)(styles.ripple, this.props.show && styles.rippleWhenShown))
	        }),
	        _react2.default.createElement(
	          'span',
	          { style: prepareStyles(styles.label) },
	          label
	        )
	      );
	    }
	  }]);
	
	  return Tooltip;
	}(_react.Component);
	
	Tooltip.propTypes = {
	  /**
	   * The css class name of the root element.
	   */
	  className: _react.PropTypes.string,
	  horizontalPosition: _react.PropTypes.oneOf(['left', 'right', 'center']),
	  label: _react.PropTypes.node.isRequired,
	  show: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object,
	  touch: _react.PropTypes.bool,
	  verticalPosition: _react.PropTypes.oneOf(['top', 'bottom'])
	};
	Tooltip.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	exports.default = Tooltip;

/***/ }),
/* 607 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(608);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(615);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NavigationMenu = function NavigationMenu(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z' })
	  );
	};
	NavigationMenu = (0, _pure2.default)(NavigationMenu);
	NavigationMenu.displayName = 'NavigationMenu';
	NavigationMenu.muiName = 'SvgIcon';
	
	exports.default = NavigationMenu;

/***/ }),
/* 608 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _shouldUpdate = __webpack_require__(609);
	
	var _shouldUpdate2 = _interopRequireDefault(_shouldUpdate);
	
	var _shallowEqual = __webpack_require__(591);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	var _createHelper = __webpack_require__(610);
	
	var _createHelper2 = _interopRequireDefault(_createHelper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var pure = (0, _shouldUpdate2.default)(function (props, nextProps) {
	  return !(0, _shallowEqual2.default)(props, nextProps);
	});
	
	exports.default = (0, _createHelper2.default)(pure, 'pure', true, true);

/***/ }),
/* 609 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(300);
	
	var _createHelper = __webpack_require__(610);
	
	var _createHelper2 = _interopRequireDefault(_createHelper);
	
	var _createEagerFactory = __webpack_require__(611);
	
	var _createEagerFactory2 = _interopRequireDefault(_createEagerFactory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var shouldUpdate = function shouldUpdate(test) {
	  return function (BaseComponent) {
	    var factory = (0, _createEagerFactory2.default)(BaseComponent);
	    return function (_Component) {
	      _inherits(_class, _Component);
	
	      function _class() {
	        _classCallCheck(this, _class);
	
	        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	      }
	
	      _class.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	        return test(this.props, nextProps);
	      };
	
	      _class.prototype.render = function render() {
	        return factory(this.props);
	      };
	
	      return _class;
	    }(_react.Component);
	  };
	};
	
	exports.default = (0, _createHelper2.default)(shouldUpdate, 'shouldUpdate');

/***/ }),
/* 610 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	var createHelper = function createHelper(func, helperName) {
	  var setDisplayName = arguments.length <= 2 || arguments[2] === undefined ? true : arguments[2];
	  var noArgs = arguments.length <= 3 || arguments[3] === undefined ? false : arguments[3];
	
	  if (false) {
	    var _ret = function () {
	      /* eslint-disable global-require */
	      var wrapDisplayName = require('./wrapDisplayName').default;
	      /* eslint-enable global-require */
	
	      if (noArgs) {
	        return {
	          v: function v(BaseComponent) {
	            var Component = func(BaseComponent);
	            Component.displayName = wrapDisplayName(BaseComponent, helperName);
	            return Component;
	          }
	        };
	      }
	
	      return {
	        v: function v() {
	          for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	          }
	
	          if (args.length > func.length) {
	            /* eslint-disable */
	            console.error(
	            /* eslint-enable */
	            'Too many arguments passed to ' + helperName + '(). It should called ' + ('like so: ' + helperName + '(...args)(BaseComponent).'));
	          }
	
	          return function (BaseComponent) {
	            var Component = func.apply(undefined, args)(BaseComponent);
	            Component.displayName = wrapDisplayName(BaseComponent, helperName);
	            return Component;
	          };
	        }
	      };
	    }();
	
	    if (typeof _ret === "object") return _ret.v;
	  }
	
	  return func;
	};
	
	exports.default = createHelper;

/***/ }),
/* 611 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createEagerElementUtil = __webpack_require__(612);
	
	var _createEagerElementUtil2 = _interopRequireDefault(_createEagerElementUtil);
	
	var _isReferentiallyTransparentFunctionComponent = __webpack_require__(613);
	
	var _isReferentiallyTransparentFunctionComponent2 = _interopRequireDefault(_isReferentiallyTransparentFunctionComponent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createFactory = function createFactory(type) {
	  var isReferentiallyTransparent = (0, _isReferentiallyTransparentFunctionComponent2.default)(type);
	  return function (p, c) {
	    return (0, _createEagerElementUtil2.default)(false, isReferentiallyTransparent, type, p, c);
	  };
	};
	
	exports.default = createFactory;

/***/ }),
/* 612 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createEagerElementUtil = function createEagerElementUtil(hasKey, isReferentiallyTransparent, type, props, children) {
	  if (!hasKey && isReferentiallyTransparent) {
	    if (children) {
	      return type(_extends({}, props, { children: children }));
	    }
	    return type(props);
	  }
	
	  var Component = type;
	
	  if (children) {
	    return _react2.default.createElement(
	      Component,
	      props,
	      children
	    );
	  }
	
	  return _react2.default.createElement(Component, props);
	};
	
	exports.default = createEagerElementUtil;

/***/ }),
/* 613 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _isClassComponent = __webpack_require__(614);
	
	var _isClassComponent2 = _interopRequireDefault(_isClassComponent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var isReferentiallyTransparentFunctionComponent = function isReferentiallyTransparentFunctionComponent(Component) {
	  return Boolean(typeof Component === 'function' && !(0, _isClassComponent2.default)(Component) && !Component.defaultProps && !Component.contextTypes && !Component.propTypes);
	};
	
	exports.default = isReferentiallyTransparentFunctionComponent;

/***/ }),
/* 614 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var isClassComponent = function isClassComponent(Component) {
	  return Boolean(Component && Component.prototype && typeof Component.prototype.isReactComponent === 'object');
	};
	
	exports.default = isClassComponent;

/***/ }),
/* 615 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _SvgIcon = __webpack_require__(616);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _SvgIcon2.default;

/***/ }),
/* 616 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _simpleAssign = __webpack_require__(579);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _transitions = __webpack_require__(582);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SvgIcon = function (_Component) {
	  _inherits(SvgIcon, _Component);
	
	  function SvgIcon() {
	    var _Object$getPrototypeO;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, SvgIcon);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_Object$getPrototypeO = Object.getPrototypeOf(SvgIcon)).call.apply(_Object$getPrototypeO, [this].concat(args))), _this), _this.state = {
	      hovered: false
	    }, _this.handleMouseLeave = function (event) {
	      _this.setState({ hovered: false });
	      _this.props.onMouseLeave(event);
	    }, _this.handleMouseEnter = function (event) {
	      _this.setState({ hovered: true });
	      _this.props.onMouseEnter(event);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(SvgIcon, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var children = _props.children;
	      var color = _props.color;
	      var hoverColor = _props.hoverColor;
	      var onMouseEnter = _props.onMouseEnter;
	      var onMouseLeave = _props.onMouseLeave;
	      var style = _props.style;
	      var viewBox = _props.viewBox;
	
	      var other = _objectWithoutProperties(_props, ['children', 'color', 'hoverColor', 'onMouseEnter', 'onMouseLeave', 'style', 'viewBox']);
	
	      var _context$muiTheme = this.context.muiTheme;
	      var svgIcon = _context$muiTheme.svgIcon;
	      var prepareStyles = _context$muiTheme.prepareStyles;
	
	
	      var offColor = color ? color : 'currentColor';
	      var onColor = hoverColor ? hoverColor : offColor;
	
	      var mergedStyles = (0, _simpleAssign2.default)({
	        display: 'inline-block',
	        color: svgIcon.color,
	        fill: this.state.hovered ? onColor : offColor,
	        height: 24,
	        width: 24,
	        userSelect: 'none',
	        transition: _transitions2.default.easeOut()
	      }, style);
	
	      return _react2.default.createElement(
	        'svg',
	        _extends({}, other, {
	          onMouseEnter: this.handleMouseEnter,
	          onMouseLeave: this.handleMouseLeave,
	          style: prepareStyles(mergedStyles),
	          viewBox: viewBox
	        }),
	        children
	      );
	    }
	  }]);
	
	  return SvgIcon;
	}(_react.Component);
	
	SvgIcon.muiName = 'SvgIcon';
	SvgIcon.propTypes = {
	  /**
	   * Elements passed into the SVG Icon.
	   */
	  children: _react.PropTypes.node,
	  /**
	   * This is the fill color of the svg icon.
	   * If not specified, this component will default
	   * to muiTheme.palette.textColor.
	   */
	  color: _react.PropTypes.string,
	  /**
	   * This is the icon color when the mouse hovers over the icon.
	   */
	  hoverColor: _react.PropTypes.string,
	  /** @ignore */
	  onMouseEnter: _react.PropTypes.func,
	  /** @ignore */
	  onMouseLeave: _react.PropTypes.func,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object,
	  /**
	   * Allows you to redefine what the coordinates
	   * without units mean inside an svg element. For example,
	   * if the SVG element is 500 (width) by 200 (height), and you
	   * pass viewBox="0 0 50 20", this means that the coordinates inside
	   * the svg will go from the top left corner (0,0) to bottom right (50,20)
	   * and each unit will be worth 10px.
	   */
	  viewBox: _react.PropTypes.string
	};
	SvgIcon.defaultProps = {
	  onMouseEnter: function onMouseEnter() {},
	  onMouseLeave: function onMouseLeave() {},
	  viewBox: '0 0 24 24'
	};
	SvgIcon.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	exports.default = SvgIcon;

/***/ }),
/* 617 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _Paper = __webpack_require__(618);
	
	var _Paper2 = _interopRequireDefault(_Paper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Paper2.default;

/***/ }),
/* 618 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _simpleAssign = __webpack_require__(579);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(583);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _transitions = __webpack_require__(582);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function getStyles(props, context) {
	  var rounded = props.rounded;
	  var circle = props.circle;
	  var transitionEnabled = props.transitionEnabled;
	  var zDepth = props.zDepth;
	  var _context$muiTheme = context.muiTheme;
	  var baseTheme = _context$muiTheme.baseTheme;
	  var paper = _context$muiTheme.paper;
	
	
	  return {
	    root: {
	      color: paper.color,
	      backgroundColor: paper.backgroundColor,
	      transition: transitionEnabled && _transitions2.default.easeOut(),
	      boxSizing: 'border-box',
	      fontFamily: baseTheme.fontFamily,
	      WebkitTapHighlightColor: 'rgba(0,0,0,0)', // Remove mobile color flashing (deprecated)
	      boxShadow: paper.zDepthShadows[zDepth - 1], // No shadow for 0 depth papers
	      borderRadius: circle ? '50%' : rounded ? '2px' : '0px'
	    }
	  };
	}
	
	var Paper = function (_Component) {
	  _inherits(Paper, _Component);
	
	  function Paper() {
	    _classCallCheck(this, Paper);
	
	    return _possibleConstructorReturn(this, Object.getPrototypeOf(Paper).apply(this, arguments));
	  }
	
	  _createClass(Paper, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var children = _props.children;
	      var circle = _props.circle;
	      var rounded = _props.rounded;
	      var style = _props.style;
	      var transitionEnabled = _props.transitionEnabled;
	      var zDepth = _props.zDepth;
	
	      var other = _objectWithoutProperties(_props, ['children', 'circle', 'rounded', 'style', 'transitionEnabled', 'zDepth']);
	
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      return _react2.default.createElement(
	        'div',
	        _extends({}, other, { style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) }),
	        children
	      );
	    }
	  }]);
	
	  return Paper;
	}(_react.Component);
	
	Paper.propTypes = {
	  /**
	   * Children passed into the paper element.
	   */
	  children: _react.PropTypes.node,
	  /**
	   * Set to true to generate a circlular paper container.
	   */
	  circle: _react.PropTypes.bool,
	  /**
	   * By default, the paper container will have a border radius.
	   * Set this to false to generate a container with sharp corners.
	   */
	  rounded: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object,
	  /**
	   * Set to false to disable CSS transitions for the paper element.
	   */
	  transitionEnabled: _react.PropTypes.bool,
	  /**
	   * This number represents the zDepth of the paper shadow.
	   */
	  zDepth: _propTypes2.default.zDepth
	};
	Paper.defaultProps = {
	  circle: false,
	  rounded: true,
	  transitionEnabled: true,
	  zDepth: 1
	};
	Paper.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	exports.default = Paper;

/***/ }),
/* 619 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _AutoComplete = __webpack_require__(620);
	
	var _AutoComplete2 = _interopRequireDefault(_AutoComplete);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _AutoComplete2.default;

/***/ }),
/* 620 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _simpleAssign = __webpack_require__(579);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(332);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _keycode = __webpack_require__(589);
	
	var _keycode2 = _interopRequireDefault(_keycode);
	
	var _TextField = __webpack_require__(621);
	
	var _TextField2 = _interopRequireDefault(_TextField);
	
	var _Menu = __webpack_require__(630);
	
	var _Menu2 = _interopRequireDefault(_Menu);
	
	var _MenuItem = __webpack_require__(637);
	
	var _MenuItem2 = _interopRequireDefault(_MenuItem);
	
	var _Divider = __webpack_require__(662);
	
	var _Divider2 = _interopRequireDefault(_Divider);
	
	var _Popover = __webpack_require__(639);
	
	var _Popover2 = _interopRequireDefault(_Popover);
	
	var _propTypes = __webpack_require__(583);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _warning = __webpack_require__(491);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _deprecatedPropType = __webpack_require__(603);
	
	var _deprecatedPropType2 = _interopRequireDefault(_deprecatedPropType);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function getStyles(props, context, state) {
	  var anchorEl = state.anchorEl;
	  var fullWidth = props.fullWidth;
	
	
	  var styles = {
	    root: {
	      display: 'inline-block',
	      position: 'relative',
	      width: fullWidth ? '100%' : 256
	    },
	    menu: {
	      width: '100%'
	    },
	    list: {
	      display: 'block',
	      width: fullWidth ? '100%' : 256
	    },
	    innerDiv: {
	      overflow: 'hidden'
	    }
	  };
	
	  if (anchorEl && fullWidth) {
	    styles.popover = {
	      width: anchorEl.clientWidth
	    };
	  }
	
	  return styles;
	}
	
	var AutoComplete = function (_Component) {
	  _inherits(AutoComplete, _Component);
	
	  function AutoComplete() {
	    var _Object$getPrototypeO;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, AutoComplete);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_Object$getPrototypeO = Object.getPrototypeOf(AutoComplete)).call.apply(_Object$getPrototypeO, [this].concat(args))), _this), _this.state = {
	      anchorEl: null,
	      focusTextField: true,
	      open: false,
	      searchText: undefined
	    }, _this.handleRequestClose = function () {
	      // Only take into account the Popover clickAway when we are
	      // not focusing the TextField.
	      if (!_this.state.focusTextField) {
	        _this.close();
	      }
	    }, _this.handleMouseDown = function (event) {
	      // Keep the TextField focused
	      event.preventDefault();
	    }, _this.handleItemTouchTap = function (event, child) {
	      var dataSource = _this.props.dataSource;
	
	      var index = parseInt(child.key, 10);
	      var chosenRequest = dataSource[index];
	      var searchText = _this.chosenRequestText(chosenRequest);
	
	      _this.timerTouchTapCloseId = setTimeout(function () {
	        _this.timerTouchTapCloseId = null;
	
	        _this.setState({
	          searchText: searchText
	        });
	        _this.close();
	        _this.props.onNewRequest(chosenRequest, index);
	      }, _this.props.menuCloseDelay);
	    }, _this.chosenRequestText = function (chosenRequest) {
	      if (typeof chosenRequest === 'string') {
	        return chosenRequest;
	      } else {
	        return chosenRequest[_this.props.dataSourceConfig.text];
	      }
	    }, _this.handleEscKeyDown = function () {
	      _this.close();
	    }, _this.handleKeyDown = function (event) {
	      if (_this.props.onKeyDown) _this.props.onKeyDown(event);
	
	      switch ((0, _keycode2.default)(event)) {
	        case 'enter':
	          _this.close();
	          var searchText = _this.state.searchText;
	          if (searchText !== '') {
	            _this.props.onNewRequest(searchText, -1);
	          }
	          break;
	
	        case 'esc':
	          _this.close();
	          break;
	
	        case 'down':
	          event.preventDefault();
	          _this.setState({
	            open: true,
	            focusTextField: false,
	            anchorEl: _reactDom2.default.findDOMNode(_this.refs.searchTextField)
	          });
	          break;
	
	        default:
	          break;
	      }
	    }, _this.handleChange = function (event) {
	      var searchText = event.target.value;
	
	      // Make sure that we have a new searchText.
	      // Fix an issue with a Cordova Webview
	      if (searchText === _this.state.searchText) {
	        return;
	      }
	
	      _this.setState({
	        searchText: searchText,
	        open: true,
	        anchorEl: _reactDom2.default.findDOMNode(_this.refs.searchTextField)
	      }, function () {
	        _this.props.onUpdateInput(searchText, _this.props.dataSource);
	      });
	    }, _this.handleBlur = function (event) {
	      if (_this.state.focusTextField && _this.timerTouchTapCloseId === null) {
	        _this.close();
	      }
	
	      if (_this.props.onBlur) {
	        _this.props.onBlur(event);
	      }
	    }, _this.handleFocus = function (event) {
	      if (!_this.state.open && (_this.props.triggerUpdateOnFocus || _this.props.openOnFocus)) {
	        _this.setState({
	          open: true,
	          anchorEl: _reactDom2.default.findDOMNode(_this.refs.searchTextField)
	        });
	      }
	
	      _this.setState({
	        focusTextField: true
	      });
	
	      if (_this.props.onFocus) {
	        _this.props.onFocus(event);
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(AutoComplete, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.requestsList = [];
	      this.setState({
	        open: this.props.open,
	        searchText: this.props.searchText
	      });
	      this.timerTouchTapCloseId = null;
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.props.searchText !== nextProps.searchText) {
	        this.setState({
	          searchText: nextProps.searchText
	        });
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      clearTimeout(this.timerTouchTapCloseId);
	    }
	  }, {
	    key: 'close',
	    value: function close() {
	      this.setState({
	        open: false,
	        anchorEl: null
	      });
	    }
	  }, {
	    key: 'setValue',
	    value: function setValue(textValue) {
	       false ? (0, _warning2.default)(false, 'setValue() is deprecated, use the searchText property.\n      It will be removed with v0.16.0.') : void 0;
	
	      this.setState({
	        searchText: textValue
	      });
	    }
	  }, {
	    key: 'getValue',
	    value: function getValue() {
	       false ? (0, _warning2.default)(false, 'getValue() is deprecated. It will be removed with v0.16.0.') : void 0;
	
	      return this.state.searchText;
	    }
	  }, {
	    key: 'blur',
	    value: function blur() {
	      this.refs.searchTextField.blur();
	    }
	  }, {
	    key: 'focus',
	    value: function focus() {
	      this.refs.searchTextField.focus();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props;
	      var anchorOrigin = _props.anchorOrigin;
	      var animated = _props.animated;
	      var animation = _props.animation;
	      var dataSource = _props.dataSource;
	      var dataSourceConfig = _props.dataSourceConfig;
	      var disableFocusRipple = _props.disableFocusRipple;
	      var errorStyle = _props.errorStyle;
	      var floatingLabelText = _props.floatingLabelText;
	      var filter = _props.filter;
	      var fullWidth = _props.fullWidth;
	      var style = _props.style;
	      var hintText = _props.hintText;
	      var maxSearchResults = _props.maxSearchResults;
	      var menuCloseDelay = _props.menuCloseDelay;
	      var textFieldStyle = _props.textFieldStyle;
	      var menuStyle = _props.menuStyle;
	      var menuProps = _props.menuProps;
	      var listStyle = _props.listStyle;
	      var targetOrigin = _props.targetOrigin;
	      var triggerUpdateOnFocus = _props.triggerUpdateOnFocus;
	      var onNewRequest = _props.onNewRequest;
	      var onUpdateInput = _props.onUpdateInput;
	      var openOnFocus = _props.openOnFocus;
	      var searchTextProp = _props.searchText;
	
	      var other = _objectWithoutProperties(_props, ['anchorOrigin', 'animated', 'animation', 'dataSource', 'dataSourceConfig', 'disableFocusRipple', 'errorStyle', 'floatingLabelText', 'filter', 'fullWidth', 'style', 'hintText', 'maxSearchResults', 'menuCloseDelay', 'textFieldStyle', 'menuStyle', 'menuProps', 'listStyle', 'targetOrigin', 'triggerUpdateOnFocus', 'onNewRequest', 'onUpdateInput', 'openOnFocus', 'searchText']);
	
	      var _state = this.state;
	      var open = _state.open;
	      var anchorEl = _state.anchorEl;
	      var searchText = _state.searchText;
	      var focusTextField = _state.focusTextField;
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context, this.state);
	
	      var requestsList = [];
	
	      dataSource.every(function (item, index) {
	        switch (typeof item === 'undefined' ? 'undefined' : _typeof(item)) {
	          case 'string':
	            if (filter(searchText, item, item)) {
	              requestsList.push({
	                text: item,
	                value: _react2.default.createElement(_MenuItem2.default, {
	                  innerDivStyle: styles.innerDiv,
	                  value: item,
	                  primaryText: item,
	                  disableFocusRipple: disableFocusRipple,
	                  key: index
	                })
	              });
	            }
	            break;
	
	          case 'object':
	            if (item && typeof item[_this2.props.dataSourceConfig.text] === 'string') {
	              var itemText = item[_this2.props.dataSourceConfig.text];
	              if (!_this2.props.filter(searchText, itemText, item)) break;
	
	              var itemValue = item[_this2.props.dataSourceConfig.value];
	              if (itemValue.type && (itemValue.type.muiName === _MenuItem2.default.muiName || itemValue.type.muiName === _Divider2.default.muiName)) {
	                requestsList.push({
	                  text: itemText,
	                  value: _react2.default.cloneElement(itemValue, {
	                    key: index,
	                    disableFocusRipple: disableFocusRipple
	                  })
	                });
	              } else {
	                requestsList.push({
	                  text: itemText,
	                  value: _react2.default.createElement(_MenuItem2.default, {
	                    innerDivStyle: styles.innerDiv,
	                    primaryText: itemText,
	                    disableFocusRipple: disableFocusRipple,
	                    key: index
	                  })
	                });
	              }
	            }
	            break;
	
	          default:
	          // Do nothing
	        }
	
	        return !(maxSearchResults && maxSearchResults > 0 && requestsList.length === maxSearchResults);
	      });
	
	      this.requestsList = requestsList;
	
	      var menu = open && requestsList.length > 0 && _react2.default.createElement(
	        _Menu2.default,
	        _extends({}, menuProps, {
	          ref: 'menu',
	          autoWidth: false,
	          disableAutoFocus: focusTextField,
	          onEscKeyDown: this.handleEscKeyDown,
	          initiallyKeyboardFocused: true,
	          onItemTouchTap: this.handleItemTouchTap,
	          onMouseDown: this.handleMouseDown,
	          style: (0, _simpleAssign2.default)(styles.menu, menuStyle),
	          listStyle: (0, _simpleAssign2.default)(styles.list, listStyle)
	        }),
	        requestsList.map(function (i) {
	          return i.value;
	        })
	      );
	
	      return _react2.default.createElement(
	        'div',
	        { style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) },
	        _react2.default.createElement(_TextField2.default, _extends({}, other, {
	          ref: 'searchTextField',
	          autoComplete: 'off',
	          value: searchText,
	          onChange: this.handleChange,
	          onBlur: this.handleBlur,
	          onFocus: this.handleFocus,
	          onKeyDown: this.handleKeyDown,
	          floatingLabelText: floatingLabelText,
	          hintText: hintText,
	          fullWidth: fullWidth,
	          multiLine: false,
	          errorStyle: errorStyle,
	          style: textFieldStyle
	        })),
	        _react2.default.createElement(
	          _Popover2.default,
	          {
	            style: styles.popover,
	            canAutoPosition: false,
	            anchorOrigin: anchorOrigin,
	            targetOrigin: targetOrigin,
	            open: open,
	            anchorEl: anchorEl,
	            useLayerForClickAway: false,
	            onRequestClose: this.handleRequestClose,
	            animated: animated,
	            animation: animation
	          },
	          menu
	        )
	      );
	    }
	  }]);
	
	  return AutoComplete;
	}(_react.Component);
	
	AutoComplete.propTypes = {
	  /**
	   * Location of the anchor for the auto complete.
	   */
	  anchorOrigin: _propTypes2.default.origin,
	  /**
	   * If true, the auto complete is animated as it is toggled.
	   */
	  animated: _react.PropTypes.bool,
	  /**
	   * Override the default animation component used.
	   */
	  animation: _react.PropTypes.func,
	  /**
	   * Array of strings or nodes used to populate the list.
	   */
	  dataSource: _react.PropTypes.array.isRequired,
	  /**
	   * Config for objects list dataSource.
	   *
	   * @typedef {Object} dataSourceConfig
	   *
	   * @property {string} text `dataSource` element key used to find a string to be matched for search
	   * and shown as a `TextField` input value after choosing the result.
	   * @property {string} value `dataSource` element key used to find a string to be shown in search results.
	   */
	  dataSourceConfig: _react.PropTypes.object,
	  /**
	   * Disables focus ripple when true.
	   */
	  disableFocusRipple: _react.PropTypes.bool,
	  /**
	   * Override style prop for error.
	   */
	  errorStyle: _react.PropTypes.object,
	  /**
	   * The error content to display.
	   */
	  errorText: _react.PropTypes.node,
	  /**
	   * Callback function used to filter the auto complete.
	   *
	   * @param {string} searchText The text to search for within `dataSource`.
	   * @param {string} key `dataSource` element, or `text` property on that element if it's not a string.
	   * @returns {boolean} `true` indicates the auto complete list will include `key` when the input is `searchText`.
	   */
	  filter: _react.PropTypes.func,
	  /**
	   * The content to use for adding floating label element.
	   */
	  floatingLabelText: _react.PropTypes.node,
	  /**
	   * If true, the field receives the property `width: 100%`.
	   */
	  fullWidth: _react.PropTypes.bool,
	  /**
	   * The hint content to display.
	   */
	  hintText: _react.PropTypes.node,
	  /**
	   * Override style for list.
	   */
	  listStyle: _react.PropTypes.object,
	  /**
	   * The max number of search results to be shown.
	   * By default it shows all the items which matches filter.
	   */
	  maxSearchResults: _react.PropTypes.number,
	  /**
	   * Delay for closing time of the menu.
	   */
	  menuCloseDelay: _react.PropTypes.number,
	  /**
	   * Props to be passed to menu.
	   */
	  menuProps: _react.PropTypes.object,
	  /**
	   * Override style for menu.
	   */
	  menuStyle: _react.PropTypes.object,
	  /** @ignore */
	  onBlur: _react.PropTypes.func,
	  /** @ignore */
	  onFocus: _react.PropTypes.func,
	  /** @ignore */
	  onKeyDown: _react.PropTypes.func,
	  /**
	   * Callback function that is fired when a list item is selected, or enter is pressed in the `TextField`.
	   *
	   * @param {string} chosenRequest Either the `TextField` input value, if enter is pressed in the `TextField`,
	   * or the text value of the corresponding list item that was selected.
	   * @param {number} index The index in `dataSource` of the list item selected, or `-1` if enter is pressed in the
	   * `TextField`.
	   */
	  onNewRequest: _react.PropTypes.func,
	  /**
	   * Callback function that is fired when the user updates the `TextField`.
	   *
	   * @param {string} searchText The auto-complete's `searchText` value.
	   * @param {array} dataSource The auto-complete's `dataSource` array.
	   */
	  onUpdateInput: _react.PropTypes.func,
	  /**
	   * Auto complete menu is open if true.
	   */
	  open: _react.PropTypes.bool,
	  /**
	   * If true, the list item is showed when a focus event triggers.
	   */
	  openOnFocus: _react.PropTypes.bool,
	  /**
	   * Text being input to auto complete.
	   */
	  searchText: _react.PropTypes.string,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object,
	  /**
	   * Origin for location of target.
	   */
	  targetOrigin: _propTypes2.default.origin,
	  /**
	   * Override the inline-styles of AutoComplete's TextField element.
	   */
	  textFieldStyle: _react.PropTypes.object,
	  /**
	   * If true, will update when focus event triggers.
	   */
	  triggerUpdateOnFocus: (0, _deprecatedPropType2.default)(_react.PropTypes.bool, 'Instead, use openOnFocus. It will be removed with v0.16.0.')
	};
	AutoComplete.defaultProps = {
	  anchorOrigin: {
	    vertical: 'bottom',
	    horizontal: 'left'
	  },
	  animated: true,
	  dataSourceConfig: {
	    text: 'text',
	    value: 'value'
	  },
	  disableFocusRipple: true,
	  filter: function filter(searchText, key) {
	    return searchText !== '' && key.indexOf(searchText) !== -1;
	  },
	  fullWidth: false,
	  open: false,
	  openOnFocus: false,
	  onUpdateInput: function onUpdateInput() {},
	  onNewRequest: function onNewRequest() {},
	  searchText: '',
	  menuCloseDelay: 300,
	  targetOrigin: {
	    vertical: 'top',
	    horizontal: 'left'
	  }
	};
	AutoComplete.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	
	
	AutoComplete.levenshteinDistance = function (searchText, key) {
	  var current = [];
	  var prev = void 0;
	  var value = void 0;
	
	  for (var i = 0; i <= key.length; i++) {
	    for (var j = 0; j <= searchText.length; j++) {
	      if (i && j) {
	        if (searchText.charAt(j - 1) === key.charAt(i - 1)) value = prev;else value = Math.min(current[j], current[j - 1], prev) + 1;
	      } else {
	        value = i + j;
	      }
	      prev = current[j];
	      current[j] = value;
	    }
	  }
	  return current.pop();
	};
	
	AutoComplete.noFilter = function () {
	  return true;
	};
	
	AutoComplete.defaultFilter = AutoComplete.caseSensitiveFilter = function (searchText, key) {
	  return searchText !== '' && key.indexOf(searchText) !== -1;
	};
	
	AutoComplete.caseInsensitiveFilter = function (searchText, key) {
	  return key.toLowerCase().indexOf(searchText.toLowerCase()) !== -1;
	};
	
	AutoComplete.levenshteinDistanceFilter = function (distanceLessThan) {
	  if (distanceLessThan === undefined) {
	    return AutoComplete.levenshteinDistance;
	  } else if (typeof distanceLessThan !== 'number') {
	    throw 'Error: AutoComplete.levenshteinDistanceFilter is a filter generator, not a filter!';
	  }
	
	  return function (s, k) {
	    return AutoComplete.levenshteinDistance(s, k) < distanceLessThan;
	  };
	};
	
	AutoComplete.fuzzyFilter = function (searchText, key) {
	  var compareString = key.toLowerCase();
	  searchText = searchText.toLowerCase();
	
	  var searchTextIndex = 0;
	  for (var index = 0; index < key.length; index++) {
	    if (compareString[index] === searchText[searchTextIndex]) {
	      searchTextIndex += 1;
	    }
	  }
	
	  return searchTextIndex === searchText.length;
	};
	
	AutoComplete.Item = _MenuItem2.default;
	AutoComplete.Divider = _Divider2.default;
	
	exports.default = AutoComplete;

/***/ }),
/* 621 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _TextField = __webpack_require__(622);
	
	var _TextField2 = _interopRequireDefault(_TextField);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _TextField2.default;

/***/ }),
/* 622 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _simpleAssign = __webpack_require__(579);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(332);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _keycode = __webpack_require__(589);
	
	var _keycode2 = _interopRequireDefault(_keycode);
	
	var _shallowEqual = __webpack_require__(591);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	var _colorManipulator = __webpack_require__(623);
	
	var _transitions = __webpack_require__(582);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _deprecatedPropType = __webpack_require__(603);
	
	var _deprecatedPropType2 = _interopRequireDefault(_deprecatedPropType);
	
	var _EnhancedTextarea = __webpack_require__(624);
	
	var _EnhancedTextarea2 = _interopRequireDefault(_EnhancedTextarea);
	
	var _TextFieldHint = __webpack_require__(627);
	
	var _TextFieldHint2 = _interopRequireDefault(_TextFieldHint);
	
	var _TextFieldLabel = __webpack_require__(628);
	
	var _TextFieldLabel2 = _interopRequireDefault(_TextFieldLabel);
	
	var _TextFieldUnderline = __webpack_require__(629);
	
	var _TextFieldUnderline2 = _interopRequireDefault(_TextFieldUnderline);
	
	var _warning = __webpack_require__(491);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var getStyles = function getStyles(props, context, state) {
	  var _context$muiTheme = context.muiTheme;
	  var baseTheme = _context$muiTheme.baseTheme;
	  var _context$muiTheme$tex = _context$muiTheme.textField;
	  var floatingLabelColor = _context$muiTheme$tex.floatingLabelColor;
	  var focusColor = _context$muiTheme$tex.focusColor;
	  var textColor = _context$muiTheme$tex.textColor;
	  var disabledTextColor = _context$muiTheme$tex.disabledTextColor;
	  var backgroundColor = _context$muiTheme$tex.backgroundColor;
	  var hintColor = _context$muiTheme$tex.hintColor;
	  var errorColor = _context$muiTheme$tex.errorColor;
	
	
	  var styles = {
	    root: {
	      fontSize: 16,
	      lineHeight: '24px',
	      width: props.fullWidth ? '100%' : 256,
	      height: (props.rows - 1) * 24 + (props.floatingLabelText ? 72 : 48),
	      display: 'inline-block',
	      position: 'relative',
	      backgroundColor: backgroundColor,
	      fontFamily: baseTheme.fontFamily,
	      transition: _transitions2.default.easeOut('200ms', 'height')
	    },
	    error: {
	      position: 'relative',
	      bottom: 2,
	      fontSize: 12,
	      lineHeight: '12px',
	      color: errorColor,
	      transition: _transitions2.default.easeOut()
	    },
	    floatingLabel: {
	      color: hintColor,
	      pointerEvents: 'none'
	    },
	    input: {
	      WebkitTapHighlightColor: 'rgba(0,0,0,0)', // Remove mobile color flashing (deprecated style)
	      padding: 0,
	      position: 'relative',
	      width: '100%',
	      border: 'none',
	      outline: 'none',
	      backgroundColor: 'rgba(0,0,0,0)',
	      color: props.disabled ? disabledTextColor : textColor,
	      cursor: props.disabled ? 'not-allowed' : 'initial',
	      font: 'inherit'
	    },
	    textarea: {}
	  };
	
	  (0, _simpleAssign2.default)(styles.error, props.errorStyle);
	
	  (0, _simpleAssign2.default)(styles.textarea, styles.input, {
	    marginTop: props.floatingLabelText ? 36 : 12,
	    marginBottom: props.floatingLabelText ? -36 : -12,
	    boxSizing: 'border-box',
	    font: 'inherit'
	  });
	
	  // Do not assign a height to the textarea as he handles it on his own.
	  styles.input.height = '100%';
	
	  if (state.hasValue) {
	    styles.floatingLabel.color = (0, _colorManipulator.fade)(props.disabled ? disabledTextColor : floatingLabelColor, 0.5);
	  }
	
	  if (state.isFocused) {
	    styles.floatingLabel.color = focusColor;
	  }
	
	  if (props.floatingLabelText) {
	    styles.input.boxSizing = 'border-box';
	
	    if (!props.multiLine) {
	      styles.input.marginTop = 14;
	    }
	
	    if (state.errorText) {
	      styles.error.bottom = !props.multiLine ? styles.error.fontSize + 3 : 3;
	    }
	  }
	
	  if (state.errorText) {
	    if (state.isFocused) {
	      styles.floatingLabel.color = styles.error.color;
	    }
	  }
	
	  return styles;
	};
	
	/**
	 * Check if a value is valid to be displayed inside an input.
	 *
	 * @param The value to check.
	 * @returns True if the string provided is valid, false otherwise.
	 */
	function isValid(value) {
	  return value !== '' && value !== undefined && value !== null;
	}
	
	var TextField = function (_Component) {
	  _inherits(TextField, _Component);
	
	  function TextField() {
	    var _Object$getPrototypeO;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, TextField);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_Object$getPrototypeO = Object.getPrototypeOf(TextField)).call.apply(_Object$getPrototypeO, [this].concat(args))), _this), _this.state = {
	      isFocused: false,
	      errorText: undefined,
	      hasValue: false,
	      isClean: true
	    }, _this.handleInputBlur = function (event) {
	      _this.setState({ isFocused: false });
	      if (_this.props.onBlur) _this.props.onBlur(event);
	    }, _this.handleInputChange = function (event) {
	      _this.setState({ hasValue: isValid(event.target.value), isClean: false });
	      if (_this.props.onChange) _this.props.onChange(event, event.target.value);
	    }, _this.handleInputFocus = function (event) {
	      if (_this.props.disabled) return;
	      _this.setState({ isFocused: true });
	      if (_this.props.onFocus) _this.props.onFocus(event);
	    }, _this.handleInputKeyDown = function (event) {
	      if ((0, _keycode2.default)(event) === 'enter' && _this.props.onEnterKeyDown) _this.props.onEnterKeyDown(event);
	      if (_this.props.onKeyDown) _this.props.onKeyDown(event);
	    }, _this.handleHeightChange = function (event, height) {
	      var newHeight = height + 24;
	      if (_this.props.floatingLabelText) {
	        newHeight += 24;
	      }
	      _reactDom2.default.findDOMNode(_this).style.height = newHeight + 'px';
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(TextField, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _props = this.props;
	      var children = _props.children;
	      var name = _props.name;
	      var hintText = _props.hintText;
	      var floatingLabelText = _props.floatingLabelText;
	      var id = _props.id;
	
	
	      var propsLeaf = children ? children.props : this.props;
	
	      this.setState({
	        errorText: this.props.errorText,
	        hasValue: isValid(propsLeaf.value) || isValid(propsLeaf.defaultValue)
	      });
	
	       false ? (0, _warning2.default)(name || hintText || floatingLabelText || id, 'We don\'t have enough information\n      to build a robust unique id for the TextField component. Please provide an id or a name.') : void 0;
	
	      var uniqueId = name + '-' + hintText + '-' + floatingLabelText + '-' + Math.floor(Math.random() * 0xFFFF);
	      this.uniqueId = uniqueId.replace(/[^A-Za-z0-9-]/gi, '');
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.errorText !== this.props.errorText) {
	        this.setState({
	          errorText: nextProps.errorText
	        });
	      }
	
	      if (nextProps.children && nextProps.children.props) {
	        nextProps = nextProps.children.props;
	      }
	
	      if (nextProps.hasOwnProperty('value')) {
	        var hasValue = isValid(nextProps.value) || this.state.isClean && isValid(nextProps.defaultValue);
	
	        if (hasValue !== this.state.hasValue) {
	          this.setState({
	            hasValue: hasValue
	          });
	        }
	      }
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState, nextContext) {
	      return !(0, _shallowEqual2.default)(this.props, nextProps) || !(0, _shallowEqual2.default)(this.state, nextState) || !(0, _shallowEqual2.default)(this.context, nextContext);
	    }
	  }, {
	    key: 'blur',
	    value: function blur() {
	      if (this.input) this.getInputNode().blur();
	    }
	  }, {
	    key: 'focus',
	    value: function focus() {
	      if (this.input) this.getInputNode().focus();
	    }
	  }, {
	    key: 'select',
	    value: function select() {
	      if (this.input) this.getInputNode().select();
	    }
	  }, {
	    key: 'getValue',
	    value: function getValue() {
	      return this.input ? this.getInputNode().value : undefined;
	    }
	  }, {
	    key: 'getInputNode',
	    value: function getInputNode() {
	      return this.props.children || this.props.multiLine ? this.input.getInputNode() : _reactDom2.default.findDOMNode(this.input);
	    }
	  }, {
	    key: '_isControlled',
	    value: function _isControlled() {
	      return this.props.hasOwnProperty('value');
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props2 = this.props;
	      var children = _props2.children;
	      var className = _props2.className;
	      var disabled = _props2.disabled;
	      var errorStyle = _props2.errorStyle;
	      var errorText = _props2.errorText;
	      var floatingLabelFixed = _props2.floatingLabelFixed;
	      var floatingLabelFocusStyle = _props2.floatingLabelFocusStyle;
	      var floatingLabelStyle = _props2.floatingLabelStyle;
	      var floatingLabelText = _props2.floatingLabelText;
	      var fullWidth = _props2.fullWidth;
	      var hintText = _props2.hintText;
	      var hintStyle = _props2.hintStyle;
	      var id = _props2.id;
	      var inputStyle = _props2.inputStyle;
	      var multiLine = _props2.multiLine;
	      var onBlur = _props2.onBlur;
	      var onChange = _props2.onChange;
	      var onFocus = _props2.onFocus;
	      var style = _props2.style;
	      var type = _props2.type;
	      var underlineDisabledStyle = _props2.underlineDisabledStyle;
	      var underlineFocusStyle = _props2.underlineFocusStyle;
	      var underlineShow = _props2.underlineShow;
	      var underlineStyle = _props2.underlineStyle;
	      var rows = _props2.rows;
	      var rowsMax = _props2.rowsMax;
	      var textareaStyle = _props2.textareaStyle;
	
	      var other = _objectWithoutProperties(_props2, ['children', 'className', 'disabled', 'errorStyle', 'errorText', 'floatingLabelFixed', 'floatingLabelFocusStyle', 'floatingLabelStyle', 'floatingLabelText', 'fullWidth', 'hintText', 'hintStyle', 'id', 'inputStyle', 'multiLine', 'onBlur', 'onChange', 'onFocus', 'style', 'type', 'underlineDisabledStyle', 'underlineFocusStyle', 'underlineShow', 'underlineStyle', 'rows', 'rowsMax', 'textareaStyle']);
	
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context, this.state);
	      var inputId = id || this.uniqueId;
	
	      var errorTextElement = this.state.errorText && _react2.default.createElement(
	        'div',
	        { style: prepareStyles(styles.error) },
	        this.state.errorText
	      );
	
	      var floatingLabelTextElement = floatingLabelText && _react2.default.createElement(
	        _TextFieldLabel2.default,
	        {
	          muiTheme: this.context.muiTheme,
	          style: (0, _simpleAssign2.default)(styles.floatingLabel, this.props.floatingLabelStyle),
	          shrinkStyle: this.props.floatingLabelFocusStyle,
	          htmlFor: inputId,
	          shrink: this.state.hasValue || this.state.isFocused || floatingLabelFixed,
	          disabled: disabled
	        },
	        floatingLabelText
	      );
	
	      var inputProps = {
	        id: inputId,
	        ref: function ref(elem) {
	          return _this2.input = elem;
	        },
	        disabled: this.props.disabled,
	        onBlur: this.handleInputBlur,
	        onChange: this.handleInputChange,
	        onFocus: this.handleInputFocus,
	        onKeyDown: this.handleInputKeyDown
	      };
	
	      var inputStyleMerged = (0, _simpleAssign2.default)(styles.input, inputStyle);
	
	      var inputElement = void 0;
	      if (children) {
	        inputElement = _react2.default.cloneElement(children, _extends({}, inputProps, children.props, {
	          style: (0, _simpleAssign2.default)(inputStyleMerged, children.props.style)
	        }));
	      } else {
	        inputElement = multiLine ? _react2.default.createElement(_EnhancedTextarea2.default, _extends({}, other, inputProps, {
	          style: inputStyleMerged,
	          rows: rows,
	          rowsMax: rowsMax,
	          onHeightChange: this.handleHeightChange,
	          textareaStyle: (0, _simpleAssign2.default)(styles.textarea, textareaStyle)
	        })) : _react2.default.createElement('input', _extends({}, other, inputProps, {
	          style: prepareStyles(inputStyleMerged),
	          type: type
	        }));
	      }
	
	      var rootProps = {};
	
	      if (children) {
	        rootProps = other;
	      }
	
	      return _react2.default.createElement(
	        'div',
	        _extends({}, rootProps, {
	          className: className,
	          style: prepareStyles((0, _simpleAssign2.default)(styles.root, style))
	        }),
	        floatingLabelTextElement,
	        hintText ? _react2.default.createElement(_TextFieldHint2.default, {
	          muiTheme: this.context.muiTheme,
	          show: !(this.state.hasValue || floatingLabelText && !this.state.isFocused) || !this.state.hasValue && floatingLabelText && floatingLabelFixed && !this.state.isFocused,
	          style: hintStyle,
	          text: hintText
	        }) : null,
	        inputElement,
	        underlineShow ? _react2.default.createElement(_TextFieldUnderline2.default, {
	          disabled: disabled,
	          disabledStyle: underlineDisabledStyle,
	          error: !!this.state.errorText,
	          errorStyle: errorStyle,
	          focus: this.state.isFocused,
	          focusStyle: underlineFocusStyle,
	          muiTheme: this.context.muiTheme,
	          style: underlineStyle
	        }) : null,
	        errorTextElement
	      );
	    }
	  }]);
	
	  return TextField;
	}(_react.Component);
	
	TextField.propTypes = {
	  children: _react.PropTypes.node,
	  /**
	   * The css class name of the root element.
	   */
	  className: _react.PropTypes.string,
	  /**
	   * The text string to use for the default value.
	   */
	  defaultValue: _react.PropTypes.any,
	  /**
	   * Disables the text field if set to true.
	   */
	  disabled: _react.PropTypes.bool,
	  /**
	   * The style object to use to override error styles.
	   */
	  errorStyle: _react.PropTypes.object,
	  /**
	   * The error content to display.
	   */
	  errorText: _react.PropTypes.node,
	  /**
	   * If true, the floating label will float even when there is no value.
	   */
	  floatingLabelFixed: _react.PropTypes.bool,
	  /**
	   * The style object to use to override floating label styles when focused.
	   */
	  floatingLabelFocusStyle: _react.PropTypes.object,
	  /**
	   * The style object to use to override floating label styles.
	   */
	  floatingLabelStyle: _react.PropTypes.object,
	  /**
	   * The content to use for the floating label element.
	   */
	  floatingLabelText: _react.PropTypes.node,
	  /**
	   * If true, the field receives the property width 100%.
	   */
	  fullWidth: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of the TextField's hint text element.
	   */
	  hintStyle: _react.PropTypes.object,
	  /**
	   * The hint content to display.
	   */
	  hintText: _react.PropTypes.node,
	  /**
	   * The id prop for the text field.
	   */
	  id: _react.PropTypes.string,
	  /**
	   * Override the inline-styles of the TextField's input element.
	   * When multiLine is false: define the style of the input element.
	   * When multiLine is true: define the style of the container of the textarea.
	   */
	  inputStyle: _react.PropTypes.object,
	  /**
	   * If true, a textarea element will be rendered.
	   * The textarea also grows and shrinks according to the number of lines.
	   */
	  multiLine: _react.PropTypes.bool,
	  /**
	   * Name applied to the input.
	   */
	  name: _react.PropTypes.string,
	  /** @ignore */
	  onBlur: _react.PropTypes.func,
	  /**
	   * Callback function that is fired when the textfield's value changes.
	   */
	  onChange: _react.PropTypes.func,
	  /**
	   * The function to call when the user presses the Enter key.
	   */
	  onEnterKeyDown: (0, _deprecatedPropType2.default)(_react.PropTypes.func, 'Use onKeyDown and check for keycode instead. It will be removed with v0.16.0.'),
	  /** @ignore */
	  onFocus: _react.PropTypes.func,
	  /** @ignore */
	  onKeyDown: _react.PropTypes.func,
	  /**
	   * Number of rows to display when multiLine option is set to true.
	   */
	  rows: _react.PropTypes.number,
	  /**
	   * Maximum number of rows to display when
	   * multiLine option is set to true.
	   */
	  rowsMax: _react.PropTypes.number,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object,
	  /**
	   * Override the inline-styles of the TextField's textarea element.
	   * The TextField use either a textarea or an input,
	   * this property has effects only when multiLine is true.
	   */
	  textareaStyle: _react.PropTypes.object,
	  /**
	   * Specifies the type of input to display
	   * such as "password" or "text".
	   */
	  type: _react.PropTypes.string,
	  /**
	   * Override the inline-styles of the
	   * TextField's underline element when disabled.
	   */
	  underlineDisabledStyle: _react.PropTypes.object,
	  /**
	   * Override the inline-styles of the TextField's
	   * underline element when focussed.
	   */
	  underlineFocusStyle: _react.PropTypes.object,
	  /**
	   * If true, shows the underline for the text field.
	   */
	  underlineShow: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of the TextField's underline element.
	   */
	  underlineStyle: _react.PropTypes.object,
	  /**
	   * The value of the text field.
	   */
	  value: _react.PropTypes.any
	};
	TextField.defaultProps = {
	  disabled: false,
	  floatingLabelFixed: false,
	  multiLine: false,
	  fullWidth: false,
	  type: 'text',
	  underlineShow: true,
	  rows: 1
	};
	TextField.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	exports.default = TextField;

/***/ }),
/* 623 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.convertColorToString = convertColorToString;
	exports.convertHexToRGB = convertHexToRGB;
	exports.decomposeColor = decomposeColor;
	exports.getContrastRatio = getContrastRatio;
	exports.getLuminance = getLuminance;
	exports.emphasize = emphasize;
	exports.fade = fade;
	exports.darken = darken;
	exports.lighten = lighten;
	/**
	 * Returns a number whose value is limited to the given range.
	 *
	 * @param {number} value The value to be clamped
	 * @param {number} min The lower boundary of the output range
	 * @param {number} max The upper boundary of the output range
	 * @returns {number} A number in the range [min, max]
	 */
	function clamp(value, min, max) {
	  if (value < min) {
	    return min;
	  }
	  if (value > max) {
	    return max;
	  }
	  return value;
	}
	
	/**
	 * Converts a color object with type and values to a string.
	 *
	 * @param {object} color - Decomposed color
	 * @param {string} color.type - One of, 'rgb', 'rgba', 'hsl', 'hsla'
	 * @param {array} color.values - [n,n,n] or [n,n,n,n]
	 * @returns {string} A CSS color string
	 */
	function convertColorToString(color) {
	  var type = color.type;
	  var values = color.values;
	
	
	  if (type.indexOf('rgb') > -1) {
	    // Only convert the first 3 values to int (i.e. not alpha)
	    for (var i = 0; i < 3; i++) {
	      values[i] = parseInt(values[i]);
	    }
	  }
	
	  var colorString = void 0;
	
	  if (type.indexOf('hsl') > -1) {
	    colorString = color.type + '(' + values[0] + ', ' + values[1] + '%, ' + values[2] + '%';
	  } else {
	    colorString = color.type + '(' + values[0] + ', ' + values[1] + ', ' + values[2];
	  }
	
	  if (values.length === 4) {
	    colorString += ', ' + color.values[3] + ')';
	  } else {
	    colorString += ')';
	  }
	
	  return colorString;
	}
	
	/**
	 * Converts a color from CSS hex format to CSS rgb format.
	 *
	 *  @param {string} color - Hex color, i.e. #nnn or #nnnnnn
	 *  @returns {string} A CSS rgb color string
	 */
	function convertHexToRGB(color) {
	  if (color.length === 4) {
	    var extendedColor = '#';
	    for (var i = 1; i < color.length; i++) {
	      extendedColor += color.charAt(i) + color.charAt(i);
	    }
	    color = extendedColor;
	  }
	
	  var values = {
	    r: parseInt(color.substr(1, 2), 16),
	    g: parseInt(color.substr(3, 2), 16),
	    b: parseInt(color.substr(5, 2), 16)
	  };
	
	  return 'rgb(' + values.r + ', ' + values.g + ', ' + values.b + ')';
	}
	
	/**
	 * Returns an object with the type and values of a color.
	 *
	 * Note: Does not support rgb % values.
	 *
	 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
	 * @returns {{type: string, values: number[]}} A MUI color object
	 */
	function decomposeColor(color) {
	  if (color.charAt(0) === '#') {
	    return decomposeColor(convertHexToRGB(color));
	  }
	
	  var marker = color.indexOf('(');
	  var type = color.substring(0, marker);
	  var values = color.substring(marker + 1, color.length - 1).split(',');
	  values = values.map(function (value) {
	    return parseFloat(value);
	  });
	
	  return { type: type, values: values };
	}
	
	/**
	 * Calculates the contrast ratio between two colors.
	 *
	 * Formula: http://www.w3.org/TR/2008/REC-WCAG20-20081211/#contrast-ratiodef
	 *
	 * @param {string} foreground - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
	 * @param {string} background - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
	 * @returns {number} A contrast ratio value in the range 0 - 21 with 2 digit precision.
	 */
	function getContrastRatio(foreground, background) {
	  var lumA = getLuminance(foreground);
	  var lumB = getLuminance(background);
	  var contrastRatio = (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
	
	  return Number(contrastRatio.toFixed(2)); // Truncate at two digits
	}
	
	/**
	 * The relative brightness of any point in a color space,
	 * normalized to 0 for darkest black and 1 for lightest white.
	 *
	 * Formula: https://www.w3.org/WAI/GL/wiki/Relative_luminance
	 *
	 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
	 * @returns {number} The relative brightness of the color in the range 0 - 1
	 */
	function getLuminance(color) {
	  color = decomposeColor(color);
	
	  if (color.type.indexOf('rgb') > -1) {
	    var rgb = color.values.map(function (val) {
	      val /= 255; // normalized
	      return val <= 0.03928 ? val / 12.92 : Math.pow((val + 0.055) / 1.055, 2.4);
	    });
	    return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3)); // Truncate at 3 digits
	  } else if (color.type.indexOf('hsl') > -1) {
	    return color.values[2] / 100;
	  }
	}
	
	/**
	 * Darken or lighten a colour, depending on its luminance.
	 * Light colors are darkened, dark colors are lightened.
	 *
	 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
	 * @param {number} coefficient=0.15 - multiplier in the range 0 - 1
	 * @returns {string} A CSS color string. Hex input values are returned as rgb
	 */
	function emphasize(color) {
	  var coefficient = arguments.length <= 1 || arguments[1] === undefined ? 0.15 : arguments[1];
	
	  return getLuminance(color) > 0.5 ? darken(color, coefficient) : lighten(color, coefficient);
	}
	
	/**
	 * Set the absolute transparency of a color.
	 * Any existing alpha values are overwritten.
	 *
	 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
	 * @param {number} value - value to set the alpha channel to in the range 0 -1
	 * @returns {string} A CSS color string. Hex input values are returned as rgb
	 */
	function fade(color, value) {
	  color = decomposeColor(color);
	  value = clamp(value, 0, 1);
	
	  if (color.type === 'rgb' || color.type === 'hsl') {
	    color.type += 'a';
	  }
	  color.values[3] = value;
	
	  return convertColorToString(color);
	}
	
	/**
	 * Darkens a color.
	 *
	 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
	 * @param {number} coefficient - multiplier in the range 0 - 1
	 * @returns {string} A CSS color string. Hex input values are returned as rgb
	 */
	function darken(color, coefficient) {
	  color = decomposeColor(color);
	  coefficient = clamp(coefficient, 0, 1);
	
	  if (color.type.indexOf('hsl') > -1) {
	    color.values[2] *= 1 - coefficient;
	  } else if (color.type.indexOf('rgb') > -1) {
	    for (var i = 0; i < 3; i++) {
	      color.values[i] *= 1 - coefficient;
	    }
	  }
	  return convertColorToString(color);
	}
	
	/**
	 * Lightens a color.
	 *
	 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
	 * @param {number} coefficient - multiplier in the range 0 - 1
	 * @returns {string} A CSS color string. Hex input values are returned as rgb
	 */
	function lighten(color, coefficient) {
	  color = decomposeColor(color);
	  coefficient = clamp(coefficient, 0, 1);
	
	  if (color.type.indexOf('hsl') > -1) {
	    color.values[2] += (100 - color.values[2]) * coefficient;
	  } else if (color.type.indexOf('rgb') > -1) {
	    for (var i = 0; i < 3; i++) {
	      color.values[i] += (255 - color.values[i]) * coefficient;
	    }
	  }
	
	  return convertColorToString(color);
	}

/***/ }),
/* 624 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _simpleAssign = __webpack_require__(579);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactEventListener = __webpack_require__(625);
	
	var _reactEventListener2 = _interopRequireDefault(_reactEventListener);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var rowsHeight = 24;
	
	function getStyles(props, context, state) {
	  return {
	    root: {
	      position: 'relative' },
	    textarea: {
	      height: state.height,
	      width: '100%',
	      resize: 'none',
	      font: 'inherit',
	      padding: 0,
	      cursor: props.disabled ? 'not-allowed' : 'initial'
	    },
	    shadow: {
	      resize: 'none',
	      // Overflow also needed to here to remove the extra row
	      // added to textareas in Firefox.
	      overflow: 'hidden',
	      // Visibility needed to hide the extra text area on ipads
	      visibility: 'hidden',
	      position: 'absolute',
	      height: 'initial'
	    }
	  };
	}
	
	var EnhancedTextarea = function (_Component) {
	  _inherits(EnhancedTextarea, _Component);
	
	  function EnhancedTextarea() {
	    var _Object$getPrototypeO;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, EnhancedTextarea);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_Object$getPrototypeO = Object.getPrototypeOf(EnhancedTextarea)).call.apply(_Object$getPrototypeO, [this].concat(args))), _this), _this.state = {
	      height: null
	    }, _this.handleResize = function (event) {
	      _this.syncHeightWithShadow(undefined, event);
	    }, _this.handleChange = function (event) {
	      _this.syncHeightWithShadow(event.target.value);
	
	      if (_this.props.hasOwnProperty('valueLink')) {
	        _this.props.valueLink.requestChange(event.target.value);
	      }
	
	      if (_this.props.onChange) {
	        _this.props.onChange(event);
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(EnhancedTextarea, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.setState({
	        height: this.props.rows * rowsHeight
	      });
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.syncHeightWithShadow();
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.value !== this.props.value) {
	        this.syncHeightWithShadow(nextProps.value);
	      }
	    }
	  }, {
	    key: 'getInputNode',
	    value: function getInputNode() {
	      return this.refs.input;
	    }
	  }, {
	    key: 'setValue',
	    value: function setValue(value) {
	      this.getInputNode().value = value;
	      this.syncHeightWithShadow(value);
	    }
	  }, {
	    key: 'syncHeightWithShadow',
	    value: function syncHeightWithShadow(newValue, event) {
	      var shadow = this.refs.shadow;
	
	      if (newValue !== undefined) {
	        shadow.value = newValue;
	      }
	
	      var newHeight = shadow.scrollHeight;
	
	      if (this.props.rowsMax >= this.props.rows) {
	        newHeight = Math.min(this.props.rowsMax * rowsHeight, newHeight);
	      }
	
	      newHeight = Math.max(newHeight, rowsHeight);
	
	      if (this.state.height !== newHeight) {
	        this.setState({
	          height: newHeight
	        });
	
	        if (this.props.onHeightChange) {
	          this.props.onHeightChange(event, newHeight);
	        }
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var onChange = _props.onChange;
	      var onHeightChange = _props.onHeightChange;
	      var rows = _props.rows;
	      var rowsMax = _props.rowsMax;
	      var shadowStyle = _props.shadowStyle;
	      var style = _props.style;
	      var textareaStyle = _props.textareaStyle;
	      var valueLink = _props.valueLink;
	
	      var other = _objectWithoutProperties(_props, ['onChange', 'onHeightChange', 'rows', 'rowsMax', 'shadowStyle', 'style', 'textareaStyle', 'valueLink']);
	
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context, this.state);
	      var rootStyles = (0, _simpleAssign2.default)(styles.root, style);
	      var textareaStyles = (0, _simpleAssign2.default)(styles.textarea, textareaStyle);
	      var shadowStyles = (0, _simpleAssign2.default)({}, textareaStyles, styles.shadow, shadowStyle);
	
	      if (this.props.hasOwnProperty('valueLink')) {
	        other.value = this.props.valueLink.value;
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { style: prepareStyles(rootStyles) },
	        _react2.default.createElement(_reactEventListener2.default, { target: 'window', onResize: this.handleResize }),
	        _react2.default.createElement('textarea', {
	          ref: 'shadow',
	          style: prepareStyles(shadowStyles),
	          tabIndex: '-1',
	          rows: this.props.rows,
	          defaultValue: this.props.defaultValue,
	          readOnly: true,
	          value: this.props.value,
	          valueLink: this.props.valueLink
	        }),
	        _react2.default.createElement('textarea', _extends({}, other, {
	          ref: 'input',
	          rows: this.props.rows,
	          style: prepareStyles(textareaStyles),
	          onChange: this.handleChange
	        }))
	      );
	    }
	  }]);
	
	  return EnhancedTextarea;
	}(_react.Component);
	
	EnhancedTextarea.propTypes = {
	  defaultValue: _react.PropTypes.any,
	  disabled: _react.PropTypes.bool,
	  onChange: _react.PropTypes.func,
	  onHeightChange: _react.PropTypes.func,
	  rows: _react.PropTypes.number,
	  rowsMax: _react.PropTypes.number,
	  shadowStyle: _react.PropTypes.object,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object,
	  textareaStyle: _react.PropTypes.object,
	  value: _react.PropTypes.string,
	  valueLink: _react.PropTypes.object
	};
	EnhancedTextarea.defaultProps = {
	  rows: 1
	};
	EnhancedTextarea.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	exports.default = EnhancedTextarea;

/***/ }),
/* 625 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _shallowEqual = __webpack_require__(626);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function on(target, eventName, callback, capture) {
	  if (target.addEventListener) {
	    target.addEventListener(eventName, callback, capture);
	  } else if (target.attachEvent) {
	    // IE8+ Support
	    target.attachEvent('on' + eventName, function () {
	      callback.call(target);
	    });
	  }
	}
	function off(target, eventName, callback, capture) {
	  if (target.removeEventListener) {
	    target.removeEventListener(eventName, callback, capture);
	  } else if (target.detachEvent) {
	    // IE8+ Support
	    target.detachEvent('on' + eventName, callback);
	  }
	}
	
	function forEachListener(props, iteratee) {
	  for (var name in props) {
	    if (name.substring(0, 2) === 'on' && props[name] instanceof Function) {
	      var _eventName = name.substring(2).toLowerCase();
	      iteratee(_eventName, props[name]);
	    }
	  }
	}
	
	var EventListener = function (_Component) {
	  _inherits(EventListener, _Component);
	
	  function EventListener() {
	    _classCallCheck(this, EventListener);
	
	    return _possibleConstructorReturn(this, Object.getPrototypeOf(EventListener).apply(this, arguments));
	  }
	
	  _createClass(EventListener, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.addListeners();
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps) {
	      return !(0, _shallowEqual2.default)(this.props, nextProps);
	    }
	  }, {
	    key: 'componentWillUpdate',
	    value: function componentWillUpdate() {
	      this.removeListeners();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this.addListeners();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.removeListeners();
	    }
	  }, {
	    key: 'addListeners',
	    value: function addListeners() {
	      var _this2 = this;
	
	      var _props = this.props;
	      var capture = _props.capture;
	      var target = _props.target;
	
	
	      if (target) {
	        (function () {
	          var element = target;
	
	          if (typeof target === 'string') {
	            element = window[target];
	          }
	
	          forEachListener(_this2.props, function (eventName, listener) {
	            return on(element, eventName, listener, capture);
	          });
	        })();
	      }
	    }
	  }, {
	    key: 'removeListeners',
	    value: function removeListeners() {
	      var _this3 = this;
	
	      var _props2 = this.props;
	      var capture = _props2.capture;
	      var target = _props2.target;
	
	
	      if (target) {
	        (function () {
	          var element = target;
	
	          if (typeof target === 'string') {
	            element = window[target];
	          }
	
	          forEachListener(_this3.props, function (eventName, listener) {
	            return off(element, eventName, listener, capture);
	          });
	        })();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return this.props.children || null;
	    }
	  }]);
	
	  return EventListener;
	}(_react.Component);
	
	EventListener.propTypes = {
	  /**
	   * Whether to use capturing listeners.
	   */
	  capture: _react.PropTypes.bool.isRequired,
	  /**
	   * You can provide a children too.
	   */
	  children: _react.PropTypes.node,
	  /**
	   * The DOM target to listen to.
	   */
	  target: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.object, _react2.default.PropTypes.string])
	};
	EventListener.defaultProps = {
	  capture: false
	};
	exports.default = EventListener;

/***/ }),
/* 626 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 * 
	 */
	
	/*eslint-disable no-self-compare */
	
	'use strict';
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	/**
	 * inlined Object.is polyfill to avoid requiring consumers ship their own
	 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	 */
	function is(x, y) {
	  // SameValue algorithm
	  if (x === y) {
	    // Steps 1-5, 7-10
	    // Steps 6.b-6.e: +0 != -0
	    // Added the nonzero y check to make Flow happy, but it is redundant
	    return x !== 0 || y !== 0 || 1 / x === 1 / y;
	  } else {
	    // Step 6.a: NaN == NaN
	    return x !== x && y !== y;
	  }
	}
	
	/**
	 * Performs equality by iterating through keys on an object and returning false
	 * when any key has values which are not strictly equal between the arguments.
	 * Returns true when the values of all keys are strictly equal.
	 */
	function shallowEqual(objA, objB) {
	  if (is(objA, objB)) {
	    return true;
	  }
	
	  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  // Test for A's keys different from B.
	  for (var i = 0; i < keysA.length; i++) {
	    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	module.exports = shallowEqual;

/***/ }),
/* 627 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _simpleAssign = __webpack_require__(579);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _transitions = __webpack_require__(582);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props) {
	  var hintColor = props.muiTheme.textField.hintColor;
	  var show = props.show;
	
	
	  return {
	    root: {
	      position: 'absolute',
	      opacity: show ? 1 : 0,
	      color: hintColor,
	      transition: _transitions2.default.easeOut(),
	      bottom: 12
	    }
	  };
	}
	
	var TextFieldHint = function TextFieldHint(props) {
	  var prepareStyles = props.muiTheme.prepareStyles;
	  var style = props.style;
	  var text = props.text;
	
	
	  var styles = getStyles(props);
	
	  return _react2.default.createElement(
	    'div',
	    { style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) },
	    text
	  );
	};
	
	TextFieldHint.propTypes = {
	  /**
	   * @ignore
	   * The material-ui theme applied to this component.
	   */
	  muiTheme: _react.PropTypes.object.isRequired,
	  /**
	   * True if the hint text should be visible.
	   */
	  show: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object,
	  /**
	   * The hint text displayed.
	   */
	  text: _react.PropTypes.node
	};
	
	TextFieldHint.defaultProps = {
	  show: true
	};
	
	exports.default = TextFieldHint;

/***/ }),
/* 628 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _simpleAssign = __webpack_require__(579);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _transitions = __webpack_require__(582);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props) {
	  var defaultStyles = {
	    position: 'absolute',
	    lineHeight: '22px',
	    top: 38,
	    transition: _transitions2.default.easeOut(),
	    zIndex: 1, // Needed to display label above Chrome's autocomplete field background
	    cursor: props.disabled ? 'not-allowed' : 'text',
	    transform: 'scale(1) translate(0, 0)',
	    transformOrigin: 'left top',
	    pointerEvents: 'auto',
	    userSelect: 'none'
	  };
	
	  var shrinkStyles = props.shrink ? (0, _simpleAssign2.default)({
	    transform: 'scale(0.75) translate(0, -28px)',
	    pointerEvents: 'none'
	  }, props.shrinkStyle) : null;
	
	  return {
	    root: (0, _simpleAssign2.default)(defaultStyles, props.style, shrinkStyles)
	  };
	}
	
	var TextFieldLabel = function TextFieldLabel(props) {
	  var muiTheme = props.muiTheme;
	  var className = props.className;
	  var children = props.children;
	  var htmlFor = props.htmlFor;
	  var onTouchTap = props.onTouchTap;
	  var prepareStyles = muiTheme.prepareStyles;
	
	  var styles = getStyles(props);
	
	  return _react2.default.createElement(
	    'label',
	    {
	      className: className,
	      style: prepareStyles(styles.root),
	      htmlFor: htmlFor,
	      onTouchTap: onTouchTap
	    },
	    children
	  );
	};
	
	TextFieldLabel.propTypes = {
	  /**
	   * The label contents.
	   */
	  children: _react.PropTypes.node,
	  /**
	   * The css class name of the root element.
	   */
	  className: _react.PropTypes.string,
	  /**
	   * Disables the label if set to true.
	   */
	  disabled: _react.PropTypes.bool,
	  /**
	   * The id of the target element that this label should refer to.
	   */
	  htmlFor: _react.PropTypes.string,
	  /**
	   * @ignore
	   * The material-ui theme applied to this component.
	   */
	  muiTheme: _react.PropTypes.object.isRequired,
	  /**
	   * Callback function for when the label is selected via a touch tap.
	   */
	  onTouchTap: _react.PropTypes.func,
	  /**
	   * True if the floating label should shrink.
	   */
	  shrink: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of the root element when focused.
	   */
	  shrinkStyle: _react.PropTypes.object,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object
	};
	
	TextFieldLabel.defaultProps = {
	  disabled: false,
	  shrink: false
	};
	
	exports.default = TextFieldLabel;

/***/ }),
/* 629 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _simpleAssign = __webpack_require__(579);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _transitions = __webpack_require__(582);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  /**
	   * True if the parent `TextField` is disabled.
	   */
	  disabled: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of the underline when parent `TextField` is disabled.
	   */
	  disabledStyle: _react.PropTypes.object,
	  /**
	   * True if the parent `TextField` has an error.
	   */
	  error: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of the underline when parent `TextField` has an error.
	   */
	  errorStyle: _react.PropTypes.object,
	  /**
	   * True if the parent `TextField` is focused.
	   */
	  focus: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of the underline when parent `TextField` is focused.
	   */
	  focusStyle: _react.PropTypes.object,
	  /**
	   * @ignore
	   * The material-ui theme applied to this component.
	   */
	  muiTheme: _react.PropTypes.object.isRequired,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object
	};
	
	var defaultProps = {
	  disabled: false,
	  disabledStyle: {},
	  error: false,
	  errorStyle: {},
	  focus: false,
	  focusStyle: {},
	  style: {}
	};
	
	var TextFieldUnderline = function TextFieldUnderline(props) {
	  var disabled = props.disabled;
	  var disabledStyle = props.disabledStyle;
	  var error = props.error;
	  var errorStyle = props.errorStyle;
	  var focus = props.focus;
	  var focusStyle = props.focusStyle;
	  var muiTheme = props.muiTheme;
	  var style = props.style;
	  var errorStyleColor = errorStyle.color;
	  var prepareStyles = muiTheme.prepareStyles;
	  var _muiTheme$textField = muiTheme.textField;
	  var borderColor = _muiTheme$textField.borderColor;
	  var disabledTextColor = _muiTheme$textField.disabledTextColor;
	  var errorColor = _muiTheme$textField.errorColor;
	  var focusColor = _muiTheme$textField.focusColor;
	
	
	  var styles = {
	    root: {
	      border: 'none',
	      borderBottom: 'solid 1px',
	      borderColor: borderColor,
	      bottom: 8,
	      boxSizing: 'content-box',
	      margin: 0,
	      position: 'absolute',
	      width: '100%'
	    },
	    disabled: {
	      borderBottom: 'dotted 2px',
	      borderColor: disabledTextColor,
	      cursor: 'not-allowed'
	    },
	    focus: {
	      borderBottom: 'solid 2px',
	      borderColor: focusColor,
	      transform: 'scaleX(0)',
	      transition: _transitions2.default.easeOut()
	    },
	    error: {
	      borderColor: errorStyleColor ? errorStyleColor : errorColor,
	      transform: 'scaleX(1)'
	    }
	  };
	
	  var underline = (0, _simpleAssign2.default)({}, styles.root, style);
	  var focusedUnderline = (0, _simpleAssign2.default)({}, underline, styles.focus, focusStyle);
	
	  if (disabled) underline = (0, _simpleAssign2.default)({}, underline, styles.disabled, disabledStyle);
	  if (focus) focusedUnderline = (0, _simpleAssign2.default)({}, focusedUnderline, { transform: 'scaleX(1)' });
	  if (error) focusedUnderline = (0, _simpleAssign2.default)({}, focusedUnderline, styles.error);
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement('hr', { style: prepareStyles(underline) }),
	    _react2.default.createElement('hr', { style: prepareStyles(focusedUnderline) })
	  );
	};
	
	TextFieldUnderline.propTypes = propTypes;
	TextFieldUnderline.defaultProps = defaultProps;
	
	exports.default = TextFieldUnderline;

/***/ }),
/* 630 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.MenuItem = exports.Menu = undefined;
	
	var _Menu2 = __webpack_require__(631);
	
	var _Menu3 = _interopRequireDefault(_Menu2);
	
	var _MenuItem2 = __webpack_require__(637);
	
	var _MenuItem3 = _interopRequireDefault(_MenuItem2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Menu = _Menu3.default;
	exports.MenuItem = _MenuItem3.default;
	exports.default = _Menu3.default;

/***/ }),
/* 631 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _simpleAssign = __webpack_require__(579);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(332);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _shallowEqual = __webpack_require__(591);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	var _ClickAwayListener = __webpack_require__(632);
	
	var _ClickAwayListener2 = _interopRequireDefault(_ClickAwayListener);
	
	var _autoPrefix = __webpack_require__(593);
	
	var _autoPrefix2 = _interopRequireDefault(_autoPrefix);
	
	var _transitions = __webpack_require__(582);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _keycode = __webpack_require__(589);
	
	var _keycode2 = _interopRequireDefault(_keycode);
	
	var _propTypes = __webpack_require__(583);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _List = __webpack_require__(633);
	
	var _List2 = _interopRequireDefault(_List);
	
	var _deprecatedPropType = __webpack_require__(603);
	
	var _deprecatedPropType2 = _interopRequireDefault(_deprecatedPropType);
	
	var _warning = __webpack_require__(491);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _menuUtils = __webpack_require__(636);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _toArray(arr) { return Array.isArray(arr) ? arr : Array.from(arr); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function getStyles(props, context) {
	  var animated = props.animated;
	  var desktop = props.desktop;
	  var maxHeight = props.maxHeight;
	  var _props$openDirection = props.openDirection;
	  var openDirection = _props$openDirection === undefined ? 'bottom-left' : _props$openDirection;
	  var width = props.width;
	
	
	  var openDown = openDirection.split('-')[0] === 'bottom';
	  var openLeft = openDirection.split('-')[1] === 'left';
	
	  var muiTheme = context.muiTheme;
	
	
	  var styles = {
	    root: {
	      // Nested div bacause the List scales x faster than it scales y
	      transition: animated ? _transitions2.default.easeOut('250ms', 'transform') : null,
	      zIndex: muiTheme.zIndex.menu,
	      top: openDown ? 0 : null,
	      bottom: !openDown ? 0 : null,
	      left: !openLeft ? 0 : null,
	      right: openLeft ? 0 : null,
	      transform: animated ? 'scaleX(0)' : null,
	      transformOrigin: openLeft ? 'right' : 'left',
	      opacity: 0,
	      maxHeight: maxHeight,
	      overflowY: maxHeight ? 'auto' : null
	    },
	    divider: {
	      marginTop: 7,
	      marginBottom: 8
	    },
	    list: {
	      display: 'table-cell',
	      paddingBottom: desktop ? 16 : 8,
	      paddingTop: desktop ? 16 : 8,
	      userSelect: 'none',
	      width: width
	    },
	    menuItemContainer: {
	      transition: animated ? _transitions2.default.easeOut(null, 'opacity') : null,
	      opacity: 0
	    },
	    selectedMenuItem: {
	      color: muiTheme.baseTheme.palette.accent1Color
	    }
	  };
	
	  return styles;
	}
	
	var Menu = function (_Component) {
	  _inherits(Menu, _Component);
	
	  function Menu(props, context) {
	    _classCallCheck(this, Menu);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(Menu).call(this, props, context));
	
	    _initialiseProps.call(_this);
	
	    var filteredChildren = _this.getFilteredChildren(props.children);
	    var selectedIndex = _this.getSelectedIndex(props, filteredChildren);
	
	    _this.state = {
	      focusIndex: props.disableAutoFocus ? -1 : selectedIndex >= 0 ? selectedIndex : 0,
	      isKeyboardFocused: props.initiallyKeyboardFocused,
	      keyWidth: props.desktop ? 64 : 56
	    };
	
	    _this.hotKeyHolder = new _menuUtils.HotKeyHolder();
	    return _this;
	  }
	
	  _createClass(Menu, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (this.props.autoWidth) {
	        this.setWidth();
	      }
	      if (!this.props.animated) {
	        this.animateOpen();
	      }
	      this.setScollPosition();
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var filteredChildren = this.getFilteredChildren(nextProps.children);
	      var selectedIndex = this.getSelectedIndex(nextProps, filteredChildren);
	
	      this.setState({
	        focusIndex: nextProps.disableAutoFocus ? -1 : selectedIndex >= 0 ? selectedIndex : 0,
	        keyWidth: nextProps.desktop ? 64 : 56
	      });
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState, nextContext) {
	      return !(0, _shallowEqual2.default)(this.props, nextProps) || !(0, _shallowEqual2.default)(this.state, nextState) || !(0, _shallowEqual2.default)(this.context, nextContext);
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      if (this.props.autoWidth) this.setWidth();
	    }
	  }, {
	    key: 'getValueLink',
	
	
	    // Do not use outside of this component, it will be removed once valueLink is deprecated
	    value: function getValueLink(props) {
	      return props.valueLink || {
	        value: props.value,
	        requestChange: props.onChange
	      };
	    }
	  }, {
	    key: 'setKeyboardFocused',
	    value: function setKeyboardFocused(keyboardFocused) {
	      this.setState({
	        isKeyboardFocused: keyboardFocused
	      });
	    }
	  }, {
	    key: 'getFilteredChildren',
	    value: function getFilteredChildren(children) {
	      var filteredChildren = [];
	      _react2.default.Children.forEach(children, function (child) {
	        if (child) {
	          filteredChildren.push(child);
	        }
	      });
	      return filteredChildren;
	    }
	  }, {
	    key: 'animateOpen',
	    value: function animateOpen() {
	      var rootStyle = _reactDom2.default.findDOMNode(this).style;
	      var scrollContainerStyle = _reactDom2.default.findDOMNode(this.refs.scrollContainer).style;
	      var menuContainers = _reactDom2.default.findDOMNode(this.refs.list).childNodes;
	
	      _autoPrefix2.default.set(rootStyle, 'transform', 'scaleX(1)');
	      _autoPrefix2.default.set(scrollContainerStyle, 'transform', 'scaleY(1)');
	      scrollContainerStyle.opacity = 1;
	
	      for (var i = 0; i < menuContainers.length; ++i) {
	        menuContainers[i].style.opacity = 1;
	      }
	    }
	  }, {
	    key: 'cloneMenuItem',
	    value: function cloneMenuItem(child, childIndex, styles, index) {
	      var _this2 = this;
	
	      var _props = this.props;
	      var desktop = _props.desktop;
	      var selectedMenuItemStyle = _props.selectedMenuItemStyle;
	
	
	      var selected = this.isChildSelected(child, this.props);
	      var selectedChildrenStyles = {};
	
	      if (selected) {
	        selectedChildrenStyles = (0, _simpleAssign2.default)(styles.selectedMenuItem, selectedMenuItemStyle);
	      }
	
	      var mergedChildrenStyles = (0, _simpleAssign2.default)({}, child.props.style, selectedChildrenStyles);
	
	      var isFocused = childIndex === this.state.focusIndex;
	      var focusState = 'none';
	      if (isFocused) {
	        focusState = this.state.isKeyboardFocused ? 'keyboard-focused' : 'focused';
	      }
	
	      return _react2.default.cloneElement(child, {
	        desktop: desktop,
	        focusState: focusState,
	        onTouchTap: function onTouchTap(event) {
	          _this2.handleMenuItemTouchTap(event, child, index);
	          if (child.props.onTouchTap) child.props.onTouchTap(event);
	        },
	        ref: isFocused ? 'focusedMenuItem' : null,
	        style: mergedChildrenStyles
	      });
	    }
	  }, {
	    key: 'decrementKeyboardFocusIndex',
	    value: function decrementKeyboardFocusIndex() {
	      var index = this.state.focusIndex;
	
	      index--;
	      if (index < 0) index = 0;
	
	      this.setFocusIndex(index, true);
	    }
	  }, {
	    key: 'getCascadeChildrenCount',
	    value: function getCascadeChildrenCount(filteredChildren) {
	      var _props2 = this.props;
	      var desktop = _props2.desktop;
	      var maxHeight = _props2.maxHeight;
	
	      var count = 1;
	      var currentHeight = desktop ? 16 : 8;
	      var menuItemHeight = desktop ? 32 : 48;
	
	      // MaxHeight isn't set - cascade all of the children
	      if (!maxHeight) return filteredChildren.length;
	
	      // Count all the children that will fit inside the max menu height
	      filteredChildren.forEach(function (child) {
	        if (currentHeight < maxHeight) {
	          var childIsADivider = child.type && child.type.muiName === 'Divider';
	
	          currentHeight += childIsADivider ? 16 : menuItemHeight;
	          count++;
	        }
	      });
	
	      return count;
	    }
	  }, {
	    key: 'getMenuItemCount',
	    value: function getMenuItemCount(filteredChildren) {
	      var menuItemCount = 0;
	      filteredChildren.forEach(function (child) {
	        var childIsADivider = child.type && child.type.muiName === 'Divider';
	        var childIsDisabled = child.props.disabled;
	        if (!childIsADivider && !childIsDisabled) menuItemCount++;
	      });
	      return menuItemCount;
	    }
	  }, {
	    key: 'getSelectedIndex',
	    value: function getSelectedIndex(props, filteredChildren) {
	      var _this3 = this;
	
	      var selectedIndex = -1;
	      var menuItemIndex = 0;
	
	      filteredChildren.forEach(function (child) {
	        var childIsADivider = child.type && child.type.muiName === 'Divider';
	
	        if (_this3.isChildSelected(child, props)) selectedIndex = menuItemIndex;
	        if (!childIsADivider) menuItemIndex++;
	      });
	
	      return selectedIndex;
	    }
	  }, {
	    key: 'setFocusIndexStartsWith',
	    value: function setFocusIndexStartsWith(keys) {
	      var foundIndex = -1;
	      _react2.default.Children.forEach(this.props.children, function (child, index) {
	        if (foundIndex >= 0) {
	          return;
	        }
	        var primaryText = child.props.primaryText;
	
	        if (typeof primaryText === 'string' && new RegExp('^' + keys, 'i').test(primaryText)) {
	          foundIndex = index;
	        }
	      });
	      if (foundIndex >= 0) {
	        this.setFocusIndex(foundIndex, true);
	        return true;
	      }
	      return false;
	    }
	  }, {
	    key: 'handleMenuItemTouchTap',
	    value: function handleMenuItemTouchTap(event, item, index) {
	      var children = this.props.children;
	      var multiple = this.props.multiple;
	      var valueLink = this.getValueLink(this.props);
	      var menuValue = valueLink.value;
	      var itemValue = item.props.value;
	      var focusIndex = _react2.default.isValidElement(children) ? 0 : children.indexOf(item);
	
	      this.setFocusIndex(focusIndex, false);
	
	      if (multiple) {
	        var itemIndex = menuValue.indexOf(itemValue);
	
	        var _menuValue = _toArray(menuValue);
	
	        var newMenuValue = _menuValue;
	
	        if (itemIndex === -1) {
	          newMenuValue.push(itemValue);
	        } else {
	          newMenuValue.splice(itemIndex, 1);
	        }
	
	        valueLink.requestChange(event, newMenuValue);
	      } else if (!multiple && itemValue !== menuValue) {
	        valueLink.requestChange(event, itemValue);
	      }
	
	      this.props.onItemTouchTap(event, item, index);
	    }
	  }, {
	    key: 'incrementKeyboardFocusIndex',
	    value: function incrementKeyboardFocusIndex(filteredChildren) {
	      var index = this.state.focusIndex;
	      var maxIndex = this.getMenuItemCount(filteredChildren) - 1;
	
	      index++;
	      if (index > maxIndex) index = maxIndex;
	
	      this.setFocusIndex(index, true);
	    }
	  }, {
	    key: 'isChildSelected',
	    value: function isChildSelected(child, props) {
	      var menuValue = this.getValueLink(props).value;
	      var childValue = child.props.value;
	
	      if (props.multiple) {
	        return menuValue.length && menuValue.indexOf(childValue) !== -1;
	      } else {
	        return child.props.hasOwnProperty('value') && menuValue === childValue;
	      }
	    }
	  }, {
	    key: 'setFocusIndex',
	    value: function setFocusIndex(newIndex, isKeyboardFocused) {
	      this.setState({
	        focusIndex: newIndex,
	        isKeyboardFocused: isKeyboardFocused
	      });
	    }
	  }, {
	    key: 'setScollPosition',
	    value: function setScollPosition() {
	      var desktop = this.props.desktop;
	      var focusedMenuItem = this.refs.focusedMenuItem;
	      var menuItemHeight = desktop ? 32 : 48;
	
	      if (focusedMenuItem) {
	        var selectedOffSet = _reactDom2.default.findDOMNode(focusedMenuItem).offsetTop;
	
	        // Make the focused item be the 2nd item in the list the user sees
	        var scrollTop = selectedOffSet - menuItemHeight;
	        if (scrollTop < menuItemHeight) scrollTop = 0;
	
	        _reactDom2.default.findDOMNode(this.refs.scrollContainer).scrollTop = scrollTop;
	      }
	    }
	  }, {
	    key: 'setWidth',
	    value: function setWidth() {
	      var el = _reactDom2.default.findDOMNode(this);
	      var listEl = _reactDom2.default.findDOMNode(this.refs.list);
	      var elWidth = el.offsetWidth;
	      var keyWidth = this.state.keyWidth;
	      var minWidth = keyWidth * 1.5;
	      var keyIncrements = elWidth / keyWidth;
	      var newWidth = void 0;
	
	      keyIncrements = keyIncrements <= 1.5 ? 1.5 : Math.ceil(keyIncrements);
	      newWidth = keyIncrements * keyWidth;
	
	      if (newWidth < minWidth) newWidth = minWidth;
	
	      el.style.width = newWidth + 'px';
	      listEl.style.width = newWidth + 'px';
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var _props3 = this.props;
	      var animated = _props3.animated;
	      var autoWidth = _props3.autoWidth;
	      var children = _props3.children;
	      var desktop = _props3.desktop;
	      var disableAutoFocus = _props3.disableAutoFocus;
	      var initiallyKeyboardFocused = _props3.initiallyKeyboardFocused;
	      var listStyle = _props3.listStyle;
	      var maxHeight = _props3.maxHeight;
	      var multiple = _props3.multiple;
	      var _props3$openDirection = _props3.openDirection;
	      var openDirection = _props3$openDirection === undefined ? 'bottom-left' : _props3$openDirection;
	      var onItemTouchTap = _props3.onItemTouchTap;
	      var onEscKeyDown = _props3.onEscKeyDown;
	      var selectedMenuItemStyle = _props3.selectedMenuItemStyle;
	      var style = _props3.style;
	      var value = _props3.value;
	      var valueLink = _props3.valueLink;
	      var width = _props3.width;
	      var zDepth = _props3.zDepth;
	
	      var other = _objectWithoutProperties(_props3, ['animated', 'autoWidth', 'children', 'desktop', 'disableAutoFocus', 'initiallyKeyboardFocused', 'listStyle', 'maxHeight', 'multiple', 'openDirection', 'onItemTouchTap', 'onEscKeyDown', 'selectedMenuItemStyle', 'style', 'value', 'valueLink', 'width', 'zDepth']);
	
	       false ? (0, _warning2.default)(typeof zDepth === 'undefined', 'Menu no longer supports `zDepth`. Instead, wrap it in `Paper` ' + 'or another component that provides `zDepth`. It will be removed with v0.16.0.') : void 0;
	
	      var focusIndex = this.state.focusIndex;
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      var mergedRootStyles = (0, _simpleAssign2.default)(styles.root, style);
	      var mergedListStyles = (0, _simpleAssign2.default)(styles.list, listStyle);
	
	      var openDown = openDirection.split('-')[0] === 'bottom';
	      var filteredChildren = this.getFilteredChildren(children);
	
	      // Cascade children opacity
	      var cumulativeDelay = openDown ? 175 : 325;
	      var cascadeChildrenCount = this.getCascadeChildrenCount(filteredChildren);
	      var cumulativeDelayIncrement = Math.ceil(150 / cascadeChildrenCount);
	
	      var menuItemIndex = 0;
	      var newChildren = _react2.default.Children.map(filteredChildren, function (child, index) {
	        var childIsADivider = child.type && child.type.muiName === 'Divider';
	        var childIsDisabled = child.props.disabled;
	        var childrenContainerStyles = {};
	
	        if (animated) {
	          var transitionDelay = 0;
	
	          // Only cascade the visible menu items
	          if (menuItemIndex >= focusIndex - 1 && menuItemIndex <= focusIndex + cascadeChildrenCount - 1) {
	            cumulativeDelay = openDown ? cumulativeDelay + cumulativeDelayIncrement : cumulativeDelay - cumulativeDelayIncrement;
	            transitionDelay = cumulativeDelay;
	          }
	
	          childrenContainerStyles = (0, _simpleAssign2.default)({}, styles.menuItemContainer, {
	            transitionDelay: transitionDelay + 'ms'
	          });
	        }
	
	        var clonedChild = childIsADivider ? _react2.default.cloneElement(child, { style: styles.divider }) : childIsDisabled ? _react2.default.cloneElement(child, { desktop: desktop }) : _this4.cloneMenuItem(child, menuItemIndex, styles, index);
	
	        if (!childIsADivider && !childIsDisabled) menuItemIndex++;
	
	        return animated ? _react2.default.createElement(
	          'div',
	          { style: prepareStyles(childrenContainerStyles) },
	          clonedChild
	        ) : clonedChild;
	      });
	
	      return _react2.default.createElement(
	        _ClickAwayListener2.default,
	        { onClickAway: this.handleClickAway },
	        _react2.default.createElement(
	          'div',
	          {
	            onKeyDown: this.handleKeyDown,
	            style: prepareStyles(mergedRootStyles),
	            ref: 'scrollContainer'
	          },
	          _react2.default.createElement(
	            _List2.default,
	            _extends({}, other, {
	              ref: 'list',
	              style: mergedListStyles
	            }),
	            newChildren
	          )
	        )
	      );
	    }
	  }]);
	
	  return Menu;
	}(_react.Component);
	
	Menu.propTypes = {
	  /**
	   * If true, the menu will apply transitions when it
	   * is added to the DOM. In order for transitions to
	   * work, wrap the menu inside a `ReactTransitionGroup`.
	   */
	  animated: (0, _deprecatedPropType2.default)(_react.PropTypes.bool, 'Instead, use a [Popover](/#/components/popover).\n      It will be removed with v0.16.0.'),
	  /**
	   * If true, the width of the menu will be set automatically
	   * according to the widths of its children,
	   * using proper keyline increments (64px for desktop,
	   * 56px otherwise).
	   */
	  autoWidth: _react.PropTypes.bool,
	  /**
	   * The content of the menu. This is usually used to pass `MenuItem`
	   * elements.
	   */
	  children: _react.PropTypes.node,
	  /**
	   * If true, the menu item will render with compact desktop styles.
	   */
	  desktop: _react.PropTypes.bool,
	  /**
	   * If true, the menu will not be auto-focused.
	   */
	  disableAutoFocus: _react.PropTypes.bool,
	  /**
	   * If true, the menu will be keyboard-focused initially.
	   */
	  initiallyKeyboardFocused: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of the underlying `List` element.
	   */
	  listStyle: _react.PropTypes.object,
	  /**
	   * The maximum height of the menu in pixels. If specified,
	   * the menu will be scrollable if it is taller than the provided
	   * height.
	   */
	  maxHeight: _react.PropTypes.number,
	  /**
	   * If true, `value` must be an array and the menu will support
	   * multiple selections.
	   */
	  multiple: _react.PropTypes.bool,
	  /**
	   * Callback function fired when a menu item with `value` not
	   * equal to the current `value` of the menu is touch-tapped.
	   *
	   * @param {object} event TouchTap event targeting the menu item.
	   * @param {any}  value If `multiple` is true, the menu's `value`
	   * array with either the menu item's `value` added (if
	   * it wasn't already selected) or omitted (if it was already selected).
	   * Otherwise, the `value` of the menu item.
	   */
	  onChange: _react.PropTypes.func,
	  /**
	   * Callback function fired when the menu is focused and the *Esc* key
	   * is pressed.
	   *
	   * @param {object} event `keydown` event targeting the menu.
	   */
	  onEscKeyDown: _react.PropTypes.func,
	  /**
	   * Callback function fired when a menu item is touch-tapped.
	   *
	   * @param {object} event TouchTap event targeting the menu item.
	   * @param {object} menuItem The menu item.
	   * @param {number} index The index of the menu item.
	   */
	  onItemTouchTap: _react.PropTypes.func,
	  /** @ignore */
	  onKeyDown: _react.PropTypes.func,
	  /**
	   * This is the placement of the menu relative to the `IconButton`.
	   */
	  openDirection: (0, _deprecatedPropType2.default)(_propTypes2.default.corners, 'Instead, use a [Popover](/#/components/popover).\n      It will be removed with v0.16.0.'),
	  /**
	   * Override the inline-styles of selected menu items.
	   */
	  selectedMenuItemStyle: _react.PropTypes.object,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object,
	  /**
	   * If `multiple` is true, an array of the `value`s of the selected
	   * menu items. Otherwise, the `value` of the selected menu item.
	   * If provided, the menu will be a controlled component.
	   * This component also supports valueLink.
	   */
	  value: _react.PropTypes.any,
	  /**
	   * ValueLink for the menu's `value`.
	   */
	  valueLink: _react.PropTypes.object,
	  /**
	   * The width of the menu. If not specified, the menu's width
	   * will be set according to the widths of its children, using
	   * proper keyline increments (64px for desktop, 56px otherwise).
	   */
	  width: _propTypes2.default.stringOrNumber,
	  /**
	   * @ignore
	   * Menu no longer supports `zDepth`. Instead, wrap it in `Paper`
	   * or another component that provides zDepth.
	   */
	  zDepth: _propTypes2.default.zDepth
	};
	Menu.defaultProps = {
	  autoWidth: true,
	  desktop: false,
	  disableAutoFocus: false,
	  initiallyKeyboardFocused: false,
	  maxHeight: null,
	  multiple: false,
	  onChange: function onChange() {},
	  onEscKeyDown: function onEscKeyDown() {},
	  onItemTouchTap: function onItemTouchTap() {},
	  onKeyDown: function onKeyDown() {}
	};
	Menu.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	
	var _initialiseProps = function _initialiseProps() {
	  var _this5 = this;
	
	  this.handleClickAway = function (event) {
	    if (event.defaultPrevented) {
	      return;
	    }
	
	    _this5.setFocusIndex(-1, false);
	  };
	
	  this.handleKeyDown = function (event) {
	    var filteredChildren = _this5.getFilteredChildren(_this5.props.children);
	    var key = (0, _keycode2.default)(event);
	    switch (key) {
	      case 'down':
	        event.preventDefault();
	        _this5.incrementKeyboardFocusIndex(filteredChildren);
	        break;
	      case 'esc':
	        _this5.props.onEscKeyDown(event);
	        break;
	      case 'tab':
	        event.preventDefault();
	        if (event.shiftKey) {
	          _this5.decrementKeyboardFocusIndex();
	        } else {
	          _this5.incrementKeyboardFocusIndex(filteredChildren);
	        }
	        break;
	      case 'up':
	        event.preventDefault();
	        _this5.decrementKeyboardFocusIndex();
	        break;
	      default:
	        if (key && key.length === 1) {
	          var hotKeys = _this5.hotKeyHolder.append(key);
	          if (_this5.setFocusIndexStartsWith(hotKeys)) {
	            event.preventDefault();
	          }
	        }
	    }
	    _this5.props.onKeyDown(event);
	  };
	};
	
	exports.default = Menu;

/***/ }),
/* 632 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _reactDom = __webpack_require__(332);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _events = __webpack_require__(588);
	
	var _events2 = _interopRequireDefault(_events);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var isDescendant = function isDescendant(el, target) {
	  if (target !== null) {
	    return el === target || isDescendant(el, target.parentNode);
	  }
	  return false;
	};
	
	var clickAwayEvents = ['mouseup', 'touchend'];
	var bind = function bind(callback) {
	  return clickAwayEvents.forEach(function (event) {
	    return _events2.default.on(document, event, callback);
	  });
	};
	var unbind = function unbind(callback) {
	  return clickAwayEvents.forEach(function (event) {
	    return _events2.default.off(document, event, callback);
	  });
	};
	
	var ClickAwayListener = function (_Component) {
	  _inherits(ClickAwayListener, _Component);
	
	  function ClickAwayListener() {
	    var _Object$getPrototypeO;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ClickAwayListener);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_Object$getPrototypeO = Object.getPrototypeOf(ClickAwayListener)).call.apply(_Object$getPrototypeO, [this].concat(args))), _this), _this.handleClickAway = function (event) {
	      if (event.defaultPrevented) {
	        return;
	      }
	
	      // IE11 support, which trigger the handleClickAway even after the unbind
	      if (_this.isCurrentlyMounted) {
	        var el = _reactDom2.default.findDOMNode(_this);
	
	        if (document.documentElement.contains(event.target) && !isDescendant(el, event.target)) {
	          _this.props.onClickAway(event);
	        }
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(ClickAwayListener, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.isCurrentlyMounted = true;
	      if (this.props.onClickAway) {
	        bind(this.handleClickAway);
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      if (prevProps.onClickAway !== this.props.onClickAway) {
	        unbind(this.handleClickAway);
	        if (this.props.onClickAway) {
	          bind(this.handleClickAway);
	        }
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.isCurrentlyMounted = false;
	      unbind(this.handleClickAway);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return this.props.children;
	    }
	  }]);
	
	  return ClickAwayListener;
	}(_react.Component);
	
	ClickAwayListener.propTypes = {
	  children: _react.PropTypes.node,
	  onClickAway: _react.PropTypes.any
	};
	exports.default = ClickAwayListener;

/***/ }),
/* 633 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _simpleAssign = __webpack_require__(579);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(583);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Subheader = __webpack_require__(634);
	
	var _Subheader2 = _interopRequireDefault(_Subheader);
	
	var _deprecatedPropType = __webpack_require__(603);
	
	var _deprecatedPropType2 = _interopRequireDefault(_deprecatedPropType);
	
	var _warning = __webpack_require__(491);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var List = function (_Component) {
	  _inherits(List, _Component);
	
	  function List() {
	    _classCallCheck(this, List);
	
	    return _possibleConstructorReturn(this, Object.getPrototypeOf(List).apply(this, arguments));
	  }
	
	  _createClass(List, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var children = _props.children;
	      var _props$insetSubheader = _props.insetSubheader;
	      var insetSubheader = _props$insetSubheader === undefined ? false : _props$insetSubheader;
	      var style = _props.style;
	      var subheader = _props.subheader;
	      var subheaderStyle = _props.subheaderStyle;
	      var zDepth = _props.zDepth;
	
	      var other = _objectWithoutProperties(_props, ['children', 'insetSubheader', 'style', 'subheader', 'subheaderStyle', 'zDepth']);
	
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	
	       false ? (0, _warning2.default)(typeof zDepth === 'undefined', 'List no longer supports `zDepth`. Instead, wrap it in `Paper` ' + 'or another component that provides zDepth. It will be removed with v0.16.0.') : void 0;
	
	      var hasSubheader = false;
	
	      if (subheader) {
	        hasSubheader = true;
	      } else {
	        var firstChild = _react.Children.toArray(children)[0];
	        if ((0, _react.isValidElement)(firstChild) && firstChild.type === _Subheader2.default) {
	          hasSubheader = true;
	        }
	      }
	
	      var styles = {
	        root: {
	          padding: 0,
	          paddingBottom: 8,
	          paddingTop: hasSubheader ? 0 : 8
	        }
	      };
	
	      return _react2.default.createElement(
	        'div',
	        _extends({}, other, { style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) }),
	        subheader && _react2.default.createElement(
	          _Subheader2.default,
	          { inset: insetSubheader, style: subheaderStyle },
	          subheader
	        ),
	        children
	      );
	    }
	  }]);
	
	  return List;
	}(_react.Component);
	
	List.propTypes = {
	  /**
	   * These are usually `ListItem`s that are passed to
	   * be part of the list.
	   */
	  children: _react.PropTypes.node,
	  /**
	   * If true, the subheader will be indented by 72px.
	   */
	  insetSubheader: (0, _deprecatedPropType2.default)(_react.PropTypes.bool, 'Refer to the `subheader` property. It will be removed with v0.16.0.'),
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object,
	  /**
	   * The subheader string that will be displayed at the top of the list.
	   */
	  subheader: (0, _deprecatedPropType2.default)(_react.PropTypes.node, 'Instead, nest the `Subheader` component directly inside the `List`. It will be removed with v0.16.0.'),
	  /**
	   * Override the inline-styles of the subheader element.
	   */
	  subheaderStyle: (0, _deprecatedPropType2.default)(_react.PropTypes.object, 'Refer to the `subheader` property. It will be removed with v0.16.0.'),
	  /**
	   * @ignore
	   * ** Breaking change ** List no longer supports `zDepth`. Instead, wrap it in `Paper`
	   * or another component that provides zDepth.
	   */
	  zDepth: _propTypes2.default.zDepth
	};
	List.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	exports.default = List;

/***/ }),
/* 634 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _Subheader = __webpack_require__(635);
	
	var _Subheader2 = _interopRequireDefault(_Subheader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Subheader2.default;

/***/ }),
/* 635 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _simpleAssign = __webpack_require__(579);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var propTypes = {
	  /**
	   * Node that will be placed inside the `Subheader`.
	   */
	  children: _react.PropTypes.node,
	  /**
	   * If true, the `Subheader` will be indented by `72px`.
	   */
	  inset: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object
	};
	
	var defaultProps = {
	  inset: false
	};
	
	var contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	
	var Subheader = function Subheader(props, context) {
	  var children = props.children;
	  var inset = props.inset;
	  var style = props.style;
	
	  var other = _objectWithoutProperties(props, ['children', 'inset', 'style']);
	
	  var _context$muiTheme = context.muiTheme;
	  var prepareStyles = _context$muiTheme.prepareStyles;
	  var subheader = _context$muiTheme.subheader;
	
	
	  var styles = {
	    root: {
	      boxSizing: 'border-box',
	      color: subheader.color,
	      fontSize: 14,
	      fontWeight: subheader.fontWeight,
	      lineHeight: '48px',
	      paddingLeft: inset ? 72 : 16,
	      width: '100%'
	    }
	  };
	
	  return _react2.default.createElement(
	    'div',
	    _extends({}, other, { style: prepareStyles((0, _simpleAssign2.default)({}, styles.root, style)) }),
	    children
	  );
	};
	
	Subheader.muiName = 'Subheader';
	Subheader.propTypes = propTypes;
	Subheader.defaultProps = defaultProps;
	Subheader.contextTypes = contextTypes;
	
	exports.default = Subheader;

/***/ }),
/* 636 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var HotKeyHolder = exports.HotKeyHolder = function () {
	  function HotKeyHolder() {
	    var _this = this;
	
	    _classCallCheck(this, HotKeyHolder);
	
	    this.clear = function () {
	      _this.timerId = null;
	      _this.lastKeys = null;
	    };
	  }
	
	  _createClass(HotKeyHolder, [{
	    key: 'append',
	    value: function append(key) {
	      clearTimeout(this.timerId);
	      this.timerId = setTimeout(this.clear, 500);
	      return this.lastKeys = (this.lastKeys || '') + key;
	    }
	  }]);
	
	  return HotKeyHolder;
	}();

/***/ }),
/* 637 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _MenuItem = __webpack_require__(638);
	
	var _MenuItem2 = _interopRequireDefault(_MenuItem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _MenuItem2.default;

/***/ }),
/* 638 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _simpleAssign = __webpack_require__(579);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(332);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _shallowEqual = __webpack_require__(591);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	var _Popover = __webpack_require__(639);
	
	var _Popover2 = _interopRequireDefault(_Popover);
	
	var _check = __webpack_require__(657);
	
	var _check2 = _interopRequireDefault(_check);
	
	var _ListItem = __webpack_require__(658);
	
	var _ListItem2 = _interopRequireDefault(_ListItem);
	
	var _Menu = __webpack_require__(631);
	
	var _Menu2 = _interopRequireDefault(_Menu);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var nestedMenuStyle = {
	  position: 'relative'
	};
	
	function getStyles(props, context) {
	  var disabledColor = context.muiTheme.baseTheme.palette.disabledColor;
	  var textColor = context.muiTheme.baseTheme.palette.textColor;
	  var leftIndent = props.desktop ? 64 : 72;
	  var sidePadding = props.desktop ? 24 : 16;
	
	  var styles = {
	    root: {
	      color: props.disabled ? disabledColor : textColor,
	      cursor: props.disabled ? 'not-allowed' : 'pointer',
	      lineHeight: props.desktop ? '32px' : '48px',
	      fontSize: props.desktop ? 15 : 16,
	      whiteSpace: 'nowrap'
	    },
	
	    innerDivStyle: {
	      paddingLeft: props.leftIcon || props.insetChildren || props.checked ? leftIndent : sidePadding,
	      paddingRight: sidePadding,
	      paddingBottom: 0,
	      paddingTop: 0
	    },
	
	    secondaryText: {
	      float: 'right'
	    },
	
	    leftIconDesktop: {
	      margin: 0,
	      left: 24,
	      top: 4
	    },
	
	    rightIconDesktop: {
	      margin: 0,
	      right: 24,
	      top: 4,
	      fill: context.muiTheme.menuItem.rightIconDesktopFill
	    }
	  };
	
	  return styles;
	}
	
	var MenuItem = function (_Component) {
	  _inherits(MenuItem, _Component);
	
	  function MenuItem() {
	    var _Object$getPrototypeO;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, MenuItem);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_Object$getPrototypeO = Object.getPrototypeOf(MenuItem)).call.apply(_Object$getPrototypeO, [this].concat(args))), _this), _this.state = {
	      open: false
	    }, _this.cloneMenuItem = function (item) {
	      return _react2.default.cloneElement(item, {
	        onTouchTap: function onTouchTap(event) {
	          if (!item.props.menuItems) {
	            _this.handleRequestClose();
	          }
	
	          if (item.props.onTouchTap) {
	            item.props.onTouchTap(event);
	          }
	        }
	      });
	    }, _this.handleTouchTap = function (event) {
	      event.preventDefault();
	
	      _this.setState({
	        open: true,
	        anchorEl: _reactDom2.default.findDOMNode(_this)
	      });
	
	      if (_this.props.onTouchTap) {
	        _this.props.onTouchTap(event);
	      }
	    }, _this.handleRequestClose = function () {
	      _this.setState({
	        open: false,
	        anchorEl: null
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(MenuItem, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.applyFocusState();
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.state.open && nextProps.focusState === 'none') {
	        this.handleRequestClose();
	      }
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState, nextContext) {
	      return !(0, _shallowEqual2.default)(this.props, nextProps) || !(0, _shallowEqual2.default)(this.state, nextState) || !(0, _shallowEqual2.default)(this.context, nextContext);
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this.applyFocusState();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this.state.open) {
	        this.setState({
	          open: false
	        });
	      }
	    }
	  }, {
	    key: 'applyFocusState',
	    value: function applyFocusState() {
	      this.refs.listItem.applyFocusState(this.props.focusState);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var checked = _props.checked;
	      var children = _props.children;
	      var desktop = _props.desktop;
	      var disabled = _props.disabled;
	      var focusState = _props.focusState;
	      var innerDivStyle = _props.innerDivStyle;
	      var insetChildren = _props.insetChildren;
	      var leftIcon = _props.leftIcon;
	      var menuItems = _props.menuItems;
	      var rightIcon = _props.rightIcon;
	      var secondaryText = _props.secondaryText;
	      var style = _props.style;
	      var animation = _props.animation;
	      var value = _props.value;
	
	      var other = _objectWithoutProperties(_props, ['checked', 'children', 'desktop', 'disabled', 'focusState', 'innerDivStyle', 'insetChildren', 'leftIcon', 'menuItems', 'rightIcon', 'secondaryText', 'style', 'animation', 'value']);
	
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	      var mergedRootStyles = (0, _simpleAssign2.default)(styles.root, style);
	      var mergedInnerDivStyles = (0, _simpleAssign2.default)(styles.innerDivStyle, innerDivStyle);
	
	      // Left Icon
	      var leftIconElement = leftIcon ? leftIcon : checked ? _react2.default.createElement(_check2.default, null) : null;
	      if (leftIconElement) {
	        var mergedLeftIconStyles = desktop ? (0, _simpleAssign2.default)(styles.leftIconDesktop, leftIconElement.props.style) : leftIconElement.props.style;
	        leftIconElement = _react2.default.cloneElement(leftIconElement, { style: mergedLeftIconStyles });
	      }
	
	      // Right Icon
	      var rightIconElement = void 0;
	      if (rightIcon) {
	        var mergedRightIconStyles = desktop ? (0, _simpleAssign2.default)(styles.rightIconDesktop, rightIcon.props.style) : rightIcon.props.style;
	        rightIconElement = _react2.default.cloneElement(rightIcon, { style: mergedRightIconStyles });
	      }
	
	      // Secondary Text
	      var secondaryTextElement = void 0;
	      if (secondaryText) {
	        var secondaryTextIsAnElement = _react2.default.isValidElement(secondaryText);
	        var mergedSecondaryTextStyles = secondaryTextIsAnElement ? (0, _simpleAssign2.default)(styles.secondaryText, secondaryText.props.style) : null;
	
	        secondaryTextElement = secondaryTextIsAnElement ? _react2.default.cloneElement(secondaryText, { style: mergedSecondaryTextStyles }) : _react2.default.createElement(
	          'div',
	          { style: prepareStyles(styles.secondaryText) },
	          secondaryText
	        );
	      }
	      var childMenuPopover = void 0;
	      if (menuItems) {
	        childMenuPopover = _react2.default.createElement(
	          _Popover2.default,
	          {
	            animation: animation,
	            anchorOrigin: { horizontal: 'right', vertical: 'top' },
	            anchorEl: this.state.anchorEl,
	            open: this.state.open,
	            useLayerForClickAway: false,
	            onRequestClose: this.handleRequestClose
	          },
	          _react2.default.createElement(
	            _Menu2.default,
	            { desktop: desktop, disabled: disabled, style: nestedMenuStyle },
	            _react2.default.Children.map(menuItems, this.cloneMenuItem)
	          )
	        );
	        other.onTouchTap = this.handleTouchTap;
	      }
	
	      return _react2.default.createElement(
	        _ListItem2.default,
	        _extends({}, other, {
	          disabled: disabled,
	          innerDivStyle: mergedInnerDivStyles,
	          insetChildren: insetChildren,
	          leftIcon: leftIconElement,
	          ref: 'listItem',
	          rightIcon: rightIconElement,
	          style: mergedRootStyles
	        }),
	        children,
	        secondaryTextElement,
	        childMenuPopover
	      );
	    }
	  }]);
	
	  return MenuItem;
	}(_react.Component);
	
	MenuItem.muiName = 'MenuItem';
	MenuItem.propTypes = {
	  /**
	   * Override the default animation component used.
	   */
	  animation: _react.PropTypes.func,
	  /**
	   * If true, a left check mark will be rendered.
	   */
	  checked: _react.PropTypes.bool,
	  /**
	   * Elements passed as children to the underlying `ListItem`.
	   */
	  children: _react.PropTypes.node,
	  /**
	   * @ignore
	   * If true, the menu item will render with compact desktop
	   * styles.
	   */
	  desktop: _react.PropTypes.bool,
	  /**
	   * If true, the menu item will be disabled.
	   */
	  disabled: _react.PropTypes.bool,
	  /**
	   * The focus state of the menu item. This prop is used to set the focus
	   * state of the underlying `ListItem`.
	   */
	  focusState: _react.PropTypes.oneOf(['none', 'focused', 'keyboard-focused']),
	  /**
	   * Override the inline-styles of the inner div.
	   */
	  innerDivStyle: _react.PropTypes.object,
	  /**
	   * If true, the children will be indented.
	   * This is only needed when there is no `leftIcon`.
	   */
	  insetChildren: _react.PropTypes.bool,
	  /**
	   * The `SvgIcon` or `FontIcon` to be displayed on the left side.
	   */
	  leftIcon: _react.PropTypes.element,
	  /**
	   * `MenuItem` elements to nest within the menu item.
	   */
	  menuItems: _react.PropTypes.node,
	  /**
	   * Callback function fired when the menu item is touch-tapped.
	   *
	   * @param {object} event TouchTap event targeting the menu item.
	   */
	  onTouchTap: _react.PropTypes.func,
	  /**
	   * Can be used to render primary text within the menu item.
	   */
	  primaryText: _react.PropTypes.node,
	  /**
	   * The `SvgIcon` or `FontIcon` to be displayed on the right side.
	   */
	  rightIcon: _react.PropTypes.element,
	  /**
	   * Can be used to render secondary text within the menu item.
	   */
	  secondaryText: _react.PropTypes.node,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object,
	  /**
	   * The value of the menu item.
	   */
	  value: _react.PropTypes.any
	};
	MenuItem.defaultProps = {
	  checked: false,
	  desktop: false,
	  disabled: false,
	  focusState: 'none',
	  insetChildren: false
	};
	MenuItem.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	exports.default = MenuItem;

/***/ }),
/* 639 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(332);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reactEventListener = __webpack_require__(625);
	
	var _reactEventListener2 = _interopRequireDefault(_reactEventListener);
	
	var _RenderToLayer = __webpack_require__(640);
	
	var _RenderToLayer2 = _interopRequireDefault(_RenderToLayer);
	
	var _propTypes = __webpack_require__(583);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Paper = __webpack_require__(617);
	
	var _Paper2 = _interopRequireDefault(_Paper);
	
	var _throttle = __webpack_require__(641);
	
	var _throttle2 = _interopRequireDefault(_throttle);
	
	var _PopoverAnimationDefault = __webpack_require__(656);
	
	var _PopoverAnimationDefault2 = _interopRequireDefault(_PopoverAnimationDefault);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Popover = function (_Component) {
	  _inherits(Popover, _Component);
	
	  function Popover(props, context) {
	    _classCallCheck(this, Popover);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(Popover).call(this, props, context));
	
	    _this.renderLayer = function () {
	      var _this$props = _this.props;
	      var animated = _this$props.animated;
	      var animation = _this$props.animation;
	      var children = _this$props.children;
	      var style = _this$props.style;
	
	      var other = _objectWithoutProperties(_this$props, ['animated', 'animation', 'children', 'style']);
	
	      var Animation = animation || _PopoverAnimationDefault2.default;
	      var styleRoot = style;
	
	      if (!Animation) {
	        Animation = _Paper2.default;
	        styleRoot = {
	          position: 'fixed'
	        };
	        if (!_this.state.open) {
	          return null;
	        }
	      }
	
	      return _react2.default.createElement(
	        Animation,
	        _extends({}, other, { style: styleRoot, open: _this.state.open && !_this.state.closing }),
	        children
	      );
	    };
	
	    _this.componentClickAway = function () {
	      _this.requestClose('clickAway');
	    };
	
	    _this.setPlacement = function (scrolling) {
	      if (!_this.state.open) {
	        return;
	      }
	
	      var anchorEl = _this.props.anchorEl || _this.anchorEl;
	
	      if (!_this.refs.layer.getLayer()) {
	        return;
	      }
	
	      var targetEl = _this.refs.layer.getLayer().children[0];
	      if (!targetEl) {
	        return;
	      }
	
	      var _this$props2 = _this.props;
	      var targetOrigin = _this$props2.targetOrigin;
	      var anchorOrigin = _this$props2.anchorOrigin;
	
	
	      var anchor = _this.getAnchorPosition(anchorEl);
	      var target = _this.getTargetPosition(targetEl);
	
	      var targetPosition = {
	        top: anchor[anchorOrigin.vertical] - target[targetOrigin.vertical],
	        left: anchor[anchorOrigin.horizontal] - target[targetOrigin.horizontal]
	      };
	
	      if (scrolling && _this.props.autoCloseWhenOffScreen) {
	        _this.autoCloseWhenOffScreen(anchor);
	      }
	
	      if (_this.props.canAutoPosition) {
	        target = _this.getTargetPosition(targetEl); // update as height may have changed
	        targetPosition = _this.applyAutoPositionIfNeeded(anchor, target, targetOrigin, anchorOrigin, targetPosition);
	      }
	
	      targetEl.style.top = Math.max(0, targetPosition.top) + 'px';
	      targetEl.style.left = Math.max(0, targetPosition.left) + 'px';
	      targetEl.style.maxHeight = window.innerHeight + 'px';
	    };
	
	    _this.handleResize = (0, _throttle2.default)(_this.setPlacement, 100);
	    _this.handleScroll = (0, _throttle2.default)(_this.setPlacement.bind(_this, true), 50);
	
	    _this.state = {
	      open: props.open,
	      closing: false
	    };
	    return _this;
	  }
	
	  _createClass(Popover, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _this2 = this;
	
	      if (nextProps.open !== this.state.open) {
	        if (nextProps.open) {
	          this.anchorEl = nextProps.anchorEl || this.props.anchorEl;
	          this.setState({
	            open: true,
	            closing: false
	          });
	        } else {
	          if (nextProps.animated) {
	            this.setState({ closing: true });
	            this.timeout = setTimeout(function () {
	              _this2.setState({
	                open: false
	              });
	            }, 500);
	          } else {
	            this.setState({
	              open: false
	            });
	          }
	        }
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this.setPlacement();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      clearTimeout(this.timeout);
	    }
	  }, {
	    key: 'requestClose',
	    value: function requestClose(reason) {
	      if (this.props.onRequestClose) {
	        this.props.onRequestClose(reason);
	      }
	    }
	  }, {
	    key: '_resizeAutoPosition',
	    value: function _resizeAutoPosition() {
	      this.setPlacement();
	    }
	  }, {
	    key: 'getAnchorPosition',
	    value: function getAnchorPosition(el) {
	      if (!el) {
	        el = _reactDom2.default.findDOMNode(this);
	      }
	
	      var rect = el.getBoundingClientRect();
	      var a = {
	        top: rect.top,
	        left: rect.left,
	        width: el.offsetWidth,
	        height: el.offsetHeight
	      };
	
	      a.right = rect.right || a.left + a.width;
	      a.bottom = rect.bottom || a.top + a.height;
	      a.middle = a.left + (a.right - a.left) / 2;
	      a.center = a.top + (a.bottom - a.top) / 2;
	
	      return a;
	    }
	  }, {
	    key: 'getTargetPosition',
	    value: function getTargetPosition(targetEl) {
	      return {
	        top: 0,
	        center: targetEl.offsetHeight / 2,
	        bottom: targetEl.offsetHeight,
	        left: 0,
	        middle: targetEl.offsetWidth / 2,
	        right: targetEl.offsetWidth
	      };
	    }
	  }, {
	    key: 'autoCloseWhenOffScreen',
	    value: function autoCloseWhenOffScreen(anchorPosition) {
	      if (anchorPosition.top < 0 || anchorPosition.top > window.innerHeight || anchorPosition.left < 0 || anchorPosition.left > window.innerWidth) {
	        this.requestClose('offScreen');
	      }
	    }
	  }, {
	    key: 'getOverlapMode',
	    value: function getOverlapMode(anchor, target, median) {
	      if ([anchor, target].indexOf(median) >= 0) return 'auto';
	      if (anchor === target) return 'inclusive';
	      return 'exclusive';
	    }
	  }, {
	    key: 'getPositions',
	    value: function getPositions(anchor, target) {
	      var a = _extends({}, anchor);
	      var t = _extends({}, target);
	
	      var positions = {
	        x: ['left', 'right'].filter(function (p) {
	          return p !== t.horizontal;
	        }),
	        y: ['top', 'bottom'].filter(function (p) {
	          return p !== t.vertical;
	        })
	      };
	
	      var overlap = {
	        x: this.getOverlapMode(a.horizontal, t.horizontal, 'middle'),
	        y: this.getOverlapMode(a.vertical, t.vertical, 'center')
	      };
	
	      positions.x.splice(overlap.x === 'auto' ? 0 : 1, 0, 'middle');
	      positions.y.splice(overlap.y === 'auto' ? 0 : 1, 0, 'center');
	
	      if (overlap.y !== 'auto') {
	        a.vertical = a.vertical === 'top' ? 'bottom' : 'top';
	        if (overlap.y === 'inclusive') {
	          t.vertical = t.vertical;
	        }
	      }
	
	      if (overlap.x !== 'auto') {
	        a.horizontal = a.horizontal === 'left' ? 'right' : 'left';
	        if (overlap.y === 'inclusive') {
	          t.horizontal = t.horizontal;
	        }
	      }
	
	      return {
	        positions: positions,
	        anchorPos: a
	      };
	    }
	  }, {
	    key: 'applyAutoPositionIfNeeded',
	    value: function applyAutoPositionIfNeeded(anchor, target, targetOrigin, anchorOrigin, targetPosition) {
	      var _getPositions = this.getPositions(anchorOrigin, targetOrigin);
	
	      var positions = _getPositions.positions;
	      var anchorPos = _getPositions.anchorPos;
	
	
	      if (targetPosition.top < 0 || targetPosition.top + target.bottom > window.innerHeight) {
	        var newTop = anchor[anchorPos.vertical] - target[positions.y[0]];
	        if (newTop + target.bottom <= window.innerHeight) targetPosition.top = Math.max(0, newTop);else {
	          newTop = anchor[anchorPos.vertical] - target[positions.y[1]];
	          if (newTop + target.bottom <= window.innerHeight) targetPosition.top = Math.max(0, newTop);
	        }
	      }
	      if (targetPosition.left < 0 || targetPosition.left + target.right > window.innerWidth) {
	        var newLeft = anchor[anchorPos.horizontal] - target[positions.x[0]];
	        if (newLeft + target.right <= window.innerWidth) targetPosition.left = Math.max(0, newLeft);else {
	          newLeft = anchor[anchorPos.horizontal] - target[positions.x[1]];
	          if (newLeft + target.right <= window.innerWidth) targetPosition.left = Math.max(0, newLeft);
	        }
	      }
	      return targetPosition;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { style: { display: 'none' } },
	        _react2.default.createElement(_reactEventListener2.default, {
	          target: 'window',
	          onScroll: this.handleScroll,
	          onResize: this.handleResize
	        }),
	        _react2.default.createElement(_RenderToLayer2.default, {
	          ref: 'layer',
	          open: this.state.open,
	          componentClickAway: this.componentClickAway,
	          useLayerForClickAway: this.props.useLayerForClickAway,
	          render: this.renderLayer
	        })
	      );
	    }
	  }]);
	
	  return Popover;
	}(_react.Component);
	
	Popover.propTypes = {
	  /**
	   * This is the DOM element that will be used to set the position of the
	   * popover.
	   */
	  anchorEl: _react.PropTypes.object,
	  /**
	   * This is the point on the anchor where the popover's
	   * `targetOrigin` will attach to.
	   * Options:
	   * vertical: [top, middle, bottom];
	   * horizontal: [left, center, right].
	   */
	  anchorOrigin: _propTypes2.default.origin,
	  /**
	   * If true, the popover will apply transitions when
	   * it is added to the DOM.
	   */
	  animated: _react.PropTypes.bool,
	  /**
	   * Override the default animation component used.
	   */
	  animation: _react.PropTypes.func,
	  /**
	   * If true, the popover will hide when the anchor is scrolled off the screen.
	   */
	  autoCloseWhenOffScreen: _react.PropTypes.bool,
	  /**
	   * If true, the popover (potentially) ignores `targetOrigin`
	   * and `anchorOrigin` to make itself fit on screen,
	   * which is useful for mobile devices.
	   */
	  canAutoPosition: _react.PropTypes.bool,
	  /**
	   * The content of the popover.
	   */
	  children: _react.PropTypes.node,
	  /**
	   * The CSS class name of the root element.
	   */
	  className: _react.PropTypes.string,
	  /**
	   * Callback function fired when the popover is requested to be closed.
	   *
	   * @param {string} reason The reason for the close request. Possibles values
	   * are 'clickAway' and 'offScreen'.
	   */
	  onRequestClose: _react.PropTypes.func,
	  /**
	   * If true, the popover is visible.
	   */
	  open: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object,
	  /**
	   * This is the point on the popover which will attach to
	   * the anchor's origin.
	   * Options:
	   * vertical: [top, middle, bottom];
	   * horizontal: [left, center, right].
	   */
	  targetOrigin: _propTypes2.default.origin,
	  /**
	   * If true, the popover will render on top of an invisible
	   * layer, which will prevent clicks to the underlying
	   * elements, and trigger an `onRequestClose('clickAway')` call.
	   */
	  useLayerForClickAway: _react.PropTypes.bool,
	  /**
	   * The zDepth of the popover.
	   */
	  zDepth: _propTypes2.default.zDepth
	};
	Popover.defaultProps = {
	  anchorOrigin: {
	    vertical: 'bottom',
	    horizontal: 'left'
	  },
	  animated: true,
	  autoCloseWhenOffScreen: true,
	  canAutoPosition: true,
	  onRequestClose: function onRequestClose() {},
	  open: false,
	  style: {
	    overflowY: 'auto'
	  },
	  targetOrigin: {
	    vertical: 'top',
	    horizontal: 'left'
	  },
	  useLayerForClickAway: true,
	  zDepth: 1
	};
	Popover.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	exports.default = Popover;

/***/ }),
/* 640 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _reactDom = __webpack_require__(332);
	
	var _dom = __webpack_require__(601);
	
	var _dom2 = _interopRequireDefault(_dom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// heavily inspired by https://github.com/Khan/react-components/blob/master/js/layered-component-mixin.jsx
	var RenderToLayer = function (_Component) {
	  _inherits(RenderToLayer, _Component);
	
	  function RenderToLayer() {
	    var _Object$getPrototypeO;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, RenderToLayer);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_Object$getPrototypeO = Object.getPrototypeOf(RenderToLayer)).call.apply(_Object$getPrototypeO, [this].concat(args))), _this), _this.onClickAway = function (event) {
	      if (event.defaultPrevented) {
	        return;
	      }
	
	      if (!_this.props.componentClickAway) {
	        return;
	      }
	
	      if (!_this.props.open) {
	        return;
	      }
	
	      var el = _this.layer;
	      if (event.target !== el && event.target === window || document.documentElement.contains(event.target) && !_dom2.default.isDescendant(el, event.target)) {
	        _this.props.componentClickAway(event);
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(RenderToLayer, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.renderLayer();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this.renderLayer();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.unrenderLayer();
	    }
	  }, {
	    key: 'getLayer',
	    value: function getLayer() {
	      return this.layer;
	    }
	  }, {
	    key: 'unrenderLayer',
	    value: function unrenderLayer() {
	      if (!this.layer) {
	        return;
	      }
	
	      if (this.props.useLayerForClickAway) {
	        this.layer.style.position = 'relative';
	        this.layer.removeEventListener('touchstart', this.onClickAway);
	        this.layer.removeEventListener('click', this.onClickAway);
	      } else {
	        window.removeEventListener('touchstart', this.onClickAway);
	        window.removeEventListener('click', this.onClickAway);
	      }
	
	      (0, _reactDom.unmountComponentAtNode)(this.layer);
	      document.body.removeChild(this.layer);
	      this.layer = null;
	    }
	
	    /**
	     * By calling this method in componentDidMount() and
	     * componentDidUpdate(), you're effectively creating a "wormhole" that
	     * funnels React's hierarchical updates through to a DOM node on an
	     * entirely different part of the page.
	     */
	
	  }, {
	    key: 'renderLayer',
	    value: function renderLayer() {
	      var _this2 = this;
	
	      var _props = this.props;
	      var open = _props.open;
	      var render = _props.render;
	
	
	      if (open) {
	        if (!this.layer) {
	          this.layer = document.createElement('div');
	          document.body.appendChild(this.layer);
	
	          if (this.props.useLayerForClickAway) {
	            this.layer.addEventListener('touchstart', this.onClickAway);
	            this.layer.addEventListener('click', this.onClickAway);
	            this.layer.style.position = 'fixed';
	            this.layer.style.top = 0;
	            this.layer.style.bottom = 0;
	            this.layer.style.left = 0;
	            this.layer.style.right = 0;
	            this.layer.style.zIndex = this.context.muiTheme.zIndex.layer;
	          } else {
	            setTimeout(function () {
	              window.addEventListener('touchstart', _this2.onClickAway);
	              window.addEventListener('click', _this2.onClickAway);
	            }, 0);
	          }
	        }
	
	        var layerElement = render();
	        this.layerElement = (0, _reactDom.unstable_renderSubtreeIntoContainer)(this, layerElement, this.layer);
	      } else {
	        this.unrenderLayer();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return null;
	    }
	  }]);
	
	  return RenderToLayer;
	}(_react.Component);
	
	RenderToLayer.propTypes = {
	  componentClickAway: _react.PropTypes.func,
	  open: _react.PropTypes.bool.isRequired,
	  render: _react.PropTypes.func.isRequired,
	  useLayerForClickAway: _react.PropTypes.bool
	};
	RenderToLayer.defaultProps = {
	  useLayerForClickAway: true
	};
	RenderToLayer.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	exports.default = RenderToLayer;

/***/ }),
/* 641 */
/***/ (function(module, exports, __webpack_require__) {

	var debounce = __webpack_require__(642),
	    isObject = __webpack_require__(643);
	
	/** Error message constants. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/**
	 * Creates a throttled function that only invokes `func` at most once per
	 * every `wait` milliseconds. The throttled function comes with a `cancel`
	 * method to cancel delayed `func` invocations and a `flush` method to
	 * immediately invoke them. Provide `options` to indicate whether `func`
	 * should be invoked on the leading and/or trailing edge of the `wait`
	 * timeout. The `func` is invoked with the last arguments provided to the
	 * throttled function. Subsequent calls to the throttled function return the
	 * result of the last `func` invocation.
	 *
	 * **Note:** If `leading` and `trailing` options are `true`, `func` is
	 * invoked on the trailing edge of the timeout only if the throttled function
	 * is invoked more than once during the `wait` timeout.
	 *
	 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	 *
	 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	 * for details over the differences between `_.throttle` and `_.debounce`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to throttle.
	 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
	 * @param {Object} [options={}] The options object.
	 * @param {boolean} [options.leading=true]
	 *  Specify invoking on the leading edge of the timeout.
	 * @param {boolean} [options.trailing=true]
	 *  Specify invoking on the trailing edge of the timeout.
	 * @returns {Function} Returns the new throttled function.
	 * @example
	 *
	 * // Avoid excessively updating the position while scrolling.
	 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
	 *
	 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
	 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
	 * jQuery(element).on('click', throttled);
	 *
	 * // Cancel the trailing throttled invocation.
	 * jQuery(window).on('popstate', throttled.cancel);
	 */
	function throttle(func, wait, options) {
	  var leading = true,
	      trailing = true;
	
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  if (isObject(options)) {
	    leading = 'leading' in options ? !!options.leading : leading;
	    trailing = 'trailing' in options ? !!options.trailing : trailing;
	  }
	  return debounce(func, wait, {
	    'leading': leading,
	    'maxWait': wait,
	    'trailing': trailing
	  });
	}
	
	module.exports = throttle;


/***/ }),
/* 642 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(643),
	    now = __webpack_require__(644),
	    toNumber = __webpack_require__(647);
	
	/** Error message constants. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max,
	    nativeMin = Math.min;
	
	/**
	 * Creates a debounced function that delays invoking `func` until after `wait`
	 * milliseconds have elapsed since the last time the debounced function was
	 * invoked. The debounced function comes with a `cancel` method to cancel
	 * delayed `func` invocations and a `flush` method to immediately invoke them.
	 * Provide `options` to indicate whether `func` should be invoked on the
	 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
	 * with the last arguments provided to the debounced function. Subsequent
	 * calls to the debounced function return the result of the last `func`
	 * invocation.
	 *
	 * **Note:** If `leading` and `trailing` options are `true`, `func` is
	 * invoked on the trailing edge of the timeout only if the debounced function
	 * is invoked more than once during the `wait` timeout.
	 *
	 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	 *
	 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	 * for details over the differences between `_.debounce` and `_.throttle`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to debounce.
	 * @param {number} [wait=0] The number of milliseconds to delay.
	 * @param {Object} [options={}] The options object.
	 * @param {boolean} [options.leading=false]
	 *  Specify invoking on the leading edge of the timeout.
	 * @param {number} [options.maxWait]
	 *  The maximum time `func` is allowed to be delayed before it's invoked.
	 * @param {boolean} [options.trailing=true]
	 *  Specify invoking on the trailing edge of the timeout.
	 * @returns {Function} Returns the new debounced function.
	 * @example
	 *
	 * // Avoid costly calculations while the window size is in flux.
	 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	 *
	 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
	 * jQuery(element).on('click', _.debounce(sendMail, 300, {
	 *   'leading': true,
	 *   'trailing': false
	 * }));
	 *
	 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
	 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
	 * var source = new EventSource('/stream');
	 * jQuery(source).on('message', debounced);
	 *
	 * // Cancel the trailing debounced invocation.
	 * jQuery(window).on('popstate', debounced.cancel);
	 */
	function debounce(func, wait, options) {
	  var lastArgs,
	      lastThis,
	      maxWait,
	      result,
	      timerId,
	      lastCallTime,
	      lastInvokeTime = 0,
	      leading = false,
	      maxing = false,
	      trailing = true;
	
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  wait = toNumber(wait) || 0;
	  if (isObject(options)) {
	    leading = !!options.leading;
	    maxing = 'maxWait' in options;
	    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
	    trailing = 'trailing' in options ? !!options.trailing : trailing;
	  }
	
	  function invokeFunc(time) {
	    var args = lastArgs,
	        thisArg = lastThis;
	
	    lastArgs = lastThis = undefined;
	    lastInvokeTime = time;
	    result = func.apply(thisArg, args);
	    return result;
	  }
	
	  function leadingEdge(time) {
	    // Reset any `maxWait` timer.
	    lastInvokeTime = time;
	    // Start the timer for the trailing edge.
	    timerId = setTimeout(timerExpired, wait);
	    // Invoke the leading edge.
	    return leading ? invokeFunc(time) : result;
	  }
	
	  function remainingWait(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime,
	        timeWaiting = wait - timeSinceLastCall;
	
	    return maxing
	      ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
	      : timeWaiting;
	  }
	
	  function shouldInvoke(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime;
	
	    // Either this is the first call, activity has stopped and we're at the
	    // trailing edge, the system time has gone backwards and we're treating
	    // it as the trailing edge, or we've hit the `maxWait` limit.
	    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
	      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
	  }
	
	  function timerExpired() {
	    var time = now();
	    if (shouldInvoke(time)) {
	      return trailingEdge(time);
	    }
	    // Restart the timer.
	    timerId = setTimeout(timerExpired, remainingWait(time));
	  }
	
	  function trailingEdge(time) {
	    timerId = undefined;
	
	    // Only invoke if we have `lastArgs` which means `func` has been
	    // debounced at least once.
	    if (trailing && lastArgs) {
	      return invokeFunc(time);
	    }
	    lastArgs = lastThis = undefined;
	    return result;
	  }
	
	  function cancel() {
	    if (timerId !== undefined) {
	      clearTimeout(timerId);
	    }
	    lastInvokeTime = 0;
	    lastArgs = lastCallTime = lastThis = timerId = undefined;
	  }
	
	  function flush() {
	    return timerId === undefined ? result : trailingEdge(now());
	  }
	
	  function debounced() {
	    var time = now(),
	        isInvoking = shouldInvoke(time);
	
	    lastArgs = arguments;
	    lastThis = this;
	    lastCallTime = time;
	
	    if (isInvoking) {
	      if (timerId === undefined) {
	        return leadingEdge(lastCallTime);
	      }
	      if (maxing) {
	        // Handle invocations in a tight loop.
	        clearTimeout(timerId);
	        timerId = setTimeout(timerExpired, wait);
	        return invokeFunc(lastCallTime);
	      }
	    }
	    if (timerId === undefined) {
	      timerId = setTimeout(timerExpired, wait);
	    }
	    return result;
	  }
	  debounced.cancel = cancel;
	  debounced.flush = flush;
	  return debounced;
	}
	
	module.exports = debounce;


/***/ }),
/* 643 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return value != null && (type == 'object' || type == 'function');
	}
	
	module.exports = isObject;


/***/ }),
/* 644 */
/***/ (function(module, exports, __webpack_require__) {

	var root = __webpack_require__(645);
	
	/**
	 * Gets the timestamp of the number of milliseconds that have elapsed since
	 * the Unix epoch (1 January 1970 00:00:00 UTC).
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Date
	 * @returns {number} Returns the timestamp.
	 * @example
	 *
	 * _.defer(function(stamp) {
	 *   console.log(_.now() - stamp);
	 * }, _.now());
	 * // => Logs the number of milliseconds it took for the deferred invocation.
	 */
	var now = function() {
	  return root.Date.now();
	};
	
	module.exports = now;


/***/ }),
/* 645 */
/***/ (function(module, exports, __webpack_require__) {

	var freeGlobal = __webpack_require__(646);
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	module.exports = root;


/***/ }),
/* 646 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	module.exports = freeGlobal;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 647 */
/***/ (function(module, exports, __webpack_require__) {

	var baseTrim = __webpack_require__(648),
	    isObject = __webpack_require__(643),
	    isSymbol = __webpack_require__(650);
	
	/** Used as references for various `Number` constants. */
	var NAN = 0 / 0;
	
	/** Used to detect bad signed hexadecimal string values. */
	var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	/** Used to detect binary string values. */
	var reIsBinary = /^0b[01]+$/i;
	
	/** Used to detect octal string values. */
	var reIsOctal = /^0o[0-7]+$/i;
	
	/** Built-in method references without a dependency on `root`. */
	var freeParseInt = parseInt;
	
	/**
	 * Converts `value` to a number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {number} Returns the number.
	 * @example
	 *
	 * _.toNumber(3.2);
	 * // => 3.2
	 *
	 * _.toNumber(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toNumber(Infinity);
	 * // => Infinity
	 *
	 * _.toNumber('3.2');
	 * // => 3.2
	 */
	function toNumber(value) {
	  if (typeof value == 'number') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return NAN;
	  }
	  if (isObject(value)) {
	    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	    value = isObject(other) ? (other + '') : other;
	  }
	  if (typeof value != 'string') {
	    return value === 0 ? value : +value;
	  }
	  value = baseTrim(value);
	  var isBinary = reIsBinary.test(value);
	  return (isBinary || reIsOctal.test(value))
	    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	    : (reIsBadHex.test(value) ? NAN : +value);
	}
	
	module.exports = toNumber;


/***/ }),
/* 648 */
/***/ (function(module, exports, __webpack_require__) {

	var trimmedEndIndex = __webpack_require__(649);
	
	/** Used to match leading whitespace. */
	var reTrimStart = /^\s+/;
	
	/**
	 * The base implementation of `_.trim`.
	 *
	 * @private
	 * @param {string} string The string to trim.
	 * @returns {string} Returns the trimmed string.
	 */
	function baseTrim(string) {
	  return string
	    ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
	    : string;
	}
	
	module.exports = baseTrim;


/***/ }),
/* 649 */
/***/ (function(module, exports) {

	/** Used to match a single whitespace character. */
	var reWhitespace = /\s/;
	
	/**
	 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
	 * character of `string`.
	 *
	 * @private
	 * @param {string} string The string to inspect.
	 * @returns {number} Returns the index of the last non-whitespace character.
	 */
	function trimmedEndIndex(string) {
	  var index = string.length;
	
	  while (index-- && reWhitespace.test(string.charAt(index))) {}
	  return index;
	}
	
	module.exports = trimmedEndIndex;


/***/ }),
/* 650 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(651),
	    isObjectLike = __webpack_require__(655);
	
	/** `Object#toString` result references. */
	var symbolTag = '[object Symbol]';
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && baseGetTag(value) == symbolTag);
	}
	
	module.exports = isSymbol;


/***/ }),
/* 651 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(652),
	    getRawTag = __webpack_require__(653),
	    objectToString = __webpack_require__(654);
	
	/** `Object#toString` result references. */
	var nullTag = '[object Null]',
	    undefinedTag = '[object Undefined]';
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * The base implementation of `getTag` without fallbacks for buggy environments.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function baseGetTag(value) {
	  if (value == null) {
	    return value === undefined ? undefinedTag : nullTag;
	  }
	  return (symToStringTag && symToStringTag in Object(value))
	    ? getRawTag(value)
	    : objectToString(value);
	}
	
	module.exports = baseGetTag;


/***/ }),
/* 652 */
/***/ (function(module, exports, __webpack_require__) {

	var root = __webpack_require__(645);
	
	/** Built-in value references. */
	var Symbol = root.Symbol;
	
	module.exports = Symbol;


/***/ }),
/* 653 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(652);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the raw `toStringTag`.
	 */
	function getRawTag(value) {
	  var isOwn = hasOwnProperty.call(value, symToStringTag),
	      tag = value[symToStringTag];
	
	  try {
	    value[symToStringTag] = undefined;
	    var unmasked = true;
	  } catch (e) {}
	
	  var result = nativeObjectToString.call(value);
	  if (unmasked) {
	    if (isOwn) {
	      value[symToStringTag] = tag;
	    } else {
	      delete value[symToStringTag];
	    }
	  }
	  return result;
	}
	
	module.exports = getRawTag;


/***/ }),
/* 654 */
/***/ (function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/**
	 * Converts `value` to a string using `Object.prototype.toString`.
	 *
	 * @private
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 */
	function objectToString(value) {
	  return nativeObjectToString.call(value);
	}
	
	module.exports = objectToString;


/***/ }),
/* 655 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return value != null && typeof value == 'object';
	}
	
	module.exports = isObjectLike;


/***/ }),
/* 656 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _simpleAssign = __webpack_require__(579);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _transitions = __webpack_require__(582);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(583);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Paper = __webpack_require__(617);
	
	var _Paper2 = _interopRequireDefault(_Paper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function getStyles(props, context, state) {
	  var targetOrigin = props.targetOrigin;
	  var open = state.open;
	  var muiTheme = context.muiTheme;
	
	  var horizontal = targetOrigin.horizontal.replace('middle', 'vertical');
	
	  return {
	    root: {
	      opacity: open ? 1 : 0,
	      transform: open ? 'scale(1, 1)' : 'scale(0, 0)',
	      transformOrigin: horizontal + ' ' + targetOrigin.vertical,
	      position: 'fixed',
	      zIndex: muiTheme.zIndex.popover,
	      transition: _transitions2.default.easeOut('250ms', ['transform', 'opacity']),
	      maxHeight: '100%'
	    },
	    horizontal: {
	      maxHeight: '100%',
	      overflowY: 'auto',
	      transform: open ? 'scaleX(1)' : 'scaleX(0)',
	      opacity: open ? 1 : 0,
	      transformOrigin: horizontal + ' ' + targetOrigin.vertical,
	      transition: _transitions2.default.easeOut('250ms', ['transform', 'opacity'])
	    },
	    vertical: {
	      opacity: open ? 1 : 0,
	      transform: open ? 'scaleY(1)' : 'scaleY(0)',
	      transformOrigin: horizontal + ' ' + targetOrigin.vertical,
	      transition: _transitions2.default.easeOut('500ms', ['transform', 'opacity'])
	    }
	  };
	}
	
	var PopoverDefaultAnimation = function (_Component) {
	  _inherits(PopoverDefaultAnimation, _Component);
	
	  function PopoverDefaultAnimation() {
	    var _Object$getPrototypeO;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, PopoverDefaultAnimation);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_Object$getPrototypeO = Object.getPrototypeOf(PopoverDefaultAnimation)).call.apply(_Object$getPrototypeO, [this].concat(args))), _this), _this.state = {
	      open: false
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(PopoverDefaultAnimation, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.setState({ open: true }); // eslint-disable-line react/no-did-mount-set-state
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      this.setState({
	        open: nextProps.open
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var className = _props.className;
	      var style = _props.style;
	      var zDepth = _props.zDepth;
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context, this.state);
	
	      return _react2.default.createElement(
	        _Paper2.default,
	        {
	          style: (0, _simpleAssign2.default)(styles.root, style),
	          zDepth: zDepth,
	          className: className
	        },
	        _react2.default.createElement(
	          'div',
	          { style: prepareStyles(styles.horizontal) },
	          _react2.default.createElement(
	            'div',
	            { style: prepareStyles(styles.vertical) },
	            this.props.children
	          )
	        )
	      );
	    }
	  }]);
	
	  return PopoverDefaultAnimation;
	}(_react.Component);
	
	PopoverDefaultAnimation.propTypes = {
	  children: _react.PropTypes.node,
	  /**
	   * The css class name of the root element.
	   */
	  className: _react.PropTypes.string,
	  open: _react.PropTypes.bool.isRequired,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object,
	  targetOrigin: _propTypes2.default.origin,
	  zDepth: _propTypes2.default.zDepth
	};
	PopoverDefaultAnimation.defaultProps = {
	  style: {},
	  zDepth: 1
	};
	PopoverDefaultAnimation.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	exports.default = PopoverDefaultAnimation;

/***/ }),
/* 657 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(608);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(615);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NavigationCheck = function NavigationCheck(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z' })
	  );
	};
	NavigationCheck = (0, _pure2.default)(NavigationCheck);
	NavigationCheck.displayName = 'NavigationCheck';
	NavigationCheck.muiName = 'SvgIcon';
	
	exports.default = NavigationCheck;

/***/ }),
/* 658 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _simpleAssign = __webpack_require__(579);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(332);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _shallowEqual = __webpack_require__(591);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	var _colorManipulator = __webpack_require__(623);
	
	var _transitions = __webpack_require__(582);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _EnhancedButton = __webpack_require__(584);
	
	var _EnhancedButton2 = _interopRequireDefault(_EnhancedButton);
	
	var _IconButton = __webpack_require__(580);
	
	var _IconButton2 = _interopRequireDefault(_IconButton);
	
	var _expandLess = __webpack_require__(659);
	
	var _expandLess2 = _interopRequireDefault(_expandLess);
	
	var _expandMore = __webpack_require__(660);
	
	var _expandMore2 = _interopRequireDefault(_expandMore);
	
	var _NestedList = __webpack_require__(661);
	
	var _NestedList2 = _interopRequireDefault(_NestedList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function getStyles(props, context, state) {
	  var insetChildren = props.insetChildren;
	  var leftAvatar = props.leftAvatar;
	  var leftCheckbox = props.leftCheckbox;
	  var leftIcon = props.leftIcon;
	  var nestedLevel = props.nestedLevel;
	  var rightAvatar = props.rightAvatar;
	  var rightIcon = props.rightIcon;
	  var rightIconButton = props.rightIconButton;
	  var rightToggle = props.rightToggle;
	  var secondaryText = props.secondaryText;
	  var secondaryTextLines = props.secondaryTextLines;
	  var muiTheme = context.muiTheme;
	  var listItem = muiTheme.listItem;
	
	
	  var textColor = muiTheme.baseTheme.palette.textColor;
	  var hoverColor = (0, _colorManipulator.fade)(textColor, 0.1);
	  var singleAvatar = !secondaryText && (leftAvatar || rightAvatar);
	  var singleNoAvatar = !secondaryText && !(leftAvatar || rightAvatar);
	  var twoLine = secondaryText && secondaryTextLines === 1;
	  var threeLine = secondaryText && secondaryTextLines > 1;
	
	  var styles = {
	    root: {
	      backgroundColor: (state.isKeyboardFocused || state.hovered) && !state.rightIconButtonHovered && !state.rightIconButtonKeyboardFocused ? hoverColor : null,
	      color: textColor,
	      display: 'block',
	      fontSize: 16,
	      lineHeight: '16px',
	      position: 'relative',
	      transition: _transitions2.default.easeOut()
	    },
	
	    // This inner div is needed so that ripples will span the entire container
	    innerDiv: {
	      marginLeft: nestedLevel * listItem.nestedLevelDepth,
	      paddingLeft: leftIcon || leftAvatar || leftCheckbox || insetChildren ? 72 : 16,
	      paddingRight: rightIcon || rightAvatar || rightIconButton ? 56 : rightToggle ? 72 : 16,
	      paddingBottom: singleAvatar ? 20 : 16,
	      paddingTop: singleNoAvatar || threeLine ? 16 : 20,
	      position: 'relative'
	    },
	
	    icons: {
	      height: 24,
	      width: 24,
	      display: 'block',
	      position: 'absolute',
	      top: twoLine ? 12 : singleAvatar ? 4 : 0,
	      margin: 12
	    },
	
	    leftIcon: {
	      left: 4
	    },
	
	    rightIcon: {
	      right: 4
	    },
	
	    avatars: {
	      position: 'absolute',
	      top: singleAvatar ? 8 : 16
	    },
	
	    label: {
	      cursor: 'pointer'
	    },
	
	    leftAvatar: {
	      left: 16
	    },
	
	    rightAvatar: {
	      right: 16
	    },
	
	    leftCheckbox: {
	      position: 'absolute',
	      display: 'block',
	      width: 24,
	      top: twoLine ? 24 : singleAvatar ? 16 : 12,
	      left: 16
	    },
	
	    primaryText: {},
	
	    rightIconButton: {
	      position: 'absolute',
	      display: 'block',
	      top: twoLine ? 12 : singleAvatar ? 4 : 0,
	      right: 4
	    },
	
	    rightToggle: {
	      position: 'absolute',
	      display: 'block',
	      width: 54,
	      top: twoLine ? 25 : singleAvatar ? 17 : 13,
	      right: 8
	    },
	
	    secondaryText: {
	      fontSize: 14,
	      lineHeight: threeLine ? '18px' : '16px',
	      height: threeLine ? 36 : 16,
	      margin: 0,
	      marginTop: 4,
	      color: listItem.secondaryTextColor,
	
	      // needed for 2 and 3 line ellipsis
	      overflow: 'hidden',
	      textOverflow: 'ellipsis',
	      whiteSpace: threeLine ? null : 'nowrap',
	      display: threeLine ? '-webkit-box' : null,
	      WebkitLineClamp: threeLine ? 2 : null,
	      WebkitBoxOrient: threeLine ? 'vertical' : null
	    }
	  };
	
	  return styles;
	}
	
	var ListItem = function (_Component) {
	  _inherits(ListItem, _Component);
	
	  function ListItem() {
	    var _Object$getPrototypeO;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ListItem);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_Object$getPrototypeO = Object.getPrototypeOf(ListItem)).call.apply(_Object$getPrototypeO, [this].concat(args))), _this), _this.state = {
	      hovered: false,
	      isKeyboardFocused: false,
	      open: false,
	      rightIconButtonHovered: false,
	      rightIconButtonKeyboardFocused: false,
	      touch: false
	    }, _this.handleKeyboardFocus = function (event, isKeyboardFocused) {
	      _this.setState({ isKeyboardFocused: isKeyboardFocused });
	      _this.props.onKeyboardFocus(event, isKeyboardFocused);
	    }, _this.handleMouseEnter = function (event) {
	      if (!_this.state.touch) _this.setState({ hovered: true });
	      _this.props.onMouseEnter(event);
	    }, _this.handleMouseLeave = function (event) {
	      _this.setState({ hovered: false });
	      _this.props.onMouseLeave(event);
	    }, _this.handleNestedListToggle = function (event) {
	      event.stopPropagation();
	      _this.setState({ open: !_this.state.open }, function () {
	        _this.props.onNestedListToggle(_this);
	      });
	    }, _this.handleRightIconButtonKeyboardFocus = function (event, isKeyboardFocused) {
	      if (isKeyboardFocused) {
	        _this.setState({
	          isKeyboardFocused: false,
	          rightIconButtonKeyboardFocused: isKeyboardFocused
	        });
	      }
	
	      var iconButton = _this.props.rightIconButton;
	
	      if (iconButton && iconButton.props.onKeyboardFocus) iconButton.props.onKeyboardFocus(event, isKeyboardFocused);
	    }, _this.handleRightIconButtonMouseLeave = function (event) {
	      var iconButton = _this.props.rightIconButton;
	      _this.setState({ rightIconButtonHovered: false });
	      if (iconButton && iconButton.props.onMouseLeave) iconButton.props.onMouseLeave(event);
	    }, _this.handleRightIconButtonMouseEnter = function (event) {
	      var iconButton = _this.props.rightIconButton;
	      _this.setState({ rightIconButtonHovered: true });
	      if (iconButton && iconButton.props.onMouseEnter) iconButton.props.onMouseEnter(event);
	    }, _this.handleRightIconButtonMouseUp = function (event) {
	      var iconButton = _this.props.rightIconButton;
	      event.stopPropagation();
	      if (iconButton && iconButton.props.onMouseUp) iconButton.props.onMouseUp(event);
	    }, _this.handleRightIconButtonTouchTap = function (event) {
	      var iconButton = _this.props.rightIconButton;
	
	      // Stop the event from bubbling up to the list-item
	      event.stopPropagation();
	      if (iconButton && iconButton.props.onTouchTap) iconButton.props.onTouchTap(event);
	    }, _this.handleTouchStart = function (event) {
	      _this.setState({ touch: true });
	      _this.props.onTouchStart(event);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(ListItem, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.setState({
	        open: this.props.open === null ? this.props.initiallyOpen === true : this.props.open
	      });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      // update the state when the component is controlled.
	      if (nextProps.open !== null) this.setState({ open: nextProps.open });
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState, nextContext) {
	      return !(0, _shallowEqual2.default)(this.props, nextProps) || !(0, _shallowEqual2.default)(this.state, nextState) || !(0, _shallowEqual2.default)(this.context, nextContext);
	    }
	
	    // This method is needed by the `MenuItem` component.
	
	  }, {
	    key: 'applyFocusState',
	    value: function applyFocusState(focusState) {
	      var button = this.refs.enhancedButton;
	
	      if (button) {
	        var buttonEl = _reactDom2.default.findDOMNode(button);
	
	        switch (focusState) {
	          case 'none':
	            buttonEl.blur();
	            break;
	          case 'focused':
	            buttonEl.focus();
	            break;
	          case 'keyboard-focused':
	            button.setKeyboardFocus();
	            buttonEl.focus();
	            break;
	        }
	      }
	    }
	  }, {
	    key: 'createDisabledElement',
	    value: function createDisabledElement(styles, contentChildren, additionalProps) {
	      var _props = this.props;
	      var innerDivStyle = _props.innerDivStyle;
	      var style = _props.style;
	
	
	      var mergedDivStyles = (0, _simpleAssign2.default)({}, styles.root, styles.innerDiv, innerDivStyle, style);
	
	      return _react2.default.createElement(
	        'div',
	        _extends({}, additionalProps, {
	          style: this.context.muiTheme.prepareStyles(mergedDivStyles)
	        }),
	        contentChildren
	      );
	    }
	  }, {
	    key: 'createLabelElement',
	    value: function createLabelElement(styles, contentChildren, additionalProps) {
	      var _props2 = this.props;
	      var innerDivStyle = _props2.innerDivStyle;
	      var style = _props2.style;
	
	
	      var mergedLabelStyles = (0, _simpleAssign2.default)({}, styles.root, styles.innerDiv, innerDivStyle, styles.label, style);
	
	      return _react2.default.createElement(
	        'label',
	        _extends({}, additionalProps, {
	          style: this.context.muiTheme.prepareStyles(mergedLabelStyles)
	        }),
	        contentChildren
	      );
	    }
	  }, {
	    key: 'createTextElement',
	    value: function createTextElement(styles, data, key) {
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      if (_react2.default.isValidElement(data)) {
	        var style = (0, _simpleAssign2.default)({}, styles, data.props.style);
	        if (typeof data.type === 'string') {
	          // if element is a native dom node
	          style = prepareStyles(style);
	        }
	        return _react2.default.cloneElement(data, {
	          key: key,
	          style: style
	        });
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { key: key, style: prepareStyles(styles) },
	        data
	      );
	    }
	  }, {
	    key: 'pushElement',
	    value: function pushElement(children, element, baseStyles, additionalProps) {
	      if (element) {
	        var styles = (0, _simpleAssign2.default)({}, baseStyles, element.props.style);
	        children.push(_react2.default.cloneElement(element, _extends({
	          key: children.length,
	          style: styles
	        }, additionalProps)));
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props3 = this.props;
	      var autoGenerateNestedIndicator = _props3.autoGenerateNestedIndicator;
	      var children = _props3.children;
	      var disabled = _props3.disabled;
	      var disableKeyboardFocus = _props3.disableKeyboardFocus;
	      var initiallyOpen = _props3.initiallyOpen;
	      var innerDivStyle = _props3.innerDivStyle;
	      var insetChildren = _props3.insetChildren;
	      var leftAvatar = _props3.leftAvatar;
	      var leftCheckbox = _props3.leftCheckbox;
	      var leftIcon = _props3.leftIcon;
	      var nestedItems = _props3.nestedItems;
	      var nestedLevel = _props3.nestedLevel;
	      var nestedListStyle = _props3.nestedListStyle;
	      var onKeyboardFocus = _props3.onKeyboardFocus;
	      var onMouseEnter = _props3.onMouseEnter;
	      var onMouseLeave = _props3.onMouseLeave;
	      var onNestedListToggle = _props3.onNestedListToggle;
	      var onTouchStart = _props3.onTouchStart;
	      var onTouchTap = _props3.onTouchTap;
	      var rightAvatar = _props3.rightAvatar;
	      var rightIcon = _props3.rightIcon;
	      var rightIconButton = _props3.rightIconButton;
	      var rightToggle = _props3.rightToggle;
	      var primaryText = _props3.primaryText;
	      var primaryTogglesNestedList = _props3.primaryTogglesNestedList;
	      var secondaryText = _props3.secondaryText;
	      var secondaryTextLines = _props3.secondaryTextLines;
	      var style = _props3.style;
	
	      var other = _objectWithoutProperties(_props3, ['autoGenerateNestedIndicator', 'children', 'disabled', 'disableKeyboardFocus', 'initiallyOpen', 'innerDivStyle', 'insetChildren', 'leftAvatar', 'leftCheckbox', 'leftIcon', 'nestedItems', 'nestedLevel', 'nestedListStyle', 'onKeyboardFocus', 'onMouseEnter', 'onMouseLeave', 'onNestedListToggle', 'onTouchStart', 'onTouchTap', 'rightAvatar', 'rightIcon', 'rightIconButton', 'rightToggle', 'primaryText', 'primaryTogglesNestedList', 'secondaryText', 'secondaryTextLines', 'style']);
	
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context, this.state);
	      var contentChildren = [children];
	
	      if (leftIcon) {
	        var additionalProps = {
	          color: leftIcon.props.color || this.context.muiTheme.listItem.leftIconColor
	        };
	        this.pushElement(contentChildren, leftIcon, (0, _simpleAssign2.default)({}, styles.icons, styles.leftIcon), additionalProps);
	      }
	
	      if (rightIcon) {
	        var _additionalProps = {
	          color: rightIcon.props.color || this.context.muiTheme.listItem.rightIconColor
	        };
	        this.pushElement(contentChildren, rightIcon, (0, _simpleAssign2.default)({}, styles.icons, styles.rightIcon), _additionalProps);
	      }
	
	      if (leftAvatar) {
	        this.pushElement(contentChildren, leftAvatar, (0, _simpleAssign2.default)({}, styles.avatars, styles.leftAvatar));
	      }
	
	      if (rightAvatar) {
	        this.pushElement(contentChildren, rightAvatar, (0, _simpleAssign2.default)({}, styles.avatars, styles.rightAvatar));
	      }
	
	      if (leftCheckbox) {
	        this.pushElement(contentChildren, leftCheckbox, (0, _simpleAssign2.default)({}, styles.leftCheckbox));
	      }
	
	      // RightIconButtonElement
	      var hasNestListItems = nestedItems.length;
	      var hasRightElement = rightAvatar || rightIcon || rightIconButton || rightToggle;
	      var needsNestedIndicator = hasNestListItems && autoGenerateNestedIndicator && !hasRightElement;
	
	      if (rightIconButton || needsNestedIndicator) {
	        var rightIconButtonElement = rightIconButton;
	        var rightIconButtonHandlers = {
	          onKeyboardFocus: this.handleRightIconButtonKeyboardFocus,
	          onMouseEnter: this.handleRightIconButtonMouseEnter,
	          onMouseLeave: this.handleRightIconButtonMouseLeave,
	          onTouchTap: this.handleRightIconButtonTouchTap,
	          onMouseDown: this.handleRightIconButtonMouseUp,
	          onMouseUp: this.handleRightIconButtonMouseUp
	        };
	
	        // Create a nested list indicator icon if we don't have an icon on the right
	        if (needsNestedIndicator) {
	          rightIconButtonElement = this.state.open ? _react2.default.createElement(
	            _IconButton2.default,
	            null,
	            _react2.default.createElement(_expandLess2.default, null)
	          ) : _react2.default.createElement(
	            _IconButton2.default,
	            null,
	            _react2.default.createElement(_expandMore2.default, null)
	          );
	          rightIconButtonHandlers.onTouchTap = this.handleNestedListToggle;
	        }
	
	        this.pushElement(contentChildren, rightIconButtonElement, (0, _simpleAssign2.default)({}, styles.rightIconButton), rightIconButtonHandlers);
	      }
	
	      if (rightToggle) {
	        this.pushElement(contentChildren, rightToggle, (0, _simpleAssign2.default)({}, styles.rightToggle));
	      }
	
	      if (primaryText) {
	        var primaryTextElement = this.createTextElement(styles.primaryText, primaryText, 'primaryText');
	        contentChildren.push(primaryTextElement);
	      }
	
	      if (secondaryText) {
	        var secondaryTextElement = this.createTextElement(styles.secondaryText, secondaryText, 'secondaryText');
	        contentChildren.push(secondaryTextElement);
	      }
	
	      var nestedList = nestedItems.length ? _react2.default.createElement(
	        _NestedList2.default,
	        { nestedLevel: nestedLevel, open: this.state.open, style: nestedListStyle },
	        nestedItems
	      ) : undefined;
	
	      var hasCheckbox = leftCheckbox || rightToggle;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        hasCheckbox ? this.createLabelElement(styles, contentChildren, other) : disabled ? this.createDisabledElement(styles, contentChildren, other) : _react2.default.createElement(
	          _EnhancedButton2.default,
	          _extends({
	            containerElement: 'span'
	          }, other, {
	            disabled: disabled,
	            disableKeyboardFocus: disableKeyboardFocus || this.state.rightIconButtonKeyboardFocused,
	            onKeyboardFocus: this.handleKeyboardFocus,
	            onMouseLeave: this.handleMouseLeave,
	            onMouseEnter: this.handleMouseEnter,
	            onTouchStart: this.handleTouchStart,
	            onTouchTap: primaryTogglesNestedList ? this.handleNestedListToggle : onTouchTap,
	            ref: 'enhancedButton',
	            style: (0, _simpleAssign2.default)({}, styles.root, style)
	          }),
	          _react2.default.createElement(
	            'div',
	            { style: prepareStyles((0, _simpleAssign2.default)(styles.innerDiv, innerDivStyle)) },
	            contentChildren
	          )
	        ),
	        nestedList
	      );
	    }
	  }]);
	
	  return ListItem;
	}(_react.Component);
	
	ListItem.muiName = 'ListItem';
	ListItem.propTypes = {
	  /**
	   * If true, generate a nested-list-indicator icon when nested list
	   * items are detected. Note that an indicator will not be created
	   * if a `rightIcon` or `rightIconButton` has been provided to
	   * the element.
	   */
	  autoGenerateNestedIndicator: _react.PropTypes.bool,
	  /**
	   * Children passed into the `ListItem`.
	   */
	  children: _react.PropTypes.node,
	  /**
	   * If true, the element will not be able to be focused by the keyboard.
	   */
	  disableKeyboardFocus: _react.PropTypes.bool,
	  /**
	   * If true, the element will not be clickable
	   * and will not display hover effects.
	   * This is automatically disabled if either `leftCheckbox`
	   * or `rightToggle` is set.
	   */
	  disabled: _react.PropTypes.bool,
	  /**
	   * If true, the nested `ListItem`s are initially displayed.
	   */
	  initiallyOpen: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of the inner div element.
	   */
	  innerDivStyle: _react.PropTypes.object,
	  /**
	   * If true, the children will be indented by 72px.
	   * This is useful if there is no left avatar or left icon.
	   */
	  insetChildren: _react.PropTypes.bool,
	  /**
	   * This is the `Avatar` element to be displayed on the left side.
	   */
	  leftAvatar: _react.PropTypes.element,
	  /**
	   * This is the `Checkbox` element to be displayed on the left side.
	   */
	  leftCheckbox: _react.PropTypes.element,
	  /**
	   * This is the `SvgIcon` or `FontIcon` to be displayed on the left side.
	   */
	  leftIcon: _react.PropTypes.element,
	  /**
	   * An array of `ListItem`s to nest underneath the current `ListItem`.
	   */
	  nestedItems: _react.PropTypes.arrayOf(_react.PropTypes.element),
	  /**
	   * Controls how deep a `ListItem` appears.
	   * This property is automatically managed, so modify at your own risk.
	   */
	  nestedLevel: _react.PropTypes.number,
	  /**
	   * Override the inline-styles of the nested items' `NestedList`.
	   */
	  nestedListStyle: _react.PropTypes.object,
	  /**
	   * Callback function fired when the `ListItem` is focused or blurred by the keyboard.
	   *
	   * @param {object} event `focus` or `blur` event targeting the `ListItem`.
	   * @param {boolean} isKeyboardFocused If true, the `ListItem` is focused.
	   */
	  onKeyboardFocus: _react.PropTypes.func,
	  /** @ignore */
	  onMouseEnter: _react.PropTypes.func,
	  /** @ignore */
	  onMouseLeave: _react.PropTypes.func,
	  /**
	   * Callbak function fired when the `ListItem` toggles its nested list.
	   *
	   * @param {object} listItem The `ListItem`.
	   */
	  onNestedListToggle: _react.PropTypes.func,
	  /** @ignore */
	  onTouchStart: _react.PropTypes.func,
	  /** @ignore */
	  onTouchTap: _react.PropTypes.func,
	  /**
	   * Control toggle state of nested list.
	   */
	  open: _react.PropTypes.bool,
	  /**
	   * This is the block element that contains the primary text.
	   * If a string is passed in, a div tag will be rendered.
	   */
	  primaryText: _react.PropTypes.node,
	  /**
	   * If true, clicking or tapping the primary text of the `ListItem`
	   * toggles the nested list.
	   */
	  primaryTogglesNestedList: _react.PropTypes.bool,
	  /**
	   * This is the `Avatar` element to be displayed on the right side.
	   */
	  rightAvatar: _react.PropTypes.element,
	  /**
	   * This is the `SvgIcon` or `FontIcon` to be displayed on the right side.
	   */
	  rightIcon: _react.PropTypes.element,
	  /**
	   * This is the `IconButton` to be displayed on the right side.
	   * Hovering over this button will remove the `ListItem` hover.
	   * Also, clicking on this button will not trigger a
	   * ripple on the `ListItem`; the event will be stopped and prevented
	   * from bubbling up to cause a `ListItem` click.
	   */
	  rightIconButton: _react.PropTypes.element,
	  /**
	   * This is the `Toggle` element to display on the right side.
	   */
	  rightToggle: _react.PropTypes.element,
	  /**
	   * This is the block element that contains the secondary text.
	   * If a string is passed in, a div tag will be rendered.
	   */
	  secondaryText: _react.PropTypes.node,
	  /**
	   * Can be 1 or 2. This is the number of secondary
	   * text lines before ellipsis will show.
	   */
	  secondaryTextLines: _react.PropTypes.oneOf([1, 2]),
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object
	};
	ListItem.defaultProps = {
	  autoGenerateNestedIndicator: true,
	  disableKeyboardFocus: false,
	  disabled: false,
	  initiallyOpen: false,
	  insetChildren: false,
	  nestedItems: [],
	  nestedLevel: 0,
	  onKeyboardFocus: function onKeyboardFocus() {},
	  onMouseEnter: function onMouseEnter() {},
	  onMouseLeave: function onMouseLeave() {},
	  onNestedListToggle: function onNestedListToggle() {},
	  onTouchStart: function onTouchStart() {},
	  open: null,
	  primaryTogglesNestedList: false,
	  secondaryTextLines: 1
	};
	ListItem.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	exports.default = ListItem;

/***/ }),
/* 659 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(608);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(615);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NavigationExpandLess = function NavigationExpandLess(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 8l-6 6 1.41 1.41L12 10.83l4.59 4.58L18 14z' })
	  );
	};
	NavigationExpandLess = (0, _pure2.default)(NavigationExpandLess);
	NavigationExpandLess.displayName = 'NavigationExpandLess';
	NavigationExpandLess.muiName = 'SvgIcon';
	
	exports.default = NavigationExpandLess;

/***/ }),
/* 660 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(608);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(615);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NavigationExpandMore = function NavigationExpandMore(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z' })
	  );
	};
	NavigationExpandMore = (0, _pure2.default)(NavigationExpandMore);
	NavigationExpandMore.displayName = 'NavigationExpandMore';
	NavigationExpandMore.muiName = 'SvgIcon';
	
	exports.default = NavigationExpandMore;

/***/ }),
/* 661 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _simpleAssign = __webpack_require__(579);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _List = __webpack_require__(633);
	
	var _List2 = _interopRequireDefault(_List);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var NestedList = function (_Component) {
	  _inherits(NestedList, _Component);
	
	  function NestedList() {
	    _classCallCheck(this, NestedList);
	
	    return _possibleConstructorReturn(this, Object.getPrototypeOf(NestedList).apply(this, arguments));
	  }
	
	  _createClass(NestedList, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var children = _props.children;
	      var open = _props.open;
	      var nestedLevel = _props.nestedLevel;
	      var style = _props.style;
	
	
	      var styles = {
	        root: {
	          display: open ? null : 'none'
	        }
	      };
	
	      return _react2.default.createElement(
	        _List2.default,
	        { style: (0, _simpleAssign2.default)({}, styles.root, style) },
	        _react2.default.Children.map(children, function (child) {
	          return _react2.default.isValidElement(child) ? _react2.default.cloneElement(child, {
	            nestedLevel: nestedLevel + 1
	          }) : child;
	        })
	      );
	    }
	  }]);
	
	  return NestedList;
	}(_react.Component);
	
	NestedList.propTypes = {
	  children: _react.PropTypes.node,
	  nestedLevel: _react.PropTypes.number.isRequired,
	  open: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object
	};
	NestedList.defaultProps = {
	  open: false
	};
	exports.default = NestedList;

/***/ }),
/* 662 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _Divider = __webpack_require__(663);
	
	var _Divider2 = _interopRequireDefault(_Divider);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Divider2.default;

/***/ }),
/* 663 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _simpleAssign = __webpack_require__(579);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var propTypes = {
	  /**
	   * The css class name of the root element.
	   */
	  className: _react.PropTypes.string,
	  /**
	   * If true, the `Divider` will be indented `72px`.
	   */
	  inset: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object
	};
	
	var defaultProps = {
	  inset: false
	};
	
	var contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	
	var Divider = function Divider(props, context) {
	  var inset = props.inset;
	  var style = props.style;
	
	  var other = _objectWithoutProperties(props, ['inset', 'style']);
	
	  var muiTheme = context.muiTheme;
	  var prepareStyles = muiTheme.prepareStyles;
	
	
	  var styles = {
	    root: {
	      margin: 0,
	      marginTop: -1,
	      marginLeft: inset ? 72 : 0,
	      height: 1,
	      border: 'none',
	      backgroundColor: muiTheme.baseTheme.palette.borderColor
	    }
	  };
	
	  return _react2.default.createElement('hr', _extends({}, other, { style: prepareStyles((0, _simpleAssign2.default)({}, styles.root, style)) }));
	};
	
	Divider.muiName = 'Divider';
	Divider.propTypes = propTypes;
	Divider.defaultProps = defaultProps;
	Divider.contextTypes = contextTypes;
	
	exports.default = Divider;

/***/ }),
/* 664 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _Avatar = __webpack_require__(665);
	
	var _Avatar2 = _interopRequireDefault(_Avatar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Avatar2.default;

/***/ }),
/* 665 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _simpleAssign = __webpack_require__(579);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function getStyles(props, context) {
	  var backgroundColor = props.backgroundColor;
	  var color = props.color;
	  var size = props.size;
	  var avatar = context.muiTheme.avatar;
	
	
	  var styles = {
	    root: {
	      color: color || avatar.color,
	      backgroundColor: backgroundColor || avatar.backgroundColor,
	      userSelect: 'none',
	      display: 'inline-flex',
	      alignItems: 'center',
	      justifyContent: 'center',
	      fontSize: size / 2,
	      borderRadius: '50%',
	      height: size,
	      width: size
	    },
	    icon: {
	      color: color || avatar.color,
	      width: size * 0.6,
	      height: size * 0.6,
	      fontSize: size * 0.6,
	      margin: size * 0.2
	    }
	  };
	
	  return styles;
	}
	
	var Avatar = function (_Component) {
	  _inherits(Avatar, _Component);
	
	  function Avatar() {
	    _classCallCheck(this, Avatar);
	
	    return _possibleConstructorReturn(this, Object.getPrototypeOf(Avatar).apply(this, arguments));
	  }
	
	  _createClass(Avatar, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var backgroundColor = _props.backgroundColor;
	      var icon = _props.icon;
	      var src = _props.src;
	      var style = _props.style;
	      var className = _props.className;
	
	      var other = _objectWithoutProperties(_props, ['backgroundColor', 'icon', 'src', 'style', 'className']);
	
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      if (src) {
	        return _react2.default.createElement('img', _extends({
	          style: prepareStyles((0, _simpleAssign2.default)(styles.root, style))
	        }, other, {
	          src: src,
	          className: className
	        }));
	      } else {
	        return _react2.default.createElement(
	          'div',
	          _extends({}, other, {
	            style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)),
	            className: className
	          }),
	          icon && _react2.default.cloneElement(icon, {
	            color: styles.icon.color,
	            style: (0, _simpleAssign2.default)(styles.icon, icon.props.style)
	          }),
	          this.props.children
	        );
	      }
	    }
	  }]);
	
	  return Avatar;
	}(_react.Component);
	
	Avatar.muiName = 'Avatar';
	Avatar.propTypes = {
	  /**
	   * The backgroundColor of the avatar. Does not apply to image avatars.
	   */
	  backgroundColor: _react.PropTypes.string,
	  /**
	   * Can be used, for instance, to render a letter inside the avatar.
	   */
	  children: _react.PropTypes.node,
	  /**
	   * The css class name of the root `div` or `img` element.
	   */
	  className: _react.PropTypes.string,
	  /**
	   * The icon or letter's color.
	   */
	  color: _react.PropTypes.string,
	  /**
	   * This is the SvgIcon or FontIcon to be used inside the avatar.
	   */
	  icon: _react.PropTypes.element,
	  /**
	   * This is the size of the avatar in pixels.
	   */
	  size: _react.PropTypes.number,
	  /**
	   * If passed in, this component will render an img element. Otherwise, a div will be rendered.
	   */
	  src: _react.PropTypes.string,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object
	};
	Avatar.defaultProps = {
	  size: 40
	};
	Avatar.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	exports.default = Avatar;

/***/ }),
/* 666 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _Badge = __webpack_require__(667);
	
	var _Badge2 = _interopRequireDefault(_Badge);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Badge2.default;

/***/ }),
/* 667 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _simpleAssign = __webpack_require__(579);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function getStyles(props, context) {
	  var primary = props.primary;
	  var secondary = props.secondary;
	  var badge = context.muiTheme.badge;
	
	
	  var badgeBackgroundColor = void 0;
	  var badgeTextColor = void 0;
	
	  if (primary) {
	    badgeBackgroundColor = badge.primaryColor;
	    badgeTextColor = badge.primaryTextColor;
	  } else if (secondary) {
	    badgeBackgroundColor = badge.secondaryColor;
	    badgeTextColor = badge.secondaryTextColor;
	  } else {
	    badgeBackgroundColor = badge.color;
	    badgeTextColor = badge.textColor;
	  }
	
	  var radius = 12;
	  var radius2x = Math.floor(2 * radius);
	
	  return {
	    root: {
	      position: 'relative',
	      display: 'inline-block',
	      padding: radius2x + 'px ' + radius2x + 'px ' + radius + 'px ' + radius + 'px'
	    },
	    badge: {
	      display: 'flex',
	      flexDirection: 'row',
	      flexWrap: 'wrap',
	      justifyContent: 'center',
	      alignContent: 'center',
	      alignItems: 'center',
	      position: 'absolute',
	      top: 0,
	      right: 0,
	      fontWeight: badge.fontWeight,
	      fontSize: radius,
	      width: radius2x,
	      height: radius2x,
	      borderRadius: '50%',
	      backgroundColor: badgeBackgroundColor,
	      color: badgeTextColor
	    }
	  };
	}
	
	var Badge = function (_Component) {
	  _inherits(Badge, _Component);
	
	  function Badge() {
	    _classCallCheck(this, Badge);
	
	    return _possibleConstructorReturn(this, Object.getPrototypeOf(Badge).apply(this, arguments));
	  }
	
	  _createClass(Badge, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var badgeContent = _props.badgeContent;
	      var badgeStyle = _props.badgeStyle;
	      var children = _props.children;
	      var primary = _props.primary;
	      var secondary = _props.secondary;
	      var style = _props.style;
	
	      var other = _objectWithoutProperties(_props, ['badgeContent', 'badgeStyle', 'children', 'primary', 'secondary', 'style']);
	
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      return _react2.default.createElement(
	        'div',
	        _extends({}, other, { style: prepareStyles((0, _simpleAssign2.default)({}, styles.root, style)) }),
	        children,
	        _react2.default.createElement(
	          'span',
	          { style: prepareStyles((0, _simpleAssign2.default)({}, styles.badge, badgeStyle)) },
	          badgeContent
	        )
	      );
	    }
	  }]);
	
	  return Badge;
	}(_react.Component);
	
	Badge.propTypes = {
	  /**
	   * This is the content rendered within the badge.
	   */
	  badgeContent: _react.PropTypes.node.isRequired,
	  /**
	   * Override the inline-styles of the badge element.
	   */
	  badgeStyle: _react.PropTypes.object,
	  /**
	   * The badge will be added relativelty to this node.
	   */
	  children: _react.PropTypes.node,
	  /**
	   * The css class name of the root element.
	   */
	  className: _react.PropTypes.string,
	  /**
	   * If true, the badge will use the primary badge colors.
	   */
	  primary: _react.PropTypes.bool,
	  /**
	   * If true, the badge will use the secondary badge colors.
	   */
	  secondary: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object
	};
	Badge.defaultProps = {
	  primary: false,
	  secondary: false
	};
	Badge.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	exports.default = Badge;

/***/ }),
/* 668 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.CardExpandable = exports.CardActions = exports.CardText = exports.CardMedia = exports.CardTitle = exports.CardHeader = exports.Card = undefined;
	
	var _Card2 = __webpack_require__(669);
	
	var _Card3 = _interopRequireDefault(_Card2);
	
	var _CardHeader2 = __webpack_require__(673);
	
	var _CardHeader3 = _interopRequireDefault(_CardHeader2);
	
	var _CardTitle2 = __webpack_require__(674);
	
	var _CardTitle3 = _interopRequireDefault(_CardTitle2);
	
	var _CardMedia2 = __webpack_require__(675);
	
	var _CardMedia3 = _interopRequireDefault(_CardMedia2);
	
	var _CardText2 = __webpack_require__(676);
	
	var _CardText3 = _interopRequireDefault(_CardText2);
	
	var _CardActions2 = __webpack_require__(677);
	
	var _CardActions3 = _interopRequireDefault(_CardActions2);
	
	var _CardExpandable2 = __webpack_require__(670);
	
	var _CardExpandable3 = _interopRequireDefault(_CardExpandable2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Card = _Card3.default;
	exports.CardHeader = _CardHeader3.default;
	exports.CardTitle = _CardTitle3.default;
	exports.CardMedia = _CardMedia3.default;
	exports.CardText = _CardText3.default;
	exports.CardActions = _CardActions3.default;
	exports.CardExpandable = _CardExpandable3.default;
	exports.default = _Card3.default;

/***/ }),
/* 669 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _simpleAssign = __webpack_require__(579);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Paper = __webpack_require__(617);
	
	var _Paper2 = _interopRequireDefault(_Paper);
	
	var _CardExpandable = __webpack_require__(670);
	
	var _CardExpandable2 = _interopRequireDefault(_CardExpandable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Card = function (_Component) {
	  _inherits(Card, _Component);
	
	  function Card() {
	    var _Object$getPrototypeO;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Card);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_Object$getPrototypeO = Object.getPrototypeOf(Card)).call.apply(_Object$getPrototypeO, [this].concat(args))), _this), _this.state = {
	      expanded: null
	    }, _this.handleExpanding = function (event) {
	      event.preventDefault();
	      var newExpandedState = !_this.state.expanded;
	      // no automatic state update when the component is controlled
	      if (_this.props.expanded === null) {
	        _this.setState({ expanded: newExpandedState });
	      }
	      if (_this.props.onExpandChange) {
	        _this.props.onExpandChange(newExpandedState);
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Card, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.setState({
	        expanded: this.props.expanded === null ? this.props.initiallyExpanded === true : this.props.expanded
	      });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      // update the state when the component is controlled.
	      if (nextProps.expanded !== null) this.setState({ expanded: nextProps.expanded });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props;
	      var style = _props.style;
	      var containerStyle = _props.containerStyle;
	      var children = _props.children;
	      var expandable = _props.expandable;
	      var expandedProp = _props.expanded;
	      var initiallyExpanded = _props.initiallyExpanded;
	      var onExpandChange = _props.onExpandChange;
	
	      var other = _objectWithoutProperties(_props, ['style', 'containerStyle', 'children', 'expandable', 'expanded', 'initiallyExpanded', 'onExpandChange']);
	
	      var lastElement = void 0;
	      var expanded = this.state.expanded;
	      var newChildren = _react2.default.Children.map(children, function (currentChild) {
	        var doClone = false;
	        var newChild = undefined;
	        var newProps = {};
	        var element = currentChild;
	        if (!currentChild || !currentChild.props) {
	          return null;
	        }
	        if (expanded === false && currentChild.props.expandable === true) return;
	        if (currentChild.props.actAsExpander === true) {
	          doClone = true;
	          newProps.onTouchTap = _this2.handleExpanding;
	          newProps.style = (0, _simpleAssign2.default)({ cursor: 'pointer' }, currentChild.props.style);
	        }
	        if (currentChild.props.showExpandableButton === true) {
	          doClone = true;
	          newChild = _react2.default.createElement(_CardExpandable2.default, { expanded: expanded, onExpanding: _this2.handleExpanding });
	        }
	        if (doClone) {
	          element = _react2.default.cloneElement(currentChild, newProps, currentChild.props.children, newChild);
	        }
	        lastElement = element;
	        return element;
	      }, this);
	
	      // If the last element is text or a title we should add
	      // 8px padding to the bottom of the card
	      var addBottomPadding = lastElement && (lastElement.type.muiName === 'CardText' || lastElement.type.muiName === 'CardTitle');
	
	      var mergedStyles = (0, _simpleAssign2.default)({
	        zIndex: 1
	      }, style);
	      var containerMergedStyles = (0, _simpleAssign2.default)({
	        paddingBottom: addBottomPadding ? 8 : 0
	      }, containerStyle);
	
	      return _react2.default.createElement(
	        _Paper2.default,
	        _extends({}, other, { style: mergedStyles }),
	        _react2.default.createElement(
	          'div',
	          { style: containerMergedStyles },
	          newChildren
	        )
	      );
	    }
	  }]);
	
	  return Card;
	}(_react.Component);
	
	Card.propTypes = {
	  /**
	   * Can be used to render elements inside the Card.
	   */
	  children: _react.PropTypes.node,
	  /**
	   * Override the inline-styles of the container element.
	   */
	  containerStyle: _react.PropTypes.object,
	  /**
	   * If true, this card component is expandable. Can be set on any child of the `Card` component.
	   */
	  expandable: _react.PropTypes.bool,
	  /**
	   * Whether this card is expanded.
	   * If `true` or `false` the component is controlled.
	   * if `null` the component is uncontrolled.
	   */
	  expanded: _react.PropTypes.bool,
	  /**
	   * Whether this card is initially expanded.
	   */
	  initiallyExpanded: _react.PropTypes.bool,
	  /**
	   * Callback function fired when the `expandable` state of the card has changed.
	   *
	   * @param {boolean} newExpandedState Represents the new `expanded` state of the card.
	   */
	  onExpandChange: _react.PropTypes.func,
	  /**
	   * If true, this card component will include a button to expand the card. `CardTitle`,
	   * `CardHeader` and `CardActions` implement `showExpandableButton`. Any child component
	   * of `Card` can implements `showExpandableButton` or forwards the property to a child
	   * component supporting it.
	   */
	  showExpandableButton: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object
	};
	Card.defaultProps = {
	  expandable: false,
	  expanded: null,
	  initiallyExpanded: false
	};
	exports.default = Card;

/***/ }),
/* 670 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _simpleAssign = __webpack_require__(579);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _keyboardArrowUp = __webpack_require__(671);
	
	var _keyboardArrowUp2 = _interopRequireDefault(_keyboardArrowUp);
	
	var _keyboardArrowDown = __webpack_require__(672);
	
	var _keyboardArrowDown2 = _interopRequireDefault(_keyboardArrowDown);
	
	var _IconButton = __webpack_require__(580);
	
	var _IconButton2 = _interopRequireDefault(_IconButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function getStyles() {
	  return {
	    root: {
	      top: 0,
	      bottom: 0,
	      right: 4,
	      margin: 'auto',
	      position: 'absolute'
	    }
	  };
	}
	
	var CardExpandable = function (_Component) {
	  _inherits(CardExpandable, _Component);
	
	  function CardExpandable() {
	    _classCallCheck(this, CardExpandable);
	
	    return _possibleConstructorReturn(this, Object.getPrototypeOf(CardExpandable).apply(this, arguments));
	  }
	
	  _createClass(CardExpandable, [{
	    key: 'render',
	    value: function render() {
	      var styles = getStyles(this.props, this.context);
	
	      return _react2.default.createElement(
	        _IconButton2.default,
	        {
	          style: (0, _simpleAssign2.default)(styles.root, this.props.style),
	          onTouchTap: this.props.onExpanding
	        },
	        this.props.expanded ? _react2.default.createElement(_keyboardArrowUp2.default, null) : _react2.default.createElement(_keyboardArrowDown2.default, null)
	      );
	    }
	  }]);
	
	  return CardExpandable;
	}(_react.Component);
	
	CardExpandable.propTypes = {
	  expanded: _react.PropTypes.bool,
	  onExpanding: _react.PropTypes.func.isRequired,
	  style: _react.PropTypes.object
	};
	CardExpandable.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	exports.default = CardExpandable;

/***/ }),
/* 671 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(608);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(615);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HardwareKeyboardArrowUp = function HardwareKeyboardArrowUp(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M7.41 15.41L12 10.83l4.59 4.58L18 14l-6-6-6 6z' })
	  );
	};
	HardwareKeyboardArrowUp = (0, _pure2.default)(HardwareKeyboardArrowUp);
	HardwareKeyboardArrowUp.displayName = 'HardwareKeyboardArrowUp';
	HardwareKeyboardArrowUp.muiName = 'SvgIcon';
	
	exports.default = HardwareKeyboardArrowUp;

/***/ }),
/* 672 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(608);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(615);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HardwareKeyboardArrowDown = function HardwareKeyboardArrowDown(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M7.41 7.84L12 12.42l4.59-4.58L18 9.25l-6 6-6-6z' })
	  );
	};
	HardwareKeyboardArrowDown = (0, _pure2.default)(HardwareKeyboardArrowDown);
	HardwareKeyboardArrowDown.displayName = 'HardwareKeyboardArrowDown';
	HardwareKeyboardArrowDown.muiName = 'SvgIcon';
	
	exports.default = HardwareKeyboardArrowDown;

/***/ }),
/* 673 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _simpleAssign = __webpack_require__(579);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Avatar = __webpack_require__(664);
	
	var _Avatar2 = _interopRequireDefault(_Avatar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function getStyles(props, context) {
	  var card = context.muiTheme.card;
	
	
	  return {
	    root: {
	      padding: 16,
	      fontWeight: card.fontWeight,
	      boxSizing: 'border-box',
	      position: 'relative',
	      whiteSpace: 'nowrap'
	    },
	    text: {
	      display: 'inline-block',
	      verticalAlign: 'top',
	      whiteSpace: 'normal',
	      paddingRight: '90px'
	    },
	    avatar: {
	      marginRight: 16
	    },
	    title: {
	      color: props.titleColor || card.titleColor,
	      display: 'block',
	      fontSize: 15
	    },
	    subtitle: {
	      color: props.subtitleColor || card.subtitleColor,
	      display: 'block',
	      fontSize: 14
	    }
	  };
	}
	
	var CardHeader = function (_Component) {
	  _inherits(CardHeader, _Component);
	
	  function CardHeader() {
	    _classCallCheck(this, CardHeader);
	
	    return _possibleConstructorReturn(this, Object.getPrototypeOf(CardHeader).apply(this, arguments));
	  }
	
	  _createClass(CardHeader, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var actAsExpander = _props.actAsExpander;
	      var avatarProp = _props.avatar;
	      var children = _props.children;
	      var expandable = _props.expandable;
	      var showExpandableButton = _props.showExpandableButton;
	      var style = _props.style;
	      var subtitle = _props.subtitle;
	      var subtitleStyle = _props.subtitleStyle;
	      var textStyle = _props.textStyle;
	      var title = _props.title;
	      var titleStyle = _props.titleStyle;
	
	      var other = _objectWithoutProperties(_props, ['actAsExpander', 'avatar', 'children', 'expandable', 'showExpandableButton', 'style', 'subtitle', 'subtitleStyle', 'textStyle', 'title', 'titleStyle']);
	
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      var avatar = avatarProp;
	
	      if ((0, _react.isValidElement)(avatarProp)) {
	        avatar = _react2.default.cloneElement(avatar, {
	          style: (0, _simpleAssign2.default)(styles.avatar, avatar.props.style)
	        });
	      } else if (avatar !== null) {
	        avatar = _react2.default.createElement(_Avatar2.default, { src: avatarProp, style: styles.avatar });
	      }
	
	      return _react2.default.createElement(
	        'div',
	        _extends({}, other, { style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) }),
	        avatar,
	        _react2.default.createElement(
	          'div',
	          { style: prepareStyles((0, _simpleAssign2.default)(styles.text, textStyle)) },
	          _react2.default.createElement(
	            'span',
	            { style: prepareStyles((0, _simpleAssign2.default)(styles.title, titleStyle)) },
	            title
	          ),
	          _react2.default.createElement(
	            'span',
	            { style: prepareStyles((0, _simpleAssign2.default)(styles.subtitle, subtitleStyle)) },
	            subtitle
	          )
	        ),
	        children
	      );
	    }
	  }]);
	
	  return CardHeader;
	}(_react.Component);
	
	CardHeader.muiName = 'CardHeader';
	CardHeader.propTypes = {
	  /**
	   * If true, a click on this card component expands the card.
	   */
	  actAsExpander: _react.PropTypes.bool,
	  /**
	   * This is the [Avatar](/#/components/avatar) element to be displayed on the Card Header.
	   * If `avatar` is an `Avatar` or other element, it will be rendered.
	   * If `avatar` is a string, it will be used as the image `src` for an `Avatar`.
	   */
	  avatar: _react.PropTypes.node,
	  /**
	   * Can be used to render elements inside the Card Header.
	   */
	  children: _react.PropTypes.node,
	  /**
	   * If true, this card component is expandable.
	   */
	  expandable: _react.PropTypes.bool,
	  /**
	   * If true, this card component will include a button to expand the card.
	   */
	  showExpandableButton: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object,
	  /**
	   * Can be used to render a subtitle in Card Header.
	   */
	  subtitle: _react.PropTypes.node,
	  /**
	   * Override the subtitle color.
	   */
	  subtitleColor: _react.PropTypes.string,
	  /**
	   * Override the inline-styles of the subtitle.
	   */
	  subtitleStyle: _react.PropTypes.object,
	  /**
	   * Override the inline-styles of the text.
	   */
	  textStyle: _react.PropTypes.object,
	  /**
	   * Can be used to render a title in Card Header.
	   */
	  title: _react.PropTypes.node,
	  /**
	   * Override the title color.
	   */
	  titleColor: _react.PropTypes.string,
	  /**
	   * Override the inline-styles of the title.
	   */
	  titleStyle: _react.PropTypes.object
	};
	CardHeader.defaultProps = {
	  avatar: null
	};
	CardHeader.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	exports.default = CardHeader;

/***/ }),
/* 674 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _simpleAssign = __webpack_require__(579);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function getStyles(props, context) {
	  var card = context.muiTheme.card;
	
	
	  return {
	    root: {
	      padding: 16,
	      position: 'relative'
	    },
	    title: {
	      fontSize: 24,
	      color: props.titleColor || card.titleColor,
	      display: 'block',
	      lineHeight: '36px'
	    },
	    subtitle: {
	      fontSize: 14,
	      color: props.subtitleColor || card.subtitleColor,
	      display: 'block'
	    }
	  };
	}
	
	var CardTitle = function (_Component) {
	  _inherits(CardTitle, _Component);
	
	  function CardTitle() {
	    _classCallCheck(this, CardTitle);
	
	    return _possibleConstructorReturn(this, Object.getPrototypeOf(CardTitle).apply(this, arguments));
	  }
	
	  _createClass(CardTitle, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var actAsExpander = _props.actAsExpander;
	      var children = _props.children;
	      var expandable = _props.expandable;
	      var showExpandableButton = _props.showExpandableButton;
	      var style = _props.style;
	      var subtitle = _props.subtitle;
	      var subtitleColor = _props.subtitleColor;
	      var subtitleStyle = _props.subtitleStyle;
	      var title = _props.title;
	      var titleColor = _props.titleColor;
	      var titleStyle = _props.titleStyle;
	
	      var other = _objectWithoutProperties(_props, ['actAsExpander', 'children', 'expandable', 'showExpandableButton', 'style', 'subtitle', 'subtitleColor', 'subtitleStyle', 'title', 'titleColor', 'titleStyle']);
	
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	      var rootStyle = (0, _simpleAssign2.default)({}, styles.root, style);
	      var extendedTitleStyle = (0, _simpleAssign2.default)({}, styles.title, titleStyle);
	      var extendedSubtitleStyle = (0, _simpleAssign2.default)({}, styles.subtitle, subtitleStyle);
	
	      return _react2.default.createElement(
	        'div',
	        _extends({}, other, { style: prepareStyles(rootStyle) }),
	        _react2.default.createElement(
	          'span',
	          { style: prepareStyles(extendedTitleStyle) },
	          title
	        ),
	        _react2.default.createElement(
	          'span',
	          { style: prepareStyles(extendedSubtitleStyle) },
	          subtitle
	        ),
	        children
	      );
	    }
	  }]);
	
	  return CardTitle;
	}(_react.Component);
	
	CardTitle.muiName = 'CardTitle';
	CardTitle.propTypes = {
	  /**
	   * If true, a click on this card component expands the card.
	   */
	  actAsExpander: _react.PropTypes.bool,
	  /**
	   * Can be used to render elements inside the Card Title.
	   */
	  children: _react.PropTypes.node,
	  /**
	   * If true, this card component is expandable.
	   */
	  expandable: _react.PropTypes.bool,
	  /**
	   * If true, this card component will include a button to expand the card.
	   */
	  showExpandableButton: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object,
	  /**
	   * Can be used to render a subtitle in the Card Title.
	   */
	  subtitle: _react.PropTypes.node,
	  /**
	   * Override the subtitle color.
	   */
	  subtitleColor: _react.PropTypes.string,
	  /**
	   * Override the inline-styles of the subtitle.
	   */
	  subtitleStyle: _react.PropTypes.object,
	  /**
	   * Can be used to render a title in the Card Title.
	   */
	  title: _react.PropTypes.node,
	  /**
	   * Override the title color.
	   */
	  titleColor: _react.PropTypes.string,
	  /**
	   * Override the inline-styles of the title.
	   */
	  titleStyle: _react.PropTypes.object
	};
	CardTitle.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	exports.default = CardTitle;

/***/ }),
/* 675 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _simpleAssign = __webpack_require__(579);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function getStyles(props, context) {
	  var cardMedia = context.muiTheme.cardMedia;
	
	
	  return {
	    root: {
	      position: 'relative'
	    },
	    overlayContainer: {
	      position: 'absolute',
	      top: 0,
	      bottom: 0,
	      right: 0,
	      left: 0
	    },
	    overlay: {
	      height: '100%',
	      position: 'relative'
	    },
	    overlayContent: {
	      position: 'absolute',
	      bottom: 0,
	      right: 0,
	      left: 0,
	      paddingTop: 8,
	      background: cardMedia.overlayContentBackground
	    },
	    media: {},
	    mediaChild: {
	      verticalAlign: 'top',
	      maxWidth: '100%',
	      minWidth: '100%',
	      width: '100%'
	    }
	  };
	}
	
	var CardMedia = function (_Component) {
	  _inherits(CardMedia, _Component);
	
	  function CardMedia() {
	    _classCallCheck(this, CardMedia);
	
	    return _possibleConstructorReturn(this, Object.getPrototypeOf(CardMedia).apply(this, arguments));
	  }
	
	  _createClass(CardMedia, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var actAsExpander = _props.actAsExpander;
	      var children = _props.children;
	      var expandable = _props.expandable;
	      var mediaStyle = _props.mediaStyle;
	      var overlay = _props.overlay;
	      var overlayContainerStyle = _props.overlayContainerStyle;
	      var overlayContentStyle = _props.overlayContentStyle;
	      var overlayStyle = _props.overlayStyle;
	      var style = _props.style;
	
	      var other = _objectWithoutProperties(_props, ['actAsExpander', 'children', 'expandable', 'mediaStyle', 'overlay', 'overlayContainerStyle', 'overlayContentStyle', 'overlayStyle', 'style']);
	
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	      var rootStyle = (0, _simpleAssign2.default)(styles.root, style);
	      var extendedMediaStyle = (0, _simpleAssign2.default)(styles.media, mediaStyle);
	      var extendedOverlayContainerStyle = (0, _simpleAssign2.default)(styles.overlayContainer, overlayContainerStyle);
	      var extendedOverlayContentStyle = (0, _simpleAssign2.default)(styles.overlayContent, overlayContentStyle);
	      var extendedOverlayStyle = (0, _simpleAssign2.default)(styles.overlay, overlayStyle);
	      var titleColor = this.context.muiTheme.cardMedia.titleColor;
	      var subtitleColor = this.context.muiTheme.cardMedia.subtitleColor;
	      var color = this.context.muiTheme.cardMedia.color;
	
	      var styledChildren = _react2.default.Children.map(children, function (child) {
	        return _react2.default.cloneElement(child, {
	          style: prepareStyles((0, _simpleAssign2.default)({}, styles.mediaChild, child.props.style))
	        });
	      });
	
	      var overlayChildren = _react2.default.Children.map(overlay, function (child) {
	        if (child.type.muiName === 'CardHeader' || child.type.muiName === 'CardTitle') {
	          return _react2.default.cloneElement(child, {
	            titleColor: titleColor,
	            subtitleColor: subtitleColor
	          });
	        } else if (child.type.muiName === 'CardText') {
	          return _react2.default.cloneElement(child, {
	            color: color
	          });
	        } else {
	          return child;
	        }
	      });
	
	      return _react2.default.createElement(
	        'div',
	        _extends({}, other, { style: prepareStyles(rootStyle) }),
	        _react2.default.createElement(
	          'div',
	          { style: prepareStyles(extendedMediaStyle) },
	          styledChildren
	        ),
	        overlay ? _react2.default.createElement(
	          'div',
	          { style: prepareStyles(extendedOverlayContainerStyle) },
	          _react2.default.createElement(
	            'div',
	            { style: prepareStyles(extendedOverlayStyle) },
	            _react2.default.createElement(
	              'div',
	              { style: prepareStyles(extendedOverlayContentStyle) },
	              overlayChildren
	            )
	          )
	        ) : ''
	      );
	    }
	  }]);
	
	  return CardMedia;
	}(_react.Component);
	
	CardMedia.propTypes = {
	  /**
	   * If true, a click on this card component expands the card.
	   */
	  actAsExpander: _react.PropTypes.bool,
	  /**
	   * Can be used to render elements inside the Card Media.
	   */
	  children: _react.PropTypes.node,
	  /**
	   * If true, this card component is expandable.
	   */
	  expandable: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of the Card Media.
	   */
	  mediaStyle: _react.PropTypes.object,
	  /**
	   * Can be used to render overlay element in Card Media.
	   */
	  overlay: _react.PropTypes.node,
	  /**
	   * Override the inline-styles of the overlay container.
	   */
	  overlayContainerStyle: _react.PropTypes.object,
	  /**
	   * Override the inline-styles of the overlay content.
	   */
	  overlayContentStyle: _react.PropTypes.object,
	  /**
	   * Override the inline-styles of the overlay element.
	   */
	  overlayStyle: _react.PropTypes.object,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object
	};
	CardMedia.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	exports.default = CardMedia;

/***/ }),
/* 676 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _simpleAssign = __webpack_require__(579);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function getStyles(props, context) {
	  var cardText = context.muiTheme.cardText;
	
	
	  return {
	    root: {
	      padding: 16,
	      fontSize: 14,
	      color: props.color || cardText.textColor
	    }
	  };
	}
	
	var CardText = function (_Component) {
	  _inherits(CardText, _Component);
	
	  function CardText() {
	    _classCallCheck(this, CardText);
	
	    return _possibleConstructorReturn(this, Object.getPrototypeOf(CardText).apply(this, arguments));
	  }
	
	  _createClass(CardText, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var actAsExpander = _props.actAsExpander;
	      var children = _props.children;
	      var color = _props.color;
	      var expandable = _props.expandable;
	      var style = _props.style;
	
	      var other = _objectWithoutProperties(_props, ['actAsExpander', 'children', 'color', 'expandable', 'style']);
	
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	      var rootStyle = (0, _simpleAssign2.default)(styles.root, style);
	
	      return _react2.default.createElement(
	        'div',
	        _extends({}, other, { style: prepareStyles(rootStyle) }),
	        children
	      );
	    }
	  }]);
	
	  return CardText;
	}(_react.Component);
	
	CardText.muiName = 'CardText';
	CardText.propTypes = {
	  /**
	   * If true, a click on this card component expands the card.
	   */
	  actAsExpander: _react.PropTypes.bool,
	  /**
	   * Can be used to render elements inside the Card Text.
	   */
	  children: _react.PropTypes.node,
	  /**
	   * Override the CardText color.
	   */
	  color: _react.PropTypes.string,
	  /**
	   * If true, this card component is expandable.
	   */
	  expandable: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object
	};
	CardText.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	exports.default = CardText;

/***/ }),
/* 677 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _simpleAssign = __webpack_require__(579);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function getStyles() {
	  return {
	    root: {
	      padding: 8,
	      position: 'relative'
	    },
	    action: {
	      marginRight: 8
	    }
	  };
	}
	
	var CardActions = function (_Component) {
	  _inherits(CardActions, _Component);
	
	  function CardActions() {
	    _classCallCheck(this, CardActions);
	
	    return _possibleConstructorReturn(this, Object.getPrototypeOf(CardActions).apply(this, arguments));
	  }
	
	  _createClass(CardActions, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var actAsExpander = _props.actAsExpander;
	      var children = _props.children;
	      var expandable = _props.expandable;
	      var style = _props.style;
	
	      var other = _objectWithoutProperties(_props, ['actAsExpander', 'children', 'expandable', 'style']);
	
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      var styledChildren = _react2.default.Children.map(children, function (child) {
	        if (_react2.default.isValidElement(child)) {
	          return _react2.default.cloneElement(child, {
	            style: (0, _simpleAssign2.default)({}, styles.action, child.props.style)
	          });
	        }
	      });
	
	      return _react2.default.createElement(
	        'div',
	        _extends({}, other, { style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) }),
	        styledChildren
	      );
	    }
	  }]);
	
	  return CardActions;
	}(_react.Component);
	
	CardActions.propTypes = {
	  /**
	   * If true, a click on this card component expands the card.
	   */
	  actAsExpander: _react.PropTypes.bool,
	  /**
	   * Can be used to render elements inside the Card Action.
	   */
	  children: _react.PropTypes.node,
	  /**
	   * If true, this card component is expandable.
	   */
	  expandable: _react.PropTypes.bool,
	  /**
	   * If true, this card component will include a button to expand the card.
	   */
	  showExpandableButton: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object
	};
	CardActions.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	exports.default = CardActions;

/***/ }),
/* 678 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _Checkbox = __webpack_require__(679);
	
	var _Checkbox2 = _interopRequireDefault(_Checkbox);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Checkbox2.default;

/***/ }),
/* 679 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _simpleAssign = __webpack_require__(579);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _EnhancedSwitch = __webpack_require__(680);
	
	var _EnhancedSwitch2 = _interopRequireDefault(_EnhancedSwitch);
	
	var _transitions = __webpack_require__(582);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _checkBoxOutlineBlank = __webpack_require__(681);
	
	var _checkBoxOutlineBlank2 = _interopRequireDefault(_checkBoxOutlineBlank);
	
	var _checkBox = __webpack_require__(682);
	
	var _checkBox2 = _interopRequireDefault(_checkBox);
	
	var _deprecatedPropType = __webpack_require__(603);
	
	var _deprecatedPropType2 = _interopRequireDefault(_deprecatedPropType);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function getStyles(props, context) {
	  var checkbox = context.muiTheme.checkbox;
	
	  var checkboxSize = 24;
	
	  return {
	    icon: {
	      height: checkboxSize,
	      width: checkboxSize
	    },
	    check: {
	      position: 'absolute',
	      opacity: 0,
	      transform: 'scale(0)',
	      transitionOrigin: '50% 50%',
	      transition: _transitions2.default.easeOut('450ms', 'opacity', '0ms') + ', ' + _transitions2.default.easeOut('0ms', 'transform', '450ms'),
	      fill: checkbox.checkedColor
	    },
	    box: {
	      position: 'absolute',
	      opacity: 1,
	      fill: checkbox.boxColor,
	      transition: _transitions2.default.easeOut('2s', null, '200ms')
	    },
	    checkWhenSwitched: {
	      opacity: 1,
	      transform: 'scale(1)',
	      transition: _transitions2.default.easeOut('0ms', 'opacity', '0ms') + ', ' + _transitions2.default.easeOut('800ms', 'transform', '0ms')
	    },
	    boxWhenSwitched: {
	      transition: _transitions2.default.easeOut('100ms', null, '0ms'),
	      fill: checkbox.checkedColor
	    },
	    checkWhenDisabled: {
	      fill: checkbox.disabledColor,
	      cursor: 'not-allowed'
	    },
	    boxWhenDisabled: {
	      fill: props.checked ? 'transparent' : checkbox.disabledColor,
	      cursor: 'not-allowed'
	    },
	    label: {
	      color: props.disabled ? checkbox.labelDisabledColor : checkbox.labelColor
	    }
	  };
	}
	
	var Checkbox = function (_Component) {
	  _inherits(Checkbox, _Component);
	
	  function Checkbox() {
	    var _Object$getPrototypeO;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Checkbox);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_Object$getPrototypeO = Object.getPrototypeOf(Checkbox)).call.apply(_Object$getPrototypeO, [this].concat(args))), _this), _this.state = {
	      switched: false
	    }, _this.handleStateChange = function (newSwitched) {
	      _this.setState({
	        switched: newSwitched
	      });
	    }, _this.handleCheck = function (event, isInputChecked) {
	      if (_this.props.onCheck) {
	        _this.props.onCheck(event, isInputChecked);
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Checkbox, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _props = this.props;
	      var checked = _props.checked;
	      var defaultChecked = _props.defaultChecked;
	      var valueLink = _props.valueLink;
	
	
	      if (checked || defaultChecked || valueLink && valueLink.value) {
	        this.setState({
	          switched: true
	        });
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.props.checked !== nextProps.checked) {
	        this.setState({
	          switched: nextProps.checked
	        });
	      }
	    }
	  }, {
	    key: 'isChecked',
	    value: function isChecked() {
	      return this.refs.enhancedSwitch.isSwitched();
	    }
	  }, {
	    key: 'setChecked',
	    value: function setChecked(newCheckedValue) {
	      this.refs.enhancedSwitch.setSwitched(newCheckedValue);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props;
	      var iconStyle = _props2.iconStyle;
	      var onCheck = _props2.onCheck;
	      var checkedIcon = _props2.checkedIcon;
	      var uncheckedIcon = _props2.uncheckedIcon;
	      var unCheckedIcon = _props2.unCheckedIcon;
	
	      var other = _objectWithoutProperties(_props2, ['iconStyle', 'onCheck', 'checkedIcon', 'uncheckedIcon', 'unCheckedIcon']);
	
	      var styles = getStyles(this.props, this.context);
	      var boxStyles = (0, _simpleAssign2.default)(styles.box, this.state.switched && styles.boxWhenSwitched, iconStyle, this.props.disabled && styles.boxWhenDisabled);
	      var checkStyles = (0, _simpleAssign2.default)(styles.check, this.state.switched && styles.checkWhenSwitched, iconStyle, this.props.disabled && styles.checkWhenDisabled);
	
	      var checkedElement = checkedIcon ? _react2.default.cloneElement(checkedIcon, {
	        style: (0, _simpleAssign2.default)(checkStyles, checkedIcon.props.style)
	      }) : _react2.default.createElement(_checkBox2.default, {
	        style: checkStyles
	      });
	
	      var unCheckedElement = unCheckedIcon || uncheckedIcon ? _react2.default.cloneElement(unCheckedIcon || uncheckedIcon, {
	        style: (0, _simpleAssign2.default)(boxStyles, (unCheckedIcon || uncheckedIcon).props.style)
	      }) : _react2.default.createElement(_checkBoxOutlineBlank2.default, {
	        style: boxStyles
	      });
	
	      var checkboxElement = _react2.default.createElement(
	        'div',
	        null,
	        unCheckedElement,
	        checkedElement
	      );
	
	      var rippleColor = this.state.switched ? checkStyles.fill : boxStyles.fill;
	      var mergedIconStyle = (0, _simpleAssign2.default)(styles.icon, iconStyle);
	
	      var labelStyle = (0, _simpleAssign2.default)(styles.label, this.props.labelStyle);
	
	      var enhancedSwitchProps = {
	        ref: 'enhancedSwitch',
	        inputType: 'checkbox',
	        switched: this.state.switched,
	        switchElement: checkboxElement,
	        rippleColor: rippleColor,
	        iconStyle: mergedIconStyle,
	        onSwitch: this.handleCheck,
	        labelStyle: labelStyle,
	        onParentShouldUpdate: this.handleStateChange,
	        labelPosition: this.props.labelPosition
	      };
	
	      return _react2.default.createElement(_EnhancedSwitch2.default, _extends({}, other, enhancedSwitchProps));
	    }
	  }]);
	
	  return Checkbox;
	}(_react.Component);
	
	Checkbox.propTypes = {
	  /**
	   * Checkbox is checked if true.
	   */
	  checked: _react.PropTypes.bool,
	  /**
	   * The SvgIcon to use for the checked state.
	   * This is useful to create icon toggles.
	   */
	  checkedIcon: _react.PropTypes.element,
	  /**
	   * The default state of our checkbox component.
	   * **Warning:** This cannot be used in conjunction with `checked`.
	   * Decide between using a controlled or uncontrolled input element and remove one of these props.
	   * More info: https://fb.me/react-controlled-components
	   */
	  defaultChecked: _react.PropTypes.bool,
	  /**
	   * Disabled if true.
	   */
	  disabled: _react.PropTypes.bool,
	  /**
	   * Overrides the inline-styles of the icon element.
	   */
	  iconStyle: _react.PropTypes.object,
	  /**
	   * Overrides the inline-styles of the input element.
	   */
	  inputStyle: _react.PropTypes.object,
	  /**
	   * Where the label will be placed next to the checkbox.
	   */
	  labelPosition: _react.PropTypes.oneOf(['left', 'right']),
	  /**
	   * Overrides the inline-styles of the Checkbox element label.
	   */
	  labelStyle: _react.PropTypes.object,
	  /**
	   * Callback function that is fired when the checkbox is checked.
	   *
	   * @param {object} event `change` event targeting the underlying checkbox `input`.
	   * @param {boolean} isInputChecked The `checked` value of the underlying checkbox `input`.
	   */
	  onCheck: _react.PropTypes.func,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object,
	  /**
	   * The SvgIcon to use for the unchecked state.
	   * This is useful to create icon toggles.
	   */
	  unCheckedIcon: (0, _deprecatedPropType2.default)(_react.PropTypes.element, 'Use uncheckedIcon instead. It will be removed with v0.16.0.'),
	  /**
	   * The SvgIcon to use for the unchecked state.
	   * This is useful to create icon toggles.
	   */
	  uncheckedIcon: _react.PropTypes.element,
	  /**
	   * ValueLink for when using controlled checkbox.
	   */
	  valueLink: _react.PropTypes.object
	};
	Checkbox.defaultProps = {
	  labelPosition: 'right',
	  disabled: false
	};
	Checkbox.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	exports.default = Checkbox;

/***/ }),
/* 680 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _simpleAssign = __webpack_require__(579);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactEventListener = __webpack_require__(625);
	
	var _reactEventListener2 = _interopRequireDefault(_reactEventListener);
	
	var _keycode = __webpack_require__(589);
	
	var _keycode2 = _interopRequireDefault(_keycode);
	
	var _transitions = __webpack_require__(582);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _FocusRipple = __webpack_require__(590);
	
	var _FocusRipple2 = _interopRequireDefault(_FocusRipple);
	
	var _TouchRipple = __webpack_require__(600);
	
	var _TouchRipple2 = _interopRequireDefault(_TouchRipple);
	
	var _Paper = __webpack_require__(617);
	
	var _Paper2 = _interopRequireDefault(_Paper);
	
	var _warning = __webpack_require__(491);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function getStyles(props, context) {
	  var baseTheme = context.muiTheme.baseTheme;
	
	
	  return {
	    root: {
	      position: 'relative',
	      cursor: props.disabled ? 'default' : 'pointer',
	      overflow: 'visible',
	      display: 'table',
	      height: 'auto',
	      width: '100%'
	    },
	    input: {
	      position: 'absolute',
	      cursor: props.disabled ? 'default' : 'pointer',
	      pointerEvents: 'all',
	      opacity: 0,
	      width: '100%',
	      height: '100%',
	      zIndex: 2,
	      left: 0,
	      boxSizing: 'border-box',
	      padding: 0,
	      margin: 0
	    },
	    controls: {
	      display: 'flex',
	      width: '100%',
	      height: '100%'
	    },
	    label: {
	      float: 'left',
	      position: 'relative',
	      display: 'block',
	      width: 'calc(100% - 60px)',
	      lineHeight: '24px',
	      color: baseTheme.palette.textColor,
	      fontFamily: baseTheme.fontFamily
	    },
	    wrap: {
	      transition: _transitions2.default.easeOut(),
	      float: 'left',
	      position: 'relative',
	      display: 'block',
	      flexShrink: 0,
	      width: 60 - baseTheme.spacing.desktopGutterLess,
	      marginRight: props.labelPosition === 'right' ? baseTheme.spacing.desktopGutterLess : 0,
	      marginLeft: props.labelPosition === 'left' ? baseTheme.spacing.desktopGutterLess : 0
	    },
	    ripple: {
	      color: props.rippleColor || baseTheme.palette.primary1Color,
	      height: '200%',
	      width: '200%',
	      top: -12,
	      left: -12
	    }
	  };
	}
	
	var EnhancedSwitch = function (_Component) {
	  _inherits(EnhancedSwitch, _Component);
	
	  function EnhancedSwitch() {
	    var _Object$getPrototypeO;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, EnhancedSwitch);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_Object$getPrototypeO = Object.getPrototypeOf(EnhancedSwitch)).call.apply(_Object$getPrototypeO, [this].concat(args))), _this), _this.state = {
	      isKeyboardFocused: false
	    }, _this.handleChange = function (event) {
	      _this.tabPressed = false;
	      _this.setState({
	        isKeyboardFocused: false
	      });
	
	      var isInputChecked = _this.refs.checkbox.checked;
	
	      if (!_this.props.hasOwnProperty('checked') && _this.props.onParentShouldUpdate) {
	        _this.props.onParentShouldUpdate(isInputChecked);
	      }
	
	      if (_this.props.onSwitch) {
	        _this.props.onSwitch(event, isInputChecked);
	      }
	    }, _this.handleKeyDown = function (event) {
	      var code = (0, _keycode2.default)(event);
	
	      if (code === 'tab') {
	        _this.tabPressed = true;
	      }
	      if (_this.state.isKeyboardFocused && code === 'space') {
	        _this.handleChange(event);
	      }
	    }, _this.handleKeyUp = function (event) {
	      if (_this.state.isKeyboardFocused && (0, _keycode2.default)(event) === 'space') {
	        _this.handleChange(event);
	      }
	    }, _this.handleMouseDown = function (event) {
	      // only listen to left clicks
	      if (event.button === 0) {
	        _this.refs.touchRipple.start(event);
	      }
	    }, _this.handleMouseUp = function () {
	      _this.refs.touchRipple.end();
	    }, _this.handleMouseLeave = function () {
	      _this.refs.touchRipple.end();
	    }, _this.handleTouchStart = function (event) {
	      _this.refs.touchRipple.start(event);
	    }, _this.handleTouchEnd = function () {
	      _this.refs.touchRipple.end();
	    }, _this.handleBlur = function (event) {
	      _this.setState({
	        isKeyboardFocused: false
	      });
	
	      if (_this.props.onBlur) {
	        _this.props.onBlur(event);
	      }
	    }, _this.handleFocus = function (event) {
	      // setTimeout is needed becuase the focus event fires first
	      // Wait so that we can capture if this was a keyboard focus
	      // or touch focus
	      setTimeout(function () {
	        if (_this.tabPressed) {
	          _this.setState({
	            isKeyboardFocused: true
	          });
	        }
	      }, 150);
	
	      if (_this.props.onFocus) {
	        _this.props.onFocus(event);
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(EnhancedSwitch, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var inputNode = this.refs.checkbox;
	      if ((!this.props.switched || inputNode.checked !== this.props.switched) && this.props.onParentShouldUpdate) {
	        this.props.onParentShouldUpdate(inputNode.checked);
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var hasCheckedProp = nextProps.hasOwnProperty('checked');
	      var hasToggledProp = nextProps.hasOwnProperty('toggled');
	      var hasNewDefaultProp = nextProps.hasOwnProperty('defaultChecked') && nextProps.defaultChecked !== this.props.defaultChecked;
	
	      if (hasCheckedProp || hasToggledProp || hasNewDefaultProp) {
	        var switched = nextProps.checked || nextProps.toggled || nextProps.defaultChecked || false;
	
	        this.setState({
	          switched: switched
	        });
	
	        if (this.props.onParentShouldUpdate && switched !== this.props.switched) {
	          this.props.onParentShouldUpdate(switched);
	        }
	      }
	    }
	  }, {
	    key: 'isSwitched',
	    value: function isSwitched() {
	      return this.refs.checkbox.checked;
	    }
	
	    // no callback here because there is no event
	
	  }, {
	    key: 'setSwitched',
	    value: function setSwitched(newSwitchedValue) {
	      if (!this.props.hasOwnProperty('checked') || this.props.checked === false) {
	        if (this.props.onParentShouldUpdate) {
	          this.props.onParentShouldUpdate(newSwitchedValue);
	        }
	        this.refs.checkbox.checked = newSwitchedValue;
	      } else {
	         false ? (0, _warning2.default)(false, 'Cannot call set method while checked is defined as a property.') : void 0;
	      }
	    }
	  }, {
	    key: 'getValue',
	    value: function getValue() {
	      return this.refs.checkbox.value;
	    }
	
	    // Checkbox inputs only use SPACE to change their state. Using ENTER will
	    // update the ui but not the input.
	
	
	    /**
	     * Because both the ripples and the checkbox input cannot share pointer
	     * events, the checkbox input takes control of pointer events and calls
	     * ripple animations manually.
	     */
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var name = _props.name;
	      var value = _props.value;
	      var iconStyle = _props.iconStyle;
	      var inputStyle = _props.inputStyle;
	      var inputType = _props.inputType;
	      var label = _props.label;
	      var labelStyle = _props.labelStyle;
	      var labelPosition = _props.labelPosition;
	      var onSwitch = _props.onSwitch;
	      var onBlur = _props.onBlur;
	      var onFocus = _props.onFocus;
	      var onMouseUp = _props.onMouseUp;
	      var onMouseDown = _props.onMouseDown;
	      var onMouseLeave = _props.onMouseLeave;
	      var onTouchStart = _props.onTouchStart;
	      var onTouchEnd = _props.onTouchEnd;
	      var onParentShouldUpdate = _props.onParentShouldUpdate;
	      var disabled = _props.disabled;
	      var disableTouchRipple = _props.disableTouchRipple;
	      var disableFocusRipple = _props.disableFocusRipple;
	      var className = _props.className;
	      var rippleColor = _props.rippleColor;
	      var rippleStyle = _props.rippleStyle;
	      var style = _props.style;
	      var switched = _props.switched;
	      var switchElement = _props.switchElement;
	      var thumbStyle = _props.thumbStyle;
	      var trackStyle = _props.trackStyle;
	
	      var other = _objectWithoutProperties(_props, ['name', 'value', 'iconStyle', 'inputStyle', 'inputType', 'label', 'labelStyle', 'labelPosition', 'onSwitch', 'onBlur', 'onFocus', 'onMouseUp', 'onMouseDown', 'onMouseLeave', 'onTouchStart', 'onTouchEnd', 'onParentShouldUpdate', 'disabled', 'disableTouchRipple', 'disableFocusRipple', 'className', 'rippleColor', 'rippleStyle', 'style', 'switched', 'switchElement', 'thumbStyle', 'trackStyle']);
	
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	      var wrapStyles = (0, _simpleAssign2.default)(styles.wrap, iconStyle);
	      var mergedRippleStyle = (0, _simpleAssign2.default)(styles.ripple, rippleStyle);
	
	      if (thumbStyle) {
	        wrapStyles.marginLeft /= 2;
	        wrapStyles.marginRight /= 2;
	      }
	
	      var labelElement = label && _react2.default.createElement(
	        'label',
	        { style: prepareStyles((0, _simpleAssign2.default)(styles.label, labelStyle)) },
	        label
	      );
	
	      var showTouchRipple = !disabled && !disableTouchRipple;
	      var showFocusRipple = !disabled && !disableFocusRipple;
	
	      var touchRipple = _react2.default.createElement(_TouchRipple2.default, {
	        ref: 'touchRipple',
	        key: 'touchRipple',
	        style: mergedRippleStyle,
	        color: mergedRippleStyle.color,
	        muiTheme: this.context.muiTheme,
	        centerRipple: true
	      });
	
	      var focusRipple = _react2.default.createElement(_FocusRipple2.default, {
	        key: 'focusRipple',
	        innerStyle: mergedRippleStyle,
	        color: mergedRippleStyle.color,
	        muiTheme: this.context.muiTheme,
	        show: this.state.isKeyboardFocused
	      });
	
	      var ripples = [showTouchRipple ? touchRipple : null, showFocusRipple ? focusRipple : null];
	
	      var inputElement = _react2.default.createElement('input', _extends({}, other, {
	        ref: 'checkbox',
	        type: inputType,
	        style: prepareStyles((0, _simpleAssign2.default)(styles.input, inputStyle)),
	        name: name,
	        value: value,
	        disabled: disabled,
	        onBlur: this.handleBlur,
	        onFocus: this.handleFocus,
	        onChange: this.handleChange,
	        onMouseUp: showTouchRipple && this.handleMouseUp,
	        onMouseDown: showTouchRipple && this.handleMouseDown,
	        onMouseLeave: showTouchRipple && this.handleMouseLeave,
	        onTouchStart: showTouchRipple && this.handleTouchStart,
	        onTouchEnd: showTouchRipple && this.handleTouchEnd
	      }));
	
	      // If toggle component (indicated by whether the style includes thumb) manually lay out
	      // elements in order to nest ripple elements
	      var switchOrThumbElement = !thumbStyle ? _react2.default.createElement(
	        'div',
	        { style: prepareStyles(wrapStyles) },
	        switchElement,
	        ripples
	      ) : _react2.default.createElement(
	        'div',
	        { style: prepareStyles(wrapStyles) },
	        _react2.default.createElement('div', { style: prepareStyles((0, _simpleAssign2.default)({}, trackStyle)) }),
	        _react2.default.createElement(
	          _Paper2.default,
	          { style: thumbStyle, zDepth: 1, circle: true },
	          ' ',
	          ripples,
	          ' '
	        )
	      );
	
	      var elementsInOrder = labelPosition === 'right' ? _react2.default.createElement(
	        'div',
	        { style: styles.controls },
	        switchOrThumbElement,
	        labelElement
	      ) : _react2.default.createElement(
	        'div',
	        { style: styles.controls },
	        labelElement,
	        switchOrThumbElement
	      );
	
	      return _react2.default.createElement(
	        'div',
	        { ref: 'root', className: className, style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) },
	        _react2.default.createElement(_reactEventListener2.default, {
	          target: 'window',
	          onKeyDown: this.handleKeyDown,
	          onKeyUp: this.handleKeyUp
	        }),
	        inputElement,
	        elementsInOrder
	      );
	    }
	  }]);
	
	  return EnhancedSwitch;
	}(_react.Component);
	
	EnhancedSwitch.propTypes = {
	  checked: _react.PropTypes.bool,
	  className: _react.PropTypes.string,
	  defaultChecked: _react.PropTypes.bool,
	  disableFocusRipple: _react.PropTypes.bool,
	  disableTouchRipple: _react.PropTypes.bool,
	  disabled: _react.PropTypes.bool,
	  iconStyle: _react.PropTypes.object,
	  inputStyle: _react.PropTypes.object,
	  inputType: _react.PropTypes.string.isRequired,
	  label: _react.PropTypes.node,
	  labelPosition: _react.PropTypes.oneOf(['left', 'right']),
	  labelStyle: _react.PropTypes.object,
	  name: _react.PropTypes.string,
	  onBlur: _react.PropTypes.func,
	  onFocus: _react.PropTypes.func,
	  onMouseDown: _react.PropTypes.func,
	  onMouseLeave: _react.PropTypes.func,
	  onMouseUp: _react.PropTypes.func,
	  onParentShouldUpdate: _react.PropTypes.func,
	  onSwitch: _react.PropTypes.func,
	  onTouchEnd: _react.PropTypes.func,
	  onTouchStart: _react.PropTypes.func,
	  rippleColor: _react.PropTypes.string,
	  rippleStyle: _react.PropTypes.object,
	  style: _react.PropTypes.object,
	  switchElement: _react.PropTypes.element.isRequired,
	  switched: _react.PropTypes.bool.isRequired,
	  thumbStyle: _react.PropTypes.object,
	  trackStyle: _react.PropTypes.object,
	  value: _react.PropTypes.any
	};
	EnhancedSwitch.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	exports.default = EnhancedSwitch;

/***/ }),
/* 681 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(608);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(615);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ToggleCheckBoxOutlineBlank = function ToggleCheckBoxOutlineBlank(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z' })
	  );
	};
	ToggleCheckBoxOutlineBlank = (0, _pure2.default)(ToggleCheckBoxOutlineBlank);
	ToggleCheckBoxOutlineBlank.displayName = 'ToggleCheckBoxOutlineBlank';
	ToggleCheckBoxOutlineBlank.muiName = 'SvgIcon';
	
	exports.default = ToggleCheckBoxOutlineBlank;

/***/ }),
/* 682 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(608);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(615);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ToggleCheckBox = function ToggleCheckBox(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z' })
	  );
	};
	ToggleCheckBox = (0, _pure2.default)(ToggleCheckBox);
	ToggleCheckBox.displayName = 'ToggleCheckBox';
	ToggleCheckBox.muiName = 'SvgIcon';
	
	exports.default = ToggleCheckBox;

/***/ }),
/* 683 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _Chip = __webpack_require__(684);
	
	var _Chip2 = _interopRequireDefault(_Chip);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Chip2.default;

/***/ }),
/* 684 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _simpleAssign = __webpack_require__(579);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _keycode = __webpack_require__(589);
	
	var _keycode2 = _interopRequireDefault(_keycode);
	
	var _colorManipulator = __webpack_require__(623);
	
	var _EnhancedButton = __webpack_require__(584);
	
	var _EnhancedButton2 = _interopRequireDefault(_EnhancedButton);
	
	var _cancel = __webpack_require__(685);
	
	var _cancel2 = _interopRequireDefault(_cancel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function getStyles(props, context, state) {
	  var chip = context.muiTheme.chip;
	
	
	  var backgroundColor = props.backgroundColor || chip.backgroundColor;
	  var focusColor = (0, _colorManipulator.emphasize)(backgroundColor, 0.08);
	  var pressedColor = (0, _colorManipulator.emphasize)(backgroundColor, 0.12);
	
	  return {
	    avatar: {
	      marginRight: -4
	    },
	    deleteIcon: {
	      color: state.deleteHovered ? (0, _colorManipulator.fade)(chip.deleteIconColor, 0.4) : chip.deleteIconColor,
	      cursor: 'pointer',
	      margin: '4px 4px 0px -8px'
	    },
	    label: {
	      color: props.labelColor || chip.textColor,
	      fontSize: chip.fontSize,
	      fontWeight: chip.fontWeight,
	      lineHeight: '32px',
	      paddingLeft: 12,
	      paddingRight: 12,
	      userSelect: 'none',
	      whiteSpace: 'nowrap'
	    },
	    root: {
	      backgroundColor: state.clicked ? pressedColor : state.focused || state.hovered ? focusColor : backgroundColor,
	      borderRadius: 16,
	      boxShadow: state.clicked ? chip.shadow : null,
	      cursor: props.onTouchTap ? 'pointer' : 'default',
	      display: 'flex',
	      whiteSpace: 'nowrap',
	      width: 'fit-content'
	    }
	  };
	}
	
	var Chip = function (_Component) {
	  _inherits(Chip, _Component);
	
	  function Chip() {
	    var _Object$getPrototypeO;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Chip);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_Object$getPrototypeO = Object.getPrototypeOf(Chip)).call.apply(_Object$getPrototypeO, [this].concat(args))), _this), _this.state = {
	      clicked: false,
	      deleteHovered: false,
	      focused: false,
	      hovered: false
	    }, _this.handleBlur = function (event) {
	      _this.setState({ clicked: false, focused: false });
	      _this.props.onBlur(event);
	    }, _this.handleFocus = function (event) {
	      if (_this.props.onTouchTap || _this.props.onRequestDelete) {
	        _this.setState({ focused: true });
	      }
	      _this.props.onFocus(event);
	    }, _this.handleKeyboardFocus = function (event, keyboardFocused) {
	      if (keyboardFocused) {
	        _this.handleFocus();
	        _this.props.onFocus(event);
	      } else {
	        _this.handleBlur();
	      }
	
	      _this.props.onKeyboardFocus(event, keyboardFocused);
	    }, _this.handleKeyDown = function (event) {
	      if ((0, _keycode2.default)(event) === 'backspace') {
	        event.preventDefault();
	        if (_this.props.onRequestDelete) {
	          _this.props.onRequestDelete(event);
	        }
	      }
	      _this.props.onKeyDown(event);
	    }, _this.handleMouseDown = function (event) {
	      // Only listen to left clicks
	      if (event.button === 0) {
	        event.stopPropagation();
	        if (_this.props.onTouchTap) {
	          _this.setState({ clicked: true });
	        }
	      }
	      _this.props.onMouseDown(event);
	    }, _this.handleMouseEnter = function (event) {
	      if (_this.props.onTouchTap) {
	        _this.setState({ hovered: true });
	      }
	      _this.props.onMouseEnter(event);
	    }, _this.handleMouseEnterDeleteIcon = function () {
	      _this.setState({ deleteHovered: true });
	    }, _this.handleMouseLeave = function (event) {
	      _this.setState({
	        clicked: false,
	        hovered: false
	      });
	      _this.props.onMouseLeave(event);
	    }, _this.handleMouseLeaveDeleteIcon = function () {
	      _this.setState({ deleteHovered: false });
	    }, _this.handleMouseUp = function (event) {
	      _this.setState({ clicked: false });
	      _this.props.onMouseUp(event);
	    }, _this.handleTouchTapDeleteIcon = function (event) {
	      // Stop the event from bubbling up to the `Chip`
	      event.stopPropagation();
	      _this.props.onRequestDelete(event);
	    }, _this.handleTouchEnd = function (event) {
	      _this.setState({ clicked: false });
	      _this.props.onTouchEnd(event);
	    }, _this.handleTouchStart = function (event) {
	      event.stopPropagation();
	      if (_this.props.onTouchTap) {
	        _this.setState({ clicked: true });
	      }
	      _this.props.onTouchStart(event);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Chip, [{
	    key: 'render',
	    value: function render() {
	      var buttonEventHandlers = {
	        onBlur: this.handleBlur,
	        onFocus: this.handleFocus,
	        onKeyDown: this.handleKeyDown,
	        onMouseDown: this.handleMouseDown,
	        onMouseEnter: this.handleMouseEnter,
	        onMouseLeave: this.handleMouseLeave,
	        onMouseUp: this.handleMouseUp,
	        onTouchEnd: this.handleTouchEnd,
	        onTouchStart: this.handleTouchStart,
	        onKeyboardFocus: this.handleKeyboardFocus
	      };
	
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context, this.state);
	
	      var _props = this.props;
	      var children = _props.children;
	      var style = _props.style;
	      var className = _props.className;
	      var labelStyle = _props.labelStyle;
	      var labelColor = _props.labelColor;
	      var backgroundColor = _props.backgroundColor;
	      var onRequestDelete = _props.onRequestDelete;
	
	      var other = _objectWithoutProperties(_props, ['children', 'style', 'className', 'labelStyle', 'labelColor', 'backgroundColor', 'onRequestDelete']);
	
	      var deletable = this.props.onRequestDelete;
	      var avatar = null;
	
	      style = (0, _simpleAssign2.default)(styles.root, style);
	      labelStyle = prepareStyles((0, _simpleAssign2.default)(styles.label, labelStyle));
	
	      var deleteIcon = deletable ? _react2.default.createElement(_cancel2.default, {
	        color: styles.deleteIcon.color,
	        style: styles.deleteIcon,
	        onTouchTap: this.handleTouchTapDeleteIcon,
	        onMouseEnter: this.handleMouseEnterDeleteIcon,
	        onMouseLeave: this.handleMouseLeaveDeleteIcon
	      }) : null;
	
	      var childCount = _react2.default.Children.count(children);
	
	      // If the first child is an avatar, extract it and style it
	      if (childCount > 1) {
	        children = _react2.default.Children.toArray(children);
	
	        if (_react2.default.isValidElement(children[0]) && children[0].type.muiName === 'Avatar') {
	          avatar = children.shift();
	
	          avatar = _react2.default.cloneElement(avatar, {
	            style: (0, _simpleAssign2.default)(styles.avatar, avatar.props.style),
	            size: 32
	          });
	        }
	      }
	
	      return _react2.default.createElement(
	        _EnhancedButton2.default,
	        _extends({}, other, buttonEventHandlers, {
	          className: className,
	          containerElement: 'div' // Firefox doesn't support nested buttons
	          , disableTouchRipple: true,
	          disableFocusRipple: true,
	          style: style
	        }),
	        avatar,
	        _react2.default.createElement(
	          'span',
	          { style: labelStyle },
	          children
	        ),
	        deleteIcon
	      );
	    }
	  }]);
	
	  return Chip;
	}(_react.Component);
	
	Chip.propTypes = {
	  /**
	   * Override the background color of the chip.
	   */
	  backgroundColor: _react.PropTypes.string,
	  /**
	   * Used to render elements inside the Chip.
	   */
	  children: _react.PropTypes.node,
	  /**
	   * CSS `className` of the root element.
	   */
	  className: _react.PropTypes.node,
	  /**
	   * Override the label color.
	   */
	  labelColor: _react.PropTypes.string,
	  /**
	   * Override the inline-styles of the label.
	   */
	  labelStyle: _react.PropTypes.object,
	  /** @ignore */
	  onBlur: _react.PropTypes.func,
	  /** @ignore */
	  onFocus: _react.PropTypes.func,
	  /** @ignore */
	  onKeyDown: _react.PropTypes.func,
	  /** @ignore */
	  onKeyboardFocus: _react.PropTypes.func,
	  /** @ignore */
	  onMouseDown: _react.PropTypes.func,
	  /** @ignore */
	  onMouseEnter: _react.PropTypes.func,
	  /** @ignore */
	  onMouseLeave: _react.PropTypes.func,
	  /** @ignore */
	  onMouseUp: _react.PropTypes.func,
	  /**
	   * Callback function fired when the delete icon is clicked. If set, the delete icon will be shown.
	   * @param {object} event `touchTap` event targeting the element.
	   */
	  onRequestDelete: _react.PropTypes.func,
	  /** @ignore */
	  onTouchEnd: _react.PropTypes.func,
	  /** @ignore */
	  onTouchStart: _react.PropTypes.func,
	  /**
	   * Callback function fired when the `Chip` element is touch-tapped.
	   *
	   * @param {object} event TouchTap event targeting the element.
	   */
	  onTouchTap: _react.PropTypes.func,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object
	};
	Chip.defaultProps = {
	  onBlur: function onBlur() {},
	  onFocus: function onFocus() {},
	  onKeyDown: function onKeyDown() {},
	  onKeyboardFocus: function onKeyboardFocus() {},
	  onMouseDown: function onMouseDown() {},
	  onMouseEnter: function onMouseEnter() {},
	  onMouseLeave: function onMouseLeave() {},
	  onMouseUp: function onMouseUp() {},
	  onTouchEnd: function onTouchEnd() {},
	  onTouchStart: function onTouchStart() {}
	};
	Chip.contextTypes = { muiTheme: _react.PropTypes.object.isRequired };
	exports.default = Chip;

/***/ }),
/* 685 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(608);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(615);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NavigationCancel = function NavigationCancel(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z' })
	  );
	};
	NavigationCancel = (0, _pure2.default)(NavigationCancel);
	NavigationCancel.displayName = 'NavigationCancel';
	NavigationCancel.muiName = 'SvgIcon';
	
	exports.default = NavigationCancel;

/***/ }),
/* 686 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _CircularProgress = __webpack_require__(687);
	
	var _CircularProgress2 = _interopRequireDefault(_CircularProgress);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _CircularProgress2.default;

/***/ }),
/* 687 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _simpleAssign = __webpack_require__(579);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _autoPrefix = __webpack_require__(593);
	
	var _autoPrefix2 = _interopRequireDefault(_autoPrefix);
	
	var _transitions = __webpack_require__(582);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function getRelativeValue(value, min, max) {
	  var clampedValue = Math.min(Math.max(min, value), max);
	  var rangeValue = max - min;
	  var relValue = Math.round(clampedValue / rangeValue * 10000) / 10000;
	  return relValue * 100;
	}
	
	function getStyles(props, context) {
	  var max = props.max;
	  var min = props.min;
	  var size = props.size;
	  var value = props.value;
	  var palette = context.muiTheme.baseTheme.palette;
	
	  var zoom = size * 1.4;
	  var baseSize = 50;
	  var margin = Math.round((50 * zoom - 50) / 2);
	
	  if (margin < 0) margin = 0;
	
	  var styles = {
	    root: {
	      position: 'relative',
	      margin: margin,
	      display: 'inline-block',
	      width: baseSize,
	      height: baseSize
	    },
	    wrapper: {
	      width: baseSize,
	      height: baseSize,
	      display: 'inline-block',
	      transition: _transitions2.default.create('transform', '20s', null, 'linear'),
	      transitionTimingFunction: 'linear'
	    },
	    svg: {
	      height: baseSize,
	      position: 'relative',
	      transform: 'scale(' + zoom + ')',
	      width: baseSize
	    },
	    path: {
	      strokeDasharray: '89, 200',
	      strokeDashoffset: 0,
	      stroke: props.color || palette.primary1Color,
	      strokeLinecap: 'round',
	      transition: _transitions2.default.create('all', '1.5s', null, 'ease-in-out')
	    }
	  };
	
	  if (props.mode === 'determinate') {
	    var relVal = getRelativeValue(value, min, max);
	    styles.path.transition = _transitions2.default.create('all', '0.3s', null, 'linear');
	    styles.path.strokeDasharray = Math.round(relVal * 1.25) + ', 200';
	  }
	
	  return styles;
	}
	
	var CircularProgress = function (_Component) {
	  _inherits(CircularProgress, _Component);
	
	  function CircularProgress() {
	    _classCallCheck(this, CircularProgress);
	
	    return _possibleConstructorReturn(this, Object.getPrototypeOf(CircularProgress).apply(this, arguments));
	  }
	
	  _createClass(CircularProgress, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.scalePath(this.refs.path);
	      this.rotateWrapper(this.refs.wrapper);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      clearTimeout(this.scalePathTimer);
	      clearTimeout(this.rotateWrapperTimer);
	    }
	  }, {
	    key: 'scalePath',
	    value: function scalePath(path, step) {
	      var _this2 = this;
	
	      if (this.props.mode !== 'indeterminate') return;
	
	      step = step || 0;
	      step %= 3;
	
	      if (step === 0) {
	        path.style.strokeDasharray = '1, 200';
	        path.style.strokeDashoffset = 0;
	        path.style.transitionDuration = '0ms';
	      } else if (step === 1) {
	        path.style.strokeDasharray = '89, 200';
	        path.style.strokeDashoffset = -35;
	        path.style.transitionDuration = '750ms';
	      } else {
	        path.style.strokeDasharray = '89, 200';
	        path.style.strokeDashoffset = -124;
	        path.style.transitionDuration = '850ms';
	      }
	
	      this.scalePathTimer = setTimeout(function () {
	        return _this2.scalePath(path, step + 1);
	      }, step ? 750 : 250);
	    }
	  }, {
	    key: 'rotateWrapper',
	    value: function rotateWrapper(wrapper) {
	      var _this3 = this;
	
	      if (this.props.mode !== 'indeterminate') return;
	
	      _autoPrefix2.default.set(wrapper.style, 'transform', 'rotate(0deg)');
	      _autoPrefix2.default.set(wrapper.style, 'transitionDuration', '0ms');
	
	      setTimeout(function () {
	        _autoPrefix2.default.set(wrapper.style, 'transform', 'rotate(1800deg)');
	        _autoPrefix2.default.set(wrapper.style, 'transitionDuration', '10s');
	        _autoPrefix2.default.set(wrapper.style, 'transitionTimingFunction', 'linear');
	      }, 50);
	
	      this.rotateWrapperTimer = setTimeout(function () {
	        return _this3.rotateWrapper(wrapper);
	      }, 10050);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var style = _props.style;
	      var innerStyle = _props.innerStyle;
	      var size = _props.size;
	
	      var other = _objectWithoutProperties(_props, ['style', 'innerStyle', 'size']);
	
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      return _react2.default.createElement(
	        'div',
	        _extends({}, other, { style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) }),
	        _react2.default.createElement(
	          'div',
	          { ref: 'wrapper', style: prepareStyles((0, _simpleAssign2.default)(styles.wrapper, innerStyle)) },
	          _react2.default.createElement(
	            'svg',
	            { style: prepareStyles(styles.svg) },
	            _react2.default.createElement('circle', {
	              ref: 'path',
	              style: prepareStyles(styles.path),
	              cx: '25',
	              cy: '25',
	              r: '20',
	              fill: 'none',
	              strokeWidth: '2.5',
	              strokeMiterlimit: '20'
	            })
	          )
	        )
	      );
	    }
	  }]);
	
	  return CircularProgress;
	}(_react.Component);
	
	CircularProgress.propTypes = {
	  /**
	   * Override the progress's color.
	   */
	  color: _react.PropTypes.string,
	  /**
	   * Style for inner wrapper div.
	   */
	  innerStyle: _react.PropTypes.object,
	  /**
	   * The max value of progress, only works in determinate mode.
	   */
	  max: _react.PropTypes.number,
	  /**
	   * The min value of progress, only works in determinate mode.
	   */
	  min: _react.PropTypes.number,
	  /**
	   * The mode of show your progress, indeterminate
	   * for when there is no value for progress.
	   */
	  mode: _react.PropTypes.oneOf(['determinate', 'indeterminate']),
	  /**
	   * The size of the progress.
	   */
	  size: _react.PropTypes.number,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object,
	  /**
	   * The value of progress, only works in determinate mode.
	   */
	  value: _react.PropTypes.number
	};
	CircularProgress.defaultProps = {
	  mode: 'indeterminate',
	  value: 0,
	  min: 0,
	  max: 100,
	  size: 1
	};
	CircularProgress.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	exports.default = CircularProgress;

/***/ }),
/* 688 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _DatePicker = __webpack_require__(689);
	
	var _DatePicker2 = _interopRequireDefault(_DatePicker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _DatePicker2.default;

/***/ }),
/* 689 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _simpleAssign = __webpack_require__(579);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _dateUtils = __webpack_require__(690);
	
	var _DatePickerDialog = __webpack_require__(691);
	
	var _DatePickerDialog2 = _interopRequireDefault(_DatePickerDialog);
	
	var _TextField = __webpack_require__(621);
	
	var _TextField2 = _interopRequireDefault(_TextField);
	
	var _deprecatedPropType = __webpack_require__(603);
	
	var _deprecatedPropType2 = _interopRequireDefault(_deprecatedPropType);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DatePicker = function (_Component) {
	  _inherits(DatePicker, _Component);
	
	  function DatePicker() {
	    var _Object$getPrototypeO;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, DatePicker);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_Object$getPrototypeO = Object.getPrototypeOf(DatePicker)).call.apply(_Object$getPrototypeO, [this].concat(args))), _this), _this.state = {
	      date: undefined
	    }, _this.handleAccept = function (date) {
	      if (!_this.isControlled()) {
	        _this.setState({
	          date: date
	        });
	      }
	      if (_this.props.onChange) {
	        _this.props.onChange(null, date);
	      }
	    }, _this.handleFocus = function (event) {
	      event.target.blur();
	      if (_this.props.onFocus) {
	        _this.props.onFocus(event);
	      }
	    }, _this.handleTouchTap = function (event) {
	      if (_this.props.onTouchTap) {
	        _this.props.onTouchTap(event);
	      }
	
	      if (!_this.props.disabled) {
	        setTimeout(function () {
	          _this.openDialog();
	        }, 0);
	      }
	    }, _this.formatDate = function (date) {
	      if (_this.props.locale) {
	        var DateTimeFormat = _this.props.DateTimeFormat || _dateUtils.dateTimeFormat;
	        return new DateTimeFormat(_this.props.locale, {
	          day: 'numeric',
	          month: 'numeric',
	          year: 'numeric'
	        }).format(date);
	      } else {
	        return (0, _dateUtils.formatIso)(date);
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(DatePicker, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.setState({
	        date: this.isControlled() ? this.getControlledDate() : this.props.defaultDate
	      });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.isControlled()) {
	        var newDate = this.getControlledDate(nextProps);
	        if (!(0, _dateUtils.isEqualDate)(this.state.date, newDate)) {
	          this.setState({
	            date: newDate
	          });
	        }
	      }
	    }
	  }, {
	    key: 'getDate',
	    value: function getDate() {
	      return this.state.date;
	    }
	
	    /**
	     * Open the date-picker dialog programmatically from a parent.
	     */
	
	  }, {
	    key: 'openDialog',
	    value: function openDialog() {
	      /**
	       * if the date is not selected then set it to new date
	       * (get the current system date while doing so)
	       * else set it to the currently selected date
	       */
	      if (this.state.date !== undefined) {
	        this.setState({
	          dialogDate: this.getDate()
	        }, this.refs.dialogWindow.show);
	      } else {
	        this.setState({
	          dialogDate: new Date()
	        }, this.refs.dialogWindow.show);
	      }
	    }
	
	    /**
	     * Alias for `openDialog()` for an api consistent with TextField.
	     */
	
	  }, {
	    key: 'focus',
	    value: function focus() {
	      this.openDialog();
	    }
	  }, {
	    key: 'isControlled',
	    value: function isControlled() {
	      return this.props.hasOwnProperty('value');
	    }
	  }, {
	    key: 'getControlledDate',
	    value: function getControlledDate() {
	      var props = arguments.length <= 0 || arguments[0] === undefined ? this.props : arguments[0];
	
	      if (props.value instanceof Date) {
	        return props.value;
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var DateTimeFormat = _props.DateTimeFormat;
	      var autoOk = _props.autoOk;
	      var cancelLabel = _props.cancelLabel;
	      var className = _props.className;
	      var container = _props.container;
	      var defaultDate = _props.defaultDate;
	      var dialogContainerStyle = _props.dialogContainerStyle;
	      var disableYearSelection = _props.disableYearSelection;
	      var firstDayOfWeek = _props.firstDayOfWeek;
	      var formatDateProp = _props.formatDate;
	      var locale = _props.locale;
	      var maxDate = _props.maxDate;
	      var minDate = _props.minDate;
	      var mode = _props.mode;
	      var okLabel = _props.okLabel;
	      var onDismiss = _props.onDismiss;
	      var onFocus = _props.onFocus;
	      var onShow = _props.onShow;
	      var onTouchTap = _props.onTouchTap;
	      var shouldDisableDate = _props.shouldDisableDate;
	      var style = _props.style;
	      var textFieldStyle = _props.textFieldStyle;
	      var wordings = _props.wordings;
	
	      var other = _objectWithoutProperties(_props, ['DateTimeFormat', 'autoOk', 'cancelLabel', 'className', 'container', 'defaultDate', 'dialogContainerStyle', 'disableYearSelection', 'firstDayOfWeek', 'formatDate', 'locale', 'maxDate', 'minDate', 'mode', 'okLabel', 'onDismiss', 'onFocus', 'onShow', 'onTouchTap', 'shouldDisableDate', 'style', 'textFieldStyle', 'wordings']);
	
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var formatDate = formatDateProp || this.formatDate;
	
	      return _react2.default.createElement(
	        'div',
	        { className: className, style: prepareStyles((0, _simpleAssign2.default)({}, style)) },
	        _react2.default.createElement(_TextField2.default, _extends({}, other, {
	          onFocus: this.handleFocus,
	          onTouchTap: this.handleTouchTap,
	          ref: 'input',
	          style: textFieldStyle,
	          value: this.state.date ? formatDate(this.state.date) : ''
	        })),
	        _react2.default.createElement(_DatePickerDialog2.default, {
	          DateTimeFormat: DateTimeFormat,
	          autoOk: autoOk,
	          cancelLabel: cancelLabel,
	          container: container,
	          containerStyle: dialogContainerStyle,
	          disableYearSelection: disableYearSelection,
	          firstDayOfWeek: firstDayOfWeek,
	          initialDate: this.state.dialogDate,
	          locale: locale,
	          maxDate: maxDate,
	          minDate: minDate,
	          mode: mode,
	          okLabel: okLabel,
	          onAccept: this.handleAccept,
	          onShow: onShow,
	          onDismiss: onDismiss,
	          ref: 'dialogWindow',
	          shouldDisableDate: shouldDisableDate,
	          wordings: wordings
	        })
	      );
	    }
	  }]);
	
	  return DatePicker;
	}(_react.Component);
	
	DatePicker.propTypes = {
	  /**
	   * Constructor for date formatting for the specified `locale`.
	   * The constructor must follow this specification: ECMAScript Internationalization API 1.0 (ECMA-402).
	   * `Intl.DateTimeFormat` is supported by most modern browsers, see http://caniuse.com/#search=intl,
	   * otherwise https://github.com/andyearnshaw/Intl.js is a good polyfill.
	   *
	   * By default, a built-in `DateTimeFormat` is used which supports the 'en-US' `locale`.
	   */
	  DateTimeFormat: _react.PropTypes.func,
	  /**
	   * If true, automatically accept and close the picker on select a date.
	   */
	  autoOk: _react.PropTypes.bool,
	  /**
	   * Override the default text of the 'Cancel' button.
	   */
	  cancelLabel: _react.PropTypes.node,
	  /**
	   * The css class name of the root element.
	   */
	  className: _react.PropTypes.string,
	  /**
	   * Used to control how the Date Picker will be displayed when the input field is focused.
	   * `dialog` (default) displays the DatePicker as a dialog with a modal.
	   * `inline` displays the DatePicker below the input field (similar to auto complete).
	   */
	  container: _react.PropTypes.oneOf(['dialog', 'inline']),
	  /**
	   * This is the initial date value of the component.
	   * If either `value` or `valueLink` is provided they will override this
	   * prop with `value` taking precedence.
	   */
	  defaultDate: _react.PropTypes.object,
	  /**
	   * Override the inline-styles of DatePickerDialog's Container element.
	   */
	  dialogContainerStyle: _react.PropTypes.object,
	  /**
	   * Disables the year selection in the date picker.
	   */
	  disableYearSelection: _react.PropTypes.bool,
	  /**
	   * Disables the DatePicker.
	   */
	  disabled: _react.PropTypes.bool,
	  /**
	   * Used to change the first day of week. It varies from
	   * Saturday to Monday between different locales.
	   * The allowed range is 0 (Sunday) to 6 (Saturday).
	   * The default is `1`, Monday, as per ISO 8601.
	   */
	  firstDayOfWeek: _react.PropTypes.number,
	  /**
	   * This function is called to format the date displayed in the input field, and should return a string.
	   * By default if no `locale` and `DateTimeFormat` is provided date objects are formatted to ISO 8601 YYYY-MM-DD.
	   *
	   * @param {object} date Date object to be formatted.
	   * @returns {any} The formatted date.
	   */
	  formatDate: _react.PropTypes.func,
	  /**
	   * Locale used for formatting the `DatePicker` date strings. Other than for 'en-US', you
	   * must provide a `DateTimeFormat` that supports the chosen `locale`.
	   */
	  locale: _react.PropTypes.string,
	  /**
	   * The ending of a range of valid dates. The range includes the endDate.
	   * The default value is current date + 100 years.
	   */
	  maxDate: _react.PropTypes.object,
	  /**
	   * The beginning of a range of valid dates. The range includes the startDate.
	   * The default value is current date - 100 years.
	   */
	  minDate: _react.PropTypes.object,
	  /**
	   * Tells the component to display the picker in portrait or landscape mode.
	   */
	  mode: _react.PropTypes.oneOf(['portrait', 'landscape']),
	  /**
	   * Override the default text of the 'OK' button.
	   */
	  okLabel: _react.PropTypes.node,
	  /**
	   * Callback function that is fired when the date value changes.
	   *
	   * @param {null} null Since there is no particular event associated with the change,
	   * the first argument will always be null.
	   * @param {object} date The new date.
	   */
	  onChange: _react.PropTypes.func,
	  /**
	   * Callback function that is fired when the Date Picker's dialog is dismissed.
	   */
	  onDismiss: _react.PropTypes.func,
	  /**
	   * Callback function that is fired when the Date Picker's `TextField` gains focus.
	   */
	  onFocus: _react.PropTypes.func,
	  /**
	   * Callback function that is fired when the Date Picker's dialog is shown.
	   */
	  onShow: _react.PropTypes.func,
	  /**
	   * Callback function that is fired when a touch tap event occurs on the Date Picker's `TextField`.
	   *
	   * @param {object} event TouchTap event targeting the `TextField`.
	   */
	  onTouchTap: _react.PropTypes.func,
	  /**
	   * Callback function used to determine if a day's entry should be disabled on the calendar.
	   *
	   * @param {object} day Date object of a day.
	   * @returns {boolean} Indicates whether the day should be disabled.
	   */
	  shouldDisableDate: _react.PropTypes.func,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object,
	  /**
	   * Override the inline-styles of DatePicker's TextField element.
	   */
	  textFieldStyle: _react.PropTypes.object,
	  /**
	   * Sets the date for the Date Picker programmatically.
	   */
	  value: _react.PropTypes.object,
	  /**
	   * Wordings used inside the button of the dialog.
	   */
	  wordings: (0, _deprecatedPropType2.default)(_react.PropTypes.object, 'Instead, use `cancelLabel` and `okLabel`.\n      It will be removed with v0.16.0.')
	};
	DatePicker.defaultProps = {
	  autoOk: false,
	  container: 'dialog',
	  disabled: false,
	  disableYearSelection: false,
	  firstDayOfWeek: 1,
	  style: {}
	};
	DatePicker.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	exports.default = DatePicker;

/***/ }),
/* 690 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.dateTimeFormat = dateTimeFormat;
	exports.addDays = addDays;
	exports.addMonths = addMonths;
	exports.addYears = addYears;
	exports.cloneDate = cloneDate;
	exports.cloneAsDate = cloneAsDate;
	exports.getDaysInMonth = getDaysInMonth;
	exports.getFirstDayOfMonth = getFirstDayOfMonth;
	exports.getFirstDayOfWeek = getFirstDayOfWeek;
	exports.getWeekArray = getWeekArray;
	exports.localizedWeekday = localizedWeekday;
	exports.formatIso = formatIso;
	exports.isEqualDate = isEqualDate;
	exports.isBeforeDate = isBeforeDate;
	exports.isAfterDate = isAfterDate;
	exports.isBetweenDates = isBetweenDates;
	exports.monthDiff = monthDiff;
	exports.yearDiff = yearDiff;
	
	var _warning = __webpack_require__(491);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dayAbbreviation = ['S', 'M', 'T', 'W', 'T', 'F', 'S'];
	var dayList = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
	var monthList = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
	var monthLongList = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
	
	function dateTimeFormat(locale, options) {
	   false ? (0, _warning2.default)(locale === 'en-US', 'The ' + locale + ' locale is not supported by the built-in DateTimeFormat.\n  Use the `DateTimeFormat` prop to supply an alternative implementation.') : void 0;
	
	  this.format = function (date) {
	    if (options.month === 'short' && options.weekday === 'short' && options.day === '2-digit') {
	      return dayList[date.getDay()] + ', ' + monthList[date.getMonth()] + ' ' + date.getDate();
	    } else if (options.day === 'numeric' && options.month === 'numeric' && options.year === 'numeric') {
	      return date.getMonth() + 1 + '/' + date.getDate() + '/' + date.getFullYear();
	    } else if (options.month === 'long' && options.year === 'numeric') {
	      return monthLongList[date.getMonth()] + ' ' + date.getFullYear();
	    } else if (options.weekday === 'narrow') {
	      return dayAbbreviation[date.getDay()];
	    } else {
	       false ? (0, _warning2.default)(false, 'Wrong usage of DateTimeFormat') : void 0;
	    }
	  };
	}
	
	function addDays(d, days) {
	  var newDate = cloneDate(d);
	  newDate.setDate(d.getDate() + days);
	  return newDate;
	}
	
	function addMonths(d, months) {
	  var newDate = cloneDate(d);
	  newDate.setMonth(d.getMonth() + months);
	  return newDate;
	}
	
	function addYears(d, years) {
	  var newDate = cloneDate(d);
	  newDate.setFullYear(d.getFullYear() + years);
	  return newDate;
	}
	
	function cloneDate(d) {
	  return new Date(d.getTime());
	}
	
	function cloneAsDate(d) {
	  var clonedDate = cloneDate(d);
	  clonedDate.setHours(0, 0, 0, 0);
	  return clonedDate;
	}
	
	function getDaysInMonth(d) {
	  var resultDate = getFirstDayOfMonth(d);
	
	  resultDate.setMonth(resultDate.getMonth() + 1);
	  resultDate.setDate(resultDate.getDate() - 1);
	
	  return resultDate.getDate();
	}
	
	function getFirstDayOfMonth(d) {
	  return new Date(d.getFullYear(), d.getMonth(), 1);
	}
	
	function getFirstDayOfWeek() {
	  var now = new Date();
	  return new Date(now.setDate(now.getDate() - now.getDay()));
	}
	
	function getWeekArray(d, firstDayOfWeek) {
	  var dayArray = [];
	  var daysInMonth = getDaysInMonth(d);
	  var weekArray = [];
	  var week = [];
	
	  for (var i = 1; i <= daysInMonth; i++) {
	    dayArray.push(new Date(d.getFullYear(), d.getMonth(), i));
	  }
	
	  var addWeek = function addWeek(week) {
	    var emptyDays = 7 - week.length;
	    for (var _i = 0; _i < emptyDays; ++_i) {
	      week[weekArray.length ? 'push' : 'unshift'](null);
	    }
	    weekArray.push(week);
	  };
	
	  dayArray.forEach(function (day) {
	    if (week.length > 0 && day.getDay() === firstDayOfWeek) {
	      addWeek(week);
	      week = [];
	    }
	    week.push(day);
	    if (dayArray.indexOf(day) === dayArray.length - 1) {
	      addWeek(week);
	    }
	  });
	
	  return weekArray;
	}
	
	function localizedWeekday(DateTimeFormat, locale, day, firstDayOfWeek) {
	  var weekdayFormatter = new DateTimeFormat(locale, { weekday: 'narrow' });
	  var firstDayDate = getFirstDayOfWeek();
	
	  return weekdayFormatter.format(addDays(firstDayDate, day + firstDayOfWeek));
	}
	
	// Convert date to ISO 8601 (YYYY-MM-DD) date string, accounting for current timezone
	function formatIso(date) {
	  return new Date(date.toDateString() + ' 12:00:00 +0000').toISOString().substring(0, 10);
	}
	
	function isEqualDate(d1, d2) {
	  return d1 && d2 && d1.getFullYear() === d2.getFullYear() && d1.getMonth() === d2.getMonth() && d1.getDate() === d2.getDate();
	}
	
	function isBeforeDate(d1, d2) {
	  var date1 = cloneAsDate(d1);
	  var date2 = cloneAsDate(d2);
	
	  return date1.getTime() < date2.getTime();
	}
	
	function isAfterDate(d1, d2) {
	  var date1 = cloneAsDate(d1);
	  var date2 = cloneAsDate(d2);
	
	  return date1.getTime() > date2.getTime();
	}
	
	function isBetweenDates(dateToCheck, startDate, endDate) {
	  return !isBeforeDate(dateToCheck, startDate) && !isAfterDate(dateToCheck, endDate);
	}
	
	function monthDiff(d1, d2) {
	  var m = void 0;
	  m = (d1.getFullYear() - d2.getFullYear()) * 12;
	  m += d1.getMonth();
	  m -= d2.getMonth();
	  return m;
	}
	
	function yearDiff(d1, d2) {
	  return ~~(monthDiff(d1, d2) / 12);
	}

/***/ }),
/* 691 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _simpleAssign = __webpack_require__(579);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactEventListener = __webpack_require__(625);
	
	var _reactEventListener2 = _interopRequireDefault(_reactEventListener);
	
	var _keycode = __webpack_require__(589);
	
	var _keycode2 = _interopRequireDefault(_keycode);
	
	var _Calendar = __webpack_require__(692);
	
	var _Calendar2 = _interopRequireDefault(_Calendar);
	
	var _Dialog = __webpack_require__(707);
	
	var _Dialog2 = _interopRequireDefault(_Dialog);
	
	var _Popover = __webpack_require__(639);
	
	var _Popover2 = _interopRequireDefault(_Popover);
	
	var _PopoverAnimationVertical = __webpack_require__(711);
	
	var _PopoverAnimationVertical2 = _interopRequireDefault(_PopoverAnimationVertical);
	
	var _dateUtils = __webpack_require__(690);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DatePickerDialog = function (_Component) {
	  _inherits(DatePickerDialog, _Component);
	
	  function DatePickerDialog() {
	    var _Object$getPrototypeO;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, DatePickerDialog);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_Object$getPrototypeO = Object.getPrototypeOf(DatePickerDialog)).call.apply(_Object$getPrototypeO, [this].concat(args))), _this), _this.state = {
	      open: false
	    }, _this.show = function () {
	      if (_this.props.onShow && !_this.state.open) {
	        _this.props.onShow();
	      }
	
	      _this.setState({
	        open: true
	      });
	    }, _this.dismiss = function () {
	      if (_this.props.onDismiss && _this.state.open) {
	        _this.props.onDismiss();
	      }
	
	      _this.setState({
	        open: false
	      });
	    }, _this.handleTouchTapDay = function () {
	      if (_this.props.autoOk) {
	        setTimeout(_this.handleTouchTapOk, 300);
	      }
	    }, _this.handleTouchTapCancel = function () {
	      _this.dismiss();
	    }, _this.handleRequestClose = function () {
	      _this.dismiss();
	    }, _this.handleTouchTapOk = function () {
	      if (_this.props.onAccept && !_this.refs.calendar.isSelectedDateDisabled()) {
	        _this.props.onAccept(_this.refs.calendar.getSelectedDate());
	      }
	
	      _this.setState({
	        open: false
	      });
	    }, _this.handleWindowKeyUp = function (event) {
	      switch ((0, _keycode2.default)(event)) {
	        case 'enter':
	          _this.handleTouchTapOk();
	          break;
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(DatePickerDialog, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var DateTimeFormat = _props.DateTimeFormat;
	      var autoOk = _props.autoOk;
	      var cancelLabel = _props.cancelLabel;
	      var container = _props.container;
	      var containerStyle = _props.containerStyle;
	      var disableYearSelection = _props.disableYearSelection;
	      var initialDate = _props.initialDate;
	      var firstDayOfWeek = _props.firstDayOfWeek;
	      var locale = _props.locale;
	      var maxDate = _props.maxDate;
	      var minDate = _props.minDate;
	      var mode = _props.mode;
	      var okLabel = _props.okLabel;
	      var onAccept = _props.onAccept;
	      var onDismiss = _props.onDismiss;
	      var onShow = _props.onShow;
	      var shouldDisableDate = _props.shouldDisableDate;
	      var style = _props.style;
	      var wordings = _props.wordings;
	      var animation = _props.animation;
	
	      var other = _objectWithoutProperties(_props, ['DateTimeFormat', 'autoOk', 'cancelLabel', 'container', 'containerStyle', 'disableYearSelection', 'initialDate', 'firstDayOfWeek', 'locale', 'maxDate', 'minDate', 'mode', 'okLabel', 'onAccept', 'onDismiss', 'onShow', 'shouldDisableDate', 'style', 'wordings', 'animation']);
	
	      var open = this.state.open;
	
	
	      var styles = {
	        dialogContent: {
	          width: mode === 'landscape' ? 479 : 310
	        },
	        dialogBodyContent: {
	          padding: 0,
	          minHeight: mode === 'landscape' ? 330 : 434,
	          minWidth: mode === 'landscape' ? 479 : 310
	        }
	      };
	
	      var Container = container === 'inline' ? _Popover2.default : _Dialog2.default;
	
	      return _react2.default.createElement(
	        'div',
	        _extends({}, other, { ref: 'root' }),
	        _react2.default.createElement(
	          Container,
	          {
	            anchorEl: this.refs.root // For Popover
	            , animation: animation || _PopoverAnimationVertical2.default // For Popover
	            , bodyStyle: styles.dialogBodyContent,
	            contentStyle: styles.dialogContent,
	            ref: 'dialog',
	            repositionOnUpdate: true,
	            open: open,
	            onRequestClose: this.handleRequestClose,
	            style: (0, _simpleAssign2.default)(styles.dialogBodyContent, containerStyle)
	          },
	          _react2.default.createElement(_reactEventListener2.default, {
	            target: 'window',
	            onKeyUp: this.handleWindowKeyUp
	          }),
	          _react2.default.createElement(_Calendar2.default, {
	            autoOk: autoOk,
	            DateTimeFormat: DateTimeFormat,
	            cancelLabel: cancelLabel,
	            disableYearSelection: disableYearSelection,
	            firstDayOfWeek: firstDayOfWeek,
	            initialDate: initialDate,
	            locale: locale,
	            onTouchTapDay: this.handleTouchTapDay,
	            maxDate: maxDate,
	            minDate: minDate,
	            mode: mode,
	            open: open,
	            ref: 'calendar',
	            onTouchTapCancel: this.handleTouchTapCancel,
	            onTouchTapOk: this.handleTouchTapOk,
	            okLabel: okLabel,
	            shouldDisableDate: shouldDisableDate,
	            wordings: wordings
	          })
	        )
	      );
	    }
	  }]);
	
	  return DatePickerDialog;
	}(_react.Component);
	
	DatePickerDialog.propTypes = {
	  DateTimeFormat: _react.PropTypes.func,
	  animation: _react.PropTypes.func,
	  autoOk: _react.PropTypes.bool,
	  cancelLabel: _react.PropTypes.node,
	  container: _react.PropTypes.oneOf(['dialog', 'inline']),
	  containerStyle: _react.PropTypes.object,
	  disableYearSelection: _react.PropTypes.bool,
	  firstDayOfWeek: _react.PropTypes.number,
	  initialDate: _react.PropTypes.object,
	  locale: _react.PropTypes.string,
	  maxDate: _react.PropTypes.object,
	  minDate: _react.PropTypes.object,
	  mode: _react.PropTypes.oneOf(['portrait', 'landscape']),
	  okLabel: _react.PropTypes.node,
	  onAccept: _react.PropTypes.func,
	  onDismiss: _react.PropTypes.func,
	  onShow: _react.PropTypes.func,
	  open: _react.PropTypes.bool,
	  shouldDisableDate: _react.PropTypes.func,
	  style: _react.PropTypes.object,
	  wordings: _react.PropTypes.object
	};
	DatePickerDialog.defaultProps = {
	  DateTimeFormat: _dateUtils.dateTimeFormat,
	  cancelLabel: 'Cancel',
	  container: 'dialog',
	  locale: 'en-US',
	  okLabel: 'OK'
	};
	DatePickerDialog.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	exports.default = DatePickerDialog;

/***/ }),
/* 692 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactEventListener = __webpack_require__(625);
	
	var _reactEventListener2 = _interopRequireDefault(_reactEventListener);
	
	var _keycode = __webpack_require__(589);
	
	var _keycode2 = _interopRequireDefault(_keycode);
	
	var _transitions = __webpack_require__(582);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _CalendarActionButtons = __webpack_require__(693);
	
	var _CalendarActionButtons2 = _interopRequireDefault(_CalendarActionButtons);
	
	var _CalendarMonth = __webpack_require__(697);
	
	var _CalendarMonth2 = _interopRequireDefault(_CalendarMonth);
	
	var _CalendarYear = __webpack_require__(699);
	
	var _CalendarYear2 = _interopRequireDefault(_CalendarYear);
	
	var _CalendarToolbar = __webpack_require__(701);
	
	var _CalendarToolbar2 = _interopRequireDefault(_CalendarToolbar);
	
	var _DateDisplay = __webpack_require__(706);
	
	var _DateDisplay2 = _interopRequireDefault(_DateDisplay);
	
	var _SlideIn = __webpack_require__(704);
	
	var _SlideIn2 = _interopRequireDefault(_SlideIn);
	
	var _dateUtils = __webpack_require__(690);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var daysArray = [].concat(_toConsumableArray(Array(7)));
	
	var Calendar = function (_Component) {
	  _inherits(Calendar, _Component);
	
	  function Calendar() {
	    var _Object$getPrototypeO;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Calendar);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_Object$getPrototypeO = Object.getPrototypeOf(Calendar)).call.apply(_Object$getPrototypeO, [this].concat(args))), _this), _this.state = {
	      displayDate: undefined,
	      displayMonthDay: true,
	      selectedDate: undefined,
	      transitionDirection: 'left',
	      transitionEnter: true
	    }, _this.handleTouchTapDay = function (event, date) {
	      _this.setSelectedDate(date);
	      if (_this.props.onTouchTapDay) _this.props.onTouchTapDay(event, date);
	    }, _this.handleMonthChange = function (months) {
	      _this.setState({
	        transitionDirection: months >= 0 ? 'left' : 'right',
	        displayDate: (0, _dateUtils.addMonths)(_this.state.displayDate, months)
	      });
	    }, _this.handleTouchTapYear = function (event, year) {
	      var date = (0, _dateUtils.cloneDate)(_this.state.selectedDate);
	      date.setFullYear(year);
	      _this.setSelectedDate(date, event);
	    }, _this.handleTouchTapDateDisplayMonthDay = function () {
	      _this.setState({
	        displayMonthDay: true
	      });
	    }, _this.handleTouchTapDateDisplayYear = function () {
	      _this.setState({
	        displayMonthDay: false
	      });
	    }, _this.handleWindowKeyDown = function (event) {
	      if (_this.props.open) {
	        switch ((0, _keycode2.default)(event)) {
	          case 'up':
	            if (event.altKey && event.shiftKey) {
	              _this.addSelectedYears(-1);
	            } else if (event.shiftKey) {
	              _this.addSelectedMonths(-1);
	            } else {
	              _this.addSelectedDays(-7);
	            }
	            break;
	
	          case 'down':
	            if (event.altKey && event.shiftKey) {
	              _this.addSelectedYears(1);
	            } else if (event.shiftKey) {
	              _this.addSelectedMonths(1);
	            } else {
	              _this.addSelectedDays(7);
	            }
	            break;
	
	          case 'right':
	            if (event.altKey && event.shiftKey) {
	              _this.addSelectedYears(1);
	            } else if (event.shiftKey) {
	              _this.addSelectedMonths(1);
	            } else {
	              _this.addSelectedDays(1);
	            }
	            break;
	
	          case 'left':
	            if (event.altKey && event.shiftKey) {
	              _this.addSelectedYears(-1);
	            } else if (event.shiftKey) {
	              _this.addSelectedMonths(-1);
	            } else {
	              _this.addSelectedDays(-1);
	            }
	            break;
	        }
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Calendar, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.setState({
	        displayDate: (0, _dateUtils.getFirstDayOfMonth)(this.props.initialDate),
	        selectedDate: this.props.initialDate
	      });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.initialDate !== this.props.initialDate) {
	        var date = nextProps.initialDate || new Date();
	        this.setState({
	          displayDate: (0, _dateUtils.getFirstDayOfMonth)(date),
	          selectedDate: date
	        });
	      }
	    }
	  }, {
	    key: 'getSelectedDate',
	    value: function getSelectedDate() {
	      return this.state.selectedDate;
	    }
	  }, {
	    key: 'isSelectedDateDisabled',
	    value: function isSelectedDateDisabled() {
	      if (!this.state.displayMonthDay) {
	        return false;
	      }
	
	      return this.refs.calendar.isSelectedDateDisabled();
	    }
	  }, {
	    key: 'addSelectedDays',
	    value: function addSelectedDays(days) {
	      this.setSelectedDate((0, _dateUtils.addDays)(this.state.selectedDate, days));
	    }
	  }, {
	    key: 'addSelectedMonths',
	    value: function addSelectedMonths(months) {
	      this.setSelectedDate((0, _dateUtils.addMonths)(this.state.selectedDate, months));
	    }
	  }, {
	    key: 'addSelectedYears',
	    value: function addSelectedYears(years) {
	      this.setSelectedDate((0, _dateUtils.addYears)(this.state.selectedDate, years));
	    }
	  }, {
	    key: 'setDisplayDate',
	    value: function setDisplayDate(date, newSelectedDate) {
	      var newDisplayDate = (0, _dateUtils.getFirstDayOfMonth)(date);
	      var direction = newDisplayDate > this.state.displayDate ? 'left' : 'right';
	
	      if (newDisplayDate !== this.state.displayDate) {
	        this.setState({
	          displayDate: newDisplayDate,
	          transitionDirection: direction,
	          selectedDate: newSelectedDate || this.state.selectedDate
	        });
	      }
	    }
	  }, {
	    key: 'setSelectedDate',
	    value: function setSelectedDate(date) {
	      var adjustedDate = date;
	      if ((0, _dateUtils.isBeforeDate)(date, this.props.minDate)) {
	        adjustedDate = this.props.minDate;
	      } else if ((0, _dateUtils.isAfterDate)(date, this.props.maxDate)) {
	        adjustedDate = this.props.maxDate;
	      }
	
	      var newDisplayDate = (0, _dateUtils.getFirstDayOfMonth)(adjustedDate);
	      if (newDisplayDate !== this.state.displayDate) {
	        this.setDisplayDate(newDisplayDate, adjustedDate);
	      } else {
	        this.setState({
	          selectedDate: adjustedDate
	        });
	      }
	    }
	  }, {
	    key: 'getToolbarInteractions',
	    value: function getToolbarInteractions() {
	      return {
	        prevMonth: (0, _dateUtils.monthDiff)(this.state.displayDate, this.props.minDate) > 0,
	        nextMonth: (0, _dateUtils.monthDiff)(this.state.displayDate, this.props.maxDate) < 0
	      };
	    }
	  }, {
	    key: 'yearSelector',
	    value: function yearSelector() {
	      if (!this.props.disableYearSelection) return _react2.default.createElement(_CalendarYear2.default, {
	        key: 'years',
	        displayDate: this.state.displayDate,
	        onTouchTapYear: this.handleTouchTapYear,
	        selectedDate: this.state.selectedDate,
	        minDate: this.props.minDate,
	        maxDate: this.props.maxDate
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var weekCount = (0, _dateUtils.getWeekArray)(this.state.displayDate, this.props.firstDayOfWeek).length;
	      var toolbarInteractions = this.getToolbarInteractions();
	      var isLandscape = this.props.mode === 'landscape';
	      var calendarTextColor = this.context.muiTheme.datePicker.calendarTextColor;
	
	
	      var styles = {
	        root: {
	          color: calendarTextColor,
	          userSelect: 'none',
	          width: isLandscape ? 479 : 310
	        },
	        calendar: {
	          display: 'flex',
	          flexDirection: 'column'
	        },
	        calendarContainer: {
	          display: 'flex',
	          alignContent: 'space-between',
	          justifyContent: 'space-between',
	          flexDirection: 'column',
	          fontSize: 12,
	          fontWeight: 400,
	          padding: '0px 8px',
	          transition: _transitions2.default.easeOut()
	        },
	        yearContainer: {
	          display: 'flex',
	          justifyContent: 'space-between',
	          flexDirection: 'column',
	          height: 272,
	          marginTop: 10,
	          overflow: 'hidden',
	          width: 310
	        },
	        weekTitle: {
	          display: 'flex',
	          flexDirection: 'row',
	          justifyContent: 'space-between',
	          fontWeight: '500',
	          height: 20,
	          lineHeight: '15px',
	          opacity: '0.5',
	          textAlign: 'center'
	        },
	        weekTitleDay: {
	          width: 42
	        },
	        transitionSlide: {
	          height: 214
	        }
	      };
	
	      var weekTitleDayStyle = prepareStyles(styles.weekTitleDay);
	
	      var _props = this.props;
	      var cancelLabel = _props.cancelLabel;
	      var DateTimeFormat = _props.DateTimeFormat;
	      var firstDayOfWeek = _props.firstDayOfWeek;
	      var locale = _props.locale;
	      var okLabel = _props.okLabel;
	      var onTouchTapCancel = _props.onTouchTapCancel;
	      var onTouchTapOk = _props.onTouchTapOk;
	      var wordings = _props.wordings;
	
	
	      return _react2.default.createElement(
	        'div',
	        { style: prepareStyles(styles.root) },
	        _react2.default.createElement(_reactEventListener2.default, {
	          target: 'window',
	          onKeyDown: this.handleWindowKeyDown
	        }),
	        _react2.default.createElement(_DateDisplay2.default, {
	          DateTimeFormat: DateTimeFormat,
	          disableYearSelection: this.props.disableYearSelection,
	          onTouchTapMonthDay: this.handleTouchTapDateDisplayMonthDay,
	          onTouchTapYear: this.handleTouchTapDateDisplayYear,
	          locale: locale,
	          monthDaySelected: this.state.displayMonthDay,
	          mode: this.props.mode,
	          selectedDate: this.state.selectedDate,
	          weekCount: weekCount
	        }),
	        _react2.default.createElement(
	          'div',
	          { style: prepareStyles(styles.calendar) },
	          this.state.displayMonthDay && _react2.default.createElement(
	            'div',
	            { style: prepareStyles(styles.calendarContainer) },
	            _react2.default.createElement(_CalendarToolbar2.default, {
	              DateTimeFormat: DateTimeFormat,
	              locale: locale,
	              displayDate: this.state.displayDate,
	              onMonthChange: this.handleMonthChange,
	              prevMonth: toolbarInteractions.prevMonth,
	              nextMonth: toolbarInteractions.nextMonth
	            }),
	            _react2.default.createElement(
	              'div',
	              { style: prepareStyles(styles.weekTitle) },
	              daysArray.map(function (event, i) {
	                return _react2.default.createElement(
	                  'span',
	                  { key: i, style: weekTitleDayStyle },
	                  (0, _dateUtils.localizedWeekday)(DateTimeFormat, locale, i, firstDayOfWeek)
	                );
	              })
	            ),
	            _react2.default.createElement(
	              _SlideIn2.default,
	              { direction: this.state.transitionDirection, style: styles.transitionSlide },
	              _react2.default.createElement(_CalendarMonth2.default, {
	                displayDate: this.state.displayDate,
	                firstDayOfWeek: this.props.firstDayOfWeek,
	                key: this.state.displayDate.toDateString(),
	                minDate: this.props.minDate,
	                maxDate: this.props.maxDate,
	                onTouchTapDay: this.handleTouchTapDay,
	                ref: 'calendar',
	                selectedDate: this.state.selectedDate,
	                shouldDisableDate: this.props.shouldDisableDate
	              })
	            )
	          ),
	          !this.state.displayMonthDay && _react2.default.createElement(
	            'div',
	            { style: prepareStyles(styles.yearContainer) },
	            this.yearSelector()
	          ),
	          okLabel && _react2.default.createElement(_CalendarActionButtons2.default, {
	            autoOk: this.props.autoOk,
	            cancelLabel: cancelLabel,
	            okLabel: okLabel,
	            onTouchTapCancel: onTouchTapCancel,
	            onTouchTapOk: onTouchTapOk,
	            wordings: wordings
	          })
	        )
	      );
	    }
	  }]);
	
	  return Calendar;
	}(_react.Component);
	
	Calendar.propTypes = {
	  DateTimeFormat: _react.PropTypes.func.isRequired,
	  autoOk: _react.PropTypes.bool,
	  cancelLabel: _react.PropTypes.node,
	  disableYearSelection: _react.PropTypes.bool,
	  firstDayOfWeek: _react.PropTypes.number,
	  initialDate: _react.PropTypes.object,
	  locale: _react.PropTypes.string.isRequired,
	  maxDate: _react.PropTypes.object,
	  minDate: _react.PropTypes.object,
	  mode: _react.PropTypes.oneOf(['portrait', 'landscape']),
	  okLabel: _react.PropTypes.node,
	  onTouchTapCancel: _react.PropTypes.func,
	  onTouchTapDay: _react.PropTypes.func,
	  onTouchTapOk: _react.PropTypes.func,
	  open: _react.PropTypes.bool,
	  shouldDisableDate: _react.PropTypes.func,
	  wordings: _react.PropTypes.object
	};
	Calendar.defaultProps = {
	  DateTimeFormat: _dateUtils.dateTimeFormat,
	  disableYearSelection: false,
	  initialDate: new Date(),
	  locale: 'en-US',
	  minDate: (0, _dateUtils.addYears)(new Date(), -100),
	  maxDate: (0, _dateUtils.addYears)(new Date(), 100)
	};
	Calendar.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	exports.default = Calendar;

/***/ }),
/* 693 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _FlatButton = __webpack_require__(694);
	
	var _FlatButton2 = _interopRequireDefault(_FlatButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CalendarActionButton = function (_Component) {
	  _inherits(CalendarActionButton, _Component);
	
	  function CalendarActionButton() {
	    _classCallCheck(this, CalendarActionButton);
	
	    return _possibleConstructorReturn(this, Object.getPrototypeOf(CalendarActionButton).apply(this, arguments));
	  }
	
	  _createClass(CalendarActionButton, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var cancelLabel = _props.cancelLabel;
	      var okLabel = _props.okLabel;
	      var wordings = _props.wordings;
	
	
	      var styles = {
	        root: {
	          display: 'flex',
	          flexDirection: 'row',
	          justifyContent: 'flex-end',
	          margin: 0,
	          maxHeight: 48,
	          padding: 0
	        },
	        flatButtons: {
	          fontsize: 14,
	          margin: '4px 8px 8px 0px',
	          maxHeight: 36,
	          minWidth: 64,
	          padding: 0
	        }
	      };
	
	      return _react2.default.createElement(
	        'div',
	        { style: styles.root },
	        _react2.default.createElement(_FlatButton2.default, {
	          label: wordings ? wordings.cancel : cancelLabel,
	          onTouchTap: this.props.onTouchTapCancel,
	          primary: true,
	          style: styles.flatButtons
	        }),
	        !this.props.autoOk && _react2.default.createElement(_FlatButton2.default, {
	          disabled: this.refs.calendar !== undefined && this.refs.calendar.isSelectedDateDisabled(),
	          label: wordings ? wordings.ok : okLabel,
	          onTouchTap: this.props.onTouchTapOk,
	          primary: true,
	          style: styles.flatButtons
	        })
	      );
	    }
	  }]);
	
	  return CalendarActionButton;
	}(_react.Component);
	
	CalendarActionButton.propTypes = {
	  autoOk: _react.PropTypes.bool,
	  cancelLabel: _react.PropTypes.node,
	  okLabel: _react.PropTypes.node,
	  onTouchTapCancel: _react.PropTypes.func,
	  onTouchTapOk: _react.PropTypes.func,
	  wordings: _react.PropTypes.object
	};
	exports.default = CalendarActionButton;

/***/ }),
/* 694 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _FlatButton = __webpack_require__(695);
	
	var _FlatButton2 = _interopRequireDefault(_FlatButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _FlatButton2.default;

/***/ }),
/* 695 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _simpleAssign = __webpack_require__(579);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _transitions = __webpack_require__(582);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _childUtils = __webpack_require__(585);
	
	var _colorManipulator = __webpack_require__(623);
	
	var _EnhancedButton = __webpack_require__(584);
	
	var _EnhancedButton2 = _interopRequireDefault(_EnhancedButton);
	
	var _FlatButtonLabel = __webpack_require__(696);
	
	var _FlatButtonLabel2 = _interopRequireDefault(_FlatButtonLabel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function validateLabel(props, propName, componentName) {
	  if (false) {
	    if (!props.children && props.label !== 0 && !props.label && !props.icon) {
	      return new Error('Required prop label or children or icon was not specified in ' + componentName + '.');
	    }
	  }
	}
	
	var FlatButton = function (_Component) {
	  _inherits(FlatButton, _Component);
	
	  function FlatButton() {
	    var _Object$getPrototypeO;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, FlatButton);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_Object$getPrototypeO = Object.getPrototypeOf(FlatButton)).call.apply(_Object$getPrototypeO, [this].concat(args))), _this), _this.state = {
	      hovered: false,
	      isKeyboardFocused: false,
	      touch: false
	    }, _this.handleKeyboardFocus = function (event, isKeyboardFocused) {
	      _this.setState({ isKeyboardFocused: isKeyboardFocused });
	      _this.props.onKeyboardFocus(event, isKeyboardFocused);
	    }, _this.handleMouseEnter = function (event) {
	      // Cancel hover styles for touch devices
	      if (!_this.state.touch) _this.setState({ hovered: true });
	      _this.props.onMouseEnter(event);
	    }, _this.handleMouseLeave = function (event) {
	      _this.setState({ hovered: false });
	      _this.props.onMouseLeave(event);
	    }, _this.handleTouchStart = function (event) {
	      _this.setState({ touch: true });
	      _this.props.onTouchStart(event);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(FlatButton, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.disabled && this.state.hovered) {
	        this.setState({
	          hovered: false
	        });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var children = _props.children;
	      var disabled = _props.disabled;
	      var hoverColor = _props.hoverColor;
	      var backgroundColor = _props.backgroundColor;
	      var icon = _props.icon;
	      var label = _props.label;
	      var labelStyle = _props.labelStyle;
	      var labelPosition = _props.labelPosition;
	      var primary = _props.primary;
	      var rippleColor = _props.rippleColor;
	      var secondary = _props.secondary;
	      var style = _props.style;
	
	      var other = _objectWithoutProperties(_props, ['children', 'disabled', 'hoverColor', 'backgroundColor', 'icon', 'label', 'labelStyle', 'labelPosition', 'primary', 'rippleColor', 'secondary', 'style']);
	
	      var _context$muiTheme = this.context.muiTheme;
	      var _context$muiTheme$but = _context$muiTheme.button;
	      var buttonHeight = _context$muiTheme$but.height;
	      var buttonMinWidth = _context$muiTheme$but.minWidth;
	      var buttonTextTransform = _context$muiTheme$but.textTransform;
	      var _context$muiTheme$fla = _context$muiTheme.flatButton;
	      var buttonFilterColor = _context$muiTheme$fla.buttonFilterColor;
	      var buttonColor = _context$muiTheme$fla.color;
	      var disabledTextColor = _context$muiTheme$fla.disabledTextColor;
	      var fontSize = _context$muiTheme$fla.fontSize;
	      var fontWeight = _context$muiTheme$fla.fontWeight;
	      var primaryTextColor = _context$muiTheme$fla.primaryTextColor;
	      var secondaryTextColor = _context$muiTheme$fla.secondaryTextColor;
	      var textColor = _context$muiTheme$fla.textColor;
	      var _context$muiTheme$fla2 = _context$muiTheme$fla.textTransform;
	      var textTransform = _context$muiTheme$fla2 === undefined ? buttonTextTransform || 'uppercase' : _context$muiTheme$fla2;
	
	      var defaultTextColor = disabled ? disabledTextColor : primary ? primaryTextColor : secondary ? secondaryTextColor : textColor;
	
	      var defaultHoverColor = (0, _colorManipulator.fade)(buttonFilterColor, 0.2);
	      var defaultRippleColor = buttonFilterColor;
	      var buttonHoverColor = hoverColor || defaultHoverColor;
	      var buttonRippleColor = rippleColor || defaultRippleColor;
	      var buttonBackgroundColor = backgroundColor || buttonColor;
	      var hovered = (this.state.hovered || this.state.isKeyboardFocused) && !disabled;
	
	      var mergedRootStyles = (0, _simpleAssign2.default)({}, {
	        height: buttonHeight,
	        lineHeight: buttonHeight + 'px',
	        minWidth: buttonMinWidth,
	        color: defaultTextColor,
	        transition: _transitions2.default.easeOut(),
	        borderRadius: 2,
	        userSelect: 'none',
	        position: 'relative',
	        overflow: 'hidden',
	        backgroundColor: hovered ? buttonHoverColor : buttonBackgroundColor,
	        padding: 0,
	        margin: 0,
	        textAlign: 'center'
	      }, style);
	
	      var iconCloned = void 0;
	      var labelStyleIcon = {};
	
	      if (icon) {
	        var iconStyles = (0, _simpleAssign2.default)({
	          verticalAlign: 'middle',
	          marginLeft: label && labelPosition !== 'before' ? 12 : 0,
	          marginRight: label && labelPosition === 'before' ? 12 : 0
	        }, icon.props.style);
	        iconCloned = _react2.default.cloneElement(icon, {
	          color: icon.props.color || mergedRootStyles.color,
	          style: iconStyles
	        });
	
	        if (labelPosition === 'before') {
	          labelStyleIcon.paddingRight = 8;
	        } else {
	          labelStyleIcon.paddingLeft = 8;
	        }
	      }
	
	      var mergedLabelStyles = (0, _simpleAssign2.default)({
	        letterSpacing: 0,
	        textTransform: textTransform,
	        fontWeight: fontWeight,
	        fontSize: fontSize
	      }, labelStyleIcon, labelStyle);
	
	      var labelElement = label ? _react2.default.createElement(_FlatButtonLabel2.default, { label: label, style: mergedLabelStyles }) : undefined;
	
	      // Place label before or after children.
	      var childrenFragment = labelPosition === 'before' ? {
	        labelElement: labelElement,
	        iconCloned: iconCloned,
	        children: children
	      } : {
	        children: children,
	        iconCloned: iconCloned,
	        labelElement: labelElement
	      };
	
	      var enhancedButtonChildren = (0, _childUtils.createChildFragment)(childrenFragment);
	
	      return _react2.default.createElement(
	        _EnhancedButton2.default,
	        _extends({}, other, {
	          disabled: disabled,
	          focusRippleColor: buttonRippleColor,
	          focusRippleOpacity: 0.3,
	          onKeyboardFocus: this.handleKeyboardFocus,
	          onMouseLeave: this.handleMouseLeave,
	          onMouseEnter: this.handleMouseEnter,
	          onTouchStart: this.handleTouchStart,
	          style: mergedRootStyles,
	          touchRippleColor: buttonRippleColor,
	          touchRippleOpacity: 0.3
	        }),
	        enhancedButtonChildren
	      );
	    }
	  }]);
	
	  return FlatButton;
	}(_react.Component);
	
	FlatButton.muiName = 'FlatButton';
	FlatButton.propTypes = {
	  /**
	   * Color of button when mouse is not hovering over it.
	   */
	  backgroundColor: _react.PropTypes.string,
	  /**
	   * This is what will be displayed inside the button.
	   * If a label is specified, the text within the label prop will
	   * be displayed. Otherwise, the component will expect children
	   * which will then be displayed. (In our example,
	   * we are nesting an `<input type="file" />` and a `span`
	   * that acts as our label to be displayed.) This only
	   * applies to flat and raised buttons.
	   */
	  children: _react.PropTypes.node,
	  /**
	   * Disables the button if set to true.
	   */
	  disabled: _react.PropTypes.bool,
	  /**
	   * Color of button when mouse hovers over.
	   */
	  hoverColor: _react.PropTypes.string,
	  /**
	   * The URL to link to when the button is clicked.
	   */
	  href: _react.PropTypes.string,
	  /**
	   * Use this property to display an icon.
	   */
	  icon: _react.PropTypes.node,
	  /**
	   * Label for the button.
	   */
	  label: validateLabel,
	  /**
	   * Place label before or after the passed children.
	   */
	  labelPosition: _react.PropTypes.oneOf(['before', 'after']),
	  /**
	   * Override the inline-styles of the button's label element.
	   */
	  labelStyle: _react.PropTypes.object,
	  /**
	   * Callback function fired when the element is focused or blurred by the keyboard.
	   *
	   * @param {object} event `focus` or `blur` event targeting the element.
	   * @param {boolean} isKeyboardFocused Indicates whether the element is focused.
	   */
	  onKeyboardFocus: _react.PropTypes.func,
	  /** @ignore */
	  onMouseEnter: _react.PropTypes.func,
	  /** @ignore */
	  onMouseLeave: _react.PropTypes.func,
	  /** @ignore */
	  onTouchStart: _react.PropTypes.func,
	  /**
	   * If true, colors button according to
	   * primaryTextColor from the Theme.
	   */
	  primary: _react.PropTypes.bool,
	  /**
	   * Color for the ripple after button is clicked.
	   */
	  rippleColor: _react.PropTypes.string,
	  /**
	   * If true, colors button according to secondaryTextColor from the theme.
	   * The primary prop has precendent if set to true.
	   */
	  secondary: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object
	};
	FlatButton.defaultProps = {
	  disabled: false,
	  labelStyle: {},
	  labelPosition: 'after',
	  onKeyboardFocus: function onKeyboardFocus() {},
	  onMouseEnter: function onMouseEnter() {},
	  onMouseLeave: function onMouseLeave() {},
	  onTouchStart: function onTouchStart() {},
	  primary: false,
	  secondary: false
	};
	FlatButton.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	exports.default = FlatButton;

/***/ }),
/* 696 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _simpleAssign = __webpack_require__(579);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function getStyles(props, context) {
	  var baseTheme = context.muiTheme.baseTheme;
	
	
	  return {
	    root: {
	      position: 'relative',
	      paddingLeft: baseTheme.spacing.desktopGutterLess,
	      paddingRight: baseTheme.spacing.desktopGutterLess,
	      verticalAlign: 'middle'
	    }
	  };
	}
	
	var FlatButtonLabel = function (_Component) {
	  _inherits(FlatButtonLabel, _Component);
	
	  function FlatButtonLabel() {
	    _classCallCheck(this, FlatButtonLabel);
	
	    return _possibleConstructorReturn(this, Object.getPrototypeOf(FlatButtonLabel).apply(this, arguments));
	  }
	
	  _createClass(FlatButtonLabel, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var label = _props.label;
	      var style = _props.style;
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      return _react2.default.createElement(
	        'span',
	        { style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) },
	        label
	      );
	    }
	  }]);
	
	  return FlatButtonLabel;
	}(_react.Component);
	
	FlatButtonLabel.propTypes = {
	  label: _react.PropTypes.node,
	  style: _react.PropTypes.object
	};
	FlatButtonLabel.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	exports.default = FlatButtonLabel;

/***/ }),
/* 697 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _dateUtils = __webpack_require__(690);
	
	var _DayButton = __webpack_require__(698);
	
	var _DayButton2 = _interopRequireDefault(_DayButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CalendarMonth = function (_Component) {
	  _inherits(CalendarMonth, _Component);
	
	  function CalendarMonth() {
	    var _Object$getPrototypeO;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, CalendarMonth);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_Object$getPrototypeO = Object.getPrototypeOf(CalendarMonth)).call.apply(_Object$getPrototypeO, [this].concat(args))), _this), _this.handleTouchTapDay = function (event, date) {
	      if (_this.props.onTouchTapDay) _this.props.onTouchTapDay(event, date);
	    }, _this.styles = {
	      root: {
	        display: 'flex',
	        flexDirection: 'column',
	        justifyContent: 'flex-start',
	        fontWeight: 400,
	        height: 228,
	        lineHeight: 2,
	        position: 'relative',
	        textAlign: 'center',
	        MozPaddingStart: 0
	      },
	      week: {
	        display: 'flex',
	        flexDirection: 'row',
	        justifyContent: 'space-around',
	        height: 34,
	        marginBottom: 2
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(CalendarMonth, [{
	    key: 'isSelectedDateDisabled',
	    value: function isSelectedDateDisabled() {
	      return this.selectedDateDisabled;
	    }
	  }, {
	    key: 'shouldDisableDate',
	    value: function shouldDisableDate(day) {
	      if (day === null) return false;
	      var disabled = !(0, _dateUtils.isBetweenDates)(day, this.props.minDate, this.props.maxDate);
	      if (!disabled && this.props.shouldDisableDate) disabled = this.props.shouldDisableDate(day);
	
	      return disabled;
	    }
	  }, {
	    key: 'getWeekElements',
	    value: function getWeekElements() {
	      var _this2 = this;
	
	      var weekArray = (0, _dateUtils.getWeekArray)(this.props.displayDate, this.props.firstDayOfWeek);
	
	      return weekArray.map(function (week, i) {
	        return _react2.default.createElement(
	          'div',
	          { key: i, style: _this2.styles.week },
	          _this2.getDayElements(week, i)
	        );
	      }, this);
	    }
	  }, {
	    key: 'getDayElements',
	    value: function getDayElements(week, i) {
	      var _this3 = this;
	
	      return week.map(function (day, j) {
	        var isSameDate = (0, _dateUtils.isEqualDate)(_this3.props.selectedDate, day);
	        var disabled = _this3.shouldDisableDate(day);
	        var selected = !disabled && isSameDate;
	
	        if (isSameDate) {
	          _this3.selectedDateDisabled = disabled;
	        }
	
	        return _react2.default.createElement(_DayButton2.default, {
	          date: day,
	          disabled: disabled,
	          key: 'db' + (i + j),
	          onTouchTap: _this3.handleTouchTapDay,
	          selected: selected
	        });
	      }, this);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { style: this.styles.root },
	        this.getWeekElements()
	      );
	    }
	  }]);
	
	  return CalendarMonth;
	}(_react.Component);
	
	CalendarMonth.propTypes = {
	  autoOk: _react.PropTypes.bool,
	  displayDate: _react.PropTypes.object.isRequired,
	  firstDayOfWeek: _react.PropTypes.number,
	  maxDate: _react.PropTypes.object,
	  minDate: _react.PropTypes.object,
	  onTouchTapDay: _react.PropTypes.func,
	  selectedDate: _react.PropTypes.object.isRequired,
	  shouldDisableDate: _react.PropTypes.func
	};
	exports.default = CalendarMonth;

/***/ }),
/* 698 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _transitions = __webpack_require__(582);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _dateUtils = __webpack_require__(690);
	
	var _EnhancedButton = __webpack_require__(584);
	
	var _EnhancedButton2 = _interopRequireDefault(_EnhancedButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function getStyles(props, context, state) {
	  var date = props.date;
	  var disabled = props.disabled;
	  var selected = props.selected;
	  var hover = state.hover;
	  var _context$muiTheme = context.muiTheme;
	  var baseTheme = _context$muiTheme.baseTheme;
	  var datePicker = _context$muiTheme.datePicker;
	
	
	  var labelColor = baseTheme.palette.textColor;
	  var buttonStateOpacity = 0;
	  var buttonStateTransform = 'scale(0)';
	
	  if (hover || selected) {
	    labelColor = datePicker.selectTextColor;
	    buttonStateOpacity = selected ? 1 : 0.6;
	    buttonStateTransform = 'scale(1)';
	  } else if ((0, _dateUtils.isEqualDate)(date, new Date())) {
	    labelColor = datePicker.color;
	  }
	
	  return {
	    root: {
	      boxSizing: 'border-box',
	      fontWeight: '400',
	      opacity: disabled && '0.6',
	      padding: '4px 0px',
	      position: 'relative',
	      WebkitTapHighlightColor: 'rgba(0,0,0,0)', // Remove mobile color flashing (deprecated)
	      width: 42
	    },
	    label: {
	      color: labelColor,
	      fontWeight: '400',
	      position: 'relative'
	    },
	    buttonState: {
	      backgroundColor: datePicker.selectColor,
	      borderRadius: '50%',
	      height: 34,
	      left: 4,
	      opacity: buttonStateOpacity,
	      position: 'absolute',
	      top: 0,
	      transform: buttonStateTransform,
	      transition: _transitions2.default.easeOut(),
	      width: 34
	    }
	  };
	}
	
	var DayButton = function (_Component) {
	  _inherits(DayButton, _Component);
	
	  function DayButton() {
	    var _Object$getPrototypeO;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, DayButton);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_Object$getPrototypeO = Object.getPrototypeOf(DayButton)).call.apply(_Object$getPrototypeO, [this].concat(args))), _this), _this.state = {
	      hover: false
	    }, _this.handleMouseEnter = function () {
	      if (!_this.props.disabled) _this.setState({ hover: true });
	    }, _this.handleMouseLeave = function () {
	      if (!_this.props.disabled) _this.setState({ hover: false });
	    }, _this.handleTouchTap = function (event) {
	      if (!_this.props.disabled && _this.props.onTouchTap) _this.props.onTouchTap(event, _this.props.date);
	    }, _this.handleKeyboardFocus = function (event, keyboardFocused) {
	      if (!_this.props.disabled && _this.props.onKeyboardFocus) {
	        _this.props.onKeyboardFocus(event, keyboardFocused, _this.props.date);
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(DayButton, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var date = _props.date;
	      var onTouchTap = _props.onTouchTap;
	      var selected = _props.selected;
	
	      var other = _objectWithoutProperties(_props, ['date', 'onTouchTap', 'selected']);
	
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context, this.state);
	
	      return this.props.date ? _react2.default.createElement(
	        _EnhancedButton2.default,
	        _extends({}, other, {
	          disabled: this.props.disabled,
	          disableFocusRipple: true,
	          disableTouchRipple: true,
	          onKeyboardFocus: this.handleKeyboardFocus,
	          onMouseEnter: this.handleMouseEnter,
	          onMouseLeave: this.handleMouseLeave,
	          onTouchTap: this.handleTouchTap,
	          style: styles.root
	        }),
	        _react2.default.createElement('div', { style: prepareStyles(styles.buttonState) }),
	        _react2.default.createElement(
	          'span',
	          { style: prepareStyles(styles.label) },
	          this.props.date.getDate()
	        )
	      ) : _react2.default.createElement('span', { style: prepareStyles(styles.root) });
	    }
	  }]);
	
	  return DayButton;
	}(_react.Component);
	
	DayButton.propTypes = {
	  date: _react.PropTypes.object,
	  disabled: _react.PropTypes.bool,
	  onKeyboardFocus: _react.PropTypes.func,
	  onTouchTap: _react.PropTypes.func,
	  selected: _react.PropTypes.bool
	};
	DayButton.defaultProps = {
	  selected: false,
	  disabled: false
	};
	DayButton.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	exports.default = DayButton;

/***/ }),
/* 699 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(332);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _YearButton = __webpack_require__(700);
	
	var _YearButton2 = _interopRequireDefault(_YearButton);
	
	var _dateUtils = __webpack_require__(690);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CalendarYear = function (_Component) {
	  _inherits(CalendarYear, _Component);
	
	  function CalendarYear() {
	    var _Object$getPrototypeO;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, CalendarYear);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_Object$getPrototypeO = Object.getPrototypeOf(CalendarYear)).call.apply(_Object$getPrototypeO, [this].concat(args))), _this), _this.handleTouchTapYear = function (event, year) {
	      if (_this.props.onTouchTapYear) _this.props.onTouchTapYear(event, year);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(CalendarYear, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.scrollToSelectedYear();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this.scrollToSelectedYear();
	    }
	  }, {
	    key: 'getYears',
	    value: function getYears() {
	      var minYear = this.props.minDate.getFullYear();
	      var maxYear = this.props.maxDate.getFullYear();
	
	      var years = [];
	      var dateCheck = (0, _dateUtils.cloneDate)(this.props.selectedDate);
	      for (var year = minYear; year <= maxYear; year++) {
	        dateCheck.setFullYear(year);
	        var selected = this.props.selectedDate.getFullYear() === year;
	        var selectedProps = {};
	        if (selected) {
	          selectedProps = { ref: 'selectedYearButton' };
	        }
	
	        var yearButton = _react2.default.createElement(_YearButton2.default, _extends({
	          key: 'yb' + year,
	          onTouchTap: this.handleTouchTapYear,
	          selected: selected,
	          year: year
	        }, selectedProps));
	
	        years.push(yearButton);
	      }
	
	      return years;
	    }
	  }, {
	    key: 'scrollToSelectedYear',
	    value: function scrollToSelectedYear() {
	      if (this.refs.selectedYearButton === undefined) return;
	
	      var container = _reactDom2.default.findDOMNode(this);
	      var yearButtonNode = _reactDom2.default.findDOMNode(this.refs.selectedYearButton);
	
	      var containerHeight = container.clientHeight;
	      var yearButtonNodeHeight = yearButtonNode.clientHeight || 32;
	
	      var scrollYOffset = yearButtonNode.offsetTop + yearButtonNodeHeight / 2 - containerHeight / 2;
	      container.scrollTop = scrollYOffset;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var years = this.getYears();
	      var backgroundColor = this.context.muiTheme.datePicker.calendarYearBackgroundColor;
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = {
	        root: {
	          backgroundColor: backgroundColor,
	          height: 'inherit',
	          lineHeight: '35px',
	          overflowX: 'hidden',
	          overflowY: 'scroll',
	          position: 'relative'
	        },
	        child: {
	          display: 'flex',
	          flexDirection: 'column',
	          justifyContent: 'center',
	          minHeight: '100%'
	        }
	      };
	
	      return _react2.default.createElement(
	        'div',
	        { style: prepareStyles(styles.root) },
	        _react2.default.createElement(
	          'div',
	          { style: prepareStyles(styles.child) },
	          years
	        )
	      );
	    }
	  }]);
	
	  return CalendarYear;
	}(_react.Component);
	
	CalendarYear.propTypes = {
	  displayDate: _react.PropTypes.object.isRequired,
	  maxDate: _react.PropTypes.object,
	  minDate: _react.PropTypes.object,
	  onTouchTapYear: _react.PropTypes.func,
	  selectedDate: _react.PropTypes.object.isRequired,
	  wordings: _react.PropTypes.object
	};
	CalendarYear.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	exports.default = CalendarYear;

/***/ }),
/* 700 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _EnhancedButton = __webpack_require__(584);
	
	var _EnhancedButton2 = _interopRequireDefault(_EnhancedButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function getStyles(props, context, state) {
	  var selected = props.selected;
	  var year = props.year;
	  var _context$muiTheme = context.muiTheme;
	  var baseTheme = _context$muiTheme.baseTheme;
	  var datePicker = _context$muiTheme.datePicker;
	  var hover = state.hover;
	
	
	  return {
	    root: {
	      boxSizing: 'border-box',
	      color: year === new Date().getFullYear() && datePicker.color,
	      display: 'block',
	      fontSize: 14,
	      margin: '0 auto',
	      position: 'relative',
	      textAlign: 'center',
	      lineHeight: 'inherit',
	      WebkitTapHighlightColor: 'rgba(0,0,0,0)' },
	    label: {
	      alignSelf: 'center',
	      color: hover || selected ? datePicker.color : baseTheme.palette.textColor,
	      fontSize: selected ? 26 : 17,
	      fontWeight: hover ? 450 : selected ? 500 : 400,
	      position: 'relative',
	      top: -1
	    }
	  };
	}
	
	var YearButton = function (_Component) {
	  _inherits(YearButton, _Component);
	
	  function YearButton() {
	    var _Object$getPrototypeO;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, YearButton);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_Object$getPrototypeO = Object.getPrototypeOf(YearButton)).call.apply(_Object$getPrototypeO, [this].concat(args))), _this), _this.state = {
	      hover: false
	    }, _this.handleMouseEnter = function () {
	      _this.setState({ hover: true });
	    }, _this.handleMouseLeave = function () {
	      _this.setState({ hover: false });
	    }, _this.handleTouchTap = function (event) {
	      if (_this.props.onTouchTap) _this.props.onTouchTap(event, _this.props.year);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(YearButton, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var className = _props.className;
	      var year = _props.year;
	      var onTouchTap = _props.onTouchTap;
	      var selected = _props.selected;
	
	      var other = _objectWithoutProperties(_props, ['className', 'year', 'onTouchTap', 'selected']);
	
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context, this.state);
	
	      return _react2.default.createElement(
	        _EnhancedButton2.default,
	        _extends({}, other, {
	          disableFocusRipple: true,
	          disableTouchRipple: true,
	          onMouseEnter: this.handleMouseEnter,
	          onMouseLeave: this.handleMouseLeave,
	          onTouchTap: this.handleTouchTap,
	          style: styles.root
	        }),
	        _react2.default.createElement(
	          'span',
	          { style: prepareStyles(styles.label) },
	          year
	        )
	      );
	    }
	  }]);
	
	  return YearButton;
	}(_react.Component);
	
	YearButton.propTypes = {
	  /**
	   * The css class name of the root element.
	   */
	  className: _react.PropTypes.string,
	  onTouchTap: _react.PropTypes.func,
	  selected: _react.PropTypes.bool,
	  year: _react.PropTypes.number
	};
	YearButton.defaultProps = {
	  selected: false
	};
	YearButton.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	exports.default = YearButton;

/***/ }),
/* 701 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _IconButton = __webpack_require__(580);
	
	var _IconButton2 = _interopRequireDefault(_IconButton);
	
	var _chevronLeft = __webpack_require__(702);
	
	var _chevronLeft2 = _interopRequireDefault(_chevronLeft);
	
	var _chevronRight = __webpack_require__(703);
	
	var _chevronRight2 = _interopRequireDefault(_chevronRight);
	
	var _SlideIn = __webpack_require__(704);
	
	var _SlideIn2 = _interopRequireDefault(_SlideIn);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var styles = {
	  root: {
	    display: 'flex',
	    justifyContent: 'space-between',
	    backgroundColor: 'inherit',
	    height: 48
	  },
	  titleDiv: {
	    fontSize: 14,
	    fontWeight: '500',
	    textAlign: 'center',
	    width: '100%'
	  },
	  titleText: {
	    height: 'inherit',
	    paddingTop: 12
	  }
	};
	
	var CalendarToolbar = function (_Component) {
	  _inherits(CalendarToolbar, _Component);
	
	  function CalendarToolbar() {
	    var _Object$getPrototypeO;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, CalendarToolbar);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_Object$getPrototypeO = Object.getPrototypeOf(CalendarToolbar)).call.apply(_Object$getPrototypeO, [this].concat(args))), _this), _this.state = {
	      transitionDirection: 'up'
	    }, _this.handleTouchTapPrevMonth = function () {
	      if (_this.props.onMonthChange && _this.props.prevMonth) _this.props.onMonthChange(-1);
	    }, _this.handleTouchTapNextMonth = function () {
	      if (_this.props.onMonthChange && _this.props.nextMonth) _this.props.onMonthChange(1);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(CalendarToolbar, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.displayDate !== this.props.displayDate) {
	        var direction = nextProps.displayDate > this.props.displayDate ? 'left' : 'right';
	        this.setState({
	          transitionDirection: direction
	        });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var DateTimeFormat = _props.DateTimeFormat;
	      var locale = _props.locale;
	      var displayDate = _props.displayDate;
	
	
	      var dateTimeFormatted = new DateTimeFormat(locale, {
	        month: 'long',
	        year: 'numeric'
	      }).format(displayDate);
	
	      var nextButtonIcon = this.context.muiTheme.isRtl ? _react2.default.createElement(_chevronLeft2.default, null) : _react2.default.createElement(_chevronRight2.default, null);
	      var prevButtonIcon = this.context.muiTheme.isRtl ? _react2.default.createElement(_chevronRight2.default, null) : _react2.default.createElement(_chevronLeft2.default, null);
	
	      return _react2.default.createElement(
	        'div',
	        { style: styles.root },
	        _react2.default.createElement(
	          _IconButton2.default,
	          {
	            disabled: !this.props.prevMonth,
	            onTouchTap: this.handleTouchTapPrevMonth
	          },
	          prevButtonIcon
	        ),
	        _react2.default.createElement(
	          _SlideIn2.default,
	          {
	            direction: this.state.transitionDirection,
	            style: styles.titleDiv
	          },
	          _react2.default.createElement(
	            'div',
	            { key: dateTimeFormatted, style: styles.titleText },
	            dateTimeFormatted
	          )
	        ),
	        _react2.default.createElement(
	          _IconButton2.default,
	          {
	            disabled: !this.props.nextMonth,
	            onTouchTap: this.handleTouchTapNextMonth
	          },
	          nextButtonIcon
	        )
	      );
	    }
	  }]);
	
	  return CalendarToolbar;
	}(_react.Component);
	
	CalendarToolbar.propTypes = {
	  DateTimeFormat: _react.PropTypes.func.isRequired,
	  displayDate: _react.PropTypes.object.isRequired,
	  locale: _react.PropTypes.string.isRequired,
	  nextMonth: _react.PropTypes.bool,
	  onMonthChange: _react.PropTypes.func,
	  prevMonth: _react.PropTypes.bool
	};
	CalendarToolbar.defaultProps = {
	  nextMonth: true,
	  prevMonth: true
	};
	CalendarToolbar.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	exports.default = CalendarToolbar;

/***/ }),
/* 702 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(608);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(615);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NavigationChevronLeft = function NavigationChevronLeft(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z' })
	  );
	};
	NavigationChevronLeft = (0, _pure2.default)(NavigationChevronLeft);
	NavigationChevronLeft.displayName = 'NavigationChevronLeft';
	NavigationChevronLeft.muiName = 'SvgIcon';
	
	exports.default = NavigationChevronLeft;

/***/ }),
/* 703 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(608);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(615);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NavigationChevronRight = function NavigationChevronRight(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z' })
	  );
	};
	NavigationChevronRight = (0, _pure2.default)(NavigationChevronRight);
	NavigationChevronRight.displayName = 'NavigationChevronRight';
	NavigationChevronRight.muiName = 'SvgIcon';
	
	exports.default = NavigationChevronRight;

/***/ }),
/* 704 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _simpleAssign = __webpack_require__(579);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactAddonsTransitionGroup = __webpack_require__(595);
	
	var _reactAddonsTransitionGroup2 = _interopRequireDefault(_reactAddonsTransitionGroup);
	
	var _SlideInChild = __webpack_require__(705);
	
	var _SlideInChild2 = _interopRequireDefault(_SlideInChild);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SlideIn = function (_Component) {
	  _inherits(SlideIn, _Component);
	
	  function SlideIn() {
	    var _Object$getPrototypeO;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, SlideIn);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_Object$getPrototypeO = Object.getPrototypeOf(SlideIn)).call.apply(_Object$getPrototypeO, [this].concat(args))), _this), _this.getLeaveDirection = function () {
	      return _this.props.direction;
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(SlideIn, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props;
	      var enterDelay = _props.enterDelay;
	      var children = _props.children;
	      var childStyle = _props.childStyle;
	      var direction = _props.direction;
	      var style = _props.style;
	
	      var other = _objectWithoutProperties(_props, ['enterDelay', 'children', 'childStyle', 'direction', 'style']);
	
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	
	      var mergedRootStyles = (0, _simpleAssign2.default)({}, {
	        position: 'relative',
	        overflow: 'hidden',
	        height: '100%'
	      }, style);
	
	      var newChildren = _react2.default.Children.map(children, function (child) {
	        return _react2.default.createElement(
	          _SlideInChild2.default,
	          {
	            key: child.key,
	            direction: direction,
	            enterDelay: enterDelay,
	            getLeaveDirection: _this2.getLeaveDirection,
	            style: childStyle
	          },
	          child
	        );
	      }, this);
	
	      return _react2.default.createElement(
	        _reactAddonsTransitionGroup2.default,
	        _extends({}, other, {
	          style: prepareStyles(mergedRootStyles),
	          component: 'div'
	        }),
	        newChildren
	      );
	    }
	  }]);
	
	  return SlideIn;
	}(_react.Component);
	
	SlideIn.propTypes = {
	  childStyle: _react.PropTypes.object,
	  children: _react.PropTypes.node,
	  direction: _react.PropTypes.oneOf(['left', 'right', 'up', 'down']),
	  enterDelay: _react.PropTypes.number,
	  style: _react.PropTypes.object
	};
	SlideIn.defaultProps = {
	  enterDelay: 0,
	  direction: 'left'
	};
	SlideIn.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	exports.default = SlideIn;

/***/ }),
/* 705 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _simpleAssign = __webpack_require__(579);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(332);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _autoPrefix = __webpack_require__(593);
	
	var _autoPrefix2 = _interopRequireDefault(_autoPrefix);
	
	var _transitions = __webpack_require__(582);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SlideInChild = function (_Component) {
	  _inherits(SlideInChild, _Component);
	
	  function SlideInChild() {
	    _classCallCheck(this, SlideInChild);
	
	    return _possibleConstructorReturn(this, Object.getPrototypeOf(SlideInChild).apply(this, arguments));
	  }
	
	  _createClass(SlideInChild, [{
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      clearTimeout(this.enterTimer);
	      clearTimeout(this.leaveTimer);
	    }
	  }, {
	    key: 'componentWillEnter',
	    value: function componentWillEnter(callback) {
	      var style = _reactDom2.default.findDOMNode(this).style;
	      var x = this.props.direction === 'left' ? '100%' : this.props.direction === 'right' ? '-100%' : '0';
	      var y = this.props.direction === 'up' ? '100%' : this.props.direction === 'down' ? '-100%' : '0';
	
	      style.opacity = '0';
	      _autoPrefix2.default.set(style, 'transform', 'translate(' + x + ', ' + y + ')');
	
	      this.enterTimer = setTimeout(callback, this.props.enterDelay);
	    }
	  }, {
	    key: 'componentDidEnter',
	    value: function componentDidEnter() {
	      var style = _reactDom2.default.findDOMNode(this).style;
	      style.opacity = '1';
	      _autoPrefix2.default.set(style, 'transform', 'translate(0,0)');
	    }
	  }, {
	    key: 'componentWillLeave',
	    value: function componentWillLeave(callback) {
	      var style = _reactDom2.default.findDOMNode(this).style;
	      var direction = this.props.getLeaveDirection();
	      var x = direction === 'left' ? '-100%' : direction === 'right' ? '100%' : '0';
	      var y = direction === 'up' ? '-100%' : direction === 'down' ? '100%' : '0';
	
	      style.opacity = '0';
	      _autoPrefix2.default.set(style, 'transform', 'translate(' + x + ', ' + y + ')');
	
	      this.leaveTimer = setTimeout(callback, 450);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var children = _props.children;
	      var enterDelay = _props.enterDelay;
	      var getLeaveDirection = _props.getLeaveDirection;
	      var style = _props.style;
	
	      var other = _objectWithoutProperties(_props, ['children', 'enterDelay', 'getLeaveDirection', 'style']);
	
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	
	      var mergedRootStyles = (0, _simpleAssign2.default)({}, {
	        position: 'absolute',
	        height: '100%',
	        width: '100%',
	        top: 0,
	        left: 0,
	        transition: _transitions2.default.easeOut(null, ['transform', 'opacity'])
	      }, style);
	
	      return _react2.default.createElement(
	        'div',
	        _extends({}, other, { style: prepareStyles(mergedRootStyles) }),
	        children
	      );
	    }
	  }]);
	
	  return SlideInChild;
	}(_react.Component);
	
	SlideInChild.propTypes = {
	  children: _react.PropTypes.node,
	  direction: _react.PropTypes.string,
	  enterDelay: _react.PropTypes.number,
	  // This callback is needed bacause the direction could change when leaving the DOM
	  getLeaveDirection: _react.PropTypes.func.isRequired,
	  style: _react.PropTypes.object
	};
	SlideInChild.defaultProps = {
	  enterDelay: 0
	};
	SlideInChild.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	exports.default = SlideInChild;

/***/ }),
/* 706 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _transitions = __webpack_require__(582);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _SlideIn = __webpack_require__(704);
	
	var _SlideIn2 = _interopRequireDefault(_SlideIn);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function getStyles(props, context, state) {
	  var datePicker = context.muiTheme.datePicker;
	  var selectedYear = state.selectedYear;
	
	  var isLandscape = props.mode === 'landscape';
	
	  var styles = {
	    root: {
	      width: isLandscape ? 165 : '100%',
	      height: isLandscape ? 330 : 'auto',
	      float: isLandscape ? 'left' : 'none',
	      fontWeight: 700,
	      display: 'inline-block',
	      backgroundColor: datePicker.selectColor,
	      borderTopLeftRadius: 2,
	      borderTopRightRadius: isLandscape ? 0 : 2,
	      borderBottomLeftRadius: isLandscape ? 2 : 0,
	      color: datePicker.textColor,
	      padding: 20,
	      boxSizing: 'border-box'
	    },
	    monthDay: {
	      display: 'block',
	      fontSize: 36,
	      lineHeight: '36px',
	      height: props.mode === 'landscape' ? '100%' : 38,
	      opacity: selectedYear ? 0.7 : 1,
	      transition: _transitions2.default.easeOut(),
	      width: '100%',
	      fontWeight: '500'
	    },
	    monthDayTitle: {
	      cursor: !selectedYear ? 'default' : 'pointer',
	      width: '100%',
	      display: 'block'
	    },
	    year: {
	      margin: 0,
	      fontSize: 16,
	      fontWeight: '500',
	      lineHeight: '16px',
	      height: 16,
	      opacity: selectedYear ? 1 : 0.7,
	      transition: _transitions2.default.easeOut(),
	      marginBottom: 10
	    },
	    yearTitle: {
	      cursor: props.disableYearSelection ? 'not-allowed' : !selectedYear ? 'pointer' : 'default'
	    }
	  };
	
	  return styles;
	}
	
	var DateDisplay = function (_Component) {
	  _inherits(DateDisplay, _Component);
	
	  function DateDisplay() {
	    var _Object$getPrototypeO;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, DateDisplay);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_Object$getPrototypeO = Object.getPrototypeOf(DateDisplay)).call.apply(_Object$getPrototypeO, [this].concat(args))), _this), _this.state = {
	      selectedYear: false,
	      transitionDirection: 'up'
	    }, _this.handleTouchTapMonthDay = function () {
	      if (_this.props.onTouchTapMonthDay && _this.state.selectedYear) {
	        _this.props.onTouchTapMonthDay();
	      }
	
	      _this.setState({ selectedYear: false });
	    }, _this.handleTouchTapYear = function () {
	      if (_this.props.onTouchTapYear && !_this.props.disableYearSelection && !_this.state.selectedYear) {
	        _this.props.onTouchTapYear();
	      }
	
	      if (!_this.props.disableYearSelection) {
	        _this.setState({ selectedYear: true });
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(DateDisplay, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      if (!this.props.monthDaySelected) {
	        this.setState({ selectedYear: true });
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.selectedDate !== this.props.selectedDate) {
	        var direction = nextProps.selectedDate > this.props.selectedDate ? 'up' : 'down';
	        this.setState({
	          transitionDirection: direction
	        });
	      }
	
	      if (nextProps.monthDaySelected !== undefined) {
	        this.setState({
	          selectedYear: !nextProps.monthDaySelected
	        });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var DateTimeFormat = _props.DateTimeFormat;
	      var disableYearSelection = _props.disableYearSelection;
	      var locale = _props.locale;
	      var mode = _props.mode;
	      var monthDaySelected = _props.monthDaySelected;
	      var onTouchTapMonthDay = _props.onTouchTapMonthDay;
	      var onTouchTapYear = _props.onTouchTapYear;
	      var selectedDate = _props.selectedDate;
	      var style = _props.style;
	      var weekCount = _props.weekCount;
	
	      var other = _objectWithoutProperties(_props, ['DateTimeFormat', 'disableYearSelection', 'locale', 'mode', 'monthDaySelected', 'onTouchTapMonthDay', 'onTouchTapYear', 'selectedDate', 'style', 'weekCount']);
	
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context, this.state);
	      var year = selectedDate.getFullYear();
	
	      var dateTimeFormatted = new DateTimeFormat(locale, {
	        month: 'short',
	        weekday: 'short',
	        day: '2-digit'
	      }).format(selectedDate);
	
	      return _react2.default.createElement(
	        'div',
	        _extends({}, other, { style: prepareStyles(styles.root, style) }),
	        _react2.default.createElement(
	          _SlideIn2.default,
	          {
	            style: styles.year,
	            direction: this.state.transitionDirection
	          },
	          _react2.default.createElement(
	            'div',
	            { key: year, style: styles.yearTitle, onTouchTap: this.handleTouchTapYear },
	            year
	          )
	        ),
	        _react2.default.createElement(
	          _SlideIn2.default,
	          {
	            style: styles.monthDay,
	            direction: this.state.transitionDirection
	          },
	          _react2.default.createElement(
	            'div',
	            {
	              key: dateTimeFormatted,
	              onTouchTap: this.handleTouchTapMonthDay,
	              style: styles.monthDayTitle
	            },
	            dateTimeFormatted
	          )
	        )
	      );
	    }
	  }]);
	
	  return DateDisplay;
	}(_react.Component);
	
	DateDisplay.propTypes = {
	  DateTimeFormat: _react.PropTypes.func.isRequired,
	  disableYearSelection: _react.PropTypes.bool,
	  locale: _react.PropTypes.string.isRequired,
	  mode: _react.PropTypes.oneOf(['portrait', 'landscape']),
	  monthDaySelected: _react.PropTypes.bool,
	  onTouchTapMonthDay: _react.PropTypes.func,
	  onTouchTapYear: _react.PropTypes.func,
	  selectedDate: _react.PropTypes.object.isRequired,
	  style: _react.PropTypes.object,
	  weekCount: _react.PropTypes.number
	};
	DateDisplay.defaultProps = {
	  disableYearSelection: false,
	  monthDaySelected: true,
	  weekCount: 4
	};
	DateDisplay.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	exports.default = DateDisplay;

/***/ }),
/* 707 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _Dialog = __webpack_require__(708);
	
	var _Dialog2 = _interopRequireDefault(_Dialog);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Dialog2.default;

/***/ }),
/* 708 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _simpleAssign = __webpack_require__(579);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(332);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reactEventListener = __webpack_require__(625);
	
	var _reactEventListener2 = _interopRequireDefault(_reactEventListener);
	
	var _keycode = __webpack_require__(589);
	
	var _keycode2 = _interopRequireDefault(_keycode);
	
	var _transitions = __webpack_require__(582);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _Overlay = __webpack_require__(709);
	
	var _Overlay2 = _interopRequireDefault(_Overlay);
	
	var _RenderToLayer = __webpack_require__(640);
	
	var _RenderToLayer2 = _interopRequireDefault(_RenderToLayer);
	
	var _Paper = __webpack_require__(617);
	
	var _Paper2 = _interopRequireDefault(_Paper);
	
	var _reactAddonsTransitionGroup = __webpack_require__(595);
	
	var _reactAddonsTransitionGroup2 = _interopRequireDefault(_reactAddonsTransitionGroup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TransitionItem = function (_Component) {
	  _inherits(TransitionItem, _Component);
	
	  function TransitionItem() {
	    var _Object$getPrototypeO;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, TransitionItem);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_Object$getPrototypeO = Object.getPrototypeOf(TransitionItem)).call.apply(_Object$getPrototypeO, [this].concat(args))), _this), _this.state = {
	      style: {}
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(TransitionItem, [{
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      clearTimeout(this.enterTimeout);
	      clearTimeout(this.leaveTimeout);
	    }
	  }, {
	    key: 'componentWillEnter',
	    value: function componentWillEnter(callback) {
	      this.componentWillAppear(callback);
	    }
	  }, {
	    key: 'componentWillAppear',
	    value: function componentWillAppear(callback) {
	      var spacing = this.context.muiTheme.baseTheme.spacing;
	
	      this.setState({
	        style: {
	          opacity: 1,
	          transform: 'translate(0, ' + spacing.desktopKeylineIncrement + 'px)'
	        }
	      });
	
	      this.enterTimeout = setTimeout(callback, 450); // matches transition duration
	    }
	  }, {
	    key: 'componentWillLeave',
	    value: function componentWillLeave(callback) {
	      this.setState({
	        style: {
	          opacity: 0,
	          transform: 'translate(0, 0)'
	        }
	      });
	
	      this.leaveTimeout = setTimeout(callback, 450); // matches transition duration
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var style = _props.style;
	      var children = _props.children;
	
	      var other = _objectWithoutProperties(_props, ['style', 'children']);
	
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	
	      return _react2.default.createElement(
	        'div',
	        _extends({}, other, { style: prepareStyles((0, _simpleAssign2.default)({}, this.state.style, style)) }),
	        children
	      );
	    }
	  }]);
	
	  return TransitionItem;
	}(_react.Component);
	
	TransitionItem.propTypes = {
	  children: _react.PropTypes.node,
	  style: _react.PropTypes.object
	};
	TransitionItem.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	
	
	function getStyles(props, context) {
	  var autoScrollBodyContent = props.autoScrollBodyContent;
	  var open = props.open;
	  var _context$muiTheme = context.muiTheme;
	  var _context$muiTheme$bas = _context$muiTheme.baseTheme;
	  var spacing = _context$muiTheme$bas.spacing;
	  var palette = _context$muiTheme$bas.palette;
	  var dialog = _context$muiTheme.dialog;
	  var zIndex = _context$muiTheme.zIndex;
	
	
	  var gutter = spacing.desktopGutter;
	  var borderScroll = '1px solid ' + palette.borderColor;
	
	  return {
	    root: {
	      position: 'fixed',
	      boxSizing: 'border-box',
	      WebkitTapHighlightColor: 'rgba(0,0,0,0)', // Remove mobile color flashing (deprecated)
	      zIndex: zIndex.dialog,
	      top: 0,
	      left: open ? 0 : -10000,
	      width: '100%',
	      height: '100%',
	      transition: open ? _transitions2.default.easeOut('0ms', 'left', '0ms') : _transitions2.default.easeOut('0ms', 'left', '450ms')
	    },
	    content: {
	      boxSizing: 'border-box',
	      WebkitTapHighlightColor: 'rgba(0,0,0,0)', // Remove mobile color flashing (deprecated)
	      transition: _transitions2.default.easeOut(),
	      position: 'relative',
	      width: '75%',
	      maxWidth: spacing.desktopKeylineIncrement * 12,
	      margin: '0 auto',
	      zIndex: zIndex.dialog
	    },
	    actionsContainer: {
	      boxSizing: 'border-box',
	      WebkitTapHighlightColor: 'rgba(0,0,0,0)', // Remove mobile color flashing (deprecated)
	      padding: 8,
	      width: '100%',
	      textAlign: 'right',
	      marginTop: autoScrollBodyContent ? -1 : 0,
	      borderTop: autoScrollBodyContent ? borderScroll : 'none'
	    },
	    overlay: {
	      zIndex: zIndex.dialogOverlay
	    },
	    title: {
	      margin: 0,
	      padding: gutter + 'px ' + gutter + 'px 20px ' + gutter + 'px',
	      color: palette.textColor,
	      fontSize: dialog.titleFontSize,
	      lineHeight: '32px',
	      fontWeight: 400,
	      marginBottom: autoScrollBodyContent ? -1 : 0,
	      borderBottom: autoScrollBodyContent ? borderScroll : 'none'
	    },
	    body: {
	      fontSize: dialog.bodyFontSize,
	      color: dialog.bodyColor,
	      padding: (props.title ? 0 : gutter) + 'px ' + gutter + 'px ' + gutter + 'px',
	      boxSizing: 'border-box',
	      overflowY: autoScrollBodyContent ? 'auto' : 'hidden'
	    }
	  };
	}
	
	var DialogInline = function (_Component2) {
	  _inherits(DialogInline, _Component2);
	
	  function DialogInline() {
	    var _Object$getPrototypeO2;
	
	    var _temp2, _this2, _ret2;
	
	    _classCallCheck(this, DialogInline);
	
	    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	      args[_key2] = arguments[_key2];
	    }
	
	    return _ret2 = (_temp2 = (_this2 = _possibleConstructorReturn(this, (_Object$getPrototypeO2 = Object.getPrototypeOf(DialogInline)).call.apply(_Object$getPrototypeO2, [this].concat(args))), _this2), _this2.handleTouchTapOverlay = function () {
	      _this2.requestClose(false);
	    }, _this2.handleKeyUp = function (event) {
	      if ((0, _keycode2.default)(event) === 'esc') {
	        _this2.requestClose(false);
	      }
	    }, _this2.handleResize = function () {
	      _this2.positionDialog();
	    }, _temp2), _possibleConstructorReturn(_this2, _ret2);
	  }
	
	  _createClass(DialogInline, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.positionDialog();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this.positionDialog();
	    }
	  }, {
	    key: 'positionDialog',
	    value: function positionDialog() {
	      var _props2 = this.props;
	      var actions = _props2.actions;
	      var autoDetectWindowHeight = _props2.autoDetectWindowHeight;
	      var autoScrollBodyContent = _props2.autoScrollBodyContent;
	      var bodyStyle = _props2.bodyStyle;
	      var open = _props2.open;
	      var repositionOnUpdate = _props2.repositionOnUpdate;
	      var title = _props2.title;
	
	
	      if (!open) {
	        return;
	      }
	
	      var clientHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
	      var container = _reactDom2.default.findDOMNode(this);
	      var dialogWindow = _reactDom2.default.findDOMNode(this.refs.dialogWindow);
	      var dialogContent = _reactDom2.default.findDOMNode(this.refs.dialogContent);
	      var minPaddingTop = 16;
	
	      // Reset the height in case the window was resized.
	      dialogWindow.style.height = '';
	      dialogContent.style.height = '';
	
	      var dialogWindowHeight = dialogWindow.offsetHeight;
	      var paddingTop = (clientHeight - dialogWindowHeight) / 2 - 64;
	      if (paddingTop < minPaddingTop) paddingTop = minPaddingTop;
	
	      // Vertically center the dialog window, but make sure it doesn't
	      // transition to that position.
	      if (repositionOnUpdate || !container.style.paddingTop) {
	        container.style.paddingTop = paddingTop + 'px';
	      }
	
	      // Force a height if the dialog is taller than clientHeight
	      if (autoDetectWindowHeight || autoScrollBodyContent) {
	        var styles = getStyles(this.props, this.context);
	        styles.body = (0, _simpleAssign2.default)(styles.body, bodyStyle);
	        var maxDialogContentHeight = clientHeight - 2 * 64;
	
	        if (title) maxDialogContentHeight -= dialogContent.previousSibling.offsetHeight;
	
	        if (_react2.default.Children.count(actions)) {
	          maxDialogContentHeight -= dialogContent.nextSibling.offsetHeight;
	        }
	
	        dialogContent.style.maxHeight = maxDialogContentHeight + 'px';
	      }
	    }
	  }, {
	    key: 'requestClose',
	    value: function requestClose(buttonClicked) {
	      if (!buttonClicked && this.props.modal) {
	        return;
	      }
	
	      if (this.props.onRequestClose) {
	        this.props.onRequestClose(!!buttonClicked);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props3 = this.props;
	      var actions = _props3.actions;
	      var actionsContainerClassName = _props3.actionsContainerClassName;
	      var actionsContainerStyle = _props3.actionsContainerStyle;
	      var bodyClassName = _props3.bodyClassName;
	      var bodyStyle = _props3.bodyStyle;
	      var children = _props3.children;
	      var className = _props3.className;
	      var contentClassName = _props3.contentClassName;
	      var contentStyle = _props3.contentStyle;
	      var overlayClassName = _props3.overlayClassName;
	      var overlayStyle = _props3.overlayStyle;
	      var open = _props3.open;
	      var titleClassName = _props3.titleClassName;
	      var titleStyle = _props3.titleStyle;
	      var title = _props3.title;
	      var style = _props3.style;
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      styles.root = (0, _simpleAssign2.default)(styles.root, style);
	      styles.content = (0, _simpleAssign2.default)(styles.content, contentStyle);
	      styles.body = (0, _simpleAssign2.default)(styles.body, bodyStyle);
	      styles.actionsContainer = (0, _simpleAssign2.default)(styles.actionsContainer, actionsContainerStyle);
	      styles.overlay = (0, _simpleAssign2.default)(styles.overlay, overlayStyle);
	      styles.title = (0, _simpleAssign2.default)(styles.title, titleStyle);
	
	      var actionsContainer = _react2.default.Children.count(actions) > 0 && _react2.default.createElement(
	        'div',
	        { className: actionsContainerClassName, style: prepareStyles(styles.actionsContainer) },
	        _react2.default.Children.toArray(actions)
	      );
	
	      var titleElement = title;
	      if (_react2.default.isValidElement(title)) {
	        titleElement = _react2.default.cloneElement(title, {
	          className: title.props.className || titleClassName,
	          style: prepareStyles((0, _simpleAssign2.default)(styles.title, title.props.style))
	        });
	      } else if (typeof title === 'string') {
	        titleElement = _react2.default.createElement(
	          'h3',
	          { className: titleClassName, style: prepareStyles(styles.title) },
	          title
	        );
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: className, style: prepareStyles(styles.root) },
	        open && _react2.default.createElement(_reactEventListener2.default, {
	          target: 'window',
	          onKeyUp: this.handleKeyUp,
	          onResize: this.handleResize
	        }),
	        _react2.default.createElement(
	          _reactAddonsTransitionGroup2.default,
	          {
	            component: 'div',
	            ref: 'dialogWindow',
	            transitionAppear: true,
	            transitionAppearTimeout: 450,
	            transitionEnter: true,
	            transitionEnterTimeout: 450
	          },
	          open && _react2.default.createElement(
	            TransitionItem,
	            {
	              className: contentClassName,
	              style: styles.content
	            },
	            _react2.default.createElement(
	              _Paper2.default,
	              { zDepth: 4 },
	              titleElement,
	              _react2.default.createElement(
	                'div',
	                {
	                  ref: 'dialogContent',
	                  className: bodyClassName,
	                  style: prepareStyles(styles.body)
	                },
	                children
	              ),
	              actionsContainer
	            )
	          )
	        ),
	        _react2.default.createElement(_Overlay2.default, {
	          show: open,
	          className: overlayClassName,
	          style: styles.overlay,
	          onTouchTap: this.handleTouchTapOverlay
	        })
	      );
	    }
	  }]);
	
	  return DialogInline;
	}(_react.Component);
	
	DialogInline.propTypes = {
	  actions: _react.PropTypes.node,
	  actionsContainerClassName: _react.PropTypes.string,
	  actionsContainerStyle: _react.PropTypes.object,
	  autoDetectWindowHeight: _react.PropTypes.bool,
	  autoScrollBodyContent: _react.PropTypes.bool,
	  bodyClassName: _react.PropTypes.string,
	  bodyStyle: _react.PropTypes.object,
	  children: _react.PropTypes.node,
	  className: _react.PropTypes.string,
	  contentClassName: _react.PropTypes.string,
	  contentStyle: _react.PropTypes.object,
	  modal: _react.PropTypes.bool,
	  onRequestClose: _react.PropTypes.func,
	  open: _react.PropTypes.bool.isRequired,
	  overlayClassName: _react.PropTypes.string,
	  overlayStyle: _react.PropTypes.object,
	  repositionOnUpdate: _react.PropTypes.bool,
	  style: _react.PropTypes.object,
	  title: _react.PropTypes.node,
	  titleClassName: _react.PropTypes.string,
	  titleStyle: _react.PropTypes.object
	};
	DialogInline.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	
	var Dialog = function (_Component3) {
	  _inherits(Dialog, _Component3);
	
	  function Dialog() {
	    var _Object$getPrototypeO3;
	
	    var _temp3, _this3, _ret3;
	
	    _classCallCheck(this, Dialog);
	
	    for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
	      args[_key3] = arguments[_key3];
	    }
	
	    return _ret3 = (_temp3 = (_this3 = _possibleConstructorReturn(this, (_Object$getPrototypeO3 = Object.getPrototypeOf(Dialog)).call.apply(_Object$getPrototypeO3, [this].concat(args))), _this3), _this3.renderLayer = function () {
	      return _react2.default.createElement(DialogInline, _this3.props);
	    }, _temp3), _possibleConstructorReturn(_this3, _ret3);
	  }
	
	  _createClass(Dialog, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(_RenderToLayer2.default, { render: this.renderLayer, open: true, useLayerForClickAway: false });
	    }
	  }]);
	
	  return Dialog;
	}(_react.Component);
	
	Dialog.propTypes = {
	  /**
	   * Action buttons to display below the Dialog content (`children`).
	   * This property accepts either a React element, or an array of React elements.
	   */
	  actions: _react.PropTypes.node,
	  /**
	   * The `className` to add to the actions container's root element.
	   */
	  actionsContainerClassName: _react.PropTypes.string,
	  /**
	   * Overrides the inline-styles of the actions container's root element.
	   */
	  actionsContainerStyle: _react.PropTypes.object,
	  /**
	   * If set to true, the height of the `Dialog` will be auto detected. A max height
	   * will be enforced so that the content does not extend beyond the viewport.
	   */
	  autoDetectWindowHeight: _react.PropTypes.bool,
	  /**
	   * If set to true, the body content of the `Dialog` will be scrollable.
	   */
	  autoScrollBodyContent: _react.PropTypes.bool,
	  /**
	   * The `className` to add to the content's root element under the title.
	   */
	  bodyClassName: _react.PropTypes.string,
	  /**
	   * Overrides the inline-styles of the content's root element under the title.
	   */
	  bodyStyle: _react.PropTypes.object,
	  /**
	   * The contents of the `Dialog`.
	   */
	  children: _react.PropTypes.node,
	  /**
	   * The css class name of the root element.
	   */
	  className: _react.PropTypes.string,
	  /**
	   * The `className` to add to the content container.
	   */
	  contentClassName: _react.PropTypes.string,
	  /**
	   * Overrides the inline-styles of the content container.
	   */
	  contentStyle: _react.PropTypes.object,
	  /**
	   * Force the user to use one of the actions in the `Dialog`.
	   * Clicking outside the `Dialog` will not trigger the `onRequestClose`.
	   */
	  modal: _react.PropTypes.bool,
	  /**
	   * Fired when the `Dialog` is requested to be closed by a click outside the `Dialog` or on the buttons.
	   *
	   * @param {bool} buttonClicked Determines whether a button click triggered this request.
	   */
	  onRequestClose: _react.PropTypes.func,
	  /**
	   * Controls whether the Dialog is opened or not.
	   */
	  open: _react.PropTypes.bool.isRequired,
	  /**
	   * The `className` to add to the `Overlay` component that is rendered behind the `Dialog`.
	   */
	  overlayClassName: _react.PropTypes.string,
	  /**
	   * Overrides the inline-styles of the `Overlay` component that is rendered behind the `Dialog`.
	   */
	  overlayStyle: _react.PropTypes.object,
	  /**
	   * Determines whether the `Dialog` should be repositioned when it's contents are updated.
	   */
	  repositionOnUpdate: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object,
	  /**
	   * The title to display on the `Dialog`. Could be number, string, element or an array containing these types.
	   */
	  title: _react.PropTypes.node,
	  /**
	   * The `className` to add to the title's root container element.
	   */
	  titleClassName: _react.PropTypes.string,
	  /**
	   * Overrides the inline-styles of the title's root container element.
	   */
	  titleStyle: _react.PropTypes.object
	};
	Dialog.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	Dialog.defaultProps = {
	  autoDetectWindowHeight: true,
	  autoScrollBodyContent: false,
	  modal: false,
	  repositionOnUpdate: true
	};
	exports.default = Dialog;

/***/ }),
/* 709 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _simpleAssign = __webpack_require__(579);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _transitions = __webpack_require__(582);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _AutoLockScrolling = __webpack_require__(710);
	
	var _AutoLockScrolling2 = _interopRequireDefault(_AutoLockScrolling);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function getStyles(props, context) {
	  var overlay = context.muiTheme.overlay;
	
	
	  var style = {
	    root: {
	      position: 'fixed',
	      height: '100%',
	      width: '100%',
	      top: 0,
	      left: '-100%',
	      opacity: 0,
	      backgroundColor: overlay.backgroundColor,
	      WebkitTapHighlightColor: 'rgba(0, 0, 0, 0)', // Remove mobile color flashing (deprecated)
	
	      // Two ways to promote overlay to its own render layer
	      willChange: 'opacity',
	      transform: 'translateZ(0)',
	
	      transition: props.transitionEnabled && _transitions2.default.easeOut('0ms', 'left', '400ms') + ', ' + _transitions2.default.easeOut('400ms', 'opacity')
	    }
	  };
	
	  if (props.show) {
	    (0, _simpleAssign2.default)(style.root, {
	      left: 0,
	      opacity: 1,
	      transition: _transitions2.default.easeOut('0ms', 'left') + ', ' + _transitions2.default.easeOut('400ms', 'opacity')
	    });
	  }
	
	  return style;
	}
	
	var Overlay = function (_Component) {
	  _inherits(Overlay, _Component);
	
	  function Overlay() {
	    _classCallCheck(this, Overlay);
	
	    return _possibleConstructorReturn(this, Object.getPrototypeOf(Overlay).apply(this, arguments));
	  }
	
	  _createClass(Overlay, [{
	    key: 'setOpacity',
	    value: function setOpacity(opacity) {
	      this.refs.overlay.style.opacity = opacity;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var autoLockScrolling = _props.autoLockScrolling;
	      var show = _props.show;
	      var style = _props.style;
	      var transitionEnabled = _props.transitionEnabled;
	
	      var other = _objectWithoutProperties(_props, ['autoLockScrolling', 'show', 'style', 'transitionEnabled']);
	
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      return _react2.default.createElement(
	        'div',
	        _extends({}, other, { ref: 'overlay', style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) }),
	        autoLockScrolling && _react2.default.createElement(_AutoLockScrolling2.default, { lock: show })
	      );
	    }
	  }]);
	
	  return Overlay;
	}(_react.Component);
	
	Overlay.propTypes = {
	  autoLockScrolling: _react.PropTypes.bool,
	  show: _react.PropTypes.bool.isRequired,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object,
	  transitionEnabled: _react.PropTypes.bool
	};
	Overlay.defaultProps = {
	  autoLockScrolling: true,
	  style: {},
	  transitionEnabled: true
	};
	Overlay.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	exports.default = Overlay;

/***/ }),
/* 710 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var originalBodyOverflow = null;
	var lockingCounter = 0;
	
	var AutoLockScrolling = function (_Component) {
	  _inherits(AutoLockScrolling, _Component);
	
	  function AutoLockScrolling() {
	    var _Object$getPrototypeO;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, AutoLockScrolling);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_Object$getPrototypeO = Object.getPrototypeOf(AutoLockScrolling)).call.apply(_Object$getPrototypeO, [this].concat(args))), _this), _this.locked = false, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(AutoLockScrolling, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (this.props.lock === true) this.preventScrolling();
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.props.lock !== nextProps.lock) {
	        if (nextProps.lock) {
	          this.preventScrolling();
	        } else {
	          this.allowScrolling();
	        }
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.allowScrolling();
	    }
	
	    // force to only lock/unlock once
	
	  }, {
	    key: 'preventScrolling',
	    value: function preventScrolling() {
	      if (this.locked === true) return;
	      lockingCounter = lockingCounter + 1;
	      this.locked = true;
	
	      // only lock the first time the component is mounted.
	      if (lockingCounter === 1) {
	        var body = document.getElementsByTagName('body')[0];
	        originalBodyOverflow = body.style.overflow;
	        body.style.overflow = 'hidden';
	      }
	    }
	  }, {
	    key: 'allowScrolling',
	    value: function allowScrolling() {
	      if (this.locked === true) {
	        lockingCounter = lockingCounter - 1;
	        this.locked = false;
	      }
	
	      if (lockingCounter === 0 && originalBodyOverflow !== null) {
	        var body = document.getElementsByTagName('body')[0];
	        body.style.overflow = originalBodyOverflow || '';
	        originalBodyOverflow = null;
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return null;
	    }
	  }]);
	
	  return AutoLockScrolling;
	}(_react.Component);
	
	AutoLockScrolling.propTypes = {
	  lock: _react.PropTypes.bool.isRequired
	};
	exports.default = AutoLockScrolling;

/***/ }),
/* 711 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _simpleAssign = __webpack_require__(579);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Paper = __webpack_require__(617);
	
	var _Paper2 = _interopRequireDefault(_Paper);
	
	var _transitions = __webpack_require__(582);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _propTypes = __webpack_require__(583);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function getStyles(props, context, state) {
	  var targetOrigin = props.targetOrigin;
	  var open = state.open;
	  var muiTheme = context.muiTheme;
	
	  var horizontal = targetOrigin.horizontal.replace('middle', 'vertical');
	
	  return {
	    root: {
	      opacity: open ? 1 : 0,
	      transform: open ? 'scaleY(1)' : 'scaleY(0)',
	      transformOrigin: horizontal + ' ' + targetOrigin.vertical,
	      position: 'fixed',
	      zIndex: muiTheme.zIndex.popover,
	      transition: _transitions2.default.easeOut('450ms', ['transform', 'opacity']),
	      maxHeight: '100%'
	    }
	  };
	}
	
	var PopoverAnimationVertical = function (_Component) {
	  _inherits(PopoverAnimationVertical, _Component);
	
	  function PopoverAnimationVertical() {
	    var _Object$getPrototypeO;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, PopoverAnimationVertical);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_Object$getPrototypeO = Object.getPrototypeOf(PopoverAnimationVertical)).call.apply(_Object$getPrototypeO, [this].concat(args))), _this), _this.state = {
	      open: false
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(PopoverAnimationVertical, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.setState({ open: true }); // eslint-disable-line react/no-did-mount-set-state
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      this.setState({
	        open: nextProps.open
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var className = _props.className;
	      var style = _props.style;
	      var zDepth = _props.zDepth;
	
	
	      var styles = getStyles(this.props, this.context, this.state);
	
	      return _react2.default.createElement(
	        _Paper2.default,
	        {
	          style: (0, _simpleAssign2.default)(styles.root, style),
	          zDepth: zDepth,
	          className: className
	        },
	        this.props.children
	      );
	    }
	  }]);
	
	  return PopoverAnimationVertical;
	}(_react.Component);
	
	PopoverAnimationVertical.propTypes = {
	  children: _react.PropTypes.node,
	  className: _react.PropTypes.string,
	  open: _react.PropTypes.bool.isRequired,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object,
	  targetOrigin: _propTypes2.default.origin,
	  zDepth: _propTypes2.default.zDepth
	};
	PopoverAnimationVertical.defaultProps = {
	  style: {},
	  zDepth: 1
	};
	PopoverAnimationVertical.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	exports.default = PopoverAnimationVertical;

/***/ }),
/* 712 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _Drawer = __webpack_require__(713);
	
	var _Drawer2 = _interopRequireDefault(_Drawer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Drawer2.default;

/***/ }),
/* 713 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _simpleAssign = __webpack_require__(579);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(332);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reactEventListener = __webpack_require__(625);
	
	var _reactEventListener2 = _interopRequireDefault(_reactEventListener);
	
	var _keycode = __webpack_require__(589);
	
	var _keycode2 = _interopRequireDefault(_keycode);
	
	var _autoPrefix = __webpack_require__(593);
	
	var _autoPrefix2 = _interopRequireDefault(_autoPrefix);
	
	var _transitions = __webpack_require__(582);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _Overlay = __webpack_require__(709);
	
	var _Overlay2 = _interopRequireDefault(_Overlay);
	
	var _Paper = __webpack_require__(617);
	
	var _Paper2 = _interopRequireDefault(_Paper);
	
	var _propTypes = __webpack_require__(583);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var openNavEventHandler = null;
	
	var Drawer = function (_Component) {
	  _inherits(Drawer, _Component);
	
	  function Drawer() {
	    var _Object$getPrototypeO;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Drawer);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_Object$getPrototypeO = Object.getPrototypeOf(Drawer)).call.apply(_Object$getPrototypeO, [this].concat(args))), _this), _this.handleTouchTapOverlay = function (event) {
	      event.preventDefault();
	      _this.close('clickaway');
	    }, _this.handleKeyUp = function (event) {
	      if (_this.state.open && !_this.props.docked && (0, _keycode2.default)(event) === 'esc') {
	        _this.close('escape');
	      }
	    }, _this.onBodyTouchStart = function (event) {
	      var swipeAreaWidth = _this.props.swipeAreaWidth;
	
	      var touchStartX = event.touches[0].pageX;
	      var touchStartY = event.touches[0].pageY;
	
	      // Open only if swiping from far left (or right) while closed
	      if (swipeAreaWidth !== null && !_this.state.open) {
	        if (_this.props.openSecondary) {
	          // If openSecondary is true calculate from the far right
	          if (touchStartX < document.body.offsetWidth - swipeAreaWidth) return;
	        } else {
	          // If openSecondary is false calculate from the far left
	          if (touchStartX > swipeAreaWidth) return;
	        }
	      }
	
	      if (!_this.state.open && (openNavEventHandler !== _this.onBodyTouchStart || _this.props.disableSwipeToOpen)) {
	        return;
	      }
	
	      _this.maybeSwiping = true;
	      _this.touchStartX = touchStartX;
	      _this.touchStartY = touchStartY;
	
	      document.body.addEventListener('touchmove', _this.onBodyTouchMove);
	      document.body.addEventListener('touchend', _this.onBodyTouchEnd);
	      document.body.addEventListener('touchcancel', _this.onBodyTouchEnd);
	    }, _this.onBodyTouchMove = function (event) {
	      var currentX = event.touches[0].pageX;
	      var currentY = event.touches[0].pageY;
	
	      if (_this.state.swiping) {
	        event.preventDefault();
	        _this.setPosition(_this.getTranslateX(currentX));
	      } else if (_this.maybeSwiping) {
	        var dXAbs = Math.abs(currentX - _this.touchStartX);
	        var dYAbs = Math.abs(currentY - _this.touchStartY);
	        // If the user has moved his thumb ten pixels in either direction,
	        // we can safely make an assumption about whether he was intending
	        // to swipe or scroll.
	        var threshold = 10;
	
	        if (dXAbs > threshold && dYAbs <= threshold) {
	          _this.swipeStartX = currentX;
	          _this.setState({
	            swiping: _this.state.open ? 'closing' : 'opening'
	          });
	          _this.setPosition(_this.getTranslateX(currentX));
	        } else if (dXAbs <= threshold && dYAbs > threshold) {
	          _this.onBodyTouchEnd();
	        }
	      }
	    }, _this.onBodyTouchEnd = function (event) {
	      if (_this.state.swiping) {
	        var currentX = event.changedTouches[0].pageX;
	        var translateRatio = _this.getTranslateX(currentX) / _this.getMaxTranslateX();
	
	        _this.maybeSwiping = false;
	        var swiping = _this.state.swiping;
	        _this.setState({
	          swiping: null
	        });
	
	        // We have to open or close after setting swiping to null,
	        // because only then CSS transition is enabled.
	        if (translateRatio > 0.5) {
	          if (swiping === 'opening') {
	            _this.setPosition(_this.getMaxTranslateX());
	          } else {
	            _this.close('swipe');
	          }
	        } else {
	          if (swiping === 'opening') {
	            _this.open('swipe');
	          } else {
	            _this.setPosition(0);
	          }
	        }
	      } else {
	        _this.maybeSwiping = false;
	      }
	
	      document.body.removeEventListener('touchmove', _this.onBodyTouchMove);
	      document.body.removeEventListener('touchend', _this.onBodyTouchEnd);
	      document.body.removeEventListener('touchcancel', _this.onBodyTouchEnd);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Drawer, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.maybeSwiping = false;
	      this.touchStartX = null;
	      this.touchStartY = null;
	      this.swipeStartX = null;
	
	      this.setState({
	        open: this.props.open !== null ? this.props.open : this.props.docked,
	        swiping: null
	      });
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.enableSwipeHandling();
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      // If controlled then the open prop takes precedence.
	      if (nextProps.open !== null) {
	        this.setState({
	          open: nextProps.open
	        });
	        // Otherwise, if docked is changed, change the open state for when uncontrolled.
	      } else if (this.props.docked !== nextProps.docked) {
	        this.setState({
	          open: nextProps.docked
	        });
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this.enableSwipeHandling();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.disableSwipeHandling();
	    }
	  }, {
	    key: 'getStyles',
	    value: function getStyles() {
	      var muiTheme = this.context.muiTheme;
	      var theme = muiTheme.drawer;
	
	      var x = this.getTranslateMultiplier() * (this.state.open ? 0 : this.getMaxTranslateX());
	
	      var styles = {
	        root: {
	          height: '100%',
	          width: this.props.width || theme.width,
	          position: 'fixed',
	          zIndex: muiTheme.zIndex.drawer,
	          left: 0,
	          top: 0,
	          transform: 'translate(' + x + 'px, 0)',
	          transition: !this.state.swiping && _transitions2.default.easeOut(null, 'transform', null),
	          backgroundColor: theme.color,
	          overflow: 'auto',
	          WebkitOverflowScrolling: 'touch' },
	        overlay: {
	          zIndex: muiTheme.zIndex.drawerOverlay,
	          pointerEvents: this.state.open ? 'auto' : 'none' },
	        rootWhenOpenRight: {
	          left: 'auto',
	          right: 0
	        }
	      };
	
	      return styles;
	    }
	  }, {
	    key: 'shouldShow',
	    value: function shouldShow() {
	      return this.state.open || !!this.state.swiping; // component is swiping
	    }
	  }, {
	    key: 'close',
	    value: function close(reason) {
	      if (this.props.open === null) this.setState({ open: false });
	      if (this.props.onRequestChange) this.props.onRequestChange(false, reason);
	      return this;
	    }
	  }, {
	    key: 'open',
	    value: function open(reason) {
	      if (this.props.open === null) this.setState({ open: true });
	      if (this.props.onRequestChange) this.props.onRequestChange(true, reason);
	      return this;
	    }
	  }, {
	    key: 'getMaxTranslateX',
	    value: function getMaxTranslateX() {
	      var width = this.props.width || this.context.muiTheme.drawer.width;
	      return width + 10;
	    }
	  }, {
	    key: 'getTranslateMultiplier',
	    value: function getTranslateMultiplier() {
	      return this.props.openSecondary ? 1 : -1;
	    }
	  }, {
	    key: 'enableSwipeHandling',
	    value: function enableSwipeHandling() {
	      if (!this.props.docked) {
	        document.body.addEventListener('touchstart', this.onBodyTouchStart);
	        if (!openNavEventHandler) {
	          openNavEventHandler = this.onBodyTouchStart;
	        }
	      } else {
	        this.disableSwipeHandling();
	      }
	    }
	  }, {
	    key: 'disableSwipeHandling',
	    value: function disableSwipeHandling() {
	      document.body.removeEventListener('touchstart', this.onBodyTouchStart);
	      if (openNavEventHandler === this.onBodyTouchStart) {
	        openNavEventHandler = null;
	      }
	    }
	  }, {
	    key: 'setPosition',
	    value: function setPosition(translateX) {
	      var drawer = _reactDom2.default.findDOMNode(this.refs.clickAwayableElement);
	      var transformCSS = 'translate(' + this.getTranslateMultiplier() * translateX + 'px, 0)';
	      this.refs.overlay.setOpacity(1 - translateX / this.getMaxTranslateX());
	      _autoPrefix2.default.set(drawer.style, 'transform', transformCSS);
	    }
	  }, {
	    key: 'getTranslateX',
	    value: function getTranslateX(currentX) {
	      return Math.min(Math.max(this.state.swiping === 'closing' ? this.getTranslateMultiplier() * (currentX - this.swipeStartX) : this.getMaxTranslateX() - this.getTranslateMultiplier() * (this.swipeStartX - currentX), 0), this.getMaxTranslateX());
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var children = _props.children;
	      var className = _props.className;
	      var containerClassName = _props.containerClassName;
	      var containerStyle = _props.containerStyle;
	      var docked = _props.docked;
	      var openSecondary = _props.openSecondary;
	      var overlayClassName = _props.overlayClassName;
	      var overlayStyle = _props.overlayStyle;
	      var style = _props.style;
	      var zDepth = _props.zDepth;
	
	
	      var styles = this.getStyles();
	
	      var overlay = void 0;
	      if (!docked) {
	        overlay = _react2.default.createElement(_Overlay2.default, {
	          ref: 'overlay',
	          show: this.shouldShow(),
	          className: overlayClassName,
	          style: (0, _simpleAssign2.default)(styles.overlay, overlayStyle),
	          transitionEnabled: !this.state.swiping,
	          onTouchTap: this.handleTouchTapOverlay
	        });
	      }
	
	      return _react2.default.createElement(
	        'div',
	        {
	          className: className,
	          style: style
	        },
	        _react2.default.createElement(_reactEventListener2.default, { target: 'window', onKeyUp: this.handleKeyUp }),
	        overlay,
	        _react2.default.createElement(
	          _Paper2.default,
	          {
	            ref: 'clickAwayableElement',
	            zDepth: zDepth,
	            rounded: false,
	            transitionEnabled: !this.state.swiping,
	            className: containerClassName,
	            style: (0, _simpleAssign2.default)(styles.root, openSecondary && styles.rootWhenOpenRight, containerStyle)
	          },
	          children
	        )
	      );
	    }
	  }]);
	
	  return Drawer;
	}(_react.Component);
	
	Drawer.propTypes = {
	  /**
	   * The contents of the `Drawer`
	   */
	  children: _react.PropTypes.node,
	  /**
	   * The CSS class name of the root element.
	   */
	  className: _react.PropTypes.string,
	  /**
	   * The CSS class name of the container element.
	   */
	  containerClassName: _react.PropTypes.string,
	  /**
	   * Override the inline-styles of the container element.
	   */
	  containerStyle: _react.PropTypes.object,
	  /**
	   * If true, swiping sideways when the `Drawer` is closed will not open it.
	   */
	  disableSwipeToOpen: _react.PropTypes.bool,
	  /**
	   * If true, the `Drawer` will be docked. In this state, the overlay won't show and
	   * clicking on a menu item will not close the `Drawer`.
	   */
	  docked: _react.PropTypes.bool,
	  /**
	   * Callback function fired when the `open` state of the `Drawer` is requested to be changed.
	   *
	   * @param {boolean} open If true, the `Drawer` was requested to be opened.
	   * @param {string} reason The reason for the open or close request. Possible values are
	   * 'swipe' for open requests; 'clickaway' (on overlay clicks),
	   * 'escape' (on escape key press), and 'swipe' for close requests.
	   */
	  onRequestChange: _react.PropTypes.func,
	  /**
	   * If true, the `Drawer` is opened.  Providing a value will turn the `Drawer`
	   * into a controlled component.
	   */
	  open: _react.PropTypes.bool,
	  /**
	   * If true, the `Drawer` is positioned to open from the opposite side.
	   */
	  openSecondary: _react.PropTypes.bool,
	  /**
	   * The CSS class name to add to the `Overlay` component that is rendered behind the `Drawer`.
	   */
	  overlayClassName: _react.PropTypes.string,
	  /**
	   * Override the inline-styles of the `Overlay` component that is rendered behind the `Drawer`.
	   */
	  overlayStyle: _react.PropTypes.object,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object,
	  /**
	   * The width of the left most (or right most) area in pixels where the `Drawer` can be
	   * swiped open from. Setting this to `null` spans that area to the entire page
	   * (**CAUTION!** Setting this property to `null` might cause issues with sliders and
	   * swipeable `Tabs`: use at your own risk).
	   */
	  swipeAreaWidth: _react.PropTypes.number,
	  /**
	   * The width of the `Drawer` in pixels. Defaults to using the values from theme.
	   */
	  width: _react.PropTypes.number,
	  /**
	   * The zDepth of the `Drawer`.
	   */
	  zDepth: _propTypes2.default.zDepth
	
	};
	Drawer.defaultProps = {
	  disableSwipeToOpen: false,
	  docked: true,
	  open: null,
	  openSecondary: false,
	  swipeAreaWidth: 30,
	  width: null,
	  zDepth: 2
	};
	Drawer.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	exports.default = Drawer;

/***/ }),
/* 714 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.MenuItem = exports.DropDownMenu = undefined;
	
	var _DropDownMenu2 = __webpack_require__(715);
	
	var _DropDownMenu3 = _interopRequireDefault(_DropDownMenu2);
	
	var _MenuItem2 = __webpack_require__(638);
	
	var _MenuItem3 = _interopRequireDefault(_MenuItem2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.DropDownMenu = _DropDownMenu3.default;
	exports.MenuItem = _MenuItem3.default;
	exports.default = _DropDownMenu3.default;

/***/ }),
/* 715 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _simpleAssign = __webpack_require__(579);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _transitions = __webpack_require__(582);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _arrowDropDown = __webpack_require__(716);
	
	var _arrowDropDown2 = _interopRequireDefault(_arrowDropDown);
	
	var _Menu = __webpack_require__(631);
	
	var _Menu2 = _interopRequireDefault(_Menu);
	
	var _ClearFix = __webpack_require__(717);
	
	var _ClearFix2 = _interopRequireDefault(_ClearFix);
	
	var _Popover = __webpack_require__(639);
	
	var _Popover2 = _interopRequireDefault(_Popover);
	
	var _PopoverAnimationVertical = __webpack_require__(711);
	
	var _PopoverAnimationVertical2 = _interopRequireDefault(_PopoverAnimationVertical);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var anchorOrigin = {
	  vertical: 'top',
	  horizontal: 'left'
	};
	
	function getStyles(props, context) {
	  var disabled = props.disabled;
	
	  var spacing = context.muiTheme.baseTheme.spacing;
	  var palette = context.muiTheme.baseTheme.palette;
	  var accentColor = context.muiTheme.dropDownMenu.accentColor;
	  return {
	    control: {
	      cursor: disabled ? 'not-allowed' : 'pointer',
	      height: '100%',
	      position: 'relative',
	      width: '100%'
	    },
	    icon: {
	      fill: accentColor,
	      position: 'absolute',
	      right: spacing.desktopGutterLess,
	      top: (spacing.desktopToolbarHeight - 24) / 2
	    },
	    label: {
	      color: disabled ? palette.disabledColor : palette.textColor,
	      lineHeight: spacing.desktopToolbarHeight + 'px',
	      opacity: 1,
	      position: 'relative',
	      paddingLeft: spacing.desktopGutter,
	      paddingRight: spacing.iconSize + spacing.desktopGutterLess + spacing.desktopGutterMini,
	      top: 0
	    },
	    labelWhenOpen: {
	      opacity: 0,
	      top: spacing.desktopToolbarHeight / 8
	    },
	    root: {
	      display: 'inline-block',
	      fontSize: spacing.desktopDropDownMenuFontSize,
	      height: spacing.desktopSubheaderHeight,
	      fontFamily: context.muiTheme.baseTheme.fontFamily,
	      outline: 'none',
	      position: 'relative',
	      transition: _transitions2.default.easeOut()
	    },
	    rootWhenOpen: {
	      opacity: 1
	    },
	    underline: {
	      borderTop: 'solid 1px ' + accentColor,
	      bottom: 1,
	      left: 0,
	      margin: '-1px ' + spacing.desktopGutter + 'px',
	      right: 0,
	      position: 'absolute'
	    }
	  };
	}
	
	var DropDownMenu = function (_Component) {
	  _inherits(DropDownMenu, _Component);
	
	  function DropDownMenu() {
	    var _Object$getPrototypeO;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, DropDownMenu);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_Object$getPrototypeO = Object.getPrototypeOf(DropDownMenu)).call.apply(_Object$getPrototypeO, [this].concat(args))), _this), _this.state = {
	      open: false
	    }, _this.handleTouchTapControl = function (event) {
	      event.preventDefault();
	      if (!_this.props.disabled) {
	        _this.setState({
	          open: !_this.state.open,
	          anchorEl: _this.refs.root
	        });
	      }
	    }, _this.handleRequestCloseMenu = function () {
	      _this.setState({
	        open: false,
	        anchorEl: null
	      });
	    }, _this.handleItemTouchTap = function (event, child, index) {
	      event.persist();
	      _this.setState({
	        open: false
	      }, function () {
	        if (_this.props.onChange) {
	          _this.props.onChange(event, index, child.props.value);
	        }
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  // The nested styles for drop-down-menu are modified by toolbar and possibly
	  // other user components, so it will give full access to its js styles rather
	  // than just the parent.
	
	
	  _createClass(DropDownMenu, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      if (this.props.autoWidth) {
	        this.setWidth();
	      }
	      if (this.props.openImmediately) {
	        // TODO: Temporary fix to make openImmediately work with popover.
	        /* eslint-disable react/no-did-mount-set-state */
	        setTimeout(function () {
	          return _this2.setState({ open: true, anchorEl: _this2.refs.root });
	        });
	        setTimeout(function () {
	          return _this2.setState({
	            open: true,
	            anchorEl: _this2.refs.root
	          });
	        }, 0);
	        /* eslint-enable react/no-did-mount-set-state */
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps() {
	      if (this.props.autoWidth) {
	        this.setWidth();
	      }
	    }
	
	    /**
	     * This method is deprecated but still here because the TextField
	     * need it in order to work. TODO: That will be addressed later.
	     */
	
	  }, {
	    key: 'getInputNode',
	    value: function getInputNode() {
	      var _this3 = this;
	
	      var root = this.refs.root;
	
	      root.focus = function () {
	        if (!_this3.props.disabled) {
	          _this3.setState({
	            open: !_this3.state.open,
	            anchorEl: _this3.refs.root
	          });
	        }
	      };
	
	      return root;
	    }
	  }, {
	    key: 'setWidth',
	    value: function setWidth() {
	      var el = this.refs.root;
	      if (!this.props.style || !this.props.style.hasOwnProperty('width')) {
	        el.style.width = 'auto';
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var animated = _props.animated;
	      var animation = _props.animation;
	      var autoWidth = _props.autoWidth;
	      var children = _props.children;
	      var className = _props.className;
	      var iconStyle = _props.iconStyle;
	      var labelStyle = _props.labelStyle;
	      var listStyle = _props.listStyle;
	      var maxHeight = _props.maxHeight;
	      var menuStyleProp = _props.menuStyle;
	      var openImmediately = _props.openImmediately;
	      var style = _props.style;
	      var underlineStyle = _props.underlineStyle;
	      var value = _props.value;
	
	      var other = _objectWithoutProperties(_props, ['animated', 'animation', 'autoWidth', 'children', 'className', 'iconStyle', 'labelStyle', 'listStyle', 'maxHeight', 'menuStyle', 'openImmediately', 'style', 'underlineStyle', 'value']);
	
	      var _state = this.state;
	      var anchorEl = _state.anchorEl;
	      var open = _state.open;
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      var displayValue = '';
	      _react2.default.Children.forEach(children, function (child) {
	        if (value === child.props.value) {
	          // This will need to be improved (in case primaryText is a node)
	          displayValue = child.props.label || child.props.primaryText;
	        }
	      });
	
	      var menuStyle = void 0;
	      if (anchorEl && !autoWidth) {
	        menuStyle = (0, _simpleAssign2.default)({
	          width: anchorEl.clientWidth
	        }, menuStyleProp);
	      } else {
	        menuStyle = menuStyleProp;
	      }
	
	      return _react2.default.createElement(
	        'div',
	        _extends({}, other, {
	          ref: 'root',
	          className: className,
	          style: prepareStyles((0, _simpleAssign2.default)({}, styles.root, open && styles.rootWhenOpen, style))
	        }),
	        _react2.default.createElement(
	          _ClearFix2.default,
	          { style: styles.control, onTouchTap: this.handleTouchTapControl },
	          _react2.default.createElement(
	            'div',
	            {
	              style: prepareStyles((0, _simpleAssign2.default)({}, styles.label, open && styles.labelWhenOpen, labelStyle))
	            },
	            displayValue
	          ),
	          _react2.default.createElement(_arrowDropDown2.default, { style: (0, _simpleAssign2.default)({}, styles.icon, iconStyle) }),
	          _react2.default.createElement('div', { style: prepareStyles((0, _simpleAssign2.default)({}, styles.underline, underlineStyle)) })
	        ),
	        _react2.default.createElement(
	          _Popover2.default,
	          {
	            anchorOrigin: anchorOrigin,
	            anchorEl: anchorEl,
	            animation: animation || _PopoverAnimationVertical2.default,
	            open: open,
	            animated: animated,
	            onRequestClose: this.handleRequestCloseMenu
	          },
	          _react2.default.createElement(
	            _Menu2.default,
	            {
	              maxHeight: maxHeight,
	              desktop: true,
	              value: value,
	              style: menuStyle,
	              listStyle: listStyle,
	              onItemTouchTap: this.handleItemTouchTap
	            },
	            children
	          )
	        )
	      );
	    }
	  }]);
	
	  return DropDownMenu;
	}(_react.Component);
	
	DropDownMenu.muiName = 'DropDownMenu';
	DropDownMenu.propTypes = {
	  /**
	   * If true, the popover will apply transitions when
	   * it gets added to the DOM.
	   */
	  animated: _react.PropTypes.bool,
	  /**
	   * Override the default animation component used.
	   */
	  animation: _react.PropTypes.func,
	  /**
	   * The width will automatically be set according to the items inside the menu.
	   * To control this width in css instead, set this prop to `false`.
	   */
	  autoWidth: _react.PropTypes.bool,
	  /**
	   * The `MenuItem`s to populate the `Menu` with. If the `MenuItems` have the
	   * prop `label` that value will be used to render the representation of that
	   * item within the field.
	   */
	  children: _react.PropTypes.node,
	  /**
	   * The css class name of the root element.
	   */
	  className: _react.PropTypes.string,
	  /**
	   * Disables the menu.
	   */
	  disabled: _react.PropTypes.bool,
	  /**
	   * Overrides the styles of icon element.
	   */
	  iconStyle: _react.PropTypes.object,
	  /**
	   * Overrides the styles of label when the `DropDownMenu` is inactive.
	   */
	  labelStyle: _react.PropTypes.object,
	  /**
	   * The style object to use to override underlying list style.
	   */
	  listStyle: _react.PropTypes.object,
	  /**
	   * The maximum height of the `Menu` when it is displayed.
	   */
	  maxHeight: _react.PropTypes.number,
	  /**
	   * Overrides the styles of `Menu` when the `DropDownMenu` is displayed.
	   */
	  menuStyle: _react.PropTypes.object,
	  /**
	   * Callback function fired when a menu item is clicked, other than the one currently selected.
	   *
	   * @param {object} event TouchTap event targeting the menu item that was clicked.
	   * @param {number} key The index of the clicked menu item in the `children` collection.
	   * @param {any} payload The `value` prop of the clicked menu item.
	   */
	  onChange: _react.PropTypes.func,
	  /**
	   * Set to true to have the `DropDownMenu` automatically open on mount.
	   */
	  openImmediately: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object,
	  /**
	   * Overrides the inline-styles of the underline.
	   */
	  underlineStyle: _react.PropTypes.object,
	  /**
	   * The value that is currently selected.
	   */
	  value: _react.PropTypes.any
	};
	DropDownMenu.defaultProps = {
	  animated: true,
	  autoWidth: true,
	  disabled: false,
	  openImmediately: false,
	  maxHeight: 500
	};
	DropDownMenu.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	exports.default = DropDownMenu;

/***/ }),
/* 716 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(608);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(615);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NavigationArrowDropDown = function NavigationArrowDropDown(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M7 10l5 5 5-5z' })
	  );
	};
	NavigationArrowDropDown = (0, _pure2.default)(NavigationArrowDropDown);
	NavigationArrowDropDown.displayName = 'NavigationArrowDropDown';
	NavigationArrowDropDown.muiName = 'SvgIcon';
	
	exports.default = NavigationArrowDropDown;

/***/ }),
/* 717 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _BeforeAfterWrapper = __webpack_require__(718);
	
	var _BeforeAfterWrapper2 = _interopRequireDefault(_BeforeAfterWrapper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var styles = {
	  before: {
	    content: "' '",
	    display: 'table'
	  },
	  after: {
	    content: "' '",
	    clear: 'both',
	    display: 'table'
	  }
	};
	
	var ClearFix = function ClearFix(_ref) {
	  var style = _ref.style;
	  var children = _ref.children;
	
	  var other = _objectWithoutProperties(_ref, ['style', 'children']);
	
	  return _react2.default.createElement(
	    _BeforeAfterWrapper2.default,
	    _extends({}, other, {
	      beforeStyle: styles.before,
	      afterStyle: styles.after,
	      style: style
	    }),
	    children
	  );
	};
	
	ClearFix.muiName = 'ClearFix';
	
	ClearFix.propTypes = {
	  children: _react.PropTypes.node,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object
	};
	
	exports.default = ClearFix;

/***/ }),
/* 718 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _simpleAssign = __webpack_require__(579);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 *  BeforeAfterWrapper
	 *    An alternative for the ::before and ::after css pseudo-elements for
	 *    components whose styles are defined in javascript instead of css.
	 *
	 *  Usage: For the element that we want to apply before and after elements to,
	 *    wrap its children with BeforeAfterWrapper. For example:
	 *
	 *                                            <Paper>
	 *  <Paper>                                     <div> // See notice
	 *    <BeforeAfterWrapper>        renders         <div/> // before element
	 *      [children of paper]       ------>         [children of paper]
	 *    </BeforeAfterWrapper>                       <div/> // after element
	 *  </Paper>                                    </div>
	 *                                            </Paper>
	 *
	 *  Notice: Notice that this div bundles together our elements. If the element
	 *    that we want to apply before and after elements is a HTML tag (i.e. a
	 *    div, p, or button tag), we can avoid this extra nesting by passing using
	 *    the BeforeAfterWrapper in place of said tag like so:
	 *
	 *  <p>
	 *    <BeforeAfterWrapper>   do this instead   <BeforeAfterWrapper elementType='p'>
	 *      [children of p]          ------>         [children of p]
	 *    </BeforeAfterWrapper>                    </BeforeAfterWrapper>
	 *  </p>
	 *
	 *  BeforeAfterWrapper features spread functionality. This means that we can
	 *  pass HTML tag properties directly into the BeforeAfterWrapper tag.
	 *
	 *  When using BeforeAfterWrapper, ensure that the parent of the beforeElement
	 *  and afterElement have a defined style position.
	 */
	
	var styles = {
	  box: {
	    boxSizing: 'border-box'
	  }
	};
	
	var BeforeAfterWrapper = function (_Component) {
	  _inherits(BeforeAfterWrapper, _Component);
	
	  function BeforeAfterWrapper() {
	    _classCallCheck(this, BeforeAfterWrapper);
	
	    return _possibleConstructorReturn(this, Object.getPrototypeOf(BeforeAfterWrapper).apply(this, arguments));
	  }
	
	  _createClass(BeforeAfterWrapper, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var beforeStyle = _props.beforeStyle;
	      var afterStyle = _props.afterStyle;
	      var beforeElementType = _props.beforeElementType;
	      var afterElementType = _props.afterElementType;
	      var elementType = _props.elementType;
	
	      var other = _objectWithoutProperties(_props, ['beforeStyle', 'afterStyle', 'beforeElementType', 'afterElementType', 'elementType']);
	
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	
	      var beforeElement = void 0;
	      var afterElement = void 0;
	
	      if (beforeStyle) {
	        beforeElement = _react2.default.createElement(this.props.beforeElementType, {
	          style: prepareStyles((0, _simpleAssign2.default)({}, styles.box, beforeStyle)),
	          key: '::before'
	        });
	      }
	
	      if (afterStyle) {
	        afterElement = _react2.default.createElement(this.props.afterElementType, {
	          style: prepareStyles((0, _simpleAssign2.default)({}, styles.box, afterStyle)),
	          key: '::after'
	        });
	      }
	
	      var children = [beforeElement, this.props.children, afterElement];
	
	      var props = other;
	      props.style = prepareStyles((0, _simpleAssign2.default)({}, this.props.style));
	
	      return _react2.default.createElement(this.props.elementType, props, children);
	    }
	  }]);
	
	  return BeforeAfterWrapper;
	}(_react.Component);
	
	BeforeAfterWrapper.propTypes = {
	  afterElementType: _react.PropTypes.string,
	  afterStyle: _react.PropTypes.object,
	  beforeElementType: _react.PropTypes.string,
	  beforeStyle: _react.PropTypes.object,
	  children: _react.PropTypes.node,
	  elementType: _react.PropTypes.string,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object
	};
	BeforeAfterWrapper.defaultProps = {
	  beforeElementType: 'div',
	  afterElementType: 'div',
	  elementType: 'div'
	};
	BeforeAfterWrapper.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	exports.default = BeforeAfterWrapper;

/***/ }),
/* 719 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _FloatingActionButton = __webpack_require__(720);
	
	var _FloatingActionButton2 = _interopRequireDefault(_FloatingActionButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _FloatingActionButton2.default;

/***/ }),
/* 720 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _simpleAssign = __webpack_require__(579);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _transitions = __webpack_require__(582);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _colorManipulator = __webpack_require__(623);
	
	var _EnhancedButton = __webpack_require__(584);
	
	var _EnhancedButton2 = _interopRequireDefault(_EnhancedButton);
	
	var _FontIcon = __webpack_require__(604);
	
	var _FontIcon2 = _interopRequireDefault(_FontIcon);
	
	var _Paper = __webpack_require__(617);
	
	var _Paper2 = _interopRequireDefault(_Paper);
	
	var _childUtils = __webpack_require__(585);
	
	var _warning = __webpack_require__(491);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _propTypes = __webpack_require__(583);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function getStyles(props, context) {
	  var floatingActionButton = context.muiTheme.floatingActionButton;
	
	
	  var backgroundColor = props.backgroundColor || floatingActionButton.color;
	  var iconColor = floatingActionButton.iconColor;
	
	  if (props.disabled) {
	    backgroundColor = props.disabledColor || floatingActionButton.disabledColor;
	    iconColor = floatingActionButton.disabledTextColor;
	  } else if (props.secondary) {
	    backgroundColor = floatingActionButton.secondaryColor;
	    iconColor = floatingActionButton.secondaryIconColor;
	  }
	
	  return {
	    root: {
	      transition: _transitions2.default.easeOut(),
	      display: 'inline-block'
	    },
	    container: {
	      backgroundColor: backgroundColor,
	      transition: _transitions2.default.easeOut(),
	      position: 'relative',
	      height: floatingActionButton.buttonSize,
	      width: floatingActionButton.buttonSize,
	      padding: 0,
	      overflow: 'hidden',
	      borderRadius: '50%',
	      textAlign: 'center',
	      verticalAlign: 'bottom'
	    },
	    containerWhenMini: {
	      height: floatingActionButton.miniSize,
	      width: floatingActionButton.miniSize
	    },
	    overlay: {
	      transition: _transitions2.default.easeOut(),
	      top: 0
	    },
	    overlayWhenHovered: {
	      backgroundColor: (0, _colorManipulator.fade)(iconColor, 0.4)
	    },
	    icon: {
	      height: floatingActionButton.buttonSize,
	      lineHeight: floatingActionButton.buttonSize + 'px',
	      fill: iconColor,
	      color: iconColor
	    },
	    iconWhenMini: {
	      height: floatingActionButton.miniSize,
	      lineHeight: floatingActionButton.miniSize + 'px'
	    }
	  };
	}
	
	var FloatingActionButton = function (_Component) {
	  _inherits(FloatingActionButton, _Component);
	
	  function FloatingActionButton() {
	    var _Object$getPrototypeO;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, FloatingActionButton);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_Object$getPrototypeO = Object.getPrototypeOf(FloatingActionButton)).call.apply(_Object$getPrototypeO, [this].concat(args))), _this), _this.state = {
	      hovered: false,
	      touch: false,
	      zDepth: undefined
	    }, _this.handleMouseDown = function (event) {
	      // only listen to left clicks
	      if (event.button === 0) {
	        _this.setState({ zDepth: _this.props.zDepth + 1 });
	      }
	      if (_this.props.onMouseDown) _this.props.onMouseDown(event);
	    }, _this.handleMouseUp = function (event) {
	      _this.setState({ zDepth: _this.props.zDepth });
	      if (_this.props.onMouseUp) {
	        _this.props.onMouseUp(event);
	      }
	    }, _this.handleMouseLeave = function (event) {
	      if (!_this.refs.container.isKeyboardFocused()) {
	        _this.setState({ zDepth: _this.props.zDepth, hovered: false });
	      }
	      if (_this.props.onMouseLeave) {
	        _this.props.onMouseLeave(event);
	      }
	    }, _this.handleMouseEnter = function (event) {
	      if (!_this.refs.container.isKeyboardFocused() && !_this.state.touch) {
	        _this.setState({ hovered: true });
	      }
	      if (_this.props.onMouseEnter) {
	        _this.props.onMouseEnter(event);
	      }
	    }, _this.handleTouchStart = function (event) {
	      _this.setState({
	        touch: true,
	        zDepth: _this.props.zDepth + 1
	      });
	      if (_this.props.onTouchStart) {
	        _this.props.onTouchStart(event);
	      }
	    }, _this.handleTouchEnd = function (event) {
	      _this.setState({ zDepth: _this.props.zDepth });
	      if (_this.props.onTouchEnd) {
	        _this.props.onTouchEnd(event);
	      }
	    }, _this.handleKeyboardFocus = function (event, keyboardFocused) {
	      if (keyboardFocused && !_this.props.disabled) {
	        _this.setState({ zDepth: _this.props.zDepth + 1 });
	        _this.refs.overlay.style.backgroundColor = (0, _colorManipulator.fade)(getStyles(_this.props, _this.context).icon.color, 0.4);
	      } else if (!_this.state.hovered) {
	        _this.setState({ zDepth: _this.props.zDepth });
	        _this.refs.overlay.style.backgroundColor = 'transparent';
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(FloatingActionButton, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.setState({
	        zDepth: this.props.disabled ? 0 : this.props.zDepth
	      });
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	       false ? (0, _warning2.default)(!this.props.iconClassName || !this.props.children, 'You have set both an iconClassName and a child icon. ' + 'It is recommended you use only one method when adding ' + 'icons to FloatingActionButtons.') : void 0;
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.disabled !== this.props.disabled) {
	        this.setState({
	          zDepth: nextProps.disabled ? 0 : this.props.zDepth
	        });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var backgroundColor = _props.backgroundColor;
	      var className = _props.className;
	      var disabled = _props.disabled;
	      var mini = _props.mini;
	      var secondary = _props.secondary;
	      var iconStyle = _props.iconStyle;
	      var iconClassName = _props.iconClassName;
	      var zDepth = _props.zDepth;
	
	      var other = _objectWithoutProperties(_props, ['backgroundColor', 'className', 'disabled', 'mini', 'secondary', 'iconStyle', 'iconClassName', 'zDepth']);
	
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      var iconElement = void 0;
	      if (iconClassName) {
	        iconElement = _react2.default.createElement(_FontIcon2.default, {
	          className: iconClassName,
	          style: (0, _simpleAssign2.default)({}, styles.icon, mini && styles.iconWhenMini, iconStyle)
	        });
	      }
	
	      var children = (0, _childUtils.extendChildren)(this.props.children, {
	        style: (0, _simpleAssign2.default)({}, styles.icon, mini && styles.iconWhenMini, iconStyle)
	      });
	
	      var buttonEventHandlers = disabled ? null : {
	        onMouseDown: this.handleMouseDown,
	        onMouseUp: this.handleMouseUp,
	        onMouseLeave: this.handleMouseLeave,
	        onMouseEnter: this.handleMouseEnter,
	        onTouchStart: this.handleTouchStart,
	        onTouchEnd: this.handleTouchEnd,
	        onKeyboardFocus: this.handleKeyboardFocus
	      };
	
	      return _react2.default.createElement(
	        _Paper2.default,
	        {
	          className: className,
	          style: (0, _simpleAssign2.default)(styles.root, this.props.style),
	          zDepth: this.state.zDepth,
	          circle: true
	        },
	        _react2.default.createElement(
	          _EnhancedButton2.default,
	          _extends({}, other, buttonEventHandlers, {
	            ref: 'container',
	            disabled: disabled,
	            style: (0, _simpleAssign2.default)(styles.container, this.props.mini && styles.containerWhenMini, iconStyle),
	            focusRippleColor: styles.icon.color,
	            touchRippleColor: styles.icon.color
	          }),
	          _react2.default.createElement(
	            'div',
	            {
	              ref: 'overlay',
	              style: prepareStyles((0, _simpleAssign2.default)(styles.overlay, this.state.hovered && !this.props.disabled && styles.overlayWhenHovered))
	            },
	            iconElement,
	            children
	          )
	        )
	      );
	    }
	  }]);
	
	  return FloatingActionButton;
	}(_react.Component);
	
	FloatingActionButton.propTypes = {
	  /**
	   * This value will override the default background color for the button.
	   * However it will not override the default disabled background color.
	   * This has to be set separately using the disabledColor attribute.
	   */
	  backgroundColor: _react.PropTypes.string,
	  /**
	   * This is what displayed inside the floating action button; for example, a SVG Icon.
	   */
	  children: _react.PropTypes.node,
	  /**
	   * The css class name of the root element.
	   */
	  className: _react.PropTypes.string,
	  /**
	   * Disables the button if set to true.
	   */
	  disabled: _react.PropTypes.bool,
	  /**
	   * This value will override the default background color for the button when it is disabled.
	   */
	  disabledColor: _react.PropTypes.string,
	  /**
	   * The URL to link to when the button is clicked.
	   */
	  href: _react.PropTypes.string,
	  /**
	   * The icon within the FloatingActionButton is a FontIcon component.
	   * This property is the classname of the icon to be displayed inside the button.
	   * An alternative to adding an iconClassName would be to manually insert a
	   * FontIcon component or custom SvgIcon component or as a child of FloatingActionButton.
	   */
	  iconClassName: _react.PropTypes.string,
	  /**
	   * This is the equivalent to iconClassName except that it is used for
	   * overriding the inline-styles of the FontIcon component.
	   */
	  iconStyle: _react.PropTypes.object,
	  /**
	   * If true, the button will be a small floating action button.
	   */
	  mini: _react.PropTypes.bool,
	  /** @ignore */
	  onMouseDown: _react.PropTypes.func,
	  /** @ignore */
	  onMouseEnter: _react.PropTypes.func,
	  /** @ignore */
	  onMouseLeave: _react.PropTypes.func,
	  /** @ignore */
	  onMouseUp: _react.PropTypes.func,
	  /** @ignore */
	  onTouchEnd: _react.PropTypes.func,
	  /** @ignore */
	  onTouchStart: _react.PropTypes.func,
	  /**
	   * If true, the button will use the secondary button colors.
	   */
	  secondary: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object,
	  /**
	   * The zDepth of the underlying `Paper` component.
	   */
	  zDepth: _propTypes2.default.zDepth
	};
	FloatingActionButton.defaultProps = {
	  disabled: false,
	  mini: false,
	  secondary: false,
	  zDepth: 2
	};
	FloatingActionButton.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	exports.default = FloatingActionButton;

/***/ }),
/* 721 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.GridTile = exports.GridList = undefined;
	
	var _GridList2 = __webpack_require__(722);
	
	var _GridList3 = _interopRequireDefault(_GridList2);
	
	var _GridTile2 = __webpack_require__(723);
	
	var _GridTile3 = _interopRequireDefault(_GridTile2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.GridList = _GridList3.default;
	exports.GridTile = _GridTile3.default;
	exports.default = _GridList3.default;

/***/ }),
/* 722 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _simpleAssign = __webpack_require__(579);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function getStyles(props) {
	  return {
	    root: {
	      display: 'flex',
	      flexWrap: 'wrap',
	      margin: -props.padding / 2
	    },
	    item: {
	      boxSizing: 'border-box',
	      padding: props.padding / 2
	    }
	  };
	}
	
	var GridList = function (_Component) {
	  _inherits(GridList, _Component);
	
	  function GridList() {
	    _classCallCheck(this, GridList);
	
	    return _possibleConstructorReturn(this, Object.getPrototypeOf(GridList).apply(this, arguments));
	  }
	
	  _createClass(GridList, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var cols = _props.cols;
	      var padding = _props.padding;
	      var cellHeight = _props.cellHeight;
	      var children = _props.children;
	      var style = _props.style;
	
	      var other = _objectWithoutProperties(_props, ['cols', 'padding', 'cellHeight', 'children', 'style']);
	
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	      var mergedRootStyles = (0, _simpleAssign2.default)(styles.root, style);
	
	      var wrappedChildren = _react2.default.Children.map(children, function (currentChild) {
	        if (_react2.default.isValidElement(currentChild) && currentChild.type.muiName === 'Subheader') {
	          return currentChild;
	        }
	        var childCols = currentChild.props.cols || 1;
	        var childRows = currentChild.props.rows || 1;
	        var itemStyle = (0, _simpleAssign2.default)({}, styles.item, {
	          width: 100 / cols * childCols + '%',
	          height: cellHeight * childRows + padding
	        });
	
	        return _react2.default.createElement(
	          'div',
	          { style: prepareStyles(itemStyle) },
	          currentChild
	        );
	      });
	
	      return _react2.default.createElement(
	        'div',
	        _extends({ style: prepareStyles(mergedRootStyles) }, other),
	        wrappedChildren
	      );
	    }
	  }]);
	
	  return GridList;
	}(_react.Component);
	
	GridList.propTypes = {
	  /**
	   * Number of px for one cell height.
	   */
	  cellHeight: _react.PropTypes.number,
	  /**
	   * Grid Tiles that will be in Grid List.
	   */
	  children: _react.PropTypes.node,
	  /**
	   * Number of columns.
	   */
	  cols: _react.PropTypes.number,
	  /**
	   * Number of px for the padding/spacing between items.
	   */
	  padding: _react.PropTypes.number,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object
	};
	GridList.defaultProps = {
	  cols: 2,
	  padding: 4,
	  cellHeight: 180
	};
	GridList.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	exports.default = GridList;

/***/ }),
/* 723 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _simpleAssign = __webpack_require__(579);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function getStyles(props, context) {
	  var _titleBar;
	
	  var _context$muiTheme = context.muiTheme;
	  var baseTheme = _context$muiTheme.baseTheme;
	  var gridTile = _context$muiTheme.gridTile;
	
	
	  var actionPos = props.actionIcon && props.actionPosition;
	
	  var styles = {
	    root: {
	      position: 'relative',
	      display: 'block',
	      height: '100%',
	      overflow: 'hidden'
	    },
	    titleBar: (_titleBar = {
	      position: 'absolute',
	      left: 0,
	      right: 0
	    }, _defineProperty(_titleBar, props.titlePosition, 0), _defineProperty(_titleBar, 'height', props.subtitle ? 68 : 48), _defineProperty(_titleBar, 'background', props.titleBackground), _defineProperty(_titleBar, 'display', 'flex'), _defineProperty(_titleBar, 'alignItems', 'center'), _titleBar),
	    titleWrap: {
	      flexGrow: 1,
	      marginLeft: actionPos !== 'left' ? baseTheme.spacing.desktopGutterLess : 0,
	      marginRight: actionPos === 'left' ? baseTheme.spacing.desktopGutterLess : 0,
	      color: gridTile.textColor,
	      overflow: 'hidden'
	    },
	    title: {
	      fontSize: '16px',
	      textOverflow: 'ellipsis',
	      overflow: 'hidden',
	      whiteSpace: 'nowrap'
	    },
	    subtitle: {
	      fontSize: '12px',
	      textOverflow: 'ellipsis',
	      overflow: 'hidden',
	      whiteSpace: 'nowrap'
	    },
	    actionIcon: {
	      order: actionPos === 'left' ? -1 : 1
	    },
	    childImg: {
	      height: '100%',
	      transform: 'translateX(-50%)',
	      position: 'relative',
	      left: '50%'
	    }
	  };
	  return styles;
	}
	
	var GridTile = function (_Component) {
	  _inherits(GridTile, _Component);
	
	  function GridTile() {
	    _classCallCheck(this, GridTile);
	
	    return _possibleConstructorReturn(this, Object.getPrototypeOf(GridTile).apply(this, arguments));
	  }
	
	  _createClass(GridTile, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.ensureImageCover();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this.ensureImageCover();
	    }
	  }, {
	    key: 'ensureImageCover',
	    value: function ensureImageCover() {
	      var _this2 = this;
	
	      var imgEl = this.refs.img;
	
	      if (imgEl) {
	        (function () {
	          var fit = function fit() {
	            if (imgEl.offsetWidth < imgEl.parentNode.offsetWidth) {
	              var isRtl = _this2.context.muiTheme.isRtl;
	
	              imgEl.style.height = 'auto';
	              if (isRtl) {
	                imgEl.style.right = '0';
	              } else {
	                imgEl.style.left = '0';
	              }
	              imgEl.style.width = '100%';
	              imgEl.style.top = '50%';
	              imgEl.style.transform = imgEl.style.WebkitTransform = 'translateY(-50%)';
	            }
	            imgEl.removeEventListener('load', fit);
	            imgEl = null; // prevent closure memory leak
	          };
	          if (imgEl.complete) {
	            fit();
	          } else {
	            imgEl.addEventListener('load', fit);
	          }
	        })();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var title = _props.title;
	      var subtitle = _props.subtitle;
	      var titlePosition = _props.titlePosition;
	      var titleBackground = _props.titleBackground;
	      var actionIcon = _props.actionIcon;
	      var actionPosition = _props.actionPosition;
	      var style = _props.style;
	      var children = _props.children;
	      var containerElement = _props.containerElement;
	
	      var other = _objectWithoutProperties(_props, ['title', 'subtitle', 'titlePosition', 'titleBackground', 'actionIcon', 'actionPosition', 'style', 'children', 'containerElement']);
	
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	      var mergedRootStyles = (0, _simpleAssign2.default)(styles.root, style);
	
	      var titleBar = null;
	
	      if (title) {
	        titleBar = _react2.default.createElement(
	          'div',
	          { key: 'titlebar', style: prepareStyles(styles.titleBar) },
	          _react2.default.createElement(
	            'div',
	            { style: prepareStyles(styles.titleWrap) },
	            _react2.default.createElement(
	              'div',
	              { style: prepareStyles(styles.title) },
	              title
	            ),
	            subtitle ? _react2.default.createElement(
	              'div',
	              { style: prepareStyles(styles.subtitle) },
	              subtitle
	            ) : null
	          ),
	          actionIcon ? _react2.default.createElement(
	            'div',
	            { style: prepareStyles(styles.actionIcon) },
	            actionIcon
	          ) : null
	        );
	      }
	
	      var newChildren = children;
	
	      // if there is a single image passed as children
	      // clone it and add our styles
	      if (_react2.default.Children.count(children) === 1) {
	        newChildren = _react2.default.Children.map(children, function (child) {
	          if (child.type === 'img') {
	            return _react2.default.cloneElement(child, {
	              key: 'img',
	              ref: 'img',
	              style: prepareStyles((0, _simpleAssign2.default)({}, styles.childImg, child.props.style))
	            });
	          } else {
	            return child;
	          }
	        });
	      }
	
	      var containerProps = _extends({
	        style: prepareStyles(mergedRootStyles)
	      }, other);
	
	      return _react2.default.isValidElement(containerElement) ? _react2.default.cloneElement(containerElement, containerProps, [newChildren, titleBar]) : _react2.default.createElement(containerElement, containerProps, [newChildren, titleBar]);
	    }
	  }]);
	
	  return GridTile;
	}(_react.Component);
	
	GridTile.propTypes = {
	  /**
	   * An IconButton element to be used as secondary action target
	   * (primary action target is the tile itself).
	   */
	  actionIcon: _react.PropTypes.element,
	  /**
	   * Position of secondary action IconButton.
	   */
	  actionPosition: _react.PropTypes.oneOf(['left', 'right']),
	  /**
	   * Theoretically you can pass any node as children, but the main use case is to pass an img,
	   * in whichcase GridTile takes care of making the image "cover" available space
	   * (similar to background-size: cover or to object-fit:cover).
	   */
	  children: _react.PropTypes.node,
	  /**
	   * Width of the tile in number of grid cells.
	   */
	  cols: _react.PropTypes.number,
	  /**
	   * Either a string used as tag name for the tile root element, or a ReactElement.
	   * This is useful when you have, for example, a custom implementation of
	   * a navigation link (that knows about your routes) and you want to use it as the primary tile action.
	   * In case you pass a ReactElement, please ensure that it passes all props,
	   * accepts styles overrides and render it's children.
	   */
	  containerElement: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.element]),
	  /**
	   * Height of the tile in number of grid cells.
	   */
	  rows: _react.PropTypes.number,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object,
	  /**
	   * String or element serving as subtitle (support text).
	   */
	  subtitle: _react.PropTypes.node,
	  /**
	   * Title to be displayed on tile.
	   */
	  title: _react.PropTypes.node,
	  /**
	   * Style used for title bar background.
	   * Useful for setting custom gradients for example
	   */
	  titleBackground: _react.PropTypes.string,
	  /**
	   * Position of the title bar (container of title, subtitle and action icon).
	   */
	  titlePosition: _react.PropTypes.oneOf(['top', 'bottom'])
	};
	GridTile.defaultProps = {
	  titlePosition: 'bottom',
	  titleBackground: 'rgba(0, 0, 0, 0.4)',
	  actionPosition: 'right',
	  cols: 1,
	  rows: 1,
	  containerElement: 'div'
	};
	GridTile.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	exports.default = GridTile;

/***/ }),
/* 724 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.MenuItem = exports.IconMenu = undefined;
	
	var _IconMenu2 = __webpack_require__(725);
	
	var _IconMenu3 = _interopRequireDefault(_IconMenu2);
	
	var _MenuItem2 = __webpack_require__(638);
	
	var _MenuItem3 = _interopRequireDefault(_MenuItem2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.IconMenu = _IconMenu3.default;
	exports.MenuItem = _MenuItem3.default;
	exports.default = _IconMenu3.default;

/***/ }),
/* 725 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _simpleAssign = __webpack_require__(579);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(332);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _events = __webpack_require__(588);
	
	var _events2 = _interopRequireDefault(_events);
	
	var _propTypes = __webpack_require__(583);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Menu = __webpack_require__(631);
	
	var _Menu2 = _interopRequireDefault(_Menu);
	
	var _Popover = __webpack_require__(639);
	
	var _Popover2 = _interopRequireDefault(_Popover);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var IconMenu = function (_Component) {
	  _inherits(IconMenu, _Component);
	
	  function IconMenu() {
	    var _Object$getPrototypeO;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, IconMenu);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_Object$getPrototypeO = Object.getPrototypeOf(IconMenu)).call.apply(_Object$getPrototypeO, [this].concat(args))), _this), _this.state = {
	      menuInitiallyKeyboardFocused: false,
	      open: false
	    }, _this.handleItemTouchTap = function (event, child) {
	      if (_this.props.touchTapCloseDelay !== 0 && !child.props.hasOwnProperty('menuItems')) {
	        (function () {
	          var isKeyboard = _events2.default.isKeyboard(event);
	          _this.timerCloseId = setTimeout(function () {
	            _this.close(isKeyboard ? 'enter' : 'itemTap', isKeyboard);
	          }, _this.props.touchTapCloseDelay);
	        })();
	      }
	
	      _this.props.onItemTouchTap(event, child);
	    }, _this.handleRequestClose = function (reason) {
	      _this.close(reason);
	    }, _this.handleEscKeyDownMenu = function (event) {
	      _this.close('escape', event);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(IconMenu, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.open != null) {
	        this.setState({
	          open: nextProps.open,
	          anchorEl: this.refs.iconMenuContainer
	        });
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      clearTimeout(this.timerCloseId);
	    }
	  }, {
	    key: 'isOpen',
	    value: function isOpen() {
	      return this.state.open;
	    }
	  }, {
	    key: 'close',
	    value: function close(reason, isKeyboard) {
	      var _this2 = this;
	
	      if (!this.state.open) {
	        return;
	      }
	
	      if (this.props.open !== null) {
	        this.props.onRequestChange(false, reason);
	      }
	
	      this.setState({ open: false }, function () {
	        // Set focus on the icon button when the menu close
	        if (isKeyboard) {
	          var iconButton = _this2.refs.iconButton;
	          _reactDom2.default.findDOMNode(iconButton).focus();
	          iconButton.setKeyboardFocus();
	        }
	      });
	    }
	  }, {
	    key: 'open',
	    value: function open(reason, event) {
	      if (this.props.open !== null) {
	        this.props.onRequestChange(true, reason);
	
	        return this.setState({
	          menuInitiallyKeyboardFocused: _events2.default.isKeyboard(event),
	          anchorEl: event.currentTarget
	        });
	      }
	
	      this.setState({
	        open: true,
	        menuInitiallyKeyboardFocused: _events2.default.isKeyboard(event),
	        anchorEl: event.currentTarget
	      });
	
	      event.preventDefault();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _props = this.props;
	      var anchorOrigin = _props.anchorOrigin;
	      var className = _props.className;
	      var animated = _props.animated;
	      var animation = _props.animation;
	      var iconButtonElement = _props.iconButtonElement;
	      var iconStyle = _props.iconStyle;
	      var onItemTouchTap = _props.onItemTouchTap;
	      var onKeyboardFocus = _props.onKeyboardFocus;
	      var onMouseDown = _props.onMouseDown;
	      var onMouseLeave = _props.onMouseLeave;
	      var onMouseEnter = _props.onMouseEnter;
	      var onMouseUp = _props.onMouseUp;
	      var onRequestChange = _props.onRequestChange;
	      var onTouchTap = _props.onTouchTap;
	      var menuStyle = _props.menuStyle;
	      var style = _props.style;
	      var targetOrigin = _props.targetOrigin;
	      var touchTapCloseDelay = _props.touchTapCloseDelay;
	      var useLayerForClickAway = _props.useLayerForClickAway;
	
	      var other = _objectWithoutProperties(_props, ['anchorOrigin', 'className', 'animated', 'animation', 'iconButtonElement', 'iconStyle', 'onItemTouchTap', 'onKeyboardFocus', 'onMouseDown', 'onMouseLeave', 'onMouseEnter', 'onMouseUp', 'onRequestChange', 'onTouchTap', 'menuStyle', 'style', 'targetOrigin', 'touchTapCloseDelay', 'useLayerForClickAway']);
	
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	      var _state = this.state;
	      var open = _state.open;
	      var anchorEl = _state.anchorEl;
	
	
	      var styles = {
	        root: {
	          display: 'inline-block',
	          position: 'relative'
	        },
	        menu: {
	          position: 'relative'
	        }
	      };
	
	      var mergedRootStyles = (0, _simpleAssign2.default)(styles.root, style);
	      var mergedMenuStyles = (0, _simpleAssign2.default)(styles.menu, menuStyle);
	
	      var iconButton = _react2.default.cloneElement(iconButtonElement, {
	        onKeyboardFocus: onKeyboardFocus,
	        iconStyle: (0, _simpleAssign2.default)({}, iconStyle, iconButtonElement.props.iconStyle),
	        onTouchTap: function onTouchTap(event) {
	          _this3.open(_events2.default.isKeyboard(event) ? 'keyboard' : 'iconTap', event);
	          if (iconButtonElement.props.onTouchTap) {
	            iconButtonElement.props.onTouchTap(event);
	          }
	        },
	        ref: 'iconButton'
	      });
	
	      var menu = _react2.default.createElement(
	        _Menu2.default,
	        _extends({}, other, {
	          initiallyKeyboardFocused: this.state.menuInitiallyKeyboardFocused,
	          onEscKeyDown: this.handleEscKeyDownMenu,
	          onItemTouchTap: this.handleItemTouchTap,
	          style: mergedMenuStyles
	        }),
	        this.props.children
	      );
	
	      return _react2.default.createElement(
	        'div',
	        {
	          ref: 'iconMenuContainer',
	          className: className,
	          onMouseDown: onMouseDown,
	          onMouseLeave: onMouseLeave,
	          onMouseEnter: onMouseEnter,
	          onMouseUp: onMouseUp,
	          onTouchTap: onTouchTap,
	          style: prepareStyles(mergedRootStyles)
	        },
	        iconButton,
	        _react2.default.createElement(
	          _Popover2.default,
	          {
	            anchorOrigin: anchorOrigin,
	            targetOrigin: targetOrigin,
	            open: open,
	            anchorEl: anchorEl,
	            childContextTypes: this.constructor.childContextTypes,
	            useLayerForClickAway: useLayerForClickAway,
	            onRequestClose: this.handleRequestClose,
	            animated: animated,
	            animation: animation,
	            context: this.context
	          },
	          menu
	        )
	      );
	    }
	  }]);
	
	  return IconMenu;
	}(_react.Component);
	
	IconMenu.muiName = 'IconMenu';
	IconMenu.propTypes = {
	  /**
	   * This is the point on the icon where the menu
	   * `targetOrigin` will attach.
	   * Options:
	   * vertical: [top, middle, bottom]
	   * horizontal: [left, center, right].
	   */
	  anchorOrigin: _propTypes2.default.origin,
	  /**
	   * If true, the popover will apply transitions when
	   * it gets added to the DOM.
	   */
	  animated: _react.PropTypes.bool,
	  /**
	   * Override the default animation component used.
	   */
	  animation: _react.PropTypes.func,
	  /**
	   * Should be used to pass `MenuItem` components.
	   */
	  children: _react.PropTypes.node,
	  /**
	   * The CSS class name of the root element.
	   */
	  className: _react.PropTypes.string,
	  /**
	   * This is the `IconButton` to render. This button will open the menu.
	   */
	  iconButtonElement: _react.PropTypes.element.isRequired,
	  /**
	   * Override the inline-styles of the underlying icon element.
	   */
	  iconStyle: _react.PropTypes.object,
	  /**
	   * Override the inline-styles of the menu element.
	   */
	  menuStyle: _react.PropTypes.object,
	  /**
	   * If true, the value can an be array and allow the menu to be a multi-select.
	   */
	  multiple: _react.PropTypes.bool,
	  /**
	   * Callback function fired when a menu item is selected with a touch-tap.
	   *
	   * @param {object} event TouchTap event targeting the selected menu item element.
	   * @param {object} child The selected element.
	   */
	  onItemTouchTap: _react.PropTypes.func,
	  /**
	   * Callback function fired when the `IconButton` element is focused or blurred by the keyboard.
	   *
	   * @param {object} event `focus` or `blur` event targeting the `IconButton` element.
	   * @param {boolean} keyboardFocused If true, the `IconButton` element is focused.
	   */
	  onKeyboardFocus: _react.PropTypes.func,
	  /** @ignore */
	  onMouseDown: _react.PropTypes.func,
	  /** @ignore */
	  onMouseEnter: _react.PropTypes.func,
	  /** @ignore */
	  onMouseLeave: _react.PropTypes.func,
	  /** @ignore */
	  onMouseUp: _react.PropTypes.func,
	  /**
	   * Callback function fired when the `open` state of the menu is requested to be changed.
	   *
	   * @param {boolean} open If true, the menu was requested to be opened.
	   * @param {string} reason The reason for the open or close request. Possible values are
	   * 'keyboard' and 'iconTap' for open requests; 'enter', 'escape', 'itemTap', and 'clickAway'
	   * for close requests.
	   */
	  onRequestChange: _react.PropTypes.func,
	  /**
	   * Callback function fired when the `IconButton` element is touch-tapped.
	   *
	   * @param {object} event TouchTap event targeting the `IconButton` element.
	   */
	  onTouchTap: _react.PropTypes.func,
	  /**
	   * If true, the `IconMenu` is opened.
	   */
	  open: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object,
	  /**
	   * This is the point on the menu which will stick to the menu
	   * origin.
	   * Options:
	   * vertical: [top, middle, bottom]
	   * horizontal: [left, center, right].
	   */
	  targetOrigin: _propTypes2.default.origin,
	  /**
	   * Sets the delay in milliseconds before closing the
	   * menu when an item is clicked.
	   * If set to 0 then the auto close functionality
	   * will be disabled.
	   */
	  touchTapCloseDelay: _react.PropTypes.number,
	  /**
	   * If true, the popover will render on top of an invisible
	   * layer, which will prevent clicks to the underlying elements.
	   */
	  useLayerForClickAway: _react.PropTypes.bool
	};
	IconMenu.defaultProps = {
	  anchorOrigin: {
	    vertical: 'top',
	    horizontal: 'left'
	  },
	  animated: true,
	  multiple: false,
	  open: null,
	  onItemTouchTap: function onItemTouchTap() {},
	  onKeyboardFocus: function onKeyboardFocus() {},
	  onMouseDown: function onMouseDown() {},
	  onMouseLeave: function onMouseLeave() {},
	  onMouseEnter: function onMouseEnter() {},
	  onMouseUp: function onMouseUp() {},
	  onRequestChange: function onRequestChange() {},
	  onTouchTap: function onTouchTap() {},
	  targetOrigin: {
	    vertical: 'top',
	    horizontal: 'left'
	  },
	  touchTapCloseDelay: 200,
	  useLayerForClickAway: false
	};
	IconMenu.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	exports.default = IconMenu;

/***/ }),
/* 726 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _LinearProgress = __webpack_require__(727);
	
	var _LinearProgress2 = _interopRequireDefault(_LinearProgress);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _LinearProgress2.default;

/***/ }),
/* 727 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _simpleAssign = __webpack_require__(579);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _transitions = __webpack_require__(582);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function getRelativeValue(value, min, max) {
	  var clampedValue = Math.min(Math.max(min, value), max);
	  var rangeValue = max - min;
	  var relValue = Math.round((clampedValue - min) / rangeValue * 10000) / 10000;
	  return relValue * 100;
	}
	
	function getStyles(props, context) {
	  var max = props.max;
	  var min = props.min;
	  var value = props.value;
	  var palette = context.muiTheme.baseTheme.palette;
	
	
	  var styles = {
	    root: {
	      position: 'relative',
	      height: 4,
	      display: 'block',
	      width: '100%',
	      backgroundColor: palette.primary3Color,
	      borderRadius: 2,
	      margin: 0,
	      overflow: 'hidden'
	    },
	    bar: {
	      height: '100%'
	    },
	    barFragment1: {},
	    barFragment2: {}
	  };
	
	  if (props.mode === 'indeterminate') {
	    styles.barFragment1 = {
	      position: 'absolute',
	      backgroundColor: props.color || palette.primary1Color,
	      top: 0,
	      left: 0,
	      bottom: 0,
	      transition: _transitions2.default.create('all', '840ms', null, 'cubic-bezier(0.650, 0.815, 0.735, 0.395)')
	    };
	
	    styles.barFragment2 = {
	      position: 'absolute',
	      backgroundColor: props.color || palette.primary1Color,
	      top: 0,
	      left: 0,
	      bottom: 0,
	      transition: _transitions2.default.create('all', '840ms', null, 'cubic-bezier(0.165, 0.840, 0.440, 1.000)')
	    };
	  } else {
	    styles.bar.backgroundColor = props.color || palette.primary1Color;
	    styles.bar.transition = _transitions2.default.create('width', '.3s', null, 'linear');
	    styles.bar.width = getRelativeValue(value, min, max) + '%';
	  }
	
	  return styles;
	}
	
	var LinearProgress = function (_Component) {
	  _inherits(LinearProgress, _Component);
	
	  function LinearProgress() {
	    _classCallCheck(this, LinearProgress);
	
	    return _possibleConstructorReturn(this, Object.getPrototypeOf(LinearProgress).apply(this, arguments));
	  }
	
	  _createClass(LinearProgress, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      this.timers = {};
	
	      this.timers.bar1 = this.barUpdate('bar1', 0, this.refs.bar1, [[-35, 100], [100, -90]]);
	
	      this.timers.bar2 = setTimeout(function () {
	        _this2.barUpdate('bar2', 0, _this2.refs.bar2, [[-200, 100], [107, -8]]);
	      }, 850);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      clearTimeout(this.timers.bar1);
	      clearTimeout(this.timers.bar2);
	    }
	  }, {
	    key: 'barUpdate',
	    value: function barUpdate(id, step, barElement, stepValues) {
	      var _this3 = this;
	
	      if (this.props.mode !== 'indeterminate') return;
	
	      step = step || 0;
	      step %= 4;
	
	      var right = this.context.muiTheme.isRtl ? 'left' : 'right';
	      var left = this.context.muiTheme.isRtl ? 'right' : 'left';
	
	      if (step === 0) {
	        barElement.style[left] = stepValues[0][0] + '%';
	        barElement.style[right] = stepValues[0][1] + '%';
	      } else if (step === 1) {
	        barElement.style.transitionDuration = '840ms';
	      } else if (step === 2) {
	        barElement.style[left] = stepValues[1][0] + '%';
	        barElement.style[right] = stepValues[1][1] + '%';
	      } else if (step === 3) {
	        barElement.style.transitionDuration = '0ms';
	      }
	      this.timers[id] = setTimeout(function () {
	        return _this3.barUpdate(id, step + 1, barElement, stepValues);
	      }, 420);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var style = _props.style;
	
	      var other = _objectWithoutProperties(_props, ['style']);
	
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      return _react2.default.createElement(
	        'div',
	        _extends({}, other, { style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) }),
	        _react2.default.createElement(
	          'div',
	          { style: prepareStyles(styles.bar) },
	          _react2.default.createElement('div', { ref: 'bar1', style: prepareStyles(styles.barFragment1) }),
	          _react2.default.createElement('div', { ref: 'bar2', style: prepareStyles(styles.barFragment2) })
	        )
	      );
	    }
	  }]);
	
	  return LinearProgress;
	}(_react.Component);
	
	LinearProgress.propTypes = {
	  /**
	   * The mode of show your progress, indeterminate for
	   * when there is no value for progress.
	   */
	  color: _react.PropTypes.string,
	  /**
	   * The max value of progress, only works in determinate mode.
	   */
	  max: _react.PropTypes.number,
	  /**
	   * The min value of progress, only works in determinate mode.
	   */
	  min: _react.PropTypes.number,
	  /**
	   * The mode of show your progress, indeterminate for when
	   * there is no value for progress.
	   */
	  mode: _react.PropTypes.oneOf(['determinate', 'indeterminate']),
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object,
	  /**
	   * The value of progress, only works in determinate mode.
	   */
	  value: _react.PropTypes.number
	};
	LinearProgress.defaultProps = {
	  mode: 'indeterminate',
	  value: 0,
	  min: 0,
	  max: 100
	};
	LinearProgress.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	exports.default = LinearProgress;

/***/ }),
/* 728 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.MakeSelectable = exports.ListItem = exports.List = undefined;
	
	var _List2 = __webpack_require__(633);
	
	var _List3 = _interopRequireDefault(_List2);
	
	var _ListItem2 = __webpack_require__(658);
	
	var _ListItem3 = _interopRequireDefault(_ListItem2);
	
	var _MakeSelectable2 = __webpack_require__(729);
	
	var _MakeSelectable3 = _interopRequireDefault(_MakeSelectable2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.List = _List3.default;
	exports.ListItem = _ListItem3.default;
	exports.MakeSelectable = _MakeSelectable3.default;
	exports.default = _List3.default;

/***/ }),
/* 729 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.MakeSelectable = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _simpleAssign = __webpack_require__(579);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _colorManipulator = __webpack_require__(623);
	
	var _deprecatedPropType = __webpack_require__(603);
	
	var _deprecatedPropType2 = _interopRequireDefault(_deprecatedPropType);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MakeSelectable = exports.MakeSelectable = function MakeSelectable(Component) {
	  var _class, _temp2;
	
	  return _temp2 = _class = function (_Component) {
	    _inherits(_class, _Component);
	
	    function _class() {
	      var _Object$getPrototypeO;
	
	      var _temp, _this, _ret;
	
	      _classCallCheck(this, _class);
	
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_Object$getPrototypeO = Object.getPrototypeOf(_class)).call.apply(_Object$getPrototypeO, [this].concat(args))), _this), _this.hasSelectedDescendant = function (previousValue, child) {
	        if (_react2.default.isValidElement(child) && child.props.nestedItems && child.props.nestedItems.length > 0) {
	          return child.props.nestedItems.reduce(_this.hasSelectedDescendant, previousValue);
	        }
	        return previousValue || _this.isChildSelected(child, _this.props);
	      }, _this.handleItemTouchTap = function (event, item) {
	        var valueLink = _this.getValueLink(_this.props);
	        var itemValue = item.props.value;
	
	        if (itemValue !== valueLink.value) {
	          valueLink.requestChange(event, itemValue);
	        }
	      }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(_class, [{
	      key: 'getValueLink',
	      value: function getValueLink(props) {
	        return props.valueLink || {
	          value: props.value,
	          requestChange: props.onChange
	        };
	      }
	    }, {
	      key: 'extendChild',
	      value: function extendChild(child, styles, selectedItemStyle) {
	        var _this2 = this;
	
	        if (child && child.type && child.type.muiName === 'ListItem') {
	          var selected = this.isChildSelected(child, this.props);
	          var selectedChildrenStyles = void 0;
	          if (selected) {
	            selectedChildrenStyles = (0, _simpleAssign2.default)({}, styles, selectedItemStyle);
	          }
	
	          var mergedChildrenStyles = (0, _simpleAssign2.default)({}, child.props.style, selectedChildrenStyles);
	
	          this.keyIndex += 1;
	
	          return _react2.default.cloneElement(child, {
	            onTouchTap: function onTouchTap(event) {
	              _this2.handleItemTouchTap(event, child);
	              if (child.props.onTouchTap) {
	                child.props.onTouchTap(event);
	              }
	            },
	            key: this.keyIndex,
	            style: mergedChildrenStyles,
	            nestedItems: child.props.nestedItems.map(function (child) {
	              return _this2.extendChild(child, styles, selectedItemStyle);
	            }),
	            initiallyOpen: this.isInitiallyOpen(child)
	          });
	        } else {
	          return child;
	        }
	      }
	    }, {
	      key: 'isInitiallyOpen',
	      value: function isInitiallyOpen(child) {
	        if (child.props.initiallyOpen) {
	          return child.props.initiallyOpen;
	        }
	        return this.hasSelectedDescendant(false, child);
	      }
	    }, {
	      key: 'isChildSelected',
	      value: function isChildSelected(child, props) {
	        return this.getValueLink(props).value === child.props.value;
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        var _this3 = this;
	
	        var _props = this.props;
	        var children = _props.children;
	        var selectedItemStyle = _props.selectedItemStyle;
	
	        var other = _objectWithoutProperties(_props, ['children', 'selectedItemStyle']);
	
	        this.keyIndex = 0;
	        var styles = {};
	
	        if (!selectedItemStyle) {
	          var textColor = this.context.muiTheme.baseTheme.palette.textColor;
	          styles.backgroundColor = (0, _colorManipulator.fade)(textColor, 0.2);
	        }
	
	        return _react2.default.createElement(
	          Component,
	          _extends({}, other, this.state),
	          _react2.default.Children.map(children, function (child) {
	            return _this3.extendChild(child, styles, selectedItemStyle);
	          })
	        );
	      }
	    }]);
	
	    return _class;
	  }(Component), _class.propTypes = {
	    children: _react.PropTypes.node,
	    onChange: _react.PropTypes.func,
	    selectedItemStyle: _react.PropTypes.object,
	    value: _react.PropTypes.any,
	    valueLink: (0, _deprecatedPropType2.default)(_react.PropTypes.shape({
	      value: _react.PropTypes.any,
	      requestChange: _react.PropTypes.func
	    }), 'This property is deprecated due to his low popularity. Use the value and onChange property.\n        It will be removed with v0.16.0.')
	  }, _class.contextTypes = {
	    muiTheme: _react.PropTypes.object.isRequired
	  }, _temp2;
	};
	
	exports.default = MakeSelectable;

/***/ }),
/* 730 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _getMuiTheme = __webpack_require__(731);
	
	var _getMuiTheme2 = _interopRequireDefault(_getMuiTheme);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MuiThemeProvider = function (_Component) {
	  _inherits(MuiThemeProvider, _Component);
	
	  function MuiThemeProvider() {
	    _classCallCheck(this, MuiThemeProvider);
	
	    return _possibleConstructorReturn(this, Object.getPrototypeOf(MuiThemeProvider).apply(this, arguments));
	  }
	
	  _createClass(MuiThemeProvider, [{
	    key: 'getChildContext',
	    value: function getChildContext() {
	      return {
	        muiTheme: this.props.muiTheme || (0, _getMuiTheme2.default)()
	      };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return this.props.children;
	    }
	  }]);
	
	  return MuiThemeProvider;
	}(_react.Component);
	
	MuiThemeProvider.propTypes = {
	  children: _react.PropTypes.element,
	  muiTheme: _react.PropTypes.object
	};
	MuiThemeProvider.childContextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	exports.default = MuiThemeProvider;

/***/ }),
/* 731 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getMuiTheme;
	
	var _merge = __webpack_require__(732);
	
	var _merge2 = _interopRequireDefault(_merge);
	
	var _colorManipulator = __webpack_require__(623);
	
	var _lightBaseTheme = __webpack_require__(820);
	
	var _lightBaseTheme2 = _interopRequireDefault(_lightBaseTheme);
	
	var _zIndex = __webpack_require__(823);
	
	var _zIndex2 = _interopRequireDefault(_zIndex);
	
	var _autoprefixer = __webpack_require__(824);
	
	var _autoprefixer2 = _interopRequireDefault(_autoprefixer);
	
	var _callOnce = __webpack_require__(856);
	
	var _callOnce2 = _interopRequireDefault(_callOnce);
	
	var _rtl = __webpack_require__(857);
	
	var _rtl2 = _interopRequireDefault(_rtl);
	
	var _compose = __webpack_require__(858);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	var _typography = __webpack_require__(859);
	
	var _typography2 = _interopRequireDefault(_typography);
	
	var _colors = __webpack_require__(821);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	/**
	 * Get the MUI theme corresponding to a base theme.
	 * It's possible to override the computed theme values
	 * by providing a second argument. The calculated
	 * theme will be deeply merged with the second argument.
	 */
	function getMuiTheme(muiTheme) {
	  for (var _len = arguments.length, more = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    more[_key - 1] = arguments[_key];
	  }
	
	  muiTheme = _merge2.default.apply(undefined, [{
	    zIndex: _zIndex2.default,
	    isRtl: false,
	    userAgent: undefined
	  }, _lightBaseTheme2.default, muiTheme].concat(more));
	
	  var _muiTheme = muiTheme;
	  var spacing = _muiTheme.spacing;
	  var fontFamily = _muiTheme.fontFamily;
	  var palette = _muiTheme.palette;
	
	  var baseTheme = { spacing: spacing, fontFamily: fontFamily, palette: palette };
	
	  muiTheme = (0, _merge2.default)({
	    appBar: {
	      color: palette.primary1Color,
	      textColor: palette.alternateTextColor,
	      height: spacing.desktopKeylineIncrement,
	      titleFontWeight: _typography2.default.fontWeightNormal,
	      padding: spacing.desktopGutter
	    },
	    avatar: {
	      color: palette.canvasColor,
	      backgroundColor: (0, _colorManipulator.emphasize)(palette.canvasColor, 0.26)
	    },
	    badge: {
	      color: palette.alternateTextColor,
	      textColor: palette.textColor,
	      primaryColor: palette.accent1Color,
	      primaryTextColor: palette.alternateTextColor,
	      secondaryColor: palette.primary1Color,
	      secondaryTextColor: palette.alternateTextColor,
	      fontWeight: _typography2.default.fontWeightMedium
	    },
	    bottomNavigation: {
	      backgroundColor: palette.canvasColor,
	      unselectedColor: (0, _colorManipulator.fade)(palette.textColor, 0.54),
	      selectedColor: palette.primary1Color,
	      height: 56,
	      unselectedFontSize: 12,
	      selectedFontSize: 14
	    },
	    button: {
	      height: 36,
	      minWidth: 88,
	      iconButtonSize: spacing.iconSize * 2
	    },
	    card: {
	      titleColor: (0, _colorManipulator.fade)(palette.textColor, 0.87),
	      subtitleColor: (0, _colorManipulator.fade)(palette.textColor, 0.54),
	      fontWeight: _typography2.default.fontWeightMedium
	    },
	    cardMedia: {
	      color: _colors.darkWhite,
	      overlayContentBackground: _colors.lightBlack,
	      titleColor: _colors.darkWhite,
	      subtitleColor: _colors.lightWhite
	    },
	    cardText: {
	      textColor: palette.textColor
	    },
	    checkbox: {
	      boxColor: palette.textColor,
	      checkedColor: palette.primary1Color,
	      requiredColor: palette.primary1Color,
	      disabledColor: palette.disabledColor,
	      labelColor: palette.textColor,
	      labelDisabledColor: palette.disabledColor
	    },
	    chip: {
	      backgroundColor: (0, _colorManipulator.emphasize)(palette.canvasColor, 0.12),
	      deleteIconColor: (0, _colorManipulator.fade)(palette.textColor, 0.26),
	      textColor: (0, _colorManipulator.fade)(palette.textColor, 0.87),
	      fontSize: 14,
	      fontWeight: _typography2.default.fontWeightNormal,
	      shadow: '0 1px 6px ' + (0, _colorManipulator.fade)(palette.shadowColor, 0.12) + ',\n        0 1px 4px ' + (0, _colorManipulator.fade)(palette.shadowColor, 0.12)
	    },
	    datePicker: {
	      color: palette.primary1Color,
	      textColor: palette.alternateTextColor,
	      calendarTextColor: palette.textColor,
	      selectColor: palette.primary2Color,
	      selectTextColor: palette.alternateTextColor,
	      calendarYearBackgroundColor: _colors.white
	    },
	    dialog: {
	      titleFontSize: 22,
	      bodyFontSize: 16,
	      bodyColor: (0, _colorManipulator.fade)(palette.textColor, 0.6)
	    },
	    dropDownMenu: {
	      accentColor: palette.borderColor
	    },
	    enhancedButton: {
	      tapHighlightColor: _colors.transparent
	    },
	    flatButton: {
	      color: _colors.transparent,
	      buttonFilterColor: '#999999',
	      disabledTextColor: (0, _colorManipulator.fade)(palette.textColor, 0.3),
	      textColor: palette.textColor,
	      primaryTextColor: palette.primary1Color,
	      secondaryTextColor: palette.accent1Color,
	      fontSize: _typography2.default.fontStyleButtonFontSize,
	      fontWeight: _typography2.default.fontWeightMedium
	    },
	    floatingActionButton: {
	      buttonSize: 56,
	      miniSize: 40,
	      color: palette.primary1Color,
	      iconColor: palette.alternateTextColor,
	      secondaryColor: palette.accent1Color,
	      secondaryIconColor: palette.alternateTextColor,
	      disabledTextColor: palette.disabledColor,
	      disabledColor: (0, _colorManipulator.emphasize)(palette.canvasColor, 0.12)
	    },
	    gridTile: {
	      textColor: _colors.white
	    },
	    icon: {
	      color: palette.canvasColor,
	      backgroundColor: palette.primary1Color
	    },
	    inkBar: {
	      backgroundColor: palette.accent1Color
	    },
	    drawer: {
	      width: spacing.desktopKeylineIncrement * 4,
	      color: palette.canvasColor
	    },
	    listItem: {
	      nestedLevelDepth: 18,
	      secondaryTextColor: palette.secondaryTextColor,
	      leftIconColor: _colors.grey600,
	      rightIconColor: _colors.grey600
	    },
	    menu: {
	      backgroundColor: palette.canvasColor,
	      containerBackgroundColor: palette.canvasColor
	    },
	    menuItem: {
	      dataHeight: 32,
	      height: 48,
	      hoverColor: (0, _colorManipulator.fade)(palette.textColor, 0.035),
	      padding: spacing.desktopGutter,
	      selectedTextColor: palette.accent1Color,
	      rightIconDesktopFill: _colors.grey600
	    },
	    menuSubheader: {
	      padding: spacing.desktopGutter,
	      borderColor: palette.borderColor,
	      textColor: palette.primary1Color
	    },
	    overlay: {
	      backgroundColor: _colors.lightBlack
	    },
	    paper: {
	      color: palette.textColor,
	      backgroundColor: palette.canvasColor,
	      zDepthShadows: [[1, 6, 0.12, 1, 4, 0.12], [3, 10, 0.16, 3, 10, 0.23], [10, 30, 0.19, 6, 10, 0.23], [14, 45, 0.25, 10, 18, 0.22], [19, 60, 0.30, 15, 20, 0.22]].map(function (d) {
	        return '0 ' + d[0] + 'px ' + d[1] + 'px ' + (0, _colorManipulator.fade)(palette.shadowColor, d[2]) + ',\n         0 ' + d[3] + 'px ' + d[4] + 'px ' + (0, _colorManipulator.fade)(palette.shadowColor, d[5]);
	      })
	    },
	    radioButton: {
	      borderColor: palette.textColor,
	      backgroundColor: palette.alternateTextColor,
	      checkedColor: palette.primary1Color,
	      requiredColor: palette.primary1Color,
	      disabledColor: palette.disabledColor,
	      size: 24,
	      labelColor: palette.textColor,
	      labelDisabledColor: palette.disabledColor
	    },
	    raisedButton: {
	      color: palette.alternateTextColor,
	      textColor: palette.textColor,
	      primaryColor: palette.primary1Color,
	      primaryTextColor: palette.alternateTextColor,
	      secondaryColor: palette.accent1Color,
	      secondaryTextColor: palette.alternateTextColor,
	      disabledColor: (0, _colorManipulator.darken)(palette.alternateTextColor, 0.1),
	      disabledTextColor: (0, _colorManipulator.fade)(palette.textColor, 0.3),
	      fontSize: _typography2.default.fontStyleButtonFontSize,
	      fontWeight: _typography2.default.fontWeightMedium
	    },
	    refreshIndicator: {
	      strokeColor: palette.borderColor,
	      loadingStrokeColor: palette.primary1Color
	    },
	    ripple: {
	      color: (0, _colorManipulator.fade)(palette.textColor, 0.87)
	    },
	    slider: {
	      trackSize: 2,
	      trackColor: palette.primary3Color,
	      trackColorSelected: palette.accent3Color,
	      handleSize: 12,
	      handleSizeDisabled: 8,
	      handleSizeActive: 18,
	      handleColorZero: palette.primary3Color,
	      handleFillColor: palette.alternateTextColor,
	      selectionColor: palette.primary1Color,
	      rippleColor: palette.primary1Color
	    },
	    snackbar: {
	      textColor: palette.alternateTextColor,
	      backgroundColor: palette.textColor,
	      actionColor: palette.accent1Color
	    },
	    subheader: {
	      color: (0, _colorManipulator.fade)(palette.textColor, 0.54),
	      fontWeight: _typography2.default.fontWeightMedium
	    },
	    stepper: {
	      backgroundColor: 'transparent',
	      hoverBackgroundColor: (0, _colorManipulator.fade)(_colors.black, 0.06),
	      iconColor: palette.primary1Color,
	      hoveredIconColor: _colors.grey700,
	      inactiveIconColor: _colors.grey500,
	      textColor: (0, _colorManipulator.fade)(_colors.black, 0.87),
	      disabledTextColor: (0, _colorManipulator.fade)(_colors.black, 0.26),
	      connectorLineColor: _colors.grey400
	    },
	    svgIcon: {
	      color: palette.textColor
	    },
	    table: {
	      backgroundColor: palette.canvasColor
	    },
	    tableFooter: {
	      borderColor: palette.borderColor,
	      textColor: palette.accent3Color
	    },
	    tableHeader: {
	      borderColor: palette.borderColor
	    },
	    tableHeaderColumn: {
	      textColor: palette.accent3Color,
	      height: 56,
	      spacing: 24
	    },
	    tableRow: {
	      hoverColor: palette.accent2Color,
	      stripeColor: (0, _colorManipulator.fade)((0, _colorManipulator.lighten)(palette.primary1Color, 0.5), 0.4),
	      selectedColor: palette.borderColor,
	      textColor: palette.textColor,
	      borderColor: palette.borderColor,
	      height: 48
	    },
	    tableRowColumn: {
	      height: 48,
	      spacing: 24
	    },
	    tabs: {
	      backgroundColor: palette.primary1Color,
	      textColor: (0, _colorManipulator.fade)(palette.alternateTextColor, 0.7),
	      selectedTextColor: palette.alternateTextColor
	    },
	    textField: {
	      textColor: palette.textColor,
	      hintColor: palette.disabledColor,
	      floatingLabelColor: palette.textColor,
	      disabledTextColor: palette.disabledColor,
	      errorColor: _colors.red500,
	      focusColor: palette.primary1Color,
	      backgroundColor: 'transparent',
	      borderColor: palette.borderColor
	    },
	    timePicker: {
	      color: palette.alternateTextColor,
	      textColor: palette.accent3Color,
	      accentColor: palette.primary1Color,
	      clockColor: palette.textColor,
	      clockCircleColor: palette.clockCircleColor,
	      headerColor: palette.pickerHeaderColor || palette.primary1Color,
	      selectColor: palette.primary2Color,
	      selectTextColor: palette.alternateTextColor
	    },
	    toggle: {
	      thumbOnColor: palette.primary1Color,
	      thumbOffColor: palette.accent2Color,
	      thumbDisabledColor: palette.borderColor,
	      thumbRequiredColor: palette.primary1Color,
	      trackOnColor: (0, _colorManipulator.fade)(palette.primary1Color, 0.5),
	      trackOffColor: palette.primary3Color,
	      trackDisabledColor: palette.primary3Color,
	      labelColor: palette.textColor,
	      labelDisabledColor: palette.disabledColor,
	      trackRequiredColor: (0, _colorManipulator.fade)(palette.primary1Color, 0.5)
	    },
	    toolbar: {
	      color: (0, _colorManipulator.fade)(palette.textColor, 0.54),
	      hoverColor: (0, _colorManipulator.fade)(palette.textColor, 0.87),
	      backgroundColor: (0, _colorManipulator.darken)(palette.accent2Color, 0.05),
	      height: 56,
	      titleFontSize: 20,
	      iconColor: (0, _colorManipulator.fade)(palette.textColor, 0.4),
	      separatorColor: (0, _colorManipulator.fade)(palette.textColor, 0.175),
	      menuHoverColor: (0, _colorManipulator.fade)(palette.textColor, 0.1)
	    },
	    tooltip: {
	      color: _colors.white,
	      rippleBackgroundColor: _colors.grey700
	    }
	  }, muiTheme, {
	    baseTheme: baseTheme, // To provide backward compatibility.
	    rawTheme: baseTheme });
	
	  var transformers = [_autoprefixer2.default, _rtl2.default, _callOnce2.default].map(function (t) {
	    return t(muiTheme);
	  }).filter(function (t) {
	    return t;
	  });
	  muiTheme.prepareStyles = _compose2.default.apply(undefined, _toConsumableArray(transformers));
	
	  return muiTheme;
	}

/***/ }),
/* 732 */
/***/ (function(module, exports, __webpack_require__) {

	var baseMerge = __webpack_require__(733),
	    createAssigner = __webpack_require__(810);
	
	/**
	 * This method is like `_.assign` except that it recursively merges own and
	 * inherited enumerable string keyed properties of source objects into the
	 * destination object. Source properties that resolve to `undefined` are
	 * skipped if a destination value exists. Array and plain object properties
	 * are merged recursively. Other objects and value types are overridden by
	 * assignment. Source objects are applied from left to right. Subsequent
	 * sources overwrite property assignments of previous sources.
	 *
	 * **Note:** This method mutates `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.5.0
	 * @category Object
	 * @param {Object} object The destination object.
	 * @param {...Object} [sources] The source objects.
	 * @returns {Object} Returns `object`.
	 * @example
	 *
	 * var object = {
	 *   'a': [{ 'b': 2 }, { 'd': 4 }]
	 * };
	 *
	 * var other = {
	 *   'a': [{ 'c': 3 }, { 'e': 5 }]
	 * };
	 *
	 * _.merge(object, other);
	 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
	 */
	var merge = createAssigner(function(object, source, srcIndex) {
	  baseMerge(object, source, srcIndex);
	});
	
	module.exports = merge;


/***/ }),
/* 733 */
/***/ (function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(734),
	    assignMergeValue = __webpack_require__(771),
	    baseFor = __webpack_require__(774),
	    baseMergeDeep = __webpack_require__(776),
	    isObject = __webpack_require__(643),
	    keysIn = __webpack_require__(804),
	    safeGet = __webpack_require__(800);
	
	/**
	 * The base implementation of `_.merge` without support for multiple sources.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @param {number} srcIndex The index of `source`.
	 * @param {Function} [customizer] The function to customize merged values.
	 * @param {Object} [stack] Tracks traversed source values and their merged
	 *  counterparts.
	 */
	function baseMerge(object, source, srcIndex, customizer, stack) {
	  if (object === source) {
	    return;
	  }
	  baseFor(source, function(srcValue, key) {
	    stack || (stack = new Stack);
	    if (isObject(srcValue)) {
	      baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
	    }
	    else {
	      var newValue = customizer
	        ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
	        : undefined;
	
	      if (newValue === undefined) {
	        newValue = srcValue;
	      }
	      assignMergeValue(object, key, newValue);
	    }
	  }, keysIn);
	}
	
	module.exports = baseMerge;


/***/ }),
/* 734 */
/***/ (function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(735),
	    stackClear = __webpack_require__(743),
	    stackDelete = __webpack_require__(744),
	    stackGet = __webpack_require__(745),
	    stackHas = __webpack_require__(746),
	    stackSet = __webpack_require__(747);
	
	/**
	 * Creates a stack cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Stack(entries) {
	  var data = this.__data__ = new ListCache(entries);
	  this.size = data.size;
	}
	
	// Add methods to `Stack`.
	Stack.prototype.clear = stackClear;
	Stack.prototype['delete'] = stackDelete;
	Stack.prototype.get = stackGet;
	Stack.prototype.has = stackHas;
	Stack.prototype.set = stackSet;
	
	module.exports = Stack;


/***/ }),
/* 735 */
/***/ (function(module, exports, __webpack_require__) {

	var listCacheClear = __webpack_require__(736),
	    listCacheDelete = __webpack_require__(737),
	    listCacheGet = __webpack_require__(740),
	    listCacheHas = __webpack_require__(741),
	    listCacheSet = __webpack_require__(742);
	
	/**
	 * Creates an list cache object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function ListCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `ListCache`.
	ListCache.prototype.clear = listCacheClear;
	ListCache.prototype['delete'] = listCacheDelete;
	ListCache.prototype.get = listCacheGet;
	ListCache.prototype.has = listCacheHas;
	ListCache.prototype.set = listCacheSet;
	
	module.exports = ListCache;


/***/ }),
/* 736 */
/***/ (function(module, exports) {

	/**
	 * Removes all key-value entries from the list cache.
	 *
	 * @private
	 * @name clear
	 * @memberOf ListCache
	 */
	function listCacheClear() {
	  this.__data__ = [];
	  this.size = 0;
	}
	
	module.exports = listCacheClear;


/***/ }),
/* 737 */
/***/ (function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(738);
	
	/** Used for built-in method references. */
	var arrayProto = Array.prototype;
	
	/** Built-in value references. */
	var splice = arrayProto.splice;
	
	/**
	 * Removes `key` and its value from the list cache.
	 *
	 * @private
	 * @name delete
	 * @memberOf ListCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function listCacheDelete(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    return false;
	  }
	  var lastIndex = data.length - 1;
	  if (index == lastIndex) {
	    data.pop();
	  } else {
	    splice.call(data, index, 1);
	  }
	  --this.size;
	  return true;
	}
	
	module.exports = listCacheDelete;


/***/ }),
/* 738 */
/***/ (function(module, exports, __webpack_require__) {

	var eq = __webpack_require__(739);
	
	/**
	 * Gets the index at which the `key` is found in `array` of key-value pairs.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} key The key to search for.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function assocIndexOf(array, key) {
	  var length = array.length;
	  while (length--) {
	    if (eq(array[length][0], key)) {
	      return length;
	    }
	  }
	  return -1;
	}
	
	module.exports = assocIndexOf;


/***/ }),
/* 739 */
/***/ (function(module, exports) {

	/**
	 * Performs a
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * comparison between two values to determine if they are equivalent.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.eq(object, object);
	 * // => true
	 *
	 * _.eq(object, other);
	 * // => false
	 *
	 * _.eq('a', 'a');
	 * // => true
	 *
	 * _.eq('a', Object('a'));
	 * // => false
	 *
	 * _.eq(NaN, NaN);
	 * // => true
	 */
	function eq(value, other) {
	  return value === other || (value !== value && other !== other);
	}
	
	module.exports = eq;


/***/ }),
/* 740 */
/***/ (function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(738);
	
	/**
	 * Gets the list cache value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf ListCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function listCacheGet(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  return index < 0 ? undefined : data[index][1];
	}
	
	module.exports = listCacheGet;


/***/ }),
/* 741 */
/***/ (function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(738);
	
	/**
	 * Checks if a list cache value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf ListCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function listCacheHas(key) {
	  return assocIndexOf(this.__data__, key) > -1;
	}
	
	module.exports = listCacheHas;


/***/ }),
/* 742 */
/***/ (function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(738);
	
	/**
	 * Sets the list cache `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf ListCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the list cache instance.
	 */
	function listCacheSet(key, value) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    ++this.size;
	    data.push([key, value]);
	  } else {
	    data[index][1] = value;
	  }
	  return this;
	}
	
	module.exports = listCacheSet;


/***/ }),
/* 743 */
/***/ (function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(735);
	
	/**
	 * Removes all key-value entries from the stack.
	 *
	 * @private
	 * @name clear
	 * @memberOf Stack
	 */
	function stackClear() {
	  this.__data__ = new ListCache;
	  this.size = 0;
	}
	
	module.exports = stackClear;


/***/ }),
/* 744 */
/***/ (function(module, exports) {

	/**
	 * Removes `key` and its value from the stack.
	 *
	 * @private
	 * @name delete
	 * @memberOf Stack
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function stackDelete(key) {
	  var data = this.__data__,
	      result = data['delete'](key);
	
	  this.size = data.size;
	  return result;
	}
	
	module.exports = stackDelete;


/***/ }),
/* 745 */
/***/ (function(module, exports) {

	/**
	 * Gets the stack value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Stack
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function stackGet(key) {
	  return this.__data__.get(key);
	}
	
	module.exports = stackGet;


/***/ }),
/* 746 */
/***/ (function(module, exports) {

	/**
	 * Checks if a stack value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Stack
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function stackHas(key) {
	  return this.__data__.has(key);
	}
	
	module.exports = stackHas;


/***/ }),
/* 747 */
/***/ (function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(735),
	    Map = __webpack_require__(748),
	    MapCache = __webpack_require__(756);
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/**
	 * Sets the stack `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Stack
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the stack cache instance.
	 */
	function stackSet(key, value) {
	  var data = this.__data__;
	  if (data instanceof ListCache) {
	    var pairs = data.__data__;
	    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
	      pairs.push([key, value]);
	      this.size = ++data.size;
	      return this;
	    }
	    data = this.__data__ = new MapCache(pairs);
	  }
	  data.set(key, value);
	  this.size = data.size;
	  return this;
	}
	
	module.exports = stackSet;


/***/ }),
/* 748 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(749),
	    root = __webpack_require__(645);
	
	/* Built-in method references that are verified to be native. */
	var Map = getNative(root, 'Map');
	
	module.exports = Map;


/***/ }),
/* 749 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsNative = __webpack_require__(750),
	    getValue = __webpack_require__(755);
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = getValue(object, key);
	  return baseIsNative(value) ? value : undefined;
	}
	
	module.exports = getNative;


/***/ }),
/* 750 */
/***/ (function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__(751),
	    isMasked = __webpack_require__(752),
	    isObject = __webpack_require__(643),
	    toSource = __webpack_require__(754);
	
	/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	 */
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
	
	/** Used to detect host constructors (Safari). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/**
	 * The base implementation of `_.isNative` without bad shim checks.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 */
	function baseIsNative(value) {
	  if (!isObject(value) || isMasked(value)) {
	    return false;
	  }
	  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
	  return pattern.test(toSource(value));
	}
	
	module.exports = baseIsNative;


/***/ }),
/* 751 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(651),
	    isObject = __webpack_require__(643);
	
	/** `Object#toString` result references. */
	var asyncTag = '[object AsyncFunction]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    proxyTag = '[object Proxy]';
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  if (!isObject(value)) {
	    return false;
	  }
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 9 which returns 'object' for typed arrays and other constructors.
	  var tag = baseGetTag(value);
	  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
	}
	
	module.exports = isFunction;


/***/ }),
/* 752 */
/***/ (function(module, exports, __webpack_require__) {

	var coreJsData = __webpack_require__(753);
	
	/** Used to detect methods masquerading as native. */
	var maskSrcKey = (function() {
	  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	  return uid ? ('Symbol(src)_1.' + uid) : '';
	}());
	
	/**
	 * Checks if `func` has its source masked.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	 */
	function isMasked(func) {
	  return !!maskSrcKey && (maskSrcKey in func);
	}
	
	module.exports = isMasked;


/***/ }),
/* 753 */
/***/ (function(module, exports, __webpack_require__) {

	var root = __webpack_require__(645);
	
	/** Used to detect overreaching core-js shims. */
	var coreJsData = root['__core-js_shared__'];
	
	module.exports = coreJsData;


/***/ }),
/* 754 */
/***/ (function(module, exports) {

	/** Used for built-in method references. */
	var funcProto = Function.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to convert.
	 * @returns {string} Returns the source code.
	 */
	function toSource(func) {
	  if (func != null) {
	    try {
	      return funcToString.call(func);
	    } catch (e) {}
	    try {
	      return (func + '');
	    } catch (e) {}
	  }
	  return '';
	}
	
	module.exports = toSource;


/***/ }),
/* 755 */
/***/ (function(module, exports) {

	/**
	 * Gets the value at `key` of `object`.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function getValue(object, key) {
	  return object == null ? undefined : object[key];
	}
	
	module.exports = getValue;


/***/ }),
/* 756 */
/***/ (function(module, exports, __webpack_require__) {

	var mapCacheClear = __webpack_require__(757),
	    mapCacheDelete = __webpack_require__(765),
	    mapCacheGet = __webpack_require__(768),
	    mapCacheHas = __webpack_require__(769),
	    mapCacheSet = __webpack_require__(770);
	
	/**
	 * Creates a map cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function MapCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `MapCache`.
	MapCache.prototype.clear = mapCacheClear;
	MapCache.prototype['delete'] = mapCacheDelete;
	MapCache.prototype.get = mapCacheGet;
	MapCache.prototype.has = mapCacheHas;
	MapCache.prototype.set = mapCacheSet;
	
	module.exports = MapCache;


/***/ }),
/* 757 */
/***/ (function(module, exports, __webpack_require__) {

	var Hash = __webpack_require__(758),
	    ListCache = __webpack_require__(735),
	    Map = __webpack_require__(748);
	
	/**
	 * Removes all key-value entries from the map.
	 *
	 * @private
	 * @name clear
	 * @memberOf MapCache
	 */
	function mapCacheClear() {
	  this.size = 0;
	  this.__data__ = {
	    'hash': new Hash,
	    'map': new (Map || ListCache),
	    'string': new Hash
	  };
	}
	
	module.exports = mapCacheClear;


/***/ }),
/* 758 */
/***/ (function(module, exports, __webpack_require__) {

	var hashClear = __webpack_require__(759),
	    hashDelete = __webpack_require__(761),
	    hashGet = __webpack_require__(762),
	    hashHas = __webpack_require__(763),
	    hashSet = __webpack_require__(764);
	
	/**
	 * Creates a hash object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Hash(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `Hash`.
	Hash.prototype.clear = hashClear;
	Hash.prototype['delete'] = hashDelete;
	Hash.prototype.get = hashGet;
	Hash.prototype.has = hashHas;
	Hash.prototype.set = hashSet;
	
	module.exports = Hash;


/***/ }),
/* 759 */
/***/ (function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(760);
	
	/**
	 * Removes all key-value entries from the hash.
	 *
	 * @private
	 * @name clear
	 * @memberOf Hash
	 */
	function hashClear() {
	  this.__data__ = nativeCreate ? nativeCreate(null) : {};
	  this.size = 0;
	}
	
	module.exports = hashClear;


/***/ }),
/* 760 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(749);
	
	/* Built-in method references that are verified to be native. */
	var nativeCreate = getNative(Object, 'create');
	
	module.exports = nativeCreate;


/***/ }),
/* 761 */
/***/ (function(module, exports) {

	/**
	 * Removes `key` and its value from the hash.
	 *
	 * @private
	 * @name delete
	 * @memberOf Hash
	 * @param {Object} hash The hash to modify.
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function hashDelete(key) {
	  var result = this.has(key) && delete this.__data__[key];
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	module.exports = hashDelete;


/***/ }),
/* 762 */
/***/ (function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(760);
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Gets the hash value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Hash
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function hashGet(key) {
	  var data = this.__data__;
	  if (nativeCreate) {
	    var result = data[key];
	    return result === HASH_UNDEFINED ? undefined : result;
	  }
	  return hasOwnProperty.call(data, key) ? data[key] : undefined;
	}
	
	module.exports = hashGet;


/***/ }),
/* 763 */
/***/ (function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(760);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Checks if a hash value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Hash
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function hashHas(key) {
	  var data = this.__data__;
	  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
	}
	
	module.exports = hashHas;


/***/ }),
/* 764 */
/***/ (function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(760);
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/**
	 * Sets the hash `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Hash
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the hash instance.
	 */
	function hashSet(key, value) {
	  var data = this.__data__;
	  this.size += this.has(key) ? 0 : 1;
	  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	  return this;
	}
	
	module.exports = hashSet;


/***/ }),
/* 765 */
/***/ (function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(766);
	
	/**
	 * Removes `key` and its value from the map.
	 *
	 * @private
	 * @name delete
	 * @memberOf MapCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function mapCacheDelete(key) {
	  var result = getMapData(this, key)['delete'](key);
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	module.exports = mapCacheDelete;


/***/ }),
/* 766 */
/***/ (function(module, exports, __webpack_require__) {

	var isKeyable = __webpack_require__(767);
	
	/**
	 * Gets the data for `map`.
	 *
	 * @private
	 * @param {Object} map The map to query.
	 * @param {string} key The reference key.
	 * @returns {*} Returns the map data.
	 */
	function getMapData(map, key) {
	  var data = map.__data__;
	  return isKeyable(key)
	    ? data[typeof key == 'string' ? 'string' : 'hash']
	    : data.map;
	}
	
	module.exports = getMapData;


/***/ }),
/* 767 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is suitable for use as unique object key.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	 */
	function isKeyable(value) {
	  var type = typeof value;
	  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	    ? (value !== '__proto__')
	    : (value === null);
	}
	
	module.exports = isKeyable;


/***/ }),
/* 768 */
/***/ (function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(766);
	
	/**
	 * Gets the map value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf MapCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function mapCacheGet(key) {
	  return getMapData(this, key).get(key);
	}
	
	module.exports = mapCacheGet;


/***/ }),
/* 769 */
/***/ (function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(766);
	
	/**
	 * Checks if a map value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf MapCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function mapCacheHas(key) {
	  return getMapData(this, key).has(key);
	}
	
	module.exports = mapCacheHas;


/***/ }),
/* 770 */
/***/ (function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(766);
	
	/**
	 * Sets the map `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf MapCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the map cache instance.
	 */
	function mapCacheSet(key, value) {
	  var data = getMapData(this, key),
	      size = data.size;
	
	  data.set(key, value);
	  this.size += data.size == size ? 0 : 1;
	  return this;
	}
	
	module.exports = mapCacheSet;


/***/ }),
/* 771 */
/***/ (function(module, exports, __webpack_require__) {

	var baseAssignValue = __webpack_require__(772),
	    eq = __webpack_require__(739);
	
	/**
	 * This function is like `assignValue` except that it doesn't assign
	 * `undefined` values.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function assignMergeValue(object, key, value) {
	  if ((value !== undefined && !eq(object[key], value)) ||
	      (value === undefined && !(key in object))) {
	    baseAssignValue(object, key, value);
	  }
	}
	
	module.exports = assignMergeValue;


/***/ }),
/* 772 */
/***/ (function(module, exports, __webpack_require__) {

	var defineProperty = __webpack_require__(773);
	
	/**
	 * The base implementation of `assignValue` and `assignMergeValue` without
	 * value checks.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function baseAssignValue(object, key, value) {
	  if (key == '__proto__' && defineProperty) {
	    defineProperty(object, key, {
	      'configurable': true,
	      'enumerable': true,
	      'value': value,
	      'writable': true
	    });
	  } else {
	    object[key] = value;
	  }
	}
	
	module.exports = baseAssignValue;


/***/ }),
/* 773 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(749);
	
	var defineProperty = (function() {
	  try {
	    var func = getNative(Object, 'defineProperty');
	    func({}, '', {});
	    return func;
	  } catch (e) {}
	}());
	
	module.exports = defineProperty;


/***/ }),
/* 774 */
/***/ (function(module, exports, __webpack_require__) {

	var createBaseFor = __webpack_require__(775);
	
	/**
	 * The base implementation of `baseForOwn` which iterates over `object`
	 * properties returned by `keysFunc` and invokes `iteratee` for each property.
	 * Iteratee functions may exit iteration early by explicitly returning `false`.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @returns {Object} Returns `object`.
	 */
	var baseFor = createBaseFor();
	
	module.exports = baseFor;


/***/ }),
/* 775 */
/***/ (function(module, exports) {

	/**
	 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
	 *
	 * @private
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseFor(fromRight) {
	  return function(object, iteratee, keysFunc) {
	    var index = -1,
	        iterable = Object(object),
	        props = keysFunc(object),
	        length = props.length;
	
	    while (length--) {
	      var key = props[fromRight ? length : ++index];
	      if (iteratee(iterable[key], key, iterable) === false) {
	        break;
	      }
	    }
	    return object;
	  };
	}
	
	module.exports = createBaseFor;


/***/ }),
/* 776 */
/***/ (function(module, exports, __webpack_require__) {

	var assignMergeValue = __webpack_require__(771),
	    cloneBuffer = __webpack_require__(777),
	    cloneTypedArray = __webpack_require__(778),
	    copyArray = __webpack_require__(781),
	    initCloneObject = __webpack_require__(782),
	    isArguments = __webpack_require__(787),
	    isArray = __webpack_require__(789),
	    isArrayLikeObject = __webpack_require__(790),
	    isBuffer = __webpack_require__(793),
	    isFunction = __webpack_require__(751),
	    isObject = __webpack_require__(643),
	    isPlainObject = __webpack_require__(795),
	    isTypedArray = __webpack_require__(796),
	    safeGet = __webpack_require__(800),
	    toPlainObject = __webpack_require__(801);
	
	/**
	 * A specialized version of `baseMerge` for arrays and objects which performs
	 * deep merges and tracks traversed objects enabling objects with circular
	 * references to be merged.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @param {string} key The key of the value to merge.
	 * @param {number} srcIndex The index of `source`.
	 * @param {Function} mergeFunc The function to merge values.
	 * @param {Function} [customizer] The function to customize assigned values.
	 * @param {Object} [stack] Tracks traversed source values and their merged
	 *  counterparts.
	 */
	function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
	  var objValue = safeGet(object, key),
	      srcValue = safeGet(source, key),
	      stacked = stack.get(srcValue);
	
	  if (stacked) {
	    assignMergeValue(object, key, stacked);
	    return;
	  }
	  var newValue = customizer
	    ? customizer(objValue, srcValue, (key + ''), object, source, stack)
	    : undefined;
	
	  var isCommon = newValue === undefined;
	
	  if (isCommon) {
	    var isArr = isArray(srcValue),
	        isBuff = !isArr && isBuffer(srcValue),
	        isTyped = !isArr && !isBuff && isTypedArray(srcValue);
	
	    newValue = srcValue;
	    if (isArr || isBuff || isTyped) {
	      if (isArray(objValue)) {
	        newValue = objValue;
	      }
	      else if (isArrayLikeObject(objValue)) {
	        newValue = copyArray(objValue);
	      }
	      else if (isBuff) {
	        isCommon = false;
	        newValue = cloneBuffer(srcValue, true);
	      }
	      else if (isTyped) {
	        isCommon = false;
	        newValue = cloneTypedArray(srcValue, true);
	      }
	      else {
	        newValue = [];
	      }
	    }
	    else if (isPlainObject(srcValue) || isArguments(srcValue)) {
	      newValue = objValue;
	      if (isArguments(objValue)) {
	        newValue = toPlainObject(objValue);
	      }
	      else if (!isObject(objValue) || isFunction(objValue)) {
	        newValue = initCloneObject(srcValue);
	      }
	    }
	    else {
	      isCommon = false;
	    }
	  }
	  if (isCommon) {
	    // Recursively merge objects and arrays (susceptible to call stack limits).
	    stack.set(srcValue, newValue);
	    mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
	    stack['delete'](srcValue);
	  }
	  assignMergeValue(object, key, newValue);
	}
	
	module.exports = baseMergeDeep;


/***/ }),
/* 777 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(645);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined,
	    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;
	
	/**
	 * Creates a clone of  `buffer`.
	 *
	 * @private
	 * @param {Buffer} buffer The buffer to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Buffer} Returns the cloned buffer.
	 */
	function cloneBuffer(buffer, isDeep) {
	  if (isDeep) {
	    return buffer.slice();
	  }
	  var length = buffer.length,
	      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
	
	  buffer.copy(result);
	  return result;
	}
	
	module.exports = cloneBuffer;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(485)(module)))

/***/ }),
/* 778 */
/***/ (function(module, exports, __webpack_require__) {

	var cloneArrayBuffer = __webpack_require__(779);
	
	/**
	 * Creates a clone of `typedArray`.
	 *
	 * @private
	 * @param {Object} typedArray The typed array to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned typed array.
	 */
	function cloneTypedArray(typedArray, isDeep) {
	  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
	  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
	}
	
	module.exports = cloneTypedArray;


/***/ }),
/* 779 */
/***/ (function(module, exports, __webpack_require__) {

	var Uint8Array = __webpack_require__(780);
	
	/**
	 * Creates a clone of `arrayBuffer`.
	 *
	 * @private
	 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
	 * @returns {ArrayBuffer} Returns the cloned array buffer.
	 */
	function cloneArrayBuffer(arrayBuffer) {
	  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
	  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
	  return result;
	}
	
	module.exports = cloneArrayBuffer;


/***/ }),
/* 780 */
/***/ (function(module, exports, __webpack_require__) {

	var root = __webpack_require__(645);
	
	/** Built-in value references. */
	var Uint8Array = root.Uint8Array;
	
	module.exports = Uint8Array;


/***/ }),
/* 781 */
/***/ (function(module, exports) {

	/**
	 * Copies the values of `source` to `array`.
	 *
	 * @private
	 * @param {Array} source The array to copy values from.
	 * @param {Array} [array=[]] The array to copy values to.
	 * @returns {Array} Returns `array`.
	 */
	function copyArray(source, array) {
	  var index = -1,
	      length = source.length;
	
	  array || (array = Array(length));
	  while (++index < length) {
	    array[index] = source[index];
	  }
	  return array;
	}
	
	module.exports = copyArray;


/***/ }),
/* 782 */
/***/ (function(module, exports, __webpack_require__) {

	var baseCreate = __webpack_require__(783),
	    getPrototype = __webpack_require__(784),
	    isPrototype = __webpack_require__(786);
	
	/**
	 * Initializes an object clone.
	 *
	 * @private
	 * @param {Object} object The object to clone.
	 * @returns {Object} Returns the initialized clone.
	 */
	function initCloneObject(object) {
	  return (typeof object.constructor == 'function' && !isPrototype(object))
	    ? baseCreate(getPrototype(object))
	    : {};
	}
	
	module.exports = initCloneObject;


/***/ }),
/* 783 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(643);
	
	/** Built-in value references. */
	var objectCreate = Object.create;
	
	/**
	 * The base implementation of `_.create` without support for assigning
	 * properties to the created object.
	 *
	 * @private
	 * @param {Object} proto The object to inherit from.
	 * @returns {Object} Returns the new object.
	 */
	var baseCreate = (function() {
	  function object() {}
	  return function(proto) {
	    if (!isObject(proto)) {
	      return {};
	    }
	    if (objectCreate) {
	      return objectCreate(proto);
	    }
	    object.prototype = proto;
	    var result = new object;
	    object.prototype = undefined;
	    return result;
	  };
	}());
	
	module.exports = baseCreate;


/***/ }),
/* 784 */
/***/ (function(module, exports, __webpack_require__) {

	var overArg = __webpack_require__(785);
	
	/** Built-in value references. */
	var getPrototype = overArg(Object.getPrototypeOf, Object);
	
	module.exports = getPrototype;


/***/ }),
/* 785 */
/***/ (function(module, exports) {

	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}
	
	module.exports = overArg;


/***/ }),
/* 786 */
/***/ (function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Checks if `value` is likely a prototype object.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	 */
	function isPrototype(value) {
	  var Ctor = value && value.constructor,
	      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	  return value === proto;
	}
	
	module.exports = isPrototype;


/***/ }),
/* 787 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsArguments = __webpack_require__(788),
	    isObjectLike = __webpack_require__(655);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
	  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
	    !propertyIsEnumerable.call(value, 'callee');
	};
	
	module.exports = isArguments;


/***/ }),
/* 788 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(651),
	    isObjectLike = __webpack_require__(655);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]';
	
	/**
	 * The base implementation of `_.isArguments`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 */
	function baseIsArguments(value) {
	  return isObjectLike(value) && baseGetTag(value) == argsTag;
	}
	
	module.exports = baseIsArguments;


/***/ }),
/* 789 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	module.exports = isArray;


/***/ }),
/* 790 */
/***/ (function(module, exports, __webpack_require__) {

	var isArrayLike = __webpack_require__(791),
	    isObjectLike = __webpack_require__(655);
	
	/**
	 * This method is like `_.isArrayLike` except that it also checks if `value`
	 * is an object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array-like object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArrayLikeObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLikeObject(document.body.children);
	 * // => true
	 *
	 * _.isArrayLikeObject('abc');
	 * // => false
	 *
	 * _.isArrayLikeObject(_.noop);
	 * // => false
	 */
	function isArrayLikeObject(value) {
	  return isObjectLike(value) && isArrayLike(value);
	}
	
	module.exports = isArrayLikeObject;


/***/ }),
/* 791 */
/***/ (function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__(751),
	    isLength = __webpack_require__(792);
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}
	
	module.exports = isArrayLike;


/***/ }),
/* 792 */
/***/ (function(module, exports) {

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	module.exports = isLength;


/***/ }),
/* 793 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(645),
	    stubFalse = __webpack_require__(794);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
	
	/**
	 * Checks if `value` is a buffer.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	 * @example
	 *
	 * _.isBuffer(new Buffer(2));
	 * // => true
	 *
	 * _.isBuffer(new Uint8Array(2));
	 * // => false
	 */
	var isBuffer = nativeIsBuffer || stubFalse;
	
	module.exports = isBuffer;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(485)(module)))

/***/ }),
/* 794 */
/***/ (function(module, exports) {

	/**
	 * This method returns `false`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {boolean} Returns `false`.
	 * @example
	 *
	 * _.times(2, _.stubFalse);
	 * // => [false, false]
	 */
	function stubFalse() {
	  return false;
	}
	
	module.exports = stubFalse;


/***/ }),
/* 795 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(651),
	    getPrototype = __webpack_require__(784),
	    isObjectLike = __webpack_require__(655);
	
	/** `Object#toString` result references. */
	var objectTag = '[object Object]';
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to infer the `Object` constructor. */
	var objectCtorString = funcToString.call(Object);
	
	/**
	 * Checks if `value` is a plain object, that is, an object created by the
	 * `Object` constructor or one with a `[[Prototype]]` of `null`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.8.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 * }
	 *
	 * _.isPlainObject(new Foo);
	 * // => false
	 *
	 * _.isPlainObject([1, 2, 3]);
	 * // => false
	 *
	 * _.isPlainObject({ 'x': 0, 'y': 0 });
	 * // => true
	 *
	 * _.isPlainObject(Object.create(null));
	 * // => true
	 */
	function isPlainObject(value) {
	  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
	    return false;
	  }
	  var proto = getPrototype(value);
	  if (proto === null) {
	    return true;
	  }
	  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
	  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
	    funcToString.call(Ctor) == objectCtorString;
	}
	
	module.exports = isPlainObject;


/***/ }),
/* 796 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsTypedArray = __webpack_require__(797),
	    baseUnary = __webpack_require__(798),
	    nodeUtil = __webpack_require__(799);
	
	/* Node.js helper references. */
	var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
	
	/**
	 * Checks if `value` is classified as a typed array.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 * @example
	 *
	 * _.isTypedArray(new Uint8Array);
	 * // => true
	 *
	 * _.isTypedArray([]);
	 * // => false
	 */
	var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
	
	module.exports = isTypedArray;


/***/ }),
/* 797 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(651),
	    isLength = __webpack_require__(792),
	    isObjectLike = __webpack_require__(655);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/** Used to identify `toStringTag` values of typed arrays. */
	var typedArrayTags = {};
	typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	typedArrayTags[uint32Tag] = true;
	typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	typedArrayTags[setTag] = typedArrayTags[stringTag] =
	typedArrayTags[weakMapTag] = false;
	
	/**
	 * The base implementation of `_.isTypedArray` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 */
	function baseIsTypedArray(value) {
	  return isObjectLike(value) &&
	    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
	}
	
	module.exports = baseIsTypedArray;


/***/ }),
/* 798 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.unary` without support for storing metadata.
	 *
	 * @private
	 * @param {Function} func The function to cap arguments for.
	 * @returns {Function} Returns the new capped function.
	 */
	function baseUnary(func) {
	  return function(value) {
	    return func(value);
	  };
	}
	
	module.exports = baseUnary;


/***/ }),
/* 799 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(646);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Detect free variable `process` from Node.js. */
	var freeProcess = moduleExports && freeGlobal.process;
	
	/** Used to access faster Node.js helpers. */
	var nodeUtil = (function() {
	  try {
	    // Use `util.types` for Node.js 10+.
	    var types = freeModule && freeModule.require && freeModule.require('util').types;
	
	    if (types) {
	      return types;
	    }
	
	    // Legacy `process.binding('util')` for Node.js < 10.
	    return freeProcess && freeProcess.binding && freeProcess.binding('util');
	  } catch (e) {}
	}());
	
	module.exports = nodeUtil;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(485)(module)))

/***/ }),
/* 800 */
/***/ (function(module, exports) {

	/**
	 * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function safeGet(object, key) {
	  if (key === 'constructor' && typeof object[key] === 'function') {
	    return;
	  }
	
	  if (key == '__proto__') {
	    return;
	  }
	
	  return object[key];
	}
	
	module.exports = safeGet;


/***/ }),
/* 801 */
/***/ (function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(802),
	    keysIn = __webpack_require__(804);
	
	/**
	 * Converts `value` to a plain object flattening inherited enumerable string
	 * keyed properties of `value` to own properties of the plain object.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {Object} Returns the converted plain object.
	 * @example
	 *
	 * function Foo() {
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.assign({ 'a': 1 }, new Foo);
	 * // => { 'a': 1, 'b': 2 }
	 *
	 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
	 * // => { 'a': 1, 'b': 2, 'c': 3 }
	 */
	function toPlainObject(value) {
	  return copyObject(value, keysIn(value));
	}
	
	module.exports = toPlainObject;


/***/ }),
/* 802 */
/***/ (function(module, exports, __webpack_require__) {

	var assignValue = __webpack_require__(803),
	    baseAssignValue = __webpack_require__(772);
	
	/**
	 * Copies properties of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy properties from.
	 * @param {Array} props The property identifiers to copy.
	 * @param {Object} [object={}] The object to copy properties to.
	 * @param {Function} [customizer] The function to customize copied values.
	 * @returns {Object} Returns `object`.
	 */
	function copyObject(source, props, object, customizer) {
	  var isNew = !object;
	  object || (object = {});
	
	  var index = -1,
	      length = props.length;
	
	  while (++index < length) {
	    var key = props[index];
	
	    var newValue = customizer
	      ? customizer(object[key], source[key], key, object, source)
	      : undefined;
	
	    if (newValue === undefined) {
	      newValue = source[key];
	    }
	    if (isNew) {
	      baseAssignValue(object, key, newValue);
	    } else {
	      assignValue(object, key, newValue);
	    }
	  }
	  return object;
	}
	
	module.exports = copyObject;


/***/ }),
/* 803 */
/***/ (function(module, exports, __webpack_require__) {

	var baseAssignValue = __webpack_require__(772),
	    eq = __webpack_require__(739);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Assigns `value` to `key` of `object` if the existing value is not equivalent
	 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * for equality comparisons.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function assignValue(object, key, value) {
	  var objValue = object[key];
	  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
	      (value === undefined && !(key in object))) {
	    baseAssignValue(object, key, value);
	  }
	}
	
	module.exports = assignValue;


/***/ }),
/* 804 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayLikeKeys = __webpack_require__(805),
	    baseKeysIn = __webpack_require__(808),
	    isArrayLike = __webpack_require__(791);
	
	/**
	 * Creates an array of the own and inherited enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keysIn(new Foo);
	 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	 */
	function keysIn(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
	}
	
	module.exports = keysIn;


/***/ }),
/* 805 */
/***/ (function(module, exports, __webpack_require__) {

	var baseTimes = __webpack_require__(806),
	    isArguments = __webpack_require__(787),
	    isArray = __webpack_require__(789),
	    isBuffer = __webpack_require__(793),
	    isIndex = __webpack_require__(807),
	    isTypedArray = __webpack_require__(796);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Creates an array of the enumerable property names of the array-like `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @param {boolean} inherited Specify returning inherited property names.
	 * @returns {Array} Returns the array of property names.
	 */
	function arrayLikeKeys(value, inherited) {
	  var isArr = isArray(value),
	      isArg = !isArr && isArguments(value),
	      isBuff = !isArr && !isArg && isBuffer(value),
	      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
	      skipIndexes = isArr || isArg || isBuff || isType,
	      result = skipIndexes ? baseTimes(value.length, String) : [],
	      length = result.length;
	
	  for (var key in value) {
	    if ((inherited || hasOwnProperty.call(value, key)) &&
	        !(skipIndexes && (
	           // Safari 9 has enumerable `arguments.length` in strict mode.
	           key == 'length' ||
	           // Node.js 0.10 has enumerable non-index properties on buffers.
	           (isBuff && (key == 'offset' || key == 'parent')) ||
	           // PhantomJS 2 has enumerable non-index properties on typed arrays.
	           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
	           // Skip index properties.
	           isIndex(key, length)
	        ))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = arrayLikeKeys;


/***/ }),
/* 806 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.times` without support for iteratee shorthands
	 * or max array length checks.
	 *
	 * @private
	 * @param {number} n The number of times to invoke `iteratee`.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the array of results.
	 */
	function baseTimes(n, iteratee) {
	  var index = -1,
	      result = Array(n);
	
	  while (++index < n) {
	    result[index] = iteratee(index);
	  }
	  return result;
	}
	
	module.exports = baseTimes;


/***/ }),
/* 807 */
/***/ (function(module, exports) {

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  var type = typeof value;
	  length = length == null ? MAX_SAFE_INTEGER : length;
	
	  return !!length &&
	    (type == 'number' ||
	      (type != 'symbol' && reIsUint.test(value))) &&
	        (value > -1 && value % 1 == 0 && value < length);
	}
	
	module.exports = isIndex;


/***/ }),
/* 808 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(643),
	    isPrototype = __webpack_require__(786),
	    nativeKeysIn = __webpack_require__(809);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeysIn(object) {
	  if (!isObject(object)) {
	    return nativeKeysIn(object);
	  }
	  var isProto = isPrototype(object),
	      result = [];
	
	  for (var key in object) {
	    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = baseKeysIn;


/***/ }),
/* 809 */
/***/ (function(module, exports) {

	/**
	 * This function is like
	 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * except that it includes inherited enumerable properties.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function nativeKeysIn(object) {
	  var result = [];
	  if (object != null) {
	    for (var key in Object(object)) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = nativeKeysIn;


/***/ }),
/* 810 */
/***/ (function(module, exports, __webpack_require__) {

	var baseRest = __webpack_require__(811),
	    isIterateeCall = __webpack_require__(819);
	
	/**
	 * Creates a function like `_.assign`.
	 *
	 * @private
	 * @param {Function} assigner The function to assign values.
	 * @returns {Function} Returns the new assigner function.
	 */
	function createAssigner(assigner) {
	  return baseRest(function(object, sources) {
	    var index = -1,
	        length = sources.length,
	        customizer = length > 1 ? sources[length - 1] : undefined,
	        guard = length > 2 ? sources[2] : undefined;
	
	    customizer = (assigner.length > 3 && typeof customizer == 'function')
	      ? (length--, customizer)
	      : undefined;
	
	    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	      customizer = length < 3 ? undefined : customizer;
	      length = 1;
	    }
	    object = Object(object);
	    while (++index < length) {
	      var source = sources[index];
	      if (source) {
	        assigner(object, source, index, customizer);
	      }
	    }
	    return object;
	  });
	}
	
	module.exports = createAssigner;


/***/ }),
/* 811 */
/***/ (function(module, exports, __webpack_require__) {

	var identity = __webpack_require__(812),
	    overRest = __webpack_require__(813),
	    setToString = __webpack_require__(815);
	
	/**
	 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @returns {Function} Returns the new function.
	 */
	function baseRest(func, start) {
	  return setToString(overRest(func, start, identity), func + '');
	}
	
	module.exports = baseRest;


/***/ }),
/* 812 */
/***/ (function(module, exports) {

	/**
	 * This method returns the first argument it receives.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Util
	 * @param {*} value Any value.
	 * @returns {*} Returns `value`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 *
	 * console.log(_.identity(object) === object);
	 * // => true
	 */
	function identity(value) {
	  return value;
	}
	
	module.exports = identity;


/***/ }),
/* 813 */
/***/ (function(module, exports, __webpack_require__) {

	var apply = __webpack_require__(814);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * A specialized version of `baseRest` which transforms the rest array.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @param {Function} transform The rest array transform.
	 * @returns {Function} Returns the new function.
	 */
	function overRest(func, start, transform) {
	  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
	  return function() {
	    var args = arguments,
	        index = -1,
	        length = nativeMax(args.length - start, 0),
	        array = Array(length);
	
	    while (++index < length) {
	      array[index] = args[start + index];
	    }
	    index = -1;
	    var otherArgs = Array(start + 1);
	    while (++index < start) {
	      otherArgs[index] = args[index];
	    }
	    otherArgs[start] = transform(array);
	    return apply(func, this, otherArgs);
	  };
	}
	
	module.exports = overRest;


/***/ }),
/* 814 */
/***/ (function(module, exports) {

	/**
	 * A faster alternative to `Function#apply`, this function invokes `func`
	 * with the `this` binding of `thisArg` and the arguments of `args`.
	 *
	 * @private
	 * @param {Function} func The function to invoke.
	 * @param {*} thisArg The `this` binding of `func`.
	 * @param {Array} args The arguments to invoke `func` with.
	 * @returns {*} Returns the result of `func`.
	 */
	function apply(func, thisArg, args) {
	  switch (args.length) {
	    case 0: return func.call(thisArg);
	    case 1: return func.call(thisArg, args[0]);
	    case 2: return func.call(thisArg, args[0], args[1]);
	    case 3: return func.call(thisArg, args[0], args[1], args[2]);
	  }
	  return func.apply(thisArg, args);
	}
	
	module.exports = apply;


/***/ }),
/* 815 */
/***/ (function(module, exports, __webpack_require__) {

	var baseSetToString = __webpack_require__(816),
	    shortOut = __webpack_require__(818);
	
	/**
	 * Sets the `toString` method of `func` to return `string`.
	 *
	 * @private
	 * @param {Function} func The function to modify.
	 * @param {Function} string The `toString` result.
	 * @returns {Function} Returns `func`.
	 */
	var setToString = shortOut(baseSetToString);
	
	module.exports = setToString;


/***/ }),
/* 816 */
/***/ (function(module, exports, __webpack_require__) {

	var constant = __webpack_require__(817),
	    defineProperty = __webpack_require__(773),
	    identity = __webpack_require__(812);
	
	/**
	 * The base implementation of `setToString` without support for hot loop shorting.
	 *
	 * @private
	 * @param {Function} func The function to modify.
	 * @param {Function} string The `toString` result.
	 * @returns {Function} Returns `func`.
	 */
	var baseSetToString = !defineProperty ? identity : function(func, string) {
	  return defineProperty(func, 'toString', {
	    'configurable': true,
	    'enumerable': false,
	    'value': constant(string),
	    'writable': true
	  });
	};
	
	module.exports = baseSetToString;


/***/ }),
/* 817 */
/***/ (function(module, exports) {

	/**
	 * Creates a function that returns `value`.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Util
	 * @param {*} value The value to return from the new function.
	 * @returns {Function} Returns the new constant function.
	 * @example
	 *
	 * var objects = _.times(2, _.constant({ 'a': 1 }));
	 *
	 * console.log(objects);
	 * // => [{ 'a': 1 }, { 'a': 1 }]
	 *
	 * console.log(objects[0] === objects[1]);
	 * // => true
	 */
	function constant(value) {
	  return function() {
	    return value;
	  };
	}
	
	module.exports = constant;


/***/ }),
/* 818 */
/***/ (function(module, exports) {

	/** Used to detect hot functions by number of calls within a span of milliseconds. */
	var HOT_COUNT = 800,
	    HOT_SPAN = 16;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeNow = Date.now;
	
	/**
	 * Creates a function that'll short out and invoke `identity` instead
	 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
	 * milliseconds.
	 *
	 * @private
	 * @param {Function} func The function to restrict.
	 * @returns {Function} Returns the new shortable function.
	 */
	function shortOut(func) {
	  var count = 0,
	      lastCalled = 0;
	
	  return function() {
	    var stamp = nativeNow(),
	        remaining = HOT_SPAN - (stamp - lastCalled);
	
	    lastCalled = stamp;
	    if (remaining > 0) {
	      if (++count >= HOT_COUNT) {
	        return arguments[0];
	      }
	    } else {
	      count = 0;
	    }
	    return func.apply(undefined, arguments);
	  };
	}
	
	module.exports = shortOut;


/***/ }),
/* 819 */
/***/ (function(module, exports, __webpack_require__) {

	var eq = __webpack_require__(739),
	    isArrayLike = __webpack_require__(791),
	    isIndex = __webpack_require__(807),
	    isObject = __webpack_require__(643);
	
	/**
	 * Checks if the given arguments are from an iteratee call.
	 *
	 * @private
	 * @param {*} value The potential iteratee value argument.
	 * @param {*} index The potential iteratee index or key argument.
	 * @param {*} object The potential iteratee object argument.
	 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
	 *  else `false`.
	 */
	function isIterateeCall(value, index, object) {
	  if (!isObject(object)) {
	    return false;
	  }
	  var type = typeof index;
	  if (type == 'number'
	        ? (isArrayLike(object) && isIndex(index, object.length))
	        : (type == 'string' && index in object)
	      ) {
	    return eq(object[index], value);
	  }
	  return false;
	}
	
	module.exports = isIterateeCall;


/***/ }),
/* 820 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _colors = __webpack_require__(821);
	
	var _colorManipulator = __webpack_require__(623);
	
	var _spacing = __webpack_require__(822);
	
	var _spacing2 = _interopRequireDefault(_spacing);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 *  Light Theme is the default theme used in material-ui. It is guaranteed to
	 *  have all theme variables needed for every component. Variables not defined
	 *  in a custom theme will default to these values.
	 */
	exports.default = {
	  spacing: _spacing2.default,
	  fontFamily: 'Roboto, sans-serif',
	  palette: {
	    primary1Color: _colors.cyan500,
	    primary2Color: _colors.cyan700,
	    primary3Color: _colors.grey400,
	    accent1Color: _colors.pinkA200,
	    accent2Color: _colors.grey100,
	    accent3Color: _colors.grey500,
	    textColor: _colors.darkBlack,
	    secondaryTextColor: (0, _colorManipulator.fade)(_colors.darkBlack, 0.54),
	    alternateTextColor: _colors.white,
	    canvasColor: _colors.white,
	    borderColor: _colors.grey300,
	    disabledColor: (0, _colorManipulator.fade)(_colors.darkBlack, 0.3),
	    pickerHeaderColor: _colors.cyan500,
	    clockCircleColor: (0, _colorManipulator.fade)(_colors.darkBlack, 0.07),
	    shadowColor: _colors.fullBlack
	  }
	}; /**
	    * NB: If you update this file, please also update `docs/src/app/customization/Themes.js`
	    */

/***/ }),
/* 821 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var red50 = exports.red50 = '#ffebee';
	var red100 = exports.red100 = '#ffcdd2';
	var red200 = exports.red200 = '#ef9a9a';
	var red300 = exports.red300 = '#e57373';
	var red400 = exports.red400 = '#ef5350';
	var red500 = exports.red500 = '#f44336';
	var red600 = exports.red600 = '#e53935';
	var red700 = exports.red700 = '#d32f2f';
	var red800 = exports.red800 = '#c62828';
	var red900 = exports.red900 = '#b71c1c';
	var redA100 = exports.redA100 = '#ff8a80';
	var redA200 = exports.redA200 = '#ff5252';
	var redA400 = exports.redA400 = '#ff1744';
	var redA700 = exports.redA700 = '#d50000';
	
	var pink50 = exports.pink50 = '#fce4ec';
	var pink100 = exports.pink100 = '#f8bbd0';
	var pink200 = exports.pink200 = '#f48fb1';
	var pink300 = exports.pink300 = '#f06292';
	var pink400 = exports.pink400 = '#ec407a';
	var pink500 = exports.pink500 = '#e91e63';
	var pink600 = exports.pink600 = '#d81b60';
	var pink700 = exports.pink700 = '#c2185b';
	var pink800 = exports.pink800 = '#ad1457';
	var pink900 = exports.pink900 = '#880e4f';
	var pinkA100 = exports.pinkA100 = '#ff80ab';
	var pinkA200 = exports.pinkA200 = '#ff4081';
	var pinkA400 = exports.pinkA400 = '#f50057';
	var pinkA700 = exports.pinkA700 = '#c51162';
	
	var purple50 = exports.purple50 = '#f3e5f5';
	var purple100 = exports.purple100 = '#e1bee7';
	var purple200 = exports.purple200 = '#ce93d8';
	var purple300 = exports.purple300 = '#ba68c8';
	var purple400 = exports.purple400 = '#ab47bc';
	var purple500 = exports.purple500 = '#9c27b0';
	var purple600 = exports.purple600 = '#8e24aa';
	var purple700 = exports.purple700 = '#7b1fa2';
	var purple800 = exports.purple800 = '#6a1b9a';
	var purple900 = exports.purple900 = '#4a148c';
	var purpleA100 = exports.purpleA100 = '#ea80fc';
	var purpleA200 = exports.purpleA200 = '#e040fb';
	var purpleA400 = exports.purpleA400 = '#d500f9';
	var purpleA700 = exports.purpleA700 = '#aa00ff';
	
	var deepPurple50 = exports.deepPurple50 = '#ede7f6';
	var deepPurple100 = exports.deepPurple100 = '#d1c4e9';
	var deepPurple200 = exports.deepPurple200 = '#b39ddb';
	var deepPurple300 = exports.deepPurple300 = '#9575cd';
	var deepPurple400 = exports.deepPurple400 = '#7e57c2';
	var deepPurple500 = exports.deepPurple500 = '#673ab7';
	var deepPurple600 = exports.deepPurple600 = '#5e35b1';
	var deepPurple700 = exports.deepPurple700 = '#512da8';
	var deepPurple800 = exports.deepPurple800 = '#4527a0';
	var deepPurple900 = exports.deepPurple900 = '#311b92';
	var deepPurpleA100 = exports.deepPurpleA100 = '#b388ff';
	var deepPurpleA200 = exports.deepPurpleA200 = '#7c4dff';
	var deepPurpleA400 = exports.deepPurpleA400 = '#651fff';
	var deepPurpleA700 = exports.deepPurpleA700 = '#6200ea';
	
	var indigo50 = exports.indigo50 = '#e8eaf6';
	var indigo100 = exports.indigo100 = '#c5cae9';
	var indigo200 = exports.indigo200 = '#9fa8da';
	var indigo300 = exports.indigo300 = '#7986cb';
	var indigo400 = exports.indigo400 = '#5c6bc0';
	var indigo500 = exports.indigo500 = '#3f51b5';
	var indigo600 = exports.indigo600 = '#3949ab';
	var indigo700 = exports.indigo700 = '#303f9f';
	var indigo800 = exports.indigo800 = '#283593';
	var indigo900 = exports.indigo900 = '#1a237e';
	var indigoA100 = exports.indigoA100 = '#8c9eff';
	var indigoA200 = exports.indigoA200 = '#536dfe';
	var indigoA400 = exports.indigoA400 = '#3d5afe';
	var indigoA700 = exports.indigoA700 = '#304ffe';
	
	var blue50 = exports.blue50 = '#e3f2fd';
	var blue100 = exports.blue100 = '#bbdefb';
	var blue200 = exports.blue200 = '#90caf9';
	var blue300 = exports.blue300 = '#64b5f6';
	var blue400 = exports.blue400 = '#42a5f5';
	var blue500 = exports.blue500 = '#2196f3';
	var blue600 = exports.blue600 = '#1e88e5';
	var blue700 = exports.blue700 = '#1976d2';
	var blue800 = exports.blue800 = '#1565c0';
	var blue900 = exports.blue900 = '#0d47a1';
	var blueA100 = exports.blueA100 = '#82b1ff';
	var blueA200 = exports.blueA200 = '#448aff';
	var blueA400 = exports.blueA400 = '#2979ff';
	var blueA700 = exports.blueA700 = '#2962ff';
	
	var lightBlue50 = exports.lightBlue50 = '#e1f5fe';
	var lightBlue100 = exports.lightBlue100 = '#b3e5fc';
	var lightBlue200 = exports.lightBlue200 = '#81d4fa';
	var lightBlue300 = exports.lightBlue300 = '#4fc3f7';
	var lightBlue400 = exports.lightBlue400 = '#29b6f6';
	var lightBlue500 = exports.lightBlue500 = '#03a9f4';
	var lightBlue600 = exports.lightBlue600 = '#039be5';
	var lightBlue700 = exports.lightBlue700 = '#0288d1';
	var lightBlue800 = exports.lightBlue800 = '#0277bd';
	var lightBlue900 = exports.lightBlue900 = '#01579b';
	var lightBlueA100 = exports.lightBlueA100 = '#80d8ff';
	var lightBlueA200 = exports.lightBlueA200 = '#40c4ff';
	var lightBlueA400 = exports.lightBlueA400 = '#00b0ff';
	var lightBlueA700 = exports.lightBlueA700 = '#0091ea';
	
	var cyan50 = exports.cyan50 = '#e0f7fa';
	var cyan100 = exports.cyan100 = '#b2ebf2';
	var cyan200 = exports.cyan200 = '#80deea';
	var cyan300 = exports.cyan300 = '#4dd0e1';
	var cyan400 = exports.cyan400 = '#26c6da';
	var cyan500 = exports.cyan500 = '#00bcd4';
	var cyan600 = exports.cyan600 = '#00acc1';
	var cyan700 = exports.cyan700 = '#0097a7';
	var cyan800 = exports.cyan800 = '#00838f';
	var cyan900 = exports.cyan900 = '#006064';
	var cyanA100 = exports.cyanA100 = '#84ffff';
	var cyanA200 = exports.cyanA200 = '#18ffff';
	var cyanA400 = exports.cyanA400 = '#00e5ff';
	var cyanA700 = exports.cyanA700 = '#00b8d4';
	
	var teal50 = exports.teal50 = '#e0f2f1';
	var teal100 = exports.teal100 = '#b2dfdb';
	var teal200 = exports.teal200 = '#80cbc4';
	var teal300 = exports.teal300 = '#4db6ac';
	var teal400 = exports.teal400 = '#26a69a';
	var teal500 = exports.teal500 = '#009688';
	var teal600 = exports.teal600 = '#00897b';
	var teal700 = exports.teal700 = '#00796b';
	var teal800 = exports.teal800 = '#00695c';
	var teal900 = exports.teal900 = '#004d40';
	var tealA100 = exports.tealA100 = '#a7ffeb';
	var tealA200 = exports.tealA200 = '#64ffda';
	var tealA400 = exports.tealA400 = '#1de9b6';
	var tealA700 = exports.tealA700 = '#00bfa5';
	
	var green50 = exports.green50 = '#e8f5e9';
	var green100 = exports.green100 = '#c8e6c9';
	var green200 = exports.green200 = '#a5d6a7';
	var green300 = exports.green300 = '#81c784';
	var green400 = exports.green400 = '#66bb6a';
	var green500 = exports.green500 = '#4caf50';
	var green600 = exports.green600 = '#43a047';
	var green700 = exports.green700 = '#388e3c';
	var green800 = exports.green800 = '#2e7d32';
	var green900 = exports.green900 = '#1b5e20';
	var greenA100 = exports.greenA100 = '#b9f6ca';
	var greenA200 = exports.greenA200 = '#69f0ae';
	var greenA400 = exports.greenA400 = '#00e676';
	var greenA700 = exports.greenA700 = '#00c853';
	
	var lightGreen50 = exports.lightGreen50 = '#f1f8e9';
	var lightGreen100 = exports.lightGreen100 = '#dcedc8';
	var lightGreen200 = exports.lightGreen200 = '#c5e1a5';
	var lightGreen300 = exports.lightGreen300 = '#aed581';
	var lightGreen400 = exports.lightGreen400 = '#9ccc65';
	var lightGreen500 = exports.lightGreen500 = '#8bc34a';
	var lightGreen600 = exports.lightGreen600 = '#7cb342';
	var lightGreen700 = exports.lightGreen700 = '#689f38';
	var lightGreen800 = exports.lightGreen800 = '#558b2f';
	var lightGreen900 = exports.lightGreen900 = '#33691e';
	var lightGreenA100 = exports.lightGreenA100 = '#ccff90';
	var lightGreenA200 = exports.lightGreenA200 = '#b2ff59';
	var lightGreenA400 = exports.lightGreenA400 = '#76ff03';
	var lightGreenA700 = exports.lightGreenA700 = '#64dd17';
	
	var lime50 = exports.lime50 = '#f9fbe7';
	var lime100 = exports.lime100 = '#f0f4c3';
	var lime200 = exports.lime200 = '#e6ee9c';
	var lime300 = exports.lime300 = '#dce775';
	var lime400 = exports.lime400 = '#d4e157';
	var lime500 = exports.lime500 = '#cddc39';
	var lime600 = exports.lime600 = '#c0ca33';
	var lime700 = exports.lime700 = '#afb42b';
	var lime800 = exports.lime800 = '#9e9d24';
	var lime900 = exports.lime900 = '#827717';
	var limeA100 = exports.limeA100 = '#f4ff81';
	var limeA200 = exports.limeA200 = '#eeff41';
	var limeA400 = exports.limeA400 = '#c6ff00';
	var limeA700 = exports.limeA700 = '#aeea00';
	
	var yellow50 = exports.yellow50 = '#fffde7';
	var yellow100 = exports.yellow100 = '#fff9c4';
	var yellow200 = exports.yellow200 = '#fff59d';
	var yellow300 = exports.yellow300 = '#fff176';
	var yellow400 = exports.yellow400 = '#ffee58';
	var yellow500 = exports.yellow500 = '#ffeb3b';
	var yellow600 = exports.yellow600 = '#fdd835';
	var yellow700 = exports.yellow700 = '#fbc02d';
	var yellow800 = exports.yellow800 = '#f9a825';
	var yellow900 = exports.yellow900 = '#f57f17';
	var yellowA100 = exports.yellowA100 = '#ffff8d';
	var yellowA200 = exports.yellowA200 = '#ffff00';
	var yellowA400 = exports.yellowA400 = '#ffea00';
	var yellowA700 = exports.yellowA700 = '#ffd600';
	
	var amber50 = exports.amber50 = '#fff8e1';
	var amber100 = exports.amber100 = '#ffecb3';
	var amber200 = exports.amber200 = '#ffe082';
	var amber300 = exports.amber300 = '#ffd54f';
	var amber400 = exports.amber400 = '#ffca28';
	var amber500 = exports.amber500 = '#ffc107';
	var amber600 = exports.amber600 = '#ffb300';
	var amber700 = exports.amber700 = '#ffa000';
	var amber800 = exports.amber800 = '#ff8f00';
	var amber900 = exports.amber900 = '#ff6f00';
	var amberA100 = exports.amberA100 = '#ffe57f';
	var amberA200 = exports.amberA200 = '#ffd740';
	var amberA400 = exports.amberA400 = '#ffc400';
	var amberA700 = exports.amberA700 = '#ffab00';
	
	var orange50 = exports.orange50 = '#fff3e0';
	var orange100 = exports.orange100 = '#ffe0b2';
	var orange200 = exports.orange200 = '#ffcc80';
	var orange300 = exports.orange300 = '#ffb74d';
	var orange400 = exports.orange400 = '#ffa726';
	var orange500 = exports.orange500 = '#ff9800';
	var orange600 = exports.orange600 = '#fb8c00';
	var orange700 = exports.orange700 = '#f57c00';
	var orange800 = exports.orange800 = '#ef6c00';
	var orange900 = exports.orange900 = '#e65100';
	var orangeA100 = exports.orangeA100 = '#ffd180';
	var orangeA200 = exports.orangeA200 = '#ffab40';
	var orangeA400 = exports.orangeA400 = '#ff9100';
	var orangeA700 = exports.orangeA700 = '#ff6d00';
	
	var deepOrange50 = exports.deepOrange50 = '#fbe9e7';
	var deepOrange100 = exports.deepOrange100 = '#ffccbc';
	var deepOrange200 = exports.deepOrange200 = '#ffab91';
	var deepOrange300 = exports.deepOrange300 = '#ff8a65';
	var deepOrange400 = exports.deepOrange400 = '#ff7043';
	var deepOrange500 = exports.deepOrange500 = '#ff5722';
	var deepOrange600 = exports.deepOrange600 = '#f4511e';
	var deepOrange700 = exports.deepOrange700 = '#e64a19';
	var deepOrange800 = exports.deepOrange800 = '#d84315';
	var deepOrange900 = exports.deepOrange900 = '#bf360c';
	var deepOrangeA100 = exports.deepOrangeA100 = '#ff9e80';
	var deepOrangeA200 = exports.deepOrangeA200 = '#ff6e40';
	var deepOrangeA400 = exports.deepOrangeA400 = '#ff3d00';
	var deepOrangeA700 = exports.deepOrangeA700 = '#dd2c00';
	
	var brown50 = exports.brown50 = '#efebe9';
	var brown100 = exports.brown100 = '#d7ccc8';
	var brown200 = exports.brown200 = '#bcaaa4';
	var brown300 = exports.brown300 = '#a1887f';
	var brown400 = exports.brown400 = '#8d6e63';
	var brown500 = exports.brown500 = '#795548';
	var brown600 = exports.brown600 = '#6d4c41';
	var brown700 = exports.brown700 = '#5d4037';
	var brown800 = exports.brown800 = '#4e342e';
	var brown900 = exports.brown900 = '#3e2723';
	
	var blueGrey50 = exports.blueGrey50 = '#eceff1';
	var blueGrey100 = exports.blueGrey100 = '#cfd8dc';
	var blueGrey200 = exports.blueGrey200 = '#b0bec5';
	var blueGrey300 = exports.blueGrey300 = '#90a4ae';
	var blueGrey400 = exports.blueGrey400 = '#78909c';
	var blueGrey500 = exports.blueGrey500 = '#607d8b';
	var blueGrey600 = exports.blueGrey600 = '#546e7a';
	var blueGrey700 = exports.blueGrey700 = '#455a64';
	var blueGrey800 = exports.blueGrey800 = '#37474f';
	var blueGrey900 = exports.blueGrey900 = '#263238';
	
	var grey50 = exports.grey50 = '#fafafa';
	var grey100 = exports.grey100 = '#f5f5f5';
	var grey200 = exports.grey200 = '#eeeeee';
	var grey300 = exports.grey300 = '#e0e0e0';
	var grey400 = exports.grey400 = '#bdbdbd';
	var grey500 = exports.grey500 = '#9e9e9e';
	var grey600 = exports.grey600 = '#757575';
	var grey700 = exports.grey700 = '#616161';
	var grey800 = exports.grey800 = '#424242';
	var grey900 = exports.grey900 = '#212121';
	
	var black = exports.black = '#000000';
	var white = exports.white = '#ffffff';
	
	var transparent = exports.transparent = 'rgba(0, 0, 0, 0)';
	var fullBlack = exports.fullBlack = 'rgba(0, 0, 0, 1)';
	var darkBlack = exports.darkBlack = 'rgba(0, 0, 0, 0.87)';
	var lightBlack = exports.lightBlack = 'rgba(0, 0, 0, 0.54)';
	var minBlack = exports.minBlack = 'rgba(0, 0, 0, 0.26)';
	var faintBlack = exports.faintBlack = 'rgba(0, 0, 0, 0.12)';
	var fullWhite = exports.fullWhite = 'rgba(255, 255, 255, 1)';
	var darkWhite = exports.darkWhite = 'rgba(255, 255, 255, 0.87)';
	var lightWhite = exports.lightWhite = 'rgba(255, 255, 255, 0.54)';

/***/ }),
/* 822 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  iconSize: 24,
	
	  desktopGutter: 24,
	  desktopGutterMore: 32,
	  desktopGutterLess: 16,
	  desktopGutterMini: 8,
	  desktopKeylineIncrement: 64,
	  desktopDropDownMenuItemHeight: 32,
	  desktopDropDownMenuFontSize: 15,
	  desktopDrawerMenuItemHeight: 48,
	  desktopSubheaderHeight: 48,
	  desktopToolbarHeight: 56
	};

/***/ }),
/* 823 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  menu: 1000,
	  appBar: 1100,
	  drawerOverlay: 1200,
	  drawer: 1300,
	  dialogOverlay: 1400,
	  dialog: 1500,
	  layer: 2000,
	  popover: 2100,
	  snackbar: 2900,
	  tooltip: 3000
	};

/***/ }),
/* 824 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	exports.default = function (muiTheme) {
	  var userAgent = muiTheme.userAgent;
	
	  if (userAgent === undefined && typeof navigator !== 'undefined') {
	    userAgent = navigator.userAgent;
	  }
	
	  if (userAgent === undefined && !hasWarnedAboutUserAgent) {
	     false ? (0, _warning2.default)(false, 'Material-UI: userAgent should be supplied in the muiTheme context\n      for server-side rendering.') : void 0;
	
	    hasWarnedAboutUserAgent = true;
	  }
	
	  if (userAgent === false) {
	    // Disabled autoprefixer
	    return null;
	  } else if (userAgent === 'all' || userAgent === undefined) {
	    // Prefix for all user agent
	    return function (style) {
	      return _inlineStylePrefixer2.default.prefixAll(style);
	    };
	  } else {
	    var _ret = function () {
	      var prefixer = new _inlineStylePrefixer2.default({
	        userAgent: userAgent
	      });
	
	      return {
	        v: function v(style) {
	          return prefixer.prefix(style);
	        }
	      };
	    }();
	
	    if ((typeof _ret === 'undefined' ? 'undefined' : _typeof(_ret)) === "object") return _ret.v;
	  }
	};
	
	var _inlineStylePrefixer = __webpack_require__(825);
	
	var _inlineStylePrefixer2 = _interopRequireDefault(_inlineStylePrefixer);
	
	var _warning = __webpack_require__(491);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var hasWarnedAboutUserAgent = false;

/***/ }),
/* 825 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	// special flexbox specifications
	
	
	var _prefixAll2 = __webpack_require__(826);
	
	var _prefixAll3 = _interopRequireDefault(_prefixAll2);
	
	var _getBrowserInformation = __webpack_require__(840);
	
	var _getBrowserInformation2 = _interopRequireDefault(_getBrowserInformation);
	
	var _getPrefixedKeyframes = __webpack_require__(843);
	
	var _getPrefixedKeyframes2 = _interopRequireDefault(_getPrefixedKeyframes);
	
	var _capitalizeString = __webpack_require__(828);
	
	var _capitalizeString2 = _interopRequireDefault(_capitalizeString);
	
	var _prefixProps = __webpack_require__(844);
	
	var _prefixProps2 = _interopRequireDefault(_prefixProps);
	
	var _calc = __webpack_require__(845);
	
	var _calc2 = _interopRequireDefault(_calc);
	
	var _zoomCursor = __webpack_require__(847);
	
	var _zoomCursor2 = _interopRequireDefault(_zoomCursor);
	
	var _grabCursor = __webpack_require__(848);
	
	var _grabCursor2 = _interopRequireDefault(_grabCursor);
	
	var _flex = __webpack_require__(849);
	
	var _flex2 = _interopRequireDefault(_flex);
	
	var _sizing = __webpack_require__(850);
	
	var _sizing2 = _interopRequireDefault(_sizing);
	
	var _gradient = __webpack_require__(851);
	
	var _gradient2 = _interopRequireDefault(_gradient);
	
	var _transition = __webpack_require__(852);
	
	var _transition2 = _interopRequireDefault(_transition);
	
	var _flexboxIE = __webpack_require__(854);
	
	var _flexboxIE2 = _interopRequireDefault(_flexboxIE);
	
	var _flexboxOld = __webpack_require__(855);
	
	var _flexboxOld2 = _interopRequireDefault(_flexboxOld);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var plugins = [_calc2.default, _zoomCursor2.default, _grabCursor2.default, _sizing2.default, _gradient2.default, _transition2.default, _flexboxIE2.default, _flexboxOld2.default,
	// this must be run AFTER the flexbox specs
	_flex2.default];
	
	var Prefixer = function () {
	  /**
	   * Instantiante a new prefixer
	   * @param {string} userAgent - userAgent to gather prefix information according to caniuse.com
	   * @param {string} keepUnprefixed - keeps unprefixed properties and values
	   */
	
	  function Prefixer() {
	    var _this = this;
	
	    var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	    _classCallCheck(this, Prefixer);
	
	    var defaultUserAgent = typeof navigator !== 'undefined' ? navigator.userAgent : undefined;
	
	    this._userAgent = options.userAgent || defaultUserAgent;
	    this._keepUnprefixed = options.keepUnprefixed || false;
	
	    this._browserInfo = (0, _getBrowserInformation2.default)(this._userAgent);
	
	    // Checks if the userAgent was resolved correctly
	    if (this._browserInfo && this._browserInfo.prefix) {
	      // set additional prefix information
	      this.cssPrefix = this._browserInfo.prefix.css;
	      this.jsPrefix = this._browserInfo.prefix.inline;
	      this.prefixedKeyframes = (0, _getPrefixedKeyframes2.default)(this._browserInfo);
	    } else {
	      this._usePrefixAllFallback = true;
	      return false;
	    }
	
	    var data = this._browserInfo.browser && _prefixProps2.default[this._browserInfo.browser];
	    if (data) {
	      this._requiresPrefix = Object.keys(data).filter(function (key) {
	        return data[key] >= _this._browserInfo.version;
	      }).reduce(function (result, name) {
	        result[name] = true;
	        return result;
	      }, {});
	      this._hasPropsRequiringPrefix = Object.keys(this._requiresPrefix).length > 0;
	    } else {
	      this._usePrefixAllFallback = true;
	    }
	  }
	
	  /**
	   * Returns a prefixed version of the style object
	   * @param {Object} styles - Style object that gets prefixed properties added
	   * @returns {Object} - Style object with prefixed properties and values
	   */
	
	
	  _createClass(Prefixer, [{
	    key: 'prefix',
	    value: function prefix(styles) {
	      var _this2 = this;
	
	      // use prefixAll as fallback if userAgent can not be resolved
	      if (this._usePrefixAllFallback) {
	        return (0, _prefixAll3.default)(styles);
	      }
	
	      // only add prefixes if needed
	      if (!this._hasPropsRequiringPrefix) {
	        return styles;
	      }
	
	      Object.keys(styles).forEach(function (property) {
	        var value = styles[property];
	        if (value instanceof Object && !Array.isArray(value)) {
	          // recurse through nested style objects
	          styles[property] = _this2.prefix(value);
	        } else {
	          // add prefixes if needed
	          if (_this2._requiresPrefix[property]) {
	            styles[_this2.jsPrefix + (0, _capitalizeString2.default)(property)] = value;
	            if (!_this2._keepUnprefixed) {
	              delete styles[property];
	            }
	          }
	        }
	      });
	
	      Object.keys(styles).forEach(function (property) {
	        [].concat(styles[property]).forEach(function (value) {
	          // resolve plugins
	          plugins.forEach(function (plugin) {
	            // generates a new plugin interface with current data
	            assignStyles(styles, plugin({
	              property: property,
	              value: value,
	              styles: styles,
	              browserInfo: _this2._browserInfo,
	              prefix: {
	                js: _this2.jsPrefix,
	                css: _this2.cssPrefix,
	                keyframes: _this2.prefixedKeyframes
	              },
	              keepUnprefixed: _this2._keepUnprefixed,
	              requiresPrefix: _this2._requiresPrefix
	            }), value, _this2._keepUnprefixed);
	          });
	        });
	      });
	
	      return styles;
	    }
	
	    /**
	     * Returns a prefixed version of the style object using all vendor prefixes
	     * @param {Object} styles - Style object that gets prefixed properties added
	     * @returns {Object} - Style object with prefixed properties and values
	     */
	
	  }], [{
	    key: 'prefixAll',
	    value: function prefixAll(styles) {
	      return (0, _prefixAll3.default)(styles);
	    }
	  }]);
	
	  return Prefixer;
	}();
	
	exports.default = Prefixer;
	
	
	function assignStyles(base) {
	  var extend = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	  var value = arguments[2];
	  var keepUnprefixed = arguments[3];
	
	  Object.keys(extend).forEach(function (property) {
	    var baseValue = base[property];
	    if (Array.isArray(baseValue)) {
	      [].concat(extend[property]).forEach(function (val) {
	        if (base[property].indexOf(val) === -1) {
	          base[property].splice(baseValue.indexOf(value), keepUnprefixed ? 0 : 1, val);
	        }
	      });
	    } else {
	      base[property] = extend[property];
	    }
	  });
	}
	module.exports = exports['default'];

/***/ }),
/* 826 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = prefixAll;
	
	var _prefixProps = __webpack_require__(827);
	
	var _prefixProps2 = _interopRequireDefault(_prefixProps);
	
	var _capitalizeString = __webpack_require__(828);
	
	var _capitalizeString2 = _interopRequireDefault(_capitalizeString);
	
	var _calc = __webpack_require__(829);
	
	var _calc2 = _interopRequireDefault(_calc);
	
	var _cursor = __webpack_require__(832);
	
	var _cursor2 = _interopRequireDefault(_cursor);
	
	var _flex = __webpack_require__(833);
	
	var _flex2 = _interopRequireDefault(_flex);
	
	var _sizing = __webpack_require__(834);
	
	var _sizing2 = _interopRequireDefault(_sizing);
	
	var _gradient = __webpack_require__(835);
	
	var _gradient2 = _interopRequireDefault(_gradient);
	
	var _transition = __webpack_require__(836);
	
	var _transition2 = _interopRequireDefault(_transition);
	
	var _flexboxIE = __webpack_require__(838);
	
	var _flexboxIE2 = _interopRequireDefault(_flexboxIE);
	
	var _flexboxOld = __webpack_require__(839);
	
	var _flexboxOld2 = _interopRequireDefault(_flexboxOld);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// special flexbox specifications
	
	
	var plugins = [_calc2.default, _cursor2.default, _sizing2.default, _gradient2.default, _transition2.default, _flexboxIE2.default, _flexboxOld2.default, _flex2.default];
	
	/**
	 * Returns a prefixed version of the style object using all vendor prefixes
	 * @param {Object} styles - Style object that gets prefixed properties added
	 * @returns {Object} - Style object with prefixed properties and values
	 */
	function prefixAll(styles) {
	  Object.keys(styles).forEach(function (property) {
	    var value = styles[property];
	    if (value instanceof Object && !Array.isArray(value)) {
	      // recurse through nested style objects
	      styles[property] = prefixAll(value);
	    } else {
	      Object.keys(_prefixProps2.default).forEach(function (prefix) {
	        var properties = _prefixProps2.default[prefix];
	        // add prefixes if needed
	        if (properties[property]) {
	          styles[prefix + (0, _capitalizeString2.default)(property)] = value;
	        }
	      });
	    }
	  });
	
	  Object.keys(styles).forEach(function (property) {
	    [].concat(styles[property]).forEach(function (value, index) {
	      // resolve every special plugins
	      plugins.forEach(function (plugin) {
	        return assignStyles(styles, plugin(property, value));
	      });
	    });
	  });
	
	  return styles;
	}
	
	function assignStyles(base) {
	  var extend = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	
	  Object.keys(extend).forEach(function (property) {
	    var baseValue = base[property];
	    if (Array.isArray(baseValue)) {
	      [].concat(extend[property]).forEach(function (value) {
	        var valueIndex = baseValue.indexOf(value);
	        if (valueIndex > -1) {
	          base[property].splice(valueIndex, 1);
	        }
	        base[property].push(value);
	      });
	    } else {
	      base[property] = extend[property];
	    }
	  });
	}
	module.exports = exports['default'];

/***/ }),
/* 827 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = { "Webkit": { "transform": true, "transformOrigin": true, "transformOriginX": true, "transformOriginY": true, "backfaceVisibility": true, "perspective": true, "perspectiveOrigin": true, "transformStyle": true, "transformOriginZ": true, "animation": true, "animationDelay": true, "animationDirection": true, "animationFillMode": true, "animationDuration": true, "animationIterationCount": true, "animationName": true, "animationPlayState": true, "animationTimingFunction": true, "appearance": true, "userSelect": true, "fontKerning": true, "textEmphasisPosition": true, "textEmphasis": true, "textEmphasisStyle": true, "textEmphasisColor": true, "boxDecorationBreak": true, "clipPath": true, "maskImage": true, "maskMode": true, "maskRepeat": true, "maskPosition": true, "maskClip": true, "maskOrigin": true, "maskSize": true, "maskComposite": true, "mask": true, "maskBorderSource": true, "maskBorderMode": true, "maskBorderSlice": true, "maskBorderWidth": true, "maskBorderOutset": true, "maskBorderRepeat": true, "maskBorder": true, "maskType": true, "textDecorationStyle": true, "textDecorationSkip": true, "textDecorationLine": true, "textDecorationColor": true, "filter": true, "fontFeatureSettings": true, "breakAfter": true, "breakBefore": true, "breakInside": true, "columnCount": true, "columnFill": true, "columnGap": true, "columnRule": true, "columnRuleColor": true, "columnRuleStyle": true, "columnRuleWidth": true, "columns": true, "columnSpan": true, "columnWidth": true, "flex": true, "flexBasis": true, "flexDirection": true, "flexGrow": true, "flexFlow": true, "flexShrink": true, "flexWrap": true, "alignContent": true, "alignItems": true, "alignSelf": true, "justifyContent": true, "order": true, "transition": true, "transitionDelay": true, "transitionDuration": true, "transitionProperty": true, "transitionTimingFunction": true, "backdropFilter": true, "scrollSnapType": true, "scrollSnapPointsX": true, "scrollSnapPointsY": true, "scrollSnapDestination": true, "scrollSnapCoordinate": true, "shapeImageThreshold": true, "shapeImageMargin": true, "shapeImageOutside": true, "hyphens": true, "flowInto": true, "flowFrom": true, "regionFragment": true, "textSizeAdjust": true, "borderImage": true, "borderImageOutset": true, "borderImageRepeat": true, "borderImageSlice": true, "borderImageSource": true, "borderImageWidth": true, "tabSize": true, "objectFit": true, "objectPosition": true }, "Moz": { "appearance": true, "userSelect": true, "boxSizing": true, "textAlignLast": true, "textDecorationStyle": true, "textDecorationSkip": true, "textDecorationLine": true, "textDecorationColor": true, "tabSize": true, "hyphens": true, "fontFeatureSettings": true, "breakAfter": true, "breakBefore": true, "breakInside": true, "columnCount": true, "columnFill": true, "columnGap": true, "columnRule": true, "columnRuleColor": true, "columnRuleStyle": true, "columnRuleWidth": true, "columns": true, "columnSpan": true, "columnWidth": true }, "ms": { "flex": true, "flexBasis": false, "flexDirection": true, "flexGrow": false, "flexFlow": true, "flexShrink": false, "flexWrap": true, "alignContent": false, "alignItems": false, "alignSelf": false, "justifyContent": false, "order": false, "transform": true, "transformOrigin": true, "transformOriginX": true, "transformOriginY": true, "userSelect": true, "wrapFlow": true, "wrapThrough": true, "wrapMargin": true, "scrollSnapType": true, "scrollSnapPointsX": true, "scrollSnapPointsY": true, "scrollSnapDestination": true, "scrollSnapCoordinate": true, "touchAction": true, "hyphens": true, "flowInto": true, "flowFrom": true, "breakBefore": true, "breakAfter": true, "breakInside": true, "regionFragment": true, "gridTemplateColumns": true, "gridTemplateRows": true, "gridTemplateAreas": true, "gridTemplate": true, "gridAutoColumns": true, "gridAutoRows": true, "gridAutoFlow": true, "grid": true, "gridRowStart": true, "gridColumnStart": true, "gridRowEnd": true, "gridRow": true, "gridColumn": true, "gridColumnEnd": true, "gridColumnGap": true, "gridRowGap": true, "gridArea": true, "gridGap": true, "textSizeAdjust": true } };
	module.exports = exports["default"];

/***/ }),
/* 828 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	// helper to capitalize strings
	
	exports.default = function (str) {
	  return str.charAt(0).toUpperCase() + str.slice(1);
	};
	
	module.exports = exports["default"];

/***/ }),
/* 829 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = calc;
	
	var _joinPrefixedValue = __webpack_require__(830);
	
	var _joinPrefixedValue2 = _interopRequireDefault(_joinPrefixedValue);
	
	var _isPrefixedValue = __webpack_require__(831);
	
	var _isPrefixedValue2 = _interopRequireDefault(_isPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function calc(property, value) {
	  if (typeof value === 'string' && !(0, _isPrefixedValue2.default)(value) && value.indexOf('calc(') > -1) {
	    return (0, _joinPrefixedValue2.default)(property, value, function (prefix, value) {
	      return value.replace(/calc\(/g, prefix + 'calc(');
	    });
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 830 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	// returns a style object with a single concated prefixed value string
	
	exports.default = function (property, value) {
	  var replacer = arguments.length <= 2 || arguments[2] === undefined ? function (prefix, value) {
	    return prefix + value;
	  } : arguments[2];
	  return _defineProperty({}, property, ['-webkit-', '-moz-', ''].map(function (prefix) {
	    return replacer(prefix, value);
	  }));
	};
	
	module.exports = exports['default'];

/***/ }),
/* 831 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (value) {
	  if (Array.isArray(value)) value = value.join(',');
	
	  return value.match(/-webkit-|-moz-|-ms-/) !== null;
	};
	
	module.exports = exports['default'];

/***/ }),
/* 832 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = cursor;
	
	var _joinPrefixedValue = __webpack_require__(830);
	
	var _joinPrefixedValue2 = _interopRequireDefault(_joinPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var values = {
	  'zoom-in': true,
	  'zoom-out': true,
	  grab: true,
	  grabbing: true
	};
	
	function cursor(property, value) {
	  if (property === 'cursor' && values[value]) {
	    return (0, _joinPrefixedValue2.default)(property, value);
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 833 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = flex;
	var values = { flex: true, 'inline-flex': true };
	
	function flex(property, value) {
	  if (property === 'display' && values[value]) {
	    return {
	      display: ['-webkit-box', '-moz-box', '-ms-' + value + 'box', '-webkit-' + value, value]
	    };
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 834 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = sizing;
	
	var _joinPrefixedValue = __webpack_require__(830);
	
	var _joinPrefixedValue2 = _interopRequireDefault(_joinPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var properties = {
	  maxHeight: true,
	  maxWidth: true,
	  width: true,
	  height: true,
	  columnWidth: true,
	  minWidth: true,
	  minHeight: true
	};
	var values = {
	  'min-content': true,
	  'max-content': true,
	  'fill-available': true,
	  'fit-content': true,
	  'contain-floats': true
	};
	
	function sizing(property, value) {
	  if (properties[property] && values[value]) {
	    return (0, _joinPrefixedValue2.default)(property, value);
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 835 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = gradient;
	
	var _joinPrefixedValue = __webpack_require__(830);
	
	var _joinPrefixedValue2 = _interopRequireDefault(_joinPrefixedValue);
	
	var _isPrefixedValue = __webpack_require__(831);
	
	var _isPrefixedValue2 = _interopRequireDefault(_isPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var values = /linear-gradient|radial-gradient|repeating-linear-gradient|repeating-radial-gradient/;
	
	function gradient(property, value) {
	  if (typeof value === 'string' && !(0, _isPrefixedValue2.default)(value) && value.match(values) !== null) {
	    return (0, _joinPrefixedValue2.default)(property, value);
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 836 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = transition;
	
	var _hyphenateStyleName = __webpack_require__(837);
	
	var _hyphenateStyleName2 = _interopRequireDefault(_hyphenateStyleName);
	
	var _capitalizeString = __webpack_require__(828);
	
	var _capitalizeString2 = _interopRequireDefault(_capitalizeString);
	
	var _isPrefixedValue = __webpack_require__(831);
	
	var _isPrefixedValue2 = _interopRequireDefault(_isPrefixedValue);
	
	var _prefixProps = __webpack_require__(827);
	
	var _prefixProps2 = _interopRequireDefault(_prefixProps);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var properties = {
	  transition: true,
	  transitionProperty: true,
	  WebkitTransition: true,
	  WebkitTransitionProperty: true
	};
	
	function transition(property, value) {
	  // also check for already prefixed transitions
	  if (typeof value === 'string' && properties[property]) {
	    var _ref2;
	
	    var outputValue = prefixValue(value);
	    var webkitOutput = outputValue.split(/,(?![^()]*(?:\([^()]*\))?\))/g).filter(function (value) {
	      return value.match(/-moz-|-ms-/) === null;
	    }).join(',');
	
	    // if the property is already prefixed
	    if (property.indexOf('Webkit') > -1) {
	      return _defineProperty({}, property, webkitOutput);
	    }
	
	    return _ref2 = {}, _defineProperty(_ref2, 'Webkit' + (0, _capitalizeString2.default)(property), webkitOutput), _defineProperty(_ref2, property, outputValue), _ref2;
	  }
	}
	
	function prefixValue(value) {
	  if ((0, _isPrefixedValue2.default)(value)) {
	    return value;
	  }
	
	  // only split multi values, not cubic beziers
	  var multipleValues = value.split(/,(?![^()]*(?:\([^()]*\))?\))/g);
	
	  // iterate each single value and check for transitioned properties
	  // that need to be prefixed as well
	  multipleValues.forEach(function (val, index) {
	    multipleValues[index] = Object.keys(_prefixProps2.default).reduce(function (out, prefix) {
	      var dashCasePrefix = '-' + prefix.toLowerCase() + '-';
	
	      Object.keys(_prefixProps2.default[prefix]).forEach(function (prop) {
	        var dashCaseProperty = (0, _hyphenateStyleName2.default)(prop);
	
	        if (val.indexOf(dashCaseProperty) > -1 && dashCaseProperty !== 'order') {
	          // join all prefixes and create a new value
	          out = val.replace(dashCaseProperty, dashCasePrefix + dashCaseProperty) + ',' + out;
	        }
	      });
	      return out;
	    }, val);
	  });
	
	  return multipleValues.join(',');
	}
	module.exports = exports['default'];

/***/ }),
/* 837 */
/***/ (function(module, exports) {

	'use strict';
	
	var uppercasePattern = /[A-Z]/g;
	var msPattern = /^ms-/;
	
	function hyphenateStyleName(string) {
	    return string
	        .replace(uppercasePattern, '-$&')
	        .toLowerCase()
	        .replace(msPattern, '-ms-');
	}
	
	module.exports = hyphenateStyleName;


/***/ }),
/* 838 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = flexboxIE;
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var alternativeValues = {
	  'space-around': 'distribute',
	  'space-between': 'justify',
	  'flex-start': 'start',
	  'flex-end': 'end'
	};
	var alternativeProps = {
	  alignContent: 'msFlexLinePack',
	  alignSelf: 'msFlexItemAlign',
	  alignItems: 'msFlexAlign',
	  justifyContent: 'msFlexPack',
	  order: 'msFlexOrder',
	  flexGrow: 'msFlexPositive',
	  flexShrink: 'msFlexNegative',
	  flexBasis: 'msPreferredSize'
	};
	
	function flexboxIE(property, value) {
	  if (alternativeProps[property]) {
	    return _defineProperty({}, alternativeProps[property], alternativeValues[value] || value);
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 839 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = flexboxOld;
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var alternativeValues = {
	  'space-around': 'justify',
	  'space-between': 'justify',
	  'flex-start': 'start',
	  'flex-end': 'end',
	  'wrap-reverse': 'multiple',
	  wrap: 'multiple'
	};
	
	var alternativeProps = {
	  alignItems: 'WebkitBoxAlign',
	  justifyContent: 'WebkitBoxPack',
	  flexWrap: 'WebkitBoxLines'
	};
	
	function flexboxOld(property, value) {
	  if (property === 'flexDirection') {
	    return {
	      WebkitBoxOrient: value.indexOf('column') > -1 ? 'vertical' : 'horizontal',
	      WebkitBoxDirection: value.indexOf('reverse') > -1 ? 'reverse' : 'normal'
	    };
	  }
	  if (alternativeProps[property]) {
	    return _defineProperty({}, alternativeProps[property], alternativeValues[value] || value);
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 840 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _bowser = __webpack_require__(841);
	
	var _bowser2 = _interopRequireDefault(_bowser);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var vendorPrefixes = {
	  Webkit: ['chrome', 'safari', 'ios', 'android', 'phantom', 'opera', 'webos', 'blackberry', 'bada', 'tizen', 'chromium', 'vivaldi'],
	  Moz: ['firefox', 'seamonkey', 'sailfish'],
	  ms: ['msie', 'msedge']
	};
	
	var browsers = {
	  chrome: [['chrome'], ['chromium']],
	  safari: [['safari']],
	  firefox: [['firefox']],
	  ie: [['msie']],
	  edge: [['msedge']],
	  opera: [['opera'], ['vivaldi']],
	  ios_saf: [['ios', 'mobile'], ['ios', 'tablet']],
	  ie_mob: [['windowsphone', 'mobile', 'msie'], ['windowsphone', 'tablet', 'msie'], ['windowsphone', 'mobile', 'msedge'], ['windowsphone', 'tablet', 'msedge']],
	  op_mini: [['opera', 'mobile'], ['opera', 'tablet']],
	  and_uc: [['android', 'mobile'], ['android', 'tablet']],
	  android: [['android', 'mobile'], ['android', 'tablet']]
	};
	
	/**
	 * Uses bowser to get default browser information such as version and name
	 * Evaluates bowser info and adds vendorPrefix information
	 * @param {string} userAgent - userAgent that gets evaluated
	 */
	
	exports.default = function (userAgent) {
	  if (!userAgent) {
	    return false;
	  }
	
	  var info = _bowser2.default._detect(userAgent);
	
	  Object.keys(vendorPrefixes).forEach(function (prefix) {
	    vendorPrefixes[prefix].forEach(function (browser) {
	      if (info[browser]) {
	        info.prefix = {
	          inline: prefix,
	          css: '-' + prefix.toLowerCase() + '-'
	        };
	      }
	    });
	  });
	
	  var name = '';
	  Object.keys(browsers).forEach(function (browser) {
	    browsers[browser].forEach(function (condition) {
	      var match = 0;
	      condition.forEach(function (single) {
	        if (info[single]) {
	          match += 1;
	        }
	      });
	      if (condition.length === match) {
	        name = browser;
	      }
	    });
	  });
	
	  info.browser = name;
	  // For cordova IOS 8 the version is missing, set truncated osversion to prevent NaN
	  info.version = info.version ? parseFloat(info.version) : parseInt(parseFloat(info.osversion), 10);
	
	  // seperate native android chrome
	  // https://github.com/rofrischmann/inline-style-prefixer/issues/45
	  if (info.browser === 'android' && info.chrome && info.version > 37) {
	    info.browser = 'and_chr';
	  }
	  info.version = parseFloat(info.version);
	  info.osversion = parseFloat(info.osversion);
	  // For android < 4.4 we want to check the osversion
	  // not the chrome version, see issue #26
	  // https://github.com/rofrischmann/inline-style-prefixer/issues/26
	  if (info.browser === 'android' && info.osversion < 5) {
	    info.version = info.osversion;
	  }
	
	  return info;
	};
	
	module.exports = exports['default'];

/***/ }),
/* 841 */
/***/ (function(module, exports, __webpack_require__) {

	/*!
	 * Bowser - a browser detector
	 * https://github.com/ded/bowser
	 * MIT License | (c) Dustin Diaz 2015
	 */
	
	!function (name, definition) {
	  if (typeof module != 'undefined' && module.exports) module.exports = definition()
	  else if (true) __webpack_require__(842)(name, definition)
	  else this[name] = definition()
	}('bowser', function () {
	  /**
	    * See useragents.js for examples of navigator.userAgent
	    */
	
	  var t = true
	
	  function detect(ua) {
	
	    function getFirstMatch(regex) {
	      var match = ua.match(regex);
	      return (match && match.length > 1 && match[1]) || '';
	    }
	
	    function getSecondMatch(regex) {
	      var match = ua.match(regex);
	      return (match && match.length > 1 && match[2]) || '';
	    }
	
	    var iosdevice = getFirstMatch(/(ipod|iphone|ipad)/i).toLowerCase()
	      , likeAndroid = /like android/i.test(ua)
	      , android = !likeAndroid && /android/i.test(ua)
	      , nexusMobile = /nexus\s*[0-6]\s*/i.test(ua)
	      , nexusTablet = !nexusMobile && /nexus\s*[0-9]+/i.test(ua)
	      , chromeos = /CrOS/.test(ua)
	      , silk = /silk/i.test(ua)
	      , sailfish = /sailfish/i.test(ua)
	      , tizen = /tizen/i.test(ua)
	      , webos = /(web|hpw)os/i.test(ua)
	      , windowsphone = /windows phone/i.test(ua)
	      , windows = !windowsphone && /windows/i.test(ua)
	      , mac = !iosdevice && !silk && /macintosh/i.test(ua)
	      , linux = !android && !sailfish && !tizen && !webos && /linux/i.test(ua)
	      , edgeVersion = getFirstMatch(/edge\/(\d+(\.\d+)?)/i)
	      , versionIdentifier = getFirstMatch(/version\/(\d+(\.\d+)?)/i)
	      , tablet = /tablet/i.test(ua)
	      , mobile = !tablet && /[^-]mobi/i.test(ua)
	      , xbox = /xbox/i.test(ua)
	      , result
	
	    if (/opera|opr|opios/i.test(ua)) {
	      result = {
	        name: 'Opera'
	      , opera: t
	      , version: versionIdentifier || getFirstMatch(/(?:opera|opr|opios)[\s\/](\d+(\.\d+)?)/i)
	      }
	    }
	    else if (/coast/i.test(ua)) {
	      result = {
	        name: 'Opera Coast'
	        , coast: t
	        , version: versionIdentifier || getFirstMatch(/(?:coast)[\s\/](\d+(\.\d+)?)/i)
	      }
	    }
	    else if (/yabrowser/i.test(ua)) {
	      result = {
	        name: 'Yandex Browser'
	      , yandexbrowser: t
	      , version: versionIdentifier || getFirstMatch(/(?:yabrowser)[\s\/](\d+(\.\d+)?)/i)
	      }
	    }
	    else if (/ucbrowser/i.test(ua)) {
	      result = {
	          name: 'UC Browser'
	        , ucbrowser: t
	        , version: getFirstMatch(/(?:ucbrowser)[\s\/](\d+(?:\.\d+)+)/i)
	      }
	    }
	    else if (/mxios/i.test(ua)) {
	      result = {
	        name: 'Maxthon'
	        , maxthon: t
	        , version: getFirstMatch(/(?:mxios)[\s\/](\d+(?:\.\d+)+)/i)
	      }
	    }
	    else if (/epiphany/i.test(ua)) {
	      result = {
	        name: 'Epiphany'
	        , epiphany: t
	        , version: getFirstMatch(/(?:epiphany)[\s\/](\d+(?:\.\d+)+)/i)
	      }
	    }
	    else if (/puffin/i.test(ua)) {
	      result = {
	        name: 'Puffin'
	        , puffin: t
	        , version: getFirstMatch(/(?:puffin)[\s\/](\d+(?:\.\d+)?)/i)
	      }
	    }
	    else if (/sleipnir/i.test(ua)) {
	      result = {
	        name: 'Sleipnir'
	        , sleipnir: t
	        , version: getFirstMatch(/(?:sleipnir)[\s\/](\d+(?:\.\d+)+)/i)
	      }
	    }
	    else if (/k-meleon/i.test(ua)) {
	      result = {
	        name: 'K-Meleon'
	        , kMeleon: t
	        , version: getFirstMatch(/(?:k-meleon)[\s\/](\d+(?:\.\d+)+)/i)
	      }
	    }
	    else if (windowsphone) {
	      result = {
	        name: 'Windows Phone'
	      , windowsphone: t
	      }
	      if (edgeVersion) {
	        result.msedge = t
	        result.version = edgeVersion
	      }
	      else {
	        result.msie = t
	        result.version = getFirstMatch(/iemobile\/(\d+(\.\d+)?)/i)
	      }
	    }
	    else if (/msie|trident/i.test(ua)) {
	      result = {
	        name: 'Internet Explorer'
	      , msie: t
	      , version: getFirstMatch(/(?:msie |rv:)(\d+(\.\d+)?)/i)
	      }
	    } else if (chromeos) {
	      result = {
	        name: 'Chrome'
	      , chromeos: t
	      , chromeBook: t
	      , chrome: t
	      , version: getFirstMatch(/(?:chrome|crios|crmo)\/(\d+(\.\d+)?)/i)
	      }
	    } else if (/chrome.+? edge/i.test(ua)) {
	      result = {
	        name: 'Microsoft Edge'
	      , msedge: t
	      , version: edgeVersion
	      }
	    }
	    else if (/vivaldi/i.test(ua)) {
	      result = {
	        name: 'Vivaldi'
	        , vivaldi: t
	        , version: getFirstMatch(/vivaldi\/(\d+(\.\d+)?)/i) || versionIdentifier
	      }
	    }
	    else if (sailfish) {
	      result = {
	        name: 'Sailfish'
	      , sailfish: t
	      , version: getFirstMatch(/sailfish\s?browser\/(\d+(\.\d+)?)/i)
	      }
	    }
	    else if (/seamonkey\//i.test(ua)) {
	      result = {
	        name: 'SeaMonkey'
	      , seamonkey: t
	      , version: getFirstMatch(/seamonkey\/(\d+(\.\d+)?)/i)
	      }
	    }
	    else if (/firefox|iceweasel|fxios/i.test(ua)) {
	      result = {
	        name: 'Firefox'
	      , firefox: t
	      , version: getFirstMatch(/(?:firefox|iceweasel|fxios)[ \/](\d+(\.\d+)?)/i)
	      }
	      if (/\((mobile|tablet);[^\)]*rv:[\d\.]+\)/i.test(ua)) {
	        result.firefoxos = t
	      }
	    }
	    else if (silk) {
	      result =  {
	        name: 'Amazon Silk'
	      , silk: t
	      , version : getFirstMatch(/silk\/(\d+(\.\d+)?)/i)
	      }
	    }
	    else if (/phantom/i.test(ua)) {
	      result = {
	        name: 'PhantomJS'
	      , phantom: t
	      , version: getFirstMatch(/phantomjs\/(\d+(\.\d+)?)/i)
	      }
	    }
	    else if (/slimerjs/i.test(ua)) {
	      result = {
	        name: 'SlimerJS'
	        , slimer: t
	        , version: getFirstMatch(/slimerjs\/(\d+(\.\d+)?)/i)
	      }
	    }
	    else if (/blackberry|\bbb\d+/i.test(ua) || /rim\stablet/i.test(ua)) {
	      result = {
	        name: 'BlackBerry'
	      , blackberry: t
	      , version: versionIdentifier || getFirstMatch(/blackberry[\d]+\/(\d+(\.\d+)?)/i)
	      }
	    }
	    else if (webos) {
	      result = {
	        name: 'WebOS'
	      , webos: t
	      , version: versionIdentifier || getFirstMatch(/w(?:eb)?osbrowser\/(\d+(\.\d+)?)/i)
	      };
	      /touchpad\//i.test(ua) && (result.touchpad = t)
	    }
	    else if (/bada/i.test(ua)) {
	      result = {
	        name: 'Bada'
	      , bada: t
	      , version: getFirstMatch(/dolfin\/(\d+(\.\d+)?)/i)
	      };
	    }
	    else if (tizen) {
	      result = {
	        name: 'Tizen'
	      , tizen: t
	      , version: getFirstMatch(/(?:tizen\s?)?browser\/(\d+(\.\d+)?)/i) || versionIdentifier
	      };
	    }
	    else if (/qupzilla/i.test(ua)) {
	      result = {
	        name: 'QupZilla'
	        , qupzilla: t
	        , version: getFirstMatch(/(?:qupzilla)[\s\/](\d+(?:\.\d+)+)/i) || versionIdentifier
	      }
	    }
	    else if (/chromium/i.test(ua)) {
	      result = {
	        name: 'Chromium'
	        , chromium: t
	        , version: getFirstMatch(/(?:chromium)[\s\/](\d+(?:\.\d+)?)/i) || versionIdentifier
	      }
	    }
	    else if (/chrome|crios|crmo/i.test(ua)) {
	      result = {
	        name: 'Chrome'
	        , chrome: t
	        , version: getFirstMatch(/(?:chrome|crios|crmo)\/(\d+(\.\d+)?)/i)
	      }
	    }
	    else if (android) {
	      result = {
	        name: 'Android'
	        , version: versionIdentifier
	      }
	    }
	    else if (/safari|applewebkit/i.test(ua)) {
	      result = {
	        name: 'Safari'
	      , safari: t
	      }
	      if (versionIdentifier) {
	        result.version = versionIdentifier
	      }
	    }
	    else if (iosdevice) {
	      result = {
	        name : iosdevice == 'iphone' ? 'iPhone' : iosdevice == 'ipad' ? 'iPad' : 'iPod'
	      }
	      // WTF: version is not part of user agent in web apps
	      if (versionIdentifier) {
	        result.version = versionIdentifier
	      }
	    }
	    else if(/googlebot/i.test(ua)) {
	      result = {
	        name: 'Googlebot'
	      , googlebot: t
	      , version: getFirstMatch(/googlebot\/(\d+(\.\d+))/i) || versionIdentifier
	      }
	    }
	    else {
	      result = {
	        name: getFirstMatch(/^(.*)\/(.*) /),
	        version: getSecondMatch(/^(.*)\/(.*) /)
	     };
	   }
	
	    // set webkit or gecko flag for browsers based on these engines
	    if (!result.msedge && /(apple)?webkit/i.test(ua)) {
	      if (/(apple)?webkit\/537\.36/i.test(ua)) {
	        result.name = result.name || "Blink"
	        result.blink = t
	      } else {
	        result.name = result.name || "Webkit"
	        result.webkit = t
	      }
	      if (!result.version && versionIdentifier) {
	        result.version = versionIdentifier
	      }
	    } else if (!result.opera && /gecko\//i.test(ua)) {
	      result.name = result.name || "Gecko"
	      result.gecko = t
	      result.version = result.version || getFirstMatch(/gecko\/(\d+(\.\d+)?)/i)
	    }
	
	    // set OS flags for platforms that have multiple browsers
	    if (!result.msedge && (android || result.silk)) {
	      result.android = t
	    } else if (iosdevice) {
	      result[iosdevice] = t
	      result.ios = t
	    } else if (mac) {
	      result.mac = t
	    } else if (xbox) {
	      result.xbox = t
	    } else if (windows) {
	      result.windows = t
	    } else if (linux) {
	      result.linux = t
	    }
	
	    // OS version extraction
	    var osVersion = '';
	    if (result.windowsphone) {
	      osVersion = getFirstMatch(/windows phone (?:os)?\s?(\d+(\.\d+)*)/i);
	    } else if (iosdevice) {
	      osVersion = getFirstMatch(/os (\d+([_\s]\d+)*) like mac os x/i);
	      osVersion = osVersion.replace(/[_\s]/g, '.');
	    } else if (android) {
	      osVersion = getFirstMatch(/android[ \/-](\d+(\.\d+)*)/i);
	    } else if (result.webos) {
	      osVersion = getFirstMatch(/(?:web|hpw)os\/(\d+(\.\d+)*)/i);
	    } else if (result.blackberry) {
	      osVersion = getFirstMatch(/rim\stablet\sos\s(\d+(\.\d+)*)/i);
	    } else if (result.bada) {
	      osVersion = getFirstMatch(/bada\/(\d+(\.\d+)*)/i);
	    } else if (result.tizen) {
	      osVersion = getFirstMatch(/tizen[\/\s](\d+(\.\d+)*)/i);
	    }
	    if (osVersion) {
	      result.osversion = osVersion;
	    }
	
	    // device type extraction
	    var osMajorVersion = osVersion.split('.')[0];
	    if (
	         tablet
	      || nexusTablet
	      || iosdevice == 'ipad'
	      || (android && (osMajorVersion == 3 || (osMajorVersion >= 4 && !mobile)))
	      || result.silk
	    ) {
	      result.tablet = t
	    } else if (
	         mobile
	      || iosdevice == 'iphone'
	      || iosdevice == 'ipod'
	      || android
	      || nexusMobile
	      || result.blackberry
	      || result.webos
	      || result.bada
	    ) {
	      result.mobile = t
	    }
	
	    // Graded Browser Support
	    // http://developer.yahoo.com/yui/articles/gbs
	    if (result.msedge ||
	        (result.msie && result.version >= 10) ||
	        (result.yandexbrowser && result.version >= 15) ||
			    (result.vivaldi && result.version >= 1.0) ||
	        (result.chrome && result.version >= 20) ||
	        (result.firefox && result.version >= 20.0) ||
	        (result.safari && result.version >= 6) ||
	        (result.opera && result.version >= 10.0) ||
	        (result.ios && result.osversion && result.osversion.split(".")[0] >= 6) ||
	        (result.blackberry && result.version >= 10.1)
	        || (result.chromium && result.version >= 20)
	        ) {
	      result.a = t;
	    }
	    else if ((result.msie && result.version < 10) ||
	        (result.chrome && result.version < 20) ||
	        (result.firefox && result.version < 20.0) ||
	        (result.safari && result.version < 6) ||
	        (result.opera && result.version < 10.0) ||
	        (result.ios && result.osversion && result.osversion.split(".")[0] < 6)
	        || (result.chromium && result.version < 20)
	        ) {
	      result.c = t
	    } else result.x = t
	
	    return result
	  }
	
	  var bowser = detect(typeof navigator !== 'undefined' ? navigator.userAgent : '')
	
	  bowser.test = function (browserList) {
	    for (var i = 0; i < browserList.length; ++i) {
	      var browserItem = browserList[i];
	      if (typeof browserItem=== 'string') {
	        if (browserItem in bowser) {
	          return true;
	        }
	      }
	    }
	    return false;
	  }
	
	  /**
	   * Get version precisions count
	   *
	   * @example
	   *   getVersionPrecision("1.10.3") // 3
	   *
	   * @param  {string} version
	   * @return {number}
	   */
	  function getVersionPrecision(version) {
	    return version.split(".").length;
	  }
	
	  /**
	   * Array::map polyfill
	   *
	   * @param  {Array} arr
	   * @param  {Function} iterator
	   * @return {Array}
	   */
	  function map(arr, iterator) {
	    var result = [], i;
	    if (Array.prototype.map) {
	      return Array.prototype.map.call(arr, iterator);
	    }
	    for (i = 0; i < arr.length; i++) {
	      result.push(iterator(arr[i]));
	    }
	    return result;
	  }
	
	  /**
	   * Calculate browser version weight
	   *
	   * @example
	   *   compareVersions(['1.10.2.1',  '1.8.2.1.90'])    // 1
	   *   compareVersions(['1.010.2.1', '1.09.2.1.90']);  // 1
	   *   compareVersions(['1.10.2.1',  '1.10.2.1']);     // 0
	   *   compareVersions(['1.10.2.1',  '1.0800.2']);     // -1
	   *
	   * @param  {Array<String>} versions versions to compare
	   * @return {Number} comparison result
	   */
	  function compareVersions(versions) {
	    // 1) get common precision for both versions, for example for "10.0" and "9" it should be 2
	    var precision = Math.max(getVersionPrecision(versions[0]), getVersionPrecision(versions[1]));
	    var chunks = map(versions, function (version) {
	      var delta = precision - getVersionPrecision(version);
	
	      // 2) "9" -> "9.0" (for precision = 2)
	      version = version + new Array(delta + 1).join(".0");
	
	      // 3) "9.0" -> ["000000000"", "000000009"]
	      return map(version.split("."), function (chunk) {
	        return new Array(20 - chunk.length).join("0") + chunk;
	      }).reverse();
	    });
	
	    // iterate in reverse order by reversed chunks array
	    while (--precision >= 0) {
	      // 4) compare: "000000009" > "000000010" = false (but "9" > "10" = true)
	      if (chunks[0][precision] > chunks[1][precision]) {
	        return 1;
	      }
	      else if (chunks[0][precision] === chunks[1][precision]) {
	        if (precision === 0) {
	          // all version chunks are same
	          return 0;
	        }
	      }
	      else {
	        return -1;
	      }
	    }
	  }
	
	  /**
	   * Check if browser is unsupported
	   *
	   * @example
	   *   bowser.isUnsupportedBrowser({
	   *     msie: "10",
	   *     firefox: "23",
	   *     chrome: "29",
	   *     safari: "5.1",
	   *     opera: "16",
	   *     phantom: "534"
	   *   });
	   *
	   * @param  {Object}  minVersions map of minimal version to browser
	   * @param  {Boolean} [strictMode = false] flag to return false if browser wasn't found in map
	   * @param  {String}  [ua] user agent string
	   * @return {Boolean}
	   */
	  function isUnsupportedBrowser(minVersions, strictMode, ua) {
	    var _bowser = bowser;
	
	    // make strictMode param optional with ua param usage
	    if (typeof strictMode === 'string') {
	      ua = strictMode;
	      strictMode = void(0);
	    }
	
	    if (strictMode === void(0)) {
	      strictMode = false;
	    }
	    if (ua) {
	      _bowser = detect(ua);
	    }
	
	    var version = "" + _bowser.version;
	    for (var browser in minVersions) {
	      if (minVersions.hasOwnProperty(browser)) {
	        if (_bowser[browser]) {
	          // browser version and min supported version.
	          return compareVersions([version, minVersions[browser]]) < 0;
	        }
	      }
	    }
	
	    return strictMode; // not found
	  }
	
	  /**
	   * Check if browser is supported
	   *
	   * @param  {Object} minVersions map of minimal version to browser
	   * @param  {Boolean} [strictMode = false] flag to return false if browser wasn't found in map
	   * @param  {String}  [ua] user agent string
	   * @return {Boolean}
	   */
	  function check(minVersions, strictMode, ua) {
	    return !isUnsupportedBrowser(minVersions, strictMode, ua);
	  }
	
	  bowser.isUnsupportedBrowser = isUnsupportedBrowser;
	  bowser.compareVersions = compareVersions;
	  bowser.check = check;
	
	  /*
	   * Set our detect method to the main bowser object so we can
	   * reuse it to test other user agents.
	   * This is needed to implement future tests.
	   */
	  bowser._detect = detect;
	
	  return bowser
	});


/***/ }),
/* 842 */
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),
/* 843 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (_ref) {
	  var browser = _ref.browser;
	  var version = _ref.version;
	  var prefix = _ref.prefix;
	
	  var prefixedKeyframes = 'keyframes';
	
	  if (browser === 'chrome' && version < 43 || (browser === 'safari' || browser === 'ios_saf') && version < 9 || browser === 'opera' && version < 30 || browser === 'android' && version <= 4.4 || browser === 'and_uc') {
	    prefixedKeyframes = prefix.css + prefixedKeyframes;
	  }
	  return prefixedKeyframes;
	};
	
	module.exports = exports['default'];

/***/ }),
/* 844 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = { "chrome": { "transform": 35, "transformOrigin": 35, "transformOriginX": 35, "transformOriginY": 35, "backfaceVisibility": 35, "perspective": 35, "perspectiveOrigin": 35, "transformStyle": 35, "transformOriginZ": 35, "animation": 42, "animationDelay": 42, "animationDirection": 42, "animationFillMode": 42, "animationDuration": 42, "animationIterationCount": 42, "animationName": 42, "animationPlayState": 42, "animationTimingFunction": 42, "appearance": 54, "userSelect": 54, "fontKerning": 32, "textEmphasisPosition": 54, "textEmphasis": 54, "textEmphasisStyle": 54, "textEmphasisColor": 54, "boxDecorationBreak": 54, "clipPath": 54, "maskImage": 54, "maskMode": 54, "maskRepeat": 54, "maskPosition": 54, "maskClip": 54, "maskOrigin": 54, "maskSize": 54, "maskComposite": 54, "mask": 54, "maskBorderSource": 54, "maskBorderMode": 54, "maskBorderSlice": 54, "maskBorderWidth": 54, "maskBorderOutset": 54, "maskBorderRepeat": 54, "maskBorder": 54, "maskType": 54, "textDecorationStyle": 54, "textDecorationSkip": 54, "textDecorationLine": 54, "textDecorationColor": 54, "filter": 54, "fontFeatureSettings": 47, "breakAfter": 49, "breakBefore": 49, "breakInside": 49, "columnCount": 49, "columnFill": 49, "columnGap": 49, "columnRule": 49, "columnRuleColor": 49, "columnRuleStyle": 49, "columnRuleWidth": 49, "columns": 49, "columnSpan": 49, "columnWidth": 49 }, "safari": { "flex": 8, "flexBasis": 8, "flexDirection": 8, "flexGrow": 8, "flexFlow": 8, "flexShrink": 8, "flexWrap": 8, "alignContent": 8, "alignItems": 8, "alignSelf": 8, "justifyContent": 8, "order": 8, "transition": 6, "transitionDelay": 6, "transitionDuration": 6, "transitionProperty": 6, "transitionTimingFunction": 6, "transform": 8, "transformOrigin": 8, "transformOriginX": 8, "transformOriginY": 8, "backfaceVisibility": 8, "perspective": 8, "perspectiveOrigin": 8, "transformStyle": 8, "transformOriginZ": 8, "animation": 8, "animationDelay": 8, "animationDirection": 8, "animationFillMode": 8, "animationDuration": 8, "animationIterationCount": 8, "animationName": 8, "animationPlayState": 8, "animationTimingFunction": 8, "appearance": 10, "userSelect": 10, "backdropFilter": 10, "fontKerning": 9, "scrollSnapType": 10, "scrollSnapPointsX": 10, "scrollSnapPointsY": 10, "scrollSnapDestination": 10, "scrollSnapCoordinate": 10, "textEmphasisPosition": 7, "textEmphasis": 7, "textEmphasisStyle": 7, "textEmphasisColor": 7, "boxDecorationBreak": 10, "clipPath": 10, "maskImage": 10, "maskMode": 10, "maskRepeat": 10, "maskPosition": 10, "maskClip": 10, "maskOrigin": 10, "maskSize": 10, "maskComposite": 10, "mask": 10, "maskBorderSource": 10, "maskBorderMode": 10, "maskBorderSlice": 10, "maskBorderWidth": 10, "maskBorderOutset": 10, "maskBorderRepeat": 10, "maskBorder": 10, "maskType": 10, "textDecorationStyle": 10, "textDecorationSkip": 10, "textDecorationLine": 10, "textDecorationColor": 10, "shapeImageThreshold": 10, "shapeImageMargin": 10, "shapeImageOutside": 10, "filter": 9, "hyphens": 10, "flowInto": 10, "flowFrom": 10, "breakBefore": 8, "breakAfter": 8, "breakInside": 8, "regionFragment": 10, "columnCount": 8, "columnFill": 8, "columnGap": 8, "columnRule": 8, "columnRuleColor": 8, "columnRuleStyle": 8, "columnRuleWidth": 8, "columns": 8, "columnSpan": 8, "columnWidth": 8 }, "firefox": { "appearance": 50, "userSelect": 50, "boxSizing": 28, "textAlignLast": 48, "textDecorationStyle": 35, "textDecorationSkip": 35, "textDecorationLine": 35, "textDecorationColor": 35, "tabSize": 50, "hyphens": 42, "fontFeatureSettings": 33, "breakAfter": 50, "breakBefore": 50, "breakInside": 50, "columnCount": 50, "columnFill": 50, "columnGap": 50, "columnRule": 50, "columnRuleColor": 50, "columnRuleStyle": 50, "columnRuleWidth": 50, "columns": 50, "columnSpan": 50, "columnWidth": 50 }, "opera": { "flex": 16, "flexBasis": 16, "flexDirection": 16, "flexGrow": 16, "flexFlow": 16, "flexShrink": 16, "flexWrap": 16, "alignContent": 16, "alignItems": 16, "alignSelf": 16, "justifyContent": 16, "order": 16, "transform": 22, "transformOrigin": 22, "transformOriginX": 22, "transformOriginY": 22, "backfaceVisibility": 22, "perspective": 22, "perspectiveOrigin": 22, "transformStyle": 22, "transformOriginZ": 22, "animation": 29, "animationDelay": 29, "animationDirection": 29, "animationFillMode": 29, "animationDuration": 29, "animationIterationCount": 29, "animationName": 29, "animationPlayState": 29, "animationTimingFunction": 29, "appearance": 40, "userSelect": 40, "fontKerning": 19, "textEmphasisPosition": 40, "textEmphasis": 40, "textEmphasisStyle": 40, "textEmphasisColor": 40, "boxDecorationBreak": 40, "clipPath": 40, "maskImage": 40, "maskMode": 40, "maskRepeat": 40, "maskPosition": 40, "maskClip": 40, "maskOrigin": 40, "maskSize": 40, "maskComposite": 40, "mask": 40, "maskBorderSource": 40, "maskBorderMode": 40, "maskBorderSlice": 40, "maskBorderWidth": 40, "maskBorderOutset": 40, "maskBorderRepeat": 40, "maskBorder": 40, "maskType": 40, "textDecorationStyle": 40, "textDecorationSkip": 40, "textDecorationLine": 40, "textDecorationColor": 40, "filter": 40, "fontFeatureSettings": 34, "breakAfter": 36, "breakBefore": 36, "breakInside": 36, "columnCount": 36, "columnFill": 36, "columnGap": 36, "columnRule": 36, "columnRuleColor": 36, "columnRuleStyle": 36, "columnRuleWidth": 36, "columns": 36, "columnSpan": 36, "columnWidth": 36 }, "ie": { "flex": 10, "flexDirection": 10, "flexFlow": 10, "flexWrap": 10, "transform": 9, "transformOrigin": 9, "transformOriginX": 9, "transformOriginY": 9, "userSelect": 11, "wrapFlow": 11, "wrapThrough": 11, "wrapMargin": 11, "scrollSnapType": 11, "scrollSnapPointsX": 11, "scrollSnapPointsY": 11, "scrollSnapDestination": 11, "scrollSnapCoordinate": 11, "touchAction": 10, "hyphens": 11, "flowInto": 11, "flowFrom": 11, "breakBefore": 11, "breakAfter": 11, "breakInside": 11, "regionFragment": 11, "gridTemplateColumns": 11, "gridTemplateRows": 11, "gridTemplateAreas": 11, "gridTemplate": 11, "gridAutoColumns": 11, "gridAutoRows": 11, "gridAutoFlow": 11, "grid": 11, "gridRowStart": 11, "gridColumnStart": 11, "gridRowEnd": 11, "gridRow": 11, "gridColumn": 11, "gridColumnEnd": 11, "gridColumnGap": 11, "gridRowGap": 11, "gridArea": 11, "gridGap": 11, "textSizeAdjust": 11 }, "edge": { "userSelect": 14, "wrapFlow": 14, "wrapThrough": 14, "wrapMargin": 14, "scrollSnapType": 14, "scrollSnapPointsX": 14, "scrollSnapPointsY": 14, "scrollSnapDestination": 14, "scrollSnapCoordinate": 14, "hyphens": 14, "flowInto": 14, "flowFrom": 14, "breakBefore": 14, "breakAfter": 14, "breakInside": 14, "regionFragment": 14, "gridTemplateColumns": 14, "gridTemplateRows": 14, "gridTemplateAreas": 14, "gridTemplate": 14, "gridAutoColumns": 14, "gridAutoRows": 14, "gridAutoFlow": 14, "grid": 14, "gridRowStart": 14, "gridColumnStart": 14, "gridRowEnd": 14, "gridRow": 14, "gridColumn": 14, "gridColumnEnd": 14, "gridColumnGap": 14, "gridRowGap": 14, "gridArea": 14, "gridGap": 14 }, "ios_saf": { "flex": 8.1, "flexBasis": 8.1, "flexDirection": 8.1, "flexGrow": 8.1, "flexFlow": 8.1, "flexShrink": 8.1, "flexWrap": 8.1, "alignContent": 8.1, "alignItems": 8.1, "alignSelf": 8.1, "justifyContent": 8.1, "order": 8.1, "transition": 6, "transitionDelay": 6, "transitionDuration": 6, "transitionProperty": 6, "transitionTimingFunction": 6, "transform": 8.1, "transformOrigin": 8.1, "transformOriginX": 8.1, "transformOriginY": 8.1, "backfaceVisibility": 8.1, "perspective": 8.1, "perspectiveOrigin": 8.1, "transformStyle": 8.1, "transformOriginZ": 8.1, "animation": 8.1, "animationDelay": 8.1, "animationDirection": 8.1, "animationFillMode": 8.1, "animationDuration": 8.1, "animationIterationCount": 8.1, "animationName": 8.1, "animationPlayState": 8.1, "animationTimingFunction": 8.1, "appearance": 9.3, "userSelect": 9.3, "backdropFilter": 9.3, "fontKerning": 9.3, "scrollSnapType": 9.3, "scrollSnapPointsX": 9.3, "scrollSnapPointsY": 9.3, "scrollSnapDestination": 9.3, "scrollSnapCoordinate": 9.3, "boxDecorationBreak": 9.3, "clipPath": 9.3, "maskImage": 9.3, "maskMode": 9.3, "maskRepeat": 9.3, "maskPosition": 9.3, "maskClip": 9.3, "maskOrigin": 9.3, "maskSize": 9.3, "maskComposite": 9.3, "mask": 9.3, "maskBorderSource": 9.3, "maskBorderMode": 9.3, "maskBorderSlice": 9.3, "maskBorderWidth": 9.3, "maskBorderOutset": 9.3, "maskBorderRepeat": 9.3, "maskBorder": 9.3, "maskType": 9.3, "textSizeAdjust": 9.3, "textDecorationStyle": 9.3, "textDecorationSkip": 9.3, "textDecorationLine": 9.3, "textDecorationColor": 9.3, "shapeImageThreshold": 9.3, "shapeImageMargin": 9.3, "shapeImageOutside": 9.3, "filter": 9, "hyphens": 9.3, "flowInto": 9.3, "flowFrom": 9.3, "breakBefore": 8.1, "breakAfter": 8.1, "breakInside": 8.1, "regionFragment": 9.3, "columnCount": 8.1, "columnFill": 8.1, "columnGap": 8.1, "columnRule": 8.1, "columnRuleColor": 8.1, "columnRuleStyle": 8.1, "columnRuleWidth": 8.1, "columns": 8.1, "columnSpan": 8.1, "columnWidth": 8.1 }, "android": { "borderImage": 4.2, "borderImageOutset": 4.2, "borderImageRepeat": 4.2, "borderImageSlice": 4.2, "borderImageSource": 4.2, "borderImageWidth": 4.2, "flex": 4.2, "flexBasis": 4.2, "flexDirection": 4.2, "flexGrow": 4.2, "flexFlow": 4.2, "flexShrink": 4.2, "flexWrap": 4.2, "alignContent": 4.2, "alignItems": 4.2, "alignSelf": 4.2, "justifyContent": 4.2, "order": 4.2, "transition": 4.2, "transitionDelay": 4.2, "transitionDuration": 4.2, "transitionProperty": 4.2, "transitionTimingFunction": 4.2, "transform": 4.4, "transformOrigin": 4.4, "transformOriginX": 4.4, "transformOriginY": 4.4, "backfaceVisibility": 4.4, "perspective": 4.4, "perspectiveOrigin": 4.4, "transformStyle": 4.4, "transformOriginZ": 4.4, "animation": 4.4, "animationDelay": 4.4, "animationDirection": 4.4, "animationFillMode": 4.4, "animationDuration": 4.4, "animationIterationCount": 4.4, "animationName": 4.4, "animationPlayState": 4.4, "animationTimingFunction": 4.4, "appearance": 50, "userSelect": 50, "fontKerning": 4.4, "textEmphasisPosition": 50, "textEmphasis": 50, "textEmphasisStyle": 50, "textEmphasisColor": 50, "boxDecorationBreak": 50, "clipPath": 50, "maskImage": 50, "maskMode": 50, "maskRepeat": 50, "maskPosition": 50, "maskClip": 50, "maskOrigin": 50, "maskSize": 50, "maskComposite": 50, "mask": 50, "maskBorderSource": 50, "maskBorderMode": 50, "maskBorderSlice": 50, "maskBorderWidth": 50, "maskBorderOutset": 50, "maskBorderRepeat": 50, "maskBorder": 50, "maskType": 50, "filter": 50, "fontFeatureSettings": 4.4, "breakAfter": 50, "breakBefore": 50, "breakInside": 50, "columnCount": 50, "columnFill": 50, "columnGap": 50, "columnRule": 50, "columnRuleColor": 50, "columnRuleStyle": 50, "columnRuleWidth": 50, "columns": 50, "columnSpan": 50, "columnWidth": 50 }, "and_chr": { "appearance": 50, "userSelect": 50, "textEmphasisPosition": 50, "textEmphasis": 50, "textEmphasisStyle": 50, "textEmphasisColor": 50, "boxDecorationBreak": 50, "clipPath": 50, "maskImage": 50, "maskMode": 50, "maskRepeat": 50, "maskPosition": 50, "maskClip": 50, "maskOrigin": 50, "maskSize": 50, "maskComposite": 50, "mask": 50, "maskBorderSource": 50, "maskBorderMode": 50, "maskBorderSlice": 50, "maskBorderWidth": 50, "maskBorderOutset": 50, "maskBorderRepeat": 50, "maskBorder": 50, "maskType": 50, "textDecorationStyle": 50, "textDecorationSkip": 50, "textDecorationLine": 50, "textDecorationColor": 50, "filter": 50, "fontFeatureSettings": 50 }, "and_uc": { "flex": 9.9, "flexBasis": 9.9, "flexDirection": 9.9, "flexGrow": 9.9, "flexFlow": 9.9, "flexShrink": 9.9, "flexWrap": 9.9, "alignContent": 9.9, "alignItems": 9.9, "alignSelf": 9.9, "justifyContent": 9.9, "order": 9.9, "transition": 9.9, "transitionDelay": 9.9, "transitionDuration": 9.9, "transitionProperty": 9.9, "transitionTimingFunction": 9.9, "transform": 9.9, "transformOrigin": 9.9, "transformOriginX": 9.9, "transformOriginY": 9.9, "backfaceVisibility": 9.9, "perspective": 9.9, "perspectiveOrigin": 9.9, "transformStyle": 9.9, "transformOriginZ": 9.9, "animation": 9.9, "animationDelay": 9.9, "animationDirection": 9.9, "animationFillMode": 9.9, "animationDuration": 9.9, "animationIterationCount": 9.9, "animationName": 9.9, "animationPlayState": 9.9, "animationTimingFunction": 9.9, "appearance": 9.9, "userSelect": 9.9, "fontKerning": 9.9, "textEmphasisPosition": 9.9, "textEmphasis": 9.9, "textEmphasisStyle": 9.9, "textEmphasisColor": 9.9, "maskImage": 9.9, "maskMode": 9.9, "maskRepeat": 9.9, "maskPosition": 9.9, "maskClip": 9.9, "maskOrigin": 9.9, "maskSize": 9.9, "maskComposite": 9.9, "mask": 9.9, "maskBorderSource": 9.9, "maskBorderMode": 9.9, "maskBorderSlice": 9.9, "maskBorderWidth": 9.9, "maskBorderOutset": 9.9, "maskBorderRepeat": 9.9, "maskBorder": 9.9, "maskType": 9.9, "textSizeAdjust": 9.9, "filter": 9.9, "hyphens": 9.9, "flowInto": 9.9, "flowFrom": 9.9, "breakBefore": 9.9, "breakAfter": 9.9, "breakInside": 9.9, "regionFragment": 9.9, "fontFeatureSettings": 9.9, "columnCount": 9.9, "columnFill": 9.9, "columnGap": 9.9, "columnRule": 9.9, "columnRuleColor": 9.9, "columnRuleStyle": 9.9, "columnRuleWidth": 9.9, "columns": 9.9, "columnSpan": 9.9, "columnWidth": 9.9 }, "op_mini": { "borderImage": 5, "borderImageOutset": 5, "borderImageRepeat": 5, "borderImageSlice": 5, "borderImageSource": 5, "borderImageWidth": 5, "tabSize": 5, "objectFit": 5, "objectPosition": 5 } };
	module.exports = exports["default"];

/***/ }),
/* 845 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = calc;
	
	var _getPrefixedValue = __webpack_require__(846);
	
	var _getPrefixedValue2 = _interopRequireDefault(_getPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function calc(_ref) {
	  var property = _ref.property;
	  var value = _ref.value;
	  var _ref$browserInfo = _ref.browserInfo;
	  var browser = _ref$browserInfo.browser;
	  var version = _ref$browserInfo.version;
	  var css = _ref.prefix.css;
	  var keepUnprefixed = _ref.keepUnprefixed;
	
	  if (typeof value === 'string' && value.indexOf('calc(') > -1 && (browser === 'firefox' && version < 15 || browser === 'chrome' && version < 25 || browser === 'safari' && version < 6.1 || browser === 'ios_saf' && version < 7)) {
	    return _defineProperty({}, property, (0, _getPrefixedValue2.default)(value.replace(/calc\(/g, css + 'calc('), value, keepUnprefixed));
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 846 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (prefixedValue, value, keepUnprefixed) {
	  return keepUnprefixed ? [prefixedValue, value] : prefixedValue;
	};
	
	module.exports = exports["default"];

/***/ }),
/* 847 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = zoomCursor;
	
	var _getPrefixedValue = __webpack_require__(846);
	
	var _getPrefixedValue2 = _interopRequireDefault(_getPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var values = { 'zoom-in': true, 'zoom-out': true };
	
	function zoomCursor(_ref) {
	  var property = _ref.property;
	  var value = _ref.value;
	  var _ref$browserInfo = _ref.browserInfo;
	  var browser = _ref$browserInfo.browser;
	  var version = _ref$browserInfo.version;
	  var css = _ref.prefix.css;
	  var keepUnprefixed = _ref.keepUnprefixed;
	
	  if (property === 'cursor' && values[value] && (browser === 'firefox' && version < 24 || browser === 'chrome' && version < 37 || browser === 'safari' && version < 9 || browser === 'opera' && version < 24)) {
	    return {
	      cursor: (0, _getPrefixedValue2.default)(css + value, value, keepUnprefixed)
	    };
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 848 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = grabCursor;
	
	var _getPrefixedValue = __webpack_require__(846);
	
	var _getPrefixedValue2 = _interopRequireDefault(_getPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var values = { grab: true, grabbing: true };
	
	function grabCursor(_ref) {
	  var property = _ref.property;
	  var value = _ref.value;
	  var _ref$browserInfo = _ref.browserInfo;
	  var browser = _ref$browserInfo.browser;
	  var version = _ref$browserInfo.version;
	  var css = _ref.prefix.css;
	  var keepUnprefixed = _ref.keepUnprefixed;
	
	  // adds prefixes for firefox, chrome, safari, and opera regardless of version until a reliable brwoser support info can be found (see: https://github.com/rofrischmann/inline-style-prefixer/issues/79)
	  if (property === 'cursor' && values[value] && (browser === 'firefox' || browser === 'chrome' || browser === 'safari' || browser === 'opera')) {
	    return {
	      cursor: (0, _getPrefixedValue2.default)(css + value, value, keepUnprefixed)
	    };
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 849 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = flex;
	
	var _getPrefixedValue = __webpack_require__(846);
	
	var _getPrefixedValue2 = _interopRequireDefault(_getPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var values = { flex: true, 'inline-flex': true };
	
	function flex(_ref) {
	  var property = _ref.property;
	  var value = _ref.value;
	  var _ref$browserInfo = _ref.browserInfo;
	  var browser = _ref$browserInfo.browser;
	  var version = _ref$browserInfo.version;
	  var css = _ref.prefix.css;
	  var keepUnprefixed = _ref.keepUnprefixed;
	
	  if (property === 'display' && values[value] && (browser === 'chrome' && version < 29 && version > 20 || (browser === 'safari' || browser === 'ios_saf') && version < 9 && version > 6 || browser === 'opera' && (version == 15 || version == 16))) {
	    return {
	      display: (0, _getPrefixedValue2.default)(css + value, value, keepUnprefixed)
	    };
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 850 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = sizing;
	
	var _getPrefixedValue = __webpack_require__(846);
	
	var _getPrefixedValue2 = _interopRequireDefault(_getPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var properties = {
	  maxHeight: true,
	  maxWidth: true,
	  width: true,
	  height: true,
	  columnWidth: true,
	  minWidth: true,
	  minHeight: true
	};
	var values = {
	  'min-content': true,
	  'max-content': true,
	  'fill-available': true,
	  'fit-content': true,
	  'contain-floats': true
	};
	
	function sizing(_ref) {
	  var property = _ref.property;
	  var value = _ref.value;
	  var css = _ref.prefix.css;
	  var keepUnprefixed = _ref.keepUnprefixed;
	
	  // This might change in the future
	  // Keep an eye on it
	  if (properties[property] && values[value]) {
	    return _defineProperty({}, property, (0, _getPrefixedValue2.default)(css + value, value, keepUnprefixed));
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 851 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = gradient;
	
	var _getPrefixedValue = __webpack_require__(846);
	
	var _getPrefixedValue2 = _interopRequireDefault(_getPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var values = /linear-gradient|radial-gradient|repeating-linear-gradient|repeating-radial-gradient/;
	
	function gradient(_ref) {
	  var property = _ref.property;
	  var value = _ref.value;
	  var _ref$browserInfo = _ref.browserInfo;
	  var browser = _ref$browserInfo.browser;
	  var version = _ref$browserInfo.version;
	  var css = _ref.prefix.css;
	  var keepUnprefixed = _ref.keepUnprefixed;
	
	  if (typeof value === 'string' && value.match(values) !== null && (browser === 'firefox' && version < 16 || browser === 'chrome' && version < 26 || (browser === 'safari' || browser === 'ios_saf') && version < 7 || (browser === 'opera' || browser === 'op_mini') && version < 12.1 || browser === 'android' && version < 4.4 || browser === 'and_uc')) {
	    return _defineProperty({}, property, (0, _getPrefixedValue2.default)(css + value, value, keepUnprefixed));
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 852 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	exports.default = transition;
	
	var _hyphenateStyleName = __webpack_require__(837);
	
	var _hyphenateStyleName2 = _interopRequireDefault(_hyphenateStyleName);
	
	var _capitalizeString = __webpack_require__(828);
	
	var _capitalizeString2 = _interopRequireDefault(_capitalizeString);
	
	var _unprefixProperty = __webpack_require__(853);
	
	var _unprefixProperty2 = _interopRequireDefault(_unprefixProperty);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var properties = { transition: true, transitionProperty: true };
	
	function transition(_ref) {
	  var property = _ref.property;
	  var value = _ref.value;
	  var css = _ref.prefix.css;
	  var requiresPrefix = _ref.requiresPrefix;
	  var keepUnprefixed = _ref.keepUnprefixed;
	
	  // also check for already prefixed transitions
	  var unprefixedProperty = (0, _unprefixProperty2.default)(property);
	
	  if (typeof value === 'string' && properties[unprefixedProperty]) {
	    var _ret = function () {
	      // TODO: memoize this array
	      var requiresPrefixDashCased = Object.keys(requiresPrefix).map(function (prop) {
	        return (0, _hyphenateStyleName2.default)(prop);
	      });
	
	      // only split multi values, not cubic beziers
	      var multipleValues = value.split(/,(?![^()]*(?:\([^()]*\))?\))/g);
	
	      requiresPrefixDashCased.forEach(function (prop) {
	        multipleValues.forEach(function (val, index) {
	          if (val.indexOf(prop) > -1 && prop !== 'order') {
	            multipleValues[index] = val.replace(prop, css + prop) + (keepUnprefixed ? ',' + val : '');
	          }
	        });
	      });
	
	      return {
	        v: _defineProperty({}, property, multipleValues.join(','))
	      };
	    }();
	
	    if ((typeof _ret === 'undefined' ? 'undefined' : _typeof(_ret)) === "object") return _ret.v;
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 853 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (property) {
	  var unprefixed = property.replace(/^(ms|Webkit|Moz|O)/, '');
	  return unprefixed.charAt(0).toLowerCase() + unprefixed.slice(1);
	};
	
	module.exports = exports['default'];

/***/ }),
/* 854 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = flexboxIE;
	
	var _getPrefixedValue = __webpack_require__(846);
	
	var _getPrefixedValue2 = _interopRequireDefault(_getPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var alternativeValues = {
	  'space-around': 'distribute',
	  'space-between': 'justify',
	  'flex-start': 'start',
	  'flex-end': 'end',
	  flex: 'flexbox',
	  'inline-flex': 'inline-flexbox'
	};
	var alternativeProps = {
	  alignContent: 'msFlexLinePack',
	  alignSelf: 'msFlexItemAlign',
	  alignItems: 'msFlexAlign',
	  justifyContent: 'msFlexPack',
	  order: 'msFlexOrder',
	  flexGrow: 'msFlexPositive',
	  flexShrink: 'msFlexNegative',
	  flexBasis: 'msPreferredSize'
	};
	
	function flexboxIE(_ref) {
	  var property = _ref.property;
	  var value = _ref.value;
	  var styles = _ref.styles;
	  var _ref$browserInfo = _ref.browserInfo;
	  var browser = _ref$browserInfo.browser;
	  var version = _ref$browserInfo.version;
	  var css = _ref.prefix.css;
	  var keepUnprefixed = _ref.keepUnprefixed;
	
	  if ((alternativeProps[property] || property === 'display' && typeof value === 'string' && value.indexOf('flex') > -1) && (browser === 'ie_mob' || browser === 'ie') && version == 10) {
	    if (!keepUnprefixed && !Array.isArray(styles[property])) {
	      delete styles[property];
	    }
	    if (property === 'display' && alternativeValues[value]) {
	      return {
	        display: (0, _getPrefixedValue2.default)(css + alternativeValues[value], value, keepUnprefixed)
	      };
	    }
	    if (alternativeProps[property]) {
	      return _defineProperty({}, alternativeProps[property], alternativeValues[value] || value);
	    }
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 855 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = flexboxOld;
	
	var _getPrefixedValue = __webpack_require__(846);
	
	var _getPrefixedValue2 = _interopRequireDefault(_getPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var alternativeValues = {
	  'space-around': 'justify',
	  'space-between': 'justify',
	  'flex-start': 'start',
	  'flex-end': 'end',
	  'wrap-reverse': 'multiple',
	  wrap: 'multiple',
	  flex: 'box',
	  'inline-flex': 'inline-box'
	};
	
	var alternativeProps = {
	  alignItems: 'WebkitBoxAlign',
	  justifyContent: 'WebkitBoxPack',
	  flexWrap: 'WebkitBoxLines'
	};
	
	var otherProps = ['alignContent', 'alignSelf', 'order', 'flexGrow', 'flexShrink', 'flexBasis', 'flexDirection'];
	var properties = Object.keys(alternativeProps).concat(otherProps);
	
	function flexboxOld(_ref) {
	  var property = _ref.property;
	  var value = _ref.value;
	  var styles = _ref.styles;
	  var _ref$browserInfo = _ref.browserInfo;
	  var browser = _ref$browserInfo.browser;
	  var version = _ref$browserInfo.version;
	  var css = _ref.prefix.css;
	  var keepUnprefixed = _ref.keepUnprefixed;
	
	  if ((properties.indexOf(property) > -1 || property === 'display' && typeof value === 'string' && value.indexOf('flex') > -1) && (browser === 'firefox' && version < 22 || browser === 'chrome' && version < 21 || (browser === 'safari' || browser === 'ios_saf') && version <= 6.1 || browser === 'android' && version < 4.4 || browser === 'and_uc')) {
	    if (!keepUnprefixed && !Array.isArray(styles[property])) {
	      delete styles[property];
	    }
	    if (property === 'flexDirection') {
	      return {
	        WebkitBoxOrient: value.indexOf('column') > -1 ? 'vertical' : 'horizontal',
	        WebkitBoxDirection: value.indexOf('reverse') > -1 ? 'reverse' : 'normal'
	      };
	    }
	    if (property === 'display' && alternativeValues[value]) {
	      return {
	        display: (0, _getPrefixedValue2.default)(css + alternativeValues[value], value, keepUnprefixed)
	      };
	    }
	    if (alternativeProps[property]) {
	      return _defineProperty({}, alternativeProps[property], alternativeValues[value] || value);
	    }
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 856 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = callOnce;
	
	var _warning = __webpack_require__(491);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CALLED_ONCE = 'muiPrepared';
	
	function callOnce() {
	  if (false) {
	    return function (style) {
	      if (style[CALLED_ONCE]) {
	        process.env.NODE_ENV !== "production" ? (0, _warning2.default)(false, 'You cannot call prepareStyles() on the same style object more than once.') : void 0;
	      }
	      style[CALLED_ONCE] = true;
	      return style;
	    };
	  }
	}

/***/ }),
/* 857 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = rtl;
	var reTranslate = /((^|\s)translate(3d|X)?\()(\-?[\d]+)/;
	var reSkew = /((^|\s)skew(x|y)?\()\s*(\-?[\d]+)(deg|rad|grad)(,\s*(\-?[\d]+)(deg|rad|grad))?/;
	
	/**
	 * This function ensures that `style` supports both ltr and rtl directions by
	 * checking `styleConstants` in `muiTheme` and replacing attribute keys if
	 * necessary.
	 */
	function rtl(muiTheme) {
	  if (muiTheme.isRtl) {
	    return function (style) {
	      var flippedAttributes = {
	        // Keys and their replacements.
	        right: 'left',
	        left: 'right',
	        marginRight: 'marginLeft',
	        marginLeft: 'marginRight',
	        paddingRight: 'paddingLeft',
	        paddingLeft: 'paddingRight',
	        borderRight: 'borderLeft',
	        borderLeft: 'borderRight'
	      };
	
	      var newStyle = {};
	
	      Object.keys(style).forEach(function (attribute) {
	        var value = style[attribute];
	        var key = attribute;
	
	        if (flippedAttributes.hasOwnProperty(attribute)) {
	          key = flippedAttributes[attribute];
	        }
	
	        switch (attribute) {
	          case 'float':
	          case 'textAlign':
	            if (value === 'right') {
	              value = 'left';
	            } else if (value === 'left') {
	              value = 'right';
	            }
	            break;
	
	          case 'direction':
	            if (value === 'ltr') {
	              value = 'rtl';
	            } else if (value === 'rtl') {
	              value = 'ltr';
	            }
	            break;
	
	          case 'transform':
	            if (!value) break;
	            var matches = void 0;
	            if (matches = value.match(reTranslate)) {
	              value = value.replace(matches[0], matches[1] + -parseFloat(matches[4]));
	            }
	            if (matches = value.match(reSkew)) {
	              value = value.replace(matches[0], matches[1] + -parseFloat(matches[4]) + matches[5] + matches[6] ? ', ' + (-parseFloat(matches[7]) + matches[8]) : '');
	            }
	            break;
	
	          case 'transformOrigin':
	            if (!value) break;
	            if (value.indexOf('right') > -1) {
	              value = value.replace('right', 'left');
	            } else if (value.indexOf('left') > -1) {
	              value = value.replace('left', 'right');
	            }
	            break;
	        }
	
	        newStyle[key] = value;
	      });
	
	      return newStyle;
	    };
	  }
	}

/***/ }),
/* 858 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = compose;
	function compose() {
	  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
	    funcs[_key] = arguments[_key];
	  }
	
	  if (funcs.length === 0) {
	    return function (arg) {
	      return arg;
	    };
	  }
	
	  if (funcs.length === 1) {
	    return funcs[0];
	  }
	
	  var last = funcs[funcs.length - 1];
	  return function () {
	    var result = last.apply(undefined, arguments);
	    for (var i = funcs.length - 2; i >= 0; i--) {
	      var f = funcs[i];
	      result = f(result);
	    }
	    return result;
	  };
	}

/***/ }),
/* 859 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _colors = __webpack_require__(821);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Typography = function Typography() {
	  _classCallCheck(this, Typography);
	
	  // text colors
	  this.textFullBlack = _colors.fullBlack;
	  this.textDarkBlack = _colors.darkBlack;
	  this.textLightBlack = _colors.lightBlack;
	  this.textMinBlack = _colors.minBlack;
	  this.textFullWhite = _colors.fullWhite;
	  this.textDarkWhite = _colors.darkWhite;
	  this.textLightWhite = _colors.lightWhite;
	
	  // font weight
	  this.fontWeightLight = 300;
	  this.fontWeightNormal = 400;
	  this.fontWeightMedium = 500;
	
	  this.fontStyleButtonFontSize = 14;
	};
	
	exports.default = new Typography();

/***/ }),
/* 860 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.PopoverAnimationVertical = exports.Popover = undefined;
	
	var _Popover2 = __webpack_require__(639);
	
	var _Popover3 = _interopRequireDefault(_Popover2);
	
	var _PopoverAnimationVertical2 = __webpack_require__(711);
	
	var _PopoverAnimationVertical3 = _interopRequireDefault(_PopoverAnimationVertical2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Popover = _Popover3.default;
	exports.PopoverAnimationVertical = _PopoverAnimationVertical3.default;
	exports.default = _Popover3.default;

/***/ }),
/* 861 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.RadioButtonGroup = exports.RadioButton = undefined;
	
	var _RadioButton2 = __webpack_require__(862);
	
	var _RadioButton3 = _interopRequireDefault(_RadioButton2);
	
	var _RadioButtonGroup2 = __webpack_require__(865);
	
	var _RadioButtonGroup3 = _interopRequireDefault(_RadioButtonGroup2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.RadioButton = _RadioButton3.default;
	exports.RadioButtonGroup = _RadioButtonGroup3.default;
	exports.default = _RadioButton3.default;

/***/ }),
/* 862 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _simpleAssign = __webpack_require__(579);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _transitions = __webpack_require__(582);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _EnhancedSwitch = __webpack_require__(680);
	
	var _EnhancedSwitch2 = _interopRequireDefault(_EnhancedSwitch);
	
	var _radioButtonUnchecked = __webpack_require__(863);
	
	var _radioButtonUnchecked2 = _interopRequireDefault(_radioButtonUnchecked);
	
	var _radioButtonChecked = __webpack_require__(864);
	
	var _radioButtonChecked2 = _interopRequireDefault(_radioButtonChecked);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function getStyles(props, context) {
	  var radioButton = context.muiTheme.radioButton;
	
	
	  return {
	    icon: {
	      height: radioButton.size,
	      width: radioButton.size
	    },
	    target: {
	      transition: _transitions2.default.easeOut(),
	      position: 'absolute',
	      opacity: 1,
	      transform: 'scale(1)',
	      fill: radioButton.borderColor
	    },
	    fill: {
	      position: 'absolute',
	      opacity: 1,
	      transform: 'scale(0)',
	      transformOrigin: '50% 50%',
	      transition: _transitions2.default.easeOut(),
	      fill: radioButton.checkedColor
	    },
	    targetWhenChecked: {
	      opacity: 0,
	      transform: 'scale(0)'
	    },
	    fillWhenChecked: {
	      opacity: 1,
	      transform: 'scale(1)'
	    },
	    targetWhenDisabled: {
	      fill: radioButton.disabledColor,
	      cursor: 'not-allowed'
	    },
	    fillWhenDisabled: {
	      fill: radioButton.disabledColor,
	      cursor: 'not-allowed'
	    },
	    label: {
	      color: props.disabled ? radioButton.labelDisabledColor : radioButton.labelColor
	    },
	    ripple: {
	      color: props.checked ? radioButton.checkedColor : radioButton.borderColor
	    }
	  };
	}
	
	var RadioButton = function (_Component) {
	  _inherits(RadioButton, _Component);
	
	  function RadioButton() {
	    var _Object$getPrototypeO;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, RadioButton);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_Object$getPrototypeO = Object.getPrototypeOf(RadioButton)).call.apply(_Object$getPrototypeO, [this].concat(args))), _this), _this.handleSwitch = function (event) {
	      if (_this.props.onCheck) {
	        _this.props.onCheck(event, _this.props.value);
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  // Only called when selected, not when unselected.
	
	
	  _createClass(RadioButton, [{
	    key: 'isChecked',
	    value: function isChecked() {
	      return this.refs.enhancedSwitch.isSwitched();
	    }
	
	    // Use RadioButtonGroup.setSelectedValue(newSelectionValue) to set a
	    // RadioButton's checked value.
	
	  }, {
	    key: 'setChecked',
	    value: function setChecked(newCheckedValue) {
	      this.refs.enhancedSwitch.setSwitched(newCheckedValue);
	    }
	  }, {
	    key: 'getValue',
	    value: function getValue() {
	      return this.refs.enhancedSwitch.getValue();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var checkedIcon = _props.checkedIcon;
	      var checked = _props.checked;
	      var iconStyle = _props.iconStyle;
	      var labelStyle = _props.labelStyle;
	      var labelPosition = _props.labelPosition;
	      var onCheck = _props.onCheck;
	      var uncheckedIcon = _props.uncheckedIcon;
	      var disabled = _props.disabled;
	
	      var other = _objectWithoutProperties(_props, ['checkedIcon', 'checked', 'iconStyle', 'labelStyle', 'labelPosition', 'onCheck', 'uncheckedIcon', 'disabled']);
	
	      var styles = getStyles(this.props, this.context);
	
	      var uncheckedStyles = (0, _simpleAssign2.default)(styles.target, checked && styles.targetWhenChecked, iconStyle, disabled && styles.targetWhenDisabled);
	
	      var checkedStyles = (0, _simpleAssign2.default)(styles.fill, checked && styles.fillWhenChecked, iconStyle, disabled && styles.fillWhenDisabled);
	
	      var uncheckedElement = _react2.default.isValidElement(uncheckedIcon) ? _react2.default.cloneElement(uncheckedIcon, {
	        style: (0, _simpleAssign2.default)(uncheckedStyles, uncheckedIcon.props.style)
	      }) : _react2.default.createElement(_radioButtonUnchecked2.default, { style: uncheckedStyles });
	
	      var checkedElement = _react2.default.isValidElement(checkedIcon) ? _react2.default.cloneElement(checkedIcon, {
	        style: (0, _simpleAssign2.default)(checkedStyles, checkedIcon.props.style)
	      }) : _react2.default.createElement(_radioButtonChecked2.default, { style: checkedStyles });
	
	      var mergedIconStyle = (0, _simpleAssign2.default)(styles.icon, iconStyle);
	      var mergedLabelStyle = (0, _simpleAssign2.default)(styles.label, labelStyle);
	
	      return _react2.default.createElement(_EnhancedSwitch2.default, _extends({}, other, {
	        ref: 'enhancedSwitch',
	        inputType: 'radio',
	        checked: checked,
	        switched: checked,
	        disabled: disabled,
	        rippleColor: styles.ripple.color,
	        iconStyle: mergedIconStyle,
	        labelStyle: mergedLabelStyle,
	        labelPosition: labelPosition,
	        onSwitch: this.handleSwitch,
	        switchElement: _react2.default.createElement(
	          'div',
	          null,
	          uncheckedElement,
	          checkedElement
	        )
	      }));
	    }
	  }]);
	
	  return RadioButton;
	}(_react.Component);
	
	RadioButton.propTypes = {
	  /**
	   * @ignore
	   * checked if true
	   * Used internally by `RadioButtonGroup`.
	   */
	  checked: _react.PropTypes.bool,
	  /**
	   * The icon element to show when the radio button is checked.
	   */
	  checkedIcon: _react.PropTypes.element,
	  /**
	   * If true, the radio button is disabled.
	   */
	  disabled: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of the icon element.
	   */
	  iconStyle: _react.PropTypes.object,
	  /**
	   * Override the inline-styles of the input element.
	   */
	  inputStyle: _react.PropTypes.object,
	  /**
	   * @ignore
	   * Used internally by `RadioButtonGroup`. Use the `labelPosition` property of `RadioButtonGroup` instead.
	   * Where the label will be placed next to the radio button.
	   */
	  labelPosition: _react.PropTypes.oneOf(['left', 'right']),
	  /**
	   * Override the inline-styles of the label element.
	   */
	  labelStyle: _react.PropTypes.object,
	  /**
	   * @ignore
	   * Callback function fired when the radio button is checked. Note that this
	   * function will not be called if the radio button is part of a
	   * radio button group: in this case, use the `onChange` property of
	   * `RadioButtonGroup`.
	   *
	   * @param {object} event `change` event targeting the element.
	   * @param {string} value The element's `value`.
	   */
	  onCheck: _react.PropTypes.func,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object,
	  /**
	   * The icon element to show when the radio button is unchecked.
	   */
	  uncheckedIcon: _react.PropTypes.element,
	  /**
	   * The value of the radio button.
	   */
	  value: _react.PropTypes.any
	};
	RadioButton.defaultProps = {
	  checked: false,
	  disabled: false,
	  labelPosition: 'right'
	};
	RadioButton.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	exports.default = RadioButton;

/***/ }),
/* 863 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(608);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(615);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ToggleRadioButtonUnchecked = function ToggleRadioButtonUnchecked(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z' })
	  );
	};
	ToggleRadioButtonUnchecked = (0, _pure2.default)(ToggleRadioButtonUnchecked);
	ToggleRadioButtonUnchecked.displayName = 'ToggleRadioButtonUnchecked';
	ToggleRadioButtonUnchecked.muiName = 'SvgIcon';
	
	exports.default = ToggleRadioButtonUnchecked;

/***/ }),
/* 864 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(608);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(615);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ToggleRadioButtonChecked = function ToggleRadioButtonChecked(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 7c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5zm0-5C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z' })
	  );
	};
	ToggleRadioButtonChecked = (0, _pure2.default)(ToggleRadioButtonChecked);
	ToggleRadioButtonChecked.displayName = 'ToggleRadioButtonChecked';
	ToggleRadioButtonChecked.muiName = 'SvgIcon';
	
	exports.default = ToggleRadioButtonChecked;

/***/ }),
/* 865 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _simpleAssign = __webpack_require__(579);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _RadioButton = __webpack_require__(861);
	
	var _RadioButton2 = _interopRequireDefault(_RadioButton);
	
	var _warning = __webpack_require__(491);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RadioButtonGroup = function (_Component) {
	  _inherits(RadioButtonGroup, _Component);
	
	  function RadioButtonGroup() {
	    var _Object$getPrototypeO;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, RadioButtonGroup);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_Object$getPrototypeO = Object.getPrototypeOf(RadioButtonGroup)).call.apply(_Object$getPrototypeO, [this].concat(args))), _this), _this.state = {
	      numberCheckedRadioButtons: 0,
	      selected: ''
	    }, _this.handleChange = function (event, newSelection) {
	      _this.updateRadioButtons(newSelection);
	
	      // Successful update
	      if (_this.state.numberCheckedRadioButtons === 0) {
	        if (_this.props.onChange) _this.props.onChange(event, newSelection);
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(RadioButtonGroup, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _this2 = this;
	
	      var cnt = 0;
	
	      _react2.default.Children.forEach(this.props.children, function (option) {
	        if (_this2.hasCheckAttribute(option)) cnt++;
	      }, this);
	
	      this.setState({
	        numberCheckedRadioButtons: cnt,
	        selected: this.props.valueSelected || this.props.defaultSelected || ''
	      });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.hasOwnProperty('valueSelected')) {
	        this.setState({
	          selected: nextProps.valueSelected
	        });
	      }
	    }
	  }, {
	    key: 'hasCheckAttribute',
	    value: function hasCheckAttribute(radioButton) {
	      return radioButton.props.hasOwnProperty('checked') && radioButton.props.checked;
	    }
	  }, {
	    key: 'updateRadioButtons',
	    value: function updateRadioButtons(newSelection) {
	      if (this.state.numberCheckedRadioButtons === 0) {
	        this.setState({ selected: newSelection });
	      } else {
	         false ? (0, _warning2.default)(false, 'Cannot select a different radio button while another radio button\n        has the \'checked\' property set to true.') : void 0;
	      }
	    }
	  }, {
	    key: 'getSelectedValue',
	    value: function getSelectedValue() {
	      return this.state.selected;
	    }
	  }, {
	    key: 'setSelectedValue',
	    value: function setSelectedValue(newSelectionValue) {
	      this.updateRadioButtons(newSelectionValue);
	    }
	  }, {
	    key: 'clearValue',
	    value: function clearValue() {
	      this.setSelectedValue('');
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	
	      var options = _react2.default.Children.map(this.props.children, function (option) {
	        var _option$props = option.props;
	        var name = _option$props.name;
	        var value = _option$props.value;
	        var label = _option$props.label;
	        var onCheck = _option$props.onCheck;
	
	        var other = _objectWithoutProperties(_option$props, ['name', 'value', 'label', 'onCheck']);
	
	        return _react2.default.createElement(_RadioButton2.default, _extends({}, other, {
	          ref: option.props.value,
	          name: _this3.props.name,
	          key: option.props.value,
	          value: option.props.value,
	          label: option.props.label,
	          labelPosition: _this3.props.labelPosition,
	          onCheck: _this3.handleChange,
	          checked: option.props.value === _this3.state.selected
	        }));
	      }, this);
	
	      return _react2.default.createElement(
	        'div',
	        {
	          style: prepareStyles((0, _simpleAssign2.default)({}, this.props.style)),
	          className: this.props.className
	        },
	        options
	      );
	    }
	  }]);
	
	  return RadioButtonGroup;
	}(_react.Component);
	
	RadioButtonGroup.propTypes = {
	  /**
	   * Should be used to pass `RadioButton` components.
	   */
	  children: _react.PropTypes.node,
	  /**
	   * The CSS class name of the root element.
	   */
	  className: _react.PropTypes.string,
	  /**
	   * The `value` property of the radio button that will be
	   * selected by default. This takes precedence over the `checked` property
	   * of the `RadioButton` elements.
	   */
	  defaultSelected: _react.PropTypes.any,
	  /**
	   * Where the label will be placed for all child radio buttons.
	   * This takes precedence over the `labelPosition` property of the
	   * `RadioButton` elements.
	   */
	  labelPosition: _react.PropTypes.oneOf(['left', 'right']),
	  /**
	   * The name that will be applied to all child radio buttons.
	   */
	  name: _react.PropTypes.string.isRequired,
	  /**
	   * Callback function that is fired when a radio button has
	   * been checked.
	   *
	   * @param {object} event `change` event targeting the selected
	   * radio button.
	   * @param {*} value The `value` of the selected radio button.
	   */
	  onChange: _react.PropTypes.func,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object,
	  /**
	   * The `value` of the currently selected radio button.
	   */
	  valueSelected: _react.PropTypes.any
	};
	RadioButtonGroup.defaultProps = {
	  style: {}
	};
	RadioButtonGroup.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	exports.default = RadioButtonGroup;

/***/ }),
/* 866 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _RaisedButton = __webpack_require__(867);
	
	var _RaisedButton2 = _interopRequireDefault(_RaisedButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _RaisedButton2.default;

/***/ }),
/* 867 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _simpleAssign = __webpack_require__(579);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _transitions = __webpack_require__(582);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _colorManipulator = __webpack_require__(623);
	
	var _childUtils = __webpack_require__(585);
	
	var _EnhancedButton = __webpack_require__(584);
	
	var _EnhancedButton2 = _interopRequireDefault(_EnhancedButton);
	
	var _Paper = __webpack_require__(617);
	
	var _Paper2 = _interopRequireDefault(_Paper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function validateLabel(props, propName, componentName) {
	  if (false) {
	    if (!props.children && props.label !== 0 && !props.label && !props.icon) {
	      return new Error('Required prop label or children or icon was not specified in ' + componentName + '.');
	    }
	  }
	}
	
	function getStyles(props, context, state) {
	  var _context$muiTheme = context.muiTheme;
	  var baseTheme = _context$muiTheme.baseTheme;
	  var button = _context$muiTheme.button;
	  var raisedButton = _context$muiTheme.raisedButton;
	  var disabled = props.disabled;
	  var disabledBackgroundColor = props.disabledBackgroundColor;
	  var disabledLabelColor = props.disabledLabelColor;
	  var fullWidth = props.fullWidth;
	  var icon = props.icon;
	  var label = props.label;
	  var labelPosition = props.labelPosition;
	  var primary = props.primary;
	  var secondary = props.secondary;
	  var style = props.style;
	
	
	  var amount = primary || secondary ? 0.4 : 0.08;
	
	  var backgroundColor = raisedButton.color;
	  var labelColor = raisedButton.textColor;
	
	  if (disabled) {
	    backgroundColor = disabledBackgroundColor || raisedButton.disabledColor;
	    labelColor = disabledLabelColor || raisedButton.disabledTextColor;
	  } else if (primary) {
	    backgroundColor = raisedButton.primaryColor;
	    labelColor = raisedButton.primaryTextColor;
	  } else if (secondary) {
	    backgroundColor = raisedButton.secondaryColor;
	    labelColor = raisedButton.secondaryTextColor;
	  } else {
	    if (props.backgroundColor) {
	      backgroundColor = props.backgroundColor;
	    }
	    if (props.labelColor) {
	      labelColor = props.labelColor;
	    }
	  }
	
	  var buttonHeight = style && style.height || button.height;
	  var borderRadius = 2;
	
	  return {
	    root: {
	      display: 'inline-block',
	      transition: _transitions2.default.easeOut(),
	      minWidth: fullWidth ? '100%' : button.minWidth
	    },
	    button: {
	      position: 'relative',
	      height: buttonHeight,
	      lineHeight: buttonHeight + 'px',
	      width: '100%',
	      padding: 0,
	      borderRadius: borderRadius,
	      transition: _transitions2.default.easeOut(),
	      backgroundColor: backgroundColor,
	      // That's the default value for a button but not a link
	      textAlign: 'center'
	    },
	    label: {
	      position: 'relative',
	      opacity: 1,
	      fontSize: raisedButton.fontSize,
	      letterSpacing: 0,
	      textTransform: raisedButton.textTransform || button.textTransform || 'uppercase',
	      fontWeight: raisedButton.fontWeight,
	      margin: 0,
	      userSelect: 'none',
	      paddingLeft: icon && labelPosition !== 'before' ? 8 : baseTheme.spacing.desktopGutterLess,
	      paddingRight: icon && labelPosition === 'before' ? 8 : baseTheme.spacing.desktopGutterLess,
	      color: labelColor
	    },
	    icon: {
	      verticalAlign: 'middle',
	      marginLeft: label && labelPosition !== 'before' ? 12 : 0,
	      marginRight: label && labelPosition === 'before' ? 12 : 0
	    },
	    overlay: {
	      height: buttonHeight,
	      borderRadius: borderRadius,
	      backgroundColor: (state.keyboardFocused || state.hovered) && !disabled && (0, _colorManipulator.fade)(labelColor, amount),
	      transition: _transitions2.default.easeOut(),
	      top: 0
	    },
	    ripple: {
	      color: labelColor,
	      opacity: !(primary || secondary) ? 0.1 : 0.16
	    }
	  };
	}
	
	var RaisedButton = function (_Component) {
	  _inherits(RaisedButton, _Component);
	
	  function RaisedButton() {
	    var _Object$getPrototypeO;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, RaisedButton);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_Object$getPrototypeO = Object.getPrototypeOf(RaisedButton)).call.apply(_Object$getPrototypeO, [this].concat(args))), _this), _this.state = {
	      hovered: false,
	      keyboardFocused: false,
	      touched: false,
	      initialZDepth: 0,
	      zDepth: 0
	    }, _this.handleMouseDown = function (event) {
	      // only listen to left clicks
	      if (event.button === 0) {
	        _this.setState({
	          zDepth: _this.state.initialZDepth + 1
	        });
	      }
	      if (_this.props.onMouseDown) {
	        _this.props.onMouseDown(event);
	      }
	    }, _this.handleMouseUp = function (event) {
	      _this.setState({
	        zDepth: _this.state.initialZDepth
	      });
	      if (_this.props.onMouseUp) {
	        _this.props.onMouseUp(event);
	      }
	    }, _this.handleMouseLeave = function (event) {
	      if (!_this.state.keyboardFocused) {
	        _this.setState({
	          zDepth: _this.state.initialZDepth,
	          hovered: false
	        });
	      }
	      if (_this.props.onMouseLeave) {
	        _this.props.onMouseLeave(event);
	      }
	    }, _this.handleMouseEnter = function (event) {
	      if (!_this.state.keyboardFocused && !_this.state.touched) {
	        _this.setState({
	          hovered: true
	        });
	      }
	      if (_this.props.onMouseEnter) {
	        _this.props.onMouseEnter(event);
	      }
	    }, _this.handleTouchStart = function (event) {
	      _this.setState({
	        touched: true,
	        zDepth: _this.state.initialZDepth + 1
	      });
	
	      if (_this.props.onTouchStart) {
	        _this.props.onTouchStart(event);
	      }
	    }, _this.handleTouchEnd = function (event) {
	      _this.setState({
	        zDepth: _this.state.initialZDepth
	      });
	
	      if (_this.props.onTouchEnd) {
	        _this.props.onTouchEnd(event);
	      }
	    }, _this.handleKeyboardFocus = function (event, keyboardFocused) {
	      var zDepth = keyboardFocused && !_this.props.disabled ? _this.state.initialZDepth + 1 : _this.state.initialZDepth;
	
	      _this.setState({
	        zDepth: zDepth,
	        keyboardFocused: keyboardFocused
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(RaisedButton, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var zDepth = this.props.disabled ? 0 : 1;
	      this.setState({
	        zDepth: zDepth,
	        initialZDepth: zDepth
	      });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var zDepth = nextProps.disabled ? 0 : 1;
	      var nextState = {
	        zDepth: zDepth,
	        initialZDepth: zDepth
	      };
	
	      if (nextProps.disabled && this.state.hovered) {
	        nextState.hovered = false;
	      }
	
	      this.setState(nextState);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var backgroundColor = _props.backgroundColor;
	      var children = _props.children;
	      var className = _props.className;
	      var disabled = _props.disabled;
	      var fullWidth = _props.fullWidth;
	      var icon = _props.icon;
	      var label = _props.label;
	      var labelColor = _props.labelColor;
	      var labelPosition = _props.labelPosition;
	      var labelStyle = _props.labelStyle;
	      var primary = _props.primary;
	      var rippleStyle = _props.rippleStyle;
	      var secondary = _props.secondary;
	
	      var other = _objectWithoutProperties(_props, ['backgroundColor', 'children', 'className', 'disabled', 'fullWidth', 'icon', 'label', 'labelColor', 'labelPosition', 'labelStyle', 'primary', 'rippleStyle', 'secondary']);
	
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context, this.state);
	      var mergedRippleStyles = (0, _simpleAssign2.default)({}, styles.ripple, rippleStyle);
	
	      var buttonEventHandlers = disabled ? {} : {
	        onMouseDown: this.handleMouseDown,
	        onMouseUp: this.handleMouseUp,
	        onMouseLeave: this.handleMouseLeave,
	        onMouseEnter: this.handleMouseEnter,
	        onTouchStart: this.handleTouchStart,
	        onTouchEnd: this.handleTouchEnd,
	        onKeyboardFocus: this.handleKeyboardFocus
	      };
	
	      var labelElement = label && _react2.default.createElement(
	        'span',
	        { style: prepareStyles((0, _simpleAssign2.default)(styles.label, labelStyle)) },
	        label
	      );
	
	      var iconCloned = icon && (0, _react.cloneElement)(icon, {
	        color: icon.props.color || styles.label.color,
	        style: (0, _simpleAssign2.default)(styles.icon, icon.props.style)
	      });
	
	      // Place label before or after children.
	      var childrenFragment = labelPosition === 'before' ? {
	        labelElement: labelElement,
	        iconCloned: iconCloned,
	        children: children
	      } : {
	        children: children,
	        iconCloned: iconCloned,
	        labelElement: labelElement
	      };
	
	      var enhancedButtonChildren = (0, _childUtils.createChildFragment)(childrenFragment);
	
	      return _react2.default.createElement(
	        _Paper2.default,
	        {
	          className: className,
	          style: (0, _simpleAssign2.default)(styles.root, this.props.style),
	          zDepth: this.state.zDepth
	        },
	        _react2.default.createElement(
	          _EnhancedButton2.default,
	          _extends({}, other, buttonEventHandlers, {
	            ref: 'container',
	            disabled: disabled,
	            style: styles.button,
	            focusRippleColor: mergedRippleStyles.color,
	            touchRippleColor: mergedRippleStyles.color,
	            focusRippleOpacity: mergedRippleStyles.opacity,
	            touchRippleOpacity: mergedRippleStyles.opacity
	          }),
	          _react2.default.createElement(
	            'div',
	            {
	              ref: 'overlay',
	              style: prepareStyles(styles.overlay)
	            },
	            enhancedButtonChildren
	          )
	        )
	      );
	    }
	  }]);
	
	  return RaisedButton;
	}(_react.Component);
	
	RaisedButton.muiName = 'RaisedButton';
	RaisedButton.propTypes = {
	  /**
	   * Override the default background color for the button,
	   * but not the default disabled background color
	   * (use `disabledBackgroundColor` for this).
	   */
	  backgroundColor: _react.PropTypes.string,
	  /**
	   * The content of the button.
	   * If a label is provided via the `label` prop, the text within the label
	   * will be displayed in addition to the content provided here.
	   */
	  children: _react.PropTypes.node,
	  /**
	   * The CSS class name of the root element.
	   */
	  className: _react.PropTypes.string,
	  /**
	   * If true, the button will be disabled.
	   */
	  disabled: _react.PropTypes.bool,
	  /**
	   * Override the default background color for the button
	   * when it is disabled.
	   */
	  disabledBackgroundColor: _react.PropTypes.string,
	  /**
	   * The color of the button's label when the button is disabled.
	   */
	  disabledLabelColor: _react.PropTypes.string,
	  /**
	   * If true, the button will take up the full width of its container.
	   */
	  fullWidth: _react.PropTypes.bool,
	  /**
	   * The URL to link to when the button is clicked.
	   */
	  href: _react.PropTypes.string,
	  /**
	   * An icon to be displayed within the button.
	   */
	  icon: _react.PropTypes.node,
	  /**
	   * The label to be displayed within the button.
	   * If content is provided via the `children` prop, that content will be
	   * displayed in addition to the label provided here.
	   */
	  label: validateLabel,
	  /**
	   * The color of the button's label.
	   */
	  labelColor: _react.PropTypes.string,
	  /**
	   * The position of the button's label relative to the button's `children`.
	   */
	  labelPosition: _react.PropTypes.oneOf(['before', 'after']),
	  /**
	   * Override the inline-styles of the button's label element.
	   */
	  labelStyle: _react.PropTypes.object,
	  /** @ignore */
	  onMouseDown: _react.PropTypes.func,
	  /** @ignore */
	  onMouseEnter: _react.PropTypes.func,
	  /** @ignore */
	  onMouseLeave: _react.PropTypes.func,
	  /** @ignore */
	  onMouseUp: _react.PropTypes.func,
	  /** @ignore */
	  onTouchEnd: _react.PropTypes.func,
	  /** @ignore */
	  onTouchStart: _react.PropTypes.func,
	  /**
	   * If true, the button will use the theme's primary color.
	   */
	  primary: _react.PropTypes.bool,
	  /**
	   * Override the inline style of the ripple element.
	   */
	  rippleStyle: _react.PropTypes.object,
	  /**
	   * If true, the button will use the theme's secondary color.
	   * If both `secondary` and `primary` are true, the button will use
	   * the theme's primary color.
	   */
	  secondary: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object
	};
	RaisedButton.defaultProps = {
	  disabled: false,
	  labelPosition: 'after',
	  fullWidth: false,
	  primary: false,
	  secondary: false
	};
	RaisedButton.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	exports.default = RaisedButton;

/***/ }),
/* 868 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _RefreshIndicator = __webpack_require__(869);
	
	var _RefreshIndicator2 = _interopRequireDefault(_RefreshIndicator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _RefreshIndicator2.default;

/***/ }),
/* 869 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _simpleAssign = __webpack_require__(579);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _autoPrefix = __webpack_require__(593);
	
	var _autoPrefix2 = _interopRequireDefault(_autoPrefix);
	
	var _transitions = __webpack_require__(582);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _Paper = __webpack_require__(617);
	
	var _Paper2 = _interopRequireDefault(_Paper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var VIEWBOX_SIZE = 32;
	
	function getStyles(props) {
	  var padding = props.size * 0.1; // same implementation of `this.getPaddingSize()`
	  return {
	    root: {
	      position: 'absolute',
	      zIndex: 2,
	      width: props.size,
	      height: props.size,
	      padding: padding,
	      top: -10000,
	      left: -10000,
	      transform: 'translate(' + (10000 + props.left) + 'px, ' + (10000 + props.top) + 'px)',
	      opacity: props.status === 'hide' ? 0 : 1,
	      transition: props.status === 'hide' ? _transitions2.default.create('all', '.3s', 'ease-out') : 'none'
	    }
	  };
	}
	
	var RefreshIndicator = function (_Component) {
	  _inherits(RefreshIndicator, _Component);
	
	  function RefreshIndicator() {
	    _classCallCheck(this, RefreshIndicator);
	
	    return _possibleConstructorReturn(this, Object.getPrototypeOf(RefreshIndicator).apply(this, arguments));
	  }
	
	  _createClass(RefreshIndicator, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.scalePath(this.refs.path, 0);
	      this.rotateWrapper(this.refs.wrapper);
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      clearTimeout(this.scalePathTimer);
	      clearTimeout(this.rotateWrapperTimer);
	      clearTimeout(this.rotateWrapperSecondTimer);
	
	      this.scalePath(this.refs.path, 0);
	      this.rotateWrapper(this.refs.wrapper);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      clearTimeout(this.scalePathTimer);
	      clearTimeout(this.rotateWrapperTimer);
	      clearTimeout(this.rotateWrapperSecondTimer);
	    }
	  }, {
	    key: 'renderChildren',
	    value: function renderChildren() {
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var paperSize = this.getPaperSize();
	
	      var childrenCmp = null;
	      if (this.props.status !== 'ready') {
	        var circleStyle = this.getCircleStyle(paperSize);
	        childrenCmp = _react2.default.createElement(
	          'div',
	          {
	            ref: 'wrapper',
	            style: prepareStyles({
	              transition: _transitions2.default.create('transform', '20s', null, 'linear'),
	              width: '100%',
	              height: '100%'
	            })
	          },
	          _react2.default.createElement(
	            'svg',
	            {
	              style: {
	                width: paperSize,
	                height: paperSize
	              },
	              viewBox: '0 0 ' + VIEWBOX_SIZE + ' ' + VIEWBOX_SIZE
	            },
	            _react2.default.createElement('circle', _extends({
	              ref: 'path',
	              style: prepareStyles((0, _simpleAssign2.default)(circleStyle.style, {
	                transition: _transitions2.default.create('all', '1.5s', null, 'ease-in-out')
	              }))
	            }, circleStyle.attr))
	          )
	        );
	      } else {
	        var _circleStyle = this.getCircleStyle(paperSize);
	        var polygonStyle = this.getPolygonStyle(paperSize);
	        childrenCmp = _react2.default.createElement(
	          'svg',
	          {
	            style: {
	              width: paperSize,
	              height: paperSize
	            },
	            viewBox: '0 0 ' + VIEWBOX_SIZE + ' ' + VIEWBOX_SIZE
	          },
	          _react2.default.createElement('circle', _extends({
	            style: prepareStyles(_circleStyle.style)
	          }, _circleStyle.attr)),
	          _react2.default.createElement('polygon', _extends({
	            style: prepareStyles(polygonStyle.style)
	          }, polygonStyle.attr))
	        );
	      }
	
	      return childrenCmp;
	    }
	  }, {
	    key: 'getTheme',
	    value: function getTheme() {
	      return this.context.muiTheme.refreshIndicator;
	    }
	  }, {
	    key: 'getPaddingSize',
	    value: function getPaddingSize() {
	      var padding = this.props.size * 0.1;
	      return padding;
	    }
	  }, {
	    key: 'getPaperSize',
	    value: function getPaperSize() {
	      return this.props.size - this.getPaddingSize() * 2;
	    }
	  }, {
	    key: 'getCircleAttr',
	    value: function getCircleAttr() {
	      return {
	        radiu: VIEWBOX_SIZE / 2 - 5,
	        originX: VIEWBOX_SIZE / 2,
	        originY: VIEWBOX_SIZE / 2,
	        strokeWidth: 3
	      };
	    }
	  }, {
	    key: 'getArcDeg',
	    value: function getArcDeg() {
	      var p = this.props.percentage / 100;
	
	      var beginDeg = p * 120;
	      var endDeg = p * 410;
	      return [beginDeg, endDeg];
	    }
	  }, {
	    key: 'getFactor',
	    value: function getFactor() {
	      var p = this.props.percentage / 100;
	      var p1 = Math.min(1, p / 0.4);
	
	      return p1;
	    }
	  }, {
	    key: 'getCircleStyle',
	    value: function getCircleStyle() {
	      var isLoading = this.props.status === 'loading';
	      var p1 = isLoading ? 1 : this.getFactor();
	      var circle = this.getCircleAttr();
	      var perimeter = Math.PI * 2 * circle.radiu;
	
	      var _getArcDeg = this.getArcDeg();
	
	      var _getArcDeg2 = _slicedToArray(_getArcDeg, 2);
	
	      var beginDeg = _getArcDeg2[0];
	      var endDeg = _getArcDeg2[1];
	
	      var arcLen = (endDeg - beginDeg) * perimeter / 360;
	      var dashOffset = -beginDeg * perimeter / 360;
	
	      var theme = this.getTheme();
	      return {
	        style: {
	          strokeDasharray: arcLen + ', ' + (perimeter - arcLen),
	          strokeDashoffset: dashOffset,
	          stroke: isLoading || this.props.percentage === 100 ? this.props.loadingColor || theme.loadingStrokeColor : this.props.color || theme.strokeColor,
	          strokeLinecap: 'round',
	          opacity: p1,
	          strokeWidth: circle.strokeWidth * p1,
	          fill: 'none'
	        },
	        attr: {
	          cx: circle.originX,
	          cy: circle.originY,
	          r: circle.radiu
	        }
	      };
	    }
	  }, {
	    key: 'getPolygonStyle',
	    value: function getPolygonStyle() {
	      var p1 = this.getFactor();
	      var circle = this.getCircleAttr();
	
	      var triangleCx = circle.originX + circle.radiu;
	      var triangleCy = circle.originY;
	      var dx = circle.strokeWidth * 7 / 4 * p1;
	      var trianglePath = triangleCx - dx + ',' + triangleCy + ' ' + (triangleCx + dx) + ',' + triangleCy + ' ' + triangleCx + ',' + (triangleCy + dx);
	
	      var _getArcDeg3 = this.getArcDeg();
	
	      var _getArcDeg4 = _slicedToArray(_getArcDeg3, 2);
	
	      var endDeg = _getArcDeg4[1];
	
	
	      var theme = this.getTheme();
	      return {
	        style: {
	          fill: this.props.percentage === 100 ? this.props.loadingColor || theme.loadingStrokeColor : this.props.color || theme.strokeColor,
	          transform: 'rotate(' + endDeg + 'deg)',
	          transformOrigin: circle.originX + 'px ' + circle.originY + 'px',
	          opacity: p1
	        },
	        attr: {
	          points: trianglePath
	        }
	      };
	    }
	  }, {
	    key: 'scalePath',
	    value: function scalePath(path, step) {
	      var _this2 = this;
	
	      if (this.props.status !== 'loading') return;
	
	      var currStep = (step || 0) % 3;
	
	      var circle = this.getCircleAttr();
	      var perimeter = Math.PI * 2 * circle.radiu;
	      var arcLen = perimeter * 0.64;
	
	      var strokeDasharray = void 0;
	      var strokeDashoffset = void 0;
	      var transitionDuration = void 0;
	
	      if (currStep === 0) {
	        strokeDasharray = '1, 200';
	        strokeDashoffset = 0;
	        transitionDuration = '0ms';
	      } else if (currStep === 1) {
	        strokeDasharray = arcLen + ', 200';
	        strokeDashoffset = -15;
	        transitionDuration = '750ms';
	      } else {
	        strokeDasharray = arcLen + ', 200';
	        strokeDashoffset = -(perimeter - 1);
	        transitionDuration = '850ms';
	      }
	
	      _autoPrefix2.default.set(path.style, 'strokeDasharray', strokeDasharray);
	      _autoPrefix2.default.set(path.style, 'strokeDashoffset', strokeDashoffset);
	      _autoPrefix2.default.set(path.style, 'transitionDuration', transitionDuration);
	
	      this.scalePathTimer = setTimeout(function () {
	        return _this2.scalePath(path, currStep + 1);
	      }, currStep ? 750 : 250);
	    }
	  }, {
	    key: 'rotateWrapper',
	    value: function rotateWrapper(wrapper) {
	      var _this3 = this;
	
	      if (this.props.status !== 'loading') return;
	
	      _autoPrefix2.default.set(wrapper.style, 'transform', null);
	      _autoPrefix2.default.set(wrapper.style, 'transform', 'rotate(0deg)');
	      _autoPrefix2.default.set(wrapper.style, 'transitionDuration', '0ms');
	
	      this.rotateWrapperSecondTimer = setTimeout(function () {
	        _autoPrefix2.default.set(wrapper.style, 'transform', 'rotate(1800deg)');
	        _autoPrefix2.default.set(wrapper.style, 'transitionDuration', '10s');
	        _autoPrefix2.default.set(wrapper.style, 'transitionTimingFunction', 'linear');
	      }, 50);
	
	      this.rotateWrapperTimer = setTimeout(function () {
	        return _this3.rotateWrapper(wrapper);
	      }, 10050);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var style = this.props.style;
	
	      var styles = getStyles(this.props, this.context);
	
	      return _react2.default.createElement(
	        _Paper2.default,
	        {
	          circle: true,
	          style: (0, _simpleAssign2.default)(styles.root, style),
	          ref: 'indicatorCt'
	        },
	        this.renderChildren()
	      );
	    }
	  }]);
	
	  return RefreshIndicator;
	}(_react.Component);
	
	RefreshIndicator.propTypes = {
	  /**
	   * Override the theme's color of the indicator while it's status is
	   * "ready" and it's percentage is less than 100.
	   */
	  color: _react.PropTypes.string,
	  /**
	   * The absolute left position of the indicator in pixels.
	   */
	  left: _react.PropTypes.number.isRequired,
	  /**
	   * Override the theme's color of the indicator while
	   * it's status is "loading" or when it's percentage is 100.
	   */
	  loadingColor: _react.PropTypes.string,
	  /**
	   * The confirmation progress to fetch data. Max value is 100.
	   */
	  percentage: _react.PropTypes.number,
	  /**
	   * Size in pixels.
	   */
	  size: _react.PropTypes.number,
	  /**
	   * The display status of the indicator. If the status is
	   * "ready", the indicator will display the ready state
	   * arrow. If the status is "loading", it will display
	   * the loading progress indicator. If the status is "hide",
	   * the indicator will be hidden.
	   */
	  status: _react.PropTypes.oneOf(['ready', 'loading', 'hide']),
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object,
	  /**
	   * The absolute top position of the indicator in pixels.
	   */
	  top: _react.PropTypes.number.isRequired
	};
	RefreshIndicator.defaultProps = {
	  percentage: 0,
	  size: 40,
	  status: 'hide'
	};
	RefreshIndicator.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	exports.default = RefreshIndicator;

/***/ }),
/* 870 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _SelectField = __webpack_require__(871);
	
	var _SelectField2 = _interopRequireDefault(_SelectField);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _SelectField2.default;

/***/ }),
/* 871 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _simpleAssign = __webpack_require__(579);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _TextField = __webpack_require__(621);
	
	var _TextField2 = _interopRequireDefault(_TextField);
	
	var _DropDownMenu = __webpack_require__(714);
	
	var _DropDownMenu2 = _interopRequireDefault(_DropDownMenu);
	
	var _deprecatedPropType = __webpack_require__(603);
	
	var _deprecatedPropType2 = _interopRequireDefault(_deprecatedPropType);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function getStyles(props) {
	  return {
	    label: {
	      paddingLeft: 0,
	      top: props.floatingLabelText ? 6 : -4
	    },
	    icon: {
	      right: 0,
	      top: props.floatingLabelText ? 22 : 14
	    },
	    hideDropDownUnderline: {
	      borderTop: 'none'
	    },
	    dropDownMenu: {
	      display: 'block'
	    }
	  };
	}
	
	var SelectField = function (_Component) {
	  _inherits(SelectField, _Component);
	
	  function SelectField() {
	    _classCallCheck(this, SelectField);
	
	    return _possibleConstructorReturn(this, Object.getPrototypeOf(SelectField).apply(this, arguments));
	  }
	
	  _createClass(SelectField, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var autoWidth = _props.autoWidth;
	      var children = _props.children;
	      var style = _props.style;
	      var labelStyle = _props.labelStyle;
	      var iconStyle = _props.iconStyle;
	      var id = _props.id;
	      var underlineDisabledStyle = _props.underlineDisabledStyle;
	      var underlineFocusStyle = _props.underlineFocusStyle;
	      var underlineStyle = _props.underlineStyle;
	      var errorStyle = _props.errorStyle;
	      var selectFieldRoot = _props.selectFieldRoot;
	      var disabled = _props.disabled;
	      var floatingLabelFixed = _props.floatingLabelFixed;
	      var floatingLabelText = _props.floatingLabelText;
	      var floatingLabelStyle = _props.floatingLabelStyle;
	      var hintStyle = _props.hintStyle;
	      var hintText = _props.hintText;
	      var fullWidth = _props.fullWidth;
	      var errorText = _props.errorText;
	      var maxHeight = _props.maxHeight;
	      var menuStyle = _props.menuStyle;
	      var onFocus = _props.onFocus;
	      var onBlur = _props.onBlur;
	      var onChange = _props.onChange;
	      var value = _props.value;
	
	      var other = _objectWithoutProperties(_props, ['autoWidth', 'children', 'style', 'labelStyle', 'iconStyle', 'id', 'underlineDisabledStyle', 'underlineFocusStyle', 'underlineStyle', 'errorStyle', 'selectFieldRoot', 'disabled', 'floatingLabelFixed', 'floatingLabelText', 'floatingLabelStyle', 'hintStyle', 'hintText', 'fullWidth', 'errorText', 'maxHeight', 'menuStyle', 'onFocus', 'onBlur', 'onChange', 'value']);
	
	      var styles = getStyles(this.props, this.context);
	
	      return _react2.default.createElement(
	        _TextField2.default,
	        _extends({}, other, {
	          style: style,
	          disabled: disabled,
	          floatingLabelFixed: floatingLabelFixed,
	          floatingLabelText: floatingLabelText,
	          floatingLabelStyle: floatingLabelStyle,
	          hintStyle: hintStyle,
	          hintText: !hintText && !floatingLabelText ? ' ' : hintText,
	          fullWidth: fullWidth,
	          errorText: errorText,
	          underlineStyle: underlineStyle,
	          errorStyle: errorStyle,
	          onFocus: onFocus,
	          onBlur: onBlur,
	          id: id,
	          underlineDisabledStyle: underlineDisabledStyle,
	          underlineFocusStyle: underlineFocusStyle
	        }),
	        _react2.default.createElement(
	          _DropDownMenu2.default,
	          {
	            disabled: disabled,
	            style: (0, _simpleAssign2.default)(styles.dropDownMenu, selectFieldRoot, menuStyle),
	            labelStyle: (0, _simpleAssign2.default)(styles.label, labelStyle),
	            iconStyle: (0, _simpleAssign2.default)(styles.icon, iconStyle),
	            underlineStyle: styles.hideDropDownUnderline,
	            autoWidth: autoWidth,
	            value: value,
	            onChange: onChange,
	            maxHeight: maxHeight
	          },
	          children
	        )
	      );
	    }
	  }]);
	
	  return SelectField;
	}(_react.Component);
	
	SelectField.propTypes = {
	  /**
	   * If true, the width will automatically be set according to the
	   * items inside the menu.
	   * To control the width in CSS instead, leave this prop set to `false`.
	   */
	  autoWidth: _react.PropTypes.bool,
	  /**
	   * The `MenuItem` elements to populate the select field with.
	   * If the menu items have a `label` prop, that value will
	   * represent the selected menu item in the rendered select field.
	   */
	  children: _react.PropTypes.node,
	  /**
	   * If true, the select field will be disabled.
	   */
	  disabled: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of the error element.
	   */
	  errorStyle: _react.PropTypes.object,
	  /**
	   * The error content to display.
	   */
	  errorText: _react.PropTypes.node,
	  /**
	   * If true, the floating label will float even when no value is selected.
	   */
	  floatingLabelFixed: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of the floating label.
	   */
	  floatingLabelStyle: _react.PropTypes.object,
	  /**
	   * The content of the floating label.
	   */
	  floatingLabelText: _react.PropTypes.node,
	  /**
	   * If true, the select field will take up the full width of its container.
	   */
	  fullWidth: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of the hint element.
	   */
	  hintStyle: _react.PropTypes.object,
	  /**
	   * The hint content to display.
	   */
	  hintText: _react.PropTypes.node,
	  /**
	   * Override the inline-styles of the icon element.
	   */
	  iconStyle: _react.PropTypes.object,
	  /**
	   * The id prop for the text field.
	   */
	  id: _react.PropTypes.string,
	  /**
	   * Override the label style when the select field is inactive.
	   */
	  labelStyle: _react.PropTypes.object,
	  /**
	   * Override the default max-height of the underlying `DropDownMenu` element.
	   */
	  maxHeight: _react.PropTypes.number,
	  /**
	   * Override the inline-styles of the underlying `DropDownMenu` element.
	   */
	  menuStyle: _react.PropTypes.object,
	  /** @ignore */
	  onBlur: _react.PropTypes.func,
	  /**
	   * Callback function fired when a menu item is selected.
	   *
	   * @param {object} event TouchTap event targeting the menu item
	   * that was selected.
	   * @param {number} key The index of the selected menu item.
	   * @param {any} payload The `value` prop of the selected menu item.
	   */
	  onChange: _react.PropTypes.func,
	  /** @ignore */
	  onFocus: _react.PropTypes.func,
	  /**
	   * Override the inline-styles of the underlying `DropDownMenu` element.
	   */
	  selectFieldRoot: (0, _deprecatedPropType2.default)(_react.PropTypes.object, 'Instead, use `menuStyle`. It will be removed with v0.16.0.'),
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object,
	  /**
	   * Override the inline-styles of the underline element when the select
	   * field is disabled.
	   */
	  underlineDisabledStyle: _react.PropTypes.object,
	  /**
	   * Override the inline-styles of the underline element when the select field
	   * is focused.
	   */
	  underlineFocusStyle: _react.PropTypes.object,
	  /**
	   * Override the inline-styles of the underline element.
	   */
	  underlineStyle: _react.PropTypes.object,
	  /**
	   * The value that is currently selected.
	   */
	  value: _react.PropTypes.any
	};
	SelectField.defaultProps = {
	  autoWidth: false,
	  disabled: false,
	  fullWidth: false
	};
	SelectField.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	exports.default = SelectField;

/***/ }),
/* 872 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _Slider = __webpack_require__(873);
	
	var _Slider2 = _interopRequireDefault(_Slider);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Slider2.default;

/***/ }),
/* 873 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _simpleAssign = __webpack_require__(579);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _keycode = __webpack_require__(589);
	
	var _keycode2 = _interopRequireDefault(_keycode);
	
	var _transitions = __webpack_require__(582);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _FocusRipple = __webpack_require__(590);
	
	var _FocusRipple2 = _interopRequireDefault(_FocusRipple);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	/**
	 * Verifies min/max range.
	 * @param   {Object} props         Properties of the React component.
	 * @param   {String} propName      Name of the property to validate.
	 * @param   {String} componentName Name of the component whose property is being validated.
	 * @returns {Object} Returns an Error if min >= max otherwise null.
	 */
	var minMaxPropType = function minMaxPropType(props, propName, componentName) {
	  for (var _len = arguments.length, rest = Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
	    rest[_key - 3] = arguments[_key];
	  }
	
	  var error = _react.PropTypes.number.apply(_react.PropTypes, [props, propName, componentName].concat(rest));
	  if (error !== null) return error;
	
	  if (props.min >= props.max) {
	    var errorMsg = propName === 'min' ? 'min should be less than max' : 'max should be greater than min';
	    return new Error(errorMsg);
	  }
	};
	
	/**
	 * Verifies value is within the min/max range.
	 * @param   {Object} props         Properties of the React component.
	 * @param   {String} propName      Name of the property to validate.
	 * @param   {String} componentName Name of the component whose property is being validated.
	 * @returns {Object} Returns an Error if the value is not within the range otherwise null.
	 */
	var valueInRangePropType = function valueInRangePropType(props, propName, componentName) {
	  for (var _len2 = arguments.length, rest = Array(_len2 > 3 ? _len2 - 3 : 0), _key2 = 3; _key2 < _len2; _key2++) {
	    rest[_key2 - 3] = arguments[_key2];
	  }
	
	  var error = _react.PropTypes.number.apply(_react.PropTypes, [props, propName, componentName].concat(rest));
	  if (error !== null) return error;
	
	  var value = props[propName];
	  if (value < props.min || props.max < value) {
	    return new Error(propName + ' should be within the range specified by min and max');
	  }
	};
	
	var crossAxisProperty = {
	  x: 'height',
	  'x-reverse': 'height',
	  y: 'width',
	  'y-reverse': 'width'
	};
	
	var crossAxisOffsetProperty = {
	  x: 'top',
	  'x-reverse': 'top',
	  y: 'left',
	  'y-reverse': 'left'
	};
	
	var mainAxisProperty = {
	  x: 'width',
	  'x-reverse': 'width',
	  y: 'height',
	  'y-reverse': 'height'
	};
	
	var mainAxisMarginFromEnd = {
	  x: 'marginRight',
	  'x-reverse': 'marginLeft',
	  y: 'marginTop',
	  'y-reverse': 'marginBottom'
	};
	
	var mainAxisMarginFromStart = {
	  x: 'marginLeft',
	  'x-reverse': 'marginRight',
	  y: 'marginBottom',
	  'y-reverse': 'marginTop'
	};
	
	var mainAxisOffsetProperty = {
	  x: 'left',
	  'x-reverse': 'right',
	  y: 'bottom',
	  'y-reverse': 'top'
	};
	
	var mainAxisClientProperty = {
	  x: 'clientWidth',
	  'x-reverse': 'clientWidth',
	  y: 'clientHeight',
	  'y-reverse': 'clientHeight'
	};
	
	var mainAxisClientOffsetProperty = {
	  x: 'clientX',
	  'x-reverse': 'clientX',
	  y: 'clientY',
	  'y-reverse': 'clientY'
	};
	
	var reverseMainAxisOffsetProperty = {
	  x: 'right',
	  'x-reverse': 'left',
	  y: 'top',
	  'y-reverse': 'bottom'
	};
	
	var isMouseControlInverted = function isMouseControlInverted(axis) {
	  return axis === 'x-reverse' || axis === 'y';
	};
	
	var getStyles = function getStyles(props, context, state) {
	  var _slider, _track, _filledAndRemaining, _handle, _objectAssign2, _objectAssign3;
	
	  var slider = context.muiTheme.slider;
	
	  var fillGutter = slider.handleSize / 2;
	  var disabledGutter = slider.trackSize + slider.handleSizeDisabled / 2;
	  var calcDisabledSpacing = props.disabled ? ' - ' + disabledGutter + 'px' : '';
	  var axis = props.axis;
	
	  var styles = {
	    slider: (_slider = {
	      touchCallout: 'none',
	      userSelect: 'none',
	      cursor: 'default'
	    }, _defineProperty(_slider, crossAxisProperty[axis], slider.handleSizeActive), _defineProperty(_slider, mainAxisProperty[axis], '100%'), _defineProperty(_slider, 'position', 'relative'), _defineProperty(_slider, 'marginTop', 24), _defineProperty(_slider, 'marginBottom', 48), _slider),
	    track: (_track = {
	      position: 'absolute'
	    }, _defineProperty(_track, crossAxisOffsetProperty[axis], (slider.handleSizeActive - slider.trackSize) / 2), _defineProperty(_track, mainAxisOffsetProperty[axis], 0), _defineProperty(_track, mainAxisProperty[axis], '100%'), _defineProperty(_track, crossAxisProperty[axis], slider.trackSize), _track),
	    filledAndRemaining: (_filledAndRemaining = {
	      position: 'absolute'
	    }, _defineProperty(_filledAndRemaining, crossAxisOffsetProperty, 0), _defineProperty(_filledAndRemaining, crossAxisProperty[axis], '100%'), _defineProperty(_filledAndRemaining, 'transition', _transitions2.default.easeOut(null, 'margin')), _filledAndRemaining),
	    handle: (_handle = {
	      boxSizing: 'border-box',
	      position: 'absolute',
	      cursor: 'pointer',
	      pointerEvents: 'inherit'
	    }, _defineProperty(_handle, crossAxisOffsetProperty[axis], 0), _defineProperty(_handle, mainAxisOffsetProperty[axis], state.percent === 0 ? '0%' : state.percent * 100 + '%'), _defineProperty(_handle, 'zIndex', 1), _defineProperty(_handle, 'margin', {
	      x: slider.trackSize / 2 + 'px 0 0 0',
	      'x-reverse': slider.trackSize / 2 + 'px 0 0 0',
	      y: '0 0 0 ' + slider.trackSize / 2 + 'px',
	      'y-reverse': '0 0 0 ' + slider.trackSize / 2 + 'px'
	    }[props.axis]), _defineProperty(_handle, 'width', slider.handleSize), _defineProperty(_handle, 'height', slider.handleSize), _defineProperty(_handle, 'backgroundColor', slider.selectionColor), _defineProperty(_handle, 'backgroundClip', 'padding-box'), _defineProperty(_handle, 'border', '0px solid transparent'), _defineProperty(_handle, 'borderRadius', '50%'), _defineProperty(_handle, 'transform', {
	      x: 'translate(-50%, -50%)',
	      'x-reverse': 'translate(50%, -50%)',
	      y: 'translate(-50%, 50%)',
	      'y-reverse': 'translate(-50%, -50%)'
	    }[props.axis]), _defineProperty(_handle, 'transition', _transitions2.default.easeOut('450ms', 'background') + ', ' + _transitions2.default.easeOut('450ms', 'border-color') + ', ' + _transitions2.default.easeOut('450ms', 'width') + ', ' + _transitions2.default.easeOut('450ms', 'height')), _defineProperty(_handle, 'overflow', 'visible'), _defineProperty(_handle, 'outline', 'none'), _handle),
	    handleWhenDisabled: {
	      boxSizing: 'content-box',
	      cursor: 'not-allowed',
	      backgroundColor: slider.trackColor,
	      width: slider.handleSizeDisabled,
	      height: slider.handleSizeDisabled,
	      border: 'none'
	    },
	    handleWhenPercentZero: {
	      border: slider.trackSize + 'px solid ' + slider.handleColorZero,
	      backgroundColor: slider.handleFillColor,
	      boxShadow: 'none'
	    },
	    handleWhenPercentZeroAndDisabled: {
	      cursor: 'not-allowed',
	      width: slider.handleSizeDisabled,
	      height: slider.handleSizeDisabled
	    },
	    handleWhenPercentZeroAndFocused: {
	      border: slider.trackSize + 'px solid ' + slider.trackColorSelected
	    },
	    handleWhenActive: {
	      width: slider.handleSizeActive,
	      height: slider.handleSizeActive
	    },
	    ripple: {
	      height: slider.handleSize,
	      width: slider.handleSize,
	      overflow: 'visible'
	    },
	    rippleWhenPercentZero: {
	      top: -slider.trackSize,
	      left: -slider.trackSize
	    },
	    rippleInner: {
	      height: '300%',
	      width: '300%',
	      top: -slider.handleSize,
	      left: -slider.handleSize
	    },
	    rippleColor: {
	      fill: state.percent === 0 ? slider.handleColorZero : slider.rippleColor
	    }
	  };
	  styles.filled = (0, _simpleAssign2.default)({}, styles.filledAndRemaining, (_objectAssign2 = {}, _defineProperty(_objectAssign2, mainAxisOffsetProperty[axis], 0), _defineProperty(_objectAssign2, 'backgroundColor', props.disabled ? slider.trackColor : slider.selectionColor), _defineProperty(_objectAssign2, mainAxisMarginFromEnd[axis], fillGutter), _defineProperty(_objectAssign2, mainAxisProperty[axis], 'calc(' + state.percent * 100 + '%' + calcDisabledSpacing + ')'), _objectAssign2));
	  styles.remaining = (0, _simpleAssign2.default)({}, styles.filledAndRemaining, (_objectAssign3 = {}, _defineProperty(_objectAssign3, reverseMainAxisOffsetProperty[axis], 0), _defineProperty(_objectAssign3, 'backgroundColor', (state.hovered || state.focused) && !props.disabled ? slider.trackColorSelected : slider.trackColor), _defineProperty(_objectAssign3, mainAxisMarginFromStart[axis], fillGutter), _defineProperty(_objectAssign3, mainAxisProperty[axis], 'calc(' + (1 - state.percent) * 100 + '%' + calcDisabledSpacing + ')'), _objectAssign3));
	
	  return styles;
	};
	
	var Slider = function (_Component) {
	  _inherits(Slider, _Component);
	
	  function Slider() {
	    var _Object$getPrototypeO;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Slider);
	
	    for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
	      args[_key3] = arguments[_key3];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_Object$getPrototypeO = Object.getPrototypeOf(Slider)).call.apply(_Object$getPrototypeO, [this].concat(args))), _this), _this.state = {
	      active: false,
	      dragging: false,
	      focused: false,
	      hovered: false,
	      percent: 0,
	      value: 0
	    }, _this.onHandleTouchStart = function (event) {
	      if (document) {
	        document.addEventListener('touchmove', _this.dragTouchHandler, false);
	        document.addEventListener('touchup', _this.dragTouchEndHandler, false);
	        document.addEventListener('touchend', _this.dragTouchEndHandler, false);
	        document.addEventListener('touchcancel', _this.dragTouchEndHandler, false);
	      }
	      _this.onDragStart(event);
	
	      // Cancel scroll and context menu
	      event.preventDefault();
	    }, _this.onHandleMouseDown = function (event) {
	      if (document) {
	        document.addEventListener('mousemove', _this.dragHandler, false);
	        document.addEventListener('mouseup', _this.dragEndHandler, false);
	
	        // Cancel text selection
	        event.preventDefault();
	
	        // Set focus manually since we called preventDefault()
	        _this.refs.handle.focus();
	      }
	      _this.onDragStart(event);
	    }, _this.onHandleKeyDown = function (event) {
	      var _this$props = _this.props;
	      var axis = _this$props.axis;
	      var min = _this$props.min;
	      var max = _this$props.max;
	      var step = _this$props.step;
	
	      var action = void 0;
	
	      switch ((0, _keycode2.default)(event)) {
	        case 'page down':
	        case 'down':
	          if (axis === 'y-reverse') {
	            action = 'increase';
	          } else {
	            action = 'decrease';
	          }
	          break;
	        case 'left':
	          if (axis === 'x-reverse') {
	            action = 'increase';
	          } else {
	            action = 'decrease';
	          }
	          break;
	        case 'page up':
	        case 'up':
	          if (axis === 'y-reverse') {
	            action = 'decrease';
	          } else {
	            action = 'increase';
	          }
	          break;
	        case 'right':
	          if (axis === 'x-reverse') {
	            action = 'decrease';
	          } else {
	            action = 'increase';
	          }
	          break;
	        case 'home':
	          action = 'home';
	          break;
	        case 'end':
	          action = 'end';
	          break;
	      }
	
	      if (action) {
	        var newValue = void 0;
	        var newPercent = void 0;
	
	        // Cancel scroll
	        event.preventDefault();
	
	        // When pressing home or end the handle should be taken to the
	        // beginning or end of the track respectively
	        switch (action) {
	          case 'decrease':
	            newValue = Math.max(min, _this.state.value - step);
	            newPercent = (newValue - min) / (max - min);
	            break;
	          case 'increase':
	            newValue = Math.min(max, _this.state.value + step);
	            newPercent = (newValue - min) / (max - min);
	            break;
	          case 'home':
	            newValue = min;
	            newPercent = 0;
	            break;
	          case 'end':
	            newValue = max;
	            newPercent = 1;
	            break;
	        }
	
	        // We need to use toFixed() because of float point errors.
	        // For example, 0.01 + 0.06 = 0.06999999999999999
	        if (_this.state.value !== newValue) {
	          _this.setState({
	            percent: newPercent,
	            value: parseFloat(newValue.toFixed(5))
	          }, function () {
	            if (_this.props.onChange) _this.props.onChange(event, _this.state.value);
	          });
	        }
	      }
	    }, _this.dragHandler = function (event) {
	      if (_this.dragRunning) {
	        return;
	      }
	      _this.dragRunning = true;
	      requestAnimationFrame(function () {
	        var pos = void 0;
	        if (isMouseControlInverted(_this.props.axis)) {
	          pos = _this.getTrackOffset() - event[mainAxisClientOffsetProperty[_this.props.axis]];
	        } else {
	          pos = event[mainAxisClientOffsetProperty[_this.props.axis]] - _this.getTrackOffset();
	        }
	        _this.onDragUpdate(event, pos);
	        _this.dragRunning = false;
	      });
	    }, _this.dragTouchHandler = function (event) {
	      if (_this.dragRunning) {
	        return;
	      }
	      _this.dragRunning = true;
	      requestAnimationFrame(function () {
	        var pos = void 0;
	        if (isMouseControlInverted(_this.props.axis)) {
	          pos = _this.getTrackOffset() - event.touches[0][mainAxisClientOffsetProperty[_this.props.axis]];
	        } else {
	          pos = event.touches[0][mainAxisClientOffsetProperty[_this.props.axis]] - _this.getTrackOffset();
	        }
	        _this.onDragUpdate(event, pos);
	        _this.dragRunning = false;
	      });
	    }, _this.dragEndHandler = function (event) {
	      if (document) {
	        document.removeEventListener('mousemove', _this.dragHandler, false);
	        document.removeEventListener('mouseup', _this.dragEndHandler, false);
	      }
	
	      _this.onDragStop(event);
	    }, _this.dragTouchEndHandler = function (event) {
	      if (document) {
	        document.removeEventListener('touchmove', _this.dragTouchHandler, false);
	        document.removeEventListener('touchup', _this.dragTouchEndHandler, false);
	        document.removeEventListener('touchend', _this.dragTouchEndHandler, false);
	        document.removeEventListener('touchcancel', _this.dragTouchEndHandler, false);
	      }
	
	      _this.onDragStop(event);
	    }, _this.handleTouchStart = function (event) {
	      if (!_this.props.disabled && !_this.state.dragging) {
	        var pos = void 0;
	        if (isMouseControlInverted(_this.props.axis)) {
	          pos = _this.getTrackOffset() - event.touches[0][mainAxisClientOffsetProperty[_this.props.axis]];
	        } else {
	          pos = event.touches[0][mainAxisClientOffsetProperty[_this.props.axis]] - _this.getTrackOffset();
	        }
	        _this.dragTo(event, pos);
	
	        // Since the touch event fired for the track and handle is child of
	        // track, we need to manually propagate the event to the handle.
	        _this.onHandleTouchStart(event);
	      }
	    }, _this.handleFocus = function (event) {
	      _this.setState({ focused: true });
	
	      if (_this.props.onFocus) {
	        _this.props.onFocus(event);
	      }
	    }, _this.handleBlur = function (event) {
	      _this.setState({
	        focused: false,
	        active: false
	      });
	
	      if (_this.props.onBlur) {
	        _this.props.onBlur(event);
	      }
	    }, _this.handleMouseDown = function (event) {
	      if (!_this.props.disabled && !_this.state.dragging) {
	        var pos = void 0;
	        if (isMouseControlInverted(_this.props.axis)) {
	          pos = _this.getTrackOffset() - event[mainAxisClientOffsetProperty[_this.props.axis]];
	        } else {
	          pos = event[mainAxisClientOffsetProperty[_this.props.axis]] - _this.getTrackOffset();
	        }
	        _this.dragTo(event, pos);
	
	        // Since the click event fired for the track and handle is child of
	        // track, we need to manually propagate the event to the handle.
	        _this.onHandleMouseDown(event);
	      }
	    }, _this.handleMouseUp = function () {
	      if (!_this.props.disabled) {
	        _this.setState({ active: false });
	      }
	    }, _this.handleMouseEnter = function () {
	      _this.setState({ hovered: true });
	    }, _this.handleMouseLeave = function () {
	      _this.setState({ hovered: false });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Slider, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var value = this.props.value;
	      if (value === undefined) {
	        value = this.props.defaultValue !== undefined ? this.props.defaultValue : this.props.min;
	      }
	      var percent = (value - this.props.min) / (this.props.max - this.props.min);
	      if (isNaN(percent)) {
	        percent = 0;
	      }
	
	      this.setState({
	        percent: percent,
	        value: value
	      });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.value !== undefined && !this.state.dragging) {
	        this.setValue(nextProps.value, nextProps.min, nextProps.max);
	      }
	    }
	  }, {
	    key: 'getValue',
	    value: function getValue() {
	      return this.state.value;
	    }
	  }, {
	    key: 'setValue',
	    value: function setValue(value, min, max) {
	      // calculate percentage
	      var percent = (value - min) / (max - min);
	      if (isNaN(percent)) percent = 0;
	      // update state
	      this.setState({
	        value: value,
	        percent: percent
	      });
	    }
	  }, {
	    key: 'getPercent',
	    value: function getPercent() {
	      return this.state.percent;
	    }
	  }, {
	    key: 'setPercent',
	    value: function setPercent(percent, callback) {
	      var value = this.alignValue(this.percentToValue(percent));
	      var _props = this.props;
	      var min = _props.min;
	      var max = _props.max;
	
	      var alignedPercent = (value - min) / (max - min);
	      if (this.state.value !== value) {
	        this.setState({ value: value, percent: alignedPercent }, callback);
	      }
	    }
	  }, {
	    key: 'clearValue',
	    value: function clearValue() {
	      this.setValue(this.props.min, this.props.min, this.props.max);
	    }
	  }, {
	    key: 'alignValue',
	    value: function alignValue(val) {
	      var _props2 = this.props;
	      var step = _props2.step;
	      var min = _props2.min;
	
	      var alignValue = Math.round((val - min) / step) * step + min;
	      return parseFloat(alignValue.toFixed(5));
	    }
	  }, {
	    key: 'getTrackOffset',
	    value: function getTrackOffset() {
	      return this.refs.track.getBoundingClientRect()[mainAxisOffsetProperty[this.props.axis]];
	    }
	  }, {
	    key: 'onDragStart',
	    value: function onDragStart(event) {
	      this.setState({
	        dragging: true,
	        active: true
	      });
	
	      if (this.props.onDragStart) {
	        this.props.onDragStart(event);
	      }
	    }
	  }, {
	    key: 'onDragStop',
	    value: function onDragStop(event) {
	      this.setState({
	        dragging: false,
	        active: false
	      });
	
	      if (this.props.onDragStop) {
	        this.props.onDragStop(event);
	      }
	    }
	  }, {
	    key: 'onDragUpdate',
	    value: function onDragUpdate(event, pos) {
	      if (!this.state.dragging) {
	        return;
	      }
	      if (!this.props.disabled) {
	        this.dragTo(event, pos);
	      }
	    }
	  }, {
	    key: 'dragTo',
	    value: function dragTo(event, pos) {
	      var max = this.refs.track[mainAxisClientProperty[this.props.axis]];
	      if (pos < 0) {
	        pos = 0;
	      } else if (pos > max) {
	        pos = max;
	      }
	      this.updateWithChangeEvent(event, pos / max);
	    }
	  }, {
	    key: 'updateWithChangeEvent',
	    value: function updateWithChangeEvent(event, percent) {
	      var _this2 = this;
	
	      this.setPercent(percent, function () {
	        if (_this2.props.onChange) {
	          _this2.props.onChange(event, _this2.state.value);
	        }
	      });
	    }
	  }, {
	    key: 'percentToValue',
	    value: function percentToValue(percent) {
	      return percent * (this.props.max - this.props.min) + this.props.min;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props3 = this.props;
	      var axis = _props3.axis;
	      var description = _props3.description;
	      var disabled = _props3.disabled;
	      var disableFocusRipple = _props3.disableFocusRipple;
	      var error = _props3.error;
	      var max = _props3.max;
	      var min = _props3.min;
	      var name = _props3.name;
	      var onBlur = _props3.onBlur;
	      var onChange = _props3.onChange;
	      var onDragStart = _props3.onDragStart;
	      var onDragStop = _props3.onDragStop;
	      var onFocus = _props3.onFocus;
	      var required = _props3.required;
	      var sliderStyle = _props3.sliderStyle;
	      var step = _props3.step;
	      var style = _props3.style;
	
	      var other = _objectWithoutProperties(_props3, ['axis', 'description', 'disabled', 'disableFocusRipple', 'error', 'max', 'min', 'name', 'onBlur', 'onChange', 'onDragStart', 'onDragStop', 'onFocus', 'required', 'sliderStyle', 'step', 'style']);
	
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context, this.state);
	
	      var handleStyles = {};
	      var percent = this.state.percent;
	      if (percent > 1) {
	        percent = 1;
	      } else if (percent < 0) {
	        percent = 0;
	      }
	
	      if (percent === 0) {
	        handleStyles = (0, _simpleAssign2.default)({}, styles.handle, styles.handleWhenPercentZero, this.state.active && styles.handleWhenActive, (this.state.hovered || this.state.focused) && !disabled && styles.handleWhenPercentZeroAndFocused, disabled && styles.handleWhenPercentZeroAndDisabled);
	      } else {
	        handleStyles = (0, _simpleAssign2.default)({}, styles.handle, this.state.active && styles.handleWhenActive, disabled && styles.handleWhenDisabled);
	      }
	
	      var rippleStyle = (0, _simpleAssign2.default)({}, styles.ripple, percent === 0 && styles.rippleWhenPercentZero);
	
	      var rippleShowCondition = (this.state.hovered || this.state.focused) && !this.state.active;
	
	      var focusRipple = void 0;
	      if (!disabled && !disableFocusRipple) {
	        focusRipple = _react2.default.createElement(_FocusRipple2.default, {
	          ref: 'focusRipple',
	          key: 'focusRipple',
	          style: rippleStyle,
	          innerStyle: styles.rippleInner,
	          show: rippleShowCondition,
	          muiTheme: this.context.muiTheme,
	          color: styles.rippleColor.fill
	        });
	      }
	
	      var handleDragProps = void 0;
	      if (!disabled) {
	        handleDragProps = {
	          onTouchStart: this.onHandleTouchStart,
	          onMouseDown: this.onHandleMouseDown,
	          onKeyDown: this.onHandleKeyDown
	        };
	      }
	
	      return _react2.default.createElement(
	        'div',
	        _extends({}, other, { style: prepareStyles((0, _simpleAssign2.default)({}, style)) }),
	        _react2.default.createElement(
	          'span',
	          null,
	          description
	        ),
	        _react2.default.createElement(
	          'span',
	          null,
	          error
	        ),
	        _react2.default.createElement(
	          'div',
	          {
	            style: prepareStyles((0, _simpleAssign2.default)(styles.slider, sliderStyle)),
	            onFocus: this.handleFocus,
	            onBlur: this.handleBlur,
	            onMouseDown: this.handleMouseDown,
	            onMouseEnter: this.handleMouseEnter,
	            onMouseLeave: this.handleMouseLeave,
	            onMouseUp: this.handleMouseUp,
	            onTouchStart: this.handleTouchStart
	          },
	          _react2.default.createElement(
	            'div',
	            { ref: 'track', style: prepareStyles(styles.track) },
	            _react2.default.createElement('div', { style: prepareStyles(styles.filled) }),
	            _react2.default.createElement('div', { style: prepareStyles(styles.remaining) }),
	            _react2.default.createElement(
	              'div',
	              _extends({
	                ref: 'handle',
	                style: prepareStyles(handleStyles),
	                tabIndex: 0
	              }, handleDragProps),
	              focusRipple
	            )
	          )
	        ),
	        _react2.default.createElement('input', {
	          ref: 'input',
	          type: 'hidden',
	          name: name,
	          value: this.state.value,
	          required: required,
	          min: min,
	          max: max,
	          step: step
	        })
	      );
	    }
	  }]);
	
	  return Slider;
	}(_react.Component);
	
	Slider.propTypes = {
	  /**
	   * The axis on which the slider will slide.
	   */
	  axis: _react.PropTypes.oneOf(['x', 'x-reverse', 'y', 'y-reverse']),
	  /**
	   * The default value of the slider.
	   */
	  defaultValue: valueInRangePropType,
	  /**
	   * Describe the slider.
	   */
	  description: _react.PropTypes.string,
	  /**
	   * Disables focus ripple if set to true.
	   */
	  disableFocusRipple: _react.PropTypes.bool,
	  /**
	   * If true, the slider will not be interactable.
	   */
	  disabled: _react.PropTypes.bool,
	  /**
	   * An error message for the slider.
	   */
	  error: _react.PropTypes.string,
	  /**
	   * The maximum value the slider can slide to on
	   * a scale from 0 to 1 inclusive. Cannot be equal to min.
	   */
	  max: minMaxPropType,
	  /**
	   * The minimum value the slider can slide to on a scale
	   * from 0 to 1 inclusive. Cannot be equal to max.
	   */
	  min: minMaxPropType,
	  /**
	   * The name of the slider. Behaves like the name attribute
	   * of an input element.
	   */
	  name: _react.PropTypes.string,
	  /** @ignore */
	  onBlur: _react.PropTypes.func,
	  /**
	   * Callback function that is fired when the user changes the slider's value.
	   */
	  onChange: _react.PropTypes.func,
	  /**
	   * Callback function that is fired when the slider has begun to move.
	   */
	  onDragStart: _react.PropTypes.func,
	  /**
	   * Callback function that is fired when the slide has stopped moving.
	   */
	  onDragStop: _react.PropTypes.func,
	  /** @ignore */
	  onFocus: _react.PropTypes.func,
	  /**
	   * Whether or not the slider is required in a form.
	   */
	  required: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of the inner slider element.
	   */
	  sliderStyle: _react.PropTypes.object,
	  /**
	   * The granularity the slider can step through values.
	   */
	  step: _react.PropTypes.number,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object,
	  /**
	   * The value of the slider.
	   */
	  value: valueInRangePropType
	};
	Slider.defaultProps = {
	  axis: 'x',
	  disabled: false,
	  disableFocusRipple: false,
	  max: 1,
	  min: 0,
	  required: true,
	  step: 0.01,
	  style: {}
	};
	Slider.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	exports.default = Slider;

/***/ }),
/* 874 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _simpleAssign = __webpack_require__(579);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var getStyles = function getStyles(_ref, _ref2) {
	  var index = _ref.index;
	  var stepper = _ref2.stepper;
	  var orientation = stepper.orientation;
	
	  var styles = {
	    root: {
	      flex: '0 0 auto'
	    }
	  };
	
	  if (index > 0) {
	    if (orientation === 'horizontal') {
	      styles.root.marginLeft = -6;
	    } else if (orientation === 'vertical') {
	      styles.root.marginTop = -14;
	    }
	  }
	
	  return styles;
	};
	
	var Step = function (_Component) {
	  _inherits(Step, _Component);
	
	  function Step() {
	    var _Object$getPrototypeO;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Step);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_Object$getPrototypeO = Object.getPrototypeOf(Step)).call.apply(_Object$getPrototypeO, [this].concat(args))), _this), _this.renderChild = function (child) {
	      var _this$props = _this.props;
	      var active = _this$props.active;
	      var completed = _this$props.completed;
	      var disabled = _this$props.disabled;
	      var index = _this$props.index;
	      var last = _this$props.last;
	
	
	      var icon = index + 1;
	
	      return _react2.default.cloneElement(child, (0, _simpleAssign2.default)({ active: active, completed: completed, disabled: disabled, icon: icon, last: last }, child.props));
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Step, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var active = _props.active;
	      var completed = _props.completed;
	      var disabled = _props.disabled;
	      var index = _props.index;
	      var last = _props.last;
	      var children = _props.children;
	      var style = _props.style;
	
	      var other = _objectWithoutProperties(_props, ['active', 'completed', 'disabled', 'index', 'last', 'children', 'style']);
	
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      return _react2.default.createElement(
	        'div',
	        _extends({ style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) }, other),
	        _react2.default.Children.map(children, this.renderChild)
	      );
	    }
	  }]);
	
	  return Step;
	}(_react.Component);
	
	Step.propTypes = {
	  /**
	   * Sets the step as active. Is passed to child components.
	   */
	  active: _react.PropTypes.bool,
	  /**
	   * Should be `Step` sub-components such as `StepLabel`.
	   */
	  children: _react.PropTypes.node,
	  /**
	   * Mark the step as completed. Is passed to child components.
	   */
	  completed: _react.PropTypes.bool,
	  /**
	   * Mark the step as disabled, will also disable the button if
	   * `StepButton` is a child of `Step`. Is passed to child components.
	   */
	  disabled: _react.PropTypes.bool,
	  /**
	   * @ignore
	   * Used internally for numbering.
	   */
	  index: _react.PropTypes.number,
	  /**
	   * @ignore
	   */
	  last: _react.PropTypes.bool,
	  /**
	   * Override the inline-style of the root element.
	   */
	  style: _react.PropTypes.object
	};
	Step.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired,
	  stepper: _react.PropTypes.object
	};
	exports.default = Step;

/***/ }),
/* 875 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _simpleAssign = __webpack_require__(579);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _transitions = __webpack_require__(582);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _EnhancedButton = __webpack_require__(584);
	
	var _EnhancedButton2 = _interopRequireDefault(_EnhancedButton);
	
	var _StepLabel = __webpack_require__(876);
	
	var _StepLabel2 = _interopRequireDefault(_StepLabel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var isLabel = function isLabel(child) {
	  return child && child.type && child.type.muiName === 'StepLabel';
	};
	
	var getStyles = function getStyles(props, context, state) {
	  var hovered = state.hovered;
	  var _context$muiTheme$ste = context.muiTheme.stepper;
	  var backgroundColor = _context$muiTheme$ste.backgroundColor;
	  var hoverBackgroundColor = _context$muiTheme$ste.hoverBackgroundColor;
	
	
	  var styles = {
	    root: {
	      padding: 0,
	      backgroundColor: hovered ? hoverBackgroundColor : backgroundColor,
	      transition: _transitions2.default.easeOut()
	    }
	  };
	
	  if (context.stepper.orientation === 'vertical') {
	    styles.root.width = '100%';
	  }
	
	  return styles;
	};
	
	var StepButton = function (_Component) {
	  _inherits(StepButton, _Component);
	
	  function StepButton() {
	    var _Object$getPrototypeO;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, StepButton);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_Object$getPrototypeO = Object.getPrototypeOf(StepButton)).call.apply(_Object$getPrototypeO, [this].concat(args))), _this), _this.state = {
	      hovered: false,
	      touched: false
	    }, _this.handleMouseEnter = function (event) {
	      var onMouseEnter = _this.props.onMouseEnter;
	      // Cancel hover styles for touch devices
	
	      if (!_this.state.touched) {
	        _this.setState({ hovered: true });
	      }
	      if (typeof onMouseEnter === 'function') {
	        onMouseEnter(event);
	      }
	    }, _this.handleMouseLeave = function (event) {
	      var onMouseLeave = _this.props.onMouseLeave;
	
	      _this.setState({ hovered: false });
	      if (typeof onMouseLeave === 'function') {
	        onMouseLeave(event);
	      }
	    }, _this.handleTouchStart = function (event) {
	      var onTouchStart = _this.props.onTouchStart;
	
	      if (!_this.state.touched) {
	        _this.setState({ touched: true });
	      }
	      if (typeof onTouchStart === 'function') {
	        onTouchStart(event);
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(StepButton, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var active = _props.active;
	      var children = _props.children;
	      var completed = _props.completed;
	      var disabled = _props.disabled;
	      var icon = _props.icon;
	      var last = _props.last;
	      var onMouseEnter = _props.onMouseEnter;
	      var onMouseLeave = _props.onMouseLeave;
	      var onTouchStart = _props.onTouchStart;
	      var style = _props.style;
	
	      var other = _objectWithoutProperties(_props, ['active', 'children', 'completed', 'disabled', 'icon', 'last', 'onMouseEnter', 'onMouseLeave', 'onTouchStart', 'style']);
	
	      var styles = getStyles(this.props, this.context, this.state);
	
	      var child = isLabel(children) ? children : _react2.default.createElement(
	        _StepLabel2.default,
	        null,
	        children
	      );
	
	      return _react2.default.createElement(
	        _EnhancedButton2.default,
	        _extends({
	          disabled: disabled,
	          style: (0, _simpleAssign2.default)(styles.root, style),
	          onMouseEnter: this.handleMouseEnter,
	          onMouseLeave: this.handleMouseLeave,
	          onTouchStart: this.handleTouchStart
	        }, other),
	        _react2.default.cloneElement(child, { active: active, completed: completed, disabled: disabled, icon: icon })
	      );
	    }
	  }]);
	
	  return StepButton;
	}(_react.Component);
	
	StepButton.propTypes = {
	  /**
	   * Passed from `Step` Is passed to StepLabel.
	   */
	  active: _react.PropTypes.bool,
	  /**
	   * Can be a `StepLabel` or a node to place inside `StepLabel` as children.
	   */
	  children: _react.PropTypes.node,
	  /**
	   * Sets completed styling. Is passed to StepLabel.
	   */
	  completed: _react.PropTypes.bool,
	  /**
	   * Disables the button and sets disabled styling. Is passed to StepLabel.
	   */
	  disabled: _react.PropTypes.bool,
	  /**
	   * The icon displayed by the step label.
	   */
	  icon: _react.PropTypes.oneOfType([_react.PropTypes.element, _react.PropTypes.string, _react.PropTypes.number]),
	  /** @ignore */
	  last: _react.PropTypes.bool,
	  /** @ignore */
	  onMouseEnter: _react.PropTypes.func,
	  /** @ignore */
	  onMouseLeave: _react.PropTypes.func,
	  /** @ignore */
	  onTouchStart: _react.PropTypes.func,
	  /**
	   * Override the inline-style of the root element.
	   */
	  style: _react.PropTypes.object
	};
	StepButton.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired,
	  stepper: _react.PropTypes.object
	};
	exports.default = StepButton;

/***/ }),
/* 876 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _simpleAssign = __webpack_require__(579);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _checkCircle = __webpack_require__(877);
	
	var _checkCircle2 = _interopRequireDefault(_checkCircle);
	
	var _SvgIcon = __webpack_require__(615);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var getStyles = function getStyles(_ref, _ref2) {
	  var active = _ref.active;
	  var completed = _ref.completed;
	  var disabled = _ref.disabled;
	  var muiTheme = _ref2.muiTheme;
	  var stepper = _ref2.stepper;
	  var _muiTheme$stepper = muiTheme.stepper;
	  var textColor = _muiTheme$stepper.textColor;
	  var disabledTextColor = _muiTheme$stepper.disabledTextColor;
	  var iconColor = _muiTheme$stepper.iconColor;
	  var inactiveIconColor = _muiTheme$stepper.inactiveIconColor;
	  var orientation = stepper.orientation;
	
	
	  var styles = {
	    root: {
	      height: orientation === 'horizontal' ? 72 : 64,
	      color: textColor,
	      display: 'flex',
	      alignItems: 'center',
	      fontSize: 14,
	      paddingLeft: 14,
	      paddingRight: 14
	    },
	    icon: {
	      color: iconColor,
	      display: 'block',
	      fontSize: 24,
	      width: 24,
	      height: 24
	    },
	    iconContainer: {
	      display: 'flex',
	      alignItems: 'center',
	      paddingRight: 8,
	      width: 24
	    }
	  };
	
	  if (active) {
	    styles.root.fontWeight = 500;
	  }
	
	  if (!completed && !active) {
	    styles.icon.color = inactiveIconColor;
	  }
	
	  if (disabled) {
	    styles.icon.color = inactiveIconColor;
	    styles.root.color = disabledTextColor;
	    styles.root.cursor = 'not-allowed';
	  }
	
	  return styles;
	};
	
	var StepLabel = function (_Component) {
	  _inherits(StepLabel, _Component);
	
	  function StepLabel() {
	    _classCallCheck(this, StepLabel);
	
	    return _possibleConstructorReturn(this, Object.getPrototypeOf(StepLabel).apply(this, arguments));
	  }
	
	  _createClass(StepLabel, [{
	    key: 'renderIcon',
	    value: function renderIcon(completed, icon, styles) {
	      var iconType = typeof icon === 'undefined' ? 'undefined' : _typeof(icon);
	
	      if (iconType === 'number' || iconType === 'string') {
	        if (completed) {
	          return _react2.default.createElement(_checkCircle2.default, {
	            color: styles.icon.color,
	            style: styles.icon
	          });
	        }
	
	        return _react2.default.createElement(
	          _SvgIcon2.default,
	          { color: styles.icon.color, style: styles.icon },
	          _react2.default.createElement('circle', { cx: '12', cy: '12', r: '10' }),
	          _react2.default.createElement(
	            'text',
	            {
	              x: '12',
	              y: '16',
	              textAnchor: 'middle',
	              fontSize: '12',
	              fill: '#fff'
	            },
	            icon
	          )
	        );
	      }
	
	      return icon;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var active = _props.active;
	      var children = _props.children;
	      var completed = _props.completed;
	      var userIcon = _props.icon;
	      var last = _props.last;
	      var style = _props.style;
	
	      var other = _objectWithoutProperties(_props, ['active', 'children', 'completed', 'icon', 'last', 'style']);
	
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	      var icon = this.renderIcon(completed, userIcon, styles);
	
	      return _react2.default.createElement(
	        'span',
	        _extends({ style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) }, other),
	        icon && _react2.default.createElement(
	          'span',
	          { style: prepareStyles(styles.iconContainer) },
	          icon
	        ),
	        children
	      );
	    }
	  }]);
	
	  return StepLabel;
	}(_react.Component);
	
	StepLabel.muiName = 'StepLabel';
	StepLabel.propTypes = {
	  /**
	   * Sets active styling. Overrides disabled coloring.
	   */
	  active: _react.PropTypes.bool,
	  /**
	   * The label text node
	   */
	  children: _react.PropTypes.node,
	  /**
	   * Sets completed styling. Overrides disabled coloring.
	   */
	  completed: _react.PropTypes.bool,
	  /**
	   * Sets disabled styling.
	   */
	  disabled: _react.PropTypes.bool,
	  /**
	   * The icon displayed by the step label.
	   */
	  icon: _react.PropTypes.oneOfType([_react.PropTypes.element, _react.PropTypes.string, _react.PropTypes.number]),
	  /**
	   * @ignore
	   */
	  last: _react.PropTypes.bool,
	  /**
	   * Override the inline-style of the root element.
	   */
	  style: _react.PropTypes.object
	};
	StepLabel.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired,
	  stepper: _react.PropTypes.object
	};
	exports.default = StepLabel;

/***/ }),
/* 877 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(608);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(615);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionCheckCircle = function ActionCheckCircle(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z' })
	  );
	};
	ActionCheckCircle = (0, _pure2.default)(ActionCheckCircle);
	ActionCheckCircle.displayName = 'ActionCheckCircle';
	ActionCheckCircle.muiName = 'SvgIcon';
	
	exports.default = ActionCheckCircle;

/***/ }),
/* 878 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _simpleAssign = __webpack_require__(579);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ExpandTransition = __webpack_require__(879);
	
	var _ExpandTransition2 = _interopRequireDefault(_ExpandTransition);
	
	var _warning = __webpack_require__(491);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function ExpandTransition(props) {
	  return _react2.default.createElement(_ExpandTransition2.default, props);
	}
	
	var getStyles = function getStyles(props, context) {
	  var styles = {
	    root: {
	      marginTop: -14,
	      marginLeft: 14 + 11, // padding + 1/2 icon
	      paddingLeft: 24 - 11 + 8,
	      paddingRight: 16,
	      overflow: 'hidden'
	    }
	  };
	
	  if (!props.last) {
	    styles.root.borderLeft = '1px solid ' + context.muiTheme.stepper.connectorLineColor;
	  }
	
	  return styles;
	};
	
	var StepContent = function (_Component) {
	  _inherits(StepContent, _Component);
	
	  function StepContent() {
	    _classCallCheck(this, StepContent);
	
	    return _possibleConstructorReturn(this, Object.getPrototypeOf(StepContent).apply(this, arguments));
	  }
	
	  _createClass(StepContent, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var active = _props.active;
	      var children = _props.children;
	      var completed = _props.completed;
	      var last = _props.last;
	      var style = _props.style;
	      var transition = _props.transition;
	      var transitionDuration = _props.transitionDuration;
	
	      var other = _objectWithoutProperties(_props, ['active', 'children', 'completed', 'last', 'style', 'transition', 'transitionDuration']);
	
	      var _context = this.context;
	      var stepper = _context.stepper;
	      var prepareStyles = _context.muiTheme.prepareStyles;
	
	
	      if (stepper.orientation !== 'vertical') {
	         false ? (0, _warning2.default)(false, '<StepContent /> is only designed for use with the vertical stepper.') : void 0;
	        return null;
	      }
	
	      var styles = getStyles(this.props, this.context);
	      var transitionProps = {
	        enterDelay: transitionDuration,
	        transitionDuration: transitionDuration,
	        open: active
	      };
	
	      return _react2.default.createElement(
	        'div',
	        _extends({ style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) }, other),
	        _react2.default.createElement(transition, transitionProps, _react2.default.createElement(
	          'div',
	          { style: { overflow: 'hidden' } },
	          children
	        ))
	      );
	    }
	  }]);
	
	  return StepContent;
	}(_react.Component);
	
	StepContent.propTypes = {
	  /**
	   * Expands the content
	   */
	  active: _react.PropTypes.bool,
	  /**
	   * Step content
	   */
	  children: _react.PropTypes.node,
	  /**
	   * @ignore
	   */
	  completed: _react.PropTypes.bool,
	  /**
	   * @ignore
	   */
	  last: _react.PropTypes.bool,
	  /**
	   * Override the inline-style of the root element.
	   */
	  style: _react.PropTypes.object,
	  /**
	   * ReactTransitionGroup component.
	   */
	  transition: _react.PropTypes.func,
	  /**
	   * Adjust the duration of the content expand transition. Passed as a prop to the transition component.
	   */
	  transitionDuration: _react.PropTypes.number
	};
	StepContent.defaultProps = {
	  transition: ExpandTransition,
	  transitionDuration: 450
	};
	StepContent.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired,
	  stepper: _react.PropTypes.object
	};
	exports.default = StepContent;

/***/ }),
/* 879 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _simpleAssign = __webpack_require__(579);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactAddonsTransitionGroup = __webpack_require__(595);
	
	var _reactAddonsTransitionGroup2 = _interopRequireDefault(_reactAddonsTransitionGroup);
	
	var _ExpandTransitionChild = __webpack_require__(880);
	
	var _ExpandTransitionChild2 = _interopRequireDefault(_ExpandTransitionChild);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ExpandTransition = function (_Component) {
	  _inherits(ExpandTransition, _Component);
	
	  function ExpandTransition() {
	    _classCallCheck(this, ExpandTransition);
	
	    return _possibleConstructorReturn(this, Object.getPrototypeOf(ExpandTransition).apply(this, arguments));
	  }
	
	  _createClass(ExpandTransition, [{
	    key: 'renderChildren',
	    value: function renderChildren(children) {
	      var _props = this.props;
	      var enterDelay = _props.enterDelay;
	      var transitionDelay = _props.transitionDelay;
	      var transitionDuration = _props.transitionDuration;
	
	      return _react2.default.Children.map(children, function (child) {
	        return _react2.default.createElement(
	          _ExpandTransitionChild2.default,
	          {
	            enterDelay: enterDelay,
	            transitionDelay: transitionDelay,
	            transitionDuration: transitionDuration,
	            key: child.key
	          },
	          child
	        );
	      }, this);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props;
	      var children = _props2.children;
	      var enterDelay = _props2.enterDelay;
	      var loading = _props2.loading;
	      var open = _props2.open;
	      var style = _props2.style;
	      var transitionDelay = _props2.transitionDelay;
	      var transitionDuration = _props2.transitionDuration;
	
	      var other = _objectWithoutProperties(_props2, ['children', 'enterDelay', 'loading', 'open', 'style', 'transitionDelay', 'transitionDuration']);
	
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	
	      var mergedRootStyles = (0, _simpleAssign2.default)({}, {
	        position: 'relative',
	        overflow: 'hidden',
	        height: '100%'
	      }, style);
	
	      var newChildren = loading ? [] : this.renderChildren(children);
	
	      return _react2.default.createElement(
	        _reactAddonsTransitionGroup2.default,
	        _extends({
	          style: prepareStyles(mergedRootStyles),
	          component: 'div'
	        }, other),
	        open && newChildren
	      );
	    }
	  }]);
	
	  return ExpandTransition;
	}(_react.Component);
	
	ExpandTransition.propTypes = {
	  children: _react.PropTypes.node,
	  enterDelay: _react.PropTypes.number,
	  loading: _react.PropTypes.bool,
	  open: _react.PropTypes.bool,
	  style: _react.PropTypes.object,
	  transitionDelay: _react.PropTypes.number,
	  transitionDuration: _react.PropTypes.number
	};
	ExpandTransition.defaultProps = {
	  enterDelay: 0,
	  transitionDelay: 0,
	  transitionDuration: 450,
	  loading: false,
	  open: false
	};
	ExpandTransition.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	exports.default = ExpandTransition;

/***/ }),
/* 880 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _simpleAssign = __webpack_require__(579);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(332);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _transitions = __webpack_require__(582);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var reflow = function reflow(elem) {
	  return elem.offsetHeight;
	};
	
	var ExpandTransitionChild = function (_Component) {
	  _inherits(ExpandTransitionChild, _Component);
	
	  function ExpandTransitionChild() {
	    _classCallCheck(this, ExpandTransitionChild);
	
	    return _possibleConstructorReturn(this, Object.getPrototypeOf(ExpandTransitionChild).apply(this, arguments));
	  }
	
	  _createClass(ExpandTransitionChild, [{
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      clearTimeout(this.enterTimer);
	      clearTimeout(this.enteredTimer);
	      clearTimeout(this.leaveTimer);
	    }
	  }, {
	    key: 'componentWillAppear',
	    value: function componentWillAppear(callback) {
	      this.open();
	      callback();
	    }
	  }, {
	    key: 'componentDidAppear',
	    value: function componentDidAppear() {
	      this.setAutoHeight();
	    }
	  }, {
	    key: 'componentWillEnter',
	    value: function componentWillEnter(callback) {
	      var _this2 = this;
	
	      var _props = this.props;
	      var enterDelay = _props.enterDelay;
	      var transitionDelay = _props.transitionDelay;
	      var transitionDuration = _props.transitionDuration;
	
	      var element = _reactDom2.default.findDOMNode(this);
	      element.style.height = 0;
	      this.enterTimer = setTimeout(function () {
	        return _this2.open();
	      }, enterDelay);
	      this.enteredTimer = setTimeout(function () {
	        return callback();
	      }, enterDelay + transitionDelay + transitionDuration);
	    }
	  }, {
	    key: 'componentDidEnter',
	    value: function componentDidEnter() {
	      this.setAutoHeight();
	    }
	  }, {
	    key: 'componentWillLeave',
	    value: function componentWillLeave(callback) {
	      var _props2 = this.props;
	      var transitionDelay = _props2.transitionDelay;
	      var transitionDuration = _props2.transitionDuration;
	
	      var element = _reactDom2.default.findDOMNode(this);
	      // Set fixed height first for animated property value
	      element.style.height = this.refs.wrapper.clientHeight + 'px';
	      reflow(element);
	      element.style.transitionDuration = transitionDuration + 'ms';
	      element.style.height = 0;
	      this.leaveTimer = setTimeout(function () {
	        return callback();
	      }, transitionDelay + transitionDuration);
	    }
	  }, {
	    key: 'setAutoHeight',
	    value: function setAutoHeight() {
	      var _ReactDOM$findDOMNode = _reactDom2.default.findDOMNode(this);
	
	      var style = _ReactDOM$findDOMNode.style;
	
	      style.transitionDuration = 0;
	      style.height = 'auto';
	    }
	  }, {
	    key: 'open',
	    value: function open() {
	      var element = _reactDom2.default.findDOMNode(this);
	      element.style.height = this.refs.wrapper.clientHeight + 'px';
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props3 = this.props;
	      var children = _props3.children;
	      var enterDelay = _props3.enterDelay;
	      var style = _props3.style;
	      var transitionDelay = _props3.transitionDelay;
	      var transitionDuration = _props3.transitionDuration;
	
	      var other = _objectWithoutProperties(_props3, ['children', 'enterDelay', 'style', 'transitionDelay', 'transitionDuration']);
	
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	
	      var mergedRootStyles = (0, _simpleAssign2.default)({
	        position: 'relative',
	        height: 0,
	        width: '100%',
	        top: 0,
	        left: 0,
	        overflow: 'hidden',
	        transition: _transitions2.default.easeOut(transitionDuration + 'ms', ['height'], transitionDelay + 'ms')
	      }, style);
	
	      return _react2.default.createElement(
	        'div',
	        _extends({}, other, { style: prepareStyles(mergedRootStyles) }),
	        _react2.default.createElement(
	          'div',
	          { ref: 'wrapper' },
	          children
	        )
	      );
	    }
	  }]);
	
	  return ExpandTransitionChild;
	}(_react.Component);
	
	ExpandTransitionChild.propTypes = {
	  children: _react.PropTypes.node,
	  enterDelay: _react.PropTypes.number,
	  style: _react.PropTypes.object,
	  transitionDelay: _react.PropTypes.number,
	  transitionDuration: _react.PropTypes.number
	};
	ExpandTransitionChild.defaultProps = {
	  enterDelay: 0,
	  transitionDelay: 0,
	  transitionDuration: 450
	};
	ExpandTransitionChild.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	exports.default = ExpandTransitionChild;

/***/ }),
/* 881 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _simpleAssign = __webpack_require__(579);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _StepConnector = __webpack_require__(882);
	
	var _StepConnector2 = _interopRequireDefault(_StepConnector);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var getStyles = function getStyles(props) {
	  var orientation = props.orientation;
	
	  return {
	    root: {
	      display: 'flex',
	      flexDirection: orientation === 'horizontal' ? 'row' : 'column',
	      alignContent: 'center',
	      alignItems: orientation === 'horizontal' ? 'center' : 'stretch',
	      justifyContent: 'space-between'
	    }
	  };
	};
	
	var Stepper = function (_Component) {
	  _inherits(Stepper, _Component);
	
	  function Stepper() {
	    _classCallCheck(this, Stepper);
	
	    return _possibleConstructorReturn(this, Object.getPrototypeOf(Stepper).apply(this, arguments));
	  }
	
	  _createClass(Stepper, [{
	    key: 'getChildContext',
	    value: function getChildContext() {
	      var orientation = this.props.orientation;
	
	      return { stepper: { orientation: orientation } };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var activeStep = _props.activeStep;
	      var children = _props.children;
	      var linear = _props.linear;
	      var style = _props.style;
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      /**
	       * One day, we may be able to use real CSS tools
	       * For now, we need to create our own "pseudo" elements
	       * and nth child selectors, etc
	       * That's what some of this garbage is for :)
	       */
	      var steps = _react2.default.Children.map(children, function (step, index) {
	        var controlProps = { index: index };
	
	        if (activeStep === index) {
	          controlProps.active = true;
	        } else if (linear && activeStep > index) {
	          controlProps.completed = true;
	        } else if (linear && activeStep < index) {
	          controlProps.disabled = true;
	        }
	
	        if (index + 1 === children.length) {
	          controlProps.last = true;
	        }
	
	        return [index > 0 && _react2.default.createElement(_StepConnector2.default, null), _react2.default.cloneElement(step, (0, _simpleAssign2.default)(controlProps, step.props))];
	      });
	
	      return _react2.default.createElement(
	        'div',
	        { style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) },
	        steps
	      );
	    }
	  }]);
	
	  return Stepper;
	}(_react.Component);
	
	Stepper.propTypes = {
	  /**
	   * Set the active step (zero based index). This will enable `Step` control helpers.
	   */
	  activeStep: _react.PropTypes.number,
	  /**
	   * Should be two or more `<Step />` components
	   */
	  children: _react.PropTypes.arrayOf(_react.PropTypes.element),
	  /**
	   * If set to `true`, the `Stepper` will assist in controlling steps for linear flow
	   */
	  linear: _react.PropTypes.bool,
	  /**
	   * The stepper orientation (layout flow direction)
	   */
	  orientation: _react.PropTypes.oneOf(['horizontal', 'vertical']),
	  /**
	   * Override the inline-style of the root element.
	   */
	  style: _react.PropTypes.object
	};
	Stepper.defaultProps = {
	  orientation: 'horizontal',
	  linear: true
	};
	Stepper.contextTypes = { muiTheme: _react.PropTypes.object.isRequired };
	Stepper.childContextTypes = { stepper: _react.PropTypes.object };
	exports.default = Stepper;

/***/ }),
/* 882 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PlainStepConnector = undefined;
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(608);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  /**
	   * Override the inline-style of the root element.
	   */
	  style: _react.PropTypes.object
	};
	
	var contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired,
	  stepper: _react.PropTypes.object
	};
	
	var StepConnector = function StepConnector(props, context) {
	  var muiTheme = context.muiTheme;
	  var stepper = context.stepper;
	
	
	  var styles = {
	    wrapper: {
	      flex: '1 1 auto'
	    },
	    line: {
	      display: 'block',
	      borderColor: muiTheme.stepper.connectorLineColor
	    }
	  };
	
	  /**
	   * Clean up once we can use CSS pseudo elements
	   */
	  if (stepper.orientation === 'horizontal') {
	    styles.line.marginLeft = -6;
	    styles.line.borderTopStyle = 'solid';
	    styles.line.borderTopWidth = 1;
	  } else if (stepper.orientation === 'vertical') {
	    styles.wrapper.marginLeft = 14 + 11; // padding + 1/2 icon
	    styles.line.borderLeftStyle = 'solid';
	    styles.line.borderLeftWidth = 1;
	    styles.line.minHeight = 28;
	  }
	
	  var prepareStyles = muiTheme.prepareStyles;
	
	
	  return _react2.default.createElement(
	    'div',
	    { style: prepareStyles(styles.wrapper) },
	    _react2.default.createElement('span', { style: prepareStyles(styles.line) })
	  );
	};
	
	StepConnector.propTypes = propTypes;
	StepConnector.contextTypes = contextTypes;
	
	exports.PlainStepConnector = StepConnector;
	exports.default = (0, _pure2.default)(StepConnector);

/***/ }),
/* 883 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _Snackbar = __webpack_require__(884);
	
	var _Snackbar2 = _interopRequireDefault(_Snackbar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Snackbar2.default;

/***/ }),
/* 884 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _simpleAssign = __webpack_require__(579);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _transitions = __webpack_require__(582);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _ClickAwayListener = __webpack_require__(632);
	
	var _ClickAwayListener2 = _interopRequireDefault(_ClickAwayListener);
	
	var _SnackbarBody = __webpack_require__(885);
	
	var _SnackbarBody2 = _interopRequireDefault(_SnackbarBody);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function getStyles(props, context, state) {
	  var _context$muiTheme = context.muiTheme;
	  var desktopSubheaderHeight = _context$muiTheme.baseTheme.spacing.desktopSubheaderHeight;
	  var zIndex = _context$muiTheme.zIndex;
	  var open = state.open;
	
	
	  var styles = {
	    root: {
	      position: 'fixed',
	      left: 0,
	      display: 'flex',
	      right: 0,
	      bottom: 0,
	      zIndex: zIndex.snackbar,
	      visibility: open ? 'visible' : 'hidden',
	      transform: open ? 'translate(0, 0)' : 'translate(0, ' + desktopSubheaderHeight + 'px)',
	      transition: _transitions2.default.easeOut('400ms', 'transform') + ', ' + _transitions2.default.easeOut('400ms', 'visibility')
	    }
	  };
	
	  return styles;
	}
	
	var Snackbar = function (_Component) {
	  _inherits(Snackbar, _Component);
	
	  function Snackbar() {
	    var _Object$getPrototypeO;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Snackbar);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_Object$getPrototypeO = Object.getPrototypeOf(Snackbar)).call.apply(_Object$getPrototypeO, [this].concat(args))), _this), _this.componentClickAway = function () {
	      if (_this.timerTransitionId) {
	        // If transitioning, don't close the snackbar.
	        return;
	      }
	
	      if (_this.props.open !== null && _this.props.onRequestClose) {
	        _this.props.onRequestClose('clickaway');
	      } else {
	        _this.setState({ open: false });
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Snackbar, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.setState({
	        open: this.props.open,
	        message: this.props.message,
	        action: this.props.action
	      });
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (this.state.open) {
	        this.setAutoHideTimer();
	        this.setTransitionTimer();
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _this2 = this;
	
	      if (this.props.open && nextProps.open && (nextProps.message !== this.props.message || nextProps.action !== this.props.action)) {
	        this.setState({
	          open: false
	        });
	
	        clearTimeout(this.timerOneAtTheTimeId);
	        this.timerOneAtTheTimeId = setTimeout(function () {
	          _this2.setState({
	            message: nextProps.message,
	            action: nextProps.action,
	            open: true
	          });
	        }, 400);
	      } else {
	        var open = nextProps.open;
	
	        this.setState({
	          open: open !== null ? open : this.state.open,
	          message: nextProps.message,
	          action: nextProps.action
	        });
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps, prevState) {
	      if (prevState.open !== this.state.open) {
	        if (this.state.open) {
	          this.setAutoHideTimer();
	          this.setTransitionTimer();
	        } else {
	          clearTimeout(this.timerAutoHideId);
	        }
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      clearTimeout(this.timerAutoHideId);
	      clearTimeout(this.timerTransitionId);
	      clearTimeout(this.timerOneAtTheTimeId);
	    }
	  }, {
	    key: 'setAutoHideTimer',
	
	
	    // Timer that controls delay before snackbar auto hides
	    value: function setAutoHideTimer() {
	      var _this3 = this;
	
	      var autoHideDuration = this.props.autoHideDuration;
	
	      if (autoHideDuration > 0) {
	        clearTimeout(this.timerAutoHideId);
	        this.timerAutoHideId = setTimeout(function () {
	          if (_this3.props.open !== null && _this3.props.onRequestClose) {
	            _this3.props.onRequestClose('timeout');
	          } else {
	            _this3.setState({ open: false });
	          }
	        }, autoHideDuration);
	      }
	    }
	
	    // Timer that controls delay before click-away events are captured (based on when animation completes)
	
	  }, {
	    key: 'setTransitionTimer',
	    value: function setTransitionTimer() {
	      var _this4 = this;
	
	      this.timerTransitionId = setTimeout(function () {
	        _this4.timerTransitionId = undefined;
	      }, 400);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var autoHideDuration = _props.autoHideDuration;
	      var messageProp = _props.message;
	      var onRequestClose = _props.onRequestClose;
	      var onActionTouchTap = _props.onActionTouchTap;
	      var style = _props.style;
	      var bodyStyle = _props.bodyStyle;
	
	      var other = _objectWithoutProperties(_props, ['autoHideDuration', 'message', 'onRequestClose', 'onActionTouchTap', 'style', 'bodyStyle']);
	
	      var _state = this.state;
	      var action = _state.action;
	      var message = _state.message;
	      var open = _state.open;
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context, this.state);
	
	      return _react2.default.createElement(
	        _ClickAwayListener2.default,
	        { onClickAway: open && this.componentClickAway },
	        _react2.default.createElement(
	          'div',
	          _extends({}, other, { style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) }),
	          _react2.default.createElement(_SnackbarBody2.default, {
	            open: open,
	            message: message,
	            action: action,
	            style: bodyStyle,
	            onActionTouchTap: onActionTouchTap
	          })
	        )
	      );
	    }
	  }]);
	
	  return Snackbar;
	}(_react.Component);
	
	Snackbar.propTypes = {
	  /**
	   * The label for the action on the snackbar.
	   */
	  action: _react.PropTypes.node,
	  /**
	   * The number of milliseconds to wait before automatically dismissing.
	   * If no value is specified the snackbar will dismiss normally.
	   * If a value is provided the snackbar can still be dismissed normally.
	   * If a snackbar is dismissed before the timer expires, the timer will be cleared.
	   */
	  autoHideDuration: _react.PropTypes.number,
	  /**
	   * Override the inline-styles of the body element.
	   */
	  bodyStyle: _react.PropTypes.object,
	  /**
	   * The css class name of the root element.
	   */
	  className: _react.PropTypes.string,
	  /**
	   * The message to be displayed.
	   *
	   * (Note: If the message is an element or array, and the `Snackbar` may re-render while it is still open,
	   * ensure that the same object remains as the `message` property if you want to avoid the `Snackbar` hiding and
	   * showing again)
	   */
	  message: _react.PropTypes.node.isRequired,
	  /**
	   * Fired when the action button is touchtapped.
	   *
	   * @param {object} event Action button event.
	   */
	  onActionTouchTap: _react.PropTypes.func,
	  /**
	   * Fired when the `Snackbar` is requested to be closed by a click outside the `Snackbar`, or after the
	   * `autoHideDuration` timer expires.
	   *
	   * Typically `onRequestClose` is used to set state in the parent component, which is used to control the `Snackbar`
	   * `open` prop.
	   *
	   * The `reason` parameter can optionally be used to control the response to `onRequestClose`,
	   * for example ignoring `clickaway`.
	   *
	   * @param {string} reason Can be:`"timeout"` (`autoHideDuration` expired) or: `"clickaway"`
	   */
	  onRequestClose: _react.PropTypes.func,
	  /**
	   * Controls whether the `Snackbar` is opened or not.
	   */
	  open: _react.PropTypes.bool.isRequired,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object
	};
	Snackbar.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	exports.default = Snackbar;

/***/ }),
/* 885 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SnackbarBody = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _simpleAssign = __webpack_require__(579);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _transitions = __webpack_require__(582);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _withWidth = __webpack_require__(886);
	
	var _withWidth2 = _interopRequireDefault(_withWidth);
	
	var _FlatButton = __webpack_require__(694);
	
	var _FlatButton2 = _interopRequireDefault(_FlatButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function getStyles(props, context) {
	  var open = props.open;
	  var width = props.width;
	  var _context$muiTheme = context.muiTheme;
	  var _context$muiTheme$bas = _context$muiTheme.baseTheme;
	  var _context$muiTheme$bas2 = _context$muiTheme$bas.spacing;
	  var desktopGutter = _context$muiTheme$bas2.desktopGutter;
	  var desktopSubheaderHeight = _context$muiTheme$bas2.desktopSubheaderHeight;
	  var fontFamily = _context$muiTheme$bas.fontFamily;
	  var _context$muiTheme$sna = _context$muiTheme.snackbar;
	  var backgroundColor = _context$muiTheme$sna.backgroundColor;
	  var textColor = _context$muiTheme$sna.textColor;
	  var actionColor = _context$muiTheme$sna.actionColor;
	
	
	  var isSmall = width === _withWidth.SMALL;
	
	  var styles = {
	    root: {
	      fontFamily: fontFamily,
	      backgroundColor: backgroundColor,
	      padding: '0 ' + desktopGutter + 'px',
	      height: desktopSubheaderHeight,
	      lineHeight: desktopSubheaderHeight + 'px',
	      borderRadius: isSmall ? 0 : 2,
	      maxWidth: isSmall ? 'inherit' : 568,
	      minWidth: isSmall ? 'inherit' : 288,
	      flexGrow: isSmall ? 1 : 0,
	      margin: 'auto'
	    },
	    content: {
	      fontSize: 14,
	      color: textColor,
	      opacity: open ? 1 : 0,
	      transition: open ? _transitions2.default.easeOut('500ms', 'opacity', '100ms') : _transitions2.default.easeOut('400ms', 'opacity')
	    },
	    action: {
	      color: actionColor,
	      float: 'right',
	      marginTop: 6,
	      marginRight: -16,
	      marginLeft: desktopGutter,
	      backgroundColor: 'transparent'
	    }
	  };
	
	  return styles;
	}
	
	var SnackbarBody = exports.SnackbarBody = function SnackbarBody(props, context) {
	  var open = props.open;
	  var action = props.action;
	  var message = props.message;
	  var onActionTouchTap = props.onActionTouchTap;
	  var style = props.style;
	
	  var other = _objectWithoutProperties(props, ['open', 'action', 'message', 'onActionTouchTap', 'style']);
	
	  var prepareStyles = context.muiTheme.prepareStyles;
	
	  var styles = getStyles(props, context);
	
	  var actionButton = action && _react2.default.createElement(_FlatButton2.default, {
	    style: styles.action,
	    label: action,
	    onTouchTap: onActionTouchTap
	  });
	
	  return _react2.default.createElement(
	    'div',
	    _extends({}, other, { style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) }),
	    _react2.default.createElement(
	      'div',
	      { style: prepareStyles(styles.content) },
	      _react2.default.createElement(
	        'span',
	        null,
	        message
	      ),
	      actionButton
	    )
	  );
	};
	
	SnackbarBody.propTypes = {
	  /**
	   * The label for the action on the snackbar.
	   */
	  action: _react.PropTypes.node,
	  /**
	   * The message to be displayed.
	   *
	   * (Note: If the message is an element or array, and the `Snackbar` may re-render while it is still open,
	   * ensure that the same object remains as the `message` property if you want to avoid the `Snackbar` hiding and
	   * showing again)
	   */
	  message: _react.PropTypes.node.isRequired,
	  /**
	   * Fired when the action button is touchtapped.
	   *
	   * @param {object} event Action button event.
	   */
	  onActionTouchTap: _react.PropTypes.func,
	  /**
	   * @ignore
	   * Controls whether the `Snackbar` is opened or not.
	   */
	  open: _react.PropTypes.bool.isRequired,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object,
	  /**
	   * @ignore
	   * Width of the screen.
	   */
	  width: _react.PropTypes.number.isRequired
	};
	
	SnackbarBody.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	
	exports.default = (0, _withWidth2.default)()(SnackbarBody);

/***/ }),
/* 886 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.LARGE = exports.MEDIUM = exports.SMALL = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.default = withWidth;
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactEventListener = __webpack_require__(625);
	
	var _reactEventListener2 = _interopRequireDefault(_reactEventListener);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SMALL = exports.SMALL = 1;
	var MEDIUM = exports.MEDIUM = 2;
	var LARGE = exports.LARGE = 3;
	
	function withWidth() {
	  var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	  var _options$largeWidth = options.largeWidth;
	  var largeWidth = _options$largeWidth === undefined ? 992 : _options$largeWidth;
	  var _options$mediumWidth = options.mediumWidth;
	  var mediumWidth = _options$mediumWidth === undefined ? 768 : _options$mediumWidth;
	  var _options$resizeInterv = options.resizeInterval;
	  var resizeInterval = _options$resizeInterv === undefined ? 166 : _options$resizeInterv;
	
	
	  return function (MyComponent) {
	    return function (_Component) {
	      _inherits(WithWidth, _Component);
	
	      function WithWidth() {
	        var _Object$getPrototypeO;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, WithWidth);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	          args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_Object$getPrototypeO = Object.getPrototypeOf(WithWidth)).call.apply(_Object$getPrototypeO, [this].concat(args))), _this), _this.state = {
	          /**
	           * For the server side rendering,
	           * let's set the width for the slower environment.
	           */
	          width: SMALL
	        }, _this.handleResize = function () {
	          clearTimeout(_this.deferTimer);
	          _this.deferTimer = setTimeout(function () {
	            _this.updateWidth();
	          }, resizeInterval);
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	      }
	
	      _createClass(WithWidth, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	          this.updateWidth();
	        }
	      }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	          clearTimeout(this.deferTimer);
	        }
	      }, {
	        key: 'updateWidth',
	        value: function updateWidth() {
	          var innerWidth = window.innerWidth;
	          var width = void 0;
	
	          if (innerWidth >= largeWidth) {
	            width = LARGE;
	          } else if (innerWidth >= mediumWidth) {
	            width = MEDIUM;
	          } else {
	            // innerWidth < 768
	            width = SMALL;
	          }
	
	          if (width !== this.state.width) {
	            this.setState({
	              width: width
	            });
	          }
	        }
	      }, {
	        key: 'render',
	        value: function render() {
	          return _react2.default.createElement(
	            _reactEventListener2.default,
	            { target: 'window', onResize: this.handleResize },
	            _react2.default.createElement(MyComponent, _extends({}, this.props, {
	              width: this.state.width
	            }))
	          );
	        }
	      }]);
	
	      return WithWidth;
	    }(_react.Component);
	  };
	}

/***/ }),
/* 887 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.Tabs = exports.Tab = undefined;
	
	var _Tab2 = __webpack_require__(888);
	
	var _Tab3 = _interopRequireDefault(_Tab2);
	
	var _Tabs2 = __webpack_require__(889);
	
	var _Tabs3 = _interopRequireDefault(_Tabs2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Tab = _Tab3.default;
	exports.Tabs = _Tabs3.default;
	exports.default = _Tabs3.default;

/***/ }),
/* 888 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _simpleAssign = __webpack_require__(579);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _EnhancedButton = __webpack_require__(584);
	
	var _EnhancedButton2 = _interopRequireDefault(_EnhancedButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function getStyles(props, context) {
	  var tabs = context.muiTheme.tabs;
	
	
	  return {
	    root: {
	      color: props.selected ? tabs.selectedTextColor : tabs.textColor,
	      fontWeight: 500,
	      fontSize: 14,
	      width: props.width,
	      textTransform: 'uppercase',
	      padding: 0
	    },
	    button: {
	      display: 'flex',
	      flexDirection: 'column',
	      alignItems: 'center',
	      justifyContent: 'center',
	      height: props.label && props.icon ? 72 : 48
	    }
	  };
	}
	
	var Tab = function (_Component) {
	  _inherits(Tab, _Component);
	
	  function Tab() {
	    var _Object$getPrototypeO;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Tab);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_Object$getPrototypeO = Object.getPrototypeOf(Tab)).call.apply(_Object$getPrototypeO, [this].concat(args))), _this), _this.handleTouchTap = function (event) {
	      if (_this.props.onTouchTap) {
	        _this.props.onTouchTap(_this.props.value, event, _this);
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Tab, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var icon = _props.icon;
	      var index = _props.index;
	      var onActive = _props.onActive;
	      var onTouchTap = _props.onTouchTap;
	      var selected = _props.selected;
	      var label = _props.label;
	      var style = _props.style;
	      var value = _props.value;
	      var width = _props.width;
	
	      var other = _objectWithoutProperties(_props, ['icon', 'index', 'onActive', 'onTouchTap', 'selected', 'label', 'style', 'value', 'width']);
	
	      var styles = getStyles(this.props, this.context);
	
	      var iconElement = void 0;
	      if (icon && _react2.default.isValidElement(icon)) {
	        var iconProps = {
	          style: {
	            fontSize: 24,
	            color: styles.root.color,
	            marginBottom: label ? 5 : 0
	          }
	        };
	        // If it's svg icon set color via props
	        if (icon.type.muiName !== 'FontIcon') {
	          iconProps.color = styles.root.color;
	        }
	        iconElement = _react2.default.cloneElement(icon, iconProps);
	      }
	
	      var rippleOpacity = 0.3;
	      var rippleColor = this.context.muiTheme.tabs.selectedTextColor;
	
	      return _react2.default.createElement(
	        _EnhancedButton2.default,
	        _extends({}, other, {
	          style: (0, _simpleAssign2.default)(styles.root, style),
	          focusRippleColor: rippleColor,
	          touchRippleColor: rippleColor,
	          focusRippleOpacity: rippleOpacity,
	          touchRippleOpacity: rippleOpacity,
	          onTouchTap: this.handleTouchTap
	        }),
	        _react2.default.createElement(
	          'div',
	          { style: styles.button },
	          iconElement,
	          label
	        )
	      );
	    }
	  }]);
	
	  return Tab;
	}(_react.Component);
	
	Tab.muiName = 'Tab';
	Tab.propTypes = {
	  /**
	   * The css class name of the root element.
	   */
	  className: _react.PropTypes.string,
	  /**
	   * Sets the icon of the tab, you can pass `FontIcon` or `SvgIcon` elements.
	   */
	  icon: _react.PropTypes.node,
	  /**
	   * @ignore
	   */
	  index: _react.PropTypes.any,
	  /**
	   * Sets the text value of the tab item to the string specified.
	   */
	  label: _react.PropTypes.node,
	  /**
	   * Fired when the active tab changes by touch or tap.
	   * Use this event to specify any functionality when an active tab changes.
	   * For example - we are using this to route to home when the third tab becomes active.
	   * This function will always recieve the active tab as it\'s first argument.
	   */
	  onActive: _react.PropTypes.func,
	  /**
	   * @ignore
	   * This property is overriden by the Tabs component.
	   */
	  onTouchTap: _react.PropTypes.func,
	  /**
	   * @ignore
	   * Defines if the current tab is selected or not.
	   * The Tabs component is responsible for setting this property.
	   */
	  selected: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object,
	  /**
	   * If value prop passed to Tabs component, this value prop is also required.
	   * It assigns a value to the tab so that it can be selected by the Tabs.
	   */
	  value: _react.PropTypes.any,
	  /**
	   * @ignore
	   * This property is overriden by the Tabs component.
	   */
	  width: _react.PropTypes.string
	};
	Tab.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	exports.default = Tab;

/***/ }),
/* 889 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _simpleAssign = __webpack_require__(579);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(332);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _TabTemplate = __webpack_require__(890);
	
	var _TabTemplate2 = _interopRequireDefault(_TabTemplate);
	
	var _InkBar = __webpack_require__(891);
	
	var _InkBar2 = _interopRequireDefault(_InkBar);
	
	var _warning = __webpack_require__(491);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function getStyles(props, context) {
	  var tabs = context.muiTheme.tabs;
	
	
	  return {
	    tabItemContainer: {
	      width: '100%',
	      backgroundColor: tabs.backgroundColor,
	      whiteSpace: 'nowrap'
	    }
	  };
	}
	
	var Tabs = function (_Component) {
	  _inherits(Tabs, _Component);
	
	  function Tabs() {
	    var _Object$getPrototypeO;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Tabs);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_Object$getPrototypeO = Object.getPrototypeOf(Tabs)).call.apply(_Object$getPrototypeO, [this].concat(args))), _this), _this.state = { selectedIndex: 0 }, _this.handleTabTouchTap = function (value, event, tab) {
	      var valueLink = _this.getValueLink(_this.props);
	      var index = tab.props.index;
	
	      if (valueLink.value && valueLink.value !== value || _this.state.selectedIndex !== index) {
	        valueLink.requestChange(value, event, tab);
	      }
	
	      _this.setState({ selectedIndex: index });
	
	      if (tab.props.onActive) {
	        tab.props.onActive(tab);
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Tabs, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var valueLink = this.getValueLink(this.props);
	      var initialIndex = this.props.initialSelectedIndex;
	
	      this.setState({
	        selectedIndex: valueLink.value !== undefined ? this.getSelectedIndex(this.props) : initialIndex < this.getTabCount() ? initialIndex : 0
	      });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(newProps, nextContext) {
	      var valueLink = this.getValueLink(newProps);
	      var newState = {
	        muiTheme: nextContext.muiTheme || this.context.muiTheme
	      };
	
	      if (valueLink.value !== undefined) {
	        newState.selectedIndex = this.getSelectedIndex(newProps);
	      }
	
	      this.setState(newState);
	    }
	  }, {
	    key: 'getEvenWidth',
	    value: function getEvenWidth() {
	      return parseInt(window.getComputedStyle(_reactDom2.default.findDOMNode(this)).getPropertyValue('width'), 10);
	    }
	  }, {
	    key: 'getTabs',
	    value: function getTabs() {
	      var tabs = [];
	      _react2.default.Children.forEach(this.props.children, function (tab) {
	        if (_react2.default.isValidElement(tab)) {
	          tabs.push(tab);
	        }
	      });
	      return tabs;
	    }
	  }, {
	    key: 'getTabCount',
	    value: function getTabCount() {
	      return this.getTabs().length;
	    }
	
	    // Do not use outside of this component, it will be removed once valueLink is deprecated
	
	  }, {
	    key: 'getValueLink',
	    value: function getValueLink(props) {
	      return props.valueLink || {
	        value: props.value,
	        requestChange: props.onChange
	      };
	    }
	  }, {
	    key: 'getSelectedIndex',
	    value: function getSelectedIndex(props) {
	      var valueLink = this.getValueLink(props);
	      var selectedIndex = -1;
	
	      this.getTabs().forEach(function (tab, index) {
	        if (valueLink.value === tab.props.value) {
	          selectedIndex = index;
	        }
	      });
	
	      return selectedIndex;
	    }
	  }, {
	    key: 'getSelected',
	    value: function getSelected(tab, index) {
	      var valueLink = this.getValueLink(this.props);
	      return valueLink.value ? valueLink.value === tab.props.value : this.state.selectedIndex === index;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props;
	      var contentContainerClassName = _props.contentContainerClassName;
	      var contentContainerStyle = _props.contentContainerStyle;
	      var initialSelectedIndex = _props.initialSelectedIndex;
	      var inkBarStyle = _props.inkBarStyle;
	      var style = _props.style;
	      var tabItemContainerStyle = _props.tabItemContainerStyle;
	      var tabTemplate = _props.tabTemplate;
	
	      var other = _objectWithoutProperties(_props, ['contentContainerClassName', 'contentContainerStyle', 'initialSelectedIndex', 'inkBarStyle', 'style', 'tabItemContainerStyle', 'tabTemplate']);
	
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	      var valueLink = this.getValueLink(this.props);
	      var tabValue = valueLink.value;
	      var tabContent = [];
	      var width = 100 / this.getTabCount();
	
	      var tabs = this.getTabs().map(function (tab, index) {
	         false ? (0, _warning2.default)(tab.type && tab.type.muiName === 'Tab', 'Tabs only accepts Tab Components as children.\n        Found ' + (tab.type.muiName || tab.type) + ' as child number ' + (index + 1) + ' of Tabs') : void 0;
	
	         false ? (0, _warning2.default)(!tabValue || tab.props.value !== undefined, 'Tabs value prop has been passed, but Tab ' + index + '\n        does not have a value prop. Needs value if Tabs is going\n        to be a controlled component.') : void 0;
	
	        tabContent.push(tab.props.children ? _react2.default.createElement(tabTemplate || _TabTemplate2.default, {
	          key: index,
	          selected: _this2.getSelected(tab, index)
	        }, tab.props.children) : undefined);
	
	        return _react2.default.cloneElement(tab, {
	          key: index,
	          index: index,
	          selected: _this2.getSelected(tab, index),
	          width: width + '%',
	          onTouchTap: _this2.handleTabTouchTap
	        });
	      });
	
	      var inkBar = this.state.selectedIndex !== -1 ? _react2.default.createElement(_InkBar2.default, {
	        left: width * this.state.selectedIndex + '%',
	        width: width + '%',
	        style: inkBarStyle
	      }) : null;
	
	      var inkBarContainerWidth = tabItemContainerStyle ? tabItemContainerStyle.width : '100%';
	
	      return _react2.default.createElement(
	        'div',
	        _extends({}, other, {
	          style: prepareStyles((0, _simpleAssign2.default)({}, style))
	        }),
	        _react2.default.createElement(
	          'div',
	          { style: prepareStyles((0, _simpleAssign2.default)(styles.tabItemContainer, tabItemContainerStyle)) },
	          tabs
	        ),
	        _react2.default.createElement(
	          'div',
	          { style: { width: inkBarContainerWidth } },
	          inkBar
	        ),
	        _react2.default.createElement(
	          'div',
	          {
	            style: prepareStyles((0, _simpleAssign2.default)({}, contentContainerStyle)),
	            className: contentContainerClassName
	          },
	          tabContent
	        )
	      );
	    }
	  }]);
	
	  return Tabs;
	}(_react.Component);
	
	Tabs.propTypes = {
	  /**
	   * Should be used to pass `Tab` components.
	   */
	  children: _react.PropTypes.node,
	  /**
	   * The css class name of the root element.
	   */
	  className: _react.PropTypes.string,
	  /**
	   * The css class name of the content's container.
	   */
	  contentContainerClassName: _react.PropTypes.string,
	  /**
	   * Override the inline-styles of the content's container.
	   */
	  contentContainerStyle: _react.PropTypes.object,
	  /**
	   * Specify initial visible tab index.
	   * If `initialSelectedIndex` is set but larger than the total amount of specified tabs,
	   * `initialSelectedIndex` will revert back to default.
	   * If `initialSlectedIndex` is set to any negative value, no tab will be selected intially.
	   */
	  initialSelectedIndex: _react.PropTypes.number,
	  /**
	   * Override the inline-styles of the InkBar.
	   */
	  inkBarStyle: _react.PropTypes.object,
	  /**
	   * Called when the selected value change.
	   */
	  onChange: _react.PropTypes.func,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object,
	  /**
	   * Override the inline-styles of the tab-labels container.
	   */
	  tabItemContainerStyle: _react.PropTypes.object,
	  /**
	   * Override the default tab template used to wrap the content of each tab element.
	   */
	  tabTemplate: _react.PropTypes.func,
	  /**
	   * Makes Tabs controllable and selects the tab whose value prop matches this prop.
	   */
	  value: _react.PropTypes.any
	};
	Tabs.defaultProps = {
	  initialSelectedIndex: 0,
	  onChange: function onChange() {}
	};
	Tabs.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	exports.default = Tabs;

/***/ }),
/* 890 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TabTemplate = function (_Component) {
	  _inherits(TabTemplate, _Component);
	
	  function TabTemplate() {
	    _classCallCheck(this, TabTemplate);
	
	    return _possibleConstructorReturn(this, Object.getPrototypeOf(TabTemplate).apply(this, arguments));
	  }
	
	  _createClass(TabTemplate, [{
	    key: 'render',
	    value: function render() {
	      var styles = {
	        width: '100%',
	        position: 'relative',
	        textAlign: 'initial'
	      };
	
	      if (!this.props.selected) {
	        styles.height = 0;
	        styles.overflow = 'hidden';
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { style: styles },
	        this.props.children
	      );
	    }
	  }]);
	
	  return TabTemplate;
	}(_react.Component);
	
	TabTemplate.propTypes = {
	  children: _react.PropTypes.node,
	  selected: _react.PropTypes.bool
	};
	exports.default = TabTemplate;

/***/ }),
/* 891 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _simpleAssign = __webpack_require__(579);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _transitions = __webpack_require__(582);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function getStyles(props, context) {
	  var inkBar = context.muiTheme.inkBar;
	
	
	  return {
	    root: {
	      left: props.left,
	      width: props.width,
	      bottom: 0,
	      display: 'block',
	      backgroundColor: props.color || inkBar.backgroundColor,
	      height: 2,
	      marginTop: -2,
	      position: 'relative',
	      transition: _transitions2.default.easeOut('1s', 'left')
	    }
	  };
	}
	
	var InkBar = function (_Component) {
	  _inherits(InkBar, _Component);
	
	  function InkBar() {
	    _classCallCheck(this, InkBar);
	
	    return _possibleConstructorReturn(this, Object.getPrototypeOf(InkBar).apply(this, arguments));
	  }
	
	  _createClass(InkBar, [{
	    key: 'render',
	    value: function render() {
	      var style = this.props.style;
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      return _react2.default.createElement('div', { style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) });
	    }
	  }]);
	
	  return InkBar;
	}(_react.Component);
	
	InkBar.propTypes = {
	  color: _react.PropTypes.string,
	  left: _react.PropTypes.string.isRequired,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object,
	  width: _react.PropTypes.string.isRequired
	};
	InkBar.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	exports.default = InkBar;

/***/ }),
/* 892 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.TableRowColumn = exports.TableRow = exports.TableHeaderColumn = exports.TableHeader = exports.TableFooter = exports.TableBody = exports.Table = undefined;
	
	var _Table2 = __webpack_require__(893);
	
	var _Table3 = _interopRequireDefault(_Table2);
	
	var _TableBody2 = __webpack_require__(894);
	
	var _TableBody3 = _interopRequireDefault(_TableBody2);
	
	var _TableFooter2 = __webpack_require__(896);
	
	var _TableFooter3 = _interopRequireDefault(_TableFooter2);
	
	var _TableHeader2 = __webpack_require__(897);
	
	var _TableHeader3 = _interopRequireDefault(_TableHeader2);
	
	var _TableHeaderColumn2 = __webpack_require__(898);
	
	var _TableHeaderColumn3 = _interopRequireDefault(_TableHeaderColumn2);
	
	var _TableRow2 = __webpack_require__(899);
	
	var _TableRow3 = _interopRequireDefault(_TableRow2);
	
	var _TableRowColumn2 = __webpack_require__(895);
	
	var _TableRowColumn3 = _interopRequireDefault(_TableRowColumn2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Table = _Table3.default;
	exports.TableBody = _TableBody3.default;
	exports.TableFooter = _TableFooter3.default;
	exports.TableHeader = _TableHeader3.default;
	exports.TableHeaderColumn = _TableHeaderColumn3.default;
	exports.TableRow = _TableRow3.default;
	exports.TableRowColumn = _TableRowColumn3.default;
	exports.default = _Table3.default;

/***/ }),
/* 893 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _simpleAssign = __webpack_require__(579);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function getStyles(props, context) {
	  var _context$muiTheme = context.muiTheme;
	  var baseTheme = _context$muiTheme.baseTheme;
	  var table = _context$muiTheme.table;
	
	
	  return {
	    root: {
	      backgroundColor: table.backgroundColor,
	      padding: '0 ' + baseTheme.spacing.desktopGutter + 'px',
	      width: '100%',
	      borderCollapse: 'collapse',
	      borderSpacing: 0,
	      tableLayout: 'fixed',
	      fontFamily: baseTheme.fontFamily
	    },
	    bodyTable: {
	      height: props.fixedHeader || props.fixedFooter ? props.height : 'auto',
	      overflowX: 'hidden',
	      overflowY: 'auto'
	    },
	    tableWrapper: {
	      height: props.fixedHeader || props.fixedFooter ? 'auto' : props.height,
	      overflow: 'auto'
	    }
	  };
	}
	
	var Table = function (_Component) {
	  _inherits(Table, _Component);
	
	  function Table() {
	    var _Object$getPrototypeO;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Table);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_Object$getPrototypeO = Object.getPrototypeOf(Table)).call.apply(_Object$getPrototypeO, [this].concat(args))), _this), _this.state = {
	      allRowsSelected: false
	    }, _this.onCellClick = function (rowNumber, columnNumber, event) {
	      if (_this.props.onCellClick) _this.props.onCellClick(rowNumber, columnNumber, event);
	    }, _this.onCellHover = function (rowNumber, columnNumber, event) {
	      if (_this.props.onCellHover) _this.props.onCellHover(rowNumber, columnNumber, event);
	    }, _this.onCellHoverExit = function (rowNumber, columnNumber, event) {
	      if (_this.props.onCellHoverExit) _this.props.onCellHoverExit(rowNumber, columnNumber, event);
	    }, _this.onRowHover = function (rowNumber) {
	      if (_this.props.onRowHover) _this.props.onRowHover(rowNumber);
	    }, _this.onRowHoverExit = function (rowNumber) {
	      if (_this.props.onRowHoverExit) _this.props.onRowHoverExit(rowNumber);
	    }, _this.onRowSelection = function (selectedRows) {
	      if (_this.state.allRowsSelected) _this.setState({ allRowsSelected: false });
	      if (_this.props.onRowSelection) _this.props.onRowSelection(selectedRows);
	    }, _this.onSelectAll = function () {
	      if (_this.props.onRowSelection) {
	        if (!_this.state.allRowsSelected) {
	          _this.props.onRowSelection('all');
	        } else {
	          _this.props.onRowSelection('none');
	        }
	      }
	
	      _this.setState({ allRowsSelected: !_this.state.allRowsSelected });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Table, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      if (this.props.allRowsSelected) {
	        this.setState({ allRowsSelected: true });
	      }
	    }
	  }, {
	    key: 'isScrollbarVisible',
	    value: function isScrollbarVisible() {
	      var tableDivHeight = this.refs.tableDiv.clientHeight;
	      var tableBodyHeight = this.refs.tableBody.clientHeight;
	
	      return tableBodyHeight > tableDivHeight;
	    }
	  }, {
	    key: 'createTableHeader',
	    value: function createTableHeader(base) {
	      return _react2.default.cloneElement(base, {
	        enableSelectAll: base.props.enableSelectAll && this.props.selectable && this.props.multiSelectable,
	        onSelectAll: this.onSelectAll,
	        selectAllSelected: this.state.allRowsSelected
	      });
	    }
	  }, {
	    key: 'createTableBody',
	    value: function createTableBody(base) {
	      return _react2.default.cloneElement(base, {
	        allRowsSelected: this.state.allRowsSelected,
	        multiSelectable: this.props.multiSelectable,
	        onCellClick: this.onCellClick,
	        onCellHover: this.onCellHover,
	        onCellHoverExit: this.onCellHoverExit,
	        onRowHover: this.onRowHover,
	        onRowHoverExit: this.onRowHoverExit,
	        onRowSelection: this.onRowSelection,
	        selectable: this.props.selectable,
	        style: (0, _simpleAssign2.default)({ height: this.props.height }, base.props.style)
	      });
	    }
	  }, {
	    key: 'createTableFooter',
	    value: function createTableFooter(base) {
	      return base;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props;
	      var children = _props.children;
	      var className = _props.className;
	      var fixedFooter = _props.fixedFooter;
	      var fixedHeader = _props.fixedHeader;
	      var style = _props.style;
	      var wrapperStyle = _props.wrapperStyle;
	      var headerStyle = _props.headerStyle;
	      var bodyStyle = _props.bodyStyle;
	      var footerStyle = _props.footerStyle;
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      var tHead = void 0;
	      var tFoot = void 0;
	      var tBody = void 0;
	
	      _react2.default.Children.forEach(children, function (child) {
	        if (!_react2.default.isValidElement(child)) return;
	
	        var muiName = child.type.muiName;
	
	        if (muiName === 'TableBody') {
	          tBody = _this2.createTableBody(child);
	        } else if (muiName === 'TableHeader') {
	          tHead = _this2.createTableHeader(child);
	        } else if (muiName === 'TableFooter') {
	          tFoot = _this2.createTableFooter(child);
	        }
	      });
	
	      // If we could not find a table-header and a table-body, do not attempt to display anything.
	      if (!tBody && !tHead) return null;
	
	      var mergedTableStyle = (0, _simpleAssign2.default)(styles.root, style);
	      var headerTable = void 0;
	      var footerTable = void 0;
	      var inlineHeader = void 0;
	      var inlineFooter = void 0;
	
	      if (fixedHeader) {
	        headerTable = _react2.default.createElement(
	          'div',
	          { style: prepareStyles((0, _simpleAssign2.default)({}, headerStyle)) },
	          _react2.default.createElement(
	            'table',
	            { className: className, style: mergedTableStyle },
	            tHead
	          )
	        );
	      } else {
	        inlineHeader = tHead;
	      }
	
	      if (tFoot !== undefined) {
	        if (fixedFooter) {
	          footerTable = _react2.default.createElement(
	            'div',
	            { style: prepareStyles((0, _simpleAssign2.default)({}, footerStyle)) },
	            _react2.default.createElement(
	              'table',
	              { className: className, style: prepareStyles(mergedTableStyle) },
	              tFoot
	            )
	          );
	        } else {
	          inlineFooter = tFoot;
	        }
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { style: prepareStyles((0, _simpleAssign2.default)(styles.tableWrapper, wrapperStyle)) },
	        headerTable,
	        _react2.default.createElement(
	          'div',
	          { style: prepareStyles((0, _simpleAssign2.default)(styles.bodyTable, bodyStyle)), ref: 'tableDiv' },
	          _react2.default.createElement(
	            'table',
	            { className: className, style: mergedTableStyle, ref: 'tableBody' },
	            inlineHeader,
	            inlineFooter,
	            tBody
	          )
	        ),
	        footerTable
	      );
	    }
	  }]);
	
	  return Table;
	}(_react.Component);
	
	Table.propTypes = {
	  /**
	   * Set to true to indicate that all rows should be selected.
	   */
	  allRowsSelected: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of the body's table element.
	   */
	  bodyStyle: _react.PropTypes.object,
	  /**
	   * Children passed to table.
	   */
	  children: _react.PropTypes.node,
	  /**
	   * The css class name of the root element.
	   */
	  className: _react.PropTypes.string,
	  /**
	   * If true, the footer will appear fixed below the table.
	   * The default value is true.
	   */
	  fixedFooter: _react.PropTypes.bool,
	  /**
	   * If true, the header will appear fixed above the table.
	   * The default value is true.
	   */
	  fixedHeader: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of the footer's table element.
	   */
	  footerStyle: _react.PropTypes.object,
	  /**
	   * Override the inline-styles of the header's table element.
	   */
	  headerStyle: _react.PropTypes.object,
	  /**
	   * The height of the table.
	   */
	  height: _react.PropTypes.string,
	  /**
	   * If true, multiple table rows can be selected.
	   * CTRL/CMD+Click and SHIFT+Click are valid actions.
	   * The default value is false.
	   */
	  multiSelectable: _react.PropTypes.bool,
	  /**
	   * Called when a row cell is clicked.
	   * rowNumber is the row number and columnId is
	   * the column number or the column key.
	   */
	  onCellClick: _react.PropTypes.func,
	  /**
	   * Called when a table cell is hovered.
	   * rowNumber is the row number of the hovered row
	   * and columnId is the column number or the column key of the cell.
	   */
	  onCellHover: _react.PropTypes.func,
	  /**
	   * Called when a table cell is no longer hovered.
	   * rowNumber is the row number of the row and columnId
	   * is the column number or the column key of the cell.
	   */
	  onCellHoverExit: _react.PropTypes.func,
	  /**
	   * Called when a table row is hovered.
	   * rowNumber is the row number of the hovered row.
	   */
	  onRowHover: _react.PropTypes.func,
	  /**
	   * Called when a table row is no longer hovered.
	   * rowNumber is the row number of the row that is no longer hovered.
	   */
	  onRowHoverExit: _react.PropTypes.func,
	  /**
	   * Called when a row is selected.
	   * selectedRows is an array of all row selections.
	   * IF all rows have been selected, the string "all"
	   * will be returned instead to indicate that all rows have been selected.
	   */
	  onRowSelection: _react.PropTypes.func,
	  /**
	   * If true, table rows can be selected.
	   * If multiple row selection is desired, enable multiSelectable.
	   * The default value is true.
	   */
	  selectable: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object,
	  /**
	   * Override the inline-styles of the table's wrapper element.
	   */
	  wrapperStyle: _react.PropTypes.object
	};
	Table.defaultProps = {
	  allRowsSelected: false,
	  fixedFooter: true,
	  fixedHeader: true,
	  height: 'inherit',
	  multiSelectable: false,
	  selectable: true
	};
	Table.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	exports.default = Table;

/***/ }),
/* 894 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _simpleAssign = __webpack_require__(579);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Checkbox = __webpack_require__(678);
	
	var _Checkbox2 = _interopRequireDefault(_Checkbox);
	
	var _TableRowColumn = __webpack_require__(895);
	
	var _TableRowColumn2 = _interopRequireDefault(_TableRowColumn);
	
	var _ClickAwayListener = __webpack_require__(632);
	
	var _ClickAwayListener2 = _interopRequireDefault(_ClickAwayListener);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TableBody = function (_Component) {
	  _inherits(TableBody, _Component);
	
	  function TableBody() {
	    var _Object$getPrototypeO;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, TableBody);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_Object$getPrototypeO = Object.getPrototypeOf(TableBody)).call.apply(_Object$getPrototypeO, [this].concat(args))), _this), _this.state = {
	      selectedRows: []
	    }, _this.handleClickAway = function () {
	      if (_this.props.deselectOnClickaway && _this.state.selectedRows.length) {
	        _this.setState({
	          selectedRows: []
	        });
	        if (_this.props.onRowSelection) {
	          _this.props.onRowSelection([]);
	        }
	      }
	    }, _this.onRowClick = function (event, rowNumber) {
	      event.stopPropagation();
	
	      if (_this.props.selectable) {
	        // Prevent text selection while selecting rows.
	        window.getSelection().removeAllRanges();
	        _this.processRowSelection(event, rowNumber);
	      }
	    }, _this.onCellClick = function (event, rowNumber, columnNumber) {
	      event.stopPropagation();
	      if (_this.props.onCellClick) {
	        _this.props.onCellClick(rowNumber, _this.getColumnId(columnNumber), event);
	      }
	    }, _this.onCellHover = function (event, rowNumber, columnNumber) {
	      if (_this.props.onCellHover) {
	        _this.props.onCellHover(rowNumber, _this.getColumnId(columnNumber), event);
	      }
	      _this.onRowHover(event, rowNumber);
	    }, _this.onCellHoverExit = function (event, rowNumber, columnNumber) {
	      if (_this.props.onCellHoverExit) {
	        _this.props.onCellHoverExit(rowNumber, _this.getColumnId(columnNumber), event);
	      }
	      _this.onRowHoverExit(event, rowNumber);
	    }, _this.onRowHover = function (event, rowNumber) {
	      if (_this.props.onRowHover) {
	        _this.props.onRowHover(rowNumber);
	      }
	    }, _this.onRowHoverExit = function (event, rowNumber) {
	      if (_this.props.onRowHoverExit) {
	        _this.props.onRowHoverExit(rowNumber);
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(TableBody, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.setState({ selectedRows: this.calculatePreselectedRows(this.props) });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.props.allRowsSelected && !nextProps.allRowsSelected) {
	        this.setState({
	          selectedRows: this.state.selectedRows.length > 0 ? [this.state.selectedRows[this.state.selectedRows.length - 1]] : []
	        });
	        // TODO: should else be conditional, not run any time props other than allRowsSelected change?
	      } else {
	        this.setState({
	          selectedRows: this.calculatePreselectedRows(nextProps)
	        });
	      }
	    }
	  }, {
	    key: 'createRows',
	    value: function createRows() {
	      var _this2 = this;
	
	      var numChildren = _react2.default.Children.count(this.props.children);
	      var rowNumber = 0;
	      var handlers = {
	        onCellClick: this.onCellClick,
	        onCellHover: this.onCellHover,
	        onCellHoverExit: this.onCellHoverExit,
	        onRowHover: this.onRowHover,
	        onRowHoverExit: this.onRowHoverExit,
	        onRowClick: this.onRowClick
	      };
	
	      return _react2.default.Children.map(this.props.children, function (child) {
	        if (_react2.default.isValidElement(child)) {
	          var _ret2 = function () {
	            var props = {
	              hoverable: _this2.props.showRowHover,
	              selected: _this2.isRowSelected(rowNumber),
	              striped: _this2.props.stripedRows && rowNumber % 2 === 0,
	              rowNumber: rowNumber++
	            };
	
	            if (rowNumber === numChildren) {
	              props.displayBorder = false;
	            }
	
	            var children = [_this2.createRowCheckboxColumn(props)];
	
	            _react2.default.Children.forEach(child.props.children, function (child) {
	              children.push(child);
	            });
	
	            return {
	              v: _react2.default.cloneElement(child, _extends({}, props, handlers), children)
	            };
	          }();
	
	          if ((typeof _ret2 === 'undefined' ? 'undefined' : _typeof(_ret2)) === "object") return _ret2.v;
	        }
	      });
	    }
	  }, {
	    key: 'createRowCheckboxColumn',
	    value: function createRowCheckboxColumn(rowProps) {
	      if (!this.props.displayRowCheckbox) {
	        return null;
	      }
	
	      var key = rowProps.rowNumber + '-cb';
	      var disabled = !this.props.selectable;
	      var checkbox = _react2.default.createElement(_Checkbox2.default, {
	        ref: 'rowSelectCB',
	        name: key,
	        value: 'selected',
	        disabled: disabled,
	        checked: rowProps.selected
	      });
	
	      return _react2.default.createElement(
	        _TableRowColumn2.default,
	        {
	          key: key,
	          columnNumber: 0,
	          style: {
	            width: 24,
	            cursor: disabled ? 'not-allowed' : 'inherit'
	          }
	        },
	        checkbox
	      );
	    }
	  }, {
	    key: 'calculatePreselectedRows',
	    value: function calculatePreselectedRows(props) {
	      // Determine what rows are 'pre-selected'.
	      var preSelectedRows = [];
	
	      if (props.selectable && props.preScanRows) {
	        (function () {
	          var index = 0;
	          _react2.default.Children.forEach(props.children, function (child) {
	            if (_react2.default.isValidElement(child)) {
	              if (child.props.selected && (preSelectedRows.length === 0 || props.multiSelectable)) {
	                preSelectedRows.push(index);
	              }
	
	              index++;
	            }
	          });
	        })();
	      }
	
	      return preSelectedRows;
	    }
	  }, {
	    key: 'isRowSelected',
	    value: function isRowSelected(rowNumber) {
	      if (this.props.allRowsSelected) {
	        return true;
	      }
	
	      for (var i = 0; i < this.state.selectedRows.length; i++) {
	        var selection = this.state.selectedRows[i];
	
	        if ((typeof selection === 'undefined' ? 'undefined' : _typeof(selection)) === 'object') {
	          if (this.isValueInRange(rowNumber, selection)) return true;
	        } else {
	          if (selection === rowNumber) return true;
	        }
	      }
	
	      return false;
	    }
	  }, {
	    key: 'isValueInRange',
	    value: function isValueInRange(value, range) {
	      if (!range) return false;
	
	      if (range.start <= value && value <= range.end || range.end <= value && value <= range.start) {
	        return true;
	      }
	
	      return false;
	    }
	  }, {
	    key: 'processRowSelection',
	    value: function processRowSelection(event, rowNumber) {
	      var selectedRows = this.state.selectedRows;
	
	      if (event.shiftKey && this.props.multiSelectable && selectedRows.length) {
	        var lastIndex = selectedRows.length - 1;
	        var lastSelection = selectedRows[lastIndex];
	
	        if ((typeof lastSelection === 'undefined' ? 'undefined' : _typeof(lastSelection)) === 'object') {
	          lastSelection.end = rowNumber;
	        } else {
	          selectedRows.splice(lastIndex, 1, { start: lastSelection, end: rowNumber });
	        }
	      } else if ((event.ctrlKey && !event.metaKey || event.metaKey && !event.ctrlKey) && this.props.multiSelectable) {
	        var idx = selectedRows.indexOf(rowNumber);
	        if (idx < 0) {
	          var foundRange = false;
	          for (var i = 0; i < selectedRows.length; i++) {
	            var range = selectedRows[i];
	            if ((typeof range === 'undefined' ? 'undefined' : _typeof(range)) !== 'object') continue;
	
	            if (this.isValueInRange(rowNumber, range)) {
	              var _selectedRows;
	
	              foundRange = true;
	              var values = this.splitRange(range, rowNumber);
	              (_selectedRows = selectedRows).splice.apply(_selectedRows, [i, 1].concat(_toConsumableArray(values)));
	            }
	          }
	
	          if (!foundRange) selectedRows.push(rowNumber);
	        } else {
	          selectedRows.splice(idx, 1);
	        }
	      } else {
	        if (selectedRows.length === 1 && selectedRows[0] === rowNumber) {
	          selectedRows = [];
	        } else {
	          selectedRows = [rowNumber];
	        }
	      }
	
	      this.setState({ selectedRows: selectedRows });
	      if (this.props.onRowSelection) this.props.onRowSelection(this.flattenRanges(selectedRows));
	    }
	  }, {
	    key: 'splitRange',
	    value: function splitRange(range, splitPoint) {
	      var splitValues = [];
	      var startOffset = range.start - splitPoint;
	      var endOffset = range.end - splitPoint;
	
	      // Process start half
	      splitValues.push.apply(splitValues, _toConsumableArray(this.genRangeOfValues(splitPoint, startOffset)));
	
	      // Process end half
	      splitValues.push.apply(splitValues, _toConsumableArray(this.genRangeOfValues(splitPoint, endOffset)));
	
	      return splitValues;
	    }
	  }, {
	    key: 'genRangeOfValues',
	    value: function genRangeOfValues(start, offset) {
	      var values = [];
	      var dir = offset > 0 ? -1 : 1; // This forces offset to approach 0 from either direction.
	      while (offset !== 0) {
	        values.push(start + offset);
	        offset += dir;
	      }
	
	      return values;
	    }
	  }, {
	    key: 'flattenRanges',
	    value: function flattenRanges(selectedRows) {
	      var rows = [];
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = selectedRows[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var selection = _step.value;
	
	          if ((typeof selection === 'undefined' ? 'undefined' : _typeof(selection)) === 'object') {
	            var values = this.genRangeOfValues(selection.end, selection.start - selection.end);
	            rows.push.apply(rows, [selection.end].concat(_toConsumableArray(values)));
	          } else {
	            rows.push(selection);
	          }
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	
	      return rows.sort();
	    }
	  }, {
	    key: 'getColumnId',
	    value: function getColumnId(columnNumber) {
	      var columnId = columnNumber;
	      if (this.props.displayRowCheckbox) {
	        columnId--;
	      }
	
	      return columnId;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var className = _props.className;
	      var style = _props.style;
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	
	      return _react2.default.createElement(
	        _ClickAwayListener2.default,
	        { onClickAway: this.handleClickAway },
	        _react2.default.createElement(
	          'tbody',
	          { className: className, style: prepareStyles((0, _simpleAssign2.default)({}, style)) },
	          this.createRows()
	        )
	      );
	    }
	  }]);
	
	  return TableBody;
	}(_react.Component);
	
	TableBody.muiName = 'TableBody';
	TableBody.propTypes = {
	  /**
	   * @ignore
	   * Set to true to indicate that all rows should be selected.
	   */
	  allRowsSelected: _react.PropTypes.bool,
	  /**
	   * Children passed to table body.
	   */
	  children: _react.PropTypes.node,
	  /**
	   * The css class name of the root element.
	   */
	  className: _react.PropTypes.string,
	  /**
	   * Controls whether or not to deselect all selected
	   * rows after clicking outside the table.
	   */
	  deselectOnClickaway: _react.PropTypes.bool,
	  /**
	   * Controls the display of the row checkbox. The default value is true.
	   */
	  displayRowCheckbox: _react.PropTypes.bool,
	  /**
	   * @ignore
	   * If true, multiple table rows can be selected.
	   * CTRL/CMD+Click and SHIFT+Click are valid actions.
	   * The default value is false.
	   */
	  multiSelectable: _react.PropTypes.bool,
	  /**
	   * @ignore
	   * Callback function for when a cell is clicked.
	   */
	  onCellClick: _react.PropTypes.func,
	  /**
	   * @ignore
	   * Called when a table cell is hovered. rowNumber
	   * is the row number of the hovered row and columnId
	   * is the column number or the column key of the cell.
	   */
	  onCellHover: _react.PropTypes.func,
	  /**
	   * @ignore
	   * Called when a table cell is no longer hovered.
	   * rowNumber is the row number of the row and columnId
	   * is the column number or the column key of the cell.
	   */
	  onCellHoverExit: _react.PropTypes.func,
	  /**
	   * @ignore
	   * Called when a table row is hovered.
	   * rowNumber is the row number of the hovered row.
	   */
	  onRowHover: _react.PropTypes.func,
	  /**
	   * @ignore
	   * Called when a table row is no longer
	   * hovered. rowNumber is the row number of the row
	   * that is no longer hovered.
	   */
	  onRowHoverExit: _react.PropTypes.func,
	  /**
	   * @ignore
	   * Called when a row is selected. selectedRows is an
	   * array of all row selections. IF all rows have been selected,
	   * the string "all" will be returned instead to indicate that
	   * all rows have been selected.
	   */
	  onRowSelection: _react.PropTypes.func,
	  /**
	   * Controls whether or not the rows are pre-scanned to determine
	   * initial state. If your table has a large number of rows and
	   * you are experiencing a delay in rendering, turn off this property.
	   */
	  preScanRows: _react.PropTypes.bool,
	  /**
	   * @ignore
	   * If true, table rows can be selected. If multiple
	   * row selection is desired, enable multiSelectable.
	   * The default value is true.
	   */
	  selectable: _react.PropTypes.bool,
	  /**
	   * If true, table rows will be highlighted when
	   * the cursor is hovering over the row. The default
	   * value is false.
	   */
	  showRowHover: _react.PropTypes.bool,
	  /**
	   * If true, every other table row starting
	   * with the first row will be striped. The default value is false.
	   */
	  stripedRows: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object
	};
	TableBody.defaultProps = {
	  allRowsSelected: false,
	  deselectOnClickaway: true,
	  displayRowCheckbox: true,
	  multiSelectable: false,
	  preScanRows: true,
	  selectable: true,
	  style: {}
	};
	TableBody.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	exports.default = TableBody;

/***/ }),
/* 895 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _simpleAssign = __webpack_require__(579);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function getStyles(props, context) {
	  var tableRowColumn = context.muiTheme.tableRowColumn;
	
	
	  var styles = {
	    root: {
	      paddingLeft: tableRowColumn.spacing,
	      paddingRight: tableRowColumn.spacing,
	      height: tableRowColumn.height,
	      textAlign: 'left',
	      fontSize: 13,
	      overflow: 'hidden',
	      whiteSpace: 'nowrap',
	      textOverflow: 'ellipsis'
	    }
	  };
	
	  if (_react2.default.Children.count(props.children) === 1 && !isNaN(props.children)) {
	    styles.textAlign = 'right';
	  }
	
	  return styles;
	}
	
	var TableRowColumn = function (_Component) {
	  _inherits(TableRowColumn, _Component);
	
	  function TableRowColumn() {
	    var _Object$getPrototypeO;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, TableRowColumn);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_Object$getPrototypeO = Object.getPrototypeOf(TableRowColumn)).call.apply(_Object$getPrototypeO, [this].concat(args))), _this), _this.state = {
	      hovered: false
	    }, _this.onClick = function (event) {
	      if (_this.props.onClick) {
	        _this.props.onClick(event, _this.props.columnNumber);
	      }
	    }, _this.onMouseEnter = function (event) {
	      if (_this.props.hoverable) {
	        _this.setState({ hovered: true });
	        if (_this.props.onHover) {
	          _this.props.onHover(event, _this.props.columnNumber);
	        }
	      }
	    }, _this.onMouseLeave = function (event) {
	      if (_this.props.hoverable) {
	        _this.setState({ hovered: false });
	        if (_this.props.onHoverExit) {
	          _this.props.onHoverExit(event, _this.props.columnNumber);
	        }
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(TableRowColumn, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var children = _props.children;
	      var className = _props.className;
	      var columnNumber = _props.columnNumber;
	      var hoverable = _props.hoverable;
	      var onClick = _props.onClick;
	      var onHover = _props.onHover;
	      var onHoverExit = _props.onHoverExit;
	      var style = _props.style;
	
	      var other = _objectWithoutProperties(_props, ['children', 'className', 'columnNumber', 'hoverable', 'onClick', 'onHover', 'onHoverExit', 'style']);
	
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      var handlers = {
	        onClick: this.onClick,
	        onMouseEnter: this.onMouseEnter,
	        onMouseLeave: this.onMouseLeave
	      };
	
	      return _react2.default.createElement(
	        'td',
	        _extends({
	          className: className,
	          style: prepareStyles((0, _simpleAssign2.default)(styles.root, style))
	        }, handlers, other),
	        children
	      );
	    }
	  }]);
	
	  return TableRowColumn;
	}(_react.Component);
	
	TableRowColumn.propTypes = {
	  children: _react.PropTypes.node,
	  /**
	   * The css class name of the root element.
	   */
	  className: _react.PropTypes.string,
	  /**
	   * @ignore
	   * Number to identify the header row. This property
	   * is automatically populated when used with TableHeader.
	   */
	  columnNumber: _react.PropTypes.number,
	  /**
	   * @ignore
	   * If true, this column responds to hover events.
	   */
	  hoverable: _react.PropTypes.bool,
	  /** @ignore */
	  onClick: _react.PropTypes.func,
	  /** @ignore */
	  onHover: _react.PropTypes.func,
	  /**
	   * @ignore
	   * Callback function for hover exit event.
	   */
	  onHoverExit: _react.PropTypes.func,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object
	};
	TableRowColumn.defaultProps = {
	  hoverable: false
	};
	TableRowColumn.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	exports.default = TableRowColumn;

/***/ }),
/* 896 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _simpleAssign = __webpack_require__(579);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _TableRowColumn = __webpack_require__(895);
	
	var _TableRowColumn2 = _interopRequireDefault(_TableRowColumn);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function getStyles(props, context) {
	  var tableFooter = context.muiTheme.tableFooter;
	
	
	  return {
	    cell: {
	      borderTop: '1px solid ' + tableFooter.borderColor,
	      verticalAlign: 'bottom',
	      padding: 20,
	      textAlign: 'left',
	      whiteSpace: 'nowrap'
	    }
	  };
	}
	
	var TableFooter = function (_Component) {
	  _inherits(TableFooter, _Component);
	
	  function TableFooter() {
	    _classCallCheck(this, TableFooter);
	
	    return _possibleConstructorReturn(this, Object.getPrototypeOf(TableFooter).apply(this, arguments));
	  }
	
	  _createClass(TableFooter, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var adjustForCheckbox = _props.adjustForCheckbox;
	      var children = _props.children;
	      var className = _props.className;
	      var style = _props.style;
	
	      var other = _objectWithoutProperties(_props, ['adjustForCheckbox', 'children', 'className', 'style']);
	
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      var footerRows = _react2.default.Children.map(children, function (child, rowNumber) {
	        var newChildProps = {
	          displayBorder: false,
	          key: 'f-' + rowNumber,
	          rowNumber: rowNumber,
	          style: (0, _simpleAssign2.default)({}, styles.cell, child.props.style)
	        };
	
	        var newDescendants = void 0;
	        if (adjustForCheckbox) {
	          newDescendants = [_react2.default.createElement(_TableRowColumn2.default, { key: 'fpcb' + rowNumber, style: { width: 24 } })].concat(_toConsumableArray(_react2.default.Children.toArray(child.props.children)));
	        }
	
	        return _react2.default.cloneElement(child, newChildProps, newDescendants);
	      });
	
	      return _react2.default.createElement(
	        'tfoot',
	        _extends({ className: className, style: prepareStyles((0, _simpleAssign2.default)({}, style)) }, other),
	        footerRows
	      );
	    }
	  }]);
	
	  return TableFooter;
	}(_react.Component);
	
	TableFooter.muiName = 'TableFooter';
	TableFooter.propTypes = {
	  /**
	   * @ignore
	   * Controls whether or not header rows should be adjusted
	   * for a checkbox column. If the select all checkbox is true,
	   * this property will not influence the number of columns.
	   * This is mainly useful for "super header" rows so that
	   * the checkbox column does not create an offset that needs
	   * to be accounted for manually.
	   */
	  adjustForCheckbox: _react.PropTypes.bool,
	  /**
	   * Children passed to table footer.
	   */
	  children: _react.PropTypes.node,
	  /**
	   * The css class name of the root element.
	   */
	  className: _react.PropTypes.string,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object
	};
	TableFooter.defaultProps = {
	  adjustForCheckbox: true,
	  style: {}
	};
	TableFooter.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	exports.default = TableFooter;

/***/ }),
/* 897 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _simpleAssign = __webpack_require__(579);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Checkbox = __webpack_require__(678);
	
	var _Checkbox2 = _interopRequireDefault(_Checkbox);
	
	var _TableHeaderColumn = __webpack_require__(898);
	
	var _TableHeaderColumn2 = _interopRequireDefault(_TableHeaderColumn);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function getStyles(props, context) {
	  var tableHeader = context.muiTheme.tableHeader;
	
	
	  return {
	    root: {
	      borderBottom: '1px solid ' + tableHeader.borderColor
	    }
	  };
	}
	
	var TableHeader = function (_Component) {
	  _inherits(TableHeader, _Component);
	
	  function TableHeader() {
	    var _Object$getPrototypeO;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, TableHeader);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_Object$getPrototypeO = Object.getPrototypeOf(TableHeader)).call.apply(_Object$getPrototypeO, [this].concat(args))), _this), _this.handleCheckAll = function (event, checked) {
	      if (_this.props.onSelectAll) _this.props.onSelectAll(checked);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(TableHeader, [{
	    key: 'createSuperHeaderRows',
	    value: function createSuperHeaderRows() {
	      var numChildren = _react2.default.Children.count(this.props.children);
	      if (numChildren === 1) return undefined;
	
	      var superHeaders = [];
	      for (var index = 0; index < numChildren - 1; index++) {
	        var child = this.props.children[index];
	
	        if (!_react2.default.isValidElement(child)) continue;
	
	        var props = {
	          key: 'sh' + index,
	          rowNumber: index
	        };
	        superHeaders.push(this.createSuperHeaderRow(child, props));
	      }
	
	      if (superHeaders.length) return superHeaders;
	    }
	  }, {
	    key: 'createSuperHeaderRow',
	    value: function createSuperHeaderRow(child, props) {
	      var children = [];
	      if (this.props.adjustForCheckbox) {
	        children.push(this.getCheckboxPlaceholder(props));
	      }
	      _react2.default.Children.forEach(child.props.children, function (child) {
	        children.push(child);
	      });
	
	      return _react2.default.cloneElement(child, props, children);
	    }
	  }, {
	    key: 'createBaseHeaderRow',
	    value: function createBaseHeaderRow() {
	      var numChildren = _react2.default.Children.count(this.props.children);
	      var child = numChildren === 1 ? this.props.children : this.props.children[numChildren - 1];
	      var props = {
	        key: 'h' + numChildren,
	        rowNumber: numChildren
	      };
	
	      var children = [this.getSelectAllCheckboxColumn(props)];
	      _react2.default.Children.forEach(child.props.children, function (child) {
	        children.push(child);
	      });
	
	      return _react2.default.cloneElement(child, props, children);
	    }
	  }, {
	    key: 'getCheckboxPlaceholder',
	    value: function getCheckboxPlaceholder(props) {
	      if (!this.props.adjustForCheckbox) return null;
	
	      var disabled = !this.props.enableSelectAll;
	      var key = 'hpcb' + props.rowNumber;
	      return _react2.default.createElement(_TableHeaderColumn2.default, {
	        key: key,
	        style: {
	          width: 24,
	          cursor: disabled ? 'not-allowed' : 'inherit'
	        }
	      });
	    }
	  }, {
	    key: 'getSelectAllCheckboxColumn',
	    value: function getSelectAllCheckboxColumn(props) {
	      if (!this.props.displaySelectAll) return this.getCheckboxPlaceholder(props);
	
	      var disabled = !this.props.enableSelectAll;
	      var checkbox = _react2.default.createElement(_Checkbox2.default, {
	        key: 'selectallcb',
	        name: 'selectallcb',
	        value: 'selected',
	        disabled: disabled,
	        checked: this.props.selectAllSelected,
	        onCheck: this.handleCheckAll
	      });
	
	      var key = 'hpcb' + props.rowNumber;
	      return _react2.default.createElement(
	        _TableHeaderColumn2.default,
	        {
	          key: key,
	          style: {
	            width: 24,
	            cursor: disabled ? 'not-allowed' : 'inherit'
	          }
	        },
	        checkbox
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var className = _props.className;
	      var style = _props.style;
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	      var superHeaderRows = this.createSuperHeaderRows();
	      var baseHeaderRow = this.createBaseHeaderRow();
	
	      return _react2.default.createElement(
	        'thead',
	        { className: className, style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) },
	        superHeaderRows,
	        baseHeaderRow
	      );
	    }
	  }]);
	
	  return TableHeader;
	}(_react.Component);
	
	TableHeader.muiName = 'TableHeader';
	TableHeader.propTypes = {
	  /**
	   * Controls whether or not header rows should be
	   * adjusted for a checkbox column. If the select all
	   * checkbox is true, this property will not influence
	   * the number of columns. This is mainly useful for
	   * "super header" rows so that the checkbox column
	   * does not create an offset that needs to be accounted
	   * for manually.
	   */
	  adjustForCheckbox: _react.PropTypes.bool,
	  /**
	   * Children passed to table header.
	   */
	  children: _react.PropTypes.node,
	  /**
	   * The css class name of the root element.
	   */
	  className: _react.PropTypes.string,
	  /**
	   * Controls whether or not the select all checkbox is displayed.
	   */
	  displaySelectAll: _react.PropTypes.bool,
	  /**
	   * If set to true, the select all button will be interactable.
	   * If set to false, the button will not be interactable.
	   * To hide the checkbox, set displaySelectAll to false.
	   */
	  enableSelectAll: _react.PropTypes.bool,
	  /**
	   * @ignore
	   * Callback when select all has been checked.
	   */
	  onSelectAll: _react.PropTypes.func,
	  /**
	   * @ignore
	   * True when select all has been checked.
	   */
	  selectAllSelected: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object
	};
	TableHeader.defaultProps = {
	  adjustForCheckbox: true,
	  displaySelectAll: true,
	  enableSelectAll: true,
	  selectAllSelected: false
	};
	TableHeader.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	exports.default = TableHeader;

/***/ }),
/* 898 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _simpleAssign = __webpack_require__(579);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Tooltip = __webpack_require__(606);
	
	var _Tooltip2 = _interopRequireDefault(_Tooltip);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function getStyles(props, context) {
	  var tableHeaderColumn = context.muiTheme.tableHeaderColumn;
	
	
	  return {
	    root: {
	      fontWeight: 'normal',
	      fontSize: 12,
	      paddingLeft: tableHeaderColumn.spacing,
	      paddingRight: tableHeaderColumn.spacing,
	      height: tableHeaderColumn.height,
	      textAlign: 'left',
	      whiteSpace: 'nowrap',
	      textOverflow: 'ellipsis',
	      color: tableHeaderColumn.textColor,
	      position: 'relative'
	    },
	    tooltip: {
	      boxSizing: 'border-box',
	      marginTop: tableHeaderColumn.height / 2
	    }
	  };
	}
	
	var TableHeaderColumn = function (_Component) {
	  _inherits(TableHeaderColumn, _Component);
	
	  function TableHeaderColumn() {
	    var _Object$getPrototypeO;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, TableHeaderColumn);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_Object$getPrototypeO = Object.getPrototypeOf(TableHeaderColumn)).call.apply(_Object$getPrototypeO, [this].concat(args))), _this), _this.state = {
	      hovered: false
	    }, _this.onMouseEnter = function () {
	      if (_this.props.tooltip !== undefined) {
	        _this.setState({ hovered: true });
	      }
	    }, _this.onMouseLeave = function () {
	      if (_this.props.tooltip !== undefined) {
	        _this.setState({ hovered: false });
	      }
	    }, _this.onClick = function (event) {
	      if (_this.props.onClick) {
	        _this.props.onClick(event, _this.props.columnNumber);
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(TableHeaderColumn, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var children = _props.children;
	      var className = _props.className;
	      var columnNumber = _props.columnNumber;
	      var hoverable = _props.hoverable;
	      var onClick = _props.onClick;
	      var onHover = _props.onHover;
	      var onHoverExit = _props.onHoverExit;
	      var style = _props.style;
	      var tooltip = _props.tooltip;
	      var tooltipStyle = _props.tooltipStyle;
	
	      var other = _objectWithoutProperties(_props, ['children', 'className', 'columnNumber', 'hoverable', 'onClick', 'onHover', 'onHoverExit', 'style', 'tooltip', 'tooltipStyle']);
	
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      var handlers = {
	        onMouseEnter: this.onMouseEnter,
	        onMouseLeave: this.onMouseLeave,
	        onClick: this.onClick
	      };
	
	      var tooltipNode = void 0;
	
	      if (tooltip !== undefined) {
	        tooltipNode = _react2.default.createElement(_Tooltip2.default, {
	          label: tooltip,
	          show: this.state.hovered,
	          style: (0, _simpleAssign2.default)(styles.tooltip, tooltipStyle)
	        });
	      }
	
	      return _react2.default.createElement(
	        'th',
	        _extends({
	          className: className,
	          style: prepareStyles((0, _simpleAssign2.default)(styles.root, style))
	        }, handlers, other),
	        tooltipNode,
	        children
	      );
	    }
	  }]);
	
	  return TableHeaderColumn;
	}(_react.Component);
	
	TableHeaderColumn.propTypes = {
	  children: _react.PropTypes.node,
	  /**
	   * The css class name of the root element.
	   */
	  className: _react.PropTypes.string,
	  /**
	   * Number to identify the header row. This property
	   * is automatically populated when used with TableHeader.
	   */
	  columnNumber: _react.PropTypes.number,
	  /**
	   * @ignore
	   * Not used here but we need to remove it from the root element.
	   */
	  hoverable: _react.PropTypes.bool,
	  /** @ignore */
	  onClick: _react.PropTypes.func,
	  /**
	   * @ignore
	   * Not used here but we need to remove it from the root element.
	   */
	  onHover: _react.PropTypes.func,
	  /**
	   * @ignore
	   * Not used here but we need to remove it from the root element.
	   */
	  onHoverExit: _react.PropTypes.func,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object,
	  /**
	   * The string to supply to the tooltip. If not
	   * string is supplied no tooltip will be shown.
	   */
	  tooltip: _react.PropTypes.string,
	  /**
	   * Additional styling that can be applied to the tooltip.
	   */
	  tooltipStyle: _react.PropTypes.object
	};
	TableHeaderColumn.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	exports.default = TableHeaderColumn;

/***/ }),
/* 899 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _simpleAssign = __webpack_require__(579);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function getStyles(props, context, state) {
	  var tableRow = context.muiTheme.tableRow;
	
	
	  var cellBgColor = 'inherit';
	  if (props.hovered || state.hovered) {
	    cellBgColor = tableRow.hoverColor;
	  } else if (props.selected) {
	    cellBgColor = tableRow.selectedColor;
	  } else if (props.striped) {
	    cellBgColor = tableRow.stripeColor;
	  }
	
	  return {
	    root: {
	      borderBottom: props.displayBorder && '1px solid ' + tableRow.borderColor,
	      color: tableRow.textColor,
	      height: tableRow.height
	    },
	    cell: {
	      backgroundColor: cellBgColor
	    }
	  };
	}
	
	var TableRow = function (_Component) {
	  _inherits(TableRow, _Component);
	
	  function TableRow() {
	    var _Object$getPrototypeO;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, TableRow);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_Object$getPrototypeO = Object.getPrototypeOf(TableRow)).call.apply(_Object$getPrototypeO, [this].concat(args))), _this), _this.state = {
	      hovered: false
	    }, _this.onCellClick = function (event, columnIndex) {
	      if (_this.props.selectable && _this.props.onCellClick) {
	        _this.props.onCellClick(event, _this.props.rowNumber, columnIndex);
	      }
	      event.ctrlKey = true;
	      _this.onRowClick(event);
	    }, _this.onCellHover = function (event, columnIndex) {
	      if (_this.props.hoverable) {
	        _this.setState({ hovered: true });
	        if (_this.props.onCellHover) _this.props.onCellHover(event, _this.props.rowNumber, columnIndex);
	        _this.onRowHover(event);
	      }
	    }, _this.onCellHoverExit = function (event, columnIndex) {
	      if (_this.props.hoverable) {
	        _this.setState({ hovered: false });
	        if (_this.props.onCellHoverExit) _this.props.onCellHoverExit(event, _this.props.rowNumber, columnIndex);
	        _this.onRowHoverExit(event);
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(TableRow, [{
	    key: 'onRowClick',
	    value: function onRowClick(event) {
	      if (this.props.selectable && this.props.onRowClick) this.props.onRowClick(event, this.props.rowNumber);
	    }
	  }, {
	    key: 'onRowHover',
	    value: function onRowHover(event) {
	      if (this.props.onRowHover) this.props.onRowHover(event, this.props.rowNumber);
	    }
	  }, {
	    key: 'onRowHoverExit',
	    value: function onRowHoverExit(event) {
	      if (this.props.onRowHoverExit) this.props.onRowHoverExit(event, this.props.rowNumber);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props;
	      var className = _props.className;
	      var displayBorder = _props.displayBorder;
	      var hoverable = _props.hoverable;
	      var hovered = _props.hovered;
	      var onCellClick = _props.onCellClick;
	      var onCellHover = _props.onCellHover;
	      var onCellHoverExit = _props.onCellHoverExit;
	      var onRowClick = _props.onRowClick;
	      var onRowHover = _props.onRowHover;
	      var onRowHoverExit = _props.onRowHoverExit;
	      var rowNumber = _props.rowNumber;
	      var selectable = _props.selectable;
	      var selected = _props.selected;
	      var striped = _props.striped;
	      var style = _props.style;
	
	      var other = _objectWithoutProperties(_props, ['className', 'displayBorder', 'hoverable', 'hovered', 'onCellClick', 'onCellHover', 'onCellHoverExit', 'onRowClick', 'onRowHover', 'onRowHoverExit', 'rowNumber', 'selectable', 'selected', 'striped', 'style']);
	
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context, this.state);
	
	      var rowColumns = _react2.default.Children.map(this.props.children, function (child, columnNumber) {
	        if (_react2.default.isValidElement(child)) {
	          return _react2.default.cloneElement(child, {
	            columnNumber: columnNumber,
	            hoverable: _this2.props.hoverable,
	            key: _this2.props.rowNumber + '-' + columnNumber,
	            onClick: _this2.onCellClick,
	            onHover: _this2.onCellHover,
	            onHoverExit: _this2.onCellHoverExit,
	            style: (0, _simpleAssign2.default)({}, styles.cell, child.props.style)
	          });
	        }
	      });
	
	      return _react2.default.createElement(
	        'tr',
	        _extends({
	          className: className,
	          style: prepareStyles((0, _simpleAssign2.default)(styles.root, style))
	        }, other),
	        rowColumns
	      );
	    }
	  }]);
	
	  return TableRow;
	}(_react.Component);
	
	TableRow.propTypes = {
	  /**
	   * Children passed to table row.
	   */
	  children: _react.PropTypes.node,
	  /**
	   * The css class name of the root element.
	   */
	  className: _react.PropTypes.string,
	  /**
	   * If true, row border will be displayed for the row.
	   * If false, no border will be drawn.
	   */
	  displayBorder: _react.PropTypes.bool,
	  /**
	   * Controls whether or not the row reponseds to hover events.
	   */
	  hoverable: _react.PropTypes.bool,
	  /**
	   * Controls whether or not the row should be rendered as being
	   * hovered. This property is evaluated in addition to this.state.hovered
	   * and can be used to synchronize the hovered state with some other
	   * external events.
	   */
	  hovered: _react.PropTypes.bool,
	  /**
	   * @ignore
	   * Called when a row cell is clicked.
	   * rowNumber is the row number and columnId is
	   * the column number or the column key.
	   */
	  onCellClick: _react.PropTypes.func,
	  /**
	   * @ignore
	   * Called when a table cell is hovered.
	   * rowNumber is the row number of the hovered row
	   * and columnId is the column number or the column key of the cell.
	   */
	  onCellHover: _react.PropTypes.func,
	  /**
	   * @ignore
	   * Called when a table cell is no longer hovered.
	   * rowNumber is the row number of the row and columnId
	   * is the column number or the column key of the cell.
	   */
	  onCellHoverExit: _react.PropTypes.func,
	  /**
	   * @ignore
	   * Called when row is clicked.
	   */
	  onRowClick: _react.PropTypes.func,
	  /**
	   * @ignore
	   * Called when a table row is hovered.
	   * rowNumber is the row number of the hovered row.
	   */
	  onRowHover: _react.PropTypes.func,
	  /**
	   * @ignore
	   * Called when a table row is no longer hovered.
	   * rowNumber is the row number of the row that is no longer hovered.
	   */
	  onRowHoverExit: _react.PropTypes.func,
	  /**
	   * Number to identify the row. This property is
	   * automatically populated when used with the TableBody component.
	   */
	  rowNumber: _react.PropTypes.number,
	  /**
	   * If true, table rows can be selected. If multiple row
	   * selection is desired, enable multiSelectable.
	   * The default value is true.
	   */
	  selectable: _react.PropTypes.bool,
	  /**
	   * Indicates that a particular row is selected.
	   * This property can be used to programmatically select rows.
	   */
	  selected: _react.PropTypes.bool,
	  /**
	   * Indicates whether or not the row is striped.
	   */
	  striped: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object
	};
	TableRow.defaultProps = {
	  displayBorder: true,
	  hoverable: false,
	  hovered: false,
	  selectable: true,
	  selected: false,
	  striped: false
	};
	TableRow.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	exports.default = TableRow;

/***/ }),
/* 900 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _TimePicker = __webpack_require__(901);
	
	var _TimePicker2 = _interopRequireDefault(_TimePicker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _TimePicker2.default;

/***/ }),
/* 901 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _simpleAssign = __webpack_require__(579);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _warning = __webpack_require__(491);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _TimePickerDialog = __webpack_require__(902);
	
	var _TimePickerDialog2 = _interopRequireDefault(_TimePickerDialog);
	
	var _TextField = __webpack_require__(621);
	
	var _TextField2 = _interopRequireDefault(_TextField);
	
	var _timeUtils = __webpack_require__(907);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var emptyTime = new Date();
	emptyTime.setHours(0);
	emptyTime.setMinutes(0);
	emptyTime.setSeconds(0);
	emptyTime.setMilliseconds(0);
	
	var TimePicker = function (_Component) {
	  _inherits(TimePicker, _Component);
	
	  function TimePicker() {
	    var _Object$getPrototypeO;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, TimePicker);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_Object$getPrototypeO = Object.getPrototypeOf(TimePicker)).call.apply(_Object$getPrototypeO, [this].concat(args))), _this), _this.state = {
	      time: null,
	      dialogTime: new Date()
	    }, _this.handleAcceptDialog = function (time) {
	      _this.setState({
	        time: time
	      });
	      if (_this.props.onChange) _this.props.onChange(null, time);
	    }, _this.handleFocusInput = function (event) {
	      event.target.blur();
	      if (_this.props.onFocus) {
	        _this.props.onFocus(event);
	      }
	    }, _this.handleTouchTapInput = function (event) {
	      event.preventDefault();
	
	      if (!_this.props.disabled) {
	        _this.openDialog();
	      }
	
	      if (_this.props.onTouchTap) {
	        _this.props.onTouchTap(event);
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(TimePicker, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.setState({
	        time: this.isControlled() ? this.getControlledTime() : this.props.defaultTime
	      });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.value !== this.props.value) {
	        this.setState({
	          time: this.getControlledTime(nextProps)
	        });
	      }
	    }
	
	    /**
	     * Deprecated.
	     * returns timepicker value.
	     **/
	
	  }, {
	    key: 'getTime',
	    value: function getTime() {
	       false ? (0, _warning2.default)(false, 'getTime() method is deprecated. Use the defaultTime property\n    instead. Or use the TimePicker as a controlled component with the value\n    property. It will be removed with v0.16.0.') : void 0;
	      return this.state.time;
	    }
	
	    /**
	     * Deprecated
	     * sets timepicker value.
	     **/
	
	  }, {
	    key: 'setTime',
	    value: function setTime(time) {
	       false ? (0, _warning2.default)(false, 'setTime() method is deprecated. Use the defaultTime property\n    instead. Or use the TimePicker as a controlled component with the value\n    property. It will be removed with v0.16.0.') : void 0;
	      this.setState({ time: time ? time : emptyTime });
	    }
	
	    /**
	     * Alias for `openDialog()` for an api consistent with TextField.
	     */
	
	  }, {
	    key: 'focus',
	    value: function focus() {
	      this.openDialog();
	    }
	  }, {
	    key: 'openDialog',
	    value: function openDialog() {
	      this.setState({
	        dialogTime: this.state.time
	      });
	      this.refs.dialogWindow.show();
	    }
	  }, {
	    key: 'isControlled',
	    value: function isControlled() {
	      return this.props.value !== null;
	    }
	  }, {
	    key: 'getControlledTime',
	    value: function getControlledTime() {
	      var props = arguments.length <= 0 || arguments[0] === undefined ? this.props : arguments[0];
	
	      var result = null;
	      if (props.value instanceof Date) {
	        result = props.value;
	      }
	      return result;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var autoOk = _props.autoOk;
	      var cancelLabel = _props.cancelLabel;
	      var defaultTime = _props.defaultTime;
	      var dialogBodyStyle = _props.dialogBodyStyle;
	      var dialogStyle = _props.dialogStyle;
	      var format = _props.format;
	      var okLabel = _props.okLabel;
	      var onFocus = _props.onFocus;
	      var onTouchTap = _props.onTouchTap;
	      var onShow = _props.onShow;
	      var onDismiss = _props.onDismiss;
	      var pedantic = _props.pedantic;
	      var style = _props.style;
	      var textFieldStyle = _props.textFieldStyle;
	
	      var other = _objectWithoutProperties(_props, ['autoOk', 'cancelLabel', 'defaultTime', 'dialogBodyStyle', 'dialogStyle', 'format', 'okLabel', 'onFocus', 'onTouchTap', 'onShow', 'onDismiss', 'pedantic', 'style', 'textFieldStyle']);
	
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	      var time = this.state.time;
	
	
	      return _react2.default.createElement(
	        'div',
	        { style: prepareStyles((0, _simpleAssign2.default)({}, style)) },
	        _react2.default.createElement(_TextField2.default, _extends({}, other, {
	          style: textFieldStyle,
	          ref: 'input',
	          value: time === emptyTime ? null : (0, _timeUtils.formatTime)(time, format, pedantic),
	          onFocus: this.handleFocusInput,
	          onTouchTap: this.handleTouchTapInput
	        })),
	        _react2.default.createElement(_TimePickerDialog2.default, {
	          ref: 'dialogWindow',
	          bodyStyle: dialogBodyStyle,
	          initialTime: this.state.dialogTime,
	          onAccept: this.handleAcceptDialog,
	          onShow: onShow,
	          onDismiss: onDismiss,
	          format: format,
	          okLabel: okLabel,
	          cancelLabel: cancelLabel,
	          autoOk: autoOk,
	          style: dialogStyle
	        })
	      );
	    }
	  }]);
	
	  return TimePicker;
	}(_react.Component);
	
	TimePicker.propTypes = {
	  /**
	   * If true, automatically accept and close the picker on set minutes.
	   */
	  autoOk: _react.PropTypes.bool,
	  /**
	   * Override the label of the 'Cancel' button.
	   */
	  cancelLabel: _react.PropTypes.node,
	  /**
	   * The initial time value of the TimePicker.
	   */
	  defaultTime: _react.PropTypes.object,
	  /**
	   * Override the inline-styles of TimePickerDialog's body element.
	   */
	  dialogBodyStyle: _react.PropTypes.object,
	  /**
	   * Override the inline-styles of TimePickerDialog's root element.
	   */
	  dialogStyle: _react.PropTypes.object,
	  /**
	   * If true, the TimePicker is disabled.
	   */
	  disabled: _react.PropTypes.bool,
	  /**
	   * Tells the component to display the picker in `ampm` (12hr) format or `24hr` format.
	   */
	  format: _react.PropTypes.oneOf(['ampm', '24hr']),
	  /**
	   * Override the label of the 'OK' button.
	   */
	  okLabel: _react.PropTypes.node,
	  /**
	   * Callback function that is fired when the time value changes. The time value is passed in a Date Object.
	   * Since there is no particular event associated with the change the first argument will always be null
	   * and the second argument will be the new Date instance.
	   */
	  onChange: _react.PropTypes.func,
	  /**
	   * Callback function fired when the TimePicker dialog is dismissed.
	   */
	  onDismiss: _react.PropTypes.func,
	  /**
	   * Callback function fired when the TimePicker `TextField` gains focus.
	   */
	  onFocus: _react.PropTypes.func,
	  /**
	   * Callback function fired when the TimePicker dialog is shown.
	   */
	  onShow: _react.PropTypes.func,
	  /**
	   * Callback function fired when the TimePicker is tapped or clicked.
	   */
	  onTouchTap: _react.PropTypes.func,
	  /**
	   * If true, uses ("noon" / "midnight") instead of ("12 a.m." / "12 p.m.").
	   *
	   * It's technically more correct to refer to "12 noon" and "12 midnight" rather than "12 a.m." and "12 p.m."
	   * and it avoids confusion between different locales. By default (for compatibility reasons) TimePicker uses
	   * ("12 a.m." / "12 p.m.").
	   */
	  pedantic: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object,
	  /**
	   * Override the inline-styles of TimePicker's TextField element.
	   */
	  textFieldStyle: _react.PropTypes.object,
	  /**
	   * Sets the time for the Time Picker programmatically.
	   */
	  value: _react.PropTypes.object
	};
	TimePicker.defaultProps = {
	  autoOk: false,
	  cancelLabel: 'Cancel',
	  defaultTime: null,
	  disabled: false,
	  format: 'ampm',
	  okLabel: 'OK',
	  pedantic: false,
	  style: {},
	  value: null
	};
	TimePicker.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	exports.default = TimePicker;

/***/ }),
/* 902 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _simpleAssign = __webpack_require__(579);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactEventListener = __webpack_require__(625);
	
	var _reactEventListener2 = _interopRequireDefault(_reactEventListener);
	
	var _keycode = __webpack_require__(589);
	
	var _keycode2 = _interopRequireDefault(_keycode);
	
	var _Clock = __webpack_require__(903);
	
	var _Clock2 = _interopRequireDefault(_Clock);
	
	var _Dialog = __webpack_require__(707);
	
	var _Dialog2 = _interopRequireDefault(_Dialog);
	
	var _FlatButton = __webpack_require__(694);
	
	var _FlatButton2 = _interopRequireDefault(_FlatButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TimePickerDialog = function (_Component) {
	  _inherits(TimePickerDialog, _Component);
	
	  function TimePickerDialog() {
	    var _Object$getPrototypeO;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, TimePickerDialog);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_Object$getPrototypeO = Object.getPrototypeOf(TimePickerDialog)).call.apply(_Object$getPrototypeO, [this].concat(args))), _this), _this.state = {
	      open: false
	    }, _this.handleRequestClose = function () {
	      _this.dismiss();
	    }, _this.handleTouchTapCancel = function () {
	      _this.dismiss();
	    }, _this.handleTouchTapOK = function () {
	      _this.dismiss();
	      if (_this.props.onAccept) {
	        _this.props.onAccept(_this.refs.clock.getSelectedTime());
	      }
	    }, _this.handleKeyUp = function (event) {
	      switch ((0, _keycode2.default)(event)) {
	        case 'enter':
	          _this.handleTouchTapOK();
	          break;
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(TimePickerDialog, [{
	    key: 'show',
	    value: function show() {
	      if (this.props.onShow && !this.state.open) this.props.onShow();
	      this.setState({
	        open: true
	      });
	    }
	  }, {
	    key: 'dismiss',
	    value: function dismiss() {
	      if (this.props.onDismiss && this.state.open) this.props.onDismiss();
	      this.setState({
	        open: false
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var bodyStyle = _props.bodyStyle;
	      var initialTime = _props.initialTime;
	      var onAccept = _props.onAccept;
	      var format = _props.format;
	      var autoOk = _props.autoOk;
	      var okLabel = _props.okLabel;
	      var cancelLabel = _props.cancelLabel;
	      var style = _props.style;
	
	      var other = _objectWithoutProperties(_props, ['bodyStyle', 'initialTime', 'onAccept', 'format', 'autoOk', 'okLabel', 'cancelLabel', 'style']);
	
	      var styles = {
	        root: {
	          fontSize: 14,
	          color: this.context.muiTheme.timePicker.clockColor
	        },
	        dialogContent: {
	          width: 280
	        },
	        body: {
	          padding: 0
	        }
	      };
	
	      var actions = [_react2.default.createElement(_FlatButton2.default, {
	        key: 0,
	        label: cancelLabel,
	        primary: true,
	        onTouchTap: this.handleTouchTapCancel
	      }), _react2.default.createElement(_FlatButton2.default, {
	        key: 1,
	        label: okLabel,
	        primary: true,
	        onTouchTap: this.handleTouchTapOK
	      })];
	
	      var onClockChangeMinutes = autoOk === true ? this.handleTouchTapOK : undefined;
	      var open = this.state.open;
	
	      return _react2.default.createElement(
	        _Dialog2.default,
	        _extends({}, other, {
	          style: (0, _simpleAssign2.default)(styles.root, style),
	          bodyStyle: (0, _simpleAssign2.default)(styles.body, bodyStyle),
	          actions: actions,
	          contentStyle: styles.dialogContent,
	          repositionOnUpdate: false,
	          open: open,
	          onRequestClose: this.handleRequestClose
	        }),
	        open && _react2.default.createElement(_reactEventListener2.default, { target: 'window', onKeyUp: this.handleKeyUp }),
	        open && _react2.default.createElement(_Clock2.default, {
	          ref: 'clock',
	          format: format,
	          initialTime: initialTime,
	          onChangeMinutes: onClockChangeMinutes
	        })
	      );
	    }
	  }]);
	
	  return TimePickerDialog;
	}(_react.Component);
	
	TimePickerDialog.propTypes = {
	  autoOk: _react.PropTypes.bool,
	  bodyStyle: _react.PropTypes.object,
	  cancelLabel: _react.PropTypes.node,
	  format: _react.PropTypes.oneOf(['ampm', '24hr']),
	  initialTime: _react.PropTypes.object,
	  okLabel: _react.PropTypes.node,
	  onAccept: _react.PropTypes.func,
	  onDismiss: _react.PropTypes.func,
	  onShow: _react.PropTypes.func,
	  style: _react.PropTypes.object
	};
	TimePickerDialog.defaultProps = {
	  okLabel: 'OK',
	  cancelLabel: 'Cancel'
	};
	TimePickerDialog.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	exports.default = TimePickerDialog;

/***/ }),
/* 903 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _TimeDisplay = __webpack_require__(904);
	
	var _TimeDisplay2 = _interopRequireDefault(_TimeDisplay);
	
	var _ClockHours = __webpack_require__(905);
	
	var _ClockHours2 = _interopRequireDefault(_ClockHours);
	
	var _ClockMinutes = __webpack_require__(909);
	
	var _ClockMinutes2 = _interopRequireDefault(_ClockMinutes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Clock = function (_Component) {
	  _inherits(Clock, _Component);
	
	  function Clock() {
	    var _Object$getPrototypeO;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Clock);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_Object$getPrototypeO = Object.getPrototypeOf(Clock)).call.apply(_Object$getPrototypeO, [this].concat(args))), _this), _this.state = {
	      selectedTime: null,
	      mode: 'hour'
	    }, _this.setMode = function (mode) {
	      setTimeout(function () {
	        _this.setState({
	          mode: mode
	        });
	      }, 100);
	    }, _this.handleSelectAffix = function (affix) {
	      if (affix === _this.getAffix()) return;
	
	      var hours = _this.state.selectedTime.getHours();
	
	      if (affix === 'am') {
	        _this.handleChangeHours(hours - 12, affix);
	        return;
	      }
	
	      _this.handleChangeHours(hours + 12, affix);
	    }, _this.handleChangeHours = function (hours, finished) {
	      var time = new Date(_this.state.selectedTime);
	      var affix = void 0;
	
	      if (typeof finished === 'string') {
	        affix = finished;
	        finished = undefined;
	      }
	      if (!affix) {
	        affix = _this.getAffix();
	      }
	      if (affix === 'pm' && hours < 12) {
	        hours += 12;
	      }
	
	      time.setHours(hours);
	      _this.setState({
	        selectedTime: time
	      });
	
	      if (finished) {
	        setTimeout(function () {
	          _this.setState({
	            mode: 'minute'
	          });
	
	          var onChangeHours = _this.props.onChangeHours;
	
	          if (onChangeHours) {
	            onChangeHours(time);
	          }
	        }, 100);
	      }
	    }, _this.handleChangeMinutes = function (minutes) {
	      var time = new Date(_this.state.selectedTime);
	      time.setMinutes(minutes);
	      _this.setState({
	        selectedTime: time
	      });
	
	      var onChangeMinutes = _this.props.onChangeMinutes;
	
	      if (onChangeMinutes) {
	        setTimeout(function () {
	          onChangeMinutes(time);
	        }, 0);
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Clock, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.setState({
	        selectedTime: this.props.initialTime || new Date()
	      });
	    }
	  }, {
	    key: 'getAffix',
	    value: function getAffix() {
	      if (this.props.format !== 'ampm') return '';
	
	      var hours = this.state.selectedTime.getHours();
	      if (hours < 12) {
	        return 'am';
	      }
	
	      return 'pm';
	    }
	  }, {
	    key: 'getSelectedTime',
	    value: function getSelectedTime() {
	      return this.state.selectedTime;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var clock = null;
	
	      var _context$muiTheme = this.context.muiTheme;
	      var prepareStyles = _context$muiTheme.prepareStyles;
	      var timePicker = _context$muiTheme.timePicker;
	
	
	      var styles = {
	        root: {
	          userSelect: 'none'
	        },
	        container: {
	          height: 280,
	          padding: 10,
	          position: 'relative',
	          boxSizing: 'content-box'
	        },
	        circle: {
	          position: 'absolute',
	          top: 20,
	          width: 260,
	          height: 260,
	          borderRadius: '100%',
	          backgroundColor: timePicker.clockCircleColor
	        }
	      };
	
	      if (this.state.mode === 'hour') {
	        clock = _react2.default.createElement(_ClockHours2.default, {
	          key: 'hours',
	          format: this.props.format,
	          onChange: this.handleChangeHours,
	          initialHours: this.state.selectedTime.getHours()
	        });
	      } else {
	        clock = _react2.default.createElement(_ClockMinutes2.default, {
	          key: 'minutes',
	          onChange: this.handleChangeMinutes,
	          initialMinutes: this.state.selectedTime.getMinutes()
	        });
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { style: prepareStyles(styles.root) },
	        _react2.default.createElement(_TimeDisplay2.default, {
	          selectedTime: this.state.selectedTime,
	          mode: this.state.mode,
	          format: this.props.format,
	          affix: this.getAffix(),
	          onSelectAffix: this.handleSelectAffix,
	          onSelectHour: this.setMode.bind(this, 'hour'),
	          onSelectMin: this.setMode.bind(this, 'minute')
	        }),
	        _react2.default.createElement(
	          'div',
	          { style: prepareStyles(styles.container) },
	          _react2.default.createElement('div', { style: prepareStyles(styles.circle) }),
	          clock
	        )
	      );
	    }
	  }]);
	
	  return Clock;
	}(_react.Component);
	
	Clock.propTypes = {
	  format: _react.PropTypes.oneOf(['ampm', '24hr']),
	  initialTime: _react.PropTypes.object,
	  onChangeHours: _react.PropTypes.func,
	  onChangeMinutes: _react.PropTypes.func
	};
	Clock.defaultProps = {
	  initialTime: new Date()
	};
	Clock.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	exports.default = Clock;

/***/ }),
/* 904 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _simpleAssign = __webpack_require__(579);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TimeDisplay = function (_Component) {
	  _inherits(TimeDisplay, _Component);
	
	  function TimeDisplay() {
	    var _Object$getPrototypeO;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, TimeDisplay);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_Object$getPrototypeO = Object.getPrototypeOf(TimeDisplay)).call.apply(_Object$getPrototypeO, [this].concat(args))), _this), _this.state = {
	      transitionDirection: 'up'
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(TimeDisplay, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.selectedTime !== this.props.selectedTime) {
	        var direction = nextProps.selectedTime > this.props.selectedTime ? 'up' : 'down';
	
	        this.setState({
	          transitionDirection: direction
	        });
	      }
	    }
	  }, {
	    key: 'sanitizeTime',
	    value: function sanitizeTime() {
	      var hour = this.props.selectedTime.getHours();
	      var min = this.props.selectedTime.getMinutes().toString();
	
	      if (this.props.format === 'ampm') {
	        hour %= 12;
	        hour = hour || 12;
	      }
	
	      hour = hour.toString();
	      if (hour.length < 2) hour = '0' + hour;
	      if (min.length < 2) min = '0' + min;
	
	      return [hour, min];
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var affix = _props.affix;
	      var format = _props.format;
	      var mode = _props.mode;
	      var onSelectAffix = _props.onSelectAffix;
	      var onSelectHour = _props.onSelectHour;
	      var onSelectMin = _props.onSelectMin;
	      var selectedTime = _props.selectedTime;
	
	      var other = _objectWithoutProperties(_props, ['affix', 'format', 'mode', 'onSelectAffix', 'onSelectHour', 'onSelectMin', 'selectedTime']);
	
	      var _context$muiTheme = this.context.muiTheme;
	      var prepareStyles = _context$muiTheme.prepareStyles;
	      var timePicker = _context$muiTheme.timePicker;
	
	
	      var styles = {
	        root: {
	          padding: '14px 0',
	          borderTopLeftRadius: 2,
	          borderTopRightRadius: 2,
	          backgroundColor: timePicker.headerColor,
	          color: 'white'
	        },
	        text: {
	          margin: '6px 0',
	          lineHeight: '58px',
	          height: 58,
	          fontSize: 58,
	          display: 'flex',
	          justifyContent: 'center',
	          alignItems: 'baseline'
	        },
	        time: {
	          margin: '0 10px'
	        },
	        affix: {
	          flex: 1,
	          position: 'relative',
	          lineHeight: '17px',
	          height: 17,
	          fontSize: 17
	        },
	        affixTop: {
	          position: 'absolute',
	          top: -20,
	          left: 0
	        },
	        clickable: {
	          cursor: 'pointer'
	        },
	        inactive: {
	          opacity: 0.7
	        }
	      };
	
	      var _sanitizeTime = this.sanitizeTime();
	
	      var _sanitizeTime2 = _slicedToArray(_sanitizeTime, 2);
	
	      var hour = _sanitizeTime2[0];
	      var min = _sanitizeTime2[1];
	
	
	      var buttons = [];
	      if (format === 'ampm') {
	        buttons = [_react2.default.createElement(
	          'div',
	          {
	            key: 'pm',
	            style: prepareStyles((0, _simpleAssign2.default)({}, styles.clickable, affix === 'pm' ? {} : styles.inactive)),
	            onTouchTap: function onTouchTap() {
	              return onSelectAffix('pm');
	            }
	          },
	          'PM'
	        ), _react2.default.createElement(
	          'div',
	          {
	            key: 'am',
	            style: prepareStyles((0, _simpleAssign2.default)({}, styles.affixTop, styles.clickable, affix === 'am' ? {} : styles.inactive)),
	            onTouchTap: function onTouchTap() {
	              return onSelectAffix('am');
	            }
	          },
	          'AM'
	        )];
	      }
	
	      return _react2.default.createElement(
	        'div',
	        _extends({}, other, { style: prepareStyles(styles.root) }),
	        _react2.default.createElement(
	          'div',
	          { style: prepareStyles(styles.text) },
	          _react2.default.createElement('div', { style: prepareStyles((0, _simpleAssign2.default)({}, styles.affix)) }),
	          _react2.default.createElement(
	            'div',
	            { style: prepareStyles(styles.time) },
	            _react2.default.createElement(
	              'span',
	              {
	                style: prepareStyles((0, _simpleAssign2.default)({}, styles.clickable, mode === 'hour' ? {} : styles.inactive)),
	                onTouchTap: onSelectHour
	              },
	              hour
	            ),
	            _react2.default.createElement(
	              'span',
	              null,
	              ':'
	            ),
	            _react2.default.createElement(
	              'span',
	              {
	                style: prepareStyles((0, _simpleAssign2.default)({}, styles.clickable, mode === 'minute' ? {} : styles.inactive)),
	                onTouchTap: onSelectMin
	              },
	              min
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { style: prepareStyles((0, _simpleAssign2.default)({}, styles.affix)) },
	            buttons
	          )
	        )
	      );
	    }
	  }]);
	
	  return TimeDisplay;
	}(_react.Component);
	
	TimeDisplay.propTypes = {
	  affix: _react.PropTypes.oneOf(['', 'pm', 'am']),
	  format: _react.PropTypes.oneOf(['ampm', '24hr']),
	  mode: _react.PropTypes.oneOf(['hour', 'minute']),
	  onSelectAffix: _react.PropTypes.func,
	  onSelectHour: _react.PropTypes.func,
	  onSelectMin: _react.PropTypes.func,
	  selectedTime: _react.PropTypes.object.isRequired
	};
	TimeDisplay.defaultProps = {
	  affix: '',
	  mode: 'hour'
	};
	TimeDisplay.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	exports.default = TimeDisplay;

/***/ }),
/* 905 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(332);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _ClockNumber = __webpack_require__(906);
	
	var _ClockNumber2 = _interopRequireDefault(_ClockNumber);
	
	var _ClockPointer = __webpack_require__(908);
	
	var _ClockPointer2 = _interopRequireDefault(_ClockPointer);
	
	var _timeUtils = __webpack_require__(907);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ClockHours = function (_Component) {
	  _inherits(ClockHours, _Component);
	
	  function ClockHours() {
	    var _Object$getPrototypeO;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ClockHours);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_Object$getPrototypeO = Object.getPrototypeOf(ClockHours)).call.apply(_Object$getPrototypeO, [this].concat(args))), _this), _this.handleUp = function (event) {
	      event.preventDefault();
	      _this.setClock(event.nativeEvent, true);
	    }, _this.handleMove = function (event) {
	      event.preventDefault();
	      if (_this.isMousePressed(event) !== 1) return;
	      _this.setClock(event.nativeEvent, false);
	    }, _this.handleTouchMove = function (event) {
	      event.preventDefault();
	      _this.setClock(event.changedTouches[0], false);
	    }, _this.handleTouchEnd = function (event) {
	      event.preventDefault();
	      _this.setClock(event.changedTouches[0], true);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(ClockHours, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var clockElement = _reactDom2.default.findDOMNode(this.refs.mask);
	
	      this.center = {
	        x: clockElement.offsetWidth / 2,
	        y: clockElement.offsetHeight / 2
	      };
	
	      this.basePoint = {
	        x: this.center.x,
	        y: 0
	      };
	    }
	  }, {
	    key: 'isMousePressed',
	    value: function isMousePressed(event) {
	      if (typeof event.buttons === 'undefined') {
	        return event.nativeEvent.which;
	      }
	
	      return event.buttons;
	    }
	  }, {
	    key: 'setClock',
	    value: function setClock(event, finish) {
	      if (typeof event.offsetX === 'undefined') {
	        var offset = (0, _timeUtils.getTouchEventOffsetValues)(event);
	
	        event.offsetX = offset.offsetX;
	        event.offsetY = offset.offsetY;
	      }
	
	      var hours = this.getHours(event.offsetX, event.offsetY);
	
	      this.props.onChange(hours, finish);
	    }
	  }, {
	    key: 'getHours',
	    value: function getHours(offsetX, offsetY) {
	      var step = 30;
	      var x = offsetX - this.center.x;
	      var y = offsetY - this.center.y;
	      var cx = this.basePoint.x - this.center.x;
	      var cy = this.basePoint.y - this.center.y;
	
	      var atan = Math.atan2(cx, cy) - Math.atan2(x, y);
	
	      var deg = (0, _timeUtils.rad2deg)(atan);
	      deg = Math.round(deg / step) * step;
	      deg %= 360;
	
	      var value = Math.floor(deg / step) || 0;
	
	      var delta = Math.pow(x, 2) + Math.pow(y, 2);
	      var distance = Math.sqrt(delta);
	
	      value = value || 12;
	      if (this.props.format === '24hr') {
	        if (distance < 90) {
	          value += 12;
	          value %= 24;
	        }
	      } else {
	        value %= 12;
	      }
	
	      return value;
	    }
	  }, {
	    key: 'getSelected',
	    value: function getSelected() {
	      var hour = this.props.initialHours;
	
	      if (this.props.format === 'ampm') {
	        hour %= 12;
	        hour = hour || 12;
	      }
	
	      return hour;
	    }
	  }, {
	    key: 'getHourNumbers',
	    value: function getHourNumbers() {
	      var _this2 = this;
	
	      var style = {
	        pointerEvents: 'none'
	      };
	      var hourSize = this.props.format === 'ampm' ? 12 : 24;
	
	      var hours = [];
	      for (var i = 1; i <= hourSize; i++) {
	        hours.push(i % 24);
	      }
	
	      return hours.map(function (hour) {
	        var isSelected = _this2.getSelected() === hour;
	        return _react2.default.createElement(_ClockNumber2.default, {
	          key: hour,
	          style: style,
	          isSelected: isSelected,
	          type: 'hour',
	          value: hour
	        });
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var styles = {
	        root: {
	          height: '100%',
	          width: '100%',
	          borderRadius: '100%',
	          position: 'relative',
	          pointerEvents: 'none',
	          boxSizing: 'border-box'
	        },
	
	        hitMask: {
	          height: '100%',
	          width: '100%',
	          pointerEvents: 'auto'
	        }
	      };
	
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var hours = this.getSelected();
	      var numbers = this.getHourNumbers();
	
	      return _react2.default.createElement(
	        'div',
	        { ref: 'clock', style: prepareStyles(styles.root) },
	        _react2.default.createElement(_ClockPointer2.default, { hasSelected: true, value: hours, type: 'hour' }),
	        numbers,
	        _react2.default.createElement('div', {
	          ref: 'mask', style: prepareStyles(styles.hitMask), onTouchMove: this.handleTouchMove,
	          onTouchEnd: this.handleTouchEnd, onMouseUp: this.handleUp, onMouseMove: this.handleMove
	        })
	      );
	    }
	  }]);
	
	  return ClockHours;
	}(_react.Component);
	
	ClockHours.propTypes = {
	  format: _react.PropTypes.oneOf(['ampm', '24hr']),
	  initialHours: _react.PropTypes.number,
	  onChange: _react.PropTypes.func
	};
	ClockHours.defaultProps = {
	  initialHours: new Date().getHours(),
	  onChange: function onChange() {},
	  format: 'ampm'
	};
	ClockHours.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	exports.default = ClockHours;

/***/ }),
/* 906 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _timeUtils = __webpack_require__(907);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function getStyles(props, context) {
	  var styles = {
	    root: {
	      display: 'inline-block',
	      position: 'absolute',
	      width: 32,
	      height: 32,
	      borderRadius: '100%',
	      left: 'calc(50% - 16px)',
	      top: 10,
	      textAlign: 'center',
	      paddingTop: 5,
	      userSelect: 'none', /* Chrome all / Safari all */
	      fontSize: '1.1em',
	      pointerEvents: 'none',
	      boxSizing: 'border-box'
	    }
	  };
	
	  var muiTheme = context.muiTheme;
	
	
	  var pos = props.value;
	
	  if (props.type === 'hour') {
	    pos %= 12;
	  } else {
	    pos = pos / 5;
	  }
	
	  var positions = [[0, 5], [54.5, 16.6], [94.4, 59.5], [109, 114], [94.4, 168.5], [54.5, 208.4], [0, 223], [-54.5, 208.4], [-94.4, 168.5], [-109, 114], [-94.4, 59.5], [-54.5, 19.6]];
	
	  var innerPositions = [[0, 40], [36.9, 49.9], [64, 77], [74, 114], [64, 151], [37, 178], [0, 188], [-37, 178], [-64, 151], [-74, 114], [-64, 77], [-37, 50]];
	
	  if (props.isSelected) {
	    styles.root.backgroundColor = muiTheme.timePicker.accentColor;
	    styles.root.color = muiTheme.timePicker.selectTextColor;
	  }
	
	  var transformPos = positions[pos];
	
	  if ((0, _timeUtils.isInner)(props)) {
	    styles.root.width = 28;
	    styles.root.height = 28;
	    styles.root.left = 'calc(50% - 14px)';
	    transformPos = innerPositions[pos];
	  }
	
	  var _transformPos = transformPos;
	
	  var _transformPos2 = _slicedToArray(_transformPos, 2);
	
	  var x = _transformPos2[0];
	  var y = _transformPos2[1];
	
	
	  styles.root.transform = 'translate(' + x + 'px, ' + y + 'px)';
	
	  return styles;
	}
	
	var ClockNumber = function (_Component) {
	  _inherits(ClockNumber, _Component);
	
	  function ClockNumber() {
	    _classCallCheck(this, ClockNumber);
	
	    return _possibleConstructorReturn(this, Object.getPrototypeOf(ClockNumber).apply(this, arguments));
	  }
	
	  _createClass(ClockNumber, [{
	    key: 'render',
	    value: function render() {
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	      var clockNumber = this.props.value === 0 ? '00' : this.props.value;
	
	      return _react2.default.createElement(
	        'span',
	        { style: prepareStyles(styles.root) },
	        clockNumber
	      );
	    }
	  }]);
	
	  return ClockNumber;
	}(_react.Component);
	
	ClockNumber.propTypes = {
	  isSelected: _react.PropTypes.bool,
	  onSelected: _react.PropTypes.func,
	  type: _react.PropTypes.oneOf(['hour', 'minute']),
	  value: _react.PropTypes.number
	};
	ClockNumber.defaultProps = {
	  value: 0,
	  type: 'minute',
	  isSelected: false
	};
	ClockNumber.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	exports.default = ClockNumber;

/***/ }),
/* 907 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.addHours = addHours;
	exports.addMinutes = addMinutes;
	exports.addSeconds = addSeconds;
	exports.formatTime = formatTime;
	exports.rad2deg = rad2deg;
	exports.getTouchEventOffsetValues = getTouchEventOffsetValues;
	exports.isInner = isInner;
	function addHours(d, hours) {
	  var newDate = clone(d);
	  newDate.setHours(d.getHours() + hours);
	  return newDate;
	}
	
	function addMinutes(d, minutes) {
	  var newDate = clone(d);
	  newDate.setMinutes(d.getMinutes() + minutes);
	  return newDate;
	}
	
	function addSeconds(d, seconds) {
	  var newDate = clone(d);
	  newDate.setSeconds(d.getMinutes() + seconds);
	  return newDate;
	}
	
	function clone(d) {
	  return new Date(d.getTime());
	}
	
	/**
	 * @param date [Date] A Date object.
	 * @param format [String] One of 'ampm', '24hr', defaults to 'ampm'.
	 * @param pedantic [Boolean] Check time-picker/time-picker.jsx file.
	 *
	 * @return String A string representing the formatted time.
	 */
	function formatTime(date) {
	  var format = arguments.length <= 1 || arguments[1] === undefined ? 'ampm' : arguments[1];
	  var pedantic = arguments.length <= 2 || arguments[2] === undefined ? false : arguments[2];
	
	  if (!date) return '';
	  var hours = date.getHours();
	  var mins = date.getMinutes().toString();
	
	  if (format === 'ampm') {
	    var isAM = hours < 12;
	    hours = hours % 12;
	    var additional = isAM ? ' am' : ' pm';
	    hours = (hours || 12).toString();
	
	    if (mins.length < 2) mins = '0' + mins;
	
	    if (pedantic) {
	      // Treat midday/midnight specially http://www.nist.gov/pml/div688/times.cfm
	      if (hours === '12' && mins === '00') {
	        return additional === ' pm' ? '12 noon' : '12 midnight';
	      }
	    }
	
	    return hours + (mins === '00' ? '' : ':' + mins) + additional;
	  }
	
	  hours = hours.toString();
	
	  if (hours.length < 2) hours = '0' + hours;
	  if (mins.length < 2) mins = '0' + mins;
	
	  return hours + ':' + mins;
	}
	
	function rad2deg(rad) {
	  return rad * 57.29577951308232;
	}
	
	function getTouchEventOffsetValues(event) {
	  var el = event.target;
	  var boundingRect = el.getBoundingClientRect();
	
	  return {
	    offsetX: event.clientX - boundingRect.left,
	    offsetY: event.clientY - boundingRect.top
	  };
	}
	
	function isInner(props) {
	  if (props.type !== 'hour') {
	    return false;
	  }
	  return props.value < 1 || props.value > 12;
	}

/***/ }),
/* 908 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _timeUtils = __webpack_require__(907);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function calcAngle(value, base) {
	  value %= base;
	  var angle = 360 / base * value;
	  return angle;
	}
	
	function getStyles(props, context, state) {
	  var hasSelected = props.hasSelected;
	  var type = props.type;
	  var value = props.value;
	  var inner = state.inner;
	  var timePicker = context.muiTheme.timePicker;
	
	  var angle = type === 'hour' ? calcAngle(value, 12) : calcAngle(value, 60);
	
	  var styles = {
	    root: {
	      height: inner ? '30%' : '40%',
	      background: timePicker.accentColor,
	      width: 2,
	      left: 'calc(50% - 1px)',
	      position: 'absolute',
	      bottom: '50%',
	      transformOrigin: 'bottom',
	      pointerEvents: 'none',
	      transform: 'rotateZ(' + angle + 'deg)'
	    },
	    mark: {
	      background: timePicker.selectTextColor,
	      border: '4px solid ' + timePicker.accentColor,
	      display: hasSelected && 'none',
	      width: 7,
	      height: 7,
	      position: 'absolute',
	      top: -5,
	      left: -6,
	      borderRadius: '100%'
	    }
	  };
	
	  return styles;
	}
	
	var ClockPointer = function (_Component) {
	  _inherits(ClockPointer, _Component);
	
	  function ClockPointer() {
	    var _Object$getPrototypeO;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ClockPointer);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_Object$getPrototypeO = Object.getPrototypeOf(ClockPointer)).call.apply(_Object$getPrototypeO, [this].concat(args))), _this), _this.state = {
	      inner: false
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(ClockPointer, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.setState({
	        inner: (0, _timeUtils.isInner)(this.props)
	      });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      this.setState({
	        inner: (0, _timeUtils.isInner)(nextProps)
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (this.props.value === null) {
	        return _react2.default.createElement('span', null);
	      }
	
	      var styles = getStyles(this.props, this.context, this.state);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	
	      return _react2.default.createElement(
	        'div',
	        { style: prepareStyles(styles.root) },
	        _react2.default.createElement('div', { style: prepareStyles(styles.mark) })
	      );
	    }
	  }]);
	
	  return ClockPointer;
	}(_react.Component);
	
	ClockPointer.propTypes = {
	  hasSelected: _react.PropTypes.bool,
	  type: _react.PropTypes.oneOf(['hour', 'minute']),
	  value: _react.PropTypes.number
	};
	ClockPointer.defaultProps = {
	  hasSelected: false,
	  value: null,
	  type: 'minute'
	};
	ClockPointer.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	exports.default = ClockPointer;

/***/ }),
/* 909 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ClockNumber = __webpack_require__(906);
	
	var _ClockNumber2 = _interopRequireDefault(_ClockNumber);
	
	var _ClockPointer = __webpack_require__(908);
	
	var _ClockPointer2 = _interopRequireDefault(_ClockPointer);
	
	var _timeUtils = __webpack_require__(907);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ClockMinutes = function (_Component) {
	  _inherits(ClockMinutes, _Component);
	
	  function ClockMinutes() {
	    var _Object$getPrototypeO;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ClockMinutes);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_Object$getPrototypeO = Object.getPrototypeOf(ClockMinutes)).call.apply(_Object$getPrototypeO, [this].concat(args))), _this), _this.handleUp = function (event) {
	      event.preventDefault();
	      _this.setClock(event.nativeEvent, true);
	    }, _this.handleMove = function (event) {
	      event.preventDefault();
	      if (_this.isMousePressed(event) !== 1) {
	        return;
	      }
	      _this.setClock(event.nativeEvent, false);
	    }, _this.handleTouch = function (event) {
	      event.preventDefault();
	      _this.setClock(event.changedTouches[0], false);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(ClockMinutes, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var clockElement = this.refs.mask;
	
	      this.center = {
	        x: clockElement.offsetWidth / 2,
	        y: clockElement.offsetHeight / 2
	      };
	
	      this.basePoint = {
	        x: this.center.x,
	        y: 0
	      };
	    }
	  }, {
	    key: 'isMousePressed',
	    value: function isMousePressed(event) {
	      if (typeof event.buttons === 'undefined') {
	        return event.nativeEvent.which;
	      }
	      return event.buttons;
	    }
	  }, {
	    key: 'setClock',
	    value: function setClock(event, finish) {
	      if (typeof event.offsetX === 'undefined') {
	        var offset = (0, _timeUtils.getTouchEventOffsetValues)(event);
	
	        event.offsetX = offset.offsetX;
	        event.offsetY = offset.offsetY;
	      }
	
	      var minutes = this.getMinutes(event.offsetX, event.offsetY);
	
	      this.props.onChange(minutes, finish);
	    }
	  }, {
	    key: 'getMinutes',
	    value: function getMinutes(offsetX, offsetY) {
	      var step = 6;
	      var x = offsetX - this.center.x;
	      var y = offsetY - this.center.y;
	      var cx = this.basePoint.x - this.center.x;
	      var cy = this.basePoint.y - this.center.y;
	
	      var atan = Math.atan2(cx, cy) - Math.atan2(x, y);
	
	      var deg = (0, _timeUtils.rad2deg)(atan);
	      deg = Math.round(deg / step) * step;
	      deg %= 360;
	
	      var value = Math.floor(deg / step) || 0;
	
	      return value;
	    }
	  }, {
	    key: 'getMinuteNumbers',
	    value: function getMinuteNumbers() {
	      var minutes = [];
	      for (var i = 0; i < 12; i++) {
	        minutes.push(i * 5);
	      }
	      var selectedMinutes = this.props.initialMinutes;
	      var hasSelected = false;
	
	      var numbers = minutes.map(function (minute) {
	        var isSelected = selectedMinutes === minute;
	        if (isSelected) {
	          hasSelected = true;
	        }
	        return _react2.default.createElement(_ClockNumber2.default, {
	          key: minute,
	          isSelected: isSelected,
	          type: 'minute',
	          value: minute
	        });
	      });
	
	      return {
	        numbers: numbers,
	        hasSelected: hasSelected,
	        selected: selectedMinutes
	      };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var styles = {
	        root: {
	          height: '100%',
	          width: '100%',
	          borderRadius: '100%',
	          position: 'relative',
	          pointerEvents: 'none',
	          boxSizing: 'border-box'
	        },
	
	        hitMask: {
	          height: '100%',
	          width: '100%',
	          pointerEvents: 'auto'
	        }
	      };
	
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var minutes = this.getMinuteNumbers();
	
	      return _react2.default.createElement(
	        'div',
	        { ref: 'clock', style: prepareStyles(styles.root) },
	        _react2.default.createElement(_ClockPointer2.default, { value: minutes.selected, type: 'minute', hasSelected: minutes.hasSelected }),
	        minutes.numbers,
	        _react2.default.createElement('div', {
	          ref: 'mask',
	          style: prepareStyles(styles.hitMask),
	          onTouchMove: this.handleTouch,
	          onTouchEnd: this.handleTouch,
	          onMouseUp: this.handleUp,
	          onMouseMove: this.handleMove
	        })
	      );
	    }
	  }]);
	
	  return ClockMinutes;
	}(_react.Component);
	
	ClockMinutes.propTypes = {
	  initialMinutes: _react.PropTypes.number,
	  onChange: _react.PropTypes.func
	};
	ClockMinutes.defaultProps = {
	  initialMinutes: new Date().getMinutes(),
	  onChange: function onChange() {}
	};
	ClockMinutes.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	exports.default = ClockMinutes;

/***/ }),
/* 910 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _Toggle = __webpack_require__(911);
	
	var _Toggle2 = _interopRequireDefault(_Toggle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Toggle2.default;

/***/ }),
/* 911 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _simpleAssign = __webpack_require__(579);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _transitions = __webpack_require__(582);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _Paper = __webpack_require__(617);
	
	var _Paper2 = _interopRequireDefault(_Paper);
	
	var _EnhancedSwitch = __webpack_require__(680);
	
	var _EnhancedSwitch2 = _interopRequireDefault(_EnhancedSwitch);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function getStyles(props, context, state) {
	  var disabled = props.disabled;
	  var _context$muiTheme = context.muiTheme;
	  var baseTheme = _context$muiTheme.baseTheme;
	  var toggle = _context$muiTheme.toggle;
	
	
	  var toggleSize = 20;
	  var toggleTrackWidth = 36;
	  var styles = {
	    icon: {
	      width: 36,
	      padding: '4px 0px 6px 2px'
	    },
	    ripple: {
	      top: -10,
	      left: -10,
	      color: state.switched ? toggle.thumbOnColor : baseTheme.palette.textColor
	    },
	    toggleElement: {
	      width: toggleTrackWidth
	    },
	    track: {
	      transition: _transitions2.default.easeOut(),
	      width: '100%',
	      height: 14,
	      borderRadius: 30,
	      backgroundColor: toggle.trackOffColor
	    },
	    thumb: {
	      transition: _transitions2.default.easeOut(),
	      position: 'absolute',
	      top: 1,
	      left: 0,
	      width: toggleSize,
	      height: toggleSize,
	      lineHeight: '24px',
	      borderRadius: '50%',
	      backgroundColor: toggle.thumbOffColor
	    },
	    trackWhenSwitched: {
	      backgroundColor: toggle.trackOnColor
	    },
	    thumbWhenSwitched: {
	      backgroundColor: toggle.thumbOnColor,
	      left: '100%'
	    },
	    trackWhenDisabled: {
	      backgroundColor: toggle.trackDisabledColor,
	      cursor: 'not-allowed'
	    },
	    thumbWhenDisabled: {
	      backgroundColor: toggle.thumbDisabledColor,
	      cursor: 'not-allowed'
	    },
	    label: {
	      color: disabled ? toggle.labelDisabledColor : toggle.labelColor,
	      width: 'calc(100% - ' + (toggleTrackWidth + 10) + 'px)',
	      cursor: disabled ? 'not-allowed' : 'initial'
	    }
	  };
	
	  return styles;
	}
	
	var Toggle = function (_Component) {
	  _inherits(Toggle, _Component);
	
	  function Toggle() {
	    var _Object$getPrototypeO;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Toggle);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_Object$getPrototypeO = Object.getPrototypeOf(Toggle)).call.apply(_Object$getPrototypeO, [this].concat(args))), _this), _this.state = {
	      switched: false
	    }, _this.handleStateChange = function (newSwitched) {
	      _this.setState({
	        switched: newSwitched
	      });
	    }, _this.handleToggle = function (event, isInputChecked) {
	      if (_this.props.onToggle) {
	        _this.props.onToggle(event, isInputChecked);
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Toggle, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _props = this.props;
	      var toggled = _props.toggled;
	      var defaultToggled = _props.defaultToggled;
	      var valueLink = _props.valueLink;
	
	
	      if (toggled || defaultToggled || valueLink && valueLink.value) {
	        this.setState({
	          switched: true
	        });
	      }
	    }
	  }, {
	    key: 'isToggled',
	    value: function isToggled() {
	      return this.refs.enhancedSwitch.isSwitched();
	    }
	  }, {
	    key: 'setToggled',
	    value: function setToggled(newToggledValue) {
	      this.refs.enhancedSwitch.setSwitched(newToggledValue);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props;
	      var defaultToggled = _props2.defaultToggled;
	      var elementStyle = _props2.elementStyle;
	      var onToggle = _props2.onToggle;
	      var toggled = _props2.toggled;
	
	      var other = _objectWithoutProperties(_props2, ['defaultToggled', 'elementStyle', 'onToggle', 'toggled']);
	
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context, this.state);
	
	      var trackStyles = (0, _simpleAssign2.default)({}, styles.track, this.props.trackStyle, this.state.switched && styles.trackWhenSwitched, this.props.disabled && styles.trackWhenDisabled);
	
	      var thumbStyles = (0, _simpleAssign2.default)({}, styles.thumb, this.props.thumbStyle, this.state.switched && styles.thumbWhenSwitched, this.props.disabled && styles.thumbWhenDisabled);
	
	      if (this.state.switched) {
	        thumbStyles.marginLeft = 0 - thumbStyles.width;
	      }
	
	      var toggleElementStyles = (0, _simpleAssign2.default)({}, styles.toggleElement, elementStyle);
	
	      var toggleElement = _react2.default.createElement(
	        'div',
	        { style: prepareStyles((0, _simpleAssign2.default)({}, toggleElementStyles)) },
	        _react2.default.createElement('div', { style: prepareStyles((0, _simpleAssign2.default)({}, trackStyles)) }),
	        _react2.default.createElement(_Paper2.default, { style: thumbStyles, circle: true, zDepth: 1 })
	      );
	
	      var rippleStyle = (0, _simpleAssign2.default)({}, styles.ripple, this.props.rippleStyle);
	
	      var iconStyle = (0, _simpleAssign2.default)({}, styles.icon, this.props.iconStyle);
	
	      var labelStyle = (0, _simpleAssign2.default)({}, styles.label, this.props.labelStyle);
	
	      var enhancedSwitchProps = {
	        ref: 'enhancedSwitch',
	        inputType: 'checkbox',
	        switchElement: toggleElement,
	        rippleStyle: rippleStyle,
	        rippleColor: rippleStyle.color,
	        iconStyle: iconStyle,
	        trackStyle: trackStyles,
	        thumbStyle: thumbStyles,
	        labelStyle: labelStyle,
	        switched: this.state.switched,
	        onSwitch: this.handleToggle,
	        onParentShouldUpdate: this.handleStateChange,
	        labelPosition: this.props.labelPosition
	      };
	
	      if (this.props.hasOwnProperty('toggled')) {
	        enhancedSwitchProps.checked = toggled;
	      } else if (this.props.hasOwnProperty('defaultToggled')) {
	        enhancedSwitchProps.defaultChecked = defaultToggled;
	      }
	
	      return _react2.default.createElement(_EnhancedSwitch2.default, _extends({}, other, enhancedSwitchProps));
	    }
	  }]);
	
	  return Toggle;
	}(_react.Component);
	
	Toggle.propTypes = {
	  /**
	   * Determines whether the Toggle is initially turned on.
	   * **Warning:** This cannot be used in conjunction with `toggled`.
	   * Decide between using a controlled or uncontrolled input element and remove one of these props.
	   * More info: https://fb.me/react-controlled-components
	   */
	  defaultToggled: _react.PropTypes.bool,
	  /**
	   * Will disable the toggle if true.
	   */
	  disabled: _react.PropTypes.bool,
	  /**
	   * Overrides the inline-styles of the Toggle element.
	   */
	  elementStyle: _react.PropTypes.object,
	  /**
	   * Overrides the inline-styles of the Icon element.
	   */
	  iconStyle: _react.PropTypes.object,
	  /**
	   * Overrides the inline-styles of the input element.
	   */
	  inputStyle: _react.PropTypes.object,
	  /**
	   * Label for toggle.
	   */
	  label: _react.PropTypes.string,
	  /**
	   * Where the label will be placed next to the toggle.
	   */
	  labelPosition: _react.PropTypes.oneOf(['left', 'right']),
	  /**
	   * Overrides the inline-styles of the Toggle element label.
	   */
	  labelStyle: _react.PropTypes.object,
	  /**
	   * Callback function that is fired when the toggle switch is toggled.
	   */
	  onToggle: _react.PropTypes.func,
	  /**
	   * Override style of ripple.
	   */
	  rippleStyle: _react.PropTypes.object,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object,
	  /**
	   * Override style for thumb.
	   */
	  thumbStyle: _react.PropTypes.object,
	  /**
	   * Toggled if set to true.
	   */
	  toggled: _react.PropTypes.bool,
	  /**
	   * Override style for track.
	   */
	  trackStyle: _react.PropTypes.object,
	  /**
	   * ValueLink prop for when using controlled toggle.
	   */
	  valueLink: _react.PropTypes.object
	};
	Toggle.defaultProps = {
	  defaultToggled: false,
	  disabled: false,
	  labelPosition: 'left'
	};
	Toggle.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	exports.default = Toggle;

/***/ }),
/* 912 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.ToolbarTitle = exports.ToolbarSeparator = exports.ToolbarGroup = exports.Toolbar = undefined;
	
	var _Toolbar2 = __webpack_require__(913);
	
	var _Toolbar3 = _interopRequireDefault(_Toolbar2);
	
	var _ToolbarGroup2 = __webpack_require__(914);
	
	var _ToolbarGroup3 = _interopRequireDefault(_ToolbarGroup2);
	
	var _ToolbarSeparator2 = __webpack_require__(915);
	
	var _ToolbarSeparator3 = _interopRequireDefault(_ToolbarSeparator2);
	
	var _ToolbarTitle2 = __webpack_require__(916);
	
	var _ToolbarTitle3 = _interopRequireDefault(_ToolbarTitle2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Toolbar = _Toolbar3.default;
	exports.ToolbarGroup = _ToolbarGroup3.default;
	exports.ToolbarSeparator = _ToolbarSeparator3.default;
	exports.ToolbarTitle = _ToolbarTitle3.default;
	exports.default = _Toolbar3.default;

/***/ }),
/* 913 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _simpleAssign = __webpack_require__(579);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function getStyles(props, context) {
	  var noGutter = props.noGutter;
	  var _context$muiTheme = context.muiTheme;
	  var baseTheme = _context$muiTheme.baseTheme;
	  var toolbar = _context$muiTheme.toolbar;
	
	
	  return {
	    root: {
	      boxSizing: 'border-box',
	      WebkitTapHighlightColor: 'rgba(0,0,0,0)', // Remove mobile color flashing (deprecated)
	      backgroundColor: toolbar.backgroundColor,
	      height: toolbar.height,
	      padding: noGutter ? 0 : '0px ' + baseTheme.spacing.desktopGutter + 'px',
	      display: 'flex',
	      justifyContent: 'space-between'
	    }
	  };
	}
	
	var Toolbar = function (_Component) {
	  _inherits(Toolbar, _Component);
	
	  function Toolbar() {
	    _classCallCheck(this, Toolbar);
	
	    return _possibleConstructorReturn(this, Object.getPrototypeOf(Toolbar).apply(this, arguments));
	  }
	
	  _createClass(Toolbar, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var children = _props.children;
	      var className = _props.className;
	      var noGutter = _props.noGutter;
	      var style = _props.style;
	
	      var other = _objectWithoutProperties(_props, ['children', 'className', 'noGutter', 'style']);
	
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      return _react2.default.createElement(
	        'div',
	        _extends({}, other, { className: className, style: prepareStyles((0, _simpleAssign2.default)({}, styles.root, style)) }),
	        children
	      );
	    }
	  }]);
	
	  return Toolbar;
	}(_react.Component);
	
	Toolbar.propTypes = {
	  /**
	   * Can be a `ToolbarGroup` to render a group of related items.
	   */
	  children: _react.PropTypes.node,
	  /**
	   * The css class name of the root element.
	   */
	  className: _react.PropTypes.string,
	  /**
	   * Do not apply `desktopGutter` to the `Toolbar`.
	   */
	  noGutter: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object
	};
	Toolbar.defaultProps = {
	  noGutter: false
	};
	Toolbar.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	exports.default = Toolbar;

/***/ }),
/* 914 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _simpleAssign = __webpack_require__(579);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function getStyles(props, context) {
	  var firstChild = props.firstChild;
	  var lastChild = props.lastChild;
	  var _context$muiTheme = context.muiTheme;
	  var baseTheme = _context$muiTheme.baseTheme;
	  var button = _context$muiTheme.button;
	  var toolbar = _context$muiTheme.toolbar;
	
	
	  var marginHorizontal = baseTheme.spacing.desktopGutter;
	  var marginVertical = (toolbar.height - button.height) / 2;
	
	  var styles = {
	    root: {
	      position: 'relative',
	      marginLeft: firstChild ? -marginHorizontal : undefined,
	      marginRight: lastChild ? -marginHorizontal : undefined,
	      display: 'flex',
	      justifyContent: 'space-between'
	    },
	    dropDownMenu: {
	      root: {
	        color: toolbar.color, // removes hover color change, we want to keep it
	        marginRight: baseTheme.spacing.desktopGutter,
	        flex: 1,
	        whiteSpace: 'nowrap'
	      },
	      controlBg: {
	        backgroundColor: toolbar.menuHoverColor,
	        borderRadius: 0
	      },
	      underline: {
	        display: 'none'
	      }
	    },
	    button: {
	      margin: marginVertical + 'px ' + marginHorizontal + 'px',
	      position: 'relative'
	    },
	    icon: {
	      root: {
	        cursor: 'pointer',
	        lineHeight: toolbar.height + 'px',
	        paddingLeft: baseTheme.spacing.desktopGutter
	      }
	    },
	    span: {
	      color: toolbar.iconColor,
	      lineHeight: toolbar.height + 'px'
	    }
	  };
	
	  return styles;
	}
	
	var ToolbarGroup = function (_Component) {
	  _inherits(ToolbarGroup, _Component);
	
	  function ToolbarGroup() {
	    _classCallCheck(this, ToolbarGroup);
	
	    return _possibleConstructorReturn(this, Object.getPrototypeOf(ToolbarGroup).apply(this, arguments));
	  }
	
	  _createClass(ToolbarGroup, [{
	    key: 'handleMouseLeaveFontIcon',
	    value: function handleMouseLeaveFontIcon(style) {
	      return function (event) {
	        event.target.style.zIndex = 'auto';
	        event.target.style.color = style.root.color;
	      };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props;
	      var children = _props.children;
	      var className = _props.className;
	      var firstChild = _props.firstChild;
	      var lastChild = _props.lastChild;
	      var style = _props.style;
	
	      var other = _objectWithoutProperties(_props, ['children', 'className', 'firstChild', 'lastChild', 'style']);
	
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      var newChildren = _react2.default.Children.map(children, function (currentChild) {
	        if (!currentChild) {
	          return null;
	        }
	        if (!currentChild.type) {
	          return currentChild;
	        }
	        switch (currentChild.type.muiName) {
	          case 'DropDownMenu':
	            return _react2.default.cloneElement(currentChild, {
	              style: (0, _simpleAssign2.default)({}, styles.dropDownMenu.root, currentChild.props.style),
	              underlineStyle: styles.dropDownMenu.underline
	            });
	          case 'RaisedButton':
	          case 'FlatButton':
	            return _react2.default.cloneElement(currentChild, {
	              style: (0, _simpleAssign2.default)({}, styles.button, currentChild.props.style)
	            });
	          case 'FontIcon':
	            return _react2.default.cloneElement(currentChild, {
	              style: (0, _simpleAssign2.default)({}, styles.icon.root, currentChild.props.style),
	              color: currentChild.props.color || _this2.context.muiTheme.toolbar.iconColor,
	              hoverColor: currentChild.props.hoverColor || _this2.context.muiTheme.toolbar.hoverColor
	            });
	          case 'ToolbarSeparator':
	          case 'ToolbarTitle':
	            return _react2.default.cloneElement(currentChild, {
	              style: (0, _simpleAssign2.default)({}, styles.span, currentChild.props.style)
	            });
	          default:
	            return currentChild;
	        }
	      }, this);
	
	      return _react2.default.createElement(
	        'div',
	        _extends({}, other, { className: className, style: prepareStyles((0, _simpleAssign2.default)({}, styles.root, style)) }),
	        newChildren
	      );
	    }
	  }]);
	
	  return ToolbarGroup;
	}(_react.Component);
	
	ToolbarGroup.propTypes = {
	  /**
	   * Can be any node or number of nodes.
	   */
	  children: _react.PropTypes.node,
	  /**
	   * The css class name of the root element.
	   */
	  className: _react.PropTypes.string,
	  /**
	   * Set this to true for if the `ToolbarGroup` is the first child of `Toolbar`
	   * to prevent setting the left gap.
	   */
	  firstChild: _react.PropTypes.bool,
	  /**
	   * Set this to true for if the `ToolbarGroup` is the last child of `Toolbar`
	   * to prevent setting the right gap.
	   */
	  lastChild: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object
	};
	ToolbarGroup.defaultProps = {
	  firstChild: false,
	  lastChild: false
	};
	ToolbarGroup.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	exports.default = ToolbarGroup;

/***/ }),
/* 915 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _simpleAssign = __webpack_require__(579);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function getStyles(props, context) {
	  var _context$muiTheme = context.muiTheme;
	  var baseTheme = _context$muiTheme.baseTheme;
	  var toolbar = _context$muiTheme.toolbar;
	
	
	  return {
	    root: {
	      backgroundColor: toolbar.separatorColor,
	      display: 'inline-block',
	      height: baseTheme.spacing.desktopGutterMore,
	      marginLeft: baseTheme.spacing.desktopGutter,
	      position: 'relative',
	      top: (toolbar.height - baseTheme.spacing.desktopGutterMore) / 2,
	      width: 1
	    }
	  };
	}
	
	var ToolbarSeparator = function (_Component) {
	  _inherits(ToolbarSeparator, _Component);
	
	  function ToolbarSeparator() {
	    _classCallCheck(this, ToolbarSeparator);
	
	    return _possibleConstructorReturn(this, Object.getPrototypeOf(ToolbarSeparator).apply(this, arguments));
	  }
	
	  _createClass(ToolbarSeparator, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var className = _props.className;
	      var style = _props.style;
	
	      var other = _objectWithoutProperties(_props, ['className', 'style']);
	
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      return _react2.default.createElement('span', _extends({}, other, { className: className, style: prepareStyles((0, _simpleAssign2.default)({}, styles.root, style)) }));
	    }
	  }]);
	
	  return ToolbarSeparator;
	}(_react.Component);
	
	ToolbarSeparator.muiName = 'ToolbarSeparator';
	ToolbarSeparator.propTypes = {
	  /**
	   * The css class name of the root element.
	   */
	  className: _react.PropTypes.string,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object
	};
	ToolbarSeparator.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	exports.default = ToolbarSeparator;

/***/ }),
/* 916 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _simpleAssign = __webpack_require__(579);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function getStyles(props, context) {
	  var _context$muiTheme = context.muiTheme;
	  var baseTheme = _context$muiTheme.baseTheme;
	  var toolbar = _context$muiTheme.toolbar;
	
	
	  return {
	    root: {
	      paddingRight: baseTheme.spacing.desktopGutterLess,
	      lineHeight: toolbar.height + 'px',
	      fontSize: toolbar.titleFontSize,
	      position: 'relative',
	      textOverflow: 'ellipsis',
	      whiteSpace: 'nowrap',
	      overflow: 'hidden'
	    }
	  };
	}
	
	var ToolbarTitle = function (_Component) {
	  _inherits(ToolbarTitle, _Component);
	
	  function ToolbarTitle() {
	    _classCallCheck(this, ToolbarTitle);
	
	    return _possibleConstructorReturn(this, Object.getPrototypeOf(ToolbarTitle).apply(this, arguments));
	  }
	
	  _createClass(ToolbarTitle, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var className = _props.className;
	      var style = _props.style;
	      var text = _props.text;
	
	      var other = _objectWithoutProperties(_props, ['className', 'style', 'text']);
	
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      return _react2.default.createElement(
	        'span',
	        _extends({}, other, { className: className, style: prepareStyles((0, _simpleAssign2.default)({}, styles.root, style)) }),
	        text
	      );
	    }
	  }]);
	
	  return ToolbarTitle;
	}(_react.Component);
	
	ToolbarTitle.muiName = 'ToolbarTitle';
	ToolbarTitle.propTypes = {
	  /**
	   * The css class name of the root element.
	   */
	  className: _react.PropTypes.string,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object,
	  /**
	   * The text to be displayed.
	   */
	  text: _react.PropTypes.string
	};
	ToolbarTitle.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	exports.default = ToolbarTitle;

/***/ }),
/* 917 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.zIndex = exports.typography = exports.transitions = exports.themeManager = exports.spacing = exports.getMuiTheme = exports.LightRawTheme = exports.lightBaseTheme = exports.DarkRawTheme = exports.darkBaseTheme = exports.colors = exports.MuiThemeProvider = undefined;
	
	var _MuiThemeProvider2 = __webpack_require__(730);
	
	var _MuiThemeProvider3 = _interopRequireDefault(_MuiThemeProvider2);
	
	var _colors2 = __webpack_require__(821);
	
	var _colors = _interopRequireWildcard(_colors2);
	
	var _darkBaseTheme2 = __webpack_require__(918);
	
	var _darkBaseTheme3 = _interopRequireDefault(_darkBaseTheme2);
	
	var _lightBaseTheme2 = __webpack_require__(820);
	
	var _lightBaseTheme3 = _interopRequireDefault(_lightBaseTheme2);
	
	var _getMuiTheme2 = __webpack_require__(731);
	
	var _getMuiTheme3 = _interopRequireDefault(_getMuiTheme2);
	
	var _spacing2 = __webpack_require__(822);
	
	var _spacing3 = _interopRequireDefault(_spacing2);
	
	var _themeManager2 = __webpack_require__(919);
	
	var _themeManager3 = _interopRequireDefault(_themeManager2);
	
	var _transitions2 = __webpack_require__(582);
	
	var _transitions3 = _interopRequireDefault(_transitions2);
	
	var _typography2 = __webpack_require__(859);
	
	var _typography3 = _interopRequireDefault(_typography2);
	
	var _zIndex2 = __webpack_require__(823);
	
	var _zIndex3 = _interopRequireDefault(_zIndex2);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.MuiThemeProvider = _MuiThemeProvider3.default;
	exports.colors = _colors;
	exports.darkBaseTheme = _darkBaseTheme3.default;
	exports.DarkRawTheme = _darkBaseTheme3.default;
	exports.lightBaseTheme = _lightBaseTheme3.default;
	exports.LightRawTheme = _lightBaseTheme3.default;
	exports.getMuiTheme = _getMuiTheme3.default;
	exports.spacing = _spacing3.default;
	exports.themeManager = _themeManager3.default;
	exports.transitions = _transitions3.default;
	exports.typography = _typography3.default;
	exports.zIndex = _zIndex3.default;

/***/ }),
/* 918 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _colors = __webpack_require__(821);
	
	var _colorManipulator = __webpack_require__(623);
	
	var _spacing = __webpack_require__(822);
	
	var _spacing2 = _interopRequireDefault(_spacing);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  spacing: _spacing2.default,
	  fontFamily: 'Roboto, sans-serif',
	  palette: {
	    primary1Color: _colors.cyan700,
	    primary2Color: _colors.cyan700,
	    primary3Color: _colors.grey600,
	    accent1Color: _colors.pinkA200,
	    accent2Color: _colors.pinkA400,
	    accent3Color: _colors.pinkA100,
	    textColor: _colors.fullWhite,
	    secondaryTextColor: (0, _colorManipulator.fade)(_colors.fullWhite, 0.7),
	    alternateTextColor: '#303030',
	    canvasColor: '#303030',
	    borderColor: (0, _colorManipulator.fade)(_colors.fullWhite, 0.3),
	    disabledColor: (0, _colorManipulator.fade)(_colors.fullWhite, 0.3),
	    pickerHeaderColor: (0, _colorManipulator.fade)(_colors.fullWhite, 0.12),
	    clockCircleColor: (0, _colorManipulator.fade)(_colors.fullWhite, 0.12)
	  }
	};

/***/ }),
/* 919 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _merge = __webpack_require__(732);
	
	var _merge2 = _interopRequireDefault(_merge);
	
	var _getMuiTheme2 = __webpack_require__(731);
	
	var _getMuiTheme3 = _interopRequireDefault(_getMuiTheme2);
	
	var _warning = __webpack_require__(491);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  getMuiTheme: function getMuiTheme(baseTheme, muiTheme) {
	     false ? (0, _warning2.default)(false, 'ThemeManager is deprecated. please import getMuiTheme\n        directly from "material-ui/styles/getMuiTheme".\n        It will be removed with v0.16.0.') : void 0;
	    return (0, _getMuiTheme3.default)(baseTheme, muiTheme);
	  },
	  modifyRawThemeSpacing: function modifyRawThemeSpacing(muiTheme, spacing) {
	     false ? (0, _warning2.default)(false, 'modifyRawThemeSpacing is deprecated. please use getMuiTheme\n        to modify your theme directly. http://www.material-ui.com/#/customization/themes.\n        It will be removed with v0.16.0.') : void 0;
	    return (0, _getMuiTheme3.default)((0, _merge2.default)({}, muiTheme.baseTheme, { spacing: spacing }));
	  },
	  modifyRawThemePalette: function modifyRawThemePalette(muiTheme, palette) {
	     false ? (0, _warning2.default)(false, 'modifyRawThemePalette is deprecated. please use getMuiTheme\n        to modify your theme directly. http://www.material-ui.com/#/customization/themes.\n        It will be removed with v0.16.0.') : void 0;
	    return (0, _getMuiTheme3.default)((0, _merge2.default)({}, muiTheme.baseTheme, { baseTheme: { palette: palette } }));
	  },
	  modifyRawThemeFontFamily: function modifyRawThemeFontFamily(muiTheme, fontFamily) {
	     false ? (0, _warning2.default)(false, 'modifyRawThemeFontFamily is deprecated. please use getMuiTheme\n        to modify your theme directly. http://www.material-ui.com/#/customization/themes.\n        It will be removed with v0.16.0.') : void 0;
	    return (0, _getMuiTheme3.default)((0, _merge2.default)({}, muiTheme.baseTheme, { fontFamily: fontFamily }));
	  }
	};

/***/ }),
/* 920 */
/***/ (function(module, exports, __webpack_require__) {

	var assignValue = __webpack_require__(803),
	    copyObject = __webpack_require__(802),
	    createAssigner = __webpack_require__(810),
	    isArrayLike = __webpack_require__(791),
	    isPrototype = __webpack_require__(786),
	    keys = __webpack_require__(921);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Assigns own enumerable string keyed properties of source objects to the
	 * destination object. Source objects are applied from left to right.
	 * Subsequent sources overwrite property assignments of previous sources.
	 *
	 * **Note:** This method mutates `object` and is loosely based on
	 * [`Object.assign`](https://mdn.io/Object/assign).
	 *
	 * @static
	 * @memberOf _
	 * @since 0.10.0
	 * @category Object
	 * @param {Object} object The destination object.
	 * @param {...Object} [sources] The source objects.
	 * @returns {Object} Returns `object`.
	 * @see _.assignIn
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 * }
	 *
	 * function Bar() {
	 *   this.c = 3;
	 * }
	 *
	 * Foo.prototype.b = 2;
	 * Bar.prototype.d = 4;
	 *
	 * _.assign({ 'a': 0 }, new Foo, new Bar);
	 * // => { 'a': 1, 'c': 3 }
	 */
	var assign = createAssigner(function(object, source) {
	  if (isPrototype(source) || isArrayLike(source)) {
	    copyObject(source, keys(source), object);
	    return;
	  }
	  for (var key in source) {
	    if (hasOwnProperty.call(source, key)) {
	      assignValue(object, key, source[key]);
	    }
	  }
	});
	
	module.exports = assign;


/***/ }),
/* 921 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayLikeKeys = __webpack_require__(805),
	    baseKeys = __webpack_require__(922),
	    isArrayLike = __webpack_require__(791);
	
	/**
	 * Creates an array of the own enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects. See the
	 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * for more details.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keys(new Foo);
	 * // => ['a', 'b'] (iteration order is not guaranteed)
	 *
	 * _.keys('hi');
	 * // => ['0', '1']
	 */
	function keys(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	}
	
	module.exports = keys;


/***/ }),
/* 922 */
/***/ (function(module, exports, __webpack_require__) {

	var isPrototype = __webpack_require__(786),
	    nativeKeys = __webpack_require__(923);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeys(object) {
	  if (!isPrototype(object)) {
	    return nativeKeys(object);
	  }
	  var result = [];
	  for (var key in Object(object)) {
	    if (hasOwnProperty.call(object, key) && key != 'constructor') {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = baseKeys;


/***/ }),
/* 923 */
/***/ (function(module, exports, __webpack_require__) {

	var overArg = __webpack_require__(785);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeKeys = overArg(Object.keys, Object);
	
	module.exports = nativeKeys;


/***/ }),
/* 924 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsEqual = __webpack_require__(925);
	
	/**
	 * Performs a deep comparison between two values to determine if they are
	 * equivalent.
	 *
	 * **Note:** This method supports comparing arrays, array buffers, booleans,
	 * date objects, error objects, maps, numbers, `Object` objects, regexes,
	 * sets, strings, symbols, and typed arrays. `Object` objects are compared
	 * by their own, not inherited, enumerable properties. Functions and DOM
	 * nodes are compared by strict equality, i.e. `===`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.isEqual(object, other);
	 * // => true
	 *
	 * object === other;
	 * // => false
	 */
	function isEqual(value, other) {
	  return baseIsEqual(value, other);
	}
	
	module.exports = isEqual;


/***/ }),
/* 925 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsEqualDeep = __webpack_require__(926),
	    isObjectLike = __webpack_require__(655);
	
	/**
	 * The base implementation of `_.isEqual` which supports partial comparisons
	 * and tracks traversed objects.
	 *
	 * @private
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @param {boolean} bitmask The bitmask flags.
	 *  1 - Unordered comparison
	 *  2 - Partial comparison
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 */
	function baseIsEqual(value, other, bitmask, customizer, stack) {
	  if (value === other) {
	    return true;
	  }
	  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
	    return value !== value && other !== other;
	  }
	  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
	}
	
	module.exports = baseIsEqual;


/***/ }),
/* 926 */
/***/ (function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(734),
	    equalArrays = __webpack_require__(927),
	    equalByTag = __webpack_require__(933),
	    equalObjects = __webpack_require__(936),
	    getTag = __webpack_require__(943),
	    isArray = __webpack_require__(789),
	    isBuffer = __webpack_require__(793),
	    isTypedArray = __webpack_require__(796);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    objectTag = '[object Object]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * A specialized version of `baseIsEqual` for arrays and objects which performs
	 * deep comparisons and tracks traversed objects enabling objects with circular
	 * references to be compared.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
	  var objIsArr = isArray(object),
	      othIsArr = isArray(other),
	      objTag = objIsArr ? arrayTag : getTag(object),
	      othTag = othIsArr ? arrayTag : getTag(other);
	
	  objTag = objTag == argsTag ? objectTag : objTag;
	  othTag = othTag == argsTag ? objectTag : othTag;
	
	  var objIsObj = objTag == objectTag,
	      othIsObj = othTag == objectTag,
	      isSameTag = objTag == othTag;
	
	  if (isSameTag && isBuffer(object)) {
	    if (!isBuffer(other)) {
	      return false;
	    }
	    objIsArr = true;
	    objIsObj = false;
	  }
	  if (isSameTag && !objIsObj) {
	    stack || (stack = new Stack);
	    return (objIsArr || isTypedArray(object))
	      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
	      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
	  }
	  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
	    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
	    if (objIsWrapped || othIsWrapped) {
	      var objUnwrapped = objIsWrapped ? object.value() : object,
	          othUnwrapped = othIsWrapped ? other.value() : other;
	
	      stack || (stack = new Stack);
	      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
	    }
	  }
	  if (!isSameTag) {
	    return false;
	  }
	  stack || (stack = new Stack);
	  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
	}
	
	module.exports = baseIsEqualDeep;


/***/ }),
/* 927 */
/***/ (function(module, exports, __webpack_require__) {

	var SetCache = __webpack_require__(928),
	    arraySome = __webpack_require__(931),
	    cacheHas = __webpack_require__(932);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for arrays with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Array} array The array to compare.
	 * @param {Array} other The other array to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `array` and `other` objects.
	 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	 */
	function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
	  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	      arrLength = array.length,
	      othLength = other.length;
	
	  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
	    return false;
	  }
	  // Check that cyclic values are equal.
	  var arrStacked = stack.get(array);
	  var othStacked = stack.get(other);
	  if (arrStacked && othStacked) {
	    return arrStacked == other && othStacked == array;
	  }
	  var index = -1,
	      result = true,
	      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;
	
	  stack.set(array, other);
	  stack.set(other, array);
	
	  // Ignore non-index properties.
	  while (++index < arrLength) {
	    var arrValue = array[index],
	        othValue = other[index];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, arrValue, index, other, array, stack)
	        : customizer(arrValue, othValue, index, array, other, stack);
	    }
	    if (compared !== undefined) {
	      if (compared) {
	        continue;
	      }
	      result = false;
	      break;
	    }
	    // Recursively compare arrays (susceptible to call stack limits).
	    if (seen) {
	      if (!arraySome(other, function(othValue, othIndex) {
	            if (!cacheHas(seen, othIndex) &&
	                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
	              return seen.push(othIndex);
	            }
	          })) {
	        result = false;
	        break;
	      }
	    } else if (!(
	          arrValue === othValue ||
	            equalFunc(arrValue, othValue, bitmask, customizer, stack)
	        )) {
	      result = false;
	      break;
	    }
	  }
	  stack['delete'](array);
	  stack['delete'](other);
	  return result;
	}
	
	module.exports = equalArrays;


/***/ }),
/* 928 */
/***/ (function(module, exports, __webpack_require__) {

	var MapCache = __webpack_require__(756),
	    setCacheAdd = __webpack_require__(929),
	    setCacheHas = __webpack_require__(930);
	
	/**
	 *
	 * Creates an array cache object to store unique values.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [values] The values to cache.
	 */
	function SetCache(values) {
	  var index = -1,
	      length = values == null ? 0 : values.length;
	
	  this.__data__ = new MapCache;
	  while (++index < length) {
	    this.add(values[index]);
	  }
	}
	
	// Add methods to `SetCache`.
	SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
	SetCache.prototype.has = setCacheHas;
	
	module.exports = SetCache;


/***/ }),
/* 929 */
/***/ (function(module, exports) {

	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/**
	 * Adds `value` to the array cache.
	 *
	 * @private
	 * @name add
	 * @memberOf SetCache
	 * @alias push
	 * @param {*} value The value to cache.
	 * @returns {Object} Returns the cache instance.
	 */
	function setCacheAdd(value) {
	  this.__data__.set(value, HASH_UNDEFINED);
	  return this;
	}
	
	module.exports = setCacheAdd;


/***/ }),
/* 930 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is in the array cache.
	 *
	 * @private
	 * @name has
	 * @memberOf SetCache
	 * @param {*} value The value to search for.
	 * @returns {number} Returns `true` if `value` is found, else `false`.
	 */
	function setCacheHas(value) {
	  return this.__data__.has(value);
	}
	
	module.exports = setCacheHas;


/***/ }),
/* 931 */
/***/ (function(module, exports) {

	/**
	 * A specialized version of `_.some` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {boolean} Returns `true` if any element passes the predicate check,
	 *  else `false`.
	 */
	function arraySome(array, predicate) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  while (++index < length) {
	    if (predicate(array[index], index, array)) {
	      return true;
	    }
	  }
	  return false;
	}
	
	module.exports = arraySome;


/***/ }),
/* 932 */
/***/ (function(module, exports) {

	/**
	 * Checks if a `cache` value for `key` exists.
	 *
	 * @private
	 * @param {Object} cache The cache to query.
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function cacheHas(cache, key) {
	  return cache.has(key);
	}
	
	module.exports = cacheHas;


/***/ }),
/* 933 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(652),
	    Uint8Array = __webpack_require__(780),
	    eq = __webpack_require__(739),
	    equalArrays = __webpack_require__(927),
	    mapToArray = __webpack_require__(934),
	    setToArray = __webpack_require__(935);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/** `Object#toString` result references. */
	var boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]';
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for comparing objects of
	 * the same `toStringTag`.
	 *
	 * **Note:** This function only supports comparing values with tags of
	 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {string} tag The `toStringTag` of the objects to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
	  switch (tag) {
	    case dataViewTag:
	      if ((object.byteLength != other.byteLength) ||
	          (object.byteOffset != other.byteOffset)) {
	        return false;
	      }
	      object = object.buffer;
	      other = other.buffer;
	
	    case arrayBufferTag:
	      if ((object.byteLength != other.byteLength) ||
	          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
	        return false;
	      }
	      return true;
	
	    case boolTag:
	    case dateTag:
	    case numberTag:
	      // Coerce booleans to `1` or `0` and dates to milliseconds.
	      // Invalid dates are coerced to `NaN`.
	      return eq(+object, +other);
	
	    case errorTag:
	      return object.name == other.name && object.message == other.message;
	
	    case regexpTag:
	    case stringTag:
	      // Coerce regexes to strings and treat strings, primitives and objects,
	      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
	      // for more details.
	      return object == (other + '');
	
	    case mapTag:
	      var convert = mapToArray;
	
	    case setTag:
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
	      convert || (convert = setToArray);
	
	      if (object.size != other.size && !isPartial) {
	        return false;
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(object);
	      if (stacked) {
	        return stacked == other;
	      }
	      bitmask |= COMPARE_UNORDERED_FLAG;
	
	      // Recursively compare objects (susceptible to call stack limits).
	      stack.set(object, other);
	      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
	      stack['delete'](object);
	      return result;
	
	    case symbolTag:
	      if (symbolValueOf) {
	        return symbolValueOf.call(object) == symbolValueOf.call(other);
	      }
	  }
	  return false;
	}
	
	module.exports = equalByTag;


/***/ }),
/* 934 */
/***/ (function(module, exports) {

	/**
	 * Converts `map` to its key-value pairs.
	 *
	 * @private
	 * @param {Object} map The map to convert.
	 * @returns {Array} Returns the key-value pairs.
	 */
	function mapToArray(map) {
	  var index = -1,
	      result = Array(map.size);
	
	  map.forEach(function(value, key) {
	    result[++index] = [key, value];
	  });
	  return result;
	}
	
	module.exports = mapToArray;


/***/ }),
/* 935 */
/***/ (function(module, exports) {

	/**
	 * Converts `set` to an array of its values.
	 *
	 * @private
	 * @param {Object} set The set to convert.
	 * @returns {Array} Returns the values.
	 */
	function setToArray(set) {
	  var index = -1,
	      result = Array(set.size);
	
	  set.forEach(function(value) {
	    result[++index] = value;
	  });
	  return result;
	}
	
	module.exports = setToArray;


/***/ }),
/* 936 */
/***/ (function(module, exports, __webpack_require__) {

	var getAllKeys = __webpack_require__(937);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1;
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for objects with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
	  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	      objProps = getAllKeys(object),
	      objLength = objProps.length,
	      othProps = getAllKeys(other),
	      othLength = othProps.length;
	
	  if (objLength != othLength && !isPartial) {
	    return false;
	  }
	  var index = objLength;
	  while (index--) {
	    var key = objProps[index];
	    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
	      return false;
	    }
	  }
	  // Check that cyclic values are equal.
	  var objStacked = stack.get(object);
	  var othStacked = stack.get(other);
	  if (objStacked && othStacked) {
	    return objStacked == other && othStacked == object;
	  }
	  var result = true;
	  stack.set(object, other);
	  stack.set(other, object);
	
	  var skipCtor = isPartial;
	  while (++index < objLength) {
	    key = objProps[index];
	    var objValue = object[key],
	        othValue = other[key];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, objValue, key, other, object, stack)
	        : customizer(objValue, othValue, key, object, other, stack);
	    }
	    // Recursively compare objects (susceptible to call stack limits).
	    if (!(compared === undefined
	          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
	          : compared
	        )) {
	      result = false;
	      break;
	    }
	    skipCtor || (skipCtor = key == 'constructor');
	  }
	  if (result && !skipCtor) {
	    var objCtor = object.constructor,
	        othCtor = other.constructor;
	
	    // Non `Object` object instances with different constructors are not equal.
	    if (objCtor != othCtor &&
	        ('constructor' in object && 'constructor' in other) &&
	        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	      result = false;
	    }
	  }
	  stack['delete'](object);
	  stack['delete'](other);
	  return result;
	}
	
	module.exports = equalObjects;


/***/ }),
/* 937 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetAllKeys = __webpack_require__(938),
	    getSymbols = __webpack_require__(940),
	    keys = __webpack_require__(921);
	
	/**
	 * Creates an array of own enumerable property names and symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function getAllKeys(object) {
	  return baseGetAllKeys(object, keys, getSymbols);
	}
	
	module.exports = getAllKeys;


/***/ }),
/* 938 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayPush = __webpack_require__(939),
	    isArray = __webpack_require__(789);
	
	/**
	 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
	 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
	 * symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @param {Function} symbolsFunc The function to get the symbols of `object`.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function baseGetAllKeys(object, keysFunc, symbolsFunc) {
	  var result = keysFunc(object);
	  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
	}
	
	module.exports = baseGetAllKeys;


/***/ }),
/* 939 */
/***/ (function(module, exports) {

	/**
	 * Appends the elements of `values` to `array`.
	 *
	 * @private
	 * @param {Array} array The array to modify.
	 * @param {Array} values The values to append.
	 * @returns {Array} Returns `array`.
	 */
	function arrayPush(array, values) {
	  var index = -1,
	      length = values.length,
	      offset = array.length;
	
	  while (++index < length) {
	    array[offset + index] = values[index];
	  }
	  return array;
	}
	
	module.exports = arrayPush;


/***/ }),
/* 940 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayFilter = __webpack_require__(941),
	    stubArray = __webpack_require__(942);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeGetSymbols = Object.getOwnPropertySymbols;
	
	/**
	 * Creates an array of the own enumerable symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of symbols.
	 */
	var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
	  if (object == null) {
	    return [];
	  }
	  object = Object(object);
	  return arrayFilter(nativeGetSymbols(object), function(symbol) {
	    return propertyIsEnumerable.call(object, symbol);
	  });
	};
	
	module.exports = getSymbols;


/***/ }),
/* 941 */
/***/ (function(module, exports) {

	/**
	 * A specialized version of `_.filter` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {Array} Returns the new filtered array.
	 */
	function arrayFilter(array, predicate) {
	  var index = -1,
	      length = array == null ? 0 : array.length,
	      resIndex = 0,
	      result = [];
	
	  while (++index < length) {
	    var value = array[index];
	    if (predicate(value, index, array)) {
	      result[resIndex++] = value;
	    }
	  }
	  return result;
	}
	
	module.exports = arrayFilter;


/***/ }),
/* 942 */
/***/ (function(module, exports) {

	/**
	 * This method returns a new empty array.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {Array} Returns the new empty array.
	 * @example
	 *
	 * var arrays = _.times(2, _.stubArray);
	 *
	 * console.log(arrays);
	 * // => [[], []]
	 *
	 * console.log(arrays[0] === arrays[1]);
	 * // => false
	 */
	function stubArray() {
	  return [];
	}
	
	module.exports = stubArray;


/***/ }),
/* 943 */
/***/ (function(module, exports, __webpack_require__) {

	var DataView = __webpack_require__(944),
	    Map = __webpack_require__(748),
	    Promise = __webpack_require__(945),
	    Set = __webpack_require__(946),
	    WeakMap = __webpack_require__(947),
	    baseGetTag = __webpack_require__(651),
	    toSource = __webpack_require__(754);
	
	/** `Object#toString` result references. */
	var mapTag = '[object Map]',
	    objectTag = '[object Object]',
	    promiseTag = '[object Promise]',
	    setTag = '[object Set]',
	    weakMapTag = '[object WeakMap]';
	
	var dataViewTag = '[object DataView]';
	
	/** Used to detect maps, sets, and weakmaps. */
	var dataViewCtorString = toSource(DataView),
	    mapCtorString = toSource(Map),
	    promiseCtorString = toSource(Promise),
	    setCtorString = toSource(Set),
	    weakMapCtorString = toSource(WeakMap);
	
	/**
	 * Gets the `toStringTag` of `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	var getTag = baseGetTag;
	
	// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
	if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	    (Map && getTag(new Map) != mapTag) ||
	    (Promise && getTag(Promise.resolve()) != promiseTag) ||
	    (Set && getTag(new Set) != setTag) ||
	    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	  getTag = function(value) {
	    var result = baseGetTag(value),
	        Ctor = result == objectTag ? value.constructor : undefined,
	        ctorString = Ctor ? toSource(Ctor) : '';
	
	    if (ctorString) {
	      switch (ctorString) {
	        case dataViewCtorString: return dataViewTag;
	        case mapCtorString: return mapTag;
	        case promiseCtorString: return promiseTag;
	        case setCtorString: return setTag;
	        case weakMapCtorString: return weakMapTag;
	      }
	    }
	    return result;
	  };
	}
	
	module.exports = getTag;


/***/ }),
/* 944 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(749),
	    root = __webpack_require__(645);
	
	/* Built-in method references that are verified to be native. */
	var DataView = getNative(root, 'DataView');
	
	module.exports = DataView;


/***/ }),
/* 945 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(749),
	    root = __webpack_require__(645);
	
	/* Built-in method references that are verified to be native. */
	var Promise = getNative(root, 'Promise');
	
	module.exports = Promise;


/***/ }),
/* 946 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(749),
	    root = __webpack_require__(645);
	
	/* Built-in method references that are verified to be native. */
	var Set = getNative(root, 'Set');
	
	module.exports = Set;


/***/ }),
/* 947 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(749),
	    root = __webpack_require__(645);
	
	/* Built-in method references that are verified to be native. */
	var WeakMap = getNative(root, 'WeakMap');
	
	module.exports = WeakMap;


/***/ }),
/* 948 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(608);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(615);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AlertError = function AlertError(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z' })
	  );
	};
	AlertError = (0, _pure2.default)(AlertError);
	AlertError.displayName = 'AlertError';
	AlertError.muiName = 'SvgIcon';
	
	exports.default = AlertError;

/***/ }),
/* 949 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ClearFix = __webpack_require__(717);
	
	var _ClearFix2 = _interopRequireDefault(_ClearFix);
	
	var _withWidth = __webpack_require__(886);
	
	var _withWidth2 = _interopRequireDefault(_withWidth);
	
	var _styles = __webpack_require__(917);
	
	var _assign = __webpack_require__(920);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; } /* https://github.com/callemall/material-ui/blob/master/docs/src/app/components/full-width-section.jsx */
	
	var DesktopGutter = _styles.spacing.desktopGutter;
	
	var FullWidthSection = _react2.default.createClass({
	  displayName: "FullWidthSection",
	
	  propTypes: {
	    useContent: _react2.default.PropTypes.bool,
	    contentType: _react2.default.PropTypes.string,
	    contentStyle: _react2.default.PropTypes.object
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      useContent: false,
	      contentType: "div"
	    };
	  },
	
	  getStyles: function getStyles() {
	    return {
	      root: {
	        padding: DesktopGutter + "px",
	        boxSizing: "border-box"
	      },
	      content: {
	        maxWidth: "1200px",
	        margin: "0 auto"
	      },
	      rootWhenSmall: {
	        paddingTop: DesktopGutter * 2 + "px",
	        paddingBottom: DesktopGutter * 2 + "px"
	      },
	      rootWhenMedium: {
	        paddingTop: DesktopGutter * 3 + "px",
	        paddingBottom: DesktopGutter * 3 + "px"
	      }
	    };
	  },
	
	  render: function render() {
	    var _props = this.props;
	    var style = _props.style;
	    var useContent = _props.useContent;
	    var contentType = _props.contentType;
	    var contentStyle = _props.contentStyle;
	
	    var other = _objectWithoutProperties(_props, ["style", "useContent", "contentType", "contentStyle"]);
	
	    var styles = this.getStyles();
	
	    var content;
	    if (useContent) {
	      content = _react2.default.createElement(contentType, { style: (0, _assign2.default)({}, styles.content, contentStyle) }, this.props.children);
	    } else {
	      content = this.props.children;
	    }
	
	    return _react2.default.createElement(
	      _ClearFix2.default,
	      _extends({}, other, {
	        style: (0, _assign2.default)({}, styles.root, style, this.props.width === _withWidth.SMALL ? styles.rootWhenSmall : styles.rootWhenMedium)
	      }),
	      content
	    );
	  }
	});
	
	exports.default = (0, _withWidth2.default)()(FullWidthSection);
	module.exports = exports["default"];

/***/ }),
/* 950 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(486);
	
	var _materialUi = __webpack_require__(576);
	
	var _exitToApp = __webpack_require__(951);
	
	var _exitToApp2 = _interopRequireDefault(_exitToApp);
	
	var _godModeControl = __webpack_require__(952);
	
	var _godModeControl2 = _interopRequireDefault(_godModeControl);
	
	var _connectToStores = __webpack_require__(1226);
	
	var _connectToStores2 = _interopRequireDefault(_connectToStores);
	
	var _UserStore = __webpack_require__(974);
	
	var _UserStore2 = _interopRequireDefault(_UserStore);
	
	var _UserActions = __webpack_require__(1158);
	
	var _UserActions2 = _interopRequireDefault(_UserActions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AccountAppBarItem = function (_React$Component) {
	  _inherits(AccountAppBarItem, _React$Component);
	
	  function AccountAppBarItem(props) {
	    _classCallCheck(this, AccountAppBarItem);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(AccountAppBarItem).call(this, props));
	
	    _this.manage = _this.manage.bind(_this);
	    return _this;
	  }
	
	  _createClass(AccountAppBarItem, [{
	    key: "logout",
	    value: function logout(e) {
	      e.preventDefault();
	      e.stopPropagation();
	      _UserActions2.default.logout();
	    }
	  }, {
	    key: "manage",
	    value: function manage() {
	      this.context.router.push("/account");
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var el = void 0;
	      var _props = this.props;
	      var isLoggedIn = _props.isLoggedIn;
	      var data = _props.data;
	      var condensedUsers = _props.condensedUsers;
	      var activeGodUser = _props.activeGodUser;
	      var activeGodRole = _props.activeGodRole;
	      var roles = _props.roles;
	      var godStealthMode = _props.godStealthMode;
	      var compact = _props.compact;
	
	
	      if (!isLoggedIn || !data) {
	        return _react2.default.createElement(
	          "div",
	          { style: { marginRight: 7 } },
	          _react2.default.createElement(
	            _reactRouter.Link,
	            { to: "/login" },
	            _react2.default.createElement(_materialUi.FlatButton, { label: compact ? "Login" : "Login to your account" })
	          )
	        );
	      }
	
	      if (data.god) {
	        el = _react2.default.createElement(_godModeControl2.default, {
	          style: { display: "inline-block" },
	          condensedUsers: condensedUsers,
	          activeGodUser: activeGodUser,
	          activeGodRole: activeGodRole,
	          roles: roles,
	          godStealthMode: godStealthMode
	        });
	      } else {
	        el = !compact && _react2.default.createElement(
	          "div",
	          {
	            style: {
	              display: "inline-block",
	              fontSize: 14,
	              color: "#fff",
	              lineHeight: 1.2,
	              marginTop: 3,
	              cursor: "pointer",
	              marginRight: 10
	            },
	            onTouchTap: this.manage
	          },
	          _react2.default.createElement(
	            "div",
	            { style: { fontWeight: "bold" } },
	            data.owner && data.owner.organization
	          ),
	          _react2.default.createElement(
	            "div",
	            null,
	            data.name || data.email
	          )
	        );
	      }
	
	      return _react2.default.createElement(
	        "div",
	        { style: { marginTop: -5, display: "flex", alignItems: "center" } },
	        el,
	        _react2.default.createElement(
	          _materialUi.IconButton,
	          {
	            tooltip: "Log out",
	            onTouchTap: this.logout,
	            style: data.god && { verticalAlign: 5 }
	          },
	          _react2.default.createElement(_exitToApp2.default, { color: "#fff" })
	        )
	      );
	    }
	  }], [{
	    key: "getStores",
	    value: function getStores() {
	      return [_UserStore2.default];
	    }
	  }, {
	    key: "getPropsFromStores",
	    value: function getPropsFromStores() {
	      return _UserStore2.default.getState();
	    }
	  }]);
	
	  return AccountAppBarItem;
	}(_react2.default.Component);
	
	AccountAppBarItem.contextTypes = {
	  router: _react2.default.PropTypes.object,
	  isLarge: _react2.default.PropTypes.bool
	};
	exports.default = (0, _connectToStores2.default)(AccountAppBarItem);
	module.exports = exports["default"];

/***/ }),
/* 951 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(608);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(615);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionExitToApp = function ActionExitToApp(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M10.09 15.59L11.5 17l5-5-5-5-1.41 1.41L12.67 11H3v2h9.67l-2.58 2.59zM19 3H5c-1.11 0-2 .9-2 2v4h2V5h14v14H5v-4H3v4c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z' })
	  );
	};
	ActionExitToApp = (0, _pure2.default)(ActionExitToApp);
	ActionExitToApp.displayName = 'ActionExitToApp';
	ActionExitToApp.muiName = 'SvgIcon';
	
	exports.default = ActionExitToApp;

/***/ }),
/* 952 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactSelect = __webpack_require__(953);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	var _copyToClipboard = __webpack_require__(971);
	
	var _copyToClipboard2 = _interopRequireDefault(_copyToClipboard);
	
	var _linkLike = __webpack_require__(973);
	
	var _linkLike2 = _interopRequireDefault(_linkLike);
	
	var _UserStore = __webpack_require__(974);
	
	var _UserStore2 = _interopRequireDefault(_UserStore);
	
	var _UserActions = __webpack_require__(1158);
	
	var _UserActions2 = _interopRequireDefault(_UserActions);
	
	var _inlineNoticeLabel = __webpack_require__(1222);
	
	var _inlineNoticeLabel2 = _interopRequireDefault(_inlineNoticeLabel);
	
	var _materialUi = __webpack_require__(576);
	
	var _permIdentity = __webpack_require__(1223);
	
	var _permIdentity2 = _interopRequireDefault(_permIdentity);
	
	var _supervisorAccount = __webpack_require__(1224);
	
	var _supervisorAccount2 = _interopRequireDefault(_supervisorAccount);
	
	var _contentCopy = __webpack_require__(1225);
	
	var _contentCopy2 = _interopRequireDefault(_contentCopy);
	
	var _GlobalNotificationActions = __webpack_require__(1182);
	
	var _GlobalNotificationActions2 = _interopRequireDefault(_GlobalNotificationActions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var GodModeControl = function (_React$PureComponent) {
	  _inherits(GodModeControl, _React$PureComponent);
	
	  function GodModeControl(props) {
	    _classCallCheck(this, GodModeControl);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(GodModeControl).call(this, props));
	
	    _this.setUser = _this.setUser.bind(_this);
	    _this.copyLink = _this.copyLink.bind(_this);
	    return _this;
	  }
	
	  _createClass(GodModeControl, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      _UserActions2.default.fetchRoles.defer();
	    }
	  }, {
	    key: "setUser",
	    value: function setUser(id) {
	      var _this2 = this;
	
	      if (!id) {
	        return;
	      }
	
	      // If the current URL looks like it has an ID in it (e.g. event_buckets/xxxxx), redirect
	      // back to the welcome screen. If not and it's a generic page (e.g. billing hub),
	      // keep the user on the page even when changing accounts.
	      var currentPath = window.location.pathname;
	      if (currentPath.match(/[a-f\d]{24}/i)) {
	        this.context.router.push("/welcome");
	      } else {
	        this.context.router.push("/blank");
	        setTimeout(function () {
	          return _this2.context.router.push(currentPath);
	        }, 50);
	      }
	
	      _UserActions2.default.setGodUser(id);
	    }
	  }, {
	    key: "copyLink",
	    value: function copyLink() {
	      var url = new URL(window.location.href);
	      url.searchParams.append("_god_become_user", this.props.activeGodUser);
	      (0, _copyToClipboard2.default)(url.toString());
	      _GlobalNotificationActions2.default.notify.defer("God one-click link copied successfully!");
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this3 = this;
	
	      var _props = this.props;
	      var condensedUsers = _props.condensedUsers;
	      var activeGodUser = _props.activeGodUser;
	      var activeGodRole = _props.activeGodRole;
	      var roles = _props.roles;
	      var godStealthMode = _props.godStealthMode;
	      var style = _props.style;
	
	
	      return _react2.default.createElement(
	        "div",
	        {
	          style: Object.assign({}, style, {
	            width: "auto",
	            display: "inline-flex",
	            alignItems: "center"
	          })
	        },
	        !godStealthMode ? _react2.default.createElement(
	          _materialUi.IconButton,
	          {
	            tooltip: "Copy one-click link",
	            onTouchTap: function onTouchTap() {
	              return _this3.copyLink();
	            },
	            style: { marginRight: -10 },
	            iconStyle: { transform: "scale(0.8)" }
	          },
	          _react2.default.createElement(_contentCopy2.default, { color: "#fff" })
	        ) : null,
	        _react2.default.createElement(
	          _materialUi.IconButton,
	          {
	            tooltip: godStealthMode ? "Disable stealth mode" : "Enable stealth mode",
	            onTouchTap: function onTouchTap() {
	              return _UserActions2.default.godSetStealthMode(!godStealthMode);
	            },
	            style: { marginRight: 5 }
	          },
	          godStealthMode ? _react2.default.createElement(_permIdentity2.default, { color: "#fff" }) : _react2.default.createElement(_supervisorAccount2.default, { color: "#fff" })
	        ),
	        _react2.default.createElement(
	          "div",
	          { style: { flex: 1 } },
	          godStealthMode ? _react2.default.createElement(
	            "div",
	            {
	              style: {
	                fontWeight: "bold",
	                color: "#fff",
	                flex: 1,
	                textAlign: "left",
	                fontSize: "1.1em",
	                marginRight: 5
	              }
	            },
	            _react2.default.createElement(
	              "div",
	              null,
	              condensedUsers.find(function (user) {
	                return activeGodUser === user.id;
	              }) ? condensedUsers.find(function (user) {
	                return activeGodUser === user.id;
	              }).organization : "Unknown"
	            ),
	            _react2.default.createElement(
	              "select",
	              {
	                style: {
	                  fontSize: "0.8em",
	                  marginTop: 4,
	                  backgroundColor: "transparent",
	                  color: "#fff",
	                  border: "1px solid #fff",
	                  borderRadius: 5
	                },
	                value: activeGodRole || "admin",
	                onChange: function onChange(e) {
	                  _UserActions2.default.setGodRole(e.target.value);
	                }
	              },
	              roles && Object.keys(roles).map(function (k) {
	                return _react2.default.createElement(
	                  "option",
	                  { key: k, value: k },
	                  roles[k].label
	                );
	              })
	            )
	          ) : _react2.default.createElement(_reactSelect2.default, {
	            style: { minWidth: 220 },
	            clearable: false,
	            tabIndex: "-1",
	            value: activeGodUser,
	            noResultsText: "Type to search...",
	            filterOption: function filterOption(o, f) {
	              return f.length > 2 && o._raw.indexOf((f || "").trim().toLowerCase()) !== -1;
	            },
	            options: condensedUsers.map(function (user) {
	              return {
	                _type: user.type || "festival_organizer",
	                _raw: (user.organization || "").toLowerCase(),
	                label: _react2.default.createElement(
	                  "span",
	                  null,
	                  user.organization,
	                  " ",
	                  user.type === "content_creator" ? _react2.default.createElement(_inlineNoticeLabel2.default, {
	                    style: { whiteSpace: "nowrap" },
	                    label: "Content Creator"
	                  }) : null
	                ),
	                value: user.id
	              };
	            }).sort(function (a, b) {
	              return -a._type.localeCompare(b._type) || a._raw.localeCompare(b._raw);
	            }),
	            onChange: function onChange(e) {
	              return _this3.setUser(e.value);
	            }
	          })
	        )
	      );
	    }
	  }]);
	
	  return GodModeControl;
	}(_react2.default.PureComponent);
	
	GodModeControl.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	exports.default = GodModeControl;
	module.exports = exports["default"];

/***/ }),
/* 953 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.defaultFilterOptions = exports.defaultClearRenderer = exports.defaultArrowRenderer = exports.defaultMenuRenderer = exports.Option = exports.Value = exports.Creatable = exports.AsyncCreatable = exports.Async = undefined;
	
	var _Select = __webpack_require__(954);
	
	var _Select2 = _interopRequireDefault(_Select);
	
	var _Async = __webpack_require__(968);
	
	var _Async2 = _interopRequireDefault(_Async);
	
	var _AsyncCreatable = __webpack_require__(969);
	
	var _AsyncCreatable2 = _interopRequireDefault(_AsyncCreatable);
	
	var _Creatable = __webpack_require__(970);
	
	var _Creatable2 = _interopRequireDefault(_Creatable);
	
	var _Value = __webpack_require__(967);
	
	var _Value2 = _interopRequireDefault(_Value);
	
	var _Option = __webpack_require__(965);
	
	var _Option2 = _interopRequireDefault(_Option);
	
	var _defaultMenuRenderer = __webpack_require__(964);
	
	var _defaultMenuRenderer2 = _interopRequireDefault(_defaultMenuRenderer);
	
	var _defaultArrowRenderer = __webpack_require__(959);
	
	var _defaultArrowRenderer2 = _interopRequireDefault(_defaultArrowRenderer);
	
	var _defaultClearRenderer = __webpack_require__(960);
	
	var _defaultClearRenderer2 = _interopRequireDefault(_defaultClearRenderer);
	
	var _defaultFilterOptions = __webpack_require__(961);
	
	var _defaultFilterOptions2 = _interopRequireDefault(_defaultFilterOptions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_Select2.default.Async = _Async2.default;
	_Select2.default.AsyncCreatable = _AsyncCreatable2.default;
	_Select2.default.Creatable = _Creatable2.default;
	_Select2.default.Value = _Value2.default;
	_Select2.default.Option = _Option2.default;
	
	exports.default = _Select2.default;
	exports.Async = _Async2.default;
	exports.AsyncCreatable = _AsyncCreatable2.default;
	exports.Creatable = _Creatable2.default;
	exports.Value = _Value2.default;
	exports.Option = _Option2.default;
	exports.defaultMenuRenderer = _defaultMenuRenderer2.default;
	exports.defaultArrowRenderer = _defaultArrowRenderer2.default;
	exports.defaultClearRenderer = _defaultClearRenderer2.default;
	exports.defaultFilterOptions = _defaultFilterOptions2.default;

/***/ }),
/* 954 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; /*!
	                                                                                                                                                                                                                                                                                Copyright (c) 2018 Jed Watson.
	                                                                                                                                                                                                                                                                                Licensed under the MIT License (MIT), see
	                                                                                                                                                                                                                                                                                http://jedwatson.github.io/react-select
	                                                                                                                                                                                                                                                                              */
	
	
	var _reactInputAutosize = __webpack_require__(955);
	
	var _reactInputAutosize2 = _interopRequireDefault(_reactInputAutosize);
	
	var _classnames = __webpack_require__(958);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(956);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(332);
	
	var _defaultArrowRenderer = __webpack_require__(959);
	
	var _defaultArrowRenderer2 = _interopRequireDefault(_defaultArrowRenderer);
	
	var _defaultClearRenderer = __webpack_require__(960);
	
	var _defaultClearRenderer2 = _interopRequireDefault(_defaultClearRenderer);
	
	var _defaultFilterOptions = __webpack_require__(961);
	
	var _defaultFilterOptions2 = _interopRequireDefault(_defaultFilterOptions);
	
	var _defaultMenuRenderer = __webpack_require__(964);
	
	var _defaultMenuRenderer2 = _interopRequireDefault(_defaultMenuRenderer);
	
	var _Option = __webpack_require__(965);
	
	var _Option2 = _interopRequireDefault(_Option);
	
	var _Value = __webpack_require__(967);
	
	var _Value2 = _interopRequireDefault(_Value);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var stringifyValue = function stringifyValue(value) {
		return typeof value === 'string' ? value : value !== null && JSON.stringify(value) || '';
	};
	
	var stringOrNode = _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node]);
	var stringOrNumber = _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]);
	
	var instanceId = 1;
	
	var shouldShowValue = function shouldShowValue(state, props) {
		var inputValue = state.inputValue,
		    isPseudoFocused = state.isPseudoFocused,
		    isFocused = state.isFocused;
		var onSelectResetsInput = props.onSelectResetsInput;
	
	
		if (!inputValue) return true;
	
		if (!onSelectResetsInput) {
			return !(!isFocused && isPseudoFocused || isFocused && !isPseudoFocused);
		}
	
		return false;
	};
	
	var shouldShowPlaceholder = function shouldShowPlaceholder(state, props, isOpen) {
		var inputValue = state.inputValue,
		    isPseudoFocused = state.isPseudoFocused,
		    isFocused = state.isFocused;
		var onSelectResetsInput = props.onSelectResetsInput;
	
	
		return !inputValue || !onSelectResetsInput && !isOpen && !isPseudoFocused && !isFocused;
	};
	
	/**
	 * Retrieve a value from the given options and valueKey
	 * @param {String|Number|Array} value	- the selected value(s)
	 * @param {Object}		 props	- the Select component's props (or nextProps)
	 */
	var expandValue = function expandValue(value, props) {
		var valueType = typeof value === 'undefined' ? 'undefined' : _typeof(value);
		if (valueType !== 'string' && valueType !== 'number' && valueType !== 'boolean') return value;
		var options = props.options,
		    valueKey = props.valueKey;
	
		if (!options) return;
		for (var i = 0; i < options.length; i++) {
			if (String(options[i][valueKey]) === String(value)) return options[i];
		}
	};
	
	var handleRequired = function handleRequired(value, multi) {
		if (!value) return true;
		return multi ? value.length === 0 : Object.keys(value).length === 0;
	};
	
	var Select = function (_React$Component) {
		_inherits(Select, _React$Component);
	
		function Select(props) {
			_classCallCheck(this, Select);
	
			var _this = _possibleConstructorReturn(this, (Select.__proto__ || Object.getPrototypeOf(Select)).call(this, props));
	
			['clearValue', 'focusOption', 'getOptionLabel', 'handleInputBlur', 'handleInputChange', 'handleInputFocus', 'handleInputValueChange', 'handleKeyDown', 'handleMenuScroll', 'handleMouseDown', 'handleMouseDownOnArrow', 'handleMouseDownOnMenu', 'handleTouchEnd', 'handleTouchEndClearValue', 'handleTouchMove', 'handleTouchOutside', 'handleTouchStart', 'handleValueClick', 'onOptionRef', 'removeValue', 'selectValue'].forEach(function (fn) {
				return _this[fn] = _this[fn].bind(_this);
			});
	
			_this.state = {
				inputValue: '',
				isFocused: false,
				isOpen: false,
				isPseudoFocused: false,
				required: false
			};
			return _this;
		}
	
		_createClass(Select, [{
			key: 'componentWillMount',
			value: function componentWillMount() {
				this._instancePrefix = 'react-select-' + (this.props.instanceId || ++instanceId) + '-';
				var valueArray = this.getValueArray(this.props.value);
	
				if (this.props.required) {
					this.setState({
						required: handleRequired(valueArray[0], this.props.multi)
					});
				}
			}
		}, {
			key: 'componentDidMount',
			value: function componentDidMount() {
				if (typeof this.props.autofocus !== 'undefined' && typeof console !== 'undefined') {
					console.warn('Warning: The autofocus prop has changed to autoFocus, support will be removed after react-select@1.0');
				}
				if (this.props.autoFocus || this.props.autofocus) {
					this.focus();
				}
			}
		}, {
			key: 'componentWillReceiveProps',
			value: function componentWillReceiveProps(nextProps) {
				var valueArray = this.getValueArray(nextProps.value, nextProps);
	
				if (nextProps.required) {
					this.setState({
						required: handleRequired(valueArray[0], nextProps.multi)
					});
				} else if (this.props.required) {
					// Used to be required but it's not any more
					this.setState({ required: false });
				}
	
				if (this.state.inputValue && this.props.value !== nextProps.value && nextProps.onSelectResetsInput) {
					this.setState({ inputValue: this.handleInputValueChange('') });
				}
			}
		}, {
			key: 'componentDidUpdate',
			value: function componentDidUpdate(prevProps, prevState) {
				// focus to the selected option
				if (this.menu && this.focused && this.state.isOpen && !this.hasScrolledToOption) {
					var focusedOptionNode = (0, _reactDom.findDOMNode)(this.focused);
					var menuNode = (0, _reactDom.findDOMNode)(this.menu);
	
					var scrollTop = menuNode.scrollTop;
					var scrollBottom = scrollTop + menuNode.offsetHeight;
					var optionTop = focusedOptionNode.offsetTop;
					var optionBottom = optionTop + focusedOptionNode.offsetHeight;
	
					if (scrollTop > optionTop || scrollBottom < optionBottom) {
						menuNode.scrollTop = focusedOptionNode.offsetTop;
					}
	
					// We still set hasScrolledToOption to true even if we didn't
					// actually need to scroll, as we've still confirmed that the
					// option is in view.
					this.hasScrolledToOption = true;
				} else if (!this.state.isOpen) {
					this.hasScrolledToOption = false;
				}
	
				if (this._scrollToFocusedOptionOnUpdate && this.focused && this.menu) {
					this._scrollToFocusedOptionOnUpdate = false;
					var focusedDOM = (0, _reactDom.findDOMNode)(this.focused);
					var menuDOM = (0, _reactDom.findDOMNode)(this.menu);
					var focusedRect = focusedDOM.getBoundingClientRect();
					var menuRect = menuDOM.getBoundingClientRect();
					if (focusedRect.bottom > menuRect.bottom) {
						menuDOM.scrollTop = focusedDOM.offsetTop + focusedDOM.clientHeight - menuDOM.offsetHeight;
					} else if (focusedRect.top < menuRect.top) {
						menuDOM.scrollTop = focusedDOM.offsetTop;
					}
				}
				if (this.props.scrollMenuIntoView && this.menuContainer) {
					var menuContainerRect = this.menuContainer.getBoundingClientRect();
					if (window.innerHeight < menuContainerRect.bottom + this.props.menuBuffer) {
						window.scrollBy(0, menuContainerRect.bottom + this.props.menuBuffer - window.innerHeight);
					}
				}
				if (prevProps.disabled !== this.props.disabled) {
					this.setState({ isFocused: false }); // eslint-disable-line react/no-did-update-set-state
					this.closeMenu();
				}
				if (prevState.isOpen !== this.state.isOpen) {
					this.toggleTouchOutsideEvent(this.state.isOpen);
					var handler = this.state.isOpen ? this.props.onOpen : this.props.onClose;
					handler && handler();
				}
			}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				this.toggleTouchOutsideEvent(false);
			}
		}, {
			key: 'toggleTouchOutsideEvent',
			value: function toggleTouchOutsideEvent(enabled) {
				var eventTogglerName = enabled ? document.addEventListener ? 'addEventListener' : 'attachEvent' : document.removeEventListener ? 'removeEventListener' : 'detachEvent';
				var pref = document.addEventListener ? '' : 'on';
	
				document[eventTogglerName](pref + 'touchstart', this.handleTouchOutside);
				document[eventTogglerName](pref + 'mousedown', this.handleTouchOutside);
			}
		}, {
			key: 'handleTouchOutside',
			value: function handleTouchOutside(event) {
				// handle touch outside on ios to dismiss menu
				if (this.wrapper && !this.wrapper.contains(event.target)) {
					this.closeMenu();
				}
			}
		}, {
			key: 'focus',
			value: function focus() {
				if (!this.input) return;
				this.input.focus();
			}
		}, {
			key: 'blurInput',
			value: function blurInput() {
				if (!this.input) return;
				this.input.blur();
			}
		}, {
			key: 'handleTouchMove',
			value: function handleTouchMove() {
				// Set a flag that the view is being dragged
				this.dragging = true;
			}
		}, {
			key: 'handleTouchStart',
			value: function handleTouchStart() {
				// Set a flag that the view is not being dragged
				this.dragging = false;
			}
		}, {
			key: 'handleTouchEnd',
			value: function handleTouchEnd(event) {
				// Check if the view is being dragged, In this case
				// we don't want to fire the click event (because the user only wants to scroll)
				if (this.dragging) return;
	
				// Fire the mouse events
				this.handleMouseDown(event);
			}
		}, {
			key: 'handleTouchEndClearValue',
			value: function handleTouchEndClearValue(event) {
				// Check if the view is being dragged, In this case
				// we don't want to fire the click event (because the user only wants to scroll)
				if (this.dragging) return;
	
				// Clear the value
				this.clearValue(event);
			}
		}, {
			key: 'handleMouseDown',
			value: function handleMouseDown(event) {
				// if the event was triggered by a mousedown and not the primary
				// button, or if the component is disabled, ignore it.
				if (this.props.disabled || event.type === 'mousedown' && event.button !== 0) {
					return;
				}
	
				if (event.target.tagName === 'INPUT') {
					if (!this.state.isFocused) {
						this._openAfterFocus = this.props.openOnClick;
						this.focus();
					} else if (!this.state.isOpen) {
						this.setState({
							isOpen: true,
							isPseudoFocused: false,
							focusedOption: null
						});
					}
	
					return;
				}
	
				// prevent default event handlers
				event.preventDefault();
	
				// for the non-searchable select, toggle the menu
				if (!this.props.searchable) {
					// This code means that if a select is searchable, onClick the options menu will not appear, only on subsequent click will it open.
					this.focus();
					return this.setState({
						isOpen: !this.state.isOpen,
						focusedOption: null
					});
				}
	
				if (this.state.isFocused) {
					// On iOS, we can get into a state where we think the input is focused but it isn't really,
					// since iOS ignores programmatic calls to input.focus() that weren't triggered by a click event.
					// Call focus() again here to be safe.
					this.focus();
	
					var input = this.input;
					var toOpen = true;
	
					if (typeof input.getInput === 'function') {
						// Get the actual DOM input if the ref is an <AutosizeInput /> component
						input = input.getInput();
					}
	
					// clears the value so that the cursor will be at the end of input when the component re-renders
					input.value = '';
	
					if (this._focusAfterClear) {
						toOpen = false;
						this._focusAfterClear = false;
					}
	
					// if the input is focused, ensure the menu is open
					this.setState({
						isOpen: toOpen,
						isPseudoFocused: false,
						focusedOption: null
					});
				} else {
					// otherwise, focus the input and open the menu
					this._openAfterFocus = this.props.openOnClick;
					this.focus();
					this.setState({ focusedOption: null });
				}
			}
		}, {
			key: 'handleMouseDownOnArrow',
			value: function handleMouseDownOnArrow(event) {
				// if the event was triggered by a mousedown and not the primary
				// button, or if the component is disabled, ignore it.
				if (this.props.disabled || event.type === 'mousedown' && event.button !== 0) {
					return;
				}
	
				if (this.state.isOpen) {
					// prevent default event handlers
					event.stopPropagation();
					event.preventDefault();
					// close the menu
					this.closeMenu();
				} else {
					// If the menu isn't open, let the event bubble to the main handleMouseDown
					this.setState({
						isOpen: true
					});
				}
			}
		}, {
			key: 'handleMouseDownOnMenu',
			value: function handleMouseDownOnMenu(event) {
				// if the event was triggered by a mousedown and not the primary
				// button, or if the component is disabled, ignore it.
				if (this.props.disabled || event.type === 'mousedown' && event.button !== 0) {
					return;
				}
	
				event.stopPropagation();
				event.preventDefault();
	
				this._openAfterFocus = true;
				this.focus();
			}
		}, {
			key: 'closeMenu',
			value: function closeMenu() {
				if (this.props.onCloseResetsInput) {
					this.setState({
						inputValue: this.handleInputValueChange(''),
						isOpen: false,
						isPseudoFocused: this.state.isFocused && !this.props.multi
					});
				} else {
					this.setState({
						isOpen: false,
						isPseudoFocused: this.state.isFocused && !this.props.multi
					});
				}
				this.hasScrolledToOption = false;
			}
		}, {
			key: 'handleInputFocus',
			value: function handleInputFocus(event) {
				if (this.props.disabled) return;
	
				var toOpen = this.state.isOpen || this._openAfterFocus || this.props.openOnFocus;
				toOpen = this._focusAfterClear ? false : toOpen; //if focus happens after clear values, don't open dropdown yet.
	
				if (this.props.onFocus) {
					this.props.onFocus(event);
				}
	
				this.setState({
					isFocused: true,
					isOpen: !!toOpen
				});
	
				this._focusAfterClear = false;
				this._openAfterFocus = false;
			}
		}, {
			key: 'handleInputBlur',
			value: function handleInputBlur(event) {
				// The check for menu.contains(activeElement) is necessary to prevent IE11's scrollbar from closing the menu in certain contexts.
				if (this.menu && (this.menu === document.activeElement || this.menu.contains(document.activeElement))) {
					this.focus();
					return;
				}
	
				if (this.props.onBlur) {
					this.props.onBlur(event);
				}
				var onBlurredState = {
					isFocused: false,
					isOpen: false,
					isPseudoFocused: false
				};
				if (this.props.onBlurResetsInput) {
					onBlurredState.inputValue = this.handleInputValueChange('');
				}
				this.setState(onBlurredState);
			}
		}, {
			key: 'handleInputChange',
			value: function handleInputChange(event) {
				var newInputValue = event.target.value;
	
				if (this.state.inputValue !== event.target.value) {
					newInputValue = this.handleInputValueChange(newInputValue);
				}
	
				this.setState({
					inputValue: newInputValue,
					isOpen: true,
					isPseudoFocused: false
				});
			}
		}, {
			key: 'setInputValue',
			value: function setInputValue(newValue) {
				if (this.props.onInputChange) {
					var nextState = this.props.onInputChange(newValue);
					if (nextState != null && (typeof nextState === 'undefined' ? 'undefined' : _typeof(nextState)) !== 'object') {
						newValue = '' + nextState;
					}
				}
				this.setState({
					inputValue: newValue
				});
			}
		}, {
			key: 'handleInputValueChange',
			value: function handleInputValueChange(newValue) {
				if (this.props.onInputChange) {
					var nextState = this.props.onInputChange(newValue);
					// Note: != used deliberately here to catch undefined and null
					if (nextState != null && (typeof nextState === 'undefined' ? 'undefined' : _typeof(nextState)) !== 'object') {
						newValue = '' + nextState;
					}
				}
				return newValue;
			}
		}, {
			key: 'handleKeyDown',
			value: function handleKeyDown(event) {
				if (this.props.disabled) return;
	
				if (typeof this.props.onInputKeyDown === 'function') {
					this.props.onInputKeyDown(event);
					if (event.defaultPrevented) {
						return;
					}
				}
	
				switch (event.keyCode) {
					case 8:
						// backspace
						if (!this.state.inputValue && this.props.backspaceRemoves) {
							event.preventDefault();
							this.popValue();
						}
						break;
					case 9:
						// tab
						if (event.shiftKey || !this.state.isOpen || !this.props.tabSelectsValue) {
							break;
						}
						event.preventDefault();
						this.selectFocusedOption();
						break;
					case 13:
						// enter
						event.preventDefault();
						event.stopPropagation();
						if (this.state.isOpen) {
							this.selectFocusedOption();
						} else {
							this.focusNextOption();
						}
						break;
					case 27:
						// escape
						event.preventDefault();
						if (this.state.isOpen) {
							this.closeMenu();
							event.stopPropagation();
						} else if (this.props.clearable && this.props.escapeClearsValue) {
							this.clearValue(event);
							event.stopPropagation();
						}
						break;
					case 32:
						// space
						if (this.props.searchable) {
							break;
						}
						event.preventDefault();
						if (!this.state.isOpen) {
							this.focusNextOption();
							break;
						}
						event.stopPropagation();
						this.selectFocusedOption();
						break;
					case 38:
						// up
						event.preventDefault();
						this.focusPreviousOption();
						break;
					case 40:
						// down
						event.preventDefault();
						this.focusNextOption();
						break;
					case 33:
						// page up
						event.preventDefault();
						this.focusPageUpOption();
						break;
					case 34:
						// page down
						event.preventDefault();
						this.focusPageDownOption();
						break;
					case 35:
						// end key
						if (event.shiftKey) {
							break;
						}
						event.preventDefault();
						this.focusEndOption();
						break;
					case 36:
						// home key
						if (event.shiftKey) {
							break;
						}
						event.preventDefault();
						this.focusStartOption();
						break;
					case 46:
						// delete
						if (!this.state.inputValue && this.props.deleteRemoves) {
							event.preventDefault();
							this.popValue();
						}
						break;
				}
			}
		}, {
			key: 'handleValueClick',
			value: function handleValueClick(option, event) {
				if (!this.props.onValueClick) return;
				this.props.onValueClick(option, event);
			}
		}, {
			key: 'handleMenuScroll',
			value: function handleMenuScroll(event) {
				if (!this.props.onMenuScrollToBottom) return;
				var target = event.target;
	
				if (target.scrollHeight > target.offsetHeight && target.scrollHeight - target.offsetHeight - target.scrollTop <= 0) {
					this.props.onMenuScrollToBottom();
				}
			}
		}, {
			key: 'getOptionLabel',
			value: function getOptionLabel(op) {
				return op[this.props.labelKey];
			}
	
			/**
	   * Turns a value into an array from the given options
	   * @param {String|Number|Array} value		- the value of the select input
	   * @param {Object}		nextProps	- optionally specify the nextProps so the returned array uses the latest configuration
	   * @returns	{Array}	the value of the select represented in an array
	   */
	
		}, {
			key: 'getValueArray',
			value: function getValueArray(value) {
				var nextProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
	
				/** support optionally passing in the `nextProps` so `componentWillReceiveProps` updates will function as expected */
				var props = (typeof nextProps === 'undefined' ? 'undefined' : _typeof(nextProps)) === 'object' ? nextProps : this.props;
				if (props.multi) {
					if (typeof value === 'string') {
						value = value.split(props.delimiter);
					}
					if (!Array.isArray(value)) {
						if (value === null || value === undefined) return [];
						value = [value];
					}
					return value.map(function (value) {
						return expandValue(value, props);
					}).filter(function (i) {
						return i;
					});
				}
				var expandedValue = expandValue(value, props);
				return expandedValue ? [expandedValue] : [];
			}
		}, {
			key: 'setValue',
			value: function setValue(value) {
				var _this2 = this;
	
				if (this.props.autoBlur) {
					this.blurInput();
				}
				if (this.props.required) {
					var required = handleRequired(value, this.props.multi);
					this.setState({ required: required });
				}
				if (this.props.simpleValue && value) {
					value = this.props.multi ? value.map(function (i) {
						return i[_this2.props.valueKey];
					}).join(this.props.delimiter) : value[this.props.valueKey];
				}
				if (this.props.onChange) {
					this.props.onChange(value);
				}
			}
		}, {
			key: 'selectValue',
			value: function selectValue(value) {
				var _this3 = this;
	
				// NOTE: we actually add/set the value in a callback to make sure the
				// input value is empty to avoid styling issues in Chrome
				if (this.props.closeOnSelect) {
					this.hasScrolledToOption = false;
				}
				var updatedValue = this.props.onSelectResetsInput ? '' : this.state.inputValue;
				if (this.props.multi) {
					this.setState({
						focusedIndex: null,
						inputValue: this.handleInputValueChange(updatedValue),
						isOpen: !this.props.closeOnSelect
					}, function () {
						var valueArray = _this3.getValueArray(_this3.props.value);
						if (valueArray.some(function (i) {
							return i[_this3.props.valueKey] === value[_this3.props.valueKey];
						})) {
							_this3.removeValue(value);
						} else {
							_this3.addValue(value);
						}
					});
				} else {
					this.setState({
						inputValue: this.handleInputValueChange(updatedValue),
						isOpen: !this.props.closeOnSelect,
						isPseudoFocused: this.state.isFocused
					}, function () {
						_this3.setValue(value);
					});
				}
			}
		}, {
			key: 'addValue',
			value: function addValue(value) {
				var valueArray = this.getValueArray(this.props.value);
				var visibleOptions = this._visibleOptions.filter(function (val) {
					return !val.disabled;
				});
				var lastValueIndex = visibleOptions.indexOf(value);
				this.setValue(valueArray.concat(value));
				if (!this.props.closeOnSelect) {
					return;
				}
				if (visibleOptions.length - 1 === lastValueIndex) {
					// the last option was selected; focus the second-last one
					this.focusOption(visibleOptions[lastValueIndex - 1]);
				} else if (visibleOptions.length > lastValueIndex) {
					// focus the option below the selected one
					this.focusOption(visibleOptions[lastValueIndex + 1]);
				}
			}
		}, {
			key: 'popValue',
			value: function popValue() {
				var valueArray = this.getValueArray(this.props.value);
				if (!valueArray.length) return;
				if (valueArray[valueArray.length - 1].clearableValue === false) return;
				this.setValue(this.props.multi ? valueArray.slice(0, valueArray.length - 1) : null);
			}
		}, {
			key: 'removeValue',
			value: function removeValue(value) {
				var _this4 = this;
	
				var valueArray = this.getValueArray(this.props.value);
				this.setValue(valueArray.filter(function (i) {
					return i[_this4.props.valueKey] !== value[_this4.props.valueKey];
				}));
				this.focus();
			}
		}, {
			key: 'clearValue',
			value: function clearValue(event) {
				// if the event was triggered by a mousedown and not the primary
				// button, ignore it.
				if (event && event.type === 'mousedown' && event.button !== 0) {
					return;
				}
	
				event.preventDefault();
	
				this.setValue(this.getResetValue());
				this.setState({
					inputValue: this.handleInputValueChange(''),
					isOpen: false
				}, this.focus);
	
				this._focusAfterClear = true;
			}
		}, {
			key: 'getResetValue',
			value: function getResetValue() {
				if (this.props.resetValue !== undefined) {
					return this.props.resetValue;
				} else if (this.props.multi) {
					return [];
				} else {
					return null;
				}
			}
		}, {
			key: 'focusOption',
			value: function focusOption(option) {
				this.setState({
					focusedOption: option
				});
			}
		}, {
			key: 'focusNextOption',
			value: function focusNextOption() {
				this.focusAdjacentOption('next');
			}
		}, {
			key: 'focusPreviousOption',
			value: function focusPreviousOption() {
				this.focusAdjacentOption('previous');
			}
		}, {
			key: 'focusPageUpOption',
			value: function focusPageUpOption() {
				this.focusAdjacentOption('page_up');
			}
		}, {
			key: 'focusPageDownOption',
			value: function focusPageDownOption() {
				this.focusAdjacentOption('page_down');
			}
		}, {
			key: 'focusStartOption',
			value: function focusStartOption() {
				this.focusAdjacentOption('start');
			}
		}, {
			key: 'focusEndOption',
			value: function focusEndOption() {
				this.focusAdjacentOption('end');
			}
		}, {
			key: 'focusAdjacentOption',
			value: function focusAdjacentOption(dir) {
				var options = this._visibleOptions.map(function (option, index) {
					return { option: option, index: index };
				}).filter(function (option) {
					return !option.option.disabled;
				});
				this._scrollToFocusedOptionOnUpdate = true;
				if (!this.state.isOpen) {
					var newState = {
						focusedOption: this._focusedOption || (options.length ? options[dir === 'next' ? 0 : options.length - 1].option : null),
						isOpen: true
					};
					if (this.props.onSelectResetsInput) {
						newState.inputValue = '';
					}
					this.setState(newState);
					return;
				}
				if (!options.length) return;
				var focusedIndex = -1;
				for (var i = 0; i < options.length; i++) {
					if (this._focusedOption === options[i].option) {
						focusedIndex = i;
						break;
					}
				}
				if (dir === 'next' && focusedIndex !== -1) {
					focusedIndex = (focusedIndex + 1) % options.length;
				} else if (dir === 'previous') {
					if (focusedIndex > 0) {
						focusedIndex = focusedIndex - 1;
					} else {
						focusedIndex = options.length - 1;
					}
				} else if (dir === 'start') {
					focusedIndex = 0;
				} else if (dir === 'end') {
					focusedIndex = options.length - 1;
				} else if (dir === 'page_up') {
					var potentialIndex = focusedIndex - this.props.pageSize;
					if (potentialIndex < 0) {
						focusedIndex = 0;
					} else {
						focusedIndex = potentialIndex;
					}
				} else if (dir === 'page_down') {
					var _potentialIndex = focusedIndex + this.props.pageSize;
					if (_potentialIndex > options.length - 1) {
						focusedIndex = options.length - 1;
					} else {
						focusedIndex = _potentialIndex;
					}
				}
	
				if (focusedIndex === -1) {
					focusedIndex = 0;
				}
	
				this.setState({
					focusedIndex: options[focusedIndex].index,
					focusedOption: options[focusedIndex].option
				});
			}
		}, {
			key: 'getFocusedOption',
			value: function getFocusedOption() {
				return this._focusedOption;
			}
		}, {
			key: 'selectFocusedOption',
			value: function selectFocusedOption() {
				if (this._focusedOption) {
					return this.selectValue(this._focusedOption);
				}
			}
		}, {
			key: 'renderLoading',
			value: function renderLoading() {
				if (!this.props.isLoading) return;
				return _react2.default.createElement(
					'span',
					{ className: 'Select-loading-zone', 'aria-hidden': 'true' },
					_react2.default.createElement('span', { className: 'Select-loading' })
				);
			}
		}, {
			key: 'renderValue',
			value: function renderValue(valueArray, isOpen) {
				var _this5 = this;
	
				var renderLabel = this.props.valueRenderer || this.getOptionLabel;
				var ValueComponent = this.props.valueComponent;
				if (!valueArray.length) {
					var showPlaceholder = shouldShowPlaceholder(this.state, this.props, isOpen);
					return showPlaceholder ? _react2.default.createElement(
						'div',
						{ className: 'Select-placeholder' },
						this.props.placeholder
					) : null;
				}
				var onClick = this.props.onValueClick ? this.handleValueClick : null;
				if (this.props.multi) {
					return valueArray.map(function (value, i) {
						return _react2.default.createElement(
							ValueComponent,
							{
								disabled: _this5.props.disabled || value.clearableValue === false,
								id: _this5._instancePrefix + '-value-' + i,
								instancePrefix: _this5._instancePrefix,
								key: 'value-' + i + '-' + value[_this5.props.valueKey],
								onClick: onClick,
								onRemove: _this5.removeValue,
								placeholder: _this5.props.placeholder,
								value: value,
								values: valueArray
							},
							renderLabel(value, i),
							_react2.default.createElement(
								'span',
								{ className: 'Select-aria-only' },
								'\xA0'
							)
						);
					});
				} else if (shouldShowValue(this.state, this.props)) {
					if (isOpen) onClick = null;
					return _react2.default.createElement(
						ValueComponent,
						{
							disabled: this.props.disabled,
							id: this._instancePrefix + '-value-item',
							instancePrefix: this._instancePrefix,
							onClick: onClick,
							placeholder: this.props.placeholder,
							value: valueArray[0]
						},
						renderLabel(valueArray[0])
					);
				}
			}
		}, {
			key: 'renderInput',
			value: function renderInput(valueArray, focusedOptionIndex) {
				var _classNames,
				    _this6 = this;
	
				var className = (0, _classnames2.default)('Select-input', this.props.inputProps.className);
				var isOpen = this.state.isOpen;
	
				var ariaOwns = (0, _classnames2.default)((_classNames = {}, _defineProperty(_classNames, this._instancePrefix + '-list', isOpen), _defineProperty(_classNames, this._instancePrefix + '-backspace-remove-message', this.props.multi && !this.props.disabled && this.state.isFocused && !this.state.inputValue), _classNames));
	
				var value = this.state.inputValue;
				if (value && !this.props.onSelectResetsInput && !this.state.isFocused) {
					// it hides input value when it is not focused and was not reset on select
					value = '';
				}
	
				var inputProps = _extends({}, this.props.inputProps, {
					'aria-activedescendant': isOpen ? this._instancePrefix + '-option-' + focusedOptionIndex : this._instancePrefix + '-value',
					'aria-describedby': this.props['aria-describedby'],
					'aria-expanded': '' + isOpen,
					'aria-haspopup': '' + isOpen,
					'aria-label': this.props['aria-label'],
					'aria-labelledby': this.props['aria-labelledby'],
					'aria-owns': ariaOwns,
					onBlur: this.handleInputBlur,
					onChange: this.handleInputChange,
					onFocus: this.handleInputFocus,
					ref: function ref(_ref) {
						return _this6.input = _ref;
					},
					role: 'combobox',
					required: this.state.required,
					tabIndex: this.props.tabIndex,
					value: value
				});
	
				if (this.props.inputRenderer) {
					return this.props.inputRenderer(inputProps);
				}
	
				if (this.props.disabled || !this.props.searchable) {
					var divProps = _objectWithoutProperties(this.props.inputProps, []);
	
					var _ariaOwns = (0, _classnames2.default)(_defineProperty({}, this._instancePrefix + '-list', isOpen));
					return _react2.default.createElement('div', _extends({}, divProps, {
						'aria-expanded': isOpen,
						'aria-owns': _ariaOwns,
						'aria-activedescendant': isOpen ? this._instancePrefix + '-option-' + focusedOptionIndex : this._instancePrefix + '-value',
						'aria-disabled': '' + this.props.disabled,
						'aria-label': this.props['aria-label'],
						'aria-labelledby': this.props['aria-labelledby'],
						className: className,
						onBlur: this.handleInputBlur,
						onFocus: this.handleInputFocus,
						ref: function ref(_ref2) {
							return _this6.input = _ref2;
						},
						role: 'combobox',
						style: { border: 0, width: 1, display: 'inline-block' },
						tabIndex: this.props.tabIndex || 0
					}));
				}
	
				if (this.props.autosize) {
					return _react2.default.createElement(_reactInputAutosize2.default, _extends({ id: this.props.id }, inputProps, { className: className, minWidth: '5' }));
				}
				return _react2.default.createElement(
					'div',
					{ className: className, key: 'input-wrap', style: { display: 'inline-block' } },
					_react2.default.createElement('input', _extends({ id: this.props.id }, inputProps))
				);
			}
		}, {
			key: 'renderClear',
			value: function renderClear() {
				var valueArray = this.getValueArray(this.props.value);
				if (!this.props.clearable || !valueArray.length || this.props.disabled || this.props.isLoading) return;
				var ariaLabel = this.props.multi ? this.props.clearAllText : this.props.clearValueText;
				var clear = this.props.clearRenderer();
	
				return _react2.default.createElement(
					'span',
					{
						'aria-label': ariaLabel,
						className: 'Select-clear-zone',
						onMouseDown: this.clearValue,
						onTouchEnd: this.handleTouchEndClearValue,
						onTouchMove: this.handleTouchMove,
						onTouchStart: this.handleTouchStart,
						title: ariaLabel
					},
					clear
				);
			}
		}, {
			key: 'renderArrow',
			value: function renderArrow() {
				if (!this.props.arrowRenderer) return;
	
				var onMouseDown = this.handleMouseDownOnArrow;
				var isOpen = this.state.isOpen;
				var arrow = this.props.arrowRenderer({ onMouseDown: onMouseDown, isOpen: isOpen });
	
				if (!arrow) {
					return null;
				}
	
				return _react2.default.createElement(
					'span',
					{
						className: 'Select-arrow-zone',
						onMouseDown: onMouseDown
					},
					arrow
				);
			}
		}, {
			key: 'filterOptions',
			value: function filterOptions(excludeOptions) {
				var filterValue = this.state.inputValue;
				var options = this.props.options || [];
				if (this.props.filterOptions) {
					// Maintain backwards compatibility with boolean attribute
					var filterOptions = typeof this.props.filterOptions === 'function' ? this.props.filterOptions : _defaultFilterOptions2.default;
	
					return filterOptions(options, filterValue, excludeOptions, {
						filterOption: this.props.filterOption,
						ignoreAccents: this.props.ignoreAccents,
						ignoreCase: this.props.ignoreCase,
						labelKey: this.props.labelKey,
						matchPos: this.props.matchPos,
						matchProp: this.props.matchProp,
						trimFilter: this.props.trimFilter,
						valueKey: this.props.valueKey
					});
				} else {
					return options;
				}
			}
		}, {
			key: 'onOptionRef',
			value: function onOptionRef(ref, isFocused) {
				if (isFocused) {
					this.focused = ref;
				}
			}
		}, {
			key: 'renderMenu',
			value: function renderMenu(options, valueArray, focusedOption) {
				if (options && options.length) {
					return this.props.menuRenderer({
						focusedOption: focusedOption,
						focusOption: this.focusOption,
						inputValue: this.state.inputValue,
						instancePrefix: this._instancePrefix,
						labelKey: this.props.labelKey,
						onFocus: this.focusOption,
						onOptionRef: this.onOptionRef,
						onSelect: this.selectValue,
						optionClassName: this.props.optionClassName,
						optionComponent: this.props.optionComponent,
						optionRenderer: this.props.optionRenderer || this.getOptionLabel,
						options: options,
						removeValue: this.removeValue,
						selectValue: this.selectValue,
						valueArray: valueArray,
						valueKey: this.props.valueKey
					});
				} else if (this.props.noResultsText) {
					return _react2.default.createElement(
						'div',
						{ className: 'Select-noresults' },
						this.props.noResultsText
					);
				} else {
					return null;
				}
			}
		}, {
			key: 'renderHiddenField',
			value: function renderHiddenField(valueArray) {
				var _this7 = this;
	
				if (!this.props.name) return;
				if (this.props.joinValues) {
					var value = valueArray.map(function (i) {
						return stringifyValue(i[_this7.props.valueKey]);
					}).join(this.props.delimiter);
					return _react2.default.createElement('input', {
						disabled: this.props.disabled,
						name: this.props.name,
						ref: function ref(_ref3) {
							return _this7.value = _ref3;
						},
						type: 'hidden',
						value: value
					});
				}
				return valueArray.map(function (item, index) {
					return _react2.default.createElement('input', {
						disabled: _this7.props.disabled,
						key: 'hidden.' + index,
						name: _this7.props.name,
						ref: 'value' + index,
						type: 'hidden',
						value: stringifyValue(item[_this7.props.valueKey])
					});
				});
			}
		}, {
			key: 'getFocusableOptionIndex',
			value: function getFocusableOptionIndex(selectedOption) {
				var options = this._visibleOptions;
				if (!options.length) return null;
	
				var valueKey = this.props.valueKey;
				var focusedOption = this.state.focusedOption || selectedOption;
				if (focusedOption && !focusedOption.disabled) {
					var focusedOptionIndex = -1;
					options.some(function (option, index) {
						var isOptionEqual = option[valueKey] === focusedOption[valueKey];
						if (isOptionEqual) {
							focusedOptionIndex = index;
						}
						return isOptionEqual;
					});
					if (focusedOptionIndex !== -1) {
						return focusedOptionIndex;
					}
				}
	
				for (var i = 0; i < options.length; i++) {
					if (!options[i].disabled) return i;
				}
				return null;
			}
		}, {
			key: 'renderOuter',
			value: function renderOuter(options, valueArray, focusedOption) {
				var _this8 = this;
	
				var menu = this.renderMenu(options, valueArray, focusedOption);
				if (!menu) {
					return null;
				}
	
				return _react2.default.createElement(
					'div',
					{ ref: function ref(_ref5) {
							return _this8.menuContainer = _ref5;
						}, className: 'Select-menu-outer', style: this.props.menuContainerStyle },
					_react2.default.createElement(
						'div',
						{
							className: 'Select-menu',
							id: this._instancePrefix + '-list',
							onMouseDown: this.handleMouseDownOnMenu,
							onScroll: this.handleMenuScroll,
							ref: function ref(_ref4) {
								return _this8.menu = _ref4;
							},
							role: 'listbox',
							style: this.props.menuStyle,
							tabIndex: -1
						},
						menu
					)
				);
			}
		}, {
			key: 'render',
			value: function render() {
				var _this9 = this;
	
				var valueArray = this.getValueArray(this.props.value);
				var options = this._visibleOptions = this.filterOptions(this.props.multi && this.props.removeSelected ? valueArray : null);
				var isOpen = this.state.isOpen;
				if (this.props.multi && !options.length && valueArray.length && !this.state.inputValue) isOpen = false;
				var focusedOptionIndex = this.getFocusableOptionIndex(valueArray[0]);
	
				var focusedOption = null;
				if (focusedOptionIndex !== null) {
					focusedOption = this._focusedOption = options[focusedOptionIndex];
				} else {
					focusedOption = this._focusedOption = null;
				}
				var className = (0, _classnames2.default)('Select', this.props.className, {
					'has-value': valueArray.length,
					'is-clearable': this.props.clearable,
					'is-disabled': this.props.disabled,
					'is-focused': this.state.isFocused,
					'is-loading': this.props.isLoading,
					'is-open': isOpen,
					'is-pseudo-focused': this.state.isPseudoFocused,
					'is-searchable': this.props.searchable,
					'Select--multi': this.props.multi,
					'Select--rtl': this.props.rtl,
					'Select--single': !this.props.multi
				});
	
				var removeMessage = null;
				if (this.props.multi && !this.props.disabled && valueArray.length && !this.state.inputValue && this.state.isFocused && this.props.backspaceRemoves) {
					removeMessage = _react2.default.createElement(
						'span',
						{ id: this._instancePrefix + '-backspace-remove-message', className: 'Select-aria-only', 'aria-live': 'assertive' },
						this.props.backspaceToRemoveMessage.replace('{label}', valueArray[valueArray.length - 1][this.props.labelKey])
					);
				}
	
				return _react2.default.createElement(
					'div',
					{ ref: function ref(_ref7) {
							return _this9.wrapper = _ref7;
						},
						className: className,
						style: this.props.wrapperStyle },
					this.renderHiddenField(valueArray),
					_react2.default.createElement(
						'div',
						{ ref: function ref(_ref6) {
								return _this9.control = _ref6;
							},
							className: 'Select-control',
							onKeyDown: this.handleKeyDown,
							onMouseDown: this.handleMouseDown,
							onTouchEnd: this.handleTouchEnd,
							onTouchMove: this.handleTouchMove,
							onTouchStart: this.handleTouchStart,
							style: this.props.style
						},
						_react2.default.createElement(
							'div',
							{ className: 'Select-multi-value-wrapper', id: this._instancePrefix + '-value' },
							this.renderValue(valueArray, isOpen),
							this.renderInput(valueArray, focusedOptionIndex)
						),
						removeMessage,
						this.renderLoading(),
						this.renderClear(),
						this.renderArrow()
					),
					isOpen ? this.renderOuter(options, valueArray, focusedOption) : null
				);
			}
		}]);
	
		return Select;
	}(_react2.default.Component);
	
	Select.propTypes = {
		'aria-describedby': _propTypes2.default.string, // html id(s) of element(s) that should be used to describe this input (for assistive tech)
		'aria-label': _propTypes2.default.string, // aria label (for assistive tech)
		'aria-labelledby': _propTypes2.default.string, // html id of an element that should be used as the label (for assistive tech)
		arrowRenderer: _propTypes2.default.func, // create the drop-down caret element
		autoBlur: _propTypes2.default.bool, // automatically blur the component when an option is selected
		autoFocus: _propTypes2.default.bool, // autofocus the component on mount
		autofocus: _propTypes2.default.bool, // deprecated; use autoFocus instead
		autosize: _propTypes2.default.bool, // whether to enable autosizing or not
		backspaceRemoves: _propTypes2.default.bool, // whether backspace removes an item if there is no text input
		backspaceToRemoveMessage: _propTypes2.default.string, // message to use for screenreaders to press backspace to remove the current item - {label} is replaced with the item label
		className: _propTypes2.default.string, // className for the outer element
		clearAllText: stringOrNode, // title for the "clear" control when multi: true
		clearRenderer: _propTypes2.default.func, // create clearable x element
		clearValueText: stringOrNode, // title for the "clear" control
		clearable: _propTypes2.default.bool, // should it be possible to reset value
		closeOnSelect: _propTypes2.default.bool, // whether to close the menu when a value is selected
		deleteRemoves: _propTypes2.default.bool, // whether delete removes an item if there is no text input
		delimiter: _propTypes2.default.string, // delimiter to use to join multiple values for the hidden field value
		disabled: _propTypes2.default.bool, // whether the Select is disabled or not
		escapeClearsValue: _propTypes2.default.bool, // whether escape clears the value when the menu is closed
		filterOption: _propTypes2.default.func, // method to filter a single option (option, filterString)
		filterOptions: _propTypes2.default.any, // boolean to enable default filtering or function to filter the options array ([options], filterString, [values])
		id: _propTypes2.default.string, // html id to set on the input element for accessibility or tests
		ignoreAccents: _propTypes2.default.bool, // whether to strip diacritics when filtering
		ignoreCase: _propTypes2.default.bool, // whether to perform case-insensitive filtering
		inputProps: _propTypes2.default.object, // custom attributes for the Input
		inputRenderer: _propTypes2.default.func, // returns a custom input component
		instanceId: _propTypes2.default.string, // set the components instanceId
		isLoading: _propTypes2.default.bool, // whether the Select is loading externally or not (such as options being loaded)
		joinValues: _propTypes2.default.bool, // joins multiple values into a single form field with the delimiter (legacy mode)
		labelKey: _propTypes2.default.string, // path of the label value in option objects
		matchPos: _propTypes2.default.string, // (any|start) match the start or entire string when filtering
		matchProp: _propTypes2.default.string, // (any|label|value) which option property to filter on
		menuBuffer: _propTypes2.default.number, // optional buffer (in px) between the bottom of the viewport and the bottom of the menu
		menuContainerStyle: _propTypes2.default.object, // optional style to apply to the menu container
		menuRenderer: _propTypes2.default.func, // renders a custom menu with options
		menuStyle: _propTypes2.default.object, // optional style to apply to the menu
		multi: _propTypes2.default.bool, // multi-value input
		name: _propTypes2.default.string, // generates a hidden <input /> tag with this field name for html forms
		noResultsText: stringOrNode, // placeholder displayed when there are no matching search results
		onBlur: _propTypes2.default.func, // onBlur handler: function (event) {}
		onBlurResetsInput: _propTypes2.default.bool, // whether input is cleared on blur
		onChange: _propTypes2.default.func, // onChange handler: function (newValue) {}
		onClose: _propTypes2.default.func, // fires when the menu is closed
		onCloseResetsInput: _propTypes2.default.bool, // whether input is cleared when menu is closed through the arrow
		onFocus: _propTypes2.default.func, // onFocus handler: function (event) {}
		onInputChange: _propTypes2.default.func, // onInputChange handler: function (inputValue) {}
		onInputKeyDown: _propTypes2.default.func, // input keyDown handler: function (event) {}
		onMenuScrollToBottom: _propTypes2.default.func, // fires when the menu is scrolled to the bottom; can be used to paginate options
		onOpen: _propTypes2.default.func, // fires when the menu is opened
		onSelectResetsInput: _propTypes2.default.bool, // whether input is cleared on select (works only for multiselect)
		onValueClick: _propTypes2.default.func, // onClick handler for value labels: function (value, event) {}
		openOnClick: _propTypes2.default.bool, // boolean to control opening the menu when the control is clicked
		openOnFocus: _propTypes2.default.bool, // always open options menu on focus
		optionClassName: _propTypes2.default.string, // additional class(es) to apply to the <Option /> elements
		optionComponent: _propTypes2.default.func, // option component to render in dropdown
		optionRenderer: _propTypes2.default.func, // optionRenderer: function (option) {}
		options: _propTypes2.default.array, // array of options
		pageSize: _propTypes2.default.number, // number of entries to page when using page up/down keys
		placeholder: stringOrNode, // field placeholder, displayed when there's no value
		removeSelected: _propTypes2.default.bool, // whether the selected option is removed from the dropdown on multi selects
		required: _propTypes2.default.bool, // applies HTML5 required attribute when needed
		resetValue: _propTypes2.default.any, // value to use when you clear the control
		rtl: _propTypes2.default.bool, // set to true in order to use react-select in right-to-left direction
		scrollMenuIntoView: _propTypes2.default.bool, // boolean to enable the viewport to shift so that the full menu fully visible when engaged
		searchable: _propTypes2.default.bool, // whether to enable searching feature or not
		simpleValue: _propTypes2.default.bool, // pass the value to onChange as a simple value (legacy pre 1.0 mode), defaults to false
		style: _propTypes2.default.object, // optional style to apply to the control
		tabIndex: stringOrNumber, // optional tab index of the control
		tabSelectsValue: _propTypes2.default.bool, // whether to treat tabbing out while focused to be value selection
		trimFilter: _propTypes2.default.bool, // whether to trim whitespace around filter value
		value: _propTypes2.default.any, // initial field value
		valueComponent: _propTypes2.default.func, // value component to render
		valueKey: _propTypes2.default.string, // path of the label value in option objects
		valueRenderer: _propTypes2.default.func, // valueRenderer: function (option) {}
		wrapperStyle: _propTypes2.default.object // optional style to apply to the component wrapper
	};
	
	Select.defaultProps = {
		arrowRenderer: _defaultArrowRenderer2.default,
		autosize: true,
		backspaceRemoves: true,
		backspaceToRemoveMessage: 'Press backspace to remove {label}',
		clearable: true,
		clearAllText: 'Clear all',
		clearRenderer: _defaultClearRenderer2.default,
		clearValueText: 'Clear value',
		closeOnSelect: true,
		deleteRemoves: true,
		delimiter: ',',
		disabled: false,
		escapeClearsValue: true,
		filterOptions: _defaultFilterOptions2.default,
		ignoreAccents: true,
		ignoreCase: true,
		inputProps: {},
		isLoading: false,
		joinValues: false,
		labelKey: 'label',
		matchPos: 'any',
		matchProp: 'any',
		menuBuffer: 0,
		menuRenderer: _defaultMenuRenderer2.default,
		multi: false,
		noResultsText: 'No results found',
		onBlurResetsInput: true,
		onCloseResetsInput: true,
		onSelectResetsInput: true,
		openOnClick: true,
		optionComponent: _Option2.default,
		pageSize: 5,
		placeholder: 'Select...',
		removeSelected: true,
		required: false,
		rtl: false,
		scrollMenuIntoView: true,
		searchable: true,
		simpleValue: false,
		tabSelectsValue: true,
		trimFilter: true,
		valueComponent: _Value2.default,
		valueKey: 'value'
	};
	
	exports.default = Select;

/***/ }),
/* 955 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(956);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var sizerStyle = {
		position: 'absolute',
		top: 0,
		left: 0,
		visibility: 'hidden',
		height: 0,
		overflow: 'scroll',
		whiteSpace: 'pre'
	};
	
	var INPUT_PROPS_BLACKLIST = ['extraWidth', 'injectStyles', 'inputClassName', 'inputRef', 'inputStyle', 'minWidth', 'onAutosize', 'placeholderIsMinWidth'];
	
	var cleanInputProps = function cleanInputProps(inputProps) {
		INPUT_PROPS_BLACKLIST.forEach(function (field) {
			return delete inputProps[field];
		});
		return inputProps;
	};
	
	var copyStyles = function copyStyles(styles, node) {
		node.style.fontSize = styles.fontSize;
		node.style.fontFamily = styles.fontFamily;
		node.style.fontWeight = styles.fontWeight;
		node.style.fontStyle = styles.fontStyle;
		node.style.letterSpacing = styles.letterSpacing;
		node.style.textTransform = styles.textTransform;
	};
	
	var isIE = typeof window !== 'undefined' && window.navigator ? /MSIE |Trident\/|Edge\//.test(window.navigator.userAgent) : false;
	
	var generateId = function generateId() {
		// we only need an auto-generated ID for stylesheet injection, which is only
		// used for IE. so if the browser is not IE, this should return undefined.
		return isIE ? '_' + Math.random().toString(36).substr(2, 12) : undefined;
	};
	
	var AutosizeInput = function (_Component) {
		_inherits(AutosizeInput, _Component);
	
		function AutosizeInput(props) {
			_classCallCheck(this, AutosizeInput);
	
			var _this = _possibleConstructorReturn(this, (AutosizeInput.__proto__ || Object.getPrototypeOf(AutosizeInput)).call(this, props));
	
			_this.inputRef = function (el) {
				_this.input = el;
				if (typeof _this.props.inputRef === 'function') {
					_this.props.inputRef(el);
				}
			};
	
			_this.placeHolderSizerRef = function (el) {
				_this.placeHolderSizer = el;
			};
	
			_this.sizerRef = function (el) {
				_this.sizer = el;
			};
	
			_this.state = {
				inputWidth: props.minWidth,
				inputId: props.id || generateId()
			};
			return _this;
		}
	
		_createClass(AutosizeInput, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				this.mounted = true;
				this.copyInputStyles();
				this.updateInputWidth();
			}
		}, {
			key: 'UNSAFE_componentWillReceiveProps',
			value: function UNSAFE_componentWillReceiveProps(nextProps) {
				var id = nextProps.id;
	
				if (id !== this.props.id) {
					this.setState({ inputId: id || generateId() });
				}
			}
		}, {
			key: 'componentDidUpdate',
			value: function componentDidUpdate(prevProps, prevState) {
				if (prevState.inputWidth !== this.state.inputWidth) {
					if (typeof this.props.onAutosize === 'function') {
						this.props.onAutosize(this.state.inputWidth);
					}
				}
				this.updateInputWidth();
			}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				this.mounted = false;
			}
		}, {
			key: 'copyInputStyles',
			value: function copyInputStyles() {
				if (!this.mounted || !window.getComputedStyle) {
					return;
				}
				var inputStyles = this.input && window.getComputedStyle(this.input);
				if (!inputStyles) {
					return;
				}
				copyStyles(inputStyles, this.sizer);
				if (this.placeHolderSizer) {
					copyStyles(inputStyles, this.placeHolderSizer);
				}
			}
		}, {
			key: 'updateInputWidth',
			value: function updateInputWidth() {
				if (!this.mounted || !this.sizer || typeof this.sizer.scrollWidth === 'undefined') {
					return;
				}
				var newInputWidth = void 0;
				if (this.props.placeholder && (!this.props.value || this.props.value && this.props.placeholderIsMinWidth)) {
					newInputWidth = Math.max(this.sizer.scrollWidth, this.placeHolderSizer.scrollWidth) + 2;
				} else {
					newInputWidth = this.sizer.scrollWidth + 2;
				}
				// add extraWidth to the detected width. for number types, this defaults to 16 to allow for the stepper UI
				var extraWidth = this.props.type === 'number' && this.props.extraWidth === undefined ? 16 : parseInt(this.props.extraWidth) || 0;
				newInputWidth += extraWidth;
				if (newInputWidth < this.props.minWidth) {
					newInputWidth = this.props.minWidth;
				}
				if (newInputWidth !== this.state.inputWidth) {
					this.setState({
						inputWidth: newInputWidth
					});
				}
			}
		}, {
			key: 'getInput',
			value: function getInput() {
				return this.input;
			}
		}, {
			key: 'focus',
			value: function focus() {
				this.input.focus();
			}
		}, {
			key: 'blur',
			value: function blur() {
				this.input.blur();
			}
		}, {
			key: 'select',
			value: function select() {
				this.input.select();
			}
		}, {
			key: 'renderStyles',
			value: function renderStyles() {
				// this method injects styles to hide IE's clear indicator, which messes
				// with input size detection. the stylesheet is only injected when the
				// browser is IE, and can also be disabled by the `injectStyles` prop.
				var injectStyles = this.props.injectStyles;
	
				return isIE && injectStyles ? _react2.default.createElement('style', { dangerouslySetInnerHTML: {
						__html: 'input#' + this.state.inputId + '::-ms-clear {display: none;}'
					} }) : null;
			}
		}, {
			key: 'render',
			value: function render() {
				var sizerValue = [this.props.defaultValue, this.props.value, ''].reduce(function (previousValue, currentValue) {
					if (previousValue !== null && previousValue !== undefined) {
						return previousValue;
					}
					return currentValue;
				});
	
				var wrapperStyle = _extends({}, this.props.style);
				if (!wrapperStyle.display) wrapperStyle.display = 'inline-block';
	
				var inputStyle = _extends({
					boxSizing: 'content-box',
					width: this.state.inputWidth + 'px'
				}, this.props.inputStyle);
	
				var inputProps = _objectWithoutProperties(this.props, []);
	
				cleanInputProps(inputProps);
				inputProps.className = this.props.inputClassName;
				inputProps.id = this.state.inputId;
				inputProps.style = inputStyle;
	
				return _react2.default.createElement(
					'div',
					{ className: this.props.className, style: wrapperStyle },
					this.renderStyles(),
					_react2.default.createElement('input', _extends({}, inputProps, { ref: this.inputRef })),
					_react2.default.createElement(
						'div',
						{ ref: this.sizerRef, style: sizerStyle },
						sizerValue
					),
					this.props.placeholder ? _react2.default.createElement(
						'div',
						{ ref: this.placeHolderSizerRef, style: sizerStyle },
						this.props.placeholder
					) : null
				);
			}
		}]);
	
		return AutosizeInput;
	}(_react.Component);
	
	AutosizeInput.propTypes = {
		className: _propTypes2.default.string, // className for the outer element
		defaultValue: _propTypes2.default.any, // default field value
		extraWidth: _propTypes2.default.oneOfType([// additional width for input element
		_propTypes2.default.number, _propTypes2.default.string]),
		id: _propTypes2.default.string, // id to use for the input, can be set for consistent snapshots
		injectStyles: _propTypes2.default.bool, // inject the custom stylesheet to hide clear UI, defaults to true
		inputClassName: _propTypes2.default.string, // className for the input element
		inputRef: _propTypes2.default.func, // ref callback for the input element
		inputStyle: _propTypes2.default.object, // css styles for the input element
		minWidth: _propTypes2.default.oneOfType([// minimum width for input element
		_propTypes2.default.number, _propTypes2.default.string]),
		onAutosize: _propTypes2.default.func, // onAutosize handler: function(newWidth) {}
		onChange: _propTypes2.default.func, // onChange handler: function(event) {}
		placeholder: _propTypes2.default.string, // placeholder text
		placeholderIsMinWidth: _propTypes2.default.bool, // don't collapse size to less than the placeholder
		style: _propTypes2.default.object, // css styles for the outer element
		value: _propTypes2.default.any // field value
	};
	AutosizeInput.defaultProps = {
		minWidth: 1,
		injectStyles: true
	};
	
	exports.default = AutosizeInput;

/***/ }),
/* 956 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	if (false) {
	  var ReactIs = require('react-is');
	
	  // By explicitly using `prop-types` you are opting into new development behavior.
	  // http://fb.me/prop-types-in-prod
	  var throwOnDirectAccess = true;
	  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
	} else {
	  // By explicitly using `prop-types` you are opting into new production behavior.
	  // http://fb.me/prop-types-in-prod
	  module.exports = __webpack_require__(957)();
	}


/***/ }),
/* 957 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = __webpack_require__(328);
	
	function emptyFunction() {}
	function emptyFunctionWithReset() {}
	emptyFunctionWithReset.resetWarningCache = emptyFunction;
	
	module.exports = function() {
	  function shim(props, propName, componentName, location, propFullName, secret) {
	    if (secret === ReactPropTypesSecret) {
	      // It is still safe when called from React.
	      return;
	    }
	    var err = new Error(
	      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	      'Use PropTypes.checkPropTypes() to call them. ' +
	      'Read more at http://fb.me/use-check-prop-types'
	    );
	    err.name = 'Invariant Violation';
	    throw err;
	  };
	  shim.isRequired = shim;
	  function getShim() {
	    return shim;
	  };
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
	  var ReactPropTypes = {
	    array: shim,
	    bool: shim,
	    func: shim,
	    number: shim,
	    object: shim,
	    string: shim,
	    symbol: shim,
	
	    any: shim,
	    arrayOf: getShim,
	    element: shim,
	    elementType: shim,
	    instanceOf: getShim,
	    node: shim,
	    objectOf: getShim,
	    oneOf: getShim,
	    oneOfType: getShim,
	    shape: getShim,
	    exact: getShim,
	
	    checkPropTypes: emptyFunctionWithReset,
	    resetWarningCache: emptyFunction
	  };
	
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ }),
/* 958 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2018 Jed Watson.
	  Licensed under the MIT License (MIT), see
	  http://jedwatson.github.io/classnames
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var hasOwn = {}.hasOwnProperty;
	
		function classNames() {
			var classes = [];
	
			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (!arg) continue;
	
				var argType = typeof arg;
	
				if (argType === 'string' || argType === 'number') {
					classes.push(arg);
				} else if (Array.isArray(arg)) {
					if (arg.length) {
						var inner = classNames.apply(null, arg);
						if (inner) {
							classes.push(inner);
						}
					}
				} else if (argType === 'object') {
					if (arg.toString === Object.prototype.toString) {
						for (var key in arg) {
							if (hasOwn.call(arg, key) && arg[key]) {
								classes.push(key);
							}
						}
					} else {
						classes.push(arg.toString());
					}
				}
			}
	
			return classes.join(' ');
		}
	
		if (typeof module !== 'undefined' && module.exports) {
			classNames.default = classNames;
			module.exports = classNames;
		} else if (true) {
			// register as 'classnames', consistent with npm package name
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return classNames;
			}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			window.classNames = classNames;
		}
	}());


/***/ }),
/* 959 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(956);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var arrowRenderer = function arrowRenderer(_ref) {
		var onMouseDown = _ref.onMouseDown;
	
		return _react2.default.createElement('span', {
			className: 'Select-arrow',
			onMouseDown: onMouseDown
		});
	};
	
	arrowRenderer.propTypes = {
		onMouseDown: _propTypes2.default.func
	};
	
	exports.default = arrowRenderer;

/***/ }),
/* 960 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var clearRenderer = function clearRenderer() {
		return _react2.default.createElement('span', {
			className: 'Select-clear',
			dangerouslySetInnerHTML: { __html: '&times;' }
		});
	};
	
	exports.default = clearRenderer;

/***/ }),
/* 961 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _stripDiacritics = __webpack_require__(962);
	
	var _stripDiacritics2 = _interopRequireDefault(_stripDiacritics);
	
	var _trim = __webpack_require__(963);
	
	var _trim2 = _interopRequireDefault(_trim);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var isValid = function isValid(value) {
		return typeof value !== 'undefined' && value !== null && value !== '';
	};
	
	var filterOptions = function filterOptions(options, filterValue, excludeOptions, props) {
		if (props.ignoreAccents) {
			filterValue = (0, _stripDiacritics2.default)(filterValue);
		}
	
		if (props.ignoreCase) {
			filterValue = filterValue.toLowerCase();
		}
	
		if (props.trimFilter) {
			filterValue = (0, _trim2.default)(filterValue);
		}
	
		if (excludeOptions) excludeOptions = excludeOptions.map(function (i) {
			return i[props.valueKey];
		});
	
		return options.filter(function (option) {
			if (excludeOptions && excludeOptions.indexOf(option[props.valueKey]) > -1) return false;
			if (props.filterOption) return props.filterOption.call(undefined, option, filterValue);
			if (!filterValue) return true;
	
			var value = option[props.valueKey];
			var label = option[props.labelKey];
			var hasValue = isValid(value);
			var hasLabel = isValid(label);
	
			if (!hasValue && !hasLabel) {
				return false;
			}
	
			var valueTest = hasValue ? String(value) : null;
			var labelTest = hasLabel ? String(label) : null;
	
			if (props.ignoreAccents) {
				if (valueTest && props.matchProp !== 'label') valueTest = (0, _stripDiacritics2.default)(valueTest);
				if (labelTest && props.matchProp !== 'value') labelTest = (0, _stripDiacritics2.default)(labelTest);
			}
	
			if (props.ignoreCase) {
				if (valueTest && props.matchProp !== 'label') valueTest = valueTest.toLowerCase();
				if (labelTest && props.matchProp !== 'value') labelTest = labelTest.toLowerCase();
			}
	
			return props.matchPos === 'start' ? valueTest && props.matchProp !== 'label' && valueTest.substr(0, filterValue.length) === filterValue || labelTest && props.matchProp !== 'value' && labelTest.substr(0, filterValue.length) === filterValue : valueTest && props.matchProp !== 'label' && valueTest.indexOf(filterValue) >= 0 || labelTest && props.matchProp !== 'value' && labelTest.indexOf(filterValue) >= 0;
		});
	};
	
	exports.default = filterOptions;

/***/ }),
/* 962 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	var map = [{ 'base': 'A', 'letters': /[\u0041\u24B6\uFF21\u00C0\u00C1\u00C2\u1EA6\u1EA4\u1EAA\u1EA8\u00C3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\u00C4\u01DE\u1EA2\u00C5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F]/g }, { 'base': 'AA', 'letters': /[\uA732]/g }, { 'base': 'AE', 'letters': /[\u00C6\u01FC\u01E2]/g }, { 'base': 'AO', 'letters': /[\uA734]/g }, { 'base': 'AU', 'letters': /[\uA736]/g }, { 'base': 'AV', 'letters': /[\uA738\uA73A]/g }, { 'base': 'AY', 'letters': /[\uA73C]/g }, { 'base': 'B', 'letters': /[\u0042\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181]/g }, { 'base': 'C', 'letters': /[\u0043\u24B8\uFF23\u0106\u0108\u010A\u010C\u00C7\u1E08\u0187\u023B\uA73E]/g }, { 'base': 'D', 'letters': /[\u0044\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779]/g }, { 'base': 'DZ', 'letters': /[\u01F1\u01C4]/g }, { 'base': 'Dz', 'letters': /[\u01F2\u01C5]/g }, { 'base': 'E', 'letters': /[\u0045\u24BA\uFF25\u00C8\u00C9\u00CA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\u00CB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E]/g }, { 'base': 'F', 'letters': /[\u0046\u24BB\uFF26\u1E1E\u0191\uA77B]/g }, { 'base': 'G', 'letters': /[\u0047\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E]/g }, { 'base': 'H', 'letters': /[\u0048\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D]/g }, { 'base': 'I', 'letters': /[\u0049\u24BE\uFF29\u00CC\u00CD\u00CE\u0128\u012A\u012C\u0130\u00CF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197]/g }, { 'base': 'J', 'letters': /[\u004A\u24BF\uFF2A\u0134\u0248]/g }, { 'base': 'K', 'letters': /[\u004B\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2]/g }, { 'base': 'L', 'letters': /[\u004C\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780]/g }, { 'base': 'LJ', 'letters': /[\u01C7]/g }, { 'base': 'Lj', 'letters': /[\u01C8]/g }, { 'base': 'M', 'letters': /[\u004D\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C]/g }, { 'base': 'N', 'letters': /[\u004E\u24C3\uFF2E\u01F8\u0143\u00D1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4]/g }, { 'base': 'NJ', 'letters': /[\u01CA]/g }, { 'base': 'Nj', 'letters': /[\u01CB]/g }, { 'base': 'O', 'letters': /[\u004F\u24C4\uFF2F\u00D2\u00D3\u00D4\u1ED2\u1ED0\u1ED6\u1ED4\u00D5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\u00D6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\u00D8\u01FE\u0186\u019F\uA74A\uA74C]/g }, { 'base': 'OI', 'letters': /[\u01A2]/g }, { 'base': 'OO', 'letters': /[\uA74E]/g }, { 'base': 'OU', 'letters': /[\u0222]/g }, { 'base': 'P', 'letters': /[\u0050\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754]/g }, { 'base': 'Q', 'letters': /[\u0051\u24C6\uFF31\uA756\uA758\u024A]/g }, { 'base': 'R', 'letters': /[\u0052\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782]/g }, { 'base': 'S', 'letters': /[\u0053\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784]/g }, { 'base': 'T', 'letters': /[\u0054\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786]/g }, { 'base': 'TZ', 'letters': /[\uA728]/g }, { 'base': 'U', 'letters': /[\u0055\u24CA\uFF35\u00D9\u00DA\u00DB\u0168\u1E78\u016A\u1E7A\u016C\u00DC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244]/g }, { 'base': 'V', 'letters': /[\u0056\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245]/g }, { 'base': 'VY', 'letters': /[\uA760]/g }, { 'base': 'W', 'letters': /[\u0057\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72]/g }, { 'base': 'X', 'letters': /[\u0058\u24CD\uFF38\u1E8A\u1E8C]/g }, { 'base': 'Y', 'letters': /[\u0059\u24CE\uFF39\u1EF2\u00DD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE]/g }, { 'base': 'Z', 'letters': /[\u005A\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762]/g }, { 'base': 'a', 'letters': /[\u0061\u24D0\uFF41\u1E9A\u00E0\u00E1\u00E2\u1EA7\u1EA5\u1EAB\u1EA9\u00E3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\u00E4\u01DF\u1EA3\u00E5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250]/g }, { 'base': 'aa', 'letters': /[\uA733]/g }, { 'base': 'ae', 'letters': /[\u00E6\u01FD\u01E3]/g }, { 'base': 'ao', 'letters': /[\uA735]/g }, { 'base': 'au', 'letters': /[\uA737]/g }, { 'base': 'av', 'letters': /[\uA739\uA73B]/g }, { 'base': 'ay', 'letters': /[\uA73D]/g }, { 'base': 'b', 'letters': /[\u0062\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253]/g }, { 'base': 'c', 'letters': /[\u0063\u24D2\uFF43\u0107\u0109\u010B\u010D\u00E7\u1E09\u0188\u023C\uA73F\u2184]/g }, { 'base': 'd', 'letters': /[\u0064\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A]/g }, { 'base': 'dz', 'letters': /[\u01F3\u01C6]/g }, { 'base': 'e', 'letters': /[\u0065\u24D4\uFF45\u00E8\u00E9\u00EA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\u00EB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD]/g }, { 'base': 'f', 'letters': /[\u0066\u24D5\uFF46\u1E1F\u0192\uA77C]/g }, { 'base': 'g', 'letters': /[\u0067\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F]/g }, { 'base': 'h', 'letters': /[\u0068\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265]/g }, { 'base': 'hv', 'letters': /[\u0195]/g }, { 'base': 'i', 'letters': /[\u0069\u24D8\uFF49\u00EC\u00ED\u00EE\u0129\u012B\u012D\u00EF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131]/g }, { 'base': 'j', 'letters': /[\u006A\u24D9\uFF4A\u0135\u01F0\u0249]/g }, { 'base': 'k', 'letters': /[\u006B\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3]/g }, { 'base': 'l', 'letters': /[\u006C\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747]/g }, { 'base': 'lj', 'letters': /[\u01C9]/g }, { 'base': 'm', 'letters': /[\u006D\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F]/g }, { 'base': 'n', 'letters': /[\u006E\u24DD\uFF4E\u01F9\u0144\u00F1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5]/g }, { 'base': 'nj', 'letters': /[\u01CC]/g }, { 'base': 'o', 'letters': /[\u006F\u24DE\uFF4F\u00F2\u00F3\u00F4\u1ED3\u1ED1\u1ED7\u1ED5\u00F5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\u00F6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\u00F8\u01FF\u0254\uA74B\uA74D\u0275]/g }, { 'base': 'oi', 'letters': /[\u01A3]/g }, { 'base': 'ou', 'letters': /[\u0223]/g }, { 'base': 'oo', 'letters': /[\uA74F]/g }, { 'base': 'p', 'letters': /[\u0070\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755]/g }, { 'base': 'q', 'letters': /[\u0071\u24E0\uFF51\u024B\uA757\uA759]/g }, { 'base': 'r', 'letters': /[\u0072\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783]/g }, { 'base': 's', 'letters': /[\u0073\u24E2\uFF53\u00DF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B]/g }, { 'base': 't', 'letters': /[\u0074\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787]/g }, { 'base': 'tz', 'letters': /[\uA729]/g }, { 'base': 'u', 'letters': /[\u0075\u24E4\uFF55\u00F9\u00FA\u00FB\u0169\u1E79\u016B\u1E7B\u016D\u00FC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289]/g }, { 'base': 'v', 'letters': /[\u0076\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C]/g }, { 'base': 'vy', 'letters': /[\uA761]/g }, { 'base': 'w', 'letters': /[\u0077\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73]/g }, { 'base': 'x', 'letters': /[\u0078\u24E7\uFF58\u1E8B\u1E8D]/g }, { 'base': 'y', 'letters': /[\u0079\u24E8\uFF59\u1EF3\u00FD\u0177\u1EF9\u0233\u1E8F\u00FF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF]/g }, { 'base': 'z', 'letters': /[\u007A\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763]/g }];
	
	var stripDiacritics = function stripDiacritics(str) {
		for (var i = 0; i < map.length; i++) {
			str = str.replace(map[i].letters, map[i].base);
		}
		return str;
	};
	
	exports.default = stripDiacritics;

/***/ }),
/* 963 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var trim = function trim(str) {
	  return str.replace(/^\s+|\s+$/g, '');
	};
	
	exports.default = trim;

/***/ }),
/* 964 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _classnames = __webpack_require__(958);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(956);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var menuRenderer = function menuRenderer(_ref) {
		var focusedOption = _ref.focusedOption,
		    focusOption = _ref.focusOption,
		    inputValue = _ref.inputValue,
		    instancePrefix = _ref.instancePrefix,
		    onFocus = _ref.onFocus,
		    onOptionRef = _ref.onOptionRef,
		    onSelect = _ref.onSelect,
		    optionClassName = _ref.optionClassName,
		    optionComponent = _ref.optionComponent,
		    optionRenderer = _ref.optionRenderer,
		    options = _ref.options,
		    removeValue = _ref.removeValue,
		    selectValue = _ref.selectValue,
		    valueArray = _ref.valueArray,
		    valueKey = _ref.valueKey;
	
		var Option = optionComponent;
	
		return options.map(function (option, i) {
			var isSelected = valueArray && valueArray.some(function (x) {
				return x[valueKey] === option[valueKey];
			});
			var isFocused = option === focusedOption;
			var optionClass = (0, _classnames2.default)(optionClassName, {
				'Select-option': true,
				'is-selected': isSelected,
				'is-focused': isFocused,
				'is-disabled': option.disabled
			});
	
			return _react2.default.createElement(
				Option,
				{
					className: optionClass,
					focusOption: focusOption,
					inputValue: inputValue,
					instancePrefix: instancePrefix,
					isDisabled: option.disabled,
					isFocused: isFocused,
					isSelected: isSelected,
					key: 'option-' + i + '-' + option[valueKey],
					onFocus: onFocus,
					onSelect: onSelect,
					option: option,
					optionIndex: i,
					ref: function ref(_ref2) {
						onOptionRef(_ref2, isFocused);
					},
					removeValue: removeValue,
					selectValue: selectValue
				},
				optionRenderer(option, i, inputValue)
			);
		});
	};
	
	menuRenderer.propTypes = {
		focusOption: _propTypes2.default.func,
		focusedOption: _propTypes2.default.object,
		inputValue: _propTypes2.default.string,
		instancePrefix: _propTypes2.default.string,
		onFocus: _propTypes2.default.func,
		onOptionRef: _propTypes2.default.func,
		onSelect: _propTypes2.default.func,
		optionClassName: _propTypes2.default.string,
		optionComponent: _propTypes2.default.func,
		optionRenderer: _propTypes2.default.func,
		options: _propTypes2.default.array,
		removeValue: _propTypes2.default.func,
		selectValue: _propTypes2.default.func,
		valueArray: _propTypes2.default.array,
		valueKey: _propTypes2.default.string
	};
	
	exports.default = menuRenderer;

/***/ }),
/* 965 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _classnames = __webpack_require__(958);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(956);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _blockEvent = __webpack_require__(966);
	
	var _blockEvent2 = _interopRequireDefault(_blockEvent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Option = function (_React$Component) {
		_inherits(Option, _React$Component);
	
		function Option(props) {
			_classCallCheck(this, Option);
	
			var _this = _possibleConstructorReturn(this, (Option.__proto__ || Object.getPrototypeOf(Option)).call(this, props));
	
			_this.handleMouseDown = _this.handleMouseDown.bind(_this);
			_this.handleMouseEnter = _this.handleMouseEnter.bind(_this);
			_this.handleMouseMove = _this.handleMouseMove.bind(_this);
			_this.handleTouchStart = _this.handleTouchStart.bind(_this);
			_this.handleTouchEnd = _this.handleTouchEnd.bind(_this);
			_this.handleTouchMove = _this.handleTouchMove.bind(_this);
			_this.onFocus = _this.onFocus.bind(_this);
			return _this;
		}
	
		_createClass(Option, [{
			key: 'handleMouseDown',
			value: function handleMouseDown(event) {
				event.preventDefault();
				event.stopPropagation();
				this.props.onSelect(this.props.option, event);
			}
		}, {
			key: 'handleMouseEnter',
			value: function handleMouseEnter(event) {
				this.onFocus(event);
			}
		}, {
			key: 'handleMouseMove',
			value: function handleMouseMove(event) {
				this.onFocus(event);
			}
		}, {
			key: 'handleTouchEnd',
			value: function handleTouchEnd(event) {
				// Check if the view is being dragged, In this case
				// we don't want to fire the click event (because the user only wants to scroll)
				if (this.dragging) return;
	
				this.handleMouseDown(event);
			}
		}, {
			key: 'handleTouchMove',
			value: function handleTouchMove() {
				// Set a flag that the view is being dragged
				this.dragging = true;
			}
		}, {
			key: 'handleTouchStart',
			value: function handleTouchStart() {
				// Set a flag that the view is not being dragged
				this.dragging = false;
			}
		}, {
			key: 'onFocus',
			value: function onFocus(event) {
				if (!this.props.isFocused) {
					this.props.onFocus(this.props.option, event);
				}
			}
		}, {
			key: 'render',
			value: function render() {
				var _props = this.props,
				    option = _props.option,
				    instancePrefix = _props.instancePrefix,
				    optionIndex = _props.optionIndex;
	
				var className = (0, _classnames2.default)(this.props.className, option.className);
	
				return option.disabled ? _react2.default.createElement(
					'div',
					{ className: className,
						onMouseDown: _blockEvent2.default,
						onClick: _blockEvent2.default },
					this.props.children
				) : _react2.default.createElement(
					'div',
					{ className: className,
						style: option.style,
						role: 'option',
						'aria-label': option.label,
						onMouseDown: this.handleMouseDown,
						onMouseEnter: this.handleMouseEnter,
						onMouseMove: this.handleMouseMove,
						onTouchStart: this.handleTouchStart,
						onTouchMove: this.handleTouchMove,
						onTouchEnd: this.handleTouchEnd,
						id: instancePrefix + '-option-' + optionIndex,
						title: option.title },
					this.props.children
				);
			}
		}]);
	
		return Option;
	}(_react2.default.Component);
	
	Option.propTypes = {
		children: _propTypes2.default.node,
		className: _propTypes2.default.string, // className (based on mouse position)
		instancePrefix: _propTypes2.default.string.isRequired, // unique prefix for the ids (used for aria)
		isDisabled: _propTypes2.default.bool, // the option is disabled
		isFocused: _propTypes2.default.bool, // the option is focused
		isSelected: _propTypes2.default.bool, // the option is selected
		onFocus: _propTypes2.default.func, // method to handle mouseEnter on option element
		onSelect: _propTypes2.default.func, // method to handle click on option element
		onUnfocus: _propTypes2.default.func, // method to handle mouseLeave on option element
		option: _propTypes2.default.object.isRequired, // object that is base for that option
		optionIndex: _propTypes2.default.number // index of the option, used to generate unique ids for aria
	};
	
	exports.default = Option;

/***/ }),
/* 966 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	exports.default = function (event) {
		event.preventDefault();
		event.stopPropagation();
		if (event.target.tagName !== 'A' || !('href' in event.target)) {
			return;
		}
		if (event.target.target) {
			window.open(event.target.href, event.target.target);
		} else {
			window.location.href = event.target.href;
		}
	};

/***/ }),
/* 967 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _classnames = __webpack_require__(958);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(956);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Value = function (_React$Component) {
		_inherits(Value, _React$Component);
	
		function Value(props) {
			_classCallCheck(this, Value);
	
			var _this = _possibleConstructorReturn(this, (Value.__proto__ || Object.getPrototypeOf(Value)).call(this, props));
	
			_this.handleMouseDown = _this.handleMouseDown.bind(_this);
			_this.onRemove = _this.onRemove.bind(_this);
			_this.handleTouchEndRemove = _this.handleTouchEndRemove.bind(_this);
			_this.handleTouchMove = _this.handleTouchMove.bind(_this);
			_this.handleTouchStart = _this.handleTouchStart.bind(_this);
			return _this;
		}
	
		_createClass(Value, [{
			key: 'handleMouseDown',
			value: function handleMouseDown(event) {
				if (event.type === 'mousedown' && event.button !== 0) {
					return;
				}
				if (this.props.onClick) {
					event.stopPropagation();
					this.props.onClick(this.props.value, event);
					return;
				}
				if (this.props.value.href) {
					event.stopPropagation();
				}
			}
		}, {
			key: 'onRemove',
			value: function onRemove(event) {
				event.preventDefault();
				event.stopPropagation();
				this.props.onRemove(this.props.value);
			}
		}, {
			key: 'handleTouchEndRemove',
			value: function handleTouchEndRemove(event) {
				// Check if the view is being dragged, In this case
				// we don't want to fire the click event (because the user only wants to scroll)
				if (this.dragging) return;
	
				// Fire the mouse events
				this.onRemove(event);
			}
		}, {
			key: 'handleTouchMove',
			value: function handleTouchMove() {
				// Set a flag that the view is being dragged
				this.dragging = true;
			}
		}, {
			key: 'handleTouchStart',
			value: function handleTouchStart() {
				// Set a flag that the view is not being dragged
				this.dragging = false;
			}
		}, {
			key: 'renderRemoveIcon',
			value: function renderRemoveIcon() {
				if (this.props.disabled || !this.props.onRemove) return;
				return _react2.default.createElement(
					'span',
					{ className: 'Select-value-icon',
						'aria-hidden': 'true',
						onMouseDown: this.onRemove,
						onTouchEnd: this.handleTouchEndRemove,
						onTouchStart: this.handleTouchStart,
						onTouchMove: this.handleTouchMove },
					'\xD7'
				);
			}
		}, {
			key: 'renderLabel',
			value: function renderLabel() {
				var className = 'Select-value-label';
				return this.props.onClick || this.props.value.href ? _react2.default.createElement(
					'a',
					{ className: className, href: this.props.value.href, target: this.props.value.target, onMouseDown: this.handleMouseDown, onTouchEnd: this.handleMouseDown },
					this.props.children
				) : _react2.default.createElement(
					'span',
					{ className: className, role: 'option', 'aria-selected': 'true', id: this.props.id },
					this.props.children
				);
			}
		}, {
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					'div',
					{ className: (0, _classnames2.default)('Select-value', this.props.value.disabled ? 'Select-value-disabled' : '', this.props.value.className),
						style: this.props.value.style,
						title: this.props.value.title
					},
					this.renderRemoveIcon(),
					this.renderLabel()
				);
			}
		}]);
	
		return Value;
	}(_react2.default.Component);
	
	Value.propTypes = {
		children: _propTypes2.default.node,
		disabled: _propTypes2.default.bool, // disabled prop passed to ReactSelect
		id: _propTypes2.default.string, // Unique id for the value - used for aria
		onClick: _propTypes2.default.func, // method to handle click on value label
		onRemove: _propTypes2.default.func, // method to handle removal of the value
		value: _propTypes2.default.object.isRequired // the option object for this value
	};
	
	exports.default = Value;

/***/ }),
/* 968 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _propTypes = __webpack_require__(956);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Select = __webpack_require__(954);
	
	var _Select2 = _interopRequireDefault(_Select);
	
	var _stripDiacritics = __webpack_require__(962);
	
	var _stripDiacritics2 = _interopRequireDefault(_stripDiacritics);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
		autoload: _propTypes2.default.bool.isRequired, // automatically call the `loadOptions` prop on-mount; defaults to true
		cache: _propTypes2.default.any, // object to use to cache results; set to null/false to disable caching
		children: _propTypes2.default.func.isRequired, // Child function responsible for creating the inner Select component; (props: Object): PropTypes.element
		ignoreAccents: _propTypes2.default.bool, // strip diacritics when filtering; defaults to true
		ignoreCase: _propTypes2.default.bool, // perform case-insensitive filtering; defaults to true
		loadOptions: _propTypes2.default.func.isRequired, // callback to load options asynchronously; (inputValue: string, callback: Function): ?Promise
		loadingPlaceholder: _propTypes2.default.oneOfType([// replaces the placeholder while options are loading
		_propTypes2.default.string, _propTypes2.default.node]),
		multi: _propTypes2.default.bool, // multi-value input
		noResultsText: _propTypes2.default.oneOfType([// field noResultsText, displayed when no options come back from the server
		_propTypes2.default.string, _propTypes2.default.node]),
		onChange: _propTypes2.default.func, // onChange handler: function (newValue) {}
		onInputChange: _propTypes2.default.func, // optional for keeping track of what is being typed
		options: _propTypes2.default.array.isRequired, // array of options
		placeholder: _propTypes2.default.oneOfType([// field placeholder, displayed when there's no value (shared with Select)
		_propTypes2.default.string, _propTypes2.default.node]),
		searchPromptText: _propTypes2.default.oneOfType([// label to prompt for search input
		_propTypes2.default.string, _propTypes2.default.node]),
		value: _propTypes2.default.any // initial field value
	};
	
	var defaultCache = {};
	
	var defaultChildren = function defaultChildren(props) {
		return _react2.default.createElement(_Select2.default, props);
	};
	
	var defaultProps = {
		autoload: true,
		cache: defaultCache,
		children: defaultChildren,
		ignoreAccents: true,
		ignoreCase: true,
		loadingPlaceholder: 'Loading...',
		options: [],
		searchPromptText: 'Type to search'
	};
	
	var Async = function (_Component) {
		_inherits(Async, _Component);
	
		function Async(props, context) {
			_classCallCheck(this, Async);
	
			var _this = _possibleConstructorReturn(this, (Async.__proto__ || Object.getPrototypeOf(Async)).call(this, props, context));
	
			_this._cache = props.cache === defaultCache ? {} : props.cache;
	
			_this.state = {
				inputValue: '',
				isLoading: false,
				options: props.options
			};
	
			_this.onInputChange = _this.onInputChange.bind(_this);
			return _this;
		}
	
		_createClass(Async, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				var autoload = this.props.autoload;
	
	
				if (autoload) {
					this.loadOptions('');
				}
			}
		}, {
			key: 'componentWillReceiveProps',
			value: function componentWillReceiveProps(nextProps) {
				if (nextProps.options !== this.props.options) {
					this.setState({
						options: nextProps.options
					});
				}
			}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				this._callback = null;
			}
		}, {
			key: 'loadOptions',
			value: function loadOptions(inputValue) {
				var _this2 = this;
	
				var loadOptions = this.props.loadOptions;
	
				var cache = this._cache;
	
				if (cache && Object.prototype.hasOwnProperty.call(cache, inputValue)) {
					this._callback = null;
	
					this.setState({
						isLoading: false,
						options: cache[inputValue]
					});
	
					return;
				}
	
				var callback = function callback(error, data) {
					var options = data && data.options || [];
	
					if (cache) {
						cache[inputValue] = options;
					}
	
					if (callback === _this2._callback) {
						_this2._callback = null;
	
						_this2.setState({
							isLoading: false,
							options: options
						});
					}
				};
	
				// Ignore all but the most recent request
				this._callback = callback;
	
				var promise = loadOptions(inputValue, callback);
				if (promise) {
					promise.then(function (data) {
						return callback(null, data);
					}, function (error) {
						return callback(error);
					});
				}
	
				if (this._callback && !this.state.isLoading) {
					this.setState({
						isLoading: true
					});
				}
			}
		}, {
			key: 'onInputChange',
			value: function onInputChange(inputValue) {
				var _props = this.props,
				    ignoreAccents = _props.ignoreAccents,
				    ignoreCase = _props.ignoreCase,
				    onInputChange = _props.onInputChange;
	
				var newInputValue = inputValue;
	
				if (onInputChange) {
					var value = onInputChange(newInputValue);
					// Note: != used deliberately here to catch undefined and null
					if (value != null && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) !== 'object') {
						newInputValue = '' + value;
					}
				}
	
				var transformedInputValue = newInputValue;
	
				if (ignoreAccents) {
					transformedInputValue = (0, _stripDiacritics2.default)(transformedInputValue);
				}
	
				if (ignoreCase) {
					transformedInputValue = transformedInputValue.toLowerCase();
				}
	
				this.setState({ inputValue: newInputValue });
				this.loadOptions(transformedInputValue);
	
				// Return new input value, but without applying toLowerCase() to avoid modifying the user's view case of the input while typing.
				return newInputValue;
			}
		}, {
			key: 'noResultsText',
			value: function noResultsText() {
				var _props2 = this.props,
				    loadingPlaceholder = _props2.loadingPlaceholder,
				    noResultsText = _props2.noResultsText,
				    searchPromptText = _props2.searchPromptText;
				var _state = this.state,
				    inputValue = _state.inputValue,
				    isLoading = _state.isLoading;
	
	
				if (isLoading) {
					return loadingPlaceholder;
				}
				if (inputValue && noResultsText) {
					return noResultsText;
				}
				return searchPromptText;
			}
		}, {
			key: 'focus',
			value: function focus() {
				this.select.focus();
			}
		}, {
			key: 'render',
			value: function render() {
				var _this3 = this;
	
				var _props3 = this.props,
				    children = _props3.children,
				    loadingPlaceholder = _props3.loadingPlaceholder,
				    placeholder = _props3.placeholder;
				var _state2 = this.state,
				    isLoading = _state2.isLoading,
				    options = _state2.options;
	
	
				var props = {
					noResultsText: this.noResultsText(),
					placeholder: isLoading ? loadingPlaceholder : placeholder,
					options: isLoading && loadingPlaceholder ? [] : options,
					ref: function ref(_ref) {
						return _this3.select = _ref;
					}
				};
	
				return children(_extends({}, this.props, props, {
					isLoading: isLoading,
					onInputChange: this.onInputChange
				}));
			}
		}]);
	
		return Async;
	}(_react.Component);
	
	exports.default = Async;
	
	
	Async.propTypes = propTypes;
	Async.defaultProps = defaultProps;

/***/ }),
/* 969 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _propTypes = __webpack_require__(956);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Async = __webpack_require__(968);
	
	var _Async2 = _interopRequireDefault(_Async);
	
	var _Creatable = __webpack_require__(970);
	
	var _Creatable2 = _interopRequireDefault(_Creatable);
	
	var _Select = __webpack_require__(954);
	
	var _Select2 = _interopRequireDefault(_Select);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AsyncCreatableSelect = function (_React$Component) {
		_inherits(AsyncCreatableSelect, _React$Component);
	
		function AsyncCreatableSelect() {
			_classCallCheck(this, AsyncCreatableSelect);
	
			return _possibleConstructorReturn(this, (AsyncCreatableSelect.__proto__ || Object.getPrototypeOf(AsyncCreatableSelect)).apply(this, arguments));
		}
	
		_createClass(AsyncCreatableSelect, [{
			key: 'focus',
			value: function focus() {
				this.select.focus();
			}
		}, {
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				return _react2.default.createElement(
					_Async2.default,
					this.props,
					function (_ref) {
						var ref = _ref.ref,
						    asyncProps = _objectWithoutProperties(_ref, ['ref']);
	
						var asyncRef = ref;
						return _react2.default.createElement(
							_Creatable2.default,
							asyncProps,
							function (_ref2) {
								var ref = _ref2.ref,
								    creatableProps = _objectWithoutProperties(_ref2, ['ref']);
	
								var creatableRef = ref;
								return _this2.props.children(_extends({}, creatableProps, {
									ref: function ref(select) {
										creatableRef(select);
										asyncRef(select);
										_this2.select = select;
									}
								}));
							}
						);
					}
				);
			}
		}]);
	
		return AsyncCreatableSelect;
	}(_react2.default.Component);
	
	var defaultChildren = function defaultChildren(props) {
		return _react2.default.createElement(_Select2.default, props);
	};
	
	AsyncCreatableSelect.propTypes = {
		children: _propTypes2.default.func.isRequired // Child function responsible for creating the inner Select component; (props: Object): PropTypes.element
	};
	
	AsyncCreatableSelect.defaultProps = {
		children: defaultChildren
	};
	
	exports.default = AsyncCreatableSelect;

/***/ }),
/* 970 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _propTypes = __webpack_require__(956);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _defaultFilterOptions = __webpack_require__(961);
	
	var _defaultFilterOptions2 = _interopRequireDefault(_defaultFilterOptions);
	
	var _defaultMenuRenderer = __webpack_require__(964);
	
	var _defaultMenuRenderer2 = _interopRequireDefault(_defaultMenuRenderer);
	
	var _Select = __webpack_require__(954);
	
	var _Select2 = _interopRequireDefault(_Select);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CreatableSelect = function (_React$Component) {
		_inherits(CreatableSelect, _React$Component);
	
		function CreatableSelect(props, context) {
			_classCallCheck(this, CreatableSelect);
	
			var _this = _possibleConstructorReturn(this, (CreatableSelect.__proto__ || Object.getPrototypeOf(CreatableSelect)).call(this, props, context));
	
			_this.filterOptions = _this.filterOptions.bind(_this);
			_this.menuRenderer = _this.menuRenderer.bind(_this);
			_this.onInputKeyDown = _this.onInputKeyDown.bind(_this);
			_this.onInputChange = _this.onInputChange.bind(_this);
			_this.onOptionSelect = _this.onOptionSelect.bind(_this);
			return _this;
		}
	
		_createClass(CreatableSelect, [{
			key: 'createNewOption',
			value: function createNewOption() {
				var _props = this.props,
				    isValidNewOption = _props.isValidNewOption,
				    newOptionCreator = _props.newOptionCreator,
				    onNewOptionClick = _props.onNewOptionClick,
				    _props$options = _props.options,
				    options = _props$options === undefined ? [] : _props$options;
	
	
				if (isValidNewOption({ label: this.inputValue })) {
					var option = newOptionCreator({ label: this.inputValue, labelKey: this.labelKey, valueKey: this.valueKey });
					var _isOptionUnique = this.isOptionUnique({ option: option, options: options });
	
					// Don't add the same option twice.
					if (_isOptionUnique) {
						if (onNewOptionClick) {
							onNewOptionClick(option);
						} else {
							options.unshift(option);
	
							this.select.selectValue(option);
						}
					}
				}
			}
		}, {
			key: 'filterOptions',
			value: function filterOptions() {
				var _props2 = this.props,
				    filterOptions = _props2.filterOptions,
				    isValidNewOption = _props2.isValidNewOption,
				    promptTextCreator = _props2.promptTextCreator,
				    showNewOptionAtTop = _props2.showNewOptionAtTop;
	
				// TRICKY Check currently selected options as well.
				// Don't display a create-prompt for a value that's selected.
				// This covers async edge-cases where a newly-created Option isn't yet in the async-loaded array.
	
				var excludeOptions = (arguments.length <= 2 ? undefined : arguments[2]) || [];
	
				var filteredOptions = filterOptions.apply(undefined, arguments) || [];
	
				if (isValidNewOption({ label: this.inputValue })) {
					var _newOptionCreator = this.props.newOptionCreator;
	
	
					var option = _newOptionCreator({
						label: this.inputValue,
						labelKey: this.labelKey,
						valueKey: this.valueKey
					});
	
					// TRICKY Compare to all options (not just filtered options) in case option has already been selected).
					// For multi-selects, this would remove it from the filtered list.
					var _isOptionUnique2 = this.isOptionUnique({
						option: option,
						options: excludeOptions.concat(filteredOptions)
					});
	
					if (_isOptionUnique2) {
						var prompt = promptTextCreator(this.inputValue);
	
						this._createPlaceholderOption = _newOptionCreator({
							label: prompt,
							labelKey: this.labelKey,
							valueKey: this.valueKey
						});
	
						if (showNewOptionAtTop) {
							filteredOptions.unshift(this._createPlaceholderOption);
						} else {
							filteredOptions.push(this._createPlaceholderOption);
						}
					}
				}
	
				return filteredOptions;
			}
		}, {
			key: 'isOptionUnique',
			value: function isOptionUnique(_ref) {
				var option = _ref.option,
				    options = _ref.options;
				var isOptionUnique = this.props.isOptionUnique;
	
	
				options = options || this.props.options;
	
				return isOptionUnique({
					labelKey: this.labelKey,
					option: option,
					options: options,
					valueKey: this.valueKey
				});
			}
		}, {
			key: 'menuRenderer',
			value: function menuRenderer(params) {
				var menuRenderer = this.props.menuRenderer;
	
	
				return menuRenderer(_extends({}, params, {
					onSelect: this.onOptionSelect,
					selectValue: this.onOptionSelect
				}));
			}
		}, {
			key: 'onInputChange',
			value: function onInputChange(input) {
				var onInputChange = this.props.onInputChange;
	
				// This value may be needed in between Select mounts (when this.select is null)
	
				this.inputValue = input;
	
				if (onInputChange) {
					this.inputValue = onInputChange(input);
				}
	
				return this.inputValue;
			}
		}, {
			key: 'onInputKeyDown',
			value: function onInputKeyDown(event) {
				var _props3 = this.props,
				    shouldKeyDownEventCreateNewOption = _props3.shouldKeyDownEventCreateNewOption,
				    onInputKeyDown = _props3.onInputKeyDown;
	
				var focusedOption = this.select.getFocusedOption();
	
				if (focusedOption && focusedOption === this._createPlaceholderOption && shouldKeyDownEventCreateNewOption(event)) {
					this.createNewOption();
	
					// Prevent decorated Select from doing anything additional with this keyDown event
					event.preventDefault();
				} else if (onInputKeyDown) {
					onInputKeyDown(event);
				}
			}
		}, {
			key: 'onOptionSelect',
			value: function onOptionSelect(option) {
				if (option === this._createPlaceholderOption) {
					this.createNewOption();
				} else {
					this.select.selectValue(option);
				}
			}
		}, {
			key: 'focus',
			value: function focus() {
				this.select.focus();
			}
		}, {
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				var _props4 = this.props,
				    refProp = _props4.ref,
				    restProps = _objectWithoutProperties(_props4, ['ref']);
	
				var children = this.props.children;
	
				// We can't use destructuring default values to set the children,
				// because it won't apply work if `children` is null. A falsy check is
				// more reliable in real world use-cases.
	
				if (!children) {
					children = defaultChildren;
				}
	
				var props = _extends({}, restProps, {
					allowCreate: true,
					filterOptions: this.filterOptions,
					menuRenderer: this.menuRenderer,
					onInputChange: this.onInputChange,
					onInputKeyDown: this.onInputKeyDown,
					ref: function ref(_ref2) {
						_this2.select = _ref2;
	
						// These values may be needed in between Select mounts (when this.select is null)
						if (_ref2) {
							_this2.labelKey = _ref2.props.labelKey;
							_this2.valueKey = _ref2.props.valueKey;
						}
						if (refProp) {
							refProp(_ref2);
						}
					}
				});
	
				return children(props);
			}
		}]);
	
		return CreatableSelect;
	}(_react2.default.Component);
	
	var defaultChildren = function defaultChildren(props) {
		return _react2.default.createElement(_Select2.default, props);
	};
	
	var isOptionUnique = function isOptionUnique(_ref3) {
		var option = _ref3.option,
		    options = _ref3.options,
		    labelKey = _ref3.labelKey,
		    valueKey = _ref3.valueKey;
	
		if (!options || !options.length) {
			return true;
		}
	
		return options.filter(function (existingOption) {
			return existingOption[labelKey] === option[labelKey] || existingOption[valueKey] === option[valueKey];
		}).length === 0;
	};
	
	var isValidNewOption = function isValidNewOption(_ref4) {
		var label = _ref4.label;
		return !!label;
	};
	
	var newOptionCreator = function newOptionCreator(_ref5) {
		var label = _ref5.label,
		    labelKey = _ref5.labelKey,
		    valueKey = _ref5.valueKey;
	
		var option = {};
		option[valueKey] = label;
		option[labelKey] = label;
		option.className = 'Select-create-option-placeholder';
	
		return option;
	};
	
	var promptTextCreator = function promptTextCreator(label) {
		return 'Create option "' + label + '"';
	};
	
	var shouldKeyDownEventCreateNewOption = function shouldKeyDownEventCreateNewOption(_ref6) {
		var keyCode = _ref6.keyCode;
	
		switch (keyCode) {
			case 9: // TAB
			case 13: // ENTER
			case 188:
				// COMMA
				return true;
			default:
				return false;
		}
	};
	
	// Default prop methods
	CreatableSelect.isOptionUnique = isOptionUnique;
	CreatableSelect.isValidNewOption = isValidNewOption;
	CreatableSelect.newOptionCreator = newOptionCreator;
	CreatableSelect.promptTextCreator = promptTextCreator;
	CreatableSelect.shouldKeyDownEventCreateNewOption = shouldKeyDownEventCreateNewOption;
	
	CreatableSelect.defaultProps = {
		filterOptions: _defaultFilterOptions2.default,
		isOptionUnique: isOptionUnique,
		isValidNewOption: isValidNewOption,
		menuRenderer: _defaultMenuRenderer2.default,
		newOptionCreator: newOptionCreator,
		promptTextCreator: promptTextCreator,
		shouldKeyDownEventCreateNewOption: shouldKeyDownEventCreateNewOption,
		showNewOptionAtTop: true
	};
	
	CreatableSelect.propTypes = {
		// Child function responsible for creating the inner Select component
		// This component can be used to compose HOCs (eg Creatable and Async)
		// (props: Object): PropTypes.element
		children: _propTypes2.default.func,
	
		// See Select.propTypes.filterOptions
		filterOptions: _propTypes2.default.any,
	
		// Searches for any matching option within the set of options.
		// This function prevents duplicate options from being created.
		// ({ option: Object, options: Array, labelKey: string, valueKey: string }): boolean
		isOptionUnique: _propTypes2.default.func,
	
		// Determines if the current input text represents a valid option.
		// ({ label: string }): boolean
		isValidNewOption: _propTypes2.default.func,
	
		// See Select.propTypes.menuRenderer
		menuRenderer: _propTypes2.default.any,
	
		// Factory to create new option.
		// ({ label: string, labelKey: string, valueKey: string }): Object
		newOptionCreator: _propTypes2.default.func,
	
		// input change handler: function (inputValue) {}
		onInputChange: _propTypes2.default.func,
	
		// input keyDown handler: function (event) {}
		onInputKeyDown: _propTypes2.default.func,
	
		// new option click handler: function (option) {}
		onNewOptionClick: _propTypes2.default.func,
	
		// See Select.propTypes.options
		options: _propTypes2.default.array,
	
		// Creates prompt/placeholder option text.
		// (filterText: string): string
		promptTextCreator: _propTypes2.default.func,
	
		ref: _propTypes2.default.func,
	
		// Decides if a keyDown event (eg its `keyCode`) should result in the creation of a new option.
		shouldKeyDownEventCreateNewOption: _propTypes2.default.func,
	
		// Where to show prompt/placeholder option text.
		// true: new option prompt at top of list (default)
		// false: new option prompt at bottom of list
		showNewOptionAtTop: _propTypes2.default.bool
	};
	
	exports.default = CreatableSelect;

/***/ }),
/* 971 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var deselectCurrent = __webpack_require__(972);
	
	var clipboardToIE11Formatting = {
	  "text/plain": "Text",
	  "text/html": "Url",
	  "default": "Text"
	}
	
	var defaultMessage = "Copy to clipboard: #{key}, Enter";
	
	function format(message) {
	  var copyKey = (/mac os x/i.test(navigator.userAgent) ? "⌘" : "Ctrl") + "+C";
	  return message.replace(/#{\s*key\s*}/g, copyKey);
	}
	
	function copy(text, options) {
	  var debug,
	    message,
	    reselectPrevious,
	    range,
	    selection,
	    mark,
	    success = false;
	  if (!options) {
	    options = {};
	  }
	  debug = options.debug || false;
	  try {
	    reselectPrevious = deselectCurrent();
	
	    range = document.createRange();
	    selection = document.getSelection();
	
	    mark = document.createElement("span");
	    mark.textContent = text;
	    // reset user styles for span element
	    mark.style.all = "unset";
	    // prevents scrolling to the end of the page
	    mark.style.position = "fixed";
	    mark.style.top = 0;
	    mark.style.clip = "rect(0, 0, 0, 0)";
	    // used to preserve spaces and line breaks
	    mark.style.whiteSpace = "pre";
	    // do not inherit user-select (it may be `none`)
	    mark.style.webkitUserSelect = "text";
	    mark.style.MozUserSelect = "text";
	    mark.style.msUserSelect = "text";
	    mark.style.userSelect = "text";
	    mark.addEventListener("copy", function(e) {
	      e.stopPropagation();
	      if (options.format) {
	        e.preventDefault();
	        if (typeof e.clipboardData === "undefined") { // IE 11
	          debug && console.warn("unable to use e.clipboardData");
	          debug && console.warn("trying IE specific stuff");
	          window.clipboardData.clearData();
	          var format = clipboardToIE11Formatting[options.format] || clipboardToIE11Formatting["default"]
	          window.clipboardData.setData(format, text);
	        } else { // all other browsers
	          e.clipboardData.clearData();
	          e.clipboardData.setData(options.format, text);
	        }
	      }
	      if (options.onCopy) {
	        e.preventDefault();
	        options.onCopy(e.clipboardData);
	      }
	    });
	
	    document.body.appendChild(mark);
	
	    range.selectNodeContents(mark);
	    selection.addRange(range);
	
	    var successful = document.execCommand("copy");
	    if (!successful) {
	      throw new Error("copy command was unsuccessful");
	    }
	    success = true;
	  } catch (err) {
	    debug && console.error("unable to copy using execCommand: ", err);
	    debug && console.warn("trying IE specific stuff");
	    try {
	      window.clipboardData.setData(options.format || "text", text);
	      options.onCopy && options.onCopy(window.clipboardData);
	      success = true;
	    } catch (err) {
	      debug && console.error("unable to copy using clipboardData: ", err);
	      debug && console.error("falling back to prompt");
	      message = format("message" in options ? options.message : defaultMessage);
	      window.prompt(message, text);
	    }
	  } finally {
	    if (selection) {
	      if (typeof selection.removeRange == "function") {
	        selection.removeRange(range);
	      } else {
	        selection.removeAllRanges();
	      }
	    }
	
	    if (mark) {
	      document.body.removeChild(mark);
	    }
	    reselectPrevious();
	  }
	
	  return success;
	}
	
	module.exports = copy;


/***/ }),
/* 972 */
/***/ (function(module, exports) {

	
	module.exports = function () {
	  var selection = document.getSelection();
	  if (!selection.rangeCount) {
	    return function () {};
	  }
	  var active = document.activeElement;
	
	  var ranges = [];
	  for (var i = 0; i < selection.rangeCount; i++) {
	    ranges.push(selection.getRangeAt(i));
	  }
	
	  switch (active.tagName.toUpperCase()) { // .toUpperCase handles XHTML
	    case 'INPUT':
	    case 'TEXTAREA':
	      active.blur();
	      break;
	
	    default:
	      active = null;
	      break;
	  }
	
	  selection.removeAllRanges();
	  return function () {
	    selection.type === 'Caret' &&
	    selection.removeAllRanges();
	
	    if (!selection.rangeCount) {
	      ranges.forEach(function(range) {
	        selection.addRange(range);
	      });
	    }
	
	    active &&
	    active.focus();
	  };
	};


/***/ }),
/* 973 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	exports.default = function (_ref) {
	  var onTouchTap = _ref.onTouchTap;
	  var children = _ref.children;
	
	  var rest = _objectWithoutProperties(_ref, ["onTouchTap", "children"]);
	
	  function _onTouchTap(e) {
	    e.preventDefault();
	    e.stopPropagation();
	    onTouchTap();
	  }
	
	  return React.createElement(
	    "a",
	    _extends({}, rest, { href: "#", onClick: _onTouchTap }),
	    children
	  );
	};
	
	module.exports = exports["default"];

/***/ }),
/* 974 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _alt = __webpack_require__(975);
	
	var _alt2 = _interopRequireDefault(_alt);
	
	var _keyBy = __webpack_require__(990);
	
	var _keyBy2 = _interopRequireDefault(_keyBy);
	
	var _assign = __webpack_require__(920);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _moment = __webpack_require__(1021);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _UserActions = __webpack_require__(1158);
	
	var _UserActions2 = _interopRequireDefault(_UserActions);
	
	var _UserUtil = __webpack_require__(1159);
	
	var _UserUtil2 = _interopRequireDefault(_UserUtil);
	
	var _EventBucketActions = __webpack_require__(1218);
	
	var _EventBucketActions2 = _interopRequireDefault(_EventBucketActions);
	
	var _SearchActions = __webpack_require__(1219);
	
	var _SearchActions2 = _interopRequireDefault(_SearchActions);
	
	var _OrderActions = __webpack_require__(1220);
	
	var _OrderActions2 = _interopRequireDefault(_OrderActions);
	
	var _ShiftActions = __webpack_require__(1221);
	
	var _ShiftActions2 = _interopRequireDefault(_ShiftActions);
	
	var _SystemStatesActions = __webpack_require__(1217);
	
	var _SystemStatesActions2 = _interopRequireDefault(_SystemStatesActions);
	
	var _logger = __webpack_require__(1174);
	
	var _logger2 = _interopRequireDefault(_logger);
	
	var _util = __webpack_require__(1183);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var SHOULD_PERSIST = !!window.localStorage;
	var LS_KEY = "eventive-userState";
	var cachedUser = SHOULD_PERSIST && window.localStorage[LS_KEY] && JSON.parse(window.localStorage[LS_KEY]) || {};
	
	// Restore user context from cache if specificed
	if (cachedUser.data) {
	  _logger2.default.setUserContext({
	    id: cachedUser.data.id,
	    email: cachedUser.data.email
	  });
	}
	
	// Inject god user from url if necessary
	var activeGodQuery = /_god_become_user=([^&]+)/g;
	var result = activeGodQuery.exec(window.location.search);
	if (result) {
	  cachedUser.activeGodUser = result[1];
	}
	
	var UserStore = function () {
	  function UserStore() {
	    _classCallCheck(this, UserStore);
	
	    this.bindActions(_UserActions2.default);
	
	    this.state = (0, _assign2.default)({
	      // SELF
	      isLoggedIn: false,
	      apiKey: null,
	      loginSuccess: false,
	      loginInProgress: false,
	      loginErrorMessage: null,
	      data: null,
	
	      forgotSuccess: false,
	      forgotInProgress: false,
	      forgotErrorMessage: null,
	
	      resetSuccess: false,
	      resetInProgress: false,
	      resetErrorMessage: null,
	
	      uploadedFiles: {},
	
	      contentCreatorInvites: {},
	      contentCreatorInviteLookupErrorMessage: null,
	      acceptInProgress: false,
	
	      revenueSharingInvites: {},
	      revenueSharingInviteLookupErrorMessage: null,
	
	      // OTHERS/ORG
	      user: null,
	      accounts: {},
	      roles: {},
	
	      // GODMODE
	      allUsers: {},
	
	      condensedUsers: [],
	      activeGodUser: null,
	      activeGodRole: null,
	      godStealthMode: false,
	
	      //paginated user page
	      paginatedUsers: {
	        page: -1,
	        sorted: [{ id: "organization", desc: false }],
	        pages: 0,
	        users: [],
	        searchTerm: ""
	      },
	      paginatedContentCreators: {
	        page: -1,
	        sorted: [{ id: "organization", desc: false }],
	        pages: 0,
	        users: [],
	        searchTerm: ""
	      },
	      loadingUsers: false,
	      loadingContentCreators: false
	    }, {
	      isLoggedIn: cachedUser.isLoggedIn,
	      apiKey: cachedUser.apiKey,
	      data: cachedUser.data,
	      activeGodUser: cachedUser.activeGodUser
	    });
	
	    // If logged in, fire off initial system state fetch immediately
	    if (this.state.isLoggedIn) {
	      _SystemStatesActions2.default.fetchLocationData.defer();
	    }
	
	    this.exportPublicMethods({
	      isLoggedIn: this.isLoggedIn.bind(this),
	      hasRole: this.hasRole.bind(this),
	      hasPermission: this.hasPermission.bind(this),
	      isGod: this.isGod.bind(this),
	      isBillingGod: this.isBillingGod.bind(this),
	      isGodInAnyForm: this.isGodInAnyForm.bind(this),
	      isEnterprise: this.isEnterprise.bind(this),
	      getGodCredentials: this.getGodCredentials.bind(this),
	      getCredentials: this.getCredentials.bind(this),
	      makeApiKeyQueryString: this.makeApiKeyQueryString.bind(this),
	      getUserId: this.getUserId.bind(this),
	      getUser: this.getUser.bind(this),
	      getUserType: this.getUserType.bind(this),
	      getAccount: this.getAccount.bind(this)
	    });
	  }
	
	  // PUBLIC METHODS
	  // ==============
	
	  _createClass(UserStore, [{
	    key: "isLoggedIn",
	    value: function isLoggedIn() {
	      return this.state.isLoggedIn;
	    }
	  }, {
	    key: "hasRole",
	    value: function hasRole(requiredRole) {
	      var userRole = this.state.activeGodRole || this.state.data && this.state.data.role;
	
	      // if multiple possible roles are passed, check if the user has one of them
	      if (Array.isArray(requiredRole)) {
	        return requiredRole.includes(userRole);
	      }
	
	      return userRole === requiredRole;
	    }
	  }, {
	    key: "hasPermission",
	    value: function hasPermission(permission) {
	      var data = this.state.data;
	
	
	      if (this.state.activeGodRole) {
	        data = this.state.roles[this.state.activeGodRole];
	      }
	
	      if (!data || !data.permissions) {
	        return false;
	      }
	      if (permission === "god") {
	        return this.isGod();
	      }
	      if (!Array.isArray(permission)) {
	        permission = [permission];
	      }
	      return data.permissions === "*" || permission.some(function (p) {
	        return data.permissions.indexOf(p) !== -1;
	      });
	    }
	  }, {
	    key: "isGodInAnyForm",
	    value: function isGodInAnyForm() {
	      var data = this.state.data;
	
	      return data && data.god ? true : false;
	    }
	  }, {
	    key: "isGod",
	    value: function isGod() {
	      var _state = this.state;
	      var data = _state.data;
	      var godStealthMode = _state.godStealthMode;
	
	      return data && data.god && !godStealthMode ? true : false;
	    }
	  }, {
	    key: "isBillingGod",
	    value: function isBillingGod() {
	      var _state2 = this.state;
	      var data = _state2.data;
	      var godStealthMode = _state2.godStealthMode;
	
	      return data && data.billing_god && !godStealthMode ? true : false;
	    }
	  }, {
	    key: "isEnterprise",
	    value: function isEnterprise() {
	      var _state3 = this.state;
	      var data = _state3.data;
	      var godStealthMode = _state3.godStealthMode;
	
	      if (this.state.activeGodUser && this.state.allUsers[this.state.activeGodUser]) {
	        return this.state.allUsers[this.state.activeGodUser].is_enterprise;
	      } else {
	        return data && data.owner && data.owner.is_enterprise;
	      }
	    }
	  }, {
	    key: "getGodCredentials",
	    value: function getGodCredentials() {
	      return this.isGodInAnyForm() && {
	        apiKey: this.state.apiKey,
	        activeUser: this.state.activeGodUser
	      };
	    }
	  }, {
	    key: "getCredentials",
	    value: function getCredentials() {
	      if (this.isGodInAnyForm()) {
	        var _getGodCredentials = this.getGodCredentials();
	
	        var apiKey = _getGodCredentials.apiKey;
	        var activeUser = _getGodCredentials.activeUser;
	
	        return { api_key: apiKey, god_become_user: activeUser };
	      } else {
	        return { api_key: this.state.apiKey };
	      }
	    }
	  }, {
	    key: "makeApiKeyQueryString",
	    value: function makeApiKeyQueryString() {
	      if (this.isGodInAnyForm()) {
	        var _getGodCredentials2 = this.getGodCredentials();
	
	        var apiKey = _getGodCredentials2.apiKey;
	        var activeUser = _getGodCredentials2.activeUser;
	
	        return "api_key=" + apiKey + "&god_become_user=" + activeUser;
	      } else {
	        return "api_key=" + this.state.apiKey;
	      }
	    }
	  }, {
	    key: "getUserId",
	    value: function getUserId() {
	      if (this.isGodInAnyForm()) {
	        return this.state.activeGodUser;
	      } else {
	        return this.state.data && this.state.data.owner && this.state.data.owner.id;
	      }
	    }
	  }, {
	    key: "getUser",
	    value: function getUser() {
	      if (this.isGodInAnyForm()) {
	        return this.state.allUsers[this.state.activeGodUser];
	      } else {
	        return this.state.data && this.state.data.owner;
	      }
	    }
	  }, {
	    key: "getAccount",
	    value: function getAccount() {
	      return this.state.data;
	    }
	  }, {
	    key: "getUserType",
	    value: function getUserType() {
	      var user = this.getUser();
	      if (user) {
	        return user.type;
	      } else {
	        return null;
	      }
	    }
	
	    // SELF-MANIPULATION (logging in/editing/etc)
	    // ==========================================
	
	  }, {
	    key: "onUpdateApiKey",
	    value: function onUpdateApiKey(apiKey) {
	      this.setState({ apiKey: apiKey });
	    }
	  }, {
	    key: "onLogin",
	    value: function onLogin(credentials) {
	      this.setState({ loginInProgress: true, loginErrorMessage: null });
	      _UserUtil2.default.login(credentials.email, credentials.password, credentials.noRedirect).then(function (data) {
	        _UserActions2.default.updateApiKey(data.token);
	        _UserActions2.default.loginSucceeded(data);
	      }).catch(_UserActions2.default.loginFailed);
	    }
	  }, {
	    key: "onLoginWithToken",
	    value: function onLoginWithToken(token) {
	      this.setState({ apiKey: token });
	      _UserUtil2.default.fetchOwnAccount(this.state.apiKey).then(function (data) {
	        _UserActions2.default.loginSucceeded(data);
	      }).catch(_UserActions2.default.fetchFailed);
	    }
	  }, {
	    key: "onLoginSucceeded",
	    value: function onLoginSucceeded(data) {
	      this.setState({
	        isLoggedIn: true,
	        loginSuccess: true,
	        loginInProgress: false,
	        loginErrorMessage: null,
	        data: data
	      });
	
	      _logger2.default.setUserContext({ id: data.id, email: data.email });
	
	      window.Intercom("boot", {
	        app_id: "oj5vkp3b",
	        email: data.email,
	        user_id: data.id
	      });
	
	      if (data.god) {
	        _UserActions2.default.fetchAllUsers.defer();
	        _UserActions2.default.fetchCondensedUsers.defer();
	      } else {
	        _EventBucketActions2.default.fetchAll.defer();
	      }
	
	      // Reset when new user logged in
	      _ShiftActions2.default.reset.defer();
	      _OrderActions2.default.reset.defer();
	      _SearchActions2.default.reset.defer();
	      _SystemStatesActions2.default.fetchLocationData.defer();
	    }
	  }, {
	    key: "onLoginFailed",
	    value: function onLoginFailed(e) {
	      this.setState({
	        isLoggedIn: false,
	        loginInProgress: false,
	        loginSuccess: false,
	        loginErrorMessage: e.message
	      });
	
	      window.Intercom("trackEvent", "login-failed");
	    }
	  }, {
	    key: "onClearErrors",
	    value: function onClearErrors() {
	      this.setState({
	        loginInProgress: false,
	        loginErrorMessage: null
	      });
	    }
	  }, {
	    key: "onLogout",
	    value: function onLogout(noRedirect) {
	      this.setState({
	        isLoggedIn: false,
	        apiKey: null,
	        data: null,
	        user: null,
	        accounts: {},
	        loginSuccess: false,
	        loginInProgress: false,
	        loginErrorMessage: null
	      });
	
	      _logger2.default.setUserContext();
	      window.Intercom("shutdown");
	      if (!noRedirect) {
	        _util.history.push("/login");
	      }
	    }
	  }, {
	    key: "onFetch",
	    value: function onFetch() {
	      _UserUtil2.default.fetchOwnAccount(this.state.apiKey).then(function (data) {
	        _UserActions2.default.setData(data);
	      }).catch(_UserActions2.default.fetchFailed);
	    }
	  }, {
	    key: "onFetchUser",
	    value: function onFetchUser() {
	      var _this = this;
	
	      _UserUtil2.default.fetchUser(this.state.apiKey).then(function (user) {
	        _this.setState({ user: user });
	      }).catch(_UserActions2.default.fetchFailed);
	    }
	  }, {
	    key: "onEditUser",
	    value: function onEditUser(data) {
	      var _this2 = this;
	
	      _UserUtil2.default.editUser(this.state.apiKey, "self", data).then(function (user) {
	        _this2.setState({ user: user });
	        _UserActions2.default.fetch(); // fetch self to refresh status (e.g. needs_stripe)
	      }).catch(_UserActions2.default.editFailed);
	    }
	  }, {
	    key: "onFetchRoles",
	    value: function onFetchRoles() {
	      var _this3 = this;
	
	      _UserUtil2.default.fetchRoles(this.state.apiKey).then(function (roles) {
	        var finalRoles = {};
	        Object.keys(roles).forEach(function (k) {
	          if (!roles[k].allowed_user_types || roles[k].allowed_user_types.indexOf(_this3.getUserType()) !== -1) {
	            finalRoles[k] = roles[k];
	          }
	        });
	        _this3.setState({ roles: finalRoles });
	      }).catch(_UserActions2.default.fetchFailed);
	    }
	  }, {
	    key: "onEdit",
	    value: function onEdit(data) {
	      _UserUtil2.default.editAccount(this.state.apiKey, "self", data).then(function (updated) {
	        _UserActions2.default.setData(updated);
	      }).catch(_UserActions2.default.editFailed);
	    }
	  }, {
	    key: "onSetData",
	    value: function onSetData(data) {
	      this.setState({
	        data: data
	      });
	      _logger2.default.setUserContext({ id: data.id, email: data.email });
	    }
	  }, {
	    key: "onForgotPassword",
	    value: function onForgotPassword(email) {
	      this.setState({
	        forgotInProgress: true
	      });
	      _UserUtil2.default.forgotPassword(email).then(_UserActions2.default.forgotSucceeded).catch(_UserActions2.default.forgotFailed);
	    }
	  }, {
	    key: "onForgotSucceeded",
	    value: function onForgotSucceeded() {
	      this.setState({
	        forgotInProgress: false,
	        forgotSuccess: true,
	        forgotErrorMessage: null
	      });
	    }
	  }, {
	    key: "onForgotFailed",
	    value: function onForgotFailed(e) {
	      this.setState({
	        forgotInProgress: false,
	        forgotSuccess: false,
	        forgotErrorMessage: e.message
	      });
	    }
	  }, {
	    key: "onResetPassword",
	    value: function onResetPassword(data) {
	      this.setState({
	        resetInProgress: true
	      });
	      _UserUtil2.default.resetPassword(data.token, data.password).then(_UserActions2.default.resetSucceeded).catch(_UserActions2.default.resetFailed);
	    }
	  }, {
	    key: "onResetSucceeded",
	    value: function onResetSucceeded() {
	      this.setState({
	        resetInProgress: false,
	        resetSuccess: true,
	        resetErrorMessage: null
	      });
	    }
	  }, {
	    key: "onResetFailed",
	    value: function onResetFailed(e) {
	      this.setState({
	        resetInProgress: false,
	        resetSuccess: false,
	        resetErrorMessage: e.message
	      });
	    }
	  }, {
	    key: "onUserSignup",
	    value: function onUserSignup(options) {
	      this.setState({ loginInProgress: true, loginErrorMessage: null });
	      _UserUtil2.default.signup(options).then(function (data) {
	        _UserActions2.default.updateApiKey(data.token);
	        _UserActions2.default.loginSucceeded(data);
	      }).catch(_UserActions2.default.loginFailed);
	    }
	  }, {
	    key: "onLookupContentCreatorInvite",
	    value: function onLookupContentCreatorInvite(token) {
	      var _this4 = this;
	
	      _UserUtil2.default.lookupContentCreatorInvite(this.state.apiKey, token).then(function (data) {
	        _this4.setState({
	          contentCreatorInvites: _extends({}, _this4.state.contentCreatorInvites, _defineProperty({}, token, data))
	        });
	      }).catch(function (e) {
	        console.log(e);
	        _this4.setState({
	          contentCreatorInviteLookupErrorMessage: e && e.message || "Unable to find invite"
	        });
	      });
	    }
	  }, {
	    key: "onAcceptContentCreatorInvite",
	    value: function onAcceptContentCreatorInvite(token) {
	      var _this5 = this;
	
	      this.setState({ acceptInProgress: true });
	      _UserUtil2.default.acceptContentCreatorInvite(this.state.apiKey, token).then(function (data) {
	        _this5.setState({ acceptInProgress: false });
	        if (data.title && data.title_delivery) {
	          _util.history.push("titles/" + data.title + "/deliveries/" + data.title_delivery);
	        } else if (data.film) {
	          _util.history.push("creator_hub/films/" + data.film);
	        }
	      }).catch(_UserActions2.default.editFailed);
	    }
	  }, {
	    key: "onLookupRevenueSharingInvite",
	    value: function onLookupRevenueSharingInvite(token) {
	      var _this6 = this;
	
	      _UserUtil2.default.lookupRevenueSharingInvite(token).then(function (data) {
	        _this6.setState({
	          revenueSharingInvites: _extends({}, _this6.state.revenueSharingInvites, _defineProperty({}, token, data))
	        });
	      }).catch(function (e) {
	        console.log(e);
	        _this6.setState({
	          revenueSharingInviteLookupErrorMessage: e && e.message || "Unable to find invite"
	        });
	      });
	    }
	  }, {
	    key: "onAcceptRevenueSharingInvite",
	    value: function onAcceptRevenueSharingInvite(token) {
	      var _this7 = this;
	
	      _UserUtil2.default.acceptRevenueSharingInvite(this.state.apiKey, token).then(function (data) {
	        _this7.setState({
	          revenueSharingInvites: _extends({}, _this7.state.revenueSharingInvites, _defineProperty({}, token, _extends({}, _this7.state.revenueSharingInvites[token], {
	            accepted: true
	          })))
	        });
	      }).catch(_UserActions2.default.editFailed);
	    }
	
	    // MANIPULATION OF OTHERS
	    // ======================
	
	  }, {
	    key: "onFetchAccounts",
	    value: function onFetchAccounts() {
	      var _this8 = this;
	
	      _UserUtil2.default.fetchAccounts(this.state.apiKey).then(function (data) {
	        _this8.setState({ accounts: (0, _keyBy2.default)(data.accounts, "id") });
	      }).catch(_UserActions2.default.fetchFailed);
	    }
	  }, {
	    key: "onDeleteAccount",
	    value: function onDeleteAccount(id) {
	      var _this9 = this;
	
	      _UserUtil2.default.deleteAccount(this.state.apiKey, id).then(function () {
	        var accounts = Object.assign({}, _this9.state.accounts);
	        delete accounts[id];
	        _this9.setState({ accounts: accounts });
	      }).catch(_UserActions2.default.fetchFailed);
	    }
	  }, {
	    key: "onCreateAccount",
	    value: function onCreateAccount(values) {
	      var _this10 = this;
	
	      _UserUtil2.default.createAccount(this.state.apiKey, values).then(function (data) {
	        var accounts = _this10.state.accounts;
	
	        accounts[data.id] = data;
	        _this10.setState({ accounts: accounts });
	      }).catch(_UserActions2.default.editFailed);
	    }
	  }, {
	    key: "onEditAccount",
	    value: function onEditAccount(_ref) {
	      var _this11 = this;
	
	      var id = _ref.id;
	      var values = _ref.values;
	
	      _UserUtil2.default.editAccount(this.state.apiKey, id, values).then(function (data) {
	        var accounts = _this11.state.accounts;
	
	        accounts[id] = data;
	        _this11.setState({ accounts: accounts });
	      }).catch(_UserActions2.default.editFailed);
	    }
	  }, {
	    key: "onUploadFile",
	    value: function onUploadFile(_ref2) {
	      var _this12 = this;
	
	      var key = _ref2.key;
	      var file = _ref2.file;
	
	      _UserUtil2.default.uploadFile(UserStore.getState().apiKey, key, file).then(function (data) {
	        var uploadedFiles = _this12.state.uploadedFiles;
	
	        uploadedFiles[key] = data.url;
	        _this12.setState({ uploadedFiles: uploadedFiles });
	      }).catch(_UserActions2.default.editFailed);
	    }
	
	    // GODMODE
	    // =======
	
	  }, {
	    key: "onFetchAllUsers",
	    value: function onFetchAllUsers() {
	      var _this13 = this;
	
	      if (this.state.activeGodUser) {
	        _UserUtil2.default.fetchUser(this.state.apiKey, {
	          apiKey: this.state.apiKey,
	          activeUser: this.state.activeGodUser
	        }).then(function (data) {
	          _this13.setState({
	            allUsers: _defineProperty({}, _this13.state.activeGodUser, data)
	          });
	          _EventBucketActions2.default.fetchAll.defer();
	        }).catch(_UserActions2.default.fetchFailed);
	      }
	      _UserUtil2.default.fetchAllUsers(this.state.apiKey, { excludeContentCreators: true }).then(function (data) {
	        _this13.setState({
	          allUsers: Object.assign({}, _this13.state.allUsers, (0, _keyBy2.default)(data.users, "id")),
	          activeGodUser: _this13.state.activeGodUser || data.users[0].id
	        });
	        _EventBucketActions2.default.fetchAll.defer();
	      }).catch(_UserActions2.default.fetchFailed);
	      _UserUtil2.default.fetchAllUsers(this.state.apiKey, { onlyContentCreators: true }).then(function (data) {
	        _this13.setState({
	          allUsers: Object.assign({}, _this13.state.allUsers, (0, _keyBy2.default)(data.users, "id"))
	        });
	      }).catch(_UserActions2.default.fetchFailed);
	    }
	  }, {
	    key: "onFetchPaginatedUsers",
	    value: function onFetchPaginatedUsers(_ref3) {
	      var _this14 = this;
	
	      var page = _ref3.page;
	      var isContentCreators = _ref3.isContentCreators;
	      var sorted = _ref3.sorted;
	      var searchTerm = _ref3.searchTerm;
	
	      this.setState(_defineProperty({}, isContentCreators ? "loadingContentCreators" : "loadingUsers", true));
	      _UserUtil2.default.fetchPaginatedUsers(this.state.apiKey, page, isContentCreators, sorted, searchTerm).then(function (data) {
	        if (isContentCreators) {
	          _this14.setState({
	            paginatedContentCreators: _extends({}, data, { page: page, sorted: sorted, searchTerm: searchTerm }),
	            loadingContentCreators: false
	          });
	        } else {
	          _this14.setState({
	            paginatedUsers: _extends({}, data, { page: page, sorted: sorted, searchTerm: searchTerm }),
	            loadingUsers: false
	          });
	        }
	      });
	    }
	  }, {
	    key: "onFetchCurrentPage",
	    value: function onFetchCurrentPage(isContentCreators) {
	      var _this15 = this;
	
	      this.setState(_defineProperty({}, isContentCreators ? "loadingContentCreators" : "loadingUsers", true));
	      var dataSet = isContentCreators ? this.state.paginatedUsers : this.state.paginatedContentCreators;
	      _UserUtil2.default.fetchPaginatedUsers(this.state.apiKey, dataSet.page, isContentCreators, dataSet.sorted).then(function (data) {
	        if (isContentCreators) {
	          _this15.setState({
	            paginatedContentCreators: _extends({}, data, {
	              page: dataSet.page,
	              sorted: dataSet.sorted
	            }),
	            loadingContentCreators: false
	          });
	        } else {
	          _this15.setState({
	            paginatedUsers: _extends({}, data, {
	              page: dataSet.page,
	              sorted: dataSet.sorted
	            }),
	            loadingUsers: false
	          });
	        }
	      });
	    }
	  }, {
	    key: "onFetchCondensedUsers",
	    value: function onFetchCondensedUsers() {
	      var _this16 = this;
	
	      _UserUtil2.default.fetchCondensedUsers(this.state.apiKey).then(function (data) {
	        _this16.setState({
	          condensedUsers: data
	        });
	      }).catch(_UserActions2.default.fetchFailed);
	    }
	  }, {
	    key: "onSetGodUser",
	    value: function onSetGodUser(activeGodUser) {
	      var _this17 = this;
	
	      this.setState({ activeGodUser: activeGodUser });
	
	      if (!this.state.allUsers[activeGodUser]) {
	        _UserUtil2.default.fetchUser(this.state.apiKey, {
	          apiKey: this.state.apiKey,
	          activeUser: this.state.activeGodUser
	        }).then(function (data) {
	          _this17.setState({
	            allUsers: _extends({}, _this17.state.allUsers, _defineProperty({}, _this17.state.activeGodUser, data))
	          });
	        }).catch(_UserActions2.default.fetchFailed);
	      }
	
	      _EventBucketActions2.default.updateEventBuckets.defer({});
	      _EventBucketActions2.default.fetchAll.defer();
	      _OrderActions2.default.reset.defer();
	      _SearchActions2.default.reset.defer();
	    }
	  }, {
	    key: "onSetGodRole",
	    value: function onSetGodRole(activeGodRole) {
	      this.setState({ activeGodRole: activeGodRole });
	    }
	  }, {
	    key: "onGodCreateUser",
	    value: function onGodCreateUser(values) {
	      var _this18 = this;
	
	      _UserUtil2.default.createUser(this.state.apiKey, values).then(function (data) {
	        _this18.setState({
	          allUsers: Object.assign({}, _this18.state.allUsers, _defineProperty({}, data.id, data)),
	          condensedUsers: [].concat(_toConsumableArray(_this18.state.condensedUsers), [{ id: data.id, organization: data.organization, type: data.type }])
	        });
	        _UserActions2.default.fetchCurrentPage(false);
	      }).catch(_UserActions2.default.editFailed);
	    }
	  }, {
	    key: "onGodAutoCreateUser",
	    value: function onGodAutoCreateUser(user) {
	      this.setState({
	        allUsers: Object.assign({}, this.state.allUsers, _defineProperty({}, user.id, user)),
	        condensedUsers: [].concat(_toConsumableArray(this.state.condensedUsers), [{ id: user.id, organization: user.organization, type: user.type }])
	      });
	    }
	  }, {
	    key: "onGodEditUser",
	    value: function onGodEditUser(_ref4) {
	      var _this19 = this;
	
	      var id = _ref4.id;
	      var values = _ref4.values;
	
	      _UserUtil2.default.editUser(this.state.apiKey, id, values).then(function (data) {
	        var newCondensedUser = [].concat(_toConsumableArray(_this19.state.condensedUsers));
	        var condensedUserIndex = newCondensedUser.findIndex(function (user) {
	          return user.id === data.id;
	        });
	        newCondensedUser[condensedUserIndex] = data;
	
	        _this19.setState({
	          allUsers: Object.assign({}, _this19.state.allUsers, _defineProperty({}, data.id, data)),
	          condensedUsers: newCondensedUser
	        });
	        _UserActions2.default.fetchCurrentPage(data.type === "content_creator");
	      }).catch(_UserActions2.default.editFailed);
	    }
	  }, {
	    key: "onGodDeleteUser",
	    value: function onGodDeleteUser(id) {
	      var _this20 = this;
	
	      _UserUtil2.default.deleteUser(this.state.apiKey, id).then(function () {
	        var allUsers = Object.assign({}, _this20.state.allUsers);
	        _UserActions2.default.fetchCurrentPage(allUsers[id].type === "content_creator");
	        delete allUsers[id];
	        _this20.setState({
	          allUsers: allUsers,
	          condensedUsers: _this20.state.condensedUsers.filter(function (user) {
	            return user.id !== id;
	          })
	        });
	      }).catch(_UserActions2.default.fetchFailed);
	    }
	  }, {
	    key: "onGodSetStealthMode",
	    value: function onGodSetStealthMode(godStealthMode) {
	      this.setState({
	        godStealthMode: godStealthMode,
	        activeGodRole: godStealthMode ? this.state.activeGodRole : null
	      });
	    }
	
	    // MISC
	    // ====
	
	  }, {
	    key: "onFetchFailed",
	    value: function onFetchFailed(e) {
	      alert("Fetch failed: " + e.message);
	      throw e;
	    }
	  }, {
	    key: "onEditFailed",
	    value: function onEditFailed(e) {
	      alert("Edit failed: " + e.message);
	      //throw e; this is normal
	    }
	  }]);
	
	  return UserStore;
	}();
	
	var store = _alt2.default.createStore(UserStore, "UserStore");
	
	if (SHOULD_PERSIST) {
	  store.listen(function (state) {
	    // Currently disabled: Update date-formatting locale
	    // if (store.getUser() && store.getUser().locale) {
	    //   moment.locale(store.getUser().locale);
	    // }
	
	    window.localStorage[LS_KEY] = JSON.stringify({
	      isLoggedIn: state.isLoggedIn,
	      apiKey: state.apiKey,
	      data: state.data,
	      activeGodUser: state.activeGodUser
	    });
	  });
	}
	
	// if still logged in using old auth method, force a logout
	if (cachedUser.data && !cachedUser.data.owner) {
	  _UserActions2.default.logout();
	}
	if (cachedUser.data && !cachedUser.data.hash) {
	  _UserActions2.default.logout();
	}
	
	// Populate initial user data on initial load
	if (cachedUser.apiKey) {
	  _UserActions2.default.fetch();
	  if (cachedUser.data.god) {
	    _UserActions2.default.fetchAllUsers();
	    _UserActions2.default.fetchCondensedUsers();
	  }
	}
	
	exports.default = store;
	module.exports = exports["default"];

/***/ }),
/* 975 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _alt = __webpack_require__(976);
	
	var _alt2 = _interopRequireDefault(_alt);
	
	var _chromeDebug = __webpack_require__(989);
	
	var _chromeDebug2 = _interopRequireDefault(_chromeDebug);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var alt = new _alt2.default();
	(0, _chromeDebug2.default)(alt);
	
	exports.default = alt;
	module.exports = exports["default"];

/***/ }),
/* 976 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _flux = __webpack_require__(977);
	
	var _StateFunctions = __webpack_require__(980);
	
	var StateFunctions = _interopRequireWildcard(_StateFunctions);
	
	var _functions = __webpack_require__(981);
	
	var fn = _interopRequireWildcard(_functions);
	
	var _store = __webpack_require__(982);
	
	var store = _interopRequireWildcard(_store);
	
	var _AltUtils = __webpack_require__(983);
	
	var utils = _interopRequireWildcard(_AltUtils);
	
	var _actions = __webpack_require__(987);
	
	var _actions2 = _interopRequireDefault(_actions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } } /* global window */
	
	
	var Alt = function () {
	  function Alt() {
	    var config = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	    _classCallCheck(this, Alt);
	
	    this.config = config;
	    this.serialize = config.serialize || JSON.stringify;
	    this.deserialize = config.deserialize || JSON.parse;
	    this.dispatcher = config.dispatcher || new _flux.Dispatcher();
	    this.batchingFunction = config.batchingFunction || function (callback) {
	      return callback();
	    };
	    this.actions = { global: {} };
	    this.stores = {};
	    this.storeTransforms = config.storeTransforms || [];
	    this.trapAsync = false;
	    this._actionsRegistry = {};
	    this._initSnapshot = {};
	    this._lastSnapshot = {};
	  }
	
	  Alt.prototype.dispatch = function () {
	    function dispatch(action, data, details) {
	      var _this = this;
	
	      this.batchingFunction(function () {
	        var id = Math.random().toString(18).substr(2, 16);
	
	        // support straight dispatching of FSA-style actions
	        if (action.hasOwnProperty('type') && action.hasOwnProperty('payload')) {
	          var fsaDetails = {
	            id: action.type,
	            namespace: action.type,
	            name: action.type
	          };
	          return _this.dispatcher.dispatch(utils.fsa(id, action.type, action.payload, fsaDetails));
	        }
	
	        if (action.id && action.dispatch) {
	          return utils.dispatch(id, action, data, _this);
	        }
	
	        return _this.dispatcher.dispatch(utils.fsa(id, action, data, details));
	      });
	    }
	
	    return dispatch;
	  }();
	
	  Alt.prototype.createUnsavedStore = function () {
	    function createUnsavedStore(StoreModel) {
	      var key = StoreModel.displayName || '';
	      store.createStoreConfig(this.config, StoreModel);
	      var Store = store.transformStore(this.storeTransforms, StoreModel);
	
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      return fn.isFunction(Store) ? store.createStoreFromClass.apply(store, [this, Store, key].concat(args)) : store.createStoreFromObject(this, Store, key);
	    }
	
	    return createUnsavedStore;
	  }();
	
	  Alt.prototype.createStore = function () {
	    function createStore(StoreModel, iden) {
	      var key = iden || StoreModel.displayName || StoreModel.name || '';
	      store.createStoreConfig(this.config, StoreModel);
	      var Store = store.transformStore(this.storeTransforms, StoreModel);
	
	      /* istanbul ignore next */
	      if (false) delete this.stores[key];
	
	      if (this.stores[key] || !key) {
	        if (this.stores[key]) {
	          utils.warn('A store named ' + String(key) + ' already exists, double check your store ' + 'names or pass in your own custom identifier for each store');
	        } else {
	          utils.warn('Store name was not specified');
	        }
	
	        key = utils.uid(this.stores, key);
	      }
	
	      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	        args[_key2 - 2] = arguments[_key2];
	      }
	
	      var storeInstance = fn.isFunction(Store) ? store.createStoreFromClass.apply(store, [this, Store, key].concat(args)) : store.createStoreFromObject(this, Store, key);
	
	      this.stores[key] = storeInstance;
	      StateFunctions.saveInitialSnapshot(this, key);
	
	      return storeInstance;
	    }
	
	    return createStore;
	  }();
	
	  Alt.prototype.generateActions = function () {
	    function generateActions() {
	      var actions = { name: 'global' };
	
	      for (var _len3 = arguments.length, actionNames = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
	        actionNames[_key3] = arguments[_key3];
	      }
	
	      return this.createActions(actionNames.reduce(function (obj, action) {
	        obj[action] = utils.dispatchIdentity;
	        return obj;
	      }, actions));
	    }
	
	    return generateActions;
	  }();
	
	  Alt.prototype.createAction = function () {
	    function createAction(name, implementation, obj) {
	      return (0, _actions2.default)(this, 'global', name, implementation, obj);
	    }
	
	    return createAction;
	  }();
	
	  Alt.prototype.createActions = function () {
	    function createActions(ActionsClass) {
	      var _this3 = this;
	
	      var exportObj = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	
	      var actions = {};
	      var key = utils.uid(this._actionsRegistry, ActionsClass.displayName || ActionsClass.name || 'Unknown');
	
	      if (fn.isFunction(ActionsClass)) {
	        fn.assign(actions, utils.getPrototypeChain(ActionsClass));
	
	        var ActionsGenerator = function (_ActionsClass) {
	          _inherits(ActionsGenerator, _ActionsClass);
	
	          function ActionsGenerator() {
	            _classCallCheck(this, ActionsGenerator);
	
	            for (var _len5 = arguments.length, args = Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
	              args[_key5] = arguments[_key5];
	            }
	
	            return _possibleConstructorReturn(this, _ActionsClass.call.apply(_ActionsClass, [this].concat(args)));
	          }
	
	          ActionsGenerator.prototype.generateActions = function () {
	            function generateActions() {
	              for (var _len6 = arguments.length, actionNames = Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
	                actionNames[_key6] = arguments[_key6];
	              }
	
	              actionNames.forEach(function (actionName) {
	                actions[actionName] = utils.dispatchIdentity;
	              });
	            }
	
	            return generateActions;
	          }();
	
	          return ActionsGenerator;
	        }(ActionsClass);
	
	        for (var _len4 = arguments.length, argsForConstructor = Array(_len4 > 2 ? _len4 - 2 : 0), _key4 = 2; _key4 < _len4; _key4++) {
	          argsForConstructor[_key4 - 2] = arguments[_key4];
	        }
	
	        fn.assign(actions, new (Function.prototype.bind.apply(ActionsGenerator, [null].concat(argsForConstructor)))());
	      } else {
	        fn.assign(actions, ActionsClass);
	      }
	
	      this.actions[key] = this.actions[key] || {};
	
	      fn.eachObject(function (actionName, action) {
	        if (!fn.isFunction(action)) {
	          exportObj[actionName] = action;
	          return;
	        }
	
	        // create the action
	        exportObj[actionName] = (0, _actions2.default)(_this3, key, actionName, action, exportObj);
	
	        // generate a constant
	        var constant = utils.formatAsConstant(actionName);
	        exportObj[constant] = exportObj[actionName].id;
	      }, [actions]);
	
	      return exportObj;
	    }
	
	    return createActions;
	  }();
	
	  Alt.prototype.takeSnapshot = function () {
	    function takeSnapshot() {
	      for (var _len7 = arguments.length, storeNames = Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
	        storeNames[_key7] = arguments[_key7];
	      }
	
	      var state = StateFunctions.snapshot(this, storeNames);
	      fn.assign(this._lastSnapshot, state);
	      return this.serialize(state);
	    }
	
	    return takeSnapshot;
	  }();
	
	  Alt.prototype.rollback = function () {
	    function rollback() {
	      StateFunctions.setAppState(this, this.serialize(this._lastSnapshot), function (storeInst) {
	        storeInst.lifecycle('rollback');
	        storeInst.emitChange();
	      });
	    }
	
	    return rollback;
	  }();
	
	  Alt.prototype.recycle = function () {
	    function recycle() {
	      for (var _len8 = arguments.length, storeNames = Array(_len8), _key8 = 0; _key8 < _len8; _key8++) {
	        storeNames[_key8] = arguments[_key8];
	      }
	
	      var initialSnapshot = storeNames.length ? StateFunctions.filterSnapshots(this, this._initSnapshot, storeNames) : this._initSnapshot;
	
	      StateFunctions.setAppState(this, this.serialize(initialSnapshot), function (storeInst) {
	        storeInst.lifecycle('init');
	        storeInst.emitChange();
	      });
	    }
	
	    return recycle;
	  }();
	
	  Alt.prototype.flush = function () {
	    function flush() {
	      var state = this.serialize(StateFunctions.snapshot(this));
	      this.recycle();
	      return state;
	    }
	
	    return flush;
	  }();
	
	  Alt.prototype.bootstrap = function () {
	    function bootstrap(data) {
	      StateFunctions.setAppState(this, data, function (storeInst, state) {
	        storeInst.lifecycle('bootstrap', state);
	        storeInst.emitChange();
	      });
	    }
	
	    return bootstrap;
	  }();
	
	  Alt.prototype.prepare = function () {
	    function prepare(storeInst, payload) {
	      var data = {};
	      if (!storeInst.displayName) {
	        throw new ReferenceError('Store provided does not have a name');
	      }
	      data[storeInst.displayName] = payload;
	      return this.serialize(data);
	    }
	
	    return prepare;
	  }();
	
	  // Instance type methods for injecting alt into your application as context
	
	  Alt.prototype.addActions = function () {
	    function addActions(name, ActionsClass) {
	      for (var _len9 = arguments.length, args = Array(_len9 > 2 ? _len9 - 2 : 0), _key9 = 2; _key9 < _len9; _key9++) {
	        args[_key9 - 2] = arguments[_key9];
	      }
	
	      this.actions[name] = Array.isArray(ActionsClass) ? this.generateActions.apply(this, ActionsClass) : this.createActions.apply(this, [ActionsClass].concat(args));
	    }
	
	    return addActions;
	  }();
	
	  Alt.prototype.addStore = function () {
	    function addStore(name, StoreModel) {
	      for (var _len10 = arguments.length, args = Array(_len10 > 2 ? _len10 - 2 : 0), _key10 = 2; _key10 < _len10; _key10++) {
	        args[_key10 - 2] = arguments[_key10];
	      }
	
	      this.createStore.apply(this, [StoreModel, name].concat(args));
	    }
	
	    return addStore;
	  }();
	
	  Alt.prototype.getActions = function () {
	    function getActions(name) {
	      return this.actions[name];
	    }
	
	    return getActions;
	  }();
	
	  Alt.prototype.getStore = function () {
	    function getStore(name) {
	      return this.stores[name];
	    }
	
	    return getStore;
	  }();
	
	  Alt.debug = function () {
	    function debug(name, alt, win) {
	      var key = 'alt.js.org';
	      var context = win;
	      if (!context && typeof window !== 'undefined') {
	        context = window;
	      }
	      if (typeof context !== 'undefined') {
	        context[key] = context[key] || [];
	        context[key].push({ name: name, alt: alt });
	      }
	      return alt;
	    }
	
	    return debug;
	  }();
	
	  return Alt;
	}();
	
	exports.default = Alt;
	module.exports = exports['default'];

/***/ }),
/* 977 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	module.exports.Dispatcher = __webpack_require__(978);


/***/ }),
/* 978 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule Dispatcher
	 * 
	 * @preventMunge
	 */
	
	'use strict';
	
	exports.__esModule = true;
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var invariant = __webpack_require__(979);
	
	var _prefix = 'ID_';
	
	/**
	 * Dispatcher is used to broadcast payloads to registered callbacks. This is
	 * different from generic pub-sub systems in two ways:
	 *
	 *   1) Callbacks are not subscribed to particular events. Every payload is
	 *      dispatched to every registered callback.
	 *   2) Callbacks can be deferred in whole or part until other callbacks have
	 *      been executed.
	 *
	 * For example, consider this hypothetical flight destination form, which
	 * selects a default city when a country is selected:
	 *
	 *   var flightDispatcher = new Dispatcher();
	 *
	 *   // Keeps track of which country is selected
	 *   var CountryStore = {country: null};
	 *
	 *   // Keeps track of which city is selected
	 *   var CityStore = {city: null};
	 *
	 *   // Keeps track of the base flight price of the selected city
	 *   var FlightPriceStore = {price: null}
	 *
	 * When a user changes the selected city, we dispatch the payload:
	 *
	 *   flightDispatcher.dispatch({
	 *     actionType: 'city-update',
	 *     selectedCity: 'paris'
	 *   });
	 *
	 * This payload is digested by `CityStore`:
	 *
	 *   flightDispatcher.register(function(payload) {
	 *     if (payload.actionType === 'city-update') {
	 *       CityStore.city = payload.selectedCity;
	 *     }
	 *   });
	 *
	 * When the user selects a country, we dispatch the payload:
	 *
	 *   flightDispatcher.dispatch({
	 *     actionType: 'country-update',
	 *     selectedCountry: 'australia'
	 *   });
	 *
	 * This payload is digested by both stores:
	 *
	 *   CountryStore.dispatchToken = flightDispatcher.register(function(payload) {
	 *     if (payload.actionType === 'country-update') {
	 *       CountryStore.country = payload.selectedCountry;
	 *     }
	 *   });
	 *
	 * When the callback to update `CountryStore` is registered, we save a reference
	 * to the returned token. Using this token with `waitFor()`, we can guarantee
	 * that `CountryStore` is updated before the callback that updates `CityStore`
	 * needs to query its data.
	 *
	 *   CityStore.dispatchToken = flightDispatcher.register(function(payload) {
	 *     if (payload.actionType === 'country-update') {
	 *       // `CountryStore.country` may not be updated.
	 *       flightDispatcher.waitFor([CountryStore.dispatchToken]);
	 *       // `CountryStore.country` is now guaranteed to be updated.
	 *
	 *       // Select the default city for the new country
	 *       CityStore.city = getDefaultCityForCountry(CountryStore.country);
	 *     }
	 *   });
	 *
	 * The usage of `waitFor()` can be chained, for example:
	 *
	 *   FlightPriceStore.dispatchToken =
	 *     flightDispatcher.register(function(payload) {
	 *       switch (payload.actionType) {
	 *         case 'country-update':
	 *         case 'city-update':
	 *           flightDispatcher.waitFor([CityStore.dispatchToken]);
	 *           FlightPriceStore.price =
	 *             getFlightPriceStore(CountryStore.country, CityStore.city);
	 *           break;
	 *     }
	 *   });
	 *
	 * The `country-update` payload will be guaranteed to invoke the stores'
	 * registered callbacks in order: `CountryStore`, `CityStore`, then
	 * `FlightPriceStore`.
	 */
	
	var Dispatcher = (function () {
	  function Dispatcher() {
	    _classCallCheck(this, Dispatcher);
	
	    this._callbacks = {};
	    this._isDispatching = false;
	    this._isHandled = {};
	    this._isPending = {};
	    this._lastID = 1;
	  }
	
	  /**
	   * Registers a callback to be invoked with every dispatched payload. Returns
	   * a token that can be used with `waitFor()`.
	   */
	
	  Dispatcher.prototype.register = function register(callback) {
	    var id = _prefix + this._lastID++;
	    this._callbacks[id] = callback;
	    return id;
	  };
	
	  /**
	   * Removes a callback based on its token.
	   */
	
	  Dispatcher.prototype.unregister = function unregister(id) {
	    !this._callbacks[id] ?  false ? invariant(false, 'Dispatcher.unregister(...): `%s` does not map to a registered callback.', id) : invariant(false) : undefined;
	    delete this._callbacks[id];
	  };
	
	  /**
	   * Waits for the callbacks specified to be invoked before continuing execution
	   * of the current callback. This method should only be used by a callback in
	   * response to a dispatched payload.
	   */
	
	  Dispatcher.prototype.waitFor = function waitFor(ids) {
	    !this._isDispatching ?  false ? invariant(false, 'Dispatcher.waitFor(...): Must be invoked while dispatching.') : invariant(false) : undefined;
	    for (var ii = 0; ii < ids.length; ii++) {
	      var id = ids[ii];
	      if (this._isPending[id]) {
	        !this._isHandled[id] ?  false ? invariant(false, 'Dispatcher.waitFor(...): Circular dependency detected while ' + 'waiting for `%s`.', id) : invariant(false) : undefined;
	        continue;
	      }
	      !this._callbacks[id] ?  false ? invariant(false, 'Dispatcher.waitFor(...): `%s` does not map to a registered callback.', id) : invariant(false) : undefined;
	      this._invokeCallback(id);
	    }
	  };
	
	  /**
	   * Dispatches a payload to all registered callbacks.
	   */
	
	  Dispatcher.prototype.dispatch = function dispatch(payload) {
	    !!this._isDispatching ?  false ? invariant(false, 'Dispatch.dispatch(...): Cannot dispatch in the middle of a dispatch.') : invariant(false) : undefined;
	    this._startDispatching(payload);
	    try {
	      for (var id in this._callbacks) {
	        if (this._isPending[id]) {
	          continue;
	        }
	        this._invokeCallback(id);
	      }
	    } finally {
	      this._stopDispatching();
	    }
	  };
	
	  /**
	   * Is this Dispatcher currently dispatching.
	   */
	
	  Dispatcher.prototype.isDispatching = function isDispatching() {
	    return this._isDispatching;
	  };
	
	  /**
	   * Call the callback stored with the given id. Also do some internal
	   * bookkeeping.
	   *
	   * @internal
	   */
	
	  Dispatcher.prototype._invokeCallback = function _invokeCallback(id) {
	    this._isPending[id] = true;
	    this._callbacks[id](this._pendingPayload);
	    this._isHandled[id] = true;
	  };
	
	  /**
	   * Set up bookkeeping needed when dispatching.
	   *
	   * @internal
	   */
	
	  Dispatcher.prototype._startDispatching = function _startDispatching(payload) {
	    for (var id in this._callbacks) {
	      this._isPending[id] = false;
	      this._isHandled[id] = false;
	    }
	    this._pendingPayload = payload;
	    this._isDispatching = true;
	  };
	
	  /**
	   * Clear bookkeeping used for dispatching.
	   *
	   * @internal
	   */
	
	  Dispatcher.prototype._stopDispatching = function _stopDispatching() {
	    delete this._pendingPayload;
	    this._isDispatching = false;
	  };
	
	  return Dispatcher;
	})();
	
	module.exports = Dispatcher;

/***/ }),
/* 979 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule invariant
	 */
	
	"use strict";
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var invariant = function (condition, format, a, b, c, d, e, f) {
	  if (false) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  }
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error('Invariant Violation: ' + format.replace(/%s/g, function () {
	        return args[argIndex++];
	      }));
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	};
	
	module.exports = invariant;

/***/ }),
/* 980 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.setAppState = setAppState;
	exports.snapshot = snapshot;
	exports.saveInitialSnapshot = saveInitialSnapshot;
	exports.filterSnapshots = filterSnapshots;
	
	var _functions = __webpack_require__(981);
	
	var fn = _interopRequireWildcard(_functions);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function setAppState(instance, data, onStore) {
	  var obj = instance.deserialize(data);
	  fn.eachObject(function (key, value) {
	    var store = instance.stores[key];
	    if (store) {
	      (function () {
	        var config = store.StoreModel.config;
	
	        var state = store.state;
	        if (config.onDeserialize) obj[key] = config.onDeserialize(value) || value;
	        if (fn.isMutableObject(state)) {
	          fn.eachObject(function (k) {
	            return delete state[k];
	          }, [state]);
	          fn.assign(state, obj[key]);
	        } else {
	          store.state = obj[key];
	        }
	        onStore(store, store.state);
	      })();
	    }
	  }, [obj]);
	}
	
	function snapshot(instance) {
	  var storeNames = arguments.length <= 1 || arguments[1] === undefined ? [] : arguments[1];
	
	  var stores = storeNames.length ? storeNames : Object.keys(instance.stores);
	  return stores.reduce(function (obj, storeHandle) {
	    var storeName = storeHandle.displayName || storeHandle;
	    var store = instance.stores[storeName];
	    var config = store.StoreModel.config;
	
	    store.lifecycle('snapshot');
	    var customSnapshot = config.onSerialize && config.onSerialize(store.state);
	    obj[storeName] = customSnapshot ? customSnapshot : store.getState();
	    return obj;
	  }, {});
	}
	
	function saveInitialSnapshot(instance, key) {
	  var state = instance.deserialize(instance.serialize(instance.stores[key].state));
	  instance._initSnapshot[key] = state;
	  instance._lastSnapshot[key] = state;
	}
	
	function filterSnapshots(instance, state, stores) {
	  return stores.reduce(function (obj, store) {
	    var storeName = store.displayName || store;
	    if (!state[storeName]) {
	      throw new ReferenceError(String(storeName) + ' is not a valid store');
	    }
	    obj[storeName] = state[storeName];
	    return obj;
	  }, {});
	}

/***/ }),
/* 981 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.isMutableObject = isMutableObject;
	exports.eachObject = eachObject;
	exports.assign = assign;
	var isFunction = exports.isFunction = function isFunction(x) {
	  return typeof x === 'function';
	};
	
	function isMutableObject(target) {
	  var Ctor = target.constructor;
	
	  return !!target && Object.prototype.toString.call(target) === '[object Object]' && isFunction(Ctor) && !Object.isFrozen(target) && (Ctor instanceof Ctor || target.type === 'AltStore');
	}
	
	function eachObject(f, o) {
	  o.forEach(function (from) {
	    Object.keys(Object(from)).forEach(function (key) {
	      f(key, from[key]);
	    });
	  });
	}
	
	function assign(target) {
	  for (var _len = arguments.length, source = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    source[_key - 1] = arguments[_key];
	  }
	
	  eachObject(function (key, value) {
	    return target[key] = value;
	  }, source);
	  return target;
	}

/***/ }),
/* 982 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.createStoreConfig = createStoreConfig;
	exports.transformStore = transformStore;
	exports.createStoreFromObject = createStoreFromObject;
	exports.createStoreFromClass = createStoreFromClass;
	
	var _AltUtils = __webpack_require__(983);
	
	var utils = _interopRequireWildcard(_AltUtils);
	
	var _functions = __webpack_require__(981);
	
	var fn = _interopRequireWildcard(_functions);
	
	var _AltStore = __webpack_require__(984);
	
	var _AltStore2 = _interopRequireDefault(_AltStore);
	
	var _StoreMixin = __webpack_require__(986);
	
	var _StoreMixin2 = _interopRequireDefault(_StoreMixin);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function doSetState(store, storeInstance, state) {
	  if (!state) {
	    return;
	  }
	
	  var config = storeInstance.StoreModel.config;
	
	
	  var nextState = fn.isFunction(state) ? state(storeInstance.state) : state;
	
	  storeInstance.state = config.setState.call(store, storeInstance.state, nextState);
	
	  if (!store.alt.dispatcher.isDispatching()) {
	    store.emitChange();
	  }
	}
	
	function createPrototype(proto, alt, key, extras) {
	  return fn.assign(proto, _StoreMixin2.default, {
	    displayName: key,
	    alt: alt,
	    dispatcher: alt.dispatcher,
	    preventDefault: function () {
	      function preventDefault() {
	        this.getInstance().preventDefault = true;
	      }
	
	      return preventDefault;
	    }(),
	
	    boundListeners: [],
	    lifecycleEvents: {},
	    actionListeners: {},
	    publicMethods: {},
	    handlesOwnErrors: false
	  }, extras);
	}
	
	function createStoreConfig(globalConfig, StoreModel) {
	  StoreModel.config = fn.assign({
	    getState: function () {
	      function getState(state) {
	        if (Array.isArray(state)) {
	          return state.slice();
	        } else if (fn.isMutableObject(state)) {
	          return fn.assign({}, state);
	        }
	
	        return state;
	      }
	
	      return getState;
	    }(),
	    setState: function () {
	      function setState(currentState, nextState) {
	        if (fn.isMutableObject(nextState)) {
	          return fn.assign(currentState, nextState);
	        }
	        return nextState;
	      }
	
	      return setState;
	    }()
	  }, globalConfig, StoreModel.config);
	}
	
	function transformStore(transforms, StoreModel) {
	  return transforms.reduce(function (Store, transform) {
	    return transform(Store);
	  }, StoreModel);
	}
	
	function createStoreFromObject(alt, StoreModel, key) {
	  var storeInstance = void 0;
	
	  var StoreProto = createPrototype({}, alt, key, fn.assign({
	    getInstance: function () {
	      function getInstance() {
	        return storeInstance;
	      }
	
	      return getInstance;
	    }(),
	    setState: function () {
	      function setState(nextState) {
	        doSetState(this, storeInstance, nextState);
	      }
	
	      return setState;
	    }()
	  }, StoreModel));
	
	  // bind the store listeners
	  /* istanbul ignore else */
	  if (StoreProto.bindListeners) {
	    _StoreMixin2.default.bindListeners.call(StoreProto, StoreProto.bindListeners);
	  }
	  /* istanbul ignore else */
	  if (StoreProto.observe) {
	    _StoreMixin2.default.bindListeners.call(StoreProto, StoreProto.observe(alt));
	  }
	
	  // bind the lifecycle events
	  /* istanbul ignore else */
	  if (StoreProto.lifecycle) {
	    fn.eachObject(function (eventName, event) {
	      _StoreMixin2.default.on.call(StoreProto, eventName, event);
	    }, [StoreProto.lifecycle]);
	  }
	
	  // create the instance and fn.assign the public methods to the instance
	  storeInstance = fn.assign(new _AltStore2.default(alt, StoreProto, StoreProto.state !== undefined ? StoreProto.state : {}, StoreModel), StoreProto.publicMethods, {
	    displayName: key,
	    config: StoreModel.config
	  });
	
	  return storeInstance;
	}
	
	function createStoreFromClass(alt, StoreModel, key) {
	  var storeInstance = void 0;
	  var config = StoreModel.config;
	
	  // Creating a class here so we don't overload the provided store's
	  // prototype with the mixin behaviour and I'm extending from StoreModel
	  // so we can inherit any extensions from the provided store.
	
	  var Store = function (_StoreModel) {
	    _inherits(Store, _StoreModel);
	
	    function Store() {
	      _classCallCheck(this, Store);
	
	      for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	        args[_key2] = arguments[_key2];
	      }
	
	      return _possibleConstructorReturn(this, _StoreModel.call.apply(_StoreModel, [this].concat(args)));
	    }
	
	    return Store;
	  }(StoreModel);
	
	  createPrototype(Store.prototype, alt, key, {
	    type: 'AltStore',
	    getInstance: function () {
	      function getInstance() {
	        return storeInstance;
	      }
	
	      return getInstance;
	    }(),
	    setState: function () {
	      function setState(nextState) {
	        doSetState(this, storeInstance, nextState);
	      }
	
	      return setState;
	    }()
	  });
	
	  for (var _len = arguments.length, argsForClass = Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
	    argsForClass[_key - 3] = arguments[_key];
	  }
	
	  var store = new (Function.prototype.bind.apply(Store, [null].concat(argsForClass)))();
	
	  /* istanbul ignore next */
	  if (config.bindListeners) store.bindListeners(config.bindListeners);
	  /* istanbul ignore next */
	  if (config.datasource) store.registerAsync(config.datasource);
	
	  storeInstance = fn.assign(new _AltStore2.default(alt, store, store.state !== undefined ? store.state : store, StoreModel), utils.getInternalMethods(StoreModel), config.publicMethods, { displayName: key });
	
	  return storeInstance;
	}

/***/ }),
/* 983 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getInternalMethods = getInternalMethods;
	exports.getPrototypeChain = getPrototypeChain;
	exports.warn = warn;
	exports.uid = uid;
	exports.formatAsConstant = formatAsConstant;
	exports.dispatchIdentity = dispatchIdentity;
	exports.fsa = fsa;
	exports.dispatch = dispatch;
	
	var _functions = __webpack_require__(981);
	
	var fn = _interopRequireWildcard(_functions);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	/*eslint-disable*/
	var builtIns = Object.getOwnPropertyNames(NoopClass);
	var builtInProto = Object.getOwnPropertyNames(NoopClass.prototype);
	/*eslint-enable*/
	
	function getInternalMethods(Obj, isProto) {
	  var excluded = isProto ? builtInProto : builtIns;
	  var obj = isProto ? Obj.prototype : Obj;
	  return Object.getOwnPropertyNames(obj).reduce(function (value, m) {
	    if (excluded.indexOf(m) !== -1) {
	      return value;
	    }
	
	    value[m] = obj[m];
	    return value;
	  }, {});
	}
	
	function getPrototypeChain(Obj) {
	  var methods = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	
	  return Obj === Function.prototype ? methods : getPrototypeChain(Object.getPrototypeOf(Obj), fn.assign(methods, getInternalMethods(Obj, true)));
	}
	
	function warn(msg) {
	  /* istanbul ignore else */
	  /*eslint-disable*/
	  if (typeof console !== 'undefined') {
	    console.warn(new ReferenceError(msg));
	  }
	  /*eslint-enable*/
	}
	
	function uid(container, name) {
	  var count = 0;
	  var key = name;
	  while (Object.hasOwnProperty.call(container, key)) {
	    key = name + String(++count);
	  }
	  return key;
	}
	
	function formatAsConstant(name) {
	  return name.replace(/[a-z]([A-Z])/g, function (i) {
	    return String(i[0]) + '_' + String(i[1].toLowerCase());
	  }).toUpperCase();
	}
	
	function dispatchIdentity(x) {
	  if (x === undefined) return null;
	
	  for (var _len = arguments.length, a = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    a[_key - 1] = arguments[_key];
	  }
	
	  return a.length ? [x].concat(a) : x;
	}
	
	function fsa(id, type, payload, details) {
	  return {
	    type: type,
	    payload: payload,
	    meta: _extends({
	      dispatchId: id
	    }, details),
	
	    id: id,
	    action: type,
	    data: payload,
	    details: details
	  };
	}
	
	function dispatch(id, actionObj, payload, alt) {
	  var data = actionObj.dispatch(payload);
	  if (data === undefined) return null;
	
	  var type = actionObj.id;
	  var namespace = type;
	  var name = type;
	  var details = { id: type, namespace: namespace, name: name };
	
	  var dispatchLater = function dispatchLater(x) {
	    return alt.dispatch(type, x, details);
	  };
	
	  if (fn.isFunction(data)) return data(dispatchLater, alt);
	
	  // XXX standardize this
	  return alt.dispatcher.dispatch(fsa(id, type, data, details));
	}
	
	/* istanbul ignore next */
	function NoopClass() {}

/***/ }),
/* 984 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _functions = __webpack_require__(981);
	
	var fn = _interopRequireWildcard(_functions);
	
	var _transmitter = __webpack_require__(985);
	
	var _transmitter2 = _interopRequireDefault(_transmitter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var AltStore = function () {
	  function AltStore(alt, model, state, StoreModel) {
	    var _this = this;
	
	    _classCallCheck(this, AltStore);
	
	    var lifecycleEvents = model.lifecycleEvents;
	    this.transmitter = (0, _transmitter2.default)();
	    this.lifecycle = function (event, x) {
	      if (lifecycleEvents[event]) lifecycleEvents[event].publish(x);
	    };
	    this.state = state;
	
	    this.alt = alt;
	    this.preventDefault = false;
	    this.displayName = model.displayName;
	    this.boundListeners = model.boundListeners;
	    this.StoreModel = StoreModel;
	    this.reduce = model.reduce || function (x) {
	      return x;
	    };
	    this.subscriptions = [];
	
	    var output = model.output || function (x) {
	      return x;
	    };
	
	    this.emitChange = function () {
	      return _this.transmitter.publish(output(_this.state));
	    };
	
	    var handleDispatch = function handleDispatch(f, payload) {
	      try {
	        return f();
	      } catch (e) {
	        if (model.handlesOwnErrors) {
	          _this.lifecycle('error', {
	            error: e,
	            payload: payload,
	            state: _this.state
	          });
	          return false;
	        }
	
	        throw e;
	      }
	    };
	
	    fn.assign(this, model.publicMethods);
	
	    // Register dispatcher
	    this.dispatchToken = alt.dispatcher.register(function (payload) {
	      _this.preventDefault = false;
	
	      _this.lifecycle('beforeEach', {
	        payload: payload,
	        state: _this.state
	      });
	
	      var actionHandlers = model.actionListeners[payload.action];
	
	      if (actionHandlers || model.otherwise) {
	        var result = void 0;
	
	        if (actionHandlers) {
	          result = handleDispatch(function () {
	            return actionHandlers.filter(Boolean).every(function (handler) {
	              return handler.call(model, payload.data, payload.action) !== false;
	            });
	          }, payload);
	        } else {
	          result = handleDispatch(function () {
	            return model.otherwise(payload.data, payload.action);
	          }, payload);
	        }
	
	        if (result !== false && !_this.preventDefault) _this.emitChange();
	      }
	
	      if (model.reduce) {
	        handleDispatch(function () {
	          var value = model.reduce(_this.state, payload);
	          if (value !== undefined) _this.state = value;
	        }, payload);
	        if (!_this.preventDefault) _this.emitChange();
	      }
	
	      _this.lifecycle('afterEach', {
	        payload: payload,
	        state: _this.state
	      });
	    });
	
	    this.lifecycle('init');
	  }
	
	  AltStore.prototype.listen = function () {
	    function listen(cb) {
	      var _this2 = this;
	
	      if (!fn.isFunction(cb)) throw new TypeError('listen expects a function');
	
	      var _transmitter$subscrib = this.transmitter.subscribe(cb);
	
	      var dispose = _transmitter$subscrib.dispose;
	
	      this.subscriptions.push({ cb: cb, dispose: dispose });
	      return function () {
	        _this2.lifecycle('unlisten');
	        dispose();
	      };
	    }
	
	    return listen;
	  }();
	
	  AltStore.prototype.unlisten = function () {
	    function unlisten(cb) {
	      this.lifecycle('unlisten');
	      this.subscriptions.filter(function (subscription) {
	        return subscription.cb === cb;
	      }).forEach(function (subscription) {
	        return subscription.dispose();
	      });
	    }
	
	    return unlisten;
	  }();
	
	  AltStore.prototype.getState = function () {
	    function getState() {
	      return this.StoreModel.config.getState.call(this, this.state);
	    }
	
	    return getState;
	  }();
	
	  return AltStore;
	}();
	
	exports.default = AltStore;
	module.exports = exports['default'];

/***/ }),
/* 985 */
/***/ (function(module, exports) {

	"use strict";
	
	function transmitter() {
	  var subscriptions = [];
	  var nowDispatching = false;
	  var toUnsubscribe = {};
	
	  var unsubscribe = function unsubscribe(onChange) {
	    var id = subscriptions.indexOf(onChange);
	    if (id < 0) return;
	    if (nowDispatching) {
	      toUnsubscribe[id] = onChange;
	      return;
	    }
	    subscriptions.splice(id, 1);
	  };
	
	  var subscribe = function subscribe(onChange) {
	    var id = subscriptions.push(onChange);
	    var dispose = function dispose() {
	      return unsubscribe(onChange);
	    };
	    return { dispose: dispose };
	  };
	
	  var publish = function publish() {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    nowDispatching = true;
	    try {
	      subscriptions.forEach(function (subscription, id) {
	        return toUnsubscribe[id] || subscription.apply(undefined, args);
	      });
	    } finally {
	      nowDispatching = false;
	      Object.keys(toUnsubscribe).forEach(function (id) {
	        return unsubscribe(toUnsubscribe[id]);
	      });
	      toUnsubscribe = {};
	    }
	  };
	
	  return {
	    publish: publish,
	    subscribe: subscribe,
	    $subscriptions: subscriptions
	  };
	}
	
	module.exports = transmitter;

/***/ }),
/* 986 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _transmitter = __webpack_require__(985);
	
	var _transmitter2 = _interopRequireDefault(_transmitter);
	
	var _functions = __webpack_require__(981);
	
	var fn = _interopRequireWildcard(_functions);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var StoreMixin = {
	  waitFor: function () {
	    function waitFor() {
	      for (var _len = arguments.length, sources = Array(_len), _key = 0; _key < _len; _key++) {
	        sources[_key] = arguments[_key];
	      }
	
	      if (!sources.length) {
	        throw new ReferenceError('Dispatch tokens not provided');
	      }
	
	      var sourcesArray = sources;
	      if (sources.length === 1) {
	        sourcesArray = Array.isArray(sources[0]) ? sources[0] : sources;
	      }
	
	      var tokens = sourcesArray.map(function (source) {
	        return source.dispatchToken || source;
	      });
	
	      this.dispatcher.waitFor(tokens);
	    }
	
	    return waitFor;
	  }(),
	  exportAsync: function () {
	    function exportAsync(asyncMethods) {
	      this.registerAsync(asyncMethods);
	    }
	
	    return exportAsync;
	  }(),
	  registerAsync: function () {
	    function registerAsync(asyncDef) {
	      var _this = this;
	
	      var loadCounter = 0;
	
	      var asyncMethods = fn.isFunction(asyncDef) ? asyncDef(this.alt) : asyncDef;
	
	      var toExport = Object.keys(asyncMethods).reduce(function (publicMethods, methodName) {
	        var desc = asyncMethods[methodName];
	        var spec = fn.isFunction(desc) ? desc(_this) : desc;
	
	        var validHandlers = ['success', 'error', 'loading'];
	        validHandlers.forEach(function (handler) {
	          if (spec[handler] && !spec[handler].id) {
	            throw new Error(String(handler) + ' handler must be an action function');
	          }
	        });
	
	        publicMethods[methodName] = function () {
	          for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	            args[_key2] = arguments[_key2];
	          }
	
	          var state = _this.getInstance().getState();
	          var value = spec.local && spec.local.apply(spec, [state].concat(args));
	          var shouldFetch = spec.shouldFetch ? spec.shouldFetch.apply(spec, [state].concat(args))
	          /*eslint-disable*/
	          : value == null;
	          /*eslint-enable*/
	          var intercept = spec.interceptResponse || function (x) {
	            return x;
	          };
	
	          var makeActionHandler = function () {
	            function makeActionHandler(action, isError) {
	              return function (x) {
	                var fire = function () {
	                  function fire() {
	                    loadCounter -= 1;
	                    action(intercept(x, action, args));
	                    if (isError) throw x;
	                    return x;
	                  }
	
	                  return fire;
	                }();
	                return _this.alt.trapAsync ? function () {
	                  return fire();
	                } : fire();
	              };
	            }
	
	            return makeActionHandler;
	          }();
	
	          // if we don't have it in cache then fetch it
	          if (shouldFetch) {
	            loadCounter += 1;
	            /* istanbul ignore else */
	            if (spec.loading) spec.loading(intercept(null, spec.loading, args));
	            return spec.remote.apply(spec, [state].concat(args)).then(makeActionHandler(spec.success), makeActionHandler(spec.error, 1));
	          }
	
	          // otherwise emit the change now
	          _this.emitChange();
	          return value;
	        };
	
	        return publicMethods;
	      }, {});
	
	      this.exportPublicMethods(toExport);
	      this.exportPublicMethods({
	        isLoading: function () {
	          function isLoading() {
	            return loadCounter > 0;
	          }
	
	          return isLoading;
	        }()
	      });
	    }
	
	    return registerAsync;
	  }(),
	  exportPublicMethods: function () {
	    function exportPublicMethods(methods) {
	      var _this2 = this;
	
	      fn.eachObject(function (methodName, value) {
	        if (!fn.isFunction(value)) {
	          throw new TypeError('exportPublicMethods expects a function');
	        }
	
	        _this2.publicMethods[methodName] = value;
	      }, [methods]);
	    }
	
	    return exportPublicMethods;
	  }(),
	  emitChange: function () {
	    function emitChange() {
	      this.getInstance().emitChange();
	    }
	
	    return emitChange;
	  }(),
	  on: function () {
	    function on(lifecycleEvent, handler) {
	      if (lifecycleEvent === 'error') this.handlesOwnErrors = true;
	      var bus = this.lifecycleEvents[lifecycleEvent] || (0, _transmitter2.default)();
	      this.lifecycleEvents[lifecycleEvent] = bus;
	      return bus.subscribe(handler.bind(this));
	    }
	
	    return on;
	  }(),
	  bindAction: function () {
	    function bindAction(symbol, handler) {
	      if (!symbol) {
	        throw new ReferenceError('Invalid action reference passed in');
	      }
	      if (!fn.isFunction(handler)) {
	        throw new TypeError('bindAction expects a function');
	      }
	
	      // You can pass in the constant or the function itself
	      var key = symbol.id ? symbol.id : symbol;
	      this.actionListeners[key] = this.actionListeners[key] || [];
	      this.actionListeners[key].push(handler.bind(this));
	      this.boundListeners.push(key);
	    }
	
	    return bindAction;
	  }(),
	  bindActions: function () {
	    function bindActions(actions) {
	      var _this3 = this;
	
	      fn.eachObject(function (action, symbol) {
	        var matchFirstCharacter = /./;
	        var assumedEventHandler = action.replace(matchFirstCharacter, function (x) {
	          return 'on' + String(x[0].toUpperCase());
	        });
	
	        if (_this3[action] && _this3[assumedEventHandler]) {
	          // If you have both action and onAction
	          throw new ReferenceError('You have multiple action handlers bound to an action: ' + (String(action) + ' and ' + String(assumedEventHandler)));
	        }
	
	        var handler = _this3[action] || _this3[assumedEventHandler];
	        if (handler) {
	          _this3.bindAction(symbol, handler);
	        }
	      }, [actions]);
	    }
	
	    return bindActions;
	  }(),
	  bindListeners: function () {
	    function bindListeners(obj) {
	      var _this4 = this;
	
	      fn.eachObject(function (methodName, symbol) {
	        var listener = _this4[methodName];
	
	        if (!listener) {
	          throw new ReferenceError(String(methodName) + ' defined but does not exist in ' + String(_this4.displayName));
	        }
	
	        if (Array.isArray(symbol)) {
	          symbol.forEach(function (action) {
	            _this4.bindAction(action, listener);
	          });
	        } else {
	          _this4.bindAction(symbol, listener);
	        }
	      }, [obj]);
	    }
	
	    return bindListeners;
	  }()
	};
	
	exports.default = StoreMixin;
	module.exports = exports['default'];

/***/ }),
/* 987 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports['default'] = makeAction;
	
	var _functions = __webpack_require__(981);
	
	var fn = _interopRequireWildcard(_functions);
	
	var _AltUtils = __webpack_require__(983);
	
	var utils = _interopRequireWildcard(_AltUtils);
	
	var _isPromise = __webpack_require__(988);
	
	var _isPromise2 = _interopRequireDefault(_isPromise);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function makeAction(alt, namespace, name, implementation, obj) {
	  var id = utils.uid(alt._actionsRegistry, String(namespace) + '.' + String(name));
	  alt._actionsRegistry[id] = 1;
	
	  var data = { id: id, namespace: namespace, name: name };
	
	  var dispatch = function dispatch(payload) {
	    return alt.dispatch(id, payload, data);
	  };
	
	  // the action itself
	  var action = function action() {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    var invocationResult = implementation.apply(obj, args);
	    var actionResult = invocationResult;
	
	    // async functions that return promises should not be dispatched
	    if (invocationResult !== undefined && !(0, _isPromise2.default)(invocationResult)) {
	      if (fn.isFunction(invocationResult)) {
	        // inner function result should be returned as an action result
	        actionResult = invocationResult(dispatch, alt);
	      } else {
	        dispatch(invocationResult);
	      }
	    }
	
	    if (invocationResult === undefined) {
	      utils.warn('An action was called but nothing was dispatched');
	    }
	
	    return actionResult;
	  };
	  action.defer = function () {
	    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	      args[_key2] = arguments[_key2];
	    }
	
	    return setTimeout(function () {
	      return action.apply(null, args);
	    });
	  };
	  action.id = id;
	  action.data = data;
	
	  // ensure each reference is unique in the namespace
	  var container = alt.actions[namespace];
	  var namespaceId = utils.uid(container, name);
	  container[namespaceId] = action;
	
	  // generate a constant
	  var constant = utils.formatAsConstant(namespaceId);
	  container[constant] = id;
	
	  return action;
	}
	module.exports = exports['default'];

/***/ }),
/* 988 */
/***/ (function(module, exports) {

	module.exports = isPromise;
	
	function isPromise(obj) {
	  return !!obj && (typeof obj === 'object' || typeof obj === 'function') && typeof obj.then === 'function';
	}


/***/ }),
/* 989 */
/***/ (function(module, exports) {

	/* global window */
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = chromeDebug;
	
	function chromeDebug(alt) {
	  if (typeof window !== 'undefined') window['alt.js.org'] = alt;
	  return alt;
	}
	
	module.exports = exports['default'];

/***/ }),
/* 990 */
/***/ (function(module, exports, __webpack_require__) {

	var baseAssignValue = __webpack_require__(772),
	    createAggregator = __webpack_require__(991);
	
	/**
	 * Creates an object composed of keys generated from the results of running
	 * each element of `collection` thru `iteratee`. The corresponding value of
	 * each key is the last element responsible for generating the key. The
	 * iteratee is invoked with one argument: (value).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	 * @returns {Object} Returns the composed aggregate object.
	 * @example
	 *
	 * var array = [
	 *   { 'dir': 'left', 'code': 97 },
	 *   { 'dir': 'right', 'code': 100 }
	 * ];
	 *
	 * _.keyBy(array, function(o) {
	 *   return String.fromCharCode(o.code);
	 * });
	 * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
	 *
	 * _.keyBy(array, 'dir');
	 * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
	 */
	var keyBy = createAggregator(function(result, value, key) {
	  baseAssignValue(result, key, value);
	});
	
	module.exports = keyBy;


/***/ }),
/* 991 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayAggregator = __webpack_require__(992),
	    baseAggregator = __webpack_require__(993),
	    baseIteratee = __webpack_require__(997),
	    isArray = __webpack_require__(789);
	
	/**
	 * Creates a function like `_.groupBy`.
	 *
	 * @private
	 * @param {Function} setter The function to set accumulator values.
	 * @param {Function} [initializer] The accumulator object initializer.
	 * @returns {Function} Returns the new aggregator function.
	 */
	function createAggregator(setter, initializer) {
	  return function(collection, iteratee) {
	    var func = isArray(collection) ? arrayAggregator : baseAggregator,
	        accumulator = initializer ? initializer() : {};
	
	    return func(collection, setter, baseIteratee(iteratee, 2), accumulator);
	  };
	}
	
	module.exports = createAggregator;


/***/ }),
/* 992 */
/***/ (function(module, exports) {

	/**
	 * A specialized version of `baseAggregator` for arrays.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} setter The function to set `accumulator` values.
	 * @param {Function} iteratee The iteratee to transform keys.
	 * @param {Object} accumulator The initial aggregated object.
	 * @returns {Function} Returns `accumulator`.
	 */
	function arrayAggregator(array, setter, iteratee, accumulator) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  while (++index < length) {
	    var value = array[index];
	    setter(accumulator, value, iteratee(value), array);
	  }
	  return accumulator;
	}
	
	module.exports = arrayAggregator;


/***/ }),
/* 993 */
/***/ (function(module, exports, __webpack_require__) {

	var baseEach = __webpack_require__(994);
	
	/**
	 * Aggregates elements of `collection` on `accumulator` with keys transformed
	 * by `iteratee` and values set by `setter`.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} setter The function to set `accumulator` values.
	 * @param {Function} iteratee The iteratee to transform keys.
	 * @param {Object} accumulator The initial aggregated object.
	 * @returns {Function} Returns `accumulator`.
	 */
	function baseAggregator(collection, setter, iteratee, accumulator) {
	  baseEach(collection, function(value, key, collection) {
	    setter(accumulator, value, iteratee(value), collection);
	  });
	  return accumulator;
	}
	
	module.exports = baseAggregator;


/***/ }),
/* 994 */
/***/ (function(module, exports, __webpack_require__) {

	var baseForOwn = __webpack_require__(995),
	    createBaseEach = __webpack_require__(996);
	
	/**
	 * The base implementation of `_.forEach` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array|Object} Returns `collection`.
	 */
	var baseEach = createBaseEach(baseForOwn);
	
	module.exports = baseEach;


/***/ }),
/* 995 */
/***/ (function(module, exports, __webpack_require__) {

	var baseFor = __webpack_require__(774),
	    keys = __webpack_require__(921);
	
	/**
	 * The base implementation of `_.forOwn` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Object} Returns `object`.
	 */
	function baseForOwn(object, iteratee) {
	  return object && baseFor(object, iteratee, keys);
	}
	
	module.exports = baseForOwn;


/***/ }),
/* 996 */
/***/ (function(module, exports, __webpack_require__) {

	var isArrayLike = __webpack_require__(791);
	
	/**
	 * Creates a `baseEach` or `baseEachRight` function.
	 *
	 * @private
	 * @param {Function} eachFunc The function to iterate over a collection.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseEach(eachFunc, fromRight) {
	  return function(collection, iteratee) {
	    if (collection == null) {
	      return collection;
	    }
	    if (!isArrayLike(collection)) {
	      return eachFunc(collection, iteratee);
	    }
	    var length = collection.length,
	        index = fromRight ? length : -1,
	        iterable = Object(collection);
	
	    while ((fromRight ? index-- : ++index < length)) {
	      if (iteratee(iterable[index], index, iterable) === false) {
	        break;
	      }
	    }
	    return collection;
	  };
	}
	
	module.exports = createBaseEach;


/***/ }),
/* 997 */
/***/ (function(module, exports, __webpack_require__) {

	var baseMatches = __webpack_require__(998),
	    baseMatchesProperty = __webpack_require__(1003),
	    identity = __webpack_require__(812),
	    isArray = __webpack_require__(789),
	    property = __webpack_require__(1018);
	
	/**
	 * The base implementation of `_.iteratee`.
	 *
	 * @private
	 * @param {*} [value=_.identity] The value to convert to an iteratee.
	 * @returns {Function} Returns the iteratee.
	 */
	function baseIteratee(value) {
	  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
	  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
	  if (typeof value == 'function') {
	    return value;
	  }
	  if (value == null) {
	    return identity;
	  }
	  if (typeof value == 'object') {
	    return isArray(value)
	      ? baseMatchesProperty(value[0], value[1])
	      : baseMatches(value);
	  }
	  return property(value);
	}
	
	module.exports = baseIteratee;


/***/ }),
/* 998 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsMatch = __webpack_require__(999),
	    getMatchData = __webpack_require__(1000),
	    matchesStrictComparable = __webpack_require__(1002);
	
	/**
	 * The base implementation of `_.matches` which doesn't clone `source`.
	 *
	 * @private
	 * @param {Object} source The object of property values to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function baseMatches(source) {
	  var matchData = getMatchData(source);
	  if (matchData.length == 1 && matchData[0][2]) {
	    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
	  }
	  return function(object) {
	    return object === source || baseIsMatch(object, source, matchData);
	  };
	}
	
	module.exports = baseMatches;


/***/ }),
/* 999 */
/***/ (function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(734),
	    baseIsEqual = __webpack_require__(925);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/**
	 * The base implementation of `_.isMatch` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The object to inspect.
	 * @param {Object} source The object of property values to match.
	 * @param {Array} matchData The property names, values, and compare flags to match.
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	 */
	function baseIsMatch(object, source, matchData, customizer) {
	  var index = matchData.length,
	      length = index,
	      noCustomizer = !customizer;
	
	  if (object == null) {
	    return !length;
	  }
	  object = Object(object);
	  while (index--) {
	    var data = matchData[index];
	    if ((noCustomizer && data[2])
	          ? data[1] !== object[data[0]]
	          : !(data[0] in object)
	        ) {
	      return false;
	    }
	  }
	  while (++index < length) {
	    data = matchData[index];
	    var key = data[0],
	        objValue = object[key],
	        srcValue = data[1];
	
	    if (noCustomizer && data[2]) {
	      if (objValue === undefined && !(key in object)) {
	        return false;
	      }
	    } else {
	      var stack = new Stack;
	      if (customizer) {
	        var result = customizer(objValue, srcValue, key, object, source, stack);
	      }
	      if (!(result === undefined
	            ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
	            : result
	          )) {
	        return false;
	      }
	    }
	  }
	  return true;
	}
	
	module.exports = baseIsMatch;


/***/ }),
/* 1000 */
/***/ (function(module, exports, __webpack_require__) {

	var isStrictComparable = __webpack_require__(1001),
	    keys = __webpack_require__(921);
	
	/**
	 * Gets the property names, values, and compare flags of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the match data of `object`.
	 */
	function getMatchData(object) {
	  var result = keys(object),
	      length = result.length;
	
	  while (length--) {
	    var key = result[length],
	        value = object[key];
	
	    result[length] = [key, value, isStrictComparable(value)];
	  }
	  return result;
	}
	
	module.exports = getMatchData;


/***/ }),
/* 1001 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(643);
	
	/**
	 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` if suitable for strict
	 *  equality comparisons, else `false`.
	 */
	function isStrictComparable(value) {
	  return value === value && !isObject(value);
	}
	
	module.exports = isStrictComparable;


/***/ }),
/* 1002 */
/***/ (function(module, exports) {

	/**
	 * A specialized version of `matchesProperty` for source values suitable
	 * for strict equality comparisons, i.e. `===`.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @param {*} srcValue The value to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function matchesStrictComparable(key, srcValue) {
	  return function(object) {
	    if (object == null) {
	      return false;
	    }
	    return object[key] === srcValue &&
	      (srcValue !== undefined || (key in Object(object)));
	  };
	}
	
	module.exports = matchesStrictComparable;


/***/ }),
/* 1003 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsEqual = __webpack_require__(925),
	    get = __webpack_require__(1004),
	    hasIn = __webpack_require__(1015),
	    isKey = __webpack_require__(1007),
	    isStrictComparable = __webpack_require__(1001),
	    matchesStrictComparable = __webpack_require__(1002),
	    toKey = __webpack_require__(1014);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/**
	 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
	 *
	 * @private
	 * @param {string} path The path of the property to get.
	 * @param {*} srcValue The value to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function baseMatchesProperty(path, srcValue) {
	  if (isKey(path) && isStrictComparable(srcValue)) {
	    return matchesStrictComparable(toKey(path), srcValue);
	  }
	  return function(object) {
	    var objValue = get(object, path);
	    return (objValue === undefined && objValue === srcValue)
	      ? hasIn(object, path)
	      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
	  };
	}
	
	module.exports = baseMatchesProperty;


/***/ }),
/* 1004 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(1005);
	
	/**
	 * Gets the value at `path` of `object`. If the resolved value is
	 * `undefined`, the `defaultValue` is returned in its place.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.7.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	 * @returns {*} Returns the resolved value.
	 * @example
	 *
	 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	 *
	 * _.get(object, 'a[0].b.c');
	 * // => 3
	 *
	 * _.get(object, ['a', '0', 'b', 'c']);
	 * // => 3
	 *
	 * _.get(object, 'a.b.c', 'default');
	 * // => 'default'
	 */
	function get(object, path, defaultValue) {
	  var result = object == null ? undefined : baseGet(object, path);
	  return result === undefined ? defaultValue : result;
	}
	
	module.exports = get;


/***/ }),
/* 1005 */
/***/ (function(module, exports, __webpack_require__) {

	var castPath = __webpack_require__(1006),
	    toKey = __webpack_require__(1014);
	
	/**
	 * The base implementation of `_.get` without support for default values.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @returns {*} Returns the resolved value.
	 */
	function baseGet(object, path) {
	  path = castPath(path, object);
	
	  var index = 0,
	      length = path.length;
	
	  while (object != null && index < length) {
	    object = object[toKey(path[index++])];
	  }
	  return (index && index == length) ? object : undefined;
	}
	
	module.exports = baseGet;


/***/ }),
/* 1006 */
/***/ (function(module, exports, __webpack_require__) {

	var isArray = __webpack_require__(789),
	    isKey = __webpack_require__(1007),
	    stringToPath = __webpack_require__(1008),
	    toString = __webpack_require__(1011);
	
	/**
	 * Casts `value` to a path array if it's not one.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @param {Object} [object] The object to query keys on.
	 * @returns {Array} Returns the cast property path array.
	 */
	function castPath(value, object) {
	  if (isArray(value)) {
	    return value;
	  }
	  return isKey(value, object) ? [value] : stringToPath(toString(value));
	}
	
	module.exports = castPath;


/***/ }),
/* 1007 */
/***/ (function(module, exports, __webpack_require__) {

	var isArray = __webpack_require__(789),
	    isSymbol = __webpack_require__(650);
	
	/** Used to match property names within property paths. */
	var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
	    reIsPlainProp = /^\w*$/;
	
	/**
	 * Checks if `value` is a property name and not a property path.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {Object} [object] The object to query keys on.
	 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	 */
	function isKey(value, object) {
	  if (isArray(value)) {
	    return false;
	  }
	  var type = typeof value;
	  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
	      value == null || isSymbol(value)) {
	    return true;
	  }
	  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
	    (object != null && value in Object(object));
	}
	
	module.exports = isKey;


/***/ }),
/* 1008 */
/***/ (function(module, exports, __webpack_require__) {

	var memoizeCapped = __webpack_require__(1009);
	
	/** Used to match property names within property paths. */
	var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
	
	/** Used to match backslashes in property paths. */
	var reEscapeChar = /\\(\\)?/g;
	
	/**
	 * Converts `string` to a property path array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the property path array.
	 */
	var stringToPath = memoizeCapped(function(string) {
	  var result = [];
	  if (string.charCodeAt(0) === 46 /* . */) {
	    result.push('');
	  }
	  string.replace(rePropName, function(match, number, quote, subString) {
	    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
	  });
	  return result;
	});
	
	module.exports = stringToPath;


/***/ }),
/* 1009 */
/***/ (function(module, exports, __webpack_require__) {

	var memoize = __webpack_require__(1010);
	
	/** Used as the maximum memoize cache size. */
	var MAX_MEMOIZE_SIZE = 500;
	
	/**
	 * A specialized version of `_.memoize` which clears the memoized function's
	 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
	 *
	 * @private
	 * @param {Function} func The function to have its output memoized.
	 * @returns {Function} Returns the new memoized function.
	 */
	function memoizeCapped(func) {
	  var result = memoize(func, function(key) {
	    if (cache.size === MAX_MEMOIZE_SIZE) {
	      cache.clear();
	    }
	    return key;
	  });
	
	  var cache = result.cache;
	  return result;
	}
	
	module.exports = memoizeCapped;


/***/ }),
/* 1010 */
/***/ (function(module, exports, __webpack_require__) {

	var MapCache = __webpack_require__(756);
	
	/** Error message constants. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/**
	 * Creates a function that memoizes the result of `func`. If `resolver` is
	 * provided, it determines the cache key for storing the result based on the
	 * arguments provided to the memoized function. By default, the first argument
	 * provided to the memoized function is used as the map cache key. The `func`
	 * is invoked with the `this` binding of the memoized function.
	 *
	 * **Note:** The cache is exposed as the `cache` property on the memoized
	 * function. Its creation may be customized by replacing the `_.memoize.Cache`
	 * constructor with one whose instances implement the
	 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
	 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to have its output memoized.
	 * @param {Function} [resolver] The function to resolve the cache key.
	 * @returns {Function} Returns the new memoized function.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': 2 };
	 * var other = { 'c': 3, 'd': 4 };
	 *
	 * var values = _.memoize(_.values);
	 * values(object);
	 * // => [1, 2]
	 *
	 * values(other);
	 * // => [3, 4]
	 *
	 * object.a = 2;
	 * values(object);
	 * // => [1, 2]
	 *
	 * // Modify the result cache.
	 * values.cache.set(object, ['a', 'b']);
	 * values(object);
	 * // => ['a', 'b']
	 *
	 * // Replace `_.memoize.Cache`.
	 * _.memoize.Cache = WeakMap;
	 */
	function memoize(func, resolver) {
	  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  var memoized = function() {
	    var args = arguments,
	        key = resolver ? resolver.apply(this, args) : args[0],
	        cache = memoized.cache;
	
	    if (cache.has(key)) {
	      return cache.get(key);
	    }
	    var result = func.apply(this, args);
	    memoized.cache = cache.set(key, result) || cache;
	    return result;
	  };
	  memoized.cache = new (memoize.Cache || MapCache);
	  return memoized;
	}
	
	// Expose `MapCache`.
	memoize.Cache = MapCache;
	
	module.exports = memoize;


/***/ }),
/* 1011 */
/***/ (function(module, exports, __webpack_require__) {

	var baseToString = __webpack_require__(1012);
	
	/**
	 * Converts `value` to a string. An empty string is returned for `null`
	 * and `undefined` values. The sign of `-0` is preserved.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 * @example
	 *
	 * _.toString(null);
	 * // => ''
	 *
	 * _.toString(-0);
	 * // => '-0'
	 *
	 * _.toString([1, 2, 3]);
	 * // => '1,2,3'
	 */
	function toString(value) {
	  return value == null ? '' : baseToString(value);
	}
	
	module.exports = toString;


/***/ }),
/* 1012 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(652),
	    arrayMap = __webpack_require__(1013),
	    isArray = __webpack_require__(789),
	    isSymbol = __webpack_require__(650);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolToString = symbolProto ? symbolProto.toString : undefined;
	
	/**
	 * The base implementation of `_.toString` which doesn't convert nullish
	 * values to empty strings.
	 *
	 * @private
	 * @param {*} value The value to process.
	 * @returns {string} Returns the string.
	 */
	function baseToString(value) {
	  // Exit early for strings to avoid a performance hit in some environments.
	  if (typeof value == 'string') {
	    return value;
	  }
	  if (isArray(value)) {
	    // Recursively convert values (susceptible to call stack limits).
	    return arrayMap(value, baseToString) + '';
	  }
	  if (isSymbol(value)) {
	    return symbolToString ? symbolToString.call(value) : '';
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	module.exports = baseToString;


/***/ }),
/* 1013 */
/***/ (function(module, exports) {

	/**
	 * A specialized version of `_.map` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 */
	function arrayMap(array, iteratee) {
	  var index = -1,
	      length = array == null ? 0 : array.length,
	      result = Array(length);
	
	  while (++index < length) {
	    result[index] = iteratee(array[index], index, array);
	  }
	  return result;
	}
	
	module.exports = arrayMap;


/***/ }),
/* 1014 */
/***/ (function(module, exports, __webpack_require__) {

	var isSymbol = __webpack_require__(650);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/**
	 * Converts `value` to a string key if it's not a string or symbol.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {string|symbol} Returns the key.
	 */
	function toKey(value) {
	  if (typeof value == 'string' || isSymbol(value)) {
	    return value;
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	module.exports = toKey;


/***/ }),
/* 1015 */
/***/ (function(module, exports, __webpack_require__) {

	var baseHasIn = __webpack_require__(1016),
	    hasPath = __webpack_require__(1017);
	
	/**
	 * Checks if `path` is a direct or inherited property of `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path to check.
	 * @returns {boolean} Returns `true` if `path` exists, else `false`.
	 * @example
	 *
	 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
	 *
	 * _.hasIn(object, 'a');
	 * // => true
	 *
	 * _.hasIn(object, 'a.b');
	 * // => true
	 *
	 * _.hasIn(object, ['a', 'b']);
	 * // => true
	 *
	 * _.hasIn(object, 'b');
	 * // => false
	 */
	function hasIn(object, path) {
	  return object != null && hasPath(object, path, baseHasIn);
	}
	
	module.exports = hasIn;


/***/ }),
/* 1016 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.hasIn` without support for deep paths.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {Array|string} key The key to check.
	 * @returns {boolean} Returns `true` if `key` exists, else `false`.
	 */
	function baseHasIn(object, key) {
	  return object != null && key in Object(object);
	}
	
	module.exports = baseHasIn;


/***/ }),
/* 1017 */
/***/ (function(module, exports, __webpack_require__) {

	var castPath = __webpack_require__(1006),
	    isArguments = __webpack_require__(787),
	    isArray = __webpack_require__(789),
	    isIndex = __webpack_require__(807),
	    isLength = __webpack_require__(792),
	    toKey = __webpack_require__(1014);
	
	/**
	 * Checks if `path` exists on `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path to check.
	 * @param {Function} hasFunc The function to check properties.
	 * @returns {boolean} Returns `true` if `path` exists, else `false`.
	 */
	function hasPath(object, path, hasFunc) {
	  path = castPath(path, object);
	
	  var index = -1,
	      length = path.length,
	      result = false;
	
	  while (++index < length) {
	    var key = toKey(path[index]);
	    if (!(result = object != null && hasFunc(object, key))) {
	      break;
	    }
	    object = object[key];
	  }
	  if (result || ++index != length) {
	    return result;
	  }
	  length = object == null ? 0 : object.length;
	  return !!length && isLength(length) && isIndex(key, length) &&
	    (isArray(object) || isArguments(object));
	}
	
	module.exports = hasPath;


/***/ }),
/* 1018 */
/***/ (function(module, exports, __webpack_require__) {

	var baseProperty = __webpack_require__(1019),
	    basePropertyDeep = __webpack_require__(1020),
	    isKey = __webpack_require__(1007),
	    toKey = __webpack_require__(1014);
	
	/**
	 * Creates a function that returns the value at `path` of a given object.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Util
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 * @example
	 *
	 * var objects = [
	 *   { 'a': { 'b': 2 } },
	 *   { 'a': { 'b': 1 } }
	 * ];
	 *
	 * _.map(objects, _.property('a.b'));
	 * // => [2, 1]
	 *
	 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
	 * // => [1, 2]
	 */
	function property(path) {
	  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
	}
	
	module.exports = property;


/***/ }),
/* 1019 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.property` without support for deep paths.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 */
	function baseProperty(key) {
	  return function(object) {
	    return object == null ? undefined : object[key];
	  };
	}
	
	module.exports = baseProperty;


/***/ }),
/* 1020 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(1005);
	
	/**
	 * A specialized version of `baseProperty` which supports deep paths.
	 *
	 * @private
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 */
	function basePropertyDeep(path) {
	  return function(object) {
	    return baseGet(object, path);
	  };
	}
	
	module.exports = basePropertyDeep;


/***/ }),
/* 1021 */
/***/ (function(module, exports, __webpack_require__) {

	var require;/* WEBPACK VAR INJECTION */(function(module) {//! moment.js
	//! version : 2.29.1
	//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
	//! license : MIT
	//! momentjs.com
	
	;(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    global.moment = factory()
	}(this, (function () { 'use strict';
	
	    var hookCallback;
	
	    function hooks() {
	        return hookCallback.apply(null, arguments);
	    }
	
	    // This is done to register the method called with moment()
	    // without creating circular dependencies.
	    function setHookCallback(callback) {
	        hookCallback = callback;
	    }
	
	    function isArray(input) {
	        return (
	            input instanceof Array ||
	            Object.prototype.toString.call(input) === '[object Array]'
	        );
	    }
	
	    function isObject(input) {
	        // IE8 will treat undefined and null as object if it wasn't for
	        // input != null
	        return (
	            input != null &&
	            Object.prototype.toString.call(input) === '[object Object]'
	        );
	    }
	
	    function hasOwnProp(a, b) {
	        return Object.prototype.hasOwnProperty.call(a, b);
	    }
	
	    function isObjectEmpty(obj) {
	        if (Object.getOwnPropertyNames) {
	            return Object.getOwnPropertyNames(obj).length === 0;
	        } else {
	            var k;
	            for (k in obj) {
	                if (hasOwnProp(obj, k)) {
	                    return false;
	                }
	            }
	            return true;
	        }
	    }
	
	    function isUndefined(input) {
	        return input === void 0;
	    }
	
	    function isNumber(input) {
	        return (
	            typeof input === 'number' ||
	            Object.prototype.toString.call(input) === '[object Number]'
	        );
	    }
	
	    function isDate(input) {
	        return (
	            input instanceof Date ||
	            Object.prototype.toString.call(input) === '[object Date]'
	        );
	    }
	
	    function map(arr, fn) {
	        var res = [],
	            i;
	        for (i = 0; i < arr.length; ++i) {
	            res.push(fn(arr[i], i));
	        }
	        return res;
	    }
	
	    function extend(a, b) {
	        for (var i in b) {
	            if (hasOwnProp(b, i)) {
	                a[i] = b[i];
	            }
	        }
	
	        if (hasOwnProp(b, 'toString')) {
	            a.toString = b.toString;
	        }
	
	        if (hasOwnProp(b, 'valueOf')) {
	            a.valueOf = b.valueOf;
	        }
	
	        return a;
	    }
	
	    function createUTC(input, format, locale, strict) {
	        return createLocalOrUTC(input, format, locale, strict, true).utc();
	    }
	
	    function defaultParsingFlags() {
	        // We need to deep clone this object.
	        return {
	            empty: false,
	            unusedTokens: [],
	            unusedInput: [],
	            overflow: -2,
	            charsLeftOver: 0,
	            nullInput: false,
	            invalidEra: null,
	            invalidMonth: null,
	            invalidFormat: false,
	            userInvalidated: false,
	            iso: false,
	            parsedDateParts: [],
	            era: null,
	            meridiem: null,
	            rfc2822: false,
	            weekdayMismatch: false,
	        };
	    }
	
	    function getParsingFlags(m) {
	        if (m._pf == null) {
	            m._pf = defaultParsingFlags();
	        }
	        return m._pf;
	    }
	
	    var some;
	    if (Array.prototype.some) {
	        some = Array.prototype.some;
	    } else {
	        some = function (fun) {
	            var t = Object(this),
	                len = t.length >>> 0,
	                i;
	
	            for (i = 0; i < len; i++) {
	                if (i in t && fun.call(this, t[i], i, t)) {
	                    return true;
	                }
	            }
	
	            return false;
	        };
	    }
	
	    function isValid(m) {
	        if (m._isValid == null) {
	            var flags = getParsingFlags(m),
	                parsedParts = some.call(flags.parsedDateParts, function (i) {
	                    return i != null;
	                }),
	                isNowValid =
	                    !isNaN(m._d.getTime()) &&
	                    flags.overflow < 0 &&
	                    !flags.empty &&
	                    !flags.invalidEra &&
	                    !flags.invalidMonth &&
	                    !flags.invalidWeekday &&
	                    !flags.weekdayMismatch &&
	                    !flags.nullInput &&
	                    !flags.invalidFormat &&
	                    !flags.userInvalidated &&
	                    (!flags.meridiem || (flags.meridiem && parsedParts));
	
	            if (m._strict) {
	                isNowValid =
	                    isNowValid &&
	                    flags.charsLeftOver === 0 &&
	                    flags.unusedTokens.length === 0 &&
	                    flags.bigHour === undefined;
	            }
	
	            if (Object.isFrozen == null || !Object.isFrozen(m)) {
	                m._isValid = isNowValid;
	            } else {
	                return isNowValid;
	            }
	        }
	        return m._isValid;
	    }
	
	    function createInvalid(flags) {
	        var m = createUTC(NaN);
	        if (flags != null) {
	            extend(getParsingFlags(m), flags);
	        } else {
	            getParsingFlags(m).userInvalidated = true;
	        }
	
	        return m;
	    }
	
	    // Plugins that add properties should also add the key here (null value),
	    // so we can properly clone ourselves.
	    var momentProperties = (hooks.momentProperties = []),
	        updateInProgress = false;
	
	    function copyConfig(to, from) {
	        var i, prop, val;
	
	        if (!isUndefined(from._isAMomentObject)) {
	            to._isAMomentObject = from._isAMomentObject;
	        }
	        if (!isUndefined(from._i)) {
	            to._i = from._i;
	        }
	        if (!isUndefined(from._f)) {
	            to._f = from._f;
	        }
	        if (!isUndefined(from._l)) {
	            to._l = from._l;
	        }
	        if (!isUndefined(from._strict)) {
	            to._strict = from._strict;
	        }
	        if (!isUndefined(from._tzm)) {
	            to._tzm = from._tzm;
	        }
	        if (!isUndefined(from._isUTC)) {
	            to._isUTC = from._isUTC;
	        }
	        if (!isUndefined(from._offset)) {
	            to._offset = from._offset;
	        }
	        if (!isUndefined(from._pf)) {
	            to._pf = getParsingFlags(from);
	        }
	        if (!isUndefined(from._locale)) {
	            to._locale = from._locale;
	        }
	
	        if (momentProperties.length > 0) {
	            for (i = 0; i < momentProperties.length; i++) {
	                prop = momentProperties[i];
	                val = from[prop];
	                if (!isUndefined(val)) {
	                    to[prop] = val;
	                }
	            }
	        }
	
	        return to;
	    }
	
	    // Moment prototype object
	    function Moment(config) {
	        copyConfig(this, config);
	        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
	        if (!this.isValid()) {
	            this._d = new Date(NaN);
	        }
	        // Prevent infinite loop in case updateOffset creates new moment
	        // objects.
	        if (updateInProgress === false) {
	            updateInProgress = true;
	            hooks.updateOffset(this);
	            updateInProgress = false;
	        }
	    }
	
	    function isMoment(obj) {
	        return (
	            obj instanceof Moment || (obj != null && obj._isAMomentObject != null)
	        );
	    }
	
	    function warn(msg) {
	        if (
	            hooks.suppressDeprecationWarnings === false &&
	            typeof console !== 'undefined' &&
	            console.warn
	        ) {
	            console.warn('Deprecation warning: ' + msg);
	        }
	    }
	
	    function deprecate(msg, fn) {
	        var firstTime = true;
	
	        return extend(function () {
	            if (hooks.deprecationHandler != null) {
	                hooks.deprecationHandler(null, msg);
	            }
	            if (firstTime) {
	                var args = [],
	                    arg,
	                    i,
	                    key;
	                for (i = 0; i < arguments.length; i++) {
	                    arg = '';
	                    if (typeof arguments[i] === 'object') {
	                        arg += '\n[' + i + '] ';
	                        for (key in arguments[0]) {
	                            if (hasOwnProp(arguments[0], key)) {
	                                arg += key + ': ' + arguments[0][key] + ', ';
	                            }
	                        }
	                        arg = arg.slice(0, -2); // Remove trailing comma and space
	                    } else {
	                        arg = arguments[i];
	                    }
	                    args.push(arg);
	                }
	                warn(
	                    msg +
	                        '\nArguments: ' +
	                        Array.prototype.slice.call(args).join('') +
	                        '\n' +
	                        new Error().stack
	                );
	                firstTime = false;
	            }
	            return fn.apply(this, arguments);
	        }, fn);
	    }
	
	    var deprecations = {};
	
	    function deprecateSimple(name, msg) {
	        if (hooks.deprecationHandler != null) {
	            hooks.deprecationHandler(name, msg);
	        }
	        if (!deprecations[name]) {
	            warn(msg);
	            deprecations[name] = true;
	        }
	    }
	
	    hooks.suppressDeprecationWarnings = false;
	    hooks.deprecationHandler = null;
	
	    function isFunction(input) {
	        return (
	            (typeof Function !== 'undefined' && input instanceof Function) ||
	            Object.prototype.toString.call(input) === '[object Function]'
	        );
	    }
	
	    function set(config) {
	        var prop, i;
	        for (i in config) {
	            if (hasOwnProp(config, i)) {
	                prop = config[i];
	                if (isFunction(prop)) {
	                    this[i] = prop;
	                } else {
	                    this['_' + i] = prop;
	                }
	            }
	        }
	        this._config = config;
	        // Lenient ordinal parsing accepts just a number in addition to
	        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
	        // TODO: Remove "ordinalParse" fallback in next major release.
	        this._dayOfMonthOrdinalParseLenient = new RegExp(
	            (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
	                '|' +
	                /\d{1,2}/.source
	        );
	    }
	
	    function mergeConfigs(parentConfig, childConfig) {
	        var res = extend({}, parentConfig),
	            prop;
	        for (prop in childConfig) {
	            if (hasOwnProp(childConfig, prop)) {
	                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
	                    res[prop] = {};
	                    extend(res[prop], parentConfig[prop]);
	                    extend(res[prop], childConfig[prop]);
	                } else if (childConfig[prop] != null) {
	                    res[prop] = childConfig[prop];
	                } else {
	                    delete res[prop];
	                }
	            }
	        }
	        for (prop in parentConfig) {
	            if (
	                hasOwnProp(parentConfig, prop) &&
	                !hasOwnProp(childConfig, prop) &&
	                isObject(parentConfig[prop])
	            ) {
	                // make sure changes to properties don't modify parent config
	                res[prop] = extend({}, res[prop]);
	            }
	        }
	        return res;
	    }
	
	    function Locale(config) {
	        if (config != null) {
	            this.set(config);
	        }
	    }
	
	    var keys;
	
	    if (Object.keys) {
	        keys = Object.keys;
	    } else {
	        keys = function (obj) {
	            var i,
	                res = [];
	            for (i in obj) {
	                if (hasOwnProp(obj, i)) {
	                    res.push(i);
	                }
	            }
	            return res;
	        };
	    }
	
	    var defaultCalendar = {
	        sameDay: '[Today at] LT',
	        nextDay: '[Tomorrow at] LT',
	        nextWeek: 'dddd [at] LT',
	        lastDay: '[Yesterday at] LT',
	        lastWeek: '[Last] dddd [at] LT',
	        sameElse: 'L',
	    };
	
	    function calendar(key, mom, now) {
	        var output = this._calendar[key] || this._calendar['sameElse'];
	        return isFunction(output) ? output.call(mom, now) : output;
	    }
	
	    function zeroFill(number, targetLength, forceSign) {
	        var absNumber = '' + Math.abs(number),
	            zerosToFill = targetLength - absNumber.length,
	            sign = number >= 0;
	        return (
	            (sign ? (forceSign ? '+' : '') : '-') +
	            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) +
	            absNumber
	        );
	    }
	
	    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g,
	        localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g,
	        formatFunctions = {},
	        formatTokenFunctions = {};
	
	    // token:    'M'
	    // padded:   ['MM', 2]
	    // ordinal:  'Mo'
	    // callback: function () { this.month() + 1 }
	    function addFormatToken(token, padded, ordinal, callback) {
	        var func = callback;
	        if (typeof callback === 'string') {
	            func = function () {
	                return this[callback]();
	            };
	        }
	        if (token) {
	            formatTokenFunctions[token] = func;
	        }
	        if (padded) {
	            formatTokenFunctions[padded[0]] = function () {
	                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
	            };
	        }
	        if (ordinal) {
	            formatTokenFunctions[ordinal] = function () {
	                return this.localeData().ordinal(
	                    func.apply(this, arguments),
	                    token
	                );
	            };
	        }
	    }
	
	    function removeFormattingTokens(input) {
	        if (input.match(/\[[\s\S]/)) {
	            return input.replace(/^\[|\]$/g, '');
	        }
	        return input.replace(/\\/g, '');
	    }
	
	    function makeFormatFunction(format) {
	        var array = format.match(formattingTokens),
	            i,
	            length;
	
	        for (i = 0, length = array.length; i < length; i++) {
	            if (formatTokenFunctions[array[i]]) {
	                array[i] = formatTokenFunctions[array[i]];
	            } else {
	                array[i] = removeFormattingTokens(array[i]);
	            }
	        }
	
	        return function (mom) {
	            var output = '',
	                i;
	            for (i = 0; i < length; i++) {
	                output += isFunction(array[i])
	                    ? array[i].call(mom, format)
	                    : array[i];
	            }
	            return output;
	        };
	    }
	
	    // format date using native date object
	    function formatMoment(m, format) {
	        if (!m.isValid()) {
	            return m.localeData().invalidDate();
	        }
	
	        format = expandFormat(format, m.localeData());
	        formatFunctions[format] =
	            formatFunctions[format] || makeFormatFunction(format);
	
	        return formatFunctions[format](m);
	    }
	
	    function expandFormat(format, locale) {
	        var i = 5;
	
	        function replaceLongDateFormatTokens(input) {
	            return locale.longDateFormat(input) || input;
	        }
	
	        localFormattingTokens.lastIndex = 0;
	        while (i >= 0 && localFormattingTokens.test(format)) {
	            format = format.replace(
	                localFormattingTokens,
	                replaceLongDateFormatTokens
	            );
	            localFormattingTokens.lastIndex = 0;
	            i -= 1;
	        }
	
	        return format;
	    }
	
	    var defaultLongDateFormat = {
	        LTS: 'h:mm:ss A',
	        LT: 'h:mm A',
	        L: 'MM/DD/YYYY',
	        LL: 'MMMM D, YYYY',
	        LLL: 'MMMM D, YYYY h:mm A',
	        LLLL: 'dddd, MMMM D, YYYY h:mm A',
	    };
	
	    function longDateFormat(key) {
	        var format = this._longDateFormat[key],
	            formatUpper = this._longDateFormat[key.toUpperCase()];
	
	        if (format || !formatUpper) {
	            return format;
	        }
	
	        this._longDateFormat[key] = formatUpper
	            .match(formattingTokens)
	            .map(function (tok) {
	                if (
	                    tok === 'MMMM' ||
	                    tok === 'MM' ||
	                    tok === 'DD' ||
	                    tok === 'dddd'
	                ) {
	                    return tok.slice(1);
	                }
	                return tok;
	            })
	            .join('');
	
	        return this._longDateFormat[key];
	    }
	
	    var defaultInvalidDate = 'Invalid date';
	
	    function invalidDate() {
	        return this._invalidDate;
	    }
	
	    var defaultOrdinal = '%d',
	        defaultDayOfMonthOrdinalParse = /\d{1,2}/;
	
	    function ordinal(number) {
	        return this._ordinal.replace('%d', number);
	    }
	
	    var defaultRelativeTime = {
	        future: 'in %s',
	        past: '%s ago',
	        s: 'a few seconds',
	        ss: '%d seconds',
	        m: 'a minute',
	        mm: '%d minutes',
	        h: 'an hour',
	        hh: '%d hours',
	        d: 'a day',
	        dd: '%d days',
	        w: 'a week',
	        ww: '%d weeks',
	        M: 'a month',
	        MM: '%d months',
	        y: 'a year',
	        yy: '%d years',
	    };
	
	    function relativeTime(number, withoutSuffix, string, isFuture) {
	        var output = this._relativeTime[string];
	        return isFunction(output)
	            ? output(number, withoutSuffix, string, isFuture)
	            : output.replace(/%d/i, number);
	    }
	
	    function pastFuture(diff, output) {
	        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
	        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
	    }
	
	    var aliases = {};
	
	    function addUnitAlias(unit, shorthand) {
	        var lowerCase = unit.toLowerCase();
	        aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
	    }
	
	    function normalizeUnits(units) {
	        return typeof units === 'string'
	            ? aliases[units] || aliases[units.toLowerCase()]
	            : undefined;
	    }
	
	    function normalizeObjectUnits(inputObject) {
	        var normalizedInput = {},
	            normalizedProp,
	            prop;
	
	        for (prop in inputObject) {
	            if (hasOwnProp(inputObject, prop)) {
	                normalizedProp = normalizeUnits(prop);
	                if (normalizedProp) {
	                    normalizedInput[normalizedProp] = inputObject[prop];
	                }
	            }
	        }
	
	        return normalizedInput;
	    }
	
	    var priorities = {};
	
	    function addUnitPriority(unit, priority) {
	        priorities[unit] = priority;
	    }
	
	    function getPrioritizedUnits(unitsObj) {
	        var units = [],
	            u;
	        for (u in unitsObj) {
	            if (hasOwnProp(unitsObj, u)) {
	                units.push({ unit: u, priority: priorities[u] });
	            }
	        }
	        units.sort(function (a, b) {
	            return a.priority - b.priority;
	        });
	        return units;
	    }
	
	    function isLeapYear(year) {
	        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
	    }
	
	    function absFloor(number) {
	        if (number < 0) {
	            // -0 -> 0
	            return Math.ceil(number) || 0;
	        } else {
	            return Math.floor(number);
	        }
	    }
	
	    function toInt(argumentForCoercion) {
	        var coercedNumber = +argumentForCoercion,
	            value = 0;
	
	        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
	            value = absFloor(coercedNumber);
	        }
	
	        return value;
	    }
	
	    function makeGetSet(unit, keepTime) {
	        return function (value) {
	            if (value != null) {
	                set$1(this, unit, value);
	                hooks.updateOffset(this, keepTime);
	                return this;
	            } else {
	                return get(this, unit);
	            }
	        };
	    }
	
	    function get(mom, unit) {
	        return mom.isValid()
	            ? mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]()
	            : NaN;
	    }
	
	    function set$1(mom, unit, value) {
	        if (mom.isValid() && !isNaN(value)) {
	            if (
	                unit === 'FullYear' &&
	                isLeapYear(mom.year()) &&
	                mom.month() === 1 &&
	                mom.date() === 29
	            ) {
	                value = toInt(value);
	                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](
	                    value,
	                    mom.month(),
	                    daysInMonth(value, mom.month())
	                );
	            } else {
	                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function stringGet(units) {
	        units = normalizeUnits(units);
	        if (isFunction(this[units])) {
	            return this[units]();
	        }
	        return this;
	    }
	
	    function stringSet(units, value) {
	        if (typeof units === 'object') {
	            units = normalizeObjectUnits(units);
	            var prioritized = getPrioritizedUnits(units),
	                i;
	            for (i = 0; i < prioritized.length; i++) {
	                this[prioritized[i].unit](units[prioritized[i].unit]);
	            }
	        } else {
	            units = normalizeUnits(units);
	            if (isFunction(this[units])) {
	                return this[units](value);
	            }
	        }
	        return this;
	    }
	
	    var match1 = /\d/, //       0 - 9
	        match2 = /\d\d/, //      00 - 99
	        match3 = /\d{3}/, //     000 - 999
	        match4 = /\d{4}/, //    0000 - 9999
	        match6 = /[+-]?\d{6}/, // -999999 - 999999
	        match1to2 = /\d\d?/, //       0 - 99
	        match3to4 = /\d\d\d\d?/, //     999 - 9999
	        match5to6 = /\d\d\d\d\d\d?/, //   99999 - 999999
	        match1to3 = /\d{1,3}/, //       0 - 999
	        match1to4 = /\d{1,4}/, //       0 - 9999
	        match1to6 = /[+-]?\d{1,6}/, // -999999 - 999999
	        matchUnsigned = /\d+/, //       0 - inf
	        matchSigned = /[+-]?\d+/, //    -inf - inf
	        matchOffset = /Z|[+-]\d\d:?\d\d/gi, // +00:00 -00:00 +0000 -0000 or Z
	        matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, // +00 -00 +00:00 -00:00 +0000 -0000 or Z
	        matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // 123456789 123456789.123
	        // any word (or two) characters or numbers including two/three word month in arabic.
	        // includes scottish gaelic two word and hyphenated months
	        matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i,
	        regexes;
	
	    regexes = {};
	
	    function addRegexToken(token, regex, strictRegex) {
	        regexes[token] = isFunction(regex)
	            ? regex
	            : function (isStrict, localeData) {
	                  return isStrict && strictRegex ? strictRegex : regex;
	              };
	    }
	
	    function getParseRegexForToken(token, config) {
	        if (!hasOwnProp(regexes, token)) {
	            return new RegExp(unescapeFormat(token));
	        }
	
	        return regexes[token](config._strict, config._locale);
	    }
	
	    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
	    function unescapeFormat(s) {
	        return regexEscape(
	            s
	                .replace('\\', '')
	                .replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (
	                    matched,
	                    p1,
	                    p2,
	                    p3,
	                    p4
	                ) {
	                    return p1 || p2 || p3 || p4;
	                })
	        );
	    }
	
	    function regexEscape(s) {
	        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
	    }
	
	    var tokens = {};
	
	    function addParseToken(token, callback) {
	        var i,
	            func = callback;
	        if (typeof token === 'string') {
	            token = [token];
	        }
	        if (isNumber(callback)) {
	            func = function (input, array) {
	                array[callback] = toInt(input);
	            };
	        }
	        for (i = 0; i < token.length; i++) {
	            tokens[token[i]] = func;
	        }
	    }
	
	    function addWeekParseToken(token, callback) {
	        addParseToken(token, function (input, array, config, token) {
	            config._w = config._w || {};
	            callback(input, config._w, config, token);
	        });
	    }
	
	    function addTimeToArrayFromToken(token, input, config) {
	        if (input != null && hasOwnProp(tokens, token)) {
	            tokens[token](input, config._a, config, token);
	        }
	    }
	
	    var YEAR = 0,
	        MONTH = 1,
	        DATE = 2,
	        HOUR = 3,
	        MINUTE = 4,
	        SECOND = 5,
	        MILLISECOND = 6,
	        WEEK = 7,
	        WEEKDAY = 8;
	
	    function mod(n, x) {
	        return ((n % x) + x) % x;
	    }
	
	    var indexOf;
	
	    if (Array.prototype.indexOf) {
	        indexOf = Array.prototype.indexOf;
	    } else {
	        indexOf = function (o) {
	            // I know
	            var i;
	            for (i = 0; i < this.length; ++i) {
	                if (this[i] === o) {
	                    return i;
	                }
	            }
	            return -1;
	        };
	    }
	
	    function daysInMonth(year, month) {
	        if (isNaN(year) || isNaN(month)) {
	            return NaN;
	        }
	        var modMonth = mod(month, 12);
	        year += (month - modMonth) / 12;
	        return modMonth === 1
	            ? isLeapYear(year)
	                ? 29
	                : 28
	            : 31 - ((modMonth % 7) % 2);
	    }
	
	    // FORMATTING
	
	    addFormatToken('M', ['MM', 2], 'Mo', function () {
	        return this.month() + 1;
	    });
	
	    addFormatToken('MMM', 0, 0, function (format) {
	        return this.localeData().monthsShort(this, format);
	    });
	
	    addFormatToken('MMMM', 0, 0, function (format) {
	        return this.localeData().months(this, format);
	    });
	
	    // ALIASES
	
	    addUnitAlias('month', 'M');
	
	    // PRIORITY
	
	    addUnitPriority('month', 8);
	
	    // PARSING
	
	    addRegexToken('M', match1to2);
	    addRegexToken('MM', match1to2, match2);
	    addRegexToken('MMM', function (isStrict, locale) {
	        return locale.monthsShortRegex(isStrict);
	    });
	    addRegexToken('MMMM', function (isStrict, locale) {
	        return locale.monthsRegex(isStrict);
	    });
	
	    addParseToken(['M', 'MM'], function (input, array) {
	        array[MONTH] = toInt(input) - 1;
	    });
	
	    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
	        var month = config._locale.monthsParse(input, token, config._strict);
	        // if we didn't find a month name, mark the date as invalid.
	        if (month != null) {
	            array[MONTH] = month;
	        } else {
	            getParsingFlags(config).invalidMonth = input;
	        }
	    });
	
	    // LOCALES
	
	    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split(
	            '_'
	        ),
	        MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/,
	        defaultMonthsShortRegex = matchWord,
	        defaultMonthsRegex = matchWord;
	
	    function localeMonths(m, format) {
	        if (!m) {
	            return isArray(this._months)
	                ? this._months
	                : this._months['standalone'];
	        }
	        return isArray(this._months)
	            ? this._months[m.month()]
	            : this._months[
	                  (this._months.isFormat || MONTHS_IN_FORMAT).test(format)
	                      ? 'format'
	                      : 'standalone'
	              ][m.month()];
	    }
	
	    function localeMonthsShort(m, format) {
	        if (!m) {
	            return isArray(this._monthsShort)
	                ? this._monthsShort
	                : this._monthsShort['standalone'];
	        }
	        return isArray(this._monthsShort)
	            ? this._monthsShort[m.month()]
	            : this._monthsShort[
	                  MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'
	              ][m.month()];
	    }
	
	    function handleStrictParse(monthName, format, strict) {
	        var i,
	            ii,
	            mom,
	            llc = monthName.toLocaleLowerCase();
	        if (!this._monthsParse) {
	            // this is not used
	            this._monthsParse = [];
	            this._longMonthsParse = [];
	            this._shortMonthsParse = [];
	            for (i = 0; i < 12; ++i) {
	                mom = createUTC([2000, i]);
	                this._shortMonthsParse[i] = this.monthsShort(
	                    mom,
	                    ''
	                ).toLocaleLowerCase();
	                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
	            }
	        }
	
	        if (strict) {
	            if (format === 'MMM') {
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._longMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        } else {
	            if (format === 'MMM') {
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._longMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._longMonthsParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        }
	    }
	
	    function localeMonthsParse(monthName, format, strict) {
	        var i, mom, regex;
	
	        if (this._monthsParseExact) {
	            return handleStrictParse.call(this, monthName, format, strict);
	        }
	
	        if (!this._monthsParse) {
	            this._monthsParse = [];
	            this._longMonthsParse = [];
	            this._shortMonthsParse = [];
	        }
	
	        // TODO: add sorting
	        // Sorting makes sure if one month (or abbr) is a prefix of another
	        // see sorting in computeMonthsParse
	        for (i = 0; i < 12; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, i]);
	            if (strict && !this._longMonthsParse[i]) {
	                this._longMonthsParse[i] = new RegExp(
	                    '^' + this.months(mom, '').replace('.', '') + '$',
	                    'i'
	                );
	                this._shortMonthsParse[i] = new RegExp(
	                    '^' + this.monthsShort(mom, '').replace('.', '') + '$',
	                    'i'
	                );
	            }
	            if (!strict && !this._monthsParse[i]) {
	                regex =
	                    '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
	                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
	            }
	            // test the regex
	            if (
	                strict &&
	                format === 'MMMM' &&
	                this._longMonthsParse[i].test(monthName)
	            ) {
	                return i;
	            } else if (
	                strict &&
	                format === 'MMM' &&
	                this._shortMonthsParse[i].test(monthName)
	            ) {
	                return i;
	            } else if (!strict && this._monthsParse[i].test(monthName)) {
	                return i;
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function setMonth(mom, value) {
	        var dayOfMonth;
	
	        if (!mom.isValid()) {
	            // No op
	            return mom;
	        }
	
	        if (typeof value === 'string') {
	            if (/^\d+$/.test(value)) {
	                value = toInt(value);
	            } else {
	                value = mom.localeData().monthsParse(value);
	                // TODO: Another silent failure?
	                if (!isNumber(value)) {
	                    return mom;
	                }
	            }
	        }
	
	        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
	        mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
	        return mom;
	    }
	
	    function getSetMonth(value) {
	        if (value != null) {
	            setMonth(this, value);
	            hooks.updateOffset(this, true);
	            return this;
	        } else {
	            return get(this, 'Month');
	        }
	    }
	
	    function getDaysInMonth() {
	        return daysInMonth(this.year(), this.month());
	    }
	
	    function monthsShortRegex(isStrict) {
	        if (this._monthsParseExact) {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                computeMonthsParse.call(this);
	            }
	            if (isStrict) {
	                return this._monthsShortStrictRegex;
	            } else {
	                return this._monthsShortRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_monthsShortRegex')) {
	                this._monthsShortRegex = defaultMonthsShortRegex;
	            }
	            return this._monthsShortStrictRegex && isStrict
	                ? this._monthsShortStrictRegex
	                : this._monthsShortRegex;
	        }
	    }
	
	    function monthsRegex(isStrict) {
	        if (this._monthsParseExact) {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                computeMonthsParse.call(this);
	            }
	            if (isStrict) {
	                return this._monthsStrictRegex;
	            } else {
	                return this._monthsRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                this._monthsRegex = defaultMonthsRegex;
	            }
	            return this._monthsStrictRegex && isStrict
	                ? this._monthsStrictRegex
	                : this._monthsRegex;
	        }
	    }
	
	    function computeMonthsParse() {
	        function cmpLenRev(a, b) {
	            return b.length - a.length;
	        }
	
	        var shortPieces = [],
	            longPieces = [],
	            mixedPieces = [],
	            i,
	            mom;
	        for (i = 0; i < 12; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, i]);
	            shortPieces.push(this.monthsShort(mom, ''));
	            longPieces.push(this.months(mom, ''));
	            mixedPieces.push(this.months(mom, ''));
	            mixedPieces.push(this.monthsShort(mom, ''));
	        }
	        // Sorting makes sure if one month (or abbr) is a prefix of another it
	        // will match the longer piece.
	        shortPieces.sort(cmpLenRev);
	        longPieces.sort(cmpLenRev);
	        mixedPieces.sort(cmpLenRev);
	        for (i = 0; i < 12; i++) {
	            shortPieces[i] = regexEscape(shortPieces[i]);
	            longPieces[i] = regexEscape(longPieces[i]);
	        }
	        for (i = 0; i < 24; i++) {
	            mixedPieces[i] = regexEscape(mixedPieces[i]);
	        }
	
	        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	        this._monthsShortRegex = this._monthsRegex;
	        this._monthsStrictRegex = new RegExp(
	            '^(' + longPieces.join('|') + ')',
	            'i'
	        );
	        this._monthsShortStrictRegex = new RegExp(
	            '^(' + shortPieces.join('|') + ')',
	            'i'
	        );
	    }
	
	    // FORMATTING
	
	    addFormatToken('Y', 0, 0, function () {
	        var y = this.year();
	        return y <= 9999 ? zeroFill(y, 4) : '+' + y;
	    });
	
	    addFormatToken(0, ['YY', 2], 0, function () {
	        return this.year() % 100;
	    });
	
	    addFormatToken(0, ['YYYY', 4], 0, 'year');
	    addFormatToken(0, ['YYYYY', 5], 0, 'year');
	    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');
	
	    // ALIASES
	
	    addUnitAlias('year', 'y');
	
	    // PRIORITIES
	
	    addUnitPriority('year', 1);
	
	    // PARSING
	
	    addRegexToken('Y', matchSigned);
	    addRegexToken('YY', match1to2, match2);
	    addRegexToken('YYYY', match1to4, match4);
	    addRegexToken('YYYYY', match1to6, match6);
	    addRegexToken('YYYYYY', match1to6, match6);
	
	    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
	    addParseToken('YYYY', function (input, array) {
	        array[YEAR] =
	            input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
	    });
	    addParseToken('YY', function (input, array) {
	        array[YEAR] = hooks.parseTwoDigitYear(input);
	    });
	    addParseToken('Y', function (input, array) {
	        array[YEAR] = parseInt(input, 10);
	    });
	
	    // HELPERS
	
	    function daysInYear(year) {
	        return isLeapYear(year) ? 366 : 365;
	    }
	
	    // HOOKS
	
	    hooks.parseTwoDigitYear = function (input) {
	        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
	    };
	
	    // MOMENTS
	
	    var getSetYear = makeGetSet('FullYear', true);
	
	    function getIsLeapYear() {
	        return isLeapYear(this.year());
	    }
	
	    function createDate(y, m, d, h, M, s, ms) {
	        // can't just apply() to create a date:
	        // https://stackoverflow.com/q/181348
	        var date;
	        // the date constructor remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            // preserve leap years using a full 400 year cycle, then reset
	            date = new Date(y + 400, m, d, h, M, s, ms);
	            if (isFinite(date.getFullYear())) {
	                date.setFullYear(y);
	            }
	        } else {
	            date = new Date(y, m, d, h, M, s, ms);
	        }
	
	        return date;
	    }
	
	    function createUTCDate(y) {
	        var date, args;
	        // the Date.UTC function remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            args = Array.prototype.slice.call(arguments);
	            // preserve leap years using a full 400 year cycle, then reset
	            args[0] = y + 400;
	            date = new Date(Date.UTC.apply(null, args));
	            if (isFinite(date.getUTCFullYear())) {
	                date.setUTCFullYear(y);
	            }
	        } else {
	            date = new Date(Date.UTC.apply(null, arguments));
	        }
	
	        return date;
	    }
	
	    // start-of-first-week - start-of-year
	    function firstWeekOffset(year, dow, doy) {
	        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
	            fwd = 7 + dow - doy,
	            // first-week day local weekday -- which local weekday is fwd
	            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
	
	        return -fwdlw + fwd - 1;
	    }
	
	    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
	    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
	        var localWeekday = (7 + weekday - dow) % 7,
	            weekOffset = firstWeekOffset(year, dow, doy),
	            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
	            resYear,
	            resDayOfYear;
	
	        if (dayOfYear <= 0) {
	            resYear = year - 1;
	            resDayOfYear = daysInYear(resYear) + dayOfYear;
	        } else if (dayOfYear > daysInYear(year)) {
	            resYear = year + 1;
	            resDayOfYear = dayOfYear - daysInYear(year);
	        } else {
	            resYear = year;
	            resDayOfYear = dayOfYear;
	        }
	
	        return {
	            year: resYear,
	            dayOfYear: resDayOfYear,
	        };
	    }
	
	    function weekOfYear(mom, dow, doy) {
	        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
	            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
	            resWeek,
	            resYear;
	
	        if (week < 1) {
	            resYear = mom.year() - 1;
	            resWeek = week + weeksInYear(resYear, dow, doy);
	        } else if (week > weeksInYear(mom.year(), dow, doy)) {
	            resWeek = week - weeksInYear(mom.year(), dow, doy);
	            resYear = mom.year() + 1;
	        } else {
	            resYear = mom.year();
	            resWeek = week;
	        }
	
	        return {
	            week: resWeek,
	            year: resYear,
	        };
	    }
	
	    function weeksInYear(year, dow, doy) {
	        var weekOffset = firstWeekOffset(year, dow, doy),
	            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
	        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
	    }
	
	    // FORMATTING
	
	    addFormatToken('w', ['ww', 2], 'wo', 'week');
	    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');
	
	    // ALIASES
	
	    addUnitAlias('week', 'w');
	    addUnitAlias('isoWeek', 'W');
	
	    // PRIORITIES
	
	    addUnitPriority('week', 5);
	    addUnitPriority('isoWeek', 5);
	
	    // PARSING
	
	    addRegexToken('w', match1to2);
	    addRegexToken('ww', match1to2, match2);
	    addRegexToken('W', match1to2);
	    addRegexToken('WW', match1to2, match2);
	
	    addWeekParseToken(['w', 'ww', 'W', 'WW'], function (
	        input,
	        week,
	        config,
	        token
	    ) {
	        week[token.substr(0, 1)] = toInt(input);
	    });
	
	    // HELPERS
	
	    // LOCALES
	
	    function localeWeek(mom) {
	        return weekOfYear(mom, this._week.dow, this._week.doy).week;
	    }
	
	    var defaultLocaleWeek = {
	        dow: 0, // Sunday is the first day of the week.
	        doy: 6, // The week that contains Jan 6th is the first week of the year.
	    };
	
	    function localeFirstDayOfWeek() {
	        return this._week.dow;
	    }
	
	    function localeFirstDayOfYear() {
	        return this._week.doy;
	    }
	
	    // MOMENTS
	
	    function getSetWeek(input) {
	        var week = this.localeData().week(this);
	        return input == null ? week : this.add((input - week) * 7, 'd');
	    }
	
	    function getSetISOWeek(input) {
	        var week = weekOfYear(this, 1, 4).week;
	        return input == null ? week : this.add((input - week) * 7, 'd');
	    }
	
	    // FORMATTING
	
	    addFormatToken('d', 0, 'do', 'day');
	
	    addFormatToken('dd', 0, 0, function (format) {
	        return this.localeData().weekdaysMin(this, format);
	    });
	
	    addFormatToken('ddd', 0, 0, function (format) {
	        return this.localeData().weekdaysShort(this, format);
	    });
	
	    addFormatToken('dddd', 0, 0, function (format) {
	        return this.localeData().weekdays(this, format);
	    });
	
	    addFormatToken('e', 0, 0, 'weekday');
	    addFormatToken('E', 0, 0, 'isoWeekday');
	
	    // ALIASES
	
	    addUnitAlias('day', 'd');
	    addUnitAlias('weekday', 'e');
	    addUnitAlias('isoWeekday', 'E');
	
	    // PRIORITY
	    addUnitPriority('day', 11);
	    addUnitPriority('weekday', 11);
	    addUnitPriority('isoWeekday', 11);
	
	    // PARSING
	
	    addRegexToken('d', match1to2);
	    addRegexToken('e', match1to2);
	    addRegexToken('E', match1to2);
	    addRegexToken('dd', function (isStrict, locale) {
	        return locale.weekdaysMinRegex(isStrict);
	    });
	    addRegexToken('ddd', function (isStrict, locale) {
	        return locale.weekdaysShortRegex(isStrict);
	    });
	    addRegexToken('dddd', function (isStrict, locale) {
	        return locale.weekdaysRegex(isStrict);
	    });
	
	    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
	        var weekday = config._locale.weekdaysParse(input, token, config._strict);
	        // if we didn't get a weekday name, mark the date as invalid
	        if (weekday != null) {
	            week.d = weekday;
	        } else {
	            getParsingFlags(config).invalidWeekday = input;
	        }
	    });
	
	    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
	        week[token] = toInt(input);
	    });
	
	    // HELPERS
	
	    function parseWeekday(input, locale) {
	        if (typeof input !== 'string') {
	            return input;
	        }
	
	        if (!isNaN(input)) {
	            return parseInt(input, 10);
	        }
	
	        input = locale.weekdaysParse(input);
	        if (typeof input === 'number') {
	            return input;
	        }
	
	        return null;
	    }
	
	    function parseIsoWeekday(input, locale) {
	        if (typeof input === 'string') {
	            return locale.weekdaysParse(input) % 7 || 7;
	        }
	        return isNaN(input) ? null : input;
	    }
	
	    // LOCALES
	    function shiftWeekdays(ws, n) {
	        return ws.slice(n, 7).concat(ws.slice(0, n));
	    }
	
	    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        defaultWeekdaysRegex = matchWord,
	        defaultWeekdaysShortRegex = matchWord,
	        defaultWeekdaysMinRegex = matchWord;
	
	    function localeWeekdays(m, format) {
	        var weekdays = isArray(this._weekdays)
	            ? this._weekdays
	            : this._weekdays[
	                  m && m !== true && this._weekdays.isFormat.test(format)
	                      ? 'format'
	                      : 'standalone'
	              ];
	        return m === true
	            ? shiftWeekdays(weekdays, this._week.dow)
	            : m
	            ? weekdays[m.day()]
	            : weekdays;
	    }
	
	    function localeWeekdaysShort(m) {
	        return m === true
	            ? shiftWeekdays(this._weekdaysShort, this._week.dow)
	            : m
	            ? this._weekdaysShort[m.day()]
	            : this._weekdaysShort;
	    }
	
	    function localeWeekdaysMin(m) {
	        return m === true
	            ? shiftWeekdays(this._weekdaysMin, this._week.dow)
	            : m
	            ? this._weekdaysMin[m.day()]
	            : this._weekdaysMin;
	    }
	
	    function handleStrictParse$1(weekdayName, format, strict) {
	        var i,
	            ii,
	            mom,
	            llc = weekdayName.toLocaleLowerCase();
	        if (!this._weekdaysParse) {
	            this._weekdaysParse = [];
	            this._shortWeekdaysParse = [];
	            this._minWeekdaysParse = [];
	
	            for (i = 0; i < 7; ++i) {
	                mom = createUTC([2000, 1]).day(i);
	                this._minWeekdaysParse[i] = this.weekdaysMin(
	                    mom,
	                    ''
	                ).toLocaleLowerCase();
	                this._shortWeekdaysParse[i] = this.weekdaysShort(
	                    mom,
	                    ''
	                ).toLocaleLowerCase();
	                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
	            }
	        }
	
	        if (strict) {
	            if (format === 'dddd') {
	                ii = indexOf.call(this._weekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else if (format === 'ddd') {
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        } else {
	            if (format === 'dddd') {
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else if (format === 'ddd') {
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        }
	    }
	
	    function localeWeekdaysParse(weekdayName, format, strict) {
	        var i, mom, regex;
	
	        if (this._weekdaysParseExact) {
	            return handleStrictParse$1.call(this, weekdayName, format, strict);
	        }
	
	        if (!this._weekdaysParse) {
	            this._weekdaysParse = [];
	            this._minWeekdaysParse = [];
	            this._shortWeekdaysParse = [];
	            this._fullWeekdaysParse = [];
	        }
	
	        for (i = 0; i < 7; i++) {
	            // make the regex if we don't have it already
	
	            mom = createUTC([2000, 1]).day(i);
	            if (strict && !this._fullWeekdaysParse[i]) {
	                this._fullWeekdaysParse[i] = new RegExp(
	                    '^' + this.weekdays(mom, '').replace('.', '\\.?') + '$',
	                    'i'
	                );
	                this._shortWeekdaysParse[i] = new RegExp(
	                    '^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$',
	                    'i'
	                );
	                this._minWeekdaysParse[i] = new RegExp(
	                    '^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$',
	                    'i'
	                );
	            }
	            if (!this._weekdaysParse[i]) {
	                regex =
	                    '^' +
	                    this.weekdays(mom, '') +
	                    '|^' +
	                    this.weekdaysShort(mom, '') +
	                    '|^' +
	                    this.weekdaysMin(mom, '');
	                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
	            }
	            // test the regex
	            if (
	                strict &&
	                format === 'dddd' &&
	                this._fullWeekdaysParse[i].test(weekdayName)
	            ) {
	                return i;
	            } else if (
	                strict &&
	                format === 'ddd' &&
	                this._shortWeekdaysParse[i].test(weekdayName)
	            ) {
	                return i;
	            } else if (
	                strict &&
	                format === 'dd' &&
	                this._minWeekdaysParse[i].test(weekdayName)
	            ) {
	                return i;
	            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
	                return i;
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function getSetDayOfWeek(input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
	        if (input != null) {
	            input = parseWeekday(input, this.localeData());
	            return this.add(input - day, 'd');
	        } else {
	            return day;
	        }
	    }
	
	    function getSetLocaleDayOfWeek(input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
	        return input == null ? weekday : this.add(input - weekday, 'd');
	    }
	
	    function getSetISODayOfWeek(input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	
	        // behaves the same as moment#day except
	        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
	        // as a setter, sunday should belong to the previous week.
	
	        if (input != null) {
	            var weekday = parseIsoWeekday(input, this.localeData());
	            return this.day(this.day() % 7 ? weekday : weekday - 7);
	        } else {
	            return this.day() || 7;
	        }
	    }
	
	    function weekdaysRegex(isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysStrictRegex;
	            } else {
	                return this._weekdaysRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                this._weekdaysRegex = defaultWeekdaysRegex;
	            }
	            return this._weekdaysStrictRegex && isStrict
	                ? this._weekdaysStrictRegex
	                : this._weekdaysRegex;
	        }
	    }
	
	    function weekdaysShortRegex(isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysShortStrictRegex;
	            } else {
	                return this._weekdaysShortRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
	                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
	            }
	            return this._weekdaysShortStrictRegex && isStrict
	                ? this._weekdaysShortStrictRegex
	                : this._weekdaysShortRegex;
	        }
	    }
	
	    function weekdaysMinRegex(isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysMinStrictRegex;
	            } else {
	                return this._weekdaysMinRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
	                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
	            }
	            return this._weekdaysMinStrictRegex && isStrict
	                ? this._weekdaysMinStrictRegex
	                : this._weekdaysMinRegex;
	        }
	    }
	
	    function computeWeekdaysParse() {
	        function cmpLenRev(a, b) {
	            return b.length - a.length;
	        }
	
	        var minPieces = [],
	            shortPieces = [],
	            longPieces = [],
	            mixedPieces = [],
	            i,
	            mom,
	            minp,
	            shortp,
	            longp;
	        for (i = 0; i < 7; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, 1]).day(i);
	            minp = regexEscape(this.weekdaysMin(mom, ''));
	            shortp = regexEscape(this.weekdaysShort(mom, ''));
	            longp = regexEscape(this.weekdays(mom, ''));
	            minPieces.push(minp);
	            shortPieces.push(shortp);
	            longPieces.push(longp);
	            mixedPieces.push(minp);
	            mixedPieces.push(shortp);
	            mixedPieces.push(longp);
	        }
	        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
	        // will match the longer piece.
	        minPieces.sort(cmpLenRev);
	        shortPieces.sort(cmpLenRev);
	        longPieces.sort(cmpLenRev);
	        mixedPieces.sort(cmpLenRev);
	
	        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	        this._weekdaysShortRegex = this._weekdaysRegex;
	        this._weekdaysMinRegex = this._weekdaysRegex;
	
	        this._weekdaysStrictRegex = new RegExp(
	            '^(' + longPieces.join('|') + ')',
	            'i'
	        );
	        this._weekdaysShortStrictRegex = new RegExp(
	            '^(' + shortPieces.join('|') + ')',
	            'i'
	        );
	        this._weekdaysMinStrictRegex = new RegExp(
	            '^(' + minPieces.join('|') + ')',
	            'i'
	        );
	    }
	
	    // FORMATTING
	
	    function hFormat() {
	        return this.hours() % 12 || 12;
	    }
	
	    function kFormat() {
	        return this.hours() || 24;
	    }
	
	    addFormatToken('H', ['HH', 2], 0, 'hour');
	    addFormatToken('h', ['hh', 2], 0, hFormat);
	    addFormatToken('k', ['kk', 2], 0, kFormat);
	
	    addFormatToken('hmm', 0, 0, function () {
	        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
	    });
	
	    addFormatToken('hmmss', 0, 0, function () {
	        return (
	            '' +
	            hFormat.apply(this) +
	            zeroFill(this.minutes(), 2) +
	            zeroFill(this.seconds(), 2)
	        );
	    });
	
	    addFormatToken('Hmm', 0, 0, function () {
	        return '' + this.hours() + zeroFill(this.minutes(), 2);
	    });
	
	    addFormatToken('Hmmss', 0, 0, function () {
	        return (
	            '' +
	            this.hours() +
	            zeroFill(this.minutes(), 2) +
	            zeroFill(this.seconds(), 2)
	        );
	    });
	
	    function meridiem(token, lowercase) {
	        addFormatToken(token, 0, 0, function () {
	            return this.localeData().meridiem(
	                this.hours(),
	                this.minutes(),
	                lowercase
	            );
	        });
	    }
	
	    meridiem('a', true);
	    meridiem('A', false);
	
	    // ALIASES
	
	    addUnitAlias('hour', 'h');
	
	    // PRIORITY
	    addUnitPriority('hour', 13);
	
	    // PARSING
	
	    function matchMeridiem(isStrict, locale) {
	        return locale._meridiemParse;
	    }
	
	    addRegexToken('a', matchMeridiem);
	    addRegexToken('A', matchMeridiem);
	    addRegexToken('H', match1to2);
	    addRegexToken('h', match1to2);
	    addRegexToken('k', match1to2);
	    addRegexToken('HH', match1to2, match2);
	    addRegexToken('hh', match1to2, match2);
	    addRegexToken('kk', match1to2, match2);
	
	    addRegexToken('hmm', match3to4);
	    addRegexToken('hmmss', match5to6);
	    addRegexToken('Hmm', match3to4);
	    addRegexToken('Hmmss', match5to6);
	
	    addParseToken(['H', 'HH'], HOUR);
	    addParseToken(['k', 'kk'], function (input, array, config) {
	        var kInput = toInt(input);
	        array[HOUR] = kInput === 24 ? 0 : kInput;
	    });
	    addParseToken(['a', 'A'], function (input, array, config) {
	        config._isPm = config._locale.isPM(input);
	        config._meridiem = input;
	    });
	    addParseToken(['h', 'hh'], function (input, array, config) {
	        array[HOUR] = toInt(input);
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('hmm', function (input, array, config) {
	        var pos = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos));
	        array[MINUTE] = toInt(input.substr(pos));
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('hmmss', function (input, array, config) {
	        var pos1 = input.length - 4,
	            pos2 = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos1));
	        array[MINUTE] = toInt(input.substr(pos1, 2));
	        array[SECOND] = toInt(input.substr(pos2));
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('Hmm', function (input, array, config) {
	        var pos = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos));
	        array[MINUTE] = toInt(input.substr(pos));
	    });
	    addParseToken('Hmmss', function (input, array, config) {
	        var pos1 = input.length - 4,
	            pos2 = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos1));
	        array[MINUTE] = toInt(input.substr(pos1, 2));
	        array[SECOND] = toInt(input.substr(pos2));
	    });
	
	    // LOCALES
	
	    function localeIsPM(input) {
	        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
	        // Using charAt should be more compatible.
	        return (input + '').toLowerCase().charAt(0) === 'p';
	    }
	
	    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i,
	        // Setting the hour should keep the time, because the user explicitly
	        // specified which hour they want. So trying to maintain the same hour (in
	        // a new timezone) makes sense. Adding/subtracting hours does not follow
	        // this rule.
	        getSetHour = makeGetSet('Hours', true);
	
	    function localeMeridiem(hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'pm' : 'PM';
	        } else {
	            return isLower ? 'am' : 'AM';
	        }
	    }
	
	    var baseConfig = {
	        calendar: defaultCalendar,
	        longDateFormat: defaultLongDateFormat,
	        invalidDate: defaultInvalidDate,
	        ordinal: defaultOrdinal,
	        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
	        relativeTime: defaultRelativeTime,
	
	        months: defaultLocaleMonths,
	        monthsShort: defaultLocaleMonthsShort,
	
	        week: defaultLocaleWeek,
	
	        weekdays: defaultLocaleWeekdays,
	        weekdaysMin: defaultLocaleWeekdaysMin,
	        weekdaysShort: defaultLocaleWeekdaysShort,
	
	        meridiemParse: defaultLocaleMeridiemParse,
	    };
	
	    // internal storage for locale config files
	    var locales = {},
	        localeFamilies = {},
	        globalLocale;
	
	    function commonPrefix(arr1, arr2) {
	        var i,
	            minl = Math.min(arr1.length, arr2.length);
	        for (i = 0; i < minl; i += 1) {
	            if (arr1[i] !== arr2[i]) {
	                return i;
	            }
	        }
	        return minl;
	    }
	
	    function normalizeLocale(key) {
	        return key ? key.toLowerCase().replace('_', '-') : key;
	    }
	
	    // pick the locale from the array
	    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
	    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
	    function chooseLocale(names) {
	        var i = 0,
	            j,
	            next,
	            locale,
	            split;
	
	        while (i < names.length) {
	            split = normalizeLocale(names[i]).split('-');
	            j = split.length;
	            next = normalizeLocale(names[i + 1]);
	            next = next ? next.split('-') : null;
	            while (j > 0) {
	                locale = loadLocale(split.slice(0, j).join('-'));
	                if (locale) {
	                    return locale;
	                }
	                if (
	                    next &&
	                    next.length >= j &&
	                    commonPrefix(split, next) >= j - 1
	                ) {
	                    //the next array item is better than a shallower substring of this one
	                    break;
	                }
	                j--;
	            }
	            i++;
	        }
	        return globalLocale;
	    }
	
	    function loadLocale(name) {
	        var oldLocale = null,
	            aliasedRequire;
	        // TODO: Find a better way to register and load all the locales in Node
	        if (
	            locales[name] === undefined &&
	            typeof module !== 'undefined' &&
	            module &&
	            module.exports
	        ) {
	            try {
	                oldLocale = globalLocale._abbr;
	                aliasedRequire = require;
	                __webpack_require__(1022)("./" + name);
	                getSetGlobalLocale(oldLocale);
	            } catch (e) {
	                // mark as not found to avoid repeating expensive file require call causing high CPU
	                // when trying to find en-US, en_US, en-us for every format call
	                locales[name] = null; // null means not found
	            }
	        }
	        return locales[name];
	    }
	
	    // This function will load locale and then set the global locale.  If
	    // no arguments are passed in, it will simply return the current global
	    // locale key.
	    function getSetGlobalLocale(key, values) {
	        var data;
	        if (key) {
	            if (isUndefined(values)) {
	                data = getLocale(key);
	            } else {
	                data = defineLocale(key, values);
	            }
	
	            if (data) {
	                // moment.duration._locale = moment._locale = data;
	                globalLocale = data;
	            } else {
	                if (typeof console !== 'undefined' && console.warn) {
	                    //warn user if arguments are passed but the locale could not be set
	                    console.warn(
	                        'Locale ' + key + ' not found. Did you forget to load it?'
	                    );
	                }
	            }
	        }
	
	        return globalLocale._abbr;
	    }
	
	    function defineLocale(name, config) {
	        if (config !== null) {
	            var locale,
	                parentConfig = baseConfig;
	            config.abbr = name;
	            if (locales[name] != null) {
	                deprecateSimple(
	                    'defineLocaleOverride',
	                    'use moment.updateLocale(localeName, config) to change ' +
	                        'an existing locale. moment.defineLocale(localeName, ' +
	                        'config) should only be used for creating a new locale ' +
	                        'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.'
	                );
	                parentConfig = locales[name]._config;
	            } else if (config.parentLocale != null) {
	                if (locales[config.parentLocale] != null) {
	                    parentConfig = locales[config.parentLocale]._config;
	                } else {
	                    locale = loadLocale(config.parentLocale);
	                    if (locale != null) {
	                        parentConfig = locale._config;
	                    } else {
	                        if (!localeFamilies[config.parentLocale]) {
	                            localeFamilies[config.parentLocale] = [];
	                        }
	                        localeFamilies[config.parentLocale].push({
	                            name: name,
	                            config: config,
	                        });
	                        return null;
	                    }
	                }
	            }
	            locales[name] = new Locale(mergeConfigs(parentConfig, config));
	
	            if (localeFamilies[name]) {
	                localeFamilies[name].forEach(function (x) {
	                    defineLocale(x.name, x.config);
	                });
	            }
	
	            // backwards compat for now: also set the locale
	            // make sure we set the locale AFTER all child locales have been
	            // created, so we won't end up with the child locale set.
	            getSetGlobalLocale(name);
	
	            return locales[name];
	        } else {
	            // useful for testing
	            delete locales[name];
	            return null;
	        }
	    }
	
	    function updateLocale(name, config) {
	        if (config != null) {
	            var locale,
	                tmpLocale,
	                parentConfig = baseConfig;
	
	            if (locales[name] != null && locales[name].parentLocale != null) {
	                // Update existing child locale in-place to avoid memory-leaks
	                locales[name].set(mergeConfigs(locales[name]._config, config));
	            } else {
	                // MERGE
	                tmpLocale = loadLocale(name);
	                if (tmpLocale != null) {
	                    parentConfig = tmpLocale._config;
	                }
	                config = mergeConfigs(parentConfig, config);
	                if (tmpLocale == null) {
	                    // updateLocale is called for creating a new locale
	                    // Set abbr so it will have a name (getters return
	                    // undefined otherwise).
	                    config.abbr = name;
	                }
	                locale = new Locale(config);
	                locale.parentLocale = locales[name];
	                locales[name] = locale;
	            }
	
	            // backwards compat for now: also set the locale
	            getSetGlobalLocale(name);
	        } else {
	            // pass null for config to unupdate, useful for tests
	            if (locales[name] != null) {
	                if (locales[name].parentLocale != null) {
	                    locales[name] = locales[name].parentLocale;
	                    if (name === getSetGlobalLocale()) {
	                        getSetGlobalLocale(name);
	                    }
	                } else if (locales[name] != null) {
	                    delete locales[name];
	                }
	            }
	        }
	        return locales[name];
	    }
	
	    // returns locale data
	    function getLocale(key) {
	        var locale;
	
	        if (key && key._locale && key._locale._abbr) {
	            key = key._locale._abbr;
	        }
	
	        if (!key) {
	            return globalLocale;
	        }
	
	        if (!isArray(key)) {
	            //short-circuit everything else
	            locale = loadLocale(key);
	            if (locale) {
	                return locale;
	            }
	            key = [key];
	        }
	
	        return chooseLocale(key);
	    }
	
	    function listLocales() {
	        return keys(locales);
	    }
	
	    function checkOverflow(m) {
	        var overflow,
	            a = m._a;
	
	        if (a && getParsingFlags(m).overflow === -2) {
	            overflow =
	                a[MONTH] < 0 || a[MONTH] > 11
	                    ? MONTH
	                    : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH])
	                    ? DATE
	                    : a[HOUR] < 0 ||
	                      a[HOUR] > 24 ||
	                      (a[HOUR] === 24 &&
	                          (a[MINUTE] !== 0 ||
	                              a[SECOND] !== 0 ||
	                              a[MILLISECOND] !== 0))
	                    ? HOUR
	                    : a[MINUTE] < 0 || a[MINUTE] > 59
	                    ? MINUTE
	                    : a[SECOND] < 0 || a[SECOND] > 59
	                    ? SECOND
	                    : a[MILLISECOND] < 0 || a[MILLISECOND] > 999
	                    ? MILLISECOND
	                    : -1;
	
	            if (
	                getParsingFlags(m)._overflowDayOfYear &&
	                (overflow < YEAR || overflow > DATE)
	            ) {
	                overflow = DATE;
	            }
	            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
	                overflow = WEEK;
	            }
	            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
	                overflow = WEEKDAY;
	            }
	
	            getParsingFlags(m).overflow = overflow;
	        }
	
	        return m;
	    }
	
	    // iso 8601 regex
	    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
	    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
	        basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
	        tzRegex = /Z|[+-]\d\d(?::?\d\d)?/,
	        isoDates = [
	            ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
	            ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
	            ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
	            ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
	            ['YYYY-DDD', /\d{4}-\d{3}/],
	            ['YYYY-MM', /\d{4}-\d\d/, false],
	            ['YYYYYYMMDD', /[+-]\d{10}/],
	            ['YYYYMMDD', /\d{8}/],
	            ['GGGG[W]WWE', /\d{4}W\d{3}/],
	            ['GGGG[W]WW', /\d{4}W\d{2}/, false],
	            ['YYYYDDD', /\d{7}/],
	            ['YYYYMM', /\d{6}/, false],
	            ['YYYY', /\d{4}/, false],
	        ],
	        // iso time formats and regexes
	        isoTimes = [
	            ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
	            ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
	            ['HH:mm:ss', /\d\d:\d\d:\d\d/],
	            ['HH:mm', /\d\d:\d\d/],
	            ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
	            ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
	            ['HHmmss', /\d\d\d\d\d\d/],
	            ['HHmm', /\d\d\d\d/],
	            ['HH', /\d\d/],
	        ],
	        aspNetJsonRegex = /^\/?Date\((-?\d+)/i,
	        // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
	        rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/,
	        obsOffsets = {
	            UT: 0,
	            GMT: 0,
	            EDT: -4 * 60,
	            EST: -5 * 60,
	            CDT: -5 * 60,
	            CST: -6 * 60,
	            MDT: -6 * 60,
	            MST: -7 * 60,
	            PDT: -7 * 60,
	            PST: -8 * 60,
	        };
	
	    // date from iso format
	    function configFromISO(config) {
	        var i,
	            l,
	            string = config._i,
	            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
	            allowTime,
	            dateFormat,
	            timeFormat,
	            tzFormat;
	
	        if (match) {
	            getParsingFlags(config).iso = true;
	
	            for (i = 0, l = isoDates.length; i < l; i++) {
	                if (isoDates[i][1].exec(match[1])) {
	                    dateFormat = isoDates[i][0];
	                    allowTime = isoDates[i][2] !== false;
	                    break;
	                }
	            }
	            if (dateFormat == null) {
	                config._isValid = false;
	                return;
	            }
	            if (match[3]) {
	                for (i = 0, l = isoTimes.length; i < l; i++) {
	                    if (isoTimes[i][1].exec(match[3])) {
	                        // match[2] should be 'T' or space
	                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
	                        break;
	                    }
	                }
	                if (timeFormat == null) {
	                    config._isValid = false;
	                    return;
	                }
	            }
	            if (!allowTime && timeFormat != null) {
	                config._isValid = false;
	                return;
	            }
	            if (match[4]) {
	                if (tzRegex.exec(match[4])) {
	                    tzFormat = 'Z';
	                } else {
	                    config._isValid = false;
	                    return;
	                }
	            }
	            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
	            configFromStringAndFormat(config);
	        } else {
	            config._isValid = false;
	        }
	    }
	
	    function extractFromRFC2822Strings(
	        yearStr,
	        monthStr,
	        dayStr,
	        hourStr,
	        minuteStr,
	        secondStr
	    ) {
	        var result = [
	            untruncateYear(yearStr),
	            defaultLocaleMonthsShort.indexOf(monthStr),
	            parseInt(dayStr, 10),
	            parseInt(hourStr, 10),
	            parseInt(minuteStr, 10),
	        ];
	
	        if (secondStr) {
	            result.push(parseInt(secondStr, 10));
	        }
	
	        return result;
	    }
	
	    function untruncateYear(yearStr) {
	        var year = parseInt(yearStr, 10);
	        if (year <= 49) {
	            return 2000 + year;
	        } else if (year <= 999) {
	            return 1900 + year;
	        }
	        return year;
	    }
	
	    function preprocessRFC2822(s) {
	        // Remove comments and folding whitespace and replace multiple-spaces with a single space
	        return s
	            .replace(/\([^)]*\)|[\n\t]/g, ' ')
	            .replace(/(\s\s+)/g, ' ')
	            .replace(/^\s\s*/, '')
	            .replace(/\s\s*$/, '');
	    }
	
	    function checkWeekday(weekdayStr, parsedInput, config) {
	        if (weekdayStr) {
	            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
	            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
	                weekdayActual = new Date(
	                    parsedInput[0],
	                    parsedInput[1],
	                    parsedInput[2]
	                ).getDay();
	            if (weekdayProvided !== weekdayActual) {
	                getParsingFlags(config).weekdayMismatch = true;
	                config._isValid = false;
	                return false;
	            }
	        }
	        return true;
	    }
	
	    function calculateOffset(obsOffset, militaryOffset, numOffset) {
	        if (obsOffset) {
	            return obsOffsets[obsOffset];
	        } else if (militaryOffset) {
	            // the only allowed military tz is Z
	            return 0;
	        } else {
	            var hm = parseInt(numOffset, 10),
	                m = hm % 100,
	                h = (hm - m) / 100;
	            return h * 60 + m;
	        }
	    }
	
	    // date and time from ref 2822 format
	    function configFromRFC2822(config) {
	        var match = rfc2822.exec(preprocessRFC2822(config._i)),
	            parsedArray;
	        if (match) {
	            parsedArray = extractFromRFC2822Strings(
	                match[4],
	                match[3],
	                match[2],
	                match[5],
	                match[6],
	                match[7]
	            );
	            if (!checkWeekday(match[1], parsedArray, config)) {
	                return;
	            }
	
	            config._a = parsedArray;
	            config._tzm = calculateOffset(match[8], match[9], match[10]);
	
	            config._d = createUTCDate.apply(null, config._a);
	            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
	
	            getParsingFlags(config).rfc2822 = true;
	        } else {
	            config._isValid = false;
	        }
	    }
	
	    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
	    function configFromString(config) {
	        var matched = aspNetJsonRegex.exec(config._i);
	        if (matched !== null) {
	            config._d = new Date(+matched[1]);
	            return;
	        }
	
	        configFromISO(config);
	        if (config._isValid === false) {
	            delete config._isValid;
	        } else {
	            return;
	        }
	
	        configFromRFC2822(config);
	        if (config._isValid === false) {
	            delete config._isValid;
	        } else {
	            return;
	        }
	
	        if (config._strict) {
	            config._isValid = false;
	        } else {
	            // Final attempt, use Input Fallback
	            hooks.createFromInputFallback(config);
	        }
	    }
	
	    hooks.createFromInputFallback = deprecate(
	        'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
	            'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
	            'discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.',
	        function (config) {
	            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
	        }
	    );
	
	    // Pick the first defined of two or three arguments.
	    function defaults(a, b, c) {
	        if (a != null) {
	            return a;
	        }
	        if (b != null) {
	            return b;
	        }
	        return c;
	    }
	
	    function currentDateArray(config) {
	        // hooks is actually the exported moment object
	        var nowValue = new Date(hooks.now());
	        if (config._useUTC) {
	            return [
	                nowValue.getUTCFullYear(),
	                nowValue.getUTCMonth(),
	                nowValue.getUTCDate(),
	            ];
	        }
	        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
	    }
	
	    // convert an array to a date.
	    // the array should mirror the parameters below
	    // note: all values past the year are optional and will default to the lowest possible value.
	    // [year, month, day , hour, minute, second, millisecond]
	    function configFromArray(config) {
	        var i,
	            date,
	            input = [],
	            currentDate,
	            expectedWeekday,
	            yearToUse;
	
	        if (config._d) {
	            return;
	        }
	
	        currentDate = currentDateArray(config);
	
	        //compute day of the year from weeks and weekdays
	        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
	            dayOfYearFromWeekInfo(config);
	        }
	
	        //if the day of the year is set, figure out what it is
	        if (config._dayOfYear != null) {
	            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
	
	            if (
	                config._dayOfYear > daysInYear(yearToUse) ||
	                config._dayOfYear === 0
	            ) {
	                getParsingFlags(config)._overflowDayOfYear = true;
	            }
	
	            date = createUTCDate(yearToUse, 0, config._dayOfYear);
	            config._a[MONTH] = date.getUTCMonth();
	            config._a[DATE] = date.getUTCDate();
	        }
	
	        // Default to current date.
	        // * if no year, month, day of month are given, default to today
	        // * if day of month is given, default month and year
	        // * if month is given, default only year
	        // * if year is given, don't default anything
	        for (i = 0; i < 3 && config._a[i] == null; ++i) {
	            config._a[i] = input[i] = currentDate[i];
	        }
	
	        // Zero out whatever was not defaulted, including time
	        for (; i < 7; i++) {
	            config._a[i] = input[i] =
	                config._a[i] == null ? (i === 2 ? 1 : 0) : config._a[i];
	        }
	
	        // Check for 24:00:00.000
	        if (
	            config._a[HOUR] === 24 &&
	            config._a[MINUTE] === 0 &&
	            config._a[SECOND] === 0 &&
	            config._a[MILLISECOND] === 0
	        ) {
	            config._nextDay = true;
	            config._a[HOUR] = 0;
	        }
	
	        config._d = (config._useUTC ? createUTCDate : createDate).apply(
	            null,
	            input
	        );
	        expectedWeekday = config._useUTC
	            ? config._d.getUTCDay()
	            : config._d.getDay();
	
	        // Apply timezone offset from input. The actual utcOffset can be changed
	        // with parseZone.
	        if (config._tzm != null) {
	            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
	        }
	
	        if (config._nextDay) {
	            config._a[HOUR] = 24;
	        }
	
	        // check for mismatching day of week
	        if (
	            config._w &&
	            typeof config._w.d !== 'undefined' &&
	            config._w.d !== expectedWeekday
	        ) {
	            getParsingFlags(config).weekdayMismatch = true;
	        }
	    }
	
	    function dayOfYearFromWeekInfo(config) {
	        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;
	
	        w = config._w;
	        if (w.GG != null || w.W != null || w.E != null) {
	            dow = 1;
	            doy = 4;
	
	            // TODO: We need to take the current isoWeekYear, but that depends on
	            // how we interpret now (local, utc, fixed offset). So create
	            // a now version of current config (take local/utc/offset flags, and
	            // create now).
	            weekYear = defaults(
	                w.GG,
	                config._a[YEAR],
	                weekOfYear(createLocal(), 1, 4).year
	            );
	            week = defaults(w.W, 1);
	            weekday = defaults(w.E, 1);
	            if (weekday < 1 || weekday > 7) {
	                weekdayOverflow = true;
	            }
	        } else {
	            dow = config._locale._week.dow;
	            doy = config._locale._week.doy;
	
	            curWeek = weekOfYear(createLocal(), dow, doy);
	
	            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);
	
	            // Default to current week.
	            week = defaults(w.w, curWeek.week);
	
	            if (w.d != null) {
	                // weekday -- low day numbers are considered next week
	                weekday = w.d;
	                if (weekday < 0 || weekday > 6) {
	                    weekdayOverflow = true;
	                }
	            } else if (w.e != null) {
	                // local weekday -- counting starts from beginning of week
	                weekday = w.e + dow;
	                if (w.e < 0 || w.e > 6) {
	                    weekdayOverflow = true;
	                }
	            } else {
	                // default to beginning of week
	                weekday = dow;
	            }
	        }
	        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
	            getParsingFlags(config)._overflowWeeks = true;
	        } else if (weekdayOverflow != null) {
	            getParsingFlags(config)._overflowWeekday = true;
	        } else {
	            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
	            config._a[YEAR] = temp.year;
	            config._dayOfYear = temp.dayOfYear;
	        }
	    }
	
	    // constant that refers to the ISO standard
	    hooks.ISO_8601 = function () {};
	
	    // constant that refers to the RFC 2822 form
	    hooks.RFC_2822 = function () {};
	
	    // date from string and format string
	    function configFromStringAndFormat(config) {
	        // TODO: Move this to another part of the creation flow to prevent circular deps
	        if (config._f === hooks.ISO_8601) {
	            configFromISO(config);
	            return;
	        }
	        if (config._f === hooks.RFC_2822) {
	            configFromRFC2822(config);
	            return;
	        }
	        config._a = [];
	        getParsingFlags(config).empty = true;
	
	        // This array is used to make a Date, either with `new Date` or `Date.UTC`
	        var string = '' + config._i,
	            i,
	            parsedInput,
	            tokens,
	            token,
	            skipped,
	            stringLength = string.length,
	            totalParsedInputLength = 0,
	            era;
	
	        tokens =
	            expandFormat(config._f, config._locale).match(formattingTokens) || [];
	
	        for (i = 0; i < tokens.length; i++) {
	            token = tokens[i];
	            parsedInput = (string.match(getParseRegexForToken(token, config)) ||
	                [])[0];
	            if (parsedInput) {
	                skipped = string.substr(0, string.indexOf(parsedInput));
	                if (skipped.length > 0) {
	                    getParsingFlags(config).unusedInput.push(skipped);
	                }
	                string = string.slice(
	                    string.indexOf(parsedInput) + parsedInput.length
	                );
	                totalParsedInputLength += parsedInput.length;
	            }
	            // don't parse if it's not a known token
	            if (formatTokenFunctions[token]) {
	                if (parsedInput) {
	                    getParsingFlags(config).empty = false;
	                } else {
	                    getParsingFlags(config).unusedTokens.push(token);
	                }
	                addTimeToArrayFromToken(token, parsedInput, config);
	            } else if (config._strict && !parsedInput) {
	                getParsingFlags(config).unusedTokens.push(token);
	            }
	        }
	
	        // add remaining unparsed input length to the string
	        getParsingFlags(config).charsLeftOver =
	            stringLength - totalParsedInputLength;
	        if (string.length > 0) {
	            getParsingFlags(config).unusedInput.push(string);
	        }
	
	        // clear _12h flag if hour is <= 12
	        if (
	            config._a[HOUR] <= 12 &&
	            getParsingFlags(config).bigHour === true &&
	            config._a[HOUR] > 0
	        ) {
	            getParsingFlags(config).bigHour = undefined;
	        }
	
	        getParsingFlags(config).parsedDateParts = config._a.slice(0);
	        getParsingFlags(config).meridiem = config._meridiem;
	        // handle meridiem
	        config._a[HOUR] = meridiemFixWrap(
	            config._locale,
	            config._a[HOUR],
	            config._meridiem
	        );
	
	        // handle era
	        era = getParsingFlags(config).era;
	        if (era !== null) {
	            config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
	        }
	
	        configFromArray(config);
	        checkOverflow(config);
	    }
	
	    function meridiemFixWrap(locale, hour, meridiem) {
	        var isPm;
	
	        if (meridiem == null) {
	            // nothing to do
	            return hour;
	        }
	        if (locale.meridiemHour != null) {
	            return locale.meridiemHour(hour, meridiem);
	        } else if (locale.isPM != null) {
	            // Fallback
	            isPm = locale.isPM(meridiem);
	            if (isPm && hour < 12) {
	                hour += 12;
	            }
	            if (!isPm && hour === 12) {
	                hour = 0;
	            }
	            return hour;
	        } else {
	            // this is not supposed to happen
	            return hour;
	        }
	    }
	
	    // date from string and array of format strings
	    function configFromStringAndArray(config) {
	        var tempConfig,
	            bestMoment,
	            scoreToBeat,
	            i,
	            currentScore,
	            validFormatFound,
	            bestFormatIsValid = false;
	
	        if (config._f.length === 0) {
	            getParsingFlags(config).invalidFormat = true;
	            config._d = new Date(NaN);
	            return;
	        }
	
	        for (i = 0; i < config._f.length; i++) {
	            currentScore = 0;
	            validFormatFound = false;
	            tempConfig = copyConfig({}, config);
	            if (config._useUTC != null) {
	                tempConfig._useUTC = config._useUTC;
	            }
	            tempConfig._f = config._f[i];
	            configFromStringAndFormat(tempConfig);
	
	            if (isValid(tempConfig)) {
	                validFormatFound = true;
	            }
	
	            // if there is any input that was not parsed add a penalty for that format
	            currentScore += getParsingFlags(tempConfig).charsLeftOver;
	
	            //or tokens
	            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
	
	            getParsingFlags(tempConfig).score = currentScore;
	
	            if (!bestFormatIsValid) {
	                if (
	                    scoreToBeat == null ||
	                    currentScore < scoreToBeat ||
	                    validFormatFound
	                ) {
	                    scoreToBeat = currentScore;
	                    bestMoment = tempConfig;
	                    if (validFormatFound) {
	                        bestFormatIsValid = true;
	                    }
	                }
	            } else {
	                if (currentScore < scoreToBeat) {
	                    scoreToBeat = currentScore;
	                    bestMoment = tempConfig;
	                }
	            }
	        }
	
	        extend(config, bestMoment || tempConfig);
	    }
	
	    function configFromObject(config) {
	        if (config._d) {
	            return;
	        }
	
	        var i = normalizeObjectUnits(config._i),
	            dayOrDate = i.day === undefined ? i.date : i.day;
	        config._a = map(
	            [i.year, i.month, dayOrDate, i.hour, i.minute, i.second, i.millisecond],
	            function (obj) {
	                return obj && parseInt(obj, 10);
	            }
	        );
	
	        configFromArray(config);
	    }
	
	    function createFromConfig(config) {
	        var res = new Moment(checkOverflow(prepareConfig(config)));
	        if (res._nextDay) {
	            // Adding is smart enough around DST
	            res.add(1, 'd');
	            res._nextDay = undefined;
	        }
	
	        return res;
	    }
	
	    function prepareConfig(config) {
	        var input = config._i,
	            format = config._f;
	
	        config._locale = config._locale || getLocale(config._l);
	
	        if (input === null || (format === undefined && input === '')) {
	            return createInvalid({ nullInput: true });
	        }
	
	        if (typeof input === 'string') {
	            config._i = input = config._locale.preparse(input);
	        }
	
	        if (isMoment(input)) {
	            return new Moment(checkOverflow(input));
	        } else if (isDate(input)) {
	            config._d = input;
	        } else if (isArray(format)) {
	            configFromStringAndArray(config);
	        } else if (format) {
	            configFromStringAndFormat(config);
	        } else {
	            configFromInput(config);
	        }
	
	        if (!isValid(config)) {
	            config._d = null;
	        }
	
	        return config;
	    }
	
	    function configFromInput(config) {
	        var input = config._i;
	        if (isUndefined(input)) {
	            config._d = new Date(hooks.now());
	        } else if (isDate(input)) {
	            config._d = new Date(input.valueOf());
	        } else if (typeof input === 'string') {
	            configFromString(config);
	        } else if (isArray(input)) {
	            config._a = map(input.slice(0), function (obj) {
	                return parseInt(obj, 10);
	            });
	            configFromArray(config);
	        } else if (isObject(input)) {
	            configFromObject(config);
	        } else if (isNumber(input)) {
	            // from milliseconds
	            config._d = new Date(input);
	        } else {
	            hooks.createFromInputFallback(config);
	        }
	    }
	
	    function createLocalOrUTC(input, format, locale, strict, isUTC) {
	        var c = {};
	
	        if (format === true || format === false) {
	            strict = format;
	            format = undefined;
	        }
	
	        if (locale === true || locale === false) {
	            strict = locale;
	            locale = undefined;
	        }
	
	        if (
	            (isObject(input) && isObjectEmpty(input)) ||
	            (isArray(input) && input.length === 0)
	        ) {
	            input = undefined;
	        }
	        // object construction must be done this way.
	        // https://github.com/moment/moment/issues/1423
	        c._isAMomentObject = true;
	        c._useUTC = c._isUTC = isUTC;
	        c._l = locale;
	        c._i = input;
	        c._f = format;
	        c._strict = strict;
	
	        return createFromConfig(c);
	    }
	
	    function createLocal(input, format, locale, strict) {
	        return createLocalOrUTC(input, format, locale, strict, false);
	    }
	
	    var prototypeMin = deprecate(
	            'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
	            function () {
	                var other = createLocal.apply(null, arguments);
	                if (this.isValid() && other.isValid()) {
	                    return other < this ? this : other;
	                } else {
	                    return createInvalid();
	                }
	            }
	        ),
	        prototypeMax = deprecate(
	            'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
	            function () {
	                var other = createLocal.apply(null, arguments);
	                if (this.isValid() && other.isValid()) {
	                    return other > this ? this : other;
	                } else {
	                    return createInvalid();
	                }
	            }
	        );
	
	    // Pick a moment m from moments so that m[fn](other) is true for all
	    // other. This relies on the function fn to be transitive.
	    //
	    // moments should either be an array of moment objects or an array, whose
	    // first element is an array of moment objects.
	    function pickBy(fn, moments) {
	        var res, i;
	        if (moments.length === 1 && isArray(moments[0])) {
	            moments = moments[0];
	        }
	        if (!moments.length) {
	            return createLocal();
	        }
	        res = moments[0];
	        for (i = 1; i < moments.length; ++i) {
	            if (!moments[i].isValid() || moments[i][fn](res)) {
	                res = moments[i];
	            }
	        }
	        return res;
	    }
	
	    // TODO: Use [].sort instead?
	    function min() {
	        var args = [].slice.call(arguments, 0);
	
	        return pickBy('isBefore', args);
	    }
	
	    function max() {
	        var args = [].slice.call(arguments, 0);
	
	        return pickBy('isAfter', args);
	    }
	
	    var now = function () {
	        return Date.now ? Date.now() : +new Date();
	    };
	
	    var ordering = [
	        'year',
	        'quarter',
	        'month',
	        'week',
	        'day',
	        'hour',
	        'minute',
	        'second',
	        'millisecond',
	    ];
	
	    function isDurationValid(m) {
	        var key,
	            unitHasDecimal = false,
	            i;
	        for (key in m) {
	            if (
	                hasOwnProp(m, key) &&
	                !(
	                    indexOf.call(ordering, key) !== -1 &&
	                    (m[key] == null || !isNaN(m[key]))
	                )
	            ) {
	                return false;
	            }
	        }
	
	        for (i = 0; i < ordering.length; ++i) {
	            if (m[ordering[i]]) {
	                if (unitHasDecimal) {
	                    return false; // only allow non-integers for smallest unit
	                }
	                if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
	                    unitHasDecimal = true;
	                }
	            }
	        }
	
	        return true;
	    }
	
	    function isValid$1() {
	        return this._isValid;
	    }
	
	    function createInvalid$1() {
	        return createDuration(NaN);
	    }
	
	    function Duration(duration) {
	        var normalizedInput = normalizeObjectUnits(duration),
	            years = normalizedInput.year || 0,
	            quarters = normalizedInput.quarter || 0,
	            months = normalizedInput.month || 0,
	            weeks = normalizedInput.week || normalizedInput.isoWeek || 0,
	            days = normalizedInput.day || 0,
	            hours = normalizedInput.hour || 0,
	            minutes = normalizedInput.minute || 0,
	            seconds = normalizedInput.second || 0,
	            milliseconds = normalizedInput.millisecond || 0;
	
	        this._isValid = isDurationValid(normalizedInput);
	
	        // representation for dateAddRemove
	        this._milliseconds =
	            +milliseconds +
	            seconds * 1e3 + // 1000
	            minutes * 6e4 + // 1000 * 60
	            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
	        // Because of dateAddRemove treats 24 hours as different from a
	        // day when working around DST, we need to store them separately
	        this._days = +days + weeks * 7;
	        // It is impossible to translate months into days without knowing
	        // which months you are are talking about, so we have to store
	        // it separately.
	        this._months = +months + quarters * 3 + years * 12;
	
	        this._data = {};
	
	        this._locale = getLocale();
	
	        this._bubble();
	    }
	
	    function isDuration(obj) {
	        return obj instanceof Duration;
	    }
	
	    function absRound(number) {
	        if (number < 0) {
	            return Math.round(-1 * number) * -1;
	        } else {
	            return Math.round(number);
	        }
	    }
	
	    // compare two arrays, return the number of differences
	    function compareArrays(array1, array2, dontConvert) {
	        var len = Math.min(array1.length, array2.length),
	            lengthDiff = Math.abs(array1.length - array2.length),
	            diffs = 0,
	            i;
	        for (i = 0; i < len; i++) {
	            if (
	                (dontConvert && array1[i] !== array2[i]) ||
	                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))
	            ) {
	                diffs++;
	            }
	        }
	        return diffs + lengthDiff;
	    }
	
	    // FORMATTING
	
	    function offset(token, separator) {
	        addFormatToken(token, 0, 0, function () {
	            var offset = this.utcOffset(),
	                sign = '+';
	            if (offset < 0) {
	                offset = -offset;
	                sign = '-';
	            }
	            return (
	                sign +
	                zeroFill(~~(offset / 60), 2) +
	                separator +
	                zeroFill(~~offset % 60, 2)
	            );
	        });
	    }
	
	    offset('Z', ':');
	    offset('ZZ', '');
	
	    // PARSING
	
	    addRegexToken('Z', matchShortOffset);
	    addRegexToken('ZZ', matchShortOffset);
	    addParseToken(['Z', 'ZZ'], function (input, array, config) {
	        config._useUTC = true;
	        config._tzm = offsetFromString(matchShortOffset, input);
	    });
	
	    // HELPERS
	
	    // timezone chunker
	    // '+10:00' > ['10',  '00']
	    // '-1530'  > ['-15', '30']
	    var chunkOffset = /([\+\-]|\d\d)/gi;
	
	    function offsetFromString(matcher, string) {
	        var matches = (string || '').match(matcher),
	            chunk,
	            parts,
	            minutes;
	
	        if (matches === null) {
	            return null;
	        }
	
	        chunk = matches[matches.length - 1] || [];
	        parts = (chunk + '').match(chunkOffset) || ['-', 0, 0];
	        minutes = +(parts[1] * 60) + toInt(parts[2]);
	
	        return minutes === 0 ? 0 : parts[0] === '+' ? minutes : -minutes;
	    }
	
	    // Return a moment from input, that is local/utc/zone equivalent to model.
	    function cloneWithOffset(input, model) {
	        var res, diff;
	        if (model._isUTC) {
	            res = model.clone();
	            diff =
	                (isMoment(input) || isDate(input)
	                    ? input.valueOf()
	                    : createLocal(input).valueOf()) - res.valueOf();
	            // Use low-level api, because this fn is low-level api.
	            res._d.setTime(res._d.valueOf() + diff);
	            hooks.updateOffset(res, false);
	            return res;
	        } else {
	            return createLocal(input).local();
	        }
	    }
	
	    function getDateOffset(m) {
	        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
	        // https://github.com/moment/moment/pull/1871
	        return -Math.round(m._d.getTimezoneOffset());
	    }
	
	    // HOOKS
	
	    // This function will be called whenever a moment is mutated.
	    // It is intended to keep the offset in sync with the timezone.
	    hooks.updateOffset = function () {};
	
	    // MOMENTS
	
	    // keepLocalTime = true means only change the timezone, without
	    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
	    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
	    // +0200, so we adjust the time as needed, to be valid.
	    //
	    // Keeping the time actually adds/subtracts (one hour)
	    // from the actual represented time. That is why we call updateOffset
	    // a second time. In case it wants us to change the offset again
	    // _changeInProgress == true case, then we have to adjust, because
	    // there is no such time in the given timezone.
	    function getSetOffset(input, keepLocalTime, keepMinutes) {
	        var offset = this._offset || 0,
	            localAdjust;
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        if (input != null) {
	            if (typeof input === 'string') {
	                input = offsetFromString(matchShortOffset, input);
	                if (input === null) {
	                    return this;
	                }
	            } else if (Math.abs(input) < 16 && !keepMinutes) {
	                input = input * 60;
	            }
	            if (!this._isUTC && keepLocalTime) {
	                localAdjust = getDateOffset(this);
	            }
	            this._offset = input;
	            this._isUTC = true;
	            if (localAdjust != null) {
	                this.add(localAdjust, 'm');
	            }
	            if (offset !== input) {
	                if (!keepLocalTime || this._changeInProgress) {
	                    addSubtract(
	                        this,
	                        createDuration(input - offset, 'm'),
	                        1,
	                        false
	                    );
	                } else if (!this._changeInProgress) {
	                    this._changeInProgress = true;
	                    hooks.updateOffset(this, true);
	                    this._changeInProgress = null;
	                }
	            }
	            return this;
	        } else {
	            return this._isUTC ? offset : getDateOffset(this);
	        }
	    }
	
	    function getSetZone(input, keepLocalTime) {
	        if (input != null) {
	            if (typeof input !== 'string') {
	                input = -input;
	            }
	
	            this.utcOffset(input, keepLocalTime);
	
	            return this;
	        } else {
	            return -this.utcOffset();
	        }
	    }
	
	    function setOffsetToUTC(keepLocalTime) {
	        return this.utcOffset(0, keepLocalTime);
	    }
	
	    function setOffsetToLocal(keepLocalTime) {
	        if (this._isUTC) {
	            this.utcOffset(0, keepLocalTime);
	            this._isUTC = false;
	
	            if (keepLocalTime) {
	                this.subtract(getDateOffset(this), 'm');
	            }
	        }
	        return this;
	    }
	
	    function setOffsetToParsedOffset() {
	        if (this._tzm != null) {
	            this.utcOffset(this._tzm, false, true);
	        } else if (typeof this._i === 'string') {
	            var tZone = offsetFromString(matchOffset, this._i);
	            if (tZone != null) {
	                this.utcOffset(tZone);
	            } else {
	                this.utcOffset(0, true);
	            }
	        }
	        return this;
	    }
	
	    function hasAlignedHourOffset(input) {
	        if (!this.isValid()) {
	            return false;
	        }
	        input = input ? createLocal(input).utcOffset() : 0;
	
	        return (this.utcOffset() - input) % 60 === 0;
	    }
	
	    function isDaylightSavingTime() {
	        return (
	            this.utcOffset() > this.clone().month(0).utcOffset() ||
	            this.utcOffset() > this.clone().month(5).utcOffset()
	        );
	    }
	
	    function isDaylightSavingTimeShifted() {
	        if (!isUndefined(this._isDSTShifted)) {
	            return this._isDSTShifted;
	        }
	
	        var c = {},
	            other;
	
	        copyConfig(c, this);
	        c = prepareConfig(c);
	
	        if (c._a) {
	            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
	            this._isDSTShifted =
	                this.isValid() && compareArrays(c._a, other.toArray()) > 0;
	        } else {
	            this._isDSTShifted = false;
	        }
	
	        return this._isDSTShifted;
	    }
	
	    function isLocal() {
	        return this.isValid() ? !this._isUTC : false;
	    }
	
	    function isUtcOffset() {
	        return this.isValid() ? this._isUTC : false;
	    }
	
	    function isUtc() {
	        return this.isValid() ? this._isUTC && this._offset === 0 : false;
	    }
	
	    // ASP.NET json date format regex
	    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/,
	        // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
	        // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
	        // and further modified to allow for strings containing both week and day
	        isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
	
	    function createDuration(input, key) {
	        var duration = input,
	            // matching against regexp is expensive, do it on demand
	            match = null,
	            sign,
	            ret,
	            diffRes;
	
	        if (isDuration(input)) {
	            duration = {
	                ms: input._milliseconds,
	                d: input._days,
	                M: input._months,
	            };
	        } else if (isNumber(input) || !isNaN(+input)) {
	            duration = {};
	            if (key) {
	                duration[key] = +input;
	            } else {
	                duration.milliseconds = +input;
	            }
	        } else if ((match = aspNetRegex.exec(input))) {
	            sign = match[1] === '-' ? -1 : 1;
	            duration = {
	                y: 0,
	                d: toInt(match[DATE]) * sign,
	                h: toInt(match[HOUR]) * sign,
	                m: toInt(match[MINUTE]) * sign,
	                s: toInt(match[SECOND]) * sign,
	                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign, // the millisecond decimal point is included in the match
	            };
	        } else if ((match = isoRegex.exec(input))) {
	            sign = match[1] === '-' ? -1 : 1;
	            duration = {
	                y: parseIso(match[2], sign),
	                M: parseIso(match[3], sign),
	                w: parseIso(match[4], sign),
	                d: parseIso(match[5], sign),
	                h: parseIso(match[6], sign),
	                m: parseIso(match[7], sign),
	                s: parseIso(match[8], sign),
	            };
	        } else if (duration == null) {
	            // checks for null or undefined
	            duration = {};
	        } else if (
	            typeof duration === 'object' &&
	            ('from' in duration || 'to' in duration)
	        ) {
	            diffRes = momentsDifference(
	                createLocal(duration.from),
	                createLocal(duration.to)
	            );
	
	            duration = {};
	            duration.ms = diffRes.milliseconds;
	            duration.M = diffRes.months;
	        }
	
	        ret = new Duration(duration);
	
	        if (isDuration(input) && hasOwnProp(input, '_locale')) {
	            ret._locale = input._locale;
	        }
	
	        if (isDuration(input) && hasOwnProp(input, '_isValid')) {
	            ret._isValid = input._isValid;
	        }
	
	        return ret;
	    }
	
	    createDuration.fn = Duration.prototype;
	    createDuration.invalid = createInvalid$1;
	
	    function parseIso(inp, sign) {
	        // We'd normally use ~~inp for this, but unfortunately it also
	        // converts floats to ints.
	        // inp may be undefined, so careful calling replace on it.
	        var res = inp && parseFloat(inp.replace(',', '.'));
	        // apply sign while we're at it
	        return (isNaN(res) ? 0 : res) * sign;
	    }
	
	    function positiveMomentsDifference(base, other) {
	        var res = {};
	
	        res.months =
	            other.month() - base.month() + (other.year() - base.year()) * 12;
	        if (base.clone().add(res.months, 'M').isAfter(other)) {
	            --res.months;
	        }
	
	        res.milliseconds = +other - +base.clone().add(res.months, 'M');
	
	        return res;
	    }
	
	    function momentsDifference(base, other) {
	        var res;
	        if (!(base.isValid() && other.isValid())) {
	            return { milliseconds: 0, months: 0 };
	        }
	
	        other = cloneWithOffset(other, base);
	        if (base.isBefore(other)) {
	            res = positiveMomentsDifference(base, other);
	        } else {
	            res = positiveMomentsDifference(other, base);
	            res.milliseconds = -res.milliseconds;
	            res.months = -res.months;
	        }
	
	        return res;
	    }
	
	    // TODO: remove 'name' arg after deprecation is removed
	    function createAdder(direction, name) {
	        return function (val, period) {
	            var dur, tmp;
	            //invert the arguments, but complain about it
	            if (period !== null && !isNaN(+period)) {
	                deprecateSimple(
	                    name,
	                    'moment().' +
	                        name +
	                        '(period, number) is deprecated. Please use moment().' +
	                        name +
	                        '(number, period). ' +
	                        'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.'
	                );
	                tmp = val;
	                val = period;
	                period = tmp;
	            }
	
	            dur = createDuration(val, period);
	            addSubtract(this, dur, direction);
	            return this;
	        };
	    }
	
	    function addSubtract(mom, duration, isAdding, updateOffset) {
	        var milliseconds = duration._milliseconds,
	            days = absRound(duration._days),
	            months = absRound(duration._months);
	
	        if (!mom.isValid()) {
	            // No op
	            return;
	        }
	
	        updateOffset = updateOffset == null ? true : updateOffset;
	
	        if (months) {
	            setMonth(mom, get(mom, 'Month') + months * isAdding);
	        }
	        if (days) {
	            set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
	        }
	        if (milliseconds) {
	            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
	        }
	        if (updateOffset) {
	            hooks.updateOffset(mom, days || months);
	        }
	    }
	
	    var add = createAdder(1, 'add'),
	        subtract = createAdder(-1, 'subtract');
	
	    function isString(input) {
	        return typeof input === 'string' || input instanceof String;
	    }
	
	    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
	    function isMomentInput(input) {
	        return (
	            isMoment(input) ||
	            isDate(input) ||
	            isString(input) ||
	            isNumber(input) ||
	            isNumberOrStringArray(input) ||
	            isMomentInputObject(input) ||
	            input === null ||
	            input === undefined
	        );
	    }
	
	    function isMomentInputObject(input) {
	        var objectTest = isObject(input) && !isObjectEmpty(input),
	            propertyTest = false,
	            properties = [
	                'years',
	                'year',
	                'y',
	                'months',
	                'month',
	                'M',
	                'days',
	                'day',
	                'd',
	                'dates',
	                'date',
	                'D',
	                'hours',
	                'hour',
	                'h',
	                'minutes',
	                'minute',
	                'm',
	                'seconds',
	                'second',
	                's',
	                'milliseconds',
	                'millisecond',
	                'ms',
	            ],
	            i,
	            property;
	
	        for (i = 0; i < properties.length; i += 1) {
	            property = properties[i];
	            propertyTest = propertyTest || hasOwnProp(input, property);
	        }
	
	        return objectTest && propertyTest;
	    }
	
	    function isNumberOrStringArray(input) {
	        var arrayTest = isArray(input),
	            dataTypeTest = false;
	        if (arrayTest) {
	            dataTypeTest =
	                input.filter(function (item) {
	                    return !isNumber(item) && isString(input);
	                }).length === 0;
	        }
	        return arrayTest && dataTypeTest;
	    }
	
	    function isCalendarSpec(input) {
	        var objectTest = isObject(input) && !isObjectEmpty(input),
	            propertyTest = false,
	            properties = [
	                'sameDay',
	                'nextDay',
	                'lastDay',
	                'nextWeek',
	                'lastWeek',
	                'sameElse',
	            ],
	            i,
	            property;
	
	        for (i = 0; i < properties.length; i += 1) {
	            property = properties[i];
	            propertyTest = propertyTest || hasOwnProp(input, property);
	        }
	
	        return objectTest && propertyTest;
	    }
	
	    function getCalendarFormat(myMoment, now) {
	        var diff = myMoment.diff(now, 'days', true);
	        return diff < -6
	            ? 'sameElse'
	            : diff < -1
	            ? 'lastWeek'
	            : diff < 0
	            ? 'lastDay'
	            : diff < 1
	            ? 'sameDay'
	            : diff < 2
	            ? 'nextDay'
	            : diff < 7
	            ? 'nextWeek'
	            : 'sameElse';
	    }
	
	    function calendar$1(time, formats) {
	        // Support for single parameter, formats only overload to the calendar function
	        if (arguments.length === 1) {
	            if (!arguments[0]) {
	                time = undefined;
	                formats = undefined;
	            } else if (isMomentInput(arguments[0])) {
	                time = arguments[0];
	                formats = undefined;
	            } else if (isCalendarSpec(arguments[0])) {
	                formats = arguments[0];
	                time = undefined;
	            }
	        }
	        // We want to compare the start of today, vs this.
	        // Getting start-of-today depends on whether we're local/utc/offset or not.
	        var now = time || createLocal(),
	            sod = cloneWithOffset(now, this).startOf('day'),
	            format = hooks.calendarFormat(this, sod) || 'sameElse',
	            output =
	                formats &&
	                (isFunction(formats[format])
	                    ? formats[format].call(this, now)
	                    : formats[format]);
	
	        return this.format(
	            output || this.localeData().calendar(format, this, createLocal(now))
	        );
	    }
	
	    function clone() {
	        return new Moment(this);
	    }
	
	    function isAfter(input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input);
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(units) || 'millisecond';
	        if (units === 'millisecond') {
	            return this.valueOf() > localInput.valueOf();
	        } else {
	            return localInput.valueOf() < this.clone().startOf(units).valueOf();
	        }
	    }
	
	    function isBefore(input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input);
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(units) || 'millisecond';
	        if (units === 'millisecond') {
	            return this.valueOf() < localInput.valueOf();
	        } else {
	            return this.clone().endOf(units).valueOf() < localInput.valueOf();
	        }
	    }
	
	    function isBetween(from, to, units, inclusivity) {
	        var localFrom = isMoment(from) ? from : createLocal(from),
	            localTo = isMoment(to) ? to : createLocal(to);
	        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
	            return false;
	        }
	        inclusivity = inclusivity || '()';
	        return (
	            (inclusivity[0] === '('
	                ? this.isAfter(localFrom, units)
	                : !this.isBefore(localFrom, units)) &&
	            (inclusivity[1] === ')'
	                ? this.isBefore(localTo, units)
	                : !this.isAfter(localTo, units))
	        );
	    }
	
	    function isSame(input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input),
	            inputMs;
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(units) || 'millisecond';
	        if (units === 'millisecond') {
	            return this.valueOf() === localInput.valueOf();
	        } else {
	            inputMs = localInput.valueOf();
	            return (
	                this.clone().startOf(units).valueOf() <= inputMs &&
	                inputMs <= this.clone().endOf(units).valueOf()
	            );
	        }
	    }
	
	    function isSameOrAfter(input, units) {
	        return this.isSame(input, units) || this.isAfter(input, units);
	    }
	
	    function isSameOrBefore(input, units) {
	        return this.isSame(input, units) || this.isBefore(input, units);
	    }
	
	    function diff(input, units, asFloat) {
	        var that, zoneDelta, output;
	
	        if (!this.isValid()) {
	            return NaN;
	        }
	
	        that = cloneWithOffset(input, this);
	
	        if (!that.isValid()) {
	            return NaN;
	        }
	
	        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
	
	        units = normalizeUnits(units);
	
	        switch (units) {
	            case 'year':
	                output = monthDiff(this, that) / 12;
	                break;
	            case 'month':
	                output = monthDiff(this, that);
	                break;
	            case 'quarter':
	                output = monthDiff(this, that) / 3;
	                break;
	            case 'second':
	                output = (this - that) / 1e3;
	                break; // 1000
	            case 'minute':
	                output = (this - that) / 6e4;
	                break; // 1000 * 60
	            case 'hour':
	                output = (this - that) / 36e5;
	                break; // 1000 * 60 * 60
	            case 'day':
	                output = (this - that - zoneDelta) / 864e5;
	                break; // 1000 * 60 * 60 * 24, negate dst
	            case 'week':
	                output = (this - that - zoneDelta) / 6048e5;
	                break; // 1000 * 60 * 60 * 24 * 7, negate dst
	            default:
	                output = this - that;
	        }
	
	        return asFloat ? output : absFloor(output);
	    }
	
	    function monthDiff(a, b) {
	        if (a.date() < b.date()) {
	            // end-of-month calculations work correct when the start month has more
	            // days than the end month.
	            return -monthDiff(b, a);
	        }
	        // difference in months
	        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()),
	            // b is in (anchor - 1 month, anchor + 1 month)
	            anchor = a.clone().add(wholeMonthDiff, 'months'),
	            anchor2,
	            adjust;
	
	        if (b - anchor < 0) {
	            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
	            // linear across the month
	            adjust = (b - anchor) / (anchor - anchor2);
	        } else {
	            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
	            // linear across the month
	            adjust = (b - anchor) / (anchor2 - anchor);
	        }
	
	        //check for negative zero, return zero if negative zero
	        return -(wholeMonthDiff + adjust) || 0;
	    }
	
	    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
	    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';
	
	    function toString() {
	        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
	    }
	
	    function toISOString(keepOffset) {
	        if (!this.isValid()) {
	            return null;
	        }
	        var utc = keepOffset !== true,
	            m = utc ? this.clone().utc() : this;
	        if (m.year() < 0 || m.year() > 9999) {
	            return formatMoment(
	                m,
	                utc
	                    ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]'
	                    : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ'
	            );
	        }
	        if (isFunction(Date.prototype.toISOString)) {
	            // native implementation is ~50x faster, use it when we can
	            if (utc) {
	                return this.toDate().toISOString();
	            } else {
	                return new Date(this.valueOf() + this.utcOffset() * 60 * 1000)
	                    .toISOString()
	                    .replace('Z', formatMoment(m, 'Z'));
	            }
	        }
	        return formatMoment(
	            m,
	            utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ'
	        );
	    }
	
	    /**
	     * Return a human readable representation of a moment that can
	     * also be evaluated to get a new moment which is the same
	     *
	     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
	     */
	    function inspect() {
	        if (!this.isValid()) {
	            return 'moment.invalid(/* ' + this._i + ' */)';
	        }
	        var func = 'moment',
	            zone = '',
	            prefix,
	            year,
	            datetime,
	            suffix;
	        if (!this.isLocal()) {
	            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
	            zone = 'Z';
	        }
	        prefix = '[' + func + '("]';
	        year = 0 <= this.year() && this.year() <= 9999 ? 'YYYY' : 'YYYYYY';
	        datetime = '-MM-DD[T]HH:mm:ss.SSS';
	        suffix = zone + '[")]';
	
	        return this.format(prefix + year + datetime + suffix);
	    }
	
	    function format(inputString) {
	        if (!inputString) {
	            inputString = this.isUtc()
	                ? hooks.defaultFormatUtc
	                : hooks.defaultFormat;
	        }
	        var output = formatMoment(this, inputString);
	        return this.localeData().postformat(output);
	    }
	
	    function from(time, withoutSuffix) {
	        if (
	            this.isValid() &&
	            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
	        ) {
	            return createDuration({ to: this, from: time })
	                .locale(this.locale())
	                .humanize(!withoutSuffix);
	        } else {
	            return this.localeData().invalidDate();
	        }
	    }
	
	    function fromNow(withoutSuffix) {
	        return this.from(createLocal(), withoutSuffix);
	    }
	
	    function to(time, withoutSuffix) {
	        if (
	            this.isValid() &&
	            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
	        ) {
	            return createDuration({ from: this, to: time })
	                .locale(this.locale())
	                .humanize(!withoutSuffix);
	        } else {
	            return this.localeData().invalidDate();
	        }
	    }
	
	    function toNow(withoutSuffix) {
	        return this.to(createLocal(), withoutSuffix);
	    }
	
	    // If passed a locale key, it will set the locale for this
	    // instance.  Otherwise, it will return the locale configuration
	    // variables for this instance.
	    function locale(key) {
	        var newLocaleData;
	
	        if (key === undefined) {
	            return this._locale._abbr;
	        } else {
	            newLocaleData = getLocale(key);
	            if (newLocaleData != null) {
	                this._locale = newLocaleData;
	            }
	            return this;
	        }
	    }
	
	    var lang = deprecate(
	        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
	        function (key) {
	            if (key === undefined) {
	                return this.localeData();
	            } else {
	                return this.locale(key);
	            }
	        }
	    );
	
	    function localeData() {
	        return this._locale;
	    }
	
	    var MS_PER_SECOND = 1000,
	        MS_PER_MINUTE = 60 * MS_PER_SECOND,
	        MS_PER_HOUR = 60 * MS_PER_MINUTE,
	        MS_PER_400_YEARS = (365 * 400 + 97) * 24 * MS_PER_HOUR;
	
	    // actual modulo - handles negative numbers (for dates before 1970):
	    function mod$1(dividend, divisor) {
	        return ((dividend % divisor) + divisor) % divisor;
	    }
	
	    function localStartOfDate(y, m, d) {
	        // the date constructor remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            // preserve leap years using a full 400 year cycle, then reset
	            return new Date(y + 400, m, d) - MS_PER_400_YEARS;
	        } else {
	            return new Date(y, m, d).valueOf();
	        }
	    }
	
	    function utcStartOfDate(y, m, d) {
	        // Date.UTC remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            // preserve leap years using a full 400 year cycle, then reset
	            return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
	        } else {
	            return Date.UTC(y, m, d);
	        }
	    }
	
	    function startOf(units) {
	        var time, startOfDate;
	        units = normalizeUnits(units);
	        if (units === undefined || units === 'millisecond' || !this.isValid()) {
	            return this;
	        }
	
	        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
	
	        switch (units) {
	            case 'year':
	                time = startOfDate(this.year(), 0, 1);
	                break;
	            case 'quarter':
	                time = startOfDate(
	                    this.year(),
	                    this.month() - (this.month() % 3),
	                    1
	                );
	                break;
	            case 'month':
	                time = startOfDate(this.year(), this.month(), 1);
	                break;
	            case 'week':
	                time = startOfDate(
	                    this.year(),
	                    this.month(),
	                    this.date() - this.weekday()
	                );
	                break;
	            case 'isoWeek':
	                time = startOfDate(
	                    this.year(),
	                    this.month(),
	                    this.date() - (this.isoWeekday() - 1)
	                );
	                break;
	            case 'day':
	            case 'date':
	                time = startOfDate(this.year(), this.month(), this.date());
	                break;
	            case 'hour':
	                time = this._d.valueOf();
	                time -= mod$1(
	                    time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
	                    MS_PER_HOUR
	                );
	                break;
	            case 'minute':
	                time = this._d.valueOf();
	                time -= mod$1(time, MS_PER_MINUTE);
	                break;
	            case 'second':
	                time = this._d.valueOf();
	                time -= mod$1(time, MS_PER_SECOND);
	                break;
	        }
	
	        this._d.setTime(time);
	        hooks.updateOffset(this, true);
	        return this;
	    }
	
	    function endOf(units) {
	        var time, startOfDate;
	        units = normalizeUnits(units);
	        if (units === undefined || units === 'millisecond' || !this.isValid()) {
	            return this;
	        }
	
	        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
	
	        switch (units) {
	            case 'year':
	                time = startOfDate(this.year() + 1, 0, 1) - 1;
	                break;
	            case 'quarter':
	                time =
	                    startOfDate(
	                        this.year(),
	                        this.month() - (this.month() % 3) + 3,
	                        1
	                    ) - 1;
	                break;
	            case 'month':
	                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
	                break;
	            case 'week':
	                time =
	                    startOfDate(
	                        this.year(),
	                        this.month(),
	                        this.date() - this.weekday() + 7
	                    ) - 1;
	                break;
	            case 'isoWeek':
	                time =
	                    startOfDate(
	                        this.year(),
	                        this.month(),
	                        this.date() - (this.isoWeekday() - 1) + 7
	                    ) - 1;
	                break;
	            case 'day':
	            case 'date':
	                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
	                break;
	            case 'hour':
	                time = this._d.valueOf();
	                time +=
	                    MS_PER_HOUR -
	                    mod$1(
	                        time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
	                        MS_PER_HOUR
	                    ) -
	                    1;
	                break;
	            case 'minute':
	                time = this._d.valueOf();
	                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
	                break;
	            case 'second':
	                time = this._d.valueOf();
	                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
	                break;
	        }
	
	        this._d.setTime(time);
	        hooks.updateOffset(this, true);
	        return this;
	    }
	
	    function valueOf() {
	        return this._d.valueOf() - (this._offset || 0) * 60000;
	    }
	
	    function unix() {
	        return Math.floor(this.valueOf() / 1000);
	    }
	
	    function toDate() {
	        return new Date(this.valueOf());
	    }
	
	    function toArray() {
	        var m = this;
	        return [
	            m.year(),
	            m.month(),
	            m.date(),
	            m.hour(),
	            m.minute(),
	            m.second(),
	            m.millisecond(),
	        ];
	    }
	
	    function toObject() {
	        var m = this;
	        return {
	            years: m.year(),
	            months: m.month(),
	            date: m.date(),
	            hours: m.hours(),
	            minutes: m.minutes(),
	            seconds: m.seconds(),
	            milliseconds: m.milliseconds(),
	        };
	    }
	
	    function toJSON() {
	        // new Date(NaN).toJSON() === null
	        return this.isValid() ? this.toISOString() : null;
	    }
	
	    function isValid$2() {
	        return isValid(this);
	    }
	
	    function parsingFlags() {
	        return extend({}, getParsingFlags(this));
	    }
	
	    function invalidAt() {
	        return getParsingFlags(this).overflow;
	    }
	
	    function creationData() {
	        return {
	            input: this._i,
	            format: this._f,
	            locale: this._locale,
	            isUTC: this._isUTC,
	            strict: this._strict,
	        };
	    }
	
	    addFormatToken('N', 0, 0, 'eraAbbr');
	    addFormatToken('NN', 0, 0, 'eraAbbr');
	    addFormatToken('NNN', 0, 0, 'eraAbbr');
	    addFormatToken('NNNN', 0, 0, 'eraName');
	    addFormatToken('NNNNN', 0, 0, 'eraNarrow');
	
	    addFormatToken('y', ['y', 1], 'yo', 'eraYear');
	    addFormatToken('y', ['yy', 2], 0, 'eraYear');
	    addFormatToken('y', ['yyy', 3], 0, 'eraYear');
	    addFormatToken('y', ['yyyy', 4], 0, 'eraYear');
	
	    addRegexToken('N', matchEraAbbr);
	    addRegexToken('NN', matchEraAbbr);
	    addRegexToken('NNN', matchEraAbbr);
	    addRegexToken('NNNN', matchEraName);
	    addRegexToken('NNNNN', matchEraNarrow);
	
	    addParseToken(['N', 'NN', 'NNN', 'NNNN', 'NNNNN'], function (
	        input,
	        array,
	        config,
	        token
	    ) {
	        var era = config._locale.erasParse(input, token, config._strict);
	        if (era) {
	            getParsingFlags(config).era = era;
	        } else {
	            getParsingFlags(config).invalidEra = input;
	        }
	    });
	
	    addRegexToken('y', matchUnsigned);
	    addRegexToken('yy', matchUnsigned);
	    addRegexToken('yyy', matchUnsigned);
	    addRegexToken('yyyy', matchUnsigned);
	    addRegexToken('yo', matchEraYearOrdinal);
	
	    addParseToken(['y', 'yy', 'yyy', 'yyyy'], YEAR);
	    addParseToken(['yo'], function (input, array, config, token) {
	        var match;
	        if (config._locale._eraYearOrdinalRegex) {
	            match = input.match(config._locale._eraYearOrdinalRegex);
	        }
	
	        if (config._locale.eraYearOrdinalParse) {
	            array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
	        } else {
	            array[YEAR] = parseInt(input, 10);
	        }
	    });
	
	    function localeEras(m, format) {
	        var i,
	            l,
	            date,
	            eras = this._eras || getLocale('en')._eras;
	        for (i = 0, l = eras.length; i < l; ++i) {
	            switch (typeof eras[i].since) {
	                case 'string':
	                    // truncate time
	                    date = hooks(eras[i].since).startOf('day');
	                    eras[i].since = date.valueOf();
	                    break;
	            }
	
	            switch (typeof eras[i].until) {
	                case 'undefined':
	                    eras[i].until = +Infinity;
	                    break;
	                case 'string':
	                    // truncate time
	                    date = hooks(eras[i].until).startOf('day').valueOf();
	                    eras[i].until = date.valueOf();
	                    break;
	            }
	        }
	        return eras;
	    }
	
	    function localeErasParse(eraName, format, strict) {
	        var i,
	            l,
	            eras = this.eras(),
	            name,
	            abbr,
	            narrow;
	        eraName = eraName.toUpperCase();
	
	        for (i = 0, l = eras.length; i < l; ++i) {
	            name = eras[i].name.toUpperCase();
	            abbr = eras[i].abbr.toUpperCase();
	            narrow = eras[i].narrow.toUpperCase();
	
	            if (strict) {
	                switch (format) {
	                    case 'N':
	                    case 'NN':
	                    case 'NNN':
	                        if (abbr === eraName) {
	                            return eras[i];
	                        }
	                        break;
	
	                    case 'NNNN':
	                        if (name === eraName) {
	                            return eras[i];
	                        }
	                        break;
	
	                    case 'NNNNN':
	                        if (narrow === eraName) {
	                            return eras[i];
	                        }
	                        break;
	                }
	            } else if ([name, abbr, narrow].indexOf(eraName) >= 0) {
	                return eras[i];
	            }
	        }
	    }
	
	    function localeErasConvertYear(era, year) {
	        var dir = era.since <= era.until ? +1 : -1;
	        if (year === undefined) {
	            return hooks(era.since).year();
	        } else {
	            return hooks(era.since).year() + (year - era.offset) * dir;
	        }
	    }
	
	    function getEraName() {
	        var i,
	            l,
	            val,
	            eras = this.localeData().eras();
	        for (i = 0, l = eras.length; i < l; ++i) {
	            // truncate time
	            val = this.clone().startOf('day').valueOf();
	
	            if (eras[i].since <= val && val <= eras[i].until) {
	                return eras[i].name;
	            }
	            if (eras[i].until <= val && val <= eras[i].since) {
	                return eras[i].name;
	            }
	        }
	
	        return '';
	    }
	
	    function getEraNarrow() {
	        var i,
	            l,
	            val,
	            eras = this.localeData().eras();
	        for (i = 0, l = eras.length; i < l; ++i) {
	            // truncate time
	            val = this.clone().startOf('day').valueOf();
	
	            if (eras[i].since <= val && val <= eras[i].until) {
	                return eras[i].narrow;
	            }
	            if (eras[i].until <= val && val <= eras[i].since) {
	                return eras[i].narrow;
	            }
	        }
	
	        return '';
	    }
	
	    function getEraAbbr() {
	        var i,
	            l,
	            val,
	            eras = this.localeData().eras();
	        for (i = 0, l = eras.length; i < l; ++i) {
	            // truncate time
	            val = this.clone().startOf('day').valueOf();
	
	            if (eras[i].since <= val && val <= eras[i].until) {
	                return eras[i].abbr;
	            }
	            if (eras[i].until <= val && val <= eras[i].since) {
	                return eras[i].abbr;
	            }
	        }
	
	        return '';
	    }
	
	    function getEraYear() {
	        var i,
	            l,
	            dir,
	            val,
	            eras = this.localeData().eras();
	        for (i = 0, l = eras.length; i < l; ++i) {
	            dir = eras[i].since <= eras[i].until ? +1 : -1;
	
	            // truncate time
	            val = this.clone().startOf('day').valueOf();
	
	            if (
	                (eras[i].since <= val && val <= eras[i].until) ||
	                (eras[i].until <= val && val <= eras[i].since)
	            ) {
	                return (
	                    (this.year() - hooks(eras[i].since).year()) * dir +
	                    eras[i].offset
	                );
	            }
	        }
	
	        return this.year();
	    }
	
	    function erasNameRegex(isStrict) {
	        if (!hasOwnProp(this, '_erasNameRegex')) {
	            computeErasParse.call(this);
	        }
	        return isStrict ? this._erasNameRegex : this._erasRegex;
	    }
	
	    function erasAbbrRegex(isStrict) {
	        if (!hasOwnProp(this, '_erasAbbrRegex')) {
	            computeErasParse.call(this);
	        }
	        return isStrict ? this._erasAbbrRegex : this._erasRegex;
	    }
	
	    function erasNarrowRegex(isStrict) {
	        if (!hasOwnProp(this, '_erasNarrowRegex')) {
	            computeErasParse.call(this);
	        }
	        return isStrict ? this._erasNarrowRegex : this._erasRegex;
	    }
	
	    function matchEraAbbr(isStrict, locale) {
	        return locale.erasAbbrRegex(isStrict);
	    }
	
	    function matchEraName(isStrict, locale) {
	        return locale.erasNameRegex(isStrict);
	    }
	
	    function matchEraNarrow(isStrict, locale) {
	        return locale.erasNarrowRegex(isStrict);
	    }
	
	    function matchEraYearOrdinal(isStrict, locale) {
	        return locale._eraYearOrdinalRegex || matchUnsigned;
	    }
	
	    function computeErasParse() {
	        var abbrPieces = [],
	            namePieces = [],
	            narrowPieces = [],
	            mixedPieces = [],
	            i,
	            l,
	            eras = this.eras();
	
	        for (i = 0, l = eras.length; i < l; ++i) {
	            namePieces.push(regexEscape(eras[i].name));
	            abbrPieces.push(regexEscape(eras[i].abbr));
	            narrowPieces.push(regexEscape(eras[i].narrow));
	
	            mixedPieces.push(regexEscape(eras[i].name));
	            mixedPieces.push(regexEscape(eras[i].abbr));
	            mixedPieces.push(regexEscape(eras[i].narrow));
	        }
	
	        this._erasRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	        this._erasNameRegex = new RegExp('^(' + namePieces.join('|') + ')', 'i');
	        this._erasAbbrRegex = new RegExp('^(' + abbrPieces.join('|') + ')', 'i');
	        this._erasNarrowRegex = new RegExp(
	            '^(' + narrowPieces.join('|') + ')',
	            'i'
	        );
	    }
	
	    // FORMATTING
	
	    addFormatToken(0, ['gg', 2], 0, function () {
	        return this.weekYear() % 100;
	    });
	
	    addFormatToken(0, ['GG', 2], 0, function () {
	        return this.isoWeekYear() % 100;
	    });
	
	    function addWeekYearFormatToken(token, getter) {
	        addFormatToken(0, [token, token.length], 0, getter);
	    }
	
	    addWeekYearFormatToken('gggg', 'weekYear');
	    addWeekYearFormatToken('ggggg', 'weekYear');
	    addWeekYearFormatToken('GGGG', 'isoWeekYear');
	    addWeekYearFormatToken('GGGGG', 'isoWeekYear');
	
	    // ALIASES
	
	    addUnitAlias('weekYear', 'gg');
	    addUnitAlias('isoWeekYear', 'GG');
	
	    // PRIORITY
	
	    addUnitPriority('weekYear', 1);
	    addUnitPriority('isoWeekYear', 1);
	
	    // PARSING
	
	    addRegexToken('G', matchSigned);
	    addRegexToken('g', matchSigned);
	    addRegexToken('GG', match1to2, match2);
	    addRegexToken('gg', match1to2, match2);
	    addRegexToken('GGGG', match1to4, match4);
	    addRegexToken('gggg', match1to4, match4);
	    addRegexToken('GGGGG', match1to6, match6);
	    addRegexToken('ggggg', match1to6, match6);
	
	    addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (
	        input,
	        week,
	        config,
	        token
	    ) {
	        week[token.substr(0, 2)] = toInt(input);
	    });
	
	    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
	        week[token] = hooks.parseTwoDigitYear(input);
	    });
	
	    // MOMENTS
	
	    function getSetWeekYear(input) {
	        return getSetWeekYearHelper.call(
	            this,
	            input,
	            this.week(),
	            this.weekday(),
	            this.localeData()._week.dow,
	            this.localeData()._week.doy
	        );
	    }
	
	    function getSetISOWeekYear(input) {
	        return getSetWeekYearHelper.call(
	            this,
	            input,
	            this.isoWeek(),
	            this.isoWeekday(),
	            1,
	            4
	        );
	    }
	
	    function getISOWeeksInYear() {
	        return weeksInYear(this.year(), 1, 4);
	    }
	
	    function getISOWeeksInISOWeekYear() {
	        return weeksInYear(this.isoWeekYear(), 1, 4);
	    }
	
	    function getWeeksInYear() {
	        var weekInfo = this.localeData()._week;
	        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
	    }
	
	    function getWeeksInWeekYear() {
	        var weekInfo = this.localeData()._week;
	        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
	    }
	
	    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
	        var weeksTarget;
	        if (input == null) {
	            return weekOfYear(this, dow, doy).year;
	        } else {
	            weeksTarget = weeksInYear(input, dow, doy);
	            if (week > weeksTarget) {
	                week = weeksTarget;
	            }
	            return setWeekAll.call(this, input, week, weekday, dow, doy);
	        }
	    }
	
	    function setWeekAll(weekYear, week, weekday, dow, doy) {
	        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
	            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
	
	        this.year(date.getUTCFullYear());
	        this.month(date.getUTCMonth());
	        this.date(date.getUTCDate());
	        return this;
	    }
	
	    // FORMATTING
	
	    addFormatToken('Q', 0, 'Qo', 'quarter');
	
	    // ALIASES
	
	    addUnitAlias('quarter', 'Q');
	
	    // PRIORITY
	
	    addUnitPriority('quarter', 7);
	
	    // PARSING
	
	    addRegexToken('Q', match1);
	    addParseToken('Q', function (input, array) {
	        array[MONTH] = (toInt(input) - 1) * 3;
	    });
	
	    // MOMENTS
	
	    function getSetQuarter(input) {
	        return input == null
	            ? Math.ceil((this.month() + 1) / 3)
	            : this.month((input - 1) * 3 + (this.month() % 3));
	    }
	
	    // FORMATTING
	
	    addFormatToken('D', ['DD', 2], 'Do', 'date');
	
	    // ALIASES
	
	    addUnitAlias('date', 'D');
	
	    // PRIORITY
	    addUnitPriority('date', 9);
	
	    // PARSING
	
	    addRegexToken('D', match1to2);
	    addRegexToken('DD', match1to2, match2);
	    addRegexToken('Do', function (isStrict, locale) {
	        // TODO: Remove "ordinalParse" fallback in next major release.
	        return isStrict
	            ? locale._dayOfMonthOrdinalParse || locale._ordinalParse
	            : locale._dayOfMonthOrdinalParseLenient;
	    });
	
	    addParseToken(['D', 'DD'], DATE);
	    addParseToken('Do', function (input, array) {
	        array[DATE] = toInt(input.match(match1to2)[0]);
	    });
	
	    // MOMENTS
	
	    var getSetDayOfMonth = makeGetSet('Date', true);
	
	    // FORMATTING
	
	    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');
	
	    // ALIASES
	
	    addUnitAlias('dayOfYear', 'DDD');
	
	    // PRIORITY
	    addUnitPriority('dayOfYear', 4);
	
	    // PARSING
	
	    addRegexToken('DDD', match1to3);
	    addRegexToken('DDDD', match3);
	    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
	        config._dayOfYear = toInt(input);
	    });
	
	    // HELPERS
	
	    // MOMENTS
	
	    function getSetDayOfYear(input) {
	        var dayOfYear =
	            Math.round(
	                (this.clone().startOf('day') - this.clone().startOf('year')) / 864e5
	            ) + 1;
	        return input == null ? dayOfYear : this.add(input - dayOfYear, 'd');
	    }
	
	    // FORMATTING
	
	    addFormatToken('m', ['mm', 2], 0, 'minute');
	
	    // ALIASES
	
	    addUnitAlias('minute', 'm');
	
	    // PRIORITY
	
	    addUnitPriority('minute', 14);
	
	    // PARSING
	
	    addRegexToken('m', match1to2);
	    addRegexToken('mm', match1to2, match2);
	    addParseToken(['m', 'mm'], MINUTE);
	
	    // MOMENTS
	
	    var getSetMinute = makeGetSet('Minutes', false);
	
	    // FORMATTING
	
	    addFormatToken('s', ['ss', 2], 0, 'second');
	
	    // ALIASES
	
	    addUnitAlias('second', 's');
	
	    // PRIORITY
	
	    addUnitPriority('second', 15);
	
	    // PARSING
	
	    addRegexToken('s', match1to2);
	    addRegexToken('ss', match1to2, match2);
	    addParseToken(['s', 'ss'], SECOND);
	
	    // MOMENTS
	
	    var getSetSecond = makeGetSet('Seconds', false);
	
	    // FORMATTING
	
	    addFormatToken('S', 0, 0, function () {
	        return ~~(this.millisecond() / 100);
	    });
	
	    addFormatToken(0, ['SS', 2], 0, function () {
	        return ~~(this.millisecond() / 10);
	    });
	
	    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
	    addFormatToken(0, ['SSSS', 4], 0, function () {
	        return this.millisecond() * 10;
	    });
	    addFormatToken(0, ['SSSSS', 5], 0, function () {
	        return this.millisecond() * 100;
	    });
	    addFormatToken(0, ['SSSSSS', 6], 0, function () {
	        return this.millisecond() * 1000;
	    });
	    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
	        return this.millisecond() * 10000;
	    });
	    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
	        return this.millisecond() * 100000;
	    });
	    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
	        return this.millisecond() * 1000000;
	    });
	
	    // ALIASES
	
	    addUnitAlias('millisecond', 'ms');
	
	    // PRIORITY
	
	    addUnitPriority('millisecond', 16);
	
	    // PARSING
	
	    addRegexToken('S', match1to3, match1);
	    addRegexToken('SS', match1to3, match2);
	    addRegexToken('SSS', match1to3, match3);
	
	    var token, getSetMillisecond;
	    for (token = 'SSSS'; token.length <= 9; token += 'S') {
	        addRegexToken(token, matchUnsigned);
	    }
	
	    function parseMs(input, array) {
	        array[MILLISECOND] = toInt(('0.' + input) * 1000);
	    }
	
	    for (token = 'S'; token.length <= 9; token += 'S') {
	        addParseToken(token, parseMs);
	    }
	
	    getSetMillisecond = makeGetSet('Milliseconds', false);
	
	    // FORMATTING
	
	    addFormatToken('z', 0, 0, 'zoneAbbr');
	    addFormatToken('zz', 0, 0, 'zoneName');
	
	    // MOMENTS
	
	    function getZoneAbbr() {
	        return this._isUTC ? 'UTC' : '';
	    }
	
	    function getZoneName() {
	        return this._isUTC ? 'Coordinated Universal Time' : '';
	    }
	
	    var proto = Moment.prototype;
	
	    proto.add = add;
	    proto.calendar = calendar$1;
	    proto.clone = clone;
	    proto.diff = diff;
	    proto.endOf = endOf;
	    proto.format = format;
	    proto.from = from;
	    proto.fromNow = fromNow;
	    proto.to = to;
	    proto.toNow = toNow;
	    proto.get = stringGet;
	    proto.invalidAt = invalidAt;
	    proto.isAfter = isAfter;
	    proto.isBefore = isBefore;
	    proto.isBetween = isBetween;
	    proto.isSame = isSame;
	    proto.isSameOrAfter = isSameOrAfter;
	    proto.isSameOrBefore = isSameOrBefore;
	    proto.isValid = isValid$2;
	    proto.lang = lang;
	    proto.locale = locale;
	    proto.localeData = localeData;
	    proto.max = prototypeMax;
	    proto.min = prototypeMin;
	    proto.parsingFlags = parsingFlags;
	    proto.set = stringSet;
	    proto.startOf = startOf;
	    proto.subtract = subtract;
	    proto.toArray = toArray;
	    proto.toObject = toObject;
	    proto.toDate = toDate;
	    proto.toISOString = toISOString;
	    proto.inspect = inspect;
	    if (typeof Symbol !== 'undefined' && Symbol.for != null) {
	        proto[Symbol.for('nodejs.util.inspect.custom')] = function () {
	            return 'Moment<' + this.format() + '>';
	        };
	    }
	    proto.toJSON = toJSON;
	    proto.toString = toString;
	    proto.unix = unix;
	    proto.valueOf = valueOf;
	    proto.creationData = creationData;
	    proto.eraName = getEraName;
	    proto.eraNarrow = getEraNarrow;
	    proto.eraAbbr = getEraAbbr;
	    proto.eraYear = getEraYear;
	    proto.year = getSetYear;
	    proto.isLeapYear = getIsLeapYear;
	    proto.weekYear = getSetWeekYear;
	    proto.isoWeekYear = getSetISOWeekYear;
	    proto.quarter = proto.quarters = getSetQuarter;
	    proto.month = getSetMonth;
	    proto.daysInMonth = getDaysInMonth;
	    proto.week = proto.weeks = getSetWeek;
	    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
	    proto.weeksInYear = getWeeksInYear;
	    proto.weeksInWeekYear = getWeeksInWeekYear;
	    proto.isoWeeksInYear = getISOWeeksInYear;
	    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
	    proto.date = getSetDayOfMonth;
	    proto.day = proto.days = getSetDayOfWeek;
	    proto.weekday = getSetLocaleDayOfWeek;
	    proto.isoWeekday = getSetISODayOfWeek;
	    proto.dayOfYear = getSetDayOfYear;
	    proto.hour = proto.hours = getSetHour;
	    proto.minute = proto.minutes = getSetMinute;
	    proto.second = proto.seconds = getSetSecond;
	    proto.millisecond = proto.milliseconds = getSetMillisecond;
	    proto.utcOffset = getSetOffset;
	    proto.utc = setOffsetToUTC;
	    proto.local = setOffsetToLocal;
	    proto.parseZone = setOffsetToParsedOffset;
	    proto.hasAlignedHourOffset = hasAlignedHourOffset;
	    proto.isDST = isDaylightSavingTime;
	    proto.isLocal = isLocal;
	    proto.isUtcOffset = isUtcOffset;
	    proto.isUtc = isUtc;
	    proto.isUTC = isUtc;
	    proto.zoneAbbr = getZoneAbbr;
	    proto.zoneName = getZoneName;
	    proto.dates = deprecate(
	        'dates accessor is deprecated. Use date instead.',
	        getSetDayOfMonth
	    );
	    proto.months = deprecate(
	        'months accessor is deprecated. Use month instead',
	        getSetMonth
	    );
	    proto.years = deprecate(
	        'years accessor is deprecated. Use year instead',
	        getSetYear
	    );
	    proto.zone = deprecate(
	        'moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/',
	        getSetZone
	    );
	    proto.isDSTShifted = deprecate(
	        'isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information',
	        isDaylightSavingTimeShifted
	    );
	
	    function createUnix(input) {
	        return createLocal(input * 1000);
	    }
	
	    function createInZone() {
	        return createLocal.apply(null, arguments).parseZone();
	    }
	
	    function preParsePostFormat(string) {
	        return string;
	    }
	
	    var proto$1 = Locale.prototype;
	
	    proto$1.calendar = calendar;
	    proto$1.longDateFormat = longDateFormat;
	    proto$1.invalidDate = invalidDate;
	    proto$1.ordinal = ordinal;
	    proto$1.preparse = preParsePostFormat;
	    proto$1.postformat = preParsePostFormat;
	    proto$1.relativeTime = relativeTime;
	    proto$1.pastFuture = pastFuture;
	    proto$1.set = set;
	    proto$1.eras = localeEras;
	    proto$1.erasParse = localeErasParse;
	    proto$1.erasConvertYear = localeErasConvertYear;
	    proto$1.erasAbbrRegex = erasAbbrRegex;
	    proto$1.erasNameRegex = erasNameRegex;
	    proto$1.erasNarrowRegex = erasNarrowRegex;
	
	    proto$1.months = localeMonths;
	    proto$1.monthsShort = localeMonthsShort;
	    proto$1.monthsParse = localeMonthsParse;
	    proto$1.monthsRegex = monthsRegex;
	    proto$1.monthsShortRegex = monthsShortRegex;
	    proto$1.week = localeWeek;
	    proto$1.firstDayOfYear = localeFirstDayOfYear;
	    proto$1.firstDayOfWeek = localeFirstDayOfWeek;
	
	    proto$1.weekdays = localeWeekdays;
	    proto$1.weekdaysMin = localeWeekdaysMin;
	    proto$1.weekdaysShort = localeWeekdaysShort;
	    proto$1.weekdaysParse = localeWeekdaysParse;
	
	    proto$1.weekdaysRegex = weekdaysRegex;
	    proto$1.weekdaysShortRegex = weekdaysShortRegex;
	    proto$1.weekdaysMinRegex = weekdaysMinRegex;
	
	    proto$1.isPM = localeIsPM;
	    proto$1.meridiem = localeMeridiem;
	
	    function get$1(format, index, field, setter) {
	        var locale = getLocale(),
	            utc = createUTC().set(setter, index);
	        return locale[field](utc, format);
	    }
	
	    function listMonthsImpl(format, index, field) {
	        if (isNumber(format)) {
	            index = format;
	            format = undefined;
	        }
	
	        format = format || '';
	
	        if (index != null) {
	            return get$1(format, index, field, 'month');
	        }
	
	        var i,
	            out = [];
	        for (i = 0; i < 12; i++) {
	            out[i] = get$1(format, i, field, 'month');
	        }
	        return out;
	    }
	
	    // ()
	    // (5)
	    // (fmt, 5)
	    // (fmt)
	    // (true)
	    // (true, 5)
	    // (true, fmt, 5)
	    // (true, fmt)
	    function listWeekdaysImpl(localeSorted, format, index, field) {
	        if (typeof localeSorted === 'boolean') {
	            if (isNumber(format)) {
	                index = format;
	                format = undefined;
	            }
	
	            format = format || '';
	        } else {
	            format = localeSorted;
	            index = format;
	            localeSorted = false;
	
	            if (isNumber(format)) {
	                index = format;
	                format = undefined;
	            }
	
	            format = format || '';
	        }
	
	        var locale = getLocale(),
	            shift = localeSorted ? locale._week.dow : 0,
	            i,
	            out = [];
	
	        if (index != null) {
	            return get$1(format, (index + shift) % 7, field, 'day');
	        }
	
	        for (i = 0; i < 7; i++) {
	            out[i] = get$1(format, (i + shift) % 7, field, 'day');
	        }
	        return out;
	    }
	
	    function listMonths(format, index) {
	        return listMonthsImpl(format, index, 'months');
	    }
	
	    function listMonthsShort(format, index) {
	        return listMonthsImpl(format, index, 'monthsShort');
	    }
	
	    function listWeekdays(localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
	    }
	
	    function listWeekdaysShort(localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
	    }
	
	    function listWeekdaysMin(localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
	    }
	
	    getSetGlobalLocale('en', {
	        eras: [
	            {
	                since: '0001-01-01',
	                until: +Infinity,
	                offset: 1,
	                name: 'Anno Domini',
	                narrow: 'AD',
	                abbr: 'AD',
	            },
	            {
	                since: '0000-12-31',
	                until: -Infinity,
	                offset: 1,
	                name: 'Before Christ',
	                narrow: 'BC',
	                abbr: 'BC',
	            },
	        ],
	        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    toInt((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	    });
	
	    // Side effect imports
	
	    hooks.lang = deprecate(
	        'moment.lang is deprecated. Use moment.locale instead.',
	        getSetGlobalLocale
	    );
	    hooks.langData = deprecate(
	        'moment.langData is deprecated. Use moment.localeData instead.',
	        getLocale
	    );
	
	    var mathAbs = Math.abs;
	
	    function abs() {
	        var data = this._data;
	
	        this._milliseconds = mathAbs(this._milliseconds);
	        this._days = mathAbs(this._days);
	        this._months = mathAbs(this._months);
	
	        data.milliseconds = mathAbs(data.milliseconds);
	        data.seconds = mathAbs(data.seconds);
	        data.minutes = mathAbs(data.minutes);
	        data.hours = mathAbs(data.hours);
	        data.months = mathAbs(data.months);
	        data.years = mathAbs(data.years);
	
	        return this;
	    }
	
	    function addSubtract$1(duration, input, value, direction) {
	        var other = createDuration(input, value);
	
	        duration._milliseconds += direction * other._milliseconds;
	        duration._days += direction * other._days;
	        duration._months += direction * other._months;
	
	        return duration._bubble();
	    }
	
	    // supports only 2.0-style add(1, 's') or add(duration)
	    function add$1(input, value) {
	        return addSubtract$1(this, input, value, 1);
	    }
	
	    // supports only 2.0-style subtract(1, 's') or subtract(duration)
	    function subtract$1(input, value) {
	        return addSubtract$1(this, input, value, -1);
	    }
	
	    function absCeil(number) {
	        if (number < 0) {
	            return Math.floor(number);
	        } else {
	            return Math.ceil(number);
	        }
	    }
	
	    function bubble() {
	        var milliseconds = this._milliseconds,
	            days = this._days,
	            months = this._months,
	            data = this._data,
	            seconds,
	            minutes,
	            hours,
	            years,
	            monthsFromDays;
	
	        // if we have a mix of positive and negative values, bubble down first
	        // check: https://github.com/moment/moment/issues/2166
	        if (
	            !(
	                (milliseconds >= 0 && days >= 0 && months >= 0) ||
	                (milliseconds <= 0 && days <= 0 && months <= 0)
	            )
	        ) {
	            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
	            days = 0;
	            months = 0;
	        }
	
	        // The following code bubbles up values, see the tests for
	        // examples of what that means.
	        data.milliseconds = milliseconds % 1000;
	
	        seconds = absFloor(milliseconds / 1000);
	        data.seconds = seconds % 60;
	
	        minutes = absFloor(seconds / 60);
	        data.minutes = minutes % 60;
	
	        hours = absFloor(minutes / 60);
	        data.hours = hours % 24;
	
	        days += absFloor(hours / 24);
	
	        // convert days to months
	        monthsFromDays = absFloor(daysToMonths(days));
	        months += monthsFromDays;
	        days -= absCeil(monthsToDays(monthsFromDays));
	
	        // 12 months -> 1 year
	        years = absFloor(months / 12);
	        months %= 12;
	
	        data.days = days;
	        data.months = months;
	        data.years = years;
	
	        return this;
	    }
	
	    function daysToMonths(days) {
	        // 400 years have 146097 days (taking into account leap year rules)
	        // 400 years have 12 months === 4800
	        return (days * 4800) / 146097;
	    }
	
	    function monthsToDays(months) {
	        // the reverse of daysToMonths
	        return (months * 146097) / 4800;
	    }
	
	    function as(units) {
	        if (!this.isValid()) {
	            return NaN;
	        }
	        var days,
	            months,
	            milliseconds = this._milliseconds;
	
	        units = normalizeUnits(units);
	
	        if (units === 'month' || units === 'quarter' || units === 'year') {
	            days = this._days + milliseconds / 864e5;
	            months = this._months + daysToMonths(days);
	            switch (units) {
	                case 'month':
	                    return months;
	                case 'quarter':
	                    return months / 3;
	                case 'year':
	                    return months / 12;
	            }
	        } else {
	            // handle milliseconds separately because of floating point math errors (issue #1867)
	            days = this._days + Math.round(monthsToDays(this._months));
	            switch (units) {
	                case 'week':
	                    return days / 7 + milliseconds / 6048e5;
	                case 'day':
	                    return days + milliseconds / 864e5;
	                case 'hour':
	                    return days * 24 + milliseconds / 36e5;
	                case 'minute':
	                    return days * 1440 + milliseconds / 6e4;
	                case 'second':
	                    return days * 86400 + milliseconds / 1000;
	                // Math.floor prevents floating point math errors here
	                case 'millisecond':
	                    return Math.floor(days * 864e5) + milliseconds;
	                default:
	                    throw new Error('Unknown unit ' + units);
	            }
	        }
	    }
	
	    // TODO: Use this.as('ms')?
	    function valueOf$1() {
	        if (!this.isValid()) {
	            return NaN;
	        }
	        return (
	            this._milliseconds +
	            this._days * 864e5 +
	            (this._months % 12) * 2592e6 +
	            toInt(this._months / 12) * 31536e6
	        );
	    }
	
	    function makeAs(alias) {
	        return function () {
	            return this.as(alias);
	        };
	    }
	
	    var asMilliseconds = makeAs('ms'),
	        asSeconds = makeAs('s'),
	        asMinutes = makeAs('m'),
	        asHours = makeAs('h'),
	        asDays = makeAs('d'),
	        asWeeks = makeAs('w'),
	        asMonths = makeAs('M'),
	        asQuarters = makeAs('Q'),
	        asYears = makeAs('y');
	
	    function clone$1() {
	        return createDuration(this);
	    }
	
	    function get$2(units) {
	        units = normalizeUnits(units);
	        return this.isValid() ? this[units + 's']() : NaN;
	    }
	
	    function makeGetter(name) {
	        return function () {
	            return this.isValid() ? this._data[name] : NaN;
	        };
	    }
	
	    var milliseconds = makeGetter('milliseconds'),
	        seconds = makeGetter('seconds'),
	        minutes = makeGetter('minutes'),
	        hours = makeGetter('hours'),
	        days = makeGetter('days'),
	        months = makeGetter('months'),
	        years = makeGetter('years');
	
	    function weeks() {
	        return absFloor(this.days() / 7);
	    }
	
	    var round = Math.round,
	        thresholds = {
	            ss: 44, // a few seconds to seconds
	            s: 45, // seconds to minute
	            m: 45, // minutes to hour
	            h: 22, // hours to day
	            d: 26, // days to month/week
	            w: null, // weeks to month
	            M: 11, // months to year
	        };
	
	    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
	    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
	        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
	    }
	
	    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
	        var duration = createDuration(posNegDuration).abs(),
	            seconds = round(duration.as('s')),
	            minutes = round(duration.as('m')),
	            hours = round(duration.as('h')),
	            days = round(duration.as('d')),
	            months = round(duration.as('M')),
	            weeks = round(duration.as('w')),
	            years = round(duration.as('y')),
	            a =
	                (seconds <= thresholds.ss && ['s', seconds]) ||
	                (seconds < thresholds.s && ['ss', seconds]) ||
	                (minutes <= 1 && ['m']) ||
	                (minutes < thresholds.m && ['mm', minutes]) ||
	                (hours <= 1 && ['h']) ||
	                (hours < thresholds.h && ['hh', hours]) ||
	                (days <= 1 && ['d']) ||
	                (days < thresholds.d && ['dd', days]);
	
	        if (thresholds.w != null) {
	            a =
	                a ||
	                (weeks <= 1 && ['w']) ||
	                (weeks < thresholds.w && ['ww', weeks]);
	        }
	        a = a ||
	            (months <= 1 && ['M']) ||
	            (months < thresholds.M && ['MM', months]) ||
	            (years <= 1 && ['y']) || ['yy', years];
	
	        a[2] = withoutSuffix;
	        a[3] = +posNegDuration > 0;
	        a[4] = locale;
	        return substituteTimeAgo.apply(null, a);
	    }
	
	    // This function allows you to set the rounding function for relative time strings
	    function getSetRelativeTimeRounding(roundingFunction) {
	        if (roundingFunction === undefined) {
	            return round;
	        }
	        if (typeof roundingFunction === 'function') {
	            round = roundingFunction;
	            return true;
	        }
	        return false;
	    }
	
	    // This function allows you to set a threshold for relative time strings
	    function getSetRelativeTimeThreshold(threshold, limit) {
	        if (thresholds[threshold] === undefined) {
	            return false;
	        }
	        if (limit === undefined) {
	            return thresholds[threshold];
	        }
	        thresholds[threshold] = limit;
	        if (threshold === 's') {
	            thresholds.ss = limit - 1;
	        }
	        return true;
	    }
	
	    function humanize(argWithSuffix, argThresholds) {
	        if (!this.isValid()) {
	            return this.localeData().invalidDate();
	        }
	
	        var withSuffix = false,
	            th = thresholds,
	            locale,
	            output;
	
	        if (typeof argWithSuffix === 'object') {
	            argThresholds = argWithSuffix;
	            argWithSuffix = false;
	        }
	        if (typeof argWithSuffix === 'boolean') {
	            withSuffix = argWithSuffix;
	        }
	        if (typeof argThresholds === 'object') {
	            th = Object.assign({}, thresholds, argThresholds);
	            if (argThresholds.s != null && argThresholds.ss == null) {
	                th.ss = argThresholds.s - 1;
	            }
	        }
	
	        locale = this.localeData();
	        output = relativeTime$1(this, !withSuffix, th, locale);
	
	        if (withSuffix) {
	            output = locale.pastFuture(+this, output);
	        }
	
	        return locale.postformat(output);
	    }
	
	    var abs$1 = Math.abs;
	
	    function sign(x) {
	        return (x > 0) - (x < 0) || +x;
	    }
	
	    function toISOString$1() {
	        // for ISO strings we do not use the normal bubbling rules:
	        //  * milliseconds bubble up until they become hours
	        //  * days do not bubble at all
	        //  * months bubble up until they become years
	        // This is because there is no context-free conversion between hours and days
	        // (think of clock changes)
	        // and also not between days and months (28-31 days per month)
	        if (!this.isValid()) {
	            return this.localeData().invalidDate();
	        }
	
	        var seconds = abs$1(this._milliseconds) / 1000,
	            days = abs$1(this._days),
	            months = abs$1(this._months),
	            minutes,
	            hours,
	            years,
	            s,
	            total = this.asSeconds(),
	            totalSign,
	            ymSign,
	            daysSign,
	            hmsSign;
	
	        if (!total) {
	            // this is the same as C#'s (Noda) and python (isodate)...
	            // but not other JS (goog.date)
	            return 'P0D';
	        }
	
	        // 3600 seconds -> 60 minutes -> 1 hour
	        minutes = absFloor(seconds / 60);
	        hours = absFloor(minutes / 60);
	        seconds %= 60;
	        minutes %= 60;
	
	        // 12 months -> 1 year
	        years = absFloor(months / 12);
	        months %= 12;
	
	        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
	        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
	
	        totalSign = total < 0 ? '-' : '';
	        ymSign = sign(this._months) !== sign(total) ? '-' : '';
	        daysSign = sign(this._days) !== sign(total) ? '-' : '';
	        hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';
	
	        return (
	            totalSign +
	            'P' +
	            (years ? ymSign + years + 'Y' : '') +
	            (months ? ymSign + months + 'M' : '') +
	            (days ? daysSign + days + 'D' : '') +
	            (hours || minutes || seconds ? 'T' : '') +
	            (hours ? hmsSign + hours + 'H' : '') +
	            (minutes ? hmsSign + minutes + 'M' : '') +
	            (seconds ? hmsSign + s + 'S' : '')
	        );
	    }
	
	    var proto$2 = Duration.prototype;
	
	    proto$2.isValid = isValid$1;
	    proto$2.abs = abs;
	    proto$2.add = add$1;
	    proto$2.subtract = subtract$1;
	    proto$2.as = as;
	    proto$2.asMilliseconds = asMilliseconds;
	    proto$2.asSeconds = asSeconds;
	    proto$2.asMinutes = asMinutes;
	    proto$2.asHours = asHours;
	    proto$2.asDays = asDays;
	    proto$2.asWeeks = asWeeks;
	    proto$2.asMonths = asMonths;
	    proto$2.asQuarters = asQuarters;
	    proto$2.asYears = asYears;
	    proto$2.valueOf = valueOf$1;
	    proto$2._bubble = bubble;
	    proto$2.clone = clone$1;
	    proto$2.get = get$2;
	    proto$2.milliseconds = milliseconds;
	    proto$2.seconds = seconds;
	    proto$2.minutes = minutes;
	    proto$2.hours = hours;
	    proto$2.days = days;
	    proto$2.weeks = weeks;
	    proto$2.months = months;
	    proto$2.years = years;
	    proto$2.humanize = humanize;
	    proto$2.toISOString = toISOString$1;
	    proto$2.toString = toISOString$1;
	    proto$2.toJSON = toISOString$1;
	    proto$2.locale = locale;
	    proto$2.localeData = localeData;
	
	    proto$2.toIsoString = deprecate(
	        'toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)',
	        toISOString$1
	    );
	    proto$2.lang = lang;
	
	    // FORMATTING
	
	    addFormatToken('X', 0, 0, 'unix');
	    addFormatToken('x', 0, 0, 'valueOf');
	
	    // PARSING
	
	    addRegexToken('x', matchSigned);
	    addRegexToken('X', matchTimestamp);
	    addParseToken('X', function (input, array, config) {
	        config._d = new Date(parseFloat(input) * 1000);
	    });
	    addParseToken('x', function (input, array, config) {
	        config._d = new Date(toInt(input));
	    });
	
	    //! moment.js
	
	    hooks.version = '2.29.1';
	
	    setHookCallback(createLocal);
	
	    hooks.fn = proto;
	    hooks.min = min;
	    hooks.max = max;
	    hooks.now = now;
	    hooks.utc = createUTC;
	    hooks.unix = createUnix;
	    hooks.months = listMonths;
	    hooks.isDate = isDate;
	    hooks.locale = getSetGlobalLocale;
	    hooks.invalid = createInvalid;
	    hooks.duration = createDuration;
	    hooks.isMoment = isMoment;
	    hooks.weekdays = listWeekdays;
	    hooks.parseZone = createInZone;
	    hooks.localeData = getLocale;
	    hooks.isDuration = isDuration;
	    hooks.monthsShort = listMonthsShort;
	    hooks.weekdaysMin = listWeekdaysMin;
	    hooks.defineLocale = defineLocale;
	    hooks.updateLocale = updateLocale;
	    hooks.locales = listLocales;
	    hooks.weekdaysShort = listWeekdaysShort;
	    hooks.normalizeUnits = normalizeUnits;
	    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
	    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
	    hooks.calendarFormat = getCalendarFormat;
	    hooks.prototype = proto;
	
	    // currently HTML5 input type only supports 24-hour formats
	    hooks.HTML5_FMT = {
	        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm', // <input type="datetime-local" />
	        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss', // <input type="datetime-local" step="1" />
	        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS', // <input type="datetime-local" step="0.001" />
	        DATE: 'YYYY-MM-DD', // <input type="date" />
	        TIME: 'HH:mm', // <input type="time" />
	        TIME_SECONDS: 'HH:mm:ss', // <input type="time" step="1" />
	        TIME_MS: 'HH:mm:ss.SSS', // <input type="time" step="0.001" />
	        WEEK: 'GGGG-[W]WW', // <input type="week" />
	        MONTH: 'YYYY-MM', // <input type="month" />
	    };
	
	    return hooks;
	
	})));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(485)(module)))

/***/ }),
/* 1022 */
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./af": 1023,
		"./af.js": 1023,
		"./ar": 1024,
		"./ar-dz": 1025,
		"./ar-dz.js": 1025,
		"./ar-kw": 1026,
		"./ar-kw.js": 1026,
		"./ar-ly": 1027,
		"./ar-ly.js": 1027,
		"./ar-ma": 1028,
		"./ar-ma.js": 1028,
		"./ar-sa": 1029,
		"./ar-sa.js": 1029,
		"./ar-tn": 1030,
		"./ar-tn.js": 1030,
		"./ar.js": 1024,
		"./az": 1031,
		"./az.js": 1031,
		"./be": 1032,
		"./be.js": 1032,
		"./bg": 1033,
		"./bg.js": 1033,
		"./bm": 1034,
		"./bm.js": 1034,
		"./bn": 1035,
		"./bn-bd": 1036,
		"./bn-bd.js": 1036,
		"./bn.js": 1035,
		"./bo": 1037,
		"./bo.js": 1037,
		"./br": 1038,
		"./br.js": 1038,
		"./bs": 1039,
		"./bs.js": 1039,
		"./ca": 1040,
		"./ca.js": 1040,
		"./cs": 1041,
		"./cs.js": 1041,
		"./cv": 1042,
		"./cv.js": 1042,
		"./cy": 1043,
		"./cy.js": 1043,
		"./da": 1044,
		"./da.js": 1044,
		"./de": 1045,
		"./de-at": 1046,
		"./de-at.js": 1046,
		"./de-ch": 1047,
		"./de-ch.js": 1047,
		"./de.js": 1045,
		"./dv": 1048,
		"./dv.js": 1048,
		"./el": 1049,
		"./el.js": 1049,
		"./en-au": 1050,
		"./en-au.js": 1050,
		"./en-ca": 1051,
		"./en-ca.js": 1051,
		"./en-gb": 1052,
		"./en-gb.js": 1052,
		"./en-ie": 1053,
		"./en-ie.js": 1053,
		"./en-il": 1054,
		"./en-il.js": 1054,
		"./en-in": 1055,
		"./en-in.js": 1055,
		"./en-nz": 1056,
		"./en-nz.js": 1056,
		"./en-sg": 1057,
		"./en-sg.js": 1057,
		"./eo": 1058,
		"./eo.js": 1058,
		"./es": 1059,
		"./es-do": 1060,
		"./es-do.js": 1060,
		"./es-mx": 1061,
		"./es-mx.js": 1061,
		"./es-us": 1062,
		"./es-us.js": 1062,
		"./es.js": 1059,
		"./et": 1063,
		"./et.js": 1063,
		"./eu": 1064,
		"./eu.js": 1064,
		"./fa": 1065,
		"./fa.js": 1065,
		"./fi": 1066,
		"./fi.js": 1066,
		"./fil": 1067,
		"./fil.js": 1067,
		"./fo": 1068,
		"./fo.js": 1068,
		"./fr": 1069,
		"./fr-ca": 1070,
		"./fr-ca.js": 1070,
		"./fr-ch": 1071,
		"./fr-ch.js": 1071,
		"./fr.js": 1069,
		"./fy": 1072,
		"./fy.js": 1072,
		"./ga": 1073,
		"./ga.js": 1073,
		"./gd": 1074,
		"./gd.js": 1074,
		"./gl": 1075,
		"./gl.js": 1075,
		"./gom-deva": 1076,
		"./gom-deva.js": 1076,
		"./gom-latn": 1077,
		"./gom-latn.js": 1077,
		"./gu": 1078,
		"./gu.js": 1078,
		"./he": 1079,
		"./he.js": 1079,
		"./hi": 1080,
		"./hi.js": 1080,
		"./hr": 1081,
		"./hr.js": 1081,
		"./hu": 1082,
		"./hu.js": 1082,
		"./hy-am": 1083,
		"./hy-am.js": 1083,
		"./id": 1084,
		"./id.js": 1084,
		"./is": 1085,
		"./is.js": 1085,
		"./it": 1086,
		"./it-ch": 1087,
		"./it-ch.js": 1087,
		"./it.js": 1086,
		"./ja": 1088,
		"./ja.js": 1088,
		"./jv": 1089,
		"./jv.js": 1089,
		"./ka": 1090,
		"./ka.js": 1090,
		"./kk": 1091,
		"./kk.js": 1091,
		"./km": 1092,
		"./km.js": 1092,
		"./kn": 1093,
		"./kn.js": 1093,
		"./ko": 1094,
		"./ko.js": 1094,
		"./ku": 1095,
		"./ku.js": 1095,
		"./ky": 1096,
		"./ky.js": 1096,
		"./lb": 1097,
		"./lb.js": 1097,
		"./lo": 1098,
		"./lo.js": 1098,
		"./lt": 1099,
		"./lt.js": 1099,
		"./lv": 1100,
		"./lv.js": 1100,
		"./me": 1101,
		"./me.js": 1101,
		"./mi": 1102,
		"./mi.js": 1102,
		"./mk": 1103,
		"./mk.js": 1103,
		"./ml": 1104,
		"./ml.js": 1104,
		"./mn": 1105,
		"./mn.js": 1105,
		"./mr": 1106,
		"./mr.js": 1106,
		"./ms": 1107,
		"./ms-my": 1108,
		"./ms-my.js": 1108,
		"./ms.js": 1107,
		"./mt": 1109,
		"./mt.js": 1109,
		"./my": 1110,
		"./my.js": 1110,
		"./nb": 1111,
		"./nb.js": 1111,
		"./ne": 1112,
		"./ne.js": 1112,
		"./nl": 1113,
		"./nl-be": 1114,
		"./nl-be.js": 1114,
		"./nl.js": 1113,
		"./nn": 1115,
		"./nn.js": 1115,
		"./oc-lnc": 1116,
		"./oc-lnc.js": 1116,
		"./pa-in": 1117,
		"./pa-in.js": 1117,
		"./pl": 1118,
		"./pl.js": 1118,
		"./pt": 1119,
		"./pt-br": 1120,
		"./pt-br.js": 1120,
		"./pt.js": 1119,
		"./ro": 1121,
		"./ro.js": 1121,
		"./ru": 1122,
		"./ru.js": 1122,
		"./sd": 1123,
		"./sd.js": 1123,
		"./se": 1124,
		"./se.js": 1124,
		"./si": 1125,
		"./si.js": 1125,
		"./sk": 1126,
		"./sk.js": 1126,
		"./sl": 1127,
		"./sl.js": 1127,
		"./sq": 1128,
		"./sq.js": 1128,
		"./sr": 1129,
		"./sr-cyrl": 1130,
		"./sr-cyrl.js": 1130,
		"./sr.js": 1129,
		"./ss": 1131,
		"./ss.js": 1131,
		"./sv": 1132,
		"./sv.js": 1132,
		"./sw": 1133,
		"./sw.js": 1133,
		"./ta": 1134,
		"./ta.js": 1134,
		"./te": 1135,
		"./te.js": 1135,
		"./tet": 1136,
		"./tet.js": 1136,
		"./tg": 1137,
		"./tg.js": 1137,
		"./th": 1138,
		"./th.js": 1138,
		"./tk": 1139,
		"./tk.js": 1139,
		"./tl-ph": 1140,
		"./tl-ph.js": 1140,
		"./tlh": 1141,
		"./tlh.js": 1141,
		"./tr": 1142,
		"./tr.js": 1142,
		"./tzl": 1143,
		"./tzl.js": 1143,
		"./tzm": 1144,
		"./tzm-latn": 1145,
		"./tzm-latn.js": 1145,
		"./tzm.js": 1144,
		"./ug-cn": 1146,
		"./ug-cn.js": 1146,
		"./uk": 1147,
		"./uk.js": 1147,
		"./ur": 1148,
		"./ur.js": 1148,
		"./uz": 1149,
		"./uz-latn": 1150,
		"./uz-latn.js": 1150,
		"./uz.js": 1149,
		"./vi": 1151,
		"./vi.js": 1151,
		"./x-pseudo": 1152,
		"./x-pseudo.js": 1152,
		"./yo": 1153,
		"./yo.js": 1153,
		"./zh-cn": 1154,
		"./zh-cn.js": 1154,
		"./zh-hk": 1155,
		"./zh-hk.js": 1155,
		"./zh-mo": 1156,
		"./zh-mo.js": 1156,
		"./zh-tw": 1157,
		"./zh-tw.js": 1157
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 1022;


/***/ }),
/* 1023 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Afrikaans [af]
	//! author : Werner Mollentze : https://github.com/wernerm
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1021)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var af = moment.defineLocale('af', {
	        months: 'Januarie_Februarie_Maart_April_Mei_Junie_Julie_Augustus_September_Oktober_November_Desember'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mrt_Apr_Mei_Jun_Jul_Aug_Sep_Okt_Nov_Des'.split('_'),
	        weekdays: 'Sondag_Maandag_Dinsdag_Woensdag_Donderdag_Vrydag_Saterdag'.split(
	            '_'
	        ),
	        weekdaysShort: 'Son_Maa_Din_Woe_Don_Vry_Sat'.split('_'),
	        weekdaysMin: 'So_Ma_Di_Wo_Do_Vr_Sa'.split('_'),
	        meridiemParse: /vm|nm/i,
	        isPM: function (input) {
	            return /^nm$/i.test(input);
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower ? 'vm' : 'VM';
	            } else {
	                return isLower ? 'nm' : 'NM';
	            }
	        },
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Vandag om] LT',
	            nextDay: '[Môre om] LT',
	            nextWeek: 'dddd [om] LT',
	            lastDay: '[Gister om] LT',
	            lastWeek: '[Laas] dddd [om] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'oor %s',
	            past: '%s gelede',
	            s: "'n paar sekondes",
	            ss: '%d sekondes',
	            m: "'n minuut",
	            mm: '%d minute',
	            h: "'n uur",
	            hh: '%d ure',
	            d: "'n dag",
	            dd: '%d dae',
	            M: "'n maand",
	            MM: '%d maande',
	            y: "'n jaar",
	            yy: '%d jaar',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	        ordinal: function (number) {
	            return (
	                number +
	                (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
	            ); // Thanks to Joris Röling : https://github.com/jjupiter
	        },
	        week: {
	            dow: 1, // Maandag is die eerste dag van die week.
	            doy: 4, // Die week wat die 4de Januarie bevat is die eerste week van die jaar.
	        },
	    });
	
	    return af;
	
	})));


/***/ }),
/* 1024 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic [ar]
	//! author : Abdel Said: https://github.com/abdelsaid
	//! author : Ahmed Elkhatib
	//! author : forabi https://github.com/forabi
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1021)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '١',
	            2: '٢',
	            3: '٣',
	            4: '٤',
	            5: '٥',
	            6: '٦',
	            7: '٧',
	            8: '٨',
	            9: '٩',
	            0: '٠',
	        },
	        numberMap = {
	            '١': '1',
	            '٢': '2',
	            '٣': '3',
	            '٤': '4',
	            '٥': '5',
	            '٦': '6',
	            '٧': '7',
	            '٨': '8',
	            '٩': '9',
	            '٠': '0',
	        },
	        pluralForm = function (n) {
	            return n === 0
	                ? 0
	                : n === 1
	                ? 1
	                : n === 2
	                ? 2
	                : n % 100 >= 3 && n % 100 <= 10
	                ? 3
	                : n % 100 >= 11
	                ? 4
	                : 5;
	        },
	        plurals = {
	            s: [
	                'أقل من ثانية',
	                'ثانية واحدة',
	                ['ثانيتان', 'ثانيتين'],
	                '%d ثوان',
	                '%d ثانية',
	                '%d ثانية',
	            ],
	            m: [
	                'أقل من دقيقة',
	                'دقيقة واحدة',
	                ['دقيقتان', 'دقيقتين'],
	                '%d دقائق',
	                '%d دقيقة',
	                '%d دقيقة',
	            ],
	            h: [
	                'أقل من ساعة',
	                'ساعة واحدة',
	                ['ساعتان', 'ساعتين'],
	                '%d ساعات',
	                '%d ساعة',
	                '%d ساعة',
	            ],
	            d: [
	                'أقل من يوم',
	                'يوم واحد',
	                ['يومان', 'يومين'],
	                '%d أيام',
	                '%d يومًا',
	                '%d يوم',
	            ],
	            M: [
	                'أقل من شهر',
	                'شهر واحد',
	                ['شهران', 'شهرين'],
	                '%d أشهر',
	                '%d شهرا',
	                '%d شهر',
	            ],
	            y: [
	                'أقل من عام',
	                'عام واحد',
	                ['عامان', 'عامين'],
	                '%d أعوام',
	                '%d عامًا',
	                '%d عام',
	            ],
	        },
	        pluralize = function (u) {
	            return function (number, withoutSuffix, string, isFuture) {
	                var f = pluralForm(number),
	                    str = plurals[u][pluralForm(number)];
	                if (f === 2) {
	                    str = str[withoutSuffix ? 0 : 1];
	                }
	                return str.replace(/%d/i, number);
	            };
	        },
	        months = [
	            'يناير',
	            'فبراير',
	            'مارس',
	            'أبريل',
	            'مايو',
	            'يونيو',
	            'يوليو',
	            'أغسطس',
	            'سبتمبر',
	            'أكتوبر',
	            'نوفمبر',
	            'ديسمبر',
	        ];
	
	    var ar = moment.defineLocale('ar', {
	        months: months,
	        monthsShort: months,
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'D/\u200FM/\u200FYYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ص|م/,
	        isPM: function (input) {
	            return 'م' === input;
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar: {
	            sameDay: '[اليوم عند الساعة] LT',
	            nextDay: '[غدًا عند الساعة] LT',
	            nextWeek: 'dddd [عند الساعة] LT',
	            lastDay: '[أمس عند الساعة] LT',
	            lastWeek: 'dddd [عند الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'بعد %s',
	            past: 'منذ %s',
	            s: pluralize('s'),
	            ss: pluralize('s'),
	            m: pluralize('m'),
	            mm: pluralize('m'),
	            h: pluralize('h'),
	            hh: pluralize('h'),
	            d: pluralize('d'),
	            dd: pluralize('d'),
	            M: pluralize('M'),
	            MM: pluralize('M'),
	            y: pluralize('y'),
	            yy: pluralize('y'),
	        },
	        preparse: function (string) {
	            return string
	                .replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	                    return numberMap[match];
	                })
	                .replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string
	                .replace(/\d/g, function (match) {
	                    return symbolMap[match];
	                })
	                .replace(/,/g, '،');
	        },
	        week: {
	            dow: 6, // Saturday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return ar;
	
	})));


/***/ }),
/* 1025 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Algeria) [ar-dz]
	//! author : Amine Roukh: https://github.com/Amine27
	//! author : Abdel Said: https://github.com/abdelsaid
	//! author : Ahmed Elkhatib
	//! author : forabi https://github.com/forabi
	//! author : Noureddine LOUAHEDJ : https://github.com/noureddinem
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1021)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var pluralForm = function (n) {
	            return n === 0
	                ? 0
	                : n === 1
	                ? 1
	                : n === 2
	                ? 2
	                : n % 100 >= 3 && n % 100 <= 10
	                ? 3
	                : n % 100 >= 11
	                ? 4
	                : 5;
	        },
	        plurals = {
	            s: [
	                'أقل من ثانية',
	                'ثانية واحدة',
	                ['ثانيتان', 'ثانيتين'],
	                '%d ثوان',
	                '%d ثانية',
	                '%d ثانية',
	            ],
	            m: [
	                'أقل من دقيقة',
	                'دقيقة واحدة',
	                ['دقيقتان', 'دقيقتين'],
	                '%d دقائق',
	                '%d دقيقة',
	                '%d دقيقة',
	            ],
	            h: [
	                'أقل من ساعة',
	                'ساعة واحدة',
	                ['ساعتان', 'ساعتين'],
	                '%d ساعات',
	                '%d ساعة',
	                '%d ساعة',
	            ],
	            d: [
	                'أقل من يوم',
	                'يوم واحد',
	                ['يومان', 'يومين'],
	                '%d أيام',
	                '%d يومًا',
	                '%d يوم',
	            ],
	            M: [
	                'أقل من شهر',
	                'شهر واحد',
	                ['شهران', 'شهرين'],
	                '%d أشهر',
	                '%d شهرا',
	                '%d شهر',
	            ],
	            y: [
	                'أقل من عام',
	                'عام واحد',
	                ['عامان', 'عامين'],
	                '%d أعوام',
	                '%d عامًا',
	                '%d عام',
	            ],
	        },
	        pluralize = function (u) {
	            return function (number, withoutSuffix, string, isFuture) {
	                var f = pluralForm(number),
	                    str = plurals[u][pluralForm(number)];
	                if (f === 2) {
	                    str = str[withoutSuffix ? 0 : 1];
	                }
	                return str.replace(/%d/i, number);
	            };
	        },
	        months = [
	            'جانفي',
	            'فيفري',
	            'مارس',
	            'أفريل',
	            'ماي',
	            'جوان',
	            'جويلية',
	            'أوت',
	            'سبتمبر',
	            'أكتوبر',
	            'نوفمبر',
	            'ديسمبر',
	        ];
	
	    var arDz = moment.defineLocale('ar-dz', {
	        months: months,
	        monthsShort: months,
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'D/\u200FM/\u200FYYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ص|م/,
	        isPM: function (input) {
	            return 'م' === input;
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar: {
	            sameDay: '[اليوم عند الساعة] LT',
	            nextDay: '[غدًا عند الساعة] LT',
	            nextWeek: 'dddd [عند الساعة] LT',
	            lastDay: '[أمس عند الساعة] LT',
	            lastWeek: 'dddd [عند الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'بعد %s',
	            past: 'منذ %s',
	            s: pluralize('s'),
	            ss: pluralize('s'),
	            m: pluralize('m'),
	            mm: pluralize('m'),
	            h: pluralize('h'),
	            hh: pluralize('h'),
	            d: pluralize('d'),
	            dd: pluralize('d'),
	            M: pluralize('M'),
	            MM: pluralize('M'),
	            y: pluralize('y'),
	            yy: pluralize('y'),
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return arDz;
	
	})));


/***/ }),
/* 1026 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Kuwait) [ar-kw]
	//! author : Nusret Parlak: https://github.com/nusretparlak
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1021)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var arKw = moment.defineLocale('ar-kw', {
	        months: 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
	            '_'
	        ),
	        monthsShort: 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
	            '_'
	        ),
	        weekdays: 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'في %s',
	            past: 'منذ %s',
	            s: 'ثوان',
	            ss: '%d ثانية',
	            m: 'دقيقة',
	            mm: '%d دقائق',
	            h: 'ساعة',
	            hh: '%d ساعات',
	            d: 'يوم',
	            dd: '%d أيام',
	            M: 'شهر',
	            MM: '%d أشهر',
	            y: 'سنة',
	            yy: '%d سنوات',
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return arKw;
	
	})));


/***/ }),
/* 1027 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Lybia) [ar-ly]
	//! author : Ali Hmer: https://github.com/kikoanis
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1021)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '1',
	            2: '2',
	            3: '3',
	            4: '4',
	            5: '5',
	            6: '6',
	            7: '7',
	            8: '8',
	            9: '9',
	            0: '0',
	        },
	        pluralForm = function (n) {
	            return n === 0
	                ? 0
	                : n === 1
	                ? 1
	                : n === 2
	                ? 2
	                : n % 100 >= 3 && n % 100 <= 10
	                ? 3
	                : n % 100 >= 11
	                ? 4
	                : 5;
	        },
	        plurals = {
	            s: [
	                'أقل من ثانية',
	                'ثانية واحدة',
	                ['ثانيتان', 'ثانيتين'],
	                '%d ثوان',
	                '%d ثانية',
	                '%d ثانية',
	            ],
	            m: [
	                'أقل من دقيقة',
	                'دقيقة واحدة',
	                ['دقيقتان', 'دقيقتين'],
	                '%d دقائق',
	                '%d دقيقة',
	                '%d دقيقة',
	            ],
	            h: [
	                'أقل من ساعة',
	                'ساعة واحدة',
	                ['ساعتان', 'ساعتين'],
	                '%d ساعات',
	                '%d ساعة',
	                '%d ساعة',
	            ],
	            d: [
	                'أقل من يوم',
	                'يوم واحد',
	                ['يومان', 'يومين'],
	                '%d أيام',
	                '%d يومًا',
	                '%d يوم',
	            ],
	            M: [
	                'أقل من شهر',
	                'شهر واحد',
	                ['شهران', 'شهرين'],
	                '%d أشهر',
	                '%d شهرا',
	                '%d شهر',
	            ],
	            y: [
	                'أقل من عام',
	                'عام واحد',
	                ['عامان', 'عامين'],
	                '%d أعوام',
	                '%d عامًا',
	                '%d عام',
	            ],
	        },
	        pluralize = function (u) {
	            return function (number, withoutSuffix, string, isFuture) {
	                var f = pluralForm(number),
	                    str = plurals[u][pluralForm(number)];
	                if (f === 2) {
	                    str = str[withoutSuffix ? 0 : 1];
	                }
	                return str.replace(/%d/i, number);
	            };
	        },
	        months = [
	            'يناير',
	            'فبراير',
	            'مارس',
	            'أبريل',
	            'مايو',
	            'يونيو',
	            'يوليو',
	            'أغسطس',
	            'سبتمبر',
	            'أكتوبر',
	            'نوفمبر',
	            'ديسمبر',
	        ];
	
	    var arLy = moment.defineLocale('ar-ly', {
	        months: months,
	        monthsShort: months,
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'D/\u200FM/\u200FYYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ص|م/,
	        isPM: function (input) {
	            return 'م' === input;
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar: {
	            sameDay: '[اليوم عند الساعة] LT',
	            nextDay: '[غدًا عند الساعة] LT',
	            nextWeek: 'dddd [عند الساعة] LT',
	            lastDay: '[أمس عند الساعة] LT',
	            lastWeek: 'dddd [عند الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'بعد %s',
	            past: 'منذ %s',
	            s: pluralize('s'),
	            ss: pluralize('s'),
	            m: pluralize('m'),
	            mm: pluralize('m'),
	            h: pluralize('h'),
	            hh: pluralize('h'),
	            d: pluralize('d'),
	            dd: pluralize('d'),
	            M: pluralize('M'),
	            MM: pluralize('M'),
	            y: pluralize('y'),
	            yy: pluralize('y'),
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string
	                .replace(/\d/g, function (match) {
	                    return symbolMap[match];
	                })
	                .replace(/,/g, '،');
	        },
	        week: {
	            dow: 6, // Saturday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return arLy;
	
	})));


/***/ }),
/* 1028 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Morocco) [ar-ma]
	//! author : ElFadili Yassine : https://github.com/ElFadiliY
	//! author : Abdel Said : https://github.com/abdelsaid
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1021)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var arMa = moment.defineLocale('ar-ma', {
	        months: 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
	            '_'
	        ),
	        monthsShort: 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
	            '_'
	        ),
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'احد_اثنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'في %s',
	            past: 'منذ %s',
	            s: 'ثوان',
	            ss: '%d ثانية',
	            m: 'دقيقة',
	            mm: '%d دقائق',
	            h: 'ساعة',
	            hh: '%d ساعات',
	            d: 'يوم',
	            dd: '%d أيام',
	            M: 'شهر',
	            MM: '%d أشهر',
	            y: 'سنة',
	            yy: '%d سنوات',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return arMa;
	
	})));


/***/ }),
/* 1029 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Saudi Arabia) [ar-sa]
	//! author : Suhail Alkowaileet : https://github.com/xsoh
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1021)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '١',
	            2: '٢',
	            3: '٣',
	            4: '٤',
	            5: '٥',
	            6: '٦',
	            7: '٧',
	            8: '٨',
	            9: '٩',
	            0: '٠',
	        },
	        numberMap = {
	            '١': '1',
	            '٢': '2',
	            '٣': '3',
	            '٤': '4',
	            '٥': '5',
	            '٦': '6',
	            '٧': '7',
	            '٨': '8',
	            '٩': '9',
	            '٠': '0',
	        };
	
	    var arSa = moment.defineLocale('ar-sa', {
	        months: 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
	            '_'
	        ),
	        monthsShort: 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
	            '_'
	        ),
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ص|م/,
	        isPM: function (input) {
	            return 'م' === input;
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar: {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'في %s',
	            past: 'منذ %s',
	            s: 'ثوان',
	            ss: '%d ثانية',
	            m: 'دقيقة',
	            mm: '%d دقائق',
	            h: 'ساعة',
	            hh: '%d ساعات',
	            d: 'يوم',
	            dd: '%d أيام',
	            M: 'شهر',
	            MM: '%d أشهر',
	            y: 'سنة',
	            yy: '%d سنوات',
	        },
	        preparse: function (string) {
	            return string
	                .replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	                    return numberMap[match];
	                })
	                .replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string
	                .replace(/\d/g, function (match) {
	                    return symbolMap[match];
	                })
	                .replace(/,/g, '،');
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return arSa;
	
	})));


/***/ }),
/* 1030 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale  :  Arabic (Tunisia) [ar-tn]
	//! author : Nader Toukabri : https://github.com/naderio
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1021)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var arTn = moment.defineLocale('ar-tn', {
	        months: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
	            '_'
	        ),
	        monthsShort: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
	            '_'
	        ),
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'في %s',
	            past: 'منذ %s',
	            s: 'ثوان',
	            ss: '%d ثانية',
	            m: 'دقيقة',
	            mm: '%d دقائق',
	            h: 'ساعة',
	            hh: '%d ساعات',
	            d: 'يوم',
	            dd: '%d أيام',
	            M: 'شهر',
	            MM: '%d أشهر',
	            y: 'سنة',
	            yy: '%d سنوات',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return arTn;
	
	})));


/***/ }),
/* 1031 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Azerbaijani [az]
	//! author : topchiyev : https://github.com/topchiyev
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1021)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var suffixes = {
	        1: '-inci',
	        5: '-inci',
	        8: '-inci',
	        70: '-inci',
	        80: '-inci',
	        2: '-nci',
	        7: '-nci',
	        20: '-nci',
	        50: '-nci',
	        3: '-üncü',
	        4: '-üncü',
	        100: '-üncü',
	        6: '-ncı',
	        9: '-uncu',
	        10: '-uncu',
	        30: '-uncu',
	        60: '-ıncı',
	        90: '-ıncı',
	    };
	
	    var az = moment.defineLocale('az', {
	        months: 'yanvar_fevral_mart_aprel_may_iyun_iyul_avqust_sentyabr_oktyabr_noyabr_dekabr'.split(
	            '_'
	        ),
	        monthsShort: 'yan_fev_mar_apr_may_iyn_iyl_avq_sen_okt_noy_dek'.split('_'),
	        weekdays: 'Bazar_Bazar ertəsi_Çərşənbə axşamı_Çərşənbə_Cümə axşamı_Cümə_Şənbə'.split(
	            '_'
	        ),
	        weekdaysShort: 'Baz_BzE_ÇAx_Çər_CAx_Cüm_Şən'.split('_'),
	        weekdaysMin: 'Bz_BE_ÇA_Çə_CA_Cü_Şə'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[bugün saat] LT',
	            nextDay: '[sabah saat] LT',
	            nextWeek: '[gələn həftə] dddd [saat] LT',
	            lastDay: '[dünən] LT',
	            lastWeek: '[keçən həftə] dddd [saat] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s sonra',
	            past: '%s əvvəl',
	            s: 'bir neçə saniyə',
	            ss: '%d saniyə',
	            m: 'bir dəqiqə',
	            mm: '%d dəqiqə',
	            h: 'bir saat',
	            hh: '%d saat',
	            d: 'bir gün',
	            dd: '%d gün',
	            M: 'bir ay',
	            MM: '%d ay',
	            y: 'bir il',
	            yy: '%d il',
	        },
	        meridiemParse: /gecə|səhər|gündüz|axşam/,
	        isPM: function (input) {
	            return /^(gündüz|axşam)$/.test(input);
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'gecə';
	            } else if (hour < 12) {
	                return 'səhər';
	            } else if (hour < 17) {
	                return 'gündüz';
	            } else {
	                return 'axşam';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ıncı|inci|nci|üncü|ncı|uncu)/,
	        ordinal: function (number) {
	            if (number === 0) {
	                // special case for zero
	                return number + '-ıncı';
	            }
	            var a = number % 10,
	                b = (number % 100) - a,
	                c = number >= 100 ? 100 : null;
	            return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return az;
	
	})));


/***/ }),
/* 1032 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Belarusian [be]
	//! author : Dmitry Demidov : https://github.com/demidov91
	//! author: Praleska: http://praleska.pro/
	//! Author : Menelion Elensúle : https://github.com/Oire
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1021)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function plural(word, num) {
	        var forms = word.split('_');
	        return num % 10 === 1 && num % 100 !== 11
	            ? forms[0]
	            : num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20)
	            ? forms[1]
	            : forms[2];
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	            ss: withoutSuffix ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
	            mm: withoutSuffix ? 'хвіліна_хвіліны_хвілін' : 'хвіліну_хвіліны_хвілін',
	            hh: withoutSuffix ? 'гадзіна_гадзіны_гадзін' : 'гадзіну_гадзіны_гадзін',
	            dd: 'дзень_дні_дзён',
	            MM: 'месяц_месяцы_месяцаў',
	            yy: 'год_гады_гадоў',
	        };
	        if (key === 'm') {
	            return withoutSuffix ? 'хвіліна' : 'хвіліну';
	        } else if (key === 'h') {
	            return withoutSuffix ? 'гадзіна' : 'гадзіну';
	        } else {
	            return number + ' ' + plural(format[key], +number);
	        }
	    }
	
	    var be = moment.defineLocale('be', {
	        months: {
	            format: 'студзеня_лютага_сакавіка_красавіка_траўня_чэрвеня_ліпеня_жніўня_верасня_кастрычніка_лістапада_снежня'.split(
	                '_'
	            ),
	            standalone: 'студзень_люты_сакавік_красавік_травень_чэрвень_ліпень_жнівень_верасень_кастрычнік_лістапад_снежань'.split(
	                '_'
	            ),
	        },
	        monthsShort: 'студ_лют_сак_крас_трав_чэрв_ліп_жнів_вер_каст_ліст_снеж'.split(
	            '_'
	        ),
	        weekdays: {
	            format: 'нядзелю_панядзелак_аўторак_сераду_чацвер_пятніцу_суботу'.split(
	                '_'
	            ),
	            standalone: 'нядзеля_панядзелак_аўторак_серада_чацвер_пятніца_субота'.split(
	                '_'
	            ),
	            isFormat: /\[ ?[Ууў] ?(?:мінулую|наступную)? ?\] ?dddd/,
	        },
	        weekdaysShort: 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
	        weekdaysMin: 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY г.',
	            LLL: 'D MMMM YYYY г., HH:mm',
	            LLLL: 'dddd, D MMMM YYYY г., HH:mm',
	        },
	        calendar: {
	            sameDay: '[Сёння ў] LT',
	            nextDay: '[Заўтра ў] LT',
	            lastDay: '[Учора ў] LT',
	            nextWeek: function () {
	                return '[У] dddd [ў] LT';
	            },
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 5:
	                    case 6:
	                        return '[У мінулую] dddd [ў] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                        return '[У мінулы] dddd [ў] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'праз %s',
	            past: '%s таму',
	            s: 'некалькі секунд',
	            m: relativeTimeWithPlural,
	            mm: relativeTimeWithPlural,
	            h: relativeTimeWithPlural,
	            hh: relativeTimeWithPlural,
	            d: 'дзень',
	            dd: relativeTimeWithPlural,
	            M: 'месяц',
	            MM: relativeTimeWithPlural,
	            y: 'год',
	            yy: relativeTimeWithPlural,
	        },
	        meridiemParse: /ночы|раніцы|дня|вечара/,
	        isPM: function (input) {
	            return /^(дня|вечара)$/.test(input);
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ночы';
	            } else if (hour < 12) {
	                return 'раніцы';
	            } else if (hour < 17) {
	                return 'дня';
	            } else {
	                return 'вечара';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(і|ы|га)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'M':
	                case 'd':
	                case 'DDD':
	                case 'w':
	                case 'W':
	                    return (number % 10 === 2 || number % 10 === 3) &&
	                        number % 100 !== 12 &&
	                        number % 100 !== 13
	                        ? number + '-і'
	                        : number + '-ы';
	                case 'D':
	                    return number + '-га';
	                default:
	                    return number;
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return be;
	
	})));


/***/ }),
/* 1033 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bulgarian [bg]
	//! author : Krasen Borisov : https://github.com/kraz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1021)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var bg = moment.defineLocale('bg', {
	        months: 'януари_февруари_март_април_май_юни_юли_август_септември_октомври_ноември_декември'.split(
	            '_'
	        ),
	        monthsShort: 'яну_фев_мар_апр_май_юни_юли_авг_сеп_окт_ное_дек'.split('_'),
	        weekdays: 'неделя_понеделник_вторник_сряда_четвъртък_петък_събота'.split(
	            '_'
	        ),
	        weekdaysShort: 'нед_пон_вто_сря_чет_пет_съб'.split('_'),
	        weekdaysMin: 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'D.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY H:mm',
	            LLLL: 'dddd, D MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[Днес в] LT',
	            nextDay: '[Утре в] LT',
	            nextWeek: 'dddd [в] LT',
	            lastDay: '[Вчера в] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 6:
	                        return '[Миналата] dddd [в] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[Миналия] dddd [в] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'след %s',
	            past: 'преди %s',
	            s: 'няколко секунди',
	            ss: '%d секунди',
	            m: 'минута',
	            mm: '%d минути',
	            h: 'час',
	            hh: '%d часа',
	            d: 'ден',
	            dd: '%d дена',
	            w: 'седмица',
	            ww: '%d седмици',
	            M: 'месец',
	            MM: '%d месеца',
	            y: 'година',
	            yy: '%d години',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
	        ordinal: function (number) {
	            var lastDigit = number % 10,
	                last2Digits = number % 100;
	            if (number === 0) {
	                return number + '-ев';
	            } else if (last2Digits === 0) {
	                return number + '-ен';
	            } else if (last2Digits > 10 && last2Digits < 20) {
	                return number + '-ти';
	            } else if (lastDigit === 1) {
	                return number + '-ви';
	            } else if (lastDigit === 2) {
	                return number + '-ри';
	            } else if (lastDigit === 7 || lastDigit === 8) {
	                return number + '-ми';
	            } else {
	                return number + '-ти';
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return bg;
	
	})));


/***/ }),
/* 1034 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bambara [bm]
	//! author : Estelle Comment : https://github.com/estellecomment
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1021)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var bm = moment.defineLocale('bm', {
	        months: 'Zanwuyekalo_Fewuruyekalo_Marisikalo_Awirilikalo_Mɛkalo_Zuwɛnkalo_Zuluyekalo_Utikalo_Sɛtanburukalo_ɔkutɔburukalo_Nowanburukalo_Desanburukalo'.split(
	            '_'
	        ),
	        monthsShort: 'Zan_Few_Mar_Awi_Mɛ_Zuw_Zul_Uti_Sɛt_ɔku_Now_Des'.split('_'),
	        weekdays: 'Kari_Ntɛnɛn_Tarata_Araba_Alamisa_Juma_Sibiri'.split('_'),
	        weekdaysShort: 'Kar_Ntɛ_Tar_Ara_Ala_Jum_Sib'.split('_'),
	        weekdaysMin: 'Ka_Nt_Ta_Ar_Al_Ju_Si'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'MMMM [tile] D [san] YYYY',
	            LLL: 'MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm',
	            LLLL: 'dddd MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm',
	        },
	        calendar: {
	            sameDay: '[Bi lɛrɛ] LT',
	            nextDay: '[Sini lɛrɛ] LT',
	            nextWeek: 'dddd [don lɛrɛ] LT',
	            lastDay: '[Kunu lɛrɛ] LT',
	            lastWeek: 'dddd [tɛmɛnen lɛrɛ] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s kɔnɔ',
	            past: 'a bɛ %s bɔ',
	            s: 'sanga dama dama',
	            ss: 'sekondi %d',
	            m: 'miniti kelen',
	            mm: 'miniti %d',
	            h: 'lɛrɛ kelen',
	            hh: 'lɛrɛ %d',
	            d: 'tile kelen',
	            dd: 'tile %d',
	            M: 'kalo kelen',
	            MM: 'kalo %d',
	            y: 'san kelen',
	            yy: 'san %d',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return bm;
	
	})));


/***/ }),
/* 1035 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bengali [bn]
	//! author : Kaushik Gandhi : https://github.com/kaushikgandhi
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1021)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '১',
	            2: '২',
	            3: '৩',
	            4: '৪',
	            5: '৫',
	            6: '৬',
	            7: '৭',
	            8: '৮',
	            9: '৯',
	            0: '০',
	        },
	        numberMap = {
	            '১': '1',
	            '২': '2',
	            '৩': '3',
	            '৪': '4',
	            '৫': '5',
	            '৬': '6',
	            '৭': '7',
	            '৮': '8',
	            '৯': '9',
	            '০': '0',
	        };
	
	    var bn = moment.defineLocale('bn', {
	        months: 'জানুয়ারি_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split(
	            '_'
	        ),
	        monthsShort: 'জানু_ফেব্রু_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্ট_অক্টো_নভে_ডিসে'.split(
	            '_'
	        ),
	        weekdays: 'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার'.split(
	            '_'
	        ),
	        weekdaysShort: 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি'.split('_'),
	        weekdaysMin: 'রবি_সোম_মঙ্গল_বুধ_বৃহ_শুক্র_শনি'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm সময়',
	            LTS: 'A h:mm:ss সময়',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm সময়',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm সময়',
	        },
	        calendar: {
	            sameDay: '[আজ] LT',
	            nextDay: '[আগামীকাল] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[গতকাল] LT',
	            lastWeek: '[গত] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s পরে',
	            past: '%s আগে',
	            s: 'কয়েক সেকেন্ড',
	            ss: '%d সেকেন্ড',
	            m: 'এক মিনিট',
	            mm: '%d মিনিট',
	            h: 'এক ঘন্টা',
	            hh: '%d ঘন্টা',
	            d: 'এক দিন',
	            dd: '%d দিন',
	            M: 'এক মাস',
	            MM: '%d মাস',
	            y: 'এক বছর',
	            yy: '%d বছর',
	        },
	        preparse: function (string) {
	            return string.replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /রাত|সকাল|দুপুর|বিকাল|রাত/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (
	                (meridiem === 'রাত' && hour >= 4) ||
	                (meridiem === 'দুপুর' && hour < 5) ||
	                meridiem === 'বিকাল'
	            ) {
	                return hour + 12;
	            } else {
	                return hour;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'রাত';
	            } else if (hour < 10) {
	                return 'সকাল';
	            } else if (hour < 17) {
	                return 'দুপুর';
	            } else if (hour < 20) {
	                return 'বিকাল';
	            } else {
	                return 'রাত';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return bn;
	
	})));


/***/ }),
/* 1036 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bengali (Bangladesh) [bn-bd]
	//! author : Asraf Hossain Patoary : https://github.com/ashwoolford
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1021)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '১',
	            2: '২',
	            3: '৩',
	            4: '৪',
	            5: '৫',
	            6: '৬',
	            7: '৭',
	            8: '৮',
	            9: '৯',
	            0: '০',
	        },
	        numberMap = {
	            '১': '1',
	            '২': '2',
	            '৩': '3',
	            '৪': '4',
	            '৫': '5',
	            '৬': '6',
	            '৭': '7',
	            '৮': '8',
	            '৯': '9',
	            '০': '0',
	        };
	
	    var bnBd = moment.defineLocale('bn-bd', {
	        months: 'জানুয়ারি_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split(
	            '_'
	        ),
	        monthsShort: 'জানু_ফেব্রু_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্ট_অক্টো_নভে_ডিসে'.split(
	            '_'
	        ),
	        weekdays: 'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার'.split(
	            '_'
	        ),
	        weekdaysShort: 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি'.split('_'),
	        weekdaysMin: 'রবি_সোম_মঙ্গল_বুধ_বৃহ_শুক্র_শনি'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm সময়',
	            LTS: 'A h:mm:ss সময়',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm সময়',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm সময়',
	        },
	        calendar: {
	            sameDay: '[আজ] LT',
	            nextDay: '[আগামীকাল] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[গতকাল] LT',
	            lastWeek: '[গত] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s পরে',
	            past: '%s আগে',
	            s: 'কয়েক সেকেন্ড',
	            ss: '%d সেকেন্ড',
	            m: 'এক মিনিট',
	            mm: '%d মিনিট',
	            h: 'এক ঘন্টা',
	            hh: '%d ঘন্টা',
	            d: 'এক দিন',
	            dd: '%d দিন',
	            M: 'এক মাস',
	            MM: '%d মাস',
	            y: 'এক বছর',
	            yy: '%d বছর',
	        },
	        preparse: function (string) {
	            return string.replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	
	        meridiemParse: /রাত|ভোর|সকাল|দুপুর|বিকাল|সন্ধ্যা|রাত/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'রাত') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'ভোর') {
	                return hour;
	            } else if (meridiem === 'সকাল') {
	                return hour;
	            } else if (meridiem === 'দুপুর') {
	                return hour >= 3 ? hour : hour + 12;
	            } else if (meridiem === 'বিকাল') {
	                return hour + 12;
	            } else if (meridiem === 'সন্ধ্যা') {
	                return hour + 12;
	            }
	        },
	
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'রাত';
	            } else if (hour < 6) {
	                return 'ভোর';
	            } else if (hour < 12) {
	                return 'সকাল';
	            } else if (hour < 15) {
	                return 'দুপুর';
	            } else if (hour < 18) {
	                return 'বিকাল';
	            } else if (hour < 20) {
	                return 'সন্ধ্যা';
	            } else {
	                return 'রাত';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return bnBd;
	
	})));


/***/ }),
/* 1037 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tibetan [bo]
	//! author : Thupten N. Chakrishar : https://github.com/vajradog
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1021)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '༡',
	            2: '༢',
	            3: '༣',
	            4: '༤',
	            5: '༥',
	            6: '༦',
	            7: '༧',
	            8: '༨',
	            9: '༩',
	            0: '༠',
	        },
	        numberMap = {
	            '༡': '1',
	            '༢': '2',
	            '༣': '3',
	            '༤': '4',
	            '༥': '5',
	            '༦': '6',
	            '༧': '7',
	            '༨': '8',
	            '༩': '9',
	            '༠': '0',
	        };
	
	    var bo = moment.defineLocale('bo', {
	        months: 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split(
	            '_'
	        ),
	        monthsShort: 'ཟླ་1_ཟླ་2_ཟླ་3_ཟླ་4_ཟླ་5_ཟླ་6_ཟླ་7_ཟླ་8_ཟླ་9_ཟླ་10_ཟླ་11_ཟླ་12'.split(
	            '_'
	        ),
	        monthsShortRegex: /^(ཟླ་\d{1,2})/,
	        monthsParseExact: true,
	        weekdays: 'གཟའ་ཉི་མ་_གཟའ་ཟླ་བ་_གཟའ་མིག་དམར་_གཟའ་ལྷག་པ་_གཟའ་ཕུར་བུ_གཟའ་པ་སངས་_གཟའ་སྤེན་པ་'.split(
	            '_'
	        ),
	        weekdaysShort: 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split(
	            '_'
	        ),
	        weekdaysMin: 'ཉི_ཟླ_མིག_ལྷག_ཕུར_སངས_སྤེན'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm',
	            LTS: 'A h:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm',
	        },
	        calendar: {
	            sameDay: '[དི་རིང] LT',
	            nextDay: '[སང་ཉིན] LT',
	            nextWeek: '[བདུན་ཕྲག་རྗེས་མ], LT',
	            lastDay: '[ཁ་སང] LT',
	            lastWeek: '[བདུན་ཕྲག་མཐའ་མ] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s ལ་',
	            past: '%s སྔན་ལ',
	            s: 'ལམ་སང',
	            ss: '%d སྐར་ཆ།',
	            m: 'སྐར་མ་གཅིག',
	            mm: '%d སྐར་མ',
	            h: 'ཆུ་ཚོད་གཅིག',
	            hh: '%d ཆུ་ཚོད',
	            d: 'ཉིན་གཅིག',
	            dd: '%d ཉིན་',
	            M: 'ཟླ་བ་གཅིག',
	            MM: '%d ཟླ་བ',
	            y: 'ལོ་གཅིག',
	            yy: '%d ལོ',
	        },
	        preparse: function (string) {
	            return string.replace(/[༡༢༣༤༥༦༧༨༩༠]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /མཚན་མོ|ཞོགས་ཀས|ཉིན་གུང|དགོང་དག|མཚན་མོ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (
	                (meridiem === 'མཚན་མོ' && hour >= 4) ||
	                (meridiem === 'ཉིན་གུང' && hour < 5) ||
	                meridiem === 'དགོང་དག'
	            ) {
	                return hour + 12;
	            } else {
	                return hour;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'མཚན་མོ';
	            } else if (hour < 10) {
	                return 'ཞོགས་ཀས';
	            } else if (hour < 17) {
	                return 'ཉིན་གུང';
	            } else if (hour < 20) {
	                return 'དགོང་དག';
	            } else {
	                return 'མཚན་མོ';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return bo;
	
	})));


/***/ }),
/* 1038 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Breton [br]
	//! author : Jean-Baptiste Le Duigou : https://github.com/jbleduigou
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1021)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function relativeTimeWithMutation(number, withoutSuffix, key) {
	        var format = {
	            mm: 'munutenn',
	            MM: 'miz',
	            dd: 'devezh',
	        };
	        return number + ' ' + mutation(format[key], number);
	    }
	    function specialMutationForYears(number) {
	        switch (lastNumber(number)) {
	            case 1:
	            case 3:
	            case 4:
	            case 5:
	            case 9:
	                return number + ' bloaz';
	            default:
	                return number + ' vloaz';
	        }
	    }
	    function lastNumber(number) {
	        if (number > 9) {
	            return lastNumber(number % 10);
	        }
	        return number;
	    }
	    function mutation(text, number) {
	        if (number === 2) {
	            return softMutation(text);
	        }
	        return text;
	    }
	    function softMutation(text) {
	        var mutationTable = {
	            m: 'v',
	            b: 'v',
	            d: 'z',
	        };
	        if (mutationTable[text.charAt(0)] === undefined) {
	            return text;
	        }
	        return mutationTable[text.charAt(0)] + text.substring(1);
	    }
	
	    var monthsParse = [
	            /^gen/i,
	            /^c[ʼ\']hwe/i,
	            /^meu/i,
	            /^ebr/i,
	            /^mae/i,
	            /^(mez|eve)/i,
	            /^gou/i,
	            /^eos/i,
	            /^gwe/i,
	            /^her/i,
	            /^du/i,
	            /^ker/i,
	        ],
	        monthsRegex = /^(genver|c[ʼ\']hwevrer|meurzh|ebrel|mae|mezheven|gouere|eost|gwengolo|here|du|kerzu|gen|c[ʼ\']hwe|meu|ebr|mae|eve|gou|eos|gwe|her|du|ker)/i,
	        monthsStrictRegex = /^(genver|c[ʼ\']hwevrer|meurzh|ebrel|mae|mezheven|gouere|eost|gwengolo|here|du|kerzu)/i,
	        monthsShortStrictRegex = /^(gen|c[ʼ\']hwe|meu|ebr|mae|eve|gou|eos|gwe|her|du|ker)/i,
	        fullWeekdaysParse = [
	            /^sul/i,
	            /^lun/i,
	            /^meurzh/i,
	            /^merc[ʼ\']her/i,
	            /^yaou/i,
	            /^gwener/i,
	            /^sadorn/i,
	        ],
	        shortWeekdaysParse = [
	            /^Sul/i,
	            /^Lun/i,
	            /^Meu/i,
	            /^Mer/i,
	            /^Yao/i,
	            /^Gwe/i,
	            /^Sad/i,
	        ],
	        minWeekdaysParse = [
	            /^Su/i,
	            /^Lu/i,
	            /^Me([^r]|$)/i,
	            /^Mer/i,
	            /^Ya/i,
	            /^Gw/i,
	            /^Sa/i,
	        ];
	
	    var br = moment.defineLocale('br', {
	        months: 'Genver_Cʼhwevrer_Meurzh_Ebrel_Mae_Mezheven_Gouere_Eost_Gwengolo_Here_Du_Kerzu'.split(
	            '_'
	        ),
	        monthsShort: 'Gen_Cʼhwe_Meu_Ebr_Mae_Eve_Gou_Eos_Gwe_Her_Du_Ker'.split('_'),
	        weekdays: 'Sul_Lun_Meurzh_Mercʼher_Yaou_Gwener_Sadorn'.split('_'),
	        weekdaysShort: 'Sul_Lun_Meu_Mer_Yao_Gwe_Sad'.split('_'),
	        weekdaysMin: 'Su_Lu_Me_Mer_Ya_Gw_Sa'.split('_'),
	        weekdaysParse: minWeekdaysParse,
	        fullWeekdaysParse: fullWeekdaysParse,
	        shortWeekdaysParse: shortWeekdaysParse,
	        minWeekdaysParse: minWeekdaysParse,
	
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex: monthsStrictRegex,
	        monthsShortStrictRegex: monthsShortStrictRegex,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [a viz] MMMM YYYY',
	            LLL: 'D [a viz] MMMM YYYY HH:mm',
	            LLLL: 'dddd, D [a viz] MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Hiziv da] LT',
	            nextDay: '[Warcʼhoazh da] LT',
	            nextWeek: 'dddd [da] LT',
	            lastDay: '[Decʼh da] LT',
	            lastWeek: 'dddd [paset da] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'a-benn %s',
	            past: '%s ʼzo',
	            s: 'un nebeud segondennoù',
	            ss: '%d eilenn',
	            m: 'ur vunutenn',
	            mm: relativeTimeWithMutation,
	            h: 'un eur',
	            hh: '%d eur',
	            d: 'un devezh',
	            dd: relativeTimeWithMutation,
	            M: 'ur miz',
	            MM: relativeTimeWithMutation,
	            y: 'ur bloaz',
	            yy: specialMutationForYears,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(añ|vet)/,
	        ordinal: function (number) {
	            var output = number === 1 ? 'añ' : 'vet';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	        meridiemParse: /a.m.|g.m./, // goude merenn | a-raok merenn
	        isPM: function (token) {
	            return token === 'g.m.';
	        },
	        meridiem: function (hour, minute, isLower) {
	            return hour < 12 ? 'a.m.' : 'g.m.';
	        },
	    });
	
	    return br;
	
	})));


/***/ }),
/* 1039 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bosnian [bs]
	//! author : Nedim Cholich : https://github.com/frontyard
	//! based on (hr) translation by Bojan Marković
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1021)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function translate(number, withoutSuffix, key) {
	        var result = number + ' ';
	        switch (key) {
	            case 'ss':
	                if (number === 1) {
	                    result += 'sekunda';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sekunde';
	                } else {
	                    result += 'sekundi';
	                }
	                return result;
	            case 'm':
	                return withoutSuffix ? 'jedna minuta' : 'jedne minute';
	            case 'mm':
	                if (number === 1) {
	                    result += 'minuta';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'minute';
	                } else {
	                    result += 'minuta';
	                }
	                return result;
	            case 'h':
	                return withoutSuffix ? 'jedan sat' : 'jednog sata';
	            case 'hh':
	                if (number === 1) {
	                    result += 'sat';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sata';
	                } else {
	                    result += 'sati';
	                }
	                return result;
	            case 'dd':
	                if (number === 1) {
	                    result += 'dan';
	                } else {
	                    result += 'dana';
	                }
	                return result;
	            case 'MM':
	                if (number === 1) {
	                    result += 'mjesec';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'mjeseca';
	                } else {
	                    result += 'mjeseci';
	                }
	                return result;
	            case 'yy':
	                if (number === 1) {
	                    result += 'godina';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'godine';
	                } else {
	                    result += 'godina';
	                }
	                return result;
	        }
	    }
	
	    var bs = moment.defineLocale('bs', {
	        months: 'januar_februar_mart_april_maj_juni_juli_august_septembar_oktobar_novembar_decembar'.split(
	            '_'
	        ),
	        monthsShort: 'jan._feb._mar._apr._maj._jun._jul._aug._sep._okt._nov._dec.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split(
	            '_'
	        ),
	        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[danas u] LT',
	            nextDay: '[sutra u] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedjelju] [u] LT';
	                    case 3:
	                        return '[u] [srijedu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay: '[jučer u] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                        return '[prošlu] dddd [u] LT';
	                    case 6:
	                        return '[prošle] [subote] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[prošli] dddd [u] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: 'prije %s',
	            s: 'par sekundi',
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: 'dan',
	            dd: translate,
	            M: 'mjesec',
	            MM: translate,
	            y: 'godinu',
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return bs;
	
	})));


/***/ }),
/* 1040 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Catalan [ca]
	//! author : Juan G. Hurtado : https://github.com/juanghurtado
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1021)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ca = moment.defineLocale('ca', {
	        months: {
	            standalone: 'gener_febrer_març_abril_maig_juny_juliol_agost_setembre_octubre_novembre_desembre'.split(
	                '_'
	            ),
	            format: "de gener_de febrer_de març_d'abril_de maig_de juny_de juliol_d'agost_de setembre_d'octubre_de novembre_de desembre".split(
	                '_'
	            ),
	            isFormat: /D[oD]?(\s)+MMMM/,
	        },
	        monthsShort: 'gen._febr._març_abr._maig_juny_jul._ag._set._oct._nov._des.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'diumenge_dilluns_dimarts_dimecres_dijous_divendres_dissabte'.split(
	            '_'
	        ),
	        weekdaysShort: 'dg._dl._dt._dc._dj._dv._ds.'.split('_'),
	        weekdaysMin: 'dg_dl_dt_dc_dj_dv_ds'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM [de] YYYY',
	            ll: 'D MMM YYYY',
	            LLL: 'D MMMM [de] YYYY [a les] H:mm',
	            lll: 'D MMM YYYY, H:mm',
	            LLLL: 'dddd D MMMM [de] YYYY [a les] H:mm',
	            llll: 'ddd D MMM YYYY, H:mm',
	        },
	        calendar: {
	            sameDay: function () {
	                return '[avui a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
	            },
	            nextDay: function () {
	                return '[demà a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
	            },
	            nextWeek: function () {
	                return 'dddd [a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
	            },
	            lastDay: function () {
	                return '[ahir a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
	            },
	            lastWeek: function () {
	                return (
	                    '[el] dddd [passat a ' +
	                    (this.hours() !== 1 ? 'les' : 'la') +
	                    '] LT'
	                );
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: "d'aquí %s",
	            past: 'fa %s',
	            s: 'uns segons',
	            ss: '%d segons',
	            m: 'un minut',
	            mm: '%d minuts',
	            h: 'una hora',
	            hh: '%d hores',
	            d: 'un dia',
	            dd: '%d dies',
	            M: 'un mes',
	            MM: '%d mesos',
	            y: 'un any',
	            yy: '%d anys',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(r|n|t|è|a)/,
	        ordinal: function (number, period) {
	            var output =
	                number === 1
	                    ? 'r'
	                    : number === 2
	                    ? 'n'
	                    : number === 3
	                    ? 'r'
	                    : number === 4
	                    ? 't'
	                    : 'è';
	            if (period === 'w' || period === 'W') {
	                output = 'a';
	            }
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return ca;
	
	})));


/***/ }),
/* 1041 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Czech [cs]
	//! author : petrbela : https://github.com/petrbela
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1021)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var months = 'leden_únor_březen_duben_květen_červen_červenec_srpen_září_říjen_listopad_prosinec'.split(
	            '_'
	        ),
	        monthsShort = 'led_úno_bře_dub_kvě_čvn_čvc_srp_zář_říj_lis_pro'.split('_'),
	        monthsParse = [
	            /^led/i,
	            /^úno/i,
	            /^bře/i,
	            /^dub/i,
	            /^kvě/i,
	            /^(čvn|červen$|června)/i,
	            /^(čvc|červenec|července)/i,
	            /^srp/i,
	            /^zář/i,
	            /^říj/i,
	            /^lis/i,
	            /^pro/i,
	        ],
	        // NOTE: 'červen' is substring of 'červenec'; therefore 'červenec' must precede 'červen' in the regex to be fully matched.
	        // Otherwise parser matches '1. červenec' as '1. červen' + 'ec'.
	        monthsRegex = /^(leden|únor|březen|duben|květen|červenec|července|červen|června|srpen|září|říjen|listopad|prosinec|led|úno|bře|dub|kvě|čvn|čvc|srp|zář|říj|lis|pro)/i;
	
	    function plural(n) {
	        return n > 1 && n < 5 && ~~(n / 10) !== 1;
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's': // a few seconds / in a few seconds / a few seconds ago
	                return withoutSuffix || isFuture ? 'pár sekund' : 'pár sekundami';
	            case 'ss': // 9 seconds / in 9 seconds / 9 seconds ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'sekundy' : 'sekund');
	                } else {
	                    return result + 'sekundami';
	                }
	            case 'm': // a minute / in a minute / a minute ago
	                return withoutSuffix ? 'minuta' : isFuture ? 'minutu' : 'minutou';
	            case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'minuty' : 'minut');
	                } else {
	                    return result + 'minutami';
	                }
	            case 'h': // an hour / in an hour / an hour ago
	                return withoutSuffix ? 'hodina' : isFuture ? 'hodinu' : 'hodinou';
	            case 'hh': // 9 hours / in 9 hours / 9 hours ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'hodiny' : 'hodin');
	                } else {
	                    return result + 'hodinami';
	                }
	            case 'd': // a day / in a day / a day ago
	                return withoutSuffix || isFuture ? 'den' : 'dnem';
	            case 'dd': // 9 days / in 9 days / 9 days ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'dny' : 'dní');
	                } else {
	                    return result + 'dny';
	                }
	            case 'M': // a month / in a month / a month ago
	                return withoutSuffix || isFuture ? 'měsíc' : 'měsícem';
	            case 'MM': // 9 months / in 9 months / 9 months ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'měsíce' : 'měsíců');
	                } else {
	                    return result + 'měsíci';
	                }
	            case 'y': // a year / in a year / a year ago
	                return withoutSuffix || isFuture ? 'rok' : 'rokem';
	            case 'yy': // 9 years / in 9 years / 9 years ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'roky' : 'let');
	                } else {
	                    return result + 'lety';
	                }
	        }
	    }
	
	    var cs = moment.defineLocale('cs', {
	        months: months,
	        monthsShort: monthsShort,
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        // NOTE: 'červen' is substring of 'červenec'; therefore 'červenec' must precede 'červen' in the regex to be fully matched.
	        // Otherwise parser matches '1. červenec' as '1. červen' + 'ec'.
	        monthsStrictRegex: /^(leden|ledna|února|únor|březen|března|duben|dubna|květen|května|červenec|července|červen|června|srpen|srpna|září|říjen|října|listopadu|listopad|prosinec|prosince)/i,
	        monthsShortStrictRegex: /^(led|úno|bře|dub|kvě|čvn|čvc|srp|zář|říj|lis|pro)/i,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays: 'neděle_pondělí_úterý_středa_čtvrtek_pátek_sobota'.split('_'),
	        weekdaysShort: 'ne_po_út_st_čt_pá_so'.split('_'),
	        weekdaysMin: 'ne_po_út_st_čt_pá_so'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd D. MMMM YYYY H:mm',
	            l: 'D. M. YYYY',
	        },
	        calendar: {
	            sameDay: '[dnes v] LT',
	            nextDay: '[zítra v] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[v neděli v] LT';
	                    case 1:
	                    case 2:
	                        return '[v] dddd [v] LT';
	                    case 3:
	                        return '[ve středu v] LT';
	                    case 4:
	                        return '[ve čtvrtek v] LT';
	                    case 5:
	                        return '[v pátek v] LT';
	                    case 6:
	                        return '[v sobotu v] LT';
	                }
	            },
	            lastDay: '[včera v] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[minulou neděli v] LT';
	                    case 1:
	                    case 2:
	                        return '[minulé] dddd [v] LT';
	                    case 3:
	                        return '[minulou středu v] LT';
	                    case 4:
	                    case 5:
	                        return '[minulý] dddd [v] LT';
	                    case 6:
	                        return '[minulou sobotu v] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: 'před %s',
	            s: translate,
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: translate,
	            dd: translate,
	            M: translate,
	            MM: translate,
	            y: translate,
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return cs;
	
	})));


/***/ }),
/* 1042 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chuvash [cv]
	//! author : Anatoly Mironov : https://github.com/mirontoli
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1021)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var cv = moment.defineLocale('cv', {
	        months: 'кӑрлач_нарӑс_пуш_ака_май_ҫӗртме_утӑ_ҫурла_авӑн_юпа_чӳк_раштав'.split(
	            '_'
	        ),
	        monthsShort: 'кӑр_нар_пуш_ака_май_ҫӗр_утӑ_ҫур_авн_юпа_чӳк_раш'.split('_'),
	        weekdays: 'вырсарникун_тунтикун_ытларикун_юнкун_кӗҫнерникун_эрнекун_шӑматкун'.split(
	            '_'
	        ),
	        weekdaysShort: 'выр_тун_ытл_юн_кӗҫ_эрн_шӑм'.split('_'),
	        weekdaysMin: 'вр_тн_ыт_юн_кҫ_эр_шм'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD-MM-YYYY',
	            LL: 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ]',
	            LLL: 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm',
	            LLLL: 'dddd, YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm',
	        },
	        calendar: {
	            sameDay: '[Паян] LT [сехетре]',
	            nextDay: '[Ыран] LT [сехетре]',
	            lastDay: '[Ӗнер] LT [сехетре]',
	            nextWeek: '[Ҫитес] dddd LT [сехетре]',
	            lastWeek: '[Иртнӗ] dddd LT [сехетре]',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: function (output) {
	                var affix = /сехет$/i.exec(output)
	                    ? 'рен'
	                    : /ҫул$/i.exec(output)
	                    ? 'тан'
	                    : 'ран';
	                return output + affix;
	            },
	            past: '%s каялла',
	            s: 'пӗр-ик ҫеккунт',
	            ss: '%d ҫеккунт',
	            m: 'пӗр минут',
	            mm: '%d минут',
	            h: 'пӗр сехет',
	            hh: '%d сехет',
	            d: 'пӗр кун',
	            dd: '%d кун',
	            M: 'пӗр уйӑх',
	            MM: '%d уйӑх',
	            y: 'пӗр ҫул',
	            yy: '%d ҫул',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-мӗш/,
	        ordinal: '%d-мӗш',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return cv;
	
	})));


/***/ }),
/* 1043 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Welsh [cy]
	//! author : Robert Allen : https://github.com/robgallen
	//! author : https://github.com/ryangreaves
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1021)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var cy = moment.defineLocale('cy', {
	        months: 'Ionawr_Chwefror_Mawrth_Ebrill_Mai_Mehefin_Gorffennaf_Awst_Medi_Hydref_Tachwedd_Rhagfyr'.split(
	            '_'
	        ),
	        monthsShort: 'Ion_Chwe_Maw_Ebr_Mai_Meh_Gor_Aws_Med_Hyd_Tach_Rhag'.split(
	            '_'
	        ),
	        weekdays: 'Dydd Sul_Dydd Llun_Dydd Mawrth_Dydd Mercher_Dydd Iau_Dydd Gwener_Dydd Sadwrn'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sul_Llun_Maw_Mer_Iau_Gwe_Sad'.split('_'),
	        weekdaysMin: 'Su_Ll_Ma_Me_Ia_Gw_Sa'.split('_'),
	        weekdaysParseExact: true,
	        // time formats are the same as en-gb
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Heddiw am] LT',
	            nextDay: '[Yfory am] LT',
	            nextWeek: 'dddd [am] LT',
	            lastDay: '[Ddoe am] LT',
	            lastWeek: 'dddd [diwethaf am] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'mewn %s',
	            past: '%s yn ôl',
	            s: 'ychydig eiliadau',
	            ss: '%d eiliad',
	            m: 'munud',
	            mm: '%d munud',
	            h: 'awr',
	            hh: '%d awr',
	            d: 'diwrnod',
	            dd: '%d diwrnod',
	            M: 'mis',
	            MM: '%d mis',
	            y: 'blwyddyn',
	            yy: '%d flynedd',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(fed|ain|af|il|ydd|ed|eg)/,
	        // traditional ordinal numbers above 31 are not commonly used in colloquial Welsh
	        ordinal: function (number) {
	            var b = number,
	                output = '',
	                lookup = [
	                    '',
	                    'af',
	                    'il',
	                    'ydd',
	                    'ydd',
	                    'ed',
	                    'ed',
	                    'ed',
	                    'fed',
	                    'fed',
	                    'fed', // 1af to 10fed
	                    'eg',
	                    'fed',
	                    'eg',
	                    'eg',
	                    'fed',
	                    'eg',
	                    'eg',
	                    'fed',
	                    'eg',
	                    'fed', // 11eg to 20fed
	                ];
	            if (b > 20) {
	                if (b === 40 || b === 50 || b === 60 || b === 80 || b === 100) {
	                    output = 'fed'; // not 30ain, 70ain or 90ain
	                } else {
	                    output = 'ain';
	                }
	            } else if (b > 0) {
	                output = lookup[b];
	            }
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return cy;
	
	})));


/***/ }),
/* 1044 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Danish [da]
	//! author : Ulrik Nielsen : https://github.com/mrbase
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1021)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var da = moment.defineLocale('da', {
	        months: 'januar_februar_marts_april_maj_juni_juli_august_september_oktober_november_december'.split(
	            '_'
	        ),
	        monthsShort: 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	        weekdays: 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
	        weekdaysShort: 'søn_man_tir_ons_tor_fre_lør'.split('_'),
	        weekdaysMin: 'sø_ma_ti_on_to_fr_lø'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY HH:mm',
	            LLLL: 'dddd [d.] D. MMMM YYYY [kl.] HH:mm',
	        },
	        calendar: {
	            sameDay: '[i dag kl.] LT',
	            nextDay: '[i morgen kl.] LT',
	            nextWeek: 'på dddd [kl.] LT',
	            lastDay: '[i går kl.] LT',
	            lastWeek: '[i] dddd[s kl.] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'om %s',
	            past: '%s siden',
	            s: 'få sekunder',
	            ss: '%d sekunder',
	            m: 'et minut',
	            mm: '%d minutter',
	            h: 'en time',
	            hh: '%d timer',
	            d: 'en dag',
	            dd: '%d dage',
	            M: 'en måned',
	            MM: '%d måneder',
	            y: 'et år',
	            yy: '%d år',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return da;
	
	})));


/***/ }),
/* 1045 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : German [de]
	//! author : lluchs : https://github.com/lluchs
	//! author: Menelion Elensúle: https://github.com/Oire
	//! author : Mikolaj Dadela : https://github.com/mik01aj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1021)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            m: ['eine Minute', 'einer Minute'],
	            h: ['eine Stunde', 'einer Stunde'],
	            d: ['ein Tag', 'einem Tag'],
	            dd: [number + ' Tage', number + ' Tagen'],
	            w: ['eine Woche', 'einer Woche'],
	            M: ['ein Monat', 'einem Monat'],
	            MM: [number + ' Monate', number + ' Monaten'],
	            y: ['ein Jahr', 'einem Jahr'],
	            yy: [number + ' Jahre', number + ' Jahren'],
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	
	    var de = moment.defineLocale('de', {
	        months: 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split(
	            '_'
	        ),
	        monthsShort: 'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split(
	            '_'
	        ),
	        weekdaysShort: 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
	        weekdaysMin: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY HH:mm',
	            LLLL: 'dddd, D. MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[heute um] LT [Uhr]',
	            sameElse: 'L',
	            nextDay: '[morgen um] LT [Uhr]',
	            nextWeek: 'dddd [um] LT [Uhr]',
	            lastDay: '[gestern um] LT [Uhr]',
	            lastWeek: '[letzten] dddd [um] LT [Uhr]',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: 'vor %s',
	            s: 'ein paar Sekunden',
	            ss: '%d Sekunden',
	            m: processRelativeTime,
	            mm: '%d Minuten',
	            h: processRelativeTime,
	            hh: '%d Stunden',
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            w: processRelativeTime,
	            ww: '%d Wochen',
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return de;
	
	})));


/***/ }),
/* 1046 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : German (Austria) [de-at]
	//! author : lluchs : https://github.com/lluchs
	//! author: Menelion Elensúle: https://github.com/Oire
	//! author : Martin Groller : https://github.com/MadMG
	//! author : Mikolaj Dadela : https://github.com/mik01aj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1021)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            m: ['eine Minute', 'einer Minute'],
	            h: ['eine Stunde', 'einer Stunde'],
	            d: ['ein Tag', 'einem Tag'],
	            dd: [number + ' Tage', number + ' Tagen'],
	            w: ['eine Woche', 'einer Woche'],
	            M: ['ein Monat', 'einem Monat'],
	            MM: [number + ' Monate', number + ' Monaten'],
	            y: ['ein Jahr', 'einem Jahr'],
	            yy: [number + ' Jahre', number + ' Jahren'],
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	
	    var deAt = moment.defineLocale('de-at', {
	        months: 'Jänner_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split(
	            '_'
	        ),
	        monthsShort: 'Jän._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split(
	            '_'
	        ),
	        weekdaysShort: 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
	        weekdaysMin: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY HH:mm',
	            LLLL: 'dddd, D. MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[heute um] LT [Uhr]',
	            sameElse: 'L',
	            nextDay: '[morgen um] LT [Uhr]',
	            nextWeek: 'dddd [um] LT [Uhr]',
	            lastDay: '[gestern um] LT [Uhr]',
	            lastWeek: '[letzten] dddd [um] LT [Uhr]',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: 'vor %s',
	            s: 'ein paar Sekunden',
	            ss: '%d Sekunden',
	            m: processRelativeTime,
	            mm: '%d Minuten',
	            h: processRelativeTime,
	            hh: '%d Stunden',
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            w: processRelativeTime,
	            ww: '%d Wochen',
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return deAt;
	
	})));


/***/ }),
/* 1047 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : German (Switzerland) [de-ch]
	//! author : sschueller : https://github.com/sschueller
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1021)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            m: ['eine Minute', 'einer Minute'],
	            h: ['eine Stunde', 'einer Stunde'],
	            d: ['ein Tag', 'einem Tag'],
	            dd: [number + ' Tage', number + ' Tagen'],
	            w: ['eine Woche', 'einer Woche'],
	            M: ['ein Monat', 'einem Monat'],
	            MM: [number + ' Monate', number + ' Monaten'],
	            y: ['ein Jahr', 'einem Jahr'],
	            yy: [number + ' Jahre', number + ' Jahren'],
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	
	    var deCh = moment.defineLocale('de-ch', {
	        months: 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split(
	            '_'
	        ),
	        monthsShort: 'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split(
	            '_'
	        ),
	        weekdaysShort: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysMin: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY HH:mm',
	            LLLL: 'dddd, D. MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[heute um] LT [Uhr]',
	            sameElse: 'L',
	            nextDay: '[morgen um] LT [Uhr]',
	            nextWeek: 'dddd [um] LT [Uhr]',
	            lastDay: '[gestern um] LT [Uhr]',
	            lastWeek: '[letzten] dddd [um] LT [Uhr]',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: 'vor %s',
	            s: 'ein paar Sekunden',
	            ss: '%d Sekunden',
	            m: processRelativeTime,
	            mm: '%d Minuten',
	            h: processRelativeTime,
	            hh: '%d Stunden',
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            w: processRelativeTime,
	            ww: '%d Wochen',
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return deCh;
	
	})));


/***/ }),
/* 1048 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Maldivian [dv]
	//! author : Jawish Hameed : https://github.com/jawish
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1021)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var months = [
	            'ޖެނުއަރީ',
	            'ފެބްރުއަރީ',
	            'މާރިޗު',
	            'އޭޕްރީލު',
	            'މޭ',
	            'ޖޫން',
	            'ޖުލައި',
	            'އޯގަސްޓު',
	            'ސެޕްޓެމްބަރު',
	            'އޮކްޓޯބަރު',
	            'ނޮވެމްބަރު',
	            'ޑިސެމްބަރު',
	        ],
	        weekdays = [
	            'އާދިއްތަ',
	            'ހޯމަ',
	            'އަންގާރަ',
	            'ބުދަ',
	            'ބުރާސްފަތި',
	            'ހުކުރު',
	            'ހޮނިހިރު',
	        ];
	
	    var dv = moment.defineLocale('dv', {
	        months: months,
	        monthsShort: months,
	        weekdays: weekdays,
	        weekdaysShort: weekdays,
	        weekdaysMin: 'އާދި_ހޯމަ_އަން_ބުދަ_ބުރާ_ހުކު_ހޮނި'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'D/M/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /މކ|މފ/,
	        isPM: function (input) {
	            return 'މފ' === input;
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'މކ';
	            } else {
	                return 'މފ';
	            }
	        },
	        calendar: {
	            sameDay: '[މިއަދު] LT',
	            nextDay: '[މާދަމާ] LT',
	            nextWeek: 'dddd LT',
	            lastDay: '[އިއްޔެ] LT',
	            lastWeek: '[ފާއިތުވި] dddd LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'ތެރޭގައި %s',
	            past: 'ކުރިން %s',
	            s: 'ސިކުންތުކޮޅެއް',
	            ss: 'd% ސިކުންތު',
	            m: 'މިނިޓެއް',
	            mm: 'މިނިޓު %d',
	            h: 'ގަޑިއިރެއް',
	            hh: 'ގަޑިއިރު %d',
	            d: 'ދުވަހެއް',
	            dd: 'ދުވަސް %d',
	            M: 'މަހެއް',
	            MM: 'މަސް %d',
	            y: 'އަހަރެއް',
	            yy: 'އަހަރު %d',
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week: {
	            dow: 7, // Sunday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return dv;
	
	})));


/***/ }),
/* 1049 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Greek [el]
	//! author : Aggelos Karalias : https://github.com/mehiel
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1021)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function isFunction(input) {
	        return (
	            (typeof Function !== 'undefined' && input instanceof Function) ||
	            Object.prototype.toString.call(input) === '[object Function]'
	        );
	    }
	
	    var el = moment.defineLocale('el', {
	        monthsNominativeEl: 'Ιανουάριος_Φεβρουάριος_Μάρτιος_Απρίλιος_Μάιος_Ιούνιος_Ιούλιος_Αύγουστος_Σεπτέμβριος_Οκτώβριος_Νοέμβριος_Δεκέμβριος'.split(
	            '_'
	        ),
	        monthsGenitiveEl: 'Ιανουαρίου_Φεβρουαρίου_Μαρτίου_Απριλίου_Μαΐου_Ιουνίου_Ιουλίου_Αυγούστου_Σεπτεμβρίου_Οκτωβρίου_Νοεμβρίου_Δεκεμβρίου'.split(
	            '_'
	        ),
	        months: function (momentToFormat, format) {
	            if (!momentToFormat) {
	                return this._monthsNominativeEl;
	            } else if (
	                typeof format === 'string' &&
	                /D/.test(format.substring(0, format.indexOf('MMMM')))
	            ) {
	                // if there is a day number before 'MMMM'
	                return this._monthsGenitiveEl[momentToFormat.month()];
	            } else {
	                return this._monthsNominativeEl[momentToFormat.month()];
	            }
	        },
	        monthsShort: 'Ιαν_Φεβ_Μαρ_Απρ_Μαϊ_Ιουν_Ιουλ_Αυγ_Σεπ_Οκτ_Νοε_Δεκ'.split('_'),
	        weekdays: 'Κυριακή_Δευτέρα_Τρίτη_Τετάρτη_Πέμπτη_Παρασκευή_Σάββατο'.split(
	            '_'
	        ),
	        weekdaysShort: 'Κυρ_Δευ_Τρι_Τετ_Πεμ_Παρ_Σαβ'.split('_'),
	        weekdaysMin: 'Κυ_Δε_Τρ_Τε_Πε_Πα_Σα'.split('_'),
	        meridiem: function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'μμ' : 'ΜΜ';
	            } else {
	                return isLower ? 'πμ' : 'ΠΜ';
	            }
	        },
	        isPM: function (input) {
	            return (input + '').toLowerCase()[0] === 'μ';
	        },
	        meridiemParse: /[ΠΜ]\.?Μ?\.?/i,
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY h:mm A',
	            LLLL: 'dddd, D MMMM YYYY h:mm A',
	        },
	        calendarEl: {
	            sameDay: '[Σήμερα {}] LT',
	            nextDay: '[Αύριο {}] LT',
	            nextWeek: 'dddd [{}] LT',
	            lastDay: '[Χθες {}] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 6:
	                        return '[το προηγούμενο] dddd [{}] LT';
	                    default:
	                        return '[την προηγούμενη] dddd [{}] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        calendar: function (key, mom) {
	            var output = this._calendarEl[key],
	                hours = mom && mom.hours();
	            if (isFunction(output)) {
	                output = output.apply(mom);
	            }
	            return output.replace('{}', hours % 12 === 1 ? 'στη' : 'στις');
	        },
	        relativeTime: {
	            future: 'σε %s',
	            past: '%s πριν',
	            s: 'λίγα δευτερόλεπτα',
	            ss: '%d δευτερόλεπτα',
	            m: 'ένα λεπτό',
	            mm: '%d λεπτά',
	            h: 'μία ώρα',
	            hh: '%d ώρες',
	            d: 'μία μέρα',
	            dd: '%d μέρες',
	            M: 'ένας μήνας',
	            MM: '%d μήνες',
	            y: 'ένας χρόνος',
	            yy: '%d χρόνια',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}η/,
	        ordinal: '%dη',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4st is the first week of the year.
	        },
	    });
	
	    return el;
	
	})));


/***/ }),
/* 1050 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Australia) [en-au]
	//! author : Jared Morse : https://github.com/jarcoal
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1021)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enAu = moment.defineLocale('en-au', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY h:mm A',
	            LLLL: 'dddd, D MMMM YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return enAu;
	
	})));


/***/ }),
/* 1051 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Canada) [en-ca]
	//! author : Jonathan Abourbih : https://github.com/jonbca
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1021)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enCa = moment.defineLocale('en-ca', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'YYYY-MM-DD',
	            LL: 'MMMM D, YYYY',
	            LLL: 'MMMM D, YYYY h:mm A',
	            LLLL: 'dddd, MMMM D, YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	    });
	
	    return enCa;
	
	})));


/***/ }),
/* 1052 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (United Kingdom) [en-gb]
	//! author : Chris Gedrim : https://github.com/chrisgedrim
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1021)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enGb = moment.defineLocale('en-gb', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return enGb;
	
	})));


/***/ }),
/* 1053 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Ireland) [en-ie]
	//! author : Chris Cartlidge : https://github.com/chriscartlidge
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1021)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enIe = moment.defineLocale('en-ie', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return enIe;
	
	})));


/***/ }),
/* 1054 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Israel) [en-il]
	//! author : Chris Gedrim : https://github.com/chrisgedrim
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1021)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enIl = moment.defineLocale('en-il', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	    });
	
	    return enIl;
	
	})));


/***/ }),
/* 1055 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (India) [en-in]
	//! author : Jatin Agrawal : https://github.com/jatinag22
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1021)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enIn = moment.defineLocale('en-in', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY h:mm A',
	            LLLL: 'dddd, D MMMM YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 1st is the first week of the year.
	        },
	    });
	
	    return enIn;
	
	})));


/***/ }),
/* 1056 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (New Zealand) [en-nz]
	//! author : Luke McGregor : https://github.com/lukemcgregor
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1021)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enNz = moment.defineLocale('en-nz', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY h:mm A',
	            LLLL: 'dddd, D MMMM YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return enNz;
	
	})));


/***/ }),
/* 1057 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Singapore) [en-sg]
	//! author : Matthew Castrillon-Madrigal : https://github.com/techdimension
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1021)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enSg = moment.defineLocale('en-sg', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return enSg;
	
	})));


/***/ }),
/* 1058 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Esperanto [eo]
	//! author : Colin Dean : https://github.com/colindean
	//! author : Mia Nordentoft Imperatori : https://github.com/miestasmia
	//! comment : miestasmia corrected the translation by colindean
	//! comment : Vivakvo corrected the translation by colindean and miestasmia
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1021)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var eo = moment.defineLocale('eo', {
	        months: 'januaro_februaro_marto_aprilo_majo_junio_julio_aŭgusto_septembro_oktobro_novembro_decembro'.split(
	            '_'
	        ),
	        monthsShort: 'jan_feb_mart_apr_maj_jun_jul_aŭg_sept_okt_nov_dec'.split('_'),
	        weekdays: 'dimanĉo_lundo_mardo_merkredo_ĵaŭdo_vendredo_sabato'.split('_'),
	        weekdaysShort: 'dim_lun_mard_merk_ĵaŭ_ven_sab'.split('_'),
	        weekdaysMin: 'di_lu_ma_me_ĵa_ve_sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: '[la] D[-an de] MMMM, YYYY',
	            LLL: '[la] D[-an de] MMMM, YYYY HH:mm',
	            LLLL: 'dddd[n], [la] D[-an de] MMMM, YYYY HH:mm',
	            llll: 'ddd, [la] D[-an de] MMM, YYYY HH:mm',
	        },
	        meridiemParse: /[ap]\.t\.m/i,
	        isPM: function (input) {
	            return input.charAt(0).toLowerCase() === 'p';
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'p.t.m.' : 'P.T.M.';
	            } else {
	                return isLower ? 'a.t.m.' : 'A.T.M.';
	            }
	        },
	        calendar: {
	            sameDay: '[Hodiaŭ je] LT',
	            nextDay: '[Morgaŭ je] LT',
	            nextWeek: 'dddd[n je] LT',
	            lastDay: '[Hieraŭ je] LT',
	            lastWeek: '[pasintan] dddd[n je] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'post %s',
	            past: 'antaŭ %s',
	            s: 'kelkaj sekundoj',
	            ss: '%d sekundoj',
	            m: 'unu minuto',
	            mm: '%d minutoj',
	            h: 'unu horo',
	            hh: '%d horoj',
	            d: 'unu tago', //ne 'diurno', ĉar estas uzita por proksimumo
	            dd: '%d tagoj',
	            M: 'unu monato',
	            MM: '%d monatoj',
	            y: 'unu jaro',
	            yy: '%d jaroj',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}a/,
	        ordinal: '%da',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return eo;
	
	})));


/***/ }),
/* 1059 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Spanish [es]
	//! author : Julio Napurí : https://github.com/julionc
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1021)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
	            '_'
	        ),
	        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
	        monthsParse = [
	            /^ene/i,
	            /^feb/i,
	            /^mar/i,
	            /^abr/i,
	            /^may/i,
	            /^jun/i,
	            /^jul/i,
	            /^ago/i,
	            /^sep/i,
	            /^oct/i,
	            /^nov/i,
	            /^dic/i,
	        ],
	        monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
	
	    var es = moment.defineLocale('es', {
	        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
	            '_'
	        ),
	        monthsShort: function (m, format) {
	            if (!m) {
	                return monthsShortDot;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShort[m.month()];
	            } else {
	                return monthsShortDot[m.month()];
	            }
	        },
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
	        monthsShortStrictRegex: /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY H:mm',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY H:mm',
	        },
	        calendar: {
	            sameDay: function () {
	                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextDay: function () {
	                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextWeek: function () {
	                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastDay: function () {
	                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastWeek: function () {
	                return (
	                    '[el] dddd [pasado a la' +
	                    (this.hours() !== 1 ? 's' : '') +
	                    '] LT'
	                );
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'en %s',
	            past: 'hace %s',
	            s: 'unos segundos',
	            ss: '%d segundos',
	            m: 'un minuto',
	            mm: '%d minutos',
	            h: 'una hora',
	            hh: '%d horas',
	            d: 'un día',
	            dd: '%d días',
	            w: 'una semana',
	            ww: '%d semanas',
	            M: 'un mes',
	            MM: '%d meses',
	            y: 'un año',
	            yy: '%d años',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	        invalidDate: 'Fecha inválida',
	    });
	
	    return es;
	
	})));


/***/ }),
/* 1060 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Spanish (Dominican Republic) [es-do]
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1021)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
	            '_'
	        ),
	        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
	        monthsParse = [
	            /^ene/i,
	            /^feb/i,
	            /^mar/i,
	            /^abr/i,
	            /^may/i,
	            /^jun/i,
	            /^jul/i,
	            /^ago/i,
	            /^sep/i,
	            /^oct/i,
	            /^nov/i,
	            /^dic/i,
	        ],
	        monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
	
	    var esDo = moment.defineLocale('es-do', {
	        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
	            '_'
	        ),
	        monthsShort: function (m, format) {
	            if (!m) {
	                return monthsShortDot;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShort[m.month()];
	            } else {
	                return monthsShortDot[m.month()];
	            }
	        },
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
	        monthsShortStrictRegex: /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY h:mm A',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: function () {
	                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextDay: function () {
	                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextWeek: function () {
	                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastDay: function () {
	                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastWeek: function () {
	                return (
	                    '[el] dddd [pasado a la' +
	                    (this.hours() !== 1 ? 's' : '') +
	                    '] LT'
	                );
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'en %s',
	            past: 'hace %s',
	            s: 'unos segundos',
	            ss: '%d segundos',
	            m: 'un minuto',
	            mm: '%d minutos',
	            h: 'una hora',
	            hh: '%d horas',
	            d: 'un día',
	            dd: '%d días',
	            w: 'una semana',
	            ww: '%d semanas',
	            M: 'un mes',
	            MM: '%d meses',
	            y: 'un año',
	            yy: '%d años',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return esDo;
	
	})));


/***/ }),
/* 1061 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Spanish (Mexico) [es-mx]
	//! author : JC Franco : https://github.com/jcfranco
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1021)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
	            '_'
	        ),
	        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
	        monthsParse = [
	            /^ene/i,
	            /^feb/i,
	            /^mar/i,
	            /^abr/i,
	            /^may/i,
	            /^jun/i,
	            /^jul/i,
	            /^ago/i,
	            /^sep/i,
	            /^oct/i,
	            /^nov/i,
	            /^dic/i,
	        ],
	        monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
	
	    var esMx = moment.defineLocale('es-mx', {
	        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
	            '_'
	        ),
	        monthsShort: function (m, format) {
	            if (!m) {
	                return monthsShortDot;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShort[m.month()];
	            } else {
	                return monthsShortDot[m.month()];
	            }
	        },
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
	        monthsShortStrictRegex: /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY H:mm',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY H:mm',
	        },
	        calendar: {
	            sameDay: function () {
	                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextDay: function () {
	                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextWeek: function () {
	                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastDay: function () {
	                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastWeek: function () {
	                return (
	                    '[el] dddd [pasado a la' +
	                    (this.hours() !== 1 ? 's' : '') +
	                    '] LT'
	                );
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'en %s',
	            past: 'hace %s',
	            s: 'unos segundos',
	            ss: '%d segundos',
	            m: 'un minuto',
	            mm: '%d minutos',
	            h: 'una hora',
	            hh: '%d horas',
	            d: 'un día',
	            dd: '%d días',
	            w: 'una semana',
	            ww: '%d semanas',
	            M: 'un mes',
	            MM: '%d meses',
	            y: 'un año',
	            yy: '%d años',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	        invalidDate: 'Fecha inválida',
	    });
	
	    return esMx;
	
	})));


/***/ }),
/* 1062 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Spanish (United States) [es-us]
	//! author : bustta : https://github.com/bustta
	//! author : chrisrodz : https://github.com/chrisrodz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1021)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
	            '_'
	        ),
	        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
	        monthsParse = [
	            /^ene/i,
	            /^feb/i,
	            /^mar/i,
	            /^abr/i,
	            /^may/i,
	            /^jun/i,
	            /^jul/i,
	            /^ago/i,
	            /^sep/i,
	            /^oct/i,
	            /^nov/i,
	            /^dic/i,
	        ],
	        monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
	
	    var esUs = moment.defineLocale('es-us', {
	        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
	            '_'
	        ),
	        monthsShort: function (m, format) {
	            if (!m) {
	                return monthsShortDot;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShort[m.month()];
	            } else {
	                return monthsShortDot[m.month()];
	            }
	        },
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
	        monthsShortStrictRegex: /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'MM/DD/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY h:mm A',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: function () {
	                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextDay: function () {
	                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextWeek: function () {
	                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastDay: function () {
	                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastWeek: function () {
	                return (
	                    '[el] dddd [pasado a la' +
	                    (this.hours() !== 1 ? 's' : '') +
	                    '] LT'
	                );
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'en %s',
	            past: 'hace %s',
	            s: 'unos segundos',
	            ss: '%d segundos',
	            m: 'un minuto',
	            mm: '%d minutos',
	            h: 'una hora',
	            hh: '%d horas',
	            d: 'un día',
	            dd: '%d días',
	            w: 'una semana',
	            ww: '%d semanas',
	            M: 'un mes',
	            MM: '%d meses',
	            y: 'un año',
	            yy: '%d años',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return esUs;
	
	})));


/***/ }),
/* 1063 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Estonian [et]
	//! author : Henry Kehlmann : https://github.com/madhenry
	//! improvements : Illimar Tambek : https://github.com/ragulka
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1021)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            s: ['mõne sekundi', 'mõni sekund', 'paar sekundit'],
	            ss: [number + 'sekundi', number + 'sekundit'],
	            m: ['ühe minuti', 'üks minut'],
	            mm: [number + ' minuti', number + ' minutit'],
	            h: ['ühe tunni', 'tund aega', 'üks tund'],
	            hh: [number + ' tunni', number + ' tundi'],
	            d: ['ühe päeva', 'üks päev'],
	            M: ['kuu aja', 'kuu aega', 'üks kuu'],
	            MM: [number + ' kuu', number + ' kuud'],
	            y: ['ühe aasta', 'aasta', 'üks aasta'],
	            yy: [number + ' aasta', number + ' aastat'],
	        };
	        if (withoutSuffix) {
	            return format[key][2] ? format[key][2] : format[key][1];
	        }
	        return isFuture ? format[key][0] : format[key][1];
	    }
	
	    var et = moment.defineLocale('et', {
	        months: 'jaanuar_veebruar_märts_aprill_mai_juuni_juuli_august_september_oktoober_november_detsember'.split(
	            '_'
	        ),
	        monthsShort: 'jaan_veebr_märts_apr_mai_juuni_juuli_aug_sept_okt_nov_dets'.split(
	            '_'
	        ),
	        weekdays: 'pühapäev_esmaspäev_teisipäev_kolmapäev_neljapäev_reede_laupäev'.split(
	            '_'
	        ),
	        weekdaysShort: 'P_E_T_K_N_R_L'.split('_'),
	        weekdaysMin: 'P_E_T_K_N_R_L'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[Täna,] LT',
	            nextDay: '[Homme,] LT',
	            nextWeek: '[Järgmine] dddd LT',
	            lastDay: '[Eile,] LT',
	            lastWeek: '[Eelmine] dddd LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s pärast',
	            past: '%s tagasi',
	            s: processRelativeTime,
	            ss: processRelativeTime,
	            m: processRelativeTime,
	            mm: processRelativeTime,
	            h: processRelativeTime,
	            hh: processRelativeTime,
	            d: processRelativeTime,
	            dd: '%d päeva',
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return et;
	
	})));


/***/ }),
/* 1064 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Basque [eu]
	//! author : Eneko Illarramendi : https://github.com/eillarra
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1021)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var eu = moment.defineLocale('eu', {
	        months: 'urtarrila_otsaila_martxoa_apirila_maiatza_ekaina_uztaila_abuztua_iraila_urria_azaroa_abendua'.split(
	            '_'
	        ),
	        monthsShort: 'urt._ots._mar._api._mai._eka._uzt._abu._ira._urr._aza._abe.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'igandea_astelehena_asteartea_asteazkena_osteguna_ostirala_larunbata'.split(
	            '_'
	        ),
	        weekdaysShort: 'ig._al._ar._az._og._ol._lr.'.split('_'),
	        weekdaysMin: 'ig_al_ar_az_og_ol_lr'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'YYYY[ko] MMMM[ren] D[a]',
	            LLL: 'YYYY[ko] MMMM[ren] D[a] HH:mm',
	            LLLL: 'dddd, YYYY[ko] MMMM[ren] D[a] HH:mm',
	            l: 'YYYY-M-D',
	            ll: 'YYYY[ko] MMM D[a]',
	            lll: 'YYYY[ko] MMM D[a] HH:mm',
	            llll: 'ddd, YYYY[ko] MMM D[a] HH:mm',
	        },
	        calendar: {
	            sameDay: '[gaur] LT[etan]',
	            nextDay: '[bihar] LT[etan]',
	            nextWeek: 'dddd LT[etan]',
	            lastDay: '[atzo] LT[etan]',
	            lastWeek: '[aurreko] dddd LT[etan]',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s barru',
	            past: 'duela %s',
	            s: 'segundo batzuk',
	            ss: '%d segundo',
	            m: 'minutu bat',
	            mm: '%d minutu',
	            h: 'ordu bat',
	            hh: '%d ordu',
	            d: 'egun bat',
	            dd: '%d egun',
	            M: 'hilabete bat',
	            MM: '%d hilabete',
	            y: 'urte bat',
	            yy: '%d urte',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return eu;
	
	})));


/***/ }),
/* 1065 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Persian [fa]
	//! author : Ebrahim Byagowi : https://github.com/ebraminio
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1021)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '۱',
	            2: '۲',
	            3: '۳',
	            4: '۴',
	            5: '۵',
	            6: '۶',
	            7: '۷',
	            8: '۸',
	            9: '۹',
	            0: '۰',
	        },
	        numberMap = {
	            '۱': '1',
	            '۲': '2',
	            '۳': '3',
	            '۴': '4',
	            '۵': '5',
	            '۶': '6',
	            '۷': '7',
	            '۸': '8',
	            '۹': '9',
	            '۰': '0',
	        };
	
	    var fa = moment.defineLocale('fa', {
	        months: 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split(
	            '_'
	        ),
	        monthsShort: 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split(
	            '_'
	        ),
	        weekdays: 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split(
	            '_'
	        ),
	        weekdaysShort: 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split(
	            '_'
	        ),
	        weekdaysMin: 'ی_د_س_چ_پ_ج_ش'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /قبل از ظهر|بعد از ظهر/,
	        isPM: function (input) {
	            return /بعد از ظهر/.test(input);
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'قبل از ظهر';
	            } else {
	                return 'بعد از ظهر';
	            }
	        },
	        calendar: {
	            sameDay: '[امروز ساعت] LT',
	            nextDay: '[فردا ساعت] LT',
	            nextWeek: 'dddd [ساعت] LT',
	            lastDay: '[دیروز ساعت] LT',
	            lastWeek: 'dddd [پیش] [ساعت] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'در %s',
	            past: '%s پیش',
	            s: 'چند ثانیه',
	            ss: '%d ثانیه',
	            m: 'یک دقیقه',
	            mm: '%d دقیقه',
	            h: 'یک ساعت',
	            hh: '%d ساعت',
	            d: 'یک روز',
	            dd: '%d روز',
	            M: 'یک ماه',
	            MM: '%d ماه',
	            y: 'یک سال',
	            yy: '%d سال',
	        },
	        preparse: function (string) {
	            return string
	                .replace(/[۰-۹]/g, function (match) {
	                    return numberMap[match];
	                })
	                .replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string
	                .replace(/\d/g, function (match) {
	                    return symbolMap[match];
	                })
	                .replace(/,/g, '،');
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}م/,
	        ordinal: '%dم',
	        week: {
	            dow: 6, // Saturday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return fa;
	
	})));


/***/ }),
/* 1066 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Finnish [fi]
	//! author : Tarmo Aidantausta : https://github.com/bleadof
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1021)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var numbersPast = 'nolla yksi kaksi kolme neljä viisi kuusi seitsemän kahdeksan yhdeksän'.split(
	            ' '
	        ),
	        numbersFuture = [
	            'nolla',
	            'yhden',
	            'kahden',
	            'kolmen',
	            'neljän',
	            'viiden',
	            'kuuden',
	            numbersPast[7],
	            numbersPast[8],
	            numbersPast[9],
	        ];
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = '';
	        switch (key) {
	            case 's':
	                return isFuture ? 'muutaman sekunnin' : 'muutama sekunti';
	            case 'ss':
	                result = isFuture ? 'sekunnin' : 'sekuntia';
	                break;
	            case 'm':
	                return isFuture ? 'minuutin' : 'minuutti';
	            case 'mm':
	                result = isFuture ? 'minuutin' : 'minuuttia';
	                break;
	            case 'h':
	                return isFuture ? 'tunnin' : 'tunti';
	            case 'hh':
	                result = isFuture ? 'tunnin' : 'tuntia';
	                break;
	            case 'd':
	                return isFuture ? 'päivän' : 'päivä';
	            case 'dd':
	                result = isFuture ? 'päivän' : 'päivää';
	                break;
	            case 'M':
	                return isFuture ? 'kuukauden' : 'kuukausi';
	            case 'MM':
	                result = isFuture ? 'kuukauden' : 'kuukautta';
	                break;
	            case 'y':
	                return isFuture ? 'vuoden' : 'vuosi';
	            case 'yy':
	                result = isFuture ? 'vuoden' : 'vuotta';
	                break;
	        }
	        result = verbalNumber(number, isFuture) + ' ' + result;
	        return result;
	    }
	    function verbalNumber(number, isFuture) {
	        return number < 10
	            ? isFuture
	                ? numbersFuture[number]
	                : numbersPast[number]
	            : number;
	    }
	
	    var fi = moment.defineLocale('fi', {
	        months: 'tammikuu_helmikuu_maaliskuu_huhtikuu_toukokuu_kesäkuu_heinäkuu_elokuu_syyskuu_lokakuu_marraskuu_joulukuu'.split(
	            '_'
	        ),
	        monthsShort: 'tammi_helmi_maalis_huhti_touko_kesä_heinä_elo_syys_loka_marras_joulu'.split(
	            '_'
	        ),
	        weekdays: 'sunnuntai_maanantai_tiistai_keskiviikko_torstai_perjantai_lauantai'.split(
	            '_'
	        ),
	        weekdaysShort: 'su_ma_ti_ke_to_pe_la'.split('_'),
	        weekdaysMin: 'su_ma_ti_ke_to_pe_la'.split('_'),
	        longDateFormat: {
	            LT: 'HH.mm',
	            LTS: 'HH.mm.ss',
	            L: 'DD.MM.YYYY',
	            LL: 'Do MMMM[ta] YYYY',
	            LLL: 'Do MMMM[ta] YYYY, [klo] HH.mm',
	            LLLL: 'dddd, Do MMMM[ta] YYYY, [klo] HH.mm',
	            l: 'D.M.YYYY',
	            ll: 'Do MMM YYYY',
	            lll: 'Do MMM YYYY, [klo] HH.mm',
	            llll: 'ddd, Do MMM YYYY, [klo] HH.mm',
	        },
	        calendar: {
	            sameDay: '[tänään] [klo] LT',
	            nextDay: '[huomenna] [klo] LT',
	            nextWeek: 'dddd [klo] LT',
	            lastDay: '[eilen] [klo] LT',
	            lastWeek: '[viime] dddd[na] [klo] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s päästä',
	            past: '%s sitten',
	            s: translate,
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: translate,
	            dd: translate,
	            M: translate,
	            MM: translate,
	            y: translate,
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return fi;
	
	})));


/***/ }),
/* 1067 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Filipino [fil]
	//! author : Dan Hagman : https://github.com/hagmandan
	//! author : Matthew Co : https://github.com/matthewdeeco
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1021)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var fil = moment.defineLocale('fil', {
	        months: 'Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre'.split(
	            '_'
	        ),
	        monthsShort: 'Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis'.split('_'),
	        weekdays: 'Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado'.split(
	            '_'
	        ),
	        weekdaysShort: 'Lin_Lun_Mar_Miy_Huw_Biy_Sab'.split('_'),
	        weekdaysMin: 'Li_Lu_Ma_Mi_Hu_Bi_Sab'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'MM/D/YYYY',
	            LL: 'MMMM D, YYYY',
	            LLL: 'MMMM D, YYYY HH:mm',
	            LLLL: 'dddd, MMMM DD, YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: 'LT [ngayong araw]',
	            nextDay: '[Bukas ng] LT',
	            nextWeek: 'LT [sa susunod na] dddd',
	            lastDay: 'LT [kahapon]',
	            lastWeek: 'LT [noong nakaraang] dddd',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'sa loob ng %s',
	            past: '%s ang nakalipas',
	            s: 'ilang segundo',
	            ss: '%d segundo',
	            m: 'isang minuto',
	            mm: '%d minuto',
	            h: 'isang oras',
	            hh: '%d oras',
	            d: 'isang araw',
	            dd: '%d araw',
	            M: 'isang buwan',
	            MM: '%d buwan',
	            y: 'isang taon',
	            yy: '%d taon',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}/,
	        ordinal: function (number) {
	            return number;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return fil;
	
	})));


/***/ }),
/* 1068 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Faroese [fo]
	//! author : Ragnar Johannesen : https://github.com/ragnar123
	//! author : Kristian Sakarisson : https://github.com/sakarisson
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1021)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var fo = moment.defineLocale('fo', {
	        months: 'januar_februar_mars_apríl_mai_juni_juli_august_september_oktober_november_desember'.split(
	            '_'
	        ),
	        monthsShort: 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
	        weekdays: 'sunnudagur_mánadagur_týsdagur_mikudagur_hósdagur_fríggjadagur_leygardagur'.split(
	            '_'
	        ),
	        weekdaysShort: 'sun_mán_týs_mik_hós_frí_ley'.split('_'),
	        weekdaysMin: 'su_má_tý_mi_hó_fr_le'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D. MMMM, YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Í dag kl.] LT',
	            nextDay: '[Í morgin kl.] LT',
	            nextWeek: 'dddd [kl.] LT',
	            lastDay: '[Í gjár kl.] LT',
	            lastWeek: '[síðstu] dddd [kl] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'um %s',
	            past: '%s síðani',
	            s: 'fá sekund',
	            ss: '%d sekundir',
	            m: 'ein minuttur',
	            mm: '%d minuttir',
	            h: 'ein tími',
	            hh: '%d tímar',
	            d: 'ein dagur',
	            dd: '%d dagar',
	            M: 'ein mánaður',
	            MM: '%d mánaðir',
	            y: 'eitt ár',
	            yy: '%d ár',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return fo;
	
	})));


/***/ }),
/* 1069 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : French [fr]
	//! author : John Fischer : https://github.com/jfroffice
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1021)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsStrictRegex = /^(janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i,
	        monthsShortStrictRegex = /(janv\.?|févr\.?|mars|avr\.?|mai|juin|juil\.?|août|sept\.?|oct\.?|nov\.?|déc\.?)/i,
	        monthsRegex = /(janv\.?|févr\.?|mars|avr\.?|mai|juin|juil\.?|août|sept\.?|oct\.?|nov\.?|déc\.?|janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i,
	        monthsParse = [
	            /^janv/i,
	            /^févr/i,
	            /^mars/i,
	            /^avr/i,
	            /^mai/i,
	            /^juin/i,
	            /^juil/i,
	            /^août/i,
	            /^sept/i,
	            /^oct/i,
	            /^nov/i,
	            /^déc/i,
	        ];
	
	    var fr = moment.defineLocale('fr', {
	        months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split(
	            '_'
	        ),
	        monthsShort: 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split(
	            '_'
	        ),
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex: monthsStrictRegex,
	        monthsShortStrictRegex: monthsShortStrictRegex,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	        weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	        weekdaysMin: 'di_lu_ma_me_je_ve_sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Aujourd’hui à] LT',
	            nextDay: '[Demain à] LT',
	            nextWeek: 'dddd [à] LT',
	            lastDay: '[Hier à] LT',
	            lastWeek: 'dddd [dernier à] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'dans %s',
	            past: 'il y a %s',
	            s: 'quelques secondes',
	            ss: '%d secondes',
	            m: 'une minute',
	            mm: '%d minutes',
	            h: 'une heure',
	            hh: '%d heures',
	            d: 'un jour',
	            dd: '%d jours',
	            w: 'une semaine',
	            ww: '%d semaines',
	            M: 'un mois',
	            MM: '%d mois',
	            y: 'un an',
	            yy: '%d ans',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(er|)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                // TODO: Return 'e' when day of month > 1. Move this case inside
	                // block for masculine words below.
	                // See https://github.com/moment/moment/issues/3375
	                case 'D':
	                    return number + (number === 1 ? 'er' : '');
	
	                // Words with masculine grammatical gender: mois, trimestre, jour
	                default:
	                case 'M':
	                case 'Q':
	                case 'DDD':
	                case 'd':
	                    return number + (number === 1 ? 'er' : 'e');
	
	                // Words with feminine grammatical gender: semaine
	                case 'w':
	                case 'W':
	                    return number + (number === 1 ? 're' : 'e');
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return fr;
	
	})));


/***/ }),
/* 1070 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : French (Canada) [fr-ca]
	//! author : Jonathan Abourbih : https://github.com/jonbca
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1021)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var frCa = moment.defineLocale('fr-ca', {
	        months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split(
	            '_'
	        ),
	        monthsShort: 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	        weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	        weekdaysMin: 'di_lu_ma_me_je_ve_sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Aujourd’hui à] LT',
	            nextDay: '[Demain à] LT',
	            nextWeek: 'dddd [à] LT',
	            lastDay: '[Hier à] LT',
	            lastWeek: 'dddd [dernier à] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'dans %s',
	            past: 'il y a %s',
	            s: 'quelques secondes',
	            ss: '%d secondes',
	            m: 'une minute',
	            mm: '%d minutes',
	            h: 'une heure',
	            hh: '%d heures',
	            d: 'un jour',
	            dd: '%d jours',
	            M: 'un mois',
	            MM: '%d mois',
	            y: 'un an',
	            yy: '%d ans',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                // Words with masculine grammatical gender: mois, trimestre, jour
	                default:
	                case 'M':
	                case 'Q':
	                case 'D':
	                case 'DDD':
	                case 'd':
	                    return number + (number === 1 ? 'er' : 'e');
	
	                // Words with feminine grammatical gender: semaine
	                case 'w':
	                case 'W':
	                    return number + (number === 1 ? 're' : 'e');
	            }
	        },
	    });
	
	    return frCa;
	
	})));


/***/ }),
/* 1071 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : French (Switzerland) [fr-ch]
	//! author : Gaspard Bucher : https://github.com/gaspard
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1021)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var frCh = moment.defineLocale('fr-ch', {
	        months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split(
	            '_'
	        ),
	        monthsShort: 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	        weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	        weekdaysMin: 'di_lu_ma_me_je_ve_sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Aujourd’hui à] LT',
	            nextDay: '[Demain à] LT',
	            nextWeek: 'dddd [à] LT',
	            lastDay: '[Hier à] LT',
	            lastWeek: 'dddd [dernier à] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'dans %s',
	            past: 'il y a %s',
	            s: 'quelques secondes',
	            ss: '%d secondes',
	            m: 'une minute',
	            mm: '%d minutes',
	            h: 'une heure',
	            hh: '%d heures',
	            d: 'un jour',
	            dd: '%d jours',
	            M: 'un mois',
	            MM: '%d mois',
	            y: 'un an',
	            yy: '%d ans',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                // Words with masculine grammatical gender: mois, trimestre, jour
	                default:
	                case 'M':
	                case 'Q':
	                case 'D':
	                case 'DDD':
	                case 'd':
	                    return number + (number === 1 ? 'er' : 'e');
	
	                // Words with feminine grammatical gender: semaine
	                case 'w':
	                case 'W':
	                    return number + (number === 1 ? 're' : 'e');
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return frCh;
	
	})));


/***/ }),
/* 1072 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Frisian [fy]
	//! author : Robin van der Vliet : https://github.com/robin0van0der0v
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1021)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsShortWithDots = 'jan._feb._mrt._apr._mai_jun._jul._aug._sep._okt._nov._des.'.split(
	            '_'
	        ),
	        monthsShortWithoutDots = 'jan_feb_mrt_apr_mai_jun_jul_aug_sep_okt_nov_des'.split(
	            '_'
	        );
	
	    var fy = moment.defineLocale('fy', {
	        months: 'jannewaris_febrewaris_maart_april_maaie_juny_july_augustus_septimber_oktober_novimber_desimber'.split(
	            '_'
	        ),
	        monthsShort: function (m, format) {
	            if (!m) {
	                return monthsShortWithDots;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShortWithoutDots[m.month()];
	            } else {
	                return monthsShortWithDots[m.month()];
	            }
	        },
	        monthsParseExact: true,
	        weekdays: 'snein_moandei_tiisdei_woansdei_tongersdei_freed_sneon'.split(
	            '_'
	        ),
	        weekdaysShort: 'si._mo._ti._wo._to._fr._so.'.split('_'),
	        weekdaysMin: 'Si_Mo_Ti_Wo_To_Fr_So'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD-MM-YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[hjoed om] LT',
	            nextDay: '[moarn om] LT',
	            nextWeek: 'dddd [om] LT',
	            lastDay: '[juster om] LT',
	            lastWeek: '[ôfrûne] dddd [om] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'oer %s',
	            past: '%s lyn',
	            s: 'in pear sekonden',
	            ss: '%d sekonden',
	            m: 'ien minút',
	            mm: '%d minuten',
	            h: 'ien oere',
	            hh: '%d oeren',
	            d: 'ien dei',
	            dd: '%d dagen',
	            M: 'ien moanne',
	            MM: '%d moannen',
	            y: 'ien jier',
	            yy: '%d jierren',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	        ordinal: function (number) {
	            return (
	                number +
	                (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
	            );
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return fy;
	
	})));


/***/ }),
/* 1073 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Irish or Irish Gaelic [ga]
	//! author : André Silva : https://github.com/askpt
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1021)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var months = [
	            'Eanáir',
	            'Feabhra',
	            'Márta',
	            'Aibreán',
	            'Bealtaine',
	            'Meitheamh',
	            'Iúil',
	            'Lúnasa',
	            'Meán Fómhair',
	            'Deireadh Fómhair',
	            'Samhain',
	            'Nollaig',
	        ],
	        monthsShort = [
	            'Ean',
	            'Feabh',
	            'Márt',
	            'Aib',
	            'Beal',
	            'Meith',
	            'Iúil',
	            'Lún',
	            'M.F.',
	            'D.F.',
	            'Samh',
	            'Noll',
	        ],
	        weekdays = [
	            'Dé Domhnaigh',
	            'Dé Luain',
	            'Dé Máirt',
	            'Dé Céadaoin',
	            'Déardaoin',
	            'Dé hAoine',
	            'Dé Sathairn',
	        ],
	        weekdaysShort = ['Domh', 'Luan', 'Máirt', 'Céad', 'Déar', 'Aoine', 'Sath'],
	        weekdaysMin = ['Do', 'Lu', 'Má', 'Cé', 'Dé', 'A', 'Sa'];
	
	    var ga = moment.defineLocale('ga', {
	        months: months,
	        monthsShort: monthsShort,
	        monthsParseExact: true,
	        weekdays: weekdays,
	        weekdaysShort: weekdaysShort,
	        weekdaysMin: weekdaysMin,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Inniu ag] LT',
	            nextDay: '[Amárach ag] LT',
	            nextWeek: 'dddd [ag] LT',
	            lastDay: '[Inné ag] LT',
	            lastWeek: 'dddd [seo caite] [ag] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'i %s',
	            past: '%s ó shin',
	            s: 'cúpla soicind',
	            ss: '%d soicind',
	            m: 'nóiméad',
	            mm: '%d nóiméad',
	            h: 'uair an chloig',
	            hh: '%d uair an chloig',
	            d: 'lá',
	            dd: '%d lá',
	            M: 'mí',
	            MM: '%d míonna',
	            y: 'bliain',
	            yy: '%d bliain',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(d|na|mh)/,
	        ordinal: function (number) {
	            var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return ga;
	
	})));


/***/ }),
/* 1074 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Scottish Gaelic [gd]
	//! author : Jon Ashdown : https://github.com/jonashdown
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1021)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var months = [
	            'Am Faoilleach',
	            'An Gearran',
	            'Am Màrt',
	            'An Giblean',
	            'An Cèitean',
	            'An t-Ògmhios',
	            'An t-Iuchar',
	            'An Lùnastal',
	            'An t-Sultain',
	            'An Dàmhair',
	            'An t-Samhain',
	            'An Dùbhlachd',
	        ],
	        monthsShort = [
	            'Faoi',
	            'Gear',
	            'Màrt',
	            'Gibl',
	            'Cèit',
	            'Ògmh',
	            'Iuch',
	            'Lùn',
	            'Sult',
	            'Dàmh',
	            'Samh',
	            'Dùbh',
	        ],
	        weekdays = [
	            'Didòmhnaich',
	            'Diluain',
	            'Dimàirt',
	            'Diciadain',
	            'Diardaoin',
	            'Dihaoine',
	            'Disathairne',
	        ],
	        weekdaysShort = ['Did', 'Dil', 'Dim', 'Dic', 'Dia', 'Dih', 'Dis'],
	        weekdaysMin = ['Dò', 'Lu', 'Mà', 'Ci', 'Ar', 'Ha', 'Sa'];
	
	    var gd = moment.defineLocale('gd', {
	        months: months,
	        monthsShort: monthsShort,
	        monthsParseExact: true,
	        weekdays: weekdays,
	        weekdaysShort: weekdaysShort,
	        weekdaysMin: weekdaysMin,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[An-diugh aig] LT',
	            nextDay: '[A-màireach aig] LT',
	            nextWeek: 'dddd [aig] LT',
	            lastDay: '[An-dè aig] LT',
	            lastWeek: 'dddd [seo chaidh] [aig] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'ann an %s',
	            past: 'bho chionn %s',
	            s: 'beagan diogan',
	            ss: '%d diogan',
	            m: 'mionaid',
	            mm: '%d mionaidean',
	            h: 'uair',
	            hh: '%d uairean',
	            d: 'latha',
	            dd: '%d latha',
	            M: 'mìos',
	            MM: '%d mìosan',
	            y: 'bliadhna',
	            yy: '%d bliadhna',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(d|na|mh)/,
	        ordinal: function (number) {
	            var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return gd;
	
	})));


/***/ }),
/* 1075 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Galician [gl]
	//! author : Juan G. Hurtado : https://github.com/juanghurtado
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1021)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var gl = moment.defineLocale('gl', {
	        months: 'xaneiro_febreiro_marzo_abril_maio_xuño_xullo_agosto_setembro_outubro_novembro_decembro'.split(
	            '_'
	        ),
	        monthsShort: 'xan._feb._mar._abr._mai._xuñ._xul._ago._set._out._nov._dec.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'domingo_luns_martes_mércores_xoves_venres_sábado'.split('_'),
	        weekdaysShort: 'dom._lun._mar._mér._xov._ven._sáb.'.split('_'),
	        weekdaysMin: 'do_lu_ma_mé_xo_ve_sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY H:mm',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY H:mm',
	        },
	        calendar: {
	            sameDay: function () {
	                return '[hoxe ' + (this.hours() !== 1 ? 'ás' : 'á') + '] LT';
	            },
	            nextDay: function () {
	                return '[mañá ' + (this.hours() !== 1 ? 'ás' : 'á') + '] LT';
	            },
	            nextWeek: function () {
	                return 'dddd [' + (this.hours() !== 1 ? 'ás' : 'a') + '] LT';
	            },
	            lastDay: function () {
	                return '[onte ' + (this.hours() !== 1 ? 'á' : 'a') + '] LT';
	            },
	            lastWeek: function () {
	                return (
	                    '[o] dddd [pasado ' + (this.hours() !== 1 ? 'ás' : 'a') + '] LT'
	                );
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: function (str) {
	                if (str.indexOf('un') === 0) {
	                    return 'n' + str;
	                }
	                return 'en ' + str;
	            },
	            past: 'hai %s',
	            s: 'uns segundos',
	            ss: '%d segundos',
	            m: 'un minuto',
	            mm: '%d minutos',
	            h: 'unha hora',
	            hh: '%d horas',
	            d: 'un día',
	            dd: '%d días',
	            M: 'un mes',
	            MM: '%d meses',
	            y: 'un ano',
	            yy: '%d anos',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return gl;
	
	})));


/***/ }),
/* 1076 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Konkani Devanagari script [gom-deva]
	//! author : The Discoverer : https://github.com/WikiDiscoverer
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1021)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            s: ['थोडया सॅकंडांनी', 'थोडे सॅकंड'],
	            ss: [number + ' सॅकंडांनी', number + ' सॅकंड'],
	            m: ['एका मिणटान', 'एक मिनूट'],
	            mm: [number + ' मिणटांनी', number + ' मिणटां'],
	            h: ['एका वरान', 'एक वर'],
	            hh: [number + ' वरांनी', number + ' वरां'],
	            d: ['एका दिसान', 'एक दीस'],
	            dd: [number + ' दिसांनी', number + ' दीस'],
	            M: ['एका म्हयन्यान', 'एक म्हयनो'],
	            MM: [number + ' म्हयन्यानी', number + ' म्हयने'],
	            y: ['एका वर्सान', 'एक वर्स'],
	            yy: [number + ' वर्सांनी', number + ' वर्सां'],
	        };
	        return isFuture ? format[key][0] : format[key][1];
	    }
	
	    var gomDeva = moment.defineLocale('gom-deva', {
	        months: {
	            standalone: 'जानेवारी_फेब्रुवारी_मार्च_एप्रील_मे_जून_जुलय_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split(
	                '_'
	            ),
	            format: 'जानेवारीच्या_फेब्रुवारीच्या_मार्चाच्या_एप्रीलाच्या_मेयाच्या_जूनाच्या_जुलयाच्या_ऑगस्टाच्या_सप्टेंबराच्या_ऑक्टोबराच्या_नोव्हेंबराच्या_डिसेंबराच्या'.split(
	                '_'
	            ),
	            isFormat: /MMMM(\s)+D[oD]?/,
	        },
	        monthsShort: 'जाने._फेब्रु._मार्च_एप्री._मे_जून_जुल._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'आयतार_सोमार_मंगळार_बुधवार_बिरेस्तार_सुक्रार_शेनवार'.split('_'),
	        weekdaysShort: 'आयत._सोम._मंगळ._बुध._ब्रेस्त._सुक्र._शेन.'.split('_'),
	        weekdaysMin: 'आ_सो_मं_बु_ब्रे_सु_शे'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'A h:mm [वाजतां]',
	            LTS: 'A h:mm:ss [वाजतां]',
	            L: 'DD-MM-YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY A h:mm [वाजतां]',
	            LLLL: 'dddd, MMMM Do, YYYY, A h:mm [वाजतां]',
	            llll: 'ddd, D MMM YYYY, A h:mm [वाजतां]',
	        },
	        calendar: {
	            sameDay: '[आयज] LT',
	            nextDay: '[फाल्यां] LT',
	            nextWeek: '[फुडलो] dddd[,] LT',
	            lastDay: '[काल] LT',
	            lastWeek: '[फाटलो] dddd[,] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s',
	            past: '%s आदीं',
	            s: processRelativeTime,
	            ss: processRelativeTime,
	            m: processRelativeTime,
	            mm: processRelativeTime,
	            h: processRelativeTime,
	            hh: processRelativeTime,
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(वेर)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                // the ordinal 'वेर' only applies to day of the month
	                case 'D':
	                    return number + 'वेर';
	                default:
	                case 'M':
	                case 'Q':
	                case 'DDD':
	                case 'd':
	                case 'w':
	                case 'W':
	                    return number;
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week
	            doy: 3, // The week that contains Jan 4th is the first week of the year (7 + 0 - 4)
	        },
	        meridiemParse: /राती|सकाळीं|दनपारां|सांजे/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'राती') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'सकाळीं') {
	                return hour;
	            } else if (meridiem === 'दनपारां') {
	                return hour > 12 ? hour : hour + 12;
	            } else if (meridiem === 'सांजे') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'राती';
	            } else if (hour < 12) {
	                return 'सकाळीं';
	            } else if (hour < 16) {
	                return 'दनपारां';
	            } else if (hour < 20) {
	                return 'सांजे';
	            } else {
	                return 'राती';
	            }
	        },
	    });
	
	    return gomDeva;
	
	})));


/***/ }),
/* 1077 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Konkani Latin script [gom-latn]
	//! author : The Discoverer : https://github.com/WikiDiscoverer
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1021)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            s: ['thoddea sekondamni', 'thodde sekond'],
	            ss: [number + ' sekondamni', number + ' sekond'],
	            m: ['eka mintan', 'ek minut'],
	            mm: [number + ' mintamni', number + ' mintam'],
	            h: ['eka voran', 'ek vor'],
	            hh: [number + ' voramni', number + ' voram'],
	            d: ['eka disan', 'ek dis'],
	            dd: [number + ' disamni', number + ' dis'],
	            M: ['eka mhoinean', 'ek mhoino'],
	            MM: [number + ' mhoineamni', number + ' mhoine'],
	            y: ['eka vorsan', 'ek voros'],
	            yy: [number + ' vorsamni', number + ' vorsam'],
	        };
	        return isFuture ? format[key][0] : format[key][1];
	    }
	
	    var gomLatn = moment.defineLocale('gom-latn', {
	        months: {
	            standalone: 'Janer_Febrer_Mars_Abril_Mai_Jun_Julai_Agost_Setembr_Otubr_Novembr_Dezembr'.split(
	                '_'
	            ),
	            format: 'Janerachea_Febrerachea_Marsachea_Abrilachea_Maiachea_Junachea_Julaiachea_Agostachea_Setembrachea_Otubrachea_Novembrachea_Dezembrachea'.split(
	                '_'
	            ),
	            isFormat: /MMMM(\s)+D[oD]?/,
	        },
	        monthsShort: 'Jan._Feb._Mars_Abr._Mai_Jun_Jul._Ago._Set._Otu._Nov._Dez.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: "Aitar_Somar_Mongllar_Budhvar_Birestar_Sukrar_Son'var".split('_'),
	        weekdaysShort: 'Ait._Som._Mon._Bud._Bre._Suk._Son.'.split('_'),
	        weekdaysMin: 'Ai_Sm_Mo_Bu_Br_Su_Sn'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'A h:mm [vazta]',
	            LTS: 'A h:mm:ss [vazta]',
	            L: 'DD-MM-YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY A h:mm [vazta]',
	            LLLL: 'dddd, MMMM Do, YYYY, A h:mm [vazta]',
	            llll: 'ddd, D MMM YYYY, A h:mm [vazta]',
	        },
	        calendar: {
	            sameDay: '[Aiz] LT',
	            nextDay: '[Faleam] LT',
	            nextWeek: '[Fuddlo] dddd[,] LT',
	            lastDay: '[Kal] LT',
	            lastWeek: '[Fattlo] dddd[,] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s',
	            past: '%s adim',
	            s: processRelativeTime,
	            ss: processRelativeTime,
	            m: processRelativeTime,
	            mm: processRelativeTime,
	            h: processRelativeTime,
	            hh: processRelativeTime,
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(er)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                // the ordinal 'er' only applies to day of the month
	                case 'D':
	                    return number + 'er';
	                default:
	                case 'M':
	                case 'Q':
	                case 'DDD':
	                case 'd':
	                case 'w':
	                case 'W':
	                    return number;
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week
	            doy: 3, // The week that contains Jan 4th is the first week of the year (7 + 0 - 4)
	        },
	        meridiemParse: /rati|sokallim|donparam|sanje/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'rati') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'sokallim') {
	                return hour;
	            } else if (meridiem === 'donparam') {
	                return hour > 12 ? hour : hour + 12;
	            } else if (meridiem === 'sanje') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'rati';
	            } else if (hour < 12) {
	                return 'sokallim';
	            } else if (hour < 16) {
	                return 'donparam';
	            } else if (hour < 20) {
	                return 'sanje';
	            } else {
	                return 'rati';
	            }
	        },
	    });
	
	    return gomLatn;
	
	})));


/***/ }),
/* 1078 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Gujarati [gu]
	//! author : Kaushik Thanki : https://github.com/Kaushik1987
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1021)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '૧',
	            2: '૨',
	            3: '૩',
	            4: '૪',
	            5: '૫',
	            6: '૬',
	            7: '૭',
	            8: '૮',
	            9: '૯',
	            0: '૦',
	        },
	        numberMap = {
	            '૧': '1',
	            '૨': '2',
	            '૩': '3',
	            '૪': '4',
	            '૫': '5',
	            '૬': '6',
	            '૭': '7',
	            '૮': '8',
	            '૯': '9',
	            '૦': '0',
	        };
	
	    var gu = moment.defineLocale('gu', {
	        months: 'જાન્યુઆરી_ફેબ્રુઆરી_માર્ચ_એપ્રિલ_મે_જૂન_જુલાઈ_ઑગસ્ટ_સપ્ટેમ્બર_ઑક્ટ્બર_નવેમ્બર_ડિસેમ્બર'.split(
	            '_'
	        ),
	        monthsShort: 'જાન્યુ._ફેબ્રુ._માર્ચ_એપ્રિ._મે_જૂન_જુલા._ઑગ._સપ્ટે._ઑક્ટ્._નવે._ડિસે.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'રવિવાર_સોમવાર_મંગળવાર_બુધ્વાર_ગુરુવાર_શુક્રવાર_શનિવાર'.split(
	            '_'
	        ),
	        weekdaysShort: 'રવિ_સોમ_મંગળ_બુધ્_ગુરુ_શુક્ર_શનિ'.split('_'),
	        weekdaysMin: 'ર_સો_મં_બુ_ગુ_શુ_શ'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm વાગ્યે',
	            LTS: 'A h:mm:ss વાગ્યે',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm વાગ્યે',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm વાગ્યે',
	        },
	        calendar: {
	            sameDay: '[આજ] LT',
	            nextDay: '[કાલે] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[ગઇકાલે] LT',
	            lastWeek: '[પાછલા] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s મા',
	            past: '%s પહેલા',
	            s: 'અમુક પળો',
	            ss: '%d સેકંડ',
	            m: 'એક મિનિટ',
	            mm: '%d મિનિટ',
	            h: 'એક કલાક',
	            hh: '%d કલાક',
	            d: 'એક દિવસ',
	            dd: '%d દિવસ',
	            M: 'એક મહિનો',
	            MM: '%d મહિનો',
	            y: 'એક વર્ષ',
	            yy: '%d વર્ષ',
	        },
	        preparse: function (string) {
	            return string.replace(/[૧૨૩૪૫૬૭૮૯૦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // Gujarati notation for meridiems are quite fuzzy in practice. While there exists
	        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Gujarati.
	        meridiemParse: /રાત|બપોર|સવાર|સાંજ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'રાત') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'સવાર') {
	                return hour;
	            } else if (meridiem === 'બપોર') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'સાંજ') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'રાત';
	            } else if (hour < 10) {
	                return 'સવાર';
	            } else if (hour < 17) {
	                return 'બપોર';
	            } else if (hour < 20) {
	                return 'સાંજ';
	            } else {
	                return 'રાત';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return gu;
	
	})));


/***/ }),
/* 1079 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Hebrew [he]
	//! author : Tomer Cohen : https://github.com/tomer
	//! author : Moshe Simantov : https://github.com/DevelopmentIL
	//! author : Tal Ater : https://github.com/TalAter
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1021)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var he = moment.defineLocale('he', {
	        months: 'ינואר_פברואר_מרץ_אפריל_מאי_יוני_יולי_אוגוסט_ספטמבר_אוקטובר_נובמבר_דצמבר'.split(
	            '_'
	        ),
	        monthsShort: 'ינו׳_פבר׳_מרץ_אפר׳_מאי_יוני_יולי_אוג׳_ספט׳_אוק׳_נוב׳_דצמ׳'.split(
	            '_'
	        ),
	        weekdays: 'ראשון_שני_שלישי_רביעי_חמישי_שישי_שבת'.split('_'),
	        weekdaysShort: 'א׳_ב׳_ג׳_ד׳_ה׳_ו׳_ש׳'.split('_'),
	        weekdaysMin: 'א_ב_ג_ד_ה_ו_ש'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [ב]MMMM YYYY',
	            LLL: 'D [ב]MMMM YYYY HH:mm',
	            LLLL: 'dddd, D [ב]MMMM YYYY HH:mm',
	            l: 'D/M/YYYY',
	            ll: 'D MMM YYYY',
	            lll: 'D MMM YYYY HH:mm',
	            llll: 'ddd, D MMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[היום ב־]LT',
	            nextDay: '[מחר ב־]LT',
	            nextWeek: 'dddd [בשעה] LT',
	            lastDay: '[אתמול ב־]LT',
	            lastWeek: '[ביום] dddd [האחרון בשעה] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'בעוד %s',
	            past: 'לפני %s',
	            s: 'מספר שניות',
	            ss: '%d שניות',
	            m: 'דקה',
	            mm: '%d דקות',
	            h: 'שעה',
	            hh: function (number) {
	                if (number === 2) {
	                    return 'שעתיים';
	                }
	                return number + ' שעות';
	            },
	            d: 'יום',
	            dd: function (number) {
	                if (number === 2) {
	                    return 'יומיים';
	                }
	                return number + ' ימים';
	            },
	            M: 'חודש',
	            MM: function (number) {
	                if (number === 2) {
	                    return 'חודשיים';
	                }
	                return number + ' חודשים';
	            },
	            y: 'שנה',
	            yy: function (number) {
	                if (number === 2) {
	                    return 'שנתיים';
	                } else if (number % 10 === 0 && number !== 10) {
	                    return number + ' שנה';
	                }
	                return number + ' שנים';
	            },
	        },
	        meridiemParse: /אחה"צ|לפנה"צ|אחרי הצהריים|לפני הצהריים|לפנות בוקר|בבוקר|בערב/i,
	        isPM: function (input) {
	            return /^(אחה"צ|אחרי הצהריים|בערב)$/.test(input);
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 5) {
	                return 'לפנות בוקר';
	            } else if (hour < 10) {
	                return 'בבוקר';
	            } else if (hour < 12) {
	                return isLower ? 'לפנה"צ' : 'לפני הצהריים';
	            } else if (hour < 18) {
	                return isLower ? 'אחה"צ' : 'אחרי הצהריים';
	            } else {
	                return 'בערב';
	            }
	        },
	    });
	
	    return he;
	
	})));


/***/ }),
/* 1080 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Hindi [hi]
	//! author : Mayank Singhal : https://github.com/mayanksinghal
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1021)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '१',
	            2: '२',
	            3: '३',
	            4: '४',
	            5: '५',
	            6: '६',
	            7: '७',
	            8: '८',
	            9: '९',
	            0: '०',
	        },
	        numberMap = {
	            '१': '1',
	            '२': '2',
	            '३': '3',
	            '४': '4',
	            '५': '5',
	            '६': '6',
	            '७': '7',
	            '८': '8',
	            '९': '9',
	            '०': '0',
	        },
	        monthsParse = [
	            /^जन/i,
	            /^फ़र|फर/i,
	            /^मार्च/i,
	            /^अप्रै/i,
	            /^मई/i,
	            /^जून/i,
	            /^जुल/i,
	            /^अग/i,
	            /^सितं|सित/i,
	            /^अक्टू/i,
	            /^नव|नवं/i,
	            /^दिसं|दिस/i,
	        ],
	        shortMonthsParse = [
	            /^जन/i,
	            /^फ़र/i,
	            /^मार्च/i,
	            /^अप्रै/i,
	            /^मई/i,
	            /^जून/i,
	            /^जुल/i,
	            /^अग/i,
	            /^सित/i,
	            /^अक्टू/i,
	            /^नव/i,
	            /^दिस/i,
	        ];
	
	    var hi = moment.defineLocale('hi', {
	        months: {
	            format: 'जनवरी_फ़रवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितम्बर_अक्टूबर_नवम्बर_दिसम्बर'.split(
	                '_'
	            ),
	            standalone: 'जनवरी_फरवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितंबर_अक्टूबर_नवंबर_दिसंबर'.split(
	                '_'
	            ),
	        },
	        monthsShort: 'जन._फ़र._मार्च_अप्रै._मई_जून_जुल._अग._सित._अक्टू._नव._दिस.'.split(
	            '_'
	        ),
	        weekdays: 'रविवार_सोमवार_मंगलवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
	        weekdaysShort: 'रवि_सोम_मंगल_बुध_गुरू_शुक्र_शनि'.split('_'),
	        weekdaysMin: 'र_सो_मं_बु_गु_शु_श'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm बजे',
	            LTS: 'A h:mm:ss बजे',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm बजे',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm बजे',
	        },
	
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: shortMonthsParse,
	
	        monthsRegex: /^(जनवरी|जन\.?|फ़रवरी|फरवरी|फ़र\.?|मार्च?|अप्रैल|अप्रै\.?|मई?|जून?|जुलाई|जुल\.?|अगस्त|अग\.?|सितम्बर|सितंबर|सित\.?|अक्टूबर|अक्टू\.?|नवम्बर|नवंबर|नव\.?|दिसम्बर|दिसंबर|दिस\.?)/i,
	
	        monthsShortRegex: /^(जनवरी|जन\.?|फ़रवरी|फरवरी|फ़र\.?|मार्च?|अप्रैल|अप्रै\.?|मई?|जून?|जुलाई|जुल\.?|अगस्त|अग\.?|सितम्बर|सितंबर|सित\.?|अक्टूबर|अक्टू\.?|नवम्बर|नवंबर|नव\.?|दिसम्बर|दिसंबर|दिस\.?)/i,
	
	        monthsStrictRegex: /^(जनवरी?|फ़रवरी|फरवरी?|मार्च?|अप्रैल?|मई?|जून?|जुलाई?|अगस्त?|सितम्बर|सितंबर|सित?\.?|अक्टूबर|अक्टू\.?|नवम्बर|नवंबर?|दिसम्बर|दिसंबर?)/i,
	
	        monthsShortStrictRegex: /^(जन\.?|फ़र\.?|मार्च?|अप्रै\.?|मई?|जून?|जुल\.?|अग\.?|सित\.?|अक्टू\.?|नव\.?|दिस\.?)/i,
	
	        calendar: {
	            sameDay: '[आज] LT',
	            nextDay: '[कल] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[कल] LT',
	            lastWeek: '[पिछले] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s में',
	            past: '%s पहले',
	            s: 'कुछ ही क्षण',
	            ss: '%d सेकंड',
	            m: 'एक मिनट',
	            mm: '%d मिनट',
	            h: 'एक घंटा',
	            hh: '%d घंटे',
	            d: 'एक दिन',
	            dd: '%d दिन',
	            M: 'एक महीने',
	            MM: '%d महीने',
	            y: 'एक वर्ष',
	            yy: '%d वर्ष',
	        },
	        preparse: function (string) {
	            return string.replace(/[१२३४५६७८९०]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // Hindi notation for meridiems are quite fuzzy in practice. While there exists
	        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Hindi.
	        meridiemParse: /रात|सुबह|दोपहर|शाम/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'रात') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'सुबह') {
	                return hour;
	            } else if (meridiem === 'दोपहर') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'शाम') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'रात';
	            } else if (hour < 10) {
	                return 'सुबह';
	            } else if (hour < 17) {
	                return 'दोपहर';
	            } else if (hour < 20) {
	                return 'शाम';
	            } else {
	                return 'रात';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return hi;
	
	})));


/***/ }),
/* 1081 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Croatian [hr]
	//! author : Bojan Marković : https://github.com/bmarkovic
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1021)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function translate(number, withoutSuffix, key) {
	        var result = number + ' ';
	        switch (key) {
	            case 'ss':
	                if (number === 1) {
	                    result += 'sekunda';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sekunde';
	                } else {
	                    result += 'sekundi';
	                }
	                return result;
	            case 'm':
	                return withoutSuffix ? 'jedna minuta' : 'jedne minute';
	            case 'mm':
	                if (number === 1) {
	                    result += 'minuta';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'minute';
	                } else {
	                    result += 'minuta';
	                }
	                return result;
	            case 'h':
	                return withoutSuffix ? 'jedan sat' : 'jednog sata';
	            case 'hh':
	                if (number === 1) {
	                    result += 'sat';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sata';
	                } else {
	                    result += 'sati';
	                }
	                return result;
	            case 'dd':
	                if (number === 1) {
	                    result += 'dan';
	                } else {
	                    result += 'dana';
	                }
	                return result;
	            case 'MM':
	                if (number === 1) {
	                    result += 'mjesec';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'mjeseca';
	                } else {
	                    result += 'mjeseci';
	                }
	                return result;
	            case 'yy':
	                if (number === 1) {
	                    result += 'godina';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'godine';
	                } else {
	                    result += 'godina';
	                }
	                return result;
	        }
	    }
	
	    var hr = moment.defineLocale('hr', {
	        months: {
	            format: 'siječnja_veljače_ožujka_travnja_svibnja_lipnja_srpnja_kolovoza_rujna_listopada_studenoga_prosinca'.split(
	                '_'
	            ),
	            standalone: 'siječanj_veljača_ožujak_travanj_svibanj_lipanj_srpanj_kolovoz_rujan_listopad_studeni_prosinac'.split(
	                '_'
	            ),
	        },
	        monthsShort: 'sij._velj._ožu._tra._svi._lip._srp._kol._ruj._lis._stu._pro.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split(
	            '_'
	        ),
	        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'Do MMMM YYYY',
	            LLL: 'Do MMMM YYYY H:mm',
	            LLLL: 'dddd, Do MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[danas u] LT',
	            nextDay: '[sutra u] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedjelju] [u] LT';
	                    case 3:
	                        return '[u] [srijedu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay: '[jučer u] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[prošlu] [nedjelju] [u] LT';
	                    case 3:
	                        return '[prošlu] [srijedu] [u] LT';
	                    case 6:
	                        return '[prošle] [subote] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[prošli] dddd [u] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: 'prije %s',
	            s: 'par sekundi',
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: 'dan',
	            dd: translate,
	            M: 'mjesec',
	            MM: translate,
	            y: 'godinu',
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return hr;
	
	})));


/***/ }),
/* 1082 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Hungarian [hu]
	//! author : Adam Brunner : https://github.com/adambrunner
	//! author : Peter Viszt  : https://github.com/passatgt
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1021)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var weekEndings = 'vasárnap hétfőn kedden szerdán csütörtökön pénteken szombaton'.split(
	        ' '
	    );
	    function translate(number, withoutSuffix, key, isFuture) {
	        var num = number;
	        switch (key) {
	            case 's':
	                return isFuture || withoutSuffix
	                    ? 'néhány másodperc'
	                    : 'néhány másodperce';
	            case 'ss':
	                return num + (isFuture || withoutSuffix)
	                    ? ' másodperc'
	                    : ' másodperce';
	            case 'm':
	                return 'egy' + (isFuture || withoutSuffix ? ' perc' : ' perce');
	            case 'mm':
	                return num + (isFuture || withoutSuffix ? ' perc' : ' perce');
	            case 'h':
	                return 'egy' + (isFuture || withoutSuffix ? ' óra' : ' órája');
	            case 'hh':
	                return num + (isFuture || withoutSuffix ? ' óra' : ' órája');
	            case 'd':
	                return 'egy' + (isFuture || withoutSuffix ? ' nap' : ' napja');
	            case 'dd':
	                return num + (isFuture || withoutSuffix ? ' nap' : ' napja');
	            case 'M':
	                return 'egy' + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
	            case 'MM':
	                return num + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
	            case 'y':
	                return 'egy' + (isFuture || withoutSuffix ? ' év' : ' éve');
	            case 'yy':
	                return num + (isFuture || withoutSuffix ? ' év' : ' éve');
	        }
	        return '';
	    }
	    function week(isFuture) {
	        return (
	            (isFuture ? '' : '[múlt] ') +
	            '[' +
	            weekEndings[this.day()] +
	            '] LT[-kor]'
	        );
	    }
	
	    var hu = moment.defineLocale('hu', {
	        months: 'január_február_március_április_május_június_július_augusztus_szeptember_október_november_december'.split(
	            '_'
	        ),
	        monthsShort: 'jan._feb._márc._ápr._máj._jún._júl._aug._szept._okt._nov._dec.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'vasárnap_hétfő_kedd_szerda_csütörtök_péntek_szombat'.split('_'),
	        weekdaysShort: 'vas_hét_kedd_sze_csüt_pén_szo'.split('_'),
	        weekdaysMin: 'v_h_k_sze_cs_p_szo'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'YYYY.MM.DD.',
	            LL: 'YYYY. MMMM D.',
	            LLL: 'YYYY. MMMM D. H:mm',
	            LLLL: 'YYYY. MMMM D., dddd H:mm',
	        },
	        meridiemParse: /de|du/i,
	        isPM: function (input) {
	            return input.charAt(1).toLowerCase() === 'u';
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower === true ? 'de' : 'DE';
	            } else {
	                return isLower === true ? 'du' : 'DU';
	            }
	        },
	        calendar: {
	            sameDay: '[ma] LT[-kor]',
	            nextDay: '[holnap] LT[-kor]',
	            nextWeek: function () {
	                return week.call(this, true);
	            },
	            lastDay: '[tegnap] LT[-kor]',
	            lastWeek: function () {
	                return week.call(this, false);
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s múlva',
	            past: '%s',
	            s: translate,
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: translate,
	            dd: translate,
	            M: translate,
	            MM: translate,
	            y: translate,
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return hu;
	
	})));


/***/ }),
/* 1083 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Armenian [hy-am]
	//! author : Armendarabyan : https://github.com/armendarabyan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1021)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var hyAm = moment.defineLocale('hy-am', {
	        months: {
	            format: 'հունվարի_փետրվարի_մարտի_ապրիլի_մայիսի_հունիսի_հուլիսի_օգոստոսի_սեպտեմբերի_հոկտեմբերի_նոյեմբերի_դեկտեմբերի'.split(
	                '_'
	            ),
	            standalone: 'հունվար_փետրվար_մարտ_ապրիլ_մայիս_հունիս_հուլիս_օգոստոս_սեպտեմբեր_հոկտեմբեր_նոյեմբեր_դեկտեմբեր'.split(
	                '_'
	            ),
	        },
	        monthsShort: 'հնվ_փտր_մրտ_ապր_մյս_հնս_հլս_օգս_սպտ_հկտ_նմբ_դկտ'.split('_'),
	        weekdays: 'կիրակի_երկուշաբթի_երեքշաբթի_չորեքշաբթի_հինգշաբթի_ուրբաթ_շաբաթ'.split(
	            '_'
	        ),
	        weekdaysShort: 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
	        weekdaysMin: 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY թ.',
	            LLL: 'D MMMM YYYY թ., HH:mm',
	            LLLL: 'dddd, D MMMM YYYY թ., HH:mm',
	        },
	        calendar: {
	            sameDay: '[այսօր] LT',
	            nextDay: '[վաղը] LT',
	            lastDay: '[երեկ] LT',
	            nextWeek: function () {
	                return 'dddd [օրը ժամը] LT';
	            },
	            lastWeek: function () {
	                return '[անցած] dddd [օրը ժամը] LT';
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s հետո',
	            past: '%s առաջ',
	            s: 'մի քանի վայրկյան',
	            ss: '%d վայրկյան',
	            m: 'րոպե',
	            mm: '%d րոպե',
	            h: 'ժամ',
	            hh: '%d ժամ',
	            d: 'օր',
	            dd: '%d օր',
	            M: 'ամիս',
	            MM: '%d ամիս',
	            y: 'տարի',
	            yy: '%d տարի',
	        },
	        meridiemParse: /գիշերվա|առավոտվա|ցերեկվա|երեկոյան/,
	        isPM: function (input) {
	            return /^(ցերեկվա|երեկոյան)$/.test(input);
	        },
	        meridiem: function (hour) {
	            if (hour < 4) {
	                return 'գիշերվա';
	            } else if (hour < 12) {
	                return 'առավոտվա';
	            } else if (hour < 17) {
	                return 'ցերեկվա';
	            } else {
	                return 'երեկոյան';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}|\d{1,2}-(ին|րդ)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'DDD':
	                case 'w':
	                case 'W':
	                case 'DDDo':
	                    if (number === 1) {
	                        return number + '-ին';
	                    }
	                    return number + '-րդ';
	                default:
	                    return number;
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return hyAm;
	
	})));


/***/ }),
/* 1084 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Indonesian [id]
	//! author : Mohammad Satrio Utomo : https://github.com/tyok
	//! reference: http://id.wikisource.org/wiki/Pedoman_Umum_Ejaan_Bahasa_Indonesia_yang_Disempurnakan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1021)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var id = moment.defineLocale('id', {
	        months: 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_November_Desember'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Agt_Sep_Okt_Nov_Des'.split('_'),
	        weekdays: 'Minggu_Senin_Selasa_Rabu_Kamis_Jumat_Sabtu'.split('_'),
	        weekdaysShort: 'Min_Sen_Sel_Rab_Kam_Jum_Sab'.split('_'),
	        weekdaysMin: 'Mg_Sn_Sl_Rb_Km_Jm_Sb'.split('_'),
	        longDateFormat: {
	            LT: 'HH.mm',
	            LTS: 'HH.mm.ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY [pukul] HH.mm',
	            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
	        },
	        meridiemParse: /pagi|siang|sore|malam/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'pagi') {
	                return hour;
	            } else if (meridiem === 'siang') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'sore' || meridiem === 'malam') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'pagi';
	            } else if (hours < 15) {
	                return 'siang';
	            } else if (hours < 19) {
	                return 'sore';
	            } else {
	                return 'malam';
	            }
	        },
	        calendar: {
	            sameDay: '[Hari ini pukul] LT',
	            nextDay: '[Besok pukul] LT',
	            nextWeek: 'dddd [pukul] LT',
	            lastDay: '[Kemarin pukul] LT',
	            lastWeek: 'dddd [lalu pukul] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'dalam %s',
	            past: '%s yang lalu',
	            s: 'beberapa detik',
	            ss: '%d detik',
	            m: 'semenit',
	            mm: '%d menit',
	            h: 'sejam',
	            hh: '%d jam',
	            d: 'sehari',
	            dd: '%d hari',
	            M: 'sebulan',
	            MM: '%d bulan',
	            y: 'setahun',
	            yy: '%d tahun',
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return id;
	
	})));


/***/ }),
/* 1085 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Icelandic [is]
	//! author : Hinrik Örn Sigurðsson : https://github.com/hinrik
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1021)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function plural(n) {
	        if (n % 100 === 11) {
	            return true;
	        } else if (n % 10 === 1) {
	            return false;
	        }
	        return true;
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's':
	                return withoutSuffix || isFuture
	                    ? 'nokkrar sekúndur'
	                    : 'nokkrum sekúndum';
	            case 'ss':
	                if (plural(number)) {
	                    return (
	                        result +
	                        (withoutSuffix || isFuture ? 'sekúndur' : 'sekúndum')
	                    );
	                }
	                return result + 'sekúnda';
	            case 'm':
	                return withoutSuffix ? 'mínúta' : 'mínútu';
	            case 'mm':
	                if (plural(number)) {
	                    return (
	                        result + (withoutSuffix || isFuture ? 'mínútur' : 'mínútum')
	                    );
	                } else if (withoutSuffix) {
	                    return result + 'mínúta';
	                }
	                return result + 'mínútu';
	            case 'hh':
	                if (plural(number)) {
	                    return (
	                        result +
	                        (withoutSuffix || isFuture
	                            ? 'klukkustundir'
	                            : 'klukkustundum')
	                    );
	                }
	                return result + 'klukkustund';
	            case 'd':
	                if (withoutSuffix) {
	                    return 'dagur';
	                }
	                return isFuture ? 'dag' : 'degi';
	            case 'dd':
	                if (plural(number)) {
	                    if (withoutSuffix) {
	                        return result + 'dagar';
	                    }
	                    return result + (isFuture ? 'daga' : 'dögum');
	                } else if (withoutSuffix) {
	                    return result + 'dagur';
	                }
	                return result + (isFuture ? 'dag' : 'degi');
	            case 'M':
	                if (withoutSuffix) {
	                    return 'mánuður';
	                }
	                return isFuture ? 'mánuð' : 'mánuði';
	            case 'MM':
	                if (plural(number)) {
	                    if (withoutSuffix) {
	                        return result + 'mánuðir';
	                    }
	                    return result + (isFuture ? 'mánuði' : 'mánuðum');
	                } else if (withoutSuffix) {
	                    return result + 'mánuður';
	                }
	                return result + (isFuture ? 'mánuð' : 'mánuði');
	            case 'y':
	                return withoutSuffix || isFuture ? 'ár' : 'ári';
	            case 'yy':
	                if (plural(number)) {
	                    return result + (withoutSuffix || isFuture ? 'ár' : 'árum');
	                }
	                return result + (withoutSuffix || isFuture ? 'ár' : 'ári');
	        }
	    }
	
	    var is = moment.defineLocale('is', {
	        months: 'janúar_febrúar_mars_apríl_maí_júní_júlí_ágúst_september_október_nóvember_desember'.split(
	            '_'
	        ),
	        monthsShort: 'jan_feb_mar_apr_maí_jún_júl_ágú_sep_okt_nóv_des'.split('_'),
	        weekdays: 'sunnudagur_mánudagur_þriðjudagur_miðvikudagur_fimmtudagur_föstudagur_laugardagur'.split(
	            '_'
	        ),
	        weekdaysShort: 'sun_mán_þri_mið_fim_fös_lau'.split('_'),
	        weekdaysMin: 'Su_Má_Þr_Mi_Fi_Fö_La'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY [kl.] H:mm',
	            LLLL: 'dddd, D. MMMM YYYY [kl.] H:mm',
	        },
	        calendar: {
	            sameDay: '[í dag kl.] LT',
	            nextDay: '[á morgun kl.] LT',
	            nextWeek: 'dddd [kl.] LT',
	            lastDay: '[í gær kl.] LT',
	            lastWeek: '[síðasta] dddd [kl.] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'eftir %s',
	            past: 'fyrir %s síðan',
	            s: translate,
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: 'klukkustund',
	            hh: translate,
	            d: translate,
	            dd: translate,
	            M: translate,
	            MM: translate,
	            y: translate,
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return is;
	
	})));


/***/ }),
/* 1086 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Italian [it]
	//! author : Lorenzo : https://github.com/aliem
	//! author: Mattia Larentis: https://github.com/nostalgiaz
	//! author: Marco : https://github.com/Manfre98
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1021)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var it = moment.defineLocale('it', {
	        months: 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split(
	            '_'
	        ),
	        monthsShort: 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
	        weekdays: 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split(
	            '_'
	        ),
	        weekdaysShort: 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
	        weekdaysMin: 'do_lu_ma_me_gi_ve_sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: function () {
	                return (
	                    '[Oggi a' +
	                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
	                    ']LT'
	                );
	            },
	            nextDay: function () {
	                return (
	                    '[Domani a' +
	                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
	                    ']LT'
	                );
	            },
	            nextWeek: function () {
	                return (
	                    'dddd [a' +
	                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
	                    ']LT'
	                );
	            },
	            lastDay: function () {
	                return (
	                    '[Ieri a' +
	                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
	                    ']LT'
	                );
	            },
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return (
	                            '[La scorsa] dddd [a' +
	                            (this.hours() > 1
	                                ? 'lle '
	                                : this.hours() === 0
	                                ? ' '
	                                : "ll'") +
	                            ']LT'
	                        );
	                    default:
	                        return (
	                            '[Lo scorso] dddd [a' +
	                            (this.hours() > 1
	                                ? 'lle '
	                                : this.hours() === 0
	                                ? ' '
	                                : "ll'") +
	                            ']LT'
	                        );
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'tra %s',
	            past: '%s fa',
	            s: 'alcuni secondi',
	            ss: '%d secondi',
	            m: 'un minuto',
	            mm: '%d minuti',
	            h: "un'ora",
	            hh: '%d ore',
	            d: 'un giorno',
	            dd: '%d giorni',
	            w: 'una settimana',
	            ww: '%d settimane',
	            M: 'un mese',
	            MM: '%d mesi',
	            y: 'un anno',
	            yy: '%d anni',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return it;
	
	})));


/***/ }),
/* 1087 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Italian (Switzerland) [it-ch]
	//! author : xfh : https://github.com/xfh
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1021)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var itCh = moment.defineLocale('it-ch', {
	        months: 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split(
	            '_'
	        ),
	        monthsShort: 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
	        weekdays: 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split(
	            '_'
	        ),
	        weekdaysShort: 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
	        weekdaysMin: 'do_lu_ma_me_gi_ve_sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Oggi alle] LT',
	            nextDay: '[Domani alle] LT',
	            nextWeek: 'dddd [alle] LT',
	            lastDay: '[Ieri alle] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[la scorsa] dddd [alle] LT';
	                    default:
	                        return '[lo scorso] dddd [alle] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: function (s) {
	                return (/^[0-9].+$/.test(s) ? 'tra' : 'in') + ' ' + s;
	            },
	            past: '%s fa',
	            s: 'alcuni secondi',
	            ss: '%d secondi',
	            m: 'un minuto',
	            mm: '%d minuti',
	            h: "un'ora",
	            hh: '%d ore',
	            d: 'un giorno',
	            dd: '%d giorni',
	            M: 'un mese',
	            MM: '%d mesi',
	            y: 'un anno',
	            yy: '%d anni',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return itCh;
	
	})));


/***/ }),
/* 1088 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Japanese [ja]
	//! author : LI Long : https://github.com/baryon
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1021)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ja = moment.defineLocale('ja', {
	        eras: [
	            {
	                since: '2019-05-01',
	                offset: 1,
	                name: '令和',
	                narrow: '㋿',
	                abbr: 'R',
	            },
	            {
	                since: '1989-01-08',
	                until: '2019-04-30',
	                offset: 1,
	                name: '平成',
	                narrow: '㍻',
	                abbr: 'H',
	            },
	            {
	                since: '1926-12-25',
	                until: '1989-01-07',
	                offset: 1,
	                name: '昭和',
	                narrow: '㍼',
	                abbr: 'S',
	            },
	            {
	                since: '1912-07-30',
	                until: '1926-12-24',
	                offset: 1,
	                name: '大正',
	                narrow: '㍽',
	                abbr: 'T',
	            },
	            {
	                since: '1873-01-01',
	                until: '1912-07-29',
	                offset: 6,
	                name: '明治',
	                narrow: '㍾',
	                abbr: 'M',
	            },
	            {
	                since: '0001-01-01',
	                until: '1873-12-31',
	                offset: 1,
	                name: '西暦',
	                narrow: 'AD',
	                abbr: 'AD',
	            },
	            {
	                since: '0000-12-31',
	                until: -Infinity,
	                offset: 1,
	                name: '紀元前',
	                narrow: 'BC',
	                abbr: 'BC',
	            },
	        ],
	        eraYearOrdinalRegex: /(元|\d+)年/,
	        eraYearOrdinalParse: function (input, match) {
	            return match[1] === '元' ? 1 : parseInt(match[1] || input, 10);
	        },
	        months: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
	            '_'
	        ),
	        weekdays: '日曜日_月曜日_火曜日_水曜日_木曜日_金曜日_土曜日'.split('_'),
	        weekdaysShort: '日_月_火_水_木_金_土'.split('_'),
	        weekdaysMin: '日_月_火_水_木_金_土'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY/MM/DD',
	            LL: 'YYYY年M月D日',
	            LLL: 'YYYY年M月D日 HH:mm',
	            LLLL: 'YYYY年M月D日 dddd HH:mm',
	            l: 'YYYY/MM/DD',
	            ll: 'YYYY年M月D日',
	            lll: 'YYYY年M月D日 HH:mm',
	            llll: 'YYYY年M月D日(ddd) HH:mm',
	        },
	        meridiemParse: /午前|午後/i,
	        isPM: function (input) {
	            return input === '午後';
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return '午前';
	            } else {
	                return '午後';
	            }
	        },
	        calendar: {
	            sameDay: '[今日] LT',
	            nextDay: '[明日] LT',
	            nextWeek: function (now) {
	                if (now.week() !== this.week()) {
	                    return '[来週]dddd LT';
	                } else {
	                    return 'dddd LT';
	                }
	            },
	            lastDay: '[昨日] LT',
	            lastWeek: function (now) {
	                if (this.week() !== now.week()) {
	                    return '[先週]dddd LT';
	                } else {
	                    return 'dddd LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}日/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'y':
	                    return number === 1 ? '元年' : number + '年';
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '日';
	                default:
	                    return number;
	            }
	        },
	        relativeTime: {
	            future: '%s後',
	            past: '%s前',
	            s: '数秒',
	            ss: '%d秒',
	            m: '1分',
	            mm: '%d分',
	            h: '1時間',
	            hh: '%d時間',
	            d: '1日',
	            dd: '%d日',
	            M: '1ヶ月',
	            MM: '%dヶ月',
	            y: '1年',
	            yy: '%d年',
	        },
	    });
	
	    return ja;
	
	})));


/***/ }),
/* 1089 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Javanese [jv]
	//! author : Rony Lantip : https://github.com/lantip
	//! reference: http://jv.wikipedia.org/wiki/Basa_Jawa
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1021)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var jv = moment.defineLocale('jv', {
	        months: 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_Nopember_Desember'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nop_Des'.split('_'),
	        weekdays: 'Minggu_Senen_Seloso_Rebu_Kemis_Jemuwah_Septu'.split('_'),
	        weekdaysShort: 'Min_Sen_Sel_Reb_Kem_Jem_Sep'.split('_'),
	        weekdaysMin: 'Mg_Sn_Sl_Rb_Km_Jm_Sp'.split('_'),
	        longDateFormat: {
	            LT: 'HH.mm',
	            LTS: 'HH.mm.ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY [pukul] HH.mm',
	            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
	        },
	        meridiemParse: /enjing|siyang|sonten|ndalu/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'enjing') {
	                return hour;
	            } else if (meridiem === 'siyang') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'sonten' || meridiem === 'ndalu') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'enjing';
	            } else if (hours < 15) {
	                return 'siyang';
	            } else if (hours < 19) {
	                return 'sonten';
	            } else {
	                return 'ndalu';
	            }
	        },
	        calendar: {
	            sameDay: '[Dinten puniko pukul] LT',
	            nextDay: '[Mbenjang pukul] LT',
	            nextWeek: 'dddd [pukul] LT',
	            lastDay: '[Kala wingi pukul] LT',
	            lastWeek: 'dddd [kepengker pukul] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'wonten ing %s',
	            past: '%s ingkang kepengker',
	            s: 'sawetawis detik',
	            ss: '%d detik',
	            m: 'setunggal menit',
	            mm: '%d menit',
	            h: 'setunggal jam',
	            hh: '%d jam',
	            d: 'sedinten',
	            dd: '%d dinten',
	            M: 'sewulan',
	            MM: '%d wulan',
	            y: 'setaun',
	            yy: '%d taun',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return jv;
	
	})));


/***/ }),
/* 1090 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Georgian [ka]
	//! author : Irakli Janiashvili : https://github.com/IrakliJani
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1021)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ka = moment.defineLocale('ka', {
	        months: 'იანვარი_თებერვალი_მარტი_აპრილი_მაისი_ივნისი_ივლისი_აგვისტო_სექტემბერი_ოქტომბერი_ნოემბერი_დეკემბერი'.split(
	            '_'
	        ),
	        monthsShort: 'იან_თებ_მარ_აპრ_მაი_ივნ_ივლ_აგვ_სექ_ოქტ_ნოე_დეკ'.split('_'),
	        weekdays: {
	            standalone: 'კვირა_ორშაბათი_სამშაბათი_ოთხშაბათი_ხუთშაბათი_პარასკევი_შაბათი'.split(
	                '_'
	            ),
	            format: 'კვირას_ორშაბათს_სამშაბათს_ოთხშაბათს_ხუთშაბათს_პარასკევს_შაბათს'.split(
	                '_'
	            ),
	            isFormat: /(წინა|შემდეგ)/,
	        },
	        weekdaysShort: 'კვი_ორშ_სამ_ოთხ_ხუთ_პარ_შაბ'.split('_'),
	        weekdaysMin: 'კვ_ორ_სა_ოთ_ხუ_პა_შა'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[დღეს] LT[-ზე]',
	            nextDay: '[ხვალ] LT[-ზე]',
	            lastDay: '[გუშინ] LT[-ზე]',
	            nextWeek: '[შემდეგ] dddd LT[-ზე]',
	            lastWeek: '[წინა] dddd LT-ზე',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: function (s) {
	                return s.replace(/(წამ|წუთ|საათ|წელ|დღ|თვ)(ი|ე)/, function (
	                    $0,
	                    $1,
	                    $2
	                ) {
	                    return $2 === 'ი' ? $1 + 'ში' : $1 + $2 + 'ში';
	                });
	            },
	            past: function (s) {
	                if (/(წამი|წუთი|საათი|დღე|თვე)/.test(s)) {
	                    return s.replace(/(ი|ე)$/, 'ის წინ');
	                }
	                if (/წელი/.test(s)) {
	                    return s.replace(/წელი$/, 'წლის წინ');
	                }
	                return s;
	            },
	            s: 'რამდენიმე წამი',
	            ss: '%d წამი',
	            m: 'წუთი',
	            mm: '%d წუთი',
	            h: 'საათი',
	            hh: '%d საათი',
	            d: 'დღე',
	            dd: '%d დღე',
	            M: 'თვე',
	            MM: '%d თვე',
	            y: 'წელი',
	            yy: '%d წელი',
	        },
	        dayOfMonthOrdinalParse: /0|1-ლი|მე-\d{1,2}|\d{1,2}-ე/,
	        ordinal: function (number) {
	            if (number === 0) {
	                return number;
	            }
	            if (number === 1) {
	                return number + '-ლი';
	            }
	            if (
	                number < 20 ||
	                (number <= 100 && number % 20 === 0) ||
	                number % 100 === 0
	            ) {
	                return 'მე-' + number;
	            }
	            return number + '-ე';
	        },
	        week: {
	            dow: 1,
	            doy: 7,
	        },
	    });
	
	    return ka;
	
	})));


/***/ }),
/* 1091 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Kazakh [kk]
	//! authors : Nurlan Rakhimzhanov : https://github.com/nurlan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1021)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var suffixes = {
	        0: '-ші',
	        1: '-ші',
	        2: '-ші',
	        3: '-ші',
	        4: '-ші',
	        5: '-ші',
	        6: '-шы',
	        7: '-ші',
	        8: '-ші',
	        9: '-шы',
	        10: '-шы',
	        20: '-шы',
	        30: '-шы',
	        40: '-шы',
	        50: '-ші',
	        60: '-шы',
	        70: '-ші',
	        80: '-ші',
	        90: '-шы',
	        100: '-ші',
	    };
	
	    var kk = moment.defineLocale('kk', {
	        months: 'қаңтар_ақпан_наурыз_сәуір_мамыр_маусым_шілде_тамыз_қыркүйек_қазан_қараша_желтоқсан'.split(
	            '_'
	        ),
	        monthsShort: 'қаң_ақп_нау_сәу_мам_мау_шіл_там_қыр_қаз_қар_жел'.split('_'),
	        weekdays: 'жексенбі_дүйсенбі_сейсенбі_сәрсенбі_бейсенбі_жұма_сенбі'.split(
	            '_'
	        ),
	        weekdaysShort: 'жек_дүй_сей_сәр_бей_жұм_сен'.split('_'),
	        weekdaysMin: 'жк_дй_сй_ср_бй_жм_сн'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Бүгін сағат] LT',
	            nextDay: '[Ертең сағат] LT',
	            nextWeek: 'dddd [сағат] LT',
	            lastDay: '[Кеше сағат] LT',
	            lastWeek: '[Өткен аптаның] dddd [сағат] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s ішінде',
	            past: '%s бұрын',
	            s: 'бірнеше секунд',
	            ss: '%d секунд',
	            m: 'бір минут',
	            mm: '%d минут',
	            h: 'бір сағат',
	            hh: '%d сағат',
	            d: 'бір күн',
	            dd: '%d күн',
	            M: 'бір ай',
	            MM: '%d ай',
	            y: 'бір жыл',
	            yy: '%d жыл',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ші|шы)/,
	        ordinal: function (number) {
	            var a = number % 10,
	                b = number >= 100 ? 100 : null;
	            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return kk;
	
	})));


/***/ }),
/* 1092 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Cambodian [km]
	//! author : Kruy Vanna : https://github.com/kruyvanna
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1021)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '១',
	            2: '២',
	            3: '៣',
	            4: '៤',
	            5: '៥',
	            6: '៦',
	            7: '៧',
	            8: '៨',
	            9: '៩',
	            0: '០',
	        },
	        numberMap = {
	            '១': '1',
	            '២': '2',
	            '៣': '3',
	            '៤': '4',
	            '៥': '5',
	            '៦': '6',
	            '៧': '7',
	            '៨': '8',
	            '៩': '9',
	            '០': '0',
	        };
	
	    var km = moment.defineLocale('km', {
	        months: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split(
	            '_'
	        ),
	        monthsShort: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split(
	            '_'
	        ),
	        weekdays: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
	        weekdaysShort: 'អា_ច_អ_ព_ព្រ_សុ_ស'.split('_'),
	        weekdaysMin: 'អា_ច_អ_ព_ព្រ_សុ_ស'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ព្រឹក|ល្ងាច/,
	        isPM: function (input) {
	            return input === 'ល្ងាច';
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ព្រឹក';
	            } else {
	                return 'ល្ងាច';
	            }
	        },
	        calendar: {
	            sameDay: '[ថ្ងៃនេះ ម៉ោង] LT',
	            nextDay: '[ស្អែក ម៉ោង] LT',
	            nextWeek: 'dddd [ម៉ោង] LT',
	            lastDay: '[ម្សិលមិញ ម៉ោង] LT',
	            lastWeek: 'dddd [សប្តាហ៍មុន] [ម៉ោង] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%sទៀត',
	            past: '%sមុន',
	            s: 'ប៉ុន្មានវិនាទី',
	            ss: '%d វិនាទី',
	            m: 'មួយនាទី',
	            mm: '%d នាទី',
	            h: 'មួយម៉ោង',
	            hh: '%d ម៉ោង',
	            d: 'មួយថ្ងៃ',
	            dd: '%d ថ្ងៃ',
	            M: 'មួយខែ',
	            MM: '%d ខែ',
	            y: 'មួយឆ្នាំ',
	            yy: '%d ឆ្នាំ',
	        },
	        dayOfMonthOrdinalParse: /ទី\d{1,2}/,
	        ordinal: 'ទី%d',
	        preparse: function (string) {
	            return string.replace(/[១២៣៤៥៦៧៨៩០]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return km;
	
	})));


/***/ }),
/* 1093 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Kannada [kn]
	//! author : Rajeev Naik : https://github.com/rajeevnaikte
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1021)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '೧',
	            2: '೨',
	            3: '೩',
	            4: '೪',
	            5: '೫',
	            6: '೬',
	            7: '೭',
	            8: '೮',
	            9: '೯',
	            0: '೦',
	        },
	        numberMap = {
	            '೧': '1',
	            '೨': '2',
	            '೩': '3',
	            '೪': '4',
	            '೫': '5',
	            '೬': '6',
	            '೭': '7',
	            '೮': '8',
	            '೯': '9',
	            '೦': '0',
	        };
	
	    var kn = moment.defineLocale('kn', {
	        months: 'ಜನವರಿ_ಫೆಬ್ರವರಿ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂಬರ್_ಅಕ್ಟೋಬರ್_ನವೆಂಬರ್_ಡಿಸೆಂಬರ್'.split(
	            '_'
	        ),
	        monthsShort: 'ಜನ_ಫೆಬ್ರ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂ_ಅಕ್ಟೋ_ನವೆಂ_ಡಿಸೆಂ'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'ಭಾನುವಾರ_ಸೋಮವಾರ_ಮಂಗಳವಾರ_ಬುಧವಾರ_ಗುರುವಾರ_ಶುಕ್ರವಾರ_ಶನಿವಾರ'.split(
	            '_'
	        ),
	        weekdaysShort: 'ಭಾನು_ಸೋಮ_ಮಂಗಳ_ಬುಧ_ಗುರು_ಶುಕ್ರ_ಶನಿ'.split('_'),
	        weekdaysMin: 'ಭಾ_ಸೋ_ಮಂ_ಬು_ಗು_ಶು_ಶ'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm',
	            LTS: 'A h:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm',
	        },
	        calendar: {
	            sameDay: '[ಇಂದು] LT',
	            nextDay: '[ನಾಳೆ] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[ನಿನ್ನೆ] LT',
	            lastWeek: '[ಕೊನೆಯ] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s ನಂತರ',
	            past: '%s ಹಿಂದೆ',
	            s: 'ಕೆಲವು ಕ್ಷಣಗಳು',
	            ss: '%d ಸೆಕೆಂಡುಗಳು',
	            m: 'ಒಂದು ನಿಮಿಷ',
	            mm: '%d ನಿಮಿಷ',
	            h: 'ಒಂದು ಗಂಟೆ',
	            hh: '%d ಗಂಟೆ',
	            d: 'ಒಂದು ದಿನ',
	            dd: '%d ದಿನ',
	            M: 'ಒಂದು ತಿಂಗಳು',
	            MM: '%d ತಿಂಗಳು',
	            y: 'ಒಂದು ವರ್ಷ',
	            yy: '%d ವರ್ಷ',
	        },
	        preparse: function (string) {
	            return string.replace(/[೧೨೩೪೫೬೭೮೯೦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /ರಾತ್ರಿ|ಬೆಳಿಗ್ಗೆ|ಮಧ್ಯಾಹ್ನ|ಸಂಜೆ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'ರಾತ್ರಿ') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'ಬೆಳಿಗ್ಗೆ') {
	                return hour;
	            } else if (meridiem === 'ಮಧ್ಯಾಹ್ನ') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'ಸಂಜೆ') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ರಾತ್ರಿ';
	            } else if (hour < 10) {
	                return 'ಬೆಳಿಗ್ಗೆ';
	            } else if (hour < 17) {
	                return 'ಮಧ್ಯಾಹ್ನ';
	            } else if (hour < 20) {
	                return 'ಸಂಜೆ';
	            } else {
	                return 'ರಾತ್ರಿ';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ನೇ)/,
	        ordinal: function (number) {
	            return number + 'ನೇ';
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return kn;
	
	})));


/***/ }),
/* 1094 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Korean [ko]
	//! author : Kyungwook, Park : https://github.com/kyungw00k
	//! author : Jeeeyul Lee <jeeeyul@gmail.com>
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1021)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ko = moment.defineLocale('ko', {
	        months: '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
	        monthsShort: '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split(
	            '_'
	        ),
	        weekdays: '일요일_월요일_화요일_수요일_목요일_금요일_토요일'.split('_'),
	        weekdaysShort: '일_월_화_수_목_금_토'.split('_'),
	        weekdaysMin: '일_월_화_수_목_금_토'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm',
	            LTS: 'A h:mm:ss',
	            L: 'YYYY.MM.DD.',
	            LL: 'YYYY년 MMMM D일',
	            LLL: 'YYYY년 MMMM D일 A h:mm',
	            LLLL: 'YYYY년 MMMM D일 dddd A h:mm',
	            l: 'YYYY.MM.DD.',
	            ll: 'YYYY년 MMMM D일',
	            lll: 'YYYY년 MMMM D일 A h:mm',
	            llll: 'YYYY년 MMMM D일 dddd A h:mm',
	        },
	        calendar: {
	            sameDay: '오늘 LT',
	            nextDay: '내일 LT',
	            nextWeek: 'dddd LT',
	            lastDay: '어제 LT',
	            lastWeek: '지난주 dddd LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s 후',
	            past: '%s 전',
	            s: '몇 초',
	            ss: '%d초',
	            m: '1분',
	            mm: '%d분',
	            h: '한 시간',
	            hh: '%d시간',
	            d: '하루',
	            dd: '%d일',
	            M: '한 달',
	            MM: '%d달',
	            y: '일 년',
	            yy: '%d년',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(일|월|주)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '일';
	                case 'M':
	                    return number + '월';
	                case 'w':
	                case 'W':
	                    return number + '주';
	                default:
	                    return number;
	            }
	        },
	        meridiemParse: /오전|오후/,
	        isPM: function (token) {
	            return token === '오후';
	        },
	        meridiem: function (hour, minute, isUpper) {
	            return hour < 12 ? '오전' : '오후';
	        },
	    });
	
	    return ko;
	
	})));


/***/ }),
/* 1095 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Kurdish [ku]
	//! author : Shahram Mebashar : https://github.com/ShahramMebashar
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1021)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '١',
	            2: '٢',
	            3: '٣',
	            4: '٤',
	            5: '٥',
	            6: '٦',
	            7: '٧',
	            8: '٨',
	            9: '٩',
	            0: '٠',
	        },
	        numberMap = {
	            '١': '1',
	            '٢': '2',
	            '٣': '3',
	            '٤': '4',
	            '٥': '5',
	            '٦': '6',
	            '٧': '7',
	            '٨': '8',
	            '٩': '9',
	            '٠': '0',
	        },
	        months = [
	            'کانونی دووەم',
	            'شوبات',
	            'ئازار',
	            'نیسان',
	            'ئایار',
	            'حوزەیران',
	            'تەمموز',
	            'ئاب',
	            'ئەیلوول',
	            'تشرینی یەكەم',
	            'تشرینی دووەم',
	            'كانونی یەکەم',
	        ];
	
	    var ku = moment.defineLocale('ku', {
	        months: months,
	        monthsShort: months,
	        weekdays: 'یه‌كشه‌ممه‌_دووشه‌ممه‌_سێشه‌ممه‌_چوارشه‌ممه‌_پێنجشه‌ممه‌_هه‌ینی_شه‌ممه‌'.split(
	            '_'
	        ),
	        weekdaysShort: 'یه‌كشه‌م_دووشه‌م_سێشه‌م_چوارشه‌م_پێنجشه‌م_هه‌ینی_شه‌ممه‌'.split(
	            '_'
	        ),
	        weekdaysMin: 'ی_د_س_چ_پ_ه_ش'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ئێواره‌|به‌یانی/,
	        isPM: function (input) {
	            return /ئێواره‌/.test(input);
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'به‌یانی';
	            } else {
	                return 'ئێواره‌';
	            }
	        },
	        calendar: {
	            sameDay: '[ئه‌مرۆ كاتژمێر] LT',
	            nextDay: '[به‌یانی كاتژمێر] LT',
	            nextWeek: 'dddd [كاتژمێر] LT',
	            lastDay: '[دوێنێ كاتژمێر] LT',
	            lastWeek: 'dddd [كاتژمێر] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'له‌ %s',
	            past: '%s',
	            s: 'چه‌ند چركه‌یه‌ك',
	            ss: 'چركه‌ %d',
	            m: 'یه‌ك خوله‌ك',
	            mm: '%d خوله‌ك',
	            h: 'یه‌ك كاتژمێر',
	            hh: '%d كاتژمێر',
	            d: 'یه‌ك ڕۆژ',
	            dd: '%d ڕۆژ',
	            M: 'یه‌ك مانگ',
	            MM: '%d مانگ',
	            y: 'یه‌ك ساڵ',
	            yy: '%d ساڵ',
	        },
	        preparse: function (string) {
	            return string
	                .replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	                    return numberMap[match];
	                })
	                .replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string
	                .replace(/\d/g, function (match) {
	                    return symbolMap[match];
	                })
	                .replace(/,/g, '،');
	        },
	        week: {
	            dow: 6, // Saturday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return ku;
	
	})));


/***/ }),
/* 1096 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Kyrgyz [ky]
	//! author : Chyngyz Arystan uulu : https://github.com/chyngyz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1021)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var suffixes = {
	        0: '-чү',
	        1: '-чи',
	        2: '-чи',
	        3: '-чү',
	        4: '-чү',
	        5: '-чи',
	        6: '-чы',
	        7: '-чи',
	        8: '-чи',
	        9: '-чу',
	        10: '-чу',
	        20: '-чы',
	        30: '-чу',
	        40: '-чы',
	        50: '-чү',
	        60: '-чы',
	        70: '-чи',
	        80: '-чи',
	        90: '-чу',
	        100: '-чү',
	    };
	
	    var ky = moment.defineLocale('ky', {
	        months: 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split(
	            '_'
	        ),
	        monthsShort: 'янв_фев_март_апр_май_июнь_июль_авг_сен_окт_ноя_дек'.split(
	            '_'
	        ),
	        weekdays: 'Жекшемби_Дүйшөмбү_Шейшемби_Шаршемби_Бейшемби_Жума_Ишемби'.split(
	            '_'
	        ),
	        weekdaysShort: 'Жек_Дүй_Шей_Шар_Бей_Жум_Ише'.split('_'),
	        weekdaysMin: 'Жк_Дй_Шй_Шр_Бй_Жм_Иш'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Бүгүн саат] LT',
	            nextDay: '[Эртең саат] LT',
	            nextWeek: 'dddd [саат] LT',
	            lastDay: '[Кечээ саат] LT',
	            lastWeek: '[Өткөн аптанын] dddd [күнү] [саат] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s ичинде',
	            past: '%s мурун',
	            s: 'бирнече секунд',
	            ss: '%d секунд',
	            m: 'бир мүнөт',
	            mm: '%d мүнөт',
	            h: 'бир саат',
	            hh: '%d саат',
	            d: 'бир күн',
	            dd: '%d күн',
	            M: 'бир ай',
	            MM: '%d ай',
	            y: 'бир жыл',
	            yy: '%d жыл',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(чи|чы|чү|чу)/,
	        ordinal: function (number) {
	            var a = number % 10,
	                b = number >= 100 ? 100 : null;
	            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return ky;
	
	})));


/***/ }),
/* 1097 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Luxembourgish [lb]
	//! author : mweimerskirch : https://github.com/mweimerskirch
	//! author : David Raison : https://github.com/kwisatz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1021)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            m: ['eng Minutt', 'enger Minutt'],
	            h: ['eng Stonn', 'enger Stonn'],
	            d: ['een Dag', 'engem Dag'],
	            M: ['ee Mount', 'engem Mount'],
	            y: ['ee Joer', 'engem Joer'],
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	    function processFutureTime(string) {
	        var number = string.substr(0, string.indexOf(' '));
	        if (eifelerRegelAppliesToNumber(number)) {
	            return 'a ' + string;
	        }
	        return 'an ' + string;
	    }
	    function processPastTime(string) {
	        var number = string.substr(0, string.indexOf(' '));
	        if (eifelerRegelAppliesToNumber(number)) {
	            return 'viru ' + string;
	        }
	        return 'virun ' + string;
	    }
	    /**
	     * Returns true if the word before the given number loses the '-n' ending.
	     * e.g. 'an 10 Deeg' but 'a 5 Deeg'
	     *
	     * @param number {integer}
	     * @returns {boolean}
	     */
	    function eifelerRegelAppliesToNumber(number) {
	        number = parseInt(number, 10);
	        if (isNaN(number)) {
	            return false;
	        }
	        if (number < 0) {
	            // Negative Number --> always true
	            return true;
	        } else if (number < 10) {
	            // Only 1 digit
	            if (4 <= number && number <= 7) {
	                return true;
	            }
	            return false;
	        } else if (number < 100) {
	            // 2 digits
	            var lastDigit = number % 10,
	                firstDigit = number / 10;
	            if (lastDigit === 0) {
	                return eifelerRegelAppliesToNumber(firstDigit);
	            }
	            return eifelerRegelAppliesToNumber(lastDigit);
	        } else if (number < 10000) {
	            // 3 or 4 digits --> recursively check first digit
	            while (number >= 10) {
	                number = number / 10;
	            }
	            return eifelerRegelAppliesToNumber(number);
	        } else {
	            // Anything larger than 4 digits: recursively check first n-3 digits
	            number = number / 1000;
	            return eifelerRegelAppliesToNumber(number);
	        }
	    }
	
	    var lb = moment.defineLocale('lb', {
	        months: 'Januar_Februar_Mäerz_Abrëll_Mee_Juni_Juli_August_September_Oktober_November_Dezember'.split(
	            '_'
	        ),
	        monthsShort: 'Jan._Febr._Mrz._Abr._Mee_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'Sonndeg_Méindeg_Dënschdeg_Mëttwoch_Donneschdeg_Freideg_Samschdeg'.split(
	            '_'
	        ),
	        weekdaysShort: 'So._Mé._Dë._Më._Do._Fr._Sa.'.split('_'),
	        weekdaysMin: 'So_Mé_Dë_Më_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm [Auer]',
	            LTS: 'H:mm:ss [Auer]',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm [Auer]',
	            LLLL: 'dddd, D. MMMM YYYY H:mm [Auer]',
	        },
	        calendar: {
	            sameDay: '[Haut um] LT',
	            sameElse: 'L',
	            nextDay: '[Muer um] LT',
	            nextWeek: 'dddd [um] LT',
	            lastDay: '[Gëschter um] LT',
	            lastWeek: function () {
	                // Different date string for 'Dënschdeg' (Tuesday) and 'Donneschdeg' (Thursday) due to phonological rule
	                switch (this.day()) {
	                    case 2:
	                    case 4:
	                        return '[Leschten] dddd [um] LT';
	                    default:
	                        return '[Leschte] dddd [um] LT';
	                }
	            },
	        },
	        relativeTime: {
	            future: processFutureTime,
	            past: processPastTime,
	            s: 'e puer Sekonnen',
	            ss: '%d Sekonnen',
	            m: processRelativeTime,
	            mm: '%d Minutten',
	            h: processRelativeTime,
	            hh: '%d Stonnen',
	            d: processRelativeTime,
	            dd: '%d Deeg',
	            M: processRelativeTime,
	            MM: '%d Méint',
	            y: processRelativeTime,
	            yy: '%d Joer',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return lb;
	
	})));


/***/ }),
/* 1098 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Lao [lo]
	//! author : Ryan Hart : https://github.com/ryanhart2
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1021)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var lo = moment.defineLocale('lo', {
	        months: 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split(
	            '_'
	        ),
	        monthsShort: 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split(
	            '_'
	        ),
	        weekdays: 'ອາທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
	        weekdaysShort: 'ທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
	        weekdaysMin: 'ທ_ຈ_ອຄ_ພ_ພຫ_ສກ_ສ'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'ວັນdddd D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ຕອນເຊົ້າ|ຕອນແລງ/,
	        isPM: function (input) {
	            return input === 'ຕອນແລງ';
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ຕອນເຊົ້າ';
	            } else {
	                return 'ຕອນແລງ';
	            }
	        },
	        calendar: {
	            sameDay: '[ມື້ນີ້ເວລາ] LT',
	            nextDay: '[ມື້ອື່ນເວລາ] LT',
	            nextWeek: '[ວັນ]dddd[ໜ້າເວລາ] LT',
	            lastDay: '[ມື້ວານນີ້ເວລາ] LT',
	            lastWeek: '[ວັນ]dddd[ແລ້ວນີ້ເວລາ] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'ອີກ %s',
	            past: '%sຜ່ານມາ',
	            s: 'ບໍ່ເທົ່າໃດວິນາທີ',
	            ss: '%d ວິນາທີ',
	            m: '1 ນາທີ',
	            mm: '%d ນາທີ',
	            h: '1 ຊົ່ວໂມງ',
	            hh: '%d ຊົ່ວໂມງ',
	            d: '1 ມື້',
	            dd: '%d ມື້',
	            M: '1 ເດືອນ',
	            MM: '%d ເດືອນ',
	            y: '1 ປີ',
	            yy: '%d ປີ',
	        },
	        dayOfMonthOrdinalParse: /(ທີ່)\d{1,2}/,
	        ordinal: function (number) {
	            return 'ທີ່' + number;
	        },
	    });
	
	    return lo;
	
	})));


/***/ }),
/* 1099 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Lithuanian [lt]
	//! author : Mindaugas Mozūras : https://github.com/mmozuras
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1021)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var units = {
	        ss: 'sekundė_sekundžių_sekundes',
	        m: 'minutė_minutės_minutę',
	        mm: 'minutės_minučių_minutes',
	        h: 'valanda_valandos_valandą',
	        hh: 'valandos_valandų_valandas',
	        d: 'diena_dienos_dieną',
	        dd: 'dienos_dienų_dienas',
	        M: 'mėnuo_mėnesio_mėnesį',
	        MM: 'mėnesiai_mėnesių_mėnesius',
	        y: 'metai_metų_metus',
	        yy: 'metai_metų_metus',
	    };
	    function translateSeconds(number, withoutSuffix, key, isFuture) {
	        if (withoutSuffix) {
	            return 'kelios sekundės';
	        } else {
	            return isFuture ? 'kelių sekundžių' : 'kelias sekundes';
	        }
	    }
	    function translateSingular(number, withoutSuffix, key, isFuture) {
	        return withoutSuffix
	            ? forms(key)[0]
	            : isFuture
	            ? forms(key)[1]
	            : forms(key)[2];
	    }
	    function special(number) {
	        return number % 10 === 0 || (number > 10 && number < 20);
	    }
	    function forms(key) {
	        return units[key].split('_');
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        if (number === 1) {
	            return (
	                result + translateSingular(number, withoutSuffix, key[0], isFuture)
	            );
	        } else if (withoutSuffix) {
	            return result + (special(number) ? forms(key)[1] : forms(key)[0]);
	        } else {
	            if (isFuture) {
	                return result + forms(key)[1];
	            } else {
	                return result + (special(number) ? forms(key)[1] : forms(key)[2]);
	            }
	        }
	    }
	    var lt = moment.defineLocale('lt', {
	        months: {
	            format: 'sausio_vasario_kovo_balandžio_gegužės_birželio_liepos_rugpjūčio_rugsėjo_spalio_lapkričio_gruodžio'.split(
	                '_'
	            ),
	            standalone: 'sausis_vasaris_kovas_balandis_gegužė_birželis_liepa_rugpjūtis_rugsėjis_spalis_lapkritis_gruodis'.split(
	                '_'
	            ),
	            isFormat: /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?|MMMM?(\[[^\[\]]*\]|\s)+D[oD]?/,
	        },
	        monthsShort: 'sau_vas_kov_bal_geg_bir_lie_rgp_rgs_spa_lap_grd'.split('_'),
	        weekdays: {
	            format: 'sekmadienį_pirmadienį_antradienį_trečiadienį_ketvirtadienį_penktadienį_šeštadienį'.split(
	                '_'
	            ),
	            standalone: 'sekmadienis_pirmadienis_antradienis_trečiadienis_ketvirtadienis_penktadienis_šeštadienis'.split(
	                '_'
	            ),
	            isFormat: /dddd HH:mm/,
	        },
	        weekdaysShort: 'Sek_Pir_Ant_Tre_Ket_Pen_Šeš'.split('_'),
	        weekdaysMin: 'S_P_A_T_K_Pn_Š'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'YYYY [m.] MMMM D [d.]',
	            LLL: 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
	            LLLL: 'YYYY [m.] MMMM D [d.], dddd, HH:mm [val.]',
	            l: 'YYYY-MM-DD',
	            ll: 'YYYY [m.] MMMM D [d.]',
	            lll: 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
	            llll: 'YYYY [m.] MMMM D [d.], ddd, HH:mm [val.]',
	        },
	        calendar: {
	            sameDay: '[Šiandien] LT',
	            nextDay: '[Rytoj] LT',
	            nextWeek: 'dddd LT',
	            lastDay: '[Vakar] LT',
	            lastWeek: '[Praėjusį] dddd LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'po %s',
	            past: 'prieš %s',
	            s: translateSeconds,
	            ss: translate,
	            m: translateSingular,
	            mm: translate,
	            h: translateSingular,
	            hh: translate,
	            d: translateSingular,
	            dd: translate,
	            M: translateSingular,
	            MM: translate,
	            y: translateSingular,
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-oji/,
	        ordinal: function (number) {
	            return number + '-oji';
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return lt;
	
	})));


/***/ }),
/* 1100 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Latvian [lv]
	//! author : Kristaps Karlsons : https://github.com/skakri
	//! author : Jānis Elmeris : https://github.com/JanisE
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1021)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var units = {
	        ss: 'sekundes_sekundēm_sekunde_sekundes'.split('_'),
	        m: 'minūtes_minūtēm_minūte_minūtes'.split('_'),
	        mm: 'minūtes_minūtēm_minūte_minūtes'.split('_'),
	        h: 'stundas_stundām_stunda_stundas'.split('_'),
	        hh: 'stundas_stundām_stunda_stundas'.split('_'),
	        d: 'dienas_dienām_diena_dienas'.split('_'),
	        dd: 'dienas_dienām_diena_dienas'.split('_'),
	        M: 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
	        MM: 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
	        y: 'gada_gadiem_gads_gadi'.split('_'),
	        yy: 'gada_gadiem_gads_gadi'.split('_'),
	    };
	    /**
	     * @param withoutSuffix boolean true = a length of time; false = before/after a period of time.
	     */
	    function format(forms, number, withoutSuffix) {
	        if (withoutSuffix) {
	            // E.g. "21 minūte", "3 minūtes".
	            return number % 10 === 1 && number % 100 !== 11 ? forms[2] : forms[3];
	        } else {
	            // E.g. "21 minūtes" as in "pēc 21 minūtes".
	            // E.g. "3 minūtēm" as in "pēc 3 minūtēm".
	            return number % 10 === 1 && number % 100 !== 11 ? forms[0] : forms[1];
	        }
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        return number + ' ' + format(units[key], number, withoutSuffix);
	    }
	    function relativeTimeWithSingular(number, withoutSuffix, key) {
	        return format(units[key], number, withoutSuffix);
	    }
	    function relativeSeconds(number, withoutSuffix) {
	        return withoutSuffix ? 'dažas sekundes' : 'dažām sekundēm';
	    }
	
	    var lv = moment.defineLocale('lv', {
	        months: 'janvāris_februāris_marts_aprīlis_maijs_jūnijs_jūlijs_augusts_septembris_oktobris_novembris_decembris'.split(
	            '_'
	        ),
	        monthsShort: 'jan_feb_mar_apr_mai_jūn_jūl_aug_sep_okt_nov_dec'.split('_'),
	        weekdays: 'svētdiena_pirmdiena_otrdiena_trešdiena_ceturtdiena_piektdiena_sestdiena'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sv_P_O_T_C_Pk_S'.split('_'),
	        weekdaysMin: 'Sv_P_O_T_C_Pk_S'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY.',
	            LL: 'YYYY. [gada] D. MMMM',
	            LLL: 'YYYY. [gada] D. MMMM, HH:mm',
	            LLLL: 'YYYY. [gada] D. MMMM, dddd, HH:mm',
	        },
	        calendar: {
	            sameDay: '[Šodien pulksten] LT',
	            nextDay: '[Rīt pulksten] LT',
	            nextWeek: 'dddd [pulksten] LT',
	            lastDay: '[Vakar pulksten] LT',
	            lastWeek: '[Pagājušā] dddd [pulksten] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'pēc %s',
	            past: 'pirms %s',
	            s: relativeSeconds,
	            ss: relativeTimeWithPlural,
	            m: relativeTimeWithSingular,
	            mm: relativeTimeWithPlural,
	            h: relativeTimeWithSingular,
	            hh: relativeTimeWithPlural,
	            d: relativeTimeWithSingular,
	            dd: relativeTimeWithPlural,
	            M: relativeTimeWithSingular,
	            MM: relativeTimeWithPlural,
	            y: relativeTimeWithSingular,
	            yy: relativeTimeWithPlural,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return lv;
	
	})));


/***/ }),
/* 1101 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Montenegrin [me]
	//! author : Miodrag Nikač <miodrag@restartit.me> : https://github.com/miodragnikac
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1021)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var translator = {
	        words: {
	            //Different grammatical cases
	            ss: ['sekund', 'sekunda', 'sekundi'],
	            m: ['jedan minut', 'jednog minuta'],
	            mm: ['minut', 'minuta', 'minuta'],
	            h: ['jedan sat', 'jednog sata'],
	            hh: ['sat', 'sata', 'sati'],
	            dd: ['dan', 'dana', 'dana'],
	            MM: ['mjesec', 'mjeseca', 'mjeseci'],
	            yy: ['godina', 'godine', 'godina'],
	        },
	        correctGrammaticalCase: function (number, wordKey) {
	            return number === 1
	                ? wordKey[0]
	                : number >= 2 && number <= 4
	                ? wordKey[1]
	                : wordKey[2];
	        },
	        translate: function (number, withoutSuffix, key) {
	            var wordKey = translator.words[key];
	            if (key.length === 1) {
	                return withoutSuffix ? wordKey[0] : wordKey[1];
	            } else {
	                return (
	                    number +
	                    ' ' +
	                    translator.correctGrammaticalCase(number, wordKey)
	                );
	            }
	        },
	    };
	
	    var me = moment.defineLocale('me', {
	        months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split(
	            '_'
	        ),
	        monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split(
	            '_'
	        ),
	        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[danas u] LT',
	            nextDay: '[sjutra u] LT',
	
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedjelju] [u] LT';
	                    case 3:
	                        return '[u] [srijedu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay: '[juče u] LT',
	            lastWeek: function () {
	                var lastWeekDays = [
	                    '[prošle] [nedjelje] [u] LT',
	                    '[prošlog] [ponedjeljka] [u] LT',
	                    '[prošlog] [utorka] [u] LT',
	                    '[prošle] [srijede] [u] LT',
	                    '[prošlog] [četvrtka] [u] LT',
	                    '[prošlog] [petka] [u] LT',
	                    '[prošle] [subote] [u] LT',
	                ];
	                return lastWeekDays[this.day()];
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: 'prije %s',
	            s: 'nekoliko sekundi',
	            ss: translator.translate,
	            m: translator.translate,
	            mm: translator.translate,
	            h: translator.translate,
	            hh: translator.translate,
	            d: 'dan',
	            dd: translator.translate,
	            M: 'mjesec',
	            MM: translator.translate,
	            y: 'godinu',
	            yy: translator.translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return me;
	
	})));


/***/ }),
/* 1102 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Maori [mi]
	//! author : John Corrigan <robbiecloset@gmail.com> : https://github.com/johnideal
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1021)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var mi = moment.defineLocale('mi', {
	        months: 'Kohi-tāte_Hui-tanguru_Poutū-te-rangi_Paenga-whāwhā_Haratua_Pipiri_Hōngoingoi_Here-turi-kōkā_Mahuru_Whiringa-ā-nuku_Whiringa-ā-rangi_Hakihea'.split(
	            '_'
	        ),
	        monthsShort: 'Kohi_Hui_Pou_Pae_Hara_Pipi_Hōngoi_Here_Mahu_Whi-nu_Whi-ra_Haki'.split(
	            '_'
	        ),
	        monthsRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	        monthsStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	        monthsShortRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	        monthsShortStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,2}/i,
	        weekdays: 'Rātapu_Mane_Tūrei_Wenerei_Tāite_Paraire_Hātarei'.split('_'),
	        weekdaysShort: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
	        weekdaysMin: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY [i] HH:mm',
	            LLLL: 'dddd, D MMMM YYYY [i] HH:mm',
	        },
	        calendar: {
	            sameDay: '[i teie mahana, i] LT',
	            nextDay: '[apopo i] LT',
	            nextWeek: 'dddd [i] LT',
	            lastDay: '[inanahi i] LT',
	            lastWeek: 'dddd [whakamutunga i] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'i roto i %s',
	            past: '%s i mua',
	            s: 'te hēkona ruarua',
	            ss: '%d hēkona',
	            m: 'he meneti',
	            mm: '%d meneti',
	            h: 'te haora',
	            hh: '%d haora',
	            d: 'he ra',
	            dd: '%d ra',
	            M: 'he marama',
	            MM: '%d marama',
	            y: 'he tau',
	            yy: '%d tau',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return mi;
	
	})));


/***/ }),
/* 1103 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Macedonian [mk]
	//! author : Borislav Mickov : https://github.com/B0k0
	//! author : Sashko Todorov : https://github.com/bkyceh
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1021)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var mk = moment.defineLocale('mk', {
	        months: 'јануари_февруари_март_април_мај_јуни_јули_август_септември_октомври_ноември_декември'.split(
	            '_'
	        ),
	        monthsShort: 'јан_фев_мар_апр_мај_јун_јул_авг_сеп_окт_ное_дек'.split('_'),
	        weekdays: 'недела_понеделник_вторник_среда_четврток_петок_сабота'.split(
	            '_'
	        ),
	        weekdaysShort: 'нед_пон_вто_сре_чет_пет_саб'.split('_'),
	        weekdaysMin: 'нe_пo_вт_ср_че_пе_сa'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'D.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY H:mm',
	            LLLL: 'dddd, D MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[Денес во] LT',
	            nextDay: '[Утре во] LT',
	            nextWeek: '[Во] dddd [во] LT',
	            lastDay: '[Вчера во] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 6:
	                        return '[Изминатата] dddd [во] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[Изминатиот] dddd [во] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'за %s',
	            past: 'пред %s',
	            s: 'неколку секунди',
	            ss: '%d секунди',
	            m: 'една минута',
	            mm: '%d минути',
	            h: 'еден час',
	            hh: '%d часа',
	            d: 'еден ден',
	            dd: '%d дена',
	            M: 'еден месец',
	            MM: '%d месеци',
	            y: 'една година',
	            yy: '%d години',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
	        ordinal: function (number) {
	            var lastDigit = number % 10,
	                last2Digits = number % 100;
	            if (number === 0) {
	                return number + '-ев';
	            } else if (last2Digits === 0) {
	                return number + '-ен';
	            } else if (last2Digits > 10 && last2Digits < 20) {
	                return number + '-ти';
	            } else if (lastDigit === 1) {
	                return number + '-ви';
	            } else if (lastDigit === 2) {
	                return number + '-ри';
	            } else if (lastDigit === 7 || lastDigit === 8) {
	                return number + '-ми';
	            } else {
	                return number + '-ти';
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return mk;
	
	})));


/***/ }),
/* 1104 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Malayalam [ml]
	//! author : Floyd Pink : https://github.com/floydpink
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1021)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ml = moment.defineLocale('ml', {
	        months: 'ജനുവരി_ഫെബ്രുവരി_മാർച്ച്_ഏപ്രിൽ_മേയ്_ജൂൺ_ജൂലൈ_ഓഗസ്റ്റ്_സെപ്റ്റംബർ_ഒക്ടോബർ_നവംബർ_ഡിസംബർ'.split(
	            '_'
	        ),
	        monthsShort: 'ജനു._ഫെബ്രു._മാർ._ഏപ്രി._മേയ്_ജൂൺ_ജൂലൈ._ഓഗ._സെപ്റ്റ._ഒക്ടോ._നവം._ഡിസം.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'ഞായറാഴ്ച_തിങ്കളാഴ്ച_ചൊവ്വാഴ്ച_ബുധനാഴ്ച_വ്യാഴാഴ്ച_വെള്ളിയാഴ്ച_ശനിയാഴ്ച'.split(
	            '_'
	        ),
	        weekdaysShort: 'ഞായർ_തിങ്കൾ_ചൊവ്വ_ബുധൻ_വ്യാഴം_വെള്ളി_ശനി'.split('_'),
	        weekdaysMin: 'ഞാ_തി_ചൊ_ബു_വ്യാ_വെ_ശ'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm -നു',
	            LTS: 'A h:mm:ss -നു',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm -നു',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm -നു',
	        },
	        calendar: {
	            sameDay: '[ഇന്ന്] LT',
	            nextDay: '[നാളെ] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[ഇന്നലെ] LT',
	            lastWeek: '[കഴിഞ്ഞ] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s കഴിഞ്ഞ്',
	            past: '%s മുൻപ്',
	            s: 'അൽപ നിമിഷങ്ങൾ',
	            ss: '%d സെക്കൻഡ്',
	            m: 'ഒരു മിനിറ്റ്',
	            mm: '%d മിനിറ്റ്',
	            h: 'ഒരു മണിക്കൂർ',
	            hh: '%d മണിക്കൂർ',
	            d: 'ഒരു ദിവസം',
	            dd: '%d ദിവസം',
	            M: 'ഒരു മാസം',
	            MM: '%d മാസം',
	            y: 'ഒരു വർഷം',
	            yy: '%d വർഷം',
	        },
	        meridiemParse: /രാത്രി|രാവിലെ|ഉച്ച കഴിഞ്ഞ്|വൈകുന്നേരം|രാത്രി/i,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (
	                (meridiem === 'രാത്രി' && hour >= 4) ||
	                meridiem === 'ഉച്ച കഴിഞ്ഞ്' ||
	                meridiem === 'വൈകുന്നേരം'
	            ) {
	                return hour + 12;
	            } else {
	                return hour;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'രാത്രി';
	            } else if (hour < 12) {
	                return 'രാവിലെ';
	            } else if (hour < 17) {
	                return 'ഉച്ച കഴിഞ്ഞ്';
	            } else if (hour < 20) {
	                return 'വൈകുന്നേരം';
	            } else {
	                return 'രാത്രി';
	            }
	        },
	    });
	
	    return ml;
	
	})));


/***/ }),
/* 1105 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Mongolian [mn]
	//! author : Javkhlantugs Nyamdorj : https://github.com/javkhaanj7
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1021)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function translate(number, withoutSuffix, key, isFuture) {
	        switch (key) {
	            case 's':
	                return withoutSuffix ? 'хэдхэн секунд' : 'хэдхэн секундын';
	            case 'ss':
	                return number + (withoutSuffix ? ' секунд' : ' секундын');
	            case 'm':
	            case 'mm':
	                return number + (withoutSuffix ? ' минут' : ' минутын');
	            case 'h':
	            case 'hh':
	                return number + (withoutSuffix ? ' цаг' : ' цагийн');
	            case 'd':
	            case 'dd':
	                return number + (withoutSuffix ? ' өдөр' : ' өдрийн');
	            case 'M':
	            case 'MM':
	                return number + (withoutSuffix ? ' сар' : ' сарын');
	            case 'y':
	            case 'yy':
	                return number + (withoutSuffix ? ' жил' : ' жилийн');
	            default:
	                return number;
	        }
	    }
	
	    var mn = moment.defineLocale('mn', {
	        months: 'Нэгдүгээр сар_Хоёрдугаар сар_Гуравдугаар сар_Дөрөвдүгээр сар_Тавдугаар сар_Зургадугаар сар_Долдугаар сар_Наймдугаар сар_Есдүгээр сар_Аравдугаар сар_Арван нэгдүгээр сар_Арван хоёрдугаар сар'.split(
	            '_'
	        ),
	        monthsShort: '1 сар_2 сар_3 сар_4 сар_5 сар_6 сар_7 сар_8 сар_9 сар_10 сар_11 сар_12 сар'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'Ням_Даваа_Мягмар_Лхагва_Пүрэв_Баасан_Бямба'.split('_'),
	        weekdaysShort: 'Ням_Дав_Мяг_Лха_Пүр_Баа_Бям'.split('_'),
	        weekdaysMin: 'Ня_Да_Мя_Лх_Пү_Ба_Бя'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'YYYY оны MMMMын D',
	            LLL: 'YYYY оны MMMMын D HH:mm',
	            LLLL: 'dddd, YYYY оны MMMMын D HH:mm',
	        },
	        meridiemParse: /ҮӨ|ҮХ/i,
	        isPM: function (input) {
	            return input === 'ҮХ';
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ҮӨ';
	            } else {
	                return 'ҮХ';
	            }
	        },
	        calendar: {
	            sameDay: '[Өнөөдөр] LT',
	            nextDay: '[Маргааш] LT',
	            nextWeek: '[Ирэх] dddd LT',
	            lastDay: '[Өчигдөр] LT',
	            lastWeek: '[Өнгөрсөн] dddd LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s дараа',
	            past: '%s өмнө',
	            s: translate,
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: translate,
	            dd: translate,
	            M: translate,
	            MM: translate,
	            y: translate,
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2} өдөр/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + ' өдөр';
	                default:
	                    return number;
	            }
	        },
	    });
	
	    return mn;
	
	})));


/***/ }),
/* 1106 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Marathi [mr]
	//! author : Harshad Kale : https://github.com/kalehv
	//! author : Vivek Athalye : https://github.com/vnathalye
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1021)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '१',
	            2: '२',
	            3: '३',
	            4: '४',
	            5: '५',
	            6: '६',
	            7: '७',
	            8: '८',
	            9: '९',
	            0: '०',
	        },
	        numberMap = {
	            '१': '1',
	            '२': '2',
	            '३': '3',
	            '४': '4',
	            '५': '5',
	            '६': '6',
	            '७': '7',
	            '८': '8',
	            '९': '9',
	            '०': '0',
	        };
	
	    function relativeTimeMr(number, withoutSuffix, string, isFuture) {
	        var output = '';
	        if (withoutSuffix) {
	            switch (string) {
	                case 's':
	                    output = 'काही सेकंद';
	                    break;
	                case 'ss':
	                    output = '%d सेकंद';
	                    break;
	                case 'm':
	                    output = 'एक मिनिट';
	                    break;
	                case 'mm':
	                    output = '%d मिनिटे';
	                    break;
	                case 'h':
	                    output = 'एक तास';
	                    break;
	                case 'hh':
	                    output = '%d तास';
	                    break;
	                case 'd':
	                    output = 'एक दिवस';
	                    break;
	                case 'dd':
	                    output = '%d दिवस';
	                    break;
	                case 'M':
	                    output = 'एक महिना';
	                    break;
	                case 'MM':
	                    output = '%d महिने';
	                    break;
	                case 'y':
	                    output = 'एक वर्ष';
	                    break;
	                case 'yy':
	                    output = '%d वर्षे';
	                    break;
	            }
	        } else {
	            switch (string) {
	                case 's':
	                    output = 'काही सेकंदां';
	                    break;
	                case 'ss':
	                    output = '%d सेकंदां';
	                    break;
	                case 'm':
	                    output = 'एका मिनिटा';
	                    break;
	                case 'mm':
	                    output = '%d मिनिटां';
	                    break;
	                case 'h':
	                    output = 'एका तासा';
	                    break;
	                case 'hh':
	                    output = '%d तासां';
	                    break;
	                case 'd':
	                    output = 'एका दिवसा';
	                    break;
	                case 'dd':
	                    output = '%d दिवसां';
	                    break;
	                case 'M':
	                    output = 'एका महिन्या';
	                    break;
	                case 'MM':
	                    output = '%d महिन्यां';
	                    break;
	                case 'y':
	                    output = 'एका वर्षा';
	                    break;
	                case 'yy':
	                    output = '%d वर्षां';
	                    break;
	            }
	        }
	        return output.replace(/%d/i, number);
	    }
	
	    var mr = moment.defineLocale('mr', {
	        months: 'जानेवारी_फेब्रुवारी_मार्च_एप्रिल_मे_जून_जुलै_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split(
	            '_'
	        ),
	        monthsShort: 'जाने._फेब्रु._मार्च._एप्रि._मे._जून._जुलै._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'रविवार_सोमवार_मंगळवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
	        weekdaysShort: 'रवि_सोम_मंगळ_बुध_गुरू_शुक्र_शनि'.split('_'),
	        weekdaysMin: 'र_सो_मं_बु_गु_शु_श'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm वाजता',
	            LTS: 'A h:mm:ss वाजता',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm वाजता',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm वाजता',
	        },
	        calendar: {
	            sameDay: '[आज] LT',
	            nextDay: '[उद्या] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[काल] LT',
	            lastWeek: '[मागील] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%sमध्ये',
	            past: '%sपूर्वी',
	            s: relativeTimeMr,
	            ss: relativeTimeMr,
	            m: relativeTimeMr,
	            mm: relativeTimeMr,
	            h: relativeTimeMr,
	            hh: relativeTimeMr,
	            d: relativeTimeMr,
	            dd: relativeTimeMr,
	            M: relativeTimeMr,
	            MM: relativeTimeMr,
	            y: relativeTimeMr,
	            yy: relativeTimeMr,
	        },
	        preparse: function (string) {
	            return string.replace(/[१२३४५६७८९०]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /पहाटे|सकाळी|दुपारी|सायंकाळी|रात्री/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'पहाटे' || meridiem === 'सकाळी') {
	                return hour;
	            } else if (
	                meridiem === 'दुपारी' ||
	                meridiem === 'सायंकाळी' ||
	                meridiem === 'रात्री'
	            ) {
	                return hour >= 12 ? hour : hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour >= 0 && hour < 6) {
	                return 'पहाटे';
	            } else if (hour < 12) {
	                return 'सकाळी';
	            } else if (hour < 17) {
	                return 'दुपारी';
	            } else if (hour < 20) {
	                return 'सायंकाळी';
	            } else {
	                return 'रात्री';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return mr;
	
	})));


/***/ }),
/* 1107 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Malay [ms]
	//! author : Weldan Jamili : https://github.com/weldan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1021)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ms = moment.defineLocale('ms', {
	        months: 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
	        weekdays: 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
	        weekdaysShort: 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
	        weekdaysMin: 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
	        longDateFormat: {
	            LT: 'HH.mm',
	            LTS: 'HH.mm.ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY [pukul] HH.mm',
	            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
	        },
	        meridiemParse: /pagi|tengahari|petang|malam/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'pagi') {
	                return hour;
	            } else if (meridiem === 'tengahari') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'petang' || meridiem === 'malam') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'pagi';
	            } else if (hours < 15) {
	                return 'tengahari';
	            } else if (hours < 19) {
	                return 'petang';
	            } else {
	                return 'malam';
	            }
	        },
	        calendar: {
	            sameDay: '[Hari ini pukul] LT',
	            nextDay: '[Esok pukul] LT',
	            nextWeek: 'dddd [pukul] LT',
	            lastDay: '[Kelmarin pukul] LT',
	            lastWeek: 'dddd [lepas pukul] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'dalam %s',
	            past: '%s yang lepas',
	            s: 'beberapa saat',
	            ss: '%d saat',
	            m: 'seminit',
	            mm: '%d minit',
	            h: 'sejam',
	            hh: '%d jam',
	            d: 'sehari',
	            dd: '%d hari',
	            M: 'sebulan',
	            MM: '%d bulan',
	            y: 'setahun',
	            yy: '%d tahun',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return ms;
	
	})));


/***/ }),
/* 1108 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Malay [ms-my]
	//! note : DEPRECATED, the correct one is [ms]
	//! author : Weldan Jamili : https://github.com/weldan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1021)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var msMy = moment.defineLocale('ms-my', {
	        months: 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
	        weekdays: 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
	        weekdaysShort: 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
	        weekdaysMin: 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
	        longDateFormat: {
	            LT: 'HH.mm',
	            LTS: 'HH.mm.ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY [pukul] HH.mm',
	            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
	        },
	        meridiemParse: /pagi|tengahari|petang|malam/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'pagi') {
	                return hour;
	            } else if (meridiem === 'tengahari') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'petang' || meridiem === 'malam') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'pagi';
	            } else if (hours < 15) {
	                return 'tengahari';
	            } else if (hours < 19) {
	                return 'petang';
	            } else {
	                return 'malam';
	            }
	        },
	        calendar: {
	            sameDay: '[Hari ini pukul] LT',
	            nextDay: '[Esok pukul] LT',
	            nextWeek: 'dddd [pukul] LT',
	            lastDay: '[Kelmarin pukul] LT',
	            lastWeek: 'dddd [lepas pukul] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'dalam %s',
	            past: '%s yang lepas',
	            s: 'beberapa saat',
	            ss: '%d saat',
	            m: 'seminit',
	            mm: '%d minit',
	            h: 'sejam',
	            hh: '%d jam',
	            d: 'sehari',
	            dd: '%d hari',
	            M: 'sebulan',
	            MM: '%d bulan',
	            y: 'setahun',
	            yy: '%d tahun',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return msMy;
	
	})));


/***/ }),
/* 1109 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Maltese (Malta) [mt]
	//! author : Alessandro Maruccia : https://github.com/alesma
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1021)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var mt = moment.defineLocale('mt', {
	        months: 'Jannar_Frar_Marzu_April_Mejju_Ġunju_Lulju_Awwissu_Settembru_Ottubru_Novembru_Diċembru'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Fra_Mar_Apr_Mej_Ġun_Lul_Aww_Set_Ott_Nov_Diċ'.split('_'),
	        weekdays: 'Il-Ħadd_It-Tnejn_It-Tlieta_L-Erbgħa_Il-Ħamis_Il-Ġimgħa_Is-Sibt'.split(
	            '_'
	        ),
	        weekdaysShort: 'Ħad_Tne_Tli_Erb_Ħam_Ġim_Sib'.split('_'),
	        weekdaysMin: 'Ħa_Tn_Tl_Er_Ħa_Ġi_Si'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Illum fil-]LT',
	            nextDay: '[Għada fil-]LT',
	            nextWeek: 'dddd [fil-]LT',
	            lastDay: '[Il-bieraħ fil-]LT',
	            lastWeek: 'dddd [li għadda] [fil-]LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'f’ %s',
	            past: '%s ilu',
	            s: 'ftit sekondi',
	            ss: '%d sekondi',
	            m: 'minuta',
	            mm: '%d minuti',
	            h: 'siegħa',
	            hh: '%d siegħat',
	            d: 'ġurnata',
	            dd: '%d ġranet',
	            M: 'xahar',
	            MM: '%d xhur',
	            y: 'sena',
	            yy: '%d sni',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return mt;
	
	})));


/***/ }),
/* 1110 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Burmese [my]
	//! author : Squar team, mysquar.com
	//! author : David Rossellat : https://github.com/gholadr
	//! author : Tin Aung Lin : https://github.com/thanyawzinmin
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1021)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '၁',
	            2: '၂',
	            3: '၃',
	            4: '၄',
	            5: '၅',
	            6: '၆',
	            7: '၇',
	            8: '၈',
	            9: '၉',
	            0: '၀',
	        },
	        numberMap = {
	            '၁': '1',
	            '၂': '2',
	            '၃': '3',
	            '၄': '4',
	            '၅': '5',
	            '၆': '6',
	            '၇': '7',
	            '၈': '8',
	            '၉': '9',
	            '၀': '0',
	        };
	
	    var my = moment.defineLocale('my', {
	        months: 'ဇန်နဝါရီ_ဖေဖော်ဝါရီ_မတ်_ဧပြီ_မေ_ဇွန်_ဇူလိုင်_သြဂုတ်_စက်တင်ဘာ_အောက်တိုဘာ_နိုဝင်ဘာ_ဒီဇင်ဘာ'.split(
	            '_'
	        ),
	        monthsShort: 'ဇန်_ဖေ_မတ်_ပြီ_မေ_ဇွန်_လိုင်_သြ_စက်_အောက်_နို_ဒီ'.split('_'),
	        weekdays: 'တနင်္ဂနွေ_တနင်္လာ_အင်္ဂါ_ဗုဒ္ဓဟူး_ကြာသပတေး_သောကြာ_စနေ'.split(
	            '_'
	        ),
	        weekdaysShort: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
	        weekdaysMin: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
	
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[ယနေ.] LT [မှာ]',
	            nextDay: '[မနက်ဖြန်] LT [မှာ]',
	            nextWeek: 'dddd LT [မှာ]',
	            lastDay: '[မနေ.က] LT [မှာ]',
	            lastWeek: '[ပြီးခဲ့သော] dddd LT [မှာ]',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'လာမည့် %s မှာ',
	            past: 'လွန်ခဲ့သော %s က',
	            s: 'စက္ကန်.အနည်းငယ်',
	            ss: '%d စက္ကန့်',
	            m: 'တစ်မိနစ်',
	            mm: '%d မိနစ်',
	            h: 'တစ်နာရီ',
	            hh: '%d နာရီ',
	            d: 'တစ်ရက်',
	            dd: '%d ရက်',
	            M: 'တစ်လ',
	            MM: '%d လ',
	            y: 'တစ်နှစ်',
	            yy: '%d နှစ်',
	        },
	        preparse: function (string) {
	            return string.replace(/[၁၂၃၄၅၆၇၈၉၀]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return my;
	
	})));


/***/ }),
/* 1111 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Norwegian Bokmål [nb]
	//! authors : Espen Hovlandsdal : https://github.com/rexxars
	//!           Sigurd Gartmann : https://github.com/sigurdga
	//!           Stephen Ramthun : https://github.com/stephenramthun
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1021)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var nb = moment.defineLocale('nb', {
	        months: 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split(
	            '_'
	        ),
	        monthsShort: 'jan._feb._mars_apr._mai_juni_juli_aug._sep._okt._nov._des.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
	        weekdaysShort: 'sø._ma._ti._on._to._fr._lø.'.split('_'),
	        weekdaysMin: 'sø_ma_ti_on_to_fr_lø'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY [kl.] HH:mm',
	            LLLL: 'dddd D. MMMM YYYY [kl.] HH:mm',
	        },
	        calendar: {
	            sameDay: '[i dag kl.] LT',
	            nextDay: '[i morgen kl.] LT',
	            nextWeek: 'dddd [kl.] LT',
	            lastDay: '[i går kl.] LT',
	            lastWeek: '[forrige] dddd [kl.] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'om %s',
	            past: '%s siden',
	            s: 'noen sekunder',
	            ss: '%d sekunder',
	            m: 'ett minutt',
	            mm: '%d minutter',
	            h: 'en time',
	            hh: '%d timer',
	            d: 'en dag',
	            dd: '%d dager',
	            w: 'en uke',
	            ww: '%d uker',
	            M: 'en måned',
	            MM: '%d måneder',
	            y: 'ett år',
	            yy: '%d år',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return nb;
	
	})));


/***/ }),
/* 1112 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Nepalese [ne]
	//! author : suvash : https://github.com/suvash
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1021)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '१',
	            2: '२',
	            3: '३',
	            4: '४',
	            5: '५',
	            6: '६',
	            7: '७',
	            8: '८',
	            9: '९',
	            0: '०',
	        },
	        numberMap = {
	            '१': '1',
	            '२': '2',
	            '३': '3',
	            '४': '4',
	            '५': '5',
	            '६': '6',
	            '७': '7',
	            '८': '8',
	            '९': '9',
	            '०': '0',
	        };
	
	    var ne = moment.defineLocale('ne', {
	        months: 'जनवरी_फेब्रुवरी_मार्च_अप्रिल_मई_जुन_जुलाई_अगष्ट_सेप्टेम्बर_अक्टोबर_नोभेम्बर_डिसेम्बर'.split(
	            '_'
	        ),
	        monthsShort: 'जन._फेब्रु._मार्च_अप्रि._मई_जुन_जुलाई._अग._सेप्ट._अक्टो._नोभे._डिसे.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'आइतबार_सोमबार_मङ्गलबार_बुधबार_बिहिबार_शुक्रबार_शनिबार'.split(
	            '_'
	        ),
	        weekdaysShort: 'आइत._सोम._मङ्गल._बुध._बिहि._शुक्र._शनि.'.split('_'),
	        weekdaysMin: 'आ._सो._मं._बु._बि._शु._श.'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'Aको h:mm बजे',
	            LTS: 'Aको h:mm:ss बजे',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, Aको h:mm बजे',
	            LLLL: 'dddd, D MMMM YYYY, Aको h:mm बजे',
	        },
	        preparse: function (string) {
	            return string.replace(/[१२३४५६७८९०]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /राति|बिहान|दिउँसो|साँझ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'राति') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'बिहान') {
	                return hour;
	            } else if (meridiem === 'दिउँसो') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'साँझ') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 3) {
	                return 'राति';
	            } else if (hour < 12) {
	                return 'बिहान';
	            } else if (hour < 16) {
	                return 'दिउँसो';
	            } else if (hour < 20) {
	                return 'साँझ';
	            } else {
	                return 'राति';
	            }
	        },
	        calendar: {
	            sameDay: '[आज] LT',
	            nextDay: '[भोलि] LT',
	            nextWeek: '[आउँदो] dddd[,] LT',
	            lastDay: '[हिजो] LT',
	            lastWeek: '[गएको] dddd[,] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%sमा',
	            past: '%s अगाडि',
	            s: 'केही क्षण',
	            ss: '%d सेकेण्ड',
	            m: 'एक मिनेट',
	            mm: '%d मिनेट',
	            h: 'एक घण्टा',
	            hh: '%d घण्टा',
	            d: 'एक दिन',
	            dd: '%d दिन',
	            M: 'एक महिना',
	            MM: '%d महिना',
	            y: 'एक बर्ष',
	            yy: '%d बर्ष',
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return ne;
	
	})));


/***/ }),
/* 1113 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Dutch [nl]
	//! author : Joris Röling : https://github.com/jorisroling
	//! author : Jacob Middag : https://github.com/middagj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1021)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split(
	            '_'
	        ),
	        monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split(
	            '_'
	        ),
	        monthsParse = [
	            /^jan/i,
	            /^feb/i,
	            /^maart|mrt.?$/i,
	            /^apr/i,
	            /^mei$/i,
	            /^jun[i.]?$/i,
	            /^jul[i.]?$/i,
	            /^aug/i,
	            /^sep/i,
	            /^okt/i,
	            /^nov/i,
	            /^dec/i,
	        ],
	        monthsRegex = /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;
	
	    var nl = moment.defineLocale('nl', {
	        months: 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split(
	            '_'
	        ),
	        monthsShort: function (m, format) {
	            if (!m) {
	                return monthsShortWithDots;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShortWithoutDots[m.month()];
	            } else {
	                return monthsShortWithDots[m.month()];
	            }
	        },
	
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex: /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december)/i,
	        monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,
	
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	
	        weekdays: 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split(
	            '_'
	        ),
	        weekdaysShort: 'zo._ma._di._wo._do._vr._za.'.split('_'),
	        weekdaysMin: 'zo_ma_di_wo_do_vr_za'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD-MM-YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[vandaag om] LT',
	            nextDay: '[morgen om] LT',
	            nextWeek: 'dddd [om] LT',
	            lastDay: '[gisteren om] LT',
	            lastWeek: '[afgelopen] dddd [om] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'over %s',
	            past: '%s geleden',
	            s: 'een paar seconden',
	            ss: '%d seconden',
	            m: 'één minuut',
	            mm: '%d minuten',
	            h: 'één uur',
	            hh: '%d uur',
	            d: 'één dag',
	            dd: '%d dagen',
	            w: 'één week',
	            ww: '%d weken',
	            M: 'één maand',
	            MM: '%d maanden',
	            y: 'één jaar',
	            yy: '%d jaar',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	        ordinal: function (number) {
	            return (
	                number +
	                (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
	            );
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return nl;
	
	})));


/***/ }),
/* 1114 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Dutch (Belgium) [nl-be]
	//! author : Joris Röling : https://github.com/jorisroling
	//! author : Jacob Middag : https://github.com/middagj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1021)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split(
	            '_'
	        ),
	        monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split(
	            '_'
	        ),
	        monthsParse = [
	            /^jan/i,
	            /^feb/i,
	            /^maart|mrt.?$/i,
	            /^apr/i,
	            /^mei$/i,
	            /^jun[i.]?$/i,
	            /^jul[i.]?$/i,
	            /^aug/i,
	            /^sep/i,
	            /^okt/i,
	            /^nov/i,
	            /^dec/i,
	        ],
	        monthsRegex = /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;
	
	    var nlBe = moment.defineLocale('nl-be', {
	        months: 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split(
	            '_'
	        ),
	        monthsShort: function (m, format) {
	            if (!m) {
	                return monthsShortWithDots;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShortWithoutDots[m.month()];
	            } else {
	                return monthsShortWithDots[m.month()];
	            }
	        },
	
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex: /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december)/i,
	        monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,
	
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	
	        weekdays: 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split(
	            '_'
	        ),
	        weekdaysShort: 'zo._ma._di._wo._do._vr._za.'.split('_'),
	        weekdaysMin: 'zo_ma_di_wo_do_vr_za'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[vandaag om] LT',
	            nextDay: '[morgen om] LT',
	            nextWeek: 'dddd [om] LT',
	            lastDay: '[gisteren om] LT',
	            lastWeek: '[afgelopen] dddd [om] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'over %s',
	            past: '%s geleden',
	            s: 'een paar seconden',
	            ss: '%d seconden',
	            m: 'één minuut',
	            mm: '%d minuten',
	            h: 'één uur',
	            hh: '%d uur',
	            d: 'één dag',
	            dd: '%d dagen',
	            M: 'één maand',
	            MM: '%d maanden',
	            y: 'één jaar',
	            yy: '%d jaar',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	        ordinal: function (number) {
	            return (
	                number +
	                (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
	            );
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return nlBe;
	
	})));


/***/ }),
/* 1115 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Nynorsk [nn]
	//! authors : https://github.com/mechuwind
	//!           Stephen Ramthun : https://github.com/stephenramthun
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1021)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var nn = moment.defineLocale('nn', {
	        months: 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split(
	            '_'
	        ),
	        monthsShort: 'jan._feb._mars_apr._mai_juni_juli_aug._sep._okt._nov._des.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'sundag_måndag_tysdag_onsdag_torsdag_fredag_laurdag'.split('_'),
	        weekdaysShort: 'su._må._ty._on._to._fr._lau.'.split('_'),
	        weekdaysMin: 'su_må_ty_on_to_fr_la'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY [kl.] H:mm',
	            LLLL: 'dddd D. MMMM YYYY [kl.] HH:mm',
	        },
	        calendar: {
	            sameDay: '[I dag klokka] LT',
	            nextDay: '[I morgon klokka] LT',
	            nextWeek: 'dddd [klokka] LT',
	            lastDay: '[I går klokka] LT',
	            lastWeek: '[Føregåande] dddd [klokka] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'om %s',
	            past: '%s sidan',
	            s: 'nokre sekund',
	            ss: '%d sekund',
	            m: 'eit minutt',
	            mm: '%d minutt',
	            h: 'ein time',
	            hh: '%d timar',
	            d: 'ein dag',
	            dd: '%d dagar',
	            w: 'ei veke',
	            ww: '%d veker',
	            M: 'ein månad',
	            MM: '%d månader',
	            y: 'eit år',
	            yy: '%d år',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return nn;
	
	})));


/***/ }),
/* 1116 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Occitan, lengadocian dialecte [oc-lnc]
	//! author : Quentin PAGÈS : https://github.com/Quenty31
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1021)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ocLnc = moment.defineLocale('oc-lnc', {
	        months: {
	            standalone: 'genièr_febrièr_març_abril_mai_junh_julhet_agost_setembre_octòbre_novembre_decembre'.split(
	                '_'
	            ),
	            format: "de genièr_de febrièr_de març_d'abril_de mai_de junh_de julhet_d'agost_de setembre_d'octòbre_de novembre_de decembre".split(
	                '_'
	            ),
	            isFormat: /D[oD]?(\s)+MMMM/,
	        },
	        monthsShort: 'gen._febr._març_abr._mai_junh_julh._ago._set._oct._nov._dec.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'dimenge_diluns_dimars_dimècres_dijòus_divendres_dissabte'.split(
	            '_'
	        ),
	        weekdaysShort: 'dg._dl._dm._dc._dj._dv._ds.'.split('_'),
	        weekdaysMin: 'dg_dl_dm_dc_dj_dv_ds'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM [de] YYYY',
	            ll: 'D MMM YYYY',
	            LLL: 'D MMMM [de] YYYY [a] H:mm',
	            lll: 'D MMM YYYY, H:mm',
	            LLLL: 'dddd D MMMM [de] YYYY [a] H:mm',
	            llll: 'ddd D MMM YYYY, H:mm',
	        },
	        calendar: {
	            sameDay: '[uèi a] LT',
	            nextDay: '[deman a] LT',
	            nextWeek: 'dddd [a] LT',
	            lastDay: '[ièr a] LT',
	            lastWeek: 'dddd [passat a] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: "d'aquí %s",
	            past: 'fa %s',
	            s: 'unas segondas',
	            ss: '%d segondas',
	            m: 'una minuta',
	            mm: '%d minutas',
	            h: 'una ora',
	            hh: '%d oras',
	            d: 'un jorn',
	            dd: '%d jorns',
	            M: 'un mes',
	            MM: '%d meses',
	            y: 'un an',
	            yy: '%d ans',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(r|n|t|è|a)/,
	        ordinal: function (number, period) {
	            var output =
	                number === 1
	                    ? 'r'
	                    : number === 2
	                    ? 'n'
	                    : number === 3
	                    ? 'r'
	                    : number === 4
	                    ? 't'
	                    : 'è';
	            if (period === 'w' || period === 'W') {
	                output = 'a';
	            }
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4,
	        },
	    });
	
	    return ocLnc;
	
	})));


/***/ }),
/* 1117 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Punjabi (India) [pa-in]
	//! author : Harpreet Singh : https://github.com/harpreetkhalsagtbit
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1021)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '੧',
	            2: '੨',
	            3: '੩',
	            4: '੪',
	            5: '੫',
	            6: '੬',
	            7: '੭',
	            8: '੮',
	            9: '੯',
	            0: '੦',
	        },
	        numberMap = {
	            '੧': '1',
	            '੨': '2',
	            '੩': '3',
	            '੪': '4',
	            '੫': '5',
	            '੬': '6',
	            '੭': '7',
	            '੮': '8',
	            '੯': '9',
	            '੦': '0',
	        };
	
	    var paIn = moment.defineLocale('pa-in', {
	        // There are months name as per Nanakshahi Calendar but they are not used as rigidly in modern Punjabi.
	        months: 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split(
	            '_'
	        ),
	        monthsShort: 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split(
	            '_'
	        ),
	        weekdays: 'ਐਤਵਾਰ_ਸੋਮਵਾਰ_ਮੰਗਲਵਾਰ_ਬੁਧਵਾਰ_ਵੀਰਵਾਰ_ਸ਼ੁੱਕਰਵਾਰ_ਸ਼ਨੀਚਰਵਾਰ'.split(
	            '_'
	        ),
	        weekdaysShort: 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
	        weekdaysMin: 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm ਵਜੇ',
	            LTS: 'A h:mm:ss ਵਜੇ',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm ਵਜੇ',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm ਵਜੇ',
	        },
	        calendar: {
	            sameDay: '[ਅਜ] LT',
	            nextDay: '[ਕਲ] LT',
	            nextWeek: '[ਅਗਲਾ] dddd, LT',
	            lastDay: '[ਕਲ] LT',
	            lastWeek: '[ਪਿਛਲੇ] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s ਵਿੱਚ',
	            past: '%s ਪਿਛਲੇ',
	            s: 'ਕੁਝ ਸਕਿੰਟ',
	            ss: '%d ਸਕਿੰਟ',
	            m: 'ਇਕ ਮਿੰਟ',
	            mm: '%d ਮਿੰਟ',
	            h: 'ਇੱਕ ਘੰਟਾ',
	            hh: '%d ਘੰਟੇ',
	            d: 'ਇੱਕ ਦਿਨ',
	            dd: '%d ਦਿਨ',
	            M: 'ਇੱਕ ਮਹੀਨਾ',
	            MM: '%d ਮਹੀਨੇ',
	            y: 'ਇੱਕ ਸਾਲ',
	            yy: '%d ਸਾਲ',
	        },
	        preparse: function (string) {
	            return string.replace(/[੧੨੩੪੫੬੭੮੯੦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // Punjabi notation for meridiems are quite fuzzy in practice. While there exists
	        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Punjabi.
	        meridiemParse: /ਰਾਤ|ਸਵੇਰ|ਦੁਪਹਿਰ|ਸ਼ਾਮ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'ਰਾਤ') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'ਸਵੇਰ') {
	                return hour;
	            } else if (meridiem === 'ਦੁਪਹਿਰ') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'ਸ਼ਾਮ') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ਰਾਤ';
	            } else if (hour < 10) {
	                return 'ਸਵੇਰ';
	            } else if (hour < 17) {
	                return 'ਦੁਪਹਿਰ';
	            } else if (hour < 20) {
	                return 'ਸ਼ਾਮ';
	            } else {
	                return 'ਰਾਤ';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return paIn;
	
	})));


/***/ }),
/* 1118 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Polish [pl]
	//! author : Rafal Hirsz : https://github.com/evoL
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1021)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsNominative = 'styczeń_luty_marzec_kwiecień_maj_czerwiec_lipiec_sierpień_wrzesień_październik_listopad_grudzień'.split(
	            '_'
	        ),
	        monthsSubjective = 'stycznia_lutego_marca_kwietnia_maja_czerwca_lipca_sierpnia_września_października_listopada_grudnia'.split(
	            '_'
	        ),
	        monthsParse = [
	            /^sty/i,
	            /^lut/i,
	            /^mar/i,
	            /^kwi/i,
	            /^maj/i,
	            /^cze/i,
	            /^lip/i,
	            /^sie/i,
	            /^wrz/i,
	            /^paź/i,
	            /^lis/i,
	            /^gru/i,
	        ];
	    function plural(n) {
	        return n % 10 < 5 && n % 10 > 1 && ~~(n / 10) % 10 !== 1;
	    }
	    function translate(number, withoutSuffix, key) {
	        var result = number + ' ';
	        switch (key) {
	            case 'ss':
	                return result + (plural(number) ? 'sekundy' : 'sekund');
	            case 'm':
	                return withoutSuffix ? 'minuta' : 'minutę';
	            case 'mm':
	                return result + (plural(number) ? 'minuty' : 'minut');
	            case 'h':
	                return withoutSuffix ? 'godzina' : 'godzinę';
	            case 'hh':
	                return result + (plural(number) ? 'godziny' : 'godzin');
	            case 'ww':
	                return result + (plural(number) ? 'tygodnie' : 'tygodni');
	            case 'MM':
	                return result + (plural(number) ? 'miesiące' : 'miesięcy');
	            case 'yy':
	                return result + (plural(number) ? 'lata' : 'lat');
	        }
	    }
	
	    var pl = moment.defineLocale('pl', {
	        months: function (momentToFormat, format) {
	            if (!momentToFormat) {
	                return monthsNominative;
	            } else if (/D MMMM/.test(format)) {
	                return monthsSubjective[momentToFormat.month()];
	            } else {
	                return monthsNominative[momentToFormat.month()];
	            }
	        },
	        monthsShort: 'sty_lut_mar_kwi_maj_cze_lip_sie_wrz_paź_lis_gru'.split('_'),
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays: 'niedziela_poniedziałek_wtorek_środa_czwartek_piątek_sobota'.split(
	            '_'
	        ),
	        weekdaysShort: 'ndz_pon_wt_śr_czw_pt_sob'.split('_'),
	        weekdaysMin: 'Nd_Pn_Wt_Śr_Cz_Pt_So'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Dziś o] LT',
	            nextDay: '[Jutro o] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[W niedzielę o] LT';
	
	                    case 2:
	                        return '[We wtorek o] LT';
	
	                    case 3:
	                        return '[W środę o] LT';
	
	                    case 6:
	                        return '[W sobotę o] LT';
	
	                    default:
	                        return '[W] dddd [o] LT';
	                }
	            },
	            lastDay: '[Wczoraj o] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[W zeszłą niedzielę o] LT';
	                    case 3:
	                        return '[W zeszłą środę o] LT';
	                    case 6:
	                        return '[W zeszłą sobotę o] LT';
	                    default:
	                        return '[W zeszły] dddd [o] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: '%s temu',
	            s: 'kilka sekund',
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: '1 dzień',
	            dd: '%d dni',
	            w: 'tydzień',
	            ww: translate,
	            M: 'miesiąc',
	            MM: translate,
	            y: 'rok',
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return pl;
	
	})));


/***/ }),
/* 1119 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Portuguese [pt]
	//! author : Jefferson : https://github.com/jalex79
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1021)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var pt = moment.defineLocale('pt', {
	        months: 'janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro'.split(
	            '_'
	        ),
	        monthsShort: 'jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez'.split('_'),
	        weekdays: 'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split(
	            '_'
	        ),
	        weekdaysShort: 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
	        weekdaysMin: 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY HH:mm',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Hoje às] LT',
	            nextDay: '[Amanhã às] LT',
	            nextWeek: 'dddd [às] LT',
	            lastDay: '[Ontem às] LT',
	            lastWeek: function () {
	                return this.day() === 0 || this.day() === 6
	                    ? '[Último] dddd [às] LT' // Saturday + Sunday
	                    : '[Última] dddd [às] LT'; // Monday - Friday
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'em %s',
	            past: 'há %s',
	            s: 'segundos',
	            ss: '%d segundos',
	            m: 'um minuto',
	            mm: '%d minutos',
	            h: 'uma hora',
	            hh: '%d horas',
	            d: 'um dia',
	            dd: '%d dias',
	            w: 'uma semana',
	            ww: '%d semanas',
	            M: 'um mês',
	            MM: '%d meses',
	            y: 'um ano',
	            yy: '%d anos',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return pt;
	
	})));


/***/ }),
/* 1120 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Portuguese (Brazil) [pt-br]
	//! author : Caio Ribeiro Pereira : https://github.com/caio-ribeiro-pereira
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1021)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ptBr = moment.defineLocale('pt-br', {
	        months: 'janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro'.split(
	            '_'
	        ),
	        monthsShort: 'jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez'.split('_'),
	        weekdays: 'domingo_segunda-feira_terça-feira_quarta-feira_quinta-feira_sexta-feira_sábado'.split(
	            '_'
	        ),
	        weekdaysShort: 'dom_seg_ter_qua_qui_sex_sáb'.split('_'),
	        weekdaysMin: 'do_2ª_3ª_4ª_5ª_6ª_sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY [às] HH:mm',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY [às] HH:mm',
	        },
	        calendar: {
	            sameDay: '[Hoje às] LT',
	            nextDay: '[Amanhã às] LT',
	            nextWeek: 'dddd [às] LT',
	            lastDay: '[Ontem às] LT',
	            lastWeek: function () {
	                return this.day() === 0 || this.day() === 6
	                    ? '[Último] dddd [às] LT' // Saturday + Sunday
	                    : '[Última] dddd [às] LT'; // Monday - Friday
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'em %s',
	            past: 'há %s',
	            s: 'poucos segundos',
	            ss: '%d segundos',
	            m: 'um minuto',
	            mm: '%d minutos',
	            h: 'uma hora',
	            hh: '%d horas',
	            d: 'um dia',
	            dd: '%d dias',
	            M: 'um mês',
	            MM: '%d meses',
	            y: 'um ano',
	            yy: '%d anos',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        invalidDate: 'Data inválida',
	    });
	
	    return ptBr;
	
	})));


/***/ }),
/* 1121 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Romanian [ro]
	//! author : Vlad Gurdiga : https://github.com/gurdiga
	//! author : Valentin Agachi : https://github.com/avaly
	//! author : Emanuel Cepoi : https://github.com/cepem
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1021)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	                ss: 'secunde',
	                mm: 'minute',
	                hh: 'ore',
	                dd: 'zile',
	                ww: 'săptămâni',
	                MM: 'luni',
	                yy: 'ani',
	            },
	            separator = ' ';
	        if (number % 100 >= 20 || (number >= 100 && number % 100 === 0)) {
	            separator = ' de ';
	        }
	        return number + separator + format[key];
	    }
	
	    var ro = moment.defineLocale('ro', {
	        months: 'ianuarie_februarie_martie_aprilie_mai_iunie_iulie_august_septembrie_octombrie_noiembrie_decembrie'.split(
	            '_'
	        ),
	        monthsShort: 'ian._feb._mart._apr._mai_iun._iul._aug._sept._oct._nov._dec.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'duminică_luni_marți_miercuri_joi_vineri_sâmbătă'.split('_'),
	        weekdaysShort: 'Dum_Lun_Mar_Mie_Joi_Vin_Sâm'.split('_'),
	        weekdaysMin: 'Du_Lu_Ma_Mi_Jo_Vi_Sâ'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY H:mm',
	            LLLL: 'dddd, D MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[azi la] LT',
	            nextDay: '[mâine la] LT',
	            nextWeek: 'dddd [la] LT',
	            lastDay: '[ieri la] LT',
	            lastWeek: '[fosta] dddd [la] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'peste %s',
	            past: '%s în urmă',
	            s: 'câteva secunde',
	            ss: relativeTimeWithPlural,
	            m: 'un minut',
	            mm: relativeTimeWithPlural,
	            h: 'o oră',
	            hh: relativeTimeWithPlural,
	            d: 'o zi',
	            dd: relativeTimeWithPlural,
	            w: 'o săptămână',
	            ww: relativeTimeWithPlural,
	            M: 'o lună',
	            MM: relativeTimeWithPlural,
	            y: 'un an',
	            yy: relativeTimeWithPlural,
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return ro;
	
	})));


/***/ }),
/* 1122 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Russian [ru]
	//! author : Viktorminator : https://github.com/Viktorminator
	//! author : Menelion Elensúle : https://github.com/Oire
	//! author : Коренберг Марк : https://github.com/socketpair
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1021)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function plural(word, num) {
	        var forms = word.split('_');
	        return num % 10 === 1 && num % 100 !== 11
	            ? forms[0]
	            : num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20)
	            ? forms[1]
	            : forms[2];
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	            ss: withoutSuffix ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
	            mm: withoutSuffix ? 'минута_минуты_минут' : 'минуту_минуты_минут',
	            hh: 'час_часа_часов',
	            dd: 'день_дня_дней',
	            ww: 'неделя_недели_недель',
	            MM: 'месяц_месяца_месяцев',
	            yy: 'год_года_лет',
	        };
	        if (key === 'm') {
	            return withoutSuffix ? 'минута' : 'минуту';
	        } else {
	            return number + ' ' + plural(format[key], +number);
	        }
	    }
	    var monthsParse = [
	        /^янв/i,
	        /^фев/i,
	        /^мар/i,
	        /^апр/i,
	        /^ма[йя]/i,
	        /^июн/i,
	        /^июл/i,
	        /^авг/i,
	        /^сен/i,
	        /^окт/i,
	        /^ноя/i,
	        /^дек/i,
	    ];
	
	    // http://new.gramota.ru/spravka/rules/139-prop : § 103
	    // Сокращения месяцев: http://new.gramota.ru/spravka/buro/search-answer?s=242637
	    // CLDR data:          http://www.unicode.org/cldr/charts/28/summary/ru.html#1753
	    var ru = moment.defineLocale('ru', {
	        months: {
	            format: 'января_февраля_марта_апреля_мая_июня_июля_августа_сентября_октября_ноября_декабря'.split(
	                '_'
	            ),
	            standalone: 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split(
	                '_'
	            ),
	        },
	        monthsShort: {
	            // по CLDR именно "июл." и "июн.", но какой смысл менять букву на точку?
	            format: 'янв._февр._мар._апр._мая_июня_июля_авг._сент._окт._нояб._дек.'.split(
	                '_'
	            ),
	            standalone: 'янв._февр._март_апр._май_июнь_июль_авг._сент._окт._нояб._дек.'.split(
	                '_'
	            ),
	        },
	        weekdays: {
	            standalone: 'воскресенье_понедельник_вторник_среда_четверг_пятница_суббота'.split(
	                '_'
	            ),
	            format: 'воскресенье_понедельник_вторник_среду_четверг_пятницу_субботу'.split(
	                '_'
	            ),
	            isFormat: /\[ ?[Вв] ?(?:прошлую|следующую|эту)? ?] ?dddd/,
	        },
	        weekdaysShort: 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
	        weekdaysMin: 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	
	        // полные названия с падежами, по три буквы, для некоторых, по 4 буквы, сокращения с точкой и без точки
	        monthsRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
	
	        // копия предыдущего
	        monthsShortRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
	
	        // полные названия с падежами
	        monthsStrictRegex: /^(январ[яь]|феврал[яь]|марта?|апрел[яь]|ма[яй]|июн[яь]|июл[яь]|августа?|сентябр[яь]|октябр[яь]|ноябр[яь]|декабр[яь])/i,
	
	        // Выражение, которое соответствует только сокращённым формам
	        monthsShortStrictRegex: /^(янв\.|февр?\.|мар[т.]|апр\.|ма[яй]|июн[ья.]|июл[ья.]|авг\.|сент?\.|окт\.|нояб?\.|дек\.)/i,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY г.',
	            LLL: 'D MMMM YYYY г., H:mm',
	            LLLL: 'dddd, D MMMM YYYY г., H:mm',
	        },
	        calendar: {
	            sameDay: '[Сегодня, в] LT',
	            nextDay: '[Завтра, в] LT',
	            lastDay: '[Вчера, в] LT',
	            nextWeek: function (now) {
	                if (now.week() !== this.week()) {
	                    switch (this.day()) {
	                        case 0:
	                            return '[В следующее] dddd, [в] LT';
	                        case 1:
	                        case 2:
	                        case 4:
	                            return '[В следующий] dddd, [в] LT';
	                        case 3:
	                        case 5:
	                        case 6:
	                            return '[В следующую] dddd, [в] LT';
	                    }
	                } else {
	                    if (this.day() === 2) {
	                        return '[Во] dddd, [в] LT';
	                    } else {
	                        return '[В] dddd, [в] LT';
	                    }
	                }
	            },
	            lastWeek: function (now) {
	                if (now.week() !== this.week()) {
	                    switch (this.day()) {
	                        case 0:
	                            return '[В прошлое] dddd, [в] LT';
	                        case 1:
	                        case 2:
	                        case 4:
	                            return '[В прошлый] dddd, [в] LT';
	                        case 3:
	                        case 5:
	                        case 6:
	                            return '[В прошлую] dddd, [в] LT';
	                    }
	                } else {
	                    if (this.day() === 2) {
	                        return '[Во] dddd, [в] LT';
	                    } else {
	                        return '[В] dddd, [в] LT';
	                    }
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'через %s',
	            past: '%s назад',
	            s: 'несколько секунд',
	            ss: relativeTimeWithPlural,
	            m: relativeTimeWithPlural,
	            mm: relativeTimeWithPlural,
	            h: 'час',
	            hh: relativeTimeWithPlural,
	            d: 'день',
	            dd: relativeTimeWithPlural,
	            w: 'неделя',
	            ww: relativeTimeWithPlural,
	            M: 'месяц',
	            MM: relativeTimeWithPlural,
	            y: 'год',
	            yy: relativeTimeWithPlural,
	        },
	        meridiemParse: /ночи|утра|дня|вечера/i,
	        isPM: function (input) {
	            return /^(дня|вечера)$/.test(input);
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ночи';
	            } else if (hour < 12) {
	                return 'утра';
	            } else if (hour < 17) {
	                return 'дня';
	            } else {
	                return 'вечера';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(й|го|я)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'M':
	                case 'd':
	                case 'DDD':
	                    return number + '-й';
	                case 'D':
	                    return number + '-го';
	                case 'w':
	                case 'W':
	                    return number + '-я';
	                default:
	                    return number;
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return ru;
	
	})));


/***/ }),
/* 1123 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Sindhi [sd]
	//! author : Narain Sagar : https://github.com/narainsagar
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1021)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var months = [
	            'جنوري',
	            'فيبروري',
	            'مارچ',
	            'اپريل',
	            'مئي',
	            'جون',
	            'جولاءِ',
	            'آگسٽ',
	            'سيپٽمبر',
	            'آڪٽوبر',
	            'نومبر',
	            'ڊسمبر',
	        ],
	        days = ['آچر', 'سومر', 'اڱارو', 'اربع', 'خميس', 'جمع', 'ڇنڇر'];
	
	    var sd = moment.defineLocale('sd', {
	        months: months,
	        monthsShort: months,
	        weekdays: days,
	        weekdaysShort: days,
	        weekdaysMin: days,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd، D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /صبح|شام/,
	        isPM: function (input) {
	            return 'شام' === input;
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'صبح';
	            }
	            return 'شام';
	        },
	        calendar: {
	            sameDay: '[اڄ] LT',
	            nextDay: '[سڀاڻي] LT',
	            nextWeek: 'dddd [اڳين هفتي تي] LT',
	            lastDay: '[ڪالهه] LT',
	            lastWeek: '[گزريل هفتي] dddd [تي] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s پوء',
	            past: '%s اڳ',
	            s: 'چند سيڪنڊ',
	            ss: '%d سيڪنڊ',
	            m: 'هڪ منٽ',
	            mm: '%d منٽ',
	            h: 'هڪ ڪلاڪ',
	            hh: '%d ڪلاڪ',
	            d: 'هڪ ڏينهن',
	            dd: '%d ڏينهن',
	            M: 'هڪ مهينو',
	            MM: '%d مهينا',
	            y: 'هڪ سال',
	            yy: '%d سال',
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return sd;
	
	})));


/***/ }),
/* 1124 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Northern Sami [se]
	//! authors : Bård Rolstad Henriksen : https://github.com/karamell
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1021)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var se = moment.defineLocale('se', {
	        months: 'ođđajagemánnu_guovvamánnu_njukčamánnu_cuoŋománnu_miessemánnu_geassemánnu_suoidnemánnu_borgemánnu_čakčamánnu_golggotmánnu_skábmamánnu_juovlamánnu'.split(
	            '_'
	        ),
	        monthsShort: 'ođđj_guov_njuk_cuo_mies_geas_suoi_borg_čakč_golg_skáb_juov'.split(
	            '_'
	        ),
	        weekdays: 'sotnabeaivi_vuossárga_maŋŋebárga_gaskavahkku_duorastat_bearjadat_lávvardat'.split(
	            '_'
	        ),
	        weekdaysShort: 'sotn_vuos_maŋ_gask_duor_bear_láv'.split('_'),
	        weekdaysMin: 's_v_m_g_d_b_L'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'MMMM D. [b.] YYYY',
	            LLL: 'MMMM D. [b.] YYYY [ti.] HH:mm',
	            LLLL: 'dddd, MMMM D. [b.] YYYY [ti.] HH:mm',
	        },
	        calendar: {
	            sameDay: '[otne ti] LT',
	            nextDay: '[ihttin ti] LT',
	            nextWeek: 'dddd [ti] LT',
	            lastDay: '[ikte ti] LT',
	            lastWeek: '[ovddit] dddd [ti] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s geažes',
	            past: 'maŋit %s',
	            s: 'moadde sekunddat',
	            ss: '%d sekunddat',
	            m: 'okta minuhta',
	            mm: '%d minuhtat',
	            h: 'okta diimmu',
	            hh: '%d diimmut',
	            d: 'okta beaivi',
	            dd: '%d beaivvit',
	            M: 'okta mánnu',
	            MM: '%d mánut',
	            y: 'okta jahki',
	            yy: '%d jagit',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return se;
	
	})));


/***/ }),
/* 1125 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Sinhalese [si]
	//! author : Sampath Sitinamaluwa : https://github.com/sampathsris
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1021)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    /*jshint -W100*/
	    var si = moment.defineLocale('si', {
	        months: 'ජනවාරි_පෙබරවාරි_මාර්තු_අප්‍රේල්_මැයි_ජූනි_ජූලි_අගෝස්තු_සැප්තැම්බර්_ඔක්තෝබර්_නොවැම්බර්_දෙසැම්බර්'.split(
	            '_'
	        ),
	        monthsShort: 'ජන_පෙබ_මාර්_අප්_මැයි_ජූනි_ජූලි_අගෝ_සැප්_ඔක්_නොවැ_දෙසැ'.split(
	            '_'
	        ),
	        weekdays: 'ඉරිදා_සඳුදා_අඟහරුවාදා_බදාදා_බ්‍රහස්පතින්දා_සිකුරාදා_සෙනසුරාදා'.split(
	            '_'
	        ),
	        weekdaysShort: 'ඉරි_සඳු_අඟ_බදා_බ්‍රහ_සිකු_සෙන'.split('_'),
	        weekdaysMin: 'ඉ_ස_අ_බ_බ්‍ර_සි_සෙ'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'a h:mm',
	            LTS: 'a h:mm:ss',
	            L: 'YYYY/MM/DD',
	            LL: 'YYYY MMMM D',
	            LLL: 'YYYY MMMM D, a h:mm',
	            LLLL: 'YYYY MMMM D [වැනි] dddd, a h:mm:ss',
	        },
	        calendar: {
	            sameDay: '[අද] LT[ට]',
	            nextDay: '[හෙට] LT[ට]',
	            nextWeek: 'dddd LT[ට]',
	            lastDay: '[ඊයේ] LT[ට]',
	            lastWeek: '[පසුගිය] dddd LT[ට]',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%sකින්',
	            past: '%sකට පෙර',
	            s: 'තත්පර කිහිපය',
	            ss: 'තත්පර %d',
	            m: 'මිනිත්තුව',
	            mm: 'මිනිත්තු %d',
	            h: 'පැය',
	            hh: 'පැය %d',
	            d: 'දිනය',
	            dd: 'දින %d',
	            M: 'මාසය',
	            MM: 'මාස %d',
	            y: 'වසර',
	            yy: 'වසර %d',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2} වැනි/,
	        ordinal: function (number) {
	            return number + ' වැනි';
	        },
	        meridiemParse: /පෙර වරු|පස් වරු|පෙ.ව|ප.ව./,
	        isPM: function (input) {
	            return input === 'ප.ව.' || input === 'පස් වරු';
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'ප.ව.' : 'පස් වරු';
	            } else {
	                return isLower ? 'පෙ.ව.' : 'පෙර වරු';
	            }
	        },
	    });
	
	    return si;
	
	})));


/***/ }),
/* 1126 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Slovak [sk]
	//! author : Martin Minka : https://github.com/k2s
	//! based on work of petrbela : https://github.com/petrbela
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1021)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var months = 'január_február_marec_apríl_máj_jún_júl_august_september_október_november_december'.split(
	            '_'
	        ),
	        monthsShort = 'jan_feb_mar_apr_máj_jún_júl_aug_sep_okt_nov_dec'.split('_');
	    function plural(n) {
	        return n > 1 && n < 5;
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's': // a few seconds / in a few seconds / a few seconds ago
	                return withoutSuffix || isFuture ? 'pár sekúnd' : 'pár sekundami';
	            case 'ss': // 9 seconds / in 9 seconds / 9 seconds ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'sekundy' : 'sekúnd');
	                } else {
	                    return result + 'sekundami';
	                }
	            case 'm': // a minute / in a minute / a minute ago
	                return withoutSuffix ? 'minúta' : isFuture ? 'minútu' : 'minútou';
	            case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'minúty' : 'minút');
	                } else {
	                    return result + 'minútami';
	                }
	            case 'h': // an hour / in an hour / an hour ago
	                return withoutSuffix ? 'hodina' : isFuture ? 'hodinu' : 'hodinou';
	            case 'hh': // 9 hours / in 9 hours / 9 hours ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'hodiny' : 'hodín');
	                } else {
	                    return result + 'hodinami';
	                }
	            case 'd': // a day / in a day / a day ago
	                return withoutSuffix || isFuture ? 'deň' : 'dňom';
	            case 'dd': // 9 days / in 9 days / 9 days ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'dni' : 'dní');
	                } else {
	                    return result + 'dňami';
	                }
	            case 'M': // a month / in a month / a month ago
	                return withoutSuffix || isFuture ? 'mesiac' : 'mesiacom';
	            case 'MM': // 9 months / in 9 months / 9 months ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'mesiace' : 'mesiacov');
	                } else {
	                    return result + 'mesiacmi';
	                }
	            case 'y': // a year / in a year / a year ago
	                return withoutSuffix || isFuture ? 'rok' : 'rokom';
	            case 'yy': // 9 years / in 9 years / 9 years ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'roky' : 'rokov');
	                } else {
	                    return result + 'rokmi';
	                }
	        }
	    }
	
	    var sk = moment.defineLocale('sk', {
	        months: months,
	        monthsShort: monthsShort,
	        weekdays: 'nedeľa_pondelok_utorok_streda_štvrtok_piatok_sobota'.split('_'),
	        weekdaysShort: 'ne_po_ut_st_št_pi_so'.split('_'),
	        weekdaysMin: 'ne_po_ut_st_št_pi_so'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd D. MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[dnes o] LT',
	            nextDay: '[zajtra o] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[v nedeľu o] LT';
	                    case 1:
	                    case 2:
	                        return '[v] dddd [o] LT';
	                    case 3:
	                        return '[v stredu o] LT';
	                    case 4:
	                        return '[vo štvrtok o] LT';
	                    case 5:
	                        return '[v piatok o] LT';
	                    case 6:
	                        return '[v sobotu o] LT';
	                }
	            },
	            lastDay: '[včera o] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[minulú nedeľu o] LT';
	                    case 1:
	                    case 2:
	                        return '[minulý] dddd [o] LT';
	                    case 3:
	                        return '[minulú stredu o] LT';
	                    case 4:
	                    case 5:
	                        return '[minulý] dddd [o] LT';
	                    case 6:
	                        return '[minulú sobotu o] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: 'pred %s',
	            s: translate,
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: translate,
	            dd: translate,
	            M: translate,
	            MM: translate,
	            y: translate,
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return sk;
	
	})));


/***/ }),
/* 1127 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Slovenian [sl]
	//! author : Robert Sedovšek : https://github.com/sedovsek
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1021)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's':
	                return withoutSuffix || isFuture
	                    ? 'nekaj sekund'
	                    : 'nekaj sekundami';
	            case 'ss':
	                if (number === 1) {
	                    result += withoutSuffix ? 'sekundo' : 'sekundi';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'sekundi' : 'sekundah';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'sekunde' : 'sekundah';
	                } else {
	                    result += 'sekund';
	                }
	                return result;
	            case 'm':
	                return withoutSuffix ? 'ena minuta' : 'eno minuto';
	            case 'mm':
	                if (number === 1) {
	                    result += withoutSuffix ? 'minuta' : 'minuto';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'minuti' : 'minutama';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'minute' : 'minutami';
	                } else {
	                    result += withoutSuffix || isFuture ? 'minut' : 'minutami';
	                }
	                return result;
	            case 'h':
	                return withoutSuffix ? 'ena ura' : 'eno uro';
	            case 'hh':
	                if (number === 1) {
	                    result += withoutSuffix ? 'ura' : 'uro';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'uri' : 'urama';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'ure' : 'urami';
	                } else {
	                    result += withoutSuffix || isFuture ? 'ur' : 'urami';
	                }
	                return result;
	            case 'd':
	                return withoutSuffix || isFuture ? 'en dan' : 'enim dnem';
	            case 'dd':
	                if (number === 1) {
	                    result += withoutSuffix || isFuture ? 'dan' : 'dnem';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'dni' : 'dnevoma';
	                } else {
	                    result += withoutSuffix || isFuture ? 'dni' : 'dnevi';
	                }
	                return result;
	            case 'M':
	                return withoutSuffix || isFuture ? 'en mesec' : 'enim mesecem';
	            case 'MM':
	                if (number === 1) {
	                    result += withoutSuffix || isFuture ? 'mesec' : 'mesecem';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'meseca' : 'mesecema';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'mesece' : 'meseci';
	                } else {
	                    result += withoutSuffix || isFuture ? 'mesecev' : 'meseci';
	                }
	                return result;
	            case 'y':
	                return withoutSuffix || isFuture ? 'eno leto' : 'enim letom';
	            case 'yy':
	                if (number === 1) {
	                    result += withoutSuffix || isFuture ? 'leto' : 'letom';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'leti' : 'letoma';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'leta' : 'leti';
	                } else {
	                    result += withoutSuffix || isFuture ? 'let' : 'leti';
	                }
	                return result;
	        }
	    }
	
	    var sl = moment.defineLocale('sl', {
	        months: 'januar_februar_marec_april_maj_junij_julij_avgust_september_oktober_november_december'.split(
	            '_'
	        ),
	        monthsShort: 'jan._feb._mar._apr._maj._jun._jul._avg._sep._okt._nov._dec.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'nedelja_ponedeljek_torek_sreda_četrtek_petek_sobota'.split('_'),
	        weekdaysShort: 'ned._pon._tor._sre._čet._pet._sob.'.split('_'),
	        weekdaysMin: 'ne_po_to_sr_če_pe_so'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD. MM. YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[danes ob] LT',
	            nextDay: '[jutri ob] LT',
	
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[v] [nedeljo] [ob] LT';
	                    case 3:
	                        return '[v] [sredo] [ob] LT';
	                    case 6:
	                        return '[v] [soboto] [ob] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[v] dddd [ob] LT';
	                }
	            },
	            lastDay: '[včeraj ob] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[prejšnjo] [nedeljo] [ob] LT';
	                    case 3:
	                        return '[prejšnjo] [sredo] [ob] LT';
	                    case 6:
	                        return '[prejšnjo] [soboto] [ob] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[prejšnji] dddd [ob] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'čez %s',
	            past: 'pred %s',
	            s: processRelativeTime,
	            ss: processRelativeTime,
	            m: processRelativeTime,
	            mm: processRelativeTime,
	            h: processRelativeTime,
	            hh: processRelativeTime,
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return sl;
	
	})));


/***/ }),
/* 1128 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Albanian [sq]
	//! author : Flakërim Ismani : https://github.com/flakerimi
	//! author : Menelion Elensúle : https://github.com/Oire
	//! author : Oerd Cukalla : https://github.com/oerd
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1021)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var sq = moment.defineLocale('sq', {
	        months: 'Janar_Shkurt_Mars_Prill_Maj_Qershor_Korrik_Gusht_Shtator_Tetor_Nëntor_Dhjetor'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Shk_Mar_Pri_Maj_Qer_Kor_Gus_Sht_Tet_Nën_Dhj'.split('_'),
	        weekdays: 'E Diel_E Hënë_E Martë_E Mërkurë_E Enjte_E Premte_E Shtunë'.split(
	            '_'
	        ),
	        weekdaysShort: 'Die_Hën_Mar_Mër_Enj_Pre_Sht'.split('_'),
	        weekdaysMin: 'D_H_Ma_Më_E_P_Sh'.split('_'),
	        weekdaysParseExact: true,
	        meridiemParse: /PD|MD/,
	        isPM: function (input) {
	            return input.charAt(0) === 'M';
	        },
	        meridiem: function (hours, minutes, isLower) {
	            return hours < 12 ? 'PD' : 'MD';
	        },
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Sot në] LT',
	            nextDay: '[Nesër në] LT',
	            nextWeek: 'dddd [në] LT',
	            lastDay: '[Dje në] LT',
	            lastWeek: 'dddd [e kaluar në] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'në %s',
	            past: '%s më parë',
	            s: 'disa sekonda',
	            ss: '%d sekonda',
	            m: 'një minutë',
	            mm: '%d minuta',
	            h: 'një orë',
	            hh: '%d orë',
	            d: 'një ditë',
	            dd: '%d ditë',
	            M: 'një muaj',
	            MM: '%d muaj',
	            y: 'një vit',
	            yy: '%d vite',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return sq;
	
	})));


/***/ }),
/* 1129 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Serbian [sr]
	//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j
	//! author : Stefan Crnjaković <stefan@hotmail.rs> : https://github.com/crnjakovic
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1021)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var translator = {
	        words: {
	            //Different grammatical cases
	            ss: ['sekunda', 'sekunde', 'sekundi'],
	            m: ['jedan minut', 'jedne minute'],
	            mm: ['minut', 'minute', 'minuta'],
	            h: ['jedan sat', 'jednog sata'],
	            hh: ['sat', 'sata', 'sati'],
	            dd: ['dan', 'dana', 'dana'],
	            MM: ['mesec', 'meseca', 'meseci'],
	            yy: ['godina', 'godine', 'godina'],
	        },
	        correctGrammaticalCase: function (number, wordKey) {
	            return number === 1
	                ? wordKey[0]
	                : number >= 2 && number <= 4
	                ? wordKey[1]
	                : wordKey[2];
	        },
	        translate: function (number, withoutSuffix, key) {
	            var wordKey = translator.words[key];
	            if (key.length === 1) {
	                return withoutSuffix ? wordKey[0] : wordKey[1];
	            } else {
	                return (
	                    number +
	                    ' ' +
	                    translator.correctGrammaticalCase(number, wordKey)
	                );
	            }
	        },
	    };
	
	    var sr = moment.defineLocale('sr', {
	        months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split(
	            '_'
	        ),
	        monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'nedelja_ponedeljak_utorak_sreda_četvrtak_petak_subota'.split(
	            '_'
	        ),
	        weekdaysShort: 'ned._pon._uto._sre._čet._pet._sub.'.split('_'),
	        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'D. M. YYYY.',
	            LL: 'D. MMMM YYYY.',
	            LLL: 'D. MMMM YYYY. H:mm',
	            LLLL: 'dddd, D. MMMM YYYY. H:mm',
	        },
	        calendar: {
	            sameDay: '[danas u] LT',
	            nextDay: '[sutra u] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedelju] [u] LT';
	                    case 3:
	                        return '[u] [sredu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay: '[juče u] LT',
	            lastWeek: function () {
	                var lastWeekDays = [
	                    '[prošle] [nedelje] [u] LT',
	                    '[prošlog] [ponedeljka] [u] LT',
	                    '[prošlog] [utorka] [u] LT',
	                    '[prošle] [srede] [u] LT',
	                    '[prošlog] [četvrtka] [u] LT',
	                    '[prošlog] [petka] [u] LT',
	                    '[prošle] [subote] [u] LT',
	                ];
	                return lastWeekDays[this.day()];
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: 'pre %s',
	            s: 'nekoliko sekundi',
	            ss: translator.translate,
	            m: translator.translate,
	            mm: translator.translate,
	            h: translator.translate,
	            hh: translator.translate,
	            d: 'dan',
	            dd: translator.translate,
	            M: 'mesec',
	            MM: translator.translate,
	            y: 'godinu',
	            yy: translator.translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return sr;
	
	})));


/***/ }),
/* 1130 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Serbian Cyrillic [sr-cyrl]
	//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j
	//! author : Stefan Crnjaković <stefan@hotmail.rs> : https://github.com/crnjakovic
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1021)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var translator = {
	        words: {
	            //Different grammatical cases
	            ss: ['секунда', 'секунде', 'секунди'],
	            m: ['један минут', 'једне минуте'],
	            mm: ['минут', 'минуте', 'минута'],
	            h: ['један сат', 'једног сата'],
	            hh: ['сат', 'сата', 'сати'],
	            dd: ['дан', 'дана', 'дана'],
	            MM: ['месец', 'месеца', 'месеци'],
	            yy: ['година', 'године', 'година'],
	        },
	        correctGrammaticalCase: function (number, wordKey) {
	            return number === 1
	                ? wordKey[0]
	                : number >= 2 && number <= 4
	                ? wordKey[1]
	                : wordKey[2];
	        },
	        translate: function (number, withoutSuffix, key) {
	            var wordKey = translator.words[key];
	            if (key.length === 1) {
	                return withoutSuffix ? wordKey[0] : wordKey[1];
	            } else {
	                return (
	                    number +
	                    ' ' +
	                    translator.correctGrammaticalCase(number, wordKey)
	                );
	            }
	        },
	    };
	
	    var srCyrl = moment.defineLocale('sr-cyrl', {
	        months: 'јануар_фебруар_март_април_мај_јун_јул_август_септембар_октобар_новембар_децембар'.split(
	            '_'
	        ),
	        monthsShort: 'јан._феб._мар._апр._мај_јун_јул_авг._сеп._окт._нов._дец.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'недеља_понедељак_уторак_среда_четвртак_петак_субота'.split('_'),
	        weekdaysShort: 'нед._пон._уто._сре._чет._пет._суб.'.split('_'),
	        weekdaysMin: 'не_по_ут_ср_че_пе_су'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'D. M. YYYY.',
	            LL: 'D. MMMM YYYY.',
	            LLL: 'D. MMMM YYYY. H:mm',
	            LLLL: 'dddd, D. MMMM YYYY. H:mm',
	        },
	        calendar: {
	            sameDay: '[данас у] LT',
	            nextDay: '[сутра у] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[у] [недељу] [у] LT';
	                    case 3:
	                        return '[у] [среду] [у] LT';
	                    case 6:
	                        return '[у] [суботу] [у] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[у] dddd [у] LT';
	                }
	            },
	            lastDay: '[јуче у] LT',
	            lastWeek: function () {
	                var lastWeekDays = [
	                    '[прошле] [недеље] [у] LT',
	                    '[прошлог] [понедељка] [у] LT',
	                    '[прошлог] [уторка] [у] LT',
	                    '[прошле] [среде] [у] LT',
	                    '[прошлог] [четвртка] [у] LT',
	                    '[прошлог] [петка] [у] LT',
	                    '[прошле] [суботе] [у] LT',
	                ];
	                return lastWeekDays[this.day()];
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'за %s',
	            past: 'пре %s',
	            s: 'неколико секунди',
	            ss: translator.translate,
	            m: translator.translate,
	            mm: translator.translate,
	            h: translator.translate,
	            hh: translator.translate,
	            d: 'дан',
	            dd: translator.translate,
	            M: 'месец',
	            MM: translator.translate,
	            y: 'годину',
	            yy: translator.translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 1st is the first week of the year.
	        },
	    });
	
	    return srCyrl;
	
	})));


/***/ }),
/* 1131 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : siSwati [ss]
	//! author : Nicolai Davies<mail@nicolai.io> : https://github.com/nicolaidavies
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1021)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ss = moment.defineLocale('ss', {
	        months: "Bhimbidvwane_Indlovana_Indlov'lenkhulu_Mabasa_Inkhwekhweti_Inhlaba_Kholwane_Ingci_Inyoni_Imphala_Lweti_Ingongoni".split(
	            '_'
	        ),
	        monthsShort: 'Bhi_Ina_Inu_Mab_Ink_Inh_Kho_Igc_Iny_Imp_Lwe_Igo'.split('_'),
	        weekdays: 'Lisontfo_Umsombuluko_Lesibili_Lesitsatfu_Lesine_Lesihlanu_Umgcibelo'.split(
	            '_'
	        ),
	        weekdaysShort: 'Lis_Umb_Lsb_Les_Lsi_Lsh_Umg'.split('_'),
	        weekdaysMin: 'Li_Us_Lb_Lt_Ls_Lh_Ug'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY h:mm A',
	            LLLL: 'dddd, D MMMM YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: '[Namuhla nga] LT',
	            nextDay: '[Kusasa nga] LT',
	            nextWeek: 'dddd [nga] LT',
	            lastDay: '[Itolo nga] LT',
	            lastWeek: 'dddd [leliphelile] [nga] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'nga %s',
	            past: 'wenteka nga %s',
	            s: 'emizuzwana lomcane',
	            ss: '%d mzuzwana',
	            m: 'umzuzu',
	            mm: '%d emizuzu',
	            h: 'lihora',
	            hh: '%d emahora',
	            d: 'lilanga',
	            dd: '%d emalanga',
	            M: 'inyanga',
	            MM: '%d tinyanga',
	            y: 'umnyaka',
	            yy: '%d iminyaka',
	        },
	        meridiemParse: /ekuseni|emini|entsambama|ebusuku/,
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'ekuseni';
	            } else if (hours < 15) {
	                return 'emini';
	            } else if (hours < 19) {
	                return 'entsambama';
	            } else {
	                return 'ebusuku';
	            }
	        },
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'ekuseni') {
	                return hour;
	            } else if (meridiem === 'emini') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'entsambama' || meridiem === 'ebusuku') {
	                if (hour === 0) {
	                    return 0;
	                }
	                return hour + 12;
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}/,
	        ordinal: '%d',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return ss;
	
	})));


/***/ }),
/* 1132 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Swedish [sv]
	//! author : Jens Alm : https://github.com/ulmus
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1021)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var sv = moment.defineLocale('sv', {
	        months: 'januari_februari_mars_april_maj_juni_juli_augusti_september_oktober_november_december'.split(
	            '_'
	        ),
	        monthsShort: 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	        weekdays: 'söndag_måndag_tisdag_onsdag_torsdag_fredag_lördag'.split('_'),
	        weekdaysShort: 'sön_mån_tis_ons_tor_fre_lör'.split('_'),
	        weekdaysMin: 'sö_må_ti_on_to_fr_lö'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY [kl.] HH:mm',
	            LLLL: 'dddd D MMMM YYYY [kl.] HH:mm',
	            lll: 'D MMM YYYY HH:mm',
	            llll: 'ddd D MMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Idag] LT',
	            nextDay: '[Imorgon] LT',
	            lastDay: '[Igår] LT',
	            nextWeek: '[På] dddd LT',
	            lastWeek: '[I] dddd[s] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'om %s',
	            past: 'för %s sedan',
	            s: 'några sekunder',
	            ss: '%d sekunder',
	            m: 'en minut',
	            mm: '%d minuter',
	            h: 'en timme',
	            hh: '%d timmar',
	            d: 'en dag',
	            dd: '%d dagar',
	            M: 'en månad',
	            MM: '%d månader',
	            y: 'ett år',
	            yy: '%d år',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(\:e|\:a)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? ':e'
	                        : b === 1
	                        ? ':a'
	                        : b === 2
	                        ? ':a'
	                        : b === 3
	                        ? ':e'
	                        : ':e';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return sv;
	
	})));


/***/ }),
/* 1133 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Swahili [sw]
	//! author : Fahad Kassim : https://github.com/fadsel
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1021)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var sw = moment.defineLocale('sw', {
	        months: 'Januari_Februari_Machi_Aprili_Mei_Juni_Julai_Agosti_Septemba_Oktoba_Novemba_Desemba'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ago_Sep_Okt_Nov_Des'.split('_'),
	        weekdays: 'Jumapili_Jumatatu_Jumanne_Jumatano_Alhamisi_Ijumaa_Jumamosi'.split(
	            '_'
	        ),
	        weekdaysShort: 'Jpl_Jtat_Jnne_Jtan_Alh_Ijm_Jmos'.split('_'),
	        weekdaysMin: 'J2_J3_J4_J5_Al_Ij_J1'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'hh:mm A',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[leo saa] LT',
	            nextDay: '[kesho saa] LT',
	            nextWeek: '[wiki ijayo] dddd [saat] LT',
	            lastDay: '[jana] LT',
	            lastWeek: '[wiki iliyopita] dddd [saat] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s baadaye',
	            past: 'tokea %s',
	            s: 'hivi punde',
	            ss: 'sekunde %d',
	            m: 'dakika moja',
	            mm: 'dakika %d',
	            h: 'saa limoja',
	            hh: 'masaa %d',
	            d: 'siku moja',
	            dd: 'siku %d',
	            M: 'mwezi mmoja',
	            MM: 'miezi %d',
	            y: 'mwaka mmoja',
	            yy: 'miaka %d',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return sw;
	
	})));


/***/ }),
/* 1134 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tamil [ta]
	//! author : Arjunkumar Krishnamoorthy : https://github.com/tk120404
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1021)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '௧',
	            2: '௨',
	            3: '௩',
	            4: '௪',
	            5: '௫',
	            6: '௬',
	            7: '௭',
	            8: '௮',
	            9: '௯',
	            0: '௦',
	        },
	        numberMap = {
	            '௧': '1',
	            '௨': '2',
	            '௩': '3',
	            '௪': '4',
	            '௫': '5',
	            '௬': '6',
	            '௭': '7',
	            '௮': '8',
	            '௯': '9',
	            '௦': '0',
	        };
	
	    var ta = moment.defineLocale('ta', {
	        months: 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split(
	            '_'
	        ),
	        monthsShort: 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split(
	            '_'
	        ),
	        weekdays: 'ஞாயிற்றுக்கிழமை_திங்கட்கிழமை_செவ்வாய்கிழமை_புதன்கிழமை_வியாழக்கிழமை_வெள்ளிக்கிழமை_சனிக்கிழமை'.split(
	            '_'
	        ),
	        weekdaysShort: 'ஞாயிறு_திங்கள்_செவ்வாய்_புதன்_வியாழன்_வெள்ளி_சனி'.split(
	            '_'
	        ),
	        weekdaysMin: 'ஞா_தி_செ_பு_வி_வெ_ச'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, HH:mm',
	            LLLL: 'dddd, D MMMM YYYY, HH:mm',
	        },
	        calendar: {
	            sameDay: '[இன்று] LT',
	            nextDay: '[நாளை] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[நேற்று] LT',
	            lastWeek: '[கடந்த வாரம்] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s இல்',
	            past: '%s முன்',
	            s: 'ஒரு சில விநாடிகள்',
	            ss: '%d விநாடிகள்',
	            m: 'ஒரு நிமிடம்',
	            mm: '%d நிமிடங்கள்',
	            h: 'ஒரு மணி நேரம்',
	            hh: '%d மணி நேரம்',
	            d: 'ஒரு நாள்',
	            dd: '%d நாட்கள்',
	            M: 'ஒரு மாதம்',
	            MM: '%d மாதங்கள்',
	            y: 'ஒரு வருடம்',
	            yy: '%d ஆண்டுகள்',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}வது/,
	        ordinal: function (number) {
	            return number + 'வது';
	        },
	        preparse: function (string) {
	            return string.replace(/[௧௨௩௪௫௬௭௮௯௦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // refer http://ta.wikipedia.org/s/1er1
	        meridiemParse: /யாமம்|வைகறை|காலை|நண்பகல்|எற்பாடு|மாலை/,
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 2) {
	                return ' யாமம்';
	            } else if (hour < 6) {
	                return ' வைகறை'; // வைகறை
	            } else if (hour < 10) {
	                return ' காலை'; // காலை
	            } else if (hour < 14) {
	                return ' நண்பகல்'; // நண்பகல்
	            } else if (hour < 18) {
	                return ' எற்பாடு'; // எற்பாடு
	            } else if (hour < 22) {
	                return ' மாலை'; // மாலை
	            } else {
	                return ' யாமம்';
	            }
	        },
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'யாமம்') {
	                return hour < 2 ? hour : hour + 12;
	            } else if (meridiem === 'வைகறை' || meridiem === 'காலை') {
	                return hour;
	            } else if (meridiem === 'நண்பகல்') {
	                return hour >= 10 ? hour : hour + 12;
	            } else {
	                return hour + 12;
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return ta;
	
	})));


/***/ }),
/* 1135 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Telugu [te]
	//! author : Krishna Chaitanya Thota : https://github.com/kcthota
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1021)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var te = moment.defineLocale('te', {
	        months: 'జనవరి_ఫిబ్రవరి_మార్చి_ఏప్రిల్_మే_జూన్_జులై_ఆగస్టు_సెప్టెంబర్_అక్టోబర్_నవంబర్_డిసెంబర్'.split(
	            '_'
	        ),
	        monthsShort: 'జన._ఫిబ్ర._మార్చి_ఏప్రి._మే_జూన్_జులై_ఆగ._సెప్._అక్టో._నవ._డిసె.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'ఆదివారం_సోమవారం_మంగళవారం_బుధవారం_గురువారం_శుక్రవారం_శనివారం'.split(
	            '_'
	        ),
	        weekdaysShort: 'ఆది_సోమ_మంగళ_బుధ_గురు_శుక్ర_శని'.split('_'),
	        weekdaysMin: 'ఆ_సో_మం_బు_గు_శు_శ'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm',
	            LTS: 'A h:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm',
	        },
	        calendar: {
	            sameDay: '[నేడు] LT',
	            nextDay: '[రేపు] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[నిన్న] LT',
	            lastWeek: '[గత] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s లో',
	            past: '%s క్రితం',
	            s: 'కొన్ని క్షణాలు',
	            ss: '%d సెకన్లు',
	            m: 'ఒక నిమిషం',
	            mm: '%d నిమిషాలు',
	            h: 'ఒక గంట',
	            hh: '%d గంటలు',
	            d: 'ఒక రోజు',
	            dd: '%d రోజులు',
	            M: 'ఒక నెల',
	            MM: '%d నెలలు',
	            y: 'ఒక సంవత్సరం',
	            yy: '%d సంవత్సరాలు',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}వ/,
	        ordinal: '%dవ',
	        meridiemParse: /రాత్రి|ఉదయం|మధ్యాహ్నం|సాయంత్రం/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'రాత్రి') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'ఉదయం') {
	                return hour;
	            } else if (meridiem === 'మధ్యాహ్నం') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'సాయంత్రం') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'రాత్రి';
	            } else if (hour < 10) {
	                return 'ఉదయం';
	            } else if (hour < 17) {
	                return 'మధ్యాహ్నం';
	            } else if (hour < 20) {
	                return 'సాయంత్రం';
	            } else {
	                return 'రాత్రి';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return te;
	
	})));


/***/ }),
/* 1136 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tetun Dili (East Timor) [tet]
	//! author : Joshua Brooks : https://github.com/joshbrooks
	//! author : Onorio De J. Afonso : https://github.com/marobo
	//! author : Sonia Simoes : https://github.com/soniasimoes
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1021)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var tet = moment.defineLocale('tet', {
	        months: 'Janeiru_Fevereiru_Marsu_Abril_Maiu_Juñu_Jullu_Agustu_Setembru_Outubru_Novembru_Dezembru'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
	        weekdays: 'Domingu_Segunda_Tersa_Kuarta_Kinta_Sesta_Sabadu'.split('_'),
	        weekdaysShort: 'Dom_Seg_Ters_Kua_Kint_Sest_Sab'.split('_'),
	        weekdaysMin: 'Do_Seg_Te_Ku_Ki_Ses_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Ohin iha] LT',
	            nextDay: '[Aban iha] LT',
	            nextWeek: 'dddd [iha] LT',
	            lastDay: '[Horiseik iha] LT',
	            lastWeek: 'dddd [semana kotuk] [iha] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'iha %s',
	            past: '%s liuba',
	            s: 'segundu balun',
	            ss: 'segundu %d',
	            m: 'minutu ida',
	            mm: 'minutu %d',
	            h: 'oras ida',
	            hh: 'oras %d',
	            d: 'loron ida',
	            dd: 'loron %d',
	            M: 'fulan ida',
	            MM: 'fulan %d',
	            y: 'tinan ida',
	            yy: 'tinan %d',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return tet;
	
	})));


/***/ }),
/* 1137 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tajik [tg]
	//! author : Orif N. Jr. : https://github.com/orif-jr
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1021)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var suffixes = {
	        0: '-ум',
	        1: '-ум',
	        2: '-юм',
	        3: '-юм',
	        4: '-ум',
	        5: '-ум',
	        6: '-ум',
	        7: '-ум',
	        8: '-ум',
	        9: '-ум',
	        10: '-ум',
	        12: '-ум',
	        13: '-ум',
	        20: '-ум',
	        30: '-юм',
	        40: '-ум',
	        50: '-ум',
	        60: '-ум',
	        70: '-ум',
	        80: '-ум',
	        90: '-ум',
	        100: '-ум',
	    };
	
	    var tg = moment.defineLocale('tg', {
	        months: {
	            format: 'январи_феврали_марти_апрели_майи_июни_июли_августи_сентябри_октябри_ноябри_декабри'.split(
	                '_'
	            ),
	            standalone: 'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split(
	                '_'
	            ),
	        },
	        monthsShort: 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
	        weekdays: 'якшанбе_душанбе_сешанбе_чоршанбе_панҷшанбе_ҷумъа_шанбе'.split(
	            '_'
	        ),
	        weekdaysShort: 'яшб_дшб_сшб_чшб_пшб_ҷум_шнб'.split('_'),
	        weekdaysMin: 'яш_дш_сш_чш_пш_ҷм_шб'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Имрӯз соати] LT',
	            nextDay: '[Фардо соати] LT',
	            lastDay: '[Дирӯз соати] LT',
	            nextWeek: 'dddd[и] [ҳафтаи оянда соати] LT',
	            lastWeek: 'dddd[и] [ҳафтаи гузашта соати] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'баъди %s',
	            past: '%s пеш',
	            s: 'якчанд сония',
	            m: 'як дақиқа',
	            mm: '%d дақиқа',
	            h: 'як соат',
	            hh: '%d соат',
	            d: 'як рӯз',
	            dd: '%d рӯз',
	            M: 'як моҳ',
	            MM: '%d моҳ',
	            y: 'як сол',
	            yy: '%d сол',
	        },
	        meridiemParse: /шаб|субҳ|рӯз|бегоҳ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'шаб') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'субҳ') {
	                return hour;
	            } else if (meridiem === 'рӯз') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'бегоҳ') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'шаб';
	            } else if (hour < 11) {
	                return 'субҳ';
	            } else if (hour < 16) {
	                return 'рӯз';
	            } else if (hour < 19) {
	                return 'бегоҳ';
	            } else {
	                return 'шаб';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ум|юм)/,
	        ordinal: function (number) {
	            var a = number % 10,
	                b = number >= 100 ? 100 : null;
	            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 1th is the first week of the year.
	        },
	    });
	
	    return tg;
	
	})));


/***/ }),
/* 1138 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Thai [th]
	//! author : Kridsada Thanabulpong : https://github.com/sirn
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1021)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var th = moment.defineLocale('th', {
	        months: 'มกราคม_กุมภาพันธ์_มีนาคม_เมษายน_พฤษภาคม_มิถุนายน_กรกฎาคม_สิงหาคม_กันยายน_ตุลาคม_พฤศจิกายน_ธันวาคม'.split(
	            '_'
	        ),
	        monthsShort: 'ม.ค._ก.พ._มี.ค._เม.ย._พ.ค._มิ.ย._ก.ค._ส.ค._ก.ย._ต.ค._พ.ย._ธ.ค.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัสบดี_ศุกร์_เสาร์'.split('_'),
	        weekdaysShort: 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัส_ศุกร์_เสาร์'.split('_'), // yes, three characters difference
	        weekdaysMin: 'อา._จ._อ._พ._พฤ._ศ._ส.'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY เวลา H:mm',
	            LLLL: 'วันddddที่ D MMMM YYYY เวลา H:mm',
	        },
	        meridiemParse: /ก่อนเที่ยง|หลังเที่ยง/,
	        isPM: function (input) {
	            return input === 'หลังเที่ยง';
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ก่อนเที่ยง';
	            } else {
	                return 'หลังเที่ยง';
	            }
	        },
	        calendar: {
	            sameDay: '[วันนี้ เวลา] LT',
	            nextDay: '[พรุ่งนี้ เวลา] LT',
	            nextWeek: 'dddd[หน้า เวลา] LT',
	            lastDay: '[เมื่อวานนี้ เวลา] LT',
	            lastWeek: '[วัน]dddd[ที่แล้ว เวลา] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'อีก %s',
	            past: '%sที่แล้ว',
	            s: 'ไม่กี่วินาที',
	            ss: '%d วินาที',
	            m: '1 นาที',
	            mm: '%d นาที',
	            h: '1 ชั่วโมง',
	            hh: '%d ชั่วโมง',
	            d: '1 วัน',
	            dd: '%d วัน',
	            w: '1 สัปดาห์',
	            ww: '%d สัปดาห์',
	            M: '1 เดือน',
	            MM: '%d เดือน',
	            y: '1 ปี',
	            yy: '%d ปี',
	        },
	    });
	
	    return th;
	
	})));


/***/ }),
/* 1139 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Turkmen [tk]
	//! author : Atamyrat Abdyrahmanov : https://github.com/atamyratabdy
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1021)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var suffixes = {
	        1: "'inji",
	        5: "'inji",
	        8: "'inji",
	        70: "'inji",
	        80: "'inji",
	        2: "'nji",
	        7: "'nji",
	        20: "'nji",
	        50: "'nji",
	        3: "'ünji",
	        4: "'ünji",
	        100: "'ünji",
	        6: "'njy",
	        9: "'unjy",
	        10: "'unjy",
	        30: "'unjy",
	        60: "'ynjy",
	        90: "'ynjy",
	    };
	
	    var tk = moment.defineLocale('tk', {
	        months: 'Ýanwar_Fewral_Mart_Aprel_Maý_Iýun_Iýul_Awgust_Sentýabr_Oktýabr_Noýabr_Dekabr'.split(
	            '_'
	        ),
	        monthsShort: 'Ýan_Few_Mar_Apr_Maý_Iýn_Iýl_Awg_Sen_Okt_Noý_Dek'.split('_'),
	        weekdays: 'Ýekşenbe_Duşenbe_Sişenbe_Çarşenbe_Penşenbe_Anna_Şenbe'.split(
	            '_'
	        ),
	        weekdaysShort: 'Ýek_Duş_Siş_Çar_Pen_Ann_Şen'.split('_'),
	        weekdaysMin: 'Ýk_Dş_Sş_Çr_Pn_An_Şn'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[bugün sagat] LT',
	            nextDay: '[ertir sagat] LT',
	            nextWeek: '[indiki] dddd [sagat] LT',
	            lastDay: '[düýn] LT',
	            lastWeek: '[geçen] dddd [sagat] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s soň',
	            past: '%s öň',
	            s: 'birnäçe sekunt',
	            m: 'bir minut',
	            mm: '%d minut',
	            h: 'bir sagat',
	            hh: '%d sagat',
	            d: 'bir gün',
	            dd: '%d gün',
	            M: 'bir aý',
	            MM: '%d aý',
	            y: 'bir ýyl',
	            yy: '%d ýyl',
	        },
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'Do':
	                case 'DD':
	                    return number;
	                default:
	                    if (number === 0) {
	                        // special case for zero
	                        return number + "'unjy";
	                    }
	                    var a = number % 10,
	                        b = (number % 100) - a,
	                        c = number >= 100 ? 100 : null;
	                    return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return tk;
	
	})));


/***/ }),
/* 1140 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tagalog (Philippines) [tl-ph]
	//! author : Dan Hagman : https://github.com/hagmandan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1021)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var tlPh = moment.defineLocale('tl-ph', {
	        months: 'Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre'.split(
	            '_'
	        ),
	        monthsShort: 'Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis'.split('_'),
	        weekdays: 'Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado'.split(
	            '_'
	        ),
	        weekdaysShort: 'Lin_Lun_Mar_Miy_Huw_Biy_Sab'.split('_'),
	        weekdaysMin: 'Li_Lu_Ma_Mi_Hu_Bi_Sab'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'MM/D/YYYY',
	            LL: 'MMMM D, YYYY',
	            LLL: 'MMMM D, YYYY HH:mm',
	            LLLL: 'dddd, MMMM DD, YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: 'LT [ngayong araw]',
	            nextDay: '[Bukas ng] LT',
	            nextWeek: 'LT [sa susunod na] dddd',
	            lastDay: 'LT [kahapon]',
	            lastWeek: 'LT [noong nakaraang] dddd',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'sa loob ng %s',
	            past: '%s ang nakalipas',
	            s: 'ilang segundo',
	            ss: '%d segundo',
	            m: 'isang minuto',
	            mm: '%d minuto',
	            h: 'isang oras',
	            hh: '%d oras',
	            d: 'isang araw',
	            dd: '%d araw',
	            M: 'isang buwan',
	            MM: '%d buwan',
	            y: 'isang taon',
	            yy: '%d taon',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}/,
	        ordinal: function (number) {
	            return number;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return tlPh;
	
	})));


/***/ }),
/* 1141 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Klingon [tlh]
	//! author : Dominika Kruk : https://github.com/amaranthrose
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1021)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var numbersNouns = 'pagh_wa’_cha’_wej_loS_vagh_jav_Soch_chorgh_Hut'.split('_');
	
	    function translateFuture(output) {
	        var time = output;
	        time =
	            output.indexOf('jaj') !== -1
	                ? time.slice(0, -3) + 'leS'
	                : output.indexOf('jar') !== -1
	                ? time.slice(0, -3) + 'waQ'
	                : output.indexOf('DIS') !== -1
	                ? time.slice(0, -3) + 'nem'
	                : time + ' pIq';
	        return time;
	    }
	
	    function translatePast(output) {
	        var time = output;
	        time =
	            output.indexOf('jaj') !== -1
	                ? time.slice(0, -3) + 'Hu’'
	                : output.indexOf('jar') !== -1
	                ? time.slice(0, -3) + 'wen'
	                : output.indexOf('DIS') !== -1
	                ? time.slice(0, -3) + 'ben'
	                : time + ' ret';
	        return time;
	    }
	
	    function translate(number, withoutSuffix, string, isFuture) {
	        var numberNoun = numberAsNoun(number);
	        switch (string) {
	            case 'ss':
	                return numberNoun + ' lup';
	            case 'mm':
	                return numberNoun + ' tup';
	            case 'hh':
	                return numberNoun + ' rep';
	            case 'dd':
	                return numberNoun + ' jaj';
	            case 'MM':
	                return numberNoun + ' jar';
	            case 'yy':
	                return numberNoun + ' DIS';
	        }
	    }
	
	    function numberAsNoun(number) {
	        var hundred = Math.floor((number % 1000) / 100),
	            ten = Math.floor((number % 100) / 10),
	            one = number % 10,
	            word = '';
	        if (hundred > 0) {
	            word += numbersNouns[hundred] + 'vatlh';
	        }
	        if (ten > 0) {
	            word += (word !== '' ? ' ' : '') + numbersNouns[ten] + 'maH';
	        }
	        if (one > 0) {
	            word += (word !== '' ? ' ' : '') + numbersNouns[one];
	        }
	        return word === '' ? 'pagh' : word;
	    }
	
	    var tlh = moment.defineLocale('tlh', {
	        months: 'tera’ jar wa’_tera’ jar cha’_tera’ jar wej_tera’ jar loS_tera’ jar vagh_tera’ jar jav_tera’ jar Soch_tera’ jar chorgh_tera’ jar Hut_tera’ jar wa’maH_tera’ jar wa’maH wa’_tera’ jar wa’maH cha’'.split(
	            '_'
	        ),
	        monthsShort: 'jar wa’_jar cha’_jar wej_jar loS_jar vagh_jar jav_jar Soch_jar chorgh_jar Hut_jar wa’maH_jar wa’maH wa’_jar wa’maH cha’'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split(
	            '_'
	        ),
	        weekdaysShort: 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split(
	            '_'
	        ),
	        weekdaysMin: 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split(
	            '_'
	        ),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[DaHjaj] LT',
	            nextDay: '[wa’leS] LT',
	            nextWeek: 'LLL',
	            lastDay: '[wa’Hu’] LT',
	            lastWeek: 'LLL',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: translateFuture,
	            past: translatePast,
	            s: 'puS lup',
	            ss: translate,
	            m: 'wa’ tup',
	            mm: translate,
	            h: 'wa’ rep',
	            hh: translate,
	            d: 'wa’ jaj',
	            dd: translate,
	            M: 'wa’ jar',
	            MM: translate,
	            y: 'wa’ DIS',
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return tlh;
	
	})));


/***/ }),
/* 1142 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Turkish [tr]
	//! authors : Erhan Gundogan : https://github.com/erhangundogan,
	//!           Burak Yiğit Kaya: https://github.com/BYK
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1021)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var suffixes = {
	        1: "'inci",
	        5: "'inci",
	        8: "'inci",
	        70: "'inci",
	        80: "'inci",
	        2: "'nci",
	        7: "'nci",
	        20: "'nci",
	        50: "'nci",
	        3: "'üncü",
	        4: "'üncü",
	        100: "'üncü",
	        6: "'ncı",
	        9: "'uncu",
	        10: "'uncu",
	        30: "'uncu",
	        60: "'ıncı",
	        90: "'ıncı",
	    };
	
	    var tr = moment.defineLocale('tr', {
	        months: 'Ocak_Şubat_Mart_Nisan_Mayıs_Haziran_Temmuz_Ağustos_Eylül_Ekim_Kasım_Aralık'.split(
	            '_'
	        ),
	        monthsShort: 'Oca_Şub_Mar_Nis_May_Haz_Tem_Ağu_Eyl_Eki_Kas_Ara'.split('_'),
	        weekdays: 'Pazar_Pazartesi_Salı_Çarşamba_Perşembe_Cuma_Cumartesi'.split(
	            '_'
	        ),
	        weekdaysShort: 'Paz_Pts_Sal_Çar_Per_Cum_Cts'.split('_'),
	        weekdaysMin: 'Pz_Pt_Sa_Ça_Pe_Cu_Ct'.split('_'),
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower ? 'öö' : 'ÖÖ';
	            } else {
	                return isLower ? 'ös' : 'ÖS';
	            }
	        },
	        meridiemParse: /öö|ÖÖ|ös|ÖS/,
	        isPM: function (input) {
	            return input === 'ös' || input === 'ÖS';
	        },
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[bugün saat] LT',
	            nextDay: '[yarın saat] LT',
	            nextWeek: '[gelecek] dddd [saat] LT',
	            lastDay: '[dün] LT',
	            lastWeek: '[geçen] dddd [saat] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s sonra',
	            past: '%s önce',
	            s: 'birkaç saniye',
	            ss: '%d saniye',
	            m: 'bir dakika',
	            mm: '%d dakika',
	            h: 'bir saat',
	            hh: '%d saat',
	            d: 'bir gün',
	            dd: '%d gün',
	            w: 'bir hafta',
	            ww: '%d hafta',
	            M: 'bir ay',
	            MM: '%d ay',
	            y: 'bir yıl',
	            yy: '%d yıl',
	        },
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'Do':
	                case 'DD':
	                    return number;
	                default:
	                    if (number === 0) {
	                        // special case for zero
	                        return number + "'ıncı";
	                    }
	                    var a = number % 10,
	                        b = (number % 100) - a,
	                        c = number >= 100 ? 100 : null;
	                    return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return tr;
	
	})));


/***/ }),
/* 1143 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Talossan [tzl]
	//! author : Robin van der Vliet : https://github.com/robin0van0der0v
	//! author : Iustì Canun
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1021)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    // After the year there should be a slash and the amount of years since December 26, 1979 in Roman numerals.
	    // This is currently too difficult (maybe even impossible) to add.
	    var tzl = moment.defineLocale('tzl', {
	        months: 'Januar_Fevraglh_Març_Avrïu_Mai_Gün_Julia_Guscht_Setemvar_Listopäts_Noemvar_Zecemvar'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Fev_Mar_Avr_Mai_Gün_Jul_Gus_Set_Lis_Noe_Zec'.split('_'),
	        weekdays: 'Súladi_Lúneçi_Maitzi_Márcuri_Xhúadi_Viénerçi_Sáturi'.split('_'),
	        weekdaysShort: 'Súl_Lún_Mai_Már_Xhú_Vié_Sát'.split('_'),
	        weekdaysMin: 'Sú_Lú_Ma_Má_Xh_Vi_Sá'.split('_'),
	        longDateFormat: {
	            LT: 'HH.mm',
	            LTS: 'HH.mm.ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM [dallas] YYYY',
	            LLL: 'D. MMMM [dallas] YYYY HH.mm',
	            LLLL: 'dddd, [li] D. MMMM [dallas] YYYY HH.mm',
	        },
	        meridiemParse: /d\'o|d\'a/i,
	        isPM: function (input) {
	            return "d'o" === input.toLowerCase();
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? "d'o" : "D'O";
	            } else {
	                return isLower ? "d'a" : "D'A";
	            }
	        },
	        calendar: {
	            sameDay: '[oxhi à] LT',
	            nextDay: '[demà à] LT',
	            nextWeek: 'dddd [à] LT',
	            lastDay: '[ieiri à] LT',
	            lastWeek: '[sür el] dddd [lasteu à] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'osprei %s',
	            past: 'ja%s',
	            s: processRelativeTime,
	            ss: processRelativeTime,
	            m: processRelativeTime,
	            mm: processRelativeTime,
	            h: processRelativeTime,
	            hh: processRelativeTime,
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            s: ['viensas secunds', "'iensas secunds"],
	            ss: [number + ' secunds', '' + number + ' secunds'],
	            m: ["'n míut", "'iens míut"],
	            mm: [number + ' míuts', '' + number + ' míuts'],
	            h: ["'n þora", "'iensa þora"],
	            hh: [number + ' þoras', '' + number + ' þoras'],
	            d: ["'n ziua", "'iensa ziua"],
	            dd: [number + ' ziuas', '' + number + ' ziuas'],
	            M: ["'n mes", "'iens mes"],
	            MM: [number + ' mesen', '' + number + ' mesen'],
	            y: ["'n ar", "'iens ar"],
	            yy: [number + ' ars', '' + number + ' ars'],
	        };
	        return isFuture
	            ? format[key][0]
	            : withoutSuffix
	            ? format[key][0]
	            : format[key][1];
	    }
	
	    return tzl;
	
	})));


/***/ }),
/* 1144 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Central Atlas Tamazight [tzm]
	//! author : Abdel Said : https://github.com/abdelsaid
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1021)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var tzm = moment.defineLocale('tzm', {
	        months: 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split(
	            '_'
	        ),
	        monthsShort: 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split(
	            '_'
	        ),
	        weekdays: 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	        weekdaysShort: 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	        weekdaysMin: 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[ⴰⵙⴷⵅ ⴴ] LT',
	            nextDay: '[ⴰⵙⴽⴰ ⴴ] LT',
	            nextWeek: 'dddd [ⴴ] LT',
	            lastDay: '[ⴰⵚⴰⵏⵜ ⴴ] LT',
	            lastWeek: 'dddd [ⴴ] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'ⴷⴰⴷⵅ ⵙ ⵢⴰⵏ %s',
	            past: 'ⵢⴰⵏ %s',
	            s: 'ⵉⵎⵉⴽ',
	            ss: '%d ⵉⵎⵉⴽ',
	            m: 'ⵎⵉⵏⵓⴺ',
	            mm: '%d ⵎⵉⵏⵓⴺ',
	            h: 'ⵙⴰⵄⴰ',
	            hh: '%d ⵜⴰⵙⵙⴰⵄⵉⵏ',
	            d: 'ⴰⵙⵙ',
	            dd: '%d oⵙⵙⴰⵏ',
	            M: 'ⴰⵢoⵓⵔ',
	            MM: '%d ⵉⵢⵢⵉⵔⵏ',
	            y: 'ⴰⵙⴳⴰⵙ',
	            yy: '%d ⵉⵙⴳⴰⵙⵏ',
	        },
	        week: {
	            dow: 6, // Saturday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return tzm;
	
	})));


/***/ }),
/* 1145 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Central Atlas Tamazight Latin [tzm-latn]
	//! author : Abdel Said : https://github.com/abdelsaid
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1021)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var tzmLatn = moment.defineLocale('tzm-latn', {
	        months: 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split(
	            '_'
	        ),
	        monthsShort: 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split(
	            '_'
	        ),
	        weekdays: 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	        weekdaysShort: 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	        weekdaysMin: 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[asdkh g] LT',
	            nextDay: '[aska g] LT',
	            nextWeek: 'dddd [g] LT',
	            lastDay: '[assant g] LT',
	            lastWeek: 'dddd [g] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'dadkh s yan %s',
	            past: 'yan %s',
	            s: 'imik',
	            ss: '%d imik',
	            m: 'minuḍ',
	            mm: '%d minuḍ',
	            h: 'saɛa',
	            hh: '%d tassaɛin',
	            d: 'ass',
	            dd: '%d ossan',
	            M: 'ayowr',
	            MM: '%d iyyirn',
	            y: 'asgas',
	            yy: '%d isgasn',
	        },
	        week: {
	            dow: 6, // Saturday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return tzmLatn;
	
	})));


/***/ }),
/* 1146 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Uyghur (China) [ug-cn]
	//! author: boyaq : https://github.com/boyaq
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1021)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ugCn = moment.defineLocale('ug-cn', {
	        months: 'يانۋار_فېۋرال_مارت_ئاپرېل_ماي_ئىيۇن_ئىيۇل_ئاۋغۇست_سېنتەبىر_ئۆكتەبىر_نويابىر_دېكابىر'.split(
	            '_'
	        ),
	        monthsShort: 'يانۋار_فېۋرال_مارت_ئاپرېل_ماي_ئىيۇن_ئىيۇل_ئاۋغۇست_سېنتەبىر_ئۆكتەبىر_نويابىر_دېكابىر'.split(
	            '_'
	        ),
	        weekdays: 'يەكشەنبە_دۈشەنبە_سەيشەنبە_چارشەنبە_پەيشەنبە_جۈمە_شەنبە'.split(
	            '_'
	        ),
	        weekdaysShort: 'يە_دۈ_سە_چا_پە_جۈ_شە'.split('_'),
	        weekdaysMin: 'يە_دۈ_سە_چا_پە_جۈ_شە'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'YYYY-يىلىM-ئاينىڭD-كۈنى',
	            LLL: 'YYYY-يىلىM-ئاينىڭD-كۈنى، HH:mm',
	            LLLL: 'dddd، YYYY-يىلىM-ئاينىڭD-كۈنى، HH:mm',
	        },
	        meridiemParse: /يېرىم كېچە|سەھەر|چۈشتىن بۇرۇن|چۈش|چۈشتىن كېيىن|كەچ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (
	                meridiem === 'يېرىم كېچە' ||
	                meridiem === 'سەھەر' ||
	                meridiem === 'چۈشتىن بۇرۇن'
	            ) {
	                return hour;
	            } else if (meridiem === 'چۈشتىن كېيىن' || meridiem === 'كەچ') {
	                return hour + 12;
	            } else {
	                return hour >= 11 ? hour : hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return 'يېرىم كېچە';
	            } else if (hm < 900) {
	                return 'سەھەر';
	            } else if (hm < 1130) {
	                return 'چۈشتىن بۇرۇن';
	            } else if (hm < 1230) {
	                return 'چۈش';
	            } else if (hm < 1800) {
	                return 'چۈشتىن كېيىن';
	            } else {
	                return 'كەچ';
	            }
	        },
	        calendar: {
	            sameDay: '[بۈگۈن سائەت] LT',
	            nextDay: '[ئەتە سائەت] LT',
	            nextWeek: '[كېلەركى] dddd [سائەت] LT',
	            lastDay: '[تۆنۈگۈن] LT',
	            lastWeek: '[ئالدىنقى] dddd [سائەت] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s كېيىن',
	            past: '%s بۇرۇن',
	            s: 'نەچچە سېكونت',
	            ss: '%d سېكونت',
	            m: 'بىر مىنۇت',
	            mm: '%d مىنۇت',
	            h: 'بىر سائەت',
	            hh: '%d سائەت',
	            d: 'بىر كۈن',
	            dd: '%d كۈن',
	            M: 'بىر ئاي',
	            MM: '%d ئاي',
	            y: 'بىر يىل',
	            yy: '%d يىل',
	        },
	
	        dayOfMonthOrdinalParse: /\d{1,2}(-كۈنى|-ئاي|-ھەپتە)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '-كۈنى';
	                case 'w':
	                case 'W':
	                    return number + '-ھەپتە';
	                default:
	                    return number;
	            }
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week: {
	            // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 1st is the first week of the year.
	        },
	    });
	
	    return ugCn;
	
	})));


/***/ }),
/* 1147 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Ukrainian [uk]
	//! author : zemlanin : https://github.com/zemlanin
	//! Author : Menelion Elensúle : https://github.com/Oire
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1021)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function plural(word, num) {
	        var forms = word.split('_');
	        return num % 10 === 1 && num % 100 !== 11
	            ? forms[0]
	            : num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20)
	            ? forms[1]
	            : forms[2];
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	            ss: withoutSuffix ? 'секунда_секунди_секунд' : 'секунду_секунди_секунд',
	            mm: withoutSuffix ? 'хвилина_хвилини_хвилин' : 'хвилину_хвилини_хвилин',
	            hh: withoutSuffix ? 'година_години_годин' : 'годину_години_годин',
	            dd: 'день_дні_днів',
	            MM: 'місяць_місяці_місяців',
	            yy: 'рік_роки_років',
	        };
	        if (key === 'm') {
	            return withoutSuffix ? 'хвилина' : 'хвилину';
	        } else if (key === 'h') {
	            return withoutSuffix ? 'година' : 'годину';
	        } else {
	            return number + ' ' + plural(format[key], +number);
	        }
	    }
	    function weekdaysCaseReplace(m, format) {
	        var weekdays = {
	                nominative: 'неділя_понеділок_вівторок_середа_четвер_п’ятниця_субота'.split(
	                    '_'
	                ),
	                accusative: 'неділю_понеділок_вівторок_середу_четвер_п’ятницю_суботу'.split(
	                    '_'
	                ),
	                genitive: 'неділі_понеділка_вівторка_середи_четверга_п’ятниці_суботи'.split(
	                    '_'
	                ),
	            },
	            nounCase;
	
	        if (m === true) {
	            return weekdays['nominative']
	                .slice(1, 7)
	                .concat(weekdays['nominative'].slice(0, 1));
	        }
	        if (!m) {
	            return weekdays['nominative'];
	        }
	
	        nounCase = /(\[[ВвУу]\]) ?dddd/.test(format)
	            ? 'accusative'
	            : /\[?(?:минулої|наступної)? ?\] ?dddd/.test(format)
	            ? 'genitive'
	            : 'nominative';
	        return weekdays[nounCase][m.day()];
	    }
	    function processHoursFunction(str) {
	        return function () {
	            return str + 'о' + (this.hours() === 11 ? 'б' : '') + '] LT';
	        };
	    }
	
	    var uk = moment.defineLocale('uk', {
	        months: {
	            format: 'січня_лютого_березня_квітня_травня_червня_липня_серпня_вересня_жовтня_листопада_грудня'.split(
	                '_'
	            ),
	            standalone: 'січень_лютий_березень_квітень_травень_червень_липень_серпень_вересень_жовтень_листопад_грудень'.split(
	                '_'
	            ),
	        },
	        monthsShort: 'січ_лют_бер_квіт_трав_черв_лип_серп_вер_жовт_лист_груд'.split(
	            '_'
	        ),
	        weekdays: weekdaysCaseReplace,
	        weekdaysShort: 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	        weekdaysMin: 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY р.',
	            LLL: 'D MMMM YYYY р., HH:mm',
	            LLLL: 'dddd, D MMMM YYYY р., HH:mm',
	        },
	        calendar: {
	            sameDay: processHoursFunction('[Сьогодні '),
	            nextDay: processHoursFunction('[Завтра '),
	            lastDay: processHoursFunction('[Вчора '),
	            nextWeek: processHoursFunction('[У] dddd ['),
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 5:
	                    case 6:
	                        return processHoursFunction('[Минулої] dddd [').call(this);
	                    case 1:
	                    case 2:
	                    case 4:
	                        return processHoursFunction('[Минулого] dddd [').call(this);
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'за %s',
	            past: '%s тому',
	            s: 'декілька секунд',
	            ss: relativeTimeWithPlural,
	            m: relativeTimeWithPlural,
	            mm: relativeTimeWithPlural,
	            h: 'годину',
	            hh: relativeTimeWithPlural,
	            d: 'день',
	            dd: relativeTimeWithPlural,
	            M: 'місяць',
	            MM: relativeTimeWithPlural,
	            y: 'рік',
	            yy: relativeTimeWithPlural,
	        },
	        // M. E.: those two are virtually unused but a user might want to implement them for his/her website for some reason
	        meridiemParse: /ночі|ранку|дня|вечора/,
	        isPM: function (input) {
	            return /^(дня|вечора)$/.test(input);
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ночі';
	            } else if (hour < 12) {
	                return 'ранку';
	            } else if (hour < 17) {
	                return 'дня';
	            } else {
	                return 'вечора';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(й|го)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'M':
	                case 'd':
	                case 'DDD':
	                case 'w':
	                case 'W':
	                    return number + '-й';
	                case 'D':
	                    return number + '-го';
	                default:
	                    return number;
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return uk;
	
	})));


/***/ }),
/* 1148 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Urdu [ur]
	//! author : Sawood Alam : https://github.com/ibnesayeed
	//! author : Zack : https://github.com/ZackVision
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1021)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var months = [
	            'جنوری',
	            'فروری',
	            'مارچ',
	            'اپریل',
	            'مئی',
	            'جون',
	            'جولائی',
	            'اگست',
	            'ستمبر',
	            'اکتوبر',
	            'نومبر',
	            'دسمبر',
	        ],
	        days = ['اتوار', 'پیر', 'منگل', 'بدھ', 'جمعرات', 'جمعہ', 'ہفتہ'];
	
	    var ur = moment.defineLocale('ur', {
	        months: months,
	        monthsShort: months,
	        weekdays: days,
	        weekdaysShort: days,
	        weekdaysMin: days,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd، D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /صبح|شام/,
	        isPM: function (input) {
	            return 'شام' === input;
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'صبح';
	            }
	            return 'شام';
	        },
	        calendar: {
	            sameDay: '[آج بوقت] LT',
	            nextDay: '[کل بوقت] LT',
	            nextWeek: 'dddd [بوقت] LT',
	            lastDay: '[گذشتہ روز بوقت] LT',
	            lastWeek: '[گذشتہ] dddd [بوقت] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s بعد',
	            past: '%s قبل',
	            s: 'چند سیکنڈ',
	            ss: '%d سیکنڈ',
	            m: 'ایک منٹ',
	            mm: '%d منٹ',
	            h: 'ایک گھنٹہ',
	            hh: '%d گھنٹے',
	            d: 'ایک دن',
	            dd: '%d دن',
	            M: 'ایک ماہ',
	            MM: '%d ماہ',
	            y: 'ایک سال',
	            yy: '%d سال',
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return ur;
	
	})));


/***/ }),
/* 1149 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Uzbek [uz]
	//! author : Sardor Muminov : https://github.com/muminoff
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1021)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var uz = moment.defineLocale('uz', {
	        months: 'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split(
	            '_'
	        ),
	        monthsShort: 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
	        weekdays: 'Якшанба_Душанба_Сешанба_Чоршанба_Пайшанба_Жума_Шанба'.split('_'),
	        weekdaysShort: 'Якш_Душ_Сеш_Чор_Пай_Жум_Шан'.split('_'),
	        weekdaysMin: 'Як_Ду_Се_Чо_Па_Жу_Ша'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'D MMMM YYYY, dddd HH:mm',
	        },
	        calendar: {
	            sameDay: '[Бугун соат] LT [да]',
	            nextDay: '[Эртага] LT [да]',
	            nextWeek: 'dddd [куни соат] LT [да]',
	            lastDay: '[Кеча соат] LT [да]',
	            lastWeek: '[Утган] dddd [куни соат] LT [да]',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'Якин %s ичида',
	            past: 'Бир неча %s олдин',
	            s: 'фурсат',
	            ss: '%d фурсат',
	            m: 'бир дакика',
	            mm: '%d дакика',
	            h: 'бир соат',
	            hh: '%d соат',
	            d: 'бир кун',
	            dd: '%d кун',
	            M: 'бир ой',
	            MM: '%d ой',
	            y: 'бир йил',
	            yy: '%d йил',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return uz;
	
	})));


/***/ }),
/* 1150 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Uzbek Latin [uz-latn]
	//! author : Rasulbek Mirzayev : github.com/Rasulbeeek
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1021)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var uzLatn = moment.defineLocale('uz-latn', {
	        months: 'Yanvar_Fevral_Mart_Aprel_May_Iyun_Iyul_Avgust_Sentabr_Oktabr_Noyabr_Dekabr'.split(
	            '_'
	        ),
	        monthsShort: 'Yan_Fev_Mar_Apr_May_Iyun_Iyul_Avg_Sen_Okt_Noy_Dek'.split('_'),
	        weekdays: 'Yakshanba_Dushanba_Seshanba_Chorshanba_Payshanba_Juma_Shanba'.split(
	            '_'
	        ),
	        weekdaysShort: 'Yak_Dush_Sesh_Chor_Pay_Jum_Shan'.split('_'),
	        weekdaysMin: 'Ya_Du_Se_Cho_Pa_Ju_Sha'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'D MMMM YYYY, dddd HH:mm',
	        },
	        calendar: {
	            sameDay: '[Bugun soat] LT [da]',
	            nextDay: '[Ertaga] LT [da]',
	            nextWeek: 'dddd [kuni soat] LT [da]',
	            lastDay: '[Kecha soat] LT [da]',
	            lastWeek: "[O'tgan] dddd [kuni soat] LT [da]",
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'Yaqin %s ichida',
	            past: 'Bir necha %s oldin',
	            s: 'soniya',
	            ss: '%d soniya',
	            m: 'bir daqiqa',
	            mm: '%d daqiqa',
	            h: 'bir soat',
	            hh: '%d soat',
	            d: 'bir kun',
	            dd: '%d kun',
	            M: 'bir oy',
	            MM: '%d oy',
	            y: 'bir yil',
	            yy: '%d yil',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return uzLatn;
	
	})));


/***/ }),
/* 1151 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Vietnamese [vi]
	//! author : Bang Nguyen : https://github.com/bangnk
	//! author : Chien Kira : https://github.com/chienkira
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1021)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var vi = moment.defineLocale('vi', {
	        months: 'tháng 1_tháng 2_tháng 3_tháng 4_tháng 5_tháng 6_tháng 7_tháng 8_tháng 9_tháng 10_tháng 11_tháng 12'.split(
	            '_'
	        ),
	        monthsShort: 'Thg 01_Thg 02_Thg 03_Thg 04_Thg 05_Thg 06_Thg 07_Thg 08_Thg 09_Thg 10_Thg 11_Thg 12'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'chủ nhật_thứ hai_thứ ba_thứ tư_thứ năm_thứ sáu_thứ bảy'.split(
	            '_'
	        ),
	        weekdaysShort: 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
	        weekdaysMin: 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
	        weekdaysParseExact: true,
	        meridiemParse: /sa|ch/i,
	        isPM: function (input) {
	            return /^ch$/i.test(input);
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower ? 'sa' : 'SA';
	            } else {
	                return isLower ? 'ch' : 'CH';
	            }
	        },
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM [năm] YYYY',
	            LLL: 'D MMMM [năm] YYYY HH:mm',
	            LLLL: 'dddd, D MMMM [năm] YYYY HH:mm',
	            l: 'DD/M/YYYY',
	            ll: 'D MMM YYYY',
	            lll: 'D MMM YYYY HH:mm',
	            llll: 'ddd, D MMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Hôm nay lúc] LT',
	            nextDay: '[Ngày mai lúc] LT',
	            nextWeek: 'dddd [tuần tới lúc] LT',
	            lastDay: '[Hôm qua lúc] LT',
	            lastWeek: 'dddd [tuần trước lúc] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s tới',
	            past: '%s trước',
	            s: 'vài giây',
	            ss: '%d giây',
	            m: 'một phút',
	            mm: '%d phút',
	            h: 'một giờ',
	            hh: '%d giờ',
	            d: 'một ngày',
	            dd: '%d ngày',
	            w: 'một tuần',
	            ww: '%d tuần',
	            M: 'một tháng',
	            MM: '%d tháng',
	            y: 'một năm',
	            yy: '%d năm',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}/,
	        ordinal: function (number) {
	            return number;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return vi;
	
	})));


/***/ }),
/* 1152 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Pseudo [x-pseudo]
	//! author : Andrew Hood : https://github.com/andrewhood125
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1021)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var xPseudo = moment.defineLocale('x-pseudo', {
	        months: 'J~áñúá~rý_F~ébrú~árý_~Márc~h_Áp~ríl_~Máý_~Júñé~_Júl~ý_Áú~gúst~_Sép~témb~ér_Ó~ctób~ér_Ñ~óvém~bér_~Décé~mbér'.split(
	            '_'
	        ),
	        monthsShort: 'J~áñ_~Féb_~Már_~Ápr_~Máý_~Júñ_~Júl_~Áúg_~Sép_~Óct_~Ñóv_~Déc'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'S~úñdá~ý_Mó~ñdáý~_Túé~sdáý~_Wéd~ñésd~áý_T~húrs~dáý_~Fríd~áý_S~átúr~dáý'.split(
	            '_'
	        ),
	        weekdaysShort: 'S~úñ_~Móñ_~Túé_~Wéd_~Thú_~Frí_~Sát'.split('_'),
	        weekdaysMin: 'S~ú_Mó~_Tú_~Wé_T~h_Fr~_Sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[T~ódá~ý át] LT',
	            nextDay: '[T~ómó~rró~w át] LT',
	            nextWeek: 'dddd [át] LT',
	            lastDay: '[Ý~ést~érdá~ý át] LT',
	            lastWeek: '[L~ást] dddd [át] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'í~ñ %s',
	            past: '%s á~gó',
	            s: 'á ~féw ~sécó~ñds',
	            ss: '%d s~écóñ~ds',
	            m: 'á ~míñ~úté',
	            mm: '%d m~íñú~tés',
	            h: 'á~ñ hó~úr',
	            hh: '%d h~óúrs',
	            d: 'á ~dáý',
	            dd: '%d d~áýs',
	            M: 'á ~móñ~th',
	            MM: '%d m~óñt~hs',
	            y: 'á ~ýéár',
	            yy: '%d ý~éárs',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return xPseudo;
	
	})));


/***/ }),
/* 1153 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Yoruba Nigeria [yo]
	//! author : Atolagbe Abisoye : https://github.com/andela-batolagbe
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1021)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var yo = moment.defineLocale('yo', {
	        months: 'Sẹ́rẹ́_Èrèlè_Ẹrẹ̀nà_Ìgbé_Èbibi_Òkùdu_Agẹmo_Ògún_Owewe_Ọ̀wàrà_Bélú_Ọ̀pẹ̀̀'.split(
	            '_'
	        ),
	        monthsShort: 'Sẹ́r_Èrl_Ẹrn_Ìgb_Èbi_Òkù_Agẹ_Ògú_Owe_Ọ̀wà_Bél_Ọ̀pẹ̀̀'.split('_'),
	        weekdays: 'Àìkú_Ajé_Ìsẹ́gun_Ọjọ́rú_Ọjọ́bọ_Ẹtì_Àbámẹ́ta'.split('_'),
	        weekdaysShort: 'Àìk_Ajé_Ìsẹ́_Ọjr_Ọjb_Ẹtì_Àbá'.split('_'),
	        weekdaysMin: 'Àì_Aj_Ìs_Ọr_Ọb_Ẹt_Àb'.split('_'),
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY h:mm A',
	            LLLL: 'dddd, D MMMM YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: '[Ònì ni] LT',
	            nextDay: '[Ọ̀la ni] LT',
	            nextWeek: "dddd [Ọsẹ̀ tón'bọ] [ni] LT",
	            lastDay: '[Àna ni] LT',
	            lastWeek: 'dddd [Ọsẹ̀ tólọ́] [ni] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'ní %s',
	            past: '%s kọjá',
	            s: 'ìsẹjú aayá die',
	            ss: 'aayá %d',
	            m: 'ìsẹjú kan',
	            mm: 'ìsẹjú %d',
	            h: 'wákati kan',
	            hh: 'wákati %d',
	            d: 'ọjọ́ kan',
	            dd: 'ọjọ́ %d',
	            M: 'osù kan',
	            MM: 'osù %d',
	            y: 'ọdún kan',
	            yy: 'ọdún %d',
	        },
	        dayOfMonthOrdinalParse: /ọjọ́\s\d{1,2}/,
	        ordinal: 'ọjọ́ %d',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return yo;
	
	})));


/***/ }),
/* 1154 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chinese (China) [zh-cn]
	//! author : suupic : https://github.com/suupic
	//! author : Zeno Zeng : https://github.com/zenozeng
	//! author : uu109 : https://github.com/uu109
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1021)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var zhCn = moment.defineLocale('zh-cn', {
	        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
	            '_'
	        ),
	        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
	            '_'
	        ),
	        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	        weekdaysShort: '周日_周一_周二_周三_周四_周五_周六'.split('_'),
	        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY/MM/DD',
	            LL: 'YYYY年M月D日',
	            LLL: 'YYYY年M月D日Ah点mm分',
	            LLLL: 'YYYY年M月D日ddddAh点mm分',
	            l: 'YYYY/M/D',
	            ll: 'YYYY年M月D日',
	            lll: 'YYYY年M月D日 HH:mm',
	            llll: 'YYYY年M月D日dddd HH:mm',
	        },
	        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	                return hour;
	            } else if (meridiem === '下午' || meridiem === '晚上') {
	                return hour + 12;
	            } else {
	                // '中午'
	                return hour >= 11 ? hour : hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return '凌晨';
	            } else if (hm < 900) {
	                return '早上';
	            } else if (hm < 1130) {
	                return '上午';
	            } else if (hm < 1230) {
	                return '中午';
	            } else if (hm < 1800) {
	                return '下午';
	            } else {
	                return '晚上';
	            }
	        },
	        calendar: {
	            sameDay: '[今天]LT',
	            nextDay: '[明天]LT',
	            nextWeek: function (now) {
	                if (now.week() !== this.week()) {
	                    return '[下]dddLT';
	                } else {
	                    return '[本]dddLT';
	                }
	            },
	            lastDay: '[昨天]LT',
	            lastWeek: function (now) {
	                if (this.week() !== now.week()) {
	                    return '[上]dddLT';
	                } else {
	                    return '[本]dddLT';
	                }
	            },
	            sameElse: 'L',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(日|月|周)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '日';
	                case 'M':
	                    return number + '月';
	                case 'w':
	                case 'W':
	                    return number + '周';
	                default:
	                    return number;
	            }
	        },
	        relativeTime: {
	            future: '%s后',
	            past: '%s前',
	            s: '几秒',
	            ss: '%d 秒',
	            m: '1 分钟',
	            mm: '%d 分钟',
	            h: '1 小时',
	            hh: '%d 小时',
	            d: '1 天',
	            dd: '%d 天',
	            w: '1 周',
	            ww: '%d 周',
	            M: '1 个月',
	            MM: '%d 个月',
	            y: '1 年',
	            yy: '%d 年',
	        },
	        week: {
	            // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return zhCn;
	
	})));


/***/ }),
/* 1155 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chinese (Hong Kong) [zh-hk]
	//! author : Ben : https://github.com/ben-lin
	//! author : Chris Lam : https://github.com/hehachris
	//! author : Konstantin : https://github.com/skfd
	//! author : Anthony : https://github.com/anthonylau
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1021)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var zhHk = moment.defineLocale('zh-hk', {
	        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
	            '_'
	        ),
	        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
	            '_'
	        ),
	        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	        weekdaysShort: '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY/MM/DD',
	            LL: 'YYYY年M月D日',
	            LLL: 'YYYY年M月D日 HH:mm',
	            LLLL: 'YYYY年M月D日dddd HH:mm',
	            l: 'YYYY/M/D',
	            ll: 'YYYY年M月D日',
	            lll: 'YYYY年M月D日 HH:mm',
	            llll: 'YYYY年M月D日dddd HH:mm',
	        },
	        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	                return hour;
	            } else if (meridiem === '中午') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === '下午' || meridiem === '晚上') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return '凌晨';
	            } else if (hm < 900) {
	                return '早上';
	            } else if (hm < 1200) {
	                return '上午';
	            } else if (hm === 1200) {
	                return '中午';
	            } else if (hm < 1800) {
	                return '下午';
	            } else {
	                return '晚上';
	            }
	        },
	        calendar: {
	            sameDay: '[今天]LT',
	            nextDay: '[明天]LT',
	            nextWeek: '[下]ddddLT',
	            lastDay: '[昨天]LT',
	            lastWeek: '[上]ddddLT',
	            sameElse: 'L',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '日';
	                case 'M':
	                    return number + '月';
	                case 'w':
	                case 'W':
	                    return number + '週';
	                default:
	                    return number;
	            }
	        },
	        relativeTime: {
	            future: '%s後',
	            past: '%s前',
	            s: '幾秒',
	            ss: '%d 秒',
	            m: '1 分鐘',
	            mm: '%d 分鐘',
	            h: '1 小時',
	            hh: '%d 小時',
	            d: '1 天',
	            dd: '%d 天',
	            M: '1 個月',
	            MM: '%d 個月',
	            y: '1 年',
	            yy: '%d 年',
	        },
	    });
	
	    return zhHk;
	
	})));


/***/ }),
/* 1156 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chinese (Macau) [zh-mo]
	//! author : Ben : https://github.com/ben-lin
	//! author : Chris Lam : https://github.com/hehachris
	//! author : Tan Yuanhong : https://github.com/le0tan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1021)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var zhMo = moment.defineLocale('zh-mo', {
	        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
	            '_'
	        ),
	        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
	            '_'
	        ),
	        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	        weekdaysShort: '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'YYYY年M月D日',
	            LLL: 'YYYY年M月D日 HH:mm',
	            LLLL: 'YYYY年M月D日dddd HH:mm',
	            l: 'D/M/YYYY',
	            ll: 'YYYY年M月D日',
	            lll: 'YYYY年M月D日 HH:mm',
	            llll: 'YYYY年M月D日dddd HH:mm',
	        },
	        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	                return hour;
	            } else if (meridiem === '中午') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === '下午' || meridiem === '晚上') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return '凌晨';
	            } else if (hm < 900) {
	                return '早上';
	            } else if (hm < 1130) {
	                return '上午';
	            } else if (hm < 1230) {
	                return '中午';
	            } else if (hm < 1800) {
	                return '下午';
	            } else {
	                return '晚上';
	            }
	        },
	        calendar: {
	            sameDay: '[今天] LT',
	            nextDay: '[明天] LT',
	            nextWeek: '[下]dddd LT',
	            lastDay: '[昨天] LT',
	            lastWeek: '[上]dddd LT',
	            sameElse: 'L',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '日';
	                case 'M':
	                    return number + '月';
	                case 'w':
	                case 'W':
	                    return number + '週';
	                default:
	                    return number;
	            }
	        },
	        relativeTime: {
	            future: '%s內',
	            past: '%s前',
	            s: '幾秒',
	            ss: '%d 秒',
	            m: '1 分鐘',
	            mm: '%d 分鐘',
	            h: '1 小時',
	            hh: '%d 小時',
	            d: '1 天',
	            dd: '%d 天',
	            M: '1 個月',
	            MM: '%d 個月',
	            y: '1 年',
	            yy: '%d 年',
	        },
	    });
	
	    return zhMo;
	
	})));


/***/ }),
/* 1157 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chinese (Taiwan) [zh-tw]
	//! author : Ben : https://github.com/ben-lin
	//! author : Chris Lam : https://github.com/hehachris
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1021)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var zhTw = moment.defineLocale('zh-tw', {
	        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
	            '_'
	        ),
	        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
	            '_'
	        ),
	        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	        weekdaysShort: '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY/MM/DD',
	            LL: 'YYYY年M月D日',
	            LLL: 'YYYY年M月D日 HH:mm',
	            LLLL: 'YYYY年M月D日dddd HH:mm',
	            l: 'YYYY/M/D',
	            ll: 'YYYY年M月D日',
	            lll: 'YYYY年M月D日 HH:mm',
	            llll: 'YYYY年M月D日dddd HH:mm',
	        },
	        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	                return hour;
	            } else if (meridiem === '中午') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === '下午' || meridiem === '晚上') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return '凌晨';
	            } else if (hm < 900) {
	                return '早上';
	            } else if (hm < 1130) {
	                return '上午';
	            } else if (hm < 1230) {
	                return '中午';
	            } else if (hm < 1800) {
	                return '下午';
	            } else {
	                return '晚上';
	            }
	        },
	        calendar: {
	            sameDay: '[今天] LT',
	            nextDay: '[明天] LT',
	            nextWeek: '[下]dddd LT',
	            lastDay: '[昨天] LT',
	            lastWeek: '[上]dddd LT',
	            sameElse: 'L',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '日';
	                case 'M':
	                    return number + '月';
	                case 'w':
	                case 'W':
	                    return number + '週';
	                default:
	                    return number;
	            }
	        },
	        relativeTime: {
	            future: '%s後',
	            past: '%s前',
	            s: '幾秒',
	            ss: '%d 秒',
	            m: '1 分鐘',
	            mm: '%d 分鐘',
	            h: '1 小時',
	            hh: '%d 小時',
	            d: '1 天',
	            dd: '%d 天',
	            M: '1 個月',
	            MM: '%d 個月',
	            y: '1 年',
	            yy: '%d 年',
	        },
	    });
	
	    return zhTw;
	
	})));


/***/ }),
/* 1158 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _alt = __webpack_require__(975);
	
	var _alt2 = _interopRequireDefault(_alt);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var UserActions = function () {
	  function UserActions() {
	    _classCallCheck(this, UserActions);
	
	    this.generateActions("updateApiKey", "updateDetails", "loginSucceeded", "loginWithToken", "loginFailed", "clearErrors", "logout", "fetch", "forgotPassword", "forgotSucceeded", "forgotFailed", "resetSucceeded", "resetFailed", "fetchUser", "edit", "editUser", "setData", "fetchFailed", "editFailed", "fetchRoles", "fetchAccounts", "deleteAccount", "createAccount", "fetchAllUsers", "fetchPaginatedUsers", "fetchCurrentPage", "fetchCondensedUsers", "setGodUser", "setGodRole", "godAutoCreateUser", "godCreateUser", "godDeleteUser", "godSetStealthMode", "userSignup", "lookupContentCreatorInvite", "acceptContentCreatorInvite", "lookupRevenueSharingInvite", "acceptRevenueSharingInvite");
	  }
	
	  _createClass(UserActions, [{
	    key: "login",
	    value: function login(email, password, noRedirect) {
	      return { email: email, password: password, noRedirect: noRedirect };
	    }
	  }, {
	    key: "register",
	    value: function register(email, password) {
	      return { email: email, password: password };
	    }
	  }, {
	    key: "editAccount",
	    value: function editAccount(id, values) {
	      return { id: id, values: values };
	    }
	  }, {
	    key: "uploadFile",
	    value: function uploadFile(key, file) {
	      return { key: key, file: file };
	    }
	  }, {
	    key: "godEditUser",
	    value: function godEditUser(id, values) {
	      return { id: id, values: values };
	    }
	  }, {
	    key: "resetPassword",
	    value: function resetPassword(token, password) {
	      return { token: token, password: password };
	    }
	  }]);
	
	  return UserActions;
	}();
	
	exports.default = _alt2.default.createActions(UserActions);
	module.exports = exports["default"];

/***/ }),
/* 1159 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _api = __webpack_require__(1160);
	
	var _api2 = _interopRequireDefault(_api);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  // USERS
	
	  fetchUser: function fetchUser(apiKey, godCredentials) {
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "GET",
	        endpoint: "users/self",
	        api_key: apiKey,
	        godCredentials: godCredentials
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response);
	      });
	    });
	  },
	  fetchCondensedUsers: function fetchCondensedUsers(apiKey) {
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "GET",
	        endpoint: "users/condensed",
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response);
	      });
	    });
	  },
	  fetchPaginatedUsers: function fetchPaginatedUsers(apiKey, page, isContentCreators, sorted, searchTerm) {
	    return new Promise(function (resolve, reject) {
	      var sortingQuery = "";
	
	      if (sorted && sorted.length !== 0) {
	        sortingQuery = "&sortedId=" + sorted[0].id + "&sortedIsDesc=" + sorted[0].desc;
	      }
	
	      _api2.default.request({
	        method: "GET",
	        endpoint: "users/paginated?page=" + page + "&" + (isContentCreators ? "only_content_creators=true" : "exclude_content_creators=true") + sortingQuery + (searchTerm ? "&searchTerm=" + searchTerm : ""),
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response);
	      });
	    });
	  },
	  editUser: function editUser(apiKey, user, data) {
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "POST",
	        endpoint: "users/" + user,
	        json: data,
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response);
	      });
	    });
	  },
	  createUser: function createUser(apiKey, data) {
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "POST",
	        endpoint: "users",
	        json: data,
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response);
	      });
	    });
	  },
	  makeApiKey: function makeApiKey(apiKey, data) {
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "POST",
	        endpoint: "users/self/api_keys",
	        json: data,
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response);
	      });
	    });
	  },
	  deleteApiKey: function deleteApiKey(apiKey, keyToDelete) {
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "DELETE",
	        endpoint: "users/self/api_keys/" + keyToDelete,
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response);
	      });
	    });
	  },
	  signup: function signup(options) {
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "POST",
	        endpoint: "user_signup",
	        json: options
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response);
	      });
	    });
	  },
	  lookupContentCreatorInvite: function lookupContentCreatorInvite(apiKey, token) {
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "POST",
	        endpoint: "content_creator_invite/lookup",
	        json: { token: token },
	        api_key: apiKey // optional, only for logged in lookup
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response);
	      });
	    });
	  },
	  acceptContentCreatorInvite: function acceptContentCreatorInvite(apiKey, options) {
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "POST",
	        endpoint: "content_creator_invite/accept",
	        json: { token: options.token, title: options.title },
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response);
	      });
	    });
	  },
	  lookupRevenueSharingInvite: function lookupRevenueSharingInvite(token) {
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "POST",
	        endpoint: "revenue_sharing/invite/lookup",
	        json: { token: token }
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response);
	      });
	    });
	  },
	  acceptRevenueSharingInvite: function acceptRevenueSharingInvite(apiKey, token) {
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "POST",
	        endpoint: "revenue_sharing/invite/accept",
	        json: { token: token },
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response);
	      });
	    });
	  },
	  uploadFile: function uploadFile(apiKey, key, file, options) {
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "POST",
	        endpoint: "files",
	        json: options,
	        fileField: key,
	        file: file,
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response);
	      });
	    });
	  },
	
	
	  // GOD MODE
	
	  fetchAllUsers: function fetchAllUsers(apiKey) {
	    var _ref = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	
	    var excludeContentCreators = _ref.excludeContentCreators;
	    var onlyContentCreators = _ref.onlyContentCreators;
	
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "GET",
	        endpoint: "users" + (excludeContentCreators ? "?exclude_content_creators=true" : onlyContentCreators ? "?only_content_creators=true" : ""),
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response);
	      });
	    });
	  },
	  deleteUser: function deleteUser(apiKey, user) {
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "DELETE",
	        endpoint: "users/" + user,
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response);
	      });
	    });
	  },
	
	
	  // ROLES
	
	  fetchRoles: function fetchRoles(apiKey) {
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "GET",
	        endpoint: "accounts/roles",
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response);
	      });
	    });
	  },
	
	
	  // ACCOUNTS
	
	  login: function login(email, password, noRedirect) {
	    return new Promise(function (resolve, reject) {
	      if (!email || !password) {
	        return reject(new Error("An email address and password are required."));
	      }
	
	      _api2.default.request({
	        method: "POST",
	        endpoint: "accounts/login",
	        json: { email: email, password: password },
	        ignoreLoginErrors: noRedirect
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response);
	      });
	    });
	  },
	  fetchOwnAccount: function fetchOwnAccount(apiKey) {
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "GET",
	        endpoint: "accounts/self",
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response);
	      });
	    });
	  },
	  fetchAccounts: function fetchAccounts(apiKey) {
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "GET",
	        endpoint: "accounts",
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response);
	      });
	    });
	  },
	  editAccount: function editAccount(apiKey, account, data) {
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "POST",
	        endpoint: "accounts/" + account,
	        json: data,
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response);
	      });
	    });
	  },
	  createAccount: function createAccount(apiKey, data) {
	    return new Promise(function (resolve, reject) {
	      if (!data.email || !data.password) {
	        return reject(new Error("An email address and password are required."));
	      }
	
	      _api2.default.request({
	        method: "POST",
	        endpoint: "accounts",
	        json: data,
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response);
	      });
	    });
	  },
	  deleteAccount: function deleteAccount(apiKey, account) {
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "DELETE",
	        endpoint: "accounts/" + account,
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response);
	      });
	    });
	  },
	  forgotPassword: function forgotPassword(email) {
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "POST",
	        endpoint: "accounts/forgot_password",
	        json: {
	          email: email,
	          reset_url: window.location.protocol + "//" + window.location.host + "/reset?token="
	        },
	        ignoreLoginErrors: true
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response);
	      });
	    });
	  },
	  resetPassword: function resetPassword(token, password) {
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "POST",
	        endpoint: "accounts/reset_password",
	        ignoreLoginErrors: true,
	        json: {
	          token: token,
	          password: password
	        }
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response);
	      });
	    });
	  },
	
	
	  // OTHER
	
	  generateVirtualActivationLink: function generateVirtualActivationLink(_ref2) {
	    var apiKey = _ref2.apiKey;
	
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "POST",
	        endpoint: "activations/generate_link",
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response);
	      });
	    });
	  },
	  generateVirtualManagementLink: function generateVirtualManagementLink(_ref3) {
	    var apiKey = _ref3.apiKey;
	    var next = _ref3.next;
	
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "POST",
	        endpoint: "activations/generate_billing_management_link",
	        json: { next: next },
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response);
	      });
	    });
	  }
	};
	module.exports = exports["default"];

/***/ }),
/* 1160 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _merge = __webpack_require__(732);
	
	var _merge2 = _interopRequireDefault(_merge);
	
	var _omitBy = __webpack_require__(1161);
	
	var _omitBy2 = _interopRequireDefault(_omitBy);
	
	var _superagent = __webpack_require__(1168);
	
	var _superagent2 = _interopRequireDefault(_superagent);
	
	var _config = __webpack_require__(1173);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _logger = __webpack_require__(1174);
	
	var _logger2 = _interopRequireDefault(_logger);
	
	var _GlobalNotificationActions = __webpack_require__(1182);
	
	var _GlobalNotificationActions2 = _interopRequireDefault(_GlobalNotificationActions);
	
	var _UserStore = __webpack_require__(974);
	
	var _UserStore2 = _interopRequireDefault(_UserStore);
	
	var _UserActions = __webpack_require__(1158);
	
	var _UserActions2 = _interopRequireDefault(_UserActions);
	
	var _util = __webpack_require__(1183);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Cache for pending requests to prevent duplicate simultaneous requests
	var pendingRequests = new Map();
	
	// Generate a unique key for request deduplication
	function generateRequestKey(opts) {
	  var keyComponents = {
	    method: opts.method,
	    endpoint: opts.endpoint,
	    qs: opts.qs,
	    json: opts.json,
	    api_key: opts.api_key,
	    godCredentials: opts.godCredentials,
	    allow_cache: opts.allow_cache,
	    getText: opts.getText
	  };
	
	  // Remove any undefined or null values to ensure consistent key generation
	  Object.keys(keyComponents).forEach(function (key) {
	    if (keyComponents[key] === undefined || keyComponents[key] === null) {
	      delete keyComponents[key];
	    }
	  });
	
	  return JSON.stringify(keyComponents);
	}
	
	function request(opts, cb) {
	  // Only deduplicate GET requests to avoid side effects with other HTTP methods
	  var shouldDedupe = opts.method && opts.method.toLowerCase() === "get";
	
	  // Generate a unique key for this request
	  var requestKey = generateRequestKey(opts);
	
	  if (shouldDedupe) {
	    // Check if an identical request is already pending
	    if (pendingRequests.has(requestKey)) {
	      // Return the existing pending request
	      var pendingRequest = pendingRequests.get(requestKey);
	      pendingRequest.then(function (result) {
	        return cb(null, result);
	      }, function (error) {
	        return cb(error);
	      });
	      return;
	    }
	  }
	
	  // Create a new promise for this request
	  var requestPromise = new Promise(function (resolve, reject) {
	    var qs = (0, _omitBy2.default)(opts.qs, function (k) {
	      return k === null || k === undefined;
	    });
	    if (Object.keys(qs).length === 0) {
	      qs = undefined;
	    }
	
	    if (opts.method.toLowerCase() === "delete") {
	      opts.method = "del";
	    }
	
	    var req = _superagent2.default[opts.method.toLowerCase()](_config2.default.endpoint + opts.endpoint);
	
	    req.query(qs);
	
	    if (opts.api_key) {
	      req.auth(opts.api_key);
	    }
	
	    // God mode authentication
	    if (opts.godCredentials) {
	      req.auth(opts.godCredentials.apiKey, opts.godCredentials.activeUser);
	    } else if (_UserStore2.default && _UserStore2.default.isLoggedIn() && _UserStore2.default.isGodInAnyForm()) {
	      var credentials = _UserStore2.default.getGodCredentials();
	      req.auth(credentials.apiKey, credentials.activeUser);
	    }
	
	    // Single file upload
	    if (opts.file) {
	      req.attach(opts.fileField, opts.file, opts.file.name);
	    }
	
	    // Multi-file upload
	    if (opts.files) {
	      opts.files.forEach(function (f) {
	        req.attach(f.field, f.file, f.file.name);
	      });
	    }
	
	    // Bypass cache
	    if (!opts.allow_cache) {
	      req.set("x-apicache-bypass", true);
	    }
	
	    if (opts.json) {
	      var data = (0, _merge2.default)(opts.json, { event_bucket: _config2.default.event_bucket });
	      if (opts.file || opts.files) {
	        // If multipart, include data as fields
	        Object.keys(data).forEach(function (k) {
	          req.field(k, data[k]);
	        });
	      } else {
	        req.send(data);
	      }
	    }
	
	    req.end(function (err, resp) {
	      // Remove from pending requests cache when complete (only for GET requests)
	      if (shouldDedupe) {
	        pendingRequests.delete(requestKey);
	      }
	
	      if (resp && resp.body && resp.body.error) {
	        // Disable logging of errors... tooooo maannyyy.
	        // let errorToLog = Object.assign({}, body.error, {
	        //   error_source: 'api-response-error',
	        //   request: opts
	        // });
	        // logger.info(errorToLog);
	
	        // Redirect to login page for invalid credentials
	        if (!opts.ignoreLoginErrors && resp.body.error.code === "InvalidCredentials" || (resp.body.error.code === "BadRequestError" || resp.body.error.code === "BadRequest") && resp.body.error.message.indexOf("An API key or token must be specified") !== -1) {
	          if (window.location.href.indexOf("login") === -1) {
	            _UserActions2.default.logout();
	            _UserActions2.default.loginFailed(resp.body.error);
	            _util.history.push("/login");
	          }
	          reject(resp.body.error);
	          return;
	        }
	
	        reject(resp.body.error);
	        return;
	      }
	
	      if (err && err.message.indexOf("Request has been terminated") === 0) {
	        _GlobalNotificationActions2.default.notify("Network connection lost. Please reconnect and try again.");
	        reject(err);
	        return;
	      }
	
	      if (resp && opts.getText) {
	        resolve(resp && resp.xhr.response);
	        return;
	      }
	
	      resolve(resp && resp.body);
	    });
	  });
	
	  // Store the promise in the cache (only for GET requests)
	  if (shouldDedupe) {
	    pendingRequests.set(requestKey, requestPromise);
	  }
	
	  // Execute the callback with the promise result
	  requestPromise.then(function (result) {
	    return cb(null, result);
	  }, function (error) {
	    return cb(error);
	  });
	}
	
	exports.default = {
	  request: request
	};
	module.exports = exports["default"];

/***/ }),
/* 1161 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIteratee = __webpack_require__(997),
	    negate = __webpack_require__(1162),
	    pickBy = __webpack_require__(1163);
	
	/**
	 * The opposite of `_.pickBy`; this method creates an object composed of
	 * the own and inherited enumerable string keyed properties of `object` that
	 * `predicate` doesn't return truthy for. The predicate is invoked with two
	 * arguments: (value, key).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Object
	 * @param {Object} object The source object.
	 * @param {Function} [predicate=_.identity] The function invoked per property.
	 * @returns {Object} Returns the new object.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': '2', 'c': 3 };
	 *
	 * _.omitBy(object, _.isNumber);
	 * // => { 'b': '2' }
	 */
	function omitBy(object, predicate) {
	  return pickBy(object, negate(baseIteratee(predicate)));
	}
	
	module.exports = omitBy;


/***/ }),
/* 1162 */
/***/ (function(module, exports) {

	/** Error message constants. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/**
	 * Creates a function that negates the result of the predicate `func`. The
	 * `func` predicate is invoked with the `this` binding and arguments of the
	 * created function.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Function
	 * @param {Function} predicate The predicate to negate.
	 * @returns {Function} Returns the new negated function.
	 * @example
	 *
	 * function isEven(n) {
	 *   return n % 2 == 0;
	 * }
	 *
	 * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
	 * // => [1, 3, 5]
	 */
	function negate(predicate) {
	  if (typeof predicate != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  return function() {
	    var args = arguments;
	    switch (args.length) {
	      case 0: return !predicate.call(this);
	      case 1: return !predicate.call(this, args[0]);
	      case 2: return !predicate.call(this, args[0], args[1]);
	      case 3: return !predicate.call(this, args[0], args[1], args[2]);
	    }
	    return !predicate.apply(this, args);
	  };
	}
	
	module.exports = negate;


/***/ }),
/* 1163 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__(1013),
	    baseIteratee = __webpack_require__(997),
	    basePickBy = __webpack_require__(1164),
	    getAllKeysIn = __webpack_require__(1166);
	
	/**
	 * Creates an object composed of the `object` properties `predicate` returns
	 * truthy for. The predicate is invoked with two arguments: (value, key).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Object
	 * @param {Object} object The source object.
	 * @param {Function} [predicate=_.identity] The function invoked per property.
	 * @returns {Object} Returns the new object.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': '2', 'c': 3 };
	 *
	 * _.pickBy(object, _.isNumber);
	 * // => { 'a': 1, 'c': 3 }
	 */
	function pickBy(object, predicate) {
	  if (object == null) {
	    return {};
	  }
	  var props = arrayMap(getAllKeysIn(object), function(prop) {
	    return [prop];
	  });
	  predicate = baseIteratee(predicate);
	  return basePickBy(object, props, function(value, path) {
	    return predicate(value, path[0]);
	  });
	}
	
	module.exports = pickBy;


/***/ }),
/* 1164 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(1005),
	    baseSet = __webpack_require__(1165),
	    castPath = __webpack_require__(1006);
	
	/**
	 * The base implementation of  `_.pickBy` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The source object.
	 * @param {string[]} paths The property paths to pick.
	 * @param {Function} predicate The function invoked per property.
	 * @returns {Object} Returns the new object.
	 */
	function basePickBy(object, paths, predicate) {
	  var index = -1,
	      length = paths.length,
	      result = {};
	
	  while (++index < length) {
	    var path = paths[index],
	        value = baseGet(object, path);
	
	    if (predicate(value, path)) {
	      baseSet(result, castPath(path, object), value);
	    }
	  }
	  return result;
	}
	
	module.exports = basePickBy;


/***/ }),
/* 1165 */
/***/ (function(module, exports, __webpack_require__) {

	var assignValue = __webpack_require__(803),
	    castPath = __webpack_require__(1006),
	    isIndex = __webpack_require__(807),
	    isObject = __webpack_require__(643),
	    toKey = __webpack_require__(1014);
	
	/**
	 * The base implementation of `_.set`.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {Array|string} path The path of the property to set.
	 * @param {*} value The value to set.
	 * @param {Function} [customizer] The function to customize path creation.
	 * @returns {Object} Returns `object`.
	 */
	function baseSet(object, path, value, customizer) {
	  if (!isObject(object)) {
	    return object;
	  }
	  path = castPath(path, object);
	
	  var index = -1,
	      length = path.length,
	      lastIndex = length - 1,
	      nested = object;
	
	  while (nested != null && ++index < length) {
	    var key = toKey(path[index]),
	        newValue = value;
	
	    if (key === '__proto__' || key === 'constructor' || key === 'prototype') {
	      return object;
	    }
	
	    if (index != lastIndex) {
	      var objValue = nested[key];
	      newValue = customizer ? customizer(objValue, key, nested) : undefined;
	      if (newValue === undefined) {
	        newValue = isObject(objValue)
	          ? objValue
	          : (isIndex(path[index + 1]) ? [] : {});
	      }
	    }
	    assignValue(nested, key, newValue);
	    nested = nested[key];
	  }
	  return object;
	}
	
	module.exports = baseSet;


/***/ }),
/* 1166 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetAllKeys = __webpack_require__(938),
	    getSymbolsIn = __webpack_require__(1167),
	    keysIn = __webpack_require__(804);
	
	/**
	 * Creates an array of own and inherited enumerable property names and
	 * symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function getAllKeysIn(object) {
	  return baseGetAllKeys(object, keysIn, getSymbolsIn);
	}
	
	module.exports = getAllKeysIn;


/***/ }),
/* 1167 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayPush = __webpack_require__(939),
	    getPrototype = __webpack_require__(784),
	    getSymbols = __webpack_require__(940),
	    stubArray = __webpack_require__(942);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeGetSymbols = Object.getOwnPropertySymbols;
	
	/**
	 * Creates an array of the own and inherited enumerable symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of symbols.
	 */
	var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
	  var result = [];
	  while (object) {
	    arrayPush(result, getSymbols(object));
	    object = getPrototype(object);
	  }
	  return result;
	};
	
	module.exports = getSymbolsIn;


/***/ }),
/* 1168 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Root reference for iframes.
	 */
	
	var root;
	if (typeof window !== 'undefined') { // Browser window
	  root = window;
	} else if (typeof self !== 'undefined') { // Web Worker
	  root = self;
	} else { // Other environments
	  console.warn("Using browser-only version of superagent in non-browser environment");
	  root = this;
	}
	
	var Emitter = __webpack_require__(1169);
	var requestBase = __webpack_require__(1170);
	var isObject = __webpack_require__(1171);
	
	/**
	 * Noop.
	 */
	
	function noop(){};
	
	/**
	 * Expose `request`.
	 */
	
	var request = module.exports = __webpack_require__(1172).bind(null, Request);
	
	/**
	 * Determine XHR.
	 */
	
	request.getXHR = function () {
	  if (root.XMLHttpRequest
	      && (!root.location || 'file:' != root.location.protocol
	          || !root.ActiveXObject)) {
	    return new XMLHttpRequest;
	  } else {
	    try { return new ActiveXObject('Microsoft.XMLHTTP'); } catch(e) {}
	    try { return new ActiveXObject('Msxml2.XMLHTTP.6.0'); } catch(e) {}
	    try { return new ActiveXObject('Msxml2.XMLHTTP.3.0'); } catch(e) {}
	    try { return new ActiveXObject('Msxml2.XMLHTTP'); } catch(e) {}
	  }
	  throw Error("Browser-only verison of superagent could not find XHR");
	};
	
	/**
	 * Removes leading and trailing whitespace, added to support IE.
	 *
	 * @param {String} s
	 * @return {String}
	 * @api private
	 */
	
	var trim = ''.trim
	  ? function(s) { return s.trim(); }
	  : function(s) { return s.replace(/(^\s*|\s*$)/g, ''); };
	
	/**
	 * Serialize the given `obj`.
	 *
	 * @param {Object} obj
	 * @return {String}
	 * @api private
	 */
	
	function serialize(obj) {
	  if (!isObject(obj)) return obj;
	  var pairs = [];
	  for (var key in obj) {
	    pushEncodedKeyValuePair(pairs, key, obj[key]);
	  }
	  return pairs.join('&');
	}
	
	/**
	 * Helps 'serialize' with serializing arrays.
	 * Mutates the pairs array.
	 *
	 * @param {Array} pairs
	 * @param {String} key
	 * @param {Mixed} val
	 */
	
	function pushEncodedKeyValuePair(pairs, key, val) {
	  if (val != null) {
	    if (Array.isArray(val)) {
	      val.forEach(function(v) {
	        pushEncodedKeyValuePair(pairs, key, v);
	      });
	    } else if (isObject(val)) {
	      for(var subkey in val) {
	        pushEncodedKeyValuePair(pairs, key + '[' + subkey + ']', val[subkey]);
	      }
	    } else {
	      pairs.push(encodeURIComponent(key)
	        + '=' + encodeURIComponent(val));
	    }
	  } else if (val === null) {
	    pairs.push(encodeURIComponent(key));
	  }
	}
	
	/**
	 * Expose serialization method.
	 */
	
	 request.serializeObject = serialize;
	
	 /**
	  * Parse the given x-www-form-urlencoded `str`.
	  *
	  * @param {String} str
	  * @return {Object}
	  * @api private
	  */
	
	function parseString(str) {
	  var obj = {};
	  var pairs = str.split('&');
	  var pair;
	  var pos;
	
	  for (var i = 0, len = pairs.length; i < len; ++i) {
	    pair = pairs[i];
	    pos = pair.indexOf('=');
	    if (pos == -1) {
	      obj[decodeURIComponent(pair)] = '';
	    } else {
	      obj[decodeURIComponent(pair.slice(0, pos))] =
	        decodeURIComponent(pair.slice(pos + 1));
	    }
	  }
	
	  return obj;
	}
	
	/**
	 * Expose parser.
	 */
	
	request.parseString = parseString;
	
	/**
	 * Default MIME type map.
	 *
	 *     superagent.types.xml = 'application/xml';
	 *
	 */
	
	request.types = {
	  html: 'text/html',
	  json: 'application/json',
	  xml: 'application/xml',
	  urlencoded: 'application/x-www-form-urlencoded',
	  'form': 'application/x-www-form-urlencoded',
	  'form-data': 'application/x-www-form-urlencoded'
	};
	
	/**
	 * Default serialization map.
	 *
	 *     superagent.serialize['application/xml'] = function(obj){
	 *       return 'generated xml here';
	 *     };
	 *
	 */
	
	 request.serialize = {
	   'application/x-www-form-urlencoded': serialize,
	   'application/json': JSON.stringify
	 };
	
	 /**
	  * Default parsers.
	  *
	  *     superagent.parse['application/xml'] = function(str){
	  *       return { object parsed from str };
	  *     };
	  *
	  */
	
	request.parse = {
	  'application/x-www-form-urlencoded': parseString,
	  'application/json': JSON.parse
	};
	
	/**
	 * Parse the given header `str` into
	 * an object containing the mapped fields.
	 *
	 * @param {String} str
	 * @return {Object}
	 * @api private
	 */
	
	function parseHeader(str) {
	  var lines = str.split(/\r?\n/);
	  var fields = {};
	  var index;
	  var line;
	  var field;
	  var val;
	
	  lines.pop(); // trailing CRLF
	
	  for (var i = 0, len = lines.length; i < len; ++i) {
	    line = lines[i];
	    index = line.indexOf(':');
	    field = line.slice(0, index).toLowerCase();
	    val = trim(line.slice(index + 1));
	    fields[field] = val;
	  }
	
	  return fields;
	}
	
	/**
	 * Check if `mime` is json or has +json structured syntax suffix.
	 *
	 * @param {String} mime
	 * @return {Boolean}
	 * @api private
	 */
	
	function isJSON(mime) {
	  return /[\/+]json\b/.test(mime);
	}
	
	/**
	 * Return the mime type for the given `str`.
	 *
	 * @param {String} str
	 * @return {String}
	 * @api private
	 */
	
	function type(str){
	  return str.split(/ *; */).shift();
	};
	
	/**
	 * Return header field parameters.
	 *
	 * @param {String} str
	 * @return {Object}
	 * @api private
	 */
	
	function params(str){
	  return str.split(/ *; */).reduce(function(obj, str){
	    var parts = str.split(/ *= */),
	        key = parts.shift(),
	        val = parts.shift();
	
	    if (key && val) obj[key] = val;
	    return obj;
	  }, {});
	};
	
	/**
	 * Initialize a new `Response` with the given `xhr`.
	 *
	 *  - set flags (.ok, .error, etc)
	 *  - parse header
	 *
	 * Examples:
	 *
	 *  Aliasing `superagent` as `request` is nice:
	 *
	 *      request = superagent;
	 *
	 *  We can use the promise-like API, or pass callbacks:
	 *
	 *      request.get('/').end(function(res){});
	 *      request.get('/', function(res){});
	 *
	 *  Sending data can be chained:
	 *
	 *      request
	 *        .post('/user')
	 *        .send({ name: 'tj' })
	 *        .end(function(res){});
	 *
	 *  Or passed to `.send()`:
	 *
	 *      request
	 *        .post('/user')
	 *        .send({ name: 'tj' }, function(res){});
	 *
	 *  Or passed to `.post()`:
	 *
	 *      request
	 *        .post('/user', { name: 'tj' })
	 *        .end(function(res){});
	 *
	 * Or further reduced to a single call for simple cases:
	 *
	 *      request
	 *        .post('/user', { name: 'tj' }, function(res){});
	 *
	 * @param {XMLHTTPRequest} xhr
	 * @param {Object} options
	 * @api private
	 */
	
	function Response(req, options) {
	  options = options || {};
	  this.req = req;
	  this.xhr = this.req.xhr;
	  // responseText is accessible only if responseType is '' or 'text' and on older browsers
	  this.text = ((this.req.method !='HEAD' && (this.xhr.responseType === '' || this.xhr.responseType === 'text')) || typeof this.xhr.responseType === 'undefined')
	     ? this.xhr.responseText
	     : null;
	  this.statusText = this.req.xhr.statusText;
	  this._setStatusProperties(this.xhr.status);
	  this.header = this.headers = parseHeader(this.xhr.getAllResponseHeaders());
	  // getAllResponseHeaders sometimes falsely returns "" for CORS requests, but
	  // getResponseHeader still works. so we get content-type even if getting
	  // other headers fails.
	  this.header['content-type'] = this.xhr.getResponseHeader('content-type');
	  this._setHeaderProperties(this.header);
	  this.body = this.req.method != 'HEAD'
	    ? this._parseBody(this.text ? this.text : this.xhr.response)
	    : null;
	}
	
	/**
	 * Get case-insensitive `field` value.
	 *
	 * @param {String} field
	 * @return {String}
	 * @api public
	 */
	
	Response.prototype.get = function(field){
	  return this.header[field.toLowerCase()];
	};
	
	/**
	 * Set header related properties:
	 *
	 *   - `.type` the content type without params
	 *
	 * A response of "Content-Type: text/plain; charset=utf-8"
	 * will provide you with a `.type` of "text/plain".
	 *
	 * @param {Object} header
	 * @api private
	 */
	
	Response.prototype._setHeaderProperties = function(header){
	  // content-type
	  var ct = this.header['content-type'] || '';
	  this.type = type(ct);
	
	  // params
	  var obj = params(ct);
	  for (var key in obj) this[key] = obj[key];
	};
	
	/**
	 * Parse the given body `str`.
	 *
	 * Used for auto-parsing of bodies. Parsers
	 * are defined on the `superagent.parse` object.
	 *
	 * @param {String} str
	 * @return {Mixed}
	 * @api private
	 */
	
	Response.prototype._parseBody = function(str){
	  var parse = request.parse[this.type];
	  if (!parse && isJSON(this.type)) {
	    parse = request.parse['application/json'];
	  }
	  return parse && str && (str.length || str instanceof Object)
	    ? parse(str)
	    : null;
	};
	
	/**
	 * Set flags such as `.ok` based on `status`.
	 *
	 * For example a 2xx response will give you a `.ok` of __true__
	 * whereas 5xx will be __false__ and `.error` will be __true__. The
	 * `.clientError` and `.serverError` are also available to be more
	 * specific, and `.statusType` is the class of error ranging from 1..5
	 * sometimes useful for mapping respond colors etc.
	 *
	 * "sugar" properties are also defined for common cases. Currently providing:
	 *
	 *   - .noContent
	 *   - .badRequest
	 *   - .unauthorized
	 *   - .notAcceptable
	 *   - .notFound
	 *
	 * @param {Number} status
	 * @api private
	 */
	
	Response.prototype._setStatusProperties = function(status){
	  // handle IE9 bug: http://stackoverflow.com/questions/10046972/msie-returns-status-code-of-1223-for-ajax-request
	  if (status === 1223) {
	    status = 204;
	  }
	
	  var type = status / 100 | 0;
	
	  // status / class
	  this.status = this.statusCode = status;
	  this.statusType = type;
	
	  // basics
	  this.info = 1 == type;
	  this.ok = 2 == type;
	  this.clientError = 4 == type;
	  this.serverError = 5 == type;
	  this.error = (4 == type || 5 == type)
	    ? this.toError()
	    : false;
	
	  // sugar
	  this.accepted = 202 == status;
	  this.noContent = 204 == status;
	  this.badRequest = 400 == status;
	  this.unauthorized = 401 == status;
	  this.notAcceptable = 406 == status;
	  this.notFound = 404 == status;
	  this.forbidden = 403 == status;
	};
	
	/**
	 * Return an `Error` representative of this response.
	 *
	 * @return {Error}
	 * @api public
	 */
	
	Response.prototype.toError = function(){
	  var req = this.req;
	  var method = req.method;
	  var url = req.url;
	
	  var msg = 'cannot ' + method + ' ' + url + ' (' + this.status + ')';
	  var err = new Error(msg);
	  err.status = this.status;
	  err.method = method;
	  err.url = url;
	
	  return err;
	};
	
	/**
	 * Expose `Response`.
	 */
	
	request.Response = Response;
	
	/**
	 * Initialize a new `Request` with the given `method` and `url`.
	 *
	 * @param {String} method
	 * @param {String} url
	 * @api public
	 */
	
	function Request(method, url) {
	  var self = this;
	  this._query = this._query || [];
	  this.method = method;
	  this.url = url;
	  this.header = {}; // preserves header name case
	  this._header = {}; // coerces header names to lowercase
	  this.on('end', function(){
	    var err = null;
	    var res = null;
	
	    try {
	      res = new Response(self);
	    } catch(e) {
	      err = new Error('Parser is unable to parse the response');
	      err.parse = true;
	      err.original = e;
	      // issue #675: return the raw response if the response parsing fails
	      err.rawResponse = self.xhr && self.xhr.responseText ? self.xhr.responseText : null;
	      // issue #876: return the http status code if the response parsing fails
	      err.statusCode = self.xhr && self.xhr.status ? self.xhr.status : null;
	      return self.callback(err);
	    }
	
	    self.emit('response', res);
	
	    var new_err;
	    try {
	      if (res.status < 200 || res.status >= 300) {
	        new_err = new Error(res.statusText || 'Unsuccessful HTTP response');
	        new_err.original = err;
	        new_err.response = res;
	        new_err.status = res.status;
	      }
	    } catch(e) {
	      new_err = e; // #985 touching res may cause INVALID_STATE_ERR on old Android
	    }
	
	    // #1000 don't catch errors from the callback to avoid double calling it
	    if (new_err) {
	      self.callback(new_err, res);
	    } else {
	      self.callback(null, res);
	    }
	  });
	}
	
	/**
	 * Mixin `Emitter` and `requestBase`.
	 */
	
	Emitter(Request.prototype);
	for (var key in requestBase) {
	  Request.prototype[key] = requestBase[key];
	}
	
	/**
	 * Set Content-Type to `type`, mapping values from `request.types`.
	 *
	 * Examples:
	 *
	 *      superagent.types.xml = 'application/xml';
	 *
	 *      request.post('/')
	 *        .type('xml')
	 *        .send(xmlstring)
	 *        .end(callback);
	 *
	 *      request.post('/')
	 *        .type('application/xml')
	 *        .send(xmlstring)
	 *        .end(callback);
	 *
	 * @param {String} type
	 * @return {Request} for chaining
	 * @api public
	 */
	
	Request.prototype.type = function(type){
	  this.set('Content-Type', request.types[type] || type);
	  return this;
	};
	
	/**
	 * Set responseType to `val`. Presently valid responseTypes are 'blob' and
	 * 'arraybuffer'.
	 *
	 * Examples:
	 *
	 *      req.get('/')
	 *        .responseType('blob')
	 *        .end(callback);
	 *
	 * @param {String} val
	 * @return {Request} for chaining
	 * @api public
	 */
	
	Request.prototype.responseType = function(val){
	  this._responseType = val;
	  return this;
	};
	
	/**
	 * Set Accept to `type`, mapping values from `request.types`.
	 *
	 * Examples:
	 *
	 *      superagent.types.json = 'application/json';
	 *
	 *      request.get('/agent')
	 *        .accept('json')
	 *        .end(callback);
	 *
	 *      request.get('/agent')
	 *        .accept('application/json')
	 *        .end(callback);
	 *
	 * @param {String} accept
	 * @return {Request} for chaining
	 * @api public
	 */
	
	Request.prototype.accept = function(type){
	  this.set('Accept', request.types[type] || type);
	  return this;
	};
	
	/**
	 * Set Authorization field value with `user` and `pass`.
	 *
	 * @param {String} user
	 * @param {String} pass
	 * @param {Object} options with 'type' property 'auto' or 'basic' (default 'basic')
	 * @return {Request} for chaining
	 * @api public
	 */
	
	Request.prototype.auth = function(user, pass, options){
	  if (!options) {
	    options = {
	      type: 'basic'
	    }
	  }
	
	  switch (options.type) {
	    case 'basic':
	      var str = btoa(user + ':' + pass);
	      this.set('Authorization', 'Basic ' + str);
	    break;
	
	    case 'auto':
	      this.username = user;
	      this.password = pass;
	    break;
	  }
	  return this;
	};
	
	/**
	* Add query-string `val`.
	*
	* Examples:
	*
	*   request.get('/shoes')
	*     .query('size=10')
	*     .query({ color: 'blue' })
	*
	* @param {Object|String} val
	* @return {Request} for chaining
	* @api public
	*/
	
	Request.prototype.query = function(val){
	  if ('string' != typeof val) val = serialize(val);
	  if (val) this._query.push(val);
	  return this;
	};
	
	/**
	 * Queue the given `file` as an attachment to the specified `field`,
	 * with optional `filename`.
	 *
	 * ``` js
	 * request.post('/upload')
	 *   .attach('content', new Blob(['<a id="a"><b id="b">hey!</b></a>'], { type: "text/html"}))
	 *   .end(callback);
	 * ```
	 *
	 * @param {String} field
	 * @param {Blob|File} file
	 * @param {String} filename
	 * @return {Request} for chaining
	 * @api public
	 */
	
	Request.prototype.attach = function(field, file, filename){
	  this._getFormData().append(field, file, filename || file.name);
	  return this;
	};
	
	Request.prototype._getFormData = function(){
	  if (!this._formData) {
	    this._formData = new root.FormData();
	  }
	  return this._formData;
	};
	
	/**
	 * Invoke the callback with `err` and `res`
	 * and handle arity check.
	 *
	 * @param {Error} err
	 * @param {Response} res
	 * @api private
	 */
	
	Request.prototype.callback = function(err, res){
	  var fn = this._callback;
	  this.clearTimeout();
	  fn(err, res);
	};
	
	/**
	 * Invoke callback with x-domain error.
	 *
	 * @api private
	 */
	
	Request.prototype.crossDomainError = function(){
	  var err = new Error('Request has been terminated\nPossible causes: the network is offline, Origin is not allowed by Access-Control-Allow-Origin, the page is being unloaded, etc.');
	  err.crossDomain = true;
	
	  err.status = this.status;
	  err.method = this.method;
	  err.url = this.url;
	
	  this.callback(err);
	};
	
	/**
	 * Invoke callback with timeout error.
	 *
	 * @api private
	 */
	
	Request.prototype._timeoutError = function(){
	  var timeout = this._timeout;
	  var err = new Error('timeout of ' + timeout + 'ms exceeded');
	  err.timeout = timeout;
	  this.callback(err);
	};
	
	/**
	 * Compose querystring to append to req.url
	 *
	 * @api private
	 */
	
	Request.prototype._appendQueryString = function(){
	  var query = this._query.join('&');
	  if (query) {
	    this.url += ~this.url.indexOf('?')
	      ? '&' + query
	      : '?' + query;
	  }
	};
	
	/**
	 * Initiate request, invoking callback `fn(res)`
	 * with an instanceof `Response`.
	 *
	 * @param {Function} fn
	 * @return {Request} for chaining
	 * @api public
	 */
	
	Request.prototype.end = function(fn){
	  var self = this;
	  var xhr = this.xhr = request.getXHR();
	  var timeout = this._timeout;
	  var data = this._formData || this._data;
	
	  // store callback
	  this._callback = fn || noop;
	
	  // state change
	  xhr.onreadystatechange = function(){
	    if (4 != xhr.readyState) return;
	
	    // In IE9, reads to any property (e.g. status) off of an aborted XHR will
	    // result in the error "Could not complete the operation due to error c00c023f"
	    var status;
	    try { status = xhr.status } catch(e) { status = 0; }
	
	    if (0 == status) {
	      if (self.timedout) return self._timeoutError();
	      if (self._aborted) return;
	      return self.crossDomainError();
	    }
	    self.emit('end');
	  };
	
	  // progress
	  var handleProgress = function(e){
	    if (e.total > 0) {
	      e.percent = e.loaded / e.total * 100;
	    }
	    e.direction = 'download';
	    self.emit('progress', e);
	  };
	  if (this.hasListeners('progress')) {
	    xhr.onprogress = handleProgress;
	  }
	  try {
	    if (xhr.upload && this.hasListeners('progress')) {
	      xhr.upload.onprogress = handleProgress;
	    }
	  } catch(e) {
	    // Accessing xhr.upload fails in IE from a web worker, so just pretend it doesn't exist.
	    // Reported here:
	    // https://connect.microsoft.com/IE/feedback/details/837245/xmlhttprequest-upload-throws-invalid-argument-when-used-from-web-worker-context
	  }
	
	  // timeout
	  if (timeout && !this._timer) {
	    this._timer = setTimeout(function(){
	      self.timedout = true;
	      self.abort();
	    }, timeout);
	  }
	
	  // querystring
	  this._appendQueryString();
	
	  // initiate request
	  if (this.username && this.password) {
	    xhr.open(this.method, this.url, true, this.username, this.password);
	  } else {
	    xhr.open(this.method, this.url, true);
	  }
	
	  // CORS
	  if (this._withCredentials) xhr.withCredentials = true;
	
	  // body
	  if ('GET' != this.method && 'HEAD' != this.method && 'string' != typeof data && !this._isHost(data)) {
	    // serialize stuff
	    var contentType = this._header['content-type'];
	    var serialize = this._serializer || request.serialize[contentType ? contentType.split(';')[0] : ''];
	    if (!serialize && isJSON(contentType)) serialize = request.serialize['application/json'];
	    if (serialize) data = serialize(data);
	  }
	
	  // set header fields
	  for (var field in this.header) {
	    if (null == this.header[field]) continue;
	    xhr.setRequestHeader(field, this.header[field]);
	  }
	
	  if (this._responseType) {
	    xhr.responseType = this._responseType;
	  }
	
	  // send stuff
	  this.emit('request', this);
	
	  // IE11 xhr.send(undefined) sends 'undefined' string as POST payload (instead of nothing)
	  // We need null here if data is undefined
	  xhr.send(typeof data !== 'undefined' ? data : null);
	  return this;
	};
	
	
	/**
	 * Expose `Request`.
	 */
	
	request.Request = Request;
	
	/**
	 * GET `url` with optional callback `fn(res)`.
	 *
	 * @param {String} url
	 * @param {Mixed|Function} [data] or fn
	 * @param {Function} [fn]
	 * @return {Request}
	 * @api public
	 */
	
	request.get = function(url, data, fn){
	  var req = request('GET', url);
	  if ('function' == typeof data) fn = data, data = null;
	  if (data) req.query(data);
	  if (fn) req.end(fn);
	  return req;
	};
	
	/**
	 * HEAD `url` with optional callback `fn(res)`.
	 *
	 * @param {String} url
	 * @param {Mixed|Function} [data] or fn
	 * @param {Function} [fn]
	 * @return {Request}
	 * @api public
	 */
	
	request.head = function(url, data, fn){
	  var req = request('HEAD', url);
	  if ('function' == typeof data) fn = data, data = null;
	  if (data) req.send(data);
	  if (fn) req.end(fn);
	  return req;
	};
	
	/**
	 * OPTIONS query to `url` with optional callback `fn(res)`.
	 *
	 * @param {String} url
	 * @param {Mixed|Function} [data] or fn
	 * @param {Function} [fn]
	 * @return {Request}
	 * @api public
	 */
	
	request.options = function(url, data, fn){
	  var req = request('OPTIONS', url);
	  if ('function' == typeof data) fn = data, data = null;
	  if (data) req.send(data);
	  if (fn) req.end(fn);
	  return req;
	};
	
	/**
	 * DELETE `url` with optional callback `fn(res)`.
	 *
	 * @param {String} url
	 * @param {Function} [fn]
	 * @return {Request}
	 * @api public
	 */
	
	function del(url, fn){
	  var req = request('DELETE', url);
	  if (fn) req.end(fn);
	  return req;
	};
	
	request['del'] = del;
	request['delete'] = del;
	
	/**
	 * PATCH `url` with optional `data` and callback `fn(res)`.
	 *
	 * @param {String} url
	 * @param {Mixed} [data]
	 * @param {Function} [fn]
	 * @return {Request}
	 * @api public
	 */
	
	request.patch = function(url, data, fn){
	  var req = request('PATCH', url);
	  if ('function' == typeof data) fn = data, data = null;
	  if (data) req.send(data);
	  if (fn) req.end(fn);
	  return req;
	};
	
	/**
	 * POST `url` with optional `data` and callback `fn(res)`.
	 *
	 * @param {String} url
	 * @param {Mixed} [data]
	 * @param {Function} [fn]
	 * @return {Request}
	 * @api public
	 */
	
	request.post = function(url, data, fn){
	  var req = request('POST', url);
	  if ('function' == typeof data) fn = data, data = null;
	  if (data) req.send(data);
	  if (fn) req.end(fn);
	  return req;
	};
	
	/**
	 * PUT `url` with optional `data` and callback `fn(res)`.
	 *
	 * @param {String} url
	 * @param {Mixed|Function} [data] or fn
	 * @param {Function} [fn]
	 * @return {Request}
	 * @api public
	 */
	
	request.put = function(url, data, fn){
	  var req = request('PUT', url);
	  if ('function' == typeof data) fn = data, data = null;
	  if (data) req.send(data);
	  if (fn) req.end(fn);
	  return req;
	};


/***/ }),
/* 1169 */
/***/ (function(module, exports, __webpack_require__) {

	
	/**
	 * Expose `Emitter`.
	 */
	
	if (true) {
	  module.exports = Emitter;
	}
	
	/**
	 * Initialize a new `Emitter`.
	 *
	 * @api public
	 */
	
	function Emitter(obj) {
	  if (obj) return mixin(obj);
	};
	
	/**
	 * Mixin the emitter properties.
	 *
	 * @param {Object} obj
	 * @return {Object}
	 * @api private
	 */
	
	function mixin(obj) {
	  for (var key in Emitter.prototype) {
	    obj[key] = Emitter.prototype[key];
	  }
	  return obj;
	}
	
	/**
	 * Listen on the given `event` with `fn`.
	 *
	 * @param {String} event
	 * @param {Function} fn
	 * @return {Emitter}
	 * @api public
	 */
	
	Emitter.prototype.on =
	Emitter.prototype.addEventListener = function(event, fn){
	  this._callbacks = this._callbacks || {};
	  (this._callbacks['$' + event] = this._callbacks['$' + event] || [])
	    .push(fn);
	  return this;
	};
	
	/**
	 * Adds an `event` listener that will be invoked a single
	 * time then automatically removed.
	 *
	 * @param {String} event
	 * @param {Function} fn
	 * @return {Emitter}
	 * @api public
	 */
	
	Emitter.prototype.once = function(event, fn){
	  function on() {
	    this.off(event, on);
	    fn.apply(this, arguments);
	  }
	
	  on.fn = fn;
	  this.on(event, on);
	  return this;
	};
	
	/**
	 * Remove the given callback for `event` or all
	 * registered callbacks.
	 *
	 * @param {String} event
	 * @param {Function} fn
	 * @return {Emitter}
	 * @api public
	 */
	
	Emitter.prototype.off =
	Emitter.prototype.removeListener =
	Emitter.prototype.removeAllListeners =
	Emitter.prototype.removeEventListener = function(event, fn){
	  this._callbacks = this._callbacks || {};
	
	  // all
	  if (0 == arguments.length) {
	    this._callbacks = {};
	    return this;
	  }
	
	  // specific event
	  var callbacks = this._callbacks['$' + event];
	  if (!callbacks) return this;
	
	  // remove all handlers
	  if (1 == arguments.length) {
	    delete this._callbacks['$' + event];
	    return this;
	  }
	
	  // remove specific handler
	  var cb;
	  for (var i = 0; i < callbacks.length; i++) {
	    cb = callbacks[i];
	    if (cb === fn || cb.fn === fn) {
	      callbacks.splice(i, 1);
	      break;
	    }
	  }
	  return this;
	};
	
	/**
	 * Emit `event` with the given args.
	 *
	 * @param {String} event
	 * @param {Mixed} ...
	 * @return {Emitter}
	 */
	
	Emitter.prototype.emit = function(event){
	  this._callbacks = this._callbacks || {};
	  var args = [].slice.call(arguments, 1)
	    , callbacks = this._callbacks['$' + event];
	
	  if (callbacks) {
	    callbacks = callbacks.slice(0);
	    for (var i = 0, len = callbacks.length; i < len; ++i) {
	      callbacks[i].apply(this, args);
	    }
	  }
	
	  return this;
	};
	
	/**
	 * Return array of callbacks for `event`.
	 *
	 * @param {String} event
	 * @return {Array}
	 * @api public
	 */
	
	Emitter.prototype.listeners = function(event){
	  this._callbacks = this._callbacks || {};
	  return this._callbacks['$' + event] || [];
	};
	
	/**
	 * Check if this emitter has `event` handlers.
	 *
	 * @param {String} event
	 * @return {Boolean}
	 * @api public
	 */
	
	Emitter.prototype.hasListeners = function(event){
	  return !! this.listeners(event).length;
	};


/***/ }),
/* 1170 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Module of mixed-in functions shared between node and client code
	 */
	var isObject = __webpack_require__(1171);
	
	/**
	 * Clear previous timeout.
	 *
	 * @return {Request} for chaining
	 * @api public
	 */
	
	exports.clearTimeout = function _clearTimeout(){
	  this._timeout = 0;
	  clearTimeout(this._timer);
	  return this;
	};
	
	/**
	 * Override default response body parser
	 *
	 * This function will be called to convert incoming data into request.body
	 *
	 * @param {Function}
	 * @api public
	 */
	
	exports.parse = function parse(fn){
	  this._parser = fn;
	  return this;
	};
	
	/**
	 * Override default request body serializer
	 *
	 * This function will be called to convert data set via .send or .attach into payload to send
	 *
	 * @param {Function}
	 * @api public
	 */
	
	exports.serialize = function serialize(fn){
	  this._serializer = fn;
	  return this;
	};
	
	/**
	 * Set timeout to `ms`.
	 *
	 * @param {Number} ms
	 * @return {Request} for chaining
	 * @api public
	 */
	
	exports.timeout = function timeout(ms){
	  this._timeout = ms;
	  return this;
	};
	
	/**
	 * Promise support
	 *
	 * @param {Function} resolve
	 * @param {Function} reject
	 * @return {Request}
	 */
	
	exports.then = function then(resolve, reject) {
	  if (!this._fullfilledPromise) {
	    var self = this;
	    this._fullfilledPromise = new Promise(function(innerResolve, innerReject){
	      self.end(function(err, res){
	        if (err) innerReject(err); else innerResolve(res);
	      });
	    });
	  }
	  return this._fullfilledPromise.then(resolve, reject);
	}
	
	/**
	 * Allow for extension
	 */
	
	exports.use = function use(fn) {
	  fn(this);
	  return this;
	}
	
	
	/**
	 * Get request header `field`.
	 * Case-insensitive.
	 *
	 * @param {String} field
	 * @return {String}
	 * @api public
	 */
	
	exports.get = function(field){
	  return this._header[field.toLowerCase()];
	};
	
	/**
	 * Get case-insensitive header `field` value.
	 * This is a deprecated internal API. Use `.get(field)` instead.
	 *
	 * (getHeader is no longer used internally by the superagent code base)
	 *
	 * @param {String} field
	 * @return {String}
	 * @api private
	 * @deprecated
	 */
	
	exports.getHeader = exports.get;
	
	/**
	 * Set header `field` to `val`, or multiple fields with one object.
	 * Case-insensitive.
	 *
	 * Examples:
	 *
	 *      req.get('/')
	 *        .set('Accept', 'application/json')
	 *        .set('X-API-Key', 'foobar')
	 *        .end(callback);
	 *
	 *      req.get('/')
	 *        .set({ Accept: 'application/json', 'X-API-Key': 'foobar' })
	 *        .end(callback);
	 *
	 * @param {String|Object} field
	 * @param {String} val
	 * @return {Request} for chaining
	 * @api public
	 */
	
	exports.set = function(field, val){
	  if (isObject(field)) {
	    for (var key in field) {
	      this.set(key, field[key]);
	    }
	    return this;
	  }
	  this._header[field.toLowerCase()] = val;
	  this.header[field] = val;
	  return this;
	};
	
	/**
	 * Remove header `field`.
	 * Case-insensitive.
	 *
	 * Example:
	 *
	 *      req.get('/')
	 *        .unset('User-Agent')
	 *        .end(callback);
	 *
	 * @param {String} field
	 */
	exports.unset = function(field){
	  delete this._header[field.toLowerCase()];
	  delete this.header[field];
	  return this;
	};
	
	/**
	 * Write the field `name` and `val` for "multipart/form-data"
	 * request bodies.
	 *
	 * ``` js
	 * request.post('/upload')
	 *   .field('foo', 'bar')
	 *   .end(callback);
	 * ```
	 *
	 * @param {String} name
	 * @param {String|Blob|File|Buffer|fs.ReadStream} val
	 * @return {Request} for chaining
	 * @api public
	 */
	exports.field = function(name, val) {
	  this._getFormData().append(name, val);
	  return this;
	};
	
	/**
	 * Abort the request, and clear potential timeout.
	 *
	 * @return {Request}
	 * @api public
	 */
	exports.abort = function(){
	  if (this._aborted) {
	    return this;
	  }
	  this._aborted = true;
	  this.xhr && this.xhr.abort(); // browser
	  this.req && this.req.abort(); // node
	  this.clearTimeout();
	  this.emit('abort');
	  return this;
	};
	
	/**
	 * Enable transmission of cookies with x-domain requests.
	 *
	 * Note that for this to work the origin must not be
	 * using "Access-Control-Allow-Origin" with a wildcard,
	 * and also must set "Access-Control-Allow-Credentials"
	 * to "true".
	 *
	 * @api public
	 */
	
	exports.withCredentials = function(){
	  // This is browser-only functionality. Node side is no-op.
	  this._withCredentials = true;
	  return this;
	};
	
	/**
	 * Set the max redirects to `n`. Does noting in browser XHR implementation.
	 *
	 * @param {Number} n
	 * @return {Request} for chaining
	 * @api public
	 */
	
	exports.redirects = function(n){
	  this._maxRedirects = n;
	  return this;
	};
	
	/**
	 * Convert to a plain javascript object (not JSON string) of scalar properties.
	 * Note as this method is designed to return a useful non-this value,
	 * it cannot be chained.
	 *
	 * @return {Object} describing method, url, and data of this request
	 * @api public
	 */
	
	exports.toJSON = function(){
	  return {
	    method: this.method,
	    url: this.url,
	    data: this._data,
	    headers: this._header
	  };
	};
	
	/**
	 * Check if `obj` is a host object,
	 * we don't want to serialize these :)
	 *
	 * TODO: future proof, move to compoent land
	 *
	 * @param {Object} obj
	 * @return {Boolean}
	 * @api private
	 */
	
	exports._isHost = function _isHost(obj) {
	  var str = {}.toString.call(obj);
	
	  switch (str) {
	    case '[object File]':
	    case '[object Blob]':
	    case '[object FormData]':
	      return true;
	    default:
	      return false;
	  }
	}
	
	/**
	 * Send `data` as the request body, defaulting the `.type()` to "json" when
	 * an object is given.
	 *
	 * Examples:
	 *
	 *       // manual json
	 *       request.post('/user')
	 *         .type('json')
	 *         .send('{"name":"tj"}')
	 *         .end(callback)
	 *
	 *       // auto json
	 *       request.post('/user')
	 *         .send({ name: 'tj' })
	 *         .end(callback)
	 *
	 *       // manual x-www-form-urlencoded
	 *       request.post('/user')
	 *         .type('form')
	 *         .send('name=tj')
	 *         .end(callback)
	 *
	 *       // auto x-www-form-urlencoded
	 *       request.post('/user')
	 *         .type('form')
	 *         .send({ name: 'tj' })
	 *         .end(callback)
	 *
	 *       // defaults to x-www-form-urlencoded
	 *      request.post('/user')
	 *        .send('name=tobi')
	 *        .send('species=ferret')
	 *        .end(callback)
	 *
	 * @param {String|Object} data
	 * @return {Request} for chaining
	 * @api public
	 */
	
	exports.send = function(data){
	  var obj = isObject(data);
	  var type = this._header['content-type'];
	
	  // merge
	  if (obj && isObject(this._data)) {
	    for (var key in data) {
	      this._data[key] = data[key];
	    }
	  } else if ('string' == typeof data) {
	    // default to x-www-form-urlencoded
	    if (!type) this.type('form');
	    type = this._header['content-type'];
	    if ('application/x-www-form-urlencoded' == type) {
	      this._data = this._data
	        ? this._data + '&' + data
	        : data;
	    } else {
	      this._data = (this._data || '') + data;
	    }
	  } else {
	    this._data = data;
	  }
	
	  if (!obj || this._isHost(data)) return this;
	
	  // default to json
	  if (!type) this.type('json');
	  return this;
	};


/***/ }),
/* 1171 */
/***/ (function(module, exports) {

	/**
	 * Check if `obj` is an object.
	 *
	 * @param {Object} obj
	 * @return {Boolean}
	 * @api private
	 */
	
	function isObject(obj) {
	  return null !== obj && 'object' === typeof obj;
	}
	
	module.exports = isObject;


/***/ }),
/* 1172 */
/***/ (function(module, exports) {

	// The node and browser modules expose versions of this with the
	// appropriate constructor function bound as first argument
	/**
	 * Issue a request:
	 *
	 * Examples:
	 *
	 *    request('GET', '/users').end(callback)
	 *    request('/users').end(callback)
	 *    request('/users', callback)
	 *
	 * @param {String} method
	 * @param {String|Function} url or callback
	 * @return {Request}
	 * @api public
	 */
	
	function request(RequestConstructor, method, url) {
	  // callback
	  if ('function' == typeof url) {
	    return new RequestConstructor('GET', method).end(url);
	  }
	
	  // url first
	  if (2 == arguments.length) {
	    return new RequestConstructor('GET', method);
	  }
	
	  return new RequestConstructor(method, url);
	}
	
	module.exports = request;


/***/ }),
/* 1173 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  /* SYNC FROM API/CONFIG */
	  fee: {
	    supported_currencies: ["usd", "cad", "gbp", "mxn", "isk", "ils", "eur", "krw", "nzd", "bam", "aud", "sek", "clp", "nok", "zar", "php", "aed", "qar", "dkk", "idr", "inr", "hkd", "ars", "chf", "thb", "jpy", "ngn"],
	    zero_decimal: ["krw", "clp", "jpy"],
	    service_fee_threshold: {
	      default: 300
	    }
	  },
	
	  locales: ["af-ZA", "am-ET", "ar-AE", "ar-BH", "ar-DZ", "ar-EG", "ar-IQ", "ar-JO", "ar-KW", "ar-LB", "ar-LY", "ar-MA", "arn-CL", "ar-OM", "ar-QA", "ar-SA", "ar-SY", "ar-TN", "ar-YE", "as-IN", "az-Cyrl-AZ", "az-Latn-AZ", "ba-RU", "be-BY", "bg-BG", "bn-BD", "bn-IN", "bo-CN", "br-FR", "bs-Cyrl-BA", "bs-Latn-BA", "ca-ES", "co-FR", "cs-CZ", "cy-GB", "da-DK", "de-AT", "de-CH", "de-DE", "de-LI", "de-LU", "dsb-DE", "dv-MV", "el-GR", "en-029", "en-AU", "en-BZ", "en-CA", "en-GB", "en-IE", "en-IN", "en-JM", "en-MY", "en-NZ", "en-PH", "en-SG", "en-TT", "en-US", "en-ZA", "en-ZW", "es-AR", "es-BO", "es-CL", "es-CO", "es-CR", "es-DO", "es-EC", "es-ES", "es-GT", "es-HN", "es-MX", "es-NI", "es-PA", "es-PE", "es-PR", "es-PY", "es-SV", "es-US", "es-UY", "es-VE", "et-EE", "eu-ES", "fa-IR", "fi-FI", "fil-PH", "fo-FO", "fr-BE", "fr-CA", "fr-CH", "fr-FR", "fr-LU", "fr-MC", "fy-NL", "ga-IE", "gd-GB", "gl-ES", "gsw-FR", "gu-IN", "ha-Latn-NG", "he-IL", "hi-IN", "hr-BA", "hr-HR", "hsb-DE", "hu-HU", "hy-AM", "id-ID", "ig-NG", "ii-CN", "is-IS", "it-CH", "it-IT", "iu-Cans-CA", "iu-Latn-CA", "ja-JP", "ka-GE", "kk-KZ", "kl-GL", "km-KH", "kn-IN", "kok-IN", "ko-KR", "ky-KG", "lb-LU", "lo-LA", "lt-LT", "lv-LV", "mi-NZ", "mk-MK", "ml-IN", "mn-MN", "mn-Mong-CN", "moh-CA", "mr-IN", "ms-BN", "ms-MY", "mt-MT", "nb-NO", "ne-NP", "nl-BE", "nl-NL", "nn-NO", "nso-ZA", "oc-FR", "or-IN", "pa-IN", "pl-PL", "prs-AF", "ps-AF", "pt-BR", "pt-PT", "qut-GT", "quz-BO", "quz-EC", "quz-PE", "rm-CH", "ro-RO", "ru-RU", "rw-RW", "sah-RU", "sa-IN", "se-FI", "se-NO", "se-SE", "si-LK", "sk-SK", "sl-SI", "sma-NO", "sma-SE", "smj-NO", "smj-SE", "smn-FI", "sms-FI", "sq-AL", "sr-Cyrl-BA", "sr-Cyrl-CS", "sr-Cyrl-ME", "sr-Cyrl-RS", "sr-Latn-BA", "sr-Latn-CS", "sr-Latn-ME", "sr-Latn-RS", "sv-FI", "sv-SE", "sw-KE", "syr-SY", "ta-IN", "te-IN", "tg-Cyrl-TJ", "th-TH", "tk-TM", "tn-ZA", "tr-TR", "tt-RU", "tzm-Latn-DZ", "ug-CN", "uk-UA", "ur-PK", "uz-Cyrl-UZ", "uz-Latn-UZ", "vi-VN", "wo-SN", "xh-ZA", "yo-NG", "zh-CN", "zh-HK", "zh-MO", "zh-SG", "zh-TW", "zu-ZA"],
	
	  endpoint: ("https://api.eventive.org/")
	};
	module.exports = exports["default"];

/***/ }),
/* 1174 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ravenJs = __webpack_require__(1175);
	
	var _ravenJs2 = _interopRequireDefault(_ravenJs);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_ravenJs2.default.config(("https://5c617dc8deb14d8db10192c627592430@app.getsentry.com/93404"), {
	  release: ("56dbecf7d0a937d06762cad5431de96ed40a29d5")
	}).install();
	
	var client;
	if (true) {
	  client = _ravenJs2.default;
	} else {
	  client = {
	    captureException: console.error,
	    captureMessage: console.log,
	    setUserContext: function setUserContext() {}
	  };
	}
	
	function log(level, body, cb) {
	  // If an error object, capture as an exception
	  if (body.stack) {
	    return client.captureException(body, cb);
	  }
	
	  if (typeof body !== "string") {
	    body = JSON.stringify(body);
	  }
	  client.captureMessage(body, {
	    level: level
	  }, cb);
	}
	
	// Hook into promise exceptions
	window.onunhandledrejection = function (e) {
	  // If not an error object, bundle it up ourselves
	  if (!(e.reason instanceof Error) && e.reason && e.reason.message) {
	    client.captureException(new Error(e.reason.message));
	  } else {
	    client.captureException(e.reason);
	  }
	};
	
	exports.default = {
	  info: log.bind(null, "info"),
	  warn: log.bind(null, "warning"),
	  err: log.bind(null, "err"),
	  setUserContext: client.setUserContext.bind(client)
	};
	module.exports = exports["default"];

/***/ }),
/* 1175 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Enforces a single instance of the Raven client, and the
	 * main entry point for Raven. If you are a consumer of the
	 * Raven library, you SHOULD load this file (vs raven.js).
	 **/
	
	'use strict';
	
	var RavenConstructor = __webpack_require__(1176);
	
	var _Raven = window.Raven;
	
	var Raven = new RavenConstructor();
	
	/*
	 * Allow multiple versions of Raven to be installed.
	 * Strip Raven from the global context and returns the instance.
	 *
	 * @return {Raven}
	 */
	Raven.noConflict = function () {
		window.Raven = _Raven;
		return Raven;
	};
	
	Raven.afterLoad();
	
	module.exports = Raven;


/***/ }),
/* 1176 */
/***/ (function(module, exports, __webpack_require__) {

	/*global XDomainRequest:false*/
	'use strict';
	
	var TraceKit = __webpack_require__(1177);
	var RavenConfigError = __webpack_require__(1179);
	var utils = __webpack_require__(1178);
	var stringify = __webpack_require__(1180);
	
	var isFunction = utils.isFunction;
	var isUndefined = utils.isUndefined;
	var isError = utils.isError;
	var isEmptyObject = utils.isEmptyObject;
	var hasKey = utils.hasKey;
	var joinRegExp = utils.joinRegExp;
	var each = utils.each;
	var objectMerge = utils.objectMerge;
	var truncate = utils.truncate;
	var urlencode = utils.urlencode;
	var uuid4 = utils.uuid4;
	var htmlTreeAsString = utils.htmlTreeAsString;
	var parseUrl = utils.parseUrl;
	var isString = utils.isString;
	var fill = utils.fill;
	
	var wrapConsoleMethod = __webpack_require__(1181).wrapMethod;
	
	var dsnKeys = 'source protocol user pass host port path'.split(' '),
	    dsnPattern = /^(?:(\w+):)?\/\/(?:(\w+)(:\w+)?@)?([\w\.-]+)(?::(\d+))?(\/.*)/;
	
	function now() {
	    return +new Date();
	}
	
	
	// First, check for JSON support
	// If there is no JSON, we no-op the core features of Raven
	// since JSON is required to encode the payload
	function Raven() {
	    this._hasJSON = !!(typeof JSON === 'object' && JSON.stringify);
	    // Raven can run in contexts where there's no document (react-native)
	    this._hasDocument = typeof document !== 'undefined';
	    this._lastCapturedException = null;
	    this._lastEventId = null;
	    this._globalServer = null;
	    this._globalKey = null;
	    this._globalProject = null;
	    this._globalContext = {};
	    this._globalOptions = {
	        logger: 'javascript',
	        ignoreErrors: [],
	        ignoreUrls: [],
	        whitelistUrls: [],
	        includePaths: [],
	        crossOrigin: 'anonymous',
	        collectWindowErrors: true,
	        maxMessageLength: 0,
	        stackTraceLimit: 50,
	        autoBreadcrumbs: true
	    };
	    this._ignoreOnError = 0;
	    this._isRavenInstalled = false;
	    this._originalErrorStackTraceLimit = Error.stackTraceLimit;
	    // capture references to window.console *and* all its methods first
	    // before the console plugin has a chance to monkey patch
	    this._originalConsole = window.console || {};
	    this._originalConsoleMethods = {};
	    this._plugins = [];
	    this._startTime = now();
	    this._wrappedBuiltIns = [];
	    this._breadcrumbs = [];
	    this._lastCapturedEvent = null;
	    this._keypressTimeout;
	    this._location = window.location;
	    this._lastHref = this._location && this._location.href;
	
	    for (var method in this._originalConsole) {  // eslint-disable-line guard-for-in
	      this._originalConsoleMethods[method] = this._originalConsole[method];
	    }
	}
	
	/*
	 * The core Raven singleton
	 *
	 * @this {Raven}
	 */
	
	Raven.prototype = {
	    // Hardcode version string so that raven source can be loaded directly via
	    // webpack (using a build step causes webpack #1617). Grunt verifies that
	    // this value matches package.json during build.
	    //   See: https://github.com/getsentry/raven-js/issues/465
	    VERSION: '3.5.1',
	
	    debug: false,
	
	    TraceKit: TraceKit, // alias to TraceKit
	
	    /*
	     * Configure Raven with a DSN and extra options
	     *
	     * @param {string} dsn The public Sentry DSN
	     * @param {object} options Optional set of of global options [optional]
	     * @return {Raven}
	     */
	    config: function(dsn, options) {
	        var self = this;
	
	        if (this._globalServer) {
	                this._logDebug('error', 'Error: Raven has already been configured');
	            return this;
	        }
	        if (!dsn) return this;
	
	        // merge in options
	        if (options) {
	            each(options, function(key, value){
	                // tags and extra are special and need to be put into context
	                if (key === 'tags' || key === 'extra') {
	                    self._globalContext[key] = value;
	                } else {
	                    self._globalOptions[key] = value;
	                }
	            });
	        }
	
	        var uri = this._parseDSN(dsn),
	            lastSlash = uri.path.lastIndexOf('/'),
	            path = uri.path.substr(1, lastSlash);
	
	        this._dsn = dsn;
	
	        // "Script error." is hard coded into browsers for errors that it can't read.
	        // this is the result of a script being pulled in from an external domain and CORS.
	        this._globalOptions.ignoreErrors.push(/^Script error\.?$/);
	        this._globalOptions.ignoreErrors.push(/^Javascript error: Script error\.? on line 0$/);
	
	        // join regexp rules into one big rule
	        this._globalOptions.ignoreErrors = joinRegExp(this._globalOptions.ignoreErrors);
	        this._globalOptions.ignoreUrls = this._globalOptions.ignoreUrls.length ? joinRegExp(this._globalOptions.ignoreUrls) : false;
	        this._globalOptions.whitelistUrls = this._globalOptions.whitelistUrls.length ? joinRegExp(this._globalOptions.whitelistUrls) : false;
	        this._globalOptions.includePaths = joinRegExp(this._globalOptions.includePaths);
	        this._globalOptions.maxBreadcrumbs = Math.max(0, Math.min(this._globalOptions.maxBreadcrumbs || 100, 100)); // default and hard limit is 100
	
	        var autoBreadcrumbDefaults = {
	            xhr: true,
	            console: true,
	            dom: true,
	            location: true
	        };
	
	        var autoBreadcrumbs = this._globalOptions.autoBreadcrumbs;
	        if ({}.toString.call(autoBreadcrumbs) === '[object Object]') {
	            autoBreadcrumbs = objectMerge(autoBreadcrumbDefaults, autoBreadcrumbs);
	        } else if (autoBreadcrumbs !== false) {
	            autoBreadcrumbs = autoBreadcrumbDefaults;
	        }
	        this._globalOptions.autoBreadcrumbs = autoBreadcrumbs;
	
	        this._globalKey = uri.user;
	        this._globalSecret = uri.pass && uri.pass.substr(1);
	        this._globalProject = uri.path.substr(lastSlash + 1);
	
	        this._globalServer = this._getGlobalServer(uri);
	
	        this._globalEndpoint = this._globalServer +
	            '/' + path + 'api/' + this._globalProject + '/store/';
	
	        TraceKit.collectWindowErrors = !!this._globalOptions.collectWindowErrors;
	
	        // return for chaining
	        return this;
	    },
	
	    /*
	     * Installs a global window.onerror error handler
	     * to capture and report uncaught exceptions.
	     * At this point, install() is required to be called due
	     * to the way TraceKit is set up.
	     *
	     * @return {Raven}
	     */
	    install: function() {
	        var self = this;
	        if (this.isSetup() && !this._isRavenInstalled) {
	            TraceKit.report.subscribe(function () {
	                self._handleOnErrorStackInfo.apply(self, arguments);
	            });
	            this._instrumentTryCatch();
	            if (self._globalOptions.autoBreadcrumbs)
	                this._instrumentBreadcrumbs();
	
	            // Install all of the plugins
	            this._drainPlugins();
	
	            this._isRavenInstalled = true;
	        }
	
	        Error.stackTraceLimit = this._globalOptions.stackTraceLimit;
	        return this;
	    },
	
	    /*
	     * Wrap code within a context so Raven can capture errors
	     * reliably across domains that is executed immediately.
	     *
	     * @param {object} options A specific set of options for this context [optional]
	     * @param {function} func The callback to be immediately executed within the context
	     * @param {array} args An array of arguments to be called with the callback [optional]
	     */
	    context: function(options, func, args) {
	        if (isFunction(options)) {
	            args = func || [];
	            func = options;
	            options = undefined;
	        }
	
	        return this.wrap(options, func).apply(this, args);
	    },
	
	    /*
	     * Wrap code within a context and returns back a new function to be executed
	     *
	     * @param {object} options A specific set of options for this context [optional]
	     * @param {function} func The function to be wrapped in a new context
	     * @param {function} func A function to call before the try/catch wrapper [optional, private]
	     * @return {function} The newly wrapped functions with a context
	     */
	    wrap: function(options, func, _before) {
	        var self = this;
	        // 1 argument has been passed, and it's not a function
	        // so just return it
	        if (isUndefined(func) && !isFunction(options)) {
	            return options;
	        }
	
	        // options is optional
	        if (isFunction(options)) {
	            func = options;
	            options = undefined;
	        }
	
	        // At this point, we've passed along 2 arguments, and the second one
	        // is not a function either, so we'll just return the second argument.
	        if (!isFunction(func)) {
	            return func;
	        }
	
	        // We don't wanna wrap it twice!
	        try {
	            if (func.__raven__) {
	                return func;
	            }
	        } catch (e) {
	            // Just accessing the __raven__ prop in some Selenium environments
	            // can cause a "Permission denied" exception (see raven-js#495).
	            // Bail on wrapping and return the function as-is (defers to window.onerror).
	            return func;
	        }
	
	        // If this has already been wrapped in the past, return that
	        if (func.__raven_wrapper__ ){
	            return func.__raven_wrapper__ ;
	        }
	
	        function wrapped() {
	            var args = [], i = arguments.length,
	                deep = !options || options && options.deep !== false;
	
	            if (_before && isFunction(_before)) {
	                _before.apply(this, arguments);
	            }
	
	            // Recursively wrap all of a function's arguments that are
	            // functions themselves.
	            while(i--) args[i] = deep ? self.wrap(options, arguments[i]) : arguments[i];
	
	            try {
	                return func.apply(this, args);
	            } catch(e) {
	                self._ignoreNextOnError();
	                self.captureException(e, options);
	                throw e;
	            }
	        }
	
	        // copy over properties of the old function
	        for (var property in func) {
	            if (hasKey(func, property)) {
	                wrapped[property] = func[property];
	            }
	        }
	        wrapped.prototype = func.prototype;
	
	        func.__raven_wrapper__ = wrapped;
	        // Signal that this function has been wrapped already
	        // for both debugging and to prevent it to being wrapped twice
	        wrapped.__raven__ = true;
	        wrapped.__inner__ = func;
	
	        return wrapped;
	    },
	
	    /*
	     * Uninstalls the global error handler.
	     *
	     * @return {Raven}
	     */
	    uninstall: function() {
	        TraceKit.report.uninstall();
	
	        this._restoreBuiltIns();
	
	        Error.stackTraceLimit = this._originalErrorStackTraceLimit;
	        this._isRavenInstalled = false;
	
	        return this;
	    },
	
	    /*
	     * Manually capture an exception and send it over to Sentry
	     *
	     * @param {error} ex An exception to be logged
	     * @param {object} options A specific set of options for this error [optional]
	     * @return {Raven}
	     */
	    captureException: function(ex, options) {
	        // If not an Error is passed through, recall as a message instead
	        if (!isError(ex)) return this.captureMessage(ex, options);
	
	        // Store the raw exception object for potential debugging and introspection
	        this._lastCapturedException = ex;
	
	        // TraceKit.report will re-raise any exception passed to it,
	        // which means you have to wrap it in try/catch. Instead, we
	        // can wrap it here and only re-raise if TraceKit.report
	        // raises an exception different from the one we asked to
	        // report on.
	        try {
	            var stack = TraceKit.computeStackTrace(ex);
	            this._handleStackInfo(stack, options);
	        } catch(ex1) {
	            if(ex !== ex1) {
	                throw ex1;
	            }
	        }
	
	        return this;
	    },
	
	    /*
	     * Manually send a message to Sentry
	     *
	     * @param {string} msg A plain message to be captured in Sentry
	     * @param {object} options A specific set of options for this message [optional]
	     * @return {Raven}
	     */
	    captureMessage: function(msg, options) {
	        // config() automagically converts ignoreErrors from a list to a RegExp so we need to test for an
	        // early call; we'll error on the side of logging anything called before configuration since it's
	        // probably something you should see:
	        if (!!this._globalOptions.ignoreErrors.test && this._globalOptions.ignoreErrors.test(msg)) {
	            return;
	        }
	
	        // Fire away!
	        this._send(
	            objectMerge({
	                message: msg + ''  // Make sure it's actually a string
	            }, options)
	        );
	
	        return this;
	    },
	
	    captureBreadcrumb: function (obj) {
	        var crumb = objectMerge({
	            timestamp: now() / 1000
	        }, obj);
	
	        this._breadcrumbs.push(crumb);
	        if (this._breadcrumbs.length > this._globalOptions.maxBreadcrumbs) {
	            this._breadcrumbs.shift();
	        }
	    },
	
	    addPlugin: function(plugin /*arg1, arg2, ... argN*/) {
	        var pluginArgs = Array.prototype.slice.call(arguments, 1);
	
	        this._plugins.push([plugin, pluginArgs]);
	        if (this._isRavenInstalled) {
	            this._drainPlugins();
	        }
	
	        return this;
	    },
	
	    /*
	     * Set/clear a user to be sent along with the payload.
	     *
	     * @param {object} user An object representing user data [optional]
	     * @return {Raven}
	     */
	    setUserContext: function(user) {
	        // Intentionally do not merge here since that's an unexpected behavior.
	        this._globalContext.user = user;
	
	        return this;
	    },
	
	    /*
	     * Merge extra attributes to be sent along with the payload.
	     *
	     * @param {object} extra An object representing extra data [optional]
	     * @return {Raven}
	     */
	    setExtraContext: function(extra) {
	        this._mergeContext('extra', extra);
	
	        return this;
	    },
	
	    /*
	     * Merge tags to be sent along with the payload.
	     *
	     * @param {object} tags An object representing tags [optional]
	     * @return {Raven}
	     */
	    setTagsContext: function(tags) {
	        this._mergeContext('tags', tags);
	
	        return this;
	    },
	
	    /*
	     * Clear all of the context.
	     *
	     * @return {Raven}
	     */
	    clearContext: function() {
	        this._globalContext = {};
	
	        return this;
	    },
	
	    /*
	     * Get a copy of the current context. This cannot be mutated.
	     *
	     * @return {object} copy of context
	     */
	    getContext: function() {
	        // lol javascript
	        return JSON.parse(stringify(this._globalContext));
	    },
	
	
	    /*
	     * Set environment of application
	     *
	     * @param {string} environment Typically something like 'production'.
	     * @return {Raven}
	     */
	    setEnvironment: function(environment) {
	        this._globalOptions.environment = environment;
	
	        return this;
	    },
	
	    /*
	     * Set release version of application
	     *
	     * @param {string} release Typically something like a git SHA to identify version
	     * @return {Raven}
	     */
	    setRelease: function(release) {
	        this._globalOptions.release = release;
	
	        return this;
	    },
	
	    /*
	     * Set the dataCallback option
	     *
	     * @param {function} callback The callback to run which allows the
	     *                            data blob to be mutated before sending
	     * @return {Raven}
	     */
	    setDataCallback: function(callback) {
	        var original = this._globalOptions.dataCallback;
	        this._globalOptions.dataCallback = isFunction(callback)
	          ? function (data) { return callback(data, original); }
	          : callback;
	
	        return this;
	    },
	
	    /*
	     * Set the shouldSendCallback option
	     *
	     * @param {function} callback The callback to run which allows
	     *                            introspecting the blob before sending
	     * @return {Raven}
	     */
	    setShouldSendCallback: function(callback) {
	        var original = this._globalOptions.shouldSendCallback;
	        this._globalOptions.shouldSendCallback = isFunction(callback)
	            ? function (data) { return callback(data, original); }
	            : callback;
	
	        return this;
	    },
	
	    /**
	     * Override the default HTTP transport mechanism that transmits data
	     * to the Sentry server.
	     *
	     * @param {function} transport Function invoked instead of the default
	     *                             `makeRequest` handler.
	     *
	     * @return {Raven}
	     */
	    setTransport: function(transport) {
	        this._globalOptions.transport = transport;
	
	        return this;
	    },
	
	    /*
	     * Get the latest raw exception that was captured by Raven.
	     *
	     * @return {error}
	     */
	    lastException: function() {
	        return this._lastCapturedException;
	    },
	
	    /*
	     * Get the last event id
	     *
	     * @return {string}
	     */
	    lastEventId: function() {
	        return this._lastEventId;
	    },
	
	    /*
	     * Determine if Raven is setup and ready to go.
	     *
	     * @return {boolean}
	     */
	    isSetup: function() {
	        if (!this._hasJSON) return false;  // needs JSON support
	        if (!this._globalServer) {
	            if (!this.ravenNotConfiguredError) {
	              this.ravenNotConfiguredError = true;
	              this._logDebug('error', 'Error: Raven has not been configured.');
	            }
	            return false;
	        }
	        return true;
	    },
	
	    afterLoad: function () {
	        // TODO: remove window dependence?
	
	        // Attempt to initialize Raven on load
	        var RavenConfig = window.RavenConfig;
	        if (RavenConfig) {
	            this.config(RavenConfig.dsn, RavenConfig.config).install();
	        }
	    },
	
	    showReportDialog: function (options) {
	        if (!window.document) // doesn't work without a document (React native)
	            return;
	
	        options = options || {};
	
	        var lastEventId = options.eventId || this.lastEventId();
	        if (!lastEventId) {
	            throw new RavenConfigError('Missing eventId');
	        }
	
	        var dsn = options.dsn || this._dsn;
	        if (!dsn) {
	            throw new RavenConfigError('Missing DSN');
	        }
	
	        var encode = encodeURIComponent;
	        var qs = '';
	        qs += '?eventId=' + encode(lastEventId);
	        qs += '&dsn=' + encode(dsn);
	
	        var user = options.user || this._globalContext.user;
	        if (user) {
	            if (user.name)  qs += '&name=' + encode(user.name);
	            if (user.email) qs += '&email=' + encode(user.email);
	        }
	
	        var globalServer = this._getGlobalServer(this._parseDSN(dsn));
	
	        var script = document.createElement('script');
	        script.async = true;
	        script.src = globalServer + '/api/embed/error-page/' + qs;
	        (document.head || document.body).appendChild(script);
	    },
	
	    /**** Private functions ****/
	    _ignoreNextOnError: function () {
	        var self = this;
	        this._ignoreOnError += 1;
	        setTimeout(function () {
	            // onerror should trigger before setTimeout
	            self._ignoreOnError -= 1;
	        });
	    },
	
	    _triggerEvent: function(eventType, options) {
	        // NOTE: `event` is a native browser thing, so let's avoid conflicting wiht it
	        var evt, key;
	
	        if (!this._hasDocument)
	            return;
	
	        options = options || {};
	
	        eventType = 'raven' + eventType.substr(0,1).toUpperCase() + eventType.substr(1);
	
	        if (document.createEvent) {
	            evt = document.createEvent('HTMLEvents');
	            evt.initEvent(eventType, true, true);
	        } else {
	            evt = document.createEventObject();
	            evt.eventType = eventType;
	        }
	
	        for (key in options) if (hasKey(options, key)) {
	            evt[key] = options[key];
	        }
	
	        if (document.createEvent) {
	            // IE9 if standards
	            document.dispatchEvent(evt);
	        } else {
	            // IE8 regardless of Quirks or Standards
	            // IE9 if quirks
	            try {
	                document.fireEvent('on' + evt.eventType.toLowerCase(), evt);
	            } catch(e) {
	                // Do nothing
	            }
	        }
	    },
	
	    /**
	     * Wraps addEventListener to capture UI breadcrumbs
	     * @param evtName the event name (e.g. "click")
	     * @returns {Function}
	     * @private
	     */
	    _breadcrumbEventHandler: function(evtName) {
	        var self = this;
	        return function (evt) {
	            // reset keypress timeout; e.g. triggering a 'click' after
	            // a 'keypress' will reset the keypress debounce so that a new
	            // set of keypresses can be recorded
	            self._keypressTimeout = null;
	
	            // It's possible this handler might trigger multiple times for the same
	            // event (e.g. event propagation through node ancestors). Ignore if we've
	            // already captured the event.
	            if (self._lastCapturedEvent === evt)
	                return;
	
	            self._lastCapturedEvent = evt;
	            var elem = evt.target;
	
	            var target;
	
	            // try/catch htmlTreeAsString because it's particularly complicated, and
	            // just accessing the DOM incorrectly can throw an exception in some circumstances.
	            try {
	                target = htmlTreeAsString(elem);
	            } catch (e) {
	                target = '<unknown>';
	            }
	
	            self.captureBreadcrumb({
	                category: 'ui.' + evtName, // e.g. ui.click, ui.input
	                message: target
	            });
	        };
	    },
	
	    /**
	     * Wraps addEventListener to capture keypress UI events
	     * @returns {Function}
	     * @private
	     */
	    _keypressEventHandler: function() {
	        var self = this,
	            debounceDuration = 1000; // milliseconds
	
	        // TODO: if somehow user switches keypress target before
	        //       debounce timeout is triggered, we will only capture
	        //       a single breadcrumb from the FIRST target (acceptable?)
	
	        return function (evt) {
	            var target = evt.target,
	                tagName = target && target.tagName;
	
	            // only consider keypress events on actual input elements
	            // this will disregard keypresses targeting body (e.g. tabbing
	            // through elements, hotkeys, etc)
	            if (!tagName || tagName !== 'INPUT' && tagName !== 'TEXTAREA')
	                return;
	
	            // record first keypress in a series, but ignore subsequent
	            // keypresses until debounce clears
	            var timeout = self._keypressTimeout;
	            if (!timeout) {
	                self._breadcrumbEventHandler('input')(evt);
	            }
	            clearTimeout(timeout);
	            self._keypressTimeout = setTimeout(function () {
	               self._keypressTimeout = null;
	            }, debounceDuration);
	        };
	    },
	
	    /**
	     * Captures a breadcrumb of type "navigation", normalizing input URLs
	     * @param to the originating URL
	     * @param from the target URL
	     * @private
	     */
	    _captureUrlChange: function(from, to) {
	        var parsedLoc = parseUrl(this._location.href);
	        var parsedTo = parseUrl(to);
	        var parsedFrom = parseUrl(from);
	
	        // because onpopstate only tells you the "new" (to) value of location.href, and
	        // not the previous (from) value, we need to track the value of the current URL
	        // state ourselves
	        this._lastHref = to;
	
	        // Use only the path component of the URL if the URL matches the current
	        // document (almost all the time when using pushState)
	        if (parsedLoc.protocol === parsedTo.protocol && parsedLoc.host === parsedTo.host)
	            to = parsedTo.relative;
	        if (parsedLoc.protocol === parsedFrom.protocol && parsedLoc.host === parsedFrom.host)
	            from = parsedFrom.relative;
	
	        this.captureBreadcrumb({
	            category: 'navigation',
	            data: {
	                to: to,
	                from: from
	            }
	        });
	    },
	
	    /**
	     * Install any queued plugins
	     */
	    _instrumentTryCatch: function() {
	        var self = this;
	
	        var wrappedBuiltIns = self._wrappedBuiltIns;
	
	        function wrapTimeFn(orig) {
	            return function (fn, t) { // preserve arity
	                // Make a copy of the arguments to prevent deoptimization
	                // https://github.com/petkaantonov/bluebird/wiki/Optimization-killers#32-leaking-arguments
	                var args = new Array(arguments.length);
	                for(var i = 0; i < args.length; ++i) {
	                    args[i] = arguments[i];
	                }
	                var originalCallback = args[0];
	                if (isFunction(originalCallback)) {
	                    args[0] = self.wrap(originalCallback);
	                }
	
	                // IE < 9 doesn't support .call/.apply on setInterval/setTimeout, but it
	                // also supports only two arguments and doesn't care what this is, so we
	                // can just call the original function directly.
	                if (orig.apply) {
	                    return orig.apply(this, args);
	                } else {
	                    return orig(args[0], args[1]);
	                }
	            };
	        }
	
	        var autoBreadcrumbs = this._globalOptions.autoBreadcrumbs;
	
	        function wrapEventTarget(global) {
	            var proto = window[global] && window[global].prototype;
	            if (proto && proto.hasOwnProperty && proto.hasOwnProperty('addEventListener')) {
	                fill(proto, 'addEventListener', function(orig) {
	                    return function (evtName, fn, capture, secure) { // preserve arity
	                        try {
	                            if (fn && fn.handleEvent) {
	                                fn.handleEvent = self.wrap(fn.handleEvent);
	                            }
	                        } catch (err) {
	                            // can sometimes get 'Permission denied to access property "handle Event'
	                        }
	
	                        // More breadcrumb DOM capture ... done here and not in `_instrumentBreadcrumbs`
	                        // so that we don't have more than one wrapper function
	                        var before;
	                        if (autoBreadcrumbs && autoBreadcrumbs.dom && (global === 'EventTarget' || global === 'Node')) {
	                            if (evtName === 'click'){
	                                before = self._breadcrumbEventHandler(evtName);
	                            } else if (evtName === 'keypress') {
	                                before = self._keypressEventHandler();
	                            }
	                        }
	                        return orig.call(this, evtName, self.wrap(fn, undefined, before), capture, secure);
	                    };
	                }, wrappedBuiltIns);
	                fill(proto, 'removeEventListener', function (orig) {
	                    return function (evt, fn, capture, secure) {
	                        fn = fn && (fn.__raven_wrapper__ ? fn.__raven_wrapper__  : fn);
	                        return orig.call(this, evt, fn, capture, secure);
	                    };
	                }, wrappedBuiltIns);
	            }
	        }
	
	        fill(window, 'setTimeout', wrapTimeFn, wrappedBuiltIns);
	        fill(window, 'setInterval', wrapTimeFn, wrappedBuiltIns);
	        if (window.requestAnimationFrame) {
	            fill(window, 'requestAnimationFrame', function (orig) {
	                return function (cb) {
	                    return orig(self.wrap(cb));
	                };
	            }, wrappedBuiltIns);
	        }
	
	        // event targets borrowed from bugsnag-js:
	        // https://github.com/bugsnag/bugsnag-js/blob/master/src/bugsnag.js#L666
	        var eventTargets = ['EventTarget', 'Window', 'Node', 'ApplicationCache', 'AudioTrackList', 'ChannelMergerNode', 'CryptoOperation', 'EventSource', 'FileReader', 'HTMLUnknownElement', 'IDBDatabase', 'IDBRequest', 'IDBTransaction', 'KeyOperation', 'MediaController', 'MessagePort', 'ModalWindow', 'Notification', 'SVGElementInstance', 'Screen', 'TextTrack', 'TextTrackCue', 'TextTrackList', 'WebSocket', 'WebSocketWorker', 'Worker', 'XMLHttpRequest', 'XMLHttpRequestEventTarget', 'XMLHttpRequestUpload'];
	        for (var i = 0; i < eventTargets.length; i++) {
	            wrapEventTarget(eventTargets[i]);
	        }
	
	        var $ = window.jQuery || window.$;
	        if ($ && $.fn && $.fn.ready) {
	            fill($.fn, 'ready', function (orig) {
	                return function (fn) {
	                    return orig.call(this, self.wrap(fn));
	                };
	            }, wrappedBuiltIns);
	        }
	    },
	
	
	    /**
	     * Instrument browser built-ins w/ breadcrumb capturing
	     *  - XMLHttpRequests
	     *  - DOM interactions (click/typing)
	     *  - window.location changes
	     *  - console
	     *
	     * Can be disabled or individually configured via the `autoBreadcrumbs` config option
	     */
	    _instrumentBreadcrumbs: function () {
	        var self = this;
	        var autoBreadcrumbs = this._globalOptions.autoBreadcrumbs;
	
	        var wrappedBuiltIns = self._wrappedBuiltIns;
	
	        function wrapProp(prop, xhr) {
	            if (prop in xhr && isFunction(xhr[prop])) {
	                fill(xhr, prop, function (orig) {
	                    return self.wrap(orig);
	                }); // intentionally don't track filled methods on XHR instances
	            }
	        }
	
	        if (autoBreadcrumbs.xhr && 'XMLHttpRequest' in window) {
	            var xhrproto = XMLHttpRequest.prototype;
	            fill(xhrproto, 'open', function(origOpen) {
	                return function (method, url) { // preserve arity
	
	                    // if Sentry key appears in URL, don't capture
	                    if (isString(url) && url.indexOf(self._globalKey) === -1) {
	                        this.__raven_xhr = {
	                            method: method,
	                            url: url,
	                            status_code: null
	                        };
	                    }
	
	                    return origOpen.apply(this, arguments);
	                };
	            }, wrappedBuiltIns);
	
	            fill(xhrproto, 'send', function(origSend) {
	                return function (data) { // preserve arity
	                    var xhr = this;
	
	                    function onreadystatechangeHandler() {
	                        if (xhr.__raven_xhr && (xhr.readyState === 1 || xhr.readyState === 4)) {
	                            try {
	                                // touching statusCode in some platforms throws
	                                // an exception
	                                xhr.__raven_xhr.status_code = xhr.status;
	                            } catch (e) { /* do nothing */ }
	                            self.captureBreadcrumb({
	                                type: 'http',
	                                category: 'xhr',
	                                data: xhr.__raven_xhr
	                            });
	                        }
	                    }
	
	                    var props = ['onload', 'onerror', 'onprogress'];
	                    for (var j = 0; j < props.length; j++) {
	                        wrapProp(props[j], xhr);
	                    }
	
	                    if ('onreadystatechange' in xhr && isFunction(xhr.onreadystatechange)) {
	                        fill(xhr, 'onreadystatechange', function (orig) {
	                            return self.wrap(orig, undefined, onreadystatechangeHandler);
	                        } /* intentionally don't track this instrumentation */);
	                    } else {
	                        // if onreadystatechange wasn't actually set by the page on this xhr, we
	                        // are free to set our own and capture the breadcrumb
	                        xhr.onreadystatechange = onreadystatechangeHandler;
	                    }
	
	                    return origSend.apply(this, arguments);
	                };
	            }, wrappedBuiltIns);
	        }
	
	        // Capture breadcrumbs from any click that is unhandled / bubbled up all the way
	        // to the document. Do this before we instrument addEventListener.
	        if (autoBreadcrumbs.dom && this._hasDocument) {
	            if (document.addEventListener) {
	                document.addEventListener('click', self._breadcrumbEventHandler('click'), false);
	                document.addEventListener('keypress', self._keypressEventHandler(), false);
	            }
	            else {
	                // IE8 Compatibility
	                document.attachEvent('onclick', self._breadcrumbEventHandler('click'));
	                document.attachEvent('onkeypress', self._keypressEventHandler());
	            }
	        }
	
	        // record navigation (URL) changes
	        // NOTE: in Chrome App environment, touching history.pushState, *even inside
	        //       a try/catch block*, will cause Chrome to output an error to console.error
	        // borrowed from: https://github.com/angular/angular.js/pull/13945/files
	        var chrome = window.chrome;
	        var isChromePackagedApp = chrome && chrome.app && chrome.app.runtime;
	        var hasPushState = !isChromePackagedApp && window.history && history.pushState;
	        if (autoBreadcrumbs.location && hasPushState) {
	            // TODO: remove onpopstate handler on uninstall()
	            var oldOnPopState = window.onpopstate;
	            window.onpopstate = function () {
	                var currentHref = self._location.href;
	                self._captureUrlChange(self._lastHref, currentHref);
	
	                if (oldOnPopState) {
	                    return oldOnPopState.apply(this, arguments);
	                }
	            };
	
	            fill(history, 'pushState', function (origPushState) {
	                // note history.pushState.length is 0; intentionally not declaring
	                // params to preserve 0 arity
	                return function (/* state, title, url */) {
	                    var url = arguments.length > 2 ? arguments[2] : undefined;
	
	                    // url argument is optional
	                    if (url) {
	                        // coerce to string (this is what pushState does)
	                        self._captureUrlChange(self._lastHref, url + '');
	                    }
	
	                    return origPushState.apply(this, arguments);
	                };
	            }, wrappedBuiltIns);
	        }
	
	        if (autoBreadcrumbs.console && 'console' in window && console.log) {
	            // console
	            var consoleMethodCallback = function (msg, data) {
	                self.captureBreadcrumb({
	                    message: msg,
	                    level: data.level,
	                    category: 'console'
	                });
	            };
	
	            each(['debug', 'info', 'warn', 'error', 'log'], function (_, level) {
	                wrapConsoleMethod(console, level, consoleMethodCallback);
	            });
	        }
	
	    },
	
	    _restoreBuiltIns: function () {
	        // restore any wrapped builtins
	        var builtin;
	        while (this._wrappedBuiltIns.length) {
	            builtin = this._wrappedBuiltIns.shift();
	
	            var obj = builtin[0],
	              name = builtin[1],
	              orig = builtin[2];
	
	            obj[name] = orig;
	        }
	    },
	
	    _drainPlugins: function() {
	        var self = this;
	
	        // FIX ME TODO
	        each(this._plugins, function(_, plugin) {
	            var installer = plugin[0];
	            var args = plugin[1];
	            installer.apply(self, [self].concat(args));
	        });
	    },
	
	    _parseDSN: function(str) {
	        var m = dsnPattern.exec(str),
	            dsn = {},
	            i = 7;
	
	        try {
	            while (i--) dsn[dsnKeys[i]] = m[i] || '';
	        } catch(e) {
	            throw new RavenConfigError('Invalid DSN: ' + str);
	        }
	
	        if (dsn.pass && !this._globalOptions.allowSecretKey) {
	            throw new RavenConfigError('Do not specify your secret key in the DSN. See: http://bit.ly/raven-secret-key');
	        }
	
	        return dsn;
	    },
	
	    _getGlobalServer: function(uri) {
	        // assemble the endpoint from the uri pieces
	        var globalServer = '//' + uri.host +
	            (uri.port ? ':' + uri.port : '');
	
	        if (uri.protocol) {
	            globalServer = uri.protocol + ':' + globalServer;
	        }
	        return globalServer;
	    },
	
	    _handleOnErrorStackInfo: function() {
	        // if we are intentionally ignoring errors via onerror, bail out
	        if (!this._ignoreOnError) {
	            this._handleStackInfo.apply(this, arguments);
	        }
	    },
	
	    _handleStackInfo: function(stackInfo, options) {
	        var self = this;
	        var frames = [];
	
	        if (stackInfo.stack && stackInfo.stack.length) {
	            each(stackInfo.stack, function(i, stack) {
	                var frame = self._normalizeFrame(stack);
	                if (frame) {
	                    frames.push(frame);
	                }
	            });
	        }
	
	        this._triggerEvent('handle', {
	            stackInfo: stackInfo,
	            options: options
	        });
	
	        this._processException(
	            stackInfo.name,
	            stackInfo.message,
	            stackInfo.url,
	            stackInfo.lineno,
	            frames.slice(0, this._globalOptions.stackTraceLimit),
	            options
	        );
	    },
	
	    _normalizeFrame: function(frame) {
	        if (!frame.url) return;
	
	        // normalize the frames data
	        var normalized = {
	            filename:   frame.url,
	            lineno:     frame.line,
	            colno:      frame.column,
	            'function': frame.func || '?'
	        };
	
	        normalized.in_app = !( // determine if an exception came from outside of our app
	            // first we check the global includePaths list.
	            !!this._globalOptions.includePaths.test && !this._globalOptions.includePaths.test(normalized.filename) ||
	            // Now we check for fun, if the function name is Raven or TraceKit
	            /(Raven|TraceKit)\./.test(normalized['function']) ||
	            // finally, we do a last ditch effort and check for raven.min.js
	            /raven\.(min\.)?js$/.test(normalized.filename)
	        );
	
	        return normalized;
	    },
	
	    _processException: function(type, message, fileurl, lineno, frames, options) {
	        var stacktrace;
	
	        if (!!this._globalOptions.ignoreErrors.test && this._globalOptions.ignoreErrors.test(message)) return;
	
	        message += '';
	
	        if (frames && frames.length) {
	            fileurl = frames[0].filename || fileurl;
	            // Sentry expects frames oldest to newest
	            // and JS sends them as newest to oldest
	            frames.reverse();
	            stacktrace = {frames: frames};
	        } else if (fileurl) {
	            stacktrace = {
	                frames: [{
	                    filename: fileurl,
	                    lineno: lineno,
	                    in_app: true
	                }]
	            };
	        }
	
	        if (!!this._globalOptions.ignoreUrls.test && this._globalOptions.ignoreUrls.test(fileurl)) return;
	        if (!!this._globalOptions.whitelistUrls.test && !this._globalOptions.whitelistUrls.test(fileurl)) return;
	
	        var data = objectMerge({
	            // sentry.interfaces.Exception
	            exception: {
	                values: [{
	                    type: type,
	                    value: message,
	                    stacktrace: stacktrace
	                }]
	            },
	            culprit: fileurl
	        }, options);
	
	        // Fire away!
	        this._send(data);
	    },
	
	    _trimPacket: function(data) {
	        // For now, we only want to truncate the two different messages
	        // but this could/should be expanded to just trim everything
	        var max = this._globalOptions.maxMessageLength;
	        if (data.message) {
	            data.message = truncate(data.message, max);
	        }
	        if (data.exception) {
	            var exception = data.exception.values[0];
	            exception.value = truncate(exception.value, max);
	        }
	
	        return data;
	    },
	
	    _getHttpData: function() {
	        if (!this._hasDocument || !document.location || !document.location.href) {
	            return;
	        }
	
	        var httpData = {
	            headers: {
	                'User-Agent': navigator.userAgent
	            }
	        };
	
	        httpData.url = document.location.href;
	
	        if (document.referrer) {
	            httpData.headers.Referer = document.referrer;
	        }
	
	        return httpData;
	    },
	
	
	    _send: function(data) {
	        var globalOptions = this._globalOptions;
	
	        var baseData = {
	            project: this._globalProject,
	            logger: globalOptions.logger,
	            platform: 'javascript'
	        }, httpData = this._getHttpData();
	
	        if (httpData) {
	            baseData.request = httpData;
	        }
	
	        data = objectMerge(baseData, data);
	
	        // Merge in the tags and extra separately since objectMerge doesn't handle a deep merge
	        data.tags = objectMerge(objectMerge({}, this._globalContext.tags), data.tags);
	        data.extra = objectMerge(objectMerge({}, this._globalContext.extra), data.extra);
	
	        // Send along our own collected metadata with extra
	        data.extra['session:duration'] = now() - this._startTime;
	
	        if (this._breadcrumbs && this._breadcrumbs.length > 0) {
	            // intentionally make shallow copy so that additions
	            // to breadcrumbs aren't accidentally sent in this request
	            data.breadcrumbs = {
	                values: [].slice.call(this._breadcrumbs, 0)
	            };
	        }
	
	        // If there are no tags/extra, strip the key from the payload alltogther.
	        if (isEmptyObject(data.tags)) delete data.tags;
	
	        if (this._globalContext.user) {
	            // sentry.interfaces.User
	            data.user = this._globalContext.user;
	        }
	
	        // Include the environment if it's defined in globalOptions
	        if (globalOptions.environment) data.environment = globalOptions.environment;
	
	        // Include the release if it's defined in globalOptions
	        if (globalOptions.release) data.release = globalOptions.release;
	
	        // Include server_name if it's defined in globalOptions
	        if (globalOptions.serverName) data.server_name = globalOptions.serverName;
	
	        if (isFunction(globalOptions.dataCallback)) {
	            data = globalOptions.dataCallback(data) || data;
	        }
	
	        // Why??????????
	        if (!data || isEmptyObject(data)) {
	            return;
	        }
	
	        // Check if the request should be filtered or not
	        if (isFunction(globalOptions.shouldSendCallback) && !globalOptions.shouldSendCallback(data)) {
	            return;
	        }
	
	        this._sendProcessedPayload(data);
	    },
	
	    _sendProcessedPayload: function(data, callback) {
	        var self = this;
	        var globalOptions = this._globalOptions;
	
	        // Send along an event_id if not explicitly passed.
	        // This event_id can be used to reference the error within Sentry itself.
	        // Set lastEventId after we know the error should actually be sent
	        this._lastEventId = data.event_id || (data.event_id = uuid4());
	
	        // Try and clean up the packet before sending by truncating long values
	        data = this._trimPacket(data);
	
	        this._logDebug('debug', 'Raven about to send:', data);
	
	        if (!this.isSetup()) return;
	
	        var auth = {
	            sentry_version: '7',
	            sentry_client: 'raven-js/' + this.VERSION,
	            sentry_key: this._globalKey
	        };
	        if (this._globalSecret) {
	            auth.sentry_secret = this._globalSecret;
	        }
	
	        var exception = data.exception && data.exception.values[0];
	        this.captureBreadcrumb({
	            category: 'sentry',
	            message: exception
	                ? (exception.type ? exception.type + ': ' : '') + exception.value
	                : data.message,
	            event_id: data.event_id,
	            level: data.level || 'error' // presume error unless specified
	        });
	
	        var url = this._globalEndpoint;
	        (globalOptions.transport || this._makeRequest).call(this, {
	            url: url,
	            auth: auth,
	            data: data,
	            options: globalOptions,
	            onSuccess: function success() {
	                self._triggerEvent('success', {
	                    data: data,
	                    src: url
	                });
	                callback && callback();
	            },
	            onError: function failure(error) {
	                self._triggerEvent('failure', {
	                    data: data,
	                    src: url
	                });
	                error = error || new Error('Raven send failed (no additional details provided)');
	                callback && callback(error);
	            }
	        });
	    },
	
	    _makeRequest: function(opts) {
	        var request = new XMLHttpRequest();
	
	        // if browser doesn't support CORS (e.g. IE7), we are out of luck
	        var hasCORS =
	            'withCredentials' in request ||
	            typeof XDomainRequest !== 'undefined';
	
	        if (!hasCORS) return;
	
	        var url = opts.url;
	        function handler() {
	            if (request.status === 200) {
	                if (opts.onSuccess) {
	                    opts.onSuccess();
	                }
	            } else if (opts.onError) {
	                opts.onError(new Error('Sentry error code: ' + request.status));
	            }
	        }
	
	        if ('withCredentials' in request) {
	            request.onreadystatechange = function () {
	                if (request.readyState !== 4) {
	                    return;
	                }
	                handler();
	            };
	        } else {
	            request = new XDomainRequest();
	            // xdomainrequest cannot go http -> https (or vice versa),
	            // so always use protocol relative
	            url = url.replace(/^https?:/, '');
	
	            // onreadystatechange not supported by XDomainRequest
	            request.onload = handler;
	        }
	
	        // NOTE: auth is intentionally sent as part of query string (NOT as custom
	        //       HTTP header) so as to avoid preflight CORS requests
	        request.open('POST', url + '?' + urlencode(opts.auth));
	        request.send(stringify(opts.data));
	    },
	
	    _logDebug: function(level) {
	        if (this._originalConsoleMethods[level] && this.debug) {
	            // In IE<10 console methods do not have their own 'apply' method
	            Function.prototype.apply.call(
	                this._originalConsoleMethods[level],
	                this._originalConsole,
	                [].slice.call(arguments, 1)
	            );
	        }
	    },
	
	    _mergeContext: function(key, context) {
	        if (isUndefined(context)) {
	            delete this._globalContext[key];
	        } else {
	            this._globalContext[key] = objectMerge(this._globalContext[key] || {}, context);
	        }
	    }
	};
	
	// Deprecations
	Raven.prototype.setUser = Raven.prototype.setUserContext;
	Raven.prototype.setReleaseContext = Raven.prototype.setRelease;
	
	module.exports = Raven;


/***/ }),
/* 1177 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(1178);
	
	var hasKey = utils.hasKey;
	var isString = utils.isString;
	var isUndefined = utils.isUndefined;
	
	/*
	 TraceKit - Cross brower stack traces - github.com/occ/TraceKit
	 MIT license
	*/
	
	var TraceKit = {
	    collectWindowErrors: true,
	    debug: false
	};
	
	// global reference to slice
	var _slice = [].slice;
	var UNKNOWN_FUNCTION = '?';
	
	// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error#Error_types
	var ERROR_TYPES_RE = /^(?:Uncaught (?:exception: )?)?((?:Eval|Internal|Range|Reference|Syntax|Type|URI)Error): ?(.*)$/;
	
	function getLocationHref() {
	    if (typeof document === 'undefined')
	        return '';
	
	    return document.location.href;
	}
	
	/**
	 * TraceKit.report: cross-browser processing of unhandled exceptions
	 *
	 * Syntax:
	 *   TraceKit.report.subscribe(function(stackInfo) { ... })
	 *   TraceKit.report.unsubscribe(function(stackInfo) { ... })
	 *   TraceKit.report(exception)
	 *   try { ...code... } catch(ex) { TraceKit.report(ex); }
	 *
	 * Supports:
	 *   - Firefox: full stack trace with line numbers, plus column number
	 *              on top frame; column number is not guaranteed
	 *   - Opera:   full stack trace with line and column numbers
	 *   - Chrome:  full stack trace with line and column numbers
	 *   - Safari:  line and column number for the top frame only; some frames
	 *              may be missing, and column number is not guaranteed
	 *   - IE:      line and column number for the top frame only; some frames
	 *              may be missing, and column number is not guaranteed
	 *
	 * In theory, TraceKit should work on all of the following versions:
	 *   - IE5.5+ (only 8.0 tested)
	 *   - Firefox 0.9+ (only 3.5+ tested)
	 *   - Opera 7+ (only 10.50 tested; versions 9 and earlier may require
	 *     Exceptions Have Stacktrace to be enabled in opera:config)
	 *   - Safari 3+ (only 4+ tested)
	 *   - Chrome 1+ (only 5+ tested)
	 *   - Konqueror 3.5+ (untested)
	 *
	 * Requires TraceKit.computeStackTrace.
	 *
	 * Tries to catch all unhandled exceptions and report them to the
	 * subscribed handlers. Please note that TraceKit.report will rethrow the
	 * exception. This is REQUIRED in order to get a useful stack trace in IE.
	 * If the exception does not reach the top of the browser, you will only
	 * get a stack trace from the point where TraceKit.report was called.
	 *
	 * Handlers receive a stackInfo object as described in the
	 * TraceKit.computeStackTrace docs.
	 */
	TraceKit.report = (function reportModuleWrapper() {
	    var handlers = [],
	        lastArgs = null,
	        lastException = null,
	        lastExceptionStack = null;
	
	    /**
	     * Add a crash handler.
	     * @param {Function} handler
	     */
	    function subscribe(handler) {
	        installGlobalHandler();
	        handlers.push(handler);
	    }
	
	    /**
	     * Remove a crash handler.
	     * @param {Function} handler
	     */
	    function unsubscribe(handler) {
	        for (var i = handlers.length - 1; i >= 0; --i) {
	            if (handlers[i] === handler) {
	                handlers.splice(i, 1);
	            }
	        }
	    }
	
	    /**
	     * Remove all crash handlers.
	     */
	    function unsubscribeAll() {
	        uninstallGlobalHandler();
	        handlers = [];
	    }
	
	    /**
	     * Dispatch stack information to all handlers.
	     * @param {Object.<string, *>} stack
	     */
	    function notifyHandlers(stack, isWindowError) {
	        var exception = null;
	        if (isWindowError && !TraceKit.collectWindowErrors) {
	          return;
	        }
	        for (var i in handlers) {
	            if (hasKey(handlers, i)) {
	                try {
	                    handlers[i].apply(null, [stack].concat(_slice.call(arguments, 2)));
	                } catch (inner) {
	                    exception = inner;
	                }
	            }
	        }
	
	        if (exception) {
	            throw exception;
	        }
	    }
	
	    var _oldOnerrorHandler, _onErrorHandlerInstalled;
	
	    /**
	     * Ensures all global unhandled exceptions are recorded.
	     * Supported by Gecko and IE.
	     * @param {string} message Error message.
	     * @param {string} url URL of script that generated the exception.
	     * @param {(number|string)} lineNo The line number at which the error
	     * occurred.
	     * @param {?(number|string)} colNo The column number at which the error
	     * occurred.
	     * @param {?Error} ex The actual Error object.
	     */
	    function traceKitWindowOnError(message, url, lineNo, colNo, ex) {
	        var stack = null;
	
	        if (lastExceptionStack) {
	            TraceKit.computeStackTrace.augmentStackTraceWithInitialElement(lastExceptionStack, url, lineNo, message);
	            processLastException();
	        } else if (ex) {
	            // New chrome and blink send along a real error object
	            // Let's just report that like a normal error.
	            // See: https://mikewest.org/2013/08/debugging-runtime-errors-with-window-onerror
	            stack = TraceKit.computeStackTrace(ex);
	            notifyHandlers(stack, true);
	        } else {
	            var location = {
	                'url': url,
	                'line': lineNo,
	                'column': colNo
	            };
	
	            var name = undefined;
	            var msg = message; // must be new var or will modify original `arguments`
	            var groups;
	            if (isString(message)) {
	                var groups = message.match(ERROR_TYPES_RE);
	                if (groups) {
	                    name = groups[1];
	                    msg = groups[2];
	                }
	            }
	
	            location.func = UNKNOWN_FUNCTION;
	
	            stack = {
	                'name': name,
	                'message': msg,
	                'url': getLocationHref(),
	                'stack': [location]
	            };
	            notifyHandlers(stack, true);
	        }
	
	        if (_oldOnerrorHandler) {
	            return _oldOnerrorHandler.apply(this, arguments);
	        }
	
	        return false;
	    }
	
	    function installGlobalHandler ()
	    {
	        if (_onErrorHandlerInstalled) {
	            return;
	        }
	        _oldOnerrorHandler = window.onerror;
	        window.onerror = traceKitWindowOnError;
	        _onErrorHandlerInstalled = true;
	    }
	
	    function uninstallGlobalHandler ()
	    {
	        if (!_onErrorHandlerInstalled) {
	            return;
	        }
	        window.onerror = _oldOnerrorHandler;
	        _onErrorHandlerInstalled = false;
	        _oldOnerrorHandler = undefined;
	    }
	
	    function processLastException() {
	        var _lastExceptionStack = lastExceptionStack,
	            _lastArgs = lastArgs;
	        lastArgs = null;
	        lastExceptionStack = null;
	        lastException = null;
	        notifyHandlers.apply(null, [_lastExceptionStack, false].concat(_lastArgs));
	    }
	
	    /**
	     * Reports an unhandled Error to TraceKit.
	     * @param {Error} ex
	     * @param {?boolean} rethrow If false, do not re-throw the exception.
	     * Only used for window.onerror to not cause an infinite loop of
	     * rethrowing.
	     */
	    function report(ex, rethrow) {
	        var args = _slice.call(arguments, 1);
	        if (lastExceptionStack) {
	            if (lastException === ex) {
	                return; // already caught by an inner catch block, ignore
	            } else {
	              processLastException();
	            }
	        }
	
	        var stack = TraceKit.computeStackTrace(ex);
	        lastExceptionStack = stack;
	        lastException = ex;
	        lastArgs = args;
	
	        // If the stack trace is incomplete, wait for 2 seconds for
	        // slow slow IE to see if onerror occurs or not before reporting
	        // this exception; otherwise, we will end up with an incomplete
	        // stack trace
	        window.setTimeout(function () {
	            if (lastException === ex) {
	                processLastException();
	            }
	        }, (stack.incomplete ? 2000 : 0));
	
	        if (rethrow !== false) {
	            throw ex; // re-throw to propagate to the top level (and cause window.onerror)
	        }
	    }
	
	    report.subscribe = subscribe;
	    report.unsubscribe = unsubscribe;
	    report.uninstall = unsubscribeAll;
	    return report;
	}());
	
	/**
	 * TraceKit.computeStackTrace: cross-browser stack traces in JavaScript
	 *
	 * Syntax:
	 *   s = TraceKit.computeStackTrace(exception) // consider using TraceKit.report instead (see below)
	 * Returns:
	 *   s.name              - exception name
	 *   s.message           - exception message
	 *   s.stack[i].url      - JavaScript or HTML file URL
	 *   s.stack[i].func     - function name, or empty for anonymous functions (if guessing did not work)
	 *   s.stack[i].args     - arguments passed to the function, if known
	 *   s.stack[i].line     - line number, if known
	 *   s.stack[i].column   - column number, if known
	 *
	 * Supports:
	 *   - Firefox:  full stack trace with line numbers and unreliable column
	 *               number on top frame
	 *   - Opera 10: full stack trace with line and column numbers
	 *   - Opera 9-: full stack trace with line numbers
	 *   - Chrome:   full stack trace with line and column numbers
	 *   - Safari:   line and column number for the topmost stacktrace element
	 *               only
	 *   - IE:       no line numbers whatsoever
	 *
	 * Tries to guess names of anonymous functions by looking for assignments
	 * in the source code. In IE and Safari, we have to guess source file names
	 * by searching for function bodies inside all page scripts. This will not
	 * work for scripts that are loaded cross-domain.
	 * Here be dragons: some function names may be guessed incorrectly, and
	 * duplicate functions may be mismatched.
	 *
	 * TraceKit.computeStackTrace should only be used for tracing purposes.
	 * Logging of unhandled exceptions should be done with TraceKit.report,
	 * which builds on top of TraceKit.computeStackTrace and provides better
	 * IE support by utilizing the window.onerror event to retrieve information
	 * about the top of the stack.
	 *
	 * Note: In IE and Safari, no stack trace is recorded on the Error object,
	 * so computeStackTrace instead walks its *own* chain of callers.
	 * This means that:
	 *  * in Safari, some methods may be missing from the stack trace;
	 *  * in IE, the topmost function in the stack trace will always be the
	 *    caller of computeStackTrace.
	 *
	 * This is okay for tracing (because you are likely to be calling
	 * computeStackTrace from the function you want to be the topmost element
	 * of the stack trace anyway), but not okay for logging unhandled
	 * exceptions (because your catch block will likely be far away from the
	 * inner function that actually caused the exception).
	 *
	 */
	TraceKit.computeStackTrace = (function computeStackTraceWrapper() {
	    /**
	     * Escapes special characters, except for whitespace, in a string to be
	     * used inside a regular expression as a string literal.
	     * @param {string} text The string.
	     * @return {string} The escaped string literal.
	     */
	    function escapeRegExp(text) {
	        return text.replace(/[\-\[\]{}()*+?.,\\\^$|#]/g, '\\$&');
	    }
	
	    /**
	     * Escapes special characters in a string to be used inside a regular
	     * expression as a string literal. Also ensures that HTML entities will
	     * be matched the same as their literal friends.
	     * @param {string} body The string.
	     * @return {string} The escaped string.
	     */
	    function escapeCodeAsRegExpForMatchingInsideHTML(body) {
	        return escapeRegExp(body).replace('<', '(?:<|&lt;)').replace('>', '(?:>|&gt;)').replace('&', '(?:&|&amp;)').replace('"', '(?:"|&quot;)').replace(/\s+/g, '\\s+');
	    }
	
	    // Contents of Exception in various browsers.
	    //
	    // SAFARI:
	    // ex.message = Can't find variable: qq
	    // ex.line = 59
	    // ex.sourceId = 580238192
	    // ex.sourceURL = http://...
	    // ex.expressionBeginOffset = 96
	    // ex.expressionCaretOffset = 98
	    // ex.expressionEndOffset = 98
	    // ex.name = ReferenceError
	    //
	    // FIREFOX:
	    // ex.message = qq is not defined
	    // ex.fileName = http://...
	    // ex.lineNumber = 59
	    // ex.columnNumber = 69
	    // ex.stack = ...stack trace... (see the example below)
	    // ex.name = ReferenceError
	    //
	    // CHROME:
	    // ex.message = qq is not defined
	    // ex.name = ReferenceError
	    // ex.type = not_defined
	    // ex.arguments = ['aa']
	    // ex.stack = ...stack trace...
	    //
	    // INTERNET EXPLORER:
	    // ex.message = ...
	    // ex.name = ReferenceError
	    //
	    // OPERA:
	    // ex.message = ...message... (see the example below)
	    // ex.name = ReferenceError
	    // ex.opera#sourceloc = 11  (pretty much useless, duplicates the info in ex.message)
	    // ex.stacktrace = n/a; see 'opera:config#UserPrefs|Exceptions Have Stacktrace'
	
	    /**
	     * Computes stack trace information from the stack property.
	     * Chrome and Gecko use this property.
	     * @param {Error} ex
	     * @return {?Object.<string, *>} Stack trace information.
	     */
	    function computeStackTraceFromStackProp(ex) {
	        if (isUndefined(ex.stack) || !ex.stack) return;
	
	        var chrome = /^\s*at (.*?) ?\(((?:file|https?|blob|chrome-extension|native|eval|<anonymous>).*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i,
	            gecko = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)((?:file|https?|blob|chrome|\[native).*?)(?::(\d+))?(?::(\d+))?\s*$/i,
	            winjs = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:file|ms-appx|https?|blob):.*?):(\d+)(?::(\d+))?\)?\s*$/i,
	            lines = ex.stack.split('\n'),
	            stack = [],
	            parts,
	            element,
	            reference = /^(.*) is undefined$/.exec(ex.message);
	
	        for (var i = 0, j = lines.length; i < j; ++i) {
	            if ((parts = chrome.exec(lines[i]))) {
	                var isNative = parts[2] && parts[2].indexOf('native') !== -1;
	                element = {
	                    'url': !isNative ? parts[2] : null,
	                    'func': parts[1] || UNKNOWN_FUNCTION,
	                    'args': isNative ? [parts[2]] : [],
	                    'line': parts[3] ? +parts[3] : null,
	                    'column': parts[4] ? +parts[4] : null
	                };
	            } else if ( parts = winjs.exec(lines[i]) ) {
	                element = {
	                    'url': parts[2],
	                    'func': parts[1] || UNKNOWN_FUNCTION,
	                    'args': [],
	                    'line': +parts[3],
	                    'column': parts[4] ? +parts[4] : null
	                };
	            } else if ((parts = gecko.exec(lines[i]))) {
	                element = {
	                    'url': parts[3],
	                    'func': parts[1] || UNKNOWN_FUNCTION,
	                    'args': parts[2] ? parts[2].split(',') : [],
	                    'line': parts[4] ? +parts[4] : null,
	                    'column': parts[5] ? +parts[5] : null
	                };
	            } else {
	                continue;
	            }
	
	            if (!element.func && element.line) {
	                element.func = UNKNOWN_FUNCTION;
	            }
	
	            stack.push(element);
	        }
	
	        if (!stack.length) {
	            return null;
	        }
	
	        if (!stack[0].column && !isUndefined(ex.columnNumber)) {
	            // FireFox uses this awesome columnNumber property for its top frame
	            // Also note, Firefox's column number is 0-based and everything else expects 1-based,
	            // so adding 1
	            stack[0].column = ex.columnNumber + 1;
	        }
	
	        return {
	            'name': ex.name,
	            'message': ex.message,
	            'url': getLocationHref(),
	            'stack': stack
	        };
	    }
	
	    /**
	     * Computes stack trace information from the stacktrace property.
	     * Opera 10 uses this property.
	     * @param {Error} ex
	     * @return {?Object.<string, *>} Stack trace information.
	     */
	    function computeStackTraceFromStacktraceProp(ex) {
	        // Access and store the stacktrace property before doing ANYTHING
	        // else to it because Opera is not very good at providing it
	        // reliably in other circumstances.
	        var stacktrace = ex.stacktrace;
	        if (isUndefined(ex.stacktrace) || !ex.stacktrace) return;
	
	        var opera10Regex = / line (\d+).*script (?:in )?(\S+)(?:: in function (\S+))?$/i,
	          opera11Regex = / line (\d+), column (\d+)\s*(?:in (?:<anonymous function: ([^>]+)>|([^\)]+))\((.*)\))? in (.*):\s*$/i,
	          lines = stacktrace.split('\n'),
	          stack = [],
	          parts;
	
	        for (var line = 0; line < lines.length; line += 2) {
	            var element = null;
	            if ((parts = opera10Regex.exec(lines[line]))) {
	                element = {
	                    'url': parts[2],
	                    'line': +parts[1],
	                    'column': null,
	                    'func': parts[3],
	                    'args':[]
	                };
	            } else if ((parts = opera11Regex.exec(lines[line]))) {
	                element = {
	                    'url': parts[6],
	                    'line': +parts[1],
	                    'column': +parts[2],
	                    'func': parts[3] || parts[4],
	                    'args': parts[5] ? parts[5].split(',') : []
	                };
	            }
	
	            if (element) {
	                if (!element.func && element.line) {
	                    element.func = UNKNOWN_FUNCTION;
	                }
	
	                stack.push(element);
	            }
	        }
	
	        if (!stack.length) {
	            return null;
	        }
	
	        return {
	            'name': ex.name,
	            'message': ex.message,
	            'url': getLocationHref(),
	            'stack': stack
	        };
	    }
	
	    /**
	     * NOT TESTED.
	     * Computes stack trace information from an error message that includes
	     * the stack trace.
	     * Opera 9 and earlier use this method if the option to show stack
	     * traces is turned on in opera:config.
	     * @param {Error} ex
	     * @return {?Object.<string, *>} Stack information.
	     */
	    function computeStackTraceFromOperaMultiLineMessage(ex) {
	        // Opera includes a stack trace into the exception message. An example is:
	        //
	        // Statement on line 3: Undefined variable: undefinedFunc
	        // Backtrace:
	        //   Line 3 of linked script file://localhost/Users/andreyvit/Projects/TraceKit/javascript-client/sample.js: In function zzz
	        //         undefinedFunc(a);
	        //   Line 7 of inline#1 script in file://localhost/Users/andreyvit/Projects/TraceKit/javascript-client/sample.html: In function yyy
	        //           zzz(x, y, z);
	        //   Line 3 of inline#1 script in file://localhost/Users/andreyvit/Projects/TraceKit/javascript-client/sample.html: In function xxx
	        //           yyy(a, a, a);
	        //   Line 1 of function script
	        //     try { xxx('hi'); return false; } catch(ex) { TraceKit.report(ex); }
	        //   ...
	
	        var lines = ex.message.split('\n');
	        if (lines.length < 4) {
	            return null;
	        }
	
	        var lineRE1 = /^\s*Line (\d+) of linked script ((?:file|https?|blob)\S+)(?:: in function (\S+))?\s*$/i,
	            lineRE2 = /^\s*Line (\d+) of inline#(\d+) script in ((?:file|https?|blob)\S+)(?:: in function (\S+))?\s*$/i,
	            lineRE3 = /^\s*Line (\d+) of function script\s*$/i,
	            stack = [],
	            scripts = document.getElementsByTagName('script'),
	            parts;
	
	        for (var line = 2; line < lines.length; line += 2) {
	            var item = null;
	            if ((parts = lineRE1.exec(lines[line]))) {
	                item = {
	                    'url': parts[2],
	                    'func': parts[3],
	                    'args': [],
	                    'line': +parts[1],
	                    'column': null
	                };
	            } else if ((parts = lineRE2.exec(lines[line]))) {
	                item = {
	                    'url': parts[3],
	                    'func': parts[4],
	                    'args': [],
	                    'line': +parts[1],
	                    'column': null // TODO: Check to see if inline#1 (+parts[2]) points to the script number or column number.
	                };
	                var relativeLine = (+parts[1]); // relative to the start of the <SCRIPT> block
	            } else if ((parts = lineRE3.exec(lines[line]))) {
	                var url = window.location.href.replace(/#.*$/, '');
	                item = {
	                    'url': url,
	                    'func': '',
	                    'args': [],
	                    'line': parts[1],
	                    'column': null
	                };
	            }
	
	            if (item) {
	                if (!item.func) {
	                    item.func = UNKNOWN_FUNCTION;
	                }
	
	                stack.push(item);
	            }
	        }
	
	        if (!stack.length) {
	            return null; // could not parse multiline exception message as Opera stack trace
	        }
	
	        return {
	            'name': ex.name,
	            'message': lines[0],
	            'url': getLocationHref(),
	            'stack': stack
	        };
	    }
	
	    /**
	     * Adds information about the first frame to incomplete stack traces.
	     * Safari and IE require this to get complete data on the first frame.
	     * @param {Object.<string, *>} stackInfo Stack trace information from
	     * one of the compute* methods.
	     * @param {string} url The URL of the script that caused an error.
	     * @param {(number|string)} lineNo The line number of the script that
	     * caused an error.
	     * @param {string=} message The error generated by the browser, which
	     * hopefully contains the name of the object that caused the error.
	     * @return {boolean} Whether or not the stack information was
	     * augmented.
	     */
	    function augmentStackTraceWithInitialElement(stackInfo, url, lineNo, message) {
	        var initial = {
	            'url': url,
	            'line': lineNo
	        };
	
	        if (initial.url && initial.line) {
	            stackInfo.incomplete = false;
	
	            if (!initial.func) {
	                initial.func = UNKNOWN_FUNCTION;
	            }
	
	            if (stackInfo.stack.length > 0) {
	                if (stackInfo.stack[0].url === initial.url) {
	                    if (stackInfo.stack[0].line === initial.line) {
	                        return false; // already in stack trace
	                    } else if (!stackInfo.stack[0].line && stackInfo.stack[0].func === initial.func) {
	                        stackInfo.stack[0].line = initial.line;
	                        return false;
	                    }
	                }
	            }
	
	            stackInfo.stack.unshift(initial);
	            stackInfo.partial = true;
	            return true;
	        } else {
	            stackInfo.incomplete = true;
	        }
	
	        return false;
	    }
	
	    /**
	     * Computes stack trace information by walking the arguments.caller
	     * chain at the time the exception occurred. This will cause earlier
	     * frames to be missed but is the only way to get any stack trace in
	     * Safari and IE. The top frame is restored by
	     * {@link augmentStackTraceWithInitialElement}.
	     * @param {Error} ex
	     * @return {?Object.<string, *>} Stack trace information.
	     */
	    function computeStackTraceByWalkingCallerChain(ex, depth) {
	        var functionName = /function\s+([_$a-zA-Z\xA0-\uFFFF][_$a-zA-Z0-9\xA0-\uFFFF]*)?\s*\(/i,
	            stack = [],
	            funcs = {},
	            recursion = false,
	            parts,
	            item,
	            source;
	
	        for (var curr = computeStackTraceByWalkingCallerChain.caller; curr && !recursion; curr = curr.caller) {
	            if (curr === computeStackTrace || curr === TraceKit.report) {
	                // console.log('skipping internal function');
	                continue;
	            }
	
	            item = {
	                'url': null,
	                'func': UNKNOWN_FUNCTION,
	                'line': null,
	                'column': null
	            };
	
	            if (curr.name) {
	                item.func = curr.name;
	            } else if ((parts = functionName.exec(curr.toString()))) {
	                item.func = parts[1];
	            }
	
	            if (typeof item.func === 'undefined') {
	              try {
	                item.func = parts.input.substring(0, parts.input.indexOf('{'));
	              } catch (e) { }
	            }
	
	            if (funcs['' + curr]) {
	                recursion = true;
	            }else{
	                funcs['' + curr] = true;
	            }
	
	            stack.push(item);
	        }
	
	        if (depth) {
	            // console.log('depth is ' + depth);
	            // console.log('stack is ' + stack.length);
	            stack.splice(0, depth);
	        }
	
	        var result = {
	            'name': ex.name,
	            'message': ex.message,
	            'url': getLocationHref(),
	            'stack': stack
	        };
	        augmentStackTraceWithInitialElement(result, ex.sourceURL || ex.fileName, ex.line || ex.lineNumber, ex.message || ex.description);
	        return result;
	    }
	
	    /**
	     * Computes a stack trace for an exception.
	     * @param {Error} ex
	     * @param {(string|number)=} depth
	     */
	    function computeStackTrace(ex, depth) {
	        var stack = null;
	        depth = (depth == null ? 0 : +depth);
	
	        try {
	            // This must be tried first because Opera 10 *destroys*
	            // its stacktrace property if you try to access the stack
	            // property first!!
	            stack = computeStackTraceFromStacktraceProp(ex);
	            if (stack) {
	                return stack;
	            }
	        } catch (e) {
	            if (TraceKit.debug) {
	                throw e;
	            }
	        }
	
	        try {
	            stack = computeStackTraceFromStackProp(ex);
	            if (stack) {
	                return stack;
	            }
	        } catch (e) {
	            if (TraceKit.debug) {
	                throw e;
	            }
	        }
	
	        try {
	            stack = computeStackTraceFromOperaMultiLineMessage(ex);
	            if (stack) {
	                return stack;
	            }
	        } catch (e) {
	            if (TraceKit.debug) {
	                throw e;
	            }
	        }
	
	        try {
	            stack = computeStackTraceByWalkingCallerChain(ex, depth + 1);
	            if (stack) {
	                return stack;
	            }
	        } catch (e) {
	            if (TraceKit.debug) {
	                throw e;
	            }
	        }
	
	        return {
	            'name': ex.name,
	            'message': ex.message,
	            'url': getLocationHref()
	        };
	    }
	
	    computeStackTrace.augmentStackTraceWithInitialElement = augmentStackTraceWithInitialElement;
	    computeStackTrace.computeStackTraceFromStackProp = computeStackTraceFromStackProp;
	
	    return computeStackTrace;
	}());
	
	module.exports = TraceKit;


/***/ }),
/* 1178 */
/***/ (function(module, exports) {

	/*eslint no-extra-parens:0*/
	'use strict';
	
	var objectPrototype = Object.prototype;
	
	function isUndefined(what) {
	    return what === void 0;
	}
	
	function isFunction(what) {
	    return typeof what === 'function';
	}
	
	function isString(what) {
	    return objectPrototype.toString.call(what) === '[object String]';
	}
	
	function isObject(what) {
	    return typeof what === 'object' && what !== null;
	}
	
	function isEmptyObject(what) {
	    for (var _ in what) return false;  // eslint-disable-line guard-for-in, no-unused-vars
	    return true;
	}
	
	// Sorta yanked from https://github.com/joyent/node/blob/aa3b4b4/lib/util.js#L560
	// with some tiny modifications
	function isError(what) {
	    var toString = objectPrototype.toString.call(what);
	    return isObject(what) &&
	        toString === '[object Error]' ||
	        toString === '[object Exception]' || // Firefox NS_ERROR_FAILURE Exceptions
	        what instanceof Error;
	}
	
	function each(obj, callback) {
	    var i, j;
	
	    if (isUndefined(obj.length)) {
	        for (i in obj) {
	            if (hasKey(obj, i)) {
	                callback.call(null, i, obj[i]);
	            }
	        }
	    } else {
	        j = obj.length;
	        if (j) {
	            for (i = 0; i < j; i++) {
	                callback.call(null, i, obj[i]);
	            }
	        }
	    }
	}
	
	function objectMerge(obj1, obj2) {
	    if (!obj2) {
	        return obj1;
	    }
	    each(obj2, function(key, value){
	        obj1[key] = value;
	    });
	    return obj1;
	}
	
	function truncate(str, max) {
	    return !max || str.length <= max ? str : str.substr(0, max) + '\u2026';
	}
	
	/**
	 * hasKey, a better form of hasOwnProperty
	 * Example: hasKey(MainHostObject, property) === true/false
	 *
	 * @param {Object} host object to check property
	 * @param {string} key to check
	 */
	function hasKey(object, key) {
	    return objectPrototype.hasOwnProperty.call(object, key);
	}
	
	function joinRegExp(patterns) {
	    // Combine an array of regular expressions and strings into one large regexp
	    // Be mad.
	    var sources = [],
	        i = 0, len = patterns.length,
	        pattern;
	
	    for (; i < len; i++) {
	        pattern = patterns[i];
	        if (isString(pattern)) {
	            // If it's a string, we need to escape it
	            // Taken from: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Regular_Expressions
	            sources.push(pattern.replace(/([.*+?^=!:${}()|\[\]\/\\])/g, '\\$1'));
	        } else if (pattern && pattern.source) {
	            // If it's a regexp already, we want to extract the source
	            sources.push(pattern.source);
	        }
	        // Intentionally skip other cases
	    }
	    return new RegExp(sources.join('|'), 'i');
	}
	
	function urlencode(o) {
	    var pairs = [];
	    each(o, function(key, value) {
	        pairs.push(encodeURIComponent(key) + '=' + encodeURIComponent(value));
	    });
	    return pairs.join('&');
	}
	
	// borrowed from https://tools.ietf.org/html/rfc3986#appendix-B
	// intentionally using regex and not <a/> href parsing trick because React Native and other
	// environments where DOM might not be available
	function parseUrl(url) {
	    var match = url.match(/^(([^:\/?#]+):)?(\/\/([^\/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
	    if (!match) return {};
	
	    // coerce to undefined values to empty string so we don't get 'undefined'
	    var query = match[6] || '';
	    var fragment = match[8] || '';
	    return {
	        protocol: match[2],
	        host: match[4],
	        path: match[5],
	        relative: match[5] + query + fragment // everything minus origin
	    };
	}
	function uuid4() {
	    var crypto = window.crypto || window.msCrypto;
	
	    if (!isUndefined(crypto) && crypto.getRandomValues) {
	        // Use window.crypto API if available
	        var arr = new Uint16Array(8);
	        crypto.getRandomValues(arr);
	
	        // set 4 in byte 7
	        arr[3] = arr[3] & 0xFFF | 0x4000;
	        // set 2 most significant bits of byte 9 to '10'
	        arr[4] = arr[4] & 0x3FFF | 0x8000;
	
	        var pad = function(num) {
	            var v = num.toString(16);
	            while (v.length < 4) {
	                v = '0' + v;
	            }
	            return v;
	        };
	
	        return pad(arr[0]) + pad(arr[1]) + pad(arr[2]) + pad(arr[3]) + pad(arr[4]) +
	        pad(arr[5]) + pad(arr[6]) + pad(arr[7]);
	    } else {
	        // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
	        return 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
	            var r = Math.random()*16|0,
	                v = c === 'x' ? r : r&0x3|0x8;
	            return v.toString(16);
	        });
	    }
	}
	
	/**
	 * Given a child DOM element, returns a query-selector statement describing that
	 * and its ancestors
	 * e.g. [HTMLElement] => body > div > input#foo.btn[name=baz]
	 * @param elem
	 * @returns {string}
	 */
	function htmlTreeAsString(elem) {
	    var MAX_TRAVERSE_HEIGHT = 5,
	        MAX_OUTPUT_LEN = 80,
	        out = [],
	        height = 0,
	        len = 0,
	        separator = ' > ',
	        sepLength = separator.length,
	        nextStr;
	
	    while (elem && height++ < MAX_TRAVERSE_HEIGHT) {
	
	        nextStr = htmlElementAsString(elem);
	        // bail out if
	        // - nextStr is the 'html' element
	        // - the length of the string that would be created exceeds MAX_OUTPUT_LEN
	        //   (ignore this limit if we are on the first iteration)
	        if (nextStr === 'html' || height > 1 && len + (out.length * sepLength) + nextStr.length >= MAX_OUTPUT_LEN) {
	            break;
	        }
	
	        out.push(nextStr);
	
	        len += nextStr.length;
	        elem = elem.parentNode;
	    }
	
	    return out.reverse().join(separator);
	}
	
	/**
	 * Returns a simple, query-selector representation of a DOM element
	 * e.g. [HTMLElement] => input#foo.btn[name=baz]
	 * @param HTMLElement
	 * @returns {string}
	 */
	function htmlElementAsString(elem) {
	    var out = [],
	        className,
	        classes,
	        key,
	        attr,
	        i;
	
	    if (!elem || !elem.tagName) {
	        return '';
	    }
	
	    out.push(elem.tagName.toLowerCase());
	    if (elem.id) {
	        out.push('#' + elem.id);
	    }
	
	    className = elem.className;
	    if (className && isString(className)) {
	        classes = className.split(' ');
	        for (i = 0; i < classes.length; i++) {
	            out.push('.' + classes[i]);
	        }
	    }
	    var attrWhitelist = ['type', 'name', 'title', 'alt'];
	    for (i = 0; i < attrWhitelist.length; i++) {
	        key = attrWhitelist[i];
	        attr = elem.getAttribute(key);
	        if (attr) {
	            out.push('[' + key + '="' + attr + '"]');
	        }
	    }
	    return out.join('');
	}
	
	/**
	 * Polyfill a method
	 * @param obj object e.g. `document`
	 * @param name method name present on object e.g. `addEventListener`
	 * @param replacement replacement function
	 * @param track {optional} record instrumentation to an array
	 */
	function fill(obj, name, replacement, track) {
	    var orig = obj[name];
	    obj[name] = replacement(orig);
	    if (track) {
	        track.push([obj, name, orig]);
	    }
	}
	
	module.exports = {
	    isUndefined: isUndefined,
	    isFunction: isFunction,
	    isString: isString,
	    isObject: isObject,
	    isEmptyObject: isEmptyObject,
	    isError: isError,
	    each: each,
	    objectMerge: objectMerge,
	    truncate: truncate,
	    hasKey: hasKey,
	    joinRegExp: joinRegExp,
	    urlencode: urlencode,
	    uuid4: uuid4,
	    htmlTreeAsString: htmlTreeAsString,
	    htmlElementAsString: htmlElementAsString,
	    parseUrl: parseUrl,
	    fill: fill
	};


/***/ }),
/* 1179 */
/***/ (function(module, exports) {

	'use strict';
	
	function RavenConfigError(message) {
	    this.name = 'RavenConfigError';
	    this.message = message;
	}
	RavenConfigError.prototype = new Error();
	RavenConfigError.prototype.constructor = RavenConfigError;
	
	module.exports = RavenConfigError;


/***/ }),
/* 1180 */
/***/ (function(module, exports) {

	exports = module.exports = stringify
	exports.getSerialize = serializer
	
	function stringify(obj, replacer, spaces, cycleReplacer) {
	  return JSON.stringify(obj, serializer(replacer, cycleReplacer), spaces)
	}
	
	function serializer(replacer, cycleReplacer) {
	  var stack = [], keys = []
	
	  if (cycleReplacer == null) cycleReplacer = function(key, value) {
	    if (stack[0] === value) return "[Circular ~]"
	    return "[Circular ~." + keys.slice(0, stack.indexOf(value)).join(".") + "]"
	  }
	
	  return function(key, value) {
	    if (stack.length > 0) {
	      var thisPos = stack.indexOf(this)
	      ~thisPos ? stack.splice(thisPos + 1) : stack.push(this)
	      ~thisPos ? keys.splice(thisPos, Infinity, key) : keys.push(key)
	      if (~stack.indexOf(value)) value = cycleReplacer.call(this, key, value)
	    }
	    else stack.push(value)
	
	    return replacer == null ? value : replacer.call(this, key, value)
	  }
	}


/***/ }),
/* 1181 */
/***/ (function(module, exports) {

	'use strict';
	
	var wrapMethod = function(console, level, callback) {
	    var originalConsoleLevel = console[level];
	    var originalConsole = console;
	
	    if (!(level in console)) {
	        return;
	    }
	
	    var sentryLevel = level === 'warn'
	        ? 'warning'
	        : level;
	
	    console[level] = function () {
	        var args = [].slice.call(arguments);
	
	        var msg = '' + args.join(' ');
	        var data = {level: sentryLevel, logger: 'console', extra: {'arguments': args}};
	        callback && callback(msg, data);
	
	        // this fails for some browsers. :(
	        if (originalConsoleLevel) {
	            // IE9 doesn't allow calling apply on console functions directly
	            // See: https://stackoverflow.com/questions/5472938/does-ie9-support-console-log-and-is-it-a-real-function#answer-5473193
	            Function.prototype.apply.call(
	                originalConsoleLevel,
	                originalConsole,
	                args
	            );
	        }
	    };
	};
	
	module.exports = {
	    wrapMethod: wrapMethod
	};


/***/ }),
/* 1182 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _alt = __webpack_require__(975);
	
	var _alt2 = _interopRequireDefault(_alt);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var GlobalNotificationActions = function GlobalNotificationActions() {
	  _classCallCheck(this, GlobalNotificationActions);
	
	  this.generateActions("notify", "close");
	};
	
	exports.default = _alt2.default.createActions(GlobalNotificationActions);
	module.exports = exports["default"];

/***/ }),
/* 1183 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.formatBasedOnQuantity = exports.formatRegion = exports.formatBytes = exports.makeEventDateRangeLabel = exports.dashify = exports.makeFilmDetailString = exports.applyCoupon = exports.capitalize = exports.unSnakeCase = exports.snakeCase = exports.formatSubscriptionStatus = exports.clientSideDownload = exports.makeCsv = exports.fillMissingDaysNew = exports.fillMissingDays = exports.formatPercent = exports.formatNumber = exports.formatPrice = exports.parsePriceToCents = exports.intersperse = exports.history = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _papaparse = __webpack_require__(1184);
	
	var _papaparse2 = _interopRequireDefault(_papaparse);
	
	var _momentTimezone = __webpack_require__(1185);
	
	var _momentTimezone2 = _interopRequireDefault(_momentTimezone);
	
	var _config = __webpack_require__(1173);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _get = __webpack_require__(1004);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _set = __webpack_require__(1188);
	
	var _set2 = _interopRequireDefault(_set);
	
	var _cloneDeep = __webpack_require__(1189);
	
	var _cloneDeep2 = _interopRequireDefault(_cloneDeep);
	
	var _loop = __webpack_require__(1205);
	
	var _loop2 = _interopRequireDefault(_loop);
	
	var _qs = __webpack_require__(1206);
	
	var _qs2 = _interopRequireDefault(_qs);
	
	var _reactRouter = __webpack_require__(486);
	
	var _createBrowserHistory = __webpack_require__(546);
	
	var _createBrowserHistory2 = _interopRequireDefault(_createBrowserHistory);
	
	var _createHashHistory = __webpack_require__(496);
	
	var _createHashHistory2 = _interopRequireDefault(_createHashHistory);
	
	var _UserStore = __webpack_require__(974);
	
	var _UserStore2 = _interopRequireDefault(_UserStore);
	
	var _SystemStatesStore = __webpack_require__(1211);
	
	var _SystemStatesStore2 = _interopRequireDefault(_SystemStatesStore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// const createAppHistory = useRouterHistory(process.env.NODE_ENV === 'production' ?  createBrowserHistory : createHashHistory);
	var createAppHistory = (0, _reactRouter.useRouterHistory)(_createBrowserHistory2.default);
	var history = exports.history = createAppHistory({
	  parseQueryString: _qs2.default.parse,
	  stringifyQuery: function stringifyQuery(q) {
	    return _qs2.default.stringify(q, { arrayFormat: "brackets", encode: false });
	  }
	});
	
	/* intersperse: Return an array with the separator interspersed between
	 * each element of the input array.
	 *
	 * > _([1,2,3]).intersperse(0)
	 * [1,0,2,0,3]
	 */
	function intersperse(arr, sep) {
	  if (arr.length === 0) {
	    return [];
	  }
	
	  return arr.slice(1).reduce(function (xs, x, i) {
	    return xs.concat([sep, x]);
	  }, [arr[0]]);
	}
	
	function parsePriceToCents() {
	  var raw = arguments.length <= 0 || arguments[0] === undefined ? "" : arguments[0];
	
	  var _ref = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	
	  var locale = _ref.locale;
	  var currency = _ref.currency;
	
	  var user = _UserStore2.default.getUser() || {};
	  currency = currency || user.currency || "usd";
	  locale = locale || user.locale || "en-US";
	
	  var separator = formatPrice(0, { locale: locale, currency: currency }).replace(/[^\.,]/g, "")[0];
	  var baseString = raw.replace(new RegExp("[^0-9\\" + separator + "]", "g"), "").replace(separator, ".");
	  return baseString * (_config2.default.fee.zero_decimal.includes(currency) ? 1 : 100);
	}
	
	/* Format a single price in cents to $xx.yy format. If an array in the form
	 * [[price1, quantity1], [price2, quantity2], ...] is passed, return a string
	 * in the format "$xx.yy (xQ), $yy.zz (xQ)" where Q is the quantity of each price.
	 * Used for showing multiple prices.
	 */
	function formatPrice() {
	  var p = arguments.length <= 0 || arguments[0] === undefined ? 0 : arguments[0];
	  var short = arguments.length <= 1 || arguments[1] === undefined ? false : arguments[1];
	  var implicit = arguments.length <= 2 || arguments[2] === undefined ? false : arguments[2];
	
	  var currency = void 0,
	      locale = void 0,
	      accounting = void 0;
	
	  if (Math.abs(p) < 0.0001) {
	    p = 0; // sometimes rounding bugs
	  }
	
	  if ((typeof short === "undefined" ? "undefined" : _typeof(short)) === "object") {
	    var _short = short;
	    short = _short.short;
	    implicit = _short.implicit;
	    currency = _short.currency;
	    locale = _short.locale;
	    accounting = _short.accounting;
	  }
	
	  var user = _UserStore2.default.getUser() || {};
	  currency = currency || user.currency || "usd";
	  locale = locale || user.locale || "en-US";
	
	  var format = function format(p) {
	    // Zero-decimal currency
	    if (_config2.default.fee.zero_decimal.includes(currency)) {
	      p *= 100;
	      short = true;
	    }
	
	    var formatted = (p / 100).toLocaleString(locale, {
	      style: "currency",
	      currency: currency.toUpperCase(),
	      minimumFractionDigits: 2
	    });
	
	    if (short) {
	      // Strip trailing .00 from price, leaving just $XYZ
	      formatted = formatted.replace(/[\.,]00(?:$|\s)/, "");
	    }
	
	    if (implicit) {
	      // strip preceding CA
	      formatted = formatted.replace(/^(-)?(CA|MX)/, "$1");
	    }
	
	    if (accounting) {
	      if (p < 0) {
	        formatted = "(" + formatted.replace("-", "") + ")";
	      }
	    }
	
	    return formatted;
	  };
	
	  if (Array.isArray(p)) {
	    return p.map(function (_ref2) {
	      var _ref3 = _slicedToArray(_ref2, 2);
	
	      var price = _ref3[0];
	      var quantity = _ref3[1];
	      return format(price) + " (x" + quantity + ")";
	    }).join(", ");
	  } else {
	    return format(p);
	  }
	}
	
	function formatNumber() {
	  var n = arguments.length <= 0 || arguments[0] === undefined ? 0 : arguments[0];
	
	  var _ref4 = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	
	  var locale = _ref4.locale;
	
	  var user = _UserStore2.default.getUser() || {};
	  locale = locale || user.locale || "en-US";
	  return (n || 0).toLocaleString(locale);
	}
	
	function formatPercent() {
	  var n = arguments.length <= 0 || arguments[0] === undefined ? 0 : arguments[0];
	
	  var _ref5 = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	
	  var locale = _ref5.locale;
	
	  var user = _UserStore2.default.getUser() || {};
	  locale = locale || user.locale || "en-US";
	  return (n || 0).toLocaleString(locale, {
	    style: "percent",
	    maximumFractionDigits: 4
	  });
	}
	
	// http://stackoverflow.com/questions/14522667/how-to-configure-flot-to-draw-missing-time-series-on-y-axis-at-point-zero
	/* helper function to find date differences*/
	function dateDiff(d1, d2) {
	  return Math.floor((d2 - d1) / (1000 * 60 * 60 * 24));
	}
	function fillMissingDays(data, makeDates, zeroLength) {
	  var i,
	      j,
	      startDay = data[0][0],
	      newData = [data[0]];
	
	  if (typeof zeroLength === "undefined") {
	    zeroLength = 1;
	  }
	
	  for (i = 1; i < data.length; i++) {
	    var diff = dateDiff(data[i - 1][0], data[i][0]);
	    var startDate = new Date(data[i - 1][0]);
	    if (diff > 1) {
	      for (j = 0; j < diff - 1; j++) {
	        var fillDate = new Date(startDate).setDate(startDate.getDate() + (j + 1));
	        newData.push([fillDate].concat(Array(zeroLength).fill(0)).concat(data[i - 1].slice(1 + zeroLength)));
	      }
	    }
	    newData.push(data[i]);
	  }
	
	  if (makeDates) {
	    return newData.map(function (r) {
	      r[0] = new Date(r[0]);
	      return r;
	    });
	  } else {
	    return newData;
	  }
	}
	function fillMissingDaysNew(data) {
	  var dateKey = arguments.length <= 1 || arguments[1] === undefined ? "date" : arguments[1];
	  var replacements = arguments.length <= 2 || arguments[2] === undefined ? {} : arguments[2];
	  var options = arguments.length <= 3 || arguments[3] === undefined ? {} : arguments[3];
	
	  var diffFunction = options.diffFunction || dateDiff,
	      cloneAll = options.cloneAll || false;
	
	  var newData = data.length ? [data[0]] : [];
	
	  for (var i = 1; i < data.length; i++) {
	    var diff = diffFunction((0, _get2.default)(data[i - 1], dateKey), (0, _get2.default)(data[i], dateKey)),
	        startDate = (0, _get2.default)(data[i - 1], dateKey);
	
	    if (diff > 1) {
	      for (var j = 0; j < diff - 1; j++) {
	        var fillDate = new Date(startDate);
	        fillDate.setDate(startDate.getDate() + (j + 1));
	
	        var fillValue = (0, _cloneDeep2.default)(data[i - 1].value).map(function (v, valueIndex) {
	          if (!cloneAll && replacements[valueIndex] !== "clone") {
	            v.result = replacements.default || 0;
	          }
	          return v;
	        });
	
	        newData.push((0, _set2.default)({ value: fillValue }, dateKey, fillDate));
	      }
	    }
	    newData.push(data[i]);
	  }
	
	  return newData;
	}
	
	function makeCsv(data) {
	  return "\uFEFF" + _papaparse2.default.unparse(data);
	}
	
	function clientSideDownload(filename, mimeType, content) {
	  var data = void 0,
	      link = void 0;
	
	  data = "data:" + mimeType + ";charset=utf-8," + encodeURIComponent(content);
	
	  link = document.createElement("a");
	  link.setAttribute("href", data);
	  link.setAttribute("download", filename);
	
	  // Firefox requires an element to actually be mounted on the DOM in order to be clickable.
	  document.getElementById("loader").appendChild(link);
	
	  link.click();
	}
	
	function formatSubscriptionStatus(subscription) {
	  if (subscription.status === "active") {
	    var term = subscription.should_autorenew ? "Renews" : "Expires";
	    return term + " " + (0, _momentTimezone2.default)(subscription.renewal_date).format("LL");
	  } else {
	    return "Expired " + (0, _momentTimezone2.default)(subscription.expired_date).format("LL");
	  }
	}
	
	function snakeCase() {
	  var s = arguments.length <= 0 || arguments[0] === undefined ? "" : arguments[0];
	
	  return s.trim().replace(/[^\w\s]/g, "").toLowerCase().replace(/\s+/g, "_");
	}
	
	function unSnakeCase() {
	  var s = arguments.length <= 0 || arguments[0] === undefined ? "" : arguments[0];
	
	  return s.toLowerCase().replace(/_/g, " ");
	}
	
	function capitalize(s) {
	  return s && s[0].toUpperCase() + s.slice(1);
	}
	
	// SYNC WITH FRONTEND
	function applyCoupon(subitem, price, item, coupon, appSettings) {
	  var originalPrice = price,
	      isVolumeDiscounted = false,
	      rawTotal = void 0,
	      fee = void 0;
	
	  // If no price (e.g. an empty inline donation)
	  if (!price) {
	    price = 0;
	  }
	
	  if (!coupon) {
	    coupon = {};
	  }
	
	  // Apply volume price - find the highest minimum quantity that the current order matches
	  // Note: For quantity=1 when a sale price is enabled, we use the sale price instead.
	  if (item && item.volume_price_enabled && !(item.sale_price && subitem.quantity === 1)) {
	    (function () {
	      var discount = { minimum_quantity: 0, price: price };
	      item.volume_price.forEach(function (potentialDiscount) {
	        if (subitem.quantity >= potentialDiscount.minimum_quantity && potentialDiscount.minimum_quantity > discount.minimum_quantity) {
	          discount = potentialDiscount;
	        }
	      });
	      price = discount.price;
	      isVolumeDiscounted = true;
	    })();
	  }
	
	  // Apply sale price
	  if (item && item.sale_price && price === item.sale_price) {
	    originalPrice = item.price;
	  }
	
	  // "Transform" cents_off with max_quantity=1 to cents_off_item
	  if (coupon.cents_off && coupon.max_quantity === 1) {
	    coupon.cents_off_item = coupon.cents_off;
	    delete coupon.cents_off;
	  }
	
	  // Apply percent off / set_price discount, including restricting by quantity
	  var percentToDiscount = 1,
	      discountedPrice = coupon.set_price ? coupon.set_price : price - price * ((coupon.percent_off || 0) / 100);
	  if (coupon.cents_off_item) {
	    discountedPrice -= coupon.cents_off_item;
	  }
	  discountedPrice = Math.max(0, discountedPrice);
	  if (coupon.max_quantity && subitem.quantity > coupon.max_quantity) {
	    percentToDiscount = coupon.max_quantity / subitem.quantity;
	    price = [[discountedPrice, coupon.max_quantity], [price, subitem.quantity - coupon.max_quantity]];
	  } else {
	    price = discountedPrice;
	  }
	
	  rawTotal = Array.isArray(price) ? price.reduce(function (total, p) {
	    return total + p[0] * p[1];
	  }, 0) : price * (subitem.quantity === 0 ? 0 : subitem.quantity || 1);
	
	  // Calculate cents_off
	  if (coupon.cents_off) {
	    rawTotal = Math.max(0, rawTotal - coupon.cents_off);
	  }
	
	  // Don't show an "original price" because the cents_off discount applies to the total
	  if (!coupon.percent_off && !coupon.cents_off_item && !isVolumeDiscounted || originalPrice === price) {
	    originalPrice = undefined;
	  }
	
	  // Calculate tax -- FEE NOT INCLUDED AS PART OF IT
	  var tax = 0;
	  if (appSettings.tax_at_box_office && appSettings.tax_percent) {
	    var type = subitem.pass_bucket ? "pass" : subitem.ticket_bucket ? "ticket" : subitem.item_bucket ? "item" : "";
	    if (item.code === "donation") {
	      type = "donation";
	    }
	
	    if (appSettings.tax_for.indexOf(type) !== -1) {
	      // Inject on a per-item basis to match ledger style rounding.
	      tax = subitem.quantity * Math.round(appSettings.tax_percent * (rawTotal / subitem.quantity));
	      rawTotal += tax;
	    }
	  }
	
	  // Calculate fee -- Sundance only for now
	  if (appSettings.fee_at_box_office) {
	    // Calculate fee by summing for each i=0...quantity, to match Ledger-style rounding.
	    var calculated = 0;
	    for (var i = 0; i < subitem.quantity; i++) {
	      // Calculate the price of this numbered item. If price is an array,
	      // the array is in the format [[price, quantity], ...]. We want to
	      // find the price for the i-th item, so we need to sum the quantities
	      // of the items in the array until we reach the i-th item.
	      var itemPrice = price;
	      if (Array.isArray(price)) {
	        var quantitySum = 0;
	        for (var j = 0; j < price.length; j++) {
	          quantitySum += price[j][1];
	          if (quantitySum > i) {
	            itemPrice = price[j][0];
	            break;
	          }
	        }
	      }
	
	      var piece = void 0;
	      if (appSettings.pricing_plan === "sundance") {
	        piece = itemPrice * 0.035 + (subitem.ticket_bucket && itemPrice > 0 ? 35 : 0);
	      } else if (appSettings.pricing_plan === "cphdox") {
	        piece = subitem.ticket_bucket && itemPrice > 0 ? 1000 : 0;
	      } else {
	        // FIXME: Unsupported except for Sundance for now
	        piece = NaN;
	      }
	
	      calculated += Math.round(piece * (100 - appSettings.absorb_fee_percent) / 100);
	    }
	    fee = calculated;
	    rawTotal += fee;
	  }
	
	  var total = rawTotal;
	
	  return { originalPrice: originalPrice, price: price, fee: fee, tax: tax, total: total };
	}
	// SYNC
	
	function makeFilmDetailString(details) {
	  var detailString = [details.runtime && details.runtime + " minutes", details.country, details.year].filter(function (x) {
	    return !!x;
	  }).join(" | ");
	  return detailString;
	}
	
	function dashify(str) {
	  return str.trim().replace(/_/g, "-").replace(/([a-z])([A-Z])/g, "$1-$2").replace(/\W/g, function (m) {
	    return (/[À-ž]/.test(m) ? m : "-"
	    );
	  }).replace(/^-+|-+$/g, "").replace(/-{2,}/g, function (m) {
	    return "-";
	  }).toLowerCase();
	}
	
	function makeEventDateRangeLabel(event) {
	  var geoAvailability = void 0;
	
	  if (event.is_virtual) {
	    if (event.geographic_restrictions.length) {
	      geoAvailability = "in " + event.geographic_restrictions.map(function (r) {
	        return formatRegion(r);
	      }).join(", ");
	    } else if (event.geographic_exclusions.length) {
	      geoAvailability = "everywhere except " + event.geographic_exclusions.map(function (r) {
	        return formatRegion(r);
	      }).join(", ");
	    }
	    if (!event.is_dated && geoAvailability) {
	      return "Available " + geoAvailability;
	    }
	    if (!event.is_dated && !event.geographic_restrictions.length && !event.geographic_exclusions.length) {
	      return React.createElement(
	        "span",
	        null,
	        "No availability restrictions"
	      );
	    }
	  }
	
	  if (!event.is_dated) return React.createElement(
	    "span",
	    null,
	    "Undated event"
	  );
	  if (!event.start_time || !event.end_time) return React.createElement(
	    "span",
	    null,
	    "Date not yet set"
	  );
	  var isDifferentTimezone = !!event.timezone && _momentTimezone2.default.tz.guess() !== event.timezone;
	  var start = event.start_time._isAMomentObject ? event.start_time : _momentTimezone2.default.tz(event.start_time, event.timezone);
	  var end = event.end_time._isAMomentObject ? event.end_time : _momentTimezone2.default.tz(event.end_time, event.timezone);
	  return React.createElement(
	    "span",
	    null,
	    event.is_virtual ? "Available " : "",
	    start.twix(end).format({
	      showDate: true,
	      implicitMinutes: false,
	      groupMeridiems: false,
	      implicitYear: false
	    }),
	    isDifferentTimezone ? " " + start.format("z") : "",
	    " ",
	    geoAvailability,
	    event.recurring_event && event.recurring_event.repeats.length ? React.createElement(_loop2.default, {
	      style: {
	        color: "inherit",
	        height: "1em",
	        verticalAlign: "-2px",
	        marginLeft: -4
	      }
	    }) : null
	  );
	}
	
	function formatBytes(bytes) {
	  var decimals = arguments.length <= 1 || arguments[1] === undefined ? 2 : arguments[1];
	
	  if (bytes === 0) return "0 Bytes";
	  var k = 1024;
	  var dm = decimals < 0 ? 0 : decimals;
	  var sizes = ["bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
	  var i = Math.floor(Math.log(bytes) / Math.log(k));
	  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
	}
	
	var POSTAL_PREFIX = "postal-";
	function formatRegion(code) {
	  var locationData = _SystemStatesStore2.default.getLocationData();
	  var continent = locationData.continents.find(function (c) {
	    return c.code === code;
	  });
	  if (continent) {
	    return continent.name;
	  }
	  var country = locationData.countries.find(function (c) {
	    return c.code === code;
	  });
	  if (country) {
	    return country.name;
	  }
	  var region = locationData.regions.find(function (r) {
	    return r.code === code;
	  });
	  if (region) {
	    return region.name;
	  }
	
	  if (code.startsWith(POSTAL_PREFIX)) {
	    return code.substring(POSTAL_PREFIX.length);
	  }
	
	  return "???";
	}
	
	function formatBasedOnQuantity(quantity, singleOption, multipleOption) {
	  return quantity === 1 ? singleOption : multipleOption;
	}
	
	exports.intersperse = intersperse;
	exports.parsePriceToCents = parsePriceToCents;
	exports.formatPrice = formatPrice;
	exports.formatNumber = formatNumber;
	exports.formatPercent = formatPercent;
	exports.fillMissingDays = fillMissingDays;
	exports.fillMissingDaysNew = fillMissingDaysNew;
	exports.makeCsv = makeCsv;
	exports.clientSideDownload = clientSideDownload;
	exports.formatSubscriptionStatus = formatSubscriptionStatus;
	exports.snakeCase = snakeCase;
	exports.unSnakeCase = unSnakeCase;
	exports.capitalize = capitalize;
	exports.applyCoupon = applyCoupon;
	exports.makeFilmDetailString = makeFilmDetailString;
	exports.dashify = dashify;
	exports.makeEventDateRangeLabel = makeEventDateRangeLabel;
	exports.formatBytes = formatBytes;
	exports.formatRegion = formatRegion;
	exports.formatBasedOnQuantity = formatBasedOnQuantity;

/***/ }),
/* 1184 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*!
		Papa Parse
		v4.1.2
		https://github.com/mholt/PapaParse
	*/
	(function(global)
	{
		"use strict";
	
		var IS_WORKER = !global.document && !!global.postMessage,
			IS_PAPA_WORKER = IS_WORKER && /(\?|&)papaworker(=|&|$)/.test(global.location.search),
			LOADED_SYNC = false, AUTO_SCRIPT_PATH;
		var workers = {}, workerIdCounter = 0;
	
		var Papa = {};
	
		Papa.parse = CsvToJson;
		Papa.unparse = JsonToCsv;
	
		Papa.RECORD_SEP = String.fromCharCode(30);
		Papa.UNIT_SEP = String.fromCharCode(31);
		Papa.BYTE_ORDER_MARK = "\ufeff";
		Papa.BAD_DELIMITERS = ["\r", "\n", "\"", Papa.BYTE_ORDER_MARK];
		Papa.WORKERS_SUPPORTED = !IS_WORKER && !!global.Worker;
		Papa.SCRIPT_PATH = null;	// Must be set by your code if you use workers and this lib is loaded asynchronously
	
		// Configurable chunk sizes for local and remote files, respectively
		Papa.LocalChunkSize = 1024 * 1024 * 10;	// 10 MB
		Papa.RemoteChunkSize = 1024 * 1024 * 5;	// 5 MB
		Papa.DefaultDelimiter = ",";			// Used if not specified and detection fails
	
		// Exposed for testing and development only
		Papa.Parser = Parser;
		Papa.ParserHandle = ParserHandle;
		Papa.NetworkStreamer = NetworkStreamer;
		Papa.FileStreamer = FileStreamer;
		Papa.StringStreamer = StringStreamer;
	
		if (typeof module !== 'undefined' && module.exports)
		{
			// Export to Node...
			module.exports = Papa;
		}
		else if (isFunction(global.define) && global.define.amd)
		{
			// Wireup with RequireJS
			!(__WEBPACK_AMD_DEFINE_RESULT__ = function() { return Papa; }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		}
		else
		{
			// ...or as browser global
			global.Papa = Papa;
		}
	
		if (global.jQuery)
		{
			var $ = global.jQuery;
			$.fn.parse = function(options)
			{
				var config = options.config || {};
				var queue = [];
	
				this.each(function(idx)
				{
					var supported = $(this).prop('tagName').toUpperCase() == "INPUT"
									&& $(this).attr('type').toLowerCase() == "file"
									&& global.FileReader;
	
					if (!supported || !this.files || this.files.length == 0)
						return true;	// continue to next input element
	
					for (var i = 0; i < this.files.length; i++)
					{
						queue.push({
							file: this.files[i],
							inputElem: this,
							instanceConfig: $.extend({}, config)
						});
					}
				});
	
				parseNextFile();	// begin parsing
				return this;		// maintains chainability
	
	
				function parseNextFile()
				{
					if (queue.length == 0)
					{
						if (isFunction(options.complete))
							options.complete();
						return;
					}
	
					var f = queue[0];
	
					if (isFunction(options.before))
					{
						var returned = options.before(f.file, f.inputElem);
	
						if (typeof returned === 'object')
						{
							if (returned.action == "abort")
							{
								error("AbortError", f.file, f.inputElem, returned.reason);
								return;	// Aborts all queued files immediately
							}
							else if (returned.action == "skip")
							{
								fileComplete();	// parse the next file in the queue, if any
								return;
							}
							else if (typeof returned.config === 'object')
								f.instanceConfig = $.extend(f.instanceConfig, returned.config);
						}
						else if (returned == "skip")
						{
							fileComplete();	// parse the next file in the queue, if any
							return;
						}
					}
	
					// Wrap up the user's complete callback, if any, so that ours also gets executed
					var userCompleteFunc = f.instanceConfig.complete;
					f.instanceConfig.complete = function(results)
					{
						if (isFunction(userCompleteFunc))
							userCompleteFunc(results, f.file, f.inputElem);
						fileComplete();
					};
	
					Papa.parse(f.file, f.instanceConfig);
				}
	
				function error(name, file, elem, reason)
				{
					if (isFunction(options.error))
						options.error({name: name}, file, elem, reason);
				}
	
				function fileComplete()
				{
					queue.splice(0, 1);
					parseNextFile();
				}
			}
		}
	
	
		if (IS_PAPA_WORKER)
		{
			global.onmessage = workerThreadReceivedMessage;
		}
		else if (Papa.WORKERS_SUPPORTED)
		{
			AUTO_SCRIPT_PATH = getScriptPath();
	
			// Check if the script was loaded synchronously
			if (!document.body)
			{
				// Body doesn't exist yet, must be synchronous
				LOADED_SYNC = true;
			}
			else
			{
				document.addEventListener('DOMContentLoaded', function () {
					LOADED_SYNC = true;
				}, true);
			}
		}
	
	
	
	
		function CsvToJson(_input, _config)
		{
			_config = _config || {};
	
			if (_config.worker && Papa.WORKERS_SUPPORTED)
			{
				var w = newWorker();
	
				w.userStep = _config.step;
				w.userChunk = _config.chunk;
				w.userComplete = _config.complete;
				w.userError = _config.error;
	
				_config.step = isFunction(_config.step);
				_config.chunk = isFunction(_config.chunk);
				_config.complete = isFunction(_config.complete);
				_config.error = isFunction(_config.error);
				delete _config.worker;	// prevent infinite loop
	
				w.postMessage({
					input: _input,
					config: _config,
					workerId: w.id
				});
	
				return;
			}
	
			var streamer = null;
			if (typeof _input === 'string')
			{
				if (_config.download)
					streamer = new NetworkStreamer(_config);
				else
					streamer = new StringStreamer(_config);
			}
			else if ((global.File && _input instanceof File) || _input instanceof Object)	// ...Safari. (see issue #106)
				streamer = new FileStreamer(_config);
	
			return streamer.stream(_input);
		}
	
	
	
	
	
	
		function JsonToCsv(_input, _config)
		{
			var _output = "";
			var _fields = [];
	
			// Default configuration
	
			/** whether to surround every datum with quotes */
			var _quotes = false;
	
			/** delimiting character */
			var _delimiter = ",";
	
			/** newline character(s) */
			var _newline = "\r\n";
	
			unpackConfig();
	
			if (typeof _input === 'string')
				_input = JSON.parse(_input);
	
			if (_input instanceof Array)
			{
				if (!_input.length || _input[0] instanceof Array)
					return serialize(null, _input);
				else if (typeof _input[0] === 'object')
					return serialize(objectKeys(_input[0]), _input);
			}
			else if (typeof _input === 'object')
			{
				if (typeof _input.data === 'string')
					_input.data = JSON.parse(_input.data);
	
				if (_input.data instanceof Array)
				{
					if (!_input.fields)
						_input.fields = _input.data[0] instanceof Array
										? _input.fields
										: objectKeys(_input.data[0]);
	
					if (!(_input.data[0] instanceof Array) && typeof _input.data[0] !== 'object')
						_input.data = [_input.data];	// handles input like [1,2,3] or ["asdf"]
				}
	
				return serialize(_input.fields || [], _input.data || []);
			}
	
			// Default (any valid paths should return before this)
			throw "exception: Unable to serialize unrecognized input";
	
	
			function unpackConfig()
			{
				if (typeof _config !== 'object')
					return;
	
				if (typeof _config.delimiter === 'string'
					&& _config.delimiter.length == 1
					&& Papa.BAD_DELIMITERS.indexOf(_config.delimiter) == -1)
				{
					_delimiter = _config.delimiter;
				}
	
				if (typeof _config.quotes === 'boolean'
					|| _config.quotes instanceof Array)
					_quotes = _config.quotes;
	
				if (typeof _config.newline === 'string')
					_newline = _config.newline;
			}
	
	
			/** Turns an object's keys into an array */
			function objectKeys(obj)
			{
				if (typeof obj !== 'object')
					return [];
				var keys = [];
				for (var key in obj)
					keys.push(key);
				return keys;
			}
	
			/** The double for loop that iterates the data and writes out a CSV string including header row */
			function serialize(fields, data)
			{
				var csv = "";
	
				if (typeof fields === 'string')
					fields = JSON.parse(fields);
				if (typeof data === 'string')
					data = JSON.parse(data);
	
				var hasHeader = fields instanceof Array && fields.length > 0;
				var dataKeyedByField = !(data[0] instanceof Array);
	
				// If there a header row, write it first
				if (hasHeader)
				{
					for (var i = 0; i < fields.length; i++)
					{
						if (i > 0)
							csv += _delimiter;
						csv += safe(fields[i], i);
					}
					if (data.length > 0)
						csv += _newline;
				}
	
				// Then write out the data
				for (var row = 0; row < data.length; row++)
				{
					var maxCol = hasHeader ? fields.length : data[row].length;
	
					for (var col = 0; col < maxCol; col++)
					{
						if (col > 0)
							csv += _delimiter;
						var colIdx = hasHeader && dataKeyedByField ? fields[col] : col;
						csv += safe(data[row][colIdx], col);
					}
	
					if (row < data.length - 1)
						csv += _newline;
				}
	
				return csv;
			}
	
			/** Encloses a value around quotes if needed (makes a value safe for CSV insertion) */
			function safe(str, col)
			{
				if (typeof str === "undefined" || str === null)
					return "";
	
				str = str.toString().replace(/"/g, '""');
	
				var needsQuotes = (typeof _quotes === 'boolean' && _quotes)
								|| (_quotes instanceof Array && _quotes[col])
								|| hasAny(str, Papa.BAD_DELIMITERS)
								|| str.indexOf(_delimiter) > -1
								|| str.charAt(0) == ' '
								|| str.charAt(str.length - 1) == ' ';
	
				return needsQuotes ? '"' + str + '"' : str;
			}
	
			function hasAny(str, substrings)
			{
				for (var i = 0; i < substrings.length; i++)
					if (str.indexOf(substrings[i]) > -1)
						return true;
				return false;
			}
		}
	
		/** ChunkStreamer is the base prototype for various streamer implementations. */
		function ChunkStreamer(config)
		{
			this._handle = null;
			this._paused = false;
			this._finished = false;
			this._input = null;
			this._baseIndex = 0;
			this._partialLine = "";
			this._rowCount = 0;
			this._start = 0;
			this._nextChunk = null;
			this.isFirstChunk = true;
			this._completeResults = {
				data: [],
				errors: [],
				meta: {}
			};
			replaceConfig.call(this, config);
	
			this.parseChunk = function(chunk)
			{
				// First chunk pre-processing
				if (this.isFirstChunk && isFunction(this._config.beforeFirstChunk))
				{
					var modifiedChunk = this._config.beforeFirstChunk(chunk);
					if (modifiedChunk !== undefined)
						chunk = modifiedChunk;
				}
				this.isFirstChunk = false;
	
				// Rejoin the line we likely just split in two by chunking the file
				var aggregate = this._partialLine + chunk;
				this._partialLine = "";
	
				var results = this._handle.parse(aggregate, this._baseIndex, !this._finished);
				
				if (this._handle.paused() || this._handle.aborted())
					return;
				
				var lastIndex = results.meta.cursor;
				
				if (!this._finished)
				{
					this._partialLine = aggregate.substring(lastIndex - this._baseIndex);
					this._baseIndex = lastIndex;
				}
	
				if (results && results.data)
					this._rowCount += results.data.length;
	
				var finishedIncludingPreview = this._finished || (this._config.preview && this._rowCount >= this._config.preview);
	
				if (IS_PAPA_WORKER)
				{
					global.postMessage({
						results: results,
						workerId: Papa.WORKER_ID,
						finished: finishedIncludingPreview
					});
				}
				else if (isFunction(this._config.chunk))
				{
					this._config.chunk(results, this._handle);
					if (this._paused)
						return;
					results = undefined;
					this._completeResults = undefined;
				}
	
				if (!this._config.step && !this._config.chunk) {
					this._completeResults.data = this._completeResults.data.concat(results.data);
					this._completeResults.errors = this._completeResults.errors.concat(results.errors);
					this._completeResults.meta = results.meta;
				}
	
				if (finishedIncludingPreview && isFunction(this._config.complete) && (!results || !results.meta.aborted))
					this._config.complete(this._completeResults);
	
				if (!finishedIncludingPreview && (!results || !results.meta.paused))
					this._nextChunk();
	
				return results;
			};
	
			this._sendError = function(error)
			{
				if (isFunction(this._config.error))
					this._config.error(error);
				else if (IS_PAPA_WORKER && this._config.error)
				{
					global.postMessage({
						workerId: Papa.WORKER_ID,
						error: error,
						finished: false
					});
				}
			};
	
			function replaceConfig(config)
			{
				// Deep-copy the config so we can edit it
				var configCopy = copy(config);
				configCopy.chunkSize = parseInt(configCopy.chunkSize);	// parseInt VERY important so we don't concatenate strings!
				if (!config.step && !config.chunk)
					configCopy.chunkSize = null;  // disable Range header if not streaming; bad values break IIS - see issue #196
				this._handle = new ParserHandle(configCopy);
				this._handle.streamer = this;
				this._config = configCopy;	// persist the copy to the caller
			}
		}
	
	
		function NetworkStreamer(config)
		{
			config = config || {};
			if (!config.chunkSize)
				config.chunkSize = Papa.RemoteChunkSize;
			ChunkStreamer.call(this, config);
	
			var xhr;
	
			if (IS_WORKER)
			{
				this._nextChunk = function()
				{
					this._readChunk();
					this._chunkLoaded();
				};
			}
			else
			{
				this._nextChunk = function()
				{
					this._readChunk();
				};
			}
	
			this.stream = function(url)
			{
				this._input = url;
				this._nextChunk();	// Starts streaming
			};
	
			this._readChunk = function()
			{
				if (this._finished)
				{
					this._chunkLoaded();
					return;
				}
	
				xhr = new XMLHttpRequest();
				
				if (!IS_WORKER)
				{
					xhr.onload = bindFunction(this._chunkLoaded, this);
					xhr.onerror = bindFunction(this._chunkError, this);
				}
	
				xhr.open("GET", this._input, !IS_WORKER);
				
				if (this._config.chunkSize)
				{
					var end = this._start + this._config.chunkSize - 1;	// minus one because byte range is inclusive
					xhr.setRequestHeader("Range", "bytes="+this._start+"-"+end);
					xhr.setRequestHeader("If-None-Match", "webkit-no-cache"); // https://bugs.webkit.org/show_bug.cgi?id=82672
				}
	
				try {
					xhr.send();
				}
				catch (err) {
					this._chunkError(err.message);
				}
	
				if (IS_WORKER && xhr.status == 0)
					this._chunkError();
				else
					this._start += this._config.chunkSize;
			}
	
			this._chunkLoaded = function()
			{
				if (xhr.readyState != 4)
					return;
	
				if (xhr.status < 200 || xhr.status >= 400)
				{
					this._chunkError();
					return;
				}
	
				this._finished = !this._config.chunkSize || this._start > getFileSize(xhr);
				this.parseChunk(xhr.responseText);
			}
	
			this._chunkError = function(errorMessage)
			{
				var errorText = xhr.statusText || errorMessage;
				this._sendError(errorText);
			}
	
			function getFileSize(xhr)
			{
				var contentRange = xhr.getResponseHeader("Content-Range");
				return parseInt(contentRange.substr(contentRange.lastIndexOf("/") + 1));
			}
		}
		NetworkStreamer.prototype = Object.create(ChunkStreamer.prototype);
		NetworkStreamer.prototype.constructor = NetworkStreamer;
	
	
		function FileStreamer(config)
		{
			config = config || {};
			if (!config.chunkSize)
				config.chunkSize = Papa.LocalChunkSize;
			ChunkStreamer.call(this, config);
	
			var reader, slice;
	
			// FileReader is better than FileReaderSync (even in worker) - see http://stackoverflow.com/q/24708649/1048862
			// But Firefox is a pill, too - see issue #76: https://github.com/mholt/PapaParse/issues/76
			var usingAsyncReader = typeof FileReader !== 'undefined';	// Safari doesn't consider it a function - see issue #105
	
			this.stream = function(file)
			{
				this._input = file;
				slice = file.slice || file.webkitSlice || file.mozSlice;
	
				if (usingAsyncReader)
				{
					reader = new FileReader();		// Preferred method of reading files, even in workers
					reader.onload = bindFunction(this._chunkLoaded, this);
					reader.onerror = bindFunction(this._chunkError, this);
				}
				else
					reader = new FileReaderSync();	// Hack for running in a web worker in Firefox
	
				this._nextChunk();	// Starts streaming
			};
	
			this._nextChunk = function()
			{
				if (!this._finished && (!this._config.preview || this._rowCount < this._config.preview))
					this._readChunk();
			}
	
			this._readChunk = function()
			{
				var input = this._input;
				if (this._config.chunkSize)
				{
					var end = Math.min(this._start + this._config.chunkSize, this._input.size);
					input = slice.call(input, this._start, end);
				}
				var txt = reader.readAsText(input, this._config.encoding);
				if (!usingAsyncReader)
					this._chunkLoaded({ target: { result: txt } });	// mimic the async signature
			}
	
			this._chunkLoaded = function(event)
			{
				// Very important to increment start each time before handling results
				this._start += this._config.chunkSize;
				this._finished = !this._config.chunkSize || this._start >= this._input.size;
				this.parseChunk(event.target.result);
			}
	
			this._chunkError = function()
			{
				this._sendError(reader.error);
			}
	
		}
		FileStreamer.prototype = Object.create(ChunkStreamer.prototype);
		FileStreamer.prototype.constructor = FileStreamer;
	
	
		function StringStreamer(config)
		{
			config = config || {};
			ChunkStreamer.call(this, config);
	
			var string;
			var remaining;
			this.stream = function(s)
			{
				string = s;
				remaining = s;
				return this._nextChunk();
			}
			this._nextChunk = function()
			{
				if (this._finished) return;
				var size = this._config.chunkSize;
				var chunk = size ? remaining.substr(0, size) : remaining;
				remaining = size ? remaining.substr(size) : '';
				this._finished = !remaining;
				return this.parseChunk(chunk);
			}
		}
		StringStreamer.prototype = Object.create(StringStreamer.prototype);
		StringStreamer.prototype.constructor = StringStreamer;
	
	
	
		// Use one ParserHandle per entire CSV file or string
		function ParserHandle(_config)
		{
			// One goal is to minimize the use of regular expressions...
			var FLOAT = /^\s*-?(\d*\.?\d+|\d+\.?\d*)(e[-+]?\d+)?\s*$/i;
	
			var self = this;
			var _stepCounter = 0;	// Number of times step was called (number of rows parsed)
			var _input;				// The input being parsed
			var _parser;			// The core parser being used
			var _paused = false;	// Whether we are paused or not
			var _aborted = false;   // Whether the parser has aborted or not
			var _delimiterError;	// Temporary state between delimiter detection and processing results
			var _fields = [];		// Fields are from the header row of the input, if there is one
			var _results = {		// The last results returned from the parser
				data: [],
				errors: [],
				meta: {}
			};
	
			if (isFunction(_config.step))
			{
				var userStep = _config.step;
				_config.step = function(results)
				{
					_results = results;
	
					if (needsHeaderRow())
						processResults();
					else	// only call user's step function after header row
					{
						processResults();
	
						// It's possbile that this line was empty and there's no row here after all
						if (_results.data.length == 0)
							return;
	
						_stepCounter += results.data.length;
						if (_config.preview && _stepCounter > _config.preview)
							_parser.abort();
						else
							userStep(_results, self);
					}
				};
			}
	
			/**
			 * Parses input. Most users won't need, and shouldn't mess with, the baseIndex
			 * and ignoreLastRow parameters. They are used by streamers (wrapper functions)
			 * when an input comes in multiple chunks, like from a file.
			 */
			this.parse = function(input, baseIndex, ignoreLastRow)
			{
				if (!_config.newline)
					_config.newline = guessLineEndings(input);
	
				_delimiterError = false;
				if (!_config.delimiter)
				{
					var delimGuess = guessDelimiter(input);
					if (delimGuess.successful)
						_config.delimiter = delimGuess.bestDelimiter;
					else
					{
						_delimiterError = true;	// add error after parsing (otherwise it would be overwritten)
						_config.delimiter = Papa.DefaultDelimiter;
					}
					_results.meta.delimiter = _config.delimiter;
				}
	
				var parserConfig = copy(_config);
				if (_config.preview && _config.header)
					parserConfig.preview++;	// to compensate for header row
	
				_input = input;
				_parser = new Parser(parserConfig);
				_results = _parser.parse(_input, baseIndex, ignoreLastRow);
				processResults();
				return _paused ? { meta: { paused: true } } : (_results || { meta: { paused: false } });
			};
	
			this.paused = function()
			{
				return _paused;
			};
	
			this.pause = function()
			{
				_paused = true;
				_parser.abort();
				_input = _input.substr(_parser.getCharIndex());
			};
	
			this.resume = function()
			{
				_paused = false;
				self.streamer.parseChunk(_input);
			};
	
			this.aborted = function () {
				return _aborted;
			}
	
			this.abort = function()
			{
				_aborted = true;
				_parser.abort();
				_results.meta.aborted = true;
				if (isFunction(_config.complete))
					_config.complete(_results);
				_input = "";
			};
	
			function processResults()
			{
				if (_results && _delimiterError)
				{
					addError("Delimiter", "UndetectableDelimiter", "Unable to auto-detect delimiting character; defaulted to '"+Papa.DefaultDelimiter+"'");
					_delimiterError = false;
				}
	
				if (_config.skipEmptyLines)
				{
					for (var i = 0; i < _results.data.length; i++)
						if (_results.data[i].length == 1 && _results.data[i][0] == "")
							_results.data.splice(i--, 1);
				}
	
				if (needsHeaderRow())
					fillHeaderFields();
	
				return applyHeaderAndDynamicTyping();
			}
	
			function needsHeaderRow()
			{
				return _config.header && _fields.length == 0;
			}
	
			function fillHeaderFields()
			{
				if (!_results)
					return;
				for (var i = 0; needsHeaderRow() && i < _results.data.length; i++)
					for (var j = 0; j < _results.data[i].length; j++)
						_fields.push(_results.data[i][j]);
				_results.data.splice(0, 1);
			}
	
			function applyHeaderAndDynamicTyping()
			{
				if (!_results || (!_config.header && !_config.dynamicTyping))
					return _results;
	
				for (var i = 0; i < _results.data.length; i++)
				{
					var row = {};
	
					for (var j = 0; j < _results.data[i].length; j++)
					{
						if (_config.dynamicTyping)
						{
							var value = _results.data[i][j];
							if (value == "true" || value == "TRUE")
								_results.data[i][j] = true;
							else if (value == "false" || value == "FALSE")
								_results.data[i][j] = false;
							else
								_results.data[i][j] = tryParseFloat(value);
						}
	
						if (_config.header)
						{
							if (j >= _fields.length)
							{
								if (!row["__parsed_extra"])
									row["__parsed_extra"] = [];
								row["__parsed_extra"].push(_results.data[i][j]);
							}
							else
								row[_fields[j]] = _results.data[i][j];
						}
					}
	
					if (_config.header)
					{
						_results.data[i] = row;
						if (j > _fields.length)
							addError("FieldMismatch", "TooManyFields", "Too many fields: expected " + _fields.length + " fields but parsed " + j, i);
						else if (j < _fields.length)
							addError("FieldMismatch", "TooFewFields", "Too few fields: expected " + _fields.length + " fields but parsed " + j, i);
					}
				}
	
				if (_config.header && _results.meta)
					_results.meta.fields = _fields;
				return _results;
			}
	
			function guessDelimiter(input)
			{
				var delimChoices = [",", "\t", "|", ";", Papa.RECORD_SEP, Papa.UNIT_SEP];
				var bestDelim, bestDelta, fieldCountPrevRow;
	
				for (var i = 0; i < delimChoices.length; i++)
				{
					var delim = delimChoices[i];
					var delta = 0, avgFieldCount = 0;
					fieldCountPrevRow = undefined;
	
					var preview = new Parser({
						delimiter: delim,
						preview: 10
					}).parse(input);
	
					for (var j = 0; j < preview.data.length; j++)
					{
						var fieldCount = preview.data[j].length;
						avgFieldCount += fieldCount;
	
						if (typeof fieldCountPrevRow === 'undefined')
						{
							fieldCountPrevRow = fieldCount;
							continue;
						}
						else if (fieldCount > 1)
						{
							delta += Math.abs(fieldCount - fieldCountPrevRow);
							fieldCountPrevRow = fieldCount;
						}
					}
	
					if (preview.data.length > 0)
						avgFieldCount /= preview.data.length;
	
					if ((typeof bestDelta === 'undefined' || delta < bestDelta)
						&& avgFieldCount > 1.99)
					{
						bestDelta = delta;
						bestDelim = delim;
					}
				}
	
				_config.delimiter = bestDelim;
	
				return {
					successful: !!bestDelim,
					bestDelimiter: bestDelim
				}
			}
	
			function guessLineEndings(input)
			{
				input = input.substr(0, 1024*1024);	// max length 1 MB
	
				var r = input.split('\r');
	
				if (r.length == 1)
					return '\n';
	
				var numWithN = 0;
				for (var i = 0; i < r.length; i++)
				{
					if (r[i][0] == '\n')
						numWithN++;
				}
	
				return numWithN >= r.length / 2 ? '\r\n' : '\r';
			}
	
			function tryParseFloat(val)
			{
				var isNumber = FLOAT.test(val);
				return isNumber ? parseFloat(val) : val;
			}
	
			function addError(type, code, msg, row)
			{
				_results.errors.push({
					type: type,
					code: code,
					message: msg,
					row: row
				});
			}
		}
	
	
	
	
	
		/** The core parser implements speedy and correct CSV parsing */
		function Parser(config)
		{
			// Unpack the config object
			config = config || {};
			var delim = config.delimiter;
			var newline = config.newline;
			var comments = config.comments;
			var step = config.step;
			var preview = config.preview;
			var fastMode = config.fastMode;
	
			// Delimiter must be valid
			if (typeof delim !== 'string'
				|| Papa.BAD_DELIMITERS.indexOf(delim) > -1)
				delim = ",";
	
			// Comment character must be valid
			if (comments === delim)
				throw "Comment character same as delimiter";
			else if (comments === true)
				comments = "#";
			else if (typeof comments !== 'string'
				|| Papa.BAD_DELIMITERS.indexOf(comments) > -1)
				comments = false;
	
			// Newline must be valid: \r, \n, or \r\n
			if (newline != '\n' && newline != '\r' && newline != '\r\n')
				newline = '\n';
	
			// We're gonna need these at the Parser scope
			var cursor = 0;
			var aborted = false;
	
			this.parse = function(input, baseIndex, ignoreLastRow)
			{
				// For some reason, in Chrome, this speeds things up (!?)
				if (typeof input !== 'string')
					throw "Input must be a string";
	
				// We don't need to compute some of these every time parse() is called,
				// but having them in a more local scope seems to perform better
				var inputLen = input.length,
					delimLen = delim.length,
					newlineLen = newline.length,
					commentsLen = comments.length;
				var stepIsFunction = typeof step === 'function';
	
				// Establish starting state
				cursor = 0;
				var data = [], errors = [], row = [], lastCursor = 0;
	
				if (!input)
					return returnable();
	
				if (fastMode || (fastMode !== false && input.indexOf('"') === -1))
				{
					var rows = input.split(newline);
					for (var i = 0; i < rows.length; i++)
					{
						var row = rows[i];
						cursor += row.length;
						if (i !== rows.length - 1)
							cursor += newline.length;
						else if (ignoreLastRow)
							return returnable();
						if (comments && row.substr(0, commentsLen) == comments)
							continue;
						if (stepIsFunction)
						{
							data = [];
							pushRow(row.split(delim));
							doStep();
							if (aborted)
								return returnable();
						}
						else
							pushRow(row.split(delim));
						if (preview && i >= preview)
						{
							data = data.slice(0, preview);
							return returnable(true);
						}
					}
					return returnable();
				}
	
				var nextDelim = input.indexOf(delim, cursor);
				var nextNewline = input.indexOf(newline, cursor);
	
				// Parser loop
				for (;;)
				{
					// Field has opening quote
					if (input[cursor] == '"')
					{
						// Start our search for the closing quote where the cursor is
						var quoteSearch = cursor;
	
						// Skip the opening quote
						cursor++;
	
						for (;;)
						{
							// Find closing quote
							var quoteSearch = input.indexOf('"', quoteSearch+1);
	
							if (quoteSearch === -1)
							{
								if (!ignoreLastRow) {
									// No closing quote... what a pity
									errors.push({
										type: "Quotes",
										code: "MissingQuotes",
										message: "Quoted field unterminated",
										row: data.length,	// row has yet to be inserted
										index: cursor
									});
								}
								return finish();
							}
	
							if (quoteSearch === inputLen-1)
							{
								// Closing quote at EOF
								var value = input.substring(cursor, quoteSearch).replace(/""/g, '"');
								return finish(value);
							}
	
							// If this quote is escaped, it's part of the data; skip it
							if (input[quoteSearch+1] == '"')
							{
								quoteSearch++;
								continue;
							}
	
							if (input[quoteSearch+1] == delim)
							{
								// Closing quote followed by delimiter
								row.push(input.substring(cursor, quoteSearch).replace(/""/g, '"'));
								cursor = quoteSearch + 1 + delimLen;
								nextDelim = input.indexOf(delim, cursor);
								nextNewline = input.indexOf(newline, cursor);
								break;
							}
	
							if (input.substr(quoteSearch+1, newlineLen) === newline)
							{
								// Closing quote followed by newline
								row.push(input.substring(cursor, quoteSearch).replace(/""/g, '"'));
								saveRow(quoteSearch + 1 + newlineLen);
								nextDelim = input.indexOf(delim, cursor);	// because we may have skipped the nextDelim in the quoted field
	
								if (stepIsFunction)
								{
									doStep();
									if (aborted)
										return returnable();
								}
								
								if (preview && data.length >= preview)
									return returnable(true);
	
								break;
							}
						}
	
						continue;
					}
	
					// Comment found at start of new line
					if (comments && row.length === 0 && input.substr(cursor, commentsLen) === comments)
					{
						if (nextNewline == -1)	// Comment ends at EOF
							return returnable();
						cursor = nextNewline + newlineLen;
						nextNewline = input.indexOf(newline, cursor);
						nextDelim = input.indexOf(delim, cursor);
						continue;
					}
	
					// Next delimiter comes before next newline, so we've reached end of field
					if (nextDelim !== -1 && (nextDelim < nextNewline || nextNewline === -1))
					{
						row.push(input.substring(cursor, nextDelim));
						cursor = nextDelim + delimLen;
						nextDelim = input.indexOf(delim, cursor);
						continue;
					}
	
					// End of row
					if (nextNewline !== -1)
					{
						row.push(input.substring(cursor, nextNewline));
						saveRow(nextNewline + newlineLen);
	
						if (stepIsFunction)
						{
							doStep();
							if (aborted)
								return returnable();
						}
	
						if (preview && data.length >= preview)
							return returnable(true);
	
						continue;
					}
	
					break;
				}
	
	
				return finish();
	
	
				function pushRow(row)
				{
					data.push(row);
					lastCursor = cursor;
				}
	
				/**
				 * Appends the remaining input from cursor to the end into
				 * row, saves the row, calls step, and returns the results.
				 */
				function finish(value)
				{
					if (ignoreLastRow)
						return returnable();
					if (typeof value === 'undefined')
						value = input.substr(cursor);
					row.push(value);
					cursor = inputLen;	// important in case parsing is paused
					pushRow(row);
					if (stepIsFunction)
						doStep();
					return returnable();
				}
	
				/**
				 * Appends the current row to the results. It sets the cursor
				 * to newCursor and finds the nextNewline. The caller should
				 * take care to execute user's step function and check for
				 * preview and end parsing if necessary.
				 */
				function saveRow(newCursor)
				{
					cursor = newCursor;
					pushRow(row);
					row = [];
					nextNewline = input.indexOf(newline, cursor);
				}
	
				/** Returns an object with the results, errors, and meta. */
				function returnable(stopped)
				{
					return {
						data: data,
						errors: errors,
						meta: {
							delimiter: delim,
							linebreak: newline,
							aborted: aborted,
							truncated: !!stopped,
							cursor: lastCursor + (baseIndex || 0)
						}
					};
				}
	
				/** Executes the user's step function and resets data & errors. */
				function doStep()
				{
					step(returnable());
					data = [], errors = [];
				}
			};
	
			/** Sets the abort flag */
			this.abort = function()
			{
				aborted = true;
			};
	
			/** Gets the cursor position */
			this.getCharIndex = function()
			{
				return cursor;
			};
		}
	
	
		// If you need to load Papa Parse asynchronously and you also need worker threads, hard-code
		// the script path here. See: https://github.com/mholt/PapaParse/issues/87#issuecomment-57885358
		function getScriptPath()
		{
			var scripts = document.getElementsByTagName('script');
			return scripts.length ? scripts[scripts.length - 1].src : '';
		}
	
		function newWorker()
		{
			if (!Papa.WORKERS_SUPPORTED)
				return false;
			if (!LOADED_SYNC && Papa.SCRIPT_PATH === null)
				throw new Error(
					'Script path cannot be determined automatically when Papa Parse is loaded asynchronously. ' +
					'You need to set Papa.SCRIPT_PATH manually.'
				);
			var workerUrl = Papa.SCRIPT_PATH || AUTO_SCRIPT_PATH;
			// Append "papaworker" to the search string to tell papaparse that this is our worker.
			workerUrl += (workerUrl.indexOf('?') !== -1 ? '&' : '?') + 'papaworker';
			var w = new global.Worker(workerUrl);
			w.onmessage = mainThreadReceivedMessage;
			w.id = workerIdCounter++;
			workers[w.id] = w;
			return w;
		}
	
		/** Callback when main thread receives a message */
		function mainThreadReceivedMessage(e)
		{
			var msg = e.data;
			var worker = workers[msg.workerId];
			var aborted = false;
	
			if (msg.error)
				worker.userError(msg.error, msg.file);
			else if (msg.results && msg.results.data)
			{
				var abort = function() {
					aborted = true;
					completeWorker(msg.workerId, { data: [], errors: [], meta: { aborted: true } });
				};
	
				var handle = {
					abort: abort,
					pause: notImplemented,
					resume: notImplemented
				};
	
				if (isFunction(worker.userStep))
				{
					for (var i = 0; i < msg.results.data.length; i++)
					{
						worker.userStep({
							data: [msg.results.data[i]],
							errors: msg.results.errors,
							meta: msg.results.meta
						}, handle);
						if (aborted)
							break;
					}
					delete msg.results;	// free memory ASAP
				}
				else if (isFunction(worker.userChunk))
				{
					worker.userChunk(msg.results, handle, msg.file);
					delete msg.results;
				}
			}
	
			if (msg.finished && !aborted)
				completeWorker(msg.workerId, msg.results);
		}
	
		function completeWorker(workerId, results) {
			var worker = workers[workerId];
			if (isFunction(worker.userComplete))
				worker.userComplete(results);
			worker.terminate();
			delete workers[workerId];
		}
	
		function notImplemented() {
			throw "Not implemented.";
		}
	
		/** Callback when worker thread receives a message */
		function workerThreadReceivedMessage(e)
		{
			var msg = e.data;
	
			if (typeof Papa.WORKER_ID === 'undefined' && msg)
				Papa.WORKER_ID = msg.workerId;
	
			if (typeof msg.input === 'string')
			{
				global.postMessage({
					workerId: Papa.WORKER_ID,
					results: Papa.parse(msg.input, msg.config),
					finished: true
				});
			}
			else if ((global.File && msg.input instanceof File) || msg.input instanceof Object)	// thank you, Safari (see issue #106)
			{
				var results = Papa.parse(msg.input, msg.config);
				if (results)
					global.postMessage({
						workerId: Papa.WORKER_ID,
						results: results,
						finished: true
					});
			}
		}
	
		/** Makes a deep copy of an array or object (mostly) */
		function copy(obj)
		{
			if (typeof obj !== 'object')
				return obj;
			var cpy = obj instanceof Array ? [] : {};
			for (var key in obj)
				cpy[key] = copy(obj[key]);
			return cpy;
		}
	
		function bindFunction(f, self)
		{
			return function() { f.apply(self, arguments); };
		}
	
		function isFunction(func)
		{
			return typeof func === 'function';
		}
	})(typeof window !== 'undefined' ? window : this);


/***/ }),
/* 1185 */
/***/ (function(module, exports, __webpack_require__) {

	var moment = module.exports = __webpack_require__(1186);
	moment.tz.load(__webpack_require__(1187));


/***/ }),
/* 1186 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;//! moment-timezone.js
	//! version : 0.5.34
	//! Copyright (c) JS Foundation and other contributors
	//! license : MIT
	//! github.com/moment/moment-timezone
	
	(function (root, factory) {
		"use strict";
	
		/*global define*/
		if (typeof module === 'object' && module.exports) {
			module.exports = factory(__webpack_require__(1021)); // Node
		} else if (true) {
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1021)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));                 // AMD
		} else {
			factory(root.moment);                        // Browser
		}
	}(this, function (moment) {
		"use strict";
	
		// Resolves es6 module loading issue
		if (moment.version === undefined && moment.default) {
			moment = moment.default;
		}
	
		// Do not load moment-timezone a second time.
		// if (moment.tz !== undefined) {
		// 	logError('Moment Timezone ' + moment.tz.version + ' was already loaded ' + (moment.tz.dataVersion ? 'with data from ' : 'without any data') + moment.tz.dataVersion);
		// 	return moment;
		// }
	
		var VERSION = "0.5.34",
			zones = {},
			links = {},
			countries = {},
			names = {},
			guesses = {},
			cachedGuess;
	
		if (!moment || typeof moment.version !== 'string') {
			logError('Moment Timezone requires Moment.js. See https://momentjs.com/timezone/docs/#/use-it/browser/');
		}
	
		var momentVersion = moment.version.split('.'),
			major = +momentVersion[0],
			minor = +momentVersion[1];
	
		// Moment.js version check
		if (major < 2 || (major === 2 && minor < 6)) {
			logError('Moment Timezone requires Moment.js >= 2.6.0. You are using Moment.js ' + moment.version + '. See momentjs.com');
		}
	
		/************************************
			Unpacking
		************************************/
	
		function charCodeToInt(charCode) {
			if (charCode > 96) {
				return charCode - 87;
			} else if (charCode > 64) {
				return charCode - 29;
			}
			return charCode - 48;
		}
	
		function unpackBase60(string) {
			var i = 0,
				parts = string.split('.'),
				whole = parts[0],
				fractional = parts[1] || '',
				multiplier = 1,
				num,
				out = 0,
				sign = 1;
	
			// handle negative numbers
			if (string.charCodeAt(0) === 45) {
				i = 1;
				sign = -1;
			}
	
			// handle digits before the decimal
			for (i; i < whole.length; i++) {
				num = charCodeToInt(whole.charCodeAt(i));
				out = 60 * out + num;
			}
	
			// handle digits after the decimal
			for (i = 0; i < fractional.length; i++) {
				multiplier = multiplier / 60;
				num = charCodeToInt(fractional.charCodeAt(i));
				out += num * multiplier;
			}
	
			return out * sign;
		}
	
		function arrayToInt (array) {
			for (var i = 0; i < array.length; i++) {
				array[i] = unpackBase60(array[i]);
			}
		}
	
		function intToUntil (array, length) {
			for (var i = 0; i < length; i++) {
				array[i] = Math.round((array[i - 1] || 0) + (array[i] * 60000)); // minutes to milliseconds
			}
	
			array[length - 1] = Infinity;
		}
	
		function mapIndices (source, indices) {
			var out = [], i;
	
			for (i = 0; i < indices.length; i++) {
				out[i] = source[indices[i]];
			}
	
			return out;
		}
	
		function unpack (string) {
			var data = string.split('|'),
				offsets = data[2].split(' '),
				indices = data[3].split(''),
				untils  = data[4].split(' ');
	
			arrayToInt(offsets);
			arrayToInt(indices);
			arrayToInt(untils);
	
			intToUntil(untils, indices.length);
	
			return {
				name       : data[0],
				abbrs      : mapIndices(data[1].split(' '), indices),
				offsets    : mapIndices(offsets, indices),
				untils     : untils,
				population : data[5] | 0
			};
		}
	
		/************************************
			Zone object
		************************************/
	
		function Zone (packedString) {
			if (packedString) {
				this._set(unpack(packedString));
			}
		}
	
		Zone.prototype = {
			_set : function (unpacked) {
				this.name       = unpacked.name;
				this.abbrs      = unpacked.abbrs;
				this.untils     = unpacked.untils;
				this.offsets    = unpacked.offsets;
				this.population = unpacked.population;
			},
	
			_index : function (timestamp) {
				var target = +timestamp,
					untils = this.untils,
					i;
	
				for (i = 0; i < untils.length; i++) {
					if (target < untils[i]) {
						return i;
					}
				}
			},
	
			countries : function () {
				var zone_name = this.name;
				return Object.keys(countries).filter(function (country_code) {
					return countries[country_code].zones.indexOf(zone_name) !== -1;
				});
			},
	
			parse : function (timestamp) {
				var target  = +timestamp,
					offsets = this.offsets,
					untils  = this.untils,
					max     = untils.length - 1,
					offset, offsetNext, offsetPrev, i;
	
				for (i = 0; i < max; i++) {
					offset     = offsets[i];
					offsetNext = offsets[i + 1];
					offsetPrev = offsets[i ? i - 1 : i];
	
					if (offset < offsetNext && tz.moveAmbiguousForward) {
						offset = offsetNext;
					} else if (offset > offsetPrev && tz.moveInvalidForward) {
						offset = offsetPrev;
					}
	
					if (target < untils[i] - (offset * 60000)) {
						return offsets[i];
					}
				}
	
				return offsets[max];
			},
	
			abbr : function (mom) {
				return this.abbrs[this._index(mom)];
			},
	
			offset : function (mom) {
				logError("zone.offset has been deprecated in favor of zone.utcOffset");
				return this.offsets[this._index(mom)];
			},
	
			utcOffset : function (mom) {
				return this.offsets[this._index(mom)];
			}
		};
	
		/************************************
			Country object
		************************************/
	
		function Country (country_name, zone_names) {
			this.name = country_name;
			this.zones = zone_names;
		}
	
		/************************************
			Current Timezone
		************************************/
	
		function OffsetAt(at) {
			var timeString = at.toTimeString();
			var abbr = timeString.match(/\([a-z ]+\)/i);
			if (abbr && abbr[0]) {
				// 17:56:31 GMT-0600 (CST)
				// 17:56:31 GMT-0600 (Central Standard Time)
				abbr = abbr[0].match(/[A-Z]/g);
				abbr = abbr ? abbr.join('') : undefined;
			} else {
				// 17:56:31 CST
				// 17:56:31 GMT+0800 (台北標準時間)
				abbr = timeString.match(/[A-Z]{3,5}/g);
				abbr = abbr ? abbr[0] : undefined;
			}
	
			if (abbr === 'GMT') {
				abbr = undefined;
			}
	
			this.at = +at;
			this.abbr = abbr;
			this.offset = at.getTimezoneOffset();
		}
	
		function ZoneScore(zone) {
			this.zone = zone;
			this.offsetScore = 0;
			this.abbrScore = 0;
		}
	
		ZoneScore.prototype.scoreOffsetAt = function (offsetAt) {
			this.offsetScore += Math.abs(this.zone.utcOffset(offsetAt.at) - offsetAt.offset);
			if (this.zone.abbr(offsetAt.at).replace(/[^A-Z]/g, '') !== offsetAt.abbr) {
				this.abbrScore++;
			}
		};
	
		function findChange(low, high) {
			var mid, diff;
	
			while ((diff = ((high.at - low.at) / 12e4 | 0) * 6e4)) {
				mid = new OffsetAt(new Date(low.at + diff));
				if (mid.offset === low.offset) {
					low = mid;
				} else {
					high = mid;
				}
			}
	
			return low;
		}
	
		function userOffsets() {
			var startYear = new Date().getFullYear() - 2,
				last = new OffsetAt(new Date(startYear, 0, 1)),
				offsets = [last],
				change, next, i;
	
			for (i = 1; i < 48; i++) {
				next = new OffsetAt(new Date(startYear, i, 1));
				if (next.offset !== last.offset) {
					change = findChange(last, next);
					offsets.push(change);
					offsets.push(new OffsetAt(new Date(change.at + 6e4)));
				}
				last = next;
			}
	
			for (i = 0; i < 4; i++) {
				offsets.push(new OffsetAt(new Date(startYear + i, 0, 1)));
				offsets.push(new OffsetAt(new Date(startYear + i, 6, 1)));
			}
	
			return offsets;
		}
	
		function sortZoneScores (a, b) {
			if (a.offsetScore !== b.offsetScore) {
				return a.offsetScore - b.offsetScore;
			}
			if (a.abbrScore !== b.abbrScore) {
				return a.abbrScore - b.abbrScore;
			}
			if (a.zone.population !== b.zone.population) {
				return b.zone.population - a.zone.population;
			}
			return b.zone.name.localeCompare(a.zone.name);
		}
	
		function addToGuesses (name, offsets) {
			var i, offset;
			arrayToInt(offsets);
			for (i = 0; i < offsets.length; i++) {
				offset = offsets[i];
				guesses[offset] = guesses[offset] || {};
				guesses[offset][name] = true;
			}
		}
	
		function guessesForUserOffsets (offsets) {
			var offsetsLength = offsets.length,
				filteredGuesses = {},
				out = [],
				i, j, guessesOffset;
	
			for (i = 0; i < offsetsLength; i++) {
				guessesOffset = guesses[offsets[i].offset] || {};
				for (j in guessesOffset) {
					if (guessesOffset.hasOwnProperty(j)) {
						filteredGuesses[j] = true;
					}
				}
			}
	
			for (i in filteredGuesses) {
				if (filteredGuesses.hasOwnProperty(i)) {
					out.push(names[i]);
				}
			}
	
			return out;
		}
	
		function rebuildGuess () {
	
			// use Intl API when available and returning valid time zone
			try {
				var intlName = Intl.DateTimeFormat().resolvedOptions().timeZone;
				if (intlName && intlName.length > 3) {
					var name = names[normalizeName(intlName)];
					if (name) {
						return name;
					}
					logError("Moment Timezone found " + intlName + " from the Intl api, but did not have that data loaded.");
				}
			} catch (e) {
				// Intl unavailable, fall back to manual guessing.
			}
	
			var offsets = userOffsets(),
				offsetsLength = offsets.length,
				guesses = guessesForUserOffsets(offsets),
				zoneScores = [],
				zoneScore, i, j;
	
			for (i = 0; i < guesses.length; i++) {
				zoneScore = new ZoneScore(getZone(guesses[i]), offsetsLength);
				for (j = 0; j < offsetsLength; j++) {
					zoneScore.scoreOffsetAt(offsets[j]);
				}
				zoneScores.push(zoneScore);
			}
	
			zoneScores.sort(sortZoneScores);
	
			return zoneScores.length > 0 ? zoneScores[0].zone.name : undefined;
		}
	
		function guess (ignoreCache) {
			if (!cachedGuess || ignoreCache) {
				cachedGuess = rebuildGuess();
			}
			return cachedGuess;
		}
	
		/************************************
			Global Methods
		************************************/
	
		function normalizeName (name) {
			return (name || '').toLowerCase().replace(/\//g, '_');
		}
	
		function addZone (packed) {
			var i, name, split, normalized;
	
			if (typeof packed === "string") {
				packed = [packed];
			}
	
			for (i = 0; i < packed.length; i++) {
				split = packed[i].split('|');
				name = split[0];
				normalized = normalizeName(name);
				zones[normalized] = packed[i];
				names[normalized] = name;
				addToGuesses(normalized, split[2].split(' '));
			}
		}
	
		function getZone (name, caller) {
	
			name = normalizeName(name);
	
			var zone = zones[name];
			var link;
	
			if (zone instanceof Zone) {
				return zone;
			}
	
			if (typeof zone === 'string') {
				zone = new Zone(zone);
				zones[name] = zone;
				return zone;
			}
	
			// Pass getZone to prevent recursion more than 1 level deep
			if (links[name] && caller !== getZone && (link = getZone(links[name], getZone))) {
				zone = zones[name] = new Zone();
				zone._set(link);
				zone.name = names[name];
				return zone;
			}
	
			return null;
		}
	
		function getNames () {
			var i, out = [];
	
			for (i in names) {
				if (names.hasOwnProperty(i) && (zones[i] || zones[links[i]]) && names[i]) {
					out.push(names[i]);
				}
			}
	
			return out.sort();
		}
	
		function getCountryNames () {
			return Object.keys(countries);
		}
	
		function addLink (aliases) {
			var i, alias, normal0, normal1;
	
			if (typeof aliases === "string") {
				aliases = [aliases];
			}
	
			for (i = 0; i < aliases.length; i++) {
				alias = aliases[i].split('|');
	
				normal0 = normalizeName(alias[0]);
				normal1 = normalizeName(alias[1]);
	
				links[normal0] = normal1;
				names[normal0] = alias[0];
	
				links[normal1] = normal0;
				names[normal1] = alias[1];
			}
		}
	
		function addCountries (data) {
			var i, country_code, country_zones, split;
			if (!data || !data.length) return;
			for (i = 0; i < data.length; i++) {
				split = data[i].split('|');
				country_code = split[0].toUpperCase();
				country_zones = split[1].split(' ');
				countries[country_code] = new Country(
					country_code,
					country_zones
				);
			}
		}
	
		function getCountry (name) {
			name = name.toUpperCase();
			return countries[name] || null;
		}
	
		function zonesForCountry(country, with_offset) {
			country = getCountry(country);
	
			if (!country) return null;
	
			var zones = country.zones.sort();
	
			if (with_offset) {
				return zones.map(function (zone_name) {
					var zone = getZone(zone_name);
					return {
						name: zone_name,
						offset: zone.utcOffset(new Date())
					};
				});
			}
	
			return zones;
		}
	
		function loadData (data) {
			addZone(data.zones);
			addLink(data.links);
			addCountries(data.countries);
			tz.dataVersion = data.version;
		}
	
		function zoneExists (name) {
			if (!zoneExists.didShowError) {
				zoneExists.didShowError = true;
					logError("moment.tz.zoneExists('" + name + "') has been deprecated in favor of !moment.tz.zone('" + name + "')");
			}
			return !!getZone(name);
		}
	
		function needsOffset (m) {
			var isUnixTimestamp = (m._f === 'X' || m._f === 'x');
			return !!(m._a && (m._tzm === undefined) && !isUnixTimestamp);
		}
	
		function logError (message) {
			if (typeof console !== 'undefined' && typeof console.error === 'function') {
				console.error(message);
			}
		}
	
		/************************************
			moment.tz namespace
		************************************/
	
		function tz (input) {
			var args = Array.prototype.slice.call(arguments, 0, -1),
				name = arguments[arguments.length - 1],
				zone = getZone(name),
				out  = moment.utc.apply(null, args);
	
			if (zone && !moment.isMoment(input) && needsOffset(out)) {
				out.add(zone.parse(out), 'minutes');
			}
	
			out.tz(name);
	
			return out;
		}
	
		tz.version      = VERSION;
		tz.dataVersion  = '';
		tz._zones       = zones;
		tz._links       = links;
		tz._names       = names;
		tz._countries	= countries;
		tz.add          = addZone;
		tz.link         = addLink;
		tz.load         = loadData;
		tz.zone         = getZone;
		tz.zoneExists   = zoneExists; // deprecated in 0.1.0
		tz.guess        = guess;
		tz.names        = getNames;
		tz.Zone         = Zone;
		tz.unpack       = unpack;
		tz.unpackBase60 = unpackBase60;
		tz.needsOffset  = needsOffset;
		tz.moveInvalidForward   = true;
		tz.moveAmbiguousForward = false;
		tz.countries    = getCountryNames;
		tz.zonesForCountry = zonesForCountry;
	
		/************************************
			Interface with Moment.js
		************************************/
	
		var fn = moment.fn;
	
		moment.tz = tz;
	
		moment.defaultZone = null;
	
		moment.updateOffset = function (mom, keepTime) {
			var zone = moment.defaultZone,
				offset;
	
			if (mom._z === undefined) {
				if (zone && needsOffset(mom) && !mom._isUTC) {
					mom._d = moment.utc(mom._a)._d;
					mom.utc().add(zone.parse(mom), 'minutes');
				}
				mom._z = zone;
			}
			if (mom._z) {
				offset = mom._z.utcOffset(mom);
				if (Math.abs(offset) < 16) {
					offset = offset / 60;
				}
				if (mom.utcOffset !== undefined) {
					var z = mom._z;
					mom.utcOffset(-offset, keepTime);
					mom._z = z;
				} else {
					mom.zone(offset, keepTime);
				}
			}
		};
	
		fn.tz = function (name, keepTime) {
			if (name) {
				if (typeof name !== 'string') {
					throw new Error('Time zone name must be a string, got ' + name + ' [' + typeof name + ']');
				}
				this._z = getZone(name);
				if (this._z) {
					moment.updateOffset(this, keepTime);
				} else {
					logError("Moment Timezone has no data for " + name + ". See http://momentjs.com/timezone/docs/#/data-loading/.");
				}
				return this;
			}
			if (this._z) { return this._z.name; }
		};
	
		function abbrWrap (old) {
			return function () {
				if (this._z) { return this._z.abbr(this); }
				return old.call(this);
			};
		}
	
		function resetZoneWrap (old) {
			return function () {
				this._z = null;
				return old.apply(this, arguments);
			};
		}
	
		function resetZoneWrap2 (old) {
			return function () {
				if (arguments.length > 0) this._z = null;
				return old.apply(this, arguments);
			};
		}
	
		fn.zoneName  = abbrWrap(fn.zoneName);
		fn.zoneAbbr  = abbrWrap(fn.zoneAbbr);
		fn.utc       = resetZoneWrap(fn.utc);
		fn.local     = resetZoneWrap(fn.local);
		fn.utcOffset = resetZoneWrap2(fn.utcOffset);
	
		moment.tz.setDefault = function(name) {
			if (major < 2 || (major === 2 && minor < 9)) {
				logError('Moment Timezone setDefault() requires Moment.js >= 2.9.0. You are using Moment.js ' + moment.version + '.');
			}
			moment.defaultZone = name ? getZone(name) : null;
			return moment;
		};
	
		// Cloning a moment should include the _z property.
		var momentProperties = moment.momentProperties;
		if (Object.prototype.toString.call(momentProperties) === '[object Array]') {
			// moment 2.8.1+
			momentProperties.push('_z');
			momentProperties.push('_a');
		} else if (momentProperties) {
			// moment 2.7.0
			momentProperties._z = null;
		}
	
		// INJECT DATA
	
		return moment;
	}));


/***/ }),
/* 1187 */
/***/ (function(module, exports) {

	module.exports = {
		"version": "2021e",
		"zones": [
			"Africa/Abidjan|LMT GMT|g.8 0|01|-2ldXH.Q|48e5",
			"Africa/Nairobi|LMT +0230 EAT +0245|-2r.g -2u -30 -2J|012132|-2ua2r.g N6nV.g 3Fbu h1cu dzbJ|47e5",
			"Africa/Algiers|PMT WET WEST CET CEST|-9.l 0 -10 -10 -20|0121212121212121343431312123431213|-2nco9.l cNb9.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 DA0 Imo0 rd0 De0 9Xz0 1fb0 1ap0 16K0 2yo0 mEp0 hwL0 jxA0 11A0 dDd0 17b0 11B0 1cN0 2Dy0 1cN0 1fB0 1cL0|26e5",
			"Africa/Lagos|LMT GMT +0030 WAT|-d.z 0 -u -10|01023|-2B40d.z 7iod.z dnXK.p dLzH.z|17e6",
			"Africa/Bissau|LMT -01 GMT|12.k 10 0|012|-2ldX0 2xoo0|39e4",
			"Africa/Maputo|LMT CAT|-2a.k -20|01|-2GJea.k|26e5",
			"Africa/Cairo|EET EEST|-20 -30|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-1bIO0 vb0 1ip0 11z0 1iN0 1nz0 12p0 1pz0 10N0 1pz0 16p0 1jz0 s3d0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1WL0 rd0 1Rz0 wp0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1qL0 Xd0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1ny0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 WL0 1qN0 Rb0 1wp0 On0 1zd0 Lz0 1EN0 Fb0 c10 8n0 8Nd0 gL0 e10 mn0|15e6",
			"Africa/Casablanca|LMT +00 +01|u.k 0 -10|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-2gMnt.E 130Lt.E rb0 Dd0 dVb0 b6p0 TX0 EoB0 LL0 gnd0 rz0 43d0 AL0 1Nd0 XX0 1Cp0 pz0 dEp0 4mn0 SyN0 AL0 1Nd0 wn0 1FB0 Db0 1zd0 Lz0 1Nf0 wM0 co0 go0 1o00 s00 dA0 vc0 11A0 A00 e00 y00 11A0 uM0 e00 Dc0 11A0 s00 e00 IM0 WM0 mo0 gM0 LA0 WM0 jA0 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0|32e5",
			"Africa/Ceuta|WET WEST CET CEST|0 -10 -10 -20|010101010101010101010232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-25KN0 11z0 drd0 18p0 3HX0 17d0 1fz0 1a10 1io0 1a00 1y7o0 LL0 gnd0 rz0 43d0 AL0 1Nd0 XX0 1Cp0 pz0 dEp0 4VB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|85e3",
			"Africa/El_Aaiun|LMT -01 +00 +01|Q.M 10 0 -10|012323232323232323232323232323232323232323232323232323232323232323232323232323232323|-1rDz7.c 1GVA7.c 6L0 AL0 1Nd0 XX0 1Cp0 pz0 1cBB0 AL0 1Nd0 wn0 1FB0 Db0 1zd0 Lz0 1Nf0 wM0 co0 go0 1o00 s00 dA0 vc0 11A0 A00 e00 y00 11A0 uM0 e00 Dc0 11A0 s00 e00 IM0 WM0 mo0 gM0 LA0 WM0 jA0 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0|20e4",
			"Africa/Johannesburg|SAST SAST SAST|-1u -20 -30|012121|-2GJdu 1Ajdu 1cL0 1cN0 1cL0|84e5",
			"Africa/Juba|LMT CAT CAST EAT|-26.s -20 -30 -30|012121212121212121212121212121212131|-1yW26.s 1zK06.s 16L0 1iN0 17b0 1jd0 17b0 1ip0 17z0 1i10 17X0 1hB0 18n0 1hd0 19b0 1gp0 19z0 1iN0 17b0 1ip0 17z0 1i10 18n0 1hd0 18L0 1gN0 19b0 1gp0 19z0 1iN0 17z0 1i10 17X0 yGd0 PeX0|",
			"Africa/Khartoum|LMT CAT CAST EAT|-2a.8 -20 -30 -30|012121212121212121212121212121212131|-1yW2a.8 1zK0a.8 16L0 1iN0 17b0 1jd0 17b0 1ip0 17z0 1i10 17X0 1hB0 18n0 1hd0 19b0 1gp0 19z0 1iN0 17b0 1ip0 17z0 1i10 18n0 1hd0 18L0 1gN0 19b0 1gp0 19z0 1iN0 17z0 1i10 17X0 yGd0 HjL0|51e5",
			"Africa/Monrovia|MMT MMT GMT|H.8 I.u 0|012|-23Lzg.Q 28G01.m|11e5",
			"Africa/Ndjamena|LMT WAT WAST|-10.c -10 -20|0121|-2le10.c 2J3c0.c Wn0|13e5",
			"Africa/Sao_Tome|LMT GMT WAT|A.J 0 -10|0121|-2le00 4i6N0 2q00|",
			"Africa/Tripoli|LMT CET CEST EET|-Q.I -10 -20 -20|012121213121212121212121213123123|-21JcQ.I 1hnBQ.I vx0 4iP0 xx0 4eN0 Bb0 7ip0 U0n0 A10 1db0 1cN0 1db0 1dd0 1db0 1eN0 1bb0 1e10 1cL0 1c10 1db0 1dd0 1db0 1cN0 1db0 1q10 fAn0 1ep0 1db0 AKq0 TA0 1o00|11e5",
			"Africa/Tunis|PMT CET CEST|-9.l -10 -20|0121212121212121212121212121212121|-2nco9.l 18pa9.l 1qM0 DA0 3Tc0 11B0 1ze0 WM0 7z0 3d0 14L0 1cN0 1f90 1ar0 16J0 1gXB0 WM0 1rA0 11c0 nwo0 Ko0 1cM0 1cM0 1rA0 10M0 zuM0 10N0 1aN0 1qM0 WM0 1qM0 11A0 1o00|20e5",
			"Africa/Windhoek|+0130 SAST SAST CAT WAT|-1u -20 -30 -20 -10|01213434343434343434343434343434343434343434343434343|-2GJdu 1Ajdu 1cL0 1SqL0 9Io0 16P0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0|32e4",
			"America/Adak|NST NWT NPT BST BDT AHST HST HDT|b0 a0 a0 b0 a0 a0 a0 90|012034343434343434343434343434343456767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17SX0 8wW0 iB0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cm0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|326",
			"America/Anchorage|AST AWT APT AHST AHDT YST AKST AKDT|a0 90 90 a0 90 90 90 80|012034343434343434343434343434343456767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17T00 8wX0 iA0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cm0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|30e4",
			"America/Puerto_Rico|AST AWT APT|40 30 30|0120|-17lU0 7XT0 iu0|24e5",
			"America/Araguaina|LMT -03 -02|3c.M 30 20|0121212121212121212121212121212121212121212121212121|-2glwL.c HdKL.c 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 dMN0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 ny10 Lz0|14e4",
			"America/Argentina/Buenos_Aires|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323232323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 A4p0 uL0 1qN0 WL0|",
			"America/Argentina/Catamarca|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323132321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 rlB0 7B0 8zb0 uL0|",
			"America/Argentina/Cordoba|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323132323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 A4p0 uL0 1qN0 WL0|",
			"America/Argentina/Jujuy|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323121323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1ze0 TX0 1ld0 WK0 1wp0 TX0 A4p0 uL0|",
			"America/Argentina/La_Rioja|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323231232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Qn0 qO0 16n0 Rb0 1wp0 TX0 rlB0 7B0 8zb0 uL0|",
			"America/Argentina/Mendoza|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232312121321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1u20 SL0 1vd0 Tb0 1wp0 TW0 ri10 Op0 7TX0 uL0|",
			"America/Argentina/Rio_Gallegos|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 rlB0 7B0 8zb0 uL0|",
			"America/Argentina/Salta|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323231323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 A4p0 uL0|",
			"America/Argentina/San_Juan|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323231232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Qn0 qO0 16n0 Rb0 1wp0 TX0 rld0 m10 8lb0 uL0|",
			"America/Argentina/San_Luis|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323121212321212|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 XX0 1q20 SL0 AN0 vDb0 m10 8lb0 8L0 jd0 1qN0 WL0 1qN0|",
			"America/Argentina/Tucuman|CMT -04 -03 -02|4g.M 40 30 20|0121212121212121212121212121212121212121212323232313232123232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 rlB0 4N0 8BX0 uL0 1qN0 WL0|",
			"America/Argentina/Ushuaia|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 rkN0 8p0 8zb0 uL0|",
			"America/Asuncion|AMT -04 -03|3O.E 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-1x589.k 1DKM9.k 3CL0 3Dd0 10L0 1pB0 10n0 1pB0 10n0 1pB0 1cL0 1dd0 1db0 1dd0 1cL0 1dd0 1cL0 1dd0 1cL0 1dd0 1db0 1dd0 1cL0 1dd0 1cL0 1dd0 1cL0 1dd0 1db0 1dd0 1cL0 1lB0 14n0 1dd0 1cL0 1fd0 WL0 1rd0 1aL0 1dB0 Xz0 1qp0 Xb0 1qN0 10L0 1rB0 TX0 1tB0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 WN0 1qL0 11B0 1nX0 1ip0 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 TX0 1tB0 19X0 1a10 1fz0 1a10 1fz0 1cN0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0|28e5",
			"America/Panama|CMT EST|5j.A 50|01|-2uduE.o|15e5",
			"America/Bahia_Banderas|LMT MST CST PST MDT CDT|71 70 60 80 60 50|0121212131414141414141414141414141414152525252525252525252525252525252525252525252525252525252|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nW0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|84e3",
			"America/Bahia|LMT -03 -02|2y.4 30 20|01212121212121212121212121212121212121212121212121212121212121|-2glxp.U HdLp.U 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 l5B0 Rb0|27e5",
			"America/Barbados|LMT AST ADT -0330|3W.t 40 30 3u|0121213121212121|-2m4k1.v 1eAN1.v RB0 1Bz0 Op0 1rb0 11d0 1jJc0 IL0 1ip0 17b0 1ip0 17b0 1ld0 13b0|28e4",
			"America/Belem|LMT -03 -02|3d.U 30 20|012121212121212121212121212121|-2glwK.4 HdKK.4 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0|20e5",
			"America/Belize|LMT CST -0530 CWT CPT CDT|5Q.M 60 5u 50 50 50|012121212121212121212121212121212121212121212121213412121212121212121212121212121212121212121215151|-2kBu7.c fPA7.c Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu Rcu 7Bt0 Ni0 4nd0 Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu e9Au qn0 lxB0 mn0|57e3",
			"America/Boa_Vista|LMT -04 -03|42.E 40 30|0121212121212121212121212121212121|-2glvV.k HdKV.k 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 smp0 WL0 1tB0 2L0|62e2",
			"America/Bogota|BMT -05 -04|4U.g 50 40|0121|-2eb73.I 38yo3.I 2en0|90e5",
			"America/Boise|PST PDT MST MWT MPT MDT|80 70 70 60 60 60|0101023425252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-261q0 1nX0 11B0 1nX0 8C10 JCL0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 Dd0 1Kn0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|21e4",
			"America/Cambridge_Bay|-00 MST MWT MPT MDDT MDT CST CDT EST|0 70 60 60 50 60 60 50 50|0123141515151515151515151515151515151515151515678651515151515151515151515151515151515151515151515151515151515151515151515151|-21Jc0 RO90 8x20 ix0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11A0 1nX0 2K0 WQ0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|15e2",
			"America/Campo_Grande|LMT -04 -03|3C.s 40 30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glwl.w HdLl.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 1C10 Lz0 1Ip0 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1HB0 FX0|77e4",
			"America/Cancun|LMT CST EST EDT CDT|5L.4 60 50 40 50|0123232341414141414141414141414141414141412|-1UQG0 2q2o0 yLB0 1lb0 14p0 1lb0 14p0 Lz0 xB0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 Dd0|63e4",
			"America/Caracas|CMT -0430 -04|4r.E 4u 40|01212|-2kV7w.k 28KM2.k 1IwOu kqo0|29e5",
			"America/Cayenne|LMT -04 -03|3t.k 40 30|012|-2mrwu.E 2gWou.E|58e3",
			"America/Chicago|CST CDT EST CWT CPT|60 50 50 50 50|01010101010101010101010101010101010102010101010103401010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 1wp0 TX0 WN0 1qL0 1cN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 11B0 1Hz0 14p0 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 RB0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|92e5",
			"America/Chihuahua|LMT MST CST CDT MDT|74.k 70 60 50 60|0121212323241414141414141414141414141414141414141414141414141414141414141414141414141414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 2zQN0 1lb0 14p0 1lb0 14q0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|81e4",
			"America/Costa_Rica|SJMT CST CDT|5A.d 60 50|0121212121|-1Xd6n.L 2lu0n.L Db0 1Kp0 Db0 pRB0 15b0 1kp0 mL0|12e5",
			"America/Phoenix|MST MDT MWT|70 60 60|01010202010|-261r0 1nX0 11B0 1nX0 SgN0 4Al1 Ap0 1db0 SWqX 1cL0|42e5",
			"America/Cuiaba|LMT -04 -03|3I.k 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glwf.E HdLf.E 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 4a10 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1HB0 FX0|54e4",
			"America/Danmarkshavn|LMT -03 -02 GMT|1e.E 30 20 0|01212121212121212121212121212121213|-2a5WJ.k 2z5fJ.k 19U0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 DC0|8",
			"America/Dawson_Creek|PST PDT PWT PPT MST|80 70 70 70 70|0102301010101010101010101010101010101010101010101010101014|-25TO0 1in0 UGp0 8x10 iy0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 ML0|12e3",
			"America/Dawson|YST YDT YWT YPT YDDT PST PDT MST|90 80 80 80 70 80 70 70|010102304056565656565656565656565656565656565656565656565656565656565656565656565656565656567|-25TN0 1in0 1o10 13V0 Ser0 8x00 iz0 LCL0 1fA0 jrA0 fNd0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1z90|13e2",
			"America/Denver|MST MDT MWT MPT|70 60 60 60|01010101023010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261r0 1nX0 11B0 1nX0 11B0 1qL0 WN0 mn0 Ord0 8x20 ix0 LCN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|26e5",
			"America/Detroit|LMT CST EST EWT EPT EDT|5w.b 60 50 40 40 40|0123425252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-2Cgir.N peqr.N 156L0 8x40 iv0 6fd0 11z0 JxX1 SMX 1cN0 1cL0 aW10 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|37e5",
			"America/Edmonton|LMT MST MDT MWT MPT|7x.Q 70 60 60 60|0121212121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2yd4q.8 shdq.8 1in0 17d0 hz0 2dB0 1fz0 1a10 11z0 1qN0 WL0 1qN0 11z0 IGN0 8x20 ix0 3NB0 11z0 XQp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|10e5",
			"America/Eirunepe|LMT -05 -04|4D.s 50 40|0121212121212121212121212121212121|-2glvk.w HdLk.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 dPB0 On0 yTd0 d5X0|31e3",
			"America/El_Salvador|LMT CST CDT|5U.M 60 50|012121|-1XiG3.c 2Fvc3.c WL0 1qN0 WL0|11e5",
			"America/Tijuana|LMT MST PST PDT PWT PPT|7M.4 70 80 70 70 70|012123245232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UQE0 4PX0 8mM0 8lc0 SN0 1cL0 pHB0 83r0 zI0 5O10 1Rz0 cOO0 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 BUp0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|20e5",
			"America/Fort_Nelson|PST PDT PWT PPT MST|80 70 70 70 70|01023010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010104|-25TO0 1in0 UGp0 8x10 iy0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0|39e2",
			"America/Fort_Wayne|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|010101023010101010101010101040454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 QI10 Db0 RB0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 5Tz0 1o10 qLb0 1cL0 1cN0 1cL0 1qhd0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
			"America/Fortaleza|LMT -03 -02|2y 30 20|0121212121212121212121212121212121212121|-2glxq HdLq 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 5z0 2mN0 On0|34e5",
			"America/Glace_Bay|LMT AST ADT AWT APT|3X.M 40 30 30 30|012134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsI0.c CwO0.c 1in0 UGp0 8x50 iu0 iq10 11z0 Jg10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|19e3",
			"America/Godthab|LMT -03 -02|3q.U 30 20|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a5Ux.4 2z5dx.4 19U0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|17e3",
			"America/Goose_Bay|NST NDT NST NDT NWT NPT AST ADT ADDT|3u.Q 2u.Q 3u 2u 2u 2u 40 30 20|010232323232323245232323232323232323232323232323232323232326767676767676767676767676767676767676767676768676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-25TSt.8 1in0 DXb0 2HbX.8 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 WL0 1qN0 WL0 1qN0 7UHu itu 1tB0 WL0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1tB0 WL0 1ld0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 S10 g0u 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14n1 1lb0 14p0 1nW0 11C0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zcX Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|76e2",
			"America/Grand_Turk|KMT EST EDT AST|57.a 50 40 40|0121212121212121212121212121212121212121212121212121212121212121212121212132121212121212121212121212121212121212121|-2l1uQ.O 2HHBQ.O 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 7jA0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|37e2",
			"America/Guatemala|LMT CST CDT|62.4 60 50|0121212121|-24KhV.U 2efXV.U An0 mtd0 Nz0 ifB0 17b0 zDB0 11z0|13e5",
			"America/Guayaquil|QMT -05 -04|5e 50 40|0121|-1yVSK 2uILK rz0|27e5",
			"America/Guyana|LMT -04 -0345 -03|3Q.D 40 3J 30|01231|-2mf87.l 8Hc7.l 2r7bJ Ey0f|80e4",
			"America/Halifax|LMT AST ADT AWT APT|4e.o 40 30 30 30|0121212121212121212121212121212121212121212121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsHJ.A xzzJ.A 1db0 3I30 1in0 3HX0 IL0 1E10 ML0 1yN0 Pb0 1Bd0 Mn0 1Bd0 Rz0 1w10 Xb0 1w10 LX0 1w10 Xb0 1w10 Lz0 1C10 Jz0 1E10 OL0 1yN0 Un0 1qp0 Xb0 1qp0 11X0 1w10 Lz0 1HB0 LX0 1C10 FX0 1w10 Xb0 1qp0 Xb0 1BB0 LX0 1td0 Xb0 1qp0 Xb0 Rf0 8x50 iu0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 3Qp0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 3Qp0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 6i10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|39e4",
			"America/Havana|HMT CST CDT|5t.A 50 40|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1Meuu.o 72zu.o ML0 sld0 An0 1Nd0 Db0 1Nd0 An0 6Ep0 An0 1Nd0 An0 JDd0 Mn0 1Ap0 On0 1fd0 11X0 1qN0 WL0 1wp0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 14n0 1ld0 14L0 1kN0 15b0 1kp0 1cL0 1cN0 1fz0 1a10 1fz0 1fB0 11z0 14p0 1nX0 11B0 1nX0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 14n0 1ld0 14n0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 1a10 1in0 1a10 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 17c0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 11A0 6i00 Rc0 1wo0 U00 1tA0 Rc0 1wo0 U00 1wo0 U00 1zc0 U00 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0|21e5",
			"America/Hermosillo|LMT MST CST PST MDT|7n.Q 70 60 80 60|0121212131414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0|64e4",
			"America/Indiana/Knox|CST CDT CWT CPT EST|60 50 50 50 50|0101023010101010101010101010101010101040101010101010101010101010101010101010101010101010141010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 11z0 1o10 11z0 1o10 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 3Cn0 8wp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 z8o0 1o00 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
			"America/Indiana/Marengo|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|0101023010101010101010104545454545414545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 dyN0 11z0 6fd0 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 jrz0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1VA0 LA0 1BX0 1e6p0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
			"America/Indiana/Petersburg|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010104010101010101010101010141014545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 njX0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 3Fb0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 19co0 1o00 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
			"America/Indiana/Tell_City|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010401054541010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 njX0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 8wn0 1cN0 1cL0 1cN0 1cK0 1cN0 1cL0 1qhd0 1o00 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
			"America/Indiana/Vevay|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|010102304545454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 kPB0 Awn0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1lnd0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
			"America/Indiana/Vincennes|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010101010454541014545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 g0p0 11z0 1o10 11z0 1qL0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 caL0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
			"America/Indiana/Winamac|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010101010101010454541054545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 jrz0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1za0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
			"America/Inuvik|-00 PST PDDT MST MDT|0 80 60 70 60|0121343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-FnA0 tWU0 1fA0 wPe0 2pz0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|35e2",
			"America/Iqaluit|-00 EWT EPT EST EDDT EDT CST CDT|0 40 40 50 30 40 60 50|01234353535353535353535353535353535353535353567353535353535353535353535353535353535353535353535353535353535353535353535353|-16K00 7nX0 iv0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11C0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|67e2",
			"America/Jamaica|KMT EST EDT|57.a 50 40|0121212121212121212121|-2l1uQ.O 2uM1Q.O 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0|94e4",
			"America/Juneau|PST PWT PPT PDT YDT YST AKST AKDT|80 70 70 70 80 90 90 80|01203030303030303030303030403030356767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17T20 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cM0 1cM0 1cL0 1cN0 1fz0 1a10 1fz0 co0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|33e3",
			"America/Kentucky/Louisville|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|0101010102301010101010101010101010101454545454545414545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 3Fd0 Nb0 LPd0 11z0 RB0 8x30 iw0 1nX1 e0X 9vd0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 xz0 gso0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1VA0 LA0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
			"America/Kentucky/Monticello|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|0101023010101010101010101010101010101010101010101010101010101010101010101454545454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 SWp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
			"America/La_Paz|CMT BST -04|4w.A 3w.A 40|012|-1x37r.o 13b0|19e5",
			"America/Lima|LMT -05 -04|58.A 50 40|0121212121212121|-2tyGP.o 1bDzP.o zX0 1aN0 1cL0 1cN0 1cL0 1PrB0 zX0 1O10 zX0 6Gp0 zX0 98p0 zX0|11e6",
			"America/Los_Angeles|PST PDT PWT PPT|80 70 70 70|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261q0 1nX0 11B0 1nX0 SgN0 8x10 iy0 5Wp1 1VaX 3dA0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|15e6",
			"America/Maceio|LMT -03 -02|2m.Q 30 20|012121212121212121212121212121212121212121|-2glxB.8 HdLB.8 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 dMN0 Lz0 8Q10 WL0 1tB0 5z0 2mN0 On0|93e4",
			"America/Managua|MMT CST EST CDT|5J.c 60 50 50|0121313121213131|-1quie.M 1yAMe.M 4mn0 9Up0 Dz0 1K10 Dz0 s3F0 1KH0 DB0 9In0 k8p0 19X0 1o30 11y0|22e5",
			"America/Manaus|LMT -04 -03|40.4 40 30|01212121212121212121212121212121|-2glvX.U HdKX.U 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 dPB0 On0|19e5",
			"America/Martinique|FFMT AST ADT|44.k 40 30|0121|-2mPTT.E 2LPbT.E 19X0|39e4",
			"America/Matamoros|LMT CST CDT|6E 60 50|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1UQG0 2FjC0 1nX0 i6p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|45e4",
			"America/Mazatlan|LMT MST CST PST MDT|75.E 70 60 80 60|0121212131414141414141414141414141414141414141414141414141414141414141414141414141414141414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|44e4",
			"America/Menominee|CST CDT CWT CPT EST|60 50 50 50 50|01010230101041010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 LCN0 1fz0 6410 9Jb0 1cM0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|85e2",
			"America/Merida|LMT CST EST CDT|5W.s 60 50 50|0121313131313131313131313131313131313131313131313131313131313131313131313131313131313131|-1UQG0 2q2o0 2hz0 wu30 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|11e5",
			"America/Metlakatla|PST PWT PPT PDT AKST AKDT|80 70 70 70 90 80|01203030303030303030303030303030304545450454545454545454545454545454545454545454|-17T20 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1hU10 Rd0 1zb0 Op0 1zb0 Op0 1zb0 uM0 jB0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|14e2",
			"America/Mexico_City|LMT MST CST CDT CWT|6A.A 70 60 50 50|012121232324232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 gEn0 TX0 3xd0 Jb0 6zB0 SL0 e5d0 17b0 1Pff0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|20e6",
			"America/Miquelon|LMT AST -03 -02|3I.E 40 30 20|012323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2mKkf.k 2LTAf.k gQ10 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|61e2",
			"America/Moncton|EST AST ADT AWT APT|50 40 30 30 30|012121212121212121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsH0 CwN0 1in0 zAo0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1K10 Lz0 1zB0 NX0 1u10 Wn0 S20 8x50 iu0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 3Cp0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14n1 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 ReX 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|64e3",
			"America/Monterrey|LMT CST CDT|6F.g 60 50|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1UQG0 2FjC0 1nX0 i6p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|41e5",
			"America/Montevideo|LMT MMT -04 -03 -0330 -0230 -02 -0130|3I.P 3I.P 40 30 3u 2u 20 1u|012343434343434343434343435353636353636375363636363636363636363636363636363636363636363|-2tRUf.9 sVc0 8jcf.9 1db0 1dcu 1cLu 1dcu 1cLu ircu 11zu 1o0u 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 1qMu WLu 1fAu 1cLu 1o0u 11zu NAu 3jXu zXu Dq0u 19Xu pcu jz0 cm10 19X0 6tB0 1fbu 3o0u jX0 4vB0 xz0 3Cp0 mmu 1a10 IMu Db0 4c10 uL0 1Nd0 An0 1SN0 uL0 mp0 28L0 iPB0 un0 1SN0 xz0 1zd0 Lz0 1zd0 Rb0 1zd0 On0 1wp0 Rb0 s8p0 1fB0 1ip0 11z0 1ld0 14n0 1o10 11z0 1o10 11z0 1o10 14n0 1ld0 14n0 1ld0 14n0 1o10 11z0 1o10 11z0 1o10 11z0|17e5",
			"America/Toronto|EST EDT EWT EPT|50 40 40 40|01010101010101010101010101010101010101010101012301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TR0 1in0 11Wu 1nzu 1fD0 WJ0 1wr0 Nb0 1Ap0 On0 1zd0 On0 1wp0 TX0 1tB0 TX0 1tB0 TX0 1tB0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 4kM0 8x40 iv0 1o10 11z0 1nX0 11z0 1o10 11z0 1o10 1qL0 11D0 1nX0 11B0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|65e5",
			"America/New_York|EST EDT EWT EPT|50 40 40 40|01010101010101010101010101010101010101010101010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261t0 1nX0 11B0 1nX0 11B0 1qL0 1a10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 RB0 8x40 iv0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|21e6",
			"America/Nipigon|EST EDT EWT EPT|50 40 40 40|010123010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TR0 1in0 Rnb0 3je0 8x40 iv0 19yN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|16e2",
			"America/Nome|NST NWT NPT BST BDT YST AKST AKDT|b0 a0 a0 b0 a0 90 90 80|012034343434343434343434343434343456767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17SX0 8wW0 iB0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cl0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|38e2",
			"America/Noronha|LMT -02 -01|29.E 20 10|0121212121212121212121212121212121212121|-2glxO.k HdKO.k 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 2L0 2pB0 On0|30e2",
			"America/North_Dakota/Beulah|MST MDT MWT MPT CST CDT|70 60 60 60 60 50|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101014545454545454545454545454545454545454545454545454545454|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
			"America/North_Dakota/Center|MST MDT MWT MPT CST CDT|70 60 60 60 60 50|010102301010101010101010101010101010101010101010101010101014545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14o0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
			"America/North_Dakota/New_Salem|MST MDT MWT MPT CST CDT|70 60 60 60 60 50|010102301010101010101010101010101010101010101010101010101010101010101010101010101454545454545454545454545454545454545454545454545454545454545454545454|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14o0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
			"America/Ojinaga|LMT MST CST CDT MDT|6V.E 70 60 50 60|0121212323241414141414141414141414141414141414141414141414141414141414141414141414141414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 2zQN0 1lb0 14p0 1lb0 14q0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e3",
			"America/Pangnirtung|-00 AST AWT APT ADDT ADT EDT EST CST CDT|0 40 30 30 20 30 40 50 60 50|012314151515151515151515151515151515167676767689767676767676767676767676767676767676767676767676767676767676767676767676767|-1XiM0 PnG0 8x50 iu0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1o00 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11C0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|14e2",
			"America/Paramaribo|LMT PMT PMT -0330 -03|3E.E 3E.Q 3E.A 3u 30|01234|-2nDUj.k Wqo0.c qanX.I 1yVXN.o|24e4",
			"America/Port-au-Prince|PPMT EST EDT|4N 50 40|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-28RHb 2FnMb 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14q0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 i6n0 1nX0 11B0 1nX0 d430 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 3iN0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e5",
			"America/Rio_Branco|LMT -05 -04|4v.c 50 40|01212121212121212121212121212121|-2glvs.M HdLs.M 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 NBd0 d5X0|31e4",
			"America/Porto_Velho|LMT -04 -03|4f.A 40 30|012121212121212121212121212121|-2glvI.o HdKI.o 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0|37e4",
			"America/Punta_Arenas|SMT -05 -04 -03|4G.K 50 40 30|0102021212121212121232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-2q2jh.e fJAh.e 5knG.K 1Vzh.e jRAG.K 1pbh.e 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 nHX0 op0 blz0 ko0 Qeo0 WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0|",
			"America/Rainy_River|CST CDT CWT CPT|60 50 50 50|010123010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TQ0 1in0 Rnb0 3je0 8x30 iw0 19yN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|842",
			"America/Rankin_Inlet|-00 CST CDDT CDT EST|0 60 40 50 50|012131313131313131313131313131313131313131313431313131313131313131313131313131313131313131313131313131313131313131313131|-vDc0 keu0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|26e2",
			"America/Recife|LMT -03 -02|2j.A 30 20|0121212121212121212121212121212121212121|-2glxE.o HdLE.o 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 2L0 2pB0 On0|33e5",
			"America/Regina|LMT MST MDT MWT MPT CST|6W.A 70 60 60 60 60|012121212121212121212121341212121212121212121212121215|-2AD51.o uHe1.o 1in0 s2L0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 66N0 1cL0 1cN0 19X0 1fB0 1cL0 1fB0 1cL0 1cN0 1cL0 M30 8x20 ix0 1ip0 1cL0 1ip0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 3NB0 1cL0 1cN0|19e4",
			"America/Resolute|-00 CST CDDT CDT EST|0 60 40 50 50|012131313131313131313131313131313131313131313431313131313431313131313131313131313131313131313131313131313131313131313131|-SnA0 GWS0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|229",
			"America/Santarem|LMT -04 -03|3C.M 40 30|0121212121212121212121212121212|-2glwl.c HdLl.c 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 NBd0|21e4",
			"America/Santiago|SMT -05 -04 -03|4G.K 50 40 30|010202121212121212321232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-2q2jh.e fJAh.e 5knG.K 1Vzh.e jRAG.K 1pbh.e 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 nHX0 op0 9Bz0 jb0 1oN0 ko0 Qeo0 WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1zb0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0|62e5",
			"America/Santo_Domingo|SDMT EST EDT -0430 AST|4E 50 40 4u 40|01213131313131414|-1ttjk 1lJMk Mn0 6sp0 Lbu 1Cou yLu 1RAu wLu 1QMu xzu 1Q0u xXu 1PAu 13jB0 e00|29e5",
			"America/Sao_Paulo|LMT -03 -02|36.s 30 20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glwR.w HdKR.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 pTd0 PX0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 1C10 Lz0 1Ip0 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1HB0 FX0|20e6",
			"America/Scoresbysund|LMT -02 -01 +00|1r.Q 20 10 0|0121323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2a5Ww.8 2z5ew.8 1a00 1cK0 1cL0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|452",
			"America/Sitka|PST PWT PPT PDT YST AKST AKDT|80 70 70 70 90 90 80|01203030303030303030303030303030345656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-17T20 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 co0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|90e2",
			"America/St_Johns|NST NDT NST NDT NWT NPT NDDT|3u.Q 2u.Q 3u 2u 2u 2u 1u|01010101010101010101010101010101010102323232323232324523232323232323232323232323232323232323232323232323232323232323232323232323232323232326232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-28oit.8 14L0 1nB0 1in0 1gm0 Dz0 1JB0 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 1cL0 1fB0 19X0 1fB0 19X0 10O0 eKX.8 19X0 1iq0 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 WL0 1qN0 WL0 1qN0 7UHu itu 1tB0 WL0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1tB0 WL0 1ld0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14n1 1lb0 14p0 1nW0 11C0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zcX Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|11e4",
			"America/Swift_Current|LMT MST MDT MWT MPT CST|7b.k 70 60 60 60 60|012134121212121212121215|-2AD4M.E uHdM.E 1in0 UGp0 8x20 ix0 1o10 17b0 1ip0 11z0 1o10 11z0 1o10 11z0 isN0 1cL0 3Cp0 1cL0 1cN0 11z0 1qN0 WL0 pMp0|16e3",
			"America/Tegucigalpa|LMT CST CDT|5M.Q 60 50|01212121|-1WGGb.8 2ETcb.8 WL0 1qN0 WL0 GRd0 AL0|11e5",
			"America/Thule|LMT AST ADT|4z.8 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a5To.Q 31NBo.Q 1cL0 1cN0 1cL0 1fB0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|656",
			"America/Thunder_Bay|CST EST EWT EPT EDT|60 50 40 40 40|0123141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141|-2q5S0 1iaN0 8x40 iv0 XNB0 1cL0 1cN0 1fz0 1cN0 1cL0 3Cp0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|11e4",
			"America/Vancouver|PST PDT PWT PPT|80 70 70 70|0102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TO0 1in0 UGp0 8x10 iy0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e5",
			"America/Whitehorse|YST YDT YWT YPT YDDT PST PDT MST|90 80 80 80 70 80 70 70|010102304056565656565656565656565656565656565656565656565656565656565656565656565656565656567|-25TN0 1in0 1o10 13V0 Ser0 8x00 iz0 LCL0 1fA0 3NA0 vrd0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1z90|23e3",
			"America/Winnipeg|CST CDT CWT CPT|60 50 50 50|010101023010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aIi0 WL0 3ND0 1in0 Jap0 Rb0 aCN0 8x30 iw0 1tB0 11z0 1ip0 11z0 1o10 11z0 1o10 11z0 1rd0 10L0 1op0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 1cL0 1cN0 11z0 6i10 WL0 6i10 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|66e4",
			"America/Yakutat|YST YWT YPT YDT AKST AKDT|90 80 80 80 90 80|01203030303030303030303030303030304545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-17T10 8x00 iz0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cn0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|642",
			"America/Yellowknife|-00 MST MWT MPT MDDT MDT|0 70 60 60 50 60|012314151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151|-1pdA0 hix0 8x20 ix0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|19e3",
			"Antarctica/Casey|-00 +08 +11|0 -80 -b0|0121212121212|-2q00 1DjS0 T90 40P0 KL0 blz0 3m10 1o30 14k0 1kr0 12l0 1o01|10",
			"Antarctica/Davis|-00 +07 +05|0 -70 -50|01012121|-vyo0 iXt0 alj0 1D7v0 VB0 3Wn0 KN0|70",
			"Pacific/Port_Moresby|+10|-a0|0||25e4",
			"Antarctica/Macquarie|AEST AEDT -00|-a0 -b0 0|010201010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-29E80 1a00 4SK0 1ayy0 Lvs0 1cM0 1o00 Rc0 1wo0 Rc0 1wo0 U00 1wo0 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 3Co0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|1",
			"Antarctica/Mawson|-00 +06 +05|0 -60 -50|012|-CEo0 2fyk0|60",
			"Pacific/Auckland|NZMT NZST NZST NZDT|-bu -cu -c0 -d0|01020202020202020202020202023232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-1GCVu Lz0 1tB0 11zu 1o0u 11zu 1o0u 11zu 1o0u 14nu 1lcu 14nu 1lcu 1lbu 11Au 1nXu 11Au 1nXu 11Au 1nXu 11Au 1nXu 11Au 1qLu WMu 1qLu 11Au 1n1bu IM0 1C00 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1qM0 14o0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1io0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00|14e5",
			"Antarctica/Palmer|-00 -03 -04 -02|0 30 40 20|0121212121213121212121212121212121212121212121212121212121212121212121212121212121|-cao0 nD0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 jsN0 14N0 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0|40",
			"Antarctica/Rothera|-00 -03|0 30|01|gOo0|130",
			"Asia/Riyadh|LMT +03|-36.Q -30|01|-TvD6.Q|57e5",
			"Antarctica/Troll|-00 +00 +02|0 0 -20|01212121212121212121212121212121212121212121212121212121212121212121|1puo0 hd0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|40",
			"Antarctica/Vostok|-00 +06|0 -60|01|-tjA0|25",
			"Europe/Oslo|CET CEST|-10 -20|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2awM0 Qm0 W6o0 5pf0 WM0 1fA0 1cM0 1cM0 1cM0 1cM0 wJc0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1qM0 WM0 zpc0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|62e4",
			"Asia/Almaty|LMT +05 +06 +07|-57.M -50 -60 -70|012323232323232323232321232323232323232323232323232|-1Pc57.M eUo7.M 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0|15e5",
			"Asia/Amman|LMT EET EEST|-2n.I -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1yW2n.I 1HiMn.I KL0 1oN0 11b0 1oN0 11b0 1pd0 1dz0 1cp0 11b0 1op0 11b0 fO10 1db0 1e10 1cL0 1cN0 1cL0 1cN0 1fz0 1pd0 10n0 1ld0 14n0 1hB0 15b0 1ip0 19X0 1cN0 1cL0 1cN0 17b0 1ld0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1So0 y00 1fc0 1dc0 1co0 1dc0 1cM0 1cM0 1cM0 1o00 11A0 1lc0 17c0 1cM0 1cM0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 4bX0 Dd0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 LA0 1C00 LA0 1C00 Oo0 1zc0 Oo0 1C00 LA0 1C00 LA0 1C00 LA0 1C00 LA0 1C00 Oo0 1zc0 Oo0 1C00 LA0 1C00 LA0 1C00 LA0 1C00 LA0 1C00 Oo0 1C00 LA0 1C00|25e5",
			"Asia/Anadyr|LMT +12 +13 +14 +11|-bN.U -c0 -d0 -e0 -b0|01232121212121212121214121212121212121212121212121212121212141|-1PcbN.U eUnN.U 23CL0 1db0 2q10 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|13e3",
			"Asia/Aqtau|LMT +04 +05 +06|-3l.4 -40 -50 -60|012323232323232323232123232312121212121212121212|-1Pc3l.4 eUnl.4 24PX0 2pX0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|15e4",
			"Asia/Aqtobe|LMT +04 +05 +06|-3M.E -40 -50 -60|0123232323232323232321232323232323232323232323232|-1Pc3M.E eUnM.E 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0|27e4",
			"Asia/Ashgabat|LMT +04 +05 +06|-3R.w -40 -50 -60|0123232323232323232323212|-1Pc3R.w eUnR.w 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0|41e4",
			"Asia/Atyrau|LMT +03 +05 +06 +04|-3r.I -30 -50 -60 -40|01232323232323232323242323232323232324242424242|-1Pc3r.I eUor.I 24PW0 2pX0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 2sp0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|",
			"Asia/Baghdad|BMT +03 +04|-2V.A -30 -40|012121212121212121212121212121212121212121212121212121|-26BeV.A 2ACnV.A 11b0 1cp0 1dz0 1dd0 1db0 1cN0 1cp0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1de0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0|66e5",
			"Asia/Qatar|LMT +04 +03|-3q.8 -40 -30|012|-21Jfq.8 27BXq.8|96e4",
			"Asia/Baku|LMT +03 +04 +05|-3j.o -30 -40 -50|01232323232323232323232123232323232323232323232323232323232323232|-1Pc3j.o 1jUoj.o WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cM0 9Je0 1o00 11z0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|27e5",
			"Asia/Bangkok|BMT +07|-6G.4 -70|01|-218SG.4|15e6",
			"Asia/Barnaul|LMT +06 +07 +08|-5z -60 -70 -80|0123232323232323232323212323232321212121212121212121212121212121212|-21S5z pCnz 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 p90 LE0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|",
			"Asia/Beirut|EET EEST|-20 -30|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-21aq0 1on0 1410 1db0 19B0 1in0 1ip0 WL0 1lQp0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 q6N0 En0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1op0 11b0 dA10 17b0 1iN0 17b0 1iN0 17b0 1iN0 17b0 1vB0 SL0 1mp0 13z0 1iN0 17b0 1iN0 17b0 1jd0 12n0 1a10 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0|22e5",
			"Asia/Bishkek|LMT +05 +06 +07|-4W.o -50 -60 -70|012323232323232323232321212121212121212121212121212|-1Pc4W.o eUnW.o 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2e00 1tX0 17b0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1cPu 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0|87e4",
			"Asia/Brunei|LMT +0730 +08|-7D.E -7u -80|012|-1KITD.E gDc9.E|42e4",
			"Asia/Kolkata|MMT IST +0630|-5l.a -5u -6u|012121|-2zOtl.a 1r2LP.a 1un0 HB0 7zX0|15e6",
			"Asia/Chita|LMT +08 +09 +10|-7x.Q -80 -90 -a0|012323232323232323232321232323232323232323232323232323232323232312|-21Q7x.Q pAnx.Q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3re0|33e4",
			"Asia/Choibalsan|LMT +07 +08 +10 +09|-7C -70 -80 -a0 -90|0123434343434343434343434343434343434343434343424242|-2APHC 2UkoC cKn0 1da0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 3Db0 h1f0 1cJ0 1cP0 1cJ0|38e3",
			"Asia/Shanghai|CST CDT|-80 -90|01010101010101010101010101010|-23uw0 18n0 OjB0 Rz0 11d0 1wL0 A10 8HX0 1G10 Tz0 1ip0 1jX0 1cN0 11b0 1oN0 aL0 1tU30 Rb0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0|23e6",
			"Asia/Colombo|MMT +0530 +06 +0630|-5j.w -5u -60 -6u|01231321|-2zOtj.w 1rFbN.w 1zzu 7Apu 23dz0 11zu n3cu|22e5",
			"Asia/Dhaka|HMT +0630 +0530 +06 +07|-5R.k -6u -5u -60 -70|0121343|-18LFR.k 1unn.k HB0 m6n0 2kxbu 1i00|16e6",
			"Asia/Damascus|LMT EET EEST|-2p.c -20 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-21Jep.c Hep.c 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1xRB0 11X0 1oN0 10L0 1pB0 11b0 1oN0 10L0 1mp0 13X0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 Nb0 1AN0 Nb0 bcp0 19X0 1gp0 19X0 3ld0 1xX0 Vd0 1Bz0 Sp0 1vX0 10p0 1dz0 1cN0 1cL0 1db0 1db0 1g10 1an0 1ap0 1db0 1fd0 1db0 1cN0 1db0 1dd0 1db0 1cp0 1dz0 1c10 1dX0 1cN0 1db0 1dd0 1db0 1cN0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1db0 1cN0 1db0 1cN0 19z0 1fB0 1qL0 11B0 1on0 Wp0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0|26e5",
			"Asia/Dili|LMT +08 +09|-8m.k -80 -90|01212|-2le8m.k 1dnXm.k 1nfA0 Xld0|19e4",
			"Asia/Dubai|LMT +04|-3F.c -40|01|-21JfF.c|39e5",
			"Asia/Dushanbe|LMT +05 +06 +07|-4z.c -50 -60 -70|012323232323232323232321|-1Pc4z.c eUnz.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2hB0|76e4",
			"Asia/Famagusta|LMT EET EEST +03|-2f.M -20 -30 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212312121212121212121212121212121212121212121|-1Vc2f.M 2a3cf.M 1cL0 1qp0 Xz0 19B0 19X0 1fB0 1db0 1cp0 1cL0 1fB0 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1o30 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 15U0 2Ks0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|",
			"Asia/Gaza|EET EEST IST IDT|-20 -30 -20 -30|010101010101010101010101010101010123232323232323232323232323232320101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-1c2o0 MM0 iM0 4JA0 10o0 1pA0 10M0 1pA0 16o0 1jA0 16o0 1jA0 pBa0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 dW0 hfB0 Db0 1fB0 Rb0 bXB0 gM0 8Q00 IM0 1wo0 TX0 1HB0 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 M10 C00 17c0 1io0 17c0 1io0 17c0 1o00 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 17c0 1io0 18N0 1bz0 19z0 1gp0 1610 1iL0 11z0 1o10 14o0 1lA1 SKX 1xd1 MKX 1AN0 1a00 1fA0 1cL0 1cN0 1nX0 1210 1nA0 1210 1qL0 WN0 1qL0 WN0 1qL0 11c0 1on0 11B0 1o00 11A0 1qo0 Xc0 1qo0 Xc0 1qo0 1200 1nA0 1200 1qo0 Xc0 1qo0 Xc0 1qo0 Xc0 1qo0 Xc0 1qo0 1200 1nA0 1200 1qo0 Xc0 1qo0 Xc0 1qo0 Xc0 1qo0 Xc0 1qo0 1200 1qo0 Xc0 1qo0|18e5",
			"Asia/Hebron|EET EEST IST IDT|-20 -30 -20 -30|01010101010101010101010101010101012323232323232323232323232323232010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-1c2o0 MM0 iM0 4JA0 10o0 1pA0 10M0 1pA0 16o0 1jA0 16o0 1jA0 pBa0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 dW0 hfB0 Db0 1fB0 Rb0 bXB0 gM0 8Q00 IM0 1wo0 TX0 1HB0 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 M10 C00 17c0 1io0 17c0 1io0 17c0 1o00 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 17c0 1io0 18N0 1bz0 19z0 1gp0 1610 1iL0 12L0 1mN0 14o0 1lc0 Tb0 1xd1 MKX bB0 cn0 1cN0 1a00 1fA0 1cL0 1cN0 1nX0 1210 1nA0 1210 1qL0 WN0 1qL0 WN0 1qL0 11c0 1on0 11B0 1o00 11A0 1qo0 Xc0 1qo0 Xc0 1qo0 1200 1nA0 1200 1qo0 Xc0 1qo0 Xc0 1qo0 Xc0 1qo0 Xc0 1qo0 1200 1nA0 1200 1qo0 Xc0 1qo0 Xc0 1qo0 Xc0 1qo0 Xc0 1qo0 1200 1qo0 Xc0 1qo0|25e4",
			"Asia/Ho_Chi_Minh|LMT PLMT +07 +08 +09|-76.E -76.u -70 -80 -90|0123423232|-2yC76.E bK00.a 1h7b6.u 5lz0 18o0 3Oq0 k5b0 aW00 BAM0|90e5",
			"Asia/Hong_Kong|LMT HKT HKST HKWT JST|-7A.G -80 -90 -8u -90|0123412121212121212121212121212121212121212121212121212121212121212121|-2CFH0 1taO0 Hc0 xUu 9tBu 11z0 1tDu Rc0 1wo0 11A0 1cM0 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1nX0 U10 1tz0 U10 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 Rd0 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 17d0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1cL0 6fd0 14n0|73e5",
			"Asia/Hovd|LMT +06 +07 +08|-66.A -60 -70 -80|012323232323232323232323232323232323232323232323232|-2APG6.A 2Uko6.A cKn0 1db0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 kEp0 1cJ0 1cP0 1cJ0|81e3",
			"Asia/Irkutsk|IMT +07 +08 +09|-6V.5 -70 -80 -90|01232323232323232323232123232323232323232323232323232323232323232|-21zGV.5 pjXV.5 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|60e4",
			"Europe/Istanbul|IMT EET EEST +03 +04|-1U.U -20 -30 -30 -40|0121212121212121212121212121212121212121212121234312121212121212121212121212121212121212121212121212121212121212123|-2ogNU.U dzzU.U 11b0 8tB0 1on0 1410 1db0 19B0 1in0 3Rd0 Un0 1oN0 11b0 zSN0 CL0 mp0 1Vz0 1gN0 8yn0 1yp0 ML0 1kp0 17b0 1ip0 17b0 1fB0 19X0 1ip0 19X0 1ip0 17b0 qdB0 38L0 1jd0 Tz0 l6O0 11A0 WN0 1qL0 TB0 1tX0 U10 1tz0 11B0 1in0 17d0 z90 cne0 pb0 2Cp0 1800 14o0 1dc0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1a00 1fA0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WO0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 Xc0 1qo0 WM0 1qM0 11A0 1o00 1200 1nA0 11A0 1tA0 U00 15w0|13e6",
			"Asia/Jakarta|BMT +0720 +0730 +09 +08 WIB|-77.c -7k -7u -90 -80 -70|01232425|-1Q0Tk luM0 mPzO 8vWu 6kpu 4PXu xhcu|31e6",
			"Asia/Jayapura|LMT +09 +0930 WIT|-9m.M -90 -9u -90|0123|-1uu9m.M sMMm.M L4nu|26e4",
			"Asia/Jerusalem|JMT IST IDT IDDT|-2k.E -20 -30 -40|01212121212121321212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-26Bek.E SyOk.E MM0 iM0 4JA0 10o0 1pA0 10M0 1pA0 16o0 1jA0 16o0 1jA0 3LA0 Eo0 oo0 1co0 1dA0 16o0 10M0 1jc0 1tA0 14o0 1cM0 1a00 11A0 1Nc0 Ao0 1Nc0 Ao0 1Ko0 LA0 1o00 WM0 EQK0 Db0 1fB0 Rb0 bXB0 gM0 8Q00 IM0 1wo0 TX0 1HB0 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 1hB0 1dX0 1ep0 1aL0 1eN0 17X0 1nf0 11z0 1tB0 19W0 1e10 17b0 1ep0 1gL0 18N0 1fz0 1eN0 17b0 1gq0 1gn0 19d0 1dz0 1c10 17X0 1hB0 1gn0 19d0 1dz0 1c10 17X0 1kp0 1dz0 1c10 1aL0 1eN0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0|81e4",
			"Asia/Kabul|+04 +0430|-40 -4u|01|-10Qs0|46e5",
			"Asia/Kamchatka|LMT +11 +12 +13|-ay.A -b0 -c0 -d0|012323232323232323232321232323232323232323232323232323232323212|-1SLKy.A ivXy.A 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|18e4",
			"Asia/Karachi|LMT +0530 +0630 +05 PKT PKST|-4s.c -5u -6u -50 -50 -60|012134545454|-2xoss.c 1qOKW.c 7zX0 eup0 LqMu 1fy00 1cL0 dK10 11b0 1610 1jX0|24e6",
			"Asia/Urumqi|LMT +06|-5O.k -60|01|-1GgtO.k|32e5",
			"Asia/Kathmandu|LMT +0530 +0545|-5F.g -5u -5J|012|-21JhF.g 2EGMb.g|12e5",
			"Asia/Khandyga|LMT +08 +09 +10 +11|-92.d -80 -90 -a0 -b0|0123232323232323232323212323232323232323232323232343434343434343432|-21Q92.d pAp2.d 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 qK0 yN0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 17V0 7zD0|66e2",
			"Asia/Krasnoyarsk|LMT +06 +07 +08|-6b.q -60 -70 -80|01232323232323232323232123232323232323232323232323232323232323232|-21Hib.q prAb.q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|10e5",
			"Asia/Kuala_Lumpur|SMT +07 +0720 +0730 +09 +08|-6T.p -70 -7k -7u -90 -80|0123435|-2Bg6T.p 17anT.p l5XE 17bO 8Fyu 1so1u|71e5",
			"Asia/Kuching|LMT +0730 +08 +0820 +09|-7l.k -7u -80 -8k -90|0123232323232323242|-1KITl.k gDbP.k 6ynu AnE 1O0k AnE 1NAk AnE 1NAk AnE 1NAk AnE 1O0k AnE 1NAk AnE pAk 8Fz0|13e4",
			"Asia/Macau|LMT CST +09 +10 CDT|-7y.a -80 -90 -a0 -90|012323214141414141414141414141414141414141414141414141414141414141414141|-2CFHy.a 1uqKy.a PX0 1kn0 15B0 11b0 4Qq0 1oM0 11c0 1ko0 1u00 11A0 1cM0 11c0 1o00 11A0 1o00 11A0 1oo0 1400 1o00 11A0 1o00 U00 1tA0 U00 1wo0 Rc0 1wru U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 Rd0 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 17d0 1cK0 1cO0 1cK0 1cO0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1cL0 6fd0 14n0|57e4",
			"Asia/Magadan|LMT +10 +11 +12|-a3.c -a0 -b0 -c0|012323232323232323232321232323232323232323232323232323232323232312|-1Pca3.c eUo3.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3Cq0|95e3",
			"Asia/Makassar|LMT MMT +08 +09 WITA|-7V.A -7V.A -80 -90 -80|01234|-21JjV.A vfc0 myLV.A 8ML0|15e5",
			"Asia/Manila|PST PDT JST|-80 -90 -90|010201010|-1kJI0 AL0 cK10 65X0 mXB0 vX0 VK10 1db0|24e6",
			"Asia/Nicosia|LMT EET EEST|-2d.s -20 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1Vc2d.s 2a3cd.s 1cL0 1qp0 Xz0 19B0 19X0 1fB0 1db0 1cp0 1cL0 1fB0 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1o30 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|32e4",
			"Asia/Novokuznetsk|LMT +06 +07 +08|-5M.M -60 -70 -80|012323232323232323232321232323232323232323232323232323232323212|-1PctM.M eULM.M 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|55e4",
			"Asia/Novosibirsk|LMT +06 +07 +08|-5v.E -60 -70 -80|0123232323232323232323212323212121212121212121212121212121212121212|-21Qnv.E pAFv.E 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 ml0 Os0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 4eN0|15e5",
			"Asia/Omsk|LMT +05 +06 +07|-4R.u -50 -60 -70|01232323232323232323232123232323232323232323232323232323232323232|-224sR.u pMLR.u 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|12e5",
			"Asia/Oral|LMT +03 +05 +06 +04|-3p.o -30 -50 -60 -40|01232323232323232424242424242424242424242424242|-1Pc3p.o eUop.o 23CK0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 1cM0 IM0 1EM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|27e4",
			"Asia/Pontianak|LMT PMT +0730 +09 +08 WITA WIB|-7h.k -7h.k -7u -90 -80 -80 -70|012324256|-2ua7h.k XE00 munL.k 8Rau 6kpu 4PXu xhcu Wqnu|23e4",
			"Asia/Pyongyang|LMT KST JST KST|-8n -8u -90 -90|012313|-2um8n 97XR 1lTzu 2Onc0 6BA0|29e5",
			"Asia/Qostanay|LMT +04 +05 +06|-4e.s -40 -50 -60|012323232323232323232123232323232323232323232323|-1Pc4e.s eUoe.s 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|",
			"Asia/Qyzylorda|LMT +04 +05 +06|-4l.Q -40 -50 -60|01232323232323232323232323232323232323232323232|-1Pc4l.Q eUol.Q 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 3ao0 1EM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 zQl0|73e4",
			"Asia/Rangoon|RMT +0630 +09|-6o.L -6u -90|0121|-21Jio.L SmnS.L 7j9u|48e5",
			"Asia/Sakhalin|LMT +09 +11 +12 +10|-9u.M -90 -b0 -c0 -a0|01232323232323232323232423232323232424242424242424242424242424242|-2AGVu.M 1BoMu.M 1qFa0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 2pB0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|58e4",
			"Asia/Samarkand|LMT +04 +05 +06|-4r.R -40 -50 -60|01232323232323232323232|-1Pc4r.R eUor.R 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0|36e4",
			"Asia/Seoul|LMT KST JST KST KDT KDT|-8r.Q -8u -90 -90 -a0 -9u|012343434343151515151515134343|-2um8r.Q 97XV.Q 1m1zu 6CM0 Fz0 1kN0 14n0 1kN0 14L0 1zd0 On0 69B0 2I0u OL0 1FB0 Rb0 1qN0 TX0 1tB0 TX0 1tB0 TX0 1tB0 TX0 2ap0 12FBu 11A0 1o00 11A0|23e6",
			"Asia/Srednekolymsk|LMT +10 +11 +12|-ae.Q -a0 -b0 -c0|01232323232323232323232123232323232323232323232323232323232323232|-1Pcae.Q eUoe.Q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|35e2",
			"Asia/Taipei|CST JST CDT|-80 -90 -90|01020202020202020202020202020202020202020|-1iw80 joM0 1yo0 Tz0 1ip0 1jX0 1cN0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 10N0 1BX0 10p0 1pz0 10p0 1pz0 10p0 1db0 1dd0 1db0 1cN0 1db0 1cN0 1db0 1cN0 1db0 1BB0 ML0 1Bd0 ML0 uq10 1db0 1cN0 1db0 97B0 AL0|74e5",
			"Asia/Tashkent|LMT +05 +06 +07|-4B.b -50 -60 -70|012323232323232323232321|-1Pc4B.b eUnB.b 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0|23e5",
			"Asia/Tbilisi|TBMT +03 +04 +05|-2X.b -30 -40 -50|0123232323232323232323212121232323232323232323212|-1Pc2X.b 1jUnX.b WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cK0 1cL0 1cN0 1cL0 1cN0 2pz0 1cL0 1fB0 3Nz0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 An0 Os0 WM0|11e5",
			"Asia/Tehran|LMT TMT +0330 +04 +05 +0430|-3p.I -3p.I -3u -40 -50 -4u|01234325252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-2btDp.I 1d3c0 1huLT.I TXu 1pz0 sN0 vAu 1cL0 1dB0 1en0 pNB0 UL0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 64p0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0|14e6",
			"Asia/Thimphu|LMT +0530 +06|-5W.A -5u -60|012|-Su5W.A 1BGMs.A|79e3",
			"Asia/Tokyo|JST JDT|-90 -a0|010101010|-QJJ0 Rc0 1lc0 14o0 1zc0 Oo0 1zc0 Oo0|38e6",
			"Asia/Tomsk|LMT +06 +07 +08|-5D.P -60 -70 -80|0123232323232323232323212323232323232323232323212121212121212121212|-21NhD.P pxzD.P 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 co0 1bB0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3Qp0|10e5",
			"Asia/Ulaanbaatar|LMT +07 +08 +09|-77.w -70 -80 -90|012323232323232323232323232323232323232323232323232|-2APH7.w 2Uko7.w cKn0 1db0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 kEp0 1cJ0 1cP0 1cJ0|12e5",
			"Asia/Ust-Nera|LMT +08 +09 +12 +11 +10|-9w.S -80 -90 -c0 -b0 -a0|012343434343434343434345434343434343434343434343434343434343434345|-21Q9w.S pApw.S 23CL0 1d90 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 17V0 7zD0|65e2",
			"Asia/Vladivostok|LMT +09 +10 +11|-8L.v -90 -a0 -b0|01232323232323232323232123232323232323232323232323232323232323232|-1SJIL.v itXL.v 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|60e4",
			"Asia/Yakutsk|LMT +08 +09 +10|-8C.W -80 -90 -a0|01232323232323232323232123232323232323232323232323232323232323232|-21Q8C.W pAoC.W 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|28e4",
			"Asia/Yekaterinburg|LMT PMT +04 +05 +06|-42.x -3J.5 -40 -50 -60|012343434343434343434343234343434343434343434343434343434343434343|-2ag42.x 7mQh.s qBvJ.5 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|14e5",
			"Asia/Yerevan|LMT +03 +04 +05|-2W -30 -40 -50|0123232323232323232323212121212323232323232323232323232323232|-1Pc2W 1jUnW WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 4RX0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|13e5",
			"Atlantic/Azores|HMT -02 -01 +00 WET|1S.w 20 10 0 0|0121212121212121212121212121212121212121212123212321232123212121212121212121212121212121212121212121232323232323232323232323232323234323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2ldW0 aPX0 Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 qIl0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cL0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|25e4",
			"Atlantic/Bermuda|BMT BST AST ADT|4j.i 3j.i 40 30|010102323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-28p7E.G 1bb0 1i10 11X0 ru30 thbE.G 1PX0 11B0 1tz0 Rd0 1zb0 Op0 1zb0 3I10 Lz0 1EN0 FX0 1HB0 FX0 1Kp0 Db0 1Kp0 Db0 1Kp0 FX0 93d0 11z0 GAp0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|65e3",
			"Atlantic/Canary|LMT -01 WET WEST|11.A 10 0 -10|01232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UtaW.o XPAW.o 1lAK0 1a10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|54e4",
			"Atlantic/Cape_Verde|LMT -02 -01|1y.4 20 10|01212|-2ldW0 1eEo0 7zX0 1djf0|50e4",
			"Atlantic/Faroe|LMT WET WEST|r.4 0 -10|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2uSnw.U 2Wgow.U 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|49e3",
			"Atlantic/Madeira|FMT -01 +00 +01 WET WEST|17.A 10 0 -10 0 -10|0121212121212121212121212121212121212121212123212321232123212121212121212121212121212121212121212121454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-2ldX0 aPX0 Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 qIl0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|27e4",
			"Atlantic/Reykjavik|LMT -01 +00 GMT|1s 10 0 0|012121212121212121212121212121212121212121212121212121212121212121213|-2uWmw mfaw 1Bd0 ML0 1LB0 Cn0 1LB0 3fX0 C10 HrX0 1cO0 LB0 1EL0 LA0 1C00 Oo0 1wo0 Rc0 1wo0 Rc0 1wo0 Rc0 1zc0 Oo0 1zc0 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1lc0 14o0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 14o0|12e4",
			"Atlantic/South_Georgia|-02|20|0||30",
			"Atlantic/Stanley|SMT -04 -03 -02|3P.o 40 30 20|012121212121212323212121212121212121212121212121212121212121212121212|-2kJw8.A 12bA8.A 19X0 1fB0 19X0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 Cn0 1Cc10 WL0 1qL0 U10 1tz0 2mN0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1tz0 U10 1tz0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1tz0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qN0 U10 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 U10 1tz0 U10 1tz0 U10|21e2",
			"Australia/Sydney|AEST AEDT|-a0 -b0|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293k0 xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 14o0 1o00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 11A0 1o00 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|40e5",
			"Australia/Adelaide|ACST ACDT|-9u -au|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293ju xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 Oo0 1zc0 WM0 1qM0 Rc0 1zc0 U00 1tA0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|11e5",
			"Australia/Brisbane|AEST AEDT|-a0 -b0|01010101010101010|-293k0 xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 H1A0 Oo0 1zc0 Oo0 1zc0 Oo0|20e5",
			"Australia/Broken_Hill|ACST ACDT|-9u -au|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293ju xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 14o0 1o00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|18e3",
			"Australia/Hobart|AEST AEDT|-a0 -b0|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-29E80 1a00 1qM0 Oo0 1zc0 Oo0 TAo0 yM0 1cM0 1cM0 1fA0 1a00 VfA0 1cM0 1o00 Rc0 1wo0 Rc0 1wo0 U00 1wo0 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|21e4",
			"Australia/Darwin|ACST ACDT|-9u -au|010101010|-293ju xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00|12e4",
			"Australia/Eucla|+0845 +0945|-8J -9J|0101010101010101010|-293iJ xc0 10jc0 yM0 1cM0 1cM0 1gSo0 Oo0 l5A0 Oo0 iJA0 G00 zU00 IM0 1qM0 11A0 1o00 11A0|368",
			"Australia/Lord_Howe|AEST +1030 +1130 +11|-a0 -au -bu -b0|0121212121313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313|raC0 1zdu Rb0 1zd0 On0 1zd0 On0 1zd0 On0 1zd0 TXu 1qMu WLu 1tAu WLu 1tAu TXu 1tAu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu 11zu 1o0u 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 11Au 1nXu 1qMu 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 1qMu 11zu 1o0u WLu 1qMu 14nu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu|347",
			"Australia/Lindeman|AEST AEDT|-a0 -b0|010101010101010101010|-293k0 xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 H1A0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0|10",
			"Australia/Melbourne|AEST AEDT|-a0 -b0|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293k0 xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1qM0 11A0 1tA0 U00 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 11A0 1o00 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|39e5",
			"Australia/Perth|AWST AWDT|-80 -90|0101010101010101010|-293i0 xc0 10jc0 yM0 1cM0 1cM0 1gSo0 Oo0 l5A0 Oo0 iJA0 G00 zU00 IM0 1qM0 11A0 1o00 11A0|18e5",
			"CET|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|",
			"Pacific/Easter|EMT -07 -06 -05|7h.s 70 60 50|012121212121212121212121212123232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-1uSgG.w 1s4IG.w WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 2pA0 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1zb0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0|30e2",
			"CST6CDT|CST CDT CWT CPT|60 50 50 50|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
			"EET|EET EEST|-20 -30|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|hDB0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|",
			"Europe/Dublin|DMT IST GMT BST IST|p.l -y.D 0 -10 -10|01232323232324242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242|-2ax9y.D Rc0 1fzy.D 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 g600 14o0 1wo0 17c0 1io0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1a00 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1tA0 IM0 90o0 U00 1tA0 U00 1tA0 U00 1tA0 U00 1tA0 WM0 1qM0 WM0 1qM0 WM0 1tA0 U00 1tA0 U00 1tA0 11z0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5",
			"EST|EST|50|0||",
			"EST5EDT|EST EDT EWT EPT|50 40 40 40|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261t0 1nX0 11B0 1nX0 SgN0 8x40 iv0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
			"Etc/GMT-0|GMT|0|0||",
			"Etc/GMT-1|+01|-10|0||",
			"Etc/GMT-11|+11|-b0|0||",
			"Pacific/Tarawa|+12|-c0|0||29e3",
			"Etc/GMT-13|+13|-d0|0||",
			"Etc/GMT-14|+14|-e0|0||",
			"Etc/GMT-2|+02|-20|0||",
			"Etc/GMT-3|+03|-30|0||",
			"Etc/GMT-4|+04|-40|0||",
			"Etc/GMT-5|+05|-50|0||",
			"Etc/GMT-6|+06|-60|0||",
			"Indian/Christmas|+07|-70|0||21e2",
			"Etc/GMT-8|+08|-80|0||",
			"Pacific/Palau|+09|-90|0||21e3",
			"Etc/GMT+1|-01|10|0||",
			"Etc/GMT+10|-10|a0|0||",
			"Etc/GMT+11|-11|b0|0||",
			"Etc/GMT+12|-12|c0|0||",
			"Etc/GMT+3|-03|30|0||",
			"Etc/GMT+4|-04|40|0||",
			"Etc/GMT+5|-05|50|0||",
			"Etc/GMT+6|-06|60|0||",
			"Etc/GMT+7|-07|70|0||",
			"Etc/GMT+8|-08|80|0||",
			"Etc/GMT+9|-09|90|0||",
			"Etc/UTC|UTC|0|0||",
			"Europe/Amsterdam|AMT NST +0120 +0020 CEST CET|-j.w -1j.w -1k -k -20 -10|010101010101010101010101010101010101010101012323234545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545|-2aFcj.w 11b0 1iP0 11A0 1io0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1co0 1io0 1yo0 Pc0 1a00 1fA0 1Bc0 Mo0 1tc0 Uo0 1tA0 U00 1uo0 W00 1s00 VA0 1so0 Vc0 1sM0 UM0 1wo0 Rc0 1u00 Wo0 1rA0 W00 1s00 VA0 1sM0 UM0 1w00 fV0 BCX.w 1tA0 U00 1u00 Wo0 1sm0 601k WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|16e5",
			"Europe/Andorra|WET CET CEST|0 -10 -20|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-UBA0 1xIN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|79e3",
			"Europe/Astrakhan|LMT +03 +04 +05|-3c.c -30 -40 -50|012323232323232323212121212121212121212121212121212121212121212|-1Pcrc.c eUMc.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|10e5",
			"Europe/Athens|AMT EET EEST CEST CET|-1y.Q -20 -30 -20 -10|012123434121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a61x.Q CNbx.Q mn0 kU10 9b0 3Es0 Xa0 1fb0 1dd0 k3X0 Nz0 SCp0 1vc0 SO0 1cM0 1a00 1ao0 1fc0 1a10 1fG0 1cg0 1dX0 1bX0 1cQ0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|35e5",
			"Europe/London|GMT BST BDST|0 -10 -20|0101010101010101010101010101010101010101010101010121212121210101210101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2axa0 Rc0 1fA0 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 2Rz0 Dc0 1zc0 Oo0 1zc0 Rc0 1wo0 17c0 1iM0 FA0 xB0 1fA0 1a00 14o0 bb0 LA0 xB0 Rc0 1wo0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1a00 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1tA0 IM0 90o0 U00 1tA0 U00 1tA0 U00 1tA0 U00 1tA0 WM0 1qM0 WM0 1qM0 WM0 1tA0 U00 1tA0 U00 1tA0 11z0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|10e6",
			"Europe/Belgrade|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-19RC0 3IP0 WM0 1fA0 1cM0 1cM0 1rc0 Qo0 1vmo0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5",
			"Europe/Berlin|CET CEST CEMT|-10 -20 -30|01010101010101210101210101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 kL0 Nc0 m10 WM0 1ao0 1cp0 dX0 jz0 Dd0 1io0 17c0 1fA0 1a00 1ehA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|41e5",
			"Europe/Prague|CET CEST GMT|-10 -20 0|01010101010101010201010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 1cM0 1qM0 11c0 mp0 xA0 mn0 17c0 1io0 17c0 1fc0 1ao0 1bNc0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|13e5",
			"Europe/Brussels|WET CET CEST WEST|0 -10 -20 -10|0121212103030303030303030303030303030303030303030303212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2ehc0 3zX0 11c0 1iO0 11A0 1o00 11A0 my0 Ic0 1qM0 Rc0 1EM0 UM0 1u00 10o0 1io0 1io0 17c0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a30 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 y00 5Wn0 WM0 1fA0 1cM0 16M0 1iM0 16M0 1C00 Uo0 1eeo0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|21e5",
			"Europe/Bucharest|BMT EET EEST|-1I.o -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1xApI.o 20LI.o RA0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Axc0 On0 1fA0 1a10 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cK0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cL0 1cN0 1cL0 1fB0 1nX0 11E0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|19e5",
			"Europe/Budapest|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 1oo0 11c0 1lc0 17c0 O1V0 3Nf0 WM0 1fA0 1cM0 1cM0 1oJ0 1dd0 1020 1fX0 1cp0 1cM0 1cM0 1cM0 1fA0 1a00 bhy0 Rb0 1wr0 Rc0 1C00 LA0 1C00 LA0 SNW0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cO0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|17e5",
			"Europe/Zurich|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-19Lc0 11A0 1o00 11A0 1xG10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|38e4",
			"Europe/Chisinau|CMT BMT EET EEST CEST CET MSK MSD|-1T -1I.o -20 -30 -20 -10 -30 -40|012323232323232323234545467676767676767676767323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-26jdT wGMa.A 20LI.o RA0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 27A0 2en0 39g0 WM0 1fA0 1cM0 V90 1t7z0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 gL0 WO0 1cM0 1cM0 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1nX0 11D0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|67e4",
			"Europe/Copenhagen|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2azC0 Tz0 VuO0 60q0 WM0 1fA0 1cM0 1cM0 1cM0 S00 1HA0 Nc0 1C00 Dc0 1Nc0 Ao0 1h5A0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5",
			"Europe/Gibraltar|GMT BST BDST CET CEST|0 -10 -20 -10 -20|010101010101010101010101010101010101010101010101012121212121010121010101010101010101034343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-2axa0 Rc0 1fA0 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 2Rz0 Dc0 1zc0 Oo0 1zc0 Rc0 1wo0 17c0 1iM0 FA0 xB0 1fA0 1a00 14o0 bb0 LA0 xB0 Rc0 1wo0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 10Jz0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|30e3",
			"Europe/Helsinki|HMT EET EEST|-1D.N -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1WuND.N OULD.N 1dA0 1xGq0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5",
			"Europe/Kaliningrad|CET CEST EET EEST MSK MSD +03|-10 -20 -20 -30 -30 -40 -30|01010101010101232454545454545454543232323232323232323232323232323232323232323262|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 390 7A0 1en0 12N0 1pbb0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|44e4",
			"Europe/Kiev|KMT EET MSK CEST CET MSD EEST|-22.4 -20 -30 -20 -10 -40 -30|0123434252525252525252525256161616161616161616161616161616161616161616161616161616161616161616161616161616161616161616161|-1Pc22.4 eUo2.4 rnz0 2Hg0 WM0 1fA0 da0 1v4m0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 Db0 3220 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cQ0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|34e5",
			"Europe/Kirov|LMT +03 +04 +05|-3i.M -30 -40 -50|01232323232323232321212121212121212121212121212121212121212121|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|48e4",
			"Europe/Lisbon|LMT WET WEST WEMT CET CEST|A.J 0 -10 -20 -10 -20|01212121212121212121212121212121212121212121232123212321232121212121212121212121212121212121212121214121212121212121212121212121212124545454212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2le00 aPX0 Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 pvy0 1cM0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|27e5",
			"Europe/Luxembourg|LMT CET CEST WET WEST WEST WET|-o.A -10 -20 0 -10 -20 -10|0121212134343434343434343434343434343434343434343434565651212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2DG0o.A t6mo.A TB0 1nX0 Up0 1o20 11A0 rW0 CM0 1qP0 R90 1EO0 UK0 1u20 10m0 1ip0 1in0 17e0 19W0 1fB0 1db0 1cp0 1in0 17d0 1fz0 1a10 1in0 1a10 1in0 17f0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 vA0 60L0 WM0 1fA0 1cM0 17c0 1io0 16M0 1C00 Uo0 1eeo0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|54e4",
			"Europe/Madrid|WET WEST WEMT CET CEST|0 -10 -20 -10 -20|010101010101010101210343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-25Td0 19B0 1cL0 1dd0 b1z0 18p0 3HX0 17d0 1fz0 1a10 1io0 1a00 1in0 17d0 iIn0 Hd0 1cL0 bb0 1200 2s20 14n0 5aL0 Mp0 1vz0 17d0 1in0 17d0 1in0 17d0 1in0 17d0 6hX0 11B0 XHX0 1a10 1fz0 1a10 19X0 1cN0 1fz0 1a10 1fC0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|62e5",
			"Europe/Malta|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2arB0 Lz0 1cN0 1db0 1410 1on0 Wp0 1qL0 17d0 1cL0 M3B0 5M20 WM0 1fA0 1co0 17c0 1iM0 16m0 1de0 1lc0 14m0 1lc0 WO0 1qM0 GTW0 On0 1C10 LA0 1C00 LA0 1EM0 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1co0 1cM0 1lA0 Xc0 1qq0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1iN0 19z0 1fB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|42e4",
			"Europe/Minsk|MMT EET MSK CEST CET MSD EEST +03|-1O -20 -30 -20 -10 -40 -30 -30|01234343252525252525252525261616161616161616161616161616161616161617|-1Pc1O eUnO qNX0 3gQ0 WM0 1fA0 1cM0 Al0 1tsn0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 3Fc0 1cN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0|19e5",
			"Europe/Monaco|PMT WET WEST WEMT CET CEST|-9.l 0 -10 -20 -10 -20|01212121212121212121212121212121212121212121212121232323232345454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-2n5c9.l cFX9.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 1u00 10o0 1io0 1wo0 Rc0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Df0 2RV0 11z0 11B0 1ze0 WM0 1fA0 1cM0 1fa0 1aq0 16M0 1ekn0 1cL0 1fC0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|38e3",
			"Europe/Moscow|MMT MMT MST MDST MSD MSK +05 EET EEST MSK|-2u.h -2v.j -3v.j -4v.j -40 -30 -50 -20 -30 -40|012132345464575454545454545454545458754545454545454545454545454545454545454595|-2ag2u.h 2pyW.W 1bA0 11X0 GN0 1Hb0 c4v.j ik0 3DA0 dz0 15A0 c10 2q10 iM10 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|16e6",
			"Europe/Paris|PMT WET WEST CEST CET WEMT|-9.l 0 -10 -20 -10 -20|0121212121212121212121212121212121212121212121212123434352543434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-2nco9.l cNb9.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 1u00 10o0 1io0 1wo0 Rc0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Df0 Ik0 5M30 WM0 1fA0 1cM0 Vx0 hB0 1aq0 16M0 1ekn0 1cL0 1fC0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|11e6",
			"Europe/Riga|RMT LST EET MSK CEST CET MSD EEST|-1A.y -2A.y -20 -30 -20 -10 -40 -30|010102345454536363636363636363727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272|-25TzA.y 11A0 1iM0 ko0 gWm0 yDXA.y 2bX0 3fE0 WM0 1fA0 1cM0 1cM0 4m0 1sLy0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 1o00 11A0 1o00 11A0 1qM0 3oo0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|64e4",
			"Europe/Rome|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2arB0 Lz0 1cN0 1db0 1410 1on0 Wp0 1qL0 17d0 1cL0 M3B0 5M20 WM0 1fA0 1cM0 16M0 1iM0 16m0 1de0 1lc0 14m0 1lc0 WO0 1qM0 GTW0 On0 1C10 LA0 1C00 LA0 1EM0 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1C00 LA0 1zc0 Oo0 1C00 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1zc0 Oo0 1fC0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|39e5",
			"Europe/Samara|LMT +03 +04 +05|-3k.k -30 -40 -50|0123232323232323232121232323232323232323232323232323232323212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 2y10 14m0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|12e5",
			"Europe/Saratov|LMT +03 +04 +05|-34.i -30 -40 -50|012323232323232321212121212121212121212121212121212121212121212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1cM0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 5810|",
			"Europe/Simferopol|SMT EET MSK CEST CET MSD EEST MSK|-2g -20 -30 -20 -10 -40 -30 -40|012343432525252525252525252161616525252616161616161616161616161616161616172|-1Pc2g eUog rEn0 2qs0 WM0 1fA0 1cM0 3V0 1u0L0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Q00 4eL0 1cL0 1cN0 1cL0 1cN0 dX0 WL0 1cN0 1cL0 1fB0 1o30 11B0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11z0 1nW0|33e4",
			"Europe/Sofia|EET CET CEST EEST|-20 -10 -20 -30|01212103030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030|-168L0 WM0 1fA0 1cM0 1cM0 1cN0 1mKH0 1dd0 1fb0 1ap0 1fb0 1a20 1fy0 1a30 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1nX0 11E0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5",
			"Europe/Stockholm|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2azC0 TB0 2yDe0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|15e5",
			"Europe/Tallinn|TMT CET CEST EET MSK MSD EEST|-1D -10 -20 -20 -30 -40 -30|012103421212454545454545454546363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363|-26oND teD 11A0 1Ta0 4rXl KSLD 2FX0 2Jg0 WM0 1fA0 1cM0 18J0 1sTX0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o10 11A0 1qM0 5QM0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|41e4",
			"Europe/Tirane|LMT CET CEST|-1j.k -10 -20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glBj.k 14pcj.k 5LC0 WM0 4M0 1fCK0 10n0 1op0 11z0 1pd0 11z0 1qN0 WL0 1qp0 Xb0 1qp0 Xb0 1qp0 11z0 1lB0 11z0 1qN0 11z0 1iN0 16n0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|42e4",
			"Europe/Ulyanovsk|LMT +03 +04 +05 +02|-3d.A -30 -40 -50 -20|01232323232323232321214121212121212121212121212121212121212121212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|13e5",
			"Europe/Uzhgorod|CET CEST MSK MSD EET EEST|-10 -20 -30 -40 -20 -30|010101023232323232323232320454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-1cqL0 6i00 WM0 1fA0 1cM0 1ml0 1Cp0 1r3W0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Q00 1Nf0 2pw0 1cL0 1cN0 1cL0 1cN0 1cL0 1cQ0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|11e4",
			"Europe/Vienna|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 3KM0 14o0 LA00 6i00 WM0 1fA0 1cM0 1cM0 1cM0 400 2qM0 1ao0 1co0 1cM0 1io0 17c0 1gHa0 19X0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|18e5",
			"Europe/Vilnius|WMT KMT CET EET MSK CEST MSD EEST|-1o -1z.A -10 -20 -30 -20 -40 -30|012324525254646464646464646473737373737373737352537373737373737373737373737373737373737373737373737373737373737373737373|-293do 6ILM.o 1Ooz.A zz0 Mfd0 29W0 3is0 WM0 1fA0 1cM0 LV0 1tgL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11B0 1o00 11A0 1qM0 8io0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|54e4",
			"Europe/Volgograd|LMT +03 +04 +05|-2V.E -30 -40 -50|0123232323232323212121212121212121212121212121212121212121212121|-21IqV.E psLV.E 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1cM0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 9Jd0 5gn0|10e5",
			"Europe/Warsaw|WMT CET CEST EET EEST|-1o -10 -20 -20 -30|012121234312121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2ctdo 1LXo 11d0 1iO0 11A0 1o00 11A0 1on0 11A0 6zy0 HWP0 5IM0 WM0 1fA0 1cM0 1dz0 1mL0 1en0 15B0 1aq0 1nA0 11A0 1io0 17c0 1fA0 1a00 iDX0 LA0 1cM0 1cM0 1C00 Oo0 1cM0 1cM0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1C00 LA0 uso0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|17e5",
			"Europe/Zaporozhye|+0220 EET MSK CEST CET MSD EEST|-2k -20 -30 -20 -10 -40 -30|01234342525252525252525252526161616161616161616161616161616161616161616161616161616161616161616161616161616161616161616161|-1Pc2k eUok rdb0 2RE0 WM0 1fA0 8m0 1v9a0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cK0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cQ0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|77e4",
			"HST|HST|a0|0||",
			"Indian/Chagos|LMT +05 +06|-4N.E -50 -60|012|-2xosN.E 3AGLN.E|30e2",
			"Indian/Cocos|+0630|-6u|0||596",
			"Indian/Kerguelen|-00 +05|0 -50|01|-MG00|130",
			"Indian/Mahe|LMT +04|-3F.M -40|01|-2xorF.M|79e3",
			"Indian/Maldives|MMT +05|-4S -50|01|-olgS|35e4",
			"Indian/Mauritius|LMT +04 +05|-3O -40 -50|012121|-2xorO 34unO 14L0 12kr0 11z0|15e4",
			"Indian/Reunion|LMT +04|-3F.Q -40|01|-2mDDF.Q|84e4",
			"Pacific/Kwajalein|+11 +10 +09 -12 +12|-b0 -a0 -90 c0 -c0|012034|-1kln0 akp0 6Up0 12ry0 Wan0|14e3",
			"MET|MET MEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|",
			"MST|MST|70|0||",
			"MST7MDT|MST MDT MWT MPT|70 60 60 60|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
			"Pacific/Chatham|+1215 +1245 +1345|-cf -cJ -dJ|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-WqAf 1adef IM0 1C00 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1qM0 14o0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1io0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00|600",
			"Pacific/Apia|LMT -1130 -11 -10 +14 +13|bq.U bu b0 a0 -e0 -d0|01232345454545454545454545|-2nDMx.4 1yW03.4 2rRbu 1ff0 1a00 CI0 AQ0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0|37e3",
			"Pacific/Bougainville|+10 +09 +11|-a0 -90 -b0|0102|-16Wy0 7CN0 2MQp0|18e4",
			"Pacific/Chuuk|+10 +09|-a0 -90|01010|-2ewy0 axB0 RVX0 axd0|49e3",
			"Pacific/Efate|LMT +11 +12|-bd.g -b0 -c0|012121212121212121212121|-2l9nd.g 2uNXd.g Dc0 n610 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 Lz0 1Nd0 An0|66e3",
			"Pacific/Enderbury|-00 -12 -11 +13|0 c0 b0 -d0|0123|-1iIo0 1GsA0 B7X0|1",
			"Pacific/Fakaofo|-11 +13|b0 -d0|01|1Gfn0|483",
			"Pacific/Fiji|LMT +12 +13|-bT.I -c0 -d0|01212121212121212121212121212121212121212121212121212121212121|-2bUzT.I 3m8NT.I LA0 1EM0 IM0 nJc0 LA0 1o00 Rc0 1wo0 Ao0 1Nc0 Ao0 1Q00 xz0 1SN0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 20o0 pc0 2hc0 bc0 4q00 pc0 20o0 pc0 20o0 pc0 20o0 s00 1VA0 s00 20o0 pc0 20o0 pc0 20o0 pc0 20o0 pc0 20o0 s00 20o0 pc0 20o0 pc0 20o0 pc0 20o0 pc0 20o0 s00 1VA0 s00|88e4",
			"Pacific/Galapagos|LMT -05 -06|5W.o 50 60|01212|-1yVS1.A 2dTz1.A gNd0 rz0|25e3",
			"Pacific/Gambier|LMT -09|8X.M 90|01|-2jof0.c|125",
			"Pacific/Guadalcanal|LMT +11|-aD.M -b0|01|-2joyD.M|11e4",
			"Pacific/Guam|GST +09 GDT ChST|-a0 -90 -b0 -a0|01020202020202020203|-18jK0 6pB0 AhB0 3QL0 g2p0 3p91 WOX rX0 1zd0 Rb0 1wp0 Rb0 5xd0 rX0 5sN0 zb1 1C0X On0 ULb0|17e4",
			"Pacific/Honolulu|HST HDT HWT HPT HST|au 9u 9u 9u a0|0102304|-1thLu 8x0 lef0 8wWu iAu 46p0|37e4",
			"Pacific/Kiritimati|-1040 -10 +14|aE a0 -e0|012|nIaE B7Xk|51e2",
			"Pacific/Kosrae|+11 +09 +10 +12|-b0 -90 -a0 -c0|01021030|-2ewz0 axC0 HBy0 akp0 axd0 WOK0 1bdz0|66e2",
			"Pacific/Majuro|+11 +09 +10 +12|-b0 -90 -a0 -c0|0102103|-2ewz0 axC0 HBy0 akp0 6RB0 12um0|28e3",
			"Pacific/Marquesas|LMT -0930|9i 9u|01|-2joeG|86e2",
			"Pacific/Pago_Pago|LMT SST|bm.M b0|01|-2nDMB.c|37e2",
			"Pacific/Nauru|LMT +1130 +09 +12|-b7.E -bu -90 -c0|01213|-1Xdn7.E QCnB.E 7mqu 1lnbu|10e3",
			"Pacific/Niue|LMT -1120 -11|bj.E bk b0|012|-FScE.k suo0.k|12e2",
			"Pacific/Norfolk|+1112 +1130 +1230 +11 +12|-bc -bu -cu -b0 -c0|012134343434343434343434343434343434343434|-Kgbc W01G Oo0 1COo0 9Jcu 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|25e4",
			"Pacific/Noumea|LMT +11 +12|-b5.M -b0 -c0|01212121|-2l9n5.M 2EqM5.M xX0 1PB0 yn0 HeP0 Ao0|98e3",
			"Pacific/Pitcairn|-0830 -08|8u 80|01|18Vku|56",
			"Pacific/Pohnpei|+11 +09 +10|-b0 -90 -a0|010210|-2ewz0 axC0 HBy0 akp0 axd0|34e3",
			"Pacific/Rarotonga|LMT -1030 -0930 -10|aD.4 au 9u a0|0123232323232323232323232323|-FSdk.U 13tbO.U IL0 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu Onu|13e3",
			"Pacific/Tahiti|LMT -10|9W.g a0|01|-2joe1.I|18e4",
			"Pacific/Tongatapu|LMT +1220 +13 +14|-cj.c -ck -d0 -e0|01232323232|-XbMj.c BgLX.c 1yndk 15A0 1wo0 xz0 1Q10 xz0 zWN0 s00|75e3",
			"PST8PDT|PST PDT PWT PPT|80 70 70 70|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261q0 1nX0 11B0 1nX0 SgN0 8x10 iy0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
			"WET|WET WEST|0 -10|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|hDB0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|"
		],
		"links": [
			"Africa/Abidjan|Africa/Accra",
			"Africa/Abidjan|Africa/Bamako",
			"Africa/Abidjan|Africa/Banjul",
			"Africa/Abidjan|Africa/Conakry",
			"Africa/Abidjan|Africa/Dakar",
			"Africa/Abidjan|Africa/Freetown",
			"Africa/Abidjan|Africa/Lome",
			"Africa/Abidjan|Africa/Nouakchott",
			"Africa/Abidjan|Africa/Ouagadougou",
			"Africa/Abidjan|Africa/Timbuktu",
			"Africa/Abidjan|Atlantic/St_Helena",
			"Africa/Cairo|Egypt",
			"Africa/Johannesburg|Africa/Maseru",
			"Africa/Johannesburg|Africa/Mbabane",
			"Africa/Lagos|Africa/Bangui",
			"Africa/Lagos|Africa/Brazzaville",
			"Africa/Lagos|Africa/Douala",
			"Africa/Lagos|Africa/Kinshasa",
			"Africa/Lagos|Africa/Libreville",
			"Africa/Lagos|Africa/Luanda",
			"Africa/Lagos|Africa/Malabo",
			"Africa/Lagos|Africa/Niamey",
			"Africa/Lagos|Africa/Porto-Novo",
			"Africa/Maputo|Africa/Blantyre",
			"Africa/Maputo|Africa/Bujumbura",
			"Africa/Maputo|Africa/Gaborone",
			"Africa/Maputo|Africa/Harare",
			"Africa/Maputo|Africa/Kigali",
			"Africa/Maputo|Africa/Lubumbashi",
			"Africa/Maputo|Africa/Lusaka",
			"Africa/Nairobi|Africa/Addis_Ababa",
			"Africa/Nairobi|Africa/Asmara",
			"Africa/Nairobi|Africa/Asmera",
			"Africa/Nairobi|Africa/Dar_es_Salaam",
			"Africa/Nairobi|Africa/Djibouti",
			"Africa/Nairobi|Africa/Kampala",
			"Africa/Nairobi|Africa/Mogadishu",
			"Africa/Nairobi|Indian/Antananarivo",
			"Africa/Nairobi|Indian/Comoro",
			"Africa/Nairobi|Indian/Mayotte",
			"Africa/Tripoli|Libya",
			"America/Adak|America/Atka",
			"America/Adak|US/Aleutian",
			"America/Anchorage|US/Alaska",
			"America/Argentina/Buenos_Aires|America/Buenos_Aires",
			"America/Argentina/Catamarca|America/Argentina/ComodRivadavia",
			"America/Argentina/Catamarca|America/Catamarca",
			"America/Argentina/Cordoba|America/Cordoba",
			"America/Argentina/Cordoba|America/Rosario",
			"America/Argentina/Jujuy|America/Jujuy",
			"America/Argentina/Mendoza|America/Mendoza",
			"America/Chicago|US/Central",
			"America/Denver|America/Shiprock",
			"America/Denver|Navajo",
			"America/Denver|US/Mountain",
			"America/Detroit|US/Michigan",
			"America/Edmonton|Canada/Mountain",
			"America/Fort_Wayne|America/Indiana/Indianapolis",
			"America/Fort_Wayne|America/Indianapolis",
			"America/Fort_Wayne|US/East-Indiana",
			"America/Godthab|America/Nuuk",
			"America/Halifax|Canada/Atlantic",
			"America/Havana|Cuba",
			"America/Indiana/Knox|America/Knox_IN",
			"America/Indiana/Knox|US/Indiana-Starke",
			"America/Jamaica|Jamaica",
			"America/Kentucky/Louisville|America/Louisville",
			"America/Los_Angeles|US/Pacific",
			"America/Manaus|Brazil/West",
			"America/Mazatlan|Mexico/BajaSur",
			"America/Mexico_City|Mexico/General",
			"America/New_York|US/Eastern",
			"America/Noronha|Brazil/DeNoronha",
			"America/Panama|America/Atikokan",
			"America/Panama|America/Cayman",
			"America/Panama|America/Coral_Harbour",
			"America/Phoenix|America/Creston",
			"America/Phoenix|US/Arizona",
			"America/Puerto_Rico|America/Anguilla",
			"America/Puerto_Rico|America/Antigua",
			"America/Puerto_Rico|America/Aruba",
			"America/Puerto_Rico|America/Blanc-Sablon",
			"America/Puerto_Rico|America/Curacao",
			"America/Puerto_Rico|America/Dominica",
			"America/Puerto_Rico|America/Grenada",
			"America/Puerto_Rico|America/Guadeloupe",
			"America/Puerto_Rico|America/Kralendijk",
			"America/Puerto_Rico|America/Lower_Princes",
			"America/Puerto_Rico|America/Marigot",
			"America/Puerto_Rico|America/Montserrat",
			"America/Puerto_Rico|America/Port_of_Spain",
			"America/Puerto_Rico|America/St_Barthelemy",
			"America/Puerto_Rico|America/St_Kitts",
			"America/Puerto_Rico|America/St_Lucia",
			"America/Puerto_Rico|America/St_Thomas",
			"America/Puerto_Rico|America/St_Vincent",
			"America/Puerto_Rico|America/Tortola",
			"America/Puerto_Rico|America/Virgin",
			"America/Regina|Canada/Saskatchewan",
			"America/Rio_Branco|America/Porto_Acre",
			"America/Rio_Branco|Brazil/Acre",
			"America/Santiago|Chile/Continental",
			"America/Sao_Paulo|Brazil/East",
			"America/St_Johns|Canada/Newfoundland",
			"America/Tijuana|America/Ensenada",
			"America/Tijuana|America/Santa_Isabel",
			"America/Tijuana|Mexico/BajaNorte",
			"America/Toronto|America/Montreal",
			"America/Toronto|America/Nassau",
			"America/Toronto|Canada/Eastern",
			"America/Vancouver|Canada/Pacific",
			"America/Whitehorse|Canada/Yukon",
			"America/Winnipeg|Canada/Central",
			"Asia/Ashgabat|Asia/Ashkhabad",
			"Asia/Bangkok|Asia/Phnom_Penh",
			"Asia/Bangkok|Asia/Vientiane",
			"Asia/Dhaka|Asia/Dacca",
			"Asia/Dubai|Asia/Muscat",
			"Asia/Ho_Chi_Minh|Asia/Saigon",
			"Asia/Hong_Kong|Hongkong",
			"Asia/Jerusalem|Asia/Tel_Aviv",
			"Asia/Jerusalem|Israel",
			"Asia/Kathmandu|Asia/Katmandu",
			"Asia/Kolkata|Asia/Calcutta",
			"Asia/Kuala_Lumpur|Asia/Singapore",
			"Asia/Kuala_Lumpur|Singapore",
			"Asia/Macau|Asia/Macao",
			"Asia/Makassar|Asia/Ujung_Pandang",
			"Asia/Nicosia|Europe/Nicosia",
			"Asia/Qatar|Asia/Bahrain",
			"Asia/Rangoon|Asia/Yangon",
			"Asia/Riyadh|Antarctica/Syowa",
			"Asia/Riyadh|Asia/Aden",
			"Asia/Riyadh|Asia/Kuwait",
			"Asia/Seoul|ROK",
			"Asia/Shanghai|Asia/Chongqing",
			"Asia/Shanghai|Asia/Chungking",
			"Asia/Shanghai|Asia/Harbin",
			"Asia/Shanghai|PRC",
			"Asia/Taipei|ROC",
			"Asia/Tehran|Iran",
			"Asia/Thimphu|Asia/Thimbu",
			"Asia/Tokyo|Japan",
			"Asia/Ulaanbaatar|Asia/Ulan_Bator",
			"Asia/Urumqi|Asia/Kashgar",
			"Atlantic/Faroe|Atlantic/Faeroe",
			"Atlantic/Reykjavik|Iceland",
			"Atlantic/South_Georgia|Etc/GMT+2",
			"Australia/Adelaide|Australia/South",
			"Australia/Brisbane|Australia/Queensland",
			"Australia/Broken_Hill|Australia/Yancowinna",
			"Australia/Darwin|Australia/North",
			"Australia/Hobart|Australia/Currie",
			"Australia/Hobart|Australia/Tasmania",
			"Australia/Lord_Howe|Australia/LHI",
			"Australia/Melbourne|Australia/Victoria",
			"Australia/Perth|Australia/West",
			"Australia/Sydney|Australia/ACT",
			"Australia/Sydney|Australia/Canberra",
			"Australia/Sydney|Australia/NSW",
			"Etc/GMT-0|Etc/GMT",
			"Etc/GMT-0|Etc/GMT+0",
			"Etc/GMT-0|Etc/GMT0",
			"Etc/GMT-0|Etc/Greenwich",
			"Etc/GMT-0|GMT",
			"Etc/GMT-0|GMT+0",
			"Etc/GMT-0|GMT-0",
			"Etc/GMT-0|GMT0",
			"Etc/GMT-0|Greenwich",
			"Etc/UTC|Etc/UCT",
			"Etc/UTC|Etc/Universal",
			"Etc/UTC|Etc/Zulu",
			"Etc/UTC|UCT",
			"Etc/UTC|UTC",
			"Etc/UTC|Universal",
			"Etc/UTC|Zulu",
			"Europe/Belgrade|Europe/Ljubljana",
			"Europe/Belgrade|Europe/Podgorica",
			"Europe/Belgrade|Europe/Sarajevo",
			"Europe/Belgrade|Europe/Skopje",
			"Europe/Belgrade|Europe/Zagreb",
			"Europe/Chisinau|Europe/Tiraspol",
			"Europe/Dublin|Eire",
			"Europe/Helsinki|Europe/Mariehamn",
			"Europe/Istanbul|Asia/Istanbul",
			"Europe/Istanbul|Turkey",
			"Europe/Lisbon|Portugal",
			"Europe/London|Europe/Belfast",
			"Europe/London|Europe/Guernsey",
			"Europe/London|Europe/Isle_of_Man",
			"Europe/London|Europe/Jersey",
			"Europe/London|GB",
			"Europe/London|GB-Eire",
			"Europe/Moscow|W-SU",
			"Europe/Oslo|Arctic/Longyearbyen",
			"Europe/Oslo|Atlantic/Jan_Mayen",
			"Europe/Prague|Europe/Bratislava",
			"Europe/Rome|Europe/San_Marino",
			"Europe/Rome|Europe/Vatican",
			"Europe/Warsaw|Poland",
			"Europe/Zurich|Europe/Busingen",
			"Europe/Zurich|Europe/Vaduz",
			"Indian/Christmas|Etc/GMT-7",
			"Pacific/Auckland|Antarctica/McMurdo",
			"Pacific/Auckland|Antarctica/South_Pole",
			"Pacific/Auckland|NZ",
			"Pacific/Chatham|NZ-CHAT",
			"Pacific/Chuuk|Pacific/Truk",
			"Pacific/Chuuk|Pacific/Yap",
			"Pacific/Easter|Chile/EasterIsland",
			"Pacific/Enderbury|Pacific/Kanton",
			"Pacific/Guam|Pacific/Saipan",
			"Pacific/Honolulu|Pacific/Johnston",
			"Pacific/Honolulu|US/Hawaii",
			"Pacific/Kwajalein|Kwajalein",
			"Pacific/Pago_Pago|Pacific/Midway",
			"Pacific/Pago_Pago|Pacific/Samoa",
			"Pacific/Pago_Pago|US/Samoa",
			"Pacific/Palau|Etc/GMT-9",
			"Pacific/Pohnpei|Pacific/Ponape",
			"Pacific/Port_Moresby|Antarctica/DumontDUrville",
			"Pacific/Port_Moresby|Etc/GMT-10",
			"Pacific/Tarawa|Etc/GMT-12",
			"Pacific/Tarawa|Pacific/Funafuti",
			"Pacific/Tarawa|Pacific/Wake",
			"Pacific/Tarawa|Pacific/Wallis"
		],
		"countries": [
			"AD|Europe/Andorra",
			"AE|Asia/Dubai",
			"AF|Asia/Kabul",
			"AG|America/Port_of_Spain America/Antigua",
			"AI|America/Port_of_Spain America/Anguilla",
			"AL|Europe/Tirane",
			"AM|Asia/Yerevan",
			"AO|Africa/Lagos Africa/Luanda",
			"AQ|Antarctica/Casey Antarctica/Davis Antarctica/DumontDUrville Antarctica/Mawson Antarctica/Palmer Antarctica/Rothera Antarctica/Syowa Antarctica/Troll Antarctica/Vostok Pacific/Auckland Antarctica/McMurdo",
			"AR|America/Argentina/Buenos_Aires America/Argentina/Cordoba America/Argentina/Salta America/Argentina/Jujuy America/Argentina/Tucuman America/Argentina/Catamarca America/Argentina/La_Rioja America/Argentina/San_Juan America/Argentina/Mendoza America/Argentina/San_Luis America/Argentina/Rio_Gallegos America/Argentina/Ushuaia",
			"AS|Pacific/Pago_Pago",
			"AT|Europe/Vienna",
			"AU|Australia/Lord_Howe Antarctica/Macquarie Australia/Hobart Australia/Melbourne Australia/Sydney Australia/Broken_Hill Australia/Brisbane Australia/Lindeman Australia/Adelaide Australia/Darwin Australia/Perth Australia/Eucla",
			"AW|America/Curacao America/Aruba",
			"AX|Europe/Helsinki Europe/Mariehamn",
			"AZ|Asia/Baku",
			"BA|Europe/Belgrade Europe/Sarajevo",
			"BB|America/Barbados",
			"BD|Asia/Dhaka",
			"BE|Europe/Brussels",
			"BF|Africa/Abidjan Africa/Ouagadougou",
			"BG|Europe/Sofia",
			"BH|Asia/Qatar Asia/Bahrain",
			"BI|Africa/Maputo Africa/Bujumbura",
			"BJ|Africa/Lagos Africa/Porto-Novo",
			"BL|America/Port_of_Spain America/St_Barthelemy",
			"BM|Atlantic/Bermuda",
			"BN|Asia/Brunei",
			"BO|America/La_Paz",
			"BQ|America/Curacao America/Kralendijk",
			"BR|America/Noronha America/Belem America/Fortaleza America/Recife America/Araguaina America/Maceio America/Bahia America/Sao_Paulo America/Campo_Grande America/Cuiaba America/Santarem America/Porto_Velho America/Boa_Vista America/Manaus America/Eirunepe America/Rio_Branco",
			"BS|America/Nassau",
			"BT|Asia/Thimphu",
			"BW|Africa/Maputo Africa/Gaborone",
			"BY|Europe/Minsk",
			"BZ|America/Belize",
			"CA|America/St_Johns America/Halifax America/Glace_Bay America/Moncton America/Goose_Bay America/Blanc-Sablon America/Toronto America/Nipigon America/Thunder_Bay America/Iqaluit America/Pangnirtung America/Atikokan America/Winnipeg America/Rainy_River America/Resolute America/Rankin_Inlet America/Regina America/Swift_Current America/Edmonton America/Cambridge_Bay America/Yellowknife America/Inuvik America/Creston America/Dawson_Creek America/Fort_Nelson America/Whitehorse America/Dawson America/Vancouver",
			"CC|Indian/Cocos",
			"CD|Africa/Maputo Africa/Lagos Africa/Kinshasa Africa/Lubumbashi",
			"CF|Africa/Lagos Africa/Bangui",
			"CG|Africa/Lagos Africa/Brazzaville",
			"CH|Europe/Zurich",
			"CI|Africa/Abidjan",
			"CK|Pacific/Rarotonga",
			"CL|America/Santiago America/Punta_Arenas Pacific/Easter",
			"CM|Africa/Lagos Africa/Douala",
			"CN|Asia/Shanghai Asia/Urumqi",
			"CO|America/Bogota",
			"CR|America/Costa_Rica",
			"CU|America/Havana",
			"CV|Atlantic/Cape_Verde",
			"CW|America/Curacao",
			"CX|Indian/Christmas",
			"CY|Asia/Nicosia Asia/Famagusta",
			"CZ|Europe/Prague",
			"DE|Europe/Zurich Europe/Berlin Europe/Busingen",
			"DJ|Africa/Nairobi Africa/Djibouti",
			"DK|Europe/Copenhagen",
			"DM|America/Port_of_Spain America/Dominica",
			"DO|America/Santo_Domingo",
			"DZ|Africa/Algiers",
			"EC|America/Guayaquil Pacific/Galapagos",
			"EE|Europe/Tallinn",
			"EG|Africa/Cairo",
			"EH|Africa/El_Aaiun",
			"ER|Africa/Nairobi Africa/Asmara",
			"ES|Europe/Madrid Africa/Ceuta Atlantic/Canary",
			"ET|Africa/Nairobi Africa/Addis_Ababa",
			"FI|Europe/Helsinki",
			"FJ|Pacific/Fiji",
			"FK|Atlantic/Stanley",
			"FM|Pacific/Chuuk Pacific/Pohnpei Pacific/Kosrae",
			"FO|Atlantic/Faroe",
			"FR|Europe/Paris",
			"GA|Africa/Lagos Africa/Libreville",
			"GB|Europe/London",
			"GD|America/Port_of_Spain America/Grenada",
			"GE|Asia/Tbilisi",
			"GF|America/Cayenne",
			"GG|Europe/London Europe/Guernsey",
			"GH|Africa/Accra",
			"GI|Europe/Gibraltar",
			"GL|America/Nuuk America/Danmarkshavn America/Scoresbysund America/Thule",
			"GM|Africa/Abidjan Africa/Banjul",
			"GN|Africa/Abidjan Africa/Conakry",
			"GP|America/Port_of_Spain America/Guadeloupe",
			"GQ|Africa/Lagos Africa/Malabo",
			"GR|Europe/Athens",
			"GS|Atlantic/South_Georgia",
			"GT|America/Guatemala",
			"GU|Pacific/Guam",
			"GW|Africa/Bissau",
			"GY|America/Guyana",
			"HK|Asia/Hong_Kong",
			"HN|America/Tegucigalpa",
			"HR|Europe/Belgrade Europe/Zagreb",
			"HT|America/Port-au-Prince",
			"HU|Europe/Budapest",
			"ID|Asia/Jakarta Asia/Pontianak Asia/Makassar Asia/Jayapura",
			"IE|Europe/Dublin",
			"IL|Asia/Jerusalem",
			"IM|Europe/London Europe/Isle_of_Man",
			"IN|Asia/Kolkata",
			"IO|Indian/Chagos",
			"IQ|Asia/Baghdad",
			"IR|Asia/Tehran",
			"IS|Atlantic/Reykjavik",
			"IT|Europe/Rome",
			"JE|Europe/London Europe/Jersey",
			"JM|America/Jamaica",
			"JO|Asia/Amman",
			"JP|Asia/Tokyo",
			"KE|Africa/Nairobi",
			"KG|Asia/Bishkek",
			"KH|Asia/Bangkok Asia/Phnom_Penh",
			"KI|Pacific/Tarawa Pacific/Enderbury Pacific/Kiritimati",
			"KM|Africa/Nairobi Indian/Comoro",
			"KN|America/Port_of_Spain America/St_Kitts",
			"KP|Asia/Pyongyang",
			"KR|Asia/Seoul",
			"KW|Asia/Riyadh Asia/Kuwait",
			"KY|America/Panama America/Cayman",
			"KZ|Asia/Almaty Asia/Qyzylorda Asia/Qostanay Asia/Aqtobe Asia/Aqtau Asia/Atyrau Asia/Oral",
			"LA|Asia/Bangkok Asia/Vientiane",
			"LB|Asia/Beirut",
			"LC|America/Port_of_Spain America/St_Lucia",
			"LI|Europe/Zurich Europe/Vaduz",
			"LK|Asia/Colombo",
			"LR|Africa/Monrovia",
			"LS|Africa/Johannesburg Africa/Maseru",
			"LT|Europe/Vilnius",
			"LU|Europe/Luxembourg",
			"LV|Europe/Riga",
			"LY|Africa/Tripoli",
			"MA|Africa/Casablanca",
			"MC|Europe/Monaco",
			"MD|Europe/Chisinau",
			"ME|Europe/Belgrade Europe/Podgorica",
			"MF|America/Port_of_Spain America/Marigot",
			"MG|Africa/Nairobi Indian/Antananarivo",
			"MH|Pacific/Majuro Pacific/Kwajalein",
			"MK|Europe/Belgrade Europe/Skopje",
			"ML|Africa/Abidjan Africa/Bamako",
			"MM|Asia/Yangon",
			"MN|Asia/Ulaanbaatar Asia/Hovd Asia/Choibalsan",
			"MO|Asia/Macau",
			"MP|Pacific/Guam Pacific/Saipan",
			"MQ|America/Martinique",
			"MR|Africa/Abidjan Africa/Nouakchott",
			"MS|America/Port_of_Spain America/Montserrat",
			"MT|Europe/Malta",
			"MU|Indian/Mauritius",
			"MV|Indian/Maldives",
			"MW|Africa/Maputo Africa/Blantyre",
			"MX|America/Mexico_City America/Cancun America/Merida America/Monterrey America/Matamoros America/Mazatlan America/Chihuahua America/Ojinaga America/Hermosillo America/Tijuana America/Bahia_Banderas",
			"MY|Asia/Kuala_Lumpur Asia/Kuching",
			"MZ|Africa/Maputo",
			"NA|Africa/Windhoek",
			"NC|Pacific/Noumea",
			"NE|Africa/Lagos Africa/Niamey",
			"NF|Pacific/Norfolk",
			"NG|Africa/Lagos",
			"NI|America/Managua",
			"NL|Europe/Amsterdam",
			"NO|Europe/Oslo",
			"NP|Asia/Kathmandu",
			"NR|Pacific/Nauru",
			"NU|Pacific/Niue",
			"NZ|Pacific/Auckland Pacific/Chatham",
			"OM|Asia/Dubai Asia/Muscat",
			"PA|America/Panama",
			"PE|America/Lima",
			"PF|Pacific/Tahiti Pacific/Marquesas Pacific/Gambier",
			"PG|Pacific/Port_Moresby Pacific/Bougainville",
			"PH|Asia/Manila",
			"PK|Asia/Karachi",
			"PL|Europe/Warsaw",
			"PM|America/Miquelon",
			"PN|Pacific/Pitcairn",
			"PR|America/Puerto_Rico",
			"PS|Asia/Gaza Asia/Hebron",
			"PT|Europe/Lisbon Atlantic/Madeira Atlantic/Azores",
			"PW|Pacific/Palau",
			"PY|America/Asuncion",
			"QA|Asia/Qatar",
			"RE|Indian/Reunion",
			"RO|Europe/Bucharest",
			"RS|Europe/Belgrade",
			"RU|Europe/Kaliningrad Europe/Moscow Europe/Simferopol Europe/Kirov Europe/Volgograd Europe/Astrakhan Europe/Saratov Europe/Ulyanovsk Europe/Samara Asia/Yekaterinburg Asia/Omsk Asia/Novosibirsk Asia/Barnaul Asia/Tomsk Asia/Novokuznetsk Asia/Krasnoyarsk Asia/Irkutsk Asia/Chita Asia/Yakutsk Asia/Khandyga Asia/Vladivostok Asia/Ust-Nera Asia/Magadan Asia/Sakhalin Asia/Srednekolymsk Asia/Kamchatka Asia/Anadyr",
			"RW|Africa/Maputo Africa/Kigali",
			"SA|Asia/Riyadh",
			"SB|Pacific/Guadalcanal",
			"SC|Indian/Mahe",
			"SD|Africa/Khartoum",
			"SE|Europe/Stockholm",
			"SG|Asia/Singapore",
			"SH|Africa/Abidjan Atlantic/St_Helena",
			"SI|Europe/Belgrade Europe/Ljubljana",
			"SJ|Europe/Oslo Arctic/Longyearbyen",
			"SK|Europe/Prague Europe/Bratislava",
			"SL|Africa/Abidjan Africa/Freetown",
			"SM|Europe/Rome Europe/San_Marino",
			"SN|Africa/Abidjan Africa/Dakar",
			"SO|Africa/Nairobi Africa/Mogadishu",
			"SR|America/Paramaribo",
			"SS|Africa/Juba",
			"ST|Africa/Sao_Tome",
			"SV|America/El_Salvador",
			"SX|America/Curacao America/Lower_Princes",
			"SY|Asia/Damascus",
			"SZ|Africa/Johannesburg Africa/Mbabane",
			"TC|America/Grand_Turk",
			"TD|Africa/Ndjamena",
			"TF|Indian/Reunion Indian/Kerguelen",
			"TG|Africa/Abidjan Africa/Lome",
			"TH|Asia/Bangkok",
			"TJ|Asia/Dushanbe",
			"TK|Pacific/Fakaofo",
			"TL|Asia/Dili",
			"TM|Asia/Ashgabat",
			"TN|Africa/Tunis",
			"TO|Pacific/Tongatapu",
			"TR|Europe/Istanbul",
			"TT|America/Port_of_Spain",
			"TV|Pacific/Funafuti",
			"TW|Asia/Taipei",
			"TZ|Africa/Nairobi Africa/Dar_es_Salaam",
			"UA|Europe/Simferopol Europe/Kiev Europe/Uzhgorod Europe/Zaporozhye",
			"UG|Africa/Nairobi Africa/Kampala",
			"UM|Pacific/Pago_Pago Pacific/Wake Pacific/Honolulu Pacific/Midway",
			"US|America/New_York America/Detroit America/Kentucky/Louisville America/Kentucky/Monticello America/Indiana/Indianapolis America/Indiana/Vincennes America/Indiana/Winamac America/Indiana/Marengo America/Indiana/Petersburg America/Indiana/Vevay America/Chicago America/Indiana/Tell_City America/Indiana/Knox America/Menominee America/North_Dakota/Center America/North_Dakota/New_Salem America/North_Dakota/Beulah America/Denver America/Boise America/Phoenix America/Los_Angeles America/Anchorage America/Juneau America/Sitka America/Metlakatla America/Yakutat America/Nome America/Adak Pacific/Honolulu",
			"UY|America/Montevideo",
			"UZ|Asia/Samarkand Asia/Tashkent",
			"VA|Europe/Rome Europe/Vatican",
			"VC|America/Port_of_Spain America/St_Vincent",
			"VE|America/Caracas",
			"VG|America/Port_of_Spain America/Tortola",
			"VI|America/Port_of_Spain America/St_Thomas",
			"VN|Asia/Bangkok Asia/Ho_Chi_Minh",
			"VU|Pacific/Efate",
			"WF|Pacific/Wallis",
			"WS|Pacific/Apia",
			"YE|Asia/Riyadh Asia/Aden",
			"YT|Africa/Nairobi Indian/Mayotte",
			"ZA|Africa/Johannesburg",
			"ZM|Africa/Maputo Africa/Lusaka",
			"ZW|Africa/Maputo Africa/Harare"
		]
	};

/***/ }),
/* 1188 */
/***/ (function(module, exports, __webpack_require__) {

	var baseSet = __webpack_require__(1165);
	
	/**
	 * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
	 * it's created. Arrays are created for missing index properties while objects
	 * are created for all other missing properties. Use `_.setWith` to customize
	 * `path` creation.
	 *
	 * **Note:** This method mutates `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.7.0
	 * @category Object
	 * @param {Object} object The object to modify.
	 * @param {Array|string} path The path of the property to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns `object`.
	 * @example
	 *
	 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	 *
	 * _.set(object, 'a[0].b.c', 4);
	 * console.log(object.a[0].b.c);
	 * // => 4
	 *
	 * _.set(object, ['x', '0', 'y', 'z'], 5);
	 * console.log(object.x[0].y.z);
	 * // => 5
	 */
	function set(object, path, value) {
	  return object == null ? object : baseSet(object, path, value);
	}
	
	module.exports = set;


/***/ }),
/* 1189 */
/***/ (function(module, exports, __webpack_require__) {

	var baseClone = __webpack_require__(1190);
	
	/** Used to compose bitmasks for cloning. */
	var CLONE_DEEP_FLAG = 1,
	    CLONE_SYMBOLS_FLAG = 4;
	
	/**
	 * This method is like `_.clone` except that it recursively clones `value`.
	 *
	 * @static
	 * @memberOf _
	 * @since 1.0.0
	 * @category Lang
	 * @param {*} value The value to recursively clone.
	 * @returns {*} Returns the deep cloned value.
	 * @see _.clone
	 * @example
	 *
	 * var objects = [{ 'a': 1 }, { 'b': 2 }];
	 *
	 * var deep = _.cloneDeep(objects);
	 * console.log(deep[0] === objects[0]);
	 * // => false
	 */
	function cloneDeep(value) {
	  return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
	}
	
	module.exports = cloneDeep;


/***/ }),
/* 1190 */
/***/ (function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(734),
	    arrayEach = __webpack_require__(1191),
	    assignValue = __webpack_require__(803),
	    baseAssign = __webpack_require__(1192),
	    baseAssignIn = __webpack_require__(1193),
	    cloneBuffer = __webpack_require__(777),
	    copyArray = __webpack_require__(781),
	    copySymbols = __webpack_require__(1194),
	    copySymbolsIn = __webpack_require__(1195),
	    getAllKeys = __webpack_require__(937),
	    getAllKeysIn = __webpack_require__(1166),
	    getTag = __webpack_require__(943),
	    initCloneArray = __webpack_require__(1196),
	    initCloneByTag = __webpack_require__(1197),
	    initCloneObject = __webpack_require__(782),
	    isArray = __webpack_require__(789),
	    isBuffer = __webpack_require__(793),
	    isMap = __webpack_require__(1201),
	    isObject = __webpack_require__(643),
	    isSet = __webpack_require__(1203),
	    keys = __webpack_require__(921),
	    keysIn = __webpack_require__(804);
	
	/** Used to compose bitmasks for cloning. */
	var CLONE_DEEP_FLAG = 1,
	    CLONE_FLAT_FLAG = 2,
	    CLONE_SYMBOLS_FLAG = 4;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/** Used to identify `toStringTag` values supported by `_.clone`. */
	var cloneableTags = {};
	cloneableTags[argsTag] = cloneableTags[arrayTag] =
	cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
	cloneableTags[boolTag] = cloneableTags[dateTag] =
	cloneableTags[float32Tag] = cloneableTags[float64Tag] =
	cloneableTags[int8Tag] = cloneableTags[int16Tag] =
	cloneableTags[int32Tag] = cloneableTags[mapTag] =
	cloneableTags[numberTag] = cloneableTags[objectTag] =
	cloneableTags[regexpTag] = cloneableTags[setTag] =
	cloneableTags[stringTag] = cloneableTags[symbolTag] =
	cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
	cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
	cloneableTags[errorTag] = cloneableTags[funcTag] =
	cloneableTags[weakMapTag] = false;
	
	/**
	 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
	 * traversed objects.
	 *
	 * @private
	 * @param {*} value The value to clone.
	 * @param {boolean} bitmask The bitmask flags.
	 *  1 - Deep clone
	 *  2 - Flatten inherited properties
	 *  4 - Clone symbols
	 * @param {Function} [customizer] The function to customize cloning.
	 * @param {string} [key] The key of `value`.
	 * @param {Object} [object] The parent object of `value`.
	 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
	 * @returns {*} Returns the cloned value.
	 */
	function baseClone(value, bitmask, customizer, key, object, stack) {
	  var result,
	      isDeep = bitmask & CLONE_DEEP_FLAG,
	      isFlat = bitmask & CLONE_FLAT_FLAG,
	      isFull = bitmask & CLONE_SYMBOLS_FLAG;
	
	  if (customizer) {
	    result = object ? customizer(value, key, object, stack) : customizer(value);
	  }
	  if (result !== undefined) {
	    return result;
	  }
	  if (!isObject(value)) {
	    return value;
	  }
	  var isArr = isArray(value);
	  if (isArr) {
	    result = initCloneArray(value);
	    if (!isDeep) {
	      return copyArray(value, result);
	    }
	  } else {
	    var tag = getTag(value),
	        isFunc = tag == funcTag || tag == genTag;
	
	    if (isBuffer(value)) {
	      return cloneBuffer(value, isDeep);
	    }
	    if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
	      result = (isFlat || isFunc) ? {} : initCloneObject(value);
	      if (!isDeep) {
	        return isFlat
	          ? copySymbolsIn(value, baseAssignIn(result, value))
	          : copySymbols(value, baseAssign(result, value));
	      }
	    } else {
	      if (!cloneableTags[tag]) {
	        return object ? value : {};
	      }
	      result = initCloneByTag(value, tag, isDeep);
	    }
	  }
	  // Check for circular references and return its corresponding clone.
	  stack || (stack = new Stack);
	  var stacked = stack.get(value);
	  if (stacked) {
	    return stacked;
	  }
	  stack.set(value, result);
	
	  if (isSet(value)) {
	    value.forEach(function(subValue) {
	      result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
	    });
	  } else if (isMap(value)) {
	    value.forEach(function(subValue, key) {
	      result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
	    });
	  }
	
	  var keysFunc = isFull
	    ? (isFlat ? getAllKeysIn : getAllKeys)
	    : (isFlat ? keysIn : keys);
	
	  var props = isArr ? undefined : keysFunc(value);
	  arrayEach(props || value, function(subValue, key) {
	    if (props) {
	      key = subValue;
	      subValue = value[key];
	    }
	    // Recursively populate clone (susceptible to call stack limits).
	    assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
	  });
	  return result;
	}
	
	module.exports = baseClone;


/***/ }),
/* 1191 */
/***/ (function(module, exports) {

	/**
	 * A specialized version of `_.forEach` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns `array`.
	 */
	function arrayEach(array, iteratee) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  while (++index < length) {
	    if (iteratee(array[index], index, array) === false) {
	      break;
	    }
	  }
	  return array;
	}
	
	module.exports = arrayEach;


/***/ }),
/* 1192 */
/***/ (function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(802),
	    keys = __webpack_require__(921);
	
	/**
	 * The base implementation of `_.assign` without support for multiple sources
	 * or `customizer` functions.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @returns {Object} Returns `object`.
	 */
	function baseAssign(object, source) {
	  return object && copyObject(source, keys(source), object);
	}
	
	module.exports = baseAssign;


/***/ }),
/* 1193 */
/***/ (function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(802),
	    keysIn = __webpack_require__(804);
	
	/**
	 * The base implementation of `_.assignIn` without support for multiple sources
	 * or `customizer` functions.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @returns {Object} Returns `object`.
	 */
	function baseAssignIn(object, source) {
	  return object && copyObject(source, keysIn(source), object);
	}
	
	module.exports = baseAssignIn;


/***/ }),
/* 1194 */
/***/ (function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(802),
	    getSymbols = __webpack_require__(940);
	
	/**
	 * Copies own symbols of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy symbols from.
	 * @param {Object} [object={}] The object to copy symbols to.
	 * @returns {Object} Returns `object`.
	 */
	function copySymbols(source, object) {
	  return copyObject(source, getSymbols(source), object);
	}
	
	module.exports = copySymbols;


/***/ }),
/* 1195 */
/***/ (function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(802),
	    getSymbolsIn = __webpack_require__(1167);
	
	/**
	 * Copies own and inherited symbols of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy symbols from.
	 * @param {Object} [object={}] The object to copy symbols to.
	 * @returns {Object} Returns `object`.
	 */
	function copySymbolsIn(source, object) {
	  return copyObject(source, getSymbolsIn(source), object);
	}
	
	module.exports = copySymbolsIn;


/***/ }),
/* 1196 */
/***/ (function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Initializes an array clone.
	 *
	 * @private
	 * @param {Array} array The array to clone.
	 * @returns {Array} Returns the initialized clone.
	 */
	function initCloneArray(array) {
	  var length = array.length,
	      result = new array.constructor(length);
	
	  // Add properties assigned by `RegExp#exec`.
	  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
	    result.index = array.index;
	    result.input = array.input;
	  }
	  return result;
	}
	
	module.exports = initCloneArray;


/***/ }),
/* 1197 */
/***/ (function(module, exports, __webpack_require__) {

	var cloneArrayBuffer = __webpack_require__(779),
	    cloneDataView = __webpack_require__(1198),
	    cloneRegExp = __webpack_require__(1199),
	    cloneSymbol = __webpack_require__(1200),
	    cloneTypedArray = __webpack_require__(778);
	
	/** `Object#toString` result references. */
	var boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/**
	 * Initializes an object clone based on its `toStringTag`.
	 *
	 * **Note:** This function only supports cloning values with tags of
	 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
	 *
	 * @private
	 * @param {Object} object The object to clone.
	 * @param {string} tag The `toStringTag` of the object to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the initialized clone.
	 */
	function initCloneByTag(object, tag, isDeep) {
	  var Ctor = object.constructor;
	  switch (tag) {
	    case arrayBufferTag:
	      return cloneArrayBuffer(object);
	
	    case boolTag:
	    case dateTag:
	      return new Ctor(+object);
	
	    case dataViewTag:
	      return cloneDataView(object, isDeep);
	
	    case float32Tag: case float64Tag:
	    case int8Tag: case int16Tag: case int32Tag:
	    case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
	      return cloneTypedArray(object, isDeep);
	
	    case mapTag:
	      return new Ctor;
	
	    case numberTag:
	    case stringTag:
	      return new Ctor(object);
	
	    case regexpTag:
	      return cloneRegExp(object);
	
	    case setTag:
	      return new Ctor;
	
	    case symbolTag:
	      return cloneSymbol(object);
	  }
	}
	
	module.exports = initCloneByTag;


/***/ }),
/* 1198 */
/***/ (function(module, exports, __webpack_require__) {

	var cloneArrayBuffer = __webpack_require__(779);
	
	/**
	 * Creates a clone of `dataView`.
	 *
	 * @private
	 * @param {Object} dataView The data view to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned data view.
	 */
	function cloneDataView(dataView, isDeep) {
	  var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
	  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
	}
	
	module.exports = cloneDataView;


/***/ }),
/* 1199 */
/***/ (function(module, exports) {

	/** Used to match `RegExp` flags from their coerced string values. */
	var reFlags = /\w*$/;
	
	/**
	 * Creates a clone of `regexp`.
	 *
	 * @private
	 * @param {Object} regexp The regexp to clone.
	 * @returns {Object} Returns the cloned regexp.
	 */
	function cloneRegExp(regexp) {
	  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
	  result.lastIndex = regexp.lastIndex;
	  return result;
	}
	
	module.exports = cloneRegExp;


/***/ }),
/* 1200 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(652);
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
	
	/**
	 * Creates a clone of the `symbol` object.
	 *
	 * @private
	 * @param {Object} symbol The symbol object to clone.
	 * @returns {Object} Returns the cloned symbol object.
	 */
	function cloneSymbol(symbol) {
	  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
	}
	
	module.exports = cloneSymbol;


/***/ }),
/* 1201 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsMap = __webpack_require__(1202),
	    baseUnary = __webpack_require__(798),
	    nodeUtil = __webpack_require__(799);
	
	/* Node.js helper references. */
	var nodeIsMap = nodeUtil && nodeUtil.isMap;
	
	/**
	 * Checks if `value` is classified as a `Map` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	 * @example
	 *
	 * _.isMap(new Map);
	 * // => true
	 *
	 * _.isMap(new WeakMap);
	 * // => false
	 */
	var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
	
	module.exports = isMap;


/***/ }),
/* 1202 */
/***/ (function(module, exports, __webpack_require__) {

	var getTag = __webpack_require__(943),
	    isObjectLike = __webpack_require__(655);
	
	/** `Object#toString` result references. */
	var mapTag = '[object Map]';
	
	/**
	 * The base implementation of `_.isMap` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	 */
	function baseIsMap(value) {
	  return isObjectLike(value) && getTag(value) == mapTag;
	}
	
	module.exports = baseIsMap;


/***/ }),
/* 1203 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsSet = __webpack_require__(1204),
	    baseUnary = __webpack_require__(798),
	    nodeUtil = __webpack_require__(799);
	
	/* Node.js helper references. */
	var nodeIsSet = nodeUtil && nodeUtil.isSet;
	
	/**
	 * Checks if `value` is classified as a `Set` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	 * @example
	 *
	 * _.isSet(new Set);
	 * // => true
	 *
	 * _.isSet(new WeakSet);
	 * // => false
	 */
	var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
	
	module.exports = isSet;


/***/ }),
/* 1204 */
/***/ (function(module, exports, __webpack_require__) {

	var getTag = __webpack_require__(943),
	    isObjectLike = __webpack_require__(655);
	
	/** `Object#toString` result references. */
	var setTag = '[object Set]';
	
	/**
	 * The base implementation of `_.isSet` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	 */
	function baseIsSet(value) {
	  return isObjectLike(value) && getTag(value) == setTag;
	}
	
	module.exports = baseIsSet;


/***/ }),
/* 1205 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(608);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(615);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvLoop = function AvLoop(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 4V1L8 5l4 4V6c3.31 0 6 2.69 6 6 0 1.01-.25 1.97-.7 2.8l1.46 1.46C19.54 15.03 20 13.57 20 12c0-4.42-3.58-8-8-8zm0 14c-3.31 0-6-2.69-6-6 0-1.01.25-1.97.7-2.8L5.24 7.74C4.46 8.97 4 10.43 4 12c0 4.42 3.58 8 8 8v3l4-4-4-4v3z' })
	  );
	};
	AvLoop = (0, _pure2.default)(AvLoop);
	AvLoop.displayName = 'AvLoop';
	AvLoop.muiName = 'SvgIcon';
	
	exports.default = AvLoop;

/***/ }),
/* 1206 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var stringify = __webpack_require__(1207);
	var parse = __webpack_require__(1210);
	var formats = __webpack_require__(1209);
	
	module.exports = {
	    formats: formats,
	    parse: parse,
	    stringify: stringify
	};


/***/ }),
/* 1207 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(1208);
	var formats = __webpack_require__(1209);
	
	var arrayPrefixGenerators = {
	    brackets: function brackets(prefix) { // eslint-disable-line func-name-matching
	        return prefix + '[]';
	    },
	    indices: function indices(prefix, key) { // eslint-disable-line func-name-matching
	        return prefix + '[' + key + ']';
	    },
	    repeat: function repeat(prefix) { // eslint-disable-line func-name-matching
	        return prefix;
	    }
	};
	
	var toISO = Date.prototype.toISOString;
	
	var defaults = {
	    delimiter: '&',
	    encode: true,
	    encoder: utils.encode,
	    encodeValuesOnly: false,
	    serializeDate: function serializeDate(date) { // eslint-disable-line func-name-matching
	        return toISO.call(date);
	    },
	    skipNulls: false,
	    strictNullHandling: false
	};
	
	var stringify = function stringify( // eslint-disable-line func-name-matching
	    object,
	    prefix,
	    generateArrayPrefix,
	    strictNullHandling,
	    skipNulls,
	    encoder,
	    filter,
	    sort,
	    allowDots,
	    serializeDate,
	    formatter,
	    encodeValuesOnly
	) {
	    var obj = object;
	    if (typeof filter === 'function') {
	        obj = filter(prefix, obj);
	    } else if (obj instanceof Date) {
	        obj = serializeDate(obj);
	    } else if (obj === null) {
	        if (strictNullHandling) {
	            return encoder && !encodeValuesOnly ? encoder(prefix, defaults.encoder) : prefix;
	        }
	
	        obj = '';
	    }
	
	    if (typeof obj === 'string' || typeof obj === 'number' || typeof obj === 'boolean' || utils.isBuffer(obj)) {
	        if (encoder) {
	            var keyValue = encodeValuesOnly ? prefix : encoder(prefix, defaults.encoder);
	            return [formatter(keyValue) + '=' + formatter(encoder(obj, defaults.encoder))];
	        }
	        return [formatter(prefix) + '=' + formatter(String(obj))];
	    }
	
	    var values = [];
	
	    if (typeof obj === 'undefined') {
	        return values;
	    }
	
	    var objKeys;
	    if (Array.isArray(filter)) {
	        objKeys = filter;
	    } else {
	        var keys = Object.keys(obj);
	        objKeys = sort ? keys.sort(sort) : keys;
	    }
	
	    for (var i = 0; i < objKeys.length; ++i) {
	        var key = objKeys[i];
	
	        if (skipNulls && obj[key] === null) {
	            continue;
	        }
	
	        if (Array.isArray(obj)) {
	            values = values.concat(stringify(
	                obj[key],
	                generateArrayPrefix(prefix, key),
	                generateArrayPrefix,
	                strictNullHandling,
	                skipNulls,
	                encoder,
	                filter,
	                sort,
	                allowDots,
	                serializeDate,
	                formatter,
	                encodeValuesOnly
	            ));
	        } else {
	            values = values.concat(stringify(
	                obj[key],
	                prefix + (allowDots ? '.' + key : '[' + key + ']'),
	                generateArrayPrefix,
	                strictNullHandling,
	                skipNulls,
	                encoder,
	                filter,
	                sort,
	                allowDots,
	                serializeDate,
	                formatter,
	                encodeValuesOnly
	            ));
	        }
	    }
	
	    return values;
	};
	
	module.exports = function (object, opts) {
	    var obj = object;
	    var options = opts ? utils.assign({}, opts) : {};
	
	    if (options.encoder !== null && options.encoder !== undefined && typeof options.encoder !== 'function') {
	        throw new TypeError('Encoder has to be a function.');
	    }
	
	    var delimiter = typeof options.delimiter === 'undefined' ? defaults.delimiter : options.delimiter;
	    var strictNullHandling = typeof options.strictNullHandling === 'boolean' ? options.strictNullHandling : defaults.strictNullHandling;
	    var skipNulls = typeof options.skipNulls === 'boolean' ? options.skipNulls : defaults.skipNulls;
	    var encode = typeof options.encode === 'boolean' ? options.encode : defaults.encode;
	    var encoder = typeof options.encoder === 'function' ? options.encoder : defaults.encoder;
	    var sort = typeof options.sort === 'function' ? options.sort : null;
	    var allowDots = typeof options.allowDots === 'undefined' ? false : options.allowDots;
	    var serializeDate = typeof options.serializeDate === 'function' ? options.serializeDate : defaults.serializeDate;
	    var encodeValuesOnly = typeof options.encodeValuesOnly === 'boolean' ? options.encodeValuesOnly : defaults.encodeValuesOnly;
	    if (typeof options.format === 'undefined') {
	        options.format = formats['default'];
	    } else if (!Object.prototype.hasOwnProperty.call(formats.formatters, options.format)) {
	        throw new TypeError('Unknown format option provided.');
	    }
	    var formatter = formats.formatters[options.format];
	    var objKeys;
	    var filter;
	
	    if (typeof options.filter === 'function') {
	        filter = options.filter;
	        obj = filter('', obj);
	    } else if (Array.isArray(options.filter)) {
	        filter = options.filter;
	        objKeys = filter;
	    }
	
	    var keys = [];
	
	    if (typeof obj !== 'object' || obj === null) {
	        return '';
	    }
	
	    var arrayFormat;
	    if (options.arrayFormat in arrayPrefixGenerators) {
	        arrayFormat = options.arrayFormat;
	    } else if ('indices' in options) {
	        arrayFormat = options.indices ? 'indices' : 'repeat';
	    } else {
	        arrayFormat = 'indices';
	    }
	
	    var generateArrayPrefix = arrayPrefixGenerators[arrayFormat];
	
	    if (!objKeys) {
	        objKeys = Object.keys(obj);
	    }
	
	    if (sort) {
	        objKeys.sort(sort);
	    }
	
	    for (var i = 0; i < objKeys.length; ++i) {
	        var key = objKeys[i];
	
	        if (skipNulls && obj[key] === null) {
	            continue;
	        }
	
	        keys = keys.concat(stringify(
	            obj[key],
	            key,
	            generateArrayPrefix,
	            strictNullHandling,
	            skipNulls,
	            encode ? encoder : null,
	            filter,
	            sort,
	            allowDots,
	            serializeDate,
	            formatter,
	            encodeValuesOnly
	        ));
	    }
	
	    var joined = keys.join(delimiter);
	    var prefix = options.addQueryPrefix === true ? '?' : '';
	
	    return joined.length > 0 ? prefix + joined : '';
	};


/***/ }),
/* 1208 */
/***/ (function(module, exports) {

	'use strict';
	
	var has = Object.prototype.hasOwnProperty;
	
	var hexTable = (function () {
	    var array = [];
	    for (var i = 0; i < 256; ++i) {
	        array.push('%' + ((i < 16 ? '0' : '') + i.toString(16)).toUpperCase());
	    }
	
	    return array;
	}());
	
	var compactQueue = function compactQueue(queue) {
	    var obj;
	
	    while (queue.length) {
	        var item = queue.pop();
	        obj = item.obj[item.prop];
	
	        if (Array.isArray(obj)) {
	            var compacted = [];
	
	            for (var j = 0; j < obj.length; ++j) {
	                if (typeof obj[j] !== 'undefined') {
	                    compacted.push(obj[j]);
	                }
	            }
	
	            item.obj[item.prop] = compacted;
	        }
	    }
	
	    return obj;
	};
	
	var arrayToObject = function arrayToObject(source, options) {
	    var obj = options && options.plainObjects ? Object.create(null) : {};
	    for (var i = 0; i < source.length; ++i) {
	        if (typeof source[i] !== 'undefined') {
	            obj[i] = source[i];
	        }
	    }
	
	    return obj;
	};
	
	var merge = function merge(target, source, options) {
	    if (!source) {
	        return target;
	    }
	
	    if (typeof source !== 'object') {
	        if (Array.isArray(target)) {
	            target.push(source);
	        } else if (typeof target === 'object') {
	            if (options.plainObjects || options.allowPrototypes || !has.call(Object.prototype, source)) {
	                target[source] = true;
	            }
	        } else {
	            return [target, source];
	        }
	
	        return target;
	    }
	
	    if (typeof target !== 'object') {
	        return [target].concat(source);
	    }
	
	    var mergeTarget = target;
	    if (Array.isArray(target) && !Array.isArray(source)) {
	        mergeTarget = arrayToObject(target, options);
	    }
	
	    if (Array.isArray(target) && Array.isArray(source)) {
	        source.forEach(function (item, i) {
	            if (has.call(target, i)) {
	                if (target[i] && typeof target[i] === 'object') {
	                    target[i] = merge(target[i], item, options);
	                } else {
	                    target.push(item);
	                }
	            } else {
	                target[i] = item;
	            }
	        });
	        return target;
	    }
	
	    return Object.keys(source).reduce(function (acc, key) {
	        var value = source[key];
	
	        if (has.call(acc, key)) {
	            acc[key] = merge(acc[key], value, options);
	        } else {
	            acc[key] = value;
	        }
	        return acc;
	    }, mergeTarget);
	};
	
	var assign = function assignSingleSource(target, source) {
	    return Object.keys(source).reduce(function (acc, key) {
	        acc[key] = source[key];
	        return acc;
	    }, target);
	};
	
	var decode = function (str) {
	    try {
	        return decodeURIComponent(str.replace(/\+/g, ' '));
	    } catch (e) {
	        return str;
	    }
	};
	
	var encode = function encode(str) {
	    // This code was originally written by Brian White (mscdex) for the io.js core querystring library.
	    // It has been adapted here for stricter adherence to RFC 3986
	    if (str.length === 0) {
	        return str;
	    }
	
	    var string = typeof str === 'string' ? str : String(str);
	
	    var out = '';
	    for (var i = 0; i < string.length; ++i) {
	        var c = string.charCodeAt(i);
	
	        if (
	            c === 0x2D // -
	            || c === 0x2E // .
	            || c === 0x5F // _
	            || c === 0x7E // ~
	            || (c >= 0x30 && c <= 0x39) // 0-9
	            || (c >= 0x41 && c <= 0x5A) // a-z
	            || (c >= 0x61 && c <= 0x7A) // A-Z
	        ) {
	            out += string.charAt(i);
	            continue;
	        }
	
	        if (c < 0x80) {
	            out = out + hexTable[c];
	            continue;
	        }
	
	        if (c < 0x800) {
	            out = out + (hexTable[0xC0 | (c >> 6)] + hexTable[0x80 | (c & 0x3F)]);
	            continue;
	        }
	
	        if (c < 0xD800 || c >= 0xE000) {
	            out = out + (hexTable[0xE0 | (c >> 12)] + hexTable[0x80 | ((c >> 6) & 0x3F)] + hexTable[0x80 | (c & 0x3F)]);
	            continue;
	        }
	
	        i += 1;
	        c = 0x10000 + (((c & 0x3FF) << 10) | (string.charCodeAt(i) & 0x3FF));
	        out += hexTable[0xF0 | (c >> 18)]
	            + hexTable[0x80 | ((c >> 12) & 0x3F)]
	            + hexTable[0x80 | ((c >> 6) & 0x3F)]
	            + hexTable[0x80 | (c & 0x3F)];
	    }
	
	    return out;
	};
	
	var compact = function compact(value) {
	    var queue = [{ obj: { o: value }, prop: 'o' }];
	    var refs = [];
	
	    for (var i = 0; i < queue.length; ++i) {
	        var item = queue[i];
	        var obj = item.obj[item.prop];
	
	        var keys = Object.keys(obj);
	        for (var j = 0; j < keys.length; ++j) {
	            var key = keys[j];
	            var val = obj[key];
	            if (typeof val === 'object' && val !== null && refs.indexOf(val) === -1) {
	                queue.push({ obj: obj, prop: key });
	                refs.push(val);
	            }
	        }
	    }
	
	    return compactQueue(queue);
	};
	
	var isRegExp = function isRegExp(obj) {
	    return Object.prototype.toString.call(obj) === '[object RegExp]';
	};
	
	var isBuffer = function isBuffer(obj) {
	    if (obj === null || typeof obj === 'undefined') {
	        return false;
	    }
	
	    return !!(obj.constructor && obj.constructor.isBuffer && obj.constructor.isBuffer(obj));
	};
	
	module.exports = {
	    arrayToObject: arrayToObject,
	    assign: assign,
	    compact: compact,
	    decode: decode,
	    encode: encode,
	    isBuffer: isBuffer,
	    isRegExp: isRegExp,
	    merge: merge
	};


/***/ }),
/* 1209 */
/***/ (function(module, exports) {

	'use strict';
	
	var replace = String.prototype.replace;
	var percentTwenties = /%20/g;
	
	module.exports = {
	    'default': 'RFC3986',
	    formatters: {
	        RFC1738: function (value) {
	            return replace.call(value, percentTwenties, '+');
	        },
	        RFC3986: function (value) {
	            return value;
	        }
	    },
	    RFC1738: 'RFC1738',
	    RFC3986: 'RFC3986'
	};


/***/ }),
/* 1210 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(1208);
	
	var has = Object.prototype.hasOwnProperty;
	
	var defaults = {
	    allowDots: false,
	    allowPrototypes: false,
	    arrayLimit: 20,
	    decoder: utils.decode,
	    delimiter: '&',
	    depth: 5,
	    parameterLimit: 1000,
	    plainObjects: false,
	    strictNullHandling: false
	};
	
	var parseValues = function parseQueryStringValues(str, options) {
	    var obj = {};
	    var cleanStr = options.ignoreQueryPrefix ? str.replace(/^\?/, '') : str;
	    var limit = options.parameterLimit === Infinity ? undefined : options.parameterLimit;
	    var parts = cleanStr.split(options.delimiter, limit);
	
	    for (var i = 0; i < parts.length; ++i) {
	        var part = parts[i];
	
	        var bracketEqualsPos = part.indexOf(']=');
	        var pos = bracketEqualsPos === -1 ? part.indexOf('=') : bracketEqualsPos + 1;
	
	        var key, val;
	        if (pos === -1) {
	            key = options.decoder(part, defaults.decoder);
	            val = options.strictNullHandling ? null : '';
	        } else {
	            key = options.decoder(part.slice(0, pos), defaults.decoder);
	            val = options.decoder(part.slice(pos + 1), defaults.decoder);
	        }
	        if (has.call(obj, key)) {
	            obj[key] = [].concat(obj[key]).concat(val);
	        } else {
	            obj[key] = val;
	        }
	    }
	
	    return obj;
	};
	
	var parseObject = function (chain, val, options) {
	    var leaf = val;
	
	    for (var i = chain.length - 1; i >= 0; --i) {
	        var obj;
	        var root = chain[i];
	
	        if (root === '[]') {
	            obj = [];
	            obj = obj.concat(leaf);
	        } else {
	            obj = options.plainObjects ? Object.create(null) : {};
	            var cleanRoot = root.charAt(0) === '[' && root.charAt(root.length - 1) === ']' ? root.slice(1, -1) : root;
	            var index = parseInt(cleanRoot, 10);
	            if (
	                !isNaN(index)
	                && root !== cleanRoot
	                && String(index) === cleanRoot
	                && index >= 0
	                && (options.parseArrays && index <= options.arrayLimit)
	            ) {
	                obj = [];
	                obj[index] = leaf;
	            } else {
	                obj[cleanRoot] = leaf;
	            }
	        }
	
	        leaf = obj;
	    }
	
	    return leaf;
	};
	
	var parseKeys = function parseQueryStringKeys(givenKey, val, options) {
	    if (!givenKey) {
	        return;
	    }
	
	    // Transform dot notation to bracket notation
	    var key = options.allowDots ? givenKey.replace(/\.([^.[]+)/g, '[$1]') : givenKey;
	
	    // The regex chunks
	
	    var brackets = /(\[[^[\]]*])/;
	    var child = /(\[[^[\]]*])/g;
	
	    // Get the parent
	
	    var segment = brackets.exec(key);
	    var parent = segment ? key.slice(0, segment.index) : key;
	
	    // Stash the parent if it exists
	
	    var keys = [];
	    if (parent) {
	        // If we aren't using plain objects, optionally prefix keys
	        // that would overwrite object prototype properties
	        if (!options.plainObjects && has.call(Object.prototype, parent)) {
	            if (!options.allowPrototypes) {
	                return;
	            }
	        }
	
	        keys.push(parent);
	    }
	
	    // Loop through children appending to the array until we hit depth
	
	    var i = 0;
	    while ((segment = child.exec(key)) !== null && i < options.depth) {
	        i += 1;
	        if (!options.plainObjects && has.call(Object.prototype, segment[1].slice(1, -1))) {
	            if (!options.allowPrototypes) {
	                return;
	            }
	        }
	        keys.push(segment[1]);
	    }
	
	    // If there's a remainder, just add whatever is left
	
	    if (segment) {
	        keys.push('[' + key.slice(segment.index) + ']');
	    }
	
	    return parseObject(keys, val, options);
	};
	
	module.exports = function (str, opts) {
	    var options = opts ? utils.assign({}, opts) : {};
	
	    if (options.decoder !== null && options.decoder !== undefined && typeof options.decoder !== 'function') {
	        throw new TypeError('Decoder has to be a function.');
	    }
	
	    options.ignoreQueryPrefix = options.ignoreQueryPrefix === true;
	    options.delimiter = typeof options.delimiter === 'string' || utils.isRegExp(options.delimiter) ? options.delimiter : defaults.delimiter;
	    options.depth = typeof options.depth === 'number' ? options.depth : defaults.depth;
	    options.arrayLimit = typeof options.arrayLimit === 'number' ? options.arrayLimit : defaults.arrayLimit;
	    options.parseArrays = options.parseArrays !== false;
	    options.decoder = typeof options.decoder === 'function' ? options.decoder : defaults.decoder;
	    options.allowDots = typeof options.allowDots === 'boolean' ? options.allowDots : defaults.allowDots;
	    options.plainObjects = typeof options.plainObjects === 'boolean' ? options.plainObjects : defaults.plainObjects;
	    options.allowPrototypes = typeof options.allowPrototypes === 'boolean' ? options.allowPrototypes : defaults.allowPrototypes;
	    options.parameterLimit = typeof options.parameterLimit === 'number' ? options.parameterLimit : defaults.parameterLimit;
	    options.strictNullHandling = typeof options.strictNullHandling === 'boolean' ? options.strictNullHandling : defaults.strictNullHandling;
	
	    if (str === '' || str === null || typeof str === 'undefined') {
	        return options.plainObjects ? Object.create(null) : {};
	    }
	
	    var tempObj = typeof str === 'string' ? parseValues(str, options) : str;
	    var obj = options.plainObjects ? Object.create(null) : {};
	
	    // Iterate over the keys and setup the new object
	
	    var keys = Object.keys(tempObj);
	    for (var i = 0; i < keys.length; ++i) {
	        var key = keys[i];
	        var newObj = parseKeys(key, tempObj[key], options);
	        obj = utils.merge(obj, newObj, options);
	    }
	
	    return utils.compact(obj);
	};


/***/ }),
/* 1211 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _alt = __webpack_require__(975);
	
	var _alt2 = _interopRequireDefault(_alt);
	
	var _keyBy = __webpack_require__(990);
	
	var _keyBy2 = _interopRequireDefault(_keyBy);
	
	var _extend = __webpack_require__(1212);
	
	var _extend2 = _interopRequireDefault(_extend);
	
	var _values = __webpack_require__(1214);
	
	var _values2 = _interopRequireDefault(_values);
	
	var _SystemStatesUtil = __webpack_require__(1216);
	
	var _SystemStatesUtil2 = _interopRequireDefault(_SystemStatesUtil);
	
	var _SystemStatesActions = __webpack_require__(1217);
	
	var _SystemStatesActions2 = _interopRequireDefault(_SystemStatesActions);
	
	var _UserStore = __webpack_require__(974);
	
	var _UserStore2 = _interopRequireDefault(_UserStore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var SystemStatesStore = function () {
	  function SystemStatesStore() {
	    _classCallCheck(this, SystemStatesStore);
	
	    this.bindActions(_SystemStatesActions2.default);
	
	    this.state = {
	      location_data: {
	        continents: [],
	        countries: [],
	        regions: []
	      },
	      isFetching: false
	    };
	
	    this.exportPublicMethods({
	      getLocationData: this.getLocationData.bind(this)
	    });
	  }
	
	  _createClass(SystemStatesStore, [{
	    key: "getLocationData",
	    value: function getLocationData() {
	      return this.state.location_data;
	    }
	  }, {
	    key: "onFetchLocationData",
	    value: function onFetchLocationData() {
	      var _this = this;
	
	      this.setState({ isFetching: true });
	      _SystemStatesUtil2.default.fetchLocationData(_UserStore2.default.getState().apiKey).then(function (data) {
	        _this.setState({ isFetching: false, location_data: data });
	      }).catch(_SystemStatesActions2.default.fetchFailed);
	    }
	  }, {
	    key: "onFetchFailed",
	    value: function onFetchFailed(e) {
	      this.setState({ isFetching: false });
	      alert("Fetching system state / location data failed: " + e.message);
	      throw e;
	    }
	  }]);
	
	  return SystemStatesStore;
	}();
	
	exports.default = _alt2.default.createStore(SystemStatesStore, "SystemStatesStore");
	module.exports = exports["default"];

/***/ }),
/* 1212 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1213);


/***/ }),
/* 1213 */
/***/ (function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(802),
	    createAssigner = __webpack_require__(810),
	    keysIn = __webpack_require__(804);
	
	/**
	 * This method is like `_.assign` except that it iterates over own and
	 * inherited source properties.
	 *
	 * **Note:** This method mutates `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @alias extend
	 * @category Object
	 * @param {Object} object The destination object.
	 * @param {...Object} [sources] The source objects.
	 * @returns {Object} Returns `object`.
	 * @see _.assign
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 * }
	 *
	 * function Bar() {
	 *   this.c = 3;
	 * }
	 *
	 * Foo.prototype.b = 2;
	 * Bar.prototype.d = 4;
	 *
	 * _.assignIn({ 'a': 0 }, new Foo, new Bar);
	 * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
	 */
	var assignIn = createAssigner(function(object, source) {
	  copyObject(source, keysIn(source), object);
	});
	
	module.exports = assignIn;


/***/ }),
/* 1214 */
/***/ (function(module, exports, __webpack_require__) {

	var baseValues = __webpack_require__(1215),
	    keys = __webpack_require__(921);
	
	/**
	 * Creates an array of the own enumerable string keyed property values of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property values.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.values(new Foo);
	 * // => [1, 2] (iteration order is not guaranteed)
	 *
	 * _.values('hi');
	 * // => ['h', 'i']
	 */
	function values(object) {
	  return object == null ? [] : baseValues(object, keys(object));
	}
	
	module.exports = values;


/***/ }),
/* 1215 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__(1013);
	
	/**
	 * The base implementation of `_.values` and `_.valuesIn` which creates an
	 * array of `object` property values corresponding to the property names
	 * of `props`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array} props The property names to get values for.
	 * @returns {Object} Returns the array of property values.
	 */
	function baseValues(object, props) {
	  return arrayMap(props, function(key) {
	    return object[key];
	  });
	}
	
	module.exports = baseValues;


/***/ }),
/* 1216 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _api = __webpack_require__(1160);
	
	var _api2 = _interopRequireDefault(_api);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  fetchLocationData: function fetchLocationData(apiKey, person) {
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "GET",
	        endpoint: "location_data",
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response.data);
	      });
	    });
	  }
	};
	module.exports = exports["default"];

/***/ }),
/* 1217 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _alt = __webpack_require__(975);
	
	var _alt2 = _interopRequireDefault(_alt);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var SystemStatesActions = function SystemStatesActions() {
	  _classCallCheck(this, SystemStatesActions);
	
	  this.generateActions("fetchLocationData", "fetchFailed");
	};
	
	exports.default = _alt2.default.createActions(SystemStatesActions);
	module.exports = exports["default"];

/***/ }),
/* 1218 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _alt = __webpack_require__(975);
	
	var _alt2 = _interopRequireDefault(_alt);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var EventBucketActions = function () {
	  function EventBucketActions() {
	    _classCallCheck(this, EventBucketActions);
	
	    this.generateActions("create", "delete", "updateEventBuckets", "fetchAll", "fetchOne", "fetchFailed", "editFailed", "fetchConfigSchema");
	  }
	
	  _createClass(EventBucketActions, [{
	    key: "updateEventBucket",
	    value: function updateEventBucket(id, eventBucket) {
	      return { id: id, eventBucket: eventBucket };
	    }
	  }, {
	    key: "edit",
	    value: function edit(id, values) {
	      return { id: id, values: values };
	    }
	  }, {
	    key: "uploadFile",
	    value: function uploadFile(id, key, file, callback) {
	      return { id: id, key: key, file: file, callback: callback };
	    }
	  }, {
	    key: "testSubdomain",
	    value: function testSubdomain(id, subdomain) {
	      return { id: id, subdomain: subdomain };
	    }
	  }, {
	    key: "duplicate",
	    value: function duplicate(id, options) {
	      options.id = id;
	      return options;
	    }
	  }]);
	
	  return EventBucketActions;
	}();
	
	exports.default = _alt2.default.createActions(EventBucketActions);
	module.exports = exports["default"];

/***/ }),
/* 1219 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _alt = __webpack_require__(975);
	
	var _alt2 = _interopRequireDefault(_alt);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var SearchActions = function SearchActions() {
	  _classCallCheck(this, SearchActions);
	
	  this.generateActions("reset", "fetchInfo", "fetchFailed", "updateInfo");
	};
	
	exports.default = _alt2.default.createActions(SearchActions);
	module.exports = exports["default"];

/***/ }),
/* 1220 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _alt = __webpack_require__(975);
	
	var _alt2 = _interopRequireDefault(_alt);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var OrderActions = function () {
	  function OrderActions() {
	    _classCallCheck(this, OrderActions);
	
	    this.generateActions("updateOrder", "updateOrders", "fetchOne", "fetchMore", "fetchAll", "fetchAllForEventBucket", "fetchAllForPerson", "fetchFailed", "resendConfirmation", "resendGiftNotification", "resendConfirmationFailed", "refundFailed", "clearErrors", "downloadReceipt", "downloadDonationReceipt", "reset");
	  }
	
	  _createClass(OrderActions, [{
	    key: "edit",
	    value: function edit(id, values) {
	      return { id: id, values: values };
	    }
	  }, {
	    key: "refund",
	    value: function refund(id, amount) {
	      return { id: id, amount: amount };
	    }
	  }]);
	
	  return OrderActions;
	}();
	
	exports.default = _alt2.default.createActions(OrderActions);
	module.exports = exports["default"];

/***/ }),
/* 1221 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _alt = __webpack_require__(975);
	
	var _alt2 = _interopRequireDefault(_alt);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ShiftActions = function ShiftActions() {
	  _classCallCheck(this, ShiftActions);
	
	  this.generateActions("reset", "fetchCurrentShift", "createShift", "closeShift");
	};
	
	exports.default = _alt2.default.createActions(ShiftActions);
	module.exports = exports["default"];

/***/ }),
/* 1222 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var InlineNoticeLabel = function InlineNoticeLabel(_ref, _ref2) {
	  var style = _ref.style;
	  var label = _ref.label;
	
	  var rest = _objectWithoutProperties(_ref, ["style", "label"]);
	
	  var muiTheme = _ref2.muiTheme;
	
	  var STYLE = {
	    color: "#fff",
	    backgroundColor: muiTheme.palette.primary1Color,
	    textTransform: "uppercase",
	    padding: "3px 5px",
	    fontSize: 10,
	    verticalAlign: "top",
	    borderRadius: 3
	  };
	
	  return _react2.default.createElement(
	    "span",
	    _extends({}, rest, { style: Object.assign({}, STYLE, style) }),
	    label
	  );
	};
	
	InlineNoticeLabel.contextTypes = { muiTheme: _react2.default.PropTypes.object };
	
	exports.default = InlineNoticeLabel;
	module.exports = exports["default"];

/***/ }),
/* 1223 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(608);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(615);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionPermIdentity = function ActionPermIdentity(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 5.9c1.16 0 2.1.94 2.1 2.1s-.94 2.1-2.1 2.1S9.9 9.16 9.9 8s.94-2.1 2.1-2.1m0 9c2.97 0 6.1 1.46 6.1 2.1v1.1H5.9V17c0-.64 3.13-2.1 6.1-2.1M12 4C9.79 4 8 5.79 8 8s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 9c-2.67 0-8 1.34-8 4v3h16v-3c0-2.66-5.33-4-8-4z' })
	  );
	};
	ActionPermIdentity = (0, _pure2.default)(ActionPermIdentity);
	ActionPermIdentity.displayName = 'ActionPermIdentity';
	ActionPermIdentity.muiName = 'SvgIcon';
	
	exports.default = ActionPermIdentity;

/***/ }),
/* 1224 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(608);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(615);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionSupervisorAccount = function ActionSupervisorAccount(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M16.5 12c1.38 0 2.49-1.12 2.49-2.5S17.88 7 16.5 7C15.12 7 14 8.12 14 9.5s1.12 2.5 2.5 2.5zM9 11c1.66 0 2.99-1.34 2.99-3S10.66 5 9 5C7.34 5 6 6.34 6 8s1.34 3 3 3zm7.5 3c-1.83 0-5.5.92-5.5 2.75V19h11v-2.25c0-1.83-3.67-2.75-5.5-2.75zM9 13c-2.33 0-7 1.17-7 3.5V19h7v-2.25c0-.85.33-2.34 2.37-3.47C10.5 13.1 9.66 13 9 13z' })
	  );
	};
	ActionSupervisorAccount = (0, _pure2.default)(ActionSupervisorAccount);
	ActionSupervisorAccount.displayName = 'ActionSupervisorAccount';
	ActionSupervisorAccount.muiName = 'SvgIcon';
	
	exports.default = ActionSupervisorAccount;

/***/ }),
/* 1225 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(608);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(615);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ContentContentCopy = function ContentContentCopy(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 16H8V7h11v14z' })
	  );
	};
	ContentContentCopy = (0, _pure2.default)(ContentContentCopy);
	ContentContentCopy.displayName = 'ContentContentCopy';
	ContentContentCopy.muiName = 'SvgIcon';
	
	exports.default = ContentContentCopy;

/***/ }),
/* 1226 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * 'Higher Order Component' that controls the props of a wrapped
	 * component via stores.
	 *
	 * Expects the Component to have two static methods:
	 *   - getStores(): Should return an array of stores.
	 *   - getPropsFromStores(props): Should return the props from the stores.
	 *
	 * Example using old React.createClass() style:
	 *
	 *    const MyComponent = React.createClass({
	 *      statics: {
	 *        getStores(props) {
	 *          return [myStore]
	 *        },
	 *        getPropsFromStores(props) {
	 *          return myStore.getState()
	 *        }
	 *      },
	 *      render() {
	 *        // Use this.props like normal ...
	 *      }
	 *    })
	 *    MyComponent = connectToStores(MyComponent)
	 *
	 *
	 * Example using ES6 Class:
	 *
	 *    class MyComponent extends React.Component {
	 *      static getStores(props) {
	 *        return [myStore]
	 *      }
	 *      static getPropsFromStores(props) {
	 *        return myStore.getState()
	 *      }
	 *      render() {
	 *        // Use this.props like normal ...
	 *      }
	 *    }
	 *    MyComponent = connectToStores(MyComponent)
	 *
	 * A great explanation of the merits of higher order components can be found at
	 * http://bit.ly/1abPkrP
	 */
	
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _functions = __webpack_require__(1227);
	
	function connectToStores(Spec) {
	  var Component = arguments.length <= 1 || arguments[1] === undefined ? Spec : arguments[1];
	  return (function () {
	    // Check for required static methods.
	    if (!(0, _functions.isFunction)(Spec.getStores)) {
	      throw new Error('connectToStores() expects the wrapped component to have a static getStores() method');
	    }
	    if (!(0, _functions.isFunction)(Spec.getPropsFromStores)) {
	      throw new Error('connectToStores() expects the wrapped component to have a static getPropsFromStores() method');
	    }
	
	    var StoreConnection = _react2['default'].createClass({
	      displayName: 'Stateful' + (Component.displayName || Component.name || 'Container'),
	
	      getInitialState: function getInitialState() {
	        return Spec.getPropsFromStores(this.props, this.context);
	      },
	
	      componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	        this.setState(Spec.getPropsFromStores(nextProps, this.context));
	      },
	
	      componentDidMount: function componentDidMount() {
	        var _this = this;
	
	        var stores = Spec.getStores(this.props, this.context);
	        this.storeListeners = stores.map(function (store) {
	          return store.listen(_this.onChange);
	        });
	        if (Spec.componentDidConnect) {
	          Spec.componentDidConnect(this.props, this.context);
	        }
	      },
	
	      componentWillUnmount: function componentWillUnmount() {
	        this.storeListeners.forEach(function (unlisten) {
	          return unlisten();
	        });
	      },
	
	      onChange: function onChange() {
	        this.setState(Spec.getPropsFromStores(this.props, this.context));
	      },
	
	      render: function render() {
	        return _react2['default'].createElement(Component, (0, _functions.assign)({}, this.props, this.state));
	      }
	    });
	    if (Component.contextTypes) {
	      StoreConnection.contextTypes = Component.contextTypes;
	    }
	
	    return StoreConnection;
	  })();
	}
	
	exports['default'] = connectToStores;
	module.exports = exports['default'];

/***/ }),
/* 1227 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports.isPojo = isPojo;
	exports.isPromise = isPromise;
	exports.eachObject = eachObject;
	exports.assign = assign;
	var isFunction = function isFunction(x) {
	  return typeof x === 'function';
	};
	
	exports.isFunction = isFunction;
	
	function isPojo(target) {
	  var Ctor = target.constructor;
	
	  return !!target && typeof target === 'object' && Object.prototype.toString.call(target) === '[object Object]' && isFunction(Ctor) && (Ctor instanceof Ctor || target.type === 'AltStore');
	}
	
	function isPromise(obj) {
	  return !!obj && (typeof obj === 'object' || typeof obj === 'function') && typeof obj.then === 'function';
	}
	
	function eachObject(f, o) {
	  o.forEach(function (from) {
	    Object.keys(Object(from)).forEach(function (key) {
	      f(key, from[key]);
	    });
	  });
	}
	
	function assign(target) {
	  for (var _len = arguments.length, source = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    source[_key - 1] = arguments[_key];
	  }
	
	  eachObject(function (key, value) {
	    return target[key] = value;
	  }, source);
	  return target;
	}

/***/ }),
/* 1228 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _searchContainer = __webpack_require__(1229);
	
	var _searchContainer2 = _interopRequireDefault(_searchContainer);
	
	var _globalSearchBox = __webpack_require__(1590);
	
	var _globalSearchBox2 = _interopRequireDefault(_globalSearchBox);
	
	var _globalSearchResults = __webpack_require__(1591);
	
	var _globalSearchResults2 = _interopRequireDefault(_globalSearchResults);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ROOT_STYLE = {
	  position: "absolute",
	  width: 300,
	  left: 0,
	  right: 0,
	  margin: "11px auto 0"
	};
	
	var COMPACT_STYLE = {
	  width: 230
	};
	
	exports.default = function (_ref) {
	  var compact = _ref.compact;
	  var godMode = _ref.godMode;
	
	  return _react2.default.createElement(
	    "div",
	    {
	      style: godMode ? { width: "100%" } : Object.assign({}, ROOT_STYLE, compact && COMPACT_STYLE)
	    },
	    _react2.default.createElement(
	      _searchContainer2.default,
	      { godMode: godMode },
	      _react2.default.createElement(_globalSearchBox2.default, null),
	      _react2.default.createElement(_globalSearchResults2.default, { compact: compact })
	    )
	  );
	};
	
	module.exports = exports["default"];

/***/ }),
/* 1229 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactEventListener = __webpack_require__(1230);
	
	var _reactEventListener2 = _interopRequireDefault(_reactEventListener);
	
	var _algoliasearch = __webpack_require__(1326);
	
	var _algoliasearch2 = _interopRequireDefault(_algoliasearch);
	
	var _algoliasearchHelper = __webpack_require__(1360);
	
	var _algoliasearchHelper2 = _interopRequireDefault(_algoliasearchHelper);
	
	var _reactAlgoliasearchHelper = __webpack_require__(1482);
	
	var _typesenseInstantsearchAdapter = __webpack_require__(1487);
	
	var _typesenseInstantsearchAdapter2 = _interopRequireDefault(_typesenseInstantsearchAdapter);
	
	var _debounce = __webpack_require__(642);
	
	var _debounce2 = _interopRequireDefault(_debounce);
	
	var _connectToStores = __webpack_require__(1226);
	
	var _connectToStores2 = _interopRequireDefault(_connectToStores);
	
	var _SearchActions = __webpack_require__(1219);
	
	var _SearchActions2 = _interopRequireDefault(_SearchActions);
	
	var _SearchStore = __webpack_require__(1588);
	
	var _SearchStore2 = _interopRequireDefault(_SearchStore);
	
	var _UserStore = __webpack_require__(974);
	
	var _UserStore2 = _interopRequireDefault(_UserStore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TYPESENSE_MODE = window.location.search.indexOf("search_legacy=1") === -1;
	
	var AlgoliaContainer = function (_React$Component) {
	  _inherits(AlgoliaContainer, _React$Component);
	
	  function AlgoliaContainer(props) {
	    _classCallCheck(this, AlgoliaContainer);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(AlgoliaContainer).call(this, props));
	
	    _this.state = {
	      fetching: false,
	      connected: false,
	      client: null,
	      helper: null,
	      selectedIndex: -1,
	      showResults: false
	    };
	
	    _this.onWindowClick = _this.onWindowClick.bind(_this);
	    _this.onKeyDown = _this.onKeyDown.bind(_this);
	    _this.setSelectedIndex = _this.setSelectedIndex.bind(_this);
	    _this.openHitByIndex = _this.openHitByIndex.bind(_this);
	    _this.setShowResults = _this.setShowResults.bind(_this);
	    return _this;
	  }
	
	  _createClass(AlgoliaContainer, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.componentWillReceiveProps(this.props);
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(props) {
	      var _this2 = this;
	
	      var isLoggedIn = props.isLoggedIn;
	      var infoFetched = props.infoFetched;
	      var godInfoFetched = props.godInfoFetched;
	      var config = props.config;
	      var godConfig = props.godConfig;
	      var godMode = props.godMode;
	      var _state = this.state;
	      var fetching = _state.fetching;
	      var connected = _state.connected;
	
	
	      if (godMode) {
	        infoFetched = godInfoFetched;
	        config = godConfig;
	      }
	
	      if (!isLoggedIn) {
	        _SearchActions2.default.reset.defer();
	        this.setState({ connected: false, fetching: false });
	        return;
	      }
	
	      if (!infoFetched && !fetching) {
	        _SearchActions2.default.fetchInfo.defer({
	          godMode: godMode,
	          typesenseMode: TYPESENSE_MODE ? true : undefined
	        });
	        this.setState({ connected: false, fetching: true });
	      }
	
	      if (infoFetched && !connected && config) {
	        (function () {
	          var client = void 0;
	          if (config.platform === "typesense") {
	            var typesenseInstantsearchAdapter = new _typesenseInstantsearchAdapter2.default({
	              server: {
	                apiKey: config.public_api_key,
	                nodes: config.nodes,
	                nearestNode: config.nearest_node || undefined,
	                cacheSearchResultsForSeconds: 10
	              },
	              additionalSearchParameters: {
	                queryBy: "name,email,code,codes,content"
	              }
	            });
	            client = typesenseInstantsearchAdapter.searchClient;
	            client._builtinSearch = client.search;
	            client.search = (0, _debounce2.default)(function (queries, cb) {
	              queries.forEach(function (q) {
	                q.params.highlightPreTag = "<em>";
	                q.params.highlightPostTag = "</em>";
	              });
	              client._builtinSearch(queries).then(function (data) {
	                return cb(null, data);
	              }).catch(function (e) {
	                return cb(e);
	              });
	            }, 150);
	          } else {
	            client = (0, _algoliasearch2.default)(config.application_id, config.public_api_key);
	          }
	
	          var helper = (0, _algoliasearchHelper2.default)(client, config.index);
	
	          _this2.setState({
	            connected: true,
	            fetching: false,
	            client: client,
	            helper: helper
	          }, function () {
	            // Reset selection whenever query changes
	            helper.on("search", function () {
	              _this2.setSelectedIndex(0);
	              _this2.setShowResults(true);
	            });
	          });
	        })();
	      }
	    }
	  }, {
	    key: "onWindowClick",
	    value: function onWindowClick(e) {
	      if (!this.container || !this.container.parentNode.contains(e.target)) {
	        this.setShowResults(false);
	      }
	    }
	  }, {
	    key: "onKeyDown",
	    value: function onKeyDown(e) {
	      // Ignore typing
	      if (e.target.tagName === "INPUT" || e.target.tagName === "SELECT" || e.target.tagName === "TEXTAREA" || e.target.isContentEditable) {
	        return;
	      }
	
	      // If cc entry is open, ignore so we don't accidentally swallow
	      // the auto-injected credit card details into a search.
	      if (document.getElementById("CreditCardEntry--input")) {
	        return;
	      }
	
	      switch (e.which) {
	        case 191:
	          // FORWARD SLASH / QUESTION MARK\
	          e.stopPropagation();
	          e.preventDefault();
	          this.setShowResults(true);
	
	        default:
	        // fall through
	      }
	    }
	  }, {
	    key: "setSelectedIndex",
	    value: function setSelectedIndex(selectedIndex) {
	      // Wrap-around selection
	      if (this.state.helper.lastResults) {
	        var maxIndex = this.state.helper.lastResults.hits.length - 1;
	        if (selectedIndex > maxIndex) {
	          selectedIndex = 0;
	        }
	        if (selectedIndex < 0) {
	          selectedIndex = maxIndex;
	        }
	      }
	
	      this.setState({ selectedIndex: selectedIndex });
	    }
	  }, {
	    key: "setShowResults",
	    value: function setShowResults(showResults) {
	      this.setState({ showResults: showResults });
	    }
	  }, {
	    key: "openHitByIndex",
	    value: function openHitByIndex(index) {
	      if (!index) {
	        index = this.state.selectedIndex;
	      }
	      if (index < 0 || !this.state.helper.lastResults || index >= this.state.helper.lastResults.hits.length) {
	        return;
	      }
	
	      var adminUrlPath = void 0,
	          adminUrlUsedPopulatedId = void 0,
	          hit = this.state.helper.lastResults.hits[index];
	
	      if (hit._type in this.props.types) {
	        adminUrlPath = this.props.types[hit._type].admin_url_path;
	        adminUrlUsedPopulatedId = this.props.types[hit._type].admin_url_use_populated_id;
	      } else {
	        adminUrlPath = hit._type;
	        adminUrlUsedPopulatedId = false;
	      }
	
	      var destination = hit._type === "GiftCard" ? "/gift_cards?gift_card_id=" + hit.objectID : (hit.event_bucket ? "/event_buckets/" + hit.event_bucket : "") + "/" + adminUrlPath + "/" + (adminUrlUsedPopulatedId ? hit._populated_from : hit.objectID) + (this.props.godMode ? "?_god_become_user=" + hit._owner : "");
	
	      if (this.props.godMode) {
	        window.open(destination);
	        return;
	      } else {
	        this.context.router.push(destination);
	      }
	
	      this.state.helper.setQuery("").search();
	      this.setState({ showResults: false });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this3 = this;
	
	      var _state2 = this.state;
	      var connected = _state2.connected;
	      var helper = _state2.helper;
	      var selectedIndex = _state2.selectedIndex;
	      var showResults = _state2.showResults;
	      var _props = this.props;
	      var types = _props.types;
	      var isLoggedIn = _props.isLoggedIn;
	      var godMode = _props.godMode;
	      var condensedUsers = _props.condensedUsers;
	
	
	      if (!connected) {
	        return null;
	      }
	
	      var childProps = {
	        resultTypes: types
	      };
	
	      return _react2.default.createElement(
	        _reactAlgoliasearchHelper.Provider,
	        { helper: helper },
	        _react2.default.createElement(
	          "div",
	          {
	            ref: function ref(_ref) {
	              _this3.container = _ref;
	            }
	          },
	          !godMode ? _react2.default.createElement(_reactEventListener2.default, {
	            target: "window",
	            onClick: this.onWindowClick,
	            onKeyDown: this.onKeyDown
	          }) : null,
	          this.props.children.map(function (c, i) {
	            return _react2.default.cloneElement(c, {
	              key: i,
	              selectedIndex: selectedIndex,
	              showResults: showResults,
	              setSelectedIndex: _this3.setSelectedIndex,
	              openHitByIndex: _this3.openHitByIndex,
	              setShowResults: _this3.setShowResults,
	              godMode: godMode,
	              condensedUsers: godMode ? condensedUsers : undefined
	            });
	          })
	        )
	      );
	    }
	  }], [{
	    key: "getStores",
	    value: function getStores() {
	      return [_SearchStore2.default, _UserStore2.default];
	    }
	  }, {
	    key: "getPropsFromStores",
	    value: function getPropsFromStores() {
	      var state = _SearchStore2.default.getState();
	      state.isLoggedIn = _UserStore2.default.getState().isLoggedIn;
	      state.condensedUsers = _UserStore2.default.getState().condensedUsers;
	      return state;
	    }
	  }]);
	
	  return AlgoliaContainer;
	}(_react2.default.Component);
	
	AlgoliaContainer.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	exports.default = (0, _connectToStores2.default)(AlgoliaContainer);
	module.exports = exports["default"];

/***/ }),
/* 1230 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(1231);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(1257);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(1258);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(1262);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(1309);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _typeof2 = __webpack_require__(1263);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _assign = __webpack_require__(1317);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	exports.withOptions = withOptions;
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactAddonsShallowCompare = __webpack_require__(1321);
	
	var _reactAddonsShallowCompare2 = _interopRequireDefault(_reactAddonsShallowCompare);
	
	var _warning = __webpack_require__(491);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _supports = __webpack_require__(1324);
	
	var supports = _interopRequireWildcard(_supports);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var defaultEventOptions = {
	  capture: false,
	  passive: false
	};
	
	function mergeDefaultEventOptions(options) {
	  return (0, _assign2.default)({}, defaultEventOptions, options);
	}
	
	function getEventListenerArgs(eventName, callback, options) {
	  var args = [eventName, callback];
	  args.push(supports.passiveOption ? options : options.capture);
	  return args;
	}
	
	function on(target, eventName, callback, options) {
	  if (supports.addEventListener) {
	    target.addEventListener.apply(target, getEventListenerArgs(eventName, callback, options));
	  } else if (supports.attachEvent) {
	    // IE8+ Support
	    target.attachEvent('on' + eventName, function () {
	      callback.call(target);
	    });
	  }
	}
	
	function off(target, eventName, callback, options) {
	  if (supports.removeEventListener) {
	    target.removeEventListener.apply(target, getEventListenerArgs(eventName, callback, options));
	  } else if (supports.detachEvent) {
	    // IE8+ Support
	    target.detachEvent('on' + eventName, callback);
	  }
	}
	
	var state = {};
	
	function forEachListener(props, iteratee) {
	  for (var name in props) {
	    if (name.substring(0, 2) !== 'on') continue;
	
	    var prop = props[name];
	    var type = typeof prop === 'undefined' ? 'undefined' : (0, _typeof3.default)(prop);
	    var isObject = type === 'object';
	    var isFunction = type === 'function';
	
	    if (!isObject && !isFunction) continue;
	
	    var _capture = name.substr(-7).toLowerCase() === 'capture';
	    var _eventName = name.substring(2).toLowerCase();
	    _eventName = _capture ? _eventName.substring(0, _eventName.length - 7) : _eventName;
	
	    if (isObject) {
	      iteratee(_eventName, prop.handler, prop.options);
	    } else {
	      iteratee(_eventName, prop, mergeDefaultEventOptions({ capture: _capture }));
	    }
	  }
	}
	
	function withOptions(handler, options) {
	   false ? (0, _warning2.default)(options, '[react-event-listener] Should be specified options in withOptions.') : void 0;
	
	  return {
	    handler: handler,
	    options: mergeDefaultEventOptions(options)
	  };
	}
	
	var EventListener = function (_Component) {
	  (0, _inherits3.default)(EventListener, _Component);
	
	  function EventListener() {
	    (0, _classCallCheck3.default)(this, EventListener);
	    return (0, _possibleConstructorReturn3.default)(this, (EventListener.__proto__ || (0, _getPrototypeOf2.default)(EventListener)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(EventListener, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.addListeners();
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps) {
	      return (0, _reactAddonsShallowCompare2.default)({
	        props: this.props,
	        state: state
	      }, nextProps, state);
	    }
	  }, {
	    key: 'componentWillUpdate',
	    value: function componentWillUpdate() {
	      this.removeListeners();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this.addListeners();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.removeListeners();
	    }
	  }, {
	    key: 'addListeners',
	    value: function addListeners() {
	      this.applyListeners(on);
	    }
	  }, {
	    key: 'removeListeners',
	    value: function removeListeners() {
	      this.applyListeners(off);
	    }
	  }, {
	    key: 'applyListeners',
	    value: function applyListeners(onOrOff) {
	      var target = this.props.target;
	
	
	      if (target) {
	        var element = target;
	
	        if (typeof target === 'string') {
	          element = window[target];
	        }
	
	        forEachListener(this.props, onOrOff.bind(null, element));
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return this.props.children || null;
	    }
	  }]);
	  return EventListener;
	}(_react.Component);
	
	 false ? EventListener.propTypes = {
	  /**
	   * You can provide a children too.
	   */
	  children: _react.PropTypes.node,
	  /**
	   * The DOM target to listen to.
	   */
	  target: _react.PropTypes.oneOfType([_react.PropTypes.object, _react.PropTypes.string])
	} : void 0;
	exports.default = EventListener;

/***/ }),
/* 1231 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1232), __esModule: true };

/***/ }),
/* 1232 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1233);
	module.exports = __webpack_require__(1244).Object.getPrototypeOf;

/***/ }),
/* 1233 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.9 Object.getPrototypeOf(O)
	var toObject        = __webpack_require__(1234)
	  , $getPrototypeOf = __webpack_require__(1236);
	
	__webpack_require__(1242)('getPrototypeOf', function(){
	  return function getPrototypeOf(it){
	    return $getPrototypeOf(toObject(it));
	  };
	});

/***/ }),
/* 1234 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.13 ToObject(argument)
	var defined = __webpack_require__(1235);
	module.exports = function(it){
	  return Object(defined(it));
	};

/***/ }),
/* 1235 */
/***/ (function(module, exports) {

	// 7.2.1 RequireObjectCoercible(argument)
	module.exports = function(it){
	  if(it == undefined)throw TypeError("Can't call method on  " + it);
	  return it;
	};

/***/ }),
/* 1236 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
	var has         = __webpack_require__(1237)
	  , toObject    = __webpack_require__(1234)
	  , IE_PROTO    = __webpack_require__(1238)('IE_PROTO')
	  , ObjectProto = Object.prototype;
	
	module.exports = Object.getPrototypeOf || function(O){
	  O = toObject(O);
	  if(has(O, IE_PROTO))return O[IE_PROTO];
	  if(typeof O.constructor == 'function' && O instanceof O.constructor){
	    return O.constructor.prototype;
	  } return O instanceof Object ? ObjectProto : null;
	};

/***/ }),
/* 1237 */
/***/ (function(module, exports) {

	var hasOwnProperty = {}.hasOwnProperty;
	module.exports = function(it, key){
	  return hasOwnProperty.call(it, key);
	};

/***/ }),
/* 1238 */
/***/ (function(module, exports, __webpack_require__) {

	var shared = __webpack_require__(1239)('keys')
	  , uid    = __webpack_require__(1241);
	module.exports = function(key){
	  return shared[key] || (shared[key] = uid(key));
	};

/***/ }),
/* 1239 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(1240)
	  , SHARED = '__core-js_shared__'
	  , store  = global[SHARED] || (global[SHARED] = {});
	module.exports = function(key){
	  return store[key] || (store[key] = {});
	};

/***/ }),
/* 1240 */
/***/ (function(module, exports) {

	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global = module.exports = typeof window != 'undefined' && window.Math == Math
	  ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')();
	if(typeof __g == 'number')__g = global; // eslint-disable-line no-undef

/***/ }),
/* 1241 */
/***/ (function(module, exports) {

	var id = 0
	  , px = Math.random();
	module.exports = function(key){
	  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
	};

/***/ }),
/* 1242 */
/***/ (function(module, exports, __webpack_require__) {

	// most Object methods by ES6 should accept primitives
	var $export = __webpack_require__(1243)
	  , core    = __webpack_require__(1244)
	  , fails   = __webpack_require__(1253);
	module.exports = function(KEY, exec){
	  var fn  = (core.Object || {})[KEY] || Object[KEY]
	    , exp = {};
	  exp[KEY] = exec(fn);
	  $export($export.S + $export.F * fails(function(){ fn(1); }), 'Object', exp);
	};

/***/ }),
/* 1243 */
/***/ (function(module, exports, __webpack_require__) {

	var global    = __webpack_require__(1240)
	  , core      = __webpack_require__(1244)
	  , ctx       = __webpack_require__(1245)
	  , hide      = __webpack_require__(1247)
	  , PROTOTYPE = 'prototype';
	
	var $export = function(type, name, source){
	  var IS_FORCED = type & $export.F
	    , IS_GLOBAL = type & $export.G
	    , IS_STATIC = type & $export.S
	    , IS_PROTO  = type & $export.P
	    , IS_BIND   = type & $export.B
	    , IS_WRAP   = type & $export.W
	    , exports   = IS_GLOBAL ? core : core[name] || (core[name] = {})
	    , expProto  = exports[PROTOTYPE]
	    , target    = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE]
	    , key, own, out;
	  if(IS_GLOBAL)source = name;
	  for(key in source){
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    if(own && key in exports)continue;
	    // export native or passed
	    out = own ? target[key] : source[key];
	    // prevent global pollution for namespaces
	    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
	    // bind timers to global for call from export context
	    : IS_BIND && own ? ctx(out, global)
	    // wrap global constructors for prevent change them in library
	    : IS_WRAP && target[key] == out ? (function(C){
	      var F = function(a, b, c){
	        if(this instanceof C){
	          switch(arguments.length){
	            case 0: return new C;
	            case 1: return new C(a);
	            case 2: return new C(a, b);
	          } return new C(a, b, c);
	        } return C.apply(this, arguments);
	      };
	      F[PROTOTYPE] = C[PROTOTYPE];
	      return F;
	    // make static versions for prototype methods
	    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
	    if(IS_PROTO){
	      (exports.virtual || (exports.virtual = {}))[key] = out;
	      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
	      if(type & $export.R && expProto && !expProto[key])hide(expProto, key, out);
	    }
	  }
	};
	// type bitmap
	$export.F = 1;   // forced
	$export.G = 2;   // global
	$export.S = 4;   // static
	$export.P = 8;   // proto
	$export.B = 16;  // bind
	$export.W = 32;  // wrap
	$export.U = 64;  // safe
	$export.R = 128; // real proto method for `library` 
	module.exports = $export;

/***/ }),
/* 1244 */
/***/ (function(module, exports) {

	var core = module.exports = {version: '2.4.0'};
	if(typeof __e == 'number')__e = core; // eslint-disable-line no-undef

/***/ }),
/* 1245 */
/***/ (function(module, exports, __webpack_require__) {

	// optional / simple context binding
	var aFunction = __webpack_require__(1246);
	module.exports = function(fn, that, length){
	  aFunction(fn);
	  if(that === undefined)return fn;
	  switch(length){
	    case 1: return function(a){
	      return fn.call(that, a);
	    };
	    case 2: return function(a, b){
	      return fn.call(that, a, b);
	    };
	    case 3: return function(a, b, c){
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function(/* ...args */){
	    return fn.apply(that, arguments);
	  };
	};

/***/ }),
/* 1246 */
/***/ (function(module, exports) {

	module.exports = function(it){
	  if(typeof it != 'function')throw TypeError(it + ' is not a function!');
	  return it;
	};

/***/ }),
/* 1247 */
/***/ (function(module, exports, __webpack_require__) {

	var dP         = __webpack_require__(1248)
	  , createDesc = __webpack_require__(1256);
	module.exports = __webpack_require__(1252) ? function(object, key, value){
	  return dP.f(object, key, createDesc(1, value));
	} : function(object, key, value){
	  object[key] = value;
	  return object;
	};

/***/ }),
/* 1248 */
/***/ (function(module, exports, __webpack_require__) {

	var anObject       = __webpack_require__(1249)
	  , IE8_DOM_DEFINE = __webpack_require__(1251)
	  , toPrimitive    = __webpack_require__(1255)
	  , dP             = Object.defineProperty;
	
	exports.f = __webpack_require__(1252) ? Object.defineProperty : function defineProperty(O, P, Attributes){
	  anObject(O);
	  P = toPrimitive(P, true);
	  anObject(Attributes);
	  if(IE8_DOM_DEFINE)try {
	    return dP(O, P, Attributes);
	  } catch(e){ /* empty */ }
	  if('get' in Attributes || 'set' in Attributes)throw TypeError('Accessors not supported!');
	  if('value' in Attributes)O[P] = Attributes.value;
	  return O;
	};

/***/ }),
/* 1249 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(1250);
	module.exports = function(it){
	  if(!isObject(it))throw TypeError(it + ' is not an object!');
	  return it;
	};

/***/ }),
/* 1250 */
/***/ (function(module, exports) {

	module.exports = function(it){
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};

/***/ }),
/* 1251 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = !__webpack_require__(1252) && !__webpack_require__(1253)(function(){
	  return Object.defineProperty(__webpack_require__(1254)('div'), 'a', {get: function(){ return 7; }}).a != 7;
	});

/***/ }),
/* 1252 */
/***/ (function(module, exports, __webpack_require__) {

	// Thank's IE8 for his funny defineProperty
	module.exports = !__webpack_require__(1253)(function(){
	  return Object.defineProperty({}, 'a', {get: function(){ return 7; }}).a != 7;
	});

/***/ }),
/* 1253 */
/***/ (function(module, exports) {

	module.exports = function(exec){
	  try {
	    return !!exec();
	  } catch(e){
	    return true;
	  }
	};

/***/ }),
/* 1254 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(1250)
	  , document = __webpack_require__(1240).document
	  // in old IE typeof document.createElement is 'object'
	  , is = isObject(document) && isObject(document.createElement);
	module.exports = function(it){
	  return is ? document.createElement(it) : {};
	};

/***/ }),
/* 1255 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.1 ToPrimitive(input [, PreferredType])
	var isObject = __webpack_require__(1250);
	// instead of the ES6 spec version, we didn't implement @@toPrimitive case
	// and the second argument - flag - preferred type is a string
	module.exports = function(it, S){
	  if(!isObject(it))return it;
	  var fn, val;
	  if(S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it)))return val;
	  if(typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it)))return val;
	  if(!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it)))return val;
	  throw TypeError("Can't convert object to primitive value");
	};

/***/ }),
/* 1256 */
/***/ (function(module, exports) {

	module.exports = function(bitmap, value){
	  return {
	    enumerable  : !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable    : !(bitmap & 4),
	    value       : value
	  };
	};

/***/ }),
/* 1257 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	exports.default = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};

/***/ }),
/* 1258 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _defineProperty = __webpack_require__(1259);
	
	var _defineProperty2 = _interopRequireDefault(_defineProperty);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
	    }
	  }
	
	  return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) defineProperties(Constructor, staticProps);
	    return Constructor;
	  };
	}();

/***/ }),
/* 1259 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1260), __esModule: true };

/***/ }),
/* 1260 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1261);
	var $Object = __webpack_require__(1244).Object;
	module.exports = function defineProperty(it, key, desc){
	  return $Object.defineProperty(it, key, desc);
	};

/***/ }),
/* 1261 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(1243);
	// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
	$export($export.S + $export.F * !__webpack_require__(1252), 'Object', {defineProperty: __webpack_require__(1248).f});

/***/ }),
/* 1262 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _typeof2 = __webpack_require__(1263);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }
	
	  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
	};

/***/ }),
/* 1263 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _iterator = __webpack_require__(1264);
	
	var _iterator2 = _interopRequireDefault(_iterator);
	
	var _symbol = __webpack_require__(1293);
	
	var _symbol2 = _interopRequireDefault(_symbol);
	
	var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default ? "symbol" : typeof obj; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
	  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
	} : function (obj) {
	  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
	};

/***/ }),
/* 1264 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1265), __esModule: true };

/***/ }),
/* 1265 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1266);
	__webpack_require__(1288);
	module.exports = __webpack_require__(1292).f('iterator');

/***/ }),
/* 1266 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $at  = __webpack_require__(1267)(true);
	
	// 21.1.3.27 String.prototype[@@iterator]()
	__webpack_require__(1269)(String, 'String', function(iterated){
	  this._t = String(iterated); // target
	  this._i = 0;                // next index
	// 21.1.5.2.1 %StringIteratorPrototype%.next()
	}, function(){
	  var O     = this._t
	    , index = this._i
	    , point;
	  if(index >= O.length)return {value: undefined, done: true};
	  point = $at(O, index);
	  this._i += point.length;
	  return {value: point, done: false};
	});

/***/ }),
/* 1267 */
/***/ (function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(1268)
	  , defined   = __webpack_require__(1235);
	// true  -> String#at
	// false -> String#codePointAt
	module.exports = function(TO_STRING){
	  return function(that, pos){
	    var s = String(defined(that))
	      , i = toInteger(pos)
	      , l = s.length
	      , a, b;
	    if(i < 0 || i >= l)return TO_STRING ? '' : undefined;
	    a = s.charCodeAt(i);
	    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
	      ? TO_STRING ? s.charAt(i) : a
	      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
	  };
	};

/***/ }),
/* 1268 */
/***/ (function(module, exports) {

	// 7.1.4 ToInteger
	var ceil  = Math.ceil
	  , floor = Math.floor;
	module.exports = function(it){
	  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
	};

/***/ }),
/* 1269 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY        = __webpack_require__(1270)
	  , $export        = __webpack_require__(1243)
	  , redefine       = __webpack_require__(1271)
	  , hide           = __webpack_require__(1247)
	  , has            = __webpack_require__(1237)
	  , Iterators      = __webpack_require__(1272)
	  , $iterCreate    = __webpack_require__(1273)
	  , setToStringTag = __webpack_require__(1286)
	  , getPrototypeOf = __webpack_require__(1236)
	  , ITERATOR       = __webpack_require__(1287)('iterator')
	  , BUGGY          = !([].keys && 'next' in [].keys()) // Safari has buggy iterators w/o `next`
	  , FF_ITERATOR    = '@@iterator'
	  , KEYS           = 'keys'
	  , VALUES         = 'values';
	
	var returnThis = function(){ return this; };
	
	module.exports = function(Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED){
	  $iterCreate(Constructor, NAME, next);
	  var getMethod = function(kind){
	    if(!BUGGY && kind in proto)return proto[kind];
	    switch(kind){
	      case KEYS: return function keys(){ return new Constructor(this, kind); };
	      case VALUES: return function values(){ return new Constructor(this, kind); };
	    } return function entries(){ return new Constructor(this, kind); };
	  };
	  var TAG        = NAME + ' Iterator'
	    , DEF_VALUES = DEFAULT == VALUES
	    , VALUES_BUG = false
	    , proto      = Base.prototype
	    , $native    = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT]
	    , $default   = $native || getMethod(DEFAULT)
	    , $entries   = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined
	    , $anyNative = NAME == 'Array' ? proto.entries || $native : $native
	    , methods, key, IteratorPrototype;
	  // Fix native
	  if($anyNative){
	    IteratorPrototype = getPrototypeOf($anyNative.call(new Base));
	    if(IteratorPrototype !== Object.prototype){
	      // Set @@toStringTag to native iterators
	      setToStringTag(IteratorPrototype, TAG, true);
	      // fix for some old engines
	      if(!LIBRARY && !has(IteratorPrototype, ITERATOR))hide(IteratorPrototype, ITERATOR, returnThis);
	    }
	  }
	  // fix Array#{values, @@iterator}.name in V8 / FF
	  if(DEF_VALUES && $native && $native.name !== VALUES){
	    VALUES_BUG = true;
	    $default = function values(){ return $native.call(this); };
	  }
	  // Define iterator
	  if((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])){
	    hide(proto, ITERATOR, $default);
	  }
	  // Plug for library
	  Iterators[NAME] = $default;
	  Iterators[TAG]  = returnThis;
	  if(DEFAULT){
	    methods = {
	      values:  DEF_VALUES ? $default : getMethod(VALUES),
	      keys:    IS_SET     ? $default : getMethod(KEYS),
	      entries: $entries
	    };
	    if(FORCED)for(key in methods){
	      if(!(key in proto))redefine(proto, key, methods[key]);
	    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
	  }
	  return methods;
	};

/***/ }),
/* 1270 */
/***/ (function(module, exports) {

	module.exports = true;

/***/ }),
/* 1271 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1247);

/***/ }),
/* 1272 */
/***/ (function(module, exports) {

	module.exports = {};

/***/ }),
/* 1273 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var create         = __webpack_require__(1274)
	  , descriptor     = __webpack_require__(1256)
	  , setToStringTag = __webpack_require__(1286)
	  , IteratorPrototype = {};
	
	// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
	__webpack_require__(1247)(IteratorPrototype, __webpack_require__(1287)('iterator'), function(){ return this; });
	
	module.exports = function(Constructor, NAME, next){
	  Constructor.prototype = create(IteratorPrototype, {next: descriptor(1, next)});
	  setToStringTag(Constructor, NAME + ' Iterator');
	};

/***/ }),
/* 1274 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	var anObject    = __webpack_require__(1249)
	  , dPs         = __webpack_require__(1275)
	  , enumBugKeys = __webpack_require__(1284)
	  , IE_PROTO    = __webpack_require__(1238)('IE_PROTO')
	  , Empty       = function(){ /* empty */ }
	  , PROTOTYPE   = 'prototype';
	
	// Create object with fake `null` prototype: use iframe Object with cleared prototype
	var createDict = function(){
	  // Thrash, waste and sodomy: IE GC bug
	  var iframe = __webpack_require__(1254)('iframe')
	    , i      = enumBugKeys.length
	    , lt     = '<'
	    , gt     = '>'
	    , iframeDocument;
	  iframe.style.display = 'none';
	  __webpack_require__(1285).appendChild(iframe);
	  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
	  // createDict = iframe.contentWindow.Object;
	  // html.removeChild(iframe);
	  iframeDocument = iframe.contentWindow.document;
	  iframeDocument.open();
	  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
	  iframeDocument.close();
	  createDict = iframeDocument.F;
	  while(i--)delete createDict[PROTOTYPE][enumBugKeys[i]];
	  return createDict();
	};
	
	module.exports = Object.create || function create(O, Properties){
	  var result;
	  if(O !== null){
	    Empty[PROTOTYPE] = anObject(O);
	    result = new Empty;
	    Empty[PROTOTYPE] = null;
	    // add "__proto__" for Object.getPrototypeOf polyfill
	    result[IE_PROTO] = O;
	  } else result = createDict();
	  return Properties === undefined ? result : dPs(result, Properties);
	};


/***/ }),
/* 1275 */
/***/ (function(module, exports, __webpack_require__) {

	var dP       = __webpack_require__(1248)
	  , anObject = __webpack_require__(1249)
	  , getKeys  = __webpack_require__(1276);
	
	module.exports = __webpack_require__(1252) ? Object.defineProperties : function defineProperties(O, Properties){
	  anObject(O);
	  var keys   = getKeys(Properties)
	    , length = keys.length
	    , i = 0
	    , P;
	  while(length > i)dP.f(O, P = keys[i++], Properties[P]);
	  return O;
	};

/***/ }),
/* 1276 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.14 / 15.2.3.14 Object.keys(O)
	var $keys       = __webpack_require__(1277)
	  , enumBugKeys = __webpack_require__(1284);
	
	module.exports = Object.keys || function keys(O){
	  return $keys(O, enumBugKeys);
	};

/***/ }),
/* 1277 */
/***/ (function(module, exports, __webpack_require__) {

	var has          = __webpack_require__(1237)
	  , toIObject    = __webpack_require__(1278)
	  , arrayIndexOf = __webpack_require__(1281)(false)
	  , IE_PROTO     = __webpack_require__(1238)('IE_PROTO');
	
	module.exports = function(object, names){
	  var O      = toIObject(object)
	    , i      = 0
	    , result = []
	    , key;
	  for(key in O)if(key != IE_PROTO)has(O, key) && result.push(key);
	  // Don't enum bug & hidden keys
	  while(names.length > i)if(has(O, key = names[i++])){
	    ~arrayIndexOf(result, key) || result.push(key);
	  }
	  return result;
	};

/***/ }),
/* 1278 */
/***/ (function(module, exports, __webpack_require__) {

	// to indexed object, toObject with fallback for non-array-like ES3 strings
	var IObject = __webpack_require__(1279)
	  , defined = __webpack_require__(1235);
	module.exports = function(it){
	  return IObject(defined(it));
	};

/***/ }),
/* 1279 */
/***/ (function(module, exports, __webpack_require__) {

	// fallback for non-array-like ES3 and non-enumerable old V8 strings
	var cof = __webpack_require__(1280);
	module.exports = Object('z').propertyIsEnumerable(0) ? Object : function(it){
	  return cof(it) == 'String' ? it.split('') : Object(it);
	};

/***/ }),
/* 1280 */
/***/ (function(module, exports) {

	var toString = {}.toString;
	
	module.exports = function(it){
	  return toString.call(it).slice(8, -1);
	};

/***/ }),
/* 1281 */
/***/ (function(module, exports, __webpack_require__) {

	// false -> Array#indexOf
	// true  -> Array#includes
	var toIObject = __webpack_require__(1278)
	  , toLength  = __webpack_require__(1282)
	  , toIndex   = __webpack_require__(1283);
	module.exports = function(IS_INCLUDES){
	  return function($this, el, fromIndex){
	    var O      = toIObject($this)
	      , length = toLength(O.length)
	      , index  = toIndex(fromIndex, length)
	      , value;
	    // Array#includes uses SameValueZero equality algorithm
	    if(IS_INCLUDES && el != el)while(length > index){
	      value = O[index++];
	      if(value != value)return true;
	    // Array#toIndex ignores holes, Array#includes - not
	    } else for(;length > index; index++)if(IS_INCLUDES || index in O){
	      if(O[index] === el)return IS_INCLUDES || index || 0;
	    } return !IS_INCLUDES && -1;
	  };
	};

/***/ }),
/* 1282 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.15 ToLength
	var toInteger = __webpack_require__(1268)
	  , min       = Math.min;
	module.exports = function(it){
	  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
	};

/***/ }),
/* 1283 */
/***/ (function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(1268)
	  , max       = Math.max
	  , min       = Math.min;
	module.exports = function(index, length){
	  index = toInteger(index);
	  return index < 0 ? max(index + length, 0) : min(index, length);
	};

/***/ }),
/* 1284 */
/***/ (function(module, exports) {

	// IE 8- don't enum bug keys
	module.exports = (
	  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
	).split(',');

/***/ }),
/* 1285 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1240).document && document.documentElement;

/***/ }),
/* 1286 */
/***/ (function(module, exports, __webpack_require__) {

	var def = __webpack_require__(1248).f
	  , has = __webpack_require__(1237)
	  , TAG = __webpack_require__(1287)('toStringTag');
	
	module.exports = function(it, tag, stat){
	  if(it && !has(it = stat ? it : it.prototype, TAG))def(it, TAG, {configurable: true, value: tag});
	};

/***/ }),
/* 1287 */
/***/ (function(module, exports, __webpack_require__) {

	var store      = __webpack_require__(1239)('wks')
	  , uid        = __webpack_require__(1241)
	  , Symbol     = __webpack_require__(1240).Symbol
	  , USE_SYMBOL = typeof Symbol == 'function';
	
	var $exports = module.exports = function(name){
	  return store[name] || (store[name] =
	    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
	};
	
	$exports.store = store;

/***/ }),
/* 1288 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1289);
	var global        = __webpack_require__(1240)
	  , hide          = __webpack_require__(1247)
	  , Iterators     = __webpack_require__(1272)
	  , TO_STRING_TAG = __webpack_require__(1287)('toStringTag');
	
	for(var collections = ['NodeList', 'DOMTokenList', 'MediaList', 'StyleSheetList', 'CSSRuleList'], i = 0; i < 5; i++){
	  var NAME       = collections[i]
	    , Collection = global[NAME]
	    , proto      = Collection && Collection.prototype;
	  if(proto && !proto[TO_STRING_TAG])hide(proto, TO_STRING_TAG, NAME);
	  Iterators[NAME] = Iterators.Array;
	}

/***/ }),
/* 1289 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var addToUnscopables = __webpack_require__(1290)
	  , step             = __webpack_require__(1291)
	  , Iterators        = __webpack_require__(1272)
	  , toIObject        = __webpack_require__(1278);
	
	// 22.1.3.4 Array.prototype.entries()
	// 22.1.3.13 Array.prototype.keys()
	// 22.1.3.29 Array.prototype.values()
	// 22.1.3.30 Array.prototype[@@iterator]()
	module.exports = __webpack_require__(1269)(Array, 'Array', function(iterated, kind){
	  this._t = toIObject(iterated); // target
	  this._i = 0;                   // next index
	  this._k = kind;                // kind
	// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
	}, function(){
	  var O     = this._t
	    , kind  = this._k
	    , index = this._i++;
	  if(!O || index >= O.length){
	    this._t = undefined;
	    return step(1);
	  }
	  if(kind == 'keys'  )return step(0, index);
	  if(kind == 'values')return step(0, O[index]);
	  return step(0, [index, O[index]]);
	}, 'values');
	
	// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
	Iterators.Arguments = Iterators.Array;
	
	addToUnscopables('keys');
	addToUnscopables('values');
	addToUnscopables('entries');

/***/ }),
/* 1290 */
/***/ (function(module, exports) {

	module.exports = function(){ /* empty */ };

/***/ }),
/* 1291 */
/***/ (function(module, exports) {

	module.exports = function(done, value){
	  return {value: value, done: !!done};
	};

/***/ }),
/* 1292 */
/***/ (function(module, exports, __webpack_require__) {

	exports.f = __webpack_require__(1287);

/***/ }),
/* 1293 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1294), __esModule: true };

/***/ }),
/* 1294 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1295);
	__webpack_require__(1306);
	__webpack_require__(1307);
	__webpack_require__(1308);
	module.exports = __webpack_require__(1244).Symbol;

/***/ }),
/* 1295 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// ECMAScript 6 symbols shim
	var global         = __webpack_require__(1240)
	  , has            = __webpack_require__(1237)
	  , DESCRIPTORS    = __webpack_require__(1252)
	  , $export        = __webpack_require__(1243)
	  , redefine       = __webpack_require__(1271)
	  , META           = __webpack_require__(1296).KEY
	  , $fails         = __webpack_require__(1253)
	  , shared         = __webpack_require__(1239)
	  , setToStringTag = __webpack_require__(1286)
	  , uid            = __webpack_require__(1241)
	  , wks            = __webpack_require__(1287)
	  , wksExt         = __webpack_require__(1292)
	  , wksDefine      = __webpack_require__(1297)
	  , keyOf          = __webpack_require__(1298)
	  , enumKeys       = __webpack_require__(1299)
	  , isArray        = __webpack_require__(1302)
	  , anObject       = __webpack_require__(1249)
	  , toIObject      = __webpack_require__(1278)
	  , toPrimitive    = __webpack_require__(1255)
	  , createDesc     = __webpack_require__(1256)
	  , _create        = __webpack_require__(1274)
	  , gOPNExt        = __webpack_require__(1303)
	  , $GOPD          = __webpack_require__(1305)
	  , $DP            = __webpack_require__(1248)
	  , $keys          = __webpack_require__(1276)
	  , gOPD           = $GOPD.f
	  , dP             = $DP.f
	  , gOPN           = gOPNExt.f
	  , $Symbol        = global.Symbol
	  , $JSON          = global.JSON
	  , _stringify     = $JSON && $JSON.stringify
	  , PROTOTYPE      = 'prototype'
	  , HIDDEN         = wks('_hidden')
	  , TO_PRIMITIVE   = wks('toPrimitive')
	  , isEnum         = {}.propertyIsEnumerable
	  , SymbolRegistry = shared('symbol-registry')
	  , AllSymbols     = shared('symbols')
	  , OPSymbols      = shared('op-symbols')
	  , ObjectProto    = Object[PROTOTYPE]
	  , USE_NATIVE     = typeof $Symbol == 'function'
	  , QObject        = global.QObject;
	// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
	var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;
	
	// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
	var setSymbolDesc = DESCRIPTORS && $fails(function(){
	  return _create(dP({}, 'a', {
	    get: function(){ return dP(this, 'a', {value: 7}).a; }
	  })).a != 7;
	}) ? function(it, key, D){
	  var protoDesc = gOPD(ObjectProto, key);
	  if(protoDesc)delete ObjectProto[key];
	  dP(it, key, D);
	  if(protoDesc && it !== ObjectProto)dP(ObjectProto, key, protoDesc);
	} : dP;
	
	var wrap = function(tag){
	  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
	  sym._k = tag;
	  return sym;
	};
	
	var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function(it){
	  return typeof it == 'symbol';
	} : function(it){
	  return it instanceof $Symbol;
	};
	
	var $defineProperty = function defineProperty(it, key, D){
	  if(it === ObjectProto)$defineProperty(OPSymbols, key, D);
	  anObject(it);
	  key = toPrimitive(key, true);
	  anObject(D);
	  if(has(AllSymbols, key)){
	    if(!D.enumerable){
	      if(!has(it, HIDDEN))dP(it, HIDDEN, createDesc(1, {}));
	      it[HIDDEN][key] = true;
	    } else {
	      if(has(it, HIDDEN) && it[HIDDEN][key])it[HIDDEN][key] = false;
	      D = _create(D, {enumerable: createDesc(0, false)});
	    } return setSymbolDesc(it, key, D);
	  } return dP(it, key, D);
	};
	var $defineProperties = function defineProperties(it, P){
	  anObject(it);
	  var keys = enumKeys(P = toIObject(P))
	    , i    = 0
	    , l = keys.length
	    , key;
	  while(l > i)$defineProperty(it, key = keys[i++], P[key]);
	  return it;
	};
	var $create = function create(it, P){
	  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
	};
	var $propertyIsEnumerable = function propertyIsEnumerable(key){
	  var E = isEnum.call(this, key = toPrimitive(key, true));
	  if(this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key))return false;
	  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
	};
	var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key){
	  it  = toIObject(it);
	  key = toPrimitive(key, true);
	  if(it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key))return;
	  var D = gOPD(it, key);
	  if(D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key]))D.enumerable = true;
	  return D;
	};
	var $getOwnPropertyNames = function getOwnPropertyNames(it){
	  var names  = gOPN(toIObject(it))
	    , result = []
	    , i      = 0
	    , key;
	  while(names.length > i){
	    if(!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META)result.push(key);
	  } return result;
	};
	var $getOwnPropertySymbols = function getOwnPropertySymbols(it){
	  var IS_OP  = it === ObjectProto
	    , names  = gOPN(IS_OP ? OPSymbols : toIObject(it))
	    , result = []
	    , i      = 0
	    , key;
	  while(names.length > i){
	    if(has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true))result.push(AllSymbols[key]);
	  } return result;
	};
	
	// 19.4.1.1 Symbol([description])
	if(!USE_NATIVE){
	  $Symbol = function Symbol(){
	    if(this instanceof $Symbol)throw TypeError('Symbol is not a constructor!');
	    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
	    var $set = function(value){
	      if(this === ObjectProto)$set.call(OPSymbols, value);
	      if(has(this, HIDDEN) && has(this[HIDDEN], tag))this[HIDDEN][tag] = false;
	      setSymbolDesc(this, tag, createDesc(1, value));
	    };
	    if(DESCRIPTORS && setter)setSymbolDesc(ObjectProto, tag, {configurable: true, set: $set});
	    return wrap(tag);
	  };
	  redefine($Symbol[PROTOTYPE], 'toString', function toString(){
	    return this._k;
	  });
	
	  $GOPD.f = $getOwnPropertyDescriptor;
	  $DP.f   = $defineProperty;
	  __webpack_require__(1304).f = gOPNExt.f = $getOwnPropertyNames;
	  __webpack_require__(1301).f  = $propertyIsEnumerable;
	  __webpack_require__(1300).f = $getOwnPropertySymbols;
	
	  if(DESCRIPTORS && !__webpack_require__(1270)){
	    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
	  }
	
	  wksExt.f = function(name){
	    return wrap(wks(name));
	  }
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, {Symbol: $Symbol});
	
	for(var symbols = (
	  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
	  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
	).split(','), i = 0; symbols.length > i; )wks(symbols[i++]);
	
	for(var symbols = $keys(wks.store), i = 0; symbols.length > i; )wksDefine(symbols[i++]);
	
	$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
	  // 19.4.2.1 Symbol.for(key)
	  'for': function(key){
	    return has(SymbolRegistry, key += '')
	      ? SymbolRegistry[key]
	      : SymbolRegistry[key] = $Symbol(key);
	  },
	  // 19.4.2.5 Symbol.keyFor(sym)
	  keyFor: function keyFor(key){
	    if(isSymbol(key))return keyOf(SymbolRegistry, key);
	    throw TypeError(key + ' is not a symbol!');
	  },
	  useSetter: function(){ setter = true; },
	  useSimple: function(){ setter = false; }
	});
	
	$export($export.S + $export.F * !USE_NATIVE, 'Object', {
	  // 19.1.2.2 Object.create(O [, Properties])
	  create: $create,
	  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
	  defineProperty: $defineProperty,
	  // 19.1.2.3 Object.defineProperties(O, Properties)
	  defineProperties: $defineProperties,
	  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
	  // 19.1.2.7 Object.getOwnPropertyNames(O)
	  getOwnPropertyNames: $getOwnPropertyNames,
	  // 19.1.2.8 Object.getOwnPropertySymbols(O)
	  getOwnPropertySymbols: $getOwnPropertySymbols
	});
	
	// 24.3.2 JSON.stringify(value [, replacer [, space]])
	$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function(){
	  var S = $Symbol();
	  // MS Edge converts symbol values to JSON as {}
	  // WebKit converts symbol values to JSON as null
	  // V8 throws on boxed symbols
	  return _stringify([S]) != '[null]' || _stringify({a: S}) != '{}' || _stringify(Object(S)) != '{}';
	})), 'JSON', {
	  stringify: function stringify(it){
	    if(it === undefined || isSymbol(it))return; // IE8 returns string on undefined
	    var args = [it]
	      , i    = 1
	      , replacer, $replacer;
	    while(arguments.length > i)args.push(arguments[i++]);
	    replacer = args[1];
	    if(typeof replacer == 'function')$replacer = replacer;
	    if($replacer || !isArray(replacer))replacer = function(key, value){
	      if($replacer)value = $replacer.call(this, key, value);
	      if(!isSymbol(value))return value;
	    };
	    args[1] = replacer;
	    return _stringify.apply($JSON, args);
	  }
	});
	
	// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
	$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(1247)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
	// 19.4.3.5 Symbol.prototype[@@toStringTag]
	setToStringTag($Symbol, 'Symbol');
	// 20.2.1.9 Math[@@toStringTag]
	setToStringTag(Math, 'Math', true);
	// 24.3.3 JSON[@@toStringTag]
	setToStringTag(global.JSON, 'JSON', true);

/***/ }),
/* 1296 */
/***/ (function(module, exports, __webpack_require__) {

	var META     = __webpack_require__(1241)('meta')
	  , isObject = __webpack_require__(1250)
	  , has      = __webpack_require__(1237)
	  , setDesc  = __webpack_require__(1248).f
	  , id       = 0;
	var isExtensible = Object.isExtensible || function(){
	  return true;
	};
	var FREEZE = !__webpack_require__(1253)(function(){
	  return isExtensible(Object.preventExtensions({}));
	});
	var setMeta = function(it){
	  setDesc(it, META, {value: {
	    i: 'O' + ++id, // object ID
	    w: {}          // weak collections IDs
	  }});
	};
	var fastKey = function(it, create){
	  // return primitive with prefix
	  if(!isObject(it))return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
	  if(!has(it, META)){
	    // can't set metadata to uncaught frozen object
	    if(!isExtensible(it))return 'F';
	    // not necessary to add metadata
	    if(!create)return 'E';
	    // add missing metadata
	    setMeta(it);
	  // return object ID
	  } return it[META].i;
	};
	var getWeak = function(it, create){
	  if(!has(it, META)){
	    // can't set metadata to uncaught frozen object
	    if(!isExtensible(it))return true;
	    // not necessary to add metadata
	    if(!create)return false;
	    // add missing metadata
	    setMeta(it);
	  // return hash weak collections IDs
	  } return it[META].w;
	};
	// add metadata on freeze-family methods calling
	var onFreeze = function(it){
	  if(FREEZE && meta.NEED && isExtensible(it) && !has(it, META))setMeta(it);
	  return it;
	};
	var meta = module.exports = {
	  KEY:      META,
	  NEED:     false,
	  fastKey:  fastKey,
	  getWeak:  getWeak,
	  onFreeze: onFreeze
	};

/***/ }),
/* 1297 */
/***/ (function(module, exports, __webpack_require__) {

	var global         = __webpack_require__(1240)
	  , core           = __webpack_require__(1244)
	  , LIBRARY        = __webpack_require__(1270)
	  , wksExt         = __webpack_require__(1292)
	  , defineProperty = __webpack_require__(1248).f;
	module.exports = function(name){
	  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
	  if(name.charAt(0) != '_' && !(name in $Symbol))defineProperty($Symbol, name, {value: wksExt.f(name)});
	};

/***/ }),
/* 1298 */
/***/ (function(module, exports, __webpack_require__) {

	var getKeys   = __webpack_require__(1276)
	  , toIObject = __webpack_require__(1278);
	module.exports = function(object, el){
	  var O      = toIObject(object)
	    , keys   = getKeys(O)
	    , length = keys.length
	    , index  = 0
	    , key;
	  while(length > index)if(O[key = keys[index++]] === el)return key;
	};

/***/ }),
/* 1299 */
/***/ (function(module, exports, __webpack_require__) {

	// all enumerable object keys, includes symbols
	var getKeys = __webpack_require__(1276)
	  , gOPS    = __webpack_require__(1300)
	  , pIE     = __webpack_require__(1301);
	module.exports = function(it){
	  var result     = getKeys(it)
	    , getSymbols = gOPS.f;
	  if(getSymbols){
	    var symbols = getSymbols(it)
	      , isEnum  = pIE.f
	      , i       = 0
	      , key;
	    while(symbols.length > i)if(isEnum.call(it, key = symbols[i++]))result.push(key);
	  } return result;
	};

/***/ }),
/* 1300 */
/***/ (function(module, exports) {

	exports.f = Object.getOwnPropertySymbols;

/***/ }),
/* 1301 */
/***/ (function(module, exports) {

	exports.f = {}.propertyIsEnumerable;

/***/ }),
/* 1302 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.2.2 IsArray(argument)
	var cof = __webpack_require__(1280);
	module.exports = Array.isArray || function isArray(arg){
	  return cof(arg) == 'Array';
	};

/***/ }),
/* 1303 */
/***/ (function(module, exports, __webpack_require__) {

	// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
	var toIObject = __webpack_require__(1278)
	  , gOPN      = __webpack_require__(1304).f
	  , toString  = {}.toString;
	
	var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
	  ? Object.getOwnPropertyNames(window) : [];
	
	var getWindowNames = function(it){
	  try {
	    return gOPN(it);
	  } catch(e){
	    return windowNames.slice();
	  }
	};
	
	module.exports.f = function getOwnPropertyNames(it){
	  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
	};


/***/ }),
/* 1304 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
	var $keys      = __webpack_require__(1277)
	  , hiddenKeys = __webpack_require__(1284).concat('length', 'prototype');
	
	exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O){
	  return $keys(O, hiddenKeys);
	};

/***/ }),
/* 1305 */
/***/ (function(module, exports, __webpack_require__) {

	var pIE            = __webpack_require__(1301)
	  , createDesc     = __webpack_require__(1256)
	  , toIObject      = __webpack_require__(1278)
	  , toPrimitive    = __webpack_require__(1255)
	  , has            = __webpack_require__(1237)
	  , IE8_DOM_DEFINE = __webpack_require__(1251)
	  , gOPD           = Object.getOwnPropertyDescriptor;
	
	exports.f = __webpack_require__(1252) ? gOPD : function getOwnPropertyDescriptor(O, P){
	  O = toIObject(O);
	  P = toPrimitive(P, true);
	  if(IE8_DOM_DEFINE)try {
	    return gOPD(O, P);
	  } catch(e){ /* empty */ }
	  if(has(O, P))return createDesc(!pIE.f.call(O, P), O[P]);
	};

/***/ }),
/* 1306 */
/***/ (function(module, exports) {



/***/ }),
/* 1307 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1297)('asyncIterator');

/***/ }),
/* 1308 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1297)('observable');

/***/ }),
/* 1309 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _setPrototypeOf = __webpack_require__(1310);
	
	var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);
	
	var _create = __webpack_require__(1314);
	
	var _create2 = _interopRequireDefault(_create);
	
	var _typeof2 = __webpack_require__(1263);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
	  }
	
	  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      enumerable: false,
	      writable: true,
	      configurable: true
	    }
	  });
	  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
	};

/***/ }),
/* 1310 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1311), __esModule: true };

/***/ }),
/* 1311 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1312);
	module.exports = __webpack_require__(1244).Object.setPrototypeOf;

/***/ }),
/* 1312 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.3.19 Object.setPrototypeOf(O, proto)
	var $export = __webpack_require__(1243);
	$export($export.S, 'Object', {setPrototypeOf: __webpack_require__(1313).set});

/***/ }),
/* 1313 */
/***/ (function(module, exports, __webpack_require__) {

	// Works with __proto__ only. Old v8 can't work with null proto objects.
	/* eslint-disable no-proto */
	var isObject = __webpack_require__(1250)
	  , anObject = __webpack_require__(1249);
	var check = function(O, proto){
	  anObject(O);
	  if(!isObject(proto) && proto !== null)throw TypeError(proto + ": can't set as prototype!");
	};
	module.exports = {
	  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
	    function(test, buggy, set){
	      try {
	        set = __webpack_require__(1245)(Function.call, __webpack_require__(1305).f(Object.prototype, '__proto__').set, 2);
	        set(test, []);
	        buggy = !(test instanceof Array);
	      } catch(e){ buggy = true; }
	      return function setPrototypeOf(O, proto){
	        check(O, proto);
	        if(buggy)O.__proto__ = proto;
	        else set(O, proto);
	        return O;
	      };
	    }({}, false) : undefined),
	  check: check
	};

/***/ }),
/* 1314 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1315), __esModule: true };

/***/ }),
/* 1315 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1316);
	var $Object = __webpack_require__(1244).Object;
	module.exports = function create(P, D){
	  return $Object.create(P, D);
	};

/***/ }),
/* 1316 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(1243)
	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	$export($export.S, 'Object', {create: __webpack_require__(1274)});

/***/ }),
/* 1317 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1318), __esModule: true };

/***/ }),
/* 1318 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1319);
	module.exports = __webpack_require__(1244).Object.assign;

/***/ }),
/* 1319 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.3.1 Object.assign(target, source)
	var $export = __webpack_require__(1243);
	
	$export($export.S + $export.F, 'Object', {assign: __webpack_require__(1320)});

/***/ }),
/* 1320 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.2.1 Object.assign(target, source, ...)
	var getKeys  = __webpack_require__(1276)
	  , gOPS     = __webpack_require__(1300)
	  , pIE      = __webpack_require__(1301)
	  , toObject = __webpack_require__(1234)
	  , IObject  = __webpack_require__(1279)
	  , $assign  = Object.assign;
	
	// should work with symbols and should have deterministic property order (V8 bug)
	module.exports = !$assign || __webpack_require__(1253)(function(){
	  var A = {}
	    , B = {}
	    , S = Symbol()
	    , K = 'abcdefghijklmnopqrst';
	  A[S] = 7;
	  K.split('').forEach(function(k){ B[k] = k; });
	  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
	}) ? function assign(target, source){ // eslint-disable-line no-unused-vars
	  var T     = toObject(target)
	    , aLen  = arguments.length
	    , index = 1
	    , getSymbols = gOPS.f
	    , isEnum     = pIE.f;
	  while(aLen > index){
	    var S      = IObject(arguments[index++])
	      , keys   = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S)
	      , length = keys.length
	      , j      = 0
	      , key;
	    while(length > j)if(isEnum.call(S, key = keys[j++]))T[key] = S[key];
	  } return T;
	} : $assign;

/***/ }),
/* 1321 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1322);

/***/ }),
/* 1322 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var shallowEqual = __webpack_require__(1323);
	
	/**
	 * Does a shallow comparison for props and state.
	 * See ReactComponentWithPureRenderMixin
	 * See also https://facebook.github.io/react/docs/shallow-compare.html
	 */
	function shallowCompare(instance, nextProps, nextState) {
	  return !shallowEqual(instance.props, nextProps) || !shallowEqual(instance.state, nextState);
	}
	
	module.exports = shallowCompare;

/***/ }),
/* 1323 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 * 
	 */
	
	/*eslint-disable no-self-compare */
	
	'use strict';
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	/**
	 * inlined Object.is polyfill to avoid requiring consumers ship their own
	 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	 */
	function is(x, y) {
	  // SameValue algorithm
	  if (x === y) {
	    // Steps 1-5, 7-10
	    // Steps 6.b-6.e: +0 != -0
	    // Added the nonzero y check to make Flow happy, but it is redundant
	    return x !== 0 || y !== 0 || 1 / x === 1 / y;
	  } else {
	    // Step 6.a: NaN == NaN
	    return x !== x && y !== y;
	  }
	}
	
	/**
	 * Performs equality by iterating through keys on an object and returning false
	 * when any key has values which are not strictly equal between the arguments.
	 * Returns true when the values of all keys are strictly equal.
	 */
	function shallowEqual(objA, objB) {
	  if (is(objA, objB)) {
	    return true;
	  }
	
	  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  // Test for A's keys different from B.
	  for (var i = 0; i < keysA.length; i++) {
	    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	module.exports = shallowEqual;

/***/ }),
/* 1324 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.passiveOption = exports.detachEvent = exports.attachEvent = exports.removeEventListener = exports.addEventListener = exports.canUseDOM = undefined;
	
	var _defineProperty = __webpack_require__(1325);
	
	var _defineProperty2 = _interopRequireDefault(_defineProperty);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Inspired by https://github.com/facebook/fbjs/blob/master/packages/fbjs/src/core/ExecutionEnvironment.js
	var canUseDOM = exports.canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	var addEventListener = exports.addEventListener = canUseDOM && 'addEventListener' in window;
	var removeEventListener = exports.removeEventListener = canUseDOM && 'removeEventListener' in window;
	
	// IE8+ Support
	var attachEvent = exports.attachEvent = canUseDOM && 'attachEvent' in window;
	var detachEvent = exports.detachEvent = canUseDOM && 'detachEvent' in window;
	
	// Passive options
	// Inspired by https://github.com/Modernizr/Modernizr/blob/master/feature-detects/dom/passiveeventlisteners.js
	var passiveOption = exports.passiveOption = function () {
	  var cache = null;
	
	  return function () {
	    if (cache !== null) {
	      return cache;
	    }
	
	    var supportsPassiveOption = false;
	
	    try {
	      window.addEventListener('test', null, (0, _defineProperty2.default)({}, 'passive', {
	        get: function get() {
	          supportsPassiveOption = true;
	        }
	      }));
	    } catch (e) {} // eslint-disable-line no-empty
	
	    cache = supportsPassiveOption;
	
	    return supportsPassiveOption;
	  }();
	}();

/***/ }),
/* 1325 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty = __webpack_require__(1259);
	
	var _defineProperty2 = _interopRequireDefault(_defineProperty);
	
	exports.default = defineProperty;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	//  weak
	
	function defineProperty(o, p, attr) {
	  return (0, _defineProperty2.default)(o, p, attr);
	}

/***/ }),
/* 1326 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var AlgoliaSearch = __webpack_require__(1327);
	var createAlgoliasearch = __webpack_require__(1350);
	
	module.exports = createAlgoliasearch(AlgoliaSearch);


/***/ }),
/* 1327 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = AlgoliaSearch;
	
	var Index = __webpack_require__(1328);
	var deprecate = __webpack_require__(1341);
	var deprecatedMessage = __webpack_require__(1342);
	var AlgoliaSearchCore = __webpack_require__(1346);
	var inherits = __webpack_require__(1329);
	var errors = __webpack_require__(1332);
	
	function AlgoliaSearch() {
	  AlgoliaSearchCore.apply(this, arguments);
	}
	
	inherits(AlgoliaSearch, AlgoliaSearchCore);
	
	/*
	 * Delete an index
	 *
	 * @param indexName the name of index to delete
	 * @param callback the result callback called with two arguments
	 *  error: null or Error('message')
	 *  content: the server answer that contains the task ID
	 */
	AlgoliaSearch.prototype.deleteIndex = function(indexName, callback) {
	  return this._jsonRequest({
	    method: 'DELETE',
	    url: '/1/indexes/' + encodeURIComponent(indexName),
	    hostType: 'write',
	    callback: callback
	  });
	};
	
	/**
	 * Move an existing index.
	 * @param srcIndexName the name of index to copy.
	 * @param dstIndexName the new index name that will contains a copy of
	 * srcIndexName (destination will be overriten if it already exist).
	 * @param callback the result callback called with two arguments
	 *  error: null or Error('message')
	 *  content: the server answer that contains the task ID
	 */
	AlgoliaSearch.prototype.moveIndex = function(srcIndexName, dstIndexName, callback) {
	  var postObj = {
	    operation: 'move', destination: dstIndexName
	  };
	  return this._jsonRequest({
	    method: 'POST',
	    url: '/1/indexes/' + encodeURIComponent(srcIndexName) + '/operation',
	    body: postObj,
	    hostType: 'write',
	    callback: callback
	  });
	};
	
	/**
	 * Copy an existing index.
	 * @param srcIndexName the name of index to copy.
	 * @param dstIndexName the new index name that will contains a copy
	 * of srcIndexName (destination will be overriten if it already exist).
	 * @param callback the result callback called with two arguments
	 *  error: null or Error('message')
	 *  content: the server answer that contains the task ID
	 */
	AlgoliaSearch.prototype.copyIndex = function(srcIndexName, dstIndexName, callback) {
	  var postObj = {
	    operation: 'copy', destination: dstIndexName
	  };
	  return this._jsonRequest({
	    method: 'POST',
	    url: '/1/indexes/' + encodeURIComponent(srcIndexName) + '/operation',
	    body: postObj,
	    hostType: 'write',
	    callback: callback
	  });
	};
	
	/**
	 * Return last log entries.
	 * @param offset Specify the first entry to retrieve (0-based, 0 is the most recent log entry).
	 * @param length Specify the maximum number of entries to retrieve starting
	 * at offset. Maximum allowed value: 1000.
	 * @param type Specify the maximum number of entries to retrieve starting
	 * at offset. Maximum allowed value: 1000.
	 * @param callback the result callback called with two arguments
	 *  error: null or Error('message')
	 *  content: the server answer that contains the task ID
	 */
	AlgoliaSearch.prototype.getLogs = function(offset, length, callback) {
	  var clone = __webpack_require__(1335);
	  var params = {};
	  if (typeof offset === 'object') {
	    // getLogs(params)
	    params = clone(offset);
	    callback = length;
	  } else if (arguments.length === 0 || typeof offset === 'function') {
	    // getLogs([cb])
	    callback = offset;
	  } else if (arguments.length === 1 || typeof length === 'function') {
	    // getLogs(1, [cb)]
	    callback = length;
	    params.offset = offset;
	  } else {
	    // getLogs(1, 2, [cb])
	    params.offset = offset;
	    params.length = length;
	  }
	
	  if (params.offset === undefined) params.offset = 0;
	  if (params.length === undefined) params.length = 10;
	
	  return this._jsonRequest({
	    method: 'GET',
	    url: '/1/logs?' + this._getSearchParams(params, ''),
	    hostType: 'read',
	    callback: callback
	  });
	};
	
	/*
	 * List all existing indexes (paginated)
	 *
	 * @param page The page to retrieve, starting at 0.
	 * @param callback the result callback called with two arguments
	 *  error: null or Error('message')
	 *  content: the server answer with index list
	 */
	AlgoliaSearch.prototype.listIndexes = function(page, callback) {
	  var params = '';
	
	  if (page === undefined || typeof page === 'function') {
	    callback = page;
	  } else {
	    params = '?page=' + page;
	  }
	
	  return this._jsonRequest({
	    method: 'GET',
	    url: '/1/indexes' + params,
	    hostType: 'read',
	    callback: callback
	  });
	};
	
	/*
	 * Get the index object initialized
	 *
	 * @param indexName the name of index
	 * @param callback the result callback with one argument (the Index instance)
	 */
	AlgoliaSearch.prototype.initIndex = function(indexName) {
	  return new Index(this, indexName);
	};
	
	/*
	 * List all existing user keys with their associated ACLs
	 *
	 * @param callback the result callback called with two arguments
	 *  error: null or Error('message')
	 *  content: the server answer with user keys list
	 */
	AlgoliaSearch.prototype.listUserKeys = function(callback) {
	  return this._jsonRequest({
	    method: 'GET',
	    url: '/1/keys',
	    hostType: 'read',
	    callback: callback
	  });
	};
	
	/*
	 * Get ACL of a user key
	 *
	 * @param key
	 * @param callback the result callback called with two arguments
	 *  error: null or Error('message')
	 *  content: the server answer with user keys list
	 */
	AlgoliaSearch.prototype.getUserKeyACL = function(key, callback) {
	  return this._jsonRequest({
	    method: 'GET',
	    url: '/1/keys/' + key,
	    hostType: 'read',
	    callback: callback
	  });
	};
	
	/*
	 * Delete an existing user key
	 * @param key
	 * @param callback the result callback called with two arguments
	 *  error: null or Error('message')
	 *  content: the server answer with user keys list
	 */
	AlgoliaSearch.prototype.deleteUserKey = function(key, callback) {
	  return this._jsonRequest({
	    method: 'DELETE',
	    url: '/1/keys/' + key,
	    hostType: 'write',
	    callback: callback
	  });
	};
	
	/*
	 * Add a new global API key
	 *
	 * @param {string[]} acls - The list of ACL for this key. Defined by an array of strings that
	 *   can contains the following values:
	 *     - search: allow to search (https and http)
	 *     - addObject: allows to add/update an object in the index (https only)
	 *     - deleteObject : allows to delete an existing object (https only)
	 *     - deleteIndex : allows to delete index content (https only)
	 *     - settings : allows to get index settings (https only)
	 *     - editSettings : allows to change index settings (https only)
	 * @param {Object} [params] - Optionnal parameters to set for the key
	 * @param {number} params.validity - Number of seconds after which the key will be automatically removed (0 means no time limit for this key)
	 * @param {number} params.maxQueriesPerIPPerHour - Number of API calls allowed from an IP address per hour
	 * @param {number} params.maxHitsPerQuery - Number of hits this API key can retrieve in one call
	 * @param {string[]} params.indexes - Allowed targeted indexes for this key
	 * @param {string} params.description - A description for your key
	 * @param {string[]} params.referers - A list of authorized referers
	 * @param {Object} params.queryParameters - Force the key to use specific query parameters
	 * @param {Function} callback - The result callback called with two arguments
	 *   error: null or Error('message')
	 *   content: the server answer with user keys list
	 * @return {Promise|undefined} Returns a promise if no callback given
	 * @example
	 * client.addUserKey(['search'], {
	 *   validity: 300,
	 *   maxQueriesPerIPPerHour: 2000,
	 *   maxHitsPerQuery: 3,
	 *   indexes: ['fruits'],
	 *   description: 'Eat three fruits',
	 *   referers: ['*.algolia.com'],
	 *   queryParameters: {
	 *     tagFilters: ['public'],
	 *   }
	 * })
	 * @see {@link https://www.algolia.com/doc/rest_api#AddKey|Algolia REST API Documentation}
	 */
	AlgoliaSearch.prototype.addUserKey = function(acls, params, callback) {
	  var isArray = __webpack_require__(1339);
	  var usage = 'Usage: client.addUserKey(arrayOfAcls[, params, callback])';
	
	  if (!isArray(acls)) {
	    throw new Error(usage);
	  }
	
	  if (arguments.length === 1 || typeof params === 'function') {
	    callback = params;
	    params = null;
	  }
	
	  var postObj = {
	    acl: acls
	  };
	
	  if (params) {
	    postObj.validity = params.validity;
	    postObj.maxQueriesPerIPPerHour = params.maxQueriesPerIPPerHour;
	    postObj.maxHitsPerQuery = params.maxHitsPerQuery;
	    postObj.indexes = params.indexes;
	    postObj.description = params.description;
	
	    if (params.queryParameters) {
	      postObj.queryParameters = this._getSearchParams(params.queryParameters, '');
	    }
	
	    postObj.referers = params.referers;
	  }
	
	  return this._jsonRequest({
	    method: 'POST',
	    url: '/1/keys',
	    body: postObj,
	    hostType: 'write',
	    callback: callback
	  });
	};
	
	/**
	 * Add a new global API key
	 * @deprecated Please use client.addUserKey()
	 */
	AlgoliaSearch.prototype.addUserKeyWithValidity = deprecate(function(acls, params, callback) {
	  return this.addUserKey(acls, params, callback);
	}, deprecatedMessage('client.addUserKeyWithValidity()', 'client.addUserKey()'));
	
	/**
	 * Update an existing API key
	 * @param {string} key - The key to update
	 * @param {string[]} acls - The list of ACL for this key. Defined by an array of strings that
	 *   can contains the following values:
	 *     - search: allow to search (https and http)
	 *     - addObject: allows to add/update an object in the index (https only)
	 *     - deleteObject : allows to delete an existing object (https only)
	 *     - deleteIndex : allows to delete index content (https only)
	 *     - settings : allows to get index settings (https only)
	 *     - editSettings : allows to change index settings (https only)
	 * @param {Object} [params] - Optionnal parameters to set for the key
	 * @param {number} params.validity - Number of seconds after which the key will be automatically removed (0 means no time limit for this key)
	 * @param {number} params.maxQueriesPerIPPerHour - Number of API calls allowed from an IP address per hour
	 * @param {number} params.maxHitsPerQuery - Number of hits this API key can retrieve in one call
	 * @param {string[]} params.indexes - Allowed targeted indexes for this key
	 * @param {string} params.description - A description for your key
	 * @param {string[]} params.referers - A list of authorized referers
	 * @param {Object} params.queryParameters - Force the key to use specific query parameters
	 * @param {Function} callback - The result callback called with two arguments
	 *   error: null or Error('message')
	 *   content: the server answer with user keys list
	 * @return {Promise|undefined} Returns a promise if no callback given
	 * @example
	 * client.updateUserKey('APIKEY', ['search'], {
	 *   validity: 300,
	 *   maxQueriesPerIPPerHour: 2000,
	 *   maxHitsPerQuery: 3,
	 *   indexes: ['fruits'],
	 *   description: 'Eat three fruits',
	 *   referers: ['*.algolia.com'],
	 *   queryParameters: {
	 *     tagFilters: ['public'],
	 *   }
	 * })
	 * @see {@link https://www.algolia.com/doc/rest_api#UpdateIndexKey|Algolia REST API Documentation}
	 */
	AlgoliaSearch.prototype.updateUserKey = function(key, acls, params, callback) {
	  var isArray = __webpack_require__(1339);
	  var usage = 'Usage: client.updateUserKey(key, arrayOfAcls[, params, callback])';
	
	  if (!isArray(acls)) {
	    throw new Error(usage);
	  }
	
	  if (arguments.length === 2 || typeof params === 'function') {
	    callback = params;
	    params = null;
	  }
	
	  var putObj = {
	    acl: acls
	  };
	
	  if (params) {
	    putObj.validity = params.validity;
	    putObj.maxQueriesPerIPPerHour = params.maxQueriesPerIPPerHour;
	    putObj.maxHitsPerQuery = params.maxHitsPerQuery;
	    putObj.indexes = params.indexes;
	    putObj.description = params.description;
	
	    if (params.queryParameters) {
	      putObj.queryParameters = this._getSearchParams(params.queryParameters, '');
	    }
	
	    putObj.referers = params.referers;
	  }
	
	  return this._jsonRequest({
	    method: 'PUT',
	    url: '/1/keys/' + key,
	    body: putObj,
	    hostType: 'write',
	    callback: callback
	  });
	};
	
	/**
	 * Initialize a new batch of search queries
	 * @deprecated use client.search()
	 */
	AlgoliaSearch.prototype.startQueriesBatch = deprecate(function startQueriesBatchDeprecated() {
	  this._batch = [];
	}, deprecatedMessage('client.startQueriesBatch()', 'client.search()'));
	
	/**
	 * Add a search query in the batch
	 * @deprecated use client.search()
	 */
	AlgoliaSearch.prototype.addQueryInBatch = deprecate(function addQueryInBatchDeprecated(indexName, query, args) {
	  this._batch.push({
	    indexName: indexName,
	    query: query,
	    params: args
	  });
	}, deprecatedMessage('client.addQueryInBatch()', 'client.search()'));
	
	/**
	 * Launch the batch of queries using XMLHttpRequest.
	 * @deprecated use client.search()
	 */
	AlgoliaSearch.prototype.sendQueriesBatch = deprecate(function sendQueriesBatchDeprecated(callback) {
	  return this.search(this._batch, callback);
	}, deprecatedMessage('client.sendQueriesBatch()', 'client.search()'));
	
	/**
	 * Perform write operations accross multiple indexes.
	 *
	 * To reduce the amount of time spent on network round trips,
	 * you can create, update, or delete several objects in one call,
	 * using the batch endpoint (all operations are done in the given order).
	 *
	 * Available actions:
	 *   - addObject
	 *   - updateObject
	 *   - partialUpdateObject
	 *   - partialUpdateObjectNoCreate
	 *   - deleteObject
	 *
	 * https://www.algolia.com/doc/rest_api#Indexes
	 * @param  {Object[]} operations An array of operations to perform
	 * @return {Promise|undefined} Returns a promise if no callback given
	 * @example
	 * client.batch([{
	 *   action: 'addObject',
	 *   indexName: 'clients',
	 *   body: {
	 *     name: 'Bill'
	 *   }
	 * }, {
	 *   action: 'udpateObject',
	 *   indexName: 'fruits',
	 *   body: {
	 *     objectID: '29138',
	 *     name: 'banana'
	 *   }
	 * }], cb)
	 */
	AlgoliaSearch.prototype.batch = function(operations, callback) {
	  var isArray = __webpack_require__(1339);
	  var usage = 'Usage: client.batch(operations[, callback])';
	
	  if (!isArray(operations)) {
	    throw new Error(usage);
	  }
	
	  return this._jsonRequest({
	    method: 'POST',
	    url: '/1/indexes/*/batch',
	    body: {
	      requests: operations
	    },
	    hostType: 'write',
	    callback: callback
	  });
	};
	
	// environment specific methods
	AlgoliaSearch.prototype.destroy = notImplemented;
	AlgoliaSearch.prototype.enableRateLimitForward = notImplemented;
	AlgoliaSearch.prototype.disableRateLimitForward = notImplemented;
	AlgoliaSearch.prototype.useSecuredAPIKey = notImplemented;
	AlgoliaSearch.prototype.disableSecuredAPIKey = notImplemented;
	AlgoliaSearch.prototype.generateSecuredApiKey = notImplemented;
	
	function notImplemented() {
	  var message = 'Not implemented in this environment.\n' +
	    'If you feel this is a mistake, write to support@algolia.com';
	
	  throw new errors.AlgoliaSearchError(message);
	}


/***/ }),
/* 1328 */
/***/ (function(module, exports, __webpack_require__) {

	var inherits = __webpack_require__(1329);
	var IndexCore = __webpack_require__(1330);
	var deprecate = __webpack_require__(1341);
	var deprecatedMessage = __webpack_require__(1342);
	var exitPromise = __webpack_require__(1343);
	var errors = __webpack_require__(1332);
	
	module.exports = Index;
	
	function Index() {
	  IndexCore.apply(this, arguments);
	}
	
	inherits(Index, IndexCore);
	
	/*
	* Add an object in this index
	*
	* @param content contains the javascript object to add inside the index
	* @param objectID (optional) an objectID you want to attribute to this object
	* (if the attribute already exist the old object will be overwrite)
	* @param callback (optional) the result callback called with two arguments:
	*  error: null or Error('message')
	*  content: the server answer that contains 3 elements: createAt, taskId and objectID
	*/
	Index.prototype.addObject = function(content, objectID, callback) {
	  var indexObj = this;
	
	  if (arguments.length === 1 || typeof objectID === 'function') {
	    callback = objectID;
	    objectID = undefined;
	  }
	
	  return this.as._jsonRequest({
	    method: objectID !== undefined ?
	    'PUT' : // update or create
	    'POST', // create (API generates an objectID)
	    url: '/1/indexes/' + encodeURIComponent(indexObj.indexName) + // create
	    (objectID !== undefined ? '/' + encodeURIComponent(objectID) : ''), // update or create
	    body: content,
	    hostType: 'write',
	    callback: callback
	  });
	};
	
	/*
	* Add several objects
	*
	* @param objects contains an array of objects to add
	* @param callback (optional) the result callback called with two arguments:
	*  error: null or Error('message')
	*  content: the server answer that updateAt and taskID
	*/
	Index.prototype.addObjects = function(objects, callback) {
	  var isArray = __webpack_require__(1339);
	  var usage = 'Usage: index.addObjects(arrayOfObjects[, callback])';
	
	  if (!isArray(objects)) {
	    throw new Error(usage);
	  }
	
	  var indexObj = this;
	  var postObj = {
	    requests: []
	  };
	  for (var i = 0; i < objects.length; ++i) {
	    var request = {
	      action: 'addObject',
	      body: objects[i]
	    };
	    postObj.requests.push(request);
	  }
	  return this.as._jsonRequest({
	    method: 'POST',
	    url: '/1/indexes/' + encodeURIComponent(indexObj.indexName) + '/batch',
	    body: postObj,
	    hostType: 'write',
	    callback: callback
	  });
	};
	
	/*
	* Update partially an object (only update attributes passed in argument)
	*
	* @param partialObject contains the javascript attributes to override, the
	*  object must contains an objectID attribute
	* @param createIfNotExists (optional) if false, avoid an automatic creation of the object
	* @param callback (optional) the result callback called with two arguments:
	*  error: null or Error('message')
	*  content: the server answer that contains 3 elements: createAt, taskId and objectID
	*/
	Index.prototype.partialUpdateObject = function(partialObject, createIfNotExists, callback) {
	  if (arguments.length === 1 || typeof createIfNotExists === 'function') {
	    callback = createIfNotExists;
	    createIfNotExists = undefined;
	  }
	
	  var indexObj = this;
	  var url = '/1/indexes/' + encodeURIComponent(indexObj.indexName) + '/' + encodeURIComponent(partialObject.objectID) + '/partial';
	  if (createIfNotExists === false) {
	    url += '?createIfNotExists=false';
	  }
	
	  return this.as._jsonRequest({
	    method: 'POST',
	    url: url,
	    body: partialObject,
	    hostType: 'write',
	    callback: callback
	  });
	};
	
	/*
	* Partially Override the content of several objects
	*
	* @param objects contains an array of objects to update (each object must contains a objectID attribute)
	* @param callback (optional) the result callback called with two arguments:
	*  error: null or Error('message')
	*  content: the server answer that updateAt and taskID
	*/
	Index.prototype.partialUpdateObjects = function(objects, callback) {
	  var isArray = __webpack_require__(1339);
	  var usage = 'Usage: index.partialUpdateObjects(arrayOfObjects[, callback])';
	
	  if (!isArray(objects)) {
	    throw new Error(usage);
	  }
	
	  var indexObj = this;
	  var postObj = {
	    requests: []
	  };
	  for (var i = 0; i < objects.length; ++i) {
	    var request = {
	      action: 'partialUpdateObject',
	      objectID: objects[i].objectID,
	      body: objects[i]
	    };
	    postObj.requests.push(request);
	  }
	  return this.as._jsonRequest({
	    method: 'POST',
	    url: '/1/indexes/' + encodeURIComponent(indexObj.indexName) + '/batch',
	    body: postObj,
	    hostType: 'write',
	    callback: callback
	  });
	};
	
	/*
	* Override the content of object
	*
	* @param object contains the javascript object to save, the object must contains an objectID attribute
	* @param callback (optional) the result callback called with two arguments:
	*  error: null or Error('message')
	*  content: the server answer that updateAt and taskID
	*/
	Index.prototype.saveObject = function(object, callback) {
	  var indexObj = this;
	  return this.as._jsonRequest({
	    method: 'PUT',
	    url: '/1/indexes/' + encodeURIComponent(indexObj.indexName) + '/' + encodeURIComponent(object.objectID),
	    body: object,
	    hostType: 'write',
	    callback: callback
	  });
	};
	
	/*
	* Override the content of several objects
	*
	* @param objects contains an array of objects to update (each object must contains a objectID attribute)
	* @param callback (optional) the result callback called with two arguments:
	*  error: null or Error('message')
	*  content: the server answer that updateAt and taskID
	*/
	Index.prototype.saveObjects = function(objects, callback) {
	  var isArray = __webpack_require__(1339);
	  var usage = 'Usage: index.saveObjects(arrayOfObjects[, callback])';
	
	  if (!isArray(objects)) {
	    throw new Error(usage);
	  }
	
	  var indexObj = this;
	  var postObj = {
	    requests: []
	  };
	  for (var i = 0; i < objects.length; ++i) {
	    var request = {
	      action: 'updateObject',
	      objectID: objects[i].objectID,
	      body: objects[i]
	    };
	    postObj.requests.push(request);
	  }
	  return this.as._jsonRequest({
	    method: 'POST',
	    url: '/1/indexes/' + encodeURIComponent(indexObj.indexName) + '/batch',
	    body: postObj,
	    hostType: 'write',
	    callback: callback
	  });
	};
	
	/*
	* Delete an object from the index
	*
	* @param objectID the unique identifier of object to delete
	* @param callback (optional) the result callback called with two arguments:
	*  error: null or Error('message')
	*  content: the server answer that contains 3 elements: createAt, taskId and objectID
	*/
	Index.prototype.deleteObject = function(objectID, callback) {
	  if (typeof objectID === 'function' || typeof objectID !== 'string' && typeof objectID !== 'number') {
	    var err = new errors.AlgoliaSearchError('Cannot delete an object without an objectID');
	    callback = objectID;
	    if (typeof callback === 'function') {
	      return callback(err);
	    }
	
	    return this.as._promise.reject(err);
	  }
	
	  var indexObj = this;
	  return this.as._jsonRequest({
	    method: 'DELETE',
	    url: '/1/indexes/' + encodeURIComponent(indexObj.indexName) + '/' + encodeURIComponent(objectID),
	    hostType: 'write',
	    callback: callback
	  });
	};
	
	/*
	* Delete several objects from an index
	*
	* @param objectIDs contains an array of objectID to delete
	* @param callback (optional) the result callback called with two arguments:
	*  error: null or Error('message')
	*  content: the server answer that contains 3 elements: createAt, taskId and objectID
	*/
	Index.prototype.deleteObjects = function(objectIDs, callback) {
	  var isArray = __webpack_require__(1339);
	  var map = __webpack_require__(1340);
	
	  var usage = 'Usage: index.deleteObjects(arrayOfObjectIDs[, callback])';
	
	  if (!isArray(objectIDs)) {
	    throw new Error(usage);
	  }
	
	  var indexObj = this;
	  var postObj = {
	    requests: map(objectIDs, function prepareRequest(objectID) {
	      return {
	        action: 'deleteObject',
	        objectID: objectID,
	        body: {
	          objectID: objectID
	        }
	      };
	    })
	  };
	
	  return this.as._jsonRequest({
	    method: 'POST',
	    url: '/1/indexes/' + encodeURIComponent(indexObj.indexName) + '/batch',
	    body: postObj,
	    hostType: 'write',
	    callback: callback
	  });
	};
	
	/*
	* Delete all objects matching a query
	*
	* @param query the query string
	* @param params the optional query parameters
	* @param callback (optional) the result callback called with one argument
	*  error: null or Error('message')
	*/
	Index.prototype.deleteByQuery = function(query, params, callback) {
	  var clone = __webpack_require__(1335);
	  var map = __webpack_require__(1340);
	
	  var indexObj = this;
	  var client = indexObj.as;
	
	  if (arguments.length === 1 || typeof params === 'function') {
	    callback = params;
	    params = {};
	  } else {
	    params = clone(params);
	  }
	
	  params.attributesToRetrieve = 'objectID';
	  params.hitsPerPage = 1000;
	  params.distinct = false;
	
	  // when deleting, we should never use cache to get the
	  // search results
	  this.clearCache();
	
	  // there's a problem in how we use the promise chain,
	  // see how waitTask is done
	  var promise = this
	  .search(query, params)
	  .then(stopOrDelete);
	
	  function stopOrDelete(searchContent) {
	    // stop here
	    if (searchContent.nbHits === 0) {
	      // return indexObj.as._request.resolve();
	      return searchContent;
	    }
	
	    // continue and do a recursive call
	    var objectIDs = map(searchContent.hits, function getObjectID(object) {
	      return object.objectID;
	    });
	
	    return indexObj
	    .deleteObjects(objectIDs)
	    .then(waitTask)
	    .then(doDeleteByQuery);
	  }
	
	  function waitTask(deleteObjectsContent) {
	    return indexObj.waitTask(deleteObjectsContent.taskID);
	  }
	
	  function doDeleteByQuery() {
	    return indexObj.deleteByQuery(query, params);
	  }
	
	  if (!callback) {
	    return promise;
	  }
	
	  promise.then(success, failure);
	
	  function success() {
	    exitPromise(function exit() {
	      callback(null);
	    }, client._setTimeout || setTimeout);
	  }
	
	  function failure(err) {
	    exitPromise(function exit() {
	      callback(err);
	    }, client._setTimeout || setTimeout);
	  }
	};
	
	/*
	* Browse all content from an index using events. Basically this will do
	* .browse() -> .browseFrom -> .browseFrom -> .. until all the results are returned
	*
	* @param {string} query - The full text query
	* @param {Object} [queryParameters] - Any search query parameter
	* @return {EventEmitter}
	* @example
	* var browser = index.browseAll('cool songs', {
	*   tagFilters: 'public,comments',
	*   hitsPerPage: 500
	* });
	*
	* browser.on('result', function resultCallback(content) {
	*   console.log(content.hits);
	* });
	*
	* // if any error occurs, you get it
	* browser.on('error', function(err) {
	*   throw err;
	* });
	*
	* // when you have browsed the whole index, you get this event
	* browser.on('end', function() {
	*   console.log('finished');
	* });
	*
	* // at any point if you want to stop the browsing process, you can stop it manually
	* // otherwise it will go on and on
	* browser.stop();
	*
	* @see {@link https://www.algolia.com/doc/rest_api#Browse|Algolia REST API Documentation}
	*/
	Index.prototype.browseAll = function(query, queryParameters) {
	  if (typeof query === 'object') {
	    queryParameters = query;
	    query = undefined;
	  }
	
	  var merge = __webpack_require__(1334);
	
	  var IndexBrowser = __webpack_require__(1344);
	
	  var browser = new IndexBrowser();
	  var client = this.as;
	  var index = this;
	  var params = client._getSearchParams(
	    merge({}, queryParameters || {}, {
	      query: query
	    }), ''
	  );
	
	  // start browsing
	  browseLoop();
	
	  function browseLoop(cursor) {
	    if (browser._stopped) {
	      return;
	    }
	
	    var queryString;
	
	    if (cursor !== undefined) {
	      queryString = 'cursor=' + encodeURIComponent(cursor);
	    } else {
	      queryString = params;
	    }
	
	    client._jsonRequest({
	      method: 'GET',
	      url: '/1/indexes/' + encodeURIComponent(index.indexName) + '/browse?' + queryString,
	      hostType: 'read',
	      callback: browseCallback
	    });
	  }
	
	  function browseCallback(err, content) {
	    if (browser._stopped) {
	      return;
	    }
	
	    if (err) {
	      browser._error(err);
	      return;
	    }
	
	    browser._result(content);
	
	    // no cursor means we are finished browsing
	    if (content.cursor === undefined) {
	      browser._end();
	      return;
	    }
	
	    browseLoop(content.cursor);
	  }
	
	  return browser;
	};
	
	/*
	* Get a Typeahead.js adapter
	* @param searchParams contains an object with query parameters (see search for details)
	*/
	Index.prototype.ttAdapter = function(params) {
	  var self = this;
	  return function ttAdapter(query, syncCb, asyncCb) {
	    var cb;
	
	    if (typeof asyncCb === 'function') {
	      // typeahead 0.11
	      cb = asyncCb;
	    } else {
	      // pre typeahead 0.11
	      cb = syncCb;
	    }
	
	    self.search(query, params, function searchDone(err, content) {
	      if (err) {
	        cb(err);
	        return;
	      }
	
	      cb(content.hits);
	    });
	  };
	};
	
	/*
	* Wait the publication of a task on the server.
	* All server task are asynchronous and you can check with this method that the task is published.
	*
	* @param taskID the id of the task returned by server
	* @param callback the result callback with with two arguments:
	*  error: null or Error('message')
	*  content: the server answer that contains the list of results
	*/
	Index.prototype.waitTask = function(taskID, callback) {
	  // wait minimum 100ms before retrying
	  var baseDelay = 100;
	  // wait maximum 5s before retrying
	  var maxDelay = 5000;
	  var loop = 0;
	
	  // waitTask() must be handled differently from other methods,
	  // it's a recursive method using a timeout
	  var indexObj = this;
	  var client = indexObj.as;
	
	  var promise = retryLoop();
	
	  function retryLoop() {
	    return client._jsonRequest({
	      method: 'GET',
	      hostType: 'read',
	      url: '/1/indexes/' + encodeURIComponent(indexObj.indexName) + '/task/' + taskID
	    }).then(function success(content) {
	      loop++;
	      var delay = baseDelay * loop * loop;
	      if (delay > maxDelay) {
	        delay = maxDelay;
	      }
	
	      if (content.status !== 'published') {
	        return client._promise.delay(delay).then(retryLoop);
	      }
	
	      return content;
	    });
	  }
	
	  if (!callback) {
	    return promise;
	  }
	
	  promise.then(successCb, failureCb);
	
	  function successCb(content) {
	    exitPromise(function exit() {
	      callback(null, content);
	    }, client._setTimeout || setTimeout);
	  }
	
	  function failureCb(err) {
	    exitPromise(function exit() {
	      callback(err);
	    }, client._setTimeout || setTimeout);
	  }
	};
	
	/*
	* This function deletes the index content. Settings and index specific API keys are kept untouched.
	*
	* @param callback (optional) the result callback called with two arguments
	*  error: null or Error('message')
	*  content: the settings object or the error message if a failure occured
	*/
	Index.prototype.clearIndex = function(callback) {
	  var indexObj = this;
	  return this.as._jsonRequest({
	    method: 'POST',
	    url: '/1/indexes/' + encodeURIComponent(indexObj.indexName) + '/clear',
	    hostType: 'write',
	    callback: callback
	  });
	};
	
	/*
	* Get settings of this index
	*
	* @param callback (optional) the result callback called with two arguments
	*  error: null or Error('message')
	*  content: the settings object or the error message if a failure occured
	*/
	Index.prototype.getSettings = function(callback) {
	  var indexObj = this;
	  return this.as._jsonRequest({
	    method: 'GET',
	    url: '/1/indexes/' + encodeURIComponent(indexObj.indexName) + '/settings?getVersion=2',
	    hostType: 'read',
	    callback: callback
	  });
	};
	
	Index.prototype.searchSynonyms = function(params, callback) {
	  if (typeof params === 'function') {
	    callback = params;
	    params = {};
	  } else if (params === undefined) {
	    params = {};
	  }
	
	  return this.as._jsonRequest({
	    method: 'POST',
	    url: '/1/indexes/' + encodeURIComponent(this.indexName) + '/synonyms/search',
	    body: params,
	    hostType: 'read',
	    callback: callback
	  });
	};
	
	Index.prototype.saveSynonym = function(synonym, opts, callback) {
	  if (typeof opts === 'function') {
	    callback = opts;
	    opts = {};
	  } else if (opts === undefined) {
	    opts = {};
	  }
	
	  return this.as._jsonRequest({
	    method: 'PUT',
	    url: '/1/indexes/' + encodeURIComponent(this.indexName) + '/synonyms/' + encodeURIComponent(synonym.objectID) +
	      '?forwardToSlaves=' + (opts.forwardToSlaves ? 'true' : 'false'),
	    body: synonym,
	    hostType: 'write',
	    callback: callback
	  });
	};
	
	Index.prototype.getSynonym = function(objectID, callback) {
	  return this.as._jsonRequest({
	    method: 'GET',
	    url: '/1/indexes/' + encodeURIComponent(this.indexName) + '/synonyms/' + encodeURIComponent(objectID),
	    hostType: 'read',
	    callback: callback
	  });
	};
	
	Index.prototype.deleteSynonym = function(objectID, opts, callback) {
	  if (typeof opts === 'function') {
	    callback = opts;
	    opts = {};
	  } else if (opts === undefined) {
	    opts = {};
	  }
	
	  return this.as._jsonRequest({
	    method: 'DELETE',
	    url: '/1/indexes/' + encodeURIComponent(this.indexName) + '/synonyms/' + encodeURIComponent(objectID) +
	      '?forwardToSlaves=' + (opts.forwardToSlaves ? 'true' : 'false'),
	    hostType: 'write',
	    callback: callback
	  });
	};
	
	Index.prototype.clearSynonyms = function(opts, callback) {
	  if (typeof opts === 'function') {
	    callback = opts;
	    opts = {};
	  } else if (opts === undefined) {
	    opts = {};
	  }
	
	  return this.as._jsonRequest({
	    method: 'POST',
	    url: '/1/indexes/' + encodeURIComponent(this.indexName) + '/synonyms/clear' +
	      '?forwardToSlaves=' + (opts.forwardToSlaves ? 'true' : 'false'),
	    hostType: 'write',
	    callback: callback
	  });
	};
	
	Index.prototype.batchSynonyms = function(synonyms, opts, callback) {
	  if (typeof opts === 'function') {
	    callback = opts;
	    opts = {};
	  } else if (opts === undefined) {
	    opts = {};
	  }
	
	  return this.as._jsonRequest({
	    method: 'POST',
	    url: '/1/indexes/' + encodeURIComponent(this.indexName) + '/synonyms/batch' +
	      '?forwardToSlaves=' + (opts.forwardToSlaves ? 'true' : 'false') +
	      '&replaceExistingSynonyms=' + (opts.replaceExistingSynonyms ? 'true' : 'false'),
	    hostType: 'write',
	    body: synonyms,
	    callback: callback
	  });
	};
	
	/*
	* Set settings for this index
	*
	* @param settigns the settings object that can contains :
	* - minWordSizefor1Typo: (integer) the minimum number of characters to accept one typo (default = 3).
	* - minWordSizefor2Typos: (integer) the minimum number of characters to accept two typos (default = 7).
	* - hitsPerPage: (integer) the number of hits per page (default = 10).
	* - attributesToRetrieve: (array of strings) default list of attributes to retrieve in objects.
	*   If set to null, all attributes are retrieved.
	* - attributesToHighlight: (array of strings) default list of attributes to highlight.
	*   If set to null, all indexed attributes are highlighted.
	* - attributesToSnippet**: (array of strings) default list of attributes to snippet alongside the number
	* of words to return (syntax is attributeName:nbWords).
	*   By default no snippet is computed. If set to null, no snippet is computed.
	* - attributesToIndex: (array of strings) the list of fields you want to index.
	*   If set to null, all textual and numerical attributes of your objects are indexed,
	*   but you should update it to get optimal results.
	*   This parameter has two important uses:
	*     - Limit the attributes to index: For example if you store a binary image in base64,
	*     you want to store it and be able to
	*       retrieve it but you don't want to search in the base64 string.
	*     - Control part of the ranking*: (see the ranking parameter for full explanation)
	*     Matches in attributes at the beginning of
	*       the list will be considered more important than matches in attributes further down the list.
	*       In one attribute, matching text at the beginning of the attribute will be
	*       considered more important than text after, you can disable
	*       this behavior if you add your attribute inside `unordered(AttributeName)`,
	*       for example attributesToIndex: ["title", "unordered(text)"].
	* - attributesForFaceting: (array of strings) The list of fields you want to use for faceting.
	*   All strings in the attribute selected for faceting are extracted and added as a facet.
	*   If set to null, no attribute is used for faceting.
	* - attributeForDistinct: (string) The attribute name used for the Distinct feature.
	* This feature is similar to the SQL "distinct" keyword: when enabled
	*   in query with the distinct=1 parameter, all hits containing a duplicate
	*   value for this attribute are removed from results.
	*   For example, if the chosen attribute is show_name and several hits have
	*   the same value for show_name, then only the best one is kept and others are removed.
	* - ranking: (array of strings) controls the way results are sorted.
	*   We have six available criteria:
	*    - typo: sort according to number of typos,
	*    - geo: sort according to decreassing distance when performing a geo-location based search,
	*    - proximity: sort according to the proximity of query words in hits,
	*    - attribute: sort according to the order of attributes defined by attributesToIndex,
	*    - exact:
	*        - if the user query contains one word: sort objects having an attribute
	*        that is exactly the query word before others.
	*          For example if you search for the "V" TV show, you want to find it
	*          with the "V" query and avoid to have all popular TV
	*          show starting by the v letter before it.
	*        - if the user query contains multiple words: sort according to the
	*        number of words that matched exactly (and not as a prefix).
	*    - custom: sort according to a user defined formula set in **customRanking** attribute.
	*   The standard order is ["typo", "geo", "proximity", "attribute", "exact", "custom"]
	* - customRanking: (array of strings) lets you specify part of the ranking.
	*   The syntax of this condition is an array of strings containing attributes
	*   prefixed by asc (ascending order) or desc (descending order) operator.
	*   For example `"customRanking" => ["desc(population)", "asc(name)"]`
	* - queryType: Select how the query words are interpreted, it can be one of the following value:
	*   - prefixAll: all query words are interpreted as prefixes,
	*   - prefixLast: only the last word is interpreted as a prefix (default behavior),
	*   - prefixNone: no query word is interpreted as a prefix. This option is not recommended.
	* - highlightPreTag: (string) Specify the string that is inserted before
	* the highlighted parts in the query result (default to "<em>").
	* - highlightPostTag: (string) Specify the string that is inserted after
	* the highlighted parts in the query result (default to "</em>").
	* - optionalWords: (array of strings) Specify a list of words that should
	* be considered as optional when found in the query.
	* @param callback (optional) the result callback called with two arguments
	*  error: null or Error('message')
	*  content: the server answer or the error message if a failure occured
	*/
	Index.prototype.setSettings = function(settings, opts, callback) {
	  if (arguments.length === 1 || typeof opts === 'function') {
	    callback = opts;
	    opts = {};
	  }
	
	  var forwardToSlaves = opts.forwardToSlaves || false;
	
	  var indexObj = this;
	  return this.as._jsonRequest({
	    method: 'PUT',
	    url: '/1/indexes/' + encodeURIComponent(indexObj.indexName) + '/settings?forwardToSlaves='
	      + (forwardToSlaves ? 'true' : 'false'),
	    hostType: 'write',
	    body: settings,
	    callback: callback
	  });
	};
	
	/*
	* List all existing user keys associated to this index
	*
	* @param callback the result callback called with two arguments
	*  error: null or Error('message')
	*  content: the server answer with user keys list
	*/
	Index.prototype.listUserKeys = function(callback) {
	  var indexObj = this;
	  return this.as._jsonRequest({
	    method: 'GET',
	    url: '/1/indexes/' + encodeURIComponent(indexObj.indexName) + '/keys',
	    hostType: 'read',
	    callback: callback
	  });
	};
	
	/*
	* Get ACL of a user key associated to this index
	*
	* @param key
	* @param callback the result callback called with two arguments
	*  error: null or Error('message')
	*  content: the server answer with user keys list
	*/
	Index.prototype.getUserKeyACL = function(key, callback) {
	  var indexObj = this;
	  return this.as._jsonRequest({
	    method: 'GET',
	    url: '/1/indexes/' + encodeURIComponent(indexObj.indexName) + '/keys/' + key,
	    hostType: 'read',
	    callback: callback
	  });
	};
	
	/*
	* Delete an existing user key associated to this index
	*
	* @param key
	* @param callback the result callback called with two arguments
	*  error: null or Error('message')
	*  content: the server answer with user keys list
	*/
	Index.prototype.deleteUserKey = function(key, callback) {
	  var indexObj = this;
	  return this.as._jsonRequest({
	    method: 'DELETE',
	    url: '/1/indexes/' + encodeURIComponent(indexObj.indexName) + '/keys/' + key,
	    hostType: 'write',
	    callback: callback
	  });
	};
	
	/*
	* Add a new API key to this index
	*
	* @param {string[]} acls - The list of ACL for this key. Defined by an array of strings that
	*   can contains the following values:
	*     - search: allow to search (https and http)
	*     - addObject: allows to add/update an object in the index (https only)
	*     - deleteObject : allows to delete an existing object (https only)
	*     - deleteIndex : allows to delete index content (https only)
	*     - settings : allows to get index settings (https only)
	*     - editSettings : allows to change index settings (https only)
	* @param {Object} [params] - Optionnal parameters to set for the key
	* @param {number} params.validity - Number of seconds after which the key will
	* be automatically removed (0 means no time limit for this key)
	* @param {number} params.maxQueriesPerIPPerHour - Number of API calls allowed from an IP address per hour
	* @param {number} params.maxHitsPerQuery - Number of hits this API key can retrieve in one call
	* @param {string} params.description - A description for your key
	* @param {string[]} params.referers - A list of authorized referers
	* @param {Object} params.queryParameters - Force the key to use specific query parameters
	* @param {Function} callback - The result callback called with two arguments
	*   error: null or Error('message')
	*   content: the server answer with user keys list
	* @return {Promise|undefined} Returns a promise if no callback given
	* @example
	* index.addUserKey(['search'], {
	*   validity: 300,
	*   maxQueriesPerIPPerHour: 2000,
	*   maxHitsPerQuery: 3,
	*   description: 'Eat three fruits',
	*   referers: ['*.algolia.com'],
	*   queryParameters: {
	*     tagFilters: ['public'],
	*   }
	* })
	* @see {@link https://www.algolia.com/doc/rest_api#AddIndexKey|Algolia REST API Documentation}
	*/
	Index.prototype.addUserKey = function(acls, params, callback) {
	  var isArray = __webpack_require__(1339);
	  var usage = 'Usage: index.addUserKey(arrayOfAcls[, params, callback])';
	
	  if (!isArray(acls)) {
	    throw new Error(usage);
	  }
	
	  if (arguments.length === 1 || typeof params === 'function') {
	    callback = params;
	    params = null;
	  }
	
	  var postObj = {
	    acl: acls
	  };
	
	  if (params) {
	    postObj.validity = params.validity;
	    postObj.maxQueriesPerIPPerHour = params.maxQueriesPerIPPerHour;
	    postObj.maxHitsPerQuery = params.maxHitsPerQuery;
	    postObj.description = params.description;
	
	    if (params.queryParameters) {
	      postObj.queryParameters = this.as._getSearchParams(params.queryParameters, '');
	    }
	
	    postObj.referers = params.referers;
	  }
	
	  return this.as._jsonRequest({
	    method: 'POST',
	    url: '/1/indexes/' + encodeURIComponent(this.indexName) + '/keys',
	    body: postObj,
	    hostType: 'write',
	    callback: callback
	  });
	};
	
	/**
	* Add an existing user key associated to this index
	* @deprecated use index.addUserKey()
	*/
	Index.prototype.addUserKeyWithValidity = deprecate(function deprecatedAddUserKeyWithValidity(acls, params, callback) {
	  return this.addUserKey(acls, params, callback);
	}, deprecatedMessage('index.addUserKeyWithValidity()', 'index.addUserKey()'));
	
	/**
	* Update an existing API key of this index
	* @param {string} key - The key to update
	* @param {string[]} acls - The list of ACL for this key. Defined by an array of strings that
	*   can contains the following values:
	*     - search: allow to search (https and http)
	*     - addObject: allows to add/update an object in the index (https only)
	*     - deleteObject : allows to delete an existing object (https only)
	*     - deleteIndex : allows to delete index content (https only)
	*     - settings : allows to get index settings (https only)
	*     - editSettings : allows to change index settings (https only)
	* @param {Object} [params] - Optionnal parameters to set for the key
	* @param {number} params.validity - Number of seconds after which the key will
	* be automatically removed (0 means no time limit for this key)
	* @param {number} params.maxQueriesPerIPPerHour - Number of API calls allowed from an IP address per hour
	* @param {number} params.maxHitsPerQuery - Number of hits this API key can retrieve in one call
	* @param {string} params.description - A description for your key
	* @param {string[]} params.referers - A list of authorized referers
	* @param {Object} params.queryParameters - Force the key to use specific query parameters
	* @param {Function} callback - The result callback called with two arguments
	*   error: null or Error('message')
	*   content: the server answer with user keys list
	* @return {Promise|undefined} Returns a promise if no callback given
	* @example
	* index.updateUserKey('APIKEY', ['search'], {
	*   validity: 300,
	*   maxQueriesPerIPPerHour: 2000,
	*   maxHitsPerQuery: 3,
	*   description: 'Eat three fruits',
	*   referers: ['*.algolia.com'],
	*   queryParameters: {
	*     tagFilters: ['public'],
	*   }
	* })
	* @see {@link https://www.algolia.com/doc/rest_api#UpdateIndexKey|Algolia REST API Documentation}
	*/
	Index.prototype.updateUserKey = function(key, acls, params, callback) {
	  var isArray = __webpack_require__(1339);
	  var usage = 'Usage: index.updateUserKey(key, arrayOfAcls[, params, callback])';
	
	  if (!isArray(acls)) {
	    throw new Error(usage);
	  }
	
	  if (arguments.length === 2 || typeof params === 'function') {
	    callback = params;
	    params = null;
	  }
	
	  var putObj = {
	    acl: acls
	  };
	
	  if (params) {
	    putObj.validity = params.validity;
	    putObj.maxQueriesPerIPPerHour = params.maxQueriesPerIPPerHour;
	    putObj.maxHitsPerQuery = params.maxHitsPerQuery;
	    putObj.description = params.description;
	
	    if (params.queryParameters) {
	      putObj.queryParameters = this.as._getSearchParams(params.queryParameters, '');
	    }
	
	    putObj.referers = params.referers;
	  }
	
	  return this.as._jsonRequest({
	    method: 'PUT',
	    url: '/1/indexes/' + encodeURIComponent(this.indexName) + '/keys/' + key,
	    body: putObj,
	    hostType: 'write',
	    callback: callback
	  });
	};


/***/ }),
/* 1329 */
/***/ (function(module, exports) {

	if (typeof Object.create === 'function') {
	  // implementation from standard node.js 'util' module
	  module.exports = function inherits(ctor, superCtor) {
	    ctor.super_ = superCtor
	    ctor.prototype = Object.create(superCtor.prototype, {
	      constructor: {
	        value: ctor,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	  };
	} else {
	  // old school shim for old browsers
	  module.exports = function inherits(ctor, superCtor) {
	    ctor.super_ = superCtor
	    var TempCtor = function () {}
	    TempCtor.prototype = superCtor.prototype
	    ctor.prototype = new TempCtor()
	    ctor.prototype.constructor = ctor
	  }
	}


/***/ }),
/* 1330 */
/***/ (function(module, exports, __webpack_require__) {

	var buildSearchMethod = __webpack_require__(1331);
	
	module.exports = IndexCore;
	
	/*
	* Index class constructor.
	* You should not use this method directly but use initIndex() function
	*/
	function IndexCore(algoliasearch, indexName) {
	  this.indexName = indexName;
	  this.as = algoliasearch;
	  this.typeAheadArgs = null;
	  this.typeAheadValueOption = null;
	
	  // make sure every index instance has it's own cache
	  this.cache = {};
	}
	
	/*
	* Clear all queries in cache
	*/
	IndexCore.prototype.clearCache = function() {
	  this.cache = {};
	};
	
	/*
	* Search inside the index using XMLHttpRequest request (Using a POST query to
	* minimize number of OPTIONS queries: Cross-Origin Resource Sharing).
	*
	* @param query the full text query
	* @param args (optional) if set, contains an object with query parameters:
	* - page: (integer) Pagination parameter used to select the page to retrieve.
	*                   Page is zero-based and defaults to 0. Thus,
	*                   to retrieve the 10th page you need to set page=9
	* - hitsPerPage: (integer) Pagination parameter used to select the number of hits per page. Defaults to 20.
	* - attributesToRetrieve: a string that contains the list of object attributes
	* you want to retrieve (let you minimize the answer size).
	*   Attributes are separated with a comma (for example "name,address").
	*   You can also use an array (for example ["name","address"]).
	*   By default, all attributes are retrieved. You can also use '*' to retrieve all
	*   values when an attributesToRetrieve setting is specified for your index.
	* - attributesToHighlight: a string that contains the list of attributes you
	*   want to highlight according to the query.
	*   Attributes are separated by a comma. You can also use an array (for example ["name","address"]).
	*   If an attribute has no match for the query, the raw value is returned.
	*   By default all indexed text attributes are highlighted.
	*   You can use `*` if you want to highlight all textual attributes.
	*   Numerical attributes are not highlighted.
	*   A matchLevel is returned for each highlighted attribute and can contain:
	*      - full: if all the query terms were found in the attribute,
	*      - partial: if only some of the query terms were found,
	*      - none: if none of the query terms were found.
	* - attributesToSnippet: a string that contains the list of attributes to snippet alongside
	* the number of words to return (syntax is `attributeName:nbWords`).
	*    Attributes are separated by a comma (Example: attributesToSnippet=name:10,content:10).
	*    You can also use an array (Example: attributesToSnippet: ['name:10','content:10']).
	*    By default no snippet is computed.
	* - minWordSizefor1Typo: the minimum number of characters in a query word to accept one typo in this word.
	* Defaults to 3.
	* - minWordSizefor2Typos: the minimum number of characters in a query word
	* to accept two typos in this word. Defaults to 7.
	* - getRankingInfo: if set to 1, the result hits will contain ranking
	* information in _rankingInfo attribute.
	* - aroundLatLng: search for entries around a given
	* latitude/longitude (specified as two floats separated by a comma).
	*   For example aroundLatLng=47.316669,5.016670).
	*   You can specify the maximum distance in meters with the aroundRadius parameter (in meters)
	*   and the precision for ranking with aroundPrecision
	*   (for example if you set aroundPrecision=100, two objects that are distant of
	*   less than 100m will be considered as identical for "geo" ranking parameter).
	*   At indexing, you should specify geoloc of an object with the _geoloc attribute
	*   (in the form {"_geoloc":{"lat":48.853409, "lng":2.348800}})
	* - insideBoundingBox: search entries inside a given area defined by the two extreme points
	* of a rectangle (defined by 4 floats: p1Lat,p1Lng,p2Lat,p2Lng).
	*   For example insideBoundingBox=47.3165,4.9665,47.3424,5.0201).
	*   At indexing, you should specify geoloc of an object with the _geoloc attribute
	*   (in the form {"_geoloc":{"lat":48.853409, "lng":2.348800}})
	* - numericFilters: a string that contains the list of numeric filters you want to
	* apply separated by a comma.
	*   The syntax of one filter is `attributeName` followed by `operand` followed by `value`.
	*   Supported operands are `<`, `<=`, `=`, `>` and `>=`.
	*   You can have multiple conditions on one attribute like for example numericFilters=price>100,price<1000.
	*   You can also use an array (for example numericFilters: ["price>100","price<1000"]).
	* - tagFilters: filter the query by a set of tags. You can AND tags by separating them by commas.
	*   To OR tags, you must add parentheses. For example, tags=tag1,(tag2,tag3) means tag1 AND (tag2 OR tag3).
	*   You can also use an array, for example tagFilters: ["tag1",["tag2","tag3"]]
	*   means tag1 AND (tag2 OR tag3).
	*   At indexing, tags should be added in the _tags** attribute
	*   of objects (for example {"_tags":["tag1","tag2"]}).
	* - facetFilters: filter the query by a list of facets.
	*   Facets are separated by commas and each facet is encoded as `attributeName:value`.
	*   For example: `facetFilters=category:Book,author:John%20Doe`.
	*   You can also use an array (for example `["category:Book","author:John%20Doe"]`).
	* - facets: List of object attributes that you want to use for faceting.
	*   Comma separated list: `"category,author"` or array `['category','author']`
	*   Only attributes that have been added in **attributesForFaceting** index setting
	*   can be used in this parameter.
	*   You can also use `*` to perform faceting on all attributes specified in **attributesForFaceting**.
	* - queryType: select how the query words are interpreted, it can be one of the following value:
	*    - prefixAll: all query words are interpreted as prefixes,
	*    - prefixLast: only the last word is interpreted as a prefix (default behavior),
	*    - prefixNone: no query word is interpreted as a prefix. This option is not recommended.
	* - optionalWords: a string that contains the list of words that should
	* be considered as optional when found in the query.
	*   Comma separated and array are accepted.
	* - distinct: If set to 1, enable the distinct feature (disabled by default)
	* if the attributeForDistinct index setting is set.
	*   This feature is similar to the SQL "distinct" keyword: when enabled
	*   in a query with the distinct=1 parameter,
	*   all hits containing a duplicate value for the attributeForDistinct attribute are removed from results.
	*   For example, if the chosen attribute is show_name and several hits have
	*   the same value for show_name, then only the best
	*   one is kept and others are removed.
	* - restrictSearchableAttributes: List of attributes you want to use for
	* textual search (must be a subset of the attributesToIndex index setting)
	* either comma separated or as an array
	* @param callback the result callback called with two arguments:
	*  error: null or Error('message'). If false, the content contains the error.
	*  content: the server answer that contains the list of results.
	*/
	IndexCore.prototype.search = buildSearchMethod('query');
	
	/*
	* -- BETA --
	* Search a record similar to the query inside the index using XMLHttpRequest request (Using a POST query to
	* minimize number of OPTIONS queries: Cross-Origin Resource Sharing).
	*
	* @param query the similar query
	* @param args (optional) if set, contains an object with query parameters.
	*   All search parameters are supported (see search function), restrictSearchableAttributes and facetFilters
	*   are the two most useful to restrict the similar results and get more relevant content
	*/
	IndexCore.prototype.similarSearch = buildSearchMethod('similarQuery');
	
	/*
	* Browse index content. The response content will have a `cursor` property that you can use
	* to browse subsequent pages for this query. Use `index.browseFrom(cursor)` when you want.
	*
	* @param {string} query - The full text query
	* @param {Object} [queryParameters] - Any search query parameter
	* @param {Function} [callback] - The result callback called with two arguments
	*   error: null or Error('message')
	*   content: the server answer with the browse result
	* @return {Promise|undefined} Returns a promise if no callback given
	* @example
	* index.browse('cool songs', {
	*   tagFilters: 'public,comments',
	*   hitsPerPage: 500
	* }, callback);
	* @see {@link https://www.algolia.com/doc/rest_api#Browse|Algolia REST API Documentation}
	*/
	IndexCore.prototype.browse = function(query, queryParameters, callback) {
	  var merge = __webpack_require__(1334);
	
	  var indexObj = this;
	
	  var page;
	  var hitsPerPage;
	
	  // we check variadic calls that are not the one defined
	  // .browse()/.browse(fn)
	  // => page = 0
	  if (arguments.length === 0 || arguments.length === 1 && typeof arguments[0] === 'function') {
	    page = 0;
	    callback = arguments[0];
	    query = undefined;
	  } else if (typeof arguments[0] === 'number') {
	    // .browse(2)/.browse(2, 10)/.browse(2, fn)/.browse(2, 10, fn)
	    page = arguments[0];
	    if (typeof arguments[1] === 'number') {
	      hitsPerPage = arguments[1];
	    } else if (typeof arguments[1] === 'function') {
	      callback = arguments[1];
	      hitsPerPage = undefined;
	    }
	    query = undefined;
	    queryParameters = undefined;
	  } else if (typeof arguments[0] === 'object') {
	    // .browse(queryParameters)/.browse(queryParameters, cb)
	    if (typeof arguments[1] === 'function') {
	      callback = arguments[1];
	    }
	    queryParameters = arguments[0];
	    query = undefined;
	  } else if (typeof arguments[0] === 'string' && typeof arguments[1] === 'function') {
	    // .browse(query, cb)
	    callback = arguments[1];
	    queryParameters = undefined;
	  }
	
	  // otherwise it's a .browse(query)/.browse(query, queryParameters)/.browse(query, queryParameters, cb)
	
	  // get search query parameters combining various possible calls
	  // to .browse();
	  queryParameters = merge({}, queryParameters || {}, {
	    page: page,
	    hitsPerPage: hitsPerPage,
	    query: query
	  });
	
	  var params = this.as._getSearchParams(queryParameters, '');
	
	  return this.as._jsonRequest({
	    method: 'GET',
	    url: '/1/indexes/' + encodeURIComponent(indexObj.indexName) + '/browse?' + params,
	    hostType: 'read',
	    callback: callback
	  });
	};
	
	/*
	* Continue browsing from a previous position (cursor), obtained via a call to `.browse()`.
	*
	* @param {string} query - The full text query
	* @param {Object} [queryParameters] - Any search query parameter
	* @param {Function} [callback] - The result callback called with two arguments
	*   error: null or Error('message')
	*   content: the server answer with the browse result
	* @return {Promise|undefined} Returns a promise if no callback given
	* @example
	* index.browseFrom('14lkfsakl32', callback);
	* @see {@link https://www.algolia.com/doc/rest_api#Browse|Algolia REST API Documentation}
	*/
	IndexCore.prototype.browseFrom = function(cursor, callback) {
	  return this.as._jsonRequest({
	    method: 'GET',
	    url: '/1/indexes/' + encodeURIComponent(this.indexName) + '/browse?cursor=' + encodeURIComponent(cursor),
	    hostType: 'read',
	    callback: callback
	  });
	};
	
	/*
	* Search in facets
	* https://www.algolia.com/doc/rest-api/search#search-in-a-facet
	*
	* @param {string} params.facetName Facet name, name of the attribute to search for values in.
	* Must be declared as a facet
	* @param {string} params.facetQuery Query for the facet search
	* @param {string} [params.*] Any search parameter of Algolia,
	* see https://www.algolia.com/doc/api-client/javascript/search#search-parameters
	* Pagination is not supported. The page and hitsPerPage parameters will be ignored.
	* @param callback (optional)
	*/
	IndexCore.prototype.searchFacet = function(params, callback) {
	  var clone = __webpack_require__(1335);
	  var omit = __webpack_require__(1336);
	  var usage = 'Usage: index.searchFacet({facetName, facetQuery, ...params}[, callback])';
	
	  if (params.facetName === undefined || params.facetQuery === undefined) {
	    throw new Error(usage);
	  }
	
	  var facetName = params.facetName;
	  var filteredParams = omit(clone(params), function(keyName) {
	    return keyName === 'facetName';
	  });
	  var searchParameters = this.as._getSearchParams(filteredParams, '');
	
	  return this.as._jsonRequest({
	    method: 'POST',
	    url: '/1/indexes/' +
	      encodeURIComponent(this.indexName) + '/facets/' + encodeURIComponent(facetName) + '/query',
	    hostType: 'read',
	    body: {params: searchParameters},
	    callback: callback
	  });
	};
	
	IndexCore.prototype._search = function(params, url, callback) {
	  return this.as._jsonRequest({
	    cache: this.cache,
	    method: 'POST',
	    url: url || '/1/indexes/' + encodeURIComponent(this.indexName) + '/query',
	    body: {params: params},
	    hostType: 'read',
	    fallback: {
	      method: 'GET',
	      url: '/1/indexes/' + encodeURIComponent(this.indexName),
	      body: {params: params}
	    },
	    callback: callback
	  });
	};
	
	/*
	* Get an object from this index
	*
	* @param objectID the unique identifier of the object to retrieve
	* @param attrs (optional) if set, contains the array of attribute names to retrieve
	* @param callback (optional) the result callback called with two arguments
	*  error: null or Error('message')
	*  content: the object to retrieve or the error message if a failure occured
	*/
	IndexCore.prototype.getObject = function(objectID, attrs, callback) {
	  var indexObj = this;
	
	  if (arguments.length === 1 || typeof attrs === 'function') {
	    callback = attrs;
	    attrs = undefined;
	  }
	
	  var params = '';
	  if (attrs !== undefined) {
	    params = '?attributes=';
	    for (var i = 0; i < attrs.length; ++i) {
	      if (i !== 0) {
	        params += ',';
	      }
	      params += attrs[i];
	    }
	  }
	
	  return this.as._jsonRequest({
	    method: 'GET',
	    url: '/1/indexes/' + encodeURIComponent(indexObj.indexName) + '/' + encodeURIComponent(objectID) + params,
	    hostType: 'read',
	    callback: callback
	  });
	};
	
	/*
	* Get several objects from this index
	*
	* @param objectIDs the array of unique identifier of objects to retrieve
	*/
	IndexCore.prototype.getObjects = function(objectIDs, attributesToRetrieve, callback) {
	  var isArray = __webpack_require__(1339);
	  var map = __webpack_require__(1340);
	
	  var usage = 'Usage: index.getObjects(arrayOfObjectIDs[, callback])';
	
	  if (!isArray(objectIDs)) {
	    throw new Error(usage);
	  }
	
	  var indexObj = this;
	
	  if (arguments.length === 1 || typeof attributesToRetrieve === 'function') {
	    callback = attributesToRetrieve;
	    attributesToRetrieve = undefined;
	  }
	
	  var body = {
	    requests: map(objectIDs, function prepareRequest(objectID) {
	      var request = {
	        indexName: indexObj.indexName,
	        objectID: objectID
	      };
	
	      if (attributesToRetrieve) {
	        request.attributesToRetrieve = attributesToRetrieve.join(',');
	      }
	
	      return request;
	    })
	  };
	
	  return this.as._jsonRequest({
	    method: 'POST',
	    url: '/1/indexes/*/objects',
	    hostType: 'read',
	    body: body,
	    callback: callback
	  });
	};
	
	IndexCore.prototype.as = null;
	IndexCore.prototype.indexName = null;
	IndexCore.prototype.typeAheadArgs = null;
	IndexCore.prototype.typeAheadValueOption = null;


/***/ }),
/* 1331 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = buildSearchMethod;
	
	var errors = __webpack_require__(1332);
	
	function buildSearchMethod(queryParam, url) {
	  return function search(query, args, callback) {
	    // warn V2 users on how to search
	    if (typeof query === 'function' && typeof args === 'object' ||
	      typeof callback === 'object') {
	      // .search(query, params, cb)
	      // .search(cb, params)
	      throw new errors.AlgoliaSearchError('index.search usage is index.search(query, params, cb)');
	    }
	
	    if (arguments.length === 0 || typeof query === 'function') {
	      // .search(), .search(cb)
	      callback = query;
	      query = '';
	    } else if (arguments.length === 1 || typeof args === 'function') {
	      // .search(query/args), .search(query, cb)
	      callback = args;
	      args = undefined;
	    }
	
	    // .search(args), careful: typeof null === 'object'
	    if (typeof query === 'object' && query !== null) {
	      args = query;
	      query = undefined;
	    } else if (query === undefined || query === null) { // .search(undefined/null)
	      query = '';
	    }
	
	    var params = '';
	
	    if (query !== undefined) {
	      params += queryParam + '=' + encodeURIComponent(query);
	    }
	
	    if (args !== undefined) {
	      // `_getSearchParams` will augment params, do not be fooled by the = versus += from previous if
	      params = this.as._getSearchParams(args, params);
	    }
	
	    return this._search(params, url, callback);
	  };
	}


/***/ }),
/* 1332 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// This file hosts our error definitions
	// We use custom error "types" so that we can act on them when we need it
	// e.g.: if error instanceof errors.UnparsableJSON then..
	
	var inherits = __webpack_require__(1329);
	
	function AlgoliaSearchError(message, extraProperties) {
	  var forEach = __webpack_require__(1333);
	
	  var error = this;
	
	  // try to get a stacktrace
	  if (typeof Error.captureStackTrace === 'function') {
	    Error.captureStackTrace(this, this.constructor);
	  } else {
	    error.stack = (new Error()).stack || 'Cannot get a stacktrace, browser is too old';
	  }
	
	  this.name = 'AlgoliaSearchError';
	  this.message = message || 'Unknown error';
	
	  if (extraProperties) {
	    forEach(extraProperties, function addToErrorObject(value, key) {
	      error[key] = value;
	    });
	  }
	}
	
	inherits(AlgoliaSearchError, Error);
	
	function createCustomError(name, message) {
	  function AlgoliaSearchCustomError() {
	    var args = Array.prototype.slice.call(arguments, 0);
	
	    // custom message not set, use default
	    if (typeof args[0] !== 'string') {
	      args.unshift(message);
	    }
	
	    AlgoliaSearchError.apply(this, args);
	    this.name = 'AlgoliaSearch' + name + 'Error';
	  }
	
	  inherits(AlgoliaSearchCustomError, AlgoliaSearchError);
	
	  return AlgoliaSearchCustomError;
	}
	
	// late exports to let various fn defs and inherits take place
	module.exports = {
	  AlgoliaSearchError: AlgoliaSearchError,
	  UnparsableJSON: createCustomError(
	    'UnparsableJSON',
	    'Could not parse the incoming response as JSON, see err.more for details'
	  ),
	  RequestTimeout: createCustomError(
	    'RequestTimeout',
	    'Request timedout before getting a response'
	  ),
	  Network: createCustomError(
	    'Network',
	    'Network issue, see err.more for details'
	  ),
	  JSONPScriptFail: createCustomError(
	    'JSONPScriptFail',
	    '<script> was loaded but did not call our provided callback'
	  ),
	  JSONPScriptError: createCustomError(
	    'JSONPScriptError',
	    '<script> unable to load due to an `error` event on it'
	  ),
	  Unknown: createCustomError(
	    'Unknown',
	    'Unknown error occured'
	  )
	};


/***/ }),
/* 1333 */
/***/ (function(module, exports) {

	
	var hasOwn = Object.prototype.hasOwnProperty;
	var toString = Object.prototype.toString;
	
	module.exports = function forEach (obj, fn, ctx) {
	    if (toString.call(fn) !== '[object Function]') {
	        throw new TypeError('iterator must be a function');
	    }
	    var l = obj.length;
	    if (l === +l) {
	        for (var i = 0; i < l; i++) {
	            fn.call(ctx, obj[i], i, obj);
	        }
	    } else {
	        for (var k in obj) {
	            if (hasOwn.call(obj, k)) {
	                fn.call(ctx, obj[k], k, obj);
	            }
	        }
	    }
	};
	


/***/ }),
/* 1334 */
/***/ (function(module, exports, __webpack_require__) {

	var foreach = __webpack_require__(1333);
	
	module.exports = function merge(destination/* , sources */) {
	  var sources = Array.prototype.slice.call(arguments);
	
	  foreach(sources, function(source) {
	    for (var keyName in source) {
	      if (source.hasOwnProperty(keyName)) {
	        if (typeof destination[keyName] === 'object' && typeof source[keyName] === 'object') {
	          destination[keyName] = merge({}, destination[keyName], source[keyName]);
	        } else if (source[keyName] !== undefined) {
	          destination[keyName] = source[keyName];
	        }
	      }
	    }
	  });
	
	  return destination;
	};


/***/ }),
/* 1335 */
/***/ (function(module, exports) {

	module.exports = function clone(obj) {
	  return JSON.parse(JSON.stringify(obj));
	};


/***/ }),
/* 1336 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = function omit(obj, test) {
	  var keys = __webpack_require__(1337);
	  var foreach = __webpack_require__(1333);
	
	  var filtered = {};
	
	  foreach(keys(obj), function doFilter(keyName) {
	    if (test(keyName) !== true) {
	      filtered[keyName] = obj[keyName];
	    }
	  });
	
	  return filtered;
	};


/***/ }),
/* 1337 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// modified from https://github.com/es-shims/es5-shim
	var has = Object.prototype.hasOwnProperty;
	var toStr = Object.prototype.toString;
	var slice = Array.prototype.slice;
	var isArgs = __webpack_require__(1338);
	var isEnumerable = Object.prototype.propertyIsEnumerable;
	var hasDontEnumBug = !isEnumerable.call({ toString: null }, 'toString');
	var hasProtoEnumBug = isEnumerable.call(function () {}, 'prototype');
	var dontEnums = [
		'toString',
		'toLocaleString',
		'valueOf',
		'hasOwnProperty',
		'isPrototypeOf',
		'propertyIsEnumerable',
		'constructor'
	];
	var equalsConstructorPrototype = function (o) {
		var ctor = o.constructor;
		return ctor && ctor.prototype === o;
	};
	var excludedKeys = {
		$console: true,
		$external: true,
		$frame: true,
		$frameElement: true,
		$frames: true,
		$innerHeight: true,
		$innerWidth: true,
		$outerHeight: true,
		$outerWidth: true,
		$pageXOffset: true,
		$pageYOffset: true,
		$parent: true,
		$scrollLeft: true,
		$scrollTop: true,
		$scrollX: true,
		$scrollY: true,
		$self: true,
		$webkitIndexedDB: true,
		$webkitStorageInfo: true,
		$window: true
	};
	var hasAutomationEqualityBug = (function () {
		/* global window */
		if (typeof window === 'undefined') { return false; }
		for (var k in window) {
			try {
				if (!excludedKeys['$' + k] && has.call(window, k) && window[k] !== null && typeof window[k] === 'object') {
					try {
						equalsConstructorPrototype(window[k]);
					} catch (e) {
						return true;
					}
				}
			} catch (e) {
				return true;
			}
		}
		return false;
	}());
	var equalsConstructorPrototypeIfNotBuggy = function (o) {
		/* global window */
		if (typeof window === 'undefined' || !hasAutomationEqualityBug) {
			return equalsConstructorPrototype(o);
		}
		try {
			return equalsConstructorPrototype(o);
		} catch (e) {
			return false;
		}
	};
	
	var keysShim = function keys(object) {
		var isObject = object !== null && typeof object === 'object';
		var isFunction = toStr.call(object) === '[object Function]';
		var isArguments = isArgs(object);
		var isString = isObject && toStr.call(object) === '[object String]';
		var theKeys = [];
	
		if (!isObject && !isFunction && !isArguments) {
			throw new TypeError('Object.keys called on a non-object');
		}
	
		var skipProto = hasProtoEnumBug && isFunction;
		if (isString && object.length > 0 && !has.call(object, 0)) {
			for (var i = 0; i < object.length; ++i) {
				theKeys.push(String(i));
			}
		}
	
		if (isArguments && object.length > 0) {
			for (var j = 0; j < object.length; ++j) {
				theKeys.push(String(j));
			}
		} else {
			for (var name in object) {
				if (!(skipProto && name === 'prototype') && has.call(object, name)) {
					theKeys.push(String(name));
				}
			}
		}
	
		if (hasDontEnumBug) {
			var skipConstructor = equalsConstructorPrototypeIfNotBuggy(object);
	
			for (var k = 0; k < dontEnums.length; ++k) {
				if (!(skipConstructor && dontEnums[k] === 'constructor') && has.call(object, dontEnums[k])) {
					theKeys.push(dontEnums[k]);
				}
			}
		}
		return theKeys;
	};
	
	keysShim.shim = function shimObjectKeys() {
		if (Object.keys) {
			var keysWorksWithArguments = (function () {
				// Safari 5.0 bug
				return (Object.keys(arguments) || '').length === 2;
			}(1, 2));
			if (!keysWorksWithArguments) {
				var originalKeys = Object.keys;
				Object.keys = function keys(object) {
					if (isArgs(object)) {
						return originalKeys(slice.call(object));
					} else {
						return originalKeys(object);
					}
				};
			}
		} else {
			Object.keys = keysShim;
		}
		return Object.keys || keysShim;
	};
	
	module.exports = keysShim;


/***/ }),
/* 1338 */
/***/ (function(module, exports) {

	'use strict';
	
	var toStr = Object.prototype.toString;
	
	module.exports = function isArguments(value) {
		var str = toStr.call(value);
		var isArgs = str === '[object Arguments]';
		if (!isArgs) {
			isArgs = str !== '[object Array]' &&
				value !== null &&
				typeof value === 'object' &&
				typeof value.length === 'number' &&
				value.length >= 0 &&
				toStr.call(value.callee) === '[object Function]';
		}
		return isArgs;
	};


/***/ }),
/* 1339 */
/***/ (function(module, exports) {

	var toString = {}.toString;
	
	module.exports = Array.isArray || function (arr) {
	  return toString.call(arr) == '[object Array]';
	};


/***/ }),
/* 1340 */
/***/ (function(module, exports, __webpack_require__) {

	var foreach = __webpack_require__(1333);
	
	module.exports = function map(arr, fn) {
	  var newArr = [];
	  foreach(arr, function(item, itemIndex) {
	    newArr.push(fn(item, itemIndex, arr));
	  });
	  return newArr;
	};


/***/ }),
/* 1341 */
/***/ (function(module, exports) {

	module.exports = function deprecate(fn, message) {
	  var warned = false;
	
	  function deprecated() {
	    if (!warned) {
	      /* eslint no-console:0 */
	      console.log(message);
	      warned = true;
	    }
	
	    return fn.apply(this, arguments);
	  }
	
	  return deprecated;
	};


/***/ }),
/* 1342 */
/***/ (function(module, exports) {

	module.exports = function deprecatedMessage(previousUsage, newUsage) {
	  var githubAnchorLink = previousUsage.toLowerCase()
	    .replace('.', '')
	    .replace('()', '');
	
	  return 'algoliasearch: `' + previousUsage + '` was replaced by `' + newUsage +
	    '`. Please see https://github.com/algolia/algoliasearch-client-js/wiki/Deprecated#' + githubAnchorLink;
	};


/***/ }),
/* 1343 */
/***/ (function(module, exports) {

	// Parse cloud does not supports setTimeout
	// We do not store a setTimeout reference in the client everytime
	// We only fallback to a fake setTimeout when not available
	// setTimeout cannot be override globally sadly
	module.exports = function exitPromise(fn, _setTimeout) {
	  _setTimeout(fn, 0);
	};


/***/ }),
/* 1344 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// This is the object returned by the `index.browseAll()` method
	
	module.exports = IndexBrowser;
	
	var inherits = __webpack_require__(1329);
	var EventEmitter = __webpack_require__(1345).EventEmitter;
	
	function IndexBrowser() {
	}
	
	inherits(IndexBrowser, EventEmitter);
	
	IndexBrowser.prototype.stop = function() {
	  this._stopped = true;
	  this._clean();
	};
	
	IndexBrowser.prototype._end = function() {
	  this.emit('end');
	  this._clean();
	};
	
	IndexBrowser.prototype._error = function(err) {
	  this.emit('error', err);
	  this._clean();
	};
	
	IndexBrowser.prototype._result = function(content) {
	  this.emit('result', content);
	};
	
	IndexBrowser.prototype._clean = function() {
	  this.removeAllListeners('stop');
	  this.removeAllListeners('end');
	  this.removeAllListeners('error');
	  this.removeAllListeners('result');
	};


/***/ }),
/* 1345 */
/***/ (function(module, exports) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	function EventEmitter() {
	  this._events = this._events || {};
	  this._maxListeners = this._maxListeners || undefined;
	}
	module.exports = EventEmitter;
	
	// Backwards-compat with node 0.10.x
	EventEmitter.EventEmitter = EventEmitter;
	
	EventEmitter.prototype._events = undefined;
	EventEmitter.prototype._maxListeners = undefined;
	
	// By default EventEmitters will print a warning if more than 10 listeners are
	// added to it. This is a useful default which helps finding memory leaks.
	EventEmitter.defaultMaxListeners = 10;
	
	// Obviously not all Emitters should be limited to 10. This function allows
	// that to be increased. Set to zero for unlimited.
	EventEmitter.prototype.setMaxListeners = function(n) {
	  if (!isNumber(n) || n < 0 || isNaN(n))
	    throw TypeError('n must be a positive number');
	  this._maxListeners = n;
	  return this;
	};
	
	EventEmitter.prototype.emit = function(type) {
	  var er, handler, len, args, i, listeners;
	
	  if (!this._events)
	    this._events = {};
	
	  // If there is no 'error' event listener then throw.
	  if (type === 'error') {
	    if (!this._events.error ||
	        (isObject(this._events.error) && !this._events.error.length)) {
	      er = arguments[1];
	      if (er instanceof Error) {
	        throw er; // Unhandled 'error' event
	      } else {
	        // At least give some kind of context to the user
	        var err = new Error('Uncaught, unspecified "error" event. (' + er + ')');
	        err.context = er;
	        throw err;
	      }
	    }
	  }
	
	  handler = this._events[type];
	
	  if (isUndefined(handler))
	    return false;
	
	  if (isFunction(handler)) {
	    switch (arguments.length) {
	      // fast cases
	      case 1:
	        handler.call(this);
	        break;
	      case 2:
	        handler.call(this, arguments[1]);
	        break;
	      case 3:
	        handler.call(this, arguments[1], arguments[2]);
	        break;
	      // slower
	      default:
	        args = Array.prototype.slice.call(arguments, 1);
	        handler.apply(this, args);
	    }
	  } else if (isObject(handler)) {
	    args = Array.prototype.slice.call(arguments, 1);
	    listeners = handler.slice();
	    len = listeners.length;
	    for (i = 0; i < len; i++)
	      listeners[i].apply(this, args);
	  }
	
	  return true;
	};
	
	EventEmitter.prototype.addListener = function(type, listener) {
	  var m;
	
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  if (!this._events)
	    this._events = {};
	
	  // To avoid recursion in the case that type === "newListener"! Before
	  // adding it to the listeners, first emit "newListener".
	  if (this._events.newListener)
	    this.emit('newListener', type,
	              isFunction(listener.listener) ?
	              listener.listener : listener);
	
	  if (!this._events[type])
	    // Optimize the case of one listener. Don't need the extra array object.
	    this._events[type] = listener;
	  else if (isObject(this._events[type]))
	    // If we've already got an array, just append.
	    this._events[type].push(listener);
	  else
	    // Adding the second element, need to change to array.
	    this._events[type] = [this._events[type], listener];
	
	  // Check for listener leak
	  if (isObject(this._events[type]) && !this._events[type].warned) {
	    if (!isUndefined(this._maxListeners)) {
	      m = this._maxListeners;
	    } else {
	      m = EventEmitter.defaultMaxListeners;
	    }
	
	    if (m && m > 0 && this._events[type].length > m) {
	      this._events[type].warned = true;
	      console.error('(node) warning: possible EventEmitter memory ' +
	                    'leak detected. %d listeners added. ' +
	                    'Use emitter.setMaxListeners() to increase limit.',
	                    this._events[type].length);
	      if (typeof console.trace === 'function') {
	        // not supported in IE 10
	        console.trace();
	      }
	    }
	  }
	
	  return this;
	};
	
	EventEmitter.prototype.on = EventEmitter.prototype.addListener;
	
	EventEmitter.prototype.once = function(type, listener) {
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  var fired = false;
	
	  function g() {
	    this.removeListener(type, g);
	
	    if (!fired) {
	      fired = true;
	      listener.apply(this, arguments);
	    }
	  }
	
	  g.listener = listener;
	  this.on(type, g);
	
	  return this;
	};
	
	// emits a 'removeListener' event iff the listener was removed
	EventEmitter.prototype.removeListener = function(type, listener) {
	  var list, position, length, i;
	
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  if (!this._events || !this._events[type])
	    return this;
	
	  list = this._events[type];
	  length = list.length;
	  position = -1;
	
	  if (list === listener ||
	      (isFunction(list.listener) && list.listener === listener)) {
	    delete this._events[type];
	    if (this._events.removeListener)
	      this.emit('removeListener', type, listener);
	
	  } else if (isObject(list)) {
	    for (i = length; i-- > 0;) {
	      if (list[i] === listener ||
	          (list[i].listener && list[i].listener === listener)) {
	        position = i;
	        break;
	      }
	    }
	
	    if (position < 0)
	      return this;
	
	    if (list.length === 1) {
	      list.length = 0;
	      delete this._events[type];
	    } else {
	      list.splice(position, 1);
	    }
	
	    if (this._events.removeListener)
	      this.emit('removeListener', type, listener);
	  }
	
	  return this;
	};
	
	EventEmitter.prototype.removeAllListeners = function(type) {
	  var key, listeners;
	
	  if (!this._events)
	    return this;
	
	  // not listening for removeListener, no need to emit
	  if (!this._events.removeListener) {
	    if (arguments.length === 0)
	      this._events = {};
	    else if (this._events[type])
	      delete this._events[type];
	    return this;
	  }
	
	  // emit removeListener for all listeners on all events
	  if (arguments.length === 0) {
	    for (key in this._events) {
	      if (key === 'removeListener') continue;
	      this.removeAllListeners(key);
	    }
	    this.removeAllListeners('removeListener');
	    this._events = {};
	    return this;
	  }
	
	  listeners = this._events[type];
	
	  if (isFunction(listeners)) {
	    this.removeListener(type, listeners);
	  } else if (listeners) {
	    // LIFO order
	    while (listeners.length)
	      this.removeListener(type, listeners[listeners.length - 1]);
	  }
	  delete this._events[type];
	
	  return this;
	};
	
	EventEmitter.prototype.listeners = function(type) {
	  var ret;
	  if (!this._events || !this._events[type])
	    ret = [];
	  else if (isFunction(this._events[type]))
	    ret = [this._events[type]];
	  else
	    ret = this._events[type].slice();
	  return ret;
	};
	
	EventEmitter.prototype.listenerCount = function(type) {
	  if (this._events) {
	    var evlistener = this._events[type];
	
	    if (isFunction(evlistener))
	      return 1;
	    else if (evlistener)
	      return evlistener.length;
	  }
	  return 0;
	};
	
	EventEmitter.listenerCount = function(emitter, type) {
	  return emitter.listenerCount(type);
	};
	
	function isFunction(arg) {
	  return typeof arg === 'function';
	}
	
	function isNumber(arg) {
	  return typeof arg === 'number';
	}
	
	function isObject(arg) {
	  return typeof arg === 'object' && arg !== null;
	}
	
	function isUndefined(arg) {
	  return arg === void 0;
	}


/***/ }),
/* 1346 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = AlgoliaSearchCore;
	
	var errors = __webpack_require__(1332);
	var exitPromise = __webpack_require__(1343);
	var IndexCore = __webpack_require__(1330);
	
	// We will always put the API KEY in the JSON body in case of too long API KEY
	var MAX_API_KEY_LENGTH = 500;
	
	/*
	 * Algolia Search library initialization
	 * https://www.algolia.com/
	 *
	 * @param {string} applicationID - Your applicationID, found in your dashboard
	 * @param {string} apiKey - Your API key, found in your dashboard
	 * @param {Object} [opts]
	 * @param {number} [opts.timeout=2000] - The request timeout set in milliseconds,
	 * another request will be issued after this timeout
	 * @param {string} [opts.protocol='http:'] - The protocol used to query Algolia Search API.
	 *                                        Set to 'https:' to force using https.
	 *                                        Default to document.location.protocol in browsers
	 * @param {Object|Array} [opts.hosts={
	 *           read: [this.applicationID + '-dsn.algolia.net'].concat([
	 *             this.applicationID + '-1.algolianet.com',
	 *             this.applicationID + '-2.algolianet.com',
	 *             this.applicationID + '-3.algolianet.com']
	 *           ]),
	 *           write: [this.applicationID + '.algolia.net'].concat([
	 *             this.applicationID + '-1.algolianet.com',
	 *             this.applicationID + '-2.algolianet.com',
	 *             this.applicationID + '-3.algolianet.com']
	 *           ]) - The hosts to use for Algolia Search API.
	 *           If you provide them, you will less benefit from our HA implementation
	 */
	function AlgoliaSearchCore(applicationID, apiKey, opts) {
	  var debug = __webpack_require__(1347)('algoliasearch');
	
	  var clone = __webpack_require__(1335);
	  var isArray = __webpack_require__(1339);
	  var map = __webpack_require__(1340);
	
	  var usage = 'Usage: algoliasearch(applicationID, apiKey, opts)';
	
	  if (opts._allowEmptyCredentials !== true && !applicationID) {
	    throw new errors.AlgoliaSearchError('Please provide an application ID. ' + usage);
	  }
	
	  if (opts._allowEmptyCredentials !== true && !apiKey) {
	    throw new errors.AlgoliaSearchError('Please provide an API key. ' + usage);
	  }
	
	  this.applicationID = applicationID;
	  this.apiKey = apiKey;
	
	  var defaultHosts = shuffle([
	    this.applicationID + '-1.algolianet.com',
	    this.applicationID + '-2.algolianet.com',
	    this.applicationID + '-3.algolianet.com'
	  ]);
	  this.hosts = {
	    read: [],
	    write: []
	  };
	
	  this.hostIndex = {
	    read: 0,
	    write: 0
	  };
	
	  opts = opts || {};
	
	  var protocol = opts.protocol || 'https:';
	  var timeout = opts.timeout === undefined ? 2000 : opts.timeout;
	
	  // while we advocate for colon-at-the-end values: 'http:' for `opts.protocol`
	  // we also accept `http` and `https`. It's a common error.
	  if (!/:$/.test(protocol)) {
	    protocol = protocol + ':';
	  }
	
	  if (opts.protocol !== 'http:' && opts.protocol !== 'https:') {
	    throw new errors.AlgoliaSearchError('protocol must be `http:` or `https:` (was `' + opts.protocol + '`)');
	  }
	
	  // no hosts given, add defaults
	  if (!opts.hosts) {
	    this.hosts.read = [this.applicationID + '-dsn.algolia.net'].concat(defaultHosts);
	    this.hosts.write = [this.applicationID + '.algolia.net'].concat(defaultHosts);
	  } else if (isArray(opts.hosts)) {
	    this.hosts.read = clone(opts.hosts);
	    this.hosts.write = clone(opts.hosts);
	  } else {
	    this.hosts.read = clone(opts.hosts.read);
	    this.hosts.write = clone(opts.hosts.write);
	  }
	
	  // add protocol and lowercase hosts
	  this.hosts.read = map(this.hosts.read, prepareHost(protocol));
	  this.hosts.write = map(this.hosts.write, prepareHost(protocol));
	  this.requestTimeout = timeout;
	
	  this.extraHeaders = [];
	
	  // In some situations you might want to warm the cache
	  this.cache = opts._cache || {};
	
	  this._ua = opts._ua;
	  this._useCache = opts._useCache === undefined || opts._cache ? true : opts._useCache;
	  this._useFallback = opts.useFallback === undefined ? true : opts.useFallback;
	
	  this._setTimeout = opts._setTimeout;
	
	  debug('init done, %j', this);
	}
	
	/*
	 * Get the index object initialized
	 *
	 * @param indexName the name of index
	 * @param callback the result callback with one argument (the Index instance)
	 */
	AlgoliaSearchCore.prototype.initIndex = function(indexName) {
	  return new IndexCore(this, indexName);
	};
	
	/**
	* Add an extra field to the HTTP request
	*
	* @param name the header field name
	* @param value the header field value
	*/
	AlgoliaSearchCore.prototype.setExtraHeader = function(name, value) {
	  this.extraHeaders.push({
	    name: name.toLowerCase(), value: value
	  });
	};
	
	/**
	* Augment sent x-algolia-agent with more data, each agent part
	* is automatically separated from the others by a semicolon;
	*
	* @param algoliaAgent the agent to add
	*/
	AlgoliaSearchCore.prototype.addAlgoliaAgent = function(algoliaAgent) {
	  this._ua += ';' + algoliaAgent;
	};
	
	/*
	 * Wrapper that try all hosts to maximize the quality of service
	 */
	AlgoliaSearchCore.prototype._jsonRequest = function(initialOpts) {
	  var requestDebug = __webpack_require__(1347)('algoliasearch:' + initialOpts.url);
	
	  var body;
	  var cache = initialOpts.cache;
	  var client = this;
	  var tries = 0;
	  var usingFallback = false;
	  var hasFallback = client._useFallback && client._request.fallback && initialOpts.fallback;
	  var headers;
	
	  if (
	    this.apiKey.length > MAX_API_KEY_LENGTH &&
	    initialOpts.body !== undefined &&
	    (initialOpts.body.params !== undefined || // index.search()
	    initialOpts.body.requests !== undefined) // client.search()
	  ) {
	    initialOpts.body.apiKey = this.apiKey;
	    headers = this._computeRequestHeaders(false);
	  } else {
	    headers = this._computeRequestHeaders();
	  }
	
	  if (initialOpts.body !== undefined) {
	    body = safeJSONStringify(initialOpts.body);
	  }
	
	  requestDebug('request start');
	  var debugData = [];
	
	  function doRequest(requester, reqOpts) {
	    var startTime = new Date();
	    var cacheID;
	
	    if (client._useCache) {
	      cacheID = initialOpts.url;
	    }
	
	    // as we sometime use POST requests to pass parameters (like query='aa'),
	    // the cacheID must also include the body to be different between calls
	    if (client._useCache && body) {
	      cacheID += '_body_' + reqOpts.body;
	    }
	
	    // handle cache existence
	    if (client._useCache && cache && cache[cacheID] !== undefined) {
	      requestDebug('serving response from cache');
	      return client._promise.resolve(JSON.parse(cache[cacheID]));
	    }
	
	    // if we reached max tries
	    if (tries >= client.hosts[initialOpts.hostType].length) {
	      if (!hasFallback || usingFallback) {
	        requestDebug('could not get any response');
	        // then stop
	        return client._promise.reject(new errors.AlgoliaSearchError(
	          'Cannot connect to the AlgoliaSearch API.' +
	          ' Send an email to support@algolia.com to report and resolve the issue.' +
	          ' Application id was: ' + client.applicationID, {debugData: debugData}
	        ));
	      }
	
	      requestDebug('switching to fallback');
	
	      // let's try the fallback starting from here
	      tries = 0;
	
	      // method, url and body are fallback dependent
	      reqOpts.method = initialOpts.fallback.method;
	      reqOpts.url = initialOpts.fallback.url;
	      reqOpts.jsonBody = initialOpts.fallback.body;
	      if (reqOpts.jsonBody) {
	        reqOpts.body = safeJSONStringify(reqOpts.jsonBody);
	      }
	      // re-compute headers, they could be omitting the API KEY
	      headers = client._computeRequestHeaders();
	
	      reqOpts.timeout = client.requestTimeout * (tries + 1);
	      client.hostIndex[initialOpts.hostType] = 0;
	      usingFallback = true; // the current request is now using fallback
	      return doRequest(client._request.fallback, reqOpts);
	    }
	
	    var currentHost = client.hosts[initialOpts.hostType][client.hostIndex[initialOpts.hostType]];
	
	    var url = currentHost + reqOpts.url;
	    var options = {
	      body: reqOpts.body,
	      jsonBody: reqOpts.jsonBody,
	      method: reqOpts.method,
	      headers: headers,
	      timeout: reqOpts.timeout,
	      debug: requestDebug
	    };
	
	    requestDebug('method: %s, url: %s, headers: %j, timeout: %d',
	      options.method, url, options.headers, options.timeout);
	
	    if (requester === client._request.fallback) {
	      requestDebug('using fallback');
	    }
	
	    // `requester` is any of this._request or this._request.fallback
	    // thus it needs to be called using the client as context
	    return requester.call(client, url, options).then(success, tryFallback);
	
	    function success(httpResponse) {
	      // compute the status of the response,
	      //
	      // When in browser mode, using XDR or JSONP, we have no statusCode available
	      // So we rely on our API response `status` property.
	      // But `waitTask` can set a `status` property which is not the statusCode (it's the task status)
	      // So we check if there's a `message` along `status` and it means it's an error
	      //
	      // That's the only case where we have a response.status that's not the http statusCode
	      var status = httpResponse && httpResponse.body && httpResponse.body.message && httpResponse.body.status ||
	
	        // this is important to check the request statusCode AFTER the body eventual
	        // statusCode because some implementations (jQuery XDomainRequest transport) may
	        // send statusCode 200 while we had an error
	        httpResponse.statusCode ||
	
	        // When in browser mode, using XDR or JSONP
	        // we default to success when no error (no response.status && response.message)
	        // If there was a JSON.parse() error then body is null and it fails
	        httpResponse && httpResponse.body && 200;
	
	      requestDebug('received response: statusCode: %s, computed statusCode: %d, headers: %j',
	        httpResponse.statusCode, status, httpResponse.headers);
	
	      var httpResponseOk = Math.floor(status / 100) === 2;
	
	      var endTime = new Date();
	      debugData.push({
	        currentHost: currentHost,
	        headers: removeCredentials(headers),
	        content: body || null,
	        contentLength: body !== undefined ? body.length : null,
	        method: reqOpts.method,
	        timeout: reqOpts.timeout,
	        url: reqOpts.url,
	        startTime: startTime,
	        endTime: endTime,
	        duration: endTime - startTime,
	        statusCode: status
	      });
	
	      if (httpResponseOk) {
	        if (client._useCache && cache) {
	          cache[cacheID] = httpResponse.responseText;
	        }
	
	        return httpResponse.body;
	      }
	
	      var shouldRetry = Math.floor(status / 100) !== 4;
	
	      if (shouldRetry) {
	        tries += 1;
	        return retryRequest();
	      }
	
	      requestDebug('unrecoverable error');
	
	      // no success and no retry => fail
	      var unrecoverableError = new errors.AlgoliaSearchError(
	        httpResponse.body && httpResponse.body.message, {debugData: debugData, statusCode: status}
	      );
	
	      return client._promise.reject(unrecoverableError);
	    }
	
	    function tryFallback(err) {
	      // error cases:
	      //  While not in fallback mode:
	      //    - CORS not supported
	      //    - network error
	      //  While in fallback mode:
	      //    - timeout
	      //    - network error
	      //    - badly formatted JSONP (script loaded, did not call our callback)
	      //  In both cases:
	      //    - uncaught exception occurs (TypeError)
	      requestDebug('error: %s, stack: %s', err.message, err.stack);
	
	      var endTime = new Date();
	      debugData.push({
	        currentHost: currentHost,
	        headers: removeCredentials(headers),
	        content: body || null,
	        contentLength: body !== undefined ? body.length : null,
	        method: reqOpts.method,
	        timeout: reqOpts.timeout,
	        url: reqOpts.url,
	        startTime: startTime,
	        endTime: endTime,
	        duration: endTime - startTime
	      });
	
	      if (!(err instanceof errors.AlgoliaSearchError)) {
	        err = new errors.Unknown(err && err.message, err);
	      }
	
	      tries += 1;
	
	      // stop the request implementation when:
	      if (
	        // we did not generate this error,
	        // it comes from a throw in some other piece of code
	        err instanceof errors.Unknown ||
	
	        // server sent unparsable JSON
	        err instanceof errors.UnparsableJSON ||
	
	        // max tries and already using fallback or no fallback
	        tries >= client.hosts[initialOpts.hostType].length &&
	        (usingFallback || !hasFallback)) {
	        // stop request implementation for this command
	        err.debugData = debugData;
	        return client._promise.reject(err);
	      }
	
	      // When a timeout occured, retry by raising timeout
	      if (err instanceof errors.RequestTimeout) {
	        return retryRequestWithHigherTimeout();
	      }
	
	      return retryRequest();
	    }
	
	    function retryRequest() {
	      requestDebug('retrying request');
	      client.hostIndex[initialOpts.hostType] = (client.hostIndex[initialOpts.hostType] + 1) % client.hosts[initialOpts.hostType].length;
	      return doRequest(requester, reqOpts);
	    }
	
	    function retryRequestWithHigherTimeout() {
	      requestDebug('retrying request with higher timeout');
	      client.hostIndex[initialOpts.hostType] = (client.hostIndex[initialOpts.hostType] + 1) % client.hosts[initialOpts.hostType].length;
	      reqOpts.timeout = client.requestTimeout * (tries + 1);
	      return doRequest(requester, reqOpts);
	    }
	  }
	
	  var promise = doRequest(
	    client._request, {
	      url: initialOpts.url,
	      method: initialOpts.method,
	      body: body,
	      jsonBody: initialOpts.body,
	      timeout: client.requestTimeout * (tries + 1)
	    }
	  );
	
	  // either we have a callback
	  // either we are using promises
	  if (initialOpts.callback) {
	    promise.then(function okCb(content) {
	      exitPromise(function() {
	        initialOpts.callback(null, content);
	      }, client._setTimeout || setTimeout);
	    }, function nookCb(err) {
	      exitPromise(function() {
	        initialOpts.callback(err);
	      }, client._setTimeout || setTimeout);
	    });
	  } else {
	    return promise;
	  }
	};
	
	/*
	* Transform search param object in query string
	*/
	AlgoliaSearchCore.prototype._getSearchParams = function(args, params) {
	  if (args === undefined || args === null) {
	    return params;
	  }
	  for (var key in args) {
	    if (key !== null && args[key] !== undefined && args.hasOwnProperty(key)) {
	      params += params === '' ? '' : '&';
	      params += key + '=' + encodeURIComponent(Object.prototype.toString.call(args[key]) === '[object Array]' ? safeJSONStringify(args[key]) : args[key]);
	    }
	  }
	  return params;
	};
	
	AlgoliaSearchCore.prototype._computeRequestHeaders = function(withAPIKey) {
	  var forEach = __webpack_require__(1333);
	
	  var requestHeaders = {
	    'x-algolia-agent': this._ua,
	    'x-algolia-application-id': this.applicationID
	  };
	
	  // browser will inline headers in the url, node.js will use http headers
	  // but in some situations, the API KEY will be too long (big secured API keys)
	  // so if the request is a POST and the KEY is very long, we will be asked to not put
	  // it into headers but in the JSON body
	  if (withAPIKey !== false) {
	    requestHeaders['x-algolia-api-key'] = this.apiKey;
	  }
	
	  if (this.userToken) {
	    requestHeaders['x-algolia-usertoken'] = this.userToken;
	  }
	
	  if (this.securityTags) {
	    requestHeaders['x-algolia-tagfilters'] = this.securityTags;
	  }
	
	  if (this.extraHeaders) {
	    forEach(this.extraHeaders, function addToRequestHeaders(header) {
	      requestHeaders[header.name] = header.value;
	    });
	  }
	
	  return requestHeaders;
	};
	
	/**
	 * Search through multiple indices at the same time
	 * @param  {Object[]}   queries  An array of queries you want to run.
	 * @param {string} queries[].indexName The index name you want to target
	 * @param {string} [queries[].query] The query to issue on this index. Can also be passed into `params`
	 * @param {Object} queries[].params Any search param like hitsPerPage, ..
	 * @param  {Function} callback Callback to be called
	 * @return {Promise|undefined} Returns a promise if no callback given
	 */
	AlgoliaSearchCore.prototype.search = function(queries, opts, callback) {
	  var isArray = __webpack_require__(1339);
	  var map = __webpack_require__(1340);
	
	  var usage = 'Usage: client.search(arrayOfQueries[, callback])';
	
	  if (!isArray(queries)) {
	    throw new Error(usage);
	  }
	
	  if (typeof opts === 'function') {
	    callback = opts;
	    opts = {};
	  } else if (opts === undefined) {
	    opts = {};
	  }
	
	  var client = this;
	
	  var postObj = {
	    requests: map(queries, function prepareRequest(query) {
	      var params = '';
	
	      // allow query.query
	      // so we are mimicing the index.search(query, params) method
	      // {indexName:, query:, params:}
	      if (query.query !== undefined) {
	        params += 'query=' + encodeURIComponent(query.query);
	      }
	
	      return {
	        indexName: query.indexName,
	        params: client._getSearchParams(query.params, params)
	      };
	    })
	  };
	
	  var JSONPParams = map(postObj.requests, function prepareJSONPParams(request, requestId) {
	    return requestId + '=' +
	      encodeURIComponent(
	        '/1/indexes/' + encodeURIComponent(request.indexName) + '?' +
	        request.params
	      );
	  }).join('&');
	
	  var url = '/1/indexes/*/queries';
	
	  if (opts.strategy !== undefined) {
	    url += '?strategy=' + opts.strategy;
	  }
	
	  return this._jsonRequest({
	    cache: this.cache,
	    method: 'POST',
	    url: url,
	    body: postObj,
	    hostType: 'read',
	    fallback: {
	      method: 'GET',
	      url: '/1/indexes/*',
	      body: {
	        params: JSONPParams
	      }
	    },
	    callback: callback
	  });
	};
	
	/**
	 * Set the extra security tagFilters header
	 * @param {string|array} tags The list of tags defining the current security filters
	 */
	AlgoliaSearchCore.prototype.setSecurityTags = function(tags) {
	  if (Object.prototype.toString.call(tags) === '[object Array]') {
	    var strTags = [];
	    for (var i = 0; i < tags.length; ++i) {
	      if (Object.prototype.toString.call(tags[i]) === '[object Array]') {
	        var oredTags = [];
	        for (var j = 0; j < tags[i].length; ++j) {
	          oredTags.push(tags[i][j]);
	        }
	        strTags.push('(' + oredTags.join(',') + ')');
	      } else {
	        strTags.push(tags[i]);
	      }
	    }
	    tags = strTags.join(',');
	  }
	
	  this.securityTags = tags;
	};
	
	/**
	 * Set the extra user token header
	 * @param {string} userToken The token identifying a uniq user (used to apply rate limits)
	 */
	AlgoliaSearchCore.prototype.setUserToken = function(userToken) {
	  this.userToken = userToken;
	};
	
	/**
	 * Clear all queries in client's cache
	 * @return undefined
	 */
	AlgoliaSearchCore.prototype.clearCache = function() {
	  this.cache = {};
	};
	
	/**
	* Set the number of milliseconds a request can take before automatically being terminated.
	*
	* @param {Number} milliseconds
	*/
	AlgoliaSearchCore.prototype.setRequestTimeout = function(milliseconds) {
	  if (milliseconds) {
	    this.requestTimeout = parseInt(milliseconds, 10);
	  }
	};
	
	function prepareHost(protocol) {
	  return function prepare(host) {
	    return protocol + '//' + host.toLowerCase();
	  };
	}
	
	// Prototype.js < 1.7, a widely used library, defines a weird
	// Array.prototype.toJSON function that will fail to stringify our content
	// appropriately
	// refs:
	//   - https://groups.google.com/forum/#!topic/prototype-core/E-SAVvV_V9Q
	//   - https://github.com/sstephenson/prototype/commit/038a2985a70593c1a86c230fadbdfe2e4898a48c
	//   - http://stackoverflow.com/a/3148441/147079
	function safeJSONStringify(obj) {
	  /* eslint no-extend-native:0 */
	
	  if (Array.prototype.toJSON === undefined) {
	    return JSON.stringify(obj);
	  }
	
	  var toJSON = Array.prototype.toJSON;
	  delete Array.prototype.toJSON;
	  var out = JSON.stringify(obj);
	  Array.prototype.toJSON = toJSON;
	
	  return out;
	}
	
	function shuffle(array) {
	  var currentIndex = array.length;
	  var temporaryValue;
	  var randomIndex;
	
	  // While there remain elements to shuffle...
	  while (currentIndex !== 0) {
	    // Pick a remaining element...
	    randomIndex = Math.floor(Math.random() * currentIndex);
	    currentIndex -= 1;
	
	    // And swap it with the current element.
	    temporaryValue = array[currentIndex];
	    array[currentIndex] = array[randomIndex];
	    array[randomIndex] = temporaryValue;
	  }
	
	  return array;
	}
	
	function removeCredentials(headers) {
	  var newHeaders = {};
	
	  for (var headerName in headers) {
	    if (Object.prototype.hasOwnProperty.call(headers, headerName)) {
	      var value;
	
	      if (headerName === 'x-algolia-api-key' || headerName === 'x-algolia-application-id') {
	        value = '**hidden for security purposes**';
	      } else {
	        value = headers[headerName];
	      }
	
	      newHeaders[headerName] = value;
	    }
	  }
	
	  return newHeaders;
	}


/***/ }),
/* 1347 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * This is the web browser implementation of `debug()`.
	 *
	 * Expose `debug()` as the module.
	 */
	
	exports = module.exports = __webpack_require__(1348);
	exports.log = log;
	exports.formatArgs = formatArgs;
	exports.save = save;
	exports.load = load;
	exports.useColors = useColors;
	exports.storage = 'undefined' != typeof chrome
	               && 'undefined' != typeof chrome.storage
	                  ? chrome.storage.local
	                  : localstorage();
	
	/**
	 * Colors.
	 */
	
	exports.colors = [
	  'lightseagreen',
	  'forestgreen',
	  'goldenrod',
	  'dodgerblue',
	  'darkorchid',
	  'crimson'
	];
	
	/**
	 * Currently only WebKit-based Web Inspectors, Firefox >= v31,
	 * and the Firebug extension (any Firefox version) are known
	 * to support "%c" CSS customizations.
	 *
	 * TODO: add a `localStorage` variable to explicitly enable/disable colors
	 */
	
	function useColors() {
	  // NB: In an Electron preload script, document will be defined but not fully
	  // initialized. Since we know we're in Chrome, we'll just detect this case
	  // explicitly
	  if (typeof window !== 'undefined' && window.process && window.process.type === 'renderer') {
	    return true;
	  }
	
	  // is webkit? http://stackoverflow.com/a/16459606/376773
	  // document is undefined in react-native: https://github.com/facebook/react-native/pull/1632
	  return (typeof document !== 'undefined' && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance) ||
	    // is firebug? http://stackoverflow.com/a/398120/376773
	    (typeof window !== 'undefined' && window.console && (window.console.firebug || (window.console.exception && window.console.table))) ||
	    // is firefox >= v31?
	    // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
	    (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31) ||
	    // double check webkit in userAgent just in case we are in a worker
	    (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/));
	}
	
	/**
	 * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
	 */
	
	exports.formatters.j = function(v) {
	  try {
	    return JSON.stringify(v);
	  } catch (err) {
	    return '[UnexpectedJSONParseError]: ' + err.message;
	  }
	};
	
	
	/**
	 * Colorize log arguments if enabled.
	 *
	 * @api public
	 */
	
	function formatArgs(args) {
	  var useColors = this.useColors;
	
	  args[0] = (useColors ? '%c' : '')
	    + this.namespace
	    + (useColors ? ' %c' : ' ')
	    + args[0]
	    + (useColors ? '%c ' : ' ')
	    + '+' + exports.humanize(this.diff);
	
	  if (!useColors) return;
	
	  var c = 'color: ' + this.color;
	  args.splice(1, 0, c, 'color: inherit')
	
	  // the final "%c" is somewhat tricky, because there could be other
	  // arguments passed either before or after the %c, so we need to
	  // figure out the correct index to insert the CSS into
	  var index = 0;
	  var lastC = 0;
	  args[0].replace(/%[a-zA-Z%]/g, function(match) {
	    if ('%%' === match) return;
	    index++;
	    if ('%c' === match) {
	      // we only are interested in the *last* %c
	      // (the user may have provided their own)
	      lastC = index;
	    }
	  });
	
	  args.splice(lastC, 0, c);
	}
	
	/**
	 * Invokes `console.log()` when available.
	 * No-op when `console.log` is not a "function".
	 *
	 * @api public
	 */
	
	function log() {
	  // this hackery is required for IE8/9, where
	  // the `console.log` function doesn't have 'apply'
	  return 'object' === typeof console
	    && console.log
	    && Function.prototype.apply.call(console.log, console, arguments);
	}
	
	/**
	 * Save `namespaces`.
	 *
	 * @param {String} namespaces
	 * @api private
	 */
	
	function save(namespaces) {
	  try {
	    if (null == namespaces) {
	      exports.storage.removeItem('debug');
	    } else {
	      exports.storage.debug = namespaces;
	    }
	  } catch(e) {}
	}
	
	/**
	 * Load `namespaces`.
	 *
	 * @return {String} returns the previously persisted debug modes
	 * @api private
	 */
	
	function load() {
	  var r;
	  try {
	    r = exports.storage.debug;
	  } catch(e) {}
	
	  // If debug isn't set in LS, and we're in Electron, try to load $DEBUG
	  if (!r && typeof process !== 'undefined' && 'env' in process) {
	    r = process.env.DEBUG;
	  }
	
	  return r;
	}
	
	/**
	 * Enable namespaces listed in `localStorage.debug` initially.
	 */
	
	exports.enable(load());
	
	/**
	 * Localstorage attempts to return the localstorage.
	 *
	 * This is necessary because safari throws
	 * when a user disables cookies/localstorage
	 * and you attempt to access it.
	 *
	 * @return {LocalStorage}
	 * @api private
	 */
	
	function localstorage() {
	  try {
	    return window.localStorage;
	  } catch (e) {}
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(294)))

/***/ }),
/* 1348 */
/***/ (function(module, exports, __webpack_require__) {

	
	/**
	 * This is the common logic for both the Node.js and web browser
	 * implementations of `debug()`.
	 *
	 * Expose `debug()` as the module.
	 */
	
	exports = module.exports = createDebug.debug = createDebug['default'] = createDebug;
	exports.coerce = coerce;
	exports.disable = disable;
	exports.enable = enable;
	exports.enabled = enabled;
	exports.humanize = __webpack_require__(1349);
	
	/**
	 * The currently active debug mode names, and names to skip.
	 */
	
	exports.names = [];
	exports.skips = [];
	
	/**
	 * Map of special "%n" handling functions, for the debug "format" argument.
	 *
	 * Valid key names are a single, lower or upper-case letter, i.e. "n" and "N".
	 */
	
	exports.formatters = {};
	
	/**
	 * Previous log timestamp.
	 */
	
	var prevTime;
	
	/**
	 * Select a color.
	 * @param {String} namespace
	 * @return {Number}
	 * @api private
	 */
	
	function selectColor(namespace) {
	  var hash = 0, i;
	
	  for (i in namespace) {
	    hash  = ((hash << 5) - hash) + namespace.charCodeAt(i);
	    hash |= 0; // Convert to 32bit integer
	  }
	
	  return exports.colors[Math.abs(hash) % exports.colors.length];
	}
	
	/**
	 * Create a debugger with the given `namespace`.
	 *
	 * @param {String} namespace
	 * @return {Function}
	 * @api public
	 */
	
	function createDebug(namespace) {
	
	  function debug() {
	    // disabled?
	    if (!debug.enabled) return;
	
	    var self = debug;
	
	    // set `diff` timestamp
	    var curr = +new Date();
	    var ms = curr - (prevTime || curr);
	    self.diff = ms;
	    self.prev = prevTime;
	    self.curr = curr;
	    prevTime = curr;
	
	    // turn the `arguments` into a proper Array
	    var args = new Array(arguments.length);
	    for (var i = 0; i < args.length; i++) {
	      args[i] = arguments[i];
	    }
	
	    args[0] = exports.coerce(args[0]);
	
	    if ('string' !== typeof args[0]) {
	      // anything else let's inspect with %O
	      args.unshift('%O');
	    }
	
	    // apply any `formatters` transformations
	    var index = 0;
	    args[0] = args[0].replace(/%([a-zA-Z%])/g, function(match, format) {
	      // if we encounter an escaped % then don't increase the array index
	      if (match === '%%') return match;
	      index++;
	      var formatter = exports.formatters[format];
	      if ('function' === typeof formatter) {
	        var val = args[index];
	        match = formatter.call(self, val);
	
	        // now we need to remove `args[index]` since it's inlined in the `format`
	        args.splice(index, 1);
	        index--;
	      }
	      return match;
	    });
	
	    // apply env-specific formatting (colors, etc.)
	    exports.formatArgs.call(self, args);
	
	    var logFn = debug.log || exports.log || console.log.bind(console);
	    logFn.apply(self, args);
	  }
	
	  debug.namespace = namespace;
	  debug.enabled = exports.enabled(namespace);
	  debug.useColors = exports.useColors();
	  debug.color = selectColor(namespace);
	
	  // env-specific initialization logic for debug instances
	  if ('function' === typeof exports.init) {
	    exports.init(debug);
	  }
	
	  return debug;
	}
	
	/**
	 * Enables a debug mode by namespaces. This can include modes
	 * separated by a colon and wildcards.
	 *
	 * @param {String} namespaces
	 * @api public
	 */
	
	function enable(namespaces) {
	  exports.save(namespaces);
	
	  exports.names = [];
	  exports.skips = [];
	
	  var split = (typeof namespaces === 'string' ? namespaces : '').split(/[\s,]+/);
	  var len = split.length;
	
	  for (var i = 0; i < len; i++) {
	    if (!split[i]) continue; // ignore empty strings
	    namespaces = split[i].replace(/\*/g, '.*?');
	    if (namespaces[0] === '-') {
	      exports.skips.push(new RegExp('^' + namespaces.substr(1) + '$'));
	    } else {
	      exports.names.push(new RegExp('^' + namespaces + '$'));
	    }
	  }
	}
	
	/**
	 * Disable debug output.
	 *
	 * @api public
	 */
	
	function disable() {
	  exports.enable('');
	}
	
	/**
	 * Returns true if the given mode name is enabled, false otherwise.
	 *
	 * @param {String} name
	 * @return {Boolean}
	 * @api public
	 */
	
	function enabled(name) {
	  var i, len;
	  for (i = 0, len = exports.skips.length; i < len; i++) {
	    if (exports.skips[i].test(name)) {
	      return false;
	    }
	  }
	  for (i = 0, len = exports.names.length; i < len; i++) {
	    if (exports.names[i].test(name)) {
	      return true;
	    }
	  }
	  return false;
	}
	
	/**
	 * Coerce `val`.
	 *
	 * @param {Mixed} val
	 * @return {Mixed}
	 * @api private
	 */
	
	function coerce(val) {
	  if (val instanceof Error) return val.stack || val.message;
	  return val;
	}


/***/ }),
/* 1349 */
/***/ (function(module, exports) {

	/**
	 * Helpers.
	 */
	
	var s = 1000;
	var m = s * 60;
	var h = m * 60;
	var d = h * 24;
	var y = d * 365.25;
	
	/**
	 * Parse or format the given `val`.
	 *
	 * Options:
	 *
	 *  - `long` verbose formatting [false]
	 *
	 * @param {String|Number} val
	 * @param {Object} [options]
	 * @throws {Error} throw an error if val is not a non-empty string or a number
	 * @return {String|Number}
	 * @api public
	 */
	
	module.exports = function(val, options) {
	  options = options || {};
	  var type = typeof val;
	  if (type === 'string' && val.length > 0) {
	    return parse(val);
	  } else if (type === 'number' && isNaN(val) === false) {
	    return options.long ? fmtLong(val) : fmtShort(val);
	  }
	  throw new Error(
	    'val is not a non-empty string or a valid number. val=' +
	      JSON.stringify(val)
	  );
	};
	
	/**
	 * Parse the given `str` and return milliseconds.
	 *
	 * @param {String} str
	 * @return {Number}
	 * @api private
	 */
	
	function parse(str) {
	  str = String(str);
	  if (str.length > 100) {
	    return;
	  }
	  var match = /^((?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|years?|yrs?|y)?$/i.exec(
	    str
	  );
	  if (!match) {
	    return;
	  }
	  var n = parseFloat(match[1]);
	  var type = (match[2] || 'ms').toLowerCase();
	  switch (type) {
	    case 'years':
	    case 'year':
	    case 'yrs':
	    case 'yr':
	    case 'y':
	      return n * y;
	    case 'days':
	    case 'day':
	    case 'd':
	      return n * d;
	    case 'hours':
	    case 'hour':
	    case 'hrs':
	    case 'hr':
	    case 'h':
	      return n * h;
	    case 'minutes':
	    case 'minute':
	    case 'mins':
	    case 'min':
	    case 'm':
	      return n * m;
	    case 'seconds':
	    case 'second':
	    case 'secs':
	    case 'sec':
	    case 's':
	      return n * s;
	    case 'milliseconds':
	    case 'millisecond':
	    case 'msecs':
	    case 'msec':
	    case 'ms':
	      return n;
	    default:
	      return undefined;
	  }
	}
	
	/**
	 * Short format for `ms`.
	 *
	 * @param {Number} ms
	 * @return {String}
	 * @api private
	 */
	
	function fmtShort(ms) {
	  if (ms >= d) {
	    return Math.round(ms / d) + 'd';
	  }
	  if (ms >= h) {
	    return Math.round(ms / h) + 'h';
	  }
	  if (ms >= m) {
	    return Math.round(ms / m) + 'm';
	  }
	  if (ms >= s) {
	    return Math.round(ms / s) + 's';
	  }
	  return ms + 'ms';
	}
	
	/**
	 * Long format for `ms`.
	 *
	 * @param {Number} ms
	 * @return {String}
	 * @api private
	 */
	
	function fmtLong(ms) {
	  return plural(ms, d, 'day') ||
	    plural(ms, h, 'hour') ||
	    plural(ms, m, 'minute') ||
	    plural(ms, s, 'second') ||
	    ms + ' ms';
	}
	
	/**
	 * Pluralization helper.
	 */
	
	function plural(ms, n, name) {
	  if (ms < n) {
	    return;
	  }
	  if (ms < n * 1.5) {
	    return Math.floor(ms / n) + ' ' + name;
	  }
	  return Math.ceil(ms / n) + ' ' + name + 's';
	}


/***/ }),
/* 1350 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var global = __webpack_require__(1351);
	var Promise = global.Promise || __webpack_require__(1352).Promise;
	
	// This is the standalone browser build entry point
	// Browser implementation of the Algolia Search JavaScript client,
	// using XMLHttpRequest, XDomainRequest and JSONP as fallback
	module.exports = function createAlgoliasearch(AlgoliaSearch, uaSuffix) {
	  var inherits = __webpack_require__(1329);
	  var errors = __webpack_require__(1332);
	  var inlineHeaders = __webpack_require__(1354);
	  var jsonpRequest = __webpack_require__(1356);
	  var places = __webpack_require__(1357);
	  uaSuffix = uaSuffix || '';
	
	  if (false) {
	    require('debug').enable('algoliasearch*');
	  }
	
	  function algoliasearch(applicationID, apiKey, opts) {
	    var cloneDeep = __webpack_require__(1335);
	
	    var getDocumentProtocol = __webpack_require__(1358);
	
	    opts = cloneDeep(opts || {});
	
	    if (opts.protocol === undefined) {
	      opts.protocol = getDocumentProtocol();
	    }
	
	    opts._ua = opts._ua || algoliasearch.ua;
	
	    return new AlgoliaSearchBrowser(applicationID, apiKey, opts);
	  }
	
	  algoliasearch.version = __webpack_require__(1359);
	  algoliasearch.ua = 'Algolia for vanilla JavaScript ' + uaSuffix + algoliasearch.version;
	  algoliasearch.initPlaces = places(algoliasearch);
	
	  // we expose into window no matter how we are used, this will allow
	  // us to easily debug any website running algolia
	  global.__algolia = {
	    debug: __webpack_require__(1347),
	    algoliasearch: algoliasearch
	  };
	
	  var support = {
	    hasXMLHttpRequest: 'XMLHttpRequest' in global,
	    hasXDomainRequest: 'XDomainRequest' in global
	  };
	
	  if (support.hasXMLHttpRequest) {
	    support.cors = 'withCredentials' in new XMLHttpRequest();
	    support.timeout = 'timeout' in new XMLHttpRequest();
	  }
	
	  function AlgoliaSearchBrowser() {
	    // call AlgoliaSearch constructor
	    AlgoliaSearch.apply(this, arguments);
	  }
	
	  inherits(AlgoliaSearchBrowser, AlgoliaSearch);
	
	  AlgoliaSearchBrowser.prototype._request = function request(url, opts) {
	    return new Promise(function wrapRequest(resolve, reject) {
	      // no cors or XDomainRequest, no request
	      if (!support.cors && !support.hasXDomainRequest) {
	        // very old browser, not supported
	        reject(new errors.Network('CORS not supported'));
	        return;
	      }
	
	      url = inlineHeaders(url, opts.headers);
	
	      var body = opts.body;
	      var req = support.cors ? new XMLHttpRequest() : new XDomainRequest();
	      var ontimeout;
	      var timedOut;
	
	      // do not rely on default XHR async flag, as some analytics code like hotjar
	      // breaks it and set it to false by default
	      if (req instanceof XMLHttpRequest) {
	        req.open(opts.method, url, true);
	      } else {
	        req.open(opts.method, url);
	      }
	
	      if (support.cors) {
	        if (body) {
	          if (opts.method === 'POST') {
	            // https://developer.mozilla.org/en-US/docs/Web/HTTP/Access_control_CORS#Simple_requests
	            req.setRequestHeader('content-type', 'application/x-www-form-urlencoded');
	          } else {
	            req.setRequestHeader('content-type', 'application/json');
	          }
	        }
	        req.setRequestHeader('accept', 'application/json');
	      }
	
	      // we set an empty onprogress listener
	      // so that XDomainRequest on IE9 is not aborted
	      // refs:
	      //  - https://github.com/algolia/algoliasearch-client-js/issues/76
	      //  - https://social.msdn.microsoft.com/Forums/ie/en-US/30ef3add-767c-4436-b8a9-f1ca19b4812e/ie9-rtm-xdomainrequest-issued-requests-may-abort-if-all-event-handlers-not-specified?forum=iewebdevelopment
	      req.onprogress = function noop() {};
	
	      req.onload = load;
	      req.onerror = error;
	
	      if (support.timeout) {
	        // .timeout supported by both XHR and XDR,
	        // we do receive timeout event, tested
	        req.timeout = opts.timeout;
	
	        req.ontimeout = timeout;
	      } else {
	        ontimeout = setTimeout(timeout, opts.timeout);
	      }
	
	      req.send(body);
	
	      // event object not received in IE8, at least
	      // but we do not use it, still important to note
	      function load(/* event */) {
	        // When browser does not supports req.timeout, we can
	        // have both a load and timeout event, since handled by a dumb setTimeout
	        if (timedOut) {
	          return;
	        }
	
	        if (!support.timeout) {
	          clearTimeout(ontimeout);
	        }
	
	        var out;
	
	        try {
	          out = {
	            body: JSON.parse(req.responseText),
	            responseText: req.responseText,
	            statusCode: req.status,
	            // XDomainRequest does not have any response headers
	            headers: req.getAllResponseHeaders && req.getAllResponseHeaders() || {}
	          };
	        } catch (e) {
	          out = new errors.UnparsableJSON({
	            more: req.responseText
	          });
	        }
	
	        if (out instanceof errors.UnparsableJSON) {
	          reject(out);
	        } else {
	          resolve(out);
	        }
	      }
	
	      function error(event) {
	        if (timedOut) {
	          return;
	        }
	
	        if (!support.timeout) {
	          clearTimeout(ontimeout);
	        }
	
	        // error event is trigerred both with XDR/XHR on:
	        //   - DNS error
	        //   - unallowed cross domain request
	        reject(
	          new errors.Network({
	            more: event
	          })
	        );
	      }
	
	      function timeout() {
	        if (!support.timeout) {
	          timedOut = true;
	          req.abort();
	        }
	
	        reject(new errors.RequestTimeout());
	      }
	    });
	  };
	
	  AlgoliaSearchBrowser.prototype._request.fallback = function requestFallback(url, opts) {
	    url = inlineHeaders(url, opts.headers);
	
	    return new Promise(function wrapJsonpRequest(resolve, reject) {
	      jsonpRequest(url, opts, function jsonpRequestDone(err, content) {
	        if (err) {
	          reject(err);
	          return;
	        }
	
	        resolve(content);
	      });
	    });
	  };
	
	  AlgoliaSearchBrowser.prototype._promise = {
	    reject: function rejectPromise(val) {
	      return Promise.reject(val);
	    },
	    resolve: function resolvePromise(val) {
	      return Promise.resolve(val);
	    },
	    delay: function delayPromise(ms) {
	      return new Promise(function resolveOnTimeout(resolve/* , reject*/) {
	        setTimeout(resolve, ms);
	      });
	    }
	  };
	
	  return algoliasearch;
	};


/***/ }),
/* 1351 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {if (typeof window !== "undefined") {
	    module.exports = window;
	} else if (typeof global !== "undefined") {
	    module.exports = global;
	} else if (typeof self !== "undefined"){
	    module.exports = self;
	} else {
	    module.exports = {};
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 1352 */
/***/ (function(module, exports, __webpack_require__) {

	var require;/* WEBPACK VAR INJECTION */(function(process, global) {/*!
	 * @overview es6-promise - a tiny implementation of Promises/A+.
	 * @copyright Copyright (c) 2014 Yehuda Katz, Tom Dale, Stefan Penner and contributors (Conversion to ES6 API by Jake Archibald)
	 * @license   Licensed under MIT license
	 *            See https://raw.githubusercontent.com/stefanpenner/es6-promise/master/LICENSE
	 * @version   3.3.1
	 */
	
	(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    (global.ES6Promise = factory());
	}(this, (function () { 'use strict';
	
	function objectOrFunction(x) {
	  return typeof x === 'function' || typeof x === 'object' && x !== null;
	}
	
	function isFunction(x) {
	  return typeof x === 'function';
	}
	
	var _isArray = undefined;
	if (!Array.isArray) {
	  _isArray = function (x) {
	    return Object.prototype.toString.call(x) === '[object Array]';
	  };
	} else {
	  _isArray = Array.isArray;
	}
	
	var isArray = _isArray;
	
	var len = 0;
	var vertxNext = undefined;
	var customSchedulerFn = undefined;
	
	var asap = function asap(callback, arg) {
	  queue[len] = callback;
	  queue[len + 1] = arg;
	  len += 2;
	  if (len === 2) {
	    // If len is 2, that means that we need to schedule an async flush.
	    // If additional callbacks are queued before the queue is flushed, they
	    // will be processed by this flush that we are scheduling.
	    if (customSchedulerFn) {
	      customSchedulerFn(flush);
	    } else {
	      scheduleFlush();
	    }
	  }
	};
	
	function setScheduler(scheduleFn) {
	  customSchedulerFn = scheduleFn;
	}
	
	function setAsap(asapFn) {
	  asap = asapFn;
	}
	
	var browserWindow = typeof window !== 'undefined' ? window : undefined;
	var browserGlobal = browserWindow || {};
	var BrowserMutationObserver = browserGlobal.MutationObserver || browserGlobal.WebKitMutationObserver;
	var isNode = typeof self === 'undefined' && typeof process !== 'undefined' && ({}).toString.call(process) === '[object process]';
	
	// test for web worker but not in IE10
	var isWorker = typeof Uint8ClampedArray !== 'undefined' && typeof importScripts !== 'undefined' && typeof MessageChannel !== 'undefined';
	
	// node
	function useNextTick() {
	  // node version 0.10.x displays a deprecation warning when nextTick is used recursively
	  // see https://github.com/cujojs/when/issues/410 for details
	  return function () {
	    return process.nextTick(flush);
	  };
	}
	
	// vertx
	function useVertxTimer() {
	  return function () {
	    vertxNext(flush);
	  };
	}
	
	function useMutationObserver() {
	  var iterations = 0;
	  var observer = new BrowserMutationObserver(flush);
	  var node = document.createTextNode('');
	  observer.observe(node, { characterData: true });
	
	  return function () {
	    node.data = iterations = ++iterations % 2;
	  };
	}
	
	// web worker
	function useMessageChannel() {
	  var channel = new MessageChannel();
	  channel.port1.onmessage = flush;
	  return function () {
	    return channel.port2.postMessage(0);
	  };
	}
	
	function useSetTimeout() {
	  // Store setTimeout reference so es6-promise will be unaffected by
	  // other code modifying setTimeout (like sinon.useFakeTimers())
	  var globalSetTimeout = setTimeout;
	  return function () {
	    return globalSetTimeout(flush, 1);
	  };
	}
	
	var queue = new Array(1000);
	function flush() {
	  for (var i = 0; i < len; i += 2) {
	    var callback = queue[i];
	    var arg = queue[i + 1];
	
	    callback(arg);
	
	    queue[i] = undefined;
	    queue[i + 1] = undefined;
	  }
	
	  len = 0;
	}
	
	function attemptVertx() {
	  try {
	    var r = require;
	    var vertx = __webpack_require__(1353);
	    vertxNext = vertx.runOnLoop || vertx.runOnContext;
	    return useVertxTimer();
	  } catch (e) {
	    return useSetTimeout();
	  }
	}
	
	var scheduleFlush = undefined;
	// Decide what async method to use to triggering processing of queued callbacks:
	if (isNode) {
	  scheduleFlush = useNextTick();
	} else if (BrowserMutationObserver) {
	  scheduleFlush = useMutationObserver();
	} else if (isWorker) {
	  scheduleFlush = useMessageChannel();
	} else if (browserWindow === undefined && "function" === 'function') {
	  scheduleFlush = attemptVertx();
	} else {
	  scheduleFlush = useSetTimeout();
	}
	
	function then(onFulfillment, onRejection) {
	  var _arguments = arguments;
	
	  var parent = this;
	
	  var child = new this.constructor(noop);
	
	  if (child[PROMISE_ID] === undefined) {
	    makePromise(child);
	  }
	
	  var _state = parent._state;
	
	  if (_state) {
	    (function () {
	      var callback = _arguments[_state - 1];
	      asap(function () {
	        return invokeCallback(_state, child, callback, parent._result);
	      });
	    })();
	  } else {
	    subscribe(parent, child, onFulfillment, onRejection);
	  }
	
	  return child;
	}
	
	/**
	  `Promise.resolve` returns a promise that will become resolved with the
	  passed `value`. It is shorthand for the following:
	
	  ```javascript
	  let promise = new Promise(function(resolve, reject){
	    resolve(1);
	  });
	
	  promise.then(function(value){
	    // value === 1
	  });
	  ```
	
	  Instead of writing the above, your code now simply becomes the following:
	
	  ```javascript
	  let promise = Promise.resolve(1);
	
	  promise.then(function(value){
	    // value === 1
	  });
	  ```
	
	  @method resolve
	  @static
	  @param {Any} value value that the returned promise will be resolved with
	  Useful for tooling.
	  @return {Promise} a promise that will become fulfilled with the given
	  `value`
	*/
	function resolve(object) {
	  /*jshint validthis:true */
	  var Constructor = this;
	
	  if (object && typeof object === 'object' && object.constructor === Constructor) {
	    return object;
	  }
	
	  var promise = new Constructor(noop);
	  _resolve(promise, object);
	  return promise;
	}
	
	var PROMISE_ID = Math.random().toString(36).substring(16);
	
	function noop() {}
	
	var PENDING = void 0;
	var FULFILLED = 1;
	var REJECTED = 2;
	
	var GET_THEN_ERROR = new ErrorObject();
	
	function selfFulfillment() {
	  return new TypeError("You cannot resolve a promise with itself");
	}
	
	function cannotReturnOwn() {
	  return new TypeError('A promises callback cannot return that same promise.');
	}
	
	function getThen(promise) {
	  try {
	    return promise.then;
	  } catch (error) {
	    GET_THEN_ERROR.error = error;
	    return GET_THEN_ERROR;
	  }
	}
	
	function tryThen(then, value, fulfillmentHandler, rejectionHandler) {
	  try {
	    then.call(value, fulfillmentHandler, rejectionHandler);
	  } catch (e) {
	    return e;
	  }
	}
	
	function handleForeignThenable(promise, thenable, then) {
	  asap(function (promise) {
	    var sealed = false;
	    var error = tryThen(then, thenable, function (value) {
	      if (sealed) {
	        return;
	      }
	      sealed = true;
	      if (thenable !== value) {
	        _resolve(promise, value);
	      } else {
	        fulfill(promise, value);
	      }
	    }, function (reason) {
	      if (sealed) {
	        return;
	      }
	      sealed = true;
	
	      _reject(promise, reason);
	    }, 'Settle: ' + (promise._label || ' unknown promise'));
	
	    if (!sealed && error) {
	      sealed = true;
	      _reject(promise, error);
	    }
	  }, promise);
	}
	
	function handleOwnThenable(promise, thenable) {
	  if (thenable._state === FULFILLED) {
	    fulfill(promise, thenable._result);
	  } else if (thenable._state === REJECTED) {
	    _reject(promise, thenable._result);
	  } else {
	    subscribe(thenable, undefined, function (value) {
	      return _resolve(promise, value);
	    }, function (reason) {
	      return _reject(promise, reason);
	    });
	  }
	}
	
	function handleMaybeThenable(promise, maybeThenable, then$$) {
	  if (maybeThenable.constructor === promise.constructor && then$$ === then && maybeThenable.constructor.resolve === resolve) {
	    handleOwnThenable(promise, maybeThenable);
	  } else {
	    if (then$$ === GET_THEN_ERROR) {
	      _reject(promise, GET_THEN_ERROR.error);
	    } else if (then$$ === undefined) {
	      fulfill(promise, maybeThenable);
	    } else if (isFunction(then$$)) {
	      handleForeignThenable(promise, maybeThenable, then$$);
	    } else {
	      fulfill(promise, maybeThenable);
	    }
	  }
	}
	
	function _resolve(promise, value) {
	  if (promise === value) {
	    _reject(promise, selfFulfillment());
	  } else if (objectOrFunction(value)) {
	    handleMaybeThenable(promise, value, getThen(value));
	  } else {
	    fulfill(promise, value);
	  }
	}
	
	function publishRejection(promise) {
	  if (promise._onerror) {
	    promise._onerror(promise._result);
	  }
	
	  publish(promise);
	}
	
	function fulfill(promise, value) {
	  if (promise._state !== PENDING) {
	    return;
	  }
	
	  promise._result = value;
	  promise._state = FULFILLED;
	
	  if (promise._subscribers.length !== 0) {
	    asap(publish, promise);
	  }
	}
	
	function _reject(promise, reason) {
	  if (promise._state !== PENDING) {
	    return;
	  }
	  promise._state = REJECTED;
	  promise._result = reason;
	
	  asap(publishRejection, promise);
	}
	
	function subscribe(parent, child, onFulfillment, onRejection) {
	  var _subscribers = parent._subscribers;
	  var length = _subscribers.length;
	
	  parent._onerror = null;
	
	  _subscribers[length] = child;
	  _subscribers[length + FULFILLED] = onFulfillment;
	  _subscribers[length + REJECTED] = onRejection;
	
	  if (length === 0 && parent._state) {
	    asap(publish, parent);
	  }
	}
	
	function publish(promise) {
	  var subscribers = promise._subscribers;
	  var settled = promise._state;
	
	  if (subscribers.length === 0) {
	    return;
	  }
	
	  var child = undefined,
	      callback = undefined,
	      detail = promise._result;
	
	  for (var i = 0; i < subscribers.length; i += 3) {
	    child = subscribers[i];
	    callback = subscribers[i + settled];
	
	    if (child) {
	      invokeCallback(settled, child, callback, detail);
	    } else {
	      callback(detail);
	    }
	  }
	
	  promise._subscribers.length = 0;
	}
	
	function ErrorObject() {
	  this.error = null;
	}
	
	var TRY_CATCH_ERROR = new ErrorObject();
	
	function tryCatch(callback, detail) {
	  try {
	    return callback(detail);
	  } catch (e) {
	    TRY_CATCH_ERROR.error = e;
	    return TRY_CATCH_ERROR;
	  }
	}
	
	function invokeCallback(settled, promise, callback, detail) {
	  var hasCallback = isFunction(callback),
	      value = undefined,
	      error = undefined,
	      succeeded = undefined,
	      failed = undefined;
	
	  if (hasCallback) {
	    value = tryCatch(callback, detail);
	
	    if (value === TRY_CATCH_ERROR) {
	      failed = true;
	      error = value.error;
	      value = null;
	    } else {
	      succeeded = true;
	    }
	
	    if (promise === value) {
	      _reject(promise, cannotReturnOwn());
	      return;
	    }
	  } else {
	    value = detail;
	    succeeded = true;
	  }
	
	  if (promise._state !== PENDING) {
	    // noop
	  } else if (hasCallback && succeeded) {
	      _resolve(promise, value);
	    } else if (failed) {
	      _reject(promise, error);
	    } else if (settled === FULFILLED) {
	      fulfill(promise, value);
	    } else if (settled === REJECTED) {
	      _reject(promise, value);
	    }
	}
	
	function initializePromise(promise, resolver) {
	  try {
	    resolver(function resolvePromise(value) {
	      _resolve(promise, value);
	    }, function rejectPromise(reason) {
	      _reject(promise, reason);
	    });
	  } catch (e) {
	    _reject(promise, e);
	  }
	}
	
	var id = 0;
	function nextId() {
	  return id++;
	}
	
	function makePromise(promise) {
	  promise[PROMISE_ID] = id++;
	  promise._state = undefined;
	  promise._result = undefined;
	  promise._subscribers = [];
	}
	
	function Enumerator(Constructor, input) {
	  this._instanceConstructor = Constructor;
	  this.promise = new Constructor(noop);
	
	  if (!this.promise[PROMISE_ID]) {
	    makePromise(this.promise);
	  }
	
	  if (isArray(input)) {
	    this._input = input;
	    this.length = input.length;
	    this._remaining = input.length;
	
	    this._result = new Array(this.length);
	
	    if (this.length === 0) {
	      fulfill(this.promise, this._result);
	    } else {
	      this.length = this.length || 0;
	      this._enumerate();
	      if (this._remaining === 0) {
	        fulfill(this.promise, this._result);
	      }
	    }
	  } else {
	    _reject(this.promise, validationError());
	  }
	}
	
	function validationError() {
	  return new Error('Array Methods must be provided an Array');
	};
	
	Enumerator.prototype._enumerate = function () {
	  var length = this.length;
	  var _input = this._input;
	
	  for (var i = 0; this._state === PENDING && i < length; i++) {
	    this._eachEntry(_input[i], i);
	  }
	};
	
	Enumerator.prototype._eachEntry = function (entry, i) {
	  var c = this._instanceConstructor;
	  var resolve$$ = c.resolve;
	
	  if (resolve$$ === resolve) {
	    var _then = getThen(entry);
	
	    if (_then === then && entry._state !== PENDING) {
	      this._settledAt(entry._state, i, entry._result);
	    } else if (typeof _then !== 'function') {
	      this._remaining--;
	      this._result[i] = entry;
	    } else if (c === Promise) {
	      var promise = new c(noop);
	      handleMaybeThenable(promise, entry, _then);
	      this._willSettleAt(promise, i);
	    } else {
	      this._willSettleAt(new c(function (resolve$$) {
	        return resolve$$(entry);
	      }), i);
	    }
	  } else {
	    this._willSettleAt(resolve$$(entry), i);
	  }
	};
	
	Enumerator.prototype._settledAt = function (state, i, value) {
	  var promise = this.promise;
	
	  if (promise._state === PENDING) {
	    this._remaining--;
	
	    if (state === REJECTED) {
	      _reject(promise, value);
	    } else {
	      this._result[i] = value;
	    }
	  }
	
	  if (this._remaining === 0) {
	    fulfill(promise, this._result);
	  }
	};
	
	Enumerator.prototype._willSettleAt = function (promise, i) {
	  var enumerator = this;
	
	  subscribe(promise, undefined, function (value) {
	    return enumerator._settledAt(FULFILLED, i, value);
	  }, function (reason) {
	    return enumerator._settledAt(REJECTED, i, reason);
	  });
	};
	
	/**
	  `Promise.all` accepts an array of promises, and returns a new promise which
	  is fulfilled with an array of fulfillment values for the passed promises, or
	  rejected with the reason of the first passed promise to be rejected. It casts all
	  elements of the passed iterable to promises as it runs this algorithm.
	
	  Example:
	
	  ```javascript
	  let promise1 = resolve(1);
	  let promise2 = resolve(2);
	  let promise3 = resolve(3);
	  let promises = [ promise1, promise2, promise3 ];
	
	  Promise.all(promises).then(function(array){
	    // The array here would be [ 1, 2, 3 ];
	  });
	  ```
	
	  If any of the `promises` given to `all` are rejected, the first promise
	  that is rejected will be given as an argument to the returned promises's
	  rejection handler. For example:
	
	  Example:
	
	  ```javascript
	  let promise1 = resolve(1);
	  let promise2 = reject(new Error("2"));
	  let promise3 = reject(new Error("3"));
	  let promises = [ promise1, promise2, promise3 ];
	
	  Promise.all(promises).then(function(array){
	    // Code here never runs because there are rejected promises!
	  }, function(error) {
	    // error.message === "2"
	  });
	  ```
	
	  @method all
	  @static
	  @param {Array} entries array of promises
	  @param {String} label optional string for labeling the promise.
	  Useful for tooling.
	  @return {Promise} promise that is fulfilled when all `promises` have been
	  fulfilled, or rejected if any of them become rejected.
	  @static
	*/
	function all(entries) {
	  return new Enumerator(this, entries).promise;
	}
	
	/**
	  `Promise.race` returns a new promise which is settled in the same way as the
	  first passed promise to settle.
	
	  Example:
	
	  ```javascript
	  let promise1 = new Promise(function(resolve, reject){
	    setTimeout(function(){
	      resolve('promise 1');
	    }, 200);
	  });
	
	  let promise2 = new Promise(function(resolve, reject){
	    setTimeout(function(){
	      resolve('promise 2');
	    }, 100);
	  });
	
	  Promise.race([promise1, promise2]).then(function(result){
	    // result === 'promise 2' because it was resolved before promise1
	    // was resolved.
	  });
	  ```
	
	  `Promise.race` is deterministic in that only the state of the first
	  settled promise matters. For example, even if other promises given to the
	  `promises` array argument are resolved, but the first settled promise has
	  become rejected before the other promises became fulfilled, the returned
	  promise will become rejected:
	
	  ```javascript
	  let promise1 = new Promise(function(resolve, reject){
	    setTimeout(function(){
	      resolve('promise 1');
	    }, 200);
	  });
	
	  let promise2 = new Promise(function(resolve, reject){
	    setTimeout(function(){
	      reject(new Error('promise 2'));
	    }, 100);
	  });
	
	  Promise.race([promise1, promise2]).then(function(result){
	    // Code here never runs
	  }, function(reason){
	    // reason.message === 'promise 2' because promise 2 became rejected before
	    // promise 1 became fulfilled
	  });
	  ```
	
	  An example real-world use case is implementing timeouts:
	
	  ```javascript
	  Promise.race([ajax('foo.json'), timeout(5000)])
	  ```
	
	  @method race
	  @static
	  @param {Array} promises array of promises to observe
	  Useful for tooling.
	  @return {Promise} a promise which settles in the same way as the first passed
	  promise to settle.
	*/
	function race(entries) {
	  /*jshint validthis:true */
	  var Constructor = this;
	
	  if (!isArray(entries)) {
	    return new Constructor(function (_, reject) {
	      return reject(new TypeError('You must pass an array to race.'));
	    });
	  } else {
	    return new Constructor(function (resolve, reject) {
	      var length = entries.length;
	      for (var i = 0; i < length; i++) {
	        Constructor.resolve(entries[i]).then(resolve, reject);
	      }
	    });
	  }
	}
	
	/**
	  `Promise.reject` returns a promise rejected with the passed `reason`.
	  It is shorthand for the following:
	
	  ```javascript
	  let promise = new Promise(function(resolve, reject){
	    reject(new Error('WHOOPS'));
	  });
	
	  promise.then(function(value){
	    // Code here doesn't run because the promise is rejected!
	  }, function(reason){
	    // reason.message === 'WHOOPS'
	  });
	  ```
	
	  Instead of writing the above, your code now simply becomes the following:
	
	  ```javascript
	  let promise = Promise.reject(new Error('WHOOPS'));
	
	  promise.then(function(value){
	    // Code here doesn't run because the promise is rejected!
	  }, function(reason){
	    // reason.message === 'WHOOPS'
	  });
	  ```
	
	  @method reject
	  @static
	  @param {Any} reason value that the returned promise will be rejected with.
	  Useful for tooling.
	  @return {Promise} a promise rejected with the given `reason`.
	*/
	function reject(reason) {
	  /*jshint validthis:true */
	  var Constructor = this;
	  var promise = new Constructor(noop);
	  _reject(promise, reason);
	  return promise;
	}
	
	function needsResolver() {
	  throw new TypeError('You must pass a resolver function as the first argument to the promise constructor');
	}
	
	function needsNew() {
	  throw new TypeError("Failed to construct 'Promise': Please use the 'new' operator, this object constructor cannot be called as a function.");
	}
	
	/**
	  Promise objects represent the eventual result of an asynchronous operation. The
	  primary way of interacting with a promise is through its `then` method, which
	  registers callbacks to receive either a promise's eventual value or the reason
	  why the promise cannot be fulfilled.
	
	  Terminology
	  -----------
	
	  - `promise` is an object or function with a `then` method whose behavior conforms to this specification.
	  - `thenable` is an object or function that defines a `then` method.
	  - `value` is any legal JavaScript value (including undefined, a thenable, or a promise).
	  - `exception` is a value that is thrown using the throw statement.
	  - `reason` is a value that indicates why a promise was rejected.
	  - `settled` the final resting state of a promise, fulfilled or rejected.
	
	  A promise can be in one of three states: pending, fulfilled, or rejected.
	
	  Promises that are fulfilled have a fulfillment value and are in the fulfilled
	  state.  Promises that are rejected have a rejection reason and are in the
	  rejected state.  A fulfillment value is never a thenable.
	
	  Promises can also be said to *resolve* a value.  If this value is also a
	  promise, then the original promise's settled state will match the value's
	  settled state.  So a promise that *resolves* a promise that rejects will
	  itself reject, and a promise that *resolves* a promise that fulfills will
	  itself fulfill.
	
	
	  Basic Usage:
	  ------------
	
	  ```js
	  let promise = new Promise(function(resolve, reject) {
	    // on success
	    resolve(value);
	
	    // on failure
	    reject(reason);
	  });
	
	  promise.then(function(value) {
	    // on fulfillment
	  }, function(reason) {
	    // on rejection
	  });
	  ```
	
	  Advanced Usage:
	  ---------------
	
	  Promises shine when abstracting away asynchronous interactions such as
	  `XMLHttpRequest`s.
	
	  ```js
	  function getJSON(url) {
	    return new Promise(function(resolve, reject){
	      let xhr = new XMLHttpRequest();
	
	      xhr.open('GET', url);
	      xhr.onreadystatechange = handler;
	      xhr.responseType = 'json';
	      xhr.setRequestHeader('Accept', 'application/json');
	      xhr.send();
	
	      function handler() {
	        if (this.readyState === this.DONE) {
	          if (this.status === 200) {
	            resolve(this.response);
	          } else {
	            reject(new Error('getJSON: `' + url + '` failed with status: [' + this.status + ']'));
	          }
	        }
	      };
	    });
	  }
	
	  getJSON('/posts.json').then(function(json) {
	    // on fulfillment
	  }, function(reason) {
	    // on rejection
	  });
	  ```
	
	  Unlike callbacks, promises are great composable primitives.
	
	  ```js
	  Promise.all([
	    getJSON('/posts'),
	    getJSON('/comments')
	  ]).then(function(values){
	    values[0] // => postsJSON
	    values[1] // => commentsJSON
	
	    return values;
	  });
	  ```
	
	  @class Promise
	  @param {function} resolver
	  Useful for tooling.
	  @constructor
	*/
	function Promise(resolver) {
	  this[PROMISE_ID] = nextId();
	  this._result = this._state = undefined;
	  this._subscribers = [];
	
	  if (noop !== resolver) {
	    typeof resolver !== 'function' && needsResolver();
	    this instanceof Promise ? initializePromise(this, resolver) : needsNew();
	  }
	}
	
	Promise.all = all;
	Promise.race = race;
	Promise.resolve = resolve;
	Promise.reject = reject;
	Promise._setScheduler = setScheduler;
	Promise._setAsap = setAsap;
	Promise._asap = asap;
	
	Promise.prototype = {
	  constructor: Promise,
	
	  /**
	    The primary way of interacting with a promise is through its `then` method,
	    which registers callbacks to receive either a promise's eventual value or the
	    reason why the promise cannot be fulfilled.
	  
	    ```js
	    findUser().then(function(user){
	      // user is available
	    }, function(reason){
	      // user is unavailable, and you are given the reason why
	    });
	    ```
	  
	    Chaining
	    --------
	  
	    The return value of `then` is itself a promise.  This second, 'downstream'
	    promise is resolved with the return value of the first promise's fulfillment
	    or rejection handler, or rejected if the handler throws an exception.
	  
	    ```js
	    findUser().then(function (user) {
	      return user.name;
	    }, function (reason) {
	      return 'default name';
	    }).then(function (userName) {
	      // If `findUser` fulfilled, `userName` will be the user's name, otherwise it
	      // will be `'default name'`
	    });
	  
	    findUser().then(function (user) {
	      throw new Error('Found user, but still unhappy');
	    }, function (reason) {
	      throw new Error('`findUser` rejected and we're unhappy');
	    }).then(function (value) {
	      // never reached
	    }, function (reason) {
	      // if `findUser` fulfilled, `reason` will be 'Found user, but still unhappy'.
	      // If `findUser` rejected, `reason` will be '`findUser` rejected and we're unhappy'.
	    });
	    ```
	    If the downstream promise does not specify a rejection handler, rejection reasons will be propagated further downstream.
	  
	    ```js
	    findUser().then(function (user) {
	      throw new PedagogicalException('Upstream error');
	    }).then(function (value) {
	      // never reached
	    }).then(function (value) {
	      // never reached
	    }, function (reason) {
	      // The `PedgagocialException` is propagated all the way down to here
	    });
	    ```
	  
	    Assimilation
	    ------------
	  
	    Sometimes the value you want to propagate to a downstream promise can only be
	    retrieved asynchronously. This can be achieved by returning a promise in the
	    fulfillment or rejection handler. The downstream promise will then be pending
	    until the returned promise is settled. This is called *assimilation*.
	  
	    ```js
	    findUser().then(function (user) {
	      return findCommentsByAuthor(user);
	    }).then(function (comments) {
	      // The user's comments are now available
	    });
	    ```
	  
	    If the assimliated promise rejects, then the downstream promise will also reject.
	  
	    ```js
	    findUser().then(function (user) {
	      return findCommentsByAuthor(user);
	    }).then(function (comments) {
	      // If `findCommentsByAuthor` fulfills, we'll have the value here
	    }, function (reason) {
	      // If `findCommentsByAuthor` rejects, we'll have the reason here
	    });
	    ```
	  
	    Simple Example
	    --------------
	  
	    Synchronous Example
	  
	    ```javascript
	    let result;
	  
	    try {
	      result = findResult();
	      // success
	    } catch(reason) {
	      // failure
	    }
	    ```
	  
	    Errback Example
	  
	    ```js
	    findResult(function(result, err){
	      if (err) {
	        // failure
	      } else {
	        // success
	      }
	    });
	    ```
	  
	    Promise Example;
	  
	    ```javascript
	    findResult().then(function(result){
	      // success
	    }, function(reason){
	      // failure
	    });
	    ```
	  
	    Advanced Example
	    --------------
	  
	    Synchronous Example
	  
	    ```javascript
	    let author, books;
	  
	    try {
	      author = findAuthor();
	      books  = findBooksByAuthor(author);
	      // success
	    } catch(reason) {
	      // failure
	    }
	    ```
	  
	    Errback Example
	  
	    ```js
	  
	    function foundBooks(books) {
	  
	    }
	  
	    function failure(reason) {
	  
	    }
	  
	    findAuthor(function(author, err){
	      if (err) {
	        failure(err);
	        // failure
	      } else {
	        try {
	          findBoooksByAuthor(author, function(books, err) {
	            if (err) {
	              failure(err);
	            } else {
	              try {
	                foundBooks(books);
	              } catch(reason) {
	                failure(reason);
	              }
	            }
	          });
	        } catch(error) {
	          failure(err);
	        }
	        // success
	      }
	    });
	    ```
	  
	    Promise Example;
	  
	    ```javascript
	    findAuthor().
	      then(findBooksByAuthor).
	      then(function(books){
	        // found books
	    }).catch(function(reason){
	      // something went wrong
	    });
	    ```
	  
	    @method then
	    @param {Function} onFulfilled
	    @param {Function} onRejected
	    Useful for tooling.
	    @return {Promise}
	  */
	  then: then,
	
	  /**
	    `catch` is simply sugar for `then(undefined, onRejection)` which makes it the same
	    as the catch block of a try/catch statement.
	  
	    ```js
	    function findAuthor(){
	      throw new Error('couldn't find that author');
	    }
	  
	    // synchronous
	    try {
	      findAuthor();
	    } catch(reason) {
	      // something went wrong
	    }
	  
	    // async with promises
	    findAuthor().catch(function(reason){
	      // something went wrong
	    });
	    ```
	  
	    @method catch
	    @param {Function} onRejection
	    Useful for tooling.
	    @return {Promise}
	  */
	  'catch': function _catch(onRejection) {
	    return this.then(null, onRejection);
	  }
	};
	
	function polyfill() {
	    var local = undefined;
	
	    if (typeof global !== 'undefined') {
	        local = global;
	    } else if (typeof self !== 'undefined') {
	        local = self;
	    } else {
	        try {
	            local = Function('return this')();
	        } catch (e) {
	            throw new Error('polyfill failed because global object is unavailable in this environment');
	        }
	    }
	
	    var P = local.Promise;
	
	    if (P) {
	        var promiseToString = null;
	        try {
	            promiseToString = Object.prototype.toString.call(P.resolve());
	        } catch (e) {
	            // silently ignored
	        }
	
	        if (promiseToString === '[object Promise]' && !P.cast) {
	            return;
	        }
	    }
	
	    local.Promise = Promise;
	}
	
	polyfill();
	// Strange compat..
	Promise.polyfill = polyfill;
	Promise.Promise = Promise;
	
	return Promise;
	
	})));
	//# sourceMappingURL=es6-promise.map
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(294), (function() { return this; }())))

/***/ }),
/* 1353 */
/***/ (function(module, exports) {

	/* (ignored) */

/***/ }),
/* 1354 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = inlineHeaders;
	
	var encode = __webpack_require__(1355);
	
	function inlineHeaders(url, headers) {
	  if (/\?/.test(url)) {
	    url += '&';
	  } else {
	    url += '?';
	  }
	
	  return url + encode(headers);
	}


/***/ }),
/* 1355 */
/***/ (function(module, exports) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	'use strict';
	
	var stringifyPrimitive = function(v) {
	  switch (typeof v) {
	    case 'string':
	      return v;
	
	    case 'boolean':
	      return v ? 'true' : 'false';
	
	    case 'number':
	      return isFinite(v) ? v : '';
	
	    default:
	      return '';
	  }
	};
	
	module.exports = function(obj, sep, eq, name) {
	  sep = sep || '&';
	  eq = eq || '=';
	  if (obj === null) {
	    obj = undefined;
	  }
	
	  if (typeof obj === 'object') {
	    return map(objectKeys(obj), function(k) {
	      var ks = encodeURIComponent(stringifyPrimitive(k)) + eq;
	      if (isArray(obj[k])) {
	        return map(obj[k], function(v) {
	          return ks + encodeURIComponent(stringifyPrimitive(v));
	        }).join(sep);
	      } else {
	        return ks + encodeURIComponent(stringifyPrimitive(obj[k]));
	      }
	    }).join(sep);
	
	  }
	
	  if (!name) return '';
	  return encodeURIComponent(stringifyPrimitive(name)) + eq +
	         encodeURIComponent(stringifyPrimitive(obj));
	};
	
	var isArray = Array.isArray || function (xs) {
	  return Object.prototype.toString.call(xs) === '[object Array]';
	};
	
	function map (xs, f) {
	  if (xs.map) return xs.map(f);
	  var res = [];
	  for (var i = 0; i < xs.length; i++) {
	    res.push(f(xs[i], i));
	  }
	  return res;
	}
	
	var objectKeys = Object.keys || function (obj) {
	  var res = [];
	  for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) res.push(key);
	  }
	  return res;
	};


/***/ }),
/* 1356 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = jsonpRequest;
	
	var errors = __webpack_require__(1332);
	
	var JSONPCounter = 0;
	
	function jsonpRequest(url, opts, cb) {
	  if (opts.method !== 'GET') {
	    cb(new Error('Method ' + opts.method + ' ' + url + ' is not supported by JSONP.'));
	    return;
	  }
	
	  opts.debug('JSONP: start');
	
	  var cbCalled = false;
	  var timedOut = false;
	
	  JSONPCounter += 1;
	  var head = document.getElementsByTagName('head')[0];
	  var script = document.createElement('script');
	  var cbName = 'algoliaJSONP_' + JSONPCounter;
	  var done = false;
	
	  window[cbName] = function(data) {
	    removeGlobals();
	
	    if (timedOut) {
	      opts.debug('JSONP: Late answer, ignoring');
	      return;
	    }
	
	    cbCalled = true;
	
	    clean();
	
	    cb(null, {
	      body: data/* ,
	      // We do not send the statusCode, there's no statusCode in JSONP, it will be
	      // computed using data.status && data.message like with XDR
	      statusCode*/
	    });
	  };
	
	  // add callback by hand
	  url += '&callback=' + cbName;
	
	  // add body params manually
	  if (opts.jsonBody && opts.jsonBody.params) {
	    url += '&' + opts.jsonBody.params;
	  }
	
	  var ontimeout = setTimeout(timeout, opts.timeout);
	
	  // script onreadystatechange needed only for
	  // <= IE8
	  // https://github.com/angular/angular.js/issues/4523
	  script.onreadystatechange = readystatechange;
	  script.onload = success;
	  script.onerror = error;
	
	  script.async = true;
	  script.defer = true;
	  script.src = url;
	  head.appendChild(script);
	
	  function success() {
	    opts.debug('JSONP: success');
	
	    if (done || timedOut) {
	      return;
	    }
	
	    done = true;
	
	    // script loaded but did not call the fn => script loading error
	    if (!cbCalled) {
	      opts.debug('JSONP: Fail. Script loaded but did not call the callback');
	      clean();
	      cb(new errors.JSONPScriptFail());
	    }
	  }
	
	  function readystatechange() {
	    if (this.readyState === 'loaded' || this.readyState === 'complete') {
	      success();
	    }
	  }
	
	  function clean() {
	    clearTimeout(ontimeout);
	    script.onload = null;
	    script.onreadystatechange = null;
	    script.onerror = null;
	    head.removeChild(script);
	  }
	
	  function removeGlobals() {
	    try {
	      delete window[cbName];
	      delete window[cbName + '_loaded'];
	    } catch (e) {
	      window[cbName] = window[cbName + '_loaded'] = undefined;
	    }
	  }
	
	  function timeout() {
	    opts.debug('JSONP: Script timeout');
	    timedOut = true;
	    clean();
	    cb(new errors.RequestTimeout());
	  }
	
	  function error() {
	    opts.debug('JSONP: Script error');
	
	    if (done || timedOut) {
	      return;
	    }
	
	    clean();
	    cb(new errors.JSONPScriptError());
	  }
	}


/***/ }),
/* 1357 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = createPlacesClient;
	
	var buildSearchMethod = __webpack_require__(1331);
	
	function createPlacesClient(algoliasearch) {
	  return function places(appID, apiKey, opts) {
	    var cloneDeep = __webpack_require__(1335);
	
	    opts = opts && cloneDeep(opts) || {};
	    opts.hosts = opts.hosts || [
	      'places-dsn.algolia.net',
	      'places-1.algolianet.com',
	      'places-2.algolianet.com',
	      'places-3.algolianet.com'
	    ];
	
	    // allow initPlaces() no arguments => community rate limited
	    if (arguments.length === 0 || typeof appID === 'object' || appID === undefined) {
	      appID = '';
	      apiKey = '';
	      opts._allowEmptyCredentials = true;
	    }
	
	    var client = algoliasearch(appID, apiKey, opts);
	    var index = client.initIndex('places');
	    index.search = buildSearchMethod('query', '/1/places/query');
	    return index;
	  };
	}


/***/ }),
/* 1358 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = getDocumentProtocol;
	
	function getDocumentProtocol() {
	  var protocol = window.document.location.protocol;
	
	  // when in `file:` mode (local html file), default to `http:`
	  if (protocol !== 'http:' && protocol !== 'https:') {
	    protocol = 'http:';
	  }
	
	  return protocol;
	}


/***/ }),
/* 1359 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = '3.19.1';


/***/ }),
/* 1360 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var AlgoliaSearchHelper = __webpack_require__(1361);
	
	var SearchParameters = __webpack_require__(1362);
	var SearchResults = __webpack_require__(1415);
	
	/**
	 * The algoliasearchHelper module is the function that will let its
	 * contains everything needed to use the Algoliasearch
	 * Helper. It is a also a function that instanciate the helper.
	 * To use the helper, you also need the Algolia JS client v3.
	 * @example
	 * //using the UMD build
	 * var client = algoliasearch('latency', '6be0576ff61c053d5f9a3225e2a90f76');
	 * var helper = algoliasearchHelper(client, 'bestbuy', {
	 *   facets: ['shipping'],
	 *   disjunctiveFacets: ['category']
	 * });
	 * helper.on('result', function(result) {
	 *   console.log(result);
	 * });
	 * helper.toggleRefine('Movies & TV Shows')
	 *       .toggleRefine('Free shipping')
	 *       .search();
	 * @example
	 * // The helper is an event emitter using the node API
	 * helper.on('result', updateTheResults);
	 * helper.once('result', updateTheResults);
	 * helper.removeListener('result', updateTheResults);
	 * helper.removeAllListeners('result');
	 * @module algoliasearchHelper
	 * @param  {AlgoliaSearch} client an AlgoliaSearch client
	 * @param  {string} index the name of the index to query
	 * @param  {SearchParameters|object} opts an object defining the initial config of the search. It doesn't have to be a {SearchParameters}, just an object containing the properties you need from it.
	 * @return {AlgoliaSearchHelper}
	 */
	function algoliasearchHelper(client, index, opts) {
	  return new AlgoliaSearchHelper(client, index, opts);
	}
	
	/**
	 * The version currently used
	 * @member module:algoliasearchHelper.version
	 * @type {number}
	 */
	algoliasearchHelper.version = __webpack_require__(1481);
	
	/**
	 * Constructor for the Helper.
	 * @member module:algoliasearchHelper.AlgoliaSearchHelper
	 * @type {AlgoliaSearchHelper}
	 */
	algoliasearchHelper.AlgoliaSearchHelper = AlgoliaSearchHelper;
	
	/**
	 * Constructor for the object containing all the parameters of the search.
	 * @member module:algoliasearchHelper.SearchParameters
	 * @type {SearchParameters}
	 */
	algoliasearchHelper.SearchParameters = SearchParameters;
	
	/**
	 * Constructor for the object containing the results of the search.
	 * @member module:algoliasearchHelper.SearchResults
	 * @type {SearchResults}
	 */
	algoliasearchHelper.SearchResults = SearchResults;
	
	/**
	 * URL tools to generate query string and parse them from/into
	 * SearchParameters
	 * @member module:algoliasearchHelper.url
	 * @type {object} {@link url}
	 *
	 */
	algoliasearchHelper.url = __webpack_require__(1467);
	
	module.exports = algoliasearchHelper;


/***/ }),
/* 1361 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var SearchParameters = __webpack_require__(1362);
	var SearchResults = __webpack_require__(1415);
	var requestBuilder = __webpack_require__(1462);
	
	var util = __webpack_require__(1463);
	var events = __webpack_require__(1345);
	
	var forEach = __webpack_require__(1374);
	var bind = __webpack_require__(1466);
	var isEmpty = __webpack_require__(1397);
	
	var url = __webpack_require__(1467);
	
	/**
	 * Event triggered when a parameter is set or updated
	 * @event AlgoliaSearchHelper#event:change
	 * @property {SearchParameters} state the current parameters with the latest changes applied
	 * @property {SearchResults} lastResults the previous results received from Algolia. `null` before
	 * the first request
	 * @example
	 * helper.on('change', function(state, lastResults) {
	 *   console.log('The parameters have changed');
	 * });
	 */
	
	/**
	 * Event triggered when the search is sent to Algolia
	 * @event AlgoliaSearchHelper#event:search
	 * @property {SearchParameters} state the parameters used for this search
	 * @property {SearchResults} lastResults the results from the previous search. `null` if
	 * it is the first search.
	 * @example
	 * helper.on('search', function(state, lastResults) {
	 *   console.log('Search sent');
	 * });
	 */
	
	/**
	 * Event triggered when the results are retrieved from Algolia
	 * @event AlgoliaSearchHelper#event:result
	 * @property {SearchResults} results the results received from Algolia
	 * @property {SearchParameters} state the parameters used to query Algolia. Those might
	 * be different from the one in the helper instance (for example if the network is unreliable).
	 * @example
	 * helper.on('result', function(results, state) {
	 *   console.log('Search results received');
	 * });
	 */
	
	/**
	 * Event triggered when Algolia sends back an error. For example, if an unknown parameter is
	 * used, the error can be caught using this event.
	 * @event AlgoliaSearchHelper#event:error
	 * @property {Error} error the error returned by the Algolia.
	 * @example
	 * helper.on('error', function(error) {
	 *   console.log('Houston we got a problem.');
	 * });
	 */
	
	/**
	 * Initialize a new AlgoliaSearchHelper
	 * @class
	 * @classdesc The AlgoliaSearchHelper is a class that ease the management of the
	 * search. It provides an event based interface for search callbacks:
	 *  - change: when the internal search state is changed.
	 *    This event contains a {@link SearchParameters} object and the
	 *    {@link SearchResults} of the last result if any.
	 *  - search: when a search is triggered using the `search()` method.
	 *  - result: when the response is retrieved from Algolia and is processed.
	 *    This event contains a {@link SearchResults} object and the
	 *    {@link SearchParameters} corresponding to this answer.
	 *  - error: when the response is an error. This event contains the error returned by the server.
	 * @param  {AlgoliaSearch} client an AlgoliaSearch client
	 * @param  {string} index the index name to query
	 * @param  {SearchParameters | object} options an object defining the initial
	 * config of the search. It doesn't have to be a {SearchParameters},
	 * just an object containing the properties you need from it.
	 */
	function AlgoliaSearchHelper(client, index, options) {
	  this.client = client;
	  var opts = options || {};
	  opts.index = index;
	  this.state = SearchParameters.make(opts);
	  this.lastResults = null;
	  this._queryId = 0;
	  this._lastQueryIdReceived = -1;
	}
	
	util.inherits(AlgoliaSearchHelper, events.EventEmitter);
	
	/**
	 * Start the search with the parameters set in the state. When the
	 * method is called, it triggers a `search` event. The results will
	 * be available through the `result` event. If an error occcurs, an
	 * `error` will be fired instead.
	 * @return {AlgoliaSearchHelper}
	 * @fires search
	 * @fires result
	 * @fires error
	 * @chainable
	 */
	AlgoliaSearchHelper.prototype.search = function() {
	  this._search();
	  return this;
	};
	
	/**
	 * Gets the search query parameters that would be sent to the Algolia Client
	 * for the hits
	 * @return {object} Query Parameters
	 */
	AlgoliaSearchHelper.prototype.getQuery = function() {
	  var state = this.state;
	  return requestBuilder._getHitsSearchParams(state);
	};
	
	/**
	 * Start a search using a modified version of the current state. This method does
	 * not trigger the helper lifecycle and does not modify the state kept internally
	 * by the helper. This second aspect means that the next search call will be the
	 * same as a search call before calling searchOnce.
	 * @param {object} options can contain all the parameters that can be set to SearchParameters
	 * plus the index
	 * @param {function} [callback] optional callback executed when the response from the
	 * server is back.
	 * @return {promise|undefined} if a callback is passed the method returns undefined
	 * otherwise it returns a promise containing an object with two keys :
	 *  - content with a SearchResults
	 *  - state with the state used for the query as a SearchParameters
	 * @example
	 * // Changing the number of records returned per page to 1
	 * // This example uses the callback API
	 * var state = helper.searchOnce({hitsPerPage: 1},
	 *   function(error, content, state) {
	 *     // if an error occured it will be passed in error, otherwise its value is null
	 *     // content contains the results formatted as a SearchResults
	 *     // state is the instance of SearchParameters used for this search
	 *   });
	 * @example
	 * // Changing the number of records returned per page to 1
	 * // This example uses the promise API
	 * var state1 = helper.searchOnce({hitsPerPage: 1})
	 *                 .then(promiseHandler);
	 *
	 * function promiseHandler(res) {
	 *   // res contains
	 *   // {
	 *   //   content : SearchResults
	 *   //   state   : SearchParameters (the one used for this specific search)
	 *   // }
	 * }
	 */
	AlgoliaSearchHelper.prototype.searchOnce = function(options, cb) {
	  var tempState = !options ? this.state : this.state.setQueryParameters(options);
	  var queries = requestBuilder._getQueries(tempState.index, tempState);
	  if (cb) {
	    return this.client.search(
	      queries,
	      function(err, content) {
	        if (err) cb(err, null, tempState);
	        else cb(null, new SearchResults(tempState, content), tempState);
	      });
	  }
	
	  return this.client.search(queries).then(
	    function(content) {
	      return {
	        content: new SearchResults(tempState, content),
	        state: tempState,
	        _originalResponse: content
	      };
	    });
	};
	
	/**
	 * Sets the text query used for the search.
	 *
	 * This method resets the current page to 0.
	 * @param  {string} q the user query
	 * @return {AlgoliaSearchHelper}
	 * @fires change
	 * @chainable
	 */
	AlgoliaSearchHelper.prototype.setQuery = function(q) {
	  this.state = this.state.setPage(0).setQuery(q);
	  this._change();
	  return this;
	};
	
	/**
	 * Remove all the types of refinements except tags. A string can be provided to remove
	 * only the refinements of a specific attribute. For more advanced use case, you can
	 * provide a function instead. This function should follow the
	 * [clearCallback definition](#SearchParameters.clearCallback).
	 *
	 * This method resets the current page to 0.
	 * @param {string} [name] optional name of the facet / attribute on which we want to remove all refinements
	 * @return {AlgoliaSearchHelper}
	 * @fires change
	 * @chainable
	 * @example
	 * // Removing all the refinements
	 * helper.clearRefinements().search();
	 * @example
	 * // Removing all the filters on a the category attribute.
	 * helper.clearRefinements('category').search();
	 * @example
	 * // Removing only the exclude filters on the category facet.
	 * helper.clearRefinements(function(value, attribute, type) {
	 *   return type === 'exclude' && attribute === 'category';
	 * }).search();
	 */
	AlgoliaSearchHelper.prototype.clearRefinements = function(name) {
	  this.state = this.state.setPage(0).clearRefinements(name);
	  this._change();
	  return this;
	};
	
	/**
	 * Remove all the tag filters.
	 *
	 * This method resets the current page to 0.
	 * @return {AlgoliaSearchHelper}
	 * @fires change
	 * @chainable
	 */
	AlgoliaSearchHelper.prototype.clearTags = function() {
	  this.state = this.state.setPage(0).clearTags();
	  this._change();
	  return this;
	};
	
	/**
	 * Adds a disjunctive filter to a facetted attribute with the `value` provided. If the
	 * filter is already set, it doesn't change the filters.
	 *
	 * This method resets the current page to 0.
	 * @param  {string} facet the facet to refine
	 * @param  {string} value the associated value (will be converted to string)
	 * @return {AlgoliaSearchHelper}
	 * @fires change
	 * @chainable
	 */
	AlgoliaSearchHelper.prototype.addDisjunctiveFacetRefinement = function(facet, value) {
	  this.state = this.state.setPage(0).addDisjunctiveFacetRefinement(facet, value);
	  this._change();
	  return this;
	};
	
	/**
	 * @deprecated since version 2.4.0, see {@link AlgoliaSearchHelper#addDisjunctiveFacetRefinement}
	 */
	AlgoliaSearchHelper.prototype.addDisjunctiveRefine = function() {
	  return this.addDisjunctiveFacetRefinement.apply(this, arguments);
	};
	
	/**
	 * Adds a refinement on a hierarchical facet. It will throw
	 * an exception if the facet is not defined or if the facet
	 * is already refined.
	 *
	 * This method resets the current page to 0.
	 * @param {string} facet the facet name
	 * @param {string} path the hierarchical facet path
	 * @return {AlgoliaSearchHelper}
	 * @throws Error if the facet is not defined or if the facet is refined
	 * @chainable
	 * @fires change
	 */
	AlgoliaSearchHelper.prototype.addHierarchicalFacetRefinement = function(facet, value) {
	  this.state = this.state.setPage(0).addHierarchicalFacetRefinement(facet, value);
	  this._change();
	  return this;
	};
	
	/**
	 * Adds a an numeric filter to an attribute with the `operator` and `value` provided. If the
	 * filter is already set, it doesn't change the filters.
	 *
	 * This method resets the current page to 0.
	 * @param  {string} attribute the attribute on which the numeric filter applies
	 * @param  {string} operator the operator of the filter
	 * @param  {number} value the value of the filter
	 * @return {AlgoliaSearchHelper}
	 * @fires change
	 * @chainable
	 */
	AlgoliaSearchHelper.prototype.addNumericRefinement = function(attribute, operator, value) {
	  this.state = this.state.setPage(0).addNumericRefinement(attribute, operator, value);
	  this._change();
	  return this;
	};
	
	/**
	 * Adds a filter to a facetted attribute with the `value` provided. If the
	 * filter is already set, it doesn't change the filters.
	 *
	 * This method resets the current page to 0.
	 * @param  {string} facet the facet to refine
	 * @param  {string} value the associated value (will be converted to string)
	 * @return {AlgoliaSearchHelper}
	 * @fires change
	 * @chainable
	 */
	AlgoliaSearchHelper.prototype.addFacetRefinement = function(facet, value) {
	  this.state = this.state.setPage(0).addFacetRefinement(facet, value);
	  this._change();
	  return this;
	};
	
	/**
	 * @deprecated since version 2.4.0, see {@link AlgoliaSearchHelper#addFacetRefinement}
	 */
	AlgoliaSearchHelper.prototype.addRefine = function() {
	  return this.addFacetRefinement.apply(this, arguments);
	};
	
	
	/**
	 * Adds a an exclusion filter to a facetted attribute with the `value` provided. If the
	 * filter is already set, it doesn't change the filters.
	 *
	 * This method resets the current page to 0.
	 * @param  {string} facet the facet to refine
	 * @param  {string} value the associated value (will be converted to string)
	 * @return {AlgoliaSearchHelper}
	 * @fires change
	 * @chainable
	 */
	AlgoliaSearchHelper.prototype.addFacetExclusion = function(facet, value) {
	  this.state = this.state.setPage(0).addExcludeRefinement(facet, value);
	  this._change();
	  return this;
	};
	
	/**
	 * @deprecated since version 2.4.0, see {@link AlgoliaSearchHelper#addFacetExclusion}
	 */
	AlgoliaSearchHelper.prototype.addExclude = function() {
	  return this.addFacetExclusion.apply(this, arguments);
	};
	
	/**
	 * Adds a tag filter with the `tag` provided. If the
	 * filter is already set, it doesn't change the filters.
	 *
	 * This method resets the current page to 0.
	 * @param {string} tag the tag to add to the filter
	 * @return {AlgoliaSearchHelper}
	 * @fires change
	 * @chainable
	 */
	AlgoliaSearchHelper.prototype.addTag = function(tag) {
	  this.state = this.state.setPage(0).addTagRefinement(tag);
	  this._change();
	  return this;
	};
	
	/**
	 * Removes an numeric filter to an attribute with the `operator` and `value` provided. If the
	 * filter is not set, it doesn't change the filters.
	 *
	 * Some parameters are optionnals, triggering different behaviors:
	 *  - if the value is not provided, then all the numeric value will be removed for the
	 *  specified attribute/operator couple.
	 *  - if the operator is not provided either, then all the numeric filter on this attribute
	 *  will be removed.
	 *
	 * This method resets the current page to 0.
	 * @param  {string} attribute the attribute on which the numeric filter applies
	 * @param  {string} [operator] the operator of the filter
	 * @param  {number} [value] the value of the filter
	 * @return {AlgoliaSearchHelper}
	 * @fires change
	 * @chainable
	 */
	AlgoliaSearchHelper.prototype.removeNumericRefinement = function(attribute, operator, value) {
	  this.state = this.state.setPage(0).removeNumericRefinement(attribute, operator, value);
	  this._change();
	  return this;
	};
	
	/**
	 * Removes a disjunctive filter to a facetted attribute with the `value` provided. If the
	 * filter is not set, it doesn't change the filters.
	 *
	 * If the value is omitted, then this method will remove all the filters for the
	 * attribute.
	 *
	 * This method resets the current page to 0.
	 * @param  {string} facet the facet to refine
	 * @param  {string} [value] the associated value
	 * @return {AlgoliaSearchHelper}
	 * @fires change
	 * @chainable
	 */
	AlgoliaSearchHelper.prototype.removeDisjunctiveFacetRefinement = function(facet, value) {
	  this.state = this.state.setPage(0).removeDisjunctiveFacetRefinement(facet, value);
	  this._change();
	  return this;
	};
	
	/**
	 * @deprecated since version 2.4.0, see {@link AlgoliaSearchHelper#removeDisjunctiveFacetRefinement}
	 */
	AlgoliaSearchHelper.prototype.removeDisjunctiveRefine = function() {
	  return this.removeDisjunctiveFacetRefinement.apply(this, arguments);
	};
	
	/**
	 * Removes the refinement set on a hierarchical facet.
	 * @param {string} facet the facet name
	 * @return {AlgoliaSearchHelper}
	 * @throws Error if the facet is not defined or if the facet is not refined
	 * @fires change
	 * @chainable
	 */
	AlgoliaSearchHelper.prototype.removeHierarchicalFacetRefinement = function(facet) {
	  this.state = this.state.setPage(0).removeHierarchicalFacetRefinement(facet);
	  this._change();
	
	  return this;
	};
	
	/**
	 * Removes a filter to a facetted attribute with the `value` provided. If the
	 * filter is not set, it doesn't change the filters.
	 *
	 * If the value is omitted, then this method will remove all the filters for the
	 * attribute.
	 *
	 * This method resets the current page to 0.
	 * @param  {string} facet the facet to refine
	 * @param  {string} [value] the associated value
	 * @return {AlgoliaSearchHelper}
	 * @fires change
	 * @chainable
	 */
	AlgoliaSearchHelper.prototype.removeFacetRefinement = function(facet, value) {
	  this.state = this.state.setPage(0).removeFacetRefinement(facet, value);
	  this._change();
	  return this;
	};
	
	/**
	 * @deprecated since version 2.4.0, see {@link AlgoliaSearchHelper#removeFacetRefinement}
	 */
	AlgoliaSearchHelper.prototype.removeRefine = function() {
	  return this.removeFacetRefinement.apply(this, arguments);
	};
	
	/**
	 * Removes an exclusion filter to a facetted attribute with the `value` provided. If the
	 * filter is not set, it doesn't change the filters.
	 *
	 * If the value is omitted, then this method will remove all the filters for the
	 * attribute.
	 *
	 * This method resets the current page to 0.
	 * @param  {string} facet the facet to refine
	 * @param  {string} [value] the associated value
	 * @return {AlgoliaSearchHelper}
	 * @fires change
	 * @chainable
	 */
	AlgoliaSearchHelper.prototype.removeFacetExclusion = function(facet, value) {
	  this.state = this.state.setPage(0).removeExcludeRefinement(facet, value);
	  this._change();
	  return this;
	};
	
	/**
	 * @deprecated since version 2.4.0, see {@link AlgoliaSearchHelper#removeFacetExclusion}
	 */
	AlgoliaSearchHelper.prototype.removeExclude = function() {
	  return this.removeFacetExclusion.apply(this, arguments);
	};
	
	/**
	 * Removes a tag filter with the `tag` provided. If the
	 * filter is not set, it doesn't change the filters.
	 *
	 * This method resets the current page to 0.
	 * @param {string} tag tag to remove from the filter
	 * @return {AlgoliaSearchHelper}
	 * @fires change
	 * @chainable
	 */
	AlgoliaSearchHelper.prototype.removeTag = function(tag) {
	  this.state = this.state.setPage(0).removeTagRefinement(tag);
	  this._change();
	  return this;
	};
	
	/**
	 * Adds or removes an exclusion filter to a facetted attribute with the `value` provided. If
	 * the value is set then it removes it, otherwise it adds the filter.
	 *
	 * This method resets the current page to 0.
	 * @param  {string} facet the facet to refine
	 * @param  {string} value the associated value
	 * @return {AlgoliaSearchHelper}
	 * @fires change
	 * @chainable
	 */
	AlgoliaSearchHelper.prototype.toggleFacetExclusion = function(facet, value) {
	  this.state = this.state.setPage(0).toggleExcludeFacetRefinement(facet, value);
	  this._change();
	  return this;
	};
	
	/**
	 * @deprecated since version 2.4.0, see {@link AlgoliaSearchHelper#toggleFacetExclusion}
	 */
	AlgoliaSearchHelper.prototype.toggleExclude = function() {
	  return this.toggleFacetExclusion.apply(this, arguments);
	};
	
	/**
	 * Adds or removes a filter to a facetted attribute with the `value` provided. If
	 * the value is set then it removes it, otherwise it adds the filter.
	 *
	 * This method can be used for conjunctive, disjunctive and hierarchical filters.
	 *
	 * This method resets the current page to 0.
	 * @param  {string} facet the facet to refine
	 * @param  {string} value the associated value
	 * @return {AlgoliaSearchHelper}
	 * @throws Error will throw an error if the facet is not declared in the settings of the helper
	 * @fires change
	 * @chainable
	 */
	AlgoliaSearchHelper.prototype.toggleRefinement = function(facet, value) {
	  this.state = this.state.setPage(0).toggleRefinement(facet, value);
	
	  this._change();
	  return this;
	};
	
	/**
	 * @deprecated since version 2.4.0, see {@link AlgoliaSearchHelper#toggleRefinement}
	 */
	AlgoliaSearchHelper.prototype.toggleRefine = function() {
	  return this.toggleRefinement.apply(this, arguments);
	};
	
	/**
	 * Adds or removes a tag filter with the `value` provided. If
	 * the value is set then it removes it, otherwise it adds the filter.
	 *
	 * This method resets the current page to 0.
	 * @param {string} tag tag to remove or add
	 * @return {AlgoliaSearchHelper}
	 * @fires change
	 * @chainable
	 */
	AlgoliaSearchHelper.prototype.toggleTag = function(tag) {
	  this.state = this.state.setPage(0).toggleTagRefinement(tag);
	  this._change();
	  return this;
	};
	
	/**
	 * Increments the page number by one.
	 * @return {AlgoliaSearchHelper}
	 * @fires change
	 * @chainable
	 * @example
	 * helper.setPage(0).nextPage().getPage();
	 * // returns 1
	 */
	AlgoliaSearchHelper.prototype.nextPage = function() {
	  return this.setPage(this.state.page + 1);
	};
	
	/**
	 * Decrements the page number by one.
	 * @fires change
	 * @return {AlgoliaSearchHelper}
	 * @chainable
	 * @example
	 * helper.setPage(1).previousPage().getPage();
	 * // returns 0
	 */
	AlgoliaSearchHelper.prototype.previousPage = function() {
	  return this.setPage(this.state.page - 1);
	};
	
	/**
	 * @private
	 */
	function setCurrentPage(page) {
	  if (page < 0) throw new Error('Page requested below 0.');
	
	  this.state = this.state.setPage(page);
	  this._change();
	  return this;
	}
	
	/**
	 * Change the current page
	 * @deprecated
	 * @param  {number} page The page number
	 * @return {AlgoliaSearchHelper}
	 * @fires change
	 * @chainable
	 */
	AlgoliaSearchHelper.prototype.setCurrentPage = setCurrentPage;
	
	/**
	 * Updates the current page.
	 * @function
	 * @param  {number} page The page number
	 * @return {AlgoliaSearchHelper}
	 * @fires change
	 * @chainable
	 */
	AlgoliaSearchHelper.prototype.setPage = setCurrentPage;
	
	/**
	 * Updates the name of the index that will be targeted by the query.
	 *
	 * This method resets the current page to 0.
	 * @param {string} name the index name
	 * @return {AlgoliaSearchHelper}
	 * @fires change
	 * @chainable
	 */
	AlgoliaSearchHelper.prototype.setIndex = function(name) {
	  this.state = this.state.setPage(0).setIndex(name);
	  this._change();
	  return this;
	};
	
	/**
	 * Update a parameter of the search. This method reset the page
	 *
	 * The complete list of parameters is available on the
	 * [Algolia website](https://www.algolia.com/doc/rest#query-an-index).
	 * The most commonly used parameters have their own [shortcuts](#query-parameters-shortcuts)
	 * or benefit from higher-level APIs (all the kind of filters and facets have their own API)
	 *
	 * This method resets the current page to 0.
	 * @param {string} parameter name of the parameter to update
	 * @param {any} value new value of the parameter
	 * @return {AlgoliaSearchHelper}
	 * @fires change
	 * @chainable
	 * @example
	 * helper.setQueryParameter('hitsPerPage', 20).search();
	 */
	AlgoliaSearchHelper.prototype.setQueryParameter = function(parameter, value) {
	  var newState = this.state.setPage(0).setQueryParameter(parameter, value);
	
	  if (this.state === newState) return this;
	
	  this.state = newState;
	  this._change();
	  return this;
	};
	
	/**
	 * Set the whole state (warning: will erase previous state)
	 * @param {SearchParameters} newState the whole new state
	 * @return {AlgoliaSearchHelper}
	 * @fires change
	 * @chainable
	 */
	AlgoliaSearchHelper.prototype.setState = function(newState) {
	  this.state = new SearchParameters(newState);
	  this._change();
	  return this;
	};
	
	/**
	 * Get the current search state stored in the helper. This object is immutable.
	 * @param {string[]} [filters] optionnal filters to retrieve only a subset of the state
	 * @return {SearchParameters|object} if filters is specified a plain object is
	 * returned containing only the requested fields, otherwise return the unfiltered
	 * state
	 * @example
	 * // Get the complete state as stored in the helper
	 * helper.getState();
	 * @example
	 * // Get a part of the state with all the refinements on attributes and the query
	 * helper.getState(['query', 'attribute:category']);
	 */
	AlgoliaSearchHelper.prototype.getState = function(filters) {
	  if (filters === undefined) return this.state;
	  return this.state.filter(filters);
	};
	
	/**
	 * DEPRECATED Get part of the state as a query string. By default, the output keys will not
	 * be prefixed and will only take the applied refinements and the query.
	 * @deprecated
	 * @param {object} [options] May contain the following parameters :
	 *
	 * **filters** : possible values are all the keys of the [SearchParameters](#searchparameters), `index` for
	 * the index, all the refinements with `attribute:*` or for some specific attributes with
	 * `attribute:theAttribute`
	 *
	 * **prefix** : prefix in front of the keys
	 *
	 * **moreAttributes** : more values to be added in the query string. Those values
	 *    won't be prefixed.
	 * @return {string} the query string
	 */
	AlgoliaSearchHelper.prototype.getStateAsQueryString = function getStateAsQueryString(options) {
	  var filters = options && options.filters || ['query', 'attribute:*'];
	  var partialState = this.getState(filters);
	
	  return url.getQueryStringFromState(partialState, options);
	};
	
	/**
	 * DEPRECATED Read a query string and return an object containing the state. Use
	 * url module.
	 * @deprecated
	 * @static
	 * @param {string} queryString the query string that will be decoded
	 * @param {object} options accepted options :
	 *   - prefix : the prefix used for the saved attributes, you have to provide the
	 *     same that was used for serialization
	 * @return {object} partial search parameters object (same properties than in the
	 * SearchParameters but not exhaustive)
	 * @see {@link url#getStateFromQueryString}
	 */
	AlgoliaSearchHelper.getConfigurationFromQueryString = url.getStateFromQueryString;
	
	/**
	 * DEPRECATED Retrieve an object of all the properties that are not understandable as helper
	 * parameters. Use url module.
	 * @deprecated
	 * @static
	 * @param {string} queryString the query string to read
	 * @param {object} options the options
	 *   - prefixForParameters : prefix used for the helper configuration keys
	 * @return {object} the object containing the parsed configuration that doesn't
	 * to the helper
	 */
	AlgoliaSearchHelper.getForeignConfigurationInQueryString = url.getUnrecognizedParametersInQueryString;
	
	/**
	 * DEPRECATED Overrides part of the state with the properties stored in the provided query
	 * string.
	 * @deprecated
	 * @param {string} queryString the query string containing the informations to url the state
	 * @param {object} options optionnal parameters :
	 *  - prefix : prefix used for the algolia parameters
	 *  - triggerChange : if set to true the state update will trigger a change event
	 */
	AlgoliaSearchHelper.prototype.setStateFromQueryString = function(queryString, options) {
	  var triggerChange = options && options.triggerChange || false;
	  var configuration = url.getStateFromQueryString(queryString, options);
	  var updatedState = this.state.setQueryParameters(configuration);
	
	  if (triggerChange) this.setState(updatedState);
	  else this.overrideStateWithoutTriggeringChangeEvent(updatedState);
	};
	
	/**
	 * Override the current state without triggering a change event.
	 * Do not use this method unless you know what you are doing. (see the example
	 * for a legit use case)
	 * @param {SearchParameters} newState the whole new state
	 * @return {AlgoliaSearchHelper}
	 * @example
	 *  helper.on('change', function(state){
	 *    // In this function you might want to find a way to store the state in the url/history
	 *    updateYourURL(state)
	 *  })
	 *  window.onpopstate = function(event){
	 *    // This is naive though as you should check if the state is really defined etc.
	 *    helper.overrideStateWithoutTriggeringChangeEvent(event.state).search()
	 *  }
	 * @chainable
	 */
	AlgoliaSearchHelper.prototype.overrideStateWithoutTriggeringChangeEvent = function(newState) {
	  this.state = new SearchParameters(newState);
	  return this;
	};
	
	/**
	 * @deprecated since 2.4.0, see {@link AlgoliaSearchHelper#hasRefinements}
	 */
	AlgoliaSearchHelper.prototype.isRefined = function(facet, value) {
	  if (this.state.isConjunctiveFacet(facet)) {
	    return this.state.isFacetRefined(facet, value);
	  } else if (this.state.isDisjunctiveFacet(facet)) {
	    return this.state.isDisjunctiveFacetRefined(facet, value);
	  }
	
	  throw new Error(facet +
	    ' is not properly defined in this helper configuration' +
	    '(use the facets or disjunctiveFacets keys to configure it)');
	};
	
	/**
	 * Check if an attribute has any numeric, conjunctive, disjunctive or hierarchical filters.
	 * @param {string} attribute the name of the attribute
	 * @return {boolean} true if the attribute is filtered by at least one value
	 * @example
	 * // hasRefinements works with numeric, conjunctive, disjunctive and hierarchical filters
	 * helper.hasRefinements('price'); // false
	 * helper.addNumericRefinement('price', '>', 100);
	 * helper.hasRefinements('price'); // true
	 *
	 * helper.hasRefinements('color'); // false
	 * helper.addFacetRefinement('color', 'blue');
	 * helper.hasRefinements('color'); // true
	 *
	 * helper.hasRefinements('material'); // false
	 * helper.addDisjunctiveFacetRefinement('material', 'plastic');
	 * helper.hasRefinements('material'); // true
	 *
	 * helper.hasRefinements('categories'); // false
	 * helper.toggleRefinement('categories', 'kitchen > knife');
	 * helper.hasRefinements('categories'); // true
	 *
	 */
	AlgoliaSearchHelper.prototype.hasRefinements = function(attribute) {
	  if (!isEmpty(this.state.getNumericRefinements(attribute))) {
	    return true;
	  } else if (this.state.isConjunctiveFacet(attribute)) {
	    return this.state.isFacetRefined(attribute);
	  } else if (this.state.isDisjunctiveFacet(attribute)) {
	    return this.state.isDisjunctiveFacetRefined(attribute);
	  } else if (this.state.isHierarchicalFacet(attribute)) {
	    return this.state.isHierarchicalFacetRefined(attribute);
	  }
	
	  // there's currently no way to know that the user did call `addNumericRefinement` at some point
	  // thus we cannot distinguish if there once was a numeric refinement that was cleared
	  // so we will return false in every other situations to be consistent
	  // while what we should do here is throw because we did not find the attribute in any type
	  // of refinement
	  return false;
	};
	
	/**
	 * Check if a value is excluded for a specific facetted attribute. If the value
	 * is omitted then the function checks if there is any excluding refinements.
	 *
	 * @param  {string}  facet name of the attribute for used for facetting
	 * @param  {string}  [value] optionnal value. If passed will test that this value
	   * is filtering the given facet.
	 * @return {boolean} true if refined
	 * @example
	 * helper.isExcludeRefined('color'); // false
	 * helper.isExcludeRefined('color', 'blue') // false
	 * helper.isExcludeRefined('color', 'red') // false
	 *
	 * helper.addFacetExclusion('color', 'red');
	 *
	 * helper.isExcludeRefined('color'); // true
	 * helper.isExcludeRefined('color', 'blue') // false
	 * helper.isExcludeRefined('color', 'red') // true
	 */
	AlgoliaSearchHelper.prototype.isExcluded = function(facet, value) {
	  return this.state.isExcludeRefined(facet, value);
	};
	
	/**
	 * @deprecated since 2.4.0, see {@link AlgoliaSearchHelper#hasRefinements}
	 */
	AlgoliaSearchHelper.prototype.isDisjunctiveRefined = function(facet, value) {
	  return this.state.isDisjunctiveFacetRefined(facet, value);
	};
	
	/**
	 * Check if the string is a currently filtering tag.
	 * @param {string} tag tag to check
	 * @return {boolean}
	 */
	AlgoliaSearchHelper.prototype.hasTag = function(tag) {
	  return this.state.isTagRefined(tag);
	};
	
	/**
	 * @deprecated since 2.4.0, see {@link AlgoliaSearchHelper#hasTag}
	 */
	AlgoliaSearchHelper.prototype.isTagRefined = function() {
	  return this.hasTagRefinements.apply(this, arguments);
	};
	
	
	/**
	 * Get the name of the currently used index.
	 * @return {string}
	 * @example
	 * helper.setIndex('highestPrice_products').getIndex();
	 * // returns 'highestPrice_products'
	 */
	AlgoliaSearchHelper.prototype.getIndex = function() {
	  return this.state.index;
	};
	
	function getCurrentPage() {
	  return this.state.page;
	}
	
	/**
	 * Get the currently selected page
	 * @deprecated
	 * @return {number} the current page
	 */
	AlgoliaSearchHelper.prototype.getCurrentPage = getCurrentPage;
	/**
	 * Get the currently selected page
	 * @function
	 * @return {number} the current page
	 */
	AlgoliaSearchHelper.prototype.getPage = getCurrentPage;
	
	/**
	 * Get all the tags currently set to filters the results.
	 *
	 * @return {string[]} The list of tags currently set.
	 */
	AlgoliaSearchHelper.prototype.getTags = function() {
	  return this.state.tagRefinements;
	};
	
	/**
	 * Get a parameter of the search by its name. It is possible that a parameter is directly
	 * defined in the index dashboard, but it will be undefined using this method.
	 *
	 * The complete list of parameters is
	 * available on the
	 * [Algolia website](https://www.algolia.com/doc/rest#query-an-index).
	 * The most commonly used parameters have their own [shortcuts](#query-parameters-shortcuts)
	 * or benefit from higher-level APIs (all the kind of filters have their own API)
	 * @param {string} parameterName the parameter name
	 * @return {any} the parameter value
	 * @example
	 * var hitsPerPage = helper.getQueryParameter('hitsPerPage');
	 */
	AlgoliaSearchHelper.prototype.getQueryParameter = function(parameterName) {
	  return this.state.getQueryParameter(parameterName);
	};
	
	/**
	 * Get the list of refinements for a given attribute. This method works with
	 * conjunctive, disjunctive, excluding and numerical filters.
	 *
	 * See also SearchResults#getRefinements
	 *
	 * @param {string} facetName attribute name used for facetting
	 * @return {Array.<FacetRefinement|NumericRefinement>} All Refinement are objects that contain a value, and
	 * a type. Numeric also contains an operator.
	 * @example
	 * helper.addNumericRefinement('price', '>', 100);
	 * helper.getRefinements('price');
	 * // [
	 * //   {
	 * //     "value": [
	 * //       100
	 * //     ],
	 * //     "operator": ">",
	 * //     "type": "numeric"
	 * //   }
	 * // ]
	 * @example
	 * helper.addFacetRefinement('color', 'blue');
	 * helper.addFacetExclusion('color', 'red');
	 * helper.getRefinements('color');
	 * // [
	 * //   {
	 * //     "value": "blue",
	 * //     "type": "conjunctive"
	 * //   },
	 * //   {
	 * //     "value": "red",
	 * //     "type": "exclude"
	 * //   }
	 * // ]
	 * @example
	 * helper.addDisjunctiveFacetRefinement('material', 'plastic');
	 * // [
	 * //   {
	 * //     "value": "plastic",
	 * //     "type": "disjunctive"
	 * //   }
	 * // ]
	 */
	AlgoliaSearchHelper.prototype.getRefinements = function(facetName) {
	  var refinements = [];
	
	  if (this.state.isConjunctiveFacet(facetName)) {
	    var conjRefinements = this.state.getConjunctiveRefinements(facetName);
	
	    forEach(conjRefinements, function(r) {
	      refinements.push({
	        value: r,
	        type: 'conjunctive'
	      });
	    });
	
	    var excludeRefinements = this.state.getExcludeRefinements(facetName);
	
	    forEach(excludeRefinements, function(r) {
	      refinements.push({
	        value: r,
	        type: 'exclude'
	      });
	    });
	  } else if (this.state.isDisjunctiveFacet(facetName)) {
	    var disjRefinements = this.state.getDisjunctiveRefinements(facetName);
	
	    forEach(disjRefinements, function(r) {
	      refinements.push({
	        value: r,
	        type: 'disjunctive'
	      });
	    });
	  }
	
	  var numericRefinements = this.state.getNumericRefinements(facetName);
	
	  forEach(numericRefinements, function(value, operator) {
	    refinements.push({
	      value: value,
	      operator: operator,
	      type: 'numeric'
	    });
	  });
	
	  return refinements;
	};
	
	/**
	 * Return the current refinement for the (attribute, operator)
	 * @param {string} attribute of the record
	 * @param {string} operator applied
	 * @return {number} value of the refinement
	 */
	AlgoliaSearchHelper.prototype.getNumericRefinement = function(attribute, operator) {
	  return this.state.getNumericRefinement(attribute, operator);
	};
	
	/**
	 * Get the current breadcrumb for a hierarchical facet, as an array
	 * @param  {string} facetName Hierarchical facet name
	 * @return {array.<string>} the path as an array of string
	 */
	AlgoliaSearchHelper.prototype.getHierarchicalFacetBreadcrumb = function(facetName) {
	  return this.state.getHierarchicalFacetBreadcrumb(facetName);
	};
	
	// /////////// PRIVATE
	
	/**
	 * Perform the underlying queries
	 * @private
	 * @return {undefined}
	 * @fires search
	 * @fires result
	 * @fires error
	 */
	AlgoliaSearchHelper.prototype._search = function() {
	  var state = this.state;
	  var queries = requestBuilder._getQueries(state.index, state);
	
	  this.emit('search', state, this.lastResults);
	  this.client.search(queries,
	    bind(this._handleResponse,
	      this,
	      state,
	      this._queryId++));
	};
	
	/**
	 * Transform the response as sent by the server and transform it into a user
	 * usable objet that merge the results of all the batch requests.
	 * @private
	 * @param {SearchParameters} state state used for to generate the request
	 * @param {number} queryId id of the current request
	 * @param {Error} err error if any, null otherwise
	 * @param {object} content content of the response
	 * @return {undefined}
	 */
	AlgoliaSearchHelper.prototype._handleResponse = function(state, queryId, err, content) {
	  if (queryId < this._lastQueryIdReceived) {
	    // Outdated answer
	    return;
	  }
	
	  this._lastQueryIdReceived = queryId;
	
	  if (err) {
	    this.emit('error', err);
	    return;
	  }
	
	  var formattedResponse = this.lastResults = new SearchResults(state, content);
	
	  this.emit('result', formattedResponse, state);
	};
	
	AlgoliaSearchHelper.prototype.containsRefinement = function(query, facetFilters, numericFilters, tagFilters) {
	  return query ||
	    facetFilters.length !== 0 ||
	    numericFilters.length !== 0 ||
	    tagFilters.length !== 0;
	};
	
	/**
	 * Test if there are some disjunctive refinements on the facet
	 * @private
	 * @param {string} facet the attribute to test
	 * @return {boolean}
	 */
	AlgoliaSearchHelper.prototype._hasDisjunctiveRefinements = function(facet) {
	  return this.state.disjunctiveRefinements[facet] &&
	    this.state.disjunctiveRefinements[facet].length > 0;
	};
	
	AlgoliaSearchHelper.prototype._change = function() {
	  this.emit('change', this.state, this.lastResults);
	};
	
	/**
	 * Clears the cache of the underlying Algolia client.
	 */
	AlgoliaSearchHelper.prototype.clearCache = function() {
	  this.client.clearCache();
	};
	
	/**
	 * @typedef AlgoliaSearchHelper.NumericRefinement
	 * @type {object}
	 * @property {number[]} value the numbers that are used for filtering this attribute with
	 * the operator specified.
	 * @property {string} operator the facetting data: value, number of entries
	 * @property {string} type will be 'numeric'
	 */
	
	/**
	 * @typedef AlgoliaSearchHelper.FacetRefinement
	 * @type {object}
	 * @property {string} value the string use to filter the attribute
	 * @property {string} type the type of filter: 'conjunctive', 'disjunctive', 'exclude'
	 */
	
	module.exports = AlgoliaSearchHelper;


/***/ }),
/* 1362 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var keys = __webpack_require__(921);
	var intersection = __webpack_require__(1363);
	var forOwn = __webpack_require__(1372);
	var forEach = __webpack_require__(1374);
	var filter = __webpack_require__(1375);
	var map = __webpack_require__(1377);
	var reduce = __webpack_require__(1379);
	var omit = __webpack_require__(1382);
	var indexOf = __webpack_require__(1392);
	var isNaN = __webpack_require__(1395);
	var isArray = __webpack_require__(789);
	var isEmpty = __webpack_require__(1397);
	var isEqual = __webpack_require__(924);
	var isUndefined = __webpack_require__(1398);
	var isString = __webpack_require__(1399);
	var isFunction = __webpack_require__(751);
	var find = __webpack_require__(1400);
	var trim = __webpack_require__(1403);
	
	var defaults = __webpack_require__(1411);
	var merge = __webpack_require__(732);
	
	var valToNumber = __webpack_require__(1412);
	
	var filterState = __webpack_require__(1413);
	
	var RefinementList = __webpack_require__(1414);
	
	/**
	 * like _.find but using _.isEqual to be able to use it
	 * to find arrays.
	 * @private
	 * @param {any[]} array array to search into
	 * @param {any} searchedValue the value we're looking for
	 * @return {any} the searched value or undefined
	 */
	function findArray(array, searchedValue) {
	  return find(array, function(currentValue) {
	    return isEqual(currentValue, searchedValue);
	  });
	}
	
	/**
	 * The facet list is the structure used to store the list of values used to
	 * filter a single attribute.
	 * @typedef {string[]} SearchParameters.FacetList
	 */
	
	/**
	 * Structure to store numeric filters with the operator as the key. The supported operators
	 * are `=`, `>`, `<`, `>=`, `<=` and `!=`.
	 * @typedef {Object.<string, Array.<number|number[]>>} SearchParameters.OperatorList
	 */
	
	/**
	 * SearchParameters is the data structure that contains all the information
	 * usable for making a search to Algolia API. It doesn't do the search itself,
	 * nor does it contains logic about the parameters.
	 * It is an immutable object, therefore it has been created in a way that each
	 * changes does not change the object itself but returns a copy with the
	 * modification.
	 * This object should probably not be instantiated outside of the helper. It will
	 * be provided when needed. This object is documented for reference as you'll
	 * get it from events generated by the {@link AlgoliaSearchHelper}.
	 * If need be, instantiate the Helper from the factory function {@link SearchParameters.make}
	 * @constructor
	 * @classdesc contains all the parameters of a search
	 * @param {object|SearchParameters} newParameters existing parameters or partial object
	 * for the properties of a new SearchParameters
	 * @see SearchParameters.make
	 * @example <caption>SearchParameters of the first query in
	 *   <a href="http://demos.algolia.com/instant-search-demo/">the instant search demo</a></caption>
	{
	   "query": "",
	   "disjunctiveFacets": [
	      "customerReviewCount",
	      "category",
	      "salePrice_range",
	      "manufacturer"
	  ],
	   "maxValuesPerFacet": 30,
	   "page": 0,
	   "hitsPerPage": 10,
	   "facets": [
	      "type",
	      "shipping"
	  ]
	}
	 */
	function SearchParameters(newParameters) {
	  var params = newParameters ? SearchParameters._parseNumbers(newParameters) : {};
	
	  /**
	   * Targeted index. This parameter is mandatory.
	   * @member {string}
	   */
	  this.index = params.index || '';
	
	  // Query
	  /**
	   * Query string of the instant search. The empty string is a valid query.
	   * @member {string}
	   * @see https://www.algolia.com/doc/rest#param-query
	   */
	  this.query = params.query || '';
	
	  // Facets
	  /**
	   * This attribute contains the list of all the conjunctive facets
	   * used. This list will be added to requested facets in the
	   * [facets attribute](https://www.algolia.com/doc/rest-api/search#param-facets) sent to algolia.
	   * @member {string[]}
	   */
	  this.facets = params.facets || [];
	  /**
	   * This attribute contains the list of all the disjunctive facets
	   * used. This list will be added to requested facets in the
	   * [facets attribute](https://www.algolia.com/doc/rest-api/search#param-facets) sent to algolia.
	   * @member {string[]}
	   */
	  this.disjunctiveFacets = params.disjunctiveFacets || [];
	  /**
	   * This attribute contains the list of all the hierarchical facets
	   * used. This list will be added to requested facets in the
	   * [facets attribute](https://www.algolia.com/doc/rest-api/search#param-facets) sent to algolia.
	   * Hierarchical facets are a sub type of disjunctive facets that
	   * let you filter faceted attributes hierarchically.
	   * @member {string[]|object[]}
	   */
	  this.hierarchicalFacets = params.hierarchicalFacets || [];
	
	  // Refinements
	  /**
	   * This attribute contains all the filters that need to be
	   * applied on the conjunctive facets. Each facet must be properly
	   * defined in the `facets` attribute.
	   *
	   * The key is the name of the facet, and the `FacetList` contains all
	   * filters selected for the associated facet name.
	   *
	   * When querying algolia, the values stored in this attribute will
	   * be translated into the `facetFiters` attribute.
	   * @member {Object.<string, SearchParameters.FacetList>}
	   */
	  this.facetsRefinements = params.facetsRefinements || {};
	  /**
	   * This attribute contains all the filters that need to be
	   * excluded from the conjunctive facets. Each facet must be properly
	   * defined in the `facets` attribute.
	   *
	   * The key is the name of the facet, and the `FacetList` contains all
	   * filters excluded for the associated facet name.
	   *
	   * When querying algolia, the values stored in this attribute will
	   * be translated into the `facetFiters` attribute.
	   * @member {Object.<string, SearchParameters.FacetList>}
	   */
	  this.facetsExcludes = params.facetsExcludes || {};
	  /**
	   * This attribute contains all the filters that need to be
	   * applied on the disjunctive facets. Each facet must be properly
	   * defined in the `disjunctiveFacets` attribute.
	   *
	   * The key is the name of the facet, and the `FacetList` contains all
	   * filters selected for the associated facet name.
	   *
	   * When querying algolia, the values stored in this attribute will
	   * be translated into the `facetFiters` attribute.
	   * @member {Object.<string, SearchParameters.FacetList>}
	   */
	  this.disjunctiveFacetsRefinements = params.disjunctiveFacetsRefinements || {};
	  /**
	   * This attribute contains all the filters that need to be
	   * applied on the numeric attributes.
	   *
	   * The key is the name of the attribute, and the value is the
	   * filters to apply to this attribute.
	   *
	   * When querying algolia, the values stored in this attribute will
	   * be translated into the `numericFilters` attribute.
	   * @member {Object.<string, SearchParameters.OperatorList>}
	   */
	  this.numericRefinements = params.numericRefinements || {};
	  /**
	   * This attribute contains all the tags used to refine the query.
	   *
	   * When querying algolia, the values stored in this attribute will
	   * be translated into the `tagFilters` attribute.
	   * @member {string[]}
	   */
	  this.tagRefinements = params.tagRefinements || [];
	  /**
	   * This attribute contains all the filters that need to be
	   * applied on the hierarchical facets. Each facet must be properly
	   * defined in the `hierarchicalFacets` attribute.
	   *
	   * The key is the name of the facet, and the `FacetList` contains all
	   * filters selected for the associated facet name. The FacetList values
	   * are structured as a string that contain the values for each level
	   * seperated by the configured separator.
	   *
	   * When querying algolia, the values stored in this attribute will
	   * be translated into the `facetFiters` attribute.
	   * @member {Object.<string, SearchParameters.FacetList>}
	   */
	  this.hierarchicalFacetsRefinements = params.hierarchicalFacetsRefinements || {};
	
	  /**
	   * Contains the numeric filters in the raw format of the Algolia API. Setting
	   * this parameter is not compatible with the usage of numeric filters methods.
	   * @see https://www.algolia.com/doc/javascript#numericFilters
	   * @member {string}
	   */
	  this.numericFilters = params.numericFilters;
	
	  /**
	   * Contains the tag filters in the raw format of the Algolia API. Setting this
	   * parameter is not compatible with the of the add/remove/toggle methods of the
	   * tag api.
	   * @see https://www.algolia.com/doc/rest#param-tagFilters
	   * @member {string}
	   */
	  this.tagFilters = params.tagFilters;
	
	  /**
	   * Contains the optional tag filters in the raw format of the Algolia API.
	   * @see https://www.algolia.com/doc/rest#param-tagFilters
	   * @member {string}
	   */
	  this.optionalTagFilters = params.optionalTagFilters;
	
	  /**
	   * Contains the optional facet filters in the raw format of the Algolia API.
	   * @see https://www.algolia.com/doc/rest#param-tagFilters
	   * @member {string}
	   */
	  this.optionalFacetFilters = params.optionalFacetFilters;
	
	
	  // Misc. parameters
	  /**
	   * Number of hits to be returned by the search API
	   * @member {number}
	   * @see https://www.algolia.com/doc/rest#param-hitsPerPage
	   */
	  this.hitsPerPage = params.hitsPerPage;
	  /**
	   * Number of values for each facetted attribute
	   * @member {number}
	   * @see https://www.algolia.com/doc/rest#param-maxValuesPerFacet
	   */
	  this.maxValuesPerFacet = params.maxValuesPerFacet;
	  /**
	   * The current page number
	   * @member {number}
	   * @see https://www.algolia.com/doc/rest#param-page
	   */
	  this.page = params.page || 0;
	  /**
	   * How the query should be treated by the search engine.
	   * Possible values: prefixAll, prefixLast, prefixNone
	   * @see https://www.algolia.com/doc/rest#param-queryType
	   * @member {string}
	   */
	  this.queryType = params.queryType;
	  /**
	   * How the typo tolerance behave in the search engine.
	   * Possible values: true, false, min, strict
	   * @see https://www.algolia.com/doc/rest#param-typoTolerance
	   * @member {string}
	   */
	  this.typoTolerance = params.typoTolerance;
	
	  /**
	   * Number of characters to wait before doing one character replacement.
	   * @see https://www.algolia.com/doc/rest#param-minWordSizefor1Typo
	   * @member {number}
	   */
	  this.minWordSizefor1Typo = params.minWordSizefor1Typo;
	  /**
	   * Number of characters to wait before doing a second character replacement.
	   * @see https://www.algolia.com/doc/rest#param-minWordSizefor2Typos
	   * @member {number}
	   */
	  this.minWordSizefor2Typos = params.minWordSizefor2Typos;
	  /**
	   * Configure the precision of the proximity ranking criterion
	   * @see https://www.algolia.com/doc/rest#param-minProximity
	   */
	  this.minProximity = params.minProximity;
	  /**
	   * Should the engine allow typos on numerics.
	   * @see https://www.algolia.com/doc/rest#param-allowTyposOnNumericTokens
	   * @member {boolean}
	   */
	  this.allowTyposOnNumericTokens = params.allowTyposOnNumericTokens;
	  /**
	   * Should the plurals be ignored
	   * @see https://www.algolia.com/doc/rest#param-ignorePlurals
	   * @member {boolean}
	   */
	  this.ignorePlurals = params.ignorePlurals;
	  /**
	   * Restrict which attribute is searched.
	   * @see https://www.algolia.com/doc/rest#param-restrictSearchableAttributes
	   * @member {string}
	   */
	  this.restrictSearchableAttributes = params.restrictSearchableAttributes;
	  /**
	   * Enable the advanced syntax.
	   * @see https://www.algolia.com/doc/rest#param-advancedSyntax
	   * @member {boolean}
	   */
	  this.advancedSyntax = params.advancedSyntax;
	  /**
	   * Enable the analytics
	   * @see https://www.algolia.com/doc/rest#param-analytics
	   * @member {boolean}
	   */
	  this.analytics = params.analytics;
	  /**
	   * Tag of the query in the analytics.
	   * @see https://www.algolia.com/doc/rest#param-analyticsTags
	   * @member {string}
	   */
	  this.analyticsTags = params.analyticsTags;
	  /**
	   * Enable the synonyms
	   * @see https://www.algolia.com/doc/rest#param-synonyms
	   * @member {boolean}
	   */
	  this.synonyms = params.synonyms;
	  /**
	   * Should the engine replace the synonyms in the highlighted results.
	   * @see https://www.algolia.com/doc/rest#param-replaceSynonymsInHighlight
	   * @member {boolean}
	   */
	  this.replaceSynonymsInHighlight = params.replaceSynonymsInHighlight;
	  /**
	   * Add some optional words to those defined in the dashboard
	   * @see https://www.algolia.com/doc/rest#param-optionalWords
	   * @member {string}
	   */
	  this.optionalWords = params.optionalWords;
	  /**
	   * Possible values are "lastWords" "firstWords" "allOptional" "none" (default)
	   * @see https://www.algolia.com/doc/rest#param-removeWordsIfNoResults
	   * @member {string}
	   */
	  this.removeWordsIfNoResults = params.removeWordsIfNoResults;
	  /**
	   * List of attributes to retrieve
	   * @see https://www.algolia.com/doc/rest#param-attributesToRetrieve
	   * @member {string}
	   */
	  this.attributesToRetrieve = params.attributesToRetrieve;
	  /**
	   * List of attributes to highlight
	   * @see https://www.algolia.com/doc/rest#param-attributesToHighlight
	   * @member {string}
	   */
	  this.attributesToHighlight = params.attributesToHighlight;
	  /**
	   * Code to be embedded on the left part of the highlighted results
	   * @see https://www.algolia.com/doc/rest#param-highlightPreTag
	   * @member {string}
	   */
	  this.highlightPreTag = params.highlightPreTag;
	  /**
	   * Code to be embedded on the right part of the highlighted results
	   * @see https://www.algolia.com/doc/rest#param-highlightPostTag
	   * @member {string}
	   */
	  this.highlightPostTag = params.highlightPostTag;
	  /**
	   * List of attributes to snippet
	   * @see https://www.algolia.com/doc/rest#param-attributesToSnippet
	   * @member {string}
	   */
	  this.attributesToSnippet = params.attributesToSnippet;
	  /**
	   * Enable the ranking informations in the response, set to 1 to activate
	   * @see https://www.algolia.com/doc/rest#param-getRankingInfo
	   * @member {number}
	   */
	  this.getRankingInfo = params.getRankingInfo;
	  /**
	   * Remove duplicates based on the index setting attributeForDistinct
	   * @see https://www.algolia.com/doc/rest#param-distinct
	   * @member {boolean|number}
	   */
	  this.distinct = params.distinct;
	  /**
	   * Center of the geo search.
	   * @see https://www.algolia.com/doc/rest#param-aroundLatLng
	   * @member {string}
	   */
	  this.aroundLatLng = params.aroundLatLng;
	  /**
	   * Center of the search, retrieve from the user IP.
	   * @see https://www.algolia.com/doc/rest#param-aroundLatLngViaIP
	   * @member {boolean}
	   */
	  this.aroundLatLngViaIP = params.aroundLatLngViaIP;
	  /**
	   * Radius of the geo search.
	   * @see https://www.algolia.com/doc/rest#param-aroundRadius
	   * @member {number}
	   */
	  this.aroundRadius = params.aroundRadius;
	  /**
	   * Precision of the geo search.
	   * @see https://www.algolia.com/doc/rest#param-aroundPrecision
	   * @member {number}
	   */
	  this.minimumAroundRadius = params.minimumAroundRadius;
	  /**
	   * Precision of the geo search.
	   * @see https://www.algolia.com/doc/rest#param-minimumAroundRadius
	   * @member {number}
	   */
	  this.aroundPrecision = params.aroundPrecision;
	  /**
	   * Geo search inside a box.
	   * @see https://www.algolia.com/doc/rest#param-insideBoundingBox
	   * @member {string}
	   */
	  this.insideBoundingBox = params.insideBoundingBox;
	  /**
	   * Geo search inside a polygon.
	   * @see https://www.algolia.com/doc/rest#param-insidePolygon
	   * @member {string}
	   */
	  this.insidePolygon = params.insidePolygon;
	  /**
	   * Allows to specify an ellipsis character for the snippet when we truncate the text
	   * (added before and after if truncated).
	   * The default value is an empty string and we recommend to set it to "…"
	   * @see https://www.algolia.com/doc/rest#param-insidePolygon
	   * @member {string}
	   */
	  this.snippetEllipsisText = params.snippetEllipsisText;
	  /**
	   * Allows to specify some attributes name on which exact won't be applied.
	   * Attributes are separated with a comma (for example "name,address" ), you can also use a
	   * JSON string array encoding (for example encodeURIComponent('["name","address"]') ).
	   * By default the list is empty.
	   * @see https://www.algolia.com/doc/rest#param-disableExactOnAttributes
	   * @member {string|string[]}
	   */
	  this.disableExactOnAttributes = params.disableExactOnAttributes;
	  /**
	   * Applies 'exact' on single word queries if the word contains at least 3 characters
	   * and is not a stop word.
	   * Can take two values: true or false.
	   * By default, its set to false.
	   * @see https://www.algolia.com/doc/rest#param-enableExactOnSingleWordQuery
	   * @member {boolean}
	   */
	  this.enableExactOnSingleWordQuery = params.enableExactOnSingleWordQuery;
	
	  // Undocumented parameters, still needed otherwise we fail
	  this.offset = params.offset;
	  this.length = params.length;
	
	  var self = this;
	  forOwn(params, function checkForUnknownParameter(paramValue, paramName) {
	    if (SearchParameters.PARAMETERS.indexOf(paramName) === -1) {
	      self[paramName] = paramValue;
	    }
	  });
	}
	
	/**
	 * List all the properties in SearchParameters and therefore all the known Algolia properties
	 * This doesn't contain any beta/hidden features.
	 * @private
	 */
	SearchParameters.PARAMETERS = keys(new SearchParameters());
	
	/**
	 * @private
	 * @param {object} partialState full or part of a state
	 * @return {object} a new object with the number keys as number
	 */
	SearchParameters._parseNumbers = function(partialState) {
	  // Do not reparse numbers in SearchParameters, they ought to be parsed already
	  if (partialState instanceof SearchParameters) return partialState;
	
	  var numbers = {};
	
	  var numberKeys = [
	    'aroundPrecision',
	    'aroundRadius',
	    'getRankingInfo',
	    'minWordSizefor2Typos',
	    'minWordSizefor1Typo',
	    'page',
	    'maxValuesPerFacet',
	    'distinct',
	    'minimumAroundRadius',
	    'hitsPerPage',
	    'minProximity'
	  ];
	
	  forEach(numberKeys, function(k) {
	    var value = partialState[k];
	    if (isString(value)) {
	      var parsedValue = parseFloat(value);
	      numbers[k] = isNaN(parsedValue) ? value : parsedValue;
	    }
	  });
	
	  if (partialState.numericRefinements) {
	    var numericRefinements = {};
	    forEach(partialState.numericRefinements, function(operators, attribute) {
	      numericRefinements[attribute] = {};
	      forEach(operators, function(values, operator) {
	        var parsedValues = map(values, function(v) {
	          if (isArray(v)) {
	            return map(v, function(vPrime) {
	              if (isString(vPrime)) {
	                return parseFloat(vPrime);
	              }
	              return vPrime;
	            });
	          } else if (isString(v)) {
	            return parseFloat(v);
	          }
	          return v;
	        });
	        numericRefinements[attribute][operator] = parsedValues;
	      });
	    });
	    numbers.numericRefinements = numericRefinements;
	  }
	
	  return merge({}, partialState, numbers);
	};
	
	/**
	 * Factory for SearchParameters
	 * @param {object|SearchParameters} newParameters existing parameters or partial
	 * object for the properties of a new SearchParameters
	 * @return {SearchParameters} frozen instance of SearchParameters
	 */
	SearchParameters.make = function makeSearchParameters(newParameters) {
	  var instance = new SearchParameters(newParameters);
	
	  forEach(newParameters.hierarchicalFacets, function(facet) {
	    if (facet.rootPath) {
	      var currentRefinement = instance.getHierarchicalRefinement(facet.name);
	
	      if (currentRefinement.length > 0 && currentRefinement[0].indexOf(facet.rootPath) !== 0) {
	        instance = instance.clearRefinements(facet.name);
	      }
	
	      // get it again in case it has been cleared
	      currentRefinement = instance.getHierarchicalRefinement(facet.name);
	      if (currentRefinement.length === 0) {
	        instance = instance.toggleHierarchicalFacetRefinement(facet.name, facet.rootPath);
	      }
	    }
	  });
	
	  return instance;
	};
	
	/**
	 * Validates the new parameters based on the previous state
	 * @param {SearchParameters} currentState the current state
	 * @param {object|SearchParameters} parameters the new parameters to set
	 * @return {Error|null} Error if the modification is invalid, null otherwise
	 */
	SearchParameters.validate = function(currentState, parameters) {
	  var params = parameters || {};
	
	  if (currentState.tagFilters && params.tagRefinements && params.tagRefinements.length > 0) {
	    return new Error(
	      '[Tags] Cannot switch from the managed tag API to the advanced API. It is probably ' +
	      'an error, if it is really what you want, you should first clear the tags with clearTags method.');
	  }
	
	  if (currentState.tagRefinements.length > 0 && params.tagFilters) {
	    return new Error(
	      '[Tags] Cannot switch from the advanced tag API to the managed API. It is probably ' +
	      'an error, if it is not, you should first clear the tags with clearTags method.');
	  }
	
	  if (currentState.numericFilters && params.numericRefinements && !isEmpty(params.numericRefinements)) {
	    return new Error(
	      "[Numeric filters] Can't switch from the advanced to the managed API. It" +
	      ' is probably an error, if this is really what you want, you have to first' +
	      ' clear the numeric filters.');
	  }
	
	  if (!isEmpty(currentState.numericRefinements) && params.numericFilters) {
	    return new Error(
	      "[Numeric filters] Can't switch from the managed API to the advanced. It" +
	      ' is probably an error, if this is really what you want, you have to first' +
	      ' clear the numeric filters.');
	  }
	
	  return null;
	};
	
	SearchParameters.prototype = {
	  constructor: SearchParameters,
	
	  /**
	   * Remove all refinements (disjunctive + conjunctive + excludes + numeric filters)
	   * @method
	   * @param {undefined|string|SearchParameters.clearCallback} [attribute] optionnal string or function
	   * - If not given, means to clear all the filters.
	   * - If `string`, means to clear all refinements for the `attribute` named filter.
	   * - If `function`, means to clear all the refinements that return truthy values.
	   * @return {SearchParameters}
	   */
	  clearRefinements: function clearRefinements(attribute) {
	    var clear = RefinementList.clearRefinement;
	    return this.setQueryParameters({
	      numericRefinements: this._clearNumericRefinements(attribute),
	      facetsRefinements: clear(this.facetsRefinements, attribute, 'conjunctiveFacet'),
	      facetsExcludes: clear(this.facetsExcludes, attribute, 'exclude'),
	      disjunctiveFacetsRefinements: clear(this.disjunctiveFacetsRefinements, attribute, 'disjunctiveFacet'),
	      hierarchicalFacetsRefinements: clear(this.hierarchicalFacetsRefinements, attribute, 'hierarchicalFacet')
	    });
	  },
	  /**
	   * Remove all the refined tags from the SearchParameters
	   * @method
	   * @return {SearchParameters}
	   */
	  clearTags: function clearTags() {
	    if (this.tagFilters === undefined && this.tagRefinements.length === 0) return this;
	
	    return this.setQueryParameters({
	      tagFilters: undefined,
	      tagRefinements: []
	    });
	  },
	  /**
	   * Set the index.
	   * @method
	   * @param {string} index the index name
	   * @return {SearchParameters}
	   */
	  setIndex: function setIndex(index) {
	    if (index === this.index) return this;
	
	    return this.setQueryParameters({
	      index: index
	    });
	  },
	  /**
	   * Query setter
	   * @method
	   * @param {string} newQuery value for the new query
	   * @return {SearchParameters}
	   */
	  setQuery: function setQuery(newQuery) {
	    if (newQuery === this.query) return this;
	
	    return this.setQueryParameters({
	      query: newQuery
	    });
	  },
	  /**
	   * Page setter
	   * @method
	   * @param {number} newPage new page number
	   * @return {SearchParameters}
	   */
	  setPage: function setPage(newPage) {
	    if (newPage === this.page) return this;
	
	    return this.setQueryParameters({
	      page: newPage
	    });
	  },
	  /**
	   * Facets setter
	   * The facets are the simple facets, used for conjunctive (and) facetting.
	   * @method
	   * @param {string[]} facets all the attributes of the algolia records used for conjunctive facetting
	   * @return {SearchParameters}
	   */
	  setFacets: function setFacets(facets) {
	    return this.setQueryParameters({
	      facets: facets
	    });
	  },
	  /**
	   * Disjunctive facets setter
	   * Change the list of disjunctive (or) facets the helper chan handle.
	   * @method
	   * @param {string[]} facets all the attributes of the algolia records used for disjunctive facetting
	   * @return {SearchParameters}
	   */
	  setDisjunctiveFacets: function setDisjunctiveFacets(facets) {
	    return this.setQueryParameters({
	      disjunctiveFacets: facets
	    });
	  },
	  /**
	   * HitsPerPage setter
	   * Hits per page represents the number of hits retrieved for this query
	   * @method
	   * @param {number} n number of hits retrieved per page of results
	   * @return {SearchParameters}
	   */
	  setHitsPerPage: function setHitsPerPage(n) {
	    if (this.hitsPerPage === n) return this;
	
	    return this.setQueryParameters({
	      hitsPerPage: n
	    });
	  },
	  /**
	   * typoTolerance setter
	   * Set the value of typoTolerance
	   * @method
	   * @param {string} typoTolerance new value of typoTolerance ("true", "false", "min" or "strict")
	   * @return {SearchParameters}
	   */
	  setTypoTolerance: function setTypoTolerance(typoTolerance) {
	    if (this.typoTolerance === typoTolerance) return this;
	
	    return this.setQueryParameters({
	      typoTolerance: typoTolerance
	    });
	  },
	  /**
	   * Add a numeric filter for a given attribute
	   * When value is an array, they are combined with OR
	   * When value is a single value, it will combined with AND
	   * @method
	   * @param {string} attribute attribute to set the filter on
	   * @param {string} operator operator of the filter (possible values: =, >, >=, <, <=, !=)
	   * @param {number | number[]} value value of the filter
	   * @return {SearchParameters}
	   * @example
	   * // for price = 50 or 40
	   * searchparameter.addNumericRefinement('price', '=', [50, 40]);
	   * @example
	   * // for size = 38 and 40
	   * searchparameter.addNumericRefinement('size', '=', 38);
	   * searchparameter.addNumericRefinement('size', '=', 40);
	   */
	  addNumericRefinement: function(attribute, operator, v) {
	    var value = valToNumber(v);
	
	    if (this.isNumericRefined(attribute, operator, value)) return this;
	
	    var mod = merge({}, this.numericRefinements);
	
	    mod[attribute] = merge({}, mod[attribute]);
	
	    if (mod[attribute][operator]) {
	      // Array copy
	      mod[attribute][operator] = mod[attribute][operator].slice();
	      // Add the element. Concat can't be used here because value can be an array.
	      mod[attribute][operator].push(value);
	    } else {
	      mod[attribute][operator] = [value];
	    }
	
	    return this.setQueryParameters({
	      numericRefinements: mod
	    });
	  },
	  /**
	   * Get the list of conjunctive refinements for a single facet
	   * @param {string} facetName name of the attribute used for facetting
	   * @return {string[]} list of refinements
	   */
	  getConjunctiveRefinements: function(facetName) {
	    if (!this.isConjunctiveFacet(facetName)) {
	      throw new Error(facetName + ' is not defined in the facets attribute of the helper configuration');
	    }
	    return this.facetsRefinements[facetName] || [];
	  },
	  /**
	   * Get the list of disjunctive refinements for a single facet
	   * @param {string} facetName name of the attribute used for facetting
	   * @return {string[]} list of refinements
	   */
	  getDisjunctiveRefinements: function(facetName) {
	    if (!this.isDisjunctiveFacet(facetName)) {
	      throw new Error(
	        facetName + ' is not defined in the disjunctiveFacets attribute of the helper configuration'
	      );
	    }
	    return this.disjunctiveFacetsRefinements[facetName] || [];
	  },
	  /**
	   * Get the list of hierarchical refinements for a single facet
	   * @param {string} facetName name of the attribute used for facetting
	   * @return {string[]} list of refinements
	   */
	  getHierarchicalRefinement: function(facetName) {
	    // we send an array but we currently do not support multiple
	    // hierarchicalRefinements for a hierarchicalFacet
	    return this.hierarchicalFacetsRefinements[facetName] || [];
	  },
	  /**
	   * Get the list of exclude refinements for a single facet
	   * @param {string} facetName name of the attribute used for facetting
	   * @return {string[]} list of refinements
	   */
	  getExcludeRefinements: function(facetName) {
	    if (!this.isConjunctiveFacet(facetName)) {
	      throw new Error(facetName + ' is not defined in the facets attribute of the helper configuration');
	    }
	    return this.facetsExcludes[facetName] || [];
	  },
	
	  /**
	   * Remove all the numeric filter for a given (attribute, operator)
	   * @method
	   * @param {string} attribute attribute to set the filter on
	   * @param {string} [operator] operator of the filter (possible values: =, >, >=, <, <=, !=)
	   * @param {number} [number] the value to be removed
	   * @return {SearchParameters}
	   */
	  removeNumericRefinement: function(attribute, operator, paramValue) {
	    if (paramValue !== undefined) {
	      var paramValueAsNumber = valToNumber(paramValue);
	      if (!this.isNumericRefined(attribute, operator, paramValueAsNumber)) return this;
	      return this.setQueryParameters({
	        numericRefinements: this._clearNumericRefinements(function(value, key) {
	          return key === attribute && value.op === operator && isEqual(value.val, paramValueAsNumber);
	        })
	      });
	    } else if (operator !== undefined) {
	      if (!this.isNumericRefined(attribute, operator)) return this;
	      return this.setQueryParameters({
	        numericRefinements: this._clearNumericRefinements(function(value, key) {
	          return key === attribute && value.op === operator;
	        })
	      });
	    }
	
	    if (!this.isNumericRefined(attribute)) return this;
	    return this.setQueryParameters({
	      numericRefinements: this._clearNumericRefinements(function(value, key) {
	        return key === attribute;
	      })
	    });
	  },
	  /**
	   * Get the list of numeric refinements for a single facet
	   * @param {string} facetName name of the attribute used for facetting
	   * @return {SearchParameters.OperatorList[]} list of refinements
	   */
	  getNumericRefinements: function(facetName) {
	    return this.numericRefinements[facetName] || {};
	  },
	  /**
	   * Return the current refinement for the (attribute, operator)
	   * @param {string} attribute of the record
	   * @param {string} operator applied
	   * @return {number} value of the refinement
	   */
	  getNumericRefinement: function(attribute, operator) {
	    return this.numericRefinements[attribute] && this.numericRefinements[attribute][operator];
	  },
	  /**
	   * Clear numeric filters.
	   * @method
	   * @private
	   * @param {string|SearchParameters.clearCallback} [attribute] optionnal string or function
	   * - If not given, means to clear all the filters.
	   * - If `string`, means to clear all refinements for the `attribute` named filter.
	   * - If `function`, means to clear all the refinements that return truthy values.
	   * @return {Object.<string, OperatorList>}
	   */
	  _clearNumericRefinements: function _clearNumericRefinements(attribute) {
	    if (isUndefined(attribute)) {
	      return {};
	    } else if (isString(attribute)) {
	      return omit(this.numericRefinements, attribute);
	    } else if (isFunction(attribute)) {
	      return reduce(this.numericRefinements, function(memo, operators, key) {
	        var operatorList = {};
	
	        forEach(operators, function(values, operator) {
	          var outValues = [];
	          forEach(values, function(value) {
	            var predicateResult = attribute({val: value, op: operator}, key, 'numeric');
	            if (!predicateResult) outValues.push(value);
	          });
	          if (!isEmpty(outValues)) operatorList[operator] = outValues;
	        });
	
	        if (!isEmpty(operatorList)) memo[key] = operatorList;
	
	        return memo;
	      }, {});
	    }
	  },
	  /**
	   * Add a facet to the facets attribute of the helper configuration, if it
	   * isn't already present.
	   * @method
	   * @param {string} facet facet name to add
	   * @return {SearchParameters}
	   */
	  addFacet: function addFacet(facet) {
	    if (this.isConjunctiveFacet(facet)) {
	      return this;
	    }
	
	    return this.setQueryParameters({
	      facets: this.facets.concat([facet])
	    });
	  },
	  /**
	   * Add a disjunctive facet to the disjunctiveFacets attribute of the helper
	   * configuration, if it isn't already present.
	   * @method
	   * @param {string} facet disjunctive facet name to add
	   * @return {SearchParameters}
	   */
	  addDisjunctiveFacet: function addDisjunctiveFacet(facet) {
	    if (this.isDisjunctiveFacet(facet)) {
	      return this;
	    }
	
	    return this.setQueryParameters({
	      disjunctiveFacets: this.disjunctiveFacets.concat([facet])
	    });
	  },
	  /**
	   * Add a hierarchical facet to the hierarchicalFacets attribute of the helper
	   * configuration.
	   * @method
	   * @param {object} hierarchicalFacet hierarchical facet to add
	   * @return {SearchParameters}
	   * @throws will throw an error if a hierarchical facet with the same name was already declared
	   */
	  addHierarchicalFacet: function addHierarchicalFacet(hierarchicalFacet) {
	    if (this.isHierarchicalFacet(hierarchicalFacet.name)) {
	      throw new Error(
	        'Cannot declare two hierarchical facets with the same name: `' + hierarchicalFacet.name + '`');
	    }
	
	    return this.setQueryParameters({
	      hierarchicalFacets: this.hierarchicalFacets.concat([hierarchicalFacet])
	    });
	  },
	  /**
	   * Add a refinement on a "normal" facet
	   * @method
	   * @param {string} facet attribute to apply the facetting on
	   * @param {string} value value of the attribute (will be converted to string)
	   * @return {SearchParameters}
	   */
	  addFacetRefinement: function addFacetRefinement(facet, value) {
	    if (!this.isConjunctiveFacet(facet)) {
	      throw new Error(facet + ' is not defined in the facets attribute of the helper configuration');
	    }
	    if (RefinementList.isRefined(this.facetsRefinements, facet, value)) return this;
	
	    return this.setQueryParameters({
	      facetsRefinements: RefinementList.addRefinement(this.facetsRefinements, facet, value)
	    });
	  },
	  /**
	   * Exclude a value from a "normal" facet
	   * @method
	   * @param {string} facet attribute to apply the exclusion on
	   * @param {string} value value of the attribute (will be converted to string)
	   * @return {SearchParameters}
	   */
	  addExcludeRefinement: function addExcludeRefinement(facet, value) {
	    if (!this.isConjunctiveFacet(facet)) {
	      throw new Error(facet + ' is not defined in the facets attribute of the helper configuration');
	    }
	    if (RefinementList.isRefined(this.facetsExcludes, facet, value)) return this;
	
	    return this.setQueryParameters({
	      facetsExcludes: RefinementList.addRefinement(this.facetsExcludes, facet, value)
	    });
	  },
	  /**
	   * Adds a refinement on a disjunctive facet.
	   * @method
	   * @param {string} facet attribute to apply the facetting on
	   * @param {string} value value of the attribute (will be converted to string)
	   * @return {SearchParameters}
	   */
	  addDisjunctiveFacetRefinement: function addDisjunctiveFacetRefinement(facet, value) {
	    if (!this.isDisjunctiveFacet(facet)) {
	      throw new Error(
	        facet + ' is not defined in the disjunctiveFacets attribute of the helper configuration');
	    }
	
	    if (RefinementList.isRefined(this.disjunctiveFacetsRefinements, facet, value)) return this;
	
	    return this.setQueryParameters({
	      disjunctiveFacetsRefinements: RefinementList.addRefinement(
	        this.disjunctiveFacetsRefinements, facet, value)
	    });
	  },
	  /**
	   * addTagRefinement adds a tag to the list used to filter the results
	   * @param {string} tag tag to be added
	   * @return {SearchParameters}
	   */
	  addTagRefinement: function addTagRefinement(tag) {
	    if (this.isTagRefined(tag)) return this;
	
	    var modification = {
	      tagRefinements: this.tagRefinements.concat(tag)
	    };
	
	    return this.setQueryParameters(modification);
	  },
	  /**
	   * Remove a facet from the facets attribute of the helper configuration, if it
	   * is present.
	   * @method
	   * @param {string} facet facet name to remove
	   * @return {SearchParameters}
	   */
	  removeFacet: function removeFacet(facet) {
	    if (!this.isConjunctiveFacet(facet)) {
	      return this;
	    }
	
	    return this.clearRefinements(facet).setQueryParameters({
	      facets: filter(this.facets, function(f) {
	        return f !== facet;
	      })
	    });
	  },
	  /**
	   * Remove a disjunctive facet from the disjunctiveFacets attribute of the
	   * helper configuration, if it is present.
	   * @method
	   * @param {string} facet disjunctive facet name to remove
	   * @return {SearchParameters}
	   */
	  removeDisjunctiveFacet: function removeDisjunctiveFacet(facet) {
	    if (!this.isDisjunctiveFacet(facet)) {
	      return this;
	    }
	
	    return this.clearRefinements(facet).setQueryParameters({
	      disjunctiveFacets: filter(this.disjunctiveFacets, function(f) {
	        return f !== facet;
	      })
	    });
	  },
	  /**
	   * Remove a hierarchical facet from the hierarchicalFacets attribute of the
	   * helper configuration, if it is present.
	   * @method
	   * @param {string} facet hierarchical facet name to remove
	   * @return {SearchParameters}
	   */
	  removeHierarchicalFacet: function removeHierarchicalFacet(facet) {
	    if (!this.isHierarchicalFacet(facet)) {
	      return this;
	    }
	
	    return this.clearRefinements(facet).setQueryParameters({
	      hierarchicalFacets: filter(this.hierarchicalFacets, function(f) {
	        return f.name !== facet;
	      })
	    });
	  },
	  /**
	   * Remove a refinement set on facet. If a value is provided, it will clear the
	   * refinement for the given value, otherwise it will clear all the refinement
	   * values for the facetted attribute.
	   * @method
	   * @param {string} facet name of the attribute used for facetting
	   * @param {string} [value] value used to filter
	   * @return {SearchParameters}
	   */
	  removeFacetRefinement: function removeFacetRefinement(facet, value) {
	    if (!this.isConjunctiveFacet(facet)) {
	      throw new Error(facet + ' is not defined in the facets attribute of the helper configuration');
	    }
	    if (!RefinementList.isRefined(this.facetsRefinements, facet, value)) return this;
	
	    return this.setQueryParameters({
	      facetsRefinements: RefinementList.removeRefinement(this.facetsRefinements, facet, value)
	    });
	  },
	  /**
	   * Remove a negative refinement on a facet
	   * @method
	   * @param {string} facet name of the attribute used for facetting
	   * @param {string} value value used to filter
	   * @return {SearchParameters}
	   */
	  removeExcludeRefinement: function removeExcludeRefinement(facet, value) {
	    if (!this.isConjunctiveFacet(facet)) {
	      throw new Error(facet + ' is not defined in the facets attribute of the helper configuration');
	    }
	    if (!RefinementList.isRefined(this.facetsExcludes, facet, value)) return this;
	
	    return this.setQueryParameters({
	      facetsExcludes: RefinementList.removeRefinement(this.facetsExcludes, facet, value)
	    });
	  },
	  /**
	   * Remove a refinement on a disjunctive facet
	   * @method
	   * @param {string} facet name of the attribute used for facetting
	   * @param {string} value value used to filter
	   * @return {SearchParameters}
	   */
	  removeDisjunctiveFacetRefinement: function removeDisjunctiveFacetRefinement(facet, value) {
	    if (!this.isDisjunctiveFacet(facet)) {
	      throw new Error(
	        facet + ' is not defined in the disjunctiveFacets attribute of the helper configuration');
	    }
	    if (!RefinementList.isRefined(this.disjunctiveFacetsRefinements, facet, value)) return this;
	
	    return this.setQueryParameters({
	      disjunctiveFacetsRefinements: RefinementList.removeRefinement(
	        this.disjunctiveFacetsRefinements, facet, value)
	    });
	  },
	  /**
	   * Remove a tag from the list of tag refinements
	   * @method
	   * @param {string} tag the tag to remove
	   * @return {SearchParameters}
	   */
	  removeTagRefinement: function removeTagRefinement(tag) {
	    if (!this.isTagRefined(tag)) return this;
	
	    var modification = {
	      tagRefinements: filter(this.tagRefinements, function(t) { return t !== tag; })
	    };
	
	    return this.setQueryParameters(modification);
	  },
	  /**
	   * Generic toggle refinement method to use with facet, disjunctive facets
	   * and hierarchical facets
	   * @param  {string} facet the facet to refine
	   * @param  {string} value the associated value
	   * @return {SearchParameters}
	   * @throws will throw an error if the facet is not declared in the settings of the helper
	   */
	  toggleRefinement: function toggleRefinement(facet, value) {
	    if (this.isHierarchicalFacet(facet)) {
	      return this.toggleHierarchicalFacetRefinement(facet, value);
	    } else if (this.isConjunctiveFacet(facet)) {
	      return this.toggleFacetRefinement(facet, value);
	    } else if (this.isDisjunctiveFacet(facet)) {
	      return this.toggleDisjunctiveFacetRefinement(facet, value);
	    }
	
	    throw new Error('Cannot refine the undeclared facet ' + facet +
	      '; it should be added to the helper options facets, disjunctiveFacets or hierarchicalFacets');
	  },
	  /**
	   * Switch the refinement applied over a facet/value
	   * @method
	   * @param {string} facet name of the attribute used for facetting
	   * @param {value} value value used for filtering
	   * @return {SearchParameters}
	   */
	  toggleFacetRefinement: function toggleFacetRefinement(facet, value) {
	    if (!this.isConjunctiveFacet(facet)) {
	      throw new Error(facet + ' is not defined in the facets attribute of the helper configuration');
	    }
	
	    return this.setQueryParameters({
	      facetsRefinements: RefinementList.toggleRefinement(this.facetsRefinements, facet, value)
	    });
	  },
	  /**
	   * Switch the refinement applied over a facet/value
	   * @method
	   * @param {string} facet name of the attribute used for facetting
	   * @param {value} value value used for filtering
	   * @return {SearchParameters}
	   */
	  toggleExcludeFacetRefinement: function toggleExcludeFacetRefinement(facet, value) {
	    if (!this.isConjunctiveFacet(facet)) {
	      throw new Error(facet + ' is not defined in the facets attribute of the helper configuration');
	    }
	
	    return this.setQueryParameters({
	      facetsExcludes: RefinementList.toggleRefinement(this.facetsExcludes, facet, value)
	    });
	  },
	  /**
	   * Switch the refinement applied over a facet/value
	   * @method
	   * @param {string} facet name of the attribute used for facetting
	   * @param {value} value value used for filtering
	   * @return {SearchParameters}
	   */
	  toggleDisjunctiveFacetRefinement: function toggleDisjunctiveFacetRefinement(facet, value) {
	    if (!this.isDisjunctiveFacet(facet)) {
	      throw new Error(
	        facet + ' is not defined in the disjunctiveFacets attribute of the helper configuration');
	    }
	
	    return this.setQueryParameters({
	      disjunctiveFacetsRefinements: RefinementList.toggleRefinement(
	        this.disjunctiveFacetsRefinements, facet, value)
	    });
	  },
	  /**
	   * Switch the refinement applied over a facet/value
	   * @method
	   * @param {string} facet name of the attribute used for facetting
	   * @param {value} value value used for filtering
	   * @return {SearchParameters}
	   */
	  toggleHierarchicalFacetRefinement: function toggleHierarchicalFacetRefinement(facet, value) {
	    if (!this.isHierarchicalFacet(facet)) {
	      throw new Error(
	        facet + ' is not defined in the hierarchicalFacets attribute of the helper configuration');
	    }
	
	    var separator = this._getHierarchicalFacetSeparator(this.getHierarchicalFacetByName(facet));
	
	    var mod = {};
	
	    var upOneOrMultipleLevel = this.hierarchicalFacetsRefinements[facet] !== undefined &&
	      this.hierarchicalFacetsRefinements[facet].length > 0 && (
	      // remove current refinement:
	      // refinement was 'beer > IPA', call is toggleRefine('beer > IPA'), refinement should be `beer`
	      this.hierarchicalFacetsRefinements[facet][0] === value ||
	      // remove a parent refinement of the current refinement:
	      //  - refinement was 'beer > IPA > Flying dog'
	      //  - call is toggleRefine('beer > IPA')
	      //  - refinement should be `beer`
	      this.hierarchicalFacetsRefinements[facet][0].indexOf(value + separator) === 0
	    );
	
	    if (upOneOrMultipleLevel) {
	      if (value.indexOf(separator) === -1) {
	        // go back to root level
	        mod[facet] = [];
	      } else {
	        mod[facet] = [value.slice(0, value.lastIndexOf(separator))];
	      }
	    } else {
	      mod[facet] = [value];
	    }
	
	    return this.setQueryParameters({
	      hierarchicalFacetsRefinements: defaults({}, mod, this.hierarchicalFacetsRefinements)
	    });
	  },
	
	  /**
	   * Adds a refinement on a hierarchical facet.
	   * @param {string} facet the facet name
	   * @param {string} path the hierarchical facet path
	   * @return {SearchParameter} the new state
	   * @throws Error if the facet is not defined or if the facet is refined
	   */
	  addHierarchicalFacetRefinement: function(facet, path) {
	    if (this.isHierarchicalFacetRefined(facet)) {
	      throw new Error(facet + ' is already refined.');
	    }
	    var mod = {};
	    mod[facet] = [path];
	    return this.setQueryParameters({
	      hierarchicalFacetsRefinements: defaults({}, mod, this.hierarchicalFacetsRefinements)
	    });
	  },
	
	  /**
	   * Removes the refinement set on a hierarchical facet.
	   * @param {string} facet the facet name
	   * @return {SearchParameter} the new state
	   * @throws Error if the facet is not defined or if the facet is not refined
	   */
	  removeHierarchicalFacetRefinement: function(facet) {
	    if (!this.isHierarchicalFacetRefined(facet)) {
	      throw new Error(facet + ' is not refined.');
	    }
	    var mod = {};
	    mod[facet] = [];
	    return this.setQueryParameters({
	      hierarchicalFacetsRefinements: defaults({}, mod, this.hierarchicalFacetsRefinements)
	    });
	  },
	  /**
	   * Switch the tag refinement
	   * @method
	   * @param {string} tag the tag to remove or add
	   * @return {SearchParameters}
	   */
	  toggleTagRefinement: function toggleTagRefinement(tag) {
	    if (this.isTagRefined(tag)) {
	      return this.removeTagRefinement(tag);
	    }
	
	    return this.addTagRefinement(tag);
	  },
	  /**
	   * Test if the facet name is from one of the disjunctive facets
	   * @method
	   * @param {string} facet facet name to test
	   * @return {boolean}
	   */
	  isDisjunctiveFacet: function(facet) {
	    return indexOf(this.disjunctiveFacets, facet) > -1;
	  },
	  /**
	   * Test if the facet name is from one of the hierarchical facets
	   * @method
	   * @param {string} facetName facet name to test
	   * @return {boolean}
	   */
	  isHierarchicalFacet: function(facetName) {
	    return this.getHierarchicalFacetByName(facetName) !== undefined;
	  },
	  /**
	   * Test if the facet name is from one of the conjunctive/normal facets
	   * @method
	   * @param {string} facet facet name to test
	   * @return {boolean}
	   */
	  isConjunctiveFacet: function(facet) {
	    return indexOf(this.facets, facet) > -1;
	  },
	  /**
	   * Returns true if the facet is refined, either for a specific value or in
	   * general.
	   * @method
	   * @param {string} facet name of the attribute for used for facetting
	   * @param {string} value, optionnal value. If passed will test that this value
	   * is filtering the given facet.
	   * @return {boolean} returns true if refined
	   */
	  isFacetRefined: function isFacetRefined(facet, value) {
	    if (!this.isConjunctiveFacet(facet)) {
	      throw new Error(facet + ' is not defined in the facets attribute of the helper configuration');
	    }
	    return RefinementList.isRefined(this.facetsRefinements, facet, value);
	  },
	  /**
	   * Returns true if the facet contains exclusions or if a specific value is
	   * excluded.
	   *
	   * @method
	   * @param {string} facet name of the attribute for used for facetting
	   * @param {string} [value] optionnal value. If passed will test that this value
	   * is filtering the given facet.
	   * @return {boolean} returns true if refined
	   */
	  isExcludeRefined: function isExcludeRefined(facet, value) {
	    if (!this.isConjunctiveFacet(facet)) {
	      throw new Error(facet + ' is not defined in the facets attribute of the helper configuration');
	    }
	    return RefinementList.isRefined(this.facetsExcludes, facet, value);
	  },
	  /**
	   * Returns true if the facet contains a refinement, or if a value passed is a
	   * refinement for the facet.
	   * @method
	   * @param {string} facet name of the attribute for used for facetting
	   * @param {string} value optionnal, will test if the value is used for refinement
	   * if there is one, otherwise will test if the facet contains any refinement
	   * @return {boolean}
	   */
	  isDisjunctiveFacetRefined: function isDisjunctiveFacetRefined(facet, value) {
	    if (!this.isDisjunctiveFacet(facet)) {
	      throw new Error(
	        facet + ' is not defined in the disjunctiveFacets attribute of the helper configuration');
	    }
	    return RefinementList.isRefined(this.disjunctiveFacetsRefinements, facet, value);
	  },
	  /**
	   * Returns true if the facet contains a refinement, or if a value passed is a
	   * refinement for the facet.
	   * @method
	   * @param {string} facet name of the attribute for used for facetting
	   * @param {string} value optionnal, will test if the value is used for refinement
	   * if there is one, otherwise will test if the facet contains any refinement
	   * @return {boolean}
	   */
	  isHierarchicalFacetRefined: function isHierarchicalFacetRefined(facet, value) {
	    if (!this.isHierarchicalFacet(facet)) {
	      throw new Error(
	        facet + ' is not defined in the hierarchicalFacets attribute of the helper configuration');
	    }
	
	    var refinements = this.getHierarchicalRefinement(facet);
	
	    if (!value) {
	      return refinements.length > 0;
	    }
	
	    return indexOf(refinements, value) !== -1;
	  },
	  /**
	   * Test if the triple (attribute, operator, value) is already refined.
	   * If only the attribute and the operator are provided, it tests if the
	   * contains any refinement value.
	   * @method
	   * @param {string} attribute attribute for which the refinement is applied
	   * @param {string} [operator] operator of the refinement
	   * @param {string} [value] value of the refinement
	   * @return {boolean} true if it is refined
	   */
	  isNumericRefined: function isNumericRefined(attribute, operator, value) {
	    if (isUndefined(value) && isUndefined(operator)) {
	      return !!this.numericRefinements[attribute];
	    }
	
	    var isOperatorDefined = this.numericRefinements[attribute] &&
	      !isUndefined(this.numericRefinements[attribute][operator]);
	
	    if (isUndefined(value) || !isOperatorDefined) {
	      return isOperatorDefined;
	    }
	
	    var parsedValue = valToNumber(value);
	    var isAttributeValueDefined = !isUndefined(
	      findArray(this.numericRefinements[attribute][operator], parsedValue)
	    );
	
	    return isOperatorDefined && isAttributeValueDefined;
	  },
	  /**
	   * Returns true if the tag refined, false otherwise
	   * @method
	   * @param {string} tag the tag to check
	   * @return {boolean}
	   */
	  isTagRefined: function isTagRefined(tag) {
	    return indexOf(this.tagRefinements, tag) !== -1;
	  },
	  /**
	   * Returns the list of all disjunctive facets refined
	   * @method
	   * @param {string} facet name of the attribute used for facetting
	   * @param {value} value value used for filtering
	   * @return {string[]}
	   */
	  getRefinedDisjunctiveFacets: function getRefinedDisjunctiveFacets() {
	    // attributes used for numeric filter can also be disjunctive
	    var disjunctiveNumericRefinedFacets = intersection(
	      keys(this.numericRefinements),
	      this.disjunctiveFacets
	    );
	
	    return keys(this.disjunctiveFacetsRefinements)
	      .concat(disjunctiveNumericRefinedFacets)
	      .concat(this.getRefinedHierarchicalFacets());
	  },
	  /**
	   * Returns the list of all disjunctive facets refined
	   * @method
	   * @param {string} facet name of the attribute used for facetting
	   * @param {value} value value used for filtering
	   * @return {string[]}
	   */
	  getRefinedHierarchicalFacets: function getRefinedHierarchicalFacets() {
	    return intersection(
	      // enforce the order between the two arrays,
	      // so that refinement name index === hierarchical facet index
	      map(this.hierarchicalFacets, 'name'),
	      keys(this.hierarchicalFacetsRefinements)
	    );
	  },
	  /**
	   * Returned the list of all disjunctive facets not refined
	   * @method
	   * @return {string[]}
	   */
	  getUnrefinedDisjunctiveFacets: function() {
	    var refinedFacets = this.getRefinedDisjunctiveFacets();
	
	    return filter(this.disjunctiveFacets, function(f) {
	      return indexOf(refinedFacets, f) === -1;
	    });
	  },
	
	  managedParameters: [
	    'index',
	    'facets', 'disjunctiveFacets', 'facetsRefinements',
	    'facetsExcludes', 'disjunctiveFacetsRefinements',
	    'numericRefinements', 'tagRefinements', 'hierarchicalFacets', 'hierarchicalFacetsRefinements'
	  ],
	  getQueryParams: function getQueryParams() {
	    var managedParameters = this.managedParameters;
	
	    var queryParams = {};
	
	    forOwn(this, function(paramValue, paramName) {
	      if (indexOf(managedParameters, paramName) === -1 && paramValue !== undefined) {
	        queryParams[paramName] = paramValue;
	      }
	    });
	
	    return queryParams;
	  },
	  /**
	   * Let the user retrieve any parameter value from the SearchParameters
	   * @param {string} paramName name of the parameter
	   * @return {any} the value of the parameter
	   */
	  getQueryParameter: function getQueryParameter(paramName) {
	    if (!this.hasOwnProperty(paramName)) {
	      throw new Error(
	        "Parameter '" + paramName + "' is not an attribute of SearchParameters " +
	        '(http://algolia.github.io/algoliasearch-helper-js/docs/SearchParameters.html)');
	    }
	
	    return this[paramName];
	  },
	  /**
	   * Let the user set a specific value for a given parameter. Will return the
	   * same instance if the parameter is invalid or if the value is the same as the
	   * previous one.
	   * @method
	   * @param {string} parameter the parameter name
	   * @param {any} value the value to be set, must be compliant with the definition
	   * of the attribute on the object
	   * @return {SearchParameters} the updated state
	   */
	  setQueryParameter: function setParameter(parameter, value) {
	    if (this[parameter] === value) return this;
	
	    var modification = {};
	
	    modification[parameter] = value;
	
	    return this.setQueryParameters(modification);
	  },
	  /**
	   * Let the user set any of the parameters with a plain object.
	   * @method
	   * @param {object} params all the keys and the values to be updated
	   * @return {SearchParameters} a new updated instance
	   */
	  setQueryParameters: function setQueryParameters(params) {
	    if (!params) return this;
	
	    var error = SearchParameters.validate(this, params);
	
	    if (error) {
	      throw error;
	    }
	
	    var parsedParams = SearchParameters._parseNumbers(params);
	
	    return this.mutateMe(function mergeWith(newInstance) {
	      var ks = keys(params);
	
	      forEach(ks, function(k) {
	        newInstance[k] = parsedParams[k];
	      });
	
	      return newInstance;
	    });
	  },
	
	  /**
	   * Returns an object with only the selected attributes.
	   * @param {string[]} filters filters to retrieve only a subset of the state. It
	   * accepts strings that can be either attributes of the SearchParameters (e.g. hitsPerPage)
	   * or attributes of the index with the notation 'attribute:nameOfMyAttribute'
	   * @return {object}
	   */
	  filter: function(filters) {
	    return filterState(this, filters);
	  },
	  /**
	   * Helper function to make it easier to build new instances from a mutating
	   * function
	   * @private
	   * @param {function} fn newMutableState -> previousState -> () function that will
	   * change the value of the newMutable to the desired state
	   * @return {SearchParameters} a new instance with the specified modifications applied
	   */
	  mutateMe: function mutateMe(fn) {
	    var newState = new this.constructor(this);
	
	    fn(newState, this);
	    return newState;
	  },
	
	  /**
	   * Helper function to get the hierarchicalFacet separator or the default one (`>`)
	   * @param  {object} hierarchicalFacet
	   * @return {string} returns the hierarchicalFacet.separator or `>` as default
	   */
	  _getHierarchicalFacetSortBy: function(hierarchicalFacet) {
	    return hierarchicalFacet.sortBy || ['isRefined:desc', 'name:asc'];
	  },
	
	  /**
	   * Helper function to get the hierarchicalFacet separator or the default one (`>`)
	   * @private
	   * @param  {object} hierarchicalFacet
	   * @return {string} returns the hierarchicalFacet.separator or `>` as default
	   */
	  _getHierarchicalFacetSeparator: function(hierarchicalFacet) {
	    return hierarchicalFacet.separator || ' > ';
	  },
	
	  /**
	   * Helper function to get the hierarchicalFacet prefix path or null
	   * @private
	   * @param  {object} hierarchicalFacet
	   * @return {string} returns the hierarchicalFacet.rootPath or null as default
	   */
	  _getHierarchicalRootPath: function(hierarchicalFacet) {
	    return hierarchicalFacet.rootPath || null;
	  },
	
	  /**
	   * Helper function to check if we show the parent level of the hierarchicalFacet
	   * @private
	   * @param  {object} hierarchicalFacet
	   * @return {string} returns the hierarchicalFacet.showParentLevel or true as default
	   */
	  _getHierarchicalShowParentLevel: function(hierarchicalFacet) {
	    if (typeof hierarchicalFacet.showParentLevel === 'boolean') {
	      return hierarchicalFacet.showParentLevel;
	    }
	    return true;
	  },
	
	  /**
	   * Helper function to get the hierarchicalFacet by it's name
	   * @param  {string} hierarchicalFacetName
	   * @return {object} a hierarchicalFacet
	   */
	  getHierarchicalFacetByName: function(hierarchicalFacetName) {
	    return find(
	      this.hierarchicalFacets,
	      {name: hierarchicalFacetName}
	    );
	  },
	
	  /**
	   * Get the current breadcrumb for a hierarchical facet, as an array
	   * @param  {string} facetName Hierarchical facet name
	   * @return {array.<string>} the path as an array of string
	   */
	  getHierarchicalFacetBreadcrumb: function(facetName) {
	    if (!this.isHierarchicalFacet(facetName)) {
	      throw new Error(
	        'Cannot get the breadcrumb of an unknown hierarchical facet: `' + facetName + '`');
	    }
	
	    var refinement = this.getHierarchicalRefinement(facetName)[0];
	    if (!refinement) return [];
	
	    var separator = this._getHierarchicalFacetSeparator(
	      this.getHierarchicalFacetByName(facetName)
	    );
	    var path = refinement.split(separator);
	    return map(path, trim);
	  }
	};
	
	/**
	 * Callback used for clearRefinement method
	 * @callback SearchParameters.clearCallback
	 * @param {OperatorList|FacetList} value the value of the filter
	 * @param {string} key the current attribute name
	 * @param {string} type `numeric`, `disjunctiveFacet`, `conjunctiveFacet`, `hierarchicalFacet` or `exclude`
	 * depending on the type of facet
	 * @return {boolean} `true` if the element should be removed. `false` otherwise.
	 */
	module.exports = SearchParameters;


/***/ }),
/* 1363 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__(1013),
	    baseIntersection = __webpack_require__(1364),
	    baseRest = __webpack_require__(811),
	    castArrayLikeObject = __webpack_require__(1371);
	
	/**
	 * Creates an array of unique values that are included in all given arrays
	 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * for equality comparisons. The order and references of result values are
	 * determined by the first array.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Array
	 * @param {...Array} [arrays] The arrays to inspect.
	 * @returns {Array} Returns the new array of intersecting values.
	 * @example
	 *
	 * _.intersection([2, 1], [2, 3]);
	 * // => [2]
	 */
	var intersection = baseRest(function(arrays) {
	  var mapped = arrayMap(arrays, castArrayLikeObject);
	  return (mapped.length && mapped[0] === arrays[0])
	    ? baseIntersection(mapped)
	    : [];
	});
	
	module.exports = intersection;


/***/ }),
/* 1364 */
/***/ (function(module, exports, __webpack_require__) {

	var SetCache = __webpack_require__(928),
	    arrayIncludes = __webpack_require__(1365),
	    arrayIncludesWith = __webpack_require__(1370),
	    arrayMap = __webpack_require__(1013),
	    baseUnary = __webpack_require__(798),
	    cacheHas = __webpack_require__(932);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMin = Math.min;
	
	/**
	 * The base implementation of methods like `_.intersection`, without support
	 * for iteratee shorthands, that accepts an array of arrays to inspect.
	 *
	 * @private
	 * @param {Array} arrays The arrays to inspect.
	 * @param {Function} [iteratee] The iteratee invoked per element.
	 * @param {Function} [comparator] The comparator invoked per element.
	 * @returns {Array} Returns the new array of shared values.
	 */
	function baseIntersection(arrays, iteratee, comparator) {
	  var includes = comparator ? arrayIncludesWith : arrayIncludes,
	      length = arrays[0].length,
	      othLength = arrays.length,
	      othIndex = othLength,
	      caches = Array(othLength),
	      maxLength = Infinity,
	      result = [];
	
	  while (othIndex--) {
	    var array = arrays[othIndex];
	    if (othIndex && iteratee) {
	      array = arrayMap(array, baseUnary(iteratee));
	    }
	    maxLength = nativeMin(array.length, maxLength);
	    caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
	      ? new SetCache(othIndex && array)
	      : undefined;
	  }
	  array = arrays[0];
	
	  var index = -1,
	      seen = caches[0];
	
	  outer:
	  while (++index < length && result.length < maxLength) {
	    var value = array[index],
	        computed = iteratee ? iteratee(value) : value;
	
	    value = (comparator || value !== 0) ? value : 0;
	    if (!(seen
	          ? cacheHas(seen, computed)
	          : includes(result, computed, comparator)
	        )) {
	      othIndex = othLength;
	      while (--othIndex) {
	        var cache = caches[othIndex];
	        if (!(cache
	              ? cacheHas(cache, computed)
	              : includes(arrays[othIndex], computed, comparator))
	            ) {
	          continue outer;
	        }
	      }
	      if (seen) {
	        seen.push(computed);
	      }
	      result.push(value);
	    }
	  }
	  return result;
	}
	
	module.exports = baseIntersection;


/***/ }),
/* 1365 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIndexOf = __webpack_require__(1366);
	
	/**
	 * A specialized version of `_.includes` for arrays without support for
	 * specifying an index to search from.
	 *
	 * @private
	 * @param {Array} [array] The array to inspect.
	 * @param {*} target The value to search for.
	 * @returns {boolean} Returns `true` if `target` is found, else `false`.
	 */
	function arrayIncludes(array, value) {
	  var length = array == null ? 0 : array.length;
	  return !!length && baseIndexOf(array, value, 0) > -1;
	}
	
	module.exports = arrayIncludes;


/***/ }),
/* 1366 */
/***/ (function(module, exports, __webpack_require__) {

	var baseFindIndex = __webpack_require__(1367),
	    baseIsNaN = __webpack_require__(1368),
	    strictIndexOf = __webpack_require__(1369);
	
	/**
	 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} value The value to search for.
	 * @param {number} fromIndex The index to search from.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function baseIndexOf(array, value, fromIndex) {
	  return value === value
	    ? strictIndexOf(array, value, fromIndex)
	    : baseFindIndex(array, baseIsNaN, fromIndex);
	}
	
	module.exports = baseIndexOf;


/***/ }),
/* 1367 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.findIndex` and `_.findLastIndex` without
	 * support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {Function} predicate The function invoked per iteration.
	 * @param {number} fromIndex The index to search from.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function baseFindIndex(array, predicate, fromIndex, fromRight) {
	  var length = array.length,
	      index = fromIndex + (fromRight ? 1 : -1);
	
	  while ((fromRight ? index-- : ++index < length)) {
	    if (predicate(array[index], index, array)) {
	      return index;
	    }
	  }
	  return -1;
	}
	
	module.exports = baseFindIndex;


/***/ }),
/* 1368 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.isNaN` without support for number objects.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	 */
	function baseIsNaN(value) {
	  return value !== value;
	}
	
	module.exports = baseIsNaN;


/***/ }),
/* 1369 */
/***/ (function(module, exports) {

	/**
	 * A specialized version of `_.indexOf` which performs strict equality
	 * comparisons of values, i.e. `===`.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} value The value to search for.
	 * @param {number} fromIndex The index to search from.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function strictIndexOf(array, value, fromIndex) {
	  var index = fromIndex - 1,
	      length = array.length;
	
	  while (++index < length) {
	    if (array[index] === value) {
	      return index;
	    }
	  }
	  return -1;
	}
	
	module.exports = strictIndexOf;


/***/ }),
/* 1370 */
/***/ (function(module, exports) {

	/**
	 * This function is like `arrayIncludes` except that it accepts a comparator.
	 *
	 * @private
	 * @param {Array} [array] The array to inspect.
	 * @param {*} target The value to search for.
	 * @param {Function} comparator The comparator invoked per element.
	 * @returns {boolean} Returns `true` if `target` is found, else `false`.
	 */
	function arrayIncludesWith(array, value, comparator) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  while (++index < length) {
	    if (comparator(value, array[index])) {
	      return true;
	    }
	  }
	  return false;
	}
	
	module.exports = arrayIncludesWith;


/***/ }),
/* 1371 */
/***/ (function(module, exports, __webpack_require__) {

	var isArrayLikeObject = __webpack_require__(790);
	
	/**
	 * Casts `value` to an empty array if it's not an array like object.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {Array|Object} Returns the cast array-like object.
	 */
	function castArrayLikeObject(value) {
	  return isArrayLikeObject(value) ? value : [];
	}
	
	module.exports = castArrayLikeObject;


/***/ }),
/* 1372 */
/***/ (function(module, exports, __webpack_require__) {

	var baseForOwn = __webpack_require__(995),
	    castFunction = __webpack_require__(1373);
	
	/**
	 * Iterates over own enumerable string keyed properties of an object and
	 * invokes `iteratee` for each property. The iteratee is invoked with three
	 * arguments: (value, key, object). Iteratee functions may exit iteration
	 * early by explicitly returning `false`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.3.0
	 * @category Object
	 * @param {Object} object The object to iterate over.
	 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	 * @returns {Object} Returns `object`.
	 * @see _.forOwnRight
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.forOwn(new Foo, function(value, key) {
	 *   console.log(key);
	 * });
	 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	 */
	function forOwn(object, iteratee) {
	  return object && baseForOwn(object, castFunction(iteratee));
	}
	
	module.exports = forOwn;


/***/ }),
/* 1373 */
/***/ (function(module, exports, __webpack_require__) {

	var identity = __webpack_require__(812);
	
	/**
	 * Casts `value` to `identity` if it's not a function.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {Function} Returns cast function.
	 */
	function castFunction(value) {
	  return typeof value == 'function' ? value : identity;
	}
	
	module.exports = castFunction;


/***/ }),
/* 1374 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayEach = __webpack_require__(1191),
	    baseEach = __webpack_require__(994),
	    castFunction = __webpack_require__(1373),
	    isArray = __webpack_require__(789);
	
	/**
	 * Iterates over elements of `collection` and invokes `iteratee` for each element.
	 * The iteratee is invoked with three arguments: (value, index|key, collection).
	 * Iteratee functions may exit iteration early by explicitly returning `false`.
	 *
	 * **Note:** As with other "Collections" methods, objects with a "length"
	 * property are iterated like arrays. To avoid this behavior use `_.forIn`
	 * or `_.forOwn` for object iteration.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @alias each
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	 * @returns {Array|Object} Returns `collection`.
	 * @see _.forEachRight
	 * @example
	 *
	 * _.forEach([1, 2], function(value) {
	 *   console.log(value);
	 * });
	 * // => Logs `1` then `2`.
	 *
	 * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
	 *   console.log(key);
	 * });
	 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	 */
	function forEach(collection, iteratee) {
	  var func = isArray(collection) ? arrayEach : baseEach;
	  return func(collection, castFunction(iteratee));
	}
	
	module.exports = forEach;


/***/ }),
/* 1375 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayFilter = __webpack_require__(941),
	    baseFilter = __webpack_require__(1376),
	    baseIteratee = __webpack_require__(997),
	    isArray = __webpack_require__(789);
	
	/**
	 * Iterates over elements of `collection`, returning an array of all elements
	 * `predicate` returns truthy for. The predicate is invoked with three
	 * arguments: (value, index|key, collection).
	 *
	 * **Note:** Unlike `_.remove`, this method returns a new array.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [predicate=_.identity] The function invoked per iteration.
	 * @returns {Array} Returns the new filtered array.
	 * @see _.reject
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'barney', 'age': 36, 'active': true },
	 *   { 'user': 'fred',   'age': 40, 'active': false }
	 * ];
	 *
	 * _.filter(users, function(o) { return !o.active; });
	 * // => objects for ['fred']
	 *
	 * // The `_.matches` iteratee shorthand.
	 * _.filter(users, { 'age': 36, 'active': true });
	 * // => objects for ['barney']
	 *
	 * // The `_.matchesProperty` iteratee shorthand.
	 * _.filter(users, ['active', false]);
	 * // => objects for ['fred']
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.filter(users, 'active');
	 * // => objects for ['barney']
	 *
	 * // Combining several predicates using `_.overEvery` or `_.overSome`.
	 * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
	 * // => objects for ['fred', 'barney']
	 */
	function filter(collection, predicate) {
	  var func = isArray(collection) ? arrayFilter : baseFilter;
	  return func(collection, baseIteratee(predicate, 3));
	}
	
	module.exports = filter;


/***/ }),
/* 1376 */
/***/ (function(module, exports, __webpack_require__) {

	var baseEach = __webpack_require__(994);
	
	/**
	 * The base implementation of `_.filter` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {Array} Returns the new filtered array.
	 */
	function baseFilter(collection, predicate) {
	  var result = [];
	  baseEach(collection, function(value, index, collection) {
	    if (predicate(value, index, collection)) {
	      result.push(value);
	    }
	  });
	  return result;
	}
	
	module.exports = baseFilter;


/***/ }),
/* 1377 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__(1013),
	    baseIteratee = __webpack_require__(997),
	    baseMap = __webpack_require__(1378),
	    isArray = __webpack_require__(789);
	
	/**
	 * Creates an array of values by running each element in `collection` thru
	 * `iteratee`. The iteratee is invoked with three arguments:
	 * (value, index|key, collection).
	 *
	 * Many lodash methods are guarded to work as iteratees for methods like
	 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
	 *
	 * The guarded methods are:
	 * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
	 * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
	 * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
	 * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 * @example
	 *
	 * function square(n) {
	 *   return n * n;
	 * }
	 *
	 * _.map([4, 8], square);
	 * // => [16, 64]
	 *
	 * _.map({ 'a': 4, 'b': 8 }, square);
	 * // => [16, 64] (iteration order is not guaranteed)
	 *
	 * var users = [
	 *   { 'user': 'barney' },
	 *   { 'user': 'fred' }
	 * ];
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.map(users, 'user');
	 * // => ['barney', 'fred']
	 */
	function map(collection, iteratee) {
	  var func = isArray(collection) ? arrayMap : baseMap;
	  return func(collection, baseIteratee(iteratee, 3));
	}
	
	module.exports = map;


/***/ }),
/* 1378 */
/***/ (function(module, exports, __webpack_require__) {

	var baseEach = __webpack_require__(994),
	    isArrayLike = __webpack_require__(791);
	
	/**
	 * The base implementation of `_.map` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 */
	function baseMap(collection, iteratee) {
	  var index = -1,
	      result = isArrayLike(collection) ? Array(collection.length) : [];
	
	  baseEach(collection, function(value, key, collection) {
	    result[++index] = iteratee(value, key, collection);
	  });
	  return result;
	}
	
	module.exports = baseMap;


/***/ }),
/* 1379 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayReduce = __webpack_require__(1380),
	    baseEach = __webpack_require__(994),
	    baseIteratee = __webpack_require__(997),
	    baseReduce = __webpack_require__(1381),
	    isArray = __webpack_require__(789);
	
	/**
	 * Reduces `collection` to a value which is the accumulated result of running
	 * each element in `collection` thru `iteratee`, where each successive
	 * invocation is supplied the return value of the previous. If `accumulator`
	 * is not given, the first element of `collection` is used as the initial
	 * value. The iteratee is invoked with four arguments:
	 * (accumulator, value, index|key, collection).
	 *
	 * Many lodash methods are guarded to work as iteratees for methods like
	 * `_.reduce`, `_.reduceRight`, and `_.transform`.
	 *
	 * The guarded methods are:
	 * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
	 * and `sortBy`
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	 * @param {*} [accumulator] The initial value.
	 * @returns {*} Returns the accumulated value.
	 * @see _.reduceRight
	 * @example
	 *
	 * _.reduce([1, 2], function(sum, n) {
	 *   return sum + n;
	 * }, 0);
	 * // => 3
	 *
	 * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
	 *   (result[value] || (result[value] = [])).push(key);
	 *   return result;
	 * }, {});
	 * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
	 */
	function reduce(collection, iteratee, accumulator) {
	  var func = isArray(collection) ? arrayReduce : baseReduce,
	      initAccum = arguments.length < 3;
	
	  return func(collection, baseIteratee(iteratee, 4), accumulator, initAccum, baseEach);
	}
	
	module.exports = reduce;


/***/ }),
/* 1380 */
/***/ (function(module, exports) {

	/**
	 * A specialized version of `_.reduce` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {*} [accumulator] The initial value.
	 * @param {boolean} [initAccum] Specify using the first element of `array` as
	 *  the initial value.
	 * @returns {*} Returns the accumulated value.
	 */
	function arrayReduce(array, iteratee, accumulator, initAccum) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  if (initAccum && length) {
	    accumulator = array[++index];
	  }
	  while (++index < length) {
	    accumulator = iteratee(accumulator, array[index], index, array);
	  }
	  return accumulator;
	}
	
	module.exports = arrayReduce;


/***/ }),
/* 1381 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.reduce` and `_.reduceRight`, without support
	 * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {*} accumulator The initial value.
	 * @param {boolean} initAccum Specify using the first or last element of
	 *  `collection` as the initial value.
	 * @param {Function} eachFunc The function to iterate over `collection`.
	 * @returns {*} Returns the accumulated value.
	 */
	function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
	  eachFunc(collection, function(value, index, collection) {
	    accumulator = initAccum
	      ? (initAccum = false, value)
	      : iteratee(accumulator, value, index, collection);
	  });
	  return accumulator;
	}
	
	module.exports = baseReduce;


/***/ }),
/* 1382 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__(1013),
	    baseClone = __webpack_require__(1190),
	    baseUnset = __webpack_require__(1383),
	    castPath = __webpack_require__(1006),
	    copyObject = __webpack_require__(802),
	    customOmitClone = __webpack_require__(1387),
	    flatRest = __webpack_require__(1388),
	    getAllKeysIn = __webpack_require__(1166);
	
	/** Used to compose bitmasks for cloning. */
	var CLONE_DEEP_FLAG = 1,
	    CLONE_FLAT_FLAG = 2,
	    CLONE_SYMBOLS_FLAG = 4;
	
	/**
	 * The opposite of `_.pick`; this method creates an object composed of the
	 * own and inherited enumerable property paths of `object` that are not omitted.
	 *
	 * **Note:** This method is considerably slower than `_.pick`.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The source object.
	 * @param {...(string|string[])} [paths] The property paths to omit.
	 * @returns {Object} Returns the new object.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': '2', 'c': 3 };
	 *
	 * _.omit(object, ['a', 'c']);
	 * // => { 'b': '2' }
	 */
	var omit = flatRest(function(object, paths) {
	  var result = {};
	  if (object == null) {
	    return result;
	  }
	  var isDeep = false;
	  paths = arrayMap(paths, function(path) {
	    path = castPath(path, object);
	    isDeep || (isDeep = path.length > 1);
	    return path;
	  });
	  copyObject(object, getAllKeysIn(object), result);
	  if (isDeep) {
	    result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
	  }
	  var length = paths.length;
	  while (length--) {
	    baseUnset(result, paths[length]);
	  }
	  return result;
	});
	
	module.exports = omit;


/***/ }),
/* 1383 */
/***/ (function(module, exports, __webpack_require__) {

	var castPath = __webpack_require__(1006),
	    last = __webpack_require__(1384),
	    parent = __webpack_require__(1385),
	    toKey = __webpack_require__(1014);
	
	/**
	 * The base implementation of `_.unset`.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {Array|string} path The property path to unset.
	 * @returns {boolean} Returns `true` if the property is deleted, else `false`.
	 */
	function baseUnset(object, path) {
	  path = castPath(path, object);
	  object = parent(object, path);
	  return object == null || delete object[toKey(last(path))];
	}
	
	module.exports = baseUnset;


/***/ }),
/* 1384 */
/***/ (function(module, exports) {

	/**
	 * Gets the last element of `array`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Array
	 * @param {Array} array The array to query.
	 * @returns {*} Returns the last element of `array`.
	 * @example
	 *
	 * _.last([1, 2, 3]);
	 * // => 3
	 */
	function last(array) {
	  var length = array == null ? 0 : array.length;
	  return length ? array[length - 1] : undefined;
	}
	
	module.exports = last;


/***/ }),
/* 1385 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(1005),
	    baseSlice = __webpack_require__(1386);
	
	/**
	 * Gets the parent value at `path` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array} path The path to get the parent value of.
	 * @returns {*} Returns the parent value.
	 */
	function parent(object, path) {
	  return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
	}
	
	module.exports = parent;


/***/ }),
/* 1386 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.slice` without an iteratee call guard.
	 *
	 * @private
	 * @param {Array} array The array to slice.
	 * @param {number} [start=0] The start position.
	 * @param {number} [end=array.length] The end position.
	 * @returns {Array} Returns the slice of `array`.
	 */
	function baseSlice(array, start, end) {
	  var index = -1,
	      length = array.length;
	
	  if (start < 0) {
	    start = -start > length ? 0 : (length + start);
	  }
	  end = end > length ? length : end;
	  if (end < 0) {
	    end += length;
	  }
	  length = start > end ? 0 : ((end - start) >>> 0);
	  start >>>= 0;
	
	  var result = Array(length);
	  while (++index < length) {
	    result[index] = array[index + start];
	  }
	  return result;
	}
	
	module.exports = baseSlice;


/***/ }),
/* 1387 */
/***/ (function(module, exports, __webpack_require__) {

	var isPlainObject = __webpack_require__(795);
	
	/**
	 * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
	 * objects.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @param {string} key The key of the property to inspect.
	 * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
	 */
	function customOmitClone(value) {
	  return isPlainObject(value) ? undefined : value;
	}
	
	module.exports = customOmitClone;


/***/ }),
/* 1388 */
/***/ (function(module, exports, __webpack_require__) {

	var flatten = __webpack_require__(1389),
	    overRest = __webpack_require__(813),
	    setToString = __webpack_require__(815);
	
	/**
	 * A specialized version of `baseRest` which flattens the rest array.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @returns {Function} Returns the new function.
	 */
	function flatRest(func) {
	  return setToString(overRest(func, undefined, flatten), func + '');
	}
	
	module.exports = flatRest;


/***/ }),
/* 1389 */
/***/ (function(module, exports, __webpack_require__) {

	var baseFlatten = __webpack_require__(1390);
	
	/**
	 * Flattens `array` a single level deep.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Array
	 * @param {Array} array The array to flatten.
	 * @returns {Array} Returns the new flattened array.
	 * @example
	 *
	 * _.flatten([1, [2, [3, [4]], 5]]);
	 * // => [1, 2, [3, [4]], 5]
	 */
	function flatten(array) {
	  var length = array == null ? 0 : array.length;
	  return length ? baseFlatten(array, 1) : [];
	}
	
	module.exports = flatten;


/***/ }),
/* 1390 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayPush = __webpack_require__(939),
	    isFlattenable = __webpack_require__(1391);
	
	/**
	 * The base implementation of `_.flatten` with support for restricting flattening.
	 *
	 * @private
	 * @param {Array} array The array to flatten.
	 * @param {number} depth The maximum recursion depth.
	 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
	 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
	 * @param {Array} [result=[]] The initial result value.
	 * @returns {Array} Returns the new flattened array.
	 */
	function baseFlatten(array, depth, predicate, isStrict, result) {
	  var index = -1,
	      length = array.length;
	
	  predicate || (predicate = isFlattenable);
	  result || (result = []);
	
	  while (++index < length) {
	    var value = array[index];
	    if (depth > 0 && predicate(value)) {
	      if (depth > 1) {
	        // Recursively flatten arrays (susceptible to call stack limits).
	        baseFlatten(value, depth - 1, predicate, isStrict, result);
	      } else {
	        arrayPush(result, value);
	      }
	    } else if (!isStrict) {
	      result[result.length] = value;
	    }
	  }
	  return result;
	}
	
	module.exports = baseFlatten;


/***/ }),
/* 1391 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(652),
	    isArguments = __webpack_require__(787),
	    isArray = __webpack_require__(789);
	
	/** Built-in value references. */
	var spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;
	
	/**
	 * Checks if `value` is a flattenable `arguments` object or array.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
	 */
	function isFlattenable(value) {
	  return isArray(value) || isArguments(value) ||
	    !!(spreadableSymbol && value && value[spreadableSymbol]);
	}
	
	module.exports = isFlattenable;


/***/ }),
/* 1392 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIndexOf = __webpack_require__(1366),
	    toInteger = __webpack_require__(1393);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * Gets the index at which the first occurrence of `value` is found in `array`
	 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * for equality comparisons. If `fromIndex` is negative, it's used as the
	 * offset from the end of `array`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Array
	 * @param {Array} array The array to inspect.
	 * @param {*} value The value to search for.
	 * @param {number} [fromIndex=0] The index to search from.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 * @example
	 *
	 * _.indexOf([1, 2, 1, 2], 2);
	 * // => 1
	 *
	 * // Search from the `fromIndex`.
	 * _.indexOf([1, 2, 1, 2], 2, 2);
	 * // => 3
	 */
	function indexOf(array, value, fromIndex) {
	  var length = array == null ? 0 : array.length;
	  if (!length) {
	    return -1;
	  }
	  var index = fromIndex == null ? 0 : toInteger(fromIndex);
	  if (index < 0) {
	    index = nativeMax(length + index, 0);
	  }
	  return baseIndexOf(array, value, index);
	}
	
	module.exports = indexOf;


/***/ }),
/* 1393 */
/***/ (function(module, exports, __webpack_require__) {

	var toFinite = __webpack_require__(1394);
	
	/**
	 * Converts `value` to an integer.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {number} Returns the converted integer.
	 * @example
	 *
	 * _.toInteger(3.2);
	 * // => 3
	 *
	 * _.toInteger(Number.MIN_VALUE);
	 * // => 0
	 *
	 * _.toInteger(Infinity);
	 * // => 1.7976931348623157e+308
	 *
	 * _.toInteger('3.2');
	 * // => 3
	 */
	function toInteger(value) {
	  var result = toFinite(value),
	      remainder = result % 1;
	
	  return result === result ? (remainder ? result - remainder : result) : 0;
	}
	
	module.exports = toInteger;


/***/ }),
/* 1394 */
/***/ (function(module, exports, __webpack_require__) {

	var toNumber = __webpack_require__(647);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0,
	    MAX_INTEGER = 1.7976931348623157e+308;
	
	/**
	 * Converts `value` to a finite number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.12.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {number} Returns the converted number.
	 * @example
	 *
	 * _.toFinite(3.2);
	 * // => 3.2
	 *
	 * _.toFinite(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toFinite(Infinity);
	 * // => 1.7976931348623157e+308
	 *
	 * _.toFinite('3.2');
	 * // => 3.2
	 */
	function toFinite(value) {
	  if (!value) {
	    return value === 0 ? value : 0;
	  }
	  value = toNumber(value);
	  if (value === INFINITY || value === -INFINITY) {
	    var sign = (value < 0 ? -1 : 1);
	    return sign * MAX_INTEGER;
	  }
	  return value === value ? value : 0;
	}
	
	module.exports = toFinite;


/***/ }),
/* 1395 */
/***/ (function(module, exports, __webpack_require__) {

	var isNumber = __webpack_require__(1396);
	
	/**
	 * Checks if `value` is `NaN`.
	 *
	 * **Note:** This method is based on
	 * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
	 * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
	 * `undefined` and other non-number values.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	 * @example
	 *
	 * _.isNaN(NaN);
	 * // => true
	 *
	 * _.isNaN(new Number(NaN));
	 * // => true
	 *
	 * isNaN(undefined);
	 * // => true
	 *
	 * _.isNaN(undefined);
	 * // => false
	 */
	function isNaN(value) {
	  // An `NaN` primitive is the only value that is not equal to itself.
	  // Perform the `toStringTag` check first to avoid errors with some
	  // ActiveX objects in IE.
	  return isNumber(value) && value != +value;
	}
	
	module.exports = isNaN;


/***/ }),
/* 1396 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(651),
	    isObjectLike = __webpack_require__(655);
	
	/** `Object#toString` result references. */
	var numberTag = '[object Number]';
	
	/**
	 * Checks if `value` is classified as a `Number` primitive or object.
	 *
	 * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
	 * classified as numbers, use the `_.isFinite` method.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a number, else `false`.
	 * @example
	 *
	 * _.isNumber(3);
	 * // => true
	 *
	 * _.isNumber(Number.MIN_VALUE);
	 * // => true
	 *
	 * _.isNumber(Infinity);
	 * // => true
	 *
	 * _.isNumber('3');
	 * // => false
	 */
	function isNumber(value) {
	  return typeof value == 'number' ||
	    (isObjectLike(value) && baseGetTag(value) == numberTag);
	}
	
	module.exports = isNumber;


/***/ }),
/* 1397 */
/***/ (function(module, exports, __webpack_require__) {

	var baseKeys = __webpack_require__(922),
	    getTag = __webpack_require__(943),
	    isArguments = __webpack_require__(787),
	    isArray = __webpack_require__(789),
	    isArrayLike = __webpack_require__(791),
	    isBuffer = __webpack_require__(793),
	    isPrototype = __webpack_require__(786),
	    isTypedArray = __webpack_require__(796);
	
	/** `Object#toString` result references. */
	var mapTag = '[object Map]',
	    setTag = '[object Set]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Checks if `value` is an empty object, collection, map, or set.
	 *
	 * Objects are considered empty if they have no own enumerable string keyed
	 * properties.
	 *
	 * Array-like values such as `arguments` objects, arrays, buffers, strings, or
	 * jQuery-like collections are considered empty if they have a `length` of `0`.
	 * Similarly, maps and sets are considered empty if they have a `size` of `0`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is empty, else `false`.
	 * @example
	 *
	 * _.isEmpty(null);
	 * // => true
	 *
	 * _.isEmpty(true);
	 * // => true
	 *
	 * _.isEmpty(1);
	 * // => true
	 *
	 * _.isEmpty([1, 2, 3]);
	 * // => false
	 *
	 * _.isEmpty({ 'a': 1 });
	 * // => false
	 */
	function isEmpty(value) {
	  if (value == null) {
	    return true;
	  }
	  if (isArrayLike(value) &&
	      (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
	        isBuffer(value) || isTypedArray(value) || isArguments(value))) {
	    return !value.length;
	  }
	  var tag = getTag(value);
	  if (tag == mapTag || tag == setTag) {
	    return !value.size;
	  }
	  if (isPrototype(value)) {
	    return !baseKeys(value).length;
	  }
	  for (var key in value) {
	    if (hasOwnProperty.call(value, key)) {
	      return false;
	    }
	  }
	  return true;
	}
	
	module.exports = isEmpty;


/***/ }),
/* 1398 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is `undefined`.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
	 * @example
	 *
	 * _.isUndefined(void 0);
	 * // => true
	 *
	 * _.isUndefined(null);
	 * // => false
	 */
	function isUndefined(value) {
	  return value === undefined;
	}
	
	module.exports = isUndefined;


/***/ }),
/* 1399 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(651),
	    isArray = __webpack_require__(789),
	    isObjectLike = __webpack_require__(655);
	
	/** `Object#toString` result references. */
	var stringTag = '[object String]';
	
	/**
	 * Checks if `value` is classified as a `String` primitive or object.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
	 * @example
	 *
	 * _.isString('abc');
	 * // => true
	 *
	 * _.isString(1);
	 * // => false
	 */
	function isString(value) {
	  return typeof value == 'string' ||
	    (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
	}
	
	module.exports = isString;


/***/ }),
/* 1400 */
/***/ (function(module, exports, __webpack_require__) {

	var createFind = __webpack_require__(1401),
	    findIndex = __webpack_require__(1402);
	
	/**
	 * Iterates over elements of `collection`, returning the first element
	 * `predicate` returns truthy for. The predicate is invoked with three
	 * arguments: (value, index|key, collection).
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to inspect.
	 * @param {Function} [predicate=_.identity] The function invoked per iteration.
	 * @param {number} [fromIndex=0] The index to search from.
	 * @returns {*} Returns the matched element, else `undefined`.
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'barney',  'age': 36, 'active': true },
	 *   { 'user': 'fred',    'age': 40, 'active': false },
	 *   { 'user': 'pebbles', 'age': 1,  'active': true }
	 * ];
	 *
	 * _.find(users, function(o) { return o.age < 40; });
	 * // => object for 'barney'
	 *
	 * // The `_.matches` iteratee shorthand.
	 * _.find(users, { 'age': 1, 'active': true });
	 * // => object for 'pebbles'
	 *
	 * // The `_.matchesProperty` iteratee shorthand.
	 * _.find(users, ['active', false]);
	 * // => object for 'fred'
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.find(users, 'active');
	 * // => object for 'barney'
	 */
	var find = createFind(findIndex);
	
	module.exports = find;


/***/ }),
/* 1401 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIteratee = __webpack_require__(997),
	    isArrayLike = __webpack_require__(791),
	    keys = __webpack_require__(921);
	
	/**
	 * Creates a `_.find` or `_.findLast` function.
	 *
	 * @private
	 * @param {Function} findIndexFunc The function to find the collection index.
	 * @returns {Function} Returns the new find function.
	 */
	function createFind(findIndexFunc) {
	  return function(collection, predicate, fromIndex) {
	    var iterable = Object(collection);
	    if (!isArrayLike(collection)) {
	      var iteratee = baseIteratee(predicate, 3);
	      collection = keys(collection);
	      predicate = function(key) { return iteratee(iterable[key], key, iterable); };
	    }
	    var index = findIndexFunc(collection, predicate, fromIndex);
	    return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
	  };
	}
	
	module.exports = createFind;


/***/ }),
/* 1402 */
/***/ (function(module, exports, __webpack_require__) {

	var baseFindIndex = __webpack_require__(1367),
	    baseIteratee = __webpack_require__(997),
	    toInteger = __webpack_require__(1393);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * This method is like `_.find` except that it returns the index of the first
	 * element `predicate` returns truthy for instead of the element itself.
	 *
	 * @static
	 * @memberOf _
	 * @since 1.1.0
	 * @category Array
	 * @param {Array} array The array to inspect.
	 * @param {Function} [predicate=_.identity] The function invoked per iteration.
	 * @param {number} [fromIndex=0] The index to search from.
	 * @returns {number} Returns the index of the found element, else `-1`.
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'barney',  'active': false },
	 *   { 'user': 'fred',    'active': false },
	 *   { 'user': 'pebbles', 'active': true }
	 * ];
	 *
	 * _.findIndex(users, function(o) { return o.user == 'barney'; });
	 * // => 0
	 *
	 * // The `_.matches` iteratee shorthand.
	 * _.findIndex(users, { 'user': 'fred', 'active': false });
	 * // => 1
	 *
	 * // The `_.matchesProperty` iteratee shorthand.
	 * _.findIndex(users, ['active', false]);
	 * // => 0
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.findIndex(users, 'active');
	 * // => 2
	 */
	function findIndex(array, predicate, fromIndex) {
	  var length = array == null ? 0 : array.length;
	  if (!length) {
	    return -1;
	  }
	  var index = fromIndex == null ? 0 : toInteger(fromIndex);
	  if (index < 0) {
	    index = nativeMax(length + index, 0);
	  }
	  return baseFindIndex(array, baseIteratee(predicate, 3), index);
	}
	
	module.exports = findIndex;


/***/ }),
/* 1403 */
/***/ (function(module, exports, __webpack_require__) {

	var baseToString = __webpack_require__(1012),
	    baseTrim = __webpack_require__(648),
	    castSlice = __webpack_require__(1404),
	    charsEndIndex = __webpack_require__(1405),
	    charsStartIndex = __webpack_require__(1406),
	    stringToArray = __webpack_require__(1407),
	    toString = __webpack_require__(1011);
	
	/**
	 * Removes leading and trailing whitespace or specified characters from `string`.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category String
	 * @param {string} [string=''] The string to trim.
	 * @param {string} [chars=whitespace] The characters to trim.
	 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	 * @returns {string} Returns the trimmed string.
	 * @example
	 *
	 * _.trim('  abc  ');
	 * // => 'abc'
	 *
	 * _.trim('-_-abc-_-', '_-');
	 * // => 'abc'
	 *
	 * _.map(['  foo  ', '  bar  '], _.trim);
	 * // => ['foo', 'bar']
	 */
	function trim(string, chars, guard) {
	  string = toString(string);
	  if (string && (guard || chars === undefined)) {
	    return baseTrim(string);
	  }
	  if (!string || !(chars = baseToString(chars))) {
	    return string;
	  }
	  var strSymbols = stringToArray(string),
	      chrSymbols = stringToArray(chars),
	      start = charsStartIndex(strSymbols, chrSymbols),
	      end = charsEndIndex(strSymbols, chrSymbols) + 1;
	
	  return castSlice(strSymbols, start, end).join('');
	}
	
	module.exports = trim;


/***/ }),
/* 1404 */
/***/ (function(module, exports, __webpack_require__) {

	var baseSlice = __webpack_require__(1386);
	
	/**
	 * Casts `array` to a slice if it's needed.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {number} start The start position.
	 * @param {number} [end=array.length] The end position.
	 * @returns {Array} Returns the cast slice.
	 */
	function castSlice(array, start, end) {
	  var length = array.length;
	  end = end === undefined ? length : end;
	  return (!start && end >= length) ? array : baseSlice(array, start, end);
	}
	
	module.exports = castSlice;


/***/ }),
/* 1405 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIndexOf = __webpack_require__(1366);
	
	/**
	 * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
	 * that is not found in the character symbols.
	 *
	 * @private
	 * @param {Array} strSymbols The string symbols to inspect.
	 * @param {Array} chrSymbols The character symbols to find.
	 * @returns {number} Returns the index of the last unmatched string symbol.
	 */
	function charsEndIndex(strSymbols, chrSymbols) {
	  var index = strSymbols.length;
	
	  while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
	  return index;
	}
	
	module.exports = charsEndIndex;


/***/ }),
/* 1406 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIndexOf = __webpack_require__(1366);
	
	/**
	 * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
	 * that is not found in the character symbols.
	 *
	 * @private
	 * @param {Array} strSymbols The string symbols to inspect.
	 * @param {Array} chrSymbols The character symbols to find.
	 * @returns {number} Returns the index of the first unmatched string symbol.
	 */
	function charsStartIndex(strSymbols, chrSymbols) {
	  var index = -1,
	      length = strSymbols.length;
	
	  while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
	  return index;
	}
	
	module.exports = charsStartIndex;


/***/ }),
/* 1407 */
/***/ (function(module, exports, __webpack_require__) {

	var asciiToArray = __webpack_require__(1408),
	    hasUnicode = __webpack_require__(1409),
	    unicodeToArray = __webpack_require__(1410);
	
	/**
	 * Converts `string` to an array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the converted array.
	 */
	function stringToArray(string) {
	  return hasUnicode(string)
	    ? unicodeToArray(string)
	    : asciiToArray(string);
	}
	
	module.exports = stringToArray;


/***/ }),
/* 1408 */
/***/ (function(module, exports) {

	/**
	 * Converts an ASCII `string` to an array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the converted array.
	 */
	function asciiToArray(string) {
	  return string.split('');
	}
	
	module.exports = asciiToArray;


/***/ }),
/* 1409 */
/***/ (function(module, exports) {

	/** Used to compose unicode character classes. */
	var rsAstralRange = '\\ud800-\\udfff',
	    rsComboMarksRange = '\\u0300-\\u036f',
	    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
	    rsComboSymbolsRange = '\\u20d0-\\u20ff',
	    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
	    rsVarRange = '\\ufe0e\\ufe0f';
	
	/** Used to compose unicode capture groups. */
	var rsZWJ = '\\u200d';
	
	/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
	var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');
	
	/**
	 * Checks if `string` contains Unicode symbols.
	 *
	 * @private
	 * @param {string} string The string to inspect.
	 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
	 */
	function hasUnicode(string) {
	  return reHasUnicode.test(string);
	}
	
	module.exports = hasUnicode;


/***/ }),
/* 1410 */
/***/ (function(module, exports) {

	/** Used to compose unicode character classes. */
	var rsAstralRange = '\\ud800-\\udfff',
	    rsComboMarksRange = '\\u0300-\\u036f',
	    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
	    rsComboSymbolsRange = '\\u20d0-\\u20ff',
	    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
	    rsVarRange = '\\ufe0e\\ufe0f';
	
	/** Used to compose unicode capture groups. */
	var rsAstral = '[' + rsAstralRange + ']',
	    rsCombo = '[' + rsComboRange + ']',
	    rsFitz = '\\ud83c[\\udffb-\\udfff]',
	    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
	    rsNonAstral = '[^' + rsAstralRange + ']',
	    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
	    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
	    rsZWJ = '\\u200d';
	
	/** Used to compose unicode regexes. */
	var reOptMod = rsModifier + '?',
	    rsOptVar = '[' + rsVarRange + ']?',
	    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
	    rsSeq = rsOptVar + reOptMod + rsOptJoin,
	    rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';
	
	/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
	var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');
	
	/**
	 * Converts a Unicode `string` to an array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the converted array.
	 */
	function unicodeToArray(string) {
	  return string.match(reUnicode) || [];
	}
	
	module.exports = unicodeToArray;


/***/ }),
/* 1411 */
/***/ (function(module, exports, __webpack_require__) {

	var baseRest = __webpack_require__(811),
	    eq = __webpack_require__(739),
	    isIterateeCall = __webpack_require__(819),
	    keysIn = __webpack_require__(804);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Assigns own and inherited enumerable string keyed properties of source
	 * objects to the destination object for all destination properties that
	 * resolve to `undefined`. Source objects are applied from left to right.
	 * Once a property is set, additional values of the same property are ignored.
	 *
	 * **Note:** This method mutates `object`.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The destination object.
	 * @param {...Object} [sources] The source objects.
	 * @returns {Object} Returns `object`.
	 * @see _.defaultsDeep
	 * @example
	 *
	 * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	 * // => { 'a': 1, 'b': 2 }
	 */
	var defaults = baseRest(function(object, sources) {
	  object = Object(object);
	
	  var index = -1;
	  var length = sources.length;
	  var guard = length > 2 ? sources[2] : undefined;
	
	  if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	    length = 1;
	  }
	
	  while (++index < length) {
	    var source = sources[index];
	    var props = keysIn(source);
	    var propsIndex = -1;
	    var propsLength = props.length;
	
	    while (++propsIndex < propsLength) {
	      var key = props[propsIndex];
	      var value = object[key];
	
	      if (value === undefined ||
	          (eq(value, objectProto[key]) && !hasOwnProperty.call(object, key))) {
	        object[key] = source[key];
	      }
	    }
	  }
	
	  return object;
	});
	
	module.exports = defaults;


/***/ }),
/* 1412 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var map = __webpack_require__(1377);
	var isArray = __webpack_require__(789);
	var isNumber = __webpack_require__(1396);
	var isString = __webpack_require__(1399);
	function valToNumber(v) {
	  if (isNumber(v)) {
	    return v;
	  } else if (isString(v)) {
	    return parseFloat(v);
	  } else if (isArray(v)) {
	    return map(v, valToNumber);
	  }
	
	  throw new Error('The value should be a number, a parseable string or an array of those.');
	}
	
	module.exports = valToNumber;


/***/ }),
/* 1413 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var forEach = __webpack_require__(1374);
	var filter = __webpack_require__(1375);
	var map = __webpack_require__(1377);
	var isEmpty = __webpack_require__(1397);
	var indexOf = __webpack_require__(1392);
	
	function filterState(state, filters) {
	  var partialState = {};
	  var attributeFilters = filter(filters, function(f) { return f.indexOf('attribute:') !== -1; });
	  var attributes = map(attributeFilters, function(aF) { return aF.split(':')[1]; });
	
	  if (indexOf(attributes, '*') === -1) {
	    forEach(attributes, function(attr) {
	      if (state.isConjunctiveFacet(attr) && state.isFacetRefined(attr)) {
	        if (!partialState.facetsRefinements) partialState.facetsRefinements = {};
	        partialState.facetsRefinements[attr] = state.facetsRefinements[attr];
	      }
	
	      if (state.isDisjunctiveFacet(attr) && state.isDisjunctiveFacetRefined(attr)) {
	        if (!partialState.disjunctiveFacetsRefinements) partialState.disjunctiveFacetsRefinements = {};
	        partialState.disjunctiveFacetsRefinements[attr] = state.disjunctiveFacetsRefinements[attr];
	      }
	
	      if (state.isHierarchicalFacet(attr) && state.isHierarchicalFacetRefined(attr)) {
	        if (!partialState.hierarchicalFacetsRefinements) partialState.hierarchicalFacetsRefinements = {};
	        partialState.hierarchicalFacetsRefinements[attr] = state.hierarchicalFacetsRefinements[attr];
	      }
	
	      var numericRefinements = state.getNumericRefinements(attr);
	      if (!isEmpty(numericRefinements)) {
	        if (!partialState.numericRefinements) partialState.numericRefinements = {};
	        partialState.numericRefinements[attr] = state.numericRefinements[attr];
	      }
	    });
	  } else {
	    if (!isEmpty(state.numericRefinements)) {
	      partialState.numericRefinements = state.numericRefinements;
	    }
	    if (!isEmpty(state.facetsRefinements)) partialState.facetsRefinements = state.facetsRefinements;
	    if (!isEmpty(state.disjunctiveFacetsRefinements)) {
	      partialState.disjunctiveFacetsRefinements = state.disjunctiveFacetsRefinements;
	    }
	    if (!isEmpty(state.hierarchicalFacetsRefinements)) {
	      partialState.hierarchicalFacetsRefinements = state.hierarchicalFacetsRefinements;
	    }
	  }
	
	  var searchParameters = filter(
	    filters,
	    function(f) {
	      return f.indexOf('attribute:') === -1;
	    }
	  );
	
	  forEach(
	    searchParameters,
	    function(parameterKey) {
	      partialState[parameterKey] = state[parameterKey];
	    }
	  );
	
	  return partialState;
	}
	
	module.exports = filterState;


/***/ }),
/* 1414 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Functions to manipulate refinement lists
	 *
	 * The RefinementList is not formally defined through a prototype but is based
	 * on a specific structure.
	 *
	 * @module SearchParameters.refinementList
	 *
	 * @typedef {string[]} SearchParameters.refinementList.Refinements
	 * @typedef {Object.<string, SearchParameters.refinementList.Refinements>} SearchParameters.refinementList.RefinementList
	 */
	
	var isUndefined = __webpack_require__(1398);
	var isString = __webpack_require__(1399);
	var isFunction = __webpack_require__(751);
	var isEmpty = __webpack_require__(1397);
	var defaults = __webpack_require__(1411);
	
	var reduce = __webpack_require__(1379);
	var filter = __webpack_require__(1375);
	var omit = __webpack_require__(1382);
	
	var lib = {
	  /**
	   * Adds a refinement to a RefinementList
	   * @param {RefinementList} refinementList the initial list
	   * @param {string} attribute the attribute to refine
	   * @param {string} value the value of the refinement, if the value is not a string it will be converted
	   * @return {RefinementList} a new and updated prefinement list
	   */
	  addRefinement: function addRefinement(refinementList, attribute, value) {
	    if (lib.isRefined(refinementList, attribute, value)) {
	      return refinementList;
	    }
	
	    var valueAsString = '' + value;
	
	    var facetRefinement = !refinementList[attribute] ?
	      [valueAsString] :
	      refinementList[attribute].concat(valueAsString);
	
	    var mod = {};
	
	    mod[attribute] = facetRefinement;
	
	    return defaults({}, mod, refinementList);
	  },
	  /**
	   * Removes refinement(s) for an attribute:
	   *  - if the value is specified removes the refinement for the value on the attribute
	   *  - if no value is specified removes all the refinements for this attribute
	   * @param {RefinementList} refinementList the initial list
	   * @param {string} attribute the attribute to refine
	   * @param {string} [value] the value of the refinement
	   * @return {RefinementList} a new and updated refinement lst
	   */
	  removeRefinement: function removeRefinement(refinementList, attribute, value) {
	    if (isUndefined(value)) {
	      return lib.clearRefinement(refinementList, attribute);
	    }
	
	    var valueAsString = '' + value;
	
	    return lib.clearRefinement(refinementList, function(v, f) {
	      return attribute === f && valueAsString === v;
	    });
	  },
	  /**
	   * Toggles the refinement value for an attribute.
	   * @param {RefinementList} refinementList the initial list
	   * @param {string} attribute the attribute to refine
	   * @param {string} value the value of the refinement
	   * @return {RefinementList} a new and updated list
	   */
	  toggleRefinement: function toggleRefinement(refinementList, attribute, value) {
	    if (isUndefined(value)) throw new Error('toggleRefinement should be used with a value');
	
	    if (lib.isRefined(refinementList, attribute, value)) {
	      return lib.removeRefinement(refinementList, attribute, value);
	    }
	
	    return lib.addRefinement(refinementList, attribute, value);
	  },
	  /**
	   * Clear all or parts of a RefinementList. Depending on the arguments, three
	   * behaviors can happen:
	   *  - if no attribute is provided: clears the whole list
	   *  - if an attribute is provided as a string: clears the list for the specific attribute
	   *  - if an attribute is provided as a function: discards the elements for which the function returns true
	   * @param {RefinementList} refinementList the initial list
	   * @param {string} [attribute] the attribute or function to discard
	   * @param {string} [refinementType] optionnal parameter to give more context to the attribute function
	   * @return {RefinementList} a new and updated refinement list
	   */
	  clearRefinement: function clearRefinement(refinementList, attribute, refinementType) {
	    if (isUndefined(attribute)) {
	      return {};
	    } else if (isString(attribute)) {
	      return omit(refinementList, attribute);
	    } else if (isFunction(attribute)) {
	      return reduce(refinementList, function(memo, values, key) {
	        var facetList = filter(values, function(value) {
	          return !attribute(value, key, refinementType);
	        });
	
	        if (!isEmpty(facetList)) memo[key] = facetList;
	
	        return memo;
	      }, {});
	    }
	  },
	  /**
	   * Test if the refinement value is used for the attribute. If no refinement value
	   * is provided, test if the refinementList contains any refinement for the
	   * given attribute.
	   * @param {RefinementList} refinementList the list of refinement
	   * @param {string} attribute name of the attribute
	   * @param {string} [refinementValue] value of the filter/refinement
	   * @return {boolean}
	   */
	  isRefined: function isRefined(refinementList, attribute, refinementValue) {
	    var indexOf = __webpack_require__(1392);
	
	    var containsRefinements = !!refinementList[attribute] &&
	      refinementList[attribute].length > 0;
	
	    if (isUndefined(refinementValue) || !containsRefinements) {
	      return containsRefinements;
	    }
	
	    var refinementValueAsString = '' + refinementValue;
	
	    return indexOf(refinementList[attribute], refinementValueAsString) !== -1;
	  }
	};
	
	module.exports = lib;


/***/ }),
/* 1415 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var forEach = __webpack_require__(1374);
	var compact = __webpack_require__(1416);
	var indexOf = __webpack_require__(1392);
	var findIndex = __webpack_require__(1402);
	var get = __webpack_require__(1004);
	
	var sumBy = __webpack_require__(1417);
	var find = __webpack_require__(1400);
	var includes = __webpack_require__(1419);
	var map = __webpack_require__(1377);
	var orderBy = __webpack_require__(1420);
	
	var defaults = __webpack_require__(1411);
	var merge = __webpack_require__(732);
	
	var isArray = __webpack_require__(789);
	var isFunction = __webpack_require__(751);
	
	var partial = __webpack_require__(1425);
	var partialRight = __webpack_require__(1457);
	
	var formatSort = __webpack_require__(1458);
	
	var generateHierarchicalTree = __webpack_require__(1461);
	
	/**
	 * @typedef SearchResults.Facet
	 * @type {object}
	 * @property {string} name name of the attribute in the record
	 * @property {object} data the facetting data: value, number of entries
	 * @property {object} stats undefined unless facet_stats is retrieved from algolia
	 */
	
	/**
	 * @typedef SearchResults.HierarchicalFacet
	 * @type {object}
	 * @property {string} name name of the current value given the hierarchical level, trimmed.
	 * If root node, you get the facet name
	 * @property {number} count number of objets matching this hierarchical value
	 * @property {string} path the current hierarchical value full path
	 * @property {boolean} isRefined `true` if the current value was refined, `false` otherwise
	 * @property {HierarchicalFacet[]} data sub values for the current level
	 */
	
	/**
	 * @typedef SearchResults.FacetValue
	 * @type {object}
	 * @property {string} value the facet value itself
	 * @property {number} count times this facet appears in the results
	 * @property {boolean} isRefined is the facet currently selected
	 * @property {boolean} isExcluded is the facet currently excluded (only for conjunctive facets)
	 */
	
	/**
	 * @typedef Refinement
	 * @type {object}
	 * @property {string} type the type of filter used:
	 * `numeric`, `facet`, `exclude`, `disjunctive`, `hierarchical`
	 * @property {string} attributeName name of the attribute used for filtering
	 * @property {string} name the value of the filter
	 * @property {number} numericValue the value as a number. Only for numeric fitlers.
	 * @property {string} operator the operator used. Only for numeric filters.
	 * @property {number} count the number of computed hits for this filter. Only on facets.
	 * @property {boolean} exhaustive if the count is exhaustive
	 */
	
	function getIndices(obj) {
	  var indices = {};
	
	  forEach(obj, function(val, idx) { indices[val] = idx; });
	
	  return indices;
	}
	
	function assignFacetStats(dest, facetStats, key) {
	  if (facetStats && facetStats[key]) {
	    dest.stats = facetStats[key];
	  }
	}
	
	function findMatchingHierarchicalFacetFromAttributeName(hierarchicalFacets, hierarchicalAttributeName) {
	  return find(
	    hierarchicalFacets,
	    function facetKeyMatchesAttribute(hierarchicalFacet) {
	      return includes(hierarchicalFacet.attributes, hierarchicalAttributeName);
	    }
	  );
	}
	
	/*eslint-disable */
	/**
	 * Constructor for SearchResults
	 * @class
	 * @classdesc SearchResults contains the results of a query to Algolia using the
	 * {@link AlgoliaSearchHelper}.
	 * @param {SearchParameters} state state that led to the response
	 * @param {object} algoliaResponse the response from algolia client
	 * @example <caption>SearchResults of the first query in
	 * <a href="http://demos.algolia.com/instant-search-demo">the instant search demo</a></caption>
	{
	   "hitsPerPage": 10,
	   "processingTimeMS": 2,
	   "facets": [
	      {
	         "name": "type",
	         "data": {
	            "HardGood": 6627,
	            "BlackTie": 550,
	            "Music": 665,
	            "Software": 131,
	            "Game": 456,
	            "Movie": 1571
	         },
	         "exhaustive": false
	      },
	      {
	         "exhaustive": false,
	         "data": {
	            "Free shipping": 5507
	         },
	         "name": "shipping"
	      }
	  ],
	   "hits": [
	      {
	         "thumbnailImage": "http://img.bbystatic.com/BestBuy_US/images/products/1688/1688832_54x108_s.gif",
	         "_highlightResult": {
	            "shortDescription": {
	               "matchLevel": "none",
	               "value": "Safeguard your PC, Mac, Android and iOS devices with comprehensive Internet protection",
	               "matchedWords": []
	            },
	            "category": {
	               "matchLevel": "none",
	               "value": "Computer Security Software",
	               "matchedWords": []
	            },
	            "manufacturer": {
	               "matchedWords": [],
	               "value": "Webroot",
	               "matchLevel": "none"
	            },
	            "name": {
	               "value": "Webroot SecureAnywhere Internet Security (3-Device) (1-Year Subscription) - Mac/Windows",
	               "matchedWords": [],
	               "matchLevel": "none"
	            }
	         },
	         "image": "http://img.bbystatic.com/BestBuy_US/images/products/1688/1688832_105x210_sc.jpg",
	         "shipping": "Free shipping",
	         "bestSellingRank": 4,
	         "shortDescription": "Safeguard your PC, Mac, Android and iOS devices with comprehensive Internet protection",
	         "url": "http://www.bestbuy.com/site/webroot-secureanywhere-internet-security-3-devi…d=1219060687969&skuId=1688832&cmp=RMX&ky=2d3GfEmNIzjA0vkzveHdZEBgpPCyMnLTJ",
	         "name": "Webroot SecureAnywhere Internet Security (3-Device) (1-Year Subscription) - Mac/Windows",
	         "category": "Computer Security Software",
	         "salePrice_range": "1 - 50",
	         "objectID": "1688832",
	         "type": "Software",
	         "customerReviewCount": 5980,
	         "salePrice": 49.99,
	         "manufacturer": "Webroot"
	      },
	      ....
	  ],
	   "nbHits": 10000,
	   "disjunctiveFacets": [
	      {
	         "exhaustive": false,
	         "data": {
	            "5": 183,
	            "12": 112,
	            "7": 149,
	            ...
	         },
	         "name": "customerReviewCount",
	         "stats": {
	            "max": 7461,
	            "avg": 157.939,
	            "min": 1
	         }
	      },
	      {
	         "data": {
	            "Printer Ink": 142,
	            "Wireless Speakers": 60,
	            "Point & Shoot Cameras": 48,
	            ...
	         },
	         "name": "category",
	         "exhaustive": false
	      },
	      {
	         "exhaustive": false,
	         "data": {
	            "> 5000": 2,
	            "1 - 50": 6524,
	            "501 - 2000": 566,
	            "201 - 500": 1501,
	            "101 - 200": 1360,
	            "2001 - 5000": 47
	         },
	         "name": "salePrice_range"
	      },
	      {
	         "data": {
	            "Dynex™": 202,
	            "Insignia™": 230,
	            "PNY": 72,
	            ...
	         },
	         "name": "manufacturer",
	         "exhaustive": false
	      }
	  ],
	   "query": "",
	   "nbPages": 100,
	   "page": 0,
	   "index": "bestbuy"
	}
	 **/
	/*eslint-enable */
	function SearchResults(state, algoliaResponse) {
	  var mainSubResponse = algoliaResponse.results[0];
	
	  /**
	   * query used to generate the results
	   * @member {string}
	   */
	  this.query = mainSubResponse.query;
	  /**
	   * The query as parsed by the engine given all the rules.
	   * @member {string}
	   */
	  this.parsedQuery = mainSubResponse.parsedQuery;
	  /**
	   * all the records that match the search parameters. Each record is
	   * augmented with a new attribute `_highlightResult`
	   * which is an object keyed by attribute and with the following properties:
	   *  - `value` : the value of the facet highlighted (html)
	   *  - `matchLevel`: full, partial or none depending on how the query terms match
	   * @member {object[]}
	   */
	  this.hits = mainSubResponse.hits;
	  /**
	   * index where the results come from
	   * @member {string}
	   */
	  this.index = mainSubResponse.index;
	  /**
	   * number of hits per page requested
	   * @member {number}
	   */
	  this.hitsPerPage = mainSubResponse.hitsPerPage;
	  /**
	   * total number of hits of this query on the index
	   * @member {number}
	   */
	  this.nbHits = mainSubResponse.nbHits;
	  /**
	   * total number of pages with respect to the number of hits per page and the total number of hits
	   * @member {number}
	   */
	  this.nbPages = mainSubResponse.nbPages;
	  /**
	   * current page
	   * @member {number}
	   */
	  this.page = mainSubResponse.page;
	  /**
	   * sum of the processing time of all the queries
	   * @member {number}
	   */
	  this.processingTimeMS = sumBy(algoliaResponse.results, 'processingTimeMS');
	  /**
	   * The position if the position was guessed by IP.
	   * @member {string}
	   * @example "48.8637,2.3615",
	   */
	  this.aroundLatLng = mainSubResponse.aroundLatLng;
	  /**
	   * The radius computed by Algolia.
	   * @member {string}
	   * @example "126792922",
	   */
	  this.automaticRadius = mainSubResponse.automaticRadius;
	  /**
	   * String identifying the server used to serve this request.
	   * @member {string}
	   * @example "c7-use-2.algolia.net",
	   */
	  this.serverUsed = mainSubResponse.serverUsed;
	  /**
	   * Boolean that indicates if the computation of the counts did time out.
	   * @member {boolean}
	   */
	  this.timeoutCounts = mainSubResponse.timeoutCounts;
	  /**
	   * Boolean that indicates if the computation of the hits did time out.
	   * @member {boolean}
	   */
	  this.timeoutHits = mainSubResponse.timeoutHits;
	
	  /**
	   * disjunctive facets results
	   * @member {SearchResults.Facet[]}
	   */
	  this.disjunctiveFacets = [];
	  /**
	   * disjunctive facets results
	   * @member {SearchResults.HierarchicalFacet[]}
	   */
	  this.hierarchicalFacets = map(state.hierarchicalFacets, function initFutureTree() {
	    return [];
	  });
	  /**
	   * other facets results
	   * @member {SearchResults.Facet[]}
	   */
	  this.facets = [];
	
	  var disjunctiveFacets = state.getRefinedDisjunctiveFacets();
	
	  var facetsIndices = getIndices(state.facets);
	  var disjunctiveFacetsIndices = getIndices(state.disjunctiveFacets);
	  var nextDisjunctiveResult = 1;
	
	  var self = this;
	  // Since we send request only for disjunctive facets that have been refined,
	  // we get the facets informations from the first, general, response.
	  forEach(mainSubResponse.facets, function(facetValueObject, facetKey) {
	    var hierarchicalFacet = findMatchingHierarchicalFacetFromAttributeName(
	      state.hierarchicalFacets,
	      facetKey
	    );
	
	    if (hierarchicalFacet) {
	      // Place the hierarchicalFacet data at the correct index depending on
	      // the attributes order that was defined at the helper initialization
	      var facetIndex = hierarchicalFacet.attributes.indexOf(facetKey);
	      var idxAttributeName = findIndex(state.hierarchicalFacets, {name: hierarchicalFacet.name});
	      self.hierarchicalFacets[idxAttributeName][facetIndex] = {
	        attribute: facetKey,
	        data: facetValueObject,
	        exhaustive: mainSubResponse.exhaustiveFacetsCount
	      };
	    } else {
	      var isFacetDisjunctive = indexOf(state.disjunctiveFacets, facetKey) !== -1;
	      var isFacetConjunctive = indexOf(state.facets, facetKey) !== -1;
	      var position;
	
	      if (isFacetDisjunctive) {
	        position = disjunctiveFacetsIndices[facetKey];
	        self.disjunctiveFacets[position] = {
	          name: facetKey,
	          data: facetValueObject,
	          exhaustive: mainSubResponse.exhaustiveFacetsCount
	        };
	        assignFacetStats(self.disjunctiveFacets[position], mainSubResponse.facets_stats, facetKey);
	      }
	      if (isFacetConjunctive) {
	        position = facetsIndices[facetKey];
	        self.facets[position] = {
	          name: facetKey,
	          data: facetValueObject,
	          exhaustive: mainSubResponse.exhaustiveFacetsCount
	        };
	        assignFacetStats(self.facets[position], mainSubResponse.facets_stats, facetKey);
	      }
	    }
	  });
	
	  // Make sure we do not keep holes within the hierarchical facets
	  this.hierarchicalFacets = compact(this.hierarchicalFacets);
	
	  // aggregate the refined disjunctive facets
	  forEach(disjunctiveFacets, function(disjunctiveFacet) {
	    var result = algoliaResponse.results[nextDisjunctiveResult];
	    var hierarchicalFacet = state.getHierarchicalFacetByName(disjunctiveFacet);
	
	    // There should be only item in facets.
	    forEach(result.facets, function(facetResults, dfacet) {
	      var position;
	
	      if (hierarchicalFacet) {
	        position = findIndex(state.hierarchicalFacets, {name: hierarchicalFacet.name});
	        var attributeIndex = findIndex(self.hierarchicalFacets[position], {attribute: dfacet});
	
	        // previous refinements and no results so not able to find it
	        if (attributeIndex === -1) {
	          return;
	        }
	
	        self.hierarchicalFacets[position][attributeIndex].data = merge(
	          {},
	          self.hierarchicalFacets[position][attributeIndex].data,
	          facetResults
	        );
	      } else {
	        position = disjunctiveFacetsIndices[dfacet];
	
	        var dataFromMainRequest = mainSubResponse.facets && mainSubResponse.facets[dfacet] || {};
	
	        self.disjunctiveFacets[position] = {
	          name: dfacet,
	          data: defaults({}, facetResults, dataFromMainRequest),
	          exhaustive: result.exhaustiveFacetsCount
	        };
	        assignFacetStats(self.disjunctiveFacets[position], result.facets_stats, dfacet);
	
	        if (state.disjunctiveFacetsRefinements[dfacet]) {
	          forEach(state.disjunctiveFacetsRefinements[dfacet], function(refinementValue) {
	            // add the disjunctive refinements if it is no more retrieved
	            if (!self.disjunctiveFacets[position].data[refinementValue] &&
	              indexOf(state.disjunctiveFacetsRefinements[dfacet], refinementValue) > -1) {
	              self.disjunctiveFacets[position].data[refinementValue] = 0;
	            }
	          });
	        }
	      }
	    });
	    nextDisjunctiveResult++;
	  });
	
	  // if we have some root level values for hierarchical facets, merge them
	  forEach(state.getRefinedHierarchicalFacets(), function(refinedFacet) {
	    var hierarchicalFacet = state.getHierarchicalFacetByName(refinedFacet);
	    var separator = state._getHierarchicalFacetSeparator(hierarchicalFacet);
	
	    var currentRefinement = state.getHierarchicalRefinement(refinedFacet);
	    // if we are already at a root refinement (or no refinement at all), there is no
	    // root level values request
	    if (currentRefinement.length === 0 || currentRefinement[0].split(separator).length < 2) {
	      return;
	    }
	
	    var result = algoliaResponse.results[nextDisjunctiveResult];
	
	    forEach(result.facets, function(facetResults, dfacet) {
	      var position = findIndex(state.hierarchicalFacets, {name: hierarchicalFacet.name});
	      var attributeIndex = findIndex(self.hierarchicalFacets[position], {attribute: dfacet});
	
	      // previous refinements and no results so not able to find it
	      if (attributeIndex === -1) {
	        return;
	      }
	
	      // when we always get root levels, if the hits refinement is `beers > IPA` (count: 5),
	      // then the disjunctive values will be `beers` (count: 100),
	      // but we do not want to display
	      //   | beers (100)
	      //     > IPA (5)
	      // We want
	      //   | beers (5)
	      //     > IPA (5)
	      var defaultData = {};
	
	      if (currentRefinement.length > 0) {
	        var root = currentRefinement[0].split(separator)[0];
	        defaultData[root] = self.hierarchicalFacets[position][attributeIndex].data[root];
	      }
	
	      self.hierarchicalFacets[position][attributeIndex].data = defaults(
	        defaultData,
	        facetResults,
	        self.hierarchicalFacets[position][attributeIndex].data
	      );
	    });
	
	    nextDisjunctiveResult++;
	  });
	
	  // add the excludes
	  forEach(state.facetsExcludes, function(excludes, facetName) {
	    var position = facetsIndices[facetName];
	
	    self.facets[position] = {
	      name: facetName,
	      data: mainSubResponse.facets[facetName],
	      exhaustive: mainSubResponse.exhaustiveFacetsCount
	    };
	    forEach(excludes, function(facetValue) {
	      self.facets[position] = self.facets[position] || {name: facetName};
	      self.facets[position].data = self.facets[position].data || {};
	      self.facets[position].data[facetValue] = 0;
	    });
	  });
	
	  this.hierarchicalFacets = map(this.hierarchicalFacets, generateHierarchicalTree(state));
	
	  this.facets = compact(this.facets);
	  this.disjunctiveFacets = compact(this.disjunctiveFacets);
	
	  this._state = state;
	}
	
	/**
	 * Get a facet object with its name
	 * @deprecated
	 * @param {string} name name of the attribute facetted
	 * @return {SearchResults.Facet} the facet object
	 */
	SearchResults.prototype.getFacetByName = function(name) {
	  var predicate = {name: name};
	
	  return find(this.facets, predicate) ||
	    find(this.disjunctiveFacets, predicate) ||
	    find(this.hierarchicalFacets, predicate);
	};
	
	/**
	 * Get the facet values of a specified attribute from a SearchResults object.
	 * @private
	 * @param {SearchResults} results the search results to search in
	 * @param {string} attribute name of the facetted attribute to search for
	 * @return {array|object} facet values. For the hierarchical facets it is an object.
	 */
	function extractNormalizedFacetValues(results, attribute) {
	  var predicate = {name: attribute};
	  if (results._state.isConjunctiveFacet(attribute)) {
	    var facet = find(results.facets, predicate);
	    if (!facet) return [];
	
	    return map(facet.data, function(v, k) {
	      return {
	        name: k,
	        count: v,
	        isRefined: results._state.isFacetRefined(attribute, k),
	        isExcluded: results._state.isExcludeRefined(attribute, k)
	      };
	    });
	  } else if (results._state.isDisjunctiveFacet(attribute)) {
	    var disjunctiveFacet = find(results.disjunctiveFacets, predicate);
	    if (!disjunctiveFacet) return [];
	
	    return map(disjunctiveFacet.data, function(v, k) {
	      return {
	        name: k,
	        count: v,
	        isRefined: results._state.isDisjunctiveFacetRefined(attribute, k)
	      };
	    });
	  } else if (results._state.isHierarchicalFacet(attribute)) {
	    return find(results.hierarchicalFacets, predicate);
	  }
	}
	
	/**
	 * Sort nodes of a hierarchical facet results
	 * @private
	 * @param {HierarchicalFacet} node node to upon which we want to apply the sort
	 */
	function recSort(sortFn, node) {
	  if (!node.data || node.data.length === 0) {
	    return node;
	  }
	  var children = map(node.data, partial(recSort, sortFn));
	  var sortedChildren = sortFn(children);
	  var newNode = merge({}, node, {data: sortedChildren});
	  return newNode;
	}
	
	SearchResults.DEFAULT_SORT = ['isRefined:desc', 'count:desc', 'name:asc'];
	
	function vanillaSortFn(order, data) {
	  return data.sort(order);
	}
	
	/**
	 * Get a the list of values for a given facet attribute. Those values are sorted
	 * refinement first, descending count (bigger value on top), and name ascending
	 * (alphabetical order). The sort formula can overridden using either string based
	 * predicates or a function.
	 *
	 * This method will return all the values returned by the Algolia engine plus all
	 * the values already refined. This means that it can happen that the
	 * `maxValuesPerFacet` [configuration](https://www.algolia.com/doc/rest-api/search#param-maxValuesPerFacet)
	 * might not be respected if you have facet values that are already refined.
	 * @param {string} attribute attribute name
	 * @param {object} opts configuration options.
	 * @param {Array.<string> | function} opts.sortBy
	 * When using strings, it consists of
	 * the name of the [FacetValue](#SearchResults.FacetValue) or the
	 * [HierarchicalFacet](#SearchResults.HierarchicalFacet) attributes with the
	 * order (`asc` or `desc`). For example to order the value by count, the
	 * argument would be `['count:asc']`.
	 *
	 * If only the attribute name is specified, the ordering defaults to the one
	 * specified in the default value for this attribute.
	 *
	 * When not specified, the order is
	 * ascending.  This parameter can also be a function which takes two facet
	 * values and should return a number, 0 if equal, 1 if the first argument is
	 * bigger or -1 otherwise.
	 *
	 * The default value for this attribute `['isRefined:desc', 'count:desc', 'name:asc']`
	 * @return {FacetValue[]|HierarchicalFacet} depending on the type of facet of
	 * the attribute requested (hierarchical, disjunctive or conjunctive)
	 * @example
	 * helper.on('results', function(content){
	 *   //get values ordered only by name ascending using the string predicate
	 *   content.getFacetValues('city', {sortBy: ['name:asc']);
	 *   //get values  ordered only by count ascending using a function
	 *   content.getFacetValues('city', {
	 *     // this is equivalent to ['count:asc']
	 *     sortBy: function(a, b) {
	 *       if (a.count === b.count) return 0;
	 *       if (a.count > b.count)   return 1;
	 *       if (b.count > a.count)   return -1;
	 *     }
	 *   });
	 * });
	 */
	SearchResults.prototype.getFacetValues = function(attribute, opts) {
	  var facetValues = extractNormalizedFacetValues(this, attribute);
	  if (!facetValues) throw new Error(attribute + ' is not a retrieved facet.');
	
	  var options = defaults({}, opts, {sortBy: SearchResults.DEFAULT_SORT});
	
	  if (isArray(options.sortBy)) {
	    var order = formatSort(options.sortBy, SearchResults.DEFAULT_SORT);
	    if (isArray(facetValues)) {
	      return orderBy(facetValues, order[0], order[1]);
	    }
	    // If facetValues is not an array, it's an object thus a hierarchical facet object
	    return recSort(partialRight(orderBy, order[0], order[1]), facetValues);
	  } else if (isFunction(options.sortBy)) {
	    if (isArray(facetValues)) {
	      return facetValues.sort(options.sortBy);
	    }
	    // If facetValues is not an array, it's an object thus a hierarchical facet object
	    return recSort(partial(vanillaSortFn, options.sortBy), facetValues);
	  }
	  throw new Error(
	    'options.sortBy is optional but if defined it must be ' +
	    'either an array of string (predicates) or a sorting function'
	  );
	};
	
	/**
	 * Returns the facet stats if attribute is defined and the facet contains some.
	 * Otherwise returns undefined.
	 * @param {string} attribute name of the facetted attribute
	 * @return {object} The stats of the facet
	 */
	SearchResults.prototype.getFacetStats = function(attribute) {
	  if (this._state.isConjunctiveFacet(attribute)) {
	    return getFacetStatsIfAvailable(this.facets, attribute);
	  } else if (this._state.isDisjunctiveFacet(attribute)) {
	    return getFacetStatsIfAvailable(this.disjunctiveFacets, attribute);
	  }
	
	  throw new Error(attribute + ' is not present in `facets` or `disjunctiveFacets`');
	};
	
	function getFacetStatsIfAvailable(facetList, facetName) {
	  var data = find(facetList, {name: facetName});
	  return data && data.stats;
	}
	
	/**
	 * Returns all refinements for all filters + tags. It also provides
	 * additional information: count and exhausistivity for each filter.
	 *
	 * See the [refinement type](#Refinement) for an exhaustive view of the available
	 * data.
	 *
	 * @return {Array.<Refinement>} all the refinements
	 */
	SearchResults.prototype.getRefinements = function() {
	  var state = this._state;
	  var results = this;
	  var res = [];
	
	  forEach(state.facetsRefinements, function(refinements, attributeName) {
	    forEach(refinements, function(name) {
	      res.push(getRefinement(state, 'facet', attributeName, name, results.facets));
	    });
	  });
	
	  forEach(state.facetsExcludes, function(refinements, attributeName) {
	    forEach(refinements, function(name) {
	      res.push(getRefinement(state, 'exclude', attributeName, name, results.facets));
	    });
	  });
	
	  forEach(state.disjunctiveFacetsRefinements, function(refinements, attributeName) {
	    forEach(refinements, function(name) {
	      res.push(getRefinement(state, 'disjunctive', attributeName, name, results.disjunctiveFacets));
	    });
	  });
	
	  forEach(state.hierarchicalFacetsRefinements, function(refinements, attributeName) {
	    forEach(refinements, function(name) {
	      res.push(getHierarchicalRefinement(state, attributeName, name, results.hierarchicalFacets));
	    });
	  });
	
	  forEach(state.numericRefinements, function(operators, attributeName) {
	    forEach(operators, function(values, operator) {
	      forEach(values, function(value) {
	        res.push({
	          type: 'numeric',
	          attributeName: attributeName,
	          name: value,
	          numericValue: value,
	          operator: operator
	        });
	      });
	    });
	  });
	
	  forEach(state.tagRefinements, function(name) {
	    res.push({type: 'tag', attributeName: '_tags', name: name});
	  });
	
	  return res;
	};
	
	function getRefinement(state, type, attributeName, name, resultsFacets) {
	  var facet = find(resultsFacets, {name: attributeName});
	  var count = get(facet, 'data[' + name + ']');
	  var exhaustive = get(facet, 'exhaustive');
	  return {
	    type: type,
	    attributeName: attributeName,
	    name: name,
	    count: count || 0,
	    exhaustive: exhaustive || false
	  };
	}
	
	function getHierarchicalRefinement(state, attributeName, name, resultsFacets) {
	  var facet = find(resultsFacets, {name: attributeName});
	  var facetDeclaration = state.getHierarchicalFacetByName(attributeName);
	  var splitted = name.split(facetDeclaration.separator);
	  var configuredName = splitted[splitted.length - 1];
	  for (var i = 0; facet !== undefined && i < splitted.length; ++i) {
	    facet = find(facet.data, {name: splitted[i]});
	  }
	  var count = get(facet, 'count');
	  var exhaustive = get(facet, 'exhaustive');
	  return {
	    type: 'hierarchical',
	    attributeName: attributeName,
	    name: configuredName,
	    count: count || 0,
	    exhaustive: exhaustive || false
	  };
	}
	
	module.exports = SearchResults;


/***/ }),
/* 1416 */
/***/ (function(module, exports) {

	/**
	 * Creates an array with all falsey values removed. The values `false`, `null`,
	 * `0`, `""`, `undefined`, and `NaN` are falsey.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Array
	 * @param {Array} array The array to compact.
	 * @returns {Array} Returns the new array of filtered values.
	 * @example
	 *
	 * _.compact([0, 1, false, 2, '', 3]);
	 * // => [1, 2, 3]
	 */
	function compact(array) {
	  var index = -1,
	      length = array == null ? 0 : array.length,
	      resIndex = 0,
	      result = [];
	
	  while (++index < length) {
	    var value = array[index];
	    if (value) {
	      result[resIndex++] = value;
	    }
	  }
	  return result;
	}
	
	module.exports = compact;


/***/ }),
/* 1417 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIteratee = __webpack_require__(997),
	    baseSum = __webpack_require__(1418);
	
	/**
	 * This method is like `_.sum` except that it accepts `iteratee` which is
	 * invoked for each element in `array` to generate the value to be summed.
	 * The iteratee is invoked with one argument: (value).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Math
	 * @param {Array} array The array to iterate over.
	 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	 * @returns {number} Returns the sum.
	 * @example
	 *
	 * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
	 *
	 * _.sumBy(objects, function(o) { return o.n; });
	 * // => 20
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.sumBy(objects, 'n');
	 * // => 20
	 */
	function sumBy(array, iteratee) {
	  return (array && array.length)
	    ? baseSum(array, baseIteratee(iteratee, 2))
	    : 0;
	}
	
	module.exports = sumBy;


/***/ }),
/* 1418 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.sum` and `_.sumBy` without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {number} Returns the sum.
	 */
	function baseSum(array, iteratee) {
	  var result,
	      index = -1,
	      length = array.length;
	
	  while (++index < length) {
	    var current = iteratee(array[index]);
	    if (current !== undefined) {
	      result = result === undefined ? current : (result + current);
	    }
	  }
	  return result;
	}
	
	module.exports = baseSum;


/***/ }),
/* 1419 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIndexOf = __webpack_require__(1366),
	    isArrayLike = __webpack_require__(791),
	    isString = __webpack_require__(1399),
	    toInteger = __webpack_require__(1393),
	    values = __webpack_require__(1214);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * Checks if `value` is in `collection`. If `collection` is a string, it's
	 * checked for a substring of `value`, otherwise
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * is used for equality comparisons. If `fromIndex` is negative, it's used as
	 * the offset from the end of `collection`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object|string} collection The collection to inspect.
	 * @param {*} value The value to search for.
	 * @param {number} [fromIndex=0] The index to search from.
	 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
	 * @returns {boolean} Returns `true` if `value` is found, else `false`.
	 * @example
	 *
	 * _.includes([1, 2, 3], 1);
	 * // => true
	 *
	 * _.includes([1, 2, 3], 1, 2);
	 * // => false
	 *
	 * _.includes({ 'a': 1, 'b': 2 }, 1);
	 * // => true
	 *
	 * _.includes('abcd', 'bc');
	 * // => true
	 */
	function includes(collection, value, fromIndex, guard) {
	  collection = isArrayLike(collection) ? collection : values(collection);
	  fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;
	
	  var length = collection.length;
	  if (fromIndex < 0) {
	    fromIndex = nativeMax(length + fromIndex, 0);
	  }
	  return isString(collection)
	    ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
	    : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
	}
	
	module.exports = includes;


/***/ }),
/* 1420 */
/***/ (function(module, exports, __webpack_require__) {

	var baseOrderBy = __webpack_require__(1421),
	    isArray = __webpack_require__(789);
	
	/**
	 * This method is like `_.sortBy` except that it allows specifying the sort
	 * orders of the iteratees to sort by. If `orders` is unspecified, all values
	 * are sorted in ascending order. Otherwise, specify an order of "desc" for
	 * descending or "asc" for ascending sort order of corresponding values.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
	 *  The iteratees to sort by.
	 * @param {string[]} [orders] The sort orders of `iteratees`.
	 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
	 * @returns {Array} Returns the new sorted array.
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'fred',   'age': 48 },
	 *   { 'user': 'barney', 'age': 34 },
	 *   { 'user': 'fred',   'age': 40 },
	 *   { 'user': 'barney', 'age': 36 }
	 * ];
	 *
	 * // Sort by `user` in ascending order and by `age` in descending order.
	 * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
	 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
	 */
	function orderBy(collection, iteratees, orders, guard) {
	  if (collection == null) {
	    return [];
	  }
	  if (!isArray(iteratees)) {
	    iteratees = iteratees == null ? [] : [iteratees];
	  }
	  orders = guard ? undefined : orders;
	  if (!isArray(orders)) {
	    orders = orders == null ? [] : [orders];
	  }
	  return baseOrderBy(collection, iteratees, orders);
	}
	
	module.exports = orderBy;


/***/ }),
/* 1421 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__(1013),
	    baseGet = __webpack_require__(1005),
	    baseIteratee = __webpack_require__(997),
	    baseMap = __webpack_require__(1378),
	    baseSortBy = __webpack_require__(1422),
	    baseUnary = __webpack_require__(798),
	    compareMultiple = __webpack_require__(1423),
	    identity = __webpack_require__(812),
	    isArray = __webpack_require__(789);
	
	/**
	 * The base implementation of `_.orderBy` without param guards.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
	 * @param {string[]} orders The sort orders of `iteratees`.
	 * @returns {Array} Returns the new sorted array.
	 */
	function baseOrderBy(collection, iteratees, orders) {
	  if (iteratees.length) {
	    iteratees = arrayMap(iteratees, function(iteratee) {
	      if (isArray(iteratee)) {
	        return function(value) {
	          return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
	        }
	      }
	      return iteratee;
	    });
	  } else {
	    iteratees = [identity];
	  }
	
	  var index = -1;
	  iteratees = arrayMap(iteratees, baseUnary(baseIteratee));
	
	  var result = baseMap(collection, function(value, key, collection) {
	    var criteria = arrayMap(iteratees, function(iteratee) {
	      return iteratee(value);
	    });
	    return { 'criteria': criteria, 'index': ++index, 'value': value };
	  });
	
	  return baseSortBy(result, function(object, other) {
	    return compareMultiple(object, other, orders);
	  });
	}
	
	module.exports = baseOrderBy;


/***/ }),
/* 1422 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.sortBy` which uses `comparer` to define the
	 * sort order of `array` and replaces criteria objects with their corresponding
	 * values.
	 *
	 * @private
	 * @param {Array} array The array to sort.
	 * @param {Function} comparer The function to define sort order.
	 * @returns {Array} Returns `array`.
	 */
	function baseSortBy(array, comparer) {
	  var length = array.length;
	
	  array.sort(comparer);
	  while (length--) {
	    array[length] = array[length].value;
	  }
	  return array;
	}
	
	module.exports = baseSortBy;


/***/ }),
/* 1423 */
/***/ (function(module, exports, __webpack_require__) {

	var compareAscending = __webpack_require__(1424);
	
	/**
	 * Used by `_.orderBy` to compare multiple properties of a value to another
	 * and stable sort them.
	 *
	 * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
	 * specify an order of "desc" for descending or "asc" for ascending sort order
	 * of corresponding values.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {boolean[]|string[]} orders The order to sort by for each property.
	 * @returns {number} Returns the sort order indicator for `object`.
	 */
	function compareMultiple(object, other, orders) {
	  var index = -1,
	      objCriteria = object.criteria,
	      othCriteria = other.criteria,
	      length = objCriteria.length,
	      ordersLength = orders.length;
	
	  while (++index < length) {
	    var result = compareAscending(objCriteria[index], othCriteria[index]);
	    if (result) {
	      if (index >= ordersLength) {
	        return result;
	      }
	      var order = orders[index];
	      return result * (order == 'desc' ? -1 : 1);
	    }
	  }
	  // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
	  // that causes it, under certain circumstances, to provide the same value for
	  // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
	  // for more details.
	  //
	  // This also ensures a stable sort in V8 and other engines.
	  // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
	  return object.index - other.index;
	}
	
	module.exports = compareMultiple;


/***/ }),
/* 1424 */
/***/ (function(module, exports, __webpack_require__) {

	var isSymbol = __webpack_require__(650);
	
	/**
	 * Compares values to sort them in ascending order.
	 *
	 * @private
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {number} Returns the sort order indicator for `value`.
	 */
	function compareAscending(value, other) {
	  if (value !== other) {
	    var valIsDefined = value !== undefined,
	        valIsNull = value === null,
	        valIsReflexive = value === value,
	        valIsSymbol = isSymbol(value);
	
	    var othIsDefined = other !== undefined,
	        othIsNull = other === null,
	        othIsReflexive = other === other,
	        othIsSymbol = isSymbol(other);
	
	    if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
	        (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
	        (valIsNull && othIsDefined && othIsReflexive) ||
	        (!valIsDefined && othIsReflexive) ||
	        !valIsReflexive) {
	      return 1;
	    }
	    if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
	        (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
	        (othIsNull && valIsDefined && valIsReflexive) ||
	        (!othIsDefined && valIsReflexive) ||
	        !othIsReflexive) {
	      return -1;
	    }
	  }
	  return 0;
	}
	
	module.exports = compareAscending;


/***/ }),
/* 1425 */
/***/ (function(module, exports, __webpack_require__) {

	var baseRest = __webpack_require__(811),
	    createWrap = __webpack_require__(1426),
	    getHolder = __webpack_require__(1452),
	    replaceHolders = __webpack_require__(1454);
	
	/** Used to compose bitmasks for function metadata. */
	var WRAP_PARTIAL_FLAG = 32;
	
	/**
	 * Creates a function that invokes `func` with `partials` prepended to the
	 * arguments it receives. This method is like `_.bind` except it does **not**
	 * alter the `this` binding.
	 *
	 * The `_.partial.placeholder` value, which defaults to `_` in monolithic
	 * builds, may be used as a placeholder for partially applied arguments.
	 *
	 * **Note:** This method doesn't set the "length" property of partially
	 * applied functions.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.2.0
	 * @category Function
	 * @param {Function} func The function to partially apply arguments to.
	 * @param {...*} [partials] The arguments to be partially applied.
	 * @returns {Function} Returns the new partially applied function.
	 * @example
	 *
	 * function greet(greeting, name) {
	 *   return greeting + ' ' + name;
	 * }
	 *
	 * var sayHelloTo = _.partial(greet, 'hello');
	 * sayHelloTo('fred');
	 * // => 'hello fred'
	 *
	 * // Partially applied with placeholders.
	 * var greetFred = _.partial(greet, _, 'fred');
	 * greetFred('hi');
	 * // => 'hi fred'
	 */
	var partial = baseRest(function(func, partials) {
	  var holders = replaceHolders(partials, getHolder(partial));
	  return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
	});
	
	// Assign default placeholders.
	partial.placeholder = {};
	
	module.exports = partial;


/***/ }),
/* 1426 */
/***/ (function(module, exports, __webpack_require__) {

	var baseSetData = __webpack_require__(1427),
	    createBind = __webpack_require__(1429),
	    createCurry = __webpack_require__(1431),
	    createHybrid = __webpack_require__(1432),
	    createPartial = __webpack_require__(1455),
	    getData = __webpack_require__(1440),
	    mergeData = __webpack_require__(1456),
	    setData = __webpack_require__(1447),
	    setWrapToString = __webpack_require__(1448),
	    toInteger = __webpack_require__(1393);
	
	/** Error message constants. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/** Used to compose bitmasks for function metadata. */
	var WRAP_BIND_FLAG = 1,
	    WRAP_BIND_KEY_FLAG = 2,
	    WRAP_CURRY_FLAG = 8,
	    WRAP_CURRY_RIGHT_FLAG = 16,
	    WRAP_PARTIAL_FLAG = 32,
	    WRAP_PARTIAL_RIGHT_FLAG = 64;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * Creates a function that either curries or invokes `func` with optional
	 * `this` binding and partially applied arguments.
	 *
	 * @private
	 * @param {Function|string} func The function or method name to wrap.
	 * @param {number} bitmask The bitmask flags.
	 *    1 - `_.bind`
	 *    2 - `_.bindKey`
	 *    4 - `_.curry` or `_.curryRight` of a bound function
	 *    8 - `_.curry`
	 *   16 - `_.curryRight`
	 *   32 - `_.partial`
	 *   64 - `_.partialRight`
	 *  128 - `_.rearg`
	 *  256 - `_.ary`
	 *  512 - `_.flip`
	 * @param {*} [thisArg] The `this` binding of `func`.
	 * @param {Array} [partials] The arguments to be partially applied.
	 * @param {Array} [holders] The `partials` placeholder indexes.
	 * @param {Array} [argPos] The argument positions of the new function.
	 * @param {number} [ary] The arity cap of `func`.
	 * @param {number} [arity] The arity of `func`.
	 * @returns {Function} Returns the new wrapped function.
	 */
	function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
	  var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
	  if (!isBindKey && typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  var length = partials ? partials.length : 0;
	  if (!length) {
	    bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
	    partials = holders = undefined;
	  }
	  ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
	  arity = arity === undefined ? arity : toInteger(arity);
	  length -= holders ? holders.length : 0;
	
	  if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
	    var partialsRight = partials,
	        holdersRight = holders;
	
	    partials = holders = undefined;
	  }
	  var data = isBindKey ? undefined : getData(func);
	
	  var newData = [
	    func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
	    argPos, ary, arity
	  ];
	
	  if (data) {
	    mergeData(newData, data);
	  }
	  func = newData[0];
	  bitmask = newData[1];
	  thisArg = newData[2];
	  partials = newData[3];
	  holders = newData[4];
	  arity = newData[9] = newData[9] === undefined
	    ? (isBindKey ? 0 : func.length)
	    : nativeMax(newData[9] - length, 0);
	
	  if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
	    bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
	  }
	  if (!bitmask || bitmask == WRAP_BIND_FLAG) {
	    var result = createBind(func, bitmask, thisArg);
	  } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
	    result = createCurry(func, bitmask, arity);
	  } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
	    result = createPartial(func, bitmask, thisArg, partials);
	  } else {
	    result = createHybrid.apply(undefined, newData);
	  }
	  var setter = data ? baseSetData : setData;
	  return setWrapToString(setter(result, newData), func, bitmask);
	}
	
	module.exports = createWrap;


/***/ }),
/* 1427 */
/***/ (function(module, exports, __webpack_require__) {

	var identity = __webpack_require__(812),
	    metaMap = __webpack_require__(1428);
	
	/**
	 * The base implementation of `setData` without support for hot loop shorting.
	 *
	 * @private
	 * @param {Function} func The function to associate metadata with.
	 * @param {*} data The metadata.
	 * @returns {Function} Returns `func`.
	 */
	var baseSetData = !metaMap ? identity : function(func, data) {
	  metaMap.set(func, data);
	  return func;
	};
	
	module.exports = baseSetData;


/***/ }),
/* 1428 */
/***/ (function(module, exports, __webpack_require__) {

	var WeakMap = __webpack_require__(947);
	
	/** Used to store function metadata. */
	var metaMap = WeakMap && new WeakMap;
	
	module.exports = metaMap;


/***/ }),
/* 1429 */
/***/ (function(module, exports, __webpack_require__) {

	var createCtor = __webpack_require__(1430),
	    root = __webpack_require__(645);
	
	/** Used to compose bitmasks for function metadata. */
	var WRAP_BIND_FLAG = 1;
	
	/**
	 * Creates a function that wraps `func` to invoke it with the optional `this`
	 * binding of `thisArg`.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	 * @param {*} [thisArg] The `this` binding of `func`.
	 * @returns {Function} Returns the new wrapped function.
	 */
	function createBind(func, bitmask, thisArg) {
	  var isBind = bitmask & WRAP_BIND_FLAG,
	      Ctor = createCtor(func);
	
	  function wrapper() {
	    var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	    return fn.apply(isBind ? thisArg : this, arguments);
	  }
	  return wrapper;
	}
	
	module.exports = createBind;


/***/ }),
/* 1430 */
/***/ (function(module, exports, __webpack_require__) {

	var baseCreate = __webpack_require__(783),
	    isObject = __webpack_require__(643);
	
	/**
	 * Creates a function that produces an instance of `Ctor` regardless of
	 * whether it was invoked as part of a `new` expression or by `call` or `apply`.
	 *
	 * @private
	 * @param {Function} Ctor The constructor to wrap.
	 * @returns {Function} Returns the new wrapped function.
	 */
	function createCtor(Ctor) {
	  return function() {
	    // Use a `switch` statement to work with class constructors. See
	    // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
	    // for more details.
	    var args = arguments;
	    switch (args.length) {
	      case 0: return new Ctor;
	      case 1: return new Ctor(args[0]);
	      case 2: return new Ctor(args[0], args[1]);
	      case 3: return new Ctor(args[0], args[1], args[2]);
	      case 4: return new Ctor(args[0], args[1], args[2], args[3]);
	      case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
	      case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
	      case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
	    }
	    var thisBinding = baseCreate(Ctor.prototype),
	        result = Ctor.apply(thisBinding, args);
	
	    // Mimic the constructor's `return` behavior.
	    // See https://es5.github.io/#x13.2.2 for more details.
	    return isObject(result) ? result : thisBinding;
	  };
	}
	
	module.exports = createCtor;


/***/ }),
/* 1431 */
/***/ (function(module, exports, __webpack_require__) {

	var apply = __webpack_require__(814),
	    createCtor = __webpack_require__(1430),
	    createHybrid = __webpack_require__(1432),
	    createRecurry = __webpack_require__(1436),
	    getHolder = __webpack_require__(1452),
	    replaceHolders = __webpack_require__(1454),
	    root = __webpack_require__(645);
	
	/**
	 * Creates a function that wraps `func` to enable currying.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	 * @param {number} arity The arity of `func`.
	 * @returns {Function} Returns the new wrapped function.
	 */
	function createCurry(func, bitmask, arity) {
	  var Ctor = createCtor(func);
	
	  function wrapper() {
	    var length = arguments.length,
	        args = Array(length),
	        index = length,
	        placeholder = getHolder(wrapper);
	
	    while (index--) {
	      args[index] = arguments[index];
	    }
	    var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
	      ? []
	      : replaceHolders(args, placeholder);
	
	    length -= holders.length;
	    if (length < arity) {
	      return createRecurry(
	        func, bitmask, createHybrid, wrapper.placeholder, undefined,
	        args, holders, undefined, undefined, arity - length);
	    }
	    var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	    return apply(fn, this, args);
	  }
	  return wrapper;
	}
	
	module.exports = createCurry;


/***/ }),
/* 1432 */
/***/ (function(module, exports, __webpack_require__) {

	var composeArgs = __webpack_require__(1433),
	    composeArgsRight = __webpack_require__(1434),
	    countHolders = __webpack_require__(1435),
	    createCtor = __webpack_require__(1430),
	    createRecurry = __webpack_require__(1436),
	    getHolder = __webpack_require__(1452),
	    reorder = __webpack_require__(1453),
	    replaceHolders = __webpack_require__(1454),
	    root = __webpack_require__(645);
	
	/** Used to compose bitmasks for function metadata. */
	var WRAP_BIND_FLAG = 1,
	    WRAP_BIND_KEY_FLAG = 2,
	    WRAP_CURRY_FLAG = 8,
	    WRAP_CURRY_RIGHT_FLAG = 16,
	    WRAP_ARY_FLAG = 128,
	    WRAP_FLIP_FLAG = 512;
	
	/**
	 * Creates a function that wraps `func` to invoke it with optional `this`
	 * binding of `thisArg`, partial application, and currying.
	 *
	 * @private
	 * @param {Function|string} func The function or method name to wrap.
	 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	 * @param {*} [thisArg] The `this` binding of `func`.
	 * @param {Array} [partials] The arguments to prepend to those provided to
	 *  the new function.
	 * @param {Array} [holders] The `partials` placeholder indexes.
	 * @param {Array} [partialsRight] The arguments to append to those provided
	 *  to the new function.
	 * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
	 * @param {Array} [argPos] The argument positions of the new function.
	 * @param {number} [ary] The arity cap of `func`.
	 * @param {number} [arity] The arity of `func`.
	 * @returns {Function} Returns the new wrapped function.
	 */
	function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
	  var isAry = bitmask & WRAP_ARY_FLAG,
	      isBind = bitmask & WRAP_BIND_FLAG,
	      isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
	      isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
	      isFlip = bitmask & WRAP_FLIP_FLAG,
	      Ctor = isBindKey ? undefined : createCtor(func);
	
	  function wrapper() {
	    var length = arguments.length,
	        args = Array(length),
	        index = length;
	
	    while (index--) {
	      args[index] = arguments[index];
	    }
	    if (isCurried) {
	      var placeholder = getHolder(wrapper),
	          holdersCount = countHolders(args, placeholder);
	    }
	    if (partials) {
	      args = composeArgs(args, partials, holders, isCurried);
	    }
	    if (partialsRight) {
	      args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
	    }
	    length -= holdersCount;
	    if (isCurried && length < arity) {
	      var newHolders = replaceHolders(args, placeholder);
	      return createRecurry(
	        func, bitmask, createHybrid, wrapper.placeholder, thisArg,
	        args, newHolders, argPos, ary, arity - length
	      );
	    }
	    var thisBinding = isBind ? thisArg : this,
	        fn = isBindKey ? thisBinding[func] : func;
	
	    length = args.length;
	    if (argPos) {
	      args = reorder(args, argPos);
	    } else if (isFlip && length > 1) {
	      args.reverse();
	    }
	    if (isAry && ary < length) {
	      args.length = ary;
	    }
	    if (this && this !== root && this instanceof wrapper) {
	      fn = Ctor || createCtor(fn);
	    }
	    return fn.apply(thisBinding, args);
	  }
	  return wrapper;
	}
	
	module.exports = createHybrid;


/***/ }),
/* 1433 */
/***/ (function(module, exports) {

	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * Creates an array that is the composition of partially applied arguments,
	 * placeholders, and provided arguments into a single array of arguments.
	 *
	 * @private
	 * @param {Array} args The provided arguments.
	 * @param {Array} partials The arguments to prepend to those provided.
	 * @param {Array} holders The `partials` placeholder indexes.
	 * @params {boolean} [isCurried] Specify composing for a curried function.
	 * @returns {Array} Returns the new array of composed arguments.
	 */
	function composeArgs(args, partials, holders, isCurried) {
	  var argsIndex = -1,
	      argsLength = args.length,
	      holdersLength = holders.length,
	      leftIndex = -1,
	      leftLength = partials.length,
	      rangeLength = nativeMax(argsLength - holdersLength, 0),
	      result = Array(leftLength + rangeLength),
	      isUncurried = !isCurried;
	
	  while (++leftIndex < leftLength) {
	    result[leftIndex] = partials[leftIndex];
	  }
	  while (++argsIndex < holdersLength) {
	    if (isUncurried || argsIndex < argsLength) {
	      result[holders[argsIndex]] = args[argsIndex];
	    }
	  }
	  while (rangeLength--) {
	    result[leftIndex++] = args[argsIndex++];
	  }
	  return result;
	}
	
	module.exports = composeArgs;


/***/ }),
/* 1434 */
/***/ (function(module, exports) {

	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * This function is like `composeArgs` except that the arguments composition
	 * is tailored for `_.partialRight`.
	 *
	 * @private
	 * @param {Array} args The provided arguments.
	 * @param {Array} partials The arguments to append to those provided.
	 * @param {Array} holders The `partials` placeholder indexes.
	 * @params {boolean} [isCurried] Specify composing for a curried function.
	 * @returns {Array} Returns the new array of composed arguments.
	 */
	function composeArgsRight(args, partials, holders, isCurried) {
	  var argsIndex = -1,
	      argsLength = args.length,
	      holdersIndex = -1,
	      holdersLength = holders.length,
	      rightIndex = -1,
	      rightLength = partials.length,
	      rangeLength = nativeMax(argsLength - holdersLength, 0),
	      result = Array(rangeLength + rightLength),
	      isUncurried = !isCurried;
	
	  while (++argsIndex < rangeLength) {
	    result[argsIndex] = args[argsIndex];
	  }
	  var offset = argsIndex;
	  while (++rightIndex < rightLength) {
	    result[offset + rightIndex] = partials[rightIndex];
	  }
	  while (++holdersIndex < holdersLength) {
	    if (isUncurried || argsIndex < argsLength) {
	      result[offset + holders[holdersIndex]] = args[argsIndex++];
	    }
	  }
	  return result;
	}
	
	module.exports = composeArgsRight;


/***/ }),
/* 1435 */
/***/ (function(module, exports) {

	/**
	 * Gets the number of `placeholder` occurrences in `array`.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} placeholder The placeholder to search for.
	 * @returns {number} Returns the placeholder count.
	 */
	function countHolders(array, placeholder) {
	  var length = array.length,
	      result = 0;
	
	  while (length--) {
	    if (array[length] === placeholder) {
	      ++result;
	    }
	  }
	  return result;
	}
	
	module.exports = countHolders;


/***/ }),
/* 1436 */
/***/ (function(module, exports, __webpack_require__) {

	var isLaziable = __webpack_require__(1437),
	    setData = __webpack_require__(1447),
	    setWrapToString = __webpack_require__(1448);
	
	/** Used to compose bitmasks for function metadata. */
	var WRAP_BIND_FLAG = 1,
	    WRAP_BIND_KEY_FLAG = 2,
	    WRAP_CURRY_BOUND_FLAG = 4,
	    WRAP_CURRY_FLAG = 8,
	    WRAP_PARTIAL_FLAG = 32,
	    WRAP_PARTIAL_RIGHT_FLAG = 64;
	
	/**
	 * Creates a function that wraps `func` to continue currying.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	 * @param {Function} wrapFunc The function to create the `func` wrapper.
	 * @param {*} placeholder The placeholder value.
	 * @param {*} [thisArg] The `this` binding of `func`.
	 * @param {Array} [partials] The arguments to prepend to those provided to
	 *  the new function.
	 * @param {Array} [holders] The `partials` placeholder indexes.
	 * @param {Array} [argPos] The argument positions of the new function.
	 * @param {number} [ary] The arity cap of `func`.
	 * @param {number} [arity] The arity of `func`.
	 * @returns {Function} Returns the new wrapped function.
	 */
	function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
	  var isCurry = bitmask & WRAP_CURRY_FLAG,
	      newHolders = isCurry ? holders : undefined,
	      newHoldersRight = isCurry ? undefined : holders,
	      newPartials = isCurry ? partials : undefined,
	      newPartialsRight = isCurry ? undefined : partials;
	
	  bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
	  bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
	
	  if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
	    bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
	  }
	  var newData = [
	    func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
	    newHoldersRight, argPos, ary, arity
	  ];
	
	  var result = wrapFunc.apply(undefined, newData);
	  if (isLaziable(func)) {
	    setData(result, newData);
	  }
	  result.placeholder = placeholder;
	  return setWrapToString(result, func, bitmask);
	}
	
	module.exports = createRecurry;


/***/ }),
/* 1437 */
/***/ (function(module, exports, __webpack_require__) {

	var LazyWrapper = __webpack_require__(1438),
	    getData = __webpack_require__(1440),
	    getFuncName = __webpack_require__(1442),
	    lodash = __webpack_require__(1444);
	
	/**
	 * Checks if `func` has a lazy counterpart.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
	 *  else `false`.
	 */
	function isLaziable(func) {
	  var funcName = getFuncName(func),
	      other = lodash[funcName];
	
	  if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
	    return false;
	  }
	  if (func === other) {
	    return true;
	  }
	  var data = getData(other);
	  return !!data && func === data[0];
	}
	
	module.exports = isLaziable;


/***/ }),
/* 1438 */
/***/ (function(module, exports, __webpack_require__) {

	var baseCreate = __webpack_require__(783),
	    baseLodash = __webpack_require__(1439);
	
	/** Used as references for the maximum length and index of an array. */
	var MAX_ARRAY_LENGTH = 4294967295;
	
	/**
	 * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
	 *
	 * @private
	 * @constructor
	 * @param {*} value The value to wrap.
	 */
	function LazyWrapper(value) {
	  this.__wrapped__ = value;
	  this.__actions__ = [];
	  this.__dir__ = 1;
	  this.__filtered__ = false;
	  this.__iteratees__ = [];
	  this.__takeCount__ = MAX_ARRAY_LENGTH;
	  this.__views__ = [];
	}
	
	// Ensure `LazyWrapper` is an instance of `baseLodash`.
	LazyWrapper.prototype = baseCreate(baseLodash.prototype);
	LazyWrapper.prototype.constructor = LazyWrapper;
	
	module.exports = LazyWrapper;


/***/ }),
/* 1439 */
/***/ (function(module, exports) {

	/**
	 * The function whose prototype chain sequence wrappers inherit from.
	 *
	 * @private
	 */
	function baseLodash() {
	  // No operation performed.
	}
	
	module.exports = baseLodash;


/***/ }),
/* 1440 */
/***/ (function(module, exports, __webpack_require__) {

	var metaMap = __webpack_require__(1428),
	    noop = __webpack_require__(1441);
	
	/**
	 * Gets metadata for `func`.
	 *
	 * @private
	 * @param {Function} func The function to query.
	 * @returns {*} Returns the metadata for `func`.
	 */
	var getData = !metaMap ? noop : function(func) {
	  return metaMap.get(func);
	};
	
	module.exports = getData;


/***/ }),
/* 1441 */
/***/ (function(module, exports) {

	/**
	 * This method returns `undefined`.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.3.0
	 * @category Util
	 * @example
	 *
	 * _.times(2, _.noop);
	 * // => [undefined, undefined]
	 */
	function noop() {
	  // No operation performed.
	}
	
	module.exports = noop;


/***/ }),
/* 1442 */
/***/ (function(module, exports, __webpack_require__) {

	var realNames = __webpack_require__(1443);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Gets the name of `func`.
	 *
	 * @private
	 * @param {Function} func The function to query.
	 * @returns {string} Returns the function name.
	 */
	function getFuncName(func) {
	  var result = (func.name + ''),
	      array = realNames[result],
	      length = hasOwnProperty.call(realNames, result) ? array.length : 0;
	
	  while (length--) {
	    var data = array[length],
	        otherFunc = data.func;
	    if (otherFunc == null || otherFunc == func) {
	      return data.name;
	    }
	  }
	  return result;
	}
	
	module.exports = getFuncName;


/***/ }),
/* 1443 */
/***/ (function(module, exports) {

	/** Used to lookup unminified function names. */
	var realNames = {};
	
	module.exports = realNames;


/***/ }),
/* 1444 */
/***/ (function(module, exports, __webpack_require__) {

	var LazyWrapper = __webpack_require__(1438),
	    LodashWrapper = __webpack_require__(1445),
	    baseLodash = __webpack_require__(1439),
	    isArray = __webpack_require__(789),
	    isObjectLike = __webpack_require__(655),
	    wrapperClone = __webpack_require__(1446);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Creates a `lodash` object which wraps `value` to enable implicit method
	 * chain sequences. Methods that operate on and return arrays, collections,
	 * and functions can be chained together. Methods that retrieve a single value
	 * or may return a primitive value will automatically end the chain sequence
	 * and return the unwrapped value. Otherwise, the value must be unwrapped
	 * with `_#value`.
	 *
	 * Explicit chain sequences, which must be unwrapped with `_#value`, may be
	 * enabled using `_.chain`.
	 *
	 * The execution of chained methods is lazy, that is, it's deferred until
	 * `_#value` is implicitly or explicitly called.
	 *
	 * Lazy evaluation allows several methods to support shortcut fusion.
	 * Shortcut fusion is an optimization to merge iteratee calls; this avoids
	 * the creation of intermediate arrays and can greatly reduce the number of
	 * iteratee executions. Sections of a chain sequence qualify for shortcut
	 * fusion if the section is applied to an array and iteratees accept only
	 * one argument. The heuristic for whether a section qualifies for shortcut
	 * fusion is subject to change.
	 *
	 * Chaining is supported in custom builds as long as the `_#value` method is
	 * directly or indirectly included in the build.
	 *
	 * In addition to lodash methods, wrappers have `Array` and `String` methods.
	 *
	 * The wrapper `Array` methods are:
	 * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
	 *
	 * The wrapper `String` methods are:
	 * `replace` and `split`
	 *
	 * The wrapper methods that support shortcut fusion are:
	 * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
	 * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
	 * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
	 *
	 * The chainable wrapper methods are:
	 * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
	 * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
	 * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
	 * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
	 * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
	 * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
	 * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
	 * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
	 * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
	 * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
	 * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
	 * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
	 * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
	 * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
	 * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
	 * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
	 * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
	 * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
	 * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
	 * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
	 * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
	 * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
	 * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
	 * `zipObject`, `zipObjectDeep`, and `zipWith`
	 *
	 * The wrapper methods that are **not** chainable by default are:
	 * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
	 * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
	 * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
	 * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
	 * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
	 * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
	 * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
	 * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
	 * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
	 * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
	 * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
	 * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
	 * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
	 * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
	 * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
	 * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
	 * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
	 * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
	 * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
	 * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
	 * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
	 * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
	 * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
	 * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
	 * `upperFirst`, `value`, and `words`
	 *
	 * @name _
	 * @constructor
	 * @category Seq
	 * @param {*} value The value to wrap in a `lodash` instance.
	 * @returns {Object} Returns the new `lodash` wrapper instance.
	 * @example
	 *
	 * function square(n) {
	 *   return n * n;
	 * }
	 *
	 * var wrapped = _([1, 2, 3]);
	 *
	 * // Returns an unwrapped value.
	 * wrapped.reduce(_.add);
	 * // => 6
	 *
	 * // Returns a wrapped value.
	 * var squares = wrapped.map(square);
	 *
	 * _.isArray(squares);
	 * // => false
	 *
	 * _.isArray(squares.value());
	 * // => true
	 */
	function lodash(value) {
	  if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
	    if (value instanceof LodashWrapper) {
	      return value;
	    }
	    if (hasOwnProperty.call(value, '__wrapped__')) {
	      return wrapperClone(value);
	    }
	  }
	  return new LodashWrapper(value);
	}
	
	// Ensure wrappers are instances of `baseLodash`.
	lodash.prototype = baseLodash.prototype;
	lodash.prototype.constructor = lodash;
	
	module.exports = lodash;


/***/ }),
/* 1445 */
/***/ (function(module, exports, __webpack_require__) {

	var baseCreate = __webpack_require__(783),
	    baseLodash = __webpack_require__(1439);
	
	/**
	 * The base constructor for creating `lodash` wrapper objects.
	 *
	 * @private
	 * @param {*} value The value to wrap.
	 * @param {boolean} [chainAll] Enable explicit method chain sequences.
	 */
	function LodashWrapper(value, chainAll) {
	  this.__wrapped__ = value;
	  this.__actions__ = [];
	  this.__chain__ = !!chainAll;
	  this.__index__ = 0;
	  this.__values__ = undefined;
	}
	
	LodashWrapper.prototype = baseCreate(baseLodash.prototype);
	LodashWrapper.prototype.constructor = LodashWrapper;
	
	module.exports = LodashWrapper;


/***/ }),
/* 1446 */
/***/ (function(module, exports, __webpack_require__) {

	var LazyWrapper = __webpack_require__(1438),
	    LodashWrapper = __webpack_require__(1445),
	    copyArray = __webpack_require__(781);
	
	/**
	 * Creates a clone of `wrapper`.
	 *
	 * @private
	 * @param {Object} wrapper The wrapper to clone.
	 * @returns {Object} Returns the cloned wrapper.
	 */
	function wrapperClone(wrapper) {
	  if (wrapper instanceof LazyWrapper) {
	    return wrapper.clone();
	  }
	  var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
	  result.__actions__ = copyArray(wrapper.__actions__);
	  result.__index__  = wrapper.__index__;
	  result.__values__ = wrapper.__values__;
	  return result;
	}
	
	module.exports = wrapperClone;


/***/ }),
/* 1447 */
/***/ (function(module, exports, __webpack_require__) {

	var baseSetData = __webpack_require__(1427),
	    shortOut = __webpack_require__(818);
	
	/**
	 * Sets metadata for `func`.
	 *
	 * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
	 * period of time, it will trip its breaker and transition to an identity
	 * function to avoid garbage collection pauses in V8. See
	 * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
	 * for more details.
	 *
	 * @private
	 * @param {Function} func The function to associate metadata with.
	 * @param {*} data The metadata.
	 * @returns {Function} Returns `func`.
	 */
	var setData = shortOut(baseSetData);
	
	module.exports = setData;


/***/ }),
/* 1448 */
/***/ (function(module, exports, __webpack_require__) {

	var getWrapDetails = __webpack_require__(1449),
	    insertWrapDetails = __webpack_require__(1450),
	    setToString = __webpack_require__(815),
	    updateWrapDetails = __webpack_require__(1451);
	
	/**
	 * Sets the `toString` method of `wrapper` to mimic the source of `reference`
	 * with wrapper details in a comment at the top of the source body.
	 *
	 * @private
	 * @param {Function} wrapper The function to modify.
	 * @param {Function} reference The reference function.
	 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	 * @returns {Function} Returns `wrapper`.
	 */
	function setWrapToString(wrapper, reference, bitmask) {
	  var source = (reference + '');
	  return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
	}
	
	module.exports = setWrapToString;


/***/ }),
/* 1449 */
/***/ (function(module, exports) {

	/** Used to match wrap detail comments. */
	var reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
	    reSplitDetails = /,? & /;
	
	/**
	 * Extracts wrapper details from the `source` body comment.
	 *
	 * @private
	 * @param {string} source The source to inspect.
	 * @returns {Array} Returns the wrapper details.
	 */
	function getWrapDetails(source) {
	  var match = source.match(reWrapDetails);
	  return match ? match[1].split(reSplitDetails) : [];
	}
	
	module.exports = getWrapDetails;


/***/ }),
/* 1450 */
/***/ (function(module, exports) {

	/** Used to match wrap detail comments. */
	var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/;
	
	/**
	 * Inserts wrapper `details` in a comment at the top of the `source` body.
	 *
	 * @private
	 * @param {string} source The source to modify.
	 * @returns {Array} details The details to insert.
	 * @returns {string} Returns the modified source.
	 */
	function insertWrapDetails(source, details) {
	  var length = details.length;
	  if (!length) {
	    return source;
	  }
	  var lastIndex = length - 1;
	  details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
	  details = details.join(length > 2 ? ', ' : ' ');
	  return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
	}
	
	module.exports = insertWrapDetails;


/***/ }),
/* 1451 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayEach = __webpack_require__(1191),
	    arrayIncludes = __webpack_require__(1365);
	
	/** Used to compose bitmasks for function metadata. */
	var WRAP_BIND_FLAG = 1,
	    WRAP_BIND_KEY_FLAG = 2,
	    WRAP_CURRY_FLAG = 8,
	    WRAP_CURRY_RIGHT_FLAG = 16,
	    WRAP_PARTIAL_FLAG = 32,
	    WRAP_PARTIAL_RIGHT_FLAG = 64,
	    WRAP_ARY_FLAG = 128,
	    WRAP_REARG_FLAG = 256,
	    WRAP_FLIP_FLAG = 512;
	
	/** Used to associate wrap methods with their bit flags. */
	var wrapFlags = [
	  ['ary', WRAP_ARY_FLAG],
	  ['bind', WRAP_BIND_FLAG],
	  ['bindKey', WRAP_BIND_KEY_FLAG],
	  ['curry', WRAP_CURRY_FLAG],
	  ['curryRight', WRAP_CURRY_RIGHT_FLAG],
	  ['flip', WRAP_FLIP_FLAG],
	  ['partial', WRAP_PARTIAL_FLAG],
	  ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
	  ['rearg', WRAP_REARG_FLAG]
	];
	
	/**
	 * Updates wrapper `details` based on `bitmask` flags.
	 *
	 * @private
	 * @returns {Array} details The details to modify.
	 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	 * @returns {Array} Returns `details`.
	 */
	function updateWrapDetails(details, bitmask) {
	  arrayEach(wrapFlags, function(pair) {
	    var value = '_.' + pair[0];
	    if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
	      details.push(value);
	    }
	  });
	  return details.sort();
	}
	
	module.exports = updateWrapDetails;


/***/ }),
/* 1452 */
/***/ (function(module, exports) {

	/**
	 * Gets the argument placeholder value for `func`.
	 *
	 * @private
	 * @param {Function} func The function to inspect.
	 * @returns {*} Returns the placeholder value.
	 */
	function getHolder(func) {
	  var object = func;
	  return object.placeholder;
	}
	
	module.exports = getHolder;


/***/ }),
/* 1453 */
/***/ (function(module, exports, __webpack_require__) {

	var copyArray = __webpack_require__(781),
	    isIndex = __webpack_require__(807);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMin = Math.min;
	
	/**
	 * Reorder `array` according to the specified indexes where the element at
	 * the first index is assigned as the first element, the element at
	 * the second index is assigned as the second element, and so on.
	 *
	 * @private
	 * @param {Array} array The array to reorder.
	 * @param {Array} indexes The arranged array indexes.
	 * @returns {Array} Returns `array`.
	 */
	function reorder(array, indexes) {
	  var arrLength = array.length,
	      length = nativeMin(indexes.length, arrLength),
	      oldArray = copyArray(array);
	
	  while (length--) {
	    var index = indexes[length];
	    array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
	  }
	  return array;
	}
	
	module.exports = reorder;


/***/ }),
/* 1454 */
/***/ (function(module, exports) {

	/** Used as the internal argument placeholder. */
	var PLACEHOLDER = '__lodash_placeholder__';
	
	/**
	 * Replaces all `placeholder` elements in `array` with an internal placeholder
	 * and returns an array of their indexes.
	 *
	 * @private
	 * @param {Array} array The array to modify.
	 * @param {*} placeholder The placeholder to replace.
	 * @returns {Array} Returns the new array of placeholder indexes.
	 */
	function replaceHolders(array, placeholder) {
	  var index = -1,
	      length = array.length,
	      resIndex = 0,
	      result = [];
	
	  while (++index < length) {
	    var value = array[index];
	    if (value === placeholder || value === PLACEHOLDER) {
	      array[index] = PLACEHOLDER;
	      result[resIndex++] = index;
	    }
	  }
	  return result;
	}
	
	module.exports = replaceHolders;


/***/ }),
/* 1455 */
/***/ (function(module, exports, __webpack_require__) {

	var apply = __webpack_require__(814),
	    createCtor = __webpack_require__(1430),
	    root = __webpack_require__(645);
	
	/** Used to compose bitmasks for function metadata. */
	var WRAP_BIND_FLAG = 1;
	
	/**
	 * Creates a function that wraps `func` to invoke it with the `this` binding
	 * of `thisArg` and `partials` prepended to the arguments it receives.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	 * @param {*} thisArg The `this` binding of `func`.
	 * @param {Array} partials The arguments to prepend to those provided to
	 *  the new function.
	 * @returns {Function} Returns the new wrapped function.
	 */
	function createPartial(func, bitmask, thisArg, partials) {
	  var isBind = bitmask & WRAP_BIND_FLAG,
	      Ctor = createCtor(func);
	
	  function wrapper() {
	    var argsIndex = -1,
	        argsLength = arguments.length,
	        leftIndex = -1,
	        leftLength = partials.length,
	        args = Array(leftLength + argsLength),
	        fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	
	    while (++leftIndex < leftLength) {
	      args[leftIndex] = partials[leftIndex];
	    }
	    while (argsLength--) {
	      args[leftIndex++] = arguments[++argsIndex];
	    }
	    return apply(fn, isBind ? thisArg : this, args);
	  }
	  return wrapper;
	}
	
	module.exports = createPartial;


/***/ }),
/* 1456 */
/***/ (function(module, exports, __webpack_require__) {

	var composeArgs = __webpack_require__(1433),
	    composeArgsRight = __webpack_require__(1434),
	    replaceHolders = __webpack_require__(1454);
	
	/** Used as the internal argument placeholder. */
	var PLACEHOLDER = '__lodash_placeholder__';
	
	/** Used to compose bitmasks for function metadata. */
	var WRAP_BIND_FLAG = 1,
	    WRAP_BIND_KEY_FLAG = 2,
	    WRAP_CURRY_BOUND_FLAG = 4,
	    WRAP_CURRY_FLAG = 8,
	    WRAP_ARY_FLAG = 128,
	    WRAP_REARG_FLAG = 256;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMin = Math.min;
	
	/**
	 * Merges the function metadata of `source` into `data`.
	 *
	 * Merging metadata reduces the number of wrappers used to invoke a function.
	 * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
	 * may be applied regardless of execution order. Methods like `_.ary` and
	 * `_.rearg` modify function arguments, making the order in which they are
	 * executed important, preventing the merging of metadata. However, we make
	 * an exception for a safe combined case where curried functions have `_.ary`
	 * and or `_.rearg` applied.
	 *
	 * @private
	 * @param {Array} data The destination metadata.
	 * @param {Array} source The source metadata.
	 * @returns {Array} Returns `data`.
	 */
	function mergeData(data, source) {
	  var bitmask = data[1],
	      srcBitmask = source[1],
	      newBitmask = bitmask | srcBitmask,
	      isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
	
	  var isCombo =
	    ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
	    ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
	    ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));
	
	  // Exit early if metadata can't be merged.
	  if (!(isCommon || isCombo)) {
	    return data;
	  }
	  // Use source `thisArg` if available.
	  if (srcBitmask & WRAP_BIND_FLAG) {
	    data[2] = source[2];
	    // Set when currying a bound function.
	    newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
	  }
	  // Compose partial arguments.
	  var value = source[3];
	  if (value) {
	    var partials = data[3];
	    data[3] = partials ? composeArgs(partials, value, source[4]) : value;
	    data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
	  }
	  // Compose partial right arguments.
	  value = source[5];
	  if (value) {
	    partials = data[5];
	    data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
	    data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
	  }
	  // Use source `argPos` if available.
	  value = source[7];
	  if (value) {
	    data[7] = value;
	  }
	  // Use source `ary` if it's smaller.
	  if (srcBitmask & WRAP_ARY_FLAG) {
	    data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
	  }
	  // Use source `arity` if one is not provided.
	  if (data[9] == null) {
	    data[9] = source[9];
	  }
	  // Use source `func` and merge bitmasks.
	  data[0] = source[0];
	  data[1] = newBitmask;
	
	  return data;
	}
	
	module.exports = mergeData;


/***/ }),
/* 1457 */
/***/ (function(module, exports, __webpack_require__) {

	var baseRest = __webpack_require__(811),
	    createWrap = __webpack_require__(1426),
	    getHolder = __webpack_require__(1452),
	    replaceHolders = __webpack_require__(1454);
	
	/** Used to compose bitmasks for function metadata. */
	var WRAP_PARTIAL_RIGHT_FLAG = 64;
	
	/**
	 * This method is like `_.partial` except that partially applied arguments
	 * are appended to the arguments it receives.
	 *
	 * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
	 * builds, may be used as a placeholder for partially applied arguments.
	 *
	 * **Note:** This method doesn't set the "length" property of partially
	 * applied functions.
	 *
	 * @static
	 * @memberOf _
	 * @since 1.0.0
	 * @category Function
	 * @param {Function} func The function to partially apply arguments to.
	 * @param {...*} [partials] The arguments to be partially applied.
	 * @returns {Function} Returns the new partially applied function.
	 * @example
	 *
	 * function greet(greeting, name) {
	 *   return greeting + ' ' + name;
	 * }
	 *
	 * var greetFred = _.partialRight(greet, 'fred');
	 * greetFred('hi');
	 * // => 'hi fred'
	 *
	 * // Partially applied with placeholders.
	 * var sayHelloTo = _.partialRight(greet, 'hello', _);
	 * sayHelloTo('fred');
	 * // => 'hello fred'
	 */
	var partialRight = baseRest(function(func, partials) {
	  var holders = replaceHolders(partials, getHolder(partialRight));
	  return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
	});
	
	// Assign default placeholders.
	partialRight.placeholder = {};
	
	module.exports = partialRight;


/***/ }),
/* 1458 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var reduce = __webpack_require__(1379);
	var find = __webpack_require__(1400);
	var startsWith = __webpack_require__(1459);
	
	/**
	 * Transform sort format from user friendly notation to lodash format
	 * @param {string[]} sortBy array of predicate of the form "attribute:order"
	 * @return {array.<string[]>} array containing 2 elements : attributes, orders
	 */
	module.exports = function formatSort(sortBy, defaults) {
	  return reduce(sortBy, function preparePredicate(out, sortInstruction) {
	    var sortInstructions = sortInstruction.split(':');
	    if (defaults && sortInstructions.length === 1) {
	      var similarDefault = find(defaults, function(predicate) {
	        return startsWith(predicate, sortInstruction[0]);
	      });
	      if (similarDefault) {
	        sortInstructions = similarDefault.split(':');
	      }
	    }
	    out[0].push(sortInstructions[0]);
	    out[1].push(sortInstructions[1]);
	    return out;
	  }, [[], []]);
	};


/***/ }),
/* 1459 */
/***/ (function(module, exports, __webpack_require__) {

	var baseClamp = __webpack_require__(1460),
	    baseToString = __webpack_require__(1012),
	    toInteger = __webpack_require__(1393),
	    toString = __webpack_require__(1011);
	
	/**
	 * Checks if `string` starts with the given target string.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category String
	 * @param {string} [string=''] The string to inspect.
	 * @param {string} [target] The string to search for.
	 * @param {number} [position=0] The position to search from.
	 * @returns {boolean} Returns `true` if `string` starts with `target`,
	 *  else `false`.
	 * @example
	 *
	 * _.startsWith('abc', 'a');
	 * // => true
	 *
	 * _.startsWith('abc', 'b');
	 * // => false
	 *
	 * _.startsWith('abc', 'b', 1);
	 * // => true
	 */
	function startsWith(string, target, position) {
	  string = toString(string);
	  position = position == null
	    ? 0
	    : baseClamp(toInteger(position), 0, string.length);
	
	  target = baseToString(target);
	  return string.slice(position, position + target.length) == target;
	}
	
	module.exports = startsWith;


/***/ }),
/* 1460 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.clamp` which doesn't coerce arguments.
	 *
	 * @private
	 * @param {number} number The number to clamp.
	 * @param {number} [lower] The lower bound.
	 * @param {number} upper The upper bound.
	 * @returns {number} Returns the clamped number.
	 */
	function baseClamp(number, lower, upper) {
	  if (number === number) {
	    if (upper !== undefined) {
	      number = number <= upper ? number : upper;
	    }
	    if (lower !== undefined) {
	      number = number >= lower ? number : lower;
	    }
	  }
	  return number;
	}
	
	module.exports = baseClamp;


/***/ }),
/* 1461 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = generateTrees;
	
	var last = __webpack_require__(1384);
	var map = __webpack_require__(1377);
	var reduce = __webpack_require__(1379);
	var orderBy = __webpack_require__(1420);
	var trim = __webpack_require__(1403);
	var find = __webpack_require__(1400);
	var pickBy = __webpack_require__(1163);
	
	var prepareHierarchicalFacetSortBy = __webpack_require__(1458);
	
	function generateTrees(state) {
	  return function generate(hierarchicalFacetResult, hierarchicalFacetIndex) {
	    var hierarchicalFacet = state.hierarchicalFacets[hierarchicalFacetIndex];
	    var hierarchicalFacetRefinement = state.hierarchicalFacetsRefinements[hierarchicalFacet.name] &&
	      state.hierarchicalFacetsRefinements[hierarchicalFacet.name][0] || '';
	    var hierarchicalSeparator = state._getHierarchicalFacetSeparator(hierarchicalFacet);
	    var hierarchicalRootPath = state._getHierarchicalRootPath(hierarchicalFacet);
	    var hierarchicalShowParentLevel = state._getHierarchicalShowParentLevel(hierarchicalFacet);
	    var sortBy = prepareHierarchicalFacetSortBy(state._getHierarchicalFacetSortBy(hierarchicalFacet));
	
	    var generateTreeFn = generateHierarchicalTree(sortBy, hierarchicalSeparator, hierarchicalRootPath,
	      hierarchicalShowParentLevel, hierarchicalFacetRefinement);
	
	    var results = hierarchicalFacetResult;
	
	    if (hierarchicalRootPath) {
	      results = hierarchicalFacetResult.slice(hierarchicalRootPath.split(hierarchicalSeparator).length);
	    }
	
	    return reduce(results, generateTreeFn, {
	      name: state.hierarchicalFacets[hierarchicalFacetIndex].name,
	      count: null, // root level, no count
	      isRefined: true, // root level, always refined
	      path: null, // root level, no path
	      data: null
	    });
	  };
	}
	
	function generateHierarchicalTree(sortBy, hierarchicalSeparator, hierarchicalRootPath,
	                                  hierarchicalShowParentLevel, currentRefinement) {
	  return function generateTree(hierarchicalTree, hierarchicalFacetResult, currentHierarchicalLevel) {
	    var parent = hierarchicalTree;
	
	    if (currentHierarchicalLevel > 0) {
	      var level = 0;
	
	      parent = hierarchicalTree;
	
	      while (level < currentHierarchicalLevel) {
	        parent = parent && find(parent.data, {isRefined: true});
	        level++;
	      }
	    }
	
	    // we found a refined parent, let's add current level data under it
	    if (parent) {
	      // filter values in case an object has multiple categories:
	      //   {
	      //     categories: {
	      //       level0: ['beers', 'bières'],
	      //       level1: ['beers > IPA', 'bières > Belges']
	      //     }
	      //   }
	      //
	      // If parent refinement is `beers`, then we do not want to have `bières > Belges`
	      // showing up
	
	      var onlyMatchingValuesFn = filterFacetValues(parent.path || hierarchicalRootPath,
	        currentRefinement, hierarchicalSeparator, hierarchicalRootPath, hierarchicalShowParentLevel);
	
	      parent.data = orderBy(
	        map(
	          pickBy(hierarchicalFacetResult.data, onlyMatchingValuesFn),
	          formatHierarchicalFacetValue(hierarchicalSeparator, currentRefinement)
	        ),
	        sortBy[0], sortBy[1]
	      );
	    }
	
	    return hierarchicalTree;
	  };
	}
	
	function filterFacetValues(parentPath, currentRefinement, hierarchicalSeparator, hierarchicalRootPath,
	                           hierarchicalShowParentLevel) {
	  return function(facetCount, facetValue) {
	    // we want the facetValue is a child of hierarchicalRootPath
	    if (hierarchicalRootPath &&
	      (facetValue.indexOf(hierarchicalRootPath) !== 0 || hierarchicalRootPath === facetValue)) {
	      return false;
	    }
	
	    // we always want root levels (only when there is no prefix path)
	    return !hierarchicalRootPath && facetValue.indexOf(hierarchicalSeparator) === -1 ||
	      // if there is a rootPath, being root level mean 1 level under rootPath
	      hierarchicalRootPath &&
	      facetValue.split(hierarchicalSeparator).length - hierarchicalRootPath.split(hierarchicalSeparator).length === 1 ||
	      // if current refinement is a root level and current facetValue is a root level,
	      // keep the facetValue
	      facetValue.indexOf(hierarchicalSeparator) === -1 &&
	      currentRefinement.indexOf(hierarchicalSeparator) === -1 ||
	      // currentRefinement is a child of the facet value
	      currentRefinement.indexOf(facetValue) === 0 ||
	      // facetValue is a child of the current parent, add it
	      facetValue.indexOf(parentPath + hierarchicalSeparator) === 0 &&
	      (hierarchicalShowParentLevel || facetValue.indexOf(currentRefinement) === 0);
	  };
	}
	
	function formatHierarchicalFacetValue(hierarchicalSeparator, currentRefinement) {
	  return function format(facetCount, facetValue) {
	    return {
	      name: trim(last(facetValue.split(hierarchicalSeparator))),
	      path: facetValue,
	      count: facetCount,
	      isRefined: currentRefinement === facetValue || currentRefinement.indexOf(facetValue + hierarchicalSeparator) === 0,
	      data: null
	    };
	  };
	}


/***/ }),
/* 1462 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var forEach = __webpack_require__(1374);
	var map = __webpack_require__(1377);
	var reduce = __webpack_require__(1379);
	var merge = __webpack_require__(732);
	var isArray = __webpack_require__(789);
	
	var requestBuilder = {
	  /**
	   * Get all the queries to send to the client, those queries can used directly
	   * with the Algolia client.
	   * @private
	   * @return {object[]} The queries
	   */
	  _getQueries: function getQueries(index, state) {
	    var queries = [];
	
	    // One query for the hits
	    queries.push({
	      indexName: index,
	      params: requestBuilder._getHitsSearchParams(state)
	    });
	
	    // One for each disjunctive facets
	    forEach(state.getRefinedDisjunctiveFacets(), function(refinedFacet) {
	      queries.push({
	        indexName: index,
	        params: requestBuilder._getDisjunctiveFacetSearchParams(state, refinedFacet)
	      });
	    });
	
	    // maybe more to get the root level of hierarchical facets when activated
	    forEach(state.getRefinedHierarchicalFacets(), function(refinedFacet) {
	      var hierarchicalFacet = state.getHierarchicalFacetByName(refinedFacet);
	
	      var currentRefinement = state.getHierarchicalRefinement(refinedFacet);
	      // if we are deeper than level 0 (starting from `beer > IPA`)
	      // we want to get the root values
	      var separator = state._getHierarchicalFacetSeparator(hierarchicalFacet);
	      if (currentRefinement.length > 0 && currentRefinement[0].split(separator).length > 1) {
	        queries.push({
	          indexName: index,
	          params: requestBuilder._getDisjunctiveFacetSearchParams(state, refinedFacet, true)
	        });
	      }
	    });
	
	    return queries;
	  },
	
	  /**
	   * Build search parameters used to fetch hits
	   * @private
	   * @return {object.<string, any>}
	   */
	  _getHitsSearchParams: function(state) {
	    var facets = state.facets
	      .concat(state.disjunctiveFacets)
	      .concat(requestBuilder._getHitsHierarchicalFacetsAttributes(state));
	
	
	    var facetFilters = requestBuilder._getFacetFilters(state);
	    var numericFilters = requestBuilder._getNumericFilters(state);
	    var tagFilters = requestBuilder._getTagFilters(state);
	    var additionalParams = {
	      facets: facets,
	      tagFilters: tagFilters
	    };
	
	    if (facetFilters.length > 0) {
	      additionalParams.facetFilters = facetFilters;
	    }
	
	    if (numericFilters.length > 0) {
	      additionalParams.numericFilters = numericFilters;
	    }
	
	    return merge(state.getQueryParams(), additionalParams);
	  },
	
	  /**
	   * Build search parameters used to fetch a disjunctive facet
	   * @private
	   * @param  {string} facet the associated facet name
	   * @param  {boolean} hierarchicalRootLevel ?? FIXME
	   * @return {object}
	   */
	  _getDisjunctiveFacetSearchParams: function(state, facet, hierarchicalRootLevel) {
	    var facetFilters = requestBuilder._getFacetFilters(state, facet, hierarchicalRootLevel);
	    var numericFilters = requestBuilder._getNumericFilters(state, facet);
	    var tagFilters = requestBuilder._getTagFilters(state);
	    var additionalParams = {
	      hitsPerPage: 1,
	      page: 0,
	      attributesToRetrieve: [],
	      attributesToHighlight: [],
	      attributesToSnippet: [],
	      tagFilters: tagFilters
	    };
	
	    var hierarchicalFacet = state.getHierarchicalFacetByName(facet);
	
	    if (hierarchicalFacet) {
	      additionalParams.facets = requestBuilder._getDisjunctiveHierarchicalFacetAttribute(
	        state,
	        hierarchicalFacet,
	        hierarchicalRootLevel
	      );
	    } else {
	      additionalParams.facets = facet;
	    }
	
	    if (numericFilters.length > 0) {
	      additionalParams.numericFilters = numericFilters;
	    }
	
	    if (facetFilters.length > 0) {
	      additionalParams.facetFilters = facetFilters;
	    }
	
	    return merge(state.getQueryParams(), additionalParams);
	  },
	
	  /**
	   * Return the numeric filters in an algolia request fashion
	   * @private
	   * @param {string} [facetName] the name of the attribute for which the filters should be excluded
	   * @return {string[]} the numeric filters in the algolia format
	   */
	  _getNumericFilters: function(state, facetName) {
	    if (state.numericFilters) {
	      return state.numericFilters;
	    }
	
	    var numericFilters = [];
	
	    forEach(state.numericRefinements, function(operators, attribute) {
	      forEach(operators, function(values, operator) {
	        if (facetName !== attribute) {
	          forEach(values, function(value) {
	            if (isArray(value)) {
	              var vs = map(value, function(v) {
	                return attribute + operator + v;
	              });
	              numericFilters.push(vs);
	            } else {
	              numericFilters.push(attribute + operator + value);
	            }
	          });
	        }
	      });
	    });
	
	    return numericFilters;
	  },
	
	  /**
	   * Return the tags filters depending
	   * @private
	   * @return {string}
	   */
	  _getTagFilters: function(state) {
	    if (state.tagFilters) {
	      return state.tagFilters;
	    }
	
	    return state.tagRefinements.join(',');
	  },
	
	
	  /**
	   * Build facetFilters parameter based on current refinements. The array returned
	   * contains strings representing the facet filters in the algolia format.
	   * @private
	   * @param  {string} [facet] if set, the current disjunctive facet
	   * @return {array.<string>}
	   */
	  _getFacetFilters: function(state, facet, hierarchicalRootLevel) {
	    var facetFilters = [];
	
	    forEach(state.facetsRefinements, function(facetValues, facetName) {
	      forEach(facetValues, function(facetValue) {
	        facetFilters.push(facetName + ':' + facetValue);
	      });
	    });
	
	    forEach(state.facetsExcludes, function(facetValues, facetName) {
	      forEach(facetValues, function(facetValue) {
	        facetFilters.push(facetName + ':-' + facetValue);
	      });
	    });
	
	    forEach(state.disjunctiveFacetsRefinements, function(facetValues, facetName) {
	      if (facetName === facet || !facetValues || facetValues.length === 0) return;
	      var orFilters = [];
	
	      forEach(facetValues, function(facetValue) {
	        orFilters.push(facetName + ':' + facetValue);
	      });
	
	      facetFilters.push(orFilters);
	    });
	
	    forEach(state.hierarchicalFacetsRefinements, function(facetValues, facetName) {
	      var facetValue = facetValues[0];
	
	      if (facetValue === undefined) {
	        return;
	      }
	
	      var hierarchicalFacet = state.getHierarchicalFacetByName(facetName);
	      var separator = state._getHierarchicalFacetSeparator(hierarchicalFacet);
	      var rootPath = state._getHierarchicalRootPath(hierarchicalFacet);
	      var attributeToRefine;
	      var attributesIndex;
	
	      // we ask for parent facet values only when the `facet` is the current hierarchical facet
	      if (facet === facetName) {
	        // if we are at the root level already, no need to ask for facet values, we get them from
	        // the hits query
	        if (facetValue.indexOf(separator) === -1 || (!rootPath && hierarchicalRootLevel === true) ||
	          (rootPath && rootPath.split(separator).length === facetValue.split(separator).length)) {
	          return;
	        }
	
	        if (!rootPath) {
	          attributesIndex = facetValue.split(separator).length - 2;
	          facetValue = facetValue.slice(0, facetValue.lastIndexOf(separator));
	        } else {
	          attributesIndex = rootPath.split(separator).length - 1;
	          facetValue = rootPath;
	        }
	
	        attributeToRefine = hierarchicalFacet.attributes[attributesIndex];
	      } else {
	        attributesIndex = facetValue.split(separator).length - 1;
	
	        attributeToRefine = hierarchicalFacet.attributes[attributesIndex];
	      }
	
	      if (attributeToRefine) {
	        facetFilters.push([attributeToRefine + ':' + facetValue]);
	      }
	    });
	
	    return facetFilters;
	  },
	
	  _getHitsHierarchicalFacetsAttributes: function(state) {
	    var out = [];
	
	    return reduce(
	      state.hierarchicalFacets,
	      // ask for as much levels as there's hierarchical refinements
	      function getHitsAttributesForHierarchicalFacet(allAttributes, hierarchicalFacet) {
	        var hierarchicalRefinement = state.getHierarchicalRefinement(hierarchicalFacet.name)[0];
	
	        // if no refinement, ask for root level
	        if (!hierarchicalRefinement) {
	          allAttributes.push(hierarchicalFacet.attributes[0]);
	          return allAttributes;
	        }
	
	        var separator = state._getHierarchicalFacetSeparator(hierarchicalFacet);
	        var level = hierarchicalRefinement.split(separator).length;
	        var newAttributes = hierarchicalFacet.attributes.slice(0, level + 1);
	
	        return allAttributes.concat(newAttributes);
	      }, out);
	  },
	
	  _getDisjunctiveHierarchicalFacetAttribute: function(state, hierarchicalFacet, rootLevel) {
	    var separator = state._getHierarchicalFacetSeparator(hierarchicalFacet);
	    if (rootLevel === true) {
	      var rootPath = state._getHierarchicalRootPath(hierarchicalFacet);
	      var attributeIndex = 0;
	
	      if (rootPath) {
	        attributeIndex = rootPath.split(separator).length;
	      }
	      return [hierarchicalFacet.attributes[attributeIndex]];
	    }
	
	    var hierarchicalRefinement = state.getHierarchicalRefinement(hierarchicalFacet.name)[0] || '';
	    // if refinement is 'beers > IPA > Flying dog',
	    // then we want `facets: ['beers > IPA']` as disjunctive facet (parent level values)
	
	    var parentLevel = hierarchicalRefinement.split(separator).length - 1;
	    return hierarchicalFacet.attributes.slice(0, parentLevel + 1);
	  }
	};
	
	module.exports = requestBuilder;


/***/ }),
/* 1463 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	var formatRegExp = /%[sdj%]/g;
	exports.format = function(f) {
	  if (!isString(f)) {
	    var objects = [];
	    for (var i = 0; i < arguments.length; i++) {
	      objects.push(inspect(arguments[i]));
	    }
	    return objects.join(' ');
	  }
	
	  var i = 1;
	  var args = arguments;
	  var len = args.length;
	  var str = String(f).replace(formatRegExp, function(x) {
	    if (x === '%%') return '%';
	    if (i >= len) return x;
	    switch (x) {
	      case '%s': return String(args[i++]);
	      case '%d': return Number(args[i++]);
	      case '%j':
	        try {
	          return JSON.stringify(args[i++]);
	        } catch (_) {
	          return '[Circular]';
	        }
	      default:
	        return x;
	    }
	  });
	  for (var x = args[i]; i < len; x = args[++i]) {
	    if (isNull(x) || !isObject(x)) {
	      str += ' ' + x;
	    } else {
	      str += ' ' + inspect(x);
	    }
	  }
	  return str;
	};
	
	
	// Mark that a method should not be used.
	// Returns a modified function which warns once by default.
	// If --no-deprecation is set, then it is a no-op.
	exports.deprecate = function(fn, msg) {
	  // Allow for deprecating things in the process of starting up.
	  if (isUndefined(global.process)) {
	    return function() {
	      return exports.deprecate(fn, msg).apply(this, arguments);
	    };
	  }
	
	  if (process.noDeprecation === true) {
	    return fn;
	  }
	
	  var warned = false;
	  function deprecated() {
	    if (!warned) {
	      if (process.throwDeprecation) {
	        throw new Error(msg);
	      } else if (process.traceDeprecation) {
	        console.trace(msg);
	      } else {
	        console.error(msg);
	      }
	      warned = true;
	    }
	    return fn.apply(this, arguments);
	  }
	
	  return deprecated;
	};
	
	
	var debugs = {};
	var debugEnviron;
	exports.debuglog = function(set) {
	  if (isUndefined(debugEnviron))
	    debugEnviron = process.env.NODE_DEBUG || '';
	  set = set.toUpperCase();
	  if (!debugs[set]) {
	    if (new RegExp('\\b' + set + '\\b', 'i').test(debugEnviron)) {
	      var pid = process.pid;
	      debugs[set] = function() {
	        var msg = exports.format.apply(exports, arguments);
	        console.error('%s %d: %s', set, pid, msg);
	      };
	    } else {
	      debugs[set] = function() {};
	    }
	  }
	  return debugs[set];
	};
	
	
	/**
	 * Echos the value of a value. Trys to print the value out
	 * in the best way possible given the different types.
	 *
	 * @param {Object} obj The object to print out.
	 * @param {Object} opts Optional options object that alters the output.
	 */
	/* legacy: obj, showHidden, depth, colors*/
	function inspect(obj, opts) {
	  // default options
	  var ctx = {
	    seen: [],
	    stylize: stylizeNoColor
	  };
	  // legacy...
	  if (arguments.length >= 3) ctx.depth = arguments[2];
	  if (arguments.length >= 4) ctx.colors = arguments[3];
	  if (isBoolean(opts)) {
	    // legacy...
	    ctx.showHidden = opts;
	  } else if (opts) {
	    // got an "options" object
	    exports._extend(ctx, opts);
	  }
	  // set default options
	  if (isUndefined(ctx.showHidden)) ctx.showHidden = false;
	  if (isUndefined(ctx.depth)) ctx.depth = 2;
	  if (isUndefined(ctx.colors)) ctx.colors = false;
	  if (isUndefined(ctx.customInspect)) ctx.customInspect = true;
	  if (ctx.colors) ctx.stylize = stylizeWithColor;
	  return formatValue(ctx, obj, ctx.depth);
	}
	exports.inspect = inspect;
	
	
	// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
	inspect.colors = {
	  'bold' : [1, 22],
	  'italic' : [3, 23],
	  'underline' : [4, 24],
	  'inverse' : [7, 27],
	  'white' : [37, 39],
	  'grey' : [90, 39],
	  'black' : [30, 39],
	  'blue' : [34, 39],
	  'cyan' : [36, 39],
	  'green' : [32, 39],
	  'magenta' : [35, 39],
	  'red' : [31, 39],
	  'yellow' : [33, 39]
	};
	
	// Don't use 'blue' not visible on cmd.exe
	inspect.styles = {
	  'special': 'cyan',
	  'number': 'yellow',
	  'boolean': 'yellow',
	  'undefined': 'grey',
	  'null': 'bold',
	  'string': 'green',
	  'date': 'magenta',
	  // "name": intentionally not styling
	  'regexp': 'red'
	};
	
	
	function stylizeWithColor(str, styleType) {
	  var style = inspect.styles[styleType];
	
	  if (style) {
	    return '\u001b[' + inspect.colors[style][0] + 'm' + str +
	           '\u001b[' + inspect.colors[style][1] + 'm';
	  } else {
	    return str;
	  }
	}
	
	
	function stylizeNoColor(str, styleType) {
	  return str;
	}
	
	
	function arrayToHash(array) {
	  var hash = {};
	
	  array.forEach(function(val, idx) {
	    hash[val] = true;
	  });
	
	  return hash;
	}
	
	
	function formatValue(ctx, value, recurseTimes) {
	  // Provide a hook for user-specified inspect functions.
	  // Check that value is an object with an inspect function on it
	  if (ctx.customInspect &&
	      value &&
	      isFunction(value.inspect) &&
	      // Filter out the util module, it's inspect function is special
	      value.inspect !== exports.inspect &&
	      // Also filter out any prototype objects using the circular check.
	      !(value.constructor && value.constructor.prototype === value)) {
	    var ret = value.inspect(recurseTimes, ctx);
	    if (!isString(ret)) {
	      ret = formatValue(ctx, ret, recurseTimes);
	    }
	    return ret;
	  }
	
	  // Primitive types cannot have properties
	  var primitive = formatPrimitive(ctx, value);
	  if (primitive) {
	    return primitive;
	  }
	
	  // Look up the keys of the object.
	  var keys = Object.keys(value);
	  var visibleKeys = arrayToHash(keys);
	
	  if (ctx.showHidden) {
	    keys = Object.getOwnPropertyNames(value);
	  }
	
	  // IE doesn't make error fields non-enumerable
	  // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
	  if (isError(value)
	      && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) {
	    return formatError(value);
	  }
	
	  // Some type of object without properties can be shortcutted.
	  if (keys.length === 0) {
	    if (isFunction(value)) {
	      var name = value.name ? ': ' + value.name : '';
	      return ctx.stylize('[Function' + name + ']', 'special');
	    }
	    if (isRegExp(value)) {
	      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
	    }
	    if (isDate(value)) {
	      return ctx.stylize(Date.prototype.toString.call(value), 'date');
	    }
	    if (isError(value)) {
	      return formatError(value);
	    }
	  }
	
	  var base = '', array = false, braces = ['{', '}'];
	
	  // Make Array say that they are Array
	  if (isArray(value)) {
	    array = true;
	    braces = ['[', ']'];
	  }
	
	  // Make functions say that they are functions
	  if (isFunction(value)) {
	    var n = value.name ? ': ' + value.name : '';
	    base = ' [Function' + n + ']';
	  }
	
	  // Make RegExps say that they are RegExps
	  if (isRegExp(value)) {
	    base = ' ' + RegExp.prototype.toString.call(value);
	  }
	
	  // Make dates with properties first say the date
	  if (isDate(value)) {
	    base = ' ' + Date.prototype.toUTCString.call(value);
	  }
	
	  // Make error with message first say the error
	  if (isError(value)) {
	    base = ' ' + formatError(value);
	  }
	
	  if (keys.length === 0 && (!array || value.length == 0)) {
	    return braces[0] + base + braces[1];
	  }
	
	  if (recurseTimes < 0) {
	    if (isRegExp(value)) {
	      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
	    } else {
	      return ctx.stylize('[Object]', 'special');
	    }
	  }
	
	  ctx.seen.push(value);
	
	  var output;
	  if (array) {
	    output = formatArray(ctx, value, recurseTimes, visibleKeys, keys);
	  } else {
	    output = keys.map(function(key) {
	      return formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
	    });
	  }
	
	  ctx.seen.pop();
	
	  return reduceToSingleString(output, base, braces);
	}
	
	
	function formatPrimitive(ctx, value) {
	  if (isUndefined(value))
	    return ctx.stylize('undefined', 'undefined');
	  if (isString(value)) {
	    var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '')
	                                             .replace(/'/g, "\\'")
	                                             .replace(/\\"/g, '"') + '\'';
	    return ctx.stylize(simple, 'string');
	  }
	  if (isNumber(value))
	    return ctx.stylize('' + value, 'number');
	  if (isBoolean(value))
	    return ctx.stylize('' + value, 'boolean');
	  // For some reason typeof null is "object", so special case here.
	  if (isNull(value))
	    return ctx.stylize('null', 'null');
	}
	
	
	function formatError(value) {
	  return '[' + Error.prototype.toString.call(value) + ']';
	}
	
	
	function formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
	  var output = [];
	  for (var i = 0, l = value.length; i < l; ++i) {
	    if (hasOwnProperty(value, String(i))) {
	      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
	          String(i), true));
	    } else {
	      output.push('');
	    }
	  }
	  keys.forEach(function(key) {
	    if (!key.match(/^\d+$/)) {
	      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
	          key, true));
	    }
	  });
	  return output;
	}
	
	
	function formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
	  var name, str, desc;
	  desc = Object.getOwnPropertyDescriptor(value, key) || { value: value[key] };
	  if (desc.get) {
	    if (desc.set) {
	      str = ctx.stylize('[Getter/Setter]', 'special');
	    } else {
	      str = ctx.stylize('[Getter]', 'special');
	    }
	  } else {
	    if (desc.set) {
	      str = ctx.stylize('[Setter]', 'special');
	    }
	  }
	  if (!hasOwnProperty(visibleKeys, key)) {
	    name = '[' + key + ']';
	  }
	  if (!str) {
	    if (ctx.seen.indexOf(desc.value) < 0) {
	      if (isNull(recurseTimes)) {
	        str = formatValue(ctx, desc.value, null);
	      } else {
	        str = formatValue(ctx, desc.value, recurseTimes - 1);
	      }
	      if (str.indexOf('\n') > -1) {
	        if (array) {
	          str = str.split('\n').map(function(line) {
	            return '  ' + line;
	          }).join('\n').substr(2);
	        } else {
	          str = '\n' + str.split('\n').map(function(line) {
	            return '   ' + line;
	          }).join('\n');
	        }
	      }
	    } else {
	      str = ctx.stylize('[Circular]', 'special');
	    }
	  }
	  if (isUndefined(name)) {
	    if (array && key.match(/^\d+$/)) {
	      return str;
	    }
	    name = JSON.stringify('' + key);
	    if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
	      name = name.substr(1, name.length - 2);
	      name = ctx.stylize(name, 'name');
	    } else {
	      name = name.replace(/'/g, "\\'")
	                 .replace(/\\"/g, '"')
	                 .replace(/(^"|"$)/g, "'");
	      name = ctx.stylize(name, 'string');
	    }
	  }
	
	  return name + ': ' + str;
	}
	
	
	function reduceToSingleString(output, base, braces) {
	  var numLinesEst = 0;
	  var length = output.reduce(function(prev, cur) {
	    numLinesEst++;
	    if (cur.indexOf('\n') >= 0) numLinesEst++;
	    return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
	  }, 0);
	
	  if (length > 60) {
	    return braces[0] +
	           (base === '' ? '' : base + '\n ') +
	           ' ' +
	           output.join(',\n  ') +
	           ' ' +
	           braces[1];
	  }
	
	  return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
	}
	
	
	// NOTE: These type checking functions intentionally don't use `instanceof`
	// because it is fragile and can be easily faked with `Object.create()`.
	function isArray(ar) {
	  return Array.isArray(ar);
	}
	exports.isArray = isArray;
	
	function isBoolean(arg) {
	  return typeof arg === 'boolean';
	}
	exports.isBoolean = isBoolean;
	
	function isNull(arg) {
	  return arg === null;
	}
	exports.isNull = isNull;
	
	function isNullOrUndefined(arg) {
	  return arg == null;
	}
	exports.isNullOrUndefined = isNullOrUndefined;
	
	function isNumber(arg) {
	  return typeof arg === 'number';
	}
	exports.isNumber = isNumber;
	
	function isString(arg) {
	  return typeof arg === 'string';
	}
	exports.isString = isString;
	
	function isSymbol(arg) {
	  return typeof arg === 'symbol';
	}
	exports.isSymbol = isSymbol;
	
	function isUndefined(arg) {
	  return arg === void 0;
	}
	exports.isUndefined = isUndefined;
	
	function isRegExp(re) {
	  return isObject(re) && objectToString(re) === '[object RegExp]';
	}
	exports.isRegExp = isRegExp;
	
	function isObject(arg) {
	  return typeof arg === 'object' && arg !== null;
	}
	exports.isObject = isObject;
	
	function isDate(d) {
	  return isObject(d) && objectToString(d) === '[object Date]';
	}
	exports.isDate = isDate;
	
	function isError(e) {
	  return isObject(e) &&
	      (objectToString(e) === '[object Error]' || e instanceof Error);
	}
	exports.isError = isError;
	
	function isFunction(arg) {
	  return typeof arg === 'function';
	}
	exports.isFunction = isFunction;
	
	function isPrimitive(arg) {
	  return arg === null ||
	         typeof arg === 'boolean' ||
	         typeof arg === 'number' ||
	         typeof arg === 'string' ||
	         typeof arg === 'symbol' ||  // ES6 symbol
	         typeof arg === 'undefined';
	}
	exports.isPrimitive = isPrimitive;
	
	exports.isBuffer = __webpack_require__(1464);
	
	function objectToString(o) {
	  return Object.prototype.toString.call(o);
	}
	
	
	function pad(n) {
	  return n < 10 ? '0' + n.toString(10) : n.toString(10);
	}
	
	
	var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep',
	              'Oct', 'Nov', 'Dec'];
	
	// 26 Feb 16:19:34
	function timestamp() {
	  var d = new Date();
	  var time = [pad(d.getHours()),
	              pad(d.getMinutes()),
	              pad(d.getSeconds())].join(':');
	  return [d.getDate(), months[d.getMonth()], time].join(' ');
	}
	
	
	// log is just a thin wrapper to console.log that prepends a timestamp
	exports.log = function() {
	  console.log('%s - %s', timestamp(), exports.format.apply(exports, arguments));
	};
	
	
	/**
	 * Inherit the prototype methods from one constructor into another.
	 *
	 * The Function.prototype.inherits from lang.js rewritten as a standalone
	 * function (not on Function.prototype). NOTE: If this file is to be loaded
	 * during bootstrapping this function needs to be rewritten using some native
	 * functions as prototype setup using normal JavaScript does not work as
	 * expected during bootstrapping (see mirror.js in r114903).
	 *
	 * @param {function} ctor Constructor function which needs to inherit the
	 *     prototype.
	 * @param {function} superCtor Constructor function to inherit prototype from.
	 */
	exports.inherits = __webpack_require__(1465);
	
	exports._extend = function(origin, add) {
	  // Don't do anything if add isn't an object
	  if (!add || !isObject(add)) return origin;
	
	  var keys = Object.keys(add);
	  var i = keys.length;
	  while (i--) {
	    origin[keys[i]] = add[keys[i]];
	  }
	  return origin;
	};
	
	function hasOwnProperty(obj, prop) {
	  return Object.prototype.hasOwnProperty.call(obj, prop);
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(294)))

/***/ }),
/* 1464 */
/***/ (function(module, exports) {

	module.exports = function isBuffer(arg) {
	  return arg && typeof arg === 'object'
	    && typeof arg.copy === 'function'
	    && typeof arg.fill === 'function'
	    && typeof arg.readUInt8 === 'function';
	}

/***/ }),
/* 1465 */
/***/ (function(module, exports) {

	if (typeof Object.create === 'function') {
	  // implementation from standard node.js 'util' module
	  module.exports = function inherits(ctor, superCtor) {
	    ctor.super_ = superCtor
	    ctor.prototype = Object.create(superCtor.prototype, {
	      constructor: {
	        value: ctor,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	  };
	} else {
	  // old school shim for old browsers
	  module.exports = function inherits(ctor, superCtor) {
	    ctor.super_ = superCtor
	    var TempCtor = function () {}
	    TempCtor.prototype = superCtor.prototype
	    ctor.prototype = new TempCtor()
	    ctor.prototype.constructor = ctor
	  }
	}


/***/ }),
/* 1466 */
/***/ (function(module, exports, __webpack_require__) {

	var baseRest = __webpack_require__(811),
	    createWrap = __webpack_require__(1426),
	    getHolder = __webpack_require__(1452),
	    replaceHolders = __webpack_require__(1454);
	
	/** Used to compose bitmasks for function metadata. */
	var WRAP_BIND_FLAG = 1,
	    WRAP_PARTIAL_FLAG = 32;
	
	/**
	 * Creates a function that invokes `func` with the `this` binding of `thisArg`
	 * and `partials` prepended to the arguments it receives.
	 *
	 * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
	 * may be used as a placeholder for partially applied arguments.
	 *
	 * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
	 * property of bound functions.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to bind.
	 * @param {*} thisArg The `this` binding of `func`.
	 * @param {...*} [partials] The arguments to be partially applied.
	 * @returns {Function} Returns the new bound function.
	 * @example
	 *
	 * function greet(greeting, punctuation) {
	 *   return greeting + ' ' + this.user + punctuation;
	 * }
	 *
	 * var object = { 'user': 'fred' };
	 *
	 * var bound = _.bind(greet, object, 'hi');
	 * bound('!');
	 * // => 'hi fred!'
	 *
	 * // Bound with placeholders.
	 * var bound = _.bind(greet, object, _, '!');
	 * bound('hi');
	 * // => 'hi fred!'
	 */
	var bind = baseRest(function(func, thisArg, partials) {
	  var bitmask = WRAP_BIND_FLAG;
	  if (partials.length) {
	    var holders = replaceHolders(partials, getHolder(bind));
	    bitmask |= WRAP_PARTIAL_FLAG;
	  }
	  return createWrap(func, bitmask, thisArg, partials, holders);
	});
	
	// Assign default placeholders.
	bind.placeholder = {};
	
	module.exports = bind;


/***/ }),
/* 1467 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Module containing the functions to serialize and deserialize
	 * {SearchParameters} in the query string format
	 * @module algoliasearchHelper.url
	 */
	
	var shortener = __webpack_require__(1468);
	var SearchParameters = __webpack_require__(1362);
	
	var qs = __webpack_require__(1472);
	
	var bind = __webpack_require__(1466);
	var forEach = __webpack_require__(1374);
	var pick = __webpack_require__(1477);
	var map = __webpack_require__(1377);
	var mapKeys = __webpack_require__(1479);
	var mapValues = __webpack_require__(1480);
	var isString = __webpack_require__(1399);
	var isPlainObject = __webpack_require__(795);
	var isArray = __webpack_require__(789);
	var invert = __webpack_require__(1469);
	
	var encode = __webpack_require__(1474).encode;
	
	function recursiveEncode(input) {
	  if (isPlainObject(input)) {
	    return mapValues(input, recursiveEncode);
	  }
	  if (isArray(input)) {
	    return map(input, recursiveEncode);
	  }
	  if (isString(input)) {
	    return encode(input);
	  }
	  return input;
	}
	
	var refinementsParameters = ['dFR', 'fR', 'nR', 'hFR', 'tR'];
	var stateKeys = shortener.ENCODED_PARAMETERS;
	function sortQueryStringValues(prefixRegexp, invertedMapping, a, b) {
	  if (prefixRegexp !== null) {
	    a = a.replace(prefixRegexp, '');
	    b = b.replace(prefixRegexp, '');
	  }
	
	  a = invertedMapping[a] || a;
	  b = invertedMapping[b] || b;
	
	  if (stateKeys.indexOf(a) !== -1 || stateKeys.indexOf(b) !== -1) {
	    if (a === 'q') return -1;
	    if (b === 'q') return 1;
	
	    var isARefinements = refinementsParameters.indexOf(a) !== -1;
	    var isBRefinements = refinementsParameters.indexOf(b) !== -1;
	    if (isARefinements && !isBRefinements) {
	      return 1;
	    } else if (isBRefinements && !isARefinements) {
	      return -1;
	    }
	  }
	
	  return a.localeCompare(b);
	}
	
	/**
	 * Read a query string and return an object containing the state
	 * @param {string} queryString the query string that will be decoded
	 * @param {object} [options] accepted options :
	 *   - prefix : the prefix used for the saved attributes, you have to provide the
	 *     same that was used for serialization
	 *   - mapping : map short attributes to another value e.g. {q: 'query'}
	 * @return {object} partial search parameters object (same properties than in the
	 * SearchParameters but not exhaustive)
	 */
	exports.getStateFromQueryString = function(queryString, options) {
	  var prefixForParameters = options && options.prefix || '';
	  var mapping = options && options.mapping || {};
	  var invertedMapping = invert(mapping);
	
	  var partialStateWithPrefix = qs.parse(queryString);
	  var prefixRegexp = new RegExp('^' + prefixForParameters);
	  var partialState = mapKeys(
	    partialStateWithPrefix,
	    function(v, k) {
	      var hasPrefix = prefixForParameters && prefixRegexp.test(k);
	      var unprefixedKey = hasPrefix ? k.replace(prefixRegexp, '') : k;
	      var decodedKey = shortener.decode(invertedMapping[unprefixedKey] || unprefixedKey);
	      return decodedKey || unprefixedKey;
	    }
	  );
	
	  var partialStateWithParsedNumbers = SearchParameters._parseNumbers(partialState);
	
	  return pick(partialStateWithParsedNumbers, SearchParameters.PARAMETERS);
	};
	
	/**
	 * Retrieve an object of all the properties that are not understandable as helper
	 * parameters.
	 * @param {string} queryString the query string to read
	 * @param {object} [options] the options
	 *   - prefixForParameters : prefix used for the helper configuration keys
	 *   - mapping : map short attributes to another value e.g. {q: 'query'}
	 * @return {object} the object containing the parsed configuration that doesn't
	 * to the helper
	 */
	exports.getUnrecognizedParametersInQueryString = function(queryString, options) {
	  var prefixForParameters = options && options.prefix;
	  var mapping = options && options.mapping || {};
	  var invertedMapping = invert(mapping);
	
	  var foreignConfig = {};
	  var config = qs.parse(queryString);
	  if (prefixForParameters) {
	    var prefixRegexp = new RegExp('^' + prefixForParameters);
	    forEach(config, function(v, key) {
	      if (!prefixRegexp.test(key)) foreignConfig[key] = v;
	    });
	  } else {
	    forEach(config, function(v, key) {
	      if (!shortener.decode(invertedMapping[key] || key)) foreignConfig[key] = v;
	    });
	  }
	
	  return foreignConfig;
	};
	
	/**
	 * Generate a query string for the state passed according to the options
	 * @param {SearchParameters} state state to serialize
	 * @param {object} [options] May contain the following parameters :
	 *  - prefix : prefix in front of the keys
	 *  - mapping : map short attributes to another value e.g. {q: 'query'}
	 *  - moreAttributes : more values to be added in the query string. Those values
	 *    won't be prefixed.
	 *  - safe : get safe urls for use in emails, chat apps or any application auto linking urls.
	 *  All parameters and values will be encoded in a way that it's safe to share them.
	 *  Default to false for legacy reasons ()
	 * @return {string} the query string
	 */
	exports.getQueryStringFromState = function(state, options) {
	  var moreAttributes = options && options.moreAttributes;
	  var prefixForParameters = options && options.prefix || '';
	  var mapping = options && options.mapping || {};
	  var safe = options && options.safe || false;
	  var invertedMapping = invert(mapping);
	
	  var stateForUrl = safe ? state : recursiveEncode(state);
	
	  var encodedState = mapKeys(
	    stateForUrl,
	    function(v, k) {
	      var shortK = shortener.encode(k);
	      return prefixForParameters + (mapping[shortK] || shortK);
	    }
	  );
	
	  var prefixRegexp = prefixForParameters === '' ? null : new RegExp('^' + prefixForParameters);
	  var sort = bind(sortQueryStringValues, null, prefixRegexp, invertedMapping);
	  if (moreAttributes) {
	    var stateQs = qs.stringify(encodedState, {encode: safe, sort: sort});
	    var moreQs = qs.stringify(moreAttributes, {encode: safe});
	    if (!stateQs) return moreQs;
	    return stateQs + '&' + moreQs;
	  }
	
	  return qs.stringify(encodedState, {encode: safe, sort: sort});
	};


/***/ }),
/* 1468 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var invert = __webpack_require__(1469);
	var keys = __webpack_require__(921);
	
	var keys2Short = {
	  advancedSyntax: 'aS',
	  allowTyposOnNumericTokens: 'aTONT',
	  analyticsTags: 'aT',
	  analytics: 'a',
	  aroundLatLngViaIP: 'aLLVIP',
	  aroundLatLng: 'aLL',
	  aroundPrecision: 'aP',
	  aroundRadius: 'aR',
	  attributesToHighlight: 'aTH',
	  attributesToRetrieve: 'aTR',
	  attributesToSnippet: 'aTS',
	  disjunctiveFacetsRefinements: 'dFR',
	  disjunctiveFacets: 'dF',
	  distinct: 'd',
	  facetsExcludes: 'fE',
	  facetsRefinements: 'fR',
	  facets: 'f',
	  getRankingInfo: 'gRI',
	  hierarchicalFacetsRefinements: 'hFR',
	  hierarchicalFacets: 'hF',
	  highlightPostTag: 'hPoT',
	  highlightPreTag: 'hPrT',
	  hitsPerPage: 'hPP',
	  ignorePlurals: 'iP',
	  index: 'idx',
	  insideBoundingBox: 'iBB',
	  insidePolygon: 'iPg',
	  length: 'l',
	  maxValuesPerFacet: 'mVPF',
	  minimumAroundRadius: 'mAR',
	  minProximity: 'mP',
	  minWordSizefor1Typo: 'mWS1T',
	  minWordSizefor2Typos: 'mWS2T',
	  numericFilters: 'nF',
	  numericRefinements: 'nR',
	  offset: 'o',
	  optionalWords: 'oW',
	  page: 'p',
	  queryType: 'qT',
	  query: 'q',
	  removeWordsIfNoResults: 'rWINR',
	  replaceSynonymsInHighlight: 'rSIH',
	  restrictSearchableAttributes: 'rSA',
	  synonyms: 's',
	  tagFilters: 'tF',
	  tagRefinements: 'tR',
	  typoTolerance: 'tT',
	  optionalTagFilters: 'oTF',
	  optionalFacetFilters: 'oFF',
	  snippetEllipsisText: 'sET',
	  disableExactOnAttributes: 'dEOA',
	  enableExactOnSingleWordQuery: 'eEOSWQ'
	};
	
	var short2Keys = invert(keys2Short);
	
	module.exports = {
	  /**
	   * All the keys of the state, encoded.
	   * @const
	   */
	  ENCODED_PARAMETERS: keys(short2Keys),
	  /**
	   * Decode a shorten attribute
	   * @param {string} shortKey the shorten attribute
	   * @return {string} the decoded attribute, undefined otherwise
	   */
	  decode: function(shortKey) {
	    return short2Keys[shortKey];
	  },
	  /**
	   * Encode an attribute into a short version
	   * @param {string} key the attribute
	   * @return {string} the shorten attribute
	   */
	  encode: function(key) {
	    return keys2Short[key];
	  }
	};


/***/ }),
/* 1469 */
/***/ (function(module, exports, __webpack_require__) {

	var constant = __webpack_require__(817),
	    createInverter = __webpack_require__(1470),
	    identity = __webpack_require__(812);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/**
	 * Creates an object composed of the inverted keys and values of `object`.
	 * If `object` contains duplicate values, subsequent values overwrite
	 * property assignments of previous values.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.7.0
	 * @category Object
	 * @param {Object} object The object to invert.
	 * @returns {Object} Returns the new inverted object.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': 2, 'c': 1 };
	 *
	 * _.invert(object);
	 * // => { '1': 'c', '2': 'b' }
	 */
	var invert = createInverter(function(result, value, key) {
	  if (value != null &&
	      typeof value.toString != 'function') {
	    value = nativeObjectToString.call(value);
	  }
	
	  result[value] = key;
	}, constant(identity));
	
	module.exports = invert;


/***/ }),
/* 1470 */
/***/ (function(module, exports, __webpack_require__) {

	var baseInverter = __webpack_require__(1471);
	
	/**
	 * Creates a function like `_.invertBy`.
	 *
	 * @private
	 * @param {Function} setter The function to set accumulator values.
	 * @param {Function} toIteratee The function to resolve iteratees.
	 * @returns {Function} Returns the new inverter function.
	 */
	function createInverter(setter, toIteratee) {
	  return function(object, iteratee) {
	    return baseInverter(object, setter, toIteratee(iteratee), {});
	  };
	}
	
	module.exports = createInverter;


/***/ }),
/* 1471 */
/***/ (function(module, exports, __webpack_require__) {

	var baseForOwn = __webpack_require__(995);
	
	/**
	 * The base implementation of `_.invert` and `_.invertBy` which inverts
	 * `object` with values transformed by `iteratee` and set by `setter`.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} setter The function to set `accumulator` values.
	 * @param {Function} iteratee The iteratee to transform values.
	 * @param {Object} accumulator The initial inverted object.
	 * @returns {Function} Returns `accumulator`.
	 */
	function baseInverter(object, setter, iteratee, accumulator) {
	  baseForOwn(object, function(value, key, object) {
	    setter(accumulator, iteratee(value), key, object);
	  });
	  return accumulator;
	}
	
	module.exports = baseInverter;


/***/ }),
/* 1472 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var stringify = __webpack_require__(1473);
	var parse = __webpack_require__(1476);
	var formats = __webpack_require__(1475);
	
	module.exports = {
	    formats: formats,
	    parse: parse,
	    stringify: stringify
	};


/***/ }),
/* 1473 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(1474);
	var formats = __webpack_require__(1475);
	var has = Object.prototype.hasOwnProperty;
	
	var arrayPrefixGenerators = {
	    brackets: function brackets(prefix) {
	        return prefix + '[]';
	    },
	    comma: 'comma',
	    indices: function indices(prefix, key) {
	        return prefix + '[' + key + ']';
	    },
	    repeat: function repeat(prefix) {
	        return prefix;
	    }
	};
	
	var isArray = Array.isArray;
	var push = Array.prototype.push;
	var pushToArray = function (arr, valueOrArray) {
	    push.apply(arr, isArray(valueOrArray) ? valueOrArray : [valueOrArray]);
	};
	
	var toISO = Date.prototype.toISOString;
	
	var defaultFormat = formats['default'];
	var defaults = {
	    addQueryPrefix: false,
	    allowDots: false,
	    charset: 'utf-8',
	    charsetSentinel: false,
	    delimiter: '&',
	    encode: true,
	    encoder: utils.encode,
	    encodeValuesOnly: false,
	    format: defaultFormat,
	    formatter: formats.formatters[defaultFormat],
	    // deprecated
	    indices: false,
	    serializeDate: function serializeDate(date) {
	        return toISO.call(date);
	    },
	    skipNulls: false,
	    strictNullHandling: false
	};
	
	var isNonNullishPrimitive = function isNonNullishPrimitive(v) {
	    return typeof v === 'string'
	        || typeof v === 'number'
	        || typeof v === 'boolean'
	        || typeof v === 'symbol'
	        || typeof v === 'bigint';
	};
	
	var stringify = function stringify(
	    object,
	    prefix,
	    generateArrayPrefix,
	    strictNullHandling,
	    skipNulls,
	    encoder,
	    filter,
	    sort,
	    allowDots,
	    serializeDate,
	    formatter,
	    encodeValuesOnly,
	    charset
	) {
	    var obj = object;
	    if (typeof filter === 'function') {
	        obj = filter(prefix, obj);
	    } else if (obj instanceof Date) {
	        obj = serializeDate(obj);
	    } else if (generateArrayPrefix === 'comma' && isArray(obj)) {
	        obj = obj.join(',');
	    }
	
	    if (obj === null) {
	        if (strictNullHandling) {
	            return encoder && !encodeValuesOnly ? encoder(prefix, defaults.encoder, charset, 'key') : prefix;
	        }
	
	        obj = '';
	    }
	
	    if (isNonNullishPrimitive(obj) || utils.isBuffer(obj)) {
	        if (encoder) {
	            var keyValue = encodeValuesOnly ? prefix : encoder(prefix, defaults.encoder, charset, 'key');
	            return [formatter(keyValue) + '=' + formatter(encoder(obj, defaults.encoder, charset, 'value'))];
	        }
	        return [formatter(prefix) + '=' + formatter(String(obj))];
	    }
	
	    var values = [];
	
	    if (typeof obj === 'undefined') {
	        return values;
	    }
	
	    var objKeys;
	    if (isArray(filter)) {
	        objKeys = filter;
	    } else {
	        var keys = Object.keys(obj);
	        objKeys = sort ? keys.sort(sort) : keys;
	    }
	
	    for (var i = 0; i < objKeys.length; ++i) {
	        var key = objKeys[i];
	
	        if (skipNulls && obj[key] === null) {
	            continue;
	        }
	
	        if (isArray(obj)) {
	            pushToArray(values, stringify(
	                obj[key],
	                typeof generateArrayPrefix === 'function' ? generateArrayPrefix(prefix, key) : prefix,
	                generateArrayPrefix,
	                strictNullHandling,
	                skipNulls,
	                encoder,
	                filter,
	                sort,
	                allowDots,
	                serializeDate,
	                formatter,
	                encodeValuesOnly,
	                charset
	            ));
	        } else {
	            pushToArray(values, stringify(
	                obj[key],
	                prefix + (allowDots ? '.' + key : '[' + key + ']'),
	                generateArrayPrefix,
	                strictNullHandling,
	                skipNulls,
	                encoder,
	                filter,
	                sort,
	                allowDots,
	                serializeDate,
	                formatter,
	                encodeValuesOnly,
	                charset
	            ));
	        }
	    }
	
	    return values;
	};
	
	var normalizeStringifyOptions = function normalizeStringifyOptions(opts) {
	    if (!opts) {
	        return defaults;
	    }
	
	    if (opts.encoder !== null && opts.encoder !== undefined && typeof opts.encoder !== 'function') {
	        throw new TypeError('Encoder has to be a function.');
	    }
	
	    var charset = opts.charset || defaults.charset;
	    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') {
	        throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
	    }
	
	    var format = formats['default'];
	    if (typeof opts.format !== 'undefined') {
	        if (!has.call(formats.formatters, opts.format)) {
	            throw new TypeError('Unknown format option provided.');
	        }
	        format = opts.format;
	    }
	    var formatter = formats.formatters[format];
	
	    var filter = defaults.filter;
	    if (typeof opts.filter === 'function' || isArray(opts.filter)) {
	        filter = opts.filter;
	    }
	
	    return {
	        addQueryPrefix: typeof opts.addQueryPrefix === 'boolean' ? opts.addQueryPrefix : defaults.addQueryPrefix,
	        allowDots: typeof opts.allowDots === 'undefined' ? defaults.allowDots : !!opts.allowDots,
	        charset: charset,
	        charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : defaults.charsetSentinel,
	        delimiter: typeof opts.delimiter === 'undefined' ? defaults.delimiter : opts.delimiter,
	        encode: typeof opts.encode === 'boolean' ? opts.encode : defaults.encode,
	        encoder: typeof opts.encoder === 'function' ? opts.encoder : defaults.encoder,
	        encodeValuesOnly: typeof opts.encodeValuesOnly === 'boolean' ? opts.encodeValuesOnly : defaults.encodeValuesOnly,
	        filter: filter,
	        formatter: formatter,
	        serializeDate: typeof opts.serializeDate === 'function' ? opts.serializeDate : defaults.serializeDate,
	        skipNulls: typeof opts.skipNulls === 'boolean' ? opts.skipNulls : defaults.skipNulls,
	        sort: typeof opts.sort === 'function' ? opts.sort : null,
	        strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : defaults.strictNullHandling
	    };
	};
	
	module.exports = function (object, opts) {
	    var obj = object;
	    var options = normalizeStringifyOptions(opts);
	
	    var objKeys;
	    var filter;
	
	    if (typeof options.filter === 'function') {
	        filter = options.filter;
	        obj = filter('', obj);
	    } else if (isArray(options.filter)) {
	        filter = options.filter;
	        objKeys = filter;
	    }
	
	    var keys = [];
	
	    if (typeof obj !== 'object' || obj === null) {
	        return '';
	    }
	
	    var arrayFormat;
	    if (opts && opts.arrayFormat in arrayPrefixGenerators) {
	        arrayFormat = opts.arrayFormat;
	    } else if (opts && 'indices' in opts) {
	        arrayFormat = opts.indices ? 'indices' : 'repeat';
	    } else {
	        arrayFormat = 'indices';
	    }
	
	    var generateArrayPrefix = arrayPrefixGenerators[arrayFormat];
	
	    if (!objKeys) {
	        objKeys = Object.keys(obj);
	    }
	
	    if (options.sort) {
	        objKeys.sort(options.sort);
	    }
	
	    for (var i = 0; i < objKeys.length; ++i) {
	        var key = objKeys[i];
	
	        if (options.skipNulls && obj[key] === null) {
	            continue;
	        }
	        pushToArray(keys, stringify(
	            obj[key],
	            key,
	            generateArrayPrefix,
	            options.strictNullHandling,
	            options.skipNulls,
	            options.encode ? options.encoder : null,
	            options.filter,
	            options.sort,
	            options.allowDots,
	            options.serializeDate,
	            options.formatter,
	            options.encodeValuesOnly,
	            options.charset
	        ));
	    }
	
	    var joined = keys.join(options.delimiter);
	    var prefix = options.addQueryPrefix === true ? '?' : '';
	
	    if (options.charsetSentinel) {
	        if (options.charset === 'iso-8859-1') {
	            // encodeURIComponent('&#10003;'), the "numeric entity" representation of a checkmark
	            prefix += 'utf8=%26%2310003%3B&';
	        } else {
	            // encodeURIComponent('✓')
	            prefix += 'utf8=%E2%9C%93&';
	        }
	    }
	
	    return joined.length > 0 ? prefix + joined : '';
	};


/***/ }),
/* 1474 */
/***/ (function(module, exports) {

	'use strict';
	
	var has = Object.prototype.hasOwnProperty;
	var isArray = Array.isArray;
	
	var hexTable = (function () {
	    var array = [];
	    for (var i = 0; i < 256; ++i) {
	        array.push('%' + ((i < 16 ? '0' : '') + i.toString(16)).toUpperCase());
	    }
	
	    return array;
	}());
	
	var compactQueue = function compactQueue(queue) {
	    while (queue.length > 1) {
	        var item = queue.pop();
	        var obj = item.obj[item.prop];
	
	        if (isArray(obj)) {
	            var compacted = [];
	
	            for (var j = 0; j < obj.length; ++j) {
	                if (typeof obj[j] !== 'undefined') {
	                    compacted.push(obj[j]);
	                }
	            }
	
	            item.obj[item.prop] = compacted;
	        }
	    }
	};
	
	var arrayToObject = function arrayToObject(source, options) {
	    var obj = options && options.plainObjects ? Object.create(null) : {};
	    for (var i = 0; i < source.length; ++i) {
	        if (typeof source[i] !== 'undefined') {
	            obj[i] = source[i];
	        }
	    }
	
	    return obj;
	};
	
	var merge = function merge(target, source, options) {
	    /* eslint no-param-reassign: 0 */
	    if (!source) {
	        return target;
	    }
	
	    if (typeof source !== 'object') {
	        if (isArray(target)) {
	            target.push(source);
	        } else if (target && typeof target === 'object') {
	            if ((options && (options.plainObjects || options.allowPrototypes)) || !has.call(Object.prototype, source)) {
	                target[source] = true;
	            }
	        } else {
	            return [target, source];
	        }
	
	        return target;
	    }
	
	    if (!target || typeof target !== 'object') {
	        return [target].concat(source);
	    }
	
	    var mergeTarget = target;
	    if (isArray(target) && !isArray(source)) {
	        mergeTarget = arrayToObject(target, options);
	    }
	
	    if (isArray(target) && isArray(source)) {
	        source.forEach(function (item, i) {
	            if (has.call(target, i)) {
	                var targetItem = target[i];
	                if (targetItem && typeof targetItem === 'object' && item && typeof item === 'object') {
	                    target[i] = merge(targetItem, item, options);
	                } else {
	                    target.push(item);
	                }
	            } else {
	                target[i] = item;
	            }
	        });
	        return target;
	    }
	
	    return Object.keys(source).reduce(function (acc, key) {
	        var value = source[key];
	
	        if (has.call(acc, key)) {
	            acc[key] = merge(acc[key], value, options);
	        } else {
	            acc[key] = value;
	        }
	        return acc;
	    }, mergeTarget);
	};
	
	var assign = function assignSingleSource(target, source) {
	    return Object.keys(source).reduce(function (acc, key) {
	        acc[key] = source[key];
	        return acc;
	    }, target);
	};
	
	var decode = function (str, decoder, charset) {
	    var strWithoutPlus = str.replace(/\+/g, ' ');
	    if (charset === 'iso-8859-1') {
	        // unescape never throws, no try...catch needed:
	        return strWithoutPlus.replace(/%[0-9a-f]{2}/gi, unescape);
	    }
	    // utf-8
	    try {
	        return decodeURIComponent(strWithoutPlus);
	    } catch (e) {
	        return strWithoutPlus;
	    }
	};
	
	var encode = function encode(str, defaultEncoder, charset) {
	    // This code was originally written by Brian White (mscdex) for the io.js core querystring library.
	    // It has been adapted here for stricter adherence to RFC 3986
	    if (str.length === 0) {
	        return str;
	    }
	
	    var string = str;
	    if (typeof str === 'symbol') {
	        string = Symbol.prototype.toString.call(str);
	    } else if (typeof str !== 'string') {
	        string = String(str);
	    }
	
	    if (charset === 'iso-8859-1') {
	        return escape(string).replace(/%u[0-9a-f]{4}/gi, function ($0) {
	            return '%26%23' + parseInt($0.slice(2), 16) + '%3B';
	        });
	    }
	
	    var out = '';
	    for (var i = 0; i < string.length; ++i) {
	        var c = string.charCodeAt(i);
	
	        if (
	            c === 0x2D // -
	            || c === 0x2E // .
	            || c === 0x5F // _
	            || c === 0x7E // ~
	            || (c >= 0x30 && c <= 0x39) // 0-9
	            || (c >= 0x41 && c <= 0x5A) // a-z
	            || (c >= 0x61 && c <= 0x7A) // A-Z
	        ) {
	            out += string.charAt(i);
	            continue;
	        }
	
	        if (c < 0x80) {
	            out = out + hexTable[c];
	            continue;
	        }
	
	        if (c < 0x800) {
	            out = out + (hexTable[0xC0 | (c >> 6)] + hexTable[0x80 | (c & 0x3F)]);
	            continue;
	        }
	
	        if (c < 0xD800 || c >= 0xE000) {
	            out = out + (hexTable[0xE0 | (c >> 12)] + hexTable[0x80 | ((c >> 6) & 0x3F)] + hexTable[0x80 | (c & 0x3F)]);
	            continue;
	        }
	
	        i += 1;
	        c = 0x10000 + (((c & 0x3FF) << 10) | (string.charCodeAt(i) & 0x3FF));
	        out += hexTable[0xF0 | (c >> 18)]
	            + hexTable[0x80 | ((c >> 12) & 0x3F)]
	            + hexTable[0x80 | ((c >> 6) & 0x3F)]
	            + hexTable[0x80 | (c & 0x3F)];
	    }
	
	    return out;
	};
	
	var compact = function compact(value) {
	    var queue = [{ obj: { o: value }, prop: 'o' }];
	    var refs = [];
	
	    for (var i = 0; i < queue.length; ++i) {
	        var item = queue[i];
	        var obj = item.obj[item.prop];
	
	        var keys = Object.keys(obj);
	        for (var j = 0; j < keys.length; ++j) {
	            var key = keys[j];
	            var val = obj[key];
	            if (typeof val === 'object' && val !== null && refs.indexOf(val) === -1) {
	                queue.push({ obj: obj, prop: key });
	                refs.push(val);
	            }
	        }
	    }
	
	    compactQueue(queue);
	
	    return value;
	};
	
	var isRegExp = function isRegExp(obj) {
	    return Object.prototype.toString.call(obj) === '[object RegExp]';
	};
	
	var isBuffer = function isBuffer(obj) {
	    if (!obj || typeof obj !== 'object') {
	        return false;
	    }
	
	    return !!(obj.constructor && obj.constructor.isBuffer && obj.constructor.isBuffer(obj));
	};
	
	var combine = function combine(a, b) {
	    return [].concat(a, b);
	};
	
	module.exports = {
	    arrayToObject: arrayToObject,
	    assign: assign,
	    combine: combine,
	    compact: compact,
	    decode: decode,
	    encode: encode,
	    isBuffer: isBuffer,
	    isRegExp: isRegExp,
	    merge: merge
	};


/***/ }),
/* 1475 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var replace = String.prototype.replace;
	var percentTwenties = /%20/g;
	
	var util = __webpack_require__(1474);
	
	var Format = {
	    RFC1738: 'RFC1738',
	    RFC3986: 'RFC3986'
	};
	
	module.exports = util.assign(
	    {
	        'default': Format.RFC3986,
	        formatters: {
	            RFC1738: function (value) {
	                return replace.call(value, percentTwenties, '+');
	            },
	            RFC3986: function (value) {
	                return String(value);
	            }
	        }
	    },
	    Format
	);


/***/ }),
/* 1476 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(1474);
	
	var has = Object.prototype.hasOwnProperty;
	var isArray = Array.isArray;
	
	var defaults = {
	    allowDots: false,
	    allowPrototypes: false,
	    arrayLimit: 20,
	    charset: 'utf-8',
	    charsetSentinel: false,
	    comma: false,
	    decoder: utils.decode,
	    delimiter: '&',
	    depth: 5,
	    ignoreQueryPrefix: false,
	    interpretNumericEntities: false,
	    parameterLimit: 1000,
	    parseArrays: true,
	    plainObjects: false,
	    strictNullHandling: false
	};
	
	var interpretNumericEntities = function (str) {
	    return str.replace(/&#(\d+);/g, function ($0, numberStr) {
	        return String.fromCharCode(parseInt(numberStr, 10));
	    });
	};
	
	var parseArrayValue = function (val, options) {
	    if (val && typeof val === 'string' && options.comma && val.indexOf(',') > -1) {
	        return val.split(',');
	    }
	
	    return val;
	};
	
	var maybeMap = function maybeMap(val, fn) {
	    if (isArray(val)) {
	        var mapped = [];
	        for (var i = 0; i < val.length; i += 1) {
	            mapped.push(fn(val[i]));
	        }
	        return mapped;
	    }
	    return fn(val);
	};
	
	// This is what browsers will submit when the ✓ character occurs in an
	// application/x-www-form-urlencoded body and the encoding of the page containing
	// the form is iso-8859-1, or when the submitted form has an accept-charset
	// attribute of iso-8859-1. Presumably also with other charsets that do not contain
	// the ✓ character, such as us-ascii.
	var isoSentinel = 'utf8=%26%2310003%3B'; // encodeURIComponent('&#10003;')
	
	// These are the percent-encoded utf-8 octets representing a checkmark, indicating that the request actually is utf-8 encoded.
	var charsetSentinel = 'utf8=%E2%9C%93'; // encodeURIComponent('✓')
	
	var parseValues = function parseQueryStringValues(str, options) {
	    var obj = {};
	    var cleanStr = options.ignoreQueryPrefix ? str.replace(/^\?/, '') : str;
	    var limit = options.parameterLimit === Infinity ? undefined : options.parameterLimit;
	    var parts = cleanStr.split(options.delimiter, limit);
	    var skipIndex = -1; // Keep track of where the utf8 sentinel was found
	    var i;
	
	    var charset = options.charset;
	    if (options.charsetSentinel) {
	        for (i = 0; i < parts.length; ++i) {
	            if (parts[i].indexOf('utf8=') === 0) {
	                if (parts[i] === charsetSentinel) {
	                    charset = 'utf-8';
	                } else if (parts[i] === isoSentinel) {
	                    charset = 'iso-8859-1';
	                }
	                skipIndex = i;
	                i = parts.length; // The eslint settings do not allow break;
	            }
	        }
	    }
	
	    for (i = 0; i < parts.length; ++i) {
	        if (i === skipIndex) {
	            continue;
	        }
	        var part = parts[i];
	
	        var bracketEqualsPos = part.indexOf(']=');
	        var pos = bracketEqualsPos === -1 ? part.indexOf('=') : bracketEqualsPos + 1;
	
	        var key, val;
	        if (pos === -1) {
	            key = options.decoder(part, defaults.decoder, charset, 'key');
	            val = options.strictNullHandling ? null : '';
	        } else {
	            key = options.decoder(part.slice(0, pos), defaults.decoder, charset, 'key');
	            val = maybeMap(
	                parseArrayValue(part.slice(pos + 1), options),
	                function (encodedVal) {
	                    return options.decoder(encodedVal, defaults.decoder, charset, 'value');
	                }
	            );
	        }
	
	        if (val && options.interpretNumericEntities && charset === 'iso-8859-1') {
	            val = interpretNumericEntities(val);
	        }
	
	        if (part.indexOf('[]=') > -1) {
	            val = isArray(val) ? [val] : val;
	        }
	
	        if (has.call(obj, key)) {
	            obj[key] = utils.combine(obj[key], val);
	        } else {
	            obj[key] = val;
	        }
	    }
	
	    return obj;
	};
	
	var parseObject = function (chain, val, options, valuesParsed) {
	    var leaf = valuesParsed ? val : parseArrayValue(val, options);
	
	    for (var i = chain.length - 1; i >= 0; --i) {
	        var obj;
	        var root = chain[i];
	
	        if (root === '[]' && options.parseArrays) {
	            obj = [].concat(leaf);
	        } else {
	            obj = options.plainObjects ? Object.create(null) : {};
	            var cleanRoot = root.charAt(0) === '[' && root.charAt(root.length - 1) === ']' ? root.slice(1, -1) : root;
	            var index = parseInt(cleanRoot, 10);
	            if (!options.parseArrays && cleanRoot === '') {
	                obj = { 0: leaf };
	            } else if (
	                !isNaN(index)
	                && root !== cleanRoot
	                && String(index) === cleanRoot
	                && index >= 0
	                && (options.parseArrays && index <= options.arrayLimit)
	            ) {
	                obj = [];
	                obj[index] = leaf;
	            } else {
	                obj[cleanRoot] = leaf;
	            }
	        }
	
	        leaf = obj; // eslint-disable-line no-param-reassign
	    }
	
	    return leaf;
	};
	
	var parseKeys = function parseQueryStringKeys(givenKey, val, options, valuesParsed) {
	    if (!givenKey) {
	        return;
	    }
	
	    // Transform dot notation to bracket notation
	    var key = options.allowDots ? givenKey.replace(/\.([^.[]+)/g, '[$1]') : givenKey;
	
	    // The regex chunks
	
	    var brackets = /(\[[^[\]]*])/;
	    var child = /(\[[^[\]]*])/g;
	
	    // Get the parent
	
	    var segment = options.depth > 0 && brackets.exec(key);
	    var parent = segment ? key.slice(0, segment.index) : key;
	
	    // Stash the parent if it exists
	
	    var keys = [];
	    if (parent) {
	        // If we aren't using plain objects, optionally prefix keys that would overwrite object prototype properties
	        if (!options.plainObjects && has.call(Object.prototype, parent)) {
	            if (!options.allowPrototypes) {
	                return;
	            }
	        }
	
	        keys.push(parent);
	    }
	
	    // Loop through children appending to the array until we hit depth
	
	    var i = 0;
	    while (options.depth > 0 && (segment = child.exec(key)) !== null && i < options.depth) {
	        i += 1;
	        if (!options.plainObjects && has.call(Object.prototype, segment[1].slice(1, -1))) {
	            if (!options.allowPrototypes) {
	                return;
	            }
	        }
	        keys.push(segment[1]);
	    }
	
	    // If there's a remainder, just add whatever is left
	
	    if (segment) {
	        keys.push('[' + key.slice(segment.index) + ']');
	    }
	
	    return parseObject(keys, val, options, valuesParsed);
	};
	
	var normalizeParseOptions = function normalizeParseOptions(opts) {
	    if (!opts) {
	        return defaults;
	    }
	
	    if (opts.decoder !== null && opts.decoder !== undefined && typeof opts.decoder !== 'function') {
	        throw new TypeError('Decoder has to be a function.');
	    }
	
	    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') {
	        throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
	    }
	    var charset = typeof opts.charset === 'undefined' ? defaults.charset : opts.charset;
	
	    return {
	        allowDots: typeof opts.allowDots === 'undefined' ? defaults.allowDots : !!opts.allowDots,
	        allowPrototypes: typeof opts.allowPrototypes === 'boolean' ? opts.allowPrototypes : defaults.allowPrototypes,
	        arrayLimit: typeof opts.arrayLimit === 'number' ? opts.arrayLimit : defaults.arrayLimit,
	        charset: charset,
	        charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : defaults.charsetSentinel,
	        comma: typeof opts.comma === 'boolean' ? opts.comma : defaults.comma,
	        decoder: typeof opts.decoder === 'function' ? opts.decoder : defaults.decoder,
	        delimiter: typeof opts.delimiter === 'string' || utils.isRegExp(opts.delimiter) ? opts.delimiter : defaults.delimiter,
	        // eslint-disable-next-line no-implicit-coercion, no-extra-parens
	        depth: (typeof opts.depth === 'number' || opts.depth === false) ? +opts.depth : defaults.depth,
	        ignoreQueryPrefix: opts.ignoreQueryPrefix === true,
	        interpretNumericEntities: typeof opts.interpretNumericEntities === 'boolean' ? opts.interpretNumericEntities : defaults.interpretNumericEntities,
	        parameterLimit: typeof opts.parameterLimit === 'number' ? opts.parameterLimit : defaults.parameterLimit,
	        parseArrays: opts.parseArrays !== false,
	        plainObjects: typeof opts.plainObjects === 'boolean' ? opts.plainObjects : defaults.plainObjects,
	        strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : defaults.strictNullHandling
	    };
	};
	
	module.exports = function (str, opts) {
	    var options = normalizeParseOptions(opts);
	
	    if (str === '' || str === null || typeof str === 'undefined') {
	        return options.plainObjects ? Object.create(null) : {};
	    }
	
	    var tempObj = typeof str === 'string' ? parseValues(str, options) : str;
	    var obj = options.plainObjects ? Object.create(null) : {};
	
	    // Iterate over the keys and setup the new object
	
	    var keys = Object.keys(tempObj);
	    for (var i = 0; i < keys.length; ++i) {
	        var key = keys[i];
	        var newObj = parseKeys(key, tempObj[key], options, typeof str === 'string');
	        obj = utils.merge(obj, newObj, options);
	    }
	
	    return utils.compact(obj);
	};


/***/ }),
/* 1477 */
/***/ (function(module, exports, __webpack_require__) {

	var basePick = __webpack_require__(1478),
	    flatRest = __webpack_require__(1388);
	
	/**
	 * Creates an object composed of the picked `object` properties.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The source object.
	 * @param {...(string|string[])} [paths] The property paths to pick.
	 * @returns {Object} Returns the new object.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': '2', 'c': 3 };
	 *
	 * _.pick(object, ['a', 'c']);
	 * // => { 'a': 1, 'c': 3 }
	 */
	var pick = flatRest(function(object, paths) {
	  return object == null ? {} : basePick(object, paths);
	});
	
	module.exports = pick;


/***/ }),
/* 1478 */
/***/ (function(module, exports, __webpack_require__) {

	var basePickBy = __webpack_require__(1164),
	    hasIn = __webpack_require__(1015);
	
	/**
	 * The base implementation of `_.pick` without support for individual
	 * property identifiers.
	 *
	 * @private
	 * @param {Object} object The source object.
	 * @param {string[]} paths The property paths to pick.
	 * @returns {Object} Returns the new object.
	 */
	function basePick(object, paths) {
	  return basePickBy(object, paths, function(value, path) {
	    return hasIn(object, path);
	  });
	}
	
	module.exports = basePick;


/***/ }),
/* 1479 */
/***/ (function(module, exports, __webpack_require__) {

	var baseAssignValue = __webpack_require__(772),
	    baseForOwn = __webpack_require__(995),
	    baseIteratee = __webpack_require__(997);
	
	/**
	 * The opposite of `_.mapValues`; this method creates an object with the
	 * same values as `object` and keys generated by running each own enumerable
	 * string keyed property of `object` thru `iteratee`. The iteratee is invoked
	 * with three arguments: (value, key, object).
	 *
	 * @static
	 * @memberOf _
	 * @since 3.8.0
	 * @category Object
	 * @param {Object} object The object to iterate over.
	 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	 * @returns {Object} Returns the new mapped object.
	 * @see _.mapValues
	 * @example
	 *
	 * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
	 *   return key + value;
	 * });
	 * // => { 'a1': 1, 'b2': 2 }
	 */
	function mapKeys(object, iteratee) {
	  var result = {};
	  iteratee = baseIteratee(iteratee, 3);
	
	  baseForOwn(object, function(value, key, object) {
	    baseAssignValue(result, iteratee(value, key, object), value);
	  });
	  return result;
	}
	
	module.exports = mapKeys;


/***/ }),
/* 1480 */
/***/ (function(module, exports, __webpack_require__) {

	var baseAssignValue = __webpack_require__(772),
	    baseForOwn = __webpack_require__(995),
	    baseIteratee = __webpack_require__(997);
	
	/**
	 * Creates an object with the same keys as `object` and values generated
	 * by running each own enumerable string keyed property of `object` thru
	 * `iteratee`. The iteratee is invoked with three arguments:
	 * (value, key, object).
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Object
	 * @param {Object} object The object to iterate over.
	 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	 * @returns {Object} Returns the new mapped object.
	 * @see _.mapKeys
	 * @example
	 *
	 * var users = {
	 *   'fred':    { 'user': 'fred',    'age': 40 },
	 *   'pebbles': { 'user': 'pebbles', 'age': 1 }
	 * };
	 *
	 * _.mapValues(users, function(o) { return o.age; });
	 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.mapValues(users, 'age');
	 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	 */
	function mapValues(object, iteratee) {
	  var result = {};
	  iteratee = baseIteratee(iteratee, 3);
	
	  baseForOwn(object, function(value, key, object) {
	    baseAssignValue(result, key, iteratee(value, key, object));
	  });
	  return result;
	}
	
	module.exports = mapValues;


/***/ }),
/* 1481 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = '2.15.0';


/***/ }),
/* 1482 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.connect = exports.Provider = undefined;
	
	var _connect = __webpack_require__(1483);
	
	var _connect2 = _interopRequireDefault(_connect);
	
	var _Provider = __webpack_require__(1485);
	
	var _Provider2 = _interopRequireDefault(_Provider);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Provider = _Provider2.default;
	exports.connect = _connect2.default;


/***/ }),
/* 1483 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.default = connect;
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactAddonsShallowCompare = __webpack_require__(1321);
	
	var _reactAddonsShallowCompare2 = _interopRequireDefault(_reactAddonsShallowCompare);
	
	var _storeShape = __webpack_require__(1484);
	
	var _storeShape2 = _interopRequireDefault(_storeShape);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var getDisplayName = function getDisplayName(WrappedComponent) {
	  return WrappedComponent.displayName || WrappedComponent.name || 'UnknownComponent';
	};
	
	function connect(mapStateToProps) {
	  return function (WrappedComponent) {
	    var _class, _temp;
	
	    return _temp = _class = function (_Component) {
	      _inherits(Connect, _Component);
	
	      function Connect(props, context) {
	        _classCallCheck(this, Connect);
	
	        var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(Connect).call(this));
	
	        if (mapStateToProps) {
	          _this.state = mapStateToProps(context.algoliaStore.getState(), props);
	
	          _this.unsubscribe = context.algoliaStore.subscribe(function () {
	            _this.setState(mapStateToProps(context.algoliaStore.getState(), _this.props));
	          });
	        }
	        return _this;
	      }
	
	      _createClass(Connect, [{
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	          if (this.unsubscribe) {
	            this.unsubscribe();
	          }
	        }
	      }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	          if (mapStateToProps) {
	            this.setState(mapStateToProps(this.context.algoliaStore.getState(), nextProps));
	          }
	        }
	      }, {
	        key: 'shouldComponentUpdate',
	        value: function shouldComponentUpdate(nextProps, nextState) {
	          return (0, _reactAddonsShallowCompare2.default)(this, nextProps, nextState);
	        }
	      }, {
	        key: 'render',
	        value: function render() {
	          return _react2.default.createElement(WrappedComponent, _extends({}, this.props, this.state, {
	            helper: this.context.algoliaStore.getHelper()
	          }));
	        }
	      }]);
	
	      return Connect;
	    }(_react.Component), _class.contextTypes = { algoliaStore: _storeShape2.default.isRequired }, _class.displayName = 'AlgoliaSearchHelperConnect(' + getDisplayName(WrappedComponent) + ')', _temp;
	  };
	}

/***/ }),
/* 1484 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(300);
	
	exports.default = _react.PropTypes.shape({
	  getHelper: _react.PropTypes.func.isRequired,
	  getState: _react.PropTypes.func.isRequired,
	  subscribe: _react.PropTypes.func.isRequired
	});

/***/ }),
/* 1485 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _createStore = __webpack_require__(1486);
	
	var _createStore2 = _interopRequireDefault(_createStore);
	
	var _storeShape = __webpack_require__(1484);
	
	var _storeShape2 = _interopRequireDefault(_storeShape);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Provider = function (_Component) {
	  _inherits(Provider, _Component);
	
	  function Provider(props) {
	    _classCallCheck(this, Provider);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(Provider).call(this, props));
	
	    _this.store = (0, _createStore2.default)(props.helper);
	    return _this;
	  }
	
	  _createClass(Provider, [{
	    key: 'getChildContext',
	    value: function getChildContext() {
	      return {
	        algoliaStore: this.store
	      };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react.Children.only(this.props.children);
	    }
	  }]);
	
	  return Provider;
	}(_react.Component);
	
	Provider.propTypes = {
	  helper: _react.PropTypes.object.isRequired,
	  children: _react.PropTypes.node.isRequired
	};
	Provider.childContextTypes = {
	  algoliaStore: _storeShape2.default.isRequired
	};
	exports.default = Provider;

/***/ }),
/* 1486 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = createStore;
	function createStore(helper) {
	  var state = {
	    searching: false,
	    searchParameters: helper.getState(),
	    searchResults: null,
	    searchResultsSearchParameters: null,
	    searchError: null
	  };
	  var listeners = [];
	  var dispatch = function dispatch() {
	    listeners.forEach(function (listener) {
	      return listener();
	    });
	  };
	
	  helper.on('change', function (searchParameters) {
	    state = _extends({}, state, {
	      searchParameters: searchParameters
	    });
	    dispatch();
	  });
	
	  helper.on('search', function () {
	    state = _extends({}, state, {
	      searching: true
	    });
	    dispatch();
	  });
	
	  helper.on('result', function (searchResults, searchParameters) {
	    state = _extends({}, state, {
	      searching: false,
	      searchResults: searchResults,
	      searchResultsSearchParameters: searchParameters
	    });
	    dispatch();
	  });
	
	  helper.on('error', function (searchError) {
	    state = _extends({}, state, {
	      searching: false,
	      searchError: searchError
	    });
	    dispatch();
	  });
	
	  return {
	    getHelper: function getHelper() {
	      return helper;
	    },
	    getState: function getState() {
	      return state;
	    },
	    subscribe: function subscribe(listener) {
	      listeners.push(listener);
	      return function unsubscribe() {
	        listeners.splice(listeners.indexOf(listener));
	      };
	    }
	  };
	}

/***/ }),
/* 1487 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1488);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _regenerator = _interopRequireDefault(__webpack_require__(1489));
	
	var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(1491));
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(1492));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(1493));
	
	var _Configuration = __webpack_require__(1494);
	
	var _typesense = __webpack_require__(1495);
	
	var _SearchRequestAdapter = __webpack_require__(1579);
	
	var _SearchResponseAdapter = __webpack_require__(1584);
	
	var _FacetSearchResponseAdapter = __webpack_require__(1587);
	
	var TypesenseInstantsearchAdapter = /*#__PURE__*/function () {
	  function TypesenseInstantsearchAdapter(options) {
	    var _this = this;
	
	    (0, _classCallCheck2["default"])(this, TypesenseInstantsearchAdapter);
	    this.configuration = new _Configuration.Configuration(options);
	    this.configuration.validate();
	    this.typesenseClient = new _typesense.SearchClient(this.configuration.server);
	    this.searchClient = {
	      search: function search(instantsearchRequests) {
	        return _this.searchTypesenseAndAdapt(instantsearchRequests);
	      },
	      searchForFacetValues: function searchForFacetValues(instantsearchRequests) {
	        return _this.searchTypesenseForFacetValuesAndAdapt(instantsearchRequests);
	      }
	    };
	  }
	
	  (0, _createClass2["default"])(TypesenseInstantsearchAdapter, [{
	    key: "searchTypesenseAndAdapt",
	    value: function () {
	      var _searchTypesenseAndAdapt = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(instantsearchRequests) {
	        var _this2 = this;
	
	        var typesenseResponse, adaptedResponses;
	        return _regenerator["default"].wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                _context.prev = 0;
	                _context.next = 3;
	                return this._adaptAndPerformTypesenseRequest(instantsearchRequests);
	
	              case 3:
	                typesenseResponse = _context.sent;
	                adaptedResponses = typesenseResponse.results.map(function (typesenseResult, index) {
	                  _this2._validateTypesenseResult(typesenseResult);
	
	                  var responseAdapter = new _SearchResponseAdapter.SearchResponseAdapter(typesenseResult, instantsearchRequests[index], _this2.configuration);
	                  return responseAdapter.adapt();
	                });
	                return _context.abrupt("return", {
	                  results: adaptedResponses
	                });
	
	              case 8:
	                _context.prev = 8;
	                _context.t0 = _context["catch"](0);
	                console.error(_context.t0);
	                throw _context.t0;
	
	              case 12:
	              case "end":
	                return _context.stop();
	            }
	          }
	        }, _callee, this, [[0, 8]]);
	      }));
	
	      function searchTypesenseAndAdapt(_x) {
	        return _searchTypesenseAndAdapt.apply(this, arguments);
	      }
	
	      return searchTypesenseAndAdapt;
	    }()
	  }, {
	    key: "searchTypesenseForFacetValuesAndAdapt",
	    value: function () {
	      var _searchTypesenseForFacetValuesAndAdapt = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(instantsearchRequests) {
	        var _this3 = this;
	
	        var typesenseResponse, adaptedResponses;
	        return _regenerator["default"].wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                _context2.prev = 0;
	                _context2.next = 3;
	                return this._adaptAndPerformTypesenseRequest(instantsearchRequests);
	
	              case 3:
	                typesenseResponse = _context2.sent;
	                adaptedResponses = typesenseResponse.results.map(function (typesenseResult, index) {
	                  _this3._validateTypesenseResult(typesenseResult);
	
	                  var responseAdapter = new _FacetSearchResponseAdapter.FacetSearchResponseAdapter(typesenseResult, instantsearchRequests[index], _this3.configuration);
	                  return responseAdapter.adapt();
	                });
	                return _context2.abrupt("return", adaptedResponses);
	
	              case 8:
	                _context2.prev = 8;
	                _context2.t0 = _context2["catch"](0);
	                console.error(_context2.t0);
	                throw _context2.t0;
	
	              case 12:
	              case "end":
	                return _context2.stop();
	            }
	          }
	        }, _callee2, this, [[0, 8]]);
	      }));
	
	      function searchTypesenseForFacetValuesAndAdapt(_x2) {
	        return _searchTypesenseForFacetValuesAndAdapt.apply(this, arguments);
	      }
	
	      return searchTypesenseForFacetValuesAndAdapt;
	    }()
	  }, {
	    key: "_adaptAndPerformTypesenseRequest",
	    value: function () {
	      var _adaptAndPerformTypesenseRequest2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3(instantsearchRequests) {
	        var requestAdapter, typesenseResponse;
	        return _regenerator["default"].wrap(function _callee3$(_context3) {
	          while (1) {
	            switch (_context3.prev = _context3.next) {
	              case 0:
	                requestAdapter = new _SearchRequestAdapter.SearchRequestAdapter(instantsearchRequests, this.typesenseClient, this.configuration);
	                _context3.next = 3;
	                return requestAdapter.request();
	
	              case 3:
	                typesenseResponse = _context3.sent;
	                return _context3.abrupt("return", typesenseResponse);
	
	              case 5:
	              case "end":
	                return _context3.stop();
	            }
	          }
	        }, _callee3, this);
	      }));
	
	      function _adaptAndPerformTypesenseRequest(_x3) {
	        return _adaptAndPerformTypesenseRequest2.apply(this, arguments);
	      }
	
	      return _adaptAndPerformTypesenseRequest;
	    }()
	  }, {
	    key: "_validateTypesenseResult",
	    value: function _validateTypesenseResult(typesenseResult) {
	      if (typesenseResult.error) {
	        throw new Error("".concat(typesenseResult.code, " - ").concat(typesenseResult.error));
	      }
	
	      if (!typesenseResult.hits && !typesenseResult.grouped_hits) {
	        throw new Error("Did not find any hits. ".concat(typesenseResult.code, " - ").concat(typesenseResult.error));
	      }
	    }
	  }]);
	  return TypesenseInstantsearchAdapter;
	}();
	
	exports["default"] = TypesenseInstantsearchAdapter;
	//# sourceMappingURL=TypesenseInstantsearchAdapter.js.map

/***/ }),
/* 1488 */
/***/ (function(module, exports) {

	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : {
	    "default": obj
	  };
	}
	
	module.exports = _interopRequireDefault;
	module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),
/* 1489 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1490);


/***/ }),
/* 1490 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	var runtime = (function (exports) {
	  "use strict";
	
	  var Op = Object.prototype;
	  var hasOwn = Op.hasOwnProperty;
	  var undefined; // More compressible than void 0.
	  var $Symbol = typeof Symbol === "function" ? Symbol : {};
	  var iteratorSymbol = $Symbol.iterator || "@@iterator";
	  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
	  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
	
	  function wrap(innerFn, outerFn, self, tryLocsList) {
	    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
	    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
	    var generator = Object.create(protoGenerator.prototype);
	    var context = new Context(tryLocsList || []);
	
	    // The ._invoke method unifies the implementations of the .next,
	    // .throw, and .return methods.
	    generator._invoke = makeInvokeMethod(innerFn, self, context);
	
	    return generator;
	  }
	  exports.wrap = wrap;
	
	  // Try/catch helper to minimize deoptimizations. Returns a completion
	  // record like context.tryEntries[i].completion. This interface could
	  // have been (and was previously) designed to take a closure to be
	  // invoked without arguments, but in all the cases we care about we
	  // already have an existing method we want to call, so there's no need
	  // to create a new function object. We can even get away with assuming
	  // the method takes exactly one argument, since that happens to be true
	  // in every case, so we don't have to touch the arguments object. The
	  // only additional allocation required is the completion record, which
	  // has a stable shape and so hopefully should be cheap to allocate.
	  function tryCatch(fn, obj, arg) {
	    try {
	      return { type: "normal", arg: fn.call(obj, arg) };
	    } catch (err) {
	      return { type: "throw", arg: err };
	    }
	  }
	
	  var GenStateSuspendedStart = "suspendedStart";
	  var GenStateSuspendedYield = "suspendedYield";
	  var GenStateExecuting = "executing";
	  var GenStateCompleted = "completed";
	
	  // Returning this object from the innerFn has the same effect as
	  // breaking out of the dispatch switch statement.
	  var ContinueSentinel = {};
	
	  // Dummy constructor functions that we use as the .constructor and
	  // .constructor.prototype properties for functions that return Generator
	  // objects. For full spec compliance, you may wish to configure your
	  // minifier not to mangle the names of these two functions.
	  function Generator() {}
	  function GeneratorFunction() {}
	  function GeneratorFunctionPrototype() {}
	
	  // This is a polyfill for %IteratorPrototype% for environments that
	  // don't natively support it.
	  var IteratorPrototype = {};
	  IteratorPrototype[iteratorSymbol] = function () {
	    return this;
	  };
	
	  var getProto = Object.getPrototypeOf;
	  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
	  if (NativeIteratorPrototype &&
	      NativeIteratorPrototype !== Op &&
	      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
	    // This environment has a native %IteratorPrototype%; use it instead
	    // of the polyfill.
	    IteratorPrototype = NativeIteratorPrototype;
	  }
	
	  var Gp = GeneratorFunctionPrototype.prototype =
	    Generator.prototype = Object.create(IteratorPrototype);
	  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
	  GeneratorFunctionPrototype.constructor = GeneratorFunction;
	  GeneratorFunctionPrototype[toStringTagSymbol] =
	    GeneratorFunction.displayName = "GeneratorFunction";
	
	  // Helper for defining the .next, .throw, and .return methods of the
	  // Iterator interface in terms of a single ._invoke method.
	  function defineIteratorMethods(prototype) {
	    ["next", "throw", "return"].forEach(function(method) {
	      prototype[method] = function(arg) {
	        return this._invoke(method, arg);
	      };
	    });
	  }
	
	  exports.isGeneratorFunction = function(genFun) {
	    var ctor = typeof genFun === "function" && genFun.constructor;
	    return ctor
	      ? ctor === GeneratorFunction ||
	        // For the native GeneratorFunction constructor, the best we can
	        // do is to check its .name property.
	        (ctor.displayName || ctor.name) === "GeneratorFunction"
	      : false;
	  };
	
	  exports.mark = function(genFun) {
	    if (Object.setPrototypeOf) {
	      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
	    } else {
	      genFun.__proto__ = GeneratorFunctionPrototype;
	      if (!(toStringTagSymbol in genFun)) {
	        genFun[toStringTagSymbol] = "GeneratorFunction";
	      }
	    }
	    genFun.prototype = Object.create(Gp);
	    return genFun;
	  };
	
	  // Within the body of any async function, `await x` is transformed to
	  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
	  // `hasOwn.call(value, "__await")` to determine if the yielded value is
	  // meant to be awaited.
	  exports.awrap = function(arg) {
	    return { __await: arg };
	  };
	
	  function AsyncIterator(generator, PromiseImpl) {
	    function invoke(method, arg, resolve, reject) {
	      var record = tryCatch(generator[method], generator, arg);
	      if (record.type === "throw") {
	        reject(record.arg);
	      } else {
	        var result = record.arg;
	        var value = result.value;
	        if (value &&
	            typeof value === "object" &&
	            hasOwn.call(value, "__await")) {
	          return PromiseImpl.resolve(value.__await).then(function(value) {
	            invoke("next", value, resolve, reject);
	          }, function(err) {
	            invoke("throw", err, resolve, reject);
	          });
	        }
	
	        return PromiseImpl.resolve(value).then(function(unwrapped) {
	          // When a yielded Promise is resolved, its final value becomes
	          // the .value of the Promise<{value,done}> result for the
	          // current iteration.
	          result.value = unwrapped;
	          resolve(result);
	        }, function(error) {
	          // If a rejected Promise was yielded, throw the rejection back
	          // into the async generator function so it can be handled there.
	          return invoke("throw", error, resolve, reject);
	        });
	      }
	    }
	
	    var previousPromise;
	
	    function enqueue(method, arg) {
	      function callInvokeWithMethodAndArg() {
	        return new PromiseImpl(function(resolve, reject) {
	          invoke(method, arg, resolve, reject);
	        });
	      }
	
	      return previousPromise =
	        // If enqueue has been called before, then we want to wait until
	        // all previous Promises have been resolved before calling invoke,
	        // so that results are always delivered in the correct order. If
	        // enqueue has not been called before, then it is important to
	        // call invoke immediately, without waiting on a callback to fire,
	        // so that the async generator function has the opportunity to do
	        // any necessary setup in a predictable way. This predictability
	        // is why the Promise constructor synchronously invokes its
	        // executor callback, and why async functions synchronously
	        // execute code before the first await. Since we implement simple
	        // async functions in terms of async generators, it is especially
	        // important to get this right, even though it requires care.
	        previousPromise ? previousPromise.then(
	          callInvokeWithMethodAndArg,
	          // Avoid propagating failures to Promises returned by later
	          // invocations of the iterator.
	          callInvokeWithMethodAndArg
	        ) : callInvokeWithMethodAndArg();
	    }
	
	    // Define the unified helper method that is used to implement .next,
	    // .throw, and .return (see defineIteratorMethods).
	    this._invoke = enqueue;
	  }
	
	  defineIteratorMethods(AsyncIterator.prototype);
	  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
	    return this;
	  };
	  exports.AsyncIterator = AsyncIterator;
	
	  // Note that simple async functions are implemented on top of
	  // AsyncIterator objects; they just return a Promise for the value of
	  // the final result produced by the iterator.
	  exports.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
	    if (PromiseImpl === void 0) PromiseImpl = Promise;
	
	    var iter = new AsyncIterator(
	      wrap(innerFn, outerFn, self, tryLocsList),
	      PromiseImpl
	    );
	
	    return exports.isGeneratorFunction(outerFn)
	      ? iter // If outerFn is a generator, return the full iterator.
	      : iter.next().then(function(result) {
	          return result.done ? result.value : iter.next();
	        });
	  };
	
	  function makeInvokeMethod(innerFn, self, context) {
	    var state = GenStateSuspendedStart;
	
	    return function invoke(method, arg) {
	      if (state === GenStateExecuting) {
	        throw new Error("Generator is already running");
	      }
	
	      if (state === GenStateCompleted) {
	        if (method === "throw") {
	          throw arg;
	        }
	
	        // Be forgiving, per 25.3.3.3.3 of the spec:
	        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
	        return doneResult();
	      }
	
	      context.method = method;
	      context.arg = arg;
	
	      while (true) {
	        var delegate = context.delegate;
	        if (delegate) {
	          var delegateResult = maybeInvokeDelegate(delegate, context);
	          if (delegateResult) {
	            if (delegateResult === ContinueSentinel) continue;
	            return delegateResult;
	          }
	        }
	
	        if (context.method === "next") {
	          // Setting context._sent for legacy support of Babel's
	          // function.sent implementation.
	          context.sent = context._sent = context.arg;
	
	        } else if (context.method === "throw") {
	          if (state === GenStateSuspendedStart) {
	            state = GenStateCompleted;
	            throw context.arg;
	          }
	
	          context.dispatchException(context.arg);
	
	        } else if (context.method === "return") {
	          context.abrupt("return", context.arg);
	        }
	
	        state = GenStateExecuting;
	
	        var record = tryCatch(innerFn, self, context);
	        if (record.type === "normal") {
	          // If an exception is thrown from innerFn, we leave state ===
	          // GenStateExecuting and loop back for another invocation.
	          state = context.done
	            ? GenStateCompleted
	            : GenStateSuspendedYield;
	
	          if (record.arg === ContinueSentinel) {
	            continue;
	          }
	
	          return {
	            value: record.arg,
	            done: context.done
	          };
	
	        } else if (record.type === "throw") {
	          state = GenStateCompleted;
	          // Dispatch the exception by looping back around to the
	          // context.dispatchException(context.arg) call above.
	          context.method = "throw";
	          context.arg = record.arg;
	        }
	      }
	    };
	  }
	
	  // Call delegate.iterator[context.method](context.arg) and handle the
	  // result, either by returning a { value, done } result from the
	  // delegate iterator, or by modifying context.method and context.arg,
	  // setting context.delegate to null, and returning the ContinueSentinel.
	  function maybeInvokeDelegate(delegate, context) {
	    var method = delegate.iterator[context.method];
	    if (method === undefined) {
	      // A .throw or .return when the delegate iterator has no .throw
	      // method always terminates the yield* loop.
	      context.delegate = null;
	
	      if (context.method === "throw") {
	        // Note: ["return"] must be used for ES3 parsing compatibility.
	        if (delegate.iterator["return"]) {
	          // If the delegate iterator has a return method, give it a
	          // chance to clean up.
	          context.method = "return";
	          context.arg = undefined;
	          maybeInvokeDelegate(delegate, context);
	
	          if (context.method === "throw") {
	            // If maybeInvokeDelegate(context) changed context.method from
	            // "return" to "throw", let that override the TypeError below.
	            return ContinueSentinel;
	          }
	        }
	
	        context.method = "throw";
	        context.arg = new TypeError(
	          "The iterator does not provide a 'throw' method");
	      }
	
	      return ContinueSentinel;
	    }
	
	    var record = tryCatch(method, delegate.iterator, context.arg);
	
	    if (record.type === "throw") {
	      context.method = "throw";
	      context.arg = record.arg;
	      context.delegate = null;
	      return ContinueSentinel;
	    }
	
	    var info = record.arg;
	
	    if (! info) {
	      context.method = "throw";
	      context.arg = new TypeError("iterator result is not an object");
	      context.delegate = null;
	      return ContinueSentinel;
	    }
	
	    if (info.done) {
	      // Assign the result of the finished delegate to the temporary
	      // variable specified by delegate.resultName (see delegateYield).
	      context[delegate.resultName] = info.value;
	
	      // Resume execution at the desired location (see delegateYield).
	      context.next = delegate.nextLoc;
	
	      // If context.method was "throw" but the delegate handled the
	      // exception, let the outer generator proceed normally. If
	      // context.method was "next", forget context.arg since it has been
	      // "consumed" by the delegate iterator. If context.method was
	      // "return", allow the original .return call to continue in the
	      // outer generator.
	      if (context.method !== "return") {
	        context.method = "next";
	        context.arg = undefined;
	      }
	
	    } else {
	      // Re-yield the result returned by the delegate method.
	      return info;
	    }
	
	    // The delegate iterator is finished, so forget it and continue with
	    // the outer generator.
	    context.delegate = null;
	    return ContinueSentinel;
	  }
	
	  // Define Generator.prototype.{next,throw,return} in terms of the
	  // unified ._invoke helper method.
	  defineIteratorMethods(Gp);
	
	  Gp[toStringTagSymbol] = "Generator";
	
	  // A Generator should always return itself as the iterator object when the
	  // @@iterator function is called on it. Some browsers' implementations of the
	  // iterator prototype chain incorrectly implement this, causing the Generator
	  // object to not be returned from this call. This ensures that doesn't happen.
	  // See https://github.com/facebook/regenerator/issues/274 for more details.
	  Gp[iteratorSymbol] = function() {
	    return this;
	  };
	
	  Gp.toString = function() {
	    return "[object Generator]";
	  };
	
	  function pushTryEntry(locs) {
	    var entry = { tryLoc: locs[0] };
	
	    if (1 in locs) {
	      entry.catchLoc = locs[1];
	    }
	
	    if (2 in locs) {
	      entry.finallyLoc = locs[2];
	      entry.afterLoc = locs[3];
	    }
	
	    this.tryEntries.push(entry);
	  }
	
	  function resetTryEntry(entry) {
	    var record = entry.completion || {};
	    record.type = "normal";
	    delete record.arg;
	    entry.completion = record;
	  }
	
	  function Context(tryLocsList) {
	    // The root entry object (effectively a try statement without a catch
	    // or a finally block) gives us a place to store values thrown from
	    // locations where there is no enclosing try statement.
	    this.tryEntries = [{ tryLoc: "root" }];
	    tryLocsList.forEach(pushTryEntry, this);
	    this.reset(true);
	  }
	
	  exports.keys = function(object) {
	    var keys = [];
	    for (var key in object) {
	      keys.push(key);
	    }
	    keys.reverse();
	
	    // Rather than returning an object with a next method, we keep
	    // things simple and return the next function itself.
	    return function next() {
	      while (keys.length) {
	        var key = keys.pop();
	        if (key in object) {
	          next.value = key;
	          next.done = false;
	          return next;
	        }
	      }
	
	      // To avoid creating an additional object, we just hang the .value
	      // and .done properties off the next function object itself. This
	      // also ensures that the minifier will not anonymize the function.
	      next.done = true;
	      return next;
	    };
	  };
	
	  function values(iterable) {
	    if (iterable) {
	      var iteratorMethod = iterable[iteratorSymbol];
	      if (iteratorMethod) {
	        return iteratorMethod.call(iterable);
	      }
	
	      if (typeof iterable.next === "function") {
	        return iterable;
	      }
	
	      if (!isNaN(iterable.length)) {
	        var i = -1, next = function next() {
	          while (++i < iterable.length) {
	            if (hasOwn.call(iterable, i)) {
	              next.value = iterable[i];
	              next.done = false;
	              return next;
	            }
	          }
	
	          next.value = undefined;
	          next.done = true;
	
	          return next;
	        };
	
	        return next.next = next;
	      }
	    }
	
	    // Return an iterator with no values.
	    return { next: doneResult };
	  }
	  exports.values = values;
	
	  function doneResult() {
	    return { value: undefined, done: true };
	  }
	
	  Context.prototype = {
	    constructor: Context,
	
	    reset: function(skipTempReset) {
	      this.prev = 0;
	      this.next = 0;
	      // Resetting context._sent for legacy support of Babel's
	      // function.sent implementation.
	      this.sent = this._sent = undefined;
	      this.done = false;
	      this.delegate = null;
	
	      this.method = "next";
	      this.arg = undefined;
	
	      this.tryEntries.forEach(resetTryEntry);
	
	      if (!skipTempReset) {
	        for (var name in this) {
	          // Not sure about the optimal order of these conditions:
	          if (name.charAt(0) === "t" &&
	              hasOwn.call(this, name) &&
	              !isNaN(+name.slice(1))) {
	            this[name] = undefined;
	          }
	        }
	      }
	    },
	
	    stop: function() {
	      this.done = true;
	
	      var rootEntry = this.tryEntries[0];
	      var rootRecord = rootEntry.completion;
	      if (rootRecord.type === "throw") {
	        throw rootRecord.arg;
	      }
	
	      return this.rval;
	    },
	
	    dispatchException: function(exception) {
	      if (this.done) {
	        throw exception;
	      }
	
	      var context = this;
	      function handle(loc, caught) {
	        record.type = "throw";
	        record.arg = exception;
	        context.next = loc;
	
	        if (caught) {
	          // If the dispatched exception was caught by a catch block,
	          // then let that catch block handle the exception normally.
	          context.method = "next";
	          context.arg = undefined;
	        }
	
	        return !! caught;
	      }
	
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        var record = entry.completion;
	
	        if (entry.tryLoc === "root") {
	          // Exception thrown outside of any try block that could handle
	          // it, so set the completion value of the entire function to
	          // throw the exception.
	          return handle("end");
	        }
	
	        if (entry.tryLoc <= this.prev) {
	          var hasCatch = hasOwn.call(entry, "catchLoc");
	          var hasFinally = hasOwn.call(entry, "finallyLoc");
	
	          if (hasCatch && hasFinally) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            } else if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else if (hasCatch) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            }
	
	          } else if (hasFinally) {
	            if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else {
	            throw new Error("try statement without catch or finally");
	          }
	        }
	      }
	    },
	
	    abrupt: function(type, arg) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc <= this.prev &&
	            hasOwn.call(entry, "finallyLoc") &&
	            this.prev < entry.finallyLoc) {
	          var finallyEntry = entry;
	          break;
	        }
	      }
	
	      if (finallyEntry &&
	          (type === "break" ||
	           type === "continue") &&
	          finallyEntry.tryLoc <= arg &&
	          arg <= finallyEntry.finallyLoc) {
	        // Ignore the finally entry if control is not jumping to a
	        // location outside the try/catch block.
	        finallyEntry = null;
	      }
	
	      var record = finallyEntry ? finallyEntry.completion : {};
	      record.type = type;
	      record.arg = arg;
	
	      if (finallyEntry) {
	        this.method = "next";
	        this.next = finallyEntry.finallyLoc;
	        return ContinueSentinel;
	      }
	
	      return this.complete(record);
	    },
	
	    complete: function(record, afterLoc) {
	      if (record.type === "throw") {
	        throw record.arg;
	      }
	
	      if (record.type === "break" ||
	          record.type === "continue") {
	        this.next = record.arg;
	      } else if (record.type === "return") {
	        this.rval = this.arg = record.arg;
	        this.method = "return";
	        this.next = "end";
	      } else if (record.type === "normal" && afterLoc) {
	        this.next = afterLoc;
	      }
	
	      return ContinueSentinel;
	    },
	
	    finish: function(finallyLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.finallyLoc === finallyLoc) {
	          this.complete(entry.completion, entry.afterLoc);
	          resetTryEntry(entry);
	          return ContinueSentinel;
	        }
	      }
	    },
	
	    "catch": function(tryLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc === tryLoc) {
	          var record = entry.completion;
	          if (record.type === "throw") {
	            var thrown = record.arg;
	            resetTryEntry(entry);
	          }
	          return thrown;
	        }
	      }
	
	      // The context.catch method must only be called with a location
	      // argument that corresponds to a known catch block.
	      throw new Error("illegal catch attempt");
	    },
	
	    delegateYield: function(iterable, resultName, nextLoc) {
	      this.delegate = {
	        iterator: values(iterable),
	        resultName: resultName,
	        nextLoc: nextLoc
	      };
	
	      if (this.method === "next") {
	        // Deliberately forget the last sent value so that we don't
	        // accidentally pass it on to the delegate.
	        this.arg = undefined;
	      }
	
	      return ContinueSentinel;
	    }
	  };
	
	  // Regardless of whether this script is executing as a CommonJS module
	  // or not, return the runtime object so that we can declare the variable
	  // regeneratorRuntime in the outer scope, which allows this module to be
	  // injected easily by `bin/regenerator --include-runtime script.js`.
	  return exports;
	
	}(
	  // If this script is executing as a CommonJS module, use module.exports
	  // as the regeneratorRuntime namespace. Otherwise create a new empty
	  // object. Either way, the resulting object will be used to initialize
	  // the regeneratorRuntime variable at the top of this file.
	   true ? module.exports : {}
	));
	
	try {
	  regeneratorRuntime = runtime;
	} catch (accidentalStrictMode) {
	  // This module should not be running in strict mode, so the above
	  // assignment should always work unless something is misconfigured. Just
	  // in case runtime.js accidentally runs in strict mode, we can escape
	  // strict mode using a global Function call. This could conceivably fail
	  // if a Content Security Policy forbids using Function, but in that case
	  // the proper solution is to fix the accidental strict mode problem. If
	  // you've misconfigured your bundler to force strict mode and applied a
	  // CSP to forbid Function, and you're not willing to fix either of those
	  // problems, please detail your unique predicament in a GitHub issue.
	  Function("r", "regeneratorRuntime = r")(runtime);
	}


/***/ }),
/* 1491 */
/***/ (function(module, exports) {

	function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
	  try {
	    var info = gen[key](arg);
	    var value = info.value;
	  } catch (error) {
	    reject(error);
	    return;
	  }
	
	  if (info.done) {
	    resolve(value);
	  } else {
	    Promise.resolve(value).then(_next, _throw);
	  }
	}
	
	function _asyncToGenerator(fn) {
	  return function () {
	    var self = this,
	        args = arguments;
	    return new Promise(function (resolve, reject) {
	      var gen = fn.apply(self, args);
	
	      function _next(value) {
	        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
	      }
	
	      function _throw(err) {
	        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
	      }
	
	      _next(undefined);
	    });
	  };
	}
	
	module.exports = _asyncToGenerator;
	module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),
/* 1492 */
/***/ (function(module, exports) {

	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	module.exports = _classCallCheck;
	module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),
/* 1493 */
/***/ (function(module, exports) {

	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];
	    descriptor.enumerable = descriptor.enumerable || false;
	    descriptor.configurable = true;
	    if ("value" in descriptor) descriptor.writable = true;
	    Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
	  if (staticProps) _defineProperties(Constructor, staticProps);
	  return Constructor;
	}
	
	module.exports = _createClass;
	module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),
/* 1494 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1488);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Configuration = void 0;
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(1492));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(1493));
	
	var Configuration = /*#__PURE__*/function () {
	  function Configuration() {
	    var _this = this;
	
	    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    (0, _classCallCheck2["default"])(this, Configuration);
	    this.server = options.server || {
	      nodes: [{
	        host: "localhost",
	        port: "8108",
	        path: "",
	        protocol: "http"
	      }]
	    };
	    this.server.cacheSearchResultsForSeconds = this.server.cacheSearchResultsForSeconds == null ? 2 * 60 : this.server.cacheSearchResultsForSeconds;
	    this.additionalSearchParameters = options.additionalSearchParameters || {};
	    this.additionalSearchParameters.queryBy = this.additionalSearchParameters.queryBy || "";
	    this.additionalSearchParameters.sortBy = this.additionalSearchParameters.sortBy || "";
	    this.additionalSearchParameters.highlightFullFields = this.additionalSearchParameters.highlightFullFields || this.additionalSearchParameters.queryBy;
	    this.geoLocationField = options.geoLocationField || "_geoloc";
	    this.collectionSpecificSearchParameters = options.collectionSpecificSearchParameters || {};
	    Object.keys(this.collectionSpecificSearchParameters).forEach(function (collection) {
	      var overrideHighlightFullFields = _this.collectionSpecificSearchParameters[collection].highlightFullFields || _this.collectionSpecificSearchParameters[collection].queryBy;
	
	      if (overrideHighlightFullFields) {
	        _this.collectionSpecificSearchParameters[collection].highlightFullFields = overrideHighlightFullFields;
	      }
	    });
	  }
	  /*
	   * Either additionalSearchParameters.queryBy needs to be set, or
	   *   All collectionSpecificSearchParameters need to have queryBy
	   *
	   * */
	
	
	  (0, _createClass2["default"])(Configuration, [{
	    key: "validate",
	    value: function validate() {
	      if (this.additionalSearchParameters.queryBy.length === 0 && Object.values(this.collectionSpecificSearchParameters).some(function (c) {
	        return (c.queryBy || "").length === 0;
	      })) {
	        throw new Error("Missing parameter: Either additionalSearchParameters.queryBy needs to be set, or all collectionSpecificSearchParameters need to have .queryBy set");
	      }
	    }
	  }]);
	  return Configuration;
	}();
	
	exports.Configuration = Configuration;
	//# sourceMappingURL=Configuration.js.map

/***/ }),
/* 1495 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1488);
	
	var _typeof = __webpack_require__(1496);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "Client", {
	  enumerable: true,
	  get: function get() {
	    return _Client.default;
	  }
	});
	Object.defineProperty(exports, "SearchClient", {
	  enumerable: true,
	  get: function get() {
	    return _SearchClient.default;
	  }
	});
	exports.Errors = void 0;
	
	var _Client = _interopRequireDefault(__webpack_require__(1497));
	
	var _SearchClient = _interopRequireDefault(__webpack_require__(1578));
	
	var Errors = _interopRequireWildcard(__webpack_require__(1500));
	
	exports.Errors = Errors;
	
	function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
	
	function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	//# sourceMappingURL=Typesense.js.map


/***/ }),
/* 1496 */
/***/ (function(module, exports) {

	function _typeof(obj) {
	  "@babel/helpers - typeof";
	
	  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
	    module.exports = _typeof = function _typeof(obj) {
	      return typeof obj;
	    };
	
	    module.exports["default"] = module.exports, module.exports.__esModule = true;
	  } else {
	    module.exports = _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
	    };
	
	    module.exports["default"] = module.exports, module.exports.__esModule = true;
	  }
	
	  return _typeof(obj);
	}
	
	module.exports = _typeof;
	module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),
/* 1497 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireDefault = __webpack_require__(1488);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(1492));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(1493));
	
	var _Configuration = _interopRequireDefault(__webpack_require__(1498));
	
	var _ApiCall = _interopRequireDefault(__webpack_require__(1520));
	
	var _Collections = _interopRequireDefault(__webpack_require__(1550));
	
	var _Collection = _interopRequireDefault(__webpack_require__(1551));
	
	var _Aliases = _interopRequireDefault(__webpack_require__(1565));
	
	var _Alias = _interopRequireDefault(__webpack_require__(1566));
	
	var _Keys = _interopRequireDefault(__webpack_require__(1567));
	
	var _Key = _interopRequireDefault(__webpack_require__(1572));
	
	var _Debug = _interopRequireDefault(__webpack_require__(1573));
	
	var _Metrics = _interopRequireDefault(__webpack_require__(1574));
	
	var _Health = _interopRequireDefault(__webpack_require__(1575));
	
	var _Operations = _interopRequireDefault(__webpack_require__(1576));
	
	var _MultiSearch = _interopRequireDefault(__webpack_require__(1577));
	
	var Client = /*#__PURE__*/function () {
	  function Client(options) {
	    (0, _classCallCheck2.default)(this, Client);
	    this.configuration = new _Configuration.default(options);
	    this._apiCall = new _ApiCall.default(this.configuration);
	    this.debug = new _Debug.default(this._apiCall);
	    this.metrics = new _Metrics.default(this._apiCall);
	    this.health = new _Health.default(this._apiCall);
	    this.operations = new _Operations.default(this._apiCall);
	    this.multiSearch = new _MultiSearch.default(this._apiCall, this.configuration);
	    this._collections = new _Collections.default(this._apiCall);
	    this._individualCollections = {};
	    this._aliases = new _Aliases.default(this._apiCall);
	    this._individualAliases = {};
	    this._keys = new _Keys.default(this._apiCall);
	    this._individualKeys = {};
	  }
	
	  (0, _createClass2.default)(Client, [{
	    key: "collections",
	    value: function collections(collectionName) {
	      if (collectionName === undefined) {
	        return this._collections;
	      } else {
	        if (this._individualCollections[collectionName] === undefined) {
	          this._individualCollections[collectionName] = new _Collection.default(collectionName, this._apiCall, this.configuration);
	        }
	
	        return this._individualCollections[collectionName];
	      }
	    }
	  }, {
	    key: "aliases",
	    value: function aliases(aliasName) {
	      if (aliasName === undefined) {
	        return this._aliases;
	      } else {
	        if (this._individualAliases[aliasName] === undefined) {
	          this._individualAliases[aliasName] = new _Alias.default(aliasName, this._apiCall);
	        }
	
	        return this._individualAliases[aliasName];
	      }
	    }
	  }, {
	    key: "keys",
	    value: function keys(id) {
	      if (id === undefined) {
	        return this._keys;
	      } else {
	        if (this._individualKeys[id] === undefined) {
	          this._individualKeys[id] = new _Key.default(id, this._apiCall);
	        }
	
	        return this._individualKeys[id];
	      }
	    }
	  }]);
	  return Client;
	}();
	
	exports.default = Client;
	//# sourceMappingURL=Client.js.map


/***/ }),
/* 1498 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireDefault = __webpack_require__(1488);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(1492));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(1493));
	
	var _loglevel = _interopRequireDefault(__webpack_require__(1499));
	
	var _Errors = __webpack_require__(1500);
	
	var Configuration = /*#__PURE__*/function () {
	  function Configuration() {
	    var _this = this;
	
	    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    (0, _classCallCheck2.default)(this, Configuration);
	    this.nodes = options.nodes || [];
	    this.nodes = this.nodes.map(function (node) {
	      return _this._setDefaultPathInNode(node);
	    }).map(function (node) {
	      return _this._setDefaultPortInNode(node);
	    });
	    this.nearestNode = options.nearestNode || null;
	    this.nearestNode = this._setDefaultPathInNode(this.nearestNode);
	    this.nearestNode = this._setDefaultPortInNode(this.nearestNode);
	    this.connectionTimeoutSeconds = options.connectionTimeoutSeconds || options.timeoutSeconds || 10;
	    this.healthcheckIntervalSeconds = options.healthcheckIntervalSeconds || 15;
	    this.numRetries = options.numRetries || this.nodes.length + (this.nearestNode == null ? 0 : 1) || 3;
	    this.retryIntervalSeconds = options.retryIntervalSeconds || 0.1;
	    this.apiKey = options.apiKey;
	    this.sendApiKeyAsQueryParam = options.sendApiKeyAsQueryParam || false;
	    this.cacheSearchResultsForSeconds = options.cacheSearchResultsForSeconds || 0; // Disable client-side cache by default
	
	    this.useServerSideSearchCache = options.useServerSideSearchCache || false;
	    this.logger = options.logger || _loglevel.default;
	    this.logLevel = options.logLevel || 'warn';
	    this.logger.setLevel(this.logLevel);
	
	    this._showDeprecationWarnings(options);
	
	    this.validate();
	  }
	
	  (0, _createClass2.default)(Configuration, [{
	    key: "validate",
	    value: function validate() {
	      if (this.nodes == null || this.nodes.length === 0 || this._validateNodes()) {
	        throw new _Errors.MissingConfigurationError('Ensure that nodes[].protocol, nodes[].host and nodes[].port are set');
	      }
	
	      if (this.nearestNode != null && this._isNodeMissingAnyParameters(this.nearestNode)) {
	        throw new _Errors.MissingConfigurationError('Ensure that nearestNodes.protocol, nearestNodes.host and nearestNodes.port are set');
	      }
	
	      if (this.apiKey == null) {
	        throw new _Errors.MissingConfigurationError('Ensure that apiKey is set');
	      }
	
	      return true;
	    }
	  }, {
	    key: "_validateNodes",
	    value: function _validateNodes() {
	      var _this2 = this;
	
	      return this.nodes.some(function (node) {
	        return _this2._isNodeMissingAnyParameters(node);
	      });
	    }
	  }, {
	    key: "_isNodeMissingAnyParameters",
	    value: function _isNodeMissingAnyParameters(node) {
	      return !['protocol', 'host', 'port', 'path'].every(function (key) {
	        return node.hasOwnProperty(key);
	      });
	    }
	  }, {
	    key: "_setDefaultPathInNode",
	    value: function _setDefaultPathInNode(node) {
	      if (node != null && !node.hasOwnProperty('path')) {
	        node.path = '';
	      }
	
	      return node;
	    }
	  }, {
	    key: "_setDefaultPortInNode",
	    value: function _setDefaultPortInNode(node) {
	      if (node != null && !node.hasOwnProperty('port') && node.hasOwnProperty('protocol')) {
	        switch (node.protocol) {
	          case 'https':
	            node.port = 443;
	            break;
	
	          case 'http':
	            node.port = 80;
	            break;
	        }
	      }
	
	      return node;
	    }
	  }, {
	    key: "_showDeprecationWarnings",
	    value: function _showDeprecationWarnings(options) {
	      if (options.timeoutSeconds) {
	        this.logger.warn('Deprecation warning: timeoutSeconds is now renamed to connectionTimeoutSeconds');
	      }
	
	      if (options.masterNode) {
	        this.logger.warn('Deprecation warning: masterNode is now consolidated to nodes, starting with Typesense Server v0.12');
	      }
	
	      if (options.readReplicaNodes) {
	        this.logger.warn('Deprecation warning: readReplicaNodes is now consolidated to nodes, starting with Typesense Server v0.12');
	      }
	    }
	  }]);
	  return Configuration;
	}();
	
	exports.default = Configuration;
	//# sourceMappingURL=Configuration.js.map


/***/ }),
/* 1499 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*
	* loglevel - https://github.com/pimterry/loglevel
	*
	* Copyright (c) 2013 Tim Perry
	* Licensed under the MIT license.
	*/
	(function (root, definition) {
	    "use strict";
	    if (true) {
	        !(__WEBPACK_AMD_DEFINE_FACTORY__ = (definition), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else if (typeof module === 'object' && module.exports) {
	        module.exports = definition();
	    } else {
	        root.log = definition();
	    }
	}(this, function () {
	    "use strict";
	
	    // Slightly dubious tricks to cut down minimized file size
	    var noop = function() {};
	    var undefinedType = "undefined";
	    var isIE = (typeof window !== undefinedType) && (typeof window.navigator !== undefinedType) && (
	        /Trident\/|MSIE /.test(window.navigator.userAgent)
	    );
	
	    var logMethods = [
	        "trace",
	        "debug",
	        "info",
	        "warn",
	        "error"
	    ];
	
	    // Cross-browser bind equivalent that works at least back to IE6
	    function bindMethod(obj, methodName) {
	        var method = obj[methodName];
	        if (typeof method.bind === 'function') {
	            return method.bind(obj);
	        } else {
	            try {
	                return Function.prototype.bind.call(method, obj);
	            } catch (e) {
	                // Missing bind shim or IE8 + Modernizr, fallback to wrapping
	                return function() {
	                    return Function.prototype.apply.apply(method, [obj, arguments]);
	                };
	            }
	        }
	    }
	
	    // Trace() doesn't print the message in IE, so for that case we need to wrap it
	    function traceForIE() {
	        if (console.log) {
	            if (console.log.apply) {
	                console.log.apply(console, arguments);
	            } else {
	                // In old IE, native console methods themselves don't have apply().
	                Function.prototype.apply.apply(console.log, [console, arguments]);
	            }
	        }
	        if (console.trace) console.trace();
	    }
	
	    // Build the best logging method possible for this env
	    // Wherever possible we want to bind, not wrap, to preserve stack traces
	    function realMethod(methodName) {
	        if (methodName === 'debug') {
	            methodName = 'log';
	        }
	
	        if (typeof console === undefinedType) {
	            return false; // No method possible, for now - fixed later by enableLoggingWhenConsoleArrives
	        } else if (methodName === 'trace' && isIE) {
	            return traceForIE;
	        } else if (console[methodName] !== undefined) {
	            return bindMethod(console, methodName);
	        } else if (console.log !== undefined) {
	            return bindMethod(console, 'log');
	        } else {
	            return noop;
	        }
	    }
	
	    // These private functions always need `this` to be set properly
	
	    function replaceLoggingMethods(level, loggerName) {
	        /*jshint validthis:true */
	        for (var i = 0; i < logMethods.length; i++) {
	            var methodName = logMethods[i];
	            this[methodName] = (i < level) ?
	                noop :
	                this.methodFactory(methodName, level, loggerName);
	        }
	
	        // Define log.log as an alias for log.debug
	        this.log = this.debug;
	    }
	
	    // In old IE versions, the console isn't present until you first open it.
	    // We build realMethod() replacements here that regenerate logging methods
	    function enableLoggingWhenConsoleArrives(methodName, level, loggerName) {
	        return function () {
	            if (typeof console !== undefinedType) {
	                replaceLoggingMethods.call(this, level, loggerName);
	                this[methodName].apply(this, arguments);
	            }
	        };
	    }
	
	    // By default, we use closely bound real methods wherever possible, and
	    // otherwise we wait for a console to appear, and then try again.
	    function defaultMethodFactory(methodName, level, loggerName) {
	        /*jshint validthis:true */
	        return realMethod(methodName) ||
	               enableLoggingWhenConsoleArrives.apply(this, arguments);
	    }
	
	    function Logger(name, defaultLevel, factory) {
	      var self = this;
	      var currentLevel;
	
	      var storageKey = "loglevel";
	      if (typeof name === "string") {
	        storageKey += ":" + name;
	      } else if (typeof name === "symbol") {
	        storageKey = undefined;
	      }
	
	      function persistLevelIfPossible(levelNum) {
	          var levelName = (logMethods[levelNum] || 'silent').toUpperCase();
	
	          if (typeof window === undefinedType || !storageKey) return;
	
	          // Use localStorage if available
	          try {
	              window.localStorage[storageKey] = levelName;
	              return;
	          } catch (ignore) {}
	
	          // Use session cookie as fallback
	          try {
	              window.document.cookie =
	                encodeURIComponent(storageKey) + "=" + levelName + ";";
	          } catch (ignore) {}
	      }
	
	      function getPersistedLevel() {
	          var storedLevel;
	
	          if (typeof window === undefinedType || !storageKey) return;
	
	          try {
	              storedLevel = window.localStorage[storageKey];
	          } catch (ignore) {}
	
	          // Fallback to cookies if local storage gives us nothing
	          if (typeof storedLevel === undefinedType) {
	              try {
	                  var cookie = window.document.cookie;
	                  var location = cookie.indexOf(
	                      encodeURIComponent(storageKey) + "=");
	                  if (location !== -1) {
	                      storedLevel = /^([^;]+)/.exec(cookie.slice(location))[1];
	                  }
	              } catch (ignore) {}
	          }
	
	          // If the stored level is not valid, treat it as if nothing was stored.
	          if (self.levels[storedLevel] === undefined) {
	              storedLevel = undefined;
	          }
	
	          return storedLevel;
	      }
	
	      /*
	       *
	       * Public logger API - see https://github.com/pimterry/loglevel for details
	       *
	       */
	
	      self.name = name;
	
	      self.levels = { "TRACE": 0, "DEBUG": 1, "INFO": 2, "WARN": 3,
	          "ERROR": 4, "SILENT": 5};
	
	      self.methodFactory = factory || defaultMethodFactory;
	
	      self.getLevel = function () {
	          return currentLevel;
	      };
	
	      self.setLevel = function (level, persist) {
	          if (typeof level === "string" && self.levels[level.toUpperCase()] !== undefined) {
	              level = self.levels[level.toUpperCase()];
	          }
	          if (typeof level === "number" && level >= 0 && level <= self.levels.SILENT) {
	              currentLevel = level;
	              if (persist !== false) {  // defaults to true
	                  persistLevelIfPossible(level);
	              }
	              replaceLoggingMethods.call(self, level, name);
	              if (typeof console === undefinedType && level < self.levels.SILENT) {
	                  return "No console available for logging";
	              }
	          } else {
	              throw "log.setLevel() called with invalid level: " + level;
	          }
	      };
	
	      self.setDefaultLevel = function (level) {
	          if (!getPersistedLevel()) {
	              self.setLevel(level, false);
	          }
	      };
	
	      self.enableAll = function(persist) {
	          self.setLevel(self.levels.TRACE, persist);
	      };
	
	      self.disableAll = function(persist) {
	          self.setLevel(self.levels.SILENT, persist);
	      };
	
	      // Initialize with the right level
	      var initialLevel = getPersistedLevel();
	      if (initialLevel == null) {
	          initialLevel = defaultLevel == null ? "WARN" : defaultLevel;
	      }
	      self.setLevel(initialLevel, false);
	    }
	
	    /*
	     *
	     * Top-level API
	     *
	     */
	
	    var defaultLogger = new Logger();
	
	    var _loggersByName = {};
	    defaultLogger.getLogger = function getLogger(name) {
	        if ((typeof name !== "symbol" && typeof name !== "string") || name === "") {
	          throw new TypeError("You must supply a name when creating a logger.");
	        }
	
	        var logger = _loggersByName[name];
	        if (!logger) {
	          logger = _loggersByName[name] = new Logger(
	            name, defaultLogger.getLevel(), defaultLogger.methodFactory);
	        }
	        return logger;
	    };
	
	    // Grab the current global log variable in case of overwrite
	    var _log = (typeof window !== undefinedType) ? window.log : undefined;
	    defaultLogger.noConflict = function() {
	        if (typeof window !== undefinedType &&
	               window.log === defaultLogger) {
	            window.log = _log;
	        }
	
	        return defaultLogger;
	    };
	
	    defaultLogger.getLoggers = function getLoggers() {
	        return _loggersByName;
	    };
	
	    // ES6 default export, for compatibility
	    defaultLogger['default'] = defaultLogger;
	
	    return defaultLogger;
	}));


/***/ }),
/* 1500 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireDefault = __webpack_require__(1488);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "HTTPError", {
	  enumerable: true,
	  get: function get() {
	    return _HTTPError.default;
	  }
	});
	Object.defineProperty(exports, "MissingConfigurationError", {
	  enumerable: true,
	  get: function get() {
	    return _MissingConfigurationError.default;
	  }
	});
	Object.defineProperty(exports, "ObjectAlreadyExists", {
	  enumerable: true,
	  get: function get() {
	    return _ObjectAlreadyExists.default;
	  }
	});
	Object.defineProperty(exports, "ObjectNotFound", {
	  enumerable: true,
	  get: function get() {
	    return _ObjectNotFound.default;
	  }
	});
	Object.defineProperty(exports, "ObjectUnprocessable", {
	  enumerable: true,
	  get: function get() {
	    return _ObjectUnprocessable.default;
	  }
	});
	Object.defineProperty(exports, "RequestMalformed", {
	  enumerable: true,
	  get: function get() {
	    return _RequestMalformed.default;
	  }
	});
	Object.defineProperty(exports, "RequestUnauthorized", {
	  enumerable: true,
	  get: function get() {
	    return _RequestUnauthorized.default;
	  }
	});
	Object.defineProperty(exports, "ServerError", {
	  enumerable: true,
	  get: function get() {
	    return _ServerError.default;
	  }
	});
	Object.defineProperty(exports, "ImportError", {
	  enumerable: true,
	  get: function get() {
	    return _ImportError.default;
	  }
	});
	Object.defineProperty(exports, "TypesenseError", {
	  enumerable: true,
	  get: function get() {
	    return _TypesenseError.default;
	  }
	});
	
	var _HTTPError = _interopRequireDefault(__webpack_require__(1501));
	
	var _MissingConfigurationError = _interopRequireDefault(__webpack_require__(1512));
	
	var _ObjectAlreadyExists = _interopRequireDefault(__webpack_require__(1513));
	
	var _ObjectNotFound = _interopRequireDefault(__webpack_require__(1514));
	
	var _ObjectUnprocessable = _interopRequireDefault(__webpack_require__(1515));
	
	var _RequestMalformed = _interopRequireDefault(__webpack_require__(1516));
	
	var _RequestUnauthorized = _interopRequireDefault(__webpack_require__(1517));
	
	var _ServerError = _interopRequireDefault(__webpack_require__(1518));
	
	var _ImportError = _interopRequireDefault(__webpack_require__(1519));
	
	var _TypesenseError = _interopRequireDefault(__webpack_require__(1507));
	//# sourceMappingURL=index.js.map


/***/ }),
/* 1501 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireDefault = __webpack_require__(1488);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(1492));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(1502));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(1504));
	
	var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(1506));
	
	var _TypesenseError2 = _interopRequireDefault(__webpack_require__(1507));
	
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
	
	var HTTPError = /*#__PURE__*/function (_TypesenseError) {
	  (0, _inherits2.default)(HTTPError, _TypesenseError);
	
	  var _super = _createSuper(HTTPError);
	
	  function HTTPError() {
	    (0, _classCallCheck2.default)(this, HTTPError);
	    return _super.apply(this, arguments);
	  }
	
	  return HTTPError;
	}(_TypesenseError2.default);
	
	exports.default = HTTPError;
	//# sourceMappingURL=HTTPError.js.map


/***/ }),
/* 1502 */
/***/ (function(module, exports, __webpack_require__) {

	var setPrototypeOf = __webpack_require__(1503);
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }
	
	  subClass.prototype = Object.create(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      writable: true,
	      configurable: true
	    }
	  });
	  if (superClass) setPrototypeOf(subClass, superClass);
	}
	
	module.exports = _inherits;
	module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),
/* 1503 */
/***/ (function(module, exports) {

	function _setPrototypeOf(o, p) {
	  module.exports = _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;
	    return o;
	  };
	
	  module.exports["default"] = module.exports, module.exports.__esModule = true;
	  return _setPrototypeOf(o, p);
	}
	
	module.exports = _setPrototypeOf;
	module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),
/* 1504 */
/***/ (function(module, exports, __webpack_require__) {

	var _typeof = __webpack_require__(1496)["default"];
	
	var assertThisInitialized = __webpack_require__(1505);
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  } else if (call !== void 0) {
	    throw new TypeError("Derived constructors may only return object or undefined");
	  }
	
	  return assertThisInitialized(self);
	}
	
	module.exports = _possibleConstructorReturn;
	module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),
/* 1505 */
/***/ (function(module, exports) {

	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }
	
	  return self;
	}
	
	module.exports = _assertThisInitialized;
	module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),
/* 1506 */
/***/ (function(module, exports) {

	function _getPrototypeOf(o) {
	  module.exports = _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };
	  module.exports["default"] = module.exports, module.exports.__esModule = true;
	  return _getPrototypeOf(o);
	}
	
	module.exports = _getPrototypeOf;
	module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),
/* 1507 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireDefault = __webpack_require__(1488);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(1492));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(1502));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(1504));
	
	var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(1506));
	
	var _wrapNativeSuper2 = _interopRequireDefault(__webpack_require__(1508));
	
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
	
	var TypesenseError = /*#__PURE__*/function (_Error) {
	  (0, _inherits2.default)(TypesenseError, _Error);
	
	  var _super = _createSuper(TypesenseError);
	
	  function TypesenseError() {
	    (0, _classCallCheck2.default)(this, TypesenseError);
	    return _super.apply(this, arguments);
	  }
	
	  return TypesenseError;
	}( /*#__PURE__*/(0, _wrapNativeSuper2.default)(Error));
	
	exports.default = TypesenseError;
	//# sourceMappingURL=TypesenseError.js.map


/***/ }),
/* 1508 */
/***/ (function(module, exports, __webpack_require__) {

	var getPrototypeOf = __webpack_require__(1506);
	
	var setPrototypeOf = __webpack_require__(1503);
	
	var isNativeFunction = __webpack_require__(1509);
	
	var construct = __webpack_require__(1510);
	
	function _wrapNativeSuper(Class) {
	  var _cache = typeof Map === "function" ? new Map() : undefined;
	
	  module.exports = _wrapNativeSuper = function _wrapNativeSuper(Class) {
	    if (Class === null || !isNativeFunction(Class)) return Class;
	
	    if (typeof Class !== "function") {
	      throw new TypeError("Super expression must either be null or a function");
	    }
	
	    if (typeof _cache !== "undefined") {
	      if (_cache.has(Class)) return _cache.get(Class);
	
	      _cache.set(Class, Wrapper);
	    }
	
	    function Wrapper() {
	      return construct(Class, arguments, getPrototypeOf(this).constructor);
	    }
	
	    Wrapper.prototype = Object.create(Class.prototype, {
	      constructor: {
	        value: Wrapper,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	    return setPrototypeOf(Wrapper, Class);
	  };
	
	  module.exports["default"] = module.exports, module.exports.__esModule = true;
	  return _wrapNativeSuper(Class);
	}
	
	module.exports = _wrapNativeSuper;
	module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),
/* 1509 */
/***/ (function(module, exports) {

	function _isNativeFunction(fn) {
	  return Function.toString.call(fn).indexOf("[native code]") !== -1;
	}
	
	module.exports = _isNativeFunction;
	module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),
/* 1510 */
/***/ (function(module, exports, __webpack_require__) {

	var setPrototypeOf = __webpack_require__(1503);
	
	var isNativeReflectConstruct = __webpack_require__(1511);
	
	function _construct(Parent, args, Class) {
	  if (isNativeReflectConstruct()) {
	    module.exports = _construct = Reflect.construct;
	    module.exports["default"] = module.exports, module.exports.__esModule = true;
	  } else {
	    module.exports = _construct = function _construct(Parent, args, Class) {
	      var a = [null];
	      a.push.apply(a, args);
	      var Constructor = Function.bind.apply(Parent, a);
	      var instance = new Constructor();
	      if (Class) setPrototypeOf(instance, Class.prototype);
	      return instance;
	    };
	
	    module.exports["default"] = module.exports, module.exports.__esModule = true;
	  }
	
	  return _construct.apply(null, arguments);
	}
	
	module.exports = _construct;
	module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),
/* 1511 */
/***/ (function(module, exports) {

	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
	  if (Reflect.construct.sham) return false;
	  if (typeof Proxy === "function") return true;
	
	  try {
	    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
	    return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	module.exports = _isNativeReflectConstruct;
	module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),
/* 1512 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireDefault = __webpack_require__(1488);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(1492));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(1502));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(1504));
	
	var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(1506));
	
	var _TypesenseError2 = _interopRequireDefault(__webpack_require__(1507));
	
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
	
	var MissingConfigurationError = /*#__PURE__*/function (_TypesenseError) {
	  (0, _inherits2.default)(MissingConfigurationError, _TypesenseError);
	
	  var _super = _createSuper(MissingConfigurationError);
	
	  function MissingConfigurationError() {
	    (0, _classCallCheck2.default)(this, MissingConfigurationError);
	    return _super.apply(this, arguments);
	  }
	
	  return MissingConfigurationError;
	}(_TypesenseError2.default);
	
	exports.default = MissingConfigurationError;
	//# sourceMappingURL=MissingConfigurationError.js.map


/***/ }),
/* 1513 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireDefault = __webpack_require__(1488);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(1492));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(1502));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(1504));
	
	var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(1506));
	
	var _TypesenseError2 = _interopRequireDefault(__webpack_require__(1507));
	
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
	
	var ObjectAlreadyExists = /*#__PURE__*/function (_TypesenseError) {
	  (0, _inherits2.default)(ObjectAlreadyExists, _TypesenseError);
	
	  var _super = _createSuper(ObjectAlreadyExists);
	
	  function ObjectAlreadyExists() {
	    (0, _classCallCheck2.default)(this, ObjectAlreadyExists);
	    return _super.apply(this, arguments);
	  }
	
	  return ObjectAlreadyExists;
	}(_TypesenseError2.default);
	
	exports.default = ObjectAlreadyExists;
	//# sourceMappingURL=ObjectAlreadyExists.js.map


/***/ }),
/* 1514 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireDefault = __webpack_require__(1488);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(1492));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(1502));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(1504));
	
	var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(1506));
	
	var _TypesenseError2 = _interopRequireDefault(__webpack_require__(1507));
	
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
	
	var ObjectNotFound = /*#__PURE__*/function (_TypesenseError) {
	  (0, _inherits2.default)(ObjectNotFound, _TypesenseError);
	
	  var _super = _createSuper(ObjectNotFound);
	
	  function ObjectNotFound() {
	    (0, _classCallCheck2.default)(this, ObjectNotFound);
	    return _super.apply(this, arguments);
	  }
	
	  return ObjectNotFound;
	}(_TypesenseError2.default);
	
	exports.default = ObjectNotFound;
	//# sourceMappingURL=ObjectNotFound.js.map


/***/ }),
/* 1515 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireDefault = __webpack_require__(1488);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(1492));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(1502));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(1504));
	
	var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(1506));
	
	var _TypesenseError2 = _interopRequireDefault(__webpack_require__(1507));
	
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
	
	var ObjectUnprocessable = /*#__PURE__*/function (_TypesenseError) {
	  (0, _inherits2.default)(ObjectUnprocessable, _TypesenseError);
	
	  var _super = _createSuper(ObjectUnprocessable);
	
	  function ObjectUnprocessable() {
	    (0, _classCallCheck2.default)(this, ObjectUnprocessable);
	    return _super.apply(this, arguments);
	  }
	
	  return ObjectUnprocessable;
	}(_TypesenseError2.default);
	
	exports.default = ObjectUnprocessable;
	//# sourceMappingURL=ObjectUnprocessable.js.map


/***/ }),
/* 1516 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireDefault = __webpack_require__(1488);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(1492));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(1502));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(1504));
	
	var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(1506));
	
	var _TypesenseError2 = _interopRequireDefault(__webpack_require__(1507));
	
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
	
	var RequestMalformed = /*#__PURE__*/function (_TypesenseError) {
	  (0, _inherits2.default)(RequestMalformed, _TypesenseError);
	
	  var _super = _createSuper(RequestMalformed);
	
	  function RequestMalformed() {
	    (0, _classCallCheck2.default)(this, RequestMalformed);
	    return _super.apply(this, arguments);
	  }
	
	  return RequestMalformed;
	}(_TypesenseError2.default);
	
	exports.default = RequestMalformed;
	//# sourceMappingURL=RequestMalformed.js.map


/***/ }),
/* 1517 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireDefault = __webpack_require__(1488);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(1492));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(1502));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(1504));
	
	var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(1506));
	
	var _TypesenseError2 = _interopRequireDefault(__webpack_require__(1507));
	
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
	
	var RequestUnauthorized = /*#__PURE__*/function (_TypesenseError) {
	  (0, _inherits2.default)(RequestUnauthorized, _TypesenseError);
	
	  var _super = _createSuper(RequestUnauthorized);
	
	  function RequestUnauthorized() {
	    (0, _classCallCheck2.default)(this, RequestUnauthorized);
	    return _super.apply(this, arguments);
	  }
	
	  return RequestUnauthorized;
	}(_TypesenseError2.default);
	
	exports.default = RequestUnauthorized;
	//# sourceMappingURL=RequestUnauthorized.js.map


/***/ }),
/* 1518 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireDefault = __webpack_require__(1488);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(1492));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(1502));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(1504));
	
	var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(1506));
	
	var _TypesenseError2 = _interopRequireDefault(__webpack_require__(1507));
	
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
	
	var ServerError = /*#__PURE__*/function (_TypesenseError) {
	  (0, _inherits2.default)(ServerError, _TypesenseError);
	
	  var _super = _createSuper(ServerError);
	
	  function ServerError() {
	    (0, _classCallCheck2.default)(this, ServerError);
	    return _super.apply(this, arguments);
	  }
	
	  return ServerError;
	}(_TypesenseError2.default);
	
	exports.default = ServerError;
	//# sourceMappingURL=ServerError.js.map


/***/ }),
/* 1519 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireDefault = __webpack_require__(1488);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(1492));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(1502));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(1504));
	
	var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(1506));
	
	var _TypesenseError2 = _interopRequireDefault(__webpack_require__(1507));
	
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
	
	var ImportError = /*#__PURE__*/function (_TypesenseError) {
	  (0, _inherits2.default)(ImportError, _TypesenseError);
	
	  var _super = _createSuper(ImportError);
	
	  function ImportError(message, importResults) {
	    var _this;
	
	    (0, _classCallCheck2.default)(this, ImportError);
	    _this = _super.call(this, message);
	    _this.importResults = importResults;
	    return _this;
	  }
	
	  return ImportError;
	}(_TypesenseError2.default);
	
	exports.default = ImportError;
	//# sourceMappingURL=ImportError.js.map


/***/ }),
/* 1520 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireDefault = __webpack_require__(1488);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _regenerator = _interopRequireDefault(__webpack_require__(1489));
	
	var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(1491));
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(1492));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(1493));
	
	var _axios = _interopRequireDefault(__webpack_require__(1521));
	
	var _Errors = __webpack_require__(1500);
	
	var APIKEYHEADERNAME = 'X-TYPESENSE-API-KEY';
	var HEALTHY = true;
	var UNHEALTHY = false;
	
	var ApiCall = /*#__PURE__*/function () {
	  function ApiCall(configuration) {
	    (0, _classCallCheck2.default)(this, ApiCall);
	    this._configuration = configuration;
	    this._apiKey = this._configuration.apiKey;
	    this._nodes = JSON.parse(JSON.stringify(this._configuration.nodes)); // Make a copy, since we'll be adding additional metadata to the nodes
	
	    this._nearestNode = JSON.parse(JSON.stringify(this._configuration.nearestNode));
	    this._connectionTimeoutSeconds = this._configuration.connectionTimeoutSeconds;
	    this._healthcheckIntervalSeconds = this._configuration.healthcheckIntervalSeconds;
	    this._numRetriesPerRequest = this._configuration.numRetries;
	    this._retryIntervalSeconds = this._configuration.retryIntervalSeconds;
	    this._sendApiKeyAsQueryParam = this._configuration.sendApiKeyAsQueryParam;
	    this.logger = this._configuration.logger;
	
	    this._initializeMetadataForNodes();
	
	    this._currentNodeIndex = -1;
	  }
	
	  (0, _createClass2.default)(ApiCall, [{
	    key: "get",
	    value: function get(endpoint) {
	      var queryParameters = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	      return this.performRequest('get', endpoint, {
	        queryParameters: queryParameters
	      });
	    }
	  }, {
	    key: "delete",
	    value: function _delete(endpoint) {
	      var queryParameters = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	      return this.performRequest('delete', endpoint, {
	        queryParameters: queryParameters
	      });
	    }
	  }, {
	    key: "post",
	    value: function post(endpoint) {
	      var bodyParameters = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	      var queryParameters = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	      var additionalHeaders = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	      return this.performRequest('post', endpoint, {
	        queryParameters: queryParameters,
	        bodyParameters: bodyParameters,
	        additionalHeaders: additionalHeaders
	      });
	    }
	  }, {
	    key: "put",
	    value: function put(endpoint) {
	      var bodyParameters = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	      var queryParameters = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	      return this.performRequest('put', endpoint, {
	        queryParameters: queryParameters,
	        bodyParameters: bodyParameters
	      });
	    }
	  }, {
	    key: "patch",
	    value: function patch(endpoint) {
	      var bodyParameters = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	      var queryParameters = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	      return this.performRequest('patch', endpoint, {
	        queryParameters: queryParameters,
	        bodyParameters: bodyParameters
	      });
	    }
	  }, {
	    key: "performRequest",
	    value: function () {
	      var _performRequest = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(requestType, endpoint, _ref) {
	        var _ref$queryParameters, queryParameters, _ref$bodyParameters, bodyParameters, _ref$additionalHeader, additionalHeaders, requestNumber, lastException, numTries, node, requestOptions, response;
	
	        return _regenerator.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                _ref$queryParameters = _ref.queryParameters, queryParameters = _ref$queryParameters === void 0 ? null : _ref$queryParameters, _ref$bodyParameters = _ref.bodyParameters, bodyParameters = _ref$bodyParameters === void 0 ? null : _ref$bodyParameters, _ref$additionalHeader = _ref.additionalHeaders, additionalHeaders = _ref$additionalHeader === void 0 ? {} : _ref$additionalHeader;
	
	                this._configuration.validate();
	
	                requestNumber = Date.now();
	                this.logger.debug("Request #".concat(requestNumber, ": Performing ").concat(requestType.toUpperCase(), " request: ").concat(endpoint));
	                numTries = 1;
	
	              case 5:
	                if (!(numTries <= this._numRetriesPerRequest + 1)) {
	                  _context.next = 40;
	                  break;
	                }
	
	                node = this._getNextNode(requestNumber);
	                this.logger.debug("Request #".concat(requestNumber, ": Attempting ").concat(requestType.toUpperCase(), " request Try #").concat(numTries, " to Node ").concat(node.index));
	                _context.prev = 8;
	                requestOptions = {
	                  method: requestType,
	                  url: this._uriFor(endpoint, node),
	                  headers: Object.assign({}, this._defaultHeaders(), additionalHeaders),
	                  timeout: this._connectionTimeoutSeconds * 1000,
	                  maxContentLength: Infinity,
	                  maxBodyLength: Infinity,
	                  validateStatus: function validateStatus(status) {
	                    /* Override default validateStatus, which only considers 2xx a success.
	                        In our case, if the server returns any HTTP code, we will handle it below.
	                        We do this to be able to raise custom errors based on response code.
	                     */
	                    return status > 0;
	                  },
	                  transformResponse: [function (data, headers) {
	                    var transformedData = data;
	
	                    if (headers !== undefined && typeof data === 'string' && headers['content-type'] && headers['content-type'].startsWith('application/json')) {
	                      transformedData = JSON.parse(data);
	                    }
	
	                    return transformedData;
	                  }]
	                };
	
	                if (queryParameters && Object.keys(queryParameters).length !== 0) {
	                  requestOptions.params = queryParameters;
	                }
	
	                if (this._sendApiKeyAsQueryParam) {
	                  requestOptions.params = requestOptions.params || {};
	                  requestOptions.params['x-typesense-api-key'] = this._apiKey;
	                }
	
	                if (bodyParameters && Object.keys(bodyParameters).length !== 0) {
	                  requestOptions.data = bodyParameters;
	                }
	
	                _context.next = 15;
	                return (0, _axios.default)(requestOptions);
	
	              case 15:
	                response = _context.sent;
	
	                if (response.status >= 1 && response.status <= 499) {
	                  // Treat any status code > 0 and < 500 to be an indication that node is healthy
	                  // We exclude 0 since some clients return 0 when request fails
	                  this._setNodeHealthcheck(node, HEALTHY);
	                }
	
	                this.logger.debug("Request #".concat(requestNumber, ": Request to Node ").concat(node.index, " was made. Response Code was ").concat(response.status, "."));
	
	                if (!(response.status >= 200 && response.status < 300)) {
	                  _context.next = 22;
	                  break;
	                }
	
	                return _context.abrupt("return", Promise.resolve(response.data));
	
	              case 22:
	                if (!(response.status < 500)) {
	                  _context.next = 26;
	                  break;
	                }
	
	                return _context.abrupt("return", Promise.reject(this._customErrorForResponse(response, response.data.message)));
	
	              case 26:
	                throw this._customErrorForResponse(response, response.data.message);
	
	              case 27:
	                _context.next = 37;
	                break;
	
	              case 29:
	                _context.prev = 29;
	                _context.t0 = _context["catch"](8);
	
	                // This block handles retries for HTTPStatus > 500 and network layer issues like connection timeouts
	                this._setNodeHealthcheck(node, UNHEALTHY);
	
	                lastException = _context.t0;
	                this.logger.warn("Request #".concat(requestNumber, ": Request to Node ").concat(node.index, " failed due to \"").concat(_context.t0.code, " ").concat(_context.t0.message).concat(_context.t0.response == null ? '' : ' - ' + JSON.stringify(_context.t0.response.data), "\"")); // this.logger.debug(error.stack)
	
	                this.logger.warn("Request #".concat(requestNumber, ": Sleeping for ").concat(this._retryIntervalSeconds, "s and then retrying request..."));
	                _context.next = 37;
	                return this._timer(this._retryIntervalSeconds);
	
	              case 37:
	                numTries++;
	                _context.next = 5;
	                break;
	
	              case 40:
	                this.logger.debug("Request #".concat(requestNumber, ": No retries left. Raising last error"));
	                return _context.abrupt("return", Promise.reject(lastException));
	
	              case 42:
	              case "end":
	                return _context.stop();
	            }
	          }
	        }, _callee, this, [[8, 29]]);
	      }));
	
	      function performRequest(_x, _x2, _x3) {
	        return _performRequest.apply(this, arguments);
	      }
	
	      return performRequest;
	    }() // Attempts to find the next healthy node, looping through the list of nodes once.
	    //   But if no healthy nodes are found, it will just return the next node, even if it's unhealthy
	    //     so we can try the request for good measure, in case that node has become healthy since
	
	  }, {
	    key: "_getNextNode",
	    value: function _getNextNode() {
	      var requestNumber = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	
	      // Check if nearestNode is set and is healthy, if so return it
	      if (this._nearestNode != null) {
	        this.logger.debug("Request #".concat(requestNumber, ": Nodes Health: Node ").concat(this._nearestNode.index, " is ").concat(this._nearestNode.isHealthy === true ? 'Healthy' : 'Unhealthy'));
	
	        if (this._nearestNode.isHealthy === true || this._nodeDueForHealthcheck(this._nearestNode, requestNumber)) {
	          this.logger.debug("Request #".concat(requestNumber, ": Updated current node to Node ").concat(this._nearestNode.index));
	          return this._nearestNode;
	        }
	
	        this.logger.debug("Request #".concat(requestNumber, ": Falling back to individual nodes"));
	      } // Fallback to nodes as usual
	
	
	      this.logger.debug("Request #".concat(requestNumber, ": Nodes Health: ").concat(this._nodes.map(function (node) {
	        return "Node ".concat(node.index, " is ").concat(node.isHealthy === true ? 'Healthy' : 'Unhealthy');
	      }).join(' || ')));
	      var candidateNode;
	
	      for (var i = 0; i <= this._nodes.length; i++) {
	        this._currentNodeIndex = (this._currentNodeIndex + 1) % this._nodes.length;
	        candidateNode = this._nodes[this._currentNodeIndex];
	
	        if (candidateNode.isHealthy === true || this._nodeDueForHealthcheck(candidateNode, requestNumber)) {
	          this.logger.debug("Request #".concat(requestNumber, ": Updated current node to Node ").concat(candidateNode.index));
	          return candidateNode;
	        }
	      } // None of the nodes are marked healthy, but some of them could have become healthy since last health check.
	      //  So we will just return the next node.
	
	
	      this.logger.debug("Request #".concat(requestNumber, ": No healthy nodes were found. Returning the next node, Node ").concat(candidateNode.index));
	      return candidateNode;
	    }
	  }, {
	    key: "_nodeDueForHealthcheck",
	    value: function _nodeDueForHealthcheck(node) {
	      var requestNumber = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	      var isDueForHealthcheck = Date.now() - node.lastAccessTimestamp > this._healthcheckIntervalSeconds * 1000;
	
	      if (isDueForHealthcheck) {
	        this.logger.debug("Request #".concat(requestNumber, ": Node ").concat(node.index, " has exceeded healtcheckIntervalSeconds of ").concat(this._healthcheckIntervalSeconds, ". Adding it back into rotation."));
	      }
	
	      return isDueForHealthcheck;
	    }
	  }, {
	    key: "_initializeMetadataForNodes",
	    value: function _initializeMetadataForNodes() {
	      var _this = this;
	
	      if (this._nearestNode != null) {
	        this._nearestNode.index = 'nearestNode';
	
	        this._setNodeHealthcheck(this._nearestNode, HEALTHY);
	      }
	
	      this._nodes.forEach(function (node, i) {
	        node.index = i;
	
	        _this._setNodeHealthcheck(node, HEALTHY);
	      });
	    }
	  }, {
	    key: "_setNodeHealthcheck",
	    value: function _setNodeHealthcheck(node, isHealthy) {
	      node.isHealthy = isHealthy;
	      node.lastAccessTimestamp = Date.now();
	    }
	  }, {
	    key: "_uriFor",
	    value: function _uriFor(endpoint, node) {
	      return "".concat(node.protocol, "://").concat(node.host, ":").concat(node.port).concat(node.path).concat(endpoint);
	    }
	  }, {
	    key: "_defaultHeaders",
	    value: function _defaultHeaders() {
	      var defaultHeaders = {};
	
	      if (!this._sendApiKeyAsQueryParam) {
	        defaultHeaders[APIKEYHEADERNAME] = this._apiKey;
	      }
	
	      defaultHeaders['Content-Type'] = 'application/json';
	      return defaultHeaders;
	    }
	  }, {
	    key: "_timer",
	    value: function () {
	      var _timer2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(seconds) {
	        return _regenerator.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                return _context2.abrupt("return", new Promise(function (resolve) {
	                  return setTimeout(resolve, seconds * 1000);
	                }));
	
	              case 1:
	              case "end":
	                return _context2.stop();
	            }
	          }
	        }, _callee2);
	      }));
	
	      function _timer(_x4) {
	        return _timer2.apply(this, arguments);
	      }
	
	      return _timer;
	    }()
	  }, {
	    key: "_customErrorForResponse",
	    value: function _customErrorForResponse(response, messageFromServer) {
	      var CustomErrorKlass;
	
	      if (response.status === 400) {
	        CustomErrorKlass = _Errors.RequestMalformed;
	      } else if (response.status === 401) {
	        CustomErrorKlass = _Errors.RequestUnauthorized;
	      } else if (response.status === 404) {
	        CustomErrorKlass = _Errors.ObjectNotFound;
	      } else if (response.status === 409) {
	        CustomErrorKlass = _Errors.ObjectAlreadyExists;
	      } else if (response.status === 422) {
	        CustomErrorKlass = _Errors.ObjectUnprocessable;
	      } else if (response.status >= 500 && response.status <= 599) {
	        CustomErrorKlass = _Errors.ServerError;
	      } else {
	        CustomErrorKlass = _Errors.HTTPError;
	      }
	
	      var errorMessage = "Request failed with HTTP code ".concat(response.status);
	
	      if (typeof messageFromServer === 'string' && messageFromServer.trim() !== '') {
	        errorMessage += " | Server said: ".concat(messageFromServer);
	      }
	
	      var customErrror = new CustomErrorKlass(errorMessage);
	      customErrror.httpStatus = response.status;
	      return customErrror;
	    }
	  }]);
	  return ApiCall;
	}();
	
	exports.default = ApiCall;
	//# sourceMappingURL=ApiCall.js.map


/***/ }),
/* 1521 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1522);

/***/ }),
/* 1522 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(1523);
	var bind = __webpack_require__(1524);
	var Axios = __webpack_require__(1525);
	var mergeConfig = __webpack_require__(1543);
	var defaults = __webpack_require__(1530);
	
	/**
	 * Create an instance of Axios
	 *
	 * @param {Object} defaultConfig The default config for the instance
	 * @return {Axios} A new instance of Axios
	 */
	function createInstance(defaultConfig) {
	  var context = new Axios(defaultConfig);
	  var instance = bind(Axios.prototype.request, context);
	
	  // Copy axios.prototype to instance
	  utils.extend(instance, Axios.prototype, context);
	
	  // Copy context to instance
	  utils.extend(instance, context);
	
	  return instance;
	}
	
	// Create the default instance to be exported
	var axios = createInstance(defaults);
	
	// Expose Axios class to allow class inheritance
	axios.Axios = Axios;
	
	// Factory for creating new instances
	axios.create = function create(instanceConfig) {
	  return createInstance(mergeConfig(axios.defaults, instanceConfig));
	};
	
	// Expose Cancel & CancelToken
	axios.Cancel = __webpack_require__(1546);
	axios.CancelToken = __webpack_require__(1547);
	axios.isCancel = __webpack_require__(1542);
	
	// Expose all/spread
	axios.all = function all(promises) {
	  return Promise.all(promises);
	};
	axios.spread = __webpack_require__(1548);
	
	// Expose isAxiosError
	axios.isAxiosError = __webpack_require__(1549);
	
	module.exports = axios;
	
	// Allow use of default import syntax in TypeScript
	module.exports.default = axios;


/***/ }),
/* 1523 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var bind = __webpack_require__(1524);
	
	// utils is a library of generic helper functions non-specific to axios
	
	var toString = Object.prototype.toString;
	
	/**
	 * Determine if a value is an Array
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an Array, otherwise false
	 */
	function isArray(val) {
	  return toString.call(val) === '[object Array]';
	}
	
	/**
	 * Determine if a value is undefined
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if the value is undefined, otherwise false
	 */
	function isUndefined(val) {
	  return typeof val === 'undefined';
	}
	
	/**
	 * Determine if a value is a Buffer
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Buffer, otherwise false
	 */
	function isBuffer(val) {
	  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor)
	    && typeof val.constructor.isBuffer === 'function' && val.constructor.isBuffer(val);
	}
	
	/**
	 * Determine if a value is an ArrayBuffer
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
	 */
	function isArrayBuffer(val) {
	  return toString.call(val) === '[object ArrayBuffer]';
	}
	
	/**
	 * Determine if a value is a FormData
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an FormData, otherwise false
	 */
	function isFormData(val) {
	  return (typeof FormData !== 'undefined') && (val instanceof FormData);
	}
	
	/**
	 * Determine if a value is a view on an ArrayBuffer
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
	 */
	function isArrayBufferView(val) {
	  var result;
	  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
	    result = ArrayBuffer.isView(val);
	  } else {
	    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
	  }
	  return result;
	}
	
	/**
	 * Determine if a value is a String
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a String, otherwise false
	 */
	function isString(val) {
	  return typeof val === 'string';
	}
	
	/**
	 * Determine if a value is a Number
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Number, otherwise false
	 */
	function isNumber(val) {
	  return typeof val === 'number';
	}
	
	/**
	 * Determine if a value is an Object
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an Object, otherwise false
	 */
	function isObject(val) {
	  return val !== null && typeof val === 'object';
	}
	
	/**
	 * Determine if a value is a plain Object
	 *
	 * @param {Object} val The value to test
	 * @return {boolean} True if value is a plain Object, otherwise false
	 */
	function isPlainObject(val) {
	  if (toString.call(val) !== '[object Object]') {
	    return false;
	  }
	
	  var prototype = Object.getPrototypeOf(val);
	  return prototype === null || prototype === Object.prototype;
	}
	
	/**
	 * Determine if a value is a Date
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Date, otherwise false
	 */
	function isDate(val) {
	  return toString.call(val) === '[object Date]';
	}
	
	/**
	 * Determine if a value is a File
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a File, otherwise false
	 */
	function isFile(val) {
	  return toString.call(val) === '[object File]';
	}
	
	/**
	 * Determine if a value is a Blob
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Blob, otherwise false
	 */
	function isBlob(val) {
	  return toString.call(val) === '[object Blob]';
	}
	
	/**
	 * Determine if a value is a Function
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Function, otherwise false
	 */
	function isFunction(val) {
	  return toString.call(val) === '[object Function]';
	}
	
	/**
	 * Determine if a value is a Stream
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Stream, otherwise false
	 */
	function isStream(val) {
	  return isObject(val) && isFunction(val.pipe);
	}
	
	/**
	 * Determine if a value is a URLSearchParams object
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
	 */
	function isURLSearchParams(val) {
	  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
	}
	
	/**
	 * Trim excess whitespace off the beginning and end of a string
	 *
	 * @param {String} str The String to trim
	 * @returns {String} The String freed of excess whitespace
	 */
	function trim(str) {
	  return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, '');
	}
	
	/**
	 * Determine if we're running in a standard browser environment
	 *
	 * This allows axios to run in a web worker, and react-native.
	 * Both environments support XMLHttpRequest, but not fully standard globals.
	 *
	 * web workers:
	 *  typeof window -> undefined
	 *  typeof document -> undefined
	 *
	 * react-native:
	 *  navigator.product -> 'ReactNative'
	 * nativescript
	 *  navigator.product -> 'NativeScript' or 'NS'
	 */
	function isStandardBrowserEnv() {
	  if (typeof navigator !== 'undefined' && (navigator.product === 'ReactNative' ||
	                                           navigator.product === 'NativeScript' ||
	                                           navigator.product === 'NS')) {
	    return false;
	  }
	  return (
	    typeof window !== 'undefined' &&
	    typeof document !== 'undefined'
	  );
	}
	
	/**
	 * Iterate over an Array or an Object invoking a function for each item.
	 *
	 * If `obj` is an Array callback will be called passing
	 * the value, index, and complete array for each item.
	 *
	 * If 'obj' is an Object callback will be called passing
	 * the value, key, and complete object for each property.
	 *
	 * @param {Object|Array} obj The object to iterate
	 * @param {Function} fn The callback to invoke for each item
	 */
	function forEach(obj, fn) {
	  // Don't bother if no value provided
	  if (obj === null || typeof obj === 'undefined') {
	    return;
	  }
	
	  // Force an array if not already something iterable
	  if (typeof obj !== 'object') {
	    /*eslint no-param-reassign:0*/
	    obj = [obj];
	  }
	
	  if (isArray(obj)) {
	    // Iterate over array values
	    for (var i = 0, l = obj.length; i < l; i++) {
	      fn.call(null, obj[i], i, obj);
	    }
	  } else {
	    // Iterate over object keys
	    for (var key in obj) {
	      if (Object.prototype.hasOwnProperty.call(obj, key)) {
	        fn.call(null, obj[key], key, obj);
	      }
	    }
	  }
	}
	
	/**
	 * Accepts varargs expecting each argument to be an object, then
	 * immutably merges the properties of each object and returns result.
	 *
	 * When multiple objects contain the same key the later object in
	 * the arguments list will take precedence.
	 *
	 * Example:
	 *
	 * ```js
	 * var result = merge({foo: 123}, {foo: 456});
	 * console.log(result.foo); // outputs 456
	 * ```
	 *
	 * @param {Object} obj1 Object to merge
	 * @returns {Object} Result of all merge properties
	 */
	function merge(/* obj1, obj2, obj3, ... */) {
	  var result = {};
	  function assignValue(val, key) {
	    if (isPlainObject(result[key]) && isPlainObject(val)) {
	      result[key] = merge(result[key], val);
	    } else if (isPlainObject(val)) {
	      result[key] = merge({}, val);
	    } else if (isArray(val)) {
	      result[key] = val.slice();
	    } else {
	      result[key] = val;
	    }
	  }
	
	  for (var i = 0, l = arguments.length; i < l; i++) {
	    forEach(arguments[i], assignValue);
	  }
	  return result;
	}
	
	/**
	 * Extends object a by mutably adding to it the properties of object b.
	 *
	 * @param {Object} a The object to be extended
	 * @param {Object} b The object to copy properties from
	 * @param {Object} thisArg The object to bind function to
	 * @return {Object} The resulting value of object a
	 */
	function extend(a, b, thisArg) {
	  forEach(b, function assignValue(val, key) {
	    if (thisArg && typeof val === 'function') {
	      a[key] = bind(val, thisArg);
	    } else {
	      a[key] = val;
	    }
	  });
	  return a;
	}
	
	/**
	 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
	 *
	 * @param {string} content with BOM
	 * @return {string} content value without BOM
	 */
	function stripBOM(content) {
	  if (content.charCodeAt(0) === 0xFEFF) {
	    content = content.slice(1);
	  }
	  return content;
	}
	
	module.exports = {
	  isArray: isArray,
	  isArrayBuffer: isArrayBuffer,
	  isBuffer: isBuffer,
	  isFormData: isFormData,
	  isArrayBufferView: isArrayBufferView,
	  isString: isString,
	  isNumber: isNumber,
	  isObject: isObject,
	  isPlainObject: isPlainObject,
	  isUndefined: isUndefined,
	  isDate: isDate,
	  isFile: isFile,
	  isBlob: isBlob,
	  isFunction: isFunction,
	  isStream: isStream,
	  isURLSearchParams: isURLSearchParams,
	  isStandardBrowserEnv: isStandardBrowserEnv,
	  forEach: forEach,
	  merge: merge,
	  extend: extend,
	  trim: trim,
	  stripBOM: stripBOM
	};


/***/ }),
/* 1524 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function bind(fn, thisArg) {
	  return function wrap() {
	    var args = new Array(arguments.length);
	    for (var i = 0; i < args.length; i++) {
	      args[i] = arguments[i];
	    }
	    return fn.apply(thisArg, args);
	  };
	};


/***/ }),
/* 1525 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(1523);
	var buildURL = __webpack_require__(1526);
	var InterceptorManager = __webpack_require__(1527);
	var dispatchRequest = __webpack_require__(1528);
	var mergeConfig = __webpack_require__(1543);
	var validator = __webpack_require__(1544);
	
	var validators = validator.validators;
	/**
	 * Create a new instance of Axios
	 *
	 * @param {Object} instanceConfig The default config for the instance
	 */
	function Axios(instanceConfig) {
	  this.defaults = instanceConfig;
	  this.interceptors = {
	    request: new InterceptorManager(),
	    response: new InterceptorManager()
	  };
	}
	
	/**
	 * Dispatch a request
	 *
	 * @param {Object} config The config specific for this request (merged with this.defaults)
	 */
	Axios.prototype.request = function request(config) {
	  /*eslint no-param-reassign:0*/
	  // Allow for axios('example/url'[, config]) a la fetch API
	  if (typeof config === 'string') {
	    config = arguments[1] || {};
	    config.url = arguments[0];
	  } else {
	    config = config || {};
	  }
	
	  config = mergeConfig(this.defaults, config);
	
	  // Set config.method
	  if (config.method) {
	    config.method = config.method.toLowerCase();
	  } else if (this.defaults.method) {
	    config.method = this.defaults.method.toLowerCase();
	  } else {
	    config.method = 'get';
	  }
	
	  var transitional = config.transitional;
	
	  if (transitional !== undefined) {
	    validator.assertOptions(transitional, {
	      silentJSONParsing: validators.transitional(validators.boolean, '1.0.0'),
	      forcedJSONParsing: validators.transitional(validators.boolean, '1.0.0'),
	      clarifyTimeoutError: validators.transitional(validators.boolean, '1.0.0')
	    }, false);
	  }
	
	  // filter out skipped interceptors
	  var requestInterceptorChain = [];
	  var synchronousRequestInterceptors = true;
	  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
	    if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) {
	      return;
	    }
	
	    synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
	
	    requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
	  });
	
	  var responseInterceptorChain = [];
	  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
	    responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
	  });
	
	  var promise;
	
	  if (!synchronousRequestInterceptors) {
	    var chain = [dispatchRequest, undefined];
	
	    Array.prototype.unshift.apply(chain, requestInterceptorChain);
	    chain = chain.concat(responseInterceptorChain);
	
	    promise = Promise.resolve(config);
	    while (chain.length) {
	      promise = promise.then(chain.shift(), chain.shift());
	    }
	
	    return promise;
	  }
	
	
	  var newConfig = config;
	  while (requestInterceptorChain.length) {
	    var onFulfilled = requestInterceptorChain.shift();
	    var onRejected = requestInterceptorChain.shift();
	    try {
	      newConfig = onFulfilled(newConfig);
	    } catch (error) {
	      onRejected(error);
	      break;
	    }
	  }
	
	  try {
	    promise = dispatchRequest(newConfig);
	  } catch (error) {
	    return Promise.reject(error);
	  }
	
	  while (responseInterceptorChain.length) {
	    promise = promise.then(responseInterceptorChain.shift(), responseInterceptorChain.shift());
	  }
	
	  return promise;
	};
	
	Axios.prototype.getUri = function getUri(config) {
	  config = mergeConfig(this.defaults, config);
	  return buildURL(config.url, config.params, config.paramsSerializer).replace(/^\?/, '');
	};
	
	// Provide aliases for supported request methods
	utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
	  /*eslint func-names:0*/
	  Axios.prototype[method] = function(url, config) {
	    return this.request(mergeConfig(config || {}, {
	      method: method,
	      url: url,
	      data: (config || {}).data
	    }));
	  };
	});
	
	utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
	  /*eslint func-names:0*/
	  Axios.prototype[method] = function(url, data, config) {
	    return this.request(mergeConfig(config || {}, {
	      method: method,
	      url: url,
	      data: data
	    }));
	  };
	});
	
	module.exports = Axios;


/***/ }),
/* 1526 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(1523);
	
	function encode(val) {
	  return encodeURIComponent(val).
	    replace(/%3A/gi, ':').
	    replace(/%24/g, '$').
	    replace(/%2C/gi, ',').
	    replace(/%20/g, '+').
	    replace(/%5B/gi, '[').
	    replace(/%5D/gi, ']');
	}
	
	/**
	 * Build a URL by appending params to the end
	 *
	 * @param {string} url The base of the url (e.g., http://www.google.com)
	 * @param {object} [params] The params to be appended
	 * @returns {string} The formatted url
	 */
	module.exports = function buildURL(url, params, paramsSerializer) {
	  /*eslint no-param-reassign:0*/
	  if (!params) {
	    return url;
	  }
	
	  var serializedParams;
	  if (paramsSerializer) {
	    serializedParams = paramsSerializer(params);
	  } else if (utils.isURLSearchParams(params)) {
	    serializedParams = params.toString();
	  } else {
	    var parts = [];
	
	    utils.forEach(params, function serialize(val, key) {
	      if (val === null || typeof val === 'undefined') {
	        return;
	      }
	
	      if (utils.isArray(val)) {
	        key = key + '[]';
	      } else {
	        val = [val];
	      }
	
	      utils.forEach(val, function parseValue(v) {
	        if (utils.isDate(v)) {
	          v = v.toISOString();
	        } else if (utils.isObject(v)) {
	          v = JSON.stringify(v);
	        }
	        parts.push(encode(key) + '=' + encode(v));
	      });
	    });
	
	    serializedParams = parts.join('&');
	  }
	
	  if (serializedParams) {
	    var hashmarkIndex = url.indexOf('#');
	    if (hashmarkIndex !== -1) {
	      url = url.slice(0, hashmarkIndex);
	    }
	
	    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
	  }
	
	  return url;
	};


/***/ }),
/* 1527 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(1523);
	
	function InterceptorManager() {
	  this.handlers = [];
	}
	
	/**
	 * Add a new interceptor to the stack
	 *
	 * @param {Function} fulfilled The function to handle `then` for a `Promise`
	 * @param {Function} rejected The function to handle `reject` for a `Promise`
	 *
	 * @return {Number} An ID used to remove interceptor later
	 */
	InterceptorManager.prototype.use = function use(fulfilled, rejected, options) {
	  this.handlers.push({
	    fulfilled: fulfilled,
	    rejected: rejected,
	    synchronous: options ? options.synchronous : false,
	    runWhen: options ? options.runWhen : null
	  });
	  return this.handlers.length - 1;
	};
	
	/**
	 * Remove an interceptor from the stack
	 *
	 * @param {Number} id The ID that was returned by `use`
	 */
	InterceptorManager.prototype.eject = function eject(id) {
	  if (this.handlers[id]) {
	    this.handlers[id] = null;
	  }
	};
	
	/**
	 * Iterate over all the registered interceptors
	 *
	 * This method is particularly useful for skipping over any
	 * interceptors that may have become `null` calling `eject`.
	 *
	 * @param {Function} fn The function to call for each interceptor
	 */
	InterceptorManager.prototype.forEach = function forEach(fn) {
	  utils.forEach(this.handlers, function forEachHandler(h) {
	    if (h !== null) {
	      fn(h);
	    }
	  });
	};
	
	module.exports = InterceptorManager;


/***/ }),
/* 1528 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(1523);
	var transformData = __webpack_require__(1529);
	var isCancel = __webpack_require__(1542);
	var defaults = __webpack_require__(1530);
	
	/**
	 * Throws a `Cancel` if cancellation has been requested.
	 */
	function throwIfCancellationRequested(config) {
	  if (config.cancelToken) {
	    config.cancelToken.throwIfRequested();
	  }
	}
	
	/**
	 * Dispatch a request to the server using the configured adapter.
	 *
	 * @param {object} config The config that is to be used for the request
	 * @returns {Promise} The Promise to be fulfilled
	 */
	module.exports = function dispatchRequest(config) {
	  throwIfCancellationRequested(config);
	
	  // Ensure headers exist
	  config.headers = config.headers || {};
	
	  // Transform request data
	  config.data = transformData.call(
	    config,
	    config.data,
	    config.headers,
	    config.transformRequest
	  );
	
	  // Flatten headers
	  config.headers = utils.merge(
	    config.headers.common || {},
	    config.headers[config.method] || {},
	    config.headers
	  );
	
	  utils.forEach(
	    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
	    function cleanHeaderConfig(method) {
	      delete config.headers[method];
	    }
	  );
	
	  var adapter = config.adapter || defaults.adapter;
	
	  return adapter(config).then(function onAdapterResolution(response) {
	    throwIfCancellationRequested(config);
	
	    // Transform response data
	    response.data = transformData.call(
	      config,
	      response.data,
	      response.headers,
	      config.transformResponse
	    );
	
	    return response;
	  }, function onAdapterRejection(reason) {
	    if (!isCancel(reason)) {
	      throwIfCancellationRequested(config);
	
	      // Transform response data
	      if (reason && reason.response) {
	        reason.response.data = transformData.call(
	          config,
	          reason.response.data,
	          reason.response.headers,
	          config.transformResponse
	        );
	      }
	    }
	
	    return Promise.reject(reason);
	  });
	};


/***/ }),
/* 1529 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(1523);
	var defaults = __webpack_require__(1530);
	
	/**
	 * Transform the data for a request or a response
	 *
	 * @param {Object|String} data The data to be transformed
	 * @param {Array} headers The headers for the request or response
	 * @param {Array|Function} fns A single function or Array of functions
	 * @returns {*} The resulting transformed data
	 */
	module.exports = function transformData(data, headers, fns) {
	  var context = this || defaults;
	  /*eslint no-param-reassign:0*/
	  utils.forEach(fns, function transform(fn) {
	    data = fn.call(context, data, headers);
	  });
	
	  return data;
	};


/***/ }),
/* 1530 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	var utils = __webpack_require__(1523);
	var normalizeHeaderName = __webpack_require__(1531);
	var enhanceError = __webpack_require__(1532);
	
	var DEFAULT_CONTENT_TYPE = {
	  'Content-Type': 'application/x-www-form-urlencoded'
	};
	
	function setContentTypeIfUnset(headers, value) {
	  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
	    headers['Content-Type'] = value;
	  }
	}
	
	function getDefaultAdapter() {
	  var adapter;
	  if (typeof XMLHttpRequest !== 'undefined') {
	    // For browsers use XHR adapter
	    adapter = __webpack_require__(1533);
	  } else if (typeof process !== 'undefined' && Object.prototype.toString.call(process) === '[object process]') {
	    // For node use HTTP adapter
	    adapter = __webpack_require__(1533);
	  }
	  return adapter;
	}
	
	function stringifySafely(rawValue, parser, encoder) {
	  if (utils.isString(rawValue)) {
	    try {
	      (parser || JSON.parse)(rawValue);
	      return utils.trim(rawValue);
	    } catch (e) {
	      if (e.name !== 'SyntaxError') {
	        throw e;
	      }
	    }
	  }
	
	  return (encoder || JSON.stringify)(rawValue);
	}
	
	var defaults = {
	
	  transitional: {
	    silentJSONParsing: true,
	    forcedJSONParsing: true,
	    clarifyTimeoutError: false
	  },
	
	  adapter: getDefaultAdapter(),
	
	  transformRequest: [function transformRequest(data, headers) {
	    normalizeHeaderName(headers, 'Accept');
	    normalizeHeaderName(headers, 'Content-Type');
	
	    if (utils.isFormData(data) ||
	      utils.isArrayBuffer(data) ||
	      utils.isBuffer(data) ||
	      utils.isStream(data) ||
	      utils.isFile(data) ||
	      utils.isBlob(data)
	    ) {
	      return data;
	    }
	    if (utils.isArrayBufferView(data)) {
	      return data.buffer;
	    }
	    if (utils.isURLSearchParams(data)) {
	      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
	      return data.toString();
	    }
	    if (utils.isObject(data) || (headers && headers['Content-Type'] === 'application/json')) {
	      setContentTypeIfUnset(headers, 'application/json');
	      return stringifySafely(data);
	    }
	    return data;
	  }],
	
	  transformResponse: [function transformResponse(data) {
	    var transitional = this.transitional;
	    var silentJSONParsing = transitional && transitional.silentJSONParsing;
	    var forcedJSONParsing = transitional && transitional.forcedJSONParsing;
	    var strictJSONParsing = !silentJSONParsing && this.responseType === 'json';
	
	    if (strictJSONParsing || (forcedJSONParsing && utils.isString(data) && data.length)) {
	      try {
	        return JSON.parse(data);
	      } catch (e) {
	        if (strictJSONParsing) {
	          if (e.name === 'SyntaxError') {
	            throw enhanceError(e, this, 'E_JSON_PARSE');
	          }
	          throw e;
	        }
	      }
	    }
	
	    return data;
	  }],
	
	  /**
	   * A timeout in milliseconds to abort a request. If set to 0 (default) a
	   * timeout is not created.
	   */
	  timeout: 0,
	
	  xsrfCookieName: 'XSRF-TOKEN',
	  xsrfHeaderName: 'X-XSRF-TOKEN',
	
	  maxContentLength: -1,
	  maxBodyLength: -1,
	
	  validateStatus: function validateStatus(status) {
	    return status >= 200 && status < 300;
	  }
	};
	
	defaults.headers = {
	  common: {
	    'Accept': 'application/json, text/plain, */*'
	  }
	};
	
	utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
	  defaults.headers[method] = {};
	});
	
	utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
	  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
	});
	
	module.exports = defaults;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(294)))

/***/ }),
/* 1531 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(1523);
	
	module.exports = function normalizeHeaderName(headers, normalizedName) {
	  utils.forEach(headers, function processHeader(value, name) {
	    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
	      headers[normalizedName] = value;
	      delete headers[name];
	    }
	  });
	};


/***/ }),
/* 1532 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Update an Error with the specified config, error code, and response.
	 *
	 * @param {Error} error The error to update.
	 * @param {Object} config The config.
	 * @param {string} [code] The error code (for example, 'ECONNABORTED').
	 * @param {Object} [request] The request.
	 * @param {Object} [response] The response.
	 * @returns {Error} The error.
	 */
	module.exports = function enhanceError(error, config, code, request, response) {
	  error.config = config;
	  if (code) {
	    error.code = code;
	  }
	
	  error.request = request;
	  error.response = response;
	  error.isAxiosError = true;
	
	  error.toJSON = function toJSON() {
	    return {
	      // Standard
	      message: this.message,
	      name: this.name,
	      // Microsoft
	      description: this.description,
	      number: this.number,
	      // Mozilla
	      fileName: this.fileName,
	      lineNumber: this.lineNumber,
	      columnNumber: this.columnNumber,
	      stack: this.stack,
	      // Axios
	      config: this.config,
	      code: this.code
	    };
	  };
	  return error;
	};


/***/ }),
/* 1533 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(1523);
	var settle = __webpack_require__(1534);
	var cookies = __webpack_require__(1536);
	var buildURL = __webpack_require__(1526);
	var buildFullPath = __webpack_require__(1537);
	var parseHeaders = __webpack_require__(1540);
	var isURLSameOrigin = __webpack_require__(1541);
	var createError = __webpack_require__(1535);
	
	module.exports = function xhrAdapter(config) {
	  return new Promise(function dispatchXhrRequest(resolve, reject) {
	    var requestData = config.data;
	    var requestHeaders = config.headers;
	    var responseType = config.responseType;
	
	    if (utils.isFormData(requestData)) {
	      delete requestHeaders['Content-Type']; // Let the browser set it
	    }
	
	    var request = new XMLHttpRequest();
	
	    // HTTP basic authentication
	    if (config.auth) {
	      var username = config.auth.username || '';
	      var password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : '';
	      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
	    }
	
	    var fullPath = buildFullPath(config.baseURL, config.url);
	    request.open(config.method.toUpperCase(), buildURL(fullPath, config.params, config.paramsSerializer), true);
	
	    // Set the request timeout in MS
	    request.timeout = config.timeout;
	
	    function onloadend() {
	      if (!request) {
	        return;
	      }
	      // Prepare the response
	      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
	      var responseData = !responseType || responseType === 'text' ||  responseType === 'json' ?
	        request.responseText : request.response;
	      var response = {
	        data: responseData,
	        status: request.status,
	        statusText: request.statusText,
	        headers: responseHeaders,
	        config: config,
	        request: request
	      };
	
	      settle(resolve, reject, response);
	
	      // Clean up request
	      request = null;
	    }
	
	    if ('onloadend' in request) {
	      // Use onloadend if available
	      request.onloadend = onloadend;
	    } else {
	      // Listen for ready state to emulate onloadend
	      request.onreadystatechange = function handleLoad() {
	        if (!request || request.readyState !== 4) {
	          return;
	        }
	
	        // The request errored out and we didn't get a response, this will be
	        // handled by onerror instead
	        // With one exception: request that using file: protocol, most browsers
	        // will return status as 0 even though it's a successful request
	        if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
	          return;
	        }
	        // readystate handler is calling before onerror or ontimeout handlers,
	        // so we should call onloadend on the next 'tick'
	        setTimeout(onloadend);
	      };
	    }
	
	    // Handle browser request cancellation (as opposed to a manual cancellation)
	    request.onabort = function handleAbort() {
	      if (!request) {
	        return;
	      }
	
	      reject(createError('Request aborted', config, 'ECONNABORTED', request));
	
	      // Clean up request
	      request = null;
	    };
	
	    // Handle low level network errors
	    request.onerror = function handleError() {
	      // Real errors are hidden from us by the browser
	      // onerror should only fire if it's a network error
	      reject(createError('Network Error', config, null, request));
	
	      // Clean up request
	      request = null;
	    };
	
	    // Handle timeout
	    request.ontimeout = function handleTimeout() {
	      var timeoutErrorMessage = 'timeout of ' + config.timeout + 'ms exceeded';
	      if (config.timeoutErrorMessage) {
	        timeoutErrorMessage = config.timeoutErrorMessage;
	      }
	      reject(createError(
	        timeoutErrorMessage,
	        config,
	        config.transitional && config.transitional.clarifyTimeoutError ? 'ETIMEDOUT' : 'ECONNABORTED',
	        request));
	
	      // Clean up request
	      request = null;
	    };
	
	    // Add xsrf header
	    // This is only done if running in a standard browser environment.
	    // Specifically not if we're in a web worker, or react-native.
	    if (utils.isStandardBrowserEnv()) {
	      // Add xsrf header
	      var xsrfValue = (config.withCredentials || isURLSameOrigin(fullPath)) && config.xsrfCookieName ?
	        cookies.read(config.xsrfCookieName) :
	        undefined;
	
	      if (xsrfValue) {
	        requestHeaders[config.xsrfHeaderName] = xsrfValue;
	      }
	    }
	
	    // Add headers to the request
	    if ('setRequestHeader' in request) {
	      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
	        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
	          // Remove Content-Type if data is undefined
	          delete requestHeaders[key];
	        } else {
	          // Otherwise add header to the request
	          request.setRequestHeader(key, val);
	        }
	      });
	    }
	
	    // Add withCredentials to request if needed
	    if (!utils.isUndefined(config.withCredentials)) {
	      request.withCredentials = !!config.withCredentials;
	    }
	
	    // Add responseType to request if needed
	    if (responseType && responseType !== 'json') {
	      request.responseType = config.responseType;
	    }
	
	    // Handle progress if needed
	    if (typeof config.onDownloadProgress === 'function') {
	      request.addEventListener('progress', config.onDownloadProgress);
	    }
	
	    // Not all browsers support upload events
	    if (typeof config.onUploadProgress === 'function' && request.upload) {
	      request.upload.addEventListener('progress', config.onUploadProgress);
	    }
	
	    if (config.cancelToken) {
	      // Handle cancellation
	      config.cancelToken.promise.then(function onCanceled(cancel) {
	        if (!request) {
	          return;
	        }
	
	        request.abort();
	        reject(cancel);
	        // Clean up request
	        request = null;
	      });
	    }
	
	    if (!requestData) {
	      requestData = null;
	    }
	
	    // Send the request
	    request.send(requestData);
	  });
	};


/***/ }),
/* 1534 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var createError = __webpack_require__(1535);
	
	/**
	 * Resolve or reject a Promise based on response status.
	 *
	 * @param {Function} resolve A function that resolves the promise.
	 * @param {Function} reject A function that rejects the promise.
	 * @param {object} response The response.
	 */
	module.exports = function settle(resolve, reject, response) {
	  var validateStatus = response.config.validateStatus;
	  if (!response.status || !validateStatus || validateStatus(response.status)) {
	    resolve(response);
	  } else {
	    reject(createError(
	      'Request failed with status code ' + response.status,
	      response.config,
	      null,
	      response.request,
	      response
	    ));
	  }
	};


/***/ }),
/* 1535 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var enhanceError = __webpack_require__(1532);
	
	/**
	 * Create an Error with the specified message, config, error code, request and response.
	 *
	 * @param {string} message The error message.
	 * @param {Object} config The config.
	 * @param {string} [code] The error code (for example, 'ECONNABORTED').
	 * @param {Object} [request] The request.
	 * @param {Object} [response] The response.
	 * @returns {Error} The created error.
	 */
	module.exports = function createError(message, config, code, request, response) {
	  var error = new Error(message);
	  return enhanceError(error, config, code, request, response);
	};


/***/ }),
/* 1536 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(1523);
	
	module.exports = (
	  utils.isStandardBrowserEnv() ?
	
	  // Standard browser envs support document.cookie
	    (function standardBrowserEnv() {
	      return {
	        write: function write(name, value, expires, path, domain, secure) {
	          var cookie = [];
	          cookie.push(name + '=' + encodeURIComponent(value));
	
	          if (utils.isNumber(expires)) {
	            cookie.push('expires=' + new Date(expires).toGMTString());
	          }
	
	          if (utils.isString(path)) {
	            cookie.push('path=' + path);
	          }
	
	          if (utils.isString(domain)) {
	            cookie.push('domain=' + domain);
	          }
	
	          if (secure === true) {
	            cookie.push('secure');
	          }
	
	          document.cookie = cookie.join('; ');
	        },
	
	        read: function read(name) {
	          var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
	          return (match ? decodeURIComponent(match[3]) : null);
	        },
	
	        remove: function remove(name) {
	          this.write(name, '', Date.now() - 86400000);
	        }
	      };
	    })() :
	
	  // Non standard browser env (web workers, react-native) lack needed support.
	    (function nonStandardBrowserEnv() {
	      return {
	        write: function write() {},
	        read: function read() { return null; },
	        remove: function remove() {}
	      };
	    })()
	);


/***/ }),
/* 1537 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var isAbsoluteURL = __webpack_require__(1538);
	var combineURLs = __webpack_require__(1539);
	
	/**
	 * Creates a new URL by combining the baseURL with the requestedURL,
	 * only when the requestedURL is not already an absolute URL.
	 * If the requestURL is absolute, this function returns the requestedURL untouched.
	 *
	 * @param {string} baseURL The base URL
	 * @param {string} requestedURL Absolute or relative URL to combine
	 * @returns {string} The combined full path
	 */
	module.exports = function buildFullPath(baseURL, requestedURL) {
	  if (baseURL && !isAbsoluteURL(requestedURL)) {
	    return combineURLs(baseURL, requestedURL);
	  }
	  return requestedURL;
	};


/***/ }),
/* 1538 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Determines whether the specified URL is absolute
	 *
	 * @param {string} url The URL to test
	 * @returns {boolean} True if the specified URL is absolute, otherwise false
	 */
	module.exports = function isAbsoluteURL(url) {
	  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
	  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
	  // by any combination of letters, digits, plus, period, or hyphen.
	  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
	};


/***/ }),
/* 1539 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Creates a new URL by combining the specified URLs
	 *
	 * @param {string} baseURL The base URL
	 * @param {string} relativeURL The relative URL
	 * @returns {string} The combined URL
	 */
	module.exports = function combineURLs(baseURL, relativeURL) {
	  return relativeURL
	    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
	    : baseURL;
	};


/***/ }),
/* 1540 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(1523);
	
	// Headers whose duplicates are ignored by node
	// c.f. https://nodejs.org/api/http.html#http_message_headers
	var ignoreDuplicateOf = [
	  'age', 'authorization', 'content-length', 'content-type', 'etag',
	  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
	  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
	  'referer', 'retry-after', 'user-agent'
	];
	
	/**
	 * Parse headers into an object
	 *
	 * ```
	 * Date: Wed, 27 Aug 2014 08:58:49 GMT
	 * Content-Type: application/json
	 * Connection: keep-alive
	 * Transfer-Encoding: chunked
	 * ```
	 *
	 * @param {String} headers Headers needing to be parsed
	 * @returns {Object} Headers parsed into an object
	 */
	module.exports = function parseHeaders(headers) {
	  var parsed = {};
	  var key;
	  var val;
	  var i;
	
	  if (!headers) { return parsed; }
	
	  utils.forEach(headers.split('\n'), function parser(line) {
	    i = line.indexOf(':');
	    key = utils.trim(line.substr(0, i)).toLowerCase();
	    val = utils.trim(line.substr(i + 1));
	
	    if (key) {
	      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
	        return;
	      }
	      if (key === 'set-cookie') {
	        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
	      } else {
	        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
	      }
	    }
	  });
	
	  return parsed;
	};


/***/ }),
/* 1541 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(1523);
	
	module.exports = (
	  utils.isStandardBrowserEnv() ?
	
	  // Standard browser envs have full support of the APIs needed to test
	  // whether the request URL is of the same origin as current location.
	    (function standardBrowserEnv() {
	      var msie = /(msie|trident)/i.test(navigator.userAgent);
	      var urlParsingNode = document.createElement('a');
	      var originURL;
	
	      /**
	    * Parse a URL to discover it's components
	    *
	    * @param {String} url The URL to be parsed
	    * @returns {Object}
	    */
	      function resolveURL(url) {
	        var href = url;
	
	        if (msie) {
	        // IE needs attribute set twice to normalize properties
	          urlParsingNode.setAttribute('href', href);
	          href = urlParsingNode.href;
	        }
	
	        urlParsingNode.setAttribute('href', href);
	
	        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
	        return {
	          href: urlParsingNode.href,
	          protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
	          host: urlParsingNode.host,
	          search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
	          hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
	          hostname: urlParsingNode.hostname,
	          port: urlParsingNode.port,
	          pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
	            urlParsingNode.pathname :
	            '/' + urlParsingNode.pathname
	        };
	      }
	
	      originURL = resolveURL(window.location.href);
	
	      /**
	    * Determine if a URL shares the same origin as the current location
	    *
	    * @param {String} requestURL The URL to test
	    * @returns {boolean} True if URL shares the same origin, otherwise false
	    */
	      return function isURLSameOrigin(requestURL) {
	        var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
	        return (parsed.protocol === originURL.protocol &&
	            parsed.host === originURL.host);
	      };
	    })() :
	
	  // Non standard browser envs (web workers, react-native) lack needed support.
	    (function nonStandardBrowserEnv() {
	      return function isURLSameOrigin() {
	        return true;
	      };
	    })()
	);


/***/ }),
/* 1542 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function isCancel(value) {
	  return !!(value && value.__CANCEL__);
	};


/***/ }),
/* 1543 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(1523);
	
	/**
	 * Config-specific merge-function which creates a new config-object
	 * by merging two configuration objects together.
	 *
	 * @param {Object} config1
	 * @param {Object} config2
	 * @returns {Object} New object resulting from merging config2 to config1
	 */
	module.exports = function mergeConfig(config1, config2) {
	  // eslint-disable-next-line no-param-reassign
	  config2 = config2 || {};
	  var config = {};
	
	  var valueFromConfig2Keys = ['url', 'method', 'data'];
	  var mergeDeepPropertiesKeys = ['headers', 'auth', 'proxy', 'params'];
	  var defaultToConfig2Keys = [
	    'baseURL', 'transformRequest', 'transformResponse', 'paramsSerializer',
	    'timeout', 'timeoutMessage', 'withCredentials', 'adapter', 'responseType', 'xsrfCookieName',
	    'xsrfHeaderName', 'onUploadProgress', 'onDownloadProgress', 'decompress',
	    'maxContentLength', 'maxBodyLength', 'maxRedirects', 'transport', 'httpAgent',
	    'httpsAgent', 'cancelToken', 'socketPath', 'responseEncoding'
	  ];
	  var directMergeKeys = ['validateStatus'];
	
	  function getMergedValue(target, source) {
	    if (utils.isPlainObject(target) && utils.isPlainObject(source)) {
	      return utils.merge(target, source);
	    } else if (utils.isPlainObject(source)) {
	      return utils.merge({}, source);
	    } else if (utils.isArray(source)) {
	      return source.slice();
	    }
	    return source;
	  }
	
	  function mergeDeepProperties(prop) {
	    if (!utils.isUndefined(config2[prop])) {
	      config[prop] = getMergedValue(config1[prop], config2[prop]);
	    } else if (!utils.isUndefined(config1[prop])) {
	      config[prop] = getMergedValue(undefined, config1[prop]);
	    }
	  }
	
	  utils.forEach(valueFromConfig2Keys, function valueFromConfig2(prop) {
	    if (!utils.isUndefined(config2[prop])) {
	      config[prop] = getMergedValue(undefined, config2[prop]);
	    }
	  });
	
	  utils.forEach(mergeDeepPropertiesKeys, mergeDeepProperties);
	
	  utils.forEach(defaultToConfig2Keys, function defaultToConfig2(prop) {
	    if (!utils.isUndefined(config2[prop])) {
	      config[prop] = getMergedValue(undefined, config2[prop]);
	    } else if (!utils.isUndefined(config1[prop])) {
	      config[prop] = getMergedValue(undefined, config1[prop]);
	    }
	  });
	
	  utils.forEach(directMergeKeys, function merge(prop) {
	    if (prop in config2) {
	      config[prop] = getMergedValue(config1[prop], config2[prop]);
	    } else if (prop in config1) {
	      config[prop] = getMergedValue(undefined, config1[prop]);
	    }
	  });
	
	  var axiosKeys = valueFromConfig2Keys
	    .concat(mergeDeepPropertiesKeys)
	    .concat(defaultToConfig2Keys)
	    .concat(directMergeKeys);
	
	  var otherKeys = Object
	    .keys(config1)
	    .concat(Object.keys(config2))
	    .filter(function filterAxiosKeys(key) {
	      return axiosKeys.indexOf(key) === -1;
	    });
	
	  utils.forEach(otherKeys, mergeDeepProperties);
	
	  return config;
	};


/***/ }),
/* 1544 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var pkg = __webpack_require__(1545);
	
	var validators = {};
	
	// eslint-disable-next-line func-names
	['object', 'boolean', 'number', 'function', 'string', 'symbol'].forEach(function(type, i) {
	  validators[type] = function validator(thing) {
	    return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
	  };
	});
	
	var deprecatedWarnings = {};
	var currentVerArr = pkg.version.split('.');
	
	/**
	 * Compare package versions
	 * @param {string} version
	 * @param {string?} thanVersion
	 * @returns {boolean}
	 */
	function isOlderVersion(version, thanVersion) {
	  var pkgVersionArr = thanVersion ? thanVersion.split('.') : currentVerArr;
	  var destVer = version.split('.');
	  for (var i = 0; i < 3; i++) {
	    if (pkgVersionArr[i] > destVer[i]) {
	      return true;
	    } else if (pkgVersionArr[i] < destVer[i]) {
	      return false;
	    }
	  }
	  return false;
	}
	
	/**
	 * Transitional option validator
	 * @param {function|boolean?} validator
	 * @param {string?} version
	 * @param {string} message
	 * @returns {function}
	 */
	validators.transitional = function transitional(validator, version, message) {
	  var isDeprecated = version && isOlderVersion(version);
	
	  function formatMessage(opt, desc) {
	    return '[Axios v' + pkg.version + '] Transitional option \'' + opt + '\'' + desc + (message ? '. ' + message : '');
	  }
	
	  // eslint-disable-next-line func-names
	  return function(value, opt, opts) {
	    if (validator === false) {
	      throw new Error(formatMessage(opt, ' has been removed in ' + version));
	    }
	
	    if (isDeprecated && !deprecatedWarnings[opt]) {
	      deprecatedWarnings[opt] = true;
	      // eslint-disable-next-line no-console
	      console.warn(
	        formatMessage(
	          opt,
	          ' has been deprecated since v' + version + ' and will be removed in the near future'
	        )
	      );
	    }
	
	    return validator ? validator(value, opt, opts) : true;
	  };
	};
	
	/**
	 * Assert object's properties type
	 * @param {object} options
	 * @param {object} schema
	 * @param {boolean?} allowUnknown
	 */
	
	function assertOptions(options, schema, allowUnknown) {
	  if (typeof options !== 'object') {
	    throw new TypeError('options must be an object');
	  }
	  var keys = Object.keys(options);
	  var i = keys.length;
	  while (i-- > 0) {
	    var opt = keys[i];
	    var validator = schema[opt];
	    if (validator) {
	      var value = options[opt];
	      var result = value === undefined || validator(value, opt, options);
	      if (result !== true) {
	        throw new TypeError('option ' + opt + ' must be ' + result);
	      }
	      continue;
	    }
	    if (allowUnknown !== true) {
	      throw Error('Unknown option ' + opt);
	    }
	  }
	}
	
	module.exports = {
	  isOlderVersion: isOlderVersion,
	  assertOptions: assertOptions,
	  validators: validators
	};


/***/ }),
/* 1545 */
/***/ (function(module, exports) {

	module.exports = {
		"name": "axios",
		"version": "0.21.4",
		"description": "Promise based HTTP client for the browser and node.js",
		"main": "index.js",
		"scripts": {
			"test": "grunt test",
			"start": "node ./sandbox/server.js",
			"build": "NODE_ENV=production grunt build",
			"preversion": "npm test",
			"version": "npm run build && grunt version && git add -A dist && git add CHANGELOG.md bower.json package.json",
			"postversion": "git push && git push --tags",
			"examples": "node ./examples/server.js",
			"coveralls": "cat coverage/lcov.info | ./node_modules/coveralls/bin/coveralls.js",
			"fix": "eslint --fix lib/**/*.js"
		},
		"repository": {
			"type": "git",
			"url": "https://github.com/axios/axios.git"
		},
		"keywords": [
			"xhr",
			"http",
			"ajax",
			"promise",
			"node"
		],
		"author": "Matt Zabriskie",
		"license": "MIT",
		"bugs": {
			"url": "https://github.com/axios/axios/issues"
		},
		"homepage": "https://axios-http.com",
		"devDependencies": {
			"coveralls": "^3.0.0",
			"es6-promise": "^4.2.4",
			"grunt": "^1.3.0",
			"grunt-banner": "^0.6.0",
			"grunt-cli": "^1.2.0",
			"grunt-contrib-clean": "^1.1.0",
			"grunt-contrib-watch": "^1.0.0",
			"grunt-eslint": "^23.0.0",
			"grunt-karma": "^4.0.0",
			"grunt-mocha-test": "^0.13.3",
			"grunt-ts": "^6.0.0-beta.19",
			"grunt-webpack": "^4.0.2",
			"istanbul-instrumenter-loader": "^1.0.0",
			"jasmine-core": "^2.4.1",
			"karma": "^6.3.2",
			"karma-chrome-launcher": "^3.1.0",
			"karma-firefox-launcher": "^2.1.0",
			"karma-jasmine": "^1.1.1",
			"karma-jasmine-ajax": "^0.1.13",
			"karma-safari-launcher": "^1.0.0",
			"karma-sauce-launcher": "^4.3.6",
			"karma-sinon": "^1.0.5",
			"karma-sourcemap-loader": "^0.3.8",
			"karma-webpack": "^4.0.2",
			"load-grunt-tasks": "^3.5.2",
			"minimist": "^1.2.0",
			"mocha": "^8.2.1",
			"sinon": "^4.5.0",
			"terser-webpack-plugin": "^4.2.3",
			"typescript": "^4.0.5",
			"url-search-params": "^0.10.0",
			"webpack": "^4.44.2",
			"webpack-dev-server": "^3.11.0"
		},
		"browser": {
			"./lib/adapters/http.js": "./lib/adapters/xhr.js"
		},
		"jsdelivr": "dist/axios.min.js",
		"unpkg": "dist/axios.min.js",
		"typings": "./index.d.ts",
		"dependencies": {
			"follow-redirects": "^1.14.0"
		},
		"bundlesize": [
			{
				"path": "./dist/axios.min.js",
				"threshold": "5kB"
			}
		]
	};

/***/ }),
/* 1546 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * A `Cancel` is an object that is thrown when an operation is canceled.
	 *
	 * @class
	 * @param {string=} message The message.
	 */
	function Cancel(message) {
	  this.message = message;
	}
	
	Cancel.prototype.toString = function toString() {
	  return 'Cancel' + (this.message ? ': ' + this.message : '');
	};
	
	Cancel.prototype.__CANCEL__ = true;
	
	module.exports = Cancel;


/***/ }),
/* 1547 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var Cancel = __webpack_require__(1546);
	
	/**
	 * A `CancelToken` is an object that can be used to request cancellation of an operation.
	 *
	 * @class
	 * @param {Function} executor The executor function.
	 */
	function CancelToken(executor) {
	  if (typeof executor !== 'function') {
	    throw new TypeError('executor must be a function.');
	  }
	
	  var resolvePromise;
	  this.promise = new Promise(function promiseExecutor(resolve) {
	    resolvePromise = resolve;
	  });
	
	  var token = this;
	  executor(function cancel(message) {
	    if (token.reason) {
	      // Cancellation has already been requested
	      return;
	    }
	
	    token.reason = new Cancel(message);
	    resolvePromise(token.reason);
	  });
	}
	
	/**
	 * Throws a `Cancel` if cancellation has been requested.
	 */
	CancelToken.prototype.throwIfRequested = function throwIfRequested() {
	  if (this.reason) {
	    throw this.reason;
	  }
	};
	
	/**
	 * Returns an object that contains a new `CancelToken` and a function that, when called,
	 * cancels the `CancelToken`.
	 */
	CancelToken.source = function source() {
	  var cancel;
	  var token = new CancelToken(function executor(c) {
	    cancel = c;
	  });
	  return {
	    token: token,
	    cancel: cancel
	  };
	};
	
	module.exports = CancelToken;


/***/ }),
/* 1548 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Syntactic sugar for invoking a function and expanding an array for arguments.
	 *
	 * Common use case would be to use `Function.prototype.apply`.
	 *
	 *  ```js
	 *  function f(x, y, z) {}
	 *  var args = [1, 2, 3];
	 *  f.apply(null, args);
	 *  ```
	 *
	 * With `spread` this example can be re-written.
	 *
	 *  ```js
	 *  spread(function(x, y, z) {})([1, 2, 3]);
	 *  ```
	 *
	 * @param {Function} callback
	 * @returns {Function}
	 */
	module.exports = function spread(callback) {
	  return function wrap(arr) {
	    return callback.apply(null, arr);
	  };
	};


/***/ }),
/* 1549 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Determines whether the payload is an error thrown by Axios
	 *
	 * @param {*} payload The value to test
	 * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
	 */
	module.exports = function isAxiosError(payload) {
	  return (typeof payload === 'object') && (payload.isAxiosError === true);
	};


/***/ }),
/* 1550 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireDefault = __webpack_require__(1488);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(1492));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(1493));
	
	var RESOURCEPATH = '/collections';
	
	var Collections = /*#__PURE__*/function () {
	  function Collections(apiCall) {
	    (0, _classCallCheck2.default)(this, Collections);
	    this._apiCall = apiCall;
	  }
	
	  (0, _createClass2.default)(Collections, [{
	    key: "create",
	    value: function create(schema) {
	      return this._apiCall.post(RESOURCEPATH, schema);
	    }
	  }, {
	    key: "retrieve",
	    value: function retrieve(schema) {
	      return this._apiCall.get(RESOURCEPATH);
	    }
	  }], [{
	    key: "RESOURCEPATH",
	    get: function get() {
	      return RESOURCEPATH;
	    }
	  }]);
	  return Collections;
	}();
	
	exports.default = Collections;
	//# sourceMappingURL=Collections.js.map


/***/ }),
/* 1551 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireDefault = __webpack_require__(1488);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(1492));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(1493));
	
	var _Collections = _interopRequireDefault(__webpack_require__(1550));
	
	var _Documents = _interopRequireDefault(__webpack_require__(1552));
	
	var _Document = _interopRequireDefault(__webpack_require__(1560));
	
	var _Overrides = _interopRequireDefault(__webpack_require__(1561));
	
	var _Override = _interopRequireDefault(__webpack_require__(1562));
	
	var _Synonyms = _interopRequireDefault(__webpack_require__(1563));
	
	var _Synonym = _interopRequireDefault(__webpack_require__(1564));
	
	var Collection = /*#__PURE__*/function () {
	  function Collection(name, apiCall, configuration) {
	    (0, _classCallCheck2.default)(this, Collection);
	    this._name = name;
	    this._apiCall = apiCall;
	    this._configuration = configuration;
	    this._documents = new _Documents.default(this._name, this._apiCall, this._configuration);
	    this._individualDocuments = {};
	    this._overrides = new _Overrides.default(this._name, this._apiCall);
	    this._individualOverrides = {};
	    this._synonyms = new _Synonyms.default(this._name, this._apiCall);
	    this._individualSynonyms = {};
	  }
	
	  (0, _createClass2.default)(Collection, [{
	    key: "retrieve",
	    value: function retrieve() {
	      return this._apiCall.get(this._endpointPath());
	    }
	  }, {
	    key: "delete",
	    value: function _delete() {
	      return this._apiCall.delete(this._endpointPath());
	    }
	  }, {
	    key: "documents",
	    value: function documents(documentId) {
	      if (documentId === undefined) {
	        return this._documents;
	      } else {
	        if (this._individualDocuments[documentId] === undefined) {
	          this._individualDocuments[documentId] = new _Document.default(this._name, documentId, this._apiCall);
	        }
	
	        return this._individualDocuments[documentId];
	      }
	    }
	  }, {
	    key: "overrides",
	    value: function overrides(overrideId) {
	      if (overrideId === undefined) {
	        return this._overrides;
	      } else {
	        if (this._individualOverrides[overrideId] === undefined) {
	          this._individualOverrides[overrideId] = new _Override.default(this._name, overrideId, this._apiCall);
	        }
	
	        return this._individualOverrides[overrideId];
	      }
	    }
	  }, {
	    key: "synonyms",
	    value: function synonyms(synonymId) {
	      if (synonymId === undefined) {
	        return this._synonyms;
	      } else {
	        if (this._individualSynonyms[synonymId] === undefined) {
	          this._individualSynonyms[synonymId] = new _Synonym.default(this._name, synonymId, this._apiCall);
	        }
	
	        return this._individualSynonyms[synonymId];
	      }
	    }
	  }, {
	    key: "_endpointPath",
	    value: function _endpointPath() {
	      return "".concat(_Collections.default.RESOURCEPATH, "/").concat(this._name);
	    }
	  }]);
	  return Collection;
	}();
	
	exports.default = Collection;
	//# sourceMappingURL=Collection.js.map


/***/ }),
/* 1552 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireDefault = __webpack_require__(1488);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _regenerator = _interopRequireDefault(__webpack_require__(1489));
	
	var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(1491));
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(1492));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(1493));
	
	var _Collections = _interopRequireDefault(__webpack_require__(1550));
	
	var _RequestWithCache = _interopRequireDefault(__webpack_require__(1553));
	
	var _Errors = __webpack_require__(1500);
	
	var RESOURCEPATH = '/documents';
	
	var Documents = /*#__PURE__*/function () {
	  function Documents(collectionName, apiCall, configuration) {
	    (0, _classCallCheck2.default)(this, Documents);
	    this._collectionName = collectionName;
	    this._apiCall = apiCall;
	    this._configuration = configuration;
	    this._requestWithCache = new _RequestWithCache.default();
	  }
	
	  (0, _createClass2.default)(Documents, [{
	    key: "create",
	    value: function create(document) {
	      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	      return this._apiCall.post(this._endpointPath(), document, options);
	    }
	  }, {
	    key: "upsert",
	    value: function upsert(document) {
	      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	      return this._apiCall.post(this._endpointPath(), document, Object.assign({}, options, {
	        action: 'upsert'
	      }));
	    }
	  }, {
	    key: "update",
	    value: function update(document) {
	      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	      return this._apiCall.post(this._endpointPath(), document, Object.assign({}, options, {
	        action: 'update'
	      }));
	    }
	  }, {
	    key: "delete",
	    value: function _delete() {
	      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	      return this._apiCall.delete(this._endpointPath(), options);
	    }
	  }, {
	    key: "createMany",
	    value: function () {
	      var _createMany = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(documents) {
	        var options,
	            _args = arguments;
	        return _regenerator.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                options = _args.length > 1 && _args[1] !== undefined ? _args[1] : {};
	
	                this._apiCall.logger.warn('createMany is deprecated and will be removed in a future version. Use import instead, which now takes both an array of documents or a JSONL string of documents');
	
	                return _context.abrupt("return", this.import(documents, options));
	
	              case 3:
	              case "end":
	                return _context.stop();
	            }
	          }
	        }, _callee, this);
	      }));
	
	      function createMany(_x) {
	        return _createMany.apply(this, arguments);
	      }
	
	      return createMany;
	    }()
	    /**
	     * Import a set of documents in a batch.
	     * @param {string|Array} documents - Can be a JSONL string of documents or an array of document objects.
	     * @return {string|Array} Returns a JSONL string if the input was a JSONL string, otherwise it returns an array of results.
	     */
	
	  }, {
	    key: "import",
	    value: function () {
	      var _import2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(documents) {
	        var options,
	            documentsInJSONLFormat,
	            resultsInJSONLFormat,
	            resultsInJSONFormat,
	            failedItems,
	            _args2 = arguments;
	        return _regenerator.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                options = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : {};
	
	                if (Array.isArray(documents)) {
	                  documentsInJSONLFormat = documents.map(function (document) {
	                    return JSON.stringify(document);
	                  }).join('\n');
	                } else {
	                  documentsInJSONLFormat = documents;
	                }
	
	                _context2.next = 4;
	                return this._apiCall.performRequest('post', this._endpointPath('import'), {
	                  queryParameters: options,
	                  bodyParameters: documentsInJSONLFormat,
	                  additionalHeaders: {
	                    'Content-Type': 'text/plain'
	                  }
	                });
	
	              case 4:
	                resultsInJSONLFormat = _context2.sent;
	
	                if (!Array.isArray(documents)) {
	                  _context2.next = 15;
	                  break;
	                }
	
	                resultsInJSONFormat = resultsInJSONLFormat.split('\n').map(function (r) {
	                  return JSON.parse(r);
	                });
	                failedItems = resultsInJSONFormat.filter(function (r) {
	                  return r.success === false;
	                });
	
	                if (!(failedItems.length > 0)) {
	                  _context2.next = 12;
	                  break;
	                }
	
	                throw new _Errors.ImportError("".concat(resultsInJSONFormat.length - failedItems.length, " documents imported successfully, ").concat(failedItems.length, " documents failed during import. Use `error.importResults` from the raised exception to get a detailed error reason for each document."), resultsInJSONFormat);
	
	              case 12:
	                return _context2.abrupt("return", resultsInJSONFormat);
	
	              case 13:
	                _context2.next = 16;
	                break;
	
	              case 15:
	                return _context2.abrupt("return", resultsInJSONLFormat);
	
	              case 16:
	              case "end":
	                return _context2.stop();
	            }
	          }
	        }, _callee2, this);
	      }));
	
	      function _import(_x2) {
	        return _import2.apply(this, arguments);
	      }
	
	      return _import;
	    }()
	  }, {
	    key: "export",
	    value: function _export() {
	      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	      return this._apiCall.get(this._endpointPath('export'), options);
	    }
	  }, {
	    key: "search",
	    value: function search(searchParameters) {
	      var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	          _ref$cacheSearchResul = _ref.cacheSearchResultsForSeconds,
	          cacheSearchResultsForSeconds = _ref$cacheSearchResul === void 0 ? this._configuration.cacheSearchResultsForSeconds : _ref$cacheSearchResul;
	
	      var additionalQueryParams = {};
	
	      if (this._configuration.useServerSideSearchCache === true) {
	        additionalQueryParams['use_cache'] = true;
	      }
	
	      var queryParams = Object.assign({}, searchParameters, additionalQueryParams);
	      return this._requestWithCache.perform(this._apiCall, this._apiCall.get, [this._endpointPath('search'), queryParams], {
	        cacheResponseForSeconds: cacheSearchResultsForSeconds
	      });
	    }
	  }, {
	    key: "_endpointPath",
	    value: function _endpointPath(operation) {
	      return "".concat(_Collections.default.RESOURCEPATH, "/").concat(this._collectionName).concat(Documents.RESOURCEPATH).concat(operation === undefined ? '' : '/' + operation);
	    }
	  }], [{
	    key: "RESOURCEPATH",
	    get: function get() {
	      return RESOURCEPATH;
	    }
	  }]);
	  return Documents;
	}();
	
	exports.default = Documents;
	//# sourceMappingURL=Documents.js.map


/***/ }),
/* 1553 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireDefault = __webpack_require__(1488);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _regenerator = _interopRequireDefault(__webpack_require__(1489));
	
	var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(1554));
	
	var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(1491));
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(1492));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(1493));
	
	var RequestWithCache = /*#__PURE__*/function () {
	  function RequestWithCache() {
	    (0, _classCallCheck2.default)(this, RequestWithCache);
	    this._responseCache = {};
	  }
	
	  (0, _createClass2.default)(RequestWithCache, [{
	    key: "perform",
	    value: function () {
	      var _perform = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(requestContext, requestFunction, requestFunctionArguments) {
	        var _ref,
	            _ref$cacheResponseFor,
	            cacheResponseForSeconds,
	            requestFunctionArgumentsJSON,
	            cacheEntry,
	            response,
	            _args = arguments;
	
	        return _regenerator.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                _ref = _args.length > 3 && _args[3] !== undefined ? _args[3] : {}, _ref$cacheResponseFor = _ref.cacheResponseForSeconds, cacheResponseForSeconds = _ref$cacheResponseFor === void 0 ? 2 * 60 : _ref$cacheResponseFor;
	
	                if (!(cacheResponseForSeconds <= 0)) {
	                  _context.next = 3;
	                  break;
	                }
	
	                return _context.abrupt("return", requestFunction.call.apply(requestFunction, [requestContext].concat((0, _toConsumableArray2.default)(requestFunctionArguments))));
	
	              case 3:
	                requestFunctionArgumentsJSON = JSON.stringify(requestFunctionArguments);
	                cacheEntry = this._responseCache[requestFunctionArgumentsJSON];
	
	                if (!cacheEntry) {
	                  _context.next = 11;
	                  break;
	                }
	
	                if (!(Date.now() - cacheEntry.requestTimestamp < cacheResponseForSeconds * 1000)) {
	                  _context.next = 10;
	                  break;
	                }
	
	                return _context.abrupt("return", Promise.resolve(cacheEntry.response));
	
	              case 10:
	                // Cache entry has expired, so delete it explicitly
	                delete this._responseCache[requestFunctionArgumentsJSON];
	
	              case 11:
	                _context.next = 13;
	                return requestFunction.call.apply(requestFunction, [requestContext].concat((0, _toConsumableArray2.default)(requestFunctionArguments)));
	
	              case 13:
	                response = _context.sent;
	                this._responseCache[requestFunctionArgumentsJSON] = {
	                  requestTimestamp: Date.now(),
	                  response: response
	                };
	                return _context.abrupt("return", response);
	
	              case 16:
	              case "end":
	                return _context.stop();
	            }
	          }
	        }, _callee, this);
	      }));
	
	      function perform(_x, _x2, _x3) {
	        return _perform.apply(this, arguments);
	      }
	
	      return perform;
	    }()
	  }]);
	  return RequestWithCache;
	}();
	
	exports.default = RequestWithCache;
	//# sourceMappingURL=RequestWithCache.js.map


/***/ }),
/* 1554 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayWithoutHoles = __webpack_require__(1555);
	
	var iterableToArray = __webpack_require__(1557);
	
	var unsupportedIterableToArray = __webpack_require__(1558);
	
	var nonIterableSpread = __webpack_require__(1559);
	
	function _toConsumableArray(arr) {
	  return arrayWithoutHoles(arr) || iterableToArray(arr) || unsupportedIterableToArray(arr) || nonIterableSpread();
	}
	
	module.exports = _toConsumableArray;
	module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),
/* 1555 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayLikeToArray = __webpack_require__(1556);
	
	function _arrayWithoutHoles(arr) {
	  if (Array.isArray(arr)) return arrayLikeToArray(arr);
	}
	
	module.exports = _arrayWithoutHoles;
	module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),
/* 1556 */
/***/ (function(module, exports) {

	function _arrayLikeToArray(arr, len) {
	  if (len == null || len > arr.length) len = arr.length;
	
	  for (var i = 0, arr2 = new Array(len); i < len; i++) {
	    arr2[i] = arr[i];
	  }
	
	  return arr2;
	}
	
	module.exports = _arrayLikeToArray;
	module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),
/* 1557 */
/***/ (function(module, exports) {

	function _iterableToArray(iter) {
	  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
	}
	
	module.exports = _iterableToArray;
	module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),
/* 1558 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayLikeToArray = __webpack_require__(1556);
	
	function _unsupportedIterableToArray(o, minLen) {
	  if (!o) return;
	  if (typeof o === "string") return arrayLikeToArray(o, minLen);
	  var n = Object.prototype.toString.call(o).slice(8, -1);
	  if (n === "Object" && o.constructor) n = o.constructor.name;
	  if (n === "Map" || n === "Set") return Array.from(o);
	  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return arrayLikeToArray(o, minLen);
	}
	
	module.exports = _unsupportedIterableToArray;
	module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),
/* 1559 */
/***/ (function(module, exports) {

	function _nonIterableSpread() {
	  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
	}
	
	module.exports = _nonIterableSpread;
	module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),
/* 1560 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireDefault = __webpack_require__(1488);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(1492));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(1493));
	
	var _Collections = _interopRequireDefault(__webpack_require__(1550));
	
	var _Documents = _interopRequireDefault(__webpack_require__(1552));
	
	var Document = /*#__PURE__*/function () {
	  function Document(collectionName, documentId, apiCall) {
	    (0, _classCallCheck2.default)(this, Document);
	    this._collectionName = collectionName;
	    this._documentId = documentId;
	    this._apiCall = apiCall;
	  }
	
	  (0, _createClass2.default)(Document, [{
	    key: "retrieve",
	    value: function retrieve() {
	      return this._apiCall.get(this._endpointPath());
	    }
	  }, {
	    key: "delete",
	    value: function _delete() {
	      return this._apiCall.delete(this._endpointPath());
	    }
	  }, {
	    key: "update",
	    value: function update(partialDocument) {
	      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	      return this._apiCall.patch(this._endpointPath(), partialDocument, options);
	    }
	  }, {
	    key: "_endpointPath",
	    value: function _endpointPath() {
	      return "".concat(_Collections.default.RESOURCEPATH, "/").concat(this._collectionName).concat(_Documents.default.RESOURCEPATH, "/").concat(this._documentId);
	    }
	  }]);
	  return Document;
	}();
	
	exports.default = Document;
	//# sourceMappingURL=Document.js.map


/***/ }),
/* 1561 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireDefault = __webpack_require__(1488);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(1492));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(1493));
	
	var _Collections = _interopRequireDefault(__webpack_require__(1550));
	
	var RESOURCEPATH = '/overrides';
	
	var Overrides = /*#__PURE__*/function () {
	  function Overrides(collectionName, apiCall) {
	    (0, _classCallCheck2.default)(this, Overrides);
	    this._collectionName = collectionName;
	    this._apiCall = apiCall;
	  }
	
	  (0, _createClass2.default)(Overrides, [{
	    key: "upsert",
	    value: function upsert(overrideId, params) {
	      return this._apiCall.put(this._endpointPath(overrideId), params);
	    }
	  }, {
	    key: "retrieve",
	    value: function retrieve() {
	      return this._apiCall.get(this._endpointPath());
	    }
	  }, {
	    key: "_endpointPath",
	    value: function _endpointPath(operation) {
	      return "".concat(_Collections.default.RESOURCEPATH, "/").concat(this._collectionName).concat(Overrides.RESOURCEPATH).concat(operation === undefined ? '' : '/' + operation);
	    }
	  }], [{
	    key: "RESOURCEPATH",
	    get: function get() {
	      return RESOURCEPATH;
	    }
	  }]);
	  return Overrides;
	}();
	
	exports.default = Overrides;
	//# sourceMappingURL=Overrides.js.map


/***/ }),
/* 1562 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireDefault = __webpack_require__(1488);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(1492));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(1493));
	
	var _Collections = _interopRequireDefault(__webpack_require__(1550));
	
	var _Overrides = _interopRequireDefault(__webpack_require__(1561));
	
	var Override = /*#__PURE__*/function () {
	  function Override(collectionName, overrideId, apiCall) {
	    (0, _classCallCheck2.default)(this, Override);
	    this._collectionName = collectionName;
	    this._overrideId = overrideId;
	    this._apiCall = apiCall;
	  }
	
	  (0, _createClass2.default)(Override, [{
	    key: "retrieve",
	    value: function retrieve() {
	      return this._apiCall.get(this._endpointPath());
	    }
	  }, {
	    key: "delete",
	    value: function _delete() {
	      return this._apiCall.delete(this._endpointPath());
	    }
	  }, {
	    key: "_endpointPath",
	    value: function _endpointPath() {
	      return "".concat(_Collections.default.RESOURCEPATH, "/").concat(this._collectionName).concat(_Overrides.default.RESOURCEPATH, "/").concat(this._overrideId);
	    }
	  }]);
	  return Override;
	}();
	
	exports.default = Override;
	//# sourceMappingURL=Override.js.map


/***/ }),
/* 1563 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireDefault = __webpack_require__(1488);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(1492));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(1493));
	
	var _Collections = _interopRequireDefault(__webpack_require__(1550));
	
	var RESOURCEPATH = '/synonyms';
	
	var Synonyms = /*#__PURE__*/function () {
	  function Synonyms(collectionName, apiCall) {
	    (0, _classCallCheck2.default)(this, Synonyms);
	    this._collectionName = collectionName;
	    this._apiCall = apiCall;
	  }
	
	  (0, _createClass2.default)(Synonyms, [{
	    key: "upsert",
	    value: function upsert(synonymId, params) {
	      return this._apiCall.put(this._endpointPath(synonymId), params);
	    }
	  }, {
	    key: "retrieve",
	    value: function retrieve() {
	      return this._apiCall.get(this._endpointPath());
	    }
	  }, {
	    key: "_endpointPath",
	    value: function _endpointPath(operation) {
	      return "".concat(_Collections.default.RESOURCEPATH, "/").concat(this._collectionName).concat(Synonyms.RESOURCEPATH).concat(operation === undefined ? '' : '/' + operation);
	    }
	  }], [{
	    key: "RESOURCEPATH",
	    get: function get() {
	      return RESOURCEPATH;
	    }
	  }]);
	  return Synonyms;
	}();
	
	exports.default = Synonyms;
	//# sourceMappingURL=Synonyms.js.map


/***/ }),
/* 1564 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireDefault = __webpack_require__(1488);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(1492));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(1493));
	
	var _Collections = _interopRequireDefault(__webpack_require__(1550));
	
	var _Synonyms = _interopRequireDefault(__webpack_require__(1563));
	
	var Synonym = /*#__PURE__*/function () {
	  function Synonym(collectionName, synonymId, apiCall) {
	    (0, _classCallCheck2.default)(this, Synonym);
	    this._collectionName = collectionName;
	    this._synonymId = synonymId;
	    this._apiCall = apiCall;
	  }
	
	  (0, _createClass2.default)(Synonym, [{
	    key: "retrieve",
	    value: function retrieve() {
	      return this._apiCall.get(this._endpointPath());
	    }
	  }, {
	    key: "delete",
	    value: function _delete() {
	      return this._apiCall.delete(this._endpointPath());
	    }
	  }, {
	    key: "_endpointPath",
	    value: function _endpointPath() {
	      return "".concat(_Collections.default.RESOURCEPATH, "/").concat(this._collectionName).concat(_Synonyms.default.RESOURCEPATH, "/").concat(this._synonymId);
	    }
	  }]);
	  return Synonym;
	}();
	
	exports.default = Synonym;
	//# sourceMappingURL=Synonym.js.map


/***/ }),
/* 1565 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireDefault = __webpack_require__(1488);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(1492));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(1493));
	
	var RESOURCEPATH = '/aliases';
	
	var Aliases = /*#__PURE__*/function () {
	  function Aliases(apiCall) {
	    (0, _classCallCheck2.default)(this, Aliases);
	    this._apiCall = apiCall;
	  }
	
	  (0, _createClass2.default)(Aliases, [{
	    key: "upsert",
	    value: function upsert(name, mapping) {
	      return this._apiCall.put(this._endpointPath(name), mapping);
	    }
	  }, {
	    key: "retrieve",
	    value: function retrieve(schema) {
	      return this._apiCall.get(RESOURCEPATH);
	    }
	  }, {
	    key: "_endpointPath",
	    value: function _endpointPath(aliasName) {
	      return "".concat(Aliases.RESOURCEPATH, "/").concat(aliasName);
	    }
	  }], [{
	    key: "RESOURCEPATH",
	    get: function get() {
	      return RESOURCEPATH;
	    }
	  }]);
	  return Aliases;
	}();
	
	exports.default = Aliases;
	//# sourceMappingURL=Aliases.js.map


/***/ }),
/* 1566 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireDefault = __webpack_require__(1488);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(1492));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(1493));
	
	var _Aliases = _interopRequireDefault(__webpack_require__(1565));
	
	var Alias = /*#__PURE__*/function () {
	  function Alias(name, apiCall) {
	    (0, _classCallCheck2.default)(this, Alias);
	    this._apiCall = apiCall;
	    this._name = name;
	  }
	
	  (0, _createClass2.default)(Alias, [{
	    key: "retrieve",
	    value: function retrieve() {
	      return this._apiCall.get(this._endpointPath());
	    }
	  }, {
	    key: "delete",
	    value: function _delete() {
	      return this._apiCall.delete(this._endpointPath());
	    }
	  }, {
	    key: "_endpointPath",
	    value: function _endpointPath() {
	      return "".concat(_Aliases.default.RESOURCEPATH, "/").concat(this._name);
	    }
	  }]);
	  return Alias;
	}();
	
	exports.default = Alias;
	//# sourceMappingURL=Alias.js.map


/***/ }),
/* 1567 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {'use strict';
	
	var _interopRequireDefault = __webpack_require__(1488);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(1492));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(1493));
	
	var _crypto = __webpack_require__(1571);
	
	var RESOURCEPATH = '/keys';
	
	var Keys = /*#__PURE__*/function () {
	  function Keys(apiCall) {
	    (0, _classCallCheck2.default)(this, Keys);
	    this._apiCall = apiCall;
	  }
	
	  (0, _createClass2.default)(Keys, [{
	    key: "create",
	    value: function create(params) {
	      return this._apiCall.post(Keys.RESOURCEPATH, params);
	    }
	  }, {
	    key: "retrieve",
	    value: function retrieve() {
	      return this._apiCall.get(RESOURCEPATH);
	    }
	  }, {
	    key: "generateScopedSearchKey",
	    value: function generateScopedSearchKey(searchKey, parameters) {
	      // Note: only a key generated with the `documents:search` action will be
	      // accepted by the server, when usined with the search endpoint.
	      var paramsJSON = JSON.stringify(parameters);
	      var digest = Buffer.from((0, _crypto.createHmac)('sha256', searchKey).update(paramsJSON).digest('base64'));
	      var keyPrefix = searchKey.substr(0, 4);
	      var rawScopedKey = "".concat(digest).concat(keyPrefix).concat(paramsJSON);
	      return Buffer.from(rawScopedKey).toString('base64');
	    }
	  }], [{
	    key: "RESOURCEPATH",
	    get: function get() {
	      return RESOURCEPATH;
	    }
	  }]);
	  return Keys;
	}();
	
	exports.default = Keys;
	//# sourceMappingURL=Keys.js.map
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1568).Buffer))

/***/ }),
/* 1568 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/*!
	 * The buffer module from node.js, for the browser.
	 *
	 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
	 * @license  MIT
	 */
	/* eslint-disable no-proto */
	
	'use strict'
	
	var base64 = __webpack_require__(1569)
	var ieee754 = __webpack_require__(1570)
	var isArray = __webpack_require__(1339)
	
	exports.Buffer = Buffer
	exports.SlowBuffer = SlowBuffer
	exports.INSPECT_MAX_BYTES = 50
	
	/**
	 * If `Buffer.TYPED_ARRAY_SUPPORT`:
	 *   === true    Use Uint8Array implementation (fastest)
	 *   === false   Use Object implementation (most compatible, even IE6)
	 *
	 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
	 * Opera 11.6+, iOS 4.2+.
	 *
	 * Due to various browser bugs, sometimes the Object implementation will be used even
	 * when the browser supports typed arrays.
	 *
	 * Note:
	 *
	 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
	 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
	 *
	 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
	 *
	 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
	 *     incorrect length in some situations.
	
	 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
	 * get the Object implementation, which is slower but behaves correctly.
	 */
	Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
	  ? global.TYPED_ARRAY_SUPPORT
	  : typedArraySupport()
	
	/*
	 * Export kMaxLength after typed array support is determined.
	 */
	exports.kMaxLength = kMaxLength()
	
	function typedArraySupport () {
	  try {
	    var arr = new Uint8Array(1)
	    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
	    return arr.foo() === 42 && // typed array instances can be augmented
	        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
	        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
	  } catch (e) {
	    return false
	  }
	}
	
	function kMaxLength () {
	  return Buffer.TYPED_ARRAY_SUPPORT
	    ? 0x7fffffff
	    : 0x3fffffff
	}
	
	function createBuffer (that, length) {
	  if (kMaxLength() < length) {
	    throw new RangeError('Invalid typed array length')
	  }
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    // Return an augmented `Uint8Array` instance, for best performance
	    that = new Uint8Array(length)
	    that.__proto__ = Buffer.prototype
	  } else {
	    // Fallback: Return an object instance of the Buffer class
	    if (that === null) {
	      that = new Buffer(length)
	    }
	    that.length = length
	  }
	
	  return that
	}
	
	/**
	 * The Buffer constructor returns instances of `Uint8Array` that have their
	 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
	 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
	 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
	 * returns a single octet.
	 *
	 * The `Uint8Array` prototype remains unmodified.
	 */
	
	function Buffer (arg, encodingOrOffset, length) {
	  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
	    return new Buffer(arg, encodingOrOffset, length)
	  }
	
	  // Common case.
	  if (typeof arg === 'number') {
	    if (typeof encodingOrOffset === 'string') {
	      throw new Error(
	        'If encoding is specified then the first argument must be a string'
	      )
	    }
	    return allocUnsafe(this, arg)
	  }
	  return from(this, arg, encodingOrOffset, length)
	}
	
	Buffer.poolSize = 8192 // not used by this implementation
	
	// TODO: Legacy, not needed anymore. Remove in next major version.
	Buffer._augment = function (arr) {
	  arr.__proto__ = Buffer.prototype
	  return arr
	}
	
	function from (that, value, encodingOrOffset, length) {
	  if (typeof value === 'number') {
	    throw new TypeError('"value" argument must not be a number')
	  }
	
	  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
	    return fromArrayBuffer(that, value, encodingOrOffset, length)
	  }
	
	  if (typeof value === 'string') {
	    return fromString(that, value, encodingOrOffset)
	  }
	
	  return fromObject(that, value)
	}
	
	/**
	 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
	 * if value is a number.
	 * Buffer.from(str[, encoding])
	 * Buffer.from(array)
	 * Buffer.from(buffer)
	 * Buffer.from(arrayBuffer[, byteOffset[, length]])
	 **/
	Buffer.from = function (value, encodingOrOffset, length) {
	  return from(null, value, encodingOrOffset, length)
	}
	
	if (Buffer.TYPED_ARRAY_SUPPORT) {
	  Buffer.prototype.__proto__ = Uint8Array.prototype
	  Buffer.__proto__ = Uint8Array
	  if (typeof Symbol !== 'undefined' && Symbol.species &&
	      Buffer[Symbol.species] === Buffer) {
	    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
	    Object.defineProperty(Buffer, Symbol.species, {
	      value: null,
	      configurable: true
	    })
	  }
	}
	
	function assertSize (size) {
	  if (typeof size !== 'number') {
	    throw new TypeError('"size" argument must be a number')
	  } else if (size < 0) {
	    throw new RangeError('"size" argument must not be negative')
	  }
	}
	
	function alloc (that, size, fill, encoding) {
	  assertSize(size)
	  if (size <= 0) {
	    return createBuffer(that, size)
	  }
	  if (fill !== undefined) {
	    // Only pay attention to encoding if it's a string. This
	    // prevents accidentally sending in a number that would
	    // be interpretted as a start offset.
	    return typeof encoding === 'string'
	      ? createBuffer(that, size).fill(fill, encoding)
	      : createBuffer(that, size).fill(fill)
	  }
	  return createBuffer(that, size)
	}
	
	/**
	 * Creates a new filled Buffer instance.
	 * alloc(size[, fill[, encoding]])
	 **/
	Buffer.alloc = function (size, fill, encoding) {
	  return alloc(null, size, fill, encoding)
	}
	
	function allocUnsafe (that, size) {
	  assertSize(size)
	  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) {
	    for (var i = 0; i < size; ++i) {
	      that[i] = 0
	    }
	  }
	  return that
	}
	
	/**
	 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
	 * */
	Buffer.allocUnsafe = function (size) {
	  return allocUnsafe(null, size)
	}
	/**
	 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
	 */
	Buffer.allocUnsafeSlow = function (size) {
	  return allocUnsafe(null, size)
	}
	
	function fromString (that, string, encoding) {
	  if (typeof encoding !== 'string' || encoding === '') {
	    encoding = 'utf8'
	  }
	
	  if (!Buffer.isEncoding(encoding)) {
	    throw new TypeError('"encoding" must be a valid string encoding')
	  }
	
	  var length = byteLength(string, encoding) | 0
	  that = createBuffer(that, length)
	
	  var actual = that.write(string, encoding)
	
	  if (actual !== length) {
	    // Writing a hex string, for example, that contains invalid characters will
	    // cause everything after the first invalid character to be ignored. (e.g.
	    // 'abxxcd' will be treated as 'ab')
	    that = that.slice(0, actual)
	  }
	
	  return that
	}
	
	function fromArrayLike (that, array) {
	  var length = array.length < 0 ? 0 : checked(array.length) | 0
	  that = createBuffer(that, length)
	  for (var i = 0; i < length; i += 1) {
	    that[i] = array[i] & 255
	  }
	  return that
	}
	
	function fromArrayBuffer (that, array, byteOffset, length) {
	  array.byteLength // this throws if `array` is not a valid ArrayBuffer
	
	  if (byteOffset < 0 || array.byteLength < byteOffset) {
	    throw new RangeError('\'offset\' is out of bounds')
	  }
	
	  if (array.byteLength < byteOffset + (length || 0)) {
	    throw new RangeError('\'length\' is out of bounds')
	  }
	
	  if (byteOffset === undefined && length === undefined) {
	    array = new Uint8Array(array)
	  } else if (length === undefined) {
	    array = new Uint8Array(array, byteOffset)
	  } else {
	    array = new Uint8Array(array, byteOffset, length)
	  }
	
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    // Return an augmented `Uint8Array` instance, for best performance
	    that = array
	    that.__proto__ = Buffer.prototype
	  } else {
	    // Fallback: Return an object instance of the Buffer class
	    that = fromArrayLike(that, array)
	  }
	  return that
	}
	
	function fromObject (that, obj) {
	  if (Buffer.isBuffer(obj)) {
	    var len = checked(obj.length) | 0
	    that = createBuffer(that, len)
	
	    if (that.length === 0) {
	      return that
	    }
	
	    obj.copy(that, 0, 0, len)
	    return that
	  }
	
	  if (obj) {
	    if ((typeof ArrayBuffer !== 'undefined' &&
	        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
	      if (typeof obj.length !== 'number' || isnan(obj.length)) {
	        return createBuffer(that, 0)
	      }
	      return fromArrayLike(that, obj)
	    }
	
	    if (obj.type === 'Buffer' && isArray(obj.data)) {
	      return fromArrayLike(that, obj.data)
	    }
	  }
	
	  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
	}
	
	function checked (length) {
	  // Note: cannot use `length < kMaxLength()` here because that fails when
	  // length is NaN (which is otherwise coerced to zero.)
	  if (length >= kMaxLength()) {
	    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
	                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
	  }
	  return length | 0
	}
	
	function SlowBuffer (length) {
	  if (+length != length) { // eslint-disable-line eqeqeq
	    length = 0
	  }
	  return Buffer.alloc(+length)
	}
	
	Buffer.isBuffer = function isBuffer (b) {
	  return !!(b != null && b._isBuffer)
	}
	
	Buffer.compare = function compare (a, b) {
	  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
	    throw new TypeError('Arguments must be Buffers')
	  }
	
	  if (a === b) return 0
	
	  var x = a.length
	  var y = b.length
	
	  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
	    if (a[i] !== b[i]) {
	      x = a[i]
	      y = b[i]
	      break
	    }
	  }
	
	  if (x < y) return -1
	  if (y < x) return 1
	  return 0
	}
	
	Buffer.isEncoding = function isEncoding (encoding) {
	  switch (String(encoding).toLowerCase()) {
	    case 'hex':
	    case 'utf8':
	    case 'utf-8':
	    case 'ascii':
	    case 'latin1':
	    case 'binary':
	    case 'base64':
	    case 'ucs2':
	    case 'ucs-2':
	    case 'utf16le':
	    case 'utf-16le':
	      return true
	    default:
	      return false
	  }
	}
	
	Buffer.concat = function concat (list, length) {
	  if (!isArray(list)) {
	    throw new TypeError('"list" argument must be an Array of Buffers')
	  }
	
	  if (list.length === 0) {
	    return Buffer.alloc(0)
	  }
	
	  var i
	  if (length === undefined) {
	    length = 0
	    for (i = 0; i < list.length; ++i) {
	      length += list[i].length
	    }
	  }
	
	  var buffer = Buffer.allocUnsafe(length)
	  var pos = 0
	  for (i = 0; i < list.length; ++i) {
	    var buf = list[i]
	    if (!Buffer.isBuffer(buf)) {
	      throw new TypeError('"list" argument must be an Array of Buffers')
	    }
	    buf.copy(buffer, pos)
	    pos += buf.length
	  }
	  return buffer
	}
	
	function byteLength (string, encoding) {
	  if (Buffer.isBuffer(string)) {
	    return string.length
	  }
	  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
	      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
	    return string.byteLength
	  }
	  if (typeof string !== 'string') {
	    string = '' + string
	  }
	
	  var len = string.length
	  if (len === 0) return 0
	
	  // Use a for loop to avoid recursion
	  var loweredCase = false
	  for (;;) {
	    switch (encoding) {
	      case 'ascii':
	      case 'latin1':
	      case 'binary':
	        return len
	      case 'utf8':
	      case 'utf-8':
	      case undefined:
	        return utf8ToBytes(string).length
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return len * 2
	      case 'hex':
	        return len >>> 1
	      case 'base64':
	        return base64ToBytes(string).length
	      default:
	        if (loweredCase) return utf8ToBytes(string).length // assume utf8
	        encoding = ('' + encoding).toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	Buffer.byteLength = byteLength
	
	function slowToString (encoding, start, end) {
	  var loweredCase = false
	
	  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
	  // property of a typed array.
	
	  // This behaves neither like String nor Uint8Array in that we set start/end
	  // to their upper/lower bounds if the value passed is out of range.
	  // undefined is handled specially as per ECMA-262 6th Edition,
	  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
	  if (start === undefined || start < 0) {
	    start = 0
	  }
	  // Return early if start > this.length. Done here to prevent potential uint32
	  // coercion fail below.
	  if (start > this.length) {
	    return ''
	  }
	
	  if (end === undefined || end > this.length) {
	    end = this.length
	  }
	
	  if (end <= 0) {
	    return ''
	  }
	
	  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
	  end >>>= 0
	  start >>>= 0
	
	  if (end <= start) {
	    return ''
	  }
	
	  if (!encoding) encoding = 'utf8'
	
	  while (true) {
	    switch (encoding) {
	      case 'hex':
	        return hexSlice(this, start, end)
	
	      case 'utf8':
	      case 'utf-8':
	        return utf8Slice(this, start, end)
	
	      case 'ascii':
	        return asciiSlice(this, start, end)
	
	      case 'latin1':
	      case 'binary':
	        return latin1Slice(this, start, end)
	
	      case 'base64':
	        return base64Slice(this, start, end)
	
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return utf16leSlice(this, start, end)
	
	      default:
	        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
	        encoding = (encoding + '').toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	
	// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
	// Buffer instances.
	Buffer.prototype._isBuffer = true
	
	function swap (b, n, m) {
	  var i = b[n]
	  b[n] = b[m]
	  b[m] = i
	}
	
	Buffer.prototype.swap16 = function swap16 () {
	  var len = this.length
	  if (len % 2 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 16-bits')
	  }
	  for (var i = 0; i < len; i += 2) {
	    swap(this, i, i + 1)
	  }
	  return this
	}
	
	Buffer.prototype.swap32 = function swap32 () {
	  var len = this.length
	  if (len % 4 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 32-bits')
	  }
	  for (var i = 0; i < len; i += 4) {
	    swap(this, i, i + 3)
	    swap(this, i + 1, i + 2)
	  }
	  return this
	}
	
	Buffer.prototype.swap64 = function swap64 () {
	  var len = this.length
	  if (len % 8 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 64-bits')
	  }
	  for (var i = 0; i < len; i += 8) {
	    swap(this, i, i + 7)
	    swap(this, i + 1, i + 6)
	    swap(this, i + 2, i + 5)
	    swap(this, i + 3, i + 4)
	  }
	  return this
	}
	
	Buffer.prototype.toString = function toString () {
	  var length = this.length | 0
	  if (length === 0) return ''
	  if (arguments.length === 0) return utf8Slice(this, 0, length)
	  return slowToString.apply(this, arguments)
	}
	
	Buffer.prototype.equals = function equals (b) {
	  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
	  if (this === b) return true
	  return Buffer.compare(this, b) === 0
	}
	
	Buffer.prototype.inspect = function inspect () {
	  var str = ''
	  var max = exports.INSPECT_MAX_BYTES
	  if (this.length > 0) {
	    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
	    if (this.length > max) str += ' ... '
	  }
	  return '<Buffer ' + str + '>'
	}
	
	Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
	  if (!Buffer.isBuffer(target)) {
	    throw new TypeError('Argument must be a Buffer')
	  }
	
	  if (start === undefined) {
	    start = 0
	  }
	  if (end === undefined) {
	    end = target ? target.length : 0
	  }
	  if (thisStart === undefined) {
	    thisStart = 0
	  }
	  if (thisEnd === undefined) {
	    thisEnd = this.length
	  }
	
	  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
	    throw new RangeError('out of range index')
	  }
	
	  if (thisStart >= thisEnd && start >= end) {
	    return 0
	  }
	  if (thisStart >= thisEnd) {
	    return -1
	  }
	  if (start >= end) {
	    return 1
	  }
	
	  start >>>= 0
	  end >>>= 0
	  thisStart >>>= 0
	  thisEnd >>>= 0
	
	  if (this === target) return 0
	
	  var x = thisEnd - thisStart
	  var y = end - start
	  var len = Math.min(x, y)
	
	  var thisCopy = this.slice(thisStart, thisEnd)
	  var targetCopy = target.slice(start, end)
	
	  for (var i = 0; i < len; ++i) {
	    if (thisCopy[i] !== targetCopy[i]) {
	      x = thisCopy[i]
	      y = targetCopy[i]
	      break
	    }
	  }
	
	  if (x < y) return -1
	  if (y < x) return 1
	  return 0
	}
	
	// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
	// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
	//
	// Arguments:
	// - buffer - a Buffer to search
	// - val - a string, Buffer, or number
	// - byteOffset - an index into `buffer`; will be clamped to an int32
	// - encoding - an optional encoding, relevant is val is a string
	// - dir - true for indexOf, false for lastIndexOf
	function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
	  // Empty buffer means no match
	  if (buffer.length === 0) return -1
	
	  // Normalize byteOffset
	  if (typeof byteOffset === 'string') {
	    encoding = byteOffset
	    byteOffset = 0
	  } else if (byteOffset > 0x7fffffff) {
	    byteOffset = 0x7fffffff
	  } else if (byteOffset < -0x80000000) {
	    byteOffset = -0x80000000
	  }
	  byteOffset = +byteOffset  // Coerce to Number.
	  if (isNaN(byteOffset)) {
	    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
	    byteOffset = dir ? 0 : (buffer.length - 1)
	  }
	
	  // Normalize byteOffset: negative offsets start from the end of the buffer
	  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
	  if (byteOffset >= buffer.length) {
	    if (dir) return -1
	    else byteOffset = buffer.length - 1
	  } else if (byteOffset < 0) {
	    if (dir) byteOffset = 0
	    else return -1
	  }
	
	  // Normalize val
	  if (typeof val === 'string') {
	    val = Buffer.from(val, encoding)
	  }
	
	  // Finally, search either indexOf (if dir is true) or lastIndexOf
	  if (Buffer.isBuffer(val)) {
	    // Special case: looking for empty string/buffer always fails
	    if (val.length === 0) {
	      return -1
	    }
	    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
	  } else if (typeof val === 'number') {
	    val = val & 0xFF // Search for a byte value [0-255]
	    if (Buffer.TYPED_ARRAY_SUPPORT &&
	        typeof Uint8Array.prototype.indexOf === 'function') {
	      if (dir) {
	        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
	      } else {
	        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
	      }
	    }
	    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
	  }
	
	  throw new TypeError('val must be string, number or Buffer')
	}
	
	function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
	  var indexSize = 1
	  var arrLength = arr.length
	  var valLength = val.length
	
	  if (encoding !== undefined) {
	    encoding = String(encoding).toLowerCase()
	    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
	        encoding === 'utf16le' || encoding === 'utf-16le') {
	      if (arr.length < 2 || val.length < 2) {
	        return -1
	      }
	      indexSize = 2
	      arrLength /= 2
	      valLength /= 2
	      byteOffset /= 2
	    }
	  }
	
	  function read (buf, i) {
	    if (indexSize === 1) {
	      return buf[i]
	    } else {
	      return buf.readUInt16BE(i * indexSize)
	    }
	  }
	
	  var i
	  if (dir) {
	    var foundIndex = -1
	    for (i = byteOffset; i < arrLength; i++) {
	      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
	        if (foundIndex === -1) foundIndex = i
	        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
	      } else {
	        if (foundIndex !== -1) i -= i - foundIndex
	        foundIndex = -1
	      }
	    }
	  } else {
	    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
	    for (i = byteOffset; i >= 0; i--) {
	      var found = true
	      for (var j = 0; j < valLength; j++) {
	        if (read(arr, i + j) !== read(val, j)) {
	          found = false
	          break
	        }
	      }
	      if (found) return i
	    }
	  }
	
	  return -1
	}
	
	Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
	  return this.indexOf(val, byteOffset, encoding) !== -1
	}
	
	Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
	  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
	}
	
	Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
	  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
	}
	
	function hexWrite (buf, string, offset, length) {
	  offset = Number(offset) || 0
	  var remaining = buf.length - offset
	  if (!length) {
	    length = remaining
	  } else {
	    length = Number(length)
	    if (length > remaining) {
	      length = remaining
	    }
	  }
	
	  // must be an even number of digits
	  var strLen = string.length
	  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')
	
	  if (length > strLen / 2) {
	    length = strLen / 2
	  }
	  for (var i = 0; i < length; ++i) {
	    var parsed = parseInt(string.substr(i * 2, 2), 16)
	    if (isNaN(parsed)) return i
	    buf[offset + i] = parsed
	  }
	  return i
	}
	
	function utf8Write (buf, string, offset, length) {
	  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
	}
	
	function asciiWrite (buf, string, offset, length) {
	  return blitBuffer(asciiToBytes(string), buf, offset, length)
	}
	
	function latin1Write (buf, string, offset, length) {
	  return asciiWrite(buf, string, offset, length)
	}
	
	function base64Write (buf, string, offset, length) {
	  return blitBuffer(base64ToBytes(string), buf, offset, length)
	}
	
	function ucs2Write (buf, string, offset, length) {
	  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
	}
	
	Buffer.prototype.write = function write (string, offset, length, encoding) {
	  // Buffer#write(string)
	  if (offset === undefined) {
	    encoding = 'utf8'
	    length = this.length
	    offset = 0
	  // Buffer#write(string, encoding)
	  } else if (length === undefined && typeof offset === 'string') {
	    encoding = offset
	    length = this.length
	    offset = 0
	  // Buffer#write(string, offset[, length][, encoding])
	  } else if (isFinite(offset)) {
	    offset = offset | 0
	    if (isFinite(length)) {
	      length = length | 0
	      if (encoding === undefined) encoding = 'utf8'
	    } else {
	      encoding = length
	      length = undefined
	    }
	  // legacy write(string, encoding, offset, length) - remove in v0.13
	  } else {
	    throw new Error(
	      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
	    )
	  }
	
	  var remaining = this.length - offset
	  if (length === undefined || length > remaining) length = remaining
	
	  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
	    throw new RangeError('Attempt to write outside buffer bounds')
	  }
	
	  if (!encoding) encoding = 'utf8'
	
	  var loweredCase = false
	  for (;;) {
	    switch (encoding) {
	      case 'hex':
	        return hexWrite(this, string, offset, length)
	
	      case 'utf8':
	      case 'utf-8':
	        return utf8Write(this, string, offset, length)
	
	      case 'ascii':
	        return asciiWrite(this, string, offset, length)
	
	      case 'latin1':
	      case 'binary':
	        return latin1Write(this, string, offset, length)
	
	      case 'base64':
	        // Warning: maxLength not taken into account in base64Write
	        return base64Write(this, string, offset, length)
	
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return ucs2Write(this, string, offset, length)
	
	      default:
	        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
	        encoding = ('' + encoding).toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	
	Buffer.prototype.toJSON = function toJSON () {
	  return {
	    type: 'Buffer',
	    data: Array.prototype.slice.call(this._arr || this, 0)
	  }
	}
	
	function base64Slice (buf, start, end) {
	  if (start === 0 && end === buf.length) {
	    return base64.fromByteArray(buf)
	  } else {
	    return base64.fromByteArray(buf.slice(start, end))
	  }
	}
	
	function utf8Slice (buf, start, end) {
	  end = Math.min(buf.length, end)
	  var res = []
	
	  var i = start
	  while (i < end) {
	    var firstByte = buf[i]
	    var codePoint = null
	    var bytesPerSequence = (firstByte > 0xEF) ? 4
	      : (firstByte > 0xDF) ? 3
	      : (firstByte > 0xBF) ? 2
	      : 1
	
	    if (i + bytesPerSequence <= end) {
	      var secondByte, thirdByte, fourthByte, tempCodePoint
	
	      switch (bytesPerSequence) {
	        case 1:
	          if (firstByte < 0x80) {
	            codePoint = firstByte
	          }
	          break
	        case 2:
	          secondByte = buf[i + 1]
	          if ((secondByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
	            if (tempCodePoint > 0x7F) {
	              codePoint = tempCodePoint
	            }
	          }
	          break
	        case 3:
	          secondByte = buf[i + 1]
	          thirdByte = buf[i + 2]
	          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
	            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
	              codePoint = tempCodePoint
	            }
	          }
	          break
	        case 4:
	          secondByte = buf[i + 1]
	          thirdByte = buf[i + 2]
	          fourthByte = buf[i + 3]
	          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
	            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
	              codePoint = tempCodePoint
	            }
	          }
	      }
	    }
	
	    if (codePoint === null) {
	      // we did not generate a valid codePoint so insert a
	      // replacement char (U+FFFD) and advance only 1 byte
	      codePoint = 0xFFFD
	      bytesPerSequence = 1
	    } else if (codePoint > 0xFFFF) {
	      // encode to utf16 (surrogate pair dance)
	      codePoint -= 0x10000
	      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
	      codePoint = 0xDC00 | codePoint & 0x3FF
	    }
	
	    res.push(codePoint)
	    i += bytesPerSequence
	  }
	
	  return decodeCodePointsArray(res)
	}
	
	// Based on http://stackoverflow.com/a/22747272/680742, the browser with
	// the lowest limit is Chrome, with 0x10000 args.
	// We go 1 magnitude less, for safety
	var MAX_ARGUMENTS_LENGTH = 0x1000
	
	function decodeCodePointsArray (codePoints) {
	  var len = codePoints.length
	  if (len <= MAX_ARGUMENTS_LENGTH) {
	    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
	  }
	
	  // Decode in chunks to avoid "call stack size exceeded".
	  var res = ''
	  var i = 0
	  while (i < len) {
	    res += String.fromCharCode.apply(
	      String,
	      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
	    )
	  }
	  return res
	}
	
	function asciiSlice (buf, start, end) {
	  var ret = ''
	  end = Math.min(buf.length, end)
	
	  for (var i = start; i < end; ++i) {
	    ret += String.fromCharCode(buf[i] & 0x7F)
	  }
	  return ret
	}
	
	function latin1Slice (buf, start, end) {
	  var ret = ''
	  end = Math.min(buf.length, end)
	
	  for (var i = start; i < end; ++i) {
	    ret += String.fromCharCode(buf[i])
	  }
	  return ret
	}
	
	function hexSlice (buf, start, end) {
	  var len = buf.length
	
	  if (!start || start < 0) start = 0
	  if (!end || end < 0 || end > len) end = len
	
	  var out = ''
	  for (var i = start; i < end; ++i) {
	    out += toHex(buf[i])
	  }
	  return out
	}
	
	function utf16leSlice (buf, start, end) {
	  var bytes = buf.slice(start, end)
	  var res = ''
	  for (var i = 0; i < bytes.length; i += 2) {
	    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
	  }
	  return res
	}
	
	Buffer.prototype.slice = function slice (start, end) {
	  var len = this.length
	  start = ~~start
	  end = end === undefined ? len : ~~end
	
	  if (start < 0) {
	    start += len
	    if (start < 0) start = 0
	  } else if (start > len) {
	    start = len
	  }
	
	  if (end < 0) {
	    end += len
	    if (end < 0) end = 0
	  } else if (end > len) {
	    end = len
	  }
	
	  if (end < start) end = start
	
	  var newBuf
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    newBuf = this.subarray(start, end)
	    newBuf.__proto__ = Buffer.prototype
	  } else {
	    var sliceLen = end - start
	    newBuf = new Buffer(sliceLen, undefined)
	    for (var i = 0; i < sliceLen; ++i) {
	      newBuf[i] = this[i + start]
	    }
	  }
	
	  return newBuf
	}
	
	/*
	 * Need to make sure that buffer isn't trying to write out of bounds.
	 */
	function checkOffset (offset, ext, length) {
	  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
	  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
	}
	
	Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var val = this[offset]
	  var mul = 1
	  var i = 0
	  while (++i < byteLength && (mul *= 0x100)) {
	    val += this[offset + i] * mul
	  }
	
	  return val
	}
	
	Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    checkOffset(offset, byteLength, this.length)
	  }
	
	  var val = this[offset + --byteLength]
	  var mul = 1
	  while (byteLength > 0 && (mul *= 0x100)) {
	    val += this[offset + --byteLength] * mul
	  }
	
	  return val
	}
	
	Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 1, this.length)
	  return this[offset]
	}
	
	Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  return this[offset] | (this[offset + 1] << 8)
	}
	
	Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  return (this[offset] << 8) | this[offset + 1]
	}
	
	Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return ((this[offset]) |
	      (this[offset + 1] << 8) |
	      (this[offset + 2] << 16)) +
	      (this[offset + 3] * 0x1000000)
	}
	
	Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset] * 0x1000000) +
	    ((this[offset + 1] << 16) |
	    (this[offset + 2] << 8) |
	    this[offset + 3])
	}
	
	Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var val = this[offset]
	  var mul = 1
	  var i = 0
	  while (++i < byteLength && (mul *= 0x100)) {
	    val += this[offset + i] * mul
	  }
	  mul *= 0x80
	
	  if (val >= mul) val -= Math.pow(2, 8 * byteLength)
	
	  return val
	}
	
	Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var i = byteLength
	  var mul = 1
	  var val = this[offset + --i]
	  while (i > 0 && (mul *= 0x100)) {
	    val += this[offset + --i] * mul
	  }
	  mul *= 0x80
	
	  if (val >= mul) val -= Math.pow(2, 8 * byteLength)
	
	  return val
	}
	
	Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 1, this.length)
	  if (!(this[offset] & 0x80)) return (this[offset])
	  return ((0xff - this[offset] + 1) * -1)
	}
	
	Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  var val = this[offset] | (this[offset + 1] << 8)
	  return (val & 0x8000) ? val | 0xFFFF0000 : val
	}
	
	Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  var val = this[offset + 1] | (this[offset] << 8)
	  return (val & 0x8000) ? val | 0xFFFF0000 : val
	}
	
	Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset]) |
	    (this[offset + 1] << 8) |
	    (this[offset + 2] << 16) |
	    (this[offset + 3] << 24)
	}
	
	Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset] << 24) |
	    (this[offset + 1] << 16) |
	    (this[offset + 2] << 8) |
	    (this[offset + 3])
	}
	
	Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	  return ieee754.read(this, offset, true, 23, 4)
	}
	
	Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	  return ieee754.read(this, offset, false, 23, 4)
	}
	
	Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 8, this.length)
	  return ieee754.read(this, offset, true, 52, 8)
	}
	
	Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 8, this.length)
	  return ieee754.read(this, offset, false, 52, 8)
	}
	
	function checkInt (buf, value, offset, ext, max, min) {
	  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
	  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
	  if (offset + ext > buf.length) throw new RangeError('Index out of range')
	}
	
	Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    var maxBytes = Math.pow(2, 8 * byteLength) - 1
	    checkInt(this, value, offset, byteLength, maxBytes, 0)
	  }
	
	  var mul = 1
	  var i = 0
	  this[offset] = value & 0xFF
	  while (++i < byteLength && (mul *= 0x100)) {
	    this[offset + i] = (value / mul) & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    var maxBytes = Math.pow(2, 8 * byteLength) - 1
	    checkInt(this, value, offset, byteLength, maxBytes, 0)
	  }
	
	  var i = byteLength - 1
	  var mul = 1
	  this[offset + i] = value & 0xFF
	  while (--i >= 0 && (mul *= 0x100)) {
	    this[offset + i] = (value / mul) & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
	  this[offset] = (value & 0xff)
	  return offset + 1
	}
	
	function objectWriteUInt16 (buf, value, offset, littleEndian) {
	  if (value < 0) value = 0xffff + value + 1
	  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
	    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
	      (littleEndian ? i : 1 - i) * 8
	  }
	}
	
	Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	  } else {
	    objectWriteUInt16(this, value, offset, true)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 8)
	    this[offset + 1] = (value & 0xff)
	  } else {
	    objectWriteUInt16(this, value, offset, false)
	  }
	  return offset + 2
	}
	
	function objectWriteUInt32 (buf, value, offset, littleEndian) {
	  if (value < 0) value = 0xffffffff + value + 1
	  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
	    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
	  }
	}
	
	Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset + 3] = (value >>> 24)
	    this[offset + 2] = (value >>> 16)
	    this[offset + 1] = (value >>> 8)
	    this[offset] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, true)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 24)
	    this[offset + 1] = (value >>> 16)
	    this[offset + 2] = (value >>> 8)
	    this[offset + 3] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, false)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) {
	    var limit = Math.pow(2, 8 * byteLength - 1)
	
	    checkInt(this, value, offset, byteLength, limit - 1, -limit)
	  }
	
	  var i = 0
	  var mul = 1
	  var sub = 0
	  this[offset] = value & 0xFF
	  while (++i < byteLength && (mul *= 0x100)) {
	    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
	      sub = 1
	    }
	    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) {
	    var limit = Math.pow(2, 8 * byteLength - 1)
	
	    checkInt(this, value, offset, byteLength, limit - 1, -limit)
	  }
	
	  var i = byteLength - 1
	  var mul = 1
	  var sub = 0
	  this[offset + i] = value & 0xFF
	  while (--i >= 0 && (mul *= 0x100)) {
	    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
	      sub = 1
	    }
	    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
	  if (value < 0) value = 0xff + value + 1
	  this[offset] = (value & 0xff)
	  return offset + 1
	}
	
	Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	  } else {
	    objectWriteUInt16(this, value, offset, true)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 8)
	    this[offset + 1] = (value & 0xff)
	  } else {
	    objectWriteUInt16(this, value, offset, false)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	    this[offset + 2] = (value >>> 16)
	    this[offset + 3] = (value >>> 24)
	  } else {
	    objectWriteUInt32(this, value, offset, true)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
	  if (value < 0) value = 0xffffffff + value + 1
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 24)
	    this[offset + 1] = (value >>> 16)
	    this[offset + 2] = (value >>> 8)
	    this[offset + 3] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, false)
	  }
	  return offset + 4
	}
	
	function checkIEEE754 (buf, value, offset, ext, max, min) {
	  if (offset + ext > buf.length) throw new RangeError('Index out of range')
	  if (offset < 0) throw new RangeError('Index out of range')
	}
	
	function writeFloat (buf, value, offset, littleEndian, noAssert) {
	  if (!noAssert) {
	    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
	  }
	  ieee754.write(buf, value, offset, littleEndian, 23, 4)
	  return offset + 4
	}
	
	Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
	  return writeFloat(this, value, offset, true, noAssert)
	}
	
	Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
	  return writeFloat(this, value, offset, false, noAssert)
	}
	
	function writeDouble (buf, value, offset, littleEndian, noAssert) {
	  if (!noAssert) {
	    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
	  }
	  ieee754.write(buf, value, offset, littleEndian, 52, 8)
	  return offset + 8
	}
	
	Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
	  return writeDouble(this, value, offset, true, noAssert)
	}
	
	Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
	  return writeDouble(this, value, offset, false, noAssert)
	}
	
	// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
	Buffer.prototype.copy = function copy (target, targetStart, start, end) {
	  if (!start) start = 0
	  if (!end && end !== 0) end = this.length
	  if (targetStart >= target.length) targetStart = target.length
	  if (!targetStart) targetStart = 0
	  if (end > 0 && end < start) end = start
	
	  // Copy 0 bytes; we're done
	  if (end === start) return 0
	  if (target.length === 0 || this.length === 0) return 0
	
	  // Fatal error conditions
	  if (targetStart < 0) {
	    throw new RangeError('targetStart out of bounds')
	  }
	  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
	  if (end < 0) throw new RangeError('sourceEnd out of bounds')
	
	  // Are we oob?
	  if (end > this.length) end = this.length
	  if (target.length - targetStart < end - start) {
	    end = target.length - targetStart + start
	  }
	
	  var len = end - start
	  var i
	
	  if (this === target && start < targetStart && targetStart < end) {
	    // descending copy from end
	    for (i = len - 1; i >= 0; --i) {
	      target[i + targetStart] = this[i + start]
	    }
	  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
	    // ascending copy from start
	    for (i = 0; i < len; ++i) {
	      target[i + targetStart] = this[i + start]
	    }
	  } else {
	    Uint8Array.prototype.set.call(
	      target,
	      this.subarray(start, start + len),
	      targetStart
	    )
	  }
	
	  return len
	}
	
	// Usage:
	//    buffer.fill(number[, offset[, end]])
	//    buffer.fill(buffer[, offset[, end]])
	//    buffer.fill(string[, offset[, end]][, encoding])
	Buffer.prototype.fill = function fill (val, start, end, encoding) {
	  // Handle string cases:
	  if (typeof val === 'string') {
	    if (typeof start === 'string') {
	      encoding = start
	      start = 0
	      end = this.length
	    } else if (typeof end === 'string') {
	      encoding = end
	      end = this.length
	    }
	    if (val.length === 1) {
	      var code = val.charCodeAt(0)
	      if (code < 256) {
	        val = code
	      }
	    }
	    if (encoding !== undefined && typeof encoding !== 'string') {
	      throw new TypeError('encoding must be a string')
	    }
	    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
	      throw new TypeError('Unknown encoding: ' + encoding)
	    }
	  } else if (typeof val === 'number') {
	    val = val & 255
	  }
	
	  // Invalid ranges are not set to a default, so can range check early.
	  if (start < 0 || this.length < start || this.length < end) {
	    throw new RangeError('Out of range index')
	  }
	
	  if (end <= start) {
	    return this
	  }
	
	  start = start >>> 0
	  end = end === undefined ? this.length : end >>> 0
	
	  if (!val) val = 0
	
	  var i
	  if (typeof val === 'number') {
	    for (i = start; i < end; ++i) {
	      this[i] = val
	    }
	  } else {
	    var bytes = Buffer.isBuffer(val)
	      ? val
	      : utf8ToBytes(new Buffer(val, encoding).toString())
	    var len = bytes.length
	    for (i = 0; i < end - start; ++i) {
	      this[i + start] = bytes[i % len]
	    }
	  }
	
	  return this
	}
	
	// HELPER FUNCTIONS
	// ================
	
	var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g
	
	function base64clean (str) {
	  // Node strips out invalid characters like \n and \t from the string, base64-js does not
	  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
	  // Node converts strings with length < 2 to ''
	  if (str.length < 2) return ''
	  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
	  while (str.length % 4 !== 0) {
	    str = str + '='
	  }
	  return str
	}
	
	function stringtrim (str) {
	  if (str.trim) return str.trim()
	  return str.replace(/^\s+|\s+$/g, '')
	}
	
	function toHex (n) {
	  if (n < 16) return '0' + n.toString(16)
	  return n.toString(16)
	}
	
	function utf8ToBytes (string, units) {
	  units = units || Infinity
	  var codePoint
	  var length = string.length
	  var leadSurrogate = null
	  var bytes = []
	
	  for (var i = 0; i < length; ++i) {
	    codePoint = string.charCodeAt(i)
	
	    // is surrogate component
	    if (codePoint > 0xD7FF && codePoint < 0xE000) {
	      // last char was a lead
	      if (!leadSurrogate) {
	        // no lead yet
	        if (codePoint > 0xDBFF) {
	          // unexpected trail
	          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	          continue
	        } else if (i + 1 === length) {
	          // unpaired lead
	          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	          continue
	        }
	
	        // valid lead
	        leadSurrogate = codePoint
	
	        continue
	      }
	
	      // 2 leads in a row
	      if (codePoint < 0xDC00) {
	        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	        leadSurrogate = codePoint
	        continue
	      }
	
	      // valid surrogate pair
	      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
	    } else if (leadSurrogate) {
	      // valid bmp char, but last char was a lead
	      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	    }
	
	    leadSurrogate = null
	
	    // encode utf8
	    if (codePoint < 0x80) {
	      if ((units -= 1) < 0) break
	      bytes.push(codePoint)
	    } else if (codePoint < 0x800) {
	      if ((units -= 2) < 0) break
	      bytes.push(
	        codePoint >> 0x6 | 0xC0,
	        codePoint & 0x3F | 0x80
	      )
	    } else if (codePoint < 0x10000) {
	      if ((units -= 3) < 0) break
	      bytes.push(
	        codePoint >> 0xC | 0xE0,
	        codePoint >> 0x6 & 0x3F | 0x80,
	        codePoint & 0x3F | 0x80
	      )
	    } else if (codePoint < 0x110000) {
	      if ((units -= 4) < 0) break
	      bytes.push(
	        codePoint >> 0x12 | 0xF0,
	        codePoint >> 0xC & 0x3F | 0x80,
	        codePoint >> 0x6 & 0x3F | 0x80,
	        codePoint & 0x3F | 0x80
	      )
	    } else {
	      throw new Error('Invalid code point')
	    }
	  }
	
	  return bytes
	}
	
	function asciiToBytes (str) {
	  var byteArray = []
	  for (var i = 0; i < str.length; ++i) {
	    // Node's code seems to be doing this and not & 0x7F..
	    byteArray.push(str.charCodeAt(i) & 0xFF)
	  }
	  return byteArray
	}
	
	function utf16leToBytes (str, units) {
	  var c, hi, lo
	  var byteArray = []
	  for (var i = 0; i < str.length; ++i) {
	    if ((units -= 2) < 0) break
	
	    c = str.charCodeAt(i)
	    hi = c >> 8
	    lo = c % 256
	    byteArray.push(lo)
	    byteArray.push(hi)
	  }
	
	  return byteArray
	}
	
	function base64ToBytes (str) {
	  return base64.toByteArray(base64clean(str))
	}
	
	function blitBuffer (src, dst, offset, length) {
	  for (var i = 0; i < length; ++i) {
	    if ((i + offset >= dst.length) || (i >= src.length)) break
	    dst[i + offset] = src[i]
	  }
	  return i
	}
	
	function isnan (val) {
	  return val !== val // eslint-disable-line no-self-compare
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 1569 */
/***/ (function(module, exports) {

	'use strict'
	
	exports.byteLength = byteLength
	exports.toByteArray = toByteArray
	exports.fromByteArray = fromByteArray
	
	var lookup = []
	var revLookup = []
	var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array
	
	var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
	for (var i = 0, len = code.length; i < len; ++i) {
	  lookup[i] = code[i]
	  revLookup[code.charCodeAt(i)] = i
	}
	
	// Support decoding URL-safe base64 strings, as Node.js does.
	// See: https://en.wikipedia.org/wiki/Base64#URL_applications
	revLookup['-'.charCodeAt(0)] = 62
	revLookup['_'.charCodeAt(0)] = 63
	
	function getLens (b64) {
	  var len = b64.length
	
	  if (len % 4 > 0) {
	    throw new Error('Invalid string. Length must be a multiple of 4')
	  }
	
	  // Trim off extra bytes after placeholder bytes are found
	  // See: https://github.com/beatgammit/base64-js/issues/42
	  var validLen = b64.indexOf('=')
	  if (validLen === -1) validLen = len
	
	  var placeHoldersLen = validLen === len
	    ? 0
	    : 4 - (validLen % 4)
	
	  return [validLen, placeHoldersLen]
	}
	
	// base64 is 4/3 + up to two characters of the original data
	function byteLength (b64) {
	  var lens = getLens(b64)
	  var validLen = lens[0]
	  var placeHoldersLen = lens[1]
	  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
	}
	
	function _byteLength (b64, validLen, placeHoldersLen) {
	  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
	}
	
	function toByteArray (b64) {
	  var tmp
	  var lens = getLens(b64)
	  var validLen = lens[0]
	  var placeHoldersLen = lens[1]
	
	  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))
	
	  var curByte = 0
	
	  // if there are placeholders, only get up to the last complete 4 chars
	  var len = placeHoldersLen > 0
	    ? validLen - 4
	    : validLen
	
	  var i
	  for (i = 0; i < len; i += 4) {
	    tmp =
	      (revLookup[b64.charCodeAt(i)] << 18) |
	      (revLookup[b64.charCodeAt(i + 1)] << 12) |
	      (revLookup[b64.charCodeAt(i + 2)] << 6) |
	      revLookup[b64.charCodeAt(i + 3)]
	    arr[curByte++] = (tmp >> 16) & 0xFF
	    arr[curByte++] = (tmp >> 8) & 0xFF
	    arr[curByte++] = tmp & 0xFF
	  }
	
	  if (placeHoldersLen === 2) {
	    tmp =
	      (revLookup[b64.charCodeAt(i)] << 2) |
	      (revLookup[b64.charCodeAt(i + 1)] >> 4)
	    arr[curByte++] = tmp & 0xFF
	  }
	
	  if (placeHoldersLen === 1) {
	    tmp =
	      (revLookup[b64.charCodeAt(i)] << 10) |
	      (revLookup[b64.charCodeAt(i + 1)] << 4) |
	      (revLookup[b64.charCodeAt(i + 2)] >> 2)
	    arr[curByte++] = (tmp >> 8) & 0xFF
	    arr[curByte++] = tmp & 0xFF
	  }
	
	  return arr
	}
	
	function tripletToBase64 (num) {
	  return lookup[num >> 18 & 0x3F] +
	    lookup[num >> 12 & 0x3F] +
	    lookup[num >> 6 & 0x3F] +
	    lookup[num & 0x3F]
	}
	
	function encodeChunk (uint8, start, end) {
	  var tmp
	  var output = []
	  for (var i = start; i < end; i += 3) {
	    tmp =
	      ((uint8[i] << 16) & 0xFF0000) +
	      ((uint8[i + 1] << 8) & 0xFF00) +
	      (uint8[i + 2] & 0xFF)
	    output.push(tripletToBase64(tmp))
	  }
	  return output.join('')
	}
	
	function fromByteArray (uint8) {
	  var tmp
	  var len = uint8.length
	  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
	  var parts = []
	  var maxChunkLength = 16383 // must be multiple of 3
	
	  // go through the array every three bytes, we'll deal with trailing stuff later
	  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
	    parts.push(encodeChunk(uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)))
	  }
	
	  // pad the end with zeros, but make sure to not forget the extra bytes
	  if (extraBytes === 1) {
	    tmp = uint8[len - 1]
	    parts.push(
	      lookup[tmp >> 2] +
	      lookup[(tmp << 4) & 0x3F] +
	      '=='
	    )
	  } else if (extraBytes === 2) {
	    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
	    parts.push(
	      lookup[tmp >> 10] +
	      lookup[(tmp >> 4) & 0x3F] +
	      lookup[(tmp << 2) & 0x3F] +
	      '='
	    )
	  }
	
	  return parts.join('')
	}


/***/ }),
/* 1570 */
/***/ (function(module, exports) {

	/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
	exports.read = function (buffer, offset, isLE, mLen, nBytes) {
	  var e, m
	  var eLen = (nBytes * 8) - mLen - 1
	  var eMax = (1 << eLen) - 1
	  var eBias = eMax >> 1
	  var nBits = -7
	  var i = isLE ? (nBytes - 1) : 0
	  var d = isLE ? -1 : 1
	  var s = buffer[offset + i]
	
	  i += d
	
	  e = s & ((1 << (-nBits)) - 1)
	  s >>= (-nBits)
	  nBits += eLen
	  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}
	
	  m = e & ((1 << (-nBits)) - 1)
	  e >>= (-nBits)
	  nBits += mLen
	  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}
	
	  if (e === 0) {
	    e = 1 - eBias
	  } else if (e === eMax) {
	    return m ? NaN : ((s ? -1 : 1) * Infinity)
	  } else {
	    m = m + Math.pow(2, mLen)
	    e = e - eBias
	  }
	  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
	}
	
	exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
	  var e, m, c
	  var eLen = (nBytes * 8) - mLen - 1
	  var eMax = (1 << eLen) - 1
	  var eBias = eMax >> 1
	  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
	  var i = isLE ? 0 : (nBytes - 1)
	  var d = isLE ? 1 : -1
	  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0
	
	  value = Math.abs(value)
	
	  if (isNaN(value) || value === Infinity) {
	    m = isNaN(value) ? 1 : 0
	    e = eMax
	  } else {
	    e = Math.floor(Math.log(value) / Math.LN2)
	    if (value * (c = Math.pow(2, -e)) < 1) {
	      e--
	      c *= 2
	    }
	    if (e + eBias >= 1) {
	      value += rt / c
	    } else {
	      value += rt * Math.pow(2, 1 - eBias)
	    }
	    if (value * c >= 2) {
	      e++
	      c /= 2
	    }
	
	    if (e + eBias >= eMax) {
	      m = 0
	      e = eMax
	    } else if (e + eBias >= 1) {
	      m = ((value * c) - 1) * Math.pow(2, mLen)
	      e = e + eBias
	    } else {
	      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
	      e = 0
	    }
	  }
	
	  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}
	
	  e = (e << mLen) | m
	  eLen += mLen
	  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}
	
	  buffer[offset + i - d] |= s * 128
	}


/***/ }),
/* 1571 */
/***/ (function(module, exports) {

	/* (ignored) */

/***/ }),
/* 1572 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireDefault = __webpack_require__(1488);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(1492));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(1493));
	
	var _Keys = _interopRequireDefault(__webpack_require__(1567));
	
	var Key = /*#__PURE__*/function () {
	  function Key(id, apiCall) {
	    (0, _classCallCheck2.default)(this, Key);
	    this._apiCall = apiCall;
	    this._id = id;
	  }
	
	  (0, _createClass2.default)(Key, [{
	    key: "retrieve",
	    value: function retrieve() {
	      return this._apiCall.get(this._endpointPath());
	    }
	  }, {
	    key: "delete",
	    value: function _delete() {
	      return this._apiCall.delete(this._endpointPath());
	    }
	  }, {
	    key: "_endpointPath",
	    value: function _endpointPath() {
	      return "".concat(_Keys.default.RESOURCEPATH, "/").concat(this._id);
	    }
	  }]);
	  return Key;
	}();
	
	exports.default = Key;
	//# sourceMappingURL=Key.js.map


/***/ }),
/* 1573 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireDefault = __webpack_require__(1488);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(1492));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(1493));
	
	var RESOURCEPATH = '/debug';
	
	var Debug = /*#__PURE__*/function () {
	  function Debug(apiCall) {
	    (0, _classCallCheck2.default)(this, Debug);
	    this._apiCall = apiCall;
	  }
	
	  (0, _createClass2.default)(Debug, [{
	    key: "retrieve",
	    value: function retrieve() {
	      return this._apiCall.get(RESOURCEPATH);
	    }
	  }]);
	  return Debug;
	}();
	
	exports.default = Debug;
	//# sourceMappingURL=Debug.js.map


/***/ }),
/* 1574 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireDefault = __webpack_require__(1488);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(1492));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(1493));
	
	var RESOURCEPATH = '/metrics.json';
	
	var Metrics = /*#__PURE__*/function () {
	  function Metrics(apiCall) {
	    (0, _classCallCheck2.default)(this, Metrics);
	    this._apiCall = apiCall;
	  }
	
	  (0, _createClass2.default)(Metrics, [{
	    key: "retrieve",
	    value: function retrieve() {
	      return this._apiCall.get(RESOURCEPATH);
	    }
	  }]);
	  return Metrics;
	}();
	
	exports.default = Metrics;
	//# sourceMappingURL=Metrics.js.map


/***/ }),
/* 1575 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireDefault = __webpack_require__(1488);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(1492));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(1493));
	
	var RESOURCEPATH = '/health';
	
	var Health = /*#__PURE__*/function () {
	  function Health(apiCall) {
	    (0, _classCallCheck2.default)(this, Health);
	    this._apiCall = apiCall;
	  }
	
	  (0, _createClass2.default)(Health, [{
	    key: "retrieve",
	    value: function retrieve() {
	      return this._apiCall.get(RESOURCEPATH);
	    }
	  }]);
	  return Health;
	}();
	
	exports.default = Health;
	//# sourceMappingURL=Health.js.map


/***/ }),
/* 1576 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireDefault = __webpack_require__(1488);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(1492));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(1493));
	
	var RESOURCEPATH = '/operations';
	
	var Operations = /*#__PURE__*/function () {
	  function Operations(apiCall) {
	    (0, _classCallCheck2.default)(this, Operations);
	    this._apiCall = apiCall;
	  }
	
	  (0, _createClass2.default)(Operations, [{
	    key: "perform",
	    value: function perform(operationName) {
	      var queryParameters = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	      return this._apiCall.post("".concat(RESOURCEPATH, "/").concat(operationName), {}, queryParameters);
	    }
	  }]);
	  return Operations;
	}();
	
	exports.default = Operations;
	//# sourceMappingURL=Operations.js.map


/***/ }),
/* 1577 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireDefault = __webpack_require__(1488);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(1492));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(1493));
	
	var _RequestWithCache = _interopRequireDefault(__webpack_require__(1553));
	
	var RESOURCEPATH = '/multi_search';
	
	var MultiSearch = /*#__PURE__*/function () {
	  function MultiSearch(apiCall, configuration) {
	    var useTextContentType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	    (0, _classCallCheck2.default)(this, MultiSearch);
	    this._apiCall = apiCall;
	    this._configuration = configuration;
	    this._useTextContentType = useTextContentType; // To avoid OPTIONS request
	
	    this._requestWithCache = new _RequestWithCache.default();
	  }
	
	  (0, _createClass2.default)(MultiSearch, [{
	    key: "perform",
	    value: function perform(searchRequests) {
	      var commonParams = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	      var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
	          _ref$cacheSearchResul = _ref.cacheSearchResultsForSeconds,
	          cacheSearchResultsForSeconds = _ref$cacheSearchResul === void 0 ? this._configuration.cacheSearchResultsForSeconds : _ref$cacheSearchResul;
	
	      var additionalHeaders = {};
	
	      if (this._useTextContentType) {
	        additionalHeaders['content-type'] = 'text/plain';
	      }
	
	      var additionalQueryParams = {};
	
	      if (this._configuration.useServerSideSearchCache === true) {
	        additionalQueryParams['use_cache'] = true;
	      }
	
	      var queryParams = Object.assign({}, commonParams, additionalQueryParams);
	      return this._requestWithCache.perform(this._apiCall, this._apiCall.post, [RESOURCEPATH, searchRequests, queryParams, additionalHeaders], {
	        cacheResponseForSeconds: cacheSearchResultsForSeconds
	      });
	    }
	  }]);
	  return MultiSearch;
	}();
	
	exports.default = MultiSearch;
	//# sourceMappingURL=MultiSearch.js.map


/***/ }),
/* 1578 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireDefault = __webpack_require__(1488);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(1492));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(1493));
	
	var _Configuration = _interopRequireDefault(__webpack_require__(1498));
	
	var _ApiCall = _interopRequireDefault(__webpack_require__(1520));
	
	var _Collection = _interopRequireDefault(__webpack_require__(1551));
	
	var _MultiSearch = _interopRequireDefault(__webpack_require__(1577));
	
	var SearchClient = /*#__PURE__*/function () {
	  function SearchClient(options) {
	    (0, _classCallCheck2.default)(this, SearchClient);
	    options = options || {}; // In v0.20.0 we restrict query params to 2000 in length
	    // But sometimes scoped API keys can be over this limit, so we send long keys as headers instead.
	    // The tradeoff is that using a header to send the API key will trigger the browser to send an OPTIONS request though.
	
	    if ((options['apiKey'] || '').length < 2000) {
	      options['sendApiKeyAsQueryParam'] = true;
	    }
	
	    this.configuration = new _Configuration.default(options);
	    this._apiCall = new _ApiCall.default(this.configuration);
	    this.multiSearch = new _MultiSearch.default(this._apiCall, this.configuration, true);
	    this._individualCollections = {};
	  }
	
	  (0, _createClass2.default)(SearchClient, [{
	    key: "collections",
	    value: function collections(collectionName) {
	      if (collectionName === undefined) {
	        throw new Error('Typesense.SearchClient only supports search operations, so the collectionName that needs to ' + 'be searched must be specified. Use Typesense.Client if you need to access the collection object.');
	      } else {
	        if (this._individualCollections[collectionName] === undefined) {
	          this._individualCollections[collectionName] = new _Collection.default(collectionName, this._apiCall, this.configuration);
	        }
	
	        return this._individualCollections[collectionName];
	      }
	    }
	  }]);
	  return SearchClient;
	}();
	
	exports.default = SearchClient;
	//# sourceMappingURL=SearchClient.js.map


/***/ }),
/* 1579 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1488);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SearchRequestAdapter = void 0;
	
	var _regenerator = _interopRequireDefault(__webpack_require__(1489));
	
	var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(1491));
	
	var _slicedToArray2 = _interopRequireDefault(__webpack_require__(1580));
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(1492));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(1493));
	
	var SearchRequestAdapter = /*#__PURE__*/function () {
	  function SearchRequestAdapter(instantsearchRequests, typesenseClient, configuration) {
	    (0, _classCallCheck2["default"])(this, SearchRequestAdapter);
	    this.instantsearchRequests = instantsearchRequests;
	    this.typesenseClient = typesenseClient;
	    this.configuration = configuration;
	    this.additionalSearchParameters = configuration.additionalSearchParameters;
	    this.collectionSpecificSearchParameters = configuration.collectionSpecificSearchParameters;
	  }
	
	  (0, _createClass2["default"])(SearchRequestAdapter, [{
	    key: "_adaptFacetFilters",
	    value: function _adaptFacetFilters(facetFilters) {
	      var _this = this;
	
	      var adaptedResult = "";
	
	      if (!facetFilters) {
	        return adaptedResult;
	      }
	      /**
	       * Need to transform:
	       *  facetFilters = [["field1:value1", "field1:value2"], "field2:value3", "field2:value4"]
	       *
	       * Into this:
	       *  field1:=[value1,value2] && field2:=value3 && field2:=value4
	       *
	       * Steps:
	       *  - For each item in facetFilters
	       *    - If item is array
	       *      - OR values together.
	       *      - Warn if field names are not the same
	       *    - If item is string, convert to facet:=value format
	       *  - Join strings by &&
	       */
	
	
	      var transformedTypesenseFilters = facetFilters.map(function (item) {
	        if (Array.isArray(item)) {
	          // Need to transform:
	          // facetFilters = ["field1:value1", "field1:value2", "facetN:valueN"]
	          //
	          // Into this:
	          // intermediateFacetFilters = {
	          //     "field1": ["value1", "value2"],
	          //     "fieldN": ["valueN"]
	          // }
	          var intermediateFacetFilters = {};
	          item.forEach(function (facetFilter) {
	            var facetFilterMatches = facetFilter.match(_this.constructor.FILTER_STRING_MATCHING_REGEX);
	            var fieldName = "".concat(facetFilterMatches[1]).concat(facetFilterMatches[2]);
	            var fieldValue = "".concat(facetFilterMatches[3]);
	            intermediateFacetFilters[fieldName] = intermediateFacetFilters[fieldName] || [];
	            intermediateFacetFilters[fieldName].push(fieldValue);
	          });
	
	          if (Object.keys(intermediateFacetFilters).length > 1) {
	            console.error("[Typesense-Instantsearch-Adapter] Typesense does not support cross-field ORs at the moment. The adapter could not OR values between these fields: ".concat(Object.keys(intermediateFacetFilters).join(",")));
	          } // Pick first value from intermediateFacetFilters
	
	
	          var fieldName = Object.keys(intermediateFacetFilters)[0];
	          var fieldValues = intermediateFacetFilters[fieldName]; // Need to transform:
	          // intermediateFacetFilters = {
	          //     "field1": ["value1", "value2"],
	          // }
	          //
	          // Into this:
	          // field1:=[value1,value2]
	          // Partition values into included and excluded values
	
	          var _fieldValues$reduce = fieldValues.reduce(function (result, fieldValue) {
	            if (fieldValue.startsWith("-") && !_this._isNumber(fieldValue)) {
	              result[0].push(fieldValue.substring(1));
	            } else {
	              result[1].push(fieldValue);
	            }
	
	            return result;
	          }, [[], []]),
	              _fieldValues$reduce2 = (0, _slicedToArray2["default"])(_fieldValues$reduce, 2),
	              excludedFieldValues = _fieldValues$reduce2[0],
	              includedFieldValues = _fieldValues$reduce2[1];
	
	          var typesenseFilterStringComponents = [];
	
	          if (includedFieldValues.length > 0) {
	            typesenseFilterStringComponents.push("".concat(fieldName, ":=[").concat(includedFieldValues.map(function (v) {
	              return _this._escapeFacetValue(v);
	            }).join(","), "]"));
	          }
	
	          if (excludedFieldValues.length > 0) {
	            typesenseFilterStringComponents.push("".concat(fieldName, ":!=[").concat(excludedFieldValues.map(function (v) {
	              return _this._escapeFacetValue(v);
	            }).join(","), "]"));
	          }
	
	          var typesenseFilterString = typesenseFilterStringComponents.filter(function (f) {
	            return f;
	          }).join(" && ");
	          return typesenseFilterString;
	        } else {
	          // Need to transform:
	          //  fieldName:fieldValue
	          // Into
	          //  fieldName:=fieldValue
	          var facetFilterMatches = item.match(_this.constructor.FILTER_STRING_MATCHING_REGEX);
	
	          var _fieldName = "".concat(facetFilterMatches[1]).concat(facetFilterMatches[2]);
	
	          var fieldValue = "".concat(facetFilterMatches[3]);
	
	          var _typesenseFilterString;
	
	          if (fieldValue.startsWith("-") && !_this._isNumber(fieldValue)) {
	            _typesenseFilterString = "".concat(_fieldName, ":!=[").concat(_this._escapeFacetValue(fieldValue.substring(1)), "]");
	          } else {
	            _typesenseFilterString = "".concat(_fieldName, ":=[").concat(_this._escapeFacetValue(fieldValue), "]");
	          }
	
	          return _typesenseFilterString;
	        }
	      });
	      adaptedResult = transformedTypesenseFilters.join(" && "); // console.log(`${JSON.stringify(facetFilters)} => ${adaptedResult}`);
	
	      return adaptedResult;
	    }
	  }, {
	    key: "_escapeFacetValue",
	    value: function _escapeFacetValue(value) {
	      // Don't escape booleans, integers or floats
	      if (typeof value === "boolean" || value === "true" || value === "false" || this._isNumber(value)) {
	        return value;
	      }
	
	      return "`".concat(value, "`");
	    }
	  }, {
	    key: "_isNumber",
	    value: function _isNumber(value) {
	      return Number.isInteger(value % 1) || // Mod 1 will automatically try converting string values to integer/float
	      !!(value % 1); // Is Float
	    }
	  }, {
	    key: "_adaptNumericFilters",
	    value: function _adaptNumericFilters(numericFilters) {
	      // Need to transform this:
	      // ["field1<=634", "field1>=289", "field2<=5", "field3>=3"]
	      // to:
	      // "field1:=[634..289] && field2:<=5 && field3:>=3"
	      var adaptedResult = "";
	
	      if (!numericFilters) {
	        return adaptedResult;
	      } // Transform to intermediate structure:
	      // {
	      //   field1: {
	      //     "<=": 634,
	      //     ">=": 289
	      //   },
	      //   field2: {
	      //     "<=": 5
	      //   },
	      //   field3: {
	      //     ">=": 3
	      //   }
	      // };
	
	
	      var filtersHash = {};
	      numericFilters.forEach(function (filter) {
	        var _filter$match = filter.match(new RegExp("(.*)(<=|>=|>|<|:)(.*)")),
	            _filter$match2 = (0, _slicedToArray2["default"])(_filter$match, 4),
	            field = _filter$match2[1],
	            operator = _filter$match2[2],
	            value = _filter$match2[3];
	
	        filtersHash[field] = filtersHash[field] || {};
	        filtersHash[field][operator] = value;
	      }); // Transform that to:
	      //  "field1:=[634..289] && field2:<=5 && field3:>=3"
	
	      var adaptedFilters = [];
	      Object.keys(filtersHash).forEach(function (field) {
	        if (filtersHash[field]["<="] != null && filtersHash[field][">="] != null) {
	          adaptedFilters.push("".concat(field, ":=[").concat(filtersHash[field][">="], "..").concat(filtersHash[field]["<="], "]"));
	        } else if (filtersHash[field]["<="] != null) {
	          adaptedFilters.push("".concat(field, ":<=").concat(filtersHash[field]["<="]));
	        } else if (filtersHash[field][">="] != null) {
	          adaptedFilters.push("".concat(field, ":>=").concat(filtersHash[field][">="]));
	        } else {
	          console.warn("[Typesense-Instantsearch-Adapter] Unsupported operator found ".concat(JSON.stringify(filtersHash[field])));
	        }
	      });
	      adaptedResult = adaptedFilters.join(" && ");
	      return adaptedResult;
	    }
	  }, {
	    key: "_adaptGeoFilter",
	    value: function _adaptGeoFilter(_ref) {
	      var insideBoundingBox = _ref.insideBoundingBox,
	          aroundRadius = _ref.aroundRadius,
	          aroundLatLng = _ref.aroundLatLng,
	          insidePolygon = _ref.insidePolygon;
	
	      // Give this parameter first priority if it exists, since
	      if (insideBoundingBox) {
	        var x1, y1, x2, y2;
	
	        if (Array.isArray(insideBoundingBox)) {
	          var _insideBoundingBox$fl = insideBoundingBox.flat();
	
	          var _insideBoundingBox$fl2 = (0, _slicedToArray2["default"])(_insideBoundingBox$fl, 4);
	
	          x1 = _insideBoundingBox$fl2[0];
	          y1 = _insideBoundingBox$fl2[1];
	          x2 = _insideBoundingBox$fl2[2];
	          y2 = _insideBoundingBox$fl2[3];
	        } else {
	          var _insideBoundingBox$sp = insideBoundingBox.split(",");
	
	          var _insideBoundingBox$sp2 = (0, _slicedToArray2["default"])(_insideBoundingBox$sp, 4);
	
	          x1 = _insideBoundingBox$sp2[0];
	          y1 = _insideBoundingBox$sp2[1];
	          x2 = _insideBoundingBox$sp2[2];
	          y2 = _insideBoundingBox$sp2[3];
	        }
	
	        return "".concat(this.configuration.geoLocationField, ":(").concat(x1, ", ").concat(y1, ", ").concat(x1, ", ").concat(y2, ", ").concat(x2, ", ").concat(y2, ", ").concat(x2, ", ").concat(y1, ")");
	      }
	
	      if (aroundLatLng || aroundRadius) {
	        if (!aroundRadius || aroundRadius === "all") {
	          throw new Error("[Typesense-Instantsearch-Adapter] In Typesense, geo-filtering around a lat/lng also requires a numerical radius. " + "So the `aroundRadius` parameter is required when `aroundLatLng` is used. " + "If you intend to just geo-sort around a lat/long, you want to use the sortBy InstantSearch widget (or a virtual sortBy custom widget).");
	        }
	
	        var adaptedAroundRadius = "".concat(parseFloat(aroundRadius) / 1000, " km"); // aroundRadius is in meters
	
	        return "".concat(this.configuration.geoLocationField, ":(").concat(aroundLatLng, ", ").concat(adaptedAroundRadius, ")");
	      }
	
	      if (insidePolygon) {
	        var coordinates = insidePolygon;
	
	        if (Array.isArray(insidePolygon)) {
	          coordinates = insidePolygon.flat().join(",");
	        }
	
	        return "".concat(this.configuration.geoLocationField, ":(").concat(coordinates, ")");
	      }
	    }
	  }, {
	    key: "_adaptFilters",
	    value: function _adaptFilters(instantsearchParams) {
	      var adaptedFilters = [];
	      adaptedFilters.push(this._adaptFacetFilters(instantsearchParams.facetFilters));
	      adaptedFilters.push(this._adaptNumericFilters(instantsearchParams.numericFilters));
	      adaptedFilters.push(this._adaptGeoFilter(instantsearchParams));
	      return adaptedFilters.filter(function (filter) {
	        return filter && filter !== "";
	      }).join(" && ");
	    }
	  }, {
	    key: "_adaptIndexName",
	    value: function _adaptIndexName(indexName) {
	      return indexName.match(this.constructor.INDEX_NAME_MATCHING_REGEX)[1];
	    }
	  }, {
	    key: "_adaptSortBy",
	    value: function _adaptSortBy(indexName) {
	      return indexName.match(this.constructor.INDEX_NAME_MATCHING_REGEX)[3];
	    }
	  }, {
	    key: "_buildSearchParameters",
	    value: function _buildSearchParameters(instantsearchRequest) {
	      var params = instantsearchRequest.params;
	      var indexName = instantsearchRequest.indexName;
	
	      var adaptedCollectionName = this._adaptIndexName(indexName); // Convert all common parameters to snake case
	
	
	      var snakeCasedAdditionalSearchParameters = {};
	
	      for (var _i = 0, _Object$entries = Object.entries(this.additionalSearchParameters); _i < _Object$entries.length; _i++) {
	        var _Object$entries$_i = (0, _slicedToArray2["default"])(_Object$entries[_i], 2),
	            key = _Object$entries$_i[0],
	            value = _Object$entries$_i[1];
	
	        snakeCasedAdditionalSearchParameters[this._camelToSnakeCase(key)] = value;
	      } // Override, collection specific parameters
	
	
	      if (this.collectionSpecificSearchParameters[adaptedCollectionName]) {
	        for (var _i2 = 0, _Object$entries2 = Object.entries(this.collectionSpecificSearchParameters[adaptedCollectionName]); _i2 < _Object$entries2.length; _i2++) {
	          var _Object$entries2$_i = (0, _slicedToArray2["default"])(_Object$entries2[_i2], 2),
	              _key = _Object$entries2$_i[0],
	              _value = _Object$entries2$_i[1];
	
	          snakeCasedAdditionalSearchParameters[this._camelToSnakeCase(_key)] = _value;
	        }
	      }
	
	      var typesenseSearchParams = Object.assign({}, snakeCasedAdditionalSearchParameters);
	
	      var adaptedSortBy = this._adaptSortBy(indexName);
	
	      Object.assign(typesenseSearchParams, {
	        collection: adaptedCollectionName,
	        q: params.query === "" || params.query === undefined ? "*" : params.query,
	        facet_by: [params.facets].flat().join(","),
	        filter_by: this._adaptFilters(params) || snakeCasedAdditionalSearchParameters.filter_by,
	        sort_by: adaptedSortBy || snakeCasedAdditionalSearchParameters.sort_by,
	        max_facet_values: params.maxValuesPerFacet,
	        page: (params.page || 0) + 1
	      });
	
	      if (params.hitsPerPage) {
	        typesenseSearchParams.per_page = params.hitsPerPage;
	      }
	
	      if (params.facetQuery) {
	        typesenseSearchParams.facet_query = "".concat(params.facetName, ":").concat(params.facetQuery);
	        typesenseSearchParams.per_page = 0;
	      } // console.log(params);
	      // console.log(typesenseSearchParams);
	
	
	      return typesenseSearchParams;
	    }
	  }, {
	    key: "_camelToSnakeCase",
	    value: function _camelToSnakeCase(str) {
	      return str.split(/(?=[A-Z])/).join("_").toLowerCase();
	    }
	  }, {
	    key: "request",
	    value: function () {
	      var _request = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
	        var _this2 = this;
	
	        var searches;
	        return _regenerator["default"].wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                searches = this.instantsearchRequests.map(function (instantsearchRequest) {
	                  return _this2._buildSearchParameters(instantsearchRequest);
	                });
	                return _context.abrupt("return", this.typesenseClient.multiSearch.perform({
	                  searches: searches
	                }));
	
	              case 2:
	              case "end":
	                return _context.stop();
	            }
	          }
	        }, _callee, this);
	      }));
	
	      function request() {
	        return _request.apply(this, arguments);
	      }
	
	      return request;
	    }()
	  }], [{
	    key: "INDEX_NAME_MATCHING_REGEX",
	    get: function get() {
	      return new RegExp("^(.+?)(?=(/sort/(.*))|$)");
	    }
	  }, {
	    key: "FILTER_STRING_MATCHING_REGEX",
	    get: function get() {
	      return new RegExp("(.*)((?!:).):(?!:)(.*)");
	    }
	  }]);
	  return SearchRequestAdapter;
	}();
	
	exports.SearchRequestAdapter = SearchRequestAdapter;
	//# sourceMappingURL=SearchRequestAdapter.js.map

/***/ }),
/* 1580 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayWithHoles = __webpack_require__(1581);
	
	var iterableToArrayLimit = __webpack_require__(1582);
	
	var unsupportedIterableToArray = __webpack_require__(1558);
	
	var nonIterableRest = __webpack_require__(1583);
	
	function _slicedToArray(arr, i) {
	  return arrayWithHoles(arr) || iterableToArrayLimit(arr, i) || unsupportedIterableToArray(arr, i) || nonIterableRest();
	}
	
	module.exports = _slicedToArray;
	module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),
/* 1581 */
/***/ (function(module, exports) {

	function _arrayWithHoles(arr) {
	  if (Array.isArray(arr)) return arr;
	}
	
	module.exports = _arrayWithHoles;
	module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),
/* 1582 */
/***/ (function(module, exports) {

	function _iterableToArrayLimit(arr, i) {
	  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
	
	  if (_i == null) return;
	  var _arr = [];
	  var _n = true;
	  var _d = false;
	
	  var _s, _e;
	
	  try {
	    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
	      _arr.push(_s.value);
	
	      if (i && _arr.length === i) break;
	    }
	  } catch (err) {
	    _d = true;
	    _e = err;
	  } finally {
	    try {
	      if (!_n && _i["return"] != null) _i["return"]();
	    } finally {
	      if (_d) throw _e;
	    }
	  }
	
	  return _arr;
	}
	
	module.exports = _iterableToArrayLimit;
	module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),
/* 1583 */
/***/ (function(module, exports) {

	function _nonIterableRest() {
	  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
	}
	
	module.exports = _nonIterableRest;
	module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),
/* 1584 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1488);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SearchResponseAdapter = void 0;
	
	var _slicedToArray2 = _interopRequireDefault(__webpack_require__(1580));
	
	var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(1554));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(1585));
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(1492));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(1493));
	
	var _utils = __webpack_require__(1586);
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	var SearchResponseAdapter = /*#__PURE__*/function () {
	  function SearchResponseAdapter(typesenseResponse, instantsearchRequest, configuration) {
	    (0, _classCallCheck2["default"])(this, SearchResponseAdapter);
	    this.typesenseResponse = typesenseResponse;
	    this.instantsearchRequest = instantsearchRequest;
	    this.configuration = configuration;
	  }
	
	  (0, _createClass2["default"])(SearchResponseAdapter, [{
	    key: "_adaptGroupedHits",
	    value: function _adaptGroupedHits(typesenseGroupedHits) {
	      var _this = this;
	
	      var adaptedResult = [];
	      adaptedResult = typesenseGroupedHits.map(function (groupedHit) {
	        return _this._adaptHits(groupedHit.hits);
	      }); // adaptedResult is now in the form of [[{}, {}], [{}, {}], ...]
	      //  where each element in the outer most array corresponds to a group.
	      // We now flatten it to [{}, {}, {}]
	
	      adaptedResult = adaptedResult.flat();
	      return adaptedResult;
	    }
	  }, {
	    key: "_adaptHits",
	    value: function _adaptHits(typesenseHits) {
	      var _this2 = this;
	
	      var adaptedResult = [];
	      adaptedResult = typesenseHits.map(function (typesenseHit) {
	        var adaptedHit = _objectSpread({}, typesenseHit.document);
	
	        adaptedHit.objectID = typesenseHit.document.id;
	        adaptedHit._snippetResult = _this2._adaptHighlightResult(typesenseHit, "snippet");
	        adaptedHit._highlightResult = _this2._adaptHighlightResult(typesenseHit, "value"); // Add text_match score to result, if a field with that name doesn't already exist
	
	        if (!adaptedHit.text_match) {
	          adaptedHit.text_match = typesenseHit.text_match;
	        }
	
	        var geoLocationValue = adaptedHit[_this2.configuration.geoLocationField];
	
	        if (geoLocationValue) {
	          adaptedHit._geoloc = {
	            lat: geoLocationValue[0],
	            lng: geoLocationValue[1]
	          };
	        }
	
	        return adaptedHit;
	      });
	      return adaptedResult;
	    }
	  }, {
	    key: "_adaptHighlightResult",
	    value: function _adaptHighlightResult(typesenseHit, snippetOrValue) {
	      var _this3 = this;
	
	      // Algolia lists all searchable attributes in this key, even if there are no matches
	      // So do the same and then override highlights
	      var result = Object.assign.apply(Object, [{}].concat((0, _toConsumableArray2["default"])(Object.entries(typesenseHit.document).map(function (_ref) {
	        var _ref2 = (0, _slicedToArray2["default"])(_ref, 2),
	            attribute = _ref2[0],
	            value = _ref2[1];
	
	        return (0, _defineProperty2["default"])({}, attribute, {
	          value: value,
	          matchLevel: "none",
	          matchedWords: []
	        });
	      }))));
	      typesenseHit.highlights.forEach(function (highlight) {
	        result[highlight.field] = {
	          value: highlight[snippetOrValue] || highlight["".concat(snippetOrValue, "s")],
	          matchLevel: "full",
	          matchedWords: highlight.matched_tokens
	        };
	
	        if (highlight.indices) {
	          result[highlight.field]["matchedIndices"] = highlight.indices;
	        }
	      }); // Now convert any values that have an array value
	      // Also, replace highlight tag
	
	      Object.entries(result).forEach(function (_ref4) {
	        var _ref5 = (0, _slicedToArray2["default"])(_ref4, 2),
	            k = _ref5[0],
	            v = _ref5[1];
	
	        var attribute = k;
	        var value = v.value,
	            matchLevel = v.matchLevel,
	            matchedWords = v.matchedWords,
	            matchedIndices = v.matchedIndices;
	
	        if (Array.isArray(value)) {
	          // Algolia lists all values of the key in highlights, even those that don't have any highlights
	          // So add all values of the array field, including highlights
	          result[attribute] = [];
	          typesenseHit.document[attribute].forEach(function (unhighlightedValueFromArray, index) {
	            if (matchedIndices && matchedIndices.includes(index)) {
	              result[attribute].push({
	                value: _this3._adaptHighlightTag("".concat(value[matchedIndices.indexOf(index)]), _this3.instantsearchRequest.params.highlightPreTag, _this3.instantsearchRequest.params.highlightPostTag),
	                matchLevel: matchLevel,
	                matchedWords: matchedWords[index]
	              });
	            } else {
	              result[attribute].push({
	                value: "".concat(unhighlightedValueFromArray),
	                matchLevel: "none",
	                matchedWords: []
	              });
	            }
	          });
	        } else {
	          // Convert all values to strings
	          result[attribute].value = _this3._adaptHighlightTag("".concat(value), _this3.instantsearchRequest.params.highlightPreTag, _this3.instantsearchRequest.params.highlightPostTag);
	        }
	      });
	      return result;
	    }
	  }, {
	    key: "_adaptFacets",
	    value: function _adaptFacets(typesenseFacetCounts) {
	      var adaptedResult = {};
	      typesenseFacetCounts.forEach(function (facet) {
	        Object.assign(adaptedResult, (0, _defineProperty2["default"])({}, facet.field_name, Object.assign.apply(Object, [{}].concat((0, _toConsumableArray2["default"])(facet.counts.map(function (count) {
	          return (0, _defineProperty2["default"])({}, count.value, count.count);
	        }))))));
	      });
	      return adaptedResult;
	    }
	  }, {
	    key: "_adaptFacetStats",
	    value: function _adaptFacetStats(typesenseFacetCounts) {
	      var adaptedResult = {};
	      typesenseFacetCounts.forEach(function (facet) {
	        if (Object.keys(facet.stats).length > 0) {
	          Object.assign(adaptedResult, (0, _defineProperty2["default"])({}, facet.field_name, facet.stats));
	        }
	      });
	      return adaptedResult;
	    }
	  }, {
	    key: "adapt",
	    value: function adapt() {
	      var adaptedResult = {
	        hits: this.typesenseResponse.grouped_hits ? this._adaptGroupedHits(this.typesenseResponse.grouped_hits) : this._adaptHits(this.typesenseResponse.hits),
	        nbHits: this.typesenseResponse.found,
	        page: this.typesenseResponse.page - 1,
	        nbPages: this._adaptNumberOfPages(),
	        hitsPerPage: this.typesenseResponse.request_params.per_page,
	        facets: this._adaptFacets(this.typesenseResponse.facet_counts || []),
	        facets_stats: this._adaptFacetStats(this.typesenseResponse.facet_counts || {}),
	        query: this.typesenseResponse.request_params.q,
	        processingTimeMS: this.typesenseResponse.search_time_ms
	      }; // console.log(adaptedResult);
	
	      return adaptedResult;
	    }
	  }]);
	  return SearchResponseAdapter;
	}();
	
	exports.SearchResponseAdapter = SearchResponseAdapter;
	Object.assign(SearchResponseAdapter.prototype, _utils.utils);
	//# sourceMappingURL=SearchResponseAdapter.js.map

/***/ }),
/* 1585 */
/***/ (function(module, exports) {

	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }
	
	  return obj;
	}
	
	module.exports = _defineProperty;
	module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),
/* 1586 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.utils = void 0;
	var utils = {
	  _adaptHighlightTag: function _adaptHighlightTag(value, highlightPreTag, highlightPostTag) {
	    return value.replace(new RegExp("<mark>", "g"), highlightPreTag).replace(new RegExp("</mark>", "g"), highlightPostTag);
	  },
	  _adaptNumberOfPages: function _adaptNumberOfPages() {
	    var result = this.typesenseResponse.found / this.typesenseResponse.request_params.per_page;
	
	    if (Number.isFinite(result)) {
	      return Math.ceil(result);
	    } else {
	      return 1;
	    }
	  }
	};
	exports.utils = utils;
	//# sourceMappingURL=utils.js.map

/***/ }),
/* 1587 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1488);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.FacetSearchResponseAdapter = void 0;
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(1492));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(1493));
	
	var _utils = __webpack_require__(1586);
	
	var FacetSearchResponseAdapter = /*#__PURE__*/function () {
	  function FacetSearchResponseAdapter(typesenseResponse, instantsearchRequest) {
	    (0, _classCallCheck2["default"])(this, FacetSearchResponseAdapter);
	    this.typesenseResponse = typesenseResponse;
	    this.instantsearchRequest = instantsearchRequest;
	  }
	
	  (0, _createClass2["default"])(FacetSearchResponseAdapter, [{
	    key: "_adaptFacetHits",
	    value: function _adaptFacetHits(typesenseFacetCounts) {
	      var _this = this;
	
	      var adaptedResult = {};
	      var facet = typesenseFacetCounts.find(function (facet) {
	        return facet.field_name === _this.instantsearchRequest.params.facetName;
	      });
	      adaptedResult = facet.counts.map(function (facetCount) {
	        return {
	          value: facetCount.value,
	          highlighted: _this._adaptHighlightTag(facetCount.highlighted, _this.instantsearchRequest.params.highlightPreTag, _this.instantsearchRequest.params.highlightPostTag),
	          count: facetCount.count
	        };
	      });
	      return adaptedResult;
	    }
	  }, {
	    key: "adapt",
	    value: function adapt() {
	      var adaptedResult = {
	        facetHits: this._adaptFacetHits(this.typesenseResponse.facet_counts),
	        exhaustiveFacetsCount: true,
	        processingTimeMS: this.typesenseResponse.search_time_ms
	      };
	      return adaptedResult;
	    }
	  }]);
	  return FacetSearchResponseAdapter;
	}();
	
	exports.FacetSearchResponseAdapter = FacetSearchResponseAdapter;
	Object.assign(FacetSearchResponseAdapter.prototype, _utils.utils);
	//# sourceMappingURL=FacetSearchResponseAdapter.js.map

/***/ }),
/* 1588 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _alt = __webpack_require__(975);
	
	var _alt2 = _interopRequireDefault(_alt);
	
	var _keyBy = __webpack_require__(990);
	
	var _keyBy2 = _interopRequireDefault(_keyBy);
	
	var _SearchUtil = __webpack_require__(1589);
	
	var _SearchUtil2 = _interopRequireDefault(_SearchUtil);
	
	var _SearchActions = __webpack_require__(1219);
	
	var _SearchActions2 = _interopRequireDefault(_SearchActions);
	
	var _UserStore = __webpack_require__(974);
	
	var _UserStore2 = _interopRequireDefault(_UserStore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var SearchStore = function () {
	  function SearchStore() {
	    _classCallCheck(this, SearchStore);
	
	    this.bindActions(_SearchActions2.default);
	
	    this.state = {
	      godInfoFetched: false,
	      infoFetched: false,
	      config: {},
	      godConfig: {},
	      types: []
	    };
	  }
	
	  _createClass(SearchStore, [{
	    key: "onReset",
	    value: function onReset() {
	      this.setState({
	        infoFetched: false,
	        config: {},
	        types: []
	      });
	    }
	  }, {
	    key: "onFetchInfo",
	    value: function onFetchInfo() {
	      var _ref = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	      var godMode = _ref.godMode;
	      var typesenseMode = _ref.typesenseMode;
	
	      var apiKey = _UserStore2.default.getState().apiKey;
	
	      // Can't fetch without API key
	      if (!apiKey) {
	        console.log("[SearchStore] No API key; not fetching search info...");
	        return;
	      }
	
	      _SearchUtil2.default.fetchInfo(apiKey, { godMode: godMode, typesenseMode: typesenseMode }).then(function (data) {
	        data.fromGodMode = !!godMode;
	        _SearchActions2.default.updateInfo(data);
	      }).catch(_SearchActions2.default.fetchFailed);
	    }
	  }, {
	    key: "onUpdateInfo",
	    value: function onUpdateInfo(data) {
	      this.setState({
	        infoFetched: data.fromGodMode ? undefined : true,
	        godInfoFetched: data.fromGodMode ? true : undefined,
	        config: !data.fromGodMode ? data.config : undefined,
	        godConfig: data.fromGodMode ? data.config : undefined,
	        types: data.types
	      });
	    }
	  }, {
	    key: "onFetchFailed",
	    value: function onFetchFailed(e) {
	      alert("Fetching Search data failed: " + e.message);
	      throw e;
	    }
	  }]);
	
	  return SearchStore;
	}();
	
	exports.default = _alt2.default.createStore(SearchStore, "SearchStore");
	module.exports = exports["default"];

/***/ }),
/* 1589 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _api = __webpack_require__(1160);
	
	var _api2 = _interopRequireDefault(_api);
	
	var _config = __webpack_require__(1173);
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  fetchInfo: function fetchInfo(apiKey, _ref) {
	    var godMode = _ref.godMode;
	    var typesenseMode = _ref.typesenseMode;
	
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "GET",
	        endpoint: "search/info",
	        qs: Object.assign({}, godMode && { god_mode: true }, typesenseMode && { platform: "typesense" }),
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response);
	      });
	    });
	  }
	};
	module.exports = exports["default"];

/***/ }),
/* 1590 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _materialUi = __webpack_require__(576);
	
	var _reactAlgoliasearchHelper = __webpack_require__(1482);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BOX_STYLE = {
	  borderRadius: "5px",
	  backgroundColor: "#fff",
	  padding: "0 10px",
	  border: "1px solid #ccc",
	  whiteSpace: "nowrap"
	};
	
	var ICON_STYLE = {
	  marginRight: 8,
	  fontSize: 14,
	  verticalAlign: -1,
	  color: "rgb(158, 158, 158)",
	  transition: "color 0.5s ease"
	};
	
	var ICON_FOCUS_STYLE = {
	  color: "rgb(2, 136, 209)"
	};
	
	var TEXT_FIELD_STYLE = {
	  width: "calc(100% - 25px)",
	  fontSize: 14,
	  lineHeight: "20px",
	  height: 40,
	  marginBottom: -1
	};
	
	var SearchBox = function (_React$Component) {
	  _inherits(SearchBox, _React$Component);
	
	  function SearchBox(props) {
	    _classCallCheck(this, SearchBox);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(SearchBox).call(this, props));
	
	    _this.state = {
	      focused: false
	    };
	
	    _this.onChange = _this.onChange.bind(_this);
	    _this.onFocus = _this.onFocus.bind(_this);
	    _this.onBlur = _this.onBlur.bind(_this);
	    _this.onKeyDown = _this.onKeyDown.bind(_this);
	    return _this;
	  }
	
	  _createClass(SearchBox, [{
	    key: "onChange",
	    value: function onChange(e) {
	      this.props.helper.setQuery(e.target.value).search();
	    }
	  }, {
	    key: "onFocus",
	    value: function onFocus(e) {
	      this.setState({ focused: true });
	      this.onChange(e);
	      this.props.setShowResults(true);
	    }
	  }, {
	    key: "onBlur",
	    value: function onBlur(e) {
	      this.setState({ focused: false });
	      if (!this.props.parameters.query) {
	        this.props.setShowResults(false);
	      }
	    }
	  }, {
	    key: "onKeyDown",
	    value: function onKeyDown(e) {
	      switch (e.which) {
	        case 13:
	          // ENTER
	          this.props.openHitByIndex(this.props.selectedIndex);
	          break;
	
	        case 38:
	          // UP ARROW
	          this.props.setSelectedIndex(this.props.selectedIndex - 1);
	          break;
	
	        case 40:
	          // DOWN ARROW
	          this.props.setSelectedIndex(this.props.selectedIndex + 1);
	          break;
	
	        case 27:
	          // ESCAPE
	          this.field.blur();
	          this.props.setShowResults(false);
	          break;
	
	        default:
	          // fall through
	          return;
	      }
	
	      // A case was triggered
	      e.preventDefault();
	      e.stopPropagation();
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(props) {
	      if (props.showResults && !this.state.focused && this.field) {
	        this.field.focus();
	        this.field.handleInputFocus({ target: this.field.getInputNode() });
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props;
	      var helper = _props.helper;
	      var parameters = _props.parameters;
	      var focused = this.state.focused;
	
	
	      return _react2.default.createElement(
	        "div",
	        { style: BOX_STYLE },
	        _react2.default.createElement(
	          "label",
	          { htmlFor: "GlobalSearchBox--TextField" },
	          _react2.default.createElement("span", {
	            style: Object.assign({}, ICON_STYLE, focused && ICON_FOCUS_STYLE),
	            className: "icon-search"
	          })
	        ),
	        _react2.default.createElement(_materialUi.TextField, {
	          style: TEXT_FIELD_STYLE,
	          tabIndex: 1,
	          id: "GlobalSearchBox--TextField",
	          ref: function ref(r) {
	            _this2.field = r;
	          },
	          value: parameters.query,
	          onChange: this.onChange,
	          onFocus: this.onFocus,
	          onBlur: this.onBlur,
	          onKeyDown: this.onKeyDown,
	          autoComplete: "off",
	          hintText: "Type to search everything..."
	        })
	      );
	    }
	  }]);
	
	  return SearchBox;
	}(_react2.default.Component);
	
	exports.default = (0, _reactAlgoliasearchHelper.connect)(function (state) {
	  return { parameters: state.searchParameters };
	})(SearchBox);
	module.exports = exports["default"];

/***/ }),
/* 1591 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _moment = __webpack_require__(1021);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _reactAlgoliasearchHelper = __webpack_require__(1482);
	
	var _reactRouter = __webpack_require__(486);
	
	var _get = __webpack_require__(1004);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _striptags = __webpack_require__(1592);
	
	var _striptags2 = _interopRequireDefault(_striptags);
	
	var _util = __webpack_require__(1183);
	
	var _SearchStore = __webpack_require__(1588);
	
	var _SearchStore2 = _interopRequireDefault(_SearchStore);
	
	var _EventBucketStore = __webpack_require__(1593);
	
	var _EventBucketStore2 = _interopRequireDefault(_EventBucketStore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CONTAINER_STYLE = {
	  border: "1px solid #ccc",
	  borderRadius: "5px",
	  backgroundColor: "#fff",
	  marginTop: 5,
	  maxHeight: "80vh",
	  overflowY: "scroll",
	  overflowX: "hidden",
	  boxShadow: "0 3px 20px rgba(89,105,129,.3),0 1px 2px rgba(0,0,0,.05),0 0 0 1px rgba(89,105,129,.1)"
	};
	var GOD_CONTAINER_STYLE = {
	  maxHeight: "70vh"
	};
	
	var NO_RESULTS_STYLE = {
	  textAlign: "center",
	  padding: 10
	};
	
	var HIT_STYLE = {
	  paddingTop: 15,
	  paddingLeft: 15,
	  paddingRight: 15,
	  paddingBottom: 15,
	  lineHeight: "1.1",
	  borderBottom: "1px solid #ccc",
	  cursor: "pointer"
	};
	
	var HINT_KEY_STYLE = {
	  border: "1px solid #CFD7E6",
	  borderRadius: 4,
	  padding: "0px 5px",
	  backgroundColor: "#fff",
	  fontFamily: "monospace",
	  margin: "0 2px"
	};
	
	var LAST_HIT_STYLE = Object.assign({}, HIT_STYLE, {
	  borderBottom: "none"
	});
	
	var HIT_TITLE_STYLE = {
	  fontWeight: "bold"
	};
	var HIT_SUBTITLE_STYLE = {
	  fontSize: "0.8em"
	};
	
	var SearchResults = function (_React$Component) {
	  _inherits(SearchResults, _React$Component);
	
	  function SearchResults() {
	    _classCallCheck(this, SearchResults);
	
	    return _possibleConstructorReturn(this, Object.getPrototypeOf(SearchResults).apply(this, arguments));
	  }
	
	  _createClass(SearchResults, [{
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props;
	      var helper = _props.helper;
	      var results = _props.results;
	      var showResults = _props.showResults;
	      var compact = _props.compact;
	      var godMode = _props.godMode;
	      var condensedUsers = _props.condensedUsers;
	      var resultTypes = _SearchStore2.default.getState().types;
	
	      if (showResults && (!results || !results.query || results.query === "*")) {
	        if (compact) return null;
	        return _react2.default.createElement(
	          "div",
	          { style: CONTAINER_STYLE },
	          _react2.default.createElement(
	            "div",
	            { style: NO_RESULTS_STYLE },
	            _react2.default.createElement(
	              "div",
	              null,
	              _react2.default.createElement(
	                "strong",
	                null,
	                "Tip:"
	              ),
	              " Open search by pressing the",
	              " ",
	              _react2.default.createElement(
	                "span",
	                { style: HINT_KEY_STYLE },
	                "/"
	              ),
	              " key."
	            ),
	            _react2.default.createElement(
	              "div",
	              null,
	              "Navigate results using ",
	              _react2.default.createElement(
	                "span",
	                { style: HINT_KEY_STYLE },
	                "\u2191"
	              ),
	              "/",
	              _react2.default.createElement(
	                "span",
	                { style: HINT_KEY_STYLE },
	                "\u2193"
	              ),
	              "/",
	              _react2.default.createElement(
	                "span",
	                { style: HINT_KEY_STYLE },
	                "Enter"
	              ),
	              "."
	            )
	          )
	        );
	      }
	
	      return showResults && results && results.query ? _react2.default.createElement(
	        "div",
	        {
	          style: Object.assign({}, CONTAINER_STYLE, godMode && GOD_CONTAINER_STYLE)
	        },
	        results.hits.length === 0 && _react2.default.createElement(
	          "div",
	          { style: NO_RESULTS_STYLE },
	          "No results found for ",
	          _react2.default.createElement(
	            "em",
	            null,
	            "\"",
	            results.query,
	            "\""
	          )
	        ),
	        results.hits.map(function (hit, i) {
	          if (!hit.name) {
	            hit.name = hit.email;
	          }
	
	          // Typesense workaround: Due to api version differences, manually strip
	          // matchLevel=none highlights from the results.
	          Object.keys(hit._highlightResult).forEach(function (key) {
	            if (hit._highlightResult[key] && hit._highlightResult[key].matchLevel === "none" || Array.isArray(hit._highlightResult[key])) {
	              delete hit._highlightResult[key];
	            }
	          });
	
	          var displayName = void 0;
	          if (hit._type in resultTypes) {
	            displayName = resultTypes[hit._type].display_name;
	          } else {
	            displayName = hit._type;
	          }
	
	          // Fallback name to id (e.g. for Ticket #123ABC)
	          if (!hit.name && hit.id) {
	            hit.name = displayName + " #" + hit.id.toUpperCase();
	          }
	
	          // Fallback name to content (Note)
	          if (!hit.name && hit.content) {
	            hit.name = (0, _striptags2.default)(hit.content);
	          }
	
	          var titleContent = void 0;
	          if (hit._highlightResult && hit._highlightResult.name) {
	            titleContent = _react2.default.createElement("span", {
	              dangerouslySetInnerHTML: {
	                __html: hit._highlightResult.name.value
	              }
	            });
	          } else if (hit._highlightResult && hit._highlightResult.id) {
	            titleContent = _react2.default.createElement(
	              "span",
	              null,
	              displayName,
	              " #",
	              _react2.default.createElement("span", {
	                dangerouslySetInnerHTML: {
	                  __html: hit._highlightResult.id.value
	                }
	              })
	            );
	          } else {
	            titleContent = hit.name;
	          }
	
	          var subtitleKeys = hit._highlightResult ? Object.keys(hit._highlightResult).filter(function (k) {
	            return ["name", "id", "content"].indexOf(k) === -1;
	          }) : [];
	
	          if (hit.person) {
	            subtitleKeys.push(hit.person.name ? "person.name" : "person.email");
	          }
	
	          var extraSubtitleItems = [];
	          if (hit.event_bucket) {
	            var bucket = _EventBucketStore2.default.getEventBucketById(hit.event_bucket);
	            if (bucket) {
	              extraSubtitleItems.push(bucket.name);
	            }
	          }
	          if (hit.start_time) {
	            extraSubtitleItems.push((0, _moment2.default)(hit.start_time).format("M/D/Y"));
	          }
	
	          return _react2.default.createElement(
	            "div",
	            {
	              key: hit.objectID,
	              style: i === results.hits.length - 1 ? LAST_HIT_STYLE : HIT_STYLE,
	              className: "GlobalSearchResults--hit " + (i === _this2.props.selectedIndex ? "selected" : ""),
	              onTouchTap: function onTouchTap() {
	                return _this2.props.openHitByIndex(i);
	              }
	            },
	            _react2.default.createElement(
	              "div",
	              { style: HIT_TITLE_STYLE },
	              titleContent
	            ),
	            _react2.default.createElement(
	              "div",
	              { style: HIT_SUBTITLE_STYLE },
	              displayName,
	              subtitleKeys.length || extraSubtitleItems.length ? " · " : null,
	              (0, _util.intersperse)(subtitleKeys.map(function (key, i) {
	                var result = hit._highlightResult[key] || {},
	                    html = result.value;
	
	                if (result.length) {
	                  html = result.map(function (r) {
	                    return r.value;
	                  }).join(", ");
	                }
	
	                // Fallback if not in _highlightResult
	                if (!html) {
	                  html = (0, _get2.default)(hit, key);
	                }
	
	                return _react2.default.createElement("span", {
	                  key: i,
	                  dangerouslySetInnerHTML: { __html: html }
	                });
	              }).concat(extraSubtitleItems), " · ")
	            ),
	            godMode ? _react2.default.createElement(
	              "div",
	              { style: HIT_SUBTITLE_STYLE },
	              (condensedUsers.find(function (user) {
	                return user.id === hit._owner;
	              }) || {
	                organization: "????"
	              }).organization
	            ) : null
	          );
	        })
	      ) : null;
	    }
	  }]);
	
	  return SearchResults;
	}(_react2.default.Component);
	
	exports.default = (0, _reactAlgoliasearchHelper.connect)(function (state) {
	  return { results: state.searchResults };
	})(SearchResults);
	module.exports = exports["default"];

/***/ }),
/* 1592 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	(function (root, factory) {
	    if (true) {
	        // AMD. Register as an anonymous module.
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else if (typeof module === 'object' && module.exports) {
	        // Node. Does not work with strict CommonJS, but
	        // only CommonJS-like environments that support module.exports,
	        // like Node.
	        module.exports = factory();
	    } else {
	        // Browser globals (root is window)
	        root.striptags = factory();
	  }
	}(this, function () {
	
	    var STATE_OUTPUT       = 0,
	        STATE_HTML         = 1,
	        STATE_PRE_COMMENT  = 2,
	        STATE_COMMENT      = 3,
	        WHITESPACE         = /\s/,
	        ALLOWED_TAGS_REGEX = /<(\w*)>/g;
	
	    function striptags(html, allowableTags, tagReplacement) {
	        var html = html || '',
	            state = STATE_OUTPUT,
	            depth = 0,
	            output = '',
	            tagBuffer = '',
	            inQuote = false,
	            i, length, c;
	
	        if (typeof allowableTags === 'string') {
	            // Parse the string into an array of tags
	            allowableTags = parseAllowableTags(allowableTags);
	        } else if (!Array.isArray(allowableTags)) {
	            // If it is not an array, explicitly set to null
	            allowableTags = null;
	        }
	
	        for (i = 0, length = html.length; i < length; i++) {
	            c = html[i];
	
	            switch (c) {
	                case '<': {
	                    // ignore '<' if inside a quote
	                    if (inQuote) {
	                        break;
	                    }
	
	                    // '<' followed by a space is not a valid tag, continue
	                    if (html[i + 1] == ' ') {
	                        consumeCharacter(c);
	                        break;
	                    }
	
	                    // change to STATE_HTML
	                    if (state == STATE_OUTPUT) {
	                        state = STATE_HTML;
	
	                        consumeCharacter(c);
	                        break;
	                    }
	
	                    // ignore additional '<' characters when inside a tag
	                    if (state == STATE_HTML) {
	                        depth++;
	                        break;
	                    }
	
	                    consumeCharacter(c);
	                    break;
	                }
	
	                case '>': {
	                    // something like this is happening: '<<>>'
	                    if (depth) {
	                        depth--;
	                        break;
	                    }
	
	                    // ignore '>' if inside a quote
	                    if (inQuote) {
	                        break;
	                    }
	
	                    // an HTML tag was closed
	                    if (state == STATE_HTML) {
	                        inQuote = state = 0;
	
	                        if (allowableTags) {
	                            tagBuffer += '>';
	                            flushTagBuffer();
	                        }
	
	                        break;
	                    }
	
	                    // '<!' met its ending '>'
	                    if (state == STATE_PRE_COMMENT) {
	                        inQuote = state = 0;
	                        tagBuffer = '';
	                        break;
	                    }
	
	                    // if last two characters were '--', then end comment
	                    if (state == STATE_COMMENT &&
	                        html[i - 1] == '-' &&
	                        html[i - 2] == '-') {
	
	                        inQuote = state = 0;
	                        tagBuffer = '';
	                        break;
	                    }
	
	                    consumeCharacter(c);
	                    break;
	                }
	
	                // catch both single and double quotes
	                case '"':
	                case '\'': {
	                    if (state == STATE_HTML) {
	                        if (inQuote == c) {
	                            // end quote found
	                            inQuote = false;
	                        } else if (!inQuote) {
	                            // start quote only if not already in one
	                            inQuote = c;
	                        }
	                    }
	
	                    consumeCharacter(c);
	                    break;
	                }
	
	                case '!': {
	                    if (state == STATE_HTML &&
	                        html[i - 1] == '<') {
	
	                        // looks like we might be starting a comment
	                        state = STATE_PRE_COMMENT;
	                        break;
	                    }
	
	                    consumeCharacter(c);
	                    break;
	                }
	
	                case '-': {
	                    // if the previous two characters were '!-', this is a comment
	                    if (state == STATE_PRE_COMMENT &&
	                        html[i - 1] == '-' &&
	                        html[i - 2] == '!') {
	
	                        state = STATE_COMMENT;
	                        break;
	                    }
	
	                    consumeCharacter(c);
	                    break;
	                }
	
	                case 'E':
	                case 'e': {
	                    // check for DOCTYPE, because it looks like a comment and isn't
	                    if (state == STATE_PRE_COMMENT &&
	                        html.substr(i - 6, 7).toLowerCase() == 'doctype') {
	
	                        state = STATE_HTML;
	                        break;
	                    }
	
	                    consumeCharacter(c);
	                    break;
	                }
	
	                default: {
	                    consumeCharacter(c);
	                }
	            }
	        }
	
	        function consumeCharacter(c) {
	            if (state == STATE_OUTPUT) {
	                output += c;
	            } else if (allowableTags && state == STATE_HTML) {
	                tagBuffer += c;
	            }
	        }
	
	        function flushTagBuffer() {
	            var normalized = '',
	                nonWhitespaceSeen = false,
	                i, length, c;
	
	            normalizeTagBuffer:
	            for (i = 0, length = tagBuffer.length; i < length; i++) {
	                c = tagBuffer[i].toLowerCase();
	
	                switch (c) {
	                    case '<': {
	                        break;
	                    }
	
	                    case '>': {
	                        break normalizeTagBuffer;
	                    }
	
	                    case '/': {
	                        nonWhitespaceSeen = true;
	                        break;
	                    }
	
	                    default: {
	                        if (!c.match(WHITESPACE)) {
	                            nonWhitespaceSeen = true;
	                            normalized += c;
	                        } else if (nonWhitespaceSeen) {
	                            break normalizeTagBuffer;
	                        }
	                    }
	                }
	            }
	
	            if (allowableTags.indexOf(normalized) !== -1) {
	                output += tagBuffer;
	            } else if (tagReplacement) {
	                output += tagReplacement;
	            }
	
	            tagBuffer = '';
	        }
	
	        return output;
	    }
	
	    /**
	     * Return an array containing tags that are allowed to pass through the
	     * algorithm.
	     *
	     * @param string allowableTags A string of tags to allow (e.g. "<b><strong>").
	     * @return array|null An array of allowed tags or null if none.
	     */
	    function parseAllowableTags(allowableTags) {
	        var tagsArray = [],
	            match;
	
	        while ((match = ALLOWED_TAGS_REGEX.exec(allowableTags)) !== null) {
	            tagsArray.push(match[1]);
	        }
	
	        return tagsArray.length !== 0 ? tagsArray : null;
	    }
	
	    return striptags;
	}));


/***/ }),
/* 1593 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _alt = __webpack_require__(975);
	
	var _alt2 = _interopRequireDefault(_alt);
	
	var _values = __webpack_require__(1214);
	
	var _values2 = _interopRequireDefault(_values);
	
	var _keyBy = __webpack_require__(990);
	
	var _keyBy2 = _interopRequireDefault(_keyBy);
	
	var _sortBy = __webpack_require__(1594);
	
	var _sortBy2 = _interopRequireDefault(_sortBy);
	
	var _EventBucketUtil = __webpack_require__(1595);
	
	var _EventBucketUtil2 = _interopRequireDefault(_EventBucketUtil);
	
	var _EventBucketActions = __webpack_require__(1218);
	
	var _EventBucketActions2 = _interopRequireDefault(_EventBucketActions);
	
	var _UserStore = __webpack_require__(974);
	
	var _UserStore2 = _interopRequireDefault(_UserStore);
	
	var _GlobalNotificationActions = __webpack_require__(1182);
	
	var _GlobalNotificationActions2 = _interopRequireDefault(_GlobalNotificationActions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var EventBucketStore = function () {
	  function EventBucketStore() {
	    _classCallCheck(this, EventBucketStore);
	
	    this.bindActions(_EventBucketActions2.default);
	
	    this.state = {
	      isFetchingAll: true,
	      eventBuckets: {},
	      configSchema: {},
	      subdomainTestResults: {},
	      newEventBucketId: null,
	      isWorking: false
	    };
	
	    this.exportPublicMethods({
	      getEventBuckets: this.getEventBuckets.bind(this),
	      getEventBucketById: this.getEventBucketById.bind(this),
	      getSubdomainTestResultsByEventBucketId: this.getSubdomainTestResultsByEventBucketId.bind(this),
	      getConfigSchema: this.getConfigSchema.bind(this)
	    });
	  }
	
	  _createClass(EventBucketStore, [{
	    key: "getEventBuckets",
	    value: function getEventBuckets() {
	      return (0, _sortBy2.default)((0, _values2.default)(this.state.eventBuckets), "created_at").reverse();
	    }
	  }, {
	    key: "getEventBucketById",
	    value: function getEventBucketById(id) {
	      return this.state.eventBuckets[id];
	    }
	  }, {
	    key: "getSubdomainTestResultsByEventBucketId",
	    value: function getSubdomainTestResultsByEventBucketId(id) {
	      return this.state.subdomainTestResults[id];
	    }
	  }, {
	    key: "getConfigSchema",
	    value: function getConfigSchema(id) {
	      var schema = Object.assign({}, this.state.configSchema),
	          bucket = this.getEventBucketById(id);
	
	      // Hide sections if not applicable
	      if (schema.sections && bucket) {
	        if (!bucket.credits_enabled) {
	          schema.sections = schema.sections.filter(function (s) {
	            return s.key !== "credits";
	          });
	        }
	        if (!bucket.enable_virtual_festival) {
	          schema.sections = schema.sections.filter(function (s) {
	            return s.key !== "virtual";
	          });
	        }
	        // TEMP until we allow UI enabling of gift cards
	        if (bucket.frontend_config && !bucket.frontend_config.gift_cards_enabled) {
	          schema.sections = schema.sections.filter(function (s) {
	            return s.key !== "gift_cards";
	          });
	        }
	
	        if (bucket.frontend_config && !bucket.frontend_config.memberships_enabled) {
	          schema.sections = schema.sections.filter(function (s) {
	            return s.key !== "memberships";
	          });
	        }
	      }
	
	      return schema;
	    }
	  }, {
	    key: "onFetchAll",
	    value: function onFetchAll() {
	      var _this = this;
	
	      this.setState({ isFetchingAll: true });
	      _EventBucketUtil2.default.fetchAll(_UserStore2.default.getState().apiKey).then(function (data) {
	        _this.setState({ isFetchingAll: false });
	        _EventBucketActions2.default.updateEventBuckets((0, _keyBy2.default)(data, "id"));
	      }).catch(_EventBucketActions2.default.fetchFailed);
	    }
	  }, {
	    key: "onFetchOne",
	    value: function onFetchOne(id) {
	      var _this2 = this;
	
	      this.setState({ isFetching: true });
	      _EventBucketUtil2.default.fetchOne(_UserStore2.default.getState().apiKey, id).then(function (data) {
	        _EventBucketActions2.default.updateEventBucket(id, data);
	        _this2.setState({ isFetching: false });
	      }).catch(_EventBucketActions2.default.fetchFailed);
	    }
	  }, {
	    key: "onEdit",
	    value: function onEdit(newData) {
	      _EventBucketUtil2.default.edit(_UserStore2.default.getState().apiKey, newData.id, newData.values).then(function (data) {
	        _EventBucketActions2.default.updateEventBucket(newData.id, data);
	      }).catch(_EventBucketActions2.default.editFailed);
	    }
	  }, {
	    key: "onUploadFile",
	    value: function onUploadFile(_ref) {
	      var _this3 = this;
	
	      var id = _ref.id;
	      var key = _ref.key;
	      var file = _ref.file;
	      var callback = _ref.callback;
	
	      _EventBucketUtil2.default.uploadFile(_UserStore2.default.getState().apiKey, id, key, file).then(function (data) {
	        var bucket = Object.assign({}, _this3.state.eventBuckets[id]);
	        if (callback) {
	          callback(data);
	          return;
	        }
	
	        if (!bucket.UPLOADED_FILES) {
	          bucket.UPLOADED_FILES = {};
	        }
	        bucket.UPLOADED_FILES[key] = data.url;
	        _EventBucketActions2.default.updateEventBucket(id, bucket);
	      }).catch(_EventBucketActions2.default.editFailed);
	    }
	  }, {
	    key: "onTestSubdomain",
	    value: function onTestSubdomain(_ref2) {
	      var _this4 = this;
	
	      var id = _ref2.id;
	      var subdomain = _ref2.subdomain;
	
	      _EventBucketUtil2.default.testSubdomain(_UserStore2.default.getState().apiKey, id, subdomain).then(function () {
	        var results = Object.assign(_this4.state.subdomainTestResults, _defineProperty({}, id, _defineProperty({}, subdomain, true)));
	        _this4.setState({ subdomainTestResults: results });
	      }).catch(function (err) {
	        var results = Object.assign(_this4.state.subdomainTestResults, _defineProperty({}, id, _defineProperty({}, subdomain, err.message)));
	        _this4.setState({ subdomainTestResults: results });
	      });
	    }
	  }, {
	    key: "onDuplicate",
	    value: function onDuplicate(_ref3) {
	      var _this5 = this;
	
	      var id = _ref3.id;
	      var fields = _ref3.fields;
	
	      this.setState({ isWorking: true, newEventBucketId: null });
	
	      _EventBucketUtil2.default.duplicate(_UserStore2.default.getState().apiKey, { id: id, fields: fields }).then(function (data) {
	        _EventBucketActions2.default.updateEventBucket(data.id, data);
	        _this5.setState({ isWorking: false, newEventBucketId: data.id });
	      }).catch(_EventBucketActions2.default.editFailed);
	    }
	  }, {
	    key: "onDelete",
	    value: function onDelete(id) {
	      _EventBucketUtil2.default.delete(_UserStore2.default.getState().apiKey, id).then(function (data) {
	        _EventBucketActions2.default.updateEventBucket(id, undefined);
	      }).catch(_EventBucketActions2.default.editFailed);
	    }
	  }, {
	    key: "onCreate",
	    value: function onCreate(newData) {
	      var _this6 = this;
	
	      this.setState({
	        newEventBucketId: null
	      });
	
	      _EventBucketUtil2.default.create(_UserStore2.default.getState().apiKey, newData).then(function (data) {
	        _EventBucketActions2.default.updateEventBucket(data.id, data);
	        _this6.setState({
	          newEventBucketId: data.id
	        });
	      }).catch(_EventBucketActions2.default.editFailed);
	    }
	  }, {
	    key: "onUpdateEventBuckets",
	    value: function onUpdateEventBuckets(eventBuckets) {
	      this.setState({ eventBuckets: eventBuckets });
	    }
	  }, {
	    key: "onUpdateEventBucket",
	    value: function onUpdateEventBucket(data) {
	      if (!data.eventBucket) {
	        delete this.state.eventBuckets[data.id];
	      } else {
	        this.state.eventBuckets[data.id] = data.eventBucket;
	      }
	      this.state.newEventBucketId = null;
	      this.setState(this.state);
	    }
	  }, {
	    key: "onFetchConfigSchema",
	    value: function onFetchConfigSchema() {
	      var _this7 = this;
	
	      _EventBucketUtil2.default.fetchConfigSchema(_UserStore2.default.getState().apiKey).then(function (configSchema) {
	        _this7.setState({ configSchema: configSchema });
	      }).catch(_EventBucketActions2.default.fetchFailed);
	    }
	  }, {
	    key: "onFetchFailed",
	    value: function onFetchFailed(e) {
	      this.setState({ isFetchingAll: false, isFetching: false });
	      console.error("Fetching event bucket failed:", e);
	      _GlobalNotificationActions2.default.notify.defer("Fetching event bucket failed: " + e.message);
	      throw e;
	    }
	  }, {
	    key: "onEditFailed",
	    value: function onEditFailed(e) {
	      alert("Edit failed: " + e.message);
	
	      // trigger event update to allow resubmit
	      if (e._eventBucket) {
	        this.state.eventBuckets[e._eventBucket].updated_at = Date.now();
	      }
	      this.setState({ eventBuckets: this.state.eventBuckets, isWorking: false });
	    }
	  }]);
	
	  return EventBucketStore;
	}();
	
	exports.default = _alt2.default.createStore(EventBucketStore, "EventBucketStore");
	module.exports = exports["default"];

/***/ }),
/* 1594 */
/***/ (function(module, exports, __webpack_require__) {

	var baseFlatten = __webpack_require__(1390),
	    baseOrderBy = __webpack_require__(1421),
	    baseRest = __webpack_require__(811),
	    isIterateeCall = __webpack_require__(819);
	
	/**
	 * Creates an array of elements, sorted in ascending order by the results of
	 * running each element in a collection thru each iteratee. This method
	 * performs a stable sort, that is, it preserves the original sort order of
	 * equal elements. The iteratees are invoked with one argument: (value).
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {...(Function|Function[])} [iteratees=[_.identity]]
	 *  The iteratees to sort by.
	 * @returns {Array} Returns the new sorted array.
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'fred',   'age': 48 },
	 *   { 'user': 'barney', 'age': 36 },
	 *   { 'user': 'fred',   'age': 30 },
	 *   { 'user': 'barney', 'age': 34 }
	 * ];
	 *
	 * _.sortBy(users, [function(o) { return o.user; }]);
	 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
	 *
	 * _.sortBy(users, ['user', 'age']);
	 * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
	 */
	var sortBy = baseRest(function(collection, iteratees) {
	  if (collection == null) {
	    return [];
	  }
	  var length = iteratees.length;
	  if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
	    iteratees = [];
	  } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
	    iteratees = [iteratees[0]];
	  }
	  return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
	});
	
	module.exports = sortBy;


/***/ }),
/* 1595 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _merge = __webpack_require__(732);
	
	var _merge2 = _interopRequireDefault(_merge);
	
	var _api = __webpack_require__(1160);
	
	var _api2 = _interopRequireDefault(_api);
	
	var _config = __webpack_require__(1173);
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  fetchAll: function fetchAll(apiKey) {
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "GET",
	        endpoint: "event_buckets",
	        qs: { include_archived: true },
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response.event_buckets);
	      });
	    });
	  },
	  fetchOne: function fetchOne(apiKey, eventBucket) {
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "GET",
	        endpoint: "event_buckets/" + eventBucket,
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response);
	      });
	    });
	  },
	  edit: function edit(apiKey, eventBucket, values) {
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "POST",
	        endpoint: "event_buckets/" + eventBucket,
	        json: values,
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          err._eventBucket = eventBucket;
	          return reject(err);
	        }
	        resolve(response);
	      });
	    });
	  },
	  uploadFile: function uploadFile(apiKey, eventBucket, key, file) {
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "POST",
	        endpoint: "event_buckets/" + eventBucket + "/upload_file",
	        fileField: key,
	        file: file,
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response);
	      });
	    });
	  },
	  delete: function _delete(apiKey, eventBucket) {
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "DELETE",
	        endpoint: "event_buckets/" + eventBucket,
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response);
	      });
	    });
	  },
	  duplicate: function duplicate(apiKey, _ref) {
	    var id = _ref.id;
	    var fields = _ref.fields;
	
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "POST",
	        endpoint: "event_buckets/" + id + "/duplicate",
	        json: { fields: fields },
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response);
	      });
	    });
	  },
	  create: function create(apiKey, values) {
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "POST",
	        endpoint: "event_buckets",
	        json: values,
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response);
	      });
	    });
	  },
	  fetchConfigSchema: function fetchConfigSchema(apiKey) {
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "GET",
	        endpoint: "_frontend/schema",
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response);
	      });
	    });
	  },
	  testSubdomain: function testSubdomain(apiKey, eventBucket, subdomain) {
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "POST",
	        endpoint: "event_buckets/" + eventBucket + "/test_subdomain",
	        json: { subdomain: subdomain },
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response);
	      });
	    });
	  }
	};
	module.exports = exports["default"];

/***/ }),
/* 1596 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _alt = __webpack_require__(975);
	
	var _alt2 = _interopRequireDefault(_alt);
	
	var _GlobalNotificationActions = __webpack_require__(1182);
	
	var _GlobalNotificationActions2 = _interopRequireDefault(_GlobalNotificationActions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var GlobalNotificationStore = function () {
	  function GlobalNotificationStore() {
	    _classCallCheck(this, GlobalNotificationStore);
	
	    this.bindActions(_GlobalNotificationActions2.default);
	
	    this.state = {
	      open: false,
	      message: ""
	    };
	  }
	
	  _createClass(GlobalNotificationStore, [{
	    key: "onNotify",
	    value: function onNotify(message) {
	      this.setState({ open: true, message: message });
	    }
	  }, {
	    key: "onClose",
	    value: function onClose() {
	      this.setState({ open: false });
	    }
	  }]);
	
	  return GlobalNotificationStore;
	}();
	
	exports.default = _alt2.default.createStore(GlobalNotificationStore, "GlobalNotificationStore");
	module.exports = exports["default"];

/***/ }),
/* 1597 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _superagent = __webpack_require__(1168);
	
	var _superagent2 = _interopRequireDefault(_superagent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SOURCE_VERSION = ("56dbecf7d0a937d06762cad5431de96ed40a29d5");
	
	var MISSING_VERSION = "???";
	
	function checkIfLatestVersion() {
	  if (!SOURCE_VERSION) {
	    return Promise.resolve(true);
	  }
	
	  return _superagent2.default.get(window.location.protocol + "//" + window.location.host + "/_version?v=" + SOURCE_VERSION).then(function (_ref) {
	    var error = _ref.error;
	    var body = _ref.body;
	
	    if (error || !body || !body.version || body.version === MISSING_VERSION) {
	      console.log("[Version check] unable to check: " + (error && error.message || body));
	      return true; // assume we're up to date
	    }
	
	    console.log("[Version check] latest=" + body.version + ", current=" + SOURCE_VERSION);
	    return body.version === SOURCE_VERSION;
	  });
	}
	
	exports.default = {
	  checkIfLatestVersion: checkIfLatestVersion
	};
	module.exports = exports["default"];

/***/ }),
/* 1598 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _materialUi = __webpack_require__(576);
	
	var _assign = __webpack_require__(920);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _reactRouter = __webpack_require__(486);
	
	var _connectToStores = __webpack_require__(1226);
	
	var _connectToStores2 = _interopRequireDefault(_connectToStores);
	
	var _UserActions = __webpack_require__(1158);
	
	var _UserActions2 = _interopRequireDefault(_UserActions);
	
	var _UserStore = __webpack_require__(974);
	
	var _UserStore2 = _interopRequireDefault(_UserStore);
	
	var _infoNotice = __webpack_require__(1599);
	
	var _infoNotice2 = _interopRequireDefault(_infoNotice);
	
	var _linkLike = __webpack_require__(973);
	
	var _linkLike2 = _interopRequireDefault(_linkLike);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Login = function (_React$Component) {
	  _inherits(Login, _React$Component);
	
	  function Login(props) {
	    _classCallCheck(this, Login);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(Login).call(this, props));
	
	    _this.state = {
	      username: "",
	      password: "",
	      hasGoneBack: false,
	      hasClearedErrors: false
	    };
	
	    _this._login = _this._login.bind(_this);
	    return _this;
	  }
	
	  _createClass(Login, [{
	    key: "_login",
	    value: function _login() {
	      _UserActions2.default.login(this.state.username, this.state.password,
	      /* noRedirect */true);
	    }
	  }, {
	    key: "componentWillMount",
	    value: function componentWillMount() {
	      if (this.props.location.state && this.props.location.state.username) {
	        this.setState({ username: this.props.location.state.username });
	      }
	
	      if (this.props.location.state && this.props.location.state.clearErrors && !this.state.hasClearedErrors) {
	        this.setState({ hasClearedErrors: true });
	        _UserActions2.default.clearErrors.defer();
	      }
	
	      this.componentWillReceiveProps(this.props);
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(props) {
	      var _this2 = this;
	
	      // If logged in
	      if (props.isLoggedIn || props.loginSuccess) {
	        setTimeout(function () {
	          if (_this2.props.location.query.next === "back" && !_this2.state.hasGoneBack) {
	            _this2.context.router.goBack();
	            _this2.setState({ hasGoneBack: true });
	          } else if (_this2.props.location.query.feedback) {
	            var destination = props.location.query.redirect;
	            window.location.assign("" + destination + (destination.indexOf("?") === -1 ? "?" : "&") + "ssoToken=" + props.data.canny_hash);
	          } else {
	            _this2.context.router.push(_this2.props.location.query.next || "/welcome");
	          }
	        }, 0);
	      }
	    }
	  }, {
	    key: "getStyles",
	    value: function getStyles() {
	      return {
	        page: {
	          minHeight: "60vh"
	        },
	        container: {
	          margin: "0 auto",
	          marginTop: "10%",
	          width: "90%",
	          maxWidth: 500,
	          padding: 20,
	          textAlign: "center",
	          borderRadius: 10
	        },
	        h2: {
	          lineHeight: 2,
	          fontWeight: "normal",
	          marginBottom: 0
	        },
	        form: {
	          maxWidth: 256,
	          margin: "0 auto"
	        },
	        actions: {
	          marginTop: 10
	        },
	        error: {
	          color: "#FF4136",
	          margin: "0.5em 0 0.5em"
	        },
	        img: {
	          display: "block",
	          height: 30,
	          margin: "0 auto"
	        },
	        forgot: {
	          marginTop: 20
	        }
	      };
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this3 = this;
	
	      var styles = this.getStyles();
	
	      return _react2.default.createElement(
	        "div",
	        { style: styles.page },
	        _react2.default.createElement(
	          _materialUi.Paper,
	          { style: styles.container },
	          _react2.default.createElement(
	            _infoNotice2.default,
	            {
	              verticalCenterIcon: true,
	              style: { textAlign: "left", marginBottom: "1.5em" }
	            },
	            "This site is for organizers and creators to manage their events and films. If you're an attendee, login on the event website instead.",
	            " ",
	            _react2.default.createElement(
	              _linkLike2.default,
	              { onTouchTap: function onTouchTap() {
	                  return Intercom("showNewMessage");
	                } },
	              "Need help?"
	            )
	          ),
	          _react2.default.createElement(
	            "h2",
	            { style: styles.h2 },
	            _react2.default.createElement("img", {
	              src: "/img/eventive-dark.png",
	              alt: "Eventive",
	              style: styles.img
	            }),
	            "Organizer & Creator Login"
	          ),
	          this.props.loginErrorMessage ? _react2.default.createElement(
	            "div",
	            { style: styles.error },
	            this.props.loginErrorMessage
	          ) : null,
	          _react2.default.createElement(
	            "form",
	            { style: styles.form },
	            _react2.default.createElement(
	              "div",
	              null,
	              _react2.default.createElement(_materialUi.TextField, {
	                hintText: "Email address",
	                value: this.state.username,
	                fullWidth: true,
	                onChange: function onChange(e) {
	                  return _this3.setState((0, _assign2.default)({}, _this3.state, { username: e.target.value }));
	                },
	                inputStyle: { height: 36, marginTop: 6, paddingBottom: 6 } // better location of autofill highlight
	                , disabled: this.props.loginInProgress
	              })
	            ),
	            _react2.default.createElement(
	              "div",
	              null,
	              _react2.default.createElement(_materialUi.TextField, {
	                hintText: "Password",
	                fullWidth: true,
	                disabled: this.props.loginInProgress,
	                value: this.state.password,
	                onChange: function onChange(e) {
	                  return _this3.setState((0, _assign2.default)({}, _this3.state, { password: e.target.value }));
	                },
	                onKeyDown: function onKeyDown(e) {
	                  if (e.keyCode === 13) _this3._login();
	                },
	                inputStyle: { height: 36, marginTop: 6, paddingBottom: 6 } // better location of autofill highlight
	                , type: "password"
	              })
	            ),
	            _react2.default.createElement(
	              "div",
	              { style: styles.actions },
	              _react2.default.createElement(_materialUi.RaisedButton, {
	                label: this.props.loginInProgress ? "Logging in..." : "Login",
	                disabled: this.props.loginInProgress,
	                primary: true,
	                onTouchTap: this._login
	              })
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { style: styles.forgot },
	            _react2.default.createElement(
	              _reactRouter.Link,
	              {
	                to: {
	                  pathname: "/sso",
	                  state: { login_hint: this.state.username }
	                }
	              },
	              "Login with SSO"
	            ),
	            " ",
	            "\xB7 ",
	            _react2.default.createElement(
	              _reactRouter.Link,
	              { to: "/forgot" },
	              "Forgot password?"
	            )
	          )
	        )
	      );
	    }
	  }], [{
	    key: "getStores",
	    value: function getStores() {
	      return [_UserStore2.default];
	    }
	  }, {
	    key: "getPropsFromStores",
	    value: function getPropsFromStores() {
	      return _UserStore2.default.getState();
	    }
	  }, {
	    key: "contextTypes",
	    get: function get() {
	      return {
	        router: _react2.default.PropTypes.object
	      };
	    }
	  }]);
	
	  return Login;
	}(_react2.default.Component);
	
	exports.default = (0, _connectToStores2.default)(Login);
	module.exports = exports["default"];

/***/ }),
/* 1599 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _radium = __webpack_require__(1600);
	
	var _radium2 = _interopRequireDefault(_radium);
	
	var _info = __webpack_require__(1661);
	
	var _info2 = _interopRequireDefault(_info);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var BASE_STYLE = {
	  display: "table", // not full width
	  backgroundColor: "#eaeaea",
	  color: "#000",
	  padding: "5px 10px",
	  borderRadius: 10
	};
	
	var VERTICAL_BASE_STYLE = {
	  display: "flex",
	  alignItems: "center"
	};
	
	var ICON_STYLE = {
	  verticalAlign: -6,
	  color: "#0187d0",
	  height: 20,
	  width: 20,
	  minWidth: 20,
	  marginRight: 5
	};
	
	var InfoNotice = function InfoNotice(_ref) {
	  var children = _ref.children;
	  var style = _ref.style;
	  var verticalCenterIcon = _ref.verticalCenterIcon;
	
	  var rest = _objectWithoutProperties(_ref, ["children", "style", "verticalCenterIcon"]);
	
	  return React.createElement(
	    "span",
	    _extends({
	      style: [BASE_STYLE, verticalCenterIcon && VERTICAL_BASE_STYLE, style]
	    }, rest),
	    React.createElement(_info2.default, {
	      style: Object.assign({}, ICON_STYLE, verticalCenterIcon && { marginRight: 8 })
	    }),
	    verticalCenterIcon ? React.createElement(
	      "div",
	      null,
	      children
	    ) : children
	  );
	};
	
	exports.default = (0, _radium2.default)(InfoNotice);
	module.exports = exports["default"];

/***/ }),
/* 1600 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _enhancer = __webpack_require__(1601);
	
	var _enhancer2 = _interopRequireDefault(_enhancer);
	
	var _plugins = __webpack_require__(1646);
	
	var _plugins2 = _interopRequireDefault(_plugins);
	
	var _style = __webpack_require__(1657);
	
	var _style2 = _interopRequireDefault(_style);
	
	var _styleRoot = __webpack_require__(1658);
	
	var _styleRoot2 = _interopRequireDefault(_styleRoot);
	
	var _getState = __webpack_require__(1642);
	
	var _getState2 = _interopRequireDefault(_getState);
	
	var _keyframes = __webpack_require__(1660);
	
	var _keyframes2 = _interopRequireDefault(_keyframes);
	
	var _resolveStyles = __webpack_require__(1603);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Radium(ComposedComponent) {
	  return (0, _enhancer2.default)(ComposedComponent);
	}
	
	Radium.Plugins = _plugins2.default;
	Radium.Style = _style2.default;
	Radium.StyleRoot = _styleRoot2.default;
	Radium.getState = _getState2.default;
	Radium.keyframes = _keyframes2.default;
	
	if (false) {
	  Radium.TestMode = {
	    clearState: _resolveStyles.__clearStateForTests,
	    disable: _resolveStyles.__setTestMode.bind(null, false),
	    enable: _resolveStyles.__setTestMode.bind(null, true)
	  };
	}
	
	exports.default = Radium;
	module.exports = exports['default'];

/***/ }),
/* 1601 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.default = enhanceWithRadium;
	
	var _react = __webpack_require__(300);
	
	var _propTypes = __webpack_require__(956);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styleKeeper = __webpack_require__(1602);
	
	var _styleKeeper2 = _interopRequireDefault(_styleKeeper);
	
	var _resolveStyles = __webpack_require__(1603);
	
	var _resolveStyles2 = _interopRequireDefault(_resolveStyles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var KEYS_TO_IGNORE_WHEN_COPYING_PROPERTIES = ['arguments', 'callee', 'caller', 'length', 'name', 'prototype', 'type'];
	
	function copyProperties(source, target) {
	  Object.getOwnPropertyNames(source).forEach(function (key) {
	    if (KEYS_TO_IGNORE_WHEN_COPYING_PROPERTIES.indexOf(key) < 0 && !target.hasOwnProperty(key)) {
	      var descriptor = Object.getOwnPropertyDescriptor(source, key);
	      Object.defineProperty(target, key, descriptor);
	    }
	  });
	}
	
	function isStateless(component) {
	  return !component.render && !(component.prototype && component.prototype.render);
	}
	
	// Check if value is a real ES class in Native / Node code.
	// See: https://stackoverflow.com/a/30760236
	function isNativeClass(component) {
	  return typeof component === 'function' && /^\s*class\s+/.test(component.toString());
	}
	
	// Manually apply babel-ish class inheritance.
	function inherits(subClass, superClass) {
	  if (typeof superClass !== 'function' && superClass !== null) {
	    throw new TypeError('Super expression must either be null or a function, not ' + (typeof superClass === 'undefined' ? 'undefined' : _typeof(superClass)));
	  }
	
	  subClass.prototype = Object.create(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      enumerable: false,
	      writable: true,
	      configurable: true
	    }
	  });
	
	  if (superClass) {
	    if (Object.setPrototypeOf) {
	      Object.setPrototypeOf(subClass, superClass);
	    } else {
	      subClass.__proto__ = superClass; // eslint-disable-line no-proto
	    }
	  }
	}
	
	function enhanceWithRadium(configOrComposedComponent) {
	  var _class, _temp;
	
	  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  if (typeof configOrComposedComponent !== 'function') {
	    var newConfig = _extends({}, config, configOrComposedComponent);
	    return function (configOrComponent) {
	      return enhanceWithRadium(configOrComponent, newConfig);
	    };
	  }
	
	  var component = configOrComposedComponent;
	  var ComposedComponent = component;
	
	  // Handle Native ES classes.
	  if (isNativeClass(ComposedComponent)) {
	    // Manually approximate babel's class transpilation, but _with_ a real `new` call.
	    ComposedComponent = function (OrigComponent) {
	      function NewComponent() {
	        // Ordinarily, babel would produce something like:
	        //
	        // ```
	        // return _possibleConstructorReturn(this, OrigComponent.apply(this, arguments));
	        // ```
	        //
	        // Instead, we just call `new` directly without the `_possibleConstructorReturn` wrapper.
	        var source = new (Function.prototype.bind.apply(OrigComponent, [null].concat(Array.prototype.slice.call(arguments))))();
	
	        // Then we manually update context with properties.
	        copyProperties(source, this);
	
	        return this;
	      }
	
	      inherits(NewComponent, OrigComponent);
	
	      return NewComponent;
	    }(ComposedComponent);
	  }
	
	  // Handle stateless components
	  if (isStateless(ComposedComponent)) {
	    ComposedComponent = function (_Component) {
	      _inherits(ComposedComponent, _Component);
	
	      function ComposedComponent() {
	        _classCallCheck(this, ComposedComponent);
	
	        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	      }
	
	      ComposedComponent.prototype.render = function render() {
	        return component(this.props, this.context);
	      };
	
	      return ComposedComponent;
	    }(_react.Component);
	
	    ComposedComponent.displayName = component.displayName || component.name;
	  }
	
	  var RadiumEnhancer = (_temp = _class = function (_ComposedComponent) {
	    _inherits(RadiumEnhancer, _ComposedComponent);
	
	    function RadiumEnhancer() {
	      _classCallCheck(this, RadiumEnhancer);
	
	      var _this2 = _possibleConstructorReturn(this, _ComposedComponent.apply(this, arguments));
	
	      _this2.state = _this2.state || {};
	      _this2.state._radiumStyleState = {};
	      _this2._radiumIsMounted = true;
	      return _this2;
	    }
	
	    RadiumEnhancer.prototype.componentWillUnmount = function componentWillUnmount() {
	      if (_ComposedComponent.prototype.componentWillUnmount) {
	        _ComposedComponent.prototype.componentWillUnmount.call(this);
	      }
	
	      this._radiumIsMounted = false;
	
	      if (this._radiumMouseUpListener) {
	        this._radiumMouseUpListener.remove();
	      }
	
	      if (this._radiumMediaQueryListenersByQuery) {
	        Object.keys(this._radiumMediaQueryListenersByQuery).forEach(function (query) {
	          this._radiumMediaQueryListenersByQuery[query].remove();
	        }, this);
	      }
	    };
	
	    RadiumEnhancer.prototype.getChildContext = function getChildContext() {
	      var superChildContext = _ComposedComponent.prototype.getChildContext ? _ComposedComponent.prototype.getChildContext.call(this) : {};
	
	      if (!this.props.radiumConfig) {
	        return superChildContext;
	      }
	
	      var newContext = _extends({}, superChildContext);
	
	      if (this.props.radiumConfig) {
	        newContext._radiumConfig = this.props.radiumConfig;
	      }
	
	      return newContext;
	    };
	
	    RadiumEnhancer.prototype.render = function render() {
	      var renderedElement = _ComposedComponent.prototype.render.call(this);
	      var currentConfig = this.props.radiumConfig || this.context._radiumConfig || config;
	
	      if (config && currentConfig !== config) {
	        currentConfig = _extends({}, config, currentConfig);
	      }
	
	      return (0, _resolveStyles2.default)(this, renderedElement, currentConfig);
	    };
	
	    return RadiumEnhancer;
	  }(ComposedComponent), _class._isRadiumEnhanced = true, _temp);
	
	  // Class inheritance uses Object.create and because of __proto__ issues
	  // with IE <10 any static properties of the superclass aren't inherited and
	  // so need to be manually populated.
	  // See http://babeljs.io/docs/advanced/caveats/#classes-10-and-below-
	
	  copyProperties(component, RadiumEnhancer);
	
	  if (false) {
	    // This also fixes React Hot Loader by exposing the original components top
	    // level prototype methods on the Radium enhanced prototype as discussed in
	    // https://github.com/FormidableLabs/radium/issues/219.
	    copyProperties(ComposedComponent.prototype, RadiumEnhancer.prototype);
	  }
	
	  if (RadiumEnhancer.propTypes && RadiumEnhancer.propTypes.style) {
	    RadiumEnhancer.propTypes = _extends({}, RadiumEnhancer.propTypes, {
	      style: _propTypes2.default.oneOfType([_propTypes2.default.array, _propTypes2.default.object])
	    });
	  }
	
	  RadiumEnhancer.displayName = component.displayName || component.name || 'Component';
	
	  RadiumEnhancer.contextTypes = _extends({}, RadiumEnhancer.contextTypes, {
	    _radiumConfig: _propTypes2.default.object,
	    _radiumStyleKeeper: _propTypes2.default.instanceOf(_styleKeeper2.default)
	  });
	
	  RadiumEnhancer.childContextTypes = _extends({}, RadiumEnhancer.childContextTypes, {
	    _radiumConfig: _propTypes2.default.object,
	    _radiumStyleKeeper: _propTypes2.default.instanceOf(_styleKeeper2.default)
	  });
	
	  return RadiumEnhancer;
	}
	module.exports = exports['default'];

/***/ }),
/* 1602 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var StyleKeeper = function () {
	  function StyleKeeper(userAgent) {
	    _classCallCheck(this, StyleKeeper);
	
	    this._userAgent = userAgent;
	    this._listeners = [];
	    this._cssSet = {};
	  }
	
	  StyleKeeper.prototype.subscribe = function subscribe(listener) {
	    var _this = this;
	
	    if (this._listeners.indexOf(listener) === -1) {
	      this._listeners.push(listener);
	    }
	
	    return {
	      // Must be fat arrow to capture `this`
	      remove: function remove() {
	        var listenerIndex = _this._listeners.indexOf(listener);
	        if (listenerIndex > -1) {
	          _this._listeners.splice(listenerIndex, 1);
	        }
	      }
	    };
	  };
	
	  StyleKeeper.prototype.addCSS = function addCSS(css) {
	    var _this2 = this;
	
	    if (!this._cssSet[css]) {
	      this._cssSet[css] = true;
	      this._emitChange();
	    }
	
	    return {
	      // Must be fat arrow to capture `this`
	      remove: function remove() {
	        delete _this2._cssSet[css];
	        _this2._emitChange();
	      }
	    };
	  };
	
	  StyleKeeper.prototype.getCSS = function getCSS() {
	    return Object.keys(this._cssSet).join('\n');
	  };
	
	  StyleKeeper.prototype._emitChange = function _emitChange() {
	    this._listeners.forEach(function (listener) {
	      return listener();
	    });
	  };
	
	  return StyleKeeper;
	}();
	
	exports.default = StyleKeeper;
	module.exports = exports['default'];

/***/ }),
/* 1603 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _appendImportantToEachValue = __webpack_require__(1604);
	
	var _appendImportantToEachValue2 = _interopRequireDefault(_appendImportantToEachValue);
	
	var _cssRuleSetToString = __webpack_require__(1607);
	
	var _cssRuleSetToString2 = _interopRequireDefault(_cssRuleSetToString);
	
	var _getState = __webpack_require__(1642);
	
	var _getState2 = _interopRequireDefault(_getState);
	
	var _getStateKey = __webpack_require__(1643);
	
	var _getStateKey2 = _interopRequireDefault(_getStateKey);
	
	var _hash = __webpack_require__(1644);
	
	var _hash2 = _interopRequireDefault(_hash);
	
	var _mergeStyles = __webpack_require__(1645);
	
	var _plugins = __webpack_require__(1646);
	
	var _plugins2 = _interopRequireDefault(_plugins);
	
	var _exenv = __webpack_require__(1656);
	
	var _exenv2 = _interopRequireDefault(_exenv);
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DEFAULT_CONFIG = {
	  plugins: [_plugins2.default.mergeStyleArray, _plugins2.default.checkProps, _plugins2.default.resolveMediaQueries, _plugins2.default.resolveInteractionStyles, _plugins2.default.keyframes, _plugins2.default.visited, _plugins2.default.removeNestedStyles, _plugins2.default.prefix, _plugins2.default.checkProps]
	};
	
	// Gross
	var globalState = {};
	
	// Declare early for recursive helpers.
	var resolveStyles = null;
	
	var _shouldResolveStyles = function _shouldResolveStyles(component) {
	  return component.type && !component.type._isRadiumEnhanced;
	};
	
	var _resolveChildren = function _resolveChildren(_ref) {
	  var children = _ref.children,
	      component = _ref.component,
	      config = _ref.config,
	      existingKeyMap = _ref.existingKeyMap;
	
	  if (!children) {
	    return children;
	  }
	
	  var childrenType = typeof children === 'undefined' ? 'undefined' : _typeof(children);
	
	  if (childrenType === 'string' || childrenType === 'number') {
	    // Don't do anything with a single primitive child
	    return children;
	  }
	
	  if (childrenType === 'function') {
	    // Wrap the function, resolving styles on the result
	    return function () {
	      var result = children.apply(this, arguments);
	      if (_react2.default.isValidElement(result)) {
	        return resolveStyles(component, result, config, existingKeyMap, true);
	      }
	      return result;
	    };
	  }
	
	  if (_react2.default.Children.count(children) === 1 && children.type) {
	    // If a React Element is an only child, don't wrap it in an array for
	    // React.Children.map() for React.Children.only() compatibility.
	    var onlyChild = _react2.default.Children.only(children);
	    return resolveStyles(component, onlyChild, config, existingKeyMap, true);
	  }
	
	  return _react2.default.Children.map(children, function (child) {
	    if (_react2.default.isValidElement(child)) {
	      return resolveStyles(component, child, config, existingKeyMap, true);
	    }
	
	    return child;
	  });
	};
	
	// Recurse over props, just like children
	var _resolveProps = function _resolveProps(_ref2) {
	  var component = _ref2.component,
	      config = _ref2.config,
	      existingKeyMap = _ref2.existingKeyMap,
	      props = _ref2.props;
	
	  var newProps = props;
	
	  Object.keys(props).forEach(function (prop) {
	    // We already recurse over children above
	    if (prop === 'children') {
	      return;
	    }
	
	    var propValue = props[prop];
	    if (_react2.default.isValidElement(propValue)) {
	      newProps = _extends({}, newProps);
	      newProps[prop] = resolveStyles(component, propValue, config, existingKeyMap, true);
	    }
	  });
	
	  return newProps;
	};
	
	var _buildGetKey = function _buildGetKey(_ref3) {
	  var componentName = _ref3.componentName,
	      existingKeyMap = _ref3.existingKeyMap,
	      renderedElement = _ref3.renderedElement;
	
	  // We need a unique key to correlate state changes due to user interaction
	  // with the rendered element, so we know to apply the proper interactive
	  // styles.
	  var originalKey = typeof renderedElement.ref === 'string' ? renderedElement.ref : renderedElement.key;
	  var key = (0, _getStateKey2.default)(originalKey);
	
	  var alreadyGotKey = false;
	  var getKey = function getKey() {
	    if (alreadyGotKey) {
	      return key;
	    }
	
	    alreadyGotKey = true;
	
	    if (existingKeyMap[key]) {
	      var elementName = void 0;
	      if (typeof renderedElement.type === 'string') {
	        elementName = renderedElement.type;
	      } else if (renderedElement.type.constructor) {
	        elementName = renderedElement.type.constructor.displayName || renderedElement.type.constructor.name;
	      }
	
	      throw new Error('Radium requires each element with interactive styles to have a unique ' + 'key, set using either the ref or key prop. ' + (originalKey ? 'Key "' + originalKey + '" is a duplicate.' : 'Multiple elements have no key specified.') + ' ' + 'Component: "' + componentName + '". ' + (elementName ? 'Element: "' + elementName + '".' : ''));
	    }
	
	    existingKeyMap[key] = true;
	
	    return key;
	  };
	
	  return getKey;
	};
	
	var _setStyleState = function _setStyleState(component, key, stateKey, value) {
	  if (!component._radiumIsMounted) {
	    return;
	  }
	
	  var existing = component._lastRadiumState || component.state && component.state._radiumStyleState || {};
	
	  var state = { _radiumStyleState: _extends({}, existing) };
	  state._radiumStyleState[key] = _extends({}, state._radiumStyleState[key]);
	  state._radiumStyleState[key][stateKey] = value;
	
	  component._lastRadiumState = state._radiumStyleState;
	  component.setState(state);
	};
	
	var _runPlugins = function _runPlugins(_ref4) {
	  var component = _ref4.component,
	      config = _ref4.config,
	      existingKeyMap = _ref4.existingKeyMap,
	      props = _ref4.props,
	      renderedElement = _ref4.renderedElement;
	
	  // Don't run plugins if renderedElement is not a simple ReactDOMElement or has
	  // no style.
	  if (!_react2.default.isValidElement(renderedElement) || typeof renderedElement.type !== 'string' || !props.style) {
	    return props;
	  }
	
	  var newProps = props;
	
	  var plugins = config.plugins || DEFAULT_CONFIG.plugins;
	
	  var componentName = component.constructor.displayName || component.constructor.name;
	  var getKey = _buildGetKey({
	    renderedElement: renderedElement,
	    existingKeyMap: existingKeyMap,
	    componentName: componentName
	  });
	  var getComponentField = function getComponentField(key) {
	    return component[key];
	  };
	  var getGlobalState = function getGlobalState(key) {
	    return globalState[key];
	  };
	  var componentGetState = function componentGetState(stateKey, elementKey) {
	    return (0, _getState2.default)(component.state, elementKey || getKey(), stateKey);
	  };
	  var setState = function setState(stateKey, value, elementKey) {
	    return _setStyleState(component, elementKey || getKey(), stateKey, value);
	  };
	
	  var addCSS = function addCSS(css) {
	    var styleKeeper = component._radiumStyleKeeper || component.context._radiumStyleKeeper;
	    if (!styleKeeper) {
	      if (__isTestModeEnabled) {
	        return {
	          remove: function remove() {}
	        };
	      }
	
	      throw new Error('To use plugins requiring `addCSS` (e.g. keyframes, media queries), ' + 'please wrap your application in the StyleRoot component. Component ' + 'name: `' + componentName + '`.');
	    }
	
	    return styleKeeper.addCSS(css);
	  };
	
	  var newStyle = props.style;
	
	  plugins.forEach(function (plugin) {
	    var result = plugin({
	      ExecutionEnvironment: _exenv2.default,
	      addCSS: addCSS,
	      appendImportantToEachValue: _appendImportantToEachValue2.default,
	      componentName: componentName,
	      config: config,
	      cssRuleSetToString: _cssRuleSetToString2.default,
	      getComponentField: getComponentField,
	      getGlobalState: getGlobalState,
	      getState: componentGetState,
	      hash: _hash2.default,
	      mergeStyles: _mergeStyles.mergeStyles,
	      props: newProps,
	      setState: setState,
	      isNestedStyle: _mergeStyles.isNestedStyle,
	      style: newStyle
	    }) || {};
	
	    newStyle = result.style || newStyle;
	
	    newProps = result.props && Object.keys(result.props).length ? _extends({}, newProps, result.props) : newProps;
	
	    var newComponentFields = result.componentFields || {};
	    Object.keys(newComponentFields).forEach(function (fieldName) {
	      component[fieldName] = newComponentFields[fieldName];
	    });
	
	    var newGlobalState = result.globalState || {};
	    Object.keys(newGlobalState).forEach(function (key) {
	      globalState[key] = newGlobalState[key];
	    });
	  });
	
	  if (newStyle !== props.style) {
	    newProps = _extends({}, newProps, { style: newStyle });
	  }
	
	  return newProps;
	};
	
	// Wrapper around React.cloneElement. To avoid processing the same element
	// twice, whenever we clone an element add a special prop to make sure we don't
	// process this element again.
	var _cloneElement = function _cloneElement(renderedElement, newProps, newChildren) {
	  // Only add flag if this is a normal DOM element
	  if (typeof renderedElement.type === 'string') {
	    newProps = _extends({}, newProps, { 'data-radium': true });
	  }
	
	  return _react2.default.cloneElement(renderedElement, newProps, newChildren);
	};
	
	//
	// The nucleus of Radium. resolveStyles is called on the rendered elements
	// before they are returned in render. It iterates over the elements and
	// children, rewriting props to add event handlers required to capture user
	// interactions (e.g. mouse over). It also replaces the style prop because it
	// adds in the various interaction styles (e.g. :hover).
	//
	resolveStyles = function resolveStyles(component, // ReactComponent, flow+eslint complaining
	renderedElement) {
	  var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : DEFAULT_CONFIG;
	  var existingKeyMap = arguments[3];
	  var shouldCheckBeforeResolve = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
	
	  // ReactElement
	  existingKeyMap = existingKeyMap || {};
	  if (!renderedElement ||
	  // Bail if we've already processed this element. This ensures that only the
	  // owner of an element processes that element, since the owner's render
	  // function will be called first (which will always be the case, since you
	  // can't know what else to render until you render the parent component).
	  renderedElement.props && renderedElement.props['data-radium'] ||
	  // Bail if this element is a radium enhanced element, because if it is,
	  // then it will take care of resolving its own styles.
	  shouldCheckBeforeResolve && !_shouldResolveStyles(renderedElement)) {
	    return renderedElement;
	  }
	
	  var newChildren = _resolveChildren({
	    children: renderedElement.props.children,
	    component: component,
	    config: config,
	    existingKeyMap: existingKeyMap
	  });
	
	  var newProps = _resolveProps({
	    component: component,
	    config: config,
	    existingKeyMap: existingKeyMap,
	    props: renderedElement.props
	  });
	
	  newProps = _runPlugins({
	    component: component,
	    config: config,
	    existingKeyMap: existingKeyMap,
	    props: newProps,
	    renderedElement: renderedElement
	  });
	
	  // If nothing changed, don't bother cloning the element. Might be a bit
	  // wasteful, as we add the sentinal to stop double-processing when we clone.
	  // Assume benign double-processing is better than unneeded cloning.
	  if (newChildren === renderedElement.props.children && newProps === renderedElement.props) {
	    return renderedElement;
	  }
	
	  return _cloneElement(renderedElement, newProps !== renderedElement.props ? newProps : {}, newChildren);
	};
	
	// Only for use by tests
	var __isTestModeEnabled = false;
	if (false) {
	  resolveStyles.__clearStateForTests = function () {
	    globalState = {};
	  };
	  resolveStyles.__setTestMode = function (isEnabled) {
	    __isTestModeEnabled = isEnabled;
	  };
	}
	
	exports.default = resolveStyles;
	module.exports = exports['default'];

/***/ }),
/* 1604 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = appendImportantToEachValue;
	
	var _appendPxIfNeeded = __webpack_require__(1605);
	
	var _appendPxIfNeeded2 = _interopRequireDefault(_appendPxIfNeeded);
	
	var _mapObject = __webpack_require__(1606);
	
	var _mapObject2 = _interopRequireDefault(_mapObject);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function appendImportantToEachValue(style) {
	  return (0, _mapObject2.default)(style, function (result, key) {
	    return (0, _appendPxIfNeeded2.default)(key, style[key]) + ' !important';
	  });
	}
	module.exports = exports['default'];

/***/ }),
/* 1605 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = appendPxIfNeeded;
	
	
	// Copied from https://github.com/facebook/react/blob/
	// 102cd291899f9942a76c40a0e78920a6fe544dc1/
	// src/renderers/dom/shared/CSSProperty.js
	var isUnitlessNumber = {
	  animationIterationCount: true,
	  boxFlex: true,
	  boxFlexGroup: true,
	  boxOrdinalGroup: true,
	  columnCount: true,
	  flex: true,
	  flexGrow: true,
	  flexPositive: true,
	  flexShrink: true,
	  flexNegative: true,
	  flexOrder: true,
	  gridRow: true,
	  gridColumn: true,
	  fontWeight: true,
	  lineClamp: true,
	  lineHeight: true,
	  opacity: true,
	  order: true,
	  orphans: true,
	  tabSize: true,
	  widows: true,
	  zIndex: true,
	  zoom: true,
	
	  // SVG-related properties
	  fillOpacity: true,
	  stopOpacity: true,
	  strokeDashoffset: true,
	  strokeOpacity: true,
	  strokeWidth: true
	};
	
	function appendPxIfNeeded(propertyName, value) {
	  var needsPxSuffix = !isUnitlessNumber[propertyName] && typeof value === 'number' && value !== 0;
	  return needsPxSuffix ? value + 'px' : value;
	}
	module.exports = exports['default'];

/***/ }),
/* 1606 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = mapObject;
	function mapObject(object, mapper) {
	  return Object.keys(object).reduce(function (result, key) {
	    result[key] = mapper(object[key], key);
	    return result;
	  }, {});
	}
	module.exports = exports["default"];

/***/ }),
/* 1607 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = cssRuleSetToString;
	
	var _appendPxIfNeeded = __webpack_require__(1605);
	
	var _appendPxIfNeeded2 = _interopRequireDefault(_appendPxIfNeeded);
	
	var _camelCasePropsToDashCase = __webpack_require__(1608);
	
	var _camelCasePropsToDashCase2 = _interopRequireDefault(_camelCasePropsToDashCase);
	
	var _mapObject = __webpack_require__(1606);
	
	var _mapObject2 = _interopRequireDefault(_mapObject);
	
	var _prefixer = __webpack_require__(1609);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function createMarkupForStyles(style) {
	  return Object.keys(style).map(function (property) {
	    return property + ': ' + style[property] + ';';
	  }).join('\n');
	}
	
	function cssRuleSetToString(selector, rules, userAgent) {
	  if (!rules) {
	    return '';
	  }
	
	  var rulesWithPx = (0, _mapObject2.default)(rules, function (value, key) {
	    return (0, _appendPxIfNeeded2.default)(key, value);
	  });
	  var prefixedRules = (0, _prefixer.getPrefixedStyle)(rulesWithPx, userAgent);
	  var cssPrefixedRules = (0, _camelCasePropsToDashCase2.default)(prefixedRules);
	  var serializedRules = createMarkupForStyles(cssPrefixedRules);
	
	  return selector + '{' + serializedRules + '}';
	}
	module.exports = exports['default'];

/***/ }),
/* 1608 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var _camelCaseRegex = /([a-z])?([A-Z])/g;
	
	var _camelCaseReplacer = function _camelCaseReplacer(match, p1, p2) {
	  return (p1 || '') + '-' + p2.toLowerCase();
	};
	
	var _camelCaseToDashCase = function _camelCaseToDashCase(s) {
	  return s.replace(_camelCaseRegex, _camelCaseReplacer);
	};
	
	var camelCasePropsToDashCase = function camelCasePropsToDashCase(prefixedStyle) {
	  // Since prefix is expected to work on inline style objects, we must
	  // translate the keys to dash case for rendering to CSS.
	  return Object.keys(prefixedStyle).reduce(function (result, key) {
	    var dashCaseKey = _camelCaseToDashCase(key);
	
	    // Fix IE vendor prefix
	    if (/^ms-/.test(dashCaseKey)) {
	      dashCaseKey = '-' + dashCaseKey;
	    }
	
	    result[dashCaseKey] = prefixedStyle[key];
	    return result;
	  }, {});
	};
	
	exports.default = camelCasePropsToDashCase;
	module.exports = exports['default'];

/***/ }),
/* 1609 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; /**
	                                                                                                                                                                                                                                                                               * Based on https://github.com/jsstyles/css-vendor, but without having to
	                                                                                                                                                                                                                                                                               * convert between different cases all the time.
	                                                                                                                                                                                                                                                                               *
	                                                                                                                                                                                                                                                                               * 
	                                                                                                                                                                                                                                                                               */
	
	exports.getPrefixedKeyframes = getPrefixedKeyframes;
	exports.getPrefixedStyle = getPrefixedStyle;
	
	var _inlineStylePrefixer = __webpack_require__(1610);
	
	var _inlineStylePrefixer2 = _interopRequireDefault(_inlineStylePrefixer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function transformValues(style) {
	  return Object.keys(style).reduce(function (newStyle, key) {
	    var value = style[key];
	    if (Array.isArray(value)) {
	      value = value.join(';' + key + ':');
	    } else if (value && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object' && typeof value.toString === 'function') {
	      value = value.toString();
	    }
	
	    newStyle[key] = value;
	    return newStyle;
	  }, {});
	}
	
	var _hasWarnedAboutUserAgent = false;
	var _lastUserAgent = void 0;
	var _cachedPrefixer = void 0;
	
	function getPrefixer(userAgent) {
	  var actualUserAgent = userAgent || global && global.navigator && global.navigator.userAgent;
	
	  if (false) {
	    if (!actualUserAgent && !_hasWarnedAboutUserAgent) {
	      /* eslint-disable no-console */
	      console.warn('Radium: userAgent should be supplied for server-side rendering. See ' + 'https://github.com/FormidableLabs/radium/tree/master/docs/api#radium ' + 'for more information.');
	      /* eslint-enable no-console */
	      _hasWarnedAboutUserAgent = true;
	    }
	  }
	
	  if (!_cachedPrefixer || actualUserAgent !== _lastUserAgent) {
	    if (actualUserAgent === 'all') {
	      _cachedPrefixer = {
	        prefix: _inlineStylePrefixer2.default.prefixAll,
	        prefixedKeyframes: 'keyframes'
	      };
	    } else {
	      _cachedPrefixer = new _inlineStylePrefixer2.default({ userAgent: actualUserAgent });
	    }
	    _lastUserAgent = actualUserAgent;
	  }
	  return _cachedPrefixer;
	}
	
	function getPrefixedKeyframes(userAgent) {
	  return getPrefixer(userAgent).prefixedKeyframes;
	}
	
	// Returns a new style object with vendor prefixes added to property names
	// and values.
	function getPrefixedStyle(style, userAgent) {
	  var styleWithFallbacks = transformValues(style);
	  var prefixer = getPrefixer(userAgent);
	  var prefixedStyle = prefixer.prefix(styleWithFallbacks);
	  return prefixedStyle;
	}
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 1610 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	// special flexbox specifications
	
	
	var _prefixAll2 = __webpack_require__(1611);
	
	var _prefixAll3 = _interopRequireDefault(_prefixAll2);
	
	var _getBrowserInformation = __webpack_require__(1627);
	
	var _getBrowserInformation2 = _interopRequireDefault(_getBrowserInformation);
	
	var _getPrefixedKeyframes = __webpack_require__(1628);
	
	var _getPrefixedKeyframes2 = _interopRequireDefault(_getPrefixedKeyframes);
	
	var _capitalizeString = __webpack_require__(1613);
	
	var _capitalizeString2 = _interopRequireDefault(_capitalizeString);
	
	var _sortPrefixedStyle = __webpack_require__(1614);
	
	var _sortPrefixedStyle2 = _interopRequireDefault(_sortPrefixedStyle);
	
	var _prefixProps = __webpack_require__(1629);
	
	var _prefixProps2 = _interopRequireDefault(_prefixProps);
	
	var _position = __webpack_require__(1630);
	
	var _position2 = _interopRequireDefault(_position);
	
	var _calc = __webpack_require__(1632);
	
	var _calc2 = _interopRequireDefault(_calc);
	
	var _zoomCursor = __webpack_require__(1633);
	
	var _zoomCursor2 = _interopRequireDefault(_zoomCursor);
	
	var _grabCursor = __webpack_require__(1634);
	
	var _grabCursor2 = _interopRequireDefault(_grabCursor);
	
	var _flex = __webpack_require__(1635);
	
	var _flex2 = _interopRequireDefault(_flex);
	
	var _sizing = __webpack_require__(1636);
	
	var _sizing2 = _interopRequireDefault(_sizing);
	
	var _gradient = __webpack_require__(1637);
	
	var _gradient2 = _interopRequireDefault(_gradient);
	
	var _transition = __webpack_require__(1638);
	
	var _transition2 = _interopRequireDefault(_transition);
	
	var _flexboxIE = __webpack_require__(1640);
	
	var _flexboxIE2 = _interopRequireDefault(_flexboxIE);
	
	var _flexboxOld = __webpack_require__(1641);
	
	var _flexboxOld2 = _interopRequireDefault(_flexboxOld);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var plugins = [_position2.default, _calc2.default, _zoomCursor2.default, _grabCursor2.default, _sizing2.default, _gradient2.default, _transition2.default, _flexboxIE2.default, _flexboxOld2.default,
	// this must be run AFTER the flexbox specs
	_flex2.default];
	
	var Prefixer = function () {
	  /**
	   * Instantiante a new prefixer
	   * @param {string} userAgent - userAgent to gather prefix information according to caniuse.com
	   * @param {string} keepUnprefixed - keeps unprefixed properties and values
	   */
	
	  function Prefixer() {
	    var _this = this;
	
	    var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	    _classCallCheck(this, Prefixer);
	
	    var defaultUserAgent = typeof navigator !== 'undefined' ? navigator.userAgent : undefined;
	
	    this._userAgent = options.userAgent || defaultUserAgent;
	    this._keepUnprefixed = options.keepUnprefixed || false;
	
	    this._browserInfo = (0, _getBrowserInformation2.default)(this._userAgent);
	
	    // Checks if the userAgent was resolved correctly
	    if (this._browserInfo && this._browserInfo.prefix) {
	      // set additional prefix information
	      this.cssPrefix = this._browserInfo.prefix.css;
	      this.jsPrefix = this._browserInfo.prefix.inline;
	      this.prefixedKeyframes = (0, _getPrefixedKeyframes2.default)(this._browserInfo);
	    } else {
	      this._usePrefixAllFallback = true;
	      return false;
	    }
	
	    var data = this._browserInfo.browser && _prefixProps2.default[this._browserInfo.browser];
	    if (data) {
	      this._requiresPrefix = Object.keys(data).filter(function (key) {
	        return data[key] >= _this._browserInfo.version;
	      }).reduce(function (result, name) {
	        result[name] = true;
	        return result;
	      }, {});
	      this._hasPropsRequiringPrefix = Object.keys(this._requiresPrefix).length > 0;
	    } else {
	      this._usePrefixAllFallback = true;
	    }
	  }
	
	  /**
	   * Returns a prefixed version of the style object
	   * @param {Object} styles - Style object that gets prefixed properties added
	   * @returns {Object} - Style object with prefixed properties and values
	   */
	
	
	  _createClass(Prefixer, [{
	    key: 'prefix',
	    value: function prefix(styles) {
	      var _this2 = this;
	
	      // use prefixAll as fallback if userAgent can not be resolved
	      if (this._usePrefixAllFallback) {
	        return (0, _prefixAll3.default)(styles);
	      }
	
	      // only add prefixes if needed
	      if (!this._hasPropsRequiringPrefix) {
	        return styles;
	      }
	
	      Object.keys(styles).forEach(function (property) {
	        var value = styles[property];
	        if (value instanceof Object && !Array.isArray(value)) {
	          // recurse through nested style objects
	          styles[property] = _this2.prefix(value);
	        } else {
	          // add prefixes if needed
	          if (_this2._requiresPrefix[property]) {
	            styles[_this2.jsPrefix + (0, _capitalizeString2.default)(property)] = value;
	            if (!_this2._keepUnprefixed) {
	              delete styles[property];
	            }
	          }
	        }
	      });
	
	      Object.keys(styles).forEach(function (property) {
	        [].concat(styles[property]).forEach(function (value) {
	          // resolve plugins
	          plugins.forEach(function (plugin) {
	            // generates a new plugin interface with current data
	            assignStyles(styles, plugin({
	              property: property,
	              value: value,
	              styles: styles,
	              browserInfo: _this2._browserInfo,
	              prefix: {
	                js: _this2.jsPrefix,
	                css: _this2.cssPrefix,
	                keyframes: _this2.prefixedKeyframes
	              },
	              keepUnprefixed: _this2._keepUnprefixed,
	              requiresPrefix: _this2._requiresPrefix
	            }), value, _this2._keepUnprefixed);
	          });
	        });
	      });
	
	      return (0, _sortPrefixedStyle2.default)(styles);
	    }
	
	    /**
	     * Returns a prefixed version of the style object using all vendor prefixes
	     * @param {Object} styles - Style object that gets prefixed properties added
	     * @returns {Object} - Style object with prefixed properties and values
	     */
	
	  }], [{
	    key: 'prefixAll',
	    value: function prefixAll(styles) {
	      return (0, _prefixAll3.default)(styles);
	    }
	  }]);
	
	  return Prefixer;
	}();
	
	exports.default = Prefixer;
	
	
	function assignStyles(base) {
	  var extend = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	  var value = arguments[2];
	  var keepUnprefixed = arguments[3];
	
	  Object.keys(extend).forEach(function (property) {
	    var baseValue = base[property];
	    if (Array.isArray(baseValue)) {
	      [].concat(extend[property]).forEach(function (val) {
	        if (base[property].indexOf(val) === -1) {
	          base[property].splice(baseValue.indexOf(value), keepUnprefixed ? 0 : 1, val);
	        }
	      });
	    } else {
	      base[property] = extend[property];
	    }
	  });
	}
	module.exports = exports['default'];

/***/ }),
/* 1611 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = prefixAll;
	
	var _prefixProps = __webpack_require__(1612);
	
	var _prefixProps2 = _interopRequireDefault(_prefixProps);
	
	var _capitalizeString = __webpack_require__(1613);
	
	var _capitalizeString2 = _interopRequireDefault(_capitalizeString);
	
	var _sortPrefixedStyle = __webpack_require__(1614);
	
	var _sortPrefixedStyle2 = _interopRequireDefault(_sortPrefixedStyle);
	
	var _position = __webpack_require__(1616);
	
	var _position2 = _interopRequireDefault(_position);
	
	var _calc = __webpack_require__(1617);
	
	var _calc2 = _interopRequireDefault(_calc);
	
	var _cursor = __webpack_require__(1620);
	
	var _cursor2 = _interopRequireDefault(_cursor);
	
	var _flex = __webpack_require__(1621);
	
	var _flex2 = _interopRequireDefault(_flex);
	
	var _sizing = __webpack_require__(1622);
	
	var _sizing2 = _interopRequireDefault(_sizing);
	
	var _gradient = __webpack_require__(1623);
	
	var _gradient2 = _interopRequireDefault(_gradient);
	
	var _transition = __webpack_require__(1624);
	
	var _transition2 = _interopRequireDefault(_transition);
	
	var _flexboxIE = __webpack_require__(1625);
	
	var _flexboxIE2 = _interopRequireDefault(_flexboxIE);
	
	var _flexboxOld = __webpack_require__(1626);
	
	var _flexboxOld2 = _interopRequireDefault(_flexboxOld);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// special flexbox specifications
	
	
	var plugins = [_position2.default, _calc2.default, _cursor2.default, _sizing2.default, _gradient2.default, _transition2.default, _flexboxIE2.default, _flexboxOld2.default, _flex2.default];
	
	/**
	 * Returns a prefixed version of the style object using all vendor prefixes
	 * @param {Object} styles - Style object that gets prefixed properties added
	 * @returns {Object} - Style object with prefixed properties and values
	 */
	function prefixAll(styles) {
	  Object.keys(styles).forEach(function (property) {
	    var value = styles[property];
	    if (value instanceof Object && !Array.isArray(value)) {
	      // recurse through nested style objects
	      styles[property] = prefixAll(value);
	    } else {
	      Object.keys(_prefixProps2.default).forEach(function (prefix) {
	        var properties = _prefixProps2.default[prefix];
	        // add prefixes if needed
	        if (properties[property]) {
	          styles[prefix + (0, _capitalizeString2.default)(property)] = value;
	        }
	      });
	    }
	  });
	
	  Object.keys(styles).forEach(function (property) {
	    [].concat(styles[property]).forEach(function (value, index) {
	      // resolve every special plugins
	      plugins.forEach(function (plugin) {
	        return assignStyles(styles, plugin(property, value));
	      });
	    });
	  });
	
	  return (0, _sortPrefixedStyle2.default)(styles);
	}
	
	function assignStyles(base) {
	  var extend = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	
	  Object.keys(extend).forEach(function (property) {
	    var baseValue = base[property];
	    if (Array.isArray(baseValue)) {
	      [].concat(extend[property]).forEach(function (value) {
	        var valueIndex = baseValue.indexOf(value);
	        if (valueIndex > -1) {
	          base[property].splice(valueIndex, 1);
	        }
	        base[property].push(value);
	      });
	    } else {
	      base[property] = extend[property];
	    }
	  });
	}
	module.exports = exports['default'];

/***/ }),
/* 1612 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = { "Webkit": { "transform": true, "transformOrigin": true, "transformOriginX": true, "transformOriginY": true, "backfaceVisibility": true, "perspective": true, "perspectiveOrigin": true, "transformStyle": true, "transformOriginZ": true, "animation": true, "animationDelay": true, "animationDirection": true, "animationFillMode": true, "animationDuration": true, "animationIterationCount": true, "animationName": true, "animationPlayState": true, "animationTimingFunction": true, "appearance": true, "userSelect": true, "fontKerning": true, "textEmphasisPosition": true, "textEmphasis": true, "textEmphasisStyle": true, "textEmphasisColor": true, "boxDecorationBreak": true, "clipPath": true, "maskImage": true, "maskMode": true, "maskRepeat": true, "maskPosition": true, "maskClip": true, "maskOrigin": true, "maskSize": true, "maskComposite": true, "mask": true, "maskBorderSource": true, "maskBorderMode": true, "maskBorderSlice": true, "maskBorderWidth": true, "maskBorderOutset": true, "maskBorderRepeat": true, "maskBorder": true, "maskType": true, "textDecorationStyle": true, "textDecorationSkip": true, "textDecorationLine": true, "textDecorationColor": true, "filter": true, "fontFeatureSettings": true, "breakAfter": true, "breakBefore": true, "breakInside": true, "columnCount": true, "columnFill": true, "columnGap": true, "columnRule": true, "columnRuleColor": true, "columnRuleStyle": true, "columnRuleWidth": true, "columns": true, "columnSpan": true, "columnWidth": true, "flex": true, "flexBasis": true, "flexDirection": true, "flexGrow": true, "flexFlow": true, "flexShrink": true, "flexWrap": true, "alignContent": true, "alignItems": true, "alignSelf": true, "justifyContent": true, "order": true, "transition": true, "transitionDelay": true, "transitionDuration": true, "transitionProperty": true, "transitionTimingFunction": true, "backdropFilter": true, "scrollSnapType": true, "scrollSnapPointsX": true, "scrollSnapPointsY": true, "scrollSnapDestination": true, "scrollSnapCoordinate": true, "shapeImageThreshold": true, "shapeImageMargin": true, "shapeImageOutside": true, "hyphens": true, "flowInto": true, "flowFrom": true, "regionFragment": true, "textSizeAdjust": true }, "Moz": { "appearance": true, "userSelect": true, "boxSizing": true, "textAlignLast": true, "textDecorationStyle": true, "textDecorationSkip": true, "textDecorationLine": true, "textDecorationColor": true, "tabSize": true, "hyphens": true, "fontFeatureSettings": true, "breakAfter": true, "breakBefore": true, "breakInside": true, "columnCount": true, "columnFill": true, "columnGap": true, "columnRule": true, "columnRuleColor": true, "columnRuleStyle": true, "columnRuleWidth": true, "columns": true, "columnSpan": true, "columnWidth": true }, "ms": { "flex": true, "flexBasis": false, "flexDirection": true, "flexGrow": false, "flexFlow": true, "flexShrink": false, "flexWrap": true, "alignContent": false, "alignItems": false, "alignSelf": false, "justifyContent": false, "order": false, "transform": true, "transformOrigin": true, "transformOriginX": true, "transformOriginY": true, "userSelect": true, "wrapFlow": true, "wrapThrough": true, "wrapMargin": true, "scrollSnapType": true, "scrollSnapPointsX": true, "scrollSnapPointsY": true, "scrollSnapDestination": true, "scrollSnapCoordinate": true, "touchAction": true, "hyphens": true, "flowInto": true, "flowFrom": true, "breakBefore": true, "breakAfter": true, "breakInside": true, "regionFragment": true, "gridTemplateColumns": true, "gridTemplateRows": true, "gridTemplateAreas": true, "gridTemplate": true, "gridAutoColumns": true, "gridAutoRows": true, "gridAutoFlow": true, "grid": true, "gridRowStart": true, "gridColumnStart": true, "gridRowEnd": true, "gridRow": true, "gridColumn": true, "gridColumnEnd": true, "gridColumnGap": true, "gridRowGap": true, "gridArea": true, "gridGap": true, "textSizeAdjust": true } };
	module.exports = exports["default"];

/***/ }),
/* 1613 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	// helper to capitalize strings
	
	exports.default = function (str) {
	  return str.charAt(0).toUpperCase() + str.slice(1);
	};
	
	module.exports = exports["default"];

/***/ }),
/* 1614 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = sortPrefixedStyle;
	
	var _isPrefixedProperty = __webpack_require__(1615);
	
	var _isPrefixedProperty2 = _interopRequireDefault(_isPrefixedProperty);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function sortPrefixedStyle(style) {
	  return Object.keys(style).sort(function (left, right) {
	    if ((0, _isPrefixedProperty2.default)(left) && !(0, _isPrefixedProperty2.default)(right)) {
	      return -1;
	    } else if (!(0, _isPrefixedProperty2.default)(left) && (0, _isPrefixedProperty2.default)(right)) {
	      return 1;
	    }
	    return 0;
	  }).reduce(function (sortedStyle, prop) {
	    sortedStyle[prop] = style[prop];
	    return sortedStyle;
	  }, {});
	}
	module.exports = exports['default'];

/***/ }),
/* 1615 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (property) {
	  return property.match(/^(Webkit|Moz|O|ms)/) !== null;
	};
	
	module.exports = exports["default"];

/***/ }),
/* 1616 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = position;
	function position(property, value) {
	  if (property === 'position' && value === 'sticky') {
	    return { position: ['-webkit-sticky', 'sticky'] };
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 1617 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = calc;
	
	var _joinPrefixedValue = __webpack_require__(1618);
	
	var _joinPrefixedValue2 = _interopRequireDefault(_joinPrefixedValue);
	
	var _isPrefixedValue = __webpack_require__(1619);
	
	var _isPrefixedValue2 = _interopRequireDefault(_isPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function calc(property, value) {
	  if (typeof value === 'string' && !(0, _isPrefixedValue2.default)(value) && value.indexOf('calc(') > -1) {
	    return (0, _joinPrefixedValue2.default)(property, value, function (prefix, value) {
	      return value.replace(/calc\(/g, prefix + 'calc(');
	    });
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 1618 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	// returns a style object with a single concated prefixed value string
	
	exports.default = function (property, value) {
	  var replacer = arguments.length <= 2 || arguments[2] === undefined ? function (prefix, value) {
	    return prefix + value;
	  } : arguments[2];
	  return _defineProperty({}, property, ['-webkit-', '-moz-', ''].map(function (prefix) {
	    return replacer(prefix, value);
	  }));
	};
	
	module.exports = exports['default'];

/***/ }),
/* 1619 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (value) {
	  if (Array.isArray(value)) value = value.join(',');
	
	  return value.match(/-webkit-|-moz-|-ms-/) !== null;
	};
	
	module.exports = exports['default'];

/***/ }),
/* 1620 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = cursor;
	
	var _joinPrefixedValue = __webpack_require__(1618);
	
	var _joinPrefixedValue2 = _interopRequireDefault(_joinPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var values = {
	  'zoom-in': true,
	  'zoom-out': true,
	  grab: true,
	  grabbing: true
	};
	
	function cursor(property, value) {
	  if (property === 'cursor' && values[value]) {
	    return (0, _joinPrefixedValue2.default)(property, value);
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 1621 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = flex;
	var values = { flex: true, 'inline-flex': true };
	
	function flex(property, value) {
	  if (property === 'display' && values[value]) {
	    return {
	      display: ['-webkit-box', '-moz-box', '-ms-' + value + 'box', '-webkit-' + value, value]
	    };
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 1622 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = sizing;
	
	var _joinPrefixedValue = __webpack_require__(1618);
	
	var _joinPrefixedValue2 = _interopRequireDefault(_joinPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var properties = {
	  maxHeight: true,
	  maxWidth: true,
	  width: true,
	  height: true,
	  columnWidth: true,
	  minWidth: true,
	  minHeight: true
	};
	var values = {
	  'min-content': true,
	  'max-content': true,
	  'fill-available': true,
	  'fit-content': true,
	  'contain-floats': true
	};
	
	function sizing(property, value) {
	  if (properties[property] && values[value]) {
	    return (0, _joinPrefixedValue2.default)(property, value);
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 1623 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = gradient;
	
	var _joinPrefixedValue = __webpack_require__(1618);
	
	var _joinPrefixedValue2 = _interopRequireDefault(_joinPrefixedValue);
	
	var _isPrefixedValue = __webpack_require__(1619);
	
	var _isPrefixedValue2 = _interopRequireDefault(_isPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var values = /linear-gradient|radial-gradient|repeating-linear-gradient|repeating-radial-gradient/;
	
	function gradient(property, value) {
	  if (typeof value === 'string' && !(0, _isPrefixedValue2.default)(value) && value.match(values) !== null) {
	    return (0, _joinPrefixedValue2.default)(property, value);
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 1624 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = transition;
	
	var _hyphenateStyleName = __webpack_require__(837);
	
	var _hyphenateStyleName2 = _interopRequireDefault(_hyphenateStyleName);
	
	var _capitalizeString = __webpack_require__(1613);
	
	var _capitalizeString2 = _interopRequireDefault(_capitalizeString);
	
	var _isPrefixedValue = __webpack_require__(1619);
	
	var _isPrefixedValue2 = _interopRequireDefault(_isPrefixedValue);
	
	var _prefixProps = __webpack_require__(1612);
	
	var _prefixProps2 = _interopRequireDefault(_prefixProps);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var properties = {
	  transition: true,
	  transitionProperty: true,
	  WebkitTransition: true,
	  WebkitTransitionProperty: true
	};
	
	function transition(property, value) {
	  // also check for already prefixed transitions
	  if (typeof value === 'string' && properties[property]) {
	    var _ref2;
	
	    var outputValue = prefixValue(value);
	    var webkitOutput = outputValue.split(/,(?![^()]*(?:\([^()]*\))?\))/g).filter(function (value) {
	      return value.match(/-moz-|-ms-/) === null;
	    }).join(',');
	
	    // if the property is already prefixed
	    if (property.indexOf('Webkit') > -1) {
	      return _defineProperty({}, property, webkitOutput);
	    }
	
	    return _ref2 = {}, _defineProperty(_ref2, 'Webkit' + (0, _capitalizeString2.default)(property), webkitOutput), _defineProperty(_ref2, property, outputValue), _ref2;
	  }
	}
	
	function prefixValue(value) {
	  if ((0, _isPrefixedValue2.default)(value)) {
	    return value;
	  }
	
	  // only split multi values, not cubic beziers
	  var multipleValues = value.split(/,(?![^()]*(?:\([^()]*\))?\))/g);
	
	  // iterate each single value and check for transitioned properties
	  // that need to be prefixed as well
	  multipleValues.forEach(function (val, index) {
	    multipleValues[index] = Object.keys(_prefixProps2.default).reduce(function (out, prefix) {
	      var dashCasePrefix = '-' + prefix.toLowerCase() + '-';
	
	      Object.keys(_prefixProps2.default[prefix]).forEach(function (prop) {
	        var dashCaseProperty = (0, _hyphenateStyleName2.default)(prop);
	
	        if (val.indexOf(dashCaseProperty) > -1 && dashCaseProperty !== 'order') {
	          // join all prefixes and create a new value
	          out = val.replace(dashCaseProperty, dashCasePrefix + dashCaseProperty) + ',' + out;
	        }
	      });
	      return out;
	    }, val);
	  });
	
	  return multipleValues.join(',');
	}
	module.exports = exports['default'];

/***/ }),
/* 1625 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = flexboxIE;
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var alternativeValues = {
	  'space-around': 'distribute',
	  'space-between': 'justify',
	  'flex-start': 'start',
	  'flex-end': 'end'
	};
	var alternativeProps = {
	  alignContent: 'msFlexLinePack',
	  alignSelf: 'msFlexItemAlign',
	  alignItems: 'msFlexAlign',
	  justifyContent: 'msFlexPack',
	  order: 'msFlexOrder',
	  flexGrow: 'msFlexPositive',
	  flexShrink: 'msFlexNegative',
	  flexBasis: 'msPreferredSize'
	};
	
	function flexboxIE(property, value) {
	  if (alternativeProps[property]) {
	    return _defineProperty({}, alternativeProps[property], alternativeValues[value] || value);
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 1626 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = flexboxOld;
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var alternativeValues = {
	  'space-around': 'justify',
	  'space-between': 'justify',
	  'flex-start': 'start',
	  'flex-end': 'end',
	  'wrap-reverse': 'multiple',
	  wrap: 'multiple'
	};
	
	var alternativeProps = {
	  alignItems: 'WebkitBoxAlign',
	  justifyContent: 'WebkitBoxPack',
	  flexWrap: 'WebkitBoxLines'
	};
	
	function flexboxOld(property, value) {
	  if (property === 'flexDirection' && typeof value === 'string') {
	    return {
	      WebkitBoxOrient: value.indexOf('column') > -1 ? 'vertical' : 'horizontal',
	      WebkitBoxDirection: value.indexOf('reverse') > -1 ? 'reverse' : 'normal'
	    };
	  }
	  if (alternativeProps[property]) {
	    return _defineProperty({}, alternativeProps[property], alternativeValues[value] || value);
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 1627 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _bowser = __webpack_require__(841);
	
	var _bowser2 = _interopRequireDefault(_bowser);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var vendorPrefixes = {
	  Webkit: ['chrome', 'safari', 'ios', 'android', 'phantom', 'opera', 'webos', 'blackberry', 'bada', 'tizen', 'chromium', 'vivaldi'],
	  Moz: ['firefox', 'seamonkey', 'sailfish'],
	  ms: ['msie', 'msedge']
	};
	var browsers = {
	  chrome: [['chrome'], ['chromium']],
	  safari: [['safari']],
	  firefox: [['firefox']],
	  edge: [['msedge']],
	  opera: [['opera'], ['vivaldi']],
	  ios_saf: [['ios', 'mobile'], ['ios', 'tablet']],
	  ie: [['msie']],
	  op_mini: [['opera', 'mobile'], ['opera', 'tablet']],
	  and_uc: [['android', 'mobile'], ['android', 'tablet']],
	  android: [['android', 'mobile'], ['android', 'tablet']]
	};
	
	var browserByInfo = function browserByInfo(info) {
	  if (info.firefox) {
	    return 'firefox';
	  }
	  var name = '';
	
	  Object.keys(browsers).forEach(function (browser) {
	    browsers[browser].forEach(function (condition) {
	      var match = 0;
	      condition.forEach(function (single) {
	        if (info[single]) {
	          match += 1;
	        }
	      });
	      if (condition.length === match) {
	        name = browser;
	      }
	    });
	  });
	
	  return name;
	};
	
	/**
	 * Uses bowser to get default browser information such as version and name
	 * Evaluates bowser info and adds vendorPrefix information
	 * @param {string} userAgent - userAgent that gets evaluated
	 */
	
	exports.default = function (userAgent) {
	  if (!userAgent) {
	    return false;
	  }
	  var info = _bowser2.default._detect(userAgent);
	
	  Object.keys(vendorPrefixes).forEach(function (prefix) {
	    vendorPrefixes[prefix].forEach(function (browser) {
	      if (info[browser]) {
	        info.prefix = {
	          inline: prefix,
	          css: '-' + prefix.toLowerCase() + '-'
	        };
	      }
	    });
	  });
	
	  info.browser = browserByInfo(info);
	
	  // For cordova IOS 8 the version is missing, set truncated osversion to prevent NaN
	  info.version = info.version ? parseFloat(info.version) : parseInt(parseFloat(info.osversion), 10);
	  info.osversion = parseFloat(info.osversion);
	
	  // iOS forces all browsers to use Safari under the hood
	  // as the Safari version seems to match the iOS version
	  // we just explicitely use the osversion instead
	  // https://github.com/rofrischmann/inline-style-prefixer/issues/72
	  if (info.browser === 'ios_saf' && info.version > info.osversion) {
	    info.version = info.osversion;
	    info.safari = true;
	  }
	
	  // seperate native android chrome
	  // https://github.com/rofrischmann/inline-style-prefixer/issues/45
	  if (info.browser === 'android' && info.chrome && info.version > 37) {
	    info.browser = 'and_chr';
	  }
	
	  // For android < 4.4 we want to check the osversion
	  // not the chrome version, see issue #26
	  // https://github.com/rofrischmann/inline-style-prefixer/issues/26
	  if (info.browser === 'android' && info.osversion < 5) {
	    info.version = info.osversion;
	  }
	
	  return info;
	};
	
	module.exports = exports['default'];

/***/ }),
/* 1628 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (_ref) {
	  var browser = _ref.browser;
	  var version = _ref.version;
	  var prefix = _ref.prefix;
	
	  var prefixedKeyframes = 'keyframes';
	
	  if (browser === 'chrome' && version < 43 || (browser === 'safari' || browser === 'ios_saf') && version < 9 || browser === 'opera' && version < 30 || browser === 'android' && version <= 4.4 || browser === 'and_uc') {
	    prefixedKeyframes = prefix.css + prefixedKeyframes;
	  }
	  return prefixedKeyframes;
	};
	
	module.exports = exports['default'];

/***/ }),
/* 1629 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = { "chrome": { "transform": 35, "transformOrigin": 35, "transformOriginX": 35, "transformOriginY": 35, "backfaceVisibility": 35, "perspective": 35, "perspectiveOrigin": 35, "transformStyle": 35, "transformOriginZ": 35, "animation": 42, "animationDelay": 42, "animationDirection": 42, "animationFillMode": 42, "animationDuration": 42, "animationIterationCount": 42, "animationName": 42, "animationPlayState": 42, "animationTimingFunction": 42, "appearance": 55, "userSelect": 55, "fontKerning": 32, "textEmphasisPosition": 55, "textEmphasis": 55, "textEmphasisStyle": 55, "textEmphasisColor": 55, "boxDecorationBreak": 55, "clipPath": 55, "maskImage": 55, "maskMode": 55, "maskRepeat": 55, "maskPosition": 55, "maskClip": 55, "maskOrigin": 55, "maskSize": 55, "maskComposite": 55, "mask": 55, "maskBorderSource": 55, "maskBorderMode": 55, "maskBorderSlice": 55, "maskBorderWidth": 55, "maskBorderOutset": 55, "maskBorderRepeat": 55, "maskBorder": 55, "maskType": 55, "textDecorationStyle": 55, "textDecorationSkip": 55, "textDecorationLine": 55, "textDecorationColor": 55, "filter": 52, "fontFeatureSettings": 47, "breakAfter": 49, "breakBefore": 49, "breakInside": 49, "columnCount": 49, "columnFill": 49, "columnGap": 49, "columnRule": 49, "columnRuleColor": 49, "columnRuleStyle": 49, "columnRuleWidth": 49, "columns": 49, "columnSpan": 49, "columnWidth": 49 }, "safari": { "flex": 8, "flexBasis": 8, "flexDirection": 8, "flexGrow": 8, "flexFlow": 8, "flexShrink": 8, "flexWrap": 8, "alignContent": 8, "alignItems": 8, "alignSelf": 8, "justifyContent": 8, "order": 8, "transition": 6, "transitionDelay": 6, "transitionDuration": 6, "transitionProperty": 6, "transitionTimingFunction": 6, "transform": 8, "transformOrigin": 8, "transformOriginX": 8, "transformOriginY": 8, "backfaceVisibility": 8, "perspective": 8, "perspectiveOrigin": 8, "transformStyle": 8, "transformOriginZ": 8, "animation": 8, "animationDelay": 8, "animationDirection": 8, "animationFillMode": 8, "animationDuration": 8, "animationIterationCount": 8, "animationName": 8, "animationPlayState": 8, "animationTimingFunction": 8, "appearance": 10, "userSelect": 10, "backdropFilter": 10, "fontKerning": 9, "scrollSnapType": 10, "scrollSnapPointsX": 10, "scrollSnapPointsY": 10, "scrollSnapDestination": 10, "scrollSnapCoordinate": 10, "textEmphasisPosition": 7, "textEmphasis": 7, "textEmphasisStyle": 7, "textEmphasisColor": 7, "boxDecorationBreak": 10, "clipPath": 10, "maskImage": 10, "maskMode": 10, "maskRepeat": 10, "maskPosition": 10, "maskClip": 10, "maskOrigin": 10, "maskSize": 10, "maskComposite": 10, "mask": 10, "maskBorderSource": 10, "maskBorderMode": 10, "maskBorderSlice": 10, "maskBorderWidth": 10, "maskBorderOutset": 10, "maskBorderRepeat": 10, "maskBorder": 10, "maskType": 10, "textDecorationStyle": 10, "textDecorationSkip": 10, "textDecorationLine": 10, "textDecorationColor": 10, "shapeImageThreshold": 10, "shapeImageMargin": 10, "shapeImageOutside": 10, "filter": 9, "hyphens": 10, "flowInto": 10, "flowFrom": 10, "breakBefore": 8, "breakAfter": 8, "breakInside": 8, "regionFragment": 10, "columnCount": 8, "columnFill": 8, "columnGap": 8, "columnRule": 8, "columnRuleColor": 8, "columnRuleStyle": 8, "columnRuleWidth": 8, "columns": 8, "columnSpan": 8, "columnWidth": 8 }, "firefox": { "appearance": 51, "userSelect": 51, "boxSizing": 28, "textAlignLast": 48, "textDecorationStyle": 35, "textDecorationSkip": 35, "textDecorationLine": 35, "textDecorationColor": 35, "tabSize": 51, "hyphens": 42, "fontFeatureSettings": 33, "breakAfter": 51, "breakBefore": 51, "breakInside": 51, "columnCount": 51, "columnFill": 51, "columnGap": 51, "columnRule": 51, "columnRuleColor": 51, "columnRuleStyle": 51, "columnRuleWidth": 51, "columns": 51, "columnSpan": 51, "columnWidth": 51 }, "opera": { "flex": 16, "flexBasis": 16, "flexDirection": 16, "flexGrow": 16, "flexFlow": 16, "flexShrink": 16, "flexWrap": 16, "alignContent": 16, "alignItems": 16, "alignSelf": 16, "justifyContent": 16, "order": 16, "transform": 22, "transformOrigin": 22, "transformOriginX": 22, "transformOriginY": 22, "backfaceVisibility": 22, "perspective": 22, "perspectiveOrigin": 22, "transformStyle": 22, "transformOriginZ": 22, "animation": 29, "animationDelay": 29, "animationDirection": 29, "animationFillMode": 29, "animationDuration": 29, "animationIterationCount": 29, "animationName": 29, "animationPlayState": 29, "animationTimingFunction": 29, "appearance": 41, "userSelect": 41, "fontKerning": 19, "textEmphasisPosition": 41, "textEmphasis": 41, "textEmphasisStyle": 41, "textEmphasisColor": 41, "boxDecorationBreak": 41, "clipPath": 41, "maskImage": 41, "maskMode": 41, "maskRepeat": 41, "maskPosition": 41, "maskClip": 41, "maskOrigin": 41, "maskSize": 41, "maskComposite": 41, "mask": 41, "maskBorderSource": 41, "maskBorderMode": 41, "maskBorderSlice": 41, "maskBorderWidth": 41, "maskBorderOutset": 41, "maskBorderRepeat": 41, "maskBorder": 41, "maskType": 41, "textDecorationStyle": 41, "textDecorationSkip": 41, "textDecorationLine": 41, "textDecorationColor": 41, "filter": 39, "fontFeatureSettings": 34, "breakAfter": 36, "breakBefore": 36, "breakInside": 36, "columnCount": 36, "columnFill": 36, "columnGap": 36, "columnRule": 36, "columnRuleColor": 36, "columnRuleStyle": 36, "columnRuleWidth": 36, "columns": 36, "columnSpan": 36, "columnWidth": 36 }, "ie": { "flex": 10, "flexDirection": 10, "flexFlow": 10, "flexWrap": 10, "transform": 9, "transformOrigin": 9, "transformOriginX": 9, "transformOriginY": 9, "userSelect": 11, "wrapFlow": 11, "wrapThrough": 11, "wrapMargin": 11, "scrollSnapType": 11, "scrollSnapPointsX": 11, "scrollSnapPointsY": 11, "scrollSnapDestination": 11, "scrollSnapCoordinate": 11, "touchAction": 10, "hyphens": 11, "flowInto": 11, "flowFrom": 11, "breakBefore": 11, "breakAfter": 11, "breakInside": 11, "regionFragment": 11, "gridTemplateColumns": 11, "gridTemplateRows": 11, "gridTemplateAreas": 11, "gridTemplate": 11, "gridAutoColumns": 11, "gridAutoRows": 11, "gridAutoFlow": 11, "grid": 11, "gridRowStart": 11, "gridColumnStart": 11, "gridRowEnd": 11, "gridRow": 11, "gridColumn": 11, "gridColumnEnd": 11, "gridColumnGap": 11, "gridRowGap": 11, "gridArea": 11, "gridGap": 11, "textSizeAdjust": 11 }, "edge": { "userSelect": 14, "wrapFlow": 14, "wrapThrough": 14, "wrapMargin": 14, "scrollSnapType": 14, "scrollSnapPointsX": 14, "scrollSnapPointsY": 14, "scrollSnapDestination": 14, "scrollSnapCoordinate": 14, "hyphens": 14, "flowInto": 14, "flowFrom": 14, "breakBefore": 14, "breakAfter": 14, "breakInside": 14, "regionFragment": 14, "gridTemplateColumns": 14, "gridTemplateRows": 14, "gridTemplateAreas": 14, "gridTemplate": 14, "gridAutoColumns": 14, "gridAutoRows": 14, "gridAutoFlow": 14, "grid": 14, "gridRowStart": 14, "gridColumnStart": 14, "gridRowEnd": 14, "gridRow": 14, "gridColumn": 14, "gridColumnEnd": 14, "gridColumnGap": 14, "gridRowGap": 14, "gridArea": 14, "gridGap": 14 }, "ios_saf": { "flex": 8.1, "flexBasis": 8.1, "flexDirection": 8.1, "flexGrow": 8.1, "flexFlow": 8.1, "flexShrink": 8.1, "flexWrap": 8.1, "alignContent": 8.1, "alignItems": 8.1, "alignSelf": 8.1, "justifyContent": 8.1, "order": 8.1, "transition": 6, "transitionDelay": 6, "transitionDuration": 6, "transitionProperty": 6, "transitionTimingFunction": 6, "transform": 8.1, "transformOrigin": 8.1, "transformOriginX": 8.1, "transformOriginY": 8.1, "backfaceVisibility": 8.1, "perspective": 8.1, "perspectiveOrigin": 8.1, "transformStyle": 8.1, "transformOriginZ": 8.1, "animation": 8.1, "animationDelay": 8.1, "animationDirection": 8.1, "animationFillMode": 8.1, "animationDuration": 8.1, "animationIterationCount": 8.1, "animationName": 8.1, "animationPlayState": 8.1, "animationTimingFunction": 8.1, "appearance": 9.3, "userSelect": 9.3, "backdropFilter": 9.3, "fontKerning": 9.3, "scrollSnapType": 9.3, "scrollSnapPointsX": 9.3, "scrollSnapPointsY": 9.3, "scrollSnapDestination": 9.3, "scrollSnapCoordinate": 9.3, "boxDecorationBreak": 9.3, "clipPath": 9.3, "maskImage": 9.3, "maskMode": 9.3, "maskRepeat": 9.3, "maskPosition": 9.3, "maskClip": 9.3, "maskOrigin": 9.3, "maskSize": 9.3, "maskComposite": 9.3, "mask": 9.3, "maskBorderSource": 9.3, "maskBorderMode": 9.3, "maskBorderSlice": 9.3, "maskBorderWidth": 9.3, "maskBorderOutset": 9.3, "maskBorderRepeat": 9.3, "maskBorder": 9.3, "maskType": 9.3, "textSizeAdjust": 9.3, "textDecorationStyle": 9.3, "textDecorationSkip": 9.3, "textDecorationLine": 9.3, "textDecorationColor": 9.3, "shapeImageThreshold": 9.3, "shapeImageMargin": 9.3, "shapeImageOutside": 9.3, "filter": 9, "hyphens": 9.3, "flowInto": 9.3, "flowFrom": 9.3, "breakBefore": 8.1, "breakAfter": 8.1, "breakInside": 8.1, "regionFragment": 9.3, "columnCount": 8.1, "columnFill": 8.1, "columnGap": 8.1, "columnRule": 8.1, "columnRuleColor": 8.1, "columnRuleStyle": 8.1, "columnRuleWidth": 8.1, "columns": 8.1, "columnSpan": 8.1, "columnWidth": 8.1 }, "android": { "flex": 4.2, "flexBasis": 4.2, "flexDirection": 4.2, "flexGrow": 4.2, "flexFlow": 4.2, "flexShrink": 4.2, "flexWrap": 4.2, "alignContent": 4.2, "alignItems": 4.2, "alignSelf": 4.2, "justifyContent": 4.2, "order": 4.2, "transition": 4.2, "transitionDelay": 4.2, "transitionDuration": 4.2, "transitionProperty": 4.2, "transitionTimingFunction": 4.2, "transform": 4.4, "transformOrigin": 4.4, "transformOriginX": 4.4, "transformOriginY": 4.4, "backfaceVisibility": 4.4, "perspective": 4.4, "perspectiveOrigin": 4.4, "transformStyle": 4.4, "transformOriginZ": 4.4, "animation": 4.4, "animationDelay": 4.4, "animationDirection": 4.4, "animationFillMode": 4.4, "animationDuration": 4.4, "animationIterationCount": 4.4, "animationName": 4.4, "animationPlayState": 4.4, "animationTimingFunction": 4.4, "appearance": 51, "userSelect": 51, "fontKerning": 4.4, "textEmphasisPosition": 51, "textEmphasis": 51, "textEmphasisStyle": 51, "textEmphasisColor": 51, "boxDecorationBreak": 51, "clipPath": 51, "maskImage": 51, "maskMode": 51, "maskRepeat": 51, "maskPosition": 51, "maskClip": 51, "maskOrigin": 51, "maskSize": 51, "maskComposite": 51, "mask": 51, "maskBorderSource": 51, "maskBorderMode": 51, "maskBorderSlice": 51, "maskBorderWidth": 51, "maskBorderOutset": 51, "maskBorderRepeat": 51, "maskBorder": 51, "maskType": 51, "filter": 51, "fontFeatureSettings": 4.4, "breakAfter": 51, "breakBefore": 51, "breakInside": 51, "columnCount": 51, "columnFill": 51, "columnGap": 51, "columnRule": 51, "columnRuleColor": 51, "columnRuleStyle": 51, "columnRuleWidth": 51, "columns": 51, "columnSpan": 51, "columnWidth": 51 }, "and_chr": { "appearance": 51, "userSelect": 51, "textEmphasisPosition": 51, "textEmphasis": 51, "textEmphasisStyle": 51, "textEmphasisColor": 51, "boxDecorationBreak": 51, "clipPath": 51, "maskImage": 51, "maskMode": 51, "maskRepeat": 51, "maskPosition": 51, "maskClip": 51, "maskOrigin": 51, "maskSize": 51, "maskComposite": 51, "mask": 51, "maskBorderSource": 51, "maskBorderMode": 51, "maskBorderSlice": 51, "maskBorderWidth": 51, "maskBorderOutset": 51, "maskBorderRepeat": 51, "maskBorder": 51, "maskType": 51, "textDecorationStyle": 51, "textDecorationSkip": 51, "textDecorationLine": 51, "textDecorationColor": 51, "filter": 51 }, "and_uc": { "flex": 9.9, "flexBasis": 9.9, "flexDirection": 9.9, "flexGrow": 9.9, "flexFlow": 9.9, "flexShrink": 9.9, "flexWrap": 9.9, "alignContent": 9.9, "alignItems": 9.9, "alignSelf": 9.9, "justifyContent": 9.9, "order": 9.9, "transition": 9.9, "transitionDelay": 9.9, "transitionDuration": 9.9, "transitionProperty": 9.9, "transitionTimingFunction": 9.9, "transform": 9.9, "transformOrigin": 9.9, "transformOriginX": 9.9, "transformOriginY": 9.9, "backfaceVisibility": 9.9, "perspective": 9.9, "perspectiveOrigin": 9.9, "transformStyle": 9.9, "transformOriginZ": 9.9, "animation": 9.9, "animationDelay": 9.9, "animationDirection": 9.9, "animationFillMode": 9.9, "animationDuration": 9.9, "animationIterationCount": 9.9, "animationName": 9.9, "animationPlayState": 9.9, "animationTimingFunction": 9.9, "appearance": 9.9, "userSelect": 9.9, "fontKerning": 9.9, "textEmphasisPosition": 9.9, "textEmphasis": 9.9, "textEmphasisStyle": 9.9, "textEmphasisColor": 9.9, "maskImage": 9.9, "maskMode": 9.9, "maskRepeat": 9.9, "maskPosition": 9.9, "maskClip": 9.9, "maskOrigin": 9.9, "maskSize": 9.9, "maskComposite": 9.9, "mask": 9.9, "maskBorderSource": 9.9, "maskBorderMode": 9.9, "maskBorderSlice": 9.9, "maskBorderWidth": 9.9, "maskBorderOutset": 9.9, "maskBorderRepeat": 9.9, "maskBorder": 9.9, "maskType": 9.9, "textSizeAdjust": 9.9, "filter": 9.9, "hyphens": 9.9, "flowInto": 9.9, "flowFrom": 9.9, "breakBefore": 9.9, "breakAfter": 9.9, "breakInside": 9.9, "regionFragment": 9.9, "fontFeatureSettings": 9.9, "columnCount": 9.9, "columnFill": 9.9, "columnGap": 9.9, "columnRule": 9.9, "columnRuleColor": 9.9, "columnRuleStyle": 9.9, "columnRuleWidth": 9.9, "columns": 9.9, "columnSpan": 9.9, "columnWidth": 9.9 }, "op_mini": {} };
	module.exports = exports["default"];

/***/ }),
/* 1630 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = position;
	
	var _getPrefixedValue = __webpack_require__(1631);
	
	var _getPrefixedValue2 = _interopRequireDefault(_getPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function position(_ref) {
	  var property = _ref.property;
	  var value = _ref.value;
	  var browser = _ref.browserInfo.browser;
	  var css = _ref.prefix.css;
	  var keepUnprefixed = _ref.keepUnprefixed;
	
	  if (property === 'position' && value === 'sticky' && (browser === 'safari' || browser === 'ios_saf')) {
	    return _defineProperty({}, property, (0, _getPrefixedValue2.default)(css + value, value, keepUnprefixed));
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 1631 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (prefixedValue, value, keepUnprefixed) {
	  return keepUnprefixed ? [prefixedValue, value] : prefixedValue;
	};
	
	module.exports = exports["default"];

/***/ }),
/* 1632 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = calc;
	
	var _getPrefixedValue = __webpack_require__(1631);
	
	var _getPrefixedValue2 = _interopRequireDefault(_getPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function calc(_ref) {
	  var property = _ref.property;
	  var value = _ref.value;
	  var _ref$browserInfo = _ref.browserInfo;
	  var browser = _ref$browserInfo.browser;
	  var version = _ref$browserInfo.version;
	  var css = _ref.prefix.css;
	  var keepUnprefixed = _ref.keepUnprefixed;
	
	  if (typeof value === 'string' && value.indexOf('calc(') > -1 && (browser === 'firefox' && version < 15 || browser === 'chrome' && version < 25 || browser === 'safari' && version < 6.1 || browser === 'ios_saf' && version < 7)) {
	    return _defineProperty({}, property, (0, _getPrefixedValue2.default)(value.replace(/calc\(/g, css + 'calc('), value, keepUnprefixed));
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 1633 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = zoomCursor;
	
	var _getPrefixedValue = __webpack_require__(1631);
	
	var _getPrefixedValue2 = _interopRequireDefault(_getPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var values = { 'zoom-in': true, 'zoom-out': true };
	
	function zoomCursor(_ref) {
	  var property = _ref.property;
	  var value = _ref.value;
	  var _ref$browserInfo = _ref.browserInfo;
	  var browser = _ref$browserInfo.browser;
	  var version = _ref$browserInfo.version;
	  var css = _ref.prefix.css;
	  var keepUnprefixed = _ref.keepUnprefixed;
	
	  if (property === 'cursor' && values[value] && (browser === 'firefox' && version < 24 || browser === 'chrome' && version < 37 || browser === 'safari' && version < 9 || browser === 'opera' && version < 24)) {
	    return {
	      cursor: (0, _getPrefixedValue2.default)(css + value, value, keepUnprefixed)
	    };
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 1634 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = grabCursor;
	
	var _getPrefixedValue = __webpack_require__(1631);
	
	var _getPrefixedValue2 = _interopRequireDefault(_getPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var values = { grab: true, grabbing: true };
	
	function grabCursor(_ref) {
	  var property = _ref.property;
	  var value = _ref.value;
	  var browser = _ref.browserInfo.browser;
	  var css = _ref.prefix.css;
	  var keepUnprefixed = _ref.keepUnprefixed;
	
	  // adds prefixes for firefox, chrome, safari, and opera regardless of version until a reliable brwoser support info can be found (see: https://github.com/rofrischmann/inline-style-prefixer/issues/79)
	  if (property === 'cursor' && values[value] && (browser === 'firefox' || browser === 'chrome' || browser === 'safari' || browser === 'opera')) {
	    return {
	      cursor: (0, _getPrefixedValue2.default)(css + value, value, keepUnprefixed)
	    };
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 1635 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = flex;
	
	var _getPrefixedValue = __webpack_require__(1631);
	
	var _getPrefixedValue2 = _interopRequireDefault(_getPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var values = { flex: true, 'inline-flex': true };
	
	function flex(_ref) {
	  var property = _ref.property;
	  var value = _ref.value;
	  var _ref$browserInfo = _ref.browserInfo;
	  var browser = _ref$browserInfo.browser;
	  var version = _ref$browserInfo.version;
	  var css = _ref.prefix.css;
	  var keepUnprefixed = _ref.keepUnprefixed;
	
	  if (property === 'display' && values[value] && (browser === 'chrome' && version < 29 && version > 20 || (browser === 'safari' || browser === 'ios_saf') && version < 9 && version > 6 || browser === 'opera' && (version == 15 || version == 16))) {
	    return {
	      display: (0, _getPrefixedValue2.default)(css + value, value, keepUnprefixed)
	    };
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 1636 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = sizing;
	
	var _getPrefixedValue = __webpack_require__(1631);
	
	var _getPrefixedValue2 = _interopRequireDefault(_getPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var properties = {
	  maxHeight: true,
	  maxWidth: true,
	  width: true,
	  height: true,
	  columnWidth: true,
	  minWidth: true,
	  minHeight: true
	};
	var values = {
	  'min-content': true,
	  'max-content': true,
	  'fill-available': true,
	  'fit-content': true,
	  'contain-floats': true
	};
	
	function sizing(_ref) {
	  var property = _ref.property;
	  var value = _ref.value;
	  var css = _ref.prefix.css;
	  var keepUnprefixed = _ref.keepUnprefixed;
	
	  // This might change in the future
	  // Keep an eye on it
	  if (properties[property] && values[value]) {
	    return _defineProperty({}, property, (0, _getPrefixedValue2.default)(css + value, value, keepUnprefixed));
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 1637 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = gradient;
	
	var _getPrefixedValue = __webpack_require__(1631);
	
	var _getPrefixedValue2 = _interopRequireDefault(_getPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var values = /linear-gradient|radial-gradient|repeating-linear-gradient|repeating-radial-gradient/;
	
	function gradient(_ref) {
	  var property = _ref.property;
	  var value = _ref.value;
	  var _ref$browserInfo = _ref.browserInfo;
	  var browser = _ref$browserInfo.browser;
	  var version = _ref$browserInfo.version;
	  var css = _ref.prefix.css;
	  var keepUnprefixed = _ref.keepUnprefixed;
	
	  if (typeof value === 'string' && value.match(values) !== null && (browser === 'firefox' && version < 16 || browser === 'chrome' && version < 26 || (browser === 'safari' || browser === 'ios_saf') && version < 7 || (browser === 'opera' || browser === 'op_mini') && version < 12.1 || browser === 'android' && version < 4.4 || browser === 'and_uc')) {
	    return _defineProperty({}, property, (0, _getPrefixedValue2.default)(css + value, value, keepUnprefixed));
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 1638 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	exports.default = transition;
	
	var _hyphenateStyleName = __webpack_require__(837);
	
	var _hyphenateStyleName2 = _interopRequireDefault(_hyphenateStyleName);
	
	var _unprefixProperty = __webpack_require__(1639);
	
	var _unprefixProperty2 = _interopRequireDefault(_unprefixProperty);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var properties = { transition: true, transitionProperty: true };
	
	function transition(_ref) {
	  var property = _ref.property;
	  var value = _ref.value;
	  var css = _ref.prefix.css;
	  var requiresPrefix = _ref.requiresPrefix;
	  var keepUnprefixed = _ref.keepUnprefixed;
	
	  // also check for already prefixed transitions
	  var unprefixedProperty = (0, _unprefixProperty2.default)(property);
	
	  if (typeof value === 'string' && properties[unprefixedProperty]) {
	    var _ret = function () {
	      // TODO: memoize this array
	      var requiresPrefixDashCased = Object.keys(requiresPrefix).map(function (prop) {
	        return (0, _hyphenateStyleName2.default)(prop);
	      });
	
	      // only split multi values, not cubic beziers
	      var multipleValues = value.split(/,(?![^()]*(?:\([^()]*\))?\))/g);
	
	      requiresPrefixDashCased.forEach(function (prop) {
	        multipleValues.forEach(function (val, index) {
	          if (val.indexOf(prop) > -1 && prop !== 'order') {
	            multipleValues[index] = val.replace(prop, css + prop) + (keepUnprefixed ? ',' + val : '');
	          }
	        });
	      });
	
	      return {
	        v: _defineProperty({}, property, multipleValues.join(','))
	      };
	    }();
	
	    if ((typeof _ret === 'undefined' ? 'undefined' : _typeof(_ret)) === "object") return _ret.v;
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 1639 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (property) {
	  var unprefixed = property.replace(/^(ms|Webkit|Moz|O)/, '');
	  return unprefixed.charAt(0).toLowerCase() + unprefixed.slice(1);
	};
	
	module.exports = exports['default'];

/***/ }),
/* 1640 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = flexboxIE;
	
	var _getPrefixedValue = __webpack_require__(1631);
	
	var _getPrefixedValue2 = _interopRequireDefault(_getPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var alternativeValues = {
	  'space-around': 'distribute',
	  'space-between': 'justify',
	  'flex-start': 'start',
	  'flex-end': 'end',
	  flex: 'flexbox',
	  'inline-flex': 'inline-flexbox'
	};
	var alternativeProps = {
	  alignContent: 'msFlexLinePack',
	  alignSelf: 'msFlexItemAlign',
	  alignItems: 'msFlexAlign',
	  justifyContent: 'msFlexPack',
	  order: 'msFlexOrder',
	  flexGrow: 'msFlexPositive',
	  flexShrink: 'msFlexNegative',
	  flexBasis: 'msPreferredSize'
	};
	
	function flexboxIE(_ref) {
	  var property = _ref.property;
	  var value = _ref.value;
	  var styles = _ref.styles;
	  var _ref$browserInfo = _ref.browserInfo;
	  var browser = _ref$browserInfo.browser;
	  var version = _ref$browserInfo.version;
	  var css = _ref.prefix.css;
	  var keepUnprefixed = _ref.keepUnprefixed;
	
	  if ((alternativeProps[property] || property === 'display' && typeof value === 'string' && value.indexOf('flex') > -1) && (browser === 'ie_mob' || browser === 'ie') && version == 10) {
	    if (!keepUnprefixed && !Array.isArray(styles[property])) {
	      delete styles[property];
	    }
	    if (property === 'display' && alternativeValues[value]) {
	      return {
	        display: (0, _getPrefixedValue2.default)(css + alternativeValues[value], value, keepUnprefixed)
	      };
	    }
	    if (alternativeProps[property]) {
	      return _defineProperty({}, alternativeProps[property], alternativeValues[value] || value);
	    }
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 1641 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = flexboxOld;
	
	var _getPrefixedValue = __webpack_require__(1631);
	
	var _getPrefixedValue2 = _interopRequireDefault(_getPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var alternativeValues = {
	  'space-around': 'justify',
	  'space-between': 'justify',
	  'flex-start': 'start',
	  'flex-end': 'end',
	  'wrap-reverse': 'multiple',
	  wrap: 'multiple',
	  flex: 'box',
	  'inline-flex': 'inline-box'
	};
	
	var alternativeProps = {
	  alignItems: 'WebkitBoxAlign',
	  justifyContent: 'WebkitBoxPack',
	  flexWrap: 'WebkitBoxLines'
	};
	
	var otherProps = ['alignContent', 'alignSelf', 'order', 'flexGrow', 'flexShrink', 'flexBasis', 'flexDirection'];
	var properties = Object.keys(alternativeProps).concat(otherProps);
	
	function flexboxOld(_ref) {
	  var property = _ref.property;
	  var value = _ref.value;
	  var styles = _ref.styles;
	  var _ref$browserInfo = _ref.browserInfo;
	  var browser = _ref$browserInfo.browser;
	  var version = _ref$browserInfo.version;
	  var css = _ref.prefix.css;
	  var keepUnprefixed = _ref.keepUnprefixed;
	
	  if ((properties.indexOf(property) > -1 || property === 'display' && typeof value === 'string' && value.indexOf('flex') > -1) && (browser === 'firefox' && version < 22 || browser === 'chrome' && version < 21 || (browser === 'safari' || browser === 'ios_saf') && version <= 6.1 || browser === 'android' && version < 4.4 || browser === 'and_uc')) {
	    if (!keepUnprefixed && !Array.isArray(styles[property])) {
	      delete styles[property];
	    }
	    if (property === 'flexDirection' && typeof value === 'string') {
	      return {
	        WebkitBoxOrient: value.indexOf('column') > -1 ? 'vertical' : 'horizontal',
	        WebkitBoxDirection: value.indexOf('reverse') > -1 ? 'reverse' : 'normal'
	      };
	    }
	    if (property === 'display' && alternativeValues[value]) {
	      return {
	        display: (0, _getPrefixedValue2.default)(css + alternativeValues[value], value, keepUnprefixed)
	      };
	    }
	    if (alternativeProps[property]) {
	      return _defineProperty({}, alternativeProps[property], alternativeValues[value] || value);
	    }
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 1642 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getStateKey = __webpack_require__(1643);
	
	var _getStateKey2 = _interopRequireDefault(_getStateKey);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getState = function getState(state, elementKey, value) {
	  var key = (0, _getStateKey2.default)(elementKey);
	
	  return !!state && !!state._radiumStyleState && !!state._radiumStyleState[key] && state._radiumStyleState[key][value];
	};
	
	exports.default = getState;
	module.exports = exports['default'];

/***/ }),
/* 1643 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var getStateKey = function getStateKey(elementKey) {
	  return elementKey === null || elementKey === undefined ? 'main' : elementKey.toString();
	};
	
	exports.default = getStateKey;
	module.exports = exports['default'];

/***/ }),
/* 1644 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = hash;
	
	
	// a simple djb2 hash based on hash-string:
	// https://github.com/MatthewBarker/hash-string/blob/master/source/hash-string.js
	// returns a hex-encoded hash
	function hash(text) {
	  if (!text) {
	    return '';
	  }
	
	  var hashValue = 5381;
	  var index = text.length - 1;
	
	  while (index) {
	    hashValue = hashValue * 33 ^ text.charCodeAt(index);
	    index -= 1;
	  }
	
	  return (hashValue >>> 0).toString(16);
	}
	module.exports = exports['default'];

/***/ }),
/* 1645 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.isNestedStyle = isNestedStyle;
	exports.mergeStyles = mergeStyles;
	function isNestedStyle(value) {
	  // Don't merge objects overriding toString, since they should be converted
	  // to string values.
	  return value && value.constructor === Object && value.toString === Object.prototype.toString;
	}
	
	// Merge style objects. Deep merge plain object values.
	function mergeStyles(styles) {
	  var result = {};
	
	  styles.forEach(function (style) {
	    if (!style || (typeof style === 'undefined' ? 'undefined' : _typeof(style)) !== 'object') {
	      return;
	    }
	
	    if (Array.isArray(style)) {
	      style = mergeStyles(style);
	    }
	
	    Object.keys(style).forEach(function (key) {
	      // Simple case, nothing nested
	      if (!isNestedStyle(style[key]) || !isNestedStyle(result[key])) {
	        result[key] = style[key];
	        return;
	      }
	
	      // If nested media, don't merge the nested styles, append a space to the
	      // end (benign when converted to CSS). This way we don't end up merging
	      // media queries that appear later in the chain with those that appear
	      // earlier.
	      if (key.indexOf('@media') === 0) {
	        var newKey = key;
	        // eslint-disable-next-line no-constant-condition
	        while (true) {
	          newKey += ' ';
	          if (!result[newKey]) {
	            result[newKey] = style[key];
	            return;
	          }
	        }
	      }
	
	      // Merge all other nested styles recursively
	      result[key] = mergeStyles([result[key], style[key]]);
	    });
	  });
	
	  return result;
	}

/***/ }),
/* 1646 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _checkPropsPlugin = __webpack_require__(1647);
	
	var _checkPropsPlugin2 = _interopRequireDefault(_checkPropsPlugin);
	
	var _keyframesPlugin = __webpack_require__(1648);
	
	var _keyframesPlugin2 = _interopRequireDefault(_keyframesPlugin);
	
	var _mergeStyleArrayPlugin = __webpack_require__(1649);
	
	var _mergeStyleArrayPlugin2 = _interopRequireDefault(_mergeStyleArrayPlugin);
	
	var _prefixPlugin = __webpack_require__(1650);
	
	var _prefixPlugin2 = _interopRequireDefault(_prefixPlugin);
	
	var _removeNestedStylesPlugin = __webpack_require__(1651);
	
	var _removeNestedStylesPlugin2 = _interopRequireDefault(_removeNestedStylesPlugin);
	
	var _resolveInteractionStylesPlugin = __webpack_require__(1652);
	
	var _resolveInteractionStylesPlugin2 = _interopRequireDefault(_resolveInteractionStylesPlugin);
	
	var _resolveMediaQueriesPlugin = __webpack_require__(1654);
	
	var _resolveMediaQueriesPlugin2 = _interopRequireDefault(_resolveMediaQueriesPlugin);
	
	var _visitedPlugin = __webpack_require__(1655);
	
	var _visitedPlugin2 = _interopRequireDefault(_visitedPlugin);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  checkProps: _checkPropsPlugin2.default,
	  keyframes: _keyframesPlugin2.default,
	  mergeStyleArray: _mergeStyleArrayPlugin2.default,
	  prefix: _prefixPlugin2.default,
	  removeNestedStyles: _removeNestedStylesPlugin2.default,
	  resolveInteractionStyles: _resolveInteractionStylesPlugin2.default,
	  resolveMediaQueries: _resolveMediaQueriesPlugin2.default,
	  visited: _visitedPlugin2.default
	};
	/* eslint-disable block-scoped-const */
	
	module.exports = exports['default'];

/***/ }),
/* 1647 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _checkProps = function checkProps() {};
	
	if (false) {
	  // Warn if you use longhand and shorthand properties in the same style
	  // object.
	  // https://developer.mozilla.org/en-US/docs/Web/CSS/Shorthand_properties
	
	  var shorthandPropertyExpansions = {
	    background: ['backgroundAttachment', 'backgroundBlendMode', 'backgroundClip', 'backgroundColor', 'backgroundImage', 'backgroundOrigin', 'backgroundPosition', 'backgroundPositionX', 'backgroundPositionY', 'backgroundRepeat', 'backgroundRepeatX', 'backgroundRepeatY', 'backgroundSize'],
	    border: ['borderBottom', 'borderBottomColor', 'borderBottomStyle', 'borderBottomWidth', 'borderColor', 'borderLeft', 'borderLeftColor', 'borderLeftStyle', 'borderLeftWidth', 'borderRight', 'borderRightColor', 'borderRightStyle', 'borderRightWidth', 'borderStyle', 'borderTop', 'borderTopColor', 'borderTopStyle', 'borderTopWidth', 'borderWidth'],
	    borderImage: ['borderImageOutset', 'borderImageRepeat', 'borderImageSlice', 'borderImageSource', 'borderImageWidth'],
	    borderRadius: ['borderBottomLeftRadius', 'borderBottomRightRadius', 'borderTopLeftRadius', 'borderTopRightRadius'],
	    font: ['fontFamily', 'fontKerning', 'fontSize', 'fontStretch', 'fontStyle', 'fontVariant', 'fontVariantLigatures', 'fontWeight', 'lineHeight'],
	    listStyle: ['listStyleImage', 'listStylePosition', 'listStyleType'],
	    margin: ['marginBottom', 'marginLeft', 'marginRight', 'marginTop'],
	    padding: ['paddingBottom', 'paddingLeft', 'paddingRight', 'paddingTop'],
	    transition: ['transitionDelay', 'transitionDuration', 'transitionProperty', 'transitionTimingFunction']
	  };
	
	  _checkProps = function checkProps(config) {
	    var componentName = config.componentName,
	        style = config.style;
	
	    if ((typeof style === 'undefined' ? 'undefined' : _typeof(style)) !== 'object' || !style) {
	      return;
	    }
	
	    var styleKeys = Object.keys(style);
	    styleKeys.forEach(function (styleKey) {
	      if (Array.isArray(shorthandPropertyExpansions[styleKey]) && shorthandPropertyExpansions[styleKey].some(function (sp) {
	        return styleKeys.indexOf(sp) !== -1;
	      })) {
	        if (process.env.NODE_ENV !== 'production') {
	          /* eslint-disable no-console */
	          console.warn('Radium: property "' + styleKey + '" in style object', style, ': do not mix longhand and ' + 'shorthand properties in the same style object. Check the render ' + 'method of ' + componentName + '.', 'See https://github.com/FormidableLabs/radium/issues/95 for more ' + 'information.');
	          /* eslint-enable no-console */
	        }
	      }
	    });
	
	    styleKeys.forEach(function (k) {
	      return _checkProps(_extends({}, config, { style: style[k] }));
	    });
	    return;
	  };
	}
	
	exports.default = _checkProps;
	module.exports = exports['default'];

/***/ }),
/* 1648 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = keyframesPlugin;
	function keyframesPlugin(_ref) {
	  var addCSS = _ref.addCSS,
	      config = _ref.config,
	      style = _ref.style;
	
	  var newStyle = Object.keys(style).reduce(function (newStyleInProgress, key) {
	    var value = style[key];
	    if (key === 'animationName' && value && value.__radiumKeyframes) {
	      var keyframesValue = value;
	
	      var _keyframesValue$__pro = keyframesValue.__process(config.userAgent),
	          animationName = _keyframesValue$__pro.animationName,
	          css = _keyframesValue$__pro.css;
	
	      addCSS(css);
	      value = animationName;
	    }
	
	    newStyleInProgress[key] = value;
	    return newStyleInProgress;
	  }, {});
	  return { style: newStyle };
	}
	module.exports = exports['default'];

/***/ }),
/* 1649 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	
	// Convenient syntax for multiple styles: `style={[style1, style2, etc]}`
	// Ignores non-objects, so you can do `this.state.isCool && styles.cool`.
	var mergeStyleArrayPlugin = function mergeStyleArrayPlugin(_ref) {
	  var style = _ref.style,
	      mergeStyles = _ref.mergeStyles;
	
	  // eslint-disable-line no-shadow
	  var newStyle = Array.isArray(style) ? mergeStyles(style) : style;
	  return { style: newStyle };
	};
	
	exports.default = mergeStyleArrayPlugin;
	module.exports = exports['default'];

/***/ }),
/* 1650 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = prefixPlugin;
	
	var _prefixer = __webpack_require__(1609);
	
	function prefixPlugin(_ref) {
	  var config = _ref.config,
	      style = _ref.style;
	
	  var newStyle = (0, _prefixer.getPrefixedStyle)(style, config.userAgent);
	  return { style: newStyle };
	}
	module.exports = exports['default'];

/***/ }),
/* 1651 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = removeNestedStyles;
	function removeNestedStyles(_ref) {
	  var isNestedStyle = _ref.isNestedStyle,
	      style = _ref.style;
	
	  // eslint-disable-line no-shadow
	  var newStyle = Object.keys(style).reduce(function (newStyleInProgress, key) {
	    var value = style[key];
	    if (!isNestedStyle(value)) {
	      newStyleInProgress[key] = value;
	    }
	    return newStyleInProgress;
	  }, {});
	
	  return {
	    style: newStyle
	  };
	}
	
	module.exports = exports['default'];

/***/ }),
/* 1652 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _mouseUpListener = __webpack_require__(1653);
	
	var _mouseUpListener2 = _interopRequireDefault(_mouseUpListener);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _isInteractiveStyleField = function _isInteractiveStyleField(styleFieldName) {
	  return styleFieldName === ':hover' || styleFieldName === ':active' || styleFieldName === ':focus';
	};
	
	var resolveInteractionStyles = function resolveInteractionStyles(config) {
	  var ExecutionEnvironment = config.ExecutionEnvironment,
	      getComponentField = config.getComponentField,
	      getState = config.getState,
	      mergeStyles = config.mergeStyles,
	      props = config.props,
	      setState = config.setState,
	      style = config.style;
	
	
	  var newComponentFields = {};
	  var newProps = {};
	
	  // Only add handlers if necessary
	  if (style[':hover']) {
	    // Always call the existing handler if one is already defined.
	    // This code, and the very similar ones below, could be abstracted a bit
	    // more, but it hurts readability IMO.
	    var existingOnMouseEnter = props.onMouseEnter;
	    newProps.onMouseEnter = function (e) {
	      existingOnMouseEnter && existingOnMouseEnter(e);
	      setState(':hover', true);
	    };
	
	    var existingOnMouseLeave = props.onMouseLeave;
	    newProps.onMouseLeave = function (e) {
	      existingOnMouseLeave && existingOnMouseLeave(e);
	      setState(':hover', false);
	    };
	  }
	
	  if (style[':active']) {
	    var existingOnMouseDown = props.onMouseDown;
	    newProps.onMouseDown = function (e) {
	      existingOnMouseDown && existingOnMouseDown(e);
	      newComponentFields._lastMouseDown = Date.now();
	      setState(':active', 'viamousedown');
	    };
	
	    var existingOnKeyDown = props.onKeyDown;
	    newProps.onKeyDown = function (e) {
	      existingOnKeyDown && existingOnKeyDown(e);
	      if (e.key === ' ' || e.key === 'Enter') {
	        setState(':active', 'viakeydown');
	      }
	    };
	
	    var existingOnKeyUp = props.onKeyUp;
	    newProps.onKeyUp = function (e) {
	      existingOnKeyUp && existingOnKeyUp(e);
	      if (e.key === ' ' || e.key === 'Enter') {
	        setState(':active', false);
	      }
	    };
	  }
	
	  if (style[':focus']) {
	    var existingOnFocus = props.onFocus;
	    newProps.onFocus = function (e) {
	      existingOnFocus && existingOnFocus(e);
	      setState(':focus', true);
	    };
	
	    var existingOnBlur = props.onBlur;
	    newProps.onBlur = function (e) {
	      existingOnBlur && existingOnBlur(e);
	      setState(':focus', false);
	    };
	  }
	
	  if (style[':active'] && !getComponentField('_radiumMouseUpListener') && ExecutionEnvironment.canUseEventListeners) {
	    newComponentFields._radiumMouseUpListener = _mouseUpListener2.default.subscribe(function () {
	      Object.keys(getComponentField('state')._radiumStyleState).forEach(function (key) {
	        if (getState(':active', key) === 'viamousedown') {
	          setState(':active', false, key);
	        }
	      });
	    });
	  }
	
	  // Merge the styles in the order they were defined
	  var interactionStyles = props.disabled ? [style[':disabled']] : Object.keys(style).filter(function (name) {
	    return _isInteractiveStyleField(name) && getState(name);
	  }).map(function (name) {
	    return style[name];
	  });
	
	  var newStyle = mergeStyles([style].concat(interactionStyles));
	
	  // Remove interactive styles
	  newStyle = Object.keys(newStyle).reduce(function (styleWithoutInteractions, name) {
	    if (!_isInteractiveStyleField(name) && name !== ':disabled') {
	      styleWithoutInteractions[name] = newStyle[name];
	    }
	    return styleWithoutInteractions;
	  }, {});
	
	  return {
	    componentFields: newComponentFields,
	    props: newProps,
	    style: newStyle
	  };
	};
	
	exports.default = resolveInteractionStyles;
	module.exports = exports['default'];

/***/ }),
/* 1653 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var _callbacks = [];
	var _mouseUpListenerIsActive = false;
	
	function _handleMouseUp() {
	  _callbacks.forEach(function (callback) {
	    callback();
	  });
	}
	
	var subscribe = function subscribe(callback) {
	  if (_callbacks.indexOf(callback) === -1) {
	    _callbacks.push(callback);
	  }
	
	  if (!_mouseUpListenerIsActive) {
	    window.addEventListener('mouseup', _handleMouseUp);
	    _mouseUpListenerIsActive = true;
	  }
	
	  return {
	    remove: function remove() {
	      var index = _callbacks.indexOf(callback);
	      _callbacks.splice(index, 1);
	
	      if (_callbacks.length === 0 && _mouseUpListenerIsActive) {
	        window.removeEventListener('mouseup', _handleMouseUp);
	        _mouseUpListenerIsActive = false;
	      }
	    }
	  };
	};
	
	exports.default = {
	  subscribe: subscribe,
	  __triggerForTests: _handleMouseUp
	};
	module.exports = exports['default'];

/***/ }),
/* 1654 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = resolveMediaQueries;
	var _windowMatchMedia = void 0;
	function _getWindowMatchMedia(ExecutionEnvironment) {
	  if (_windowMatchMedia === undefined) {
	    _windowMatchMedia = !!ExecutionEnvironment.canUseDOM && !!window && !!window.matchMedia && function (mediaQueryString) {
	      return window.matchMedia(mediaQueryString);
	    } || null;
	  }
	  return _windowMatchMedia;
	}
	
	function _filterObject(obj, predicate) {
	  return Object.keys(obj).filter(function (key) {
	    return predicate(obj[key], key);
	  }).reduce(function (result, key) {
	    result[key] = obj[key];
	    return result;
	  }, {});
	}
	
	function _removeMediaQueries(style) {
	  return Object.keys(style).reduce(function (styleWithoutMedia, key) {
	    if (key.indexOf('@media') !== 0) {
	      styleWithoutMedia[key] = style[key];
	    }
	    return styleWithoutMedia;
	  }, {});
	}
	
	function _topLevelRulesToCSS(_ref) {
	  var addCSS = _ref.addCSS,
	      appendImportantToEachValue = _ref.appendImportantToEachValue,
	      cssRuleSetToString = _ref.cssRuleSetToString,
	      hash = _ref.hash,
	      isNestedStyle = _ref.isNestedStyle,
	      style = _ref.style,
	      userAgent = _ref.userAgent;
	
	  var className = '';
	  Object.keys(style).filter(function (name) {
	    return name.indexOf('@media') === 0;
	  }).map(function (query) {
	    var topLevelRules = appendImportantToEachValue(_filterObject(style[query], function (value) {
	      return !isNestedStyle(value);
	    }));
	
	    if (!Object.keys(topLevelRules).length) {
	      return;
	    }
	
	    var ruleCSS = cssRuleSetToString('', topLevelRules, userAgent);
	
	    // CSS classes cannot start with a number
	    var mediaQueryClassName = 'rmq-' + hash(query + ruleCSS);
	    var css = query + '{ .' + mediaQueryClassName + ruleCSS + '}';
	
	    addCSS(css);
	
	    className += (className ? ' ' : '') + mediaQueryClassName;
	  });
	  return className;
	}
	
	function _subscribeToMediaQuery(_ref2) {
	  var listener = _ref2.listener,
	      listenersByQuery = _ref2.listenersByQuery,
	      matchMedia = _ref2.matchMedia,
	      mediaQueryListsByQuery = _ref2.mediaQueryListsByQuery,
	      query = _ref2.query;
	
	  query = query.replace('@media ', '');
	
	  var mql = mediaQueryListsByQuery[query];
	  if (!mql && matchMedia) {
	    mediaQueryListsByQuery[query] = mql = matchMedia(query);
	  }
	
	  if (!listenersByQuery || !listenersByQuery[query]) {
	    mql.addListener(listener);
	
	    listenersByQuery[query] = {
	      remove: function remove() {
	        mql.removeListener(listener);
	      }
	    };
	  }
	  return mql;
	}
	
	function resolveMediaQueries(_ref3) {
	  var ExecutionEnvironment = _ref3.ExecutionEnvironment,
	      addCSS = _ref3.addCSS,
	      appendImportantToEachValue = _ref3.appendImportantToEachValue,
	      config = _ref3.config,
	      cssRuleSetToString = _ref3.cssRuleSetToString,
	      getComponentField = _ref3.getComponentField,
	      getGlobalState = _ref3.getGlobalState,
	      hash = _ref3.hash,
	      isNestedStyle = _ref3.isNestedStyle,
	      mergeStyles = _ref3.mergeStyles,
	      props = _ref3.props,
	      setState = _ref3.setState,
	      style = _ref3.style;
	
	  // eslint-disable-line no-shadow
	  var newStyle = _removeMediaQueries(style);
	  var mediaQueryClassNames = _topLevelRulesToCSS({
	    addCSS: addCSS,
	    appendImportantToEachValue: appendImportantToEachValue,
	    cssRuleSetToString: cssRuleSetToString,
	    hash: hash,
	    isNestedStyle: isNestedStyle,
	    style: style,
	    userAgent: config.userAgent
	  });
	
	  var newProps = mediaQueryClassNames ? {
	    className: mediaQueryClassNames + (props.className ? ' ' + props.className : '')
	  } : null;
	
	  var matchMedia = config.matchMedia || _getWindowMatchMedia(ExecutionEnvironment);
	
	  if (!matchMedia) {
	    return {
	      props: newProps,
	      style: newStyle
	    };
	  }
	
	  var listenersByQuery = _extends({}, getComponentField('_radiumMediaQueryListenersByQuery'));
	  var mediaQueryListsByQuery = getGlobalState('mediaQueryListsByQuery') || {};
	
	  Object.keys(style).filter(function (name) {
	    return name.indexOf('@media') === 0;
	  }).map(function (query) {
	    var nestedRules = _filterObject(style[query], isNestedStyle);
	
	    if (!Object.keys(nestedRules).length) {
	      return;
	    }
	
	    var mql = _subscribeToMediaQuery({
	      listener: function listener() {
	        return setState(query, mql.matches, '_all');
	      },
	      listenersByQuery: listenersByQuery,
	      matchMedia: matchMedia,
	      mediaQueryListsByQuery: mediaQueryListsByQuery,
	      query: query
	    });
	
	    // Apply media query states
	    if (mql.matches) {
	      newStyle = mergeStyles([newStyle, nestedRules]);
	    }
	  });
	
	  return {
	    componentFields: {
	      _radiumMediaQueryListenersByQuery: listenersByQuery
	    },
	    globalState: { mediaQueryListsByQuery: mediaQueryListsByQuery },
	    props: newProps,
	    style: newStyle
	  };
	}
	module.exports = exports['default'];

/***/ }),
/* 1655 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = visited;
	function visited(_ref) {
	  var addCSS = _ref.addCSS,
	      appendImportantToEachValue = _ref.appendImportantToEachValue,
	      config = _ref.config,
	      cssRuleSetToString = _ref.cssRuleSetToString,
	      hash = _ref.hash,
	      props = _ref.props,
	      style = _ref.style;
	
	  // eslint-disable-line no-shadow
	  var className = props.className;
	
	  var newStyle = Object.keys(style).reduce(function (newStyleInProgress, key) {
	    var value = style[key];
	    if (key === ':visited') {
	      value = appendImportantToEachValue(value);
	      var ruleCSS = cssRuleSetToString('', value, config.userAgent);
	      var visitedClassName = 'rad-' + hash(ruleCSS);
	      var css = '.' + visitedClassName + ':visited' + ruleCSS;
	
	      addCSS(css);
	      className = (className ? className + ' ' : '') + visitedClassName;
	    } else {
	      newStyleInProgress[key] = value;
	    }
	
	    return newStyleInProgress;
	  }, {});
	
	  return {
	    props: className === props.className ? null : { className: className },
	    style: newStyle
	  };
	}
	
	module.exports = exports['default'];

/***/ }),
/* 1656 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2015 Jed Watson.
	  Based on code that is Copyright 2013-2015, Facebook, Inc.
	  All rights reserved.
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var canUseDOM = !!(
			typeof window !== 'undefined' &&
			window.document &&
			window.document.createElement
		);
	
		var ExecutionEnvironment = {
	
			canUseDOM: canUseDOM,
	
			canUseWorkers: typeof Worker !== 'undefined',
	
			canUseEventListeners:
				canUseDOM && !!(window.addEventListener || window.attachEvent),
	
			canUseViewport: canUseDOM && !!window.screen
	
		};
	
		if (true) {
			!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return ExecutionEnvironment;
			}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if (typeof module !== 'undefined' && module.exports) {
			module.exports = ExecutionEnvironment;
		} else {
			window.ExecutionEnvironment = ExecutionEnvironment;
		}
	
	}());


/***/ }),
/* 1657 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _class, _temp;
	
	var _cssRuleSetToString = __webpack_require__(1607);
	
	var _cssRuleSetToString2 = _interopRequireDefault(_cssRuleSetToString);
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(956);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Style = (_temp = _class = function (_PureComponent) {
	  _inherits(Style, _PureComponent);
	
	  function Style() {
	    _classCallCheck(this, Style);
	
	    return _possibleConstructorReturn(this, _PureComponent.apply(this, arguments));
	  }
	
	  Style.prototype._buildStyles = function _buildStyles(styles) {
	    var _this2 = this;
	
	    var userAgent = this.props.radiumConfig && this.props.radiumConfig.userAgent || this.context && this.context._radiumConfig && this.context._radiumConfig.userAgent;
	
	    var scopeSelector = this.props.scopeSelector;
	
	    var rootRules = Object.keys(styles).reduce(function (accumulator, selector) {
	      if (_typeof(styles[selector]) !== 'object') {
	        accumulator[selector] = styles[selector];
	      }
	
	      return accumulator;
	    }, {});
	    var rootStyles = Object.keys(rootRules).length ? (0, _cssRuleSetToString2.default)(scopeSelector || '', rootRules, userAgent) : '';
	
	    return rootStyles + Object.keys(styles).reduce(function (accumulator, selector) {
	      var rules = styles[selector];
	
	      if (selector === 'mediaQueries') {
	        accumulator += _this2._buildMediaQueryString(rules);
	      } else if (_typeof(styles[selector]) === 'object') {
	        var completeSelector = scopeSelector ? selector.split(',').map(function (part) {
	          return scopeSelector + ' ' + part.trim();
	        }).join(',') : selector;
	
	        accumulator += (0, _cssRuleSetToString2.default)(completeSelector, rules, userAgent);
	      }
	
	      return accumulator;
	    }, '');
	  };
	
	  Style.prototype._buildMediaQueryString = function _buildMediaQueryString(stylesByMediaQuery) {
	    var _this3 = this;
	
	    var mediaQueryString = '';
	
	    Object.keys(stylesByMediaQuery).forEach(function (query) {
	      mediaQueryString += '@media ' + query + '{' + _this3._buildStyles(stylesByMediaQuery[query]) + '}';
	    });
	
	    return mediaQueryString;
	  };
	
	  Style.prototype.render = function render() {
	    if (!this.props.rules) {
	      return null;
	    }
	
	    var styles = this._buildStyles(this.props.rules);
	
	    return _react2.default.createElement('style', { dangerouslySetInnerHTML: { __html: styles } });
	  };
	
	  return Style;
	}(_react.PureComponent), _class.propTypes = {
	  radiumConfig: _propTypes2.default.object,
	  rules: _propTypes2.default.object,
	  scopeSelector: _propTypes2.default.string
	}, _class.contextTypes = {
	  _radiumConfig: _propTypes2.default.object
	}, _class.defaultProps = {
	  scopeSelector: ''
	}, _temp);
	exports.default = Style;
	module.exports = exports['default'];

/***/ }),
/* 1658 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(956);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _enhancer = __webpack_require__(1601);
	
	var _enhancer2 = _interopRequireDefault(_enhancer);
	
	var _styleKeeper = __webpack_require__(1602);
	
	var _styleKeeper2 = _interopRequireDefault(_styleKeeper);
	
	var _styleSheet = __webpack_require__(1659);
	
	var _styleSheet2 = _interopRequireDefault(_styleSheet);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _getStyleKeeper(instance) {
	  if (!instance._radiumStyleKeeper) {
	    var userAgent = instance.props.radiumConfig && instance.props.radiumConfig.userAgent || instance.context._radiumConfig && instance.context._radiumConfig.userAgent;
	    instance._radiumStyleKeeper = new _styleKeeper2.default(userAgent);
	  }
	
	  return instance._radiumStyleKeeper;
	}
	
	var StyleRoot = function (_PureComponent) {
	  _inherits(StyleRoot, _PureComponent);
	
	  function StyleRoot() {
	    _classCallCheck(this, StyleRoot);
	
	    var _this = _possibleConstructorReturn(this, _PureComponent.apply(this, arguments));
	
	    _getStyleKeeper(_this);
	    return _this;
	  }
	
	  StyleRoot.prototype.getChildContext = function getChildContext() {
	    return { _radiumStyleKeeper: _getStyleKeeper(this) };
	  };
	
	  StyleRoot.prototype.render = function render() {
	    /* eslint-disable no-unused-vars */
	    // Pass down all props except config to the rendered div.
	    var _props = this.props,
	        radiumConfig = _props.radiumConfig,
	        otherProps = _objectWithoutProperties(_props, ['radiumConfig']);
	    /* eslint-enable no-unused-vars */
	
	    return _react2.default.createElement(
	      'div',
	      otherProps,
	      this.props.children,
	      _react2.default.createElement(_styleSheet2.default, null)
	    );
	  };
	
	  return StyleRoot;
	}(_react.PureComponent);
	
	StyleRoot.contextTypes = {
	  _radiumConfig: _propTypes2.default.object,
	  _radiumStyleKeeper: _propTypes2.default.instanceOf(_styleKeeper2.default)
	};
	
	StyleRoot.childContextTypes = {
	  _radiumStyleKeeper: _propTypes2.default.instanceOf(_styleKeeper2.default)
	};
	
	StyleRoot = (0, _enhancer2.default)(StyleRoot);
	
	exports.default = StyleRoot;
	module.exports = exports['default'];

/***/ }),
/* 1659 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _class, _temp;
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(956);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styleKeeper = __webpack_require__(1602);
	
	var _styleKeeper2 = _interopRequireDefault(_styleKeeper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var StyleSheet = (_temp = _class = function (_PureComponent) {
	  _inherits(StyleSheet, _PureComponent);
	
	  function StyleSheet() {
	    _classCallCheck(this, StyleSheet);
	
	    var _this = _possibleConstructorReturn(this, _PureComponent.apply(this, arguments));
	
	    _this._onChange = function () {
	      setTimeout(function () {
	        _this._isMounted && _this.setState(_this._getCSSState());
	      }, 0);
	    };
	
	    _this.state = _this._getCSSState();
	    return _this;
	  }
	
	  StyleSheet.prototype.componentDidMount = function componentDidMount() {
	    this._isMounted = true;
	    this._subscription = this.context._radiumStyleKeeper.subscribe(this._onChange);
	    this._onChange();
	  };
	
	  StyleSheet.prototype.componentWillUnmount = function componentWillUnmount() {
	    this._isMounted = false;
	    if (this._subscription) {
	      this._subscription.remove();
	    }
	  };
	
	  StyleSheet.prototype._getCSSState = function _getCSSState() {
	    return { css: this.context._radiumStyleKeeper.getCSS() };
	  };
	
	  StyleSheet.prototype.render = function render() {
	    return _react2.default.createElement('style', { dangerouslySetInnerHTML: { __html: this.state.css } });
	  };
	
	  return StyleSheet;
	}(_react.PureComponent), _class.contextTypes = {
	  _radiumStyleKeeper: _propTypes2.default.instanceOf(_styleKeeper2.default)
	}, _temp);
	exports.default = StyleSheet;
	module.exports = exports['default'];

/***/ }),
/* 1660 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = keyframes;
	
	var _cssRuleSetToString = __webpack_require__(1607);
	
	var _cssRuleSetToString2 = _interopRequireDefault(_cssRuleSetToString);
	
	var _hash = __webpack_require__(1644);
	
	var _hash2 = _interopRequireDefault(_hash);
	
	var _prefixer = __webpack_require__(1609);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function keyframes(keyframeRules, name) {
	  return {
	    __radiumKeyframes: true,
	    __process: function __process(userAgent) {
	      var keyframesPrefixed = (0, _prefixer.getPrefixedKeyframes)(userAgent);
	      var rules = Object.keys(keyframeRules).map(function (percentage) {
	        return (0, _cssRuleSetToString2.default)(percentage, keyframeRules[percentage], userAgent);
	      }).join('\n');
	      var animationName = (name ? name + '-' : '') + 'radium-animation-' + (0, _hash2.default)(rules);
	      var css = '@' + keyframesPrefixed + ' ' + animationName + ' {\n' + rules + '\n}\n';
	      return { css: css, animationName: animationName };
	    }
	  };
	}
	
	module.exports = exports['default'];

/***/ }),
/* 1661 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(608);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(615);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionInfo = function ActionInfo(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z' })
	  );
	};
	ActionInfo = (0, _pure2.default)(ActionInfo);
	ActionInfo.displayName = 'ActionInfo';
	ActionInfo.muiName = 'SvgIcon';
	
	exports.default = ActionInfo;

/***/ }),
/* 1662 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _materialUi = __webpack_require__(576);
	
	var _reactRouter = __webpack_require__(486);
	
	var _connectToStores = __webpack_require__(1226);
	
	var _connectToStores2 = _interopRequireDefault(_connectToStores);
	
	var _UserActions = __webpack_require__(1158);
	
	var _UserActions2 = _interopRequireDefault(_UserActions);
	
	var _UserStore = __webpack_require__(974);
	
	var _UserStore2 = _interopRequireDefault(_UserStore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Activate = function (_React$Component) {
	  _inherits(Activate, _React$Component);
	
	  function Activate(props) {
	    _classCallCheck(this, Activate);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(Activate).call(this, props));
	
	    _this.state = {
	      username: "",
	      password: "",
	      confirmPassword: "",
	      hasStartedConfirming: false,
	      activating: false
	    };
	
	    _this._activate = _this._activate.bind(_this);
	    return _this;
	  }
	
	  _createClass(Activate, [{
	    key: "_activate",
	    value: function _activate() {
	      this.setState({ activating: true });
	      _UserActions2.default.edit({ password: this.state.password });
	    }
	  }, {
	    key: "componentWillMount",
	    value: function componentWillMount() {
	      _UserActions2.default.logout.defer( /* noRedirect */true);
	
	      try {
	        var _atob$split = atob(this.props.location.query.token).split(";");
	
	        var _atob$split2 = _slicedToArray(_atob$split, 2);
	
	        var username = _atob$split2[0];
	        var password = _atob$split2[1];
	
	        this.setState({ username: username });
	        _UserActions2.default.login.defer(username, password, /* noRedirect */true);
	      } catch (e) {
	        _UserActions2.default.editFailed(e);
	      }
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(newProps) {
	      if (this.state.activating && newProps.isLoggedIn) {
	        this.context.router.push("/welcome");
	      }
	    }
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      if (this.field) {
	        this.field.focus();
	      }
	    }
	  }, {
	    key: "getStyles",
	    value: function getStyles() {
	      return {
	        container: {
	          margin: "20px auto",
	          marginTop: "10%",
	          width: 270
	        },
	        actions: {
	          marginTop: 10,
	          textAlign: "center"
	        },
	        terms: {
	          marginTop: "1em",
	          textAlign: "center",
	          fontSize: "1em",
	          lineHeight: 1.5,
	          color: "#a7a7a7"
	        },
	        termsLink: {
	          color: "#8a8a8a"
	        },
	        error: {
	          color: "#FF4136"
	        }
	      };
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var styles = this.getStyles(),
	          error = this.props.loginErrorMessage || this.props.editErrorMessage;
	
	      if (error && error.indexOf("Invalid password") !== -1) {
	        return _react2.default.createElement(
	          "div",
	          { style: Object.assign({}, styles.container, styles.error) },
	          "This account has already been activated.",
	          " ",
	          _react2.default.createElement(
	            _reactRouter.Link,
	            {
	              to: {
	                pathname: "/login",
	                state: { username: this.state.username, clearErrors: true }
	              }
	            },
	            "Login\xA0instead."
	          )
	        );
	      }
	
	      return _react2.default.createElement(
	        "div",
	        { style: styles.container },
	        error ? _react2.default.createElement(
	          "div",
	          { style: styles.error },
	          "Failed to activate account: ",
	          error
	        ) : _react2.default.createElement(
	          "div",
	          null,
	          "Welcome to Eventive! To continue, please set a password for your account."
	        ),
	        _react2.default.createElement(
	          "form",
	          null,
	          _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(_materialUi.TextField, {
	              floatingLabelText: "Email address",
	              value: this.state.username,
	              disabled: true
	            })
	          ),
	          _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(_materialUi.TextField, {
	              ref: function ref(r) {
	                _this2.field = r;
	              },
	              floatingLabelText: "New password",
	              floatingLabelFixed: true,
	              value: this.state.password,
	              onChange: function onChange(e) {
	                return _this2.setState({ password: e.target.value });
	              },
	              type: "password",
	              disabled: this.props.editInProgress
	            })
	          ),
	          _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(_materialUi.TextField, {
	              floatingLabelText: "Confirm new password",
	              floatingLabelFixed: true,
	              value: this.state.confirmPassword,
	              onChange: function onChange(e) {
	                return _this2.setState({
	                  hasStartedConfirming: true,
	                  confirmPassword: e.target.value
	                });
	              },
	              onKeyDown: function onKeyDown(e) {
	                if (e.keyCode === 13) _this2._activate();
	              },
	              errorText: this.state.hasStartedConfirming && this.state.password !== this.state.confirmPassword ? "The passwords do not match." : null,
	              type: "password",
	              disabled: this.props.editInProgress
	            })
	          ),
	          _react2.default.createElement(
	            "div",
	            { style: styles.actions },
	            _react2.default.createElement(_materialUi.RaisedButton, {
	              label: this.props.editInProgress ? "Activating..." : "Activate account",
	              disabled: this.props.editInProgress || !this.state.password || this.state.password !== this.state.confirmPassword,
	              primary: true,
	              onTouchTap: this._activate
	            })
	          ),
	          _react2.default.createElement(
	            "div",
	            { style: styles.terms },
	            "By activating your account, you agree to the Eventive",
	            " ",
	            _react2.default.createElement(
	              "a",
	              {
	                href: "https://eventive.org/terms",
	                target: "_blank",
	                style: styles.termsLink
	              },
	              "Terms of Service"
	            ),
	            " ",
	            "and",
	            " ",
	            _react2.default.createElement(
	              "a",
	              {
	                href: "https://eventive.org/privacy",
	                target: "_blank",
	                style: styles.termsLink
	              },
	              "Privacy\xA0Policy"
	            ),
	            "."
	          )
	        )
	      );
	    }
	  }], [{
	    key: "getStores",
	    value: function getStores() {
	      return [_UserStore2.default];
	    }
	  }, {
	    key: "getPropsFromStores",
	    value: function getPropsFromStores() {
	      return _UserStore2.default.getState();
	    }
	  }, {
	    key: "contextTypes",
	    get: function get() {
	      return {
	        router: _react2.default.PropTypes.object.isRequired
	      };
	    }
	  }]);
	
	  return Activate;
	}(_react2.default.Component);
	
	exports.default = (0, _connectToStores2.default)(Activate);
	module.exports = exports["default"];

/***/ }),
/* 1663 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _materialUi = __webpack_require__(576);
	
	var _reactRouter = __webpack_require__(486);
	
	var _workingIndicator = __webpack_require__(1664);
	
	var _workingIndicator2 = _interopRequireDefault(_workingIndicator);
	
	var _connectToStores = __webpack_require__(1226);
	
	var _connectToStores2 = _interopRequireDefault(_connectToStores);
	
	var _UserActions = __webpack_require__(1158);
	
	var _UserActions2 = _interopRequireDefault(_UserActions);
	
	var _UserStore = __webpack_require__(974);
	
	var _UserStore2 = _interopRequireDefault(_UserStore);
	
	var _TitleActions = __webpack_require__(1665);
	
	var _TitleActions2 = _interopRequireDefault(_TitleActions);
	
	var _TitleStore = __webpack_require__(1666);
	
	var _TitleStore2 = _interopRequireDefault(_TitleStore);
	
	var _linkLike = __webpack_require__(973);
	
	var _linkLike2 = _interopRequireDefault(_linkLike);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AcceptCreatorInvite = function (_React$Component) {
	  _inherits(AcceptCreatorInvite, _React$Component);
	
	  function AcceptCreatorInvite(props) {
	    _classCallCheck(this, AcceptCreatorInvite);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(AcceptCreatorInvite).call(this, props));
	
	    _this.state = {
	      username: "",
	      name: "",
	      organization: "",
	      password: "",
	      confirmPassword: "",
	      hasStartedConfirming: false,
	      activating: false
	    };
	
	    _this._signup = _this._signup.bind(_this);
	    _this._accept = _this._accept.bind(_this);
	    return _this;
	  }
	
	  _createClass(AcceptCreatorInvite, [{
	    key: "_signup",
	    value: function _signup() {
	      this.setState({ activating: true });
	      _UserActions2.default.userSignup({
	        type: "content_creator",
	        email: this.state.username,
	        password: this.state.password,
	        name: this.state.name,
	        organization: this.state.organization
	      });
	    }
	  }, {
	    key: "_accept",
	    value: function _accept(title) {
	      _UserActions2.default.acceptContentCreatorInvite({
	        token: this.props.location.query.token,
	        title: title
	      });
	    }
	  }, {
	    key: "componentWillMount",
	    value: function componentWillMount() {
	      if (this.props.isLoggedIn) {
	        _TitleActions2.default.fetchAll();
	      }
	      _UserActions2.default.lookupContentCreatorInvite(this.props.location.query.token);
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(newProps) {
	      var invite = newProps.contentCreatorInvites[this.props.location.query.token];
	
	      if (invite && invite.email && !this.state.username) {
	        this.setState({ username: invite.email });
	      }
	
	      // Fetch titles for title_requested_media mode
	      if (newProps.isLoggedIn && !this.props.isLoggedIn) {
	        _TitleActions2.default.fetchAll.defer();
	      }
	    }
	  }, {
	    key: "getStyles",
	    value: function getStyles() {
	      return {
	        container: {
	          margin: "10% auto 5%",
	          width: 375,
	          fontSize: "11pt",
	          textAlign: "center"
	        },
	        bodyText: {
	          textAlign: "left",
	          marginBottom: "0.5em"
	        },
	        actions: {
	          marginTop: "1em",
	          textAlign: "center"
	        },
	        terms: {
	          textAlign: "center",
	          fontSize: "10pt",
	          lineHeight: 1.5,
	          color: "#a7a7a7",
	          maxWidth: 270,
	          margin: "1em auto 0"
	        },
	        termsLink: {
	          color: "#8a8a8a"
	        },
	        error: {
	          color: "#FF4136"
	        }
	      };
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var styles = this.getStyles();
	      var error = this.props.loginErrorMessage;
	
	      var invite = this.props.contentCreatorInvites[this.props.location.query.token];
	
	      var userTitles = _TitleStore2.default.getTitles();
	
	      if (!invite && this.props.contentCreatorInviteLookupErrorMessage) {
	        return _react2.default.createElement(
	          "div",
	          { style: styles.container },
	          _react2.default.createElement(
	            "div",
	            { style: styles.error },
	            _react2.default.createElement(
	              "p",
	              null,
	              "Failed to accept invite: This invite may have been revoked, or perhaps has already been accepted."
	            ),
	            " ",
	            _react2.default.createElement(
	              "p",
	              null,
	              "Please try",
	              " ",
	              _react2.default.createElement(
	                _reactRouter.Link,
	                {
	                  to: {
	                    pathname: "/login"
	                  },
	                  style: styles.alreadyHaveAccount
	                },
	                "logging in"
	              ),
	              " ",
	              "instead, or",
	              " ",
	              _react2.default.createElement(
	                _linkLike2.default,
	                {
	                  onTouchTap: function onTouchTap() {
	                    return Intercom("showNewMessage", "I am having trouble accepting a Content Creator invitation. My name, organization, and film are: ");
	                  }
	                },
	                "send us a message"
	              ),
	              "."
	            )
	          )
	        );
	      }
	
	      if (!invite) {
	        return _react2.default.createElement(_workingIndicator2.default, { fullPage: true, style: { margin: "10% auto" } });
	      }
	
	      if (this.props.isLoggedIn) {
	        return _react2.default.createElement(
	          "div",
	          { style: _extends({}, styles.container, { textAlign: "center" }) },
	          _react2.default.createElement(
	            "div",
	            { style: { marginBottom: "1em" } },
	            _react2.default.createElement(
	              "strong",
	              null,
	              invite.user_name
	            ),
	            " has invited you to",
	            " ",
	            invite.title_requested_media ? "deliver assets" : "upload content",
	            " ",
	            "for ",
	            _react2.default.createElement(
	              "strong",
	              null,
	              invite.film_name
	            ),
	            ", screening within",
	            " ",
	            _react2.default.createElement(
	              "strong",
	              null,
	              invite.event_bucket_name
	            ),
	            "."
	          ),
	          invite.title_requested_media ? _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(
	              "div",
	              { style: { marginBottom: "1em" } },
	              "You can fulfill this asset request using a title from your Eventive account. Please select an existing title, or create a new one."
	            ),
	            _react2.default.createElement(
	              "div",
	              { style: { marginBottom: "2em" } },
	              _TitleStore2.default.getState().isFetching ? _react2.default.createElement(
	                "div",
	                { style: { fontStyle: "italic", marginBottom: 10 } },
	                "Loading your titles..."
	              ) : _react2.default.createElement(
	                "div",
	                null,
	                userTitles.length === 0 ? _react2.default.createElement(
	                  "div",
	                  { style: { fontStyle: "italic", marginBottom: 10 } },
	                  "No existing titles found."
	                ) : null,
	                userTitles.sort(function (a, b) {
	                  return a.name.localeCompare(b.name);
	                }).concat([{ id: "new", new: true }]).map(function (title) {
	                  return _react2.default.createElement(
	                    "div",
	                    { key: title.id, style: { marginBottom: "1em" } },
	                    _react2.default.createElement(_materialUi.RaisedButton, {
	                      primary: title.new,
	                      disabled: _this2.props.acceptInProgress,
	                      label: title.new ? "Create new title" : title.name,
	                      onTouchTap: function onTouchTap() {
	                        return _this2._accept(title.new ? true : title.id);
	                      }
	                    })
	                  );
	                })
	              )
	            )
	          ) : _react2.default.createElement(
	            "div",
	            { style: { marginBottom: "1em" } },
	            _react2.default.createElement(_materialUi.RaisedButton, {
	              label: this.props.acceptInProgress ? "Accepting..." : "Accept invite",
	              disabled: this.props.acceptInProgress,
	              primary: true,
	              onTouchTap: function onTouchTap() {
	                return _this2._accept();
	              }
	            })
	          ),
	          _react2.default.createElement(
	            _linkLike2.default,
	            {
	              onTouchTap: function onTouchTap() {
	                return _UserActions2.default.logout(true);
	              },
	              style: { fontSize: "0.9em" }
	            },
	            "Log out and accept as a different user"
	          )
	        );
	      }
	
	      var notReady = this.props.loginInProgress || !this.state.username || !this.state.password || !this.state.name || !this.state.organization || !this.state.organization.trim() || this.state.password !== this.state.confirmPassword;
	
	      return _react2.default.createElement(
	        "div",
	        { style: styles.container },
	        error ? _react2.default.createElement(
	          "div",
	          { style: styles.error },
	          "Failed to activate account: ",
	          error
	        ) : _react2.default.createElement(
	          "div",
	          { style: styles.bodyText },
	          _react2.default.createElement(
	            "div",
	            null,
	            "Welcome to Eventive for Content Creators. To begin",
	            " ",
	            invite.title_requested_media ? "delivering assets" : "uploading content",
	            " ",
	            "for \"",
	            invite.film_name,
	            "\", please create an account below, or",
	            " ",
	            _react2.default.createElement(
	              _reactRouter.Link,
	              {
	                to: {
	                  pathname: "/login",
	                  query: {
	                    next: encodeURIComponent(this.props.location.pathname + this.props.location.search)
	                  },
	                  state: { username: this.state.username }
	                },
	                style: styles.alreadyHaveAccount
	              },
	              "login to an existing account"
	            ),
	            "."
	          ),
	          _react2.default.createElement(
	            "div",
	            { style: { marginTop: "1em" } },
	            "Please ensure the information you provide is accurate, as it will be used to verify and protect your rights to the content."
	          )
	        ),
	        _react2.default.createElement(
	          "form",
	          null,
	          _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(_materialUi.TextField, {
	              floatingLabelText: "Email address",
	              floatingLabelFixed: true,
	              value: this.state.username,
	              onChange: function onChange(e) {
	                return _this2.setState({ username: e.target.value });
	              },
	              disabled: this.props.loginInProgress
	            })
	          ),
	          _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(_materialUi.TextField, {
	              floatingLabelText: "Full name",
	              floatingLabelFixed: true,
	              value: this.state.name,
	              onChange: function onChange(e) {
	                return _this2.setState({ name: e.target.value });
	              },
	              disabled: this.props.loginInProgress,
	              autoFocus: true
	            })
	          ),
	          _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(_materialUi.TextField, {
	              floatingLabelText: "Company / legal name",
	              floatingLabelFixed: true,
	              value: this.state.organization,
	              onChange: function onChange(e) {
	                return _this2.setState({ organization: e.target.value });
	              },
	              disabled: this.props.loginInProgress
	            })
	          ),
	          _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(_materialUi.TextField, {
	              floatingLabelText: "New password",
	              floatingLabelFixed: true,
	              value: this.state.password,
	              onChange: function onChange(e) {
	                return _this2.setState({ password: e.target.value });
	              },
	              type: "password",
	              autoComplete: "new-password",
	              disabled: this.props.loginInProgress
	            })
	          ),
	          _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(_materialUi.TextField, {
	              floatingLabelText: "Confirm new password",
	              floatingLabelFixed: true,
	              value: this.state.confirmPassword,
	              onChange: function onChange(e) {
	                return _this2.setState({
	                  hasStartedConfirming: true,
	                  confirmPassword: e.target.value
	                });
	              },
	              onKeyDown: function onKeyDown(e) {
	                if (e.keyCode === 13 && !notReady) _this2._signup();
	              },
	              errorText: this.state.hasStartedConfirming && this.state.password !== this.state.confirmPassword ? "The passwords do not match." : null,
	              type: "password",
	              autoComplete: "new-password",
	              disabled: this.props.loginInProgress
	            })
	          ),
	          _react2.default.createElement(
	            "div",
	            { style: styles.actions },
	            _react2.default.createElement(_materialUi.RaisedButton, {
	              label: this.props.loginInProgress ? "Activating..." : "Activate account",
	              disabled: notReady,
	              primary: true,
	              onTouchTap: this._signup
	            })
	          ),
	          _react2.default.createElement(
	            "div",
	            { style: styles.terms },
	            "By activating your account, you agree to the Eventive",
	            " ",
	            _react2.default.createElement(
	              "a",
	              {
	                href: "https://eventive.org/terms",
	                target: "_blank",
	                style: styles.termsLink
	              },
	              "Terms of Service"
	            ),
	            " ",
	            "and",
	            " ",
	            _react2.default.createElement(
	              "a",
	              {
	                href: "https://eventive.org/privacy",
	                target: "_blank",
	                style: styles.termsLink
	              },
	              "Privacy\xA0Policy"
	            ),
	            "."
	          )
	        )
	      );
	    }
	  }], [{
	    key: "getStores",
	    value: function getStores() {
	      return [_UserStore2.default, _TitleStore2.default];
	    }
	  }, {
	    key: "getPropsFromStores",
	    value: function getPropsFromStores() {
	      return _UserStore2.default.getState();
	    }
	  }, {
	    key: "contextTypes",
	    get: function get() {
	      return {
	        router: _react2.default.PropTypes.object.isRequired
	      };
	    }
	  }]);
	
	  return AcceptCreatorInvite;
	}(_react2.default.Component);
	
	exports.default = (0, _connectToStores2.default)(AcceptCreatorInvite);
	module.exports = exports["default"];

/***/ }),
/* 1664 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _materialUi = __webpack_require__(576);
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var CENTERED_STYLE = {
	  margin: "0 auto",
	  textAlign: "center"
	};
	
	var FULL_PAGE_STYLE = {
	  margin: "0 auto",
	  padding: 10,
	  textAlign: "center"
	};
	
	var FULL_PAGE_PROPS = {
	  size: 1.5
	};
	
	var OVERLAY_STYLE = {
	  position: "fixed",
	  top: 0,
	  bottom: 0,
	  left: 0,
	  right: 0,
	  backgroundColor: "rgba(255, 255, 255, 0.8)",
	  display: "flex",
	  alignItems: "center",
	  justifyContent: "center",
	  zIndex: 2
	};
	
	exports.default = function (_ref) {
	  var style = _ref.style;
	  var fullPage = _ref.fullPage;
	  var centered = _ref.centered;
	  var overlay = _ref.overlay;
	
	  var rest = _objectWithoutProperties(_ref, ["style", "fullPage", "centered", "overlay"]);
	
	  if (fullPage) {
	    rest = Object.assign({}, FULL_PAGE_PROPS, rest);
	  }
	
	  return React.createElement(
	    "div",
	    {
	      style: Object.assign({}, centered && CENTERED_STYLE, fullPage && FULL_PAGE_STYLE, overlay && OVERLAY_STYLE, style)
	    },
	    React.createElement(_materialUi.CircularProgress, _extends({ mode: "indeterminate" }, rest))
	  );
	};
	
	module.exports = exports["default"];

/***/ }),
/* 1665 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _alt = __webpack_require__(975);
	
	var _alt2 = _interopRequireDefault(_alt);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var TitleActions = function () {
	  function TitleActions() {
	    _classCallCheck(this, TitleActions);
	
	    this.generateActions("create", "delete", "updateTitles", "fetchAll", "fetchOne", "fetchFailed", "editFailed");
	  }
	
	  _createClass(TitleActions, [{
	    key: "editImage",
	    value: function editImage(id, field, file) {
	      return { id: id, field: field, file: file };
	    }
	  }, {
	    key: "edit",
	    value: function edit(id, values) {
	      return { id: id, values: values };
	    }
	  }, {
	    key: "updateTitle",
	    value: function updateTitle(id, title) {
	      return { id: id, title: title };
	    }
	  }]);
	
	  return TitleActions;
	}();
	
	exports.default = _alt2.default.createActions(TitleActions);
	module.exports = exports["default"];

/***/ }),
/* 1666 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _alt = __webpack_require__(975);
	
	var _alt2 = _interopRequireDefault(_alt);
	
	var _keyBy = __webpack_require__(990);
	
	var _keyBy2 = _interopRequireDefault(_keyBy);
	
	var _values = __webpack_require__(1214);
	
	var _values2 = _interopRequireDefault(_values);
	
	var _TitleUtil = __webpack_require__(1667);
	
	var _TitleUtil2 = _interopRequireDefault(_TitleUtil);
	
	var _TitleActions = __webpack_require__(1665);
	
	var _TitleActions2 = _interopRequireDefault(_TitleActions);
	
	var _UserStore = __webpack_require__(974);
	
	var _UserStore2 = _interopRequireDefault(_UserStore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var TitleStore = function () {
	  function TitleStore() {
	    _classCallCheck(this, TitleStore);
	
	    this.bindActions(_TitleActions2.default);
	
	    this.state = {
	      titles: {},
	      isFetching: false,
	      isCreating: false,
	      newTitleId: null
	    };
	
	    this.exportPublicMethods({
	      getTitleById: this.getTitleById.bind(this),
	      getTitles: this.getTitles.bind(this)
	    });
	  }
	
	  _createClass(TitleStore, [{
	    key: "getTitleById",
	    value: function getTitleById(id) {
	      return this.state.titles[id];
	    }
	  }, {
	    key: "getTitles",
	    value: function getTitles(id) {
	      return (0, _values2.default)(this.state.titles);
	    }
	  }, {
	    key: "onFetchAll",
	    value: function onFetchAll() {
	      var _this = this;
	
	      this.setState({ isFetching: true });
	      _TitleUtil2.default.fetchAll(_UserStore2.default.getState().apiKey).then(function (data) {
	        _TitleActions2.default.updateTitles((0, _keyBy2.default)(data, "id"));
	        _this.setState({ isFetching: false });
	      }).catch(_TitleActions2.default.fetchFailed);
	    }
	  }, {
	    key: "onFetchOne",
	    value: function onFetchOne(id) {
	      var _this2 = this;
	
	      this.setState({ isFetching: true });
	      _TitleUtil2.default.fetchOne(_UserStore2.default.getState().apiKey, id).then(function (data) {
	        _TitleActions2.default.updateTitle(id, data);
	        _this2.setState({ isFetching: false });
	      }).catch(_TitleActions2.default.fetchFailed);
	    }
	  }, {
	    key: "onEdit",
	    value: function onEdit(newData) {
	      var _this3 = this;
	
	      this.setState({ isEditing: newData.id });
	      _TitleUtil2.default.edit(_UserStore2.default.getState().apiKey, newData.id, newData.values).then(function (data) {
	        _TitleActions2.default.updateTitle(newData.id, data);
	        _this3.setState({ isEditing: null });
	      }).catch(_TitleActions2.default.editFailed);
	    }
	  }, {
	    key: "onCreate",
	    value: function onCreate(newData) {
	      var _this4 = this;
	
	      this.setState({ isCreating: true, newTitleId: null });
	
	      _TitleUtil2.default.create(_UserStore2.default.getState().apiKey, newData).then(function (data) {
	        _TitleActions2.default.updateTitle(data.id, data);
	        _this4.setState({ isCreating: false, newTitleId: data.id });
	      }).catch(_TitleActions2.default.editFailed);
	    }
	  }, {
	    key: "onUpdateTitles",
	    value: function onUpdateTitles(titles) {
	      this.setState({
	        titles: _extends({}, this.state.titles, titles)
	      });
	    }
	  }, {
	    key: "onUpdateTitle",
	    value: function onUpdateTitle(data) {
	      if (!data.title) {
	        delete this.state.titles[data.id];
	      } else {
	        this.state.titles[data.id] = data.title;
	      }
	      this.state.newTitleId = null;
	      this.setState(this.state);
	    }
	  }, {
	    key: "onFetchFailed",
	    value: function onFetchFailed(e) {
	      alert("Fetching title failed: " + e.message);
	      throw e;
	    }
	  }, {
	    key: "onEditFailed",
	    value: function onEditFailed(e) {
	      alert("Edit failed: " + e.message);
	      this.setState({ isCreating: false, isEditing: false });
	    }
	  }]);
	
	  return TitleStore;
	}();
	
	exports.default = _alt2.default.createStore(TitleStore, "TitleStore");
	module.exports = exports["default"];

/***/ }),
/* 1667 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _api = __webpack_require__(1160);
	
	var _api2 = _interopRequireDefault(_api);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  fetchAll: function fetchAll(apiKey) {
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "GET",
	        endpoint: "titles",
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response.titles);
	      });
	    });
	  },
	  fetchOne: function fetchOne(apiKey, title) {
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "GET",
	        endpoint: "titles/" + title,
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response);
	      });
	    });
	  },
	  edit: function edit(apiKey, title, values) {
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "POST",
	        endpoint: "titles/" + title,
	        json: values,
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response);
	      });
	    });
	  },
	  create: function create(apiKey, values) {
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "POST",
	        endpoint: "titles",
	        json: values,
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response);
	      });
	    });
	  },
	  editTitleDelivery: function editTitleDelivery(apiKey, titleDelivery, values) {
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "POST",
	        endpoint: "title_deliveries/" + titleDelivery,
	        json: values,
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response);
	      });
	    });
	  }
	};
	module.exports = exports["default"];

/***/ }),
/* 1668 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _materialUi = __webpack_require__(576);
	
	var _reactRouter = __webpack_require__(486);
	
	var _workingIndicator = __webpack_require__(1664);
	
	var _workingIndicator2 = _interopRequireDefault(_workingIndicator);
	
	var _connectToStores = __webpack_require__(1226);
	
	var _connectToStores2 = _interopRequireDefault(_connectToStores);
	
	var _UserActions = __webpack_require__(1158);
	
	var _UserActions2 = _interopRequireDefault(_UserActions);
	
	var _UserStore = __webpack_require__(974);
	
	var _UserStore2 = _interopRequireDefault(_UserStore);
	
	var _linkLike = __webpack_require__(973);
	
	var _linkLike2 = _interopRequireDefault(_linkLike);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AcceptRevenueSharingInvite = function (_React$Component) {
	  _inherits(AcceptRevenueSharingInvite, _React$Component);
	
	  function AcceptRevenueSharingInvite(props) {
	    _classCallCheck(this, AcceptRevenueSharingInvite);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(AcceptRevenueSharingInvite).call(this, props));
	
	    _this.state = {
	      username: "",
	      name: "",
	      organization: "",
	      password: "",
	      confirmPassword: "",
	      hasStartedConfirming: false,
	      activating: false
	    };
	
	    _this._signup = _this._signup.bind(_this);
	    _this._accept = _this._accept.bind(_this);
	    return _this;
	  }
	
	  _createClass(AcceptRevenueSharingInvite, [{
	    key: "_signup",
	    value: function _signup() {
	      this.setState({ activating: true });
	      _UserActions2.default.userSignup({
	        type: "content_creator",
	        email: this.state.username,
	        password: this.state.password,
	        name: this.state.name,
	        organization: this.state.organization
	      });
	    }
	  }, {
	    key: "_accept",
	    value: function _accept() {
	      _UserActions2.default.acceptRevenueSharingInvite(this.props.location.query.token);
	    }
	  }, {
	    key: "componentWillMount",
	    value: function componentWillMount() {
	      _UserActions2.default.lookupRevenueSharingInvite(this.props.location.query.token);
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(newProps) {
	      var invite = newProps.revenueSharingInvites[this.props.location.query.token];
	
	      if (invite && invite.email && !this.state.username) {
	        this.setState({ username: invite.email });
	      }
	
	      if (invite && invite.accepted) {
	        this.context.router.push("revenue_sharing");
	      }
	    }
	  }, {
	    key: "getStyles",
	    value: function getStyles() {
	      return {
	        container: {
	          margin: "10% auto 5%",
	          width: 375,
	          fontSize: "11pt",
	          textAlign: "center"
	        },
	        bodyText: {
	          textAlign: "left",
	          marginBottom: "0.5em"
	        },
	        actions: {
	          marginTop: "1em",
	          textAlign: "center"
	        },
	        terms: {
	          textAlign: "center",
	          fontSize: "10pt",
	          lineHeight: 1.5,
	          color: "#a7a7a7",
	          maxWidth: 270,
	          margin: "1em auto 0"
	        },
	        termsLink: {
	          color: "#8a8a8a"
	        },
	        error: {
	          color: "#FF4136"
	        }
	      };
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var styles = this.getStyles();
	      var error = this.props.loginErrorMessage;
	
	      var invite = this.props.revenueSharingInvites[this.props.location.query.token];
	
	      if (!invite && this.props.revenueSharingInviteLookupErrorMessage) {
	        return _react2.default.createElement(
	          "div",
	          { style: styles.container },
	          _react2.default.createElement(
	            "div",
	            { style: styles.error },
	            _react2.default.createElement(
	              "p",
	              null,
	              "Failed to accept invite: This invite may have been revoked, or perhaps has already been accepted. (",
	              this.props.revenueSharingInviteLookupErrorMessage,
	              ")"
	            ),
	            " ",
	            _react2.default.createElement(
	              "p",
	              null,
	              "Please try",
	              " ",
	              _react2.default.createElement(
	                _reactRouter.Link,
	                {
	                  to: {
	                    pathname: "/login"
	                  },
	                  style: styles.alreadyHaveAccount
	                },
	                "logging in"
	              ),
	              " ",
	              "instead, or",
	              " ",
	              _react2.default.createElement(
	                _linkLike2.default,
	                {
	                  onTouchTap: function onTouchTap() {
	                    return Intercom("showNewMessage", "I am having trouble accepting a Revenue Sharing invitation. My name and organization are: ");
	                  }
	                },
	                "send us a message"
	              ),
	              "."
	            )
	          )
	        );
	      }
	
	      if (!invite) {
	        return _react2.default.createElement(_workingIndicator2.default, { fullPage: true, style: { margin: "10% auto" } });
	      }
	
	      if (this.props.isLoggedIn) {
	        return _react2.default.createElement(
	          "div",
	          { style: _extends({}, styles.container, { textAlign: "center" }) },
	          _react2.default.createElement(
	            "div",
	            { style: { marginBottom: "1em" } },
	            _react2.default.createElement(
	              "strong",
	              null,
	              invite.user_name
	            ),
	            " has invited you to participate in revenue sharing for ",
	            _react2.default.createElement(
	              "strong",
	              null,
	              invite.event_name
	            ),
	            ". Funds will be automatically disbursed to you."
	          ),
	          _react2.default.createElement(
	            "div",
	            { style: { marginBottom: "1em" } },
	            _react2.default.createElement(_materialUi.RaisedButton, {
	              label: this.props.acceptInProgress ? "Accepting..." : "Accept invite",
	              disabled: this.props.acceptInProgress,
	              primary: true,
	              onTouchTap: this._accept
	            })
	          ),
	          _react2.default.createElement(
	            _linkLike2.default,
	            {
	              onTouchTap: function onTouchTap() {
	                return _UserActions2.default.logout(true);
	              },
	              style: { fontSize: "0.9em" }
	            },
	            "Log out and accept as a different user"
	          )
	        );
	      }
	
	      return _react2.default.createElement(
	        "div",
	        { style: styles.container },
	        error ? _react2.default.createElement(
	          "div",
	          { style: styles.error },
	          "Failed to activate account: ",
	          error
	        ) : _react2.default.createElement(
	          "div",
	          { style: styles.bodyText },
	          _react2.default.createElement(
	            "div",
	            null,
	            "Welcome to Eventive Revenue Sharing. To begin sharing in the revenue for \"",
	            invite.event_name,
	            "\", please create an account below, or",
	            " ",
	            _react2.default.createElement(
	              _reactRouter.Link,
	              {
	                to: {
	                  pathname: "/login",
	                  query: {
	                    next: encodeURIComponent(this.props.location.pathname + this.props.location.search)
	                  },
	                  state: { username: this.state.username }
	                },
	                style: styles.alreadyHaveAccount
	              },
	              "login to an existing account"
	            ),
	            "."
	          ),
	          _react2.default.createElement(
	            "div",
	            { style: { marginTop: "1em" } },
	            "Please ensure the information you provide is accurate, as it will be used to verify your identity for payment compliance."
	          )
	        ),
	        _react2.default.createElement(
	          "form",
	          null,
	          _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(_materialUi.TextField, {
	              floatingLabelText: "Email address",
	              floatingLabelFixed: true,
	              value: this.state.username,
	              onChange: function onChange(e) {
	                return _this2.setState({ username: e.target.value });
	              },
	              disabled: this.props.loginInProgress
	            })
	          ),
	          _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(_materialUi.TextField, {
	              floatingLabelText: "Company / legal name",
	              floatingLabelFixed: true,
	              value: this.state.organization,
	              onChange: function onChange(e) {
	                return _this2.setState({ organization: e.target.value });
	              },
	              disabled: this.props.loginInProgress,
	              autoFocus: true
	            })
	          ),
	          _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(_materialUi.TextField, {
	              floatingLabelText: "Individual name",
	              floatingLabelFixed: true,
	              value: this.state.name,
	              onChange: function onChange(e) {
	                return _this2.setState({ name: e.target.value });
	              },
	              disabled: this.props.loginInProgress
	            })
	          ),
	          _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(_materialUi.TextField, {
	              floatingLabelText: "New password",
	              floatingLabelFixed: true,
	              value: this.state.password,
	              onChange: function onChange(e) {
	                return _this2.setState({ password: e.target.value });
	              },
	              type: "password",
	              autoComplete: "new-password",
	              disabled: this.props.loginInProgress
	            })
	          ),
	          _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(_materialUi.TextField, {
	              floatingLabelText: "Confirm new password",
	              floatingLabelFixed: true,
	              value: this.state.confirmPassword,
	              onChange: function onChange(e) {
	                return _this2.setState({
	                  hasStartedConfirming: true,
	                  confirmPassword: e.target.value
	                });
	              },
	              onKeyDown: function onKeyDown(e) {
	                if (e.keyCode === 13) _this2._signup();
	              },
	              errorText: this.state.hasStartedConfirming && this.state.password !== this.state.confirmPassword ? "The passwords do not match." : null,
	              type: "password",
	              autoComplete: "new-password",
	              disabled: this.props.loginInProgress
	            })
	          ),
	          _react2.default.createElement(
	            "div",
	            { style: styles.actions },
	            _react2.default.createElement(_materialUi.RaisedButton, {
	              label: this.props.loginInProgress ? "Activating..." : "Activate account",
	              disabled: this.props.loginInProgress || !this.state.username || !this.state.password || !this.state.name || !this.state.organization || this.state.password !== this.state.confirmPassword,
	              primary: true,
	              onTouchTap: this._signup
	            })
	          ),
	          _react2.default.createElement(
	            "div",
	            { style: styles.terms },
	            "By activating your account, you agree to the Eventive",
	            " ",
	            _react2.default.createElement(
	              "a",
	              {
	                href: "https://eventive.org/terms",
	                target: "_blank",
	                style: styles.termsLink
	              },
	              "Terms of Service"
	            ),
	            " ",
	            "and",
	            " ",
	            _react2.default.createElement(
	              "a",
	              {
	                href: "https://eventive.org/privacy",
	                target: "_blank",
	                style: styles.termsLink
	              },
	              "Privacy\xA0Policy"
	            ),
	            "."
	          )
	        )
	      );
	    }
	  }], [{
	    key: "getStores",
	    value: function getStores() {
	      return [_UserStore2.default];
	    }
	  }, {
	    key: "getPropsFromStores",
	    value: function getPropsFromStores() {
	      return _UserStore2.default.getState();
	    }
	  }, {
	    key: "contextTypes",
	    get: function get() {
	      return {
	        router: _react2.default.PropTypes.object.isRequired
	      };
	    }
	  }]);
	
	  return AcceptRevenueSharingInvite;
	}(_react2.default.Component);
	
	exports.default = (0, _connectToStores2.default)(AcceptRevenueSharingInvite);
	module.exports = exports["default"];

/***/ }),
/* 1669 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _materialUi = __webpack_require__(576);
	
	var _connectToStores = __webpack_require__(1226);
	
	var _connectToStores2 = _interopRequireDefault(_connectToStores);
	
	var _UserActions = __webpack_require__(1158);
	
	var _UserActions2 = _interopRequireDefault(_UserActions);
	
	var _UserStore = __webpack_require__(974);
	
	var _UserStore2 = _interopRequireDefault(_UserStore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Forgot = function (_React$Component) {
	  _inherits(Forgot, _React$Component);
	
	  function Forgot(props) {
	    _classCallCheck(this, Forgot);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(Forgot).call(this, props));
	
	    _this.state = {
	      email: ""
	    };
	
	    _this._reset = _this._reset.bind(_this);
	    return _this;
	  }
	
	  _createClass(Forgot, [{
	    key: "_reset",
	    value: function _reset() {
	      _UserActions2.default.forgotPassword(this.state.email);
	    }
	  }, {
	    key: "getStyles",
	    value: function getStyles() {
	      return {
	        page: {
	          minHeight: "60vh"
	        },
	        container: {
	          margin: "0 auto",
	          marginTop: "10%",
	          width: "90%",
	          maxWidth: 350,
	          padding: 20,
	          textAlign: "center",
	          borderRadius: 10
	        },
	        actions: {
	          marginTop: 10,
	          textAlign: "center"
	        },
	        error: {
	          color: "#FF4136"
	        },
	        innerContent: {
	          maxWidth: 240,
	          margin: "0 auto"
	        }
	      };
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var styles = this.getStyles();
	
	      return _react2.default.createElement(
	        "div",
	        { style: styles.page },
	        _react2.default.createElement(
	          _materialUi.Paper,
	          { style: styles.container },
	          this.props.forgotSuccess ? _react2.default.createElement(
	            "div",
	            { style: styles.innerContent },
	            "Please check your email for instructions to reset your password."
	          ) : _react2.default.createElement(
	            "div",
	            null,
	            this.props.forgotErrorMessage ? _react2.default.createElement(
	              "div",
	              { style: styles.error },
	              this.props.forgotErrorMessage
	            ) : _react2.default.createElement(
	              "div",
	              { style: styles.innerContent },
	              "To begin the password recovery process, please enter your email address."
	            ),
	            _react2.default.createElement(
	              "form",
	              null,
	              _react2.default.createElement(
	                "div",
	                null,
	                _react2.default.createElement(_materialUi.TextField, {
	                  hintText: "Email address",
	                  value: this.state.email,
	                  onChange: function onChange(e) {
	                    return _this2.setState({ email: e.target.value });
	                  },
	                  autoFocus: true,
	                  onKeyDown: function onKeyDown(e) {
	                    if (e.keyCode === 13) _this2._reset();
	                  },
	                  disabled: this.props.forgotInProgress
	                })
	              ),
	              _react2.default.createElement(
	                "div",
	                { style: styles.actions },
	                _react2.default.createElement(_materialUi.RaisedButton, {
	                  label: "Go back",
	                  style: { marginRight: 12 },
	                  onTouchTap: this.context.router.goBack
	                }),
	                _react2.default.createElement(_materialUi.RaisedButton, {
	                  label: this.props.forgotInProgress ? "Resetting..." : "Reset password",
	                  disabled: this.props.forgotInProgress,
	                  primary: true,
	                  onTouchTap: this._reset
	                })
	              )
	            )
	          )
	        )
	      );
	    }
	  }], [{
	    key: "getStores",
	    value: function getStores() {
	      return [_UserStore2.default];
	    }
	  }, {
	    key: "getPropsFromStores",
	    value: function getPropsFromStores() {
	      return _UserStore2.default.getState();
	    }
	  }, {
	    key: "contextTypes",
	    get: function get() {
	      return {
	        router: _react2.default.PropTypes.object
	      };
	    }
	  }]);
	
	  return Forgot;
	}(_react2.default.Component);
	
	exports.default = (0, _connectToStores2.default)(Forgot);
	module.exports = exports["default"];

/***/ }),
/* 1670 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _materialUi = __webpack_require__(576);
	
	var _reactRouter = __webpack_require__(486);
	
	var _connectToStores = __webpack_require__(1226);
	
	var _connectToStores2 = _interopRequireDefault(_connectToStores);
	
	var _UserActions = __webpack_require__(1158);
	
	var _UserActions2 = _interopRequireDefault(_UserActions);
	
	var _UserStore = __webpack_require__(974);
	
	var _UserStore2 = _interopRequireDefault(_UserStore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Reset = function (_React$Component) {
	  _inherits(Reset, _React$Component);
	
	  function Reset(props) {
	    _classCallCheck(this, Reset);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(Reset).call(this, props));
	
	    _this.state = {
	      password: "",
	      confirmPassword: ""
	    };
	
	    _this._reset = _this._reset.bind(_this);
	    return _this;
	  }
	
	  _createClass(Reset, [{
	    key: "_reset",
	    value: function _reset() {
	      _UserActions2.default.resetPassword(this.props.location.query.token, this.state.password);
	    }
	  }, {
	    key: "getStyles",
	    value: function getStyles() {
	      return {
	        page: {
	          minHeight: "60vh"
	        },
	        container: {
	          margin: "0 auto",
	          marginTop: "10%",
	          width: "90%",
	          maxWidth: 350,
	          padding: 20,
	          textAlign: "center",
	          borderRadius: 10
	        },
	        actions: {
	          marginTop: 10,
	          textAlign: "center"
	        },
	        error: {
	          color: "#FF4136"
	        },
	        innerContent: {
	          maxWidth: 240,
	          margin: "0 auto"
	        }
	      };
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var styles = this.getStyles();
	
	      return _react2.default.createElement(
	        "div",
	        { style: styles.page },
	        _react2.default.createElement(
	          _materialUi.Paper,
	          { style: styles.container },
	          this.props.resetSuccess ? _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(
	              "div",
	              null,
	              "Password reset successfully! Please login again."
	            ),
	            _react2.default.createElement(
	              "div",
	              { style: styles.actions },
	              _react2.default.createElement(_materialUi.RaisedButton, {
	                label: "Return to login",
	                style: { marginLeft: 12 },
	                onTouchTap: function onTouchTap() {
	                  return _this2.context.router.push("/login");
	                },
	                primary: true
	              })
	            )
	          ) : _react2.default.createElement(
	            "div",
	            null,
	            this.props.resetErrorMessage ? _react2.default.createElement(
	              "div",
	              { style: styles.error },
	              "Failed to reset password: ",
	              this.props.resetErrorMessage
	            ) : _react2.default.createElement(
	              "div",
	              null,
	              "Almost there\u2014please enter a new password."
	            ),
	            _react2.default.createElement(
	              "form",
	              null,
	              _react2.default.createElement(
	                "div",
	                null,
	                _react2.default.createElement(_materialUi.TextField, {
	                  hintText: "New password",
	                  value: this.state.password,
	                  onChange: function onChange(e) {
	                    return _this2.setState({ password: e.target.value });
	                  },
	                  type: "password",
	                  disabled: this.props.resetInProgress
	                })
	              ),
	              _react2.default.createElement(
	                "div",
	                null,
	                _react2.default.createElement(_materialUi.TextField, {
	                  hintText: "Confirm new password",
	                  value: this.state.confirmPassword,
	                  onChange: function onChange(e) {
	                    return _this2.setState({ confirmPassword: e.target.value });
	                  },
	                  errorText: this.state.password !== this.state.confirmPassword ? "The passwords do not match." : null,
	                  errorStyle: { textAlign: "left" },
	                  type: "password",
	                  onKeyDown: function onKeyDown(e) {
	                    if (e.keyCode === 13) _this2._reset();
	                  },
	                  disabled: this.props.resetInProgress
	                })
	              ),
	              _react2.default.createElement(
	                "div",
	                { style: styles.actions },
	                _react2.default.createElement(_materialUi.RaisedButton, {
	                  label: this.props.resetInProgress ? "Resetting..." : "Reset password",
	                  disabled: this.props.resetInProgress || !this.state.password || this.state.password !== this.state.confirmPassword,
	                  primary: true,
	                  onTouchTap: this._reset
	                })
	              )
	            )
	          )
	        )
	      );
	    }
	  }], [{
	    key: "getStores",
	    value: function getStores() {
	      return [_UserStore2.default];
	    }
	  }, {
	    key: "getPropsFromStores",
	    value: function getPropsFromStores() {
	      return _UserStore2.default.getState();
	    }
	  }, {
	    key: "contextTypes",
	    get: function get() {
	      return {
	        router: _react2.default.PropTypes.object.isRequired
	      };
	    }
	  }]);
	
	  return Reset;
	}(_react2.default.Component);
	
	exports.default = (0, _connectToStores2.default)(Reset);
	module.exports = exports["default"];

/***/ }),
/* 1671 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _values = __webpack_require__(1214);
	
	var _values2 = _interopRequireDefault(_values);
	
	var _reactRouter = __webpack_require__(486);
	
	var _pageWithNav = __webpack_require__(1672);
	
	var _pageWithNav2 = _interopRequireDefault(_pageWithNav);
	
	var _inlineButton = __webpack_require__(1674);
	
	var _inlineButton2 = _interopRequireDefault(_inlineButton);
	
	var _inlineNoticeLabel = __webpack_require__(1222);
	
	var _inlineNoticeLabel2 = _interopRequireDefault(_inlineNoticeLabel);
	
	var _connectToStores = __webpack_require__(1226);
	
	var _connectToStores2 = _interopRequireDefault(_connectToStores);
	
	var _EventBucketActions = __webpack_require__(1218);
	
	var _EventBucketActions2 = _interopRequireDefault(_EventBucketActions);
	
	var _EventBucketStore = __webpack_require__(1593);
	
	var _EventBucketStore2 = _interopRequireDefault(_EventBucketStore);
	
	var _UserStore = __webpack_require__(974);
	
	var _UserStore2 = _interopRequireDefault(_UserStore);
	
	var _UserActions = __webpack_require__(1158);
	
	var _UserActions2 = _interopRequireDefault(_UserActions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Dashboard = function (_React$Component) {
	  _inherits(Dashboard, _React$Component);
	
	  function Dashboard(props) {
	    _classCallCheck(this, Dashboard);
	
	    return _possibleConstructorReturn(this, Object.getPrototypeOf(Dashboard).call(this, props));
	  }
	
	  _createClass(Dashboard, [{
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(props) {
	      if (!props.isLoggedIn) {
	        this.props.history.push("/login");
	      }
	    }
	  }, {
	    key: "getStyles",
	    value: function getStyles() {
	      return {
	        menuItem: {
	          lineHeight: 1.3,
	          padding: "16px 0",
	          marginLeft: 40
	        }
	      };
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var menuItems = [{ text: "Account", isSubheader: true }, {
	        route: "/account",
	        text: "Manage account"
	      }, _UserStore2.default.hasPermission("manage_organization") && {
	        route: "/organization",
	        text: "Manage organization"
	      }, _UserStore2.default.getUserType() !== "content_creator" && {
	        route: "/feedback",
	        text: _react2.default.createElement(
	          "span",
	          null,
	          "Feature requests"
	        )
	      }, (_UserStore2.default.isGod() || _UserStore2.default.hasRole("admin") && (_UserStore2.default.getUser().id === "5dae0d7c41443700308287c5" || _UserStore2.default.getUser().id === "5a68bc8cf4a2de00148eedb0" || _UserStore2.default.getUser().id === "632796a787711400538e66da")) && {
	        route: "/audit_log",
	        text: "Audit log"
	      }, _UserStore2.default.hasPermission("manage_billing") && _UserStore2.default.getUserType() !== "content_creator" && {
	        key: "financials",
	        text: "Financials",
	        isCollapsible: true,
	        subitems: [{
	          route: "/billing",
	          text: _react2.default.createElement(
	            "div",
	            { style: { marginLeft: 20 } },
	            "Billing Hub"
	          )
	        }, {
	          route: "/revenue_sharing",
	          text: _react2.default.createElement(
	            "div",
	            { style: { marginLeft: 20 } },
	            "Revenue Sharing"
	          )
	        }]
	      }];
	
	      if (_UserStore2.default.getUserType() === "content_creator") {
	        menuItems = menuItems.concat([{ isDivider: true }, {
	          text: _react2.default.createElement(
	            "div",
	            null,
	            "Creator"
	          ),
	          isSubheader: true
	        }, {
	          text: "Creator Hub",
	          route: "/creator_hub"
	        }, { isDivider: true }, { text: "Financials", isSubheader: true }, {
	          route: "/revenue_sharing",
	          text: "Revenue Sharing"
	        }]);
	
	        // Remove hasPermission=false items
	        menuItems = menuItems.filter(function (i) {
	          return i !== false;
	        });
	
	        return _react2.default.createElement(
	          _pageWithNav2.default,
	          { menuItems: menuItems },
	          this.props.children
	        );
	      }
	
	      menuItems = menuItems.concat([{ isDivider: true }, {
	        text: _react2.default.createElement(
	          "div",
	          null,
	          "Event buckets",
	          " ",
	          _UserStore2.default.hasRole("admin") ? _react2.default.createElement(_inlineButton2.default, {
	            style: { verticalAlign: 2, marginLeft: 5 },
	            label: "+ Create new",
	            onTouchTap: function onTouchTap() {
	              return _this2.context.router.push("/event_buckets/new");
	            }
	          }) : null
	        ),
	        isSubheader: true
	      }]).concat(_EventBucketStore2.default.getEventBuckets().length === 0 ? [{
	        disabled: true,
	        text: _react2.default.createElement(
	          "i",
	          null,
	          this.props.isFetchingAll ? "Loading your event buckets..." : "No event buckets"
	        )
	      }] : []);
	
	      var styles = this.getStyles();
	      var eventBucketId = this.props.params.eventBucketId;
	      var currentEventBucket = _EventBucketStore2.default.getEventBucketById(eventBucketId);
	      var currentRoutes = this.props.routes.map(function (r) {
	        return r.name;
	      });
	
	      if (this.props.eventBuckets) {
	        var activeEventBuckets = _EventBucketStore2.default.getEventBuckets().filter(function (b) {
	          return b.mode !== "archived" || b.id === eventBucketId;
	        });
	        var archivedEventBuckets = _EventBucketStore2.default.getEventBuckets().filter(function (b) {
	          return b.mode === "archived";
	        });
	
	        menuItems = menuItems.concat([].concat.apply([], activeEventBuckets.map(function (b) {
	          return [{
	            route: "/event_buckets/" + b.id,
	            text: b.name
	          }].concat(eventBucketId !== b.id ? [] : [_UserStore2.default.hasPermission(["edit_event_bucket", "manage_configurator", "manage_embed_wizard"]) && {
	            route: "/event_buckets/" + b.id + "/settings",
	            text: _react2.default.createElement(
	              "div",
	              {
	                style: {
	                  marginLeft: 20,
	                  fontWeight: 500
	                }
	              },
	              "Settings"
	            )
	          }, _UserStore2.default.hasPermission("view_analytics_list") && {
	            route: "/event_buckets/" + b.id + "/analytics",
	            text: _react2.default.createElement(
	              "div",
	              {
	                style: {
	                  marginLeft: 20,
	                  fontWeight: 500
	                }
	              },
	              "Analytics"
	            )
	          }].concat(currentRoutes.indexOf("analytics") !== -1 || currentRoutes.indexOf("pass-analytics") !== -1 || currentRoutes.indexOf("attendee-analytics") !== -1 || currentRoutes.indexOf("geo-analytics") !== -1 || currentRoutes.indexOf("event-sales-analytics") !== -1 || currentRoutes.indexOf("event-passes-analytics") !== -1 || currentRoutes.indexOf("sales-analytics") !== -1 || currentRoutes.indexOf("event-ticket-analytics") !== -1 || currentRoutes.indexOf("streaming-analytics") !== -1 || currentRoutes.indexOf("recurring-pass-analytics") !== -1 || currentRoutes.indexOf("membership-analytics") !== -1 || currentRoutes.indexOf("recurring-membership-analytics") !== -1 || currentRoutes.indexOf("event-memberships-analytics") !== -1 ? [(_UserStore2.default.hasPermission("view_analytics") || _UserStore2.default.hasPermission("view_attendee_analytics")) && {
	            text: _react2.default.createElement(
	              "div",
	              { style: styles.menuItem },
	              "Attendee analytics"
	            ),
	            route: "/event_buckets/" + b.id + "/analytics/attendees"
	          }, (_UserStore2.default.hasPermission("view_analytics") || _UserStore2.default.hasPermission("view_event_analytics")) && {
	            text: _react2.default.createElement(
	              "div",
	              { style: styles.menuItem },
	              "Event analytics"
	            ),
	            route: "/event_buckets/" + b.id + "/analytics/events"
	          }, (_UserStore2.default.hasPermission("view_analytics") || _UserStore2.default.hasPermission("view_standalone_ticket_analytics")) && {
	            text: _react2.default.createElement(
	              "div",
	              { style: styles.menuItem },
	              "Standalone ticket analytics"
	            ),
	            route: "/event_buckets/" + b.id + "/analytics/event_sales"
	          }, (_UserStore2.default.hasPermission("view_analytics") || _UserStore2.default.hasPermission("view_pass_sales_analytics")) && {
	            text: _react2.default.createElement(
	              "div",
	              { style: styles.menuItem },
	              "Pass sales analytics"
	            ),
	            route: "/event_buckets/" + b.id + "/analytics/passes"
	          }, (_UserStore2.default.hasPermission("view_analytics") || _UserStore2.default.hasPermission("view_pass_ticket_analytics")) && {
	            text: _react2.default.createElement(
	              "div",
	              { style: styles.menuItem },
	              "Pass ticket analytics"
	            ),
	            route: "/event_buckets/" + b.id + "/analytics/event_passes"
	          }, (_UserStore2.default.hasPermission("view_analytics") || _UserStore2.default.hasPermission("view_recurring_pass_analytics")) && {
	            text: _react2.default.createElement(
	              "div",
	              { style: styles.menuItem },
	              "Recurring pass analytics"
	            ),
	            route: "/event_buckets/" + b.id + "/analytics/recurring_pass"
	          }, currentEventBucket.frontend_config.memberships_enabled && (_UserStore2.default.hasPermission("view_analytics") || _UserStore2.default.hasPermission("view_pass_sales_analytics")) && {
	            text: _react2.default.createElement(
	              "div",
	              { style: styles.menuItem },
	              "Membership sales analytics"
	            ),
	            route: "/event_buckets/" + b.id + "/analytics/memberships"
	          }, currentEventBucket.frontend_config.memberships_enabled && (_UserStore2.default.hasPermission("view_analytics") || _UserStore2.default.hasPermission("view_pass_ticket_analytics")) && {
	            text: _react2.default.createElement(
	              "div",
	              { style: styles.menuItem },
	              "Membership ticket analytics"
	            ),
	            route: "/event_buckets/" + b.id + "/analytics/event_memberships"
	          }, currentEventBucket.frontend_config.memberships_enabled && (_UserStore2.default.hasPermission("view_analytics") || _UserStore2.default.hasPermission("view_recurring_pass_analytics")) && {
	            text: _react2.default.createElement(
	              "div",
	              { style: styles.menuItem },
	              "Membership status analytics"
	            ),
	            route: "/event_buckets/" + b.id + "/analytics/recurring_membership"
	          }, (_UserStore2.default.hasPermission("view_analytics") || _UserStore2.default.hasPermission("view_geo_analytics")) && {
	            text: _react2.default.createElement(
	              "div",
	              { style: styles.menuItem },
	              "Geo analytics"
	            ),
	            route: "/event_buckets/" + b.id + "/analytics/geo"
	          }, (_UserStore2.default.hasPermission("view_analytics") || _UserStore2.default.hasPermission("view_streaming_analytics")) && {
	            text: _react2.default.createElement(
	              "div",
	              { style: styles.menuItem },
	              "Streaming analytics"
	            ),
	            route: "/event_buckets/" + b.id + "/analytics/streaming"
	          }, (_UserStore2.default.hasPermission("view_analytics") || _UserStore2.default.hasPermission("view_sales_analytics")) && {
	            text: _react2.default.createElement(
	              "div",
	              { style: styles.menuItem },
	              "Sales analytics"
	            ),
	            route: "/event_buckets/" + b.id + "/analytics/sales"
	          }] : []).concat([_UserStore2.default.hasPermission("box_office") && {
	            route: "/event_buckets/" + b.id + "/box_office",
	            text: _react2.default.createElement(
	              "div",
	              {
	                style: {
	                  marginLeft: 20,
	                  fontWeight: 500
	                }
	              },
	              "Box office"
	            )
	          }, _UserStore2.default.hasPermission("view_film_list") && {
	            route: "/event_buckets/" + b.id + "/films",
	            text: _react2.default.createElement(
	              "div",
	              {
	                style: {
	                  marginLeft: 20,
	                  fontWeight: 500
	                }
	              },
	              "Films"
	            )
	          }].concat(currentRoutes.indexOf("films") !== -1 || currentRoutes.indexOf("film-editor") !== -1 || currentRoutes.indexOf("new-film") !== -1 || currentRoutes.indexOf("bulk-import-films") !== -1 ? [_UserStore2.default.hasPermission("edit_film") && {
	            text: _react2.default.createElement(
	              "div",
	              { style: styles.menuItem },
	              "Create new film"
	            ),
	            route: "/event_buckets/" + b.id + "/films/new"
	          }, _UserStore2.default.hasPermission("bulk_import_films") && {
	            text: _react2.default.createElement(
	              "div",
	              { style: styles.menuItem },
	              "Bulk import films"
	            ),
	            route: "/event_buckets/" + b.id + "/bulk_import_films"
	          }] : []).concat([b.enable_virtual_festival && (_UserStore2.default.hasPermission("manage_virtual_festival") || _UserStore2.default.hasPermission("view_virtual_event_list")) && {
	            route: "/event_buckets/" + b.id + "/virtual_festival",
	            text: _react2.default.createElement(
	              "div",
	              {
	                style: {
	                  marginLeft: 20,
	                  fontWeight: 500
	                }
	              },
	              "Virtual screenings"
	            )
	          }]).concat(currentRoutes.indexOf("virtual-festival") !== -1 || currentRoutes.indexOf("virtual-festival-event-editor") !== -1 || currentRoutes.indexOf("virtual-festival-events") !== -1 || currentRoutes.indexOf("virtual-festival-bulk-import-events") !== -1 ? [_UserStore2.default.hasPermission("manage_virtual_festival") && {
	            text: _react2.default.createElement(
	              "div",
	              { style: styles.menuItem },
	              "Create new virtual screening"
	            ),
	            route: "/event_buckets/" + b.id + "/events/new?virtual=true"
	          }, _UserStore2.default.hasPermission("manage_virtual_festival") && {
	            text: _react2.default.createElement(
	              "div",
	              { style: styles.menuItem },
	              "Livestreaming hub"
	            ),
	            route: "/event_buckets/" + b.id + "/virtual_festival/live"
	          }, _UserStore2.default.hasPermission("manage_virtual_festival") && {
	            text: _react2.default.createElement(
	              "div",
	              { style: styles.menuItem },
	              "Bulk import screenings"
	            ),
	            route: "/event_buckets/" + b.id + "/virtual_festival/bulk_import_events"
	          }
	          // TOO UNWIELDY
	          // ].concat(b.events.map(e => {
	          //   return {
	          //     text: <div style={styles.menuItem}>{e.name}</div>,
	          //     route: 'event',
	          //     routeParams: { eventBucketId: b.id, eventId: e.id }
	          //   }
	          // })) : []).concat([
	          ] : []).concat([false /* DISABLED */ && _UserStore2.default.hasPermission("edit_event") && currentEventBucket && currentEventBucket.class === "yearround" && {
	            route: "/event_buckets/" + b.id + "/scheduler",
	            text: _react2.default.createElement(
	              "div",
	              {
	                style: {
	                  marginLeft: 20,
	                  fontWeight: 500
	                }
	              },
	              "Scheduler"
	            )
	          }]).concat([_UserStore2.default.hasPermission("view_physical_event_list") && {
	            route: "/event_buckets/" + b.id + "/events",
	            text: _react2.default.createElement(
	              "div",
	              {
	                style: {
	                  marginLeft: 20,
	                  fontWeight: 500
	                }
	              },
	              "Physical events"
	            )
	          }]).concat(currentRoutes.indexOf("event") !== -1 || currentRoutes.indexOf("event-editor") !== -1 || currentRoutes.indexOf("events") !== -1 || currentRoutes.indexOf("bulk-import-events") !== -1 ? [_UserStore2.default.hasPermission("edit_physical_event") && {
	            text: _react2.default.createElement(
	              "div",
	              { style: styles.menuItem },
	              "Create new event"
	            ),
	            route: "/event_buckets/" + b.id + "/events/new"
	          }, _UserStore2.default.hasPermission("bulk_import_events") && {
	            text: _react2.default.createElement(
	              "div",
	              { style: styles.menuItem },
	              "Bulk import events"
	            ),
	            route: "/event_buckets/" + b.id + "/bulk_import_events"
	          }
	          // TOO UNWIELDY
	          // ].concat(b.events.map(e => {
	          //   return {
	          //     text: <div style={styles.menuItem}>{e.name}</div>,
	          //     route: 'event',
	          //     routeParams: { eventBucketId: b.id, eventId: e.id }
	          //   }
	          // })) : []).concat([
	          ] : []).concat([(_UserStore2.default.hasPermission("view_pass_bucket_list") || _UserStore2.default.hasPermission("print_pass_labels") || _UserStore2.default.hasPermission("box_office")) && {
	            route: "/event_buckets/" + b.id + "/pass_buckets",
	            text: _react2.default.createElement(
	              "div",
	              {
	                style: {
	                  marginLeft: 20,
	                  fontWeight: 500
	                }
	              },
	              "Pass buckets"
	            )
	          }]).concat(currentRoutes.indexOf("pass-buckets") !== -1 || currentRoutes.indexOf("pass-bucket") !== -1 || currentRoutes.indexOf("pass-bucket-editor") !== -1 || currentRoutes.indexOf("pass-label-printer") !== -1 || currentRoutes.indexOf("bulk-import-passes") !== -1 || currentRoutes.indexOf("pass-bucket-analytics") !== -1 || currentRoutes.indexOf("pass-bucket-check-in") !== -1 ? [_UserStore2.default.hasPermission("print_pass_labels") && {
	            text: _react2.default.createElement(
	              "div",
	              { style: styles.menuItem },
	              "Pass label printer"
	            ),
	            route: "/event_buckets/" + b.id + "/pass_label_printer"
	          }, _UserStore2.default.hasPermission("bulk_import_passes") && {
	            text: _react2.default.createElement(
	              "div",
	              { style: styles.menuItem },
	              "Bulk import passes"
	            ),
	            route: "/event_buckets/" + b.id + "/bulk_import_passes"
	          }, _UserStore2.default.hasPermission("box_office") && {
	            text: _react2.default.createElement(
	              "div",
	              { style: styles.menuItem },
	              "Check in passholders"
	            ),
	            route: "/event_buckets/" + b.id + "/pass_buckets/check_in"
	          }
	          // TOO UNWIELDY
	          // { isDivider: true, inset: true }
	          // ].concat(
	          //   b.pass_buckets.map(p => {
	          //   return UserStore.hasPermission('view_pass_bucket') && {
	          //     text: <div style={styles.menuItem}>{p.name}</div>,
	          //     route: `/event_buckets/${b.id}/pass_buckets/${p.id}`
	          //   }
	          // })) : []).concat([
	          ] : []).concat([b.frontend_config.memberships_enabled && {
	            route: "/event_buckets/" + b.id + "/memberships",
	            text: _react2.default.createElement(
	              "div",
	              {
	                style: {
	                  marginLeft: 20,
	                  fontWeight: 500
	                }
	              },
	              "Memberships"
	            )
	          }]).concat(currentRoutes.indexOf("memberships") !== -1 || currentRoutes.indexOf("membership") !== -1 || currentRoutes.indexOf("membership_editor") !== -1 || currentRoutes.indexOf("bulk-import-memberships") !== -1 || currentRoutes.indexOf("membership-check-in") !== -1 || currentRoutes.indexOf("membership-label-printer") !== -1 ? [_UserStore2.default.hasPermission("print_pass_labels") && {
	            text: _react2.default.createElement(
	              "div",
	              { style: styles.menuItem },
	              "Membership label printer"
	            ),
	            route: "/event_buckets/" + b.id + "/membership_label_printer"
	          }, _UserStore2.default.hasPermission("bulk_import_passes") && {
	            text: _react2.default.createElement(
	              "div",
	              { style: styles.menuItem },
	              "Bulk import memberships"
	            ),
	            route: "/event_buckets/" + b.id + "/bulk_import_memberships"
	          }, _UserStore2.default.hasPermission("box_office") && {
	            text: _react2.default.createElement(
	              "div",
	              { style: styles.menuItem },
	              "Pick up memberships"
	            ),
	            route: "/event_buckets/" + b.id + "/memberships/check_in"
	          }] : []).concat([_UserStore2.default.hasPermission("view_coupon_list") && {
	            route: "/event_buckets/" + b.id + "/coupons",
	            text: _react2.default.createElement(
	              "div",
	              {
	                style: {
	                  marginLeft: 20,
	                  fontWeight: 500
	                }
	              },
	              "Discounts"
	            )
	          }]).concat(currentRoutes.indexOf("coupon") !== -1 || currentRoutes.indexOf("coupons") !== -1 || currentRoutes.indexOf("coupon-editor") !== -1 ? [_UserStore2.default.hasPermission("edit_coupon") && {
	            text: _react2.default.createElement(
	              "div",
	              { style: styles.menuItem },
	              "Create new discount"
	            ),
	            route: "/event_buckets/" + b.id + "/coupons/new"
	          }
	          // TOO UNWIELDY
	          // ].concat(
	          //   b.coupons.map(c => {
	          //   return {
	          //     text: <div style={styles.menuItem}>{c.name}</div>,
	          //     route: 'coupon',
	          //     routeParams: { eventBucketId: b.id, couponId: c.id }
	          //   }
	          // })) : []).concat([
	          ] : []).concat([_UserStore2.default.hasPermission("manage_venues") && {
	            route: "/event_buckets/" + b.id + "/venues",
	            text: _react2.default.createElement(
	              "div",
	              {
	                style: {
	                  marginLeft: 20,
	                  fontWeight: 500
	                }
	              },
	              "Venues"
	            )
	          }]).concat(currentRoutes.indexOf("venue") !== -1 || currentRoutes.indexOf("venues") !== -1 ? [_UserStore2.default.hasPermission("manage_venues") && {
	            text: _react2.default.createElement(
	              "div",
	              { style: styles.menuItem },
	              "Create new venue"
	            ),
	            route: "/event_buckets/" + b.id + "/venues/new"
	          }
	          // TOO UNWIELDY
	          // ].concat(
	          //   b.venues.map(v => {
	          //   return {
	          //     text: <div style={styles.menuItem}>{v.name}</div>,
	          //     route: 'coupon',
	          //     routeParams: { eventBucketId: b.id, venueId: v.id }
	          //   }
	          // })) : []).concat([
	          ] : []).concat([_UserStore2.default.hasPermission("manage_tags") && {
	            route: "/event_buckets/" + b.id + "/tags",
	            text: _react2.default.createElement(
	              "div",
	              {
	                style: {
	                  marginLeft: 20,
	                  fontWeight: 500
	                }
	              },
	              "Tags"
	            )
	          }]).concat(currentRoutes.indexOf("tag") !== -1 || currentRoutes.indexOf("tags") !== -1 ? [_UserStore2.default.hasPermission("manage_tags") && {
	            text: _react2.default.createElement(
	              "div",
	              { style: styles.menuItem },
	              "Create new tag"
	            ),
	            route: "/event_buckets/" + b.id + "/tags/new"
	          }
	          // TOO UNWIELDY
	          // ].concat(
	          //   b.venues.map(v => {
	          //   return {
	          //     text: <div style={styles.menuItem}>{v.name}</div>,
	          //     route: 'coupon',
	          //     routeParams: { eventBucketId: b.id, venueId: v.id }
	          //   }
	          // })) : []).concat([
	          ] : []).concat([false && // KIOSKS CURRENTLY DISABLED
	          _UserStore2.default.hasPermission("manage_kiosks") && {
	            route: "/event_buckets/" + b.id + "/kiosks",
	            text: _react2.default.createElement(
	              "div",
	              {
	                style: {
	                  marginLeft: 20,
	                  fontWeight: 500
	                }
	              },
	              "Kiosks"
	            )
	          }]).concat(currentRoutes.indexOf("kiosk") !== -1 || currentRoutes.indexOf("kiosks") !== -1 ? [
	            // UserStore.hasPermission('manage_kiosks') && {
	            //   text: <div style={styles.menuItem}>Create new kiosk</div>,
	            //   route: `/event_buckets/${b.id}/kiosks/new`
	            // }
	            // TOO UNWIELDY
	            // ].concat(
	            //   b.kiosks.map(k => {
	            //   return {
	            //     text: <div style={styles.menuItem}>{k.name}</div>,
	            //     route: 'kiosk',
	            //     routeParams: { eventBucketId: b.id, kioskId: k.id }
	            //   }
	            // })) : [])
	          ] : []).concat([_UserStore2.default.hasPermission("manage_mailings") && {
	            route: "/event_buckets/" + b.id + "/mailings",
	            text: _react2.default.createElement(
	              "div",
	              {
	                style: {
	                  marginLeft: 20,
	                  fontWeight: 500
	                }
	              },
	              "Mailings"
	            )
	          }]).concat(currentRoutes.indexOf("mailing") !== -1 || currentRoutes.indexOf("mailings") !== -1 ? [_UserStore2.default.hasPermission("manage_mailings") && {
	            text: _react2.default.createElement(
	              "div",
	              { style: styles.menuItem },
	              "Create new mailing"
	            ),
	            route: "/event_buckets/" + b.id + "/mailings/new"
	          }] : []).concat(b.enable_balloting ? _UserStore2.default.hasPermission("manage_balloting") || _UserStore2.default.hasPermission("view_balloting") ? [{
	            route: "/event_buckets/" + b.id + "/balloting",
	            text: _react2.default.createElement(
	              "div",
	              {
	                style: {
	                  marginLeft: 20,
	                  fontWeight: 500
	                }
	              },
	              "Balloting"
	            )
	          }] : _UserStore2.default.hasPermission("app_balloting") ? [{
	            route: "/event_buckets/" + b.id + "/balloting/app",
	            text: _react2.default.createElement(
	              "div",
	              {
	                style: {
	                  marginLeft: 20,
	                  fontWeight: 500
	                }
	              },
	              "Balloting"
	            )
	          }] : [] : []).concat([_UserStore2.default.hasPermission("manage_external_syncs") && {
	            route: "/event_buckets/" + b.id + "/external_syncs",
	            text: _react2.default.createElement(
	              "div",
	              {
	                style: {
	                  marginLeft: 20,
	                  fontWeight: 500
	                }
	              },
	              "External syncs"
	            )
	          }]).concat(currentRoutes.indexOf("external-sync") !== -1 || currentRoutes.indexOf("external-syncs") !== -1 ? [_UserStore2.default.hasPermission("manage_external_syncs") && {
	            text: _react2.default.createElement(
	              "div",
	              { style: styles.menuItem },
	              "Create new external sync"
	            ),
	            route: "/event_buckets/" + b.id + "/external_syncs/new"
	          }] : []).concat([_UserStore2.default.hasPermission("view_item_bucket") && {
	            route: "/event_buckets/" + b.id + "/item_buckets",
	            text: _react2.default.createElement(
	              "div",
	              {
	                style: {
	                  marginLeft: 20,
	                  fontWeight: 500
	                }
	              },
	              "Item buckets"
	            )
	          }]).concat(currentRoutes.indexOf("item-bucket") !== -1 || currentRoutes.indexOf("item-buckets") !== -1 || currentRoutes.indexOf("item-bucket-editor") !== -1 ? [_UserStore2.default.hasPermission("edit_item_bucket") && {
	            text: _react2.default.createElement(
	              "div",
	              { style: styles.menuItem },
	              "Create new item bucket"
	            ),
	            route: "/event_buckets/" + b.id + "/item_buckets/new"
	          }] : []).concat([_UserStore2.default.hasPermission(["manage_people", "view_people"]) && {
	            route: "/event_buckets/" + b.id + "/people",
	            text: _react2.default.createElement(
	              "div",
	              {
	                style: {
	                  marginLeft: 20,
	                  fontWeight: 500
	                }
	              },
	              "People"
	            )
	          }, _UserStore2.default.hasPermission(["manage_orders", "view_orders"]) && {
	            route: "/event_buckets/" + b.id + "/orders",
	            text: _react2.default.createElement(
	              "div",
	              {
	                style: {
	                  marginLeft: 20,
	                  fontWeight: 500
	                }
	              },
	              "Orders"
	            )
	          }])));
	        })));
	
	        if (archivedEventBuckets.length) {
	          menuItems = menuItems.concat([{
	            key: "archive",
	            text: "Archive",
	            isCollapsible: true,
	            subitems: archivedEventBuckets.map(function (b) {
	              return {
	                route: "/event_buckets/" + b.id,
	                text: _react2.default.createElement(
	                  "div",
	                  {
	                    style: {
	                      marginLeft: 20
	                    }
	                  },
	                  b.name
	                )
	              };
	            })
	          }]);
	        }
	      }
	
	      if (_UserStore2.default.hasPermission("view_analytics") || _UserStore2.default.hasRole("manager")) {
	        menuItems = menuItems.concat([{ isDivider: true }, { text: "Global", isSubheader: true }].concat([{
	          route: "/people",
	          text: "All customers"
	        }]).concat([(currentRoutes.indexOf("bulk-import-people") !== -1 || currentRoutes.indexOf("people") !== -1) && {
	          route: "/bulk_import_people",
	          text: _react2.default.createElement(
	            "div",
	            {
	              style: {
	                marginLeft: 20
	              }
	            },
	            "Bulk import people"
	          )
	        }]).concat([{
	          route: "/orders",
	          text: "All orders"
	        }, _UserStore2.default.hasPermission("view_global_reports") && {
	          route: "/reports",
	          text: "Global reports"
	        }, _UserStore2.default.isGod() && {
	          route: "/scheduled_reports",
	          text: _react2.default.createElement(
	            "span",
	            null,
	            "Scheduled reports",
	            " ",
	            _react2.default.createElement(_inlineNoticeLabel2.default, {
	              style: { marginLeft: 5, fontWeight: "bold" },
	              label: "God beta"
	            })
	          )
	        }]));
	      }
	
	      if (_UserStore2.default.hasPermission("manage_virtual_festival") || _UserStore2.default.hasPermission("manage_scanner") || _UserStore2.default.hasPermission("setup_scanner")) {
	        menuItems = menuItems.concat([!_UserStore2.default.hasPermission("view_analytics") && { isDivider: true }, {
	          key: "more",
	          text: "More",
	          isCollapsible: true,
	          subitems: [_UserStore2.default.hasPermission("manage_virtual_festival") && {
	            text: _react2.default.createElement(
	              "div",
	              {
	                style: {
	                  marginLeft: 20
	                }
	              },
	              "Creator Hub"
	            ),
	            route: "/creator_hub"
	          }, (_UserStore2.default.hasPermission("manage_scanner") || _UserStore2.default.hasPermission("setup_scanner")) && {
	            route: "/account/scanner",
	            text: _react2.default.createElement(
	              "div",
	              {
	                style: {
	                  marginLeft: 20
	                }
	              },
	              "Scanner setup"
	            )
	          }, _UserStore2.default.hasPermission("manage_scanner") && {
	            route: "/shop",
	            text: _react2.default.createElement(
	              "div",
	              {
	                style: {
	                  marginLeft: 20
	                }
	              },
	              "Hardware shop"
	            )
	          }].filter(function (x) {
	            return !!x;
	          })
	        }]);
	      }
	
	      if (_UserStore2.default.isGod()) {
	        menuItems = menuItems.concat([{ isDivider: true }, {
	          route: "/god",
	          text: "🕊"
	        }, _UserStore2.default.isBillingGod() && {
	          route: "/god/invoicing_hub",
	          text: "🦆"
	        }, {
	          route: "/god_orders",
	          text: "💸"
	        }, {
	          route: "/organization_health",
	          text: "🩺"
	        }, {
	          route: "/god/revenue",
	          text: "📈"
	        }, {
	          route: "/god/streams",
	          text: "📺"
	        }, {
	          route: "/god/upcoming_events",
	          text: "📅"
	        }, {
	          route: "/god/lookup",
	          text: "🔎"
	        }]);
	      }
	
	      // Remove hasPermission=false items
	      menuItems = menuItems.filter(function (i) {
	        return i !== false;
	      });
	
	      return _react2.default.createElement(
	        _pageWithNav2.default,
	        { menuItems: menuItems },
	        this.props.children
	      );
	    }
	  }], [{
	    key: "getStores",
	    value: function getStores() {
	      return [_EventBucketStore2.default, _UserStore2.default];
	    }
	  }, {
	    key: "getPropsFromStores",
	    value: function getPropsFromStores() {
	      var state = _EventBucketStore2.default.getState();
	      state.isLoggedIn = _UserStore2.default.getState().isLoggedIn;
	      return state;
	    }
	  }, {
	    key: "componentDidConnect",
	    value: function componentDidConnect(props) {
	      _EventBucketActions2.default.fetchAll.defer();
	      _UserActions2.default.fetchRoles.defer();
	    }
	  }, {
	    key: "contextTypes",
	    get: function get() {
	      return {
	        router: _react2.default.PropTypes.object,
	        muiTheme: _react2.default.PropTypes.object
	      };
	    }
	  }]);
	
	  return Dashboard;
	}(_react2.default.Component);
	
	exports.default = (0, _connectToStores2.default)(Dashboard);
	module.exports = exports["default"];

/***/ }),
/* 1672 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(486);
	
	var _materialUi = __webpack_require__(576);
	
	var _assign = __webpack_require__(920);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _styles = __webpack_require__(917);
	
	var _withWidth = __webpack_require__(886);
	
	var _withWidth2 = _interopRequireDefault(_withWidth);
	
	var _menuInsetDivider = __webpack_require__(1673);
	
	var _menuInsetDivider2 = _interopRequireDefault(_menuInsetDivider);
	
	var _UserActions = __webpack_require__(1158);
	
	var _UserActions2 = _interopRequireDefault(_UserActions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SIDEBAR_STATE_LOCALSTORAGE_KEY = "eventive--sidebarCollapsed";
	
	var initialSidebarCollapsedState = false;
	try {
	  var rawValue = window.localStorage.getItem(SIDEBAR_STATE_LOCALSTORAGE_KEY);
	  if (typeof rawValue !== "undefined") {
	    initialSidebarCollapsedState = JSON.parse(rawValue);
	  }
	} catch (e) {
	  // fall through
	}
	window.__eventiveSidebarCollapsed = initialSidebarCollapsedState;
	
	var PageWithNav = function (_React$Component) {
	  _inherits(PageWithNav, _React$Component);
	
	  function PageWithNav(props) {
	    _classCallCheck(this, PageWithNav);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(PageWithNav).call(this, props));
	
	    _this.state = {
	      openedCollapsibles: {},
	      sidebarCollapsed: initialSidebarCollapsedState,
	      sidebarTemporarilyOpened: false,
	      justChangedSidebar: false,
	      justMounted: true
	    };
	
	    _this._onScrollNav = _this._onScrollNav.bind(_this);
	    _this._onToggleCollapsed = _this._onToggleCollapsed.bind(_this);
	    return _this;
	  }
	
	  _createClass(PageWithNav, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      setTimeout(function () {
	        return _this2.setState({ justMounted: false });
	      }, 100);
	    }
	  }, {
	    key: "getStyles",
	    value: function getStyles() {
	      var subNavWidth = _styles.spacing.desktopKeylineIncrement * 4 + "px";
	      var styles = {
	        root: {
	          //paddingTop: Spacing.desktopKeylineIncrement + 'px'
	        },
	        rootWhenMedium: {
	          position: "relative"
	        },
	        secondaryNav: {
	          borderTop: "solid 1px " + _styles.colors.grey300,
	          zIndex: 999
	        },
	        content: {
	          boxSizing: "border-box",
	          padding: _styles.spacing.desktopGutter + "px"
	          //maxWidth: (Spacing.desktopKeylineIncrement * 14) + 'px'
	        },
	        secondaryNavWhenMedium: {
	          borderTop: "none",
	          position: "fixed",
	          top: "64px",
	          left: "0px",
	          width: subNavWidth,
	          height: "calc(100vh - 64px)",
	          // overflowY: "scroll",
	          borderRight: "solid 1px " + _styles.colors.grey300,
	          boxShadow: "rgba(0, 0, 0, 0.156863) 0px 3px 10px, rgba(0, 0, 0, 0.227451) 0px 3px 10px"
	        },
	        contentWhenMedium: {
	          transition: this.state.justMounted ? "" : "margin 0.2s ease-in-out",
	          marginLeft: this.state.sidebarCollapsed ? "" : subNavWidth,
	          padding: "32px",
	          minHeight: "85vh"
	        },
	        menuItem: {
	          fontSize: "13px",
	          cursor: "pointer",
	          padding: 0
	        },
	        menuItemActive: {
	          color: _styles.colors.lightBlue700,
	          fontWeight: "500"
	          //backgroundColor: 'rgba(33,33,33,0.08)'
	        },
	        menuItemInner: {
	          padding: "0 8px"
	        },
	        subheaderMenuItem: {
	          cursor: "inherit",
	          marginLeft: 24
	        },
	        subheaderMenuItemInner: {
	          //color: Colors.lightBlue700,
	          color: "rgb(33,33,33)",
	          padding: 0,
	          fontWeight: "500",
	          borderBottom: "1px solid",
	          width: 208,
	          //display: 'inline-block',
	          lineHeight: "36px",
	          marginBottom: 6,
	          marginTop: 6
	        },
	        subheaderCollapsible: {}
	      };
	
	      if (this.props.width === _withWidth.MEDIUM || this.props.width === _withWidth.LARGE) {
	        styles.root = (0, _assign2.default)({}, styles.root, styles.rootWhenMedium);
	        styles.secondaryNav = (0, _assign2.default)({}, styles.secondaryNav, styles.secondaryNavWhenMedium);
	        styles.content = (0, _assign2.default)({}, styles.content, styles.contentWhenMedium);
	      }
	
	      return styles;
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this3 = this;
	
	      var styles = this.getStyles();
	      var items = this.props.menuItems;
	
	      // add opened collapsibles
	      items = items.reduce(function (f, item) {
	        f.push(item);
	        if (item.isCollapsible && _this3.state.openedCollapsibles[item.key]) {
	          f = f.concat(item.subitems);
	        }
	        return f;
	      }, []);
	
	      var menuItems = items.map(function (x, i) {
	        return x.isDivider ? x.inset ? _react2.default.createElement(_menuInsetDivider2.default, { key: i }) : _react2.default.createElement(_materialUi.Divider, { key: i }) : function () {
	          var menuItem = _react2.default.createElement(_materialUi.MenuItem, {
	            key: i,
	            style: (0, _assign2.default)({}, styles.menuItem, x.isSubheader ? styles.subheaderMenuItem : {}, x.isFirst ? styles.subheaderFirstMenuItem : {}, !x.isSubheader && x.route && _this3.context.router.isActive(x.route) ? styles.menuItemActive : {}, x.isCollapsible && styles.subheaderCollapsible, x.disabled && { pointerEvents: "none" }),
	            primaryText: _react2.default.createElement(
	              "div",
	              {
	                style: (0, _assign2.default)({}, styles.menuItemInner, x.isSubheader && styles.subheaderMenuItemInner)
	              },
	              x.isCollapsible ? _this3.state.openedCollapsibles[x.key] ? "▾ " : "▸ " : "",
	              x.text
	            ),
	            disabled: x.isSubheader,
	            onClick: x.isCollapsible ? function () {
	              var openedCollapsibles = _this3.state.openedCollapsibles;
	
	              openedCollapsibles[x.key] = !openedCollapsibles[x.key];
	              _this3.setState({ openedCollapsibles: openedCollapsibles });
	            } : undefined
	          });
	
	          if (x.route) {
	            return _react2.default.createElement(
	              _reactRouter.Link,
	              { style: { textDecoration: "none" }, to: x.route },
	              menuItem
	            );
	          } else {
	            return menuItem;
	          }
	        }();
	      });
	
	      var isSidebarCollapsed = this.props.width !== _withWidth.SMALL && this.state.sidebarCollapsed && !this.state.sidebarTemporarilyOpened;
	
	      return _react2.default.createElement(
	        "div",
	        { style: styles.root },
	        _react2.default.createElement(
	          "div",
	          { style: styles.content, className: "print-reset-content" },
	          this.props.children
	        ),
	        _react2.default.createElement(
	          "div",
	          {
	            style: Object.assign({ transition: "margin 0.2s ease-in-out" }, styles.secondaryNav, isSidebarCollapsed && {
	              marginLeft: -236
	            }),
	            onMouseEnter: function onMouseEnter() {
	              if (!_this3.state.justChangedSidebar) {
	                _this3.setState({ sidebarTemporarilyOpened: true });
	              }
	            },
	            onMouseLeave: function onMouseLeave() {
	              if (!_this3.state.justChangedSidebar) {
	                _this3.setState({ sidebarTemporarilyOpened: false });
	              }
	            },
	            className: "no-print"
	          },
	          _react2.default.createElement(
	            _materialUi.Paper,
	            {
	              zDepth: 0,
	              style: Object.assign({
	                position: "relative"
	              }, this.props.width !== _withWidth.SMALL && {
	                height: "100%",
	                overflowY: isSidebarCollapsed ? "hidden" : "scroll"
	              }),
	              ref: function ref(r) {
	                _this3.secondaryNavContainer = r;
	              },
	              onWheel: this._onScrollNav
	            },
	            this.props.width !== _withWidth.SMALL ? _react2.default.createElement(
	              "div",
	              {
	                style: {
	                  position: "fixed",
	                  left: isSidebarCollapsed ? 3 : 239,
	                  top: 80,
	                  zIndex: 3000,
	                  transition: "all 0.2s ease-in-out"
	                }
	              },
	              _react2.default.createElement(
	                _materialUi.IconButton,
	                {
	                  tooltip: this.state.sidebarCollapsed ? this.state.sidebarTemporarilyOpened ? "Pin sidebar open" : "Expand sidebar" : "Collapse sidebar",
	                  onTouchTap: this._onToggleCollapsed,
	                  style: {
	                    backgroundColor: "#e5e5e5",
	                    border: "1px solid #fff",
	                    borderRadius: "100%",
	                    width: 36,
	                    height: 36,
	                    padding: 4
	                  },
	                  iconStyle: { width: 24, height: 24 },
	                  tooltipStyles: { marginTop: -16, marginLeft: 36 },
	                  tooltipPosition: "center-right"
	                },
	                this.state.sidebarCollapsed && this.state.sidebarTemporarilyOpened ? _react2.default.createElement(
	                  _materialUi.SvgIcon,
	                  { viewBox: "0 0 48 48" },
	                  _react2.default.createElement("path", { d: "M31.7 25.6 36 29.45V32.45H25.5V44.5L24 46L22.5 44.5V32.45H12V29.45L16 25.6V9H13.5V6H34.2V9H31.7ZM16.05 29.45H31.65L28.7 26.7V9H19V26.7ZM23.85 29.45Z" })
	                ) : this.state.sidebarCollapsed ? _react2.default.createElement(
	                  _materialUi.SvgIcon,
	                  { viewBox: "0 0 48 48" },
	                  _react2.default.createElement("path", { d: "M6 36V33H42V36ZM6 25.5V22.5H42V25.5ZM6 15V12H42V15Z" })
	                ) : _react2.default.createElement(
	                  _materialUi.SvgIcon,
	                  { viewBox: "0 0 48 48" },
	                  _react2.default.createElement("path", { d: "M6 36v-3h26v3Zm0-10.6v-3h20v3ZM6 15v-3h26v3Zm33.9 18.4-9.45-9.45 9.4-9.4L42 16.7l-7.25 7.25 7.3 7.3Z" })
	                )
	              )
	            ) : null,
	            _react2.default.createElement(
	              _materialUi.Menu,
	              {
	                disableAutoFocus: true,
	                ref: "menuItems",
	                listStyle: Object.assign({ transition: "opacity 0.2s ease-in-out" }, isSidebarCollapsed ? { opacity: 0, pointerEvents: "none" } : { opacity: 1 })
	              },
	              menuItems
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: "_getSelectedIndex",
	    value: function _getSelectedIndex() {
	      var menuItems = this.props.menuItems;
	      var currentItem = void 0;
	
	      for (var i = menuItems.length - 1; i >= 0; i--) {
	        currentItem = menuItems[i];
	        if (currentItem.route && this.context.router.isActive(currentItem.route, currentItem.routeParams)) return i;
	      }
	    }
	  }, {
	    key: "_onScrollNav",
	    value: function _onScrollNav(e) {
	      // Don't interrupt scrolling on mobile
	      if (this.props.width === _withWidth.SMALL) {
	        return;
	      }
	
	      // Otherwise, ensure that user scrolling within secondary nav doesn't affect rest of the page
	      var el = this.secondaryNavContainer,
	          hitBottom = el.scrollHeight - el.scrollTop === el.clientHeight,
	          hitTop = el.scrollTop === 0,
	          scrollingDown = e.deltaY > 0;
	
	      if (scrollingDown && hitBottom || !scrollingDown && hitTop) {
	        e.preventDefault();
	        e.stopPropagation();
	      }
	    }
	  }, {
	    key: "_onToggleCollapsed",
	    value: function _onToggleCollapsed() {
	      var _this4 = this;
	
	      var sidebarCollapsed = !this.state.sidebarCollapsed;
	
	      try {
	        window.__eventiveSidebarCollapsed = sidebarCollapsed;
	        window.localStorage.setItem(SIDEBAR_STATE_LOCALSTORAGE_KEY, sidebarCollapsed);
	      } catch (e) {}
	      // fall through
	
	
	      // Hack: Refresh user store to trigger App component to re-render footer with
	      // appropriate left padding
	      _UserActions2.default.clearErrors.defer();
	
	      this.setState({
	        sidebarCollapsed: sidebarCollapsed,
	        sidebarTemporarilyOpened: false,
	        justChangedSidebar: true
	      });
	
	      setTimeout(function () {
	        _this4.setState({ justChangedSidebar: false });
	      }, 100);
	    }
	  }], [{
	    key: "contextTypes",
	    get: function get() {
	      return {
	        router: _react2.default.PropTypes.object
	      };
	    }
	  }]);
	
	  return PageWithNav;
	}(_react2.default.Component);
	
	exports.default = (0, _withWidth2.default)()(PageWithNav);
	module.exports = exports["default"];

/***/ }),
/* 1673 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(956);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MenuInsetDivider = function MenuInsetDivider(props, context) {
	  var style = props.style;
	  var _context$muiTheme = context.muiTheme;
	  var baseTheme = _context$muiTheme.baseTheme;
	  var prepareStyles = _context$muiTheme.prepareStyles;
	
	
	  var styles = {
	    root: {
	      margin: 0,
	      marginTop: 8,
	      marginBottom: 7,
	      marginLeft: 64,
	      width: 140,
	      height: 1,
	      border: "none",
	      backgroundColor: baseTheme.palette.borderColor
	    }
	  };
	
	  return _react2.default.createElement("hr", { style: prepareStyles(Object.assign(styles.root, style)) });
	};
	
	MenuInsetDivider.propTypes = {
	  style: _propTypes2.default.object
	};
	
	MenuInsetDivider.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	
	exports.default = MenuInsetDivider;
	module.exports = exports["default"];

/***/ }),
/* 1674 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _radium = __webpack_require__(1600);
	
	var _radium2 = _interopRequireDefault(_radium);
	
	var _styles = __webpack_require__(917);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var styles = {
	  base: {
	    cursor: "pointer",
	    display: "inline-block",
	    fontWeight: "normal",
	    padding: "2px 5px",
	    lineHeight: "14px",
	    fontSize: 11,
	    borderRadius: 5,
	    border: "1px solid " + _styles.colors.lightBlue700,
	    color: _styles.colors.lightBlue700,
	    transition: "0.1s ease-in-out",
	    ":hover": {
	      backgroundColor: _styles.colors.lightBlue700,
	      color: "#fff"
	    }
	  }
	};
	
	var InlineButton = function (_React$Component) {
	  _inherits(InlineButton, _React$Component);
	
	  function InlineButton() {
	    _classCallCheck(this, InlineButton);
	
	    return _possibleConstructorReturn(this, Object.getPrototypeOf(InlineButton).apply(this, arguments));
	  }
	
	  _createClass(InlineButton, [{
	    key: "render",
	    value: function render() {
	      var _props = this.props;
	      var label = _props.label;
	      var style = _props.style;
	      var onTouchTap = _props.onTouchTap;
	      var onClick = _props.onClick;
	
	
	      return _react2.default.createElement(
	        "div",
	        {
	          onClick: onClick,
	          onTouchTap: onTouchTap,
	          style: [styles.base, style]
	        },
	        label
	      );
	    }
	  }]);
	
	  return InlineButton;
	}(_react2.default.Component);
	
	exports.default = (0, _radium2.default)(InlineButton);
	module.exports = exports["default"];

/***/ }),
/* 1675 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _materialUi = __webpack_require__(576);
	
	var _reactRouter = __webpack_require__(486);
	
	var _workingIndicator = __webpack_require__(1664);
	
	var _workingIndicator2 = _interopRequireDefault(_workingIndicator);
	
	var _selectWells = __webpack_require__(1676);
	
	var _selectWells2 = _interopRequireDefault(_selectWells);
	
	var _connectToStores = __webpack_require__(1226);
	
	var _connectToStores2 = _interopRequireDefault(_connectToStores);
	
	var _EventBucketStore = __webpack_require__(1593);
	
	var _EventBucketStore2 = _interopRequireDefault(_EventBucketStore);
	
	var _UserStore = __webpack_require__(974);
	
	var _UserStore2 = _interopRequireDefault(_UserStore);
	
	var _movie = __webpack_require__(1677);
	
	var _movie2 = _interopRequireDefault(_movie);
	
	var _accountBalance = __webpack_require__(1678);
	
	var _accountBalance2 = _interopRequireDefault(_accountBalance);
	
	var _cake = __webpack_require__(1679);
	
	var _cake2 = _interopRequireDefault(_cake);
	
	var _util = __webpack_require__(1183);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Welcome = function (_React$Component) {
	  _inherits(Welcome, _React$Component);
	
	  function Welcome(props) {
	    _classCallCheck(this, Welcome);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(Welcome).call(this, props));
	
	    _this.getStyles = _this.getStyles.bind(_this);
	    return _this;
	  }
	
	  _createClass(Welcome, [{
	    key: "componentWillMount",
	    value: function componentWillMount() {
	      this.componentWillReceiveProps();
	    }
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      window.Intercom("boot", {
	        app_id: "oj5vkp3b"
	      });
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps() {}
	  }, {
	    key: "getStyles",
	    value: function getStyles() {
	      var isLarge = this.context.isLarge;
	
	
	      return {
	        img: {
	          height: 35
	        },
	        content: {
	          maxWidth: 600,
	          padding: 20,
	          textAlign: "center",
	          margin: isLarge ? "10vh auto 0" : "10px auto 0",
	          borderRadius: 10
	        },
	        jump: {
	          margin: "20px -20px -20px",
	          backgroundColor: "#f1f1f1",
	          padding: 10,
	          borderRadius: "0 0 10px 10px"
	        }
	      };
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var styles = this.getStyles();
	      var _props = this.props;
	      var eventBuckets = _props.eventBuckets;
	      var isFetchingEventBuckets = _props.isFetchingEventBuckets;
	
	
	      if (_UserStore2.default.getUserType() === "content_creator") {
	        return _react2.default.createElement(
	          "div",
	          { style: styles.content },
	          _react2.default.createElement(
	            "h2",
	            null,
	            _react2.default.createElement("img", {
	              src: "/img/eventive-dark.png",
	              alt: "Eventive",
	              style: styles.img
	            })
	          ),
	          _react2.default.createElement(
	            "p",
	            { style: { fontSize: "14pt", margin: "1em 0 1.5em" } },
	            "Welcome to Eventive! Your account grants you limited access to the Eventive Platform. What would you like to do?"
	          ),
	          _react2.default.createElement(_selectWells2.default, {
	            options: [{
	              value: "creator_hub",
	              icon: _movie2.default,
	              label: "Creator Hub",
	              sublabel: "Upload content for other organizations"
	            }, {
	              value: "revenue_sharing",
	              icon: _accountBalance2.default,
	              label: "Revenue Sharing",
	              sublabel: "Receive revenue from other organizations"
	            }, {
	              value: "host",
	              icon: _cake2.default,
	              label: "Upgrade",
	              sublabel: "Upgrade your account to host your own screenings"
	            }],
	            onChange: function onChange(v) {
	              if (v === "host") {
	                window.open("https://eventive.org/pricing", "_blank");
	                return;
	              }
	              _this2.context.router.push("/" + v);
	            }
	          })
	        );
	      }
	
	      return _react2.default.createElement(
	        _materialUi.Paper,
	        { zIndex: 2, style: styles.content },
	        _react2.default.createElement(
	          "h2",
	          null,
	          _react2.default.createElement("img", { src: "/img/eventive-dark.png", alt: "Eventive", style: styles.img })
	        ),
	        _react2.default.createElement(
	          "p",
	          null,
	          "Welcome to the Eventive Dashboard! Have you checked out our",
	          " ",
	          _react2.default.createElement(
	            "a",
	            { href: "https://help.eventive.org", target: "_blank" },
	            "Help Center"
	          ),
	          " ",
	          "lately? It's filled with guides and resources for making your events a success."
	        ),
	        isFetchingEventBuckets ? _react2.default.createElement(_workingIndicator2.default, null) : eventBuckets.length === 0 ? _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement(_materialUi.RaisedButton, {
	            label: "Create your first event bucket",
	            primary: true
	            // href="https://help.eventive.org/getting-started/create-your-first-event-bucket"
	            // target="_blank"
	            , onTouchTap: function onTouchTap() {
	              return _this2.context.router.push("/event_buckets/new?force=true");
	            }
	          })
	        ) : _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(_materialUi.RaisedButton, {
	              label: "Ask us a question right now",
	              onTouchTap: function onTouchTap() {
	                return Intercom("showNewMessage");
	              }
	            })
	          ),
	          _react2.default.createElement(
	            "div",
	            { style: styles.jump },
	            _react2.default.createElement(
	              "strong",
	              null,
	              "Jump to:"
	            ),
	            " ",
	            (0, _util.intersperse)(eventBuckets.filter(function (b) {
	              return b.mode !== "archived";
	            }).map(function (b) {
	              return _react2.default.createElement(
	                _reactRouter.Link,
	                { key: b.id, to: "/event_buckets/" + b.id },
	                b.name
	              );
	            }), " · ")
	          )
	        )
	      );
	    }
	  }], [{
	    key: "getStores",
	    value: function getStores() {
	      return [_UserStore2.default, _EventBucketStore2.default];
	    }
	  }, {
	    key: "getPropsFromStores",
	    value: function getPropsFromStores() {
	      return {
	        eventBuckets: _EventBucketStore2.default.getEventBuckets(),
	        isFetchingEventBuckets: _EventBucketStore2.default.getState().isFetchingAll
	      };
	    }
	  }]);
	
	  return Welcome;
	}(_react2.default.Component);
	
	Welcome.contextTypes = {
	  isLarge: _react2.default.PropTypes.bool,
	  router: _react2.default.PropTypes.object
	};
	exports.default = (0, _connectToStores2.default)(Welcome);
	module.exports = exports["default"];

/***/ }),
/* 1676 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _radium = __webpack_require__(1600);
	
	var _radium2 = _interopRequireDefault(_radium);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var STYLES = {
	  container: {
	    display: "flex",
	    margin: "-0.5em",
	    color: "#616161",
	    flexWrap: "wrap"
	  },
	  well: {
	    flex: 1,
	    minWidth: 100,
	    display: "flex",
	    justifyContent: "center",
	    alignItems: "center",
	    textAlign: "center",
	    cursor: "pointer",
	    borderRadius: 5,
	    padding: "1em",
	    margin: "0.5em",
	    boxShadow: "0px 0px 5px #ccc",
	    transition: "0.2s all ease-in-out",
	    ":hover": {
	      boxShadow: "rgb(2, 94, 209) 0px 0px 5px"
	    }
	  },
	  selected: {
	    boxShadow: "rgb(2, 94, 209) 0px 0px 10px",
	    ":hover": {
	      boxShadow: "rgb(2, 94, 209) 0px 0px 10px"
	    }
	  },
	  disabled: {
	    backgroundColor: "rgb(229, 229, 229)",
	    boxShadow: "none",
	    cursor: "not-allowed",
	    color: "rgba(33, 33, 33, 0.3)",
	    ":hover": {
	      boxShadow: "none"
	    }
	  },
	  icon: {
	    width: 50,
	    height: 50,
	    color: "#616161",
	    verticalAlign: "-18px"
	  },
	  label: {
	    fontSize: "1.4em",
	    marginLeft: "0.5em",
	    display: "inline-block"
	  },
	  sublabel: {
	    fontSize: "1em",
	    marginTop: "0.5em",
	    lineHeight: "1em"
	  },
	  labelWithSublabel: {
	    display: "block",
	    marginLeft: 0
	  }
	};
	
	var SelectWells = function SelectWells(_ref) {
	  var style = _ref.style;
	  var options = _ref.options;
	  var value = _ref.value;
	  var onChange = _ref.onChange;
	
	  return React.createElement(
	    "div",
	    { style: [STYLES.container, style] },
	    options.map(function (o) {
	      return React.createElement(
	        "div",
	        {
	          key: o.value,
	          style: [STYLES.well, value === o.value && STYLES.selected, o.disabled && STYLES.disabled],
	          onTouchTap: function onTouchTap() {
	            return !o.disabled && onChange(o.value);
	          }
	        },
	        React.createElement(
	          "div",
	          null,
	          o.icon && React.createElement(o.icon, {
	            style: Object.assign({}, STYLES.icon, o.disabled && STYLES.disabled)
	          }),
	          o.label && React.createElement(
	            "div",
	            {
	              style: [STYLES.label, o.disabled && STYLES.disabled, o.sublabel && STYLES.labelWithSublabel]
	            },
	            o.label
	          ),
	          o.sublabel && React.createElement(
	            "div",
	            { style: [STYLES.sublabel, o.disabled && STYLES.disabled] },
	            o.sublabel
	          )
	        )
	      );
	    })
	  );
	};
	
	exports.default = (0, _radium2.default)(SelectWells);
	module.exports = exports["default"];

/***/ }),
/* 1677 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(608);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(615);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvMovie = function AvMovie(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M18 4l2 4h-3l-2-4h-2l2 4h-3l-2-4H8l2 4H7L5 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4h-4z' })
	  );
	};
	AvMovie = (0, _pure2.default)(AvMovie);
	AvMovie.displayName = 'AvMovie';
	AvMovie.muiName = 'SvgIcon';
	
	exports.default = AvMovie;

/***/ }),
/* 1678 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(608);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(615);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionAccountBalance = function ActionAccountBalance(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M4 10v7h3v-7H4zm6 0v7h3v-7h-3zM2 22h19v-3H2v3zm14-12v7h3v-7h-3zm-4.5-9L2 6v2h19V6l-9.5-5z' })
	  );
	};
	ActionAccountBalance = (0, _pure2.default)(ActionAccountBalance);
	ActionAccountBalance.displayName = 'ActionAccountBalance';
	ActionAccountBalance.muiName = 'SvgIcon';
	
	exports.default = ActionAccountBalance;

/***/ }),
/* 1679 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(608);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(615);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SocialCake = function SocialCake(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 6c1.11 0 2-.9 2-2 0-.38-.1-.73-.29-1.03L12 0l-1.71 2.97c-.19.3-.29.65-.29 1.03 0 1.1.9 2 2 2zm4.6 9.99l-1.07-1.07-1.08 1.07c-1.3 1.3-3.58 1.31-4.89 0l-1.07-1.07-1.09 1.07C6.75 16.64 5.88 17 4.96 17c-.73 0-1.4-.23-1.96-.61V21c0 .55.45 1 1 1h16c.55 0 1-.45 1-1v-4.61c-.56.38-1.23.61-1.96.61-.92 0-1.79-.36-2.44-1.01zM18 9h-5V7h-2v2H6c-1.66 0-3 1.34-3 3v1.54c0 1.08.88 1.96 1.96 1.96.52 0 1.02-.2 1.38-.57l2.14-2.13 2.13 2.13c.74.74 2.03.74 2.77 0l2.14-2.13 2.13 2.13c.37.37.86.57 1.38.57 1.08 0 1.96-.88 1.96-1.96V12C21 10.34 19.66 9 18 9z' })
	  );
	};
	SocialCake = (0, _pure2.default)(SocialCake);
	SocialCake.displayName = 'SocialCake';
	SocialCake.muiName = 'SvgIcon';
	
	exports.default = SocialCake;

/***/ }),
/* 1680 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _materialUi = __webpack_require__(576);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Unauthorized = function (_React$Component) {
	  _inherits(Unauthorized, _React$Component);
	
	  function Unauthorized() {
	    _classCallCheck(this, Unauthorized);
	
	    return _possibleConstructorReturn(this, Object.getPrototypeOf(Unauthorized).apply(this, arguments));
	  }
	
	  _createClass(Unauthorized, [{
	    key: "getStyles",
	    value: function getStyles() {
	      return {
	        content: {
	          maxWidth: 600,
	          padding: 20,
	          textAlign: "center",
	          margin: "10vh auto 0"
	        }
	      };
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var styles = this.getStyles(),
	          missingRoutes = this.props.location.state && this.props.location.state.missing;
	
	      return _react2.default.createElement(
	        _materialUi.Paper,
	        { zIndex: 2, style: styles.content },
	        _react2.default.createElement(
	          "h2",
	          null,
	          "Unauthorized"
	        ),
	        _react2.default.createElement(
	          "div",
	          null,
	          "Sorry, you're not allowed to access this page."
	        ),
	        missingRoutes ? _react2.default.createElement(
	          "div",
	          null,
	          "Missing permission: ",
	          _react2.default.createElement(
	            "code",
	            null,
	            missingRoutes.join(",")
	          )
	        ) : null
	      );
	    }
	  }]);
	
	  return Unauthorized;
	}(_react2.default.Component);
	
	exports.default = Unauthorized;
	module.exports = exports["default"];

/***/ }),
/* 1681 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _assign = __webpack_require__(920);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _get = __webpack_require__(1004);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _set = __webpack_require__(1188);
	
	var _set2 = _interopRequireDefault(_set);
	
	var _materialUi = __webpack_require__(576);
	
	var _reactRouter = __webpack_require__(486);
	
	var _config = __webpack_require__(1173);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _label = __webpack_require__(1682);
	
	var _label2 = _interopRequireDefault(_label);
	
	var _selectField = __webpack_require__(1683);
	
	var _selectField2 = _interopRequireDefault(_selectField);
	
	var _workingIndicator = __webpack_require__(1664);
	
	var _workingIndicator2 = _interopRequireDefault(_workingIndicator);
	
	var _connectToStores = __webpack_require__(1226);
	
	var _connectToStores2 = _interopRequireDefault(_connectToStores);
	
	var _UserActions = __webpack_require__(1158);
	
	var _UserActions2 = _interopRequireDefault(_UserActions);
	
	var _UserStore = __webpack_require__(974);
	
	var _UserStore2 = _interopRequireDefault(_UserStore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PASSWORD_PLACEHOLDER = "•••••••••";
	
	var Account = function (_React$Component) {
	  _inherits(Account, _React$Component);
	
	  function Account(props) {
	    _classCallCheck(this, Account);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(Account).call(this, props));
	
	    _this.state = {
	      user: null,
	      dirty: false,
	      fetched: false,
	      values: {
	        email_snapshot_frequency: "never", // default
	        email_threshold_alerts: false
	      }
	    };
	
	    _this.onChange = _this.onChange.bind(_this);
	    _this.onChangeValue = _this.onChangeValue.bind(_this);
	    _this.save = _this.save.bind(_this);
	    return _this;
	  }
	
	  _createClass(Account, [{
	    key: "getStyles",
	    value: function getStyles() {
	      return {
	        actions: {
	          marginTop: 30
	        },
	        connections: {
	          marginTop: 30
	        },
	        connection: {
	          marginTop: 10
	        }
	      };
	    }
	  }, {
	    key: "onChange",
	    value: function onChange(id, e, checked) {
	      this.onChangeValue(id, typeof checked !== "undefined" ? !checked : e.target.value);
	    }
	  }, {
	    key: "onChangeValue",
	    value: function onChangeValue(id, value) {
	      this.state.dirty = true;
	      (0, _set2.default)(this.state.values, id, value);
	      this.setState(this.state);
	    }
	  }, {
	    key: "save",
	    value: function save() {
	      var values = (0, _assign2.default)({}, this.state.values);
	      _UserActions2.default.edit(values);
	    }
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.componentWillReceiveProps(this.props);
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(newProps) {
	      var user = newProps.data;
	
	      if (user) {
	        user.password = "";
	      }
	
	      if (!this.state.isFetchingUser && !this.state.fetched) {
	        _UserActions2.default.fetch();
	        this.setState({ isFetchingUser: true });
	      } else if (user) {
	        this.setState({ isFetchingUser: false });
	      }
	
	      this.setState({ user: user, dirty: false, fetched: true, values: user || {} });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var styles = this.getStyles();
	
	      if (!this.state.user) {
	        return _react2.default.createElement(_workingIndicator2.default, { fullPage: true });
	      }
	
	      var _state = this.state;
	      var user = _state.user;
	      var apiKey = _state.apiKey;
	
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          "h1",
	          null,
	          "Account"
	        ),
	        _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(_materialUi.TextField, {
	              value: (0, _get2.default)(this.state, "values.name", "") || "",
	              floatingLabelText: "Name",
	              onChange: function onChange(e) {
	                return _this2.onChangeValue("name", e.target.value);
	              }
	            })
	          ),
	          _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(_materialUi.TextField, {
	              value: (0, _get2.default)(this.state, "values.email", "") || "",
	              floatingLabelText: "Email address",
	              onChange: function onChange(e) {
	                return _this2.onChangeValue("email", e.target.value);
	              }
	            })
	          ),
	          _react2.default.createElement(
	            "div",
	            null,
	            this.state.editingPassword ? _react2.default.createElement(_materialUi.TextField, {
	              value: (0, _get2.default)(this.state, "values.password", "") || "",
	              floatingLabelText: "Password",
	              floatingLabelFixed: true,
	              hintText: PASSWORD_PLACEHOLDER,
	              type: "password",
	              autoComplete: "new-password",
	              onChange: function onChange(e) {
	                return _this2.onChangeValue("password", e.target.value);
	              }
	            }) : _react2.default.createElement(
	              "div",
	              { style: { marginBottom: 15 } },
	              _react2.default.createElement(
	                _label2.default,
	                null,
	                "Password"
	              ),
	              _react2.default.createElement(_materialUi.RaisedButton, {
	                label: "Change password",
	                primary: false,
	                onTouchTap: function onTouchTap() {
	                  return _this2.setState({ editingPassword: true });
	                }
	              })
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { style: { marginTop: 15 } },
	            _react2.default.createElement(
	              _label2.default,
	              null,
	              "Organization"
	            ),
	            _react2.default.createElement(
	              "div",
	              { style: { fontSize: 16 } },
	              (0, _get2.default)(this.state, "user.owner.organization", "")
	            ),
	            _UserStore2.default.hasPermission("manage_organization") ? _react2.default.createElement(
	              "div",
	              null,
	              _react2.default.createElement(
	                _reactRouter.Link,
	                { to: "/organization" },
	                "Manage organization"
	              )
	            ) : null
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { style: { marginTop: 15 } },
	          _react2.default.createElement(
	            _label2.default,
	            null,
	            "Email preferences"
	          ),
	          _UserStore2.default.getUserType() !== "content_creator" && _UserStore2.default.hasPermission("view_analytics") ? _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(_materialUi.Checkbox, {
	              label: "Send event bucket activity snapshot",
	              checked: this.state.values.email_snapshot_frequency !== "never",
	              onCheck: function onCheck(e, checked) {
	                _this2.onChangeValue("email_snapshot_frequency", checked ? "week" : "never");
	              }
	            }),
	            this.state.values.email_snapshot_frequency !== "never" ? _react2.default.createElement(_selectField2.default, {
	              style: { width: 100, marginLeft: 40, marginBottom: 10 },
	              options: [{ value: "day", label: "Daily" }, { value: "week", label: "Weekly" }],
	              value: this.state.values.email_snapshot_frequency,
	              clearable: false,
	              onChange: function onChange(o) {
	                return _this2.onChangeValue("email_snapshot_frequency", o.value);
	              }
	            }) : null,
	            _react2.default.createElement(_materialUi.Checkbox, {
	              label: "Send threshold alerts (when ticket sales exceed 80% capacity)",
	              checked: this.state.values.email_threshold_alerts,
	              onCheck: function onCheck(e, checked) {
	                _this2.onChangeValue("email_threshold_alerts", checked);
	              }
	            })
	          ) : _react2.default.createElement(
	            "div",
	            null,
	            "You have no available emails to configure."
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { style: styles.actions },
	          _react2.default.createElement(_materialUi.RaisedButton, {
	            label: this.state.dirty ? "Save changes" : "No changes to save",
	            primary: true,
	            disabled: !this.state.dirty,
	            onClick: this.save
	          })
	        )
	      );
	    }
	  }], [{
	    key: "getStores",
	    value: function getStores() {
	      return [_UserStore2.default];
	    }
	  }, {
	    key: "getPropsFromStores",
	    value: function getPropsFromStores() {
	      return _UserStore2.default.getState();
	    }
	  }, {
	    key: "contextTypes",
	    get: function get() {
	      return {
	        router: _react2.default.PropTypes.object
	      };
	    }
	  }]);
	
	  return Account;
	}(_react2.default.Component);
	
	exports.default = (0, _connectToStores2.default)(Account);
	module.exports = exports["default"];

/***/ }),
/* 1682 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	  var style = _ref.style;
	  var children = _ref.children;
	
	  return _react2.default.createElement(
	    "div",
	    {
	      style: Object.assign({
	        fontSize: 12,
	        color: "rgba(33, 33, 33, 0.498039)",
	        marginBottom: 5,
	        marginTop: 10
	      }, style)
	    },
	    children
	  );
	};
	
	module.exports = exports["default"];

/***/ }),
/* 1683 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reactSelect = __webpack_require__(953);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	var _label = __webpack_require__(1682);
	
	var _label2 = _interopRequireDefault(_label);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	exports.default = function (_ref) {
	  var label = _ref.label;
	  var labelStyle = _ref.labelStyle;
	  var style = _ref.style;
	
	  var rest = _objectWithoutProperties(_ref, ["label", "labelStyle", "style"]);
	
	  return React.createElement(
	    "div",
	    { style: style },
	    label && React.createElement(
	      _label2.default,
	      { style: labelStyle },
	      label
	    ),
	    React.createElement(_reactSelect2.default, rest)
	  );
	};
	
	module.exports = exports["default"];

/***/ }),
/* 1684 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _moment = __webpack_require__(1021);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _connectToStores = __webpack_require__(1226);
	
	var _connectToStores2 = _interopRequireDefault(_connectToStores);
	
	var _config = __webpack_require__(1173);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _util = __webpack_require__(1183);
	
	var _styles = __webpack_require__(917);
	
	var _materialUi = __webpack_require__(576);
	
	var _reactRouter = __webpack_require__(486);
	
	var _UserStore = __webpack_require__(974);
	
	var _UserStore2 = _interopRequireDefault(_UserStore);
	
	var _RevenueSharingUtil = __webpack_require__(1685);
	
	var _RevenueSharingUtil2 = _interopRequireDefault(_RevenueSharingUtil);
	
	var _workingIndicator = __webpack_require__(1664);
	
	var _workingIndicator2 = _interopRequireDefault(_workingIndicator);
	
	var _tableRefreshIndicator = __webpack_require__(1686);
	
	var _tableRefreshIndicator2 = _interopRequireDefault(_tableRefreshIndicator);
	
	var _genericAnalyticsTable = __webpack_require__(1687);
	
	var _genericAnalyticsTable2 = _interopRequireDefault(_genericAnalyticsTable);
	
	var _monthPicker = __webpack_require__(1706);
	
	var _monthPicker2 = _interopRequireDefault(_monthPicker);
	
	var _infoNotice = __webpack_require__(1599);
	
	var _infoNotice2 = _interopRequireDefault(_infoNotice);
	
	var _linkLike = __webpack_require__(973);
	
	var _linkLike2 = _interopRequireDefault(_linkLike);
	
	var _startRevenueSharingButton = __webpack_require__(1707);
	
	var _startRevenueSharingButton2 = _interopRequireDefault(_startRevenueSharingButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RevenueSharing = function (_React$Component) {
	  _inherits(RevenueSharing, _React$Component);
	
	  function RevenueSharing(props) {
	    _classCallCheck(this, RevenueSharing);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(RevenueSharing).call(this, props));
	
	    _this.state = {
	      isFetching: false,
	      isExporting: false,
	      showGeneratedExport: null,
	      status: null,
	      activity: null,
	      selectedMonth: _monthPicker2.default.getCurrentMonth()
	    };
	
	    _this.exportReport = _this.exportReport.bind(_this);
	    return _this;
	  }
	
	  _createClass(RevenueSharing, [{
	    key: "exportReport",
	    value: function exportReport() {
	      var _this2 = this;
	
	      var url = _config2.default.endpoint + "revenue_sharing/export_detailed_report?month=" + this.state.selectedMonth + "&" + _UserStore2.default.makeApiKeyQueryString();
	
	      fetch(url).then(function (r) {
	        return r.json();
	      }).then(function (d) {
	        if (d.error || !d.temporary_export) {
	          window.alert("Export failed: " + (d.error ? d.error.message : "An unknown error occurred"));
	        } else {
	          _this2.setState({ isExporting: true });
	          _this2._checkTemporaryExport(d.temporary_export, 500);
	        }
	      });
	    }
	  }, {
	    key: "_checkTemporaryExport",
	    value: function _checkTemporaryExport(id, wait) {
	      var _this3 = this;
	
	      setTimeout(function () {
	        fetch(_config2.default.endpoint + "temporary_exports/" + id + "?" + _UserStore2.default.makeApiKeyQueryString()).then(function (r) {
	          return r.json();
	        }).then(function (e) {
	          if (e.completed_at) {
	            _this3.setState({ isExporting: false });
	            if (e.download_url) {
	              _this3.setState({ showGeneratedExport: e });
	            } else {
	              window.alert("Export failed: " + e.error);
	            }
	          } else {
	            _this3._checkTemporaryExport(id, Math.min(4000, wait * 2)); // backoff: 500ms, 1s, 2s, 4s max wait
	          }
	        });
	      }, wait);
	    }
	  }, {
	    key: "_fetchActivity",
	    value: function _fetchActivity() {
	      var _this4 = this;
	
	      this.setState({ isFetchingActivity: true });
	      _RevenueSharingUtil2.default.fetchRevenueSharingActivity(_UserStore2.default.getState().apiKey, { month: this.state.selectedMonth }).then(function (data) {
	        return _this4.setState({ isFetchingActivity: false, activity: data });
	      }).catch(function (e) {
	        return window.alert("Failed to load Revenue Sharing activity: " + e.message);
	      });
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps() {
	      var _this5 = this;
	
	      if (!this.state.status && !this.state.isFetching) {
	        this.setState({ isFetching: true });
	        _RevenueSharingUtil2.default.fetchRevenueSharingStatus(_UserStore2.default.getState().apiKey).then(function (data) {
	          return _this5.setState({ isFetching: false, status: data });
	        }).catch(function (e) {
	          return window.alert("Failed to load Revenue Sharing: " + e.message);
	        });
	        this._fetchActivity();
	      }
	    }
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.componentWillReceiveProps();
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this6 = this;
	
	      if (!this.state.status || this.state.isFetching) {
	        return _react2.default.createElement(_workingIndicator2.default, { fullPage: true, style: { margin: "10% auto" } });
	      }
	
	      var receivingDetails = this.state.status.details;
	
	      var receivingAccount = receivingDetails && receivingDetails.external_accounts.data[0];
	
	      var isCurrentMonth = this.state.selectedMonth === _monthPicker2.default.getCurrentMonth();
	
	      var makeStripeDestination = function makeStripeDestination(country) {
	        return _config2.default.endpoint + "revenue_sharing/stripe_redirect?redirect_url=" + encodeURIComponent(window.location.href) + "&" + _UserStore2.default.makeApiKeyQueryString() + "&type=" + (_this6.state.status.is_ready ? "management" : "onboarding") + (country ? "&country=" + country : "");
	      };
	
	      return _react2.default.createElement(
	        "div",
	        { style: { fontSize: "12pt", maxWidth: 700, margin: "2vw auto 0" } },
	        this.state.isExporting || this.state.showGeneratedExport ? _react2.default.createElement(
	          _materialUi.Dialog,
	          {
	            title: this.state.showGeneratedExport ? "Revenue Sharing itemization" : "Exporting Revenue Sharing itemization...",
	            modal: true,
	            openImmediately: true,
	            open: true,
	            actions: this.state.showGeneratedExport ? [_react2.default.createElement(_materialUi.FlatButton, {
	              label: "Close",
	              onTouchTap: function onTouchTap() {
	                return _this6.setState({ showGeneratedExport: null });
	              }
	            })] : []
	          },
	          this.state.showGeneratedExport ? _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(
	              "p",
	              null,
	              "Great news, your revenue sharing itemization is ready!"
	            ),
	            _react2.default.createElement(
	              "p",
	              null,
	              _react2.default.createElement(
	                "strong",
	                null,
	                this.state.showGeneratedExport.description
	              ),
	              _react2.default.createElement("br", null),
	              _react2.default.createElement(
	                "a",
	                {
	                  target: "_blank",
	                  href: this.state.showGeneratedExport.download_url
	                },
	                _react2.default.createElement(
	                  "strong",
	                  null,
	                  "Click here to download."
	                )
	              )
	            )
	          ) : _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(_workingIndicator2.default, { centered: true }),
	            _react2.default.createElement(
	              "p",
	              null,
	              "Your report is now being generated! This may take anywhere from a few seconds to a few minutes. Keep this page open and it will automatically update when your report is ready."
	            ),
	            _react2.default.createElement(
	              "p",
	              null,
	              "Feel free to close this page. You will receive an email with a download link as soon as your report has been generated."
	            )
	          )
	        ) : null,
	        _react2.default.createElement(
	          "h2",
	          null,
	          "Eventive Revenue Sharing"
	        ),
	        _react2.default.createElement(
	          "p",
	          null,
	          "Use Eventive Revenue Sharing to easily share screening proceeds with multiple parties. Eventive automates every step of the process\u2014from setup all the way to payouts.",
	          _react2.default.createElement(
	            _infoNotice2.default,
	            { style: { marginTop: 10 } },
	            "Questions? Check out our",
	            " ",
	            _react2.default.createElement(
	              "a",
	              {
	                href: "https://help.eventive.org/en/articles/5043252-eventive-revenue-sharing",
	                target: "_blank"
	              },
	              "guide to Eventive Revenue Sharing"
	            ),
	            "."
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          {
	            style: {
	              margin: "30px -20px 0",
	              backgroundColor: _styles.colors.blue50,
	              border: "1px solid " + _styles.colors.blue200,
	              borderRadius: 20,
	              padding: "20px 20px 10px"
	            }
	          },
	          _react2.default.createElement(
	            "h3",
	            null,
	            "Your Revenue Sharing Account"
	          ),
	          _react2.default.createElement(
	            "p",
	            null,
	            "Eventive Revenue Sharing is powered by",
	            " ",
	            _react2.default.createElement(
	              "a",
	              { href: "https://stripe.com/", target: "_blank" },
	              "Stripe Express"
	            ),
	            ". We'll securely transfer all your earnings directly to a bank account or debit card of your choice on a monthly basis."
	          ),
	          _react2.default.createElement(
	            "p",
	            null,
	            "Status:",
	            " ",
	            _react2.default.createElement(
	              "strong",
	              null,
	              this.state.status.is_ready ? _react2.default.createElement(
	                "span",
	                null,
	                _react2.default.createElement(
	                  "span",
	                  { style: { color: "green" } },
	                  "You're all set!"
	                ),
	                " You will receive a single combined",
	                " ",
	                receivingDetails ? receivingDetails.default_currency.toUpperCase() : "",
	                " ",
	                "payout every month to",
	                " ",
	                receivingAccount ? "your " + (receivingAccount.bank_name || receivingAccount.brand) + " account ending in " + receivingAccount.last4 : "your bank",
	                "."
	              ) : _react2.default.createElement(
	                "span",
	                { style: { color: "red" } },
	                "Not yet connected. You will not receive payouts."
	              )
	            )
	          ),
	          (_UserStore2.default.getUser() || {}).type === "festival_organizer" || this.state.status.is_ready || this.state.activity && (this.state.activity.current_events.length || this.state.activity.ledger.length) ? _react2.default.createElement(
	            "p",
	            null,
	            this.state.status.is_ready ? _react2.default.createElement(_materialUi.RaisedButton, {
	              label: "Manage bank account & review past payouts",
	              primary: false,
	              href: makeStripeDestination()
	            }) : _react2.default.createElement(_startRevenueSharingButton2.default, {
	              label: "Connect bank account to receive payouts",
	              onSubmit: function onSubmit(country) {
	                window.location.href = makeStripeDestination(country);
	              }
	            })
	          ) : this.state.isFetchingActivity ? _react2.default.createElement(_workingIndicator2.default, { size: 0.75, style: {} }) : _react2.default.createElement(
	            "p",
	            { style: { fontStyle: "italic" } },
	            "Once you (",
	            (_UserStore2.default.getUser() || {}).organization,
	            ") have been invited to Revenue Sharing for at least one event, you can add your bank account or debit card details here."
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { style: { marginTop: 40 } },
	          _react2.default.createElement(
	            "h3",
	            null,
	            "Your Revenue Sharing Activity"
	          ),
	          this.state.activity ? _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(_tableRefreshIndicator2.default, {
	              isRefreshing: this.state.isFetchingActivity,
	              onRefresh: function onRefresh() {
	                return _this6._fetchActivity();
	              },
	              style: { marginTop: -50 }
	            }),
	            _react2.default.createElement(
	              "h4",
	              { style: { marginTop: 20 } },
	              "Currently connected events"
	            ),
	            _react2.default.createElement(
	              "div",
	              { style: { fontSize: 13, marginTop: 10 } },
	              this.state.activity.current_events.length ? _react2.default.createElement(_genericAnalyticsTable2.default, {
	                csvLabel: "eventive-events",
	                noSort: true,
	                noDownload: true,
	                data: this.state.activity.current_events.map(function (event) {
	                  return {
	                    organization_name: event.organization_name,
	                    name: event.name,
	                    user_percent: (0, _util.formatPercent)(event.user_percent),
	                    user_donation_percent: (0, _util.formatPercent)(event.user_donation_percent),
	                    actions: {
	                      value: "",
	                      label: _react2.default.createElement(
	                        "span",
	                        null,
	                        _react2.default.createElement(
	                          "a",
	                          { target: "_blank", href: event.public_url },
	                          "View\xA0live"
	                        ),
	                        event.can_view_event_data ? _react2.default.createElement(
	                          "span",
	                          null,
	                          " ",
	                          "\xB7",
	                          " ",
	                          _react2.default.createElement(
	                            _reactRouter.Link,
	                            { to: "/revenue_sharing/" + event.id },
	                            "View\xA0analytics"
	                          )
	                        ) : null
	                      )
	                    }
	                  };
	                }),
	                columns: [{ label: "Organization", value: "organization_name" }, { label: "Name", value: "name" }, { label: "Net %", value: "user_percent" }, {
	                  label: "Donation %",
	                  value: "user_donation_percent"
	                }, { label: "Actions", value: "actions" }],
	                itemsPerPage: 5
	              }) : _react2.default.createElement(
	                "div",
	                {
	                  style: {
	                    border: "1px solid #ccc",
	                    borderRadius: "1em",
	                    padding: 10,
	                    fontWeight: "bold",
	                    textAlign: "center"
	                  }
	                },
	                "You have not been invited to Revenue Sharing for any current events. If you're expecting to see something here, please make sure you've accepted the email invitation, or",
	                " ",
	                _react2.default.createElement(
	                  _linkLike2.default,
	                  {
	                    onTouchTap: function onTouchTap() {
	                      return Intercom("showNewMessage", "I need help with Eventive Revenue Sharing: ");
	                    }
	                  },
	                  "send us a message"
	                ),
	                " ",
	                "if you need help."
	              ),
	              " "
	            ),
	            _react2.default.createElement(
	              "h4",
	              {
	                style: { marginTop: 30, display: "flex", alignItems: "center" }
	              },
	              _react2.default.createElement(
	                "span",
	                { style: { whiteSpace: "nowrap" } },
	                "Revenue Sharing ",
	                isCurrentMonth ? "upcoming" : "",
	                " payout for"
	              ),
	              _react2.default.createElement(
	                "div",
	                {
	                  style: {
	                    display: "inline-block",
	                    width: 250,
	                    marginLeft: 10
	                  }
	                },
	                _react2.default.createElement(_monthPicker2.default, {
	                  value: this.state.selectedMonth,
	                  onChange: function onChange(month) {
	                    _this6.setState({ selectedMonth: month }, function () {
	                      return _this6._fetchActivity();
	                    });
	                  }
	                })
	              )
	            ),
	            !this.state.isFetchingActivity && _react2.default.createElement(
	              "p",
	              { style: { fontSize: 13, marginTop: 10, fontStyle: "italic" } },
	              isCurrentMonth ? "The month is ongoing, and your payout may change. " : "The below is your total payout for the selected month. ",
	              "Revenue Sharing totals shown below are computed after ticketing fees and refunds have been deducted. A 1% Stripe service fee will be deducted from the final payout."
	            ),
	            _react2.default.createElement(
	              "div",
	              { style: { fontSize: 13, marginTop: 10 } },
	              this.state.isFetchingActivity ? _react2.default.createElement(_workingIndicator2.default, { centered: true, style: {} }) : this.state.activity.ledger.length ? _react2.default.createElement(
	                "div",
	                null,
	                _react2.default.createElement(
	                  "div",
	                  { style: { marginTop: -5, marginBottom: 15 } },
	                  "Looking for more details?",
	                  " ",
	                  _react2.default.createElement(
	                    _linkLike2.default,
	                    { onTouchTap: function onTouchTap() {
	                        return _this6.exportReport();
	                      } },
	                    "Download itemized report for",
	                    " ",
	                    (0, _moment2.default)(this.state.selectedMonth, "MM-YYYY").format("MMMM YYYY"),
	                    "."
	                  )
	                ),
	                _react2.default.createElement(_genericAnalyticsTable2.default, {
	                  csvLabel: "eventive-revenue-sharing",
	                  csvDetail: this.state.selectedMonth,
	                  noSort: true,
	                  noDownload: true,
	                  data: this.state.activity.ledger.map(function (item) {
	                    return {
	                      name: item.label,
	                      net: {
	                        value: item.net,
	                        label: (0, _util.formatPrice)(item.net, {
	                          currency: item.currency
	                        })
	                      }
	                    };
	                  }),
	                  columns: [{
	                    label: "Payout for " + (_UserStore2.default.getUser() || {}).organization,
	                    value: "name"
	                  }, {
	                    label: "" + Object.entries(this.state.activity.ledger.reduce(function (totals, l) {
	                      if (!totals[l.currency]) {
	                        totals[l.currency] = 0;
	                      }
	                      totals[l.currency] += l.net;
	                      return totals;
	                    }, {})).map(function (_ref) {
	                      var _ref2 = _slicedToArray(_ref, 2);
	
	                      var currency = _ref2[0];
	                      var value = _ref2[1];
	                      return "" + (0, _util.formatPrice)(value, { currency: currency });
	                    }).join(" + "),
	                    value: "net"
	                  }]
	                })
	              ) : _react2.default.createElement(
	                "div",
	                {
	                  style: {
	                    border: "1px solid #ccc",
	                    borderRadius: "1em",
	                    padding: 10,
	                    fontWeight: "bold",
	                    textAlign: "center"
	                  }
	                },
	                "Your payout for the selected period is estimated to be $0.00."
	              )
	            )
	          ) : _react2.default.createElement(_workingIndicator2.default, { centered: true, style: { marginTop: 20 } })
	        )
	      );
	    }
	  }], [{
	    key: "getStores",
	    value: function getStores() {
	      return [_UserStore2.default];
	    }
	  }, {
	    key: "getPropsFromStores",
	    value: function getPropsFromStores() {
	      return _UserStore2.default.getState();
	    }
	  }, {
	    key: "contextTypes",
	    get: function get() {
	      return {
	        router: _react2.default.PropTypes.object
	      };
	    }
	  }]);
	
	  return RevenueSharing;
	}(_react2.default.Component);
	
	exports.default = (0, _connectToStores2.default)(RevenueSharing);
	module.exports = exports["default"];

/***/ }),
/* 1685 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _api = __webpack_require__(1160);
	
	var _api2 = _interopRequireDefault(_api);
	
	var _config = __webpack_require__(1173);
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  fetchRevenueSharingStatus: function fetchRevenueSharingStatus(apiKey) {
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "GET",
	        endpoint: "revenue_sharing/status",
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response);
	      });
	    });
	  },
	  fetchRevenueSharingActivity: function fetchRevenueSharingActivity(apiKey, _ref) {
	    var month = _ref.month;
	
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "GET",
	        endpoint: "revenue_sharing/activity",
	        qs: { month: month },
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response);
	      });
	    });
	  }
	};
	module.exports = exports["default"];

/***/ }),
/* 1686 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _materialUi = __webpack_require__(576);
	
	exports.default = function (_ref) {
	  var onRefresh = _ref.onRefresh;
	  var isRefreshing = _ref.isRefreshing;
	  var style = _ref.style;
	
	  var containerStyle = Object.assign({
	    position: "relative",
	    float: "right",
	    width: 40,
	    cursor: "pointer"
	  }, style);
	
	  return React.createElement(
	    "div",
	    { style: containerStyle, onTouchTap: onRefresh },
	    React.createElement(_materialUi.RefreshIndicator, {
	      left: 0,
	      top: 0,
	      status: isRefreshing ? "loading" : "ready",
	      percentage: 100
	    })
	  );
	};
	
	module.exports = exports["default"];

/***/ }),
/* 1687 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _moment = __webpack_require__(1021);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _reactRouter = __webpack_require__(486);
	
	var _reactable = __webpack_require__(1688);
	
	var _materialUi = __webpack_require__(576);
	
	var _qs = __webpack_require__(1206);
	
	var _qs2 = _interopRequireDefault(_qs);
	
	var _workingIndicator = __webpack_require__(1664);
	
	var _workingIndicator2 = _interopRequireDefault(_workingIndicator);
	
	var _inlineLinkIconButton = __webpack_require__(1704);
	
	var _inlineLinkIconButton2 = _interopRequireDefault(_inlineLinkIconButton);
	
	var _linkLike = __webpack_require__(973);
	
	var _linkLike2 = _interopRequireDefault(_linkLike);
	
	var _util = __webpack_require__(1183);
	
	var util = _interopRequireWildcard(_util);
	
	var _UserStore = __webpack_require__(974);
	
	var _UserStore2 = _interopRequireDefault(_UserStore);
	
	var _config = __webpack_require__(1173);
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var GenericAnalyticsTable = function (_React$Component) {
	  _inherits(GenericAnalyticsTable, _React$Component);
	
	  function GenericAnalyticsTable(props) {
	    _classCallCheck(this, GenericAnalyticsTable);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(GenericAnalyticsTable).call(this, props));
	
	    _this.state = {
	      currentPage: 0
	    };
	
	    _this._makeRow = _this._makeRow.bind(_this);
	    _this.makeRows = _this.makeRows.bind(_this);
	    _this.downloadCsv = _this.downloadCsv.bind(_this);
	    _this.downloadPdf = _this.downloadPdf.bind(_this);
	    return _this;
	  }
	
	  _createClass(GenericAnalyticsTable, [{
	    key: "_makeRow",
	    value: function _makeRow(id, data) {
	      var _this2 = this;
	
	      var options = arguments.length <= 2 || arguments[2] === undefined ? {} : arguments[2];
	
	      var noWrapTdStyle = { whiteSpace: "nowrap" };
	
	      // Membership route was formatted different than expected.
	      // Form string compatible with existing code below.
	      var routeLabel = this.props.label;
	      if (this.props.label === "Membership Bucket") {
	        routeLabel = "membership";
	      }
	
	      return _react2.default.createElement(
	        _reactable.Tr,
	        {
	          key: id ? id : crypto.randomUUID(),
	          style: options.source && options.source.rowStyle || data.rowStyle
	        },
	        options.source ? _react2.default.createElement(
	          _reactable.Td,
	          { column: this.props.label, value: options.source.name },
	          _react2.default.createElement(
	            "span",
	            null,
	            options.source.nameLabel || options.source.name,
	            options.source.id && !this.props.noLink && _react2.default.createElement(_inlineLinkIconButton2.default, {
	              onTouchTap: function onTouchTap() {
	                _this2.context.router.push("/event_buckets/" + _this2.props.eventBucket.id + "/" + util.snakeCase(routeLabel) + "s/" + id);
	              },
	              tooltip: "View " + this.props.label
	
	            })
	          )
	        ) : null,
	        this.props.columns.map(function (c) {
	          var value = void 0,
	              label = void 0,
	              itemStyle = void 0,
	              itemClass = void 0;
	
	          if (c.value && typeof c.value === "function") {
	            value = label = c.value(data);
	          } else if (data[c.value] && _typeof(data[c.value]) === "object") {
	            var _data$c$value = data[c.value];
	            value = _data$c$value.value;
	            label = _data$c$value.label;
	            itemStyle = _data$c$value.itemStyle;
	            itemClass = _data$c$value.itemClass;
	          } else {
	            value = label = data[c.value];
	          }
	
	          itemStyle = Object.assign(itemStyle || data.itemStyle || {}, c.style);
	
	          return _react2.default.createElement(
	            _reactable.Td,
	            { key: c.label, column: c.label, value: value, style: itemStyle, className: itemClass },
	            label
	          );
	        })
	      );
	    }
	  }, {
	    key: "makeRows",
	    value: function makeRows(data) {
	      var _this3 = this;
	
	      return [(this.props.source ? [this.props.label] : []).concat(this.props.columns.map(function (c) {
	        return c.label;
	      }))].concat(data.map(function (v) {
	        return (_this3.props.source ? [(v._source || _this3.props.source[v.id] || {
	          name: "Deleted " + _this3.props.label.toLowerCase()
	        }).name] : []).concat(_this3.props.columns.map(function (c) {
	          return c.value && typeof c.value === "function" ? c.value(v) : v[c.value] && typeof v[c.value].label !== "undefined" ? typeof v[c.value].csv_label !== "undefined" ? v[c.value].csv_label : _typeof(v[c.value].label) !== "object" ? v[c.value].label : v[c.value].value : v[c.value];
	        }));
	      }));
	    }
	  }, {
	    key: "downloadCsv",
	    value: function downloadCsv(data) {
	      util.clientSideDownload(this.props.csvLabel + "-" + (this.props.csvLabelDetail || util.snakeCase(this.props.eventBucket.name)) + ".csv", "text/csv", util.makeCsv(this.makeRows(data)));
	    }
	  }, {
	    key: "downloadPdf",
	    value: function downloadPdf(data) {
	      var rows = this.makeRows(data),
	          options = {
	        filename: this.props.pdfFilename,
	        title: this.props.pdfTitle,
	        subtitle: this.props.pdfSubtitle,
	        header: rows[0],
	        rows: rows.slice(1)
	      };
	
	      var form = document.createElement("form");
	      form.method = "post";
	      form.action = _config2.default.endpoint + "reports/generated.pdf?" + _UserStore2.default.makeApiKeyQueryString();
	      form.target = "generatedPdf";
	
	      var input = document.createElement("input");
	      input.name = "options";
	      input.type = "hidden";
	      input.value = JSON.stringify(options);
	      form.appendChild(input);
	
	      document.body.appendChild(form);
	
	      window.open("", "generatedPdf");
	      form.submit();
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this4 = this;
	
	      var _props = this.props;
	      var data = _props.data;
	      var label = _props.label;
	      var eventBucket = _props.eventBucket;
	      var source = _props.source;
	      var defaultSort = _props.defaultSort;
	      var defaultSortInvert = _props.defaultSortInvert;
	      var noSort = _props.noSort;
	      var columns = _props.columns;
	
	
	      var dataArray = Array.isArray(data) ? data : Object.keys(data).map(function (k) {
	        return Object.assign({ id: k }, data[k]);
	      });
	
	      var rows = dataArray.map(function (v) {
	        return _this4._makeRow(v.id, v, {
	          source: v._source || (source ? source[v.id] || { name: "Deleted " + label.toLowerCase() } : undefined)
	        });
	      });
	
	      var columnLabels = (source ? [label] : []).concat(columns.map(function (c) {
	        return c.label;
	      }));
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          _reactable.Table,
	          {
	            className: "bordered striped responsive-table",
	            sortable: noSort ? undefined : columnLabels,
	            defaultSort: defaultSort ? {
	              column: defaultSort,
	              direction: defaultSortInvert ? "asc" : "desc"
	            } : undefined,
	            columns: columnLabels,
	            itemsPerPage: this.props.itemsPerPage && rows.length > this.props.itemsPerPage ? this.props.itemsPerPage : undefined,
	            currentPage: this.props.itemsPerPage ? this.state.currentPage : undefined,
	            onPageChange: this.props.itemsPerPage ? function (p) {
	              return _this4.setState({ currentPage: p });
	            } : undefined
	          },
	          rows
	        ),
	        this.props.loading ? _react2.default.createElement(
	          "div",
	          { style: this.props.loadingStyle || { minHeight: "70vh" } },
	          _react2.default.createElement(_workingIndicator2.default, { centered: true, style: { margin: "1em" } })
	        ) : null,
	        !this.props.noDownload ? _react2.default.createElement(
	          "div",
	          {
	            style: Object.assign({ marginTop: "1em" }, this.props.downloadContainerStyle)
	          },
	          this.props.downloadSubtle ? _react2.default.createElement(
	            _linkLike2.default,
	            { onTouchTap: function onTouchTap() {
	                return _this4.downloadCsv(dataArray);
	              } },
	            _react2.default.createElement(
	              "svg",
	              {
	                xmlns: "http://www.w3.org/2000/svg",
	                viewBox: "0 0 20 20",
	                fill: "currentColor",
	                style: {
	                  width: 16,
	                  height: 16,
	                  marginRight: 4,
	                  verticalAlign: -4
	                }
	              },
	              _react2.default.createElement("path", {
	                fillRule: "evenodd",
	                d: "M3 17a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm3.293-7.707a1 1 0 011.414 0L9 10.586V3a1 1 0 112 0v7.586l1.293-1.293a1 1 0 111.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z",
	                clipRule: "evenodd"
	              })
	            ),
	            "Download (.csv)"
	          ) : _react2.default.createElement(_materialUi.RaisedButton, {
	            label: "Download (.csv)",
	            onTouchTap: function onTouchTap() {
	              return _this4.downloadCsv(dataArray);
	            }
	          }),
	          this.props.showPdfDownload ? _react2.default.createElement(_materialUi.RaisedButton, {
	            style: { marginLeft: 7 },
	            label: "Download (.pdf)",
	            onTouchTap: function onTouchTap() {
	              return _this4.downloadPdf(dataArray);
	            }
	          }) : null
	        ) : null
	      );
	    }
	  }], [{
	    key: "contextTypes",
	    get: function get() {
	      return {
	        router: _react2.default.PropTypes.object
	      };
	    }
	  }]);
	
	  return GenericAnalyticsTable;
	}(_react2.default.Component);
	
	exports.default = GenericAnalyticsTable;
	module.exports = exports["default"];

/***/ }),
/* 1688 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactableTable = __webpack_require__(1689);
	
	var _reactableTr = __webpack_require__(1697);
	
	var _reactableTd = __webpack_require__(1698);
	
	var _reactableTh = __webpack_require__(1695);
	
	var _reactableTfoot = __webpack_require__(1701);
	
	var _reactableThead = __webpack_require__(1694);
	
	var _reactableSort = __webpack_require__(1703);
	
	var _reactableUnsafe = __webpack_require__(1693);
	
	_react2['default'].Children.children = function (children) {
	    return _react2['default'].Children.map(children, function (x) {
	        return x;
	    }) || [];
	};
	
	var Reactable = { Table: _reactableTable.Table, Tr: _reactableTr.Tr, Td: _reactableTd.Td, Th: _reactableTh.Th, Tfoot: _reactableTfoot.Tfoot, Thead: _reactableThead.Thead, Sort: _reactableSort.Sort, unsafe: _reactableUnsafe.unsafe };
	
	exports['default'] = Reactable;
	
	if (typeof window !== 'undefined') {
	    window.Reactable = Reactable;
	}
	module.exports = exports['default'];


/***/ }),
/* 1689 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _libFilter_props_from = __webpack_require__(1690);
	
	var _libExtract_data_from = __webpack_require__(1691);
	
	var _unsafe = __webpack_require__(1693);
	
	var _thead = __webpack_require__(1694);
	
	var _th = __webpack_require__(1695);
	
	var _tr = __webpack_require__(1697);
	
	var _tfoot = __webpack_require__(1701);
	
	var _paginator = __webpack_require__(1702);
	
	var Table = (function (_React$Component) {
	    _inherits(Table, _React$Component);
	
	    function Table(props) {
	        _classCallCheck(this, Table);
	
	        _get(Object.getPrototypeOf(Table.prototype), 'constructor', this).call(this, props);
	
	        this.state = {
	            currentPage: this.props.currentPage ? this.props.currentPage : 0,
	            currentSort: {
	                column: null,
	                direction: this.props.defaultSortDescending ? -1 : 1
	            },
	            filter: ''
	        };
	
	        // Set the state of the current sort to the default sort
	        if (props.sortBy !== false || props.defaultSort !== false) {
	            var sortingColumn = props.sortBy || props.defaultSort;
	            this.state.currentSort = this.getCurrentSort(sortingColumn);
	        }
	    }
	
	    _createClass(Table, [{
	        key: 'filterBy',
	        value: function filterBy(filter) {
	            this.setState({ filter: filter });
	        }
	
	        // Translate a user defined column array to hold column objects if strings are specified
	        // (e.g. ['column1'] => [{key: 'column1', label: 'column1'}])
	    }, {
	        key: 'translateColumnsArray',
	        value: function translateColumnsArray(columns) {
	            return columns.map((function (column, i) {
	                if (typeof column === 'string') {
	                    return {
	                        key: column,
	                        label: column
	                    };
	                } else {
	                    if (typeof column.sortable !== 'undefined') {
	                        var sortFunction = column.sortable === true ? 'default' : column.sortable;
	                        this._sortable[column.key] = sortFunction;
	                    }
	
	                    return column;
	                }
	            }).bind(this));
	        }
	    }, {
	        key: 'parseChildData',
	        value: function parseChildData(props, moduleHot) {
	            var data = [],
	                tfoot = undefined;
	
	            // Transform any children back to a data array
	            if (typeof props.children !== 'undefined') {
	                _react2['default'].Children.forEach(props.children, (function (child) {
	                    if (typeof child === 'undefined' || child === null || !child) {
	                        return;
	                    }
	
	                    if (moduleHot) {
	                        var displayName = child.type.displayName ? child.type.displayName : null;
	
	                        switch (displayName) {
	                            case _thead.Thead:
	                                break;
	                            case _tfoot.Tfoot.name:
	                                if (typeof tfoot !== 'undefined') {
	                                    console.warn('You can only have one <Tfoot>, but more than one was specified.' + 'Ignoring all but the last one');
	                                }
	                                tfoot = child;
	                                break;
	                            case _tr.Tr.name:
	                                var childData = child.props.data || {};
	
	                                _react2['default'].Children.forEach(child.props.children, function (descendant) {
	                                    // TODO
	                                    /* if (descendant.type.ConvenienceConstructor === Td) { */
	                                    if (typeof descendant !== 'object' || descendant == null) {
	                                        return;
	                                    } else if (typeof descendant.props.column !== 'undefined') {
	                                        var value = undefined;
	
	                                        if (typeof descendant.props.data !== 'undefined') {
	                                            value = descendant.props.data;
	                                        } else if (typeof descendant.props.children !== 'undefined') {
	                                            value = descendant.props.children;
	                                        } else {
	                                            console.warn('exports.Td specified without ' + 'a `data` property or children, ' + 'ignoring');
	                                            return;
	                                        }
	
	                                        childData[descendant.props.column] = {
	                                            value: value,
	                                            props: (0, _libFilter_props_from.filterPropsFrom)(descendant.props),
	                                            __reactableMeta: true
	                                        };
	                                    } else {
	                                        console.warn('exports.Td specified without a ' + '`column` property, ignoring');
	                                    }
	                                });
	
	                                data.push({
	                                    data: childData,
	                                    props: (0, _libFilter_props_from.filterPropsFrom)(child.props),
	                                    __reactableMeta: true
	                                });
	                                break;
	
	                            default:
	                                console.warn('The only possible children of <Table> are <Thead>, <Tr>, ' + 'or one <Tfoot>.');
	                        }
	                    } else {
	                        switch (child.type) {
	                            case _thead.Thead:
	                                break;
	                            case _tfoot.Tfoot:
	                                if (typeof tfoot !== 'undefined') {
	                                    console.warn('You can only have one <Tfoot>, but more than one was specified.' + 'Ignoring all but the last one');
	                                }
	                                tfoot = child;
	                                break;
	                            case _tr.Tr:
	                                var childData = child.props.data || {};
	
	                                _react2['default'].Children.forEach(child.props.children, function (descendant) {
	                                    // TODO
	                                    /* if (descendant.type.ConvenienceConstructor === Td) { */
	                                    if (typeof descendant !== 'object' || descendant == null) {
	                                        return;
	                                    } else if (typeof descendant.props.column !== 'undefined') {
	                                        var value = undefined;
	
	                                        if (typeof descendant.props.data !== 'undefined') {
	                                            value = descendant.props.data;
	                                        } else if (typeof descendant.props.children !== 'undefined') {
	                                            value = descendant.props.children;
	                                        } else {
	                                            console.warn('exports.Td specified without ' + 'a `data` property or children, ' + 'ignoring');
	                                            return;
	                                        }
	
	                                        childData[descendant.props.column] = {
	                                            value: value,
	                                            props: (0, _libFilter_props_from.filterPropsFrom)(descendant.props),
	                                            __reactableMeta: true
	                                        };
	                                    } else {
	                                        console.warn('exports.Td specified without a ' + '`column` property, ignoring');
	                                    }
	                                });
	
	                                data.push({
	                                    data: childData,
	                                    props: (0, _libFilter_props_from.filterPropsFrom)(child.props),
	                                    __reactableMeta: true
	                                });
	                                break;
	
	                            default:
	                                console.warn('The only possible children of <Table> are <Thead>, <Tr>, ' + 'or one <Tfoot>.');
	                        }
	                    }
	                }).bind(this));
	            }
	            return { data: data, tfoot: tfoot };
	        }
	    }, {
	        key: 'initialize',
	        value: function initialize(props) {
	            this.data = props.data || [];
	            var hasModuleHot = typeof module !== 'undefined' && module.hot;
	            var parseChildData = parseChildData = this.parseChildData(props, hasModuleHot);
	
	            var _parseChildData = parseChildData;
	            var data = _parseChildData.data;
	            var tfoot = _parseChildData.tfoot;
	
	            this.data = this.data.concat(data);
	            this.tfoot = tfoot;
	
	            this.initializeSorts(props);
	            this.initializeFilters(props);
	        }
	    }, {
	        key: 'initializeFilters',
	        value: function initializeFilters(props) {
	            this._filterable = {};
	            // Transform filterable properties into a more friendly list
	            for (var i in props.filterable) {
	                var column = props.filterable[i];
	                var columnName = undefined,
	                    filterFunction = undefined;
	
	                if (column instanceof Object) {
	                    if (typeof column.column !== 'undefined') {
	                        columnName = column.column;
	                    } else {
	                        console.warn('Filterable column specified without column name');
	                        continue;
	                    }
	
	                    if (typeof column.filterFunction === 'function') {
	                        filterFunction = column.filterFunction;
	                    } else {
	                        filterFunction = 'default';
	                    }
	                } else {
	                    columnName = column;
	                    filterFunction = 'default';
	                }
	
	                this._filterable[columnName] = filterFunction;
	            }
	        }
	    }, {
	        key: 'initializeSorts',
	        value: function initializeSorts(props) {
	            this._sortable = {};
	            // Transform sortable properties into a more friendly list
	            for (var i in props.sortable) {
	                var column = props.sortable[i];
	                var columnName = undefined,
	                    sortFunction = undefined;
	
	                if (column instanceof Object) {
	                    if (typeof column.column !== 'undefined') {
	                        columnName = column.column;
	                    } else {
	                        console.warn('Sortable column specified without column name');
	                        return;
	                    }
	
	                    if (typeof column.sortFunction === 'function') {
	                        sortFunction = column.sortFunction;
	                    } else {
	                        sortFunction = 'default';
	                    }
	                } else {
	                    columnName = column;
	                    sortFunction = 'default';
	                }
	
	                this._sortable[columnName] = sortFunction;
	            }
	        }
	    }, {
	        key: 'getCurrentSort',
	        value: function getCurrentSort(column) {
	            var columnName = undefined,
	                sortDirection = undefined;
	
	            if (column instanceof Object) {
	                if (typeof column.column !== 'undefined') {
	                    columnName = column.column;
	                } else {
	                    console.warn('Default column specified without column name');
	                    return;
	                }
	
	                if (typeof column.direction !== 'undefined') {
	                    if (column.direction === 1 || column.direction === 'asc') {
	                        sortDirection = 1;
	                    } else if (column.direction === -1 || column.direction === 'desc') {
	                        sortDirection = -1;
	                    } else {
	                        var defaultDirection = this.props.defaultSortDescending ? 'descending' : 'ascending';
	
	                        console.warn('Invalid default sort specified. Defaulting to ' + defaultDirection);
	                        sortDirection = this.props.defaultSortDescending ? -1 : 1;
	                    }
	                } else {
	                    sortDirection = this.props.defaultSortDescending ? -1 : 1;
	                }
	            } else {
	                columnName = column;
	                sortDirection = this.props.defaultSortDescending ? -1 : 1;
	            }
	
	            return {
	                column: columnName,
	                direction: sortDirection
	            };
	        }
	    }, {
	        key: 'updateCurrentSort',
	        value: function updateCurrentSort(sortBy) {
	            if (sortBy !== false && sortBy.column !== this.state.currentSort.column && sortBy.direction !== this.state.currentSort.direction) {
	
	                this.setState({ currentSort: this.getCurrentSort(sortBy) });
	            }
	        }
	    }, {
	        key: 'updateCurrentPage',
	        value: function updateCurrentPage(nextPage) {
	            if (typeof nextPage !== 'undefined' && nextPage !== this.state.currentPage) {
	                this.setState({ currentPage: nextPage });
	            }
	        }
	    }, {
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            this.initialize(this.props);
	            this.sortByCurrentSort();
	            this.filterBy(this.props.filterBy);
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            this.initialize(nextProps);
	            this.updateCurrentPage(nextProps.currentPage);
	            this.updateCurrentSort(nextProps.sortBy);
	            this.sortByCurrentSort();
	            this.filterBy(nextProps.filterBy);
	        }
	    }, {
	        key: 'applyFilter',
	        value: function applyFilter(filter, children) {
	            // Helper function to apply filter text to a list of table rows
	            filter = filter.toLowerCase();
	            var matchedChildren = [];
	
	            for (var i = 0; i < children.length; i++) {
	                var data = children[i].props.data;
	
	                for (var filterColumn in this._filterable) {
	                    if (typeof data[filterColumn] !== 'undefined') {
	                        // Default filter
	                        if (typeof this._filterable[filterColumn] === 'undefined' || this._filterable[filterColumn] === 'default') {
	                            if ((0, _libExtract_data_from.extractDataFrom)(data, filterColumn).toString().toLowerCase().indexOf(filter) > -1) {
	                                matchedChildren.push(children[i]);
	                                break;
	                            }
	                        } else {
	                            // Apply custom filter
	                            if (this._filterable[filterColumn]((0, _libExtract_data_from.extractDataFrom)(data, filterColumn).toString(), filter)) {
	                                matchedChildren.push(children[i]);
	                                break;
	                            }
	                        }
	                    }
	                }
	            }
	
	            return matchedChildren;
	        }
	    }, {
	        key: 'sortByCurrentSort',
	        value: function sortByCurrentSort() {
	            // Apply a sort function according to the current sort in the state.
	            // This allows us to perform a default sort even on a non sortable column.
	            var currentSort = this.state.currentSort;
	
	            if (currentSort.column === null) {
	                return;
	            }
	
	            this.data.sort((function (a, b) {
	                var keyA = (0, _libExtract_data_from.extractDataFrom)(a, currentSort.column);
	                keyA = (0, _unsafe.isUnsafe)(keyA) ? keyA.toString() : keyA || '';
	                var keyB = (0, _libExtract_data_from.extractDataFrom)(b, currentSort.column);
	                keyB = (0, _unsafe.isUnsafe)(keyB) ? keyB.toString() : keyB || '';
	
	                // Default sort
	                if (typeof this._sortable[currentSort.column] === 'undefined' || this._sortable[currentSort.column] === 'default') {
	
	                    // Reverse direction if we're doing a reverse sort
	                    if (keyA < keyB) {
	                        return -1 * currentSort.direction;
	                    }
	
	                    if (keyA > keyB) {
	                        return 1 * currentSort.direction;
	                    }
	
	                    return 0;
	                } else {
	                    // Reverse columns if we're doing a reverse sort
	                    if (currentSort.direction === 1) {
	                        return this._sortable[currentSort.column](keyA, keyB);
	                    } else {
	                        return this._sortable[currentSort.column](keyB, keyA);
	                    }
	                }
	            }).bind(this));
	        }
	    }, {
	        key: 'onSort',
	        value: function onSort(column) {
	            // Don't perform sort on unsortable columns
	            if (typeof this._sortable[column] === 'undefined') {
	                return;
	            }
	
	            var currentSort = this.state.currentSort;
	
	            if (currentSort.column === column) {
	                currentSort.direction *= -1;
	            } else {
	                currentSort.column = column;
	                currentSort.direction = this.props.defaultSortDescending ? -1 : 1;
	            }
	
	            // Set the current sort and pass it to the sort function
	            this.setState({ currentSort: currentSort });
	            this.sortByCurrentSort();
	
	            if (typeof this.props.onSort === 'function') {
	                this.props.onSort(currentSort);
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this = this;
	
	            var children = [];
	            var columns = undefined;
	            var userColumnsSpecified = false;
	            var showHeaders = typeof this.props.hideTableHeader === 'undefined';
	
	            var firstChild = null;
	
	            if (this.props.children) {
	                if (this.props.children.length > 0 && this.props.children[0] && this.props.children[0].type === _thead.Thead) {
	                    firstChild = this.props.children[0];
	                } else if (this.props.children.type === _thead.Thead) {
	                    firstChild = this.props.children;
	                }
	            }
	
	            if (firstChild !== null) {
	                columns = _thead.Thead.getColumns(firstChild);
	            } else {
	                columns = this.props.columns || [];
	            }
	
	            if (columns.length > 0) {
	                userColumnsSpecified = true;
	                columns = this.translateColumnsArray(columns);
	            }
	
	            // Build up table rows
	            if (this.data && typeof this.data.map === 'function') {
	                // Build up the columns array
	                children = children.concat(this.data.map((function (rawData, i) {
	                    var data = rawData;
	                    var props = {};
	                    if (rawData.__reactableMeta === true) {
	                        data = rawData.data;
	                        props = rawData.props;
	                    }
	
	                    // Loop through the keys in each data row and build a td for it
	                    for (var k in data) {
	                        if (data.hasOwnProperty(k)) {
	                            // Update the columns array with the data's keys if columns were not
	                            // already specified
	                            if (userColumnsSpecified === false) {
	                                (function () {
	                                    var column = {
	                                        key: k,
	                                        label: k
	                                    };
	
	                                    // Only add a new column if it doesn't already exist in the columns array
	                                    if (columns.find(function (element) {
	                                        return element.key === column.key;
	                                    }) === undefined) {
	                                        columns.push(column);
	                                    }
	                                })();
	                            }
	                        }
	                    }
	
	                    return _react2['default'].createElement(_tr.Tr, _extends({ columns: columns, key: i, data: data }, props));
	                }).bind(this)));
	            }
	
	            if (this.props.sortable === true) {
	                for (var i = 0; i < columns.length; i++) {
	                    this._sortable[columns[i].key] = 'default';
	                }
	            }
	
	            // Determine if we render the filter box
	            var filtering = false;
	            if (this.props.filterable && Array.isArray(this.props.filterable) && this.props.filterable.length > 0 && !this.props.hideFilterInput) {
	                filtering = true;
	            }
	
	            // Apply filters
	            var filteredChildren = children;
	            if (this.state.filter !== '') {
	                filteredChildren = this.applyFilter(this.state.filter, filteredChildren);
	            }
	
	            // Determine pagination properties and which columns to display
	            var itemsPerPage = 0;
	            var pagination = false;
	            var numPages = undefined;
	            var currentPage = this.state.currentPage;
	            var pageButtonLimit = this.props.pageButtonLimit || 10;
	
	            var currentChildren = filteredChildren;
	            if (this.props.itemsPerPage > 0) {
	                itemsPerPage = this.props.itemsPerPage;
	                numPages = Math.ceil(filteredChildren.length / itemsPerPage);
	
	                if (currentPage > numPages - 1) {
	                    currentPage = numPages - 1;
	                }
	
	                pagination = true;
	                currentChildren = filteredChildren.slice(currentPage * itemsPerPage, (currentPage + 1) * itemsPerPage);
	            }
	
	            // Manually transfer props
	            var props = (0, _libFilter_props_from.filterPropsFrom)(this.props);
	
	            var noDataText = this.props.noDataText ? _react2['default'].createElement(
	                'tr',
	                { className: 'reactable-no-data' },
	                _react2['default'].createElement(
	                    'td',
	                    { colSpan: columns.length },
	                    this.props.noDataText
	                )
	            ) : null;
	
	            var tableHeader = null;
	            if (columns && columns.length > 0 && showHeaders) {
	                tableHeader = _react2['default'].createElement(_thead.Thead, { columns: columns,
	                    filtering: filtering,
	                    onFilter: function (filter) {
	                        _this.setState({ filter: filter });
	                        if (_this.props.onFilter) {
	                            _this.props.onFilter(filter);
	                        }
	                    },
	                    filterPlaceholder: this.props.filterPlaceholder,
	                    filterClassName: this.props.filterClassName,
	                    currentFilter: this.state.filter,
	                    sort: this.state.currentSort,
	                    sortableColumns: this._sortable,
	                    onSort: this.onSort.bind(this),
	                    key: 'thead' });
	            }
	            return _react2['default'].createElement(
	                'table',
	                props,
	                tableHeader,
	                _react2['default'].createElement(
	                    'tbody',
	                    { className: 'reactable-data', key: 'tbody' },
	                    currentChildren.length > 0 ? currentChildren : noDataText
	                ),
	                pagination === true ? _react2['default'].createElement(_paginator.Paginator, { colSpan: columns.length,
	                    pageButtonLimit: pageButtonLimit,
	                    numPages: numPages,
	                    currentPage: currentPage,
	                    onPageChange: function (page) {
	                        _this.setState({ currentPage: page });
	                        if (_this.props.onPageChange) {
	                            _this.props.onPageChange(page);
	                        }
	                    },
	                    previousPageLabel: this.props.previousPageLabel,
	                    nextPageLabel: this.props.nextPageLabel,
	                    key: 'paginator' }) : null,
	                this.tfoot
	            );
	        }
	    }]);
	
	    return Table;
	})(_react2['default'].Component);
	
	exports.Table = Table;
	
	Table.defaultProps = {
	    sortBy: false,
	    defaultSort: false,
	    defaultSortDescending: false,
	    itemsPerPage: 0,
	    filterBy: '',
	    hideFilterInput: false
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(485)(module)))

/***/ }),
/* 1690 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.filterPropsFrom = filterPropsFrom;
	var internalProps = {
	    hideTableHeader: true,
	    column: true,
	    columns: true,
	    sortable: true,
	    filterable: true,
	    filtering: true,
	    onFilter: true,
	    filterPlaceholder: true,
	    filterClassName: true,
	    currentFilter: true,
	    sort: true,
	    sortBy: true,
	    sortableColumns: true,
	    onSort: true,
	    defaultSort: true,
	    defaultSortDescending: true,
	    itemsPerPage: true,
	    filterBy: true,
	    hideFilterInput: true,
	    noDataText: true,
	    currentPage: true,
	    onPageChange: true,
	    previousPageLabel: true,
	    nextPageLabel: true,
	    pageButtonLimit: true,
	    childNode: true,
	    data: true,
	    children: true
	};
	
	function filterPropsFrom(baseProps) {
	    baseProps = baseProps || {};
	    var props = {};
	    for (var key in baseProps) {
	        if (!(key in internalProps)) {
	            props[key] = baseProps[key];
	        }
	    }
	
	    return props;
	}


/***/ }),
/* 1691 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	exports.extractDataFrom = extractDataFrom;
	
	var _stringable = __webpack_require__(1692);
	
	function extractDataFrom(key, column) {
	    var value;
	    if (typeof key !== 'undefined' && key !== null && key.__reactableMeta === true) {
	        value = key.data[column];
	    } else {
	        value = key[column];
	    }
	
	    if (typeof value !== 'undefined' && value !== null && value.__reactableMeta === true) {
	        value = typeof value.props.value !== 'undefined' && value.props.value !== null ? value.props.value : value.value;
	    }
	
	    return (0, _stringable.stringable)(value) ? value : '';
	}


/***/ }),
/* 1692 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	exports.stringable = stringable;
	
	function stringable(thing) {
	    return thing !== null && typeof thing !== 'undefined' && typeof (thing.toString === 'function');
	}


/***/ }),
/* 1693 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	exports.unsafe = unsafe;
	exports.isUnsafe = isUnsafe;
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Unsafe = (function () {
	    function Unsafe(content) {
	        _classCallCheck(this, Unsafe);
	
	        this.content = content;
	    }
	
	    _createClass(Unsafe, [{
	        key: "toString",
	        value: function toString() {
	            return this.content;
	        }
	    }]);
	
	    return Unsafe;
	})();
	
	function unsafe(str) {
	    return new Unsafe(str);
	}
	
	;
	
	function isUnsafe(obj) {
	    return obj instanceof Unsafe;
	}
	
	;


/***/ }),
/* 1694 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _th = __webpack_require__(1695);
	
	var _filterer = __webpack_require__(1696);
	
	var _libFilter_props_from = __webpack_require__(1690);
	
	var Thead = (function (_React$Component) {
	    _inherits(Thead, _React$Component);
	
	    function Thead() {
	        _classCallCheck(this, Thead);
	
	        _get(Object.getPrototypeOf(Thead.prototype), 'constructor', this).apply(this, arguments);
	    }
	
	    _createClass(Thead, [{
	        key: 'handleClickTh',
	        value: function handleClickTh(column) {
	            this.props.onSort(column.key);
	        }
	    }, {
	        key: 'handleKeyDownTh',
	        value: function handleKeyDownTh(column, event) {
	            if (event.keyCode === 13) {
	                this.props.onSort(column.key);
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            // Declare the list of Ths
	            var Ths = [];
	            for (var index = 0; index < this.props.columns.length; index++) {
	                var column = this.props.columns[index];
	                var thClass = 'reactable-th-' + column.key.replace(/\s+/g, '-').toLowerCase();
	                var sortClass = '';
	                var thRole = null;
	
	                if (this.props.sortableColumns[column.key]) {
	                    sortClass += 'reactable-header-sortable ';
	                    thRole = 'button';
	                }
	
	                if (this.props.sort.column === column.key) {
	                    sortClass += 'reactable-header-sort';
	                    if (this.props.sort.direction === 1) {
	                        sortClass += '-asc';
	                    } else {
	                        sortClass += '-desc';
	                    }
	                }
	
	                if (sortClass.length > 0) {
	                    thClass += ' ' + sortClass;
	                }
	
	                if (typeof column.props === 'object' && typeof column.props.className === 'string') {
	                    thClass += ' ' + column.props.className;
	                }
	
	                Ths.push(_react2['default'].createElement(
	                    _th.Th,
	                    _extends({}, column.props, {
	                        className: thClass,
	                        key: index,
	                        onClick: this.handleClickTh.bind(this, column),
	                        onKeyDown: this.handleKeyDownTh.bind(this, column),
	                        role: thRole,
	                        tabIndex: '0' }),
	                    column.label
	                ));
	            }
	
	            // Manually transfer props
	            var props = (0, _libFilter_props_from.filterPropsFrom)(this.props);
	
	            return _react2['default'].createElement(
	                'thead',
	                props,
	                this.props.filtering === true ? _react2['default'].createElement(_filterer.Filterer, {
	                    colSpan: this.props.columns.length,
	                    onFilter: this.props.onFilter,
	                    placeholder: this.props.filterPlaceholder,
	                    value: this.props.currentFilter,
	                    className: this.props.filterClassName
	                }) : null,
	                _react2['default'].createElement(
	                    'tr',
	                    { className: 'reactable-column-header' },
	                    Ths
	                )
	            );
	        }
	    }], [{
	        key: 'getColumns',
	        value: function getColumns(component) {
	            // Can't use React.Children.map since that doesn't return a proper array
	            var columns = [];
	            _react2['default'].Children.forEach(component.props.children, function (th) {
	                var column = {};
	                if (!th) return;
	                if (typeof th.props !== 'undefined') {
	                    column.props = (0, _libFilter_props_from.filterPropsFrom)(th.props);
	
	                    // use the content as the label & key
	                    if (typeof th.props.children !== 'undefined') {
	                        column.label = th.props.children;
	                        column.key = column.label;
	                    }
	
	                    // the key in the column attribute supersedes the one defined previously
	                    if (typeof th.props.column === 'string') {
	                        column.key = th.props.column;
	
	                        // in case we don't have a label yet
	                        if (typeof column.label === 'undefined') {
	                            column.label = column.key;
	                        }
	                    }
	                }
	
	                if (typeof column.key === 'undefined') {
	                    throw new TypeError('<th> must have either a "column" property or a string ' + 'child');
	                } else {
	                    columns.push(column);
	                }
	            });
	
	            return columns;
	        }
	    }]);
	
	    return Thead;
	})(_react2['default'].Component);
	
	exports.Thead = Thead;
	;


/***/ }),
/* 1695 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _unsafe = __webpack_require__(1693);
	
	var _libFilter_props_from = __webpack_require__(1690);
	
	var Th = (function (_React$Component) {
	    _inherits(Th, _React$Component);
	
	    function Th() {
	        _classCallCheck(this, Th);
	
	        _get(Object.getPrototypeOf(Th.prototype), 'constructor', this).apply(this, arguments);
	    }
	
	    _createClass(Th, [{
	        key: 'render',
	        value: function render() {
	            var childProps = undefined;
	
	            if ((0, _unsafe.isUnsafe)(this.props.children)) {
	                return _react2['default'].createElement('th', _extends({}, (0, _libFilter_props_from.filterPropsFrom)(this.props), {
	                    dangerouslySetInnerHTML: { __html: this.props.children.toString() } }));
	            } else {
	                return _react2['default'].createElement(
	                    'th',
	                    (0, _libFilter_props_from.filterPropsFrom)(this.props),
	                    this.props.children
	                );
	            }
	        }
	    }]);
	
	    return Th;
	})(_react2['default'].Component);
	
	exports.Th = Th;
	;


/***/ }),
/* 1696 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(332);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var FiltererInput = (function (_React$Component) {
	    _inherits(FiltererInput, _React$Component);
	
	    function FiltererInput() {
	        _classCallCheck(this, FiltererInput);
	
	        _get(Object.getPrototypeOf(FiltererInput.prototype), 'constructor', this).apply(this, arguments);
	    }
	
	    _createClass(FiltererInput, [{
	        key: 'onChange',
	        value: function onChange() {
	            this.props.onFilter(_reactDom2['default'].findDOMNode(this).value);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2['default'].createElement('input', { type: 'text',
	                className: this.props.className,
	                placeholder: this.props.placeholder,
	                value: this.props.value,
	                onKeyUp: this.onChange.bind(this),
	                onChange: this.onChange.bind(this) });
	        }
	    }]);
	
	    return FiltererInput;
	})(_react2['default'].Component);
	
	exports.FiltererInput = FiltererInput;
	;
	
	var Filterer = (function (_React$Component2) {
	    _inherits(Filterer, _React$Component2);
	
	    function Filterer() {
	        _classCallCheck(this, Filterer);
	
	        _get(Object.getPrototypeOf(Filterer.prototype), 'constructor', this).apply(this, arguments);
	    }
	
	    _createClass(Filterer, [{
	        key: 'render',
	        value: function render() {
	            if (typeof this.props.colSpan === 'undefined') {
	                throw new TypeError('Must pass a colSpan argument to Filterer');
	            }
	
	            return _react2['default'].createElement(
	                'tr',
	                { className: 'reactable-filterer' },
	                _react2['default'].createElement(
	                    'td',
	                    { colSpan: this.props.colSpan },
	                    _react2['default'].createElement(FiltererInput, { onFilter: this.props.onFilter,
	                        value: this.props.value,
	                        placeholder: this.props.placeholder,
	                        className: this.props.className ? 'reactable-filter-input ' + this.props.className : 'reactable-filter-input' })
	                )
	            );
	        }
	    }]);
	
	    return Filterer;
	})(_react2['default'].Component);
	
	exports.Filterer = Filterer;
	;


/***/ }),
/* 1697 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _td = __webpack_require__(1698);
	
	var _libTo_array = __webpack_require__(1700);
	
	var _libFilter_props_from = __webpack_require__(1690);
	
	var Tr = (function (_React$Component) {
	    _inherits(Tr, _React$Component);
	
	    function Tr() {
	        _classCallCheck(this, Tr);
	
	        _get(Object.getPrototypeOf(Tr.prototype), 'constructor', this).apply(this, arguments);
	    }
	
	    _createClass(Tr, [{
	        key: 'render',
	        value: function render() {
	            var children = (0, _libTo_array.toArray)(_react2['default'].Children.children(this.props.children));
	
	            if (this.props.data && this.props.columns && typeof this.props.columns.map === 'function') {
	                if (typeof children.concat === 'undefined') {
	                    console.log(children);
	                }
	
	                children = children.concat(this.props.columns.map((function (_ref, i) {
	                    var _ref$props = _ref.props;
	                    var props = _ref$props === undefined ? {} : _ref$props;
	
	                    var column = _objectWithoutProperties(_ref, ['props']);
	
	                    if (this.props.data.hasOwnProperty(column.key)) {
	                        var value = this.props.data[column.key];
	
	                        if (typeof value !== 'undefined' && value !== null && value.__reactableMeta === true) {
	                            props = value.props;
	                            value = value.value;
	                        }
	
	                        return _react2['default'].createElement(
	                            _td.Td,
	                            _extends({ column: column, key: column.key }, props),
	                            value
	                        );
	                    } else {
	                        return _react2['default'].createElement(_td.Td, { column: column, key: column.key });
	                    }
	                }).bind(this)));
	            }
	
	            // Manually transfer props
	            var props = (0, _libFilter_props_from.filterPropsFrom)(this.props);
	
	            return _react2['default'].createElement('tr', props, children);
	        }
	    }]);
	
	    return Tr;
	})(_react2['default'].Component);
	
	exports.Tr = Tr;
	;
	
	Tr.childNode = _td.Td;
	Tr.dataType = 'object';


/***/ }),
/* 1698 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _libIs_react_component = __webpack_require__(1699);
	
	var _libStringable = __webpack_require__(1692);
	
	var _unsafe = __webpack_require__(1693);
	
	var _libFilter_props_from = __webpack_require__(1690);
	
	var Td = (function (_React$Component) {
	    _inherits(Td, _React$Component);
	
	    function Td() {
	        _classCallCheck(this, Td);
	
	        _get(Object.getPrototypeOf(Td.prototype), 'constructor', this).apply(this, arguments);
	    }
	
	    _createClass(Td, [{
	        key: 'stringifyIfNotReactComponent',
	        value: function stringifyIfNotReactComponent(object) {
	            if (!(0, _libIs_react_component.isReactComponent)(object) && (0, _libStringable.stringable)(object) && typeof object !== 'undefined') {
	                return object.toString();
	            }
	            return null;
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            // Attach any properties on the column to this Td object to allow things like custom event handlers
	            var mergedProps = (0, _libFilter_props_from.filterPropsFrom)(this.props);
	            if (typeof this.props.column === 'object') {
	                for (var key in this.props.column) {
	                    if (key !== 'key' && key !== 'name') {
	                        mergedProps[key] = this.props.column[key];
	                    }
	                }
	            }
	            // handleClick aliases onClick event
	            mergedProps.onClick = this.props.handleClick;
	
	            var stringifiedChildProps;
	
	            if (typeof this.props.data === 'undefined') {
	                stringifiedChildProps = this.stringifyIfNotReactComponent(this.props.children);
	            }
	
	            if ((0, _unsafe.isUnsafe)(this.props.children)) {
	                return _react2['default'].createElement('td', _extends({}, mergedProps, {
	                    dangerouslySetInnerHTML: { __html: this.props.children.toString() } }));
	            } else {
	                return _react2['default'].createElement(
	                    'td',
	                    mergedProps,
	                    stringifiedChildProps || this.props.children
	                );
	            }
	        }
	    }]);
	
	    return Td;
	})(_react2['default'].Component);
	
	exports.Td = Td;
	;


/***/ }),
/* 1699 */
/***/ (function(module, exports) {

	// this is a bit hacky - it'd be nice if React exposed an API for this
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	exports.isReactComponent = isReactComponent;
	
	function isReactComponent(thing) {
	    return thing !== null && typeof thing === 'object' && typeof thing.props !== 'undefined';
	}


/***/ }),
/* 1700 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.toArray = toArray;
	
	function toArray(obj) {
	    var ret = [];
	    for (var attr in obj) {
	        ret[attr] = obj;
	    }
	
	    return ret;
	}


/***/ }),
/* 1701 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var Tfoot = (function (_React$Component) {
	    _inherits(Tfoot, _React$Component);
	
	    function Tfoot() {
	        _classCallCheck(this, Tfoot);
	
	        _get(Object.getPrototypeOf(Tfoot.prototype), 'constructor', this).apply(this, arguments);
	    }
	
	    _createClass(Tfoot, [{
	        key: 'render',
	        value: function render() {
	            return _react2['default'].createElement('tfoot', this.props);
	        }
	    }]);
	
	    return Tfoot;
	})(_react2['default'].Component);
	
	exports.Tfoot = Tfoot;


/***/ }),
/* 1702 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	function pageHref(num) {
	    return '#page-' + (num + 1);
	}
	
	var Paginator = (function (_React$Component) {
	    _inherits(Paginator, _React$Component);
	
	    function Paginator() {
	        _classCallCheck(this, Paginator);
	
	        _get(Object.getPrototypeOf(Paginator.prototype), 'constructor', this).apply(this, arguments);
	    }
	
	    _createClass(Paginator, [{
	        key: 'handlePrevious',
	        value: function handlePrevious(e) {
	            e.preventDefault();
	            this.props.onPageChange(this.props.currentPage - 1);
	        }
	    }, {
	        key: 'handleNext',
	        value: function handleNext(e) {
	            e.preventDefault();
	            this.props.onPageChange(this.props.currentPage + 1);
	        }
	    }, {
	        key: 'handlePageButton',
	        value: function handlePageButton(page, e) {
	            e.preventDefault();
	            this.props.onPageChange(page);
	        }
	    }, {
	        key: 'renderPrevious',
	        value: function renderPrevious() {
	            if (this.props.currentPage > 0) {
	                return _react2['default'].createElement(
	                    'a',
	                    { className: 'reactable-previous-page',
	                        href: pageHref(this.props.currentPage - 1),
	                        onClick: this.handlePrevious.bind(this) },
	                    this.props.previousPageLabel || 'Previous'
	                );
	            }
	        }
	    }, {
	        key: 'renderNext',
	        value: function renderNext() {
	            if (this.props.currentPage < this.props.numPages - 1) {
	                return _react2['default'].createElement(
	                    'a',
	                    { className: 'reactable-next-page',
	                        href: pageHref(this.props.currentPage + 1),
	                        onClick: this.handleNext.bind(this) },
	                    this.props.nextPageLabel || 'Next'
	                );
	            }
	        }
	    }, {
	        key: 'renderPageButton',
	        value: function renderPageButton(className, pageNum) {
	
	            return _react2['default'].createElement(
	                'a',
	                { className: className,
	                    key: pageNum,
	                    href: pageHref(pageNum),
	                    onClick: this.handlePageButton.bind(this, pageNum) },
	                pageNum + 1
	            );
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            if (typeof this.props.colSpan === 'undefined') {
	                throw new TypeError('Must pass a colSpan argument to Paginator');
	            }
	
	            if (typeof this.props.numPages === 'undefined') {
	                throw new TypeError('Must pass a non-zero numPages argument to Paginator');
	            }
	
	            if (typeof this.props.currentPage === 'undefined') {
	                throw new TypeError('Must pass a currentPage argument to Paginator');
	            }
	
	            var pageButtons = [];
	            var pageButtonLimit = this.props.pageButtonLimit;
	            var currentPage = this.props.currentPage;
	            var numPages = this.props.numPages;
	            var lowerHalf = Math.round(pageButtonLimit / 2);
	            var upperHalf = pageButtonLimit - lowerHalf;
	
	            for (var i = 0; i < this.props.numPages; i++) {
	                var showPageButton = false;
	                var pageNum = i;
	                var className = "reactable-page-button";
	                if (currentPage === i) {
	                    className += " reactable-current-page";
	                }
	                pageButtons.push(this.renderPageButton(className, pageNum));
	            }
	
	            if (currentPage - pageButtonLimit + lowerHalf > 0) {
	                if (currentPage > numPages - lowerHalf) {
	                    pageButtons.splice(0, numPages - pageButtonLimit);
	                } else {
	                    pageButtons.splice(0, currentPage - pageButtonLimit + lowerHalf);
	                }
	            }
	
	            if (numPages - currentPage > upperHalf) {
	                pageButtons.splice(pageButtonLimit, pageButtons.length - pageButtonLimit);
	            }
	
	            return _react2['default'].createElement(
	                'tbody',
	                { className: 'reactable-pagination' },
	                _react2['default'].createElement(
	                    'tr',
	                    null,
	                    _react2['default'].createElement(
	                        'td',
	                        { colSpan: this.props.colSpan },
	                        this.renderPrevious(),
	                        pageButtons,
	                        this.renderNext()
	                    )
	                )
	            );
	        }
	    }]);
	
	    return Paginator;
	})(_react2['default'].Component);
	
	exports.Paginator = Paginator;
	;


/***/ }),
/* 1703 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	var Sort = {
	    Numeric: function Numeric(a, b) {
	        var valA = parseFloat(a.toString().replace(/,/g, ''));
	        var valB = parseFloat(b.toString().replace(/,/g, ''));
	
	        // Sort non-numeric values alphabetically at the bottom of the list
	        if (isNaN(valA) && isNaN(valB)) {
	            valA = a;
	            valB = b;
	        } else {
	            if (isNaN(valA)) {
	                return 1;
	            }
	            if (isNaN(valB)) {
	                return -1;
	            }
	        }
	
	        if (valA < valB) {
	            return -1;
	        }
	        if (valA > valB) {
	            return 1;
	        }
	
	        return 0;
	    },
	
	    NumericInteger: function NumericInteger(a, b) {
	        if (isNaN(a) || isNaN(b)) {
	            return a > b ? 1 : -1;
	        }
	
	        return a - b;
	    },
	
	    Currency: function Currency(a, b) {
	        // Parse out dollar signs, then do a regular numeric sort
	        a = a.replace(/[^0-9\.\-\,]+/g, '');
	        b = b.replace(/[^0-9\.\-\,]+/g, '');
	
	        return exports.Sort.Numeric(a, b);
	    },
	
	    Date: (function (_Date) {
	        function Date(_x, _x2) {
	            return _Date.apply(this, arguments);
	        }
	
	        Date.toString = function () {
	            return _Date.toString();
	        };
	
	        return Date;
	    })(function (a, b) {
	        // Note: this function tries to do a standard javascript string -> date conversion
	        // If you need more control over the date string format, consider using a different
	        // date library and writing your own function
	        var valA = Date.parse(a);
	        var valB = Date.parse(b);
	
	        // Handle non-date values with numeric sort
	        // Sort non-numeric values alphabetically at the bottom of the list
	        if (isNaN(valA) || isNaN(valB)) {
	            return exports.Sort.Numeric(a, b);
	        }
	
	        if (valA > valB) {
	            return 1;
	        }
	        if (valB > valA) {
	            return -1;
	        }
	
	        return 0;
	    }),
	
	    CaseInsensitive: function CaseInsensitive(a, b) {
	        return a.toLowerCase().localeCompare(b.toLowerCase());
	    }
	};
	exports.Sort = Sort;


/***/ }),
/* 1704 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _materialUi = __webpack_require__(576);
	
	var _link = __webpack_require__(1705);
	
	var _link2 = _interopRequireDefault(_link);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var BUTTON_STYLE = {
	  width: 30,
	  height: 20,
	  padding: 0,
	  verticalAlign: -6,
	  zIndex: 999
	};
	
	var ICON_STYLE = {
	  width: 20,
	  height: 20,
	  color: "rgba(0,0,0,0.5)"
	};
	
	var TOOLTIP_STYLE = {
	  marginTop: -30,
	  userSelect: "none"
	};
	
	var InlineLinkIconButton = function InlineLinkIconButton(_ref) {
	  var tooltip = _ref.tooltip;
	  var onTouchTap = _ref.onTouchTap;
	  var _ref$iconComponent = _ref.iconComponent;
	  var iconComponent = _ref$iconComponent === undefined ? React.createElement(_link2.default, null) : _ref$iconComponent;
	  var iconStyle = _ref.iconStyle;
	  var style = _ref.style;
	
	  var rest = _objectWithoutProperties(_ref, ["tooltip", "onTouchTap", "iconComponent", "iconStyle", "style"]);
	
	  return React.createElement(
	    _materialUi.IconButton,
	    _extends({
	      style: Object.assign({}, BUTTON_STYLE, style),
	      iconStyle: Object.assign({}, ICON_STYLE, iconStyle),
	      tooltip: tooltip,
	      tooltipStyles: TOOLTIP_STYLE,
	      onTouchTap: onTouchTap
	    }, rest),
	    iconComponent
	  );
	};
	
	exports.default = InlineLinkIconButton;
	module.exports = exports["default"];

/***/ }),
/* 1705 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(608);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(615);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ContentLink = function ContentLink(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M3.9 12c0-1.71 1.39-3.1 3.1-3.1h4V7H7c-2.76 0-5 2.24-5 5s2.24 5 5 5h4v-1.9H7c-1.71 0-3.1-1.39-3.1-3.1zM8 13h8v-2H8v2zm9-6h-4v1.9h4c1.71 0 3.1 1.39 3.1 3.1s-1.39 3.1-3.1 3.1h-4V17h4c2.76 0 5-2.24 5-5s-2.24-5-5-5z' })
	  );
	};
	ContentLink = (0, _pure2.default)(ContentLink);
	ContentLink.displayName = 'ContentLink';
	ContentLink.muiName = 'SvgIcon';
	
	exports.default = ContentLink;

/***/ }),
/* 1706 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactSelect = __webpack_require__(953);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	var _momentTimezone = __webpack_require__(1185);
	
	var _momentTimezone2 = _interopRequireDefault(_momentTimezone);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BILLING_TIMEZONE = "America/Chicago";
	var FIRST_MONTH = "02-2021"; // first month of ledger billing = Feb 2021
	
	var MonthPicker = function (_React$Component) {
	  _inherits(MonthPicker, _React$Component);
	
	  function MonthPicker(props) {
	    _classCallCheck(this, MonthPicker);
	
	    return _possibleConstructorReturn(this, Object.getPrototypeOf(MonthPicker).call(this, props));
	  }
	
	  _createClass(MonthPicker, [{
	    key: "_generateMonths",
	    value: function _generateMonths() {
	      var curr = (0, _momentTimezone2.default)(FIRST_MONTH, "MM-YYYY").tz(BILLING_TIMEZONE).startOf("month");
	      var end = (0, _momentTimezone2.default)().tz(BILLING_TIMEZONE).startOf("month");
	
	      var months = [];
	
	      while (curr) {
	        if (curr <= end) {
	          months.push({
	            value: curr.format("MM-YYYY"),
	            label: curr.diff(end) === 0 ? (0, _momentTimezone2.default)().tz(BILLING_TIMEZONE).format("MMMM [1]–D, YYYY") : curr.format("MMMM YYYY"),
	            _end: (0, _momentTimezone2.default)(curr).endOf("month")
	          });
	          curr.add(1, "month");
	        } else {
	          curr = null;
	        }
	      }
	
	      return months.reverse();
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var months = this._generateMonths();
	      return _react2.default.createElement(_reactSelect2.default, {
	        clearable: false,
	        value: this.props.value,
	        options: months,
	        onChange: function onChange(e) {
	          return _this2.props.onChange(e.value);
	        }
	      });
	    }
	  }]);
	
	  return MonthPicker;
	}(_react2.default.Component);
	
	MonthPicker.getCurrentMonth = function () {
	  return (0, _momentTimezone2.default)().tz(BILLING_TIMEZONE).startOf("month").format("MM-YYYY");
	};
	
	exports.default = MonthPicker;
	module.exports = exports["default"];

/***/ }),
/* 1707 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _materialUi = __webpack_require__(576);
	
	var _Popover = __webpack_require__(860);
	
	var _qs = __webpack_require__(1206);
	
	var _qs2 = _interopRequireDefault(_qs);
	
	var _config = __webpack_require__(1173);
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FLAG_STYLE = {
	  width: 20,
	  height: 15,
	  marginRight: 10,
	  verticalAlign: -2
	};
	
	var StartRevenueSharingButton = function (_React$Component) {
	  _inherits(StartRevenueSharingButton, _React$Component);
	
	  function StartRevenueSharingButton(props) {
	    _classCallCheck(this, StartRevenueSharingButton);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(StartRevenueSharingButton).call(this, props));
	
	    _this.state = {
	      open: false,
	      anchorEl: null
	    };
	
	    _this._onClick = _this._onClick.bind(_this);
	    _this._onClose = _this._onClose.bind(_this);
	    return _this;
	  }
	
	  _createClass(StartRevenueSharingButton, [{
	    key: "_onClick",
	    value: function _onClick(e) {
	      e.preventDefault();
	
	      this.setState({
	        open: true,
	        anchorEl: e.currentTarget
	      });
	    }
	  }, {
	    key: "_onClose",
	    value: function _onClose() {
	      this.setState({ open: false });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props;
	      var style = _props.style;
	      var label = _props.label;
	
	
	      return _react2.default.createElement(
	        "div",
	        { style: Object.assign({ display: "inline-block" }, style) },
	        _react2.default.createElement(_materialUi.RaisedButton, { label: label, primary: true, onTouchTap: this._onClick }),
	        _react2.default.createElement(
	          _materialUi.Popover,
	          {
	            open: this.state.open,
	            anchorEl: this.state.anchorEl,
	            onRequestClose: this._onClose,
	            animation: _Popover.PopoverAnimationVertical
	          },
	          _react2.default.createElement(
	            _materialUi.Menu,
	            { desktop: true, autoWidth: true },
	            _react2.default.createElement(_materialUi.MenuItem, {
	              primaryText: "To connect, please select your country:",
	              disabled: true
	            }),
	            _react2.default.createElement(_materialUi.MenuItem, {
	              primaryText: _react2.default.createElement(
	                "span",
	                null,
	                _react2.default.createElement("img", {
	                  src: "https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.5.0/flags/4x3/us.svg",
	                  style: FLAG_STYLE
	                }),
	                "United States (USD)"
	              ),
	              onTouchTap: function onTouchTap() {
	                return _this2.props.onSubmit("US");
	              }
	            }),
	            _react2.default.createElement(_materialUi.MenuItem, {
	              primaryText: _react2.default.createElement(
	                "span",
	                null,
	                _react2.default.createElement("img", {
	                  src: "https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.5.0/flags/4x3/ca.svg",
	                  style: FLAG_STYLE
	                }),
	                "Canada (CAD)"
	              ),
	              onTouchTap: function onTouchTap() {
	                return _this2.props.onSubmit("CA");
	              }
	            }),
	            _react2.default.createElement(_materialUi.MenuItem, {
	              primaryText: _react2.default.createElement(
	                "span",
	                null,
	                _react2.default.createElement("img", {
	                  src: "https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.5.0/flags/4x3/gb.svg",
	                  style: FLAG_STYLE
	                }),
	                "United Kingdom (GBP)"
	              ),
	              onTouchTap: function onTouchTap() {
	                return _this2.props.onSubmit("GB");
	              }
	            }),
	            _react2.default.createElement(_materialUi.MenuItem, {
	              primaryText: _react2.default.createElement(
	                "span",
	                null,
	                _react2.default.createElement("img", {
	                  src: "https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.5.0/flags/4x3/au.svg",
	                  style: FLAG_STYLE
	                }),
	                "Australia (AUD)"
	              ),
	              onTouchTap: function onTouchTap() {
	                return _this2.props.onSubmit("AU");
	              }
	            }),
	            _react2.default.createElement(_materialUi.MenuItem, {
	              primaryText: _react2.default.createElement(
	                "span",
	                null,
	                _react2.default.createElement("img", {
	                  src: "https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.5.0/flags/4x3/ie.svg",
	                  style: FLAG_STYLE
	                }),
	                "Ireland (EUR)"
	              ),
	              onTouchTap: function onTouchTap() {
	                return _this2.props.onSubmit("IE");
	              }
	            }),
	            _react2.default.createElement(_materialUi.MenuItem, {
	              primaryText: _react2.default.createElement(
	                "span",
	                null,
	                _react2.default.createElement("img", {
	                  src: "https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.5.0/flags/4x3/de.svg",
	                  style: FLAG_STYLE
	                }),
	                "Germany (EUR)"
	              ),
	              onTouchTap: function onTouchTap() {
	                return _this2.props.onSubmit("DE");
	              }
	            }),
	            _react2.default.createElement(_materialUi.MenuItem, {
	              primaryText: _react2.default.createElement(
	                "span",
	                null,
	                _react2.default.createElement("img", {
	                  src: "https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.5.0/flags/4x3/dk.svg",
	                  style: FLAG_STYLE
	                }),
	                "Denmark (DKK)"
	              ),
	              onTouchTap: function onTouchTap() {
	                return _this2.props.onSubmit("DK");
	              }
	            }),
	            _react2.default.createElement(_materialUi.MenuItem, {
	              primaryText: "Country not listed",
	              onTouchTap: function onTouchTap() {
	                return window.alert("Unfortunately, other countries are not yet supported. However, we are working to add additional countries soon. Please reach out to our team and let us know what country you're looking for next!");
	              }
	            })
	          )
	        )
	      );
	    }
	  }]);
	
	  return StartRevenueSharingButton;
	}(_react2.default.Component);
	
	exports.default = StartRevenueSharingButton;
	module.exports = exports["default"];

/***/ }),
/* 1708 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _assign = __webpack_require__(920);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _get = __webpack_require__(1004);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _set = __webpack_require__(1188);
	
	var _set2 = _interopRequireDefault(_set);
	
	var _materialUi = __webpack_require__(576);
	
	var _reactRouter = __webpack_require__(486);
	
	var _config = __webpack_require__(1173);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _label = __webpack_require__(1682);
	
	var _label2 = _interopRequireDefault(_label);
	
	var _selectField = __webpack_require__(1683);
	
	var _selectField2 = _interopRequireDefault(_selectField);
	
	var _workingIndicator = __webpack_require__(1664);
	
	var _workingIndicator2 = _interopRequireDefault(_workingIndicator);
	
	var _connectToStores = __webpack_require__(1226);
	
	var _connectToStores2 = _interopRequireDefault(_connectToStores);
	
	var _UserActions = __webpack_require__(1158);
	
	var _UserActions2 = _interopRequireDefault(_UserActions);
	
	var _UserStore = __webpack_require__(974);
	
	var _UserStore2 = _interopRequireDefault(_UserStore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SSO = function (_React$Component) {
	  _inherits(SSO, _React$Component);
	
	  function SSO(props) {
	    _classCallCheck(this, SSO);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(SSO).call(this, props));
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(SSO, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      if (this.props.location.query.token) {
	        _UserActions2.default.loginWithToken(this.props.location.query.token);
	      } else {
	        window.location.replace(_config2.default.endpoint + "auth/sso?redirect=" + encodeURIComponent(window.location.href) + "&login_hint=" + ((this.props.location.state || {}).login_hint || ""));
	      }
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(props) {
	      if (_UserStore2.default.isLoggedIn()) {
	        props.history.replace("/welcome");
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement(_workingIndicator2.default, { fullPage: true });
	    }
	  }], [{
	    key: "getStores",
	    value: function getStores() {
	      return [_UserStore2.default];
	    }
	  }, {
	    key: "getPropsFromStores",
	    value: function getPropsFromStores() {
	      return _UserStore2.default.getState();
	    }
	  }, {
	    key: "contextTypes",
	    get: function get() {
	      return {
	        router: _react2.default.PropTypes.object
	      };
	    }
	  }]);
	
	  return SSO;
	}(_react2.default.Component);
	
	exports.default = (0, _connectToStores2.default)(SSO);
	module.exports = exports["default"];

/***/ }),
/* 1709 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _materialUi = __webpack_require__(576);
	
	var _moment = __webpack_require__(1021);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _reactRouter = __webpack_require__(486);
	
	var _config = __webpack_require__(1173);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _accountTable = __webpack_require__(1710);
	
	var _accountTable2 = _interopRequireDefault(_accountTable);
	
	var _connectWithStripe = __webpack_require__(1712);
	
	var _connectWithStripe2 = _interopRequireDefault(_connectWithStripe);
	
	var _connectToStores = __webpack_require__(1226);
	
	var _connectToStores2 = _interopRequireDefault(_connectToStores);
	
	var _UserActions = __webpack_require__(1158);
	
	var _UserActions2 = _interopRequireDefault(_UserActions);
	
	var _UserStore = __webpack_require__(974);
	
	var _UserStore2 = _interopRequireDefault(_UserStore);
	
	var _UserUtil = __webpack_require__(1159);
	
	var _UserUtil2 = _interopRequireDefault(_UserUtil);
	
	var _creditCardEntry = __webpack_require__(1713);
	
	var _creditCardEntry2 = _interopRequireDefault(_creditCardEntry);
	
	var _workingIndicator = __webpack_require__(1664);
	
	var _workingIndicator2 = _interopRequireDefault(_workingIndicator);
	
	var _linkLike = __webpack_require__(973);
	
	var _linkLike2 = _interopRequireDefault(_linkLike);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Organization = function (_React$Component) {
	  _inherits(Organization, _React$Component);
	
	  function Organization(props) {
	    _classCallCheck(this, Organization);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(Organization).call(this, props));
	
	    _this.state = {
	      fetched: false,
	      isFetching: false,
	      isEditingBilling: false,
	      isSubmittingBilling: false,
	      billingErrorMessage: null,
	      ssoDomain: "",
	      ssoConfig: {}
	    };
	
	    _this.submitBilling = _this.submitBilling.bind(_this);
	    _this.submitSso = _this.submitSso.bind(_this);
	    return _this;
	  }
	
	  _createClass(Organization, [{
	    key: "getStyles",
	    value: function getStyles() {
	      return {
	        section: {
	          marginTop: 30
	        },
	        connectionsGrid: {
	          display: "flex",
	          flexDirection: "row",
	          marginBottom: -10,
	          marginRight: -10,
	          marginLeft: -10,
	          flexWrap: "wrap"
	        },
	        connection: {
	          flexGrow: 1,
	          margin: 10,
	          width: 400,
	          boxSizing: "border-box",
	          boxShadow: "0 0 9px 3px rgba(0,0,0,0.1)",
	          padding: 15,
	          borderRadius: 10,
	          textAlign: "center",
	          display: "flex",
	          flexDirection: "column"
	        },
	        connectionHeader: {
	          marginBottom: 0
	        },
	        connectionDetail: {
	          margin: "8px auto 16px",
	          flex: 1,
	          display: "flex",
	          alignItems: "center",
	          maxWidth: 450
	        },
	        disabledButton: {
	          opacity: 0.5,
	          pointerEvents: "none"
	        },
	        error: {
	          color: "red",
	          margin: "5px 0"
	        },
	        connectedLabel: {
	          color: "#fff",
	          padding: "2px 5px",
	          fontSize: "0.75em"
	        }
	      };
	    }
	  }, {
	    key: "submitBilling",
	    value: function submitBilling() {
	      var _this2 = this;
	
	      this.setState({
	        isSubmittingBilling: true
	      });
	      Stripe.card.createToken(this.refs.cardEntry.getPaymentDetails(), function (status, response) {
	        if (response.error) {
	          _this2.setState({
	            isSubmittingBilling: false,
	            billingErrorMessage: response.error.message
	          });
	        } else {
	          _UserActions2.default.editUser({
	            payments_token: response.id
	          });
	        }
	      });
	    }
	  }, {
	    key: "submitSso",
	    value: function submitSso() {
	      this.setState({
	        isSubmittingSso: true
	      });
	      _UserActions2.default.editUser({
	        sso_domain: this.state.ssoDomain,
	        sso_config: this.state.ssoConfig
	      });
	    }
	  }, {
	    key: "activateVirtual",
	    value: function activateVirtual() {
	      _UserUtil2.default.generateVirtualActivationLink({
	        apiKey: _UserStore2.default.getState().apiKey
	      }).then(function (_ref) {
	        var url = _ref.url;
	
	        window.location.href = url + "&next=" + encodeURIComponent(window.location.href);
	      });
	    }
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var _this3 = this;
	
	      this.componentWillReceiveProps(this.props);
	
	      if (!document.getElementById("plaid-loader")) {
	        var script = document.createElement("script");
	        script.id = "plaid-loader";
	        script.onload = function () {
	          _this3._initializePlaid();
	        };
	        script.src = "https://cdn.plaid.com/link/v2/stable/link-initialize.js";
	        document.head.appendChild(script); //or something of the likes
	      } else {
	        this._initializePlaid();
	      }
	    }
	  }, {
	    key: "_initializePlaid",
	    value: function _initializePlaid() {
	      var _this4 = this;
	
	      var linkHandler = Plaid.create({
	        env: "production",
	        clientName: "Eventive",
	        key: "ea2fa373b010fffcbf72172db21460",
	        product: ["auth"],
	        selectAccount: true,
	        onSuccess: function onSuccess(public_token, metadata) {
	          _this4.setState({ isSubmittingBilling: true });
	          _UserActions2.default.editUser({
	            bank_account_public_token: public_token,
	            bank_account_id: metadata.account_id
	          });
	        },
	        onExit: function onExit(err, metadata) {}
	      });
	      this.setState({ plaidLinkHandler: linkHandler });
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(newProps) {
	      var user = newProps.user;
	
	
	      if (!this.state.isFetching && !this.state.fetched) {
	        _UserActions2.default.fetchUser();
	        _UserActions2.default.fetchAccounts();
	        _UserActions2.default.fetchRoles();
	        this.setState({ isFetching: true });
	      } else if (user) {
	        this.setState({
	          isFetching: false,
	          fetched: true,
	          isEditingBilling: false,
	          isSubmittingBilling: false,
	          isSubmittingSso: false,
	          billingErrorMessage: null,
	          ssoConfig: user.sso_config || {},
	          ssoDomain: user.sso_domain
	        });
	        if (this.stripe && !this.state.hasScrolledStripe && window.location.hash === "#stripe") {
	          this.stripe.scrollIntoView();
	          this.setState({ hasScrolledStripe: true });
	        }
	      }
	    }
	  }, {
	    key: "_makeStatus",
	    value: function _makeStatus(label) {
	      var styles = this.getStyles();
	      return typeof label === "string" ? _react2.default.createElement(
	        "span",
	        {
	          style: Object.assign({}, styles.connectedLabel, {
	            backgroundColor: "#0086D4"
	          })
	        },
	        label
	      ) : label ? _react2.default.createElement(
	        "span",
	        {
	          style: Object.assign({}, styles.connectedLabel, {
	            backgroundColor: "#4CAF50"
	          })
	        },
	        "Connected"
	      ) : _react2.default.createElement(
	        "span",
	        {
	          style: Object.assign({}, styles.connectedLabel, {
	            backgroundColor: "#F44336"
	          })
	        },
	        "Not connected"
	      );
	    }
	  }, {
	    key: "addBankAccount",
	    value: function addBankAccount() {}
	  }, {
	    key: "render",
	    value: function render() {
	      var _this5 = this;
	
	      var styles = this.getStyles();
	
	      if (!this.props.user) {
	        return _react2.default.createElement(_workingIndicator2.default, { fullPage: true });
	      }
	
	      var _props = this.props;
	      var data = _props.data;
	      var user = _props.user;
	      var accounts = _props.accounts;
	      var roles = _props.roles;
	      var apiKey = _props.apiKey;
	
	
	      if (user.type === "content_creator") {
	        return _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement(
	            "h1",
	            null,
	            user.organization
	          ),
	          _react2.default.createElement(
	            "div",
	            { style: styles.section },
	            _react2.default.createElement(
	              "h2",
	              null,
	              "Accounts"
	            ),
	            _react2.default.createElement(_accountTable2.default, {
	              accounts: accounts,
	              roles: roles,
	              selfAccountId: data.id,
	              onSelfEdit: function onSelfEdit() {
	                return _this5.context.router.push("/account");
	              }
	            })
	          )
	        );
	      }
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          "h1",
	          null,
	          user.organization
	        ),
	        _react2.default.createElement(
	          "div",
	          { style: styles.section },
	          _react2.default.createElement(
	            "h2",
	            null,
	            "Accounts"
	          ),
	          _react2.default.createElement(_accountTable2.default, {
	            accounts: accounts,
	            roles: roles,
	            selfAccountId: data.id,
	            onSelfEdit: function onSelfEdit() {
	              return _this5.context.router.push("/account");
	            }
	          })
	        ),
	        _react2.default.createElement(
	          "div",
	          { style: styles.section },
	          _react2.default.createElement(
	            "h2",
	            null,
	            "Connections"
	          ),
	          _react2.default.createElement(
	            "div",
	            { style: styles.connectionsGrid },
	            _react2.default.createElement(
	              "div",
	              { style: styles.connection },
	              _react2.default.createElement(
	                "h3",
	                {
	                  ref: function ref(r) {
	                    _this5.stripe = r;
	                  },
	                  style: styles.connectionHeader
	                },
	                "Stripe ",
	                this._makeStatus(user.connections.stripe)
	              ),
	              _react2.default.createElement(
	                "div",
	                { style: styles.connectionDetail },
	                _react2.default.createElement(
	                  "div",
	                  null,
	                  "Eventive uses",
	                  " ",
	                  _react2.default.createElement(
	                    "a",
	                    { href: "https://stripe.com", target: "_blank" },
	                    "Stripe"
	                  ),
	                  " ",
	                  "to securely process payments.",
	                  " ",
	                  user.connections.stripe ? "Your organization has connected with Stripe and is ready to accept credit card payments." : "You must connect with Stripe in order to accept credit card payments.",
	                  " ",
	                  _react2.default.createElement(
	                    "a",
	                    {
	                      target: "_blank",
	                      href: "https://help.eventive.org/getting-started/connect-your-bank-account"
	                    },
	                    "Learn\xA0more."
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                null,
	                _react2.default.createElement(_connectWithStripe2.default, {
	                  href: _config2.default.endpoint + ("auth/stripe?" + _UserStore2.default.makeApiKeyQueryString() + "&redirect=" + encodeURIComponent(window.location.href)),
	                  style: user.connections.stripe ? styles.disabledButton : null,
	                  connected: !!user.connections.stripe
	                })
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { style: styles.connection },
	              _react2.default.createElement(
	                "h3",
	                null,
	                "MailChimp ",
	                this._makeStatus(user.connections.mailchimp)
	              ),
	              _react2.default.createElement(
	                "div",
	                { style: styles.connectionDetail },
	                _react2.default.createElement(
	                  "div",
	                  null,
	                  "Connect with",
	                  " ",
	                  _react2.default.createElement(
	                    "a",
	                    { href: "https://mailchimp.com", target: "_blank" },
	                    "MailChimp"
	                  ),
	                  " ",
	                  "for automatic mailing list synchronization using",
	                  " ",
	                  _react2.default.createElement(
	                    "a",
	                    {
	                      target: "_blank",
	                      href: "https://help.eventive.org/integrations/create-external-syncs"
	                    },
	                    "Eventive external\xA0syncs"
	                  ),
	                  "."
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                null,
	                _react2.default.createElement(_materialUi.RaisedButton, {
	                  disabled: user.connections.mailchimp,
	                  href: _config2.default.endpoint + ("auth/mailchimp?" + _UserStore2.default.makeApiKeyQueryString() + "&redirect=" + encodeURIComponent(window.location.href)),
	                  label: _react2.default.createElement(
	                    "span",
	                    null,
	                    !user.connections.mailchimp ? "Connect with " : "",
	                    _react2.default.createElement("img", {
	                      src: "https://storage.googleapis.com/eventive-co/mailchimp-logo.svg",
	                      style: {
	                        width: 93,
	                        verticalAlign: -10,
	                        opacity: user.connections.mailchimp ? 0.5 : 1
	                      }
	                    }),
	                    user.connections.mailchimp ? " connected" : ""
	                  )
	                })
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { style: styles.connection },
	              _react2.default.createElement(
	                "h3",
	                null,
	                "Eventival ",
	                this._makeStatus(user.connections.eventival)
	              ),
	              _react2.default.createElement(
	                "div",
	                { style: styles.connectionDetail },
	                _react2.default.createElement(
	                  "div",
	                  null,
	                  "Connect with",
	                  " ",
	                  _react2.default.createElement(
	                    "a",
	                    { href: "https://eventival.com", target: "_blank" },
	                    "Eventival"
	                  ),
	                  " ",
	                  "to automatically sync films, events, and/or passes from your Eventival database using",
	                  " ",
	                  _react2.default.createElement(
	                    "a",
	                    {
	                      target: "_blank",
	                      href: "https://help.eventive.org/integrations/create-external-syncs"
	                    },
	                    "Eventive external\xA0syncs"
	                  ),
	                  "."
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                null,
	                _react2.default.createElement(_materialUi.RaisedButton, {
	                  disabled: user.connections.eventival,
	                  onClick: function onClick() {
	                    return Intercom("showNewMessage", "I'm ready to connect my Eventival account. My Eventival organization name is: ");
	                  },
	                  label: _react2.default.createElement(
	                    "span",
	                    null,
	                    !user.connections.eventival ? _react2.default.createElement(
	                      "span",
	                      null,
	                      "Connect with\xA0\xA0"
	                    ) : "",
	                    _react2.default.createElement("img", {
	                      src: "https://storage.googleapis.com/eventive-co/eventival-dark.png",
	                      style: {
	                        width: 80,
	                        verticalAlign: -1,
	                        opacity: user.connections.eventival ? 0.5 : 1
	                      }
	                    }),
	                    user.connections.eventival ? _react2.default.createElement(
	                      "span",
	                      null,
	                      "\xA0\xA0connected"
	                    ) : ""
	                  )
	                })
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { style: styles.connection },
	              _react2.default.createElement(
	                "h3",
	                null,
	                "Zapier "
	              ),
	              _react2.default.createElement(
	                "div",
	                { style: styles.connectionDetail },
	                _react2.default.createElement(
	                  "div",
	                  null,
	                  "Connect with",
	                  " ",
	                  _react2.default.createElement(
	                    "a",
	                    { href: "https://zapier.com", target: "_blank" },
	                    "Zapier"
	                  ),
	                  " ",
	                  "to instantly link Eventive to 1,500+ other apps, from Airtable, to Instagram, to Salesforce, and everything in between."
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                null,
	                _react2.default.createElement(_materialUi.RaisedButton, {
	                  target: "_blank",
	                  href: "https://zapier.com/developer/public-invite/19730/610b47a66a699a64812f1f8128c3f206/",
	                  label: _react2.default.createElement(
	                    "span",
	                    null,
	                    "Connect with",
	                    " ",
	                    _react2.default.createElement("img", {
	                      src: "https://storage.googleapis.com/eventive-co/zapier.svg",
	                      style: { width: 53, verticalAlign: -6, marginLeft: 2 }
	                    })
	                  )
	                })
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { style: styles.section },
	          _react2.default.createElement(
	            "h2",
	            null,
	            "Eventive Virtual"
	          ),
	          _react2.default.createElement(
	            "div",
	            null,
	            "Eventive Virtual is an annual add-on subscription to the Eventive platform.",
	            " ",
	            _react2.default.createElement(
	              "a",
	              { href: "https://eventive.org/virtual", target: "_blank" },
	              "Learn more."
	            )
	          ),
	          user.virtual_festival_plan_status === "active" ? _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(
	              "strong",
	              null,
	              "Thanks!"
	            ),
	            " Your Eventive Virtual",
	            " ",
	            user.virtual_festival_plan === "single_film" ? "Single Film" : user.virtual_festival_plan,
	            " ",
	            "subscription is active.",
	            " ",
	            _react2.default.createElement(
	              _reactRouter.Link,
	              { to: "/billing" },
	              "Manage subscription in the Billing Hub."
	            )
	          ) : _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(_materialUi.RaisedButton, {
	              style: { marginTop: 5 },
	              primary: true,
	              label: "Activate Eventive Virtual",
	              onTouchTap: this.activateVirtual
	            })
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { style: styles.section },
	          _react2.default.createElement(
	            "h2",
	            null,
	            "Single Sign-On (SSO)"
	          ),
	          _react2.default.createElement(
	            "div",
	            null,
	            "Single Sign-On (SSO) is an optional add-on to the Eventive Dashboard. With SSO, your organization administrators can login securely to the Eventive Dashboard using credentials they already have, including AD, SAML, G Suite, and more.",
	            " ",
	            _react2.default.createElement(
	              "a",
	              {
	                href: "https://help.eventive.org/en/articles/4665490-eventive-dashboard-single-sign-on-sso",
	                target: "_blank"
	              },
	              "Learn more."
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { style: { marginTop: 5 } },
	            "Status:",
	            " ",
	            _react2.default.createElement(
	              "strong",
	              null,
	              user.sso_domain ? "Enabled for " + user.sso_domain : _react2.default.createElement(
	                "span",
	                null,
	                "Not active \u2013",
	                " ",
	                _react2.default.createElement(
	                  _linkLike2.default,
	                  {
	                    onTouchTap: function onTouchTap() {
	                      return Intercom("showNewMessage", "I'd like to enable Single Sign-On for the Eventive Dashboard.\n\nDomain: << domain >>\nIdentity platform: << platform >>\nBilling: << monthly ($499/month) >> or << annual ($5499/year) >>\n\nThank you!");
	                    }
	                  },
	                  "Enable SSO"
	                )
	              )
	            )
	          ),
	          user.sso_domain || _UserStore2.default.isGod() ? _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(
	              "div",
	              null,
	              _react2.default.createElement(_materialUi.TextField, {
	                style: { marginBottom: 5, marginTop: -8 },
	                disabled: !_UserStore2.default.isGod(),
	                floatingLabelText: "SSO domain",
	                floatingLabelFixed: true,
	                placeholder: "SSO not enabled",
	                title: "Contact your Account Manager to change this domain.",
	                value: this.state.ssoDomain,
	                onChange: function onChange(e) {
	                  _this5.setState({ ssoDomain: e.target.value });
	                }
	              })
	            ),
	            _react2.default.createElement(
	              "div",
	              { style: { maxWidth: 550 } },
	              _react2.default.createElement(_materialUi.Checkbox, {
	                label: "Upon login, create a new Eventive Dashboard account if one doesn't exist",
	                checked: this.state.ssoConfig.create_if_new,
	                onCheck: function onCheck() {
	                  _this5.setState({
	                    ssoConfig: _extends({}, _this5.state.ssoConfig, {
	                      create_if_new: !_this5.state.ssoConfig.create_if_new
	                    })
	                  });
	                }
	              })
	            ),
	            _react2.default.createElement(
	              "div",
	              { style: { maxWidth: 550 } },
	              _react2.default.createElement(_materialUi.Checkbox, {
	                label: "Only allow authentication using SSO (block username/password auth)",
	                checked: this.state.ssoConfig.sso_only,
	                onCheck: function onCheck() {
	                  _this5.setState({
	                    ssoConfig: _extends({}, _this5.state.ssoConfig, {
	                      sso_only: !_this5.state.ssoConfig.sso_only
	                    })
	                  });
	                }
	              })
	            ),
	            _react2.default.createElement(_materialUi.RaisedButton, {
	              style: { marginTop: 15 },
	              label: this.state.isSubmittingSso ? "Saving SSO settings..." : "Save SSO settings",
	              disabled: this.state.isSubmittingSso,
	              onClick: this.submitSso
	            })
	          ) : null
	        )
	      );
	    }
	  }], [{
	    key: "getStores",
	    value: function getStores() {
	      return [_UserStore2.default];
	    }
	  }, {
	    key: "getPropsFromStores",
	    value: function getPropsFromStores() {
	      return _UserStore2.default.getState();
	    }
	  }, {
	    key: "contextTypes",
	    get: function get() {
	      return {
	        router: _react2.default.PropTypes.object
	      };
	    }
	  }]);
	
	  return Organization;
	}(_react2.default.Component);
	
	exports.default = (0, _connectToStores2.default)(Organization);
	module.exports = exports["default"];

/***/ }),
/* 1710 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _moment = __webpack_require__(1021);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _reactRouter = __webpack_require__(486);
	
	var _reactable = __webpack_require__(1688);
	
	var _materialUi = __webpack_require__(576);
	
	var _util = __webpack_require__(1183);
	
	var _accountEditorModal = __webpack_require__(1711);
	
	var _accountEditorModal2 = _interopRequireDefault(_accountEditorModal);
	
	var _UserActions = __webpack_require__(1158);
	
	var _UserActions2 = _interopRequireDefault(_UserActions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var NEW_ACCOUNT = "NEW";
	
	var AccountTable = function (_React$Component) {
	  _inherits(AccountTable, _React$Component);
	
	  function AccountTable(props) {
	    _classCallCheck(this, AccountTable);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(AccountTable).call(this, props));
	
	    _this.state = {
	      deletedAccounts: {},
	      accountIdBeingEdited: null
	    };
	
	    _this._edit = _this._edit.bind(_this);
	    _this._delete = _this._delete.bind(_this);
	    _this._saveAccount = _this._saveAccount.bind(_this);
	    _this._dismissAccount = _this._dismissAccount.bind(_this);
	    _this._makeRowForAccount = _this._makeRowForAccount.bind(_this);
	    return _this;
	  }
	
	  _createClass(AccountTable, [{
	    key: "_edit",
	    value: function _edit(id, e) {
	      e.preventDefault();
	
	      if (id === this.props.selfAccountId) {
	        return this.props.onSelfEdit();
	      }
	
	      this.setState({ accountIdBeingEdited: id });
	    }
	  }, {
	    key: "_delete",
	    value: function _delete(id, e) {
	      e.preventDefault();
	
	      if (window.confirm("Are you sure you want to delete this account? There is no going back.")) {
	        _UserActions2.default.deleteAccount(id);
	        this.state.deletedAccounts[id] = true;
	        this.setState(this.state);
	      }
	    }
	  }, {
	    key: "_saveAccount",
	    value: function _saveAccount(account) {
	      var id = this.state.accountIdBeingEdited;
	
	      if (id === NEW_ACCOUNT) {
	        _UserActions2.default.createAccount(account);
	      } else {
	        _UserActions2.default.editAccount(id, account);
	      }
	
	      this._dismissAccount();
	    }
	  }, {
	    key: "_dismissAccount",
	    value: function _dismissAccount() {
	      this.setState({ accountIdBeingEdited: null });
	    }
	  }, {
	    key: "_makeRowForAccount",
	    value: function _makeRowForAccount(account) {
	      var isDeleted = this.state.deletedAccounts[account.id],
	          isSelf = account.id === this.props.selfAccountId;
	
	      return _react2.default.createElement(
	        _reactable.Tr,
	        {
	          style: isDeleted && { textDecoration: "line-through", color: "#ccc" },
	          key: account.id
	        },
	        _react2.default.createElement(
	          _reactable.Td,
	          { column: "Name", value: account.name },
	          _react2.default.createElement(
	            "span",
	            null,
	            account.name,
	            isSelf && " (you)"
	          )
	        ),
	        _react2.default.createElement(
	          _reactable.Td,
	          { column: "Email", value: account.email },
	          _react2.default.createElement(
	            "span",
	            null,
	            account.email,
	            " ",
	            account.sso_last_authenticated_at ? _react2.default.createElement(
	              "span",
	              { style: { fontWeight: "bold" } },
	              "(via SSO \u2705)"
	            ) : ""
	          )
	        ),
	        _react2.default.createElement(
	          _reactable.Td,
	          { column: "Role", value: account.role },
	          this.props.roles[account.role] && this.props.roles[account.role].label
	        ),
	        _react2.default.createElement(
	          _reactable.Td,
	          { column: "Actions" },
	          _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(
	              "a",
	              {
	                style: isDeleted && { color: "#ccc" },
	                href: "#",
	                onClick: this._edit.bind(this, account.id)
	              },
	              "Edit"
	            ),
	            !isDeleted && !isSelf && _react2.default.createElement(
	              "span",
	              null,
	              "\xA0",
	              _react2.default.createElement(
	                "a",
	                { href: "#", onClick: this._delete.bind(this, account.id) },
	                "Delete"
	              )
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var rows = Object.values(this.props.accounts).map(this._makeRowForAccount);
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        this.state.accountIdBeingEdited ? _react2.default.createElement(_accountEditorModal2.default, {
	          isNew: this.state.accountIdBeingEdited === NEW_ACCOUNT,
	          account: this.props.accounts[this.state.accountIdBeingEdited],
	          roles: this.props.roles,
	          onSave: this._saveAccount,
	          onCancel: this._dismissAccount
	        }) : null,
	        _react2.default.createElement(
	          _reactable.Table,
	          {
	            className: "bordered striped responsive-table",
	            columns: ["Name", "Email", "Role", "Actions"]
	          },
	          rows
	        ),
	        _react2.default.createElement(_materialUi.RaisedButton, {
	          label: "Add new account",
	          primary: true,
	          style: { marginTop: 10 },
	          onTouchTap: this._edit.bind(this, NEW_ACCOUNT)
	        })
	      );
	    }
	  }]);
	
	  return AccountTable;
	}(_react2.default.Component);
	
	exports.default = AccountTable;
	module.exports = exports["default"];

/***/ }),
/* 1711 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _materialUi = __webpack_require__(576);
	
	var _reactSelect = __webpack_require__(953);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	var _label = __webpack_require__(1682);
	
	var _label2 = _interopRequireDefault(_label);
	
	var _infoNotice = __webpack_require__(1599);
	
	var _infoNotice2 = _interopRequireDefault(_infoNotice);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var USER_SHOULD_SET_PASSWORD = "USER_SHOULD_SET_PASSWORD";
	var PASSWORD_PLACEHOLDER = "•••••••••";
	
	var AccountEditorModal = function (_React$Component) {
	  _inherits(AccountEditorModal, _React$Component);
	
	  function AccountEditorModal(props) {
	    _classCallCheck(this, AccountEditorModal);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(AccountEditorModal).call(this, props));
	
	    _this.state = {
	      values: {}
	    };
	
	    _this.onRequestClose = _this.onRequestClose.bind(_this);
	    _this.onSave = _this.onSave.bind(_this);
	    _this.onChangeValue = _this.onChangeValue.bind(_this);
	    return _this;
	  }
	
	  _createClass(AccountEditorModal, [{
	    key: "getStyles",
	    value: function getStyles() {
	      return {
	        container: {
	          margin: "15px 0"
	        },
	        inputContainer: {
	          textAlign: "left",
	          margin: "0 auto",
	          maxWidth: "90%",
	          width: 256
	        },
	        actions: {
	          marginTop: 15
	        },
	        dialogTitle: {
	          borderBottom: "none"
	        },
	        dialogActionsContainer: {
	          borderTop: "none"
	        }
	      };
	    }
	  }, {
	    key: "onRequestClose",
	    value: function onRequestClose() {
	      this.props.onCancel();
	    }
	  }, {
	    key: "onSave",
	    value: function onSave() {
	      this.props.onSave(this.state.values);
	    }
	  }, {
	    key: "onChangeValue",
	    value: function onChangeValue(id, value) {
	      var values = this.state.values;
	
	      values[id] = value;
	      this.setState({ values: values });
	    }
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.componentWillReceiveProps(this.props);
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(newProps) {
	      var account = newProps.account || {};
	
	      this.setState({
	        values: {
	          name: account.name,
	          email: account.email,
	          password: newProps.isNew ? USER_SHOULD_SET_PASSWORD : "",
	          role: account.role || "admin"
	        }
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var styles = this.getStyles();
	      var roles = this.props.roles;
	
	
	      return _react2.default.createElement(
	        _materialUi.Dialog,
	        {
	          title: this.props.isNew ? "Create account" : "Edit account",
	          titleStyle: styles.dialogTitle,
	          actionsContainerStyle: styles.dialogActionsContainer,
	          openImmediately: true,
	          actions: [_react2.default.createElement(_materialUi.FlatButton, { label: "Cancel", onTouchTap: this.onRequestClose }), _react2.default.createElement(_materialUi.FlatButton, { primary: true, label: "Save", onTouchTap: this.onSave })],
	          modal: true,
	          open: true,
	          autoDetectWindowHeight: false,
	          autoScrollBodyContent: false,
	          bodyStyle: { overflowY: "visible" },
	          onRequestClose: this.onRequestClose
	        },
	        _react2.default.createElement(
	          "form",
	          { autoComplete: "off", style: { width: 256, margin: "0 auto" } },
	          _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(_materialUi.TextField, {
	              value: this.state.values.name,
	              floatingLabelText: "Name",
	              floatingLabelFixed: true,
	              onChange: function onChange(e) {
	                return _this2.onChangeValue("name", e.target.value);
	              }
	            })
	          ),
	          _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(_materialUi.TextField, {
	              value: this.state.values.email,
	              floatingLabelText: "Email address",
	              floatingLabelFixed: true,
	              type: "email",
	              autoComplete: "username email",
	              onChange: function onChange(e) {
	                return _this2.onChangeValue("email", e.target.value);
	              }
	            })
	          ),
	          _react2.default.createElement(
	            "div",
	            null,
	            this.props.isNew ? _react2.default.createElement(
	              "div",
	              null,
	              _react2.default.createElement(
	                _label2.default,
	                null,
	                "Password"
	              ),
	              _react2.default.createElement(_materialUi.Checkbox, {
	                label: "Send link for account holder to set",
	                style: { fontSize: "0.75em" },
	                checked: this.state.values.password === USER_SHOULD_SET_PASSWORD,
	                onCheck: function onCheck(e, checked) {
	                  return _this2.onChangeValue("password", checked ? USER_SHOULD_SET_PASSWORD : "");
	                }
	              })
	            ) : null,
	            this.state.values.password !== USER_SHOULD_SET_PASSWORD ? _react2.default.createElement(_materialUi.TextField, {
	              value: this.state.values.password,
	              hintText: PASSWORD_PLACEHOLDER,
	              floatingLabelFixed: true,
	              floatingLabelText: !this.props.isNew && "Password",
	              type: "password",
	              autoComplete: "new-password",
	              onChange: function onChange(e) {
	                return _this2.onChangeValue("password", e.target.value);
	              }
	            }) : null
	          ),
	          _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(
	              _label2.default,
	              null,
	              "Role"
	            ),
	            _react2.default.createElement(_reactSelect2.default, {
	              clearable: false,
	              value: this.state.values.role,
	              options: Object.keys(roles).map(function (k) {
	                return {
	                  label: roles[k].label,
	                  value: k
	                };
	              }),
	              onChange: function onChange(e) {
	                return _this2.onChangeValue("role", e ? e.value : "");
	              }
	            }),
	            _react2.default.createElement(
	              _infoNotice2.default,
	              { style: { marginTop: "1em", fontSize: "10pt" } },
	              "Check out our",
	              " ",
	              _react2.default.createElement(
	                "a",
	                {
	                  href: "https://help.eventive.org/en/articles/5971421-explanation-of-roles-and-permissions",
	                  target: "_blank"
	                },
	                "guide to roles and permissions"
	              ),
	              "."
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return AccountEditorModal;
	}(_react2.default.Component);
	
	exports.default = AccountEditorModal;
	module.exports = exports["default"];

/***/ }),
/* 1712 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	exports.default = function (_ref) {
	  var onTouchTap = _ref.onTouchTap;
	  var href = _ref.href;
	  var connected = _ref.connected;
	
	  var rest = _objectWithoutProperties(_ref, ["onTouchTap", "href", "connected"]);
	
	  function _onTouchTap(e) {
	    e.preventDefault();
	    onTouchTap();
	  }
	
	  return React.createElement(
	    "a",
	    _extends({}, rest, {
	      onClick: onTouchTap && _onTouchTap,
	      href: href || "#",
	      className: "stripe-connect light-blue"
	    }),
	    React.createElement(
	      "span",
	      null,
	      connected ? "Bank account connected" : "Connect bank account"
	    )
	  );
	};
	
	module.exports = exports["default"];

/***/ }),
/* 1713 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(332);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _materialUi = __webpack_require__(576);
	
	var _card = __webpack_require__(1714);
	
	var _card2 = _interopRequireDefault(_card);
	
	var _payment = __webpack_require__(1720);
	
	var _payment2 = _interopRequireDefault(_payment);
	
	var _cardSwipe = __webpack_require__(1729);
	
	var _cardSwipe2 = _interopRequireDefault(_cardSwipe);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CreditCardEntry = function (_React$Component) {
	  _inherits(CreditCardEntry, _React$Component);
	
	  function CreditCardEntry(props) {
	    _classCallCheck(this, CreditCardEntry);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(CreditCardEntry).call(this, props));
	
	    _this.state = {
	      number: "",
	      name: "",
	      expiry: "",
	      cvc: "",
	      isWaitingForSwipe: false,
	      rawSwipe: "",
	      isSwiped: false
	    };
	
	    _this.getPaymentDetails = _this.getPaymentDetails.bind(_this);
	    _this.reset = _this.reset.bind(_this);
	
	    _this.onChange = _this.onChange.bind(_this);
	
	    _this.startSwipe = _this.startSwipe.bind(_this);
	    _this.onSwipeInputChange = _this.onSwipeInputChange.bind(_this);
	    _this.onSwipeInputBlur = _this.onSwipeInputBlur.bind(_this);
	    _this.onSwipeInputKeyDown = _this.onSwipeInputKeyDown.bind(_this);
	    _this.onSwipeCancel = _this.onSwipeCancel.bind(_this);
	    _this.onSwipe = _this.onSwipe.bind(_this);
	    return _this;
	  }
	
	  _createClass(CreditCardEntry, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.card = new _card2.default({
	        form: _reactDom2.default.findDOMNode(this.form),
	        container: _reactDom2.default.findDOMNode(this.cardPreview),
	        debug: true
	      });
	
	      this.scanner = new _cardSwipe2.default.Scanner();
	      new _cardSwipe2.default({
	        scanner: this.scanner,
	        onScan: this.onSwipe
	      });
	    }
	  }, {
	    key: "getPaymentDetails",
	    value: function getPaymentDetails() {
	      var _ref = this.state.expiry ? this.state.expiry.split(/\s*\/\s*/) : [null, null];
	
	      var _ref2 = _slicedToArray(_ref, 2);
	
	      var month = _ref2[0];
	      var year = _ref2[1];
	      var paymentDetails = {
	        name: this.state.name,
	        number: this.state.number,
	        cvc: this.state.isSwiped ? undefined : this.state.cvc, // Swipe doesn't have CVC
	        exp_month: month,
	        exp_year: year
	      };
	
	      return paymentDetails;
	    }
	  }, {
	    key: "reset",
	    value: function reset() {
	      this.setState({
	        number: null,
	        name: null,
	        expiry: null,
	        cvc: null
	      });
	    }
	  }, {
	    key: "onChange",
	    value: function onChange() {
	      if (this.props.onChange) {
	        this.props.onChange(this.getPaymentDetails());
	      }
	    }
	  }, {
	    key: "set",
	    value: function set(fields) {
	      this.setState(fields);
	    }
	  }, {
	    key: "startSwipe",
	    value: function startSwipe() {
	      var _this2 = this;
	
	      this.setState({
	        isWaitingForSwipe: true,
	        rawSwipe: ""
	      }, function () {
	        _this2.swipeInput.focus();
	      });
	    }
	  }, {
	    key: "onSwipeInputChange",
	    value: function onSwipeInputChange(e) {
	      this.setState({ rawSwipe: e.target.value });
	    }
	  }, {
	    key: "onSwipeInputBlur",
	    value: function onSwipeInputBlur() {
	      var _this3 = this;
	
	      // Don't let focus switch from the swipe while waiting for swipe
	      if (this.state.isWaitingForSwipe) {
	        setTimeout(function () {
	          _this3.swipeInput.focus();
	        }, 10);
	      }
	    }
	  }, {
	    key: "onSwipeInputKeyDown",
	    value: function onSwipeInputKeyDown(e) {
	      if (e.keyCode === 13) {
	        try {
	          this.scanner.input(this.state.rawSwipe);
	        } catch (e) {
	          // fall through
	          // just want 'em to swipe again
	        }
	      }
	    }
	  }, {
	    key: "onSwipeCancel",
	    value: function onSwipeCancel() {
	      this.setState({
	        isWaitingForSwipe: false
	      });
	    }
	  }, {
	    key: "onSwipe",
	    value: function onSwipe(swipeInfo) {
	      var _this4 = this;
	
	      // Ignore empty swipes
	      if (!Object.keys(swipeInfo).length) {
	        return;
	      }
	
	      this.setState({
	        number: swipeInfo.account,
	        name: swipeInfo.name,
	        expiry: swipeInfo.exp_month + "/" + swipeInfo.exp_year,
	        isWaitingForSwipe: false,
	        isSwiped: true
	      }, function () {
	        _this4.onChange();
	      });
	
	      // Force card re-render
	      var e = document.createEvent("HTMLEvents");
	      e.initEvent("keyup", false, true);
	      Array.prototype.slice.call(this.form.getElementsByTagName("input")).forEach(function (node) {
	        node.dispatchEvent(e);
	      });
	    }
	  }, {
	    key: "onFieldChange",
	    value: function onFieldChange(key, e) {
	      var _this5 = this;
	
	      var value = e.target.value;
	
	      // Manually format + dispatch cardType change since not fired on Android Chrome
	      // https://github.com/jessepollak/card/issues/199
	
	      if (key === "number") {
	        value = _payment2.default.fns.formatCardNumber(value);
	        try {
	          var cardType = _payment2.default.fns.cardType(value);
	          var ev = new CustomEvent("payment.cardType", { detail: cardType });
	          this._cardNumberField.input.dispatchEvent(ev);
	        } catch (exception) {
	          // silently swallow IE11 exceptions
	        }
	      } else if (key === "expiry") {
	        var trimmed = value.trim(),
	            firstCharZeroOrOne = trimmed[0] === "0" || trimmed[0] === "1";
	
	        if (trimmed.length === 1 && !firstCharZeroOrOne || trimmed.length == 2 && firstCharZeroOrOne) {
	          value = trimmed + " / ";
	        }
	      }
	
	      this.setState(_defineProperty({}, key, value), function () {
	        _this5.onChange();
	      });
	    }
	  }, {
	    key: "getStyles",
	    value: function getStyles() {
	      return {
	        swipeInput: {
	          // Invisible - this is populated by the USB card reader
	          width: 0,
	          overflow: "hidden"
	        },
	        swipeButton: {
	          marginBottom: 20,
	          marginLeft: 5,
	          marginRight: 5
	        },
	        cardPreview: {
	          float: "right",
	          maxWidth: "100%",
	          overflow: "hidden"
	        },
	        form: {
	          marginRight: 10
	        },
	        field: {
	          margin: 2
	        },
	        actions: {
	          marginTop: 10
	        },
	        error: {
	          color: "#FF4136"
	        }
	      };
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this6 = this;
	
	      var styles = this.getStyles();
	
	      return _react2.default.createElement(
	        "div",
	        { style: this.props.style },
	        _react2.default.createElement(
	          "div",
	          { style: styles.swipeInput },
	          _react2.default.createElement("input", {
	            id: "CreditCardEntry--input",
	            ref: function ref(_ref3) {
	              return _this6.swipeInput = _ref3;
	            },
	            type: "text",
	            onChange: this.onSwipeInputChange,
	            onBlur: this.onSwipeInputBlur,
	            onKeyDown: this.onSwipeInputKeyDown,
	            value: this.state.rawSwipe
	          })
	        ),
	        _react2.default.createElement(
	          _materialUi.Dialog,
	          {
	            title: "Swipe card",
	            actions: [_react2.default.createElement(_materialUi.FlatButton, {
	              label: "Cancel",
	              primary: true,
	              onTouchTap: this.onSwipeCancel
	            })],
	            modal: false,
	            open: this.state.isWaitingForSwipe,
	            onRequestClose: this.onSwipeCancel
	          },
	          "Swipe the card now using any USB card reader."
	        ),
	        "Click to",
	        " ",
	        _react2.default.createElement(_materialUi.RaisedButton, {
	          style: styles.swipeButton,
	          label: "Swipe card",
	          onTouchTap: this.startSwipe
	        }),
	        " ",
	        "or manually enter details below.",
	        _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement("div", {
	            className: "cardPreview",
	            ref: function ref(_ref4) {
	              return _this6.cardPreview = _ref4;
	            },
	            style: styles.cardPreview
	          }),
	          _react2.default.createElement(
	            "form",
	            { ref: function ref(_ref5) {
	                return _this6.form = _ref5;
	              }, style: styles.form },
	            _react2.default.createElement(_materialUi.TextField, {
	              placeholder: "Card number",
	              name: "number",
	              disabled: this.state.isSwiped,
	              value: this.state.number || "",
	              onKeyUp: this.onFieldChange.bind(this, "number"),
	              onChange: this.onFieldChange.bind(this, "number"),
	              ref: function ref(i) {
	                return _this6._cardNumberField = i;
	              },
	              pattern: "\\d*",
	              type: "tel",
	              style: styles.field
	            }),
	            _react2.default.createElement(_materialUi.TextField, {
	              placeholder: "Name on card",
	              type: "text",
	              name: "name",
	              disabled: this.state.isSwiped,
	              value: this.state.name || "",
	              onChange: this.onFieldChange.bind(this, "name"),
	              style: styles.field
	            }),
	            _react2.default.createElement(_materialUi.TextField, {
	              placeholder: "MM/YY",
	              name: "expiry",
	              disabled: this.state.isSwiped,
	              value: this.state.expiry || "",
	              onChange: this.onFieldChange.bind(this, "expiry"),
	              pattern: "\\d*",
	              type: "tel",
	              ref: "cardExpiryField",
	              style: styles.field
	            }),
	            !this.state.isSwiped ? // Swipe doesn't have CVC
	            _react2.default.createElement(_materialUi.TextField, {
	              placeholder: "CVC",
	              name: "cvc",
	              value: this.state.cvc || "",
	              onChange: this.onFieldChange.bind(this, "cvc"),
	              pattern: "\\d*",
	              type: "tel",
	              ref: "cardCVCField",
	              style: styles.field
	            }) : _react2.default.createElement("div", { style: { height: 48, width: 50 } })
	          )
	        )
	      );
	    }
	  }]);
	
	  return CreditCardEntry;
	}(_react2.default.Component);
	
	exports.default = CreditCardEntry;
	module.exports = exports["default"];

/***/ }),
/* 1714 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {// Generated by CoffeeScript 1.12.7
	(function() {
	  var Card, QJ, extend, payment,
	    bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };
	
	  __webpack_require__(1715);
	
	  QJ = __webpack_require__(1719);
	
	  payment = __webpack_require__(1720);
	
	  extend = __webpack_require__(1723);
	
	  Card = (function() {
	    var bindVal, setVal;
	
	    Card.prototype.initializedDataAttr = "data-jp-card-initialized";
	
	    Card.prototype.cardTemplate = '' + '<div class="jp-card-container">' + '<div class="jp-card">' + '<div class="jp-card-front">' + '<div class="jp-card-logo jp-card-elo">' + '<div class="e">e</div>' + '<div class="l">l</div>' + '<div class="o">o</div>' + '</div>' + '<div class="jp-card-logo jp-card-visa">Visa</div>' + '<div class="jp-card-logo jp-card-visaelectron">Visa<div class="elec">Electron</div></div>' + '<div class="jp-card-logo jp-card-mastercard">Mastercard</div>' + '<div class="jp-card-logo jp-card-maestro">Maestro</div>' + '<div class="jp-card-logo jp-card-amex"></div>' + '<div class="jp-card-logo jp-card-discover">discover</div>' + '<div class="jp-card-logo jp-card-unionpay">UnionPay</div>' + '<div class="jp-card-logo jp-card-dinersclub"></div>' + '<div class="jp-card-logo jp-card-hipercard">Hipercard</div>' + '<div class="jp-card-logo jp-card-troy">troy</div>' + '<div class="jp-card-logo jp-card-dankort"><div class="dk"><div class="d"></div><div class="k"></div></div></div>' + '<div class="jp-card-logo jp-card-jcb">' + '<div class="j">J</div>' + '<div class="c">C</div>' + '<div class="b">B</div>' + '</div>' + '<div class="jp-card-lower">' + '<div class="jp-card-shiny"></div>' + '<div class="jp-card-cvc jp-card-display">{{cvc}}</div>' + '<div class="jp-card-number jp-card-display">{{number}}</div>' + '<div class="jp-card-name jp-card-display">{{name}}</div>' + '<div class="jp-card-expiry jp-card-display" data-before="{{monthYear}}" data-after="{{validDate}}">{{expiry}}</div>' + '</div>' + '</div>' + '<div class="jp-card-back">' + '<div class="jp-card-bar"></div>' + '<div class="jp-card-cvc jp-card-display">{{cvc}}</div>' + '<div class="jp-card-shiny"></div>' + '</div>' + '</div>' + '</div>';
	
	    Card.prototype.template = function(tpl, data) {
	      return tpl.replace(/\{\{(.*?)\}\}/g, function(match, key, str) {
	        return data[key];
	      });
	    };
	
	    Card.prototype.cardTypes = ['jp-card-amex', 'jp-card-dankort', 'jp-card-dinersclub', 'jp-card-discover', 'jp-card-unionpay', 'jp-card-jcb', 'jp-card-laser', 'jp-card-maestro', 'jp-card-mastercard', 'jp-card-troy', 'jp-card-unionpay', 'jp-card-visa', 'jp-card-visaelectron', 'jp-card-elo', 'jp-card-hipercard'];
	
	    Card.prototype.defaults = {
	      formatting: true,
	      formSelectors: {
	        numberInput: 'input[name="number"]',
	        expiryInput: 'input[name="expiry"]',
	        cvcInput: 'input[name="cvc"]',
	        nameInput: 'input[name="name"]'
	      },
	      cardSelectors: {
	        cardContainer: '.jp-card-container',
	        card: '.jp-card',
	        numberDisplay: '.jp-card-number',
	        expiryDisplay: '.jp-card-expiry',
	        cvcDisplay: '.jp-card-cvc',
	        nameDisplay: '.jp-card-name'
	      },
	      messages: {
	        validDate: 'valid\nthru',
	        monthYear: 'month/year'
	      },
	      placeholders: {
	        number: '&bull;&bull;&bull;&bull; &bull;&bull;&bull;&bull; &bull;&bull;&bull;&bull; &bull;&bull;&bull;&bull;',
	        cvc: '&bull;&bull;&bull;',
	        expiry: '&bull;&bull;/&bull;&bull;',
	        name: 'Full Name'
	      },
	      masks: {
	        cardNumber: false
	      },
	      classes: {
	        valid: 'jp-card-valid',
	        invalid: 'jp-card-invalid'
	      },
	      debug: false
	    };
	
	    function Card(opts) {
	      this.maskCardNumber = bind(this.maskCardNumber, this);
	      var toInitialize;
	      this.options = extend(true, this.defaults, opts);
	      if (!this.options.form) {
	        console.log("Please provide a form");
	        return;
	      }
	      this.$el = QJ(this.options.form);
	      if (!this.options.container) {
	        console.log("Please provide a container");
	        return;
	      }
	      this.$container = QJ(this.options.container);
	      toInitialize = QJ.isDOMElement(this.$container) ? this.$container : this.$container[0];
	      if (toInitialize.getAttribute(this.initializedDataAttr)) {
	        return;
	      }
	      toInitialize.setAttribute(this.initializedDataAttr, true);
	      this.render();
	      this.attachHandlers();
	      this.handleInitialPlaceholders();
	    }
	
	    Card.prototype.render = function() {
	      var $cardContainer, baseWidth, name, obj, ref, ref1, selector, ua;
	      QJ.append(this.$container, this.template(this.cardTemplate, extend({}, this.options.messages, this.options.placeholders)));
	      ref = this.options.cardSelectors;
	      for (name in ref) {
	        selector = ref[name];
	        this["$" + name] = QJ.find(this.$container, selector);
	      }
	      ref1 = this.options.formSelectors;
	      for (name in ref1) {
	        selector = ref1[name];
	        selector = this.options[name] ? this.options[name] : selector;
	        obj = QJ.find(this.$el, selector);
	        if (!obj.length && this.options.debug) {
	          console.error("Card can't find a " + name + " in your form.");
	        }
	        this["$" + name] = obj;
	      }
	      if (this.options.formatting) {
	        Payment.formatCardNumber(this.$numberInput);
	        Payment.formatCardCVC(this.$cvcInput);
	        Payment.formatCardExpiry(this.$expiryInput);
	      }
	      if (this.options.width) {
	        $cardContainer = QJ(this.options.cardSelectors.cardContainer)[0];
	        baseWidth = parseInt($cardContainer.clientWidth || window.getComputedStyle($cardContainer).width);
	        $cardContainer.style.transform = "scale(" + (this.options.width / baseWidth) + ")";
	      }
	      if (typeof navigator !== "undefined" && navigator !== null ? navigator.userAgent : void 0) {
	        ua = navigator.userAgent.toLowerCase();
	        if (ua.indexOf('safari') !== -1 && ua.indexOf('chrome') === -1) {
	          QJ.addClass(this.$card, 'jp-card-safari');
	        }
	      }
	      if (/MSIE 10\./i.test(navigator.userAgent)) {
	        QJ.addClass(this.$card, 'jp-card-ie-10');
	      }
	      if (/rv:11.0/i.test(navigator.userAgent)) {
	        return QJ.addClass(this.$card, 'jp-card-ie-11');
	      }
	    };
	
	    Card.prototype.attachHandlers = function() {
	      var expiryFilters, numberInputFilters;
	      numberInputFilters = [this.validToggler('cardNumber')];
	      if (this.options.masks.cardNumber) {
	        numberInputFilters.push(this.maskCardNumber);
	      }
	      bindVal(this.$numberInput, this.$numberDisplay, {
	        fill: false,
	        filters: numberInputFilters
	      });
	      QJ.on(this.$numberInput, 'payment.cardType', this.handle('setCardType'));
	      expiryFilters = [
	        function(val) {
	          if (val.length === 1 && val[0] === '0') {
	            return '';
	          } else {
	            return val.replace(/(\s+)/g, '');
	          }
	        }
	      ];
	      expiryFilters.push(this.validToggler('cardExpiry'));
	      bindVal(this.$expiryInput, this.$expiryDisplay, {
	        join: function(text) {
	          if (text[0].length === 2 || text[1]) {
	            return "/";
	          } else {
	            return "";
	          }
	        },
	        filters: expiryFilters
	      });
	      bindVal(this.$cvcInput, this.$cvcDisplay, {
	        filters: this.validToggler('cardCVC')
	      });
	      QJ.on(this.$cvcInput, 'focus', this.handle('flipCard'));
	      QJ.on(this.$cvcInput, 'blur', this.handle('unflipCard'));
	      return bindVal(this.$nameInput, this.$nameDisplay, {
	        fill: false,
	        filters: this.validToggler('cardHolderName'),
	        join: ' '
	      });
	    };
	
	    Card.prototype.handleInitialPlaceholders = function() {
	      var el, name, ref, results, selector;
	      ref = this.options.formSelectors;
	      results = [];
	      for (name in ref) {
	        selector = ref[name];
	        el = this["$" + name];
	        if (el instanceof NodeList) {
	          el = el[0];
	        }
	        if (QJ.val(el)) {
	          QJ.trigger(el, 'paste');
	          results.push((function(el) {
	            return setTimeout(function() {
	              return QJ.trigger(el, 'keyup');
	            });
	          })(el));
	        } else {
	          results.push(void 0);
	        }
	      }
	      return results;
	    };
	
	    Card.prototype.handle = function(fn) {
	      return (function(_this) {
	        return function(e) {
	          var args;
	          args = Array.prototype.slice.call(arguments);
	          args.unshift(e.target);
	          return _this.handlers[fn].apply(_this, args);
	        };
	      })(this);
	    };
	
	    Card.prototype.validToggler = function(validatorName) {
	      var isValid;
	      if (validatorName === "cardExpiry") {
	        isValid = function(val) {
	          var objVal;
	          objVal = Payment.fns.cardExpiryVal(val);
	          return Payment.fns.validateCardExpiry(objVal.month, objVal.year);
	        };
	      } else if (validatorName === "cardCVC") {
	        isValid = (function(_this) {
	          return function(val) {
	            return Payment.fns.validateCardCVC(val, _this.cardType);
	          };
	        })(this);
	      } else if (validatorName === "cardNumber") {
	        isValid = function(val) {
	          return Payment.fns.validateCardNumber(val);
	        };
	      } else if (validatorName === "cardHolderName") {
	        isValid = function(val) {
	          return val !== "";
	        };
	      }
	      return (function(_this) {
	        return function(val, $in, $out) {
	          var result;
	          result = isValid(val);
	          _this.toggleValidClass($in, result);
	          _this.toggleValidClass($out, result);
	          return val;
	        };
	      })(this);
	    };
	
	    Card.prototype.toggleValidClass = function(el, test) {
	      QJ.toggleClass(el, this.options.classes.valid, test);
	      return QJ.toggleClass(el, this.options.classes.invalid, !test);
	    };
	
	    Card.prototype.maskCardNumber = function(val, el, out) {
	      var mask, numbers;
	      mask = this.options.masks.cardNumber;
	      numbers = val.split(' ');
	      if (numbers.length >= 3) {
	        numbers.forEach(function(item, idx) {
	          if (idx !== numbers.length - 1) {
	            return numbers[idx] = numbers[idx].replace(/\d/g, mask);
	          }
	        });
	        return numbers.join(' ');
	      } else {
	        return val.replace(/\d/g, mask);
	      }
	    };
	
	    Card.prototype.handlers = {
	      setCardType: function($el, e) {
	        var cardType, event;
	        cardType = e.data;
	        event = new CustomEvent('card-type-changed', {
	          'detail': e.data
	        });
	        document.dispatchEvent(event);
	        if (!QJ.hasClass(this.$card, cardType)) {
	          QJ.removeClass(this.$card, 'jp-card-unknown');
	          QJ.removeClass(this.$card, this.cardTypes.join(' '));
	          QJ.addClass(this.$card, "jp-card-" + cardType);
	          QJ.toggleClass(this.$card, 'jp-card-identified', cardType !== 'unknown');
	          return this.cardType = cardType;
	        }
	      },
	      flipCard: function() {
	        return QJ.addClass(this.$card, 'jp-card-flipped');
	      },
	      unflipCard: function() {
	        return QJ.removeClass(this.$card, 'jp-card-flipped');
	      }
	    };
	
	    bindVal = function(el, out, opts) {
	      var joiner, o, outDefaults;
	      if (opts == null) {
	        opts = {};
	      }
	      opts.fill = opts.fill || false;
	      opts.filters = opts.filters || [];
	      if (!(opts.filters instanceof Array)) {
	        opts.filters = [opts.filters];
	      }
	      opts.join = opts.join || "";
	      if (!(typeof opts.join === "function")) {
	        joiner = opts.join;
	        opts.join = function() {
	          return joiner;
	        };
	      }
	      outDefaults = (function() {
	        var j, len, results;
	        results = [];
	        for (j = 0, len = out.length; j < len; j++) {
	          o = out[j];
	          results.push(o.textContent);
	        }
	        return results;
	      })();
	      setVal(el, out, outDefaults, opts);
	      QJ.on(el, 'focus', function() {
	        return QJ.addClass(out, 'jp-card-focused');
	      });
	      QJ.on(el, 'blur', function() {
	        return QJ.removeClass(out, 'jp-card-focused');
	      });
	      QJ.on(el, 'keyup change paste', function(e) {
	        return setVal(el, out, outDefaults, opts);
	      });
	      return el;
	    };
	
	    setVal = function(el, out, outDefaults, opts) {
	      var elem, filter, i, j, join, k, len, len1, outEl, outVal, ref, results, val;
	      val = (function() {
	        var j, len, results;
	        results = [];
	        for (j = 0, len = el.length; j < len; j++) {
	          elem = el[j];
	          results.push(QJ.val(elem));
	        }
	        return results;
	      })();
	      join = opts.join(val);
	      val = val.join(join);
	      if (val === join) {
	        val = "";
	      }
	      ref = opts.filters;
	      for (j = 0, len = ref.length; j < len; j++) {
	        filter = ref[j];
	        val = filter(val, el, out);
	      }
	      results = [];
	      for (i = k = 0, len1 = out.length; k < len1; i = ++k) {
	        outEl = out[i];
	        if (opts.fill) {
	          outVal = val + outDefaults[i].substring(val.length);
	        } else {
	          outVal = val || outDefaults[i];
	        }
	        results.push(outEl.textContent = outVal);
	      }
	      return results;
	    };
	
	    Card.prototype.getCardType = function() {
	      var ccType;
	      ccType = Payment.fns.cardType(this.$numberInput[0].value);
	      if (ccType) {
	        return ccType;
	      } else {
	        return 'unknown';
	      }
	    };
	
	    return Card;
	
	  })();
	
	  module.exports = Card;
	
	  global.Card = Card;
	
	}).call(this);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 1715 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1716);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(1718)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../css-loader/index.js!./card.css", function() {
				var newContent = require("!!./../../css-loader/index.js!./card.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1716 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1717)();
	// imports
	
	
	// module
	exports.push([module.id, ".jp-card.jp-card-safari.jp-card-identified .jp-card-back:before,.jp-card.jp-card-safari.jp-card-identified .jp-card-front:before{background-image:repeating-linear-gradient(45deg,hsla(0,0%,100%,0) 1px,hsla(0,0%,100%,.03) 2px,hsla(0,0%,100%,.04) 3px,hsla(0,0%,100%,.05) 4px),repeating-linear-gradient(135deg,hsla(0,0%,100%,.05) 1px,hsla(0,0%,100%,0) 2px,hsla(0,0%,100%,.04) 3px,hsla(0,0%,100%,.03) 4px),repeating-linear-gradient(90deg,hsla(0,0%,100%,0) 1px,hsla(0,0%,100%,.03) 2px,hsla(0,0%,100%,.04) 3px,hsla(0,0%,100%,.05) 4px),repeating-linear-gradient(210deg,hsla(0,0%,100%,0) 1px,hsla(0,0%,100%,.03) 2px,hsla(0,0%,100%,.04) 3px,hsla(0,0%,100%,.05) 4px),-webkit-linear-gradient(-245deg,hsla(0,0%,100%,0) 50%,hsla(0,0%,100%,.2) 70%,hsla(0,0%,100%,0) 90%);background-image:repeating-linear-gradient(45deg,hsla(0,0%,100%,0) 1px,hsla(0,0%,100%,.03) 2px,hsla(0,0%,100%,.04) 3px,hsla(0,0%,100%,.05) 4px),repeating-linear-gradient(135deg,hsla(0,0%,100%,.05) 1px,hsla(0,0%,100%,0) 2px,hsla(0,0%,100%,.04) 3px,hsla(0,0%,100%,.03) 4px),repeating-linear-gradient(90deg,hsla(0,0%,100%,0) 1px,hsla(0,0%,100%,.03) 2px,hsla(0,0%,100%,.04) 3px,hsla(0,0%,100%,.05) 4px),repeating-linear-gradient(210deg,hsla(0,0%,100%,0) 1px,hsla(0,0%,100%,.03) 2px,hsla(0,0%,100%,.04) 3px,hsla(0,0%,100%,.05) 4px),linear-gradient(-25deg,hsla(0,0%,100%,0) 50%,hsla(0,0%,100%,.2) 70%,hsla(0,0%,100%,0) 90%)}.jp-card.jp-card-ie-10.jp-card-flipped,.jp-card.jp-card-ie-11.jp-card-flipped{-webkit-transform:0deg;transform:0deg}.jp-card.jp-card-ie-10.jp-card-flipped .jp-card-back,.jp-card.jp-card-ie-10.jp-card-flipped .jp-card-front,.jp-card.jp-card-ie-11.jp-card-flipped .jp-card-back,.jp-card.jp-card-ie-11.jp-card-flipped .jp-card-front{-webkit-transform:rotateY(0deg);transform:rotateY(0deg)}.jp-card.jp-card-ie-10.jp-card-flipped .jp-card-back:after,.jp-card.jp-card-ie-11.jp-card-flipped .jp-card-back:after{left:18%}.jp-card.jp-card-ie-10.jp-card-flipped .jp-card-back .jp-card-cvc,.jp-card.jp-card-ie-11.jp-card-flipped .jp-card-back .jp-card-cvc{-webkit-transform:rotateY(180deg);transform:rotateY(180deg);left:5%}.jp-card.jp-card-ie-10.jp-card-flipped .jp-card-back .jp-card-shiny,.jp-card.jp-card-ie-11.jp-card-flipped .jp-card-back .jp-card-shiny{left:84%}.jp-card.jp-card-ie-10.jp-card-flipped .jp-card-back .jp-card-shiny:after,.jp-card.jp-card-ie-11.jp-card-flipped .jp-card-back .jp-card-shiny:after{left:-480%;-webkit-transform:rotateY(180deg);transform:rotateY(180deg)}.jp-card.jp-card-ie-10.jp-card-amex .jp-card-back,.jp-card.jp-card-ie-11.jp-card-amex .jp-card-back{display:none}.jp-card-logo{height:36px;width:60px;font-style:italic}.jp-card-logo,.jp-card-logo:after,.jp-card-logo:before{box-sizing:border-box}.jp-card-logo.jp-card-amex{text-transform:uppercase;font-size:4px;font-weight:700;color:#fff;background-image:repeating-radial-gradient(circle at center,#fff 1px,#999 2px);border:1px solid #eee}.jp-card-logo.jp-card-amex:after,.jp-card-logo.jp-card-amex:before{width:28px;display:block;position:absolute;left:16px}.jp-card-logo.jp-card-amex:before{height:28px;content:\"american\";top:3px;text-align:left;padding-left:2px;padding-top:11px;background:#267ac3}.jp-card-logo.jp-card-amex:after{content:\"express\";bottom:11px;text-align:right;padding-right:2px}.jp-card.jp-card-amex.jp-card-flipped{-webkit-transform:none;transform:none}.jp-card.jp-card-amex.jp-card-identified .jp-card-back:before,.jp-card.jp-card-amex.jp-card-identified .jp-card-front:before{background-color:#108168}.jp-card.jp-card-amex.jp-card-identified .jp-card-front .jp-card-logo.jp-card-amex{opacity:1}.jp-card.jp-card-amex.jp-card-identified .jp-card-front .jp-card-cvc{visibility:visible}.jp-card.jp-card-amex.jp-card-identified .jp-card-front:after{opacity:1}.jp-card-logo.jp-card-discover{background:#f60;color:#111;text-transform:uppercase;font-style:normal;font-weight:700;font-size:10px;text-align:center;overflow:hidden;z-index:1;padding-top:9px;letter-spacing:.03em;border:1px solid #eee}.jp-card-logo.jp-card-discover:after,.jp-card-logo.jp-card-discover:before{content:\" \";display:block;position:absolute}.jp-card-logo.jp-card-discover:before{background:#fff;width:200px;height:200px;border-radius:200px;bottom:-5%;right:-80%;z-index:-1}.jp-card-logo.jp-card-discover:after{width:8px;height:8px;border-radius:4px;top:10px;left:27px;background-color:#f60;background-image:-webkit-radial-gradient(#f60,#fff);background-image:radial-gradient(#f60,#fff);content:\"network\";font-size:4px;line-height:24px;text-indent:-7px}.jp-card .jp-card-front .jp-card-logo.jp-card-discover{right:12%;top:18%}.jp-card.jp-card-discover.jp-card-identified .jp-card-back:before,.jp-card.jp-card-discover.jp-card-identified .jp-card-front:before{background-color:#86b8cf}.jp-card.jp-card-discover.jp-card-identified .jp-card-logo.jp-card-discover{opacity:1}.jp-card.jp-card-discover.jp-card-identified .jp-card-front:after{-webkit-transition:.4s;transition:.4s;content:\" \";display:block;background-color:#f60;background-image:-webkit-linear-gradient(#f60,#ffa366,#f60);background-image:linear-gradient(#f60,#ffa366,#f60);height:50px;width:50px;border-radius:25px;position:absolute;left:100%;top:15%;margin-left:-25px;box-shadow:inset 1px 1px 3px 1px rgba(0,0,0,.5)}.jp-card-logo.jp-card-unionpay{width:60px;display:block;height:40px;background:#e21836;-webkit-transform:skew(-15deg);-moz-transform:skew(20deg);-o-transform:skew(20deg);border-radius:5px;font-size:10px;z-index:1;line-height:33px;color:#fff;text-align:center;font-family:\"Sans-serif\",Microsoft Yahei,\\\\5FAE\\8F6F\\96C5\\9ED1,Hiragino Sans,Gulim,\\\\5B8B\\4F53;font-weight:700}.jp-card-logo.jp-card-unionpay:after,.jp-card-logo.jp-card-unionpay:before{display:block;margin:0 auto;position:absolute;height:40px;top:0;z-index:-1}.jp-card-logo.jp-card-unionpay:before{content:\" \";width:28px;background:#00447c;left:14px;border-top-left-radius:5px;border-bottom-left-radius:5px}.jp-card-logo.jp-card-unionpay:after{content:\"\\94F6\\8054\";width:26px;background:#007b84;left:34px;border-radius:5px;font-size:10px;line-height:54px;text-indent:-17px}.jp-card.jp-card-unionpay.jp-card-identified .jp-card-back:before,.jp-card.jp-card-unionpay.jp-card-identified .jp-card-front:before{background-color:#987c00}.jp-card.jp-card-unionpay.jp-card-identified .jp-card-logo.jp-card-unionpay{opacity:1}.jp-card-logo.jp-card-visa{text-transform:uppercase;color:#fff;text-align:center;font-weight:700;font-size:24px;line-height:18px;margin-top:5px}.jp-card-logo.jp-card-visa:after,.jp-card-logo.jp-card-visa:before{content:\" \";display:block;width:100%;height:25%}.jp-card-logo.jp-card-visa:before{position:absolute;left:-4px;width:0;height:0;border-style:solid;border-width:0 12px 6px 0;border-color:transparent #fff transparent transparent}.jp-card.jp-card-visa.jp-card-identified .jp-card-back:before,.jp-card.jp-card-visa.jp-card-identified .jp-card-front:before{background-color:#191278}.jp-card.jp-card-visa.jp-card-identified .jp-card-logo.jp-card-visa{opacity:1;box-shadow:none}.jp-card-logo.jp-card-visaelectron{background:#fff;text-transform:uppercase;color:#1a1876;text-align:center;font-weight:700;font-size:15px;line-height:18px}.jp-card-logo.jp-card-visaelectron:after,.jp-card-logo.jp-card-visaelectron:before{content:\" \";display:block;width:100%;height:25%}.jp-card-logo.jp-card-visaelectron:before{background:#1a1876}.jp-card-logo.jp-card-visaelectron:after{background:#e79800}.jp-card-logo.jp-card-visaelectron .elec{float:right;font-family:arial;font-size:9px;margin-right:1px;margin-top:-5px;text-transform:none}.jp-card.jp-card-visaelectron.jp-card-identified .jp-card-back:before,.jp-card.jp-card-visaelectron.jp-card-identified .jp-card-front:before{background-color:#191278}.jp-card.jp-card-visaelectron.jp-card-identified .jp-card-logo.jp-card-visaelectron{opacity:1}.jp-card-logo.jp-card-mastercard{color:#fff;font-style:normal;text-transform:lowercase;font-weight:700;text-align:center;font-size:9px;line-height:84px;z-index:1;text-shadow:1px 1px rgba(0,0,0,.6)}.jp-card-logo.jp-card-mastercard:after,.jp-card-logo.jp-card-mastercard:before{content:\" \";display:block;width:36px;top:0;position:absolute;height:36px;border-radius:18px}.jp-card-logo.jp-card-mastercard:before{left:0;background:#eb001b;z-index:-1;opacity:.9}.jp-card-logo.jp-card-mastercard:after{right:0;background:#ff5f00;z-index:-2}.jp-card.jp-card-mastercard.jp-card-identified .jp-card-back .jp-card-logo.jp-card-mastercard,.jp-card.jp-card-mastercard.jp-card-identified .jp-card-front .jp-card-logo.jp-card-mastercard{box-shadow:none}.jp-card.jp-card-mastercard.jp-card-identified .jp-card-back:before,.jp-card.jp-card-mastercard.jp-card-identified .jp-card-front:before{background-color:#0061a8}.jp-card.jp-card-mastercard.jp-card-identified .jp-card-logo.jp-card-mastercard{opacity:1}.jp-card-logo.jp-card-maestro{color:#fff;font-style:normal;text-transform:lowercase;font-weight:700;text-align:center;font-size:14px;line-height:84px;z-index:1;text-shadow:1px 1px rgba(0,0,0,.6)}.jp-card-logo.jp-card-maestro:after,.jp-card-logo.jp-card-maestro:before{content:\" \";display:block;width:36px;top:0;position:absolute;height:36px;border-radius:18px}.jp-card-logo.jp-card-maestro:before{left:0;background:#eb001b;z-index:-2}.jp-card-logo.jp-card-maestro:after{right:0;background:#00a2e5;z-index:-1;opacity:.8}.jp-card.jp-card-maestro.jp-card-identified .jp-card-back .jp-card-logo.jp-card-maestro,.jp-card.jp-card-maestro.jp-card-identified .jp-card-front .jp-card-logo.jp-card-maestro{box-shadow:none}.jp-card.jp-card-maestro.jp-card-identified .jp-card-back:before,.jp-card.jp-card-maestro.jp-card-identified .jp-card-front:before{background-color:#0b2c5f}.jp-card.jp-card-maestro.jp-card-identified .jp-card-logo.jp-card-maestro{opacity:1}.jp-card-logo.jp-card-dankort{width:60px;height:36px;padding:3px;border-radius:8px;border:1px solid #000;background-color:#fff}.jp-card-logo.jp-card-dankort .dk{position:relative;width:100%;height:100%;overflow:hidden}.jp-card-logo.jp-card-dankort .dk:before{background-color:#ed1c24;content:'';position:absolute;width:100%;height:100%;display:block;border-radius:6px}.jp-card-logo.jp-card-dankort .dk:after{content:'';position:absolute;top:50%;margin-top:-7.7px;right:0;width:0;height:0;border-style:solid;border-width:7px 7px 10px 0;border-color:transparent #ed1c24 transparent transparent;z-index:1}.jp-card-logo.jp-card-dankort .d,.jp-card-logo.jp-card-dankort .k{position:absolute;top:50%;width:50%;display:block;height:15.4px;margin-top:-7.7px;background:#fff}.jp-card-logo.jp-card-dankort .d{left:0;border-radius:0 8px 10px 0}.jp-card-logo.jp-card-dankort .d:before{content:'';position:absolute;top:50%;left:50%;display:block;background:#ed1c24;border-radius:2px 4px 6px 0;height:5px;width:7px;margin:-3px 0 0 -4px}.jp-card-logo.jp-card-dankort .k{right:0}.jp-card-logo.jp-card-dankort .k:after,.jp-card-logo.jp-card-dankort .k:before{content:'';position:absolute;right:50%;width:0;height:0;border-style:solid;margin-right:-1px}.jp-card-logo.jp-card-dankort .k:before{top:0;border-width:8px 5px 0 0;border-color:#ed1c24 transparent transparent}.jp-card-logo.jp-card-dankort .k:after{bottom:0;border-width:0 5px 8px 0;border-color:transparent transparent #ed1c24}.jp-card.jp-card-dankort.jp-card-identified .jp-card-back:before,.jp-card.jp-card-dankort.jp-card-identified .jp-card-front:before{background-color:#0055c7}.jp-card.jp-card-dankort.jp-card-identified .jp-card-logo.jp-card-dankort{opacity:1}.jp-card-logo.jp-card-elo{height:50px;width:50px;border-radius:100%;background:#000;color:#fff;text-align:center;text-transform:lowercase;font-size:21px;font-style:normal;letter-spacing:1px;font-weight:700;padding-top:13px}.jp-card-logo.jp-card-elo .e,.jp-card-logo.jp-card-elo .l,.jp-card-logo.jp-card-elo .o{display:inline-block;position:relative}.jp-card-logo.jp-card-elo .e{-webkit-transform:rotate(-15deg);transform:rotate(-15deg)}.jp-card-logo.jp-card-elo .o{position:relative;display:inline-block;width:12px;height:12px;right:0;top:7px;border-radius:100%;background-image:-webkit-linear-gradient(#ff0 50%,red 0);background-image:linear-gradient(#ff0 50%,red 0);-webkit-transform:rotate(40deg);transform:rotate(40deg);text-indent:-9999px}.jp-card-logo.jp-card-elo .o:before{content:\"\";position:absolute;width:49%;height:49%;background:#000;border-radius:100%;text-indent:-99999px;top:25%;left:25%}.jp-card.jp-card-elo.jp-card-identified .jp-card-back:before,.jp-card.jp-card-elo.jp-card-identified .jp-card-front:before{background-color:#6f6969}.jp-card.jp-card-elo.jp-card-identified .jp-card-logo.jp-card-elo{opacity:1}.jp-card-logo.jp-card-jcb{background-color:#fff;font-style:normal;color:#fff;width:50px;padding:2px 0 0 2px}.jp-card-logo.jp-card-jcb,.jp-card-logo.jp-card-jcb>div{border-radius:5px 0 5px 0;-moz-border-radius:5px 0 5px 0;-webkit-border-radius:5px 0 5px 0}.jp-card-logo.jp-card-jcb>div{width:15px;margin-right:1px;display:inline-block;text-align:center;text-shadow:1px 1px rgba(0,0,0,.6)}.jp-card-logo.jp-card-jcb>div:after,.jp-card-logo.jp-card-jcb>div:before{content:\" \";display:block;height:8px}.jp-card-logo.jp-card-jcb>div.j{background-color:#000063;background-image:-webkit-linear-gradient(left,#000063,#008cff);background-image:linear-gradient(90deg,#000063,#008cff)}.jp-card-logo.jp-card-jcb>div.c{background-color:#630000;background-image:-webkit-linear-gradient(left,#630000,#ff008d);background-image:linear-gradient(90deg,#630000,#ff008d)}.jp-card-logo.jp-card-jcb>div.b{background-color:#006300;background-image:-webkit-linear-gradient(left,#006300,#0f0);background-image:linear-gradient(90deg,#006300,#0f0)}.jp-card.jp-card-jcb.jp-card-identified .jp-card-back:before,.jp-card.jp-card-jcb.jp-card-identified .jp-card-front:before{background-color:#cb8000}.jp-card.jp-card-jcb.jp-card-identified .jp-card-logo.jp-card-jcb{opacity:1;box-shadow:none}.jp-card-logo.jp-card-dinersclub{font-family:serif;height:40px;width:100px;color:#fff;font-size:17px;font-style:normal;letter-spacing:1px}.jp-card-logo.jp-card-dinersclub:after,.jp-card-logo.jp-card-dinersclub:before{display:block;position:relative}.jp-card-logo.jp-card-dinersclub:before{content:'Diners Club'}.jp-card-logo.jp-card-dinersclub:after{content:'International';text-transform:uppercase;font-size:.6em}.jp-card.jp-card-dinersclub .jp-card-front .jp-card-logo{box-shadow:none!important}.jp-card.jp-card-dinersclub.jp-card-identified .jp-card-back:before,.jp-card.jp-card-dinersclub.jp-card-identified .jp-card-front:before{background-color:#999}.jp-card.jp-card-dinersclub.jp-card-identified .jp-card-logo.jp-card-dinersclub{opacity:1}.jp-card-logo.jp-card-hipercard{height:20px;width:100px;color:#fff;font-size:21px;font-style:italic;font-weight:700}.jp-card-logo.jp-card-hipercard:after,.jp-card-logo.jp-card-hipercard:before{display:block;position:relative}.jp-card.jp-card-hipercard.jp-card-identified .jp-card-back:before,.jp-card.jp-card-hipercard.jp-card-identified .jp-card-front:before{background-color:#770304}.jp-card.jp-card-hipercard.jp-card-identified .jp-card-logo.jp-card-hipercard{opacity:1;box-shadow:none}.jp-card-logo.jp-card-troy{text-transform:lowercase;color:#fff;text-align:center;font-weight:700;font-size:24px;line-height:18px;margin-top:5px}.jp-card-logo.jp-card-troy:after,.jp-card-logo.jp-card-troy:before{content:\\\"\\\";display:block;width:26%;height:6%;background:#22b8c3;right:32%;top:24%;position:absolute;transform:rotate(105deg)}.jp-card.jp-card-troy.jp-card-identified .jp-card-back:before,.jp-card.jp-card-troy.jp-card-identified .jp-card-front:before{background-color:#01adba}.jp-card.jp-card-troy.jp-card-identified .jp-card-logo.jp-card-troy{opacity:1;box-shadow:none}.jp-card-container{-webkit-perspective:1000px;perspective:1000px;width:350px;max-width:100%;height:200px;margin:auto;z-index:1;position:relative}.jp-card{font-family:Helvetica Neue,Helvetica,Arial,sans-serif;line-height:1;position:relative;width:100%;height:100%;min-width:315px;border-radius:10px;-webkit-transform-style:preserve-3d;transform-style:preserve-3d;-webkit-transition:all .4s linear;transition:all .4s linear}.jp-card>*,.jp-card>:after,.jp-card>:before{box-sizing:border-box;font-family:inherit}.jp-card.jp-card-flipped{-webkit-transform:rotateY(180deg);transform:rotateY(180deg)}.jp-card .jp-card-back,.jp-card .jp-card-front{-webkit-backface-visibility:hidden;backface-visibility:hidden;-webkit-transform-style:preserve-3d;transform-style:preserve-3d;-webkit-transition:all .4s linear;transition:all .4s linear;width:100%;height:100%;position:absolute;top:0;left:0;overflow:hidden;border-radius:10px;background:#ddd}.jp-card .jp-card-back:before,.jp-card .jp-card-front:before{content:\" \";display:block;position:absolute;width:100%;height:100%;top:0;left:0;opacity:0;border-radius:10px;-webkit-transition:all .4s ease;transition:all .4s ease}.jp-card .jp-card-back:after,.jp-card .jp-card-front:after{content:\" \";display:block}.jp-card .jp-card-back .jp-card-display,.jp-card .jp-card-front .jp-card-display{color:#fff;font-weight:400;opacity:.5;-webkit-transition:opacity .4s linear;transition:opacity .4s linear}.jp-card .jp-card-back .jp-card-display.jp-card-focused,.jp-card .jp-card-front .jp-card-display.jp-card-focused{opacity:1;font-weight:700}.jp-card .jp-card-back .jp-card-cvc,.jp-card .jp-card-front .jp-card-cvc{font-family:Bitstream Vera Sans Mono,Consolas,Courier,monospace;font-size:14px}.jp-card .jp-card-back .jp-card-shiny,.jp-card .jp-card-front .jp-card-shiny{width:50px;height:35px;border-radius:5px;background:#ccc;position:relative}.jp-card .jp-card-back .jp-card-shiny:before,.jp-card .jp-card-front .jp-card-shiny:before{content:\" \";display:block;width:70%;height:60%;border-top-right-radius:5px;border-bottom-right-radius:5px;background:#d9d9d9;position:absolute;top:20%}.jp-card .jp-card-front .jp-card-logo{position:absolute;opacity:0;right:5%;top:8%;-webkit-transition:.4s;transition:.4s}.jp-card .jp-card-front .jp-card-lower{width:80%;position:absolute;left:10%;bottom:30px}@media only screen and (max-width:480px){.jp-card .jp-card-front .jp-card-lower{width:90%;left:5%}}.jp-card .jp-card-front .jp-card-lower .jp-card-cvc{visibility:hidden;float:right;position:relative;bottom:5px}.jp-card .jp-card-front .jp-card-lower .jp-card-number{font-family:Bitstream Vera Sans Mono,Consolas,Courier,monospace;font-size:24px;clear:both;margin-bottom:30px}.jp-card .jp-card-front .jp-card-lower .jp-card-expiry{font-family:Bitstream Vera Sans Mono,Consolas,Courier,monospace;letter-spacing:0;position:relative;float:right;width:25%}.jp-card .jp-card-front .jp-card-lower .jp-card-expiry:after,.jp-card .jp-card-front .jp-card-lower .jp-card-expiry:before{font-family:Helvetica Neue,Helvetica,Arial,sans-serif;font-weight:700;font-size:7px;white-space:pre;display:block;opacity:.5}.jp-card .jp-card-front .jp-card-lower .jp-card-expiry:before{content:attr(data-before);margin-bottom:2px;font-size:7px;text-transform:uppercase}.jp-card .jp-card-front .jp-card-lower .jp-card-expiry:after{position:absolute;content:attr(data-after);text-align:right;right:100%;margin-right:5px;margin-top:2px;bottom:0}.jp-card .jp-card-front .jp-card-lower .jp-card-name{text-transform:uppercase;font-family:Bitstream Vera Sans Mono,Consolas,Courier,monospace;font-size:20px;max-height:45px;position:absolute;bottom:0;width:190px;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:horizontal;overflow:hidden;text-overflow:ellipsis}.jp-card .jp-card-back{-webkit-transform:rotateY(180deg);transform:rotateY(180deg)}.jp-card .jp-card-back .jp-card-bar{background-color:#444;background-image:-webkit-linear-gradient(#444,#333);background-image:linear-gradient(#444,#333);width:100%;height:20%;position:absolute;top:10%}.jp-card .jp-card-back:after{content:\" \";display:block;background-color:#fff;background-image:-webkit-linear-gradient(#fff,#fff);background-image:linear-gradient(#fff,#fff);width:80%;height:16%;position:absolute;top:40%;left:2%}.jp-card .jp-card-back .jp-card-cvc{position:absolute;top:40%;left:85%;-webkit-transition-delay:.6s;transition-delay:.6s}.jp-card .jp-card-back .jp-card-shiny{position:absolute;top:66%;left:2%}.jp-card .jp-card-back .jp-card-shiny:after{content:\"This card has been issued by Jesse Pollak and is licensed for anyone to use anywhere for free. It comes with no warranty. For support issues, please visit: github.com/jessepollak/card.\";position:absolute;left:120%;top:5%;color:#fff;font-size:7px;width:230px;opacity:.5}.jp-card.jp-card-identified{box-shadow:0 0 20px rgba(0,0,0,.3)}.jp-card.jp-card-identified .jp-card-back,.jp-card.jp-card-identified .jp-card-front{background-color:#000;background-color:rgba(0,0,0,.5)}.jp-card.jp-card-identified .jp-card-back:before,.jp-card.jp-card-identified .jp-card-front:before{-webkit-transition:all .4s ease;transition:all .4s ease;background-image:repeating-linear-gradient(45deg,hsla(0,0%,100%,0) 1px,hsla(0,0%,100%,.03) 2px,hsla(0,0%,100%,.04) 3px,hsla(0,0%,100%,.05) 4px),repeating-linear-gradient(135deg,hsla(0,0%,100%,.05) 1px,hsla(0,0%,100%,0) 2px,hsla(0,0%,100%,.04) 3px,hsla(0,0%,100%,.03) 4px),repeating-linear-gradient(90deg,hsla(0,0%,100%,0) 1px,hsla(0,0%,100%,.03) 2px,hsla(0,0%,100%,.04) 3px,hsla(0,0%,100%,.05) 4px),repeating-linear-gradient(210deg,hsla(0,0%,100%,0) 1px,hsla(0,0%,100%,.03) 2px,hsla(0,0%,100%,.04) 3px,hsla(0,0%,100%,.05) 4px),repeating-radial-gradient(circle at 30% 30%,hsla(0,0%,100%,0) 1px,hsla(0,0%,100%,.03) 2px,hsla(0,0%,100%,.04) 3px,hsla(0,0%,100%,.05) 4px),repeating-radial-gradient(circle at 70% 70%,hsla(0,0%,100%,0) 1px,hsla(0,0%,100%,.03) 2px,hsla(0,0%,100%,.04) 3px,hsla(0,0%,100%,.05) 4px),repeating-radial-gradient(circle at 90% 20%,hsla(0,0%,100%,0) 1px,hsla(0,0%,100%,.03) 2px,hsla(0,0%,100%,.04) 3px,hsla(0,0%,100%,.05) 4px),repeating-radial-gradient(circle at 15% 80%,hsla(0,0%,100%,0) 1px,hsla(0,0%,100%,.03) 2px,hsla(0,0%,100%,.04) 3px,hsla(0,0%,100%,.05) 4px),-webkit-linear-gradient(-245deg,hsla(0,0%,100%,0) 50%,hsla(0,0%,100%,.2) 70%,hsla(0,0%,100%,0) 90%);background-image:repeating-linear-gradient(45deg,hsla(0,0%,100%,0) 1px,hsla(0,0%,100%,.03) 2px,hsla(0,0%,100%,.04) 3px,hsla(0,0%,100%,.05) 4px),repeating-linear-gradient(135deg,hsla(0,0%,100%,.05) 1px,hsla(0,0%,100%,0) 2px,hsla(0,0%,100%,.04) 3px,hsla(0,0%,100%,.03) 4px),repeating-linear-gradient(90deg,hsla(0,0%,100%,0) 1px,hsla(0,0%,100%,.03) 2px,hsla(0,0%,100%,.04) 3px,hsla(0,0%,100%,.05) 4px),repeating-linear-gradient(210deg,hsla(0,0%,100%,0) 1px,hsla(0,0%,100%,.03) 2px,hsla(0,0%,100%,.04) 3px,hsla(0,0%,100%,.05) 4px),repeating-radial-gradient(circle at 30% 30%,hsla(0,0%,100%,0) 1px,hsla(0,0%,100%,.03) 2px,hsla(0,0%,100%,.04) 3px,hsla(0,0%,100%,.05) 4px),repeating-radial-gradient(circle at 70% 70%,hsla(0,0%,100%,0) 1px,hsla(0,0%,100%,.03) 2px,hsla(0,0%,100%,.04) 3px,hsla(0,0%,100%,.05) 4px),repeating-radial-gradient(circle at 90% 20%,hsla(0,0%,100%,0) 1px,hsla(0,0%,100%,.03) 2px,hsla(0,0%,100%,.04) 3px,hsla(0,0%,100%,.05) 4px),repeating-radial-gradient(circle at 15% 80%,hsla(0,0%,100%,0) 1px,hsla(0,0%,100%,.03) 2px,hsla(0,0%,100%,.04) 3px,hsla(0,0%,100%,.05) 4px),linear-gradient(-25deg,hsla(0,0%,100%,0) 50%,hsla(0,0%,100%,.2) 70%,hsla(0,0%,100%,0) 90%);opacity:1}.jp-card.jp-card-identified .jp-card-back .jp-card-logo,.jp-card.jp-card-identified .jp-card-front .jp-card-logo{box-shadow:0 0 0 2px hsla(0,0%,100%,.3)}.jp-card.jp-card-identified.no-radial-gradient .jp-card-back:before,.jp-card.jp-card-identified.no-radial-gradient .jp-card-front:before{background-image:repeating-linear-gradient(45deg,hsla(0,0%,100%,0) 1px,hsla(0,0%,100%,.03) 2px,hsla(0,0%,100%,.04) 3px,hsla(0,0%,100%,.05) 4px),repeating-linear-gradient(135deg,hsla(0,0%,100%,.05) 1px,hsla(0,0%,100%,0) 2px,hsla(0,0%,100%,.04) 3px,hsla(0,0%,100%,.03) 4px),repeating-linear-gradient(90deg,hsla(0,0%,100%,0) 1px,hsla(0,0%,100%,.03) 2px,hsla(0,0%,100%,.04) 3px,hsla(0,0%,100%,.05) 4px),repeating-linear-gradient(210deg,hsla(0,0%,100%,0) 1px,hsla(0,0%,100%,.03) 2px,hsla(0,0%,100%,.04) 3px,hsla(0,0%,100%,.05) 4px),-webkit-linear-gradient(-245deg,hsla(0,0%,100%,0) 50%,hsla(0,0%,100%,.2) 70%,hsla(0,0%,100%,0) 90%);background-image:repeating-linear-gradient(45deg,hsla(0,0%,100%,0) 1px,hsla(0,0%,100%,.03) 2px,hsla(0,0%,100%,.04) 3px,hsla(0,0%,100%,.05) 4px),repeating-linear-gradient(135deg,hsla(0,0%,100%,.05) 1px,hsla(0,0%,100%,0) 2px,hsla(0,0%,100%,.04) 3px,hsla(0,0%,100%,.03) 4px),repeating-linear-gradient(90deg,hsla(0,0%,100%,0) 1px,hsla(0,0%,100%,.03) 2px,hsla(0,0%,100%,.04) 3px,hsla(0,0%,100%,.05) 4px),repeating-linear-gradient(210deg,hsla(0,0%,100%,0) 1px,hsla(0,0%,100%,.03) 2px,hsla(0,0%,100%,.04) 3px,hsla(0,0%,100%,.05) 4px),linear-gradient(-25deg,hsla(0,0%,100%,0) 50%,hsla(0,0%,100%,.2) 70%,hsla(0,0%,100%,0) 90%)}@media (max-width:450px){.card-wrapper{max-width:80vw;width:100%;margin:20px auto;overflow-x:hidden}.card-wrapper>.jp-card-container{transform:scale(.625);transform-origin:left center}}", ""]);
	
	// exports


/***/ }),
/* 1717 */
/***/ (function(module, exports) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	// css base code, injected by the css-loader
	module.exports = function() {
		var list = [];
	
		// return the list of modules as css string
		list.toString = function toString() {
			var result = [];
			for(var i = 0; i < this.length; i++) {
				var item = this[i];
				if(item[2]) {
					result.push("@media " + item[2] + "{" + item[1] + "}");
				} else {
					result.push(item[1]);
				}
			}
			return result.join("");
		};
	
		// import a list of modules into the list
		list.i = function(modules, mediaQuery) {
			if(typeof modules === "string")
				modules = [[null, modules, ""]];
			var alreadyImportedModules = {};
			for(var i = 0; i < this.length; i++) {
				var id = this[i][0];
				if(typeof id === "number")
					alreadyImportedModules[id] = true;
			}
			for(i = 0; i < modules.length; i++) {
				var item = modules[i];
				// skip already imported module
				// this implementation is not 100% perfect for weird media query combinations
				//  when a module is imported multiple times with different media queries.
				//  I hope this will never occur (Hey this way we have smaller bundles)
				if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
					if(mediaQuery && !item[2]) {
						item[2] = mediaQuery;
					} else if(mediaQuery) {
						item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
					}
					list.push(item);
				}
			}
		};
		return list;
	};


/***/ }),
/* 1718 */
/***/ (function(module, exports, __webpack_require__) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	var stylesInDom = {},
		memoize = function(fn) {
			var memo;
			return function () {
				if (typeof memo === "undefined") memo = fn.apply(this, arguments);
				return memo;
			};
		},
		isOldIE = memoize(function() {
			return /msie [6-9]\b/.test(window.navigator.userAgent.toLowerCase());
		}),
		getHeadElement = memoize(function () {
			return document.head || document.getElementsByTagName("head")[0];
		}),
		singletonElement = null,
		singletonCounter = 0,
		styleElementsInsertedAtTop = [];
	
	module.exports = function(list, options) {
		if(false) {
			if(typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
		}
	
		options = options || {};
		// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
		// tags it will allow on a page
		if (typeof options.singleton === "undefined") options.singleton = isOldIE();
	
		// By default, add <style> tags to the bottom of <head>.
		if (typeof options.insertAt === "undefined") options.insertAt = "bottom";
	
		var styles = listToStyles(list);
		addStylesToDom(styles, options);
	
		return function update(newList) {
			var mayRemove = [];
			for(var i = 0; i < styles.length; i++) {
				var item = styles[i];
				var domStyle = stylesInDom[item.id];
				domStyle.refs--;
				mayRemove.push(domStyle);
			}
			if(newList) {
				var newStyles = listToStyles(newList);
				addStylesToDom(newStyles, options);
			}
			for(var i = 0; i < mayRemove.length; i++) {
				var domStyle = mayRemove[i];
				if(domStyle.refs === 0) {
					for(var j = 0; j < domStyle.parts.length; j++)
						domStyle.parts[j]();
					delete stylesInDom[domStyle.id];
				}
			}
		};
	}
	
	function addStylesToDom(styles, options) {
		for(var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];
			if(domStyle) {
				domStyle.refs++;
				for(var j = 0; j < domStyle.parts.length; j++) {
					domStyle.parts[j](item.parts[j]);
				}
				for(; j < item.parts.length; j++) {
					domStyle.parts.push(addStyle(item.parts[j], options));
				}
			} else {
				var parts = [];
				for(var j = 0; j < item.parts.length; j++) {
					parts.push(addStyle(item.parts[j], options));
				}
				stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
			}
		}
	}
	
	function listToStyles(list) {
		var styles = [];
		var newStyles = {};
		for(var i = 0; i < list.length; i++) {
			var item = list[i];
			var id = item[0];
			var css = item[1];
			var media = item[2];
			var sourceMap = item[3];
			var part = {css: css, media: media, sourceMap: sourceMap};
			if(!newStyles[id])
				styles.push(newStyles[id] = {id: id, parts: [part]});
			else
				newStyles[id].parts.push(part);
		}
		return styles;
	}
	
	function insertStyleElement(options, styleElement) {
		var head = getHeadElement();
		var lastStyleElementInsertedAtTop = styleElementsInsertedAtTop[styleElementsInsertedAtTop.length - 1];
		if (options.insertAt === "top") {
			if(!lastStyleElementInsertedAtTop) {
				head.insertBefore(styleElement, head.firstChild);
			} else if(lastStyleElementInsertedAtTop.nextSibling) {
				head.insertBefore(styleElement, lastStyleElementInsertedAtTop.nextSibling);
			} else {
				head.appendChild(styleElement);
			}
			styleElementsInsertedAtTop.push(styleElement);
		} else if (options.insertAt === "bottom") {
			head.appendChild(styleElement);
		} else {
			throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
		}
	}
	
	function removeStyleElement(styleElement) {
		styleElement.parentNode.removeChild(styleElement);
		var idx = styleElementsInsertedAtTop.indexOf(styleElement);
		if(idx >= 0) {
			styleElementsInsertedAtTop.splice(idx, 1);
		}
	}
	
	function createStyleElement(options) {
		var styleElement = document.createElement("style");
		styleElement.type = "text/css";
		insertStyleElement(options, styleElement);
		return styleElement;
	}
	
	function createLinkElement(options) {
		var linkElement = document.createElement("link");
		linkElement.rel = "stylesheet";
		insertStyleElement(options, linkElement);
		return linkElement;
	}
	
	function addStyle(obj, options) {
		var styleElement, update, remove;
	
		if (options.singleton) {
			var styleIndex = singletonCounter++;
			styleElement = singletonElement || (singletonElement = createStyleElement(options));
			update = applyToSingletonTag.bind(null, styleElement, styleIndex, false);
			remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true);
		} else if(obj.sourceMap &&
			typeof URL === "function" &&
			typeof URL.createObjectURL === "function" &&
			typeof URL.revokeObjectURL === "function" &&
			typeof Blob === "function" &&
			typeof btoa === "function") {
			styleElement = createLinkElement(options);
			update = updateLink.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
				if(styleElement.href)
					URL.revokeObjectURL(styleElement.href);
			};
		} else {
			styleElement = createStyleElement(options);
			update = applyToTag.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
			};
		}
	
		update(obj);
	
		return function updateStyle(newObj) {
			if(newObj) {
				if(newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap)
					return;
				update(obj = newObj);
			} else {
				remove();
			}
		};
	}
	
	var replaceText = (function () {
		var textStore = [];
	
		return function (index, replacement) {
			textStore[index] = replacement;
			return textStore.filter(Boolean).join('\n');
		};
	})();
	
	function applyToSingletonTag(styleElement, index, remove, obj) {
		var css = remove ? "" : obj.css;
	
		if (styleElement.styleSheet) {
			styleElement.styleSheet.cssText = replaceText(index, css);
		} else {
			var cssNode = document.createTextNode(css);
			var childNodes = styleElement.childNodes;
			if (childNodes[index]) styleElement.removeChild(childNodes[index]);
			if (childNodes.length) {
				styleElement.insertBefore(cssNode, childNodes[index]);
			} else {
				styleElement.appendChild(cssNode);
			}
		}
	}
	
	function applyToTag(styleElement, obj) {
		var css = obj.css;
		var media = obj.media;
	
		if(media) {
			styleElement.setAttribute("media", media)
		}
	
		if(styleElement.styleSheet) {
			styleElement.styleSheet.cssText = css;
		} else {
			while(styleElement.firstChild) {
				styleElement.removeChild(styleElement.firstChild);
			}
			styleElement.appendChild(document.createTextNode(css));
		}
	}
	
	function updateLink(linkElement, obj) {
		var css = obj.css;
		var sourceMap = obj.sourceMap;
	
		if(sourceMap) {
			// http://stackoverflow.com/a/26603875
			css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
		}
	
		var blob = new Blob([css], { type: "text/css" });
	
		var oldSrc = linkElement.href;
	
		linkElement.href = URL.createObjectURL(blob);
	
		if(oldSrc)
			URL.revokeObjectURL(oldSrc);
	}


/***/ }),
/* 1719 */
/***/ (function(module, exports) {

	// Generated by CoffeeScript 1.10.0
	(function() {
	  var QJ, rreturn, rtrim;
	
	  QJ = function(selector) {
	    if (QJ.isDOMElement(selector)) {
	      return selector;
	    }
	    return document.querySelectorAll(selector);
	  };
	
	  QJ.isDOMElement = function(el) {
	    return el && (el.nodeName != null);
	  };
	
	  rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;
	
	  QJ.trim = function(text) {
	    if (text === null) {
	      return "";
	    } else {
	      return (text + "").replace(rtrim, "");
	    }
	  };
	
	  rreturn = /\r/g;
	
	  QJ.val = function(el, val) {
	    var ret;
	    if (arguments.length > 1) {
	      return el.value = val;
	    } else {
	      ret = el.value;
	      if (typeof ret === "string") {
	        return ret.replace(rreturn, "");
	      } else {
	        if (ret === null) {
	          return "";
	        } else {
	          return ret;
	        }
	      }
	    }
	  };
	
	  QJ.preventDefault = function(eventObject) {
	    if (typeof eventObject.preventDefault === "function") {
	      eventObject.preventDefault();
	      return;
	    }
	    eventObject.returnValue = false;
	    return false;
	  };
	
	  QJ.normalizeEvent = function(e) {
	    var original;
	    original = e;
	    e = {
	      which: original.which != null ? original.which : void 0,
	      target: original.target || original.srcElement,
	      preventDefault: function() {
	        return QJ.preventDefault(original);
	      },
	      originalEvent: original,
	      data: original.data || original.detail
	    };
	    if (e.which == null) {
	      e.which = original.charCode != null ? original.charCode : original.keyCode;
	    }
	    return e;
	  };
	
	  QJ.on = function(element, eventName, callback) {
	    var el, i, j, len, len1, multEventName, originalCallback, ref;
	    if (element.length) {
	      for (i = 0, len = element.length; i < len; i++) {
	        el = element[i];
	        QJ.on(el, eventName, callback);
	      }
	      return;
	    }
	    if (eventName.match(" ")) {
	      ref = eventName.split(" ");
	      for (j = 0, len1 = ref.length; j < len1; j++) {
	        multEventName = ref[j];
	        QJ.on(element, multEventName, callback);
	      }
	      return;
	    }
	    originalCallback = callback;
	    callback = function(e) {
	      e = QJ.normalizeEvent(e);
	      return originalCallback(e);
	    };
	    if (element.addEventListener) {
	      return element.addEventListener(eventName, callback, false);
	    }
	    if (element.attachEvent) {
	      eventName = "on" + eventName;
	      return element.attachEvent(eventName, callback);
	    }
	    element['on' + eventName] = callback;
	  };
	
	  QJ.addClass = function(el, className) {
	    var e;
	    if (el.length) {
	      return (function() {
	        var i, len, results;
	        results = [];
	        for (i = 0, len = el.length; i < len; i++) {
	          e = el[i];
	          results.push(QJ.addClass(e, className));
	        }
	        return results;
	      })();
	    }
	    if (el.classList) {
	      return el.classList.add(className);
	    } else {
	      return el.className += ' ' + className;
	    }
	  };
	
	  QJ.hasClass = function(el, className) {
	    var e, hasClass, i, len;
	    if (el.length) {
	      hasClass = true;
	      for (i = 0, len = el.length; i < len; i++) {
	        e = el[i];
	        hasClass = hasClass && QJ.hasClass(e, className);
	      }
	      return hasClass;
	    }
	    if (el.classList) {
	      return el.classList.contains(className);
	    } else {
	      return new RegExp('(^| )' + className + '( |$)', 'gi').test(el.className);
	    }
	  };
	
	  QJ.removeClass = function(el, className) {
	    var cls, e, i, len, ref, results;
	    if (el.length) {
	      return (function() {
	        var i, len, results;
	        results = [];
	        for (i = 0, len = el.length; i < len; i++) {
	          e = el[i];
	          results.push(QJ.removeClass(e, className));
	        }
	        return results;
	      })();
	    }
	    if (el.classList) {
	      ref = className.split(' ');
	      results = [];
	      for (i = 0, len = ref.length; i < len; i++) {
	        cls = ref[i];
	        results.push(el.classList.remove(cls));
	      }
	      return results;
	    } else {
	      return el.className = el.className.replace(new RegExp('(^|\\b)' + className.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
	    }
	  };
	
	  QJ.toggleClass = function(el, className, bool) {
	    var e;
	    if (el.length) {
	      return (function() {
	        var i, len, results;
	        results = [];
	        for (i = 0, len = el.length; i < len; i++) {
	          e = el[i];
	          results.push(QJ.toggleClass(e, className, bool));
	        }
	        return results;
	      })();
	    }
	    if (bool) {
	      if (!QJ.hasClass(el, className)) {
	        return QJ.addClass(el, className);
	      }
	    } else {
	      return QJ.removeClass(el, className);
	    }
	  };
	
	  QJ.append = function(el, toAppend) {
	    var e;
	    if (el.length) {
	      return (function() {
	        var i, len, results;
	        results = [];
	        for (i = 0, len = el.length; i < len; i++) {
	          e = el[i];
	          results.push(QJ.append(e, toAppend));
	        }
	        return results;
	      })();
	    }
	    return el.insertAdjacentHTML('beforeend', toAppend);
	  };
	
	  QJ.find = function(el, selector) {
	    if (el instanceof NodeList || el instanceof Array) {
	      el = el[0];
	    }
	    return el.querySelectorAll(selector);
	  };
	
	  QJ.trigger = function(el, name, data) {
	    var e, error, ev;
	    try {
	      ev = new CustomEvent(name, {
	        detail: data
	      });
	    } catch (error) {
	      e = error;
	      ev = document.createEvent('CustomEvent');
	      if (ev.initCustomEvent) {
	        ev.initCustomEvent(name, true, true, data);
	      } else {
	        ev.initEvent(name, true, true, data);
	      }
	    }
	    return el.dispatchEvent(ev);
	  };
	
	  module.exports = QJ;
	
	}).call(this);


/***/ }),
/* 1720 */
/***/ (function(module, exports, __webpack_require__) {

	// Generated by CoffeeScript 1.12.7
	(function() {
	  var Payment, QJ, cardFromNumber, cardFromType, cards, cursorSafeAssignValue, defaultFormat, formatBackCardNumber, formatBackExpiry, formatCardNumber, formatExpiry, formatForwardExpiry, formatForwardSlash, formatMonthExpiry, globalThis, hasTextSelected, luhnCheck, reFormatCardNumber, restrictCVC, restrictCardNumber, restrictCombinedExpiry, restrictExpiry, restrictMonthExpiry, restrictNumeric, restrictYearExpiry, setCardType,
	    indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };
	
	  globalThis = __webpack_require__(1721)();
	
	  QJ = __webpack_require__(1719);
	
	  defaultFormat = /(\d{1,4})/g;
	
	  cards = [
	    {
	      type: 'amex',
	      pattern: /^3[47]/,
	      format: /(\d{1,4})(\d{1,6})?(\d{1,5})?/,
	      length: [15],
	      cvcLength: [4],
	      luhn: true
	    }, {
	      type: 'dankort',
	      pattern: /^5019/,
	      format: defaultFormat,
	      length: [16],
	      cvcLength: [3],
	      luhn: true
	    }, {
	      type: 'dinersclub',
	      pattern: /^(36|38|30[0-5])/,
	      format: /(\d{1,4})(\d{1,6})?(\d{1,4})?/,
	      length: [14],
	      cvcLength: [3],
	      luhn: true
	    }, {
	      type: 'discover',
	      pattern: /^(6011|65|64[4-9]|622)/,
	      format: defaultFormat,
	      length: [16],
	      cvcLength: [3],
	      luhn: true
	    }, {
	      type: 'elo',
	      pattern: /^401178|^401179|^431274|^438935|^451416|^457393|^457631|^457632|^504175|^627780|^636297|^636369|^636368|^(506699|5067[0-6]\d|50677[0-8])|^(50900\d|5090[1-9]\d|509[1-9]\d{2})|^65003[1-3]|^(65003[5-9]|65004\d|65005[0-1])|^(65040[5-9]|6504[1-3]\d)|^(65048[5-9]|65049\d|6505[0-2]\d|65053[0-8])|^(65054[1-9]|6505[5-8]\d|65059[0-8])|^(65070\d|65071[0-8])|^65072[0-7]|^(65090[1-9]|65091\d|650920)|^(65165[2-9]|6516[6-7]\d)|^(65500\d|65501\d)|^(65502[1-9]|6550[3-4]\d|65505[0-8])|^(65092[1-9]|65097[0-8])/,
	      format: defaultFormat,
	      length: [16],
	      cvcLength: [3],
	      luhn: true
	    }, {
	      type: 'hipercard',
	      pattern: /^(384100|384140|384160|606282|637095|637568|60(?!11))/,
	      format: defaultFormat,
	      length: [14, 15, 16, 17, 18, 19],
	      cvcLength: [3],
	      luhn: true
	    }, {
	      type: 'jcb',
	      pattern: /^(308[8-9]|309[0-3]|3094[0]{4}|309[6-9]|310[0-2]|311[2-9]|3120|315[8-9]|333[7-9]|334[0-9]|35)/,
	      format: defaultFormat,
	      length: [16, 19],
	      cvcLength: [3],
	      luhn: true
	    }, {
	      type: 'laser',
	      pattern: /^(6706|6771|6709)/,
	      format: defaultFormat,
	      length: [16, 17, 18, 19],
	      cvcLength: [3],
	      luhn: true
	    }, {
	      type: 'maestro',
	      pattern: /^(50|5[6-9]|6007|6220|6304|6703|6708|6759|676[1-3])/,
	      format: defaultFormat,
	      length: [12, 13, 14, 15, 16, 17, 18, 19],
	      cvcLength: [3],
	      luhn: true
	    }, {
	      type: 'mastercard',
	      pattern: /^(5[1-5]|677189)|^(222[1-9]|2[3-6]\d{2}|27[0-1]\d|2720)/,
	      format: defaultFormat,
	      length: [16],
	      cvcLength: [3],
	      luhn: true
	    }, {
	      type: 'mir',
	      pattern: /^220[0-4][0-9][0-9]\d{10}$/,
	      format: defaultFormat,
	      length: [16],
	      cvcLength: [3],
	      luhn: true
	    }, {
	      type: 'troy',
	      pattern: /^9792/,
	      format: defaultFormat,
	      length: [16],
	      cvcLength: [3],
	      luhn: true
	    }, {
	      type: 'unionpay',
	      pattern: /^62/,
	      format: defaultFormat,
	      length: [16, 17, 18, 19],
	      cvcLength: [3],
	      luhn: false
	    }, {
	      type: 'visaelectron',
	      pattern: /^4(026|17500|405|508|844|91[37])/,
	      format: defaultFormat,
	      length: [16],
	      cvcLength: [3],
	      luhn: true
	    }, {
	      type: 'visa',
	      pattern: /^4/,
	      format: defaultFormat,
	      length: [13, 16],
	      cvcLength: [3],
	      luhn: true
	    }
	  ];
	
	  cardFromNumber = function(num) {
	    var card, foundCard, j, len, match;
	    num = (num + '').replace(/\D/g, '');
	    foundCard = void 0;
	    for (j = 0, len = cards.length; j < len; j++) {
	      card = cards[j];
	      if (match = num.match(card.pattern)) {
	        if (!foundCard || match[0].length > foundCard[1][0].length) {
	          foundCard = [card, match];
	        }
	      }
	    }
	    return foundCard && foundCard[0];
	  };
	
	  cardFromType = function(type) {
	    var card, j, len;
	    for (j = 0, len = cards.length; j < len; j++) {
	      card = cards[j];
	      if (card.type === type) {
	        return card;
	      }
	    }
	  };
	
	  luhnCheck = function(num) {
	    var digit, digits, j, len, odd, sum;
	    odd = true;
	    sum = 0;
	    digits = (num + '').split('').reverse();
	    for (j = 0, len = digits.length; j < len; j++) {
	      digit = digits[j];
	      digit = parseInt(digit, 10);
	      if ((odd = !odd)) {
	        digit *= 2;
	      }
	      if (digit > 9) {
	        digit -= 9;
	      }
	      sum += digit;
	    }
	    return sum % 10 === 0;
	  };
	
	  hasTextSelected = function(target) {
	    var e, ref;
	    try {
	      if ((target.selectionStart != null) && target.selectionStart !== target.selectionEnd) {
	        return true;
	      }
	      if ((typeof document !== "undefined" && document !== null ? (ref = document.selection) != null ? ref.createRange : void 0 : void 0) != null) {
	        if (document.selection.createRange().text) {
	          return true;
	        }
	      }
	    } catch (error) {
	      e = error;
	    }
	    return false;
	  };
	
	  reFormatCardNumber = function(e) {
	    return setTimeout((function(_this) {
	      return function() {
	        var target, value;
	        target = e.target;
	        value = QJ.val(target);
	        value = Payment.fns.formatCardNumber(value);
	        cursorSafeAssignValue(target, value);
	        return QJ.trigger(target, 'change');
	      };
	    })(this));
	  };
	
	  formatCardNumber = function(maxLength) {
	    return function(e) {
	      var card, digit, i, j, len, length, re, target, upperLength, upperLengths, value;
	      if (e.which > 0) {
	        digit = String.fromCharCode(e.which);
	        value = QJ.val(e.target) + digit;
	      } else {
	        digit = e.data;
	        value = QJ.val(e.target);
	      }
	      if (!/^\d+$/.test(digit)) {
	        return;
	      }
	      target = e.target;
	      card = cardFromNumber(value);
	      length = (value.replace(/\D/g, '')).length;
	      upperLengths = [16];
	      if (card) {
	        upperLengths = card.length;
	      }
	      if (maxLength) {
	        upperLengths = upperLengths.filter(function(x) {
	          return x <= maxLength;
	        });
	      }
	      for (i = j = 0, len = upperLengths.length; j < len; i = ++j) {
	        upperLength = upperLengths[i];
	        if (length >= upperLength && upperLengths[i + 1]) {
	          continue;
	        }
	        if (length >= upperLength) {
	          return;
	        }
	      }
	      if (hasTextSelected(target)) {
	        return;
	      }
	      if (card && card.type === 'amex') {
	        re = /^(\d{4}|\d{4}\s\d{6})$/;
	      } else {
	        re = /(?:^|\s)(\d{4})$/;
	      }
	      value = value.substring(0, value.length - 1);
	      if (re.test(value)) {
	        e.preventDefault();
	        QJ.val(target, value + ' ' + digit);
	        return QJ.trigger(target, 'change');
	      }
	    };
	  };
	
	  formatBackCardNumber = function(e) {
	    var target, value;
	    target = e.target;
	    value = QJ.val(target);
	    if (e.meta) {
	      return;
	    }
	    if (e.which !== 8) {
	      return;
	    }
	    if (hasTextSelected(target)) {
	      return;
	    }
	    if (/\d\s$/.test(value)) {
	      e.preventDefault();
	      QJ.val(target, value.replace(/\d\s$/, ''));
	      return QJ.trigger(target, 'change');
	    } else if (/\s\d?$/.test(value)) {
	      e.preventDefault();
	      QJ.val(target, value.replace(/\s\d?$/, ''));
	      return QJ.trigger(target, 'change');
	    }
	  };
	
	  formatExpiry = function(e) {
	    var digit, target, val;
	    target = e.target;
	    if (e.which > 0) {
	      digit = String.fromCharCode(e.which);
	      val = QJ.val(target) + digit;
	    } else {
	      digit = e.data;
	      val = QJ.val(target);
	    }
	    if (!/^\d+$/.test(digit)) {
	      return;
	    }
	    if (/^\d$/.test(val) && (val !== '0' && val !== '1')) {
	      e.preventDefault();
	      QJ.val(target, "0" + val + " / ");
	      return QJ.trigger(target, 'change');
	    } else if (/^\d\d$/.test(val)) {
	      e.preventDefault();
	      QJ.val(target, val + " / ");
	      return QJ.trigger(target, 'change');
	    }
	  };
	
	  formatMonthExpiry = function(e) {
	    var digit, target, val;
	    digit = String.fromCharCode(e.which);
	    if (!/^\d+$/.test(digit)) {
	      return;
	    }
	    target = e.target;
	    val = QJ.val(target) + digit;
	    if (/^\d$/.test(val) && (val !== '0' && val !== '1')) {
	      e.preventDefault();
	      QJ.val(target, "0" + val);
	      return QJ.trigger(target, 'change');
	    } else if (/^\d\d$/.test(val)) {
	      e.preventDefault();
	      QJ.val(target, "" + val);
	      return QJ.trigger(target, 'change');
	    }
	  };
	
	  formatForwardExpiry = function(e) {
	    var digit, target, val;
	    digit = String.fromCharCode(e.which);
	    if (!/^\d+$/.test(digit)) {
	      return;
	    }
	    target = e.target;
	    val = QJ.val(target);
	    if (/^\d\d$/.test(val)) {
	      QJ.val(target, val + " / ");
	      return QJ.trigger(target, 'change');
	    }
	  };
	
	  formatForwardSlash = function(e) {
	    var slash, target, val;
	    slash = String.fromCharCode(e.which);
	    if (slash !== '/') {
	      return;
	    }
	    target = e.target;
	    val = QJ.val(target);
	    if (/^\d$/.test(val) && val !== '0') {
	      QJ.val(target, "0" + val + " / ");
	      return QJ.trigger(target, 'change');
	    }
	  };
	
	  formatBackExpiry = function(e) {
	    var target, value;
	    if (e.metaKey) {
	      return;
	    }
	    target = e.target;
	    value = QJ.val(target);
	    if (e.which !== 8) {
	      return;
	    }
	    if (hasTextSelected(target)) {
	      return;
	    }
	    if (/\d(\s|\/)+$/.test(value)) {
	      e.preventDefault();
	      QJ.val(target, value.replace(/\d(\s|\/)*$/, ''));
	      return QJ.trigger(target, 'change');
	    } else if (/\s\/\s?\d?$/.test(value)) {
	      e.preventDefault();
	      QJ.val(target, value.replace(/\s\/\s?\d?$/, ''));
	      return QJ.trigger(target, 'change');
	    }
	  };
	
	  restrictNumeric = function(e) {
	    var input;
	    if (e.metaKey || e.ctrlKey) {
	      return true;
	    }
	    if (e.which === 32) {
	      return e.preventDefault();
	    }
	    if (e.which === 0) {
	      return true;
	    }
	    if (e.which < 33) {
	      return true;
	    }
	    input = String.fromCharCode(e.which);
	    if (!/[\d\s]/.test(input)) {
	      return e.preventDefault();
	    }
	  };
	
	  restrictCardNumber = function(maxLength) {
	    return function(e) {
	      var card, digit, length, target, value;
	      target = e.target;
	      digit = String.fromCharCode(e.which);
	      if (!/^\d+$/.test(digit)) {
	        return;
	      }
	      if (hasTextSelected(target)) {
	        return;
	      }
	      value = (QJ.val(target) + digit).replace(/\D/g, '');
	      card = cardFromNumber(value);
	      length = 16;
	      if (card) {
	        length = card.length[card.length.length - 1];
	      }
	      if (maxLength) {
	        length = Math.min(length, maxLength);
	      }
	      if (!(value.length <= length)) {
	        return e.preventDefault();
	      }
	    };
	  };
	
	  restrictExpiry = function(e, length) {
	    var digit, target, value;
	    target = e.target;
	    digit = String.fromCharCode(e.which);
	    if (!/^\d+$/.test(digit)) {
	      return;
	    }
	    if (hasTextSelected(target)) {
	      return;
	    }
	    value = QJ.val(target) + digit;
	    value = value.replace(/\D/g, '');
	    if (value.length > length) {
	      return e.preventDefault();
	    }
	  };
	
	  restrictCombinedExpiry = function(e) {
	    return restrictExpiry(e, 6);
	  };
	
	  restrictMonthExpiry = function(e) {
	    return restrictExpiry(e, 2);
	  };
	
	  restrictYearExpiry = function(e) {
	    return restrictExpiry(e, 4);
	  };
	
	  restrictCVC = function(e) {
	    var digit, target, val;
	    target = e.target;
	    digit = String.fromCharCode(e.which);
	    if (!/^\d+$/.test(digit)) {
	      return;
	    }
	    if (hasTextSelected(target)) {
	      return;
	    }
	    val = QJ.val(target) + digit;
	    if (!(val.length <= 4)) {
	      return e.preventDefault();
	    }
	  };
	
	  setCardType = function(e) {
	    var allTypes, card, cardType, target, val;
	    target = e.target;
	    val = QJ.val(target);
	    cardType = Payment.fns.cardType(val) || 'unknown';
	    if (!QJ.hasClass(target, cardType)) {
	      allTypes = (function() {
	        var j, len, results;
	        results = [];
	        for (j = 0, len = cards.length; j < len; j++) {
	          card = cards[j];
	          results.push(card.type);
	        }
	        return results;
	      })();
	      QJ.removeClass(target, 'unknown');
	      QJ.removeClass(target, allTypes.join(' '));
	      QJ.addClass(target, cardType);
	      QJ.toggleClass(target, 'identified', cardType !== 'unknown');
	      return QJ.trigger(target, 'payment.cardType', cardType);
	    }
	  };
	
	  cursorSafeAssignValue = function(target, value) {
	    var selectionEnd;
	    selectionEnd = target.selectionEnd;
	    QJ.val(target, value);
	    if (selectionEnd) {
	      return target.selectionEnd = selectionEnd;
	    }
	  };
	
	  Payment = (function() {
	    function Payment() {}
	
	    Payment.J = QJ;
	
	    Payment.fns = {
	      cardExpiryVal: function(value) {
	        var month, prefix, ref, year;
	        value = value.replace(/\s/g, '');
	        ref = value.split('/', 2), month = ref[0], year = ref[1];
	        if ((year != null ? year.length : void 0) === 2 && /^\d+$/.test(year)) {
	          prefix = (new Date).getFullYear();
	          prefix = prefix.toString().slice(0, 2);
	          year = prefix + year;
	        }
	        month = parseInt(month, 10);
	        year = parseInt(year, 10);
	        return {
	          month: month,
	          year: year
	        };
	      },
	      validateCardNumber: function(num) {
	        var card, ref;
	        num = (num + '').replace(/\s+|-/g, '');
	        if (!/^\d+$/.test(num)) {
	          return false;
	        }
	        card = cardFromNumber(num);
	        if (!card) {
	          return false;
	        }
	        return (ref = num.length, indexOf.call(card.length, ref) >= 0) && (card.luhn === false || luhnCheck(num));
	      },
	      validateCardExpiry: function(month, year) {
	        var currentTime, expiry, prefix, ref, ref1;
	        if (typeof month === 'object' && 'month' in month) {
	          ref = month, month = ref.month, year = ref.year;
	        } else if (typeof month === 'string' && indexOf.call(month, '/') >= 0) {
	          ref1 = Payment.fns.cardExpiryVal(month), month = ref1.month, year = ref1.year;
	        }
	        if (!(month && year)) {
	          return false;
	        }
	        month = QJ.trim(month);
	        year = QJ.trim(year);
	        if (!/^\d+$/.test(month)) {
	          return false;
	        }
	        if (!/^\d+$/.test(year)) {
	          return false;
	        }
	        month = parseInt(month, 10);
	        if (!(month && month <= 12)) {
	          return false;
	        }
	        if (year.length === 2) {
	          prefix = (new Date).getFullYear();
	          prefix = prefix.toString().slice(0, 2);
	          year = prefix + year;
	        }
	        expiry = new Date(year, month);
	        currentTime = new Date;
	        expiry.setMonth(expiry.getMonth() - 1);
	        expiry.setMonth(expiry.getMonth() + 1, 1);
	        return expiry > currentTime;
	      },
	      validateCardCVC: function(cvc, type) {
	        var ref, ref1;
	        cvc = QJ.trim(cvc);
	        if (!/^\d+$/.test(cvc)) {
	          return false;
	        }
	        if (type && cardFromType(type)) {
	          return ref = cvc.length, indexOf.call((ref1 = cardFromType(type)) != null ? ref1.cvcLength : void 0, ref) >= 0;
	        } else {
	          return cvc.length >= 3 && cvc.length <= 4;
	        }
	      },
	      cardType: function(num) {
	        var ref;
	        if (!num) {
	          return null;
	        }
	        return ((ref = cardFromNumber(num)) != null ? ref.type : void 0) || null;
	      },
	      formatCardNumber: function(num) {
	        var card, groups, ref, upperLength;
	        card = cardFromNumber(num);
	        if (!card) {
	          return num;
	        }
	        upperLength = card.length[card.length.length - 1];
	        num = num.replace(/\D/g, '');
	        num = num.slice(0, upperLength);
	        if (card.format.global) {
	          return (ref = num.match(card.format)) != null ? ref.join(' ') : void 0;
	        } else {
	          groups = card.format.exec(num);
	          if (groups == null) {
	            return;
	          }
	          groups.shift();
	          groups = groups.filter(function(n) {
	            return n;
	          });
	          return groups.join(' ');
	        }
	      }
	    };
	
	    Payment.restrictNumeric = function(el) {
	      QJ.on(el, 'keypress', restrictNumeric);
	      return QJ.on(el, 'input', restrictNumeric);
	    };
	
	    Payment.cardExpiryVal = function(el) {
	      return Payment.fns.cardExpiryVal(QJ.val(el));
	    };
	
	    Payment.formatCardCVC = function(el) {
	      Payment.restrictNumeric(el);
	      QJ.on(el, 'keypress', restrictCVC);
	      QJ.on(el, 'input', restrictCVC);
	      return el;
	    };
	
	    Payment.formatCardExpiry = function(el) {
	      var month, year;
	      Payment.restrictNumeric(el);
	      if (el.length && el.length === 2) {
	        month = el[0], year = el[1];
	        this.formatCardExpiryMultiple(month, year);
	      } else {
	        QJ.on(el, 'keypress', restrictCombinedExpiry);
	        QJ.on(el, 'keypress', formatExpiry);
	        QJ.on(el, 'keypress', formatForwardSlash);
	        QJ.on(el, 'keypress', formatForwardExpiry);
	        QJ.on(el, 'keydown', formatBackExpiry);
	        QJ.on(el, 'input', formatExpiry);
	      }
	      return el;
	    };
	
	    Payment.formatCardExpiryMultiple = function(month, year) {
	      QJ.on(month, 'keypress', restrictMonthExpiry);
	      QJ.on(month, 'keypress', formatMonthExpiry);
	      QJ.on(month, 'input', formatMonthExpiry);
	      QJ.on(year, 'keypress', restrictYearExpiry);
	      return QJ.on(year, 'input', restrictYearExpiry);
	    };
	
	    Payment.formatCardNumber = function(el, maxLength) {
	      Payment.restrictNumeric(el);
	      QJ.on(el, 'keypress', restrictCardNumber(maxLength));
	      QJ.on(el, 'keypress', formatCardNumber(maxLength));
	      QJ.on(el, 'keydown', formatBackCardNumber);
	      QJ.on(el, 'keyup blur', setCardType);
	      QJ.on(el, 'blur', formatCardNumber(maxLength));
	      QJ.on(el, 'paste', reFormatCardNumber);
	      QJ.on(el, 'input', formatCardNumber(maxLength));
	      return el;
	    };
	
	    Payment.getCardArray = function() {
	      return cards;
	    };
	
	    Payment.setCardArray = function(cardArray) {
	      cards = cardArray;
	      return true;
	    };
	
	    Payment.addToCardArray = function(cardObject) {
	      return cards.push(cardObject);
	    };
	
	    Payment.removeFromCardArray = function(type) {
	      var key, value;
	      for (key in cards) {
	        value = cards[key];
	        if (value.type === type) {
	          cards.splice(key, 1);
	        }
	      }
	      return true;
	    };
	
	    return Payment;
	
	  })();
	
	  module.exports = Payment;
	
	  globalThis.Payment = Payment;
	
	}).call(this);


/***/ }),
/* 1721 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	var implementation = __webpack_require__(1722);
	
	module.exports = function getPolyfill() {
		if (typeof global !== 'object' || !global || global.Math !== Math || global.Array !== Array) {
			return implementation;
		}
		return global;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 1722 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	module.exports = global;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 1723 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(1724);


/***/ }),
/* 1724 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/*!
	 * node.extend
	 * Copyright 2011, John Resig
	 * Dual licensed under the MIT or GPL Version 2 licenses.
	 * http://jquery.org/license
	 *
	 * @fileoverview
	 * Port of jQuery.extend that actually works on node.js
	 */
	var is = __webpack_require__(1725);
	var has = __webpack_require__(1726);
	
	var defineProperty = Object.defineProperty;
	var gOPD = Object.getOwnPropertyDescriptor;
	
	// If name is '__proto__', and Object.defineProperty is available, define __proto__ as an own property on target
	var setProperty = function setP(target, name, value) {
	  if (defineProperty && name === '__proto__') {
	    defineProperty(target, name, {
	      enumerable: true,
	      configurable: true,
	      value: value,
	      writable: true
	    });
	  } else {
	    target[name] = value;
	  }
	};
	
	// Return undefined instead of __proto__ if '__proto__' is not an own property
	var getProperty = function getP(obj, name) {
	  if (name === '__proto__') {
	    if (!has(obj, name)) {
	      return void 0;
	    } else if (gOPD) {
	      // In early versions of node, obj['__proto__'] is buggy when obj has
	      // __proto__ as an own property. Object.getOwnPropertyDescriptor() works.
	      return gOPD(obj, name).value;
	    }
	  }
	
	  return obj[name];
	};
	
	module.exports = function extend() {
	  var target = arguments[0] || {};
	  var i = 1;
	  var length = arguments.length;
	  var deep = false;
	  var options, name, src, copy, copyIsArray, clone;
	
	  // Handle a deep copy situation
	  if (typeof target === 'boolean') {
	    deep = target;
	    target = arguments[1] || {};
	    // skip the boolean and the target
	    i = 2;
	  }
	
	  // Handle case when target is a string or something (possible in deep copy)
	  if (typeof target !== 'object' && !is.fn(target)) {
	    target = {};
	  }
	
	  for (; i < length; i++) {
	    // Only deal with non-null/undefined values
	    options = arguments[i];
	    if (options != null) {
	      if (typeof options === 'string') {
	        options = options.split('');
	      }
	      // Extend the base object
	      for (name in options) {
	        src = getProperty(target, name);
	        copy = getProperty(options, name);
	
	        // Prevent never-ending loop
	        if (target === copy) {
	          continue;
	        }
	
	        // Recurse if we're merging plain objects or arrays
	        if (deep && copy && (is.hash(copy) || (copyIsArray = is.array(copy)))) {
	          if (copyIsArray) {
	            copyIsArray = false;
	            clone = src && is.array(src) ? src : [];
	          } else {
	            clone = src && is.hash(src) ? src : {};
	          }
	
	          // Never move original objects, clone them
	          setProperty(target, name, extend(deep, clone, copy));
	
	        // Don't bring in undefined values
	        } else if (typeof copy !== 'undefined') {
	          setProperty(target, name, copy);
	        }
	      }
	    }
	  }
	
	  // Return the modified object
	  return target;
	};


/***/ }),
/* 1725 */
/***/ (function(module, exports) {

	/* globals window, HTMLElement */
	
	'use strict';
	
	/**!
	 * is
	 * the definitive JavaScript type testing library
	 *
	 * @copyright 2013-2014 Enrico Marino / Jordan Harband
	 * @license MIT
	 */
	
	var objProto = Object.prototype;
	var owns = objProto.hasOwnProperty;
	var toStr = objProto.toString;
	var symbolValueOf;
	if (typeof Symbol === 'function') {
	  symbolValueOf = Symbol.prototype.valueOf;
	}
	var bigIntValueOf;
	if (typeof BigInt === 'function') {
	  bigIntValueOf = BigInt.prototype.valueOf;
	}
	var isActualNaN = function (value) {
	  return value !== value;
	};
	var NON_HOST_TYPES = {
	  'boolean': 1,
	  number: 1,
	  string: 1,
	  undefined: 1
	};
	
	var base64Regex = /^([A-Za-z0-9+/]{4})*([A-Za-z0-9+/]{4}|[A-Za-z0-9+/]{3}=|[A-Za-z0-9+/]{2}==)$/;
	var hexRegex = /^[A-Fa-f0-9]+$/;
	
	/**
	 * Expose `is`
	 */
	
	var is = {};
	
	/**
	 * Test general.
	 */
	
	/**
	 * is.type
	 * Test if `value` is a type of `type`.
	 *
	 * @param {*} value value to test
	 * @param {String} type type
	 * @return {Boolean} true if `value` is a type of `type`, false otherwise
	 * @api public
	 */
	
	is.a = is.type = function (value, type) {
	  return typeof value === type;
	};
	
	/**
	 * is.defined
	 * Test if `value` is defined.
	 *
	 * @param {*} value value to test
	 * @return {Boolean} true if 'value' is defined, false otherwise
	 * @api public
	 */
	
	is.defined = function (value) {
	  return typeof value !== 'undefined';
	};
	
	/**
	 * is.empty
	 * Test if `value` is empty.
	 *
	 * @param {*} value value to test
	 * @return {Boolean} true if `value` is empty, false otherwise
	 * @api public
	 */
	
	is.empty = function (value) {
	  var type = toStr.call(value);
	  var key;
	
	  if (type === '[object Array]' || type === '[object Arguments]' || type === '[object String]') {
	    return value.length === 0;
	  }
	
	  if (type === '[object Object]') {
	    for (key in value) {
	      if (owns.call(value, key)) {
	        return false;
	      }
	    }
	    return true;
	  }
	
	  return !value;
	};
	
	/**
	 * is.equal
	 * Test if `value` is equal to `other`.
	 *
	 * @param {*} value value to test
	 * @param {*} other value to compare with
	 * @return {Boolean} true if `value` is equal to `other`, false otherwise
	 */
	
	is.equal = function equal(value, other) {
	  if (value === other) {
	    return true;
	  }
	
	  var type = toStr.call(value);
	  var key;
	
	  if (type !== toStr.call(other)) {
	    return false;
	  }
	
	  if (type === '[object Object]') {
	    for (key in value) {
	      if (!is.equal(value[key], other[key]) || !(key in other)) {
	        return false;
	      }
	    }
	    for (key in other) {
	      if (!is.equal(value[key], other[key]) || !(key in value)) {
	        return false;
	      }
	    }
	    return true;
	  }
	
	  if (type === '[object Array]') {
	    key = value.length;
	    if (key !== other.length) {
	      return false;
	    }
	    while (key--) {
	      if (!is.equal(value[key], other[key])) {
	        return false;
	      }
	    }
	    return true;
	  }
	
	  if (type === '[object Function]') {
	    return value.prototype === other.prototype;
	  }
	
	  if (type === '[object Date]') {
	    return value.getTime() === other.getTime();
	  }
	
	  return false;
	};
	
	/**
	 * is.hosted
	 * Test if `value` is hosted by `host`.
	 *
	 * @param {*} value to test
	 * @param {*} host host to test with
	 * @return {Boolean} true if `value` is hosted by `host`, false otherwise
	 * @api public
	 */
	
	is.hosted = function (value, host) {
	  var type = typeof host[value];
	  return type === 'object' ? !!host[value] : !NON_HOST_TYPES[type];
	};
	
	/**
	 * is.instance
	 * Test if `value` is an instance of `constructor`.
	 *
	 * @param {*} value value to test
	 * @return {Boolean} true if `value` is an instance of `constructor`
	 * @api public
	 */
	
	is.instance = is['instanceof'] = function (value, constructor) {
	  return value instanceof constructor;
	};
	
	/**
	 * is.nil / is.null
	 * Test if `value` is null.
	 *
	 * @param {*} value value to test
	 * @return {Boolean} true if `value` is null, false otherwise
	 * @api public
	 */
	
	is.nil = is['null'] = function (value) {
	  return value === null;
	};
	
	/**
	 * is.undef / is.undefined
	 * Test if `value` is undefined.
	 *
	 * @param {*} value value to test
	 * @return {Boolean} true if `value` is undefined, false otherwise
	 * @api public
	 */
	
	is.undef = is.undefined = function (value) {
	  return typeof value === 'undefined';
	};
	
	/**
	 * Test arguments.
	 */
	
	/**
	 * is.args
	 * Test if `value` is an arguments object.
	 *
	 * @param {*} value value to test
	 * @return {Boolean} true if `value` is an arguments object, false otherwise
	 * @api public
	 */
	
	is.args = is.arguments = function (value) {
	  var isStandardArguments = toStr.call(value) === '[object Arguments]';
	  var isOldArguments = !is.array(value) && is.arraylike(value) && is.object(value) && is.fn(value.callee);
	  return isStandardArguments || isOldArguments;
	};
	
	/**
	 * Test array.
	 */
	
	/**
	 * is.array
	 * Test if 'value' is an array.
	 *
	 * @param {*} value value to test
	 * @return {Boolean} true if `value` is an array, false otherwise
	 * @api public
	 */
	
	is.array = Array.isArray || function (value) {
	  return toStr.call(value) === '[object Array]';
	};
	
	/**
	 * is.arguments.empty
	 * Test if `value` is an empty arguments object.
	 *
	 * @param {*} value value to test
	 * @return {Boolean} true if `value` is an empty arguments object, false otherwise
	 * @api public
	 */
	is.args.empty = function (value) {
	  return is.args(value) && value.length === 0;
	};
	
	/**
	 * is.array.empty
	 * Test if `value` is an empty array.
	 *
	 * @param {*} value value to test
	 * @return {Boolean} true if `value` is an empty array, false otherwise
	 * @api public
	 */
	is.array.empty = function (value) {
	  return is.array(value) && value.length === 0;
	};
	
	/**
	 * is.arraylike
	 * Test if `value` is an arraylike object.
	 *
	 * @param {*} value value to test
	 * @return {Boolean} true if `value` is an arguments object, false otherwise
	 * @api public
	 */
	
	is.arraylike = function (value) {
	  return !!value && !is.bool(value)
	    && owns.call(value, 'length')
	    && isFinite(value.length)
	    && is.number(value.length)
	    && value.length >= 0;
	};
	
	/**
	 * Test boolean.
	 */
	
	/**
	 * is.bool
	 * Test if `value` is a boolean.
	 *
	 * @param {*} value value to test
	 * @return {Boolean} true if `value` is a boolean, false otherwise
	 * @api public
	 */
	
	is.bool = is['boolean'] = function (value) {
	  return toStr.call(value) === '[object Boolean]';
	};
	
	/**
	 * is.false
	 * Test if `value` is false.
	 *
	 * @param {*} value value to test
	 * @return {Boolean} true if `value` is false, false otherwise
	 * @api public
	 */
	
	is['false'] = function (value) {
	  return is.bool(value) && Boolean(Number(value)) === false;
	};
	
	/**
	 * is.true
	 * Test if `value` is true.
	 *
	 * @param {*} value value to test
	 * @return {Boolean} true if `value` is true, false otherwise
	 * @api public
	 */
	
	is['true'] = function (value) {
	  return is.bool(value) && Boolean(Number(value)) === true;
	};
	
	/**
	 * Test date.
	 */
	
	/**
	 * is.date
	 * Test if `value` is a date.
	 *
	 * @param {*} value value to test
	 * @return {Boolean} true if `value` is a date, false otherwise
	 * @api public
	 */
	
	is.date = function (value) {
	  return toStr.call(value) === '[object Date]';
	};
	
	/**
	 * is.date.valid
	 * Test if `value` is a valid date.
	 *
	 * @param {*} value value to test
	 * @returns {Boolean} true if `value` is a valid date, false otherwise
	 */
	is.date.valid = function (value) {
	  return is.date(value) && !isNaN(Number(value));
	};
	
	/**
	 * Test element.
	 */
	
	/**
	 * is.element
	 * Test if `value` is an html element.
	 *
	 * @param {*} value value to test
	 * @return {Boolean} true if `value` is an HTML Element, false otherwise
	 * @api public
	 */
	
	is.element = function (value) {
	  return value !== undefined
	    && typeof HTMLElement !== 'undefined'
	    && value instanceof HTMLElement
	    && value.nodeType === 1;
	};
	
	/**
	 * Test error.
	 */
	
	/**
	 * is.error
	 * Test if `value` is an error object.
	 *
	 * @param {*} value value to test
	 * @return {Boolean} true if `value` is an error object, false otherwise
	 * @api public
	 */
	
	is.error = function (value) {
	  return toStr.call(value) === '[object Error]';
	};
	
	/**
	 * Test function.
	 */
	
	/**
	 * is.fn / is.function (deprecated)
	 * Test if `value` is a function.
	 *
	 * @param {*} value value to test
	 * @return {Boolean} true if `value` is a function, false otherwise
	 * @api public
	 */
	
	is.fn = is['function'] = function (value) {
	  var isAlert = typeof window !== 'undefined' && value === window.alert;
	  if (isAlert) {
	    return true;
	  }
	  var str = toStr.call(value);
	  return str === '[object Function]' || str === '[object GeneratorFunction]' || str === '[object AsyncFunction]';
	};
	
	/**
	 * Test number.
	 */
	
	/**
	 * is.number
	 * Test if `value` is a number.
	 *
	 * @param {*} value value to test
	 * @return {Boolean} true if `value` is a number, false otherwise
	 * @api public
	 */
	
	is.number = function (value) {
	  return toStr.call(value) === '[object Number]';
	};
	
	/**
	 * is.infinite
	 * Test if `value` is positive or negative infinity.
	 *
	 * @param {*} value value to test
	 * @return {Boolean} true if `value` is positive or negative Infinity, false otherwise
	 * @api public
	 */
	is.infinite = function (value) {
	  return value === Infinity || value === -Infinity;
	};
	
	/**
	 * is.decimal
	 * Test if `value` is a decimal number.
	 *
	 * @param {*} value value to test
	 * @return {Boolean} true if `value` is a decimal number, false otherwise
	 * @api public
	 */
	
	is.decimal = function (value) {
	  return is.number(value) && !isActualNaN(value) && !is.infinite(value) && value % 1 !== 0;
	};
	
	/**
	 * is.divisibleBy
	 * Test if `value` is divisible by `n`.
	 *
	 * @param {Number} value value to test
	 * @param {Number} n dividend
	 * @return {Boolean} true if `value` is divisible by `n`, false otherwise
	 * @api public
	 */
	
	is.divisibleBy = function (value, n) {
	  var isDividendInfinite = is.infinite(value);
	  var isDivisorInfinite = is.infinite(n);
	  var isNonZeroNumber = is.number(value) && !isActualNaN(value) && is.number(n) && !isActualNaN(n) && n !== 0;
	  return isDividendInfinite || isDivisorInfinite || (isNonZeroNumber && value % n === 0);
	};
	
	/**
	 * is.integer
	 * Test if `value` is an integer.
	 *
	 * @param value to test
	 * @return {Boolean} true if `value` is an integer, false otherwise
	 * @api public
	 */
	
	is.integer = is['int'] = function (value) {
	  return is.number(value) && !isActualNaN(value) && value % 1 === 0;
	};
	
	/**
	 * is.maximum
	 * Test if `value` is greater than 'others' values.
	 *
	 * @param {Number} value value to test
	 * @param {Array} others values to compare with
	 * @return {Boolean} true if `value` is greater than `others` values
	 * @api public
	 */
	
	is.maximum = function (value, others) {
	  if (isActualNaN(value)) {
	    throw new TypeError('NaN is not a valid value');
	  } else if (!is.arraylike(others)) {
	    throw new TypeError('second argument must be array-like');
	  }
	  var len = others.length;
	
	  while (--len >= 0) {
	    if (value < others[len]) {
	      return false;
	    }
	  }
	
	  return true;
	};
	
	/**
	 * is.minimum
	 * Test if `value` is less than `others` values.
	 *
	 * @param {Number} value value to test
	 * @param {Array} others values to compare with
	 * @return {Boolean} true if `value` is less than `others` values
	 * @api public
	 */
	
	is.minimum = function (value, others) {
	  if (isActualNaN(value)) {
	    throw new TypeError('NaN is not a valid value');
	  } else if (!is.arraylike(others)) {
	    throw new TypeError('second argument must be array-like');
	  }
	  var len = others.length;
	
	  while (--len >= 0) {
	    if (value > others[len]) {
	      return false;
	    }
	  }
	
	  return true;
	};
	
	/**
	 * is.nan
	 * Test if `value` is not a number.
	 *
	 * @param {*} value value to test
	 * @return {Boolean} true if `value` is not a number, false otherwise
	 * @api public
	 */
	
	is.nan = function (value) {
	  return !is.number(value) || value !== value;
	};
	
	/**
	 * is.even
	 * Test if `value` is an even number.
	 *
	 * @param {Number} value value to test
	 * @return {Boolean} true if `value` is an even number, false otherwise
	 * @api public
	 */
	
	is.even = function (value) {
	  return is.infinite(value) || (is.number(value) && value === value && value % 2 === 0);
	};
	
	/**
	 * is.odd
	 * Test if `value` is an odd number.
	 *
	 * @param {Number} value value to test
	 * @return {Boolean} true if `value` is an odd number, false otherwise
	 * @api public
	 */
	
	is.odd = function (value) {
	  return is.infinite(value) || (is.number(value) && value === value && value % 2 !== 0);
	};
	
	/**
	 * is.ge
	 * Test if `value` is greater than or equal to `other`.
	 *
	 * @param {Number} value value to test
	 * @param {Number} other value to compare with
	 * @return {Boolean}
	 * @api public
	 */
	
	is.ge = function (value, other) {
	  if (isActualNaN(value) || isActualNaN(other)) {
	    throw new TypeError('NaN is not a valid value');
	  }
	  return !is.infinite(value) && !is.infinite(other) && value >= other;
	};
	
	/**
	 * is.gt
	 * Test if `value` is greater than `other`.
	 *
	 * @param {Number} value value to test
	 * @param {Number} other value to compare with
	 * @return {Boolean}
	 * @api public
	 */
	
	is.gt = function (value, other) {
	  if (isActualNaN(value) || isActualNaN(other)) {
	    throw new TypeError('NaN is not a valid value');
	  }
	  return !is.infinite(value) && !is.infinite(other) && value > other;
	};
	
	/**
	 * is.le
	 * Test if `value` is less than or equal to `other`.
	 *
	 * @param {Number} value value to test
	 * @param {Number} other value to compare with
	 * @return {Boolean} if 'value' is less than or equal to 'other'
	 * @api public
	 */
	
	is.le = function (value, other) {
	  if (isActualNaN(value) || isActualNaN(other)) {
	    throw new TypeError('NaN is not a valid value');
	  }
	  return !is.infinite(value) && !is.infinite(other) && value <= other;
	};
	
	/**
	 * is.lt
	 * Test if `value` is less than `other`.
	 *
	 * @param {Number} value value to test
	 * @param {Number} other value to compare with
	 * @return {Boolean} if `value` is less than `other`
	 * @api public
	 */
	
	is.lt = function (value, other) {
	  if (isActualNaN(value) || isActualNaN(other)) {
	    throw new TypeError('NaN is not a valid value');
	  }
	  return !is.infinite(value) && !is.infinite(other) && value < other;
	};
	
	/**
	 * is.within
	 * Test if `value` is within `start` and `finish`.
	 *
	 * @param {Number} value value to test
	 * @param {Number} start lower bound
	 * @param {Number} finish upper bound
	 * @return {Boolean} true if 'value' is is within 'start' and 'finish'
	 * @api public
	 */
	is.within = function (value, start, finish) {
	  if (isActualNaN(value) || isActualNaN(start) || isActualNaN(finish)) {
	    throw new TypeError('NaN is not a valid value');
	  } else if (!is.number(value) || !is.number(start) || !is.number(finish)) {
	    throw new TypeError('all arguments must be numbers');
	  }
	  var isAnyInfinite = is.infinite(value) || is.infinite(start) || is.infinite(finish);
	  return isAnyInfinite || (value >= start && value <= finish);
	};
	
	/**
	 * Test object.
	 */
	
	/**
	 * is.object
	 * Test if `value` is an object.
	 *
	 * @param {*} value value to test
	 * @return {Boolean} true if `value` is an object, false otherwise
	 * @api public
	 */
	is.object = function (value) {
	  return toStr.call(value) === '[object Object]';
	};
	
	/**
	 * is.primitive
	 * Test if `value` is a primitive.
	 *
	 * @param {*} value value to test
	 * @return {Boolean} true if `value` is a primitive, false otherwise
	 * @api public
	 */
	is.primitive = function isPrimitive(value) {
	  if (!value) {
	    return true;
	  }
	  if (typeof value === 'object' || is.object(value) || is.fn(value) || is.array(value)) {
	    return false;
	  }
	  return true;
	};
	
	/**
	 * is.hash
	 * Test if `value` is a hash - a plain object literal.
	 *
	 * @param {*} value value to test
	 * @return {Boolean} true if `value` is a hash, false otherwise
	 * @api public
	 */
	
	is.hash = function (value) {
	  return is.object(value) && value.constructor === Object && !value.nodeType && !value.setInterval;
	};
	
	/**
	 * Test regexp.
	 */
	
	/**
	 * is.regexp
	 * Test if `value` is a regular expression.
	 *
	 * @param {*} value value to test
	 * @return {Boolean} true if `value` is a regexp, false otherwise
	 * @api public
	 */
	
	is.regexp = function (value) {
	  return toStr.call(value) === '[object RegExp]';
	};
	
	/**
	 * Test string.
	 */
	
	/**
	 * is.string
	 * Test if `value` is a string.
	 *
	 * @param {*} value value to test
	 * @return {Boolean} true if 'value' is a string, false otherwise
	 * @api public
	 */
	
	is.string = function (value) {
	  return toStr.call(value) === '[object String]';
	};
	
	/**
	 * Test base64 string.
	 */
	
	/**
	 * is.base64
	 * Test if `value` is a valid base64 encoded string.
	 *
	 * @param {*} value value to test
	 * @return {Boolean} true if 'value' is a base64 encoded string, false otherwise
	 * @api public
	 */
	
	is.base64 = function (value) {
	  return is.string(value) && (!value.length || base64Regex.test(value));
	};
	
	/**
	 * Test base64 string.
	 */
	
	/**
	 * is.hex
	 * Test if `value` is a valid hex encoded string.
	 *
	 * @param {*} value value to test
	 * @return {Boolean} true if 'value' is a hex encoded string, false otherwise
	 * @api public
	 */
	
	is.hex = function (value) {
	  return is.string(value) && (!value.length || hexRegex.test(value));
	};
	
	/**
	 * is.symbol
	 * Test if `value` is an ES6 Symbol
	 *
	 * @param {*} value value to test
	 * @return {Boolean} true if `value` is a Symbol, false otherise
	 * @api public
	 */
	
	is.symbol = function (value) {
	  return typeof Symbol === 'function' && toStr.call(value) === '[object Symbol]' && typeof symbolValueOf.call(value) === 'symbol';
	};
	
	/**
	 * is.bigint
	 * Test if `value` is an ES-proposed BigInt
	 *
	 * @param {*} value value to test
	 * @return {Boolean} true if `value` is a BigInt, false otherise
	 * @api public
	 */
	
	is.bigint = function (value) {
	  // eslint-disable-next-line valid-typeof
	  return typeof BigInt === 'function' && toStr.call(value) === '[object BigInt]' && typeof bigIntValueOf.call(value) === 'bigint';
	};
	
	module.exports = is;


/***/ }),
/* 1726 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var bind = __webpack_require__(1727);
	
	module.exports = bind.call(Function.call, Object.prototype.hasOwnProperty);


/***/ }),
/* 1727 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var implementation = __webpack_require__(1728);
	
	module.exports = Function.prototype.bind || implementation;


/***/ }),
/* 1728 */
/***/ (function(module, exports) {

	'use strict';
	
	/* eslint no-invalid-this: 1 */
	
	var ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
	var slice = Array.prototype.slice;
	var toStr = Object.prototype.toString;
	var funcType = '[object Function]';
	
	module.exports = function bind(that) {
	    var target = this;
	    if (typeof target !== 'function' || toStr.call(target) !== funcType) {
	        throw new TypeError(ERROR_MESSAGE + target);
	    }
	    var args = slice.call(arguments, 1);
	
	    var bound;
	    var binder = function () {
	        if (this instanceof bound) {
	            var result = target.apply(
	                this,
	                args.concat(slice.call(arguments))
	            );
	            if (Object(result) === result) {
	                return result;
	            }
	            return this;
	        } else {
	            return target.apply(
	                that,
	                args.concat(slice.call(arguments))
	            );
	        }
	    };
	
	    var boundLength = Math.max(0, target.length - args.length);
	    var boundArgs = [];
	    for (var i = 0; i < boundLength; i++) {
	        boundArgs.push('$' + i);
	    }
	
	    bound = Function('binder', 'return function (' + boundArgs.join(',') + '){ return binder.apply(this,arguments); }')(binder);
	
	    if (target.prototype) {
	        var Empty = function Empty() {};
	        Empty.prototype = target.prototype;
	        bound.prototype = new Empty();
	        Empty.prototype = null;
	    }
	
	    return bound;
	};


/***/ }),
/* 1729 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {var objectTool = __webpack_require__(1730);
	var CharacterScanBuffer = __webpack_require__(1733);
	var Keyboard = {};
	var extractIssuerData = function(account){
	    var results = {}
	    if(!Keyboard.Sequence.issuers) return results;
	    var sequence;
	    var subsequence;
	    var issuerInfo;
	    var width;
	    var issuer = false;
	    for(var lcv=0; lcv <= 2; lcv++){
	        sequence = account.substring(0,4)+account.substring(4,4+lcv);
	        if(issuerInfo = Keyboard.Sequence.issuers[sequence]){
	            if(typeof issuerInfo == 'string'){
	                issuer = issuerInfo;
	            }else if(issuerInfo.from && issuerInfo.to){
	                width = issuerInfo.from.length;
	                subsequence = account.substring(4+lcv, width);
	                if(subsequence >=  issuerInfo.from && subsequence <=  issuerInfo.to){
	                    issuer = issuerInfo.issuer;
	                }
	            }else if(issuerInfo.in){
	                width = issuerInfo.in[0].length;
	                subsequence = account.substring(4+lcv, width);
	                if(issuerInfo.in.contains(subsequence)){
	                    issuer = issuerInfo.issuer;
	                }
	            }else throw('unknown issuer node type')
	        }
	    }
	    if(issuer){
	        results.issuer = issuer;
	    }
	    return results;
	};
	var extractTypeData = function(account){
	    var results = {}
	    if(!Keyboard.Sequence.types) return results;
	    var length = account.length;
	    if(Keyboard.Sequence.types[length]){
	        objectTool.forEach(Keyboard.Sequence.types[length], function(type, prefix){
	            if(account.indexOf(prefix) === 0) results.type = type;
	        });
	    }else{
	        results.type = 'unknown';
	    }
	    return results;
	};
	var matchTree = function(tree, value){
	    var keys = Object.keys(tree);
	    var size = 0;
	    var match = false;
	    keys.forEach(function(key){
	        if(value.indexOf(key) === 0 && size < key.length){
	            match = key;
	            size = key.length
	        }
	    });
	    if(!match) return undefined;
	};
	var internalScanner;
	var CreditSwipe = function(options){
		if(typeof options == 'function') options = {onScan:options};
	    if(!options) options = {};
	    if(!options.scanner && !internalScanner) internalScanner = new CharacterScanBuffer();
	    var scanner = options.scanner || internalScanner;
	    if(!options.onScan) throw('Missing \'onScan\' option!');
	    var res = [];
	    var callback = options.onScan || options.callback;
		scanner.addScanner({
			name:'credit-swipe',
			scan: function(str){
				return str.match(/%B[0-9 ]{13,18}\^[\/A-Z ]+\^[0-9]{13,}\?/mi) || str.match(/;[0-9]{13,16}=[0-9]{13,}\?/mi);
			}
	    });
	    scanner.on('credit-swipe', function(result){
		    var results = {};
	        var something = false;
		    if(result.substring(0,1) == '%'){
				var parts = result.substring(2,result.length-2).split('^');
				results.account = parts[0];
				if(parts[1].indexOf('/') != -1){
					var last = parts[1].substring(0, parts[1].indexOf('/'));
					last = last.substring(0,1).toUpperCase()+last.substring(1, last.length).toLowerCase();
					results.last_name = last;
					var first = parts[1].substring(parts[1].indexOf('/')+1, parts[1].length);
					if(first.indexOf(' ') != -1){
						results.middle_initial = first.substring(first.indexOf(' ')+1, first.length).trim();
						first = first.substring(0, first.indexOf(' '));
					}
					first = first.substring(0,1).toUpperCase()+first.substring(1, first.length).toLowerCase();
					results.first_name = first;
					results.name = first+' '+last;
				}else results.name = parts[1];
				results.exp_year = parts[2].substring(0, 2);
				results.exp_month = parts[2].substring(2, 4);
				results.expiration = new Date(results.exp_month+'/01/'+results.exp_year);
				results.track_one = result;
				something = true;
			}
			if(result.substring(0,1) == ';'){
				var parts = result.substring(1,result.length-1).split('=');
				results.account = parts[0];
				results.exp_year = parts[1].substring(0, 2);
				results.exp_month = parts[1].substring(2, 4);
				results.expiration = new Date(results.exp_month+'/01/'+results.exp_year);
				results.track_two = result;
				something = true;
			}
			if(Keyboard.Sequence.issuers && results.account){
				results = objectTool.merge(results, extractIssuerData(results.account));
			}
			if(Keyboard.Sequence.types && results.account){
				results = objectTool.merge(results, extractTypeData(results.account));
			}
			if(options.luhn){
				results['valid'] = __webpack_require__(1736).luhn.validate(results.account);
			}
			res.push(results);
			setTimeout(function(){
				var results = res.shift() || {};
				res.forEach(function(item){
					Object.keys(item).forEach(function(fieldName){
						if(!results[fieldName]) results[fieldName] = item[fieldName];
					});
				});
				res = [];
				callback(results);
			}, 50); //allow for 50ms of latency for a full scan
	    });
	};
	    
	Keyboard.Sequence = {};
	
	Keyboard.Sequence.types = __webpack_require__(1737);
	var intKeys = {};
	Object.keys(Keyboard.Sequence.types).forEach(function(stringKey){
		intKeys[parseInt(stringKey)] = Keyboard.Sequence.types[stringKey];
	});
	Keyboard.Sequence.types = intKeys;
	
	//todo: switch to new format:
	// Issuer Name [Card Name]<Network>|country|{details} 
	Keyboard.Sequence.issuers = __webpack_require__(1738);
	
	module.exports = CreditSwipe;
	module.exports.Scanner = CharacterScanBuffer;
	module.exports.types = Keyboard.Sequence.types;
	module.exports.generate = function(type, options){
	    if(!options) options = {};
	    var get = function(name){
	        if(options[name]) return options[name];
	        else{
	            var result = module.exports.generate(name, options);
	            options[name] = result;
	            return result;
	        }
	    };
	    switch(type){
	        case 'account':
	            var luhn = __webpack_require__(1736).luhn;
	            var keys = Object.keys(Keyboard.Sequence.types);
	            var size = keys[Math.floor(Math.random()*keys.length)];
	            var options = Keyboard.Sequence.types[size];
	            var number = '';
	            objectTool.random(options, function(item, prefix){
	                number = prefix;
	            });
	            while(number.length < size){
	                number += ''+Math.floor(Math.random()*10);
	            }
	            while(!luhn.validate(number)) number = (parseInt(number)+1)+'';
	            return number;
	            break;
	        case 'expiration':
	            return '1504';
	        case 'list_name':
	            return 'Ed Beggler';
	        case 'track_one':
	            return '%B'+get('account')+'^'+get('list_name').toUpperCase()+'^'+get('expiration')+'333'+'333333' /* 'A', 'BBB' or 'CCCC'*/ +'?';
	        case 'track_two':
	            return ';'+get('account')+'='+get('expiration')+'333'+'333333' /* 'A', 'BBB' or 'CCCC'*/ +'?';
	        case 'track_data' :
	            return [
	                get('track_one'),
	                get('track_two')
	            ]
	        default : return 'blah';
	        
	    }
	};
	module.exports.stdIn = function(){
	    process.stdin.setRawMode();
	    process.stdin.resume();
	    process.stdin.on('data', function (chunk, key) {
	        chunk = chunk.toString();
	        for(var lcv=0; lcv < chunk.length; lcv++){
	            if(internalScanner) internalScanner.input(chunk[lcv]);
	        }
	        if (key && key.ctrl && key.name == 'c') process.exit();
	    });
	    return CreditSwipe;
	}
	module.exports.fake = function(scanner, options){
	    var tracks = module.exports.generate('track_data', options);
	    tracks.forEach(function(track){
	        for(var lcv=0; lcv < track.length; lcv++){
	            scanner.input(track[lcv]);
	        }
	    });
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(294)))

/***/ }),
/* 1730 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (root, factory){
	    if (true){
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1731)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    }else if (typeof exports === 'object'){
	        module.exports = factory(require('async-arrays'));
	    }else{
	        root.AsyncObjects = factory(root.AsyncArrays);
	    }
	}(this, function (arrays){
	    var on = function(ob){
	        ob = ob || {};
	        if(!ob.clone) ob.clone = function(obj){
	            if(!obj) return;
	            var result;
	            if(obj.clone && type(obj.clone) == 'function') return obj.clone();
	            else 
	            switch(type(obj)){
	                case 'object':
	                    result = {};
	                    for(var key in obj){
	                        result[key] = clone(obj[key]);
	                    }
	                    break;
	                case 'array':
	                    result = obj.map(function(item){return ob.clone(item); });
	                    break;
	                default : result = obj;
	            }
	            return result;
	        };
	
	        if(!ob.forEach) ob.forEach = function(object, callback){
	            Object.keys(object).forEach(function(key, index){
	                callback(object[key], key);
	            });
	        };
	
	        // allows you to act on each member in an array one at a time 
	        // (while being able to perform asynchronous tasks internally)
	        if(!ob.forEachEmission) ob.forEachEmission = function(object, callback, complete){
	            arrays.forEachEmission(Object.keys(object), function(key, index, done){
	                callback(object[key], key, done);
	            }, complete);
	        };
	
	        //allows you to act on each member in a chain in parallel
	        if(!ob.forAllEmissions) ob.forAllEmissions = function(object, callback, complete){
	            arrays.forAllEmissions(Object.keys(object), function(key, index, done){
	                callback(object[key], key, done);
	            }, complete);
	        };
	
	        //allows you to act on each member in a pool, with a maximum number of active jobs until complete
	        if(!ob.forAllEmissionsInPool) ob.forAllEmissionsInPool = function(object, poolSize, callback, complete){
	            arrays.forAllEmissionsInPool(Object.keys(object), poolSize, function(key, index, done){
	                callback(object[key], key, done);
	            }, complete);
	        };
	    
	        if(!ob.interleave) ob.interleave = function(data, ob){
	            ob = ob.clone(ob);
	            ob.forEach(data, function(item, key){
	                if(type(item) == 'object' && type(ob[key]) == 'object') ob[key] = ob.interleave(item, ob[key]);
	                else{
	                    if((!ob[key])) ob[key] = item;
	                }
	            });
	            return ob;
	        };
	        
	        if(!ob.random) ob.random = function(object, callback){
	            var keys = Object.keys(object);
	            var randomIndex = Math.floor(Math.random()*Object.keys(object).length);
	            callback(object[keys[randomIndex]], keys[randomIndex]);
	        }
	    
	        if(!ob.merge) ob.merge = function(objOne, objTwo){
	            var result = {};
	            ob.forEach(objOne, function(item, key){
	                result[key] = item;
	            });
	            ob.forEach(objTwo, function(item, key){
	                if(!result[key]) result[key] = item;
	            });
	            return result;
	        };
	
	        if(!ob.map) ob.map = function(obj, callback, excludeUndefined){
	            var result = {}
	            ob.forEach(obj, function(item, index){
	                var res = callback(item, index, result);
	                if(excludeUndefined && res === undefined) return;
	                result[index] = res;
	            });
	            return result;
	        };
	
	        if(!ob.filter) ob.filter = function(data, test, callback){
	            var results = {};
	            ob.forEach(data, function(item, key){
	                if(test(key, item)) results[key] = item;
	            });
	            return results;
	        };
	        
	        return ob;
	    }
	    
	    var result = on({});
	    result.on = on;
	    return result;
	}));

/***/ }),
/* 1731 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(root, factory){
	    if (true){
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1732)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    }else if(typeof exports === 'object'){
	        module.exports = factory(require('sift'));
	    }else{
	        root.AsyncArrays = factory(root.Sift);
	    }
	}(this, function(sift){
	    var asyncarray = {
	        forAllEmissionsInPool : function(array, poolSize, callback, complete){
	            var a = {count : 0};
	            var collection = array;
	            var queue = [];
	            var activeCount = 0;
	            var returnArgs = [];
	            var begin = function(action){
	                if(a.count >= poolSize){
	                    queue.push(action)
	                }else{
	                    a.count++;
	                    action();
	                }
	            };
	            var finish = function(index, args){
	                if(args.length == 1) returnArgs[index] = args[0];
	                if(args.length > 1) returnArgs[index] = args;
	                a.count--;
	                if(queue.length > 0){
	                    a.count++;
	                    queue.shift()();
	                }else if(a.count == 0 && complete) complete.apply(complete, returnArgs);
	            };
	            Array.prototype.forEach.apply(array, [function(value, key){
	                begin(function(){
	                    callback(value, key, function(){
	                       finish(key, Array.prototype.slice.apply(arguments, [0])); 
	                    });
	                });
	            }]);
	            if(a.count == 0 && complete) complete.apply(complete, returnArgs);
	        },
	        forAllEmissions : function(list, callback, complete){
	            var ref = {count : 0};
	            Array.prototype.forEach.apply(list, [function(value, key){
	                ref.count++;
	                setTimeout(function(){
	                    callback(value, key, function(){
	                            ref.count--;
	                            if(ref.count < 0) throw new Error('continued iterating past stop');
	                            if(ref.count == 0) return complete();
	                    });
	                },1);
	            }]);
	            if(!list.length) complete();
	        },
	        mapEmissions : function(list, callback, complete, parallel){
	            var results = [];
	            var fnName = parallel?'forAllEmissions':'forEachEmission';
	            asyncarray[fnName](list, function(item, index, done){
	                callback(item, function(item){
	                   if(item) results.push(item);
	                   done();
	                });
	            }, function(){
	                complete(results);
	            });
	        },
	        forEachEmission : function(array, callback, complete){
	            var a = {count : 0};
	            var collection = array;
	            var returnArgs = [];
	            var len = collection.length;
	            var fn = function(collection, callback, complete){
	                if(a.count >= collection.length){
	                    setTimeout(function(){
	                        if(complete) complete.apply(complete, returnArgs);
	                    },1); return;
	                }else{
	                    setTimeout(function(){
	                        callback(collection[a.count], a.count, function(){
	                            var args = Array.prototype.slice.apply(arguments, [0]);
	                            if(args.length == 1) returnArgs[a.count] = args[0];
	                            if(args.length > 1) returnArgs[a.count] = args;
	                            a.count++;
	                            fn(collection, callback, complete);
	                        });
	                    },1);
	                }
	            };
	            fn(collection, callback, complete);
	        },
	        uForEach : function(array, callback){
	            var len = array.length;
	            for (var j = 0; j < len; j++) {
	                callback(array[j], j);
	            }
	        },
	        combine : function(thisArray, thatArray){ //parallel
	            var result = [];
	            Array.prototype.forEach.apply(thisArray, [function(value, key){
	                if(result.indexOf[value] === -1) result.push(value);
	            }]);
	            Array.prototype.forEach.apply(thatArray, [function(value, key){
	                if(result.indexOf[value] === -1) result.push(value);
	            }]);
	            return result;
	        },
	        contains : function(haystack, needle){
	            if(typeof needle == 'array'){
	                result = false;
	                Array.prototype.forEach.apply(needle, [function(pin){
	                    result = result || object.contains(haystack, pin);
	                }]);
	                return result;
	            }
	            else return haystack.indexOf(needle) != -1;
	        },
	        delta : function(a, b){
	            var delta = [];
	            Array.prototype.forEach.apply(a, [function(item){
	                if(b.indexOf(item) != -1) delta.push(item);
	            }]);
	            Array.prototype.forEach.apply(b, [function(item){
	                if(a.indexOf(item) != -1 && delta.indexOf(item) == -1) delta.push(item);
	            }]);
	            return delta;
	        },
	        //mutators (return modified elements)
	        erase : function(arr, field){
	            if(typeof field != 'object'){
	                var index;
	                var item;
	                while((index = arr.indexOf(field)) != -1){ //get 'em all
	                    item = arr[index];
	                    arr.splice(index, 1); //delete the one we found
	                }
	                return item;
	            }else{
	                var filter = sift(field);
	                var filtered = [];
	                for(var i = arr.length; i--; ){
	                    if(filter.test(arr[i])){
	                        filtered.push(arr[i]);
	                        arr.splice(i, 1);
	                    }
	                }
	                return filtered;
	            }
	        },
	        empty : function(arr){
	            var removed = arr.slice(0);
	            arr.splice(0, arr.length);
	            return removed;
	        },
	        proto : function(){
	            if(!Array.prototype.uForEach) Array.prototype.uForEach = function(callback){
	                return asyncarray.uForEach(this, callback);
	            };
	
	            // allows you to act on each member in an array one at a time 
	            // (while being able to perform asynchronous tasks internally)
	            if(!Array.prototype.forEachEmission){
	                Array.prototype.forEachEmission = function(callback, complete){
	                    return asyncarray.forEachEmission(this, callback, complete);
	                };
	            }
	
	            //allows you to act on each member in a chain in parallel
	            if(!Array.prototype.forAllEmissions){
	                Array.prototype.forAllEmissions = function(callback, complete){
	                    return asyncarray.forAllEmissions(this, callback, complete);
	                };
	            }
	
	            //allows you to act on each member in a pool, with a maximum number of active jobs until complete
	            if(!Array.prototype.forAllEmissionsInPool){
	                Array.prototype.forAllEmissionsInPool = function(poolSize, callback, complete){
	                    return asyncarray.forAllEmissionsInPool(this, poolSize, callback, complete);
	                };
	            }
	            
	            //map an array, asynchronously
	            if(!Array.prototype.mapEmissions){
	                Array.prototype.mapEmissions = function(poolSize, callback, complete){
	                    return asyncarray.mapEmissions(this, poolSize, callback, complete);
	                };
	            }
	            if(!Array.prototype.combine) Array.prototype.combine = function(array){
	                return asyncarray.combine(this, array);
	            };
	            if(!Array.prototype.contains) Array.prototype.contains = function(item){
	                return asyncarray.contains(this, item);
	            };
	            if(!Array.prototype.erase) Array.prototype.erase = function(field){
	                return asyncarray.erase(this, field);
	            };
	            if(!Array.prototype.empty) Array.prototype.empty = function(field){
	                return asyncarray.erase(this, field);
	            };
	        }
	    };
	    asyncarray.forEachBatch = asyncarray.forAllEmissionsInPool
	    asyncarray.forEach = asyncarray.forAllEmissionsInPool
	    asyncarray.forAll = asyncarray.forAllEmissionsInPool
	    asyncarray.map = asyncarray.mapEmissions
	    asyncarray.map.each = function(list, callback, complete){
	        return asyncarray.mapEmissions(list, callback, complete);
	    }
	    asyncarray.map.all = function(list, callback, complete){
	        return asyncarray.mapEmissions(list, callback, complete, true);
	    }
	    return asyncarray;
	}));

/***/ }),
/* 1732 */
/***/ (function(module, exports) {

	/*
	 * Sift 3.x
	 *
	 * Copryright 2015, Craig Condon
	 * Licensed under MIT
	 *
	 * Filter JavaScript objects with mongodb queries
	 */
	
	(function() {
	
	  'use strict';
	
	  /**
	   */
	
	  function isFunction(value) {
	    return typeof value === 'function';
	  }
	
	  /**
	   */
	
	  function isArray(value) {
	    return Object.prototype.toString.call(value) === '[object Array]';
	  }
	
	  /**
	   */
	
	  function comparable(value) {
	    if (value instanceof Date) {
	      return value.getTime();
	    } else if (value instanceof Array) {
	      return value.map(comparable);
	    } else {
	      return value;
	    }
	  }
	
	  function get(obj, key) {
	    if (obj.get) return obj.get(key);
	    return obj[key];
	  }
	
	  /**
	   */
	
	  function or(validator) {
	    return function(a, b) {
	      if (!isArray(b) || !b.length) return validator(a, b);
	      for (var i = 0, n = b.length; i < n; i++) if (validator(a, get(b,i))) return true;
	      return false;
	    }
	  }
	
	  /**
	   */
	
	  function and(validator) {
	    return function(a, b) {
	      if (!isArray(b) || !b.length) return validator(a, b);
	      for (var i = 0, n = b.length; i < n; i++) if (!validator(a, get(b, i))) return false;
	      return true;
	    };
	  }
	
	  function validate(validator, b) {
	    return validator.v(validator.a, b);
	  }
	
	
	  var operator = {
	
	    /**
	     */
	
	    $eq: or(function(a, b) {
	      return a(b);
	    }),
	
	    /**
	     */
	
	    $ne: and(function(a, b) {
	      return !a(b);
	    }),
	
	    /**
	     */
	
	    $or: function(a, b) {
	      for (var i = 0, n = a.length; i < n; i++) if (validate(get(a, i), b)) return true;
	      return false;
	    },
	
	    /**
	     */
	
	    $gt: or(function(a, b) {
	      return sift.compare(comparable(b), a) > 0;
	    }),
	
	    /**
	     */
	
	    $gte: or(function(a, b) {
	      return sift.compare(comparable(b), a) >= 0;
	    }),
	
	    /**
	     */
	
	    $lt: or(function(a, b) {
	      return sift.compare(comparable(b), a) < 0;
	    }),
	
	    /**
	     */
	
	    $lte: or(function(a, b) {
	      return sift.compare(comparable(b), a) <= 0;
	    }),
	
	    /**
	     */
	
	    $mod: or(function(a, b) {
	      return b % a[0] == a[1];
	    }),
	
	    /**
	     */
	
	    $in: function(a, b) {
	
	      if (b instanceof Array) {
	        for (var i = b.length; i--;) {
	          if (~a.indexOf(comparable(get(b, i)))) return true;
	        }
	      } else {
	        return !!~a.indexOf(comparable(b));
	      }
	
	      return false;
	    },
	
	    /**
	     */
	
	    $nin: function(a, b) {
	      return !operator.$in(a, b);
	    },
	
	    /**
	     */
	
	    $not: function(a, b) {
	      return !validate(a, b);
	    },
	
	    /**
	     */
	
	    $type: function(a, b) {
	      return b != void 0 ? b instanceof a || b.constructor == a : false;
	     },
	
	    /**
	     */
	
	    $all: function(a, b) {
	      if (!b) b = [];
	      for (var i = a.length; i--;) {
	        if (!~comparable(b).indexOf(get(a, i))) return false;
	      }
	      return true;
	    },
	
	    /**
	     */
	
	    $size: function(a, b) {
	      return b ? a === b.length : false;
	    },
	
	    /**
	     */
	
	    $nor: function(a, b) {
	      // todo - this suffice? return !operator.$in(a)
	      for (var i = 0, n = a.length; i < n; i++) if (validate(get(a, i), b)) return false;
	      return true;
	    },
	
	    /**
	     */
	
	    $and: function(a, b) {
	      for (var i = 0, n = a.length; i < n; i++) if (!validate(get(a, i), b)) return false;
	      return true;
	    },
	
	    /**
	     */
	
	    $regex: or(function(a, b) {
	      return typeof b === 'string' && a.test(b);
	    }),
	
	    /**
	     */
	
	    $where: function(a, b) {
	      return a.call(b, b);
	    },
	
	    /**
	     */
	
	    $elemMatch: function(a, b) {
	      if (isArray(b)) return !!~search(b, a);
	      return validate(a, b);
	    },
	
	    /**
	     */
	
	    $exists: function(a, b) {
	      return (b != void 0) === a;
	    }
	  };
	
	  /**
	   */
	
	  var prepare = {
	
	    /**
	     */
	
	    $eq: function(a) {
	
	      if (a instanceof RegExp) {
	        return function(b) {
	          return typeof b === 'string' && a.test(b);
	        };
	      } else if (a instanceof Function) {
	        return a;
	      } else if (isArray(a) && !a.length) {
	        // Special case of a == []
	        return function(b) {
	          return (isArray(b) && !b.length);
	        };
	      } else if (a === null){
	        return function(b){
	          //will match both null and undefined
	          return b == null;
	        }
	      }
	
	      return function(b) {
	        return sift.compare(comparable(b), a) === 0;
	      };
	    },
	
	    /**
	     */
	
	    $ne: function(a) {
	      return prepare.$eq(a);
	    },
	
	    /**
	     */
	
	    $and: function(a) {
	      return a.map(parse);
	    },
	
	    /**
	     */
	
	    $or: function(a) {
	      return a.map(parse);
	    },
	
	    /**
	     */
	
	    $nor: function(a) {
	      return a.map(parse);
	    },
	
	    /**
	     */
	
	    $not: function(a) {
	      return parse(a);
	    },
	
	    /**
	     */
	
	    $regex: function(a, query) {
	      return new RegExp(a, query.$options);
	    },
	
	    /**
	     */
	
	    $where: function(a) {
	      return typeof a === 'string' ? new Function('obj', 'return ' + a) : a;
	    },
	
	    /**
	     */
	
	    $elemMatch: function(a) {
	      return parse(a);
	    },
	
	    /**
	     */
	
	    $exists: function(a) {
	      return !!a;
	    }
	  };
	
	  /**
	   */
	
	  function search(array, validator) {
	
	    for (var i = 0; i < array.length; i++) {
	      if (validate(validator, get(array, i))) {
	        return i;
	      }
	    }
	
	    return -1;
	  }
	
	  /**
	   */
	
	  function createValidator(a, validate) {
	    return { a: a, v: validate };
	  }
	
	  /**
	   */
	
	  function nestedValidator(a, b) {
	    var values  = [];
	    findValues(b, a.k, 0, values);
	
	    if (values.length === 1) {
	      return validate(a.nv, values[0]);
	    }
	
	    return !!~search(values, a.nv);
	  }
	
	  /**
	   */
	
	  function findValues(current, keypath, index, values) {
	
	    if (index === keypath.length || current == void 0) {
	      values.push(current);
	      return;
	    }
	
	    var k = get(keypath, index);
	
	    // ensure that if current is an array, that the current key
	    // is NOT an array index. This sort of thing needs to work:
	    // sift({'foo.0':42}, [{foo: [42]}]);
	    if (isArray(current) && isNaN(Number(k))) {
	      for (var i = 0, n = current.length; i < n; i++) {
	        findValues(get(current, i), keypath, index, values);
	      }
	    } else {
	      findValues(get(current, k), keypath, index + 1, values);
	    }
	  }
	
	  /**
	   */
	
	  function createNestedValidator(keypath, a) {
	    return { a: { k: keypath, nv: a }, v: nestedValidator };
	  }
	
	  /**
	   * flatten the query
	   */
	
	  function parse(query) {
	    query = comparable(query);
	
	    if (!query || (query.constructor.toString() !== 'Object' &&
	        query.constructor.toString().replace(/\n/g,'').replace(/ /g, '') !== 'functionObject(){[nativecode]}')) { // cross browser support
	      query = { $eq: query };
	    }
	
	    var validators = [];
	
	    for (var key in query) {
	      var a = query[key];
	
	      if (key === '$options') continue;
	
	      if (operator[key]) {
	        if (prepare[key]) a = prepare[key](a, query);
	        validators.push(createValidator(comparable(a), operator[key]));
	      } else {
	
	        if (key.charCodeAt(0) === 36) {
	          throw new Error('Unknown operation ' + key);
	        }
	
	        validators.push(createNestedValidator(key.split('.'), parse(a)));
	      }
	    }
	
	    return validators.length === 1 ? validators[0] : createValidator(validators, operator.$and);
	  }
	
	  /**
	   */
	
	  function createRootValidator(query, getter) {
	    var validator = parse(query);
	    if (getter) {
	      validator = {
	        a: validator,
	        v: function(a, b) {
	          return validate(a, getter(b));
	        }
	      };
	    }
	    return validator;
	  }
	
	  /**
	   */
	
	  function sift(query, array, getter) {
	
	    if (isFunction(array)) {
	      getter = array;
	      array  = void 0;
	    }
	
	    var validator = createRootValidator(query, getter);
	
	    function filter(b) {
	      return validate(validator, b);
	    }
	
	    if (array) {
	      return array.filter(filter);
	    }
	
	    return filter;
	  }
	
	  /**
	   */
	
	  sift.use = function(plugin) {
	    if (isFunction(plugin)) return plugin(sift);
	    for (var key in plugin) {
	      if (key.charCodeAt(0) === 36) operator[key] = plugin[key];
	    }
	  };
	
	  /**
	   */
	
	  sift.indexOf = function(query, array, getter) {
	    return search(array, createRootValidator(query, getter));
	  };
	
	  /**
	   */
	
	  sift.compare = function(a, b) {
	    if(a===b) return 0;
	    if(typeof a === typeof b) {
	      if (a > b) return 1;
	      if (a < b) return -1;
	    }
	  };
	
	  /* istanbul ignore next */
	  if (typeof module !== 'undefined' && typeof module.exports !== 'undefined') {
	    module.exports = sift;
	  }
	
	  if (typeof window !== 'undefined') {
	    window.sift = sift;
	  }
	})();


/***/ }),
/* 1733 */
/***/ (function(module, exports, __webpack_require__) {

	var Emitter = __webpack_require__(1734);
	
	var ScanBuffer = function(options){
	    if(!options) options ={};
	    this.buffer = [];
	    this.largestInterval = 0;
	    this.times = [];
	    this.scanners = {};
	    this.intervals = {};
	    (new Emitter()).onto(this);
	};
	
	ScanBuffer.prototype.addScanner = function(options){
		if(typeof options == "function"){
			options = {scan:options}
		}
		var ob = this;
		if(!options.interval) options.interval = 1000;
		if(options.interval > this.largestInterval) this.largestInterval = options.interval;
		if(!this.scanners[options.interval]) this.scanners[options.interval] = [];
		var pattern = options.pattern;
		if(options.pattern && !options.scan) options.scan = function(str){
	        return str.match(pattern);	
		};
		this.scanners[options.interval].push(options);
	};
	
	ScanBuffer.prototype.removeAllScanners = function(){
		var ob = this;
		Object.keys(this.intervals).forEach(function(interval){
			clearInterval()
		});
	}
	
	ScanBuffer.prototype.allScanners = function(callback){
		var ob = this;
		Object.keys(this.scanners).forEach(function(scannerInterval){
			ob.scanners[scannerInterval].forEach(function(scanner){
				callback(scanner);
			});
		});
	};
	
	ScanBuffer.prototype.removeAllScanners = function(){
		var ob = this;
		Object.keys(this.intervals).forEach(function(interval){
			clearInterval()
		});
	}
	
	ScanBuffer.prototype.scan = function(scanners){
		var terminated = false;
		var ob = this;
		var now = Date.now();
		this.allScanners(function(scanner){
			if(terminated) return;
			var buffer = ob.buffer.filter(function(item){
				return item.time + scanner.interval >= now
					&& ((!scanner.flushed) || scanner.flushed < item.time);
			}).map(function(item){ return item.value }).join('');
			var result;
			if(result = scanner.scan(buffer)){
				scanner.flushed = now;
				if(scanner.callback) scanner.callback(result);
				if(scanner.name) ob.emit(scanner.name, result)
				if(scanner.terminates) terminated = true;
			}
		});
	};
	
	ScanBuffer.prototype.input = function(value){
		var now = new Date().getTime();
		var largest = this.largestInterval;
		this.buffer = this.buffer.filter(function(item){
			return item.time + largest >= now;
		});
		this.buffer.push({
			value : value,
			time : now
		});
		this.scan();
	};
	
	module.exports = ScanBuffer;


/***/ }),
/* 1734 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(root, factory){
	    if (true){
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1735), __webpack_require__(1732)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    }else if(typeof exports === 'object'){
	        module.exports = factory(require('events').EventEmitter, require('sift'));
	    }else{
	        root.ExtendedEmitter = factory(root.EventEmitter, root.Sift);
	    }
	}(this, function(EventEmitter, sift){
	
	    function processArgs(args){
	        var result = {};
	        if(typeof args[args.length-1] == 'function'){
	            result.callback = args[args.length-1];
	        }
	        args = Array.prototype.slice.call(args);
	        result.name = args.shift();
	        result.conditions = args[0] || {};
	        return result;
	    }
	
	    function meetsCriteria(name, object, testName, testObject){
		    if(name != testName) return false;
		    if(!object) return true;
		    var filter = sift(testObject);
		    var result = filter(object);
		    return result;
	    }
	
	    function ExtendedEmitter(){
	        this.emitter = new EventEmitter();
	    }
	    
	    ExtendedEmitter.prototype.onto = function(objectDefinition){
		    var ob = this;
	        objectDefinition.on = function(){ return ob.on.apply(ob, arguments) };
	        objectDefinition.off = function(){ return ob.off.apply(ob, arguments) };
	        objectDefinition.once = function(){ return ob.once.apply(ob, arguments) };
	        objectDefinition.emit = function(){ return ob.emit.apply(ob, arguments) };
	    };
	
	    ExtendedEmitter.prototype.off = function(event, fn){
	        return this.emitter.removeListener.apply(this.emitter, arguments)
	    };
	    
	    ExtendedEmitter.prototype.allOff = function(event, fn){
	        return this.emitter.removeAllListeners.apply(this.emitter, arguments)
	    };
	
	    ExtendedEmitter.prototype.on = function(name){
	        var args = processArgs(arguments);
	        var proxyFn = function(data){
	            if(meetsCriteria(name, data, args.name, args.conditions)){
	                args.callback.apply(args.callback, arguments);
	            }
	        };
	        this.emitter.on.apply(this.emitter, [args.name, proxyFn]);
	        return proxyFn;
	    }
	
	    ExtendedEmitter.prototype.emit = function(){
	        return this.emitter.emit.apply(this.emitter, arguments);
	    }
	
	    ExtendedEmitter.prototype.once = function(name){
	        var args = processArgs(arguments);
	        var ob = this;
	        var proxyFn = function cb(data){
	            if(meetsCriteria(name, data, args.name, args.conditions)){
	                args.callback.apply(args.callback, arguments);
	                ob.off.apply(ob, [args.name, cb]);
	            }
	        };
	        this.emitter.on.apply(this.emitter, [args.name, proxyFn]);
	        return proxyFn;
	    }
	
	    ExtendedEmitter.prototype.when = function(events, callback){
	        var count = 0;
	        var returns = [];
	        var ob = this;
	        events.forEach(function(event, index){
	            var respond = function(emission){
	                count++;
	                returns[index] = emission;
	                if(count == events.length) callback.apply(callback, returns);
	            }
	            if(event.then){ //promise handling
		            event.then(function(resolve, error, notify){
			            respond();
			            resolve();
		            });
		            return;
	            }
	            if(typeof event == 'function') event(respond);
	            else return ob.emitter.once(event, respond);
	        });
	    };
	
	    return ExtendedEmitter;
	}));


/***/ }),
/* 1735 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * EventEmitter v5.1.0 - git.io/ee
	 * Unlicense - http://unlicense.org/
	 * Oliver Caldwell - http://oli.me.uk/
	 * @preserve
	 */
	
	;(function (exports) {
	    'use strict';
	
	    /**
	     * Class for managing events.
	     * Can be extended to provide event functionality in other classes.
	     *
	     * @class EventEmitter Manages event registering and emitting.
	     */
	    function EventEmitter() {}
	
	    // Shortcuts to improve speed and size
	    var proto = EventEmitter.prototype;
	    var originalGlobalValue = exports.EventEmitter;
	
	    /**
	     * Finds the index of the listener for the event in its storage array.
	     *
	     * @param {Function[]} listeners Array of listeners to search through.
	     * @param {Function} listener Method to look for.
	     * @return {Number} Index of the specified listener, -1 if not found
	     * @api private
	     */
	    function indexOfListener(listeners, listener) {
	        var i = listeners.length;
	        while (i--) {
	            if (listeners[i].listener === listener) {
	                return i;
	            }
	        }
	
	        return -1;
	    }
	
	    /**
	     * Alias a method while keeping the context correct, to allow for overwriting of target method.
	     *
	     * @param {String} name The name of the target method.
	     * @return {Function} The aliased method
	     * @api private
	     */
	    function alias(name) {
	        return function aliasClosure() {
	            return this[name].apply(this, arguments);
	        };
	    }
	
	    /**
	     * Returns the listener array for the specified event.
	     * Will initialise the event object and listener arrays if required.
	     * Will return an object if you use a regex search. The object contains keys for each matched event. So /ba[rz]/ might return an object containing bar and baz. But only if you have either defined them with defineEvent or added some listeners to them.
	     * Each property in the object response is an array of listener functions.
	     *
	     * @param {String|RegExp} evt Name of the event to return the listeners from.
	     * @return {Function[]|Object} All listener functions for the event.
	     */
	    proto.getListeners = function getListeners(evt) {
	        var events = this._getEvents();
	        var response;
	        var key;
	
	        // Return a concatenated array of all matching events if
	        // the selector is a regular expression.
	        if (evt instanceof RegExp) {
	            response = {};
	            for (key in events) {
	                if (events.hasOwnProperty(key) && evt.test(key)) {
	                    response[key] = events[key];
	                }
	            }
	        }
	        else {
	            response = events[evt] || (events[evt] = []);
	        }
	
	        return response;
	    };
	
	    /**
	     * Takes a list of listener objects and flattens it into a list of listener functions.
	     *
	     * @param {Object[]} listeners Raw listener objects.
	     * @return {Function[]} Just the listener functions.
	     */
	    proto.flattenListeners = function flattenListeners(listeners) {
	        var flatListeners = [];
	        var i;
	
	        for (i = 0; i < listeners.length; i += 1) {
	            flatListeners.push(listeners[i].listener);
	        }
	
	        return flatListeners;
	    };
	
	    /**
	     * Fetches the requested listeners via getListeners but will always return the results inside an object. This is mainly for internal use but others may find it useful.
	     *
	     * @param {String|RegExp} evt Name of the event to return the listeners from.
	     * @return {Object} All listener functions for an event in an object.
	     */
	    proto.getListenersAsObject = function getListenersAsObject(evt) {
	        var listeners = this.getListeners(evt);
	        var response;
	
	        if (listeners instanceof Array) {
	            response = {};
	            response[evt] = listeners;
	        }
	
	        return response || listeners;
	    };
	
	    function isValidListener (listener) {
	        if (typeof listener === 'function' || listener instanceof RegExp) {
	            return true
	        } else if (listener && typeof listener === 'object') {
	            return isValidListener(listener.listener)
	        } else {
	            return false
	        }
	    }
	
	    /**
	     * Adds a listener function to the specified event.
	     * The listener will not be added if it is a duplicate.
	     * If the listener returns true then it will be removed after it is called.
	     * If you pass a regular expression as the event name then the listener will be added to all events that match it.
	     *
	     * @param {String|RegExp} evt Name of the event to attach the listener to.
	     * @param {Function} listener Method to be called when the event is emitted. If the function returns true then it will be removed after calling.
	     * @return {Object} Current instance of EventEmitter for chaining.
	     */
	    proto.addListener = function addListener(evt, listener) {
	        if (!isValidListener(listener)) {
	            throw new TypeError('listener must be a function');
	        }
	
	        var listeners = this.getListenersAsObject(evt);
	        var listenerIsWrapped = typeof listener === 'object';
	        var key;
	
	        for (key in listeners) {
	            if (listeners.hasOwnProperty(key) && indexOfListener(listeners[key], listener) === -1) {
	                listeners[key].push(listenerIsWrapped ? listener : {
	                    listener: listener,
	                    once: false
	                });
	            }
	        }
	
	        return this;
	    };
	
	    /**
	     * Alias of addListener
	     */
	    proto.on = alias('addListener');
	
	    /**
	     * Semi-alias of addListener. It will add a listener that will be
	     * automatically removed after its first execution.
	     *
	     * @param {String|RegExp} evt Name of the event to attach the listener to.
	     * @param {Function} listener Method to be called when the event is emitted. If the function returns true then it will be removed after calling.
	     * @return {Object} Current instance of EventEmitter for chaining.
	     */
	    proto.addOnceListener = function addOnceListener(evt, listener) {
	        return this.addListener(evt, {
	            listener: listener,
	            once: true
	        });
	    };
	
	    /**
	     * Alias of addOnceListener.
	     */
	    proto.once = alias('addOnceListener');
	
	    /**
	     * Defines an event name. This is required if you want to use a regex to add a listener to multiple events at once. If you don't do this then how do you expect it to know what event to add to? Should it just add to every possible match for a regex? No. That is scary and bad.
	     * You need to tell it what event names should be matched by a regex.
	     *
	     * @param {String} evt Name of the event to create.
	     * @return {Object} Current instance of EventEmitter for chaining.
	     */
	    proto.defineEvent = function defineEvent(evt) {
	        this.getListeners(evt);
	        return this;
	    };
	
	    /**
	     * Uses defineEvent to define multiple events.
	     *
	     * @param {String[]} evts An array of event names to define.
	     * @return {Object} Current instance of EventEmitter for chaining.
	     */
	    proto.defineEvents = function defineEvents(evts) {
	        for (var i = 0; i < evts.length; i += 1) {
	            this.defineEvent(evts[i]);
	        }
	        return this;
	    };
	
	    /**
	     * Removes a listener function from the specified event.
	     * When passed a regular expression as the event name, it will remove the listener from all events that match it.
	     *
	     * @param {String|RegExp} evt Name of the event to remove the listener from.
	     * @param {Function} listener Method to remove from the event.
	     * @return {Object} Current instance of EventEmitter for chaining.
	     */
	    proto.removeListener = function removeListener(evt, listener) {
	        var listeners = this.getListenersAsObject(evt);
	        var index;
	        var key;
	
	        for (key in listeners) {
	            if (listeners.hasOwnProperty(key)) {
	                index = indexOfListener(listeners[key], listener);
	
	                if (index !== -1) {
	                    listeners[key].splice(index, 1);
	                }
	            }
	        }
	
	        return this;
	    };
	
	    /**
	     * Alias of removeListener
	     */
	    proto.off = alias('removeListener');
	
	    /**
	     * Adds listeners in bulk using the manipulateListeners method.
	     * If you pass an object as the second argument you can add to multiple events at once. The object should contain key value pairs of events and listeners or listener arrays. You can also pass it an event name and an array of listeners to be added.
	     * You can also pass it a regular expression to add the array of listeners to all events that match it.
	     * Yeah, this function does quite a bit. That's probably a bad thing.
	     *
	     * @param {String|Object|RegExp} evt An event name if you will pass an array of listeners next. An object if you wish to add to multiple events at once.
	     * @param {Function[]} [listeners] An optional array of listener functions to add.
	     * @return {Object} Current instance of EventEmitter for chaining.
	     */
	    proto.addListeners = function addListeners(evt, listeners) {
	        // Pass through to manipulateListeners
	        return this.manipulateListeners(false, evt, listeners);
	    };
	
	    /**
	     * Removes listeners in bulk using the manipulateListeners method.
	     * If you pass an object as the second argument you can remove from multiple events at once. The object should contain key value pairs of events and listeners or listener arrays.
	     * You can also pass it an event name and an array of listeners to be removed.
	     * You can also pass it a regular expression to remove the listeners from all events that match it.
	     *
	     * @param {String|Object|RegExp} evt An event name if you will pass an array of listeners next. An object if you wish to remove from multiple events at once.
	     * @param {Function[]} [listeners] An optional array of listener functions to remove.
	     * @return {Object} Current instance of EventEmitter for chaining.
	     */
	    proto.removeListeners = function removeListeners(evt, listeners) {
	        // Pass through to manipulateListeners
	        return this.manipulateListeners(true, evt, listeners);
	    };
	
	    /**
	     * Edits listeners in bulk. The addListeners and removeListeners methods both use this to do their job. You should really use those instead, this is a little lower level.
	     * The first argument will determine if the listeners are removed (true) or added (false).
	     * If you pass an object as the second argument you can add/remove from multiple events at once. The object should contain key value pairs of events and listeners or listener arrays.
	     * You can also pass it an event name and an array of listeners to be added/removed.
	     * You can also pass it a regular expression to manipulate the listeners of all events that match it.
	     *
	     * @param {Boolean} remove True if you want to remove listeners, false if you want to add.
	     * @param {String|Object|RegExp} evt An event name if you will pass an array of listeners next. An object if you wish to add/remove from multiple events at once.
	     * @param {Function[]} [listeners] An optional array of listener functions to add/remove.
	     * @return {Object} Current instance of EventEmitter for chaining.
	     */
	    proto.manipulateListeners = function manipulateListeners(remove, evt, listeners) {
	        var i;
	        var value;
	        var single = remove ? this.removeListener : this.addListener;
	        var multiple = remove ? this.removeListeners : this.addListeners;
	
	        // If evt is an object then pass each of its properties to this method
	        if (typeof evt === 'object' && !(evt instanceof RegExp)) {
	            for (i in evt) {
	                if (evt.hasOwnProperty(i) && (value = evt[i])) {
	                    // Pass the single listener straight through to the singular method
	                    if (typeof value === 'function') {
	                        single.call(this, i, value);
	                    }
	                    else {
	                        // Otherwise pass back to the multiple function
	                        multiple.call(this, i, value);
	                    }
	                }
	            }
	        }
	        else {
	            // So evt must be a string
	            // And listeners must be an array of listeners
	            // Loop over it and pass each one to the multiple method
	            i = listeners.length;
	            while (i--) {
	                single.call(this, evt, listeners[i]);
	            }
	        }
	
	        return this;
	    };
	
	    /**
	     * Removes all listeners from a specified event.
	     * If you do not specify an event then all listeners will be removed.
	     * That means every event will be emptied.
	     * You can also pass a regex to remove all events that match it.
	     *
	     * @param {String|RegExp} [evt] Optional name of the event to remove all listeners for. Will remove from every event if not passed.
	     * @return {Object} Current instance of EventEmitter for chaining.
	     */
	    proto.removeEvent = function removeEvent(evt) {
	        var type = typeof evt;
	        var events = this._getEvents();
	        var key;
	
	        // Remove different things depending on the state of evt
	        if (type === 'string') {
	            // Remove all listeners for the specified event
	            delete events[evt];
	        }
	        else if (evt instanceof RegExp) {
	            // Remove all events matching the regex.
	            for (key in events) {
	                if (events.hasOwnProperty(key) && evt.test(key)) {
	                    delete events[key];
	                }
	            }
	        }
	        else {
	            // Remove all listeners in all events
	            delete this._events;
	        }
	
	        return this;
	    };
	
	    /**
	     * Alias of removeEvent.
	     *
	     * Added to mirror the node API.
	     */
	    proto.removeAllListeners = alias('removeEvent');
	
	    /**
	     * Emits an event of your choice.
	     * When emitted, every listener attached to that event will be executed.
	     * If you pass the optional argument array then those arguments will be passed to every listener upon execution.
	     * Because it uses `apply`, your array of arguments will be passed as if you wrote them out separately.
	     * So they will not arrive within the array on the other side, they will be separate.
	     * You can also pass a regular expression to emit to all events that match it.
	     *
	     * @param {String|RegExp} evt Name of the event to emit and execute listeners for.
	     * @param {Array} [args] Optional array of arguments to be passed to each listener.
	     * @return {Object} Current instance of EventEmitter for chaining.
	     */
	    proto.emitEvent = function emitEvent(evt, args) {
	        var listenersMap = this.getListenersAsObject(evt);
	        var listeners;
	        var listener;
	        var i;
	        var key;
	        var response;
	
	        for (key in listenersMap) {
	            if (listenersMap.hasOwnProperty(key)) {
	                listeners = listenersMap[key].slice(0);
	
	                for (i = 0; i < listeners.length; i++) {
	                    // If the listener returns true then it shall be removed from the event
	                    // The function is executed either with a basic call or an apply if there is an args array
	                    listener = listeners[i];
	
	                    if (listener.once === true) {
	                        this.removeListener(evt, listener.listener);
	                    }
	
	                    response = listener.listener.apply(this, args || []);
	
	                    if (response === this._getOnceReturnValue()) {
	                        this.removeListener(evt, listener.listener);
	                    }
	                }
	            }
	        }
	
	        return this;
	    };
	
	    /**
	     * Alias of emitEvent
	     */
	    proto.trigger = alias('emitEvent');
	
	    /**
	     * Subtly different from emitEvent in that it will pass its arguments on to the listeners, as opposed to taking a single array of arguments to pass on.
	     * As with emitEvent, you can pass a regex in place of the event name to emit to all events that match it.
	     *
	     * @param {String|RegExp} evt Name of the event to emit and execute listeners for.
	     * @param {...*} Optional additional arguments to be passed to each listener.
	     * @return {Object} Current instance of EventEmitter for chaining.
	     */
	    proto.emit = function emit(evt) {
	        var args = Array.prototype.slice.call(arguments, 1);
	        return this.emitEvent(evt, args);
	    };
	
	    /**
	     * Sets the current value to check against when executing listeners. If a
	     * listeners return value matches the one set here then it will be removed
	     * after execution. This value defaults to true.
	     *
	     * @param {*} value The new value to check for when executing listeners.
	     * @return {Object} Current instance of EventEmitter for chaining.
	     */
	    proto.setOnceReturnValue = function setOnceReturnValue(value) {
	        this._onceReturnValue = value;
	        return this;
	    };
	
	    /**
	     * Fetches the current value to check against when executing listeners. If
	     * the listeners return value matches this one then it should be removed
	     * automatically. It will return true by default.
	     *
	     * @return {*|Boolean} The current value to check for or the default, true.
	     * @api private
	     */
	    proto._getOnceReturnValue = function _getOnceReturnValue() {
	        if (this.hasOwnProperty('_onceReturnValue')) {
	            return this._onceReturnValue;
	        }
	        else {
	            return true;
	        }
	    };
	
	    /**
	     * Fetches the events object and creates one if required.
	     *
	     * @return {Object} The events storage object.
	     * @api private
	     */
	    proto._getEvents = function _getEvents() {
	        return this._events || (this._events = {});
	    };
	
	    /**
	     * Reverts the global {@link EventEmitter} to its previous value and returns a reference to this version.
	     *
	     * @return {Function} Non conflicting EventEmitter class.
	     */
	    EventEmitter.noConflict = function noConflict() {
	        exports.EventEmitter = originalGlobalValue;
	        return EventEmitter;
	    };
	
	    // Expose the class either via AMD, CommonJS or the global object
	    if (true) {
	        !(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
	            return EventEmitter;
	        }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    }
	    else if (typeof module === 'object' && module.exports){
	        module.exports = EventEmitter;
	    }
	    else {
	        exports.EventEmitter = EventEmitter;
	    }
	}(this || {}));


/***/ }),
/* 1736 */
/***/ (function(module, exports) {

	"use strict",module.exports=function(){function a(a){var b=a.trim(),c=b.length,d=parseInt(b,10),e=0,f,g;if(c===0)return!0;if(isNaN(d)||!/^[0-9]+$/.test(b))return!1;for(var h=c;h>0;h--){f=Math.floor(d)%10,e+=f,h--,d/=10,f=Math.floor(d)%10,g=f*2;switch(g){case 10:g=1;break;case 12:g=3;break;case 14:g=5;break;case 16:g=7;break;case 18:g=9;break;default:g=g}d/=10,e+=g}return e%10===0}return{validate:a}}();

/***/ }),
/* 1737 */
/***/ (function(module, exports) {

	module.exports = {
		"13": {
			"4": "Visa"
		},
		"14": {
			"36": "Diners Club",
			"38": "Carte Blanche",
			"300": "Diners Club",
			"301": "Diners Club",
			"302": "Diners Club",
			"303": "Diners Club",
			"304": "Diners Club",
			"305": "Diners Club"
		},
		"15": {
			"34": "American Express",
			"37": "American Express",
			"1800": "JCB",
			"2014": "EnRoute",
			"2131": "JCB",
			"2149": "EnRoute"
		},
		"16": {
			"3": "JCB",
			"4": "Visa",
			"51": "Master Card",
			"52": "Master Card",
			"53": "Master Card",
			"54": "Master Card",
			"55": "Master Card",
			"6011": "Discover"
		}
	};

/***/ }),
/* 1738 */
/***/ (function(module, exports) {

	module.exports = {
		"47": {
			"from": "61",
			"to": "64",
			"issuer": "TCF Bank Saint Paul MN (USA) Visa Debit Card"
		},
		"200": "MBNA Quantum MasterCard Credit Card",
		"511": {
			"from": "360",
			"to": "499",
			"issuer": "US     Chase Manhattan Bank USA"
		},
		"672": "girocard Debit Cards (Germany)",
		"673": "Debit Cards (the Netherlands)",
		"3713": "American Express Costco Wholesale Card",
		"3715": "American Express Centurion Card",
		"3717": "American Express Platinum Card",
		"3723": "American Express Costco Wholesale Card Platinum",
		"3732": "American Express Blue Airmiles Cash Back Card (Canada)",
		"3733": "American Express Blue Airmiles Card / SPG Credit Card (Canada) / AMEX Aeroplan Plus Platinum (Canada) / Business Platinum Charge Card (Canada)",
		"3735": "American Express Gold Cash Back Card / American Express Platinum Charge Card (Canada)",
		"3742": "Charge Card (UK)",
		"3743": "American Express International Euro Charge Card (UK)",
		"3745": "American Express International Dollar Charge Card (UK)",
		"3750": "American Express Germany Products",
		"3751": "American Express Finland",
		"3752": "American Express Italy",
		"3753": "American Express The Netherlands",
		"3758": "American Express Switzerland corporate card (CH)",
		"3759": "American Express Cathay Pacific Credit Card (Hong Kong)",
		"3760": "American Express Card Australia",
		"3763": "American Express Card (Hong Kong)",
		"3764": "American Express Credit Card",
		"3766": "Platinum Charge Card (Mexico)",
		"3767": "Platinum Credit Card (Mexico)",
		"3770": "Lloyds TSB Airmiles Amex Card (UK)",
		"3772": "Starwood Preferred Guest hotel loyalty credit card",
		"3777": "ANZ American Express Frequent Flyer (Australia) / Saison Card International (Japan)",
		"3797": "Delta Skymiles",
		"4008": {
			"from": "37",
			"to": "39",
			"issuer": "Electron GWK Bank NV"
		},
		"4009": {
			"from": "37",
			"to": "44",
			"issuer": "Bank of China Great Wall Visa"
		},
		"4013": "Visa Debit Card",
		"4016": "Citybank (El Salvador)",
		"4018": "1st Financial Bank USA",
		"4019": "Wachovia Bank Visa",
		"4026": "Nordea Bank, VISA Electron",
		"4028": "HSBC Philippine Airlines Mabuhay Miles",
		"4029": "TD Bank Debit Card",
		"4037": "US Bank Visa (USA)",
		"4060": "CHASE Visa Debit/Credit",
		"4105": {
			"from": "04",
			"to": "06",
			"issuer": "Bank Negara Indonesia (ID) Visa Credit Card"
		},
		"4106": {
			"from": "35",
			"to": "39",
			"issuer": "Columbus Bank &amp; Trust Company, (Aspire Visa Gold Card)"
		},
		"4117": "Bank of America (US; formerly Fleet) VISA Debit Card",
		"4124": "Chase Banking Debit Card",
		"4128": "Citibank (US) Platium Select Dividends VISA Credit Card[citation needed]",
		"4129": {
			"from": "84",
			"to": "85",
			"issuer": "Sovereign Bank - Visa Debit Card"
		},
		"4143": "Capital One - Visa Card",
		"4146": "Urban Trust Bank - Salute Visa Card",
		"4153": "Visa Platinum Japan",
		"4166": "Kotak Mahindra Bank Gold Credit Card",
		"4170": {
			"from": "08",
			"to": "11",
			"issuer": "Bank of America (USA; Formerly Fleet) - Business Visa Car"
		},
		"4172": "Crédit Populaire d'Algérie (CPA), Algeria - Visa Gold Card",
		"4177": "BC &quot;Moldindconbank&quot; S.A (Moldova)- Visa Electron",
		"4185": "Washington Mutual (US) - Visa Card",
		"4197": {
			"from": "73",
			"to": "76",
			"issuer": "Visa Electron"
		},
		"4213": "China Minsheng Bank VISA Debit Card; Landesbank Berlin Xbox Live VISA Prepaid Card (Germany)",
		"4216": "Citizens Bank of Canada/Vancouver City Savings Credit Union Visa Gift Card",
		"4217": {
			"from": "64",
			"to": "66",
			"issuer": "Bank of America VISA Debit Card"
		},
		"4218": "China Minsheng Banking Corporation VISA Credit Card",
		"4238": "Members Credit Union Visa Debit",
		"4239": "St George Bank Visa Debit (Australia)",
		"4241": "Silverton Bank (Gift Card)",
		"4251": "Fidelity Debit Card issued by PNC",
		"4254": {
			"from": "35",
			"to": "36",
			"issuer": "Washington Mutual (formerly Fleet) VISA Debit Card"
		},
		"4256": "Bank of America GM Visa Check Card",
		"4258": {
			"in": [
				"00",
				"02",
				"03",
				"04",
				"08",
				"09",
				"34",
				"38",
				"39"
			],
			"issuer": "M &amp; T Bank Visa Check Card"
		},
		"4259": "Banco BICE (Chile) Gold Visa Credit Card",
		"4264": {
			"in": [
				"10",
				"19",
				"20",
				"28",
				"29",
				"30",
				"38",
				"39",
				"62",
				"64",
				"85"
			],
			"issuer": "Industrial and Commercial Bank of China Visa"
		},
		"4265": {
			"from": "56",
			"to": "58",
			"issuer": "HSBC Bank VISA Credit Card (Australia)"
		},
		"4266": {
			"from": "55",
			"to": "56",
			"issuer": "Chase (formerly Bank One) Visa Credit Card"
		},
		"4276": "Sberbank of Russia",
		"4279": "Sberbank of Russia, Visa Gold",
		"4282": "Landesbank Berlin (Germany) Visa Credit Card",
		"4298": {
			"from": "05",
			"to": "12",
			"issuer": "First National Bank of Omaha and affiliate Visa Debit Card"
		},
		"4301": "Chase Visa",
		"4304": "Barclays Bank Plc",
		"4305": {
			"in": [
				"36",
				"44",
				"46",
				"50",
				"94"
			],
			"issuer": "Bank of America (formerly Fleet) Visa Credit Card"
		},
		"4308": "Macys Visa",
		"4311": "National City Bank Visa Credit Card",
		"4312": "Chase Leisure Rewards Visa Business Debit/Check Card",
		"4313": {
			"in": [
				"10",
				"11",
				"12",
				"13",
				"14",
				"15",
				"17",
				"67"
			],
			"issuer": "Chase (formerly First USA)"
		},
		"4315": "Silverton Bank NA",
		"4318": "S-Bank Visa",
		"4319": {
			"from": "31",
			"to": "32",
			"issuer": "Ulster Bank VISA Debit Card, Republic of Ireland"
		},
		"4321": "Citizens Bank of Canada/Vancouver City Savings Credit Union Visa Gift Card",
		"4323": "Wells Fargo Visa check card",
		"4326": {
			"from": "24",
			"to": "30",
			"issuer": "Bank of America (formerly Fleet National Bank) Visa Check Card, Debit"
		},
		"4333": "Citibank Credit Card (Hong Kong)",
		"4343": "First Interstate Bank Visa Credit Card",
		"4344": "Landesbank Berlin Holding Visa Credit Card (Amazon.de Credit Card)",
		"4349": "Chase Card Services Canada Marriott Rewards Platinum Visa Card",
		"4355": "U.S. Bank Premiere Line Visa Card",
		"4356": {
			"from": "80",
			"to": "90",
			"issuer": "Bank of America, Visa, Platinum Check Card, Debit"
		},
		"4367": "China Construction Bank Credit Card",
		"4377": "Panin Bank - Indonesia, Visa, Platinum Card",
		"4380": "Bank of China Olympics Visa Credit Card",
		"4382": "UOB Campus Visa Debit Card (Singapore)",
		"4384": "HSBC Visa Credit Card (India)",
		"4388": "Capital One Visa Credit Card",
		"4390": "ChequeMax (El Salvador)",
		"4391": "Krungthai Bank - Platinum (Thailand)",
		"4392": {
			"from": "25",
			"to": "27",
			"issuer": "China Merchants Bank Visa Credit Car"
		},
		"4404": "(UBP-php)",
		"4405": "Latvijas Krājbanka (LV)",
		"4408": "Chase (AARP)",
		"4412": "Deutsche Bank (DE) Gold Credit Card",
		"4428": "BECU Visa",
		"4430": "PNC Bank (Debit Card) (former National City Debit)",
		"4432": "U.S. Bank",
		"4435": "Banner Bank VISA (Debit Card)",
		"4436": "PNC Bank Visa Points",
		"4451": "First Tennessee Bank (USA) VISA Debit Card",
		"4458": "Nationwide Building Society (UK) - Plus (interbank network) Cash Card for use with savings accounts",
		"4465": "Wells Fargo (USA) - Visa Credit Card",
		"4470": "M&amp;I Marshall &amp; Ilsley Bank (USA) - Visa debit Card",
		"4479": "TCF Bank Debit Card",
		"4481": "BC Card VISA Check Card",
		"4482": "TD Bank",
		"4488": "Suntrust Bank - Visa Credit Card",
		"4489": "National City Bank Visa Debit Card (Credit Card?)",
		"4490": "Community Trust Bank( Visa Debit Card)",
		"4492": "Vista Federal Credit Union (Walt Disney World) Visa Debit Card",
		"4493": "Nicu Dinu's Bank ( Cernavoda, Romania )",
		"4500": "Canadian Imperial Bank of Commerce (CIBC) Visa &amp; MBNA Quantum Visa Credit Cards",
		"4502": "CIBC VISA",
		"4503": "CIBC VISA",
		"4504": "CIBC VISA",
		"4505": "CIBC VISA",
		"4506": "Marfin Laiki Bank Visa Debit Card",
		"4507": "St George Bank Visa Debit Card",
		"4508": "Visa Electron - Popular Bank (NY) a Branch of Banco Popular Dominicano",
		"4509": "ANZ Bank Visa Credit Card",
		"4510": "Royal Bank of Canada (CA) - Visa",
		"4511": "Seylan Bank, Sri Lanka",
		"4512": "Royal Bank of Canada (CA) - Visa",
		"4513": "Bancolombia (CB)",
		"4514": "Royal Bank of Canada RBC AVION Visa (Platinum/Infinite)",
		"4516": "RBC Banque Royale VISA BUSINESS (Affaires) - VISA",
		"4519": "Royal Bank of Canada (CA) - Client Card (ATM/INTERAC)",
		"4520": "TD Bank CAD VISA",
		"4529": "MetaBank Visa",
		"4530": "VISA Desjardins Group",
		"4535": "Scotiabank - Visa Card",
		"4536": "Scotiabank - Interac Debit Card",
		"4537": "Scotiabank - Visa Card",
		"4538": "Scotiabank - Visa Card",
		"4540": "Carte d'accès Desjardins / VISA Desjardins",
		"4541": "Standard Chartered Manhattan Platinum VISA (India)",
		"4542": "Rakuten Bank - Japan",
		"4543": "Visa Debit UK",
		"4544": "Banque Laurentienne du Canada / Laurentian Bank of Canada (CA) - Visa",
		"4545": "BANESCO (former BancUnion Visa) - Venezuela.",
		"4549": "Banco Popular de Puerto Rico - Visa credit and debit cards",
		"4551": "TD Bank/General Motors Corporation GM CAD VISA",
		"4552": "Cooperative Bank (UK)",
		"4553": "Wing Hang Bank Credit Card (Hong Kong)",
		"4555": "Bank of Ceylon VISA Credit Card (UK)",
		"4556": "Citibank Visa Vodafone (Greece)",
		"4557": "Debit Card Bank of credit (PE)",
		"4559": "CHASE (formerly Washington Mutual/Providian) Platinum VISA Credit Card",
		"4560": "ANZ Visa Debit Card",
		"4563": "Citibank Malaysia (MY) - Visa Credit Card",
		"4565": "ABSA VISA",
		"4568": "Berliner Bank (DE) - Visa Debit Card",
		"4569": "Skandiabanken VISA Debit Card (NO)",
		"4570": "DZ Bank VISA Credit Card (DE)",
		"4571": "All Danish VISA-cards (Visa/Dankort)",
		"4579": "KB Card VISA Gold Card",
		"4585": "HSBC Bank Australia VISA Debit Card",
		"4587": "Peoples Trust Visa Gift Card",
		"4599": "Caja Madrid (ES",
		"4608": "Suncoast Schools Federal Credit Union",
		"4715": "Wachovia VISA",
		"4718": "Target Corporation VISA Gift Card",
		"4720": "HSBC VISA (Platinum?), Sri Lanka",
		"4736": "[GE Money Bank] Walmart Prepaid Visa Debit Card, USA",
		"4744": "Bank of America Visa Debit",
		"4751": {
			"from": "27",
			"to": "30",
			"issuer": "Natwest Visa Debit"
		},
		"4758": "Oregon Community Credit Union",
		"4760": "Bank Niaga (Indonesia) Visa Debit Card",
		"4773": "Siam Commercial Bank - platinum (Thailand)",
		"4779": "Sainsbury's Bank (UK) - Visa Debit Card",
		"4797": "SEB bankas Visa Debit Card (Lithuania)",
		"4798": "US Bank Visa Select Rewards Business Platinum",
		"4800": "MBNA Gold Visa Credit Card",
		"4807": "M&amp;I Visa Credit Card",
		"4809": "Charles Schwab Bank - Visa Platinum Check Card",
		"4820": "Wings Financial FCU Credit Card (also Metro Community FCU)",
		"4824": "Wirecard Bank Visa Card",
		"4828": "Wachovia Bank (US) - Visa Debit Card",
		"4841": "Old National Bank Commercial Debit Card",
		"4842": "Maybank-issued Visa Credit Card (Malaysia)",
		"4843": "Digital FCU Visa Gold Credit Card",
		"4854": "Washington Mutual (US) - Visa Debit Card",
		"4861": "Wings Financial FCU Check Card",
		"4862": "Capital One Visa Credit Card",
		"4867": "JP Morgan Chase Bank (US) - Visa Card",
		"4868": "Wells Fargo (US) - Bank N.A. Check Card",
		"4873": "Capital One Orbitz Visa Platinum Credit Card",
		"4888": "Bank of America (US) - Visa Credit Card",
		"4890": "QIWI Bank - Visa Virtual, Visa Card (Virtual Visa Prepaid) and Visa Plastic (Visa Prepaid)",
		"4892": "[Columbus Bank and Trust Company] Green dot NASCAR Debit Visa Prepaid card",
		"4893": "Nationwide Building Society (UK) Visa Select Credit Card",
		"4903": "Switch (Debit Card)",
		"4904": "Banner Bank VISA (Credit)",
		"4905": "Switch (Debit Card)",
		"4906": "BC VISA Credit Card (Korea)",
		"4907": "Citibank Credit card (Japan)",
		"4909": "Northern Rock - Building Society - Vida Debit Card (UK)",
		"4910": "HSBC Bank VISA Credit Card (Sri Lanka).",
		"4911": "Switch (Debit Card)",
		"4912": "HSBC UAE",
		"4913": "Visa Electron",
		"4914": "Banrisul Visa",
		"4915": "Republic Bank Limited VISA Credit Card (Trinidad &amp; Tobago)",
		"4917": "Visa Electron",
		"4918": "Caja Madrid VISA Business Credit Card (Spain)",
		"4919": "Charles Schwab Bank VISA Check Card",
		"4920": "Luottokunta issued VISA (Finland); Citibank UAE issued Visa Credit Card",
		"4921": "Lloyds TSB Visa Debit Card",
		"4925": "Visa Debit Card (Norway)",
		"4929": "Visa Debit Card UK",
		"4931": "Visa Citi AA - American Airlines (Dominican Republic)",
		"4935": "Credito Siciliano Visa Electron (Italy)",
		"4936": "Switch (Debit Card)",
		"4937": "Standard Chartered Bank UAE issued Visa credit card",
		"4960": "Emporiki Bank Visa Credit Card (Greece)",
		"4974": "BNP Paribas (France)",
		"4978": "Caisse d'Epargne VISA Credit Card (France)",
		"4984": "Banco do Brasil Ourocard Visa",
		"5100": {
			"from": "60",
			"to": "62",
			"issuer": "ES     SEMP"
		},
		"5112": {
			"in": [
				"24",
				"27",
				"28",
				"88",
				"93",
				"94",
				"96",
				"98"
			],
			"issuer": "US     Chase Manhattan Bank USA"
		},
		"5115": {
			"in": [
				"14",
				"28",
				"30",
				"36",
				"48",
				"53",
				"55",
				"59",
				"90"
			],
			"issuer": "US     Chase Manhattan Bank USA"
		},
		"5116": {
			"in": [
				"14",
				"20",
				"22",
				"42",
				"47",
				"50",
				"54",
				"56",
				"61",
				"71"
			],
			"issuer": "US     Chase Manhattan Bank USA"
		},
		"5117": {
			"in": [
				"12",
				"16",
				"21",
				"26",
				"30",
				"40",
				"56",
				"60",
				"88",
				"96",
				"99"
			],
			"issuer": "US     Chase Manhattan Bank USA"
		},
		"5118": {
			"from": "87",
			"to": "99",
			"issuer": "US     Chase Manhattan Bank USA"
		},
		"5119": {
			"in": [
				"00",
				"01",
				"02",
				"04",
				"10",
				"11",
				"13",
				"16",
				"17",
				"20",
				"21",
				"32",
				"34",
				"37",
				"38",
				"39",
				"42",
				"53",
				"58",
				"64",
				"67",
				"72",
				"74",
				"81",
				"87",
				"88",
				"95",
				"98",
				"99"
			],
			"issuer": "US     Chase Manhattan Bank USA"
		},
		"5120": {
			"from": "25",
			"to": "27",
			"issuer": "US     Orchard Bank     Credit Card issued by HSBC (previously Household Bank"
		},
		"5121": {
			"from": "10",
			"to": "11",
			"issuer": "US     Western States BankCard Association"
		},
		"5122": "First Gulf Bank",
		"5123": {
			"in": [
				"44",
				"56",
				"69",
				"75",
				"87",
				"88",
				"90"
			],
			"issuer": "US     Western States BankCard Association"
		},
		"5125": {
			"from": "51",
			"to": "55",
			"issuer": "ES     Europay 6000"
		},
		"5130": "Banque Postale (France)",
		"5131": {
			"from": "44",
			"to": "99",
			"issuer": "FR     Europay France Advanzia Bank"
		},
		"5132": "Crédit Mutuel MasterCard Credit Card (France)",
		"5133": {
			"in": [
				"00",
				"10",
				"20",
				"50"
			],
			"issuer": "FR     Europay France"
		},
		"5134": {
			"in": [
				"00",
				"11",
				"12",
				"13"
			],
			"issuer": "FR     Europay France"
		},
		"5135": "BRED Banque Populaire MasterCard Credit Card",
		"5136": {
			"in": [
				"55",
				"98",
				"99"
			],
			"issuer": "FR     Europay France"
		},
		"5137": {
			"in": [
				"00",
				"04",
				"07",
				"08",
				"10",
				"11",
				"12",
				"13",
				"14"
			],
			"issuer": "FR     Europay France"
		},
		"5138": {
			"from": "00",
			"to": "35",
			"issuer": "FR     Europay France"
		},
		"5140": {
			"from": "19",
			"to": "20",
			"issuer": "US     Wells Fargo"
		},
		"5141": "Banco Popular North America Mastercard Debit Card",
		"5148": "US Airways Dividend Miles Platinum MasterCard",
		"5150": "MetaBank MasterCard FSA debit card (issued on behalf of third-party administrators)",
		"5151": "OboPay Prepaid Debit Card Issued By First Premier",
		"5155": "Orchard Bank issued by HSBC",
		"5156": "BestBuy MasterCard issued by HSBC (previously Household Bank)",
		"5163": {
			"in": [
				"39",
				"40",
				"45",
				"48",
				"49",
				"50",
				"55",
				"59",
				"60",
				"65",
				"69",
				"70",
				"75",
				"79",
				"80",
				"85",
				"89"
			],
			"issuer": "AU     WestPac Banking Corporation"
		},
		"5176": "China Minsheng Bank MasterCard Credit Card",
		"5177": "BANAMEX Debit Card",
		"5179": "Bank Atlantic Mastercard Debit Card",
		"5182": "Banco Nacional de Costa Rica Servibanca Debit Card",
		"5185": "HONGKONG AND SHANGHAI BANKING CORPORATION, LTD., THE MasterCard (HK)",
		"5187": "China Merchants Bank MasterCard Credit Card",
		"5191": {
			"from": "80",
			"to": "83",
			"issuer": "CA     Bank of Montreal"
		},
		"5192": {
			"from": "93",
			"to": "94",
			"issuer": "CA     Bank of Montreal"
		},
		"5193": {
			"from": "93",
			"to": "95",
			"issuer": "CA     Bank of Montreal"
		},
		"5194": {
			"from": "93",
			"to": "94",
			"issuer": "CA     Bank of Montreal"
		},
		"5195": {
			"from": "40",
			"to": "44",
			"issuer": "CA     Bank of Montreal"
		},
		"5217": "Commonwealth Bank of Australia Debit MasterCard",
		"5221": "MasterCard Credit Cards in South Africa",
		"5228": "Presidents Choice MasterCard Credit Card",
		"5232": "Sparkasse Germany MasterCard Credit Card",
		"5234": "Lufthansa Miles &amp; More MasterCard Credit Card",
		"5243": "Hudson's Bay Company MasterCard Credit Card (Canada)",
		"5255": "Mastercard CartaSi (Italy)",
		"5256": "Sparda-Bank MasterCard Charge Card (Germany)",
		"5258": "Mastercard National Bank of Canada (Canada)",
		"5259": "Canadian Tire Bank Cash Advantage Platinum MasterCard",
		"5262": "Citibank MasterCard Debit Card",
		"5264": "Bank Negara Indonesia MasterCard Debit Card",
		"5268": "CitiBank Platinum Enrich (Canada) MasterCard Credit Card",
		"5275": "Sampo Bank (Finland) MasterCard Debit Card",
		"5286": "Virgin Money South Africa (Virtual Bank; Operates partially on ABSA's system)",
		"5287": "Washington Mutual Bank Debit card",
		"5289": "ANZ (Previously RBS and ABN AMRO) Switch Platinum MasterCard Credit Card (Singapore)",
		"5301": "BarclayCard Mastercards.",
		"5303": "BAC San José (Costa Rica) Debit card",
		"5316": "CUETS Financial Canada MasterCard Credit Card",
		"5317": "CUETS Financial Canada Global Payment MasterCard",
		"5322": "Washington Mutual Business Debit card",
		"5327": "Dexia banka Slovensko, a.s.; MasterCard credit PayPass",
		"5329": "MBNA Preferred MasterCard Credit Card",
		"5396": "Saks Fifth Avenue World Elite MasterCard issued by HSBC",
		"5399": "ICICI Bank MasterCard debit Card",
		"5401": "Bank of America (formerly MBNA) MasterCard Gold Credit Card",
		"5403": "Citibank MasterCard Credit Card (&quot;Virtual Card&quot; number)",
		"5404": "Lloyds TSB Bank MasterCard Credit Card",
		"5406": "Bancolombia MasterCard Credit Card (Colombia)",
		"5407": "HSBC Bank GM Card",
		"5409": "HSBC Bank, Union Bank of California Pay Pass debit card",
		"5412": "HSBC Malaysia issued Mastercard",
		"5416": "Washington Mutual (formerly Providian) Platinum MasterCard Credit Card",
		"5417": "Chase Bank",
		"5420": "MasterCard issued by USAA, Mastercard issued by John Lewis (Partnership Card)",
		"5424": "Citibank MasterCard Credit Card (Dividend, Diamond and others)",
		"5425": "Barclaycard MasterCard Credit Card (Germany)",
		"5426": "Alberta Treasury Branch",
		"5430": "Stockmann Department Store Mastercard, issued by Nordea (Finland)",
		"5434": "MasterCard credit cards from UK and Irish banks",
		"5437": "St George Bank Credit Card (Australia)",
		"5438": "USAA Federal Savings Bank",
		"5440": "Mastercard from MBF Malaysia",
		"5442": "HSBC Mastercard Credit Card (Singapore)",
		"5443": "HSBC MasterCard Debit Card with PayPass (USA)",
		"5444": "BHW MasterCard Charge Card (Germany)",
		"5446": "Canadian Tire MasterCard Credit Card",
		"5451": "NatWest Mastercard Credit Card",
		"5452": "MBNA Canada Mastercard",
		"5455": "BancorpSouth Mastercard MasterMoney Debit Card",
		"5457": "Dexia banka Slovensko, a.s.; Mastercard Gold with PayPass technology",
		"5458": "USAA Credit Card",
		"5459": "Harris Bank Debit Card",
		"5460": "Berliner Bank (Germany),Mint MasterCard Credit Card and Capital One UK",
		"5466": "Citibank, MBNA &amp; Chase World MasterCard Credit Cards,",
		"5469": "Sberbank of Russia",
		"5471": "Davivienda MasterCard Credit Card (Colombia)",
		"5474": "Wells Fargo Bank BusinessLine credit card (US)",
		"5483": "HypoVereinsbank (Germany)",
		"5490": "MBNA &amp; Chase Platinum MasterCard Credit Cards",
		"5491": "AT&amp;T Universal MasterCard Credit Card, now part of Citibank, also MBNA MasterCard Credit Cards",
		"5520": "DBS POSB Everyday Platinum Mastercard (Singapore) / Bank of Scotland Private Banking Platinum MasterCard / RBS World Mastercard",
		"5521": "BC Platinum Mastercard",
		"5522": "NatWest Platinum Mastercard",
		"5523": "MBNA Smart Cash World MasterCard (Canada)",
		"5524": "Bank Of Montreal World Elite MasterCard (Canada)",
		"5528": "Diner's Club",
		"5573": "Metro Bank MasterCard Debit Card",
		"5588": "[Citibank] MasterCard Credit Card &quot;Business&quot;",
		"5898": "All Korean Banks ATM/DEBIT Card",
		"5899": "MCB",
		"6011": "Discover Card Credit Card",
		"6012": "BANESCO (former BancUnion) Maestro Debit card",
		"6016": "Bancolombia",
		"6019": "Brandsmart USA Credit Card",
		"6035": "Citibank (Home Depot) Card",
		"6041": "Walmart Canada Gift Card",
		"6044": "Ikea Credit Card (issued by Citi Cards Canada)",
		"6045": "Lowes (Canada) (issued by GE Money Canada)",
		"6051": "Starbucks Card - USA &amp; Canada",
		"6060": "Shinhan Card",
		"6225": "Shanghai Pudong Development Bank UnionPay",
		"6253": "BC Card CUP Credit Card[6]",
		"6277": "iCard (issued by ICICI Bank Canada)",
		"6333": {
			"from": "00",
			"to": "49",
			"issuer": "Maestro Cards"
		},
		"6334": {
			"from": "50",
			"to": "99",
			"issuer": "Solo Cards"
		},
		"6360": "BC Card",
		"6541": "KR     BC Card     BC Global",
		"6556": "KR     BC Card     BC Global",
		"6660": "Citibank ATM Card (Hong Kong)",
		"6709": "[[Laser (debit card)|Laser Debit Card] IRL]",
		"6718": "RBS Cashline ATM Cards, Cirrus Branded",
		"6759": "VARIOUS BANKS (UK) - Maestro (formerly Switch) debit cards",
		"6761": "Maestro debit card",
		"6767": "VARIOUS BANKS (UK) - Solo; xx indicates the bank in the UK national sort code system.",
		"6771": "VARIOUS BANKS - Laser debit card",
		"7001": "Best Buy Credit Card (private-label card issued by HSBC Bank Nevada)",
		"7021": "Best Buy Credit Card (private-label card issued by HSBC Bank Nevada)",
		"7069": "Petro-Canada (Petro-Points loyalty program)",
		"9280": "BSW Bonus Card (www.bsw.de)",
		"41974": {
			"from": "0",
			"to": "1",
			"issuer": "Visa Electron"
		},
		"51185": "US     Chase Manhattan Bank USA",
		"51639": "Westpac Australia Classic MasterCard",
		"54896": "Industrial and Commercial Bank of China (ICBC) Peony American Express Gold Card China",
		"63191": "British Home Stores - Bhs credit card",
		"63563": "Ventura",
		"337941": "Bank Millennium American Express Gold Credit Card (Poland)",
		"370244": "BANESCO (BancUnion) American Express Gold - Venezuela.",
		"370246": "Industrial and Commercial Bank of China (ICBC) Peony American Express Card (PRC)",
		"370285": "brooklyn Merchants Bank American Express Green Card",
		"370286": "China Merchants Bank American Express Gold Card",
		"372301": "American Express Gift Card (Canada)",
		"372395": "Blue Cash American Express Card",
		"372550": "Starwood Preferred Guest hotel loyalty credit card",
		"372734": "Blue for Business credit (small business)",
		"372888": "American Express Gold Card (USA)",
		"374288": "Centurion Charge Card (UK)",
		"374289": "Platinum Charge Card (UK)",
		"374328": "American Express Gift Card (Only at US merchants)",
		"374345": "Citi American Express Cards (USA)",
		"374350": "Citibank (American Airlines) American Express credit card",
		"374614": "British Airways American Express Premium Plus Card",
		"374622": "American Express Optima Credit Card (France)",
		"374660": "American Express BMW Card",
		"374661": "American Express BMW Card",
		"374671": "Blue American Express Card",
		"374691": "Platinum Credit Card (UK)",
		"374693": "Platinum Credit Card (UK)",
		"374801": "Platinum Charge Card (Finland)",
		"374970": "Air France KLM Flying Blue co-branded Gold Charge Card (France)",
		"374996": "Corporate Card (France)",
		"375622": "Garanti Bank American Express Green Card (Turkey)",
		"375628": "Garanti Bank American Express Shop&amp;Miles co-branded Gold Card (Turkey)",
		"375790": "American Express Sweden corporate card (SE)",
		"376211": "Singapore Airlines Krisflyer American Express Gold Credit Card (Singapore)",
		"376966": "China CITIC Bank American Express Card (PRC)",
		"376968": "China CITIC Bank American Express Gold Card (PRC)",
		"377032": "American Express Corp-Banca / Banco Occidental de Descuento (Venezuela)",
		"377064": "Lloyds TSB Airmiles Premier Amex Card (UK)",
		"377100": "American Express Platinum Credit Card (Hong Kong)",
		"377311": "MBNA Europe Bank (Bank of America) Virgin Atlantic Credit Card (UK)",
		"377441": "American Express Black Card (New Zealand)",
		"377445": "BMW American Express Card (New Zealand)",
		"377481": "American Express (Macy's)",
		"377662": "Swiss International Airlines Miles &amp; More American Express Gold (CH)",
		"377750": "American Express Platinum LifeMiles Card - Banco Internacional del Perú (Interbank)",
		"377753": "American Express Gold credit card - Banco Internacional del Perú (Interbank)",
		"377850": "Westpac American Express Card (Australia)",
		"377852": "Westpac American Express Platinum Card (Australia)",
		"377945": "American Express Corporate (Hungary)",
		"377946": "American Express Corporate (Poland)",
		"379108": "British Airways American Express Credit Card (UK)",
		"379186": "Maybank American Express Credit Card (MY)",
		"379196": "Blue Sky American Express Credit Card (UK)",
		"379464": "Corporate card (US)",
		"400115": "Visa Electron Barclays",
		"400121": "Electron IRL",
		"400344": "CapitalOne Platinum",
		"400610": "META Bank, (Rewards 660 Visa) Credit Limit Between $200 &amp; $2000",
		"400937": "CN BOC Great Wall International Card Corporate",
		"400938": "CN BOC Great Wall International Card Corporate Gold",
		"400941": "CN BOC Great Wall International Card",
		"400942": "CN BOC Great Wall International Card Gold",
		"400944": "Associated Bank (Citibank (South Dakota) N.A.)",
		"401106": "McCoy Federal Credit Union VISA debit card",
		"401171": "Delta Community Credit Union Visa",
		"401180": "Suntrust Bank Debit Card",
		"401343": "Tesco Bank Bonus Visa",
		"401344": "Tesco Bank Clubcard Visa",
		"401612": "Banco Tequendama Visa CREDIT PLATINUM CARD (Colombia)",
		"401773": "Electron IRL",
		"401795": "NAB Visa Debit Card (Australia)",
		"402360": "Visa Electron from Poste Italiane (Italy) brand name &quot;PostePay&quot;, Max. balance 3000",
		"402802": "Handelsbanken Visa Credit/Debit Card",
		"403897": "Avangard Bank, Visa Credit/Debit Card",
		"404137": "Greater Building Society Visa Debit Card (Australia)",
		"404146": "National Development Bank Visa Classic (Srilanka)",
		"404527": "Cabela's World's Foremost Bank",
		"404586": "Open Bank, Russia - Visa Platinum Transaero Card",
		"404645": "US Bank Visa Debit Card (USA)",
		"405670": "BRE Bank (mBank) Visa Electron Debit Card (Poland)",
		"406366": "Guangdong Development Bank China Southern Visa UnionPay Duo Credit Card",
		"406742": "Entropay Virtual Visa Card USD",
		"406774": "Visa Platinum credit card, Banco Interamericano de Finanzas - Interamerican finances bank - BIF",
		"407220": "ANZ Frequent Flyer Gold Visa Card",
		"407441": "CitiBank Patriot Memory Promo Debit Card",
		"407444": "CSL Plasma and Other Various Plasma Donation Centers",
		"409311": "Branch Banking &amp; Trust Classic Credit Card USA",
		"409617": "First Czech-Russian bank, Russia, Visa Gold Czech Airlines",
		"410654": "Ithala Limited (South Africa) VISA Electron",
		"410894": "Branch Banking and Trust (BB&amp;T)",
		"410897": "The Golden 1 Credit Union (US) Visa Classic",
		"411016": "BANESCO (former BancUnion Visa). Visa Platinum - Venezuela.",
		"411298": "Lloyds TSB (UK) - Visa Credit Card",
		"411636": "Irish Life &amp; Permanent PLC Visa Debit Classic",
		"411773": "Bank of America (US; formerly Fleet) Temporary VISA Debit Card (Embossed name - Preferred Customer)",
		"411911": "DBS (SG) - Live Fresh Platinum Visa Credit Card",
		"411945": "Masterbank (Russia), Visa Infinite",
		"411986": "Banca Transilvania - Visa Credit Card",
		"412134": "Pennsylvania State Employees Credit Union (PSECU) Credit Card",
		"412266": "TD Bank Gift Card",
		"412983": "MBNA (Europe) University of Cambridge VISA Credit Card",
		"413433": "Sovereign Bank Business Check Card",
		"414049": "Banca Transilvania - Visa Electron",
		"414051": "Bank of Georgia (GE) - Visa Orange Debit Card",
		"414099": "Budapest Bank, Visa Electron, Hungary",
		"414588": "Guaranty Bank Visa Debit card USA",
		"414711": "Citibank (American Airlines) Visa Signature Credit Card",
		"414716": "Bank of America (US) - Alaska Airlines Signature Visa Credit Card",
		"414720": "Chase (US, formerly Bank One) - Chase Sapphire or Holiday Inn Priority Club Rewards Visa Credit Card",
		"414983": "Plumas Bank (California, US) - Visa Check Card",
		"415045": "Kredyt Bank Visa Business Electron (Poland)",
		"415055": "Le Crédit Lyonnais, France - Visa Cleo",
		"415231": "Bancomer Debit Card",
		"415461": "Raiffeisen Bank (CZ) - Visa Debit",
		"415874": "TD Bank (USA)",
		"415929": "Cahoot (UK) - Visa Credit Card",
		"415981": "Sovereign Bank - Visa Debit Card",
		"416039": "ING Bank Śląski (PL) - Visa Electron",
		"416451": "Fortis Bank (PL) - Visa Electron",
		"416724": "Wells Fargo Bank Debit Visa USA",
		"416896": "Inteligo (PL) - Visa Electron",
		"417935": "Visa Electron",
		"418122": "National Development Bank Visa prepaid (Srilanka)",
		"418221": "TD Bank in the United States",
		"418224": "New Zealand Post (NZ) - Visa Loaded Card",
		"418236": "Korea Exchange Bank - KEB VISA Signature Card",
		"418238": "UOB (SG) - Visa Platinum Debit Card",
		"418307": "Green Dot Prepaid Visa debit card",
		"419661": "DongA Bank Vietnam - Visa credit Card",
		"420567": "Volkswagen Bank direct VISA Credit Card (Germany) 67",
		"420571": "Forex Bank Visa Credit Card Sweden",
		"420719": "US Bank debit card.",
		"420767": "Chase VISA debit card",
		"420796": "Banque Invik Everywhere Money prepaid debit Visa Electron card (LU/SE)",
		"420984": "Bank of Lee's Summit, VISA Debit",
		"421323": "ICICI Bank visa Gold Debit/ATM Card (India)",
		"421324": "IndusInd Bank Debit Card (India)",
		"421325": "UTI Bank Prepaid Visa Card",
		"421337": "Allahabad Bank Debit Card, India",
		"421338": "Chequera Debit Card City (El Salvador)",
		"421355": "Interbank - Banco Internacional del Peru Debit Card (Peru)",
		"421402": "Citizens Bank of Canada/Vancouver City Savings Credit Union Visa Gift Card",
		"421458": "Canara Bank",
		"421494": "Asia Commercial Bank Vietnam - Visa Debit Card",
		"421630": "ICICI Bank Visa Gold debit/ATM Card (India)",
		"421689": "Commercial Bank, Sri Lanka - VISA Debit (Electronic)",
		"422050": "SAMBIL MALL Servitebca Visa Prepaid Card (Issued by Venezolano de Credito).",
		"422189": "GE Money (PL) - Visa credit card",
		"422287": "Raiffeisen bank (Russia), Visa Classic",
		"422594": "United Bank for Africa. Visa Classic Dual Currency Debit Card",
		"422629": "HSBC Bank (Turkey) VISA Credit Card",
		"422695": "Chase Bank (British Airways) Visa Signature Credit Card",
		"422727": "Citibank Korea BC VISA Check Card",
		"422793": "o2 money card (managed by Natwest) Prepay card",
		"423347": "Patelco Credit Union",
		"423966": "Suffolk County National Bank Visa Debit (NY)",
		"424201": "Landesbank Baden-Württemberg Payback Premium",
		"424327": "Skandiabanken Visa Credit Card (NO)",
		"424339": "Skandiabanken Betal &amp; Kreditkort Visa credit card (SE)",
		"424631": "Chase Bank USA VISA Business Credit Card",
		"424671": "Ing Bank Slaski SA (Poland)",
		"425522": "Columbus Bank and Trust, AVS=866-443-6669",
		"425907": "Wells Fargo Business Platinum Check Visa Card",
		"425914": "Compass Bank, Visa, Business Platinum Check Card, Debit",
		"426354": "Comdirect Bank (Germany) Visa Credit Card, Natwest UK Visa",
		"426376": "Standard Chartered Bank Bangladesh",
		"426393": "Natwest UK Visa Credit card",
		"426488": "Code Credit Union (Dayton, Ohio)",
		"426501": "HHonors Platinum Visa Credit Card (Barclaycard)",
		"426510": "Solutions Finance Credit Card (Barclaycard)",
		"426534": "Citibank Australia Visa Platinum Card",
		"426569": "CitiBank Platinum Visa Credit Card (Singapore)",
		"426588": "UOB Platinum Visa Credit Card (Singapore)",
		"426684": "Chase +1 Student Visa Card (2008)",
		"426698": "First Command Financial Planning, Inc.",
		"427208": "Mercedes Benz Bank",
		"427229": "VTB24 (Russia), Visa Classic (Un)embossed",
		"427342": "Lloyds TSB Business Debit Card",
		"427557": "RBC Centura Bank Visa Debit Card (Pocket Check Card)",
		"427760": "Citibank, Russia",
		"428208": "Chase Debit Visa",
		"428333": "Prezzy card (New Zealand Post)",
		"428418": "ASB Bank (New Zealand) Visa Debit Card",
		"428434": "Citizens Bank of Canada (Canada) Prepaid Visa Gift Card",
		"428454": "Kiwibank (New Zealand) Visa Debit Card",
		"429158": "Bank of Moscow (Russia) Visa Electron Social Security Card",
		"429420": "Digital Federal Credit Union (DCU) Visa Check Card",
		"429475": "Regions Bank Visa Debit Card",
		"430092": "Standard Chartered Platinum VISA Credit Card (Singapore)",
		"430252": "Bank of Cyprus Greece Prepaid Visa",
		"430552": "Summit Federal Credit Union Visa Debit Card",
		"430567": "Tesco Bank Classic Visa",
		"430586": "Pennsylvania State Employees' Credit Union Check Card",
		"430605": "Affinity Plus Federal Credit Union Debit Card (USA)",
		"431170": "Rizal Commercial Banking Corporation Visa Credit Card (Philippines)",
		"431239": "Citibank Australia VISA Debit Card",
		"431261": "IWBank Visa",
		"431262": "IWBank Visa Electron",
		"431732": "Plains Commerce, (Total Visa), Small Credit Limit, Credit Repair Card",
		"431930": "Halifax Ireland VISA Debit card",
		"431935": "Permanent TSB VISA Debit Card, Republic of Ireland",
		"432158": "BA Finance/Credit Europe bank (Russia), Visa Classic &quot;Auchan&quot; card",
		"432732": "Metabank Debit Card",
		"432845": "Sovereign Bank Check Card",
		"432901": "BRE Bank (MultiBank) Visa Classic Aquarius PayWawe Debit Card (Poland)",
		"432919": "Cartasi Eura Visa Electron (Italy)",
		"432937": "BRE Bank (MultiBank) Visa Electron Aquarius Debit Card (Poland)",
		"432995": "TCF Visa Debit Card (USA)",
		"433445": "BBVA Puerto Rico - Visa Electron",
		"433507": "MBNA - Visa",
		"433948": "Barclays &amp; Times Card Visa Gold Credit Card (India)",
		"433950": "Barclays &amp; Yatra.com Platinum Credit Card (India)",
		"433991": "Palm Desert National Bank as Cingular Wireless' rebate debit card",
		"434254": "Best Bank",
		"434256": "Wells Fargo Debit",
		"434257": "Wells Fargo Debit",
		"435225": "Nordea Bank Visa Electron Debit Card (Poland)",
		"435744": "ShenZhen Development Bank, Visa, Classic, Credit (China)",
		"435760": "Compass Bank, Visa, Business Check Card, Debit",
		"436338": "Landesbank Berlin AG (ADAC VISA Gold)",
		"436618": "U.S. Bank Visa debit card",
		"436742": "China Construction Bank Debit Card",
		"436773": "National Bank of New Zealand Visa Credit Card",
		"437737": "Barclay Debit Card (India)",
		"438088": "Bank of China Visa Unionpay Gold Credit Card",
		"438617": "China Construction Bank (Asia) Finance Credit Card",
		"438676": "Shinhan Card VISA Platinum Card",
		"438755": "San Diego County Credit Union Visa Card",
		"438857": "Chase Bank (United Airlines) Visa credit card",
		"440210": "Citibank Handlowy (PL) - Visa Silver",
		"440211": "Citibank Handlowy (PL) - Visa Gold",
		"440260": "Allied Irish Banks &quot;Click&quot; Visa Card",
		"440319": "Schwab Bank Invest First Visa Signature",
		"440626": "Slovenská sporiteľňa Visa Electron",
		"440752": "ČSOB (CZ) - Visa Classic",
		"440753": "ČSOB (CZ) - Visa Electron",
		"441669": "MetaBank Visa Gift Card",
		"441712": "First USA Bank, N.A.",
		"441822": "1st National Bank of Omaha",
		"442162": "MBNA EUROPE BANK LIMITED Classic Visa Credit Card",
		"442518": "Wells Fargo Platinum Visa",
		"442790": "Citizens Bank (RBS) Platinum Visa Debit Card",
		"443233": "Shinhan Card (former LG Card)",
		"443438": "Credit Union Australia - Visa Debit Card",
		"443464": "Five Star Bank",
		"444238": "SMP bank (Russia) Visa Classic",
		"444400": "First US Bank",
		"444512": "Fifth Third Bank",
		"445093": "HSBC Vietnam - VISA Credit Card",
		"445094": "HSBC Vietnam - VISA Credit Card",
		"445479": "Keytrade Bank Visa Classic Credit Card",
		"445480": "Keytrade Bank Visa Gold Credit Card",
		"446053": "US Bank Visa Classic Debit Card USA",
		"446153": "BRE Bank (CZ) - mBank Visa Gold Credit Card",
		"446155": "BRE Bank (CZ) - mBank Visa Electron",
		"446157": "BRE Bank (CZ) - mBank Visa Classic Debit Card",
		"446158": "BRE Bank (PL) - mBank Visa Electron",
		"446261": "Lloyds TSB (UK) - Visa Debit Card (for Personal and Business Accounts)",
		"446268": "Cahoot (UK) - Visa Debit",
		"446272": "Lloyds TSB (UK) - Platinum Account Visa Debit Card",
		"446274": "Lloyds TSB (UK) - Premier Visa Debit Card (with £250 Cheque guarantee limit)",
		"446277": "Abbey (bank) - Business Banking Visa Debit Card",
		"446278": "Halifax (UK) - Visa debit card",
		"446279": "Bank of Scotland (UK) - Visa debit card",
		"446291": "Halifax (UK) - Visa Gold debit card",
		"447320": "BC VISA Check Card issued by Woori Bank",
		"447452": "Union Bank &amp; Trust Company Visa debit card",
		"447692": "HSBC India Visa Silver Credit Card (India)",
		"447747": "ICICI Bank Visa Gold Credit Card (India)",
		"447817": "Promsvyazbank, Russia - Visa Gold Transaero Card",
		"447935": "National City Bank Visa Debit Card",
		"447995": "Old Navy Visa Credit Card",
		"448156": "Chase Bank / MyECount.com Sprint Wireless' rebate debit card",
		"448336": "BRE Bank (PL) - mBank Visa Classic",
		"448360": "Getin Noble Bank Visa Electron Debit Card (OpenFinance.PL) (Poland)",
		"448445": "Lloyds Bank - Visa Credit Card",
		"449352": "Nationwide Building Society Visa Credit Card",
		"449364": "Valley Bank",
		"449533": "Bank of America (USA), National Association - Classic, Debit, Visa",
		"450003": "CIBC Infinite Aerogold (VISA credit card)",
		"450060": "CIBC Aerogold (VISA credit card)",
		"450065": "CIBC Platinum (VISA credit card)",
		"450405": "Æon Credit Service Credit Card",
		"450605": "Bendigo Bank Visa Blue Debit Card",
		"450823": "Lloyds TSB VISA",
		"450875": "Co-operative Bank Visa Debit Card (formerly Visa Electron)",
		"450878": "Banco de Chile Visa Credit Card",
		"451291": "Bank of China - Visa Credit Card",
		"451503": "Royal Bank of Canada (CA) - VISA",
		"451834": "DBS Bank Credit Card (Hong Kong)",
		"451845": "Shinhan Bank VISA Check Card",
		"452088": "TD Bank CAD VISA infinite",
		"453030": "NAB Gold Affinity",
		"453231": "Banco Mercantil Venezuela Visa Card",
		"453801": "ScotiaBank - Visa Gold",
		"453826": "ScotiaBank - Visa Infinite",
		"453904": "Nordea (SE) - Visa Electron",
		"453978": "Barclays Bank (UK) - Connect Visa Debit Card",
		"453979": "Barclays Bank (UK) - Connect Visa Debit Card",
		"453980": "permanent tsb Visa Credit Card",
		"453997": "Friulcassa / CartaSi (IT) - Visa Card",
		"453998": "CartaSi (IT) - Visa Card",
		"454305": "RBS Visa Credit Card",
		"454312": "First Direct (UK) - Visa Credit Card",
		"454313": "Nationwide Building Society (UK) - Visa Debit Card",
		"454361": "First Direct (a division of HSBC UK) Visa Debit Card",
		"454417": "Slovenská sporiteľňa Visa",
		"454434": "First Trust Bank (UK) - Visa Debit Card",
		"454495": "Co-operative Bank (UK) - Visa Credit Card",
		"454605": "Citibank Australia (AU) Visa Card",
		"454718": "UOB (SG) A*STAR VISA Corporate Gold Credit Card",
		"454742": "Santander (Previously Abbey (bank)) Visa Debit Card",
		"454749": "BHW (DE) - Visa Charge Card",
		"454867": "ASB Bank Visa Credit Card (New Zealand)",
		"454869": "Westpac New Zealand Visa Credit Card",
		"455025": "Cooperative Bank (UK) - Visa",
		"455121": "GM-Visa Card (CAD) issued by TDCanada Trust",
		"455271": "Bank of East Asia Classic Credit Card (Hong Kong)",
		"455272": "Bank of East Asia Gold Credit Card (Hong Kong)",
		"455451": "ICICI Bank Visa Platinum Debit Card (India)",
		"455503": "Bancomer Azul Clásica Credit Card (México)",
		"455701": "National Australia Bank (AU) - GOLD VISA Credit Card",
		"455702": "National Australia Bank VISA (AU) - Credit Card",
		"455707": "Hang Seng Bank Credit Card",
		"455788": "Visa gold debit card BCP-Banco de Crédito del Perú.",
		"456351": "(CN)Bank of China Debit card (China UnionPay)",
		"456403": "Bank of Melbourne 1 (AU; now Westpac) - Visa Debit Card",
		"456406": "Challenge Bank (AU; now Westpac) - Visa Debit Card",
		"456413": "DEFENCE FORCE CREDIT UNION VISA DEBIT CARD (Australia)",
		"456414": "CREDIT UNION AUSTRALIA VISA DEBIT (Australia)",
		"456432": "SUNCORP METWAY VISA DEBIT CARD (Australia)",
		"456443": "BENDIGO BANK LTD - BASIC BLACK VISA CREDIT CARD (Australia)",
		"456445": "STATE BANK VICTORIA - VISA DEBIT CARD (now Commonwealth Bank Australia)",
		"456448": "BANK OF QUEENSLAND VISA CREDIT CARD (Australia)",
		"456453": "ANZ Bank VISA Gift Card (Australia)",
		"456462": "ANZ Bank VISA Credit Card (Australia)",
		"456468": "ANZ Bank VISA Credit Card Frequent Flyer Platinum (Australia)",
		"456469": "ANZ Bank VISA Credit Card Gold (Australia)",
		"456472": "Westpac Bank Altitude Visa Credit Card Platinum (Australia)",
		"456475": "Newcastle Permanent Building Society ltd VISA Debit (Australia)",
		"456491": "ASB Bank (New Zealand)",
		"456707": "Citibank (UK) Visa Prepaid card)",
		"456735": "Alliance and Leicester VISA Debit Card (UK)",
		"456738": "Citibank (UK) - Visa Debit Card (UK)",
		"458109": "Swedbank Visa Debit Card Sweden",
		"458123": "Bank of Communications/HSBC (CN) Y-Power Visa Card",
		"458440": "HSBC Vietnam - VISA Debit Card",
		"461983": "Best Buy Reward Zone/Chase (Canada)",
		"465859": "Barclays Visa Debit (UK)",
		"465904": "Santander Visa Debit (UK)",
		"465921": "Barclays Visa Debit (UK)",
		"465942": "HSBC Visa Debit Card (UK)",
		"467937": "Lakshmi Vilas Bank ( India)",
		"468805": "Axis Bank Debit Card (India)",
		"469568": "Dena Bank Debit Card (India)",
		"470758": "US Bank, Visa Debit, USA",
		"472926": "Peoples Trust Vanilla Prepaid Visa Card, Canada",
		"473099": "Wells Fargo Bank, Visa Debit, Iowa USA",
		"473104": "Swiss International Airlines Miles &amp; More Visa Gold (CH)",
		"473702": "Wells Fargo, Visa card, USA",
		"474480": "Bank of America Visa Debit, Midwest USA",
		"475050": "JPMorgan Chase Visa Credit Card",
		"475110": "Ulster Bank, Visa Debit, UK (immediate authorisation)",
		"475116": "RBS Royal Bank of Scotland, Visa Debit, UK (immediate authorisation)",
		"475117": "RBS Royal Bank of Scotland, Visa Debit, UK",
		"475118": "RBS Royal Bank of Scotland, Visa Debit, UK",
		"475131": "West Visa Debit Card",
		"475132": "West Private Banking Visa Debit",
		"475423": "MetaBank VISA TravelMoney, Debit",
		"475427": "MetaBank Rebate Visa Card",
		"475637": "WellsFargo Bank National Association, Visa Debit",
		"475714": "Santander UK Visa Debit card",
		"475743": "O2 Money Card (Ireland), prepaid",
		"476072": "may be HR Block prepaid Visa",
		"476515": "Venezolano de Credito Superefectiva Gold Visa Check card.",
		"476559": "South Florida Educational Federal Credit Union Visa Debit Card",
		"477361": "Big Sky Credit Union Visa (Australia)",
		"477517": "JPMorgan Chase Bank N.A.",
		"477548": "SEB - Visa debit (Estonia)",
		"477596": "Sainsbury's Bank (UK) - Visa Debit Card",
		"477915": "BZWBK (PL) - Visa Debit Card",
		"478200": "BANK ONE - VISA CLASSIC -DEBIT",
		"478825": "JPMorganChase Corporate Card",
		"478880": "Umpqua Bank of Oregon Visa Debit Card",
		"478901": "Vancity Visa credit card (Canada)",
		"478907": "Vancity Visa credit card (Canada)",
		"478986": "CIBC US Dollar Visa (Canada)",
		"478992": "Heartland Credit Union (Springfield, IL)",
		"479000": "Bulgarian Postbank VISA Credit card",
		"479056": "First National Bank (South Africa) Visa Electron Debit Card",
		"479080": "Visa Credit card BZWBK Polish bank",
		"479087": "Alfa bank (Russia), Visa Platinum",
		"479144": "Georgia Federal Credit Union",
		"479213": "TD Banknorth Visa Debit Card",
		"479293": "Abbey International Visa Debit Card",
		"479348": "Vision Banco Visa Debit Card (Paraguay)",
		"479731": "Swedbank Visa Electron (Estonia)",
		"479769": "&quot;Saint-Petersburg Bank&quot;, Russia",
		"479884": "E*Trade Visa Debit Card (U.S.)",
		"480152": "Citigroup Inc. - MyECount.com Verizon Wireless' rebate debit card",
		"480183": "Community Business Bank",
		"480213": "Capital ONE FSB Business",
		"480641": "Commonwealth Credit Union Visa Debit Card",
		"480801": "WellsOne Commercial Card",
		"482870": "Wachovia Bank (US) - Visa Debit Card",
		"483542": "Standard Charterd Bank Vietnam - Visa Debit Card",
		"483561": "ANZ NATIONAL BANK LTD - Visa Debit Card",
		"483583": "Sony Finance International, Japan - Dual Currency (JPY/USD) Credit Card",
		"483585": "HSBC Revolution VISA Platinum Credit Card (Singapore)",
		"483588": "Canada Post Visa Reloadable Prepaid Card",
		"484427": "Paypal (UK) - Top-up card (managed by RBS)",
		"484432": "Bank Of Scotland (UK) - Visa Electron Card",
		"486236": "Capital One - Visa Platinum Credit Card",
		"486269": "HSBC Platinum Visa Credit Card (India)",
		"486430": "Lloyds TSB (UK) - Visa Card",
		"486483": "HSBC (UK) - Commercial Visa credit Card",
		"486990": "Plumas Bank (California, US) - Visa Business Check Card",
		"486993": "Umpqua Bank of Oregon (US) - Visa Business Check Card",
		"490115": "First National Bank VISA South Africa / Cedyna INC Visa Japan",
		"490220": "BC VISA Credit Card issued by Woori Bank",
		"490292": "NAB VISA Gold Debit Card (Australia)",
		"490603": "BC VISA Credit Card issued by Industrial Bank of Korea",
		"490606": "BC VISA Credit Card issued by Kookmin Bank",
		"490611": "BC VISA Credit Card issued by Nonghyup Central Bank",
		"490612": "BC VISA Credit Card issued by Nonghyup Local Banks",
		"490620": "BC VISA Credit Card",
		"490623": "BC VISA Credit Card issued by SC First Bank",
		"490625": "BC VISA Credit Card issued by Hana Bank",
		"490627": "BC VISA Credit Card issued by Citibank in Korea",
		"490678": "BC VISA Credit Card issued by Shinhan Card",
		"490696": "Citibank (Argentina)",
		"490762": "Bayerische Landesbank VISA Credit Card (Germany)",
		"490841": "Banco Espirito Santo Gold Visa Credit Card (Portugal)",
		"490847": "Parex Bank Visa Credit Card",
		"491002": "Citibank (UK) AAdvantage Gold Visa Card",
		"491611": "Halifax Ireland VISA Credit Card",
		"491731": "Abbey (bank) VISA Electron (UK)",
		"491754": "Halifax (United Kingdom bank) VISA Electron (UK)",
		"491859": "Danske Bank Privatkort Visa Electron debit card (SE)",
		"492046": "Luottokunta issued VISA Gold (Finland)",
		"492111": "HSBC Visa Credit Card (Hong Kong)",
		"492127": "HSBC Visa Credit Card (Bermuda)",
		"492160": "HSBC Visa Credit Card (Singapore)",
		"492181": "Lloyds TSB Visa Debit Card",
		"492182": "Lloyds TSB Visa Debit Card",
		"492213": "Nedbank VISA Credit Card (ZA)",
		"492940": "Barclaycard Visa Credit Card",
		"492942": "Barclaycard Premier and OnePulse (Oyster) Visa Credit Cards with contactless payment (UK)",
		"492946": "Barclaycard Business Visa Credit Card",
		"492949": "Barclaycard Visa Initial Credit Card",
		"493467": "Bank of China Olympics Visa Credit Card (Singapore)",
		"493468": "Bank of China Platinum Visa Credit Card (Singapore)",
		"494052": "Commonwealth Bank VISA Credit Card (Australia)",
		"494053": "Commonwealth Bank VISA Credit Card (Gold)(Australia)",
		"494114": "National Bank of Abu Dhabi Cashplus Global Visa Electron (UAE)",
		"494120": "HSBC Visa Gold Debit Card (United Kingdom)",
		"496604": "HSBC Visa Credit Card (Hong Kong)",
		"496645": "HSBC Visa Gold Credit Card (Singapore)",
		"496696": "HSBC Visa Gold Credit Card (Bermuda)",
		"497063": "La banque postale visa (France)",
		"497128": "Natixis / Banque Populaire (France)",
		"497160": "HSBC Visa Credit Card (France)",
		"497164": "Banque Accord Visa Credit Card (France)",
		"497251": "First Command Financial Planning, Inc.",
		"497301": "Société Générale CB Visa (France)",
		"497302": "Société Générale CB Visa (France)",
		"497543": "Natexis Banques Populaires Visa Credit Card (France)",
		"497545": "Natexis Banques Populaires Visa Credit Card (France)",
		"497618": "Boursorama Visa Credit Card (France)",
		"497652": "Barclays Bank PLC Visa Credit Card (France)",
		"497671": "Credit du Nord Visa Credit Card (France)",
		"497958": "Boursorama Banque VISA PREMIER credit card (France)",
		"498824": "The Co-operative Bank (incl Smile) Visa Debit Card (UK in £)",
		"499897": "DKB Deutsche Kreditbank AG Visa Charge Card (Germany)",
		"499916": "Bank of New Zealand VISA Platinum Credit Card",
		"499977": "Bank of New Zealand VISA Credit Card",
		"500235": "CA     National Bank of Canada     ATM/Debit Card",
		"500766": "CA     Bank of Montreal     ATM/Debit Card",
		"501012": "CA     Meridian Credit Union     Debit and Exchange Network Card",
		"502029": "ASPIDER     Smartcards for Mobile Telecommunications",
		"503615": "ZA     Standard Bank of South Africa     Maestro Debit Card",
		"504507": "Barnes &amp; Noble     Gift Card",
		"504834": "IN     ING Vysya Bank     Maestro Debit/ATM Card",
		"504837": "US     Fleet Bank     ATM Only Card.",
		"510000": "RO     Amro Bank ",
		"510001": "GR     Agricultural Bank of Greece ",
		"510002": "EE     Estonia Credit Bank ",
		"510003": "KR     Samsung Card Co ",
		"510005": "TR     HSBC ",
		"510008": "NL     VSB International ",
		"510009": "CH     Europay ",
		"510010": "PL     Powszchny Bank Kredytowy Warsawie ",
		"510011": "CH     Europay ",
		"510017": "ES     Fimestic Bank ",
		"510018": "PL     PKO Savings Bank ",
		"510019": "HU     Budapest Bank Ltd     Investment Card, embossed.",
		"510029": "NL     VSB International ",
		"510030": "FI     SEB Kort ",
		"510034": "ES     Fimestic Bank ",
		"510035": "BY     Belarus Bank ",
		"510036": "AD     Sabadell Bank of Andorra ",
		"510037": "GR     General Bank of Greece ",
		"510040": "US     5-Star Bank ",
		"510087": "ES     Santander Bank     Debit Card",
		"510136": "CZ     CitiBank     Gold Credit Card",
		"510142": "CZ     CitiBank ",
		"510197": "UBS AG     MasterCard",
		"510241": "UK     RBS ",
		"510840": "The Bancorp Bank     Higher One MasterCard Debit Card",
		"510875": "US     Lake Michigan Credit Union     MasterCard Debit Card",
		"510982": "US     USAA     USAA Cash Rewards Debit MasterCard",
		"511810": "US     PayPal     PayPal Secure Credit Card",
		"512000": "US     Western States BankCard Association ",
		"512005": "US     Western States BankCard Association ",
		"512010": "US     Western States BankCard Association ",
		"512012": "US     Chase Manhattan Bank USA ",
		"512015": "US     Western States BankCard Association ",
		"512022": "US     Western States BankCard Association ",
		"512023": "JO     International Card ",
		"512024": "US     Western States BankCard Association ",
		"512105": "US     Western States BankCard Association ",
		"512109": "CL     Corp Banca ",
		"512136": "US     Western States BankCard Association ",
		"512462": "Lotte Card     MasterCard Gold Card",
		"512500": "US     Western States BankCard Association",
		"512568": "PL     Citi     Gold MasterCard Citi Poland",
		"512569": "UK     Lloyds TSB ",
		"512607": "Continental Finance     MasterCard $300 Limit Card",
		"512622": "IN     SBI     Tata Card Mastercard Credit Card",
		"512687": "UK     Sainsbury     Sainsbury Credit Card",
		"513100": "FR     Europay France ",
		"513101": "FR     Europay France Crédit Agricole     Gold MasterCard Credit Card",
		"513141": "FR     Europay France Crédit Agricole     MasterCard Credit Card",
		"513142": "FR     Europay France ",
		"513143": "FR     Europay France Advanzia Bank     MasterCard Credit Card",
		"513453": "FR     BNP Paribas     MasterCard Credit Card",
		"513536": "FR     Europay France BRED Banque Populaire     Affinity MasterCard Credit Card",
		"513624": "FR     Europay France - Barclays Bank PLC     MasterCard Platinum",
		"513691": "RU     Russian Standard Bank, Russia     MasterCard Unembossed (Instant Issue)",
		"513900": "FR     Europay France ",
		"514011": "US     Integra Bank ",
		"514012": "US     CitiBank South Dakota ",
		"514013": "US     Elgin First Credit Union ",
		"514015": "US     Infibank ",
		"514016": "US     Miramar First Credit Union ",
		"514017": "US     Franklin Templeton Bank and Trust ",
		"514021": "US     Juniper Bank     Now known as Barclays Bank PLC",
		"514022": "US     Navy First Credit Union ",
		"514102": "US     Park National Bank ",
		"514108": "US     Paradigm Bank Texas ",
		"514253": "US     EDS Employees First Credit Union ",
		"514700": "Mascoma Savings Bank     Business Mastercard Debit Card",
		"514876": "KR     CitiBank     Platinum MasterCard",
		"514889": "US     Juniper Bank     Now known as Barclays Bank PLC",
		"514923": "US     Chase Manhattan Bank USA ",
		"515854": "RU     Citibank Citigold Debit Card ",
		"516010": "PL     Polbank EFG     MasterCard Credit Card",
		"516029": "CitiFinancial     Shell/CitiFinancial Europe MasterCard",
		"516300": "AU     WestPac Banking Corporation ",
		"516310": "AU     WestPac Banking Corporation ",
		"516315": "AU     WestPac Banking Corporation ",
		"516319": "AU     WestPac Banking Corporation     Virgin MasterCard Credit Card",
		"516331": "RU     Svyaznoy Bank ",
		"516335": "AU     WestPac Banking Corporation ",
		"516337": "AU     WestPac Banking Corporation     Australia Platinum MasterCard",
		"516361": "AU     Westpac Banking Corporation     Visa Debit Card",
		"517644": "US     Miramar First Credit Union ",
		"517651": "US     5-Star Bank ",
		"517652": "HDFC Bank     MasterCard Gold Credit Card",
		"517669": "US     HSBC     (formerly Household) MasterCard Credit Card",
		"517805": "US     Capital One     MasterCard Credit Card or First Premier Bank",
		"517869": "US     Union Bank     MasterCard Debit Card",
		"518126": "Utility Warehouse     MasterCard PrePaid Card",
		"518127": "CA     President's Choice Financial     MasterCard Credit Card",
		"518142": "UK     MBNA     MasterCard[citation needed]",
		"518145": "UK     Royal Bank of Scotland     Tesco Bank Classic MasterCard Credit Card",
		"518152": "UK         Tesco Bank ClubCard MasterCard Credit Card",
		"518175": "UK     MBNA     British Midland Airways MasterCard",
		"518176": "IE     MBNA     MBNA Ireland Platinum MasterCard",
		"518652": "ROYAL BANK OF SCOTLAND PLC. EUR GBR EDINBURGH",
		"518791": "Lloyds TSB     MasterCard CreditCard",
		"518996": "UniCredit Bank, Russia",
		"519000": "CA     Bank of Montreal ",
		"519113": "CA     Bank of Montreal ",
		"519129": "CA     Bank of Montreal ",
		"519133": "CA     Bank of Montreal ",
		"519154": "CA     Bank of Montreal ",
		"519163": "NZ     Kiwibank ",
		"519173": "CA     Bank of Montreal ",
		"519244": "AU     Bendigo Bank     Business Blue Debit Mastercard",
		"519259": "CA     Bank of Montreal ",
		"519269": "CA     Bank of Montreal     USD Mastercard",
		"519281": "CA     Bank of Montreal ",
		"519283": "CA     Bank of Montreal ",
		"519290": "CA     Bank of Montreal ",
		"519332": "CA     Bank of Montreal ",
		"519342": "CA     Bank of Montreal ",
		"519371": "CA     Bank of Montreal ",
		"519373": "CA     Bank of Montreal ",
		"519381": "CA     Bank of Montreal ",
		"519383": "CA     Bank of Montreal ",
		"519400": "CA     Bank of Montreal ",
		"519403": "CA     Bank of Montreal ",
		"519409": "CA     Bank of Montreal ",
		"519443": "CA     Bank of Montreal ",
		"519463": "PH     Banco De Oro     MasterCard Debit Card",
		"519520": "Altair     Prepaid Cards",
		"519525": "Contis Group &amp; EZPay     Prepaid Cards",
		"520169": "BestBuy MasterCard by Bank of Communications/HSBC (China)",
		"520306": "Citibank/Lufthansa Miles &amp; More MasterCard Credit Card (Russia)",
		"520641": "Tesco Bank Bonus Mastercard(UK)",
		"520988": "Garanti Bank Shop&amp;Miles MasterCard Credit Card",
		"521324": "Tinkoff Credit Systems (Russia), MasterCard Platinum Credit Card",
		"521326": "SMP Bank (Russia), MasterCard Platinum Transaero Card",
		"521804": "Tesco Bank Business Mastercard (UK)",
		"521853": "PayPal MasterCard",
		"522182": "People's Trust (US)",
		"522223": "Avangard Bank, Russia",
		"522276": "Chase Manhattan Bank MasterCard Credit Card",
		"523748": "Commonwealth Bank of Australia Prepaid Travel Money Mastercard",
		"523911": "Affinity Bank",
		"523912": "Affinity Bank",
		"523951": "ICICI Bank MasterCard Credit Card",
		"524040": "OCBC Bank BEST-OCBC MasterCard Credit Card (Singapore)",
		"525241": "Saison Card International, Japan - United Airlines Mileage Plus",
		"525405": "VÚB Banka (Banca Intesa group) MasterCard original+ Credit card (Slovakia)",
		"525678": "Banamex Debit card",
		"525896": "Mastercard Husky (Canada) [Husky/Mohawk MasterCard]",
		"525995": "Canadian Tire Bank Gas Advantage MasterCard",
		"526219": "Citibank MasterCard American Airlines AAdvantage Debit Card",
		"526224": "Citibank MasterCard Debit Card",
		"526418": "Vietcombank - Vietnam - MasterCard Debit Card",
		"526468": "State Bank of India",
		"526471": "POSBank MasterCard Debit/ATM Card (Singapore)",
		"526495": "Bank of India MasterCard Debit/ATM Card",
		"526702": "Yes Bank Mastercard Silver Debit Card (India)",
		"526722": "Standard Bank South Africa MasterCard Credit Card (Gift Card)",
		"526781": "VÚB Banka (Banca Intesa group) - MasterCard unembossed Credit card (Slovakia)",
		"526790": "Asia Commercial Bank Vietnam - MasterCard Debit Card",
		"527434": "Caixanova NovaXove (Spain) Mastecard Debit Card",
		"527455": "Rubycard Pre-Paid Mastercard (Ireland) issued by Newcastle Building Society",
		"527456": "WireCard Bank (Germany)",
		"528013": "Bankwest Australia MasterCard Debit Card",
		"528038": "ING Bank N.V. Amsterdam",
		"528061": "BMO Bank of Montreal MasterCard Prepaid Travel",
		"528093": "Banesto (Spain) Mastercard Prepaid Sevilla Futbol Club",
		"528229": "Nexpay prepaid card",
		"528683": "The Governor And Company Of The Bank Of Scotland EUR GBR DUNFERMLINE",
		"528689": "Santander Zero MasterCard Credit Card UK",
		"529480": "Santander [CONTIGO] Credit Card (Spain)",
		"529580": "(Italy) Kalixa Prepaid MasterCard (Vincento Payment Solutions)",
		"529930": "Marks &amp; Spencer Money MasterCard Credit Card",
		"529962": "Prepaid MasterCards issued by DCBANK. (MuchMusic)",
		"529964": "Altair prepaid MasterCard",
		"529965": "pre paid debit cards",
		"529966": "pre paid debit cards",
		"530343": "Net1 Virtual Card Prepaid",
		"530695": "Bancolombia Prepaid MasterCard Credit Card (E-prepago)",
		"530785": "Sears MasterCard issued by [Chase Cards Canada]",
		"530831": "Orange Cash Prepaid MasterCard, issued by Orange and Barclays with PayPass",
		"531207": "Uralsib Bank (Russia), MasterCard World - Aeroflot bonus",
		"531306": "Moneybookers.com Prepaid Mastercard issued by Newcastle Building Society",
		"531355": "National Bank MasterCard Credit Card",
		"532450": "China Construction Bank Credit Card",
		"532561": "HSBC Bank USA Premier Debit Mastercard with PayPass",
		"532700": "RBS Premium MasterCard Debit Card",
		"532902": "Wachovia Bank MasterCard Credit Card",
		"533157": "RNKO, Euroset Kukuruza Bonus (Russia) Mastercard Unembossed, Instant Issue",
		"533206": "Avangard Bank MasterCard Credit Card",
		"533248": "Comerica Bank Mastercard prepaid",
		"533838": "[CBA] Prepaid Gift card as MasterCard",
		"533846": "Kalixa Prepaid Mastercard UK Kalixa Prepaid MasterCard (Vincento Payment Solutions)",
		"533875": "Paypal Italy MasterCard Prepaid",
		"533896": "Paypal Access Card (UK)",
		"533908": "Bank Zachodni WBK Mastercard Premium Prepaid PayPass (Electronic) (Poland)",
		"533936": "Kalixa Prepaid Mastercard DE Kalixa Prepaid MasterCard (Vincento Payment Solutions)",
		"535316": "Commonwealth Bank Standard MasterCard Credit Card",
		"535317": "Commonwealth Bank Credit Card",
		"535318": "Commonwealth Bank Gold MasterCard Credit Card",
		"536386": "Barclaycard World Mastercard (UK)",
		"537004": "RNKO, Russia, Svyaznoy MasterCard Unembossed Card Instant Issue",
		"538720": "BC Mastercard issued by Woori Bank",
		"538803": "BC Mastercard issued by Industrial Bank of Korea",
		"538806": "BC Mastercard issued by Kookmin Bank",
		"538811": "BC Mastercard issued by Nonghyup Central Bank",
		"538812": "BC Mastercard issued by Nonghyup Local Banks",
		"538820": "BC Mastercard",
		"538823": "BC Mastercard issued by SC First Bank",
		"538825": "BC Mastercard issued by Hana Bank",
		"538827": "BC Mastercard issued by Citibank in Korea",
		"538878": "BC Mastercard issued by Shinhan Bank",
		"539028": "Citibank Mastercard (Brazil)",
		"539673": "Avangard Bank, MasterCard World Signia Card",
		"540002": "DBS (Esso co-branded) Singapore",
		"540034": "Standard Chartered Bank Titanium Credit Card (Hong Kong)",
		"540041": "HSBC Bank Gold Malaysia",
		"540141": "BANESCO Classic Mastercard card (Venezuela).",
		"540168": "Chase MasterCard Credit Card",
		"540207": "BNZ (Bank of New Zealand) Global Plus MasterCard Credit Card",
		"540221": "ANZ National Bank ANZ MasterCard Credit Card",
		"540223": "Westpac New Zealand MasterCard Credit Card",
		"540410": "Brown Thomas MasterCard (Issued by AIB)",
		"540450": "Advanced Payment Solutions (APS)",
		"540451": "Advanced Payment Solutions (APS)",
		"540758": "MBNA Bank UK bmi Blue Mastercard",
		"540801": "Household Bank USA MasterCard Credit Card",
		"540806": "Hang Seng Bank Credit Card",
		"540838": "BOC Great Wall Credit Card (CN)",
		"540877": "Bank of China Platinum MasterCard Credit Card (SG)",
		"541010": "Raiffeisen Zentralbank",
		"541065": "Citibank MC",
		"541142": "CIBC MasterCard (Canadian Imperial Bank of Commerce) formerly Citi MasterCard Canada",
		"541206": "USAA",
		"541277": "Nordea Finance/Valutakortet Valuta MasterCard credit card (SE)",
		"541330": "Mastercard test BIN for NIV, TIP certifiction (not production cards)",
		"541592": "Neteller (UK) Mastercard debit card",
		"541606": "WestJet/RBC Royal Bank of Canada MasterCard (Canada)",
		"541657": "(eBay MasterCard) via Providian",
		"542418": "Citibank Platinum Select",
		"542505": "RBS Gold Mastercard Credit Card (formerly ABN Amro Bank) (India)",
		"542523": "Allied Irish Banks MasterCard Credit Card (Ireland)",
		"542598": "Bank of Ireland Post Office Platinum Card (UK)",
		"543034": "Stockmann Department Store Exclusive Mastercard, issued by Nordea (Finland)",
		"543077": "Handelsbanken Business Mastercard (Sweden)",
		"543122": "HSBC issued Mastercard (Hong Kong)",
		"543250": "Bank of New Zealand MasterCard Credit Card",
		"543267": "Bank of Ireland MasterCard Credit Card",
		"543429": "Halifax 'One' Mastercard",
		"543458": "HSBC UK Premier Credit Card",
		"543460": "HSBC Mastercard Credit Card (UK)",
		"543478": "National Irish Bank Mastercard",
		"543479": "National Irish Bank Gold Mastercard",
		"543482": "RBS Mastercard Credit Card",
		"543556": "NatWest Mastercard Charge Card",
		"543678": "Westpac New Zealand Mastercard Gold Credit Card",
		"543696": "Itau Mastercard Credit Card",
		"543699": "NatWest MasterCard Gold Credit Card",
		"544156": "Allied Irish Banks Gold MasterCard Credit Card",
		"544258": "BRE Bank (MultiBank) Mastercard Aquarius PayPass Credit Card (Black)(Poland)",
		"544291": "Kiwibank Go Fly MasterCard Standard (NZ)",
		"544434": "Wizard Clear Advantage MasterCard (Australia)",
		"544440": "Valovis Bank, Prepaid MasterCard Debit(Germany)",
		"544748": "Chase SLATE MasterCard Credit Card",
		"544917": "Citizens Bank (Personal Checking) Debit",
		"545045": "Danske Bank Intercard MasterCard debit card (SE)",
		"545157": "Masterbank (Russia), MasterCard World Signia",
		"545250": "Maestro (debit card) BZWBK Poland",
		"545511": "Masterbank (Russia) MasterCard Gold Debit Card",
		"545578": "Halifax MasterCard (UK)",
		"545955": "Mascoma Savings Bank Mastercard Consumer Debit Card",
		"546259": "The Governor And Company Of The Bank Of Ireland EUR IRL DUBLIN 2",
		"546286": "Dexia banka Slovensko,a.s.; MasterCard Red with PayPass technology",
		"546604": "First USA Banke, N.A. Master Card",
		"546641": "HSBC GM MasterCard Credit Card",
		"546680": "HSBC GM MasterCard Credit Card",
		"547046": "Santander Uni-k Credit Card (México)",
		"547343": "ANZ Business MasterCard (New Zealand)",
		"547347": "HSBC Commercial Card (UK in £)",
		"547356": "RBS Royal Bank of Scotland",
		"547367": "NatWest (RBS)",
		"547372": "Swedbank, Estonia, MasterCard Business Card",
		"548009": "Fifth Third Bank",
		"548045": "BANCO BRADESCO S.A. (BRAZIL)",
		"548652": "Banco de Chile Master Card Credit Card",
		"548653": "Banco de Chile Master Card Credit Card RUA",
		"548673": "Alfa-Bank/Aeroflot-bonus, M-Video bonus debit Card (Russia)",
		"548674": "Alfa-Bank Credit Card (Russia)",
		"548805": "Hatton National Bank, Sri Lanka RUA",
		"548901": "Banco Santander MasterCard debit card (Spain)",
		"548912": "Banco Santander MasterCard debit card with chip (Spain)",
		"548955": "HOUSEHOLD BANK (NEVADA), N.A, (Orchard Bank M/C, HSBC Card Services) RUA",
		"549035": "MBNA American Bank [Now part of Bank of America]",
		"549099": "MBNA American Bank [Now part of Bank of America]",
		"549104": "Chase Manhattan Bank USA, N.A.",
		"549110": "HSBC Bank Nevada, N.A. issued Household Bank Platinum Mastercard",
		"549113": "Citibank MC",
		"549123": "USAA Federal Savings Bank Platinum",
		"549409": "HSBC Bank Nevada, NA Premier World Mastercard (credit card)",
		"549471": "Qantas Woolworths Everyday Mastercard (issued by HSBC)",
		"550619": "&quot;Skycard&quot; MasterCard Credit Card issued in UK in association with Barclaycard",
		"551128": "ITS Bank/SHAZAM (Interbank Network) Mastercard USA unclear if Debit or Credit",
		"551167": "ITS Bank/SHAZAM (Interbank Network) Mastercard USA unclear if Debit or Credit",
		"551445": "Cambridge Trust Company in Massachusetts, USA",
		"552016": "Bank of China International MasterCard Platinum (Hong Kong area)",
		"552033": "Commonwealth Bank Platinum Awards MasterCard Credit Card",
		"552038": "POSB (DBS Bank) everyday Platinum MasterCard Credit Card",
		"552093": "Citibank Mastercard Platinum Credit Card (India)",
		"552157": "Lloyds TSB Platinum Mastercard",
		"552188": "Tesco Bank Finest Platinum Mastercard (UK)",
		"552213": "NatWest Platinum Mastercard",
		"552724": "Danske Bank MasterCard Direkt debit card (SE)",
		"553421": "Bank of Scotland Mastercard",
		"553823": "MIT Federal Credit Union Debit Mastercard",
		"553877": "Star Processing PrePaid Mastercard",
		"553985": "First National Bank in Edinburg, USA",
		"554346": "Kookmin Bank Mastercard &quot;Free Pass&quot; Debit Card",
		"554544": "Bank of Ireland",
		"554564": "Onyxcard",
		"554619": "Citibank Mastercard Silver Credit Card (India)",
		"554641": "Euro Kartensysteme Eurocard und Eurocheque gmbh",
		"554827": "POSBank MasterCard Debit Card (Singapore)",
		"555005": "Commonwealth Bank of Australia Corporate Mastercard",
		"556951": "Nat West Bank Mastercard",
		"557098": "Aqua Card Mastercard (UK)",
		"557505": "Bank Handlowy Mastercard Electronic Pay Pass (Karta Miejska) Debit Card (Poland)",
		"557510": "BRE Bank (MultiBank) Mastercard Aquarius PayPass Debit Card(Poland)",
		"557513": "BRE Bank (MultiBank) Mastercard PayPass Debit Card(Poland)",
		"557552": "Ally Bank Platinum Debit Card",
		"557843": "&quot;Goldfish&quot; MasterCard Credit Card issued in UK by Morgan Stanley",
		"557892": "MasterCard Credit Card issued in Nordea Denmark",
		"557905": "Santander Mexico Debit Card",
		"557907": "Santander Mexico Debit Card",
		"558108": "Citizens Bank (Business Checking) Debit",
		"558158": "Paypal MasterCard Debit Card, JPMorgan Chase Bank, Formerly Bank One",
		"558818": "[Hdfc Bank] MasterCard Credit Card &quot;Business Platinum&quot; India",
		"558846": "FIA",
		"560017": "Comdata Card",
		"560054": "HSBC Bank USA, N.A. Maestro card",
		"560279": "Commonwealth Bank of Australia Key Card",
		"560373": "Alliance and Leicester cash deposit card",
		"561059": "Australian Bank Card",
		"561066": "HSBC Bank Canada ATM Card",
		"561150": "Chase (USA), ATM Card",
		"564100": "Santander UK cash card",
		"564104": "Nationwide",
		"564120": "Nationwide Cashbuilder ATM card.",
		"564182": "Switch (debit card) Debit Card",
		"565659": "Banco Santander Ferrari MasterCard credit card (Spain)",
		"574085": "Banco Santander Puerto Rico ATM/debit card",
		"581353": "Vancity ATM Card",
		"581828": "Credit Union (Ontario) debit cards",
		"585048": "Suntrust Banks - ATM Card",
		"585210": "Citibank Greece ATM Card",
		"586357": "Branch Banking and Trust (BB&amp;T) ATM Card",
		"587781": "Bank of America ATM Card",
		"588644": "Citibank Korea International ATM Card",
		"589242": "National Bank of Greece Greece Debit Card",
		"589261": "Maestro (debit card) Pekao",
		"589297": "TD Canada Trust Interac/ATM Card",
		"589460": "'Choice Card', issued by HSBC, for the Cold Storage chain",
		"589562": "TARJETA NARANJA (Argentina)",
		"589732": "Digital TV Converter Box $40.00 Coupons (USA) - DTV2009.GOV",
		"589856": "Standard Chartered Bank (Hong Kong) ATM Card",
		"600229": "Wegmans Shoppers Card",
		"600292": "Hudson's Bay Company",
		"600293": "Hudson's Bay Company",
		"600294": "Hudson's Bay Company",
		"600315": "Safeway",
		"600649": "Fastcard Gift Cards",
		"601021": "ARI Canada - Ontario government",
		"601056": "ValueLink stored value card (Starbucks, Borders Books, et al.)",
		"601382": "Bank of China Unionpay Debit card (GreatWall Debit Card)",
		"601725": "ING Direct Canada ATM Card",
		"601859": "A GAP card that carries GAP, Banana Republic and Old Navy logos, issued by GE Money Bank.",
		"601887": "President's Choice Financial Canada Debit Card (ATM/Interac)",
		"602700": "Wichita State University &quot;Shocker Card&quot; (a stored value card)",
		"602969": "CN Bank of Beijing Debit Card Visa Interlink/China UnionPay CNY",
		"603207": "Shoppers Drug Mart Optimum Program",
		"603220": "Walmart Credit Card",
		"603367": "(CN) Bank of Hangzhou Debit Card, China UnionPay",
		"603411": "Palm Desert National Bank, USA (IKobo.com Money-transfer debit card)",
		"603450": "Starbucks Card (Starbucks Europe Ltd)",
		"603528": "STAPLES Canada Enterprise Credit Card (issued by Citi Cards Canada)",
		"603692": "Stockmann Card",
		"603753": "McDonald's Gift Card (serviced by ValueLink)",
		"603798": "KiwiBank Debit Card (Cirrus)",
		"603948": "OBI Petrol Card",
		"604646": "Scene LP (Cineplex Entertainment)",
		"604767": "More Rewards (Overwaitea Food Group loyalty card, BC and AB, Canada)",
		"604809": "Svyaznoy Club loyalty card",
		"604976": "Tim Hortons QuickPay Tim Card",
		"606095": "Starbucks Card - Europe",
		"606172": "Club Sobeys (Canada)",
		"606179": "Commonwealth Finance Solutions Ltd",
		"606263": "MoneyTech Inc. - Brazil",
		"606469": "Revolution MoneyExchange",
		"606484": "PRJ Financial Services - Karum Group LLC",
		"606934": "Starbucks Card - Korea",
		"607120": "Starbucks Card - Korea",
		"620013": "Bank of Communications Hong Kong Branch Expo 2010 Shanghai China CUP Gift Card (HK)",
		"620021": "Bank of Communications Expo 2010 Shanghai China Prepaid Card (China)",
		"621019": "Zheshang Bank Debit Card (CN)",
		"621041": "Bank of China (Hong Kong) BOC Card - Debit (HK)",
		"621060": "Woori Bank UnionPay Shanghai Tourism Card (CN)",
		"622141": "Zhejiang Tailong Commercial Bank Debit Card (CN)",
		"622200": "CN ICBC Peony Money Link Card",
		"622201": "CN ICBC Peony Money Link Card",
		"622202": "CN ICBC Peony Money Link Card E-Age",
		"622203": "CN ICBC Peony Money Link Card E-Age",
		"622208": "CN ICBC Elite Club Account Card",
		"622210": "CN ICBC Peony Quasi-Credit Card",
		"622212": "Chong Hing Bank China Unionpay Gift Card (HK)",
		"622226": "Bank of Communications Pacific Card Debit Card",
		"622252": "BestBuy UnionPay Credit Card by Bank of Communications/HSBC",
		"622260": "Bank of Communications Expo 2010 Shanghai China CUP Special Edition Debit Card (CN)",
		"622309": "Zheshang Bank Debit Card (CN)",
		"622372": "The Bank of East Asia UnionPay Dual Currency Platinum Credit Card (HK)",
		"622379": "Qilu Bank  Debit Card (CN)",
		"622381": "CCB (Asia) CUP Credit Card (HK)",
		"622409": "Hang Seng Bank Green Banking Smart Card - Debit (HK)",
		"622410": "Hang Seng Bank Hang Seng Card - Debit (HK)",
		"622427": "Taizhou Bank DaTang Debit card (CN)",
		"622492": "DBS Octopus ATM Card - Debit (HK)",
		"622568": "Guangdong Development Bank Debit(China UnionPay) Card (CN)",
		"622630": "China Huaxia Bank Debit card, China Unionpay(CN)",
		"622632": "China Huaxia Bank Debit card, China Unionpay(CN)",
		"622633": "China Huaxia Bank Debit card, China Unionpay(CN)",
		"622659": "CHINA EVERBRIGHT BANK Debit and Credit All in One Card (CN)",
		"622700": "China Construction Bank Debit(China UnionPay) Card (CN)",
		"622752": "Bank of China China UnionPay Credit Card (CN)",
		"622789": "Bank of China China UnionPay Platinum Credit Card (SG)",
		"622933": "Bank of East Asia UnionPay Debit Card (HK)",
		"622942": "Standard Chartered UnionPay Debit Card (HK)",
		"622974": "AEON Prepaid UnionPay Card (HK)",
		"625008": "Chong Hing Bank UnionPay Dual Currency Credit Card (HK)",
		"625028": "Bank of Communications Hong Kong Branch UnionPay Dual Currency Diamond Credit Card (HK)",
		"625029": "Bank of Communications Hong Kong Branch UnionPay Dual Currency Gold Credit Card (HK)",
		"625040": "Bank of China (Hong Kong) UnionPay Dual Currency Gold Credit Card - HKD Account (HK)",
		"625041": "Bank of China (Hong Kong) UnionPay Dual Currency Gold Credit Card - CNY Account (HK)",
		"625042": "Bank of China (Hong Kong) UnionPay Dual Currency Platinum Credit Card - HKD Account (HK)",
		"625043": "Bank of China (Hong Kong) UnionPay Dual Currency Platinum Credit Card - CNY Account (HK)",
		"625063": "Wing Lung Bank UnionPay Dual Currency Platinum Credit Card (HK)",
		"627397": "Wild Oats Gift Card",
		"627421": "Aeroplan (Air Canada)",
		"627425": "Disney Rewards Card (issued by Chase)* ",
		"627692": "Dexit",
		"627895": "virtual money inc",
		"628181": "Sears Card (issued by Chase Cards Canada)",
		"630490": "Bank of Ireland Laser/Maestro debit card",
		"630495": "National Irish Bank Laser/Maestro debit card",
		"630499": "permanent tsb Laser/Maestro debit card",
		"633174": "Co-operative membership card",
		"633513": "Midlands Co-operative Society membership card",
		"633540": "Argos Card",
		"633625": "National Savings &amp; Investments (UK)",
		"633641": "Post Office Card Account card",
		"633675": "G-T-P Group Ltd Payment Card",
		"633676": "HMV Gift Card",
		"633698": "G-T-P Group Ltd Prepaid Card",
		"633791": "Commonwealth Finance Solutions Ltd",
		"633834": "Debenhams Store Card by Santander Plc",
		"633845": "Subway Subcard (UK)",
		"634001": "Tesco Personal Finnace",
		"634004": "Tesco Clubcard",
		"634005": "Tesco Fuelcard",
		"634008": "Tesco Personal Finnace",
		"634009": "Tesco Tesco Clubcard (Poland)",
		"635608": "Origin Compower",
		"635629": "Origin Compower",
		"636325": "Sahand Samaneh Mahpa Co Loyalty Card (IR)",
		"636587": "Worldstar Freedom Plus Card issued by Worldstar Freedom Plus Limited",
		"639231": "Comprocard (Comprocard)",
		"639300": "Malina loyalty card (RU)",
		"670695": "Allied Irish Banks Maestro/Laser card (IRL)",
		"675922": "Clydesdale Bank Maestro debit card",
		"675940": "HSBC (UK) Maestro Debit card",
		"675964": "RBS Maestro Debit Card, with £100 Cheque Guarantee",
		"675967": "NatWest Maestro Debit Card, with £100 Cheque Guarantee",
		"675968": "NatWest Maestro Debit Card, with £250 Cheque Guarantee",
		"676165": "Maestro debit card - CSOB Bank (CZ)",
		"676280": "Maestro debit card - Sberbank (RU)",
		"676378": "BZ-WBK (PL) - Maestro PayPass",
		"676398": "ING Bank Slaski (PL) - Maestro PayPass",
		"676481": "HSBC Bank (Turkey) - Maestro debit card",
		"676509": "GENERALI BANK (IT) - Maestro debit card",
		"676613": "Citibank (PL) - Maestro debit card",
		"676953": "Pekao (PL) - Maestro debit card",
		"676969": "Eurobank EFG (GR) - Maestro debit card",
		"677310": "Garantibank (RO)",
		"677518": "SMP Bank (Russia) - Moscow Metro Express Card/Maestro debit card",
		"677574": "Intesa SanPaolo - Maestro debit card",
		"677594": "Alior Bank (PL) - Maestro debit card",
		"690149": "IAPA Frequent Flyers Card",
		"700247": "Priority Pass Passenger Card",
		"778900": "Perekrestok X5Club loyalty program, Russia",
		"923362": "Swedbank, Estonia, Temporary (30 day) ATM Card",
		"926366": "Kaubamaja/Selver Parnerkaart, Estonia",
		"3754150": "Commonwealth Bank of Australia Standard American Express",
		"3754151": "Commonwealth Bank of Australia Gold American Express",
		"3754155": "Commonwealth Bank of Australia Gold American Express",
		"3754165": "Commonwealth Bank of Australia Platinum American Express",
		"3755490": "American Express Blue Swedbank (Estonia)",
		"3755492": "American Express Gold Swedbank (Estonia)",
		"4188500": "Italy (Italy) - Visa Card",
		"4225842": "United Bank for Africa. Visa Classic Local Currency Debit Card",
		"4225846": "United Bank for Africa. Visa Classic Single Currency Debit Card",
		"4289150": "BRE Bank (MultiBank) Visa Platinum Credit Card (Poland)",
		"4289151": "BRE Bank (MultiBank) Visa Aquarius (Black) Credit Card (Poland)",
		"4329386": "BRE Bank (MultiBank) Visa Classic Aquarius Debit Card (Poland)",
		"4329387": "BRE Bank (MultiBank) Visa Classic Debit Card (Poland)",
		"6226313": "China Huaxia Bank Debit card, China Unionpay(CN)",
		"6356500": "Harrods",
		"42383701": "Sampopank (Estonia), Visa Premier",
		"42383702": "Sampopank (Estonia), Visa Gold",
		"54254200": "GE Money Bank Mastercard debit card (SE)",
		"54254207": "GE Money Bank Mastercard credit card (SE)",
		"414746 3": "Citibank (SG) - PremierMiles Visa Signature Credit Card",
		"414746 4": "Citibank (SG) - Dividend Visa Signature Credit Card",
		"414780 8": "US Bank",
		"41900*": "U.S. Bank (US) WorldPerks VISA Credit Card",
		"4327??": "North Carolina State Employees' Credit Union VISA Check Card",
		"4342??": "Bank of America Classic Visa Credit Card",
		"4580?": "Israeli Credit Cards (ICC) (IL) - Visa Card (Discount Bank and other partners)",
		"4889 39": "Lakshmi Vilas Bank (India)",
		"5049xx": "US     CitiBank     Sears Card",
		"5108XX": "INGDirect     Electric Orange Debit Card",
		"541256 02": "SEB Kort AB, Choice Club credit card (SE)",
		"541256 50": "SEB Kort AB, SJ Prio credit card (SE)",
		"54546?": "Natwest Student Mastercard (UK)",
		"55456789020": "BC Card"
	};

/***/ }),
/* 1739 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _moment = __webpack_require__(1021);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _reactRouter = __webpack_require__(486);
	
	var _materialUi = __webpack_require__(576);
	
	var _workingIndicator = __webpack_require__(1664);
	
	var _workingIndicator2 = _interopRequireDefault(_workingIndicator);
	
	var _statsBlockContainer = __webpack_require__(1740);
	
	var _statsBlockContainer2 = _interopRequireDefault(_statsBlockContainer);
	
	var _statsBlock = __webpack_require__(1741);
	
	var _statsBlock2 = _interopRequireDefault(_statsBlock);
	
	var _connectToStores = __webpack_require__(1226);
	
	var _connectToStores2 = _interopRequireDefault(_connectToStores);
	
	var _UserStore = __webpack_require__(974);
	
	var _UserStore2 = _interopRequireDefault(_UserStore);
	
	var _BalanceActions = __webpack_require__(1742);
	
	var _BalanceActions2 = _interopRequireDefault(_BalanceActions);
	
	var _BalanceStore = __webpack_require__(1743);
	
	var _BalanceStore2 = _interopRequireDefault(_BalanceStore);
	
	var _BalanceUtil = __webpack_require__(1744);
	
	var _BalanceUtil2 = _interopRequireDefault(_BalanceUtil);
	
	var _util = __webpack_require__(1183);
	
	var _genericAnalyticsTable = __webpack_require__(1687);
	
	var _genericAnalyticsTable2 = _interopRequireDefault(_genericAnalyticsTable);
	
	var _qs = __webpack_require__(1206);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Balance = function (_React$Component) {
	  _inherits(Balance, _React$Component);
	
	  function Balance(props) {
	    _classCallCheck(this, Balance);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(Balance).call(this, props));
	
	    _this.state = {
	      hasLoaded: false,
	      hasMoreTransactions: false,
	      balanceTransactions: null
	    };
	    return _this;
	  }
	
	  _createClass(Balance, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      _BalanceActions2.default.fetchBalance();
	    }
	  }, {
	    key: "_loadBalanceTransactions",
	    value: function _loadBalanceTransactions(_ref) {
	      var _this2 = this;
	
	      var accountId = _ref.accountId;
	      var startingAfter = _ref.startingAfter;
	      var endingBefore = _ref.endingBefore;
	
	      this.setState({ balanceTransactions: [], loading: true });
	      _BalanceUtil2.default.fetchBalanceTransactions(_UserStore2.default.getState().apiKey, {
	        accountId: accountId,
	        startingAfter: startingAfter,
	        endingBefore: endingBefore
	      }).then(function (_ref2) {
	        var has_more = _ref2.has_more;
	        var transactions = _ref2.transactions;
	
	        _this2.context.router.replace(_this2.props.location.pathname + "?" + (0, _qs.stringify)({
	          account_id: accountId,
	          starting_after: startingAfter,
	          ending_before: endingBefore
	        }, { state: { ignoreScrollBehavior: true } }));
	
	        _this2.setState({
	          loading: false,
	          hasMoreTransactions: has_more,
	          balanceTransactions: transactions
	        });
	      }).catch(function (e) {
	        return window.alert(e.message);
	      });
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(newProps) {
	      if (newProps.balance && !this.props.location.query.account_id) {
	        this.context.router.replace(this.props.location.pathname + "?" + (0, _qs.stringify)({
	          account_id: newProps.balance.balances[0].account_id
	        }));
	      }
	
	      if (this.props.location.query.account_id && !this.state.balanceTransactions) {
	        this._loadBalanceTransactions({
	          accountId: this.props.location.query.account_id,
	          startingAfter: this.props.location.query.starting_after,
	          endingBefore: this.props.location.query.ending_before
	        });
	      }
	    }
	  }, {
	    key: "getStyles",
	    value: function getStyles() {
	      return {};
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this3 = this;
	
	      var styles = this.getStyles();
	      var balanceData = this.props.balance;
	
	      if (!balanceData) {
	        return _react2.default.createElement(_workingIndicator2.default, { fullPage: true });
	      }
	
	      var selectedBalance = balanceData.balances[0].balance;
	      var currency = selectedBalance.available[0].currency;
	      var available = selectedBalance.available[0].amount;
	      var pending = selectedBalance.pending[0].amount;
	      var total = available + pending;
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          "h1",
	          null,
	          "Eventive Balance Ledger"
	        ),
	        _react2.default.createElement(
	          _statsBlockContainer2.default,
	          { style: { marginBottom: "1em" } },
	          _react2.default.createElement(_statsBlock2.default, {
	            value: (0, _util.formatPrice)(total, { currency: currency }),
	            label: "Current account balance"
	          }),
	          _react2.default.createElement(_statsBlock2.default, {
	            value: (0, _util.formatPrice)(available, { currency: currency }),
	            label: "Balance available to withdraw"
	          }),
	          _react2.default.createElement(_statsBlock2.default, {
	            value: (0, _util.formatPrice)(0, { currency: currency }),
	            label: "Balance available for instant payout"
	          })
	        ),
	        _react2.default.createElement(
	          "div",
	          { style: { marginBottom: "1em" } },
	          _react2.default.createElement(
	            "div",
	            {
	              style: {
	                float: "right",
	                display: "inline-block",
	                marginBottom: "1em"
	              }
	            },
	            _react2.default.createElement(_materialUi.RaisedButton, {
	              label: "Previous",
	              onClick: function onClick() {
	                _this3._loadBalanceTransactions({
	                  accountId: _this3.props.location.query.account_id,
	                  endingBefore: _this3.state.balanceTransactions[0].id
	                });
	              }
	            }),
	            " ",
	            _react2.default.createElement(_materialUi.RaisedButton, {
	              style: { marginLeft: "1em" },
	              label: "Next",
	              onClick: function onClick() {
	                _this3._loadBalanceTransactions({
	                  accountId: _this3.props.location.query.account_id,
	                  startingAfter: _this3.state.balanceTransactions[_this3.state.balanceTransactions.length - 1].id
	                });
	              }
	            })
	          ),
	          _react2.default.createElement(
	            "div",
	            null,
	            "This ledger serves as the master record of what is going in and out of your Eventive/Stripe balance and, ultimately, your bank account. You can download aggregated reports using the various Bank transfer logs available in ",
	            _react2.default.createElement(
	              _reactRouter.Link,
	              { to: "/reports" },
	              "Global reports"
	            ),
	            "."
	          )
	        ),
	        _react2.default.createElement(_genericAnalyticsTable2.default, {
	          csvLabel: "balance-log",
	          noSort: true,
	          noDownload: true,
	          loading: this.state.loading,
	          data: (this.state.balanceTransactions || []).map(function (transaction) {
	            var eventiveOrderId = transaction.source.metadata.eventive_order || transaction.source.charge && transaction.source.charge.metadata.eventive_order;
	
	            return {
	              date: {
	                value: transaction.created,
	                label: _react2.default.createElement(
	                  "span",
	                  { style: { whiteSpace: "nowrap" } },
	                  (0, _moment2.default)(transaction.created * 1000).format("lll")
	                )
	              },
	              type: {
	                value: transaction.type,
	                label: _react2.default.createElement(
	                  "span",
	                  { style: { whiteSpace: "nowrap" } },
	                  (0, _util.capitalize)((0, _util.unSnakeCase)(transaction.type))
	                )
	              },
	              net: {
	                value: transaction.net,
	                label: _react2.default.createElement(
	                  "span",
	                  { style: { fontWeight: "bold" } },
	                  (0, _util.formatPrice)(transaction.net, {
	                    currency: transaction.currency,
	                    accounting: true
	                  })
	                )
	              },
	              amount: (0, _util.formatPrice)(transaction.amount, {
	                currency: transaction.currency,
	                accounting: true
	              }),
	              fee: (0, _util.formatPrice)(-transaction.fee, {
	                currency: transaction.currency,
	                accounting: true
	              }),
	              description: (eventiveOrderId ? transaction.description.indexOf("Application fee refund") !== -1 ? "Eventive fee refund for order #" + eventiveOrderId : transaction.description.indexOf("REFUND FOR PAYMENT") === 0 ? transaction.description.replace(/(REFUND FOR PAYMENT|REFUND FOR CHARGE)/, "REFUND FOR ORDER #" + eventiveOrderId) : transaction.description.indexOf("Subscription creation") !== -1 ? "Subscription: " + transaction.source.description : null : null) || transaction.description || transaction.id,
	              available: {
	                value: transaction.available_on,
	                label: (0, _moment2.default)(transaction.available_on * 1000).format("MMM D")
	              },
	              actions: {
	                value: 1,
	                label: _react2.default.createElement(
	                  "span",
	                  { style: { whiteSpace: "nowrap" } },
	                  eventiveOrderId ? _react2.default.createElement(
	                    _reactRouter.Link,
	                    { to: "/orders/" + eventiveOrderId, target: "_blank" },
	                    "View order"
	                  ) : null
	                )
	              }
	            };
	          }),
	          columns: [{ label: "Date", value: "date" }, { label: "Type", value: "type" }, { label: "Net", value: "net" }, { label: "Amount", value: "amount" }, { label: "Fee", value: "fee" }, { label: "Description", value: "description" }, { label: "Available", value: "available" }, { label: "Actions", value: "actions" }]
	        })
	      );
	    }
	  }], [{
	    key: "getStores",
	    value: function getStores() {
	      return [_BalanceStore2.default];
	    }
	  }, {
	    key: "getPropsFromStores",
	    value: function getPropsFromStores() {
	      return _BalanceStore2.default.getState();
	    }
	  }, {
	    key: "contextTypes",
	    get: function get() {
	      return {
	        router: _react2.default.PropTypes.object
	      };
	    }
	  }]);
	
	  return Balance;
	}(_react2.default.Component);
	
	exports.default = (0, _connectToStores2.default)(Balance);
	module.exports = exports["default"];

/***/ }),
/* 1740 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var StatsBlockContainer = function (_React$Component) {
	  _inherits(StatsBlockContainer, _React$Component);
	
	  function StatsBlockContainer() {
	    _classCallCheck(this, StatsBlockContainer);
	
	    return _possibleConstructorReturn(this, Object.getPrototypeOf(StatsBlockContainer).apply(this, arguments));
	  }
	
	  _createClass(StatsBlockContainer, [{
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var styles = {
	        container: {
	          display: "flex",
	          marginLeft: -10
	        },
	        child: {
	          width: "100%",
	          marginLeft: 10,
	          marginTop: 10,
	          boxSizing: "border-box"
	        }
	      };
	
	      return _react2.default.createElement(
	        "div",
	        { style: Object.assign({}, styles.container, this.props.style) },
	        this.props.children.filter(function (c) {
	          return !!c;
	        }).map(function (c, i) {
	          return _react2.default.createElement(
	            "div",
	            {
	              key: i,
	              style: Object.assign({}, styles.child, _this2.props["style" + i])
	            },
	            c
	          );
	        })
	      );
	    }
	  }]);
	
	  return StatsBlockContainer;
	}(_react2.default.Component);
	
	exports.default = StatsBlockContainer;
	module.exports = exports["default"];

/***/ }),
/* 1741 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var StatsBlock = function (_React$Component) {
	  _inherits(StatsBlock, _React$Component);
	
	  function StatsBlock() {
	    _classCallCheck(this, StatsBlock);
	
	    return _possibleConstructorReturn(this, Object.getPrototypeOf(StatsBlock).apply(this, arguments));
	  }
	
	  _createClass(StatsBlock, [{
	    key: "render",
	    value: function render() {
	      var _props = this.props;
	      var value = _props.value;
	      var label = _props.label;
	      var subvalue = _props.subvalue;
	      var onTouchTap = _props.onTouchTap;
	      var style = _props.style;
	      var styles = {
	        block: {
	          border: "1px solid #0288d1",
	          minHeight: 88,
	          textAlign: "center",
	          display: "flex",
	          flexDirection: "column",
	          alignItems: "center",
	          justifyContent: "center"
	        },
	        value: {
	          fontWeight: 700,
	          fontSize: "2.5em"
	        },
	        subvalue: {
	          fontWeight: 500,
	          fontSize: "0.75em"
	        },
	        label: {
	          textTransform: "uppercase",
	          marginTop: 7,
	          marginBottom: -5,
	          lineHeight: 1.1,
	          fontSize: "1em"
	        }
	      };
	
	      return _react2.default.createElement(
	        "div",
	        {
	          style: Object.assign({}, styles.block, style),
	          className: onTouchTap ? "statsBlock hvr-bounce-to-bottom" : "statsBlock",
	          onTouchTap: onTouchTap
	        },
	        _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement(
	            "div",
	            { style: styles.value },
	            value,
	            subvalue ? _react2.default.createElement(
	              "span",
	              { style: styles.subvalue },
	              "/" + subvalue
	            ) : null
	          ),
	          _react2.default.createElement(
	            "div",
	            { style: styles.label },
	            label
	          )
	        )
	      );
	    }
	  }]);
	
	  return StatsBlock;
	}(_react2.default.Component);
	
	exports.default = StatsBlock;
	module.exports = exports["default"];

/***/ }),
/* 1742 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _alt = __webpack_require__(975);
	
	var _alt2 = _interopRequireDefault(_alt);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var BalanceActions = function BalanceActions() {
	  _classCallCheck(this, BalanceActions);
	
	  this.generateActions("fetchBalance", "fetchFailed");
	};
	
	exports.default = _alt2.default.createActions(BalanceActions);
	module.exports = exports["default"];

/***/ }),
/* 1743 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _alt = __webpack_require__(975);
	
	var _alt2 = _interopRequireDefault(_alt);
	
	var _keyBy = __webpack_require__(990);
	
	var _keyBy2 = _interopRequireDefault(_keyBy);
	
	var _BalanceUtil = __webpack_require__(1744);
	
	var _BalanceUtil2 = _interopRequireDefault(_BalanceUtil);
	
	var _BalanceActions = __webpack_require__(1742);
	
	var _BalanceActions2 = _interopRequireDefault(_BalanceActions);
	
	var _UserStore = __webpack_require__(974);
	
	var _UserStore2 = _interopRequireDefault(_UserStore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var BalanceStore = function () {
	  function BalanceStore() {
	    _classCallCheck(this, BalanceStore);
	
	    this.bindActions(_BalanceActions2.default);
	
	    this.state = {
	      isFetching: false,
	      balance: null
	    };
	  }
	
	  _createClass(BalanceStore, [{
	    key: "onFetchBalance",
	    value: function onFetchBalance() {
	      var _this = this;
	
	      _BalanceUtil2.default.fetchBalance(_UserStore2.default.getState().apiKey).then(function (data) {
	        _this.setState({ balance: data });
	      }).catch(_BalanceActions2.default.fetchFailed);
	    }
	  }, {
	    key: "onFetchFailed",
	    value: function onFetchFailed(e) {
	      alert("Fetching balance data failed: " + e.message);
	      throw e;
	    }
	  }]);
	
	  return BalanceStore;
	}();
	
	exports.default = _alt2.default.createStore(BalanceStore, "BalanceStore");
	module.exports = exports["default"];

/***/ }),
/* 1744 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _api = __webpack_require__(1160);
	
	var _api2 = _interopRequireDefault(_api);
	
	var _config = __webpack_require__(1173);
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  fetchBalance: function fetchBalance(apiKey) {
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "POST",
	        endpoint: "financials/balance",
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response);
	      });
	    });
	  },
	  fetchBalanceTransactions: function fetchBalanceTransactions(apiKey, _ref) {
	    var startingAfter = _ref.startingAfter;
	    var endingBefore = _ref.endingBefore;
	    var accountId = _ref.accountId;
	
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "POST",
	        endpoint: "financials/balance_transactions",
	        json: {
	          starting_after: startingAfter,
	          ending_before: endingBefore,
	          account_id: accountId
	        },
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response);
	      });
	    });
	  }
	};
	module.exports = exports["default"];

/***/ }),
/* 1745 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _moment = __webpack_require__(1021);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _reactRouter = __webpack_require__(486);
	
	var _materialUi = __webpack_require__(576);
	
	var _colors = __webpack_require__(821);
	
	var colors = _interopRequireWildcard(_colors);
	
	var _reactSelect = __webpack_require__(953);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	var _workingIndicator = __webpack_require__(1664);
	
	var _workingIndicator2 = _interopRequireDefault(_workingIndicator);
	
	var _statsBlockContainer = __webpack_require__(1740);
	
	var _statsBlockContainer2 = _interopRequireDefault(_statsBlockContainer);
	
	var _statsBlock = __webpack_require__(1741);
	
	var _statsBlock2 = _interopRequireDefault(_statsBlock);
	
	var _label = __webpack_require__(1682);
	
	var _label2 = _interopRequireDefault(_label);
	
	var _addLineItem = __webpack_require__(1746);
	
	var _addLineItem2 = _interopRequireDefault(_addLineItem);
	
	var _linkLike = __webpack_require__(973);
	
	var _linkLike2 = _interopRequireDefault(_linkLike);
	
	var _connectToStores = __webpack_require__(1226);
	
	var _connectToStores2 = _interopRequireDefault(_connectToStores);
	
	var _UserStore = __webpack_require__(974);
	
	var _UserStore2 = _interopRequireDefault(_UserStore);
	
	var _UserActions = __webpack_require__(1158);
	
	var _UserActions2 = _interopRequireDefault(_UserActions);
	
	var _GodActions = __webpack_require__(1748);
	
	var _GodActions2 = _interopRequireDefault(_GodActions);
	
	var _UserUtil = __webpack_require__(1159);
	
	var _UserUtil2 = _interopRequireDefault(_UserUtil);
	
	var _BillingUtil = __webpack_require__(1749);
	
	var _BillingUtil2 = _interopRequireDefault(_BillingUtil);
	
	var _util = __webpack_require__(1183);
	
	var _genericAnalyticsTable = __webpack_require__(1687);
	
	var _genericAnalyticsTable2 = _interopRequireDefault(_genericAnalyticsTable);
	
	var _userEditorModal = __webpack_require__(1750);
	
	var _userEditorModal2 = _interopRequireDefault(_userEditorModal);
	
	var _inlineNoticeLabel = __webpack_require__(1222);
	
	var _inlineNoticeLabel2 = _interopRequireDefault(_inlineNoticeLabel);
	
	var _queryString = __webpack_require__(513);
	
	var _queryString2 = _interopRequireDefault(_queryString);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var parsedQueryString = _queryString2.default.parse(window.location.search);
	
	var BILLING_TIMEZONE = "America/Chicago";
	
	var Billing = function (_React$Component) {
	  _inherits(Billing, _React$Component);
	
	  function Billing(props) {
	    _classCallCheck(this, Billing);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(Billing).call(this, props));
	
	    _this.state = {
	      summary: null,
	
	      selectedMonth: parsedQueryString.month || (0, _moment2.default)().tz(BILLING_TIMEZONE).format("MM-YYYY"),
	      invoicePreview: null,
	      invoiceDisplayMode: "summary",
	
	      billingEmails: [],
	
	      isAttemptingComp: null,
	      isEditingLineItem: null,
	
	      isFinalizing: false
	    };
	
	    _this._fakeEventBucket = _this._fakeEventBucket.bind(_this);
	    return _this;
	  }
	
	  _createClass(Billing, [{
	    key: "activateVirtual",
	    value: function activateVirtual() {
	      _UserUtil2.default.generateVirtualActivationLink({
	        apiKey: _UserStore2.default.getState().apiKey
	      }).then(function (_ref) {
	        var url = _ref.url;
	
	        window.location.href = url + "&next=" + encodeURIComponent(window.location.href);
	      });
	    }
	  }, {
	    key: "manageVirtual",
	    value: function manageVirtual() {
	      _UserUtil2.default.generateVirtualManagementLink({
	        apiKey: _UserStore2.default.getState().apiKey,
	        next: window.location.href
	      }).then(function (_ref2) {
	        var url = _ref2.url;
	
	        window.location.href = url;
	      });
	    }
	  }, {
	    key: "updateSubscription",
	    value: function updateSubscription(opts) {
	      var _this2 = this;
	
	      this.setState({ isUpdating: true });
	      _BillingUtil2.default.updateSettings(_UserStore2.default.getState().apiKey, opts).then(function () {
	        return _this2._loadSummary();
	      }).then(function () {
	        return _this2.setState({ isUpdating: false });
	      }).catch(function (e) {
	        return window.alert("Update failed: " + e.message);
	      });
	    }
	  }, {
	    key: "performAdjustment",
	    value: function performAdjustment(opts) {
	      var _this3 = this;
	
	      var adjustment = {
	        action: opts.action,
	        amount: opts.amount,
	        currency: opts.currency,
	        date: opts.date,
	        description: opts.description,
	        target: opts.target,
	        owner: _UserStore2.default.getUserId()
	      };
	      _BillingUtil2.default.performAdjustment(_UserStore2.default.getState().apiKey, adjustment).then(function () {
	        _this3.setState({
	          isAttemptingComp: null,
	          isEditingLineItem: null
	        });
	        _this3._loadInvoicePreview({ quiet: true });
	      }).catch(function (e) {
	        return window.alert("Adjustment failed: " + e.message);
	      });
	    }
	  }, {
	    key: "finalize",
	    value: function finalize() {
	      var _this4 = this;
	
	      this.setState({ loading: true, isFinalizing: true });
	      _BillingUtil2.default.pushInvoiceToStripe(_UserStore2.default.getState().apiKey, {
	        month: this.state.selectedMonth
	      }).then(function (_ref3) {
	        var invoice = _ref3.invoice;
	
	        _this4.setState({
	          loading: false,
	          isFinalizing: false,
	          invoicePreview: invoice
	        });
	      }).catch(function (e) {
	        _this4.setState({
	          loading: false,
	          isFinalizing: false
	        });
	        window.alert("Finalization failed: " + e.message);
	      });
	    }
	  }, {
	    key: "_loadSummary",
	    value: function _loadSummary() {
	      var _this5 = this;
	
	      return _BillingUtil2.default.fetchBillingSummary(_UserStore2.default.getState().apiKey).then(function (data) {
	        _this5.setState({ summary: data });
	      });
	    }
	  }, {
	    key: "_loadInvoicePreview",
	    value: function _loadInvoicePreview() {
	      var _this6 = this;
	
	      var _ref4 = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	      var quiet = _ref4.quiet;
	
	      var selectingMonth = this.state.selectedMonth;
	      var start = _moment2.default.tz(this.state.selectedMonth, "MM-YYYY", BILLING_TIMEZONE).startOf("month");
	      var end = _moment2.default.tz(this.state.selectedMonth, "MM-YYYY", BILLING_TIMEZONE).endOf("month");
	
	      this.setState(Object.assign({ loading: true }, !quiet && { invoicePreview: null }));
	
	      _BillingUtil2.default.fetchInvoicePreview(_UserStore2.default.getState().apiKey, {
	        start: start,
	        end: end
	      }).then(function (_ref5) {
	        var preview = _ref5.preview;
	
	        if (_this6.state.selectedMonth === selectingMonth) {
	          _this6.setState({
	            loading: false,
	            invoicePreview: preview
	          });
	        }
	      }).catch(function (e) {
	        return window.alert(e.message);
	      });
	    }
	  }, {
	    key: "_fakeEventBucket",
	    value: function _fakeEventBucket() {
	      var _ref6 = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	      var name = _ref6.name;
	      var timezone = _ref6.timezone;
	
	      _GodActions2.default.createFakeEventBucket({
	        user: _UserStore2.default.getState().user.id,
	        name: name,
	        timezone: timezone
	      });
	      this.setState({ showGodUserSettings: false });
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(newProps) {
	      if (!this.state.loading && !this.state.invoicePreview) {
	        this._loadSummary();
	        this._loadInvoicePreview();
	      }
	    }
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      _UserActions2.default.fetchUser.defer();
	      this.componentWillReceiveProps(this.props);
	    }
	  }, {
	    key: "_generateMonths",
	    value: function _generateMonths() {
	      var curr = _moment2.default.tz("02-2021", "MM-YYYY", BILLING_TIMEZONE) // first month of ledger billing = Feb 2021
	      .startOf("month");
	      var end = (0, _moment2.default)().tz(BILLING_TIMEZONE).startOf("month");
	
	      var months = [];
	
	      while (curr) {
	        if (curr <= end) {
	          months.push({
	            value: curr.format("MM-YYYY"),
	            label: curr.diff(end) === 0 ? (0, _moment2.default)().tz(BILLING_TIMEZONE).format("MMMM [1]–D, YYYY") : curr.format("MMMM YYYY"),
	            _end: (0, _moment2.default)(curr).endOf("month")
	          });
	          curr.add(1, "month");
	        } else {
	          curr = null;
	        }
	      }
	
	      return months.reverse();
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this7 = this;
	
	      var months = this._generateMonths();
	      var _state = this.state;
	      var invoiceDisplayMode = _state.invoiceDisplayMode;
	      var invoicePreview = _state.invoicePreview;
	      var summary = _state.summary;
	
	
	      var invoiceRawMonth = months.find(function (m) {
	        return m.value === _this7.state.selectedMonth;
	      });
	      var invoiceLabel = invoiceRawMonth && invoiceRawMonth.label;
	
	      var lineItems = void 0;
	
	      if (this.state.invoicePreview) {
	        if (invoiceDisplayMode === "summary") {
	          lineItems = {};
	          for (var currency in invoicePreview.line_items) {
	            var items = invoicePreview.line_items[currency];
	            var groups = {};
	            var _iteratorNormalCompletion = true;
	            var _didIteratorError = false;
	            var _iteratorError = undefined;
	
	            try {
	              for (var _iterator = items[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                var i = _step.value;
	
	                var category = i.editable_id ? i.editable_id : i.category;
	
	                if (!groups[category]) {
	                  groups[category] = {
	                    category: i.category,
	                    description: [],
	                    count: 0,
	                    amount: 0,
	                    currency: currency
	                  };
	                }
	
	                groups[category].description.push("" + i.description + (i.summary_count ? " (" + i.summary_count + ")" : ""));
	                if (!i.editable_id) {
	                  groups[category].count += i.summary_count || 1;
	                }
	                groups[category].amount += i.amount;
	              }
	            } catch (err) {
	              _didIteratorError = true;
	              _iteratorError = err;
	            } finally {
	              try {
	                if (!_iteratorNormalCompletion && _iterator.return) {
	                  _iterator.return();
	                }
	              } finally {
	                if (_didIteratorError) {
	                  throw _iteratorError;
	                }
	              }
	            }
	
	            lineItems[currency] = Object.values(groups);
	          }
	        } else {
	          lineItems = invoicePreview.line_items;
	        }
	      }
	
	      var isBillingGod = _UserStore2.default.isBillingGod();
	      var user = _UserStore2.default.getState().user;
	
	      var latestInvoiceBlurb = summary && summary.subscription_data && summary.subscription_data.latest_invoice ? _react2.default.createElement(
	        "div",
	        { style: { fontSize: 12, marginTop: 5 } },
	        _react2.default.createElement(
	          "a",
	          {
	            href: summary.subscription_data.latest_invoice.link,
	            target: "_blank"
	          },
	          "Download",
	          " ",
	          (0, _moment2.default)(summary.subscription_data.latest_invoice.date_paid).format("l"),
	          " ",
	          "receipt for US$",
	          (summary.subscription_data.latest_invoice.amount_due / 100).toFixed(2)
	        )
	      ) : null;
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        this.state.showGodUserSettings ? _react2.default.createElement(_userEditorModal2.default, {
	          user: user,
	          roles: _UserStore2.default.getState().roles,
	          onSave: function onSave(data) {
	            _UserActions2.default.godEditUser(user.id, data);
	            _this7.setState({ showGodUserSettings: false });
	            setTimeout(function () {
	              return _this7._loadSummary();
	            }, 2000);
	          },
	          onCancel: function onCancel() {
	            _this7.setState({ showGodUserSettings: false });
	          },
	          onFakeEventBucket: this._fakeEventBucket
	        }) : null,
	        _react2.default.createElement(
	          "div",
	          { style: { display: "flex", fontSize: "12pt" } },
	          _react2.default.createElement(
	            "div",
	            {
	              style: {
	                width: "30%",
	                minWidth: 200,
	                maxWidth: 300,
	                marginRight: 30,
	                paddingTop: 10
	              }
	            },
	            _react2.default.createElement(
	              "h2",
	              { style: { marginBottom: 20 } },
	              "Eventive Billing Hub"
	            ),
	            _react2.default.createElement(
	              "p",
	              null,
	              "Welcome to the Eventive Billing Hub! You can use this page to view past and upcoming invoices.",
	              _UserStore2.default.isGod() && summary && summary.meta ? _react2.default.createElement(
	                "div",
	                { style: { marginTop: 15, fontSize: "0.75rem" } },
	                _react2.default.createElement(
	                  _label2.default,
	                  null,
	                  "Eventive God Quick Controls"
	                ),
	                _react2.default.createElement(
	                  "div",
	                  null,
	                  _react2.default.createElement(
	                    _linkLike2.default,
	                    {
	                      onTouchTap: function onTouchTap() {
	                        return _this7.setState({ showGodUserSettings: true });
	                      }
	                    },
	                    "Edit Organization"
	                  ),
	                  " ",
	                  "\xB7 ",
	                  _react2.default.createElement(
	                    "code",
	                    null,
	                    user.id
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  null,
	                  _react2.default.createElement(
	                    "a",
	                    {
	                      href: "https://dashboard.stripe.com/customers/" + summary.meta.stripe_customer_id,
	                      target: "_blank"
	                    },
	                    "View Stripe Customer"
	                  ),
	                  " ",
	                  "\xB7 ",
	                  _react2.default.createElement(
	                    "code",
	                    null,
	                    summary.meta.stripe_customer_id
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  null,
	                  _react2.default.createElement(
	                    "a",
	                    {
	                      href: "https://dashboard.stripe.com/connect/accounts/" + summary.meta.stripe_account_id,
	                      target: "_blank"
	                    },
	                    "View Stripe Account"
	                  ),
	                  " ",
	                  "\xB7",
	                  " ",
	                  !summary.meta.stripe_account_id ? _react2.default.createElement(_inlineNoticeLabel2.default, {
	                    style: {
	                      marginLeft: 2,
	                      fontWeight: "bold",
	                      backgroundColor: "orange"
	                    },
	                    label: "No account connected"
	                  }) : summary.meta.is_platform_managed ? _react2.default.createElement(_inlineNoticeLabel2.default, {
	                    style: {
	                      marginLeft: 2,
	                      fontWeight: "bold",
	                      backgroundColor: "green"
	                    },
	                    label: "Platform managed"
	                  }) : _react2.default.createElement(
	                    "code",
	                    null,
	                    summary.meta.stripe_account_id
	                  )
	                )
	              ) : null
	            ),
	            summary && user ? _react2.default.createElement(
	              "div",
	              null,
	              _react2.default.createElement(
	                "div",
	                null,
	                _react2.default.createElement(
	                  _label2.default,
	                  null,
	                  "Organization"
	                ),
	                _react2.default.createElement(
	                  "div",
	                  null,
	                  user.organization
	                ),
	                _react2.default.createElement(
	                  "div",
	                  null,
	                  _react2.default.createElement(
	                    "code",
	                    {
	                      style: {
	                        fontWeight: "bold",
	                        backgroundColor: "rgba(0,0,0,0.1)",
	                        padding: "2px 4px",
	                        fontSize: 12
	                      }
	                    },
	                    _UserStore2.default.getUserId()
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { style: { marginTop: 20 } },
	                _react2.default.createElement(
	                  _label2.default,
	                  null,
	                  "Account primary currency"
	                ),
	                _react2.default.createElement(
	                  "div",
	                  null,
	                  user.currency.toUpperCase()
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { style: { marginTop: 20 } },
	                _react2.default.createElement(
	                  _label2.default,
	                  null,
	                  "Eventive Virtual subscription"
	                ),
	                this.state.isUpdating ? _react2.default.createElement(
	                  "div",
	                  null,
	                  "Loading..."
	                ) : user.virtual_festival_plan === "distributor" && user.virtual_festival_plan_status === "active" ? _react2.default.createElement(
	                  "div",
	                  null,
	                  _react2.default.createElement(
	                    "div",
	                    null,
	                    _react2.default.createElement(
	                      "strong",
	                      null,
	                      _react2.default.createElement(
	                        "span",
	                        {
	                          style: {
	                            backgroundColor: "#4CAF50",
	                            padding: "2px 4px",
	                            color: "white"
	                          }
	                        },
	                        "Your Distributor plan is active."
	                      ),
	                      " ",
	                      "Each new film ingestion is subject to a US$100 fee."
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    {
	                      style: {
	                        fontSize: 12,
	                        lineHeight: 1.2,
	                        marginTop: 5,
	                        color: "rgba(0,0,0,0.7)"
	                      }
	                    },
	                    "If you wish to upgrade your plan for unlimited use of the platform, please",
	                    " ",
	                    _react2.default.createElement(
	                      _linkLike2.default,
	                      {
	                        onTouchTap: function onTouchTap() {
	                          return Intercom("showNewMessage", "I would like to speak with the sales team about upgrading my Eventive Distributor account. ");
	                        }
	                      },
	                      "contact us"
	                    ),
	                    "."
	                  )
	                ) : user.virtual_festival_plan === "single_film" && user.virtual_festival_plan_status === "active" ? _react2.default.createElement(
	                  "div",
	                  null,
	                  _react2.default.createElement(
	                    "div",
	                    null,
	                    _react2.default.createElement(
	                      "strong",
	                      null,
	                      _react2.default.createElement(
	                        "span",
	                        {
	                          style: {
	                            backgroundColor: "#4CAF50",
	                            padding: "2px 4px",
	                            color: "white"
	                          }
	                        },
	                        "Your Single Film plan is active."
	                      ),
	                      " ",
	                      "Each film is subject to a US$299 fee."
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    {
	                      style: {
	                        fontSize: 12,
	                        lineHeight: 1.2,
	                        marginTop: 5,
	                        color: "rgba(0,0,0,0.7)"
	                      }
	                    },
	                    "If you wish to upgrade your plan for unlimited use of the platform, please",
	                    " ",
	                    _react2.default.createElement(
	                      _linkLike2.default,
	                      {
	                        onTouchTap: function onTouchTap() {
	                          return Intercom("showNewMessage", "I would like to speak with the sales team about upgrading my Eventive Single Film account to a full activation! ");
	                        }
	                      },
	                      "contact us"
	                    ),
	                    "."
	                  )
	                ) : summary.subscription_data && summary.subscription_data.outstanding_invoice ? _react2.default.createElement(
	                  "div",
	                  null,
	                  _react2.default.createElement(
	                    "strong",
	                    null,
	                    _react2.default.createElement(
	                      "span",
	                      {
	                        style: {
	                          backgroundColor: "orange",
	                          padding: "2px 4px",
	                          color: "white"
	                        }
	                      },
	                      "It's time to renew!"
	                    ),
	                    " ",
	                    "Your US",
	                    (0, _util.formatPrice)(summary.subscription_data.outstanding_invoice.amount_due, { currency: "usd", locale: "en-US" }),
	                    " ",
	                    "invoice is pending \u2013",
	                    " ",
	                    (0, _moment2.default)(summary.subscription_data.outstanding_invoice.date_due) > Date.now() ? (0, _moment2.default)(summary.subscription_data.outstanding_invoice.date_due).startOf("day").from((0, _moment2.default)().startOf("day"), true) + " left to pay" : "payment is now past due",
	                    "."
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { style: { marginTop: 10, marginBottom: 5 } },
	                    _react2.default.createElement(_materialUi.RaisedButton, {
	                      primary: true,
	                      label: "Renew Eventive Virtual",
	                      onClick: function onClick() {
	                        window.open(summary.subscription_data.outstanding_invoice.link, "_blank");
	                      }
	                    })
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { style: { fontSize: 12, marginTop: 0 } },
	                    _react2.default.createElement(
	                      _linkLike2.default,
	                      {
	                        onTouchTap: function onTouchTap() {
	                          if (window.confirm("Are you sure? Your access to Eventive Virtual will be terminated immediately.")) {
	                            _this7.updateSubscription({
	                              cancel: true
	                            });
	                          }
	                        }
	                      },
	                      "Cancel subscription immediately"
	                    )
	                  )
	                ) : summary.subscription_data && !summary.subscription_data.should_autorenew ? _react2.default.createElement(
	                  "div",
	                  null,
	                  _react2.default.createElement(
	                    "div",
	                    null,
	                    _react2.default.createElement(
	                      "strong",
	                      null,
	                      _react2.default.createElement(
	                        "span",
	                        {
	                          style: {
	                            backgroundColor: "#4CAF50",
	                            padding: "2px 4px",
	                            color: "white"
	                          }
	                        },
	                        "Your subscription is active!"
	                      ),
	                      " ",
	                      "Your plan will expire",
	                      " ",
	                      (0, _moment2.default)(summary.subscription_data.current_period_end).fromNow(),
	                      "."
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    {
	                      style: {
	                        fontSize: 12,
	                        lineHeight: 1.2,
	                        marginTop: 5,
	                        color: "rgba(0,0,0,0.7)"
	                      }
	                    },
	                    "On",
	                    " ",
	                    (0, _moment2.default)(summary.subscription_data.current_period_end).format("LL"),
	                    ", your subscription will be immediately canceled and all virtual screenings will be disabled. Enable renewal below to avoid this."
	                  ),
	                  latestInvoiceBlurb,
	                  _react2.default.createElement(
	                    "div",
	                    { style: { fontSize: 12, marginTop: 0 } },
	                    _react2.default.createElement(
	                      _linkLike2.default,
	                      {
	                        onTouchTap: function onTouchTap() {
	                          return _this7.updateSubscription({
	                            should_autorenew: true
	                          });
	                        }
	                      },
	                      "Enable subscription renewal"
	                    )
	                  )
	                ) : summary.subscription_data && summary.subscription_data.should_autorenew ? _react2.default.createElement(
	                  "div",
	                  null,
	                  _react2.default.createElement(
	                    "div",
	                    null,
	                    _react2.default.createElement(
	                      "strong",
	                      null,
	                      _react2.default.createElement(
	                        "span",
	                        {
	                          style: {
	                            backgroundColor: "#4CAF50",
	                            padding: "2px 4px",
	                            color: "white"
	                          }
	                        },
	                        "Your subscription is active!"
	                      ),
	                      " ",
	                      "Your plan will renew",
	                      " ",
	                      (0, _moment2.default)(summary.subscription_data.current_period_end).fromNow(),
	                      "."
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    {
	                      style: {
	                        fontSize: 12,
	                        lineHeight: 1.2,
	                        marginTop: 5,
	                        color: "rgba(0,0,0,0.7)"
	                      }
	                    },
	                    "You will receive a renewal invoice on",
	                    " ",
	                    (0, _moment2.default)(summary.subscription_data.current_period_end).format("LL"),
	                    ". If not paid within 30 days of receipt, your subscription will be canceled."
	                  ),
	                  latestInvoiceBlurb,
	                  _react2.default.createElement(
	                    "div",
	                    { style: { fontSize: 12, marginTop: 0 } },
	                    _react2.default.createElement(
	                      _linkLike2.default,
	                      {
	                        onTouchTap: function onTouchTap() {
	                          if (summary.subscription_data.subscription_schedule_id) {
	                            Intercom("showNewMessage", "I would like to cancel my scheduled subscription: ");
	                          } else {
	                            _this7.updateSubscription({
	                              should_autorenew: false
	                            });
	                          }
	                        }
	                      },
	                      "Cancel subscription (disable renewal)"
	                    )
	                  )
	                ) : _react2.default.createElement(
	                  "div",
	                  null,
	                  _react2.default.createElement(
	                    "strong",
	                    null,
	                    "No current Eventive Virtual subscription."
	                  ),
	                  " ",
	                  _react2.default.createElement(
	                    "a",
	                    { href: "https://eventive.org/virtual", target: "_blank" },
	                    "Learn more."
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { style: { marginTop: 10, marginBottom: 5 } },
	                    _react2.default.createElement(_materialUi.RaisedButton, {
	                      primary: true,
	                      label: "Activate Eventive Virtual",
	                      onClick: function onClick() {
	                        return _this7.activateVirtual();
	                      }
	                    })
	                  )
	                )
	              ),
	              !this.state.isUpdating ? _react2.default.createElement(
	                "div",
	                { style: { fontSize: 12, marginTop: 0 } },
	                _react2.default.createElement(
	                  _linkLike2.default,
	                  {
	                    onTouchTap: function onTouchTap() {
	                      _this7.manageVirtual();
	                    }
	                  },
	                  "View past receipts"
	                )
	              ) : null,
	              summary.ingest_credit_remaining ? _react2.default.createElement(
	                "div",
	                { style: { marginTop: 20 } },
	                _react2.default.createElement(
	                  _label2.default,
	                  null,
	                  "Remaining Eventive Virtual ingestion credit"
	                ),
	                _react2.default.createElement(
	                  "div",
	                  null,
	                  "US",
	                  (0, _util.formatPrice)(summary.ingest_credit_remaining, {
	                    currency: "usd",
	                    locale: "en-US"
	                  })
	                ),
	                _react2.default.createElement(
	                  "div",
	                  {
	                    style: {
	                      fontSize: 12,
	                      lineHeight: 1.2,
	                      marginTop: 5,
	                      color: "rgba(0,0,0,0.7)"
	                    }
	                  },
	                  "The above credit will be automatically applied to your incurred content ingestion fees."
	                )
	              ) : null
	            ) : _react2.default.createElement(
	              "div",
	              { style: { marginTop: 60, textAlign: "center" } },
	              _react2.default.createElement(
	                "p",
	                null,
	                "Loading summary..."
	              ),
	              _react2.default.createElement(_workingIndicator2.default, { centered: true })
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { style: { flex: 1 } },
	            _react2.default.createElement(
	              "h3",
	              { style: { display: "flex", alignItems: "center" } },
	              _react2.default.createElement(
	                "span",
	                { style: { whiteSpace: "nowrap" } },
	                "Your Eventive invoice for"
	              ),
	              _react2.default.createElement(
	                "div",
	                {
	                  style: {
	                    display: "inline-block",
	                    width: 250,
	                    marginLeft: 10
	                  }
	                },
	                _react2.default.createElement(_reactSelect2.default, {
	                  clearable: false,
	                  value: this.state.selectedMonth,
	                  options: months,
	                  onChange: function onChange(e) {
	                    return _this7.setState({ selectedMonth: e.value }, function () {
	                      _this7.context.router.replace("/billing?month=" + e.value);
	                      _this7._loadInvoicePreview();
	                    });
	                  }
	                })
	              )
	            ),
	            !invoicePreview ? _react2.default.createElement(
	              "div",
	              { style: { marginTop: 60, textAlign: "center" } },
	              _react2.default.createElement(
	                "p",
	                null,
	                "Generating invoice..."
	              ),
	              _react2.default.createElement(_workingIndicator2.default, { centered: true })
	            ) : _react2.default.createElement(
	              "div",
	              null,
	              invoicePreview && invoicePreview.finalized_at ? _react2.default.createElement(
	                "p",
	                null,
	                "Thank you for partnering with Eventive! This is your Eventive invoice for ",
	                invoiceLabel,
	                ". If you have any questions, please",
	                " ",
	                _react2.default.createElement(
	                  _linkLike2.default,
	                  {
	                    onTouchTap: function onTouchTap() {
	                      return Intercom("showNewMessage", "I have a question about my " + invoiceLabel + " invoice: ");
	                    }
	                  },
	                  "send us a message"
	                ),
	                "."
	              ) : _react2.default.createElement(
	                "p",
	                null,
	                "This a ",
	                _react2.default.createElement(
	                  "strong",
	                  null,
	                  "PREVIEW ONLY"
	                ),
	                " of your upcoming Eventive invoice for",
	                " ",
	                (0, _moment2.default)(this.state.selectedMonth, "MM-YYYY").format("MMMM YYYY"),
	                ". Your final invoice may change,",
	                " ",
	                _react2.default.createElement(
	                  "strong",
	                  null,
	                  "PERHAPS SIGNIFICANTLY"
	                ),
	                ", due to a number of possible factors, including (but not limited to) rebate of never-watched deferred unlock fees, free ingest credits included in your plan, premium services purchased that are not listed here, etc."
	              ),
	              _react2.default.createElement(
	                "div",
	                {
	                  style: {
	                    display: "inline-block",
	                    borderRadius: 5,
	                    padding: 15,
	                    border: "1px dashed #ccc",
	                    marginBottom: 10
	                  }
	                },
	                "Status:",
	                " ",
	                invoicePreview.invoice_status === "paid" ? _react2.default.createElement(
	                  "strong",
	                  null,
	                  "Payment received \u2013 thank you!",
	                  invoicePreview.invoice_pdf_url ? _react2.default.createElement(
	                    "span",
	                    null,
	                    " ",
	                    "\xB7",
	                    " ",
	                    _react2.default.createElement(
	                      "a",
	                      {
	                        href: invoicePreview.invoice_pdf_url,
	                        target: "_blank"
	                      },
	                      "Download invoice PDF"
	                    )
	                  ) : null
	                ) : invoicePreview.invoice_status === "uncollectible" || invoicePreview.invoice_status === "void" ? _react2.default.createElement(
	                  "strong",
	                  null,
	                  "Invoice marked ",
	                  invoicePreview.invoice_status
	                ) : invoicePreview.finalized_at ? _react2.default.createElement(
	                  "strong",
	                  null,
	                  "Finalized",
	                  " ",
	                  (0, _moment2.default)(invoicePreview.finalized_at).format("lll")
	                ) : _react2.default.createElement(
	                  "strong",
	                  null,
	                  "Not yet finalized"
	                ),
	                invoicePreview.finalized_at && (invoicePreview.invoice_status === "draft" || invoicePreview.invoice_status === "open" || invoicePreview.invoice_status === "not_yet_sent") ? invoicePreview.invoice_payment_url ? _react2.default.createElement(
	                  "div",
	                  null,
	                  _react2.default.createElement(
	                    "div",
	                    null,
	                    "Payment terms: Due in 30 days"
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { style: { marginTop: 10 } },
	                    _react2.default.createElement(_materialUi.RaisedButton, {
	                      primary: true,
	                      label: "Pay this invoice...",
	                      onClick: function onClick() {
	                        window.location.href = invoicePreview.invoice_payment_url;
	                      }
	                    })
	                  ),
	                  invoicePreview.invoice_pdf_url ? _react2.default.createElement(
	                    "div",
	                    { style: { marginTop: 10 } },
	                    _react2.default.createElement(
	                      "a",
	                      {
	                        href: invoicePreview.invoice_pdf_url,
	                        target: "_blank"
	                      },
	                      "Download invoice PDF"
	                    )
	                  ) : null
	                ) : _react2.default.createElement(
	                  "div",
	                  null,
	                  "Payment link and invoice PDF will be available shortly."
	                ) : null,
	                isBillingGod ? _react2.default.createElement(
	                  "div",
	                  { style: { marginTop: 10 } },
	                  _react2.default.createElement(_materialUi.RaisedButton, {
	                    primary: !invoicePreview.finalized_at,
	                    disabled: this.state.isFinalizing || invoicePreview.invoice_payment_url,
	                    label: invoicePreview.invoice_payment_url ? "Invoice has been sent" : invoicePreview.finalized_at ? "Re-finalize and overwrite in Stripe" : "Finalize and push to Stripe",
	                    onClick: function onClick() {
	                      if (invoicePreview.finalized_at && !window.confirm("This will overwrite the invoice in Stripe. Are you sure?")) {
	                        return;
	                      }
	                      _this7.finalize();
	                    }
	                  }),
	                  invoicePreview.stripe_invoice_id ? _react2.default.createElement(_materialUi.RaisedButton, {
	                    style: { marginLeft: 10 },
	                    label: invoicePreview.invoice_payment_url ? "View in Stripe" : "Send in Stripe",
	                    onClick: function onClick() {
	                      window.open("https://dashboard.stripe.com/invoices/" + invoicePreview.stripe_invoice_id + "/edit", "_blank");
	                    }
	                  }) : null
	                ) : null
	              ),
	              _react2.default.createElement(
	                "div",
	                { style: { marginBottom: 20 } },
	                this.state.loading && _react2.default.createElement(
	                  "div",
	                  {
	                    style: {
	                      position: "fixed",
	                      textAlign: "center",
	                      top: 64,
	                      left: 256,
	                      right: 0,
	                      padding: 20,
	                      backgroundColor: colors.green700,
	                      color: "#fff",
	                      zIndex: 999
	                    }
	                  },
	                  "Loading updated invoice..."
	                ),
	                _react2.default.createElement(
	                  "div",
	                  null,
	                  _react2.default.createElement(
	                    _label2.default,
	                    null,
	                    "Invoice display mode"
	                  ),
	                  _react2.default.createElement(
	                    _materialUi.RadioButtonGroup,
	                    {
	                      valueSelected: this.state.invoiceDisplayMode,
	                      onChange: function onChange(e, v) {
	                        return _this7.setState({ invoiceDisplayMode: v });
	                      }
	                    },
	                    _react2.default.createElement(_materialUi.RadioButton, {
	                      style: { display: "inline-block", width: 130 },
	                      value: "summary",
	                      label: "Summary"
	                    }),
	                    _react2.default.createElement(_materialUi.RadioButton, {
	                      style: { display: "inline-block", width: 130 },
	                      value: "itemized",
	                      label: "Itemized"
	                    })
	                  )
	                )
	              ),
	              Object.keys(lineItems).length === 0 ? _react2.default.createElement(
	                "div",
	                null,
	                _react2.default.createElement(
	                  "div",
	                  {
	                    style: {
	                      border: "1px solid #ccc",
	                      borderRadius: "1em",
	                      padding: 20,
	                      fontWeight: "bold",
	                      textAlign: "center"
	                    }
	                  },
	                  "Your invoice for ",
	                  invoiceLabel,
	                  " is currently estimated to be $0.00."
	                ),
	                isBillingGod && invoiceDisplayMode === "itemized" ? _react2.default.createElement(
	                  "div",
	                  { style: { fontSize: 13 } },
	                  _react2.default.createElement(_addLineItem2.default, {
	                    currency: "usd",
	                    onSubmit: function onSubmit(_ref7) {
	                      var description = _ref7.description;
	                      var amount = _ref7.amount;
	
	                      _this7.performAdjustment({
	                        action: "create",
	                        currency: "usd",
	                        amount: amount,
	                        description: description,
	                        date: invoiceRawMonth._end
	                      });
	                    }
	                  })
	                ) : null
	              ) : _react2.default.createElement(
	                "div",
	                null,
	                Object.keys(lineItems).map(function (currency) {
	                  return _react2.default.createElement(
	                    "div",
	                    { key: currency, style: { marginTop: "1em" } },
	                    Object.keys(lineItems).length > 1 ? _react2.default.createElement(
	                      "h4",
	                      null,
	                      currency.toUpperCase(),
	                      "-denominated invoice preview"
	                    ) : null,
	                    _react2.default.createElement(
	                      "div",
	                      { style: { fontSize: 13 } },
	                      _react2.default.createElement(_genericAnalyticsTable2.default, {
	                        csvLabel: "eventive-invoice",
	                        csvLabelDetail: _this7.state.selectedMonth,
	                        noSort: true,
	                        downloadSubtle: true,
	                        downloadContainerStyle: {
	                          marginTop: "-2.5em",
	                          marginLeft: "1.5em"
	                        },
	                        data: lineItems[currency].concat([{
	                          type: "total",
	                          currency: currency,
	                          amount: lineItems[currency].reduce(function (t, i) {
	                            return t + i.amount;
	                          }, 0)
	                        }]).map(function (line_item) {
	                          return {
	                            category: {
	                              value: line_item.type === "total" ? "Total" : line_item.category,
	                              label: _react2.default.createElement(
	                                "span",
	                                { style: { whiteSpace: "nowrap" } },
	                                line_item.category
	                              )
	                            },
	                            amount: {
	                              value: line_item.amount / 100,
	                              label: _react2.default.createElement(
	                                "div",
	                                {
	                                  style: line_item.type === "total" ? {
	                                    fontWeight: "bold",
	                                    fontSize: "1.25em",
	                                    paddingTop: 5,
	                                    paddingBottom: 5
	                                  } : {}
	                                },
	                                (0, _util.formatPrice)(line_item.amount, {
	                                  currency: line_item.currency,
	                                  accounting: true
	                                })
	                              )
	                            },
	                            description: {
	                              value: line_item.type === "total" ? "" : "" + line_item.description + (line_item.subtitle ? " (" + line_item.subtitle + ")" : ""),
	                              label: _react2.default.createElement(
	                                "div",
	                                { style: { lineHeight: 1.2 } },
	                                _react2.default.createElement(
	                                  "div",
	                                  null,
	                                  Array.isArray(line_item.description) ? line_item.description.join(", ") : line_item.description
	                                ),
	                                isBillingGod && line_item.editable_id ? _react2.default.createElement(
	                                  "div",
	                                  {
	                                    style: {
	                                      fontSize: "0.8em",
	                                      marginTop: 1
	                                    }
	                                  },
	                                  _react2.default.createElement(
	                                    _linkLike2.default,
	                                    {
	                                      onTouchTap: function onTouchTap() {
	                                        return _this7.setState({
	                                          isEditingLineItem: _defineProperty({}, line_item.currency, line_item)
	                                        });
	                                      }
	                                    },
	                                    "Edit line item"
	                                  ),
	                                  " ",
	                                  "\xB7",
	                                  " ",
	                                  _react2.default.createElement(
	                                    _linkLike2.default,
	                                    {
	                                      onTouchTap: function onTouchTap() {
	                                        if (window.confirm("Are you sure you want to delete this line item?")) {
	                                          _this7.performAdjustment({
	                                            action: "delete",
	                                            target: line_item.editable_id
	                                          });
	                                        }
	                                      }
	                                    },
	                                    "Delete line item"
	                                  )
	                                ) : line_item.subtitle || line_item.related_link || line_item.count || isBillingGod && line_item.amount > 0 && line_item.type !== "total" ? _react2.default.createElement(
	                                  "div",
	                                  {
	                                    style: {
	                                      fontSize: "0.8em",
	                                      marginTop: 1
	                                    }
	                                  },
	                                  line_item.count ? line_item.count + " items included" : _react2.default.createElement(
	                                    "span",
	                                    null,
	                                    isBillingGod && !line_item.subtitle && !line_item.related_link ? "Custom" : null,
	                                    line_item.subtitle,
	                                    " ",
	                                    line_item.related_link ? _react2.default.createElement(
	                                      "span",
	                                      null,
	                                      " ",
	                                      "\xB7",
	                                      " ",
	                                      _react2.default.createElement(
	                                        _reactRouter.Link,
	                                        {
	                                          to: line_item.related_link,
	                                          target: "_blank"
	                                        },
	                                        "View"
	                                      )
	                                    ) : null,
	                                    isBillingGod && line_item.amount > 0 ? _react2.default.createElement(
	                                      "span",
	                                      null,
	                                      " ",
	                                      "\xB7",
	                                      " ",
	                                      _this7.state.isAttemptingComp === line_item ? _react2.default.createElement(
	                                        "span",
	                                        null,
	                                        "Comp",
	                                        " ",
	                                        (0, _util.formatPrice)(line_item.amount, {
	                                          currency: line_item.currency
	                                        }),
	                                        "?",
	                                        " ",
	                                        _react2.default.createElement(
	                                          _linkLike2.default,
	                                          {
	                                            onTouchTap: function onTouchTap() {
	                                              return _this7.performAdjustment({
	                                                action: "create",
	                                                currency: line_item.currency,
	                                                amount: -line_item.amount,
	                                                description: "Comp of " + line_item.description,
	                                                date: invoiceRawMonth._end,
	                                                line_item: line_item
	                                              });
	                                            },
	                                            style: {
	                                              fontWeight: "bold"
	                                            }
	                                          },
	                                          "Confirm"
	                                        ),
	                                        " ",
	                                        "or",
	                                        " ",
	                                        _react2.default.createElement(
	                                          _linkLike2.default,
	                                          {
	                                            onTouchTap: function onTouchTap() {
	                                              return _this7.setState({
	                                                isAttemptingComp: null
	                                              });
	                                            }
	                                          },
	                                          "Nope"
	                                        )
	                                      ) : _react2.default.createElement(
	                                        _linkLike2.default,
	                                        {
	                                          onTouchTap: function onTouchTap() {
	                                            return _this7.setState({
	                                              isAttemptingComp: line_item
	                                            });
	                                          }
	                                        },
	                                        "QuickComp"
	                                      )
	                                    ) : null
	                                  )
	                                ) : null
	                              )
	                            }
	                          };
	                        }),
	                        columns: [{ label: "Category", value: "category" }, {
	                          label: "Description",
	                          value: "description"
	                        }, { label: "Amount", value: "amount" }]
	                      }),
	                      isBillingGod && invoiceDisplayMode === "itemized" ? _react2.default.createElement(
	                        "div",
	                        null,
	                        _react2.default.createElement(_addLineItem2.default, {
	                          currency: currency,
	                          initialItem: _this7.state.isEditingLineItem && _this7.state.isEditingLineItem[currency] || undefined,
	                          onSubmit: function onSubmit(_ref8) {
	                            var description = _ref8.description;
	                            var amount = _ref8.amount;
	
	                            var editingItem = _this7.state.isEditingLineItem && _this7.state.isEditingLineItem[currency];
	
	                            if (editingItem) {
	                              _this7.performAdjustment({
	                                action: "edit",
	                                target: editingItem.editable_id,
	                                amount: amount,
	                                description: description
	                              });
	                            } else {
	                              _this7.performAdjustment({
	                                action: "create",
	                                currency: currency,
	                                amount: amount,
	                                description: description,
	                                date: invoiceRawMonth._end
	                              });
	                            }
	                          }
	                        })
	                      ) : null
	                    )
	                  );
	                })
	              )
	            )
	          )
	        )
	      );
	    }
	  }], [{
	    key: "getStores",
	    value: function getStores() {
	      return [_UserStore2.default];
	    }
	  }, {
	    key: "getPropsFromStores",
	    value: function getPropsFromStores() {
	      return _UserStore2.default.getState();
	    }
	  }, {
	    key: "contextTypes",
	    get: function get() {
	      return {
	        router: _react2.default.PropTypes.object
	      };
	    }
	  }]);
	
	  return Billing;
	}(_react2.default.Component);
	
	exports.default = (0, _connectToStores2.default)(Billing);
	module.exports = exports["default"];

/***/ }),
/* 1746 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _currencyField = __webpack_require__(1747);
	
	var _currencyField2 = _interopRequireDefault(_currencyField);
	
	var _materialUi = __webpack_require__(576);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AddLineItem = function (_React$Component) {
	  _inherits(AddLineItem, _React$Component);
	
	  function AddLineItem(props) {
	    _classCallCheck(this, AddLineItem);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(AddLineItem).call(this, props));
	
	    _this.state = {
	      description: "",
	      amount: 0,
	      fromInitialItem: false
	    };
	
	    _this.onSubmit = _this.onSubmit.bind(_this);
	    return _this;
	  }
	
	  _createClass(AddLineItem, [{
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(props) {
	      if (props.initialItem) {
	        this.setState({
	          description: props.initialItem.description,
	          amount: props.initialItem.amount,
	          fromInitialItem: true
	        });
	      }
	    }
	  }, {
	    key: "onSubmit",
	    value: function onSubmit() {
	      this.props.onSubmit({
	        description: this.state.description,
	        amount: this.state.amount
	      });
	      this.setState({
	        description: "",
	        amount: 0,
	        fromInitialItem: false
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var fromInitialItem = this.state.fromInitialItem;
	
	
	      return _react2.default.createElement(
	        "div",
	        {
	          style: {
	            border: "1px dashed #ccc",
	            borderRadius: "1em",
	            padding: 10,
	            marginTop: 30
	          }
	        },
	        fromInitialItem ? _react2.default.createElement(
	          "div",
	          null,
	          "Edit this Adjustment line item below."
	        ) : _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement(
	            "strong",
	            null,
	            "BillingGod: Need to make a tweak?"
	          ),
	          " Add a new Adjustment line item to the above invoice."
	        ),
	        _react2.default.createElement(
	          "div",
	          {
	            style: { marginTop: -10, display: "flex", alignItems: "baseline" }
	          },
	          _react2.default.createElement(_materialUi.TextField, {
	            style: { flex: 1, marginRight: "1em" },
	            floatingLabelText: "Description",
	            floatingLabelFixed: true,
	            value: this.state.description,
	            onChange: function onChange(e) {
	              return _this2.setState({ description: e.target.value });
	            },
	            placeholder: "Line item description",
	            autoFocus: !!fromInitialItem
	          }),
	          _react2.default.createElement(_currencyField2.default, {
	            floatingLabelText: "Amount",
	            floatingLabelFixed: true,
	            placeholder: "$0.00",
	            allowNegative: true,
	            style: { width: 100, marginRight: "1em" },
	            value: this.state.amount,
	            currency: this.props.currency,
	            onChange: function onChange(e) {
	              return _this2.setState({
	                amount: e.target.value
	              });
	            }
	          }),
	          _react2.default.createElement(
	            "div",
	            { style: {} },
	            _react2.default.createElement(_materialUi.RaisedButton, {
	              label: fromInitialItem ? "Update" : "Add to invoice",
	              disabled: !this.state.amount || !this.state.description,
	              onClick: this.onSubmit
	            })
	          )
	        )
	      );
	    }
	  }]);
	
	  return AddLineItem;
	}(_react2.default.Component);
	
	exports.default = AddLineItem;
	module.exports = exports["default"];

/***/ }),
/* 1747 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _materialUi = __webpack_require__(576);
	
	var _util = __webpack_require__(1183);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * Display currency input fields in a user-friendly $xx.yy format, but serialize them
	 * into cents before propagating to the parent component. A thin wrapper around
	 * material-ui's <TextField/>.
	 */
	var CurrencyField = function (_React$Component) {
	  _inherits(CurrencyField, _React$Component);
	
	  function CurrencyField(props) {
	    _classCallCheck(this, CurrencyField);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(CurrencyField).call(this, props));
	
	    _this.state = {
	      editedValue: null
	    };
	
	    _this._extractValue = _this._extractValue.bind(_this);
	    _this._handleInputChange = _this._handleInputChange.bind(_this);
	    _this._handleInputBlur = _this._handleInputBlur.bind(_this);
	    return _this;
	  }
	
	  _createClass(CurrencyField, [{
	    key: "_extractValue",
	    value: function _extractValue(value) {
	      var sign = this.props.allowNegative && value[0] === "-" ? -1 : 1;
	      return (0, _util.parsePriceToCents)(value) * sign;
	    }
	  }, {
	    key: "_handleInputChange",
	    value: function _handleInputChange(e) {
	      var value = e.target.value;
	
	
	      this.setState({
	        editedValue: value
	      });
	
	      this.props.onChange({
	        target: {
	          value: this._extractValue(value)
	        }
	      });
	    }
	  }, {
	    key: "_handleInputBlur",
	    value: function _handleInputBlur(e) {
	      if (this.props.onBlur) {
	        this.props.onBlur({
	          target: {
	            value: this._extractValue(this.state.editedValue || e.target.value)
	          }
	        });
	      }
	      this.setState({ editedValue: null });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _props = this.props;
	      var value = _props.value;
	      var onChange = _props.onChange;
	      var onBlur = _props.onBlur;
	      var placeholder = _props.placeholder;
	      var props = _objectWithoutProperties(_props, ["value", "onChange", "onBlur", "placeholder"]);
	      var editedValue = this.state.editedValue;
	
	
	      if (placeholder === "$0.00") {
	        placeholder = (0, _util.formatPrice)(0, this.props.currency ? { currency: this.props.currency } : undefined);
	      }
	
	      return _react2.default.createElement(_materialUi.TextField, _extends({
	        value: editedValue !== null ? editedValue : value ? "" + (0, _util.formatPrice)(value, this.props.currency ? { currency: this.props.currency } : undefined) : "",
	        onChange: this._handleInputChange,
	        onBlur: this._handleInputBlur,
	        placeholder: placeholder
	      }, props));
	    }
	  }]);
	
	  return CurrencyField;
	}(_react2.default.Component);
	
	exports.default = CurrencyField;
	module.exports = exports["default"];

/***/ }),
/* 1748 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _alt = __webpack_require__(975);
	
	var _alt2 = _interopRequireDefault(_alt);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var GodActions = function GodActions() {
	  _classCallCheck(this, GodActions);
	
	  this.generateActions("createFakeEventBucket", "godFailed", "autoCreate", "fetchStats", "fetchRevenue", "fetchUpcomingEvents", "becomePerson");
	};
	
	exports.default = _alt2.default.createActions(GodActions);
	module.exports = exports["default"];

/***/ }),
/* 1749 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _api = __webpack_require__(1160);
	
	var _api2 = _interopRequireDefault(_api);
	
	var _config = __webpack_require__(1173);
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  fetchBillingSummary: function fetchBillingSummary(apiKey) {
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "GET",
	        endpoint: "billing/summary",
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response);
	      });
	    });
	  },
	  updateSettings: function updateSettings(apiKey, body) {
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "POST",
	        endpoint: "billing/settings",
	        json: body,
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response);
	      });
	    });
	  },
	  fetchInvoicePreview: function fetchInvoicePreview(apiKey, _ref) {
	    var start = _ref.start;
	    var end = _ref.end;
	
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "POST",
	        endpoint: "billing/invoice_preview",
	        json: {
	          start: start,
	          end: end
	        },
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response);
	      });
	    });
	  },
	  performAdjustment: function performAdjustment(apiKey, body) {
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "POST",
	        endpoint: "billing/adjustment",
	        json: body,
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response);
	      });
	    });
	  },
	  pushInvoiceToStripe: function pushInvoiceToStripe(apiKey, body) {
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "POST",
	        endpoint: "billing/invoice_push_to_stripe",
	        json: body,
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response);
	      });
	    });
	  },
	  fetchInvoicingHub: function fetchInvoicingHub(apiKey, _ref2) {
	    var month = _ref2.month;
	
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "GET",
	        endpoint: "billing/invoicing_hub",
	        qs: {
	          month: month
	        },
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response);
	      });
	    });
	  }
	};
	module.exports = exports["default"];

/***/ }),
/* 1750 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _materialUi = __webpack_require__(576);
	
	var _reactSelect = __webpack_require__(953);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	var _set = __webpack_require__(1188);
	
	var _set2 = _interopRequireDefault(_set);
	
	var _get = __webpack_require__(1004);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _reactCodemirror = __webpack_require__(1751);
	
	var _reactCodemirror2 = _interopRequireDefault(_reactCodemirror);
	
	__webpack_require__(1754);
	
	var _base = __webpack_require__(1755);
	
	var _base2 = _interopRequireDefault(_base);
	
	var _config = __webpack_require__(1173);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _label = __webpack_require__(1682);
	
	var _label2 = _interopRequireDefault(_label);
	
	var _moment = __webpack_require__(1021);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var UserEditorModal = function (_React$Component) {
	  _inherits(UserEditorModal, _React$Component);
	
	  function UserEditorModal(props) {
	    _classCallCheck(this, UserEditorModal);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(UserEditorModal).call(this, props));
	
	    _this.state = {
	      user: {},
	      values: {}
	    };
	
	    _this.onRequestClose = _this.onRequestClose.bind(_this);
	    _this.onSave = _this.onSave.bind(_this);
	    _this.onChangeValue = _this.onChangeValue.bind(_this);
	    return _this;
	  }
	
	  _createClass(UserEditorModal, [{
	    key: "getStyles",
	    value: function getStyles() {
	      return {
	        container: {
	          margin: "15px 0"
	        },
	        inputContainer: {
	          textAlign: "left",
	          margin: "0 auto",
	          maxWidth: "90%",
	          width: 500
	        },
	        actions: {
	          marginTop: 15
	        },
	        dialogTitle: {
	          borderBottom: "none"
	        },
	        dialogActionsContainer: {
	          borderTop: "none"
	        }
	      };
	    }
	  }, {
	    key: "onRequestClose",
	    value: function onRequestClose() {
	      this.props.onCancel();
	    }
	  }, {
	    key: "onSave",
	    value: function onSave() {
	      this.props.onSave(this.state.values);
	    }
	  }, {
	    key: "onChangeValue",
	    value: function onChangeValue(id, value) {
	      var values = this.state.values;
	
	      (0, _set2.default)(values, id, value);
	      this.setState({ values: values });
	    }
	  }, {
	    key: "onFakeEventBucket",
	    value: function onFakeEventBucket() {
	      this.props.onFakeEventBucket();
	    }
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.componentWillReceiveProps(this.props);
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(newProps) {
	      var user = newProps.user || { global_config: {} };
	
	      this.setState({
	        user: user,
	        values: {
	          organization: user.organization,
	          fee_percent: user.fee_percent,
	          is_demo: user.is_demo,
	          currency: user.currency,
	          locale: user.locale,
	          stripe_account_mode: user.stripe_account_mode,
	          stripe_customer_id: user.stripe_customer_id,
	          virtual_festival_plan: user.virtual_festival_plan,
	          virtual_festival_plan_status: user.virtual_festival_plan_status,
	          eventival_config: JSON.stringify(user.eventival_config, null, 2),
	          global_config: user.global_config
	        }
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var styles = this.getStyles();
	      var roles = this.props.roles;
	
	
	      return _react2.default.createElement(
	        _base2.default,
	        {
	          title: this.props.isNew ? "Create organization" : "Edit organization",
	          titleStyle: styles.dialogTitle,
	          actionsContainerStyle: styles.dialogActionsContainer,
	          openImmediately: true,
	          actions: [_react2.default.createElement(_materialUi.FlatButton, { label: "Cancel", onTouchTap: this.onRequestClose }), _react2.default.createElement(_materialUi.FlatButton, { primary: true, label: "Save", onTouchTap: this.onSave })],
	          modal: true,
	          open: true,
	          autoDetectWindowHeight: false,
	          autoScrollBodyContent: false,
	          bodyStyle: { overflowY: "visible" },
	          onRequestClose: this.onRequestClose
	        },
	        _react2.default.createElement(
	          "form",
	          {
	            autoComplete: "off",
	            style: { margin: "0 auto" },
	            onSubmit: this.onSave
	          },
	          _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(_materialUi.TextField, {
	              value: this.state.values.organization,
	              floatingLabelText: "Organization name",
	              floatingLabelFixed: true,
	              fullWidth: true,
	              onChange: function onChange(e) {
	                return _this2.onChangeValue("organization", e.target.value);
	              }
	            })
	          ),
	          _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(
	              _label2.default,
	              null,
	              "Currency"
	            ),
	            _react2.default.createElement(_reactSelect2.default, {
	              clearable: false,
	              value: this.state.values.currency,
	              options: _config2.default.fee.supported_currencies.map(function (k) {
	                return {
	                  label: k.toUpperCase(),
	                  value: k
	                };
	              }),
	              onChange: function onChange(e) {
	                return _this2.onChangeValue("currency", e ? e.value : "");
	              }
	            })
	          ),
	          _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(
	              _label2.default,
	              null,
	              "Locale"
	            ),
	            _react2.default.createElement(_reactSelect2.default, {
	              clearable: false,
	              value: this.state.values.locale,
	              options: _config2.default.locales.map(function (k) {
	                return { label: k, value: k };
	              }),
	              onChange: function onChange(e) {
	                return _this2.onChangeValue("locale", e ? e.value : "");
	              }
	            })
	          ),
	          _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(
	              _label2.default,
	              null,
	              "Fee percent"
	            ),
	            _react2.default.createElement(_reactSelect2.default, {
	              clearable: false,
	              value: this.state.values.fee_percent,
	              options: [{ label: "2%", value: 2 }, { label: "4.5%", value: 4.5 }],
	              onChange: function onChange(e) {
	                return _this2.onChangeValue("fee_percent", e ? e.value : "");
	              }
	            })
	          ),
	          _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(
	              _label2.default,
	              null,
	              "Mode"
	            ),
	            _react2.default.createElement(_reactSelect2.default, {
	              clearable: false,
	              value: this.state.values.is_demo ? "demo" : "standard",
	              options: [{ label: "Standard", value: "standard" }, { label: "Demo (no charges)", value: "demo" }],
	              onChange: function onChange(e) {
	                return _this2.onChangeValue("is_demo", e && e.value === "demo");
	              }
	            })
	          ),
	          _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(
	              _label2.default,
	              null,
	              "Eventive Virtual"
	            ),
	            this.state.user.virtual_festival_plan_status === "active" ? _react2.default.createElement(
	              "div",
	              null,
	              _react2.default.createElement(
	                "div",
	                null,
	                "Eventive Virtual is currently activated and",
	                " ",
	                this.state.user.virtual_festival_plan_payment_due_at ? "payment is due " + (0, _moment2.default)(this.state.user.virtual_festival_plan_payment_due_at).format("LLL") : "no payment is due",
	                "."
	              ),
	              _react2.default.createElement(_materialUi.Checkbox, {
	                checked: this.state.values.virtual_festival_plan_status === "expired",
	                label: "Immediately DEACTIVATE Eventive Virtual subscription and revoke virtual access. This will permanently cancel the subscription and TERMINATE ACCESS IMMEDIATELY.",
	                style: { marginTop: "0.5em" },
	                onCheck: function onCheck(e, checked) {
	                  return _this2.onChangeValue("virtual_festival_plan_status", checked ? "expired" : "active");
	                }
	              })
	            ) : _react2.default.createElement(
	              "div",
	              null,
	              _react2.default.createElement(
	                "div",
	                null,
	                "Not currently enrolled in Eventive Virtual."
	              ),
	              _react2.default.createElement(_materialUi.Checkbox, {
	                checked: this.state.values.virtual_festival_plan_status === "active",
	                label: "Enroll in Eventive Virtual",
	                style: { marginTop: "0.25em" },
	                onCheck: function onCheck(e, checked) {
	                  return _this2.onChangeValue("virtual_festival_plan_status", "active");
	                }
	              })
	            ),
	            this.state.values.virtual_festival_plan_status === "active" ? _react2.default.createElement(_reactSelect2.default, {
	              clearable: false,
	              style: { marginTop: "0.5em" },
	              value: this.state.values.virtual_festival_plan,
	              options: [{
	                label: "Standard virtual festival billing plan",
	                value: "standard"
	              }, {
	                label: "Distributor virtual festival billing plan",
	                value: "distributor"
	              }, {
	                label: "Single Film virtual festival billing plan",
	                value: "single_film"
	              }],
	              onChange: function onChange(e) {
	                return _this2.onChangeValue("virtual_festival_plan", e ? e.value : "");
	              }
	            }) : null
	          ),
	          _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(
	              _label2.default,
	              null,
	              "Eventival config"
	            ),
	            _react2.default.createElement(_reactCodemirror2.default, {
	              ref: function ref(r) {
	                return r && r.getCodeMirror().setSize(null, 100);
	              },
	              value: (0, _get2.default)(this.state, "values.eventival_config", ""),
	              onChange: this.onChangeValue.bind(this, "eventival_config"),
	              options: {
	                lineWrapping: true,
	                lineNumbers: true,
	                tabSize: 2,
	                indentUnit: 2,
	                mode: { name: "javascript", json: true }
	              }
	            })
	          ),
	          _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(
	              _label2.default,
	              null,
	              "Advanced"
	            ),
	            _react2.default.createElement(_materialUi.Checkbox, {
	              checked: (0, _get2.default)(this.state.values, "global_config.facebook_login_disabled"),
	              label: 'Disable "Login with Facebook" functionality',
	              onCheck: function onCheck(e, checked) {
	                return _this2.onChangeValue("global_config.facebook_login_disabled", checked);
	              }
	            }),
	            _react2.default.createElement(_materialUi.Checkbox, {
	              checked: (0, _get2.default)(this.state.values, "global_config.cannes_mode"),
	              label: "Enable Cannes mode",
	              onCheck: function onCheck(e, checked) {
	                return _this2.onChangeValue("global_config.cannes_mode", checked);
	              }
	            }),
	            _react2.default.createElement(_materialUi.Checkbox, {
	              checked: (0, _get2.default)(this.state.values, "global_config.gdpr_opt_in"),
	              label: "Show GDPR opt-in",
	              onCheck: function onCheck(e, checked) {
	                return _this2.onChangeValue("global_config.gdpr_opt_in", checked);
	              }
	            }),
	            _react2.default.createElement(_materialUi.Checkbox, {
	              checked: (0, _get2.default)(this.state.values, "global_config.external_pos_enabled"),
	              label: "Enable external POS",
	              onCheck: function onCheck(e, checked) {
	                return _this2.onChangeValue("global_config.external_pos_enabled", checked);
	              }
	            })
	          ),
	          _react2.default.createElement(_materialUi.TextField, {
	            value: this.state.values.stripe_customer_id,
	            floatingLabelText: "Set Stripe customer ID (optional)",
	            placeholder: "(will create new Stripe customer)",
	            floatingLabelFixed: true,
	            onChange: function onChange(e) {
	              return _this2.onChangeValue("stripe_customer_id", e.target.value);
	            }
	          }),
	          !this.props.isNew ? _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(
	              _label2.default,
	              null,
	              "Generate fake event bucket"
	            ),
	            _react2.default.createElement(_materialUi.RaisedButton, {
	              label: "Generate fake event bucket",
	              onTouchTap: function onTouchTap() {
	                return window.confirm("Are you sure?") && _this2.props.onFakeEventBucket();
	              }
	            })
	          ) : null
	        )
	      );
	    }
	  }]);
	
	  return UserEditorModal;
	}(_react2.default.Component);
	
	exports.default = UserEditorModal;
	module.exports = exports["default"];

/***/ }),
/* 1751 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(300);
	var className = __webpack_require__(958);
	var debounce = __webpack_require__(1752);
	
	var CodeMirror = React.createClass({
		displayName: 'CodeMirror',
	
		propTypes: {
			onChange: React.PropTypes.func,
			onFocusChange: React.PropTypes.func,
			options: React.PropTypes.object,
			path: React.PropTypes.string,
			value: React.PropTypes.string,
			className: React.PropTypes.any,
			codeMirrorInstance: React.PropTypes.object
		},
		getCodeMirrorInstance: function getCodeMirrorInstance() {
			return this.props.codeMirrorInstance || __webpack_require__(1753);
		},
		getInitialState: function getInitialState() {
			return {
				isFocused: false
			};
		},
		componentDidMount: function componentDidMount() {
			var textareaNode = this.refs.textarea;
			var codeMirrorInstance = this.getCodeMirrorInstance();
			this.codeMirror = codeMirrorInstance.fromTextArea(textareaNode, this.props.options);
			this.codeMirror.on('change', this.codemirrorValueChanged);
			this.codeMirror.on('focus', this.focusChanged.bind(this, true));
			this.codeMirror.on('blur', this.focusChanged.bind(this, false));
			this.codeMirror.setValue(this.props.defaultValue || this.props.value || '');
		},
		componentWillUnmount: function componentWillUnmount() {
			// is there a lighter-weight way to remove the cm instance?
			if (this.codeMirror) {
				this.codeMirror.toTextArea();
			}
		},
		componentWillReceiveProps: debounce(function (nextProps) {
			if (this.codeMirror && nextProps.value !== undefined && this.codeMirror.getValue() != nextProps.value) {
				this.codeMirror.setValue(nextProps.value);
			}
			if (typeof nextProps.options === 'object') {
				for (var optionName in nextProps.options) {
					if (nextProps.options.hasOwnProperty(optionName)) {
						this.codeMirror.setOption(optionName, nextProps.options[optionName]);
					}
				}
			}
		}, 0),
		getCodeMirror: function getCodeMirror() {
			return this.codeMirror;
		},
		focus: function focus() {
			if (this.codeMirror) {
				this.codeMirror.focus();
			}
		},
		focusChanged: function focusChanged(focused) {
			this.setState({
				isFocused: focused
			});
			this.props.onFocusChange && this.props.onFocusChange(focused);
		},
		codemirrorValueChanged: function codemirrorValueChanged(doc, change) {
			if (this.props.onChange && change.origin != 'setValue') {
				this.props.onChange(doc.getValue());
			}
		},
		render: function render() {
			var editorClassName = className('ReactCodeMirror', this.state.isFocused ? 'ReactCodeMirror--focused' : null, this.props.className);
			return React.createElement(
				'div',
				{ className: editorClassName },
				React.createElement('textarea', { ref: 'textarea', name: this.props.path, defaultValue: this.props.value, autoComplete: 'off' })
			);
		}
	});
	
	module.exports = CodeMirror;

/***/ }),
/* 1752 */
/***/ (function(module, exports) {

	/**
	 * lodash 4.0.6 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as the `TypeError` message for "Functions" methods. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/** Used as references for various `Number` constants. */
	var NAN = 0 / 0;
	
	/** `Object#toString` result references. */
	var funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    symbolTag = '[object Symbol]';
	
	/** Used to match leading and trailing whitespace. */
	var reTrim = /^\s+|\s+$/g;
	
	/** Used to detect bad signed hexadecimal string values. */
	var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	/** Used to detect binary string values. */
	var reIsBinary = /^0b[01]+$/i;
	
	/** Used to detect octal string values. */
	var reIsOctal = /^0o[0-7]+$/i;
	
	/** Built-in method references without a dependency on `root`. */
	var freeParseInt = parseInt;
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max,
	    nativeMin = Math.min;
	
	/**
	 * Gets the timestamp of the number of milliseconds that have elapsed since
	 * the Unix epoch (1 January 1970 00:00:00 UTC).
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @type {Function}
	 * @category Date
	 * @returns {number} Returns the timestamp.
	 * @example
	 *
	 * _.defer(function(stamp) {
	 *   console.log(_.now() - stamp);
	 * }, _.now());
	 * // => Logs the number of milliseconds it took for the deferred function to be invoked.
	 */
	var now = Date.now;
	
	/**
	 * Creates a debounced function that delays invoking `func` until after `wait`
	 * milliseconds have elapsed since the last time the debounced function was
	 * invoked. The debounced function comes with a `cancel` method to cancel
	 * delayed `func` invocations and a `flush` method to immediately invoke them.
	 * Provide an options object to indicate whether `func` should be invoked on
	 * the leading and/or trailing edge of the `wait` timeout. The `func` is invoked
	 * with the last arguments provided to the debounced function. Subsequent calls
	 * to the debounced function return the result of the last `func` invocation.
	 *
	 * **Note:** If `leading` and `trailing` options are `true`, `func` is invoked
	 * on the trailing edge of the timeout only if the debounced function is
	 * invoked more than once during the `wait` timeout.
	 *
	 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	 * for details over the differences between `_.debounce` and `_.throttle`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to debounce.
	 * @param {number} [wait=0] The number of milliseconds to delay.
	 * @param {Object} [options={}] The options object.
	 * @param {boolean} [options.leading=false]
	 *  Specify invoking on the leading edge of the timeout.
	 * @param {number} [options.maxWait]
	 *  The maximum time `func` is allowed to be delayed before it's invoked.
	 * @param {boolean} [options.trailing=true]
	 *  Specify invoking on the trailing edge of the timeout.
	 * @returns {Function} Returns the new debounced function.
	 * @example
	 *
	 * // Avoid costly calculations while the window size is in flux.
	 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	 *
	 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
	 * jQuery(element).on('click', _.debounce(sendMail, 300, {
	 *   'leading': true,
	 *   'trailing': false
	 * }));
	 *
	 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
	 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
	 * var source = new EventSource('/stream');
	 * jQuery(source).on('message', debounced);
	 *
	 * // Cancel the trailing debounced invocation.
	 * jQuery(window).on('popstate', debounced.cancel);
	 */
	function debounce(func, wait, options) {
	  var lastArgs,
	      lastThis,
	      maxWait,
	      result,
	      timerId,
	      lastCallTime = 0,
	      lastInvokeTime = 0,
	      leading = false,
	      maxing = false,
	      trailing = true;
	
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  wait = toNumber(wait) || 0;
	  if (isObject(options)) {
	    leading = !!options.leading;
	    maxing = 'maxWait' in options;
	    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
	    trailing = 'trailing' in options ? !!options.trailing : trailing;
	  }
	
	  function invokeFunc(time) {
	    var args = lastArgs,
	        thisArg = lastThis;
	
	    lastArgs = lastThis = undefined;
	    lastInvokeTime = time;
	    result = func.apply(thisArg, args);
	    return result;
	  }
	
	  function leadingEdge(time) {
	    // Reset any `maxWait` timer.
	    lastInvokeTime = time;
	    // Start the timer for the trailing edge.
	    timerId = setTimeout(timerExpired, wait);
	    // Invoke the leading edge.
	    return leading ? invokeFunc(time) : result;
	  }
	
	  function remainingWait(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime,
	        result = wait - timeSinceLastCall;
	
	    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
	  }
	
	  function shouldInvoke(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime;
	
	    // Either this is the first call, activity has stopped and we're at the
	    // trailing edge, the system time has gone backwards and we're treating
	    // it as the trailing edge, or we've hit the `maxWait` limit.
	    return (!lastCallTime || (timeSinceLastCall >= wait) ||
	      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
	  }
	
	  function timerExpired() {
	    var time = now();
	    if (shouldInvoke(time)) {
	      return trailingEdge(time);
	    }
	    // Restart the timer.
	    timerId = setTimeout(timerExpired, remainingWait(time));
	  }
	
	  function trailingEdge(time) {
	    clearTimeout(timerId);
	    timerId = undefined;
	
	    // Only invoke if we have `lastArgs` which means `func` has been
	    // debounced at least once.
	    if (trailing && lastArgs) {
	      return invokeFunc(time);
	    }
	    lastArgs = lastThis = undefined;
	    return result;
	  }
	
	  function cancel() {
	    if (timerId !== undefined) {
	      clearTimeout(timerId);
	    }
	    lastCallTime = lastInvokeTime = 0;
	    lastArgs = lastThis = timerId = undefined;
	  }
	
	  function flush() {
	    return timerId === undefined ? result : trailingEdge(now());
	  }
	
	  function debounced() {
	    var time = now(),
	        isInvoking = shouldInvoke(time);
	
	    lastArgs = arguments;
	    lastThis = this;
	    lastCallTime = time;
	
	    if (isInvoking) {
	      if (timerId === undefined) {
	        return leadingEdge(lastCallTime);
	      }
	      if (maxing) {
	        // Handle invocations in a tight loop.
	        clearTimeout(timerId);
	        timerId = setTimeout(timerExpired, wait);
	        return invokeFunc(lastCallTime);
	      }
	    }
	    if (timerId === undefined) {
	      timerId = setTimeout(timerExpired, wait);
	    }
	    return result;
	  }
	  debounced.cancel = cancel;
	  debounced.flush = flush;
	  return debounced;
	}
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified,
	 *  else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 8 which returns 'object' for typed array and weak map constructors,
	  // and PhantomJS 1.9 which returns 'function' for `NodeList` instances.
	  var tag = isObject(value) ? objectToString.call(value) : '';
	  return tag == funcTag || tag == genTag;
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/6.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified,
	 *  else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && objectToString.call(value) == symbolTag);
	}
	
	/**
	 * Converts `value` to a number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {number} Returns the number.
	 * @example
	 *
	 * _.toNumber(3);
	 * // => 3
	 *
	 * _.toNumber(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toNumber(Infinity);
	 * // => Infinity
	 *
	 * _.toNumber('3');
	 * // => 3
	 */
	function toNumber(value) {
	  if (typeof value == 'number') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return NAN;
	  }
	  if (isObject(value)) {
	    var other = isFunction(value.valueOf) ? value.valueOf() : value;
	    value = isObject(other) ? (other + '') : other;
	  }
	  if (typeof value != 'string') {
	    return value === 0 ? value : +value;
	  }
	  value = value.replace(reTrim, '');
	  var isBinary = reIsBinary.test(value);
	  return (isBinary || reIsOctal.test(value))
	    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	    : (reIsBadHex.test(value) ? NAN : +value);
	}
	
	module.exports = debounce;


/***/ }),
/* 1753 */
/***/ (function(module, exports, __webpack_require__) {

	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: http://codemirror.net/LICENSE
	
	// This is CodeMirror (http://codemirror.net), a code editor
	// implemented in JavaScript on top of the browser's DOM.
	//
	// You can find some technical background for some of the code below
	// at http://marijnhaverbeke.nl/blog/#cm-internals .
	
	(function(mod) {
	  if (true) // CommonJS
	    module.exports = mod();
	  else if (typeof define == "function" && define.amd) // AMD
	    return define([], mod);
	  else // Plain browser env
	    (this || window).CodeMirror = mod();
	})(function() {
	  "use strict";
	
	  // BROWSER SNIFFING
	
	  // Kludges for bugs and behavior differences that can't be feature
	  // detected are enabled based on userAgent etc sniffing.
	  var userAgent = navigator.userAgent;
	  var platform = navigator.platform;
	
	  var gecko = /gecko\/\d/i.test(userAgent);
	  var ie_upto10 = /MSIE \d/.test(userAgent);
	  var ie_11up = /Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(userAgent);
	  var ie = ie_upto10 || ie_11up;
	  var ie_version = ie && (ie_upto10 ? document.documentMode || 6 : ie_11up[1]);
	  var webkit = /WebKit\//.test(userAgent);
	  var qtwebkit = webkit && /Qt\/\d+\.\d+/.test(userAgent);
	  var chrome = /Chrome\//.test(userAgent);
	  var presto = /Opera\//.test(userAgent);
	  var safari = /Apple Computer/.test(navigator.vendor);
	  var mac_geMountainLion = /Mac OS X 1\d\D([8-9]|\d\d)\D/.test(userAgent);
	  var phantom = /PhantomJS/.test(userAgent);
	
	  var ios = /AppleWebKit/.test(userAgent) && /Mobile\/\w+/.test(userAgent);
	  // This is woefully incomplete. Suggestions for alternative methods welcome.
	  var mobile = ios || /Android|webOS|BlackBerry|Opera Mini|Opera Mobi|IEMobile/i.test(userAgent);
	  var mac = ios || /Mac/.test(platform);
	  var chromeOS = /\bCrOS\b/.test(userAgent);
	  var windows = /win/i.test(platform);
	
	  var presto_version = presto && userAgent.match(/Version\/(\d*\.\d*)/);
	  if (presto_version) presto_version = Number(presto_version[1]);
	  if (presto_version && presto_version >= 15) { presto = false; webkit = true; }
	  // Some browsers use the wrong event properties to signal cmd/ctrl on OS X
	  var flipCtrlCmd = mac && (qtwebkit || presto && (presto_version == null || presto_version < 12.11));
	  var captureRightClick = gecko || (ie && ie_version >= 9);
	
	  // Optimize some code when these features are not used.
	  var sawReadOnlySpans = false, sawCollapsedSpans = false;
	
	  // EDITOR CONSTRUCTOR
	
	  // A CodeMirror instance represents an editor. This is the object
	  // that user code is usually dealing with.
	
	  function CodeMirror(place, options) {
	    if (!(this instanceof CodeMirror)) return new CodeMirror(place, options);
	
	    this.options = options = options ? copyObj(options) : {};
	    // Determine effective options based on given values and defaults.
	    copyObj(defaults, options, false);
	    setGuttersForLineNumbers(options);
	
	    var doc = options.value;
	    if (typeof doc == "string") doc = new Doc(doc, options.mode, null, options.lineSeparator);
	    this.doc = doc;
	
	    var input = new CodeMirror.inputStyles[options.inputStyle](this);
	    var display = this.display = new Display(place, doc, input);
	    display.wrapper.CodeMirror = this;
	    updateGutters(this);
	    themeChanged(this);
	    if (options.lineWrapping)
	      this.display.wrapper.className += " CodeMirror-wrap";
	    if (options.autofocus && !mobile) display.input.focus();
	    initScrollbars(this);
	
	    this.state = {
	      keyMaps: [],  // stores maps added by addKeyMap
	      overlays: [], // highlighting overlays, as added by addOverlay
	      modeGen: 0,   // bumped when mode/overlay changes, used to invalidate highlighting info
	      overwrite: false,
	      delayingBlurEvent: false,
	      focused: false,
	      suppressEdits: false, // used to disable editing during key handlers when in readOnly mode
	      pasteIncoming: false, cutIncoming: false, // help recognize paste/cut edits in input.poll
	      selectingText: false,
	      draggingText: false,
	      highlight: new Delayed(), // stores highlight worker timeout
	      keySeq: null,  // Unfinished key sequence
	      specialChars: null
	    };
	
	    var cm = this;
	
	    // Override magic textarea content restore that IE sometimes does
	    // on our hidden textarea on reload
	    if (ie && ie_version < 11) setTimeout(function() { cm.display.input.reset(true); }, 20);
	
	    registerEventHandlers(this);
	    ensureGlobalHandlers();
	
	    startOperation(this);
	    this.curOp.forceUpdate = true;
	    attachDoc(this, doc);
	
	    if ((options.autofocus && !mobile) || cm.hasFocus())
	      setTimeout(bind(onFocus, this), 20);
	    else
	      onBlur(this);
	
	    for (var opt in optionHandlers) if (optionHandlers.hasOwnProperty(opt))
	      optionHandlers[opt](this, options[opt], Init);
	    maybeUpdateLineNumberWidth(this);
	    if (options.finishInit) options.finishInit(this);
	    for (var i = 0; i < initHooks.length; ++i) initHooks[i](this);
	    endOperation(this);
	    // Suppress optimizelegibility in Webkit, since it breaks text
	    // measuring on line wrapping boundaries.
	    if (webkit && options.lineWrapping &&
	        getComputedStyle(display.lineDiv).textRendering == "optimizelegibility")
	      display.lineDiv.style.textRendering = "auto";
	  }
	
	  // DISPLAY CONSTRUCTOR
	
	  // The display handles the DOM integration, both for input reading
	  // and content drawing. It holds references to DOM nodes and
	  // display-related state.
	
	  function Display(place, doc, input) {
	    var d = this;
	    this.input = input;
	
	    // Covers bottom-right square when both scrollbars are present.
	    d.scrollbarFiller = elt("div", null, "CodeMirror-scrollbar-filler");
	    d.scrollbarFiller.setAttribute("cm-not-content", "true");
	    // Covers bottom of gutter when coverGutterNextToScrollbar is on
	    // and h scrollbar is present.
	    d.gutterFiller = elt("div", null, "CodeMirror-gutter-filler");
	    d.gutterFiller.setAttribute("cm-not-content", "true");
	    // Will contain the actual code, positioned to cover the viewport.
	    d.lineDiv = elt("div", null, "CodeMirror-code");
	    // Elements are added to these to represent selection and cursors.
	    d.selectionDiv = elt("div", null, null, "position: relative; z-index: 1");
	    d.cursorDiv = elt("div", null, "CodeMirror-cursors");
	    // A visibility: hidden element used to find the size of things.
	    d.measure = elt("div", null, "CodeMirror-measure");
	    // When lines outside of the viewport are measured, they are drawn in this.
	    d.lineMeasure = elt("div", null, "CodeMirror-measure");
	    // Wraps everything that needs to exist inside the vertically-padded coordinate system
	    d.lineSpace = elt("div", [d.measure, d.lineMeasure, d.selectionDiv, d.cursorDiv, d.lineDiv],
	                      null, "position: relative; outline: none");
	    // Moved around its parent to cover visible view.
	    d.mover = elt("div", [elt("div", [d.lineSpace], "CodeMirror-lines")], null, "position: relative");
	    // Set to the height of the document, allowing scrolling.
	    d.sizer = elt("div", [d.mover], "CodeMirror-sizer");
	    d.sizerWidth = null;
	    // Behavior of elts with overflow: auto and padding is
	    // inconsistent across browsers. This is used to ensure the
	    // scrollable area is big enough.
	    d.heightForcer = elt("div", null, null, "position: absolute; height: " + scrollerGap + "px; width: 1px;");
	    // Will contain the gutters, if any.
	    d.gutters = elt("div", null, "CodeMirror-gutters");
	    d.lineGutter = null;
	    // Actual scrollable element.
	    d.scroller = elt("div", [d.sizer, d.heightForcer, d.gutters], "CodeMirror-scroll");
	    d.scroller.setAttribute("tabIndex", "-1");
	    // The element in which the editor lives.
	    d.wrapper = elt("div", [d.scrollbarFiller, d.gutterFiller, d.scroller], "CodeMirror");
	
	    // Work around IE7 z-index bug (not perfect, hence IE7 not really being supported)
	    if (ie && ie_version < 8) { d.gutters.style.zIndex = -1; d.scroller.style.paddingRight = 0; }
	    if (!webkit && !(gecko && mobile)) d.scroller.draggable = true;
	
	    if (place) {
	      if (place.appendChild) place.appendChild(d.wrapper);
	      else place(d.wrapper);
	    }
	
	    // Current rendered range (may be bigger than the view window).
	    d.viewFrom = d.viewTo = doc.first;
	    d.reportedViewFrom = d.reportedViewTo = doc.first;
	    // Information about the rendered lines.
	    d.view = [];
	    d.renderedView = null;
	    // Holds info about a single rendered line when it was rendered
	    // for measurement, while not in view.
	    d.externalMeasured = null;
	    // Empty space (in pixels) above the view
	    d.viewOffset = 0;
	    d.lastWrapHeight = d.lastWrapWidth = 0;
	    d.updateLineNumbers = null;
	
	    d.nativeBarWidth = d.barHeight = d.barWidth = 0;
	    d.scrollbarsClipped = false;
	
	    // Used to only resize the line number gutter when necessary (when
	    // the amount of lines crosses a boundary that makes its width change)
	    d.lineNumWidth = d.lineNumInnerWidth = d.lineNumChars = null;
	    // Set to true when a non-horizontal-scrolling line widget is
	    // added. As an optimization, line widget aligning is skipped when
	    // this is false.
	    d.alignWidgets = false;
	
	    d.cachedCharWidth = d.cachedTextHeight = d.cachedPaddingH = null;
	
	    // Tracks the maximum line length so that the horizontal scrollbar
	    // can be kept static when scrolling.
	    d.maxLine = null;
	    d.maxLineLength = 0;
	    d.maxLineChanged = false;
	
	    // Used for measuring wheel scrolling granularity
	    d.wheelDX = d.wheelDY = d.wheelStartX = d.wheelStartY = null;
	
	    // True when shift is held down.
	    d.shift = false;
	
	    // Used to track whether anything happened since the context menu
	    // was opened.
	    d.selForContextMenu = null;
	
	    d.activeTouch = null;
	
	    input.init(d);
	  }
	
	  // STATE UPDATES
	
	  // Used to get the editor into a consistent state again when options change.
	
	  function loadMode(cm) {
	    cm.doc.mode = CodeMirror.getMode(cm.options, cm.doc.modeOption);
	    resetModeState(cm);
	  }
	
	  function resetModeState(cm) {
	    cm.doc.iter(function(line) {
	      if (line.stateAfter) line.stateAfter = null;
	      if (line.styles) line.styles = null;
	    });
	    cm.doc.frontier = cm.doc.first;
	    startWorker(cm, 100);
	    cm.state.modeGen++;
	    if (cm.curOp) regChange(cm);
	  }
	
	  function wrappingChanged(cm) {
	    if (cm.options.lineWrapping) {
	      addClass(cm.display.wrapper, "CodeMirror-wrap");
	      cm.display.sizer.style.minWidth = "";
	      cm.display.sizerWidth = null;
	    } else {
	      rmClass(cm.display.wrapper, "CodeMirror-wrap");
	      findMaxLine(cm);
	    }
	    estimateLineHeights(cm);
	    regChange(cm);
	    clearCaches(cm);
	    setTimeout(function(){updateScrollbars(cm);}, 100);
	  }
	
	  // Returns a function that estimates the height of a line, to use as
	  // first approximation until the line becomes visible (and is thus
	  // properly measurable).
	  function estimateHeight(cm) {
	    var th = textHeight(cm.display), wrapping = cm.options.lineWrapping;
	    var perLine = wrapping && Math.max(5, cm.display.scroller.clientWidth / charWidth(cm.display) - 3);
	    return function(line) {
	      if (lineIsHidden(cm.doc, line)) return 0;
	
	      var widgetsHeight = 0;
	      if (line.widgets) for (var i = 0; i < line.widgets.length; i++) {
	        if (line.widgets[i].height) widgetsHeight += line.widgets[i].height;
	      }
	
	      if (wrapping)
	        return widgetsHeight + (Math.ceil(line.text.length / perLine) || 1) * th;
	      else
	        return widgetsHeight + th;
	    };
	  }
	
	  function estimateLineHeights(cm) {
	    var doc = cm.doc, est = estimateHeight(cm);
	    doc.iter(function(line) {
	      var estHeight = est(line);
	      if (estHeight != line.height) updateLineHeight(line, estHeight);
	    });
	  }
	
	  function themeChanged(cm) {
	    cm.display.wrapper.className = cm.display.wrapper.className.replace(/\s*cm-s-\S+/g, "") +
	      cm.options.theme.replace(/(^|\s)\s*/g, " cm-s-");
	    clearCaches(cm);
	  }
	
	  function guttersChanged(cm) {
	    updateGutters(cm);
	    regChange(cm);
	    setTimeout(function(){alignHorizontally(cm);}, 20);
	  }
	
	  // Rebuild the gutter elements, ensure the margin to the left of the
	  // code matches their width.
	  function updateGutters(cm) {
	    var gutters = cm.display.gutters, specs = cm.options.gutters;
	    removeChildren(gutters);
	    for (var i = 0; i < specs.length; ++i) {
	      var gutterClass = specs[i];
	      var gElt = gutters.appendChild(elt("div", null, "CodeMirror-gutter " + gutterClass));
	      if (gutterClass == "CodeMirror-linenumbers") {
	        cm.display.lineGutter = gElt;
	        gElt.style.width = (cm.display.lineNumWidth || 1) + "px";
	      }
	    }
	    gutters.style.display = i ? "" : "none";
	    updateGutterSpace(cm);
	  }
	
	  function updateGutterSpace(cm) {
	    var width = cm.display.gutters.offsetWidth;
	    cm.display.sizer.style.marginLeft = width + "px";
	  }
	
	  // Compute the character length of a line, taking into account
	  // collapsed ranges (see markText) that might hide parts, and join
	  // other lines onto it.
	  function lineLength(line) {
	    if (line.height == 0) return 0;
	    var len = line.text.length, merged, cur = line;
	    while (merged = collapsedSpanAtStart(cur)) {
	      var found = merged.find(0, true);
	      cur = found.from.line;
	      len += found.from.ch - found.to.ch;
	    }
	    cur = line;
	    while (merged = collapsedSpanAtEnd(cur)) {
	      var found = merged.find(0, true);
	      len -= cur.text.length - found.from.ch;
	      cur = found.to.line;
	      len += cur.text.length - found.to.ch;
	    }
	    return len;
	  }
	
	  // Find the longest line in the document.
	  function findMaxLine(cm) {
	    var d = cm.display, doc = cm.doc;
	    d.maxLine = getLine(doc, doc.first);
	    d.maxLineLength = lineLength(d.maxLine);
	    d.maxLineChanged = true;
	    doc.iter(function(line) {
	      var len = lineLength(line);
	      if (len > d.maxLineLength) {
	        d.maxLineLength = len;
	        d.maxLine = line;
	      }
	    });
	  }
	
	  // Make sure the gutters options contains the element
	  // "CodeMirror-linenumbers" when the lineNumbers option is true.
	  function setGuttersForLineNumbers(options) {
	    var found = indexOf(options.gutters, "CodeMirror-linenumbers");
	    if (found == -1 && options.lineNumbers) {
	      options.gutters = options.gutters.concat(["CodeMirror-linenumbers"]);
	    } else if (found > -1 && !options.lineNumbers) {
	      options.gutters = options.gutters.slice(0);
	      options.gutters.splice(found, 1);
	    }
	  }
	
	  // SCROLLBARS
	
	  // Prepare DOM reads needed to update the scrollbars. Done in one
	  // shot to minimize update/measure roundtrips.
	  function measureForScrollbars(cm) {
	    var d = cm.display, gutterW = d.gutters.offsetWidth;
	    var docH = Math.round(cm.doc.height + paddingVert(cm.display));
	    return {
	      clientHeight: d.scroller.clientHeight,
	      viewHeight: d.wrapper.clientHeight,
	      scrollWidth: d.scroller.scrollWidth, clientWidth: d.scroller.clientWidth,
	      viewWidth: d.wrapper.clientWidth,
	      barLeft: cm.options.fixedGutter ? gutterW : 0,
	      docHeight: docH,
	      scrollHeight: docH + scrollGap(cm) + d.barHeight,
	      nativeBarWidth: d.nativeBarWidth,
	      gutterWidth: gutterW
	    };
	  }
	
	  function NativeScrollbars(place, scroll, cm) {
	    this.cm = cm;
	    var vert = this.vert = elt("div", [elt("div", null, null, "min-width: 1px")], "CodeMirror-vscrollbar");
	    var horiz = this.horiz = elt("div", [elt("div", null, null, "height: 100%; min-height: 1px")], "CodeMirror-hscrollbar");
	    place(vert); place(horiz);
	
	    on(vert, "scroll", function() {
	      if (vert.clientHeight) scroll(vert.scrollTop, "vertical");
	    });
	    on(horiz, "scroll", function() {
	      if (horiz.clientWidth) scroll(horiz.scrollLeft, "horizontal");
	    });
	
	    this.checkedZeroWidth = false;
	    // Need to set a minimum width to see the scrollbar on IE7 (but must not set it on IE8).
	    if (ie && ie_version < 8) this.horiz.style.minHeight = this.vert.style.minWidth = "18px";
	  }
	
	  NativeScrollbars.prototype = copyObj({
	    update: function(measure) {
	      var needsH = measure.scrollWidth > measure.clientWidth + 1;
	      var needsV = measure.scrollHeight > measure.clientHeight + 1;
	      var sWidth = measure.nativeBarWidth;
	
	      if (needsV) {
	        this.vert.style.display = "block";
	        this.vert.style.bottom = needsH ? sWidth + "px" : "0";
	        var totalHeight = measure.viewHeight - (needsH ? sWidth : 0);
	        // A bug in IE8 can cause this value to be negative, so guard it.
	        this.vert.firstChild.style.height =
	          Math.max(0, measure.scrollHeight - measure.clientHeight + totalHeight) + "px";
	      } else {
	        this.vert.style.display = "";
	        this.vert.firstChild.style.height = "0";
	      }
	
	      if (needsH) {
	        this.horiz.style.display = "block";
	        this.horiz.style.right = needsV ? sWidth + "px" : "0";
	        this.horiz.style.left = measure.barLeft + "px";
	        var totalWidth = measure.viewWidth - measure.barLeft - (needsV ? sWidth : 0);
	        this.horiz.firstChild.style.width =
	          (measure.scrollWidth - measure.clientWidth + totalWidth) + "px";
	      } else {
	        this.horiz.style.display = "";
	        this.horiz.firstChild.style.width = "0";
	      }
	
	      if (!this.checkedZeroWidth && measure.clientHeight > 0) {
	        if (sWidth == 0) this.zeroWidthHack();
	        this.checkedZeroWidth = true;
	      }
	
	      return {right: needsV ? sWidth : 0, bottom: needsH ? sWidth : 0};
	    },
	    setScrollLeft: function(pos) {
	      if (this.horiz.scrollLeft != pos) this.horiz.scrollLeft = pos;
	      if (this.disableHoriz) this.enableZeroWidthBar(this.horiz, this.disableHoriz);
	    },
	    setScrollTop: function(pos) {
	      if (this.vert.scrollTop != pos) this.vert.scrollTop = pos;
	      if (this.disableVert) this.enableZeroWidthBar(this.vert, this.disableVert);
	    },
	    zeroWidthHack: function() {
	      var w = mac && !mac_geMountainLion ? "12px" : "18px";
	      this.horiz.style.height = this.vert.style.width = w;
	      this.horiz.style.pointerEvents = this.vert.style.pointerEvents = "none";
	      this.disableHoriz = new Delayed;
	      this.disableVert = new Delayed;
	    },
	    enableZeroWidthBar: function(bar, delay) {
	      bar.style.pointerEvents = "auto";
	      function maybeDisable() {
	        // To find out whether the scrollbar is still visible, we
	        // check whether the element under the pixel in the bottom
	        // left corner of the scrollbar box is the scrollbar box
	        // itself (when the bar is still visible) or its filler child
	        // (when the bar is hidden). If it is still visible, we keep
	        // it enabled, if it's hidden, we disable pointer events.
	        var box = bar.getBoundingClientRect();
	        var elt = document.elementFromPoint(box.left + 1, box.bottom - 1);
	        if (elt != bar) bar.style.pointerEvents = "none";
	        else delay.set(1000, maybeDisable);
	      }
	      delay.set(1000, maybeDisable);
	    },
	    clear: function() {
	      var parent = this.horiz.parentNode;
	      parent.removeChild(this.horiz);
	      parent.removeChild(this.vert);
	    }
	  }, NativeScrollbars.prototype);
	
	  function NullScrollbars() {}
	
	  NullScrollbars.prototype = copyObj({
	    update: function() { return {bottom: 0, right: 0}; },
	    setScrollLeft: function() {},
	    setScrollTop: function() {},
	    clear: function() {}
	  }, NullScrollbars.prototype);
	
	  CodeMirror.scrollbarModel = {"native": NativeScrollbars, "null": NullScrollbars};
	
	  function initScrollbars(cm) {
	    if (cm.display.scrollbars) {
	      cm.display.scrollbars.clear();
	      if (cm.display.scrollbars.addClass)
	        rmClass(cm.display.wrapper, cm.display.scrollbars.addClass);
	    }
	
	    cm.display.scrollbars = new CodeMirror.scrollbarModel[cm.options.scrollbarStyle](function(node) {
	      cm.display.wrapper.insertBefore(node, cm.display.scrollbarFiller);
	      // Prevent clicks in the scrollbars from killing focus
	      on(node, "mousedown", function() {
	        if (cm.state.focused) setTimeout(function() { cm.display.input.focus(); }, 0);
	      });
	      node.setAttribute("cm-not-content", "true");
	    }, function(pos, axis) {
	      if (axis == "horizontal") setScrollLeft(cm, pos);
	      else setScrollTop(cm, pos);
	    }, cm);
	    if (cm.display.scrollbars.addClass)
	      addClass(cm.display.wrapper, cm.display.scrollbars.addClass);
	  }
	
	  function updateScrollbars(cm, measure) {
	    if (!measure) measure = measureForScrollbars(cm);
	    var startWidth = cm.display.barWidth, startHeight = cm.display.barHeight;
	    updateScrollbarsInner(cm, measure);
	    for (var i = 0; i < 4 && startWidth != cm.display.barWidth || startHeight != cm.display.barHeight; i++) {
	      if (startWidth != cm.display.barWidth && cm.options.lineWrapping)
	        updateHeightsInViewport(cm);
	      updateScrollbarsInner(cm, measureForScrollbars(cm));
	      startWidth = cm.display.barWidth; startHeight = cm.display.barHeight;
	    }
	  }
	
	  // Re-synchronize the fake scrollbars with the actual size of the
	  // content.
	  function updateScrollbarsInner(cm, measure) {
	    var d = cm.display;
	    var sizes = d.scrollbars.update(measure);
	
	    d.sizer.style.paddingRight = (d.barWidth = sizes.right) + "px";
	    d.sizer.style.paddingBottom = (d.barHeight = sizes.bottom) + "px";
	    d.heightForcer.style.borderBottom = sizes.bottom + "px solid transparent"
	
	    if (sizes.right && sizes.bottom) {
	      d.scrollbarFiller.style.display = "block";
	      d.scrollbarFiller.style.height = sizes.bottom + "px";
	      d.scrollbarFiller.style.width = sizes.right + "px";
	    } else d.scrollbarFiller.style.display = "";
	    if (sizes.bottom && cm.options.coverGutterNextToScrollbar && cm.options.fixedGutter) {
	      d.gutterFiller.style.display = "block";
	      d.gutterFiller.style.height = sizes.bottom + "px";
	      d.gutterFiller.style.width = measure.gutterWidth + "px";
	    } else d.gutterFiller.style.display = "";
	  }
	
	  // Compute the lines that are visible in a given viewport (defaults
	  // the the current scroll position). viewport may contain top,
	  // height, and ensure (see op.scrollToPos) properties.
	  function visibleLines(display, doc, viewport) {
	    var top = viewport && viewport.top != null ? Math.max(0, viewport.top) : display.scroller.scrollTop;
	    top = Math.floor(top - paddingTop(display));
	    var bottom = viewport && viewport.bottom != null ? viewport.bottom : top + display.wrapper.clientHeight;
	
	    var from = lineAtHeight(doc, top), to = lineAtHeight(doc, bottom);
	    // Ensure is a {from: {line, ch}, to: {line, ch}} object, and
	    // forces those lines into the viewport (if possible).
	    if (viewport && viewport.ensure) {
	      var ensureFrom = viewport.ensure.from.line, ensureTo = viewport.ensure.to.line;
	      if (ensureFrom < from) {
	        from = ensureFrom;
	        to = lineAtHeight(doc, heightAtLine(getLine(doc, ensureFrom)) + display.wrapper.clientHeight);
	      } else if (Math.min(ensureTo, doc.lastLine()) >= to) {
	        from = lineAtHeight(doc, heightAtLine(getLine(doc, ensureTo)) - display.wrapper.clientHeight);
	        to = ensureTo;
	      }
	    }
	    return {from: from, to: Math.max(to, from + 1)};
	  }
	
	  // LINE NUMBERS
	
	  // Re-align line numbers and gutter marks to compensate for
	  // horizontal scrolling.
	  function alignHorizontally(cm) {
	    var display = cm.display, view = display.view;
	    if (!display.alignWidgets && (!display.gutters.firstChild || !cm.options.fixedGutter)) return;
	    var comp = compensateForHScroll(display) - display.scroller.scrollLeft + cm.doc.scrollLeft;
	    var gutterW = display.gutters.offsetWidth, left = comp + "px";
	    for (var i = 0; i < view.length; i++) if (!view[i].hidden) {
	      if (cm.options.fixedGutter) {
	        if (view[i].gutter)
	          view[i].gutter.style.left = left;
	        if (view[i].gutterBackground)
	          view[i].gutterBackground.style.left = left;
	      }
	      var align = view[i].alignable;
	      if (align) for (var j = 0; j < align.length; j++)
	        align[j].style.left = left;
	    }
	    if (cm.options.fixedGutter)
	      display.gutters.style.left = (comp + gutterW) + "px";
	  }
	
	  // Used to ensure that the line number gutter is still the right
	  // size for the current document size. Returns true when an update
	  // is needed.
	  function maybeUpdateLineNumberWidth(cm) {
	    if (!cm.options.lineNumbers) return false;
	    var doc = cm.doc, last = lineNumberFor(cm.options, doc.first + doc.size - 1), display = cm.display;
	    if (last.length != display.lineNumChars) {
	      var test = display.measure.appendChild(elt("div", [elt("div", last)],
	                                                 "CodeMirror-linenumber CodeMirror-gutter-elt"));
	      var innerW = test.firstChild.offsetWidth, padding = test.offsetWidth - innerW;
	      display.lineGutter.style.width = "";
	      display.lineNumInnerWidth = Math.max(innerW, display.lineGutter.offsetWidth - padding) + 1;
	      display.lineNumWidth = display.lineNumInnerWidth + padding;
	      display.lineNumChars = display.lineNumInnerWidth ? last.length : -1;
	      display.lineGutter.style.width = display.lineNumWidth + "px";
	      updateGutterSpace(cm);
	      return true;
	    }
	    return false;
	  }
	
	  function lineNumberFor(options, i) {
	    return String(options.lineNumberFormatter(i + options.firstLineNumber));
	  }
	
	  // Computes display.scroller.scrollLeft + display.gutters.offsetWidth,
	  // but using getBoundingClientRect to get a sub-pixel-accurate
	  // result.
	  function compensateForHScroll(display) {
	    return display.scroller.getBoundingClientRect().left - display.sizer.getBoundingClientRect().left;
	  }
	
	  // DISPLAY DRAWING
	
	  function DisplayUpdate(cm, viewport, force) {
	    var display = cm.display;
	
	    this.viewport = viewport;
	    // Store some values that we'll need later (but don't want to force a relayout for)
	    this.visible = visibleLines(display, cm.doc, viewport);
	    this.editorIsHidden = !display.wrapper.offsetWidth;
	    this.wrapperHeight = display.wrapper.clientHeight;
	    this.wrapperWidth = display.wrapper.clientWidth;
	    this.oldDisplayWidth = displayWidth(cm);
	    this.force = force;
	    this.dims = getDimensions(cm);
	    this.events = [];
	  }
	
	  DisplayUpdate.prototype.signal = function(emitter, type) {
	    if (hasHandler(emitter, type))
	      this.events.push(arguments);
	  };
	  DisplayUpdate.prototype.finish = function() {
	    for (var i = 0; i < this.events.length; i++)
	      signal.apply(null, this.events[i]);
	  };
	
	  function maybeClipScrollbars(cm) {
	    var display = cm.display;
	    if (!display.scrollbarsClipped && display.scroller.offsetWidth) {
	      display.nativeBarWidth = display.scroller.offsetWidth - display.scroller.clientWidth;
	      display.heightForcer.style.height = scrollGap(cm) + "px";
	      display.sizer.style.marginBottom = -display.nativeBarWidth + "px";
	      display.sizer.style.borderRightWidth = scrollGap(cm) + "px";
	      display.scrollbarsClipped = true;
	    }
	  }
	
	  // Does the actual updating of the line display. Bails out
	  // (returning false) when there is nothing to be done and forced is
	  // false.
	  function updateDisplayIfNeeded(cm, update) {
	    var display = cm.display, doc = cm.doc;
	
	    if (update.editorIsHidden) {
	      resetView(cm);
	      return false;
	    }
	
	    // Bail out if the visible area is already rendered and nothing changed.
	    if (!update.force &&
	        update.visible.from >= display.viewFrom && update.visible.to <= display.viewTo &&
	        (display.updateLineNumbers == null || display.updateLineNumbers >= display.viewTo) &&
	        display.renderedView == display.view && countDirtyView(cm) == 0)
	      return false;
	
	    if (maybeUpdateLineNumberWidth(cm)) {
	      resetView(cm);
	      update.dims = getDimensions(cm);
	    }
	
	    // Compute a suitable new viewport (from & to)
	    var end = doc.first + doc.size;
	    var from = Math.max(update.visible.from - cm.options.viewportMargin, doc.first);
	    var to = Math.min(end, update.visible.to + cm.options.viewportMargin);
	    if (display.viewFrom < from && from - display.viewFrom < 20) from = Math.max(doc.first, display.viewFrom);
	    if (display.viewTo > to && display.viewTo - to < 20) to = Math.min(end, display.viewTo);
	    if (sawCollapsedSpans) {
	      from = visualLineNo(cm.doc, from);
	      to = visualLineEndNo(cm.doc, to);
	    }
	
	    var different = from != display.viewFrom || to != display.viewTo ||
	      display.lastWrapHeight != update.wrapperHeight || display.lastWrapWidth != update.wrapperWidth;
	    adjustView(cm, from, to);
	
	    display.viewOffset = heightAtLine(getLine(cm.doc, display.viewFrom));
	    // Position the mover div to align with the current scroll position
	    cm.display.mover.style.top = display.viewOffset + "px";
	
	    var toUpdate = countDirtyView(cm);
	    if (!different && toUpdate == 0 && !update.force && display.renderedView == display.view &&
	        (display.updateLineNumbers == null || display.updateLineNumbers >= display.viewTo))
	      return false;
	
	    // For big changes, we hide the enclosing element during the
	    // update, since that speeds up the operations on most browsers.
	    var focused = activeElt();
	    if (toUpdate > 4) display.lineDiv.style.display = "none";
	    patchDisplay(cm, display.updateLineNumbers, update.dims);
	    if (toUpdate > 4) display.lineDiv.style.display = "";
	    display.renderedView = display.view;
	    // There might have been a widget with a focused element that got
	    // hidden or updated, if so re-focus it.
	    if (focused && activeElt() != focused && focused.offsetHeight) focused.focus();
	
	    // Prevent selection and cursors from interfering with the scroll
	    // width and height.
	    removeChildren(display.cursorDiv);
	    removeChildren(display.selectionDiv);
	    display.gutters.style.height = display.sizer.style.minHeight = 0;
	
	    if (different) {
	      display.lastWrapHeight = update.wrapperHeight;
	      display.lastWrapWidth = update.wrapperWidth;
	      startWorker(cm, 400);
	    }
	
	    display.updateLineNumbers = null;
	
	    return true;
	  }
	
	  function postUpdateDisplay(cm, update) {
	    var viewport = update.viewport;
	
	    for (var first = true;; first = false) {
	      if (!first || !cm.options.lineWrapping || update.oldDisplayWidth == displayWidth(cm)) {
	        // Clip forced viewport to actual scrollable area.
	        if (viewport && viewport.top != null)
	          viewport = {top: Math.min(cm.doc.height + paddingVert(cm.display) - displayHeight(cm), viewport.top)};
	        // Updated line heights might result in the drawn area not
	        // actually covering the viewport. Keep looping until it does.
	        update.visible = visibleLines(cm.display, cm.doc, viewport);
	        if (update.visible.from >= cm.display.viewFrom && update.visible.to <= cm.display.viewTo)
	          break;
	      }
	      if (!updateDisplayIfNeeded(cm, update)) break;
	      updateHeightsInViewport(cm);
	      var barMeasure = measureForScrollbars(cm);
	      updateSelection(cm);
	      updateScrollbars(cm, barMeasure);
	      setDocumentHeight(cm, barMeasure);
	    }
	
	    update.signal(cm, "update", cm);
	    if (cm.display.viewFrom != cm.display.reportedViewFrom || cm.display.viewTo != cm.display.reportedViewTo) {
	      update.signal(cm, "viewportChange", cm, cm.display.viewFrom, cm.display.viewTo);
	      cm.display.reportedViewFrom = cm.display.viewFrom; cm.display.reportedViewTo = cm.display.viewTo;
	    }
	  }
	
	  function updateDisplaySimple(cm, viewport) {
	    var update = new DisplayUpdate(cm, viewport);
	    if (updateDisplayIfNeeded(cm, update)) {
	      updateHeightsInViewport(cm);
	      postUpdateDisplay(cm, update);
	      var barMeasure = measureForScrollbars(cm);
	      updateSelection(cm);
	      updateScrollbars(cm, barMeasure);
	      setDocumentHeight(cm, barMeasure);
	      update.finish();
	    }
	  }
	
	  function setDocumentHeight(cm, measure) {
	    cm.display.sizer.style.minHeight = measure.docHeight + "px";
	    cm.display.heightForcer.style.top = measure.docHeight + "px";
	    cm.display.gutters.style.height = (measure.docHeight + cm.display.barHeight + scrollGap(cm)) + "px";
	  }
	
	  // Read the actual heights of the rendered lines, and update their
	  // stored heights to match.
	  function updateHeightsInViewport(cm) {
	    var display = cm.display;
	    var prevBottom = display.lineDiv.offsetTop;
	    for (var i = 0; i < display.view.length; i++) {
	      var cur = display.view[i], height;
	      if (cur.hidden) continue;
	      if (ie && ie_version < 8) {
	        var bot = cur.node.offsetTop + cur.node.offsetHeight;
	        height = bot - prevBottom;
	        prevBottom = bot;
	      } else {
	        var box = cur.node.getBoundingClientRect();
	        height = box.bottom - box.top;
	      }
	      var diff = cur.line.height - height;
	      if (height < 2) height = textHeight(display);
	      if (diff > .001 || diff < -.001) {
	        updateLineHeight(cur.line, height);
	        updateWidgetHeight(cur.line);
	        if (cur.rest) for (var j = 0; j < cur.rest.length; j++)
	          updateWidgetHeight(cur.rest[j]);
	      }
	    }
	  }
	
	  // Read and store the height of line widgets associated with the
	  // given line.
	  function updateWidgetHeight(line) {
	    if (line.widgets) for (var i = 0; i < line.widgets.length; ++i)
	      line.widgets[i].height = line.widgets[i].node.parentNode.offsetHeight;
	  }
	
	  // Do a bulk-read of the DOM positions and sizes needed to draw the
	  // view, so that we don't interleave reading and writing to the DOM.
	  function getDimensions(cm) {
	    var d = cm.display, left = {}, width = {};
	    var gutterLeft = d.gutters.clientLeft;
	    for (var n = d.gutters.firstChild, i = 0; n; n = n.nextSibling, ++i) {
	      left[cm.options.gutters[i]] = n.offsetLeft + n.clientLeft + gutterLeft;
	      width[cm.options.gutters[i]] = n.clientWidth;
	    }
	    return {fixedPos: compensateForHScroll(d),
	            gutterTotalWidth: d.gutters.offsetWidth,
	            gutterLeft: left,
	            gutterWidth: width,
	            wrapperWidth: d.wrapper.clientWidth};
	  }
	
	  // Sync the actual display DOM structure with display.view, removing
	  // nodes for lines that are no longer in view, and creating the ones
	  // that are not there yet, and updating the ones that are out of
	  // date.
	  function patchDisplay(cm, updateNumbersFrom, dims) {
	    var display = cm.display, lineNumbers = cm.options.lineNumbers;
	    var container = display.lineDiv, cur = container.firstChild;
	
	    function rm(node) {
	      var next = node.nextSibling;
	      // Works around a throw-scroll bug in OS X Webkit
	      if (webkit && mac && cm.display.currentWheelTarget == node)
	        node.style.display = "none";
	      else
	        node.parentNode.removeChild(node);
	      return next;
	    }
	
	    var view = display.view, lineN = display.viewFrom;
	    // Loop over the elements in the view, syncing cur (the DOM nodes
	    // in display.lineDiv) with the view as we go.
	    for (var i = 0; i < view.length; i++) {
	      var lineView = view[i];
	      if (lineView.hidden) {
	      } else if (!lineView.node || lineView.node.parentNode != container) { // Not drawn yet
	        var node = buildLineElement(cm, lineView, lineN, dims);
	        container.insertBefore(node, cur);
	      } else { // Already drawn
	        while (cur != lineView.node) cur = rm(cur);
	        var updateNumber = lineNumbers && updateNumbersFrom != null &&
	          updateNumbersFrom <= lineN && lineView.lineNumber;
	        if (lineView.changes) {
	          if (indexOf(lineView.changes, "gutter") > -1) updateNumber = false;
	          updateLineForChanges(cm, lineView, lineN, dims);
	        }
	        if (updateNumber) {
	          removeChildren(lineView.lineNumber);
	          lineView.lineNumber.appendChild(document.createTextNode(lineNumberFor(cm.options, lineN)));
	        }
	        cur = lineView.node.nextSibling;
	      }
	      lineN += lineView.size;
	    }
	    while (cur) cur = rm(cur);
	  }
	
	  // When an aspect of a line changes, a string is added to
	  // lineView.changes. This updates the relevant part of the line's
	  // DOM structure.
	  function updateLineForChanges(cm, lineView, lineN, dims) {
	    for (var j = 0; j < lineView.changes.length; j++) {
	      var type = lineView.changes[j];
	      if (type == "text") updateLineText(cm, lineView);
	      else if (type == "gutter") updateLineGutter(cm, lineView, lineN, dims);
	      else if (type == "class") updateLineClasses(lineView);
	      else if (type == "widget") updateLineWidgets(cm, lineView, dims);
	    }
	    lineView.changes = null;
	  }
	
	  // Lines with gutter elements, widgets or a background class need to
	  // be wrapped, and have the extra elements added to the wrapper div
	  function ensureLineWrapped(lineView) {
	    if (lineView.node == lineView.text) {
	      lineView.node = elt("div", null, null, "position: relative");
	      if (lineView.text.parentNode)
	        lineView.text.parentNode.replaceChild(lineView.node, lineView.text);
	      lineView.node.appendChild(lineView.text);
	      if (ie && ie_version < 8) lineView.node.style.zIndex = 2;
	    }
	    return lineView.node;
	  }
	
	  function updateLineBackground(lineView) {
	    var cls = lineView.bgClass ? lineView.bgClass + " " + (lineView.line.bgClass || "") : lineView.line.bgClass;
	    if (cls) cls += " CodeMirror-linebackground";
	    if (lineView.background) {
	      if (cls) lineView.background.className = cls;
	      else { lineView.background.parentNode.removeChild(lineView.background); lineView.background = null; }
	    } else if (cls) {
	      var wrap = ensureLineWrapped(lineView);
	      lineView.background = wrap.insertBefore(elt("div", null, cls), wrap.firstChild);
	    }
	  }
	
	  // Wrapper around buildLineContent which will reuse the structure
	  // in display.externalMeasured when possible.
	  function getLineContent(cm, lineView) {
	    var ext = cm.display.externalMeasured;
	    if (ext && ext.line == lineView.line) {
	      cm.display.externalMeasured = null;
	      lineView.measure = ext.measure;
	      return ext.built;
	    }
	    return buildLineContent(cm, lineView);
	  }
	
	  // Redraw the line's text. Interacts with the background and text
	  // classes because the mode may output tokens that influence these
	  // classes.
	  function updateLineText(cm, lineView) {
	    var cls = lineView.text.className;
	    var built = getLineContent(cm, lineView);
	    if (lineView.text == lineView.node) lineView.node = built.pre;
	    lineView.text.parentNode.replaceChild(built.pre, lineView.text);
	    lineView.text = built.pre;
	    if (built.bgClass != lineView.bgClass || built.textClass != lineView.textClass) {
	      lineView.bgClass = built.bgClass;
	      lineView.textClass = built.textClass;
	      updateLineClasses(lineView);
	    } else if (cls) {
	      lineView.text.className = cls;
	    }
	  }
	
	  function updateLineClasses(lineView) {
	    updateLineBackground(lineView);
	    if (lineView.line.wrapClass)
	      ensureLineWrapped(lineView).className = lineView.line.wrapClass;
	    else if (lineView.node != lineView.text)
	      lineView.node.className = "";
	    var textClass = lineView.textClass ? lineView.textClass + " " + (lineView.line.textClass || "") : lineView.line.textClass;
	    lineView.text.className = textClass || "";
	  }
	
	  function updateLineGutter(cm, lineView, lineN, dims) {
	    if (lineView.gutter) {
	      lineView.node.removeChild(lineView.gutter);
	      lineView.gutter = null;
	    }
	    if (lineView.gutterBackground) {
	      lineView.node.removeChild(lineView.gutterBackground);
	      lineView.gutterBackground = null;
	    }
	    if (lineView.line.gutterClass) {
	      var wrap = ensureLineWrapped(lineView);
	      lineView.gutterBackground = elt("div", null, "CodeMirror-gutter-background " + lineView.line.gutterClass,
	                                      "left: " + (cm.options.fixedGutter ? dims.fixedPos : -dims.gutterTotalWidth) +
	                                      "px; width: " + dims.gutterTotalWidth + "px");
	      wrap.insertBefore(lineView.gutterBackground, lineView.text);
	    }
	    var markers = lineView.line.gutterMarkers;
	    if (cm.options.lineNumbers || markers) {
	      var wrap = ensureLineWrapped(lineView);
	      var gutterWrap = lineView.gutter = elt("div", null, "CodeMirror-gutter-wrapper", "left: " +
	                                             (cm.options.fixedGutter ? dims.fixedPos : -dims.gutterTotalWidth) + "px");
	      cm.display.input.setUneditable(gutterWrap);
	      wrap.insertBefore(gutterWrap, lineView.text);
	      if (lineView.line.gutterClass)
	        gutterWrap.className += " " + lineView.line.gutterClass;
	      if (cm.options.lineNumbers && (!markers || !markers["CodeMirror-linenumbers"]))
	        lineView.lineNumber = gutterWrap.appendChild(
	          elt("div", lineNumberFor(cm.options, lineN),
	              "CodeMirror-linenumber CodeMirror-gutter-elt",
	              "left: " + dims.gutterLeft["CodeMirror-linenumbers"] + "px; width: "
	              + cm.display.lineNumInnerWidth + "px"));
	      if (markers) for (var k = 0; k < cm.options.gutters.length; ++k) {
	        var id = cm.options.gutters[k], found = markers.hasOwnProperty(id) && markers[id];
	        if (found)
	          gutterWrap.appendChild(elt("div", [found], "CodeMirror-gutter-elt", "left: " +
	                                     dims.gutterLeft[id] + "px; width: " + dims.gutterWidth[id] + "px"));
	      }
	    }
	  }
	
	  function updateLineWidgets(cm, lineView, dims) {
	    if (lineView.alignable) lineView.alignable = null;
	    for (var node = lineView.node.firstChild, next; node; node = next) {
	      var next = node.nextSibling;
	      if (node.className == "CodeMirror-linewidget")
	        lineView.node.removeChild(node);
	    }
	    insertLineWidgets(cm, lineView, dims);
	  }
	
	  // Build a line's DOM representation from scratch
	  function buildLineElement(cm, lineView, lineN, dims) {
	    var built = getLineContent(cm, lineView);
	    lineView.text = lineView.node = built.pre;
	    if (built.bgClass) lineView.bgClass = built.bgClass;
	    if (built.textClass) lineView.textClass = built.textClass;
	
	    updateLineClasses(lineView);
	    updateLineGutter(cm, lineView, lineN, dims);
	    insertLineWidgets(cm, lineView, dims);
	    return lineView.node;
	  }
	
	  // A lineView may contain multiple logical lines (when merged by
	  // collapsed spans). The widgets for all of them need to be drawn.
	  function insertLineWidgets(cm, lineView, dims) {
	    insertLineWidgetsFor(cm, lineView.line, lineView, dims, true);
	    if (lineView.rest) for (var i = 0; i < lineView.rest.length; i++)
	      insertLineWidgetsFor(cm, lineView.rest[i], lineView, dims, false);
	  }
	
	  function insertLineWidgetsFor(cm, line, lineView, dims, allowAbove) {
	    if (!line.widgets) return;
	    var wrap = ensureLineWrapped(lineView);
	    for (var i = 0, ws = line.widgets; i < ws.length; ++i) {
	      var widget = ws[i], node = elt("div", [widget.node], "CodeMirror-linewidget");
	      if (!widget.handleMouseEvents) node.setAttribute("cm-ignore-events", "true");
	      positionLineWidget(widget, node, lineView, dims);
	      cm.display.input.setUneditable(node);
	      if (allowAbove && widget.above)
	        wrap.insertBefore(node, lineView.gutter || lineView.text);
	      else
	        wrap.appendChild(node);
	      signalLater(widget, "redraw");
	    }
	  }
	
	  function positionLineWidget(widget, node, lineView, dims) {
	    if (widget.noHScroll) {
	      (lineView.alignable || (lineView.alignable = [])).push(node);
	      var width = dims.wrapperWidth;
	      node.style.left = dims.fixedPos + "px";
	      if (!widget.coverGutter) {
	        width -= dims.gutterTotalWidth;
	        node.style.paddingLeft = dims.gutterTotalWidth + "px";
	      }
	      node.style.width = width + "px";
	    }
	    if (widget.coverGutter) {
	      node.style.zIndex = 5;
	      node.style.position = "relative";
	      if (!widget.noHScroll) node.style.marginLeft = -dims.gutterTotalWidth + "px";
	    }
	  }
	
	  // POSITION OBJECT
	
	  // A Pos instance represents a position within the text.
	  var Pos = CodeMirror.Pos = function(line, ch) {
	    if (!(this instanceof Pos)) return new Pos(line, ch);
	    this.line = line; this.ch = ch;
	  };
	
	  // Compare two positions, return 0 if they are the same, a negative
	  // number when a is less, and a positive number otherwise.
	  var cmp = CodeMirror.cmpPos = function(a, b) { return a.line - b.line || a.ch - b.ch; };
	
	  function copyPos(x) {return Pos(x.line, x.ch);}
	  function maxPos(a, b) { return cmp(a, b) < 0 ? b : a; }
	  function minPos(a, b) { return cmp(a, b) < 0 ? a : b; }
	
	  // INPUT HANDLING
	
	  function ensureFocus(cm) {
	    if (!cm.state.focused) { cm.display.input.focus(); onFocus(cm); }
	  }
	
	  // This will be set to a {lineWise: bool, text: [string]} object, so
	  // that, when pasting, we know what kind of selections the copied
	  // text was made out of.
	  var lastCopied = null;
	
	  function applyTextInput(cm, inserted, deleted, sel, origin) {
	    var doc = cm.doc;
	    cm.display.shift = false;
	    if (!sel) sel = doc.sel;
	
	    var paste = cm.state.pasteIncoming || origin == "paste";
	    var textLines = doc.splitLines(inserted), multiPaste = null
	    // When pasing N lines into N selections, insert one line per selection
	    if (paste && sel.ranges.length > 1) {
	      if (lastCopied && lastCopied.text.join("\n") == inserted) {
	        if (sel.ranges.length % lastCopied.text.length == 0) {
	          multiPaste = [];
	          for (var i = 0; i < lastCopied.text.length; i++)
	            multiPaste.push(doc.splitLines(lastCopied.text[i]));
	        }
	      } else if (textLines.length == sel.ranges.length) {
	        multiPaste = map(textLines, function(l) { return [l]; });
	      }
	    }
	
	    // Normal behavior is to insert the new text into every selection
	    for (var i = sel.ranges.length - 1; i >= 0; i--) {
	      var range = sel.ranges[i];
	      var from = range.from(), to = range.to();
	      if (range.empty()) {
	        if (deleted && deleted > 0) // Handle deletion
	          from = Pos(from.line, from.ch - deleted);
	        else if (cm.state.overwrite && !paste) // Handle overwrite
	          to = Pos(to.line, Math.min(getLine(doc, to.line).text.length, to.ch + lst(textLines).length));
	        else if (lastCopied && lastCopied.lineWise && lastCopied.text.join("\n") == inserted)
	          from = to = Pos(from.line, 0)
	      }
	      var updateInput = cm.curOp.updateInput;
	      var changeEvent = {from: from, to: to, text: multiPaste ? multiPaste[i % multiPaste.length] : textLines,
	                         origin: origin || (paste ? "paste" : cm.state.cutIncoming ? "cut" : "+input")};
	      makeChange(cm.doc, changeEvent);
	      signalLater(cm, "inputRead", cm, changeEvent);
	    }
	    if (inserted && !paste)
	      triggerElectric(cm, inserted);
	
	    ensureCursorVisible(cm);
	    cm.curOp.updateInput = updateInput;
	    cm.curOp.typing = true;
	    cm.state.pasteIncoming = cm.state.cutIncoming = false;
	  }
	
	  function handlePaste(e, cm) {
	    var pasted = e.clipboardData && e.clipboardData.getData("Text");
	    if (pasted) {
	      e.preventDefault();
	      if (!cm.isReadOnly() && !cm.options.disableInput)
	        runInOp(cm, function() { applyTextInput(cm, pasted, 0, null, "paste"); });
	      return true;
	    }
	  }
	
	  function triggerElectric(cm, inserted) {
	    // When an 'electric' character is inserted, immediately trigger a reindent
	    if (!cm.options.electricChars || !cm.options.smartIndent) return;
	    var sel = cm.doc.sel;
	
	    for (var i = sel.ranges.length - 1; i >= 0; i--) {
	      var range = sel.ranges[i];
	      if (range.head.ch > 100 || (i && sel.ranges[i - 1].head.line == range.head.line)) continue;
	      var mode = cm.getModeAt(range.head);
	      var indented = false;
	      if (mode.electricChars) {
	        for (var j = 0; j < mode.electricChars.length; j++)
	          if (inserted.indexOf(mode.electricChars.charAt(j)) > -1) {
	            indented = indentLine(cm, range.head.line, "smart");
	            break;
	          }
	      } else if (mode.electricInput) {
	        if (mode.electricInput.test(getLine(cm.doc, range.head.line).text.slice(0, range.head.ch)))
	          indented = indentLine(cm, range.head.line, "smart");
	      }
	      if (indented) signalLater(cm, "electricInput", cm, range.head.line);
	    }
	  }
	
	  function copyableRanges(cm) {
	    var text = [], ranges = [];
	    for (var i = 0; i < cm.doc.sel.ranges.length; i++) {
	      var line = cm.doc.sel.ranges[i].head.line;
	      var lineRange = {anchor: Pos(line, 0), head: Pos(line + 1, 0)};
	      ranges.push(lineRange);
	      text.push(cm.getRange(lineRange.anchor, lineRange.head));
	    }
	    return {text: text, ranges: ranges};
	  }
	
	  function disableBrowserMagic(field, spellcheck) {
	    field.setAttribute("autocorrect", "off");
	    field.setAttribute("autocapitalize", "off");
	    field.setAttribute("spellcheck", !!spellcheck);
	  }
	
	  // TEXTAREA INPUT STYLE
	
	  function TextareaInput(cm) {
	    this.cm = cm;
	    // See input.poll and input.reset
	    this.prevInput = "";
	
	    // Flag that indicates whether we expect input to appear real soon
	    // now (after some event like 'keypress' or 'input') and are
	    // polling intensively.
	    this.pollingFast = false;
	    // Self-resetting timeout for the poller
	    this.polling = new Delayed();
	    // Tracks when input.reset has punted to just putting a short
	    // string into the textarea instead of the full selection.
	    this.inaccurateSelection = false;
	    // Used to work around IE issue with selection being forgotten when focus moves away from textarea
	    this.hasSelection = false;
	    this.composing = null;
	  };
	
	  function hiddenTextarea() {
	    var te = elt("textarea", null, null, "position: absolute; bottom: -1em; padding: 0; width: 1px; height: 1em; outline: none");
	    var div = elt("div", [te], null, "overflow: hidden; position: relative; width: 3px; height: 0px;");
	    // The textarea is kept positioned near the cursor to prevent the
	    // fact that it'll be scrolled into view on input from scrolling
	    // our fake cursor out of view. On webkit, when wrap=off, paste is
	    // very slow. So make the area wide instead.
	    if (webkit) te.style.width = "1000px";
	    else te.setAttribute("wrap", "off");
	    // If border: 0; -- iOS fails to open keyboard (issue #1287)
	    if (ios) te.style.border = "1px solid black";
	    disableBrowserMagic(te);
	    return div;
	  }
	
	  TextareaInput.prototype = copyObj({
	    init: function(display) {
	      var input = this, cm = this.cm;
	
	      // Wraps and hides input textarea
	      var div = this.wrapper = hiddenTextarea();
	      // The semihidden textarea that is focused when the editor is
	      // focused, and receives input.
	      var te = this.textarea = div.firstChild;
	      display.wrapper.insertBefore(div, display.wrapper.firstChild);
	
	      // Needed to hide big blue blinking cursor on Mobile Safari (doesn't seem to work in iOS 8 anymore)
	      if (ios) te.style.width = "0px";
	
	      on(te, "input", function() {
	        if (ie && ie_version >= 9 && input.hasSelection) input.hasSelection = null;
	        input.poll();
	      });
	
	      on(te, "paste", function(e) {
	        if (signalDOMEvent(cm, e) || handlePaste(e, cm)) return
	
	        cm.state.pasteIncoming = true;
	        input.fastPoll();
	      });
	
	      function prepareCopyCut(e) {
	        if (signalDOMEvent(cm, e)) return
	        if (cm.somethingSelected()) {
	          lastCopied = {lineWise: false, text: cm.getSelections()};
	          if (input.inaccurateSelection) {
	            input.prevInput = "";
	            input.inaccurateSelection = false;
	            te.value = lastCopied.text.join("\n");
	            selectInput(te);
	          }
	        } else if (!cm.options.lineWiseCopyCut) {
	          return;
	        } else {
	          var ranges = copyableRanges(cm);
	          lastCopied = {lineWise: true, text: ranges.text};
	          if (e.type == "cut") {
	            cm.setSelections(ranges.ranges, null, sel_dontScroll);
	          } else {
	            input.prevInput = "";
	            te.value = ranges.text.join("\n");
	            selectInput(te);
	          }
	        }
	        if (e.type == "cut") cm.state.cutIncoming = true;
	      }
	      on(te, "cut", prepareCopyCut);
	      on(te, "copy", prepareCopyCut);
	
	      on(display.scroller, "paste", function(e) {
	        if (eventInWidget(display, e) || signalDOMEvent(cm, e)) return;
	        cm.state.pasteIncoming = true;
	        input.focus();
	      });
	
	      // Prevent normal selection in the editor (we handle our own)
	      on(display.lineSpace, "selectstart", function(e) {
	        if (!eventInWidget(display, e)) e_preventDefault(e);
	      });
	
	      on(te, "compositionstart", function() {
	        var start = cm.getCursor("from");
	        if (input.composing) input.composing.range.clear()
	        input.composing = {
	          start: start,
	          range: cm.markText(start, cm.getCursor("to"), {className: "CodeMirror-composing"})
	        };
	      });
	      on(te, "compositionend", function() {
	        if (input.composing) {
	          input.poll();
	          input.composing.range.clear();
	          input.composing = null;
	        }
	      });
	    },
	
	    prepareSelection: function() {
	      // Redraw the selection and/or cursor
	      var cm = this.cm, display = cm.display, doc = cm.doc;
	      var result = prepareSelection(cm);
	
	      // Move the hidden textarea near the cursor to prevent scrolling artifacts
	      if (cm.options.moveInputWithCursor) {
	        var headPos = cursorCoords(cm, doc.sel.primary().head, "div");
	        var wrapOff = display.wrapper.getBoundingClientRect(), lineOff = display.lineDiv.getBoundingClientRect();
	        result.teTop = Math.max(0, Math.min(display.wrapper.clientHeight - 10,
	                                            headPos.top + lineOff.top - wrapOff.top));
	        result.teLeft = Math.max(0, Math.min(display.wrapper.clientWidth - 10,
	                                             headPos.left + lineOff.left - wrapOff.left));
	      }
	
	      return result;
	    },
	
	    showSelection: function(drawn) {
	      var cm = this.cm, display = cm.display;
	      removeChildrenAndAdd(display.cursorDiv, drawn.cursors);
	      removeChildrenAndAdd(display.selectionDiv, drawn.selection);
	      if (drawn.teTop != null) {
	        this.wrapper.style.top = drawn.teTop + "px";
	        this.wrapper.style.left = drawn.teLeft + "px";
	      }
	    },
	
	    // Reset the input to correspond to the selection (or to be empty,
	    // when not typing and nothing is selected)
	    reset: function(typing) {
	      if (this.contextMenuPending) return;
	      var minimal, selected, cm = this.cm, doc = cm.doc;
	      if (cm.somethingSelected()) {
	        this.prevInput = "";
	        var range = doc.sel.primary();
	        minimal = hasCopyEvent &&
	          (range.to().line - range.from().line > 100 || (selected = cm.getSelection()).length > 1000);
	        var content = minimal ? "-" : selected || cm.getSelection();
	        this.textarea.value = content;
	        if (cm.state.focused) selectInput(this.textarea);
	        if (ie && ie_version >= 9) this.hasSelection = content;
	      } else if (!typing) {
	        this.prevInput = this.textarea.value = "";
	        if (ie && ie_version >= 9) this.hasSelection = null;
	      }
	      this.inaccurateSelection = minimal;
	    },
	
	    getField: function() { return this.textarea; },
	
	    supportsTouch: function() { return false; },
	
	    focus: function() {
	      if (this.cm.options.readOnly != "nocursor" && (!mobile || activeElt() != this.textarea)) {
	        try { this.textarea.focus(); }
	        catch (e) {} // IE8 will throw if the textarea is display: none or not in DOM
	      }
	    },
	
	    blur: function() { this.textarea.blur(); },
	
	    resetPosition: function() {
	      this.wrapper.style.top = this.wrapper.style.left = 0;
	    },
	
	    receivedFocus: function() { this.slowPoll(); },
	
	    // Poll for input changes, using the normal rate of polling. This
	    // runs as long as the editor is focused.
	    slowPoll: function() {
	      var input = this;
	      if (input.pollingFast) return;
	      input.polling.set(this.cm.options.pollInterval, function() {
	        input.poll();
	        if (input.cm.state.focused) input.slowPoll();
	      });
	    },
	
	    // When an event has just come in that is likely to add or change
	    // something in the input textarea, we poll faster, to ensure that
	    // the change appears on the screen quickly.
	    fastPoll: function() {
	      var missed = false, input = this;
	      input.pollingFast = true;
	      function p() {
	        var changed = input.poll();
	        if (!changed && !missed) {missed = true; input.polling.set(60, p);}
	        else {input.pollingFast = false; input.slowPoll();}
	      }
	      input.polling.set(20, p);
	    },
	
	    // Read input from the textarea, and update the document to match.
	    // When something is selected, it is present in the textarea, and
	    // selected (unless it is huge, in which case a placeholder is
	    // used). When nothing is selected, the cursor sits after previously
	    // seen text (can be empty), which is stored in prevInput (we must
	    // not reset the textarea when typing, because that breaks IME).
	    poll: function() {
	      var cm = this.cm, input = this.textarea, prevInput = this.prevInput;
	      // Since this is called a *lot*, try to bail out as cheaply as
	      // possible when it is clear that nothing happened. hasSelection
	      // will be the case when there is a lot of text in the textarea,
	      // in which case reading its value would be expensive.
	      if (this.contextMenuPending || !cm.state.focused ||
	          (hasSelection(input) && !prevInput && !this.composing) ||
	          cm.isReadOnly() || cm.options.disableInput || cm.state.keySeq)
	        return false;
	
	      var text = input.value;
	      // If nothing changed, bail.
	      if (text == prevInput && !cm.somethingSelected()) return false;
	      // Work around nonsensical selection resetting in IE9/10, and
	      // inexplicable appearance of private area unicode characters on
	      // some key combos in Mac (#2689).
	      if (ie && ie_version >= 9 && this.hasSelection === text ||
	          mac && /[\uf700-\uf7ff]/.test(text)) {
	        cm.display.input.reset();
	        return false;
	      }
	
	      if (cm.doc.sel == cm.display.selForContextMenu) {
	        var first = text.charCodeAt(0);
	        if (first == 0x200b && !prevInput) prevInput = "\u200b";
	        if (first == 0x21da) { this.reset(); return this.cm.execCommand("undo"); }
	      }
	      // Find the part of the input that is actually new
	      var same = 0, l = Math.min(prevInput.length, text.length);
	      while (same < l && prevInput.charCodeAt(same) == text.charCodeAt(same)) ++same;
	
	      var self = this;
	      runInOp(cm, function() {
	        applyTextInput(cm, text.slice(same), prevInput.length - same,
	                       null, self.composing ? "*compose" : null);
	
	        // Don't leave long text in the textarea, since it makes further polling slow
	        if (text.length > 1000 || text.indexOf("\n") > -1) input.value = self.prevInput = "";
	        else self.prevInput = text;
	
	        if (self.composing) {
	          self.composing.range.clear();
	          self.composing.range = cm.markText(self.composing.start, cm.getCursor("to"),
	                                             {className: "CodeMirror-composing"});
	        }
	      });
	      return true;
	    },
	
	    ensurePolled: function() {
	      if (this.pollingFast && this.poll()) this.pollingFast = false;
	    },
	
	    onKeyPress: function() {
	      if (ie && ie_version >= 9) this.hasSelection = null;
	      this.fastPoll();
	    },
	
	    onContextMenu: function(e) {
	      var input = this, cm = input.cm, display = cm.display, te = input.textarea;
	      var pos = posFromMouse(cm, e), scrollPos = display.scroller.scrollTop;
	      if (!pos || presto) return; // Opera is difficult.
	
	      // Reset the current text selection only if the click is done outside of the selection
	      // and 'resetSelectionOnContextMenu' option is true.
	      var reset = cm.options.resetSelectionOnContextMenu;
	      if (reset && cm.doc.sel.contains(pos) == -1)
	        operation(cm, setSelection)(cm.doc, simpleSelection(pos), sel_dontScroll);
	
	      var oldCSS = te.style.cssText, oldWrapperCSS = input.wrapper.style.cssText;
	      input.wrapper.style.cssText = "position: absolute"
	      var wrapperBox = input.wrapper.getBoundingClientRect()
	      te.style.cssText = "position: absolute; width: 30px; height: 30px; top: " + (e.clientY - wrapperBox.top - 5) +
	        "px; left: " + (e.clientX - wrapperBox.left - 5) + "px; z-index: 1000; background: " +
	        (ie ? "rgba(255, 255, 255, .05)" : "transparent") +
	        "; outline: none; border-width: 0; outline: none; overflow: hidden; opacity: .05; filter: alpha(opacity=5);";
	      if (webkit) var oldScrollY = window.scrollY; // Work around Chrome issue (#2712)
	      display.input.focus();
	      if (webkit) window.scrollTo(null, oldScrollY);
	      display.input.reset();
	      // Adds "Select all" to context menu in FF
	      if (!cm.somethingSelected()) te.value = input.prevInput = " ";
	      input.contextMenuPending = true;
	      display.selForContextMenu = cm.doc.sel;
	      clearTimeout(display.detectingSelectAll);
	
	      // Select-all will be greyed out if there's nothing to select, so
	      // this adds a zero-width space so that we can later check whether
	      // it got selected.
	      function prepareSelectAllHack() {
	        if (te.selectionStart != null) {
	          var selected = cm.somethingSelected();
	          var extval = "\u200b" + (selected ? te.value : "");
	          te.value = "\u21da"; // Used to catch context-menu undo
	          te.value = extval;
	          input.prevInput = selected ? "" : "\u200b";
	          te.selectionStart = 1; te.selectionEnd = extval.length;
	          // Re-set this, in case some other handler touched the
	          // selection in the meantime.
	          display.selForContextMenu = cm.doc.sel;
	        }
	      }
	      function rehide() {
	        input.contextMenuPending = false;
	        input.wrapper.style.cssText = oldWrapperCSS
	        te.style.cssText = oldCSS;
	        if (ie && ie_version < 9) display.scrollbars.setScrollTop(display.scroller.scrollTop = scrollPos);
	
	        // Try to detect the user choosing select-all
	        if (te.selectionStart != null) {
	          if (!ie || (ie && ie_version < 9)) prepareSelectAllHack();
	          var i = 0, poll = function() {
	            if (display.selForContextMenu == cm.doc.sel && te.selectionStart == 0 &&
	                te.selectionEnd > 0 && input.prevInput == "\u200b")
	              operation(cm, commands.selectAll)(cm);
	            else if (i++ < 10) display.detectingSelectAll = setTimeout(poll, 500);
	            else display.input.reset();
	          };
	          display.detectingSelectAll = setTimeout(poll, 200);
	        }
	      }
	
	      if (ie && ie_version >= 9) prepareSelectAllHack();
	      if (captureRightClick) {
	        e_stop(e);
	        var mouseup = function() {
	          off(window, "mouseup", mouseup);
	          setTimeout(rehide, 20);
	        };
	        on(window, "mouseup", mouseup);
	      } else {
	        setTimeout(rehide, 50);
	      }
	    },
	
	    readOnlyChanged: function(val) {
	      if (!val) this.reset();
	    },
	
	    setUneditable: nothing,
	
	    needsContentAttribute: false
	  }, TextareaInput.prototype);
	
	  // CONTENTEDITABLE INPUT STYLE
	
	  function ContentEditableInput(cm) {
	    this.cm = cm;
	    this.lastAnchorNode = this.lastAnchorOffset = this.lastFocusNode = this.lastFocusOffset = null;
	    this.polling = new Delayed();
	    this.gracePeriod = false;
	  }
	
	  ContentEditableInput.prototype = copyObj({
	    init: function(display) {
	      var input = this, cm = input.cm;
	      var div = input.div = display.lineDiv;
	      disableBrowserMagic(div, cm.options.spellcheck);
	
	      on(div, "paste", function(e) {
	        if (signalDOMEvent(cm, e) || handlePaste(e, cm)) return
	        // IE doesn't fire input events, so we schedule a read for the pasted content in this way
	        if (ie_version <= 11) setTimeout(operation(cm, function() {
	          if (!input.pollContent()) regChange(cm);
	        }), 20)
	      })
	
	      on(div, "compositionstart", function(e) {
	        var data = e.data;
	        input.composing = {sel: cm.doc.sel, data: data, startData: data};
	        if (!data) return;
	        var prim = cm.doc.sel.primary();
	        var line = cm.getLine(prim.head.line);
	        var found = line.indexOf(data, Math.max(0, prim.head.ch - data.length));
	        if (found > -1 && found <= prim.head.ch)
	          input.composing.sel = simpleSelection(Pos(prim.head.line, found),
	                                                Pos(prim.head.line, found + data.length));
	      });
	      on(div, "compositionupdate", function(e) {
	        input.composing.data = e.data;
	      });
	      on(div, "compositionend", function(e) {
	        var ours = input.composing;
	        if (!ours) return;
	        if (e.data != ours.startData && !/\u200b/.test(e.data))
	          ours.data = e.data;
	        // Need a small delay to prevent other code (input event,
	        // selection polling) from doing damage when fired right after
	        // compositionend.
	        setTimeout(function() {
	          if (!ours.handled)
	            input.applyComposition(ours);
	          if (input.composing == ours)
	            input.composing = null;
	        }, 50);
	      });
	
	      on(div, "touchstart", function() {
	        input.forceCompositionEnd();
	      });
	
	      on(div, "input", function() {
	        if (input.composing) return;
	        if (cm.isReadOnly() || !input.pollContent())
	          runInOp(input.cm, function() {regChange(cm);});
	      });
	
	      function onCopyCut(e) {
	        if (signalDOMEvent(cm, e)) return
	        if (cm.somethingSelected()) {
	          lastCopied = {lineWise: false, text: cm.getSelections()};
	          if (e.type == "cut") cm.replaceSelection("", null, "cut");
	        } else if (!cm.options.lineWiseCopyCut) {
	          return;
	        } else {
	          var ranges = copyableRanges(cm);
	          lastCopied = {lineWise: true, text: ranges.text};
	          if (e.type == "cut") {
	            cm.operation(function() {
	              cm.setSelections(ranges.ranges, 0, sel_dontScroll);
	              cm.replaceSelection("", null, "cut");
	            });
	          }
	        }
	        if (e.clipboardData) {
	          e.clipboardData.clearData();
	          var content = lastCopied.text.join("\n")
	          // iOS exposes the clipboard API, but seems to discard content inserted into it
	          e.clipboardData.setData("Text", content);
	          if (e.clipboardData.getData("Text") == content) {
	            e.preventDefault();
	            return
	          }
	        }
	        // Old-fashioned briefly-focus-a-textarea hack
	        var kludge = hiddenTextarea(), te = kludge.firstChild;
	        cm.display.lineSpace.insertBefore(kludge, cm.display.lineSpace.firstChild);
	        te.value = lastCopied.text.join("\n");
	        var hadFocus = document.activeElement;
	        selectInput(te);
	        setTimeout(function() {
	          cm.display.lineSpace.removeChild(kludge);
	          hadFocus.focus();
	          if (hadFocus == div) input.showPrimarySelection()
	        }, 50);
	      }
	      on(div, "copy", onCopyCut);
	      on(div, "cut", onCopyCut);
	    },
	
	    prepareSelection: function() {
	      var result = prepareSelection(this.cm, false);
	      result.focus = this.cm.state.focused;
	      return result;
	    },
	
	    showSelection: function(info, takeFocus) {
	      if (!info || !this.cm.display.view.length) return;
	      if (info.focus || takeFocus) this.showPrimarySelection();
	      this.showMultipleSelections(info);
	    },
	
	    showPrimarySelection: function() {
	      var sel = window.getSelection(), prim = this.cm.doc.sel.primary();
	      var curAnchor = domToPos(this.cm, sel.anchorNode, sel.anchorOffset);
	      var curFocus = domToPos(this.cm, sel.focusNode, sel.focusOffset);
	      if (curAnchor && !curAnchor.bad && curFocus && !curFocus.bad &&
	          cmp(minPos(curAnchor, curFocus), prim.from()) == 0 &&
	          cmp(maxPos(curAnchor, curFocus), prim.to()) == 0)
	        return;
	
	      var start = posToDOM(this.cm, prim.from());
	      var end = posToDOM(this.cm, prim.to());
	      if (!start && !end) return;
	
	      var view = this.cm.display.view;
	      var old = sel.rangeCount && sel.getRangeAt(0);
	      if (!start) {
	        start = {node: view[0].measure.map[2], offset: 0};
	      } else if (!end) { // FIXME dangerously hacky
	        var measure = view[view.length - 1].measure;
	        var map = measure.maps ? measure.maps[measure.maps.length - 1] : measure.map;
	        end = {node: map[map.length - 1], offset: map[map.length - 2] - map[map.length - 3]};
	      }
	
	      try { var rng = range(start.node, start.offset, end.offset, end.node); }
	      catch(e) {} // Our model of the DOM might be outdated, in which case the range we try to set can be impossible
	      if (rng) {
	        if (!gecko && this.cm.state.focused) {
	          sel.collapse(start.node, start.offset);
	          if (!rng.collapsed) sel.addRange(rng);
	        } else {
	          sel.removeAllRanges();
	          sel.addRange(rng);
	        }
	        if (old && sel.anchorNode == null) sel.addRange(old);
	        else if (gecko) this.startGracePeriod();
	      }
	      this.rememberSelection();
	    },
	
	    startGracePeriod: function() {
	      var input = this;
	      clearTimeout(this.gracePeriod);
	      this.gracePeriod = setTimeout(function() {
	        input.gracePeriod = false;
	        if (input.selectionChanged())
	          input.cm.operation(function() { input.cm.curOp.selectionChanged = true; });
	      }, 20);
	    },
	
	    showMultipleSelections: function(info) {
	      removeChildrenAndAdd(this.cm.display.cursorDiv, info.cursors);
	      removeChildrenAndAdd(this.cm.display.selectionDiv, info.selection);
	    },
	
	    rememberSelection: function() {
	      var sel = window.getSelection();
	      this.lastAnchorNode = sel.anchorNode; this.lastAnchorOffset = sel.anchorOffset;
	      this.lastFocusNode = sel.focusNode; this.lastFocusOffset = sel.focusOffset;
	    },
	
	    selectionInEditor: function() {
	      var sel = window.getSelection();
	      if (!sel.rangeCount) return false;
	      var node = sel.getRangeAt(0).commonAncestorContainer;
	      return contains(this.div, node);
	    },
	
	    focus: function() {
	      if (this.cm.options.readOnly != "nocursor") this.div.focus();
	    },
	    blur: function() { this.div.blur(); },
	    getField: function() { return this.div; },
	
	    supportsTouch: function() { return true; },
	
	    receivedFocus: function() {
	      var input = this;
	      if (this.selectionInEditor())
	        this.pollSelection();
	      else
	        runInOp(this.cm, function() { input.cm.curOp.selectionChanged = true; });
	
	      function poll() {
	        if (input.cm.state.focused) {
	          input.pollSelection();
	          input.polling.set(input.cm.options.pollInterval, poll);
	        }
	      }
	      this.polling.set(this.cm.options.pollInterval, poll);
	    },
	
	    selectionChanged: function() {
	      var sel = window.getSelection();
	      return sel.anchorNode != this.lastAnchorNode || sel.anchorOffset != this.lastAnchorOffset ||
	        sel.focusNode != this.lastFocusNode || sel.focusOffset != this.lastFocusOffset;
	    },
	
	    pollSelection: function() {
	      if (!this.composing && !this.gracePeriod && this.selectionChanged()) {
	        var sel = window.getSelection(), cm = this.cm;
	        this.rememberSelection();
	        var anchor = domToPos(cm, sel.anchorNode, sel.anchorOffset);
	        var head = domToPos(cm, sel.focusNode, sel.focusOffset);
	        if (anchor && head) runInOp(cm, function() {
	          setSelection(cm.doc, simpleSelection(anchor, head), sel_dontScroll);
	          if (anchor.bad || head.bad) cm.curOp.selectionChanged = true;
	        });
	      }
	    },
	
	    pollContent: function() {
	      var cm = this.cm, display = cm.display, sel = cm.doc.sel.primary();
	      var from = sel.from(), to = sel.to();
	      if (from.line < display.viewFrom || to.line > display.viewTo - 1) return false;
	
	      var fromIndex;
	      if (from.line == display.viewFrom || (fromIndex = findViewIndex(cm, from.line)) == 0) {
	        var fromLine = lineNo(display.view[0].line);
	        var fromNode = display.view[0].node;
	      } else {
	        var fromLine = lineNo(display.view[fromIndex].line);
	        var fromNode = display.view[fromIndex - 1].node.nextSibling;
	      }
	      var toIndex = findViewIndex(cm, to.line);
	      if (toIndex == display.view.length - 1) {
	        var toLine = display.viewTo - 1;
	        var toNode = display.lineDiv.lastChild;
	      } else {
	        var toLine = lineNo(display.view[toIndex + 1].line) - 1;
	        var toNode = display.view[toIndex + 1].node.previousSibling;
	      }
	
	      var newText = cm.doc.splitLines(domTextBetween(cm, fromNode, toNode, fromLine, toLine));
	      var oldText = getBetween(cm.doc, Pos(fromLine, 0), Pos(toLine, getLine(cm.doc, toLine).text.length));
	      while (newText.length > 1 && oldText.length > 1) {
	        if (lst(newText) == lst(oldText)) { newText.pop(); oldText.pop(); toLine--; }
	        else if (newText[0] == oldText[0]) { newText.shift(); oldText.shift(); fromLine++; }
	        else break;
	      }
	
	      var cutFront = 0, cutEnd = 0;
	      var newTop = newText[0], oldTop = oldText[0], maxCutFront = Math.min(newTop.length, oldTop.length);
	      while (cutFront < maxCutFront && newTop.charCodeAt(cutFront) == oldTop.charCodeAt(cutFront))
	        ++cutFront;
	      var newBot = lst(newText), oldBot = lst(oldText);
	      var maxCutEnd = Math.min(newBot.length - (newText.length == 1 ? cutFront : 0),
	                               oldBot.length - (oldText.length == 1 ? cutFront : 0));
	      while (cutEnd < maxCutEnd &&
	             newBot.charCodeAt(newBot.length - cutEnd - 1) == oldBot.charCodeAt(oldBot.length - cutEnd - 1))
	        ++cutEnd;
	
	      newText[newText.length - 1] = newBot.slice(0, newBot.length - cutEnd);
	      newText[0] = newText[0].slice(cutFront);
	
	      var chFrom = Pos(fromLine, cutFront);
	      var chTo = Pos(toLine, oldText.length ? lst(oldText).length - cutEnd : 0);
	      if (newText.length > 1 || newText[0] || cmp(chFrom, chTo)) {
	        replaceRange(cm.doc, newText, chFrom, chTo, "+input");
	        return true;
	      }
	    },
	
	    ensurePolled: function() {
	      this.forceCompositionEnd();
	    },
	    reset: function() {
	      this.forceCompositionEnd();
	    },
	    forceCompositionEnd: function() {
	      if (!this.composing || this.composing.handled) return;
	      this.applyComposition(this.composing);
	      this.composing.handled = true;
	      this.div.blur();
	      this.div.focus();
	    },
	    applyComposition: function(composing) {
	      if (this.cm.isReadOnly())
	        operation(this.cm, regChange)(this.cm)
	      else if (composing.data && composing.data != composing.startData)
	        operation(this.cm, applyTextInput)(this.cm, composing.data, 0, composing.sel);
	    },
	
	    setUneditable: function(node) {
	      node.contentEditable = "false"
	    },
	
	    onKeyPress: function(e) {
	      e.preventDefault();
	      if (!this.cm.isReadOnly())
	        operation(this.cm, applyTextInput)(this.cm, String.fromCharCode(e.charCode == null ? e.keyCode : e.charCode), 0);
	    },
	
	    readOnlyChanged: function(val) {
	      this.div.contentEditable = String(val != "nocursor")
	    },
	
	    onContextMenu: nothing,
	    resetPosition: nothing,
	
	    needsContentAttribute: true
	  }, ContentEditableInput.prototype);
	
	  function posToDOM(cm, pos) {
	    var view = findViewForLine(cm, pos.line);
	    if (!view || view.hidden) return null;
	    var line = getLine(cm.doc, pos.line);
	    var info = mapFromLineView(view, line, pos.line);
	
	    var order = getOrder(line), side = "left";
	    if (order) {
	      var partPos = getBidiPartAt(order, pos.ch);
	      side = partPos % 2 ? "right" : "left";
	    }
	    var result = nodeAndOffsetInLineMap(info.map, pos.ch, side);
	    result.offset = result.collapse == "right" ? result.end : result.start;
	    return result;
	  }
	
	  function badPos(pos, bad) { if (bad) pos.bad = true; return pos; }
	
	  function domToPos(cm, node, offset) {
	    var lineNode;
	    if (node == cm.display.lineDiv) {
	      lineNode = cm.display.lineDiv.childNodes[offset];
	      if (!lineNode) return badPos(cm.clipPos(Pos(cm.display.viewTo - 1)), true);
	      node = null; offset = 0;
	    } else {
	      for (lineNode = node;; lineNode = lineNode.parentNode) {
	        if (!lineNode || lineNode == cm.display.lineDiv) return null;
	        if (lineNode.parentNode && lineNode.parentNode == cm.display.lineDiv) break;
	      }
	    }
	    for (var i = 0; i < cm.display.view.length; i++) {
	      var lineView = cm.display.view[i];
	      if (lineView.node == lineNode)
	        return locateNodeInLineView(lineView, node, offset);
	    }
	  }
	
	  function locateNodeInLineView(lineView, node, offset) {
	    var wrapper = lineView.text.firstChild, bad = false;
	    if (!node || !contains(wrapper, node)) return badPos(Pos(lineNo(lineView.line), 0), true);
	    if (node == wrapper) {
	      bad = true;
	      node = wrapper.childNodes[offset];
	      offset = 0;
	      if (!node) {
	        var line = lineView.rest ? lst(lineView.rest) : lineView.line;
	        return badPos(Pos(lineNo(line), line.text.length), bad);
	      }
	    }
	
	    var textNode = node.nodeType == 3 ? node : null, topNode = node;
	    if (!textNode && node.childNodes.length == 1 && node.firstChild.nodeType == 3) {
	      textNode = node.firstChild;
	      if (offset) offset = textNode.nodeValue.length;
	    }
	    while (topNode.parentNode != wrapper) topNode = topNode.parentNode;
	    var measure = lineView.measure, maps = measure.maps;
	
	    function find(textNode, topNode, offset) {
	      for (var i = -1; i < (maps ? maps.length : 0); i++) {
	        var map = i < 0 ? measure.map : maps[i];
	        for (var j = 0; j < map.length; j += 3) {
	          var curNode = map[j + 2];
	          if (curNode == textNode || curNode == topNode) {
	            var line = lineNo(i < 0 ? lineView.line : lineView.rest[i]);
	            var ch = map[j] + offset;
	            if (offset < 0 || curNode != textNode) ch = map[j + (offset ? 1 : 0)];
	            return Pos(line, ch);
	          }
	        }
	      }
	    }
	    var found = find(textNode, topNode, offset);
	    if (found) return badPos(found, bad);
	
	    // FIXME this is all really shaky. might handle the few cases it needs to handle, but likely to cause problems
	    for (var after = topNode.nextSibling, dist = textNode ? textNode.nodeValue.length - offset : 0; after; after = after.nextSibling) {
	      found = find(after, after.firstChild, 0);
	      if (found)
	        return badPos(Pos(found.line, found.ch - dist), bad);
	      else
	        dist += after.textContent.length;
	    }
	    for (var before = topNode.previousSibling, dist = offset; before; before = before.previousSibling) {
	      found = find(before, before.firstChild, -1);
	      if (found)
	        return badPos(Pos(found.line, found.ch + dist), bad);
	      else
	        dist += before.textContent.length;
	    }
	  }
	
	  function domTextBetween(cm, from, to, fromLine, toLine) {
	    var text = "", closing = false, lineSep = cm.doc.lineSeparator();
	    function recognizeMarker(id) { return function(marker) { return marker.id == id; }; }
	    function walk(node) {
	      if (node.nodeType == 1) {
	        var cmText = node.getAttribute("cm-text");
	        if (cmText != null) {
	          if (cmText == "") cmText = node.textContent.replace(/\u200b/g, "");
	          text += cmText;
	          return;
	        }
	        var markerID = node.getAttribute("cm-marker"), range;
	        if (markerID) {
	          var found = cm.findMarks(Pos(fromLine, 0), Pos(toLine + 1, 0), recognizeMarker(+markerID));
	          if (found.length && (range = found[0].find()))
	            text += getBetween(cm.doc, range.from, range.to).join(lineSep);
	          return;
	        }
	        if (node.getAttribute("contenteditable") == "false") return;
	        for (var i = 0; i < node.childNodes.length; i++)
	          walk(node.childNodes[i]);
	        if (/^(pre|div|p)$/i.test(node.nodeName))
	          closing = true;
	      } else if (node.nodeType == 3) {
	        var val = node.nodeValue;
	        if (!val) return;
	        if (closing) {
	          text += lineSep;
	          closing = false;
	        }
	        text += val;
	      }
	    }
	    for (;;) {
	      walk(from);
	      if (from == to) break;
	      from = from.nextSibling;
	    }
	    return text;
	  }
	
	  CodeMirror.inputStyles = {"textarea": TextareaInput, "contenteditable": ContentEditableInput};
	
	  // SELECTION / CURSOR
	
	  // Selection objects are immutable. A new one is created every time
	  // the selection changes. A selection is one or more non-overlapping
	  // (and non-touching) ranges, sorted, and an integer that indicates
	  // which one is the primary selection (the one that's scrolled into
	  // view, that getCursor returns, etc).
	  function Selection(ranges, primIndex) {
	    this.ranges = ranges;
	    this.primIndex = primIndex;
	  }
	
	  Selection.prototype = {
	    primary: function() { return this.ranges[this.primIndex]; },
	    equals: function(other) {
	      if (other == this) return true;
	      if (other.primIndex != this.primIndex || other.ranges.length != this.ranges.length) return false;
	      for (var i = 0; i < this.ranges.length; i++) {
	        var here = this.ranges[i], there = other.ranges[i];
	        if (cmp(here.anchor, there.anchor) != 0 || cmp(here.head, there.head) != 0) return false;
	      }
	      return true;
	    },
	    deepCopy: function() {
	      for (var out = [], i = 0; i < this.ranges.length; i++)
	        out[i] = new Range(copyPos(this.ranges[i].anchor), copyPos(this.ranges[i].head));
	      return new Selection(out, this.primIndex);
	    },
	    somethingSelected: function() {
	      for (var i = 0; i < this.ranges.length; i++)
	        if (!this.ranges[i].empty()) return true;
	      return false;
	    },
	    contains: function(pos, end) {
	      if (!end) end = pos;
	      for (var i = 0; i < this.ranges.length; i++) {
	        var range = this.ranges[i];
	        if (cmp(end, range.from()) >= 0 && cmp(pos, range.to()) <= 0)
	          return i;
	      }
	      return -1;
	    }
	  };
	
	  function Range(anchor, head) {
	    this.anchor = anchor; this.head = head;
	  }
	
	  Range.prototype = {
	    from: function() { return minPos(this.anchor, this.head); },
	    to: function() { return maxPos(this.anchor, this.head); },
	    empty: function() {
	      return this.head.line == this.anchor.line && this.head.ch == this.anchor.ch;
	    }
	  };
	
	  // Take an unsorted, potentially overlapping set of ranges, and
	  // build a selection out of it. 'Consumes' ranges array (modifying
	  // it).
	  function normalizeSelection(ranges, primIndex) {
	    var prim = ranges[primIndex];
	    ranges.sort(function(a, b) { return cmp(a.from(), b.from()); });
	    primIndex = indexOf(ranges, prim);
	    for (var i = 1; i < ranges.length; i++) {
	      var cur = ranges[i], prev = ranges[i - 1];
	      if (cmp(prev.to(), cur.from()) >= 0) {
	        var from = minPos(prev.from(), cur.from()), to = maxPos(prev.to(), cur.to());
	        var inv = prev.empty() ? cur.from() == cur.head : prev.from() == prev.head;
	        if (i <= primIndex) --primIndex;
	        ranges.splice(--i, 2, new Range(inv ? to : from, inv ? from : to));
	      }
	    }
	    return new Selection(ranges, primIndex);
	  }
	
	  function simpleSelection(anchor, head) {
	    return new Selection([new Range(anchor, head || anchor)], 0);
	  }
	
	  // Most of the external API clips given positions to make sure they
	  // actually exist within the document.
	  function clipLine(doc, n) {return Math.max(doc.first, Math.min(n, doc.first + doc.size - 1));}
	  function clipPos(doc, pos) {
	    if (pos.line < doc.first) return Pos(doc.first, 0);
	    var last = doc.first + doc.size - 1;
	    if (pos.line > last) return Pos(last, getLine(doc, last).text.length);
	    return clipToLen(pos, getLine(doc, pos.line).text.length);
	  }
	  function clipToLen(pos, linelen) {
	    var ch = pos.ch;
	    if (ch == null || ch > linelen) return Pos(pos.line, linelen);
	    else if (ch < 0) return Pos(pos.line, 0);
	    else return pos;
	  }
	  function isLine(doc, l) {return l >= doc.first && l < doc.first + doc.size;}
	  function clipPosArray(doc, array) {
	    for (var out = [], i = 0; i < array.length; i++) out[i] = clipPos(doc, array[i]);
	    return out;
	  }
	
	  // SELECTION UPDATES
	
	  // The 'scroll' parameter given to many of these indicated whether
	  // the new cursor position should be scrolled into view after
	  // modifying the selection.
	
	  // If shift is held or the extend flag is set, extends a range to
	  // include a given position (and optionally a second position).
	  // Otherwise, simply returns the range between the given positions.
	  // Used for cursor motion and such.
	  function extendRange(doc, range, head, other) {
	    if (doc.cm && doc.cm.display.shift || doc.extend) {
	      var anchor = range.anchor;
	      if (other) {
	        var posBefore = cmp(head, anchor) < 0;
	        if (posBefore != (cmp(other, anchor) < 0)) {
	          anchor = head;
	          head = other;
	        } else if (posBefore != (cmp(head, other) < 0)) {
	          head = other;
	        }
	      }
	      return new Range(anchor, head);
	    } else {
	      return new Range(other || head, head);
	    }
	  }
	
	  // Extend the primary selection range, discard the rest.
	  function extendSelection(doc, head, other, options) {
	    setSelection(doc, new Selection([extendRange(doc, doc.sel.primary(), head, other)], 0), options);
	  }
	
	  // Extend all selections (pos is an array of selections with length
	  // equal the number of selections)
	  function extendSelections(doc, heads, options) {
	    for (var out = [], i = 0; i < doc.sel.ranges.length; i++)
	      out[i] = extendRange(doc, doc.sel.ranges[i], heads[i], null);
	    var newSel = normalizeSelection(out, doc.sel.primIndex);
	    setSelection(doc, newSel, options);
	  }
	
	  // Updates a single range in the selection.
	  function replaceOneSelection(doc, i, range, options) {
	    var ranges = doc.sel.ranges.slice(0);
	    ranges[i] = range;
	    setSelection(doc, normalizeSelection(ranges, doc.sel.primIndex), options);
	  }
	
	  // Reset the selection to a single range.
	  function setSimpleSelection(doc, anchor, head, options) {
	    setSelection(doc, simpleSelection(anchor, head), options);
	  }
	
	  // Give beforeSelectionChange handlers a change to influence a
	  // selection update.
	  function filterSelectionChange(doc, sel, options) {
	    var obj = {
	      ranges: sel.ranges,
	      update: function(ranges) {
	        this.ranges = [];
	        for (var i = 0; i < ranges.length; i++)
	          this.ranges[i] = new Range(clipPos(doc, ranges[i].anchor),
	                                     clipPos(doc, ranges[i].head));
	      },
	      origin: options && options.origin
	    };
	    signal(doc, "beforeSelectionChange", doc, obj);
	    if (doc.cm) signal(doc.cm, "beforeSelectionChange", doc.cm, obj);
	    if (obj.ranges != sel.ranges) return normalizeSelection(obj.ranges, obj.ranges.length - 1);
	    else return sel;
	  }
	
	  function setSelectionReplaceHistory(doc, sel, options) {
	    var done = doc.history.done, last = lst(done);
	    if (last && last.ranges) {
	      done[done.length - 1] = sel;
	      setSelectionNoUndo(doc, sel, options);
	    } else {
	      setSelection(doc, sel, options);
	    }
	  }
	
	  // Set a new selection.
	  function setSelection(doc, sel, options) {
	    setSelectionNoUndo(doc, sel, options);
	    addSelectionToHistory(doc, doc.sel, doc.cm ? doc.cm.curOp.id : NaN, options);
	  }
	
	  function setSelectionNoUndo(doc, sel, options) {
	    if (hasHandler(doc, "beforeSelectionChange") || doc.cm && hasHandler(doc.cm, "beforeSelectionChange"))
	      sel = filterSelectionChange(doc, sel, options);
	
	    var bias = options && options.bias ||
	      (cmp(sel.primary().head, doc.sel.primary().head) < 0 ? -1 : 1);
	    setSelectionInner(doc, skipAtomicInSelection(doc, sel, bias, true));
	
	    if (!(options && options.scroll === false) && doc.cm)
	      ensureCursorVisible(doc.cm);
	  }
	
	  function setSelectionInner(doc, sel) {
	    if (sel.equals(doc.sel)) return;
	
	    doc.sel = sel;
	
	    if (doc.cm) {
	      doc.cm.curOp.updateInput = doc.cm.curOp.selectionChanged = true;
	      signalCursorActivity(doc.cm);
	    }
	    signalLater(doc, "cursorActivity", doc);
	  }
	
	  // Verify that the selection does not partially select any atomic
	  // marked ranges.
	  function reCheckSelection(doc) {
	    setSelectionInner(doc, skipAtomicInSelection(doc, doc.sel, null, false), sel_dontScroll);
	  }
	
	  // Return a selection that does not partially select any atomic
	  // ranges.
	  function skipAtomicInSelection(doc, sel, bias, mayClear) {
	    var out;
	    for (var i = 0; i < sel.ranges.length; i++) {
	      var range = sel.ranges[i];
	      var old = sel.ranges.length == doc.sel.ranges.length && doc.sel.ranges[i];
	      var newAnchor = skipAtomic(doc, range.anchor, old && old.anchor, bias, mayClear);
	      var newHead = skipAtomic(doc, range.head, old && old.head, bias, mayClear);
	      if (out || newAnchor != range.anchor || newHead != range.head) {
	        if (!out) out = sel.ranges.slice(0, i);
	        out[i] = new Range(newAnchor, newHead);
	      }
	    }
	    return out ? normalizeSelection(out, sel.primIndex) : sel;
	  }
	
	  function skipAtomicInner(doc, pos, oldPos, dir, mayClear) {
	    var line = getLine(doc, pos.line);
	    if (line.markedSpans) for (var i = 0; i < line.markedSpans.length; ++i) {
	      var sp = line.markedSpans[i], m = sp.marker;
	      if ((sp.from == null || (m.inclusiveLeft ? sp.from <= pos.ch : sp.from < pos.ch)) &&
	          (sp.to == null || (m.inclusiveRight ? sp.to >= pos.ch : sp.to > pos.ch))) {
	        if (mayClear) {
	          signal(m, "beforeCursorEnter");
	          if (m.explicitlyCleared) {
	            if (!line.markedSpans) break;
	            else {--i; continue;}
	          }
	        }
	        if (!m.atomic) continue;
	
	        if (oldPos) {
	          var near = m.find(dir < 0 ? 1 : -1), diff;
	          if (dir < 0 ? m.inclusiveRight : m.inclusiveLeft)
	            near = movePos(doc, near, -dir, near && near.line == pos.line ? line : null);
	          if (near && near.line == pos.line && (diff = cmp(near, oldPos)) && (dir < 0 ? diff < 0 : diff > 0))
	            return skipAtomicInner(doc, near, pos, dir, mayClear);
	        }
	
	        var far = m.find(dir < 0 ? -1 : 1);
	        if (dir < 0 ? m.inclusiveLeft : m.inclusiveRight)
	          far = movePos(doc, far, dir, far.line == pos.line ? line : null);
	        return far ? skipAtomicInner(doc, far, pos, dir, mayClear) : null;
	      }
	    }
	    return pos;
	  }
	
	  // Ensure a given position is not inside an atomic range.
	  function skipAtomic(doc, pos, oldPos, bias, mayClear) {
	    var dir = bias || 1;
	    var found = skipAtomicInner(doc, pos, oldPos, dir, mayClear) ||
	        (!mayClear && skipAtomicInner(doc, pos, oldPos, dir, true)) ||
	        skipAtomicInner(doc, pos, oldPos, -dir, mayClear) ||
	        (!mayClear && skipAtomicInner(doc, pos, oldPos, -dir, true));
	    if (!found) {
	      doc.cantEdit = true;
	      return Pos(doc.first, 0);
	    }
	    return found;
	  }
	
	  function movePos(doc, pos, dir, line) {
	    if (dir < 0 && pos.ch == 0) {
	      if (pos.line > doc.first) return clipPos(doc, Pos(pos.line - 1));
	      else return null;
	    } else if (dir > 0 && pos.ch == (line || getLine(doc, pos.line)).text.length) {
	      if (pos.line < doc.first + doc.size - 1) return Pos(pos.line + 1, 0);
	      else return null;
	    } else {
	      return new Pos(pos.line, pos.ch + dir);
	    }
	  }
	
	  // SELECTION DRAWING
	
	  function updateSelection(cm) {
	    cm.display.input.showSelection(cm.display.input.prepareSelection());
	  }
	
	  function prepareSelection(cm, primary) {
	    var doc = cm.doc, result = {};
	    var curFragment = result.cursors = document.createDocumentFragment();
	    var selFragment = result.selection = document.createDocumentFragment();
	
	    for (var i = 0; i < doc.sel.ranges.length; i++) {
	      if (primary === false && i == doc.sel.primIndex) continue;
	      var range = doc.sel.ranges[i];
	      if (range.from().line >= cm.display.viewTo || range.to().line < cm.display.viewFrom) continue;
	      var collapsed = range.empty();
	      if (collapsed || cm.options.showCursorWhenSelecting)
	        drawSelectionCursor(cm, range.head, curFragment);
	      if (!collapsed)
	        drawSelectionRange(cm, range, selFragment);
	    }
	    return result;
	  }
	
	  // Draws a cursor for the given range
	  function drawSelectionCursor(cm, head, output) {
	    var pos = cursorCoords(cm, head, "div", null, null, !cm.options.singleCursorHeightPerLine);
	
	    var cursor = output.appendChild(elt("div", "\u00a0", "CodeMirror-cursor"));
	    cursor.style.left = pos.left + "px";
	    cursor.style.top = pos.top + "px";
	    cursor.style.height = Math.max(0, pos.bottom - pos.top) * cm.options.cursorHeight + "px";
	
	    if (pos.other) {
	      // Secondary cursor, shown when on a 'jump' in bi-directional text
	      var otherCursor = output.appendChild(elt("div", "\u00a0", "CodeMirror-cursor CodeMirror-secondarycursor"));
	      otherCursor.style.display = "";
	      otherCursor.style.left = pos.other.left + "px";
	      otherCursor.style.top = pos.other.top + "px";
	      otherCursor.style.height = (pos.other.bottom - pos.other.top) * .85 + "px";
	    }
	  }
	
	  // Draws the given range as a highlighted selection
	  function drawSelectionRange(cm, range, output) {
	    var display = cm.display, doc = cm.doc;
	    var fragment = document.createDocumentFragment();
	    var padding = paddingH(cm.display), leftSide = padding.left;
	    var rightSide = Math.max(display.sizerWidth, displayWidth(cm) - display.sizer.offsetLeft) - padding.right;
	
	    function add(left, top, width, bottom) {
	      if (top < 0) top = 0;
	      top = Math.round(top);
	      bottom = Math.round(bottom);
	      fragment.appendChild(elt("div", null, "CodeMirror-selected", "position: absolute; left: " + left +
	                               "px; top: " + top + "px; width: " + (width == null ? rightSide - left : width) +
	                               "px; height: " + (bottom - top) + "px"));
	    }
	
	    function drawForLine(line, fromArg, toArg) {
	      var lineObj = getLine(doc, line);
	      var lineLen = lineObj.text.length;
	      var start, end;
	      function coords(ch, bias) {
	        return charCoords(cm, Pos(line, ch), "div", lineObj, bias);
	      }
	
	      iterateBidiSections(getOrder(lineObj), fromArg || 0, toArg == null ? lineLen : toArg, function(from, to, dir) {
	        var leftPos = coords(from, "left"), rightPos, left, right;
	        if (from == to) {
	          rightPos = leftPos;
	          left = right = leftPos.left;
	        } else {
	          rightPos = coords(to - 1, "right");
	          if (dir == "rtl") { var tmp = leftPos; leftPos = rightPos; rightPos = tmp; }
	          left = leftPos.left;
	          right = rightPos.right;
	        }
	        if (fromArg == null && from == 0) left = leftSide;
	        if (rightPos.top - leftPos.top > 3) { // Different lines, draw top part
	          add(left, leftPos.top, null, leftPos.bottom);
	          left = leftSide;
	          if (leftPos.bottom < rightPos.top) add(left, leftPos.bottom, null, rightPos.top);
	        }
	        if (toArg == null && to == lineLen) right = rightSide;
	        if (!start || leftPos.top < start.top || leftPos.top == start.top && leftPos.left < start.left)
	          start = leftPos;
	        if (!end || rightPos.bottom > end.bottom || rightPos.bottom == end.bottom && rightPos.right > end.right)
	          end = rightPos;
	        if (left < leftSide + 1) left = leftSide;
	        add(left, rightPos.top, right - left, rightPos.bottom);
	      });
	      return {start: start, end: end};
	    }
	
	    var sFrom = range.from(), sTo = range.to();
	    if (sFrom.line == sTo.line) {
	      drawForLine(sFrom.line, sFrom.ch, sTo.ch);
	    } else {
	      var fromLine = getLine(doc, sFrom.line), toLine = getLine(doc, sTo.line);
	      var singleVLine = visualLine(fromLine) == visualLine(toLine);
	      var leftEnd = drawForLine(sFrom.line, sFrom.ch, singleVLine ? fromLine.text.length + 1 : null).end;
	      var rightStart = drawForLine(sTo.line, singleVLine ? 0 : null, sTo.ch).start;
	      if (singleVLine) {
	        if (leftEnd.top < rightStart.top - 2) {
	          add(leftEnd.right, leftEnd.top, null, leftEnd.bottom);
	          add(leftSide, rightStart.top, rightStart.left, rightStart.bottom);
	        } else {
	          add(leftEnd.right, leftEnd.top, rightStart.left - leftEnd.right, leftEnd.bottom);
	        }
	      }
	      if (leftEnd.bottom < rightStart.top)
	        add(leftSide, leftEnd.bottom, null, rightStart.top);
	    }
	
	    output.appendChild(fragment);
	  }
	
	  // Cursor-blinking
	  function restartBlink(cm) {
	    if (!cm.state.focused) return;
	    var display = cm.display;
	    clearInterval(display.blinker);
	    var on = true;
	    display.cursorDiv.style.visibility = "";
	    if (cm.options.cursorBlinkRate > 0)
	      display.blinker = setInterval(function() {
	        display.cursorDiv.style.visibility = (on = !on) ? "" : "hidden";
	      }, cm.options.cursorBlinkRate);
	    else if (cm.options.cursorBlinkRate < 0)
	      display.cursorDiv.style.visibility = "hidden";
	  }
	
	  // HIGHLIGHT WORKER
	
	  function startWorker(cm, time) {
	    if (cm.doc.mode.startState && cm.doc.frontier < cm.display.viewTo)
	      cm.state.highlight.set(time, bind(highlightWorker, cm));
	  }
	
	  function highlightWorker(cm) {
	    var doc = cm.doc;
	    if (doc.frontier < doc.first) doc.frontier = doc.first;
	    if (doc.frontier >= cm.display.viewTo) return;
	    var end = +new Date + cm.options.workTime;
	    var state = copyState(doc.mode, getStateBefore(cm, doc.frontier));
	    var changedLines = [];
	
	    doc.iter(doc.frontier, Math.min(doc.first + doc.size, cm.display.viewTo + 500), function(line) {
	      if (doc.frontier >= cm.display.viewFrom) { // Visible
	        var oldStyles = line.styles, tooLong = line.text.length > cm.options.maxHighlightLength;
	        var highlighted = highlightLine(cm, line, tooLong ? copyState(doc.mode, state) : state, true);
	        line.styles = highlighted.styles;
	        var oldCls = line.styleClasses, newCls = highlighted.classes;
	        if (newCls) line.styleClasses = newCls;
	        else if (oldCls) line.styleClasses = null;
	        var ischange = !oldStyles || oldStyles.length != line.styles.length ||
	          oldCls != newCls && (!oldCls || !newCls || oldCls.bgClass != newCls.bgClass || oldCls.textClass != newCls.textClass);
	        for (var i = 0; !ischange && i < oldStyles.length; ++i) ischange = oldStyles[i] != line.styles[i];
	        if (ischange) changedLines.push(doc.frontier);
	        line.stateAfter = tooLong ? state : copyState(doc.mode, state);
	      } else {
	        if (line.text.length <= cm.options.maxHighlightLength)
	          processLine(cm, line.text, state);
	        line.stateAfter = doc.frontier % 5 == 0 ? copyState(doc.mode, state) : null;
	      }
	      ++doc.frontier;
	      if (+new Date > end) {
	        startWorker(cm, cm.options.workDelay);
	        return true;
	      }
	    });
	    if (changedLines.length) runInOp(cm, function() {
	      for (var i = 0; i < changedLines.length; i++)
	        regLineChange(cm, changedLines[i], "text");
	    });
	  }
	
	  // Finds the line to start with when starting a parse. Tries to
	  // find a line with a stateAfter, so that it can start with a
	  // valid state. If that fails, it returns the line with the
	  // smallest indentation, which tends to need the least context to
	  // parse correctly.
	  function findStartLine(cm, n, precise) {
	    var minindent, minline, doc = cm.doc;
	    var lim = precise ? -1 : n - (cm.doc.mode.innerMode ? 1000 : 100);
	    for (var search = n; search > lim; --search) {
	      if (search <= doc.first) return doc.first;
	      var line = getLine(doc, search - 1);
	      if (line.stateAfter && (!precise || search <= doc.frontier)) return search;
	      var indented = countColumn(line.text, null, cm.options.tabSize);
	      if (minline == null || minindent > indented) {
	        minline = search - 1;
	        minindent = indented;
	      }
	    }
	    return minline;
	  }
	
	  function getStateBefore(cm, n, precise) {
	    var doc = cm.doc, display = cm.display;
	    if (!doc.mode.startState) return true;
	    var pos = findStartLine(cm, n, precise), state = pos > doc.first && getLine(doc, pos-1).stateAfter;
	    if (!state) state = startState(doc.mode);
	    else state = copyState(doc.mode, state);
	    doc.iter(pos, n, function(line) {
	      processLine(cm, line.text, state);
	      var save = pos == n - 1 || pos % 5 == 0 || pos >= display.viewFrom && pos < display.viewTo;
	      line.stateAfter = save ? copyState(doc.mode, state) : null;
	      ++pos;
	    });
	    if (precise) doc.frontier = pos;
	    return state;
	  }
	
	  // POSITION MEASUREMENT
	
	  function paddingTop(display) {return display.lineSpace.offsetTop;}
	  function paddingVert(display) {return display.mover.offsetHeight - display.lineSpace.offsetHeight;}
	  function paddingH(display) {
	    if (display.cachedPaddingH) return display.cachedPaddingH;
	    var e = removeChildrenAndAdd(display.measure, elt("pre", "x"));
	    var style = window.getComputedStyle ? window.getComputedStyle(e) : e.currentStyle;
	    var data = {left: parseInt(style.paddingLeft), right: parseInt(style.paddingRight)};
	    if (!isNaN(data.left) && !isNaN(data.right)) display.cachedPaddingH = data;
	    return data;
	  }
	
	  function scrollGap(cm) { return scrollerGap - cm.display.nativeBarWidth; }
	  function displayWidth(cm) {
	    return cm.display.scroller.clientWidth - scrollGap(cm) - cm.display.barWidth;
	  }
	  function displayHeight(cm) {
	    return cm.display.scroller.clientHeight - scrollGap(cm) - cm.display.barHeight;
	  }
	
	  // Ensure the lineView.wrapping.heights array is populated. This is
	  // an array of bottom offsets for the lines that make up a drawn
	  // line. When lineWrapping is on, there might be more than one
	  // height.
	  function ensureLineHeights(cm, lineView, rect) {
	    var wrapping = cm.options.lineWrapping;
	    var curWidth = wrapping && displayWidth(cm);
	    if (!lineView.measure.heights || wrapping && lineView.measure.width != curWidth) {
	      var heights = lineView.measure.heights = [];
	      if (wrapping) {
	        lineView.measure.width = curWidth;
	        var rects = lineView.text.firstChild.getClientRects();
	        for (var i = 0; i < rects.length - 1; i++) {
	          var cur = rects[i], next = rects[i + 1];
	          if (Math.abs(cur.bottom - next.bottom) > 2)
	            heights.push((cur.bottom + next.top) / 2 - rect.top);
	        }
	      }
	      heights.push(rect.bottom - rect.top);
	    }
	  }
	
	  // Find a line map (mapping character offsets to text nodes) and a
	  // measurement cache for the given line number. (A line view might
	  // contain multiple lines when collapsed ranges are present.)
	  function mapFromLineView(lineView, line, lineN) {
	    if (lineView.line == line)
	      return {map: lineView.measure.map, cache: lineView.measure.cache};
	    for (var i = 0; i < lineView.rest.length; i++)
	      if (lineView.rest[i] == line)
	        return {map: lineView.measure.maps[i], cache: lineView.measure.caches[i]};
	    for (var i = 0; i < lineView.rest.length; i++)
	      if (lineNo(lineView.rest[i]) > lineN)
	        return {map: lineView.measure.maps[i], cache: lineView.measure.caches[i], before: true};
	  }
	
	  // Render a line into the hidden node display.externalMeasured. Used
	  // when measurement is needed for a line that's not in the viewport.
	  function updateExternalMeasurement(cm, line) {
	    line = visualLine(line);
	    var lineN = lineNo(line);
	    var view = cm.display.externalMeasured = new LineView(cm.doc, line, lineN);
	    view.lineN = lineN;
	    var built = view.built = buildLineContent(cm, view);
	    view.text = built.pre;
	    removeChildrenAndAdd(cm.display.lineMeasure, built.pre);
	    return view;
	  }
	
	  // Get a {top, bottom, left, right} box (in line-local coordinates)
	  // for a given character.
	  function measureChar(cm, line, ch, bias) {
	    return measureCharPrepared(cm, prepareMeasureForLine(cm, line), ch, bias);
	  }
	
	  // Find a line view that corresponds to the given line number.
	  function findViewForLine(cm, lineN) {
	    if (lineN >= cm.display.viewFrom && lineN < cm.display.viewTo)
	      return cm.display.view[findViewIndex(cm, lineN)];
	    var ext = cm.display.externalMeasured;
	    if (ext && lineN >= ext.lineN && lineN < ext.lineN + ext.size)
	      return ext;
	  }
	
	  // Measurement can be split in two steps, the set-up work that
	  // applies to the whole line, and the measurement of the actual
	  // character. Functions like coordsChar, that need to do a lot of
	  // measurements in a row, can thus ensure that the set-up work is
	  // only done once.
	  function prepareMeasureForLine(cm, line) {
	    var lineN = lineNo(line);
	    var view = findViewForLine(cm, lineN);
	    if (view && !view.text) {
	      view = null;
	    } else if (view && view.changes) {
	      updateLineForChanges(cm, view, lineN, getDimensions(cm));
	      cm.curOp.forceUpdate = true;
	    }
	    if (!view)
	      view = updateExternalMeasurement(cm, line);
	
	    var info = mapFromLineView(view, line, lineN);
	    return {
	      line: line, view: view, rect: null,
	      map: info.map, cache: info.cache, before: info.before,
	      hasHeights: false
	    };
	  }
	
	  // Given a prepared measurement object, measures the position of an
	  // actual character (or fetches it from the cache).
	  function measureCharPrepared(cm, prepared, ch, bias, varHeight) {
	    if (prepared.before) ch = -1;
	    var key = ch + (bias || ""), found;
	    if (prepared.cache.hasOwnProperty(key)) {
	      found = prepared.cache[key];
	    } else {
	      if (!prepared.rect)
	        prepared.rect = prepared.view.text.getBoundingClientRect();
	      if (!prepared.hasHeights) {
	        ensureLineHeights(cm, prepared.view, prepared.rect);
	        prepared.hasHeights = true;
	      }
	      found = measureCharInner(cm, prepared, ch, bias);
	      if (!found.bogus) prepared.cache[key] = found;
	    }
	    return {left: found.left, right: found.right,
	            top: varHeight ? found.rtop : found.top,
	            bottom: varHeight ? found.rbottom : found.bottom};
	  }
	
	  var nullRect = {left: 0, right: 0, top: 0, bottom: 0};
	
	  function nodeAndOffsetInLineMap(map, ch, bias) {
	    var node, start, end, collapse;
	    // First, search the line map for the text node corresponding to,
	    // or closest to, the target character.
	    for (var i = 0; i < map.length; i += 3) {
	      var mStart = map[i], mEnd = map[i + 1];
	      if (ch < mStart) {
	        start = 0; end = 1;
	        collapse = "left";
	      } else if (ch < mEnd) {
	        start = ch - mStart;
	        end = start + 1;
	      } else if (i == map.length - 3 || ch == mEnd && map[i + 3] > ch) {
	        end = mEnd - mStart;
	        start = end - 1;
	        if (ch >= mEnd) collapse = "right";
	      }
	      if (start != null) {
	        node = map[i + 2];
	        if (mStart == mEnd && bias == (node.insertLeft ? "left" : "right"))
	          collapse = bias;
	        if (bias == "left" && start == 0)
	          while (i && map[i - 2] == map[i - 3] && map[i - 1].insertLeft) {
	            node = map[(i -= 3) + 2];
	            collapse = "left";
	          }
	        if (bias == "right" && start == mEnd - mStart)
	          while (i < map.length - 3 && map[i + 3] == map[i + 4] && !map[i + 5].insertLeft) {
	            node = map[(i += 3) + 2];
	            collapse = "right";
	          }
	        break;
	      }
	    }
	    return {node: node, start: start, end: end, collapse: collapse, coverStart: mStart, coverEnd: mEnd};
	  }
	
	  function getUsefulRect(rects, bias) {
	    var rect = nullRect
	    if (bias == "left") for (var i = 0; i < rects.length; i++) {
	      if ((rect = rects[i]).left != rect.right) break
	    } else for (var i = rects.length - 1; i >= 0; i--) {
	      if ((rect = rects[i]).left != rect.right) break
	    }
	    return rect
	  }
	
	  function measureCharInner(cm, prepared, ch, bias) {
	    var place = nodeAndOffsetInLineMap(prepared.map, ch, bias);
	    var node = place.node, start = place.start, end = place.end, collapse = place.collapse;
	
	    var rect;
	    if (node.nodeType == 3) { // If it is a text node, use a range to retrieve the coordinates.
	      for (var i = 0; i < 4; i++) { // Retry a maximum of 4 times when nonsense rectangles are returned
	        while (start && isExtendingChar(prepared.line.text.charAt(place.coverStart + start))) --start;
	        while (place.coverStart + end < place.coverEnd && isExtendingChar(prepared.line.text.charAt(place.coverStart + end))) ++end;
	        if (ie && ie_version < 9 && start == 0 && end == place.coverEnd - place.coverStart)
	          rect = node.parentNode.getBoundingClientRect();
	        else
	          rect = getUsefulRect(range(node, start, end).getClientRects(), bias)
	        if (rect.left || rect.right || start == 0) break;
	        end = start;
	        start = start - 1;
	        collapse = "right";
	      }
	      if (ie && ie_version < 11) rect = maybeUpdateRectForZooming(cm.display.measure, rect);
	    } else { // If it is a widget, simply get the box for the whole widget.
	      if (start > 0) collapse = bias = "right";
	      var rects;
	      if (cm.options.lineWrapping && (rects = node.getClientRects()).length > 1)
	        rect = rects[bias == "right" ? rects.length - 1 : 0];
	      else
	        rect = node.getBoundingClientRect();
	    }
	    if (ie && ie_version < 9 && !start && (!rect || !rect.left && !rect.right)) {
	      var rSpan = node.parentNode.getClientRects()[0];
	      if (rSpan)
	        rect = {left: rSpan.left, right: rSpan.left + charWidth(cm.display), top: rSpan.top, bottom: rSpan.bottom};
	      else
	        rect = nullRect;
	    }
	
	    var rtop = rect.top - prepared.rect.top, rbot = rect.bottom - prepared.rect.top;
	    var mid = (rtop + rbot) / 2;
	    var heights = prepared.view.measure.heights;
	    for (var i = 0; i < heights.length - 1; i++)
	      if (mid < heights[i]) break;
	    var top = i ? heights[i - 1] : 0, bot = heights[i];
	    var result = {left: (collapse == "right" ? rect.right : rect.left) - prepared.rect.left,
	                  right: (collapse == "left" ? rect.left : rect.right) - prepared.rect.left,
	                  top: top, bottom: bot};
	    if (!rect.left && !rect.right) result.bogus = true;
	    if (!cm.options.singleCursorHeightPerLine) { result.rtop = rtop; result.rbottom = rbot; }
	
	    return result;
	  }
	
	  // Work around problem with bounding client rects on ranges being
	  // returned incorrectly when zoomed on IE10 and below.
	  function maybeUpdateRectForZooming(measure, rect) {
	    if (!window.screen || screen.logicalXDPI == null ||
	        screen.logicalXDPI == screen.deviceXDPI || !hasBadZoomedRects(measure))
	      return rect;
	    var scaleX = screen.logicalXDPI / screen.deviceXDPI;
	    var scaleY = screen.logicalYDPI / screen.deviceYDPI;
	    return {left: rect.left * scaleX, right: rect.right * scaleX,
	            top: rect.top * scaleY, bottom: rect.bottom * scaleY};
	  }
	
	  function clearLineMeasurementCacheFor(lineView) {
	    if (lineView.measure) {
	      lineView.measure.cache = {};
	      lineView.measure.heights = null;
	      if (lineView.rest) for (var i = 0; i < lineView.rest.length; i++)
	        lineView.measure.caches[i] = {};
	    }
	  }
	
	  function clearLineMeasurementCache(cm) {
	    cm.display.externalMeasure = null;
	    removeChildren(cm.display.lineMeasure);
	    for (var i = 0; i < cm.display.view.length; i++)
	      clearLineMeasurementCacheFor(cm.display.view[i]);
	  }
	
	  function clearCaches(cm) {
	    clearLineMeasurementCache(cm);
	    cm.display.cachedCharWidth = cm.display.cachedTextHeight = cm.display.cachedPaddingH = null;
	    if (!cm.options.lineWrapping) cm.display.maxLineChanged = true;
	    cm.display.lineNumChars = null;
	  }
	
	  function pageScrollX() { return window.pageXOffset || (document.documentElement || document.body).scrollLeft; }
	  function pageScrollY() { return window.pageYOffset || (document.documentElement || document.body).scrollTop; }
	
	  // Converts a {top, bottom, left, right} box from line-local
	  // coordinates into another coordinate system. Context may be one of
	  // "line", "div" (display.lineDiv), "local"/null (editor), "window",
	  // or "page".
	  function intoCoordSystem(cm, lineObj, rect, context) {
	    if (lineObj.widgets) for (var i = 0; i < lineObj.widgets.length; ++i) if (lineObj.widgets[i].above) {
	      var size = widgetHeight(lineObj.widgets[i]);
	      rect.top += size; rect.bottom += size;
	    }
	    if (context == "line") return rect;
	    if (!context) context = "local";
	    var yOff = heightAtLine(lineObj);
	    if (context == "local") yOff += paddingTop(cm.display);
	    else yOff -= cm.display.viewOffset;
	    if (context == "page" || context == "window") {
	      var lOff = cm.display.lineSpace.getBoundingClientRect();
	      yOff += lOff.top + (context == "window" ? 0 : pageScrollY());
	      var xOff = lOff.left + (context == "window" ? 0 : pageScrollX());
	      rect.left += xOff; rect.right += xOff;
	    }
	    rect.top += yOff; rect.bottom += yOff;
	    return rect;
	  }
	
	  // Coverts a box from "div" coords to another coordinate system.
	  // Context may be "window", "page", "div", or "local"/null.
	  function fromCoordSystem(cm, coords, context) {
	    if (context == "div") return coords;
	    var left = coords.left, top = coords.top;
	    // First move into "page" coordinate system
	    if (context == "page") {
	      left -= pageScrollX();
	      top -= pageScrollY();
	    } else if (context == "local" || !context) {
	      var localBox = cm.display.sizer.getBoundingClientRect();
	      left += localBox.left;
	      top += localBox.top;
	    }
	
	    var lineSpaceBox = cm.display.lineSpace.getBoundingClientRect();
	    return {left: left - lineSpaceBox.left, top: top - lineSpaceBox.top};
	  }
	
	  function charCoords(cm, pos, context, lineObj, bias) {
	    if (!lineObj) lineObj = getLine(cm.doc, pos.line);
	    return intoCoordSystem(cm, lineObj, measureChar(cm, lineObj, pos.ch, bias), context);
	  }
	
	  // Returns a box for a given cursor position, which may have an
	  // 'other' property containing the position of the secondary cursor
	  // on a bidi boundary.
	  function cursorCoords(cm, pos, context, lineObj, preparedMeasure, varHeight) {
	    lineObj = lineObj || getLine(cm.doc, pos.line);
	    if (!preparedMeasure) preparedMeasure = prepareMeasureForLine(cm, lineObj);
	    function get(ch, right) {
	      var m = measureCharPrepared(cm, preparedMeasure, ch, right ? "right" : "left", varHeight);
	      if (right) m.left = m.right; else m.right = m.left;
	      return intoCoordSystem(cm, lineObj, m, context);
	    }
	    function getBidi(ch, partPos) {
	      var part = order[partPos], right = part.level % 2;
	      if (ch == bidiLeft(part) && partPos && part.level < order[partPos - 1].level) {
	        part = order[--partPos];
	        ch = bidiRight(part) - (part.level % 2 ? 0 : 1);
	        right = true;
	      } else if (ch == bidiRight(part) && partPos < order.length - 1 && part.level < order[partPos + 1].level) {
	        part = order[++partPos];
	        ch = bidiLeft(part) - part.level % 2;
	        right = false;
	      }
	      if (right && ch == part.to && ch > part.from) return get(ch - 1);
	      return get(ch, right);
	    }
	    var order = getOrder(lineObj), ch = pos.ch;
	    if (!order) return get(ch);
	    var partPos = getBidiPartAt(order, ch);
	    var val = getBidi(ch, partPos);
	    if (bidiOther != null) val.other = getBidi(ch, bidiOther);
	    return val;
	  }
	
	  // Used to cheaply estimate the coordinates for a position. Used for
	  // intermediate scroll updates.
	  function estimateCoords(cm, pos) {
	    var left = 0, pos = clipPos(cm.doc, pos);
	    if (!cm.options.lineWrapping) left = charWidth(cm.display) * pos.ch;
	    var lineObj = getLine(cm.doc, pos.line);
	    var top = heightAtLine(lineObj) + paddingTop(cm.display);
	    return {left: left, right: left, top: top, bottom: top + lineObj.height};
	  }
	
	  // Positions returned by coordsChar contain some extra information.
	  // xRel is the relative x position of the input coordinates compared
	  // to the found position (so xRel > 0 means the coordinates are to
	  // the right of the character position, for example). When outside
	  // is true, that means the coordinates lie outside the line's
	  // vertical range.
	  function PosWithInfo(line, ch, outside, xRel) {
	    var pos = Pos(line, ch);
	    pos.xRel = xRel;
	    if (outside) pos.outside = true;
	    return pos;
	  }
	
	  // Compute the character position closest to the given coordinates.
	  // Input must be lineSpace-local ("div" coordinate system).
	  function coordsChar(cm, x, y) {
	    var doc = cm.doc;
	    y += cm.display.viewOffset;
	    if (y < 0) return PosWithInfo(doc.first, 0, true, -1);
	    var lineN = lineAtHeight(doc, y), last = doc.first + doc.size - 1;
	    if (lineN > last)
	      return PosWithInfo(doc.first + doc.size - 1, getLine(doc, last).text.length, true, 1);
	    if (x < 0) x = 0;
	
	    var lineObj = getLine(doc, lineN);
	    for (;;) {
	      var found = coordsCharInner(cm, lineObj, lineN, x, y);
	      var merged = collapsedSpanAtEnd(lineObj);
	      var mergedPos = merged && merged.find(0, true);
	      if (merged && (found.ch > mergedPos.from.ch || found.ch == mergedPos.from.ch && found.xRel > 0))
	        lineN = lineNo(lineObj = mergedPos.to.line);
	      else
	        return found;
	    }
	  }
	
	  function coordsCharInner(cm, lineObj, lineNo, x, y) {
	    var innerOff = y - heightAtLine(lineObj);
	    var wrongLine = false, adjust = 2 * cm.display.wrapper.clientWidth;
	    var preparedMeasure = prepareMeasureForLine(cm, lineObj);
	
	    function getX(ch) {
	      var sp = cursorCoords(cm, Pos(lineNo, ch), "line", lineObj, preparedMeasure);
	      wrongLine = true;
	      if (innerOff > sp.bottom) return sp.left - adjust;
	      else if (innerOff < sp.top) return sp.left + adjust;
	      else wrongLine = false;
	      return sp.left;
	    }
	
	    var bidi = getOrder(lineObj), dist = lineObj.text.length;
	    var from = lineLeft(lineObj), to = lineRight(lineObj);
	    var fromX = getX(from), fromOutside = wrongLine, toX = getX(to), toOutside = wrongLine;
	
	    if (x > toX) return PosWithInfo(lineNo, to, toOutside, 1);
	    // Do a binary search between these bounds.
	    for (;;) {
	      if (bidi ? to == from || to == moveVisually(lineObj, from, 1) : to - from <= 1) {
	        var ch = x < fromX || x - fromX <= toX - x ? from : to;
	        var outside = ch == from ? fromOutside : toOutside
	        var xDiff = x - (ch == from ? fromX : toX);
	        // This is a kludge to handle the case where the coordinates
	        // are after a line-wrapped line. We should replace it with a
	        // more general handling of cursor positions around line
	        // breaks. (Issue #4078)
	        if (toOutside && !bidi && !/\s/.test(lineObj.text.charAt(ch)) && xDiff > 0 &&
	            ch < lineObj.text.length && preparedMeasure.view.measure.heights.length > 1) {
	          var charSize = measureCharPrepared(cm, preparedMeasure, ch, "right");
	          if (innerOff <= charSize.bottom && innerOff >= charSize.top && Math.abs(x - charSize.right) < xDiff) {
	            outside = false
	            ch++
	            xDiff = x - charSize.right
	          }
	        }
	        while (isExtendingChar(lineObj.text.charAt(ch))) ++ch;
	        var pos = PosWithInfo(lineNo, ch, outside, xDiff < -1 ? -1 : xDiff > 1 ? 1 : 0);
	        return pos;
	      }
	      var step = Math.ceil(dist / 2), middle = from + step;
	      if (bidi) {
	        middle = from;
	        for (var i = 0; i < step; ++i) middle = moveVisually(lineObj, middle, 1);
	      }
	      var middleX = getX(middle);
	      if (middleX > x) {to = middle; toX = middleX; if (toOutside = wrongLine) toX += 1000; dist = step;}
	      else {from = middle; fromX = middleX; fromOutside = wrongLine; dist -= step;}
	    }
	  }
	
	  var measureText;
	  // Compute the default text height.
	  function textHeight(display) {
	    if (display.cachedTextHeight != null) return display.cachedTextHeight;
	    if (measureText == null) {
	      measureText = elt("pre");
	      // Measure a bunch of lines, for browsers that compute
	      // fractional heights.
	      for (var i = 0; i < 49; ++i) {
	        measureText.appendChild(document.createTextNode("x"));
	        measureText.appendChild(elt("br"));
	      }
	      measureText.appendChild(document.createTextNode("x"));
	    }
	    removeChildrenAndAdd(display.measure, measureText);
	    var height = measureText.offsetHeight / 50;
	    if (height > 3) display.cachedTextHeight = height;
	    removeChildren(display.measure);
	    return height || 1;
	  }
	
	  // Compute the default character width.
	  function charWidth(display) {
	    if (display.cachedCharWidth != null) return display.cachedCharWidth;
	    var anchor = elt("span", "xxxxxxxxxx");
	    var pre = elt("pre", [anchor]);
	    removeChildrenAndAdd(display.measure, pre);
	    var rect = anchor.getBoundingClientRect(), width = (rect.right - rect.left) / 10;
	    if (width > 2) display.cachedCharWidth = width;
	    return width || 10;
	  }
	
	  // OPERATIONS
	
	  // Operations are used to wrap a series of changes to the editor
	  // state in such a way that each change won't have to update the
	  // cursor and display (which would be awkward, slow, and
	  // error-prone). Instead, display updates are batched and then all
	  // combined and executed at once.
	
	  var operationGroup = null;
	
	  var nextOpId = 0;
	  // Start a new operation.
	  function startOperation(cm) {
	    cm.curOp = {
	      cm: cm,
	      viewChanged: false,      // Flag that indicates that lines might need to be redrawn
	      startHeight: cm.doc.height, // Used to detect need to update scrollbar
	      forceUpdate: false,      // Used to force a redraw
	      updateInput: null,       // Whether to reset the input textarea
	      typing: false,           // Whether this reset should be careful to leave existing text (for compositing)
	      changeObjs: null,        // Accumulated changes, for firing change events
	      cursorActivityHandlers: null, // Set of handlers to fire cursorActivity on
	      cursorActivityCalled: 0, // Tracks which cursorActivity handlers have been called already
	      selectionChanged: false, // Whether the selection needs to be redrawn
	      updateMaxLine: false,    // Set when the widest line needs to be determined anew
	      scrollLeft: null, scrollTop: null, // Intermediate scroll position, not pushed to DOM yet
	      scrollToPos: null,       // Used to scroll to a specific position
	      focus: false,
	      id: ++nextOpId           // Unique ID
	    };
	    if (operationGroup) {
	      operationGroup.ops.push(cm.curOp);
	    } else {
	      cm.curOp.ownsGroup = operationGroup = {
	        ops: [cm.curOp],
	        delayedCallbacks: []
	      };
	    }
	  }
	
	  function fireCallbacksForOps(group) {
	    // Calls delayed callbacks and cursorActivity handlers until no
	    // new ones appear
	    var callbacks = group.delayedCallbacks, i = 0;
	    do {
	      for (; i < callbacks.length; i++)
	        callbacks[i].call(null);
	      for (var j = 0; j < group.ops.length; j++) {
	        var op = group.ops[j];
	        if (op.cursorActivityHandlers)
	          while (op.cursorActivityCalled < op.cursorActivityHandlers.length)
	            op.cursorActivityHandlers[op.cursorActivityCalled++].call(null, op.cm);
	      }
	    } while (i < callbacks.length);
	  }
	
	  // Finish an operation, updating the display and signalling delayed events
	  function endOperation(cm) {
	    var op = cm.curOp, group = op.ownsGroup;
	    if (!group) return;
	
	    try { fireCallbacksForOps(group); }
	    finally {
	      operationGroup = null;
	      for (var i = 0; i < group.ops.length; i++)
	        group.ops[i].cm.curOp = null;
	      endOperations(group);
	    }
	  }
	
	  // The DOM updates done when an operation finishes are batched so
	  // that the minimum number of relayouts are required.
	  function endOperations(group) {
	    var ops = group.ops;
	    for (var i = 0; i < ops.length; i++) // Read DOM
	      endOperation_R1(ops[i]);
	    for (var i = 0; i < ops.length; i++) // Write DOM (maybe)
	      endOperation_W1(ops[i]);
	    for (var i = 0; i < ops.length; i++) // Read DOM
	      endOperation_R2(ops[i]);
	    for (var i = 0; i < ops.length; i++) // Write DOM (maybe)
	      endOperation_W2(ops[i]);
	    for (var i = 0; i < ops.length; i++) // Read DOM
	      endOperation_finish(ops[i]);
	  }
	
	  function endOperation_R1(op) {
	    var cm = op.cm, display = cm.display;
	    maybeClipScrollbars(cm);
	    if (op.updateMaxLine) findMaxLine(cm);
	
	    op.mustUpdate = op.viewChanged || op.forceUpdate || op.scrollTop != null ||
	      op.scrollToPos && (op.scrollToPos.from.line < display.viewFrom ||
	                         op.scrollToPos.to.line >= display.viewTo) ||
	      display.maxLineChanged && cm.options.lineWrapping;
	    op.update = op.mustUpdate &&
	      new DisplayUpdate(cm, op.mustUpdate && {top: op.scrollTop, ensure: op.scrollToPos}, op.forceUpdate);
	  }
	
	  function endOperation_W1(op) {
	    op.updatedDisplay = op.mustUpdate && updateDisplayIfNeeded(op.cm, op.update);
	  }
	
	  function endOperation_R2(op) {
	    var cm = op.cm, display = cm.display;
	    if (op.updatedDisplay) updateHeightsInViewport(cm);
	
	    op.barMeasure = measureForScrollbars(cm);
	
	    // If the max line changed since it was last measured, measure it,
	    // and ensure the document's width matches it.
	    // updateDisplay_W2 will use these properties to do the actual resizing
	    if (display.maxLineChanged && !cm.options.lineWrapping) {
	      op.adjustWidthTo = measureChar(cm, display.maxLine, display.maxLine.text.length).left + 3;
	      cm.display.sizerWidth = op.adjustWidthTo;
	      op.barMeasure.scrollWidth =
	        Math.max(display.scroller.clientWidth, display.sizer.offsetLeft + op.adjustWidthTo + scrollGap(cm) + cm.display.barWidth);
	      op.maxScrollLeft = Math.max(0, display.sizer.offsetLeft + op.adjustWidthTo - displayWidth(cm));
	    }
	
	    if (op.updatedDisplay || op.selectionChanged)
	      op.preparedSelection = display.input.prepareSelection(op.focus);
	  }
	
	  function endOperation_W2(op) {
	    var cm = op.cm;
	
	    if (op.adjustWidthTo != null) {
	      cm.display.sizer.style.minWidth = op.adjustWidthTo + "px";
	      if (op.maxScrollLeft < cm.doc.scrollLeft)
	        setScrollLeft(cm, Math.min(cm.display.scroller.scrollLeft, op.maxScrollLeft), true);
	      cm.display.maxLineChanged = false;
	    }
	
	    var takeFocus = op.focus && op.focus == activeElt() && (!document.hasFocus || document.hasFocus())
	    if (op.preparedSelection)
	      cm.display.input.showSelection(op.preparedSelection, takeFocus);
	    if (op.updatedDisplay || op.startHeight != cm.doc.height)
	      updateScrollbars(cm, op.barMeasure);
	    if (op.updatedDisplay)
	      setDocumentHeight(cm, op.barMeasure);
	
	    if (op.selectionChanged) restartBlink(cm);
	
	    if (cm.state.focused && op.updateInput)
	      cm.display.input.reset(op.typing);
	    if (takeFocus) ensureFocus(op.cm);
	  }
	
	  function endOperation_finish(op) {
	    var cm = op.cm, display = cm.display, doc = cm.doc;
	
	    if (op.updatedDisplay) postUpdateDisplay(cm, op.update);
	
	    // Abort mouse wheel delta measurement, when scrolling explicitly
	    if (display.wheelStartX != null && (op.scrollTop != null || op.scrollLeft != null || op.scrollToPos))
	      display.wheelStartX = display.wheelStartY = null;
	
	    // Propagate the scroll position to the actual DOM scroller
	    if (op.scrollTop != null && (display.scroller.scrollTop != op.scrollTop || op.forceScroll)) {
	      doc.scrollTop = Math.max(0, Math.min(display.scroller.scrollHeight - display.scroller.clientHeight, op.scrollTop));
	      display.scrollbars.setScrollTop(doc.scrollTop);
	      display.scroller.scrollTop = doc.scrollTop;
	    }
	    if (op.scrollLeft != null && (display.scroller.scrollLeft != op.scrollLeft || op.forceScroll)) {
	      doc.scrollLeft = Math.max(0, Math.min(display.scroller.scrollWidth - display.scroller.clientWidth, op.scrollLeft));
	      display.scrollbars.setScrollLeft(doc.scrollLeft);
	      display.scroller.scrollLeft = doc.scrollLeft;
	      alignHorizontally(cm);
	    }
	    // If we need to scroll a specific position into view, do so.
	    if (op.scrollToPos) {
	      var coords = scrollPosIntoView(cm, clipPos(doc, op.scrollToPos.from),
	                                     clipPos(doc, op.scrollToPos.to), op.scrollToPos.margin);
	      if (op.scrollToPos.isCursor && cm.state.focused) maybeScrollWindow(cm, coords);
	    }
	
	    // Fire events for markers that are hidden/unidden by editing or
	    // undoing
	    var hidden = op.maybeHiddenMarkers, unhidden = op.maybeUnhiddenMarkers;
	    if (hidden) for (var i = 0; i < hidden.length; ++i)
	      if (!hidden[i].lines.length) signal(hidden[i], "hide");
	    if (unhidden) for (var i = 0; i < unhidden.length; ++i)
	      if (unhidden[i].lines.length) signal(unhidden[i], "unhide");
	
	    if (display.wrapper.offsetHeight)
	      doc.scrollTop = cm.display.scroller.scrollTop;
	
	    // Fire change events, and delayed event handlers
	    if (op.changeObjs)
	      signal(cm, "changes", cm, op.changeObjs);
	    if (op.update)
	      op.update.finish();
	  }
	
	  // Run the given function in an operation
	  function runInOp(cm, f) {
	    if (cm.curOp) return f();
	    startOperation(cm);
	    try { return f(); }
	    finally { endOperation(cm); }
	  }
	  // Wraps a function in an operation. Returns the wrapped function.
	  function operation(cm, f) {
	    return function() {
	      if (cm.curOp) return f.apply(cm, arguments);
	      startOperation(cm);
	      try { return f.apply(cm, arguments); }
	      finally { endOperation(cm); }
	    };
	  }
	  // Used to add methods to editor and doc instances, wrapping them in
	  // operations.
	  function methodOp(f) {
	    return function() {
	      if (this.curOp) return f.apply(this, arguments);
	      startOperation(this);
	      try { return f.apply(this, arguments); }
	      finally { endOperation(this); }
	    };
	  }
	  function docMethodOp(f) {
	    return function() {
	      var cm = this.cm;
	      if (!cm || cm.curOp) return f.apply(this, arguments);
	      startOperation(cm);
	      try { return f.apply(this, arguments); }
	      finally { endOperation(cm); }
	    };
	  }
	
	  // VIEW TRACKING
	
	  // These objects are used to represent the visible (currently drawn)
	  // part of the document. A LineView may correspond to multiple
	  // logical lines, if those are connected by collapsed ranges.
	  function LineView(doc, line, lineN) {
	    // The starting line
	    this.line = line;
	    // Continuing lines, if any
	    this.rest = visualLineContinued(line);
	    // Number of logical lines in this visual line
	    this.size = this.rest ? lineNo(lst(this.rest)) - lineN + 1 : 1;
	    this.node = this.text = null;
	    this.hidden = lineIsHidden(doc, line);
	  }
	
	  // Create a range of LineView objects for the given lines.
	  function buildViewArray(cm, from, to) {
	    var array = [], nextPos;
	    for (var pos = from; pos < to; pos = nextPos) {
	      var view = new LineView(cm.doc, getLine(cm.doc, pos), pos);
	      nextPos = pos + view.size;
	      array.push(view);
	    }
	    return array;
	  }
	
	  // Updates the display.view data structure for a given change to the
	  // document. From and to are in pre-change coordinates. Lendiff is
	  // the amount of lines added or subtracted by the change. This is
	  // used for changes that span multiple lines, or change the way
	  // lines are divided into visual lines. regLineChange (below)
	  // registers single-line changes.
	  function regChange(cm, from, to, lendiff) {
	    if (from == null) from = cm.doc.first;
	    if (to == null) to = cm.doc.first + cm.doc.size;
	    if (!lendiff) lendiff = 0;
	
	    var display = cm.display;
	    if (lendiff && to < display.viewTo &&
	        (display.updateLineNumbers == null || display.updateLineNumbers > from))
	      display.updateLineNumbers = from;
	
	    cm.curOp.viewChanged = true;
	
	    if (from >= display.viewTo) { // Change after
	      if (sawCollapsedSpans && visualLineNo(cm.doc, from) < display.viewTo)
	        resetView(cm);
	    } else if (to <= display.viewFrom) { // Change before
	      if (sawCollapsedSpans && visualLineEndNo(cm.doc, to + lendiff) > display.viewFrom) {
	        resetView(cm);
	      } else {
	        display.viewFrom += lendiff;
	        display.viewTo += lendiff;
	      }
	    } else if (from <= display.viewFrom && to >= display.viewTo) { // Full overlap
	      resetView(cm);
	    } else if (from <= display.viewFrom) { // Top overlap
	      var cut = viewCuttingPoint(cm, to, to + lendiff, 1);
	      if (cut) {
	        display.view = display.view.slice(cut.index);
	        display.viewFrom = cut.lineN;
	        display.viewTo += lendiff;
	      } else {
	        resetView(cm);
	      }
	    } else if (to >= display.viewTo) { // Bottom overlap
	      var cut = viewCuttingPoint(cm, from, from, -1);
	      if (cut) {
	        display.view = display.view.slice(0, cut.index);
	        display.viewTo = cut.lineN;
	      } else {
	        resetView(cm);
	      }
	    } else { // Gap in the middle
	      var cutTop = viewCuttingPoint(cm, from, from, -1);
	      var cutBot = viewCuttingPoint(cm, to, to + lendiff, 1);
	      if (cutTop && cutBot) {
	        display.view = display.view.slice(0, cutTop.index)
	          .concat(buildViewArray(cm, cutTop.lineN, cutBot.lineN))
	          .concat(display.view.slice(cutBot.index));
	        display.viewTo += lendiff;
	      } else {
	        resetView(cm);
	      }
	    }
	
	    var ext = display.externalMeasured;
	    if (ext) {
	      if (to < ext.lineN)
	        ext.lineN += lendiff;
	      else if (from < ext.lineN + ext.size)
	        display.externalMeasured = null;
	    }
	  }
	
	  // Register a change to a single line. Type must be one of "text",
	  // "gutter", "class", "widget"
	  function regLineChange(cm, line, type) {
	    cm.curOp.viewChanged = true;
	    var display = cm.display, ext = cm.display.externalMeasured;
	    if (ext && line >= ext.lineN && line < ext.lineN + ext.size)
	      display.externalMeasured = null;
	
	    if (line < display.viewFrom || line >= display.viewTo) return;
	    var lineView = display.view[findViewIndex(cm, line)];
	    if (lineView.node == null) return;
	    var arr = lineView.changes || (lineView.changes = []);
	    if (indexOf(arr, type) == -1) arr.push(type);
	  }
	
	  // Clear the view.
	  function resetView(cm) {
	    cm.display.viewFrom = cm.display.viewTo = cm.doc.first;
	    cm.display.view = [];
	    cm.display.viewOffset = 0;
	  }
	
	  // Find the view element corresponding to a given line. Return null
	  // when the line isn't visible.
	  function findViewIndex(cm, n) {
	    if (n >= cm.display.viewTo) return null;
	    n -= cm.display.viewFrom;
	    if (n < 0) return null;
	    var view = cm.display.view;
	    for (var i = 0; i < view.length; i++) {
	      n -= view[i].size;
	      if (n < 0) return i;
	    }
	  }
	
	  function viewCuttingPoint(cm, oldN, newN, dir) {
	    var index = findViewIndex(cm, oldN), diff, view = cm.display.view;
	    if (!sawCollapsedSpans || newN == cm.doc.first + cm.doc.size)
	      return {index: index, lineN: newN};
	    for (var i = 0, n = cm.display.viewFrom; i < index; i++)
	      n += view[i].size;
	    if (n != oldN) {
	      if (dir > 0) {
	        if (index == view.length - 1) return null;
	        diff = (n + view[index].size) - oldN;
	        index++;
	      } else {
	        diff = n - oldN;
	      }
	      oldN += diff; newN += diff;
	    }
	    while (visualLineNo(cm.doc, newN) != newN) {
	      if (index == (dir < 0 ? 0 : view.length - 1)) return null;
	      newN += dir * view[index - (dir < 0 ? 1 : 0)].size;
	      index += dir;
	    }
	    return {index: index, lineN: newN};
	  }
	
	  // Force the view to cover a given range, adding empty view element
	  // or clipping off existing ones as needed.
	  function adjustView(cm, from, to) {
	    var display = cm.display, view = display.view;
	    if (view.length == 0 || from >= display.viewTo || to <= display.viewFrom) {
	      display.view = buildViewArray(cm, from, to);
	      display.viewFrom = from;
	    } else {
	      if (display.viewFrom > from)
	        display.view = buildViewArray(cm, from, display.viewFrom).concat(display.view);
	      else if (display.viewFrom < from)
	        display.view = display.view.slice(findViewIndex(cm, from));
	      display.viewFrom = from;
	      if (display.viewTo < to)
	        display.view = display.view.concat(buildViewArray(cm, display.viewTo, to));
	      else if (display.viewTo > to)
	        display.view = display.view.slice(0, findViewIndex(cm, to));
	    }
	    display.viewTo = to;
	  }
	
	  // Count the number of lines in the view whose DOM representation is
	  // out of date (or nonexistent).
	  function countDirtyView(cm) {
	    var view = cm.display.view, dirty = 0;
	    for (var i = 0; i < view.length; i++) {
	      var lineView = view[i];
	      if (!lineView.hidden && (!lineView.node || lineView.changes)) ++dirty;
	    }
	    return dirty;
	  }
	
	  // EVENT HANDLERS
	
	  // Attach the necessary event handlers when initializing the editor
	  function registerEventHandlers(cm) {
	    var d = cm.display;
	    on(d.scroller, "mousedown", operation(cm, onMouseDown));
	    // Older IE's will not fire a second mousedown for a double click
	    if (ie && ie_version < 11)
	      on(d.scroller, "dblclick", operation(cm, function(e) {
	        if (signalDOMEvent(cm, e)) return;
	        var pos = posFromMouse(cm, e);
	        if (!pos || clickInGutter(cm, e) || eventInWidget(cm.display, e)) return;
	        e_preventDefault(e);
	        var word = cm.findWordAt(pos);
	        extendSelection(cm.doc, word.anchor, word.head);
	      }));
	    else
	      on(d.scroller, "dblclick", function(e) { signalDOMEvent(cm, e) || e_preventDefault(e); });
	    // Some browsers fire contextmenu *after* opening the menu, at
	    // which point we can't mess with it anymore. Context menu is
	    // handled in onMouseDown for these browsers.
	    if (!captureRightClick) on(d.scroller, "contextmenu", function(e) {onContextMenu(cm, e);});
	
	    // Used to suppress mouse event handling when a touch happens
	    var touchFinished, prevTouch = {end: 0};
	    function finishTouch() {
	      if (d.activeTouch) {
	        touchFinished = setTimeout(function() {d.activeTouch = null;}, 1000);
	        prevTouch = d.activeTouch;
	        prevTouch.end = +new Date;
	      }
	    };
	    function isMouseLikeTouchEvent(e) {
	      if (e.touches.length != 1) return false;
	      var touch = e.touches[0];
	      return touch.radiusX <= 1 && touch.radiusY <= 1;
	    }
	    function farAway(touch, other) {
	      if (other.left == null) return true;
	      var dx = other.left - touch.left, dy = other.top - touch.top;
	      return dx * dx + dy * dy > 20 * 20;
	    }
	    on(d.scroller, "touchstart", function(e) {
	      if (!signalDOMEvent(cm, e) && !isMouseLikeTouchEvent(e)) {
	        clearTimeout(touchFinished);
	        var now = +new Date;
	        d.activeTouch = {start: now, moved: false,
	                         prev: now - prevTouch.end <= 300 ? prevTouch : null};
	        if (e.touches.length == 1) {
	          d.activeTouch.left = e.touches[0].pageX;
	          d.activeTouch.top = e.touches[0].pageY;
	        }
	      }
	    });
	    on(d.scroller, "touchmove", function() {
	      if (d.activeTouch) d.activeTouch.moved = true;
	    });
	    on(d.scroller, "touchend", function(e) {
	      var touch = d.activeTouch;
	      if (touch && !eventInWidget(d, e) && touch.left != null &&
	          !touch.moved && new Date - touch.start < 300) {
	        var pos = cm.coordsChar(d.activeTouch, "page"), range;
	        if (!touch.prev || farAway(touch, touch.prev)) // Single tap
	          range = new Range(pos, pos);
	        else if (!touch.prev.prev || farAway(touch, touch.prev.prev)) // Double tap
	          range = cm.findWordAt(pos);
	        else // Triple tap
	          range = new Range(Pos(pos.line, 0), clipPos(cm.doc, Pos(pos.line + 1, 0)));
	        cm.setSelection(range.anchor, range.head);
	        cm.focus();
	        e_preventDefault(e);
	      }
	      finishTouch();
	    });
	    on(d.scroller, "touchcancel", finishTouch);
	
	    // Sync scrolling between fake scrollbars and real scrollable
	    // area, ensure viewport is updated when scrolling.
	    on(d.scroller, "scroll", function() {
	      if (d.scroller.clientHeight) {
	        setScrollTop(cm, d.scroller.scrollTop);
	        setScrollLeft(cm, d.scroller.scrollLeft, true);
	        signal(cm, "scroll", cm);
	      }
	    });
	
	    // Listen to wheel events in order to try and update the viewport on time.
	    on(d.scroller, "mousewheel", function(e){onScrollWheel(cm, e);});
	    on(d.scroller, "DOMMouseScroll", function(e){onScrollWheel(cm, e);});
	
	    // Prevent wrapper from ever scrolling
	    on(d.wrapper, "scroll", function() { d.wrapper.scrollTop = d.wrapper.scrollLeft = 0; });
	
	    d.dragFunctions = {
	      enter: function(e) {if (!signalDOMEvent(cm, e)) e_stop(e);},
	      over: function(e) {if (!signalDOMEvent(cm, e)) { onDragOver(cm, e); e_stop(e); }},
	      start: function(e){onDragStart(cm, e);},
	      drop: operation(cm, onDrop),
	      leave: function(e) {if (!signalDOMEvent(cm, e)) { clearDragCursor(cm); }}
	    };
	
	    var inp = d.input.getField();
	    on(inp, "keyup", function(e) { onKeyUp.call(cm, e); });
	    on(inp, "keydown", operation(cm, onKeyDown));
	    on(inp, "keypress", operation(cm, onKeyPress));
	    on(inp, "focus", bind(onFocus, cm));
	    on(inp, "blur", bind(onBlur, cm));
	  }
	
	  function dragDropChanged(cm, value, old) {
	    var wasOn = old && old != CodeMirror.Init;
	    if (!value != !wasOn) {
	      var funcs = cm.display.dragFunctions;
	      var toggle = value ? on : off;
	      toggle(cm.display.scroller, "dragstart", funcs.start);
	      toggle(cm.display.scroller, "dragenter", funcs.enter);
	      toggle(cm.display.scroller, "dragover", funcs.over);
	      toggle(cm.display.scroller, "dragleave", funcs.leave);
	      toggle(cm.display.scroller, "drop", funcs.drop);
	    }
	  }
	
	  // Called when the window resizes
	  function onResize(cm) {
	    var d = cm.display;
	    if (d.lastWrapHeight == d.wrapper.clientHeight && d.lastWrapWidth == d.wrapper.clientWidth)
	      return;
	    // Might be a text scaling operation, clear size caches.
	    d.cachedCharWidth = d.cachedTextHeight = d.cachedPaddingH = null;
	    d.scrollbarsClipped = false;
	    cm.setSize();
	  }
	
	  // MOUSE EVENTS
	
	  // Return true when the given mouse event happened in a widget
	  function eventInWidget(display, e) {
	    for (var n = e_target(e); n != display.wrapper; n = n.parentNode) {
	      if (!n || (n.nodeType == 1 && n.getAttribute("cm-ignore-events") == "true") ||
	          (n.parentNode == display.sizer && n != display.mover))
	        return true;
	    }
	  }
	
	  // Given a mouse event, find the corresponding position. If liberal
	  // is false, it checks whether a gutter or scrollbar was clicked,
	  // and returns null if it was. forRect is used by rectangular
	  // selections, and tries to estimate a character position even for
	  // coordinates beyond the right of the text.
	  function posFromMouse(cm, e, liberal, forRect) {
	    var display = cm.display;
	    if (!liberal && e_target(e).getAttribute("cm-not-content") == "true") return null;
	
	    var x, y, space = display.lineSpace.getBoundingClientRect();
	    // Fails unpredictably on IE[67] when mouse is dragged around quickly.
	    try { x = e.clientX - space.left; y = e.clientY - space.top; }
	    catch (e) { return null; }
	    var coords = coordsChar(cm, x, y), line;
	    if (forRect && coords.xRel == 1 && (line = getLine(cm.doc, coords.line).text).length == coords.ch) {
	      var colDiff = countColumn(line, line.length, cm.options.tabSize) - line.length;
	      coords = Pos(coords.line, Math.max(0, Math.round((x - paddingH(cm.display).left) / charWidth(cm.display)) - colDiff));
	    }
	    return coords;
	  }
	
	  // A mouse down can be a single click, double click, triple click,
	  // start of selection drag, start of text drag, new cursor
	  // (ctrl-click), rectangle drag (alt-drag), or xwin
	  // middle-click-paste. Or it might be a click on something we should
	  // not interfere with, such as a scrollbar or widget.
	  function onMouseDown(e) {
	    var cm = this, display = cm.display;
	    if (signalDOMEvent(cm, e) || display.activeTouch && display.input.supportsTouch()) return;
	    display.shift = e.shiftKey;
	
	    if (eventInWidget(display, e)) {
	      if (!webkit) {
	        // Briefly turn off draggability, to allow widgets to do
	        // normal dragging things.
	        display.scroller.draggable = false;
	        setTimeout(function(){display.scroller.draggable = true;}, 100);
	      }
	      return;
	    }
	    if (clickInGutter(cm, e)) return;
	    var start = posFromMouse(cm, e);
	    window.focus();
	
	    switch (e_button(e)) {
	    case 1:
	      // #3261: make sure, that we're not starting a second selection
	      if (cm.state.selectingText)
	        cm.state.selectingText(e);
	      else if (start)
	        leftButtonDown(cm, e, start);
	      else if (e_target(e) == display.scroller)
	        e_preventDefault(e);
	      break;
	    case 2:
	      if (webkit) cm.state.lastMiddleDown = +new Date;
	      if (start) extendSelection(cm.doc, start);
	      setTimeout(function() {display.input.focus();}, 20);
	      e_preventDefault(e);
	      break;
	    case 3:
	      if (captureRightClick) onContextMenu(cm, e);
	      else delayBlurEvent(cm);
	      break;
	    }
	  }
	
	  var lastClick, lastDoubleClick;
	  function leftButtonDown(cm, e, start) {
	    if (ie) setTimeout(bind(ensureFocus, cm), 0);
	    else cm.curOp.focus = activeElt();
	
	    var now = +new Date, type;
	    if (lastDoubleClick && lastDoubleClick.time > now - 400 && cmp(lastDoubleClick.pos, start) == 0) {
	      type = "triple";
	    } else if (lastClick && lastClick.time > now - 400 && cmp(lastClick.pos, start) == 0) {
	      type = "double";
	      lastDoubleClick = {time: now, pos: start};
	    } else {
	      type = "single";
	      lastClick = {time: now, pos: start};
	    }
	
	    var sel = cm.doc.sel, modifier = mac ? e.metaKey : e.ctrlKey, contained;
	    if (cm.options.dragDrop && dragAndDrop && !cm.isReadOnly() &&
	        type == "single" && (contained = sel.contains(start)) > -1 &&
	        (cmp((contained = sel.ranges[contained]).from(), start) < 0 || start.xRel > 0) &&
	        (cmp(contained.to(), start) > 0 || start.xRel < 0))
	      leftButtonStartDrag(cm, e, start, modifier);
	    else
	      leftButtonSelect(cm, e, start, type, modifier);
	  }
	
	  // Start a text drag. When it ends, see if any dragging actually
	  // happen, and treat as a click if it didn't.
	  function leftButtonStartDrag(cm, e, start, modifier) {
	    var display = cm.display, startTime = +new Date;
	    var dragEnd = operation(cm, function(e2) {
	      if (webkit) display.scroller.draggable = false;
	      cm.state.draggingText = false;
	      off(document, "mouseup", dragEnd);
	      off(display.scroller, "drop", dragEnd);
	      if (Math.abs(e.clientX - e2.clientX) + Math.abs(e.clientY - e2.clientY) < 10) {
	        e_preventDefault(e2);
	        if (!modifier && +new Date - 200 < startTime)
	          extendSelection(cm.doc, start);
	        // Work around unexplainable focus problem in IE9 (#2127) and Chrome (#3081)
	        if (webkit || ie && ie_version == 9)
	          setTimeout(function() {document.body.focus(); display.input.focus();}, 20);
	        else
	          display.input.focus();
	      }
	    });
	    // Let the drag handler handle this.
	    if (webkit) display.scroller.draggable = true;
	    cm.state.draggingText = dragEnd;
	    dragEnd.copy = mac ? e.altKey : e.ctrlKey
	    // IE's approach to draggable
	    if (display.scroller.dragDrop) display.scroller.dragDrop();
	    on(document, "mouseup", dragEnd);
	    on(display.scroller, "drop", dragEnd);
	  }
	
	  // Normal selection, as opposed to text dragging.
	  function leftButtonSelect(cm, e, start, type, addNew) {
	    var display = cm.display, doc = cm.doc;
	    e_preventDefault(e);
	
	    var ourRange, ourIndex, startSel = doc.sel, ranges = startSel.ranges;
	    if (addNew && !e.shiftKey) {
	      ourIndex = doc.sel.contains(start);
	      if (ourIndex > -1)
	        ourRange = ranges[ourIndex];
	      else
	        ourRange = new Range(start, start);
	    } else {
	      ourRange = doc.sel.primary();
	      ourIndex = doc.sel.primIndex;
	    }
	
	    if (chromeOS ? e.shiftKey && e.metaKey : e.altKey) {
	      type = "rect";
	      if (!addNew) ourRange = new Range(start, start);
	      start = posFromMouse(cm, e, true, true);
	      ourIndex = -1;
	    } else if (type == "double") {
	      var word = cm.findWordAt(start);
	      if (cm.display.shift || doc.extend)
	        ourRange = extendRange(doc, ourRange, word.anchor, word.head);
	      else
	        ourRange = word;
	    } else if (type == "triple") {
	      var line = new Range(Pos(start.line, 0), clipPos(doc, Pos(start.line + 1, 0)));
	      if (cm.display.shift || doc.extend)
	        ourRange = extendRange(doc, ourRange, line.anchor, line.head);
	      else
	        ourRange = line;
	    } else {
	      ourRange = extendRange(doc, ourRange, start);
	    }
	
	    if (!addNew) {
	      ourIndex = 0;
	      setSelection(doc, new Selection([ourRange], 0), sel_mouse);
	      startSel = doc.sel;
	    } else if (ourIndex == -1) {
	      ourIndex = ranges.length;
	      setSelection(doc, normalizeSelection(ranges.concat([ourRange]), ourIndex),
	                   {scroll: false, origin: "*mouse"});
	    } else if (ranges.length > 1 && ranges[ourIndex].empty() && type == "single" && !e.shiftKey) {
	      setSelection(doc, normalizeSelection(ranges.slice(0, ourIndex).concat(ranges.slice(ourIndex + 1)), 0),
	                   {scroll: false, origin: "*mouse"});
	      startSel = doc.sel;
	    } else {
	      replaceOneSelection(doc, ourIndex, ourRange, sel_mouse);
	    }
	
	    var lastPos = start;
	    function extendTo(pos) {
	      if (cmp(lastPos, pos) == 0) return;
	      lastPos = pos;
	
	      if (type == "rect") {
	        var ranges = [], tabSize = cm.options.tabSize;
	        var startCol = countColumn(getLine(doc, start.line).text, start.ch, tabSize);
	        var posCol = countColumn(getLine(doc, pos.line).text, pos.ch, tabSize);
	        var left = Math.min(startCol, posCol), right = Math.max(startCol, posCol);
	        for (var line = Math.min(start.line, pos.line), end = Math.min(cm.lastLine(), Math.max(start.line, pos.line));
	             line <= end; line++) {
	          var text = getLine(doc, line).text, leftPos = findColumn(text, left, tabSize);
	          if (left == right)
	            ranges.push(new Range(Pos(line, leftPos), Pos(line, leftPos)));
	          else if (text.length > leftPos)
	            ranges.push(new Range(Pos(line, leftPos), Pos(line, findColumn(text, right, tabSize))));
	        }
	        if (!ranges.length) ranges.push(new Range(start, start));
	        setSelection(doc, normalizeSelection(startSel.ranges.slice(0, ourIndex).concat(ranges), ourIndex),
	                     {origin: "*mouse", scroll: false});
	        cm.scrollIntoView(pos);
	      } else {
	        var oldRange = ourRange;
	        var anchor = oldRange.anchor, head = pos;
	        if (type != "single") {
	          if (type == "double")
	            var range = cm.findWordAt(pos);
	          else
	            var range = new Range(Pos(pos.line, 0), clipPos(doc, Pos(pos.line + 1, 0)));
	          if (cmp(range.anchor, anchor) > 0) {
	            head = range.head;
	            anchor = minPos(oldRange.from(), range.anchor);
	          } else {
	            head = range.anchor;
	            anchor = maxPos(oldRange.to(), range.head);
	          }
	        }
	        var ranges = startSel.ranges.slice(0);
	        ranges[ourIndex] = new Range(clipPos(doc, anchor), head);
	        setSelection(doc, normalizeSelection(ranges, ourIndex), sel_mouse);
	      }
	    }
	
	    var editorSize = display.wrapper.getBoundingClientRect();
	    // Used to ensure timeout re-tries don't fire when another extend
	    // happened in the meantime (clearTimeout isn't reliable -- at
	    // least on Chrome, the timeouts still happen even when cleared,
	    // if the clear happens after their scheduled firing time).
	    var counter = 0;
	
	    function extend(e) {
	      var curCount = ++counter;
	      var cur = posFromMouse(cm, e, true, type == "rect");
	      if (!cur) return;
	      if (cmp(cur, lastPos) != 0) {
	        cm.curOp.focus = activeElt();
	        extendTo(cur);
	        var visible = visibleLines(display, doc);
	        if (cur.line >= visible.to || cur.line < visible.from)
	          setTimeout(operation(cm, function(){if (counter == curCount) extend(e);}), 150);
	      } else {
	        var outside = e.clientY < editorSize.top ? -20 : e.clientY > editorSize.bottom ? 20 : 0;
	        if (outside) setTimeout(operation(cm, function() {
	          if (counter != curCount) return;
	          display.scroller.scrollTop += outside;
	          extend(e);
	        }), 50);
	      }
	    }
	
	    function done(e) {
	      cm.state.selectingText = false;
	      counter = Infinity;
	      e_preventDefault(e);
	      display.input.focus();
	      off(document, "mousemove", move);
	      off(document, "mouseup", up);
	      doc.history.lastSelOrigin = null;
	    }
	
	    var move = operation(cm, function(e) {
	      if (!e_button(e)) done(e);
	      else extend(e);
	    });
	    var up = operation(cm, done);
	    cm.state.selectingText = up;
	    on(document, "mousemove", move);
	    on(document, "mouseup", up);
	  }
	
	  // Determines whether an event happened in the gutter, and fires the
	  // handlers for the corresponding event.
	  function gutterEvent(cm, e, type, prevent) {
	    try { var mX = e.clientX, mY = e.clientY; }
	    catch(e) { return false; }
	    if (mX >= Math.floor(cm.display.gutters.getBoundingClientRect().right)) return false;
	    if (prevent) e_preventDefault(e);
	
	    var display = cm.display;
	    var lineBox = display.lineDiv.getBoundingClientRect();
	
	    if (mY > lineBox.bottom || !hasHandler(cm, type)) return e_defaultPrevented(e);
	    mY -= lineBox.top - display.viewOffset;
	
	    for (var i = 0; i < cm.options.gutters.length; ++i) {
	      var g = display.gutters.childNodes[i];
	      if (g && g.getBoundingClientRect().right >= mX) {
	        var line = lineAtHeight(cm.doc, mY);
	        var gutter = cm.options.gutters[i];
	        signal(cm, type, cm, line, gutter, e);
	        return e_defaultPrevented(e);
	      }
	    }
	  }
	
	  function clickInGutter(cm, e) {
	    return gutterEvent(cm, e, "gutterClick", true);
	  }
	
	  // Kludge to work around strange IE behavior where it'll sometimes
	  // re-fire a series of drag-related events right after the drop (#1551)
	  var lastDrop = 0;
	
	  function onDrop(e) {
	    var cm = this;
	    clearDragCursor(cm);
	    if (signalDOMEvent(cm, e) || eventInWidget(cm.display, e))
	      return;
	    e_preventDefault(e);
	    if (ie) lastDrop = +new Date;
	    var pos = posFromMouse(cm, e, true), files = e.dataTransfer.files;
	    if (!pos || cm.isReadOnly()) return;
	    // Might be a file drop, in which case we simply extract the text
	    // and insert it.
	    if (files && files.length && window.FileReader && window.File) {
	      var n = files.length, text = Array(n), read = 0;
	      var loadFile = function(file, i) {
	        if (cm.options.allowDropFileTypes &&
	            indexOf(cm.options.allowDropFileTypes, file.type) == -1)
	          return;
	
	        var reader = new FileReader;
	        reader.onload = operation(cm, function() {
	          var content = reader.result;
	          if (/[\x00-\x08\x0e-\x1f]{2}/.test(content)) content = "";
	          text[i] = content;
	          if (++read == n) {
	            pos = clipPos(cm.doc, pos);
	            var change = {from: pos, to: pos,
	                          text: cm.doc.splitLines(text.join(cm.doc.lineSeparator())),
	                          origin: "paste"};
	            makeChange(cm.doc, change);
	            setSelectionReplaceHistory(cm.doc, simpleSelection(pos, changeEnd(change)));
	          }
	        });
	        reader.readAsText(file);
	      };
	      for (var i = 0; i < n; ++i) loadFile(files[i], i);
	    } else { // Normal drop
	      // Don't do a replace if the drop happened inside of the selected text.
	      if (cm.state.draggingText && cm.doc.sel.contains(pos) > -1) {
	        cm.state.draggingText(e);
	        // Ensure the editor is re-focused
	        setTimeout(function() {cm.display.input.focus();}, 20);
	        return;
	      }
	      try {
	        var text = e.dataTransfer.getData("Text");
	        if (text) {
	          if (cm.state.draggingText && !cm.state.draggingText.copy)
	            var selected = cm.listSelections();
	          setSelectionNoUndo(cm.doc, simpleSelection(pos, pos));
	          if (selected) for (var i = 0; i < selected.length; ++i)
	            replaceRange(cm.doc, "", selected[i].anchor, selected[i].head, "drag");
	          cm.replaceSelection(text, "around", "paste");
	          cm.display.input.focus();
	        }
	      }
	      catch(e){}
	    }
	  }
	
	  function onDragStart(cm, e) {
	    if (ie && (!cm.state.draggingText || +new Date - lastDrop < 100)) { e_stop(e); return; }
	    if (signalDOMEvent(cm, e) || eventInWidget(cm.display, e)) return;
	
	    e.dataTransfer.setData("Text", cm.getSelection());
	    e.dataTransfer.effectAllowed = "copyMove"
	
	    // Use dummy image instead of default browsers image.
	    // Recent Safari (~6.0.2) have a tendency to segfault when this happens, so we don't do it there.
	    if (e.dataTransfer.setDragImage && !safari) {
	      var img = elt("img", null, null, "position: fixed; left: 0; top: 0;");
	      img.src = "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==";
	      if (presto) {
	        img.width = img.height = 1;
	        cm.display.wrapper.appendChild(img);
	        // Force a relayout, or Opera won't use our image for some obscure reason
	        img._top = img.offsetTop;
	      }
	      e.dataTransfer.setDragImage(img, 0, 0);
	      if (presto) img.parentNode.removeChild(img);
	    }
	  }
	
	  function onDragOver(cm, e) {
	    var pos = posFromMouse(cm, e);
	    if (!pos) return;
	    var frag = document.createDocumentFragment();
	    drawSelectionCursor(cm, pos, frag);
	    if (!cm.display.dragCursor) {
	      cm.display.dragCursor = elt("div", null, "CodeMirror-cursors CodeMirror-dragcursors");
	      cm.display.lineSpace.insertBefore(cm.display.dragCursor, cm.display.cursorDiv);
	    }
	    removeChildrenAndAdd(cm.display.dragCursor, frag);
	  }
	
	  function clearDragCursor(cm) {
	    if (cm.display.dragCursor) {
	      cm.display.lineSpace.removeChild(cm.display.dragCursor);
	      cm.display.dragCursor = null;
	    }
	  }
	
	  // SCROLL EVENTS
	
	  // Sync the scrollable area and scrollbars, ensure the viewport
	  // covers the visible area.
	  function setScrollTop(cm, val) {
	    if (Math.abs(cm.doc.scrollTop - val) < 2) return;
	    cm.doc.scrollTop = val;
	    if (!gecko) updateDisplaySimple(cm, {top: val});
	    if (cm.display.scroller.scrollTop != val) cm.display.scroller.scrollTop = val;
	    cm.display.scrollbars.setScrollTop(val);
	    if (gecko) updateDisplaySimple(cm);
	    startWorker(cm, 100);
	  }
	  // Sync scroller and scrollbar, ensure the gutter elements are
	  // aligned.
	  function setScrollLeft(cm, val, isScroller) {
	    if (isScroller ? val == cm.doc.scrollLeft : Math.abs(cm.doc.scrollLeft - val) < 2) return;
	    val = Math.min(val, cm.display.scroller.scrollWidth - cm.display.scroller.clientWidth);
	    cm.doc.scrollLeft = val;
	    alignHorizontally(cm);
	    if (cm.display.scroller.scrollLeft != val) cm.display.scroller.scrollLeft = val;
	    cm.display.scrollbars.setScrollLeft(val);
	  }
	
	  // Since the delta values reported on mouse wheel events are
	  // unstandardized between browsers and even browser versions, and
	  // generally horribly unpredictable, this code starts by measuring
	  // the scroll effect that the first few mouse wheel events have,
	  // and, from that, detects the way it can convert deltas to pixel
	  // offsets afterwards.
	  //
	  // The reason we want to know the amount a wheel event will scroll
	  // is that it gives us a chance to update the display before the
	  // actual scrolling happens, reducing flickering.
	
	  var wheelSamples = 0, wheelPixelsPerUnit = null;
	  // Fill in a browser-detected starting value on browsers where we
	  // know one. These don't have to be accurate -- the result of them
	  // being wrong would just be a slight flicker on the first wheel
	  // scroll (if it is large enough).
	  if (ie) wheelPixelsPerUnit = -.53;
	  else if (gecko) wheelPixelsPerUnit = 15;
	  else if (chrome) wheelPixelsPerUnit = -.7;
	  else if (safari) wheelPixelsPerUnit = -1/3;
	
	  var wheelEventDelta = function(e) {
	    var dx = e.wheelDeltaX, dy = e.wheelDeltaY;
	    if (dx == null && e.detail && e.axis == e.HORIZONTAL_AXIS) dx = e.detail;
	    if (dy == null && e.detail && e.axis == e.VERTICAL_AXIS) dy = e.detail;
	    else if (dy == null) dy = e.wheelDelta;
	    return {x: dx, y: dy};
	  };
	  CodeMirror.wheelEventPixels = function(e) {
	    var delta = wheelEventDelta(e);
	    delta.x *= wheelPixelsPerUnit;
	    delta.y *= wheelPixelsPerUnit;
	    return delta;
	  };
	
	  function onScrollWheel(cm, e) {
	    var delta = wheelEventDelta(e), dx = delta.x, dy = delta.y;
	
	    var display = cm.display, scroll = display.scroller;
	    // Quit if there's nothing to scroll here
	    var canScrollX = scroll.scrollWidth > scroll.clientWidth;
	    var canScrollY = scroll.scrollHeight > scroll.clientHeight;
	    if (!(dx && canScrollX || dy && canScrollY)) return;
	
	    // Webkit browsers on OS X abort momentum scrolls when the target
	    // of the scroll event is removed from the scrollable element.
	    // This hack (see related code in patchDisplay) makes sure the
	    // element is kept around.
	    if (dy && mac && webkit) {
	      outer: for (var cur = e.target, view = display.view; cur != scroll; cur = cur.parentNode) {
	        for (var i = 0; i < view.length; i++) {
	          if (view[i].node == cur) {
	            cm.display.currentWheelTarget = cur;
	            break outer;
	          }
	        }
	      }
	    }
	
	    // On some browsers, horizontal scrolling will cause redraws to
	    // happen before the gutter has been realigned, causing it to
	    // wriggle around in a most unseemly way. When we have an
	    // estimated pixels/delta value, we just handle horizontal
	    // scrolling entirely here. It'll be slightly off from native, but
	    // better than glitching out.
	    if (dx && !gecko && !presto && wheelPixelsPerUnit != null) {
	      if (dy && canScrollY)
	        setScrollTop(cm, Math.max(0, Math.min(scroll.scrollTop + dy * wheelPixelsPerUnit, scroll.scrollHeight - scroll.clientHeight)));
	      setScrollLeft(cm, Math.max(0, Math.min(scroll.scrollLeft + dx * wheelPixelsPerUnit, scroll.scrollWidth - scroll.clientWidth)));
	      // Only prevent default scrolling if vertical scrolling is
	      // actually possible. Otherwise, it causes vertical scroll
	      // jitter on OSX trackpads when deltaX is small and deltaY
	      // is large (issue #3579)
	      if (!dy || (dy && canScrollY))
	        e_preventDefault(e);
	      display.wheelStartX = null; // Abort measurement, if in progress
	      return;
	    }
	
	    // 'Project' the visible viewport to cover the area that is being
	    // scrolled into view (if we know enough to estimate it).
	    if (dy && wheelPixelsPerUnit != null) {
	      var pixels = dy * wheelPixelsPerUnit;
	      var top = cm.doc.scrollTop, bot = top + display.wrapper.clientHeight;
	      if (pixels < 0) top = Math.max(0, top + pixels - 50);
	      else bot = Math.min(cm.doc.height, bot + pixels + 50);
	      updateDisplaySimple(cm, {top: top, bottom: bot});
	    }
	
	    if (wheelSamples < 20) {
	      if (display.wheelStartX == null) {
	        display.wheelStartX = scroll.scrollLeft; display.wheelStartY = scroll.scrollTop;
	        display.wheelDX = dx; display.wheelDY = dy;
	        setTimeout(function() {
	          if (display.wheelStartX == null) return;
	          var movedX = scroll.scrollLeft - display.wheelStartX;
	          var movedY = scroll.scrollTop - display.wheelStartY;
	          var sample = (movedY && display.wheelDY && movedY / display.wheelDY) ||
	            (movedX && display.wheelDX && movedX / display.wheelDX);
	          display.wheelStartX = display.wheelStartY = null;
	          if (!sample) return;
	          wheelPixelsPerUnit = (wheelPixelsPerUnit * wheelSamples + sample) / (wheelSamples + 1);
	          ++wheelSamples;
	        }, 200);
	      } else {
	        display.wheelDX += dx; display.wheelDY += dy;
	      }
	    }
	  }
	
	  // KEY EVENTS
	
	  // Run a handler that was bound to a key.
	  function doHandleBinding(cm, bound, dropShift) {
	    if (typeof bound == "string") {
	      bound = commands[bound];
	      if (!bound) return false;
	    }
	    // Ensure previous input has been read, so that the handler sees a
	    // consistent view of the document
	    cm.display.input.ensurePolled();
	    var prevShift = cm.display.shift, done = false;
	    try {
	      if (cm.isReadOnly()) cm.state.suppressEdits = true;
	      if (dropShift) cm.display.shift = false;
	      done = bound(cm) != Pass;
	    } finally {
	      cm.display.shift = prevShift;
	      cm.state.suppressEdits = false;
	    }
	    return done;
	  }
	
	  function lookupKeyForEditor(cm, name, handle) {
	    for (var i = 0; i < cm.state.keyMaps.length; i++) {
	      var result = lookupKey(name, cm.state.keyMaps[i], handle, cm);
	      if (result) return result;
	    }
	    return (cm.options.extraKeys && lookupKey(name, cm.options.extraKeys, handle, cm))
	      || lookupKey(name, cm.options.keyMap, handle, cm);
	  }
	
	  var stopSeq = new Delayed;
	  function dispatchKey(cm, name, e, handle) {
	    var seq = cm.state.keySeq;
	    if (seq) {
	      if (isModifierKey(name)) return "handled";
	      stopSeq.set(50, function() {
	        if (cm.state.keySeq == seq) {
	          cm.state.keySeq = null;
	          cm.display.input.reset();
	        }
	      });
	      name = seq + " " + name;
	    }
	    var result = lookupKeyForEditor(cm, name, handle);
	
	    if (result == "multi")
	      cm.state.keySeq = name;
	    if (result == "handled")
	      signalLater(cm, "keyHandled", cm, name, e);
	
	    if (result == "handled" || result == "multi") {
	      e_preventDefault(e);
	      restartBlink(cm);
	    }
	
	    if (seq && !result && /\'$/.test(name)) {
	      e_preventDefault(e);
	      return true;
	    }
	    return !!result;
	  }
	
	  // Handle a key from the keydown event.
	  function handleKeyBinding(cm, e) {
	    var name = keyName(e, true);
	    if (!name) return false;
	
	    if (e.shiftKey && !cm.state.keySeq) {
	      // First try to resolve full name (including 'Shift-'). Failing
	      // that, see if there is a cursor-motion command (starting with
	      // 'go') bound to the keyname without 'Shift-'.
	      return dispatchKey(cm, "Shift-" + name, e, function(b) {return doHandleBinding(cm, b, true);})
	          || dispatchKey(cm, name, e, function(b) {
	               if (typeof b == "string" ? /^go[A-Z]/.test(b) : b.motion)
	                 return doHandleBinding(cm, b);
	             });
	    } else {
	      return dispatchKey(cm, name, e, function(b) { return doHandleBinding(cm, b); });
	    }
	  }
	
	  // Handle a key from the keypress event
	  function handleCharBinding(cm, e, ch) {
	    return dispatchKey(cm, "'" + ch + "'", e,
	                       function(b) { return doHandleBinding(cm, b, true); });
	  }
	
	  var lastStoppedKey = null;
	  function onKeyDown(e) {
	    var cm = this;
	    cm.curOp.focus = activeElt();
	    if (signalDOMEvent(cm, e)) return;
	    // IE does strange things with escape.
	    if (ie && ie_version < 11 && e.keyCode == 27) e.returnValue = false;
	    var code = e.keyCode;
	    cm.display.shift = code == 16 || e.shiftKey;
	    var handled = handleKeyBinding(cm, e);
	    if (presto) {
	      lastStoppedKey = handled ? code : null;
	      // Opera has no cut event... we try to at least catch the key combo
	      if (!handled && code == 88 && !hasCopyEvent && (mac ? e.metaKey : e.ctrlKey))
	        cm.replaceSelection("", null, "cut");
	    }
	
	    // Turn mouse into crosshair when Alt is held on Mac.
	    if (code == 18 && !/\bCodeMirror-crosshair\b/.test(cm.display.lineDiv.className))
	      showCrossHair(cm);
	  }
	
	  function showCrossHair(cm) {
	    var lineDiv = cm.display.lineDiv;
	    addClass(lineDiv, "CodeMirror-crosshair");
	
	    function up(e) {
	      if (e.keyCode == 18 || !e.altKey) {
	        rmClass(lineDiv, "CodeMirror-crosshair");
	        off(document, "keyup", up);
	        off(document, "mouseover", up);
	      }
	    }
	    on(document, "keyup", up);
	    on(document, "mouseover", up);
	  }
	
	  function onKeyUp(e) {
	    if (e.keyCode == 16) this.doc.sel.shift = false;
	    signalDOMEvent(this, e);
	  }
	
	  function onKeyPress(e) {
	    var cm = this;
	    if (eventInWidget(cm.display, e) || signalDOMEvent(cm, e) || e.ctrlKey && !e.altKey || mac && e.metaKey) return;
	    var keyCode = e.keyCode, charCode = e.charCode;
	    if (presto && keyCode == lastStoppedKey) {lastStoppedKey = null; e_preventDefault(e); return;}
	    if ((presto && (!e.which || e.which < 10)) && handleKeyBinding(cm, e)) return;
	    var ch = String.fromCharCode(charCode == null ? keyCode : charCode);
	    if (handleCharBinding(cm, e, ch)) return;
	    cm.display.input.onKeyPress(e);
	  }
	
	  // FOCUS/BLUR EVENTS
	
	  function delayBlurEvent(cm) {
	    cm.state.delayingBlurEvent = true;
	    setTimeout(function() {
	      if (cm.state.delayingBlurEvent) {
	        cm.state.delayingBlurEvent = false;
	        onBlur(cm);
	      }
	    }, 100);
	  }
	
	  function onFocus(cm) {
	    if (cm.state.delayingBlurEvent) cm.state.delayingBlurEvent = false;
	
	    if (cm.options.readOnly == "nocursor") return;
	    if (!cm.state.focused) {
	      signal(cm, "focus", cm);
	      cm.state.focused = true;
	      addClass(cm.display.wrapper, "CodeMirror-focused");
	      // This test prevents this from firing when a context
	      // menu is closed (since the input reset would kill the
	      // select-all detection hack)
	      if (!cm.curOp && cm.display.selForContextMenu != cm.doc.sel) {
	        cm.display.input.reset();
	        if (webkit) setTimeout(function() { cm.display.input.reset(true); }, 20); // Issue #1730
	      }
	      cm.display.input.receivedFocus();
	    }
	    restartBlink(cm);
	  }
	  function onBlur(cm) {
	    if (cm.state.delayingBlurEvent) return;
	
	    if (cm.state.focused) {
	      signal(cm, "blur", cm);
	      cm.state.focused = false;
	      rmClass(cm.display.wrapper, "CodeMirror-focused");
	    }
	    clearInterval(cm.display.blinker);
	    setTimeout(function() {if (!cm.state.focused) cm.display.shift = false;}, 150);
	  }
	
	  // CONTEXT MENU HANDLING
	
	  // To make the context menu work, we need to briefly unhide the
	  // textarea (making it as unobtrusive as possible) to let the
	  // right-click take effect on it.
	  function onContextMenu(cm, e) {
	    if (eventInWidget(cm.display, e) || contextMenuInGutter(cm, e)) return;
	    if (signalDOMEvent(cm, e, "contextmenu")) return;
	    cm.display.input.onContextMenu(e);
	  }
	
	  function contextMenuInGutter(cm, e) {
	    if (!hasHandler(cm, "gutterContextMenu")) return false;
	    return gutterEvent(cm, e, "gutterContextMenu", false);
	  }
	
	  // UPDATING
	
	  // Compute the position of the end of a change (its 'to' property
	  // refers to the pre-change end).
	  var changeEnd = CodeMirror.changeEnd = function(change) {
	    if (!change.text) return change.to;
	    return Pos(change.from.line + change.text.length - 1,
	               lst(change.text).length + (change.text.length == 1 ? change.from.ch : 0));
	  };
	
	  // Adjust a position to refer to the post-change position of the
	  // same text, or the end of the change if the change covers it.
	  function adjustForChange(pos, change) {
	    if (cmp(pos, change.from) < 0) return pos;
	    if (cmp(pos, change.to) <= 0) return changeEnd(change);
	
	    var line = pos.line + change.text.length - (change.to.line - change.from.line) - 1, ch = pos.ch;
	    if (pos.line == change.to.line) ch += changeEnd(change).ch - change.to.ch;
	    return Pos(line, ch);
	  }
	
	  function computeSelAfterChange(doc, change) {
	    var out = [];
	    for (var i = 0; i < doc.sel.ranges.length; i++) {
	      var range = doc.sel.ranges[i];
	      out.push(new Range(adjustForChange(range.anchor, change),
	                         adjustForChange(range.head, change)));
	    }
	    return normalizeSelection(out, doc.sel.primIndex);
	  }
	
	  function offsetPos(pos, old, nw) {
	    if (pos.line == old.line)
	      return Pos(nw.line, pos.ch - old.ch + nw.ch);
	    else
	      return Pos(nw.line + (pos.line - old.line), pos.ch);
	  }
	
	  // Used by replaceSelections to allow moving the selection to the
	  // start or around the replaced test. Hint may be "start" or "around".
	  function computeReplacedSel(doc, changes, hint) {
	    var out = [];
	    var oldPrev = Pos(doc.first, 0), newPrev = oldPrev;
	    for (var i = 0; i < changes.length; i++) {
	      var change = changes[i];
	      var from = offsetPos(change.from, oldPrev, newPrev);
	      var to = offsetPos(changeEnd(change), oldPrev, newPrev);
	      oldPrev = change.to;
	      newPrev = to;
	      if (hint == "around") {
	        var range = doc.sel.ranges[i], inv = cmp(range.head, range.anchor) < 0;
	        out[i] = new Range(inv ? to : from, inv ? from : to);
	      } else {
	        out[i] = new Range(from, from);
	      }
	    }
	    return new Selection(out, doc.sel.primIndex);
	  }
	
	  // Allow "beforeChange" event handlers to influence a change
	  function filterChange(doc, change, update) {
	    var obj = {
	      canceled: false,
	      from: change.from,
	      to: change.to,
	      text: change.text,
	      origin: change.origin,
	      cancel: function() { this.canceled = true; }
	    };
	    if (update) obj.update = function(from, to, text, origin) {
	      if (from) this.from = clipPos(doc, from);
	      if (to) this.to = clipPos(doc, to);
	      if (text) this.text = text;
	      if (origin !== undefined) this.origin = origin;
	    };
	    signal(doc, "beforeChange", doc, obj);
	    if (doc.cm) signal(doc.cm, "beforeChange", doc.cm, obj);
	
	    if (obj.canceled) return null;
	    return {from: obj.from, to: obj.to, text: obj.text, origin: obj.origin};
	  }
	
	  // Apply a change to a document, and add it to the document's
	  // history, and propagating it to all linked documents.
	  function makeChange(doc, change, ignoreReadOnly) {
	    if (doc.cm) {
	      if (!doc.cm.curOp) return operation(doc.cm, makeChange)(doc, change, ignoreReadOnly);
	      if (doc.cm.state.suppressEdits) return;
	    }
	
	    if (hasHandler(doc, "beforeChange") || doc.cm && hasHandler(doc.cm, "beforeChange")) {
	      change = filterChange(doc, change, true);
	      if (!change) return;
	    }
	
	    // Possibly split or suppress the update based on the presence
	    // of read-only spans in its range.
	    var split = sawReadOnlySpans && !ignoreReadOnly && removeReadOnlyRanges(doc, change.from, change.to);
	    if (split) {
	      for (var i = split.length - 1; i >= 0; --i)
	        makeChangeInner(doc, {from: split[i].from, to: split[i].to, text: i ? [""] : change.text});
	    } else {
	      makeChangeInner(doc, change);
	    }
	  }
	
	  function makeChangeInner(doc, change) {
	    if (change.text.length == 1 && change.text[0] == "" && cmp(change.from, change.to) == 0) return;
	    var selAfter = computeSelAfterChange(doc, change);
	    addChangeToHistory(doc, change, selAfter, doc.cm ? doc.cm.curOp.id : NaN);
	
	    makeChangeSingleDoc(doc, change, selAfter, stretchSpansOverChange(doc, change));
	    var rebased = [];
	
	    linkedDocs(doc, function(doc, sharedHist) {
	      if (!sharedHist && indexOf(rebased, doc.history) == -1) {
	        rebaseHist(doc.history, change);
	        rebased.push(doc.history);
	      }
	      makeChangeSingleDoc(doc, change, null, stretchSpansOverChange(doc, change));
	    });
	  }
	
	  // Revert a change stored in a document's history.
	  function makeChangeFromHistory(doc, type, allowSelectionOnly) {
	    if (doc.cm && doc.cm.state.suppressEdits && !allowSelectionOnly) return;
	
	    var hist = doc.history, event, selAfter = doc.sel;
	    var source = type == "undo" ? hist.done : hist.undone, dest = type == "undo" ? hist.undone : hist.done;
	
	    // Verify that there is a useable event (so that ctrl-z won't
	    // needlessly clear selection events)
	    for (var i = 0; i < source.length; i++) {
	      event = source[i];
	      if (allowSelectionOnly ? event.ranges && !event.equals(doc.sel) : !event.ranges)
	        break;
	    }
	    if (i == source.length) return;
	    hist.lastOrigin = hist.lastSelOrigin = null;
	
	    for (;;) {
	      event = source.pop();
	      if (event.ranges) {
	        pushSelectionToHistory(event, dest);
	        if (allowSelectionOnly && !event.equals(doc.sel)) {
	          setSelection(doc, event, {clearRedo: false});
	          return;
	        }
	        selAfter = event;
	      }
	      else break;
	    }
	
	    // Build up a reverse change object to add to the opposite history
	    // stack (redo when undoing, and vice versa).
	    var antiChanges = [];
	    pushSelectionToHistory(selAfter, dest);
	    dest.push({changes: antiChanges, generation: hist.generation});
	    hist.generation = event.generation || ++hist.maxGeneration;
	
	    var filter = hasHandler(doc, "beforeChange") || doc.cm && hasHandler(doc.cm, "beforeChange");
	
	    for (var i = event.changes.length - 1; i >= 0; --i) {
	      var change = event.changes[i];
	      change.origin = type;
	      if (filter && !filterChange(doc, change, false)) {
	        source.length = 0;
	        return;
	      }
	
	      antiChanges.push(historyChangeFromChange(doc, change));
	
	      var after = i ? computeSelAfterChange(doc, change) : lst(source);
	      makeChangeSingleDoc(doc, change, after, mergeOldSpans(doc, change));
	      if (!i && doc.cm) doc.cm.scrollIntoView({from: change.from, to: changeEnd(change)});
	      var rebased = [];
	
	      // Propagate to the linked documents
	      linkedDocs(doc, function(doc, sharedHist) {
	        if (!sharedHist && indexOf(rebased, doc.history) == -1) {
	          rebaseHist(doc.history, change);
	          rebased.push(doc.history);
	        }
	        makeChangeSingleDoc(doc, change, null, mergeOldSpans(doc, change));
	      });
	    }
	  }
	
	  // Sub-views need their line numbers shifted when text is added
	  // above or below them in the parent document.
	  function shiftDoc(doc, distance) {
	    if (distance == 0) return;
	    doc.first += distance;
	    doc.sel = new Selection(map(doc.sel.ranges, function(range) {
	      return new Range(Pos(range.anchor.line + distance, range.anchor.ch),
	                       Pos(range.head.line + distance, range.head.ch));
	    }), doc.sel.primIndex);
	    if (doc.cm) {
	      regChange(doc.cm, doc.first, doc.first - distance, distance);
	      for (var d = doc.cm.display, l = d.viewFrom; l < d.viewTo; l++)
	        regLineChange(doc.cm, l, "gutter");
	    }
	  }
	
	  // More lower-level change function, handling only a single document
	  // (not linked ones).
	  function makeChangeSingleDoc(doc, change, selAfter, spans) {
	    if (doc.cm && !doc.cm.curOp)
	      return operation(doc.cm, makeChangeSingleDoc)(doc, change, selAfter, spans);
	
	    if (change.to.line < doc.first) {
	      shiftDoc(doc, change.text.length - 1 - (change.to.line - change.from.line));
	      return;
	    }
	    if (change.from.line > doc.lastLine()) return;
	
	    // Clip the change to the size of this doc
	    if (change.from.line < doc.first) {
	      var shift = change.text.length - 1 - (doc.first - change.from.line);
	      shiftDoc(doc, shift);
	      change = {from: Pos(doc.first, 0), to: Pos(change.to.line + shift, change.to.ch),
	                text: [lst(change.text)], origin: change.origin};
	    }
	    var last = doc.lastLine();
	    if (change.to.line > last) {
	      change = {from: change.from, to: Pos(last, getLine(doc, last).text.length),
	                text: [change.text[0]], origin: change.origin};
	    }
	
	    change.removed = getBetween(doc, change.from, change.to);
	
	    if (!selAfter) selAfter = computeSelAfterChange(doc, change);
	    if (doc.cm) makeChangeSingleDocInEditor(doc.cm, change, spans);
	    else updateDoc(doc, change, spans);
	    setSelectionNoUndo(doc, selAfter, sel_dontScroll);
	  }
	
	  // Handle the interaction of a change to a document with the editor
	  // that this document is part of.
	  function makeChangeSingleDocInEditor(cm, change, spans) {
	    var doc = cm.doc, display = cm.display, from = change.from, to = change.to;
	
	    var recomputeMaxLength = false, checkWidthStart = from.line;
	    if (!cm.options.lineWrapping) {
	      checkWidthStart = lineNo(visualLine(getLine(doc, from.line)));
	      doc.iter(checkWidthStart, to.line + 1, function(line) {
	        if (line == display.maxLine) {
	          recomputeMaxLength = true;
	          return true;
	        }
	      });
	    }
	
	    if (doc.sel.contains(change.from, change.to) > -1)
	      signalCursorActivity(cm);
	
	    updateDoc(doc, change, spans, estimateHeight(cm));
	
	    if (!cm.options.lineWrapping) {
	      doc.iter(checkWidthStart, from.line + change.text.length, function(line) {
	        var len = lineLength(line);
	        if (len > display.maxLineLength) {
	          display.maxLine = line;
	          display.maxLineLength = len;
	          display.maxLineChanged = true;
	          recomputeMaxLength = false;
	        }
	      });
	      if (recomputeMaxLength) cm.curOp.updateMaxLine = true;
	    }
	
	    // Adjust frontier, schedule worker
	    doc.frontier = Math.min(doc.frontier, from.line);
	    startWorker(cm, 400);
	
	    var lendiff = change.text.length - (to.line - from.line) - 1;
	    // Remember that these lines changed, for updating the display
	    if (change.full)
	      regChange(cm);
	    else if (from.line == to.line && change.text.length == 1 && !isWholeLineUpdate(cm.doc, change))
	      regLineChange(cm, from.line, "text");
	    else
	      regChange(cm, from.line, to.line + 1, lendiff);
	
	    var changesHandler = hasHandler(cm, "changes"), changeHandler = hasHandler(cm, "change");
	    if (changeHandler || changesHandler) {
	      var obj = {
	        from: from, to: to,
	        text: change.text,
	        removed: change.removed,
	        origin: change.origin
	      };
	      if (changeHandler) signalLater(cm, "change", cm, obj);
	      if (changesHandler) (cm.curOp.changeObjs || (cm.curOp.changeObjs = [])).push(obj);
	    }
	    cm.display.selForContextMenu = null;
	  }
	
	  function replaceRange(doc, code, from, to, origin) {
	    if (!to) to = from;
	    if (cmp(to, from) < 0) { var tmp = to; to = from; from = tmp; }
	    if (typeof code == "string") code = doc.splitLines(code);
	    makeChange(doc, {from: from, to: to, text: code, origin: origin});
	  }
	
	  // SCROLLING THINGS INTO VIEW
	
	  // If an editor sits on the top or bottom of the window, partially
	  // scrolled out of view, this ensures that the cursor is visible.
	  function maybeScrollWindow(cm, coords) {
	    if (signalDOMEvent(cm, "scrollCursorIntoView")) return;
	
	    var display = cm.display, box = display.sizer.getBoundingClientRect(), doScroll = null;
	    if (coords.top + box.top < 0) doScroll = true;
	    else if (coords.bottom + box.top > (window.innerHeight || document.documentElement.clientHeight)) doScroll = false;
	    if (doScroll != null && !phantom) {
	      var scrollNode = elt("div", "\u200b", null, "position: absolute; top: " +
	                           (coords.top - display.viewOffset - paddingTop(cm.display)) + "px; height: " +
	                           (coords.bottom - coords.top + scrollGap(cm) + display.barHeight) + "px; left: " +
	                           coords.left + "px; width: 2px;");
	      cm.display.lineSpace.appendChild(scrollNode);
	      scrollNode.scrollIntoView(doScroll);
	      cm.display.lineSpace.removeChild(scrollNode);
	    }
	  }
	
	  // Scroll a given position into view (immediately), verifying that
	  // it actually became visible (as line heights are accurately
	  // measured, the position of something may 'drift' during drawing).
	  function scrollPosIntoView(cm, pos, end, margin) {
	    if (margin == null) margin = 0;
	    for (var limit = 0; limit < 5; limit++) {
	      var changed = false, coords = cursorCoords(cm, pos);
	      var endCoords = !end || end == pos ? coords : cursorCoords(cm, end);
	      var scrollPos = calculateScrollPos(cm, Math.min(coords.left, endCoords.left),
	                                         Math.min(coords.top, endCoords.top) - margin,
	                                         Math.max(coords.left, endCoords.left),
	                                         Math.max(coords.bottom, endCoords.bottom) + margin);
	      var startTop = cm.doc.scrollTop, startLeft = cm.doc.scrollLeft;
	      if (scrollPos.scrollTop != null) {
	        setScrollTop(cm, scrollPos.scrollTop);
	        if (Math.abs(cm.doc.scrollTop - startTop) > 1) changed = true;
	      }
	      if (scrollPos.scrollLeft != null) {
	        setScrollLeft(cm, scrollPos.scrollLeft);
	        if (Math.abs(cm.doc.scrollLeft - startLeft) > 1) changed = true;
	      }
	      if (!changed) break;
	    }
	    return coords;
	  }
	
	  // Scroll a given set of coordinates into view (immediately).
	  function scrollIntoView(cm, x1, y1, x2, y2) {
	    var scrollPos = calculateScrollPos(cm, x1, y1, x2, y2);
	    if (scrollPos.scrollTop != null) setScrollTop(cm, scrollPos.scrollTop);
	    if (scrollPos.scrollLeft != null) setScrollLeft(cm, scrollPos.scrollLeft);
	  }
	
	  // Calculate a new scroll position needed to scroll the given
	  // rectangle into view. Returns an object with scrollTop and
	  // scrollLeft properties. When these are undefined, the
	  // vertical/horizontal position does not need to be adjusted.
	  function calculateScrollPos(cm, x1, y1, x2, y2) {
	    var display = cm.display, snapMargin = textHeight(cm.display);
	    if (y1 < 0) y1 = 0;
	    var screentop = cm.curOp && cm.curOp.scrollTop != null ? cm.curOp.scrollTop : display.scroller.scrollTop;
	    var screen = displayHeight(cm), result = {};
	    if (y2 - y1 > screen) y2 = y1 + screen;
	    var docBottom = cm.doc.height + paddingVert(display);
	    var atTop = y1 < snapMargin, atBottom = y2 > docBottom - snapMargin;
	    if (y1 < screentop) {
	      result.scrollTop = atTop ? 0 : y1;
	    } else if (y2 > screentop + screen) {
	      var newTop = Math.min(y1, (atBottom ? docBottom : y2) - screen);
	      if (newTop != screentop) result.scrollTop = newTop;
	    }
	
	    var screenleft = cm.curOp && cm.curOp.scrollLeft != null ? cm.curOp.scrollLeft : display.scroller.scrollLeft;
	    var screenw = displayWidth(cm) - (cm.options.fixedGutter ? display.gutters.offsetWidth : 0);
	    var tooWide = x2 - x1 > screenw;
	    if (tooWide) x2 = x1 + screenw;
	    if (x1 < 10)
	      result.scrollLeft = 0;
	    else if (x1 < screenleft)
	      result.scrollLeft = Math.max(0, x1 - (tooWide ? 0 : 10));
	    else if (x2 > screenw + screenleft - 3)
	      result.scrollLeft = x2 + (tooWide ? 0 : 10) - screenw;
	    return result;
	  }
	
	  // Store a relative adjustment to the scroll position in the current
	  // operation (to be applied when the operation finishes).
	  function addToScrollPos(cm, left, top) {
	    if (left != null || top != null) resolveScrollToPos(cm);
	    if (left != null)
	      cm.curOp.scrollLeft = (cm.curOp.scrollLeft == null ? cm.doc.scrollLeft : cm.curOp.scrollLeft) + left;
	    if (top != null)
	      cm.curOp.scrollTop = (cm.curOp.scrollTop == null ? cm.doc.scrollTop : cm.curOp.scrollTop) + top;
	  }
	
	  // Make sure that at the end of the operation the current cursor is
	  // shown.
	  function ensureCursorVisible(cm) {
	    resolveScrollToPos(cm);
	    var cur = cm.getCursor(), from = cur, to = cur;
	    if (!cm.options.lineWrapping) {
	      from = cur.ch ? Pos(cur.line, cur.ch - 1) : cur;
	      to = Pos(cur.line, cur.ch + 1);
	    }
	    cm.curOp.scrollToPos = {from: from, to: to, margin: cm.options.cursorScrollMargin, isCursor: true};
	  }
	
	  // When an operation has its scrollToPos property set, and another
	  // scroll action is applied before the end of the operation, this
	  // 'simulates' scrolling that position into view in a cheap way, so
	  // that the effect of intermediate scroll commands is not ignored.
	  function resolveScrollToPos(cm) {
	    var range = cm.curOp.scrollToPos;
	    if (range) {
	      cm.curOp.scrollToPos = null;
	      var from = estimateCoords(cm, range.from), to = estimateCoords(cm, range.to);
	      var sPos = calculateScrollPos(cm, Math.min(from.left, to.left),
	                                    Math.min(from.top, to.top) - range.margin,
	                                    Math.max(from.right, to.right),
	                                    Math.max(from.bottom, to.bottom) + range.margin);
	      cm.scrollTo(sPos.scrollLeft, sPos.scrollTop);
	    }
	  }
	
	  // API UTILITIES
	
	  // Indent the given line. The how parameter can be "smart",
	  // "add"/null, "subtract", or "prev". When aggressive is false
	  // (typically set to true for forced single-line indents), empty
	  // lines are not indented, and places where the mode returns Pass
	  // are left alone.
	  function indentLine(cm, n, how, aggressive) {
	    var doc = cm.doc, state;
	    if (how == null) how = "add";
	    if (how == "smart") {
	      // Fall back to "prev" when the mode doesn't have an indentation
	      // method.
	      if (!doc.mode.indent) how = "prev";
	      else state = getStateBefore(cm, n);
	    }
	
	    var tabSize = cm.options.tabSize;
	    var line = getLine(doc, n), curSpace = countColumn(line.text, null, tabSize);
	    if (line.stateAfter) line.stateAfter = null;
	    var curSpaceString = line.text.match(/^\s*/)[0], indentation;
	    if (!aggressive && !/\S/.test(line.text)) {
	      indentation = 0;
	      how = "not";
	    } else if (how == "smart") {
	      indentation = doc.mode.indent(state, line.text.slice(curSpaceString.length), line.text);
	      if (indentation == Pass || indentation > 150) {
	        if (!aggressive) return;
	        how = "prev";
	      }
	    }
	    if (how == "prev") {
	      if (n > doc.first) indentation = countColumn(getLine(doc, n-1).text, null, tabSize);
	      else indentation = 0;
	    } else if (how == "add") {
	      indentation = curSpace + cm.options.indentUnit;
	    } else if (how == "subtract") {
	      indentation = curSpace - cm.options.indentUnit;
	    } else if (typeof how == "number") {
	      indentation = curSpace + how;
	    }
	    indentation = Math.max(0, indentation);
	
	    var indentString = "", pos = 0;
	    if (cm.options.indentWithTabs)
	      for (var i = Math.floor(indentation / tabSize); i; --i) {pos += tabSize; indentString += "\t";}
	    if (pos < indentation) indentString += spaceStr(indentation - pos);
	
	    if (indentString != curSpaceString) {
	      replaceRange(doc, indentString, Pos(n, 0), Pos(n, curSpaceString.length), "+input");
	      line.stateAfter = null;
	      return true;
	    } else {
	      // Ensure that, if the cursor was in the whitespace at the start
	      // of the line, it is moved to the end of that space.
	      for (var i = 0; i < doc.sel.ranges.length; i++) {
	        var range = doc.sel.ranges[i];
	        if (range.head.line == n && range.head.ch < curSpaceString.length) {
	          var pos = Pos(n, curSpaceString.length);
	          replaceOneSelection(doc, i, new Range(pos, pos));
	          break;
	        }
	      }
	    }
	  }
	
	  // Utility for applying a change to a line by handle or number,
	  // returning the number and optionally registering the line as
	  // changed.
	  function changeLine(doc, handle, changeType, op) {
	    var no = handle, line = handle;
	    if (typeof handle == "number") line = getLine(doc, clipLine(doc, handle));
	    else no = lineNo(handle);
	    if (no == null) return null;
	    if (op(line, no) && doc.cm) regLineChange(doc.cm, no, changeType);
	    return line;
	  }
	
	  // Helper for deleting text near the selection(s), used to implement
	  // backspace, delete, and similar functionality.
	  function deleteNearSelection(cm, compute) {
	    var ranges = cm.doc.sel.ranges, kill = [];
	    // Build up a set of ranges to kill first, merging overlapping
	    // ranges.
	    for (var i = 0; i < ranges.length; i++) {
	      var toKill = compute(ranges[i]);
	      while (kill.length && cmp(toKill.from, lst(kill).to) <= 0) {
	        var replaced = kill.pop();
	        if (cmp(replaced.from, toKill.from) < 0) {
	          toKill.from = replaced.from;
	          break;
	        }
	      }
	      kill.push(toKill);
	    }
	    // Next, remove those actual ranges.
	    runInOp(cm, function() {
	      for (var i = kill.length - 1; i >= 0; i--)
	        replaceRange(cm.doc, "", kill[i].from, kill[i].to, "+delete");
	      ensureCursorVisible(cm);
	    });
	  }
	
	  // Used for horizontal relative motion. Dir is -1 or 1 (left or
	  // right), unit can be "char", "column" (like char, but doesn't
	  // cross line boundaries), "word" (across next word), or "group" (to
	  // the start of next group of word or non-word-non-whitespace
	  // chars). The visually param controls whether, in right-to-left
	  // text, direction 1 means to move towards the next index in the
	  // string, or towards the character to the right of the current
	  // position. The resulting position will have a hitSide=true
	  // property if it reached the end of the document.
	  function findPosH(doc, pos, dir, unit, visually) {
	    var line = pos.line, ch = pos.ch, origDir = dir;
	    var lineObj = getLine(doc, line);
	    function findNextLine() {
	      var l = line + dir;
	      if (l < doc.first || l >= doc.first + doc.size) return false
	      line = l;
	      return lineObj = getLine(doc, l);
	    }
	    function moveOnce(boundToLine) {
	      var next = (visually ? moveVisually : moveLogically)(lineObj, ch, dir, true);
	      if (next == null) {
	        if (!boundToLine && findNextLine()) {
	          if (visually) ch = (dir < 0 ? lineRight : lineLeft)(lineObj);
	          else ch = dir < 0 ? lineObj.text.length : 0;
	        } else return false
	      } else ch = next;
	      return true;
	    }
	
	    if (unit == "char") {
	      moveOnce()
	    } else if (unit == "column") {
	      moveOnce(true)
	    } else if (unit == "word" || unit == "group") {
	      var sawType = null, group = unit == "group";
	      var helper = doc.cm && doc.cm.getHelper(pos, "wordChars");
	      for (var first = true;; first = false) {
	        if (dir < 0 && !moveOnce(!first)) break;
	        var cur = lineObj.text.charAt(ch) || "\n";
	        var type = isWordChar(cur, helper) ? "w"
	          : group && cur == "\n" ? "n"
	          : !group || /\s/.test(cur) ? null
	          : "p";
	        if (group && !first && !type) type = "s";
	        if (sawType && sawType != type) {
	          if (dir < 0) {dir = 1; moveOnce();}
	          break;
	        }
	
	        if (type) sawType = type;
	        if (dir > 0 && !moveOnce(!first)) break;
	      }
	    }
	    var result = skipAtomic(doc, Pos(line, ch), pos, origDir, true);
	    if (!cmp(pos, result)) result.hitSide = true;
	    return result;
	  }
	
	  // For relative vertical movement. Dir may be -1 or 1. Unit can be
	  // "page" or "line". The resulting position will have a hitSide=true
	  // property if it reached the end of the document.
	  function findPosV(cm, pos, dir, unit) {
	    var doc = cm.doc, x = pos.left, y;
	    if (unit == "page") {
	      var pageSize = Math.min(cm.display.wrapper.clientHeight, window.innerHeight || document.documentElement.clientHeight);
	      y = pos.top + dir * (pageSize - (dir < 0 ? 1.5 : .5) * textHeight(cm.display));
	    } else if (unit == "line") {
	      y = dir > 0 ? pos.bottom + 3 : pos.top - 3;
	    }
	    for (;;) {
	      var target = coordsChar(cm, x, y);
	      if (!target.outside) break;
	      if (dir < 0 ? y <= 0 : y >= doc.height) { target.hitSide = true; break; }
	      y += dir * 5;
	    }
	    return target;
	  }
	
	  // EDITOR METHODS
	
	  // The publicly visible API. Note that methodOp(f) means
	  // 'wrap f in an operation, performed on its `this` parameter'.
	
	  // This is not the complete set of editor methods. Most of the
	  // methods defined on the Doc type are also injected into
	  // CodeMirror.prototype, for backwards compatibility and
	  // convenience.
	
	  CodeMirror.prototype = {
	    constructor: CodeMirror,
	    focus: function(){window.focus(); this.display.input.focus();},
	
	    setOption: function(option, value) {
	      var options = this.options, old = options[option];
	      if (options[option] == value && option != "mode") return;
	      options[option] = value;
	      if (optionHandlers.hasOwnProperty(option))
	        operation(this, optionHandlers[option])(this, value, old);
	    },
	
	    getOption: function(option) {return this.options[option];},
	    getDoc: function() {return this.doc;},
	
	    addKeyMap: function(map, bottom) {
	      this.state.keyMaps[bottom ? "push" : "unshift"](getKeyMap(map));
	    },
	    removeKeyMap: function(map) {
	      var maps = this.state.keyMaps;
	      for (var i = 0; i < maps.length; ++i)
	        if (maps[i] == map || maps[i].name == map) {
	          maps.splice(i, 1);
	          return true;
	        }
	    },
	
	    addOverlay: methodOp(function(spec, options) {
	      var mode = spec.token ? spec : CodeMirror.getMode(this.options, spec);
	      if (mode.startState) throw new Error("Overlays may not be stateful.");
	      insertSorted(this.state.overlays,
	                   {mode: mode, modeSpec: spec, opaque: options && options.opaque,
	                    priority: (options && options.priority) || 0},
	                   function(overlay) { return overlay.priority })
	      this.state.modeGen++;
	      regChange(this);
	    }),
	    removeOverlay: methodOp(function(spec) {
	      var overlays = this.state.overlays;
	      for (var i = 0; i < overlays.length; ++i) {
	        var cur = overlays[i].modeSpec;
	        if (cur == spec || typeof spec == "string" && cur.name == spec) {
	          overlays.splice(i, 1);
	          this.state.modeGen++;
	          regChange(this);
	          return;
	        }
	      }
	    }),
	
	    indentLine: methodOp(function(n, dir, aggressive) {
	      if (typeof dir != "string" && typeof dir != "number") {
	        if (dir == null) dir = this.options.smartIndent ? "smart" : "prev";
	        else dir = dir ? "add" : "subtract";
	      }
	      if (isLine(this.doc, n)) indentLine(this, n, dir, aggressive);
	    }),
	    indentSelection: methodOp(function(how) {
	      var ranges = this.doc.sel.ranges, end = -1;
	      for (var i = 0; i < ranges.length; i++) {
	        var range = ranges[i];
	        if (!range.empty()) {
	          var from = range.from(), to = range.to();
	          var start = Math.max(end, from.line);
	          end = Math.min(this.lastLine(), to.line - (to.ch ? 0 : 1)) + 1;
	          for (var j = start; j < end; ++j)
	            indentLine(this, j, how);
	          var newRanges = this.doc.sel.ranges;
	          if (from.ch == 0 && ranges.length == newRanges.length && newRanges[i].from().ch > 0)
	            replaceOneSelection(this.doc, i, new Range(from, newRanges[i].to()), sel_dontScroll);
	        } else if (range.head.line > end) {
	          indentLine(this, range.head.line, how, true);
	          end = range.head.line;
	          if (i == this.doc.sel.primIndex) ensureCursorVisible(this);
	        }
	      }
	    }),
	
	    // Fetch the parser token for a given character. Useful for hacks
	    // that want to inspect the mode state (say, for completion).
	    getTokenAt: function(pos, precise) {
	      return takeToken(this, pos, precise);
	    },
	
	    getLineTokens: function(line, precise) {
	      return takeToken(this, Pos(line), precise, true);
	    },
	
	    getTokenTypeAt: function(pos) {
	      pos = clipPos(this.doc, pos);
	      var styles = getLineStyles(this, getLine(this.doc, pos.line));
	      var before = 0, after = (styles.length - 1) / 2, ch = pos.ch;
	      var type;
	      if (ch == 0) type = styles[2];
	      else for (;;) {
	        var mid = (before + after) >> 1;
	        if ((mid ? styles[mid * 2 - 1] : 0) >= ch) after = mid;
	        else if (styles[mid * 2 + 1] < ch) before = mid + 1;
	        else { type = styles[mid * 2 + 2]; break; }
	      }
	      var cut = type ? type.indexOf("cm-overlay ") : -1;
	      return cut < 0 ? type : cut == 0 ? null : type.slice(0, cut - 1);
	    },
	
	    getModeAt: function(pos) {
	      var mode = this.doc.mode;
	      if (!mode.innerMode) return mode;
	      return CodeMirror.innerMode(mode, this.getTokenAt(pos).state).mode;
	    },
	
	    getHelper: function(pos, type) {
	      return this.getHelpers(pos, type)[0];
	    },
	
	    getHelpers: function(pos, type) {
	      var found = [];
	      if (!helpers.hasOwnProperty(type)) return found;
	      var help = helpers[type], mode = this.getModeAt(pos);
	      if (typeof mode[type] == "string") {
	        if (help[mode[type]]) found.push(help[mode[type]]);
	      } else if (mode[type]) {
	        for (var i = 0; i < mode[type].length; i++) {
	          var val = help[mode[type][i]];
	          if (val) found.push(val);
	        }
	      } else if (mode.helperType && help[mode.helperType]) {
	        found.push(help[mode.helperType]);
	      } else if (help[mode.name]) {
	        found.push(help[mode.name]);
	      }
	      for (var i = 0; i < help._global.length; i++) {
	        var cur = help._global[i];
	        if (cur.pred(mode, this) && indexOf(found, cur.val) == -1)
	          found.push(cur.val);
	      }
	      return found;
	    },
	
	    getStateAfter: function(line, precise) {
	      var doc = this.doc;
	      line = clipLine(doc, line == null ? doc.first + doc.size - 1: line);
	      return getStateBefore(this, line + 1, precise);
	    },
	
	    cursorCoords: function(start, mode) {
	      var pos, range = this.doc.sel.primary();
	      if (start == null) pos = range.head;
	      else if (typeof start == "object") pos = clipPos(this.doc, start);
	      else pos = start ? range.from() : range.to();
	      return cursorCoords(this, pos, mode || "page");
	    },
	
	    charCoords: function(pos, mode) {
	      return charCoords(this, clipPos(this.doc, pos), mode || "page");
	    },
	
	    coordsChar: function(coords, mode) {
	      coords = fromCoordSystem(this, coords, mode || "page");
	      return coordsChar(this, coords.left, coords.top);
	    },
	
	    lineAtHeight: function(height, mode) {
	      height = fromCoordSystem(this, {top: height, left: 0}, mode || "page").top;
	      return lineAtHeight(this.doc, height + this.display.viewOffset);
	    },
	    heightAtLine: function(line, mode) {
	      var end = false, lineObj;
	      if (typeof line == "number") {
	        var last = this.doc.first + this.doc.size - 1;
	        if (line < this.doc.first) line = this.doc.first;
	        else if (line > last) { line = last; end = true; }
	        lineObj = getLine(this.doc, line);
	      } else {
	        lineObj = line;
	      }
	      return intoCoordSystem(this, lineObj, {top: 0, left: 0}, mode || "page").top +
	        (end ? this.doc.height - heightAtLine(lineObj) : 0);
	    },
	
	    defaultTextHeight: function() { return textHeight(this.display); },
	    defaultCharWidth: function() { return charWidth(this.display); },
	
	    setGutterMarker: methodOp(function(line, gutterID, value) {
	      return changeLine(this.doc, line, "gutter", function(line) {
	        var markers = line.gutterMarkers || (line.gutterMarkers = {});
	        markers[gutterID] = value;
	        if (!value && isEmpty(markers)) line.gutterMarkers = null;
	        return true;
	      });
	    }),
	
	    clearGutter: methodOp(function(gutterID) {
	      var cm = this, doc = cm.doc, i = doc.first;
	      doc.iter(function(line) {
	        if (line.gutterMarkers && line.gutterMarkers[gutterID]) {
	          line.gutterMarkers[gutterID] = null;
	          regLineChange(cm, i, "gutter");
	          if (isEmpty(line.gutterMarkers)) line.gutterMarkers = null;
	        }
	        ++i;
	      });
	    }),
	
	    lineInfo: function(line) {
	      if (typeof line == "number") {
	        if (!isLine(this.doc, line)) return null;
	        var n = line;
	        line = getLine(this.doc, line);
	        if (!line) return null;
	      } else {
	        var n = lineNo(line);
	        if (n == null) return null;
	      }
	      return {line: n, handle: line, text: line.text, gutterMarkers: line.gutterMarkers,
	              textClass: line.textClass, bgClass: line.bgClass, wrapClass: line.wrapClass,
	              widgets: line.widgets};
	    },
	
	    getViewport: function() { return {from: this.display.viewFrom, to: this.display.viewTo};},
	
	    addWidget: function(pos, node, scroll, vert, horiz) {
	      var display = this.display;
	      pos = cursorCoords(this, clipPos(this.doc, pos));
	      var top = pos.bottom, left = pos.left;
	      node.style.position = "absolute";
	      node.setAttribute("cm-ignore-events", "true");
	      this.display.input.setUneditable(node);
	      display.sizer.appendChild(node);
	      if (vert == "over") {
	        top = pos.top;
	      } else if (vert == "above" || vert == "near") {
	        var vspace = Math.max(display.wrapper.clientHeight, this.doc.height),
	        hspace = Math.max(display.sizer.clientWidth, display.lineSpace.clientWidth);
	        // Default to positioning above (if specified and possible); otherwise default to positioning below
	        if ((vert == 'above' || pos.bottom + node.offsetHeight > vspace) && pos.top > node.offsetHeight)
	          top = pos.top - node.offsetHeight;
	        else if (pos.bottom + node.offsetHeight <= vspace)
	          top = pos.bottom;
	        if (left + node.offsetWidth > hspace)
	          left = hspace - node.offsetWidth;
	      }
	      node.style.top = top + "px";
	      node.style.left = node.style.right = "";
	      if (horiz == "right") {
	        left = display.sizer.clientWidth - node.offsetWidth;
	        node.style.right = "0px";
	      } else {
	        if (horiz == "left") left = 0;
	        else if (horiz == "middle") left = (display.sizer.clientWidth - node.offsetWidth) / 2;
	        node.style.left = left + "px";
	      }
	      if (scroll)
	        scrollIntoView(this, left, top, left + node.offsetWidth, top + node.offsetHeight);
	    },
	
	    triggerOnKeyDown: methodOp(onKeyDown),
	    triggerOnKeyPress: methodOp(onKeyPress),
	    triggerOnKeyUp: onKeyUp,
	
	    execCommand: function(cmd) {
	      if (commands.hasOwnProperty(cmd))
	        return commands[cmd].call(null, this);
	    },
	
	    triggerElectric: methodOp(function(text) { triggerElectric(this, text); }),
	
	    findPosH: function(from, amount, unit, visually) {
	      var dir = 1;
	      if (amount < 0) { dir = -1; amount = -amount; }
	      for (var i = 0, cur = clipPos(this.doc, from); i < amount; ++i) {
	        cur = findPosH(this.doc, cur, dir, unit, visually);
	        if (cur.hitSide) break;
	      }
	      return cur;
	    },
	
	    moveH: methodOp(function(dir, unit) {
	      var cm = this;
	      cm.extendSelectionsBy(function(range) {
	        if (cm.display.shift || cm.doc.extend || range.empty())
	          return findPosH(cm.doc, range.head, dir, unit, cm.options.rtlMoveVisually);
	        else
	          return dir < 0 ? range.from() : range.to();
	      }, sel_move);
	    }),
	
	    deleteH: methodOp(function(dir, unit) {
	      var sel = this.doc.sel, doc = this.doc;
	      if (sel.somethingSelected())
	        doc.replaceSelection("", null, "+delete");
	      else
	        deleteNearSelection(this, function(range) {
	          var other = findPosH(doc, range.head, dir, unit, false);
	          return dir < 0 ? {from: other, to: range.head} : {from: range.head, to: other};
	        });
	    }),
	
	    findPosV: function(from, amount, unit, goalColumn) {
	      var dir = 1, x = goalColumn;
	      if (amount < 0) { dir = -1; amount = -amount; }
	      for (var i = 0, cur = clipPos(this.doc, from); i < amount; ++i) {
	        var coords = cursorCoords(this, cur, "div");
	        if (x == null) x = coords.left;
	        else coords.left = x;
	        cur = findPosV(this, coords, dir, unit);
	        if (cur.hitSide) break;
	      }
	      return cur;
	    },
	
	    moveV: methodOp(function(dir, unit) {
	      var cm = this, doc = this.doc, goals = [];
	      var collapse = !cm.display.shift && !doc.extend && doc.sel.somethingSelected();
	      doc.extendSelectionsBy(function(range) {
	        if (collapse)
	          return dir < 0 ? range.from() : range.to();
	        var headPos = cursorCoords(cm, range.head, "div");
	        if (range.goalColumn != null) headPos.left = range.goalColumn;
	        goals.push(headPos.left);
	        var pos = findPosV(cm, headPos, dir, unit);
	        if (unit == "page" && range == doc.sel.primary())
	          addToScrollPos(cm, null, charCoords(cm, pos, "div").top - headPos.top);
	        return pos;
	      }, sel_move);
	      if (goals.length) for (var i = 0; i < doc.sel.ranges.length; i++)
	        doc.sel.ranges[i].goalColumn = goals[i];
	    }),
	
	    // Find the word at the given position (as returned by coordsChar).
	    findWordAt: function(pos) {
	      var doc = this.doc, line = getLine(doc, pos.line).text;
	      var start = pos.ch, end = pos.ch;
	      if (line) {
	        var helper = this.getHelper(pos, "wordChars");
	        if ((pos.xRel < 0 || end == line.length) && start) --start; else ++end;
	        var startChar = line.charAt(start);
	        var check = isWordChar(startChar, helper)
	          ? function(ch) { return isWordChar(ch, helper); }
	          : /\s/.test(startChar) ? function(ch) {return /\s/.test(ch);}
	          : function(ch) {return !/\s/.test(ch) && !isWordChar(ch);};
	        while (start > 0 && check(line.charAt(start - 1))) --start;
	        while (end < line.length && check(line.charAt(end))) ++end;
	      }
	      return new Range(Pos(pos.line, start), Pos(pos.line, end));
	    },
	
	    toggleOverwrite: function(value) {
	      if (value != null && value == this.state.overwrite) return;
	      if (this.state.overwrite = !this.state.overwrite)
	        addClass(this.display.cursorDiv, "CodeMirror-overwrite");
	      else
	        rmClass(this.display.cursorDiv, "CodeMirror-overwrite");
	
	      signal(this, "overwriteToggle", this, this.state.overwrite);
	    },
	    hasFocus: function() { return this.display.input.getField() == activeElt(); },
	    isReadOnly: function() { return !!(this.options.readOnly || this.doc.cantEdit); },
	
	    scrollTo: methodOp(function(x, y) {
	      if (x != null || y != null) resolveScrollToPos(this);
	      if (x != null) this.curOp.scrollLeft = x;
	      if (y != null) this.curOp.scrollTop = y;
	    }),
	    getScrollInfo: function() {
	      var scroller = this.display.scroller;
	      return {left: scroller.scrollLeft, top: scroller.scrollTop,
	              height: scroller.scrollHeight - scrollGap(this) - this.display.barHeight,
	              width: scroller.scrollWidth - scrollGap(this) - this.display.barWidth,
	              clientHeight: displayHeight(this), clientWidth: displayWidth(this)};
	    },
	
	    scrollIntoView: methodOp(function(range, margin) {
	      if (range == null) {
	        range = {from: this.doc.sel.primary().head, to: null};
	        if (margin == null) margin = this.options.cursorScrollMargin;
	      } else if (typeof range == "number") {
	        range = {from: Pos(range, 0), to: null};
	      } else if (range.from == null) {
	        range = {from: range, to: null};
	      }
	      if (!range.to) range.to = range.from;
	      range.margin = margin || 0;
	
	      if (range.from.line != null) {
	        resolveScrollToPos(this);
	        this.curOp.scrollToPos = range;
	      } else {
	        var sPos = calculateScrollPos(this, Math.min(range.from.left, range.to.left),
	                                      Math.min(range.from.top, range.to.top) - range.margin,
	                                      Math.max(range.from.right, range.to.right),
	                                      Math.max(range.from.bottom, range.to.bottom) + range.margin);
	        this.scrollTo(sPos.scrollLeft, sPos.scrollTop);
	      }
	    }),
	
	    setSize: methodOp(function(width, height) {
	      var cm = this;
	      function interpret(val) {
	        return typeof val == "number" || /^\d+$/.test(String(val)) ? val + "px" : val;
	      }
	      if (width != null) cm.display.wrapper.style.width = interpret(width);
	      if (height != null) cm.display.wrapper.style.height = interpret(height);
	      if (cm.options.lineWrapping) clearLineMeasurementCache(this);
	      var lineNo = cm.display.viewFrom;
	      cm.doc.iter(lineNo, cm.display.viewTo, function(line) {
	        if (line.widgets) for (var i = 0; i < line.widgets.length; i++)
	          if (line.widgets[i].noHScroll) { regLineChange(cm, lineNo, "widget"); break; }
	        ++lineNo;
	      });
	      cm.curOp.forceUpdate = true;
	      signal(cm, "refresh", this);
	    }),
	
	    operation: function(f){return runInOp(this, f);},
	
	    refresh: methodOp(function() {
	      var oldHeight = this.display.cachedTextHeight;
	      regChange(this);
	      this.curOp.forceUpdate = true;
	      clearCaches(this);
	      this.scrollTo(this.doc.scrollLeft, this.doc.scrollTop);
	      updateGutterSpace(this);
	      if (oldHeight == null || Math.abs(oldHeight - textHeight(this.display)) > .5)
	        estimateLineHeights(this);
	      signal(this, "refresh", this);
	    }),
	
	    swapDoc: methodOp(function(doc) {
	      var old = this.doc;
	      old.cm = null;
	      attachDoc(this, doc);
	      clearCaches(this);
	      this.display.input.reset();
	      this.scrollTo(doc.scrollLeft, doc.scrollTop);
	      this.curOp.forceScroll = true;
	      signalLater(this, "swapDoc", this, old);
	      return old;
	    }),
	
	    getInputField: function(){return this.display.input.getField();},
	    getWrapperElement: function(){return this.display.wrapper;},
	    getScrollerElement: function(){return this.display.scroller;},
	    getGutterElement: function(){return this.display.gutters;}
	  };
	  eventMixin(CodeMirror);
	
	  // OPTION DEFAULTS
	
	  // The default configuration options.
	  var defaults = CodeMirror.defaults = {};
	  // Functions to run when options are changed.
	  var optionHandlers = CodeMirror.optionHandlers = {};
	
	  function option(name, deflt, handle, notOnInit) {
	    CodeMirror.defaults[name] = deflt;
	    if (handle) optionHandlers[name] =
	      notOnInit ? function(cm, val, old) {if (old != Init) handle(cm, val, old);} : handle;
	  }
	
	  // Passed to option handlers when there is no old value.
	  var Init = CodeMirror.Init = {toString: function(){return "CodeMirror.Init";}};
	
	  // These two are, on init, called from the constructor because they
	  // have to be initialized before the editor can start at all.
	  option("value", "", function(cm, val) {
	    cm.setValue(val);
	  }, true);
	  option("mode", null, function(cm, val) {
	    cm.doc.modeOption = val;
	    loadMode(cm);
	  }, true);
	
	  option("indentUnit", 2, loadMode, true);
	  option("indentWithTabs", false);
	  option("smartIndent", true);
	  option("tabSize", 4, function(cm) {
	    resetModeState(cm);
	    clearCaches(cm);
	    regChange(cm);
	  }, true);
	  option("lineSeparator", null, function(cm, val) {
	    cm.doc.lineSep = val;
	    if (!val) return;
	    var newBreaks = [], lineNo = cm.doc.first;
	    cm.doc.iter(function(line) {
	      for (var pos = 0;;) {
	        var found = line.text.indexOf(val, pos);
	        if (found == -1) break;
	        pos = found + val.length;
	        newBreaks.push(Pos(lineNo, found));
	      }
	      lineNo++;
	    });
	    for (var i = newBreaks.length - 1; i >= 0; i--)
	      replaceRange(cm.doc, val, newBreaks[i], Pos(newBreaks[i].line, newBreaks[i].ch + val.length))
	  });
	  option("specialChars", /[\u0000-\u001f\u007f\u00ad\u200b-\u200f\u2028\u2029\ufeff]/g, function(cm, val, old) {
	    cm.state.specialChars = new RegExp(val.source + (val.test("\t") ? "" : "|\t"), "g");
	    if (old != CodeMirror.Init) cm.refresh();
	  });
	  option("specialCharPlaceholder", defaultSpecialCharPlaceholder, function(cm) {cm.refresh();}, true);
	  option("electricChars", true);
	  option("inputStyle", mobile ? "contenteditable" : "textarea", function() {
	    throw new Error("inputStyle can not (yet) be changed in a running editor"); // FIXME
	  }, true);
	  option("spellcheck", false, function(cm, val) {
	    cm.getInputField().spellcheck = val
	  }, true);
	  option("rtlMoveVisually", !windows);
	  option("wholeLineUpdateBefore", true);
	
	  option("theme", "default", function(cm) {
	    themeChanged(cm);
	    guttersChanged(cm);
	  }, true);
	  option("keyMap", "default", function(cm, val, old) {
	    var next = getKeyMap(val);
	    var prev = old != CodeMirror.Init && getKeyMap(old);
	    if (prev && prev.detach) prev.detach(cm, next);
	    if (next.attach) next.attach(cm, prev || null);
	  });
	  option("extraKeys", null);
	
	  option("lineWrapping", false, wrappingChanged, true);
	  option("gutters", [], function(cm) {
	    setGuttersForLineNumbers(cm.options);
	    guttersChanged(cm);
	  }, true);
	  option("fixedGutter", true, function(cm, val) {
	    cm.display.gutters.style.left = val ? compensateForHScroll(cm.display) + "px" : "0";
	    cm.refresh();
	  }, true);
	  option("coverGutterNextToScrollbar", false, function(cm) {updateScrollbars(cm);}, true);
	  option("scrollbarStyle", "native", function(cm) {
	    initScrollbars(cm);
	    updateScrollbars(cm);
	    cm.display.scrollbars.setScrollTop(cm.doc.scrollTop);
	    cm.display.scrollbars.setScrollLeft(cm.doc.scrollLeft);
	  }, true);
	  option("lineNumbers", false, function(cm) {
	    setGuttersForLineNumbers(cm.options);
	    guttersChanged(cm);
	  }, true);
	  option("firstLineNumber", 1, guttersChanged, true);
	  option("lineNumberFormatter", function(integer) {return integer;}, guttersChanged, true);
	  option("showCursorWhenSelecting", false, updateSelection, true);
	
	  option("resetSelectionOnContextMenu", true);
	  option("lineWiseCopyCut", true);
	
	  option("readOnly", false, function(cm, val) {
	    if (val == "nocursor") {
	      onBlur(cm);
	      cm.display.input.blur();
	      cm.display.disabled = true;
	    } else {
	      cm.display.disabled = false;
	    }
	    cm.display.input.readOnlyChanged(val)
	  });
	  option("disableInput", false, function(cm, val) {if (!val) cm.display.input.reset();}, true);
	  option("dragDrop", true, dragDropChanged);
	  option("allowDropFileTypes", null);
	
	  option("cursorBlinkRate", 530);
	  option("cursorScrollMargin", 0);
	  option("cursorHeight", 1, updateSelection, true);
	  option("singleCursorHeightPerLine", true, updateSelection, true);
	  option("workTime", 100);
	  option("workDelay", 100);
	  option("flattenSpans", true, resetModeState, true);
	  option("addModeClass", false, resetModeState, true);
	  option("pollInterval", 100);
	  option("undoDepth", 200, function(cm, val){cm.doc.history.undoDepth = val;});
	  option("historyEventDelay", 1250);
	  option("viewportMargin", 10, function(cm){cm.refresh();}, true);
	  option("maxHighlightLength", 10000, resetModeState, true);
	  option("moveInputWithCursor", true, function(cm, val) {
	    if (!val) cm.display.input.resetPosition();
	  });
	
	  option("tabindex", null, function(cm, val) {
	    cm.display.input.getField().tabIndex = val || "";
	  });
	  option("autofocus", null);
	
	  // MODE DEFINITION AND QUERYING
	
	  // Known modes, by name and by MIME
	  var modes = CodeMirror.modes = {}, mimeModes = CodeMirror.mimeModes = {};
	
	  // Extra arguments are stored as the mode's dependencies, which is
	  // used by (legacy) mechanisms like loadmode.js to automatically
	  // load a mode. (Preferred mechanism is the require/define calls.)
	  CodeMirror.defineMode = function(name, mode) {
	    if (!CodeMirror.defaults.mode && name != "null") CodeMirror.defaults.mode = name;
	    if (arguments.length > 2)
	      mode.dependencies = Array.prototype.slice.call(arguments, 2);
	    modes[name] = mode;
	  };
	
	  CodeMirror.defineMIME = function(mime, spec) {
	    mimeModes[mime] = spec;
	  };
	
	  // Given a MIME type, a {name, ...options} config object, or a name
	  // string, return a mode config object.
	  CodeMirror.resolveMode = function(spec) {
	    if (typeof spec == "string" && mimeModes.hasOwnProperty(spec)) {
	      spec = mimeModes[spec];
	    } else if (spec && typeof spec.name == "string" && mimeModes.hasOwnProperty(spec.name)) {
	      var found = mimeModes[spec.name];
	      if (typeof found == "string") found = {name: found};
	      spec = createObj(found, spec);
	      spec.name = found.name;
	    } else if (typeof spec == "string" && /^[\w\-]+\/[\w\-]+\+xml$/.test(spec)) {
	      return CodeMirror.resolveMode("application/xml");
	    } else if (typeof spec == "string" && /^[\w\-]+\/[\w\-]+\+json$/.test(spec)) {
	      return CodeMirror.resolveMode("application/json");
	    }
	    if (typeof spec == "string") return {name: spec};
	    else return spec || {name: "null"};
	  };
	
	  // Given a mode spec (anything that resolveMode accepts), find and
	  // initialize an actual mode object.
	  CodeMirror.getMode = function(options, spec) {
	    var spec = CodeMirror.resolveMode(spec);
	    var mfactory = modes[spec.name];
	    if (!mfactory) return CodeMirror.getMode(options, "text/plain");
	    var modeObj = mfactory(options, spec);
	    if (modeExtensions.hasOwnProperty(spec.name)) {
	      var exts = modeExtensions[spec.name];
	      for (var prop in exts) {
	        if (!exts.hasOwnProperty(prop)) continue;
	        if (modeObj.hasOwnProperty(prop)) modeObj["_" + prop] = modeObj[prop];
	        modeObj[prop] = exts[prop];
	      }
	    }
	    modeObj.name = spec.name;
	    if (spec.helperType) modeObj.helperType = spec.helperType;
	    if (spec.modeProps) for (var prop in spec.modeProps)
	      modeObj[prop] = spec.modeProps[prop];
	
	    return modeObj;
	  };
	
	  // Minimal default mode.
	  CodeMirror.defineMode("null", function() {
	    return {token: function(stream) {stream.skipToEnd();}};
	  });
	  CodeMirror.defineMIME("text/plain", "null");
	
	  // This can be used to attach properties to mode objects from
	  // outside the actual mode definition.
	  var modeExtensions = CodeMirror.modeExtensions = {};
	  CodeMirror.extendMode = function(mode, properties) {
	    var exts = modeExtensions.hasOwnProperty(mode) ? modeExtensions[mode] : (modeExtensions[mode] = {});
	    copyObj(properties, exts);
	  };
	
	  // EXTENSIONS
	
	  CodeMirror.defineExtension = function(name, func) {
	    CodeMirror.prototype[name] = func;
	  };
	  CodeMirror.defineDocExtension = function(name, func) {
	    Doc.prototype[name] = func;
	  };
	  CodeMirror.defineOption = option;
	
	  var initHooks = [];
	  CodeMirror.defineInitHook = function(f) {initHooks.push(f);};
	
	  var helpers = CodeMirror.helpers = {};
	  CodeMirror.registerHelper = function(type, name, value) {
	    if (!helpers.hasOwnProperty(type)) helpers[type] = CodeMirror[type] = {_global: []};
	    helpers[type][name] = value;
	  };
	  CodeMirror.registerGlobalHelper = function(type, name, predicate, value) {
	    CodeMirror.registerHelper(type, name, value);
	    helpers[type]._global.push({pred: predicate, val: value});
	  };
	
	  // MODE STATE HANDLING
	
	  // Utility functions for working with state. Exported because nested
	  // modes need to do this for their inner modes.
	
	  var copyState = CodeMirror.copyState = function(mode, state) {
	    if (state === true) return state;
	    if (mode.copyState) return mode.copyState(state);
	    var nstate = {};
	    for (var n in state) {
	      var val = state[n];
	      if (val instanceof Array) val = val.concat([]);
	      nstate[n] = val;
	    }
	    return nstate;
	  };
	
	  var startState = CodeMirror.startState = function(mode, a1, a2) {
	    return mode.startState ? mode.startState(a1, a2) : true;
	  };
	
	  // Given a mode and a state (for that mode), find the inner mode and
	  // state at the position that the state refers to.
	  CodeMirror.innerMode = function(mode, state) {
	    while (mode.innerMode) {
	      var info = mode.innerMode(state);
	      if (!info || info.mode == mode) break;
	      state = info.state;
	      mode = info.mode;
	    }
	    return info || {mode: mode, state: state};
	  };
	
	  // STANDARD COMMANDS
	
	  // Commands are parameter-less actions that can be performed on an
	  // editor, mostly used for keybindings.
	  var commands = CodeMirror.commands = {
	    selectAll: function(cm) {cm.setSelection(Pos(cm.firstLine(), 0), Pos(cm.lastLine()), sel_dontScroll);},
	    singleSelection: function(cm) {
	      cm.setSelection(cm.getCursor("anchor"), cm.getCursor("head"), sel_dontScroll);
	    },
	    killLine: function(cm) {
	      deleteNearSelection(cm, function(range) {
	        if (range.empty()) {
	          var len = getLine(cm.doc, range.head.line).text.length;
	          if (range.head.ch == len && range.head.line < cm.lastLine())
	            return {from: range.head, to: Pos(range.head.line + 1, 0)};
	          else
	            return {from: range.head, to: Pos(range.head.line, len)};
	        } else {
	          return {from: range.from(), to: range.to()};
	        }
	      });
	    },
	    deleteLine: function(cm) {
	      deleteNearSelection(cm, function(range) {
	        return {from: Pos(range.from().line, 0),
	                to: clipPos(cm.doc, Pos(range.to().line + 1, 0))};
	      });
	    },
	    delLineLeft: function(cm) {
	      deleteNearSelection(cm, function(range) {
	        return {from: Pos(range.from().line, 0), to: range.from()};
	      });
	    },
	    delWrappedLineLeft: function(cm) {
	      deleteNearSelection(cm, function(range) {
	        var top = cm.charCoords(range.head, "div").top + 5;
	        var leftPos = cm.coordsChar({left: 0, top: top}, "div");
	        return {from: leftPos, to: range.from()};
	      });
	    },
	    delWrappedLineRight: function(cm) {
	      deleteNearSelection(cm, function(range) {
	        var top = cm.charCoords(range.head, "div").top + 5;
	        var rightPos = cm.coordsChar({left: cm.display.lineDiv.offsetWidth + 100, top: top}, "div");
	        return {from: range.from(), to: rightPos };
	      });
	    },
	    undo: function(cm) {cm.undo();},
	    redo: function(cm) {cm.redo();},
	    undoSelection: function(cm) {cm.undoSelection();},
	    redoSelection: function(cm) {cm.redoSelection();},
	    goDocStart: function(cm) {cm.extendSelection(Pos(cm.firstLine(), 0));},
	    goDocEnd: function(cm) {cm.extendSelection(Pos(cm.lastLine()));},
	    goLineStart: function(cm) {
	      cm.extendSelectionsBy(function(range) { return lineStart(cm, range.head.line); },
	                            {origin: "+move", bias: 1});
	    },
	    goLineStartSmart: function(cm) {
	      cm.extendSelectionsBy(function(range) {
	        return lineStartSmart(cm, range.head);
	      }, {origin: "+move", bias: 1});
	    },
	    goLineEnd: function(cm) {
	      cm.extendSelectionsBy(function(range) { return lineEnd(cm, range.head.line); },
	                            {origin: "+move", bias: -1});
	    },
	    goLineRight: function(cm) {
	      cm.extendSelectionsBy(function(range) {
	        var top = cm.charCoords(range.head, "div").top + 5;
	        return cm.coordsChar({left: cm.display.lineDiv.offsetWidth + 100, top: top}, "div");
	      }, sel_move);
	    },
	    goLineLeft: function(cm) {
	      cm.extendSelectionsBy(function(range) {
	        var top = cm.charCoords(range.head, "div").top + 5;
	        return cm.coordsChar({left: 0, top: top}, "div");
	      }, sel_move);
	    },
	    goLineLeftSmart: function(cm) {
	      cm.extendSelectionsBy(function(range) {
	        var top = cm.charCoords(range.head, "div").top + 5;
	        var pos = cm.coordsChar({left: 0, top: top}, "div");
	        if (pos.ch < cm.getLine(pos.line).search(/\S/)) return lineStartSmart(cm, range.head);
	        return pos;
	      }, sel_move);
	    },
	    goLineUp: function(cm) {cm.moveV(-1, "line");},
	    goLineDown: function(cm) {cm.moveV(1, "line");},
	    goPageUp: function(cm) {cm.moveV(-1, "page");},
	    goPageDown: function(cm) {cm.moveV(1, "page");},
	    goCharLeft: function(cm) {cm.moveH(-1, "char");},
	    goCharRight: function(cm) {cm.moveH(1, "char");},
	    goColumnLeft: function(cm) {cm.moveH(-1, "column");},
	    goColumnRight: function(cm) {cm.moveH(1, "column");},
	    goWordLeft: function(cm) {cm.moveH(-1, "word");},
	    goGroupRight: function(cm) {cm.moveH(1, "group");},
	    goGroupLeft: function(cm) {cm.moveH(-1, "group");},
	    goWordRight: function(cm) {cm.moveH(1, "word");},
	    delCharBefore: function(cm) {cm.deleteH(-1, "char");},
	    delCharAfter: function(cm) {cm.deleteH(1, "char");},
	    delWordBefore: function(cm) {cm.deleteH(-1, "word");},
	    delWordAfter: function(cm) {cm.deleteH(1, "word");},
	    delGroupBefore: function(cm) {cm.deleteH(-1, "group");},
	    delGroupAfter: function(cm) {cm.deleteH(1, "group");},
	    indentAuto: function(cm) {cm.indentSelection("smart");},
	    indentMore: function(cm) {cm.indentSelection("add");},
	    indentLess: function(cm) {cm.indentSelection("subtract");},
	    insertTab: function(cm) {cm.replaceSelection("\t");},
	    insertSoftTab: function(cm) {
	      var spaces = [], ranges = cm.listSelections(), tabSize = cm.options.tabSize;
	      for (var i = 0; i < ranges.length; i++) {
	        var pos = ranges[i].from();
	        var col = countColumn(cm.getLine(pos.line), pos.ch, tabSize);
	        spaces.push(spaceStr(tabSize - col % tabSize));
	      }
	      cm.replaceSelections(spaces);
	    },
	    defaultTab: function(cm) {
	      if (cm.somethingSelected()) cm.indentSelection("add");
	      else cm.execCommand("insertTab");
	    },
	    transposeChars: function(cm) {
	      runInOp(cm, function() {
	        var ranges = cm.listSelections(), newSel = [];
	        for (var i = 0; i < ranges.length; i++) {
	          var cur = ranges[i].head, line = getLine(cm.doc, cur.line).text;
	          if (line) {
	            if (cur.ch == line.length) cur = new Pos(cur.line, cur.ch - 1);
	            if (cur.ch > 0) {
	              cur = new Pos(cur.line, cur.ch + 1);
	              cm.replaceRange(line.charAt(cur.ch - 1) + line.charAt(cur.ch - 2),
	                              Pos(cur.line, cur.ch - 2), cur, "+transpose");
	            } else if (cur.line > cm.doc.first) {
	              var prev = getLine(cm.doc, cur.line - 1).text;
	              if (prev)
	                cm.replaceRange(line.charAt(0) + cm.doc.lineSeparator() +
	                                prev.charAt(prev.length - 1),
	                                Pos(cur.line - 1, prev.length - 1), Pos(cur.line, 1), "+transpose");
	            }
	          }
	          newSel.push(new Range(cur, cur));
	        }
	        cm.setSelections(newSel);
	      });
	    },
	    newlineAndIndent: function(cm) {
	      runInOp(cm, function() {
	        var len = cm.listSelections().length;
	        for (var i = 0; i < len; i++) {
	          var range = cm.listSelections()[i];
	          cm.replaceRange(cm.doc.lineSeparator(), range.anchor, range.head, "+input");
	          cm.indentLine(range.from().line + 1, null, true);
	        }
	        ensureCursorVisible(cm);
	      });
	    },
	    openLine: function(cm) {cm.replaceSelection("\n", "start")},
	    toggleOverwrite: function(cm) {cm.toggleOverwrite();}
	  };
	
	
	  // STANDARD KEYMAPS
	
	  var keyMap = CodeMirror.keyMap = {};
	
	  keyMap.basic = {
	    "Left": "goCharLeft", "Right": "goCharRight", "Up": "goLineUp", "Down": "goLineDown",
	    "End": "goLineEnd", "Home": "goLineStartSmart", "PageUp": "goPageUp", "PageDown": "goPageDown",
	    "Delete": "delCharAfter", "Backspace": "delCharBefore", "Shift-Backspace": "delCharBefore",
	    "Tab": "defaultTab", "Shift-Tab": "indentAuto",
	    "Enter": "newlineAndIndent", "Insert": "toggleOverwrite",
	    "Esc": "singleSelection"
	  };
	  // Note that the save and find-related commands aren't defined by
	  // default. User code or addons can define them. Unknown commands
	  // are simply ignored.
	  keyMap.pcDefault = {
	    "Ctrl-A": "selectAll", "Ctrl-D": "deleteLine", "Ctrl-Z": "undo", "Shift-Ctrl-Z": "redo", "Ctrl-Y": "redo",
	    "Ctrl-Home": "goDocStart", "Ctrl-End": "goDocEnd", "Ctrl-Up": "goLineUp", "Ctrl-Down": "goLineDown",
	    "Ctrl-Left": "goGroupLeft", "Ctrl-Right": "goGroupRight", "Alt-Left": "goLineStart", "Alt-Right": "goLineEnd",
	    "Ctrl-Backspace": "delGroupBefore", "Ctrl-Delete": "delGroupAfter", "Ctrl-S": "save", "Ctrl-F": "find",
	    "Ctrl-G": "findNext", "Shift-Ctrl-G": "findPrev", "Shift-Ctrl-F": "replace", "Shift-Ctrl-R": "replaceAll",
	    "Ctrl-[": "indentLess", "Ctrl-]": "indentMore",
	    "Ctrl-U": "undoSelection", "Shift-Ctrl-U": "redoSelection", "Alt-U": "redoSelection",
	    fallthrough: "basic"
	  };
	  // Very basic readline/emacs-style bindings, which are standard on Mac.
	  keyMap.emacsy = {
	    "Ctrl-F": "goCharRight", "Ctrl-B": "goCharLeft", "Ctrl-P": "goLineUp", "Ctrl-N": "goLineDown",
	    "Alt-F": "goWordRight", "Alt-B": "goWordLeft", "Ctrl-A": "goLineStart", "Ctrl-E": "goLineEnd",
	    "Ctrl-V": "goPageDown", "Shift-Ctrl-V": "goPageUp", "Ctrl-D": "delCharAfter", "Ctrl-H": "delCharBefore",
	    "Alt-D": "delWordAfter", "Alt-Backspace": "delWordBefore", "Ctrl-K": "killLine", "Ctrl-T": "transposeChars",
	    "Ctrl-O": "openLine"
	  };
	  keyMap.macDefault = {
	    "Cmd-A": "selectAll", "Cmd-D": "deleteLine", "Cmd-Z": "undo", "Shift-Cmd-Z": "redo", "Cmd-Y": "redo",
	    "Cmd-Home": "goDocStart", "Cmd-Up": "goDocStart", "Cmd-End": "goDocEnd", "Cmd-Down": "goDocEnd", "Alt-Left": "goGroupLeft",
	    "Alt-Right": "goGroupRight", "Cmd-Left": "goLineLeft", "Cmd-Right": "goLineRight", "Alt-Backspace": "delGroupBefore",
	    "Ctrl-Alt-Backspace": "delGroupAfter", "Alt-Delete": "delGroupAfter", "Cmd-S": "save", "Cmd-F": "find",
	    "Cmd-G": "findNext", "Shift-Cmd-G": "findPrev", "Cmd-Alt-F": "replace", "Shift-Cmd-Alt-F": "replaceAll",
	    "Cmd-[": "indentLess", "Cmd-]": "indentMore", "Cmd-Backspace": "delWrappedLineLeft", "Cmd-Delete": "delWrappedLineRight",
	    "Cmd-U": "undoSelection", "Shift-Cmd-U": "redoSelection", "Ctrl-Up": "goDocStart", "Ctrl-Down": "goDocEnd",
	    fallthrough: ["basic", "emacsy"]
	  };
	  keyMap["default"] = mac ? keyMap.macDefault : keyMap.pcDefault;
	
	  // KEYMAP DISPATCH
	
	  function normalizeKeyName(name) {
	    var parts = name.split(/-(?!$)/), name = parts[parts.length - 1];
	    var alt, ctrl, shift, cmd;
	    for (var i = 0; i < parts.length - 1; i++) {
	      var mod = parts[i];
	      if (/^(cmd|meta|m)$/i.test(mod)) cmd = true;
	      else if (/^a(lt)?$/i.test(mod)) alt = true;
	      else if (/^(c|ctrl|control)$/i.test(mod)) ctrl = true;
	      else if (/^s(hift)$/i.test(mod)) shift = true;
	      else throw new Error("Unrecognized modifier name: " + mod);
	    }
	    if (alt) name = "Alt-" + name;
	    if (ctrl) name = "Ctrl-" + name;
	    if (cmd) name = "Cmd-" + name;
	    if (shift) name = "Shift-" + name;
	    return name;
	  }
	
	  // This is a kludge to keep keymaps mostly working as raw objects
	  // (backwards compatibility) while at the same time support features
	  // like normalization and multi-stroke key bindings. It compiles a
	  // new normalized keymap, and then updates the old object to reflect
	  // this.
	  CodeMirror.normalizeKeyMap = function(keymap) {
	    var copy = {};
	    for (var keyname in keymap) if (keymap.hasOwnProperty(keyname)) {
	      var value = keymap[keyname];
	      if (/^(name|fallthrough|(de|at)tach)$/.test(keyname)) continue;
	      if (value == "...") { delete keymap[keyname]; continue; }
	
	      var keys = map(keyname.split(" "), normalizeKeyName);
	      for (var i = 0; i < keys.length; i++) {
	        var val, name;
	        if (i == keys.length - 1) {
	          name = keys.join(" ");
	          val = value;
	        } else {
	          name = keys.slice(0, i + 1).join(" ");
	          val = "...";
	        }
	        var prev = copy[name];
	        if (!prev) copy[name] = val;
	        else if (prev != val) throw new Error("Inconsistent bindings for " + name);
	      }
	      delete keymap[keyname];
	    }
	    for (var prop in copy) keymap[prop] = copy[prop];
	    return keymap;
	  };
	
	  var lookupKey = CodeMirror.lookupKey = function(key, map, handle, context) {
	    map = getKeyMap(map);
	    var found = map.call ? map.call(key, context) : map[key];
	    if (found === false) return "nothing";
	    if (found === "...") return "multi";
	    if (found != null && handle(found)) return "handled";
	
	    if (map.fallthrough) {
	      if (Object.prototype.toString.call(map.fallthrough) != "[object Array]")
	        return lookupKey(key, map.fallthrough, handle, context);
	      for (var i = 0; i < map.fallthrough.length; i++) {
	        var result = lookupKey(key, map.fallthrough[i], handle, context);
	        if (result) return result;
	      }
	    }
	  };
	
	  // Modifier key presses don't count as 'real' key presses for the
	  // purpose of keymap fallthrough.
	  var isModifierKey = CodeMirror.isModifierKey = function(value) {
	    var name = typeof value == "string" ? value : keyNames[value.keyCode];
	    return name == "Ctrl" || name == "Alt" || name == "Shift" || name == "Mod";
	  };
	
	  // Look up the name of a key as indicated by an event object.
	  var keyName = CodeMirror.keyName = function(event, noShift) {
	    if (presto && event.keyCode == 34 && event["char"]) return false;
	    var base = keyNames[event.keyCode], name = base;
	    if (name == null || event.altGraphKey) return false;
	    if (event.altKey && base != "Alt") name = "Alt-" + name;
	    if ((flipCtrlCmd ? event.metaKey : event.ctrlKey) && base != "Ctrl") name = "Ctrl-" + name;
	    if ((flipCtrlCmd ? event.ctrlKey : event.metaKey) && base != "Cmd") name = "Cmd-" + name;
	    if (!noShift && event.shiftKey && base != "Shift") name = "Shift-" + name;
	    return name;
	  };
	
	  function getKeyMap(val) {
	    return typeof val == "string" ? keyMap[val] : val;
	  }
	
	  // FROMTEXTAREA
	
	  CodeMirror.fromTextArea = function(textarea, options) {
	    options = options ? copyObj(options) : {};
	    options.value = textarea.value;
	    if (!options.tabindex && textarea.tabIndex)
	      options.tabindex = textarea.tabIndex;
	    if (!options.placeholder && textarea.placeholder)
	      options.placeholder = textarea.placeholder;
	    // Set autofocus to true if this textarea is focused, or if it has
	    // autofocus and no other element is focused.
	    if (options.autofocus == null) {
	      var hasFocus = activeElt();
	      options.autofocus = hasFocus == textarea ||
	        textarea.getAttribute("autofocus") != null && hasFocus == document.body;
	    }
	
	    function save() {textarea.value = cm.getValue();}
	    if (textarea.form) {
	      on(textarea.form, "submit", save);
	      // Deplorable hack to make the submit method do the right thing.
	      if (!options.leaveSubmitMethodAlone) {
	        var form = textarea.form, realSubmit = form.submit;
	        try {
	          var wrappedSubmit = form.submit = function() {
	            save();
	            form.submit = realSubmit;
	            form.submit();
	            form.submit = wrappedSubmit;
	          };
	        } catch(e) {}
	      }
	    }
	
	    options.finishInit = function(cm) {
	      cm.save = save;
	      cm.getTextArea = function() { return textarea; };
	      cm.toTextArea = function() {
	        cm.toTextArea = isNaN; // Prevent this from being ran twice
	        save();
	        textarea.parentNode.removeChild(cm.getWrapperElement());
	        textarea.style.display = "";
	        if (textarea.form) {
	          off(textarea.form, "submit", save);
	          if (typeof textarea.form.submit == "function")
	            textarea.form.submit = realSubmit;
	        }
	      };
	    };
	
	    textarea.style.display = "none";
	    var cm = CodeMirror(function(node) {
	      textarea.parentNode.insertBefore(node, textarea.nextSibling);
	    }, options);
	    return cm;
	  };
	
	  // STRING STREAM
	
	  // Fed to the mode parsers, provides helper functions to make
	  // parsers more succinct.
	
	  var StringStream = CodeMirror.StringStream = function(string, tabSize) {
	    this.pos = this.start = 0;
	    this.string = string;
	    this.tabSize = tabSize || 8;
	    this.lastColumnPos = this.lastColumnValue = 0;
	    this.lineStart = 0;
	  };
	
	  StringStream.prototype = {
	    eol: function() {return this.pos >= this.string.length;},
	    sol: function() {return this.pos == this.lineStart;},
	    peek: function() {return this.string.charAt(this.pos) || undefined;},
	    next: function() {
	      if (this.pos < this.string.length)
	        return this.string.charAt(this.pos++);
	    },
	    eat: function(match) {
	      var ch = this.string.charAt(this.pos);
	      if (typeof match == "string") var ok = ch == match;
	      else var ok = ch && (match.test ? match.test(ch) : match(ch));
	      if (ok) {++this.pos; return ch;}
	    },
	    eatWhile: function(match) {
	      var start = this.pos;
	      while (this.eat(match)){}
	      return this.pos > start;
	    },
	    eatSpace: function() {
	      var start = this.pos;
	      while (/[\s\u00a0]/.test(this.string.charAt(this.pos))) ++this.pos;
	      return this.pos > start;
	    },
	    skipToEnd: function() {this.pos = this.string.length;},
	    skipTo: function(ch) {
	      var found = this.string.indexOf(ch, this.pos);
	      if (found > -1) {this.pos = found; return true;}
	    },
	    backUp: function(n) {this.pos -= n;},
	    column: function() {
	      if (this.lastColumnPos < this.start) {
	        this.lastColumnValue = countColumn(this.string, this.start, this.tabSize, this.lastColumnPos, this.lastColumnValue);
	        this.lastColumnPos = this.start;
	      }
	      return this.lastColumnValue - (this.lineStart ? countColumn(this.string, this.lineStart, this.tabSize) : 0);
	    },
	    indentation: function() {
	      return countColumn(this.string, null, this.tabSize) -
	        (this.lineStart ? countColumn(this.string, this.lineStart, this.tabSize) : 0);
	    },
	    match: function(pattern, consume, caseInsensitive) {
	      if (typeof pattern == "string") {
	        var cased = function(str) {return caseInsensitive ? str.toLowerCase() : str;};
	        var substr = this.string.substr(this.pos, pattern.length);
	        if (cased(substr) == cased(pattern)) {
	          if (consume !== false) this.pos += pattern.length;
	          return true;
	        }
	      } else {
	        var match = this.string.slice(this.pos).match(pattern);
	        if (match && match.index > 0) return null;
	        if (match && consume !== false) this.pos += match[0].length;
	        return match;
	      }
	    },
	    current: function(){return this.string.slice(this.start, this.pos);},
	    hideFirstChars: function(n, inner) {
	      this.lineStart += n;
	      try { return inner(); }
	      finally { this.lineStart -= n; }
	    }
	  };
	
	  // TEXTMARKERS
	
	  // Created with markText and setBookmark methods. A TextMarker is a
	  // handle that can be used to clear or find a marked position in the
	  // document. Line objects hold arrays (markedSpans) containing
	  // {from, to, marker} object pointing to such marker objects, and
	  // indicating that such a marker is present on that line. Multiple
	  // lines may point to the same marker when it spans across lines.
	  // The spans will have null for their from/to properties when the
	  // marker continues beyond the start/end of the line. Markers have
	  // links back to the lines they currently touch.
	
	  var nextMarkerId = 0;
	
	  var TextMarker = CodeMirror.TextMarker = function(doc, type) {
	    this.lines = [];
	    this.type = type;
	    this.doc = doc;
	    this.id = ++nextMarkerId;
	  };
	  eventMixin(TextMarker);
	
	  // Clear the marker.
	  TextMarker.prototype.clear = function() {
	    if (this.explicitlyCleared) return;
	    var cm = this.doc.cm, withOp = cm && !cm.curOp;
	    if (withOp) startOperation(cm);
	    if (hasHandler(this, "clear")) {
	      var found = this.find();
	      if (found) signalLater(this, "clear", found.from, found.to);
	    }
	    var min = null, max = null;
	    for (var i = 0; i < this.lines.length; ++i) {
	      var line = this.lines[i];
	      var span = getMarkedSpanFor(line.markedSpans, this);
	      if (cm && !this.collapsed) regLineChange(cm, lineNo(line), "text");
	      else if (cm) {
	        if (span.to != null) max = lineNo(line);
	        if (span.from != null) min = lineNo(line);
	      }
	      line.markedSpans = removeMarkedSpan(line.markedSpans, span);
	      if (span.from == null && this.collapsed && !lineIsHidden(this.doc, line) && cm)
	        updateLineHeight(line, textHeight(cm.display));
	    }
	    if (cm && this.collapsed && !cm.options.lineWrapping) for (var i = 0; i < this.lines.length; ++i) {
	      var visual = visualLine(this.lines[i]), len = lineLength(visual);
	      if (len > cm.display.maxLineLength) {
	        cm.display.maxLine = visual;
	        cm.display.maxLineLength = len;
	        cm.display.maxLineChanged = true;
	      }
	    }
	
	    if (min != null && cm && this.collapsed) regChange(cm, min, max + 1);
	    this.lines.length = 0;
	    this.explicitlyCleared = true;
	    if (this.atomic && this.doc.cantEdit) {
	      this.doc.cantEdit = false;
	      if (cm) reCheckSelection(cm.doc);
	    }
	    if (cm) signalLater(cm, "markerCleared", cm, this);
	    if (withOp) endOperation(cm);
	    if (this.parent) this.parent.clear();
	  };
	
	  // Find the position of the marker in the document. Returns a {from,
	  // to} object by default. Side can be passed to get a specific side
	  // -- 0 (both), -1 (left), or 1 (right). When lineObj is true, the
	  // Pos objects returned contain a line object, rather than a line
	  // number (used to prevent looking up the same line twice).
	  TextMarker.prototype.find = function(side, lineObj) {
	    if (side == null && this.type == "bookmark") side = 1;
	    var from, to;
	    for (var i = 0; i < this.lines.length; ++i) {
	      var line = this.lines[i];
	      var span = getMarkedSpanFor(line.markedSpans, this);
	      if (span.from != null) {
	        from = Pos(lineObj ? line : lineNo(line), span.from);
	        if (side == -1) return from;
	      }
	      if (span.to != null) {
	        to = Pos(lineObj ? line : lineNo(line), span.to);
	        if (side == 1) return to;
	      }
	    }
	    return from && {from: from, to: to};
	  };
	
	  // Signals that the marker's widget changed, and surrounding layout
	  // should be recomputed.
	  TextMarker.prototype.changed = function() {
	    var pos = this.find(-1, true), widget = this, cm = this.doc.cm;
	    if (!pos || !cm) return;
	    runInOp(cm, function() {
	      var line = pos.line, lineN = lineNo(pos.line);
	      var view = findViewForLine(cm, lineN);
	      if (view) {
	        clearLineMeasurementCacheFor(view);
	        cm.curOp.selectionChanged = cm.curOp.forceUpdate = true;
	      }
	      cm.curOp.updateMaxLine = true;
	      if (!lineIsHidden(widget.doc, line) && widget.height != null) {
	        var oldHeight = widget.height;
	        widget.height = null;
	        var dHeight = widgetHeight(widget) - oldHeight;
	        if (dHeight)
	          updateLineHeight(line, line.height + dHeight);
	      }
	    });
	  };
	
	  TextMarker.prototype.attachLine = function(line) {
	    if (!this.lines.length && this.doc.cm) {
	      var op = this.doc.cm.curOp;
	      if (!op.maybeHiddenMarkers || indexOf(op.maybeHiddenMarkers, this) == -1)
	        (op.maybeUnhiddenMarkers || (op.maybeUnhiddenMarkers = [])).push(this);
	    }
	    this.lines.push(line);
	  };
	  TextMarker.prototype.detachLine = function(line) {
	    this.lines.splice(indexOf(this.lines, line), 1);
	    if (!this.lines.length && this.doc.cm) {
	      var op = this.doc.cm.curOp;
	      (op.maybeHiddenMarkers || (op.maybeHiddenMarkers = [])).push(this);
	    }
	  };
	
	  // Collapsed markers have unique ids, in order to be able to order
	  // them, which is needed for uniquely determining an outer marker
	  // when they overlap (they may nest, but not partially overlap).
	  var nextMarkerId = 0;
	
	  // Create a marker, wire it up to the right lines, and
	  function markText(doc, from, to, options, type) {
	    // Shared markers (across linked documents) are handled separately
	    // (markTextShared will call out to this again, once per
	    // document).
	    if (options && options.shared) return markTextShared(doc, from, to, options, type);
	    // Ensure we are in an operation.
	    if (doc.cm && !doc.cm.curOp) return operation(doc.cm, markText)(doc, from, to, options, type);
	
	    var marker = new TextMarker(doc, type), diff = cmp(from, to);
	    if (options) copyObj(options, marker, false);
	    // Don't connect empty markers unless clearWhenEmpty is false
	    if (diff > 0 || diff == 0 && marker.clearWhenEmpty !== false)
	      return marker;
	    if (marker.replacedWith) {
	      // Showing up as a widget implies collapsed (widget replaces text)
	      marker.collapsed = true;
	      marker.widgetNode = elt("span", [marker.replacedWith], "CodeMirror-widget");
	      if (!options.handleMouseEvents) marker.widgetNode.setAttribute("cm-ignore-events", "true");
	      if (options.insertLeft) marker.widgetNode.insertLeft = true;
	    }
	    if (marker.collapsed) {
	      if (conflictingCollapsedRange(doc, from.line, from, to, marker) ||
	          from.line != to.line && conflictingCollapsedRange(doc, to.line, from, to, marker))
	        throw new Error("Inserting collapsed marker partially overlapping an existing one");
	      sawCollapsedSpans = true;
	    }
	
	    if (marker.addToHistory)
	      addChangeToHistory(doc, {from: from, to: to, origin: "markText"}, doc.sel, NaN);
	
	    var curLine = from.line, cm = doc.cm, updateMaxLine;
	    doc.iter(curLine, to.line + 1, function(line) {
	      if (cm && marker.collapsed && !cm.options.lineWrapping && visualLine(line) == cm.display.maxLine)
	        updateMaxLine = true;
	      if (marker.collapsed && curLine != from.line) updateLineHeight(line, 0);
	      addMarkedSpan(line, new MarkedSpan(marker,
	                                         curLine == from.line ? from.ch : null,
	                                         curLine == to.line ? to.ch : null));
	      ++curLine;
	    });
	    // lineIsHidden depends on the presence of the spans, so needs a second pass
	    if (marker.collapsed) doc.iter(from.line, to.line + 1, function(line) {
	      if (lineIsHidden(doc, line)) updateLineHeight(line, 0);
	    });
	
	    if (marker.clearOnEnter) on(marker, "beforeCursorEnter", function() { marker.clear(); });
	
	    if (marker.readOnly) {
	      sawReadOnlySpans = true;
	      if (doc.history.done.length || doc.history.undone.length)
	        doc.clearHistory();
	    }
	    if (marker.collapsed) {
	      marker.id = ++nextMarkerId;
	      marker.atomic = true;
	    }
	    if (cm) {
	      // Sync editor state
	      if (updateMaxLine) cm.curOp.updateMaxLine = true;
	      if (marker.collapsed)
	        regChange(cm, from.line, to.line + 1);
	      else if (marker.className || marker.title || marker.startStyle || marker.endStyle || marker.css)
	        for (var i = from.line; i <= to.line; i++) regLineChange(cm, i, "text");
	      if (marker.atomic) reCheckSelection(cm.doc);
	      signalLater(cm, "markerAdded", cm, marker);
	    }
	    return marker;
	  }
	
	  // SHARED TEXTMARKERS
	
	  // A shared marker spans multiple linked documents. It is
	  // implemented as a meta-marker-object controlling multiple normal
	  // markers.
	  var SharedTextMarker = CodeMirror.SharedTextMarker = function(markers, primary) {
	    this.markers = markers;
	    this.primary = primary;
	    for (var i = 0; i < markers.length; ++i)
	      markers[i].parent = this;
	  };
	  eventMixin(SharedTextMarker);
	
	  SharedTextMarker.prototype.clear = function() {
	    if (this.explicitlyCleared) return;
	    this.explicitlyCleared = true;
	    for (var i = 0; i < this.markers.length; ++i)
	      this.markers[i].clear();
	    signalLater(this, "clear");
	  };
	  SharedTextMarker.prototype.find = function(side, lineObj) {
	    return this.primary.find(side, lineObj);
	  };
	
	  function markTextShared(doc, from, to, options, type) {
	    options = copyObj(options);
	    options.shared = false;
	    var markers = [markText(doc, from, to, options, type)], primary = markers[0];
	    var widget = options.widgetNode;
	    linkedDocs(doc, function(doc) {
	      if (widget) options.widgetNode = widget.cloneNode(true);
	      markers.push(markText(doc, clipPos(doc, from), clipPos(doc, to), options, type));
	      for (var i = 0; i < doc.linked.length; ++i)
	        if (doc.linked[i].isParent) return;
	      primary = lst(markers);
	    });
	    return new SharedTextMarker(markers, primary);
	  }
	
	  function findSharedMarkers(doc) {
	    return doc.findMarks(Pos(doc.first, 0), doc.clipPos(Pos(doc.lastLine())),
	                         function(m) { return m.parent; });
	  }
	
	  function copySharedMarkers(doc, markers) {
	    for (var i = 0; i < markers.length; i++) {
	      var marker = markers[i], pos = marker.find();
	      var mFrom = doc.clipPos(pos.from), mTo = doc.clipPos(pos.to);
	      if (cmp(mFrom, mTo)) {
	        var subMark = markText(doc, mFrom, mTo, marker.primary, marker.primary.type);
	        marker.markers.push(subMark);
	        subMark.parent = marker;
	      }
	    }
	  }
	
	  function detachSharedMarkers(markers) {
	    for (var i = 0; i < markers.length; i++) {
	      var marker = markers[i], linked = [marker.primary.doc];;
	      linkedDocs(marker.primary.doc, function(d) { linked.push(d); });
	      for (var j = 0; j < marker.markers.length; j++) {
	        var subMarker = marker.markers[j];
	        if (indexOf(linked, subMarker.doc) == -1) {
	          subMarker.parent = null;
	          marker.markers.splice(j--, 1);
	        }
	      }
	    }
	  }
	
	  // TEXTMARKER SPANS
	
	  function MarkedSpan(marker, from, to) {
	    this.marker = marker;
	    this.from = from; this.to = to;
	  }
	
	  // Search an array of spans for a span matching the given marker.
	  function getMarkedSpanFor(spans, marker) {
	    if (spans) for (var i = 0; i < spans.length; ++i) {
	      var span = spans[i];
	      if (span.marker == marker) return span;
	    }
	  }
	  // Remove a span from an array, returning undefined if no spans are
	  // left (we don't store arrays for lines without spans).
	  function removeMarkedSpan(spans, span) {
	    for (var r, i = 0; i < spans.length; ++i)
	      if (spans[i] != span) (r || (r = [])).push(spans[i]);
	    return r;
	  }
	  // Add a span to a line.
	  function addMarkedSpan(line, span) {
	    line.markedSpans = line.markedSpans ? line.markedSpans.concat([span]) : [span];
	    span.marker.attachLine(line);
	  }
	
	  // Used for the algorithm that adjusts markers for a change in the
	  // document. These functions cut an array of spans at a given
	  // character position, returning an array of remaining chunks (or
	  // undefined if nothing remains).
	  function markedSpansBefore(old, startCh, isInsert) {
	    if (old) for (var i = 0, nw; i < old.length; ++i) {
	      var span = old[i], marker = span.marker;
	      var startsBefore = span.from == null || (marker.inclusiveLeft ? span.from <= startCh : span.from < startCh);
	      if (startsBefore || span.from == startCh && marker.type == "bookmark" && (!isInsert || !span.marker.insertLeft)) {
	        var endsAfter = span.to == null || (marker.inclusiveRight ? span.to >= startCh : span.to > startCh);
	        (nw || (nw = [])).push(new MarkedSpan(marker, span.from, endsAfter ? null : span.to));
	      }
	    }
	    return nw;
	  }
	  function markedSpansAfter(old, endCh, isInsert) {
	    if (old) for (var i = 0, nw; i < old.length; ++i) {
	      var span = old[i], marker = span.marker;
	      var endsAfter = span.to == null || (marker.inclusiveRight ? span.to >= endCh : span.to > endCh);
	      if (endsAfter || span.from == endCh && marker.type == "bookmark" && (!isInsert || span.marker.insertLeft)) {
	        var startsBefore = span.from == null || (marker.inclusiveLeft ? span.from <= endCh : span.from < endCh);
	        (nw || (nw = [])).push(new MarkedSpan(marker, startsBefore ? null : span.from - endCh,
	                                              span.to == null ? null : span.to - endCh));
	      }
	    }
	    return nw;
	  }
	
	  // Given a change object, compute the new set of marker spans that
	  // cover the line in which the change took place. Removes spans
	  // entirely within the change, reconnects spans belonging to the
	  // same marker that appear on both sides of the change, and cuts off
	  // spans partially within the change. Returns an array of span
	  // arrays with one element for each line in (after) the change.
	  function stretchSpansOverChange(doc, change) {
	    if (change.full) return null;
	    var oldFirst = isLine(doc, change.from.line) && getLine(doc, change.from.line).markedSpans;
	    var oldLast = isLine(doc, change.to.line) && getLine(doc, change.to.line).markedSpans;
	    if (!oldFirst && !oldLast) return null;
	
	    var startCh = change.from.ch, endCh = change.to.ch, isInsert = cmp(change.from, change.to) == 0;
	    // Get the spans that 'stick out' on both sides
	    var first = markedSpansBefore(oldFirst, startCh, isInsert);
	    var last = markedSpansAfter(oldLast, endCh, isInsert);
	
	    // Next, merge those two ends
	    var sameLine = change.text.length == 1, offset = lst(change.text).length + (sameLine ? startCh : 0);
	    if (first) {
	      // Fix up .to properties of first
	      for (var i = 0; i < first.length; ++i) {
	        var span = first[i];
	        if (span.to == null) {
	          var found = getMarkedSpanFor(last, span.marker);
	          if (!found) span.to = startCh;
	          else if (sameLine) span.to = found.to == null ? null : found.to + offset;
	        }
	      }
	    }
	    if (last) {
	      // Fix up .from in last (or move them into first in case of sameLine)
	      for (var i = 0; i < last.length; ++i) {
	        var span = last[i];
	        if (span.to != null) span.to += offset;
	        if (span.from == null) {
	          var found = getMarkedSpanFor(first, span.marker);
	          if (!found) {
	            span.from = offset;
	            if (sameLine) (first || (first = [])).push(span);
	          }
	        } else {
	          span.from += offset;
	          if (sameLine) (first || (first = [])).push(span);
	        }
	      }
	    }
	    // Make sure we didn't create any zero-length spans
	    if (first) first = clearEmptySpans(first);
	    if (last && last != first) last = clearEmptySpans(last);
	
	    var newMarkers = [first];
	    if (!sameLine) {
	      // Fill gap with whole-line-spans
	      var gap = change.text.length - 2, gapMarkers;
	      if (gap > 0 && first)
	        for (var i = 0; i < first.length; ++i)
	          if (first[i].to == null)
	            (gapMarkers || (gapMarkers = [])).push(new MarkedSpan(first[i].marker, null, null));
	      for (var i = 0; i < gap; ++i)
	        newMarkers.push(gapMarkers);
	      newMarkers.push(last);
	    }
	    return newMarkers;
	  }
	
	  // Remove spans that are empty and don't have a clearWhenEmpty
	  // option of false.
	  function clearEmptySpans(spans) {
	    for (var i = 0; i < spans.length; ++i) {
	      var span = spans[i];
	      if (span.from != null && span.from == span.to && span.marker.clearWhenEmpty !== false)
	        spans.splice(i--, 1);
	    }
	    if (!spans.length) return null;
	    return spans;
	  }
	
	  // Used for un/re-doing changes from the history. Combines the
	  // result of computing the existing spans with the set of spans that
	  // existed in the history (so that deleting around a span and then
	  // undoing brings back the span).
	  function mergeOldSpans(doc, change) {
	    var old = getOldSpans(doc, change);
	    var stretched = stretchSpansOverChange(doc, change);
	    if (!old) return stretched;
	    if (!stretched) return old;
	
	    for (var i = 0; i < old.length; ++i) {
	      var oldCur = old[i], stretchCur = stretched[i];
	      if (oldCur && stretchCur) {
	        spans: for (var j = 0; j < stretchCur.length; ++j) {
	          var span = stretchCur[j];
	          for (var k = 0; k < oldCur.length; ++k)
	            if (oldCur[k].marker == span.marker) continue spans;
	          oldCur.push(span);
	        }
	      } else if (stretchCur) {
	        old[i] = stretchCur;
	      }
	    }
	    return old;
	  }
	
	  // Used to 'clip' out readOnly ranges when making a change.
	  function removeReadOnlyRanges(doc, from, to) {
	    var markers = null;
	    doc.iter(from.line, to.line + 1, function(line) {
	      if (line.markedSpans) for (var i = 0; i < line.markedSpans.length; ++i) {
	        var mark = line.markedSpans[i].marker;
	        if (mark.readOnly && (!markers || indexOf(markers, mark) == -1))
	          (markers || (markers = [])).push(mark);
	      }
	    });
	    if (!markers) return null;
	    var parts = [{from: from, to: to}];
	    for (var i = 0; i < markers.length; ++i) {
	      var mk = markers[i], m = mk.find(0);
	      for (var j = 0; j < parts.length; ++j) {
	        var p = parts[j];
	        if (cmp(p.to, m.from) < 0 || cmp(p.from, m.to) > 0) continue;
	        var newParts = [j, 1], dfrom = cmp(p.from, m.from), dto = cmp(p.to, m.to);
	        if (dfrom < 0 || !mk.inclusiveLeft && !dfrom)
	          newParts.push({from: p.from, to: m.from});
	        if (dto > 0 || !mk.inclusiveRight && !dto)
	          newParts.push({from: m.to, to: p.to});
	        parts.splice.apply(parts, newParts);
	        j += newParts.length - 1;
	      }
	    }
	    return parts;
	  }
	
	  // Connect or disconnect spans from a line.
	  function detachMarkedSpans(line) {
	    var spans = line.markedSpans;
	    if (!spans) return;
	    for (var i = 0; i < spans.length; ++i)
	      spans[i].marker.detachLine(line);
	    line.markedSpans = null;
	  }
	  function attachMarkedSpans(line, spans) {
	    if (!spans) return;
	    for (var i = 0; i < spans.length; ++i)
	      spans[i].marker.attachLine(line);
	    line.markedSpans = spans;
	  }
	
	  // Helpers used when computing which overlapping collapsed span
	  // counts as the larger one.
	  function extraLeft(marker) { return marker.inclusiveLeft ? -1 : 0; }
	  function extraRight(marker) { return marker.inclusiveRight ? 1 : 0; }
	
	  // Returns a number indicating which of two overlapping collapsed
	  // spans is larger (and thus includes the other). Falls back to
	  // comparing ids when the spans cover exactly the same range.
	  function compareCollapsedMarkers(a, b) {
	    var lenDiff = a.lines.length - b.lines.length;
	    if (lenDiff != 0) return lenDiff;
	    var aPos = a.find(), bPos = b.find();
	    var fromCmp = cmp(aPos.from, bPos.from) || extraLeft(a) - extraLeft(b);
	    if (fromCmp) return -fromCmp;
	    var toCmp = cmp(aPos.to, bPos.to) || extraRight(a) - extraRight(b);
	    if (toCmp) return toCmp;
	    return b.id - a.id;
	  }
	
	  // Find out whether a line ends or starts in a collapsed span. If
	  // so, return the marker for that span.
	  function collapsedSpanAtSide(line, start) {
	    var sps = sawCollapsedSpans && line.markedSpans, found;
	    if (sps) for (var sp, i = 0; i < sps.length; ++i) {
	      sp = sps[i];
	      if (sp.marker.collapsed && (start ? sp.from : sp.to) == null &&
	          (!found || compareCollapsedMarkers(found, sp.marker) < 0))
	        found = sp.marker;
	    }
	    return found;
	  }
	  function collapsedSpanAtStart(line) { return collapsedSpanAtSide(line, true); }
	  function collapsedSpanAtEnd(line) { return collapsedSpanAtSide(line, false); }
	
	  // Test whether there exists a collapsed span that partially
	  // overlaps (covers the start or end, but not both) of a new span.
	  // Such overlap is not allowed.
	  function conflictingCollapsedRange(doc, lineNo, from, to, marker) {
	    var line = getLine(doc, lineNo);
	    var sps = sawCollapsedSpans && line.markedSpans;
	    if (sps) for (var i = 0; i < sps.length; ++i) {
	      var sp = sps[i];
	      if (!sp.marker.collapsed) continue;
	      var found = sp.marker.find(0);
	      var fromCmp = cmp(found.from, from) || extraLeft(sp.marker) - extraLeft(marker);
	      var toCmp = cmp(found.to, to) || extraRight(sp.marker) - extraRight(marker);
	      if (fromCmp >= 0 && toCmp <= 0 || fromCmp <= 0 && toCmp >= 0) continue;
	      if (fromCmp <= 0 && (sp.marker.inclusiveRight && marker.inclusiveLeft ? cmp(found.to, from) >= 0 : cmp(found.to, from) > 0) ||
	          fromCmp >= 0 && (sp.marker.inclusiveRight && marker.inclusiveLeft ? cmp(found.from, to) <= 0 : cmp(found.from, to) < 0))
	        return true;
	    }
	  }
	
	  // A visual line is a line as drawn on the screen. Folding, for
	  // example, can cause multiple logical lines to appear on the same
	  // visual line. This finds the start of the visual line that the
	  // given line is part of (usually that is the line itself).
	  function visualLine(line) {
	    var merged;
	    while (merged = collapsedSpanAtStart(line))
	      line = merged.find(-1, true).line;
	    return line;
	  }
	
	  // Returns an array of logical lines that continue the visual line
	  // started by the argument, or undefined if there are no such lines.
	  function visualLineContinued(line) {
	    var merged, lines;
	    while (merged = collapsedSpanAtEnd(line)) {
	      line = merged.find(1, true).line;
	      (lines || (lines = [])).push(line);
	    }
	    return lines;
	  }
	
	  // Get the line number of the start of the visual line that the
	  // given line number is part of.
	  function visualLineNo(doc, lineN) {
	    var line = getLine(doc, lineN), vis = visualLine(line);
	    if (line == vis) return lineN;
	    return lineNo(vis);
	  }
	  // Get the line number of the start of the next visual line after
	  // the given line.
	  function visualLineEndNo(doc, lineN) {
	    if (lineN > doc.lastLine()) return lineN;
	    var line = getLine(doc, lineN), merged;
	    if (!lineIsHidden(doc, line)) return lineN;
	    while (merged = collapsedSpanAtEnd(line))
	      line = merged.find(1, true).line;
	    return lineNo(line) + 1;
	  }
	
	  // Compute whether a line is hidden. Lines count as hidden when they
	  // are part of a visual line that starts with another line, or when
	  // they are entirely covered by collapsed, non-widget span.
	  function lineIsHidden(doc, line) {
	    var sps = sawCollapsedSpans && line.markedSpans;
	    if (sps) for (var sp, i = 0; i < sps.length; ++i) {
	      sp = sps[i];
	      if (!sp.marker.collapsed) continue;
	      if (sp.from == null) return true;
	      if (sp.marker.widgetNode) continue;
	      if (sp.from == 0 && sp.marker.inclusiveLeft && lineIsHiddenInner(doc, line, sp))
	        return true;
	    }
	  }
	  function lineIsHiddenInner(doc, line, span) {
	    if (span.to == null) {
	      var end = span.marker.find(1, true);
	      return lineIsHiddenInner(doc, end.line, getMarkedSpanFor(end.line.markedSpans, span.marker));
	    }
	    if (span.marker.inclusiveRight && span.to == line.text.length)
	      return true;
	    for (var sp, i = 0; i < line.markedSpans.length; ++i) {
	      sp = line.markedSpans[i];
	      if (sp.marker.collapsed && !sp.marker.widgetNode && sp.from == span.to &&
	          (sp.to == null || sp.to != span.from) &&
	          (sp.marker.inclusiveLeft || span.marker.inclusiveRight) &&
	          lineIsHiddenInner(doc, line, sp)) return true;
	    }
	  }
	
	  // LINE WIDGETS
	
	  // Line widgets are block elements displayed above or below a line.
	
	  var LineWidget = CodeMirror.LineWidget = function(doc, node, options) {
	    if (options) for (var opt in options) if (options.hasOwnProperty(opt))
	      this[opt] = options[opt];
	    this.doc = doc;
	    this.node = node;
	  };
	  eventMixin(LineWidget);
	
	  function adjustScrollWhenAboveVisible(cm, line, diff) {
	    if (heightAtLine(line) < ((cm.curOp && cm.curOp.scrollTop) || cm.doc.scrollTop))
	      addToScrollPos(cm, null, diff);
	  }
	
	  LineWidget.prototype.clear = function() {
	    var cm = this.doc.cm, ws = this.line.widgets, line = this.line, no = lineNo(line);
	    if (no == null || !ws) return;
	    for (var i = 0; i < ws.length; ++i) if (ws[i] == this) ws.splice(i--, 1);
	    if (!ws.length) line.widgets = null;
	    var height = widgetHeight(this);
	    updateLineHeight(line, Math.max(0, line.height - height));
	    if (cm) runInOp(cm, function() {
	      adjustScrollWhenAboveVisible(cm, line, -height);
	      regLineChange(cm, no, "widget");
	    });
	  };
	  LineWidget.prototype.changed = function() {
	    var oldH = this.height, cm = this.doc.cm, line = this.line;
	    this.height = null;
	    var diff = widgetHeight(this) - oldH;
	    if (!diff) return;
	    updateLineHeight(line, line.height + diff);
	    if (cm) runInOp(cm, function() {
	      cm.curOp.forceUpdate = true;
	      adjustScrollWhenAboveVisible(cm, line, diff);
	    });
	  };
	
	  function widgetHeight(widget) {
	    if (widget.height != null) return widget.height;
	    var cm = widget.doc.cm;
	    if (!cm) return 0;
	    if (!contains(document.body, widget.node)) {
	      var parentStyle = "position: relative;";
	      if (widget.coverGutter)
	        parentStyle += "margin-left: -" + cm.display.gutters.offsetWidth + "px;";
	      if (widget.noHScroll)
	        parentStyle += "width: " + cm.display.wrapper.clientWidth + "px;";
	      removeChildrenAndAdd(cm.display.measure, elt("div", [widget.node], null, parentStyle));
	    }
	    return widget.height = widget.node.parentNode.offsetHeight;
	  }
	
	  function addLineWidget(doc, handle, node, options) {
	    var widget = new LineWidget(doc, node, options);
	    var cm = doc.cm;
	    if (cm && widget.noHScroll) cm.display.alignWidgets = true;
	    changeLine(doc, handle, "widget", function(line) {
	      var widgets = line.widgets || (line.widgets = []);
	      if (widget.insertAt == null) widgets.push(widget);
	      else widgets.splice(Math.min(widgets.length - 1, Math.max(0, widget.insertAt)), 0, widget);
	      widget.line = line;
	      if (cm && !lineIsHidden(doc, line)) {
	        var aboveVisible = heightAtLine(line) < doc.scrollTop;
	        updateLineHeight(line, line.height + widgetHeight(widget));
	        if (aboveVisible) addToScrollPos(cm, null, widget.height);
	        cm.curOp.forceUpdate = true;
	      }
	      return true;
	    });
	    return widget;
	  }
	
	  // LINE DATA STRUCTURE
	
	  // Line objects. These hold state related to a line, including
	  // highlighting info (the styles array).
	  var Line = CodeMirror.Line = function(text, markedSpans, estimateHeight) {
	    this.text = text;
	    attachMarkedSpans(this, markedSpans);
	    this.height = estimateHeight ? estimateHeight(this) : 1;
	  };
	  eventMixin(Line);
	  Line.prototype.lineNo = function() { return lineNo(this); };
	
	  // Change the content (text, markers) of a line. Automatically
	  // invalidates cached information and tries to re-estimate the
	  // line's height.
	  function updateLine(line, text, markedSpans, estimateHeight) {
	    line.text = text;
	    if (line.stateAfter) line.stateAfter = null;
	    if (line.styles) line.styles = null;
	    if (line.order != null) line.order = null;
	    detachMarkedSpans(line);
	    attachMarkedSpans(line, markedSpans);
	    var estHeight = estimateHeight ? estimateHeight(line) : 1;
	    if (estHeight != line.height) updateLineHeight(line, estHeight);
	  }
	
	  // Detach a line from the document tree and its markers.
	  function cleanUpLine(line) {
	    line.parent = null;
	    detachMarkedSpans(line);
	  }
	
	  function extractLineClasses(type, output) {
	    if (type) for (;;) {
	      var lineClass = type.match(/(?:^|\s+)line-(background-)?(\S+)/);
	      if (!lineClass) break;
	      type = type.slice(0, lineClass.index) + type.slice(lineClass.index + lineClass[0].length);
	      var prop = lineClass[1] ? "bgClass" : "textClass";
	      if (output[prop] == null)
	        output[prop] = lineClass[2];
	      else if (!(new RegExp("(?:^|\s)" + lineClass[2] + "(?:$|\s)")).test(output[prop]))
	        output[prop] += " " + lineClass[2];
	    }
	    return type;
	  }
	
	  function callBlankLine(mode, state) {
	    if (mode.blankLine) return mode.blankLine(state);
	    if (!mode.innerMode) return;
	    var inner = CodeMirror.innerMode(mode, state);
	    if (inner.mode.blankLine) return inner.mode.blankLine(inner.state);
	  }
	
	  function readToken(mode, stream, state, inner) {
	    for (var i = 0; i < 10; i++) {
	      if (inner) inner[0] = CodeMirror.innerMode(mode, state).mode;
	      var style = mode.token(stream, state);
	      if (stream.pos > stream.start) return style;
	    }
	    throw new Error("Mode " + mode.name + " failed to advance stream.");
	  }
	
	  // Utility for getTokenAt and getLineTokens
	  function takeToken(cm, pos, precise, asArray) {
	    function getObj(copy) {
	      return {start: stream.start, end: stream.pos,
	              string: stream.current(),
	              type: style || null,
	              state: copy ? copyState(doc.mode, state) : state};
	    }
	
	    var doc = cm.doc, mode = doc.mode, style;
	    pos = clipPos(doc, pos);
	    var line = getLine(doc, pos.line), state = getStateBefore(cm, pos.line, precise);
	    var stream = new StringStream(line.text, cm.options.tabSize), tokens;
	    if (asArray) tokens = [];
	    while ((asArray || stream.pos < pos.ch) && !stream.eol()) {
	      stream.start = stream.pos;
	      style = readToken(mode, stream, state);
	      if (asArray) tokens.push(getObj(true));
	    }
	    return asArray ? tokens : getObj();
	  }
	
	  // Run the given mode's parser over a line, calling f for each token.
	  function runMode(cm, text, mode, state, f, lineClasses, forceToEnd) {
	    var flattenSpans = mode.flattenSpans;
	    if (flattenSpans == null) flattenSpans = cm.options.flattenSpans;
	    var curStart = 0, curStyle = null;
	    var stream = new StringStream(text, cm.options.tabSize), style;
	    var inner = cm.options.addModeClass && [null];
	    if (text == "") extractLineClasses(callBlankLine(mode, state), lineClasses);
	    while (!stream.eol()) {
	      if (stream.pos > cm.options.maxHighlightLength) {
	        flattenSpans = false;
	        if (forceToEnd) processLine(cm, text, state, stream.pos);
	        stream.pos = text.length;
	        style = null;
	      } else {
	        style = extractLineClasses(readToken(mode, stream, state, inner), lineClasses);
	      }
	      if (inner) {
	        var mName = inner[0].name;
	        if (mName) style = "m-" + (style ? mName + " " + style : mName);
	      }
	      if (!flattenSpans || curStyle != style) {
	        while (curStart < stream.start) {
	          curStart = Math.min(stream.start, curStart + 50000);
	          f(curStart, curStyle);
	        }
	        curStyle = style;
	      }
	      stream.start = stream.pos;
	    }
	    while (curStart < stream.pos) {
	      // Webkit seems to refuse to render text nodes longer than 57444 characters
	      var pos = Math.min(stream.pos, curStart + 50000);
	      f(pos, curStyle);
	      curStart = pos;
	    }
	  }
	
	  // Compute a style array (an array starting with a mode generation
	  // -- for invalidation -- followed by pairs of end positions and
	  // style strings), which is used to highlight the tokens on the
	  // line.
	  function highlightLine(cm, line, state, forceToEnd) {
	    // A styles array always starts with a number identifying the
	    // mode/overlays that it is based on (for easy invalidation).
	    var st = [cm.state.modeGen], lineClasses = {};
	    // Compute the base array of styles
	    runMode(cm, line.text, cm.doc.mode, state, function(end, style) {
	      st.push(end, style);
	    }, lineClasses, forceToEnd);
	
	    // Run overlays, adjust style array.
	    for (var o = 0; o < cm.state.overlays.length; ++o) {
	      var overlay = cm.state.overlays[o], i = 1, at = 0;
	      runMode(cm, line.text, overlay.mode, true, function(end, style) {
	        var start = i;
	        // Ensure there's a token end at the current position, and that i points at it
	        while (at < end) {
	          var i_end = st[i];
	          if (i_end > end)
	            st.splice(i, 1, end, st[i+1], i_end);
	          i += 2;
	          at = Math.min(end, i_end);
	        }
	        if (!style) return;
	        if (overlay.opaque) {
	          st.splice(start, i - start, end, "cm-overlay " + style);
	          i = start + 2;
	        } else {
	          for (; start < i; start += 2) {
	            var cur = st[start+1];
	            st[start+1] = (cur ? cur + " " : "") + "cm-overlay " + style;
	          }
	        }
	      }, lineClasses);
	    }
	
	    return {styles: st, classes: lineClasses.bgClass || lineClasses.textClass ? lineClasses : null};
	  }
	
	  function getLineStyles(cm, line, updateFrontier) {
	    if (!line.styles || line.styles[0] != cm.state.modeGen) {
	      var state = getStateBefore(cm, lineNo(line));
	      var result = highlightLine(cm, line, line.text.length > cm.options.maxHighlightLength ? copyState(cm.doc.mode, state) : state);
	      line.stateAfter = state;
	      line.styles = result.styles;
	      if (result.classes) line.styleClasses = result.classes;
	      else if (line.styleClasses) line.styleClasses = null;
	      if (updateFrontier === cm.doc.frontier) cm.doc.frontier++;
	    }
	    return line.styles;
	  }
	
	  // Lightweight form of highlight -- proceed over this line and
	  // update state, but don't save a style array. Used for lines that
	  // aren't currently visible.
	  function processLine(cm, text, state, startAt) {
	    var mode = cm.doc.mode;
	    var stream = new StringStream(text, cm.options.tabSize);
	    stream.start = stream.pos = startAt || 0;
	    if (text == "") callBlankLine(mode, state);
	    while (!stream.eol()) {
	      readToken(mode, stream, state);
	      stream.start = stream.pos;
	    }
	  }
	
	  // Convert a style as returned by a mode (either null, or a string
	  // containing one or more styles) to a CSS style. This is cached,
	  // and also looks for line-wide styles.
	  var styleToClassCache = {}, styleToClassCacheWithMode = {};
	  function interpretTokenStyle(style, options) {
	    if (!style || /^\s*$/.test(style)) return null;
	    var cache = options.addModeClass ? styleToClassCacheWithMode : styleToClassCache;
	    return cache[style] ||
	      (cache[style] = style.replace(/\S+/g, "cm-$&"));
	  }
	
	  // Render the DOM representation of the text of a line. Also builds
	  // up a 'line map', which points at the DOM nodes that represent
	  // specific stretches of text, and is used by the measuring code.
	  // The returned object contains the DOM node, this map, and
	  // information about line-wide styles that were set by the mode.
	  function buildLineContent(cm, lineView) {
	    // The padding-right forces the element to have a 'border', which
	    // is needed on Webkit to be able to get line-level bounding
	    // rectangles for it (in measureChar).
	    var content = elt("span", null, null, webkit ? "padding-right: .1px" : null);
	    var builder = {pre: elt("pre", [content], "CodeMirror-line"), content: content,
	                   col: 0, pos: 0, cm: cm,
	                   trailingSpace: false,
	                   splitSpaces: (ie || webkit) && cm.getOption("lineWrapping")};
	    lineView.measure = {};
	
	    // Iterate over the logical lines that make up this visual line.
	    for (var i = 0; i <= (lineView.rest ? lineView.rest.length : 0); i++) {
	      var line = i ? lineView.rest[i - 1] : lineView.line, order;
	      builder.pos = 0;
	      builder.addToken = buildToken;
	      // Optionally wire in some hacks into the token-rendering
	      // algorithm, to deal with browser quirks.
	      if (hasBadBidiRects(cm.display.measure) && (order = getOrder(line)))
	        builder.addToken = buildTokenBadBidi(builder.addToken, order);
	      builder.map = [];
	      var allowFrontierUpdate = lineView != cm.display.externalMeasured && lineNo(line);
	      insertLineContent(line, builder, getLineStyles(cm, line, allowFrontierUpdate));
	      if (line.styleClasses) {
	        if (line.styleClasses.bgClass)
	          builder.bgClass = joinClasses(line.styleClasses.bgClass, builder.bgClass || "");
	        if (line.styleClasses.textClass)
	          builder.textClass = joinClasses(line.styleClasses.textClass, builder.textClass || "");
	      }
	
	      // Ensure at least a single node is present, for measuring.
	      if (builder.map.length == 0)
	        builder.map.push(0, 0, builder.content.appendChild(zeroWidthElement(cm.display.measure)));
	
	      // Store the map and a cache object for the current logical line
	      if (i == 0) {
	        lineView.measure.map = builder.map;
	        lineView.measure.cache = {};
	      } else {
	        (lineView.measure.maps || (lineView.measure.maps = [])).push(builder.map);
	        (lineView.measure.caches || (lineView.measure.caches = [])).push({});
	      }
	    }
	
	    // See issue #2901
	    if (webkit) {
	      var last = builder.content.lastChild
	      if (/\bcm-tab\b/.test(last.className) || (last.querySelector && last.querySelector(".cm-tab")))
	        builder.content.className = "cm-tab-wrap-hack";
	    }
	
	    signal(cm, "renderLine", cm, lineView.line, builder.pre);
	    if (builder.pre.className)
	      builder.textClass = joinClasses(builder.pre.className, builder.textClass || "");
	
	    return builder;
	  }
	
	  function defaultSpecialCharPlaceholder(ch) {
	    var token = elt("span", "\u2022", "cm-invalidchar");
	    token.title = "\\u" + ch.charCodeAt(0).toString(16);
	    token.setAttribute("aria-label", token.title);
	    return token;
	  }
	
	  // Build up the DOM representation for a single token, and add it to
	  // the line map. Takes care to render special characters separately.
	  function buildToken(builder, text, style, startStyle, endStyle, title, css) {
	    if (!text) return;
	    var displayText = builder.splitSpaces ? splitSpaces(text, builder.trailingSpace) : text
	    var special = builder.cm.state.specialChars, mustWrap = false;
	    if (!special.test(text)) {
	      builder.col += text.length;
	      var content = document.createTextNode(displayText);
	      builder.map.push(builder.pos, builder.pos + text.length, content);
	      if (ie && ie_version < 9) mustWrap = true;
	      builder.pos += text.length;
	    } else {
	      var content = document.createDocumentFragment(), pos = 0;
	      while (true) {
	        special.lastIndex = pos;
	        var m = special.exec(text);
	        var skipped = m ? m.index - pos : text.length - pos;
	        if (skipped) {
	          var txt = document.createTextNode(displayText.slice(pos, pos + skipped));
	          if (ie && ie_version < 9) content.appendChild(elt("span", [txt]));
	          else content.appendChild(txt);
	          builder.map.push(builder.pos, builder.pos + skipped, txt);
	          builder.col += skipped;
	          builder.pos += skipped;
	        }
	        if (!m) break;
	        pos += skipped + 1;
	        if (m[0] == "\t") {
	          var tabSize = builder.cm.options.tabSize, tabWidth = tabSize - builder.col % tabSize;
	          var txt = content.appendChild(elt("span", spaceStr(tabWidth), "cm-tab"));
	          txt.setAttribute("role", "presentation");
	          txt.setAttribute("cm-text", "\t");
	          builder.col += tabWidth;
	        } else if (m[0] == "\r" || m[0] == "\n") {
	          var txt = content.appendChild(elt("span", m[0] == "\r" ? "\u240d" : "\u2424", "cm-invalidchar"));
	          txt.setAttribute("cm-text", m[0]);
	          builder.col += 1;
	        } else {
	          var txt = builder.cm.options.specialCharPlaceholder(m[0]);
	          txt.setAttribute("cm-text", m[0]);
	          if (ie && ie_version < 9) content.appendChild(elt("span", [txt]));
	          else content.appendChild(txt);
	          builder.col += 1;
	        }
	        builder.map.push(builder.pos, builder.pos + 1, txt);
	        builder.pos++;
	      }
	    }
	    builder.trailingSpace = displayText.charCodeAt(text.length - 1) == 32
	    if (style || startStyle || endStyle || mustWrap || css) {
	      var fullStyle = style || "";
	      if (startStyle) fullStyle += startStyle;
	      if (endStyle) fullStyle += endStyle;
	      var token = elt("span", [content], fullStyle, css);
	      if (title) token.title = title;
	      return builder.content.appendChild(token);
	    }
	    builder.content.appendChild(content);
	  }
	
	  function splitSpaces(text, trailingBefore) {
	    if (text.length > 1 && !/  /.test(text)) return text
	    var spaceBefore = trailingBefore, result = ""
	    for (var i = 0; i < text.length; i++) {
	      var ch = text.charAt(i)
	      if (ch == " " && spaceBefore && (i == text.length - 1 || text.charCodeAt(i + 1) == 32))
	        ch = "\u00a0"
	      result += ch
	      spaceBefore = ch == " "
	    }
	    return result
	  }
	
	  // Work around nonsense dimensions being reported for stretches of
	  // right-to-left text.
	  function buildTokenBadBidi(inner, order) {
	    return function(builder, text, style, startStyle, endStyle, title, css) {
	      style = style ? style + " cm-force-border" : "cm-force-border";
	      var start = builder.pos, end = start + text.length;
	      for (;;) {
	        // Find the part that overlaps with the start of this text
	        for (var i = 0; i < order.length; i++) {
	          var part = order[i];
	          if (part.to > start && part.from <= start) break;
	        }
	        if (part.to >= end) return inner(builder, text, style, startStyle, endStyle, title, css);
	        inner(builder, text.slice(0, part.to - start), style, startStyle, null, title, css);
	        startStyle = null;
	        text = text.slice(part.to - start);
	        start = part.to;
	      }
	    };
	  }
	
	  function buildCollapsedSpan(builder, size, marker, ignoreWidget) {
	    var widget = !ignoreWidget && marker.widgetNode;
	    if (widget) builder.map.push(builder.pos, builder.pos + size, widget);
	    if (!ignoreWidget && builder.cm.display.input.needsContentAttribute) {
	      if (!widget)
	        widget = builder.content.appendChild(document.createElement("span"));
	      widget.setAttribute("cm-marker", marker.id);
	    }
	    if (widget) {
	      builder.cm.display.input.setUneditable(widget);
	      builder.content.appendChild(widget);
	    }
	    builder.pos += size;
	    builder.trailingSpace = false
	  }
	
	  // Outputs a number of spans to make up a line, taking highlighting
	  // and marked text into account.
	  function insertLineContent(line, builder, styles) {
	    var spans = line.markedSpans, allText = line.text, at = 0;
	    if (!spans) {
	      for (var i = 1; i < styles.length; i+=2)
	        builder.addToken(builder, allText.slice(at, at = styles[i]), interpretTokenStyle(styles[i+1], builder.cm.options));
	      return;
	    }
	
	    var len = allText.length, pos = 0, i = 1, text = "", style, css;
	    var nextChange = 0, spanStyle, spanEndStyle, spanStartStyle, title, collapsed;
	    for (;;) {
	      if (nextChange == pos) { // Update current marker set
	        spanStyle = spanEndStyle = spanStartStyle = title = css = "";
	        collapsed = null; nextChange = Infinity;
	        var foundBookmarks = [], endStyles
	        for (var j = 0; j < spans.length; ++j) {
	          var sp = spans[j], m = sp.marker;
	          if (m.type == "bookmark" && sp.from == pos && m.widgetNode) {
	            foundBookmarks.push(m);
	          } else if (sp.from <= pos && (sp.to == null || sp.to > pos || m.collapsed && sp.to == pos && sp.from == pos)) {
	            if (sp.to != null && sp.to != pos && nextChange > sp.to) {
	              nextChange = sp.to;
	              spanEndStyle = "";
	            }
	            if (m.className) spanStyle += " " + m.className;
	            if (m.css) css = (css ? css + ";" : "") + m.css;
	            if (m.startStyle && sp.from == pos) spanStartStyle += " " + m.startStyle;
	            if (m.endStyle && sp.to == nextChange) (endStyles || (endStyles = [])).push(m.endStyle, sp.to)
	            if (m.title && !title) title = m.title;
	            if (m.collapsed && (!collapsed || compareCollapsedMarkers(collapsed.marker, m) < 0))
	              collapsed = sp;
	          } else if (sp.from > pos && nextChange > sp.from) {
	            nextChange = sp.from;
	          }
	        }
	        if (endStyles) for (var j = 0; j < endStyles.length; j += 2)
	          if (endStyles[j + 1] == nextChange) spanEndStyle += " " + endStyles[j]
	
	        if (!collapsed || collapsed.from == pos) for (var j = 0; j < foundBookmarks.length; ++j)
	          buildCollapsedSpan(builder, 0, foundBookmarks[j]);
	        if (collapsed && (collapsed.from || 0) == pos) {
	          buildCollapsedSpan(builder, (collapsed.to == null ? len + 1 : collapsed.to) - pos,
	                             collapsed.marker, collapsed.from == null);
	          if (collapsed.to == null) return;
	          if (collapsed.to == pos) collapsed = false;
	        }
	      }
	      if (pos >= len) break;
	
	      var upto = Math.min(len, nextChange);
	      while (true) {
	        if (text) {
	          var end = pos + text.length;
	          if (!collapsed) {
	            var tokenText = end > upto ? text.slice(0, upto - pos) : text;
	            builder.addToken(builder, tokenText, style ? style + spanStyle : spanStyle,
	                             spanStartStyle, pos + tokenText.length == nextChange ? spanEndStyle : "", title, css);
	          }
	          if (end >= upto) {text = text.slice(upto - pos); pos = upto; break;}
	          pos = end;
	          spanStartStyle = "";
	        }
	        text = allText.slice(at, at = styles[i++]);
	        style = interpretTokenStyle(styles[i++], builder.cm.options);
	      }
	    }
	  }
	
	  // DOCUMENT DATA STRUCTURE
	
	  // By default, updates that start and end at the beginning of a line
	  // are treated specially, in order to make the association of line
	  // widgets and marker elements with the text behave more intuitive.
	  function isWholeLineUpdate(doc, change) {
	    return change.from.ch == 0 && change.to.ch == 0 && lst(change.text) == "" &&
	      (!doc.cm || doc.cm.options.wholeLineUpdateBefore);
	  }
	
	  // Perform a change on the document data structure.
	  function updateDoc(doc, change, markedSpans, estimateHeight) {
	    function spansFor(n) {return markedSpans ? markedSpans[n] : null;}
	    function update(line, text, spans) {
	      updateLine(line, text, spans, estimateHeight);
	      signalLater(line, "change", line, change);
	    }
	    function linesFor(start, end) {
	      for (var i = start, result = []; i < end; ++i)
	        result.push(new Line(text[i], spansFor(i), estimateHeight));
	      return result;
	    }
	
	    var from = change.from, to = change.to, text = change.text;
	    var firstLine = getLine(doc, from.line), lastLine = getLine(doc, to.line);
	    var lastText = lst(text), lastSpans = spansFor(text.length - 1), nlines = to.line - from.line;
	
	    // Adjust the line structure
	    if (change.full) {
	      doc.insert(0, linesFor(0, text.length));
	      doc.remove(text.length, doc.size - text.length);
	    } else if (isWholeLineUpdate(doc, change)) {
	      // This is a whole-line replace. Treated specially to make
	      // sure line objects move the way they are supposed to.
	      var added = linesFor(0, text.length - 1);
	      update(lastLine, lastLine.text, lastSpans);
	      if (nlines) doc.remove(from.line, nlines);
	      if (added.length) doc.insert(from.line, added);
	    } else if (firstLine == lastLine) {
	      if (text.length == 1) {
	        update(firstLine, firstLine.text.slice(0, from.ch) + lastText + firstLine.text.slice(to.ch), lastSpans);
	      } else {
	        var added = linesFor(1, text.length - 1);
	        added.push(new Line(lastText + firstLine.text.slice(to.ch), lastSpans, estimateHeight));
	        update(firstLine, firstLine.text.slice(0, from.ch) + text[0], spansFor(0));
	        doc.insert(from.line + 1, added);
	      }
	    } else if (text.length == 1) {
	      update(firstLine, firstLine.text.slice(0, from.ch) + text[0] + lastLine.text.slice(to.ch), spansFor(0));
	      doc.remove(from.line + 1, nlines);
	    } else {
	      update(firstLine, firstLine.text.slice(0, from.ch) + text[0], spansFor(0));
	      update(lastLine, lastText + lastLine.text.slice(to.ch), lastSpans);
	      var added = linesFor(1, text.length - 1);
	      if (nlines > 1) doc.remove(from.line + 1, nlines - 1);
	      doc.insert(from.line + 1, added);
	    }
	
	    signalLater(doc, "change", doc, change);
	  }
	
	  // The document is represented as a BTree consisting of leaves, with
	  // chunk of lines in them, and branches, with up to ten leaves or
	  // other branch nodes below them. The top node is always a branch
	  // node, and is the document object itself (meaning it has
	  // additional methods and properties).
	  //
	  // All nodes have parent links. The tree is used both to go from
	  // line numbers to line objects, and to go from objects to numbers.
	  // It also indexes by height, and is used to convert between height
	  // and line object, and to find the total height of the document.
	  //
	  // See also http://marijnhaverbeke.nl/blog/codemirror-line-tree.html
	
	  function LeafChunk(lines) {
	    this.lines = lines;
	    this.parent = null;
	    for (var i = 0, height = 0; i < lines.length; ++i) {
	      lines[i].parent = this;
	      height += lines[i].height;
	    }
	    this.height = height;
	  }
	
	  LeafChunk.prototype = {
	    chunkSize: function() { return this.lines.length; },
	    // Remove the n lines at offset 'at'.
	    removeInner: function(at, n) {
	      for (var i = at, e = at + n; i < e; ++i) {
	        var line = this.lines[i];
	        this.height -= line.height;
	        cleanUpLine(line);
	        signalLater(line, "delete");
	      }
	      this.lines.splice(at, n);
	    },
	    // Helper used to collapse a small branch into a single leaf.
	    collapse: function(lines) {
	      lines.push.apply(lines, this.lines);
	    },
	    // Insert the given array of lines at offset 'at', count them as
	    // having the given height.
	    insertInner: function(at, lines, height) {
	      this.height += height;
	      this.lines = this.lines.slice(0, at).concat(lines).concat(this.lines.slice(at));
	      for (var i = 0; i < lines.length; ++i) lines[i].parent = this;
	    },
	    // Used to iterate over a part of the tree.
	    iterN: function(at, n, op) {
	      for (var e = at + n; at < e; ++at)
	        if (op(this.lines[at])) return true;
	    }
	  };
	
	  function BranchChunk(children) {
	    this.children = children;
	    var size = 0, height = 0;
	    for (var i = 0; i < children.length; ++i) {
	      var ch = children[i];
	      size += ch.chunkSize(); height += ch.height;
	      ch.parent = this;
	    }
	    this.size = size;
	    this.height = height;
	    this.parent = null;
	  }
	
	  BranchChunk.prototype = {
	    chunkSize: function() { return this.size; },
	    removeInner: function(at, n) {
	      this.size -= n;
	      for (var i = 0; i < this.children.length; ++i) {
	        var child = this.children[i], sz = child.chunkSize();
	        if (at < sz) {
	          var rm = Math.min(n, sz - at), oldHeight = child.height;
	          child.removeInner(at, rm);
	          this.height -= oldHeight - child.height;
	          if (sz == rm) { this.children.splice(i--, 1); child.parent = null; }
	          if ((n -= rm) == 0) break;
	          at = 0;
	        } else at -= sz;
	      }
	      // If the result is smaller than 25 lines, ensure that it is a
	      // single leaf node.
	      if (this.size - n < 25 &&
	          (this.children.length > 1 || !(this.children[0] instanceof LeafChunk))) {
	        var lines = [];
	        this.collapse(lines);
	        this.children = [new LeafChunk(lines)];
	        this.children[0].parent = this;
	      }
	    },
	    collapse: function(lines) {
	      for (var i = 0; i < this.children.length; ++i) this.children[i].collapse(lines);
	    },
	    insertInner: function(at, lines, height) {
	      this.size += lines.length;
	      this.height += height;
	      for (var i = 0; i < this.children.length; ++i) {
	        var child = this.children[i], sz = child.chunkSize();
	        if (at <= sz) {
	          child.insertInner(at, lines, height);
	          if (child.lines && child.lines.length > 50) {
	            // To avoid memory thrashing when child.lines is huge (e.g. first view of a large file), it's never spliced.
	            // Instead, small slices are taken. They're taken in order because sequential memory accesses are fastest.
	            var remaining = child.lines.length % 25 + 25
	            for (var pos = remaining; pos < child.lines.length;) {
	              var leaf = new LeafChunk(child.lines.slice(pos, pos += 25));
	              child.height -= leaf.height;
	              this.children.splice(++i, 0, leaf);
	              leaf.parent = this;
	            }
	            child.lines = child.lines.slice(0, remaining);
	            this.maybeSpill();
	          }
	          break;
	        }
	        at -= sz;
	      }
	    },
	    // When a node has grown, check whether it should be split.
	    maybeSpill: function() {
	      if (this.children.length <= 10) return;
	      var me = this;
	      do {
	        var spilled = me.children.splice(me.children.length - 5, 5);
	        var sibling = new BranchChunk(spilled);
	        if (!me.parent) { // Become the parent node
	          var copy = new BranchChunk(me.children);
	          copy.parent = me;
	          me.children = [copy, sibling];
	          me = copy;
	       } else {
	          me.size -= sibling.size;
	          me.height -= sibling.height;
	          var myIndex = indexOf(me.parent.children, me);
	          me.parent.children.splice(myIndex + 1, 0, sibling);
	        }
	        sibling.parent = me.parent;
	      } while (me.children.length > 10);
	      me.parent.maybeSpill();
	    },
	    iterN: function(at, n, op) {
	      for (var i = 0; i < this.children.length; ++i) {
	        var child = this.children[i], sz = child.chunkSize();
	        if (at < sz) {
	          var used = Math.min(n, sz - at);
	          if (child.iterN(at, used, op)) return true;
	          if ((n -= used) == 0) break;
	          at = 0;
	        } else at -= sz;
	      }
	    }
	  };
	
	  var nextDocId = 0;
	  var Doc = CodeMirror.Doc = function(text, mode, firstLine, lineSep) {
	    if (!(this instanceof Doc)) return new Doc(text, mode, firstLine, lineSep);
	    if (firstLine == null) firstLine = 0;
	
	    BranchChunk.call(this, [new LeafChunk([new Line("", null)])]);
	    this.first = firstLine;
	    this.scrollTop = this.scrollLeft = 0;
	    this.cantEdit = false;
	    this.cleanGeneration = 1;
	    this.frontier = firstLine;
	    var start = Pos(firstLine, 0);
	    this.sel = simpleSelection(start);
	    this.history = new History(null);
	    this.id = ++nextDocId;
	    this.modeOption = mode;
	    this.lineSep = lineSep;
	    this.extend = false;
	
	    if (typeof text == "string") text = this.splitLines(text);
	    updateDoc(this, {from: start, to: start, text: text});
	    setSelection(this, simpleSelection(start), sel_dontScroll);
	  };
	
	  Doc.prototype = createObj(BranchChunk.prototype, {
	    constructor: Doc,
	    // Iterate over the document. Supports two forms -- with only one
	    // argument, it calls that for each line in the document. With
	    // three, it iterates over the range given by the first two (with
	    // the second being non-inclusive).
	    iter: function(from, to, op) {
	      if (op) this.iterN(from - this.first, to - from, op);
	      else this.iterN(this.first, this.first + this.size, from);
	    },
	
	    // Non-public interface for adding and removing lines.
	    insert: function(at, lines) {
	      var height = 0;
	      for (var i = 0; i < lines.length; ++i) height += lines[i].height;
	      this.insertInner(at - this.first, lines, height);
	    },
	    remove: function(at, n) { this.removeInner(at - this.first, n); },
	
	    // From here, the methods are part of the public interface. Most
	    // are also available from CodeMirror (editor) instances.
	
	    getValue: function(lineSep) {
	      var lines = getLines(this, this.first, this.first + this.size);
	      if (lineSep === false) return lines;
	      return lines.join(lineSep || this.lineSeparator());
	    },
	    setValue: docMethodOp(function(code) {
	      var top = Pos(this.first, 0), last = this.first + this.size - 1;
	      makeChange(this, {from: top, to: Pos(last, getLine(this, last).text.length),
	                        text: this.splitLines(code), origin: "setValue", full: true}, true);
	      setSelection(this, simpleSelection(top));
	    }),
	    replaceRange: function(code, from, to, origin) {
	      from = clipPos(this, from);
	      to = to ? clipPos(this, to) : from;
	      replaceRange(this, code, from, to, origin);
	    },
	    getRange: function(from, to, lineSep) {
	      var lines = getBetween(this, clipPos(this, from), clipPos(this, to));
	      if (lineSep === false) return lines;
	      return lines.join(lineSep || this.lineSeparator());
	    },
	
	    getLine: function(line) {var l = this.getLineHandle(line); return l && l.text;},
	
	    getLineHandle: function(line) {if (isLine(this, line)) return getLine(this, line);},
	    getLineNumber: function(line) {return lineNo(line);},
	
	    getLineHandleVisualStart: function(line) {
	      if (typeof line == "number") line = getLine(this, line);
	      return visualLine(line);
	    },
	
	    lineCount: function() {return this.size;},
	    firstLine: function() {return this.first;},
	    lastLine: function() {return this.first + this.size - 1;},
	
	    clipPos: function(pos) {return clipPos(this, pos);},
	
	    getCursor: function(start) {
	      var range = this.sel.primary(), pos;
	      if (start == null || start == "head") pos = range.head;
	      else if (start == "anchor") pos = range.anchor;
	      else if (start == "end" || start == "to" || start === false) pos = range.to();
	      else pos = range.from();
	      return pos;
	    },
	    listSelections: function() { return this.sel.ranges; },
	    somethingSelected: function() {return this.sel.somethingSelected();},
	
	    setCursor: docMethodOp(function(line, ch, options) {
	      setSimpleSelection(this, clipPos(this, typeof line == "number" ? Pos(line, ch || 0) : line), null, options);
	    }),
	    setSelection: docMethodOp(function(anchor, head, options) {
	      setSimpleSelection(this, clipPos(this, anchor), clipPos(this, head || anchor), options);
	    }),
	    extendSelection: docMethodOp(function(head, other, options) {
	      extendSelection(this, clipPos(this, head), other && clipPos(this, other), options);
	    }),
	    extendSelections: docMethodOp(function(heads, options) {
	      extendSelections(this, clipPosArray(this, heads), options);
	    }),
	    extendSelectionsBy: docMethodOp(function(f, options) {
	      var heads = map(this.sel.ranges, f);
	      extendSelections(this, clipPosArray(this, heads), options);
	    }),
	    setSelections: docMethodOp(function(ranges, primary, options) {
	      if (!ranges.length) return;
	      for (var i = 0, out = []; i < ranges.length; i++)
	        out[i] = new Range(clipPos(this, ranges[i].anchor),
	                           clipPos(this, ranges[i].head));
	      if (primary == null) primary = Math.min(ranges.length - 1, this.sel.primIndex);
	      setSelection(this, normalizeSelection(out, primary), options);
	    }),
	    addSelection: docMethodOp(function(anchor, head, options) {
	      var ranges = this.sel.ranges.slice(0);
	      ranges.push(new Range(clipPos(this, anchor), clipPos(this, head || anchor)));
	      setSelection(this, normalizeSelection(ranges, ranges.length - 1), options);
	    }),
	
	    getSelection: function(lineSep) {
	      var ranges = this.sel.ranges, lines;
	      for (var i = 0; i < ranges.length; i++) {
	        var sel = getBetween(this, ranges[i].from(), ranges[i].to());
	        lines = lines ? lines.concat(sel) : sel;
	      }
	      if (lineSep === false) return lines;
	      else return lines.join(lineSep || this.lineSeparator());
	    },
	    getSelections: function(lineSep) {
	      var parts = [], ranges = this.sel.ranges;
	      for (var i = 0; i < ranges.length; i++) {
	        var sel = getBetween(this, ranges[i].from(), ranges[i].to());
	        if (lineSep !== false) sel = sel.join(lineSep || this.lineSeparator());
	        parts[i] = sel;
	      }
	      return parts;
	    },
	    replaceSelection: function(code, collapse, origin) {
	      var dup = [];
	      for (var i = 0; i < this.sel.ranges.length; i++)
	        dup[i] = code;
	      this.replaceSelections(dup, collapse, origin || "+input");
	    },
	    replaceSelections: docMethodOp(function(code, collapse, origin) {
	      var changes = [], sel = this.sel;
	      for (var i = 0; i < sel.ranges.length; i++) {
	        var range = sel.ranges[i];
	        changes[i] = {from: range.from(), to: range.to(), text: this.splitLines(code[i]), origin: origin};
	      }
	      var newSel = collapse && collapse != "end" && computeReplacedSel(this, changes, collapse);
	      for (var i = changes.length - 1; i >= 0; i--)
	        makeChange(this, changes[i]);
	      if (newSel) setSelectionReplaceHistory(this, newSel);
	      else if (this.cm) ensureCursorVisible(this.cm);
	    }),
	    undo: docMethodOp(function() {makeChangeFromHistory(this, "undo");}),
	    redo: docMethodOp(function() {makeChangeFromHistory(this, "redo");}),
	    undoSelection: docMethodOp(function() {makeChangeFromHistory(this, "undo", true);}),
	    redoSelection: docMethodOp(function() {makeChangeFromHistory(this, "redo", true);}),
	
	    setExtending: function(val) {this.extend = val;},
	    getExtending: function() {return this.extend;},
	
	    historySize: function() {
	      var hist = this.history, done = 0, undone = 0;
	      for (var i = 0; i < hist.done.length; i++) if (!hist.done[i].ranges) ++done;
	      for (var i = 0; i < hist.undone.length; i++) if (!hist.undone[i].ranges) ++undone;
	      return {undo: done, redo: undone};
	    },
	    clearHistory: function() {this.history = new History(this.history.maxGeneration);},
	
	    markClean: function() {
	      this.cleanGeneration = this.changeGeneration(true);
	    },
	    changeGeneration: function(forceSplit) {
	      if (forceSplit)
	        this.history.lastOp = this.history.lastSelOp = this.history.lastOrigin = null;
	      return this.history.generation;
	    },
	    isClean: function (gen) {
	      return this.history.generation == (gen || this.cleanGeneration);
	    },
	
	    getHistory: function() {
	      return {done: copyHistoryArray(this.history.done),
	              undone: copyHistoryArray(this.history.undone)};
	    },
	    setHistory: function(histData) {
	      var hist = this.history = new History(this.history.maxGeneration);
	      hist.done = copyHistoryArray(histData.done.slice(0), null, true);
	      hist.undone = copyHistoryArray(histData.undone.slice(0), null, true);
	    },
	
	    addLineClass: docMethodOp(function(handle, where, cls) {
	      return changeLine(this, handle, where == "gutter" ? "gutter" : "class", function(line) {
	        var prop = where == "text" ? "textClass"
	                 : where == "background" ? "bgClass"
	                 : where == "gutter" ? "gutterClass" : "wrapClass";
	        if (!line[prop]) line[prop] = cls;
	        else if (classTest(cls).test(line[prop])) return false;
	        else line[prop] += " " + cls;
	        return true;
	      });
	    }),
	    removeLineClass: docMethodOp(function(handle, where, cls) {
	      return changeLine(this, handle, where == "gutter" ? "gutter" : "class", function(line) {
	        var prop = where == "text" ? "textClass"
	                 : where == "background" ? "bgClass"
	                 : where == "gutter" ? "gutterClass" : "wrapClass";
	        var cur = line[prop];
	        if (!cur) return false;
	        else if (cls == null) line[prop] = null;
	        else {
	          var found = cur.match(classTest(cls));
	          if (!found) return false;
	          var end = found.index + found[0].length;
	          line[prop] = cur.slice(0, found.index) + (!found.index || end == cur.length ? "" : " ") + cur.slice(end) || null;
	        }
	        return true;
	      });
	    }),
	
	    addLineWidget: docMethodOp(function(handle, node, options) {
	      return addLineWidget(this, handle, node, options);
	    }),
	    removeLineWidget: function(widget) { widget.clear(); },
	
	    markText: function(from, to, options) {
	      return markText(this, clipPos(this, from), clipPos(this, to), options, options && options.type || "range");
	    },
	    setBookmark: function(pos, options) {
	      var realOpts = {replacedWith: options && (options.nodeType == null ? options.widget : options),
	                      insertLeft: options && options.insertLeft,
	                      clearWhenEmpty: false, shared: options && options.shared,
	                      handleMouseEvents: options && options.handleMouseEvents};
	      pos = clipPos(this, pos);
	      return markText(this, pos, pos, realOpts, "bookmark");
	    },
	    findMarksAt: function(pos) {
	      pos = clipPos(this, pos);
	      var markers = [], spans = getLine(this, pos.line).markedSpans;
	      if (spans) for (var i = 0; i < spans.length; ++i) {
	        var span = spans[i];
	        if ((span.from == null || span.from <= pos.ch) &&
	            (span.to == null || span.to >= pos.ch))
	          markers.push(span.marker.parent || span.marker);
	      }
	      return markers;
	    },
	    findMarks: function(from, to, filter) {
	      from = clipPos(this, from); to = clipPos(this, to);
	      var found = [], lineNo = from.line;
	      this.iter(from.line, to.line + 1, function(line) {
	        var spans = line.markedSpans;
	        if (spans) for (var i = 0; i < spans.length; i++) {
	          var span = spans[i];
	          if (!(span.to != null && lineNo == from.line && from.ch >= span.to ||
	                span.from == null && lineNo != from.line ||
	                span.from != null && lineNo == to.line && span.from >= to.ch) &&
	              (!filter || filter(span.marker)))
	            found.push(span.marker.parent || span.marker);
	        }
	        ++lineNo;
	      });
	      return found;
	    },
	    getAllMarks: function() {
	      var markers = [];
	      this.iter(function(line) {
	        var sps = line.markedSpans;
	        if (sps) for (var i = 0; i < sps.length; ++i)
	          if (sps[i].from != null) markers.push(sps[i].marker);
	      });
	      return markers;
	    },
	
	    posFromIndex: function(off) {
	      var ch, lineNo = this.first, sepSize = this.lineSeparator().length;
	      this.iter(function(line) {
	        var sz = line.text.length + sepSize;
	        if (sz > off) { ch = off; return true; }
	        off -= sz;
	        ++lineNo;
	      });
	      return clipPos(this, Pos(lineNo, ch));
	    },
	    indexFromPos: function (coords) {
	      coords = clipPos(this, coords);
	      var index = coords.ch;
	      if (coords.line < this.first || coords.ch < 0) return 0;
	      var sepSize = this.lineSeparator().length;
	      this.iter(this.first, coords.line, function (line) {
	        index += line.text.length + sepSize;
	      });
	      return index;
	    },
	
	    copy: function(copyHistory) {
	      var doc = new Doc(getLines(this, this.first, this.first + this.size),
	                        this.modeOption, this.first, this.lineSep);
	      doc.scrollTop = this.scrollTop; doc.scrollLeft = this.scrollLeft;
	      doc.sel = this.sel;
	      doc.extend = false;
	      if (copyHistory) {
	        doc.history.undoDepth = this.history.undoDepth;
	        doc.setHistory(this.getHistory());
	      }
	      return doc;
	    },
	
	    linkedDoc: function(options) {
	      if (!options) options = {};
	      var from = this.first, to = this.first + this.size;
	      if (options.from != null && options.from > from) from = options.from;
	      if (options.to != null && options.to < to) to = options.to;
	      var copy = new Doc(getLines(this, from, to), options.mode || this.modeOption, from, this.lineSep);
	      if (options.sharedHist) copy.history = this.history;
	      (this.linked || (this.linked = [])).push({doc: copy, sharedHist: options.sharedHist});
	      copy.linked = [{doc: this, isParent: true, sharedHist: options.sharedHist}];
	      copySharedMarkers(copy, findSharedMarkers(this));
	      return copy;
	    },
	    unlinkDoc: function(other) {
	      if (other instanceof CodeMirror) other = other.doc;
	      if (this.linked) for (var i = 0; i < this.linked.length; ++i) {
	        var link = this.linked[i];
	        if (link.doc != other) continue;
	        this.linked.splice(i, 1);
	        other.unlinkDoc(this);
	        detachSharedMarkers(findSharedMarkers(this));
	        break;
	      }
	      // If the histories were shared, split them again
	      if (other.history == this.history) {
	        var splitIds = [other.id];
	        linkedDocs(other, function(doc) {splitIds.push(doc.id);}, true);
	        other.history = new History(null);
	        other.history.done = copyHistoryArray(this.history.done, splitIds);
	        other.history.undone = copyHistoryArray(this.history.undone, splitIds);
	      }
	    },
	    iterLinkedDocs: function(f) {linkedDocs(this, f);},
	
	    getMode: function() {return this.mode;},
	    getEditor: function() {return this.cm;},
	
	    splitLines: function(str) {
	      if (this.lineSep) return str.split(this.lineSep);
	      return splitLinesAuto(str);
	    },
	    lineSeparator: function() { return this.lineSep || "\n"; }
	  });
	
	  // Public alias.
	  Doc.prototype.eachLine = Doc.prototype.iter;
	
	  // Set up methods on CodeMirror's prototype to redirect to the editor's document.
	  var dontDelegate = "iter insert remove copy getEditor constructor".split(" ");
	  for (var prop in Doc.prototype) if (Doc.prototype.hasOwnProperty(prop) && indexOf(dontDelegate, prop) < 0)
	    CodeMirror.prototype[prop] = (function(method) {
	      return function() {return method.apply(this.doc, arguments);};
	    })(Doc.prototype[prop]);
	
	  eventMixin(Doc);
	
	  // Call f for all linked documents.
	  function linkedDocs(doc, f, sharedHistOnly) {
	    function propagate(doc, skip, sharedHist) {
	      if (doc.linked) for (var i = 0; i < doc.linked.length; ++i) {
	        var rel = doc.linked[i];
	        if (rel.doc == skip) continue;
	        var shared = sharedHist && rel.sharedHist;
	        if (sharedHistOnly && !shared) continue;
	        f(rel.doc, shared);
	        propagate(rel.doc, doc, shared);
	      }
	    }
	    propagate(doc, null, true);
	  }
	
	  // Attach a document to an editor.
	  function attachDoc(cm, doc) {
	    if (doc.cm) throw new Error("This document is already in use.");
	    cm.doc = doc;
	    doc.cm = cm;
	    estimateLineHeights(cm);
	    loadMode(cm);
	    if (!cm.options.lineWrapping) findMaxLine(cm);
	    cm.options.mode = doc.modeOption;
	    regChange(cm);
	  }
	
	  // LINE UTILITIES
	
	  // Find the line object corresponding to the given line number.
	  function getLine(doc, n) {
	    n -= doc.first;
	    if (n < 0 || n >= doc.size) throw new Error("There is no line " + (n + doc.first) + " in the document.");
	    for (var chunk = doc; !chunk.lines;) {
	      for (var i = 0;; ++i) {
	        var child = chunk.children[i], sz = child.chunkSize();
	        if (n < sz) { chunk = child; break; }
	        n -= sz;
	      }
	    }
	    return chunk.lines[n];
	  }
	
	  // Get the part of a document between two positions, as an array of
	  // strings.
	  function getBetween(doc, start, end) {
	    var out = [], n = start.line;
	    doc.iter(start.line, end.line + 1, function(line) {
	      var text = line.text;
	      if (n == end.line) text = text.slice(0, end.ch);
	      if (n == start.line) text = text.slice(start.ch);
	      out.push(text);
	      ++n;
	    });
	    return out;
	  }
	  // Get the lines between from and to, as array of strings.
	  function getLines(doc, from, to) {
	    var out = [];
	    doc.iter(from, to, function(line) { out.push(line.text); });
	    return out;
	  }
	
	  // Update the height of a line, propagating the height change
	  // upwards to parent nodes.
	  function updateLineHeight(line, height) {
	    var diff = height - line.height;
	    if (diff) for (var n = line; n; n = n.parent) n.height += diff;
	  }
	
	  // Given a line object, find its line number by walking up through
	  // its parent links.
	  function lineNo(line) {
	    if (line.parent == null) return null;
	    var cur = line.parent, no = indexOf(cur.lines, line);
	    for (var chunk = cur.parent; chunk; cur = chunk, chunk = chunk.parent) {
	      for (var i = 0;; ++i) {
	        if (chunk.children[i] == cur) break;
	        no += chunk.children[i].chunkSize();
	      }
	    }
	    return no + cur.first;
	  }
	
	  // Find the line at the given vertical position, using the height
	  // information in the document tree.
	  function lineAtHeight(chunk, h) {
	    var n = chunk.first;
	    outer: do {
	      for (var i = 0; i < chunk.children.length; ++i) {
	        var child = chunk.children[i], ch = child.height;
	        if (h < ch) { chunk = child; continue outer; }
	        h -= ch;
	        n += child.chunkSize();
	      }
	      return n;
	    } while (!chunk.lines);
	    for (var i = 0; i < chunk.lines.length; ++i) {
	      var line = chunk.lines[i], lh = line.height;
	      if (h < lh) break;
	      h -= lh;
	    }
	    return n + i;
	  }
	
	
	  // Find the height above the given line.
	  function heightAtLine(lineObj) {
	    lineObj = visualLine(lineObj);
	
	    var h = 0, chunk = lineObj.parent;
	    for (var i = 0; i < chunk.lines.length; ++i) {
	      var line = chunk.lines[i];
	      if (line == lineObj) break;
	      else h += line.height;
	    }
	    for (var p = chunk.parent; p; chunk = p, p = chunk.parent) {
	      for (var i = 0; i < p.children.length; ++i) {
	        var cur = p.children[i];
	        if (cur == chunk) break;
	        else h += cur.height;
	      }
	    }
	    return h;
	  }
	
	  // Get the bidi ordering for the given line (and cache it). Returns
	  // false for lines that are fully left-to-right, and an array of
	  // BidiSpan objects otherwise.
	  function getOrder(line) {
	    var order = line.order;
	    if (order == null) order = line.order = bidiOrdering(line.text);
	    return order;
	  }
	
	  // HISTORY
	
	  function History(startGen) {
	    // Arrays of change events and selections. Doing something adds an
	    // event to done and clears undo. Undoing moves events from done
	    // to undone, redoing moves them in the other direction.
	    this.done = []; this.undone = [];
	    this.undoDepth = Infinity;
	    // Used to track when changes can be merged into a single undo
	    // event
	    this.lastModTime = this.lastSelTime = 0;
	    this.lastOp = this.lastSelOp = null;
	    this.lastOrigin = this.lastSelOrigin = null;
	    // Used by the isClean() method
	    this.generation = this.maxGeneration = startGen || 1;
	  }
	
	  // Create a history change event from an updateDoc-style change
	  // object.
	  function historyChangeFromChange(doc, change) {
	    var histChange = {from: copyPos(change.from), to: changeEnd(change), text: getBetween(doc, change.from, change.to)};
	    attachLocalSpans(doc, histChange, change.from.line, change.to.line + 1);
	    linkedDocs(doc, function(doc) {attachLocalSpans(doc, histChange, change.from.line, change.to.line + 1);}, true);
	    return histChange;
	  }
	
	  // Pop all selection events off the end of a history array. Stop at
	  // a change event.
	  function clearSelectionEvents(array) {
	    while (array.length) {
	      var last = lst(array);
	      if (last.ranges) array.pop();
	      else break;
	    }
	  }
	
	  // Find the top change event in the history. Pop off selection
	  // events that are in the way.
	  function lastChangeEvent(hist, force) {
	    if (force) {
	      clearSelectionEvents(hist.done);
	      return lst(hist.done);
	    } else if (hist.done.length && !lst(hist.done).ranges) {
	      return lst(hist.done);
	    } else if (hist.done.length > 1 && !hist.done[hist.done.length - 2].ranges) {
	      hist.done.pop();
	      return lst(hist.done);
	    }
	  }
	
	  // Register a change in the history. Merges changes that are within
	  // a single operation, or are close together with an origin that
	  // allows merging (starting with "+") into a single event.
	  function addChangeToHistory(doc, change, selAfter, opId) {
	    var hist = doc.history;
	    hist.undone.length = 0;
	    var time = +new Date, cur;
	
	    if ((hist.lastOp == opId ||
	         hist.lastOrigin == change.origin && change.origin &&
	         ((change.origin.charAt(0) == "+" && doc.cm && hist.lastModTime > time - doc.cm.options.historyEventDelay) ||
	          change.origin.charAt(0) == "*")) &&
	        (cur = lastChangeEvent(hist, hist.lastOp == opId))) {
	      // Merge this change into the last event
	      var last = lst(cur.changes);
	      if (cmp(change.from, change.to) == 0 && cmp(change.from, last.to) == 0) {
	        // Optimized case for simple insertion -- don't want to add
	        // new changesets for every character typed
	        last.to = changeEnd(change);
	      } else {
	        // Add new sub-event
	        cur.changes.push(historyChangeFromChange(doc, change));
	      }
	    } else {
	      // Can not be merged, start a new event.
	      var before = lst(hist.done);
	      if (!before || !before.ranges)
	        pushSelectionToHistory(doc.sel, hist.done);
	      cur = {changes: [historyChangeFromChange(doc, change)],
	             generation: hist.generation};
	      hist.done.push(cur);
	      while (hist.done.length > hist.undoDepth) {
	        hist.done.shift();
	        if (!hist.done[0].ranges) hist.done.shift();
	      }
	    }
	    hist.done.push(selAfter);
	    hist.generation = ++hist.maxGeneration;
	    hist.lastModTime = hist.lastSelTime = time;
	    hist.lastOp = hist.lastSelOp = opId;
	    hist.lastOrigin = hist.lastSelOrigin = change.origin;
	
	    if (!last) signal(doc, "historyAdded");
	  }
	
	  function selectionEventCanBeMerged(doc, origin, prev, sel) {
	    var ch = origin.charAt(0);
	    return ch == "*" ||
	      ch == "+" &&
	      prev.ranges.length == sel.ranges.length &&
	      prev.somethingSelected() == sel.somethingSelected() &&
	      new Date - doc.history.lastSelTime <= (doc.cm ? doc.cm.options.historyEventDelay : 500);
	  }
	
	  // Called whenever the selection changes, sets the new selection as
	  // the pending selection in the history, and pushes the old pending
	  // selection into the 'done' array when it was significantly
	  // different (in number of selected ranges, emptiness, or time).
	  function addSelectionToHistory(doc, sel, opId, options) {
	    var hist = doc.history, origin = options && options.origin;
	
	    // A new event is started when the previous origin does not match
	    // the current, or the origins don't allow matching. Origins
	    // starting with * are always merged, those starting with + are
	    // merged when similar and close together in time.
	    if (opId == hist.lastSelOp ||
	        (origin && hist.lastSelOrigin == origin &&
	         (hist.lastModTime == hist.lastSelTime && hist.lastOrigin == origin ||
	          selectionEventCanBeMerged(doc, origin, lst(hist.done), sel))))
	      hist.done[hist.done.length - 1] = sel;
	    else
	      pushSelectionToHistory(sel, hist.done);
	
	    hist.lastSelTime = +new Date;
	    hist.lastSelOrigin = origin;
	    hist.lastSelOp = opId;
	    if (options && options.clearRedo !== false)
	      clearSelectionEvents(hist.undone);
	  }
	
	  function pushSelectionToHistory(sel, dest) {
	    var top = lst(dest);
	    if (!(top && top.ranges && top.equals(sel)))
	      dest.push(sel);
	  }
	
	  // Used to store marked span information in the history.
	  function attachLocalSpans(doc, change, from, to) {
	    var existing = change["spans_" + doc.id], n = 0;
	    doc.iter(Math.max(doc.first, from), Math.min(doc.first + doc.size, to), function(line) {
	      if (line.markedSpans)
	        (existing || (existing = change["spans_" + doc.id] = {}))[n] = line.markedSpans;
	      ++n;
	    });
	  }
	
	  // When un/re-doing restores text containing marked spans, those
	  // that have been explicitly cleared should not be restored.
	  function removeClearedSpans(spans) {
	    if (!spans) return null;
	    for (var i = 0, out; i < spans.length; ++i) {
	      if (spans[i].marker.explicitlyCleared) { if (!out) out = spans.slice(0, i); }
	      else if (out) out.push(spans[i]);
	    }
	    return !out ? spans : out.length ? out : null;
	  }
	
	  // Retrieve and filter the old marked spans stored in a change event.
	  function getOldSpans(doc, change) {
	    var found = change["spans_" + doc.id];
	    if (!found) return null;
	    for (var i = 0, nw = []; i < change.text.length; ++i)
	      nw.push(removeClearedSpans(found[i]));
	    return nw;
	  }
	
	  // Used both to provide a JSON-safe object in .getHistory, and, when
	  // detaching a document, to split the history in two
	  function copyHistoryArray(events, newGroup, instantiateSel) {
	    for (var i = 0, copy = []; i < events.length; ++i) {
	      var event = events[i];
	      if (event.ranges) {
	        copy.push(instantiateSel ? Selection.prototype.deepCopy.call(event) : event);
	        continue;
	      }
	      var changes = event.changes, newChanges = [];
	      copy.push({changes: newChanges});
	      for (var j = 0; j < changes.length; ++j) {
	        var change = changes[j], m;
	        newChanges.push({from: change.from, to: change.to, text: change.text});
	        if (newGroup) for (var prop in change) if (m = prop.match(/^spans_(\d+)$/)) {
	          if (indexOf(newGroup, Number(m[1])) > -1) {
	            lst(newChanges)[prop] = change[prop];
	            delete change[prop];
	          }
	        }
	      }
	    }
	    return copy;
	  }
	
	  // Rebasing/resetting history to deal with externally-sourced changes
	
	  function rebaseHistSelSingle(pos, from, to, diff) {
	    if (to < pos.line) {
	      pos.line += diff;
	    } else if (from < pos.line) {
	      pos.line = from;
	      pos.ch = 0;
	    }
	  }
	
	  // Tries to rebase an array of history events given a change in the
	  // document. If the change touches the same lines as the event, the
	  // event, and everything 'behind' it, is discarded. If the change is
	  // before the event, the event's positions are updated. Uses a
	  // copy-on-write scheme for the positions, to avoid having to
	  // reallocate them all on every rebase, but also avoid problems with
	  // shared position objects being unsafely updated.
	  function rebaseHistArray(array, from, to, diff) {
	    for (var i = 0; i < array.length; ++i) {
	      var sub = array[i], ok = true;
	      if (sub.ranges) {
	        if (!sub.copied) { sub = array[i] = sub.deepCopy(); sub.copied = true; }
	        for (var j = 0; j < sub.ranges.length; j++) {
	          rebaseHistSelSingle(sub.ranges[j].anchor, from, to, diff);
	          rebaseHistSelSingle(sub.ranges[j].head, from, to, diff);
	        }
	        continue;
	      }
	      for (var j = 0; j < sub.changes.length; ++j) {
	        var cur = sub.changes[j];
	        if (to < cur.from.line) {
	          cur.from = Pos(cur.from.line + diff, cur.from.ch);
	          cur.to = Pos(cur.to.line + diff, cur.to.ch);
	        } else if (from <= cur.to.line) {
	          ok = false;
	          break;
	        }
	      }
	      if (!ok) {
	        array.splice(0, i + 1);
	        i = 0;
	      }
	    }
	  }
	
	  function rebaseHist(hist, change) {
	    var from = change.from.line, to = change.to.line, diff = change.text.length - (to - from) - 1;
	    rebaseHistArray(hist.done, from, to, diff);
	    rebaseHistArray(hist.undone, from, to, diff);
	  }
	
	  // EVENT UTILITIES
	
	  // Due to the fact that we still support jurassic IE versions, some
	  // compatibility wrappers are needed.
	
	  var e_preventDefault = CodeMirror.e_preventDefault = function(e) {
	    if (e.preventDefault) e.preventDefault();
	    else e.returnValue = false;
	  };
	  var e_stopPropagation = CodeMirror.e_stopPropagation = function(e) {
	    if (e.stopPropagation) e.stopPropagation();
	    else e.cancelBubble = true;
	  };
	  function e_defaultPrevented(e) {
	    return e.defaultPrevented != null ? e.defaultPrevented : e.returnValue == false;
	  }
	  var e_stop = CodeMirror.e_stop = function(e) {e_preventDefault(e); e_stopPropagation(e);};
	
	  function e_target(e) {return e.target || e.srcElement;}
	  function e_button(e) {
	    var b = e.which;
	    if (b == null) {
	      if (e.button & 1) b = 1;
	      else if (e.button & 2) b = 3;
	      else if (e.button & 4) b = 2;
	    }
	    if (mac && e.ctrlKey && b == 1) b = 3;
	    return b;
	  }
	
	  // EVENT HANDLING
	
	  // Lightweight event framework. on/off also work on DOM nodes,
	  // registering native DOM handlers.
	
	  var on = CodeMirror.on = function(emitter, type, f) {
	    if (emitter.addEventListener)
	      emitter.addEventListener(type, f, false);
	    else if (emitter.attachEvent)
	      emitter.attachEvent("on" + type, f);
	    else {
	      var map = emitter._handlers || (emitter._handlers = {});
	      var arr = map[type] || (map[type] = []);
	      arr.push(f);
	    }
	  };
	
	  var noHandlers = []
	  function getHandlers(emitter, type, copy) {
	    var arr = emitter._handlers && emitter._handlers[type]
	    if (copy) return arr && arr.length > 0 ? arr.slice() : noHandlers
	    else return arr || noHandlers
	  }
	
	  var off = CodeMirror.off = function(emitter, type, f) {
	    if (emitter.removeEventListener)
	      emitter.removeEventListener(type, f, false);
	    else if (emitter.detachEvent)
	      emitter.detachEvent("on" + type, f);
	    else {
	      var handlers = getHandlers(emitter, type, false)
	      for (var i = 0; i < handlers.length; ++i)
	        if (handlers[i] == f) { handlers.splice(i, 1); break; }
	    }
	  };
	
	  var signal = CodeMirror.signal = function(emitter, type /*, values...*/) {
	    var handlers = getHandlers(emitter, type, true)
	    if (!handlers.length) return;
	    var args = Array.prototype.slice.call(arguments, 2);
	    for (var i = 0; i < handlers.length; ++i) handlers[i].apply(null, args);
	  };
	
	  var orphanDelayedCallbacks = null;
	
	  // Often, we want to signal events at a point where we are in the
	  // middle of some work, but don't want the handler to start calling
	  // other methods on the editor, which might be in an inconsistent
	  // state or simply not expect any other events to happen.
	  // signalLater looks whether there are any handlers, and schedules
	  // them to be executed when the last operation ends, or, if no
	  // operation is active, when a timeout fires.
	  function signalLater(emitter, type /*, values...*/) {
	    var arr = getHandlers(emitter, type, false)
	    if (!arr.length) return;
	    var args = Array.prototype.slice.call(arguments, 2), list;
	    if (operationGroup) {
	      list = operationGroup.delayedCallbacks;
	    } else if (orphanDelayedCallbacks) {
	      list = orphanDelayedCallbacks;
	    } else {
	      list = orphanDelayedCallbacks = [];
	      setTimeout(fireOrphanDelayed, 0);
	    }
	    function bnd(f) {return function(){f.apply(null, args);};};
	    for (var i = 0; i < arr.length; ++i)
	      list.push(bnd(arr[i]));
	  }
	
	  function fireOrphanDelayed() {
	    var delayed = orphanDelayedCallbacks;
	    orphanDelayedCallbacks = null;
	    for (var i = 0; i < delayed.length; ++i) delayed[i]();
	  }
	
	  // The DOM events that CodeMirror handles can be overridden by
	  // registering a (non-DOM) handler on the editor for the event name,
	  // and preventDefault-ing the event in that handler.
	  function signalDOMEvent(cm, e, override) {
	    if (typeof e == "string")
	      e = {type: e, preventDefault: function() { this.defaultPrevented = true; }};
	    signal(cm, override || e.type, cm, e);
	    return e_defaultPrevented(e) || e.codemirrorIgnore;
	  }
	
	  function signalCursorActivity(cm) {
	    var arr = cm._handlers && cm._handlers.cursorActivity;
	    if (!arr) return;
	    var set = cm.curOp.cursorActivityHandlers || (cm.curOp.cursorActivityHandlers = []);
	    for (var i = 0; i < arr.length; ++i) if (indexOf(set, arr[i]) == -1)
	      set.push(arr[i]);
	  }
	
	  function hasHandler(emitter, type) {
	    return getHandlers(emitter, type).length > 0
	  }
	
	  // Add on and off methods to a constructor's prototype, to make
	  // registering events on such objects more convenient.
	  function eventMixin(ctor) {
	    ctor.prototype.on = function(type, f) {on(this, type, f);};
	    ctor.prototype.off = function(type, f) {off(this, type, f);};
	  }
	
	  // MISC UTILITIES
	
	  // Number of pixels added to scroller and sizer to hide scrollbar
	  var scrollerGap = 30;
	
	  // Returned or thrown by various protocols to signal 'I'm not
	  // handling this'.
	  var Pass = CodeMirror.Pass = {toString: function(){return "CodeMirror.Pass";}};
	
	  // Reused option objects for setSelection & friends
	  var sel_dontScroll = {scroll: false}, sel_mouse = {origin: "*mouse"}, sel_move = {origin: "+move"};
	
	  function Delayed() {this.id = null;}
	  Delayed.prototype.set = function(ms, f) {
	    clearTimeout(this.id);
	    this.id = setTimeout(f, ms);
	  };
	
	  // Counts the column offset in a string, taking tabs into account.
	  // Used mostly to find indentation.
	  var countColumn = CodeMirror.countColumn = function(string, end, tabSize, startIndex, startValue) {
	    if (end == null) {
	      end = string.search(/[^\s\u00a0]/);
	      if (end == -1) end = string.length;
	    }
	    for (var i = startIndex || 0, n = startValue || 0;;) {
	      var nextTab = string.indexOf("\t", i);
	      if (nextTab < 0 || nextTab >= end)
	        return n + (end - i);
	      n += nextTab - i;
	      n += tabSize - (n % tabSize);
	      i = nextTab + 1;
	    }
	  };
	
	  // The inverse of countColumn -- find the offset that corresponds to
	  // a particular column.
	  var findColumn = CodeMirror.findColumn = function(string, goal, tabSize) {
	    for (var pos = 0, col = 0;;) {
	      var nextTab = string.indexOf("\t", pos);
	      if (nextTab == -1) nextTab = string.length;
	      var skipped = nextTab - pos;
	      if (nextTab == string.length || col + skipped >= goal)
	        return pos + Math.min(skipped, goal - col);
	      col += nextTab - pos;
	      col += tabSize - (col % tabSize);
	      pos = nextTab + 1;
	      if (col >= goal) return pos;
	    }
	  }
	
	  var spaceStrs = [""];
	  function spaceStr(n) {
	    while (spaceStrs.length <= n)
	      spaceStrs.push(lst(spaceStrs) + " ");
	    return spaceStrs[n];
	  }
	
	  function lst(arr) { return arr[arr.length-1]; }
	
	  var selectInput = function(node) { node.select(); };
	  if (ios) // Mobile Safari apparently has a bug where select() is broken.
	    selectInput = function(node) { node.selectionStart = 0; node.selectionEnd = node.value.length; };
	  else if (ie) // Suppress mysterious IE10 errors
	    selectInput = function(node) { try { node.select(); } catch(_e) {} };
	
	  function indexOf(array, elt) {
	    for (var i = 0; i < array.length; ++i)
	      if (array[i] == elt) return i;
	    return -1;
	  }
	  function map(array, f) {
	    var out = [];
	    for (var i = 0; i < array.length; i++) out[i] = f(array[i], i);
	    return out;
	  }
	
	  function insertSorted(array, value, score) {
	    var pos = 0, priority = score(value)
	    while (pos < array.length && score(array[pos]) <= priority) pos++
	    array.splice(pos, 0, value)
	  }
	
	  function nothing() {}
	
	  function createObj(base, props) {
	    var inst;
	    if (Object.create) {
	      inst = Object.create(base);
	    } else {
	      nothing.prototype = base;
	      inst = new nothing();
	    }
	    if (props) copyObj(props, inst);
	    return inst;
	  };
	
	  function copyObj(obj, target, overwrite) {
	    if (!target) target = {};
	    for (var prop in obj)
	      if (obj.hasOwnProperty(prop) && (overwrite !== false || !target.hasOwnProperty(prop)))
	        target[prop] = obj[prop];
	    return target;
	  }
	
	  function bind(f) {
	    var args = Array.prototype.slice.call(arguments, 1);
	    return function(){return f.apply(null, args);};
	  }
	
	  var nonASCIISingleCaseWordChar = /[\u00df\u0587\u0590-\u05f4\u0600-\u06ff\u3040-\u309f\u30a0-\u30ff\u3400-\u4db5\u4e00-\u9fcc\uac00-\ud7af]/;
	  var isWordCharBasic = CodeMirror.isWordChar = function(ch) {
	    return /\w/.test(ch) || ch > "\x80" &&
	      (ch.toUpperCase() != ch.toLowerCase() || nonASCIISingleCaseWordChar.test(ch));
	  };
	  function isWordChar(ch, helper) {
	    if (!helper) return isWordCharBasic(ch);
	    if (helper.source.indexOf("\\w") > -1 && isWordCharBasic(ch)) return true;
	    return helper.test(ch);
	  }
	
	  function isEmpty(obj) {
	    for (var n in obj) if (obj.hasOwnProperty(n) && obj[n]) return false;
	    return true;
	  }
	
	  // Extending unicode characters. A series of a non-extending char +
	  // any number of extending chars is treated as a single unit as far
	  // as editing and measuring is concerned. This is not fully correct,
	  // since some scripts/fonts/browsers also treat other configurations
	  // of code points as a group.
	  var extendingChars = /[\u0300-\u036f\u0483-\u0489\u0591-\u05bd\u05bf\u05c1\u05c2\u05c4\u05c5\u05c7\u0610-\u061a\u064b-\u065e\u0670\u06d6-\u06dc\u06de-\u06e4\u06e7\u06e8\u06ea-\u06ed\u0711\u0730-\u074a\u07a6-\u07b0\u07eb-\u07f3\u0816-\u0819\u081b-\u0823\u0825-\u0827\u0829-\u082d\u0900-\u0902\u093c\u0941-\u0948\u094d\u0951-\u0955\u0962\u0963\u0981\u09bc\u09be\u09c1-\u09c4\u09cd\u09d7\u09e2\u09e3\u0a01\u0a02\u0a3c\u0a41\u0a42\u0a47\u0a48\u0a4b-\u0a4d\u0a51\u0a70\u0a71\u0a75\u0a81\u0a82\u0abc\u0ac1-\u0ac5\u0ac7\u0ac8\u0acd\u0ae2\u0ae3\u0b01\u0b3c\u0b3e\u0b3f\u0b41-\u0b44\u0b4d\u0b56\u0b57\u0b62\u0b63\u0b82\u0bbe\u0bc0\u0bcd\u0bd7\u0c3e-\u0c40\u0c46-\u0c48\u0c4a-\u0c4d\u0c55\u0c56\u0c62\u0c63\u0cbc\u0cbf\u0cc2\u0cc6\u0ccc\u0ccd\u0cd5\u0cd6\u0ce2\u0ce3\u0d3e\u0d41-\u0d44\u0d4d\u0d57\u0d62\u0d63\u0dca\u0dcf\u0dd2-\u0dd4\u0dd6\u0ddf\u0e31\u0e34-\u0e3a\u0e47-\u0e4e\u0eb1\u0eb4-\u0eb9\u0ebb\u0ebc\u0ec8-\u0ecd\u0f18\u0f19\u0f35\u0f37\u0f39\u0f71-\u0f7e\u0f80-\u0f84\u0f86\u0f87\u0f90-\u0f97\u0f99-\u0fbc\u0fc6\u102d-\u1030\u1032-\u1037\u1039\u103a\u103d\u103e\u1058\u1059\u105e-\u1060\u1071-\u1074\u1082\u1085\u1086\u108d\u109d\u135f\u1712-\u1714\u1732-\u1734\u1752\u1753\u1772\u1773\u17b7-\u17bd\u17c6\u17c9-\u17d3\u17dd\u180b-\u180d\u18a9\u1920-\u1922\u1927\u1928\u1932\u1939-\u193b\u1a17\u1a18\u1a56\u1a58-\u1a5e\u1a60\u1a62\u1a65-\u1a6c\u1a73-\u1a7c\u1a7f\u1b00-\u1b03\u1b34\u1b36-\u1b3a\u1b3c\u1b42\u1b6b-\u1b73\u1b80\u1b81\u1ba2-\u1ba5\u1ba8\u1ba9\u1c2c-\u1c33\u1c36\u1c37\u1cd0-\u1cd2\u1cd4-\u1ce0\u1ce2-\u1ce8\u1ced\u1dc0-\u1de6\u1dfd-\u1dff\u200c\u200d\u20d0-\u20f0\u2cef-\u2cf1\u2de0-\u2dff\u302a-\u302f\u3099\u309a\ua66f-\ua672\ua67c\ua67d\ua6f0\ua6f1\ua802\ua806\ua80b\ua825\ua826\ua8c4\ua8e0-\ua8f1\ua926-\ua92d\ua947-\ua951\ua980-\ua982\ua9b3\ua9b6-\ua9b9\ua9bc\uaa29-\uaa2e\uaa31\uaa32\uaa35\uaa36\uaa43\uaa4c\uaab0\uaab2-\uaab4\uaab7\uaab8\uaabe\uaabf\uaac1\uabe5\uabe8\uabed\udc00-\udfff\ufb1e\ufe00-\ufe0f\ufe20-\ufe26\uff9e\uff9f]/;
	  function isExtendingChar(ch) { return ch.charCodeAt(0) >= 768 && extendingChars.test(ch); }
	
	  // DOM UTILITIES
	
	  function elt(tag, content, className, style) {
	    var e = document.createElement(tag);
	    if (className) e.className = className;
	    if (style) e.style.cssText = style;
	    if (typeof content == "string") e.appendChild(document.createTextNode(content));
	    else if (content) for (var i = 0; i < content.length; ++i) e.appendChild(content[i]);
	    return e;
	  }
	
	  var range;
	  if (document.createRange) range = function(node, start, end, endNode) {
	    var r = document.createRange();
	    r.setEnd(endNode || node, end);
	    r.setStart(node, start);
	    return r;
	  };
	  else range = function(node, start, end) {
	    var r = document.body.createTextRange();
	    try { r.moveToElementText(node.parentNode); }
	    catch(e) { return r; }
	    r.collapse(true);
	    r.moveEnd("character", end);
	    r.moveStart("character", start);
	    return r;
	  };
	
	  function removeChildren(e) {
	    for (var count = e.childNodes.length; count > 0; --count)
	      e.removeChild(e.firstChild);
	    return e;
	  }
	
	  function removeChildrenAndAdd(parent, e) {
	    return removeChildren(parent).appendChild(e);
	  }
	
	  var contains = CodeMirror.contains = function(parent, child) {
	    if (child.nodeType == 3) // Android browser always returns false when child is a textnode
	      child = child.parentNode;
	    if (parent.contains)
	      return parent.contains(child);
	    do {
	      if (child.nodeType == 11) child = child.host;
	      if (child == parent) return true;
	    } while (child = child.parentNode);
	  };
	
	  function activeElt() {
	    var activeElement = document.activeElement;
	    while (activeElement && activeElement.root && activeElement.root.activeElement)
	      activeElement = activeElement.root.activeElement;
	    return activeElement;
	  }
	  // Older versions of IE throws unspecified error when touching
	  // document.activeElement in some cases (during loading, in iframe)
	  if (ie && ie_version < 11) activeElt = function() {
	    try { return document.activeElement; }
	    catch(e) { return document.body; }
	  };
	
	  function classTest(cls) { return new RegExp("(^|\\s)" + cls + "(?:$|\\s)\\s*"); }
	  var rmClass = CodeMirror.rmClass = function(node, cls) {
	    var current = node.className;
	    var match = classTest(cls).exec(current);
	    if (match) {
	      var after = current.slice(match.index + match[0].length);
	      node.className = current.slice(0, match.index) + (after ? match[1] + after : "");
	    }
	  };
	  var addClass = CodeMirror.addClass = function(node, cls) {
	    var current = node.className;
	    if (!classTest(cls).test(current)) node.className += (current ? " " : "") + cls;
	  };
	  function joinClasses(a, b) {
	    var as = a.split(" ");
	    for (var i = 0; i < as.length; i++)
	      if (as[i] && !classTest(as[i]).test(b)) b += " " + as[i];
	    return b;
	  }
	
	  // WINDOW-WIDE EVENTS
	
	  // These must be handled carefully, because naively registering a
	  // handler for each editor will cause the editors to never be
	  // garbage collected.
	
	  function forEachCodeMirror(f) {
	    if (!document.body.getElementsByClassName) return;
	    var byClass = document.body.getElementsByClassName("CodeMirror");
	    for (var i = 0; i < byClass.length; i++) {
	      var cm = byClass[i].CodeMirror;
	      if (cm) f(cm);
	    }
	  }
	
	  var globalsRegistered = false;
	  function ensureGlobalHandlers() {
	    if (globalsRegistered) return;
	    registerGlobalHandlers();
	    globalsRegistered = true;
	  }
	  function registerGlobalHandlers() {
	    // When the window resizes, we need to refresh active editors.
	    var resizeTimer;
	    on(window, "resize", function() {
	      if (resizeTimer == null) resizeTimer = setTimeout(function() {
	        resizeTimer = null;
	        forEachCodeMirror(onResize);
	      }, 100);
	    });
	    // When the window loses focus, we want to show the editor as blurred
	    on(window, "blur", function() {
	      forEachCodeMirror(onBlur);
	    });
	  }
	
	  // FEATURE DETECTION
	
	  // Detect drag-and-drop
	  var dragAndDrop = function() {
	    // There is *some* kind of drag-and-drop support in IE6-8, but I
	    // couldn't get it to work yet.
	    if (ie && ie_version < 9) return false;
	    var div = elt('div');
	    return "draggable" in div || "dragDrop" in div;
	  }();
	
	  var zwspSupported;
	  function zeroWidthElement(measure) {
	    if (zwspSupported == null) {
	      var test = elt("span", "\u200b");
	      removeChildrenAndAdd(measure, elt("span", [test, document.createTextNode("x")]));
	      if (measure.firstChild.offsetHeight != 0)
	        zwspSupported = test.offsetWidth <= 1 && test.offsetHeight > 2 && !(ie && ie_version < 8);
	    }
	    var node = zwspSupported ? elt("span", "\u200b") :
	      elt("span", "\u00a0", null, "display: inline-block; width: 1px; margin-right: -1px");
	    node.setAttribute("cm-text", "");
	    return node;
	  }
	
	  // Feature-detect IE's crummy client rect reporting for bidi text
	  var badBidiRects;
	  function hasBadBidiRects(measure) {
	    if (badBidiRects != null) return badBidiRects;
	    var txt = removeChildrenAndAdd(measure, document.createTextNode("A\u062eA"));
	    var r0 = range(txt, 0, 1).getBoundingClientRect();
	    var r1 = range(txt, 1, 2).getBoundingClientRect();
	    removeChildren(measure);
	    if (!r0 || r0.left == r0.right) return false; // Safari returns null in some cases (#2780)
	    return badBidiRects = (r1.right - r0.right < 3);
	  }
	
	  // See if "".split is the broken IE version, if so, provide an
	  // alternative way to split lines.
	  var splitLinesAuto = CodeMirror.splitLines = "\n\nb".split(/\n/).length != 3 ? function(string) {
	    var pos = 0, result = [], l = string.length;
	    while (pos <= l) {
	      var nl = string.indexOf("\n", pos);
	      if (nl == -1) nl = string.length;
	      var line = string.slice(pos, string.charAt(nl - 1) == "\r" ? nl - 1 : nl);
	      var rt = line.indexOf("\r");
	      if (rt != -1) {
	        result.push(line.slice(0, rt));
	        pos += rt + 1;
	      } else {
	        result.push(line);
	        pos = nl + 1;
	      }
	    }
	    return result;
	  } : function(string){return string.split(/\r\n?|\n/);};
	
	  var hasSelection = window.getSelection ? function(te) {
	    try { return te.selectionStart != te.selectionEnd; }
	    catch(e) { return false; }
	  } : function(te) {
	    try {var range = te.ownerDocument.selection.createRange();}
	    catch(e) {}
	    if (!range || range.parentElement() != te) return false;
	    return range.compareEndPoints("StartToEnd", range) != 0;
	  };
	
	  var hasCopyEvent = (function() {
	    var e = elt("div");
	    if ("oncopy" in e) return true;
	    e.setAttribute("oncopy", "return;");
	    return typeof e.oncopy == "function";
	  })();
	
	  var badZoomedRects = null;
	  function hasBadZoomedRects(measure) {
	    if (badZoomedRects != null) return badZoomedRects;
	    var node = removeChildrenAndAdd(measure, elt("span", "x"));
	    var normal = node.getBoundingClientRect();
	    var fromRange = range(node, 0, 1).getBoundingClientRect();
	    return badZoomedRects = Math.abs(normal.left - fromRange.left) > 1;
	  }
	
	  // KEY NAMES
	
	  var keyNames = CodeMirror.keyNames = {
	    3: "Enter", 8: "Backspace", 9: "Tab", 13: "Enter", 16: "Shift", 17: "Ctrl", 18: "Alt",
	    19: "Pause", 20: "CapsLock", 27: "Esc", 32: "Space", 33: "PageUp", 34: "PageDown", 35: "End",
	    36: "Home", 37: "Left", 38: "Up", 39: "Right", 40: "Down", 44: "PrintScrn", 45: "Insert",
	    46: "Delete", 59: ";", 61: "=", 91: "Mod", 92: "Mod", 93: "Mod",
	    106: "*", 107: "=", 109: "-", 110: ".", 111: "/", 127: "Delete",
	    173: "-", 186: ";", 187: "=", 188: ",", 189: "-", 190: ".", 191: "/", 192: "`", 219: "[", 220: "\\",
	    221: "]", 222: "'", 63232: "Up", 63233: "Down", 63234: "Left", 63235: "Right", 63272: "Delete",
	    63273: "Home", 63275: "End", 63276: "PageUp", 63277: "PageDown", 63302: "Insert"
	  };
	  (function() {
	    // Number keys
	    for (var i = 0; i < 10; i++) keyNames[i + 48] = keyNames[i + 96] = String(i);
	    // Alphabetic keys
	    for (var i = 65; i <= 90; i++) keyNames[i] = String.fromCharCode(i);
	    // Function keys
	    for (var i = 1; i <= 12; i++) keyNames[i + 111] = keyNames[i + 63235] = "F" + i;
	  })();
	
	  // BIDI HELPERS
	
	  function iterateBidiSections(order, from, to, f) {
	    if (!order) return f(from, to, "ltr");
	    var found = false;
	    for (var i = 0; i < order.length; ++i) {
	      var part = order[i];
	      if (part.from < to && part.to > from || from == to && part.to == from) {
	        f(Math.max(part.from, from), Math.min(part.to, to), part.level == 1 ? "rtl" : "ltr");
	        found = true;
	      }
	    }
	    if (!found) f(from, to, "ltr");
	  }
	
	  function bidiLeft(part) { return part.level % 2 ? part.to : part.from; }
	  function bidiRight(part) { return part.level % 2 ? part.from : part.to; }
	
	  function lineLeft(line) { var order = getOrder(line); return order ? bidiLeft(order[0]) : 0; }
	  function lineRight(line) {
	    var order = getOrder(line);
	    if (!order) return line.text.length;
	    return bidiRight(lst(order));
	  }
	
	  function lineStart(cm, lineN) {
	    var line = getLine(cm.doc, lineN);
	    var visual = visualLine(line);
	    if (visual != line) lineN = lineNo(visual);
	    var order = getOrder(visual);
	    var ch = !order ? 0 : order[0].level % 2 ? lineRight(visual) : lineLeft(visual);
	    return Pos(lineN, ch);
	  }
	  function lineEnd(cm, lineN) {
	    var merged, line = getLine(cm.doc, lineN);
	    while (merged = collapsedSpanAtEnd(line)) {
	      line = merged.find(1, true).line;
	      lineN = null;
	    }
	    var order = getOrder(line);
	    var ch = !order ? line.text.length : order[0].level % 2 ? lineLeft(line) : lineRight(line);
	    return Pos(lineN == null ? lineNo(line) : lineN, ch);
	  }
	  function lineStartSmart(cm, pos) {
	    var start = lineStart(cm, pos.line);
	    var line = getLine(cm.doc, start.line);
	    var order = getOrder(line);
	    if (!order || order[0].level == 0) {
	      var firstNonWS = Math.max(0, line.text.search(/\S/));
	      var inWS = pos.line == start.line && pos.ch <= firstNonWS && pos.ch;
	      return Pos(start.line, inWS ? 0 : firstNonWS);
	    }
	    return start;
	  }
	
	  function compareBidiLevel(order, a, b) {
	    var linedir = order[0].level;
	    if (a == linedir) return true;
	    if (b == linedir) return false;
	    return a < b;
	  }
	  var bidiOther;
	  function getBidiPartAt(order, pos) {
	    bidiOther = null;
	    for (var i = 0, found; i < order.length; ++i) {
	      var cur = order[i];
	      if (cur.from < pos && cur.to > pos) return i;
	      if ((cur.from == pos || cur.to == pos)) {
	        if (found == null) {
	          found = i;
	        } else if (compareBidiLevel(order, cur.level, order[found].level)) {
	          if (cur.from != cur.to) bidiOther = found;
	          return i;
	        } else {
	          if (cur.from != cur.to) bidiOther = i;
	          return found;
	        }
	      }
	    }
	    return found;
	  }
	
	  function moveInLine(line, pos, dir, byUnit) {
	    if (!byUnit) return pos + dir;
	    do pos += dir;
	    while (pos > 0 && isExtendingChar(line.text.charAt(pos)));
	    return pos;
	  }
	
	  // This is needed in order to move 'visually' through bi-directional
	  // text -- i.e., pressing left should make the cursor go left, even
	  // when in RTL text. The tricky part is the 'jumps', where RTL and
	  // LTR text touch each other. This often requires the cursor offset
	  // to move more than one unit, in order to visually move one unit.
	  function moveVisually(line, start, dir, byUnit) {
	    var bidi = getOrder(line);
	    if (!bidi) return moveLogically(line, start, dir, byUnit);
	    var pos = getBidiPartAt(bidi, start), part = bidi[pos];
	    var target = moveInLine(line, start, part.level % 2 ? -dir : dir, byUnit);
	
	    for (;;) {
	      if (target > part.from && target < part.to) return target;
	      if (target == part.from || target == part.to) {
	        if (getBidiPartAt(bidi, target) == pos) return target;
	        part = bidi[pos += dir];
	        return (dir > 0) == part.level % 2 ? part.to : part.from;
	      } else {
	        part = bidi[pos += dir];
	        if (!part) return null;
	        if ((dir > 0) == part.level % 2)
	          target = moveInLine(line, part.to, -1, byUnit);
	        else
	          target = moveInLine(line, part.from, 1, byUnit);
	      }
	    }
	  }
	
	  function moveLogically(line, start, dir, byUnit) {
	    var target = start + dir;
	    if (byUnit) while (target > 0 && isExtendingChar(line.text.charAt(target))) target += dir;
	    return target < 0 || target > line.text.length ? null : target;
	  }
	
	  // Bidirectional ordering algorithm
	  // See http://unicode.org/reports/tr9/tr9-13.html for the algorithm
	  // that this (partially) implements.
	
	  // One-char codes used for character types:
	  // L (L):   Left-to-Right
	  // R (R):   Right-to-Left
	  // r (AL):  Right-to-Left Arabic
	  // 1 (EN):  European Number
	  // + (ES):  European Number Separator
	  // % (ET):  European Number Terminator
	  // n (AN):  Arabic Number
	  // , (CS):  Common Number Separator
	  // m (NSM): Non-Spacing Mark
	  // b (BN):  Boundary Neutral
	  // s (B):   Paragraph Separator
	  // t (S):   Segment Separator
	  // w (WS):  Whitespace
	  // N (ON):  Other Neutrals
	
	  // Returns null if characters are ordered as they appear
	  // (left-to-right), or an array of sections ({from, to, level}
	  // objects) in the order in which they occur visually.
	  var bidiOrdering = (function() {
	    // Character types for codepoints 0 to 0xff
	    var lowTypes = "bbbbbbbbbtstwsbbbbbbbbbbbbbbssstwNN%%%NNNNNN,N,N1111111111NNNNNNNLLLLLLLLLLLLLLLLLLLLLLLLLLNNNNNNLLLLLLLLLLLLLLLLLLLLLLLLLLNNNNbbbbbbsbbbbbbbbbbbbbbbbbbbbbbbbbb,N%%%%NNNNLNNNNN%%11NLNNN1LNNNNNLLLLLLLLLLLLLLLLLLLLLLLNLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLN";
	    // Character types for codepoints 0x600 to 0x6ff
	    var arabicTypes = "rrrrrrrrrrrr,rNNmmmmmmrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrmmmmmmmmmmmmmmrrrrrrrnnnnnnnnnn%nnrrrmrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrmmmmmmmmmmmmmmmmmmmNmmmm";
	    function charType(code) {
	      if (code <= 0xf7) return lowTypes.charAt(code);
	      else if (0x590 <= code && code <= 0x5f4) return "R";
	      else if (0x600 <= code && code <= 0x6ed) return arabicTypes.charAt(code - 0x600);
	      else if (0x6ee <= code && code <= 0x8ac) return "r";
	      else if (0x2000 <= code && code <= 0x200b) return "w";
	      else if (code == 0x200c) return "b";
	      else return "L";
	    }
	
	    var bidiRE = /[\u0590-\u05f4\u0600-\u06ff\u0700-\u08ac]/;
	    var isNeutral = /[stwN]/, isStrong = /[LRr]/, countsAsLeft = /[Lb1n]/, countsAsNum = /[1n]/;
	    // Browsers seem to always treat the boundaries of block elements as being L.
	    var outerType = "L";
	
	    function BidiSpan(level, from, to) {
	      this.level = level;
	      this.from = from; this.to = to;
	    }
	
	    return function(str) {
	      if (!bidiRE.test(str)) return false;
	      var len = str.length, types = [];
	      for (var i = 0, type; i < len; ++i)
	        types.push(type = charType(str.charCodeAt(i)));
	
	      // W1. Examine each non-spacing mark (NSM) in the level run, and
	      // change the type of the NSM to the type of the previous
	      // character. If the NSM is at the start of the level run, it will
	      // get the type of sor.
	      for (var i = 0, prev = outerType; i < len; ++i) {
	        var type = types[i];
	        if (type == "m") types[i] = prev;
	        else prev = type;
	      }
	
	      // W2. Search backwards from each instance of a European number
	      // until the first strong type (R, L, AL, or sor) is found. If an
	      // AL is found, change the type of the European number to Arabic
	      // number.
	      // W3. Change all ALs to R.
	      for (var i = 0, cur = outerType; i < len; ++i) {
	        var type = types[i];
	        if (type == "1" && cur == "r") types[i] = "n";
	        else if (isStrong.test(type)) { cur = type; if (type == "r") types[i] = "R"; }
	      }
	
	      // W4. A single European separator between two European numbers
	      // changes to a European number. A single common separator between
	      // two numbers of the same type changes to that type.
	      for (var i = 1, prev = types[0]; i < len - 1; ++i) {
	        var type = types[i];
	        if (type == "+" && prev == "1" && types[i+1] == "1") types[i] = "1";
	        else if (type == "," && prev == types[i+1] &&
	                 (prev == "1" || prev == "n")) types[i] = prev;
	        prev = type;
	      }
	
	      // W5. A sequence of European terminators adjacent to European
	      // numbers changes to all European numbers.
	      // W6. Otherwise, separators and terminators change to Other
	      // Neutral.
	      for (var i = 0; i < len; ++i) {
	        var type = types[i];
	        if (type == ",") types[i] = "N";
	        else if (type == "%") {
	          for (var end = i + 1; end < len && types[end] == "%"; ++end) {}
	          var replace = (i && types[i-1] == "!") || (end < len && types[end] == "1") ? "1" : "N";
	          for (var j = i; j < end; ++j) types[j] = replace;
	          i = end - 1;
	        }
	      }
	
	      // W7. Search backwards from each instance of a European number
	      // until the first strong type (R, L, or sor) is found. If an L is
	      // found, then change the type of the European number to L.
	      for (var i = 0, cur = outerType; i < len; ++i) {
	        var type = types[i];
	        if (cur == "L" && type == "1") types[i] = "L";
	        else if (isStrong.test(type)) cur = type;
	      }
	
	      // N1. A sequence of neutrals takes the direction of the
	      // surrounding strong text if the text on both sides has the same
	      // direction. European and Arabic numbers act as if they were R in
	      // terms of their influence on neutrals. Start-of-level-run (sor)
	      // and end-of-level-run (eor) are used at level run boundaries.
	      // N2. Any remaining neutrals take the embedding direction.
	      for (var i = 0; i < len; ++i) {
	        if (isNeutral.test(types[i])) {
	          for (var end = i + 1; end < len && isNeutral.test(types[end]); ++end) {}
	          var before = (i ? types[i-1] : outerType) == "L";
	          var after = (end < len ? types[end] : outerType) == "L";
	          var replace = before || after ? "L" : "R";
	          for (var j = i; j < end; ++j) types[j] = replace;
	          i = end - 1;
	        }
	      }
	
	      // Here we depart from the documented algorithm, in order to avoid
	      // building up an actual levels array. Since there are only three
	      // levels (0, 1, 2) in an implementation that doesn't take
	      // explicit embedding into account, we can build up the order on
	      // the fly, without following the level-based algorithm.
	      var order = [], m;
	      for (var i = 0; i < len;) {
	        if (countsAsLeft.test(types[i])) {
	          var start = i;
	          for (++i; i < len && countsAsLeft.test(types[i]); ++i) {}
	          order.push(new BidiSpan(0, start, i));
	        } else {
	          var pos = i, at = order.length;
	          for (++i; i < len && types[i] != "L"; ++i) {}
	          for (var j = pos; j < i;) {
	            if (countsAsNum.test(types[j])) {
	              if (pos < j) order.splice(at, 0, new BidiSpan(1, pos, j));
	              var nstart = j;
	              for (++j; j < i && countsAsNum.test(types[j]); ++j) {}
	              order.splice(at, 0, new BidiSpan(2, nstart, j));
	              pos = j;
	            } else ++j;
	          }
	          if (pos < i) order.splice(at, 0, new BidiSpan(1, pos, i));
	        }
	      }
	      if (order[0].level == 1 && (m = str.match(/^\s+/))) {
	        order[0].from = m[0].length;
	        order.unshift(new BidiSpan(0, 0, m[0].length));
	      }
	      if (lst(order).level == 1 && (m = str.match(/\s+$/))) {
	        lst(order).to -= m[0].length;
	        order.push(new BidiSpan(0, len - m[0].length, len));
	      }
	      if (order[0].level == 2)
	        order.unshift(new BidiSpan(1, order[0].to, order[0].to));
	      if (order[0].level != lst(order).level)
	        order.push(new BidiSpan(order[0].level, len, len));
	
	      return order;
	    };
	  })();
	
	  // THE END
	
	  CodeMirror.version = "5.18.0";
	
	  return CodeMirror;
	});


/***/ }),
/* 1754 */
/***/ (function(module, exports, __webpack_require__) {

	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: http://codemirror.net/LICENSE
	
	(function(mod) {
	  if (true) // CommonJS
	    mod(__webpack_require__(1753));
	  else if (typeof define == "function" && define.amd) // AMD
	    define(["../../lib/codemirror"], mod);
	  else // Plain browser env
	    mod(CodeMirror);
	})(function(CodeMirror) {
	"use strict";
	
	function expressionAllowed(stream, state, backUp) {
	  return /^(?:operator|sof|keyword c|case|new|[\[{}\(,;:]|=>)$/.test(state.lastType) ||
	    (state.lastType == "quasi" && /\{\s*$/.test(stream.string.slice(0, stream.pos - (backUp || 0))))
	}
	
	CodeMirror.defineMode("javascript", function(config, parserConfig) {
	  var indentUnit = config.indentUnit;
	  var statementIndent = parserConfig.statementIndent;
	  var jsonldMode = parserConfig.jsonld;
	  var jsonMode = parserConfig.json || jsonldMode;
	  var isTS = parserConfig.typescript;
	  var wordRE = parserConfig.wordCharacters || /[\w$\xa1-\uffff]/;
	
	  // Tokenizer
	
	  var keywords = function(){
	    function kw(type) {return {type: type, style: "keyword"};}
	    var A = kw("keyword a"), B = kw("keyword b"), C = kw("keyword c");
	    var operator = kw("operator"), atom = {type: "atom", style: "atom"};
	
	    var jsKeywords = {
	      "if": kw("if"), "while": A, "with": A, "else": B, "do": B, "try": B, "finally": B,
	      "return": C, "break": C, "continue": C, "new": kw("new"), "delete": C, "throw": C, "debugger": C,
	      "var": kw("var"), "const": kw("var"), "let": kw("var"),
	      "function": kw("function"), "catch": kw("catch"),
	      "for": kw("for"), "switch": kw("switch"), "case": kw("case"), "default": kw("default"),
	      "in": operator, "typeof": operator, "instanceof": operator,
	      "true": atom, "false": atom, "null": atom, "undefined": atom, "NaN": atom, "Infinity": atom,
	      "this": kw("this"), "class": kw("class"), "super": kw("atom"),
	      "yield": C, "export": kw("export"), "import": kw("import"), "extends": C,
	      "await": C, "async": kw("async")
	    };
	
	    // Extend the 'normal' keywords with the TypeScript language extensions
	    if (isTS) {
	      var type = {type: "variable", style: "variable-3"};
	      var tsKeywords = {
	        // object-like things
	        "interface": kw("class"),
	        "implements": C,
	        "namespace": C,
	        "module": kw("module"),
	        "enum": kw("module"),
	
	        // scope modifiers
	        "public": kw("modifier"),
	        "private": kw("modifier"),
	        "protected": kw("modifier"),
	        "abstract": kw("modifier"),
	
	        // operators
	        "as": operator,
	
	        // types
	        "string": type, "number": type, "boolean": type, "any": type
	      };
	
	      for (var attr in tsKeywords) {
	        jsKeywords[attr] = tsKeywords[attr];
	      }
	    }
	
	    return jsKeywords;
	  }();
	
	  var isOperatorChar = /[+\-*&%=<>!?|~^]/;
	  var isJsonldKeyword = /^@(context|id|value|language|type|container|list|set|reverse|index|base|vocab|graph)"/;
	
	  function readRegexp(stream) {
	    var escaped = false, next, inSet = false;
	    while ((next = stream.next()) != null) {
	      if (!escaped) {
	        if (next == "/" && !inSet) return;
	        if (next == "[") inSet = true;
	        else if (inSet && next == "]") inSet = false;
	      }
	      escaped = !escaped && next == "\\";
	    }
	  }
	
	  // Used as scratch variables to communicate multiple values without
	  // consing up tons of objects.
	  var type, content;
	  function ret(tp, style, cont) {
	    type = tp; content = cont;
	    return style;
	  }
	  function tokenBase(stream, state) {
	    var ch = stream.next();
	    if (ch == '"' || ch == "'") {
	      state.tokenize = tokenString(ch);
	      return state.tokenize(stream, state);
	    } else if (ch == "." && stream.match(/^\d+(?:[eE][+\-]?\d+)?/)) {
	      return ret("number", "number");
	    } else if (ch == "." && stream.match("..")) {
	      return ret("spread", "meta");
	    } else if (/[\[\]{}\(\),;\:\.]/.test(ch)) {
	      return ret(ch);
	    } else if (ch == "=" && stream.eat(">")) {
	      return ret("=>", "operator");
	    } else if (ch == "0" && stream.eat(/x/i)) {
	      stream.eatWhile(/[\da-f]/i);
	      return ret("number", "number");
	    } else if (ch == "0" && stream.eat(/o/i)) {
	      stream.eatWhile(/[0-7]/i);
	      return ret("number", "number");
	    } else if (ch == "0" && stream.eat(/b/i)) {
	      stream.eatWhile(/[01]/i);
	      return ret("number", "number");
	    } else if (/\d/.test(ch)) {
	      stream.match(/^\d*(?:\.\d*)?(?:[eE][+\-]?\d+)?/);
	      return ret("number", "number");
	    } else if (ch == "/") {
	      if (stream.eat("*")) {
	        state.tokenize = tokenComment;
	        return tokenComment(stream, state);
	      } else if (stream.eat("/")) {
	        stream.skipToEnd();
	        return ret("comment", "comment");
	      } else if (expressionAllowed(stream, state, 1)) {
	        readRegexp(stream);
	        stream.match(/^\b(([gimyu])(?![gimyu]*\2))+\b/);
	        return ret("regexp", "string-2");
	      } else {
	        stream.eatWhile(isOperatorChar);
	        return ret("operator", "operator", stream.current());
	      }
	    } else if (ch == "`") {
	      state.tokenize = tokenQuasi;
	      return tokenQuasi(stream, state);
	    } else if (ch == "#") {
	      stream.skipToEnd();
	      return ret("error", "error");
	    } else if (isOperatorChar.test(ch)) {
	      stream.eatWhile(isOperatorChar);
	      return ret("operator", "operator", stream.current());
	    } else if (wordRE.test(ch)) {
	      stream.eatWhile(wordRE);
	      var word = stream.current(), known = keywords.propertyIsEnumerable(word) && keywords[word];
	      return (known && state.lastType != ".") ? ret(known.type, known.style, word) :
	                     ret("variable", "variable", word);
	    }
	  }
	
	  function tokenString(quote) {
	    return function(stream, state) {
	      var escaped = false, next;
	      if (jsonldMode && stream.peek() == "@" && stream.match(isJsonldKeyword)){
	        state.tokenize = tokenBase;
	        return ret("jsonld-keyword", "meta");
	      }
	      while ((next = stream.next()) != null) {
	        if (next == quote && !escaped) break;
	        escaped = !escaped && next == "\\";
	      }
	      if (!escaped) state.tokenize = tokenBase;
	      return ret("string", "string");
	    };
	  }
	
	  function tokenComment(stream, state) {
	    var maybeEnd = false, ch;
	    while (ch = stream.next()) {
	      if (ch == "/" && maybeEnd) {
	        state.tokenize = tokenBase;
	        break;
	      }
	      maybeEnd = (ch == "*");
	    }
	    return ret("comment", "comment");
	  }
	
	  function tokenQuasi(stream, state) {
	    var escaped = false, next;
	    while ((next = stream.next()) != null) {
	      if (!escaped && (next == "`" || next == "$" && stream.eat("{"))) {
	        state.tokenize = tokenBase;
	        break;
	      }
	      escaped = !escaped && next == "\\";
	    }
	    return ret("quasi", "string-2", stream.current());
	  }
	
	  var brackets = "([{}])";
	  // This is a crude lookahead trick to try and notice that we're
	  // parsing the argument patterns for a fat-arrow function before we
	  // actually hit the arrow token. It only works if the arrow is on
	  // the same line as the arguments and there's no strange noise
	  // (comments) in between. Fallback is to only notice when we hit the
	  // arrow, and not declare the arguments as locals for the arrow
	  // body.
	  function findFatArrow(stream, state) {
	    if (state.fatArrowAt) state.fatArrowAt = null;
	    var arrow = stream.string.indexOf("=>", stream.start);
	    if (arrow < 0) return;
	
	    var depth = 0, sawSomething = false;
	    for (var pos = arrow - 1; pos >= 0; --pos) {
	      var ch = stream.string.charAt(pos);
	      var bracket = brackets.indexOf(ch);
	      if (bracket >= 0 && bracket < 3) {
	        if (!depth) { ++pos; break; }
	        if (--depth == 0) { if (ch == "(") sawSomething = true; break; }
	      } else if (bracket >= 3 && bracket < 6) {
	        ++depth;
	      } else if (wordRE.test(ch)) {
	        sawSomething = true;
	      } else if (/["'\/]/.test(ch)) {
	        return;
	      } else if (sawSomething && !depth) {
	        ++pos;
	        break;
	      }
	    }
	    if (sawSomething && !depth) state.fatArrowAt = pos;
	  }
	
	  // Parser
	
	  var atomicTypes = {"atom": true, "number": true, "variable": true, "string": true, "regexp": true, "this": true, "jsonld-keyword": true};
	
	  function JSLexical(indented, column, type, align, prev, info) {
	    this.indented = indented;
	    this.column = column;
	    this.type = type;
	    this.prev = prev;
	    this.info = info;
	    if (align != null) this.align = align;
	  }
	
	  function inScope(state, varname) {
	    for (var v = state.localVars; v; v = v.next)
	      if (v.name == varname) return true;
	    for (var cx = state.context; cx; cx = cx.prev) {
	      for (var v = cx.vars; v; v = v.next)
	        if (v.name == varname) return true;
	    }
	  }
	
	  function parseJS(state, style, type, content, stream) {
	    var cc = state.cc;
	    // Communicate our context to the combinators.
	    // (Less wasteful than consing up a hundred closures on every call.)
	    cx.state = state; cx.stream = stream; cx.marked = null, cx.cc = cc; cx.style = style;
	
	    if (!state.lexical.hasOwnProperty("align"))
	      state.lexical.align = true;
	
	    while(true) {
	      var combinator = cc.length ? cc.pop() : jsonMode ? expression : statement;
	      if (combinator(type, content)) {
	        while(cc.length && cc[cc.length - 1].lex)
	          cc.pop()();
	        if (cx.marked) return cx.marked;
	        if (type == "variable" && inScope(state, content)) return "variable-2";
	        return style;
	      }
	    }
	  }
	
	  // Combinator utils
	
	  var cx = {state: null, column: null, marked: null, cc: null};
	  function pass() {
	    for (var i = arguments.length - 1; i >= 0; i--) cx.cc.push(arguments[i]);
	  }
	  function cont() {
	    pass.apply(null, arguments);
	    return true;
	  }
	  function register(varname) {
	    function inList(list) {
	      for (var v = list; v; v = v.next)
	        if (v.name == varname) return true;
	      return false;
	    }
	    var state = cx.state;
	    cx.marked = "def";
	    if (state.context) {
	      if (inList(state.localVars)) return;
	      state.localVars = {name: varname, next: state.localVars};
	    } else {
	      if (inList(state.globalVars)) return;
	      if (parserConfig.globalVars)
	        state.globalVars = {name: varname, next: state.globalVars};
	    }
	  }
	
	  // Combinators
	
	  var defaultVars = {name: "this", next: {name: "arguments"}};
	  function pushcontext() {
	    cx.state.context = {prev: cx.state.context, vars: cx.state.localVars};
	    cx.state.localVars = defaultVars;
	  }
	  function popcontext() {
	    cx.state.localVars = cx.state.context.vars;
	    cx.state.context = cx.state.context.prev;
	  }
	  function pushlex(type, info) {
	    var result = function() {
	      var state = cx.state, indent = state.indented;
	      if (state.lexical.type == "stat") indent = state.lexical.indented;
	      else for (var outer = state.lexical; outer && outer.type == ")" && outer.align; outer = outer.prev)
	        indent = outer.indented;
	      state.lexical = new JSLexical(indent, cx.stream.column(), type, null, state.lexical, info);
	    };
	    result.lex = true;
	    return result;
	  }
	  function poplex() {
	    var state = cx.state;
	    if (state.lexical.prev) {
	      if (state.lexical.type == ")")
	        state.indented = state.lexical.indented;
	      state.lexical = state.lexical.prev;
	    }
	  }
	  poplex.lex = true;
	
	  function expect(wanted) {
	    function exp(type) {
	      if (type == wanted) return cont();
	      else if (wanted == ";") return pass();
	      else return cont(exp);
	    };
	    return exp;
	  }
	
	  function statement(type, value) {
	    if (type == "var") return cont(pushlex("vardef", value.length), vardef, expect(";"), poplex);
	    if (type == "keyword a") return cont(pushlex("form"), expression, statement, poplex);
	    if (type == "keyword b") return cont(pushlex("form"), statement, poplex);
	    if (type == "{") return cont(pushlex("}"), block, poplex);
	    if (type == ";") return cont();
	    if (type == "if") {
	      if (cx.state.lexical.info == "else" && cx.state.cc[cx.state.cc.length - 1] == poplex)
	        cx.state.cc.pop()();
	      return cont(pushlex("form"), expression, statement, poplex, maybeelse);
	    }
	    if (type == "function") return cont(functiondef);
	    if (type == "for") return cont(pushlex("form"), forspec, statement, poplex);
	    if (type == "variable") return cont(pushlex("stat"), maybelabel);
	    if (type == "switch") return cont(pushlex("form"), expression, pushlex("}", "switch"), expect("{"),
	                                      block, poplex, poplex);
	    if (type == "case") return cont(expression, expect(":"));
	    if (type == "default") return cont(expect(":"));
	    if (type == "catch") return cont(pushlex("form"), pushcontext, expect("("), funarg, expect(")"),
	                                     statement, poplex, popcontext);
	    if (type == "class") return cont(pushlex("form"), className, poplex);
	    if (type == "export") return cont(pushlex("stat"), afterExport, poplex);
	    if (type == "import") return cont(pushlex("stat"), afterImport, poplex);
	    if (type == "module") return cont(pushlex("form"), pattern, pushlex("}"), expect("{"), block, poplex, poplex)
	    if (type == "async") return cont(statement)
	    return pass(pushlex("stat"), expression, expect(";"), poplex);
	  }
	  function expression(type) {
	    return expressionInner(type, false);
	  }
	  function expressionNoComma(type) {
	    return expressionInner(type, true);
	  }
	  function expressionInner(type, noComma) {
	    if (cx.state.fatArrowAt == cx.stream.start) {
	      var body = noComma ? arrowBodyNoComma : arrowBody;
	      if (type == "(") return cont(pushcontext, pushlex(")"), commasep(pattern, ")"), poplex, expect("=>"), body, popcontext);
	      else if (type == "variable") return pass(pushcontext, pattern, expect("=>"), body, popcontext);
	    }
	
	    var maybeop = noComma ? maybeoperatorNoComma : maybeoperatorComma;
	    if (atomicTypes.hasOwnProperty(type)) return cont(maybeop);
	    if (type == "function") return cont(functiondef, maybeop);
	    if (type == "keyword c" || type == "async") return cont(noComma ? maybeexpressionNoComma : maybeexpression);
	    if (type == "(") return cont(pushlex(")"), maybeexpression, expect(")"), poplex, maybeop);
	    if (type == "operator" || type == "spread") return cont(noComma ? expressionNoComma : expression);
	    if (type == "[") return cont(pushlex("]"), arrayLiteral, poplex, maybeop);
	    if (type == "{") return contCommasep(objprop, "}", null, maybeop);
	    if (type == "quasi") return pass(quasi, maybeop);
	    if (type == "new") return cont(maybeTarget(noComma));
	    return cont();
	  }
	  function maybeexpression(type) {
	    if (type.match(/[;\}\)\],]/)) return pass();
	    return pass(expression);
	  }
	  function maybeexpressionNoComma(type) {
	    if (type.match(/[;\}\)\],]/)) return pass();
	    return pass(expressionNoComma);
	  }
	
	  function maybeoperatorComma(type, value) {
	    if (type == ",") return cont(expression);
	    return maybeoperatorNoComma(type, value, false);
	  }
	  function maybeoperatorNoComma(type, value, noComma) {
	    var me = noComma == false ? maybeoperatorComma : maybeoperatorNoComma;
	    var expr = noComma == false ? expression : expressionNoComma;
	    if (type == "=>") return cont(pushcontext, noComma ? arrowBodyNoComma : arrowBody, popcontext);
	    if (type == "operator") {
	      if (/\+\+|--/.test(value)) return cont(me);
	      if (value == "?") return cont(expression, expect(":"), expr);
	      return cont(expr);
	    }
	    if (type == "quasi") { return pass(quasi, me); }
	    if (type == ";") return;
	    if (type == "(") return contCommasep(expressionNoComma, ")", "call", me);
	    if (type == ".") return cont(property, me);
	    if (type == "[") return cont(pushlex("]"), maybeexpression, expect("]"), poplex, me);
	  }
	  function quasi(type, value) {
	    if (type != "quasi") return pass();
	    if (value.slice(value.length - 2) != "${") return cont(quasi);
	    return cont(expression, continueQuasi);
	  }
	  function continueQuasi(type) {
	    if (type == "}") {
	      cx.marked = "string-2";
	      cx.state.tokenize = tokenQuasi;
	      return cont(quasi);
	    }
	  }
	  function arrowBody(type) {
	    findFatArrow(cx.stream, cx.state);
	    return pass(type == "{" ? statement : expression);
	  }
	  function arrowBodyNoComma(type) {
	    findFatArrow(cx.stream, cx.state);
	    return pass(type == "{" ? statement : expressionNoComma);
	  }
	  function maybeTarget(noComma) {
	    return function(type) {
	      if (type == ".") return cont(noComma ? targetNoComma : target);
	      else return pass(noComma ? expressionNoComma : expression);
	    };
	  }
	  function target(_, value) {
	    if (value == "target") { cx.marked = "keyword"; return cont(maybeoperatorComma); }
	  }
	  function targetNoComma(_, value) {
	    if (value == "target") { cx.marked = "keyword"; return cont(maybeoperatorNoComma); }
	  }
	  function maybelabel(type) {
	    if (type == ":") return cont(poplex, statement);
	    return pass(maybeoperatorComma, expect(";"), poplex);
	  }
	  function property(type) {
	    if (type == "variable") {cx.marked = "property"; return cont();}
	  }
	  function objprop(type, value) {
	    if (type == "async") {
	      cx.marked = "property";
	      return cont(objprop);
	    } else if (type == "variable" || cx.style == "keyword") {
	      cx.marked = "property";
	      if (value == "get" || value == "set") return cont(getterSetter);
	      return cont(afterprop);
	    } else if (type == "number" || type == "string") {
	      cx.marked = jsonldMode ? "property" : (cx.style + " property");
	      return cont(afterprop);
	    } else if (type == "jsonld-keyword") {
	      return cont(afterprop);
	    } else if (type == "modifier") {
	      return cont(objprop)
	    } else if (type == "[") {
	      return cont(expression, expect("]"), afterprop);
	    } else if (type == "spread") {
	      return cont(expression);
	    } else if (type == ":") {
	      return pass(afterprop)
	    }
	  }
	  function getterSetter(type) {
	    if (type != "variable") return pass(afterprop);
	    cx.marked = "property";
	    return cont(functiondef);
	  }
	  function afterprop(type) {
	    if (type == ":") return cont(expressionNoComma);
	    if (type == "(") return pass(functiondef);
	  }
	  function commasep(what, end) {
	    function proceed(type, value) {
	      if (type == ",") {
	        var lex = cx.state.lexical;
	        if (lex.info == "call") lex.pos = (lex.pos || 0) + 1;
	        return cont(function(type, value) {
	          if (type == end || value == end) return pass()
	          return pass(what)
	        }, proceed);
	      }
	      if (type == end || value == end) return cont();
	      return cont(expect(end));
	    }
	    return function(type, value) {
	      if (type == end || value == end) return cont();
	      return pass(what, proceed);
	    };
	  }
	  function contCommasep(what, end, info) {
	    for (var i = 3; i < arguments.length; i++)
	      cx.cc.push(arguments[i]);
	    return cont(pushlex(end, info), commasep(what, end), poplex);
	  }
	  function block(type) {
	    if (type == "}") return cont();
	    return pass(statement, block);
	  }
	  function maybetype(type) {
	    if (isTS && type == ":") return cont(typeexpr);
	  }
	  function maybedefault(_, value) {
	    if (value == "=") return cont(expressionNoComma);
	  }
	  function typeexpr(type) {
	    if (type == "variable") {cx.marked = "variable-3"; return cont(afterType);}
	    if (type == "{") return cont(commasep(typeprop, "}"))
	    if (type == "(") return cont(commasep(typearg, ")"), maybeReturnType)
	  }
	  function maybeReturnType(type) {
	    if (type == "=>") return cont(typeexpr)
	  }
	  function typeprop(type) {
	    if (type == "variable" || cx.style == "keyword") {
	      cx.marked = "property"
	      return cont(typeprop)
	    } else if (type == ":") {
	      return cont(typeexpr)
	    }
	  }
	  function typearg(type) {
	    if (type == "variable") return cont(typearg)
	    else if (type == ":") return cont(typeexpr)
	  }
	  function afterType(type, value) {
	    if (value == "<") return cont(commasep(typeexpr, ">"), afterType)
	    if (type == "[") return cont(expect("]"), afterType)
	  }
	  function vardef() {
	    return pass(pattern, maybetype, maybeAssign, vardefCont);
	  }
	  function pattern(type, value) {
	    if (type == "modifier") return cont(pattern)
	    if (type == "variable") { register(value); return cont(); }
	    if (type == "spread") return cont(pattern);
	    if (type == "[") return contCommasep(pattern, "]");
	    if (type == "{") return contCommasep(proppattern, "}");
	  }
	  function proppattern(type, value) {
	    if (type == "variable" && !cx.stream.match(/^\s*:/, false)) {
	      register(value);
	      return cont(maybeAssign);
	    }
	    if (type == "variable") cx.marked = "property";
	    if (type == "spread") return cont(pattern);
	    if (type == "}") return pass();
	    return cont(expect(":"), pattern, maybeAssign);
	  }
	  function maybeAssign(_type, value) {
	    if (value == "=") return cont(expressionNoComma);
	  }
	  function vardefCont(type) {
	    if (type == ",") return cont(vardef);
	  }
	  function maybeelse(type, value) {
	    if (type == "keyword b" && value == "else") return cont(pushlex("form", "else"), statement, poplex);
	  }
	  function forspec(type) {
	    if (type == "(") return cont(pushlex(")"), forspec1, expect(")"), poplex);
	  }
	  function forspec1(type) {
	    if (type == "var") return cont(vardef, expect(";"), forspec2);
	    if (type == ";") return cont(forspec2);
	    if (type == "variable") return cont(formaybeinof);
	    return pass(expression, expect(";"), forspec2);
	  }
	  function formaybeinof(_type, value) {
	    if (value == "in" || value == "of") { cx.marked = "keyword"; return cont(expression); }
	    return cont(maybeoperatorComma, forspec2);
	  }
	  function forspec2(type, value) {
	    if (type == ";") return cont(forspec3);
	    if (value == "in" || value == "of") { cx.marked = "keyword"; return cont(expression); }
	    return pass(expression, expect(";"), forspec3);
	  }
	  function forspec3(type) {
	    if (type != ")") cont(expression);
	  }
	  function functiondef(type, value) {
	    if (value == "*") {cx.marked = "keyword"; return cont(functiondef);}
	    if (type == "variable") {register(value); return cont(functiondef);}
	    if (type == "(") return cont(pushcontext, pushlex(")"), commasep(funarg, ")"), poplex, maybetype, statement, popcontext);
	  }
	  function funarg(type) {
	    if (type == "spread") return cont(funarg);
	    return pass(pattern, maybetype, maybedefault);
	  }
	  function className(type, value) {
	    if (type == "variable") {register(value); return cont(classNameAfter);}
	  }
	  function classNameAfter(type, value) {
	    if (value == "extends") return cont(isTS ? typeexpr : expression, classNameAfter);
	    if (type == "{") return cont(pushlex("}"), classBody, poplex);
	  }
	  function classBody(type, value) {
	    if (type == "variable" || cx.style == "keyword") {
	      if (value == "static") {
	        cx.marked = "keyword";
	        return cont(classBody);
	      }
	      cx.marked = "property";
	      if (value == "get" || value == "set") return cont(classGetterSetter, functiondef, classBody);
	      return cont(functiondef, classBody);
	    }
	    if (value == "*") {
	      cx.marked = "keyword";
	      return cont(classBody);
	    }
	    if (type == ";") return cont(classBody);
	    if (type == "}") return cont();
	  }
	  function classGetterSetter(type) {
	    if (type != "variable") return pass();
	    cx.marked = "property";
	    return cont();
	  }
	  function afterExport(_type, value) {
	    if (value == "*") { cx.marked = "keyword"; return cont(maybeFrom, expect(";")); }
	    if (value == "default") { cx.marked = "keyword"; return cont(expression, expect(";")); }
	    return pass(statement);
	  }
	  function afterImport(type) {
	    if (type == "string") return cont();
	    return pass(importSpec, maybeFrom);
	  }
	  function importSpec(type, value) {
	    if (type == "{") return contCommasep(importSpec, "}");
	    if (type == "variable") register(value);
	    if (value == "*") cx.marked = "keyword";
	    return cont(maybeAs);
	  }
	  function maybeAs(_type, value) {
	    if (value == "as") { cx.marked = "keyword"; return cont(importSpec); }
	  }
	  function maybeFrom(_type, value) {
	    if (value == "from") { cx.marked = "keyword"; return cont(expression); }
	  }
	  function arrayLiteral(type) {
	    if (type == "]") return cont();
	    return pass(commasep(expressionNoComma, "]"));
	  }
	
	  function isContinuedStatement(state, textAfter) {
	    return state.lastType == "operator" || state.lastType == "," ||
	      isOperatorChar.test(textAfter.charAt(0)) ||
	      /[,.]/.test(textAfter.charAt(0));
	  }
	
	  // Interface
	
	  return {
	    startState: function(basecolumn) {
	      var state = {
	        tokenize: tokenBase,
	        lastType: "sof",
	        cc: [],
	        lexical: new JSLexical((basecolumn || 0) - indentUnit, 0, "block", false),
	        localVars: parserConfig.localVars,
	        context: parserConfig.localVars && {vars: parserConfig.localVars},
	        indented: basecolumn || 0
	      };
	      if (parserConfig.globalVars && typeof parserConfig.globalVars == "object")
	        state.globalVars = parserConfig.globalVars;
	      return state;
	    },
	
	    token: function(stream, state) {
	      if (stream.sol()) {
	        if (!state.lexical.hasOwnProperty("align"))
	          state.lexical.align = false;
	        state.indented = stream.indentation();
	        findFatArrow(stream, state);
	      }
	      if (state.tokenize != tokenComment && stream.eatSpace()) return null;
	      var style = state.tokenize(stream, state);
	      if (type == "comment") return style;
	      state.lastType = type == "operator" && (content == "++" || content == "--") ? "incdec" : type;
	      return parseJS(state, style, type, content, stream);
	    },
	
	    indent: function(state, textAfter) {
	      if (state.tokenize == tokenComment) return CodeMirror.Pass;
	      if (state.tokenize != tokenBase) return 0;
	      var firstChar = textAfter && textAfter.charAt(0), lexical = state.lexical;
	      // Kludge to prevent 'maybelse' from blocking lexical scope pops
	      if (!/^\s*else\b/.test(textAfter)) for (var i = state.cc.length - 1; i >= 0; --i) {
	        var c = state.cc[i];
	        if (c == poplex) lexical = lexical.prev;
	        else if (c != maybeelse) break;
	      }
	      if (lexical.type == "stat" && firstChar == "}") lexical = lexical.prev;
	      if (statementIndent && lexical.type == ")" && lexical.prev.type == "stat")
	        lexical = lexical.prev;
	      var type = lexical.type, closing = firstChar == type;
	
	      if (type == "vardef") return lexical.indented + (state.lastType == "operator" || state.lastType == "," ? lexical.info + 1 : 0);
	      else if (type == "form" && firstChar == "{") return lexical.indented;
	      else if (type == "form") return lexical.indented + indentUnit;
	      else if (type == "stat")
	        return lexical.indented + (isContinuedStatement(state, textAfter) ? statementIndent || indentUnit : 0);
	      else if (lexical.info == "switch" && !closing && parserConfig.doubleIndentSwitch != false)
	        return lexical.indented + (/^(?:case|default)\b/.test(textAfter) ? indentUnit : 2 * indentUnit);
	      else if (lexical.align) return lexical.column + (closing ? 0 : 1);
	      else return lexical.indented + (closing ? 0 : indentUnit);
	    },
	
	    electricInput: /^\s*(?:case .*?:|default:|\{|\})$/,
	    blockCommentStart: jsonMode ? null : "/*",
	    blockCommentEnd: jsonMode ? null : "*/",
	    lineComment: jsonMode ? null : "//",
	    fold: "brace",
	    closeBrackets: "()[]{}''\"\"``",
	
	    helperType: jsonMode ? "json" : "javascript",
	    jsonldMode: jsonldMode,
	    jsonMode: jsonMode,
	
	    expressionAllowed: expressionAllowed,
	    skipExpression: function(state) {
	      var top = state.cc[state.cc.length - 1]
	      if (top == expression || top == expressionNoComma) state.cc.pop()
	    }
	  };
	});
	
	CodeMirror.registerHelper("wordChars", "javascript", /[\w$]/);
	
	CodeMirror.defineMIME("text/javascript", "javascript");
	CodeMirror.defineMIME("text/ecmascript", "javascript");
	CodeMirror.defineMIME("application/javascript", "javascript");
	CodeMirror.defineMIME("application/x-javascript", "javascript");
	CodeMirror.defineMIME("application/ecmascript", "javascript");
	CodeMirror.defineMIME("application/json", {name: "javascript", json: true});
	CodeMirror.defineMIME("application/x-json", {name: "javascript", json: true});
	CodeMirror.defineMIME("application/ld+json", {name: "javascript", jsonld: true});
	CodeMirror.defineMIME("text/typescript", { name: "javascript", typescript: true });
	CodeMirror.defineMIME("application/typescript", { name: "javascript", typescript: true });
	
	});


/***/ }),
/* 1755 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _materialUi = __webpack_require__(576);
	
	var _close = __webpack_require__(1756);
	
	var _close2 = _interopRequireDefault(_close);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // ================================
	// SYNC WITH FRONTEND/OVERLAYS/BASE
	// ================================
	
	var bodyStyle = {
	  fontSize: 13,
	  color: "#000"
	};
	var bodyStyleSlim = {
	  overflowY: "visible"
	};
	var rootStyle = {
	  overflowY: "scroll",
	  background: "rgba(0, 0, 0, 0.541176)"
	};
	var contentStyle = {
	  position: "relative",
	  width: "90%",
	  paddingBottom: 74
	};
	var overlayStyle = {
	  position: "absolute",
	  background: "none"
	};
	var hiddenTitleStyle = {
	  borderBottom: "none"
	};
	var hiddebActionsContainerStyle = {
	  borderTop: "none"
	};
	
	var BaseOverlay = function (_React$Component) {
	  _inherits(BaseOverlay, _React$Component);
	
	  function BaseOverlay() {
	    _classCallCheck(this, BaseOverlay);
	
	    return _possibleConstructorReturn(this, Object.getPrototypeOf(BaseOverlay).apply(this, arguments));
	  }
	
	  _createClass(BaseOverlay, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.componentWillReceiveProps(this.props);
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps() {
	      var _this2 = this;
	
	      // Modal dismissal
	      // SYNC WITH FRONTEND
	      // Handle tap on bottom padding (see contentStyle ^)
	      // Without this, tap events on the bottom 74 px padding are lost and don't dismiss.
	
	      if (!this.contentNode || this.hasSetUpDismissal) {
	        return;
	      }
	      this.hasSetUpDismissal = true;
	
	      setTimeout(function () {
	        var content = _this2.contentNode.parentNode.parentNode,
	            contentContainer = content.parentNode;
	
	        contentContainer.addEventListener("click", function (e) {
	          if (!content.contains(e.target) && _this2.props.onRequestClose && !_this2.props.disableBackgroundDismiss) {
	            e.preventDefault();
	            e.stopPropagation();
	            _this2.props.onRequestClose();
	          }
	        });
	      }, 100); // wait for container to mount before adding listener
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this3 = this;
	
	      var _props = this.props;
	      var children = _props.children;
	      var useMuiDefaultStyle = _props.useMuiDefaultStyle;
	      var hideTitleAndFooterBorders = _props.hideTitleAndFooterBorders;
	      var titleStyle = _props.titleStyle;
	      var actionsContainerStyle = _props.actionsContainerStyle;
	      var dialogContentStyle = _props.dialogContentStyle;
	      var onRequestClose = _props.onRequestClose;
	
	      var others = _objectWithoutProperties(_props, ["children", "useMuiDefaultStyle", "hideTitleAndFooterBorders", "titleStyle", "actionsContainerStyle", "dialogContentStyle", "onRequestClose"]);
	
	      if (hideTitleAndFooterBorders) {
	        titleStyle = Object.assign({}, hiddenTitleStyle, titleStyle);
	        actionsContainerStyle = Object.assign({}, hiddebActionsContainerStyle, actionsContainerStyle);
	      }
	
	      return _react2.default.createElement(
	        _materialUi.Dialog,
	        _extends({
	          open: true,
	          bodyStyle: !useMuiDefaultStyle ? bodyStyle : bodyStyleSlim,
	          style: rootStyle,
	          contentStyle: Object.assign({}, contentStyle, dialogContentStyle),
	          overlayStyle: overlayStyle,
	          titleStyle: titleStyle,
	          actionsContainerStyle: actionsContainerStyle,
	          autoDetectWindowHeight: false,
	          onRequestClose: this.props.disableBackgroundDismiss ? undefined : onRequestClose
	        }, others),
	        _react2.default.createElement(
	          "div",
	          {
	            ref: function ref(r) {
	              _this3.contentNode = r;
	            }
	          },
	          this.props.showCloseButton ? _react2.default.createElement(_close2.default, {
	            style: {
	              width: 20,
	              height: 20,
	              position: "absolute",
	              right: 24,
	              top: 24,
	              cursor: "pointer"
	            },
	            onTouchTap: this.props.onRequestClose
	          }) : null,
	          this.props.children
	        )
	      );
	    }
	  }]);
	
	  return BaseOverlay;
	}(_react2.default.Component);
	
	exports.default = BaseOverlay;
	module.exports = exports["default"];

/***/ }),
/* 1756 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(608);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(615);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NavigationClose = function NavigationClose(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z' })
	  );
	};
	NavigationClose = (0, _pure2.default)(NavigationClose);
	NavigationClose.displayName = 'NavigationClose';
	NavigationClose.muiName = 'SvgIcon';
	
	exports.default = NavigationClose;

/***/ }),
/* 1757 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _config = __webpack_require__(1173);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _workingIndicator = __webpack_require__(1664);
	
	var _workingIndicator2 = _interopRequireDefault(_workingIndicator);
	
	var _connectToStores = __webpack_require__(1226);
	
	var _connectToStores2 = _interopRequireDefault(_connectToStores);
	
	var _UserStore = __webpack_require__(974);
	
	var _UserStore2 = _interopRequireDefault(_UserStore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Account = function (_React$Component) {
	  _inherits(Account, _React$Component);
	
	  function Account(props) {
	    _classCallCheck(this, Account);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(Account).call(this, props));
	
	    _this.getScannerImgUrl = _this.getScannerImgUrl.bind(_this);
	    return _this;
	  }
	
	  _createClass(Account, [{
	    key: "getScannerImgUrl",
	    value: function getScannerImgUrl() {
	      var url = _config2.default.endpoint + "users/self/api_keys/qr.svg?api_key=" + this.props.apiKey + "&scope=ticket-scanner";
	      if (_UserStore2.default.isGod()) {
	        url += "&god_become_user=" + _UserStore2.default.getGodCredentials().activeUser;
	      }
	      return url;
	    }
	  }, {
	    key: "getStyles",
	    value: function getStyles() {
	      return {
	        body: {
	          fontSize: "12pt"
	        },
	        image: {
	          width: "100%",
	          maxWidth: 250,
	          border: "1px solid #ccc"
	        }
	      };
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var styles = this.getStyles();
	
	      if (!this.props.apiKey) {
	        return _react2.default.createElement(_workingIndicator2.default, { fullPage: true });
	      }
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          "h1",
	          null,
	          "Eventive Scanner"
	        ),
	        _react2.default.createElement(
	          "p",
	          { style: styles.body },
	          "Eventive Scanner is a mobile application (iOS and Android) that allows you to quickly and easily scan and sell tickets and passes at the door.",
	          _react2.default.createElement("br", null),
	          _react2.default.createElement(
	            "a",
	            { href: "https://help.eventive.org/en/articles/892280-eventive-scanner", target: "_blank" },
	            "Learn more about Eventive Scanner."
	          )
	        ),
	        _react2.default.createElement(
	          "h2",
	          null,
	          "Using Eventive Scanner"
	        ),
	        _react2.default.createElement(
	          "p",
	          { style: styles.body },
	          "We offer a",
	          " ",
	          _react2.default.createElement(
	            "a",
	            {
	              href: "https://help.eventive.org/eventive-scanner/introducing-eventive-scanner",
	              target: "_blank"
	            },
	            "dedicated scanner for rent"
	          ),
	          " ",
	          "to meet your festival's needs.",
	          _react2.default.createElement("br", null),
	          "You can also install our free standalone iOS or Android application for use on an unlimited number of devices."
	        ),
	        _react2.default.createElement(
	          "p",
	          { style: styles.body },
	          _react2.default.createElement(
	            "a",
	            {
	              href: "https://itunes.apple.com/US/app/id1052529739?mt=8",
	              target: "_blank"
	            },
	            _react2.default.createElement("img", { src: "/img/download-on-app-store.svg" })
	          ),
	          _react2.default.createElement(
	            "a",
	            {
	              href: "https://play.google.com/store/apps/details?id=org.eventive.scanner",
	              target: "_blank"
	            },
	            _react2.default.createElement("img", { src: "/img/download-on-google-play.png", style: { paddingLeft: 15, width: 135 } })
	          )
	        ),
	        _react2.default.createElement(
	          "h2",
	          null,
	          "Authentication QR code for ",
	          this.props.data.owner.organization
	        ),
	        _react2.default.createElement(
	          "p",
	          { style: styles.body },
	          "After installing the app, just scan the code below to login as",
	          " ",
	          this.props.data.owner.organization,
	          "."
	        ),
	        _react2.default.createElement("img", { style: styles.image, src: this.getScannerImgUrl() })
	      );
	    }
	  }], [{
	    key: "getStores",
	    value: function getStores() {
	      return [_UserStore2.default];
	    }
	  }, {
	    key: "getPropsFromStores",
	    value: function getPropsFromStores() {
	      return _UserStore2.default.getState();
	    }
	  }, {
	    key: "contextTypes",
	    get: function get() {
	      return {
	        router: _react2.default.PropTypes.object
	      };
	    }
	  }]);
	
	  return Account;
	}(_react2.default.Component);
	
	exports.default = (0, _connectToStores2.default)(Account);
	module.exports = exports["default"];

/***/ }),
/* 1758 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _connectToStores = __webpack_require__(1226);
	
	var _connectToStores2 = _interopRequireDefault(_connectToStores);
	
	var _UserStore = __webpack_require__(974);
	
	var _UserStore2 = _interopRequireDefault(_UserStore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BoardToken = "0863baab-6a00-eb33-2055-12b62e533a70";
	
	var Feedback = function (_React$Component) {
	  _inherits(Feedback, _React$Component);
	
	  function Feedback(props) {
	    _classCallCheck(this, Feedback);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(Feedback).call(this, props));
	
	    _this.state = {
	      rendered: false
	    };
	    return _this;
	  }
	
	  _createClass(Feedback, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      // prettier-ignore
	      (function (w, d, i, s) {
	        function l() {
	          if (!d.getElementById(i)) {
	            var f = d.getElementsByTagName(s)[0],
	                e = d.createElement(s);e.type = "text/javascript", e.async = !0, e.src = "https://canny.io/sdk.js", f.parentNode.insertBefore(e, f);
	          }
	        }if ("function" != typeof w.Canny) {
	          var c = function c() {
	            c.q.push(arguments);
	          };c.q = [], w.Canny = c, "complete" === d.readyState ? l() : w.attachEvent ? w.attachEvent("onload", l) : w.addEventListener("load", l, !1);
	        }
	      })(window, document, "canny-jssdk", "script");
	      this.componentWillReceiveProps(this.props);
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(newProps) {
	      if (newProps.data && newProps.data.canny_hash && !this.state.rendered) {
	        this.setState({ rendered: true });
	        Canny("render", {
	          boardToken: BoardToken,
	          basePath: "/feedback",
	          ssoToken: newProps.data.canny_hash
	        });
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement("div", { "data-canny": true });
	    }
	  }], [{
	    key: "getStores",
	    value: function getStores() {
	      return [_UserStore2.default];
	    }
	  }, {
	    key: "getPropsFromStores",
	    value: function getPropsFromStores() {
	      return _UserStore2.default.getState();
	    }
	  }]);
	
	  return Feedback;
	}(_react2.default.Component);
	
	exports.default = (0, _connectToStores2.default)(Feedback);
	module.exports = exports["default"];

/***/ }),
/* 1759 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _connectToStores = __webpack_require__(1226);
	
	var _connectToStores2 = _interopRequireDefault(_connectToStores);
	
	var _UserStore = __webpack_require__(974);
	
	var _UserStore2 = _interopRequireDefault(_UserStore);
	
	var _infoNotice = __webpack_require__(1599);
	
	var _infoNotice2 = _interopRequireDefault(_infoNotice);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BOOQABLE_COMPANY = "45612a3d-883c-419d-8041-491810f11f48";
	var SCRIPT_SRC = "https://" + BOOQABLE_COMPANY + ".assets.booqable.com/v2/booqable.js";
	
	var Shop = function (_React$Component) {
	  _inherits(Shop, _React$Component);
	
	  function Shop(props) {
	    _classCallCheck(this, Shop);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(Shop).call(this, props));
	
	    _this.state = {
	      rendered: false
	    };
	    _this.onLoad = _this.onLoad.bind(_this);
	    return _this;
	  }
	
	  _createClass(Shop, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.componentWillReceiveProps(this.props);
	    }
	  }, {
	    key: "onLoad",
	    value: function onLoad() {
	      if (window.Booqable) {
	        window.Booqable.init();
	      }
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(newProps) {
	      if (newProps.data && !this.state.rendered) {
	        this.setState({ rendered: true });
	        window.booqableOptions = {
	          company: BOOQABLE_COMPANY
	        };
	        if (!document.querySelector("script[src=\"" + SCRIPT_SRC + "\"]")) {
	          var script = document.createElement("script");
	          script.type = "text/javascript";
	          script.src = SCRIPT_SRC;
	          script.onload = this.onLoad;
	          document.body.appendChild(script);
	        } else {
	          this.onLoad();
	        }
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          "style",
	          null,
	          "\n          #booqable-launcher {\n            display: block !important;\n            bottom: 20px !important;\n            right: 95px !important;\n          }\n\n          #booqable-sidebar {\n            right: 95px !important;\n          }\n\n          .booqable-product-list-wrapper .booqable-product-list-notice.clickable {\n            margin-top: 30px !important;\n          }\n        "
	        ),
	        _react2.default.createElement(
	          "h1",
	          null,
	          "Eventive Hardware Shop"
	        ),
	        _react2.default.createElement(
	          "p",
	          { style: { fontSize: "12pt" } },
	          "Rent or purchase hardware for your events."
	        ),
	        _react2.default.createElement(
	          _infoNotice2.default,
	          { style: { marginBottom: "2em", fontSize: "10pt" } },
	          "Learn more about",
	          " ",
	          _react2.default.createElement(
	            "a",
	            {
	              href: "https://help.eventive.org/en/articles/5125284-equipment-rentals-purchases",
	              target: "_blank"
	            },
	            "utilizing the Eventive Hardware Shop"
	          ),
	          "."
	        ),
	        _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement(
	            "div",
	            {
	              style: { fontWeight: "bold", fontSize: "14pt", marginBottom: 15 }
	            },
	            "Rental dates"
	          ),
	          _react2.default.createElement(
	            "div",
	            { style: { width: 300 } },
	            _react2.default.createElement("div", { className: "booqable-datepicker" })
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { style: { marginTop: 30 } },
	          _react2.default.createElement(
	            "div",
	            {
	              style: {
	                fontWeight: "bold",
	                fontSize: "14pt",
	                marginBottom: 18
	              }
	            },
	            "Available for rental"
	          ),
	          _react2.default.createElement(
	            "div",
	            { style: { margin: -15 } },
	            _react2.default.createElement("div", {
	              className: "booqable-product-list",
	              "data-categories": "rentals-82a0c498-22a9-4968-9a9e-8d843ce9d1a1"
	            })
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { style: { marginTop: 30 } },
	          _react2.default.createElement(
	            "div",
	            {
	              style: {
	                fontWeight: "bold",
	                fontSize: "14pt",
	                marginBottom: 18
	              }
	            },
	            "Available for purchase"
	          ),
	          _react2.default.createElement(
	            "div",
	            { style: { margin: -15 } },
	            _react2.default.createElement("div", {
	              className: "booqable-product-list",
	              "data-categories": "purchase-ec953cb4-225c-4cf3-9772-4a72c6569e7e"
	            })
	          )
	        )
	      );
	    }
	  }], [{
	    key: "getStores",
	    value: function getStores() {
	      return [_UserStore2.default];
	    }
	  }, {
	    key: "getPropsFromStores",
	    value: function getPropsFromStores() {
	      return _UserStore2.default.getState();
	    }
	  }]);
	
	  return Shop;
	}(_react2.default.Component);
	
	exports.default = (0, _connectToStores2.default)(Shop);
	module.exports = exports["default"];

/***/ }),
/* 1760 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _config = __webpack_require__(1173);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _workingIndicator = __webpack_require__(1664);
	
	var _workingIndicator2 = _interopRequireDefault(_workingIndicator);
	
	var _connectToStores = __webpack_require__(1226);
	
	var _connectToStores2 = _interopRequireDefault(_connectToStores);
	
	var _UserStore = __webpack_require__(974);
	
	var _UserStore2 = _interopRequireDefault(_UserStore);
	
	var _UserUtil = __webpack_require__(1159);
	
	var _UserUtil2 = _interopRequireDefault(_UserUtil);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ApiSetup = function (_React$Component) {
	  _inherits(ApiSetup, _React$Component);
	
	  function ApiSetup(props) {
	    _classCallCheck(this, ApiSetup);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(ApiSetup).call(this, props));
	
	    _this.state = {
	      public: {},
	      secret: {}
	    };
	    return _this;
	  }
	
	  _createClass(ApiSetup, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      _UserUtil2.default.makeApiKey(this.props.apiKey, {
	        scope: "user-public",
	        allow_existing: true,
	        god_become_user: _UserStore2.default.isGod() ? _UserStore2.default.getGodCredentials().activeUser : undefined
	      }).then(function (k) {
	        return _this2.setState({ public: k });
	      });
	      _UserUtil2.default.makeApiKey(this.props.apiKey, {
	        scope: "user-secret",
	        allow_existing: true,
	        god_become_user: _UserStore2.default.isGod() ? _UserStore2.default.getGodCredentials().activeUser : undefined
	      }).then(function (k) {
	        return _this2.setState({ secret: k });
	      });
	    }
	  }, {
	    key: "generate",
	    value: function generate(scope) {
	      var _this3 = this;
	
	      if (window.confirm("Are you sure? All existing " + scope + " keys will stop working immediately and must be replaced with the new key.")) {
	        var oldKey = this.state[scope].key;
	        this.setState(_defineProperty({}, scope, {}));
	
	        _UserUtil2.default.deleteApiKey(this.props.apiKey, oldKey).then(function () {
	          return _UserUtil2.default.makeApiKey(_this3.props.apiKey, {
	            scope: "user-" + scope,
	            allow_existing: true,
	            god_become_user: _UserStore2.default.isGod() ? _UserStore2.default.getGodCredentials().activeUser : undefined
	          });
	        }).then(function (k) {
	          return _this3.setState(_defineProperty({}, scope, k));
	        });
	      }
	    }
	  }, {
	    key: "getStyles",
	    value: function getStyles() {
	      return {
	        key: { margin: "0.5em 0 0" }
	      };
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var styles = this.getStyles();
	
	      if (!this.props.apiKey) {
	        return _react2.default.createElement(_workingIndicator2.default, { fullPage: true });
	      }
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          "p",
	          null,
	          "The Eventive API allows you to build a fully custom Eventive experience, from backend to frontend to mobile.",
	          _react2.default.createElement("br", null),
	          _react2.default.createElement(
	            "a",
	            {
	              href: "https://help.eventive.org/integrations/eventive-api",
	              target: "_blank"
	            },
	            "Learn more about the Eventive API."
	          )
	        ),
	        _react2.default.createElement(
	          "h2",
	          null,
	          "API keys for ",
	          this.props.data.owner.organization
	        ),
	        _react2.default.createElement(
	          "h3",
	          { style: styles.key },
	          "Public API key:",
	          " ",
	          _react2.default.createElement(
	            "code",
	            null,
	            this.state.public.key || "...loading..."
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          null,
	          "Include in customer-accessible pages (e.g. in client-side JavaScript). For read-only access to events/films, new order flow, etc."
	        ),
	        _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement(
	            "small",
	            null,
	            "Generated: ",
	            this.state.public.created_at || "...loading...",
	            " ",
	            this.state.public.key ? _react2.default.createElement(
	              "span",
	              null,
	              "|",
	              " ",
	              _react2.default.createElement(
	                "a",
	                { href: "#", onClick: this.generate.bind(this, "public") },
	                "Invalidate & generate new key"
	              )
	            ) : null
	          )
	        ),
	        _react2.default.createElement(
	          "h3",
	          { style: styles.key },
	          "Secret API key:",
	          " ",
	          _react2.default.createElement(
	            "code",
	            null,
	            this.state.secret.key || "...loading..."
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          null,
	          "For your backend only. Full read & write access to the Eventive Platform. Never expose to customers."
	        ),
	        _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement(
	            "small",
	            null,
	            "Generated: ",
	            this.state.secret.created_at || "...loading...",
	            " ",
	            this.state.secret.key ? _react2.default.createElement(
	              "span",
	              null,
	              "|",
	              " ",
	              _react2.default.createElement(
	                "a",
	                { href: "#", onClick: this.generate.bind(this, "secret") },
	                "Invalidate & generate new key"
	              )
	            ) : null
	          )
	        )
	      );
	    }
	  }], [{
	    key: "getStores",
	    value: function getStores() {
	      return [_UserStore2.default];
	    }
	  }, {
	    key: "getPropsFromStores",
	    value: function getPropsFromStores() {
	      return _UserStore2.default.getState();
	    }
	  }, {
	    key: "contextTypes",
	    get: function get() {
	      return {
	        router: _react2.default.PropTypes.object
	      };
	    }
	  }]);
	
	  return ApiSetup;
	}(_react2.default.Component);
	
	exports.default = (0, _connectToStores2.default)(ApiSetup);
	module.exports = exports["default"];

/***/ }),
/* 1761 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _values = __webpack_require__(1214);
	
	var _values2 = _interopRequireDefault(_values);
	
	var _pickBy = __webpack_require__(1163);
	
	var _pickBy2 = _interopRequireDefault(_pickBy);
	
	var _materialUi = __webpack_require__(576);
	
	var _reactable = __webpack_require__(1688);
	
	var _reactRouter = __webpack_require__(486);
	
	var _virtualContentTable = __webpack_require__(1762);
	
	var _virtualContentTable2 = _interopRequireDefault(_virtualContentTable);
	
	var _filmTable = __webpack_require__(1763);
	
	var _filmTable2 = _interopRequireDefault(_filmTable);
	
	var _connectToStores = __webpack_require__(1226);
	
	var _connectToStores2 = _interopRequireDefault(_connectToStores);
	
	var _FilmActions = __webpack_require__(1764);
	
	var _FilmActions2 = _interopRequireDefault(_FilmActions);
	
	var _FilmStore = __webpack_require__(1765);
	
	var _FilmStore2 = _interopRequireDefault(_FilmStore);
	
	var _VirtualContentStore = __webpack_require__(1768);
	
	var _VirtualContentStore2 = _interopRequireDefault(_VirtualContentStore);
	
	var _VirtualContentActions = __webpack_require__(1767);
	
	var _VirtualContentActions2 = _interopRequireDefault(_VirtualContentActions);
	
	var _TitleStore = __webpack_require__(1666);
	
	var _TitleStore2 = _interopRequireDefault(_TitleStore);
	
	var _TitleActions = __webpack_require__(1665);
	
	var _TitleActions2 = _interopRequireDefault(_TitleActions);
	
	var _config = __webpack_require__(1173);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _UserStore = __webpack_require__(974);
	
	var _UserStore2 = _interopRequireDefault(_UserStore);
	
	var _workingIndicator = __webpack_require__(1664);
	
	var _workingIndicator2 = _interopRequireDefault(_workingIndicator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Films = function (_React$Component) {
	  _inherits(Films, _React$Component);
	
	  function Films(props) {
	    _classCallCheck(this, Films);
	
	    return _possibleConstructorReturn(this, Object.getPrototypeOf(Films).call(this, props));
	  }
	
	  _createClass(Films, [{
	    key: "getStyles",
	    value: function getStyles() {
	      return {};
	    }
	  }, {
	    key: "componentWillMount",
	    value: function componentWillMount() {
	      _FilmActions2.default.fetchAllForCreator();
	      _VirtualContentActions2.default.fetchAll();
	      _TitleActions2.default.fetchAll();
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var styles = this.getStyles(),
	          titles = (0, _values2.default)((0, _pickBy2.default)(this.props.titleStore.titles, function (f) {
	        return true;
	      })),
	          films = (0, _values2.default)((0, _pickBy2.default)(this.props.filmStore.films, function (f) {
	        return !!f.event_bucket_name && !(f.virtual_content && f.virtual_content.type !== "vod") && !titles.some(function (t) {
	          return t.receiving_film && t.receiving_film.id === f.id && t.receiving_film.title_requested_media && !t.receiving_film.title_requested_media.includes("virtual");
	        } // hide if title delivery but only for print
	        ) && (!_UserStore2.default.getUser() || f.owner_id !== _UserStore2.default.getUser().id);
	      })),
	          virtualContent = _VirtualContentStore2.default.getVirtualContent().filter(function (v) {
	        return v.status !== "pending_upload" && v.status !== "vod_upload_started" && v.type === "vod" && v.platform !== "cinesend" && // Deprecated pathway
	        v.platform !== "eventive";
	      } // Deprecated pathway
	      );
	
	      if (films.length === 0 && _FilmStore2.default.getState().isFetching || virtualContent.length === 0 && _VirtualContentStore2.default.getState().isFetching || titles.length === 0 && _TitleStore2.default.getState().isFetching) {
	        return _react2.default.createElement(_workingIndicator2.default, { fullPage: true });
	      }
	
	      var hasTitles = titles.length > 0;
	
	      var hasVirtualContent = virtualContent.length > 0;
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          "h1",
	          null,
	          "Eventive Creator Hub"
	        ),
	        _react2.default.createElement(
	          "p",
	          { style: { fontSize: "12pt" } },
	          "Welcome to the Creator Hub. Here you can manage all the content you have uploaded to Eventive as well as authorized screenings hosted by other organizations."
	        ),
	        hasTitles ? _react2.default.createElement(
	          "div",
	          { className: "Eventive--TitlesTable" },
	          _react2.default.createElement(
	            "h2",
	            { style: { marginTop: "1em", marginBottom: "0em" } },
	            "Your titles"
	          ),
	          _react2.default.createElement(
	            _reactable.Table,
	            {
	              className: "bordered striped responsive-table",
	              style: { margin: "0.5em 0" },
	              columns: ["Delivery Identifier", "Recipient", "Status", "Actions"]
	            },
	            titles.sort(function (a, b) {
	              return a.name.localeCompare(b.name);
	            }).map(function (title, i) {
	              return [_react2.default.createElement(
	                _reactable.Tr,
	                {
	                  key: title.id,
	                  style: {
	                    backgroundColor: "rgb(2, 136, 209)",
	                    color: "#fff"
	                  }
	                },
	                _react2.default.createElement(
	                  _reactable.Td,
	                  {
	                    column: "Delivery Identifier",
	                    style: {
	                      fontWeight: "bold",
	                      fontSize: "1.25em"
	                    }
	                  },
	                  _react2.default.createElement(
	                    "div",
	                    { style: {} },
	                    _react2.default.createElement(
	                      "span",
	                      { style: { fontFamily: "monospace, sans-serif" } },
	                      title.delivery_identifier_prefix
	                    ),
	                    " ",
	                    "\xB7 ",
	                    title.name
	                  )
	                )
	              )].concat(title.title_deliveries.length ? title.title_deliveries.map(function (titleDelivery, i) {
	                return _react2.default.createElement(
	                  _reactable.Tr,
	                  { key: titleDelivery.id },
	                  _react2.default.createElement(
	                    _reactable.Td,
	                    { column: "Delivery Identifier" },
	                    _react2.default.createElement(
	                      "span",
	                      {
	                        style: {
	                          fontFamily: "monospace, sans-serif"
	                        }
	                      },
	                      titleDelivery.delivery_identifier
	                    )
	                  ),
	                  _react2.default.createElement(
	                    _reactable.Td,
	                    { column: "Recipient" },
	                    _react2.default.createElement(
	                      "span",
	                      null,
	                      titleDelivery.receiving_event_bucket.name,
	                      " (",
	                      titleDelivery.receiving_user.organization,
	                      ")"
	                    )
	                  ),
	                  _react2.default.createElement(
	                    _reactable.Td,
	                    { column: "Status" },
	                    _react2.default.createElement(_filmTable.TitleDeliveryStatus, {
	                      title_delivery: titleDelivery
	                    })
	                  ),
	                  _react2.default.createElement(
	                    _reactable.Td,
	                    { column: "Actions" },
	                    _react2.default.createElement(
	                      _reactRouter.Link,
	                      {
	                        to: "/titles/" + title.id + "/deliveries/" + titleDelivery.id
	                      },
	                      "Manage delivery"
	                    )
	                  )
	                );
	              }) : [_react2.default.createElement(
	                _reactable.Tr,
	                null,
	                _react2.default.createElement(
	                  _reactable.Td,
	                  { column: "Delivery Identifier" },
	                  "No deliveries, yet"
	                )
	              )]);
	            })
	          ),
	          _react2.default.createElement(
	            "style",
	            null,
	            ".Eventive--TitlesTable .reactable-column-header { display: none; }"
	          )
	        ) : null,
	        hasVirtualContent ? _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement(
	            "h2",
	            { style: { marginTop: "1em", marginBottom: "0em" } },
	            "Uploaded content assets"
	          ),
	          _react2.default.createElement(_virtualContentTable2.default, { virtualContent: virtualContent }),
	          _react2.default.createElement(
	            "h2",
	            { style: { marginTop: "1em", marginBottom: "0em" } },
	            "Screenings"
	          )
	        ) : null,
	        _react2.default.createElement(_filmTable2.default, { films: films, creatorView: true })
	      );
	    }
	  }], [{
	    key: "getStores",
	    value: function getStores() {
	      return [_UserStore2.default, _FilmStore2.default, _VirtualContentStore2.default, _TitleStore2.default];
	    }
	  }, {
	    key: "getPropsFromStores",
	    value: function getPropsFromStores() {
	      return {
	        filmStore: _FilmStore2.default.getState(),
	        titleStore: _TitleStore2.default.getState()
	      };
	    }
	  }, {
	    key: "contextTypes",
	    get: function get() {
	      return {
	        router: _react2.default.PropTypes.object
	      };
	    }
	  }]);
	
	  return Films;
	}(_react2.default.Component);
	
	exports.default = (0, _connectToStores2.default)(Films);
	module.exports = exports["default"];

/***/ }),
/* 1762 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(486);
	
	var _reactable = __webpack_require__(1688);
	
	var _filmTable = __webpack_require__(1763);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FilmTable = function (_React$Component) {
	  _inherits(FilmTable, _React$Component);
	
	  function FilmTable(props) {
	    _classCallCheck(this, FilmTable);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(FilmTable).call(this, props));
	
	    _this._makeRowForEvent = _this._makeRowForEvent.bind(_this);
	    return _this;
	  }
	
	  _createClass(FilmTable, [{
	    key: "getStyles",
	    value: function getStyles() {
	      return {};
	    }
	  }, {
	    key: "_makeRowForEvent",
	    value: function _makeRowForEvent(virtualContent) {
	      return _react2.default.createElement(
	        _reactable.Tr,
	        { key: virtualContent.id },
	        _react2.default.createElement(
	          _reactable.Td,
	          { column: "Label" },
	          virtualContent.label
	        ),
	        _react2.default.createElement(
	          _reactable.Td,
	          { column: "Status" },
	          _react2.default.createElement(_filmTable.Status, { virtual_content: virtualContent, detailed: false })
	        ),
	        _react2.default.createElement(
	          _reactable.Td,
	          { column: "Actions" },
	          _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(
	              _reactRouter.Link,
	              {
	                to: {
	                  pathname: "/creator_hub/virtual_content/" + virtualContent.id,
	                  state: { fromListing: true }
	                }
	              },
	              "Manage asset"
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var styles = this.getStyles();
	      var virtualContent = this.props.virtualContent;
	
	
	      var tableProps = {
	        className: "bordered striped responsive-table",
	        sortable: ["Label", "Status"],
	        defaultSort: { column: "Label", direction: "asc" },
	        columns: ["Label", "Status", "Actions"],
	        filterable: ["Label", "Status"]
	      };
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          "style",
	          null,
	          "\n          .reactable-filterer input {\n            width: 200px;\n          }\n        "
	        ),
	        _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement(
	            _reactable.Table,
	            _extends({}, tableProps, {
	              filterPlaceholder: "Type to filter content assets..."
	            }),
	            virtualContent.map(function (v) {
	              return _this2._makeRowForEvent(v);
	            })
	          )
	        )
	      );
	    }
	  }]);
	
	  return FilmTable;
	}(_react2.default.Component);
	
	exports.default = FilmTable;
	module.exports = exports["default"];

/***/ }),
/* 1763 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.TitleDeliveryStatus = exports.Status = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(486);
	
	var _reactable = __webpack_require__(1688);
	
	var _styles = __webpack_require__(917);
	
	var _util = __webpack_require__(1183);
	
	var _EventBucketStore = __webpack_require__(1593);
	
	var _EventBucketStore2 = _interopRequireDefault(_EventBucketStore);
	
	var _UserStore = __webpack_require__(974);
	
	var _UserStore2 = _interopRequireDefault(_UserStore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SUCCESS_COLOR = "#4CAF50";
	
	var Status = exports.Status = function Status(_ref) {
	  var film = _ref.film;
	  var virtual_content = _ref.virtual_content;
	  var detailed = _ref.detailed;
	  var inWidget = _ref.inWidget;
	
	  if (film && !virtual_content) {
	    virtual_content = film.virtual_content;
	  }
	
	  if (!virtual_content) {
	    if (detailed && !inWidget) {
	      return _react2.default.createElement(
	        "span",
	        null,
	        "\u2013"
	      );
	    } else {
	      return _react2.default.createElement(
	        "span",
	        { style: { fontWeight: "bold", color: _styles.colors.red600 } },
	        inWidget ? "No virtual content" : "Needs upload"
	      );
	    }
	  }
	  var _virtual_content = virtual_content;
	  var type = _virtual_content.type;
	  var status = _virtual_content.status;
	  var label = _virtual_content.label;
	  var platform = _virtual_content.platform;
	  var caption_tracks = _virtual_content.caption_tracks;
	  var status_percent = _virtual_content.status_percent;
	  var status_description = _virtual_content.status_description;
	
	  if (type === "vod") {
	    if (platform === "cinesend" || platform === "eventive") {
	      status = "legacy_unsupported";
	    }
	    var messages = {
	      legacy_unsupported: {
	        message: _react2.default.createElement(
	          "span",
	          null,
	          "No longer supported \u2013 re-upload required",
	          " ",
	          _react2.default.createElement(
	            "a",
	            {
	              href: "https://help.eventive.org/en/articles/5292118-legacy-asset-pathway-deprecation-information-may-2021",
	              target: "_blank"
	            },
	            "(?)"
	          )
	        ),
	        color: _styles.colors.red600
	      },
	      pending_upload: {
	        message: "Upload in progress",
	        color: _styles.colors.orange600
	      },
	      pending_transcoding: {
	        message: "Transcoding in progress",
	        color: _styles.colors.orange600
	      },
	      transcoding_failure: {
	        message: "Transcoding failed",
	        color: _styles.colors.orange600
	      },
	      vod_upload_started: {
	        message: "VOD upload in progress",
	        color: _styles.colors.orange600
	      },
	      vod_upload_failure: {
	        message: "VOD upload failed",
	        color: _styles.colors.orange600
	      },
	      vod_upload_complete: {
	        message: "VOD waiting for transcoding",
	        color: _styles.colors.orange600
	      },
	      vod_transcode_started: {
	        message: (platform || "").indexOf("ev_next") === 0 && !status_percent ? "VOD transcoding queued" : "VOD transcoding in progress" + (status_percent ? " (" + status_percent + "%)" : ""),
	        color: _styles.colors.orange600
	      },
	      vod_transcode_failure: {
	        message: "VOD transcoding failed" + (status_description ? " (" + status_description + ")" : ""),
	        color: _styles.colors.orange600
	      },
	      vod_transcode_complete: {
	        message: "VOD waiting for publishing",
	        color: _styles.colors.orange600
	      },
	      vod_publish_started: {
	        message: "VOD publishing in progress",
	        color: _styles.colors.orange600
	      },
	      vod_publish_failure: {
	        message: "VOD publishing failed" + (status_description ? " (" + status_description + ")" : ""),
	        color: _styles.colors.orange600
	      },
	      ready: {
	        message: _react2.default.createElement(
	          "span",
	          null,
	          "Streaming VOD ready",
	          " ",
	          caption_tracks && caption_tracks.length ? _react2.default.createElement(
	            "span",
	            { title: "Closed captions" },
	            "+",
	            " ",
	            _react2.default.createElement(
	              "svg",
	              {
	                viewBox: "0 0 24 24",
	                fill: "currentColor",
	                style: {
	                  width: 24,
	                  height: 24,
	                  verticalAlign: -3,
	                  margin: "-4px 0"
	                }
	              },
	              _react2.default.createElement("path", { d: "M0 0h24v24H0z", fill: "none" }),
	              _react2.default.createElement("path", { d: "M19 4H5c-1.11 0-2 .9-2 2v12c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm-8 7H9.5v-.5h-2v3h2V13H11v1c0 .55-.45 1-1 1H7c-.55 0-1-.45-1-1v-4c0-.55.45-1 1-1h3c.55 0 1 .45 1 1v1zm7 0h-1.5v-.5h-2v3h2V13H18v1c0 .55-.45 1-1 1h-3c-.55 0-1-.45-1-1v-4c0-.55.45-1 1-1h3c.55 0 1 .45 1 1v1z" })
	            )
	          ) : null
	        ),
	        color: SUCCESS_COLOR
	      }
	    };
	
	    var _ref2 = messages[status] || {
	      message: status,
	      color: _styles.colors.orange600
	    };
	
	    var message = _ref2.message;
	    var color = _ref2.color;
	
	    return _react2.default.createElement(
	      "span",
	      { style: { fontWeight: "bold", color: color } },
	      message,
	      _UserStore2.default.isGod() && _react2.default.createElement(
	        "span",
	        {
	          style: {
	            color: "rgba(0,0,0,0.4)",
	            display: "block",
	            fontSize: "0.7em",
	            marginTop: "0.1em",
	            lineHeight: "1.1em"
	          }
	        },
	        virtual_content.id,
	        " / ",
	        virtual_content.platform,
	        virtual_content.additional_regions ? _react2.default.createElement(
	          "div",
	          { style: { color: "#3194d5", marginTop: "0.1em" } },
	          "Replicated to ",
	          virtual_content.additional_regions.sort().join(", ")
	        ) : null
	      )
	    );
	  } else if (type === "livestream" || type === "broadcast") {
	    var _messages = {
	      livestream_not_created: {
	        message: type === "broadcast" ? "Real-time broadcast ready" : "Not started",
	        color: _styles.colors.red600
	      },
	      livestream_creating: {
	        message: "Starting",
	        color: SUCCESS_COLOR
	      },
	      livestream_creating_preview: {
	        message: "Starting in preview window",
	        color: SUCCESS_COLOR
	      },
	      livestream_previewing: {
	        message: "Started in preview window",
	        color: SUCCESS_COLOR
	      },
	      livestream_previewing_creating: {
	        message: "Going live",
	        color: SUCCESS_COLOR
	      },
	      livestream_create_failure: {
	        message: "Failed to start",
	        color: _styles.colors.red600
	      },
	      livestream_encode_failure: {
	        message: "Live encoding failed",
	        color: _styles.colors.red600
	      },
	      livestream_created: {
	        message: "Started",
	        color: SUCCESS_COLOR
	      },
	      livestream_stopping: {
	        message: "Stopping",
	        color: _styles.colors.red600
	      },
	      livestream_stop_failure: {
	        message: "Failed to stop",
	        color: _styles.colors.red600
	      },
	      livestream_publish_failure: {
	        message: "VOD publishing failed" + (status_description ? " (" + status_description + ")" : ""),
	        color: _styles.colors.orange600
	      },
	      livestream_stopped: {
	        message: "Stopped",
	        color: _styles.colors.red600
	      }
	    };
	    var _messages$status = _messages[status];
	    var _message = _messages$status.message;
	    var _color = _messages$status.color;
	
	    return _react2.default.createElement(
	      "span",
	      { style: { fontWeight: "bold", color: _color } },
	      _message
	    );
	  } else if (type === "external" && status === "ready") {
	    return _react2.default.createElement(
	      "span",
	      { style: { fontWeight: "bold", color: SUCCESS_COLOR } },
	      "External content ready"
	    );
	  }
	  return null;
	};
	
	var TitleDeliveryStatus = exports.TitleDeliveryStatus = function TitleDeliveryStatus(_ref3) {
	  var film = _ref3.film;
	  var title_delivery = _ref3.title_delivery;
	  var extended = _ref3.extended;
	
	  if (film && !title_delivery) {
	    title_delivery = film.title_delivery;
	  }
	
	  var messages = {
	    requested: {
	      message: "Invitation sent to creator",
	      color: _styles.colors.grey600
	    },
	    draft: {
	      message: "Delivery draft started",
	      color: _styles.colors.orange600
	    },
	    submitted_awaiting_delivery: {
	      message: "Awaiting delivery",
	      color: _styles.colors.orange600
	    },
	    delivery_received: {
	      message: "Delivery received, pending QC",
	      color: _styles.colors.green600
	    },
	    action_needed: {
	      message: "Needs action from content creator",
	      color: _styles.colors.red600
	    },
	    delivery_approved: {
	      message: "Delivery approved, asset ready",
	      color: _styles.colors.green600
	    },
	    delivery_approved_missing_virtual: {
	      message: "Print delivery approved, but missing virtual content",
	      color: _styles.colors.red600
	    }
	  };
	
	  var status = title_delivery ? title_delivery.status : film && film.title_requested_media && film.title_requested_media.length ? "requested" : "none";
	
	  // In the case when Simple DCP has approved the print delivery, but the virtual content is missing
	  // (likely because the user chose to manually upload it, but didn't).
	  if (status === "delivery_approved" && film && film.title_requested_media && film.title_requested_media.includes("virtual") && !film.virtual_content) {
	    status = "delivery_approved_missing_virtual";
	  }
	
	  if (status === "none") {
	    return _react2.default.createElement(
	      "span",
	      null,
	      "\u2013"
	    );
	  }
	
	  // fixme - don't show requested items if already uploaded for virtual
	  // if no title requested media do something special (check heartland)
	  var requestedDetail = film && film.title_requested_media && film.title_requested_media.length ? " (" + film.title_requested_media.sort().join(", ") + ")" : "";
	
	  var _messages$status2 = messages[status];
	  var message = _messages$status2.message;
	  var color = _messages$status2.color;
	
	  return _react2.default.createElement(
	    "span",
	    { style: { fontWeight: "bold", color: color } },
	    message,
	    requestedDetail,
	    extended && title_delivery ? _react2.default.createElement(
	      "div",
	      {
	        style: {
	          fontWeight: "normal",
	          color: "rgba(0, 0, 0, 0.4)",
	          fontSize: "9pt"
	        }
	      },
	      _react2.default.createElement(
	        "span",
	        { style: { fontFamily: "monospace, sans-serif" } },
	        title_delivery.delivery_identifier
	      ),
	      title_delivery.status_description ? _react2.default.createElement(
	        "span",
	        null,
	        " \xB7 ",
	        title_delivery.status_description
	      ) : null
	    ) : null
	  );
	};
	
	var FilmTable = function (_React$Component) {
	  _inherits(FilmTable, _React$Component);
	
	  function FilmTable(props) {
	    _classCallCheck(this, FilmTable);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(FilmTable).call(this, props));
	
	    _this._makeRowForEvent = _this._makeRowForEvent.bind(_this);
	    return _this;
	  }
	
	  _createClass(FilmTable, [{
	    key: "getStyles",
	    value: function getStyles() {
	      return {};
	    }
	  }, {
	    key: "_makeRowForEvent",
	    value: function _makeRowForEvent(film, detailed) {
	      return _react2.default.createElement(
	        _reactable.Tr,
	        { key: film.id },
	        _react2.default.createElement(
	          _reactable.Td,
	          { column: "Name" },
	          film.name
	        ),
	        _react2.default.createElement(
	          _reactable.Td,
	          { column: "Date", value: film.start_time },
	          (0, _util.makeEventDateRangeLabel)({
	            is_dated: true,
	            start_time: film.start_time,
	            end_time: film.end_time,
	            timezone: (_EventBucketStore2.default.getEventBucketById(film.event_bucket) || {}).timezone
	          })
	        ),
	        _react2.default.createElement(
	          _reactable.Td,
	          { column: "Event" },
	          film.event_bucket_name
	        ),
	        _react2.default.createElement(
	          _reactable.Td,
	          { column: "Status" },
	          _react2.default.createElement(Status, { film: film, detailed: detailed })
	        ),
	        _react2.default.createElement(
	          _reactable.Td,
	          { column: "Delivery Status" },
	          _react2.default.createElement(TitleDeliveryStatus, {
	            film: film,
	            detailed: detailed,
	            extended: true
	          })
	        ),
	        _react2.default.createElement(
	          _reactable.Td,
	          { column: "Details" },
	          (0, _util.makeFilmDetailString)(film.details)
	        ),
	        _react2.default.createElement(
	          _reactable.Td,
	          { column: "Organization" },
	          film.owner_organization
	        ),
	        _react2.default.createElement(
	          _reactable.Td,
	          { column: "Actions" },
	          this.props.livestreamView ? _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(
	              _reactRouter.Link,
	              {
	                to: {
	                  pathname: "/event_buckets/" + film.event_bucket + "/virtual_festival/live/" + film.id,
	                  state: { fromListing: true }
	                }
	              },
	              "Manage livestream"
	            )
	          ) : this.props.creatorView ? _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(
	              _reactRouter.Link,
	              {
	                to: {
	                  pathname: "/creator_hub/films/" + film.id,
	                  state: { fromListing: true }
	                }
	              },
	              "Manage content"
	            )
	          ) : _UserStore2.default.hasPermission("preview_virtual_screening") && !_UserStore2.default.hasPermission("manage_films") ? _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(
	              _reactRouter.Link,
	              {
	                to: {
	                  pathname: "/event_buckets/" + film.event_bucket + "/films/" + film.id,
	                  state: { fromListing: true }
	                }
	              },
	              "View details"
	            )
	          ) : _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(
	              _reactRouter.Link,
	              {
	                to: {
	                  pathname: "/event_buckets/" + film.event_bucket + "/films/" + film.id + "/edit",
	                  state: { fromListing: true }
	                }
	              },
	              "Edit film"
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var styles = this.getStyles();
	      var _props = this.props;
	      var films = _props.films;
	      var creatorView = _props.creatorView;
	      var livestreamView = _props.livestreamView;
	      var eventBucket = films.length && _EventBucketStore2.default.getEventBucketById(films[0].event_bucket) || {};
	      var isVirtual = eventBucket.enable_virtual_festival;
	      var isTitleDelivery = eventBucket.enable_title_delivery;
	      var detailed = (_UserStore2.default.getUser() || {}).type === "festival_organizer";
	
	      var caseInsensitiveSort = function caseInsensitiveSort(a, b) {
	        return a.localeCompare(b, undefined, { sensitivity: 'base' });
	      };
	
	      var tableProps = {
	        className: "bordered striped responsive-table",
	        sortable: livestreamView ? [{ column: "Name", sortFunction: caseInsensitiveSort }, "Date", "Status"] : creatorView ? [{ column: "Name", sortFunction: caseInsensitiveSort }, "Organization", "Event"] : [{ column: "Name", sortFunction: caseInsensitiveSort }, "Details"],
	        defaultSort: livestreamView ? { column: "Date", direction: "asc" } : { column: "Name", direction: "asc" },
	        columns: livestreamView ? ["Name", "Date", "Status", "Actions"] : creatorView ? ["Name", "Organization", "Event", "Status", "Actions"] : isVirtual ? ["Name", "Details"].concat(isTitleDelivery ? ["Delivery Status"] : []).concat(["Status", "Actions"]) : ["Name", "Details", "Actions"],
	        filterable: creatorView ? ["Name", "Organization", "Event"] : ["Name", "Details"]
	      };
	
	      // filter "accident" unnamed films out
	      films = films.filter(function (f) {
	        return !(f.created_at === f.updated_at && !f.name);
	      });
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          "style",
	          null,
	          "\n          .reactable-filterer input {\n            width: 200px;\n          }\n        "
	        ),
	        _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement(
	            _reactable.Table,
	            _extends({}, tableProps, {
	              filterPlaceholder: this.props.creatorView ? "Type to filter screenings..." : this.props.livestreamView ? "Type to filter livestreams..." : "Type to filter films..."
	            }),
	            films.map(function (film) {
	              return _this2._makeRowForEvent(film, detailed);
	            })
	          )
	        ),
	        films.length === 0 ? livestreamView ? _react2.default.createElement(
	          "div",
	          { className: "empty-table-message" },
	          "No upcoming livestreams.",
	          " ",
	          _react2.default.createElement(
	            _reactRouter.Link,
	            {
	              to: "/event_buckets/" + this.props.eventBucket + "/events/new?virtual=true"
	            },
	            "Create a new virtual screening."
	          )
	        ) : creatorView ? _react2.default.createElement(
	          "div",
	          { className: "empty-table-message" },
	          "No screening invites yet."
	        ) : _react2.default.createElement(
	          "div",
	          { className: "empty-table-message" },
	          "No films yet.",
	          " ",
	          _react2.default.createElement(
	            _reactRouter.Link,
	            { to: "/event_buckets/" + this.props.eventBucket + "/films/new" },
	            "Create a new film."
	          )
	        ) : null,
	        this.props.createButton ? _react2.default.createElement(
	          "div",
	          { style: { marginTop: "1em" } },
	          this.props.createButton
	        ) : null
	      );
	    }
	  }]);
	
	  return FilmTable;
	}(_react2.default.Component);
	
	exports.default = FilmTable;

/***/ }),
/* 1764 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _alt = __webpack_require__(975);
	
	var _alt2 = _interopRequireDefault(_alt);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var FilmActions = function () {
	  function FilmActions() {
	    _classCallCheck(this, FilmActions);
	
	    this.generateActions("create", "delete", "updateFilms", "updateAllFilms", "fetchAllForUser", "fetchAllForEventBucket", "fetchAllForCreator", "fetchOne", "fetchFailed", "editFailed");
	  }
	
	  _createClass(FilmActions, [{
	    key: "editImage",
	    value: function editImage(id, field, file) {
	      return { id: id, field: field, file: file };
	    }
	  }, {
	    key: "edit",
	    value: function edit(id, values) {
	      return { id: id, values: values };
	    }
	  }, {
	    key: "updateFilm",
	    value: function updateFilm(id, film) {
	      return { id: id, film: film };
	    }
	  }, {
	    key: "inviteContentCreator",
	    value: function inviteContentCreator(id, email, options) {
	      return { id: id, email: email, options: options };
	    }
	  }]);
	
	  return FilmActions;
	}();
	
	exports.default = _alt2.default.createActions(FilmActions);
	module.exports = exports["default"];

/***/ }),
/* 1765 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _alt = __webpack_require__(975);
	
	var _alt2 = _interopRequireDefault(_alt);
	
	var _keyBy = __webpack_require__(990);
	
	var _keyBy2 = _interopRequireDefault(_keyBy);
	
	var _values = __webpack_require__(1214);
	
	var _values2 = _interopRequireDefault(_values);
	
	var _FilmUtil = __webpack_require__(1766);
	
	var _FilmUtil2 = _interopRequireDefault(_FilmUtil);
	
	var _FilmActions = __webpack_require__(1764);
	
	var _FilmActions2 = _interopRequireDefault(_FilmActions);
	
	var _UserStore = __webpack_require__(974);
	
	var _UserStore2 = _interopRequireDefault(_UserStore);
	
	var _VirtualContentActions = __webpack_require__(1767);
	
	var _VirtualContentActions2 = _interopRequireDefault(_VirtualContentActions);
	
	var _GlobalNotificationActions = __webpack_require__(1182);
	
	var _GlobalNotificationActions2 = _interopRequireDefault(_GlobalNotificationActions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var FilmStore = function () {
	  function FilmStore() {
	    _classCallCheck(this, FilmStore);
	
	    this.bindActions(_FilmActions2.default);
	
	    this.state = {
	      films: {},
	      allFilms: [],
	      isFetching: false,
	      isEditing: null,
	      isCreating: false,
	      newFilmId: null,
	      uploadingImageField: null
	    };
	
	    this.exportPublicMethods({
	      getFilmById: this.getFilmById.bind(this),
	      getFilmsForEventBucket: this.getFilmsForEventBucket.bind(this),
	      getAllUserFilms: this.getAllUserFilms.bind(this)
	    });
	  }
	
	  _createClass(FilmStore, [{
	    key: "getFilmById",
	    value: function getFilmById(id) {
	      return this.state.films[id];
	    }
	  }, {
	    key: "getFilmsForEventBucket",
	    value: function getFilmsForEventBucket(id) {
	      return (0, _values2.default)(this.state.films).filter(function (n) {
	        return n.event_bucket === id;
	      });
	    }
	  }, {
	    key: "getAllUserFilms",
	    value: function getAllUserFilms() {
	      return (0, _values2.default)(this.state.allFilms);
	    }
	  }, {
	    key: "onFetchAllForUser",
	    value: function onFetchAllForUser() {
	      var _this = this;
	
	      this.setState({ isFetching: true });
	      _FilmUtil2.default.fetchAllForUser(_UserStore2.default.getState().apiKey).then(function (data) {
	        //FilmActions.updateAllFilms(data);  // why is this not working?
	        _this.setState({ allFilms: data });
	        _this.setState({ isFetching: false });
	      }).catch(_FilmActions2.default.fetchFailed);
	    }
	  }, {
	    key: "onFetchAllForEventBucket",
	    value: function onFetchAllForEventBucket(eventBucket) {
	      var _this2 = this;
	
	      this.setState({ isFetching: true });
	      _FilmUtil2.default.fetchAllForEventBucket(_UserStore2.default.getState().apiKey, eventBucket).then(function (data) {
	        _FilmActions2.default.updateFilms((0, _keyBy2.default)(data, "id"));
	        _this2.setState({ isFetching: false });
	      }).catch(_FilmActions2.default.fetchFailed);
	    }
	  }, {
	    key: "onFetchAllForCreator",
	    value: function onFetchAllForCreator() {
	      var _this3 = this;
	
	      this.setState({ isFetching: true });
	      _FilmUtil2.default.fetchAllForCreator(_UserStore2.default.getState().apiKey).then(function (data) {
	        _FilmActions2.default.updateFilms((0, _keyBy2.default)(data, "id"));
	        _this3.setState({ isFetching: false });
	      }).catch(_FilmActions2.default.fetchFailed);
	    }
	  }, {
	    key: "onFetchOne",
	    value: function onFetchOne(id) {
	      var _this4 = this;
	
	      this.setState({ isFetching: true });
	      _FilmUtil2.default.fetchOne(_UserStore2.default.getState().apiKey, id).then(function (data) {
	        _FilmActions2.default.updateFilm(id, data);
	        _this4.setState({ isFetching: false });
	      }).catch(_FilmActions2.default.fetchFailed);
	    }
	  }, {
	    key: "onEdit",
	    value: function onEdit(newData) {
	      var _this5 = this;
	
	      this.setState({ isEditing: newData.id });
	      _FilmUtil2.default.edit(_UserStore2.default.getState().apiKey, newData.id, newData.values).then(function (data) {
	        _FilmActions2.default.updateFilm(newData.id, data);
	        _this5.setState({ isEditing: null });
	      }).catch(_FilmActions2.default.editFailed);
	    }
	  }, {
	    key: "onEditImage",
	    value: function onEditImage(_ref) {
	      var _this6 = this;
	
	      var id = _ref.id;
	      var field = _ref.field;
	      var file = _ref.file;
	
	      this.setState({ uploadingImageField: field });
	      _FilmUtil2.default.editImage(_UserStore2.default.getState().apiKey, id, field, file).then(function (data) {
	        _FilmActions2.default.updateFilm(id, data);
	        _this6.setState({ uploadingImageField: null });
	      }).catch(_FilmActions2.default.editFailed);
	    }
	  }, {
	    key: "onDelete",
	    value: function onDelete(id) {
	      _FilmUtil2.default.delete(_UserStore2.default.getState().apiKey, id).then(function (data) {
	        _FilmActions2.default.updateFilm(id, undefined);
	      }).catch(_FilmActions2.default.editFailed);
	    }
	  }, {
	    key: "onCreate",
	    value: function onCreate(newData) {
	      var _this7 = this;
	
	      this.setState({ isCreating: true, newFilmId: null });
	
	      _FilmUtil2.default.create(_UserStore2.default.getState().apiKey, newData).then(function (data) {
	        _FilmActions2.default.updateFilm(data.id, data);
	        _this7.setState({ isCreating: false, newFilmId: data.id });
	      }).catch(_FilmActions2.default.editFailed);
	    }
	  }, {
	    key: "onInviteContentCreator",
	    value: function onInviteContentCreator(_ref2) {
	      var id = _ref2.id;
	      var email = _ref2.email;
	      var options = _ref2.options;
	
	      _FilmUtil2.default.inviteContentCreator(_UserStore2.default.getState().apiKey, id, email, options).then(function (data) {
	        _GlobalNotificationActions2.default.notify.defer("Content creator invitation sent successfully.");
	        _FilmActions2.default.fetchOne.defer(id);
	      }).catch(_FilmActions2.default.editFailed);
	    }
	  }, {
	    key: "onUpdateAllFilms",
	    value: function onUpdateAllFilms(films) {
	      this.setState({ allFilms: films });
	    }
	  }, {
	    key: "onUpdateFilms",
	    value: function onUpdateFilms(films) {
	      this.setState({ films: films });
	    }
	  }, {
	    key: "onUpdateFilm",
	    value: function onUpdateFilm(data) {
	      if (!data.film) {
	        delete this.state.films[data.id];
	      } else {
	        this.state.films[data.id] = data.film;
	        if (data.film.virtual_content) {
	          _VirtualContentActions2.default.updateVirtualContent.defer(data.film.virtual_content.id, data.film.virtual_content);
	        }
	      }
	      this.state.newFilmId = null;
	      this.setState(this.state);
	    }
	  }, {
	    key: "onFetchFailed",
	    value: function onFetchFailed(e) {
	      alert("Fetching films failed: " + e.message);
	      throw e;
	    }
	  }, {
	    key: "onEditFailed",
	    value: function onEditFailed(e) {
	      alert("Edit failed: " + e.message);
	      this.setState({ isCreating: false, isEditing: false });
	    }
	  }]);
	
	  return FilmStore;
	}();
	
	exports.default = _alt2.default.createStore(FilmStore, "FilmStore");
	module.exports = exports["default"];

/***/ }),
/* 1766 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _api = __webpack_require__(1160);
	
	var _api2 = _interopRequireDefault(_api);
	
	var _qs = __webpack_require__(1206);
	
	var _qs2 = _interopRequireDefault(_qs);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	exports.default = {
	  fetchAllForUser: function fetchAllForUser(apiKey) {
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "GET",
	        endpoint: "films",
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response.films);
	      });
	    });
	  },
	  fetchAllForEventBucket: function fetchAllForEventBucket(apiKey, eventBucket) {
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "GET",
	        endpoint: "event_buckets/" + eventBucket + "/films",
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response.films);
	      });
	    });
	  },
	  fetchAllByTag: function fetchAllByTag(apiKey, eventBucket, tag) {
	    var params = arguments.length <= 3 || arguments[3] === undefined ? {} : arguments[3];
	
	    var newParams = _extends({}, params);
	
	    if (params.sorted && params.sorted.length !== 0) {
	      newParams = _extends({}, newParams, { sortedId: params.sorted[0].id, sortedIsDesc: params.sorted[0].desc });
	    }
	
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "GET",
	        endpoint: "/event_buckets/" + eventBucket + "/tags/" + tag + "/films?" + _qs2.default.stringify(newParams),
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response);
	      });
	    });
	  },
	  fetchAllForCreator: function fetchAllForCreator(apiKey) {
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "GET",
	        endpoint: "films?content_creator=true",
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response.films);
	      });
	    });
	  },
	  fetchOne: function fetchOne(apiKey, film) {
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "GET",
	        endpoint: "films/" + film,
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response);
	      });
	    });
	  },
	  edit: function edit(apiKey, film, values) {
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "POST",
	        endpoint: "films/" + film,
	        json: values,
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response);
	      });
	    });
	  },
	  editImage: function editImage(apiKey, film, field, file) {
	    return new Promise(function (resolve, reject) {
	      _api2.default.request(Object.assign({
	        method: "POST",
	        endpoint: "films/" + film,
	        api_key: apiKey
	      }, file ? { fileField: field, file: file } : {
	        json: _defineProperty({}, field, null)
	      }), function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response);
	      });
	    });
	  },
	  delete: function _delete(apiKey, film) {
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "DELETE",
	        endpoint: "films/" + film,
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response);
	      });
	    });
	  },
	  create: function create(apiKey, values) {
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "POST",
	        endpoint: "films",
	        json: values,
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response);
	      });
	    });
	  },
	  inviteContentCreator: function inviteContentCreator(apiKey, filmId, email, options) {
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "POST",
	        endpoint: "films/" + filmId + "/content_creator_invite",
	        json: _extends({
	          email: email
	        }, options ? { title_requested_media: options.title_requested_media } : null),
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response);
	      });
	    });
	  }
	};
	module.exports = exports["default"];

/***/ }),
/* 1767 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _alt = __webpack_require__(975);
	
	var _alt2 = _interopRequireDefault(_alt);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var VirtualContentActions = function () {
	  function VirtualContentActions() {
	    _classCallCheck(this, VirtualContentActions);
	
	    this.generateActions("create", "delete", "updateVirtualContents", "fetchAll", "fetchByIds", "fetchOne", "fetchFailed", "fetchChatReviewQueue", "submitChatReviewAction", "generateManifest", "editFailed", "startStreaming", "stopStreaming");
	  }
	
	  _createClass(VirtualContentActions, [{
	    key: "editImage",
	    value: function editImage(id, field, file) {
	      return { id: id, field: field, file: file };
	    }
	  }, {
	    key: "edit",
	    value: function edit(id, values) {
	      return { id: id, values: values };
	    }
	  }, {
	    key: "updateVirtualContent",
	    value: function updateVirtualContent(id, virtualContent) {
	      return { id: id, virtualContent: virtualContent };
	    }
	  }]);
	
	  return VirtualContentActions;
	}();
	
	exports.default = _alt2.default.createActions(VirtualContentActions);
	module.exports = exports["default"];

/***/ }),
/* 1768 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _alt = __webpack_require__(975);
	
	var _alt2 = _interopRequireDefault(_alt);
	
	var _keyBy = __webpack_require__(990);
	
	var _keyBy2 = _interopRequireDefault(_keyBy);
	
	var _values = __webpack_require__(1214);
	
	var _values2 = _interopRequireDefault(_values);
	
	var _VirtualContentUtil = __webpack_require__(1769);
	
	var _VirtualContentUtil2 = _interopRequireDefault(_VirtualContentUtil);
	
	var _VirtualContentActions = __webpack_require__(1767);
	
	var _VirtualContentActions2 = _interopRequireDefault(_VirtualContentActions);
	
	var _UserStore = __webpack_require__(974);
	
	var _UserStore2 = _interopRequireDefault(_UserStore);
	
	var _GlobalNotificationActions = __webpack_require__(1182);
	
	var _GlobalNotificationActions2 = _interopRequireDefault(_GlobalNotificationActions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var VirtualContentStore = function () {
	  function VirtualContentStore() {
	    _classCallCheck(this, VirtualContentStore);
	
	    this.bindActions(_VirtualContentActions2.default);
	
	    this.state = {
	      virtualContents: {},
	      reviewQueues: {},
	      isFetching: false,
	      isEditing: null,
	      isCreating: false,
	      newVirtualContentId: null
	    };
	
	    this.exportPublicMethods({
	      getVirtualContentById: this.getVirtualContentById.bind(this),
	      getVirtualContent: this.getVirtualContent.bind(this)
	    });
	  }
	
	  _createClass(VirtualContentStore, [{
	    key: "getVirtualContentById",
	    value: function getVirtualContentById(id) {
	      return this.state.virtualContents[id];
	    }
	  }, {
	    key: "getVirtualContent",
	    value: function getVirtualContent(id) {
	      return (0, _values2.default)(this.state.virtualContents);
	    }
	  }, {
	    key: "onFetchAll",
	    value: function onFetchAll() {
	      var _this = this;
	
	      this.setState({ isFetching: true });
	      _VirtualContentUtil2.default.fetchAll(_UserStore2.default.getState().apiKey).then(function (data) {
	        _VirtualContentActions2.default.updateVirtualContents((0, _keyBy2.default)(data, "id"));
	        _this.setState({ isFetching: false });
	      }).catch(_VirtualContentActions2.default.fetchFailed);
	    }
	  }, {
	    key: "onFetchByIds",
	    value: function onFetchByIds(ids) {
	      var _this2 = this;
	
	      this.setState({ isFetching: true });
	      _VirtualContentUtil2.default.fetchByIds(_UserStore2.default.getState().apiKey, ids).then(function (data) {
	        _VirtualContentActions2.default.updateVirtualContents((0, _keyBy2.default)(data, "id"));
	        _this2.setState({ isFetching: false });
	      }).catch(_VirtualContentActions2.default.fetchFailed);
	    }
	  }, {
	    key: "onFetchOne",
	    value: function onFetchOne(id) {
	      var _this3 = this;
	
	      this.setState({ isFetching: true });
	      _VirtualContentUtil2.default.fetchOne(_UserStore2.default.getState().apiKey, id).then(function (data) {
	        _VirtualContentActions2.default.updateVirtualContent(id, data);
	        _this3.setState({ isFetching: false });
	      }).catch(_VirtualContentActions2.default.fetchFailed);
	    }
	  }, {
	    key: "onEdit",
	    value: function onEdit(newData) {
	      var _this4 = this;
	
	      this.setState({ isEditing: newData.id });
	      _VirtualContentUtil2.default.edit(_UserStore2.default.getState().apiKey, newData.id, newData.values).then(function (data) {
	        _VirtualContentActions2.default.updateVirtualContent(newData.id, data);
	        _this4.setState({ isEditing: null });
	      }).catch(_VirtualContentActions2.default.editFailed);
	    }
	  }, {
	    key: "onDelete",
	    value: function onDelete(id) {
	      _VirtualContentUtil2.default.delete(_UserStore2.default.getState().apiKey, id).then(function (data) {
	        _VirtualContentActions2.default.updateVirtualContent(id, undefined);
	      }).catch(_VirtualContentActions2.default.editFailed);
	    }
	  }, {
	    key: "onCreate",
	    value: function onCreate(newData) {
	      var _this5 = this;
	
	      this.setState({ isCreating: true, newVirtualContentId: null });
	
	      _VirtualContentUtil2.default.create(_UserStore2.default.getState().apiKey, newData).then(function (data) {
	        _VirtualContentActions2.default.updateVirtualContent(data.id, data);
	        _this5.setState({ isCreating: false, newVirtualContentId: data.id });
	      }).catch(_VirtualContentActions2.default.editFailed);
	    }
	  }, {
	    key: "onUpdateVirtualContents",
	    value: function onUpdateVirtualContents(virtualContents) {
	      this.setState({
	        virtualContents: _extends({}, this.state.virtualContents, virtualContents)
	      });
	    }
	  }, {
	    key: "onUpdateVirtualContent",
	    value: function onUpdateVirtualContent(data) {
	      if (!data.virtualContent) {
	        delete this.state.virtualContents[data.id];
	      } else {
	        this.state.virtualContents[data.id] = data.virtualContent;
	      }
	      this.state.newVirtualContentId = null;
	      this.setState(this.state);
	    }
	  }, {
	    key: "onFetchFailed",
	    value: function onFetchFailed(e) {
	      alert("Fetching virtual content failed: " + e.message);
	      throw e;
	    }
	  }, {
	    key: "onEditFailed",
	    value: function onEditFailed(e) {
	      alert("Edit failed: " + e.message);
	      this.setState({ isCreating: false, isEditing: false });
	    }
	  }, {
	    key: "onStartStreaming",
	    value: function onStartStreaming(id) {
	      var _this6 = this;
	
	      this.setState({ isEditing: true });
	      return _VirtualContentUtil2.default.startStreaming(_UserStore2.default.getState().apiKey, id).then(function (data) {
	        _this6.setState({ isEditing: false });
	      }).catch(_VirtualContentActions2.default.editFailed);
	    }
	  }, {
	    key: "onStopStreaming",
	    value: function onStopStreaming(id) {
	      var _this7 = this;
	
	      this.setState({ isEditing: true });
	      return _VirtualContentUtil2.default.stopStreaming(_UserStore2.default.getState().apiKey, id).then(function (data) {
	        _this7.setState({ isEditing: false });
	      }).catch(_VirtualContentActions2.default.editFailed);
	    }
	  }, {
	    key: "onFetchChatReviewQueue",
	    value: function onFetchChatReviewQueue(data) {
	      var _this8 = this;
	
	      return _VirtualContentUtil2.default.fetchChatReviewQueue(_UserStore2.default.getState().apiKey, data.virtualContentId, data.options).then(function (responseData) {
	        _this8.state.reviewQueues[data.virtualContentId] = responseData;
	        _this8.setState(_this8.state);
	      }).catch(_VirtualContentActions2.default.editFailed);
	    }
	  }, {
	    key: "onSubmitChatReviewAction",
	    value: function onSubmitChatReviewAction(data) {
	      return _VirtualContentUtil2.default.submitChatReviewAction(_UserStore2.default.getState().apiKey, data.virtualContentId, data.options).then(function (responseData) {
	        console.log(responseData);
	      }).catch(_VirtualContentActions2.default.editFailed);
	    }
	  }, {
	    key: "onGenerateManifest",
	    value: function onGenerateManifest(id) {
	      var _this9 = this;
	
	      this.setState({ isEditing: true });
	      return _VirtualContentUtil2.default.generateManifest(_UserStore2.default.getState().apiKey, id).then(function (data) {
	        if (data.status_description) {
	          _GlobalNotificationActions2.default.notify.defer("Manifest re-generation failed: " + data.status_description);
	        } else {
	          _GlobalNotificationActions2.default.notify.defer("Manifest re-generated successfully.");
	        }
	
	        _VirtualContentActions2.default.updateVirtualContent(data.id, _extends({}, _this9.state.virtualContents[data.id], {
	          status: data.status,
	          status_description: data.status_description
	        }));
	
	        _this9.setState({ isEditing: false });
	      }).catch(_VirtualContentActions2.default.editFailed);
	    }
	  }]);
	
	  return VirtualContentStore;
	}();
	
	exports.default = _alt2.default.createStore(VirtualContentStore, "VirtualContentStore");
	module.exports = exports["default"];

/***/ }),
/* 1769 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _api = __webpack_require__(1160);
	
	var _api2 = _interopRequireDefault(_api);
	
	var _queryString = __webpack_require__(513);
	
	var _queryString2 = _interopRequireDefault(_queryString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  fetchAll: function fetchAll(apiKey) {
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "GET",
	        endpoint: "virtual_content",
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response.virtual_content);
	      });
	    });
	  },
	  fetchByIds: function fetchByIds(apiKey, ids) {
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "GET",
	        endpoint: "virtual_content",
	        qs: {
	          conditions: JSON.stringify({
	            _id: { $in: ids }
	          })
	        },
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response.virtual_content);
	      });
	    });
	  },
	  fetchOne: function fetchOne(apiKey, virtualContent) {
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "GET",
	        endpoint: "virtual_content/" + virtualContent,
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(_extends({}, response, { _fetched_at: Date.now() }));
	      });
	    });
	  },
	  edit: function edit(apiKey, virtualContent, values) {
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "POST",
	        endpoint: "virtual_content/" + virtualContent,
	        json: values,
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response);
	      });
	    });
	  },
	  delete: function _delete(apiKey, virtualContent) {
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "DELETE",
	        endpoint: "virtual_content/" + virtualContent,
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response);
	      });
	    });
	  },
	  create: function create(apiKey, values) {
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "POST",
	        endpoint: "virtual_content",
	        json: values,
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response);
	      });
	    });
	  },
	  upload: function upload(apiKey, id) {
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "POST",
	        endpoint: "virtual_content/" + id + "/upload",
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response);
	      });
	    });
	  },
	  export: function _export(apiKey, id) {
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "POST",
	        endpoint: "virtual_content/" + id + "/export",
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response);
	      });
	    });
	  },
	  generateManifest: function generateManifest(apiKey, id) {
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "POST",
	        endpoint: "virtual_content/" + id + "/generate_manifest",
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response);
	      });
	    });
	  },
	  uploadSignature: function uploadSignature(apiKey, id, query) {
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "POST",
	        endpoint: "virtual_content/" + id + "/upload_signature?" + _queryString2.default.stringify(query),
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response);
	      });
	    });
	  },
	  fetchChatReviewQueue: function fetchChatReviewQueue(apiKey, id, options) {
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "POST",
	        endpoint: "watch/" + id + "/admin_chat_review_queue",
	        json: options,
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response);
	      });
	    });
	  },
	  submitChatReviewAction: function submitChatReviewAction(apiKey, virtualContentId, options) {
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "POST",
	        endpoint: "watch/" + virtualContentId + "/admin_chat_action",
	        json: options,
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response);
	      });
	    });
	  },
	  startStreaming: function startStreaming(apiKey, id) {
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "POST",
	        endpoint: "virtual_content/" + id + "/start_streaming",
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response);
	      });
	    });
	  },
	  stopStreaming: function stopStreaming(apiKey, id) {
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "POST",
	        endpoint: "virtual_content/" + id + "/stop_streaming",
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response);
	      });
	    });
	  }
	};
	module.exports = exports["default"];

/***/ }),
/* 1770 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(486);
	
	var _values = __webpack_require__(1214);
	
	var _values2 = _interopRequireDefault(_values);
	
	var _pickBy = __webpack_require__(1163);
	
	var _pickBy2 = _interopRequireDefault(_pickBy);
	
	var _materialUi = __webpack_require__(576);
	
	var _connectToStores = __webpack_require__(1226);
	
	var _connectToStores2 = _interopRequireDefault(_connectToStores);
	
	var _FilmActions = __webpack_require__(1764);
	
	var _FilmActions2 = _interopRequireDefault(_FilmActions);
	
	var _FilmStore = __webpack_require__(1765);
	
	var _FilmStore2 = _interopRequireDefault(_FilmStore);
	
	var _VirtualContentStore = __webpack_require__(1768);
	
	var _VirtualContentStore2 = _interopRequireDefault(_VirtualContentStore);
	
	var _VirtualContentActions = __webpack_require__(1767);
	
	var _VirtualContentActions2 = _interopRequireDefault(_VirtualContentActions);
	
	var _config = __webpack_require__(1173);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _UserStore = __webpack_require__(974);
	
	var _UserStore2 = _interopRequireDefault(_UserStore);
	
	var _workingIndicator = __webpack_require__(1664);
	
	var _workingIndicator2 = _interopRequireDefault(_workingIndicator);
	
	var _linkLike = __webpack_require__(973);
	
	var _linkLike2 = _interopRequireDefault(_linkLike);
	
	var _inlineNoticeLabel = __webpack_require__(1222);
	
	var _inlineNoticeLabel2 = _interopRequireDefault(_inlineNoticeLabel);
	
	var _virtualContentUploader = __webpack_require__(1771);
	
	var _virtualContentUploader2 = _interopRequireDefault(_virtualContentUploader);
	
	var _queryString = __webpack_require__(513);
	
	var _queryString2 = _interopRequireDefault(_queryString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var parsedQueryString = _queryString2.default.parse(window.location.search);
	
	var Films = function (_React$Component) {
	  _inherits(Films, _React$Component);
	
	  function Films(props) {
	    _classCallCheck(this, Films);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(Films).call(this, props));
	
	    _this.state = {
	      grantingOtherContent: false,
	      uploadingNewContent: false,
	      uploadedContent: false
	    };
	    return _this;
	  }
	
	  _createClass(Films, [{
	    key: "shouldUseBeta",
	    value: function shouldUseBeta(film) {
	      // If film._use_beta_vod_flow_for_new_virtual_content is true, returns true unless overridden by beta=0 in the query string.
	      // If film._use_beta_vod_flow_for_new_virtual_content is false, returns false unless overridden by beta=1 in the query string.
	      if (parsedQueryString.beta === "1") {
	        return true;
	      }
	      if (parsedQueryString.beta === "0") {
	        return false;
	      }
	      return film._use_beta_vod_flow_for_new_virtual_content;
	    }
	  }, {
	    key: "getStyles",
	    value: function getStyles() {
	      return {
	        container: {
	          maxWidth: 500,
	          margin: "5% auto",
	          fontSize: "11pt",
	          padding: "5px 20px",
	          borderRadius: "1em",
	          boxShadow: "0 0 20px 2px rgba(0,0,0,0.2)"
	        }
	      };
	    }
	  }, {
	    key: "componentWillMount",
	    value: function componentWillMount() {
	      _FilmActions2.default.fetchOne(this.props.params.filmId);
	      _VirtualContentActions2.default.fetchAll();
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var styles = this.getStyles(),
	          film = _FilmStore2.default.getFilmById(this.props.params.filmId),
	          existingVirtualContent = this.state.uploadedContent || film && film.virtual_content;
	
	      if (this.state.grantingOtherContent || !film || this.props.isFetching || _VirtualContentStore2.default.getState().isFetching) {
	        return _react2.default.createElement(_workingIndicator2.default, { fullPage: true });
	      }
	
	      return _react2.default.createElement(
	        "div",
	        { style: styles.container },
	        _react2.default.createElement(
	          "p",
	          null,
	          _react2.default.createElement(
	            "strong",
	            null,
	            film.owner_organization
	          ),
	          " has invited you to upload content for ",
	          _react2.default.createElement(
	            "strong",
	            null,
	            film.name
	          ),
	          ", screening within",
	          " ",
	          _react2.default.createElement(
	            "strong",
	            null,
	            film.event_bucket_name
	          ),
	          "."
	        ),
	        _react2.default.createElement(
	          "p",
	          null,
	          "Your content will be protected with multi-platform DRM and invisible per-user",
	          " ",
	          _react2.default.createElement(
	            "a",
	            { href: "https://eventive.org/antipiracy", target: "_blank" },
	            "forensic watermarking"
	          ),
	          ", encoded for optimal playback across a variety of streaming environments, geo-blocked and audience restricted as required, and delivered securely to authorized viewers."
	        ),
	        this.state.uploadedContent || existingVirtualContent && ["pending_upload", "vod_upload_started", "vod_upload_failure"].indexOf(existingVirtualContent.status) === -1 && !this.state.uploadingNewContent ? _react2.default.createElement(
	          "div",
	          {
	            style: {
	              margin: "2em 0",
	              border: "2px dashed #ccc",
	              borderRadius: 5,
	              paddingLeft: "2em",
	              paddingRight: "2em",
	              textAlign: "center"
	            }
	          },
	          existingVirtualContent ? _react2.default.createElement(
	            "p",
	            null,
	            "You have successfully uploaded \"",
	            existingVirtualContent.label,
	            "\". Thank you."
	          ) : _react2.default.createElement(
	            "p",
	            null,
	            "Your content has been uploaded. Thank you."
	          ),
	          _react2.default.createElement(
	            "p",
	            { style: { marginTop: "-0.75em" } },
	            existingVirtualContent ? _react2.default.createElement(
	              "span",
	              null,
	              _react2.default.createElement(
	                _reactRouter.Link,
	                {
	                  to: "/creator_hub/virtual_content/" + existingVirtualContent.id
	                },
	                "Manage asset"
	              ),
	              " ",
	              "\xB7",
	              " "
	            ) : null,
	            _react2.default.createElement(
	              _linkLike2.default,
	              {
	                onTouchTap: function onTouchTap() {
	                  return Intercom("showNewMessage", "Please revoke access to " + film.name + " from " + film.event_bucket_name + " / " + film.owner_organization + " (ref # " + film.id + ").");
	                }
	              },
	              "Revoke access"
	            )
	          )
	        ) : _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement(
	            "div",
	            {
	              style: {
	                margin: "2em 0 1.5em"
	              }
	            },
	            _react2.default.createElement(_virtualContentUploader2.default, {
	              useBeta: film._use_beta_vod_flow_for_new_virtual_content,
	              filmId: film.id,
	              onSuccess: function onSuccess(content) {
	                _this2.setState({ uploadedContent: content });
	              },
	              existingVirtualContentId: existingVirtualContent ? existingVirtualContent.id : undefined,
	              noFetchOther: true,
	              otherContentStyle: {
	                marginTop: "1.5em",
	                padding: "1em 1em 0",
	                border: "1px dashed #ccc",
	                borderRadius: "1em"
	              },
	              otherContentIntroduction: _react2.default.createElement(
	                "div",
	                { style: { fontStyle: "italic" } },
	                "You have previously uploaded content that can be used for this screening. To grant access, select an item below."
	              ),
	              onOtherContentSelect: function onOtherContentSelect(content) {
	                if (window.confirm("Are you sure you would like to grant access to \"" + (content.label || "Unlabeled content") + "\" to " + film.owner_organization + "? The content will be shared immediately.")) {
	                  _this2.setState({ grantingOtherContent: true });
	                  _VirtualContentActions2.default.edit(content.id, {
	                    _films: [film.id]
	                  });
	                  setTimeout(function () {
	                    _this2.setState({
	                      grantingOtherContent: false,
	                      uploadedContent: content
	                    });
	                  }, 1500);
	                }
	              }
	            })
	          )
	        ),
	        true ? _react2.default.createElement(
	          "p",
	          { style: { textAlign: "center", color: "rgba(0,0,0,0.6)" } },
	          "Powered by Eventive Media"
	        ) : _react2.default.createElement(
	          "p",
	          { style: { textAlign: "center", color: "rgba(0,0,0,0.6)" } },
	          "Eventive Media powered by",
	          " ",
	          _react2.default.createElement(
	            "a",
	            { href: "https://cinesend.com", target: "_blank" },
	            _react2.default.createElement(
	              "svg",
	              {
	                viewBox: "0 0 603 142.7",
	                alt: "CineSend",
	                style: {
	                  width: 80,
	                  height: 40,
	                  verticalAlign: -15,
	                  marginLeft: "0.1em"
	                }
	              },
	              _react2.default.createElement("path", {
	                fill: "#FB0F3B",
	                d: "M330.9 26.7c36.6-10 73.6-18.2 110.9-25.3h.1c2.4-.3 4.6-1.1 6.9-.1.8.3 1.3 1.2 1.2 2-.1.9-.7 1.7-1.7 1.9C430 8.7 412 13.8 393.9 18c-17.7 5.2-36.1 9.4-52.2 18.7-5.8 4.2-12 8.9-14.7 15.8-1.7 3.7-.8 8.1 1.2 11.5 8.6 14.6 26.1 24 29.6 40.9.9 4.2 1.8 11.6-2.3 15.6-4.1 4.3-10.1 6.1-15.7 7.6-13.4 3.2-27.1 4.1-40.8 5.6-29.8 3.2-59.7 5.2-89.7 7.1-14.6.9-28.9.4-43.3.6-.7 0-1.1-.7-.8-1.3 0-.1.1-.1.1-.2.2-.5.7-.8 1.2-.8 25.7-1.9 51.4-3.9 77.1-6.9 17.1-2.1 34.5-4.4 50.8-10.3 9.9-4.1 20.6-9.7 24.8-20.2 3.5-7.9-1.6-16.3-6.1-22.6-7.1-7.9-17.2-13.6-21.4-23.8-2-5.7-.3-12.2 4.7-15.8 10.3-7.1 22.8-9.5 34.5-12.8z"
	              }),
	              _react2.default.createElement("path", {
	                fill: "#353149",
	                d: "M14.2 26c7.5-9.4 19.1-14.6 30.9-15.9 14-1.6 29.5-.3 41 8.5 9.4 6.9 13.9 18.5 14.9 29.8-5.6-.1-11.1.3-16.7-.2-7.8-1.3-8.2-11.1-14.5-14.7C57.2 26.4 38.3 29 30.4 42c-6 10.1-6.1 22.4-5.1 33.8 1 10.9 6.7 22.6 17.6 26.7 9.2 3.1 20.5 2.7 28.4-3.6 4.6-3.7 6.4-9.6 8.5-14.9 7.1.1 14.2 0 21.4 0-1 11.7-5.9 23.5-15.4 30.8-10.7 8.1-24.7 10.2-37.8 9.4-11.4-.6-23.2-4.5-31.1-13.1C5.5 99.7 2.1 82.7 3 67.1 2.2 52.7 4.9 37.4 14.2 26z"
	              }),
	              _react2.default.createElement("path", {
	                fill: "#FB0F3B",
	                d: "M575.8 43.4c.2-10.8-.1-21.6.2-32.5 4.6.2 9.2-.1 13.8.2 5.5.2 10 5.4 9.9 10.8.1 19.9 0 39.8.1 59.7 0 11.6-.6 25.2-10.2 33.2-9.4 7.1-21.5 10.3-33.2 9.6-10.8.2-22.9-2.6-29.6-11.8-8.6-11.8-9.1-27.2-8.1-41.3.8-11.6 5.2-23.4 14.4-30.9 8.4-7 20.3-7.7 30.6-5.1 4.8 1.3 8.4 5 12.1 8.1z"
	              }),
	              _react2.default.createElement("path", {
	                fill: "#353149",
	                d: "M111.1 13c6.5.4 14.9-2.4 19.5 3.7 3.3 3.7 2.2 9 2 13.5-7.2-.2-14.3-.1-21.5-.1V13z"
	              }),
	              _react2.default.createElement("path", {
	                fill: "#FB0F3B",
	                d: "M370 42.2c9.9-8.5 24-9 36.3-7.1 10.4 1.5 19.9 8.1 24.6 17.5 5.3 10.4 5.5 22.5 5.5 33.9-18.3.8-36.7-.1-55.1.5 1 5.8 3.3 12.3 9.1 15 5.9 3.5 13.9 1.4 18.1-3.7 1.4-1.4 2.7-3.2 4.9-3.4 7.1-.2 14.3-.2 21.4-.3-.6 12.9-10.6 24-22.6 27.9-7 2.6-14.6 2.1-21.9 2-12.1-.2-23.7-7.8-28.8-18.8-5.6-10.5-5.3-22.8-4.8-34.3.7-11 4.7-22.2 13.3-29.2zM450.6 42.7c12.3-8.7 28.7-10.7 43-6.3 7.4 2.4 14.8 6.5 18.5 13.6 2.7 5.7 3.5 12.1 3.9 18.3.2 18.2-.1 36.4.3 54.7-5.5.4-11.1.6-16.5-.2-4.4-.8-8.1-4.7-8-9.3-.2-15.5.1-31-.1-46.4-.2-9.3-12-15.8-19.8-10.6-4.7 1.9-6.9 7.1-6.9 11.9-.3 18.3.4 36.6-.3 54.9-8.1-.2-16.2-.1-24.3-.1.2-18.8 0-37.5.1-56.3.4-8.7 2.5-18.7 10.1-24.2z"
	              }),
	              _react2.default.createElement("path", {
	                fill: "#353149",
	                d: "M145.8 45.4c15.6-12.7 39.9-13.1 55.6-.5 7.2 6.7 8.7 17.2 8.9 26.5-.1 16.9.3 33.8-.2 50.7-4.5-.2-9 .1-13.4-.4-4.5-.7-8-5.1-8.1-9.6-.2-15.5.2-31-.1-46.5-.6-10.9-15.1-15.6-23.4-9.8-4.5 2.5-6.1 7.9-6 12.7-.2 17.9.7 35.8-.1 53.6-7.3-.2-14.5-.1-21.7-.1.1-17.3 0-34.7 0-52 .1-8.8 2-18.3 8.5-24.6zM221.9 51.4c5.1-8.6 14.4-14.3 24.3-15.5 13-1.8 28.1 1 36.7 11.7 8.5 10.5 9.9 24.7 9.4 37.7-18.3.1-36.6-.1-55 .1.6 5 1.2 10.5 4.9 14.3 4.8 5.6 13.3 6.4 19.8 3.7 4.7-1.5 6.5-7.6 11.8-7.7 5.7-.5 11.5-.1 17.2-.2-2.3 11.8-11.2 21.9-22.7 25.5-11.2 3.6-24.1 3.4-34.6-2.3-10.7-6.1-16.7-18-18-30-1.2-12.5-.8-26.2 6.2-37.3zM111 37.9c6.5.2 15-2.5 19.5 3.6 3.2 3.4 2.2 8.4 2.3 12.6-.3 22.7.7 45.4-.1 68.1-7.3-.2-14.6-.1-21.9-.1-.2-28.2.6-56.2.2-84.2z"
	              }),
	              _react2.default.createElement("path", {
	                fill: "#FFF",
	                d: "M247.2 55c5.9-2 13.4-1.6 18 3.2 3.2 3.4 4.1 8.2 4.4 12.7h-32.1c0-6.5 3.3-13.4 9.7-15.9zM381.5 69.8c.6-8.1 7.7-15.4 16.1-14.3 7.5.1 12.7 7.4 12.8 14.5-9.6-.8-19.2.5-28.9-.2zM555.5 56.3c5.8-1.7 12.1 1.5 15.6 6.1 3.5 5.1 4.6 11.5 4.7 17.6-.7 6.6-1.5 14-6.3 19.1-3.8 3.5-9.5 5.8-14.6 3.7-9.4-2.9-12.5-13.9-12.7-22.7-.3-9.3 3.4-20.9 13.3-23.8z"
	              })
	            )
	          )
	        )
	      );
	    }
	  }], [{
	    key: "getStores",
	    value: function getStores() {
	      return [_UserStore2.default, _FilmStore2.default, _VirtualContentStore2.default];
	    }
	  }, {
	    key: "getPropsFromStores",
	    value: function getPropsFromStores() {
	      return _FilmStore2.default.getState();
	    }
	  }, {
	    key: "contextTypes",
	    get: function get() {
	      return {
	        router: _react2.default.PropTypes.object
	      };
	    }
	  }]);
	
	  return Films;
	}(_react2.default.Component);
	
	exports.default = (0, _connectToStores2.default)(Films);
	module.exports = exports["default"];

/***/ }),
/* 1771 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _values = __webpack_require__(1214);
	
	var _values2 = _interopRequireDefault(_values);
	
	var _pickBy = __webpack_require__(1163);
	
	var _pickBy2 = _interopRequireDefault(_pickBy);
	
	var _materialUi = __webpack_require__(576);
	
	var _link = __webpack_require__(1705);
	
	var _link2 = _interopRequireDefault(_link);
	
	var _juration = __webpack_require__(1772);
	
	var _juration2 = _interopRequireDefault(_juration);
	
	var _moment = __webpack_require__(1021);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _connectToStores = __webpack_require__(1226);
	
	var _connectToStores2 = _interopRequireDefault(_connectToStores);
	
	var _VirtualContentActions = __webpack_require__(1767);
	
	var _VirtualContentActions2 = _interopRequireDefault(_VirtualContentActions);
	
	var _VirtualContentStore = __webpack_require__(1768);
	
	var _VirtualContentStore2 = _interopRequireDefault(_VirtualContentStore);
	
	var _VirtualContentUtil = __webpack_require__(1769);
	
	var _VirtualContentUtil2 = _interopRequireDefault(_VirtualContentUtil);
	
	var _UserStore = __webpack_require__(974);
	
	var _UserStore2 = _interopRequireDefault(_UserStore);
	
	var _workingIndicator = __webpack_require__(1664);
	
	var _workingIndicator2 = _interopRequireDefault(_workingIndicator);
	
	var _linkLike = __webpack_require__(973);
	
	var _linkLike2 = _interopRequireDefault(_linkLike);
	
	var _selectField = __webpack_require__(1683);
	
	var _selectField2 = _interopRequireDefault(_selectField);
	
	var _inlineNoticeLabel = __webpack_require__(1222);
	
	var _inlineNoticeLabel2 = _interopRequireDefault(_inlineNoticeLabel);
	
	var _util = __webpack_require__(1183);
	
	var _evaporate = __webpack_require__(1775);
	
	var _evaporate2 = _interopRequireDefault(_evaporate);
	
	var _sparkMd = __webpack_require__(1776);
	
	var _sparkMd2 = _interopRequireDefault(_sparkMd);
	
	var _jsSha = __webpack_require__(1777);
	
	var _jsSha2 = _interopRequireDefault(_jsSha);
	
	var _queryString = __webpack_require__(513);
	
	var _queryString2 = _interopRequireDefault(_queryString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var parsedQueryString = _queryString2.default.parse(window.location.search);
	
	var THREESIXTY_VR_ENABLED = true;
	var GOOGLE_DRIVE_ENABLED = false;
	
	var VirtualContentUploader = function (_React$Component) {
	  _inherits(VirtualContentUploader, _React$Component);
	
	  function VirtualContentUploader(props) {
	    _classCallCheck(this, VirtualContentUploader);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(VirtualContentUploader).call(this, props));
	
	    _this.state = {
	      needsTosConfirm: false,
	      completed: false,
	      virtualContentId: null,
	      file: null,
	      progressStats: null,
	      isDropboxUploadFromLink: null,
	
	      showUrlEntry: false,
	      urlEntered: "",
	
	      asset_pathway: parsedQueryString.asset_pathway === "legacy" ? "" : parsedQueryString.asset_pathway || "ev_next",
	      source_video_layout: parsedQueryString.source_video_layout || undefined,
	      source_audio_layout: parsedQueryString.source_audio_layout || undefined
	    };
	    return _this;
	  }
	
	  _createClass(VirtualContentUploader, [{
	    key: "getStyles",
	    value: function getStyles() {
	      return {};
	    }
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      // Inject dropbox uploader
	      if (!document.getElementById("dropboxjs")) {
	        var script = document.createElement("script");
	        script.id = "dropboxjs";
	        script.src = "https://www.dropbox.com/static/api/2/dropins.js";
	        script.setAttribute("data-app-key", "g65s6evybsoyska");
	        document.body.appendChild(script);
	      }
	
	      // Inject Google Drive uploader
	      if (GOOGLE_DRIVE_ENABLED && !document.getElementById("googleapi")) {
	        window.onGoogleApiLoad = function () {
	          window.gapi.load("auth2");
	          window.gapi.load("picker");
	          window.gapi.client.load("drive", "v2");
	        };
	        var googleScript = document.createElement("script");
	        googleScript.id = "googleapi";
	        googleScript.src = "https://apis.google.com/js/api.js?onload=onGoogleApiLoad";
	        document.body.appendChild(googleScript);
	      }
	
	      if (!this.props.noFetchOther) {
	        _VirtualContentActions2.default.fetchAll.defer();
	      }
	      this.componentWillReceiveProps(this.props);
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(newProps) {
	      var _this2 = this;
	
	      if (this.props.isCreating && newProps.newVirtualContentId) {
	        this.setState({
	          virtualContentId: newProps.newVirtualContentId
	        }, function () {
	          _this2.upload();
	        });
	      }
	    }
	  }, {
	    key: "onSuccess",
	    value: function onSuccess() {
	      var _this3 = this;
	
	      this.setState({ completed: true }, function () {
	        if (_this3.props.onSuccess) {
	          _this3.props.onSuccess(_VirtualContentStore2.default.getVirtualContentById(_this3.state.virtualContentId));
	        } else {
	          window.alert("Upload successful!");
	        }
	      });
	    }
	  }, {
	    key: "_fetchDestinationFilename",
	    value: function _fetchDestinationFilename() {
	      return fetch(("https://api.cinesend.com/api/integrators/eventive") + "/videos/" + this.state.cinesendVideoId + "/upload-destination?fileName=" + this.state.file.name + "&fileSize=" + this.state.file.size + "&apiKey=" + ("05da5575-44a3-4e58-a9c6-a1fcc5429898")).then(function (r) {
	        return r.json();
	      }).then(function (d) {
	        return d.destination;
	      });
	    }
	  }, {
	    key: "_fetchSignatureFromCinesend",
	    value: function _fetchSignatureFromCinesend(signParams, signHeaders, stringToSign, signatureDateTime, canonicalRequest) {
	      return fetch(("https://api.cinesend.com/api/integrators/eventive") + "/videos/" + this.state.cinesendVideoId + "/upload-signature?to_sign=" + stringToSign + "&datetime=" + signatureDateTime + "&apiKey=" + ("05da5575-44a3-4e58-a9c6-a1fcc5429898"), {
	        method: "GET",
	        headers: {
	          "Content-Type": "application/json"
	        }
	      }).then(function (data) {
	        return data.json();
	      }).then(function (d) {
	        return d.signature;
	      });
	    }
	  }, {
	    key: "_fetchSignatureFromEventive",
	    value: function _fetchSignatureFromEventive(signParams, signHeaders, stringToSign, signatureDateTime, canonicalRequest) {
	      return _VirtualContentUtil2.default.uploadSignature(_UserStore2.default.getState().apiKey, this.state.virtualContentId, {
	        to_sign: decodeURIComponent(stringToSign),
	        datetime: signatureDateTime,
	        canonical_request: canonicalRequest
	      }).then(function (e) {
	        return e.signature;
	      });
	    }
	  }, {
	    key: "dropboxUpload",
	    value: function dropboxUpload() {
	      var _this4 = this;
	
	      Dropbox.choose({
	        success: function success(files) {
	          var _files$ = files[0];
	          var bytes = _files$.bytes;
	          var name = _files$.name;
	          var link = _files$.link;
	
	
	          if (!link) {
	            window.alert("[Panic] Failed to retrieve file from Dropbox successfully. Payload received: " + JSON.stringify(files));
	            return;
	          }
	
	          _this4.setState({
	            needsTosConfirm: true,
	            file: {
	              name: name,
	              size: bytes,
	              directSourceLink: link
	            }
	          });
	        },
	        cancel: function cancel() {},
	        linkType: "direct",
	        multiselect: false,
	        extensions: ["video"],
	        folderselect: false
	      });
	    }
	  }, {
	    key: "googleDriveUpload",
	    value: function googleDriveUpload() {
	      var _this5 = this;
	
	      if (!this.state.googleOauthToken) {
	        window.gapi.auth2.init({
	          client_id: "888211540537-ecmrmu3l18t0457e5kgkeehus01tchau.apps.googleusercontent.com"
	        }).then(function () {
	          window.gapi.auth2.getAuthInstance().signIn({
	            scope: "https://www.googleapis.com/auth/drive.readonly"
	          }).then(function (res) {
	            var _res$getAuthResponse = res.getAuthResponse(true);
	
	            var access_token = _res$getAuthResponse.access_token;
	
	            _this5.setState({ googleOauthToken: access_token }, function () {
	              return _this5.googleDriveUpload();
	            });
	          });
	        });
	        return;
	      }
	
	      var picker = new google.picker.PickerBuilder().addView(google.picker.ViewId.DOCS_VIDEOS).setOAuthToken(this.state.googleOauthToken).setDeveloperKey("AIzaSyA_htjtfZLJ7pYQd2GmE7ub8_hvZX7B8LE").setCallback(function (data) {
	        if (data.action == google.picker.Action.PICKED) {
	          var request = window.gapi.client.drive.files.get({
	            fileId: data.docs[0].id
	          });
	          request.execute(function (resp) {
	            console.log(resp.downloadUrl);
	            _this5.setState({
	              needsTosConfirm: true,
	              file: {
	                name: resp.title,
	                size: resp.fileSize,
	                directSourceLink: "GOOGLEDRIVE_" + JSON.stringify({
	                  url: resp.downloadUrl,
	                  oauth_token: _this5.state.googleOauthToken
	                })
	              }
	            });
	          });
	        }
	      }).build();
	      picker.setVisible(true);
	    }
	  }, {
	    key: "urlUpload",
	    value: function () {
	      var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
	        var urlEntered, vimeoMatch, chunks;
	        return regeneratorRuntime.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                if (this.state.showUrlEntry) {
	                  _context.next = 3;
	                  break;
	                }
	
	                this.setState({ showUrlEntry: true });
	                return _context.abrupt("return");
	
	              case 3:
	                urlEntered = this.state.urlEntered;
	                vimeoMatch = urlEntered.indexOf("vimeo.com") !== -1 && urlEntered.indexOf("download") === -1;
	
	                if (!vimeoMatch) {
	                  _context.next = 8;
	                  break;
	                }
	
	                this.setState({
	                  vimeoInvalid: true
	                });
	                return _context.abrupt("return");
	
	              case 8:
	                chunks = urlEntered.split("/");
	
	                this.setState({
	                  vimeoInvalid: false,
	                  showUrlEntry: false,
	                  needsTosConfirm: true,
	                  file: {
	                    name: chunks[chunks.length - 1],
	                    directSourceLink: urlEntered
	                  }
	                });
	
	              case 10:
	              case "end":
	                return _context.stop();
	            }
	          }
	        }, _callee, this);
	      }));
	
	      function urlUpload() {
	        return _ref.apply(this, arguments);
	      }
	
	      return urlUpload;
	    }()
	  }, {
	    key: "create",
	    value: function create() {
	      if (!this.state.file && (!this.input || !this.input.files.length)) {
	        return;
	      }
	
	      if (!this.state.needsTosConfirm) {
	        var _file = this.input.files[0];
	        this.setState({ needsTosConfirm: true, tosAgreed: false, file: _file });
	        return;
	      }
	
	      this.setState({ needsTosConfirm: false });
	
	      var file = this.state.file;
	
	
	      _VirtualContentActions2.default.create(Object.assign({
	        type: "vod",
	        label: file.name,
	        file_size: file.size,
	        ams_drm_enabled: true,
	        asset_pathway: this.state.asset_pathway || undefined,
	        source_video_layout: this.state.source_video_layout || undefined,
	        source_audio_layout: this.state.source_audio_layout || undefined,
	        source_upload_url: file.directSourceLink
	      }, this.props.filmId && {
	        _films: [this.props.filmId]
	      }));
	    }
	  }, {
	    key: "upload",
	    value: function () {
	      var _ref2 = _asyncToGenerator(regeneratorRuntime.mark(function _callee2() {
	        var _this6 = this;
	
	        var evaporate, awsKey;
	        return regeneratorRuntime.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                if (!(this.state.file && this.state.file.directSourceLink)) {
	                  _context2.next = 3;
	                  break;
	                }
	
	                this.onSuccess();
	                return _context2.abrupt("return");
	
	              case 3:
	                _context2.prev = 3;
	
	                this.setState({ progressStats: {} });
	
	                _context2.next = 7;
	                return _evaporate2.default.create({
	                  aws_key: ("AKIAY5FAVG4CKB6FBHF5"),
	                  bucket: ("eventive-mezzanine-uploads-prod"),
	                  cloudfront: true,
	                  s3Acceleration: true,
	                  computeContentMd5: true,
	                  s3FileCacheHoursAgo: 6,
	                  onlyRetryForSameFileName: true,
	                  cryptoMd5Method: function cryptoMd5Method(d) {
	                    return btoa(_sparkMd2.default.ArrayBuffer.hash(d, true));
	                  },
	                  cryptoHexEncodedHash256: function cryptoHexEncodedHash256(d) {
	                    return (0, _jsSha2.default)(d);
	                  },
	                  customAuthMethod: this._fetchSignatureFromEventive.bind(this)
	                });
	
	              case 7:
	                evaporate = _context2.sent;
	                awsKey = evaporate.add({
	                  name: this.state.virtualContentId,
	                  file: this.state.file,
	                  progress: function progress(p, progressStats) {
	                    return _this6.setState({ progressStats: progressStats });
	                  },
	                  complete: function complete(_xhr, awsKey) {
	                    return _this6.onSuccess(awsKey);
	                  }
	                });
	                _context2.next = 15;
	                break;
	
	              case 11:
	                _context2.prev = 11;
	                _context2.t0 = _context2["catch"](3);
	
	                console.error(_context2.t0);
	                window.alert("Upload failed: " + _context2.t0.message);
	
	              case 15:
	              case "end":
	                return _context2.stop();
	            }
	          }
	        }, _callee2, this, [[3, 11]]);
	      }));
	
	      function upload() {
	        return _ref2.apply(this, arguments);
	      }
	
	      return upload;
	    }()
	  }, {
	    key: "render",
	    value: function render() {
	      var _this7 = this;
	
	      var _state = this.state;
	      var showUrlEntry = _state.showUrlEntry;
	      var urlEntered = _state.urlEntered;
	      var needsTosConfirm = _state.needsTosConfirm;
	      var completed = _state.completed;
	      var progressStats = _state.progressStats;
	
	
	      var otherVirtualContent = _VirtualContentStore2.default.getVirtualContent().filter(function (c) {
	        return (!_this7.props.existingVirtualContentId || c.id !== _this7.props.existingVirtualContentId) && c.status === "ready" && c.type === "vod" && c.platform !== "cinesend" && // Cinesend assets deprecated
	        c.platform !== "eventive";
	      } // AMS assets deprecated
	      ).filter(function (c) {
	        if (_this7.state.otherContentSearch) {
	          return (c.label || "").toLowerCase().indexOf(_this7.state.otherContentSearch.toLowerCase()) !== -1;
	        }
	        return true;
	      }).sort(function (a, b) {
	        return b.created_at.localeCompare(a.created_at);
	      });
	
	      var invalid = this.urlField && !this.urlField.input.checkValidity();
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          _materialUi.Dialog,
	          {
	            title: "Direct URL upload",
	            modal: false,
	            open: !!showUrlEntry,
	            actions: [_react2.default.createElement(_materialUi.FlatButton, {
	              onClick: function onClick() {
	                return _this7.setState({ showUrlEntry: false });
	              },
	              label: "Cancel"
	            }), _react2.default.createElement(_materialUi.FlatButton, {
	              primary: true,
	              disabled: !urlEntered || invalid,
	              onClick: function onClick() {
	                return _this7.urlUpload();
	              },
	              label: "Confirm"
	            })],
	            onRequestClose: function onRequestClose() {
	              return _this7.setState({ showUrlEntry: false });
	            }
	          },
	          _react2.default.createElement(
	            "div",
	            null,
	            "You can upload an asset directly from a URL. Ensure the URL points directly to a downloadable video file (typically ending in .mp4 or .mov)\u2014links to intermediate pages will not work."
	          ),
	          _react2.default.createElement(_materialUi.TextField, {
	            ref: function ref(r) {
	              _this7.urlField = r;
	            },
	            floatingLabelFixed: true,
	            floatingLabelText: "Fully-qualified URL",
	            placeholder: "https://example.com/video.mp4",
	            value: urlEntered,
	            autoFocus: true,
	            style: { width: 400 },
	            type: "url",
	            onChange: function onChange(e) {
	              return _this7.setState({ urlEntered: e.target.value, vimeoInvalid: false });
	            }
	          }),
	          this.state.vimeoInvalid ? _react2.default.createElement(
	            "p",
	            null,
	            "Vimeo URLs cannot be used to upload directly due to Vimeo security limitations. If the uploader is a Vimeo Plus member or higher and has enabled downloads for the video, you can",
	            " ",
	            _react2.default.createElement(
	              "a",
	              {
	                href: "https://vimeo.zendesk.com/hc/en-us/articles/229678128-Download-videos",
	                target: "_blank"
	              },
	              "download the source file from Vimeo"
	            ),
	            ", then upload it to Eventive."
	          ) : invalid ? _react2.default.createElement(
	            "p",
	            null,
	            "Please enter a valid URL (including \"https://\") to continue."
	          ) : null
	        ),
	        needsTosConfirm ? _react2.default.createElement(
	          "div",
	          {
	            style: {
	              border: "1px dashed #0288d1",
	              borderRadius: "0.5em",
	              padding: 20,
	              textAlign: "left"
	            }
	          },
	          _react2.default.createElement(
	            "div",
	            {
	              style: {
	                marginTop: "-0.5em",
	                marginBottom: 20,
	                display: "flex"
	              }
	            },
	            THREESIXTY_VR_ENABLED ? _react2.default.createElement(
	              "div",
	              { style: { flex: "1 0 0", marginRight: 10 } },
	              _react2.default.createElement(_selectField2.default, {
	                value: this.state.source_video_layout || "default",
	                onChange: function onChange(v) {
	                  return _this7.setState({
	                    source_video_layout: v.value === "default" ? undefined : v.value
	                  });
	                },
	                label: _react2.default.createElement(
	                  "span",
	                  null,
	                  "Video layout",
	                  " ",
	                  _react2.default.createElement(
	                    "a",
	                    {
	                      href: "https://help.eventive.org/en/articles/5331073-video-specifications-for-eventive-virtual",
	                      target: "_blank"
	                    },
	                    "(?)"
	                  )
	                ),
	                options: [{ value: "default", label: "Default" }, {
	                  value: "360_single",
	                  label: "360°/VR"
	                }],
	                clearable: false
	              })
	            ) : null,
	            _react2.default.createElement(
	              "div",
	              { style: { flex: "1 0 0" } },
	              _react2.default.createElement(_selectField2.default, {
	                value: this.state.source_audio_layout || "default",
	                onChange: function onChange(v) {
	                  return _this7.setState({
	                    source_audio_layout: v.value === "default" ? undefined : v.value
	                  });
	                },
	                label: _react2.default.createElement(
	                  "span",
	                  null,
	                  "Audio layout",
	                  " ",
	                  _react2.default.createElement(
	                    "a",
	                    {
	                      href: "https://help.eventive.org/en/articles/5134510-audio-specifications-for-eventive-virtual",
	                      target: "_blank"
	                    },
	                    "(?)"
	                  )
	                ),
	                options: [{
	                  value: "default",
	                  label: parsedQueryString.audio_beta ? "Stereo" : "Default"
	                }, {
	                  value: "default_with_audio_description",
	                  label: parsedQueryString.audio_beta ? "Stereo + Audio Description" : "Default + Descriptive Audio"
	                }].concat(parsedQueryString.audio_beta ? [{
	                  value: "5_1_surround",
	                  label: "5.1 Surround + Stereo (+ Optional Audio Description)"
	                }, {
	                  value: "5_1_surround_legacy",
	                  label: '"8-Track"/"8-Channel" 5.1 Surround + Stereo'
	                }
	                // { value: "atmos", label: "Dolby Atmos" }
	                ] : []),
	                clearable: false
	              })
	            )
	          ),
	          _react2.default.createElement(_materialUi.Checkbox, {
	            labelStyle: { lineHeight: 1.2 },
	            inputStyle: { width: 50 },
	            label: _react2.default.createElement(
	              "span",
	              null,
	              "I agree that I am authorized to upload the video content",
	              " ",
	              _react2.default.createElement(
	                "span",
	                { style: { wordBreak: "break-all" } },
	                "\"",
	                this.state.file.name,
	                "\""
	              ),
	              " ",
	              "in accordance with the Eventive",
	              " ",
	              _react2.default.createElement(
	                "a",
	                {
	                  target: "_blank",
	                  href: "https://eventive.org/terms",
	                  onClick: function onClick(e) {
	                    return e.stopPropagation();
	                  }
	                },
	                "Terms of Service"
	              ),
	              ".",
	              _UserStore2.default.isGod() && this.state.asset_pathway ? " (pathway: " + this.state.asset_pathway + ")" : ""
	            ),
	            checked: this.state.tosAgreed,
	            onCheck: function onCheck() {
	              return _this7.setState({ tosAgreed: !_this7.state.tosAgreed });
	            }
	          }),
	          _react2.default.createElement(
	            "div",
	            { style: { marginTop: 20, textAlign: "center" } },
	            _react2.default.createElement(_materialUi.RaisedButton, {
	              label: "Begin upload",
	              primary: true,
	              disabled: !this.state.tosAgreed,
	              onClick: function onClick() {
	                return _this7.create();
	              }
	            })
	          )
	        ) : progressStats ? _react2.default.createElement(
	          "div",
	          {
	            style: {
	              textAlign: "center"
	            }
	          },
	          _react2.default.createElement(
	            "div",
	            null,
	            completed ? "Content uploaded" : "Content uploading @ " + ((progressStats.readableSpeed || "").toUpperCase() || "0 KB") + "/s"
	          ),
	          _react2.default.createElement(_materialUi.LinearProgress, {
	            mode: "determinate",
	            max: 1,
	            value: (progressStats.totalUploaded || 0) / (progressStats.fileSize || this.state.file.size),
	            style: {
	              height: "1em",
	              borderRadius: "0.5em",
	              margin: "0.5em 0 0.25em"
	            }
	          }),
	          _react2.default.createElement(
	            "div",
	            { style: { textAlign: "right", fontSize: "0.8em" } },
	            progressStats.secondsLeft && progressStats.secondsLeft > 0 ? _juration2.default.stringify(progressStats.secondsLeft, {
	              format: "short"
	            }) : "∞ hrs",
	            " ",
	            "remaining \xB7 ",
	            (0, _util.formatBytes)(progressStats.totalUploaded || 0),
	            " ",
	            "/ ",
	            (0, _util.formatBytes)(progressStats.fileSize || this.state.file.size)
	          )
	        ) : _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement(
	            "p",
	            { style: { textAlign: "center" } },
	            _react2.default.createElement(
	              _materialUi.RaisedButton,
	              {
	                label: this.props.isCreating ? "Initializing upload..." : "Upload content",
	                primary: true,
	                containerElement: "label",
	                disabled: this.props.isCreating
	              },
	              _react2.default.createElement("input", {
	                type: "file",
	                accept: ".mov,.mp4",
	                style: { display: "none" },
	                ref: function ref(_ref3) {
	                  _this7.input = _ref3;
	                },
	                onChange: function onChange() {
	                  return _this7.create();
	                }
	              })
	            ),
	            !this.props.isCreating ? _react2.default.createElement(
	              "div",
	              null,
	              _react2.default.createElement(
	                "div",
	                {
	                  style: {
	                    marginTop: "1em",
	                    fontSize: "1em",
	                    display: "inline-flex"
	                  }
	                },
	                _react2.default.createElement(
	                  _materialUi.FlatButton,
	                  {
	                    style: {
	                      display: "inline-block",
	                      cursor: "pointer",
	                      color: "#424242",
	                      border: "1px solid #ccc",
	                      borderRadius: "3px",
	                      padding: "6px 8px",
	                      height: "auto",
	                      lineHeight: "1"
	                    },
	                    onClick: function onClick(e) {
	                      _this7.dropboxUpload();
	                    }
	                  },
	                  _react2.default.createElement("span", {
	                    style: {
	                      background: "transparent url('https://www.dropbox.com/static/images/widgets/dbx-saver-status.png') no-repeat",
	                      width: 15,
	                      height: 14,
	                      display: "inline-block",
	                      verticalAlign: -1,
	                      marginRight: 4
	                    }
	                  }),
	                  "Dropbox"
	                ),
	                _react2.default.createElement(
	                  _materialUi.FlatButton,
	                  {
	                    style: {
	                      marginLeft: "1em",
	                      display: "inline-block",
	                      cursor: "pointer",
	                      color: "#424242",
	                      border: "1px solid #ccc",
	                      borderRadius: "3px",
	                      padding: "6px 8px",
	                      height: "auto",
	                      lineHeight: "1"
	                    },
	                    onClick: function onClick(e) {
	                      _this7.urlUpload();
	                    }
	                  },
	                  _react2.default.createElement(_link2.default, {
	                    style: {
	                      width: 16,
	                      height: 16,
	                      margin: "-3px 0px"
	                    }
	                  }),
	                  " ",
	                  "From URL"
	                ),
	                GOOGLE_DRIVE_ENABLED ? _react2.default.createElement(
	                  _materialUi.FlatButton,
	                  {
	                    style: {
	                      marginLeft: "1em",
	                      display: "inline-block",
	                      cursor: "pointer",
	                      color: "#424242",
	                      border: "1px solid #ccc",
	                      borderRadius: "3px",
	                      padding: "6px 8px",
	                      height: "auto",
	                      lineHeight: "1"
	                    },
	                    onClick: function onClick(e) {
	                      _this7.googleDriveUpload();
	                    }
	                  },
	                  _react2.default.createElement("img", {
	                    src: "data:image/png;base64,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",
	                    style: {
	                      width: 15,
	                      height: 15,
	                      display: "inline-block",
	                      verticalAlign: -2,
	                      marginRight: 4
	                    }
	                  }),
	                  "Google Drive"
	                ) : null
	              )
	            ) : null,
	            _react2.default.createElement(
	              "div",
	              {
	                style: {
	                  marginTop: "1em",
	                  fontSize: "0.75em",
	                  lineHeight: 1.25
	                }
	              },
	              "10 GB maximum file size",
	              _react2.default.createElement("br", null),
	              "1080p resolution recommended",
	              _react2.default.createElement("br", null),
	              ".mov, .mp4 accepted"
	            )
	          ),
	          otherVirtualContent.length || this.state.otherContentSearch ? _react2.default.createElement(
	            "div",
	            { style: this.props.otherContentStyle },
	            this.props.otherContentIntroduction,
	            _react2.default.createElement(
	              "div",
	              {
	                style: {
	                  marginLeft: "auto",
	                  marginRight: "auto",
	                  marginTop: this.props.otherContentIntroduction ? 10 : 0,
	                  width: 200
	                }
	              },
	              _react2.default.createElement("input", {
	                type: "text",
	                placeholder: "Search existing content...",
	                value: this.state.otherContentSearch,
	                onChange: function onChange(e) {
	                  _this7.setState({ otherContentSearch: e.target.value });
	                },
	                style: {
	                  border: "1px solid #ccc",
	                  padding: "2px 5px",
	                  borderRadius: 5,
	                  width: "100%",
	                  boxSizing: "border-box"
	                }
	              })
	            ),
	            _react2.default.createElement(
	              "div",
	              {
	                style: {
	                  maxHeight: this.props.otherContentIntroduction ? 205 : 115,
	                  overflowY: "auto",
	                  margin: "1em 0"
	                }
	              },
	              this.state.otherContentSearch && otherVirtualContent.length === 0 ? _react2.default.createElement(
	                "div",
	                {
	                  style: {
	                    fontSize: "0.8em",
	                    textAlign: "center"
	                  }
	                },
	                "No matches found"
	              ) : _react2.default.createElement(
	                "table",
	                {
	                  className: "hoverable",
	                  style: { borderCollapse: "collapse", minWidth: 300 }
	                },
	                _react2.default.createElement(
	                  "tbody",
	                  null,
	                  otherVirtualContent.map(function (content) {
	                    return _react2.default.createElement(
	                      "tr",
	                      {
	                        key: content.id,
	                        className: "",
	                        style: {
	                          fontSize: "0.8em"
	                        }
	                      },
	                      _react2.default.createElement(
	                        "td",
	                        {
	                          style: {
	                            borderTop: "1px solid #ccc",
	                            borderBottom: "1px solid #ccc",
	                            wordBreak: "break-word",
	                            lineHeight: "1.2"
	                          }
	                        },
	                        content.label || "Unlabeled content",
	                        content.platform && _UserStore2.default.isGod() ? " (" + content.platform + ")" : "",
	                        _react2.default.createElement(
	                          "div",
	                          {
	                            style: {
	                              fontSize: "0.8em",
	                              marginTop: 2,
	                              opacity: 0.6
	                            }
	                          },
	                          "Uploaded",
	                          " ",
	                          (0, _moment2.default)(content.created_at).format("ll"),
	                          " ",
	                          "\xB7",
	                          " ",
	                          content.duration ? _juration2.default.stringify(content.duration / 1000, { format: "short" }) : "Still processing"
	                        )
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        {
	                          style: {
	                            whiteSpace: "nowrap",
	                            borderTop: "1px solid #ccc",
	                            borderBottom: "1px solid #ccc"
	                          }
	                        },
	                        _react2.default.createElement(
	                          _linkLike2.default,
	                          {
	                            onTouchTap: function onTouchTap() {
	                              if (_this7.props.onOtherContentSelect) {
	                                _this7.props.onOtherContentSelect(content);
	                              } else {
	                                _this7.props.onSuccess(content);
	                              }
	                            }
	                          },
	                          _this7.props.otherContentIntroduction ? "Use this content" : "Use"
	                        )
	                      )
	                    );
	                  })
	                )
	              )
	            )
	          ) : null
	        )
	      );
	    }
	  }], [{
	    key: "getStores",
	    value: function getStores() {
	      return [_VirtualContentStore2.default];
	    }
	  }, {
	    key: "getPropsFromStores",
	    value: function getPropsFromStores() {
	      return _VirtualContentStore2.default.getState();
	    }
	  }, {
	    key: "contextTypes",
	    get: function get() {
	      return {
	        router: _react2.default.PropTypes.object
	      };
	    }
	  }]);
	
	  return VirtualContentUploader;
	}(_react2.default.Component);
	
	exports.default = (0, _connectToStores2.default)(VirtualContentUploader);
	module.exports = exports["default"];

/***/ }),
/* 1772 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module) {/*
	 * juration - a natural language duration parser
	 * https://github.com/domchristie/juration
	 *
	 * Copyright 2011, Dom Christie
	 * Licenced under the MIT licence
	 *
	 */
	
	(function() {
	
	  var UNITS = {
	    seconds: {
	      patterns: ['second', 'sec', 's'],
	      value: 1,
	      formats: {
	        'chrono': '',
	        'micro':  's',
	        'short':  'sec',
	        'long':   'second',
	        'plural': 'seconds'
	      }
	    },
	    minutes: {
	      patterns: ['minute', 'min', 'm(?!s)'],
	      value: 60,
	      formats: {
	        'chrono': ':',
	        'micro':  'm',
	        'short':  'min',
	        'long':   'minute',
	        'plural': 'minutes'
	      }
	    },
	    hours: {
	      patterns: ['hour', 'hr', 'h'],
	      value: 3600,
	      formats: {
	        'chrono': ':',
	        'micro':  'h',
	        'short':  'hr',
	        'long':   'hour',
	        'plural': 'hours'
	      }
	    },
	    days: {
	      patterns: ['day', 'dy', 'd'],
	      value: 86400,
	      formats: {
	        'chrono': ':',
	        'micro':  'd',
	        'short':  'day',
	        'long':   'day',
	        'plural': 'days'
	      }
	    },
	    weeks: {
	      patterns: ['week', 'wk', 'w'],
	      value: 604800,
	      formats: {
	        'chrono': ':',
	        'micro':  'w',
	        'short':  'wk',
	        'long':   'week',
	        'plural': 'weeks'
	      }
	    },
	    months: {
	      patterns: ['month', 'mon', 'mo', 'mth'],
	      value: 2592000,
	      formats: {
	        'chrono': ':',
	        'micro':  'm',
	        'short':  'mth',
	        'long':   'month',
	        'plural': 'months'
	      }
	    },
	    years: {
	      patterns: ['year', 'yr', 'y'],
	      value: 31536000,
	      formats: {
	        'chrono': ':',
	        'micro':  'y',
	        'short':  'yr',
	        'long':   'year',
	        'plural': 'years'
	      }
	    }
	  };
	    
	  var stringify = function(seconds, options) {
	    
	    if(!_isNumeric(seconds)) {
	      throw "juration.stringify(): Unable to stringify a non-numeric value";
	    }
	    
	    if((typeof options === 'object' && options.format !== undefined) && (options.format !== 'micro' && options.format !== 'short' && options.format !== 'long' && options.format !== 'chrono')) {
	      throw "juration.stringify(): format cannot be '" + options.format + "', and must be either 'micro', 'short', or 'long'";
	    }
	    
	    var defaults = {
	      format: 'long'
	    };
	    
	    var opts = _extend(defaults, options);
	    
	    var units = ['years', 'months', 'days', 'hours', 'minutes', 'seconds'], values = [];
	    for(var i = 0, len = units.length; i < len; i++) {
	      if(i === 0) {
	        values[i] = Math.floor(seconds / UNITS[units[i]].value);
	      }
	      else {
	        values[i] = Math.floor((seconds % UNITS[units[i-1]].value) / UNITS[units[i]].value);
	      }
	      if(opts.format === 'micro' || opts.format === 'chrono') {
	        values[i] += UNITS[units[i]].formats[opts.format];
	      }
	      else {
	        var singular = UNITS[units[i]].formats[opts.format],
	            plural = opts.format === 'long' ? 
	                      UNITS[units[i]].formats['plural'] :
	                      '';
	        values[i] += ' ' + _pluralize(values[i], singular, plural);
	      }
	    }
	    var output = '';
	    for(i = 0, len = values.length; i < len; i++) {
	      if(values[i].charAt(0) !== "0" && opts.format != 'chrono') {
	        output += values[i] + ' ';
	      }
	      else if (opts.format == 'chrono') {
	        output += _padLeft(values[i]+'', '0', i==values.length-1 ? 2 : 3);
	      }
	    }
	    return output.replace(/\s+$/, '').replace(/^(00:)+/g, '').replace(/^0/, '');
	  };
	  
	  var parse = function(string) {
	    
	    // returns calculated values separated by spaces
	    for(var unit in UNITS) {
	      for(var i = 0, mLen = UNITS[unit].patterns.length; i < mLen; i++) {
	        var regex = new RegExp("((?:\\d+\\.\\d+)|\\d+)\\s?(" + UNITS[unit].patterns[i] + "s?(?=\\s|\\d|\\b))", 'gi');
	        string = string.replace(regex, function(str, p1, p2) {
	          return " " + (p1 * UNITS[unit].value).toString() + " ";
	        });
	      }
	    }
	    
	    var sum = 0,
	        numbers = string
	                    .replace(/(?!\.)\W+/g, ' ')                       // replaces non-word chars (excluding '.') with whitespace
	                    .replace(/^\s+|\s+$|(?:and|plus|with)\s?/g, '')   // trim L/R whitespace, replace known join words with ''
	                    .split(' ');
	    
	    for(var j = 0, nLen = numbers.length; j < nLen; j++) {
	      if(numbers[j] && isFinite(numbers[j])) {
	         sum += parseFloat(numbers[j]);
	      } else if(!numbers[j]) {
	        throw "juration.parse(): Unable to parse: a falsey value";
	      } else {
	        // throw an exception if it's not a valid word/unit
	        throw "juration.parse(): Unable to parse: " + numbers[j].replace(/^\d+/g, '');
	      }
	    }
	    return sum;
	  };
	  
	  // _padLeft('5', '0', 2); // 05
	  var _padLeft = function(s, c, n) {
	      if (! s || ! c || s.length >= n) {
	        return s;
	      }
	      
	      var max = (n - s.length)/c.length;
	      for (var i = 0; i < max; i++) {
	        s = c + s;
	      }
	      
	      return s;
	  };
	  
	  var _pluralize = function(count, singular, plural) {
	    return count == 1 ? singular : plural || singular + "s";
	  };
	  
	  var _isNumeric = function(n) {
	    return !isNaN(parseFloat(n)) && isFinite(n);
	  };
	  
	  var _extend = function(obj, extObj) {
	    for (var i in extObj) {
	      if(extObj[i] !== undefined) {
	        obj[i] = extObj[i];
	      }
	    }
	    return obj;
	  };
	  
	  var setLanguage = function(language){
	    if (true){
	      __webpack_require__(1773)("./" + language);
	      return;
	    }
	  }
	  
	  var juration = {
	    UNITS: UNITS,
	    setLanguage: setLanguage,
	    parse: parse,
	    stringify: stringify,
	    humanize: stringify
	  };
	
	  if ( typeof module === "object" && module && typeof module.exports === "object" ) {
	    //loaders that implement the Node module pattern (including browserify)
	    module.exports = juration;
	  } else {
	    // Otherwise expose juration
	    window.juration = juration;
	
	    // Register as a named AMD module
	    if ( true ) {
	      !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () { return juration; }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    }
	  }
	})();
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(485)(module)))

/***/ }),
/* 1773 */
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./it-IT": 1774,
		"./it-IT.js": 1774
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 1773;


/***/ }),
/* 1774 */
/***/ (function(module, exports, __webpack_require__) {

	(function(){
	  var juration;
	  if (true)
	    juration = __webpack_require__(1772);
	  else
	    juration = window.juration;
	  
	  if (juration && juration.UNITS){
	    juration.UNITS.seconds.patterns = ['second', 'sec', 's'];
	    juration.UNITS.minutes.patterns = ['minute', 'min', 'm(?!s)'];
	    juration.UNITS.hours.patterns = ['hour', 'hr', 'h'];
	    juration.UNITS.days.patterns = ['day', 'dy', 'd'];
	    juration.UNITS.weeks.patterns = ['week', 'wk', 'w'];
	    juration.UNITS.months.patterns = ['month', 'mon', 'mo', 'mth'];
	    juration.UNITS.years.patterns = ['year', 'yr', 'y'];
	    
	    juration.UNITS.seconds.formats = {
	      'chrono': '',
	      'micro':  's',
	      'short':  'sec',
	      'long':   'secondo',
	      'plural': 'secondi'
	    };
	    juration.UNITS.minutes.formats = {
	      'chrono': ':',
	      'micro':  'm',
	      'short':  'min',
	      'long':   'minuto',
	      'plural': 'minuti'
	    };
	    juration.UNITS.hours.formats = {
	      'chrono': ':',
	      'micro':  'h',
	      'short':  'hr',
	      'long':   'ora',
	      'plural': 'ore'
	    };
	    juration.UNITS.days.formats = {
	      'chrono': ':',
	      'micro':  'd',
	      'short':  'day',
	      'long':   'giorno',
	      'plural': 'giorni'
	    };
	    juration.UNITS.weeks.formats = {
	      'chrono': ':',
	      'micro':  'w',
	      'short':  'wk',
	      'long':   'settimana',
	      'plural': 'settimane'
	    };
	    juration.UNITS.months.formats = {
	      'chrono': ':',
	      'micro':  'm',
	      'short':  'mth',
	      'long':   'mese',
	      'plural': 'mesi'
	    };
	    juration.UNITS.years.formats = {
	      'chrono': ':',
	      'micro':  'y',
	      'short':  'yr',
	      'long':   'anno',
	      'plural': 'anni'
	    };
	  }
	})();
	


/***/ }),
/* 1775 */
/***/ (function(module, exports) {

	/*Copyright (c) 2016, TT Labs, Inc.
	 All rights reserved.
	
	 Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
	
	 Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
	
	 Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
	
	 Neither the name of the TT Labs, Inc. nor the names of its contributors may be used to endorse or promote products derived from this software without specific prior written permission.
	
	 THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.*/
	
	
	/***************************************************************************************************
	 *                                                                                                 *
	 *  version 2.1.4                                                                                  *
	 *                                                                                                 *
	 ***************************************************************************************************/
	
	(function () {
	  "use strict";
	
	  var FAR_FUTURE = new Date('2060-10-22'),
	      HOURS_AGO,
	      PENDING = 0, EVAPORATING = 2, COMPLETE = 3, PAUSED = 4, CANCELED = 5, ERROR = 10, ABORTED = 20, PAUSING = 30,
	      PAUSED_STATUSES = [PAUSED, PAUSING],
	      ACTIVE_STATUSES = [PENDING, EVAPORATING, ERROR],
	      ETAG_OF_0_LENGTH_BLOB = '"d41d8cd98f00b204e9800998ecf8427e"',
	      PARTS_MONITOR_INTERVAL_MS = 2 * 60 * 1000,
	      IMMUTABLE_OPTIONS = [
	        'maxConcurrentParts',
	        'logging',
	        'cloudfront',
	        'encodeFilename',
	        'computeContentMd5',
	        'allowS3ExistenceOptimization',
	        'onlyRetryForSameFileName',
	        'timeUrl',
	        'cryptoMd5Method',
	        'cryptoHexEncodedHash256',
	        'awsRegion',
	        'awsSignatureVersion',
	        'evaporateChanged'
	      ],
	      S3_EXTRA_ENCODED_CHARS =  {
	        33: "%21", // !
	        39: "%27", // '
	        40: "%28", // (
	        41: "%29", // )
	        42: "%2A"  // *
	      },
	      l;
	
	  var Evaporate = function (config) {
	    this.config = extend({
	      readableStreams: false,
	      readableStreamPartMethod: null,
	      bucket: null,
	      logging: true,
	      maxConcurrentParts: 5,
	      partSize: 6 * 1024 * 1024,
	      retryBackoffPower: 2,
	      maxRetryBackoffSecs: 300,
	      progressIntervalMS: 1000,
	      cloudfront: false,
	      s3Acceleration: false,
	      mockLocalStorage: false,
	      encodeFilename: true,
	      computeContentMd5: false,
	      allowS3ExistenceOptimization: false,
	      onlyRetryForSameFileName: false,
	      timeUrl: null,
	      cryptoMd5Method: null,
	      cryptoHexEncodedHash256: null,
	      aws_key: null,
	      awsRegion: 'us-east-1',
	      awsSignatureVersion: '4',
	      sendCanonicalRequestToSignerUrl: false,
	      s3FileCacheHoursAgo: null, // Must be a whole number of hours. Will be interpreted as negative (hours in the past).
	      signParams: {},
	      signHeaders: {},
	      customAuthMethod: undefined,
	      maxFileSize: null,
	      signResponseHandler: null,
	      xhrWithCredentials: false,
	      // undocumented, experimental
	      localTimeOffset: undefined,
	      evaporateChanged: function () {},
	      abortCompletionThrottlingMs: 1000
	    }, config);
	
	    if (typeof window !== 'undefined' && window.console) {
	      l = window.console;
	      l.d = l.log;
	      l.w = window.console.warn ? l.warn : l.d;
	      l.e = window.console.error ? l.error : l.d;
	    }
	
	    this._instantiationError = this.validateEvaporateOptions();
	    if (typeof this._instantiationError === 'string') {
	      this.supported = false;
	      return;
	    } else {
	      delete this._instantiationError;
	    }
	
	    if (!this.config.logging) {
	      // Reset the logger to be a no_op
	      l = noOpLogger();
	    }
	
	    var _d = new Date();
	    HOURS_AGO = new Date(_d.setHours(_d.getHours() - (this.config.s3FileCacheHoursAgo || -100)));
	    if (typeof config.localTimeOffset === 'number') {
	      this.localTimeOffset = config.localTimeOffset;
	    } else {
	      var self = this;
	      Evaporate.getLocalTimeOffset(this.config)
	          .then(function (offset) {
	            self.localTimeOffset = offset;
	          });
	    }
	    this.pendingFiles = {};
	    this.queuedFiles = [];
	    this.filesInProcess = [];
	    historyCache = new HistoryCache(this.config.mockLocalStorage);
	  };
	  Evaporate.create = function (config) {
	    var evapConfig = extend({}, config);
	    return Evaporate.getLocalTimeOffset(evapConfig)
	        .then(function (offset) {
	          evapConfig.localTimeOffset = offset;
	          return new Promise(function (resolve, reject) {
	            var e = new Evaporate(evapConfig);
	            if (e.supported === true) {
	              resolve(e);
	            } else {
	              reject(e._instantiationError);
	            }
	          });
	        });
	  };
	  Evaporate.getLocalTimeOffset = function (config) {
	    return new Promise(function (resolve, reject) {
	      if (typeof config.localTimeOffset === 'number') {
	        return resolve(config.localTimeOffset);
	      }
	      if (config.timeUrl) {
	        var xhr = new XMLHttpRequest();
	
	        xhr.open("GET", config.timeUrl + '?requestTime=' + new Date().getTime());
	        xhr.onreadystatechange = function () {
	          if (xhr.readyState === 4) {
	            if (xhr.status === 200) {
	              var server_date = new Date(Date.parse(xhr.responseText)),
	                  offset = server_date - new Date();
	              l.d('localTimeOffset is', offset, 'ms');
	              resolve(offset);
	            }
	          }
	        };
	
	        xhr.onerror = function (xhr) {
	          l.e('xhr error timeUrl', xhr);
	          reject('Fetching offset time failed with status: ' + xhr.status);
	        };
	        xhr.send();
	      } else {
	        resolve(0);
	      }
	    });
	  };
	  Evaporate.prototype.config = {};
	  Evaporate.prototype.localTimeOffset = 0;
	  Evaporate.prototype.supported = false;
	  Evaporate.prototype._instantiationError = undefined;
	  Evaporate.prototype.evaporatingCount = 0;
	  Evaporate.prototype.pendingFiles = {};
	  Evaporate.prototype.filesInProcess = [];
	  Evaporate.prototype.queuedFiles = [];
	  Evaporate.prototype.startNextFile = function (reason) {
	    if (!this.queuedFiles.length ||
	        this.evaporatingCount >= this.config.maxConcurrentParts) { return; }
	    var fileUpload = this.queuedFiles.shift();
	    if (fileUpload.status === PENDING) {
	      l.d('Starting', decodeURIComponent(fileUpload.name), 'reason:', reason);
	      this.evaporatingCnt(+1);
	      fileUpload.start();
	    } else {
	      // Add the file back to the stack, it's not ready
	      l.d('Requeued', decodeURIComponent(fileUpload.name), 'status:', fileUpload.status, 'reason:', reason);
	      this.queuedFiles.push(fileUpload);
	    }
	  };
	  Evaporate.prototype.fileCleanup = function (fileUpload) {
	    removeAtIndex(this.queuedFiles, fileUpload);
	    if (removeAtIndex(this.filesInProcess, fileUpload)) {
	      this.evaporatingCnt(-1);
	    }
	    fileUpload.done();
	    this.consumeRemainingSlots();
	  };
	  Evaporate.prototype.queueFile = function (fileUpload) {
	    this.filesInProcess.push(fileUpload);
	    this.queuedFiles.push(fileUpload);
	    if (this.filesInProcess.length === 1) {
	      this.startNextFile('first file');
	    }
	  };
	  Evaporate.prototype.add = function (file,  pConfig) {
	    var self = this,
	        fileConfig;
	    return new Promise(function (resolve, reject) {
	      var c = extend(pConfig, {});
	
	      IMMUTABLE_OPTIONS.forEach(function (a) { delete c[a]; });
	
	      fileConfig = extend(self.config, c);
	
	      if (typeof file === 'undefined' || typeof file.file === 'undefined') {
	        return reject('Missing file');
	      }
	      if (fileConfig.maxFileSize && file.file.size > fileConfig.maxFileSize) {
	        return reject('File size too large. Maximum size allowed is ' + fileConfig.maxFileSize);
	      }
	      if (typeof file.name === 'undefined') {
	        return reject('Missing attribute: name');
	      }
	
	      if (fileConfig.encodeFilename) {
	        // correctly encode to an S3 object name, considering '/' and ' '
	        file.name = s3EncodedObjectName(file.name);
	      }
	
	      var fileUpload = new FileUpload(extend({
	            started: function () {},
	            uploadInitiated: function () {},
	            progress: function () {},
	            complete: function () {},
	            cancelled: function () {},
	            paused: function () {},
	            resumed: function () {},
	            pausing: function () {},
	            nameChanged: function () {},
	            info: function () {},
	            warn: function () {},
	            error: function () {},
	            beforeSigner: undefined,
	            xAmzHeadersAtInitiate: {},
	            notSignedHeadersAtInitiate: {},
	            xAmzHeadersCommon: null,
	            xAmzHeadersAtUpload: {},
	            xAmzHeadersAtComplete: {}
	          }, file, {
	            status: PENDING,
	            priority: 0,
	            loadedBytes: 0,
	            sizeBytes: file.file.size,
	            eTag: ''
	          }), fileConfig, self),
	          fileKey = fileUpload.id;
	
	      self.pendingFiles[fileKey] = fileUpload;
	
	      self.queueFile(fileUpload);
	
	      // Resolve or reject the Add promise based on how the fileUpload completes
	      fileUpload.deferredCompletion.promise
	          .then(
	              function () {
	                self.fileCleanup(fileUpload);
	                resolve(decodeURIComponent(fileUpload.name));
	              },
	              function (reason) {
	                self.fileCleanup(fileUpload);
	                reject(reason);
	              }
	          );
	    })
	  };
	  Evaporate.prototype.cancel = function (id) {
	    return typeof id === 'undefined' ? this._cancelAll() : this._cancelOne(id);
	  };
	  Evaporate.prototype._cancelAll = function () {
	    l.d('Canceling all file uploads');
	    var promises = [];
	    for (var key in this.pendingFiles) {
	      if (this.pendingFiles.hasOwnProperty(key)) {
	        var file = this.pendingFiles[key];
	        if (ACTIVE_STATUSES.indexOf(file.status) > -1) {
	          promises.push(file.stop());
	        }
	      }
	    }
	    if (!promises.length) {
	      promises.push(Promise.reject('No files to cancel.'));
	    }
	    return Promise.all(promises);
	  };
	  Evaporate.prototype._cancelOne = function (id) {
	    var promise = [];
	    if (this.pendingFiles[id]) {
	      promise.push(this.pendingFiles[id].stop());
	    } else {
	      promise.push(Promise.reject('File does not exist'));
	    }
	    return Promise.all(promise);
	  };
	  Evaporate.prototype.pause = function (id, options) {
	    options = options || {};
	    var force = typeof options.force === 'undefined' ? false : options.force;
	    return typeof id === 'undefined' ? this._pauseAll(force) : this._pauseOne(id, force);
	  };
	  Evaporate.prototype._pauseAll = function (force) {
	    l.d('Pausing all file uploads');
	    var promises = [];
	    for (var key in this.pendingFiles) {
	      if (this.pendingFiles.hasOwnProperty(key)) {
	        var file = this.pendingFiles[key];
	        if (ACTIVE_STATUSES.indexOf(file.status) > -1) {
	          this._pause(file, force, promises);
	        }
	      }
	    }
	    return Promise.all(promises);
	  };
	  Evaporate.prototype._pauseOne = function (id, force) {
	    var promises = [],
	        file = this.pendingFiles[id];
	    if (typeof file === 'undefined') {
	      promises.push(Promise.reject('Cannot pause a file that has not been added.'));
	    } else if (file.status === PAUSED) {
	      promises.push(Promise.reject('Cannot pause a file that is already paused.'));
	    }
	    if (!promises.length) {
	      this._pause(file, force, promises);
	    }
	    return Promise.all(promises);
	  };
	  Evaporate.prototype._pause = function(fileUpload, force, promises) {
	    promises.push(fileUpload.pause(force));
	    removeAtIndex(this.filesInProcess, fileUpload);
	    removeAtIndex(this.queuedFiles, fileUpload);
	  };
	  Evaporate.prototype.resume = function (id) {
	    return typeof id === 'undefined' ? this._resumeAll() : this._resumeOne(id);
	  };
	  Evaporate.prototype._resumeAll = function () {
	    l.d('Resuming all file uploads');
	    for (var key in this.pendingFiles) {
	      if (this.pendingFiles.hasOwnProperty(key)) {
	        var file = this.pendingFiles[key];
	        if (PAUSED_STATUSES.indexOf(file.status) > -1)  {
	          this.resumeFile(file);
	        }
	      }
	    }
	    return Promise.resolve();
	  };
	  Evaporate.prototype._resumeOne = function (id) {
	    var file = this.pendingFiles[id],
	        promises = [];
	    if (typeof file === 'undefined') {
	      promises.push(Promise.reject('Cannot pause a file that does not exist.'));
	    } else if (PAUSED_STATUSES.indexOf(file.status) === -1) {
	      promises.push(Promise.reject('Cannot resume a file that has not been paused.'));
	    } else {
	      this.resumeFile(file);
	    }
	    return Promise.all(promises);
	  };
	  Evaporate.prototype.resumeFile = function (fileUpload) {
	    fileUpload.resume();
	    this.queueFile(fileUpload);
	  };
	  Evaporate.prototype.forceRetry = function () {};
	  Evaporate.prototype.consumeRemainingSlots = function () {
	    var avail = this.config.maxConcurrentParts - this.evaporatingCount;
	    if (!avail) { return; }
	    for (var i = 0; i < this.filesInProcess.length; i++) {
	      var file = this.filesInProcess[i];
	      var consumed = file.consumeSlots();
	      if (consumed < 0) { continue; }
	      avail -= consumed;
	      if (!avail) { return; }
	    }
	  };
	  Evaporate.prototype.validateEvaporateOptions = function () {
	    this.supported = !(
	    typeof File === 'undefined' ||
	    typeof Promise === 'undefined');
	
	    if (!this.supported) {
	      return 'Evaporate requires support for File and Promise';
	    }
	
	    if (this.config.readableStreams) {
	      if (typeof this.config.readableStreamPartMethod !== 'function') {
	        return "Option readableStreamPartMethod is required when readableStreams is set."
	      }
	    } else  {
	      if (typeof Blob === 'undefined' || typeof (
	          Blob.prototype.webkitSlice ||
	          Blob.prototype.mozSlice ||
	          Blob.prototype.slice) === 'undefined') {
	        return 'Evaporate requires support for Blob [webkitSlice || mozSlice || slice]';
	      }
	    }
	
	    if (!this.config.signerUrl && typeof this.config.customAuthMethod !== 'function') {
	      return "Option signerUrl is required unless customAuthMethod is present.";
	    }
	
	    if (!this.config.bucket) {
	      return "The AWS 'bucket' option must be present.";
	    }
	
	    if (this.config.computeContentMd5) {
	      this.supported = typeof FileReader.prototype.readAsArrayBuffer !== 'undefined';
	      if (!this.supported) {
	        return 'The browser\'s FileReader object does not support readAsArrayBuffer';
	      }
	
	      if (typeof this.config.cryptoMd5Method !== 'function') {
	        return 'Option computeContentMd5 has been set but cryptoMd5Method is not defined.'
	      }
	
	      if (this.config.awsSignatureVersion === '4') {
	        if (typeof this.config.cryptoHexEncodedHash256 !== 'function') {
	          return 'Option awsSignatureVersion is 4 but cryptoHexEncodedHash256 is not defined.';
	        }
	      }
	    } else if (this.config.awsSignatureVersion === '4') {
	      return 'Option awsSignatureVersion is 4 but computeContentMd5 is not enabled.';
	    }
	    return true;
	  };
	  Evaporate.prototype.evaporatingCnt = function (incr) {
	    this.evaporatingCount = Math.max(0, this.evaporatingCount + incr);
	    this.config.evaporateChanged(this, this.evaporatingCount);
	  };
	
	
	  function FileUpload(file, con, evaporate) {
	    this.fileTotalBytesUploaded = 0;
	    this.s3Parts = [];
	    this.partsOnS3 = [];
	    this.partsInProcess = [];
	    this.partsToUpload = [];
	    this.numParts = -1;
	    this.con = extend({}, con);
	    this.evaporate = evaporate;
	    this.localTimeOffset = evaporate.localTimeOffset;
	    this.deferredCompletion = defer();
	
	    extend(this, file);
	
	    this.id = decodeURIComponent(this.con.bucket + '/' + this.name);
	
	    this.signParams = con.signParams;
	  }
	  FileUpload.prototype.con = undefined;
	  FileUpload.prototype.evaporate = undefined;
	  FileUpload.prototype.localTimeOffset = 0;
	  FileUpload.prototype.id = undefined;
	  FileUpload.prototype.status = PENDING;
	  FileUpload.prototype.numParts = -1;
	  FileUpload.prototype.fileTotalBytesUploaded = 0;
	  FileUpload.prototype.partsInProcess = [];
	  FileUpload.prototype.partsToUpload = [];
	  FileUpload.prototype.s3Parts = [];
	  FileUpload.prototype.partsOnS3 = [];
	  FileUpload.prototype.deferredCompletion = undefined;
	  FileUpload.prototype.abortedByUser = false;
	
	  // Progress and Stats
	  FileUpload.prototype.progressInterval = undefined;
	  FileUpload.prototype.startTime = undefined;
	  FileUpload.prototype.loaded = 0;
	  FileUpload.prototype.totalUploaded = 0;
	  FileUpload.prototype.updateLoaded = function (loadedNow) {
	    this.loaded += loadedNow;
	    this.fileTotalBytesUploaded += loadedNow;
	  };
	  FileUpload.prototype.progessStats = function () {
	    // Adapted from https://github.com/fkjaekel
	    // https://github.com/TTLabs/EvaporateJS/issues/13
	    if (this.fileTotalBytesUploaded === 0) {
	      return {
	        speed: 0,
	        readableSpeed: "",
	        loaded: 0,
	        totalUploaded: 0,
	        remainingSize: this.sizeBytes,
	        secondsLeft: -1,
	        fileSize: this.sizeBytes,
	      };
	    }
	
	    this.totalUploaded += this.loaded;
	    var delta = (new Date() - this.startTime) / 1000,
	        avgSpeed = this.totalUploaded / delta,
	        remainingSize = this.sizeBytes - this.fileTotalBytesUploaded,
	        stats = {
	          speed: avgSpeed,
	          readableSpeed: readableFileSize(avgSpeed),
	          loaded: this.loaded,
	          totalUploaded: this.fileTotalBytesUploaded,
	          remainingSize: remainingSize,
	          secondsLeft: -1,
	          fileSize: this.sizeBytes,
	
	        };
	
	    if (avgSpeed > 0) {
	      stats.secondsLeft = Math.round(remainingSize / avgSpeed);
	    }
	
	    return stats;
	  };
	  FileUpload.prototype.onProgress = function () {
	    if ([ABORTED, PAUSED].indexOf(this.status) === -1) {
	      this.progress(this.fileTotalBytesUploaded / this.sizeBytes, this.progessStats());
	      this.loaded = 0;
	    }
	  };
	  FileUpload.prototype.startMonitor = function () {
	    clearInterval(this.progressInterval);
	    this.startTime = new Date();
	    this.loaded = 0;
	    this.totalUploaded = 0;
	    this.onProgress();
	    this.progressInterval = setInterval(this.onProgress.bind(this), this.con.progressIntervalMS);
	  };
	  FileUpload.prototype.stopMonitor = function () {
	    clearInterval(this.progressInterval);
	  };
	
	  // Evaporate proxies
	  FileUpload.prototype.startNextFile = function (reason) {
	    this.evaporate.startNextFile(reason);
	  };
	  FileUpload.prototype.evaporatingCnt = function (incr) {
	    this.evaporate.evaporatingCnt(incr);
	  };
	  FileUpload.prototype.consumeRemainingSlots = function () {
	    this.evaporate.consumeRemainingSlots();
	  };
	  FileUpload.prototype.getRemainingSlots = function () {
	    var evapCount = this.evaporate.evaporatingCount;
	    if (!this.partsInProcess.length && evapCount > 0) {
	      // we can use our file slot
	      evapCount -= 1;
	    }
	    return this.con.maxConcurrentParts - evapCount;
	  };
	
	  FileUpload.prototype.lastPartSatisfied = Promise.resolve('onStart');
	
	  FileUpload.prototype.start = function () {
	    this.status = EVAPORATING;
	    this.startMonitor();
	    this.started(this.id);
	
	    if (this.uploadId) {
	      l.d('resuming FileUpload ', this.id);
	      return this.consumeSlots();
	    }
	
	    var awsKey = this.name;
	
	    this.getUnfinishedFileUpload();
	
	    var existenceOptimized = this.con.computeContentMd5 &&
	            this.con.allowS3ExistenceOptimization &&
	            typeof this.firstMd5Digest !== 'undefined' &&
	            typeof this.eTag !== 'undefined';
	
	        if (this.uploadId) {
	          if (existenceOptimized) {
	            return this.reuseS3Object(awsKey)
	                .then(this.deferredCompletion.resolve)
	                .catch(this.uploadFileFromScratch.bind(this));
	          }
	
	          this.resumeInterruptedUpload()
	              .then(this._uploadComplete.bind(this))
	              .catch(this.uploadFileFromScratch.bind(this));
	        } else {
	          this.uploadFileFromScratch("");
	        }
	  };
	  FileUpload.prototype.uploadFileFromScratch = function (reason) {
	    if (ACTIVE_STATUSES.indexOf(this.status) === -1) { return; }
	    l.d(reason);
	    this.uploadId = undefined;
	    return this.uploadFile(this.name)
	        .then(this._uploadComplete.bind(this))
	        .catch(this._abortUpload.bind(this));
	  };
	  FileUpload.prototype._uploadComplete = function () {
	    this.completeUpload().then(this.deferredCompletion.resolve);
	  };
	  FileUpload.prototype.stop = function () {
	    l.d('stopping FileUpload ', this.id);
	    this.setStatus(CANCELED);
	    this.info('Canceling uploads...');
	    this.abortedByUser = true;
	    var self = this;
	    return this.abortUpload()
	        .then(function () {
	          throw("User aborted the upload");
	        })
	        .catch(function (reason) {
	          self.deferredCompletion.reject(reason);
	        });
	  };
	  FileUpload.prototype.pause = function (force) {
	    l.d('pausing FileUpload, force:', !!force, this.id);
	    var promises = [];
	    this.info('Pausing uploads...');
	    this.status = PAUSING;
	    if (force) {
	      this.abortParts(true);
	    } else {
	      promises = this.partsInProcess.map(function (p) {
	        return this.s3Parts[p].awsRequest.awsDeferred.promise
	      }, this);
	      this.pausing();
	    }
	    return Promise.all(promises)
	        .then(function () {
	          this.stopMonitor();
	          this.status = PAUSED;
	          this.startNextFile('pause');
	          this.paused();
	        }.bind(this));
	  };
	  FileUpload.prototype.resume = function () {
	    this.status = PENDING;
	    this.resumed();
	  };
	  FileUpload.prototype.done = function () {
	    clearInterval(this.progressInterval);
	    this.startNextFile('file done');
	    this.partsOnS3 = [];
	    this.s3Parts = [];
	  };
	  FileUpload.prototype._startCompleteUpload = function (callComplete) {
	    return function () {
	      var promise = callComplete ? this.completeUpload() : Promise.resolve();
	      promise.then(this.deferredCompletion.resolve.bind(this));
	    }
	  };
	  FileUpload.prototype._abortUpload = function () {
	    if (!this.abortedByUser) {
	      var self = this;
	      this.abortUpload()
	          .then(
	              function () { self.deferredCompletion.reject('File upload aborted due to a part failing to upload'); },
	              this.deferredCompletion.reject.bind(this));
	    }
	  };
	
	  FileUpload.prototype.abortParts = function (pause) {
	    var self = this;
	    var toAbort = this.partsInProcess.slice(0);
	    toAbort.forEach(function (i) {
	      var s3Part = self.s3Parts[i];
	      if (s3Part) {
	        s3Part.awsRequest.abort();
	        if (pause) { s3Part.status = PENDING; }
	        removeAtIndex(self.partsInProcess, s3Part.partNumber);
	        if (self.partsToUpload.length) { self.evaporatingCnt(-1); }
	      }
	    });
	  };
	  FileUpload.prototype.makeParts = function (firstPart) {
	    this.numParts = Math.ceil(this.sizeBytes / this.con.partSize) || 1; // issue #58
	    var partsDeferredPromises = [];
	
	    var self = this;
	
	    function cleanUpAfterPart(s3Part) {
	      removeAtIndex(self.partsToUpload, s3Part.partNumber);
	      removeAtIndex(self.partsInProcess, s3Part.partNumber);
	
	      if (self.partsToUpload.length) { self.evaporatingCnt(-1); }
	    }
	
	    function resolve(s3Part) { return function () {
	      cleanUpAfterPart(s3Part);
	      if (self.partsToUpload.length) { self.consumeRemainingSlots(); }
	      if (self.partsToUpload.length < self.con.maxConcurrentParts) {
	        self.startNextFile('part resolve');
	      }
	    };
	    }
	    function reject(s3Part) { return function () {
	      cleanUpAfterPart(s3Part);
	    };
	    }
	
	    var limit = firstPart ? 1 : this.numParts;
	
	    for (var part = 1; part <= limit; part++) {
	      var s3Part = this.s3Parts[part];
	      if (typeof s3Part !== "undefined"){
	        if(s3Part.status === COMPLETE) { continue; }
	      } else {
	        s3Part = this.makePart(part, PENDING, this.sizeBytes);
	      }
	      s3Part.awsRequest = new PutPart(this, s3Part);
	      s3Part.awsRequest.awsDeferred.promise
	          .then(resolve(s3Part), reject(s3Part));
	
	      this.partsToUpload.push(part);
	      partsDeferredPromises.push(this.s3Parts[part].awsRequest.awsDeferred.promise);
	    }
	
	    return partsDeferredPromises;
	  };
	  FileUpload.prototype.makePart = function (partNumber, status, size) {
	    var s3Part = {
	      status: status,
	      loadedBytes: 0,
	      loadedBytesPrevious: null,
	      isEmpty: (size === 0), // issue #58
	      md5_digest: null,
	      partNumber: partNumber
	    };
	
	    this.s3Parts[partNumber] = s3Part;
	
	    return s3Part;
	  };
	  FileUpload.prototype.setStatus = function (s) {
	    this.status = s;
	  };
	
	  FileUpload.prototype.createUploadFile = function () {
	    if (this.status === ABORTED) { return; }
	    var fileKey = uploadKey(this),
	        newUpload = {
	          awsKey: this.name,
	          bucket: this.con.bucket,
	          uploadId: this.uploadId,
	          fileSize: this.sizeBytes,
	          fileType: this.file.type,
	          lastModifiedDate: dateISOString(this.file.lastModified),
	          partSize: this.con.partSize,
	          signParams: this.con.signParams,
	          createdAt: new Date().toISOString()
	        };
	    saveUpload(fileKey, newUpload);
	  };
	  FileUpload.prototype.updateUploadFile = function (updates) {
	    var fileKey = uploadKey(this),
	        uploads = getSavedUploads(),
	        upload = extend({}, uploads[fileKey], updates);
	    saveUpload(fileKey, upload);
	  };
	  FileUpload.prototype.completeUploadFile = function (xhr) {
	    var uploads = getSavedUploads(),
	        upload = uploads[uploadKey(this)];
	
	    if (typeof upload !== 'undefined') {
	      upload.completedAt = new Date().toISOString();
	      upload.eTag = this.eTag;
	      upload.firstMd5Digest = this.firstMd5Digest;
	      uploads[uploadKey(this)] = upload;
	      historyCache.setItem('awsUploads', JSON.stringify(uploads));
	    }
	
	    this.complete(xhr, this.name, this.progessStats());
	    this.setStatus(COMPLETE);
	    this.onProgress();
	  };
	  FileUpload.prototype.removeUploadFile = function (){
	    if (typeof this.file !== 'undefined') {
	      removeUpload(uploadKey(this));
	    }
	  };
	  FileUpload.prototype.getUnfinishedFileUpload = function () {
	    var savedUploads = getSavedUploads(true),
	        u = savedUploads[uploadKey(this)];
	
	    if (this.canRetryUpload(u)) {
	      this.uploadId = u.uploadId;
	      this.name = u.awsKey;
	      this.eTag = u.eTag;
	      this.firstMd5Digest = u.firstMd5Digest;
	      this.signParams = u.signParams;
	    }
	  };
	  FileUpload.prototype.canRetryUpload = function (u) {
	    // Must be the same file name, file size, last_modified, file type as previous upload
	    if (typeof u === 'undefined') {
	      return false;
	    }
	    var completedAt = new Date(u.completedAt || FAR_FUTURE);
	
	    // check that the part sizes and bucket match, and if the file name of the upload
	    // matches if onlyRetryForSameFileName is true
	    return this.con.partSize === u.partSize &&
	        completedAt > HOURS_AGO &&
	        this.con.bucket === u.bucket &&
	        (this.con.onlyRetryForSameFileName ? this.name === u.awsKey : true);
	  };
	
	  FileUpload.prototype.partSuccess = function (eTag, putRequest) {
	    var part = putRequest.part;
	    l.d(putRequest.request.step, 'ETag:', eTag);
	    if (part.isEmpty || (eTag !== ETAG_OF_0_LENGTH_BLOB)) { // issue #58
	      part.eTag = eTag;
	      part.status = COMPLETE;
	      this.partsOnS3.push(part);
	      return true;
	    } else {
	      part.status = ERROR;
	      putRequest.resetLoadedBytes();
	      var msg = ['eTag matches MD5 of 0 length blob for part #', putRequest.partNumber, 'Retrying part.'].join(" ");
	      l.w(msg);
	      this.warn(msg);
	    }
	  };
	  FileUpload.prototype.listPartsSuccess = function (listPartsRequest, partsXml) {
	    this.info('uploadId', this.uploadId, 'is not complete. Fetching parts from part marker', listPartsRequest.partNumberMarker);
	    partsXml = partsXml.replace(/(\r\n|\n|\r)/gm, ""); // strip line breaks to ease the regex requirements
	    var partRegex = /<Part>(.+?)<\/Part\>/g;
	
	    while (true) {
	      var cp = (partRegex.exec(partsXml) || [])[1];
	      if (!cp) { break; }
	
	      var partSize = parseInt(elementText(cp, "Size"), 10);
	      this.fileTotalBytesUploaded += partSize;
	      this.partsOnS3.push({
	        eTag: elementText(cp, "ETag").replace(/&quot;/g, '"'),
	        partNumber: parseInt(elementText(cp, "PartNumber"), 10),
	        size: partSize,
	        LastModified: elementText(cp, "LastModified")
	      });
	    }
	    return elementText(partsXml, "IsTruncated") === 'true' ? elementText(partsXml, "NextPartNumberMarker") : undefined;
	  };
	  FileUpload.prototype.makePartsfromPartsOnS3 = function () {
	    if (ACTIVE_STATUSES.indexOf(this.status) === -1) { return; }
	    this.nameChanged(this.name);
	    this.partsOnS3.forEach(function (cp) {
	      var uploadedPart = this.makePart(cp.partNumber, COMPLETE, cp.size);
	      uploadedPart.eTag = cp.eTag;
	      uploadedPart.loadedBytes = cp.size;
	      uploadedPart.loadedBytesPrevious = cp.size;
	      uploadedPart.finishedUploadingAt = cp.LastModified;
	    }.bind(this));
	  };
	  FileUpload.prototype.completeUpload = function () {
	    var self = this;
	    return new CompleteMultipartUpload(this)
	        .send()
	        .then(
	            function (xhr) {
	              self.eTag = elementText(xhr.responseText, "ETag").replace(/&quot;/g, '"');
	              self.completeUploadFile(xhr);
	            });
	  };
	  FileUpload.prototype.getCompletedPayload = function () {
	    var completeDoc = [];
	    completeDoc.push('<CompleteMultipartUpload>');
	    this.s3Parts.forEach(function (part, partNumber) {
	      if (partNumber > 0) {
	        ['<Part><PartNumber>', partNumber, '</PartNumber><ETag>', part.eTag, '</ETag></Part>']
	            .forEach(function (a) { completeDoc.push(a); });
	      }
	    });
	    completeDoc.push('</CompleteMultipartUpload>');
	
	    return completeDoc.join("");
	  };
	  FileUpload.prototype.consumeSlots = function () {
	    if (this.partsToUpload.length === 0) { return -1 }
	    if (this.partsToUpload.length !== this.partsInProcess.length &&
	        this.status === EVAPORATING) {
	
	      var partsToUpload = Math.min(this.getRemainingSlots(), this.partsToUpload.length);
	
	      if (!partsToUpload) { return -1; }
	
	      var satisfied = 0;
	      for (var i = 0; i < this.partsToUpload.length; i++) {
	        var s3Part = this.s3Parts[this.partsToUpload[i]];
	
	        if (s3Part.status === EVAPORATING) { continue; }
	
	        if (this.canStartPart(s3Part)) {
	          if (this.partsInProcess.length && this.partsToUpload.length > 1) {
	            this.evaporatingCnt(+1);
	          }
	          this.partsInProcess.push(s3Part.partNumber);
	          var awsRequest = s3Part.awsRequest;
	          this.lastPartSatisfied.then(awsRequest.delaySend.bind(awsRequest));
	          this.lastPartSatisfied = awsRequest.getStartedPromise();
	        } else { continue; }
	
	        satisfied += 1;
	
	        if (satisfied === partsToUpload) { break; }
	
	      }
	      var allInProcess = this.partsToUpload.length === this.partsInProcess.length,
	          remainingSlots = this.getRemainingSlots();
	      if (allInProcess && remainingSlots > 0) {
	        // We don't need any more slots...
	        this.startNextFile('consume slots');
	      }
	      return remainingSlots;
	    }
	    return 0;
	  };
	  FileUpload.prototype.canStartPart = function (part) {
	    return this.partsInProcess.indexOf(part.partNumber) === -1 && !part.awsRequest.errorExceptionStatus();
	  };
	  FileUpload.prototype.uploadFile = function (awsKey) {
	    this.removeUploadFile();
	    var self = this;
	    return new InitiateMultipartUpload(self, awsKey)
	        .send()
	        .then(
	            function () {
	              self.uploadInitiated(self.uploadId);
	              self.partsToUpload = [];
	              return self.uploadParts()
	                  .then(
	                      function () {},
	                      function (reason) {
	                        throw(reason);
	                      })
	            });
	  };
	  FileUpload.prototype.uploadParts = function () {
	    this.loaded = 0;
	    this.totalUploaded = 0;
	    if (ACTIVE_STATUSES.indexOf(this.status) === -1) {
	      return Promise.reject('Part uploading stopped because the file was canceled');
	    }
	    var promises = this.makeParts();
	    this.setStatus(EVAPORATING);
	    this.startTime = new Date();
	    this.consumeSlots();
	    return Promise.all(promises);
	  };
	  FileUpload.prototype.abortUpload = function () {
	    return new Promise(function (resolve, reject) {
	
	      if(typeof this.uploadId === 'undefined') {
	        resolve();
	        return;
	      }
	
	      new DeleteMultipartUpload(this)
	          .send()
	          .then(resolve, reject);
	    }.bind(this))
	        .then(
	            function () {
	              this.setStatus(ABORTED);
	              this.cancelled();
	              this.removeUploadFile();
	            }.bind(this),
	            this.deferredCompletion.reject.bind(this));
	  };
	  FileUpload.prototype.resumeInterruptedUpload = function () {
	    return new ResumeInterruptedUpload(this)
	        .send()
	        .then(this.uploadParts.bind(this));
	  };
	  FileUpload.prototype.reuseS3Object = function (awsKey) {
	    var self = this;
	    // Attempt to reuse entire uploaded object on S3
	    this.makeParts(1);
	    this.partsToUpload = [];
	    var firstS3Part = this.s3Parts[1];
	    function reject(reason) {
	      self.name = awsKey;
	      throw(reason);
	    }
	    return firstS3Part.awsRequest.getPartMd5Digest()
	        .then(function () {
	          if (self.firstMd5Digest === firstS3Part.md5_digest) {
	            return new ReuseS3Object(self, awsKey)
	                .send()
	                .then(
	                    function (xhr) {
	                      l.d('headObject found matching object on S3.');
	                      self.completeUploadFile(xhr);
	                      self.nameChanged(self.name);
	                    })
	                .catch(reject);
	
	          } else {
	            var msg = self.con.allowS3ExistenceOptimization ? 'File\'s first part MD5 digest does not match what was stored.' : 'allowS3ExistenceOptimization is not enabled.';
	            reject(msg);
	          }
	        });
	  };
	
	
	  function SignedS3AWSRequest(fileUpload, request) {
	    this.fileUpload = fileUpload;
	    this.con = fileUpload.con;
	    this.attempts = 1;
	    this.localTimeOffset = this.fileUpload.localTimeOffset;
	    this.awsDeferred = defer();
	    this.started = defer();
	
	    this.awsUrl = awsUrl(this.con);
	    this.awsHost = uri(this.awsUrl).hostname;
	
	    var r = extend({}, request);
	    if (fileUpload.contentType) {
	      r.contentType = fileUpload.contentType;
	    }
	
	    this.updateRequest(r);
	  }
	  SignedS3AWSRequest.prototype.fileUpload = undefined;
	  SignedS3AWSRequest.prototype.con = undefined;
	  SignedS3AWSRequest.prototype.awsUrl = undefined;
	  SignedS3AWSRequest.prototype.awsHost = undefined;
	  SignedS3AWSRequest.prototype.authorize = function () {};
	  SignedS3AWSRequest.prototype.localTimeOffset = 0;
	  SignedS3AWSRequest.prototype.awsDeferred = undefined;
	  SignedS3AWSRequest.prototype.started = undefined;
	  SignedS3AWSRequest.prototype.getPath = function () {
	    var path = '/' + this.con.bucket + '/' + this.fileUpload.name;
	    if (this.con.cloudfront || this.awsUrl.indexOf('cloudfront') > -1) {
	      path = '/' + this.fileUpload.name;
	    }
	    return path;
	  };
	
	  SignedS3AWSRequest.prototype.updateRequest = function (request) {
	    this.request = request;
	    var SigningClass = signingVersion(this, l);
	    this.signer = new SigningClass(request);
	  };
	  SignedS3AWSRequest.prototype.success = function () { this.awsDeferred.resolve(this.currentXhr); };
	  SignedS3AWSRequest.prototype.backOffWait = function () {
	    return (this.attempts === 1) ? 0 : 1000 * Math.min(
	            this.con.maxRetryBackoffSecs,
	            Math.pow(this.con.retryBackoffPower, this.attempts - 2)
	        );
	  };
	  SignedS3AWSRequest.prototype.error =  function (reason) {
	    if (this.errorExceptionStatus()) {
	      return;
	    }
	
	    this.signer.error();
	    l.d(this.request.step, 'error:', this.fileUpload.id, reason);
	
	    if (typeof this.errorHandler(reason) !== 'undefined' ) {
	      return;
	    }
	
	    this.fileUpload.warn('Error in ', this.request.step, reason);
	    this.fileUpload.setStatus(ERROR);
	
	    var self = this,
	        backOffWait = this.backOffWait();
	    this.attempts += 1;
	
	    setTimeout(function () {
	      if (!self.errorExceptionStatus()) { self.trySend(); }
	    }, backOffWait);
	  };
	  SignedS3AWSRequest.prototype.errorHandler = function () { };
	  SignedS3AWSRequest.prototype.errorExceptionStatus = function () { return false; };
	  SignedS3AWSRequest.prototype.getPayload = function () { return Promise.resolve(null); };
	  SignedS3AWSRequest.prototype.success_status = function (xhr) {
	    return (xhr.status >= 200 && xhr.status <= 299) ||
	        this.request.success404 && xhr.status === 404;
	  };
	  SignedS3AWSRequest.prototype.stringToSign = function () {
	    return encodeURIComponent(this.signer.stringToSign());
	  };
	  SignedS3AWSRequest.prototype.canonicalRequest = function () {
	    return this.signer.canonicalRequest();
	  }
	  SignedS3AWSRequest.prototype.signResponse = function(payload, stringToSign, signatureDateTime) {
	    var self = this;
	    return new Promise(function (resolve) {
	      if (typeof self.con.signResponseHandler === 'function') {
	        return self.con.signResponseHandler(payload, stringToSign, signatureDateTime)
	            .then(resolve);
	      }
	      resolve(payload);
	    });
	  };
	  SignedS3AWSRequest.prototype.sendRequestToAWS = function () {
	    var self = this;
	    return new Promise( function (resolve, reject) {
	      var xhr = new XMLHttpRequest();
	      self.currentXhr = xhr;
	
	      var url = [self.awsUrl, self.getPath(), self.request.path].join(""),
	          all_headers = {};
	
	      if (self.request.query_string) {
	        url += self.request.query_string;
	      }
	      extend(all_headers, self.request.not_signed_headers);
	      extend(all_headers, self.request.x_amz_headers);
	
	      xhr.onreadystatechange = function () {
	        if (xhr.readyState === 4) {
	
	          if (self.success_status(xhr)) {
	            if (self.request.response_match &&
	                xhr.response.match(new RegExp(self.request.response_match)) === undefined) {
	              reject('AWS response does not match set pattern: ' + self.request.response_match);
	            } else {
	              resolve();
	            }
	          } else {
	            var reason = xhr.responseText ? getAwsResponse(xhr) : ' ';
	            reason += 'status:' + xhr.status;
	            reject(reason);
	          }
	        }
	      };
	
	      xhr.open(self.request.method, url);
	      xhr.setRequestHeader('Authorization', self.signer.authorizationString());
	
	      for (var key in all_headers) {
	        if (all_headers.hasOwnProperty(key)) {
	          xhr.setRequestHeader(key, all_headers[key]);
	        }
	      }
	
	      self.signer.setHeaders(xhr);
	
	      if (self.request.contentType) {
	        xhr.setRequestHeader('Content-Type', self.request.contentType);
	      }
	
	      if (self.request.md5_digest) {
	        xhr.setRequestHeader('Content-MD5', self.request.md5_digest);
	      }
	      xhr.onerror = function (xhr) {
	        var reason = xhr.responseText ? getAwsResponse(xhr) : 'transport error';
	        reject(reason);
	      };
	
	      if (typeof self.request.onProgress === 'function') {
	        xhr.upload.onprogress = self.request.onProgress;
	      }
	
	      self.getPayload()
	          .then(xhr.send.bind(xhr), reject);
	
	      setTimeout(function () { // We have to delay here or Safari will hang
	        self.started.resolve('request sent ' + self.request.step);
	      }, 20);
	      self.signer.payload = null;
	      self.payloadPromise = undefined;
	    });
	  };
	  //see: http://docs.amazonwebservices.com/AmazonS3/latest/dev/RESTAuthentication.html#ConstructingTheAuthenticationHeader
	  SignedS3AWSRequest.prototype.authorize = function () {
	    this.request.dateString = this.signer.dateString(this.localTimeOffset);
	    this.request.x_amz_headers = extend(this.request.x_amz_headers, {
	      'x-amz-date': this.request.dateString
	    });
	    return this.signer.getPayload()
	        .then(function () {
	          return authorizationMethod(this).authorize();
	        }.bind(this));
	  };
	  SignedS3AWSRequest.prototype.authorizationSuccess = function (authorization) {
	    l.d(this.request.step, 'signature:', authorization);
	    this.request.auth = authorization;
	  };
	  SignedS3AWSRequest.prototype.trySend = function () {
	    var self = this;
	    return this.authorize()
	        .then(
	            function (value) {
	              self.authorizationSuccess(value);
	              if (self.fileUpload.status === ABORTED) { return; }
	              self.sendRequestToAWS().then(self.success.bind(self), self.error.bind(self));
	            },
	            self.error.bind(self));
	  };
	  SignedS3AWSRequest.prototype.send = function () {
	    this.trySend();
	    return this.awsDeferred.promise;
	  };
	
	  function CancelableS3AWSRequest(fileUpload, request) {
	    SignedS3AWSRequest.call(this, fileUpload, request);
	  }
	  CancelableS3AWSRequest.prototype = Object.create(SignedS3AWSRequest.prototype);
	  CancelableS3AWSRequest.prototype.constructor = CancelableS3AWSRequest;
	  CancelableS3AWSRequest.prototype.errorExceptionStatus = function () {
	    return [ABORTED, CANCELED].indexOf(this.fileUpload.status) > -1;
	  };
	
	  function SignedS3AWSRequestWithRetryLimit(fileUpload, request, maxRetries) {
	    if (maxRetries > -1) {
	      this.maxRetries = maxRetries;
	    }
	    SignedS3AWSRequest.call(this, fileUpload, request);
	  }
	  SignedS3AWSRequestWithRetryLimit.prototype = Object.create(CancelableS3AWSRequest.prototype);
	  SignedS3AWSRequestWithRetryLimit.prototype.constructor = SignedS3AWSRequestWithRetryLimit;
	  SignedS3AWSRequestWithRetryLimit.prototype.maxRetries = 1;
	  SignedS3AWSRequestWithRetryLimit.prototype.errorHandler =  function (reason) {
	    if (this.attempts > this.maxRetries) {
	      var msg = ['MaxRetries exceeded. Will re-upload file id ', this.fileUpload.id, ', ', reason].join("");
	      l.w(msg);
	      this.awsDeferred.reject(msg);
	      return true;
	    }
	  };
	  SignedS3AWSRequestWithRetryLimit.prototype.rejectedSuccess = function () {
	    var reason = Array.prototype.slice.call(arguments, 1).join("");
	    this.awsDeferred.reject(reason);
	    return false;
	  };
	
	  // see: http://docs.amazonwebservices.com/AmazonS3/latest/API/mpUploadInitiate.html
	  function InitiateMultipartUpload(fileUpload, awsKey) {
	    var request = {
	      method: 'POST',
	      path: '?uploads',
	      step: 'initiate',
	      x_amz_headers: fileUpload.xAmzHeadersAtInitiate,
	      not_signed_headers: fileUpload.notSignedHeadersAtInitiate,
	      response_match: '<UploadId>(.+)<\/UploadId>'
	    };
	
	    CancelableS3AWSRequest.call(this, fileUpload, request);
	    this.awsKey = awsKey;
	  }
	  InitiateMultipartUpload.prototype = Object.create(CancelableS3AWSRequest.prototype);
	  InitiateMultipartUpload.prototype.constructor = InitiateMultipartUpload;
	  InitiateMultipartUpload.prototype.success = function () {
	    var match = this.currentXhr.response.match(new RegExp(this.request.response_match));
	    this.fileUpload.uploadId = match[1];
	    this.fileUpload.awsKey = this.awsKey;
	    l.d('InitiateMultipartUpload ID is', this.fileUpload.uploadId);
	    this.fileUpload.createUploadFile();
	    this.awsDeferred.resolve(this.currentXhr);
	  };
	
	  //http://docs.amazonwebservices.com/AmazonS3/latest/API/mpUploadComplete.html
	  function CompleteMultipartUpload(fileUpload) {
	    fileUpload.info('will attempt to complete upload');
	    var request = {
	      method: 'POST',
	      contentType: 'application/xml; charset=UTF-8',
	      path: '?uploadId=' + fileUpload.uploadId,
	      x_amz_headers: fileUpload.xAmzHeadersCommon || fileUpload.xAmzHeadersAtComplete,
	      step: 'complete'
	    };
	    CancelableS3AWSRequest.call(this, fileUpload, request);
	  }
	  CompleteMultipartUpload.prototype = Object.create(CancelableS3AWSRequest.prototype);
	  CompleteMultipartUpload.prototype.constructor = CompleteMultipartUpload;
	  CompleteMultipartUpload.prototype.getPayload = function () {
	    return Promise.resolve(this.fileUpload.getCompletedPayload());
	  };
	
	  //http://docs.amazonwebservices.com/AmazonS3/latest/API/mpUploadComplete.html
	  function ReuseS3Object(fileUpload, awsKey) {
	    this.awsKey = awsKey;
	
	    fileUpload.info('will attempt to verify existence of the file');
	
	    var request = {
	      method: 'HEAD',
	      path: '',
	      x_amz_headers: fileUpload.xAmzHeadersCommon,
	      success404: true,
	      step: 'head_object'
	    };
	
	    SignedS3AWSRequestWithRetryLimit.call(this, fileUpload, request);
	  }
	  ReuseS3Object.prototype = Object.create(SignedS3AWSRequestWithRetryLimit.prototype);
	  ReuseS3Object.prototype.constructor = ReuseS3Object;
	  ReuseS3Object.prototype.awsKey = undefined;
	  ReuseS3Object.prototype.success = function () {
	    var eTag = this.currentXhr.getResponseHeader('Etag');
	    if (eTag !== this.fileUpload.eTag &&
	        !this.rejectedSuccess('uploadId ', this.fileUpload.id, ' found on S3 but the Etag doesn\'t match.')) { return; }
	    this.awsDeferred.resolve(this.currentXhr);
	  };
	
	  //http://docs.amazonwebservices.com/AmazonS3/latest/API/mpUploadListParts.html
	  function ResumeInterruptedUpload(fileUpload) {
	    SignedS3AWSRequestWithRetryLimit.call(this, fileUpload);
	    this.updateRequest(this.setupRequest(0));
	  }
	  ResumeInterruptedUpload.prototype = Object.create(SignedS3AWSRequestWithRetryLimit.prototype);
	  ResumeInterruptedUpload.prototype.constructor = ResumeInterruptedUpload;
	  ResumeInterruptedUpload.prototype.awsKey = undefined;
	  ResumeInterruptedUpload.prototype.partNumberMarker = 0;
	  ResumeInterruptedUpload.prototype.setupRequest = function (partNumberMarker) {
	    var msg = ['setupRequest() for uploadId:', this.fileUpload.uploadId, 'for part marker:', partNumberMarker].join(" ");
	    l.d(msg);
	
	    this.fileUpload.info(msg);
	
	    this.awsKey = this.fileUpload.name;
	    this.partNumberMarker = partNumberMarker;
	
	    var request = {
	      method: 'GET',
	      path: ['?uploadId=', this.fileUpload.uploadId].join(""),
	      query_string: "&part-number-marker=" + partNumberMarker,
	      x_amz_headers: this.fileUpload.xAmzHeadersCommon,
	      step: 'get upload parts',
	      success404: true
	    };
	
	    this.request = request;
	    return request;
	  };
	  ResumeInterruptedUpload.prototype.success = function () {
	    if (this.currentXhr.status === 404) {
	      // Success! Upload is no longer recognized, so there is nothing to fetch
	      if (this.rejectedSuccess('uploadId ', this.fileUpload.id, ' not found on S3.')) { this.awsDeferred.resolve(this.currentXhr); }
	      return;
	    }
	
	    var nextPartNumber = this.fileUpload.listPartsSuccess(this, this.currentXhr.responseText);
	    if (nextPartNumber) {
	      var request = this.setupRequest(nextPartNumber); // let's fetch the next set of parts
	      this.updateRequest(request);
	      this.trySend();
	    } else {
	      this.fileUpload.makePartsfromPartsOnS3();
	      this.awsDeferred.resolve(this.currentXhr);
	    }
	  };
	
	  //http://docs.aws.amazon.com/AmazonS3/latest/API/mpUploadUploadPart.html
	  function PutPart(fileUpload, part) {
	    this.part = part;
	
	    this.partNumber = part.partNumber;
	    this.start = (this.partNumber - 1) * fileUpload.con.partSize;
	    this.end = Math.min(this.partNumber * fileUpload.con.partSize, fileUpload.sizeBytes);
	
	    var request = {
	      method: 'PUT',
	      path: '?partNumber=' + this.partNumber + '&uploadId=' + fileUpload.uploadId,
	      step: 'upload #' + this.partNumber,
	      x_amz_headers: fileUpload.xAmzHeadersCommon || fileUpload.xAmzHeadersAtUpload,
	      contentSha256: "UNSIGNED-PAYLOAD",
	      onProgress: this.onProgress.bind(this)
	    };
	
	    SignedS3AWSRequest.call(this, fileUpload, request);
	  }
	  PutPart.prototype = Object.create(SignedS3AWSRequest.prototype);
	  PutPart.prototype.constructor = PutPart;
	  PutPart.prototype.part = 1;
	  PutPart.prototype.payloadPromise = undefined;
	  PutPart.prototype.start = 0;
	  PutPart.prototype.end = 0;
	  PutPart.prototype.partNumber = undefined;
	  PutPart.prototype.getPartMd5Digest = function () {
	    var self = this,
	        part = this.part;
	    return new Promise(function (resolve, reject) {
	      if (self.con.computeContentMd5 && !part.md5_digest) {
	        self.getPayload()
	            .then(function (data) {
	              var md5_digest = self.con.cryptoMd5Method(data);
	              if (self.partNumber === 1 && self.con.computeContentMd5 && typeof self.fileUpload.firstMd5Digest === "undefined") {
	                self.fileUpload.firstMd5Digest = md5_digest;
	                self.fileUpload.updateUploadFile({firstMd5Digest: md5_digest})
	              }
	              resolve(md5_digest);
	            }, reject);
	      } else {
	        resolve(part.md5_digest);
	      }
	    }).then(function (md5_digest) {
	      if (md5_digest) {
	        l.d(self.request.step, 'MD5 digest:', md5_digest);
	        self.request.md5_digest = md5_digest;
	        self.part.md5_digest = md5_digest;
	      }
	    });
	  };
	  PutPart.prototype.sendRequestToAWS = function () {
	    this.stalledInterval = setInterval(this.stalledPartMonitor(), PARTS_MONITOR_INTERVAL_MS);
	    this.stalledPartMonitor();
	    return SignedS3AWSRequest.prototype.sendRequestToAWS.call(this);
	  };
	  PutPart.prototype.send = function () {
	    if (this.part.status !== COMPLETE &&
	        [ABORTED, PAUSED, CANCELED].indexOf(this.fileUpload.status) === -1
	    ) {
	      l.d('uploadPart #', this.partNumber, this.attempts === 1 ? 'submitting' : 'retrying');
	
	      this.part.status = EVAPORATING;
	      this.attempts += 1;
	      this.part.loadedBytesPrevious = null;
	
	      var self = this;
	      return this.getPartMd5Digest()
	          .then(function () {
	            l.d('Sending', self.request.step);
	            SignedS3AWSRequest.prototype.send.call(self);
	          });
	    }
	  };
	  PutPart.prototype.success = function () {
	    clearInterval(this.stalledInterval);
	    var eTag = this.currentXhr.getResponseHeader('ETag');
	    this.currentXhr = null;
	    if (this.fileUpload.partSuccess(eTag, this)) { this.awsDeferred.resolve(this.currentXhr); }
	  };
	  PutPart.prototype.onProgress = function (evt) {
	    if (evt.loaded > 0) {
	      var loadedNow = evt.loaded - this.part.loadedBytes;
	      if (loadedNow) {
	        this.part.loadedBytes = evt.loaded;
	        this.fileUpload.updateLoaded(loadedNow);
	      }
	    }
	  };
	  PutPart.prototype.stalledPartMonitor = function () {
	    var lastLoaded = this.part.loadedBytes;
	    var self = this;
	    return function () {
	      clearInterval(self.stalledInterval);
	      if ([EVAPORATING, ERROR, PAUSING, PAUSED].indexOf(self.fileUpload.status) === -1 &&
	          self.part.status !== ABORTED &&
	          self.part.loadedBytes < this.size) {
	        if (lastLoaded === self.part.loadedBytes) {
	          l.w('Part stalled. Will abort and retry:', self.partNumber, decodeURIComponent(self.fileUpload.name));
	          self.abort();
	          if (!self.errorExceptionStatus()) {
	            self.delaySend();
	          }
	        } else {
	          self.stalledInterval = setInterval(self.stalledPartMonitor(), PARTS_MONITOR_INTERVAL_MS);
	        }
	      }
	    }
	  };
	  PutPart.prototype.resetLoadedBytes = function () {
	    this.fileUpload.updateLoaded(-this.part.loadedBytes);
	    this.part.loadedBytes = 0;
	    this.fileUpload.onProgress();
	  };
	  PutPart.prototype.errorExceptionStatus = function () {
	    return [CANCELED, ABORTED, PAUSED, PAUSING].indexOf(this.fileUpload.status) > -1;
	  };
	  PutPart.prototype.delaySend = function () {
	    var backOffWait = this.backOffWait();
	    this.attempts += 1;
	    setTimeout(this.send.bind(this), backOffWait);
	  };
	  PutPart.prototype.errorHandler = function (reason) {
	    clearInterval(this.stalledInterval);
	    if (reason.match(/status:404/)) {
	      var errMsg = '404 error on part PUT. The part and the file will abort. ' + reason;
	      l.w(errMsg);
	      this.fileUpload.error(errMsg);
	      this.part.status = ABORTED;
	      this.awsDeferred.reject(errMsg);
	      return true;
	    }
	    this.resetLoadedBytes();
	    this.part.status = ERROR;
	
	    if (!this.errorExceptionStatus()) {
	      this.delaySend();
	    }
	    return true;
	  };
	  PutPart.prototype.abort = function () {
	    if (this.currentXhr) {
	      this.currentXhr.abort();
	    }
	    this.resetLoadedBytes();
	    this.attempts = 1;
	  };
	  PutPart.size = 0;
	  PutPart.prototype.streamToArrayBuffer = function (stream) {
	    return new Promise(function (resolve, reject) {
	      // stream is empty or ended
	      if (!stream.readable) { return resolve([]); }
	
	      var arr = new Uint8Array(Math.min(this.con.partSize, this.end - this.start)),
	          i = 0;
	      stream.on('data', onData);
	      stream.on('end', onEnd);
	      stream.on('error', onEnd);
	      stream.on('close', onClose);
	
	      function onData(data) {
	        if (data.byteLength === 1) { return; }
	        arr.set(data, i);
	        i += data.byteLength;
	      }
	
	      function onEnd(err) {
	        if (err) { reject(err); }
	        else { resolve(arr); }
	        cleanup();
	      }
	
	      function onClose() {
	        resolve(arr);
	        cleanup();
	      }
	
	      function cleanup() {
	        arr = null;
	        stream.removeListener('data', onData);
	        stream.removeListener('end', onEnd);
	        stream.removeListener('error', onEnd);
	        stream.removeListener('close', onClose);
	      }
	    }.bind(this));
	  };
	  PutPart.prototype.getPayload = function () {
	    if (typeof this.payloadPromise === 'undefined') {
	      this.payloadPromise = this.con.readableStreams ? this.payloadFromStream() : this.payloadFromBlob();
	    }
	    return this.payloadPromise;
	  };
	  PutPart.prototype.payloadFromStream = function () {
	    var stream = this.con.readableStreamPartMethod(this.fileUpload.file, this.start, this.end - 1);
	    return new Promise(function (resolve, reject) {
	      var streamPromise = this.streamToArrayBuffer(stream);
	      streamPromise.then(function (data) {
	        resolve(data);
	      }.bind(this), reject);
	    }.bind(this));
	  };
	  PutPart.prototype.payloadFromBlob = function () {
	    // browsers' implementation of the Blob.slice function has been renamed a couple of times, and the meaning of the
	    // 2nd parameter changed. For example Gecko went from slice(start,length) -> mozSlice(start, end) -> slice(start, end).
	    // As of 12/12/12, it seems that the unified 'slice' is the best bet, hence it being first in the list. See
	    // https://developer.mozilla.org/en-US/docs/DOM/Blob for more info.
	    var file = this.fileUpload.file,
	        slicerFn = (file.slice ? 'slice' : (file.mozSlice ? 'mozSlice' : 'webkitSlice')),
	        blob = file[slicerFn](this.start, this.end);
	    if (this.con.computeContentMd5) {
	      return new Promise(function (resolve) {
	        var reader = new FileReader();
	        reader.onloadend = function () {
	          var buffer = this.result && typeof this.result.buffer !== 'undefined',
	              result = buffer ? new Uint8Array(this.result.buffer) : this.result;
	          resolve(result);
	        };
	        reader.readAsArrayBuffer(blob);
	      });
	    }
	    return Promise.resolve(blob);
	  };
	  PutPart.prototype.stalledInterval = -1;
	  PutPart.prototype.getStartedPromise = function () {
	    return this.started.promise;
	  };
	
	
	  //http://docs.amazonwebservices.com/AmazonS3/latest/API/mpUploadAbort.html
	  function DeleteMultipartUpload(fileUpload) {
	    fileUpload.info('will attempt to abort the upload');
	
	    fileUpload.abortParts();
	
	    var request = {
	      method: 'DELETE',
	      path: '?uploadId=' + fileUpload.uploadId,
	      x_amz_headers: fileUpload.xAmzHeadersCommon,
	      success404: true,
	      step: 'abort'
	    };
	
	    SignedS3AWSRequest.call(this, fileUpload, request);
	  }
	  DeleteMultipartUpload.prototype = Object.create(SignedS3AWSRequest.prototype);
	  DeleteMultipartUpload.prototype.constructor = DeleteMultipartUpload;
	  DeleteMultipartUpload.prototype.maxRetries = 1;
	  DeleteMultipartUpload.prototype.success = function () {
	    this.fileUpload.setStatus(ABORTED);
	    this.awsDeferred.resolve(this.currentXhr);
	  };
	  DeleteMultipartUpload.prototype.errorHandler =  function (reason) {
	    if (this.attempts > this.maxRetries) {
	      var msg = 'Error aborting upload, Exceeded retries deleting the file upload: ' + reason;
	      l.w(msg);
	      this.fileUpload.error(msg);
	      this.awsDeferred.reject(msg);
	      return true;
	    }
	  };
	
	  function signingVersion(awsRequest, l) {
	    var con = awsRequest.con;
	    function AwsSignature(request) {
	      this.request = request;
	    }
	    AwsSignature.prototype.request = {};
	    AwsSignature.prototype.error = function () {};
	    AwsSignature.prototype.authorizationString = function () {};
	    AwsSignature.prototype.stringToSign = function () {};
	    AwsSignature.prototype.canonicalRequest = function () {};
	    AwsSignature.prototype.setHeaders = function () {};
	    AwsSignature.prototype.datetime = function (timeOffset) {
	      return new Date(new Date().getTime() + timeOffset);
	
	    };
	    AwsSignature.prototype.dateString = function (timeOffset) {
	      return this.datetime(timeOffset).toISOString().slice(0, 19).replace(/-|:/g, '') + "Z";
	    };
	
	    function AwsSignatureV2(request) {
	      AwsSignature.call(this, request);
	    }
	    AwsSignatureV2.prototype = Object.create(AwsSignature.prototype);
	    AwsSignatureV2.prototype.constructor = AwsSignatureV2;
	    AwsSignatureV2.prototype.authorizationString = function () {
	      return ['AWS ', con.aws_key, ':', this.request.auth].join('');
	    };
	    AwsSignatureV2.prototype.stringToSign = function () {
	      var x_amz_headers = '', result, header_key_array = [];
	
	      for (var key in this.request.x_amz_headers) {
	        if (this.request.x_amz_headers.hasOwnProperty(key)) {
	          header_key_array.push(key);
	        }
	      }
	      header_key_array.sort();
	
	      header_key_array.forEach(function (header_key) {
	        x_amz_headers += (header_key + ':' + this.request.x_amz_headers[header_key] + '\n');
	      }.bind(this));
	
	      result = this.request.method + '\n' +
	          (this.request.md5_digest || '') + '\n' +
	          (this.request.contentType || '') + '\n' +
	          '\n' +
	          x_amz_headers +
	          (con.cloudfront ? '/' + con.bucket : '') +
	          awsRequest.getPath() + this.request.path;
	
	      l.d('V2 stringToSign:', result);
	      return result;
	
	    };
	    AwsSignatureV2.prototype.dateString = function (timeOffset) {
	      return this.datetime(timeOffset).toUTCString();
	    };
	    AwsSignatureV2.prototype.getPayload = function () { return Promise.resolve(); };
	
	    function AwsSignatureV4(request) {
	      this._cr = undefined
	      AwsSignature.call(this, request);
	    }
	    AwsSignatureV4.prototype = Object.create(AwsSignature.prototype);
	    AwsSignatureV4.prototype.constructor = AwsSignatureV4;
	    AwsSignatureV4.prototype._cr = undefined;
	    AwsSignatureV4.prototype.payload = null;
	    AwsSignatureV4.prototype.error = function () { this._cr = undefined; };
	    AwsSignatureV4.prototype.getPayload = function () {
	      return awsRequest.getPayload()
	          .then(function (data) {
	            this.payload = data;
	          }.bind(this));
	    };
	    AwsSignatureV4.prototype.authorizationString = function () {
	      var authParts = [];
	
	      var credentials = this.credentialString();
	      var headers = this.canonicalHeaders();
	
	      authParts.push(['AWS4-HMAC-SHA256 Credential=', con.aws_key, '/', credentials].join(''));
	      authParts.push('SignedHeaders=' + headers.signedHeaders);
	      authParts.push('Signature=' + this.request.auth);
	
	      return authParts.join(', ');
	    };
	    AwsSignatureV4.prototype.stringToSign = function () {
	      var signParts = [];
	      signParts.push('AWS4-HMAC-SHA256');
	      signParts.push(this.request.dateString);
	      signParts.push(this.credentialString());
	      signParts.push(con.cryptoHexEncodedHash256(this.canonicalRequest()));
	      var result = signParts.join('\n');
	
	      l.d('V4 stringToSign:', result);
	      return result;
	    };
	    AwsSignatureV4.prototype.credentialString = function () {
	      var credParts = [];
	
	      credParts.push(this.request.dateString.slice(0, 8));
	      credParts.push(con.awsRegion);
	      credParts.push('s3');
	      credParts.push('aws4_request');
	      return credParts.join('/');
	    };
	    AwsSignatureV4.prototype.canonicalQueryString = function () {
	      var qs = awsRequest.request.query_string || '',
	          search = uri([awsRequest.awsUrl, this.request.path, qs].join("")).search,
	          searchParts = search.length ? search.split('&') : [],
	          encoded = [],
	          nameValue,
	          i;
	
	      for (i = 0; i < searchParts.length; i++) {
	        nameValue = searchParts[i].split("=");
	        encoded.push({
	          name: encodeURIComponent(nameValue[0]),
	          value: nameValue.length > 1 ? encodeURIComponent(nameValue[1]) : null
	        })
	      }
	      var sorted = encoded.sort(function (a, b) {
	        if (a.name < b.name) {
	          return -1;
	        } else if (a.name > b.name) {
	          return 1;
	        }
	        return 0;
	      });
	
	      var result = [];
	      for (i = 0; i < sorted.length; i++) {
	        nameValue = sorted[i].value ? [sorted[i].name, sorted[i].value].join("=") : sorted[i].name + '=';
	        result.push(nameValue);
	      }
	
	      return result.join('&');
	    };
	    AwsSignatureV4.prototype.getPayloadSha256Content = function () {
	      var result = this.request.contentSha256 || con.cryptoHexEncodedHash256(this.payload || '');
	      l.d(this.request.step, 'getPayloadSha256Content:', result);
	      return result;
	    };
	    AwsSignatureV4.prototype.canonicalHeaders = function () {
	      var canonicalHeaders = [],
	          keys = [],
	          i;
	
	      function addHeader(name, value) {
	        var key = name.toLowerCase();
	        keys.push(key);
	        canonicalHeaders[key] = value.replace(/\s+/g, ' ');
	      }
	
	      if (this.request.md5_digest) {
	        addHeader("Content-Md5", this.request.md5_digest);
	      }
	
	      addHeader('Host', awsRequest.awsHost);
	
	      if (this.request.contentType) {
	        addHeader('Content-Type', this.request.contentType || '');
	      }
	
	      var amzHeaders = this.request.x_amz_headers || {};
	      for (var key in amzHeaders) {
	        if (amzHeaders.hasOwnProperty(key)) {
	          addHeader(key, amzHeaders[key]);
	        }
	      }
	
	      var sortedKeys = keys.sort(function (a, b) {
	        if (a < b) {
	          return -1;
	        } else if (a > b) {
	          return 1;
	        }
	        return 0;
	      });
	
	      var result = [];
	
	      var unsigned_headers = [],
	          not_signed = this.request.not_signed_headers || [],
	          signed_headers = [];
	      for (i = 0; i < not_signed.length; i++) {
	        unsigned_headers.push(not_signed[i].toLowerCase());
	      }
	
	      for (i = 0; i < sortedKeys.length; i++) {
	        var k = sortedKeys[i];
	        result.push([k, canonicalHeaders[k]].join(":"));
	        if (unsigned_headers.indexOf(k) === -1) {
	          signed_headers.push(k);
	        }
	      }
	
	      return {
	        canonicalHeaders: result.join("\n"),
	        signedHeaders: signed_headers.join(";")
	      };
	    };
	    AwsSignatureV4.prototype.canonicalRequest = function () {
	      if (typeof this._cr !== 'undefined') { return this._cr; }
	      var canonParts = [];
	
	      canonParts.push(this.request.method);
	      canonParts.push(uri([awsRequest.awsUrl, awsRequest.getPath(), this.request.path].join("")).pathname);
	      canonParts.push(this.canonicalQueryString() || '');
	
	      var headers = this.canonicalHeaders();
	      canonParts.push(headers.canonicalHeaders + '\n');
	      canonParts.push(headers.signedHeaders);
	      canonParts.push(this.getPayloadSha256Content());
	
	      this._cr = canonParts.join("\n");
	      l.d(this.request.step, 'V4 CanonicalRequest:', this._cr);
	      return this._cr;
	    };
	    AwsSignatureV4.prototype.setHeaders = function (xhr) {
	      xhr.setRequestHeader("x-amz-content-sha256", this.getPayloadSha256Content());
	    };
	
	    return con.awsSignatureVersion === '4' ? AwsSignatureV4 : AwsSignatureV2;
	  }
	  function authorizationMethod(awsRequest) {
	    var fileUpload = awsRequest.fileUpload,
	        con = fileUpload.con,
	        request = awsRequest.request;
	
	    function AuthorizationMethod() {
	      this.request = request;
	    }
	    AuthorizationMethod.prototype = Object.create(AuthorizationMethod.prototype);
	    AuthorizationMethod.prototype.request = {};
	    AuthorizationMethod.makeSignParamsObject = function (params) {
	      var out = {};
	      for (var param in params) {
	        if (!params.hasOwnProperty(param)) { continue; }
	        if (typeof params[param] === 'function') {
	          out[param] = params[param]();
	        } else {
	          out[param] = params[param];
	        }
	      }
	      return out;
	    };
	    AuthorizationMethod.prototype.authorize = function () {
	      return new Promise(function (resolve, reject) {
	        var xhr = new XMLHttpRequest();
	        awsRequest.currentXhr = xhr;
	
	        var stringToSign = awsRequest.stringToSign(),
	            url = [con.signerUrl, '?to_sign=', stringToSign, '&datetime=', request.dateString];
	        if (con.sendCanonicalRequestToSignerUrl) {
	          url.push('&canonical_request=');
	          url.push(encodeURIComponent(awsRequest.canonicalRequest()));
	        }
	        url = url.join("");
	
	        var signParams = AuthorizationMethod.makeSignParamsObject(fileUpload.signParams);
	        for (var param in signParams) {
	          if (!signParams.hasOwnProperty(param)) { continue; }
	          url += ('&' + encodeURIComponent(param) + '=' + encodeURIComponent(signParams[param]));
	        }
	
	        if (con.xhrWithCredentials) {
	          xhr.withCredentials = true;
	        }
	
	        xhr.onreadystatechange = function () {
	          if (xhr.readyState === 4) {
	            if (xhr.status === 200) {
	              awsRequest.signResponse(xhr.response, stringToSign, request.dateString)
	                  .then(resolve);
	            } else {
	              if ([401, 403].indexOf(xhr.status) > -1) {
	                var reason = "status:" + xhr.status;
	                fileUpload.deferredCompletion.reject('Permission denied ' + reason);
	                return reject(reason);
	              }
	              reject("Signature fetch returned status: " + xhr.status);
	            }
	          }
	        };
	
	        xhr.onerror = function (xhr) {
	          reject('authorizedSend transport error: ' + xhr.responseText);
	        };
	
	        xhr.open('GET', url);
	        var signHeaders = AuthorizationMethod.makeSignParamsObject(con.signHeaders);
	        for (var header in signHeaders) {
	          if (!signHeaders.hasOwnProperty(header)) { continue; }
	          xhr.setRequestHeader(header, signHeaders[header])
	        }
	
	        if (typeof fileUpload.beforeSigner  === 'function') {
	          fileUpload.beforeSigner(xhr, url);
	        }
	        xhr.send();
	      });
	    };
	
	    function AuthorizationCustom() {
	      AuthorizationMethod.call(this);
	    }
	    AuthorizationCustom.prototype = Object.create(AuthorizationMethod.prototype);
	    AuthorizationCustom.prototype.authorize = function () {
	      return con.customAuthMethod(
	          AuthorizationMethod.makeSignParamsObject(fileUpload.signParams),
	          AuthorizationMethod.makeSignParamsObject(con.signHeaders),
	          awsRequest.stringToSign(),
	          request.dateString,
	          awsRequest.canonicalRequest())
	          .catch(function (reason) {
	            fileUpload.deferredCompletion.reject(reason);
	            throw reason;
	          });
	    };
	
	    if (typeof con.customAuthMethod === 'function') {
	      return new AuthorizationCustom()
	    }
	
	    return new AuthorizationMethod();
	  }
	
	  function awsUrl(con) {
	    var url;
	    if (con.aws_url) {
	      url = [con.aws_url];
	    } else {
	      if (con.s3Acceleration) {
	        url = ["https://", con.bucket, ".s3-accelerate"];
	        con.cloudfront = true;
	      } else {
	        url = ["https://", (con.cloudfront ? con.bucket + "." : ""), "s3"];
	        if (con.awsRegion !== "us-east-1") {
	          url.push("-", con.awsRegion);
	        }
	      }
	      url.push(".amazonaws.com");
	    }
	    return url.join("");
	  }
	
	  function s3EncodedObjectName(fileName) {
	    var fileParts = fileName.split('/'),
	        encodedParts = [];
	    fileParts.forEach(function (p) {
	      var buf = [],
	          enc = encodeURIComponent(p);
	      for (var i = 0; i < enc.length; i++) {
	        buf.push(S3_EXTRA_ENCODED_CHARS[enc.charCodeAt(i)] || enc.charAt(i));
	      }
	      encodedParts.push(buf.join(""));
	    });
	    return encodedParts.join('/');
	  }
	
	  function uri(url) {
	    var p,
	        href = url || '/';
	
	    try {
	      p = new URL(href);
	    } catch (e) {
	      p = document.createElement('a');
	      p.href = href;
	    }
	
	    return {
	      protocol: p.protocol, // => "http:"
	      hostname: p.hostname, // => "example.com"
	      // IE omits the leading slash, so add it if it's missing
	      pathname: p.pathname.replace(/(^\/?)/, "/"), // => "/pathname/"
	      port: p.port, // => "3000"
	      search: (p.search[0] === '?') ? p.search.substr(1) : p.search, // => "search=test"
	      hash: p.hash, // => "#hash"
	      host: p.host  // => "example.com:3000"
	    };
	  }
	
	  function dateISOString(date) {
	    // Try to get the modified date as an ISO String, if the date exists
	    return date ? new Date(date).toISOString() : '';
	  }
	
	  function getAwsResponse(xhr) {
	    var code = elementText(xhr.responseText, "Code"),
	        msg = elementText(xhr.responseText, "Message");
	    return code.length ? ['AWS Code: ', code, ', Message:', msg].join("") : '';
	  }
	
	  function elementText(source, element) {
	    var match = source.match(["<", element, ">(.+)</", element, ">"].join(""));
	    return match ? match[1] : '';
	  }
	
	  function defer() {
	    var deferred = {}, promise;
	    promise = new Promise(function(resolve, reject){
	      deferred = {resolve: resolve, reject: reject};
	    });
	    return {
	      resolve: deferred.resolve,
	      reject: deferred.reject,
	      promise: promise
	    }
	  }
	
	  function extend(obj1, obj2, obj3) {
	    function ext(target, source) {
	      if (typeof source !== 'object') { return; }
	      for (var key in source) {
	        if (source.hasOwnProperty(key)) {
	          target[key] = source[key];
	        }
	      }
	    }
	
	    obj1 = obj1 || {};
	    obj2 = obj2 || {};
	    obj3 = obj3 || {};
	    ext(obj2, obj3);
	    ext(obj1, obj2);
	
	    return obj1;
	  }
	
	  function getSavedUploads(purge) {
	    var uploads = JSON.parse(historyCache.getItem('awsUploads') || '{}');
	
	    if (purge) {
	      for (var key in uploads) {
	        if (uploads.hasOwnProperty(key)) {
	          var upload = uploads[key],
	              completedAt = new Date(upload.completedAt || FAR_FUTURE);
	
	          if (completedAt < HOURS_AGO) {
	            // The upload is recent, let's keep it
	            delete uploads[key];
	          }
	        }
	      }
	
	      historyCache.setItem('awsUploads', JSON.stringify(uploads));
	    }
	
	    return uploads;
	  }
	
	  function uploadKey(fileUpload) {
	    // The key tries to give a signature to a file in the absence of its path.
	    // "<filename>-<mimetype>-<modifieddate>-<filesize>"
	    return [
	      fileUpload.file.name,
	      fileUpload.file.type,
	      dateISOString(fileUpload.file.lastModified),
	      fileUpload.sizeBytes
	    ].join("-");
	  }
	
	  function saveUpload(uploadKey, upload) {
	    var uploads = getSavedUploads();
	    uploads[uploadKey] = upload;
	    historyCache.setItem('awsUploads', JSON.stringify(uploads));
	  }
	
	  function removeUpload(uploadKey) {
	    var uploads = getSavedUploads();
	    delete uploads[uploadKey];
	    historyCache.setItem('awsUploads', JSON.stringify(uploads));
	  }
	
	  function removeAtIndex(a, i) {
	    var idx = a.indexOf(i);
	    if (idx > -1) {
	      a.splice(idx, 1);
	      return true;
	    }
	  }
	
	  function readableFileSize(size) {
	    // Adapted from https://github.com/fkjaekel
	    // https://github.com/TTLabs/EvaporateJS/issues/13
	    var units = ['B', 'Kb', 'Mb', 'Gb', 'Tb', 'Pb', 'Eb', 'Zb', 'Yb'],
	        i = 0;
	    while(size >= 1024) {
	      size /= 1024;
	      ++i;
	    }
	    return [size.toFixed(2).replace('.00', ''), units[i]].join(" ");
	  }
	
	  var historyCache;
	  function HistoryCache(mockLocalStorage) {
	    var supported = HistoryCache.supported();
	    this.cacheStore = mockLocalStorage ? {} : (supported ? localStorage : undefined);
	  }
	  HistoryCache.prototype.supported = false;
	  HistoryCache.prototype.cacheStore = undefined;
	  HistoryCache.prototype.getItem = function (key) { if (this.cacheStore) { return this.cacheStore[key]; }};
	  HistoryCache.prototype.setItem = function (key, value) { if (this.cacheStore) { this.cacheStore[key] = value; }};
	  HistoryCache.prototype.removeItem = function (key) { if (this.cacheStore) { return delete this.cacheStore[key] }};
	  HistoryCache.supported = function () {
	    var result = false;
	    if (typeof window !== 'undefined') {
	      if (!('localStorage' in window)) {
	        return result;
	      }
	    } else {
	      return result;
	    }
	
	    // Try to use storage (it might be disabled, e.g. user is in private mode)
	    try {
	      var k = '___test';
	      localStorage[k] = 'OK';
	      var test = localStorage[k];
	      delete localStorage[k];
	      return test === 'OK';
	    } catch (e) {
	      return result;
	    }
	  };
	
	  function noOpLogger() { return {d: function () {}, w: function () {}, e: function () {}}; }
	
	  l = noOpLogger();
	
	  if (typeof module !== 'undefined' && module.exports) {
	    module.exports = Evaporate;
	  } else if (typeof window !== 'undefined') {
	    window.Evaporate = Evaporate;
	  }
	
	}());


/***/ }),
/* 1776 */
/***/ (function(module, exports, __webpack_require__) {

	(function (factory) {
	    if (true) {
	        // Node/CommonJS
	        module.exports = factory();
	    } else if (typeof define === 'function' && define.amd) {
	        // AMD
	        define(factory);
	    } else {
	        // Browser globals (with support for web workers)
	        var glob;
	
	        try {
	            glob = window;
	        } catch (e) {
	            glob = self;
	        }
	
	        glob.SparkMD5 = factory();
	    }
	}(function (undefined) {
	
	    'use strict';
	
	    /*
	     * Fastest md5 implementation around (JKM md5).
	     * Credits: Joseph Myers
	     *
	     * @see http://www.myersdaily.org/joseph/javascript/md5-text.html
	     * @see http://jsperf.com/md5-shootout/7
	     */
	
	    /* this function is much faster,
	      so if possible we use it. Some IEs
	      are the only ones I know of that
	      need the idiotic second function,
	      generated by an if clause.  */
	    var add32 = function (a, b) {
	        return (a + b) & 0xFFFFFFFF;
	    },
	        hex_chr = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'a', 'b', 'c', 'd', 'e', 'f'];
	
	
	    function cmn(q, a, b, x, s, t) {
	        a = add32(add32(a, q), add32(x, t));
	        return add32((a << s) | (a >>> (32 - s)), b);
	    }
	
	    function md5cycle(x, k) {
	        var a = x[0],
	            b = x[1],
	            c = x[2],
	            d = x[3];
	
	        a += (b & c | ~b & d) + k[0] - 680876936 | 0;
	        a  = (a << 7 | a >>> 25) + b | 0;
	        d += (a & b | ~a & c) + k[1] - 389564586 | 0;
	        d  = (d << 12 | d >>> 20) + a | 0;
	        c += (d & a | ~d & b) + k[2] + 606105819 | 0;
	        c  = (c << 17 | c >>> 15) + d | 0;
	        b += (c & d | ~c & a) + k[3] - 1044525330 | 0;
	        b  = (b << 22 | b >>> 10) + c | 0;
	        a += (b & c | ~b & d) + k[4] - 176418897 | 0;
	        a  = (a << 7 | a >>> 25) + b | 0;
	        d += (a & b | ~a & c) + k[5] + 1200080426 | 0;
	        d  = (d << 12 | d >>> 20) + a | 0;
	        c += (d & a | ~d & b) + k[6] - 1473231341 | 0;
	        c  = (c << 17 | c >>> 15) + d | 0;
	        b += (c & d | ~c & a) + k[7] - 45705983 | 0;
	        b  = (b << 22 | b >>> 10) + c | 0;
	        a += (b & c | ~b & d) + k[8] + 1770035416 | 0;
	        a  = (a << 7 | a >>> 25) + b | 0;
	        d += (a & b | ~a & c) + k[9] - 1958414417 | 0;
	        d  = (d << 12 | d >>> 20) + a | 0;
	        c += (d & a | ~d & b) + k[10] - 42063 | 0;
	        c  = (c << 17 | c >>> 15) + d | 0;
	        b += (c & d | ~c & a) + k[11] - 1990404162 | 0;
	        b  = (b << 22 | b >>> 10) + c | 0;
	        a += (b & c | ~b & d) + k[12] + 1804603682 | 0;
	        a  = (a << 7 | a >>> 25) + b | 0;
	        d += (a & b | ~a & c) + k[13] - 40341101 | 0;
	        d  = (d << 12 | d >>> 20) + a | 0;
	        c += (d & a | ~d & b) + k[14] - 1502002290 | 0;
	        c  = (c << 17 | c >>> 15) + d | 0;
	        b += (c & d | ~c & a) + k[15] + 1236535329 | 0;
	        b  = (b << 22 | b >>> 10) + c | 0;
	
	        a += (b & d | c & ~d) + k[1] - 165796510 | 0;
	        a  = (a << 5 | a >>> 27) + b | 0;
	        d += (a & c | b & ~c) + k[6] - 1069501632 | 0;
	        d  = (d << 9 | d >>> 23) + a | 0;
	        c += (d & b | a & ~b) + k[11] + 643717713 | 0;
	        c  = (c << 14 | c >>> 18) + d | 0;
	        b += (c & a | d & ~a) + k[0] - 373897302 | 0;
	        b  = (b << 20 | b >>> 12) + c | 0;
	        a += (b & d | c & ~d) + k[5] - 701558691 | 0;
	        a  = (a << 5 | a >>> 27) + b | 0;
	        d += (a & c | b & ~c) + k[10] + 38016083 | 0;
	        d  = (d << 9 | d >>> 23) + a | 0;
	        c += (d & b | a & ~b) + k[15] - 660478335 | 0;
	        c  = (c << 14 | c >>> 18) + d | 0;
	        b += (c & a | d & ~a) + k[4] - 405537848 | 0;
	        b  = (b << 20 | b >>> 12) + c | 0;
	        a += (b & d | c & ~d) + k[9] + 568446438 | 0;
	        a  = (a << 5 | a >>> 27) + b | 0;
	        d += (a & c | b & ~c) + k[14] - 1019803690 | 0;
	        d  = (d << 9 | d >>> 23) + a | 0;
	        c += (d & b | a & ~b) + k[3] - 187363961 | 0;
	        c  = (c << 14 | c >>> 18) + d | 0;
	        b += (c & a | d & ~a) + k[8] + 1163531501 | 0;
	        b  = (b << 20 | b >>> 12) + c | 0;
	        a += (b & d | c & ~d) + k[13] - 1444681467 | 0;
	        a  = (a << 5 | a >>> 27) + b | 0;
	        d += (a & c | b & ~c) + k[2] - 51403784 | 0;
	        d  = (d << 9 | d >>> 23) + a | 0;
	        c += (d & b | a & ~b) + k[7] + 1735328473 | 0;
	        c  = (c << 14 | c >>> 18) + d | 0;
	        b += (c & a | d & ~a) + k[12] - 1926607734 | 0;
	        b  = (b << 20 | b >>> 12) + c | 0;
	
	        a += (b ^ c ^ d) + k[5] - 378558 | 0;
	        a  = (a << 4 | a >>> 28) + b | 0;
	        d += (a ^ b ^ c) + k[8] - 2022574463 | 0;
	        d  = (d << 11 | d >>> 21) + a | 0;
	        c += (d ^ a ^ b) + k[11] + 1839030562 | 0;
	        c  = (c << 16 | c >>> 16) + d | 0;
	        b += (c ^ d ^ a) + k[14] - 35309556 | 0;
	        b  = (b << 23 | b >>> 9) + c | 0;
	        a += (b ^ c ^ d) + k[1] - 1530992060 | 0;
	        a  = (a << 4 | a >>> 28) + b | 0;
	        d += (a ^ b ^ c) + k[4] + 1272893353 | 0;
	        d  = (d << 11 | d >>> 21) + a | 0;
	        c += (d ^ a ^ b) + k[7] - 155497632 | 0;
	        c  = (c << 16 | c >>> 16) + d | 0;
	        b += (c ^ d ^ a) + k[10] - 1094730640 | 0;
	        b  = (b << 23 | b >>> 9) + c | 0;
	        a += (b ^ c ^ d) + k[13] + 681279174 | 0;
	        a  = (a << 4 | a >>> 28) + b | 0;
	        d += (a ^ b ^ c) + k[0] - 358537222 | 0;
	        d  = (d << 11 | d >>> 21) + a | 0;
	        c += (d ^ a ^ b) + k[3] - 722521979 | 0;
	        c  = (c << 16 | c >>> 16) + d | 0;
	        b += (c ^ d ^ a) + k[6] + 76029189 | 0;
	        b  = (b << 23 | b >>> 9) + c | 0;
	        a += (b ^ c ^ d) + k[9] - 640364487 | 0;
	        a  = (a << 4 | a >>> 28) + b | 0;
	        d += (a ^ b ^ c) + k[12] - 421815835 | 0;
	        d  = (d << 11 | d >>> 21) + a | 0;
	        c += (d ^ a ^ b) + k[15] + 530742520 | 0;
	        c  = (c << 16 | c >>> 16) + d | 0;
	        b += (c ^ d ^ a) + k[2] - 995338651 | 0;
	        b  = (b << 23 | b >>> 9) + c | 0;
	
	        a += (c ^ (b | ~d)) + k[0] - 198630844 | 0;
	        a  = (a << 6 | a >>> 26) + b | 0;
	        d += (b ^ (a | ~c)) + k[7] + 1126891415 | 0;
	        d  = (d << 10 | d >>> 22) + a | 0;
	        c += (a ^ (d | ~b)) + k[14] - 1416354905 | 0;
	        c  = (c << 15 | c >>> 17) + d | 0;
	        b += (d ^ (c | ~a)) + k[5] - 57434055 | 0;
	        b  = (b << 21 |b >>> 11) + c | 0;
	        a += (c ^ (b | ~d)) + k[12] + 1700485571 | 0;
	        a  = (a << 6 | a >>> 26) + b | 0;
	        d += (b ^ (a | ~c)) + k[3] - 1894986606 | 0;
	        d  = (d << 10 | d >>> 22) + a | 0;
	        c += (a ^ (d | ~b)) + k[10] - 1051523 | 0;
	        c  = (c << 15 | c >>> 17) + d | 0;
	        b += (d ^ (c | ~a)) + k[1] - 2054922799 | 0;
	        b  = (b << 21 |b >>> 11) + c | 0;
	        a += (c ^ (b | ~d)) + k[8] + 1873313359 | 0;
	        a  = (a << 6 | a >>> 26) + b | 0;
	        d += (b ^ (a | ~c)) + k[15] - 30611744 | 0;
	        d  = (d << 10 | d >>> 22) + a | 0;
	        c += (a ^ (d | ~b)) + k[6] - 1560198380 | 0;
	        c  = (c << 15 | c >>> 17) + d | 0;
	        b += (d ^ (c | ~a)) + k[13] + 1309151649 | 0;
	        b  = (b << 21 |b >>> 11) + c | 0;
	        a += (c ^ (b | ~d)) + k[4] - 145523070 | 0;
	        a  = (a << 6 | a >>> 26) + b | 0;
	        d += (b ^ (a | ~c)) + k[11] - 1120210379 | 0;
	        d  = (d << 10 | d >>> 22) + a | 0;
	        c += (a ^ (d | ~b)) + k[2] + 718787259 | 0;
	        c  = (c << 15 | c >>> 17) + d | 0;
	        b += (d ^ (c | ~a)) + k[9] - 343485551 | 0;
	        b  = (b << 21 | b >>> 11) + c | 0;
	
	        x[0] = a + x[0] | 0;
	        x[1] = b + x[1] | 0;
	        x[2] = c + x[2] | 0;
	        x[3] = d + x[3] | 0;
	    }
	
	    function md5blk(s) {
	        var md5blks = [],
	            i; /* Andy King said do it this way. */
	
	        for (i = 0; i < 64; i += 4) {
	            md5blks[i >> 2] = s.charCodeAt(i) + (s.charCodeAt(i + 1) << 8) + (s.charCodeAt(i + 2) << 16) + (s.charCodeAt(i + 3) << 24);
	        }
	        return md5blks;
	    }
	
	    function md5blk_array(a) {
	        var md5blks = [],
	            i; /* Andy King said do it this way. */
	
	        for (i = 0; i < 64; i += 4) {
	            md5blks[i >> 2] = a[i] + (a[i + 1] << 8) + (a[i + 2] << 16) + (a[i + 3] << 24);
	        }
	        return md5blks;
	    }
	
	    function md51(s) {
	        var n = s.length,
	            state = [1732584193, -271733879, -1732584194, 271733878],
	            i,
	            length,
	            tail,
	            tmp,
	            lo,
	            hi;
	
	        for (i = 64; i <= n; i += 64) {
	            md5cycle(state, md5blk(s.substring(i - 64, i)));
	        }
	        s = s.substring(i - 64);
	        length = s.length;
	        tail = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
	        for (i = 0; i < length; i += 1) {
	            tail[i >> 2] |= s.charCodeAt(i) << ((i % 4) << 3);
	        }
	        tail[i >> 2] |= 0x80 << ((i % 4) << 3);
	        if (i > 55) {
	            md5cycle(state, tail);
	            for (i = 0; i < 16; i += 1) {
	                tail[i] = 0;
	            }
	        }
	
	        // Beware that the final length might not fit in 32 bits so we take care of that
	        tmp = n * 8;
	        tmp = tmp.toString(16).match(/(.*?)(.{0,8})$/);
	        lo = parseInt(tmp[2], 16);
	        hi = parseInt(tmp[1], 16) || 0;
	
	        tail[14] = lo;
	        tail[15] = hi;
	
	        md5cycle(state, tail);
	        return state;
	    }
	
	    function md51_array(a) {
	        var n = a.length,
	            state = [1732584193, -271733879, -1732584194, 271733878],
	            i,
	            length,
	            tail,
	            tmp,
	            lo,
	            hi;
	
	        for (i = 64; i <= n; i += 64) {
	            md5cycle(state, md5blk_array(a.subarray(i - 64, i)));
	        }
	
	        // Not sure if it is a bug, however IE10 will always produce a sub array of length 1
	        // containing the last element of the parent array if the sub array specified starts
	        // beyond the length of the parent array - weird.
	        // https://connect.microsoft.com/IE/feedback/details/771452/typed-array-subarray-issue
	        a = (i - 64) < n ? a.subarray(i - 64) : new Uint8Array(0);
	
	        length = a.length;
	        tail = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
	        for (i = 0; i < length; i += 1) {
	            tail[i >> 2] |= a[i] << ((i % 4) << 3);
	        }
	
	        tail[i >> 2] |= 0x80 << ((i % 4) << 3);
	        if (i > 55) {
	            md5cycle(state, tail);
	            for (i = 0; i < 16; i += 1) {
	                tail[i] = 0;
	            }
	        }
	
	        // Beware that the final length might not fit in 32 bits so we take care of that
	        tmp = n * 8;
	        tmp = tmp.toString(16).match(/(.*?)(.{0,8})$/);
	        lo = parseInt(tmp[2], 16);
	        hi = parseInt(tmp[1], 16) || 0;
	
	        tail[14] = lo;
	        tail[15] = hi;
	
	        md5cycle(state, tail);
	
	        return state;
	    }
	
	    function rhex(n) {
	        var s = '',
	            j;
	        for (j = 0; j < 4; j += 1) {
	            s += hex_chr[(n >> (j * 8 + 4)) & 0x0F] + hex_chr[(n >> (j * 8)) & 0x0F];
	        }
	        return s;
	    }
	
	    function hex(x) {
	        var i;
	        for (i = 0; i < x.length; i += 1) {
	            x[i] = rhex(x[i]);
	        }
	        return x.join('');
	    }
	
	    // In some cases the fast add32 function cannot be used..
	    if (hex(md51('hello')) !== '5d41402abc4b2a76b9719d911017c592') {
	        add32 = function (x, y) {
	            var lsw = (x & 0xFFFF) + (y & 0xFFFF),
	                msw = (x >> 16) + (y >> 16) + (lsw >> 16);
	            return (msw << 16) | (lsw & 0xFFFF);
	        };
	    }
	
	    // ---------------------------------------------------
	
	    /**
	     * ArrayBuffer slice polyfill.
	     *
	     * @see https://github.com/ttaubert/node-arraybuffer-slice
	     */
	
	    if (typeof ArrayBuffer !== 'undefined' && !ArrayBuffer.prototype.slice) {
	        (function () {
	            function clamp(val, length) {
	                val = (val | 0) || 0;
	
	                if (val < 0) {
	                    return Math.max(val + length, 0);
	                }
	
	                return Math.min(val, length);
	            }
	
	            ArrayBuffer.prototype.slice = function (from, to) {
	                var length = this.byteLength,
	                    begin = clamp(from, length),
	                    end = length,
	                    num,
	                    target,
	                    targetArray,
	                    sourceArray;
	
	                if (to !== undefined) {
	                    end = clamp(to, length);
	                }
	
	                if (begin > end) {
	                    return new ArrayBuffer(0);
	                }
	
	                num = end - begin;
	                target = new ArrayBuffer(num);
	                targetArray = new Uint8Array(target);
	
	                sourceArray = new Uint8Array(this, begin, num);
	                targetArray.set(sourceArray);
	
	                return target;
	            };
	        })();
	    }
	
	    // ---------------------------------------------------
	
	    /**
	     * Helpers.
	     */
	
	    function toUtf8(str) {
	        if (/[\u0080-\uFFFF]/.test(str)) {
	            str = unescape(encodeURIComponent(str));
	        }
	
	        return str;
	    }
	
	    function utf8Str2ArrayBuffer(str, returnUInt8Array) {
	        var length = str.length,
	           buff = new ArrayBuffer(length),
	           arr = new Uint8Array(buff),
	           i;
	
	        for (i = 0; i < length; i += 1) {
	            arr[i] = str.charCodeAt(i);
	        }
	
	        return returnUInt8Array ? arr : buff;
	    }
	
	    function arrayBuffer2Utf8Str(buff) {
	        return String.fromCharCode.apply(null, new Uint8Array(buff));
	    }
	
	    function concatenateArrayBuffers(first, second, returnUInt8Array) {
	        var result = new Uint8Array(first.byteLength + second.byteLength);
	
	        result.set(new Uint8Array(first));
	        result.set(new Uint8Array(second), first.byteLength);
	
	        return returnUInt8Array ? result : result.buffer;
	    }
	
	    function hexToBinaryString(hex) {
	        var bytes = [],
	            length = hex.length,
	            x;
	
	        for (x = 0; x < length - 1; x += 2) {
	            bytes.push(parseInt(hex.substr(x, 2), 16));
	        }
	
	        return String.fromCharCode.apply(String, bytes);
	    }
	
	    // ---------------------------------------------------
	
	    /**
	     * SparkMD5 OOP implementation.
	     *
	     * Use this class to perform an incremental md5, otherwise use the
	     * static methods instead.
	     */
	
	    function SparkMD5() {
	        // call reset to init the instance
	        this.reset();
	    }
	
	    /**
	     * Appends a string.
	     * A conversion will be applied if an utf8 string is detected.
	     *
	     * @param {String} str The string to be appended
	     *
	     * @return {SparkMD5} The instance itself
	     */
	    SparkMD5.prototype.append = function (str) {
	        // Converts the string to utf8 bytes if necessary
	        // Then append as binary
	        this.appendBinary(toUtf8(str));
	
	        return this;
	    };
	
	    /**
	     * Appends a binary string.
	     *
	     * @param {String} contents The binary string to be appended
	     *
	     * @return {SparkMD5} The instance itself
	     */
	    SparkMD5.prototype.appendBinary = function (contents) {
	        this._buff += contents;
	        this._length += contents.length;
	
	        var length = this._buff.length,
	            i;
	
	        for (i = 64; i <= length; i += 64) {
	            md5cycle(this._hash, md5blk(this._buff.substring(i - 64, i)));
	        }
	
	        this._buff = this._buff.substring(i - 64);
	
	        return this;
	    };
	
	    /**
	     * Finishes the incremental computation, reseting the internal state and
	     * returning the result.
	     *
	     * @param {Boolean} raw True to get the raw string, false to get the hex string
	     *
	     * @return {String} The result
	     */
	    SparkMD5.prototype.end = function (raw) {
	        var buff = this._buff,
	            length = buff.length,
	            i,
	            tail = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
	            ret;
	
	        for (i = 0; i < length; i += 1) {
	            tail[i >> 2] |= buff.charCodeAt(i) << ((i % 4) << 3);
	        }
	
	        this._finish(tail, length);
	        ret = hex(this._hash);
	
	        if (raw) {
	            ret = hexToBinaryString(ret);
	        }
	
	        this.reset();
	
	        return ret;
	    };
	
	    /**
	     * Resets the internal state of the computation.
	     *
	     * @return {SparkMD5} The instance itself
	     */
	    SparkMD5.prototype.reset = function () {
	        this._buff = '';
	        this._length = 0;
	        this._hash = [1732584193, -271733879, -1732584194, 271733878];
	
	        return this;
	    };
	
	    /**
	     * Gets the internal state of the computation.
	     *
	     * @return {Object} The state
	     */
	    SparkMD5.prototype.getState = function () {
	        return {
	            buff: this._buff,
	            length: this._length,
	            hash: this._hash.slice()
	        };
	    };
	
	    /**
	     * Gets the internal state of the computation.
	     *
	     * @param {Object} state The state
	     *
	     * @return {SparkMD5} The instance itself
	     */
	    SparkMD5.prototype.setState = function (state) {
	        this._buff = state.buff;
	        this._length = state.length;
	        this._hash = state.hash;
	
	        return this;
	    };
	
	    /**
	     * Releases memory used by the incremental buffer and other additional
	     * resources. If you plan to use the instance again, use reset instead.
	     */
	    SparkMD5.prototype.destroy = function () {
	        delete this._hash;
	        delete this._buff;
	        delete this._length;
	    };
	
	    /**
	     * Finish the final calculation based on the tail.
	     *
	     * @param {Array}  tail   The tail (will be modified)
	     * @param {Number} length The length of the remaining buffer
	     */
	    SparkMD5.prototype._finish = function (tail, length) {
	        var i = length,
	            tmp,
	            lo,
	            hi;
	
	        tail[i >> 2] |= 0x80 << ((i % 4) << 3);
	        if (i > 55) {
	            md5cycle(this._hash, tail);
	            for (i = 0; i < 16; i += 1) {
	                tail[i] = 0;
	            }
	        }
	
	        // Do the final computation based on the tail and length
	        // Beware that the final length may not fit in 32 bits so we take care of that
	        tmp = this._length * 8;
	        tmp = tmp.toString(16).match(/(.*?)(.{0,8})$/);
	        lo = parseInt(tmp[2], 16);
	        hi = parseInt(tmp[1], 16) || 0;
	
	        tail[14] = lo;
	        tail[15] = hi;
	        md5cycle(this._hash, tail);
	    };
	
	    /**
	     * Performs the md5 hash on a string.
	     * A conversion will be applied if utf8 string is detected.
	     *
	     * @param {String}  str The string
	     * @param {Boolean} [raw] True to get the raw string, false to get the hex string
	     *
	     * @return {String} The result
	     */
	    SparkMD5.hash = function (str, raw) {
	        // Converts the string to utf8 bytes if necessary
	        // Then compute it using the binary function
	        return SparkMD5.hashBinary(toUtf8(str), raw);
	    };
	
	    /**
	     * Performs the md5 hash on a binary string.
	     *
	     * @param {String}  content The binary string
	     * @param {Boolean} [raw]     True to get the raw string, false to get the hex string
	     *
	     * @return {String} The result
	     */
	    SparkMD5.hashBinary = function (content, raw) {
	        var hash = md51(content),
	            ret = hex(hash);
	
	        return raw ? hexToBinaryString(ret) : ret;
	    };
	
	    // ---------------------------------------------------
	
	    /**
	     * SparkMD5 OOP implementation for array buffers.
	     *
	     * Use this class to perform an incremental md5 ONLY for array buffers.
	     */
	    SparkMD5.ArrayBuffer = function () {
	        // call reset to init the instance
	        this.reset();
	    };
	
	    /**
	     * Appends an array buffer.
	     *
	     * @param {ArrayBuffer} arr The array to be appended
	     *
	     * @return {SparkMD5.ArrayBuffer} The instance itself
	     */
	    SparkMD5.ArrayBuffer.prototype.append = function (arr) {
	        var buff = concatenateArrayBuffers(this._buff.buffer, arr, true),
	            length = buff.length,
	            i;
	
	        this._length += arr.byteLength;
	
	        for (i = 64; i <= length; i += 64) {
	            md5cycle(this._hash, md5blk_array(buff.subarray(i - 64, i)));
	        }
	
	        this._buff = (i - 64) < length ? new Uint8Array(buff.buffer.slice(i - 64)) : new Uint8Array(0);
	
	        return this;
	    };
	
	    /**
	     * Finishes the incremental computation, reseting the internal state and
	     * returning the result.
	     *
	     * @param {Boolean} raw True to get the raw string, false to get the hex string
	     *
	     * @return {String} The result
	     */
	    SparkMD5.ArrayBuffer.prototype.end = function (raw) {
	        var buff = this._buff,
	            length = buff.length,
	            tail = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
	            i,
	            ret;
	
	        for (i = 0; i < length; i += 1) {
	            tail[i >> 2] |= buff[i] << ((i % 4) << 3);
	        }
	
	        this._finish(tail, length);
	        ret = hex(this._hash);
	
	        if (raw) {
	            ret = hexToBinaryString(ret);
	        }
	
	        this.reset();
	
	        return ret;
	    };
	
	    /**
	     * Resets the internal state of the computation.
	     *
	     * @return {SparkMD5.ArrayBuffer} The instance itself
	     */
	    SparkMD5.ArrayBuffer.prototype.reset = function () {
	        this._buff = new Uint8Array(0);
	        this._length = 0;
	        this._hash = [1732584193, -271733879, -1732584194, 271733878];
	
	        return this;
	    };
	
	    /**
	     * Gets the internal state of the computation.
	     *
	     * @return {Object} The state
	     */
	    SparkMD5.ArrayBuffer.prototype.getState = function () {
	        var state = SparkMD5.prototype.getState.call(this);
	
	        // Convert buffer to a string
	        state.buff = arrayBuffer2Utf8Str(state.buff);
	
	        return state;
	    };
	
	    /**
	     * Gets the internal state of the computation.
	     *
	     * @param {Object} state The state
	     *
	     * @return {SparkMD5.ArrayBuffer} The instance itself
	     */
	    SparkMD5.ArrayBuffer.prototype.setState = function (state) {
	        // Convert string to buffer
	        state.buff = utf8Str2ArrayBuffer(state.buff, true);
	
	        return SparkMD5.prototype.setState.call(this, state);
	    };
	
	    SparkMD5.ArrayBuffer.prototype.destroy = SparkMD5.prototype.destroy;
	
	    SparkMD5.ArrayBuffer.prototype._finish = SparkMD5.prototype._finish;
	
	    /**
	     * Performs the md5 hash on an array buffer.
	     *
	     * @param {ArrayBuffer} arr The array buffer
	     * @param {Boolean}     [raw] True to get the raw string, false to get the hex one
	     *
	     * @return {String} The result
	     */
	    SparkMD5.ArrayBuffer.hash = function (arr, raw) {
	        var hash = md51_array(new Uint8Array(arr)),
	            ret = hex(hash);
	
	        return raw ? hexToBinaryString(ret) : ret;
	    };
	
	    return SparkMD5;
	}));


/***/ }),
/* 1777 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(process, global) {/**
	 * [js-sha256]{@link https://github.com/emn178/js-sha256}
	 *
	 * @version 0.9.0
	 * @author Chen, Yi-Cyuan [emn178@gmail.com]
	 * @copyright Chen, Yi-Cyuan 2014-2017
	 * @license MIT
	 */
	/*jslint bitwise: true */
	(function () {
	  'use strict';
	
	  var ERROR = 'input is invalid type';
	  var WINDOW = typeof window === 'object';
	  var root = WINDOW ? window : {};
	  if (root.JS_SHA256_NO_WINDOW) {
	    WINDOW = false;
	  }
	  var WEB_WORKER = !WINDOW && typeof self === 'object';
	  var NODE_JS = !root.JS_SHA256_NO_NODE_JS && typeof process === 'object' && process.versions && process.versions.node;
	  if (NODE_JS) {
	    root = global;
	  } else if (WEB_WORKER) {
	    root = self;
	  }
	  var COMMON_JS = !root.JS_SHA256_NO_COMMON_JS && typeof module === 'object' && module.exports;
	  var AMD = "function" === 'function' && __webpack_require__(1778);
	  var ARRAY_BUFFER = !root.JS_SHA256_NO_ARRAY_BUFFER && typeof ArrayBuffer !== 'undefined';
	  var HEX_CHARS = '0123456789abcdef'.split('');
	  var EXTRA = [-2147483648, 8388608, 32768, 128];
	  var SHIFT = [24, 16, 8, 0];
	  var K = [
	    0x428a2f98, 0x71374491, 0xb5c0fbcf, 0xe9b5dba5, 0x3956c25b, 0x59f111f1, 0x923f82a4, 0xab1c5ed5,
	    0xd807aa98, 0x12835b01, 0x243185be, 0x550c7dc3, 0x72be5d74, 0x80deb1fe, 0x9bdc06a7, 0xc19bf174,
	    0xe49b69c1, 0xefbe4786, 0x0fc19dc6, 0x240ca1cc, 0x2de92c6f, 0x4a7484aa, 0x5cb0a9dc, 0x76f988da,
	    0x983e5152, 0xa831c66d, 0xb00327c8, 0xbf597fc7, 0xc6e00bf3, 0xd5a79147, 0x06ca6351, 0x14292967,
	    0x27b70a85, 0x2e1b2138, 0x4d2c6dfc, 0x53380d13, 0x650a7354, 0x766a0abb, 0x81c2c92e, 0x92722c85,
	    0xa2bfe8a1, 0xa81a664b, 0xc24b8b70, 0xc76c51a3, 0xd192e819, 0xd6990624, 0xf40e3585, 0x106aa070,
	    0x19a4c116, 0x1e376c08, 0x2748774c, 0x34b0bcb5, 0x391c0cb3, 0x4ed8aa4a, 0x5b9cca4f, 0x682e6ff3,
	    0x748f82ee, 0x78a5636f, 0x84c87814, 0x8cc70208, 0x90befffa, 0xa4506ceb, 0xbef9a3f7, 0xc67178f2
	  ];
	  var OUTPUT_TYPES = ['hex', 'array', 'digest', 'arrayBuffer'];
	
	  var blocks = [];
	
	  if (root.JS_SHA256_NO_NODE_JS || !Array.isArray) {
	    Array.isArray = function (obj) {
	      return Object.prototype.toString.call(obj) === '[object Array]';
	    };
	  }
	
	  if (ARRAY_BUFFER && (root.JS_SHA256_NO_ARRAY_BUFFER_IS_VIEW || !ArrayBuffer.isView)) {
	    ArrayBuffer.isView = function (obj) {
	      return typeof obj === 'object' && obj.buffer && obj.buffer.constructor === ArrayBuffer;
	    };
	  }
	
	  var createOutputMethod = function (outputType, is224) {
	    return function (message) {
	      return new Sha256(is224, true).update(message)[outputType]();
	    };
	  };
	
	  var createMethod = function (is224) {
	    var method = createOutputMethod('hex', is224);
	    if (NODE_JS) {
	      method = nodeWrap(method, is224);
	    }
	    method.create = function () {
	      return new Sha256(is224);
	    };
	    method.update = function (message) {
	      return method.create().update(message);
	    };
	    for (var i = 0; i < OUTPUT_TYPES.length; ++i) {
	      var type = OUTPUT_TYPES[i];
	      method[type] = createOutputMethod(type, is224);
	    }
	    return method;
	  };
	
	  var nodeWrap = function (method, is224) {
	    var crypto = eval("require('crypto')");
	    var Buffer = eval("require('buffer').Buffer");
	    var algorithm = is224 ? 'sha224' : 'sha256';
	    var nodeMethod = function (message) {
	      if (typeof message === 'string') {
	        return crypto.createHash(algorithm).update(message, 'utf8').digest('hex');
	      } else {
	        if (message === null || message === undefined) {
	          throw new Error(ERROR);
	        } else if (message.constructor === ArrayBuffer) {
	          message = new Uint8Array(message);
	        }
	      }
	      if (Array.isArray(message) || ArrayBuffer.isView(message) ||
	        message.constructor === Buffer) {
	        return crypto.createHash(algorithm).update(new Buffer(message)).digest('hex');
	      } else {
	        return method(message);
	      }
	    };
	    return nodeMethod;
	  };
	
	  var createHmacOutputMethod = function (outputType, is224) {
	    return function (key, message) {
	      return new HmacSha256(key, is224, true).update(message)[outputType]();
	    };
	  };
	
	  var createHmacMethod = function (is224) {
	    var method = createHmacOutputMethod('hex', is224);
	    method.create = function (key) {
	      return new HmacSha256(key, is224);
	    };
	    method.update = function (key, message) {
	      return method.create(key).update(message);
	    };
	    for (var i = 0; i < OUTPUT_TYPES.length; ++i) {
	      var type = OUTPUT_TYPES[i];
	      method[type] = createHmacOutputMethod(type, is224);
	    }
	    return method;
	  };
	
	  function Sha256(is224, sharedMemory) {
	    if (sharedMemory) {
	      blocks[0] = blocks[16] = blocks[1] = blocks[2] = blocks[3] =
	        blocks[4] = blocks[5] = blocks[6] = blocks[7] =
	        blocks[8] = blocks[9] = blocks[10] = blocks[11] =
	        blocks[12] = blocks[13] = blocks[14] = blocks[15] = 0;
	      this.blocks = blocks;
	    } else {
	      this.blocks = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
	    }
	
	    if (is224) {
	      this.h0 = 0xc1059ed8;
	      this.h1 = 0x367cd507;
	      this.h2 = 0x3070dd17;
	      this.h3 = 0xf70e5939;
	      this.h4 = 0xffc00b31;
	      this.h5 = 0x68581511;
	      this.h6 = 0x64f98fa7;
	      this.h7 = 0xbefa4fa4;
	    } else { // 256
	      this.h0 = 0x6a09e667;
	      this.h1 = 0xbb67ae85;
	      this.h2 = 0x3c6ef372;
	      this.h3 = 0xa54ff53a;
	      this.h4 = 0x510e527f;
	      this.h5 = 0x9b05688c;
	      this.h6 = 0x1f83d9ab;
	      this.h7 = 0x5be0cd19;
	    }
	
	    this.block = this.start = this.bytes = this.hBytes = 0;
	    this.finalized = this.hashed = false;
	    this.first = true;
	    this.is224 = is224;
	  }
	
	  Sha256.prototype.update = function (message) {
	    if (this.finalized) {
	      return;
	    }
	    var notString, type = typeof message;
	    if (type !== 'string') {
	      if (type === 'object') {
	        if (message === null) {
	          throw new Error(ERROR);
	        } else if (ARRAY_BUFFER && message.constructor === ArrayBuffer) {
	          message = new Uint8Array(message);
	        } else if (!Array.isArray(message)) {
	          if (!ARRAY_BUFFER || !ArrayBuffer.isView(message)) {
	            throw new Error(ERROR);
	          }
	        }
	      } else {
	        throw new Error(ERROR);
	      }
	      notString = true;
	    }
	    var code, index = 0, i, length = message.length, blocks = this.blocks;
	
	    while (index < length) {
	      if (this.hashed) {
	        this.hashed = false;
	        blocks[0] = this.block;
	        blocks[16] = blocks[1] = blocks[2] = blocks[3] =
	          blocks[4] = blocks[5] = blocks[6] = blocks[7] =
	          blocks[8] = blocks[9] = blocks[10] = blocks[11] =
	          blocks[12] = blocks[13] = blocks[14] = blocks[15] = 0;
	      }
	
	      if (notString) {
	        for (i = this.start; index < length && i < 64; ++index) {
	          blocks[i >> 2] |= message[index] << SHIFT[i++ & 3];
	        }
	      } else {
	        for (i = this.start; index < length && i < 64; ++index) {
	          code = message.charCodeAt(index);
	          if (code < 0x80) {
	            blocks[i >> 2] |= code << SHIFT[i++ & 3];
	          } else if (code < 0x800) {
	            blocks[i >> 2] |= (0xc0 | (code >> 6)) << SHIFT[i++ & 3];
	            blocks[i >> 2] |= (0x80 | (code & 0x3f)) << SHIFT[i++ & 3];
	          } else if (code < 0xd800 || code >= 0xe000) {
	            blocks[i >> 2] |= (0xe0 | (code >> 12)) << SHIFT[i++ & 3];
	            blocks[i >> 2] |= (0x80 | ((code >> 6) & 0x3f)) << SHIFT[i++ & 3];
	            blocks[i >> 2] |= (0x80 | (code & 0x3f)) << SHIFT[i++ & 3];
	          } else {
	            code = 0x10000 + (((code & 0x3ff) << 10) | (message.charCodeAt(++index) & 0x3ff));
	            blocks[i >> 2] |= (0xf0 | (code >> 18)) << SHIFT[i++ & 3];
	            blocks[i >> 2] |= (0x80 | ((code >> 12) & 0x3f)) << SHIFT[i++ & 3];
	            blocks[i >> 2] |= (0x80 | ((code >> 6) & 0x3f)) << SHIFT[i++ & 3];
	            blocks[i >> 2] |= (0x80 | (code & 0x3f)) << SHIFT[i++ & 3];
	          }
	        }
	      }
	
	      this.lastByteIndex = i;
	      this.bytes += i - this.start;
	      if (i >= 64) {
	        this.block = blocks[16];
	        this.start = i - 64;
	        this.hash();
	        this.hashed = true;
	      } else {
	        this.start = i;
	      }
	    }
	    if (this.bytes > 4294967295) {
	      this.hBytes += this.bytes / 4294967296 << 0;
	      this.bytes = this.bytes % 4294967296;
	    }
	    return this;
	  };
	
	  Sha256.prototype.finalize = function () {
	    if (this.finalized) {
	      return;
	    }
	    this.finalized = true;
	    var blocks = this.blocks, i = this.lastByteIndex;
	    blocks[16] = this.block;
	    blocks[i >> 2] |= EXTRA[i & 3];
	    this.block = blocks[16];
	    if (i >= 56) {
	      if (!this.hashed) {
	        this.hash();
	      }
	      blocks[0] = this.block;
	      blocks[16] = blocks[1] = blocks[2] = blocks[3] =
	        blocks[4] = blocks[5] = blocks[6] = blocks[7] =
	        blocks[8] = blocks[9] = blocks[10] = blocks[11] =
	        blocks[12] = blocks[13] = blocks[14] = blocks[15] = 0;
	    }
	    blocks[14] = this.hBytes << 3 | this.bytes >>> 29;
	    blocks[15] = this.bytes << 3;
	    this.hash();
	  };
	
	  Sha256.prototype.hash = function () {
	    var a = this.h0, b = this.h1, c = this.h2, d = this.h3, e = this.h4, f = this.h5, g = this.h6,
	      h = this.h7, blocks = this.blocks, j, s0, s1, maj, t1, t2, ch, ab, da, cd, bc;
	
	    for (j = 16; j < 64; ++j) {
	      // rightrotate
	      t1 = blocks[j - 15];
	      s0 = ((t1 >>> 7) | (t1 << 25)) ^ ((t1 >>> 18) | (t1 << 14)) ^ (t1 >>> 3);
	      t1 = blocks[j - 2];
	      s1 = ((t1 >>> 17) | (t1 << 15)) ^ ((t1 >>> 19) | (t1 << 13)) ^ (t1 >>> 10);
	      blocks[j] = blocks[j - 16] + s0 + blocks[j - 7] + s1 << 0;
	    }
	
	    bc = b & c;
	    for (j = 0; j < 64; j += 4) {
	      if (this.first) {
	        if (this.is224) {
	          ab = 300032;
	          t1 = blocks[0] - 1413257819;
	          h = t1 - 150054599 << 0;
	          d = t1 + 24177077 << 0;
	        } else {
	          ab = 704751109;
	          t1 = blocks[0] - 210244248;
	          h = t1 - 1521486534 << 0;
	          d = t1 + 143694565 << 0;
	        }
	        this.first = false;
	      } else {
	        s0 = ((a >>> 2) | (a << 30)) ^ ((a >>> 13) | (a << 19)) ^ ((a >>> 22) | (a << 10));
	        s1 = ((e >>> 6) | (e << 26)) ^ ((e >>> 11) | (e << 21)) ^ ((e >>> 25) | (e << 7));
	        ab = a & b;
	        maj = ab ^ (a & c) ^ bc;
	        ch = (e & f) ^ (~e & g);
	        t1 = h + s1 + ch + K[j] + blocks[j];
	        t2 = s0 + maj;
	        h = d + t1 << 0;
	        d = t1 + t2 << 0;
	      }
	      s0 = ((d >>> 2) | (d << 30)) ^ ((d >>> 13) | (d << 19)) ^ ((d >>> 22) | (d << 10));
	      s1 = ((h >>> 6) | (h << 26)) ^ ((h >>> 11) | (h << 21)) ^ ((h >>> 25) | (h << 7));
	      da = d & a;
	      maj = da ^ (d & b) ^ ab;
	      ch = (h & e) ^ (~h & f);
	      t1 = g + s1 + ch + K[j + 1] + blocks[j + 1];
	      t2 = s0 + maj;
	      g = c + t1 << 0;
	      c = t1 + t2 << 0;
	      s0 = ((c >>> 2) | (c << 30)) ^ ((c >>> 13) | (c << 19)) ^ ((c >>> 22) | (c << 10));
	      s1 = ((g >>> 6) | (g << 26)) ^ ((g >>> 11) | (g << 21)) ^ ((g >>> 25) | (g << 7));
	      cd = c & d;
	      maj = cd ^ (c & a) ^ da;
	      ch = (g & h) ^ (~g & e);
	      t1 = f + s1 + ch + K[j + 2] + blocks[j + 2];
	      t2 = s0 + maj;
	      f = b + t1 << 0;
	      b = t1 + t2 << 0;
	      s0 = ((b >>> 2) | (b << 30)) ^ ((b >>> 13) | (b << 19)) ^ ((b >>> 22) | (b << 10));
	      s1 = ((f >>> 6) | (f << 26)) ^ ((f >>> 11) | (f << 21)) ^ ((f >>> 25) | (f << 7));
	      bc = b & c;
	      maj = bc ^ (b & d) ^ cd;
	      ch = (f & g) ^ (~f & h);
	      t1 = e + s1 + ch + K[j + 3] + blocks[j + 3];
	      t2 = s0 + maj;
	      e = a + t1 << 0;
	      a = t1 + t2 << 0;
	    }
	
	    this.h0 = this.h0 + a << 0;
	    this.h1 = this.h1 + b << 0;
	    this.h2 = this.h2 + c << 0;
	    this.h3 = this.h3 + d << 0;
	    this.h4 = this.h4 + e << 0;
	    this.h5 = this.h5 + f << 0;
	    this.h6 = this.h6 + g << 0;
	    this.h7 = this.h7 + h << 0;
	  };
	
	  Sha256.prototype.hex = function () {
	    this.finalize();
	
	    var h0 = this.h0, h1 = this.h1, h2 = this.h2, h3 = this.h3, h4 = this.h4, h5 = this.h5,
	      h6 = this.h6, h7 = this.h7;
	
	    var hex = HEX_CHARS[(h0 >> 28) & 0x0F] + HEX_CHARS[(h0 >> 24) & 0x0F] +
	      HEX_CHARS[(h0 >> 20) & 0x0F] + HEX_CHARS[(h0 >> 16) & 0x0F] +
	      HEX_CHARS[(h0 >> 12) & 0x0F] + HEX_CHARS[(h0 >> 8) & 0x0F] +
	      HEX_CHARS[(h0 >> 4) & 0x0F] + HEX_CHARS[h0 & 0x0F] +
	      HEX_CHARS[(h1 >> 28) & 0x0F] + HEX_CHARS[(h1 >> 24) & 0x0F] +
	      HEX_CHARS[(h1 >> 20) & 0x0F] + HEX_CHARS[(h1 >> 16) & 0x0F] +
	      HEX_CHARS[(h1 >> 12) & 0x0F] + HEX_CHARS[(h1 >> 8) & 0x0F] +
	      HEX_CHARS[(h1 >> 4) & 0x0F] + HEX_CHARS[h1 & 0x0F] +
	      HEX_CHARS[(h2 >> 28) & 0x0F] + HEX_CHARS[(h2 >> 24) & 0x0F] +
	      HEX_CHARS[(h2 >> 20) & 0x0F] + HEX_CHARS[(h2 >> 16) & 0x0F] +
	      HEX_CHARS[(h2 >> 12) & 0x0F] + HEX_CHARS[(h2 >> 8) & 0x0F] +
	      HEX_CHARS[(h2 >> 4) & 0x0F] + HEX_CHARS[h2 & 0x0F] +
	      HEX_CHARS[(h3 >> 28) & 0x0F] + HEX_CHARS[(h3 >> 24) & 0x0F] +
	      HEX_CHARS[(h3 >> 20) & 0x0F] + HEX_CHARS[(h3 >> 16) & 0x0F] +
	      HEX_CHARS[(h3 >> 12) & 0x0F] + HEX_CHARS[(h3 >> 8) & 0x0F] +
	      HEX_CHARS[(h3 >> 4) & 0x0F] + HEX_CHARS[h3 & 0x0F] +
	      HEX_CHARS[(h4 >> 28) & 0x0F] + HEX_CHARS[(h4 >> 24) & 0x0F] +
	      HEX_CHARS[(h4 >> 20) & 0x0F] + HEX_CHARS[(h4 >> 16) & 0x0F] +
	      HEX_CHARS[(h4 >> 12) & 0x0F] + HEX_CHARS[(h4 >> 8) & 0x0F] +
	      HEX_CHARS[(h4 >> 4) & 0x0F] + HEX_CHARS[h4 & 0x0F] +
	      HEX_CHARS[(h5 >> 28) & 0x0F] + HEX_CHARS[(h5 >> 24) & 0x0F] +
	      HEX_CHARS[(h5 >> 20) & 0x0F] + HEX_CHARS[(h5 >> 16) & 0x0F] +
	      HEX_CHARS[(h5 >> 12) & 0x0F] + HEX_CHARS[(h5 >> 8) & 0x0F] +
	      HEX_CHARS[(h5 >> 4) & 0x0F] + HEX_CHARS[h5 & 0x0F] +
	      HEX_CHARS[(h6 >> 28) & 0x0F] + HEX_CHARS[(h6 >> 24) & 0x0F] +
	      HEX_CHARS[(h6 >> 20) & 0x0F] + HEX_CHARS[(h6 >> 16) & 0x0F] +
	      HEX_CHARS[(h6 >> 12) & 0x0F] + HEX_CHARS[(h6 >> 8) & 0x0F] +
	      HEX_CHARS[(h6 >> 4) & 0x0F] + HEX_CHARS[h6 & 0x0F];
	    if (!this.is224) {
	      hex += HEX_CHARS[(h7 >> 28) & 0x0F] + HEX_CHARS[(h7 >> 24) & 0x0F] +
	        HEX_CHARS[(h7 >> 20) & 0x0F] + HEX_CHARS[(h7 >> 16) & 0x0F] +
	        HEX_CHARS[(h7 >> 12) & 0x0F] + HEX_CHARS[(h7 >> 8) & 0x0F] +
	        HEX_CHARS[(h7 >> 4) & 0x0F] + HEX_CHARS[h7 & 0x0F];
	    }
	    return hex;
	  };
	
	  Sha256.prototype.toString = Sha256.prototype.hex;
	
	  Sha256.prototype.digest = function () {
	    this.finalize();
	
	    var h0 = this.h0, h1 = this.h1, h2 = this.h2, h3 = this.h3, h4 = this.h4, h5 = this.h5,
	      h6 = this.h6, h7 = this.h7;
	
	    var arr = [
	      (h0 >> 24) & 0xFF, (h0 >> 16) & 0xFF, (h0 >> 8) & 0xFF, h0 & 0xFF,
	      (h1 >> 24) & 0xFF, (h1 >> 16) & 0xFF, (h1 >> 8) & 0xFF, h1 & 0xFF,
	      (h2 >> 24) & 0xFF, (h2 >> 16) & 0xFF, (h2 >> 8) & 0xFF, h2 & 0xFF,
	      (h3 >> 24) & 0xFF, (h3 >> 16) & 0xFF, (h3 >> 8) & 0xFF, h3 & 0xFF,
	      (h4 >> 24) & 0xFF, (h4 >> 16) & 0xFF, (h4 >> 8) & 0xFF, h4 & 0xFF,
	      (h5 >> 24) & 0xFF, (h5 >> 16) & 0xFF, (h5 >> 8) & 0xFF, h5 & 0xFF,
	      (h6 >> 24) & 0xFF, (h6 >> 16) & 0xFF, (h6 >> 8) & 0xFF, h6 & 0xFF
	    ];
	    if (!this.is224) {
	      arr.push((h7 >> 24) & 0xFF, (h7 >> 16) & 0xFF, (h7 >> 8) & 0xFF, h7 & 0xFF);
	    }
	    return arr;
	  };
	
	  Sha256.prototype.array = Sha256.prototype.digest;
	
	  Sha256.prototype.arrayBuffer = function () {
	    this.finalize();
	
	    var buffer = new ArrayBuffer(this.is224 ? 28 : 32);
	    var dataView = new DataView(buffer);
	    dataView.setUint32(0, this.h0);
	    dataView.setUint32(4, this.h1);
	    dataView.setUint32(8, this.h2);
	    dataView.setUint32(12, this.h3);
	    dataView.setUint32(16, this.h4);
	    dataView.setUint32(20, this.h5);
	    dataView.setUint32(24, this.h6);
	    if (!this.is224) {
	      dataView.setUint32(28, this.h7);
	    }
	    return buffer;
	  };
	
	  function HmacSha256(key, is224, sharedMemory) {
	    var i, type = typeof key;
	    if (type === 'string') {
	      var bytes = [], length = key.length, index = 0, code;
	      for (i = 0; i < length; ++i) {
	        code = key.charCodeAt(i);
	        if (code < 0x80) {
	          bytes[index++] = code;
	        } else if (code < 0x800) {
	          bytes[index++] = (0xc0 | (code >> 6));
	          bytes[index++] = (0x80 | (code & 0x3f));
	        } else if (code < 0xd800 || code >= 0xe000) {
	          bytes[index++] = (0xe0 | (code >> 12));
	          bytes[index++] = (0x80 | ((code >> 6) & 0x3f));
	          bytes[index++] = (0x80 | (code & 0x3f));
	        } else {
	          code = 0x10000 + (((code & 0x3ff) << 10) | (key.charCodeAt(++i) & 0x3ff));
	          bytes[index++] = (0xf0 | (code >> 18));
	          bytes[index++] = (0x80 | ((code >> 12) & 0x3f));
	          bytes[index++] = (0x80 | ((code >> 6) & 0x3f));
	          bytes[index++] = (0x80 | (code & 0x3f));
	        }
	      }
	      key = bytes;
	    } else {
	      if (type === 'object') {
	        if (key === null) {
	          throw new Error(ERROR);
	        } else if (ARRAY_BUFFER && key.constructor === ArrayBuffer) {
	          key = new Uint8Array(key);
	        } else if (!Array.isArray(key)) {
	          if (!ARRAY_BUFFER || !ArrayBuffer.isView(key)) {
	            throw new Error(ERROR);
	          }
	        }
	      } else {
	        throw new Error(ERROR);
	      }
	    }
	
	    if (key.length > 64) {
	      key = (new Sha256(is224, true)).update(key).array();
	    }
	
	    var oKeyPad = [], iKeyPad = [];
	    for (i = 0; i < 64; ++i) {
	      var b = key[i] || 0;
	      oKeyPad[i] = 0x5c ^ b;
	      iKeyPad[i] = 0x36 ^ b;
	    }
	
	    Sha256.call(this, is224, sharedMemory);
	
	    this.update(iKeyPad);
	    this.oKeyPad = oKeyPad;
	    this.inner = true;
	    this.sharedMemory = sharedMemory;
	  }
	  HmacSha256.prototype = new Sha256();
	
	  HmacSha256.prototype.finalize = function () {
	    Sha256.prototype.finalize.call(this);
	    if (this.inner) {
	      this.inner = false;
	      var innerHash = this.array();
	      Sha256.call(this, this.is224, this.sharedMemory);
	      this.update(this.oKeyPad);
	      this.update(innerHash);
	      Sha256.prototype.finalize.call(this);
	    }
	  };
	
	  var exports = createMethod();
	  exports.sha256 = exports;
	  exports.sha224 = createMethod(true);
	  exports.sha256.hmac = createHmacMethod();
	  exports.sha224.hmac = createHmacMethod(true);
	
	  if (COMMON_JS) {
	    module.exports = exports;
	  } else {
	    root.sha256 = exports.sha256;
	    root.sha224 = exports.sha224;
	    if (AMD) {
	      !(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
	        return exports;
	      }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    }
	  }
	})();
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(294), (function() { return this; }())))

/***/ }),
/* 1778 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(__webpack_amd_options__) {module.exports = __webpack_amd_options__;
	
	/* WEBPACK VAR INJECTION */}.call(exports, {}))

/***/ }),
/* 1779 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _values = __webpack_require__(1214);
	
	var _values2 = _interopRequireDefault(_values);
	
	var _pickBy = __webpack_require__(1163);
	
	var _pickBy2 = _interopRequireDefault(_pickBy);
	
	var _materialUi = __webpack_require__(576);
	
	var _juration = __webpack_require__(1772);
	
	var _juration2 = _interopRequireDefault(_juration);
	
	var _connectToStores = __webpack_require__(1226);
	
	var _connectToStores2 = _interopRequireDefault(_connectToStores);
	
	var _VirtualContentStore = __webpack_require__(1768);
	
	var _VirtualContentStore2 = _interopRequireDefault(_VirtualContentStore);
	
	var _VirtualContentActions = __webpack_require__(1767);
	
	var _VirtualContentActions2 = _interopRequireDefault(_VirtualContentActions);
	
	var _reactDropzone = __webpack_require__(1780);
	
	var _reactDropzone2 = _interopRequireDefault(_reactDropzone);
	
	var _config = __webpack_require__(1173);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _UserStore = __webpack_require__(974);
	
	var _UserStore2 = _interopRequireDefault(_UserStore);
	
	var _UserUtil = __webpack_require__(1159);
	
	var _UserUtil2 = _interopRequireDefault(_UserUtil);
	
	var _util = __webpack_require__(1183);
	
	var _workingIndicator = __webpack_require__(1664);
	
	var _workingIndicator2 = _interopRequireDefault(_workingIndicator);
	
	var _linkLike = __webpack_require__(973);
	
	var _linkLike2 = _interopRequireDefault(_linkLike);
	
	var _label = __webpack_require__(1682);
	
	var _label2 = _interopRequireDefault(_label);
	
	var _filmTable = __webpack_require__(1763);
	
	var _tableRefreshIndicator = __webpack_require__(1686);
	
	var _tableRefreshIndicator2 = _interopRequireDefault(_tableRefreshIndicator);
	
	var _virtualContentPreview = __webpack_require__(1781);
	
	var _virtualContentPreview2 = _interopRequireDefault(_virtualContentPreview);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var VirtualContent = function (_React$Component) {
	  _inherits(VirtualContent, _React$Component);
	
	  function VirtualContent(props) {
	    _classCallCheck(this, VirtualContent);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(VirtualContent).call(this, props));
	
	    _this.state = {
	      virtualContent: null,
	      label: "",
	      caption_tracks: [],
	      dirty: false,
	      showPreview: false
	    };
	
	    _this._refresh = _this._refresh.bind(_this);
	    return _this;
	  }
	
	  _createClass(VirtualContent, [{
	    key: "save",
	    value: function save() {
	      _VirtualContentActions2.default.edit(this.props.params.virtualContentId, {
	        label: this.state.label,
	        caption_tracks: this.state.caption_tracks.filter(function (c) {
	          return !!c.url;
	        })
	      });
	    }
	  }, {
	    key: "getStyles",
	    value: function getStyles() {
	      return {
	        container: {
	          maxWidth: 500,
	          margin: "5% auto",
	          fontSize: "11pt",
	          padding: "5px 20px 20px",
	          borderRadius: "1em",
	          boxShadow: "0 0 20px 2px rgba(0,0,0,0.2)"
	        },
	        actions: {
	          marginTop: "1em"
	        }
	      };
	    }
	  }, {
	    key: "componentWillMount",
	    value: function componentWillMount() {
	      _VirtualContentActions2.default.fetchOne.defer(this.props.params.virtualContentId);
	      this.componentWillReceiveProps(this.props);
	    }
	  }, {
	    key: "_refresh",
	    value: function _refresh() {
	      _VirtualContentActions2.default.fetchOne(this.props.params.virtualContentId);
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(newProps) {
	      var virtualContent = newProps.virtualContents[newProps.params.virtualContentId];
	      if (virtualContent && (!this.state.virtualContent || this.props.isEditing && newProps.isEditing || this.props.isFetching && !newProps.isFetching || virtualContent._is_limited_access && !this.state.virtualContent._is_limited_access || this.state.virtualContent.status !== virtualContent.status)) {
	        this.setState({
	          virtualContent: virtualContent,
	          label: virtualContent.label,
	          caption_tracks: virtualContent.caption_tracks,
	          dirty: false
	        });
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var styles = this.getStyles();
	      var virtualContent = this.state.virtualContent;
	
	
	      if (!virtualContent) {
	        return _react2.default.createElement(_workingIndicator2.default, { fullPage: true });
	      }
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        this.props.isEditing && _react2.default.createElement(_workingIndicator2.default, { fullPage: true, overlay: true }),
	        this.state.showPreview ? _react2.default.createElement(_virtualContentPreview2.default, {
	          virtualContentId: virtualContent.id,
	          onRequestClose: function onRequestClose() {
	            return _this2.setState({ showPreview: false });
	          }
	        }) : null,
	        _react2.default.createElement(
	          "div",
	          { style: styles.container },
	          _react2.default.createElement(_tableRefreshIndicator2.default, {
	            isRefreshing: this.props.isFetching,
	            onRefresh: this._refresh,
	            style: { marginTop: "2.5%" }
	          }),
	          _react2.default.createElement(_materialUi.TextField, {
	            floatingLabelText: "Content asset label",
	            floatingLabelFixed: true,
	            value: this.state.label,
	            disabled: virtualContent._is_limited_access,
	            onChange: function onChange(e) {
	              return _this2.setState({ label: e.target.value, dirty: true });
	            }
	          }),
	          _react2.default.createElement(
	            _label2.default,
	            { style: { marginTop: "0.5em", marginBottom: "0em" } },
	            "Content asset status"
	          ),
	          _react2.default.createElement(_filmTable.Status, { virtual_content: virtualContent }),
	          virtualContent._fetched_at ? _react2.default.createElement(
	            "div",
	            {
	              style: {
	                fontWeight: "bold",
	                color: "rgba(0,0,0,0.4)",
	                display: "block",
	                fontSize: "0.7em",
	                marginTop: "0.1em",
	                lineHeight: "1.1em"
	              }
	            },
	            "Last checked",
	            " ",
	            new Date(virtualContent._fetched_at).toLocaleTimeString()
	          ) : null,
	          virtualContent.duration ? _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(
	              _label2.default,
	              { style: { marginBottom: "0em" } },
	              "Content asset duration"
	            ),
	            _react2.default.createElement(
	              "div",
	              null,
	              _juration2.default.stringify(virtualContent.duration / 1000)
	            )
	          ) : null,
	          _react2.default.createElement(
	            _label2.default,
	            { style: { marginBottom: "0em" } },
	            "Content asset preview"
	          ),
	          _react2.default.createElement(
	            "div",
	            { style: { color: "rgba(0,0,0,0.6)", fontStyle: "italic" } },
	            virtualContent._is_limited_access ? "Only available to original uploader" : virtualContent.status === "ready" ? this.state.dirty ? "Save changes to preview" : _react2.default.createElement(
	              _linkLike2.default,
	              {
	                onTouchTap: function onTouchTap() {
	                  return _this2.setState({ showPreview: true });
	                },
	                style: { fontStyle: "normal" }
	              },
	              "View preview"
	            ) : virtualContent.status.indexOf("pending_") === 0 ? "Available when transcoding completed" : "Not available"
	          ),
	          _react2.default.createElement(
	            _label2.default,
	            { style: { marginBottom: "0em" } },
	            "Original file size"
	          ),
	          _react2.default.createElement(
	            "div",
	            null,
	            (0, _util.formatBytes)(virtualContent.file_size || 0)
	          ),
	          _react2.default.createElement(
	            _label2.default,
	            { style: { marginBottom: "0em" } },
	            "Subtitles"
	          ),
	          _react2.default.createElement(
	            "div",
	            null,
	            this.state.caption_tracks.map(function (t, i) {
	              return _react2.default.createElement(
	                "div",
	                {
	                  key: i + "-" + t.url,
	                  style: {
	                    display: "flex",
	                    alignItems: "center",
	                    marginTop: -5,
	                    marginBottom: 5
	                  }
	                },
	                _react2.default.createElement(_materialUi.TextField, {
	                  placeholder: "Subtitle track title",
	                  style: { width: 200 },
	                  value: _this2.state.caption_tracks[i].title,
	                  onChange: function onChange(e) {
	                    _this2.state.caption_tracks[i].title = e.target.value;
	                    _this2.setState({
	                      caption_tracks: _this2.state.caption_tracks,
	                      dirty: true
	                    });
	                  }
	                }),
	                _react2.default.createElement(
	                  "div",
	                  { style: { marginLeft: 10 } },
	                  t.url ? _react2.default.createElement(
	                    "div",
	                    null,
	                    _react2.default.createElement(_materialUi.RaisedButton, { disabled: true, label: "Uploaded" })
	                  ) : t.uploading ? _react2.default.createElement(
	                    "div",
	                    null,
	                    _react2.default.createElement(_materialUi.RaisedButton, { disabled: true, label: "Uploading" })
	                  ) : _react2.default.createElement(
	                    _reactDropzone2.default,
	                    {
	                      style: {},
	                      onDrop: function onDrop(files) {
	                        if (files.length) {
	                          _this2.state.caption_tracks[i].uploading = true;
	                          _this2.setState({
	                            caption_tracks: _this2.state.caption_tracks
	                          });
	
	                          _UserUtil2.default.uploadFile(_UserStore2.default.getState().apiKey, virtualContent.id + "-captions-" + Date.now(), files[0], { transform: "captions" }).then(function (data) {
	                            _this2.state.caption_tracks[i].url = data.url;
	                            _this2.setState({
	                              caption_tracks: _this2.state.caption_tracks,
	                              dirty: true
	                            });
	                          }).catch(function (e) {
	                            _this2.state.caption_tracks[i].url = undefined;
	                            _this2.setState({
	                              caption_tracks: _this2.state.caption_tracks
	                            }, function () {
	                              window.alert("Upload failed: " + e.message);
	                            });
	                          });
	                        }
	                      }
	                    },
	                    _react2.default.createElement(_materialUi.RaisedButton, { primary: true, label: "Add file" })
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { style: { marginLeft: 10 } },
	                  _react2.default.createElement(_materialUi.FlatButton, {
	                    onClick: function onClick() {
	                      _this2.state.caption_tracks.splice(i, 1);
	                      _this2.setState({
	                        caption_tracks: _this2.state.caption_tracks,
	                        dirty: true
	                      });
	                    },
	                    label: _react2.default.createElement(
	                      "span",
	                      { style: { fontSize: "1.5em" } },
	                      "\xD7"
	                    )
	                  })
	                )
	              );
	            }),
	            _react2.default.createElement(
	              "div",
	              null,
	              this.state.caption_tracks.length === 0 ? _react2.default.createElement(
	                "span",
	                null,
	                "None \xB7 "
	              ) : null,
	              _react2.default.createElement(
	                _linkLike2.default,
	                {
	                  onTouchTap: function onTouchTap() {
	                    _this2.setState({
	                      caption_tracks: _this2.state.caption_tracks.concat([{ title: "English" }])
	                    });
	                  }
	                },
	                "Upload ",
	                this.state.caption_tracks.length ? "additional" : "",
	                " ",
	                "subtitles"
	              ),
	              _react2.default.createElement(
	                "div",
	                { style: { fontSize: "0.8em" } },
	                ".srt, .vtt files supported"
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { style: styles.actions },
	            _react2.default.createElement(_materialUi.RaisedButton, {
	              label: "Save content asset",
	              onClick: function onClick() {
	                return _this2.save();
	              },
	              disabled: !this.state.dirty,
	              primary: true
	            })
	          ),
	          !virtualContent._is_limited_access && _react2.default.createElement(
	            "div",
	            { style: styles.actions },
	            _react2.default.createElement(
	              _linkLike2.default,
	              {
	                onTouchTap: function onTouchTap() {
	                  return Intercom("showNewMessage", "Please destroy the content asset " + virtualContent.label + " (ref # " + virtualContent.id + ").");
	                }
	              },
	              "Destroy content asset"
	            )
	          )
	        )
	      );
	    }
	  }], [{
	    key: "getStores",
	    value: function getStores() {
	      return [_VirtualContentStore2.default];
	    }
	  }, {
	    key: "getPropsFromStores",
	    value: function getPropsFromStores() {
	      return _VirtualContentStore2.default.getState();
	    }
	  }, {
	    key: "contextTypes",
	    get: function get() {
	      return {
	        router: _react2.default.PropTypes.object
	      };
	    }
	  }]);
	
	  return VirtualContent;
	}(_react2.default.Component);
	
	exports.default = (0, _connectToStores2.default)(VirtualContent);
	module.exports = exports["default"];

/***/ }),
/* 1780 */
/***/ (function(module, exports, __webpack_require__) {

	(function webpackUniversalModuleDefinition(root, factory) {
		if(true)
			module.exports = factory(__webpack_require__(300), __webpack_require__(956));
		else if(typeof define === 'function' && define.amd)
			define(["react", "prop-types"], factory);
		else if(typeof exports === 'object')
			exports["Dropzone"] = factory(require("react"), require("prop-types"));
		else
			root["Dropzone"] = factory(root["react"], root["prop-types"]);
	})(this, function(__WEBPACK_EXTERNAL_MODULE_2__, __WEBPACK_EXTERNAL_MODULE_3__) {
	return /******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	/******/
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	/******/
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	/******/
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	/******/
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	/******/
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	/******/
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	/******/
	/******/
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	/******/
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	/******/
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	/******/
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ([
	/* 0 */
	/***/ function(module, exports, __webpack_require__) {
	
		/* WEBPACK VAR INJECTION */(function(process) {'use strict';
		
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		
		var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
		
		var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
		
		var _react = __webpack_require__(2);
		
		var _react2 = _interopRequireDefault(_react);
		
		var _propTypes = __webpack_require__(3);
		
		var _propTypes2 = _interopRequireDefault(_propTypes);
		
		var _attrAccept = __webpack_require__(4);
		
		var _attrAccept2 = _interopRequireDefault(_attrAccept);
		
		var _getDataTransferItems = __webpack_require__(5);
		
		var _getDataTransferItems2 = _interopRequireDefault(_getDataTransferItems);
		
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
		
		function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
		
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
		
		function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
		
		function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint prefer-template: 0 */
		
		
		var supportMultiple = typeof document !== 'undefined' && document && document.createElement ? 'multiple' in document.createElement('input') : true;
		
		var Dropzone = function (_React$Component) {
		  _inherits(Dropzone, _React$Component);
		
		  _createClass(Dropzone, null, [{
		    key: 'onDocumentDragOver',
		    value: function onDocumentDragOver(e) {
		      // allow the entire document to be a drag target
		      e.preventDefault();
		    }
		  }]);
		
		  function Dropzone(props, context) {
		    _classCallCheck(this, Dropzone);
		
		    var _this = _possibleConstructorReturn(this, (Dropzone.__proto__ || Object.getPrototypeOf(Dropzone)).call(this, props, context));
		
		    _this.renderChildren = function (children) {
		      if (typeof children === 'function') {
		        return children(_this.state);
		      }
		      return children;
		    };
		
		    _this.onClick = _this.onClick.bind(_this);
		    _this.onDocumentDrop = _this.onDocumentDrop.bind(_this);
		    _this.onDragStart = _this.onDragStart.bind(_this);
		    _this.onDragEnter = _this.onDragEnter.bind(_this);
		    _this.onDragLeave = _this.onDragLeave.bind(_this);
		    _this.onDragOver = _this.onDragOver.bind(_this);
		    _this.onDrop = _this.onDrop.bind(_this);
		    _this.onFileDialogCancel = _this.onFileDialogCancel.bind(_this);
		    _this.fileAccepted = _this.fileAccepted.bind(_this);
		    _this.setRef = _this.setRef.bind(_this);
		    _this.isFileDialogActive = false;
		    _this.state = {
		      isDragActive: false,
		      acceptedFiles: [],
		      rejectedFiles: []
		    };
		    return _this;
		  }
		
		  _createClass(Dropzone, [{
		    key: 'componentDidMount',
		    value: function componentDidMount() {
		      var preventDropOnDocument = this.props.preventDropOnDocument;
		
		      this.dragTargets = [];
		
		      if (preventDropOnDocument) {
		        document.addEventListener('dragover', Dropzone.onDocumentDragOver, false);
		        document.addEventListener('drop', this.onDocumentDrop, false);
		      }
		      // Tried implementing addEventListener, but didn't work out
		      document.body.onfocus = this.onFileDialogCancel;
		    }
		  }, {
		    key: 'componentWillUnmount',
		    value: function componentWillUnmount() {
		      var preventDropOnDocument = this.props.preventDropOnDocument;
		
		      if (preventDropOnDocument) {
		        document.removeEventListener('dragover', Dropzone.onDocumentDragOver);
		        document.removeEventListener('drop', this.onDocumentDrop);
		      }
		      // Can be replaced with removeEventListener, if addEventListener works
		      document.body.onfocus = null;
		    }
		  }, {
		    key: 'onDocumentDrop',
		    value: function onDocumentDrop(e) {
		      if (this.node.contains(e.target)) {
		        // if we intercepted an event for our instance, let it propagate down to the instance's onDrop handler
		        return;
		      }
		      e.preventDefault();
		      this.dragTargets = [];
		    }
		  }, {
		    key: 'onDragStart',
		    value: function onDragStart(e) {
		      if (this.props.onDragStart) {
		        this.props.onDragStart.call(this, e);
		      }
		    }
		  }, {
		    key: 'onDragEnter',
		    value: function onDragEnter(e) {
		      e.preventDefault();
		
		      // Count the dropzone and any children that are entered.
		      if (this.dragTargets.indexOf(e.target) === -1) {
		        this.dragTargets.push(e.target);
		      }
		
		      var allFilesAccepted = this.allFilesAccepted((0, _getDataTransferItems2.default)(e, this.props.multiple));
		
		      this.setState({
		        isDragActive: allFilesAccepted,
		        isDragReject: !allFilesAccepted
		      });
		
		      if (this.props.onDragEnter) {
		        this.props.onDragEnter.call(this, e);
		      }
		    }
		  }, {
		    key: 'onDragOver',
		    value: function onDragOver(e) {
		      // eslint-disable-line class-methods-use-this
		      e.preventDefault();
		      e.stopPropagation();
		      try {
		        e.dataTransfer.dropEffect = 'copy'; // eslint-disable-line no-param-reassign
		      } catch (err) {
		        // continue regardless of error
		      }
		
		      if (this.props.onDragOver) {
		        this.props.onDragOver.call(this, e);
		      }
		      return false;
		    }
		  }, {
		    key: 'onDragLeave',
		    value: function onDragLeave(e) {
		      var _this2 = this;
		
		      e.preventDefault();
		
		      // Only deactivate once the dropzone and all children have been left.
		      this.dragTargets = this.dragTargets.filter(function (el) {
		        return el !== e.target && _this2.node.contains(el);
		      });
		      if (this.dragTargets.length > 0) {
		        return;
		      }
		
		      this.setState({
		        isDragActive: false,
		        isDragReject: false
		      });
		
		      if (this.props.onDragLeave) {
		        this.props.onDragLeave.call(this, e);
		      }
		    }
		  }, {
		    key: 'onDrop',
		    value: function onDrop(e) {
		      var _this3 = this;
		
		      var _props = this.props,
		          onDrop = _props.onDrop,
		          onDropAccepted = _props.onDropAccepted,
		          onDropRejected = _props.onDropRejected,
		          multiple = _props.multiple,
		          disablePreview = _props.disablePreview;
		
		      var fileList = (0, _getDataTransferItems2.default)(e, multiple);
		      var acceptedFiles = [];
		      var rejectedFiles = [];
		
		      // Stop default browser behavior
		      e.preventDefault();
		
		      // Reset the counter along with the drag on a drop.
		      this.dragTargets = [];
		      this.isFileDialogActive = false;
		
		      fileList.forEach(function (file) {
		        if (!disablePreview) {
		          try {
		            file.preview = window.URL.createObjectURL(file); // eslint-disable-line no-param-reassign
		          } catch (err) {
		            if (process.env.NODE_ENV !== 'production') {
		              console.error('Failed to generate preview for file', file, err); // eslint-disable-line no-console
		            }
		          }
		        }
		
		        if (_this3.fileAccepted(file) && _this3.fileMatchSize(file)) {
		          acceptedFiles.push(file);
		        } else {
		          rejectedFiles.push(file);
		        }
		      });
		
		      if (onDrop) {
		        onDrop.call(this, acceptedFiles, rejectedFiles, e);
		      }
		
		      if (rejectedFiles.length > 0 && onDropRejected) {
		        onDropRejected.call(this, rejectedFiles, e);
		      }
		
		      if (acceptedFiles.length > 0 && onDropAccepted) {
		        onDropAccepted.call(this, acceptedFiles, e);
		      }
		
		      // Reset drag state
		      this.setState({
		        isDragActive: false,
		        isDragReject: false,
		        acceptedFiles: acceptedFiles,
		        rejectedFiles: rejectedFiles
		      });
		    }
		  }, {
		    key: 'onClick',
		    value: function onClick(e) {
		      var _props2 = this.props,
		          onClick = _props2.onClick,
		          disableClick = _props2.disableClick;
		
		      if (!disableClick) {
		        e.stopPropagation();
		        this.open();
		        if (onClick) {
		          onClick.call(this, e);
		        }
		      }
		    }
		  }, {
		    key: 'onFileDialogCancel',
		    value: function onFileDialogCancel() {
		      // timeout will not recognize context of this method
		      var onFileDialogCancel = this.props.onFileDialogCancel;
		      var fileInputEl = this.fileInputEl;
		      var isFileDialogActive = this.isFileDialogActive;
		      // execute the timeout only if the onFileDialogCancel is defined and FileDialog
		      // is opened in the browser
		
		      if (onFileDialogCancel && isFileDialogActive) {
		        setTimeout(function () {
		          // Returns an object as FileList
		          var FileList = fileInputEl.files;
		          if (!FileList.length) {
		            isFileDialogActive = false;
		            onFileDialogCancel();
		          }
		        }, 300);
		      }
		    }
		  }, {
		    key: 'setRef',
		    value: function setRef(ref) {
		      this.node = ref;
		    }
		  }, {
		    key: 'fileAccepted',
		    value: function fileAccepted(file) {
		      // Firefox versions prior to 53 return a bogus MIME type for every file drag, so dragovers with
		      // that MIME type will always be accepted
		      return file.type === 'application/x-moz-file' || (0, _attrAccept2.default)(file, this.props.accept);
		    }
		  }, {
		    key: 'fileMatchSize',
		    value: function fileMatchSize(file) {
		      return file.size <= this.props.maxSize && file.size >= this.props.minSize;
		    }
		  }, {
		    key: 'allFilesAccepted',
		    value: function allFilesAccepted(files) {
		      return files.every(this.fileAccepted);
		    }
		  }, {
		    key: 'open',
		    value: function open() {
		      this.isFileDialogActive = true;
		      this.fileInputEl.value = null;
		      this.fileInputEl.click();
		    }
		  }, {
		    key: 'render',
		    value: function render() {
		      var _this4 = this;
		
		      var _props3 = this.props,
		          accept = _props3.accept,
		          activeClassName = _props3.activeClassName,
		          inputProps = _props3.inputProps,
		          multiple = _props3.multiple,
		          name = _props3.name,
		          rejectClassName = _props3.rejectClassName,
		          children = _props3.children,
		          rest = _objectWithoutProperties(_props3, ['accept', 'activeClassName', 'inputProps', 'multiple', 'name', 'rejectClassName', 'children']);
		
		      var activeStyle = rest.activeStyle,
		          className = rest.className,
		          rejectStyle = rest.rejectStyle,
		          style = rest.style,
		          props = _objectWithoutProperties(rest, ['activeStyle', 'className', 'rejectStyle', 'style']);
		
		      var _state = this.state,
		          isDragActive = _state.isDragActive,
		          isDragReject = _state.isDragReject;
		
		
		      className = className || '';
		
		      if (isDragActive && activeClassName) {
		        className += ' ' + activeClassName;
		      }
		      if (isDragReject && rejectClassName) {
		        className += ' ' + rejectClassName;
		      }
		
		      if (!className && !style && !activeStyle && !rejectStyle) {
		        style = {
		          width: 200,
		          height: 200,
		          borderWidth: 2,
		          borderColor: '#666',
		          borderStyle: 'dashed',
		          borderRadius: 5
		        };
		        activeStyle = {
		          borderStyle: 'solid',
		          backgroundColor: '#eee'
		        };
		        rejectStyle = {
		          borderStyle: 'solid',
		          backgroundColor: '#ffdddd'
		        };
		      }
		
		      var appliedStyle = void 0;
		      if (activeStyle && isDragActive) {
		        appliedStyle = _extends({}, style, activeStyle);
		      } else if (rejectStyle && isDragReject) {
		        appliedStyle = _extends({}, style, rejectStyle);
		      } else {
		        appliedStyle = _extends({}, style);
		      }
		
		      var inputAttributes = {
		        accept: accept,
		        type: 'file',
		        style: { display: 'none' },
		        multiple: supportMultiple && multiple,
		        ref: function ref(el) {
		          return _this4.fileInputEl = el;
		        }, // eslint-disable-line
		        onChange: this.onDrop
		      };
		
		      if (name && name.length) {
		        inputAttributes.name = name;
		      }
		
		      // Remove custom properties before passing them to the wrapper div element
		      var customProps = ['acceptedFiles', 'preventDropOnDocument', 'disablePreview', 'disableClick', 'onDropAccepted', 'onDropRejected', 'onFileDialogCancel', 'maxSize', 'minSize'];
		      var divProps = _extends({}, props);
		      customProps.forEach(function (prop) {
		        return delete divProps[prop];
		      });
		
		      return _react2.default.createElement(
		        'div',
		        _extends({
		          className: className,
		          style: appliedStyle
		        }, divProps /* expand user provided props first so event handlers are never overridden */, {
		          onClick: this.onClick,
		          onDragStart: this.onDragStart,
		          onDragEnter: this.onDragEnter,
		          onDragOver: this.onDragOver,
		          onDragLeave: this.onDragLeave,
		          onDrop: this.onDrop,
		          ref: this.setRef
		        }),
		        this.renderChildren(children),
		        _react2.default.createElement('input', _extends({}, inputProps /* expand user provided inputProps first so inputAttributes override them */, inputAttributes))
		      );
		    }
		  }]);
		
		  return Dropzone;
		}(_react2.default.Component);
		
		Dropzone.defaultProps = {
		  preventDropOnDocument: true,
		  disablePreview: false,
		  disableClick: false,
		  multiple: true,
		  maxSize: Infinity,
		  minSize: 0
		};
		
		Dropzone.propTypes = {
		  onClick: _propTypes2.default.func,
		  onDrop: _propTypes2.default.func,
		  onDropAccepted: _propTypes2.default.func,
		  onDropRejected: _propTypes2.default.func,
		  onDragStart: _propTypes2.default.func,
		  onDragEnter: _propTypes2.default.func,
		  onDragOver: _propTypes2.default.func,
		  onDragLeave: _propTypes2.default.func,
		
		  children: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.func]), // Contents of the dropzone
		  style: _propTypes2.default.object, // CSS styles to apply
		  activeStyle: _propTypes2.default.object, // CSS styles to apply when drop will be accepted
		  rejectStyle: _propTypes2.default.object, // CSS styles to apply when drop will be rejected
		  className: _propTypes2.default.string, // Optional className
		  activeClassName: _propTypes2.default.string, // className for accepted state
		  rejectClassName: _propTypes2.default.string, // className for rejected state
		
		  preventDropOnDocument: _propTypes2.default.bool, // If false, allow dropped items to take over the current browser window
		  disablePreview: _propTypes2.default.bool, // Enable/disable preview generation
		  disableClick: _propTypes2.default.bool, // Disallow clicking on the dropzone container to open file dialog
		  onFileDialogCancel: _propTypes2.default.func, // Provide a callback on clicking the cancel button of the file dialog
		
		  inputProps: _propTypes2.default.object, // Pass additional attributes to the <input type="file"/> tag
		  multiple: _propTypes2.default.bool, // Allow dropping multiple files
		  accept: _propTypes2.default.string, // Allow specific types of files. See https://github.com/okonet/attr-accept for more information
		  name: _propTypes2.default.string, // name attribute for the input tag
		  maxSize: _propTypes2.default.number,
		  minSize: _propTypes2.default.number
		};
		
		exports.default = Dropzone;
		module.exports = exports['default'];
		/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))
	
	/***/ },
	/* 1 */
	/***/ function(module, exports) {
	
		// shim for using process in browser
		var process = module.exports = {};
		
		// cached from whatever global is present so that test runners that stub it
		// don't break things.  But we need to wrap it in a try catch in case it is
		// wrapped in strict mode code which doesn't define any globals.  It's inside a
		// function because try/catches deoptimize in certain engines.
		
		var cachedSetTimeout;
		var cachedClearTimeout;
		
		function defaultSetTimout() {
		    throw new Error('setTimeout has not been defined');
		}
		function defaultClearTimeout () {
		    throw new Error('clearTimeout has not been defined');
		}
		(function () {
		    try {
		        if (typeof setTimeout === 'function') {
		            cachedSetTimeout = setTimeout;
		        } else {
		            cachedSetTimeout = defaultSetTimout;
		        }
		    } catch (e) {
		        cachedSetTimeout = defaultSetTimout;
		    }
		    try {
		        if (typeof clearTimeout === 'function') {
		            cachedClearTimeout = clearTimeout;
		        } else {
		            cachedClearTimeout = defaultClearTimeout;
		        }
		    } catch (e) {
		        cachedClearTimeout = defaultClearTimeout;
		    }
		} ())
		function runTimeout(fun) {
		    if (cachedSetTimeout === setTimeout) {
		        //normal enviroments in sane situations
		        return setTimeout(fun, 0);
		    }
		    // if setTimeout wasn't available but was latter defined
		    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
		        cachedSetTimeout = setTimeout;
		        return setTimeout(fun, 0);
		    }
		    try {
		        // when when somebody has screwed with setTimeout but no I.E. maddness
		        return cachedSetTimeout(fun, 0);
		    } catch(e){
		        try {
		            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
		            return cachedSetTimeout.call(null, fun, 0);
		        } catch(e){
		            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
		            return cachedSetTimeout.call(this, fun, 0);
		        }
		    }
		
		
		}
		function runClearTimeout(marker) {
		    if (cachedClearTimeout === clearTimeout) {
		        //normal enviroments in sane situations
		        return clearTimeout(marker);
		    }
		    // if clearTimeout wasn't available but was latter defined
		    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
		        cachedClearTimeout = clearTimeout;
		        return clearTimeout(marker);
		    }
		    try {
		        // when when somebody has screwed with setTimeout but no I.E. maddness
		        return cachedClearTimeout(marker);
		    } catch (e){
		        try {
		            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
		            return cachedClearTimeout.call(null, marker);
		        } catch (e){
		            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
		            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
		            return cachedClearTimeout.call(this, marker);
		        }
		    }
		
		
		
		}
		var queue = [];
		var draining = false;
		var currentQueue;
		var queueIndex = -1;
		
		function cleanUpNextTick() {
		    if (!draining || !currentQueue) {
		        return;
		    }
		    draining = false;
		    if (currentQueue.length) {
		        queue = currentQueue.concat(queue);
		    } else {
		        queueIndex = -1;
		    }
		    if (queue.length) {
		        drainQueue();
		    }
		}
		
		function drainQueue() {
		    if (draining) {
		        return;
		    }
		    var timeout = runTimeout(cleanUpNextTick);
		    draining = true;
		
		    var len = queue.length;
		    while(len) {
		        currentQueue = queue;
		        queue = [];
		        while (++queueIndex < len) {
		            if (currentQueue) {
		                currentQueue[queueIndex].run();
		            }
		        }
		        queueIndex = -1;
		        len = queue.length;
		    }
		    currentQueue = null;
		    draining = false;
		    runClearTimeout(timeout);
		}
		
		process.nextTick = function (fun) {
		    var args = new Array(arguments.length - 1);
		    if (arguments.length > 1) {
		        for (var i = 1; i < arguments.length; i++) {
		            args[i - 1] = arguments[i];
		        }
		    }
		    queue.push(new Item(fun, args));
		    if (queue.length === 1 && !draining) {
		        runTimeout(drainQueue);
		    }
		};
		
		// v8 likes predictible objects
		function Item(fun, array) {
		    this.fun = fun;
		    this.array = array;
		}
		Item.prototype.run = function () {
		    this.fun.apply(null, this.array);
		};
		process.title = 'browser';
		process.browser = true;
		process.env = {};
		process.argv = [];
		process.version = ''; // empty string to avoid regexp issues
		process.versions = {};
		
		function noop() {}
		
		process.on = noop;
		process.addListener = noop;
		process.once = noop;
		process.off = noop;
		process.removeListener = noop;
		process.removeAllListeners = noop;
		process.emit = noop;
		
		process.binding = function (name) {
		    throw new Error('process.binding is not supported');
		};
		
		process.cwd = function () { return '/' };
		process.chdir = function (dir) {
		    throw new Error('process.chdir is not supported');
		};
		process.umask = function() { return 0; };
	
	
	/***/ },
	/* 2 */
	/***/ function(module, exports) {
	
		module.exports = __WEBPACK_EXTERNAL_MODULE_2__;
	
	/***/ },
	/* 3 */
	/***/ function(module, exports) {
	
		module.exports = __WEBPACK_EXTERNAL_MODULE_3__;
	
	/***/ },
	/* 4 */
	/***/ function(module, exports) {
	
		module.exports=function(t){function n(e){if(r[e])return r[e].exports;var o=r[e]={exports:{},id:e,loaded:!1};return t[e].call(o.exports,o,o.exports,n),o.loaded=!0,o.exports}var r={};return n.m=t,n.c=r,n.p="",n(0)}([function(t,n,r){"use strict";n.__esModule=!0,r(8),r(9),n["default"]=function(t,n){if(t&&n){var r=function(){var r=Array.isArray(n)?n:n.split(","),e=t.name||"",o=t.type||"",i=o.replace(/\/.*$/,"");return{v:r.some(function(t){var n=t.trim();return"."===n.charAt(0)?e.toLowerCase().endsWith(n.toLowerCase()):/\/\*$/.test(n)?i===n.replace(/\/.*$/,""):o===n})}}();if("object"==typeof r)return r.v}return!0},t.exports=n["default"]},function(t,n){var r=t.exports={version:"1.2.2"};"number"==typeof __e&&(__e=r)},function(t,n){var r=t.exports="undefined"!=typeof window&&window.Math==Math?window:"undefined"!=typeof self&&self.Math==Math?self:Function("return this")();"number"==typeof __g&&(__g=r)},function(t,n,r){var e=r(2),o=r(1),i=r(4),u=r(19),c="prototype",f=function(t,n){return function(){return t.apply(n,arguments)}},s=function(t,n,r){var a,p,l,y,d=t&s.G,h=t&s.P,v=d?e:t&s.S?e[n]||(e[n]={}):(e[n]||{})[c],x=d?o:o[n]||(o[n]={});d&&(r=n);for(a in r)p=!(t&s.F)&&v&&a in v,l=(p?v:r)[a],y=t&s.B&&p?f(l,e):h&&"function"==typeof l?f(Function.call,l):l,v&&!p&&u(v,a,l),x[a]!=l&&i(x,a,y),h&&((x[c]||(x[c]={}))[a]=l)};e.core=o,s.F=1,s.G=2,s.S=4,s.P=8,s.B=16,s.W=32,t.exports=s},function(t,n,r){var e=r(5),o=r(18);t.exports=r(22)?function(t,n,r){return e.setDesc(t,n,o(1,r))}:function(t,n,r){return t[n]=r,t}},function(t,n){var r=Object;t.exports={create:r.create,getProto:r.getPrototypeOf,isEnum:{}.propertyIsEnumerable,getDesc:r.getOwnPropertyDescriptor,setDesc:r.defineProperty,setDescs:r.defineProperties,getKeys:r.keys,getNames:r.getOwnPropertyNames,getSymbols:r.getOwnPropertySymbols,each:[].forEach}},function(t,n){var r=0,e=Math.random();t.exports=function(t){return"Symbol(".concat(void 0===t?"":t,")_",(++r+e).toString(36))}},function(t,n,r){var e=r(20)("wks"),o=r(2).Symbol;t.exports=function(t){return e[t]||(e[t]=o&&o[t]||(o||r(6))("Symbol."+t))}},function(t,n,r){r(26),t.exports=r(1).Array.some},function(t,n,r){r(25),t.exports=r(1).String.endsWith},function(t,n){t.exports=function(t){if("function"!=typeof t)throw TypeError(t+" is not a function!");return t}},function(t,n){var r={}.toString;t.exports=function(t){return r.call(t).slice(8,-1)}},function(t,n,r){var e=r(10);t.exports=function(t,n,r){if(e(t),void 0===n)return t;switch(r){case 1:return function(r){return t.call(n,r)};case 2:return function(r,e){return t.call(n,r,e)};case 3:return function(r,e,o){return t.call(n,r,e,o)}}return function(){return t.apply(n,arguments)}}},function(t,n){t.exports=function(t){if(void 0==t)throw TypeError("Can't call method on  "+t);return t}},function(t,n,r){t.exports=function(t){var n=/./;try{"/./"[t](n)}catch(e){try{return n[r(7)("match")]=!1,!"/./"[t](n)}catch(o){}}return!0}},function(t,n){t.exports=function(t){try{return!!t()}catch(n){return!0}}},function(t,n){t.exports=function(t){return"object"==typeof t?null!==t:"function"==typeof t}},function(t,n,r){var e=r(16),o=r(11),i=r(7)("match");t.exports=function(t){var n;return e(t)&&(void 0!==(n=t[i])?!!n:"RegExp"==o(t))}},function(t,n){t.exports=function(t,n){return{enumerable:!(1&t),configurable:!(2&t),writable:!(4&t),value:n}}},function(t,n,r){var e=r(2),o=r(4),i=r(6)("src"),u="toString",c=Function[u],f=(""+c).split(u);r(1).inspectSource=function(t){return c.call(t)},(t.exports=function(t,n,r,u){"function"==typeof r&&(o(r,i,t[n]?""+t[n]:f.join(String(n))),"name"in r||(r.name=n)),t===e?t[n]=r:(u||delete t[n],o(t,n,r))})(Function.prototype,u,function(){return"function"==typeof this&&this[i]||c.call(this)})},function(t,n,r){var e=r(2),o="__core-js_shared__",i=e[o]||(e[o]={});t.exports=function(t){return i[t]||(i[t]={})}},function(t,n,r){var e=r(17),o=r(13);t.exports=function(t,n,r){if(e(n))throw TypeError("String#"+r+" doesn't accept regex!");return String(o(t))}},function(t,n,r){t.exports=!r(15)(function(){return 7!=Object.defineProperty({},"a",{get:function(){return 7}}).a})},function(t,n){var r=Math.ceil,e=Math.floor;t.exports=function(t){return isNaN(t=+t)?0:(t>0?e:r)(t)}},function(t,n,r){var e=r(23),o=Math.min;t.exports=function(t){return t>0?o(e(t),9007199254740991):0}},function(t,n,r){"use strict";var e=r(3),o=r(24),i=r(21),u="endsWith",c=""[u];e(e.P+e.F*r(14)(u),"String",{endsWith:function(t){var n=i(this,t,u),r=arguments,e=r.length>1?r[1]:void 0,f=o(n.length),s=void 0===e?f:Math.min(o(e),f),a=String(t);return c?c.call(n,a,s):n.slice(s-a.length,s)===a}})},function(t,n,r){var e=r(5),o=r(3),i=r(1).Array||Array,u={},c=function(t,n){e.each.call(t.split(","),function(t){void 0==n&&t in i?u[t]=i[t]:t in[]&&(u[t]=r(12)(Function.call,[][t],n))})};c("pop,reverse,shift,keys,values,entries",1),c("indexOf,every,some,forEach,map,filter,find,findIndex,includes",3),c("join,slice,concat,push,splice,unshift,sort,lastIndexOf,reduce,reduceRight,copyWithin,fill"),o(o.S,"Array",u)}]);
	
	/***/ },
	/* 5 */
	/***/ function(module, exports) {
	
		"use strict";
		
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.default = getDataTransferFiles;
		function getDataTransferFiles(event) {
		  var isMultipleAllowed = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
		
		  var dataTransferItemsList = [];
		  if (event.dataTransfer) {
		    var dt = event.dataTransfer;
		    if (dt.files && dt.files.length) {
		      dataTransferItemsList = dt.files;
		    } else if (dt.items && dt.items.length) {
		      // During the drag even the dataTransfer.files is null
		      // but Chrome implements some drag store, which is accesible via dataTransfer.items
		      dataTransferItemsList = dt.items;
		    }
		  } else if (event.target && event.target.files) {
		    dataTransferItemsList = event.target.files;
		  }
		
		  if (dataTransferItemsList.length > 0) {
		    dataTransferItemsList = isMultipleAllowed ? dataTransferItemsList : [dataTransferItemsList[0]];
		  }
		
		  // Convert from DataTransferItemsList to the native Array
		  return Array.prototype.slice.call(dataTransferItemsList);
		}
		module.exports = exports["default"];
	
	/***/ }
	/******/ ])
	});
	;
	//# sourceMappingURL=index.js.map

/***/ }),
/* 1781 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _materialUi = __webpack_require__(576);
	
	var _UserStore = __webpack_require__(974);
	
	var _UserStore2 = _interopRequireDefault(_UserStore);
	
	var _base = __webpack_require__(1755);
	
	var _base2 = _interopRequireDefault(_base);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var VirtualContentPreviewOverlay = function (_React$Component) {
	  _inherits(VirtualContentPreviewOverlay, _React$Component);
	
	  function VirtualContentPreviewOverlay(props) {
	    _classCallCheck(this, VirtualContentPreviewOverlay);
	
	    return _possibleConstructorReturn(this, Object.getPrototypeOf(VirtualContentPreviewOverlay).call(this, props));
	  }
	
	  _createClass(VirtualContentPreviewOverlay, [{
	    key: "shouldComponentUpdate",
	    value: function shouldComponentUpdate(nextProps) {
	      if (nextProps.filmId !== this.props.filmId || nextProps.virtualContentId !== this.props.virtualContentId) {
	        return true;
	      }
	      return false;
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _props = this.props;
	      var onRequestClose = _props.onRequestClose;
	      var filmId = _props.filmId;
	      var virtualContentId = _props.virtualContentId;
	
	      var user = _UserStore2.default.getUser() || {};
	
	      var destination = ("https://watch.eventive.org/") + "admin/preview?data=" + btoa(JSON.stringify(_extends({
	        film_id: filmId,
	        virtual_content_id: virtualContentId
	      }, _UserStore2.default.getCredentials())));
	
	      return _react2.default.createElement(
	        _base2.default,
	        {
	          onRequestClose: onRequestClose,
	          useMuiDefaultStyle: true,
	          actions: [_react2.default.createElement(_materialUi.FlatButton, { label: "Close preview", onTouchTap: onRequestClose })]
	        },
	        _react2.default.createElement(
	          "h2",
	          { style: { color: "#000", marginBottom: "1em" } },
	          "Virtual content preview"
	        ),
	        _react2.default.createElement(
	          "div",
	          {
	            style: { position: "relative", paddingTop: "56.25%", width: "100%" }
	          },
	          _react2.default.createElement("iframe", {
	            style: {
	              position: "absolute",
	              top: 0,
	              left: 0,
	              width: "100%",
	              height: "100%"
	            },
	            frameBorder: "0",
	            scrolling: "no",
	            ref: function ref(r) {
	              if (r) {
	                r.setAttribute("allow", "autoplay; encrypted-media; fullscreen");
	                r.src = destination;
	              }
	            }
	          })
	        )
	      );
	    }
	  }]);
	
	  return VirtualContentPreviewOverlay;
	}(_react2.default.Component);
	
	exports.default = VirtualContentPreviewOverlay;
	module.exports = exports["default"];

/***/ }),
/* 1782 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(486);
	
	var _values = __webpack_require__(1214);
	
	var _values2 = _interopRequireDefault(_values);
	
	var _pickBy = __webpack_require__(1163);
	
	var _pickBy2 = _interopRequireDefault(_pickBy);
	
	var _materialUi = __webpack_require__(576);
	
	var _connectToStores = __webpack_require__(1226);
	
	var _connectToStores2 = _interopRequireDefault(_connectToStores);
	
	var _TitleActions = __webpack_require__(1665);
	
	var _TitleActions2 = _interopRequireDefault(_TitleActions);
	
	var _TitleStore = __webpack_require__(1666);
	
	var _TitleStore2 = _interopRequireDefault(_TitleStore);
	
	var _TitleUtil = __webpack_require__(1667);
	
	var _TitleUtil2 = _interopRequireDefault(_TitleUtil);
	
	var _VirtualContentStore = __webpack_require__(1768);
	
	var _VirtualContentStore2 = _interopRequireDefault(_VirtualContentStore);
	
	var _VirtualContentActions = __webpack_require__(1767);
	
	var _VirtualContentActions2 = _interopRequireDefault(_VirtualContentActions);
	
	var _config = __webpack_require__(1173);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _UserStore = __webpack_require__(974);
	
	var _UserStore2 = _interopRequireDefault(_UserStore);
	
	var _workingIndicator = __webpack_require__(1664);
	
	var _workingIndicator2 = _interopRequireDefault(_workingIndicator);
	
	var _filmTable = __webpack_require__(1763);
	
	var _queryString = __webpack_require__(513);
	
	var _queryString2 = _interopRequireDefault(_queryString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var parsedQueryString = _queryString2.default.parse(window.location.search);
	
	var TitleDelivery = function (_React$Component) {
	  _inherits(TitleDelivery, _React$Component);
	
	  function TitleDelivery(props) {
	    _classCallCheck(this, TitleDelivery);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(TitleDelivery).call(this, props));
	
	    _this.state = {
	      isSaving: false,
	
	      hasExistingPrint: null,
	      existingPrintDeliveryMethod: null,
	      virtualDeliveryMethod: null
	    };
	    return _this;
	  }
	
	  _createClass(TitleDelivery, [{
	    key: "saveDeliveryDetails",
	    value: function saveDeliveryDetails() {
	      var _this2 = this;
	
	      this.setState({ isSaving: true });
	      _TitleUtil2.default.editTitleDelivery(_UserStore2.default.getState().apiKey, this.props.params.titleDeliveryId, {
	        print_delivery_type: this.state.hasExistingPrint === false ? "new_order" : this.state.existingPrintDeliveryMethod,
	        virtual_delivery_type: this.state.virtualDeliveryMethod
	      }).then(function (data) {
	        // Re-fetch after saving
	        _TitleActions2.default.fetchOne(_this2.props.params.titleId);
	        _this2.setState({ isSaving: false }, function () {
	          window.scrollTo(0, 0);
	        });
	      }).catch(function (e) {
	        window.alert("Failed to save details: " + e.message);
	        _this2.setState({ isSaving: false });
	      });
	    }
	  }, {
	    key: "_injectUrl",
	    value: function _injectUrl(url, title, titleDelivery) {
	      var account = _UserStore2.default.getAccount() || {};
	      var values = {
	        title_name: title.name,
	        creator_email: account.email,
	        creator_name: account.name,
	        delivery_identifier: "" + titleDelivery.receiving_event_bucket.name
	      };
	      return url.replace(/{{(.*?)}}/g, function (_, key) {
	        var value = values[key];
	        return encodeURIComponent(value);
	      });
	    }
	  }, {
	    key: "_makeQuotePrintLink",
	    value: function _makeQuotePrintLink(title, titleDelivery) {
	      return this._injectUrl(titleDelivery.print_quote_portal_url || "", title, titleDelivery);
	    }
	  }, {
	    key: "_makeUploadPrintLink",
	    value: function _makeUploadPrintLink(title, titleDelivery) {
	      return this._injectUrl(titleDelivery.print_upload_portal_url || "", title, titleDelivery);
	    }
	  }, {
	    key: "_makeUploadVirtualLink",
	    value: function _makeUploadVirtualLink() {
	      var _this3 = this;
	
	      var title = _TitleStore2.default.getTitleById(this.props.params.titleId),
	          titleDelivery = title && title.title_deliveries.find(function (d) {
	        return d.id === _this3.props.params.titleDeliveryId;
	      });
	      return "/creator_hub/films/" + titleDelivery.receiving_film.id;
	    }
	  }, {
	    key: "getStyles",
	    value: function getStyles() {
	      return {
	        container: {
	          maxWidth: 500,
	          margin: "5% auto",
	          fontSize: "11pt",
	          padding: "5px 20px",
	          borderRadius: "1em",
	          boxShadow: "0 0 20px 2px rgba(0,0,0,0.2)"
	        },
	        header: {
	          fontWeight: "bold",
	          fontSize: "14pt",
	          marginTop: "1em",
	          marginBottom: "-0.25em"
	        },
	        radio: {
	          marginTop: "0.5em",
	          fontSize: "0.9em"
	        }
	      };
	    }
	  }, {
	    key: "componentWillMount",
	    value: function componentWillMount() {
	      _TitleActions2.default.fetchOne(this.props.params.titleId);
	      _VirtualContentActions2.default.fetchAll();
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this4 = this;
	
	      var styles = this.getStyles(),
	          title = _TitleStore2.default.getTitleById(this.props.params.titleId),
	          titleDelivery = title && title.title_deliveries.find(function (d) {
	        return d.id === _this4.props.params.titleDeliveryId;
	      });
	
	      if (!title || !titleDelivery || this.props.isFetching) {
	        return _react2.default.createElement(_workingIndicator2.default, { fullPage: true });
	      }
	
	      var needsPrint = titleDelivery.receiving_film.title_requested_media.includes("print");
	      var needsVirtual = titleDelivery.receiving_film.title_requested_media.includes("virtual");
	
	      var isDigitalFile = titleDelivery.accepted_print_formats && titleDelivery.accepted_print_formats.includes("digital_file");
	
	      var canSave = (needsPrint ? (isDigitalFile || this.state.hasExistingPrint === true) && this.state.existingPrintDeliveryMethod || this.state.hasExistingPrint === false : true) && (needsVirtual && needsPrint ? isDigitalFile || this.state.virtualDeliveryMethod : true),
	          canEnterVirtual = needsPrint ? isDigitalFile ? this.state.existingPrintDeliveryMethod : this.state.hasExistingPrint !== null : true;
	
	      return _react2.default.createElement(
	        "div",
	        { style: styles.container },
	        _react2.default.createElement(
	          "div",
	          {
	            style: {
	              textAlign: "center",
	              fontSize: "1.25em",
	              margin: "1em 0"
	            }
	          },
	          _react2.default.createElement(
	            "span",
	            { style: { fontFamily: "monospace, sans-serif" } },
	            titleDelivery.delivery_identifier
	          ),
	          " ",
	          "\xB7 ",
	          _react2.default.createElement(_filmTable.TitleDeliveryStatus, { title_delivery: titleDelivery })
	        ),
	        titleDelivery.status_description ? _react2.default.createElement(
	          "div",
	          {
	            style: {
	              textAlign: "center",
	              fontSize: "1em",
	              marginTop: "-0.5em",
	              marginBottom: "1em",
	              fontStyle: "italic",
	              color: "rgb(229, 57, 53)",
	              border: "1px solid rgb(229, 57, 53)",
	              borderRadius: "0.25em",
	              padding: 5
	            }
	          },
	          titleDelivery.status_description
	        ) : null,
	        _react2.default.createElement(
	          "p",
	          null,
	          "Welcome! Eventive",
	          needsPrint ? ", in partnership with Simple DCP," : "",
	          " is here to assist you in delivering ",
	          _react2.default.createElement(
	            "strong",
	            null,
	            title.name
	          ),
	          " to",
	          " ",
	          _react2.default.createElement(
	            "strong",
	            null,
	            titleDelivery.receiving_event_bucket.name
	          ),
	          ", hosted by ",
	          _react2.default.createElement(
	            "strong",
	            null,
	            titleDelivery.receiving_user.organization
	          ),
	          "."
	        ),
	        _react2.default.createElement(
	          "p",
	          null,
	          "You can track this delivery using the unique identifier",
	          " ",
	          _react2.default.createElement(
	            "span",
	            {
	              style: {
	                fontFamily: "monospace, sans-serif",
	                whiteSpace: "nowrap"
	              }
	            },
	            titleDelivery.delivery_identifier
	          ),
	          ". Provide this identifier to ensure accurate support."
	        ),
	        titleDelivery.status === "draft" ? _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement(
	            "h2",
	            { style: styles.header },
	            "Requested assets"
	          ),
	          _react2.default.createElement(
	            "p",
	            null,
	            "The following assets are requested for this title."
	          ),
	          _react2.default.createElement(
	            "ul",
	            { style: { marginTop: "-0.5em" } },
	            titleDelivery.receiving_film.title_requested_media.sort().map(function (media) {
	              return _react2.default.createElement(
	                "li",
	                null,
	                media === "virtual" ? "Virtual screening asset" : media === "print" ? isDigitalFile ? "Digital file (non-DCP)" : "Print (DCP)" : "?"
	              );
	            })
	          ),
	          titleDelivery.receiving_film.title_requested_media.includes("print") ? isDigitalFile ? _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(
	              "h2",
	              { style: styles.header },
	              "Digital file (non-DCP) delivery"
	            ),
	            _react2.default.createElement(
	              "p",
	              null,
	              "How would you like to deliver your non-DCP digital file for exhibition?",
	              _react2.default.createElement(
	                _materialUi.RadioButtonGroup,
	                {
	                  style: styles.radio,
	                  name: "existingPrintDeliveryMethod",
	                  valueSelected: this.state.existingPrintDeliveryMethod,
	                  onChange: function onChange(e, v) {
	                    return _this4.setState({
	                      existingPrintDeliveryMethod: v,
	                      virtualDeliveryMethod: needsVirtual ? "direct_upload" : null
	                    });
	                  }
	                },
	                _react2.default.createElement(_materialUi.RadioButton, {
	                  value: "upload_asset",
	                  label: "Upload digital file via web portal"
	                }),
	                _react2.default.createElement(_materialUi.RadioButton, {
	                  value: "on_file",
	                  label: "Use digital file on file with Simple DCP"
	                })
	              )
	            )
	          ) : _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(
	              "h2",
	              { style: styles.header },
	              "Print delivery"
	            ),
	            _react2.default.createElement(
	              "p",
	              null,
	              "Do you have an exhibition print of ",
	              title.name,
	              " available to deliver to ",
	              titleDelivery.receiving_user.organization,
	              "?",
	              _react2.default.createElement(
	                _materialUi.RadioButtonGroup,
	                {
	                  style: styles.radio,
	                  name: "hasExistingPrint",
	                  valueSelected: this.state.hasExistingPrint,
	                  onChange: function onChange(e, v) {
	                    return _this4.setState({ hasExistingPrint: v });
	                  }
	                },
	                _react2.default.createElement(_materialUi.RadioButton, {
	                  value: true,
	                  label: "Yes, I have an exhibition print (DCP) available"
	                }),
	                _react2.default.createElement(_materialUi.RadioButton, {
	                  value: false,
	                  label: "No, I need to have an exhibition print made"
	                })
	              )
	            ),
	            this.state.hasExistingPrint === true ? _react2.default.createElement(
	              "div",
	              {
	                style: {
	                  fontSize: "0.75em",
	                  marginTop: "0em",
	                  lineHeight: "1.25em",
	                  fontStyle: "italic"
	                }
	              },
	              "Note: The exhibition systems in use at this festival are known to be incompatible with DCPs made using the Quvis Wraptor Plugin for Adobe products. DCPs found to be created using this software will be summarily rejected."
	            ) : null,
	            this.state.hasExistingPrint === true ? _react2.default.createElement(
	              "p",
	              null,
	              "How would you like to deliver your existing print?",
	              _react2.default.createElement(
	                _materialUi.RadioButtonGroup,
	                {
	                  style: styles.radio,
	                  name: "existingPrintDeliveryMethod",
	                  valueSelected: this.state.existingPrintDeliveryMethod,
	                  onChange: function onChange(e, v) {
	                    return _this4.setState({ existingPrintDeliveryMethod: v });
	                  }
	                },
	                _react2.default.createElement(_materialUi.RadioButton, {
	                  value: "upload_asset",
	                  label: "Upload via web portal"
	                }),
	                _react2.default.createElement(_materialUi.RadioButton, {
	                  value: "mail_asset",
	                  label: "Mail physical drive"
	                }),
	                _react2.default.createElement(_materialUi.RadioButton, {
	                  value: "on_file",
	                  label: "Use print on file with Simple DCP"
	                })
	              )
	            ) : this.state.hasExistingPrint === false ? _react2.default.createElement(
	              "p",
	              null,
	              "Got it. In the next step, our recommended vendor, Simple DCP, will provide an instant quote."
	            ) : null
	          ) : null,
	          titleDelivery.receiving_film.title_requested_media.includes("virtual") ? _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(
	              "h2",
	              { style: styles.header },
	              "Virtual screening asset delivery"
	            ),
	            !canEnterVirtual ? _react2.default.createElement(
	              "p",
	              { style: { fontStyle: "italic" } },
	              "Please answer all questions above about your",
	              " ",
	              isDigitalFile ? "digital file" : "print",
	              " delivery."
	            ) : _react2.default.createElement(
	              "div",
	              null,
	              needsPrint && !isDigitalFile ? _react2.default.createElement(
	                "p",
	                null,
	                "How would you like to deliver your virtual screening asset?",
	                _react2.default.createElement(
	                  _materialUi.RadioButtonGroup,
	                  {
	                    style: styles.radio,
	                    name: "virtualDeliveryMethod",
	                    valueSelected: this.state.virtualDeliveryMethod,
	                    onChange: function onChange(e, v) {
	                      return _this4.setState({ virtualDeliveryMethod: v });
	                    }
	                  },
	                  _react2.default.createElement(_materialUi.RadioButton, {
	                    value: "direct_upload",
	                    label: "Manually upload a virtual screening asset"
	                  }),
	                  _react2.default.createElement(_materialUi.RadioButton, {
	                    value: "extract_from_print",
	                    label: "Extract and create virtual asset from exhibition print"
	                  })
	                )
	              ) : _react2.default.createElement(
	                "p",
	                null,
	                "In the next step, you can upload your virtual screening asset."
	              )
	            )
	          ) : null,
	          _react2.default.createElement(
	            "h2",
	            { style: styles.header },
	            "Confirm and save"
	          ),
	          !canSave ? _react2.default.createElement(
	            "p",
	            { style: { fontStyle: "italic" } },
	            "Please answer all questions above about your delivery."
	          ) : needsPrint ? _react2.default.createElement(
	            "p",
	            null,
	            "Please review your answers above, as they cannot be modified after you click save. When you are ready to proceed to delivery, please save and continue."
	          ) : _react2.default.createElement(
	            "p",
	            null,
	            "We will initiate a new upload session for your asset."
	          ),
	          _react2.default.createElement(_materialUi.RaisedButton, {
	            label: this.state.isSaving ? "Saving delivery details..." : "Save delivery details & continue",
	            style: { marginBottom: "1.5em" },
	            disabled: !canSave || this.state.isSaving,
	            primary: true,
	            onTouchTap: function onTouchTap() {
	              if (needsVirtual && !needsPrint) {
	                // Virtual only - short circuit as always direct upload
	                _this4.setState({ virtualDeliveryMethod: "direct_upload" }, function () {
	                  _this4.saveDeliveryDetails();
	                });
	              } else {
	                _this4.saveDeliveryDetails();
	              }
	            }
	          })
	        ) : _react2.default.createElement(
	          "div",
	          { style: { marginBottom: "1.5em" } },
	          titleDelivery.print_delivery_type ? _react2.default.createElement(
	            "p",
	            null,
	            _react2.default.createElement(
	              "strong",
	              null,
	              isDigitalFile ? "Digital file delivery" : "Print delivery"
	            ),
	            ": You have indicated that you",
	            " ",
	            titleDelivery.print_delivery_type === "new_order" ? "need to have an exhibition print made. Please click below to request a quote. Simple DCP will handle the process from there." : titleDelivery.print_delivery_type === "upload_asset" ? "will upload your " + (isDigitalFile ? "exhibition-quality digital file (non-DCP)" : "DCP") + " directly. Please utilize the uploader below." : titleDelivery.print_delivery_type === "on_file" ? "already have a print on file with Simple DCP. We will attempt to pull this print from archive, and contact you if there are any issues." : titleDelivery.print_delivery_type === "mail_asset" ? "will deliver your DCP by mail. " + (titleDelivery.print_mail_instructions || "Please contact the festival for further instructions.") : "?."
	          ) : null,
	          titleDelivery.print_delivery_type === "new_order" ? _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(_materialUi.RaisedButton, {
	              label: "Request DCP quote",
	              primary: true,
	              href: this._makeQuotePrintLink(title, titleDelivery),
	              target: "_blank"
	            })
	          ) : titleDelivery.print_delivery_type === "upload_asset" ? _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(_materialUi.RaisedButton, {
	              label: "Launch " + (isDigitalFile ? "digital file" : "DCP") + " upload portal",
	              primary: true,
	              href: this._makeUploadPrintLink(title, titleDelivery),
	              target: "_blank"
	            })
	          ) : null,
	          titleDelivery.virtual_delivery_type ? _react2.default.createElement(
	            "p",
	            null,
	            _react2.default.createElement(
	              "strong",
	              null,
	              "Virtual delivery"
	            ),
	            ": You have",
	            " ",
	            titleDelivery.virtual_delivery_type === "extract_from_print" ? "requested that we extract and prepare your virtual screening asset using the print asset that you deliver. No additional action is necessary." : "indicated that you will upload a virtual screening asset. Please upload this asset below."
	          ) : null,
	          titleDelivery.virtual_delivery_type === "direct_upload" ? _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(_materialUi.RaisedButton, {
	              label: "Upload virtual content",
	              primary: true,
	              href: this._makeUploadVirtualLink({}),
	              target: "_blank"
	            })
	          ) : null,
	          _react2.default.createElement(
	            "div",
	            {
	              style: {
	                marginTop: "1.5em",
	                borderTop: "1px solid #ccc",
	                paddingTop: "1.5em"
	              }
	            },
	            _react2.default.createElement(
	              "strong",
	              null,
	              "What's next?"
	            ),
	            " We will review your submitted materials promptly upon receipt. As your delivery is processed, or if there are any questions or issues, we will keep you informed via email to ",
	            _UserStore2.default.getAccount().email,
	            "."
	          )
	        )
	      );
	    }
	  }], [{
	    key: "getStores",
	    value: function getStores() {
	      return [_UserStore2.default, _TitleStore2.default, _VirtualContentStore2.default];
	    }
	  }, {
	    key: "getPropsFromStores",
	    value: function getPropsFromStores() {
	      return _TitleStore2.default.getState();
	    }
	  }, {
	    key: "contextTypes",
	    get: function get() {
	      return {
	        router: _react2.default.PropTypes.object
	      };
	    }
	  }]);
	
	  return TitleDelivery;
	}(_react2.default.Component);
	
	exports.default = (0, _connectToStores2.default)(TitleDelivery);
	module.exports = exports["default"];

/***/ }),
/* 1783 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _materialUi = __webpack_require__(576);
	
	var _util = __webpack_require__(1183);
	
	var _statsBlockContainer = __webpack_require__(1740);
	
	var _statsBlockContainer2 = _interopRequireDefault(_statsBlockContainer);
	
	var _statsBlock = __webpack_require__(1741);
	
	var _statsBlock2 = _interopRequireDefault(_statsBlock);
	
	var _eventBucketSalesChart = __webpack_require__(1784);
	
	var _eventBucketSalesChart2 = _interopRequireDefault(_eventBucketSalesChart);
	
	var _workingIndicator = __webpack_require__(1664);
	
	var _workingIndicator2 = _interopRequireDefault(_workingIndicator);
	
	var _chart = __webpack_require__(1785);
	
	var _chart2 = _interopRequireDefault(_chart);
	
	var _tableRefreshIndicator = __webpack_require__(1686);
	
	var _tableRefreshIndicator2 = _interopRequireDefault(_tableRefreshIndicator);
	
	var _viewLiveVirtualButton = __webpack_require__(1865);
	
	var _viewLiveVirtualButton2 = _interopRequireDefault(_viewLiveVirtualButton);
	
	var _connectToStores = __webpack_require__(1226);
	
	var _connectToStores2 = _interopRequireDefault(_connectToStores);
	
	var _EventBucketActions = __webpack_require__(1218);
	
	var _EventBucketActions2 = _interopRequireDefault(_EventBucketActions);
	
	var _EventBucketStore = __webpack_require__(1593);
	
	var _EventBucketStore2 = _interopRequireDefault(_EventBucketStore);
	
	var _AnalyticsStore = __webpack_require__(1861);
	
	var _AnalyticsStore2 = _interopRequireDefault(_AnalyticsStore);
	
	var _AnalyticsActions = __webpack_require__(1863);
	
	var _AnalyticsActions2 = _interopRequireDefault(_AnalyticsActions);
	
	var _UserStore = __webpack_require__(974);
	
	var _UserStore2 = _interopRequireDefault(_UserStore);
	
	var _PassBucketStore = __webpack_require__(1867);
	
	var _PassBucketStore2 = _interopRequireDefault(_PassBucketStore);
	
	var _PassBucketActions = __webpack_require__(1869);
	
	var _PassBucketActions2 = _interopRequireDefault(_PassBucketActions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var EventBucket = function (_React$Component) {
	  _inherits(EventBucket, _React$Component);
	
	  function EventBucket(props) {
	    _classCallCheck(this, EventBucket);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(EventBucket).call(this, props));
	
	    _this.state = {
	      isFetchingEventBucket: false,
	      fetchedEventBucket: null,
	      showAllTime: false
	    };
	
	    _this._refresh = _this._refresh.bind(_this);
	    return _this;
	  }
	
	  _createClass(EventBucket, [{
	    key: "getStyles",
	    value: function getStyles() {
	      return {
	        title: {
	          textAlign: "center"
	        },
	        actionButtonsContainer: {
	          textAlign: "center",
	          marginTop: "1em"
	        }
	      };
	    }
	  }, {
	    key: "_refresh",
	    value: function _refresh(props) {
	      var _this2 = this;
	
	      this.setState({ isFetchingEventBucket: true }, function () {
	        var eventBucketId = (props || _this2.props).params.eventBucketId;
	        _EventBucketActions2.default.fetchOne(eventBucketId);
	        _AnalyticsActions2.default.fetchEventBucketOverview(eventBucketId);
	      });
	    }
	  }, {
	    key: "componentWillMount",
	    value: function componentWillMount() {
	      if (this.props.params.eventBucketId) {
	        _PassBucketActions2.default.fetchAllForEventBucket(this.props.params.eventBucketId);
	      }
	    }
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.componentWillReceiveProps(this.props);
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(newProps) {
	      var eventBucket = newProps.getEventBucketById(newProps.params.eventBucketId);
	
	      if (newProps.params.eventBucketId !== this.props.params.eventBucketId) {
	        _PassBucketActions2.default.fetchAllForEventBucket(newProps.params.eventBucketId);
	      }
	
	      if (!this.state.isFetchingEventBucket && this.state.fetchedEventBucket !== newProps.params.eventBucketId) {
	        this._refresh(newProps);
	      } else if (eventBucket) {
	        this.setState({
	          isFetchingEventBucket: false,
	          fetchedEventBucket: eventBucket.id
	        });
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this3 = this;
	
	      var styles = this.getStyles(),
	          eventBucket = this.props.getEventBucketById(this.props.params.eventBucketId),
	          overview = this.props.getEventBucketOverview(this.props.params.eventBucketId);
	
	      function count(key, amount) {
	        return amount + " " + (key + (amount !== 1 ? "s" : ""));
	      }
	
	      if (!eventBucket) {
	        return _react2.default.createElement(_workingIndicator2.default, { fullPage: true });
	      }
	
	      var hasBanner = eventBucket.frontend_config.banner_image;
	      var isMembership = eventBucket.frontend_config.memberships_enabled;
	
	      var passBucketCount = this.props.getPassBucketsForEventBucket(this.props.params.eventBucketId).length;
	      var membershipCount = this.props.getMembershipsForEventBucket(this.props.params.eventBucketId).length;
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        (!_UserStore2.default.hasRole("box_office") || !hasBanner) && _react2.default.createElement(
	          "h1",
	          { style: styles.title },
	          eventBucket.name
	        ),
	        _react2.default.createElement(
	          "div",
	          { style: styles.actionButtonsContainer },
	          _UserStore2.default.hasRole("box_office") ? hasBanner && _react2.default.createElement("img", {
	            src: eventBucket.frontend_config.banner_image,
	            style: { width: "100%", marginBottom: 10 }
	          }) : _react2.default.createElement(_materialUi.RaisedButton, {
	            style: { verticalAlign: "top" },
	            primary: true,
	            label: "View native site",
	            href: eventBucket.urls.root,
	            target: "_blank"
	          }),
	          eventBucket.enable_virtual_festival ? _react2.default.createElement(_viewLiveVirtualButton2.default, {
	            style: { verticalAlign: "top", marginLeft: 7 },
	            primary: true,
	            label: "virtual catalog",
	            href: eventBucket.urls.virtual_festival,
	            target: "_blank"
	          }) : null,
	          _UserStore2.default.hasPermission(["edit_event_bucket", "manage_configurator", "manage_embed_wizard"]) ? _react2.default.createElement(_materialUi.RaisedButton, {
	            style: { marginLeft: 7 },
	            label: "Settings",
	            onTouchTap: function onTouchTap() {
	              return _this3.context.router.push("/event_buckets/" + eventBucket.id + "/settings");
	            }
	          }) : null,
	          _UserStore2.default.hasPermission("view_analytics_list") ? _react2.default.createElement(_materialUi.RaisedButton, {
	            style: { marginLeft: 7 },
	            label: "Analytics",
	            onTouchTap: function onTouchTap() {
	              return _this3.context.router.push("/event_buckets/" + eventBucket.id + "/analytics");
	            }
	          }) : null,
	          !(_UserStore2.default.hasRole("box_office") || _UserStore2.default.hasRole("film_preview")) && _react2.default.createElement(_tableRefreshIndicator2.default, {
	            onRefresh: function onRefresh() {
	              return _this3._refresh();
	            },
	            isRefreshing: this.props.isFetching || this.state.isFetchingEventBucket,
	            style: {}
	          })
	        ),
	        _react2.default.createElement(
	          "div",
	          { style: { margin: "1em 0 2em" } },
	          _react2.default.createElement(
	            _statsBlockContainer2.default,
	            null,
	            _UserStore2.default.hasPermission("view_virtual_event_list") || _UserStore2.default.hasPermission("box_office") ? eventBucket.enable_virtual_festival ? _react2.default.createElement(_statsBlock2.default, {
	              value: eventBucket.virtual_events.length,
	              label: "Virtual screenings",
	              onTouchTap: function onTouchTap() {
	                return _this3.context.router.push("/event_buckets/" + eventBucket.id + "/virtual_festival");
	              }
	            }) : _react2.default.createElement(_statsBlock2.default, {
	              value: eventBucket.virtual_events.length,
	              label: "Virtual screenings"
	            }) : null,
	            _UserStore2.default.hasPermission("view_physical_event_list") ? _react2.default.createElement(_statsBlock2.default, {
	              value: eventBucket.events.length,
	              label: "Physical events",
	              onTouchTap: function onTouchTap() {
	                return _this3.context.router.push("/event_buckets/" + eventBucket.id + "/events");
	              }
	            }) : null,
	            _UserStore2.default.hasPermission("view_pass_bucket_list") ? _react2.default.createElement(_statsBlock2.default, {
	              value: passBucketCount,
	              label: "Pass buckets",
	              onTouchTap: function onTouchTap() {
	                return _this3.context.router.push("/event_buckets/" + eventBucket.id + "/pass_buckets");
	              }
	            }) : null,
	            _UserStore2.default.hasPermission("view_pass_bucket_list") && isMembership ? _react2.default.createElement(_statsBlock2.default, {
	              value: membershipCount,
	              label: "Membership buckets",
	              onTouchTap: function onTouchTap() {
	                return _this3.context.router.push("/event_buckets/" + eventBucket.id + "/memberships");
	              }
	            }) : null,
	            _UserStore2.default.hasPermission("manage_venues") ? _react2.default.createElement(_statsBlock2.default, {
	              value: eventBucket.venues.length,
	              label: "Venues",
	              onTouchTap: function onTouchTap() {
	                return _this3.context.router.push("/event_buckets/" + eventBucket.id + "/venues");
	              }
	            }) : null
	          ),
	          _react2.default.createElement(
	            _statsBlockContainer2.default,
	            null,
	            _UserStore2.default.hasPermission("view_analytics") ? _react2.default.createElement(_statsBlock2.default, {
	              value: (0, _util.formatPrice)(overview ? overview.total_net_volume : 0, ((_UserStore2.default.getUser() || {}).stripe_account_mode === "platform_managed" || ["krw", "clp"].includes((_UserStore2.default.getUser() || {}).currency)) && {
	                currency: "usd"
	              }),
	              label: "Net sales"
	            }) : null,
	            _UserStore2.default.hasPermission("view_analytics") && (_UserStore2.default.hasPermission("manage_orders") || _UserStore2.default.hasPermission("view_orders")) ? _react2.default.createElement(_statsBlock2.default, {
	              value: overview ? overview.total_paid_count : 0,
	              label: "Paid orders",
	              onTouchTap: function onTouchTap() {
	                return _this3.context.router.push("/event_buckets/" + eventBucket.id + "/orders");
	              }
	            }) : null,
	            _UserStore2.default.hasPermission("manage_orders") || _UserStore2.default.hasPermission("view_orders") ? _react2.default.createElement(_statsBlock2.default, {
	              value: overview ? overview.total_count : 0,
	              label: "Total orders",
	              onTouchTap: function onTouchTap() {
	                return _this3.context.router.push("/event_buckets/" + eventBucket.id + "/orders");
	              }
	            }) : null
	          ),
	          _UserStore2.default.hasRole("box_office") || _UserStore2.default.hasRole("manager") ? _react2.default.createElement(
	            "div",
	            {
	              style: _UserStore2.default.hasRole("manager") ? null : { maxWidth: 400, margin: "0 auto" }
	            },
	            _react2.default.createElement(
	              _statsBlockContainer2.default,
	              null,
	              [_react2.default.createElement(_statsBlock2.default, {
	                value: "Box Office",
	                onTouchTap: function onTouchTap() {
	                  return _this3.context.router.push("/event_buckets/" + eventBucket.id + "/box_office");
	                }
	              })]
	            ),
	            _react2.default.createElement(
	              _statsBlockContainer2.default,
	              null,
	              [_react2.default.createElement(_statsBlock2.default, {
	                value: "People",
	                onTouchTap: function onTouchTap() {
	                  return _this3.context.router.push("/event_buckets/" + eventBucket.id + "/people");
	                }
	              })]
	            ),
	            _react2.default.createElement(
	              _statsBlockContainer2.default,
	              null,
	              [_react2.default.createElement(_statsBlock2.default, {
	                value: "Orders",
	                onTouchTap: function onTouchTap() {
	                  return _this3.context.router.push("/event_buckets/" + eventBucket.id + "/orders");
	                }
	              })]
	            )
	          ) : null
	        ),
	        overview && _UserStore2.default.hasPermission("view_analytics") ? overview.total_paid_count ? _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement(_eventBucketSalesChart2.default, {
	            eventBucket: eventBucket.id,
	            showAllTime: this.state.showAllTime
	          }),
	          _react2.default.createElement(
	            "div",
	            { style: { marginTop: "1.5em", textAlign: "center" } },
	            _react2.default.createElement(_materialUi.RaisedButton, {
	              label: this.state.showAllTime ? "Hide all time sales graphs" : "Show all time sales graphs",
	              onTouchTap: function onTouchTap() {
	                return _this3.setState({ showAllTime: !_this3.state.showAllTime });
	              },
	              labelStyle: { color: "rgb(2, 136, 209)" }
	            })
	          )
	        ) : _react2.default.createElement(_chart2.default, {
	          placeholder: "Detailed sales analytics will be available here as soon as the first " + eventBucket.name + " item is sold!"
	        }) : null
	      );
	    }
	  }], [{
	    key: "getStores",
	    value: function getStores() {
	      return [_EventBucketStore2.default, _AnalyticsStore2.default, _PassBucketStore2.default];
	    }
	  }, {
	    key: "getPropsFromStores",
	    value: function getPropsFromStores() {
	      return {
	        isFetching: _EventBucketStore2.default.getState().isFetching,
	        getEventBucketById: _EventBucketStore2.default.getEventBucketById,
	        getEventBucketOverview: _AnalyticsStore2.default.getEventBucketOverview,
	        getPassBucketsForEventBucket: _PassBucketStore2.default.getPassBucketsForEventBucket,
	        getMembershipsForEventBucket: _PassBucketStore2.default.getMembershipsForEventBucket
	      };
	    }
	  }, {
	    key: "contextTypes",
	    get: function get() {
	      return {
	        router: _react2.default.PropTypes.object
	      };
	    }
	  }]);
	
	  return EventBucket;
	}(_react2.default.Component);
	
	exports.default = (0, _connectToStores2.default)(EventBucket);
	module.exports = exports["default"];

/***/ }),
/* 1784 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _util = __webpack_require__(1183);
	
	var util = _interopRequireWildcard(_util);
	
	var _chart = __webpack_require__(1785);
	
	var _chart2 = _interopRequireDefault(_chart);
	
	var _momentTimezone = __webpack_require__(1185);
	
	var _momentTimezone2 = _interopRequireDefault(_momentTimezone);
	
	var _connectToStores = __webpack_require__(1226);
	
	var _connectToStores2 = _interopRequireDefault(_connectToStores);
	
	var _AnalyticsStore = __webpack_require__(1861);
	
	var _AnalyticsStore2 = _interopRequireDefault(_AnalyticsStore);
	
	var _AnalyticsActions = __webpack_require__(1863);
	
	var _AnalyticsActions2 = _interopRequireDefault(_AnalyticsActions);
	
	var _SalesDataProcessorWorker = __webpack_require__(1864);
	
	var _SalesDataProcessorWorker2 = _interopRequireDefault(_SalesDataProcessorWorker);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PRICE_FORMATTER = function PRICE_FORMATTER() {
	  var factor = arguments.length <= 0 || arguments[0] === undefined ? 1 : arguments[0];
	  return function (p) {
	    return util.formatPrice(p * factor, /* short */true);
	  };
	};
	
	var CHART_OPTIONS = {
	  axis: { y: { tick: { format: PRICE_FORMATTER(100) } } },
	  point: { show: false }
	};
	
	var EventBucketSalesChart = function (_React$Component) {
	  _inherits(EventBucketSalesChart, _React$Component);
	
	  function EventBucketSalesChart(props) {
	    _classCallCheck(this, EventBucketSalesChart);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(EventBucketSalesChart).call(this, props));
	
	    _this.state = {
	      googleHasLoaded: false,
	      sales: null,
	      weekTable: [],
	      dataTable: [],
	      runningTable: []
	    };
	    return _this;
	  }
	
	  _createClass(EventBucketSalesChart, [{
	    key: "componentWillMount",
	    value: function componentWillMount() {
	      _AnalyticsActions2.default.fetchEventBucketSales.defer(this.props.eventBucket);
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(newProps) {
	      var _this2 = this;
	
	      if (newProps.eventBucket !== this.props.eventBucket) {
	        _AnalyticsActions2.default.fetchEventBucketSales.defer(newProps.eventBucket);
	      }
	
	      var sales = this.props.getEventBucketSalesById(this.props.eventBucket) || [];
	
	      if (sales && sales.length && sales !== this.state.sales) {
	        this.setState({ sales: sales });
	
	        var worker = new _SalesDataProcessorWorker2.default();
	        worker.postMessage({ sales: sales });
	        worker.addEventListener("message", function (event) {
	          var _event$data = event.data;
	          var weekResult = _event$data.weekResult;
	          var dataResult = _event$data.dataResult;
	          var runningResult = _event$data.runningResult;
	
	          _this2.setState({ weekResult: weekResult, dataResult: dataResult, runningResult: runningResult });
	        });
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _state = this.state;
	      var weekResult = _state.weekResult;
	      var dataResult = _state.dataResult;
	      var runningResult = _state.runningResult;
	
	      var browserTimezone = _momentTimezone2.default.tz(_momentTimezone2.default.tz.guess()).format('z');
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(_chart2.default, {
	          title: "Net sales (last week, " + browserTimezone + ")",
	          type: "area",
	          indexBy: "timeframe.end",
	          dateFormat: "%b %e",
	          chartOptions: CHART_OPTIONS,
	          data: weekResult
	        }),
	        this.props.showAllTime ? _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement(_chart2.default, {
	            title: "Net sales (all time, " + browserTimezone + ")",
	            type: "area",
	            indexBy: "timeframe.end",
	            dateFormat: "%b %e",
	            chartOptions: CHART_OPTIONS,
	            data: dataResult
	          }),
	          _react2.default.createElement(_chart2.default, {
	            title: "Total net sales (all time, " + browserTimezone + ")",
	            type: "area",
	            indexBy: "timeframe.end",
	            dateFormat: "%b %e",
	            chartOptions: CHART_OPTIONS,
	            data: runningResult
	          })
	        ) : null
	      );
	    }
	  }], [{
	    key: "getStores",
	    value: function getStores() {
	      return [_AnalyticsStore2.default];
	    }
	  }, {
	    key: "getPropsFromStores",
	    value: function getPropsFromStores() {
	      return {
	        getEventBucketSalesById: _AnalyticsStore2.default.getEventBucketSalesById
	      };
	    }
	  }]);
	
	  return EventBucketSalesChart;
	}(_react2.default.Component);
	
	exports.default = (0, _connectToStores2.default)(EventBucketSalesChart);
	module.exports = exports["default"];

/***/ }),
/* 1785 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _keenJs = __webpack_require__(1786);
	
	var _keenJs2 = _interopRequireDefault(_keenJs);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Chart = function (_React$Component) {
	  _inherits(Chart, _React$Component);
	
	  function Chart(props) {
	    _classCallCheck(this, Chart);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(Chart).call(this, props));
	
	    _this.chart = null;
	    return _this;
	  }
	
	  _createClass(Chart, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.componentWillUpdate(this.props);
	    }
	  }, {
	    key: "shouldComponentUpdate",
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      var hasNewData = nextProps.data !== this.props.data || nextProps.placeholder !== this.props.placeholder || nextProps.chartOptions !== this.props.chartOptions;
	      return hasNewData;
	    }
	  }, {
	    key: "componentWillUpdate",
	    value: function componentWillUpdate(newProps) {
	      if (!this.chart) {
	        this.chart = new _keenJs2.default.Dataviz().el(this.el);
	      }
	
	      var chart = this.chart;
	      var data = newProps.data;
	      var placeholder = newProps.placeholder;
	
	      var rest = _objectWithoutProperties(newProps, ["data", "placeholder"]);
	
	      if (!chart) {
	        return;
	      }
	
	      if (placeholder) {
	        rest.type = "message";
	      }
	
	      chart.attributes(rest).prepare();
	
	      if (data) {
	        chart.data(data).render();
	      } else if (placeholder) {
	        chart.render().message(placeholder);
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var placeholder = this.props.placeholder;
	
	      return _react2.default.createElement("div", {
	        ref: function ref(r) {
	          _this2.el = r;
	        },
	        className: placeholder && "Chart--has-placeholder"
	      });
	    }
	  }]);
	
	  return Chart;
	}(_react2.default.Component);
	
	Chart.defaultProps = {
	  type: "line",
	  height: 300
	};
	
	exports.default = Chart;
	module.exports = exports["default"];

/***/ }),
/* 1786 */
/***/ (function(module, exports, __webpack_require__) {

	var KeenBase = __webpack_require__(1787);
	KeenBase.extendLibrary(KeenBase, __webpack_require__(1818));
	KeenBase.Dataviz = __webpack_require__(1830);
	KeenBase.Dataset = __webpack_require__(1831);
	KeenBase.version = __webpack_require__(1860).version;
	
	KeenBase.prototype.draw = function(query, el, attributes){
	  var chart = KeenBase.Dataviz()
	    .attributes(attributes)
	    .el(el)
	    .prepare();
	
	  this.run(query, function(err, res){
	    if (err) {
	      chart.message(err.message);
	    }
	    else {
	      chart.data(res).render();
	    }
	  });
	  return chart;
	};
	
	module.exports = KeenBase;


/***/ }),
/* 1787 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(global) {(function(env) {
	  'use strict';
	
	  var KeenCore = __webpack_require__(1788);
	  var each = __webpack_require__(1794);
	  var extend = __webpack_require__(1795);
	  var listener = __webpack_require__(1797)(KeenCore);
	
	  // ------------------------
	  // Methods
	  // ------------------------
	  extend(KeenCore.prototype, __webpack_require__(1798));
	  extend(KeenCore.prototype, __webpack_require__(1803));
	  extend(KeenCore.prototype, {
	    'extendEvent'      : __webpack_require__(1801).extendEvent,
	    'extendEvents'     : __webpack_require__(1801).extendEvents
	  });
	
	  // ------------------------
	  // Auto-Tracking
	  // ------------------------
	  extend(KeenCore.prototype, {
	    'initAutoTracking': __webpack_require__(1804)(KeenCore)
	  });
	
	  // ------------------------
	  // Deprecated
	  // ------------------------
	  KeenCore.prototype.trackExternalLink = trackExternalLink;
	
	  // ------------------------
	  // Helpers
	  // ------------------------
	  extend(KeenCore.helpers, {
	    'getBrowserProfile'  : __webpack_require__(1806),
	    'getDatetimeIndex'   : __webpack_require__(1809),
	    'getDomNodePath'     : __webpack_require__(1810),
	    'getDomNodeProfile'  : __webpack_require__(1811),
	    'getScreenProfile'   : __webpack_require__(1807),
	    'getScrollState'     : __webpack_require__(1812),
	    'getUniqueId'        : __webpack_require__(1813),
	    'getWindowProfile'   : __webpack_require__(1808)
	  });
	
	  // ------------------------
	  // Utils
	  // ------------------------
	  extend(KeenCore.utils, {
	    'cookie'        : __webpack_require__(1814),
	    'deepExtend'    : __webpack_require__(1802),
	    'listener'      : listener,
	    'serializeForm' : __webpack_require__(1816),
	    'timer'         : __webpack_require__(1817)
	  });
	
	  KeenCore.listenTo = function(listenerHash){
	    each(listenerHash, function(callback, key){
	      var split = key.split(' ');
	      var eventType = split[0],
	          selector = split.slice(1, split.length).join(' ');
	      // Create an unassigned listener
	      return listener(selector).on(eventType, callback);
	    });
	  };
	
	  // ------------------------------
	  // DEPRECATED
	  // Apply client.globalProperties
	  // ------------------------------
	  function trackExternalLink(jsEvent, eventCollection, payload, timeout, timeoutCallback){
	    this.emit('error', 'This method has been deprecated. Check out DOM listeners: https://github.com/keen/keen-tracking.js#listeners');
	    var evt = jsEvent,
	      target = (evt.currentTarget) ? evt.currentTarget : (evt.srcElement || evt.target),
	      timer = timeout || 500,
	      triggered = false,
	      targetAttr = '',
	      callback,
	      win;
	    if (target.getAttribute !== void 0) {
	      targetAttr = target.getAttribute('target');
	    } else if (target.target) {
	      targetAttr = target.target;
	    }
	    if ((targetAttr == '_blank' || targetAttr == 'blank') && !evt.metaKey) {
	      win = window.open('about:blank');
	      win.document.location = target.href;
	    }
	    if (target.nodeName === 'A') {
	      callback = function(){
	        if(!triggered && !evt.metaKey && (targetAttr !== '_blank' && targetAttr !== 'blank')){
	          triggered = true;
	          window.location = target.href;
	        }
	      };
	    }
	    else if (target.nodeName === 'FORM') {
	      callback = function(){
	        if(!triggered){
	          triggered = true;
	          target.submit();
	        }
	      };
	    }
	    else {
	      this.trigger('error', '#trackExternalLink method not attached to an <a> or <form> DOM element');
	    }
	    if (timeoutCallback) {
	      callback = function(){
	        if(!triggered){
	          triggered = true;
	          timeoutCallback();
	        }
	      };
	    }
	    this.recordEvent(eventCollection, payload, callback);
	    setTimeout(callback, timer);
	    if (!evt.metaKey) {
	      return false;
	    }
	  }
	
	  // IE-specific polyfills, yay!
	  // -----------------------------
	  if (!Array.prototype.indexOf){
	    Array.prototype.indexOf = function(elt /*, from*/) {
	      var len = this.length >>> 0;
	
	      var from = Number(arguments[1]) || 0;
	      from = (from < 0)
	           ? Math.ceil(from)
	           : Math.floor(from);
	      if (from < 0)
	        from += len;
	
	      for (; from < len; from++) {
	        if (from in this &&
	            this[from] === elt)
	          return from;
	      }
	      return -1;
	    };
	  }
	
	
	  // Module Definitions
	  // --------------------
	
	  // CommonJS
	  if (typeof module !== 'undefined' && module.exports) {
	    module.exports = KeenCore;
	  }
	
	  // RequireJS
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function(){
	      return KeenCore;
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  }
	  env.Keen = KeenCore.extendLibrary(KeenCore);
	
	}).call(this, typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {});
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 1788 */
/***/ (function(module, exports, __webpack_require__) {

	var KeenCore = __webpack_require__(1789);
	
	var each = __webpack_require__(1794),
	    extend = __webpack_require__(1795),
	    queue = __webpack_require__(1796);
	
	KeenCore.helpers = KeenCore.helpers || {};
	
	// Install internal queue
	KeenCore.on('client', function(client){
	  client.extensions = {
	    events: [],
	    collections: {}
	  };
	  client.queue = queue();
	  client.queue.on('flush', function(){
	    client.recordDeferredEvents();
	  });
	});
	
	// Accessors
	KeenCore.prototype.writeKey = function(str){
	  if (!arguments.length) return this.config.writeKey;
	  this.config.writeKey = (str ? String(str) : null);
	  return this;
	};
	
	// DEPRECATED
	KeenCore.prototype.setGlobalProperties = function(props){
	  KeenCore.log('This method has been deprecated. Check out #extendEvents: https://github.com/keen/keen-tracking.js#extend-events');
	  if (!props || typeof props !== 'function') {
	    this.emit('error', 'Invalid value for global properties: ' + props);
	    return;
	  }
	  this.config.globalProperties = props;
	  return this;
	};
	
	module.exports = KeenCore;


/***/ }),
/* 1789 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {(function(env){
	  var previousKeen = env.Keen || undefined;
	  var each = __webpack_require__(1790),
	      extend = __webpack_require__(1791),
	      parseParams = __webpack_require__(1792),
	      serialize = __webpack_require__(1793);
	
	  var Emitter = __webpack_require__(1169);
	
	  function Client(props){
	    if (this instanceof Client === false) {
	      return new Client(props);
	    }
	    this.configure(props);
	
	    // Set up event handling
	    if (Client.debug) {
	      this.on('error', Client.log);
	    }
	    this.emit('ready');
	    Client.emit('client', this);
	  }
	
	  if (previousKeen && typeof previousKeen.resources === 'undefined') {
	    Client.legacyVersion = previousKeen;
	  }
	
	  Emitter(Client);
	  Emitter(Client.prototype);
	
	  extend(Client, {
	    debug: false,
	    enabled: true,
	    loaded: false,
	    version: '__VERSION__'
	  });
	
	  // Set or extend helpers
	  Client.helpers = Client.helpers || {};
	
	  // Set or extend resources
	  Client.resources = Client.resources || {};
	  extend(Client.resources, {
	    'base'      : '{protocol}://{host}',
	    'version'   : '{protocol}://{host}/3.0',
	    'projects'  : '{protocol}://{host}/3.0/projects',
	    'projectId' : '{protocol}://{host}/3.0/projects/{projectId}',
	    'events'    : '{protocol}://{host}/3.0/projects/{projectId}/events',
	    'queries'   : '{protocol}://{host}/3.0/projects/{projectId}/queries'
	  });
	
	  // Set or extend utils
	  Client.utils = Client.utils || {};
	  extend(Client.utils, {
	    'each'        : each,
	    'extend'      : extend,
	    'parseParams' : parseParams,
	    'serialize'   : serialize
	  });
	
	  Client.extendLibrary = function(target, source) {
	    var previous = previousKeen || source;
	    if (isDefined(previous) && isDefined(previous.resources)) {
	      each(previous, function(value, key) {
	        if (typeof value === 'object') {
	          target[key] = target[key] || {};
	          extend(target[key], value);
	        }
	        else {
	          target[key] = target[key] || value;
	        }
	      });
	      extend(target.prototype, previous.prototype);
	    }
	    return target;
	  };
	
	  Client.log = function(str){
	    if (Client.debug && typeof console === 'object') {
	      console.log('[Keen]', str);
	    }
	  };
	
	  Client.noConflict = function(){
	    if (typeof env.Keen !== 'undefined') {
	      env.Keen = Client.legacyVersion || previousKeen;
	    }
	    return Client;
	  };
	
	  Client.ready = function(fn){
	    if (Client.loaded) {
	      fn();
	    }
	    else {
	      Client.once('ready', fn);
	    }
	  };
	
	  Client.prototype.configure = function(obj){
	    var config = obj || {};
	    this.config = this.config || {
	      projectId    : undefined,
	      writeKey     : undefined,
	      host         : 'api.keen.io',
	      protocol     : 'https',
	      requestType  : 'jsonp',
	      resources    : extend({}, Client.resources)
	    };
	
	    // IE<10 request shim
	    if (typeof window !== 'undefined' && window.navigator && window.navigator.userAgent && window.navigator.userAgent.indexOf('MSIE') > -1) {
	      config.protocol = document.location.protocol.replace(':', '');
	    }
	
	    if (config.host) {
	      config.host.replace(/.*?:\/\//g, '');
	    }
	
	    extend(this.config, config);
	    return this;
	  };
	
	  Client.prototype.masterKey = function(str){
	    if (!arguments.length) return this.config.masterKey;
	    this.config.masterKey = str ? String(str) : null;
	    return this;
	  };
	
	  Client.prototype.projectId = function(str){
	    if (!arguments.length) return this.config.projectId;
	    this.config.projectId = (str ? String(str) : null);
	    return this;
	  };
	
	  Client.prototype.resources = function(obj){
	    if (!arguments.length) return this.config.resources;
	    var self = this;
	    if (typeof obj === 'object') {
	      each(obj, function(value, key){
	        self.config.resources[key] = (value ? value : null);
	      });
	    }
	    return self;
	  };
	
	  Client.prototype.url = function(name){
	    var args = Array.prototype.slice.call(arguments, 1),
	        baseUrl = this.config.resources.base || '{protocol}://{host}',
	        path;
	
	    if (name && typeof name === 'string') {
	      if (this.config.resources[name]) {
	        path = this.config.resources[name];
	      }
	      else {
	        path = baseUrl + name;
	      }
	    }
	    else {
	      path = baseUrl;
	    }
	
	    each(this.config, function(value, key){
	      if (typeof value !== 'object') {
	        path = path.replace('{' + key + '}', value);
	      }
	    });
	
	    each(args, function(arg, i){
	      if (typeof arg === 'string') {
	        path += '/' + arg;
	      }
	      else if (typeof arg === 'object') {
	        path += '?';
	        each(arg, function(value, key){
	          path += key + '=' + value + '&';
	        });
	        path = path.slice(0, -1);
	      }
	    });
	
	    return path;
	  };
	
	  domReady(function(){
	    Client.loaded = true;
	    Client.emit('ready');
	  });
	
	  function domReady(fn){
	    if (Client.loaded || typeof document === 'undefined') {
	      fn();
	      return;
	    }
	    // Firefox 3.5 shim
	    if(document.readyState == null && document.addEventListener){
	      document.addEventListener('DOMContentLoaded', function DOMContentLoaded(){
	        document.removeEventListener('DOMContentLoaded', DOMContentLoaded, false);
	        document.readyState = 'complete';
	      }, false);
	      document.readyState = 'loading';
	    }
	    testDom(fn);
	  }
	
	  function testDom(fn){
	    if (/in/.test(document.readyState)) {
	      setTimeout(function(){
	        testDom(fn);
	      }, 9);
	    }
	    else {
	      fn();
	    }
	  }
	
	  function isDefined(target) {
	    return typeof target !== 'undefined';
	  }
	
	  function isUndefined(target) {
	    return typeof target === 'undefined';
	  }
	
	  module.exports = Client;
	
	}).call(this, typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {});
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 1790 */
/***/ (function(module, exports) {

	module.exports = each;
	
	function each(o, cb, s){
	  var n;
	  if (!o){
	    return 0;
	  }
	  s = !s ? o : s;
	  if (o instanceof Array){
	    // Indexed arrays, needed for Safari
	    for (n=0; n<o.length; n++) {
	      if (cb.call(s, o[n], n, o) === false){
	        return 0;
	      }
	    }
	  } else {
	    // Hashtables
	    for (n in o){
	      if (o.hasOwnProperty(n)) {
	        if (cb.call(s, o[n], n, o) === false){
	          return 0;
	        }
	      }
	    }
	  }
	  return 1;
	}


/***/ }),
/* 1791 */
/***/ (function(module, exports) {

	module.exports = extend;
	
	function extend(target){
	  for (var i = 1; i < arguments.length; i++) {
	    for (var prop in arguments[i]){
	      target[prop] = arguments[i][prop];
	    }
	  }
	  return target;
	};


/***/ }),
/* 1792 */
/***/ (function(module, exports) {

	module.exports = parseParams;
	
	function parseParams(str){
	  // via: http://stackoverflow.com/a/2880929/2511985
	  var urlParams = {},
	      match,
	      pl     = /\+/g,  // Regex for replacing addition symbol with a space
	      search = /([^&=]+)=?([^&]*)/g,
	      decode = function (s) { return decodeURIComponent(s.replace(pl, " ")); },
	      query  = str.split("?")[1];
	
	  while (!!(match=search.exec(query))) {
	    urlParams[decode(match[1])] = decode(match[2]);
	  }
	  return urlParams;
	};


/***/ }),
/* 1793 */
/***/ (function(module, exports, __webpack_require__) {

	var each = __webpack_require__(1790),
	    extend = __webpack_require__(1791);
	
	module.exports = serialize;
	
	function serialize(data){
	  var query = [];
	  each(data, function(value, key){
	    if ('string' !== typeof value) {
	      value = JSON.stringify(value);
	    }
	    query.push(key + '=' + encodeURIComponent(value));
	  });
	  return query.join('&');
	}


/***/ }),
/* 1794 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1790);


/***/ }),
/* 1795 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1791);


/***/ }),
/* 1796 */
/***/ (function(module, exports, __webpack_require__) {

	var Emitter = __webpack_require__(1169);
	
	function queue() {
	  if (this instanceof queue === false) {
	    return new queue();
	  }
	  this.capacity = 0;
	  this.config = {
	    capacity: 5000,
	    interval: 15
	  };
	  this.events = {
	    // "collection-1": [],
	    // "collection-2": []
	  };
	  this.interval = 0;
	  this.timer = null;
	  return this;
	}
	
	Emitter(queue.prototype);
	
	queue.prototype.check = function() {
	  if (shouldFlushQueue(this)) {
	    this.flush();
	  }
	  if (this.config.interval === 0 || this.capacity === 0) {
	    this.pause();
	  }
	  return this;
	};
	
	queue.prototype.flush = function() {
	  this.emit('flush');
	  this.interval = 0;
	  return this;
	};
	
	queue.prototype.pause = function() {
	  if (this.timer) {
	    clearInterval(this.timer);
	    this.timer = null;
	  }
	  return this;
	};
	
	queue.prototype.start = function() {
	  var self = this;
	  self.pause();
	  self.timer = setInterval(function() {
	    self.interval++;
	    self.check();
	  }, 1000);
	  return self;
	};
	
	function shouldFlushQueue(props) {
	  if (props.capacity > 0 && props.interval >= props.config.interval) {
	    return true;
	  }
	  else if (props.capacity >= props.config.capacity) {
	    return true;
	  }
	  return false;
	}
	
	module.exports = queue;


/***/ }),
/* 1797 */
/***/ (function(module, exports, __webpack_require__) {

	var Emitter = __webpack_require__(1169);
	
	var each = __webpack_require__(1794);
	
	/*
	
	  // Create a new element listner
	  var myClickerCatcher = Keen.utils.listener(".nav li > a");
	
	  // Listen for a given event
	  myClicker.on("click", function(e){
	    // do stuff!
	  });
	
	  // Listen for event once
	  myClicker.once("click", function(e){ });
	
	  // Cancel a given event listener
	  myClicker.off("click");
	
	  // Cancel all event listners
	  myClicker.off();
	
	*/
	
	module.exports = function(ctx){
	
	  // Make sure this object exists
	  ctx.domListeners = ctx.domListeners || {
	    /*
	    'click': {
	      '.nav li > a': [fn, fn, fn]
	    }
	    */
	  };
	
	  function listener(str){
	    if (!str) return;
	    if (this instanceof listener === false) {
	      return new listener(str);
	    }
	    this.selector = str;
	    return this;
	  }
	
	  listener.prototype.on = function(str, fn){
	    var self = this;
	
	    if (arguments.length !== 2 || 'string' !== typeof str || 'function' !== typeof fn) return this;
	
	    // Set each listener on a parent dictionary, indexed by event:
	    if ('undefined' === typeof ctx.domListeners[str]) {
	      addListener(str, eventHandler(str));
	      ctx.domListeners[str] = {};
	    }
	    ctx.domListeners[str][self.selector] = ctx.domListeners[str][self.selector] || [];
	    ctx.domListeners[str][self.selector].push(fn);
	    return self;
	  };
	
	  listener.prototype.once = function(str, fn){
	    var self = this;
	    function on() {
	      self.off(str, on);
	      return fn.apply(self, arguments);
	    }
	    on.fn = fn;
	    self.on(str, on);
	    return self;
	  };
	
	  listener.prototype.off = function(str, fn){
	    var self = this, survivors = [];
	    if (arguments.length === 2) {
	      each(ctx.domListeners[str][self.selector], function(handler, i){
	        if (handler === fn || handler.fn === fn) return;
	        survivors.push(handler);
	      });
	      ctx.domListeners[str][self.selector] = survivors;
	    }
	    else if (arguments.length === 1) {
	      try {
	        delete ctx.domListeners[str][self.selector];
	      }
	      catch(e){
	        ctx.domListeners[str][self.selector] = [];
	      }
	    }
	    else {
	      // loop over every eventType and delete handlers
	      each(ctx.domListeners, function(hash, eventType){
	        // if ('undefined' === typeof hash[str]) return;
	        try {
	          delete ctx.domListeners[eventType][self.selector];
	        }
	        catch(e){
	          ctx.domListeners[eventType][self.selector] = function(){};
	        }
	      });
	    }
	    return self;
	  };
	
	  function eventHandler(eventType){
	    return function(e){
	      var evt, target;
	
	      evt = e || window.event;
	      target = evt.target || evt.srcElement;
	
	      // If nothing assigned to this event type, let it go
	      if ('undefined' === ctx.domListeners[eventType]) return;
	
	      each(ctx.domListeners[eventType], function(handlers, key){
	
	        if (matches(target, key)) {
	          // Call all handlers for this eventType + node
	          each(handlers, function(fn, i){
	            if ('click' === eventType && 'A' === target.nodeName) {
	              deferClickEvent(evt, target, fn);
	            }
	            else if ('submit' === eventType && 'FORM' === target.nodeName) {
	              deferFormSubmit(evt, target, fn);
	            }
	            else {
	              fn(evt);
	            }
	          });
	        }
	        else if ('window' === key) {
	          // Call all handlers
	          each(handlers, function(fn, i){
	            fn(evt);
	          });
	        }
	        return;
	      });
	    };
	  }
	
	  return listener;
	}
	
	
	// ------------------------------
	// Attach global event listener
	// ------------------------------
	
	function addListener(eventType, fn){
	  if (document.addEventListener) {
	    document.addEventListener(eventType, fn, false);
	  } else {
	    document.attachEvent("on" + eventType, fn);
	  }
	}
	
	
	// ------------------------------
	// Match DOM element to selector
	// ------------------------------
	
	function matches(elem, selector) {
	  // We'll use querySelectorAll to find all element matching the selector,
	  // then check if the given element is included in that list.
	  // Executing the query on the parentNode reduces the resulting nodeList,
	  // document doesn't have a parentNode, though.
	  var nodeList = ( elem.parentNode || document ).querySelectorAll( selector ) || [],
	      i = nodeList.length;
	
	  // loop on the nodeList
	  while ( i-- ) {
	    if ( nodeList[i] == elem ) { return true; }
	  }
	  return false;
	}
	
	
	// ------------------------------
	// Handle 'click' events (A)
	// ------------------------------
	
	function deferClickEvent(evt, anchor, callback){
	  var timeout = 500,
	      targetAttr,
	      cbResponse;
	
	  // Get 'target' attribute from anchor
	  if (anchor.getAttribute !== void 0) {
	    targetAttr = anchor.getAttribute("target");
	  } else if (anchor.target) {
	    targetAttr = anchor.target;
	  }
	
	  // Fire listener and catch possible response (return false)
	  cbResponse = callback(evt);
	
	  // If prevented within callback, bail:
	  if (('boolean' === typeof cbResponse && cbResponse === false) || evt.defaultPrevented || evt.returnValue === false) {
	    if (evt.preventDefault) {
	      evt.preventDefault();
	    }
	    evt.returnValue = false;
	    return false;
	  }
	  // Else if anchor doesn't kick off a new window or tab.. defer and replay the event:
	  else if (targetAttr !== '_blank' && targetAttr !== 'blank' && !evt.metaKey) {
	    if (evt.preventDefault) {
	      evt.preventDefault();
	    }
	    evt.returnValue = false;
	    setTimeout(function(){
	      window.location = anchor.href;
	    }, timeout);
	  }
	
	  return false;
	}
	
	
	// ------------------------------
	// Handle 'submit' events (FORM)
	// ------------------------------
	
	function deferFormSubmit(evt, form, callback){
	  var timeout = 500;
	
	  // Fire listener and catch possible response (return false)
	  var cbResponse = callback(evt);
	
	  // If prevented within callback, bail
	  if (('boolean' === typeof cbResponse && cbResponse === false) || evt.defaultPrevented || evt.returnValue === false) {
	    if (evt.preventDefault) {
	      evt.preventDefault();
	    }
	    evt.returnValue = false;
	    return false;
	  }
	  // Defer and replay event
	  else {
	    if (evt.preventDefault) {
	      evt.preventDefault();
	    }
	    evt.returnValue = false;
	    setTimeout(function(){
	      form.submit();
	    }, timeout);
	  }
	
	  return false;
	}


/***/ }),
/* 1798 */
/***/ (function(module, exports, __webpack_require__) {

	var Keen = __webpack_require__(1788);
	var base64 = __webpack_require__(1799);
	var each = __webpack_require__(1794);
	var extend = __webpack_require__(1795);
	var extendEvents = __webpack_require__(1801);
	
	module.exports = {
	  'recordEvent': recordEvent,
	  'recordEvents': recordEvents,
	
	  // DEPRECATED
	  'addEvent': addEvent,
	  'addEvents': addEvents
	};
	
	// ------------------------------
	// .recordEvent
	// ------------------------------
	
	function recordEvent(eventCollection, eventBody, callback, async){
	  var url, data, cb, getRequestUrl, getRequestUrlOkLength, extendedEventBody, isAsync;
	
	  url = this.url('events', encodeURIComponent(eventCollection));
	  data = {};
	  cb = callback;
	
	  // Requests are asynchronous by default
	  isAsync = ('boolean' === typeof async) ? async : true;
	
	  if (!checkValidation.call(this, cb)) {
	    return;
	  }
	
	  if (!eventCollection || typeof eventCollection !== 'string') {
	    handleValidationError.call(this, 'Collection name must be a string.', cb);
	    return;
	  }
	
	  // ------------------------------
	  // DEPRECATED
	  // Apply client.globalProperties
	  // ------------------------------
	  if (this.config.globalProperties) {
	    data = this.config.globalProperties(eventCollection);
	  }
	  extend(data, eventBody);
	
	  // ------------------------------
	  // Run extendEvent(s) transforms
	  // ------------------------------
	  extendedEventBody = {};
	  extendEvents.getExtendedEventBody(extendedEventBody, this.extensions.events);
	  extendEvents.getExtendedEventBody(extendedEventBody, this.extensions.collections[eventCollection]);
	  extendEvents.getExtendedEventBody(extendedEventBody, [data]);
	
	  this.emit('recordEvent', eventCollection, extendedEventBody);
	
	  if (!Keen.enabled) {
	    handleValidationError.call(this, 'Keen.enabled is set to false.', cb);
	    return false;
	  }
	
	  // ------------------------------
	  // Send event
	  // ------------------------------
	
	  getRequestUrl = this.url('events', encodeURIComponent(eventCollection), {
	    api_key  : this.writeKey(),
	    data     : encodeURIComponent( base64.encode( JSON.stringify(extendedEventBody) ) ),
	    modified : new Date().getTime()
	  });
	  getRequestUrlOkLength = getRequestUrl.length < getUrlMaxLength();
	
	  if (isAsync) {
	    switch (this.config.requestType) {
	      case 'xhr':
	        sendXhr.call(this, 'POST', url, extendedEventBody, cb);
	        break;
	      case 'beacon':
	        if (getRequestUrlOkLength) {
	          sendBeacon.call(this, getRequestUrl, cb);
	        }
	        else {
	          attemptPostXhr.call(this, url, extendedEventBody,
	              'Beacon URL length exceeds current browser limit, and XHR is not supported.', cb)
	        }
	        break;
	      default:
	        if (getRequestUrlOkLength) {
	          sendJSONp.call(this, getRequestUrl, cb);
	        }
	        else {
	          attemptPostXhr.call(this, url, extendedEventBody,
	              'JSONp URL length exceeds current browser limit, and XHR is not supported.', cb)
	        }
	        break;
	    }
	  }
	  else {
	    // Send synchronous request
	    if (getRequestUrlOkLength) {
	      sendSynchronousXhr(getRequestUrl);
	    }
	  }
	
	  callback = cb = null;
	  return this;
	}
	
	// ------------------------------
	// .recordEvents
	// ------------------------------
	
	function recordEvents(eventsHash, callback){
	  var self = this, url, cb, extendedEventsHash;
	
	  url = this.url('events');
	  cb = callback;
	  callback = null;
	
	  if (!checkValidation.call(this, cb)) {
	    return;
	  }
	
	  if ('object' !== typeof eventsHash || eventsHash instanceof Array) {
	    handleValidationError.call(this, 'First argument must be an object', cb);
	    return;
	  }
	
	  if (arguments.length > 2) {
	    handleValidationError.call(this, 'Incorrect arguments provided to #recordEvents method', cb);
	    return;
	  }
	
	  // ------------------------------
	  // DEPRECATED
	  // Apply client.globalProperties
	  // ------------------------------
	  if (this.config.globalProperties) {
	    // Loop over each set of events
	    each(eventsHash, function(events, collection){
	      // Loop over each individual event
	      each(events, function(body, index){
	        // Start with global properties for this collection
	        var modified = self.config.globalProperties(collection);
	        // Apply provided properties for this event body
	        eventsHash[collection][index] = extend(modified, body);
	      });
	    });
	  }
	
	  // ------------------------------
	  // Run extendEvent(s) transforms
	  // ------------------------------
	  extendedEventsHash = {};
	  each(eventsHash, function(eventList, eventCollection){
	    // Find or create collection on new hash
	    extendedEventsHash[eventCollection] = extendedEventsHash[eventCollection] || [];
	    // Loop over each eventBody in the existing hash
	    each(eventList, function(eventBody, index){
	      // Create a new data object
	      var extendedEventBody = {};
	      // Process "events" transform pipeline
	      extendEvents.getExtendedEventBody(extendedEventBody, self.extensions.events);
	      // Process "collection" transform pipeline
	      extendEvents.getExtendedEventBody(extendedEventBody, self.extensions.collections[eventCollection]);
	      // Blend existing eventBody data into the result
	      extendEvents.getExtendedEventBody(extendedEventBody, [eventBody]);
	      // Push extendedEventBody into new hash
	      extendedEventsHash[eventCollection].push(extendedEventBody);
	    });
	  });
	
	  this.emit('recordEvents', extendedEventsHash);
	
	  if (!Keen.enabled) {
	    handleValidationError.call(this, 'Keen.enabled is set to false.', cb);
	    return false;
	  }
	
	  if (getXhr()) {
	    sendXhr.call(this, 'POST', url, extendedEventsHash, cb);
	  }
	  else {
	    // each(eventsHash, function(eventArray, eventCollection){
	    //    ... send each individually?
	    // });
	  }
	
	  callback = cb = null;
	  return this;
	}
	
	
	// ----------------------
	// DEPRECATED
	// ----------------------
	
	function addEvent(){
	  this.emit('error', 'This method has been deprecated. Check out #recordEvent: https://github.com/keen/keen-tracking.js#record-a-single-event');
	  recordEvent.apply(this, arguments);
	}
	
	function addEvents(){
	  this.emit('error', 'This method has been deprecated. Check out #recordEvents: https://github.com/keen/keen-tracking.js#record-multiple-events');
	  recordEvents.apply(this, arguments);
	}
	
	
	// ------------------------------
	// Validation
	// ------------------------------
	
	function checkValidation(callback){
	  var cb = callback;
	  callback = null;
	
	  if (!this.projectId()) {
	    handleValidationError.call(this, 'Keen.Client is missing a projectId property.', cb);
	    return false;
	  }
	  if (!this.writeKey()) {
	    handleValidationError.call(this, 'Keen.Client is missing a writeKey property.', cb);
	    return false;
	  }
	  return true;
	}
	
	function handleValidationError(message, cb){
	  var err = 'Event(s) not recorded: ' + message;
	  this.emit('error', err);
	  if (cb) {
	    cb.call(this, err, null);
	    cb = null;
	  }
	}
	
	function getUrlMaxLength(){
	  if ('undefined' !== typeof window && navigator) {
	    if (navigator.userAgent.indexOf('MSIE') !== -1 || navigator.appVersion.indexOf('Trident/') > 0) {
	      return 2000;
	    }
	  }
	  return 16000;
	}
	
	
	// ------------------------------
	// XHR Requests
	// ------------------------------
	
	function attemptPostXhr(url, data, noXhrError, callback) {
	  if (getXhr()) {
	    sendXhr.call(this, 'POST', url, data, callback);
	  }
	  else {
	    handleValidationError.call(this, noXhrError);
	  }
	}
	
	function sendXhr(method, url, data, callback){
	  var self = this;
	  var payload;
	  var xhr = getXhr();
	  var cb = callback;
	  callback = null;
	
	  xhr.onreadystatechange = function() {
	    var response;
	    if (xhr.readyState == 4) {
	      if (xhr.status >= 200 && xhr.status < 300) {
	        try {
	          response = JSON.parse( xhr.responseText );
	        } catch (e) {
	          Keen.emit('error', 'Could not parse HTTP response: ' + xhr.responseText);
	          if (cb) {
	            cb.call(self, xhr, null);
	          }
	        }
	        if (cb && response) {
	          cb.call(self, null, response);
	        }
	      }
	      else {
	        Keen.emit('error', 'HTTP request failed.');
	        if (cb) {
	          cb.call(self, xhr, null);
	        }
	      }
	    }
	  };
	
	  xhr.open(method, url, true);
	  xhr.setRequestHeader('Authorization', self.writeKey());
	  xhr.setRequestHeader('Content-Type', 'application/json');
	
	  if (data) {
	    payload = JSON.stringify(data);
	  }
	
	  if (method.toUpperCase() === 'GET') {
	    xhr.send();
	  }
	  if (method.toUpperCase() === 'POST') {
	    xhr.send(payload);
	  }
	
	}
	
	function sendSynchronousXhr(url){
	  var xhr = getXhr();
	  if (xhr) {
	    xhr.open('GET', url, false);
	    xhr.send(null);
	  }
	}
	
	function getXhr() {
	  // yay, superagent!
	  var root = 'undefined' == typeof window ? this : window;
	  if (root.XMLHttpRequest && ('file:' != root.location.protocol || !root.ActiveXObject)) {
	    return new XMLHttpRequest;
	  } else {
	    try { return new ActiveXObject('Microsoft.XMLHTTP'); } catch(e) {}
	    try { return new ActiveXObject('Msxml2.XMLHTTP.6.0'); } catch(e) {}
	    try { return new ActiveXObject('Msxml2.XMLHTTP.3.0'); } catch(e) {}
	    try { return new ActiveXObject('Msxml2.XMLHTTP'); } catch(e) {}
	  }
	  return false;
	};
	
	
	// ------------------------------
	// JSON-P Requests
	// ------------------------------
	
	function sendJSONp(url, callback){
	  var self = this,
	      cb = callback,
	      timestamp = new Date().getTime(),
	      script = document.createElement('script'),
	      parent = document.getElementsByTagName('head')[0],
	      callbackName = 'keenJSONPCallback',
	      loaded = false;
	
	  callback = null;
	
	  callbackName += timestamp;
	  while (callbackName in window) {
	    callbackName += 'a';
	  }
	  window[callbackName] = function(response) {
	    if (loaded === true) return;
	    loaded = true;
	    if (cb) {
	      cb.call(self, null, response);
	    }
	    cleanup();
	  };
	  script.src = url + '&jsonp=' + callbackName;
	  parent.appendChild(script);
	
	  // for early IE w/ no onerror event
	  script.onreadystatechange = function() {
	    if (loaded === false && this.readyState === 'loaded') {
	      loaded = true;
	      handleError();
	      cleanup();
	    }
	  };
	  // non-ie, etc
	  script.onerror = function() {
	    // on IE9 both onerror and onreadystatechange are called
	    if (loaded === false) {
	      loaded = true;
	      handleError();
	      cleanup();
	    }
	  };
	
	  function handleError(){
	    if (cb) {
	      cb.call(self, 'An error occurred!', null);
	    }
	  }
	
	  function cleanup(){
	    window[callbackName] = undefined;
	    try {
	      delete window[callbackName];
	    } catch(e){};
	    parent.removeChild(script);
	  }
	
	}
	
	
	// ------------------------------
	// Image Beacon Requests
	// ------------------------------
	
	function sendBeacon(url, callback){
	  var self = this,
	      cb = callback,
	      img = document.createElement('img'),
	      loaded = false;
	
	  callback = null;
	
	  img.onload = function() {
	    loaded = true;
	    if ('naturalHeight' in this) {
	      if (this.naturalHeight + this.naturalWidth === 0) {
	        this.onerror();
	        return;
	      }
	    } else if (this.width + this.height === 0) {
	      this.onerror();
	      return;
	    }
	    if (cb) {
	      cb.call(self);
	    }
	  };
	  img.onerror = function() {
	    loaded = true;
	    if (cb) {
	      cb.call(self, 'An error occurred!', null);
	    }
	  };
	  img.src = url + '&c=clv1';
	}


/***/ }),
/* 1799 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1800);


/***/ }),
/* 1800 */
/***/ (function(module, exports) {

	module.exports = {
	  map: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",
	  encode: function (n) {
	    "use strict";
	    var o = "", i = 0, m = this.map, i1, i2, i3, e1, e2, e3, e4;
	    n = this.utf8.encode(n);
	    while (i < n.length) {
	      i1 = n.charCodeAt(i++); i2 = n.charCodeAt(i++); i3 = n.charCodeAt(i++);
	      e1 = (i1 >> 2); e2 = (((i1 & 3) << 4) | (i2 >> 4)); e3 = (isNaN(i2) ? 64 : ((i2 & 15) << 2) | (i3 >> 6));
	      e4 = (isNaN(i2) || isNaN(i3)) ? 64 : i3 & 63;
	      o = o + m.charAt(e1) + m.charAt(e2) + m.charAt(e3) + m.charAt(e4);
	    } return o;
	  },
	  decode: function (n) {
	    "use strict";
	    var o = "", i = 0, m = this.map, cc = String.fromCharCode, e1, e2, e3, e4, c1, c2, c3;
	    n = n.replace(/[^A-Za-z0-9\+\/\=]/g, "");
	    while (i < n.length) {
	      e1 = m.indexOf(n.charAt(i++)); e2 = m.indexOf(n.charAt(i++));
	      e3 = m.indexOf(n.charAt(i++)); e4 = m.indexOf(n.charAt(i++));
	      c1 = (e1 << 2) | (e2 >> 4); c2 = ((e2 & 15) << 4) | (e3 >> 2);
	      c3 = ((e3 & 3) << 6) | e4;
	      o = o + (cc(c1) + ((e3 != 64) ? cc(c2) : "")) + (((e4 != 64) ? cc(c3) : ""));
	    } return this.utf8.decode(o);
	  },
	  utf8: {
	    encode: function (n) {
	      "use strict";
	      var o = "", i = 0, cc = String.fromCharCode, c;
	      while (i < n.length) {
	        c = n.charCodeAt(i++); o = o + ((c < 128) ? cc(c) : ((c > 127) && (c < 2048)) ?
	        (cc((c >> 6) | 192) + cc((c & 63) | 128)) : (cc((c >> 12) | 224) + cc(((c >> 6) & 63) | 128) + cc((c & 63) | 128)));
	        } return o;
	    },
	    decode: function (n) {
	      "use strict";
	      var o = "", i = 0, cc = String.fromCharCode, c2, c;
	      while (i < n.length) {
	        c = n.charCodeAt(i);
	        o = o + ((c < 128) ? [cc(c), i++][0] : ((c > 191) && (c < 224)) ?
	        [cc(((c & 31) << 6) | ((c2 = n.charCodeAt(i + 1)) & 63)), (i += 2)][0] :
	        [cc(((c & 15) << 12) | (((c2 = n.charCodeAt(i + 1)) & 63) << 6) | ((c3 = n.charCodeAt(i + 2)) & 63)), (i += 3)][0]);
	      } return o;
	    }
	  }
	};


/***/ }),
/* 1801 */
/***/ (function(module, exports, __webpack_require__) {

	var deepExtend = __webpack_require__(1802);
	var each = __webpack_require__(1794);
	
	module.exports = {
	  'extendEvent': extendEvent,
	  'extendEvents': extendEvents,
	  'getExtendedEventBody': getExtendedEventBody
	};
	
	function extendEvent(eventCollection, eventModifier){
	  if (arguments.length !== 2 || typeof eventCollection !== 'string'
	    || ('object' !== typeof eventModifier && 'function' !== typeof eventModifier)) {
	      handleValidationError.call(this, 'Incorrect arguments provided to #extendEvent method');
	      return;
	  }
	  this.extensions.collections[eventCollection] = this.extensions.collections[eventCollection] || [];
	  this.extensions.collections[eventCollection].push(eventModifier);
	  this.emit('extendEvent', eventCollection, eventModifier);
	  return this;
	}
	
	function extendEvents(eventsModifier){
	  if (arguments.length !== 1 || ('object' !== typeof eventsModifier && 'function' !== typeof eventsModifier)) {
	    handleValidationError.call(this, 'Incorrect arguments provided to #extendEvents method');
	    return;
	  }
	  this.extensions.events.push(eventsModifier);
	  this.emit('extendEvents', eventsModifier);
	  return this;
	}
	
	function handleValidationError(message){
	  var err = 'Event(s) not extended: ' + message;
	  this.emit('error', err);
	}
	
	function getExtendedEventBody(result, queue){
	  if (queue && queue.length > 0) {
	    each(queue, function(eventModifier, i){
	      var modifierResult = (typeof eventModifier === 'function') ? eventModifier() : eventModifier;
	      deepExtend(result, modifierResult);
	    });
	  }
	  return result;
	}


/***/ }),
/* 1802 */
/***/ (function(module, exports) {

	module.exports = deepExtend;
	
	function deepExtend(target){
	  for (var i = 1; i < arguments.length; i++) {
	    // Copy unique items from incoming array
	    if (target instanceof Array && arguments[i] instanceof Array) {
	      for (var j = 0; j < arguments[i].length; j++) {
	        if (target.indexOf(arguments[i][j]) < 0) {
	          target.push(arguments[i][j]);
	        }
	      }
	    }
	    // Blend objects
	    else {
	      for (var prop in arguments[i]){
	        // Recurse when both contain objects of same name and incoming is not a null object
	        if ('undefined' !== typeof target[prop] && 'object' === typeof arguments[i][prop] && arguments[i][prop] !== null) {
	          deepExtend(target[prop], clone(arguments[i][prop]));
	        }
	        // Otherwise just copy it over...
	        else if (arguments[i][prop] !== undefined) {
	          target[prop] = clone(arguments[i][prop]);
	        }
	      }
	    }
	  }
	  return target;
	}
	
	function clone(input){
	  return JSON.parse( JSON.stringify(input) );
	}


/***/ }),
/* 1803 */
/***/ (function(module, exports, __webpack_require__) {

	var Keen = __webpack_require__(1788);
	var each = __webpack_require__(1794);
	var queue = __webpack_require__(1796);
	
	module.exports = {
	  'deferEvent': deferEvent,
	  'deferEvents': deferEvents,
	  'queueCapacity': queueCapacity,
	  'queueInterval': queueInterval,
	  'recordDeferredEvents': recordDeferredEvents
	};
	
	function deferEvent(eventCollection, eventBody){
	
	  if (arguments.length !== 2 || typeof eventCollection !== 'string') {
	    handleValidationError.call(this, 'Incorrect arguments provided to #deferEvent method');
	    return;
	  }
	
	  this.queue.events[eventCollection] = this.queue.events[eventCollection] || [];
	  this.queue.events[eventCollection].push(eventBody);
	  this.queue.capacity++;
	  if (!this.queue.timer) {
	    this.queue.start();
	  }
	  this.emit('deferEvent', eventCollection, eventBody);
	  return this;
	}
	
	function deferEvents(eventsHash){
	  var self = this;
	
	  if (arguments.length !== 1 || typeof eventsHash !== 'object') {
	    handleValidationError.call(this, 'Incorrect arguments provided to #deferEvents method');
	    return;
	  }
	
	  each(eventsHash, function(eventList, eventCollection){
	    self.queue.events[eventCollection] = self.queue.events[eventCollection] || [];
	    self.queue.events[eventCollection] = self.queue.events[eventCollection].concat(eventList);
	    self.queue.capacity = self.queue.capacity + eventList.length;
	    if (!self.queue.timer) {
	      self.queue.start();
	    }
	  });
	  self.emit('deferEvents', eventsHash);
	  return self;
	}
	
	function queueCapacity(num){
	  if (!arguments.length) return this.queue.config.capacity;
	  this.queue.config.capacity = num ? Number(num): 0;
	  this.queue.check();
	  return this;
	}
	
	function queueInterval(num){
	  if (!arguments.length) return this.queue.config.interval;
	  this.queue.config.interval = num ? Number(num): 0;
	  this.queue.check();
	  return this;
	}
	
	function recordDeferredEvents(){
	  var self = this,
	      clonedQueueConfig,
	      clonedQueueEvents;
	
	  if (self.queue.capacity > 0) {
	    self.queue.pause();
	    clonedQueueConfig = JSON.parse(JSON.stringify(self.queue.config));
	    clonedQueueEvents = JSON.parse(JSON.stringify(self.queue.events));
	    self.queue = queue();
	    self.queue.config = clonedQueueConfig;
	    self.emit('recordDeferredEvents', clonedQueueEvents);
	    self.recordEvents(clonedQueueEvents, function(err, res){
	      if (err) {
	        // Retry once
	        self.recordEvents(clonedQueueEvents);
	      }
	      else {
	        clonedQueueEvents = undefined;
	      }
	    });
	  }
	  return self;
	}
	
	function handleValidationError(message){
	  var err = 'Event(s) not deferred: ' + message;
	  this.emit('error', err);
	}


/***/ }),
/* 1804 */
/***/ (function(module, exports, __webpack_require__) {

	var pkg = __webpack_require__(1805);
	
	function initAutoTracking(lib) {
	  return function(obj) {
	    var client = this;
	    var helpers = lib.helpers;
	    var utils = lib.utils;
	
	    var options = utils.extend({
	      ignoreDisabledFormFields: false,
	      ignoreFormFieldTypes: ['password'],
	      recordClicks: true,
	      recordFormSubmits: true,
	      recordPageViews: true,
	      recordScrollState: true
	    }, obj);
	
	    var now = new Date();
	
	    var cookie = new utils.cookie('keen');
	    var uuid = cookie.get('uuid');
	    if (!uuid) {
	      uuid = helpers.getUniqueId();
	      cookie.set('uuid', uuid);
	    }
	
	    var scrollState = {};
	    if (options.recordScrollState) {
	      scrollState = helpers.getScrollState();
	      utils.listener('window').on('scroll', function(){
	        scrollState = helpers.getScrollState(scrollState);
	      });
	    }
	
	    client.extendEvents(function() {
	      var browserProfile = helpers.getBrowserProfile();
	      return {
	        tracked_by: pkg.name + '-' + pkg.version,
	        local_time_full: new Date(),
	        user: {
	          uuid: uuid
	        },
	        page: {
	          title: document ? document.title : null,
	          description: browserProfile.description,
	          time_on_page: getSecondsSinceDate(now)
	        },
	
	        ip_address: '${keen.ip}',
	        geo: { /* Enriched */ },
	
	        user_agent: '${keen.user_agent}',
	        tech: {
	          profile: browserProfile
	          /* Enriched */
	        },
	
	        url: {
	          full: window ? window.location.href : '',
	          info: { /* Enriched */ }
	        },
	
	        referrer: {
	          full: document ? document.referrer : '',
	          info: { /* Enriched */ }
	        },
	
	        time: {
	          local: { /* Enriched */ },
	          utc: { /* Enriched */ }
	        },
	
	        keen: {
	          timestamp: new Date().toISOString(),
	          addons: [
	            {
	              name: 'keen:ip_to_geo',
	              input: {
	                ip: 'ip_address'
	              },
	              output : 'geo'
	            },
	            {
	              name: 'keen:ua_parser',
	              input: {
	                ua_string: 'user_agent'
	              },
	              output: 'tech'
	            },
	            {
	              name: 'keen:url_parser',
	              input: {
	                url: 'url.full'
	              },
	              output: 'url.info'
	            },
	            {
	              name: 'keen:url_parser',
	              input: {
	                url: 'referrer.full'
	              },
	              output: 'referrer.info'
	            },
	            {
	              name: 'keen:date_time_parser',
	              input: {
	                date_time: 'keen.timestamp'
	              },
	              output: 'time.utc'
	            },
	            {
	              name: 'keen:date_time_parser',
	              input: {
	                date_time: 'local_time_full'
	              },
	              output: 'time.local'
	            }
	          ],
	        }
	      };
	    });
	
	
	
	    if (options.recordClicks === true) {
	      utils.listener('a, a *').on('click', function(e) {
	        var el = e.target;
	        var props = {
	          element: helpers.getDomNodeProfile(el),
	          local_time_full: new Date(),
	          page: {
	            scroll_state: scrollState
	          }
	        };
	        client.recordEvent('clicks', props);
	      });
	    }
	
	    if (options.recordFormSubmits === true) {
	      utils.listener('form').on('submit', function(e) {
	        var el = e.target;
	        var serializerOptions = {
	          disabled: options.ignoreDisabledFormFields,
	          ignoreTypes: options.ignoreFormFieldTypes
	        };
	        var props = {
	          form: {
	            action: el.action,
	            fields: utils.serializeForm(el, serializerOptions),
	            method: el.method
	          },
	          element: helpers.getDomNodeProfile(el),
	          local_time_full: new Date(),
	          page: {
	            scroll_state: scrollState
	          }
	        };
	        client.recordEvent('form_submissions', props);
	      });
	    }
	
	    if (options.recordPageViews === true) {
	      client.recordEvent('pageviews');
	    }
	
	    return client;
	  };
	}
	
	function getSecondsSinceDate(date) {
	  var diff = new Date().getTime() - date.getTime();
	  return Math.round(diff / 1000);
	}
	
	module.exports = initAutoTracking;


/***/ }),
/* 1805 */
/***/ (function(module, exports) {

	module.exports = {
		"name": "keen-tracking",
		"version": "1.4.0",
		"description": "Data Collection SDK for Keen IO",
		"main": "lib/server.js",
		"browser": "lib/browser.js",
		"repository": {
			"type": "git",
			"url": "https://github.com/keen/keen-tracking.js.git"
		},
		"scripts": {
			"start": "gulp with-tests",
			"test": "gulp test:cli"
		},
		"bugs": "https://github.com/keen/keen-tracking.js/issues",
		"author": "Dustin Larimer <dustin@keen.io> (https://keen.io/)",
		"contributors": [
			"Dustin Larimer <dustin@keen.io> (https://github.com/dustinlarimer)",
			"Eric Anderson <eric@keen.io> (https://github.com/aroc)",
			"Joe Wegner <joe@keen.io> (http://www.wegnerdesign.com)",
			"Alex Kleissner <alex@keen.io> (https://github.com/hex337)"
		],
		"license": "MIT",
		"dependencies": {
			"component-emitter": "^1.2.0",
			"js-cookie": "2.1.0",
			"keen-core": "^0.1.3"
		},
		"devDependencies": {
			"browserify": "^9.0.8",
			"chai": "^2.3.0",
			"chai-spies": "^0.6.0",
			"del": "^1.1.1",
			"gulp": "^3.8.11",
			"gulp-awspublish": "0.0.23",
			"gulp-connect": "^2.2.0",
			"gulp-derequire": "^2.1.0",
			"gulp-mocha": "^2.0.1",
			"gulp-mocha-phantomjs": "^0.6.1",
			"gulp-remove-empty-lines": "0.0.2",
			"gulp-rename": "^1.2.2",
			"gulp-replace": "^0.5.3",
			"gulp-sourcemaps": "^1.5.2",
			"gulp-strip-comments": "^1.0.1",
			"gulp-uglify": "^1.5.2",
			"gulp-util": "^3.0.4",
			"gulp-yuicompressor": "0.0.3",
			"karma": "^1.7.1",
			"karma-chrome-launcher": "^0.1.12",
			"karma-firefox-launcher": "^0.1.6",
			"karma-mocha": "^0.2.0",
			"karma-nyan-reporter": "0.0.60",
			"karma-requirejs": "^0.2.2",
			"karma-safari-launcher": "^0.1.1",
			"karma-sauce-launcher": "^0.2.11",
			"mocha": "^2.2.5",
			"moment": "^2.10.3",
			"phantomjs": "^1.9.7-15",
			"proclaim": "^3.3.0",
			"requirejs": "^2.3.5",
			"vinyl-buffer": "^1.0.0",
			"vinyl-source-stream": "^1.1.0"
		}
	};

/***/ }),
/* 1806 */
/***/ (function(module, exports, __webpack_require__) {

	var getScreenProfile = __webpack_require__(1807),
	    getWindowProfile = __webpack_require__(1808);
	
	function getBrowserProfile() {
	  return {
	    'cookies'    : ('undefined' !== typeof navigator.cookieEnabled) ? navigator.cookieEnabled : false,
	    'codeName'   : navigator.appCodeName,
	    'description': getDocumentDescription(),
	    'language'   : navigator.language,
	    'name'       : navigator.appName,
	    'online'     : navigator.onLine,
	    'platform'   : navigator.platform,
	    'useragent'  : navigator.userAgent,
	    'version'    : navigator.appVersion,
	    'screen'     : getScreenProfile(),
	    'window'     : getWindowProfile()
	  }
	}
	
	function getDocumentDescription() {
	  var el;
	  if (document && typeof document.querySelector === 'function') {
	    el = document.querySelector('meta[name="description"]');
	  }
	  return el ? el.content : '';
	}
	
	module.exports = getBrowserProfile;


/***/ }),
/* 1807 */
/***/ (function(module, exports) {

	function getScreenProfile(){
	  var keys, output;
	
	  if ('undefined' == typeof window || !window.screen) return {};
	
	  keys = ['height', 'width', 'colorDepth', 'pixelDepth', 'availHeight', 'availWidth'];
	  output = {};
	
	  for (var i = 0; i < keys.length; i++) {
	    output[keys[i]] = window.screen[keys[i]] ? window.screen[keys[i]] : null;
	  }
	
	  output.orientation = {
	    'angle' : window.screen.orientation ? window.screen.orientation['angle'] : 0,
	    'type'  : window.innerWidth > window.innerHeight ? 'landscape': 'portrait'
	  };
	
	  return output;
	}
	
	module.exports = getScreenProfile;


/***/ }),
/* 1808 */
/***/ (function(module, exports) {

	function getWindowProfile(){
	  var body, html, output;
	
	  if ('undefined' == typeof document) return {};
	
	  body = document.body;
	  html = document.documentElement;
	
	  output = {
	    'height': ('innerHeight' in window) ? window.innerHeight : document.documentElement.offsetHeight,
	    'width': ('innerWidth' in window) ? window.innerWidth : document.documentElement.offsetWidth,
	    'scrollHeight': Math.max( body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight ) || null
	  };
	
	  if (window.screen) {
	    output.ratio = {
	      'height': (window.screen.availHeight) ? parseFloat( (window.innerHeight/window.screen.availHeight).toFixed(2) ) : null,
	      'width': (window.screen.availWidth) ? parseFloat( (window.innerWidth/window.screen.availWidth).toFixed(2) ) : null
	    };
	  }
	
	  return output;
	}
	
	module.exports = getWindowProfile;
	
	/*
	  Notes:
	    document.documentElement.offsetHeight/Width is a workaround for IE8 and below, where window.innerHeight/Width is undefined
	*/


/***/ }),
/* 1809 */
/***/ (function(module, exports) {

	function getDateTimeIndex(input){
	  var date = input || new Date();
	  return {
	    'hour_of_day'  : date.getHours(),
	    'day_of_week'  : parseInt( 1 + date.getDay() ),
	    'day_of_month' : date.getDate(),
	    'month'        : parseInt( 1 + date.getMonth() ),
	    'year'         : date.getFullYear()
	  };
	}
	
	module.exports = getDateTimeIndex;


/***/ }),
/* 1810 */
/***/ (function(module, exports) {

	function getDomNodePath(el){
	  if (!el.nodeName) return '';
	
	  var stack = [];
	  while ( el.parentNode != null ) {
	    // console.log(el.nodeName);
	    var sibCount = 0;
	    var sibIndex = 0;
	    for ( var i = 0; i < el.parentNode.childNodes.length; i++ ) {
	      var sib = el.parentNode.childNodes[i];
	      if ( sib.nodeName == el.nodeName ) {
	        if ( sib === el ) {
	          sibIndex = sibCount;
	        }
	        sibCount++;
	      }
	    }
	    if ( el.hasAttribute('id') && el.id != '' ) {
	      stack.unshift(el.nodeName.toLowerCase() + '#' + el.id);
	    } else if ( sibCount > 1 ) {
	      stack.unshift(el.nodeName.toLowerCase() + ':eq(' + sibIndex + ')');
	    } else {
	      stack.unshift(el.nodeName.toLowerCase());
	    }
	    el = el.parentNode;
	  }
	
	  return stack.slice(1).join(' > ');
	}
	
	module.exports = getDomNodePath;
	
	// via: http://stackoverflow.com/a/16742828/2511985


/***/ }),
/* 1811 */
/***/ (function(module, exports, __webpack_require__) {

	var getDomNodePath = __webpack_require__(1810);
	
	function getDomNodeProfile(el) {
	  return {
	    action: el.action,
	    class: el.className,
	    href: el.href,
	    id: el.id,
	    method: el.method,
	    name: el.name,
	    node_name: el.nodeName,
	    selector: getDomNodePath(el),
	    text: el.text,
	    title: el.title,
	    type: el.type,
	    x_position: el.offsetLeft || el.clientLeft || null,
	    y_position: el.offsetTop || el.clientTop || null
	  };
	}
	
	module.exports = getDomNodeProfile;


/***/ }),
/* 1812 */
/***/ (function(module, exports, __webpack_require__) {

	var extend = __webpack_require__(1795);
	
	function getScrollState(obj){
	  var config = typeof obj === 'object' ? obj : {};
	  var state = extend({
	    pixel: 0,
	    pixel_max: 0,
	    ratio: null,
	    ratio_max: null
	  }, config);
	
	  if (typeof window !== undefined || typeof document !== undefined) {
	    state.pixel = getScrollOffset() + getWindowHeight();
	    if (state.pixel > state.pixel_max) {
	      state.pixel_max = state.pixel;
	    }
	    state.ratio = parseFloat(Number(state.pixel / getScrollableArea()).toFixed(2));
	    state.ratio_max = parseFloat(Number(state.pixel_max / getScrollableArea()).toFixed(2));
	  }
	
	  return state;
	}
	
	function getScrollableArea() {
	  var body = document.body;
	  var html = document.documentElement;
	  return Math.max( body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight ) || null;
	}
	
	function getScrollOffset() {
	  return (window.pageYOffset !== undefined) ? window.pageYOffset : (document.documentElement || document.body.parentNode || document.body).scrollTop;
	}
	
	function getWindowHeight() {
	  return window.innerHeight || document.documentElement.clientHeight;
	}
	
	module.exports = getScrollState;


/***/ }),
/* 1813 */
/***/ (function(module, exports) {

	// via: http://stackoverflow.com/a/2117523/2511985
	
	function getUniqueId(){
	  var str = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx';
	  return str.replace(/[xy]/g, function(c) {
	    var r = Math.random()*16|0, v = c == 'x' ? r : (r&0x3|0x8);
	    return v.toString(16);
	  });
	}
	
	module.exports = getUniqueId;


/***/ }),
/* 1814 */
/***/ (function(module, exports, __webpack_require__) {

	var Cookies = __webpack_require__(1815);
	var extend = __webpack_require__(1795);
	
	module.exports = cookie;
	
	function cookie(str){
	  if (!arguments.length) return;
	  if (this instanceof cookie === false) {
	    return new cookie(str);
	  }
	
	  this.config = {
	    key: str,
	    options: {
	      expires: 365
	    }
	  };
	  this.data = this.get();
	  return this;
	}
	
	cookie.prototype.get = function(str){
	  var data = {};
	
	  if (Cookies.get(this.config.key)) {
	    data = Cookies.getJSON(this.config.key);
	  }
	  if (str && typeof data === 'object' && typeof data !== null) {
	    return (typeof data[str] !== 'undefined') ? data[str] : null;
	  }
	  else {
	    return data;
	  }
	};
	
	cookie.prototype.set = function(str, value){
	  if (!arguments.length || !this.enabled()) return this;
	  if (typeof str === 'string'  && arguments.length === 2) {
	    this.data[str] = value ? value : null;
	  }
	  else if (typeof str === 'object' && arguments.length === 1) {
	    extend(this.data, str);
	  }
	  Cookies.set(this.config.key, this.data, this.config.options);
	  return this;
	};
	
	cookie.prototype.expire = function(daysUntilExpire){
	  if (daysUntilExpire) {
	    Cookies.set(this.config.key, this.data, extend(this.config.options, { expires: daysUntilExpire }));
	  } else {
	    Cookies.remove(this.config.key);
	    this.data = {};
	  }
	  return this;
	};
	
	cookie.prototype.options = function(obj){
	  if (!arguments.length) return this.config.options;
	  this.config.options = (typeof obj === 'object') ? obj : {};
	  return this;
	};
	
	cookie.prototype.enabled = function(){
	  return navigator.cookieEnabled;
	};


/***/ }),
/* 1815 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * JavaScript Cookie v2.1.0
	 * https://github.com/js-cookie/js-cookie
	 *
	 * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
	 * Released under the MIT license
	 */
	(function (factory) {
		if (true) {
			!(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if (typeof exports === 'object') {
			module.exports = factory();
		} else {
			var _OldCookies = window.Cookies;
			var api = window.Cookies = factory();
			api.noConflict = function () {
				window.Cookies = _OldCookies;
				return api;
			};
		}
	}(function () {
		function extend () {
			var i = 0;
			var result = {};
			for (; i < arguments.length; i++) {
				var attributes = arguments[ i ];
				for (var key in attributes) {
					result[key] = attributes[key];
				}
			}
			return result;
		}
	
		function init (converter) {
			function api (key, value, attributes) {
				var result;
	
				// Write
	
				if (arguments.length > 1) {
					attributes = extend({
						path: '/'
					}, api.defaults, attributes);
	
					if (typeof attributes.expires === 'number') {
						var expires = new Date();
						expires.setMilliseconds(expires.getMilliseconds() + attributes.expires * 864e+5);
						attributes.expires = expires;
					}
	
					try {
						result = JSON.stringify(value);
						if (/^[\{\[]/.test(result)) {
							value = result;
						}
					} catch (e) {}
	
					if (!converter.write) {
						value = encodeURIComponent(String(value))
							.replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);
					} else {
						value = converter.write(value, key);
					}
	
					key = encodeURIComponent(String(key));
					key = key.replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent);
					key = key.replace(/[\(\)]/g, escape);
	
					return (document.cookie = [
						key, '=', value,
						attributes.expires && '; expires=' + attributes.expires.toUTCString(), // use expires attribute, max-age is not supported by IE
						attributes.path    && '; path=' + attributes.path,
						attributes.domain  && '; domain=' + attributes.domain,
						attributes.secure ? '; secure' : ''
					].join(''));
				}
	
				// Read
	
				if (!key) {
					result = {};
				}
	
				// To prevent the for loop in the first place assign an empty array
				// in case there are no cookies at all. Also prevents odd result when
				// calling "get()"
				var cookies = document.cookie ? document.cookie.split('; ') : [];
				var rdecode = /(%[0-9A-Z]{2})+/g;
				var i = 0;
	
				for (; i < cookies.length; i++) {
					var parts = cookies[i].split('=');
					var name = parts[0].replace(rdecode, decodeURIComponent);
					var cookie = parts.slice(1).join('=');
	
					if (cookie.charAt(0) === '"') {
						cookie = cookie.slice(1, -1);
					}
	
					try {
						cookie = converter.read ?
							converter.read(cookie, name) : converter(cookie, name) ||
							cookie.replace(rdecode, decodeURIComponent);
	
						if (this.json) {
							try {
								cookie = JSON.parse(cookie);
							} catch (e) {}
						}
	
						if (key === name) {
							result = cookie;
							break;
						}
	
						if (!key) {
							result[name] = cookie;
						}
					} catch (e) {}
				}
	
				return result;
			}
	
			api.get = api.set = api;
			api.getJSON = function () {
				return api.apply({
					json: true
				}, [].slice.call(arguments));
			};
			api.defaults = {};
	
			api.remove = function (key, attributes) {
				api(key, '', extend(attributes, {
					expires: -1
				}));
			};
	
			api.withConverter = init;
	
			return api;
		}
	
		return init(function () {});
	}));


/***/ }),
/* 1816 */
/***/ (function(module, exports) {

	/*
	  This is a modified copy of https://github.com/defunctzombie/form-serialize/ v0.7.1
	  Includes a new configuration option:
	    * ignoreTypes - Array, Default: [], Example: [ 'password' ]
	*/
	
	// types which indicate a submit action and are not successful controls
	// these will be ignored
	var k_r_submitter = /^(?:submit|button|image|reset|file)$/i;
	
	// node names which could be successful controls
	var k_r_success_contrls = /^(?:input|select|textarea|keygen)/i;
	
	// Matches bracket notation.
	var brackets = /(\[[^\[\]]*\])/g;
	
	// serializes form fields
	// @param form MUST be an HTMLForm element
	// @param options is an optional argument to configure the serialization. Default output
	// with no options specified is a url encoded string
	//    - hash: [true | false] Configure the output type. If true, the output will
	//    be a js object.
	//    - serializer: [function] Optional serializer function to override the default one.
	//    The function takes 3 arguments (result, key, value) and should return new result
	//    hash and url encoded str serializers are provided with this module
	//    - disabled: [true | false]. If true serialize disabled fields.
	//    - empty: [true | false]. If true serialize empty fields
	function serialize(form, options) {
	  if (typeof options != 'object') {
	    options = { hash: !!options };
	  }
	  else if (options.hash === undefined) {
	    options.hash = true;
	  }
	
	  var result = (options.hash) ? {} : '';
	  var serializer = options.serializer || ((options.hash) ? hash_serializer : str_serialize);
	
	  var elements = form && form.elements ? form.elements : [];
	
	  // Object store each radio and set if it's empty or not
	  var radio_store = Object.create(null);
	
	  for (var i=0 ; i<elements.length ; ++i) {
	    var element = elements[i];
	
	    // NEW: Skip ignored field types
	    if (options.ignoreTypes && options.ignoreTypes.indexOf(element.type) > -1) {
	      continue;
	    }
	    // ingore disabled fields
	    if ((!options.disabled && element.disabled) || !element.name) {
	      continue;
	    }
	    // ignore anyhting that is not considered a success field
	    if (!k_r_success_contrls.test(element.nodeName) ||
	      k_r_submitter.test(element.type)) {
	      continue;
	    }
	
	    var key = element.name;
	    var val = element.value;
	
	    // we can't just use element.value for checkboxes cause some browsers lie to us
	    // they say "on" for value when the box isn't checked
	    if ((element.type === 'checkbox' || element.type === 'radio') && !element.checked) {
	      val = undefined;
	    }
	
	    // If we want empty elements
	    if (options.empty) {
	      if (element.type === 'checkbox' && !element.checked) {
	        val = '';
	      }
	
	      // for radio
	      if (element.type === 'radio') {
	        if (!radio_store[element.name] && !element.checked) {
	          radio_store[element.name] = false;
	        }
	        else if (element.checked) {
	          radio_store[element.name] = true;
	        }
	      }
	
	      // if options empty is true, continue only if its radio
	      if (val == undefined && element.type == 'radio') {
	        continue;
	      }
	    }
	    else {
	      // value-less fields are ignored unless options.empty is true
	      if (!val) {
	        continue;
	      }
	    }
	
	    // multi select boxes
	    if (element.type === 'select-multiple') {
	      val = [];
	
	      var selectOptions = element.options;
	      var isSelectedOptions = false;
	      for (var j=0 ; j<selectOptions.length ; ++j) {
	        var option = selectOptions[j];
	        var allowedEmpty = options.empty && !option.value;
	        var hasValue = (option.value || allowedEmpty);
	        if (option.selected && hasValue) {
	          isSelectedOptions = true;
	
	          // If using a hash serializer be sure to add the
	          // correct notation for an array in the multi-select
	          // context. Here the name attribute on the select element
	          // might be missing the trailing bracket pair. Both names
	          // "foo" and "foo[]" should be arrays.
	          if (options.hash && key.slice(key.length - 2) !== '[]') {
	            result = serializer(result, key + '[]', option.value);
	          }
	          else {
	            result = serializer(result, key, option.value);
	          }
	        }
	      }
	
	      if (!isSelectedOptions && options.empty) {
	        result = serializer(result, key, '');
	      }
	      continue;
	    }
	
	    result = serializer(result, key, val);
	  }
	
	  if (options.empty) {
	    for (var key in radio_store) {
	      if (!radio_store[key]) {
	        result = serializer(result, key, '');
	      }
	    }
	  }
	
	  return result;
	}
	
	function parse_keys(string) {
	  var keys = [];
	  var prefix = /^([^\[\]]*)/;
	  var children = new RegExp(brackets);
	  var match = prefix.exec(string);
	
	  if (match[1]) {
	      keys.push(match[1]);
	  }
	
	  while ((match = children.exec(string)) !== null) {
	      keys.push(match[1]);
	  }
	
	  return keys;
	}
	
	function hash_assign(result, keys, value) {
	  if (keys.length === 0) {
	    result = value;
	    return result;
	  }
	
	  var key = keys.shift();
	  var between = key.match(/^\[(.+?)\]$/);
	
	  if (key === '[]') {
	    result = result || [];
	
	    if (Array.isArray(result)) {
	      result.push(hash_assign(null, keys, value));
	    }
	    else {
	      // This might be the result of bad name attributes like "[][foo]",
	      // in this case the original `result` object will already be
	      // assigned to an object literal. Rather than coerce the object to
	      // an array, or cause an exception the attribute "_values" is
	      // assigned as an array.
	      result._values = result._values || [];
	      result._values.push(hash_assign(null, keys, value));
	    }
	
	    return result;
	  }
	
	  // Key is an attribute name and can be assigned directly.
	  if (!between) {
	    result[key] = hash_assign(result[key], keys, value);
	  }
	  else {
	    var string = between[1];
	    // +var converts the variable into a number
	    // better than parseInt because it doesn't truncate away trailing
	    // letters and actually fails if whole thing is not a number
	    var index = +string;
	
	    // If the characters between the brackets is not a number it is an
	    // attribute name and can be assigned directly.
	    if (isNaN(index)) {
	      result = result || {};
	      result[string] = hash_assign(result[string], keys, value);
	    }
	    else {
	      result = result || [];
	      result[index] = hash_assign(result[index], keys, value);
	    }
	  }
	
	  return result;
	}
	
	// Object/hash encoding serializer.
	function hash_serializer(result, key, value) {
	  var matches = key.match(brackets);
	
	  // Has brackets? Use the recursive assignment function to walk the keys,
	  // construct any missing objects in the result tree and make the assignment
	  // at the end of the chain.
	  if (matches) {
	    var keys = parse_keys(key);
	    hash_assign(result, keys, value);
	  }
	  else {
	    // Non bracket notation can make assignments directly.
	    var existing = result[key];
	
	    // If the value has been assigned already (for instance when a radio and
	    // a checkbox have the same name attribute) convert the previous value
	    // into an array before pushing into it.
	    //
	    // NOTE: If this requirement were removed all hash creation and
	    // assignment could go through `hash_assign`.
	    if (existing) {
	      if (!Array.isArray(existing)) {
	        result[key] = [ existing ];
	      }
	
	      result[key].push(value);
	    }
	    else {
	      result[key] = value;
	    }
	  }
	
	  return result;
	}
	
	// urlform encoding serializer
	function str_serialize(result, key, value) {
	  // encode newlines as \r\n cause the html spec says so
	  value = value.replace(/(\r)?\n/g, '\r\n');
	  value = encodeURIComponent(value);
	
	  // spaces should be '+' rather than '%20'.
	  value = value.replace(/%20/g, '+');
	  return result + (result ? '&' : '') + encodeURIComponent(key) + '=' + value;
	}
	
	module.exports = serialize;


/***/ }),
/* 1817 */
/***/ (function(module, exports) {

	module.exports = timer;
	
	function timer(num){
	  if (this instanceof timer === false) {
	    return new timer(num);
	  }
	  this.count = num || 0;
	  return this;
	}
	
	timer.prototype.start = function(){
	  var self = this;
	  this.pause();
	  this.interval = setInterval(function(){
	    self.count++;
	  }, 1000);
	  return this;
	};
	
	timer.prototype.pause = function(){
	  clearInterval(this.interval);
	  return this;
	};
	
	timer.prototype.value = function(){
	  return this.count;
	};
	
	timer.prototype.clear = function(){
	  this.count = 0;
	  return this;
	};


/***/ }),
/* 1818 */
/***/ (function(module, exports, __webpack_require__) {

	var KeenLibrary = __webpack_require__(1819);
	var Promise = __webpack_require__(1824);
	
	var each = __webpack_require__(1820),
	    extend = __webpack_require__(1821);
	
	var request = __webpack_require__(1828);
	extend(KeenLibrary.prototype, request);
	
	KeenLibrary.prototype.readKey = function(str){
	  if (!arguments.length) return this.config.readKey;
	  this.config.readKey = str ? String(str) : null;
	  return this;
	};
	
	KeenLibrary.prototype.query = function(a, b){
	  if (a && b && typeof b === 'string') {
	    if (b.indexOf('/result') < 0) {
	      b += '/result';
	    }
	    return this
	      .get(this.url('queries', a, b))
	      .auth(this.readKey())
	      .send();
	  }
	  else if (a === 'dataset' && typeof b === 'object') {
	    return this
	      .get(this.url('datasets', b.name, 'results'))
	      .auth(this.readKey())
	      .send(b);
	  }
	  else if (a && b && typeof b === 'object') {
	    // Include analysis_type for downstream use
	    var q = extend({ analysis_type: a }, b);
	    return this
	      .post(this.url('queries', a))
	      .auth(this.readKey())
	      .send(q);
	  }
	  else if (a && !b) {
	    return Promise.reject({
	      error_code: 'SDKError',
	      message: ".query() called with incorrect arguments"
	    });
	  }
	};
	
	// Keen.Query handler
	// --------------------------------
	KeenLibrary.Query = Query;
	
	KeenLibrary.prototype.run = function(q, callback){
	  var self = this,
	      cb = callback,
	      queries,
	      promises,
	      output;
	
	  callback = null;
	  queries = q instanceof Array? q : [q];
	  promises = [];
	
	  each(queries, function(query, i){
	    if (typeof query === 'string') {
	      promises.push(self.query('saved', query + '/result'));
	    }
	    else if (query instanceof KeenLibrary.Query) {
	      // Include analysis_type for downstream use
	      promises.push(self.query(query.analysis, extend({ analysis_type: query.analysis }, query.params)));
	    }
	  });
	
	  if (promises.length > 1) {
	    output = Promise.all(promises);
	  }
	  else {
	    // Only return single
	    output = promises[0];
	  }
	
	  if (cb) {
	    // Manually handle callback, as
	    // Promise.nodeify drops nulls
	    output.then(function(res){
	      cb(null, res);
	    });
	    output['catch'](function(err){
	      cb(err, null);
	    });
	  }
	
	  return output;
	};
	
	function Query(analysisType, params) {
	  this.analysis = analysisType;
	  this.params = {};
	  this.set(params);
	
	  // Localize timezone if none is set
	  if (this.params.timezone === void 0) {
	    this.params.timezone = new Date().getTimezoneOffset() * -60;
	  }
	}
	
	Query.prototype.set = function(attributes) {
	  var self = this;
	  each(attributes, function(v, k){
	    var key = k, value = v;
	    if (k.match(new RegExp('[A-Z]'))) {
	      key = k.replace(/([A-Z])/g, function($1) { return '_'+$1.toLowerCase(); });
	    }
	    self.params[key] = value;
	    if (value instanceof Array) {
	      each(value, function(dv, index){
	        if (dv instanceof Array == false && typeof dv === 'object') {
	          each(dv, function(deepValue, deepKey){
	            if (deepKey.match(new RegExp('[A-Z]'))) {
	              var _deepKey = deepKey.replace(/([A-Z])/g, function($1) { return '_'+$1.toLowerCase(); });
	              delete self.params[key][index][deepKey];
	              self.params[key][index][_deepKey] = deepValue;
	            }
	          });
	        }
	      });
	    }
	  });
	  return self;
	};
	
	Query.prototype.get = function(attribute) {
	  var key = attribute;
	  if (key.match(new RegExp('[A-Z]'))) {
	    key = key.replace(/([A-Z])/g, function($1) { return '_'+$1.toLowerCase(); });
	  }
	  if (this.params) {
	    return this.params[key] || null;
	  }
	};
	
	Query.prototype.addFilter = function(property, operator, value) {
	  this.params.filters = this.params.filters || [];
	  this.params.filters.push({
	    'property_name': property,
	    'operator': operator,
	    'property_value': value
	  });
	  return this;
	};
	
	module.exports = KeenLibrary;


/***/ }),
/* 1819 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {(function(env){
	  var previousKeen = env.Keen || undefined;
	  var each = __webpack_require__(1820),
	      extend = __webpack_require__(1821),
	      parseParams = __webpack_require__(1822),
	      serialize = __webpack_require__(1823);
	
	  var Emitter = __webpack_require__(1169);
	
	  function Client(props){
	    if (this instanceof Client === false) {
	      return new Client(props);
	    }
	    this.configure(props);
	
	    // Set up event handling
	    if (Client.debug) {
	      this.on('error', Client.log);
	    }
	    this.emit('ready');
	    Client.emit('client', this);
	  }
	
	  if (previousKeen && typeof previousKeen.resources === 'undefined') {
	    Client.legacyVersion = previousKeen;
	  }
	
	  Emitter(Client);
	  Emitter(Client.prototype);
	
	  extend(Client, {
	    debug: false,
	    enabled: true,
	    loaded: false,
	    version: '__VERSION__'
	  });
	
	  // Set or extend helpers
	  Client.helpers = Client.helpers || {};
	
	  // Set or extend resources
	  Client.resources = Client.resources || {};
	  extend(Client.resources, {
	    'base'      : '{protocol}://{host}',
	    'version'   : '{protocol}://{host}/3.0',
	    'projects'  : '{protocol}://{host}/3.0/projects',
	    'projectId' : '{protocol}://{host}/3.0/projects/{projectId}',
	    'events'    : '{protocol}://{host}/3.0/projects/{projectId}/events',
	    'queries'   : '{protocol}://{host}/3.0/projects/{projectId}/queries',
	    'datasets'  : '{protocol}://{host}/3.0/projects/{projectId}/datasets'
	  });
	
	  // Set or extend utils
	  Client.utils = Client.utils || {};
	  extend(Client.utils, {
	    'each'        : each,
	    'extend'      : extend,
	    'parseParams' : parseParams,
	    'serialize'   : serialize
	  });
	
	  Client.extendLibrary = function(target, source) {
	    var previous = previousKeen || source;
	    if (isDefined(previous) && isDefined(previous.resources)) {
	      each(previous, function(value, key) {
	        if (typeof value === 'object') {
	          target[key] = target[key] || {};
	          extend(target[key], value);
	        }
	        else {
	          target[key] = target[key] || value;
	        }
	      });
	      extend(target.prototype, previous.prototype);
	    }
	    return target;
	  };
	
	  Client.log = function(str){
	    if (Client.debug && typeof console === 'object') {
	      console.log('[Keen]', str);
	    }
	  };
	
	  Client.noConflict = function(){
	    if (typeof env.Keen !== 'undefined') {
	      env.Keen = Client.legacyVersion || previousKeen;
	    }
	    return Client;
	  };
	
	  Client.ready = function(fn){
	    if (Client.loaded) {
	      fn();
	    }
	    else {
	      Client.once('ready', fn);
	    }
	  };
	
	  Client.prototype.configure = function(obj){
	    var config = obj || {};
	    this.config = this.config || {
	      projectId    : undefined,
	      writeKey     : undefined,
	      host         : 'api.keen.io',
	      protocol     : 'https',
	      requestType  : 'jsonp',
	      resources    : extend({}, Client.resources)
	    };
	
	    // IE<10 request shim
	    if (typeof window !== 'undefined' && window.navigator && window.navigator.userAgent && window.navigator.userAgent.indexOf('MSIE') > -1) {
	      config.protocol = document.location.protocol.replace(':', '');
	    }
	
	    if (config.host) {
	      config.host.replace(/.*?:\/\//g, '');
	    }
	
	    extend(this.config, config);
	    return this;
	  };
	
	  Client.prototype.masterKey = function(str){
	    if (!arguments.length) return this.config.masterKey;
	    this.config.masterKey = str ? String(str) : null;
	    return this;
	  };
	
	  Client.prototype.projectId = function(str){
	    if (!arguments.length) return this.config.projectId;
	    this.config.projectId = (str ? String(str) : null);
	    return this;
	  };
	
	  Client.prototype.resources = function(obj){
	    if (!arguments.length) return this.config.resources;
	    var self = this;
	    if (typeof obj === 'object') {
	      each(obj, function(value, key){
	        self.config.resources[key] = (value ? value : null);
	      });
	    }
	    return self;
	  };
	
	  Client.prototype.url = function(name){
	    var args = Array.prototype.slice.call(arguments, 1),
	        baseUrl = this.config.resources.base || '{protocol}://{host}',
	        path;
	
	    if (name && typeof name === 'string') {
	      if (this.config.resources[name]) {
	        path = this.config.resources[name];
	      }
	      else {
	        path = baseUrl + name;
	      }
	    }
	    else {
	      path = baseUrl;
	    }
	
	    each(this.config, function(value, key){
	      if (typeof value !== 'object') {
	        path = path.replace('{' + key + '}', value);
	      }
	    });
	
	    each(args, function(arg, i){
	      if (typeof arg === 'string') {
	        path += '/' + arg;
	      }
	      else if (typeof arg === 'object') {
	        path += '?';
	        each(arg, function(value, key){
	          path += key + '=' + value + '&';
	        });
	        path = path.slice(0, -1);
	      }
	    });
	
	    return path;
	  };
	
	  domReady(function(){
	    Client.loaded = true;
	    Client.emit('ready');
	  });
	
	  function domReady(fn){
	    if (Client.loaded || typeof document === 'undefined') {
	      fn();
	      return;
	    }
	    // Firefox 3.5 shim
	    if(document.readyState == null && document.addEventListener){
	      document.addEventListener('DOMContentLoaded', function DOMContentLoaded(){
	        document.removeEventListener('DOMContentLoaded', DOMContentLoaded, false);
	        document.readyState = 'complete';
	      }, false);
	      document.readyState = 'loading';
	    }
	    testDom(fn);
	  }
	
	  function testDom(fn){
	    if (/in/.test(document.readyState)) {
	      setTimeout(function(){
	        testDom(fn);
	      }, 9);
	    }
	    else {
	      fn();
	    }
	  }
	
	  function isDefined(target) {
	    return typeof target !== 'undefined';
	  }
	
	  function isUndefined(target) {
	    return typeof target === 'undefined';
	  }
	
	  module.exports = Client;
	
	}).call(this, typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {});
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 1820 */
/***/ (function(module, exports) {

	module.exports = each;
	
	function each(o, cb, s){
	  var n;
	  if (!o){
	    return 0;
	  }
	  s = !s ? o : s;
	  if (o instanceof Array){
	    // Indexed arrays, needed for Safari
	    for (n=0; n<o.length; n++) {
	      if (cb.call(s, o[n], n, o) === false){
	        return 0;
	      }
	    }
	  } else {
	    // Hashtables
	    for (n in o){
	      if (o.hasOwnProperty(n)) {
	        if (cb.call(s, o[n], n, o) === false){
	          return 0;
	        }
	      }
	    }
	  }
	  return 1;
	}


/***/ }),
/* 1821 */
/***/ (function(module, exports) {

	module.exports = extend;
	
	function extend(target){
	  for (var i = 1; i < arguments.length; i++) {
	    for (var prop in arguments[i]){
	      target[prop] = arguments[i][prop];
	    }
	  }
	  return target;
	};


/***/ }),
/* 1822 */
/***/ (function(module, exports) {

	module.exports = parseParams;
	
	function parseParams(str){
	  // via: http://stackoverflow.com/a/2880929/2511985
	  var urlParams = {},
	      match,
	      pl     = /\+/g,  // Regex for replacing addition symbol with a space
	      search = /([^&=]+)=?([^&]*)/g,
	      decode = function (s) { return decodeURIComponent(s.replace(pl, " ")); },
	      query  = str.split("?")[1];
	
	  while (!!(match=search.exec(query))) {
	    urlParams[decode(match[1])] = decode(match[2]);
	  }
	  return urlParams;
	};


/***/ }),
/* 1823 */
/***/ (function(module, exports, __webpack_require__) {

	var each = __webpack_require__(1820),
	    extend = __webpack_require__(1821);
	
	module.exports = serialize;
	
	function serialize(data){
	  var query = [];
	  each(data, function(value, key){
	    if ('string' !== typeof value) {
	      value = JSON.stringify(value);
	    }
	    query.push(key + '=' + encodeURIComponent(value));
	  });
	  return query.join('&');
	}


/***/ }),
/* 1824 */
/***/ (function(module, exports, __webpack_require__) {

	var Bluebird = __webpack_require__(1825);
	Bluebird.config({
	  cancellation: true,
	  longStackTraces: false,
	  warnings: false
	});
	module.exports = Bluebird;


/***/ }),
/* 1825 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process, global, setImmediate) {/* @preserve
	 * The MIT License (MIT)
	 * 
	 * Copyright (c) 2013-2015 Petka Antonov
	 * 
	 * Permission is hereby granted, free of charge, to any person obtaining a copy
	 * of this software and associated documentation files (the "Software"), to deal
	 * in the Software without restriction, including without limitation the rights
	 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	 * copies of the Software, and to permit persons to whom the Software is
	 * furnished to do so, subject to the following conditions:
	 * 
	 * The above copyright notice and this permission notice shall be included in
	 * all copies or substantial portions of the Software.
	 * 
	 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.  IN NO EVENT SHALL THE
	 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	 * THE SOFTWARE.
	 * 
	 */
	/**
	 * bluebird build version 3.4.1
	 * Features enabled: core
	 * Features disabled: race, call_get, generators, map, nodeify, promisify, props, reduce, settle, some, using, timers, filter, any, each
	*/
	!function(e){if(true)module.exports=e();else if("function"==typeof define&&define.amd)define([],e);else{var f;"undefined"!=typeof window?f=window:"undefined"!=typeof global?f=global:"undefined"!=typeof self&&(f=self),f.Promise=e()}}(function(){var define,module,exports;return (function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof _dereq_=="function"&&_dereq_;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof _dereq_=="function"&&_dereq_;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(_dereq_,module,exports){
	"use strict";
	var firstLineError;
	try {throw new Error(); } catch (e) {firstLineError = e;}
	var schedule = _dereq_("./schedule");
	var Queue = _dereq_("./queue");
	var util = _dereq_("./util");
	
	function Async() {
	    this._customScheduler = false;
	    this._isTickUsed = false;
	    this._lateQueue = new Queue(16);
	    this._normalQueue = new Queue(16);
	    this._haveDrainedQueues = false;
	    this._trampolineEnabled = true;
	    var self = this;
	    this.drainQueues = function () {
	        self._drainQueues();
	    };
	    this._schedule = schedule;
	}
	
	Async.prototype.setScheduler = function(fn) {
	    var prev = this._schedule;
	    this._schedule = fn;
	    this._customScheduler = true;
	    return prev;
	};
	
	Async.prototype.hasCustomScheduler = function() {
	    return this._customScheduler;
	};
	
	Async.prototype.enableTrampoline = function() {
	    this._trampolineEnabled = true;
	};
	
	Async.prototype.disableTrampolineIfNecessary = function() {
	    if (util.hasDevTools) {
	        this._trampolineEnabled = false;
	    }
	};
	
	Async.prototype.haveItemsQueued = function () {
	    return this._isTickUsed || this._haveDrainedQueues;
	};
	
	
	Async.prototype.fatalError = function(e, isNode) {
	    if (isNode) {
	        process.stderr.write("Fatal " + (e instanceof Error ? e.stack : e) +
	            "\n");
	        process.exit(2);
	    } else {
	        this.throwLater(e);
	    }
	};
	
	Async.prototype.throwLater = function(fn, arg) {
	    if (arguments.length === 1) {
	        arg = fn;
	        fn = function () { throw arg; };
	    }
	    if (typeof setTimeout !== "undefined") {
	        setTimeout(function() {
	            fn(arg);
	        }, 0);
	    } else try {
	        this._schedule(function() {
	            fn(arg);
	        });
	    } catch (e) {
	        throw new Error("No async scheduler available\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
	    }
	};
	
	function AsyncInvokeLater(fn, receiver, arg) {
	    this._lateQueue.push(fn, receiver, arg);
	    this._queueTick();
	}
	
	function AsyncInvoke(fn, receiver, arg) {
	    this._normalQueue.push(fn, receiver, arg);
	    this._queueTick();
	}
	
	function AsyncSettlePromises(promise) {
	    this._normalQueue._pushOne(promise);
	    this._queueTick();
	}
	
	if (!util.hasDevTools) {
	    Async.prototype.invokeLater = AsyncInvokeLater;
	    Async.prototype.invoke = AsyncInvoke;
	    Async.prototype.settlePromises = AsyncSettlePromises;
	} else {
	    Async.prototype.invokeLater = function (fn, receiver, arg) {
	        if (this._trampolineEnabled) {
	            AsyncInvokeLater.call(this, fn, receiver, arg);
	        } else {
	            this._schedule(function() {
	                setTimeout(function() {
	                    fn.call(receiver, arg);
	                }, 100);
	            });
	        }
	    };
	
	    Async.prototype.invoke = function (fn, receiver, arg) {
	        if (this._trampolineEnabled) {
	            AsyncInvoke.call(this, fn, receiver, arg);
	        } else {
	            this._schedule(function() {
	                fn.call(receiver, arg);
	            });
	        }
	    };
	
	    Async.prototype.settlePromises = function(promise) {
	        if (this._trampolineEnabled) {
	            AsyncSettlePromises.call(this, promise);
	        } else {
	            this._schedule(function() {
	                promise._settlePromises();
	            });
	        }
	    };
	}
	
	Async.prototype.invokeFirst = function (fn, receiver, arg) {
	    this._normalQueue.unshift(fn, receiver, arg);
	    this._queueTick();
	};
	
	Async.prototype._drainQueue = function(queue) {
	    while (queue.length() > 0) {
	        var fn = queue.shift();
	        if (typeof fn !== "function") {
	            fn._settlePromises();
	            continue;
	        }
	        var receiver = queue.shift();
	        var arg = queue.shift();
	        fn.call(receiver, arg);
	    }
	};
	
	Async.prototype._drainQueues = function () {
	    this._drainQueue(this._normalQueue);
	    this._reset();
	    this._haveDrainedQueues = true;
	    this._drainQueue(this._lateQueue);
	};
	
	Async.prototype._queueTick = function () {
	    if (!this._isTickUsed) {
	        this._isTickUsed = true;
	        this._schedule(this.drainQueues);
	    }
	};
	
	Async.prototype._reset = function () {
	    this._isTickUsed = false;
	};
	
	module.exports = Async;
	module.exports.firstLineError = firstLineError;
	
	},{"./queue":17,"./schedule":18,"./util":21}],2:[function(_dereq_,module,exports){
	"use strict";
	module.exports = function(Promise, INTERNAL, tryConvertToPromise, debug) {
	var calledBind = false;
	var rejectThis = function(_, e) {
	    this._reject(e);
	};
	
	var targetRejected = function(e, context) {
	    context.promiseRejectionQueued = true;
	    context.bindingPromise._then(rejectThis, rejectThis, null, this, e);
	};
	
	var bindingResolved = function(thisArg, context) {
	    if (((this._bitField & 50397184) === 0)) {
	        this._resolveCallback(context.target);
	    }
	};
	
	var bindingRejected = function(e, context) {
	    if (!context.promiseRejectionQueued) this._reject(e);
	};
	
	Promise.prototype.bind = function (thisArg) {
	    if (!calledBind) {
	        calledBind = true;
	        Promise.prototype._propagateFrom = debug.propagateFromFunction();
	        Promise.prototype._boundValue = debug.boundValueFunction();
	    }
	    var maybePromise = tryConvertToPromise(thisArg);
	    var ret = new Promise(INTERNAL);
	    ret._propagateFrom(this, 1);
	    var target = this._target();
	    ret._setBoundTo(maybePromise);
	    if (maybePromise instanceof Promise) {
	        var context = {
	            promiseRejectionQueued: false,
	            promise: ret,
	            target: target,
	            bindingPromise: maybePromise
	        };
	        target._then(INTERNAL, targetRejected, undefined, ret, context);
	        maybePromise._then(
	            bindingResolved, bindingRejected, undefined, ret, context);
	        ret._setOnCancel(maybePromise);
	    } else {
	        ret._resolveCallback(target);
	    }
	    return ret;
	};
	
	Promise.prototype._setBoundTo = function (obj) {
	    if (obj !== undefined) {
	        this._bitField = this._bitField | 2097152;
	        this._boundTo = obj;
	    } else {
	        this._bitField = this._bitField & (~2097152);
	    }
	};
	
	Promise.prototype._isBound = function () {
	    return (this._bitField & 2097152) === 2097152;
	};
	
	Promise.bind = function (thisArg, value) {
	    return Promise.resolve(value).bind(thisArg);
	};
	};
	
	},{}],3:[function(_dereq_,module,exports){
	"use strict";
	var old;
	if (typeof Promise !== "undefined") old = Promise;
	function noConflict() {
	    try { if (Promise === bluebird) Promise = old; }
	    catch (e) {}
	    return bluebird;
	}
	var bluebird = _dereq_("./promise")();
	bluebird.noConflict = noConflict;
	module.exports = bluebird;
	
	},{"./promise":15}],4:[function(_dereq_,module,exports){
	"use strict";
	module.exports = function(Promise, PromiseArray, apiRejection, debug) {
	var util = _dereq_("./util");
	var tryCatch = util.tryCatch;
	var errorObj = util.errorObj;
	var async = Promise._async;
	
	Promise.prototype["break"] = Promise.prototype.cancel = function() {
	    if (!debug.cancellation()) return this._warn("cancellation is disabled");
	
	    var promise = this;
	    var child = promise;
	    while (promise.isCancellable()) {
	        if (!promise._cancelBy(child)) {
	            if (child._isFollowing()) {
	                child._followee().cancel();
	            } else {
	                child._cancelBranched();
	            }
	            break;
	        }
	
	        var parent = promise._cancellationParent;
	        if (parent == null || !parent.isCancellable()) {
	            if (promise._isFollowing()) {
	                promise._followee().cancel();
	            } else {
	                promise._cancelBranched();
	            }
	            break;
	        } else {
	            if (promise._isFollowing()) promise._followee().cancel();
	            child = promise;
	            promise = parent;
	        }
	    }
	};
	
	Promise.prototype._branchHasCancelled = function() {
	    this._branchesRemainingToCancel--;
	};
	
	Promise.prototype._enoughBranchesHaveCancelled = function() {
	    return this._branchesRemainingToCancel === undefined ||
	           this._branchesRemainingToCancel <= 0;
	};
	
	Promise.prototype._cancelBy = function(canceller) {
	    if (canceller === this) {
	        this._branchesRemainingToCancel = 0;
	        this._invokeOnCancel();
	        return true;
	    } else {
	        this._branchHasCancelled();
	        if (this._enoughBranchesHaveCancelled()) {
	            this._invokeOnCancel();
	            return true;
	        }
	    }
	    return false;
	};
	
	Promise.prototype._cancelBranched = function() {
	    if (this._enoughBranchesHaveCancelled()) {
	        this._cancel();
	    }
	};
	
	Promise.prototype._cancel = function() {
	    if (!this.isCancellable()) return;
	
	    this._setCancelled();
	    async.invoke(this._cancelPromises, this, undefined);
	};
	
	Promise.prototype._cancelPromises = function() {
	    if (this._length() > 0) this._settlePromises();
	};
	
	Promise.prototype._unsetOnCancel = function() {
	    this._onCancelField = undefined;
	};
	
	Promise.prototype.isCancellable = function() {
	    return this.isPending() && !this.isCancelled();
	};
	
	Promise.prototype._doInvokeOnCancel = function(onCancelCallback, internalOnly) {
	    if (util.isArray(onCancelCallback)) {
	        for (var i = 0; i < onCancelCallback.length; ++i) {
	            this._doInvokeOnCancel(onCancelCallback[i], internalOnly);
	        }
	    } else if (onCancelCallback !== undefined) {
	        if (typeof onCancelCallback === "function") {
	            if (!internalOnly) {
	                var e = tryCatch(onCancelCallback).call(this._boundValue());
	                if (e === errorObj) {
	                    this._attachExtraTrace(e.e);
	                    async.throwLater(e.e);
	                }
	            }
	        } else {
	            onCancelCallback._resultCancelled(this);
	        }
	    }
	};
	
	Promise.prototype._invokeOnCancel = function() {
	    var onCancelCallback = this._onCancel();
	    this._unsetOnCancel();
	    async.invoke(this._doInvokeOnCancel, this, onCancelCallback);
	};
	
	Promise.prototype._invokeInternalOnCancel = function() {
	    if (this.isCancellable()) {
	        this._doInvokeOnCancel(this._onCancel(), true);
	        this._unsetOnCancel();
	    }
	};
	
	Promise.prototype._resultCancelled = function() {
	    this.cancel();
	};
	
	};
	
	},{"./util":21}],5:[function(_dereq_,module,exports){
	"use strict";
	module.exports = function(NEXT_FILTER) {
	var util = _dereq_("./util");
	var getKeys = _dereq_("./es5").keys;
	var tryCatch = util.tryCatch;
	var errorObj = util.errorObj;
	
	function catchFilter(instances, cb, promise) {
	    return function(e) {
	        var boundTo = promise._boundValue();
	        predicateLoop: for (var i = 0; i < instances.length; ++i) {
	            var item = instances[i];
	
	            if (item === Error ||
	                (item != null && item.prototype instanceof Error)) {
	                if (e instanceof item) {
	                    return tryCatch(cb).call(boundTo, e);
	                }
	            } else if (typeof item === "function") {
	                var matchesPredicate = tryCatch(item).call(boundTo, e);
	                if (matchesPredicate === errorObj) {
	                    return matchesPredicate;
	                } else if (matchesPredicate) {
	                    return tryCatch(cb).call(boundTo, e);
	                }
	            } else if (util.isObject(e)) {
	                var keys = getKeys(item);
	                for (var j = 0; j < keys.length; ++j) {
	                    var key = keys[j];
	                    if (item[key] != e[key]) {
	                        continue predicateLoop;
	                    }
	                }
	                return tryCatch(cb).call(boundTo, e);
	            }
	        }
	        return NEXT_FILTER;
	    };
	}
	
	return catchFilter;
	};
	
	},{"./es5":10,"./util":21}],6:[function(_dereq_,module,exports){
	"use strict";
	module.exports = function(Promise) {
	var longStackTraces = false;
	var contextStack = [];
	
	Promise.prototype._promiseCreated = function() {};
	Promise.prototype._pushContext = function() {};
	Promise.prototype._popContext = function() {return null;};
	Promise._peekContext = Promise.prototype._peekContext = function() {};
	
	function Context() {
	    this._trace = new Context.CapturedTrace(peekContext());
	}
	Context.prototype._pushContext = function () {
	    if (this._trace !== undefined) {
	        this._trace._promiseCreated = null;
	        contextStack.push(this._trace);
	    }
	};
	
	Context.prototype._popContext = function () {
	    if (this._trace !== undefined) {
	        var trace = contextStack.pop();
	        var ret = trace._promiseCreated;
	        trace._promiseCreated = null;
	        return ret;
	    }
	    return null;
	};
	
	function createContext() {
	    if (longStackTraces) return new Context();
	}
	
	function peekContext() {
	    var lastIndex = contextStack.length - 1;
	    if (lastIndex >= 0) {
	        return contextStack[lastIndex];
	    }
	    return undefined;
	}
	Context.CapturedTrace = null;
	Context.create = createContext;
	Context.deactivateLongStackTraces = function() {};
	Context.activateLongStackTraces = function() {
	    var Promise_pushContext = Promise.prototype._pushContext;
	    var Promise_popContext = Promise.prototype._popContext;
	    var Promise_PeekContext = Promise._peekContext;
	    var Promise_peekContext = Promise.prototype._peekContext;
	    var Promise_promiseCreated = Promise.prototype._promiseCreated;
	    Context.deactivateLongStackTraces = function() {
	        Promise.prototype._pushContext = Promise_pushContext;
	        Promise.prototype._popContext = Promise_popContext;
	        Promise._peekContext = Promise_PeekContext;
	        Promise.prototype._peekContext = Promise_peekContext;
	        Promise.prototype._promiseCreated = Promise_promiseCreated;
	        longStackTraces = false;
	    };
	    longStackTraces = true;
	    Promise.prototype._pushContext = Context.prototype._pushContext;
	    Promise.prototype._popContext = Context.prototype._popContext;
	    Promise._peekContext = Promise.prototype._peekContext = peekContext;
	    Promise.prototype._promiseCreated = function() {
	        var ctx = this._peekContext();
	        if (ctx && ctx._promiseCreated == null) ctx._promiseCreated = this;
	    };
	};
	return Context;
	};
	
	},{}],7:[function(_dereq_,module,exports){
	"use strict";
	module.exports = function(Promise, Context) {
	var getDomain = Promise._getDomain;
	var async = Promise._async;
	var Warning = _dereq_("./errors").Warning;
	var util = _dereq_("./util");
	var canAttachTrace = util.canAttachTrace;
	var unhandledRejectionHandled;
	var possiblyUnhandledRejection;
	var bluebirdFramePattern =
	    /[\\\/]bluebird[\\\/]js[\\\/](release|debug|instrumented)/;
	var stackFramePattern = null;
	var formatStack = null;
	var indentStackFrames = false;
	var printWarning;
	var debugging = !!(util.env("BLUEBIRD_DEBUG") != 0 &&
	                        (true ||
	                         util.env("BLUEBIRD_DEBUG") ||
	                         util.env("NODE_ENV") === "development"));
	
	var warnings = !!(util.env("BLUEBIRD_WARNINGS") != 0 &&
	    (debugging || util.env("BLUEBIRD_WARNINGS")));
	
	var longStackTraces = !!(util.env("BLUEBIRD_LONG_STACK_TRACES") != 0 &&
	    (debugging || util.env("BLUEBIRD_LONG_STACK_TRACES")));
	
	var wForgottenReturn = util.env("BLUEBIRD_W_FORGOTTEN_RETURN") != 0 &&
	    (warnings || !!util.env("BLUEBIRD_W_FORGOTTEN_RETURN"));
	
	Promise.prototype.suppressUnhandledRejections = function() {
	    var target = this._target();
	    target._bitField = ((target._bitField & (~1048576)) |
	                      524288);
	};
	
	Promise.prototype._ensurePossibleRejectionHandled = function () {
	    if ((this._bitField & 524288) !== 0) return;
	    this._setRejectionIsUnhandled();
	    async.invokeLater(this._notifyUnhandledRejection, this, undefined);
	};
	
	Promise.prototype._notifyUnhandledRejectionIsHandled = function () {
	    fireRejectionEvent("rejectionHandled",
	                                  unhandledRejectionHandled, undefined, this);
	};
	
	Promise.prototype._setReturnedNonUndefined = function() {
	    this._bitField = this._bitField | 268435456;
	};
	
	Promise.prototype._returnedNonUndefined = function() {
	    return (this._bitField & 268435456) !== 0;
	};
	
	Promise.prototype._notifyUnhandledRejection = function () {
	    if (this._isRejectionUnhandled()) {
	        var reason = this._settledValue();
	        this._setUnhandledRejectionIsNotified();
	        fireRejectionEvent("unhandledRejection",
	                                      possiblyUnhandledRejection, reason, this);
	    }
	};
	
	Promise.prototype._setUnhandledRejectionIsNotified = function () {
	    this._bitField = this._bitField | 262144;
	};
	
	Promise.prototype._unsetUnhandledRejectionIsNotified = function () {
	    this._bitField = this._bitField & (~262144);
	};
	
	Promise.prototype._isUnhandledRejectionNotified = function () {
	    return (this._bitField & 262144) > 0;
	};
	
	Promise.prototype._setRejectionIsUnhandled = function () {
	    this._bitField = this._bitField | 1048576;
	};
	
	Promise.prototype._unsetRejectionIsUnhandled = function () {
	    this._bitField = this._bitField & (~1048576);
	    if (this._isUnhandledRejectionNotified()) {
	        this._unsetUnhandledRejectionIsNotified();
	        this._notifyUnhandledRejectionIsHandled();
	    }
	};
	
	Promise.prototype._isRejectionUnhandled = function () {
	    return (this._bitField & 1048576) > 0;
	};
	
	Promise.prototype._warn = function(message, shouldUseOwnTrace, promise) {
	    return warn(message, shouldUseOwnTrace, promise || this);
	};
	
	Promise.onPossiblyUnhandledRejection = function (fn) {
	    var domain = getDomain();
	    possiblyUnhandledRejection =
	        typeof fn === "function" ? (domain === null ? fn : domain.bind(fn))
	                                 : undefined;
	};
	
	Promise.onUnhandledRejectionHandled = function (fn) {
	    var domain = getDomain();
	    unhandledRejectionHandled =
	        typeof fn === "function" ? (domain === null ? fn : domain.bind(fn))
	                                 : undefined;
	};
	
	var disableLongStackTraces = function() {};
	Promise.longStackTraces = function () {
	    if (async.haveItemsQueued() && !config.longStackTraces) {
	        throw new Error("cannot enable long stack traces after promises have been created\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
	    }
	    if (!config.longStackTraces && longStackTracesIsSupported()) {
	        var Promise_captureStackTrace = Promise.prototype._captureStackTrace;
	        var Promise_attachExtraTrace = Promise.prototype._attachExtraTrace;
	        config.longStackTraces = true;
	        disableLongStackTraces = function() {
	            if (async.haveItemsQueued() && !config.longStackTraces) {
	                throw new Error("cannot enable long stack traces after promises have been created\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
	            }
	            Promise.prototype._captureStackTrace = Promise_captureStackTrace;
	            Promise.prototype._attachExtraTrace = Promise_attachExtraTrace;
	            Context.deactivateLongStackTraces();
	            async.enableTrampoline();
	            config.longStackTraces = false;
	        };
	        Promise.prototype._captureStackTrace = longStackTracesCaptureStackTrace;
	        Promise.prototype._attachExtraTrace = longStackTracesAttachExtraTrace;
	        Context.activateLongStackTraces();
	        async.disableTrampolineIfNecessary();
	    }
	};
	
	Promise.hasLongStackTraces = function () {
	    return config.longStackTraces && longStackTracesIsSupported();
	};
	
	var fireDomEvent = (function() {
	    try {
	        var event = document.createEvent("CustomEvent");
	        event.initCustomEvent("testingtheevent", false, true, {});
	        util.global.dispatchEvent(event);
	        return function(name, event) {
	            var domEvent = document.createEvent("CustomEvent");
	            domEvent.initCustomEvent(name.toLowerCase(), false, true, event);
	            return !util.global.dispatchEvent(domEvent);
	        };
	    } catch (e) {}
	    return function() {
	        return false;
	    };
	})();
	
	var fireGlobalEvent = (function() {
	    if (util.isNode) {
	        return function() {
	            return process.emit.apply(process, arguments);
	        };
	    } else {
	        if (!util.global) {
	            return function() {
	                return false;
	            };
	        }
	        return function(name) {
	            var methodName = "on" + name.toLowerCase();
	            var method = util.global[methodName];
	            if (!method) return false;
	            method.apply(util.global, [].slice.call(arguments, 1));
	            return true;
	        };
	    }
	})();
	
	function generatePromiseLifecycleEventObject(name, promise) {
	    return {promise: promise};
	}
	
	var eventToObjectGenerator = {
	    promiseCreated: generatePromiseLifecycleEventObject,
	    promiseFulfilled: generatePromiseLifecycleEventObject,
	    promiseRejected: generatePromiseLifecycleEventObject,
	    promiseResolved: generatePromiseLifecycleEventObject,
	    promiseCancelled: generatePromiseLifecycleEventObject,
	    promiseChained: function(name, promise, child) {
	        return {promise: promise, child: child};
	    },
	    warning: function(name, warning) {
	        return {warning: warning};
	    },
	    unhandledRejection: function (name, reason, promise) {
	        return {reason: reason, promise: promise};
	    },
	    rejectionHandled: generatePromiseLifecycleEventObject
	};
	
	var activeFireEvent = function (name) {
	    var globalEventFired = false;
	    try {
	        globalEventFired = fireGlobalEvent.apply(null, arguments);
	    } catch (e) {
	        async.throwLater(e);
	        globalEventFired = true;
	    }
	
	    var domEventFired = false;
	    try {
	        domEventFired = fireDomEvent(name,
	                    eventToObjectGenerator[name].apply(null, arguments));
	    } catch (e) {
	        async.throwLater(e);
	        domEventFired = true;
	    }
	
	    return domEventFired || globalEventFired;
	};
	
	Promise.config = function(opts) {
	    opts = Object(opts);
	    if ("longStackTraces" in opts) {
	        if (opts.longStackTraces) {
	            Promise.longStackTraces();
	        } else if (!opts.longStackTraces && Promise.hasLongStackTraces()) {
	            disableLongStackTraces();
	        }
	    }
	    if ("warnings" in opts) {
	        var warningsOption = opts.warnings;
	        config.warnings = !!warningsOption;
	        wForgottenReturn = config.warnings;
	
	        if (util.isObject(warningsOption)) {
	            if ("wForgottenReturn" in warningsOption) {
	                wForgottenReturn = !!warningsOption.wForgottenReturn;
	            }
	        }
	    }
	    if ("cancellation" in opts && opts.cancellation && !config.cancellation) {
	        if (async.haveItemsQueued()) {
	            throw new Error(
	                "cannot enable cancellation after promises are in use");
	        }
	        Promise.prototype._clearCancellationData =
	            cancellationClearCancellationData;
	        Promise.prototype._propagateFrom = cancellationPropagateFrom;
	        Promise.prototype._onCancel = cancellationOnCancel;
	        Promise.prototype._setOnCancel = cancellationSetOnCancel;
	        Promise.prototype._attachCancellationCallback =
	            cancellationAttachCancellationCallback;
	        Promise.prototype._execute = cancellationExecute;
	        propagateFromFunction = cancellationPropagateFrom;
	        config.cancellation = true;
	    }
	    if ("monitoring" in opts) {
	        if (opts.monitoring && !config.monitoring) {
	            config.monitoring = true;
	            Promise.prototype._fireEvent = activeFireEvent;
	        } else if (!opts.monitoring && config.monitoring) {
	            config.monitoring = false;
	            Promise.prototype._fireEvent = defaultFireEvent;
	        }
	    }
	};
	
	function defaultFireEvent() { return false; }
	
	Promise.prototype._fireEvent = defaultFireEvent;
	Promise.prototype._execute = function(executor, resolve, reject) {
	    try {
	        executor(resolve, reject);
	    } catch (e) {
	        return e;
	    }
	};
	Promise.prototype._onCancel = function () {};
	Promise.prototype._setOnCancel = function (handler) { ; };
	Promise.prototype._attachCancellationCallback = function(onCancel) {
	    ;
	};
	Promise.prototype._captureStackTrace = function () {};
	Promise.prototype._attachExtraTrace = function () {};
	Promise.prototype._clearCancellationData = function() {};
	Promise.prototype._propagateFrom = function (parent, flags) {
	    ;
	    ;
	};
	
	function cancellationExecute(executor, resolve, reject) {
	    var promise = this;
	    try {
	        executor(resolve, reject, function(onCancel) {
	            if (typeof onCancel !== "function") {
	                throw new TypeError("onCancel must be a function, got: " +
	                                    util.toString(onCancel));
	            }
	            promise._attachCancellationCallback(onCancel);
	        });
	    } catch (e) {
	        return e;
	    }
	}
	
	function cancellationAttachCancellationCallback(onCancel) {
	    if (!this.isCancellable()) return this;
	
	    var previousOnCancel = this._onCancel();
	    if (previousOnCancel !== undefined) {
	        if (util.isArray(previousOnCancel)) {
	            previousOnCancel.push(onCancel);
	        } else {
	            this._setOnCancel([previousOnCancel, onCancel]);
	        }
	    } else {
	        this._setOnCancel(onCancel);
	    }
	}
	
	function cancellationOnCancel() {
	    return this._onCancelField;
	}
	
	function cancellationSetOnCancel(onCancel) {
	    this._onCancelField = onCancel;
	}
	
	function cancellationClearCancellationData() {
	    this._cancellationParent = undefined;
	    this._onCancelField = undefined;
	}
	
	function cancellationPropagateFrom(parent, flags) {
	    if ((flags & 1) !== 0) {
	        this._cancellationParent = parent;
	        var branchesRemainingToCancel = parent._branchesRemainingToCancel;
	        if (branchesRemainingToCancel === undefined) {
	            branchesRemainingToCancel = 0;
	        }
	        parent._branchesRemainingToCancel = branchesRemainingToCancel + 1;
	    }
	    if ((flags & 2) !== 0 && parent._isBound()) {
	        this._setBoundTo(parent._boundTo);
	    }
	}
	
	function bindingPropagateFrom(parent, flags) {
	    if ((flags & 2) !== 0 && parent._isBound()) {
	        this._setBoundTo(parent._boundTo);
	    }
	}
	var propagateFromFunction = bindingPropagateFrom;
	
	function boundValueFunction() {
	    var ret = this._boundTo;
	    if (ret !== undefined) {
	        if (ret instanceof Promise) {
	            if (ret.isFulfilled()) {
	                return ret.value();
	            } else {
	                return undefined;
	            }
	        }
	    }
	    return ret;
	}
	
	function longStackTracesCaptureStackTrace() {
	    this._trace = new CapturedTrace(this._peekContext());
	}
	
	function longStackTracesAttachExtraTrace(error, ignoreSelf) {
	    if (canAttachTrace(error)) {
	        var trace = this._trace;
	        if (trace !== undefined) {
	            if (ignoreSelf) trace = trace._parent;
	        }
	        if (trace !== undefined) {
	            trace.attachExtraTrace(error);
	        } else if (!error.__stackCleaned__) {
	            var parsed = parseStackAndMessage(error);
	            util.notEnumerableProp(error, "stack",
	                parsed.message + "\n" + parsed.stack.join("\n"));
	            util.notEnumerableProp(error, "__stackCleaned__", true);
	        }
	    }
	}
	
	function checkForgottenReturns(returnValue, promiseCreated, name, promise,
	                               parent) {
	    if (returnValue === undefined && promiseCreated !== null &&
	        wForgottenReturn) {
	        if (parent !== undefined && parent._returnedNonUndefined()) return;
	        if ((promise._bitField & 65535) === 0) return;
	
	        if (name) name = name + " ";
	        var msg = "a promise was created in a " + name +
	            "handler but was not returned from it";
	        promise._warn(msg, true, promiseCreated);
	    }
	}
	
	function deprecated(name, replacement) {
	    var message = name +
	        " is deprecated and will be removed in a future version.";
	    if (replacement) message += " Use " + replacement + " instead.";
	    return warn(message);
	}
	
	function warn(message, shouldUseOwnTrace, promise) {
	    if (!config.warnings) return;
	    var warning = new Warning(message);
	    var ctx;
	    if (shouldUseOwnTrace) {
	        promise._attachExtraTrace(warning);
	    } else if (config.longStackTraces && (ctx = Promise._peekContext())) {
	        ctx.attachExtraTrace(warning);
	    } else {
	        var parsed = parseStackAndMessage(warning);
	        warning.stack = parsed.message + "\n" + parsed.stack.join("\n");
	    }
	
	    if (!activeFireEvent("warning", warning)) {
	        formatAndLogError(warning, "", true);
	    }
	}
	
	function reconstructStack(message, stacks) {
	    for (var i = 0; i < stacks.length - 1; ++i) {
	        stacks[i].push("From previous event:");
	        stacks[i] = stacks[i].join("\n");
	    }
	    if (i < stacks.length) {
	        stacks[i] = stacks[i].join("\n");
	    }
	    return message + "\n" + stacks.join("\n");
	}
	
	function removeDuplicateOrEmptyJumps(stacks) {
	    for (var i = 0; i < stacks.length; ++i) {
	        if (stacks[i].length === 0 ||
	            ((i + 1 < stacks.length) && stacks[i][0] === stacks[i+1][0])) {
	            stacks.splice(i, 1);
	            i--;
	        }
	    }
	}
	
	function removeCommonRoots(stacks) {
	    var current = stacks[0];
	    for (var i = 1; i < stacks.length; ++i) {
	        var prev = stacks[i];
	        var currentLastIndex = current.length - 1;
	        var currentLastLine = current[currentLastIndex];
	        var commonRootMeetPoint = -1;
	
	        for (var j = prev.length - 1; j >= 0; --j) {
	            if (prev[j] === currentLastLine) {
	                commonRootMeetPoint = j;
	                break;
	            }
	        }
	
	        for (var j = commonRootMeetPoint; j >= 0; --j) {
	            var line = prev[j];
	            if (current[currentLastIndex] === line) {
	                current.pop();
	                currentLastIndex--;
	            } else {
	                break;
	            }
	        }
	        current = prev;
	    }
	}
	
	function cleanStack(stack) {
	    var ret = [];
	    for (var i = 0; i < stack.length; ++i) {
	        var line = stack[i];
	        var isTraceLine = "    (No stack trace)" === line ||
	            stackFramePattern.test(line);
	        var isInternalFrame = isTraceLine && shouldIgnore(line);
	        if (isTraceLine && !isInternalFrame) {
	            if (indentStackFrames && line.charAt(0) !== " ") {
	                line = "    " + line;
	            }
	            ret.push(line);
	        }
	    }
	    return ret;
	}
	
	function stackFramesAsArray(error) {
	    var stack = error.stack.replace(/\s+$/g, "").split("\n");
	    for (var i = 0; i < stack.length; ++i) {
	        var line = stack[i];
	        if ("    (No stack trace)" === line || stackFramePattern.test(line)) {
	            break;
	        }
	    }
	    if (i > 0) {
	        stack = stack.slice(i);
	    }
	    return stack;
	}
	
	function parseStackAndMessage(error) {
	    var stack = error.stack;
	    var message = error.toString();
	    stack = typeof stack === "string" && stack.length > 0
	                ? stackFramesAsArray(error) : ["    (No stack trace)"];
	    return {
	        message: message,
	        stack: cleanStack(stack)
	    };
	}
	
	function formatAndLogError(error, title, isSoft) {
	    if (typeof console !== "undefined") {
	        var message;
	        if (util.isObject(error)) {
	            var stack = error.stack;
	            message = title + formatStack(stack, error);
	        } else {
	            message = title + String(error);
	        }
	        if (typeof printWarning === "function") {
	            printWarning(message, isSoft);
	        } else if (typeof console.log === "function" ||
	            typeof console.log === "object") {
	            console.log(message);
	        }
	    }
	}
	
	function fireRejectionEvent(name, localHandler, reason, promise) {
	    var localEventFired = false;
	    try {
	        if (typeof localHandler === "function") {
	            localEventFired = true;
	            if (name === "rejectionHandled") {
	                localHandler(promise);
	            } else {
	                localHandler(reason, promise);
	            }
	        }
	    } catch (e) {
	        async.throwLater(e);
	    }
	
	    if (name === "unhandledRejection") {
	        if (!activeFireEvent(name, reason, promise) && !localEventFired) {
	            formatAndLogError(reason, "Unhandled rejection ");
	        }
	    } else {
	        activeFireEvent(name, promise);
	    }
	}
	
	function formatNonError(obj) {
	    var str;
	    if (typeof obj === "function") {
	        str = "[function " +
	            (obj.name || "anonymous") +
	            "]";
	    } else {
	        str = obj && typeof obj.toString === "function"
	            ? obj.toString() : util.toString(obj);
	        var ruselessToString = /\[object [a-zA-Z0-9$_]+\]/;
	        if (ruselessToString.test(str)) {
	            try {
	                var newStr = JSON.stringify(obj);
	                str = newStr;
	            }
	            catch(e) {
	
	            }
	        }
	        if (str.length === 0) {
	            str = "(empty array)";
	        }
	    }
	    return ("(<" + snip(str) + ">, no stack trace)");
	}
	
	function snip(str) {
	    var maxChars = 41;
	    if (str.length < maxChars) {
	        return str;
	    }
	    return str.substr(0, maxChars - 3) + "...";
	}
	
	function longStackTracesIsSupported() {
	    return typeof captureStackTrace === "function";
	}
	
	var shouldIgnore = function() { return false; };
	var parseLineInfoRegex = /[\/<\(]([^:\/]+):(\d+):(?:\d+)\)?\s*$/;
	function parseLineInfo(line) {
	    var matches = line.match(parseLineInfoRegex);
	    if (matches) {
	        return {
	            fileName: matches[1],
	            line: parseInt(matches[2], 10)
	        };
	    }
	}
	
	function setBounds(firstLineError, lastLineError) {
	    if (!longStackTracesIsSupported()) return;
	    var firstStackLines = firstLineError.stack.split("\n");
	    var lastStackLines = lastLineError.stack.split("\n");
	    var firstIndex = -1;
	    var lastIndex = -1;
	    var firstFileName;
	    var lastFileName;
	    for (var i = 0; i < firstStackLines.length; ++i) {
	        var result = parseLineInfo(firstStackLines[i]);
	        if (result) {
	            firstFileName = result.fileName;
	            firstIndex = result.line;
	            break;
	        }
	    }
	    for (var i = 0; i < lastStackLines.length; ++i) {
	        var result = parseLineInfo(lastStackLines[i]);
	        if (result) {
	            lastFileName = result.fileName;
	            lastIndex = result.line;
	            break;
	        }
	    }
	    if (firstIndex < 0 || lastIndex < 0 || !firstFileName || !lastFileName ||
	        firstFileName !== lastFileName || firstIndex >= lastIndex) {
	        return;
	    }
	
	    shouldIgnore = function(line) {
	        if (bluebirdFramePattern.test(line)) return true;
	        var info = parseLineInfo(line);
	        if (info) {
	            if (info.fileName === firstFileName &&
	                (firstIndex <= info.line && info.line <= lastIndex)) {
	                return true;
	            }
	        }
	        return false;
	    };
	}
	
	function CapturedTrace(parent) {
	    this._parent = parent;
	    this._promisesCreated = 0;
	    var length = this._length = 1 + (parent === undefined ? 0 : parent._length);
	    captureStackTrace(this, CapturedTrace);
	    if (length > 32) this.uncycle();
	}
	util.inherits(CapturedTrace, Error);
	Context.CapturedTrace = CapturedTrace;
	
	CapturedTrace.prototype.uncycle = function() {
	    var length = this._length;
	    if (length < 2) return;
	    var nodes = [];
	    var stackToIndex = {};
	
	    for (var i = 0, node = this; node !== undefined; ++i) {
	        nodes.push(node);
	        node = node._parent;
	    }
	    length = this._length = i;
	    for (var i = length - 1; i >= 0; --i) {
	        var stack = nodes[i].stack;
	        if (stackToIndex[stack] === undefined) {
	            stackToIndex[stack] = i;
	        }
	    }
	    for (var i = 0; i < length; ++i) {
	        var currentStack = nodes[i].stack;
	        var index = stackToIndex[currentStack];
	        if (index !== undefined && index !== i) {
	            if (index > 0) {
	                nodes[index - 1]._parent = undefined;
	                nodes[index - 1]._length = 1;
	            }
	            nodes[i]._parent = undefined;
	            nodes[i]._length = 1;
	            var cycleEdgeNode = i > 0 ? nodes[i - 1] : this;
	
	            if (index < length - 1) {
	                cycleEdgeNode._parent = nodes[index + 1];
	                cycleEdgeNode._parent.uncycle();
	                cycleEdgeNode._length =
	                    cycleEdgeNode._parent._length + 1;
	            } else {
	                cycleEdgeNode._parent = undefined;
	                cycleEdgeNode._length = 1;
	            }
	            var currentChildLength = cycleEdgeNode._length + 1;
	            for (var j = i - 2; j >= 0; --j) {
	                nodes[j]._length = currentChildLength;
	                currentChildLength++;
	            }
	            return;
	        }
	    }
	};
	
	CapturedTrace.prototype.attachExtraTrace = function(error) {
	    if (error.__stackCleaned__) return;
	    this.uncycle();
	    var parsed = parseStackAndMessage(error);
	    var message = parsed.message;
	    var stacks = [parsed.stack];
	
	    var trace = this;
	    while (trace !== undefined) {
	        stacks.push(cleanStack(trace.stack.split("\n")));
	        trace = trace._parent;
	    }
	    removeCommonRoots(stacks);
	    removeDuplicateOrEmptyJumps(stacks);
	    util.notEnumerableProp(error, "stack", reconstructStack(message, stacks));
	    util.notEnumerableProp(error, "__stackCleaned__", true);
	};
	
	var captureStackTrace = (function stackDetection() {
	    var v8stackFramePattern = /^\s*at\s*/;
	    var v8stackFormatter = function(stack, error) {
	        if (typeof stack === "string") return stack;
	
	        if (error.name !== undefined &&
	            error.message !== undefined) {
	            return error.toString();
	        }
	        return formatNonError(error);
	    };
	
	    if (typeof Error.stackTraceLimit === "number" &&
	        typeof Error.captureStackTrace === "function") {
	        Error.stackTraceLimit += 6;
	        stackFramePattern = v8stackFramePattern;
	        formatStack = v8stackFormatter;
	        var captureStackTrace = Error.captureStackTrace;
	
	        shouldIgnore = function(line) {
	            return bluebirdFramePattern.test(line);
	        };
	        return function(receiver, ignoreUntil) {
	            Error.stackTraceLimit += 6;
	            captureStackTrace(receiver, ignoreUntil);
	            Error.stackTraceLimit -= 6;
	        };
	    }
	    var err = new Error();
	
	    if (typeof err.stack === "string" &&
	        err.stack.split("\n")[0].indexOf("stackDetection@") >= 0) {
	        stackFramePattern = /@/;
	        formatStack = v8stackFormatter;
	        indentStackFrames = true;
	        return function captureStackTrace(o) {
	            o.stack = new Error().stack;
	        };
	    }
	
	    var hasStackAfterThrow;
	    try { throw new Error(); }
	    catch(e) {
	        hasStackAfterThrow = ("stack" in e);
	    }
	    if (!("stack" in err) && hasStackAfterThrow &&
	        typeof Error.stackTraceLimit === "number") {
	        stackFramePattern = v8stackFramePattern;
	        formatStack = v8stackFormatter;
	        return function captureStackTrace(o) {
	            Error.stackTraceLimit += 6;
	            try { throw new Error(); }
	            catch(e) { o.stack = e.stack; }
	            Error.stackTraceLimit -= 6;
	        };
	    }
	
	    formatStack = function(stack, error) {
	        if (typeof stack === "string") return stack;
	
	        if ((typeof error === "object" ||
	            typeof error === "function") &&
	            error.name !== undefined &&
	            error.message !== undefined) {
	            return error.toString();
	        }
	        return formatNonError(error);
	    };
	
	    return null;
	
	})([]);
	
	if (typeof console !== "undefined" && typeof console.warn !== "undefined") {
	    printWarning = function (message) {
	        console.warn(message);
	    };
	    if (util.isNode && process.stderr.isTTY) {
	        printWarning = function(message, isSoft) {
	            var color = isSoft ? "\u001b[33m" : "\u001b[31m";
	            console.warn(color + message + "\u001b[0m\n");
	        };
	    } else if (!util.isNode && typeof (new Error().stack) === "string") {
	        printWarning = function(message, isSoft) {
	            console.warn("%c" + message,
	                        isSoft ? "color: darkorange" : "color: red");
	        };
	    }
	}
	
	var config = {
	    warnings: warnings,
	    longStackTraces: false,
	    cancellation: false,
	    monitoring: false
	};
	
	if (longStackTraces) Promise.longStackTraces();
	
	return {
	    longStackTraces: function() {
	        return config.longStackTraces;
	    },
	    warnings: function() {
	        return config.warnings;
	    },
	    cancellation: function() {
	        return config.cancellation;
	    },
	    monitoring: function() {
	        return config.monitoring;
	    },
	    propagateFromFunction: function() {
	        return propagateFromFunction;
	    },
	    boundValueFunction: function() {
	        return boundValueFunction;
	    },
	    checkForgottenReturns: checkForgottenReturns,
	    setBounds: setBounds,
	    warn: warn,
	    deprecated: deprecated,
	    CapturedTrace: CapturedTrace,
	    fireDomEvent: fireDomEvent,
	    fireGlobalEvent: fireGlobalEvent
	};
	};
	
	},{"./errors":9,"./util":21}],8:[function(_dereq_,module,exports){
	"use strict";
	module.exports = function(Promise) {
	function returner() {
	    return this.value;
	}
	function thrower() {
	    throw this.reason;
	}
	
	Promise.prototype["return"] =
	Promise.prototype.thenReturn = function (value) {
	    if (value instanceof Promise) value.suppressUnhandledRejections();
	    return this._then(
	        returner, undefined, undefined, {value: value}, undefined);
	};
	
	Promise.prototype["throw"] =
	Promise.prototype.thenThrow = function (reason) {
	    return this._then(
	        thrower, undefined, undefined, {reason: reason}, undefined);
	};
	
	Promise.prototype.catchThrow = function (reason) {
	    if (arguments.length <= 1) {
	        return this._then(
	            undefined, thrower, undefined, {reason: reason}, undefined);
	    } else {
	        var _reason = arguments[1];
	        var handler = function() {throw _reason;};
	        return this.caught(reason, handler);
	    }
	};
	
	Promise.prototype.catchReturn = function (value) {
	    if (arguments.length <= 1) {
	        if (value instanceof Promise) value.suppressUnhandledRejections();
	        return this._then(
	            undefined, returner, undefined, {value: value}, undefined);
	    } else {
	        var _value = arguments[1];
	        if (_value instanceof Promise) _value.suppressUnhandledRejections();
	        var handler = function() {return _value;};
	        return this.caught(value, handler);
	    }
	};
	};
	
	},{}],9:[function(_dereq_,module,exports){
	"use strict";
	var es5 = _dereq_("./es5");
	var Objectfreeze = es5.freeze;
	var util = _dereq_("./util");
	var inherits = util.inherits;
	var notEnumerableProp = util.notEnumerableProp;
	
	function subError(nameProperty, defaultMessage) {
	    function SubError(message) {
	        if (!(this instanceof SubError)) return new SubError(message);
	        notEnumerableProp(this, "message",
	            typeof message === "string" ? message : defaultMessage);
	        notEnumerableProp(this, "name", nameProperty);
	        if (Error.captureStackTrace) {
	            Error.captureStackTrace(this, this.constructor);
	        } else {
	            Error.call(this);
	        }
	    }
	    inherits(SubError, Error);
	    return SubError;
	}
	
	var _TypeError, _RangeError;
	var Warning = subError("Warning", "warning");
	var CancellationError = subError("CancellationError", "cancellation error");
	var TimeoutError = subError("TimeoutError", "timeout error");
	var AggregateError = subError("AggregateError", "aggregate error");
	try {
	    _TypeError = TypeError;
	    _RangeError = RangeError;
	} catch(e) {
	    _TypeError = subError("TypeError", "type error");
	    _RangeError = subError("RangeError", "range error");
	}
	
	var methods = ("join pop push shift unshift slice filter forEach some " +
	    "every map indexOf lastIndexOf reduce reduceRight sort reverse").split(" ");
	
	for (var i = 0; i < methods.length; ++i) {
	    if (typeof Array.prototype[methods[i]] === "function") {
	        AggregateError.prototype[methods[i]] = Array.prototype[methods[i]];
	    }
	}
	
	es5.defineProperty(AggregateError.prototype, "length", {
	    value: 0,
	    configurable: false,
	    writable: true,
	    enumerable: true
	});
	AggregateError.prototype["isOperational"] = true;
	var level = 0;
	AggregateError.prototype.toString = function() {
	    var indent = Array(level * 4 + 1).join(" ");
	    var ret = "\n" + indent + "AggregateError of:" + "\n";
	    level++;
	    indent = Array(level * 4 + 1).join(" ");
	    for (var i = 0; i < this.length; ++i) {
	        var str = this[i] === this ? "[Circular AggregateError]" : this[i] + "";
	        var lines = str.split("\n");
	        for (var j = 0; j < lines.length; ++j) {
	            lines[j] = indent + lines[j];
	        }
	        str = lines.join("\n");
	        ret += str + "\n";
	    }
	    level--;
	    return ret;
	};
	
	function OperationalError(message) {
	    if (!(this instanceof OperationalError))
	        return new OperationalError(message);
	    notEnumerableProp(this, "name", "OperationalError");
	    notEnumerableProp(this, "message", message);
	    this.cause = message;
	    this["isOperational"] = true;
	
	    if (message instanceof Error) {
	        notEnumerableProp(this, "message", message.message);
	        notEnumerableProp(this, "stack", message.stack);
	    } else if (Error.captureStackTrace) {
	        Error.captureStackTrace(this, this.constructor);
	    }
	
	}
	inherits(OperationalError, Error);
	
	var errorTypes = Error["__BluebirdErrorTypes__"];
	if (!errorTypes) {
	    errorTypes = Objectfreeze({
	        CancellationError: CancellationError,
	        TimeoutError: TimeoutError,
	        OperationalError: OperationalError,
	        RejectionError: OperationalError,
	        AggregateError: AggregateError
	    });
	    es5.defineProperty(Error, "__BluebirdErrorTypes__", {
	        value: errorTypes,
	        writable: false,
	        enumerable: false,
	        configurable: false
	    });
	}
	
	module.exports = {
	    Error: Error,
	    TypeError: _TypeError,
	    RangeError: _RangeError,
	    CancellationError: errorTypes.CancellationError,
	    OperationalError: errorTypes.OperationalError,
	    TimeoutError: errorTypes.TimeoutError,
	    AggregateError: errorTypes.AggregateError,
	    Warning: Warning
	};
	
	},{"./es5":10,"./util":21}],10:[function(_dereq_,module,exports){
	var isES5 = (function(){
	    "use strict";
	    return this === undefined;
	})();
	
	if (isES5) {
	    module.exports = {
	        freeze: Object.freeze,
	        defineProperty: Object.defineProperty,
	        getDescriptor: Object.getOwnPropertyDescriptor,
	        keys: Object.keys,
	        names: Object.getOwnPropertyNames,
	        getPrototypeOf: Object.getPrototypeOf,
	        isArray: Array.isArray,
	        isES5: isES5,
	        propertyIsWritable: function(obj, prop) {
	            var descriptor = Object.getOwnPropertyDescriptor(obj, prop);
	            return !!(!descriptor || descriptor.writable || descriptor.set);
	        }
	    };
	} else {
	    var has = {}.hasOwnProperty;
	    var str = {}.toString;
	    var proto = {}.constructor.prototype;
	
	    var ObjectKeys = function (o) {
	        var ret = [];
	        for (var key in o) {
	            if (has.call(o, key)) {
	                ret.push(key);
	            }
	        }
	        return ret;
	    };
	
	    var ObjectGetDescriptor = function(o, key) {
	        return {value: o[key]};
	    };
	
	    var ObjectDefineProperty = function (o, key, desc) {
	        o[key] = desc.value;
	        return o;
	    };
	
	    var ObjectFreeze = function (obj) {
	        return obj;
	    };
	
	    var ObjectGetPrototypeOf = function (obj) {
	        try {
	            return Object(obj).constructor.prototype;
	        }
	        catch (e) {
	            return proto;
	        }
	    };
	
	    var ArrayIsArray = function (obj) {
	        try {
	            return str.call(obj) === "[object Array]";
	        }
	        catch(e) {
	            return false;
	        }
	    };
	
	    module.exports = {
	        isArray: ArrayIsArray,
	        keys: ObjectKeys,
	        names: ObjectKeys,
	        defineProperty: ObjectDefineProperty,
	        getDescriptor: ObjectGetDescriptor,
	        freeze: ObjectFreeze,
	        getPrototypeOf: ObjectGetPrototypeOf,
	        isES5: isES5,
	        propertyIsWritable: function() {
	            return true;
	        }
	    };
	}
	
	},{}],11:[function(_dereq_,module,exports){
	"use strict";
	module.exports = function(Promise, tryConvertToPromise) {
	var util = _dereq_("./util");
	var CancellationError = Promise.CancellationError;
	var errorObj = util.errorObj;
	
	function PassThroughHandlerContext(promise, type, handler) {
	    this.promise = promise;
	    this.type = type;
	    this.handler = handler;
	    this.called = false;
	    this.cancelPromise = null;
	}
	
	PassThroughHandlerContext.prototype.isFinallyHandler = function() {
	    return this.type === 0;
	};
	
	function FinallyHandlerCancelReaction(finallyHandler) {
	    this.finallyHandler = finallyHandler;
	}
	
	FinallyHandlerCancelReaction.prototype._resultCancelled = function() {
	    checkCancel(this.finallyHandler);
	};
	
	function checkCancel(ctx, reason) {
	    if (ctx.cancelPromise != null) {
	        if (arguments.length > 1) {
	            ctx.cancelPromise._reject(reason);
	        } else {
	            ctx.cancelPromise._cancel();
	        }
	        ctx.cancelPromise = null;
	        return true;
	    }
	    return false;
	}
	
	function succeed() {
	    return finallyHandler.call(this, this.promise._target()._settledValue());
	}
	function fail(reason) {
	    if (checkCancel(this, reason)) return;
	    errorObj.e = reason;
	    return errorObj;
	}
	function finallyHandler(reasonOrValue) {
	    var promise = this.promise;
	    var handler = this.handler;
	
	    if (!this.called) {
	        this.called = true;
	        var ret = this.isFinallyHandler()
	            ? handler.call(promise._boundValue())
	            : handler.call(promise._boundValue(), reasonOrValue);
	        if (ret !== undefined) {
	            promise._setReturnedNonUndefined();
	            var maybePromise = tryConvertToPromise(ret, promise);
	            if (maybePromise instanceof Promise) {
	                if (this.cancelPromise != null) {
	                    if (maybePromise.isCancelled()) {
	                        var reason =
	                            new CancellationError("late cancellation observer");
	                        promise._attachExtraTrace(reason);
	                        errorObj.e = reason;
	                        return errorObj;
	                    } else if (maybePromise.isPending()) {
	                        maybePromise._attachCancellationCallback(
	                            new FinallyHandlerCancelReaction(this));
	                    }
	                }
	                return maybePromise._then(
	                    succeed, fail, undefined, this, undefined);
	            }
	        }
	    }
	
	    if (promise.isRejected()) {
	        checkCancel(this);
	        errorObj.e = reasonOrValue;
	        return errorObj;
	    } else {
	        checkCancel(this);
	        return reasonOrValue;
	    }
	}
	
	Promise.prototype._passThrough = function(handler, type, success, fail) {
	    if (typeof handler !== "function") return this.then();
	    return this._then(success,
	                      fail,
	                      undefined,
	                      new PassThroughHandlerContext(this, type, handler),
	                      undefined);
	};
	
	Promise.prototype.lastly =
	Promise.prototype["finally"] = function (handler) {
	    return this._passThrough(handler,
	                             0,
	                             finallyHandler,
	                             finallyHandler);
	};
	
	Promise.prototype.tap = function (handler) {
	    return this._passThrough(handler, 1, finallyHandler);
	};
	
	return PassThroughHandlerContext;
	};
	
	},{"./util":21}],12:[function(_dereq_,module,exports){
	"use strict";
	module.exports =
	function(Promise, PromiseArray, tryConvertToPromise, INTERNAL) {
	var util = _dereq_("./util");
	var canEvaluate = util.canEvaluate;
	var tryCatch = util.tryCatch;
	var errorObj = util.errorObj;
	var reject;
	
	if (false) {
	if (canEvaluate) {
	    var thenCallback = function(i) {
	        return new Function("value", "holder", "                             \n\
	            'use strict';                                                    \n\
	            holder.pIndex = value;                                           \n\
	            holder.checkFulfillment(this);                                   \n\
	            ".replace(/Index/g, i));
	    };
	
	    var promiseSetter = function(i) {
	        return new Function("promise", "holder", "                           \n\
	            'use strict';                                                    \n\
	            holder.pIndex = promise;                                         \n\
	            ".replace(/Index/g, i));
	    };
	
	    var generateHolderClass = function(total) {
	        var props = new Array(total);
	        for (var i = 0; i < props.length; ++i) {
	            props[i] = "this.p" + (i+1);
	        }
	        var assignment = props.join(" = ") + " = null;";
	        var cancellationCode= "var promise;\n" + props.map(function(prop) {
	            return "                                                         \n\
	                promise = " + prop + ";                                      \n\
	                if (promise instanceof Promise) {                            \n\
	                    promise.cancel();                                        \n\
	                }                                                            \n\
	            ";
	        }).join("\n");
	        var passedArguments = props.join(", ");
	        var name = "Holder$" + total;
	
	
	        var code = "return function(tryCatch, errorObj, Promise) {           \n\
	            'use strict';                                                    \n\
	            function [TheName](fn) {                                         \n\
	                [TheProperties]                                              \n\
	                this.fn = fn;                                                \n\
	                this.now = 0;                                                \n\
	            }                                                                \n\
	            [TheName].prototype.checkFulfillment = function(promise) {       \n\
	                var now = ++this.now;                                        \n\
	                if (now === [TheTotal]) {                                    \n\
	                    promise._pushContext();                                  \n\
	                    var callback = this.fn;                                  \n\
	                    var ret = tryCatch(callback)([ThePassedArguments]);      \n\
	                    promise._popContext();                                   \n\
	                    if (ret === errorObj) {                                  \n\
	                        promise._rejectCallback(ret.e, false);               \n\
	                    } else {                                                 \n\
	                        promise._resolveCallback(ret);                       \n\
	                    }                                                        \n\
	                }                                                            \n\
	            };                                                               \n\
	                                                                             \n\
	            [TheName].prototype._resultCancelled = function() {              \n\
	                [CancellationCode]                                           \n\
	            };                                                               \n\
	                                                                             \n\
	            return [TheName];                                                \n\
	        }(tryCatch, errorObj, Promise);                                      \n\
	        ";
	
	        code = code.replace(/\[TheName\]/g, name)
	            .replace(/\[TheTotal\]/g, total)
	            .replace(/\[ThePassedArguments\]/g, passedArguments)
	            .replace(/\[TheProperties\]/g, assignment)
	            .replace(/\[CancellationCode\]/g, cancellationCode);
	
	        return new Function("tryCatch", "errorObj", "Promise", code)
	                           (tryCatch, errorObj, Promise);
	    };
	
	    var holderClasses = [];
	    var thenCallbacks = [];
	    var promiseSetters = [];
	
	    for (var i = 0; i < 8; ++i) {
	        holderClasses.push(generateHolderClass(i + 1));
	        thenCallbacks.push(thenCallback(i + 1));
	        promiseSetters.push(promiseSetter(i + 1));
	    }
	
	    reject = function (reason) {
	        this._reject(reason);
	    };
	}}
	
	Promise.join = function () {
	    var last = arguments.length - 1;
	    var fn;
	    if (last > 0 && typeof arguments[last] === "function") {
	        fn = arguments[last];
	        if (false) {
	            if (last <= 8 && canEvaluate) {
	                var ret = new Promise(INTERNAL);
	                ret._captureStackTrace();
	                var HolderClass = holderClasses[last - 1];
	                var holder = new HolderClass(fn);
	                var callbacks = thenCallbacks;
	
	                for (var i = 0; i < last; ++i) {
	                    var maybePromise = tryConvertToPromise(arguments[i], ret);
	                    if (maybePromise instanceof Promise) {
	                        maybePromise = maybePromise._target();
	                        var bitField = maybePromise._bitField;
	                        ;
	                        if (((bitField & 50397184) === 0)) {
	                            maybePromise._then(callbacks[i], reject,
	                                               undefined, ret, holder);
	                            promiseSetters[i](maybePromise, holder);
	                        } else if (((bitField & 33554432) !== 0)) {
	                            callbacks[i].call(ret,
	                                              maybePromise._value(), holder);
	                        } else if (((bitField & 16777216) !== 0)) {
	                            ret._reject(maybePromise._reason());
	                        } else {
	                            ret._cancel();
	                        }
	                    } else {
	                        callbacks[i].call(ret, maybePromise, holder);
	                    }
	                }
	                if (!ret._isFateSealed()) {
	                    ret._setAsyncGuaranteed();
	                    ret._setOnCancel(holder);
	                }
	                return ret;
	            }
	        }
	    }
	    var args = [].slice.call(arguments);;
	    if (fn) args.pop();
	    var ret = new PromiseArray(args).promise();
	    return fn !== undefined ? ret.spread(fn) : ret;
	};
	
	};
	
	},{"./util":21}],13:[function(_dereq_,module,exports){
	"use strict";
	module.exports =
	function(Promise, INTERNAL, tryConvertToPromise, apiRejection, debug) {
	var util = _dereq_("./util");
	var tryCatch = util.tryCatch;
	
	Promise.method = function (fn) {
	    if (typeof fn !== "function") {
	        throw new Promise.TypeError("expecting a function but got " + util.classString(fn));
	    }
	    return function () {
	        var ret = new Promise(INTERNAL);
	        ret._captureStackTrace();
	        ret._pushContext();
	        var value = tryCatch(fn).apply(this, arguments);
	        var promiseCreated = ret._popContext();
	        debug.checkForgottenReturns(
	            value, promiseCreated, "Promise.method", ret);
	        ret._resolveFromSyncValue(value);
	        return ret;
	    };
	};
	
	Promise.attempt = Promise["try"] = function (fn) {
	    if (typeof fn !== "function") {
	        return apiRejection("expecting a function but got " + util.classString(fn));
	    }
	    var ret = new Promise(INTERNAL);
	    ret._captureStackTrace();
	    ret._pushContext();
	    var value;
	    if (arguments.length > 1) {
	        debug.deprecated("calling Promise.try with more than 1 argument");
	        var arg = arguments[1];
	        var ctx = arguments[2];
	        value = util.isArray(arg) ? tryCatch(fn).apply(ctx, arg)
	                                  : tryCatch(fn).call(ctx, arg);
	    } else {
	        value = tryCatch(fn)();
	    }
	    var promiseCreated = ret._popContext();
	    debug.checkForgottenReturns(
	        value, promiseCreated, "Promise.try", ret);
	    ret._resolveFromSyncValue(value);
	    return ret;
	};
	
	Promise.prototype._resolveFromSyncValue = function (value) {
	    if (value === util.errorObj) {
	        this._rejectCallback(value.e, false);
	    } else {
	        this._resolveCallback(value, true);
	    }
	};
	};
	
	},{"./util":21}],14:[function(_dereq_,module,exports){
	"use strict";
	var util = _dereq_("./util");
	var maybeWrapAsError = util.maybeWrapAsError;
	var errors = _dereq_("./errors");
	var OperationalError = errors.OperationalError;
	var es5 = _dereq_("./es5");
	
	function isUntypedError(obj) {
	    return obj instanceof Error &&
	        es5.getPrototypeOf(obj) === Error.prototype;
	}
	
	var rErrorKey = /^(?:name|message|stack|cause)$/;
	function wrapAsOperationalError(obj) {
	    var ret;
	    if (isUntypedError(obj)) {
	        ret = new OperationalError(obj);
	        ret.name = obj.name;
	        ret.message = obj.message;
	        ret.stack = obj.stack;
	        var keys = es5.keys(obj);
	        for (var i = 0; i < keys.length; ++i) {
	            var key = keys[i];
	            if (!rErrorKey.test(key)) {
	                ret[key] = obj[key];
	            }
	        }
	        return ret;
	    }
	    util.markAsOriginatingFromRejection(obj);
	    return obj;
	}
	
	function nodebackForPromise(promise, multiArgs) {
	    return function(err, value) {
	        if (promise === null) return;
	        if (err) {
	            var wrapped = wrapAsOperationalError(maybeWrapAsError(err));
	            promise._attachExtraTrace(wrapped);
	            promise._reject(wrapped);
	        } else if (!multiArgs) {
	            promise._fulfill(value);
	        } else {
	            var args = [].slice.call(arguments, 1);;
	            promise._fulfill(args);
	        }
	        promise = null;
	    };
	}
	
	module.exports = nodebackForPromise;
	
	},{"./errors":9,"./es5":10,"./util":21}],15:[function(_dereq_,module,exports){
	"use strict";
	module.exports = function() {
	var makeSelfResolutionError = function () {
	    return new TypeError("circular promise resolution chain\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
	};
	var reflectHandler = function() {
	    return new Promise.PromiseInspection(this._target());
	};
	var apiRejection = function(msg) {
	    return Promise.reject(new TypeError(msg));
	};
	function Proxyable() {}
	var UNDEFINED_BINDING = {};
	var util = _dereq_("./util");
	
	var getDomain;
	if (util.isNode) {
	    getDomain = function() {
	        var ret = process.domain;
	        if (ret === undefined) ret = null;
	        return ret;
	    };
	} else {
	    getDomain = function() {
	        return null;
	    };
	}
	util.notEnumerableProp(Promise, "_getDomain", getDomain);
	
	var es5 = _dereq_("./es5");
	var Async = _dereq_("./async");
	var async = new Async();
	es5.defineProperty(Promise, "_async", {value: async});
	var errors = _dereq_("./errors");
	var TypeError = Promise.TypeError = errors.TypeError;
	Promise.RangeError = errors.RangeError;
	var CancellationError = Promise.CancellationError = errors.CancellationError;
	Promise.TimeoutError = errors.TimeoutError;
	Promise.OperationalError = errors.OperationalError;
	Promise.RejectionError = errors.OperationalError;
	Promise.AggregateError = errors.AggregateError;
	var INTERNAL = function(){};
	var APPLY = {};
	var NEXT_FILTER = {};
	var tryConvertToPromise = _dereq_("./thenables")(Promise, INTERNAL);
	var PromiseArray =
	    _dereq_("./promise_array")(Promise, INTERNAL,
	                               tryConvertToPromise, apiRejection, Proxyable);
	var Context = _dereq_("./context")(Promise);
	 /*jshint unused:false*/
	var createContext = Context.create;
	var debug = _dereq_("./debuggability")(Promise, Context);
	var CapturedTrace = debug.CapturedTrace;
	var PassThroughHandlerContext =
	    _dereq_("./finally")(Promise, tryConvertToPromise);
	var catchFilter = _dereq_("./catch_filter")(NEXT_FILTER);
	var nodebackForPromise = _dereq_("./nodeback");
	var errorObj = util.errorObj;
	var tryCatch = util.tryCatch;
	function check(self, executor) {
	    if (typeof executor !== "function") {
	        throw new TypeError("expecting a function but got " + util.classString(executor));
	    }
	    if (self.constructor !== Promise) {
	        throw new TypeError("the promise constructor cannot be invoked directly\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
	    }
	}
	
	function Promise(executor) {
	    this._bitField = 0;
	    this._fulfillmentHandler0 = undefined;
	    this._rejectionHandler0 = undefined;
	    this._promise0 = undefined;
	    this._receiver0 = undefined;
	    if (executor !== INTERNAL) {
	        check(this, executor);
	        this._resolveFromExecutor(executor);
	    }
	    this._promiseCreated();
	    this._fireEvent("promiseCreated", this);
	}
	
	Promise.prototype.toString = function () {
	    return "[object Promise]";
	};
	
	Promise.prototype.caught = Promise.prototype["catch"] = function (fn) {
	    var len = arguments.length;
	    if (len > 1) {
	        var catchInstances = new Array(len - 1),
	            j = 0, i;
	        for (i = 0; i < len - 1; ++i) {
	            var item = arguments[i];
	            if (util.isObject(item)) {
	                catchInstances[j++] = item;
	            } else {
	                return apiRejection("expecting an object but got " + util.classString(item));
	            }
	        }
	        catchInstances.length = j;
	        fn = arguments[i];
	        return this.then(undefined, catchFilter(catchInstances, fn, this));
	    }
	    return this.then(undefined, fn);
	};
	
	Promise.prototype.reflect = function () {
	    return this._then(reflectHandler,
	        reflectHandler, undefined, this, undefined);
	};
	
	Promise.prototype.then = function (didFulfill, didReject) {
	    if (debug.warnings() && arguments.length > 0 &&
	        typeof didFulfill !== "function" &&
	        typeof didReject !== "function") {
	        var msg = ".then() only accepts functions but was passed: " +
	                util.classString(didFulfill);
	        if (arguments.length > 1) {
	            msg += ", " + util.classString(didReject);
	        }
	        this._warn(msg);
	    }
	    return this._then(didFulfill, didReject, undefined, undefined, undefined);
	};
	
	Promise.prototype.done = function (didFulfill, didReject) {
	    var promise =
	        this._then(didFulfill, didReject, undefined, undefined, undefined);
	    promise._setIsFinal();
	};
	
	Promise.prototype.spread = function (fn) {
	    if (typeof fn !== "function") {
	        return apiRejection("expecting a function but got " + util.classString(fn));
	    }
	    return this.all()._then(fn, undefined, undefined, APPLY, undefined);
	};
	
	Promise.prototype.toJSON = function () {
	    var ret = {
	        isFulfilled: false,
	        isRejected: false,
	        fulfillmentValue: undefined,
	        rejectionReason: undefined
	    };
	    if (this.isFulfilled()) {
	        ret.fulfillmentValue = this.value();
	        ret.isFulfilled = true;
	    } else if (this.isRejected()) {
	        ret.rejectionReason = this.reason();
	        ret.isRejected = true;
	    }
	    return ret;
	};
	
	Promise.prototype.all = function () {
	    if (arguments.length > 0) {
	        this._warn(".all() was passed arguments but it does not take any");
	    }
	    return new PromiseArray(this).promise();
	};
	
	Promise.prototype.error = function (fn) {
	    return this.caught(util.originatesFromRejection, fn);
	};
	
	Promise.getNewLibraryCopy = module.exports;
	
	Promise.is = function (val) {
	    return val instanceof Promise;
	};
	
	Promise.fromNode = Promise.fromCallback = function(fn) {
	    var ret = new Promise(INTERNAL);
	    ret._captureStackTrace();
	    var multiArgs = arguments.length > 1 ? !!Object(arguments[1]).multiArgs
	                                         : false;
	    var result = tryCatch(fn)(nodebackForPromise(ret, multiArgs));
	    if (result === errorObj) {
	        ret._rejectCallback(result.e, true);
	    }
	    if (!ret._isFateSealed()) ret._setAsyncGuaranteed();
	    return ret;
	};
	
	Promise.all = function (promises) {
	    return new PromiseArray(promises).promise();
	};
	
	Promise.cast = function (obj) {
	    var ret = tryConvertToPromise(obj);
	    if (!(ret instanceof Promise)) {
	        ret = new Promise(INTERNAL);
	        ret._captureStackTrace();
	        ret._setFulfilled();
	        ret._rejectionHandler0 = obj;
	    }
	    return ret;
	};
	
	Promise.resolve = Promise.fulfilled = Promise.cast;
	
	Promise.reject = Promise.rejected = function (reason) {
	    var ret = new Promise(INTERNAL);
	    ret._captureStackTrace();
	    ret._rejectCallback(reason, true);
	    return ret;
	};
	
	Promise.setScheduler = function(fn) {
	    if (typeof fn !== "function") {
	        throw new TypeError("expecting a function but got " + util.classString(fn));
	    }
	    return async.setScheduler(fn);
	};
	
	Promise.prototype._then = function (
	    didFulfill,
	    didReject,
	    _,    receiver,
	    internalData
	) {
	    var haveInternalData = internalData !== undefined;
	    var promise = haveInternalData ? internalData : new Promise(INTERNAL);
	    var target = this._target();
	    var bitField = target._bitField;
	
	    if (!haveInternalData) {
	        promise._propagateFrom(this, 3);
	        promise._captureStackTrace();
	        if (receiver === undefined &&
	            ((this._bitField & 2097152) !== 0)) {
	            if (!((bitField & 50397184) === 0)) {
	                receiver = this._boundValue();
	            } else {
	                receiver = target === this ? undefined : this._boundTo;
	            }
	        }
	        this._fireEvent("promiseChained", this, promise);
	    }
	
	    var domain = getDomain();
	    if (!((bitField & 50397184) === 0)) {
	        var handler, value, settler = target._settlePromiseCtx;
	        if (((bitField & 33554432) !== 0)) {
	            value = target._rejectionHandler0;
	            handler = didFulfill;
	        } else if (((bitField & 16777216) !== 0)) {
	            value = target._fulfillmentHandler0;
	            handler = didReject;
	            target._unsetRejectionIsUnhandled();
	        } else {
	            settler = target._settlePromiseLateCancellationObserver;
	            value = new CancellationError("late cancellation observer");
	            target._attachExtraTrace(value);
	            handler = didReject;
	        }
	
	        async.invoke(settler, target, {
	            handler: domain === null ? handler
	                : (typeof handler === "function" && domain.bind(handler)),
	            promise: promise,
	            receiver: receiver,
	            value: value
	        });
	    } else {
	        target._addCallbacks(didFulfill, didReject, promise, receiver, domain);
	    }
	
	    return promise;
	};
	
	Promise.prototype._length = function () {
	    return this._bitField & 65535;
	};
	
	Promise.prototype._isFateSealed = function () {
	    return (this._bitField & 117506048) !== 0;
	};
	
	Promise.prototype._isFollowing = function () {
	    return (this._bitField & 67108864) === 67108864;
	};
	
	Promise.prototype._setLength = function (len) {
	    this._bitField = (this._bitField & -65536) |
	        (len & 65535);
	};
	
	Promise.prototype._setFulfilled = function () {
	    this._bitField = this._bitField | 33554432;
	    this._fireEvent("promiseFulfilled", this);
	};
	
	Promise.prototype._setRejected = function () {
	    this._bitField = this._bitField | 16777216;
	    this._fireEvent("promiseRejected", this);
	};
	
	Promise.prototype._setFollowing = function () {
	    this._bitField = this._bitField | 67108864;
	    this._fireEvent("promiseResolved", this);
	};
	
	Promise.prototype._setIsFinal = function () {
	    this._bitField = this._bitField | 4194304;
	};
	
	Promise.prototype._isFinal = function () {
	    return (this._bitField & 4194304) > 0;
	};
	
	Promise.prototype._unsetCancelled = function() {
	    this._bitField = this._bitField & (~65536);
	};
	
	Promise.prototype._setCancelled = function() {
	    this._bitField = this._bitField | 65536;
	    this._fireEvent("promiseCancelled", this);
	};
	
	Promise.prototype._setAsyncGuaranteed = function() {
	    if (async.hasCustomScheduler()) return;
	    this._bitField = this._bitField | 134217728;
	};
	
	Promise.prototype._receiverAt = function (index) {
	    var ret = index === 0 ? this._receiver0 : this[
	            index * 4 - 4 + 3];
	    if (ret === UNDEFINED_BINDING) {
	        return undefined;
	    } else if (ret === undefined && this._isBound()) {
	        return this._boundValue();
	    }
	    return ret;
	};
	
	Promise.prototype._promiseAt = function (index) {
	    return this[
	            index * 4 - 4 + 2];
	};
	
	Promise.prototype._fulfillmentHandlerAt = function (index) {
	    return this[
	            index * 4 - 4 + 0];
	};
	
	Promise.prototype._rejectionHandlerAt = function (index) {
	    return this[
	            index * 4 - 4 + 1];
	};
	
	Promise.prototype._boundValue = function() {};
	
	Promise.prototype._migrateCallback0 = function (follower) {
	    var bitField = follower._bitField;
	    var fulfill = follower._fulfillmentHandler0;
	    var reject = follower._rejectionHandler0;
	    var promise = follower._promise0;
	    var receiver = follower._receiverAt(0);
	    if (receiver === undefined) receiver = UNDEFINED_BINDING;
	    this._addCallbacks(fulfill, reject, promise, receiver, null);
	};
	
	Promise.prototype._migrateCallbackAt = function (follower, index) {
	    var fulfill = follower._fulfillmentHandlerAt(index);
	    var reject = follower._rejectionHandlerAt(index);
	    var promise = follower._promiseAt(index);
	    var receiver = follower._receiverAt(index);
	    if (receiver === undefined) receiver = UNDEFINED_BINDING;
	    this._addCallbacks(fulfill, reject, promise, receiver, null);
	};
	
	Promise.prototype._addCallbacks = function (
	    fulfill,
	    reject,
	    promise,
	    receiver,
	    domain
	) {
	    var index = this._length();
	
	    if (index >= 65535 - 4) {
	        index = 0;
	        this._setLength(0);
	    }
	
	    if (index === 0) {
	        this._promise0 = promise;
	        this._receiver0 = receiver;
	        if (typeof fulfill === "function") {
	            this._fulfillmentHandler0 =
	                domain === null ? fulfill : domain.bind(fulfill);
	        }
	        if (typeof reject === "function") {
	            this._rejectionHandler0 =
	                domain === null ? reject : domain.bind(reject);
	        }
	    } else {
	        var base = index * 4 - 4;
	        this[base + 2] = promise;
	        this[base + 3] = receiver;
	        if (typeof fulfill === "function") {
	            this[base + 0] =
	                domain === null ? fulfill : domain.bind(fulfill);
	        }
	        if (typeof reject === "function") {
	            this[base + 1] =
	                domain === null ? reject : domain.bind(reject);
	        }
	    }
	    this._setLength(index + 1);
	    return index;
	};
	
	Promise.prototype._proxy = function (proxyable, arg) {
	    this._addCallbacks(undefined, undefined, arg, proxyable, null);
	};
	
	Promise.prototype._resolveCallback = function(value, shouldBind) {
	    if (((this._bitField & 117506048) !== 0)) return;
	    if (value === this)
	        return this._rejectCallback(makeSelfResolutionError(), false);
	    var maybePromise = tryConvertToPromise(value, this);
	    if (!(maybePromise instanceof Promise)) return this._fulfill(value);
	
	    if (shouldBind) this._propagateFrom(maybePromise, 2);
	
	    var promise = maybePromise._target();
	
	    if (promise === this) {
	        this._reject(makeSelfResolutionError());
	        return;
	    }
	
	    var bitField = promise._bitField;
	    if (((bitField & 50397184) === 0)) {
	        var len = this._length();
	        if (len > 0) promise._migrateCallback0(this);
	        for (var i = 1; i < len; ++i) {
	            promise._migrateCallbackAt(this, i);
	        }
	        this._setFollowing();
	        this._setLength(0);
	        this._setFollowee(promise);
	    } else if (((bitField & 33554432) !== 0)) {
	        this._fulfill(promise._value());
	    } else if (((bitField & 16777216) !== 0)) {
	        this._reject(promise._reason());
	    } else {
	        var reason = new CancellationError("late cancellation observer");
	        promise._attachExtraTrace(reason);
	        this._reject(reason);
	    }
	};
	
	Promise.prototype._rejectCallback =
	function(reason, synchronous, ignoreNonErrorWarnings) {
	    var trace = util.ensureErrorObject(reason);
	    var hasStack = trace === reason;
	    if (!hasStack && !ignoreNonErrorWarnings && debug.warnings()) {
	        var message = "a promise was rejected with a non-error: " +
	            util.classString(reason);
	        this._warn(message, true);
	    }
	    this._attachExtraTrace(trace, synchronous ? hasStack : false);
	    this._reject(reason);
	};
	
	Promise.prototype._resolveFromExecutor = function (executor) {
	    var promise = this;
	    this._captureStackTrace();
	    this._pushContext();
	    var synchronous = true;
	    var r = this._execute(executor, function(value) {
	        promise._resolveCallback(value);
	    }, function (reason) {
	        promise._rejectCallback(reason, synchronous);
	    });
	    synchronous = false;
	    this._popContext();
	
	    if (r !== undefined) {
	        promise._rejectCallback(r, true);
	    }
	};
	
	Promise.prototype._settlePromiseFromHandler = function (
	    handler, receiver, value, promise
	) {
	    var bitField = promise._bitField;
	    if (((bitField & 65536) !== 0)) return;
	    promise._pushContext();
	    var x;
	    if (receiver === APPLY) {
	        if (!value || typeof value.length !== "number") {
	            x = errorObj;
	            x.e = new TypeError("cannot .spread() a non-array: " +
	                                    util.classString(value));
	        } else {
	            x = tryCatch(handler).apply(this._boundValue(), value);
	        }
	    } else {
	        x = tryCatch(handler).call(receiver, value);
	    }
	    var promiseCreated = promise._popContext();
	    bitField = promise._bitField;
	    if (((bitField & 65536) !== 0)) return;
	
	    if (x === NEXT_FILTER) {
	        promise._reject(value);
	    } else if (x === errorObj) {
	        promise._rejectCallback(x.e, false);
	    } else {
	        debug.checkForgottenReturns(x, promiseCreated, "",  promise, this);
	        promise._resolveCallback(x);
	    }
	};
	
	Promise.prototype._target = function() {
	    var ret = this;
	    while (ret._isFollowing()) ret = ret._followee();
	    return ret;
	};
	
	Promise.prototype._followee = function() {
	    return this._rejectionHandler0;
	};
	
	Promise.prototype._setFollowee = function(promise) {
	    this._rejectionHandler0 = promise;
	};
	
	Promise.prototype._settlePromise = function(promise, handler, receiver, value) {
	    var isPromise = promise instanceof Promise;
	    var bitField = this._bitField;
	    var asyncGuaranteed = ((bitField & 134217728) !== 0);
	    if (((bitField & 65536) !== 0)) {
	        if (isPromise) promise._invokeInternalOnCancel();
	
	        if (receiver instanceof PassThroughHandlerContext &&
	            receiver.isFinallyHandler()) {
	            receiver.cancelPromise = promise;
	            if (tryCatch(handler).call(receiver, value) === errorObj) {
	                promise._reject(errorObj.e);
	            }
	        } else if (handler === reflectHandler) {
	            promise._fulfill(reflectHandler.call(receiver));
	        } else if (receiver instanceof Proxyable) {
	            receiver._promiseCancelled(promise);
	        } else if (isPromise || promise instanceof PromiseArray) {
	            promise._cancel();
	        } else {
	            receiver.cancel();
	        }
	    } else if (typeof handler === "function") {
	        if (!isPromise) {
	            handler.call(receiver, value, promise);
	        } else {
	            if (asyncGuaranteed) promise._setAsyncGuaranteed();
	            this._settlePromiseFromHandler(handler, receiver, value, promise);
	        }
	    } else if (receiver instanceof Proxyable) {
	        if (!receiver._isResolved()) {
	            if (((bitField & 33554432) !== 0)) {
	                receiver._promiseFulfilled(value, promise);
	            } else {
	                receiver._promiseRejected(value, promise);
	            }
	        }
	    } else if (isPromise) {
	        if (asyncGuaranteed) promise._setAsyncGuaranteed();
	        if (((bitField & 33554432) !== 0)) {
	            promise._fulfill(value);
	        } else {
	            promise._reject(value);
	        }
	    }
	};
	
	Promise.prototype._settlePromiseLateCancellationObserver = function(ctx) {
	    var handler = ctx.handler;
	    var promise = ctx.promise;
	    var receiver = ctx.receiver;
	    var value = ctx.value;
	    if (typeof handler === "function") {
	        if (!(promise instanceof Promise)) {
	            handler.call(receiver, value, promise);
	        } else {
	            this._settlePromiseFromHandler(handler, receiver, value, promise);
	        }
	    } else if (promise instanceof Promise) {
	        promise._reject(value);
	    }
	};
	
	Promise.prototype._settlePromiseCtx = function(ctx) {
	    this._settlePromise(ctx.promise, ctx.handler, ctx.receiver, ctx.value);
	};
	
	Promise.prototype._settlePromise0 = function(handler, value, bitField) {
	    var promise = this._promise0;
	    var receiver = this._receiverAt(0);
	    this._promise0 = undefined;
	    this._receiver0 = undefined;
	    this._settlePromise(promise, handler, receiver, value);
	};
	
	Promise.prototype._clearCallbackDataAtIndex = function(index) {
	    var base = index * 4 - 4;
	    this[base + 2] =
	    this[base + 3] =
	    this[base + 0] =
	    this[base + 1] = undefined;
	};
	
	Promise.prototype._fulfill = function (value) {
	    var bitField = this._bitField;
	    if (((bitField & 117506048) >>> 16)) return;
	    if (value === this) {
	        var err = makeSelfResolutionError();
	        this._attachExtraTrace(err);
	        return this._reject(err);
	    }
	    this._setFulfilled();
	    this._rejectionHandler0 = value;
	
	    if ((bitField & 65535) > 0) {
	        if (((bitField & 134217728) !== 0)) {
	            this._settlePromises();
	        } else {
	            async.settlePromises(this);
	        }
	    }
	};
	
	Promise.prototype._reject = function (reason) {
	    var bitField = this._bitField;
	    if (((bitField & 117506048) >>> 16)) return;
	    this._setRejected();
	    this._fulfillmentHandler0 = reason;
	
	    if (this._isFinal()) {
	        return async.fatalError(reason, util.isNode);
	    }
	
	    if ((bitField & 65535) > 0) {
	        async.settlePromises(this);
	    } else {
	        this._ensurePossibleRejectionHandled();
	    }
	};
	
	Promise.prototype._fulfillPromises = function (len, value) {
	    for (var i = 1; i < len; i++) {
	        var handler = this._fulfillmentHandlerAt(i);
	        var promise = this._promiseAt(i);
	        var receiver = this._receiverAt(i);
	        this._clearCallbackDataAtIndex(i);
	        this._settlePromise(promise, handler, receiver, value);
	    }
	};
	
	Promise.prototype._rejectPromises = function (len, reason) {
	    for (var i = 1; i < len; i++) {
	        var handler = this._rejectionHandlerAt(i);
	        var promise = this._promiseAt(i);
	        var receiver = this._receiverAt(i);
	        this._clearCallbackDataAtIndex(i);
	        this._settlePromise(promise, handler, receiver, reason);
	    }
	};
	
	Promise.prototype._settlePromises = function () {
	    var bitField = this._bitField;
	    var len = (bitField & 65535);
	
	    if (len > 0) {
	        if (((bitField & 16842752) !== 0)) {
	            var reason = this._fulfillmentHandler0;
	            this._settlePromise0(this._rejectionHandler0, reason, bitField);
	            this._rejectPromises(len, reason);
	        } else {
	            var value = this._rejectionHandler0;
	            this._settlePromise0(this._fulfillmentHandler0, value, bitField);
	            this._fulfillPromises(len, value);
	        }
	        this._setLength(0);
	    }
	    this._clearCancellationData();
	};
	
	Promise.prototype._settledValue = function() {
	    var bitField = this._bitField;
	    if (((bitField & 33554432) !== 0)) {
	        return this._rejectionHandler0;
	    } else if (((bitField & 16777216) !== 0)) {
	        return this._fulfillmentHandler0;
	    }
	};
	
	function deferResolve(v) {this.promise._resolveCallback(v);}
	function deferReject(v) {this.promise._rejectCallback(v, false);}
	
	Promise.defer = Promise.pending = function() {
	    debug.deprecated("Promise.defer", "new Promise");
	    var promise = new Promise(INTERNAL);
	    return {
	        promise: promise,
	        resolve: deferResolve,
	        reject: deferReject
	    };
	};
	
	util.notEnumerableProp(Promise,
	                       "_makeSelfResolutionError",
	                       makeSelfResolutionError);
	
	_dereq_("./method")(Promise, INTERNAL, tryConvertToPromise, apiRejection,
	    debug);
	_dereq_("./bind")(Promise, INTERNAL, tryConvertToPromise, debug);
	_dereq_("./cancel")(Promise, PromiseArray, apiRejection, debug);
	_dereq_("./direct_resolve")(Promise);
	_dereq_("./synchronous_inspection")(Promise);
	_dereq_("./join")(
	    Promise, PromiseArray, tryConvertToPromise, INTERNAL, debug);
	Promise.Promise = Promise;
	Promise.version = "3.4.0";
	                                                         
	    util.toFastProperties(Promise);                                          
	    util.toFastProperties(Promise.prototype);                                
	    function fillTypes(value) {                                              
	        var p = new Promise(INTERNAL);                                       
	        p._fulfillmentHandler0 = value;                                      
	        p._rejectionHandler0 = value;                                        
	        p._promise0 = value;                                                 
	        p._receiver0 = value;                                                
	    }                                                                        
	    // Complete slack tracking, opt out of field-type tracking and           
	    // stabilize map                                                         
	    fillTypes({a: 1});                                                       
	    fillTypes({b: 2});                                                       
	    fillTypes({c: 3});                                                       
	    fillTypes(1);                                                            
	    fillTypes(function(){});                                                 
	    fillTypes(undefined);                                                    
	    fillTypes(false);                                                        
	    fillTypes(new Promise(INTERNAL));                                        
	    debug.setBounds(Async.firstLineError, util.lastLineError);               
	    return Promise;                                                          
	
	};
	
	},{"./async":1,"./bind":2,"./cancel":4,"./catch_filter":5,"./context":6,"./debuggability":7,"./direct_resolve":8,"./errors":9,"./es5":10,"./finally":11,"./join":12,"./method":13,"./nodeback":14,"./promise_array":16,"./synchronous_inspection":19,"./thenables":20,"./util":21}],16:[function(_dereq_,module,exports){
	"use strict";
	module.exports = function(Promise, INTERNAL, tryConvertToPromise,
	    apiRejection, Proxyable) {
	var util = _dereq_("./util");
	var isArray = util.isArray;
	
	function toResolutionValue(val) {
	    switch(val) {
	    case -2: return [];
	    case -3: return {};
	    }
	}
	
	function PromiseArray(values) {
	    var promise = this._promise = new Promise(INTERNAL);
	    if (values instanceof Promise) {
	        promise._propagateFrom(values, 3);
	    }
	    promise._setOnCancel(this);
	    this._values = values;
	    this._length = 0;
	    this._totalResolved = 0;
	    this._init(undefined, -2);
	}
	util.inherits(PromiseArray, Proxyable);
	
	PromiseArray.prototype.length = function () {
	    return this._length;
	};
	
	PromiseArray.prototype.promise = function () {
	    return this._promise;
	};
	
	PromiseArray.prototype._init = function init(_, resolveValueIfEmpty) {
	    var values = tryConvertToPromise(this._values, this._promise);
	    if (values instanceof Promise) {
	        values = values._target();
	        var bitField = values._bitField;
	        ;
	        this._values = values;
	
	        if (((bitField & 50397184) === 0)) {
	            this._promise._setAsyncGuaranteed();
	            return values._then(
	                init,
	                this._reject,
	                undefined,
	                this,
	                resolveValueIfEmpty
	           );
	        } else if (((bitField & 33554432) !== 0)) {
	            values = values._value();
	        } else if (((bitField & 16777216) !== 0)) {
	            return this._reject(values._reason());
	        } else {
	            return this._cancel();
	        }
	    }
	    values = util.asArray(values);
	    if (values === null) {
	        var err = apiRejection(
	            "expecting an array or an iterable object but got " + util.classString(values)).reason();
	        this._promise._rejectCallback(err, false);
	        return;
	    }
	
	    if (values.length === 0) {
	        if (resolveValueIfEmpty === -5) {
	            this._resolveEmptyArray();
	        }
	        else {
	            this._resolve(toResolutionValue(resolveValueIfEmpty));
	        }
	        return;
	    }
	    this._iterate(values);
	};
	
	PromiseArray.prototype._iterate = function(values) {
	    var len = this.getActualLength(values.length);
	    this._length = len;
	    this._values = this.shouldCopyValues() ? new Array(len) : this._values;
	    var result = this._promise;
	    var isResolved = false;
	    var bitField = null;
	    for (var i = 0; i < len; ++i) {
	        var maybePromise = tryConvertToPromise(values[i], result);
	
	        if (maybePromise instanceof Promise) {
	            maybePromise = maybePromise._target();
	            bitField = maybePromise._bitField;
	        } else {
	            bitField = null;
	        }
	
	        if (isResolved) {
	            if (bitField !== null) {
	                maybePromise.suppressUnhandledRejections();
	            }
	        } else if (bitField !== null) {
	            if (((bitField & 50397184) === 0)) {
	                maybePromise._proxy(this, i);
	                this._values[i] = maybePromise;
	            } else if (((bitField & 33554432) !== 0)) {
	                isResolved = this._promiseFulfilled(maybePromise._value(), i);
	            } else if (((bitField & 16777216) !== 0)) {
	                isResolved = this._promiseRejected(maybePromise._reason(), i);
	            } else {
	                isResolved = this._promiseCancelled(i);
	            }
	        } else {
	            isResolved = this._promiseFulfilled(maybePromise, i);
	        }
	    }
	    if (!isResolved) result._setAsyncGuaranteed();
	};
	
	PromiseArray.prototype._isResolved = function () {
	    return this._values === null;
	};
	
	PromiseArray.prototype._resolve = function (value) {
	    this._values = null;
	    this._promise._fulfill(value);
	};
	
	PromiseArray.prototype._cancel = function() {
	    if (this._isResolved() || !this._promise.isCancellable()) return;
	    this._values = null;
	    this._promise._cancel();
	};
	
	PromiseArray.prototype._reject = function (reason) {
	    this._values = null;
	    this._promise._rejectCallback(reason, false);
	};
	
	PromiseArray.prototype._promiseFulfilled = function (value, index) {
	    this._values[index] = value;
	    var totalResolved = ++this._totalResolved;
	    if (totalResolved >= this._length) {
	        this._resolve(this._values);
	        return true;
	    }
	    return false;
	};
	
	PromiseArray.prototype._promiseCancelled = function() {
	    this._cancel();
	    return true;
	};
	
	PromiseArray.prototype._promiseRejected = function (reason) {
	    this._totalResolved++;
	    this._reject(reason);
	    return true;
	};
	
	PromiseArray.prototype._resultCancelled = function() {
	    if (this._isResolved()) return;
	    var values = this._values;
	    this._cancel();
	    if (values instanceof Promise) {
	        values.cancel();
	    } else {
	        for (var i = 0; i < values.length; ++i) {
	            if (values[i] instanceof Promise) {
	                values[i].cancel();
	            }
	        }
	    }
	};
	
	PromiseArray.prototype.shouldCopyValues = function () {
	    return true;
	};
	
	PromiseArray.prototype.getActualLength = function (len) {
	    return len;
	};
	
	return PromiseArray;
	};
	
	},{"./util":21}],17:[function(_dereq_,module,exports){
	"use strict";
	function arrayMove(src, srcIndex, dst, dstIndex, len) {
	    for (var j = 0; j < len; ++j) {
	        dst[j + dstIndex] = src[j + srcIndex];
	        src[j + srcIndex] = void 0;
	    }
	}
	
	function Queue(capacity) {
	    this._capacity = capacity;
	    this._length = 0;
	    this._front = 0;
	}
	
	Queue.prototype._willBeOverCapacity = function (size) {
	    return this._capacity < size;
	};
	
	Queue.prototype._pushOne = function (arg) {
	    var length = this.length();
	    this._checkCapacity(length + 1);
	    var i = (this._front + length) & (this._capacity - 1);
	    this[i] = arg;
	    this._length = length + 1;
	};
	
	Queue.prototype._unshiftOne = function(value) {
	    var capacity = this._capacity;
	    this._checkCapacity(this.length() + 1);
	    var front = this._front;
	    var i = (((( front - 1 ) &
	                    ( capacity - 1) ) ^ capacity ) - capacity );
	    this[i] = value;
	    this._front = i;
	    this._length = this.length() + 1;
	};
	
	Queue.prototype.unshift = function(fn, receiver, arg) {
	    this._unshiftOne(arg);
	    this._unshiftOne(receiver);
	    this._unshiftOne(fn);
	};
	
	Queue.prototype.push = function (fn, receiver, arg) {
	    var length = this.length() + 3;
	    if (this._willBeOverCapacity(length)) {
	        this._pushOne(fn);
	        this._pushOne(receiver);
	        this._pushOne(arg);
	        return;
	    }
	    var j = this._front + length - 3;
	    this._checkCapacity(length);
	    var wrapMask = this._capacity - 1;
	    this[(j + 0) & wrapMask] = fn;
	    this[(j + 1) & wrapMask] = receiver;
	    this[(j + 2) & wrapMask] = arg;
	    this._length = length;
	};
	
	Queue.prototype.shift = function () {
	    var front = this._front,
	        ret = this[front];
	
	    this[front] = undefined;
	    this._front = (front + 1) & (this._capacity - 1);
	    this._length--;
	    return ret;
	};
	
	Queue.prototype.length = function () {
	    return this._length;
	};
	
	Queue.prototype._checkCapacity = function (size) {
	    if (this._capacity < size) {
	        this._resizeTo(this._capacity << 1);
	    }
	};
	
	Queue.prototype._resizeTo = function (capacity) {
	    var oldCapacity = this._capacity;
	    this._capacity = capacity;
	    var front = this._front;
	    var length = this._length;
	    var moveItemsCount = (front + length) & (oldCapacity - 1);
	    arrayMove(this, 0, this, oldCapacity, moveItemsCount);
	};
	
	module.exports = Queue;
	
	},{}],18:[function(_dereq_,module,exports){
	"use strict";
	var util = _dereq_("./util");
	var schedule;
	var noAsyncScheduler = function() {
	    throw new Error("No async scheduler available\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
	};
	var NativePromise = util.getNativePromise();
	if (util.isNode && typeof MutationObserver === "undefined") {
	    var GlobalSetImmediate = global.setImmediate;
	    var ProcessNextTick = process.nextTick;
	    schedule = util.isRecentNode
	                ? function(fn) { GlobalSetImmediate.call(global, fn); }
	                : function(fn) { ProcessNextTick.call(process, fn); };
	} else if (typeof NativePromise === "function") {
	    var nativePromise = NativePromise.resolve();
	    schedule = function(fn) {
	        nativePromise.then(fn);
	    };
	} else if ((typeof MutationObserver !== "undefined") &&
	          !(typeof window !== "undefined" &&
	            window.navigator &&
	            window.navigator.standalone)) {
	    schedule = (function() {
	        var div = document.createElement("div");
	        var opts = {attributes: true};
	        var toggleScheduled = false;
	        var div2 = document.createElement("div");
	        var o2 = new MutationObserver(function() {
	            div.classList.toggle("foo");
	            toggleScheduled = false;
	        });
	        o2.observe(div2, opts);
	
	        var scheduleToggle = function() {
	            if (toggleScheduled) return;
	                toggleScheduled = true;
	                div2.classList.toggle("foo");
	            };
	
	            return function schedule(fn) {
	            var o = new MutationObserver(function() {
	                o.disconnect();
	                fn();
	            });
	            o.observe(div, opts);
	            scheduleToggle();
	        };
	    })();
	} else if (typeof setImmediate !== "undefined") {
	    schedule = function (fn) {
	        setImmediate(fn);
	    };
	} else if (typeof setTimeout !== "undefined") {
	    schedule = function (fn) {
	        setTimeout(fn, 0);
	    };
	} else {
	    schedule = noAsyncScheduler;
	}
	module.exports = schedule;
	
	},{"./util":21}],19:[function(_dereq_,module,exports){
	"use strict";
	module.exports = function(Promise) {
	function PromiseInspection(promise) {
	    if (promise !== undefined) {
	        promise = promise._target();
	        this._bitField = promise._bitField;
	        this._settledValueField = promise._isFateSealed()
	            ? promise._settledValue() : undefined;
	    }
	    else {
	        this._bitField = 0;
	        this._settledValueField = undefined;
	    }
	}
	
	PromiseInspection.prototype._settledValue = function() {
	    return this._settledValueField;
	};
	
	var value = PromiseInspection.prototype.value = function () {
	    if (!this.isFulfilled()) {
	        throw new TypeError("cannot get fulfillment value of a non-fulfilled promise\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
	    }
	    return this._settledValue();
	};
	
	var reason = PromiseInspection.prototype.error =
	PromiseInspection.prototype.reason = function () {
	    if (!this.isRejected()) {
	        throw new TypeError("cannot get rejection reason of a non-rejected promise\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
	    }
	    return this._settledValue();
	};
	
	var isFulfilled = PromiseInspection.prototype.isFulfilled = function() {
	    return (this._bitField & 33554432) !== 0;
	};
	
	var isRejected = PromiseInspection.prototype.isRejected = function () {
	    return (this._bitField & 16777216) !== 0;
	};
	
	var isPending = PromiseInspection.prototype.isPending = function () {
	    return (this._bitField & 50397184) === 0;
	};
	
	var isResolved = PromiseInspection.prototype.isResolved = function () {
	    return (this._bitField & 50331648) !== 0;
	};
	
	PromiseInspection.prototype.isCancelled =
	Promise.prototype._isCancelled = function() {
	    return (this._bitField & 65536) === 65536;
	};
	
	Promise.prototype.isCancelled = function() {
	    return this._target()._isCancelled();
	};
	
	Promise.prototype.isPending = function() {
	    return isPending.call(this._target());
	};
	
	Promise.prototype.isRejected = function() {
	    return isRejected.call(this._target());
	};
	
	Promise.prototype.isFulfilled = function() {
	    return isFulfilled.call(this._target());
	};
	
	Promise.prototype.isResolved = function() {
	    return isResolved.call(this._target());
	};
	
	Promise.prototype.value = function() {
	    return value.call(this._target());
	};
	
	Promise.prototype.reason = function() {
	    var target = this._target();
	    target._unsetRejectionIsUnhandled();
	    return reason.call(target);
	};
	
	Promise.prototype._value = function() {
	    return this._settledValue();
	};
	
	Promise.prototype._reason = function() {
	    this._unsetRejectionIsUnhandled();
	    return this._settledValue();
	};
	
	Promise.PromiseInspection = PromiseInspection;
	};
	
	},{}],20:[function(_dereq_,module,exports){
	"use strict";
	module.exports = function(Promise, INTERNAL) {
	var util = _dereq_("./util");
	var errorObj = util.errorObj;
	var isObject = util.isObject;
	
	function tryConvertToPromise(obj, context) {
	    if (isObject(obj)) {
	        if (obj instanceof Promise) return obj;
	        var then = getThen(obj);
	        if (then === errorObj) {
	            if (context) context._pushContext();
	            var ret = Promise.reject(then.e);
	            if (context) context._popContext();
	            return ret;
	        } else if (typeof then === "function") {
	            if (isAnyBluebirdPromise(obj)) {
	                var ret = new Promise(INTERNAL);
	                obj._then(
	                    ret._fulfill,
	                    ret._reject,
	                    undefined,
	                    ret,
	                    null
	                );
	                return ret;
	            }
	            return doThenable(obj, then, context);
	        }
	    }
	    return obj;
	}
	
	function doGetThen(obj) {
	    return obj.then;
	}
	
	function getThen(obj) {
	    try {
	        return doGetThen(obj);
	    } catch (e) {
	        errorObj.e = e;
	        return errorObj;
	    }
	}
	
	var hasProp = {}.hasOwnProperty;
	function isAnyBluebirdPromise(obj) {
	    try {
	        return hasProp.call(obj, "_promise0");
	    } catch (e) {
	        return false;
	    }
	}
	
	function doThenable(x, then, context) {
	    var promise = new Promise(INTERNAL);
	    var ret = promise;
	    if (context) context._pushContext();
	    promise._captureStackTrace();
	    if (context) context._popContext();
	    var synchronous = true;
	    var result = util.tryCatch(then).call(x, resolve, reject);
	    synchronous = false;
	
	    if (promise && result === errorObj) {
	        promise._rejectCallback(result.e, true, true);
	        promise = null;
	    }
	
	    function resolve(value) {
	        if (!promise) return;
	        promise._resolveCallback(value);
	        promise = null;
	    }
	
	    function reject(reason) {
	        if (!promise) return;
	        promise._rejectCallback(reason, synchronous, true);
	        promise = null;
	    }
	    return ret;
	}
	
	return tryConvertToPromise;
	};
	
	},{"./util":21}],21:[function(_dereq_,module,exports){
	"use strict";
	var es5 = _dereq_("./es5");
	var canEvaluate = typeof navigator == "undefined";
	
	var errorObj = {e: {}};
	var tryCatchTarget;
	var globalObject = typeof self !== "undefined" ? self :
	    typeof window !== "undefined" ? window :
	    typeof global !== "undefined" ? global :
	    this !== undefined ? this : null;
	
	function tryCatcher() {
	    try {
	        var target = tryCatchTarget;
	        tryCatchTarget = null;
	        return target.apply(this, arguments);
	    } catch (e) {
	        errorObj.e = e;
	        return errorObj;
	    }
	}
	function tryCatch(fn) {
	    tryCatchTarget = fn;
	    return tryCatcher;
	}
	
	var inherits = function(Child, Parent) {
	    var hasProp = {}.hasOwnProperty;
	
	    function T() {
	        this.constructor = Child;
	        this.constructor$ = Parent;
	        for (var propertyName in Parent.prototype) {
	            if (hasProp.call(Parent.prototype, propertyName) &&
	                propertyName.charAt(propertyName.length-1) !== "$"
	           ) {
	                this[propertyName + "$"] = Parent.prototype[propertyName];
	            }
	        }
	    }
	    T.prototype = Parent.prototype;
	    Child.prototype = new T();
	    return Child.prototype;
	};
	
	
	function isPrimitive(val) {
	    return val == null || val === true || val === false ||
	        typeof val === "string" || typeof val === "number";
	
	}
	
	function isObject(value) {
	    return typeof value === "function" ||
	           typeof value === "object" && value !== null;
	}
	
	function maybeWrapAsError(maybeError) {
	    if (!isPrimitive(maybeError)) return maybeError;
	
	    return new Error(safeToString(maybeError));
	}
	
	function withAppended(target, appendee) {
	    var len = target.length;
	    var ret = new Array(len + 1);
	    var i;
	    for (i = 0; i < len; ++i) {
	        ret[i] = target[i];
	    }
	    ret[i] = appendee;
	    return ret;
	}
	
	function getDataPropertyOrDefault(obj, key, defaultValue) {
	    if (es5.isES5) {
	        var desc = Object.getOwnPropertyDescriptor(obj, key);
	
	        if (desc != null) {
	            return desc.get == null && desc.set == null
	                    ? desc.value
	                    : defaultValue;
	        }
	    } else {
	        return {}.hasOwnProperty.call(obj, key) ? obj[key] : undefined;
	    }
	}
	
	function notEnumerableProp(obj, name, value) {
	    if (isPrimitive(obj)) return obj;
	    var descriptor = {
	        value: value,
	        configurable: true,
	        enumerable: false,
	        writable: true
	    };
	    es5.defineProperty(obj, name, descriptor);
	    return obj;
	}
	
	function thrower(r) {
	    throw r;
	}
	
	var inheritedDataKeys = (function() {
	    var excludedPrototypes = [
	        Array.prototype,
	        Object.prototype,
	        Function.prototype
	    ];
	
	    var isExcludedProto = function(val) {
	        for (var i = 0; i < excludedPrototypes.length; ++i) {
	            if (excludedPrototypes[i] === val) {
	                return true;
	            }
	        }
	        return false;
	    };
	
	    if (es5.isES5) {
	        var getKeys = Object.getOwnPropertyNames;
	        return function(obj) {
	            var ret = [];
	            var visitedKeys = Object.create(null);
	            while (obj != null && !isExcludedProto(obj)) {
	                var keys;
	                try {
	                    keys = getKeys(obj);
	                } catch (e) {
	                    return ret;
	                }
	                for (var i = 0; i < keys.length; ++i) {
	                    var key = keys[i];
	                    if (visitedKeys[key]) continue;
	                    visitedKeys[key] = true;
	                    var desc = Object.getOwnPropertyDescriptor(obj, key);
	                    if (desc != null && desc.get == null && desc.set == null) {
	                        ret.push(key);
	                    }
	                }
	                obj = es5.getPrototypeOf(obj);
	            }
	            return ret;
	        };
	    } else {
	        var hasProp = {}.hasOwnProperty;
	        return function(obj) {
	            if (isExcludedProto(obj)) return [];
	            var ret = [];
	
	            /*jshint forin:false */
	            enumeration: for (var key in obj) {
	                if (hasProp.call(obj, key)) {
	                    ret.push(key);
	                } else {
	                    for (var i = 0; i < excludedPrototypes.length; ++i) {
	                        if (hasProp.call(excludedPrototypes[i], key)) {
	                            continue enumeration;
	                        }
	                    }
	                    ret.push(key);
	                }
	            }
	            return ret;
	        };
	    }
	
	})();
	
	var thisAssignmentPattern = /this\s*\.\s*\S+\s*=/;
	function isClass(fn) {
	    try {
	        if (typeof fn === "function") {
	            var keys = es5.names(fn.prototype);
	
	            var hasMethods = es5.isES5 && keys.length > 1;
	            var hasMethodsOtherThanConstructor = keys.length > 0 &&
	                !(keys.length === 1 && keys[0] === "constructor");
	            var hasThisAssignmentAndStaticMethods =
	                thisAssignmentPattern.test(fn + "") && es5.names(fn).length > 0;
	
	            if (hasMethods || hasMethodsOtherThanConstructor ||
	                hasThisAssignmentAndStaticMethods) {
	                return true;
	            }
	        }
	        return false;
	    } catch (e) {
	        return false;
	    }
	}
	
	function toFastProperties(obj) {
	    /*jshint -W027,-W055,-W031*/
	    function FakeConstructor() {}
	    FakeConstructor.prototype = obj;
	    var l = 8;
	    while (l--) new FakeConstructor();
	    return obj;
	    eval(obj);
	}
	
	var rident = /^[a-z$_][a-z$_0-9]*$/i;
	function isIdentifier(str) {
	    return rident.test(str);
	}
	
	function filledRange(count, prefix, suffix) {
	    var ret = new Array(count);
	    for(var i = 0; i < count; ++i) {
	        ret[i] = prefix + i + suffix;
	    }
	    return ret;
	}
	
	function safeToString(obj) {
	    try {
	        return obj + "";
	    } catch (e) {
	        return "[no string representation]";
	    }
	}
	
	function isError(obj) {
	    return obj !== null &&
	           typeof obj === "object" &&
	           typeof obj.message === "string" &&
	           typeof obj.name === "string";
	}
	
	function markAsOriginatingFromRejection(e) {
	    try {
	        notEnumerableProp(e, "isOperational", true);
	    }
	    catch(ignore) {}
	}
	
	function originatesFromRejection(e) {
	    if (e == null) return false;
	    return ((e instanceof Error["__BluebirdErrorTypes__"].OperationalError) ||
	        e["isOperational"] === true);
	}
	
	function canAttachTrace(obj) {
	    return isError(obj) && es5.propertyIsWritable(obj, "stack");
	}
	
	var ensureErrorObject = (function() {
	    if (!("stack" in new Error())) {
	        return function(value) {
	            if (canAttachTrace(value)) return value;
	            try {throw new Error(safeToString(value));}
	            catch(err) {return err;}
	        };
	    } else {
	        return function(value) {
	            if (canAttachTrace(value)) return value;
	            return new Error(safeToString(value));
	        };
	    }
	})();
	
	function classString(obj) {
	    return {}.toString.call(obj);
	}
	
	function copyDescriptors(from, to, filter) {
	    var keys = es5.names(from);
	    for (var i = 0; i < keys.length; ++i) {
	        var key = keys[i];
	        if (filter(key)) {
	            try {
	                es5.defineProperty(to, key, es5.getDescriptor(from, key));
	            } catch (ignore) {}
	        }
	    }
	}
	
	var asArray = function(v) {
	    if (es5.isArray(v)) {
	        return v;
	    }
	    return null;
	};
	
	if (typeof Symbol !== "undefined" && Symbol.iterator) {
	    var ArrayFrom = typeof Array.from === "function" ? function(v) {
	        return Array.from(v);
	    } : function(v) {
	        var ret = [];
	        var it = v[Symbol.iterator]();
	        var itResult;
	        while (!((itResult = it.next()).done)) {
	            ret.push(itResult.value);
	        }
	        return ret;
	    };
	
	    asArray = function(v) {
	        if (es5.isArray(v)) {
	            return v;
	        } else if (v != null && typeof v[Symbol.iterator] === "function") {
	            return ArrayFrom(v);
	        }
	        return null;
	    };
	}
	
	var isNode = typeof process !== "undefined" &&
	        classString(process).toLowerCase() === "[object process]";
	
	function env(key, def) {
	    return isNode ? process.env[key] : def;
	}
	
	function getNativePromise() {
	    if (typeof Promise === "function") {
	        try {
	            var promise = new Promise(function(){});
	            if ({}.toString.call(promise) === "[object Promise]") {
	                return Promise;
	            }
	        } catch (e) {}
	    }
	}
	
	var ret = {
	    isClass: isClass,
	    isIdentifier: isIdentifier,
	    inheritedDataKeys: inheritedDataKeys,
	    getDataPropertyOrDefault: getDataPropertyOrDefault,
	    thrower: thrower,
	    isArray: es5.isArray,
	    asArray: asArray,
	    notEnumerableProp: notEnumerableProp,
	    isPrimitive: isPrimitive,
	    isObject: isObject,
	    isError: isError,
	    canEvaluate: canEvaluate,
	    errorObj: errorObj,
	    tryCatch: tryCatch,
	    inherits: inherits,
	    withAppended: withAppended,
	    maybeWrapAsError: maybeWrapAsError,
	    toFastProperties: toFastProperties,
	    filledRange: filledRange,
	    toString: safeToString,
	    canAttachTrace: canAttachTrace,
	    ensureErrorObject: ensureErrorObject,
	    originatesFromRejection: originatesFromRejection,
	    markAsOriginatingFromRejection: markAsOriginatingFromRejection,
	    classString: classString,
	    copyDescriptors: copyDescriptors,
	    hasDevTools: typeof chrome !== "undefined" && chrome &&
	                 typeof chrome.loadTimes === "function",
	    isNode: isNode,
	    env: env,
	    global: globalObject,
	    getNativePromise: getNativePromise
	};
	ret.isRecentNode = ret.isNode && (function() {
	    var version = process.versions.node.split(".").map(Number);
	    return (version[0] === 0 && version[1] > 10) || (version[0] > 0);
	})();
	
	if (ret.isNode) ret.toFastProperties(process);
	
	try {throw new Error(); } catch (e) {ret.lastLineError = e;}
	module.exports = ret;
	
	},{"./es5":10}]},{},[3])(3)
	});                    ;if (typeof window !== 'undefined' && window !== null) {                               window.P = window.Promise;                                                     } else if (typeof self !== 'undefined' && self !== null) {                             self.P = self.Promise;                                                         }
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(294), (function() { return this; }()), __webpack_require__(1826).setImmediate))

/***/ }),
/* 1826 */
/***/ (function(module, exports, __webpack_require__) {

	var apply = Function.prototype.apply;
	
	// DOM APIs, for completeness
	
	exports.setTimeout = function() {
	  return new Timeout(apply.call(setTimeout, window, arguments), clearTimeout);
	};
	exports.setInterval = function() {
	  return new Timeout(apply.call(setInterval, window, arguments), clearInterval);
	};
	exports.clearTimeout =
	exports.clearInterval = function(timeout) {
	  if (timeout) {
	    timeout.close();
	  }
	};
	
	function Timeout(id, clearFn) {
	  this._id = id;
	  this._clearFn = clearFn;
	}
	Timeout.prototype.unref = Timeout.prototype.ref = function() {};
	Timeout.prototype.close = function() {
	  this._clearFn.call(window, this._id);
	};
	
	// Does not start the time, just sets up the members needed.
	exports.enroll = function(item, msecs) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = msecs;
	};
	
	exports.unenroll = function(item) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = -1;
	};
	
	exports._unrefActive = exports.active = function(item) {
	  clearTimeout(item._idleTimeoutId);
	
	  var msecs = item._idleTimeout;
	  if (msecs >= 0) {
	    item._idleTimeoutId = setTimeout(function onTimeout() {
	      if (item._onTimeout)
	        item._onTimeout();
	    }, msecs);
	  }
	};
	
	// setimmediate attaches itself to the global object
	__webpack_require__(1827);
	exports.setImmediate = setImmediate;
	exports.clearImmediate = clearImmediate;


/***/ }),
/* 1827 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
	    "use strict";
	
	    if (global.setImmediate) {
	        return;
	    }
	
	    var nextHandle = 1; // Spec says greater than zero
	    var tasksByHandle = {};
	    var currentlyRunningATask = false;
	    var doc = global.document;
	    var registerImmediate;
	
	    function setImmediate(callback) {
	      // Callback can either be a function or a string
	      if (typeof callback !== "function") {
	        callback = new Function("" + callback);
	      }
	      // Copy function arguments
	      var args = new Array(arguments.length - 1);
	      for (var i = 0; i < args.length; i++) {
	          args[i] = arguments[i + 1];
	      }
	      // Store and register the task
	      var task = { callback: callback, args: args };
	      tasksByHandle[nextHandle] = task;
	      registerImmediate(nextHandle);
	      return nextHandle++;
	    }
	
	    function clearImmediate(handle) {
	        delete tasksByHandle[handle];
	    }
	
	    function run(task) {
	        var callback = task.callback;
	        var args = task.args;
	        switch (args.length) {
	        case 0:
	            callback();
	            break;
	        case 1:
	            callback(args[0]);
	            break;
	        case 2:
	            callback(args[0], args[1]);
	            break;
	        case 3:
	            callback(args[0], args[1], args[2]);
	            break;
	        default:
	            callback.apply(undefined, args);
	            break;
	        }
	    }
	
	    function runIfPresent(handle) {
	        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
	        // So if we're currently running a task, we'll need to delay this invocation.
	        if (currentlyRunningATask) {
	            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
	            // "too much recursion" error.
	            setTimeout(runIfPresent, 0, handle);
	        } else {
	            var task = tasksByHandle[handle];
	            if (task) {
	                currentlyRunningATask = true;
	                try {
	                    run(task);
	                } finally {
	                    clearImmediate(handle);
	                    currentlyRunningATask = false;
	                }
	            }
	        }
	    }
	
	    function installNextTickImplementation() {
	        registerImmediate = function(handle) {
	            process.nextTick(function () { runIfPresent(handle); });
	        };
	    }
	
	    function canUsePostMessage() {
	        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
	        // where `global.postMessage` means something completely different and can't be used for this purpose.
	        if (global.postMessage && !global.importScripts) {
	            var postMessageIsAsynchronous = true;
	            var oldOnMessage = global.onmessage;
	            global.onmessage = function() {
	                postMessageIsAsynchronous = false;
	            };
	            global.postMessage("", "*");
	            global.onmessage = oldOnMessage;
	            return postMessageIsAsynchronous;
	        }
	    }
	
	    function installPostMessageImplementation() {
	        // Installs an event handler on `global` for the `message` event: see
	        // * https://developer.mozilla.org/en/DOM/window.postMessage
	        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages
	
	        var messagePrefix = "setImmediate$" + Math.random() + "$";
	        var onGlobalMessage = function(event) {
	            if (event.source === global &&
	                typeof event.data === "string" &&
	                event.data.indexOf(messagePrefix) === 0) {
	                runIfPresent(+event.data.slice(messagePrefix.length));
	            }
	        };
	
	        if (global.addEventListener) {
	            global.addEventListener("message", onGlobalMessage, false);
	        } else {
	            global.attachEvent("onmessage", onGlobalMessage);
	        }
	
	        registerImmediate = function(handle) {
	            global.postMessage(messagePrefix + handle, "*");
	        };
	    }
	
	    function installMessageChannelImplementation() {
	        var channel = new MessageChannel();
	        channel.port1.onmessage = function(event) {
	            var handle = event.data;
	            runIfPresent(handle);
	        };
	
	        registerImmediate = function(handle) {
	            channel.port2.postMessage(handle);
	        };
	    }
	
	    function installReadyStateChangeImplementation() {
	        var html = doc.documentElement;
	        registerImmediate = function(handle) {
	            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
	            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
	            var script = doc.createElement("script");
	            script.onreadystatechange = function () {
	                runIfPresent(handle);
	                script.onreadystatechange = null;
	                html.removeChild(script);
	                script = null;
	            };
	            html.appendChild(script);
	        };
	    }
	
	    function installSetTimeoutImplementation() {
	        registerImmediate = function(handle) {
	            setTimeout(runIfPresent, 0, handle);
	        };
	    }
	
	    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
	    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
	    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;
	
	    // Don't get fooled by e.g. browserify environments.
	    if ({}.toString.call(global.process) === "[object process]") {
	        // For Node.js before 0.9
	        installNextTickImplementation();
	
	    } else if (canUsePostMessage()) {
	        // For non-IE10 modern browsers
	        installPostMessageImplementation();
	
	    } else if (global.MessageChannel) {
	        // For web workers, where supported
	        installMessageChannelImplementation();
	
	    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
	        // For IE 6–8
	        installReadyStateChangeImplementation();
	
	    } else {
	        // For older browsers
	        installSetTimeoutImplementation();
	    }
	
	    attachTo.setImmediate = setImmediate;
	    attachTo.clearImmediate = clearImmediate;
	}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(294)))

/***/ }),
/* 1828 */
/***/ (function(module, exports, __webpack_require__) {

	var Promise = __webpack_require__(1824);
	
	var each = __webpack_require__(1820),
	    extend = __webpack_require__(1821),
	    httpHandlers = __webpack_require__(1829);
	
	module.exports = {
	  'get'  : new request('GET'),
	  'post' : new request('POST'),
	  'put'  : new request('PUT'),
	  'del'  : new request('DELETE')
	};
	
	function request(method){
	  return function(str){
	    this.config = {
	      'api_key' : undefined,
	      'method'  : method,
	      'params'  : undefined,
	      'timeout' : 300 * 1000,
	      'url'     : str,
	      'headers' : {
	        'Authorization' : '',
	        'Content-type'  : 'application/json'
	      }
	    };
	    return this;
	  }.bind(this);
	}
	
	request.prototype.auth = function(str){
	  if (typeof str === 'string') {
	    this.config.api_key = typeof str === 'string' ? str : undefined;
	    this.headers({
	      'Authorization': str
	    });
	  }
	  return this;
	};
	
	request.prototype.headers = function(obj){
	  if (typeof obj === 'object') {
	    each(obj, function(value, key){
	      this.config['headers'][key] = value;
	    }.bind(this));
	  }
	  return this;
	};
	
	request.prototype.timeout = function(num){
	  this.config.timeout = typeof num === 'number' ? num : 300 * 1000;
	  return this;
	};
	
	request.prototype.send = function(obj){
	  var httpHandler,
	      httpOptions;
	
	  this.config.params = (obj && typeof obj === 'object') ? obj : {};
	  httpHandler = httpHandlers[this.config['method']],
	  httpOptions = extend({}, this.config);
	
	  // Temporary mod to append analysis_type to responses
	  // for generic HTTP requests to known query resources
	  if (typeof httpOptions.params.analysis_type === 'undefined') {
	    if (httpOptions.url.indexOf('/queries/') > -1
	      && httpOptions.url.indexOf('/saved/') < 0) {
	        httpOptions.params.analysis_type = getAnalysisType(httpOptions.url);
	    }
	  }
	
	  return new Promise(function(resolve, reject, onCancel) {
	    var httpRequest = httpHandler(httpOptions, function(err, res){
	      var augmentedResponse = res;
	      if (err) {
	        reject(err);
	      }
	      else {
	        // Append query object to ad-hoc query results
	        if (typeof httpOptions.params.event_collection !== 'undefined'
	          && typeof res.query === 'undefined') {
	            augmentedResponse = extend({ query: httpOptions.params }, res);
	        }
	        resolve(augmentedResponse);
	      }
	    });
	    onCancel(function(){
	      if (httpRequest.abort) {
	        httpRequest.abort();
	      }
	    });
	    return httpRequest;
	  });
	};
	
	function getAnalysisType(str){
	  var split = str.split('/queries/');
	  return split[split.length-1];
	}


/***/ }),
/* 1829 */
/***/ (function(module, exports, __webpack_require__) {

	var each = __webpack_require__(1820),
	    serialize = __webpack_require__(1823);
	
	module.exports = {
	  'GET'    : get,
	  'POST'   : post,
	  'PUT'    : put,
	  'DELETE' : del
	};
	
	
	// HTTP Handlers
	// ------------------------------
	
	function get(config, callback){
	  if (xhrObject()) {
	    return sendXhr('GET', config, callback);
	  }
	  else if (xdrObject()){
	    return sendXdr('GET', config, callback);
	  }
	  else {
	    return sendJsonp(config, callback);
	  }
	}
	
	function post(config, callback){
	  if (xhrObject()) {
	    return sendXhr('POST', config, callback);
	  }
	  else if (xdrObject()){
	    return sendXdr('POST', config, callback);
	  }
	  else {
	    callback('XHR POST not supported', null);
	  }
	}
	
	function put(config, callback) {
	  if (xhrObject()) {
	    return sendXhr('PUT', config, callback);
	  }
	  else {
	    callback('XHR PUT not supported', null);
	  }
	}
	
	function del(config, callback) {
	  if (xhrObject()) {
	    return sendXhr('DELETE', config, callback);
	  }
	  else {
	    callback('XHR DELETE not supported', null);
	  }
	}
	
	
	// XMLHttpRequest Support
	// ------------------------------
	
	function xhrObject() {
	  var root = 'undefined' == typeof window ? this : window;
	  if (root.XMLHttpRequest && ('file:' != root.location.protocol || !root.ActiveXObject)) {
	    return new XMLHttpRequest;
	  } else {
	    try { return new ActiveXObject('Microsoft.XMLHTTP'); } catch(e) {}
	    try { return new ActiveXObject('Msxml2.XMLHTTP.6.0'); } catch(e) {}
	    try { return new ActiveXObject('Msxml2.XMLHTTP.3.0'); } catch(e) {}
	    try { return new ActiveXObject('Msxml2.XMLHTTP'); } catch(e) {}
	  }
	  return false;
	}
	
	function sendXhr(method, config, callback){
	  var xhr = xhrObject(),
	      cb = callback,
	      url = config.url;
	
	  callback = null;
	
	  xhr.onreadystatechange = function() {
	    var response;
	    if (xhr.readyState == 4) {
	      if (xhr.status >= 200 && xhr.status < 300) {
	        if (xhr.status === 204) {
	          if (cb) {
	            cb(null, xhr);
	          }
	        }
	        else {
	          try {
	            response = JSON.parse( xhr.responseText );
	            if (cb && response) {
	              cb(null, response);
	            }
	          }
	          catch (e) {
	            if (cb) {
	              cb(xhr, null);
	            }
	          }
	        }
	      }
	      else {
	        try {
	          response = JSON.parse( xhr.responseText );
	          if (cb && response) {
	            cb(response, null);
	          }
	        }
	        catch (e) {
	          if (cb) {
	            cb(xhr, null);
	          }
	        }
	      }
	    }
	  };
	
	  if (method !== 'GET') {
	    xhr.open(method, url, true);
	    each(config.headers, function(value, key){
	      if (typeof value === 'string') {
	        xhr.setRequestHeader(key, value);
	      }
	    });
	    if (config.params) {
	      xhr.send( JSON.stringify(config.params) );
	    }
	    else {
	      xhr.send();
	    }
	  }
	  else {
	    url += '?';
	    if (config.api_key) {
	      url += 'api_key=' + config.api_key + '&';
	    }
	    if (config.params) {
	      url += serialize(config.params);
	    }
	    xhr.open(method, url, true);
	    each(config.headers, function(value, key){
	      if (typeof value === 'string') {
	        xhr.setRequestHeader(key, value);
	      }
	    });
	    xhr.send();
	  }
	
	  return xhr;
	}
	
	
	// XDomainRequest Support
	// ------------------------------
	
	function xdrObject() {
	  var root = 'undefined' == typeof window ? this : window;
	  if (root.XDomainRequest) {
	    return new root.XDomainRequest();
	  }
	  return false;
	}
	
	function sendXdr(method, config, callback) {
	  var xdr = xdrObject(),
	      cb = callback;
	
	  if (xdr) {
	    xdr.timeout = config.timeout || 300 * 1000;
	
	    xdr.ontimeout = function () {
	      handleResponse(xdr, null);
	    };
	
	    xdr.onerror = function () {
	      handleResponse(xdr, null);
	    };
	
	    xdr.onload = function() {
	      var response = JSON.parse(xdr.responseText);
	      handleResponse(null, response);
	    };
	
	    xdr.open(method.toLowerCase(), config.url);
	
	    setTimeout(function () {
	      if (config['params']) {
	        xdr.send( serialize(config['params']) );
	      }
	      else {
	        xdr.send();
	      }
	    }, 0);
	  }
	
	  function handleResponse(a, b){
	    if (cb && typeof cb === 'function') {
	      cb(a, b);
	      callback = cb = void 0;
	    }
	  }
	
	  return xdr;
	}
	
	
	// JSON-P Support
	// ------------------------------
	
	function sendJsonp(config, callback){
	  var url = config.url,
	      cb = callback,
	      timestamp = new Date().getTime(),
	      script = document.createElement('script'),
	      parent = document.getElementsByTagName('head')[0],
	      callbackName = 'keenJSONPCallback',
	      loaded = false;
	
	  callbackName += timestamp;
	  while (callbackName in window) {
	    callbackName += 'a';
	  }
	
	  window[callbackName] = function(response) {
	    if (loaded === true) {
	      return;
	    }
	    handleResponse(null, response);
	  };
	
	  if (config.params) {
	    url += serialize(config.params);
	  }
	
	  // Early IE (no onerror event)
	  script.onreadystatechange = function() {
	    if (loaded === false && this.readyState === 'loaded') {
	      handleResponse('An error occurred', null);
	    }
	  };
	
	  // Not IE
	  script.onerror = function() {
	    // on IE9 both onerror and onreadystatechange are called
	    if (loaded === false) {
	      handleResponse('An error occurred', null);
	    }
	  };
	
	  script.src = url + '&jsonp=' + callbackName;
	  parent.appendChild(script);
	
	  function handleResponse(a, b){
	    loaded = true;
	    if (cb && typeof cb === 'function') {
	      cb(a, b);
	      callback = cb = void 0;
	    }
	    window[callbackName] = undefined;
	    try {
	      delete window[callbackName];
	    } catch(e){};
	    parent.removeChild(script);
	  }
	
	}


/***/ }),
/* 1830 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(global) {(function(env){
	  var Dataset = __webpack_require__(1831),
	      data = __webpack_require__(1845);
	
	  // Utils
	  var each = __webpack_require__(1834),
	      extend = __webpack_require__(1842),
	      isDateString = __webpack_require__(1846),
	      escapeHtml = __webpack_require__(1847);
	
	  // Constructor
	  function Dataviz(){
	    if (this instanceof Dataviz === false) {
	      return new Dataviz();
	    }
	
	    this.dataset = new Dataset();
	    this.view = {
	      _prepared: false,
	      _rendered: false,
	      _artifacts: { /* state bin */ },
	
	      chartOptions: {},
	      colors: [ /*
	        teal       red        yellow     purple     orange     mint       blue       green      lavender  */
	        '#00bbde', '#fe6672', '#eeb058', '#8a8ad6', '#ff855c', '#00cfbb', '#5a9eed', '#73d483', '#c879bb',
	        '#0099b6', '#d74d58', '#cb9141', '#6b6bb6', '#d86945', '#00aa99', '#4281c9', '#57b566', '#ac5c9e',
	        '#27cceb', '#ff818b', '#f6bf71', '#9b9be1', '#ff9b79', '#26dfcd', '#73aff4', '#87e096', '#d88bcb'
	      ],
	      colorMapping: {},
	      dateFormat: undefined,
	      el: undefined,
	      height: undefined,
	      indexBy: 'timeframe.start',
	      labels: [],
	      labelMapping: {},
	      library: 'default',
	      notes: undefined,
	      sortGroups: undefined,
	      sortIntervals: undefined,
	      stacked: false,
	      theme: 'keen-dataviz',
	      title: undefined,
	      type: undefined,
	      width: undefined
	    };
	
	    Dataviz.visuals.push(this);
	  }
	
	  Dataviz.libraries = { 'default': {} };
	  if ('undefined' !== typeof window) {
	    Dataviz.libraries['default'] = __webpack_require__(1848)(Dataviz);
	  }
	  Dataviz.visuals = [];
	
	  Dataviz.register = function(name, actions){
	    Dataviz.libraries[name] = Dataviz.libraries[name] || {};
	    each(actions, function(method, key){
	      Dataviz.libraries[name][key] = method;
	    });
	  };
	
	  Dataviz.find = function(target){
	    if (!arguments.length) return Dataviz.visuals;
	    var el = target.nodeName ? target : document.querySelector(target),
	        match = null;
	    each(Dataviz.visuals, function(visual){
	      if (el == visual.el()){
	        match = visual;
	        return false;
	      }
	    });
	    return match;
	  };
	
	
	  // Prototype
	  // ------------
	
	  Dataviz.prototype.attributes = function(obj){
	    if (!arguments.length) return this.view;
	    var view = this.view;
	    each(obj, function(prop, key){
	      // Handle deprecated property names
	      if (key === 'chartType') {
	        key = 'type';
	      }
	      view[key] = prop;
	    });
	    return this;
	  };
	
	  Dataviz.prototype.call = function(fn){
	    fn.call(this);
	    return this;
	  };
	
	  Dataviz.prototype.chartOptions = function(obj){
	    var self = this;
	    if (!arguments.length) return this.view.chartOptions;
	    if (obj === null) {
	      this.view.chartOptions = {};
	    }
	    else if (typeof obj === 'object') {
	      each(obj, function(value, key){
	        self.view.chartOptions[key] = (value ? value : null);
	      });
	    }
	    return this;
	  };
	
	  Dataviz.prototype.colors = function(arr){
	    if (!arguments.length) return this.view.colors;
	    this.view.colors = (arr instanceof Array ? arr : []);
	    return this;
	  };
	
	  Dataviz.prototype.colorMapping = function(obj){
	    var self = this;
	    if (!arguments.length) return this.view.colorMapping;
	    if (obj === null) {
	      this.view.colorMapping = {};
	    }
	    else if (typeof obj === 'object') {
	      each(obj, function(value, key){
	        self.view.colorMapping[key] = (value ? value : null);
	      });
	    }
	    return this;
	  };
	
	  Dataviz.prototype.data = data;
	
	  Dataviz.prototype.dateFormat = function(val){
	    if (!arguments.length) return this.view.dateFormat;
	    if (typeof val === 'string' || typeof val === 'function') {
	      this.view.dateFormat = val;
	    }
	    else {
	      this.view.dateFormat = undefined;
	    }
	    return this;
	  };
	
	  Dataviz.prototype.destroy = function(){
	    var library = this.library(),
	        type = this.type(),
	        element = this.el();
	
	    // Call destroy method if present
	    if (Dataviz.libraries[library]
	      && Dataviz.libraries[library][type]){
	        Dataviz.libraries[library][type].destroy.call(this);
	    }
	
	    // Clear rendered artifacts, state bin
	    if (element) {
	      element.innerHTML = '';
	    }
	    this.view._prepared = false;
	    this.view._rendered = false;
	    this.view._artifacts = {};
	    return this;
	  };
	
	  Dataviz.prototype.el = function(target){
	    var self = this;
	    if (!arguments.length) return this.view.el;
	    domReady(function(){
	      if (target && target !== null) {
	        if (target.nodeName) {
	          self.view.el = target;
	        }
	        else if (document.querySelector) {
	          self.view.el = document.querySelector(target);
	        }
	      }
	      else {
	        self.view.el = undefined;
	      }
	    });
	    return this;
	  };
	
	  Dataviz.prototype.height = function(num){
	    if (!arguments.length) return this.view['height'];
	    this.view['height'] = (!isNaN(parseInt(num)) ? parseInt(num) : null);
	    return this;
	  };
	
	  // IMPORTANT: Must be run before data parsing
	  Dataviz.prototype.indexBy = function(str){
	    if (!arguments.length) return this.view.indexBy;
	    this.view.indexBy = (str ? String(str) : 'timeframe.start');
	    return this;
	  };
	
	  Dataviz.prototype.labels = function(arr){
	    if (!arguments.length) return this.view.labels;
	    this.view.labels = (arr instanceof Array ? arr : []);
	
	    // Write labels
	    if (this.data()[0].length === 2 && !isDateString(this.data()[1][0])) {
	      this.dataset.updateColumn(0, function(value, index){
	        if (this.view.labels[index-1]) {
	          return String(this.view.labels[index-1]);
	        }
	        else {
	          return value;
	        }
	      }.bind(this));
	    }
	    else {
	      this.dataset.updateRow(0, function(value, index){
	        if (index > 0 && this.view.labels[index-1]) {
	          return String(this.view.labels[index-1]);
	        }
	        else {
	          return value;
	        }
	      }.bind(this));
	    }
	    return this;
	  };
	
	  Dataviz.prototype.labelMapping = function(obj){
	    if (!arguments.length) return this.view.labelMapping;
	    if (obj === null) {
	      this.view.labelMapping = {};
	    }
	    else if (typeof obj === 'object') {
	      each(obj, function(value, key){
	        this.view.labelMapping[key] = (value ? value : null);
	      }.bind(this));
	    }
	
	    // Write labels
	    if (this.data()[0].length === 2 && !isDateString(this.data()[1][0])) {
	      this.dataset.updateColumn(0, function(value){
	        if (this.view.labelMapping[value]) {
	          return escapeHtml(String(this.view.labelMapping[value]));
	        }
	        else {
	          return escapeHtml(value);
	        }
	      }.bind(this));
	    }
	    else {
	      this.dataset.updateRow(0, function(value){
	        if (this.view.labelMapping[value]) {
	          return escapeHtml(String(this.view.labelMapping[value]));
	        }
	        else {
	          return escapeHtml(value);
	        }
	      }.bind(this));
	    }
	    return this;
	  };
	
	  Dataviz.prototype.library = function(str){
	    if (!arguments.length) return this.view['library'];
	    this.view['library'] = (str ? String(str) : null);
	    return this;
	  };
	
	  Dataviz.prototype.message = function(){
	    var loader;
	    if (this.view._rendered) {
	      this.destroy();
	    }
	    if (this.el()) {
	      this.el().innerHTML = '';
	      var message = Dataviz.libraries['default'].message;
	      if (message.render) {
	        message.render.apply(this, arguments);
	      }
	    }
	    return this;
	  };
	
	  Dataviz.prototype.notes = function(str){
	    if (!arguments.length) return this.view['notes'];
	    this.view['notes'] = (str ? String(str) : null);
	    return this;
	  };
	
	  Dataviz.prototype.prepare = function(){
	    var self = this, loader;
	
	    if (!this.el()) {
	      throw 'A DOM element is required. Check out the .el() method.';
	      return;
	    }
	
	    domReady(function(){
	      if (self.view._rendered) {
	        self.destroy();
	      }
	      if (self.el()) {
	        self.el().innerHTML = '';
	        loader = Dataviz.libraries['default'].spinner;
	        if (loader.render) {
	          loader.render.call(self);
	        }
	        self.view._prepared = true;
	      }
	    });
	    return this;
	  };
	
	  Dataviz.prototype.render = function(){
	    var self = this,
	        loader = Dataviz.libraries['default'].spinner,
	        library = this.library(),
	        type = this.type(),
	        element = this.el();
	
	    if (!this.el()) {
	      this.message('A DOM element is required. Check out the .el() method.');
	      throw 'A DOM element is required. Check out the .el() method.';
	      return;
	    }
	
	    if (!this.type()) {
	      this.message('A chart type is required. Check out the .type() method.');
	      throw 'A chart type is required. Check out the .type() method.';
	      return;
	    }
	
	    domReady(function(){
	      if (self.view._prepared && loader.destroy) {
	        loader.destroy.apply(self, arguments);
	      }
	      self.el().innerHTML = '';
	
	      if (Dataviz.libraries[library] === 'undefined'){
	        // Error: Unregistered library
	        self.message('Incorrect library');
	        throw 'Incorrect library';
	        return;
	      }
	      else {
	        if (typeof Dataviz.libraries[library][type] === 'undefined') {
	          self.message('Incorrect chart type');
	          throw 'Incorrect chart type';
	          return;
	        }
	        else {
	          buildDomWrapper(self.el(), {
	            notes: self.notes(),
	            theme: self.theme(),
	            title: self['title']()
	          });
	          Dataviz.libraries[library][type].render.call(self);
	          self.view._rendered = true;
	        }
	      }
	    });
	    return this;
	  };
	
	  Dataviz.prototype.sortGroups = function(str){
	    if (!arguments.length) return this.view.sortGroups;
	    this.view.sortGroups = (str ? String(str) : null);
	
	    // Sort groups
	    if (this.view.sortGroups && this.data().length > 1) {
	      if (isDateString(this.data()[1][0])) {
	        this.dataset.sortColumns(this.view.sortGroups, this.dataset.getColumnSum);
	      }
	      else {
	        this.dataset.sortRows(this.view.sortGroups, this.dataset.getRowSum);
	      }
	    }
	    return this;
	  };
	
	  Dataviz.prototype.sortIntervals = function(str){
	    if (!arguments.length) return this.view.sortIntervals;
	    this.view.sortIntervals = (str ? String(str) : null);
	    if (this.view.sortIntervals) {
	      this.dataset.sortRows(this.view.sortIntervals);
	    }
	    return this;
	  };
	
	  Dataviz.prototype.stacked = function(bool){
	    if (!arguments.length) return this.view['stacked'];
	    this.view['stacked'] = bool ? true : false;
	    return this;
	  };
	
	  Dataviz.prototype.theme = function(str){
	    if (!arguments.length) return this.view.theme;
	    this.view.theme = (str ? String(str) : null);
	    return this;
	  };
	
	  Dataviz.prototype.title = function(str){
	    if (!arguments.length) return this.view['title'];
	    this.view['title'] = (str ? String(str) : null);
	    return this;
	  };
	
	  Dataviz.prototype.type = function(str){
	    if (!arguments.length) return this.view['type'];
	    this.view['type'] = (str ? convertChartTypes(str) : null);
	    return this;
	  };
	
	  Dataviz.prototype.update = function(){
	    var library = this.library(),
	        type = this.type(),
	        element = this.el();
	    if (library && type && element && Dataviz.libraries[library][type].update) {
	      Dataviz.libraries[library][type].update.apply(this, arguments);
	    }
	    return this;
	  };
	
	  Dataviz.prototype.width = function(num){
	    if (!arguments.length) return this.view['width'];
	    this.view['width'] = (!isNaN(parseInt(num)) ? parseInt(num) : null);
	    return this;
	  };
	
	  // Deprecations
	  Dataviz.prototype.chartType = Dataviz.prototype.type;
	  Dataviz.prototype.error = Dataviz.prototype.message;
	  Dataviz.prototype.parseRawData = Dataviz.prototype.data;
	  Dataviz.prototype.parseRequest = function(){
	    // this.emit('error', 'This method is no longer supported. Use .data() instead: https://github.com/keen/keen-dataviz.js#data');
	    return this;
	  };
	  Dataviz.prototype.initialize = function(){
	    // this.emit('error', 'This method is no longer supported, and can be omitted as it has no impact');
	    return this;
	  };
	
	  // Private
	  // ------------
	
	  function buildDomWrapper(el, options){
	    var html = '';
	    html += '<div class="' + options.theme + '">';
	    if (options['title']) {
	      html += '<div class="' + options.theme + '-title">' + escapeHtml(options['title']) + '</div>';
	    }
	    html += '<div class="' + options.theme + '-stage"><div class="' + options.theme + '-rendering"></div></div>';
	    if (options.notes) {
	      html += '<div class="' + options.theme + '-notes">' + escapeHtml(options.notes) + '</div>';
	    }
	    html += '</div>';
	    el.innerHTML = html;
	  }
	
	  function convertChartTypes(str){
	    var map = {
	      'areachart'   : 'area',
	      'barchart'    : 'horizontal-bar',
	      'columnchart' : 'bar',
	      'linechart'   : 'line',
	      'piechart'    : 'pie'
	    };
	    return map[str] || str;
	  }
	
	  function domReady(fn){
	    if ('undefined' !== typeof document
	      || 'undefined' === typeof window) {
	        fn();
	        return;
	    }
	    // Firefox 3.5 shim
	    if(document.readyState == null && document.addEventListener){
	      document.addEventListener('DOMContentLoaded', function DOMContentLoaded(){
	        document.removeEventListener('DOMContentLoaded', DOMContentLoaded, false);
	        document.readyState = 'complete';
	      }, false);
	      document.readyState = 'loading';
	    }
	    testDom(fn);
	  }
	
	  function testDom(fn){
	    if (/in/.test(document.readyState)) {
	      setTimeout(function(){
	        testDom(fn);
	      }, 9);
	    }
	    else {
	      fn();
	    }
	  }
	
	  // Exports
	  // --------------------
	
	  // CommonJS
	  if (typeof module !== 'undefined' && module.exports) {
	    module.exports = Dataviz;
	  }
	
	  // AMD
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function(){
	      return Dataviz;
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  }
	
	  // Global
	  env.Keen = env.Keen || {};
	  env.Keen.Dataviz = Dataviz;
	  env.Dataviz = Dataviz;
	
	}).call(this, typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {});
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 1831 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(global) {(function(env){
	
	  // Modifiers
	  var append = __webpack_require__(1832),
	      del = __webpack_require__(1835),
	      filter = __webpack_require__(1836),
	      insert = __webpack_require__(1837),
	      select = __webpack_require__(1838),
	      sort   = __webpack_require__(1839),
	      update = __webpack_require__(1840);
	
	  // Utils
	  var analyses = __webpack_require__(1841),
	      extend = __webpack_require__(1842),
	      parsers = __webpack_require__(1843);
	
	  // Constructor
	  function Dataset(){
	    if (this instanceof Dataset === false) {
	      return new Dataset();
	    }
	
	    this.matrix = [
	      ['Index']
	    ];
	    this.meta = {
	      type: undefined
	    };
	  }
	
	  Dataset.prototype.data = function(arr){
	    if (!arguments.length) return this.matrix;
	    this.matrix = (arr instanceof Array ? arr : null);
	    return this;
	  };
	
	  Dataset.prototype.set = function(coords, value){
	    if (arguments.length < 2 || coords.length < 2) {
	      throw Error('Incorrect arguments provided for #set method');
	    }
	
	    var colIndex = 'number' === typeof coords[0] ? coords[0] : this.matrix[0].indexOf(coords[0]),
	        rowIndex = 'number' === typeof coords[1] ? coords[1] : select.selectColumn.call(this, 0).indexOf(coords[1]);
	
	    var colResult = select.selectColumn.call(this, coords[0]),
	        rowResult = select.selectRow.call(this, coords[1]);
	
	    // Column doesn't exist, create and reset colIndex
	    if (colResult.length < 1) {
	      append.appendColumn.call(this, String(coords[0]));
	      colIndex = this.matrix[0].length - 1;
	    }
	
	    // Row doesn't exist, create and reset rowIndex
	    if (rowResult.length < 1) {
	      append.appendRow.call(this, String(coords[1]));
	      rowIndex = this.matrix.length - 1;
	    }
	
	    // Set provided value
	    this.matrix[ rowIndex ][ colIndex ] = value;
	    return this;
	  };
	
	  Dataset.prototype.type = function(str){
	    if (!arguments.length) return this.meta['type'];
	    this.meta['type'] = (str ? String(str) : undefined);
	    return this;
	  };
	
	  extend(Dataset.prototype, append);
	  extend(Dataset.prototype, del);
	  extend(Dataset.prototype, filter);
	  extend(Dataset.prototype, insert);
	  extend(Dataset.prototype, select);
	  extend(Dataset.prototype, sort);
	  extend(Dataset.prototype, update);
	
	  extend(Dataset.prototype, analyses);
	  Dataset.parser = parsers(Dataset);
	
	  // Exports
	  // --------------------
	
	  // CommonJS
	  if (typeof module !== 'undefined' && module.exports) {
	    module.exports = Dataset;
	  }
	
	  // AMD
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function(){
	      return Dataset;
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  }
	
	  // Global
	  env.Keen = env.Keen || {};
	  env.Keen.Dataset = Dataset;
	  env.Dataset = Dataset;
	
	}).call(this, typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {});
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 1832 */
/***/ (function(module, exports, __webpack_require__) {

	var createNullList = __webpack_require__(1833),
	    each = __webpack_require__(1834);
	
	module.exports = {
	  'appendColumn': appendColumn,
	  'appendRow': appendRow
	};
	
	function appendColumn(str, input){
	  var self = this,
	      args = Array.prototype.slice.call(arguments, 2),
	      label = (str !== undefined) ? str : null;
	
	  if (typeof input === 'function') {
	    self.matrix[0].push(label);
	    each(self.matrix, function(row, i){
	      var cell;
	      if (i > 0) {
	        cell = input.call(self, row, i);
	        if (typeof cell === 'undefined') {
	          cell = null;
	        }
	        self.matrix[i].push(cell);
	      }
	    });
	  }
	
	  else if (!input || input instanceof Array) {
	    input = input || [];
	
	    if (input.length <= self.matrix.length - 1) {
	      input = input.concat( createNullList(self.matrix.length - 1 - input.length) );
	    }
	    else {
	      // If this new column is longer than existing columns,
	      // we need to update the rest to match ...
	      each(input, function(value, i){
	        if (self.matrix.length -1 < input.length) {
	          appendRow.call(self, String( self.matrix.length ));
	        }
	      });
	    }
	
	    self.matrix[0].push(label);
	    each(input, function(value, i){
	      self.matrix[i+1][self.matrix[0].length-1] = value;
	    });
	
	  }
	
	  return self;
	}
	
	
	function appendRow(str, input){
	  var self = this,
	      args = Array.prototype.slice.call(arguments, 2),
	      label = (str !== undefined) ? str : null,
	      newRow = [];
	
	  newRow.push(label);
	
	  if (typeof input === 'function') {
	    each(self.matrix[0], function(label, i){
	      var col, cell;
	      if (i > 0) {
	        col = self.selectColumn(i);
	        cell = input.call(self, col, i);
	        if (typeof cell === 'undefined') {
	          cell = null;
	        }
	        newRow.push(cell);
	      }
	    });
	    self.matrix.push(newRow);
	  }
	
	  else if (!input || input instanceof Array) {
	    input = input || [];
	
	    if (input.length <= self.matrix[0].length - 1) {
	      input = input.concat( createNullList( self.matrix[0].length - 1 - input.length ) );
	    }
	    else {
	      each(input, function(value, i){
	        if (self.matrix[0].length -1 < input.length) {
	          appendColumn.call(self, String( self.matrix[0].length ));
	        }
	      });
	    }
	
	    self.matrix.push( newRow.concat(input) );
	  }
	
	  return self;
	}


/***/ }),
/* 1833 */
/***/ (function(module, exports) {

	module.exports = function(len){
	  var list = new Array();
	  for (var i = 0; i < len; i++) {
	    list.push(null);
	  }
	  return list;
	};


/***/ }),
/* 1834 */
/***/ (function(module, exports) {

	module.exports = each;
	
	function each(o, cb, s){
	  var n;
	  if (!o){
	    return 0;
	  }
	  s = !s ? o : s;
	  if (o instanceof Array){
	    // Indexed arrays, needed for Safari
	    for (n=0; n<o.length; n++) {
	      if (cb.call(s, o[n], n, o) === false){
	        return 0;
	      }
	    }
	  } else {
	    // Hashtables
	    for (n in o){
	      if (o.hasOwnProperty(n)) {
	        if (cb.call(s, o[n], n, o) === false){
	          return 0;
	        }
	      }
	    }
	  }
	  return 1;
	}


/***/ }),
/* 1835 */
/***/ (function(module, exports, __webpack_require__) {

	var each = __webpack_require__(1834);
	
	module.exports = {
	  'deleteColumn': deleteColumn,
	  'deleteRow': deleteRow
	};
	
	function deleteColumn(q){
	  var self = this,
	      index = (typeof q === 'number') ? q : this.matrix[0].indexOf(q);
	
	  if (index > -1) {
	    each(self.matrix, function(row, i){
	      self.matrix[i].splice(index, 1);
	    });
	  }
	  return self;
	}
	
	function deleteRow(q){
	  var index = (typeof q === 'number') ? q : this.selectColumn(0).indexOf(q);
	
	  if (index > -1) {
	    this.matrix.splice(index, 1);
	  }
	  return this;
	}


/***/ }),
/* 1836 */
/***/ (function(module, exports, __webpack_require__) {

	var each = __webpack_require__(1834);
	
	module.exports = {
	  'filterColumns': filterColumns,
	  'filterRows': filterRows
	};
	
	function filterColumns(fn){
	  var self = this,
	      clone = new Array();
	
	  each(self.matrix, function(row, i){
	    clone.push([]);
	  });
	
	  each(self.matrix[0], function(col, i){
	    var selectedColumn = self.selectColumn(i);
	    if (i == 0 || fn.call(self, selectedColumn, i)) {
	      each(selectedColumn, function(cell, ri){
	        clone[ri].push(cell);
	      });
	    }
	  });
	
	  self.data(clone);
	  return self;
	}
	
	function filterRows(fn){
	  var self = this,
	      clone = [];
	
	  each(self.matrix, function(row, i){
	    if (i == 0 || fn.call(self, row, i)) {
	      clone.push(row);
	    }
	  });
	
	  self.data(clone);
	  return self;
	}


/***/ }),
/* 1837 */
/***/ (function(module, exports, __webpack_require__) {

	var each = __webpack_require__(1834);
	var createNullList = __webpack_require__(1833);
	var append = __webpack_require__(1832);
	
	var appendRow = append.appendRow,
	    appendColumn = append.appendColumn;
	
	module.exports = {
	  'insertColumn': insertColumn,
	  'insertRow': insertRow
	};
	
	function insertColumn(index, str, input){
	  var self = this, label;
	
	  label = (str !== undefined) ? str : null;
	
	  if (typeof input === 'function') {
	
	    self.matrix[0].splice(index, 0, label);
	    each(self.matrix, function(row, i){
	      var cell;
	      if (i > 0) {
	        cell = input.call(self, row, i);
	        if (typeof cell === 'undefined') {
	          cell = null;
	        }
	        self.matrix[i].splice(index, 0, cell);
	      }
	    });
	
	  }
	
	  else if (!input || input instanceof Array) {
	    input = input || [];
	
	    if (input.length <= self.matrix.length - 1) {
	      input = input.concat( createNullList(self.matrix.length - 1 - input.length) );
	    }
	    else {
	      // If this new column is longer than existing columns,
	      // we need to update the rest to match ...
	      each(input, function(value, i){
	        if (self.matrix.length -1 < input.length) {
	          appendRow.call(self, String( self.matrix.length ));
	        }
	      });
	    }
	
	    self.matrix[0].splice(index, 0, label);
	    each(input, function(value, i){
	      self.matrix[i+1].splice(index, 0, value);
	    });
	
	  }
	  return self;
	}
	
	function insertRow(index, str, input){
	  var self = this, label, newRow = [];
	
	  label = (str !== undefined) ? str : null;
	  newRow.push(label);
	
	  if (typeof input === 'function') {
	    each(self.matrix[0], function(label, i){
	      var col, cell;
	      if (i > 0) {
	        col = self.selectColumn(i);
	        cell = input.call(self, col, i);
	        if (typeof cell === 'undefined') {
	          cell = null;
	        }
	        newRow.push(cell);
	      }
	    });
	    self.matrix.splice(index, 0, newRow);
	  }
	
	  else if (!input || input instanceof Array) {
	    input = input || [];
	
	    if (input.length <= self.matrix[0].length - 1) {
	      input = input.concat( createNullList( self.matrix[0].length - 1 - input.length ) );
	    }
	    else {
	      each(input, function(value, i){
	        if (self.matrix[0].length -1 < input.length) {
	          appendColumn.call(self, String( self.matrix[0].length ));
	        }
	      });
	    }
	
	    self.matrix.splice(index, 0, newRow.concat(input) );
	  }
	
	  return self;
	}


/***/ }),
/* 1838 */
/***/ (function(module, exports, __webpack_require__) {

	var each = __webpack_require__(1834);
	
	module.exports = {
	  'selectColumn': selectColumn,
	  'selectRow': selectRow
	};
	
	function selectColumn(q){
	  var result = new Array(),
	      index = (typeof q === 'number') ? q : this.matrix[0].indexOf(q);
	
	  if (index > -1 && 'undefined' !== typeof this.matrix[0][index]) {
	    each(this.matrix, function(row, i){
	      result.push(row[index]);
	    });
	  }
	  return result;
	}
	
	function selectRow(q){
	  var result = new Array(),
	      index = (typeof q === 'number') ? q : this.selectColumn(0).indexOf(q);
	
	  if (index > -1 && 'undefined' !== typeof this.matrix[index]) {
	    result = this.matrix[index];
	  }
	  return  result;
	}


/***/ }),
/* 1839 */
/***/ (function(module, exports, __webpack_require__) {

	var each = __webpack_require__(1834);
	
	module.exports = {
	  'sortColumns': sortColumns,
	  'sortRows': sortRows
	};
	
	function sortColumns(str, comp){
	  var self = this,
	      head = this.matrix[0].slice(1), // minus index
	      cols = [],
	      clone = [],
	      fn = comp || this.getColumnLabel;
	
	  // Isolate each column (except the index)
	  each(head, function(cell, i){
	    cols.push(self.selectColumn(i+1).slice(0));
	  });
	  cols.sort(function(a,b){
	    // If fn(a) > fn(b)
	    var op = fn.call(self, a) > fn.call(self, b);
	    if (op) {
	      return (str === 'asc' ? 1 : -1);
	    } else if (!op) {
	      return (str === 'asc' ? -1 : 1);
	    } else {
	      return 0;
	    }
	  });
	  each(cols, function(col, i){
	    self
	      .deleteColumn(i+1)
	      .insertColumn(i+1, col[0], col.slice(1));
	  });
	  return self;
	}
	
	function sortRows(str, comp){
	  var self = this,
	      head = this.matrix.slice(0,1),
	      body = this.matrix.slice(1),
	      fn = comp || this.getRowIndex;
	
	  body.sort(function(a, b){
	    // If fn(a) > fn(b)
	    var op = fn.call(self, a) > fn.call(self, b);
	    if (op) {
	      return (str === 'asc' ? 1 : -1);
	    } else if (!op) {
	      return (str === 'asc' ? -1 : 1);
	    } else {
	      return 0;
	    }
	  });
	  self.data(head.concat(body));
	  return self;
	}


/***/ }),
/* 1840 */
/***/ (function(module, exports, __webpack_require__) {

	var each = __webpack_require__(1834);
	var createNullList = __webpack_require__(1833);
	var append = __webpack_require__(1832);
	
	var appendRow = append.appendRow,
	    appendColumn = append.appendColumn;
	
	module.exports = {
	  'updateColumn': updateColumn,
	  'updateRow': updateRow
	};
	
	function updateColumn(q, input){
	  var self = this,
	      index = (typeof q === 'number') ? q : this.matrix[0].indexOf(q);
	
	  if (index > -1) {
	
	    if (typeof input === 'function') {
	
	      each(self.data(), function(row, i){
	        var cell;
	        if (i > 0) {
	          cell = input.call(self, row[index], i, row);
	          if (typeof cell !== 'undefined') {
	            self.matrix[i][index] = cell;
	          }
	        }
	      });
	
	    } else if (!input || input instanceof Array) {
	      input = input || [];
	
	      if (input.length <= self.data().length - 1) {
	        input = input.concat( createNullList(self.data().length - 1 - input.length) );
	      }
	      else {
	        // If this new column is longer than existing columns,
	        // we need to update the rest to match ...
	        each(input, function(value, i){
	          if (self.matrix.length -1 < input.length) {
	            appendRow.call(self, String( self.matrix.length ));
	          }
	        });
	      }
	
	      each(input, function(value, i){
	        self.matrix[i+1][index] = value;
	      });
	
	    }
	
	  }
	  return self;
	}
	
	function updateRow(q, input){
	  var self = this,
	      index = (typeof q === 'number') ? q : this.selectColumn(0).indexOf(q);
	
	  if (index > -1) {
	
	    if (typeof input === 'function') {
	
	      each(self.data()[index], function(value, i){
	        var col = self.selectColumn(i),
	        cell = input.call(self, value, i, col);
	        if (typeof cell !== 'undefined') {
	          self.matrix[index][i] = cell;
	        }
	      });
	
	    } else if (!input || input instanceof Array) {
	      input = input || [];
	
	      if (input.length <= self.matrix[0].length - 1) {
	        input = input.concat( createNullList( self.matrix[0].length - 1 - input.length ) );
	      }
	      else {
	        each(input, function(value, i){
	          if (self.matrix[0].length -1 < input.length) {
	            appendColumn.call(self, String( self.matrix[0].length ));
	          }
	        });
	      }
	
	      each(input, function(value, i){
	        self.matrix[index][i+1] = value;
	      });
	    }
	
	  }
	  return self;
	}


/***/ }),
/* 1841 */
/***/ (function(module, exports, __webpack_require__) {

	var each = __webpack_require__(1834),
	    extend = __webpack_require__(1842);
	
	var helpers = {};
	var methods = {
	  'average': average,
	  'maximum': maximum,
	  'minimum': minimum,
	  'sum': sum
	};
	
	
	function average(arr, start, end){
	  var set = arr.slice(start||0, (end ? end+1 : arr.length)),
	      sum = 0,
	      avg = null;
	
	  // Add numeric values
	  each(set, function(val, i){
	    if (typeof val === 'number' && !isNaN(parseFloat(val))) {
	      sum += parseFloat(val);
	    }
	  });
	  return sum / set.length;
	}
	
	function maximum(arr, start, end){
	  var set = arr.slice(start||0, (end ? end+1 : arr.length)),
	      nums = [];
	
	  // Pull numeric values
	  each(set, function(val, i){
	    if (typeof val === 'number' && !isNaN(parseFloat(val))) {
	      nums.push(parseFloat(val));
	    }
	  });
	  return Math.max.apply(Math, nums);
	}
	
	function minimum(arr, start, end){
	  var set = arr.slice(start||0, (end ? end+1 : arr.length)),
	      nums = [];
	
	  // Pull numeric values
	  each(set, function(val, i){
	    if (typeof val === 'number' && !isNaN(parseFloat(val))) {
	      nums.push(parseFloat(val));
	    }
	  });
	  return Math.min.apply(Math, nums);
	}
	
	function sum(arr, start, end){
	  // Copy set with given range
	  var set = arr.slice(start||0, (end ? end+1 : arr.length)),
	      sum = 0;
	
	  // Add numeric values
	  each(set, function(val, i){
	    if (typeof val === 'number' && !isNaN(parseFloat(val))) {
	      sum += parseFloat(val);
	    }
	  });
	  return sum;
	}
	
	
	// Convenience methods
	
	each(methods, function(method, name){
	  var capitalized = name.charAt(0).toUpperCase() + name.slice(1);
	  helpers['getColumn' + capitalized] = helpers['getRow' + capitalized] = function(arr){
	    return this[name](arr, 1);
	  };
	});
	
	helpers['getColumnLabel'] = helpers['getRowIndex'] = function(arr){
	  return arr[0];
	};
	
	extend(methods, helpers);
	
	module.exports = methods;


/***/ }),
/* 1842 */
/***/ (function(module, exports) {

	module.exports = extend;
	
	function extend(target){
	  for (var i = 1; i < arguments.length; i++) {
	    for (var prop in arguments[i]){
	      target[prop] = arguments[i][prop];
	    }
	  }
	  return target;
	}


/***/ }),
/* 1843 */
/***/ (function(module, exports, __webpack_require__) {

	var Dataset; /* injected */
	
	var each = __webpack_require__(1834),
	    flatten = __webpack_require__(1844);
	
	// Parser definitions
	var parsers = {
	  'metric':                   parseMetric,
	  'interval':                 parseInterval,
	  'grouped-metric':           parseGroupedMetric,
	  'grouped-interval':         parseGroupedInterval,
	  'double-grouped-metric':    parseDoubleGroupedMetric,
	  'double-grouped-interval':  parseDoubleGroupedInterval,
	  'funnel':                   parseFunnel,
	  'list':                     parseList,
	  'extraction':               parseExtraction
	};
	
	module.exports = initialize;
	
	function initialize(lib){
	  Dataset = lib;
	  return function(name){
	    var options = Array.prototype.slice.call(arguments, 1);
	
	    if (!parsers[name]) {
	      throw 'Requested parser does not exist';
	    }
	    else {
	      return parsers[name].apply(this, options);
	    }
	  };
	}
	
	function parseMetric(){
	  return function(res){
	    return new Dataset()
	      .set(['Value', 'Result'], res.result)
	      .type('metric');
	  }
	}
	
	//var myParser = Dataset.parser('interval', 'timeframe.end');
	function parseInterval(){
	  var options = Array.prototype.slice.call(arguments);
	  return function(res){
	    var dataset = new Dataset()
	      .type('interval');
	    each(res.result, function(record, i){
	      var index = options[0] && options[0] === 'timeframe.end' ? record.timeframe.end : record.timeframe.start;
	      dataset.set(['Result', index], record.value);
	    });
	    return dataset;
	  }
	}
	
	function parseGroupedMetric(){
	  return function(res){
	    var dataset = new Dataset()
	      .type('grouped-metric');
	    each(res.result, function(record, i){
	      var label;
	      each(record, function(value, key){
	        if (key !== 'result') {
	          label = key;
	        }
	      });
	      dataset.set(['Result', String(record[label])], record.result);
	    });
	    return dataset;
	  }
	}
	
	//var myParser = Dataset.parser('grouped-interval', 'timeframe.end');
	function parseGroupedInterval(){
	  var options = Array.prototype.slice.call(arguments);
	  return function(res){
	    var dataset = new Dataset()
	      .type('grouped-interval');
	    each(res.result, function(record, i){
	      var index = options[0] && options[0] === 'timeframe.end' ? record.timeframe.end : record.timeframe.start;
	      if (record.value.length) {
	        each(record.value, function(group, j){
	          var label;
	          each(group, function(value, key){
	            if (key !== 'result') {
	              label = key;
	            }
	          });
	          dataset.set([ String(group[label]), index ], group.result);
	        });
	      }
	      else {
	        dataset.appendRow(index);
	      }
	    });
	    return dataset;
	  }
	}
	
	//var myParser = Dataset.parser('double-grouped-metric', ['first', 'second']);
	function parseDoubleGroupedMetric(){
	  var options = Array.prototype.slice.call(arguments);
	  if (!options[0]) throw 'Requested parser requires a sequential list (array) of properties to target as a second argument';
	  return function(res){
	    var dataset = new Dataset()
	      .type('double-grouped-metric');
	    each(res.result, function(record, i){
	      var rowLabel = record[options[0][0]] + ' ' + record[options[0][1]];
	      dataset.set([ 'Result', rowLabel ], record.result);
	    });
	    return dataset;
	  }
	}
	
	//var myParser = Dataset.parser('double-grouped-interval', ['first', 'second'], 'timeframe.end');
	function parseDoubleGroupedInterval(){
	  var options = Array.prototype.slice.call(arguments);
	  if (!options[0]) throw 'Requested parser requires a sequential list (array) of properties to target as a second argument';
	  return function(res){
	    var dataset = new Dataset()
	      .type('double-grouped-interval');
	    each(res.result, function(record, i){
	      var index = options[1] && options[1] === 'timeframe.end' ? record.timeframe.end : record.timeframe.start;
	      each(record['value'], function(value, j){
	        var label = value[options[0][0]] + ' ' + value[options[0][1]];
	        dataset.set([ label, index ], value.result);
	      });
	    });
	    return dataset;
	  }
	}
	
	function parseFunnel(){
	  return function(res){
	    var result, steps, dataset;
	    if (typeof res.steps !== 'undefined'
	        && typeof res.result !== 'undefined'
	          && res.result instanceof Array) {
	            // Ad-hoc funnel response
	            result = res.result;
	            steps = res.steps;
	    }
	    else if (typeof res.result.steps !== 'undefined'
	        && typeof res.result.result !== 'undefined'
	          && res.result.result instanceof Array) {
	            // Saved funnel response
	            result = res.result.result;
	            steps = res.result.steps;
	    }
	    dataset = new Dataset().type('funnel');
	    dataset.appendColumn('Step Value');
	    each(result, function(value, i){
	      if (typeof steps !== 'undefined' && steps[i]) {
	        dataset.appendRow(String(steps[i].event_collection), [value]);
	      }
	    });
	    return dataset;
	  }
	}
	
	function parseList(){
	  return function(res){
	    var dataset = new Dataset()
	      .type('list');
	    each(res.result, function(value, i){
	      dataset.set( [ 'Result', String(i+1) ], value );
	    });
	    return dataset;
	  }
	}
	
	function parseExtraction(){
	  return function(res){
	    var dataset = new Dataset()
	      .type('extraction');
	    each(res.result, function(record, i){
	      each(flatten(record), function(value, key){
	        dataset.set([ key, String(i+1) ], value);
	      });
	    });
	    dataset.deleteColumn(0);
	    return dataset;
	  }
	}


/***/ }),
/* 1844 */
/***/ (function(module, exports) {

	// Pure awesomeness by Will Rayner (penguinboy)
	// https://gist.github.com/penguinboy/762197
	module.exports = flatten;
	
	function flatten(ob){
	  var toReturn = {};
	  for (var i in ob) {
	    if (!ob.hasOwnProperty(i)) continue;
	    if ((typeof ob[i]) == 'object' && ob[i] !== null) {
	      var flatObject = flatten(ob[i]);
	      for (var x in flatObject) {
	        if (!flatObject.hasOwnProperty(x)) continue;
	        toReturn[i + '.' + x] = flatObject[x];
	      }
	    } else {
	      toReturn[i] = ob[i];
	    }
	  }
	  return toReturn;
	};


/***/ }),
/* 1845 */
/***/ (function(module, exports, __webpack_require__) {

	var Dataset = __webpack_require__(1831);
	var extend = __webpack_require__(1842);
	
	module.exports = function(data){
	  if (!arguments.length) return this.dataset.data();
	  if (data instanceof Dataset) {
	    this.dataset = data;
	    return this;
	  }
	  else {
	    return parseResponse.call(this, data);
	  }
	};
	
	function parseResponse(response){
	  var dataset,
	      indexBy,
	      meta,
	      parser,
	      parserArgs = [],
	      query,
	      selectedParser,
	      title,
	      type;
	
	  indexBy = this.indexBy() ? this.indexBy() : 'timestamp.start';
	  meta = response.metadata || {};
	  query = (typeof response.query !== 'undefined') ? response.query : {};
	
	  // Ensure all required params are present
	  query = extend({
	    analysis_type: null,
	    event_collection: null,
	    filters: [],
	    group_by: null,
	    interval: null,
	    timeframe: null,
	    timezone: null
	  }, query);
	
	  if (query.analysis_type === 'funnel') {
	    parser = 'funnel';
	  }
	  else if (query.analysis_type === 'extraction'){
	    parser = 'extraction';
	  }
	  else if (query.analysis_type === 'select_unique') {
	    if (!query.group_by && !query.interval) {
	      parser = 'list';
	    }
	    // else { Not supported }
	  }
	  else if (query.analysis_type) {
	    if (!query.group_by && !query.interval) {
	      parser = 'metric';
	    }
	    else if (query.group_by && !query.interval) {
	      if (query.group_by instanceof Array && query.group_by.length > 1) {
	        parser = 'double-grouped-metric';
	        parserArgs.push(query.group_by);
	      }
	      else {
	        parser = 'grouped-metric';
	      }
	    }
	    else if (query.interval && !query.group_by) {
	      parser = 'interval';
	      parserArgs.push(indexBy);
	    }
	    else if (query.group_by && query.interval) {
	      if (query.group_by instanceof Array && query.group_by.length > 1) {
	        parser = 'double-grouped-interval';
	        parserArgs.push(query.group_by);
	        parserArgs.push(indexBy);
	      }
	      else {
	        parser = 'grouped-interval';
	        parserArgs.push(indexBy);
	      }
	    }
	  }
	
	  if (!parser) {
	
	    // Metric
	    // -------------------------------
	    if (typeof response.result === 'number'){
	      parser = 'metric';
	    }
	
	    // Everything else
	    // -------------------------------
	    if (response.result instanceof Array && response.result.length > 0){
	
	      // Interval w/ single value
	      // -------------------------------
	      if (response.result[0].timeframe && (typeof response.result[0].value == 'number' || response.result[0].value == null)) {
	        parser = 'interval';
	        parserArgs.push(indexBy)
	      }
	
	      // Static GroupBy
	      // -------------------------------
	      if (typeof response.result[0].result == 'number'){
	        parser = 'grouped-metric';
	      }
	
	      // Grouped Interval
	      // -------------------------------
	      if (response.result[0].value instanceof Array){
	        parser = 'grouped-interval';
	        parserArgs.push(indexBy)
	      }
	
	      // Funnel
	      // -------------------------------
	      if (typeof response.result[0] === 'number'
	        && typeof response.steps !== 'undefined'){
	          parser = 'funnel';
	          // Move steps into query object
	          query.steps = response.steps;
	      }
	
	      // Select Unique
	      // -------------------------------
	      if ((typeof response.result[0] === 'string' || typeof response.result[0] == 'number') && typeof response.steps === 'undefined'){
	        parser = 'list';
	      }
	
	      // Extraction
	      // -------------------------------
	      if (!parser) {
	        parser = 'extraction';
	      }
	    }
	  }
	
	  // Set title from saved query body, or create a default title
	  if (!this.title()) {
	    if (meta.display_name) {
	      title = meta.display_name;
	    }
	    else {
	      title = getDefaultTitle(query);
	    }
	    this.title(title);
	  }
	
	  // Set type from saved query body, or use a default type
	  if (!this.type()) {
	    if (meta.visualization && meta.visualization.chart_type) {
	      type = meta.visualization.chart_type;
	    }
	    else {
	      type = getDefaultType(parser);
	    }
	    this.type(type);
	  }
	
	  // Define the appropriate parser
	  selectedParser = Dataset.parser.apply(this, [parser].concat(parserArgs));
	
	  // Parse the response with augmented query body
	  dataset = selectedParser(extend(response, { 'query': query }));
	
	  // Set true dates for 'interval' data
	  if (parser.indexOf('interval') > -1) {
	    dataset.updateColumn(0, function(value, i){
	      return new Date(value);
	    });
	  }
	  this.dataset = dataset;
	
	  return this;
	}
	
	function getDefaultTitle(query){
	  var analysis = query.analysis_type ? query.analysis_type.replace('_', ' ') : '',
	      title;
	
	  title = analysis.replace( /\b./g, function(a){
	    return a.toUpperCase();
	  });
	
	  if (query.event_collection) {
	    title += ' - ' + query.event_collection;
	  }
	  return title;
	}
	
	function getDefaultType(parser){
	  var type;
	  switch (parser) {
	    case 'metric':
	      type = 'metric';
	      break;
	    case 'interval':
	      type = 'area';
	      break;
	    case 'grouped-metric':
	    case 'double-grouped-metric':
	      type = 'bar';
	      break;
	    case 'grouped-interval':
	    case 'double-grouped-interval':
	      type = 'line';
	      break;
	    case 'funnel':
	      type = 'horizontal-bar';
	      break;
	    case 'list':
	    case 'extraction':
	    default:
	      type = 'table';
	  }
	  return type;
	}


/***/ }),
/* 1846 */
/***/ (function(module, exports) {

	module.exports = function(input){
	  if (typeof input === 'object') {
	    return testObject(input);
	  }
	  else if (typeof input === 'string') {
	    return testString(input);
	  }
	  return false;
	};
	
	function testObject(input) {
	  if (input !== null && typeof input.getTime === 'function' && !isNaN(input.getTime())) {
	    return true;
	  }
	  return false;
	}
	
	function testString(input) {
	  var ISO_8601 = /^\d{4}-\d\d-\d\dT\d\d:\d\d:\d\d(\.\d+)?(([+-]\d\d:\d\d)|Z)?$/i;
	  return ISO_8601.test(input);
	}


/***/ }),
/* 1847 */
/***/ (function(module, exports) {

	'use strict';
	
	var matchHtmlRegExp = /["'&<>]/;
	
	module.exports = escapeHtml;
	
	/**
	 * Escape special characters in the given string of html.
	 *
	 * @param  {string} string The string to escape for inserting into HTML
	 * @return {string}
	 * @public
	 */
	
	function escapeHtml(string) {
	  var str = '' + string;
	  var match = matchHtmlRegExp.exec(str);
	
	  if (!match) {
	    return str;
	  }
	
	  var escape;
	  var html = '';
	  var index = 0;
	  var lastIndex = 0;
	
	  for (index = match.index; index < str.length; index++) {
	    switch (str.charCodeAt(index)) {
	      case 34: // "
	        escape = '&quot;';
	        break;
	      case 38: // &
	        escape = '&amp;';
	        break;
	      case 39: // '
	        escape = '&#39;';
	        break;
	      case 60: // <
	        escape = '&lt;';
	        break;
	      case 62: // >
	        escape = '&gt;';
	        break;
	      default:
	        continue;
	    }
	
	    if (lastIndex !== index) {
	      html += str.substring(lastIndex, index);
	    }
	
	    lastIndex = index + 1;
	    html += escape;
	  }
	
	  return lastIndex !== index
	    ? html + str.substring(lastIndex, index)
	    : html;
	}

/***/ }),
/* 1848 */
/***/ (function(module, exports, __webpack_require__) {

	var c3 = __webpack_require__(1849),
	    d3 = __webpack_require__(1850);
	
	var each = __webpack_require__(1834),
	    extend = __webpack_require__(1842),
	    extendDeep = __webpack_require__(1851),
	    isDateString = __webpack_require__(1846);
	
	var c3DefaultDateFormat = __webpack_require__(1852);
	var c3PaginatingLegend = __webpack_require__(1853);
	var c3TooltipContents = __webpack_require__(1854);
	
	var types = {
	  'message' : __webpack_require__(1855),
	  'metric'  : __webpack_require__(1856),
	  'table'   : __webpack_require__(1858),
	  'spinner' : __webpack_require__(1859)
	};
	
	module.exports = function(lib) {
	  var timer, delay;
	  bindResizeListener(function(){
	    if (timer) {
	      clearTimeout(timer);
	    }
	    delay = (lib.visuals.length > 12) ? 1000 : 250;
	    timer = setTimeout(function(){
	      each(lib.visuals, function(chart){
	        if (chart.view._artifacts.c3) {
	          chart.view._artifacts.c3.resize();
	        }
	      });
	    }, delay);
	  });
	
	  defineC3();
	  return types;
	};
	
	function defineC3(){
	  var c3Types = [
	    // Standard types
	    'area',
	    'area-spline',
	    'area-step',
	    'bar',
	    'donut',
	    'gauge',
	    'line',
	    'pie',
	    'step',
	    'spline',
	
	    // Horizontal variant types
	    'horizontal-area',
	    'horizontal-area-spline',
	    'horizontal-area-step',
	    'horizontal-bar',
	    'horizontal-line',
	    'horizontal-step',
	    'horizontal-spline'
	  ];
	
	  function getDefaultOptions(){
	    var DEFAULT_OPTIONS,
	        ENFORCED_OPTIONS,
	        options;
	
	    DEFAULT_OPTIONS = {
	      axis: {},
	      color: {},
	      data: {
	        order: null
	      },
	      legend: {
	        position: 'right',
	        show: true
	      },
	      padding: {},
	      point: {
	        focus: {
	          expand: {
	            enabled: false
	          }
	        },
	        r: 2,
	        show: true
	      },
	      tooltip: {},
	      transition: {
	        duration: 0
	      }
	    };
	
	    ENFORCED_OPTIONS = {
	      bindto: this.el().querySelector('.' + this.theme() + '-rendering'),
	      color: {
	        pattern: this.colors()
	      },
	      data: {
	        colors: extend({}, this.colorMapping()),
	        columns: [],
	        type: this.type().replace('horizontal-', '')
	      },
	      size: {
	        height: this.height() ? this.height() - this.el().offsetHeight : 400,
	        width: this.width()
	      },
	      tooltip: {}
	    };
	
	    // Apply chartOptions
	    options = extendDeep({}, DEFAULT_OPTIONS, this.chartOptions());
	
	    // Apply enforced options
	    options = extendDeep(options, ENFORCED_OPTIONS);
	    options.color.pattern = ENFORCED_OPTIONS.color.pattern;
	    options.data.colors = ENFORCED_OPTIONS.data.colors;
	    options.data.columns = ENFORCED_OPTIONS.data.columns;
	
	    return options;
	  }
	
	  each(c3Types, function(type, index) {
	    types[type] = {
	      render: function(){
	        var options = getDefaultOptions.call(this);
	
	        if (this.data()[0].length === 1 || this.data().length === 1) {
	          this.message('No data to display');
	          return;
	        }
	
	        if (type === 'gauge') {
	          // Accommodate a neat bug:
	          options.legend.position = 'bottom';
	          options.data.columns = [[
	            this.title() || this.data()[1][0],
	            this.data()[1][1]
	          ]];
	        }
	        else if (type === 'pie' || type === 'donut') {
	          options.data.columns = this.data().slice(1);
	        }
	        else {
	
	          // Apply formatting for horizontal variant types
	          if (type.indexOf('horizontal-') > -1) {
	            options.axis.rotated = type.indexOf('horizontal-') > -1;
	          }
	
	          if (isDateString(this.data()[1][0])) {
	            // TIMESERIES
	            options.axis.x = options.axis.x || {};
	            options.axis.x.type = 'timeseries';
	            options.axis.x.tick = options.axis.x.tick || {
	              format: this.dateFormat() || c3DefaultDateFormat(this.data()[1][0], this.data()[2] ? this.data()[2][0] : this.data()[1][0]),
	              culling: { max: 5 }
	            };
	
	            options.data.columns[0] = [];
	            each(this.dataset.selectColumn(0), function(cell, i){
	              if (i > 0) {
	                cell = new Date(cell);
	              }
	              options.data.columns[0][i] = cell;
	            });
	            options.data.columns[0][0] = 'x';
	            options.data.x = 'x';
	            if (this.stacked() && this.data()[0].length > 2) {
	              options.data.groups = [ this.dataset.selectRow(0).slice(1) ];
	            }
	          }
	          else {
	            // CATEGORIES
	            options.axis.x = options.axis.x || {};
	            options.axis.x.type = 'category';
	            options.axis.x.categories = this.dataset.selectColumn(0).slice(1);
	            if (this.stacked() && this.data()[0].length > 2) {
	              options.data.groups = [ this.dataset.selectRow(0).slice(1) ];
	            }
	          }
	
	          if (this.data()[0].length === 2) {
	            options.legend.show = false;
	          }
	
	          each(this.data()[0], function(cell, i){
	            if (i > 0) {
	              options.data.columns.push(this.dataset.selectColumn(i));
	            }
	          }.bind(this));
	
	        }
	
	        if (options.legend.show === true
	          && options.legend.position === 'right'
	            && ['gauge'].indexOf(type.replace('horizontal-', ''))) {
	
	                // Apply custom color handling
	                options.data.color = c3CustomDataMapping.bind(this);
	
	                // Apply custom tooltip
	                var formatValue;
	                if (options.tooltip && options.tooltip.format && options.tooltip.format.value) {
	                  formatValue = c3CustomTooltipFiltering.bind(this, options.tooltip.format.value);
	                } else {
	                  formatValue = c3CustomTooltipFiltering.bind(this, null);
	                }
	                options.tooltip = {
	                  contents: c3TooltipContents,
	                  format: Object.assign({}, options.tooltip && options.tooltip.format, {
	                    value: formatValue
	                  })
	                };
	
	                options.legend.show = false;
	                var paddedWidth = this.el().querySelector('.' + this.theme() + '-rendering').offsetWidth - 100;
	                options.size.width = options.size.width || paddedWidth;
	                this.el().querySelector('.' + this.theme() + '-rendering').setAttribute('style', 'margin-right: 120px;');
	
	                // Render artifacts
	                this.view._artifacts['c3'] = c3.generate(options);
	                c3PaginatingLegend.call(this, options.data.columns);
	        }
	        else {
	          options.legend.show = false;
	          this.view._artifacts['c3'] = c3.generate(options);
	        }
	
	      },
	      update: function(){
	        // no special update handling
	        this.render();
	      },
	      destroy: function(){
	        if (this.view._artifacts['c3']) {
	          this.view._artifacts['c3'].destroy();
	          this.view._artifacts['c3'] = null;
	        }
	      }
	    };
	  });
	}
	
	function c3CustomDataMapping(color, d) {
	  var scope;
	  if (this.view._artifacts.pagination
	    && this.type() !== 'gauge'
	      /*&& this.type() !== 'pie'
	        && this.type() !== 'donut'*/) {
	          scope = this.view._artifacts.pagination.labels;
	          if ((d.id && scope.indexOf(d.id) > -1)
	            || (d && !d.id && scope.indexOf(d) > -1)) {
	              return color;
	          }
	          else {
	            if (this.type() === 'donut' || this.type() === 'pie') {
	              return 'rgba(0,0,0,.1)';
	            }
	            else {
	              return 'rgba(0,0,0,.07)';
	            }
	          }
	  }
	  else {
	    return color;
	  }
	}
	
	function c3CustomTooltipFiltering(valueFunction, value, ratio, id, index) {
	  var scope;
	  if (this.view._artifacts.pagination
	    && this.type() !== 'gauge'
	      /*&& this.type() !== 'pie'
	        && this.type() !== 'donut'*/) {
	          scope = this.view._artifacts.pagination.labels;
	          if (scope.indexOf(id) > -1) {
	            return valueFunction ? valueFunction(value, ratio, id, index) : value;
	          }
	  }
	  else {
	    return value;
	  }
	}
	
	function bindResizeListener(fn){
	  if ('undefined' === typeof window) return;
	  window.onresize = window.resize = function(){};
	  if (window.addEventListener) {
	    window.addEventListener('resize', fn, true);
	  }
	  else if (window.attachEvent) {
	    window.attachEvent('onresize', fn);
	  }
	}


/***/ }),
/* 1849 */
/***/ (function(module, exports, __webpack_require__) {

	/* @license C3.js v0.4.24 | (c) C3 Team and other contributors | http://c3js.org/ */
	(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    (global.c3 = factory());
	}(this, (function () { 'use strict';
	
	    var CLASS = {
	        target: 'c3-target',
	        chart: 'c3-chart',
	        chartLine: 'c3-chart-line',
	        chartLines: 'c3-chart-lines',
	        chartBar: 'c3-chart-bar',
	        chartBars: 'c3-chart-bars',
	        chartText: 'c3-chart-text',
	        chartTexts: 'c3-chart-texts',
	        chartArc: 'c3-chart-arc',
	        chartArcs: 'c3-chart-arcs',
	        chartArcsTitle: 'c3-chart-arcs-title',
	        chartArcsBackground: 'c3-chart-arcs-background',
	        chartArcsGaugeUnit: 'c3-chart-arcs-gauge-unit',
	        chartArcsGaugeMax: 'c3-chart-arcs-gauge-max',
	        chartArcsGaugeMin: 'c3-chart-arcs-gauge-min',
	        selectedCircle: 'c3-selected-circle',
	        selectedCircles: 'c3-selected-circles',
	        eventRect: 'c3-event-rect',
	        eventRects: 'c3-event-rects',
	        eventRectsSingle: 'c3-event-rects-single',
	        eventRectsMultiple: 'c3-event-rects-multiple',
	        zoomRect: 'c3-zoom-rect',
	        brush: 'c3-brush',
	        focused: 'c3-focused',
	        defocused: 'c3-defocused',
	        region: 'c3-region',
	        regions: 'c3-regions',
	        title: 'c3-title',
	        tooltipContainer: 'c3-tooltip-container',
	        tooltip: 'c3-tooltip',
	        tooltipName: 'c3-tooltip-name',
	        shape: 'c3-shape',
	        shapes: 'c3-shapes',
	        line: 'c3-line',
	        lines: 'c3-lines',
	        bar: 'c3-bar',
	        bars: 'c3-bars',
	        circle: 'c3-circle',
	        circles: 'c3-circles',
	        arc: 'c3-arc',
	        arcLabelLine: 'c3-arc-label-line',
	        arcs: 'c3-arcs',
	        area: 'c3-area',
	        areas: 'c3-areas',
	        empty: 'c3-empty',
	        text: 'c3-text',
	        texts: 'c3-texts',
	        gaugeValue: 'c3-gauge-value',
	        grid: 'c3-grid',
	        gridLines: 'c3-grid-lines',
	        xgrid: 'c3-xgrid',
	        xgrids: 'c3-xgrids',
	        xgridLine: 'c3-xgrid-line',
	        xgridLines: 'c3-xgrid-lines',
	        xgridFocus: 'c3-xgrid-focus',
	        ygrid: 'c3-ygrid',
	        ygrids: 'c3-ygrids',
	        ygridLine: 'c3-ygrid-line',
	        ygridLines: 'c3-ygrid-lines',
	        axis: 'c3-axis',
	        axisX: 'c3-axis-x',
	        axisXLabel: 'c3-axis-x-label',
	        axisY: 'c3-axis-y',
	        axisYLabel: 'c3-axis-y-label',
	        axisY2: 'c3-axis-y2',
	        axisY2Label: 'c3-axis-y2-label',
	        legendBackground: 'c3-legend-background',
	        legendItem: 'c3-legend-item',
	        legendItemEvent: 'c3-legend-item-event',
	        legendItemTile: 'c3-legend-item-tile',
	        legendItemHidden: 'c3-legend-item-hidden',
	        legendItemFocused: 'c3-legend-item-focused',
	        dragarea: 'c3-dragarea',
	        EXPANDED: '_expanded_',
	        SELECTED: '_selected_',
	        INCLUDED: '_included_'
	    };
	
	    var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
	      return typeof obj;
	    } : function (obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
	    };
	
	    var classCallCheck = function (instance, Constructor) {
	      if (!(instance instanceof Constructor)) {
	        throw new TypeError("Cannot call a class as a function");
	      }
	    };
	
	    var inherits = function (subClass, superClass) {
	      if (typeof superClass !== "function" && superClass !== null) {
	        throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	      }
	
	      subClass.prototype = Object.create(superClass && superClass.prototype, {
	        constructor: {
	          value: subClass,
	          enumerable: false,
	          writable: true,
	          configurable: true
	        }
	      });
	      if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	    };
	
	    var possibleConstructorReturn = function (self, call) {
	      if (!self) {
	        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	      }
	
	      return call && (typeof call === "object" || typeof call === "function") ? call : self;
	    };
	
	    var isValue = function isValue(v) {
	        return v || v === 0;
	    };
	    var isFunction = function isFunction(o) {
	        return typeof o === 'function';
	    };
	    var isArray = function isArray(o) {
	        return Array.isArray(o);
	    };
	    var isString = function isString(o) {
	        return typeof o === 'string';
	    };
	    var isUndefined = function isUndefined(v) {
	        return typeof v === 'undefined';
	    };
	    var isDefined = function isDefined(v) {
	        return typeof v !== 'undefined';
	    };
	    var ceil10 = function ceil10(v) {
	        return Math.ceil(v / 10) * 10;
	    };
	    var asHalfPixel = function asHalfPixel(n) {
	        return Math.ceil(n) + 0.5;
	    };
	    var diffDomain = function diffDomain(d) {
	        return d[1] - d[0];
	    };
	    var isEmpty = function isEmpty(o) {
	        return typeof o === 'undefined' || o === null || isString(o) && o.length === 0 || (typeof o === 'undefined' ? 'undefined' : _typeof(o)) === 'object' && Object.keys(o).length === 0;
	    };
	    var notEmpty = function notEmpty(o) {
	        return !c3_chart_internal_fn.isEmpty(o);
	    };
	    var getOption = function getOption(options, key, defaultValue) {
	        return isDefined(options[key]) ? options[key] : defaultValue;
	    };
	    var hasValue = function hasValue(dict, value) {
	        var found = false;
	        Object.keys(dict).forEach(function (key) {
	            if (dict[key] === value) {
	                found = true;
	            }
	        });
	        return found;
	    };
	    var sanitise = function sanitise(str) {
	        return typeof str === 'string' ? str.replace(/</g, '&lt;').replace(/>/g, '&gt;') : str;
	    };
	    var getPathBox = function getPathBox(path) {
	        var box = path.getBoundingClientRect(),
	            items = [path.pathSegList.getItem(0), path.pathSegList.getItem(1)],
	            minX = items[0].x,
	            minY = Math.min(items[0].y, items[1].y);
	        return { x: minX, y: minY, width: box.width, height: box.height };
	    };
	
	    var c3_axis_fn;
	    var c3_axis_internal_fn;
	
	    function AxisInternal(component, params) {
	        var internal = this;
	        internal.component = component;
	        internal.params = params || {};
	
	        internal.d3 = component.d3;
	        internal.scale = internal.d3.scale.linear();
	        internal.range;
	        internal.orient = "bottom";
	        internal.innerTickSize = 6;
	        internal.outerTickSize = this.params.withOuterTick ? 6 : 0;
	        internal.tickPadding = 3;
	        internal.tickValues = null;
	        internal.tickFormat;
	        internal.tickArguments;
	
	        internal.tickOffset = 0;
	        internal.tickCulling = true;
	        internal.tickCentered;
	        internal.tickTextCharSize;
	        internal.tickTextRotate = internal.params.tickTextRotate;
	        internal.tickLength;
	
	        internal.axis = internal.generateAxis();
	    }
	    c3_axis_internal_fn = AxisInternal.prototype;
	
	    c3_axis_internal_fn.axisX = function (selection, x, tickOffset) {
	        selection.attr("transform", function (d) {
	            return "translate(" + Math.ceil(x(d) + tickOffset) + ", 0)";
	        });
	    };
	    c3_axis_internal_fn.axisY = function (selection, y) {
	        selection.attr("transform", function (d) {
	            return "translate(0," + Math.ceil(y(d)) + ")";
	        });
	    };
	    c3_axis_internal_fn.scaleExtent = function (domain) {
	        var start = domain[0],
	            stop = domain[domain.length - 1];
	        return start < stop ? [start, stop] : [stop, start];
	    };
	    c3_axis_internal_fn.generateTicks = function (scale) {
	        var internal = this;
	        var i,
	            domain,
	            ticks = [];
	        if (scale.ticks) {
	            return scale.ticks.apply(scale, internal.tickArguments);
	        }
	        domain = scale.domain();
	        for (i = Math.ceil(domain[0]); i < domain[1]; i++) {
	            ticks.push(i);
	        }
	        if (ticks.length > 0 && ticks[0] > 0) {
	            ticks.unshift(ticks[0] - (ticks[1] - ticks[0]));
	        }
	        return ticks;
	    };
	    c3_axis_internal_fn.copyScale = function () {
	        var internal = this;
	        var newScale = internal.scale.copy(),
	            domain;
	        if (internal.params.isCategory) {
	            domain = internal.scale.domain();
	            newScale.domain([domain[0], domain[1] - 1]);
	        }
	        return newScale;
	    };
	    c3_axis_internal_fn.textFormatted = function (v) {
	        var internal = this,
	            formatted = internal.tickFormat ? internal.tickFormat(v) : v;
	        return typeof formatted !== 'undefined' ? formatted : '';
	    };
	    c3_axis_internal_fn.updateRange = function () {
	        var internal = this;
	        internal.range = internal.scale.rangeExtent ? internal.scale.rangeExtent() : internal.scaleExtent(internal.scale.range());
	        return internal.range;
	    };
	    c3_axis_internal_fn.updateTickTextCharSize = function (tick) {
	        var internal = this;
	        if (internal.tickTextCharSize) {
	            return internal.tickTextCharSize;
	        }
	        var size = {
	            h: 11.5,
	            w: 5.5
	        };
	        tick.select('text').text(function (d) {
	            return internal.textFormatted(d);
	        }).each(function (d) {
	            var box = this.getBoundingClientRect(),
	                text = internal.textFormatted(d),
	                h = box.height,
	                w = text ? box.width / text.length : undefined;
	            if (h && w) {
	                size.h = h;
	                size.w = w;
	            }
	        }).text('');
	        internal.tickTextCharSize = size;
	        return size;
	    };
	    c3_axis_internal_fn.transitionise = function (selection) {
	        return this.params.withoutTransition ? selection : this.d3.transition(selection);
	    };
	    c3_axis_internal_fn.isVertical = function () {
	        return this.orient === 'left' || this.orient === 'right';
	    };
	    c3_axis_internal_fn.tspanData = function (d, i, ticks, scale) {
	        var internal = this;
	        var splitted = internal.params.tickMultiline ? internal.splitTickText(d, ticks, scale) : [].concat(internal.textFormatted(d));
	
	        if (internal.params.tickMultiline && internal.params.tickMultilineMax > 0) {
	            splitted = internal.ellipsify(splitted, internal.params.tickMultilineMax);
	        }
	
	        return splitted.map(function (s) {
	            return { index: i, splitted: s, length: splitted.length };
	        });
	    };
	    c3_axis_internal_fn.splitTickText = function (d, ticks, scale) {
	        var internal = this,
	            tickText = internal.textFormatted(d),
	            maxWidth = internal.params.tickWidth,
	            subtext,
	            spaceIndex,
	            textWidth,
	            splitted = [];
	
	        if (Object.prototype.toString.call(tickText) === "[object Array]") {
	            return tickText;
	        }
	
	        if (!maxWidth || maxWidth <= 0) {
	            maxWidth = internal.isVertical() ? 95 : internal.params.isCategory ? Math.ceil(scale(ticks[1]) - scale(ticks[0])) - 12 : 110;
	        }
	
	        function split(splitted, text) {
	            spaceIndex = undefined;
	            for (var i = 1; i < text.length; i++) {
	                if (text.charAt(i) === ' ') {
	                    spaceIndex = i;
	                }
	                subtext = text.substr(0, i + 1);
	                textWidth = internal.tickTextCharSize.w * subtext.length;
	                // if text width gets over tick width, split by space index or crrent index
	                if (maxWidth < textWidth) {
	                    return split(splitted.concat(text.substr(0, spaceIndex ? spaceIndex : i)), text.slice(spaceIndex ? spaceIndex + 1 : i));
	                }
	            }
	            return splitted.concat(text);
	        }
	
	        return split(splitted, tickText + "");
	    };
	    c3_axis_internal_fn.ellipsify = function (splitted, max) {
	        if (splitted.length <= max) {
	            return splitted;
	        }
	
	        var ellipsified = splitted.slice(0, max);
	        var remaining = 3;
	        for (var i = max - 1; i >= 0; i--) {
	            var available = ellipsified[i].length;
	
	            ellipsified[i] = ellipsified[i].substr(0, available - remaining).padEnd(available, '.');
	
	            remaining -= available;
	
	            if (remaining <= 0) {
	                break;
	            }
	        }
	
	        return ellipsified;
	    };
	    c3_axis_internal_fn.updateTickLength = function () {
	        var internal = this;
	        internal.tickLength = Math.max(internal.innerTickSize, 0) + internal.tickPadding;
	    };
	    c3_axis_internal_fn.lineY2 = function (d) {
	        var internal = this,
	            tickPosition = internal.scale(d) + (internal.tickCentered ? 0 : internal.tickOffset);
	        return internal.range[0] < tickPosition && tickPosition < internal.range[1] ? internal.innerTickSize : 0;
	    };
	    c3_axis_internal_fn.textY = function () {
	        var internal = this,
	            rotate = internal.tickTextRotate;
	        return rotate ? 11.5 - 2.5 * (rotate / 15) * (rotate > 0 ? 1 : -1) : internal.tickLength;
	    };
	    c3_axis_internal_fn.textTransform = function () {
	        var internal = this,
	            rotate = internal.tickTextRotate;
	        return rotate ? "rotate(" + rotate + ")" : "";
	    };
	    c3_axis_internal_fn.textTextAnchor = function () {
	        var internal = this,
	            rotate = internal.tickTextRotate;
	        return rotate ? rotate > 0 ? "start" : "end" : "middle";
	    };
	    c3_axis_internal_fn.tspanDx = function () {
	        var internal = this,
	            rotate = internal.tickTextRotate;
	        return rotate ? 8 * Math.sin(Math.PI * (rotate / 180)) : 0;
	    };
	    c3_axis_internal_fn.tspanDy = function (d, i) {
	        var internal = this,
	            dy = internal.tickTextCharSize.h;
	        if (i === 0) {
	            if (internal.isVertical()) {
	                dy = -((d.length - 1) * (internal.tickTextCharSize.h / 2) - 3);
	            } else {
	                dy = ".71em";
	            }
	        }
	        return dy;
	    };
	
	    c3_axis_internal_fn.generateAxis = function () {
	        var internal = this,
	            d3 = internal.d3,
	            params = internal.params;
	        function axis(g) {
	            g.each(function () {
	                var g = axis.g = d3.select(this);
	
	                var scale0 = this.__chart__ || internal.scale,
	                    scale1 = this.__chart__ = internal.copyScale();
	
	                var ticks = internal.tickValues ? internal.tickValues : internal.generateTicks(scale1),
	                    tick = g.selectAll(".tick").data(ticks, scale1),
	                    tickEnter = tick.enter().insert("g", ".domain").attr("class", "tick").style("opacity", 1e-6),
	
	                // MEMO: No exit transition. The reason is this transition affects max tick width calculation because old tick will be included in the ticks.
	                tickExit = tick.exit().remove(),
	                    tickUpdate = internal.transitionise(tick).style("opacity", 1),
	                    tickTransform,
	                    tickX,
	                    tickY;
	
	                if (params.isCategory) {
	                    internal.tickOffset = Math.ceil((scale1(1) - scale1(0)) / 2);
	                    tickX = internal.tickCentered ? 0 : internal.tickOffset;
	                    tickY = internal.tickCentered ? internal.tickOffset : 0;
	                } else {
	                    internal.tickOffset = tickX = 0;
	                }
	
	                tickEnter.append("line");
	                tickEnter.append("text");
	
	                internal.updateRange();
	                internal.updateTickLength();
	                internal.updateTickTextCharSize(g.select('.tick'));
	
	                var lineUpdate = tickUpdate.select("line"),
	                    textUpdate = tickUpdate.select("text"),
	                    tspanUpdate = tick.select("text").selectAll('tspan').data(function (d, i) {
	                    return internal.tspanData(d, i, ticks, scale1);
	                });
	
	                tspanUpdate.enter().append('tspan');
	                tspanUpdate.exit().remove();
	                tspanUpdate.text(function (d) {
	                    return d.splitted;
	                });
	
	                var path = g.selectAll(".domain").data([0]),
	                    pathUpdate = (path.enter().append("path").attr("class", "domain"), internal.transitionise(path));
	
	                // TODO: each attr should be one function and change its behavior by internal.orient, probably
	                switch (internal.orient) {
	                    case "bottom":
	                        {
	                            tickTransform = internal.axisX;
	                            lineUpdate.attr("x1", tickX).attr("x2", tickX).attr("y2", function (d, i) {
	                                return internal.lineY2(d, i);
	                            });
	                            textUpdate.attr("x", 0).attr("y", function (d, i) {
	                                return internal.textY(d, i);
	                            }).attr("transform", function (d, i) {
	                                return internal.textTransform(d, i);
	                            }).style("text-anchor", function (d, i) {
	                                return internal.textTextAnchor(d, i);
	                            });
	                            tspanUpdate.attr('x', 0).attr("dy", function (d, i) {
	                                return internal.tspanDy(d, i);
	                            }).attr('dx', function (d, i) {
	                                return internal.tspanDx(d, i);
	                            });
	                            pathUpdate.attr("d", "M" + internal.range[0] + "," + internal.outerTickSize + "V0H" + internal.range[1] + "V" + internal.outerTickSize);
	                            break;
	                        }
	                    case "top":
	                        {
	                            // TODO: rotated tick text
	                            tickTransform = internal.axisX;
	                            lineUpdate.attr("x1", tickX).attr("x2", tickX).attr("y2", function (d, i) {
	                                return -1 * internal.lineY2(d, i);
	                            });
	                            textUpdate.attr("x", 0).attr("y", function (d, i) {
	                                return -1 * internal.textY(d, i) - (params.isCategory ? 2 : internal.tickLength - 2);
	                            }).attr("transform", function (d, i) {
	                                return internal.textTransform(d, i);
	                            }).style("text-anchor", function (d, i) {
	                                return internal.textTextAnchor(d, i);
	                            });
	                            tspanUpdate.attr('x', 0).attr("dy", function (d, i) {
	                                return internal.tspanDy(d, i);
	                            }).attr('dx', function (d, i) {
	                                return internal.tspanDx(d, i);
	                            });
	                            pathUpdate.attr("d", "M" + internal.range[0] + "," + -internal.outerTickSize + "V0H" + internal.range[1] + "V" + -internal.outerTickSize);
	                            break;
	                        }
	                    case "left":
	                        {
	                            tickTransform = internal.axisY;
	                            lineUpdate.attr("x2", -internal.innerTickSize).attr("y1", tickY).attr("y2", tickY);
	                            textUpdate.attr("x", -internal.tickLength).attr("y", internal.tickOffset).style("text-anchor", "end");
	                            tspanUpdate.attr('x', -internal.tickLength).attr("dy", function (d, i) {
	                                return internal.tspanDy(d, i);
	                            });
	                            pathUpdate.attr("d", "M" + -internal.outerTickSize + "," + internal.range[0] + "H0V" + internal.range[1] + "H" + -internal.outerTickSize);
	                            break;
	                        }
	                    case "right":
	                        {
	                            tickTransform = internal.axisY;
	                            lineUpdate.attr("x2", internal.innerTickSize).attr("y1", tickY).attr("y2", tickY);
	                            textUpdate.attr("x", internal.tickLength).attr("y", internal.tickOffset).style("text-anchor", "start");
	                            tspanUpdate.attr('x', internal.tickLength).attr("dy", function (d, i) {
	                                return internal.tspanDy(d, i);
	                            });
	                            pathUpdate.attr("d", "M" + internal.outerTickSize + "," + internal.range[0] + "H0V" + internal.range[1] + "H" + internal.outerTickSize);
	                            break;
	                        }
	                }
	                if (scale1.rangeBand) {
	                    var x = scale1,
	                        dx = x.rangeBand() / 2;
	                    scale0 = scale1 = function scale1(d) {
	                        return x(d) + dx;
	                    };
	                } else if (scale0.rangeBand) {
	                    scale0 = scale1;
	                } else {
	                    tickExit.call(tickTransform, scale1, internal.tickOffset);
	                }
	                tickEnter.call(tickTransform, scale0, internal.tickOffset);
	                tickUpdate.call(tickTransform, scale1, internal.tickOffset);
	            });
	        }
	        axis.scale = function (x) {
	            if (!arguments.length) {
	                return internal.scale;
	            }
	            internal.scale = x;
	            return axis;
	        };
	        axis.orient = function (x) {
	            if (!arguments.length) {
	                return internal.orient;
	            }
	            internal.orient = x in { top: 1, right: 1, bottom: 1, left: 1 } ? x + "" : "bottom";
	            return axis;
	        };
	        axis.tickFormat = function (format) {
	            if (!arguments.length) {
	                return internal.tickFormat;
	            }
	            internal.tickFormat = format;
	            return axis;
	        };
	        axis.tickCentered = function (isCentered) {
	            if (!arguments.length) {
	                return internal.tickCentered;
	            }
	            internal.tickCentered = isCentered;
	            return axis;
	        };
	        axis.tickOffset = function () {
	            return internal.tickOffset;
	        };
	        axis.tickInterval = function () {
	            var interval, length;
	            if (params.isCategory) {
	                interval = internal.tickOffset * 2;
	            } else {
	                length = axis.g.select('path.domain').node().getTotalLength() - internal.outerTickSize * 2;
	                interval = length / axis.g.selectAll('line').size();
	            }
	            return interval === Infinity ? 0 : interval;
	        };
	        axis.ticks = function () {
	            if (!arguments.length) {
	                return internal.tickArguments;
	            }
	            internal.tickArguments = arguments;
	            return axis;
	        };
	        axis.tickCulling = function (culling) {
	            if (!arguments.length) {
	                return internal.tickCulling;
	            }
	            internal.tickCulling = culling;
	            return axis;
	        };
	        axis.tickValues = function (x) {
	            if (typeof x === 'function') {
	                internal.tickValues = function () {
	                    return x(internal.scale.domain());
	                };
	            } else {
	                if (!arguments.length) {
	                    return internal.tickValues;
	                }
	                internal.tickValues = x;
	            }
	            return axis;
	        };
	        return axis;
	    };
	
	    var Axis = function (_Component) {
	        inherits(Axis, _Component);
	
	        function Axis(owner) {
	            classCallCheck(this, Axis);
	
	            var fn = {
	                fn: c3_axis_fn,
	                internal: {
	                    fn: c3_axis_internal_fn
	                }
	            };
	
	            var _this = possibleConstructorReturn(this, (Axis.__proto__ || Object.getPrototypeOf(Axis)).call(this, owner, 'axis', fn));
	
	            _this.d3 = owner.d3;
	            _this.internal = AxisInternal;
	            return _this;
	        }
	
	        return Axis;
	    }(Component);
	
	    c3_axis_fn = Axis.prototype;
	
	    c3_axis_fn.init = function init() {
	        var $$ = this.owner,
	            config = $$.config,
	            main = $$.main;
	        $$.axes.x = main.append("g").attr("class", CLASS.axis + ' ' + CLASS.axisX).attr("clip-path", config.axis_x_inner ? "" : $$.clipPathForXAxis).attr("transform", $$.getTranslate('x')).style("visibility", config.axis_x_show ? 'visible' : 'hidden');
	        $$.axes.x.append("text").attr("class", CLASS.axisXLabel).attr("transform", config.axis_rotated ? "rotate(-90)" : "").style("text-anchor", this.textAnchorForXAxisLabel.bind(this));
	        $$.axes.y = main.append("g").attr("class", CLASS.axis + ' ' + CLASS.axisY).attr("clip-path", config.axis_y_inner ? "" : $$.clipPathForYAxis).attr("transform", $$.getTranslate('y')).style("visibility", config.axis_y_show ? 'visible' : 'hidden');
	        $$.axes.y.append("text").attr("class", CLASS.axisYLabel).attr("transform", config.axis_rotated ? "" : "rotate(-90)").style("text-anchor", this.textAnchorForYAxisLabel.bind(this));
	
	        $$.axes.y2 = main.append("g").attr("class", CLASS.axis + ' ' + CLASS.axisY2)
	        // clip-path?
	        .attr("transform", $$.getTranslate('y2')).style("visibility", config.axis_y2_show ? 'visible' : 'hidden');
	        $$.axes.y2.append("text").attr("class", CLASS.axisY2Label).attr("transform", config.axis_rotated ? "" : "rotate(-90)").style("text-anchor", this.textAnchorForY2AxisLabel.bind(this));
	    };
	    c3_axis_fn.getXAxis = function getXAxis(scale, orient, tickFormat, tickValues, withOuterTick, withoutTransition, withoutRotateTickText) {
	        var $$ = this.owner,
	            config = $$.config,
	            axisParams = {
	            isCategory: $$.isCategorized(),
	            withOuterTick: withOuterTick,
	            tickMultiline: config.axis_x_tick_multiline,
	            tickMultilineMax: config.axis_x_tick_multiline ? Number(config.axis_x_tick_multilineMax) : 0,
	            tickWidth: config.axis_x_tick_width,
	            tickTextRotate: withoutRotateTickText ? 0 : config.axis_x_tick_rotate,
	            withoutTransition: withoutTransition
	        },
	            axis = new this.internal(this, axisParams).axis.scale(scale).orient(orient);
	
	        if ($$.isTimeSeries() && tickValues && typeof tickValues !== "function") {
	            tickValues = tickValues.map(function (v) {
	                return $$.parseDate(v);
	            });
	        }
	
	        // Set tick
	        axis.tickFormat(tickFormat).tickValues(tickValues);
	        if ($$.isCategorized()) {
	            axis.tickCentered(config.axis_x_tick_centered);
	            if (isEmpty(config.axis_x_tick_culling)) {
	                config.axis_x_tick_culling = false;
	            }
	        }
	
	        return axis;
	    };
	    c3_axis_fn.updateXAxisTickValues = function updateXAxisTickValues(targets, axis) {
	        var $$ = this.owner,
	            config = $$.config,
	            tickValues;
	        if (config.axis_x_tick_fit || config.axis_x_tick_count) {
	            tickValues = this.generateTickValues($$.mapTargetsToUniqueXs(targets), config.axis_x_tick_count, $$.isTimeSeries());
	        }
	        if (axis) {
	            axis.tickValues(tickValues);
	        } else {
	            $$.xAxis.tickValues(tickValues);
	            $$.subXAxis.tickValues(tickValues);
	        }
	        return tickValues;
	    };
	    c3_axis_fn.getYAxis = function getYAxis(scale, orient, tickFormat, tickValues, withOuterTick, withoutTransition, withoutRotateTickText) {
	        var $$ = this.owner,
	            config = $$.config,
	            axisParams = {
	            withOuterTick: withOuterTick,
	            withoutTransition: withoutTransition,
	            tickTextRotate: withoutRotateTickText ? 0 : config.axis_y_tick_rotate
	        },
	            axis = new this.internal(this, axisParams).axis.scale(scale).orient(orient).tickFormat(tickFormat);
	        if ($$.isTimeSeriesY()) {
	            axis.ticks($$.d3.time[config.axis_y_tick_time_value], config.axis_y_tick_time_interval);
	        } else {
	            axis.tickValues(tickValues);
	        }
	        return axis;
	    };
	    c3_axis_fn.getId = function getId(id) {
	        var config = this.owner.config;
	        return id in config.data_axes ? config.data_axes[id] : 'y';
	    };
	    c3_axis_fn.getXAxisTickFormat = function getXAxisTickFormat() {
	        var $$ = this.owner,
	            config = $$.config,
	            format = $$.isTimeSeries() ? $$.defaultAxisTimeFormat : $$.isCategorized() ? $$.categoryName : function (v) {
	            return v < 0 ? v.toFixed(0) : v;
	        };
	        if (config.axis_x_tick_format) {
	            if (isFunction(config.axis_x_tick_format)) {
	                format = config.axis_x_tick_format;
	            } else if ($$.isTimeSeries()) {
	                format = function format(date) {
	                    return date ? $$.axisTimeFormat(config.axis_x_tick_format)(date) : "";
	                };
	            }
	        }
	        return isFunction(format) ? function (v) {
	            return format.call($$, v);
	        } : format;
	    };
	    c3_axis_fn.getTickValues = function getTickValues(tickValues, axis) {
	        return tickValues ? tickValues : axis ? axis.tickValues() : undefined;
	    };
	    c3_axis_fn.getXAxisTickValues = function getXAxisTickValues() {
	        return this.getTickValues(this.owner.config.axis_x_tick_values, this.owner.xAxis);
	    };
	    c3_axis_fn.getYAxisTickValues = function getYAxisTickValues() {
	        return this.getTickValues(this.owner.config.axis_y_tick_values, this.owner.yAxis);
	    };
	    c3_axis_fn.getY2AxisTickValues = function getY2AxisTickValues() {
	        return this.getTickValues(this.owner.config.axis_y2_tick_values, this.owner.y2Axis);
	    };
	    c3_axis_fn.getLabelOptionByAxisId = function getLabelOptionByAxisId(axisId) {
	        var $$ = this.owner,
	            config = $$.config,
	            option;
	        if (axisId === 'y') {
	            option = config.axis_y_label;
	        } else if (axisId === 'y2') {
	            option = config.axis_y2_label;
	        } else if (axisId === 'x') {
	            option = config.axis_x_label;
	        }
	        return option;
	    };
	    c3_axis_fn.getLabelText = function getLabelText(axisId) {
	        var option = this.getLabelOptionByAxisId(axisId);
	        return isString(option) ? option : option ? option.text : null;
	    };
	    c3_axis_fn.setLabelText = function setLabelText(axisId, text) {
	        var $$ = this.owner,
	            config = $$.config,
	            option = this.getLabelOptionByAxisId(axisId);
	        if (isString(option)) {
	            if (axisId === 'y') {
	                config.axis_y_label = text;
	            } else if (axisId === 'y2') {
	                config.axis_y2_label = text;
	            } else if (axisId === 'x') {
	                config.axis_x_label = text;
	            }
	        } else if (option) {
	            option.text = text;
	        }
	    };
	    c3_axis_fn.getLabelPosition = function getLabelPosition(axisId, defaultPosition) {
	        var option = this.getLabelOptionByAxisId(axisId),
	            position = option && (typeof option === 'undefined' ? 'undefined' : _typeof(option)) === 'object' && option.position ? option.position : defaultPosition;
	        return {
	            isInner: position.indexOf('inner') >= 0,
	            isOuter: position.indexOf('outer') >= 0,
	            isLeft: position.indexOf('left') >= 0,
	            isCenter: position.indexOf('center') >= 0,
	            isRight: position.indexOf('right') >= 0,
	            isTop: position.indexOf('top') >= 0,
	            isMiddle: position.indexOf('middle') >= 0,
	            isBottom: position.indexOf('bottom') >= 0
	        };
	    };
	    c3_axis_fn.getXAxisLabelPosition = function getXAxisLabelPosition() {
	        return this.getLabelPosition('x', this.owner.config.axis_rotated ? 'inner-top' : 'inner-right');
	    };
	    c3_axis_fn.getYAxisLabelPosition = function getYAxisLabelPosition() {
	        return this.getLabelPosition('y', this.owner.config.axis_rotated ? 'inner-right' : 'inner-top');
	    };
	    c3_axis_fn.getY2AxisLabelPosition = function getY2AxisLabelPosition() {
	        return this.getLabelPosition('y2', this.owner.config.axis_rotated ? 'inner-right' : 'inner-top');
	    };
	    c3_axis_fn.getLabelPositionById = function getLabelPositionById(id) {
	        return id === 'y2' ? this.getY2AxisLabelPosition() : id === 'y' ? this.getYAxisLabelPosition() : this.getXAxisLabelPosition();
	    };
	    c3_axis_fn.textForXAxisLabel = function textForXAxisLabel() {
	        return this.getLabelText('x');
	    };
	    c3_axis_fn.textForYAxisLabel = function textForYAxisLabel() {
	        return this.getLabelText('y');
	    };
	    c3_axis_fn.textForY2AxisLabel = function textForY2AxisLabel() {
	        return this.getLabelText('y2');
	    };
	    c3_axis_fn.xForAxisLabel = function xForAxisLabel(forHorizontal, position) {
	        var $$ = this.owner;
	        if (forHorizontal) {
	            return position.isLeft ? 0 : position.isCenter ? $$.width / 2 : $$.width;
	        } else {
	            return position.isBottom ? -$$.height : position.isMiddle ? -$$.height / 2 : 0;
	        }
	    };
	    c3_axis_fn.dxForAxisLabel = function dxForAxisLabel(forHorizontal, position) {
	        if (forHorizontal) {
	            return position.isLeft ? "0.5em" : position.isRight ? "-0.5em" : "0";
	        } else {
	            return position.isTop ? "-0.5em" : position.isBottom ? "0.5em" : "0";
	        }
	    };
	    c3_axis_fn.textAnchorForAxisLabel = function textAnchorForAxisLabel(forHorizontal, position) {
	        if (forHorizontal) {
	            return position.isLeft ? 'start' : position.isCenter ? 'middle' : 'end';
	        } else {
	            return position.isBottom ? 'start' : position.isMiddle ? 'middle' : 'end';
	        }
	    };
	    c3_axis_fn.xForXAxisLabel = function xForXAxisLabel() {
	        return this.xForAxisLabel(!this.owner.config.axis_rotated, this.getXAxisLabelPosition());
	    };
	    c3_axis_fn.xForYAxisLabel = function xForYAxisLabel() {
	        return this.xForAxisLabel(this.owner.config.axis_rotated, this.getYAxisLabelPosition());
	    };
	    c3_axis_fn.xForY2AxisLabel = function xForY2AxisLabel() {
	        return this.xForAxisLabel(this.owner.config.axis_rotated, this.getY2AxisLabelPosition());
	    };
	    c3_axis_fn.dxForXAxisLabel = function dxForXAxisLabel() {
	        return this.dxForAxisLabel(!this.owner.config.axis_rotated, this.getXAxisLabelPosition());
	    };
	    c3_axis_fn.dxForYAxisLabel = function dxForYAxisLabel() {
	        return this.dxForAxisLabel(this.owner.config.axis_rotated, this.getYAxisLabelPosition());
	    };
	    c3_axis_fn.dxForY2AxisLabel = function dxForY2AxisLabel() {
	        return this.dxForAxisLabel(this.owner.config.axis_rotated, this.getY2AxisLabelPosition());
	    };
	    c3_axis_fn.dyForXAxisLabel = function dyForXAxisLabel() {
	        var $$ = this.owner,
	            config = $$.config,
	            position = this.getXAxisLabelPosition();
	        if (config.axis_rotated) {
	            return position.isInner ? "1.2em" : -25 - ($$.config.axis_x_inner ? 0 : this.getMaxTickWidth('x'));
	        } else {
	            return position.isInner ? "-0.5em" : config.axis_x_height ? config.axis_x_height - 10 : "3em";
	        }
	    };
	    c3_axis_fn.dyForYAxisLabel = function dyForYAxisLabel() {
	        var $$ = this.owner,
	            position = this.getYAxisLabelPosition();
	        if ($$.config.axis_rotated) {
	            return position.isInner ? "-0.5em" : "3em";
	        } else {
	            return position.isInner ? "1.2em" : -10 - ($$.config.axis_y_inner ? 0 : this.getMaxTickWidth('y') + 10);
	        }
	    };
	    c3_axis_fn.dyForY2AxisLabel = function dyForY2AxisLabel() {
	        var $$ = this.owner,
	            position = this.getY2AxisLabelPosition();
	        if ($$.config.axis_rotated) {
	            return position.isInner ? "1.2em" : "-2.2em";
	        } else {
	            return position.isInner ? "-0.5em" : 15 + ($$.config.axis_y2_inner ? 0 : this.getMaxTickWidth('y2') + 15);
	        }
	    };
	    c3_axis_fn.textAnchorForXAxisLabel = function textAnchorForXAxisLabel() {
	        var $$ = this.owner;
	        return this.textAnchorForAxisLabel(!$$.config.axis_rotated, this.getXAxisLabelPosition());
	    };
	    c3_axis_fn.textAnchorForYAxisLabel = function textAnchorForYAxisLabel() {
	        var $$ = this.owner;
	        return this.textAnchorForAxisLabel($$.config.axis_rotated, this.getYAxisLabelPosition());
	    };
	    c3_axis_fn.textAnchorForY2AxisLabel = function textAnchorForY2AxisLabel() {
	        var $$ = this.owner;
	        return this.textAnchorForAxisLabel($$.config.axis_rotated, this.getY2AxisLabelPosition());
	    };
	    c3_axis_fn.getMaxTickWidth = function getMaxTickWidth(id, withoutRecompute) {
	        var $$ = this.owner,
	            config = $$.config,
	            maxWidth = 0,
	            targetsToShow,
	            scale,
	            axis,
	            dummy,
	            svg;
	        if (withoutRecompute && $$.currentMaxTickWidths[id]) {
	            return $$.currentMaxTickWidths[id];
	        }
	        if ($$.svg) {
	            targetsToShow = $$.filterTargetsToShow($$.data.targets);
	            if (id === 'y') {
	                scale = $$.y.copy().domain($$.getYDomain(targetsToShow, 'y'));
	                axis = this.getYAxis(scale, $$.yOrient, config.axis_y_tick_format, $$.yAxisTickValues, false, true, true);
	            } else if (id === 'y2') {
	                scale = $$.y2.copy().domain($$.getYDomain(targetsToShow, 'y2'));
	                axis = this.getYAxis(scale, $$.y2Orient, config.axis_y2_tick_format, $$.y2AxisTickValues, false, true, true);
	            } else {
	                scale = $$.x.copy().domain($$.getXDomain(targetsToShow));
	                axis = this.getXAxis(scale, $$.xOrient, $$.xAxisTickFormat, $$.xAxisTickValues, false, true, true);
	                this.updateXAxisTickValues(targetsToShow, axis);
	            }
	            dummy = $$.d3.select('body').append('div').classed('c3', true);
	            svg = dummy.append("svg").style('visibility', 'hidden').style('position', 'fixed').style('top', 0).style('left', 0), svg.append('g').call(axis).each(function () {
	                $$.d3.select(this).selectAll('text').each(function () {
	                    var box = this.getBoundingClientRect();
	                    if (maxWidth < box.width) {
	                        maxWidth = box.width;
	                    }
	                });
	                dummy.remove();
	            });
	        }
	        $$.currentMaxTickWidths[id] = maxWidth <= 0 ? $$.currentMaxTickWidths[id] : maxWidth;
	        return $$.currentMaxTickWidths[id];
	    };
	
	    c3_axis_fn.updateLabels = function updateLabels(withTransition) {
	        var $$ = this.owner;
	        var axisXLabel = $$.main.select('.' + CLASS.axisX + ' .' + CLASS.axisXLabel),
	            axisYLabel = $$.main.select('.' + CLASS.axisY + ' .' + CLASS.axisYLabel),
	            axisY2Label = $$.main.select('.' + CLASS.axisY2 + ' .' + CLASS.axisY2Label);
	        (withTransition ? axisXLabel.transition() : axisXLabel).attr("x", this.xForXAxisLabel.bind(this)).attr("dx", this.dxForXAxisLabel.bind(this)).attr("dy", this.dyForXAxisLabel.bind(this)).text(this.textForXAxisLabel.bind(this));
	        (withTransition ? axisYLabel.transition() : axisYLabel).attr("x", this.xForYAxisLabel.bind(this)).attr("dx", this.dxForYAxisLabel.bind(this)).attr("dy", this.dyForYAxisLabel.bind(this)).text(this.textForYAxisLabel.bind(this));
	        (withTransition ? axisY2Label.transition() : axisY2Label).attr("x", this.xForY2AxisLabel.bind(this)).attr("dx", this.dxForY2AxisLabel.bind(this)).attr("dy", this.dyForY2AxisLabel.bind(this)).text(this.textForY2AxisLabel.bind(this));
	    };
	    c3_axis_fn.getPadding = function getPadding(padding, key, defaultValue, domainLength) {
	        var p = typeof padding === 'number' ? padding : padding[key];
	        if (!isValue(p)) {
	            return defaultValue;
	        }
	        if (padding.unit === 'ratio') {
	            return padding[key] * domainLength;
	        }
	        // assume padding is pixels if unit is not specified
	        return this.convertPixelsToAxisPadding(p, domainLength);
	    };
	    c3_axis_fn.convertPixelsToAxisPadding = function convertPixelsToAxisPadding(pixels, domainLength) {
	        var $$ = this.owner,
	            length = $$.config.axis_rotated ? $$.width : $$.height;
	        return domainLength * (pixels / length);
	    };
	    c3_axis_fn.generateTickValues = function generateTickValues(values, tickCount, forTimeSeries) {
	        var tickValues = values,
	            targetCount,
	            start,
	            end,
	            count,
	            interval,
	            i,
	            tickValue;
	        if (tickCount) {
	            targetCount = isFunction(tickCount) ? tickCount() : tickCount;
	            // compute ticks according to tickCount
	            if (targetCount === 1) {
	                tickValues = [values[0]];
	            } else if (targetCount === 2) {
	                tickValues = [values[0], values[values.length - 1]];
	            } else if (targetCount > 2) {
	                count = targetCount - 2;
	                start = values[0];
	                end = values[values.length - 1];
	                interval = (end - start) / (count + 1);
	                // re-construct unique values
	                tickValues = [start];
	                for (i = 0; i < count; i++) {
	                    tickValue = +start + interval * (i + 1);
	                    tickValues.push(forTimeSeries ? new Date(tickValue) : tickValue);
	                }
	                tickValues.push(end);
	            }
	        }
	        if (!forTimeSeries) {
	            tickValues = tickValues.sort(function (a, b) {
	                return a - b;
	            });
	        }
	        return tickValues;
	    };
	    c3_axis_fn.generateTransitions = function generateTransitions(duration) {
	        var $$ = this.owner,
	            axes = $$.axes;
	        return {
	            axisX: duration ? axes.x.transition().duration(duration) : axes.x,
	            axisY: duration ? axes.y.transition().duration(duration) : axes.y,
	            axisY2: duration ? axes.y2.transition().duration(duration) : axes.y2,
	            axisSubX: duration ? axes.subx.transition().duration(duration) : axes.subx
	        };
	    };
	    c3_axis_fn.redraw = function redraw(transitions, isHidden) {
	        var $$ = this.owner;
	        $$.axes.x.style("opacity", isHidden ? 0 : 1);
	        $$.axes.y.style("opacity", isHidden ? 0 : 1);
	        $$.axes.y2.style("opacity", isHidden ? 0 : 1);
	        $$.axes.subx.style("opacity", isHidden ? 0 : 1);
	        transitions.axisX.call($$.xAxis);
	        transitions.axisY.call($$.yAxis);
	        transitions.axisY2.call($$.y2Axis);
	        transitions.axisSubX.call($$.subXAxis);
	    };
	
	    var c3 = { version: "0.4.24" };
	
	    var c3_chart_fn;
	    var c3_chart_internal_fn;
	
	    function Component(owner, componentKey, fn) {
	        this.owner = owner;
	        c3.chart.internal[componentKey] = fn;
	    }
	
	    function Chart(config) {
	        var $$ = this.internal = new ChartInternal(this);
	        $$.loadConfig(config);
	
	        $$.beforeInit(config);
	        $$.init();
	        $$.afterInit(config);
	
	        // bind "this" to nested API
	        (function bindThis(fn, target, argThis) {
	            Object.keys(fn).forEach(function (key) {
	                target[key] = fn[key].bind(argThis);
	                if (Object.keys(fn[key]).length > 0) {
	                    bindThis(fn[key], target[key], argThis);
	                }
	            });
	        })(c3_chart_fn, this, this);
	    }
	
	    function ChartInternal(api) {
	        var $$ = this;
	        $$.d3 = window.d3 ? window.d3 :  true ? __webpack_require__(1850) : undefined;
	        $$.api = api;
	        $$.config = $$.getDefaultConfig();
	        $$.data = {};
	        $$.cache = {};
	        $$.axes = {};
	    }
	
	    c3.generate = function (config) {
	        return new Chart(config);
	    };
	
	    c3.chart = {
	        fn: Chart.prototype,
	        internal: {
	            fn: ChartInternal.prototype
	        }
	    };
	    c3_chart_fn = c3.chart.fn;
	    c3_chart_internal_fn = c3.chart.internal.fn;
	
	    c3_chart_internal_fn.beforeInit = function () {
	        // can do something
	    };
	    c3_chart_internal_fn.afterInit = function () {
	        // can do something
	    };
	    c3_chart_internal_fn.init = function () {
	        var $$ = this,
	            config = $$.config;
	
	        $$.initParams();
	
	        if (config.data_url) {
	            $$.convertUrlToData(config.data_url, config.data_mimeType, config.data_headers, config.data_keys, $$.initWithData);
	        } else if (config.data_json) {
	            $$.initWithData($$.convertJsonToData(config.data_json, config.data_keys));
	        } else if (config.data_rows) {
	            $$.initWithData($$.convertRowsToData(config.data_rows));
	        } else if (config.data_columns) {
	            $$.initWithData($$.convertColumnsToData(config.data_columns));
	        } else {
	            throw Error('url or json or rows or columns is required.');
	        }
	    };
	
	    c3_chart_internal_fn.initParams = function () {
	        var $$ = this,
	            d3 = $$.d3,
	            config = $$.config;
	
	        // MEMO: clipId needs to be unique because it conflicts when multiple charts exist
	        $$.clipId = "c3-" + +new Date() + '-clip', $$.clipIdForXAxis = $$.clipId + '-xaxis', $$.clipIdForYAxis = $$.clipId + '-yaxis', $$.clipIdForGrid = $$.clipId + '-grid', $$.clipIdForSubchart = $$.clipId + '-subchart', $$.clipPath = $$.getClipPath($$.clipId), $$.clipPathForXAxis = $$.getClipPath($$.clipIdForXAxis), $$.clipPathForYAxis = $$.getClipPath($$.clipIdForYAxis);
	        $$.clipPathForGrid = $$.getClipPath($$.clipIdForGrid), $$.clipPathForSubchart = $$.getClipPath($$.clipIdForSubchart), $$.dragStart = null;
	        $$.dragging = false;
	        $$.flowing = false;
	        $$.cancelClick = false;
	        $$.mouseover = false;
	        $$.transiting = false;
	
	        $$.color = $$.generateColor();
	        $$.levelColor = $$.generateLevelColor();
	
	        $$.dataTimeFormat = config.data_xLocaltime ? d3.time.format : d3.time.format.utc;
	        $$.axisTimeFormat = config.axis_x_localtime ? d3.time.format : d3.time.format.utc;
	        $$.defaultAxisTimeFormat = $$.axisTimeFormat.multi([[".%L", function (d) {
	            return d.getMilliseconds();
	        }], [":%S", function (d) {
	            return d.getSeconds();
	        }], ["%I:%M", function (d) {
	            return d.getMinutes();
	        }], ["%I %p", function (d) {
	            return d.getHours();
	        }], ["%-m/%-d", function (d) {
	            return d.getDay() && d.getDate() !== 1;
	        }], ["%-m/%-d", function (d) {
	            return d.getDate() !== 1;
	        }], ["%-m/%-d", function (d) {
	            return d.getMonth();
	        }], ["%Y/%-m/%-d", function () {
	            return true;
	        }]]);
	
	        $$.hiddenTargetIds = [];
	        $$.hiddenLegendIds = [];
	        $$.focusedTargetIds = [];
	        $$.defocusedTargetIds = [];
	
	        $$.xOrient = config.axis_rotated ? config.axis_x_inner ? "right" : "left" : config.axis_x_inner ? "top" : "bottom";
	        $$.yOrient = config.axis_rotated ? config.axis_y_inner ? "top" : "bottom" : config.axis_y_inner ? "right" : "left";
	        $$.y2Orient = config.axis_rotated ? config.axis_y2_inner ? "bottom" : "top" : config.axis_y2_inner ? "left" : "right";
	        $$.subXOrient = config.axis_rotated ? "left" : "bottom";
	
	        $$.isLegendRight = config.legend_position === 'right';
	        $$.isLegendInset = config.legend_position === 'inset';
	        $$.isLegendTop = config.legend_inset_anchor === 'top-left' || config.legend_inset_anchor === 'top-right';
	        $$.isLegendLeft = config.legend_inset_anchor === 'top-left' || config.legend_inset_anchor === 'bottom-left';
	        $$.legendStep = 0;
	        $$.legendItemWidth = 0;
	        $$.legendItemHeight = 0;
	
	        $$.currentMaxTickWidths = {
	            x: 0,
	            y: 0,
	            y2: 0
	        };
	
	        $$.rotated_padding_left = 30;
	        $$.rotated_padding_right = config.axis_rotated && !config.axis_x_show ? 0 : 30;
	        $$.rotated_padding_top = 5;
	
	        $$.withoutFadeIn = {};
	
	        $$.intervalForObserveInserted = undefined;
	
	        $$.axes.subx = d3.selectAll([]); // needs when excluding subchart.js
	    };
	
	    c3_chart_internal_fn.initChartElements = function () {
	        if (this.initBar) {
	            this.initBar();
	        }
	        if (this.initLine) {
	            this.initLine();
	        }
	        if (this.initArc) {
	            this.initArc();
	        }
	        if (this.initGauge) {
	            this.initGauge();
	        }
	        if (this.initText) {
	            this.initText();
	        }
	    };
	
	    c3_chart_internal_fn.initWithData = function (data) {
	        var $$ = this,
	            d3 = $$.d3,
	            config = $$.config;
	        var defs,
	            main,
	            binding = true;
	
	        $$.axis = new Axis($$);
	
	        if ($$.initPie) {
	            $$.initPie();
	        }
	        if ($$.initBrush) {
	            $$.initBrush();
	        }
	        if ($$.initZoom) {
	            $$.initZoom();
	        }
	
	        if (!config.bindto) {
	            $$.selectChart = d3.selectAll([]);
	        } else if (typeof config.bindto.node === 'function') {
	            $$.selectChart = config.bindto;
	        } else {
	            $$.selectChart = d3.select(config.bindto);
	        }
	        if ($$.selectChart.empty()) {
	            $$.selectChart = d3.select(document.createElement('div')).style('opacity', 0);
	            $$.observeInserted($$.selectChart);
	            binding = false;
	        }
	        $$.selectChart.html("").classed("c3", true);
	
	        // Init data as targets
	        $$.data.xs = {};
	        $$.data.targets = $$.convertDataToTargets(data);
	
	        if (config.data_filter) {
	            $$.data.targets = $$.data.targets.filter(config.data_filter);
	        }
	
	        // Set targets to hide if needed
	        if (config.data_hide) {
	            $$.addHiddenTargetIds(config.data_hide === true ? $$.mapToIds($$.data.targets) : config.data_hide);
	        }
	        if (config.legend_hide) {
	            $$.addHiddenLegendIds(config.legend_hide === true ? $$.mapToIds($$.data.targets) : config.legend_hide);
	        }
	
	        // Init sizes and scales
	        $$.updateSizes();
	        $$.updateScales();
	
	        // Set domains for each scale
	        $$.x.domain(d3.extent($$.getXDomain($$.data.targets)));
	        $$.y.domain($$.getYDomain($$.data.targets, 'y'));
	        $$.y2.domain($$.getYDomain($$.data.targets, 'y2'));
	        $$.subX.domain($$.x.domain());
	        $$.subY.domain($$.y.domain());
	        $$.subY2.domain($$.y2.domain());
	
	        // Save original x domain for zoom update
	        $$.orgXDomain = $$.x.domain();
	
	        // Set initialized scales to brush and zoom
	        if ($$.brush) {
	            $$.brush.scale($$.subX);
	        }
	        if (config.zoom_enabled) {
	            $$.zoom.scale($$.x);
	        }
	
	        /*-- Basic Elements --*/
	
	        // Define svgs
	        $$.svg = $$.selectChart.append("svg").style("overflow", "hidden").on('mouseenter', function () {
	            return config.onmouseover.call($$);
	        }).on('mouseleave', function () {
	            return config.onmouseout.call($$);
	        });
	
	        if ($$.config.svg_classname) {
	            $$.svg.attr('class', $$.config.svg_classname);
	        }
	
	        // Define defs
	        defs = $$.svg.append("defs");
	        $$.clipChart = $$.appendClip(defs, $$.clipId);
	        $$.clipXAxis = $$.appendClip(defs, $$.clipIdForXAxis);
	        $$.clipYAxis = $$.appendClip(defs, $$.clipIdForYAxis);
	        $$.clipGrid = $$.appendClip(defs, $$.clipIdForGrid);
	        $$.clipSubchart = $$.appendClip(defs, $$.clipIdForSubchart);
	        $$.updateSvgSize();
	
	        // Define regions
	        main = $$.main = $$.svg.append("g").attr("transform", $$.getTranslate('main'));
	
	        if ($$.initSubchart) {
	            $$.initSubchart();
	        }
	        if ($$.initTooltip) {
	            $$.initTooltip();
	        }
	        if ($$.initLegend) {
	            $$.initLegend();
	        }
	        if ($$.initTitle) {
	            $$.initTitle();
	        }
	
	        /*-- Main Region --*/
	
	        // text when empty
	        main.append("text").attr("class", CLASS.text + ' ' + CLASS.empty).attr("text-anchor", "middle") // horizontal centering of text at x position in all browsers.
	        .attr("dominant-baseline", "middle"); // vertical centering of text at y position in all browsers, except IE.
	
	        // Regions
	        $$.initRegion();
	
	        // Grids
	        $$.initGrid();
	
	        // Define g for chart area
	        main.append('g').attr("clip-path", $$.clipPath).attr('class', CLASS.chart);
	
	        // Grid lines
	        if (config.grid_lines_front) {
	            $$.initGridLines();
	        }
	
	        // Cover whole with rects for events
	        $$.initEventRect();
	
	        // Define g for chart
	        $$.initChartElements();
	
	        // if zoom privileged, insert rect to forefront
	        // TODO: is this needed?
	        main.insert('rect', config.zoom_privileged ? null : 'g.' + CLASS.regions).attr('class', CLASS.zoomRect).attr('width', $$.width).attr('height', $$.height).style('opacity', 0).on("dblclick.zoom", null);
	
	        // Set default extent if defined
	        if (config.axis_x_extent) {
	            $$.brush.extent($$.getDefaultExtent());
	        }
	
	        // Add Axis
	        $$.axis.init();
	
	        // Set targets
	        $$.updateTargets($$.data.targets);
	
	        // Draw with targets
	        if (binding) {
	            $$.updateDimension();
	            $$.config.oninit.call($$);
	            $$.redraw({
	                withTransition: false,
	                withTransform: true,
	                withUpdateXDomain: true,
	                withUpdateOrgXDomain: true,
	                withTransitionForAxis: false
	            });
	        }
	
	        // Bind resize event
	        $$.bindResize();
	
	        // export element of the chart
	        $$.api.element = $$.selectChart.node();
	    };
	
	    c3_chart_internal_fn.smoothLines = function (el, type) {
	        var $$ = this;
	        if (type === 'grid') {
	            el.each(function () {
	                var g = $$.d3.select(this),
	                    x1 = g.attr('x1'),
	                    x2 = g.attr('x2'),
	                    y1 = g.attr('y1'),
	                    y2 = g.attr('y2');
	                g.attr({
	                    'x1': Math.ceil(x1),
	                    'x2': Math.ceil(x2),
	                    'y1': Math.ceil(y1),
	                    'y2': Math.ceil(y2)
	                });
	            });
	        }
	    };
	
	    c3_chart_internal_fn.updateSizes = function () {
	        var $$ = this,
	            config = $$.config;
	        var legendHeight = $$.legend ? $$.getLegendHeight() : 0,
	            legendWidth = $$.legend ? $$.getLegendWidth() : 0,
	            legendHeightForBottom = $$.isLegendRight || $$.isLegendInset ? 0 : legendHeight,
	            hasArc = $$.hasArcType(),
	            xAxisHeight = config.axis_rotated || hasArc ? 0 : $$.getHorizontalAxisHeight('x'),
	            subchartHeight = config.subchart_show && !hasArc ? config.subchart_size_height + xAxisHeight : 0;
	
	        $$.currentWidth = $$.getCurrentWidth();
	        $$.currentHeight = $$.getCurrentHeight();
	
	        // for main
	        $$.margin = config.axis_rotated ? {
	            top: $$.getHorizontalAxisHeight('y2') + $$.getCurrentPaddingTop(),
	            right: hasArc ? 0 : $$.getCurrentPaddingRight(),
	            bottom: $$.getHorizontalAxisHeight('y') + legendHeightForBottom + $$.getCurrentPaddingBottom(),
	            left: subchartHeight + (hasArc ? 0 : $$.getCurrentPaddingLeft())
	        } : {
	            top: 4 + $$.getCurrentPaddingTop(), // for top tick text
	            right: hasArc ? 0 : $$.getCurrentPaddingRight(),
	            bottom: xAxisHeight + subchartHeight + legendHeightForBottom + $$.getCurrentPaddingBottom(),
	            left: hasArc ? 0 : $$.getCurrentPaddingLeft()
	        };
	
	        // for subchart
	        $$.margin2 = config.axis_rotated ? {
	            top: $$.margin.top,
	            right: NaN,
	            bottom: 20 + legendHeightForBottom,
	            left: $$.rotated_padding_left
	        } : {
	            top: $$.currentHeight - subchartHeight - legendHeightForBottom,
	            right: NaN,
	            bottom: xAxisHeight + legendHeightForBottom,
	            left: $$.margin.left
	        };
	
	        // for legend
	        $$.margin3 = {
	            top: 0,
	            right: NaN,
	            bottom: 0,
	            left: 0
	        };
	        if ($$.updateSizeForLegend) {
	            $$.updateSizeForLegend(legendHeight, legendWidth);
	        }
	
	        $$.width = $$.currentWidth - $$.margin.left - $$.margin.right;
	        $$.height = $$.currentHeight - $$.margin.top - $$.margin.bottom;
	        if ($$.width < 0) {
	            $$.width = 0;
	        }
	        if ($$.height < 0) {
	            $$.height = 0;
	        }
	
	        $$.width2 = config.axis_rotated ? $$.margin.left - $$.rotated_padding_left - $$.rotated_padding_right : $$.width;
	        $$.height2 = config.axis_rotated ? $$.height : $$.currentHeight - $$.margin2.top - $$.margin2.bottom;
	        if ($$.width2 < 0) {
	            $$.width2 = 0;
	        }
	        if ($$.height2 < 0) {
	            $$.height2 = 0;
	        }
	
	        // for arc
	        $$.arcWidth = $$.width - ($$.isLegendRight ? legendWidth + 10 : 0);
	        $$.arcHeight = $$.height - ($$.isLegendRight ? 0 : 10);
	        if ($$.hasType('gauge') && !config.gauge_fullCircle) {
	            $$.arcHeight += $$.height - $$.getGaugeLabelHeight();
	        }
	        if ($$.updateRadius) {
	            $$.updateRadius();
	        }
	
	        if ($$.isLegendRight && hasArc) {
	            $$.margin3.left = $$.arcWidth / 2 + $$.radiusExpanded * 1.1;
	        }
	    };
	
	    c3_chart_internal_fn.updateTargets = function (targets) {
	        var $$ = this;
	
	        /*-- Main --*/
	
	        //-- Text --//
	        $$.updateTargetsForText(targets);
	
	        //-- Bar --//
	        $$.updateTargetsForBar(targets);
	
	        //-- Line --//
	        $$.updateTargetsForLine(targets);
	
	        //-- Arc --//
	        if ($$.hasArcType() && $$.updateTargetsForArc) {
	            $$.updateTargetsForArc(targets);
	        }
	
	        /*-- Sub --*/
	
	        if ($$.updateTargetsForSubchart) {
	            $$.updateTargetsForSubchart(targets);
	        }
	
	        // Fade-in each chart
	        $$.showTargets();
	    };
	    c3_chart_internal_fn.showTargets = function () {
	        var $$ = this;
	        $$.svg.selectAll('.' + CLASS.target).filter(function (d) {
	            return $$.isTargetToShow(d.id);
	        }).transition().duration($$.config.transition_duration).style("opacity", 1);
	    };
	
	    c3_chart_internal_fn.redraw = function (options, transitions) {
	        var $$ = this,
	            main = $$.main,
	            d3 = $$.d3,
	            config = $$.config;
	        var areaIndices = $$.getShapeIndices($$.isAreaType),
	            barIndices = $$.getShapeIndices($$.isBarType),
	            lineIndices = $$.getShapeIndices($$.isLineType);
	        var withY, withSubchart, withTransition, withTransitionForExit, withTransitionForAxis, withTransform, withUpdateXDomain, withUpdateOrgXDomain, withTrimXDomain, withLegend, withEventRect, withDimension, withUpdateXAxis;
	        var hideAxis = $$.hasArcType();
	        var drawArea, drawBar, drawLine, xForText, yForText;
	        var duration, durationForExit, durationForAxis;
	        var waitForDraw, flow;
	        var targetsToShow = $$.filterTargetsToShow($$.data.targets),
	            tickValues,
	            i,
	            intervalForCulling,
	            xDomainForZoom;
	        var xv = $$.xv.bind($$),
	            cx,
	            cy;
	
	        options = options || {};
	        withY = getOption(options, "withY", true);
	        withSubchart = getOption(options, "withSubchart", true);
	        withTransition = getOption(options, "withTransition", true);
	        withTransform = getOption(options, "withTransform", false);
	        withUpdateXDomain = getOption(options, "withUpdateXDomain", false);
	        withUpdateOrgXDomain = getOption(options, "withUpdateOrgXDomain", false);
	        withTrimXDomain = getOption(options, "withTrimXDomain", true);
	        withUpdateXAxis = getOption(options, "withUpdateXAxis", withUpdateXDomain);
	        withLegend = getOption(options, "withLegend", false);
	        withEventRect = getOption(options, "withEventRect", true);
	        withDimension = getOption(options, "withDimension", true);
	        withTransitionForExit = getOption(options, "withTransitionForExit", withTransition);
	        withTransitionForAxis = getOption(options, "withTransitionForAxis", withTransition);
	
	        duration = withTransition ? config.transition_duration : 0;
	        durationForExit = withTransitionForExit ? duration : 0;
	        durationForAxis = withTransitionForAxis ? duration : 0;
	
	        transitions = transitions || $$.axis.generateTransitions(durationForAxis);
	
	        // update legend and transform each g
	        if (withLegend && config.legend_show) {
	            $$.updateLegend($$.mapToIds($$.data.targets), options, transitions);
	        } else if (withDimension) {
	            // need to update dimension (e.g. axis.y.tick.values) because y tick values should change
	            // no need to update axis in it because they will be updated in redraw()
	            $$.updateDimension(true);
	        }
	
	        // MEMO: needed for grids calculation
	        if ($$.isCategorized() && targetsToShow.length === 0) {
	            $$.x.domain([0, $$.axes.x.selectAll('.tick').size()]);
	        }
	
	        if (targetsToShow.length) {
	            $$.updateXDomain(targetsToShow, withUpdateXDomain, withUpdateOrgXDomain, withTrimXDomain);
	            if (!config.axis_x_tick_values) {
	                tickValues = $$.axis.updateXAxisTickValues(targetsToShow);
	            }
	        } else {
	            $$.xAxis.tickValues([]);
	            $$.subXAxis.tickValues([]);
	        }
	
	        if (config.zoom_rescale && !options.flow) {
	            xDomainForZoom = $$.x.orgDomain();
	        }
	
	        $$.y.domain($$.getYDomain(targetsToShow, 'y', xDomainForZoom));
	        $$.y2.domain($$.getYDomain(targetsToShow, 'y2', xDomainForZoom));
	
	        if (!config.axis_y_tick_values && config.axis_y_tick_count) {
	            $$.yAxis.tickValues($$.axis.generateTickValues($$.y.domain(), config.axis_y_tick_count));
	        }
	        if (!config.axis_y2_tick_values && config.axis_y2_tick_count) {
	            $$.y2Axis.tickValues($$.axis.generateTickValues($$.y2.domain(), config.axis_y2_tick_count));
	        }
	
	        // axes
	        $$.axis.redraw(transitions, hideAxis);
	
	        // Update axis label
	        $$.axis.updateLabels(withTransition);
	
	        // show/hide if manual culling needed
	        if ((withUpdateXDomain || withUpdateXAxis) && targetsToShow.length) {
	            if (config.axis_x_tick_culling && tickValues) {
	                for (i = 1; i < tickValues.length; i++) {
	                    if (tickValues.length / i < config.axis_x_tick_culling_max) {
	                        intervalForCulling = i;
	                        break;
	                    }
	                }
	                $$.svg.selectAll('.' + CLASS.axisX + ' .tick text').each(function (e) {
	                    var index = tickValues.indexOf(e);
	                    if (index >= 0) {
	                        d3.select(this).style('display', index % intervalForCulling ? 'none' : 'block');
	                    }
	                });
	            } else {
	                $$.svg.selectAll('.' + CLASS.axisX + ' .tick text').style('display', 'block');
	            }
	        }
	
	        // setup drawer - MEMO: these must be called after axis updated
	        drawArea = $$.generateDrawArea ? $$.generateDrawArea(areaIndices, false) : undefined;
	        drawBar = $$.generateDrawBar ? $$.generateDrawBar(barIndices) : undefined;
	        drawLine = $$.generateDrawLine ? $$.generateDrawLine(lineIndices, false) : undefined;
	        xForText = $$.generateXYForText(areaIndices, barIndices, lineIndices, true);
	        yForText = $$.generateXYForText(areaIndices, barIndices, lineIndices, false);
	
	        // Update sub domain
	        if (withY) {
	            $$.subY.domain($$.getYDomain(targetsToShow, 'y'));
	            $$.subY2.domain($$.getYDomain(targetsToShow, 'y2'));
	        }
	
	        // xgrid focus
	        $$.updateXgridFocus();
	
	        // Data empty label positioning and text.
	        main.select("text." + CLASS.text + '.' + CLASS.empty).attr("x", $$.width / 2).attr("y", $$.height / 2).text(config.data_empty_label_text).transition().style('opacity', targetsToShow.length ? 0 : 1);
	
	        // grid
	        $$.updateGrid(duration);
	
	        // rect for regions
	        $$.updateRegion(duration);
	
	        // bars
	        $$.updateBar(durationForExit);
	
	        // lines, areas and cricles
	        $$.updateLine(durationForExit);
	        $$.updateArea(durationForExit);
	        $$.updateCircle();
	
	        // text
	        if ($$.hasDataLabel()) {
	            $$.updateText(durationForExit);
	        }
	
	        // title
	        if ($$.redrawTitle) {
	            $$.redrawTitle();
	        }
	
	        // arc
	        if ($$.redrawArc) {
	            $$.redrawArc(duration, durationForExit, withTransform);
	        }
	
	        // subchart
	        if ($$.redrawSubchart) {
	            $$.redrawSubchart(withSubchart, transitions, duration, durationForExit, areaIndices, barIndices, lineIndices);
	        }
	
	        // circles for select
	        main.selectAll('.' + CLASS.selectedCircles).filter($$.isBarType.bind($$)).selectAll('circle').remove();
	
	        // event rects will redrawn when flow called
	        if (config.interaction_enabled && !options.flow && withEventRect) {
	            $$.redrawEventRect();
	            if ($$.updateZoom) {
	                $$.updateZoom();
	            }
	        }
	
	        // update circleY based on updated parameters
	        $$.updateCircleY();
	
	        // generate circle x/y functions depending on updated params
	        cx = ($$.config.axis_rotated ? $$.circleY : $$.circleX).bind($$);
	        cy = ($$.config.axis_rotated ? $$.circleX : $$.circleY).bind($$);
	
	        if (options.flow) {
	            flow = $$.generateFlow({
	                targets: targetsToShow,
	                flow: options.flow,
	                duration: options.flow.duration,
	                drawBar: drawBar,
	                drawLine: drawLine,
	                drawArea: drawArea,
	                cx: cx,
	                cy: cy,
	                xv: xv,
	                xForText: xForText,
	                yForText: yForText
	            });
	        }
	
	        if ((duration || flow) && $$.isTabVisible()) {
	            // Only use transition if tab visible. See #938.
	            // transition should be derived from one transition
	            d3.transition().duration(duration).each(function () {
	                var transitionsToWait = [];
	
	                // redraw and gather transitions
	                [$$.redrawBar(drawBar, true), $$.redrawLine(drawLine, true), $$.redrawArea(drawArea, true), $$.redrawCircle(cx, cy, true), $$.redrawText(xForText, yForText, options.flow, true), $$.redrawRegion(true), $$.redrawGrid(true)].forEach(function (transitions) {
	                    transitions.forEach(function (transition) {
	                        transitionsToWait.push(transition);
	                    });
	                });
	
	                // Wait for end of transitions to call flow and onrendered callback
	                waitForDraw = $$.generateWait();
	                transitionsToWait.forEach(function (t) {
	                    waitForDraw.add(t);
	                });
	            }).call(waitForDraw, function () {
	                if (flow) {
	                    flow();
	                }
	                if (config.onrendered) {
	                    config.onrendered.call($$);
	                }
	            });
	        } else {
	            $$.redrawBar(drawBar);
	            $$.redrawLine(drawLine);
	            $$.redrawArea(drawArea);
	            $$.redrawCircle(cx, cy);
	            $$.redrawText(xForText, yForText, options.flow);
	            $$.redrawRegion();
	            $$.redrawGrid();
	            if (config.onrendered) {
	                config.onrendered.call($$);
	            }
	        }
	
	        // update fadein condition
	        $$.mapToIds($$.data.targets).forEach(function (id) {
	            $$.withoutFadeIn[id] = true;
	        });
	    };
	
	    c3_chart_internal_fn.updateAndRedraw = function (options) {
	        var $$ = this,
	            config = $$.config,
	            transitions;
	        options = options || {};
	        // same with redraw
	        options.withTransition = getOption(options, "withTransition", true);
	        options.withTransform = getOption(options, "withTransform", false);
	        options.withLegend = getOption(options, "withLegend", false);
	        // NOT same with redraw
	        options.withUpdateXDomain = true;
	        options.withUpdateOrgXDomain = true;
	        options.withTransitionForExit = false;
	        options.withTransitionForTransform = getOption(options, "withTransitionForTransform", options.withTransition);
	        // MEMO: this needs to be called before updateLegend and it means this ALWAYS needs to be called)
	        $$.updateSizes();
	        // MEMO: called in updateLegend in redraw if withLegend
	        if (!(options.withLegend && config.legend_show)) {
	            transitions = $$.axis.generateTransitions(options.withTransitionForAxis ? config.transition_duration : 0);
	            // Update scales
	            $$.updateScales();
	            $$.updateSvgSize();
	            // Update g positions
	            $$.transformAll(options.withTransitionForTransform, transitions);
	        }
	        // Draw with new sizes & scales
	        $$.redraw(options, transitions);
	    };
	    c3_chart_internal_fn.redrawWithoutRescale = function () {
	        this.redraw({
	            withY: false,
	            withSubchart: false,
	            withEventRect: false,
	            withTransitionForAxis: false
	        });
	    };
	
	    c3_chart_internal_fn.isTimeSeries = function () {
	        return this.config.axis_x_type === 'timeseries';
	    };
	    c3_chart_internal_fn.isCategorized = function () {
	        return this.config.axis_x_type.indexOf('categor') >= 0;
	    };
	    c3_chart_internal_fn.isCustomX = function () {
	        var $$ = this,
	            config = $$.config;
	        return !$$.isTimeSeries() && (config.data_x || notEmpty(config.data_xs));
	    };
	
	    c3_chart_internal_fn.isTimeSeriesY = function () {
	        return this.config.axis_y_type === 'timeseries';
	    };
	
	    c3_chart_internal_fn.getTranslate = function (target) {
	        var $$ = this,
	            config = $$.config,
	            x,
	            y;
	        if (target === 'main') {
	            x = asHalfPixel($$.margin.left);
	            y = asHalfPixel($$.margin.top);
	        } else if (target === 'context') {
	            x = asHalfPixel($$.margin2.left);
	            y = asHalfPixel($$.margin2.top);
	        } else if (target === 'legend') {
	            x = $$.margin3.left;
	            y = $$.margin3.top;
	        } else if (target === 'x') {
	            x = 0;
	            y = config.axis_rotated ? 0 : $$.height;
	        } else if (target === 'y') {
	            x = 0;
	            y = config.axis_rotated ? $$.height : 0;
	        } else if (target === 'y2') {
	            x = config.axis_rotated ? 0 : $$.width;
	            y = config.axis_rotated ? 1 : 0;
	        } else if (target === 'subx') {
	            x = 0;
	            y = config.axis_rotated ? 0 : $$.height2;
	        } else if (target === 'arc') {
	            x = $$.arcWidth / 2;
	            y = $$.arcHeight / 2 - ($$.hasType('gauge') ? 6 : 0); // to prevent wrong display of min and max label
	        }
	        return "translate(" + x + "," + y + ")";
	    };
	    c3_chart_internal_fn.initialOpacity = function (d) {
	        return d.value !== null && this.withoutFadeIn[d.id] ? 1 : 0;
	    };
	    c3_chart_internal_fn.initialOpacityForCircle = function (d) {
	        return d.value !== null && this.withoutFadeIn[d.id] ? this.opacityForCircle(d) : 0;
	    };
	    c3_chart_internal_fn.opacityForCircle = function (d) {
	        var isPointShouldBeShown = isFunction(this.config.point_show) ? this.config.point_show(d) : this.config.point_show;
	        var opacity = isPointShouldBeShown ? 1 : 0;
	        return isValue(d.value) ? this.isScatterType(d) ? 0.5 : opacity : 0;
	    };
	    c3_chart_internal_fn.opacityForText = function () {
	        return this.hasDataLabel() ? 1 : 0;
	    };
	    c3_chart_internal_fn.xx = function (d) {
	        return d ? this.x(d.x) : null;
	    };
	    c3_chart_internal_fn.xv = function (d) {
	        var $$ = this,
	            value = d.value;
	        if ($$.isTimeSeries()) {
	            value = $$.parseDate(d.value);
	        } else if ($$.isCategorized() && typeof d.value === 'string') {
	            value = $$.config.axis_x_categories.indexOf(d.value);
	        }
	        return Math.ceil($$.x(value));
	    };
	    c3_chart_internal_fn.yv = function (d) {
	        var $$ = this,
	            yScale = d.axis && d.axis === 'y2' ? $$.y2 : $$.y;
	        return Math.ceil(yScale(d.value));
	    };
	    c3_chart_internal_fn.subxx = function (d) {
	        return d ? this.subX(d.x) : null;
	    };
	
	    c3_chart_internal_fn.transformMain = function (withTransition, transitions) {
	        var $$ = this,
	            xAxis,
	            yAxis,
	            y2Axis;
	        if (transitions && transitions.axisX) {
	            xAxis = transitions.axisX;
	        } else {
	            xAxis = $$.main.select('.' + CLASS.axisX);
	            if (withTransition) {
	                xAxis = xAxis.transition();
	            }
	        }
	        if (transitions && transitions.axisY) {
	            yAxis = transitions.axisY;
	        } else {
	            yAxis = $$.main.select('.' + CLASS.axisY);
	            if (withTransition) {
	                yAxis = yAxis.transition();
	            }
	        }
	        if (transitions && transitions.axisY2) {
	            y2Axis = transitions.axisY2;
	        } else {
	            y2Axis = $$.main.select('.' + CLASS.axisY2);
	            if (withTransition) {
	                y2Axis = y2Axis.transition();
	            }
	        }
	        (withTransition ? $$.main.transition() : $$.main).attr("transform", $$.getTranslate('main'));
	        xAxis.attr("transform", $$.getTranslate('x'));
	        yAxis.attr("transform", $$.getTranslate('y'));
	        y2Axis.attr("transform", $$.getTranslate('y2'));
	        $$.main.select('.' + CLASS.chartArcs).attr("transform", $$.getTranslate('arc'));
	    };
	    c3_chart_internal_fn.transformAll = function (withTransition, transitions) {
	        var $$ = this;
	        $$.transformMain(withTransition, transitions);
	        if ($$.config.subchart_show) {
	            $$.transformContext(withTransition, transitions);
	        }
	        if ($$.legend) {
	            $$.transformLegend(withTransition);
	        }
	    };
	
	    c3_chart_internal_fn.updateSvgSize = function () {
	        var $$ = this,
	            brush = $$.svg.select(".c3-brush .background");
	        $$.svg.attr('width', $$.currentWidth).attr('height', $$.currentHeight);
	        $$.svg.selectAll(['#' + $$.clipId, '#' + $$.clipIdForGrid]).select('rect').attr('width', $$.width).attr('height', $$.height);
	        $$.svg.select('#' + $$.clipIdForXAxis).select('rect').attr('x', $$.getXAxisClipX.bind($$)).attr('y', $$.getXAxisClipY.bind($$)).attr('width', $$.getXAxisClipWidth.bind($$)).attr('height', $$.getXAxisClipHeight.bind($$));
	        $$.svg.select('#' + $$.clipIdForYAxis).select('rect').attr('x', $$.getYAxisClipX.bind($$)).attr('y', $$.getYAxisClipY.bind($$)).attr('width', $$.getYAxisClipWidth.bind($$)).attr('height', $$.getYAxisClipHeight.bind($$));
	        $$.svg.select('#' + $$.clipIdForSubchart).select('rect').attr('width', $$.width).attr('height', brush.size() ? brush.attr('height') : 0);
	        $$.svg.select('.' + CLASS.zoomRect).attr('width', $$.width).attr('height', $$.height);
	        // MEMO: parent div's height will be bigger than svg when <!DOCTYPE html>
	        $$.selectChart.style('max-height', $$.currentHeight + "px");
	    };
	
	    c3_chart_internal_fn.updateDimension = function (withoutAxis) {
	        var $$ = this;
	        if (!withoutAxis) {
	            if ($$.config.axis_rotated) {
	                $$.axes.x.call($$.xAxis);
	                $$.axes.subx.call($$.subXAxis);
	            } else {
	                $$.axes.y.call($$.yAxis);
	                $$.axes.y2.call($$.y2Axis);
	            }
	        }
	        $$.updateSizes();
	        $$.updateScales();
	        $$.updateSvgSize();
	        $$.transformAll(false);
	    };
	
	    c3_chart_internal_fn.observeInserted = function (selection) {
	        var $$ = this,
	            observer;
	        if (typeof MutationObserver === 'undefined') {
	            window.console.error("MutationObserver not defined.");
	            return;
	        }
	        observer = new MutationObserver(function (mutations) {
	            mutations.forEach(function (mutation) {
	                if (mutation.type === 'childList' && mutation.previousSibling) {
	                    observer.disconnect();
	                    // need to wait for completion of load because size calculation requires the actual sizes determined after that completion
	                    $$.intervalForObserveInserted = window.setInterval(function () {
	                        // parentNode will NOT be null when completed
	                        if (selection.node().parentNode) {
	                            window.clearInterval($$.intervalForObserveInserted);
	                            $$.updateDimension();
	                            if ($$.brush) {
	                                $$.brush.update();
	                            }
	                            $$.config.oninit.call($$);
	                            $$.redraw({
	                                withTransform: true,
	                                withUpdateXDomain: true,
	                                withUpdateOrgXDomain: true,
	                                withTransition: false,
	                                withTransitionForTransform: false,
	                                withLegend: true
	                            });
	                            selection.transition().style('opacity', 1);
	                        }
	                    }, 10);
	                }
	            });
	        });
	        observer.observe(selection.node(), { attributes: true, childList: true, characterData: true });
	    };
	
	    c3_chart_internal_fn.bindResize = function () {
	        var $$ = this,
	            config = $$.config;
	
	        $$.resizeFunction = $$.generateResize(); // need to call .remove
	
	        $$.resizeFunction.add(function () {
	            config.onresize.call($$);
	        });
	        if (config.resize_auto) {
	            $$.resizeFunction.add(function () {
	                if ($$.resizeTimeout !== undefined) {
	                    window.clearTimeout($$.resizeTimeout);
	                }
	                $$.resizeTimeout = window.setTimeout(function () {
	                    delete $$.resizeTimeout;
	                    $$.api.flush();
	                }, 100);
	            });
	        }
	        $$.resizeFunction.add(function () {
	            config.onresized.call($$);
	        });
	
	        $$.resizeIfElementDisplayed = function () {
	            // if element not displayed skip it
	            if ($$.api == null || !$$.api.element.offsetParent) {
	                return;
	            }
	
	            $$.resizeFunction();
	        };
	
	        if (window.attachEvent) {
	            window.attachEvent('onresize', $$.resizeIfElementDisplayed);
	        } else if (window.addEventListener) {
	            window.addEventListener('resize', $$.resizeIfElementDisplayed, false);
	        } else {
	            // fallback to this, if this is a very old browser
	            var wrapper = window.onresize;
	            if (!wrapper) {
	                // create a wrapper that will call all charts
	                wrapper = $$.generateResize();
	            } else if (!wrapper.add || !wrapper.remove) {
	                // there is already a handler registered, make sure we call it too
	                wrapper = $$.generateResize();
	                wrapper.add(window.onresize);
	            }
	            // add this graph to the wrapper, we will be removed if the user calls destroy
	            wrapper.add($$.resizeFunction);
	            window.onresize = function () {
	                // if element not displayed skip it
	                if (!$$.api.element.offsetParent) {
	                    return;
	                }
	
	                wrapper();
	            };
	        }
	    };
	
	    c3_chart_internal_fn.generateResize = function () {
	        var resizeFunctions = [];
	        function callResizeFunctions() {
	            resizeFunctions.forEach(function (f) {
	                f();
	            });
	        }
	        callResizeFunctions.add = function (f) {
	            resizeFunctions.push(f);
	        };
	        callResizeFunctions.remove = function (f) {
	            for (var i = 0; i < resizeFunctions.length; i++) {
	                if (resizeFunctions[i] === f) {
	                    resizeFunctions.splice(i, 1);
	                    break;
	                }
	            }
	        };
	        return callResizeFunctions;
	    };
	
	    c3_chart_internal_fn.endall = function (transition, callback) {
	        var n = 0;
	        transition.each(function () {
	            ++n;
	        }).each("end", function () {
	            if (! --n) {
	                callback.apply(this, arguments);
	            }
	        });
	    };
	    c3_chart_internal_fn.generateWait = function () {
	        var transitionsToWait = [],
	            f = function f(transition, callback) {
	            var timer = setInterval(function () {
	                var done = 0;
	                transitionsToWait.forEach(function (t) {
	                    if (t.empty()) {
	                        done += 1;
	                        return;
	                    }
	                    try {
	                        t.transition();
	                    } catch (e) {
	                        done += 1;
	                    }
	                });
	                if (done === transitionsToWait.length) {
	                    clearInterval(timer);
	                    if (callback) {
	                        callback();
	                    }
	                }
	            }, 10);
	        };
	        f.add = function (transition) {
	            transitionsToWait.push(transition);
	        };
	        return f;
	    };
	
	    c3_chart_internal_fn.parseDate = function (date) {
	        var $$ = this,
	            parsedDate;
	        if (date instanceof Date) {
	            parsedDate = date;
	        } else if (typeof date === 'string') {
	            parsedDate = $$.dataTimeFormat($$.config.data_xFormat).parse(date);
	        } else if ((typeof date === 'undefined' ? 'undefined' : _typeof(date)) === 'object') {
	            parsedDate = new Date(+date);
	        } else if (typeof date === 'number' && !isNaN(date)) {
	            parsedDate = new Date(+date);
	        }
	        if (!parsedDate || isNaN(+parsedDate)) {
	            window.console.error("Failed to parse x '" + date + "' to Date object");
	        }
	        return parsedDate;
	    };
	
	    c3_chart_internal_fn.isTabVisible = function () {
	        var hidden;
	        if (typeof document.hidden !== "undefined") {
	            // Opera 12.10 and Firefox 18 and later support
	            hidden = "hidden";
	        } else if (typeof document.mozHidden !== "undefined") {
	            hidden = "mozHidden";
	        } else if (typeof document.msHidden !== "undefined") {
	            hidden = "msHidden";
	        } else if (typeof document.webkitHidden !== "undefined") {
	            hidden = "webkitHidden";
	        }
	
	        return document[hidden] ? false : true;
	    };
	
	    c3_chart_internal_fn.isValue = isValue;
	    c3_chart_internal_fn.isFunction = isFunction;
	    c3_chart_internal_fn.isString = isString;
	    c3_chart_internal_fn.isUndefined = isUndefined;
	    c3_chart_internal_fn.isDefined = isDefined;
	    c3_chart_internal_fn.ceil10 = ceil10;
	    c3_chart_internal_fn.asHalfPixel = asHalfPixel;
	    c3_chart_internal_fn.diffDomain = diffDomain;
	    c3_chart_internal_fn.isEmpty = isEmpty;
	    c3_chart_internal_fn.notEmpty = notEmpty;
	    c3_chart_internal_fn.notEmpty = notEmpty;
	    c3_chart_internal_fn.getOption = getOption;
	    c3_chart_internal_fn.hasValue = hasValue;
	    c3_chart_internal_fn.sanitise = sanitise;
	    c3_chart_internal_fn.getPathBox = getPathBox;
	    c3_chart_internal_fn.CLASS = CLASS;
	
	    /* jshint ignore:start */
	
	    // PhantomJS doesn't have support for Function.prototype.bind, which has caused confusion. Use
	    // this polyfill to avoid the confusion.
	    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Function/bind#Polyfill
	
	    if (!Function.prototype.bind) {
	        Function.prototype.bind = function (oThis) {
	            if (typeof this !== 'function') {
	                // closest thing possible to the ECMAScript 5
	                // internal IsCallable function
	                throw new TypeError('Function.prototype.bind - what is trying to be bound is not callable');
	            }
	
	            var aArgs = Array.prototype.slice.call(arguments, 1),
	                fToBind = this,
	                fNOP = function fNOP() {},
	                fBound = function fBound() {
	                return fToBind.apply(this instanceof fNOP ? this : oThis, aArgs.concat(Array.prototype.slice.call(arguments)));
	            };
	
	            fNOP.prototype = this.prototype;
	            fBound.prototype = new fNOP();
	
	            return fBound;
	        };
	    }
	
	    // SVGPathSeg API polyfill
	    // https://github.com/progers/pathseg
	    //
	    // This is a drop-in replacement for the SVGPathSeg and SVGPathSegList APIs that were removed from
	    // SVG2 (https://lists.w3.org/Archives/Public/www-svg/2015Jun/0044.html), including the latest spec
	    // changes which were implemented in Firefox 43 and Chrome 46.
	
	    (function () {
	
	        if (!("SVGPathSeg" in window)) {
	            // Spec: http://www.w3.org/TR/SVG11/single-page.html#paths-InterfaceSVGPathSeg
	            window.SVGPathSeg = function (type, typeAsLetter, owningPathSegList) {
	                this.pathSegType = type;
	                this.pathSegTypeAsLetter = typeAsLetter;
	                this._owningPathSegList = owningPathSegList;
	            };
	
	            window.SVGPathSeg.prototype.classname = "SVGPathSeg";
	
	            window.SVGPathSeg.PATHSEG_UNKNOWN = 0;
	            window.SVGPathSeg.PATHSEG_CLOSEPATH = 1;
	            window.SVGPathSeg.PATHSEG_MOVETO_ABS = 2;
	            window.SVGPathSeg.PATHSEG_MOVETO_REL = 3;
	            window.SVGPathSeg.PATHSEG_LINETO_ABS = 4;
	            window.SVGPathSeg.PATHSEG_LINETO_REL = 5;
	            window.SVGPathSeg.PATHSEG_CURVETO_CUBIC_ABS = 6;
	            window.SVGPathSeg.PATHSEG_CURVETO_CUBIC_REL = 7;
	            window.SVGPathSeg.PATHSEG_CURVETO_QUADRATIC_ABS = 8;
	            window.SVGPathSeg.PATHSEG_CURVETO_QUADRATIC_REL = 9;
	            window.SVGPathSeg.PATHSEG_ARC_ABS = 10;
	            window.SVGPathSeg.PATHSEG_ARC_REL = 11;
	            window.SVGPathSeg.PATHSEG_LINETO_HORIZONTAL_ABS = 12;
	            window.SVGPathSeg.PATHSEG_LINETO_HORIZONTAL_REL = 13;
	            window.SVGPathSeg.PATHSEG_LINETO_VERTICAL_ABS = 14;
	            window.SVGPathSeg.PATHSEG_LINETO_VERTICAL_REL = 15;
	            window.SVGPathSeg.PATHSEG_CURVETO_CUBIC_SMOOTH_ABS = 16;
	            window.SVGPathSeg.PATHSEG_CURVETO_CUBIC_SMOOTH_REL = 17;
	            window.SVGPathSeg.PATHSEG_CURVETO_QUADRATIC_SMOOTH_ABS = 18;
	            window.SVGPathSeg.PATHSEG_CURVETO_QUADRATIC_SMOOTH_REL = 19;
	
	            // Notify owning PathSegList on any changes so they can be synchronized back to the path element.
	            window.SVGPathSeg.prototype._segmentChanged = function () {
	                if (this._owningPathSegList) this._owningPathSegList.segmentChanged(this);
	            };
	
	            window.SVGPathSegClosePath = function (owningPathSegList) {
	                window.SVGPathSeg.call(this, window.SVGPathSeg.PATHSEG_CLOSEPATH, "z", owningPathSegList);
	            };
	            window.SVGPathSegClosePath.prototype = Object.create(window.SVGPathSeg.prototype);
	            window.SVGPathSegClosePath.prototype.toString = function () {
	                return "[object SVGPathSegClosePath]";
	            };
	            window.SVGPathSegClosePath.prototype._asPathString = function () {
	                return this.pathSegTypeAsLetter;
	            };
	            window.SVGPathSegClosePath.prototype.clone = function () {
	                return new window.SVGPathSegClosePath(undefined);
	            };
	
	            window.SVGPathSegMovetoAbs = function (owningPathSegList, x, y) {
	                window.SVGPathSeg.call(this, window.SVGPathSeg.PATHSEG_MOVETO_ABS, "M", owningPathSegList);
	                this._x = x;
	                this._y = y;
	            };
	            window.SVGPathSegMovetoAbs.prototype = Object.create(window.SVGPathSeg.prototype);
	            window.SVGPathSegMovetoAbs.prototype.toString = function () {
	                return "[object SVGPathSegMovetoAbs]";
	            };
	            window.SVGPathSegMovetoAbs.prototype._asPathString = function () {
	                return this.pathSegTypeAsLetter + " " + this._x + " " + this._y;
	            };
	            window.SVGPathSegMovetoAbs.prototype.clone = function () {
	                return new window.SVGPathSegMovetoAbs(undefined, this._x, this._y);
	            };
	            Object.defineProperty(window.SVGPathSegMovetoAbs.prototype, "x", { get: function get() {
	                    return this._x;
	                }, set: function set(x) {
	                    this._x = x;this._segmentChanged();
	                }, enumerable: true });
	            Object.defineProperty(window.SVGPathSegMovetoAbs.prototype, "y", { get: function get() {
	                    return this._y;
	                }, set: function set(y) {
	                    this._y = y;this._segmentChanged();
	                }, enumerable: true });
	
	            window.SVGPathSegMovetoRel = function (owningPathSegList, x, y) {
	                window.SVGPathSeg.call(this, window.SVGPathSeg.PATHSEG_MOVETO_REL, "m", owningPathSegList);
	                this._x = x;
	                this._y = y;
	            };
	            window.SVGPathSegMovetoRel.prototype = Object.create(window.SVGPathSeg.prototype);
	            window.SVGPathSegMovetoRel.prototype.toString = function () {
	                return "[object SVGPathSegMovetoRel]";
	            };
	            window.SVGPathSegMovetoRel.prototype._asPathString = function () {
	                return this.pathSegTypeAsLetter + " " + this._x + " " + this._y;
	            };
	            window.SVGPathSegMovetoRel.prototype.clone = function () {
	                return new window.SVGPathSegMovetoRel(undefined, this._x, this._y);
	            };
	            Object.defineProperty(window.SVGPathSegMovetoRel.prototype, "x", { get: function get() {
	                    return this._x;
	                }, set: function set(x) {
	                    this._x = x;this._segmentChanged();
	                }, enumerable: true });
	            Object.defineProperty(window.SVGPathSegMovetoRel.prototype, "y", { get: function get() {
	                    return this._y;
	                }, set: function set(y) {
	                    this._y = y;this._segmentChanged();
	                }, enumerable: true });
	
	            window.SVGPathSegLinetoAbs = function (owningPathSegList, x, y) {
	                window.SVGPathSeg.call(this, window.SVGPathSeg.PATHSEG_LINETO_ABS, "L", owningPathSegList);
	                this._x = x;
	                this._y = y;
	            };
	            window.SVGPathSegLinetoAbs.prototype = Object.create(window.SVGPathSeg.prototype);
	            window.SVGPathSegLinetoAbs.prototype.toString = function () {
	                return "[object SVGPathSegLinetoAbs]";
	            };
	            window.SVGPathSegLinetoAbs.prototype._asPathString = function () {
	                return this.pathSegTypeAsLetter + " " + this._x + " " + this._y;
	            };
	            window.SVGPathSegLinetoAbs.prototype.clone = function () {
	                return new window.SVGPathSegLinetoAbs(undefined, this._x, this._y);
	            };
	            Object.defineProperty(window.SVGPathSegLinetoAbs.prototype, "x", { get: function get() {
	                    return this._x;
	                }, set: function set(x) {
	                    this._x = x;this._segmentChanged();
	                }, enumerable: true });
	            Object.defineProperty(window.SVGPathSegLinetoAbs.prototype, "y", { get: function get() {
	                    return this._y;
	                }, set: function set(y) {
	                    this._y = y;this._segmentChanged();
	                }, enumerable: true });
	
	            window.SVGPathSegLinetoRel = function (owningPathSegList, x, y) {
	                window.SVGPathSeg.call(this, window.SVGPathSeg.PATHSEG_LINETO_REL, "l", owningPathSegList);
	                this._x = x;
	                this._y = y;
	            };
	            window.SVGPathSegLinetoRel.prototype = Object.create(window.SVGPathSeg.prototype);
	            window.SVGPathSegLinetoRel.prototype.toString = function () {
	                return "[object SVGPathSegLinetoRel]";
	            };
	            window.SVGPathSegLinetoRel.prototype._asPathString = function () {
	                return this.pathSegTypeAsLetter + " " + this._x + " " + this._y;
	            };
	            window.SVGPathSegLinetoRel.prototype.clone = function () {
	                return new window.SVGPathSegLinetoRel(undefined, this._x, this._y);
	            };
	            Object.defineProperty(window.SVGPathSegLinetoRel.prototype, "x", { get: function get() {
	                    return this._x;
	                }, set: function set(x) {
	                    this._x = x;this._segmentChanged();
	                }, enumerable: true });
	            Object.defineProperty(window.SVGPathSegLinetoRel.prototype, "y", { get: function get() {
	                    return this._y;
	                }, set: function set(y) {
	                    this._y = y;this._segmentChanged();
	                }, enumerable: true });
	
	            window.SVGPathSegCurvetoCubicAbs = function (owningPathSegList, x, y, x1, y1, x2, y2) {
	                window.SVGPathSeg.call(this, window.SVGPathSeg.PATHSEG_CURVETO_CUBIC_ABS, "C", owningPathSegList);
	                this._x = x;
	                this._y = y;
	                this._x1 = x1;
	                this._y1 = y1;
	                this._x2 = x2;
	                this._y2 = y2;
	            };
	            window.SVGPathSegCurvetoCubicAbs.prototype = Object.create(window.SVGPathSeg.prototype);
	            window.SVGPathSegCurvetoCubicAbs.prototype.toString = function () {
	                return "[object SVGPathSegCurvetoCubicAbs]";
	            };
	            window.SVGPathSegCurvetoCubicAbs.prototype._asPathString = function () {
	                return this.pathSegTypeAsLetter + " " + this._x1 + " " + this._y1 + " " + this._x2 + " " + this._y2 + " " + this._x + " " + this._y;
	            };
	            window.SVGPathSegCurvetoCubicAbs.prototype.clone = function () {
	                return new window.SVGPathSegCurvetoCubicAbs(undefined, this._x, this._y, this._x1, this._y1, this._x2, this._y2);
	            };
	            Object.defineProperty(window.SVGPathSegCurvetoCubicAbs.prototype, "x", { get: function get() {
	                    return this._x;
	                }, set: function set(x) {
	                    this._x = x;this._segmentChanged();
	                }, enumerable: true });
	            Object.defineProperty(window.SVGPathSegCurvetoCubicAbs.prototype, "y", { get: function get() {
	                    return this._y;
	                }, set: function set(y) {
	                    this._y = y;this._segmentChanged();
	                }, enumerable: true });
	            Object.defineProperty(window.SVGPathSegCurvetoCubicAbs.prototype, "x1", { get: function get() {
	                    return this._x1;
	                }, set: function set(x1) {
	                    this._x1 = x1;this._segmentChanged();
	                }, enumerable: true });
	            Object.defineProperty(window.SVGPathSegCurvetoCubicAbs.prototype, "y1", { get: function get() {
	                    return this._y1;
	                }, set: function set(y1) {
	                    this._y1 = y1;this._segmentChanged();
	                }, enumerable: true });
	            Object.defineProperty(window.SVGPathSegCurvetoCubicAbs.prototype, "x2", { get: function get() {
	                    return this._x2;
	                }, set: function set(x2) {
	                    this._x2 = x2;this._segmentChanged();
	                }, enumerable: true });
	            Object.defineProperty(window.SVGPathSegCurvetoCubicAbs.prototype, "y2", { get: function get() {
	                    return this._y2;
	                }, set: function set(y2) {
	                    this._y2 = y2;this._segmentChanged();
	                }, enumerable: true });
	
	            window.SVGPathSegCurvetoCubicRel = function (owningPathSegList, x, y, x1, y1, x2, y2) {
	                window.SVGPathSeg.call(this, window.SVGPathSeg.PATHSEG_CURVETO_CUBIC_REL, "c", owningPathSegList);
	                this._x = x;
	                this._y = y;
	                this._x1 = x1;
	                this._y1 = y1;
	                this._x2 = x2;
	                this._y2 = y2;
	            };
	            window.SVGPathSegCurvetoCubicRel.prototype = Object.create(window.SVGPathSeg.prototype);
	            window.SVGPathSegCurvetoCubicRel.prototype.toString = function () {
	                return "[object SVGPathSegCurvetoCubicRel]";
	            };
	            window.SVGPathSegCurvetoCubicRel.prototype._asPathString = function () {
	                return this.pathSegTypeAsLetter + " " + this._x1 + " " + this._y1 + " " + this._x2 + " " + this._y2 + " " + this._x + " " + this._y;
	            };
	            window.SVGPathSegCurvetoCubicRel.prototype.clone = function () {
	                return new window.SVGPathSegCurvetoCubicRel(undefined, this._x, this._y, this._x1, this._y1, this._x2, this._y2);
	            };
	            Object.defineProperty(window.SVGPathSegCurvetoCubicRel.prototype, "x", { get: function get() {
	                    return this._x;
	                }, set: function set(x) {
	                    this._x = x;this._segmentChanged();
	                }, enumerable: true });
	            Object.defineProperty(window.SVGPathSegCurvetoCubicRel.prototype, "y", { get: function get() {
	                    return this._y;
	                }, set: function set(y) {
	                    this._y = y;this._segmentChanged();
	                }, enumerable: true });
	            Object.defineProperty(window.SVGPathSegCurvetoCubicRel.prototype, "x1", { get: function get() {
	                    return this._x1;
	                }, set: function set(x1) {
	                    this._x1 = x1;this._segmentChanged();
	                }, enumerable: true });
	            Object.defineProperty(window.SVGPathSegCurvetoCubicRel.prototype, "y1", { get: function get() {
	                    return this._y1;
	                }, set: function set(y1) {
	                    this._y1 = y1;this._segmentChanged();
	                }, enumerable: true });
	            Object.defineProperty(window.SVGPathSegCurvetoCubicRel.prototype, "x2", { get: function get() {
	                    return this._x2;
	                }, set: function set(x2) {
	                    this._x2 = x2;this._segmentChanged();
	                }, enumerable: true });
	            Object.defineProperty(window.SVGPathSegCurvetoCubicRel.prototype, "y2", { get: function get() {
	                    return this._y2;
	                }, set: function set(y2) {
	                    this._y2 = y2;this._segmentChanged();
	                }, enumerable: true });
	
	            window.SVGPathSegCurvetoQuadraticAbs = function (owningPathSegList, x, y, x1, y1) {
	                window.SVGPathSeg.call(this, window.SVGPathSeg.PATHSEG_CURVETO_QUADRATIC_ABS, "Q", owningPathSegList);
	                this._x = x;
	                this._y = y;
	                this._x1 = x1;
	                this._y1 = y1;
	            };
	            window.SVGPathSegCurvetoQuadraticAbs.prototype = Object.create(window.SVGPathSeg.prototype);
	            window.SVGPathSegCurvetoQuadraticAbs.prototype.toString = function () {
	                return "[object SVGPathSegCurvetoQuadraticAbs]";
	            };
	            window.SVGPathSegCurvetoQuadraticAbs.prototype._asPathString = function () {
	                return this.pathSegTypeAsLetter + " " + this._x1 + " " + this._y1 + " " + this._x + " " + this._y;
	            };
	            window.SVGPathSegCurvetoQuadraticAbs.prototype.clone = function () {
	                return new window.SVGPathSegCurvetoQuadraticAbs(undefined, this._x, this._y, this._x1, this._y1);
	            };
	            Object.defineProperty(window.SVGPathSegCurvetoQuadraticAbs.prototype, "x", { get: function get() {
	                    return this._x;
	                }, set: function set(x) {
	                    this._x = x;this._segmentChanged();
	                }, enumerable: true });
	            Object.defineProperty(window.SVGPathSegCurvetoQuadraticAbs.prototype, "y", { get: function get() {
	                    return this._y;
	                }, set: function set(y) {
	                    this._y = y;this._segmentChanged();
	                }, enumerable: true });
	            Object.defineProperty(window.SVGPathSegCurvetoQuadraticAbs.prototype, "x1", { get: function get() {
	                    return this._x1;
	                }, set: function set(x1) {
	                    this._x1 = x1;this._segmentChanged();
	                }, enumerable: true });
	            Object.defineProperty(window.SVGPathSegCurvetoQuadraticAbs.prototype, "y1", { get: function get() {
	                    return this._y1;
	                }, set: function set(y1) {
	                    this._y1 = y1;this._segmentChanged();
	                }, enumerable: true });
	
	            window.SVGPathSegCurvetoQuadraticRel = function (owningPathSegList, x, y, x1, y1) {
	                window.SVGPathSeg.call(this, window.SVGPathSeg.PATHSEG_CURVETO_QUADRATIC_REL, "q", owningPathSegList);
	                this._x = x;
	                this._y = y;
	                this._x1 = x1;
	                this._y1 = y1;
	            };
	            window.SVGPathSegCurvetoQuadraticRel.prototype = Object.create(window.SVGPathSeg.prototype);
	            window.SVGPathSegCurvetoQuadraticRel.prototype.toString = function () {
	                return "[object SVGPathSegCurvetoQuadraticRel]";
	            };
	            window.SVGPathSegCurvetoQuadraticRel.prototype._asPathString = function () {
	                return this.pathSegTypeAsLetter + " " + this._x1 + " " + this._y1 + " " + this._x + " " + this._y;
	            };
	            window.SVGPathSegCurvetoQuadraticRel.prototype.clone = function () {
	                return new window.SVGPathSegCurvetoQuadraticRel(undefined, this._x, this._y, this._x1, this._y1);
	            };
	            Object.defineProperty(window.SVGPathSegCurvetoQuadraticRel.prototype, "x", { get: function get() {
	                    return this._x;
	                }, set: function set(x) {
	                    this._x = x;this._segmentChanged();
	                }, enumerable: true });
	            Object.defineProperty(window.SVGPathSegCurvetoQuadraticRel.prototype, "y", { get: function get() {
	                    return this._y;
	                }, set: function set(y) {
	                    this._y = y;this._segmentChanged();
	                }, enumerable: true });
	            Object.defineProperty(window.SVGPathSegCurvetoQuadraticRel.prototype, "x1", { get: function get() {
	                    return this._x1;
	                }, set: function set(x1) {
	                    this._x1 = x1;this._segmentChanged();
	                }, enumerable: true });
	            Object.defineProperty(window.SVGPathSegCurvetoQuadraticRel.prototype, "y1", { get: function get() {
	                    return this._y1;
	                }, set: function set(y1) {
	                    this._y1 = y1;this._segmentChanged();
	                }, enumerable: true });
	
	            window.SVGPathSegArcAbs = function (owningPathSegList, x, y, r1, r2, angle, largeArcFlag, sweepFlag) {
	                window.SVGPathSeg.call(this, window.SVGPathSeg.PATHSEG_ARC_ABS, "A", owningPathSegList);
	                this._x = x;
	                this._y = y;
	                this._r1 = r1;
	                this._r2 = r2;
	                this._angle = angle;
	                this._largeArcFlag = largeArcFlag;
	                this._sweepFlag = sweepFlag;
	            };
	            window.SVGPathSegArcAbs.prototype = Object.create(window.SVGPathSeg.prototype);
	            window.SVGPathSegArcAbs.prototype.toString = function () {
	                return "[object SVGPathSegArcAbs]";
	            };
	            window.SVGPathSegArcAbs.prototype._asPathString = function () {
	                return this.pathSegTypeAsLetter + " " + this._r1 + " " + this._r2 + " " + this._angle + " " + (this._largeArcFlag ? "1" : "0") + " " + (this._sweepFlag ? "1" : "0") + " " + this._x + " " + this._y;
	            };
	            window.SVGPathSegArcAbs.prototype.clone = function () {
	                return new window.SVGPathSegArcAbs(undefined, this._x, this._y, this._r1, this._r2, this._angle, this._largeArcFlag, this._sweepFlag);
	            };
	            Object.defineProperty(window.SVGPathSegArcAbs.prototype, "x", { get: function get() {
	                    return this._x;
	                }, set: function set(x) {
	                    this._x = x;this._segmentChanged();
	                }, enumerable: true });
	            Object.defineProperty(window.SVGPathSegArcAbs.prototype, "y", { get: function get() {
	                    return this._y;
	                }, set: function set(y) {
	                    this._y = y;this._segmentChanged();
	                }, enumerable: true });
	            Object.defineProperty(window.SVGPathSegArcAbs.prototype, "r1", { get: function get() {
	                    return this._r1;
	                }, set: function set(r1) {
	                    this._r1 = r1;this._segmentChanged();
	                }, enumerable: true });
	            Object.defineProperty(window.SVGPathSegArcAbs.prototype, "r2", { get: function get() {
	                    return this._r2;
	                }, set: function set(r2) {
	                    this._r2 = r2;this._segmentChanged();
	                }, enumerable: true });
	            Object.defineProperty(window.SVGPathSegArcAbs.prototype, "angle", { get: function get() {
	                    return this._angle;
	                }, set: function set(angle) {
	                    this._angle = angle;this._segmentChanged();
	                }, enumerable: true });
	            Object.defineProperty(window.SVGPathSegArcAbs.prototype, "largeArcFlag", { get: function get() {
	                    return this._largeArcFlag;
	                }, set: function set(largeArcFlag) {
	                    this._largeArcFlag = largeArcFlag;this._segmentChanged();
	                }, enumerable: true });
	            Object.defineProperty(window.SVGPathSegArcAbs.prototype, "sweepFlag", { get: function get() {
	                    return this._sweepFlag;
	                }, set: function set(sweepFlag) {
	                    this._sweepFlag = sweepFlag;this._segmentChanged();
	                }, enumerable: true });
	
	            window.SVGPathSegArcRel = function (owningPathSegList, x, y, r1, r2, angle, largeArcFlag, sweepFlag) {
	                window.SVGPathSeg.call(this, window.SVGPathSeg.PATHSEG_ARC_REL, "a", owningPathSegList);
	                this._x = x;
	                this._y = y;
	                this._r1 = r1;
	                this._r2 = r2;
	                this._angle = angle;
	                this._largeArcFlag = largeArcFlag;
	                this._sweepFlag = sweepFlag;
	            };
	            window.SVGPathSegArcRel.prototype = Object.create(window.SVGPathSeg.prototype);
	            window.SVGPathSegArcRel.prototype.toString = function () {
	                return "[object SVGPathSegArcRel]";
	            };
	            window.SVGPathSegArcRel.prototype._asPathString = function () {
	                return this.pathSegTypeAsLetter + " " + this._r1 + " " + this._r2 + " " + this._angle + " " + (this._largeArcFlag ? "1" : "0") + " " + (this._sweepFlag ? "1" : "0") + " " + this._x + " " + this._y;
	            };
	            window.SVGPathSegArcRel.prototype.clone = function () {
	                return new window.SVGPathSegArcRel(undefined, this._x, this._y, this._r1, this._r2, this._angle, this._largeArcFlag, this._sweepFlag);
	            };
	            Object.defineProperty(window.SVGPathSegArcRel.prototype, "x", { get: function get() {
	                    return this._x;
	                }, set: function set(x) {
	                    this._x = x;this._segmentChanged();
	                }, enumerable: true });
	            Object.defineProperty(window.SVGPathSegArcRel.prototype, "y", { get: function get() {
	                    return this._y;
	                }, set: function set(y) {
	                    this._y = y;this._segmentChanged();
	                }, enumerable: true });
	            Object.defineProperty(window.SVGPathSegArcRel.prototype, "r1", { get: function get() {
	                    return this._r1;
	                }, set: function set(r1) {
	                    this._r1 = r1;this._segmentChanged();
	                }, enumerable: true });
	            Object.defineProperty(window.SVGPathSegArcRel.prototype, "r2", { get: function get() {
	                    return this._r2;
	                }, set: function set(r2) {
	                    this._r2 = r2;this._segmentChanged();
	                }, enumerable: true });
	            Object.defineProperty(window.SVGPathSegArcRel.prototype, "angle", { get: function get() {
	                    return this._angle;
	                }, set: function set(angle) {
	                    this._angle = angle;this._segmentChanged();
	                }, enumerable: true });
	            Object.defineProperty(window.SVGPathSegArcRel.prototype, "largeArcFlag", { get: function get() {
	                    return this._largeArcFlag;
	                }, set: function set(largeArcFlag) {
	                    this._largeArcFlag = largeArcFlag;this._segmentChanged();
	                }, enumerable: true });
	            Object.defineProperty(window.SVGPathSegArcRel.prototype, "sweepFlag", { get: function get() {
	                    return this._sweepFlag;
	                }, set: function set(sweepFlag) {
	                    this._sweepFlag = sweepFlag;this._segmentChanged();
	                }, enumerable: true });
	
	            window.SVGPathSegLinetoHorizontalAbs = function (owningPathSegList, x) {
	                window.SVGPathSeg.call(this, window.SVGPathSeg.PATHSEG_LINETO_HORIZONTAL_ABS, "H", owningPathSegList);
	                this._x = x;
	            };
	            window.SVGPathSegLinetoHorizontalAbs.prototype = Object.create(window.SVGPathSeg.prototype);
	            window.SVGPathSegLinetoHorizontalAbs.prototype.toString = function () {
	                return "[object SVGPathSegLinetoHorizontalAbs]";
	            };
	            window.SVGPathSegLinetoHorizontalAbs.prototype._asPathString = function () {
	                return this.pathSegTypeAsLetter + " " + this._x;
	            };
	            window.SVGPathSegLinetoHorizontalAbs.prototype.clone = function () {
	                return new window.SVGPathSegLinetoHorizontalAbs(undefined, this._x);
	            };
	            Object.defineProperty(window.SVGPathSegLinetoHorizontalAbs.prototype, "x", { get: function get() {
	                    return this._x;
	                }, set: function set(x) {
	                    this._x = x;this._segmentChanged();
	                }, enumerable: true });
	
	            window.SVGPathSegLinetoHorizontalRel = function (owningPathSegList, x) {
	                window.SVGPathSeg.call(this, window.SVGPathSeg.PATHSEG_LINETO_HORIZONTAL_REL, "h", owningPathSegList);
	                this._x = x;
	            };
	            window.SVGPathSegLinetoHorizontalRel.prototype = Object.create(window.SVGPathSeg.prototype);
	            window.SVGPathSegLinetoHorizontalRel.prototype.toString = function () {
	                return "[object SVGPathSegLinetoHorizontalRel]";
	            };
	            window.SVGPathSegLinetoHorizontalRel.prototype._asPathString = function () {
	                return this.pathSegTypeAsLetter + " " + this._x;
	            };
	            window.SVGPathSegLinetoHorizontalRel.prototype.clone = function () {
	                return new window.SVGPathSegLinetoHorizontalRel(undefined, this._x);
	            };
	            Object.defineProperty(window.SVGPathSegLinetoHorizontalRel.prototype, "x", { get: function get() {
	                    return this._x;
	                }, set: function set(x) {
	                    this._x = x;this._segmentChanged();
	                }, enumerable: true });
	
	            window.SVGPathSegLinetoVerticalAbs = function (owningPathSegList, y) {
	                window.SVGPathSeg.call(this, window.SVGPathSeg.PATHSEG_LINETO_VERTICAL_ABS, "V", owningPathSegList);
	                this._y = y;
	            };
	            window.SVGPathSegLinetoVerticalAbs.prototype = Object.create(window.SVGPathSeg.prototype);
	            window.SVGPathSegLinetoVerticalAbs.prototype.toString = function () {
	                return "[object SVGPathSegLinetoVerticalAbs]";
	            };
	            window.SVGPathSegLinetoVerticalAbs.prototype._asPathString = function () {
	                return this.pathSegTypeAsLetter + " " + this._y;
	            };
	            window.SVGPathSegLinetoVerticalAbs.prototype.clone = function () {
	                return new window.SVGPathSegLinetoVerticalAbs(undefined, this._y);
	            };
	            Object.defineProperty(window.SVGPathSegLinetoVerticalAbs.prototype, "y", { get: function get() {
	                    return this._y;
	                }, set: function set(y) {
	                    this._y = y;this._segmentChanged();
	                }, enumerable: true });
	
	            window.SVGPathSegLinetoVerticalRel = function (owningPathSegList, y) {
	                window.SVGPathSeg.call(this, window.SVGPathSeg.PATHSEG_LINETO_VERTICAL_REL, "v", owningPathSegList);
	                this._y = y;
	            };
	            window.SVGPathSegLinetoVerticalRel.prototype = Object.create(window.SVGPathSeg.prototype);
	            window.SVGPathSegLinetoVerticalRel.prototype.toString = function () {
	                return "[object SVGPathSegLinetoVerticalRel]";
	            };
	            window.SVGPathSegLinetoVerticalRel.prototype._asPathString = function () {
	                return this.pathSegTypeAsLetter + " " + this._y;
	            };
	            window.SVGPathSegLinetoVerticalRel.prototype.clone = function () {
	                return new window.SVGPathSegLinetoVerticalRel(undefined, this._y);
	            };
	            Object.defineProperty(window.SVGPathSegLinetoVerticalRel.prototype, "y", { get: function get() {
	                    return this._y;
	                }, set: function set(y) {
	                    this._y = y;this._segmentChanged();
	                }, enumerable: true });
	
	            window.SVGPathSegCurvetoCubicSmoothAbs = function (owningPathSegList, x, y, x2, y2) {
	                window.SVGPathSeg.call(this, window.SVGPathSeg.PATHSEG_CURVETO_CUBIC_SMOOTH_ABS, "S", owningPathSegList);
	                this._x = x;
	                this._y = y;
	                this._x2 = x2;
	                this._y2 = y2;
	            };
	            window.SVGPathSegCurvetoCubicSmoothAbs.prototype = Object.create(window.SVGPathSeg.prototype);
	            window.SVGPathSegCurvetoCubicSmoothAbs.prototype.toString = function () {
	                return "[object SVGPathSegCurvetoCubicSmoothAbs]";
	            };
	            window.SVGPathSegCurvetoCubicSmoothAbs.prototype._asPathString = function () {
	                return this.pathSegTypeAsLetter + " " + this._x2 + " " + this._y2 + " " + this._x + " " + this._y;
	            };
	            window.SVGPathSegCurvetoCubicSmoothAbs.prototype.clone = function () {
	                return new window.SVGPathSegCurvetoCubicSmoothAbs(undefined, this._x, this._y, this._x2, this._y2);
	            };
	            Object.defineProperty(window.SVGPathSegCurvetoCubicSmoothAbs.prototype, "x", { get: function get() {
	                    return this._x;
	                }, set: function set(x) {
	                    this._x = x;this._segmentChanged();
	                }, enumerable: true });
	            Object.defineProperty(window.SVGPathSegCurvetoCubicSmoothAbs.prototype, "y", { get: function get() {
	                    return this._y;
	                }, set: function set(y) {
	                    this._y = y;this._segmentChanged();
	                }, enumerable: true });
	            Object.defineProperty(window.SVGPathSegCurvetoCubicSmoothAbs.prototype, "x2", { get: function get() {
	                    return this._x2;
	                }, set: function set(x2) {
	                    this._x2 = x2;this._segmentChanged();
	                }, enumerable: true });
	            Object.defineProperty(window.SVGPathSegCurvetoCubicSmoothAbs.prototype, "y2", { get: function get() {
	                    return this._y2;
	                }, set: function set(y2) {
	                    this._y2 = y2;this._segmentChanged();
	                }, enumerable: true });
	
	            window.SVGPathSegCurvetoCubicSmoothRel = function (owningPathSegList, x, y, x2, y2) {
	                window.SVGPathSeg.call(this, window.SVGPathSeg.PATHSEG_CURVETO_CUBIC_SMOOTH_REL, "s", owningPathSegList);
	                this._x = x;
	                this._y = y;
	                this._x2 = x2;
	                this._y2 = y2;
	            };
	            window.SVGPathSegCurvetoCubicSmoothRel.prototype = Object.create(window.SVGPathSeg.prototype);
	            window.SVGPathSegCurvetoCubicSmoothRel.prototype.toString = function () {
	                return "[object SVGPathSegCurvetoCubicSmoothRel]";
	            };
	            window.SVGPathSegCurvetoCubicSmoothRel.prototype._asPathString = function () {
	                return this.pathSegTypeAsLetter + " " + this._x2 + " " + this._y2 + " " + this._x + " " + this._y;
	            };
	            window.SVGPathSegCurvetoCubicSmoothRel.prototype.clone = function () {
	                return new window.SVGPathSegCurvetoCubicSmoothRel(undefined, this._x, this._y, this._x2, this._y2);
	            };
	            Object.defineProperty(window.SVGPathSegCurvetoCubicSmoothRel.prototype, "x", { get: function get() {
	                    return this._x;
	                }, set: function set(x) {
	                    this._x = x;this._segmentChanged();
	                }, enumerable: true });
	            Object.defineProperty(window.SVGPathSegCurvetoCubicSmoothRel.prototype, "y", { get: function get() {
	                    return this._y;
	                }, set: function set(y) {
	                    this._y = y;this._segmentChanged();
	                }, enumerable: true });
	            Object.defineProperty(window.SVGPathSegCurvetoCubicSmoothRel.prototype, "x2", { get: function get() {
	                    return this._x2;
	                }, set: function set(x2) {
	                    this._x2 = x2;this._segmentChanged();
	                }, enumerable: true });
	            Object.defineProperty(window.SVGPathSegCurvetoCubicSmoothRel.prototype, "y2", { get: function get() {
	                    return this._y2;
	                }, set: function set(y2) {
	                    this._y2 = y2;this._segmentChanged();
	                }, enumerable: true });
	
	            window.SVGPathSegCurvetoQuadraticSmoothAbs = function (owningPathSegList, x, y) {
	                window.SVGPathSeg.call(this, window.SVGPathSeg.PATHSEG_CURVETO_QUADRATIC_SMOOTH_ABS, "T", owningPathSegList);
	                this._x = x;
	                this._y = y;
	            };
	            window.SVGPathSegCurvetoQuadraticSmoothAbs.prototype = Object.create(window.SVGPathSeg.prototype);
	            window.SVGPathSegCurvetoQuadraticSmoothAbs.prototype.toString = function () {
	                return "[object SVGPathSegCurvetoQuadraticSmoothAbs]";
	            };
	            window.SVGPathSegCurvetoQuadraticSmoothAbs.prototype._asPathString = function () {
	                return this.pathSegTypeAsLetter + " " + this._x + " " + this._y;
	            };
	            window.SVGPathSegCurvetoQuadraticSmoothAbs.prototype.clone = function () {
	                return new window.SVGPathSegCurvetoQuadraticSmoothAbs(undefined, this._x, this._y);
	            };
	            Object.defineProperty(window.SVGPathSegCurvetoQuadraticSmoothAbs.prototype, "x", { get: function get() {
	                    return this._x;
	                }, set: function set(x) {
	                    this._x = x;this._segmentChanged();
	                }, enumerable: true });
	            Object.defineProperty(window.SVGPathSegCurvetoQuadraticSmoothAbs.prototype, "y", { get: function get() {
	                    return this._y;
	                }, set: function set(y) {
	                    this._y = y;this._segmentChanged();
	                }, enumerable: true });
	
	            window.SVGPathSegCurvetoQuadraticSmoothRel = function (owningPathSegList, x, y) {
	                window.SVGPathSeg.call(this, window.SVGPathSeg.PATHSEG_CURVETO_QUADRATIC_SMOOTH_REL, "t", owningPathSegList);
	                this._x = x;
	                this._y = y;
	            };
	            window.SVGPathSegCurvetoQuadraticSmoothRel.prototype = Object.create(window.SVGPathSeg.prototype);
	            window.SVGPathSegCurvetoQuadraticSmoothRel.prototype.toString = function () {
	                return "[object SVGPathSegCurvetoQuadraticSmoothRel]";
	            };
	            window.SVGPathSegCurvetoQuadraticSmoothRel.prototype._asPathString = function () {
	                return this.pathSegTypeAsLetter + " " + this._x + " " + this._y;
	            };
	            window.SVGPathSegCurvetoQuadraticSmoothRel.prototype.clone = function () {
	                return new window.SVGPathSegCurvetoQuadraticSmoothRel(undefined, this._x, this._y);
	            };
	            Object.defineProperty(window.SVGPathSegCurvetoQuadraticSmoothRel.prototype, "x", { get: function get() {
	                    return this._x;
	                }, set: function set(x) {
	                    this._x = x;this._segmentChanged();
	                }, enumerable: true });
	            Object.defineProperty(window.SVGPathSegCurvetoQuadraticSmoothRel.prototype, "y", { get: function get() {
	                    return this._y;
	                }, set: function set(y) {
	                    this._y = y;this._segmentChanged();
	                }, enumerable: true });
	
	            // Add createSVGPathSeg* functions to window.SVGPathElement.
	            // Spec: http://www.w3.org/TR/SVG11/single-page.html#paths-Interfacewindow.SVGPathElement.
	            window.SVGPathElement.prototype.createSVGPathSegClosePath = function () {
	                return new window.SVGPathSegClosePath(undefined);
	            };
	            window.SVGPathElement.prototype.createSVGPathSegMovetoAbs = function (x, y) {
	                return new window.SVGPathSegMovetoAbs(undefined, x, y);
	            };
	            window.SVGPathElement.prototype.createSVGPathSegMovetoRel = function (x, y) {
	                return new window.SVGPathSegMovetoRel(undefined, x, y);
	            };
	            window.SVGPathElement.prototype.createSVGPathSegLinetoAbs = function (x, y) {
	                return new window.SVGPathSegLinetoAbs(undefined, x, y);
	            };
	            window.SVGPathElement.prototype.createSVGPathSegLinetoRel = function (x, y) {
	                return new window.SVGPathSegLinetoRel(undefined, x, y);
	            };
	            window.SVGPathElement.prototype.createSVGPathSegCurvetoCubicAbs = function (x, y, x1, y1, x2, y2) {
	                return new window.SVGPathSegCurvetoCubicAbs(undefined, x, y, x1, y1, x2, y2);
	            };
	            window.SVGPathElement.prototype.createSVGPathSegCurvetoCubicRel = function (x, y, x1, y1, x2, y2) {
	                return new window.SVGPathSegCurvetoCubicRel(undefined, x, y, x1, y1, x2, y2);
	            };
	            window.SVGPathElement.prototype.createSVGPathSegCurvetoQuadraticAbs = function (x, y, x1, y1) {
	                return new window.SVGPathSegCurvetoQuadraticAbs(undefined, x, y, x1, y1);
	            };
	            window.SVGPathElement.prototype.createSVGPathSegCurvetoQuadraticRel = function (x, y, x1, y1) {
	                return new window.SVGPathSegCurvetoQuadraticRel(undefined, x, y, x1, y1);
	            };
	            window.SVGPathElement.prototype.createSVGPathSegArcAbs = function (x, y, r1, r2, angle, largeArcFlag, sweepFlag) {
	                return new window.SVGPathSegArcAbs(undefined, x, y, r1, r2, angle, largeArcFlag, sweepFlag);
	            };
	            window.SVGPathElement.prototype.createSVGPathSegArcRel = function (x, y, r1, r2, angle, largeArcFlag, sweepFlag) {
	                return new window.SVGPathSegArcRel(undefined, x, y, r1, r2, angle, largeArcFlag, sweepFlag);
	            };
	            window.SVGPathElement.prototype.createSVGPathSegLinetoHorizontalAbs = function (x) {
	                return new window.SVGPathSegLinetoHorizontalAbs(undefined, x);
	            };
	            window.SVGPathElement.prototype.createSVGPathSegLinetoHorizontalRel = function (x) {
	                return new window.SVGPathSegLinetoHorizontalRel(undefined, x);
	            };
	            window.SVGPathElement.prototype.createSVGPathSegLinetoVerticalAbs = function (y) {
	                return new window.SVGPathSegLinetoVerticalAbs(undefined, y);
	            };
	            window.SVGPathElement.prototype.createSVGPathSegLinetoVerticalRel = function (y) {
	                return new window.SVGPathSegLinetoVerticalRel(undefined, y);
	            };
	            window.SVGPathElement.prototype.createSVGPathSegCurvetoCubicSmoothAbs = function (x, y, x2, y2) {
	                return new window.SVGPathSegCurvetoCubicSmoothAbs(undefined, x, y, x2, y2);
	            };
	            window.SVGPathElement.prototype.createSVGPathSegCurvetoCubicSmoothRel = function (x, y, x2, y2) {
	                return new window.SVGPathSegCurvetoCubicSmoothRel(undefined, x, y, x2, y2);
	            };
	            window.SVGPathElement.prototype.createSVGPathSegCurvetoQuadraticSmoothAbs = function (x, y) {
	                return new window.SVGPathSegCurvetoQuadraticSmoothAbs(undefined, x, y);
	            };
	            window.SVGPathElement.prototype.createSVGPathSegCurvetoQuadraticSmoothRel = function (x, y) {
	                return new window.SVGPathSegCurvetoQuadraticSmoothRel(undefined, x, y);
	            };
	
	            if (!("getPathSegAtLength" in window.SVGPathElement.prototype)) {
	                // Add getPathSegAtLength to SVGPathElement.
	                // Spec: https://www.w3.org/TR/SVG11/single-page.html#paths-__svg__SVGPathElement__getPathSegAtLength
	                // This polyfill requires SVGPathElement.getTotalLength to implement the distance-along-a-path algorithm.
	                window.SVGPathElement.prototype.getPathSegAtLength = function (distance) {
	                    if (distance === undefined || !isFinite(distance)) throw "Invalid arguments.";
	
	                    var measurementElement = document.createElementNS("http://www.w3.org/2000/svg", "path");
	                    measurementElement.setAttribute("d", this.getAttribute("d"));
	                    var lastPathSegment = measurementElement.pathSegList.numberOfItems - 1;
	
	                    // If the path is empty, return 0.
	                    if (lastPathSegment <= 0) return 0;
	
	                    do {
	                        measurementElement.pathSegList.removeItem(lastPathSegment);
	                        if (distance > measurementElement.getTotalLength()) break;
	                        lastPathSegment--;
	                    } while (lastPathSegment > 0);
	                    return lastPathSegment;
	                };
	            }
	        }
	
	        if (!("SVGPathSegList" in window)) {
	            // Spec: http://www.w3.org/TR/SVG11/single-page.html#paths-InterfaceSVGPathSegList
	            window.SVGPathSegList = function (pathElement) {
	                this._pathElement = pathElement;
	                this._list = this._parsePath(this._pathElement.getAttribute("d"));
	
	                // Use a MutationObserver to catch changes to the path's "d" attribute.
	                this._mutationObserverConfig = { "attributes": true, "attributeFilter": ["d"] };
	                this._pathElementMutationObserver = new MutationObserver(this._updateListFromPathMutations.bind(this));
	                this._pathElementMutationObserver.observe(this._pathElement, this._mutationObserverConfig);
	            };
	
	            window.SVGPathSegList.prototype.classname = "SVGPathSegList";
	
	            Object.defineProperty(window.SVGPathSegList.prototype, "numberOfItems", {
	                get: function get() {
	                    this._checkPathSynchronizedToList();
	                    return this._list.length;
	                },
	                enumerable: true
	            });
	
	            // Add the pathSegList accessors to window.SVGPathElement.
	            // Spec: http://www.w3.org/TR/SVG11/single-page.html#paths-InterfaceSVGAnimatedPathData
	            Object.defineProperty(window.SVGPathElement.prototype, "pathSegList", {
	                get: function get() {
	                    if (!this._pathSegList) this._pathSegList = new window.SVGPathSegList(this);
	                    return this._pathSegList;
	                },
	                enumerable: true
	            });
	            // FIXME: The following are not implemented and simply return window.SVGPathElement.pathSegList.
	            Object.defineProperty(window.SVGPathElement.prototype, "normalizedPathSegList", { get: function get() {
	                    return this.pathSegList;
	                }, enumerable: true });
	            Object.defineProperty(window.SVGPathElement.prototype, "animatedPathSegList", { get: function get() {
	                    return this.pathSegList;
	                }, enumerable: true });
	            Object.defineProperty(window.SVGPathElement.prototype, "animatedNormalizedPathSegList", { get: function get() {
	                    return this.pathSegList;
	                }, enumerable: true });
	
	            // Process any pending mutations to the path element and update the list as needed.
	            // This should be the first call of all public functions and is needed because
	            // MutationObservers are not synchronous so we can have pending asynchronous mutations.
	            window.SVGPathSegList.prototype._checkPathSynchronizedToList = function () {
	                this._updateListFromPathMutations(this._pathElementMutationObserver.takeRecords());
	            };
	
	            window.SVGPathSegList.prototype._updateListFromPathMutations = function (mutationRecords) {
	                if (!this._pathElement) return;
	                var hasPathMutations = false;
	                mutationRecords.forEach(function (record) {
	                    if (record.attributeName == "d") hasPathMutations = true;
	                });
	                if (hasPathMutations) this._list = this._parsePath(this._pathElement.getAttribute("d"));
	            };
	
	            // Serialize the list and update the path's 'd' attribute.
	            window.SVGPathSegList.prototype._writeListToPath = function () {
	                this._pathElementMutationObserver.disconnect();
	                this._pathElement.setAttribute("d", window.SVGPathSegList._pathSegArrayAsString(this._list));
	                this._pathElementMutationObserver.observe(this._pathElement, this._mutationObserverConfig);
	            };
	
	            // When a path segment changes the list needs to be synchronized back to the path element.
	            window.SVGPathSegList.prototype.segmentChanged = function (pathSeg) {
	                this._writeListToPath();
	            };
	
	            window.SVGPathSegList.prototype.clear = function () {
	                this._checkPathSynchronizedToList();
	
	                this._list.forEach(function (pathSeg) {
	                    pathSeg._owningPathSegList = null;
	                });
	                this._list = [];
	                this._writeListToPath();
	            };
	
	            window.SVGPathSegList.prototype.initialize = function (newItem) {
	                this._checkPathSynchronizedToList();
	
	                this._list = [newItem];
	                newItem._owningPathSegList = this;
	                this._writeListToPath();
	                return newItem;
	            };
	
	            window.SVGPathSegList.prototype._checkValidIndex = function (index) {
	                if (isNaN(index) || index < 0 || index >= this.numberOfItems) throw "INDEX_SIZE_ERR";
	            };
	
	            window.SVGPathSegList.prototype.getItem = function (index) {
	                this._checkPathSynchronizedToList();
	
	                this._checkValidIndex(index);
	                return this._list[index];
	            };
	
	            window.SVGPathSegList.prototype.insertItemBefore = function (newItem, index) {
	                this._checkPathSynchronizedToList();
	
	                // Spec: If the index is greater than or equal to numberOfItems, then the new item is appended to the end of the list.
	                if (index > this.numberOfItems) index = this.numberOfItems;
	                if (newItem._owningPathSegList) {
	                    // SVG2 spec says to make a copy.
	                    newItem = newItem.clone();
	                }
	                this._list.splice(index, 0, newItem);
	                newItem._owningPathSegList = this;
	                this._writeListToPath();
	                return newItem;
	            };
	
	            window.SVGPathSegList.prototype.replaceItem = function (newItem, index) {
	                this._checkPathSynchronizedToList();
	
	                if (newItem._owningPathSegList) {
	                    // SVG2 spec says to make a copy.
	                    newItem = newItem.clone();
	                }
	                this._checkValidIndex(index);
	                this._list[index] = newItem;
	                newItem._owningPathSegList = this;
	                this._writeListToPath();
	                return newItem;
	            };
	
	            window.SVGPathSegList.prototype.removeItem = function (index) {
	                this._checkPathSynchronizedToList();
	
	                this._checkValidIndex(index);
	                var item = this._list[index];
	                this._list.splice(index, 1);
	                this._writeListToPath();
	                return item;
	            };
	
	            window.SVGPathSegList.prototype.appendItem = function (newItem) {
	                this._checkPathSynchronizedToList();
	
	                if (newItem._owningPathSegList) {
	                    // SVG2 spec says to make a copy.
	                    newItem = newItem.clone();
	                }
	                this._list.push(newItem);
	                newItem._owningPathSegList = this;
	                // TODO: Optimize this to just append to the existing attribute.
	                this._writeListToPath();
	                return newItem;
	            };
	
	            window.SVGPathSegList._pathSegArrayAsString = function (pathSegArray) {
	                var string = "";
	                var first = true;
	                pathSegArray.forEach(function (pathSeg) {
	                    if (first) {
	                        first = false;
	                        string += pathSeg._asPathString();
	                    } else {
	                        string += " " + pathSeg._asPathString();
	                    }
	                });
	                return string;
	            };
	
	            // This closely follows SVGPathParser::parsePath from Source/core/svg/SVGPathParser.cpp.
	            window.SVGPathSegList.prototype._parsePath = function (string) {
	                if (!string || string.length == 0) return [];
	
	                var owningPathSegList = this;
	
	                var Builder = function Builder() {
	                    this.pathSegList = [];
	                };
	
	                Builder.prototype.appendSegment = function (pathSeg) {
	                    this.pathSegList.push(pathSeg);
	                };
	
	                var Source = function Source(string) {
	                    this._string = string;
	                    this._currentIndex = 0;
	                    this._endIndex = this._string.length;
	                    this._previousCommand = window.SVGPathSeg.PATHSEG_UNKNOWN;
	
	                    this._skipOptionalSpaces();
	                };
	
	                Source.prototype._isCurrentSpace = function () {
	                    var character = this._string[this._currentIndex];
	                    return character <= " " && (character == " " || character == "\n" || character == "\t" || character == "\r" || character == "\f");
	                };
	
	                Source.prototype._skipOptionalSpaces = function () {
	                    while (this._currentIndex < this._endIndex && this._isCurrentSpace()) {
	                        this._currentIndex++;
	                    }return this._currentIndex < this._endIndex;
	                };
	
	                Source.prototype._skipOptionalSpacesOrDelimiter = function () {
	                    if (this._currentIndex < this._endIndex && !this._isCurrentSpace() && this._string.charAt(this._currentIndex) != ",") return false;
	                    if (this._skipOptionalSpaces()) {
	                        if (this._currentIndex < this._endIndex && this._string.charAt(this._currentIndex) == ",") {
	                            this._currentIndex++;
	                            this._skipOptionalSpaces();
	                        }
	                    }
	                    return this._currentIndex < this._endIndex;
	                };
	
	                Source.prototype.hasMoreData = function () {
	                    return this._currentIndex < this._endIndex;
	                };
	
	                Source.prototype.peekSegmentType = function () {
	                    var lookahead = this._string[this._currentIndex];
	                    return this._pathSegTypeFromChar(lookahead);
	                };
	
	                Source.prototype._pathSegTypeFromChar = function (lookahead) {
	                    switch (lookahead) {
	                        case "Z":
	                        case "z":
	                            return window.SVGPathSeg.PATHSEG_CLOSEPATH;
	                        case "M":
	                            return window.SVGPathSeg.PATHSEG_MOVETO_ABS;
	                        case "m":
	                            return window.SVGPathSeg.PATHSEG_MOVETO_REL;
	                        case "L":
	                            return window.SVGPathSeg.PATHSEG_LINETO_ABS;
	                        case "l":
	                            return window.SVGPathSeg.PATHSEG_LINETO_REL;
	                        case "C":
	                            return window.SVGPathSeg.PATHSEG_CURVETO_CUBIC_ABS;
	                        case "c":
	                            return window.SVGPathSeg.PATHSEG_CURVETO_CUBIC_REL;
	                        case "Q":
	                            return window.SVGPathSeg.PATHSEG_CURVETO_QUADRATIC_ABS;
	                        case "q":
	                            return window.SVGPathSeg.PATHSEG_CURVETO_QUADRATIC_REL;
	                        case "A":
	                            return window.SVGPathSeg.PATHSEG_ARC_ABS;
	                        case "a":
	                            return window.SVGPathSeg.PATHSEG_ARC_REL;
	                        case "H":
	                            return window.SVGPathSeg.PATHSEG_LINETO_HORIZONTAL_ABS;
	                        case "h":
	                            return window.SVGPathSeg.PATHSEG_LINETO_HORIZONTAL_REL;
	                        case "V":
	                            return window.SVGPathSeg.PATHSEG_LINETO_VERTICAL_ABS;
	                        case "v":
	                            return window.SVGPathSeg.PATHSEG_LINETO_VERTICAL_REL;
	                        case "S":
	                            return window.SVGPathSeg.PATHSEG_CURVETO_CUBIC_SMOOTH_ABS;
	                        case "s":
	                            return window.SVGPathSeg.PATHSEG_CURVETO_CUBIC_SMOOTH_REL;
	                        case "T":
	                            return window.SVGPathSeg.PATHSEG_CURVETO_QUADRATIC_SMOOTH_ABS;
	                        case "t":
	                            return window.SVGPathSeg.PATHSEG_CURVETO_QUADRATIC_SMOOTH_REL;
	                        default:
	                            return window.SVGPathSeg.PATHSEG_UNKNOWN;
	                    }
	                };
	
	                Source.prototype._nextCommandHelper = function (lookahead, previousCommand) {
	                    // Check for remaining coordinates in the current command.
	                    if ((lookahead == "+" || lookahead == "-" || lookahead == "." || lookahead >= "0" && lookahead <= "9") && previousCommand != window.SVGPathSeg.PATHSEG_CLOSEPATH) {
	                        if (previousCommand == window.SVGPathSeg.PATHSEG_MOVETO_ABS) return window.SVGPathSeg.PATHSEG_LINETO_ABS;
	                        if (previousCommand == window.SVGPathSeg.PATHSEG_MOVETO_REL) return window.SVGPathSeg.PATHSEG_LINETO_REL;
	                        return previousCommand;
	                    }
	                    return window.SVGPathSeg.PATHSEG_UNKNOWN;
	                };
	
	                Source.prototype.initialCommandIsMoveTo = function () {
	                    // If the path is empty it is still valid, so return true.
	                    if (!this.hasMoreData()) return true;
	                    var command = this.peekSegmentType();
	                    // Path must start with moveTo.
	                    return command == window.SVGPathSeg.PATHSEG_MOVETO_ABS || command == window.SVGPathSeg.PATHSEG_MOVETO_REL;
	                };
	
	                // Parse a number from an SVG path. This very closely follows genericParseNumber(...) from Source/core/svg/SVGParserUtilities.cpp.
	                // Spec: http://www.w3.org/TR/SVG11/single-page.html#paths-PathDataBNF
	                Source.prototype._parseNumber = function () {
	                    var exponent = 0;
	                    var integer = 0;
	                    var frac = 1;
	                    var decimal = 0;
	                    var sign = 1;
	                    var expsign = 1;
	
	                    var startIndex = this._currentIndex;
	
	                    this._skipOptionalSpaces();
	
	                    // Read the sign.
	                    if (this._currentIndex < this._endIndex && this._string.charAt(this._currentIndex) == "+") this._currentIndex++;else if (this._currentIndex < this._endIndex && this._string.charAt(this._currentIndex) == "-") {
	                        this._currentIndex++;
	                        sign = -1;
	                    }
	
	                    if (this._currentIndex == this._endIndex || (this._string.charAt(this._currentIndex) < "0" || this._string.charAt(this._currentIndex) > "9") && this._string.charAt(this._currentIndex) != ".")
	                        // The first character of a number must be one of [0-9+-.].
	                        return undefined;
	
	                    // Read the integer part, build right-to-left.
	                    var startIntPartIndex = this._currentIndex;
	                    while (this._currentIndex < this._endIndex && this._string.charAt(this._currentIndex) >= "0" && this._string.charAt(this._currentIndex) <= "9") {
	                        this._currentIndex++;
	                    } // Advance to first non-digit.
	
	                    if (this._currentIndex != startIntPartIndex) {
	                        var scanIntPartIndex = this._currentIndex - 1;
	                        var multiplier = 1;
	                        while (scanIntPartIndex >= startIntPartIndex) {
	                            integer += multiplier * (this._string.charAt(scanIntPartIndex--) - "0");
	                            multiplier *= 10;
	                        }
	                    }
	
	                    // Read the decimals.
	                    if (this._currentIndex < this._endIndex && this._string.charAt(this._currentIndex) == ".") {
	                        this._currentIndex++;
	
	                        // There must be a least one digit following the .
	                        if (this._currentIndex >= this._endIndex || this._string.charAt(this._currentIndex) < "0" || this._string.charAt(this._currentIndex) > "9") return undefined;
	                        while (this._currentIndex < this._endIndex && this._string.charAt(this._currentIndex) >= "0" && this._string.charAt(this._currentIndex) <= "9") {
	                            frac *= 10;
	                            decimal += (this._string.charAt(this._currentIndex) - "0") / frac;
	                            this._currentIndex += 1;
	                        }
	                    }
	
	                    // Read the exponent part.
	                    if (this._currentIndex != startIndex && this._currentIndex + 1 < this._endIndex && (this._string.charAt(this._currentIndex) == "e" || this._string.charAt(this._currentIndex) == "E") && this._string.charAt(this._currentIndex + 1) != "x" && this._string.charAt(this._currentIndex + 1) != "m") {
	                        this._currentIndex++;
	
	                        // Read the sign of the exponent.
	                        if (this._string.charAt(this._currentIndex) == "+") {
	                            this._currentIndex++;
	                        } else if (this._string.charAt(this._currentIndex) == "-") {
	                            this._currentIndex++;
	                            expsign = -1;
	                        }
	
	                        // There must be an exponent.
	                        if (this._currentIndex >= this._endIndex || this._string.charAt(this._currentIndex) < "0" || this._string.charAt(this._currentIndex) > "9") return undefined;
	
	                        while (this._currentIndex < this._endIndex && this._string.charAt(this._currentIndex) >= "0" && this._string.charAt(this._currentIndex) <= "9") {
	                            exponent *= 10;
	                            exponent += this._string.charAt(this._currentIndex) - "0";
	                            this._currentIndex++;
	                        }
	                    }
	
	                    var number = integer + decimal;
	                    number *= sign;
	
	                    if (exponent) number *= Math.pow(10, expsign * exponent);
	
	                    if (startIndex == this._currentIndex) return undefined;
	
	                    this._skipOptionalSpacesOrDelimiter();
	
	                    return number;
	                };
	
	                Source.prototype._parseArcFlag = function () {
	                    if (this._currentIndex >= this._endIndex) return undefined;
	                    var flag = false;
	                    var flagChar = this._string.charAt(this._currentIndex++);
	                    if (flagChar == "0") flag = false;else if (flagChar == "1") flag = true;else return undefined;
	
	                    this._skipOptionalSpacesOrDelimiter();
	                    return flag;
	                };
	
	                Source.prototype.parseSegment = function () {
	                    var lookahead = this._string[this._currentIndex];
	                    var command = this._pathSegTypeFromChar(lookahead);
	                    if (command == window.SVGPathSeg.PATHSEG_UNKNOWN) {
	                        // Possibly an implicit command. Not allowed if this is the first command.
	                        if (this._previousCommand == window.SVGPathSeg.PATHSEG_UNKNOWN) return null;
	                        command = this._nextCommandHelper(lookahead, this._previousCommand);
	                        if (command == window.SVGPathSeg.PATHSEG_UNKNOWN) return null;
	                    } else {
	                        this._currentIndex++;
	                    }
	
	                    this._previousCommand = command;
	
	                    switch (command) {
	                        case window.SVGPathSeg.PATHSEG_MOVETO_REL:
	                            return new window.SVGPathSegMovetoRel(owningPathSegList, this._parseNumber(), this._parseNumber());
	                        case window.SVGPathSeg.PATHSEG_MOVETO_ABS:
	                            return new window.SVGPathSegMovetoAbs(owningPathSegList, this._parseNumber(), this._parseNumber());
	                        case window.SVGPathSeg.PATHSEG_LINETO_REL:
	                            return new window.SVGPathSegLinetoRel(owningPathSegList, this._parseNumber(), this._parseNumber());
	                        case window.SVGPathSeg.PATHSEG_LINETO_ABS:
	                            return new window.SVGPathSegLinetoAbs(owningPathSegList, this._parseNumber(), this._parseNumber());
	                        case window.SVGPathSeg.PATHSEG_LINETO_HORIZONTAL_REL:
	                            return new window.SVGPathSegLinetoHorizontalRel(owningPathSegList, this._parseNumber());
	                        case window.SVGPathSeg.PATHSEG_LINETO_HORIZONTAL_ABS:
	                            return new window.SVGPathSegLinetoHorizontalAbs(owningPathSegList, this._parseNumber());
	                        case window.SVGPathSeg.PATHSEG_LINETO_VERTICAL_REL:
	                            return new window.SVGPathSegLinetoVerticalRel(owningPathSegList, this._parseNumber());
	                        case window.SVGPathSeg.PATHSEG_LINETO_VERTICAL_ABS:
	                            return new window.SVGPathSegLinetoVerticalAbs(owningPathSegList, this._parseNumber());
	                        case window.SVGPathSeg.PATHSEG_CLOSEPATH:
	                            this._skipOptionalSpaces();
	                            return new window.SVGPathSegClosePath(owningPathSegList);
	                        case window.SVGPathSeg.PATHSEG_CURVETO_CUBIC_REL:
	                            var points = { x1: this._parseNumber(), y1: this._parseNumber(), x2: this._parseNumber(), y2: this._parseNumber(), x: this._parseNumber(), y: this._parseNumber() };
	                            return new window.SVGPathSegCurvetoCubicRel(owningPathSegList, points.x, points.y, points.x1, points.y1, points.x2, points.y2);
	                        case window.SVGPathSeg.PATHSEG_CURVETO_CUBIC_ABS:
	                            var points = { x1: this._parseNumber(), y1: this._parseNumber(), x2: this._parseNumber(), y2: this._parseNumber(), x: this._parseNumber(), y: this._parseNumber() };
	                            return new window.SVGPathSegCurvetoCubicAbs(owningPathSegList, points.x, points.y, points.x1, points.y1, points.x2, points.y2);
	                        case window.SVGPathSeg.PATHSEG_CURVETO_CUBIC_SMOOTH_REL:
	                            var points = { x2: this._parseNumber(), y2: this._parseNumber(), x: this._parseNumber(), y: this._parseNumber() };
	                            return new window.SVGPathSegCurvetoCubicSmoothRel(owningPathSegList, points.x, points.y, points.x2, points.y2);
	                        case window.SVGPathSeg.PATHSEG_CURVETO_CUBIC_SMOOTH_ABS:
	                            var points = { x2: this._parseNumber(), y2: this._parseNumber(), x: this._parseNumber(), y: this._parseNumber() };
	                            return new window.SVGPathSegCurvetoCubicSmoothAbs(owningPathSegList, points.x, points.y, points.x2, points.y2);
	                        case window.SVGPathSeg.PATHSEG_CURVETO_QUADRATIC_REL:
	                            var points = { x1: this._parseNumber(), y1: this._parseNumber(), x: this._parseNumber(), y: this._parseNumber() };
	                            return new window.SVGPathSegCurvetoQuadraticRel(owningPathSegList, points.x, points.y, points.x1, points.y1);
	                        case window.SVGPathSeg.PATHSEG_CURVETO_QUADRATIC_ABS:
	                            var points = { x1: this._parseNumber(), y1: this._parseNumber(), x: this._parseNumber(), y: this._parseNumber() };
	                            return new window.SVGPathSegCurvetoQuadraticAbs(owningPathSegList, points.x, points.y, points.x1, points.y1);
	                        case window.SVGPathSeg.PATHSEG_CURVETO_QUADRATIC_SMOOTH_REL:
	                            return new window.SVGPathSegCurvetoQuadraticSmoothRel(owningPathSegList, this._parseNumber(), this._parseNumber());
	                        case window.SVGPathSeg.PATHSEG_CURVETO_QUADRATIC_SMOOTH_ABS:
	                            return new window.SVGPathSegCurvetoQuadraticSmoothAbs(owningPathSegList, this._parseNumber(), this._parseNumber());
	                        case window.SVGPathSeg.PATHSEG_ARC_REL:
	                            var points = { x1: this._parseNumber(), y1: this._parseNumber(), arcAngle: this._parseNumber(), arcLarge: this._parseArcFlag(), arcSweep: this._parseArcFlag(), x: this._parseNumber(), y: this._parseNumber() };
	                            return new window.SVGPathSegArcRel(owningPathSegList, points.x, points.y, points.x1, points.y1, points.arcAngle, points.arcLarge, points.arcSweep);
	                        case window.SVGPathSeg.PATHSEG_ARC_ABS:
	                            var points = { x1: this._parseNumber(), y1: this._parseNumber(), arcAngle: this._parseNumber(), arcLarge: this._parseArcFlag(), arcSweep: this._parseArcFlag(), x: this._parseNumber(), y: this._parseNumber() };
	                            return new window.SVGPathSegArcAbs(owningPathSegList, points.x, points.y, points.x1, points.y1, points.arcAngle, points.arcLarge, points.arcSweep);
	                        default:
	                            throw "Unknown path seg type.";
	                    }
	                };
	
	                var builder = new Builder();
	                var source = new Source(string);
	
	                if (!source.initialCommandIsMoveTo()) return [];
	                while (source.hasMoreData()) {
	                    var pathSeg = source.parseSegment();
	                    if (!pathSeg) return [];
	                    builder.appendSegment(pathSeg);
	                }
	
	                return builder.pathSegList;
	            };
	        }
	    })();
	
	    // String.padEnd polyfill for IE11
	    //
	    // https://github.com/uxitten/polyfill/blob/master/string.polyfill.js
	    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/padEnd
	    if (!String.prototype.padEnd) {
	        String.prototype.padEnd = function padEnd(targetLength, padString) {
	            targetLength = targetLength >> 0; //floor if number or convert non-number to 0;
	            padString = String(typeof padString !== 'undefined' ? padString : ' ');
	            if (this.length > targetLength) {
	                return String(this);
	            } else {
	                targetLength = targetLength - this.length;
	                if (targetLength > padString.length) {
	                    padString += padString.repeat(targetLength / padString.length); //append to original to ensure we are longer than needed
	                }
	                return String(this) + padString.slice(0, targetLength);
	            }
	        };
	    }
	
	    /* jshint ignore:end */
	
	    c3_chart_fn.axis = function () {};
	    c3_chart_fn.axis.labels = function (labels) {
	        var $$ = this.internal;
	        if (arguments.length) {
	            Object.keys(labels).forEach(function (axisId) {
	                $$.axis.setLabelText(axisId, labels[axisId]);
	            });
	            $$.axis.updateLabels();
	        }
	        // TODO: return some values?
	    };
	    c3_chart_fn.axis.max = function (max) {
	        var $$ = this.internal,
	            config = $$.config;
	        if (arguments.length) {
	            if ((typeof max === 'undefined' ? 'undefined' : _typeof(max)) === 'object') {
	                if (isValue(max.x)) {
	                    config.axis_x_max = max.x;
	                }
	                if (isValue(max.y)) {
	                    config.axis_y_max = max.y;
	                }
	                if (isValue(max.y2)) {
	                    config.axis_y2_max = max.y2;
	                }
	            } else {
	                config.axis_y_max = config.axis_y2_max = max;
	            }
	            $$.redraw({ withUpdateOrgXDomain: true, withUpdateXDomain: true });
	        } else {
	            return {
	                x: config.axis_x_max,
	                y: config.axis_y_max,
	                y2: config.axis_y2_max
	            };
	        }
	    };
	    c3_chart_fn.axis.min = function (min) {
	        var $$ = this.internal,
	            config = $$.config;
	        if (arguments.length) {
	            if ((typeof min === 'undefined' ? 'undefined' : _typeof(min)) === 'object') {
	                if (isValue(min.x)) {
	                    config.axis_x_min = min.x;
	                }
	                if (isValue(min.y)) {
	                    config.axis_y_min = min.y;
	                }
	                if (isValue(min.y2)) {
	                    config.axis_y2_min = min.y2;
	                }
	            } else {
	                config.axis_y_min = config.axis_y2_min = min;
	            }
	            $$.redraw({ withUpdateOrgXDomain: true, withUpdateXDomain: true });
	        } else {
	            return {
	                x: config.axis_x_min,
	                y: config.axis_y_min,
	                y2: config.axis_y2_min
	            };
	        }
	    };
	    c3_chart_fn.axis.range = function (range) {
	        if (arguments.length) {
	            if (isDefined(range.max)) {
	                this.axis.max(range.max);
	            }
	            if (isDefined(range.min)) {
	                this.axis.min(range.min);
	            }
	        } else {
	            return {
	                max: this.axis.max(),
	                min: this.axis.min()
	            };
	        }
	    };
	
	    c3_chart_fn.category = function (i, category) {
	        var $$ = this.internal,
	            config = $$.config;
	        if (arguments.length > 1) {
	            config.axis_x_categories[i] = category;
	            $$.redraw();
	        }
	        return config.axis_x_categories[i];
	    };
	    c3_chart_fn.categories = function (categories) {
	        var $$ = this.internal,
	            config = $$.config;
	        if (!arguments.length) {
	            return config.axis_x_categories;
	        }
	        config.axis_x_categories = categories;
	        $$.redraw();
	        return config.axis_x_categories;
	    };
	
	    c3_chart_fn.resize = function (size) {
	        var $$ = this.internal,
	            config = $$.config;
	        config.size_width = size ? size.width : null;
	        config.size_height = size ? size.height : null;
	        this.flush();
	    };
	
	    c3_chart_fn.flush = function () {
	        var $$ = this.internal;
	        $$.updateAndRedraw({ withLegend: true, withTransition: false, withTransitionForTransform: false });
	    };
	
	    c3_chart_fn.destroy = function () {
	        var $$ = this.internal;
	
	        window.clearInterval($$.intervalForObserveInserted);
	
	        if ($$.resizeTimeout !== undefined) {
	            window.clearTimeout($$.resizeTimeout);
	        }
	
	        if (window.detachEvent) {
	            window.detachEvent('onresize', $$.resizeIfElementDisplayed);
	        } else if (window.removeEventListener) {
	            window.removeEventListener('resize', $$.resizeIfElementDisplayed);
	        } else {
	            var wrapper = window.onresize;
	            // check if no one else removed our wrapper and remove our resizeFunction from it
	            if (wrapper && wrapper.add && wrapper.remove) {
	                wrapper.remove($$.resizeFunction);
	            }
	        }
	
	        // remove the inner resize functions
	        $$.resizeFunction.remove();
	
	        $$.selectChart.classed('c3', false).html("");
	
	        // MEMO: this is needed because the reference of some elements will not be released, then memory leak will happen.
	        Object.keys($$).forEach(function (key) {
	            $$[key] = null;
	        });
	
	        return null;
	    };
	
	    // TODO: fix
	    c3_chart_fn.color = function (id) {
	        var $$ = this.internal;
	        return $$.color(id); // more patterns
	    };
	
	    c3_chart_fn.data = function (targetIds) {
	        var targets = this.internal.data.targets;
	        return typeof targetIds === 'undefined' ? targets : targets.filter(function (t) {
	            return [].concat(targetIds).indexOf(t.id) >= 0;
	        });
	    };
	    c3_chart_fn.data.shown = function (targetIds) {
	        return this.internal.filterTargetsToShow(this.data(targetIds));
	    };
	    c3_chart_fn.data.values = function (targetId) {
	        var targets,
	            values = null;
	        if (targetId) {
	            targets = this.data(targetId);
	            values = targets[0] ? targets[0].values.map(function (d) {
	                return d.value;
	            }) : null;
	        }
	        return values;
	    };
	    c3_chart_fn.data.names = function (names) {
	        this.internal.clearLegendItemTextBoxCache();
	        return this.internal.updateDataAttributes('names', names);
	    };
	    c3_chart_fn.data.colors = function (colors) {
	        return this.internal.updateDataAttributes('colors', colors);
	    };
	    c3_chart_fn.data.axes = function (axes) {
	        return this.internal.updateDataAttributes('axes', axes);
	    };
	
	    c3_chart_fn.flow = function (args) {
	        var $$ = this.internal,
	            targets,
	            data,
	            notfoundIds = [],
	            orgDataCount = $$.getMaxDataCount(),
	            dataCount,
	            domain,
	            baseTarget,
	            baseValue,
	            length = 0,
	            tail = 0,
	            diff,
	            to;
	
	        if (args.json) {
	            data = $$.convertJsonToData(args.json, args.keys);
	        } else if (args.rows) {
	            data = $$.convertRowsToData(args.rows);
	        } else if (args.columns) {
	            data = $$.convertColumnsToData(args.columns);
	        } else {
	            return;
	        }
	        targets = $$.convertDataToTargets(data, true);
	
	        // Update/Add data
	        $$.data.targets.forEach(function (t) {
	            var found = false,
	                i,
	                j;
	            for (i = 0; i < targets.length; i++) {
	                if (t.id === targets[i].id) {
	                    found = true;
	
	                    if (t.values[t.values.length - 1]) {
	                        tail = t.values[t.values.length - 1].index + 1;
	                    }
	                    length = targets[i].values.length;
	
	                    for (j = 0; j < length; j++) {
	                        targets[i].values[j].index = tail + j;
	                        if (!$$.isTimeSeries()) {
	                            targets[i].values[j].x = tail + j;
	                        }
	                    }
	                    t.values = t.values.concat(targets[i].values);
	
	                    targets.splice(i, 1);
	                    break;
	                }
	            }
	            if (!found) {
	                notfoundIds.push(t.id);
	            }
	        });
	
	        // Append null for not found targets
	        $$.data.targets.forEach(function (t) {
	            var i, j;
	            for (i = 0; i < notfoundIds.length; i++) {
	                if (t.id === notfoundIds[i]) {
	                    tail = t.values[t.values.length - 1].index + 1;
	                    for (j = 0; j < length; j++) {
	                        t.values.push({
	                            id: t.id,
	                            index: tail + j,
	                            x: $$.isTimeSeries() ? $$.getOtherTargetX(tail + j) : tail + j,
	                            value: null
	                        });
	                    }
	                }
	            }
	        });
	
	        // Generate null values for new target
	        if ($$.data.targets.length) {
	            targets.forEach(function (t) {
	                var i,
	                    missing = [];
	                for (i = $$.data.targets[0].values[0].index; i < tail; i++) {
	                    missing.push({
	                        id: t.id,
	                        index: i,
	                        x: $$.isTimeSeries() ? $$.getOtherTargetX(i) : i,
	                        value: null
	                    });
	                }
	                t.values.forEach(function (v) {
	                    v.index += tail;
	                    if (!$$.isTimeSeries()) {
	                        v.x += tail;
	                    }
	                });
	                t.values = missing.concat(t.values);
	            });
	        }
	        $$.data.targets = $$.data.targets.concat(targets); // add remained
	
	        // check data count because behavior needs to change when it's only one
	        dataCount = $$.getMaxDataCount();
	        baseTarget = $$.data.targets[0];
	        baseValue = baseTarget.values[0];
	
	        // Update length to flow if needed
	        if (isDefined(args.to)) {
	            length = 0;
	            to = $$.isTimeSeries() ? $$.parseDate(args.to) : args.to;
	            baseTarget.values.forEach(function (v) {
	                if (v.x < to) {
	                    length++;
	                }
	            });
	        } else if (isDefined(args.length)) {
	            length = args.length;
	        }
	
	        // If only one data, update the domain to flow from left edge of the chart
	        if (!orgDataCount) {
	            if ($$.isTimeSeries()) {
	                if (baseTarget.values.length > 1) {
	                    diff = baseTarget.values[baseTarget.values.length - 1].x - baseValue.x;
	                } else {
	                    diff = baseValue.x - $$.getXDomain($$.data.targets)[0];
	                }
	            } else {
	                diff = 1;
	            }
	            domain = [baseValue.x - diff, baseValue.x];
	            $$.updateXDomain(null, true, true, false, domain);
	        } else if (orgDataCount === 1) {
	            if ($$.isTimeSeries()) {
	                diff = (baseTarget.values[baseTarget.values.length - 1].x - baseValue.x) / 2;
	                domain = [new Date(+baseValue.x - diff), new Date(+baseValue.x + diff)];
	                $$.updateXDomain(null, true, true, false, domain);
	            }
	        }
	
	        // Set targets
	        $$.updateTargets($$.data.targets);
	
	        // Redraw with new targets
	        $$.redraw({
	            flow: {
	                index: baseValue.index,
	                length: length,
	                duration: isValue(args.duration) ? args.duration : $$.config.transition_duration,
	                done: args.done,
	                orgDataCount: orgDataCount
	            },
	            withLegend: true,
	            withTransition: orgDataCount > 1,
	            withTrimXDomain: false,
	            withUpdateXAxis: true
	        });
	    };
	
	    c3_chart_internal_fn.generateFlow = function (args) {
	        var $$ = this,
	            config = $$.config,
	            d3 = $$.d3;
	
	        return function () {
	            var targets = args.targets,
	                flow = args.flow,
	                drawBar = args.drawBar,
	                drawLine = args.drawLine,
	                drawArea = args.drawArea,
	                cx = args.cx,
	                cy = args.cy,
	                xv = args.xv,
	                xForText = args.xForText,
	                yForText = args.yForText,
	                duration = args.duration;
	
	            var translateX,
	                scaleX = 1,
	                transform,
	                flowIndex = flow.index,
	                flowLength = flow.length,
	                flowStart = $$.getValueOnIndex($$.data.targets[0].values, flowIndex),
	                flowEnd = $$.getValueOnIndex($$.data.targets[0].values, flowIndex + flowLength),
	                orgDomain = $$.x.domain(),
	                domain,
	                durationForFlow = flow.duration || duration,
	                done = flow.done || function () {},
	                wait = $$.generateWait();
	
	            var xgrid = $$.xgrid || d3.selectAll([]),
	                xgridLines = $$.xgridLines || d3.selectAll([]),
	                mainRegion = $$.mainRegion || d3.selectAll([]),
	                mainText = $$.mainText || d3.selectAll([]),
	                mainBar = $$.mainBar || d3.selectAll([]),
	                mainLine = $$.mainLine || d3.selectAll([]),
	                mainArea = $$.mainArea || d3.selectAll([]),
	                mainCircle = $$.mainCircle || d3.selectAll([]);
	
	            // set flag
	            $$.flowing = true;
	
	            // remove head data after rendered
	            $$.data.targets.forEach(function (d) {
	                d.values.splice(0, flowLength);
	            });
	
	            // update x domain to generate axis elements for flow
	            domain = $$.updateXDomain(targets, true, true);
	            // update elements related to x scale
	            if ($$.updateXGrid) {
	                $$.updateXGrid(true);
	            }
	
	            // generate transform to flow
	            if (!flow.orgDataCount) {
	                // if empty
	                if ($$.data.targets[0].values.length !== 1) {
	                    translateX = $$.x(orgDomain[0]) - $$.x(domain[0]);
	                } else {
	                    if ($$.isTimeSeries()) {
	                        flowStart = $$.getValueOnIndex($$.data.targets[0].values, 0);
	                        flowEnd = $$.getValueOnIndex($$.data.targets[0].values, $$.data.targets[0].values.length - 1);
	                        translateX = $$.x(flowStart.x) - $$.x(flowEnd.x);
	                    } else {
	                        translateX = diffDomain(domain) / 2;
	                    }
	                }
	            } else if (flow.orgDataCount === 1 || (flowStart && flowStart.x) === (flowEnd && flowEnd.x)) {
	                translateX = $$.x(orgDomain[0]) - $$.x(domain[0]);
	            } else {
	                if ($$.isTimeSeries()) {
	                    translateX = $$.x(orgDomain[0]) - $$.x(domain[0]);
	                } else {
	                    translateX = $$.x(flowStart.x) - $$.x(flowEnd.x);
	                }
	            }
	            scaleX = diffDomain(orgDomain) / diffDomain(domain);
	            transform = 'translate(' + translateX + ',0) scale(' + scaleX + ',1)';
	
	            $$.hideXGridFocus();
	
	            d3.transition().ease('linear').duration(durationForFlow).each(function () {
	                wait.add($$.axes.x.transition().call($$.xAxis));
	                wait.add(mainBar.transition().attr('transform', transform));
	                wait.add(mainLine.transition().attr('transform', transform));
	                wait.add(mainArea.transition().attr('transform', transform));
	                wait.add(mainCircle.transition().attr('transform', transform));
	                wait.add(mainText.transition().attr('transform', transform));
	                wait.add(mainRegion.filter($$.isRegionOnX).transition().attr('transform', transform));
	                wait.add(xgrid.transition().attr('transform', transform));
	                wait.add(xgridLines.transition().attr('transform', transform));
	            }).call(wait, function () {
	                var i,
	                    shapes = [],
	                    texts = [],
	                    eventRects = [];
	
	                // remove flowed elements
	                if (flowLength) {
	                    for (i = 0; i < flowLength; i++) {
	                        shapes.push('.' + CLASS.shape + '-' + (flowIndex + i));
	                        texts.push('.' + CLASS.text + '-' + (flowIndex + i));
	                        eventRects.push('.' + CLASS.eventRect + '-' + (flowIndex + i));
	                    }
	                    $$.svg.selectAll('.' + CLASS.shapes).selectAll(shapes).remove();
	                    $$.svg.selectAll('.' + CLASS.texts).selectAll(texts).remove();
	                    $$.svg.selectAll('.' + CLASS.eventRects).selectAll(eventRects).remove();
	                    $$.svg.select('.' + CLASS.xgrid).remove();
	                }
	
	                // draw again for removing flowed elements and reverting attr
	                xgrid.attr('transform', null).attr($$.xgridAttr);
	                xgridLines.attr('transform', null);
	                xgridLines.select('line').attr("x1", config.axis_rotated ? 0 : xv).attr("x2", config.axis_rotated ? $$.width : xv);
	                xgridLines.select('text').attr("x", config.axis_rotated ? $$.width : 0).attr("y", xv);
	                mainBar.attr('transform', null).attr("d", drawBar);
	                mainLine.attr('transform', null).attr("d", drawLine);
	                mainArea.attr('transform', null).attr("d", drawArea);
	                mainCircle.attr('transform', null).attr("cx", cx).attr("cy", cy);
	                mainText.attr('transform', null).attr('x', xForText).attr('y', yForText).style('fill-opacity', $$.opacityForText.bind($$));
	                mainRegion.attr('transform', null);
	                mainRegion.select('rect').filter($$.isRegionOnX).attr("x", $$.regionX.bind($$)).attr("width", $$.regionWidth.bind($$));
	
	                if (config.interaction_enabled) {
	                    $$.redrawEventRect();
	                }
	
	                // callback for end of flow
	                done();
	
	                $$.flowing = false;
	            });
	        };
	    };
	
	    c3_chart_fn.focus = function (targetIds) {
	        var $$ = this.internal,
	            candidates;
	
	        targetIds = $$.mapToTargetIds(targetIds);
	        candidates = $$.svg.selectAll($$.selectorTargets(targetIds.filter($$.isTargetToShow, $$))), this.revert();
	        this.defocus();
	        candidates.classed(CLASS.focused, true).classed(CLASS.defocused, false);
	        if ($$.hasArcType()) {
	            $$.expandArc(targetIds);
	        }
	        $$.toggleFocusLegend(targetIds, true);
	
	        $$.focusedTargetIds = targetIds;
	        $$.defocusedTargetIds = $$.defocusedTargetIds.filter(function (id) {
	            return targetIds.indexOf(id) < 0;
	        });
	    };
	
	    c3_chart_fn.defocus = function (targetIds) {
	        var $$ = this.internal,
	            candidates;
	
	        targetIds = $$.mapToTargetIds(targetIds);
	        candidates = $$.svg.selectAll($$.selectorTargets(targetIds.filter($$.isTargetToShow, $$))), candidates.classed(CLASS.focused, false).classed(CLASS.defocused, true);
	        if ($$.hasArcType()) {
	            $$.unexpandArc(targetIds);
	        }
	        $$.toggleFocusLegend(targetIds, false);
	
	        $$.focusedTargetIds = $$.focusedTargetIds.filter(function (id) {
	            return targetIds.indexOf(id) < 0;
	        });
	        $$.defocusedTargetIds = targetIds;
	    };
	
	    c3_chart_fn.revert = function (targetIds) {
	        var $$ = this.internal,
	            candidates;
	
	        targetIds = $$.mapToTargetIds(targetIds);
	        candidates = $$.svg.selectAll($$.selectorTargets(targetIds)); // should be for all targets
	
	        candidates.classed(CLASS.focused, false).classed(CLASS.defocused, false);
	        if ($$.hasArcType()) {
	            $$.unexpandArc(targetIds);
	        }
	        if ($$.config.legend_show) {
	            $$.showLegend(targetIds.filter($$.isLegendToShow.bind($$)));
	            $$.legend.selectAll($$.selectorLegends(targetIds)).filter(function () {
	                return $$.d3.select(this).classed(CLASS.legendItemFocused);
	            }).classed(CLASS.legendItemFocused, false);
	        }
	
	        $$.focusedTargetIds = [];
	        $$.defocusedTargetIds = [];
	    };
	
	    c3_chart_fn.xgrids = function (grids) {
	        var $$ = this.internal,
	            config = $$.config;
	        if (!grids) {
	            return config.grid_x_lines;
	        }
	        config.grid_x_lines = grids;
	        $$.redrawWithoutRescale();
	        return config.grid_x_lines;
	    };
	    c3_chart_fn.xgrids.add = function (grids) {
	        var $$ = this.internal;
	        return this.xgrids($$.config.grid_x_lines.concat(grids ? grids : []));
	    };
	    c3_chart_fn.xgrids.remove = function (params) {
	        // TODO: multiple
	        var $$ = this.internal;
	        $$.removeGridLines(params, true);
	    };
	
	    c3_chart_fn.ygrids = function (grids) {
	        var $$ = this.internal,
	            config = $$.config;
	        if (!grids) {
	            return config.grid_y_lines;
	        }
	        config.grid_y_lines = grids;
	        $$.redrawWithoutRescale();
	        return config.grid_y_lines;
	    };
	    c3_chart_fn.ygrids.add = function (grids) {
	        var $$ = this.internal;
	        return this.ygrids($$.config.grid_y_lines.concat(grids ? grids : []));
	    };
	    c3_chart_fn.ygrids.remove = function (params) {
	        // TODO: multiple
	        var $$ = this.internal;
	        $$.removeGridLines(params, false);
	    };
	
	    c3_chart_fn.groups = function (groups) {
	        var $$ = this.internal,
	            config = $$.config;
	        if (isUndefined(groups)) {
	            return config.data_groups;
	        }
	        config.data_groups = groups;
	        $$.redraw();
	        return config.data_groups;
	    };
	
	    c3_chart_fn.legend = function () {};
	    c3_chart_fn.legend.show = function (targetIds) {
	        var $$ = this.internal;
	        $$.showLegend($$.mapToTargetIds(targetIds));
	        $$.updateAndRedraw({ withLegend: true });
	    };
	    c3_chart_fn.legend.hide = function (targetIds) {
	        var $$ = this.internal;
	        $$.hideLegend($$.mapToTargetIds(targetIds));
	        $$.updateAndRedraw({ withLegend: true });
	    };
	
	    c3_chart_fn.load = function (args) {
	        var $$ = this.internal,
	            config = $$.config;
	        // update xs if specified
	        if (args.xs) {
	            $$.addXs(args.xs);
	        }
	        // update names if exists
	        if ('names' in args) {
	            c3_chart_fn.data.names.bind(this)(args.names);
	        }
	        // update classes if exists
	        if ('classes' in args) {
	            Object.keys(args.classes).forEach(function (id) {
	                config.data_classes[id] = args.classes[id];
	            });
	        }
	        // update categories if exists
	        if ('categories' in args && $$.isCategorized()) {
	            config.axis_x_categories = args.categories;
	        }
	        // update axes if exists
	        if ('axes' in args) {
	            Object.keys(args.axes).forEach(function (id) {
	                config.data_axes[id] = args.axes[id];
	            });
	        }
	        // update colors if exists
	        if ('colors' in args) {
	            Object.keys(args.colors).forEach(function (id) {
	                config.data_colors[id] = args.colors[id];
	            });
	        }
	        // use cache if exists
	        if ('cacheIds' in args && $$.hasCaches(args.cacheIds)) {
	            $$.load($$.getCaches(args.cacheIds), args.done);
	            return;
	        }
	        // unload if needed
	        if ('unload' in args) {
	            // TODO: do not unload if target will load (included in url/rows/columns)
	            $$.unload($$.mapToTargetIds(typeof args.unload === 'boolean' && args.unload ? null : args.unload), function () {
	                $$.loadFromArgs(args);
	            });
	        } else {
	            $$.loadFromArgs(args);
	        }
	    };
	
	    c3_chart_fn.unload = function (args) {
	        var $$ = this.internal;
	        args = args || {};
	        if (args instanceof Array) {
	            args = { ids: args };
	        } else if (typeof args === 'string') {
	            args = { ids: [args] };
	        }
	        $$.unload($$.mapToTargetIds(args.ids), function () {
	            $$.redraw({ withUpdateOrgXDomain: true, withUpdateXDomain: true, withLegend: true });
	            if (args.done) {
	                args.done();
	            }
	        });
	    };
	
	    c3_chart_fn.regions = function (regions) {
	        var $$ = this.internal,
	            config = $$.config;
	        if (!regions) {
	            return config.regions;
	        }
	        config.regions = regions;
	        $$.redrawWithoutRescale();
	        return config.regions;
	    };
	    c3_chart_fn.regions.add = function (regions) {
	        var $$ = this.internal,
	            config = $$.config;
	        if (!regions) {
	            return config.regions;
	        }
	        config.regions = config.regions.concat(regions);
	        $$.redrawWithoutRescale();
	        return config.regions;
	    };
	    c3_chart_fn.regions.remove = function (options) {
	        var $$ = this.internal,
	            config = $$.config,
	            duration,
	            classes,
	            regions;
	
	        options = options || {};
	        duration = $$.getOption(options, "duration", config.transition_duration);
	        classes = $$.getOption(options, "classes", [CLASS.region]);
	
	        regions = $$.main.select('.' + CLASS.regions).selectAll(classes.map(function (c) {
	            return '.' + c;
	        }));
	        (duration ? regions.transition().duration(duration) : regions).style('opacity', 0).remove();
	
	        config.regions = config.regions.filter(function (region) {
	            var found = false;
	            if (!region['class']) {
	                return true;
	            }
	            region['class'].split(' ').forEach(function (c) {
	                if (classes.indexOf(c) >= 0) {
	                    found = true;
	                }
	            });
	            return !found;
	        });
	
	        return config.regions;
	    };
	
	    c3_chart_fn.selected = function (targetId) {
	        var $$ = this.internal,
	            d3 = $$.d3;
	        return d3.merge($$.main.selectAll('.' + CLASS.shapes + $$.getTargetSelectorSuffix(targetId)).selectAll('.' + CLASS.shape).filter(function () {
	            return d3.select(this).classed(CLASS.SELECTED);
	        }).map(function (d) {
	            return d.map(function (d) {
	                var data = d.__data__;return data.data ? data.data : data;
	            });
	        }));
	    };
	    c3_chart_fn.select = function (ids, indices, resetOther) {
	        var $$ = this.internal,
	            d3 = $$.d3,
	            config = $$.config;
	        if (!config.data_selection_enabled) {
	            return;
	        }
	        $$.main.selectAll('.' + CLASS.shapes).selectAll('.' + CLASS.shape).each(function (d, i) {
	            var shape = d3.select(this),
	                id = d.data ? d.data.id : d.id,
	                toggle = $$.getToggle(this, d).bind($$),
	                isTargetId = config.data_selection_grouped || !ids || ids.indexOf(id) >= 0,
	                isTargetIndex = !indices || indices.indexOf(i) >= 0,
	                isSelected = shape.classed(CLASS.SELECTED);
	            // line/area selection not supported yet
	            if (shape.classed(CLASS.line) || shape.classed(CLASS.area)) {
	                return;
	            }
	            if (isTargetId && isTargetIndex) {
	                if (config.data_selection_isselectable(d) && !isSelected) {
	                    toggle(true, shape.classed(CLASS.SELECTED, true), d, i);
	                }
	            } else if (isDefined(resetOther) && resetOther) {
	                if (isSelected) {
	                    toggle(false, shape.classed(CLASS.SELECTED, false), d, i);
	                }
	            }
	        });
	    };
	    c3_chart_fn.unselect = function (ids, indices) {
	        var $$ = this.internal,
	            d3 = $$.d3,
	            config = $$.config;
	        if (!config.data_selection_enabled) {
	            return;
	        }
	        $$.main.selectAll('.' + CLASS.shapes).selectAll('.' + CLASS.shape).each(function (d, i) {
	            var shape = d3.select(this),
	                id = d.data ? d.data.id : d.id,
	                toggle = $$.getToggle(this, d).bind($$),
	                isTargetId = config.data_selection_grouped || !ids || ids.indexOf(id) >= 0,
	                isTargetIndex = !indices || indices.indexOf(i) >= 0,
	                isSelected = shape.classed(CLASS.SELECTED);
	            // line/area selection not supported yet
	            if (shape.classed(CLASS.line) || shape.classed(CLASS.area)) {
	                return;
	            }
	            if (isTargetId && isTargetIndex) {
	                if (config.data_selection_isselectable(d)) {
	                    if (isSelected) {
	                        toggle(false, shape.classed(CLASS.SELECTED, false), d, i);
	                    }
	                }
	            }
	        });
	    };
	
	    c3_chart_fn.show = function (targetIds, options) {
	        var $$ = this.internal,
	            targets;
	
	        targetIds = $$.mapToTargetIds(targetIds);
	        options = options || {};
	
	        $$.removeHiddenTargetIds(targetIds);
	        targets = $$.svg.selectAll($$.selectorTargets(targetIds));
	
	        targets.transition().style('opacity', 1, 'important').call($$.endall, function () {
	            targets.style('opacity', null).style('opacity', 1);
	        });
	
	        if (options.withLegend) {
	            $$.showLegend(targetIds);
	        }
	
	        $$.redraw({ withUpdateOrgXDomain: true, withUpdateXDomain: true, withLegend: true });
	    };
	
	    c3_chart_fn.hide = function (targetIds, options) {
	        var $$ = this.internal,
	            targets;
	
	        targetIds = $$.mapToTargetIds(targetIds);
	        options = options || {};
	
	        $$.addHiddenTargetIds(targetIds);
	        targets = $$.svg.selectAll($$.selectorTargets(targetIds));
	
	        targets.transition().style('opacity', 0, 'important').call($$.endall, function () {
	            targets.style('opacity', null).style('opacity', 0);
	        });
	
	        if (options.withLegend) {
	            $$.hideLegend(targetIds);
	        }
	
	        $$.redraw({ withUpdateOrgXDomain: true, withUpdateXDomain: true, withLegend: true });
	    };
	
	    c3_chart_fn.toggle = function (targetIds, options) {
	        var that = this,
	            $$ = this.internal;
	        $$.mapToTargetIds(targetIds).forEach(function (targetId) {
	            $$.isTargetToShow(targetId) ? that.hide(targetId, options) : that.show(targetId, options);
	        });
	    };
	
	    c3_chart_fn.tooltip = function () {};
	    c3_chart_fn.tooltip.show = function (args) {
	        var $$ = this.internal,
	            index,
	            mouse;
	
	        // determine mouse position on the chart
	        if (args.mouse) {
	            mouse = args.mouse;
	        }
	
	        // determine focus data
	        if (args.data) {
	            if ($$.isMultipleX()) {
	                // if multiple xs, target point will be determined by mouse
	                mouse = [$$.x(args.data.x), $$.getYScale(args.data.id)(args.data.value)];
	                index = null;
	            } else {
	                // TODO: when tooltip_grouped = false
	                index = isValue(args.data.index) ? args.data.index : $$.getIndexByX(args.data.x);
	            }
	        } else if (typeof args.x !== 'undefined') {
	            index = $$.getIndexByX(args.x);
	        } else if (typeof args.index !== 'undefined') {
	            index = args.index;
	        }
	
	        // emulate mouse events to show
	        $$.dispatchEvent('mouseover', index, mouse);
	        $$.dispatchEvent('mousemove', index, mouse);
	
	        $$.config.tooltip_onshow.call($$, args.data);
	    };
	    c3_chart_fn.tooltip.hide = function () {
	        // TODO: get target data by checking the state of focus
	        this.internal.dispatchEvent('mouseout', 0);
	
	        this.internal.config.tooltip_onhide.call(this);
	    };
	
	    c3_chart_fn.transform = function (type, targetIds) {
	        var $$ = this.internal,
	            options = ['pie', 'donut'].indexOf(type) >= 0 ? { withTransform: true } : null;
	        $$.transformTo(targetIds, type, options);
	    };
	
	    c3_chart_internal_fn.transformTo = function (targetIds, type, optionsForRedraw) {
	        var $$ = this,
	            withTransitionForAxis = !$$.hasArcType(),
	            options = optionsForRedraw || { withTransitionForAxis: withTransitionForAxis };
	        options.withTransitionForTransform = false;
	        $$.transiting = false;
	        $$.setTargetType(targetIds, type);
	        $$.updateTargets($$.data.targets); // this is needed when transforming to arc
	        $$.updateAndRedraw(options);
	    };
	
	    c3_chart_fn.x = function (x) {
	        var $$ = this.internal;
	        if (arguments.length) {
	            $$.updateTargetX($$.data.targets, x);
	            $$.redraw({ withUpdateOrgXDomain: true, withUpdateXDomain: true });
	        }
	        return $$.data.xs;
	    };
	    c3_chart_fn.xs = function (xs) {
	        var $$ = this.internal;
	        if (arguments.length) {
	            $$.updateTargetXs($$.data.targets, xs);
	            $$.redraw({ withUpdateOrgXDomain: true, withUpdateXDomain: true });
	        }
	        return $$.data.xs;
	    };
	
	    c3_chart_fn.zoom = function (domain) {
	        var $$ = this.internal;
	        if (domain) {
	            if ($$.isTimeSeries()) {
	                domain = domain.map(function (x) {
	                    return $$.parseDate(x);
	                });
	            }
	            $$.brush.extent(domain);
	            $$.redraw({ withUpdateXDomain: true, withY: $$.config.zoom_rescale });
	            $$.config.zoom_onzoom.call(this, $$.x.orgDomain());
	        }
	        return $$.brush.extent();
	    };
	    c3_chart_fn.zoom.enable = function (enabled) {
	        var $$ = this.internal;
	        $$.config.zoom_enabled = enabled;
	        $$.updateAndRedraw();
	    };
	    c3_chart_fn.unzoom = function () {
	        var $$ = this.internal;
	        $$.brush.clear().update();
	        $$.redraw({ withUpdateXDomain: true });
	    };
	
	    c3_chart_fn.zoom.max = function (max) {
	        var $$ = this.internal,
	            config = $$.config,
	            d3 = $$.d3;
	        if (max === 0 || max) {
	            config.zoom_x_max = d3.max([$$.orgXDomain[1], max]);
	        } else {
	            return config.zoom_x_max;
	        }
	    };
	
	    c3_chart_fn.zoom.min = function (min) {
	        var $$ = this.internal,
	            config = $$.config,
	            d3 = $$.d3;
	        if (min === 0 || min) {
	            config.zoom_x_min = d3.min([$$.orgXDomain[0], min]);
	        } else {
	            return config.zoom_x_min;
	        }
	    };
	
	    c3_chart_fn.zoom.range = function (range) {
	        if (arguments.length) {
	            if (isDefined(range.max)) {
	                this.domain.max(range.max);
	            }
	            if (isDefined(range.min)) {
	                this.domain.min(range.min);
	            }
	        } else {
	            return {
	                max: this.domain.max(),
	                min: this.domain.min()
	            };
	        }
	    };
	
	    c3_chart_internal_fn.initPie = function () {
	        var $$ = this,
	            d3 = $$.d3;
	        $$.pie = d3.layout.pie().value(function (d) {
	            return d.values.reduce(function (a, b) {
	                return a + b.value;
	            }, 0);
	        });
	        $$.pie.sort($$.getOrderFunction() || null);
	    };
	
	    c3_chart_internal_fn.updateRadius = function () {
	        var $$ = this,
	            config = $$.config,
	            w = config.gauge_width || config.donut_width,
	            gaugeArcWidth = $$.filterTargetsToShow($$.data.targets).length * $$.config.gauge_arcs_minWidth;
	        $$.radiusExpanded = Math.min($$.arcWidth, $$.arcHeight) / 2 * ($$.hasType('gauge') ? 0.85 : 1);
	        $$.radius = $$.radiusExpanded * 0.95;
	        $$.innerRadiusRatio = w ? ($$.radius - w) / $$.radius : 0.6;
	        $$.innerRadius = $$.hasType('donut') || $$.hasType('gauge') ? $$.radius * $$.innerRadiusRatio : 0;
	        $$.gaugeArcWidth = w ? w : gaugeArcWidth <= $$.radius - $$.innerRadius ? $$.radius - $$.innerRadius : gaugeArcWidth <= $$.radius ? gaugeArcWidth : $$.radius;
	    };
	
	    c3_chart_internal_fn.updateArc = function () {
	        var $$ = this;
	        $$.svgArc = $$.getSvgArc();
	        $$.svgArcExpanded = $$.getSvgArcExpanded();
	        $$.svgArcExpandedSub = $$.getSvgArcExpanded(0.98);
	    };
	
	    c3_chart_internal_fn.updateAngle = function (d) {
	        var $$ = this,
	            config = $$.config,
	            found = false,
	            index = 0,
	            gMin,
	            gMax,
	            gTic,
	            gValue;
	
	        if (!config) {
	            return null;
	        }
	
	        $$.pie($$.filterTargetsToShow($$.data.targets)).forEach(function (t) {
	            if (!found && t.data.id === d.data.id) {
	                found = true;
	                d = t;
	                d.index = index;
	            }
	            index++;
	        });
	        if (isNaN(d.startAngle)) {
	            d.startAngle = 0;
	        }
	        if (isNaN(d.endAngle)) {
	            d.endAngle = d.startAngle;
	        }
	        if ($$.isGaugeType(d.data)) {
	            gMin = config.gauge_min;
	            gMax = config.gauge_max;
	            gTic = Math.PI * (config.gauge_fullCircle ? 2 : 1) / (gMax - gMin);
	            gValue = d.value < gMin ? 0 : d.value < gMax ? d.value - gMin : gMax - gMin;
	            d.startAngle = config.gauge_startingAngle;
	            d.endAngle = d.startAngle + gTic * gValue;
	        }
	        return found ? d : null;
	    };
	
	    c3_chart_internal_fn.getSvgArc = function () {
	        var $$ = this,
	            hasGaugeType = $$.hasType('gauge'),
	            singleArcWidth = $$.gaugeArcWidth / $$.filterTargetsToShow($$.data.targets).length,
	            arc = $$.d3.svg.arc().outerRadius(function (d) {
	            return hasGaugeType ? $$.radius - singleArcWidth * d.index : $$.radius;
	        }).innerRadius(function (d) {
	            return hasGaugeType ? $$.radius - singleArcWidth * (d.index + 1) : $$.innerRadius;
	        }),
	            newArc = function newArc(d, withoutUpdate) {
	            var updated;
	            if (withoutUpdate) {
	                return arc(d);
	            } // for interpolate
	            updated = $$.updateAngle(d);
	            return updated ? arc(updated) : "M 0 0";
	        };
	        // TODO: extends all function
	        newArc.centroid = arc.centroid;
	        return newArc;
	    };
	
	    c3_chart_internal_fn.getSvgArcExpanded = function (rate) {
	        rate = rate || 1;
	        var $$ = this,
	            hasGaugeType = $$.hasType('gauge'),
	            singleArcWidth = $$.gaugeArcWidth / $$.filterTargetsToShow($$.data.targets).length,
	            expandWidth = Math.min($$.radiusExpanded * rate - $$.radius, singleArcWidth * 0.8 - (1 - rate) * 100),
	            arc = $$.d3.svg.arc().outerRadius(function (d) {
	            return hasGaugeType ? $$.radius - singleArcWidth * d.index + expandWidth : $$.radiusExpanded * rate;
	        }).innerRadius(function (d) {
	            return hasGaugeType ? $$.radius - singleArcWidth * (d.index + 1) : $$.innerRadius;
	        });
	        return function (d) {
	            var updated = $$.updateAngle(d);
	            return updated ? arc(updated) : "M 0 0";
	        };
	    };
	
	    c3_chart_internal_fn.getArc = function (d, withoutUpdate, force) {
	        return force || this.isArcType(d.data) ? this.svgArc(d, withoutUpdate) : "M 0 0";
	    };
	
	    c3_chart_internal_fn.transformForArcLabel = function (d) {
	        var $$ = this,
	            config = $$.config,
	            updated = $$.updateAngle(d),
	            c,
	            x,
	            y,
	            h,
	            ratio,
	            translate = "",
	            hasGauge = $$.hasType('gauge');
	        if (updated && !hasGauge) {
	            c = this.svgArc.centroid(updated);
	            x = isNaN(c[0]) ? 0 : c[0];
	            y = isNaN(c[1]) ? 0 : c[1];
	            h = Math.sqrt(x * x + y * y);
	            if ($$.hasType('donut') && config.donut_label_ratio) {
	                ratio = isFunction(config.donut_label_ratio) ? config.donut_label_ratio(d, $$.radius, h) : config.donut_label_ratio;
	            } else if ($$.hasType('pie') && config.pie_label_ratio) {
	                ratio = isFunction(config.pie_label_ratio) ? config.pie_label_ratio(d, $$.radius, h) : config.pie_label_ratio;
	            } else {
	                ratio = $$.radius && h ? (36 / $$.radius > 0.375 ? 1.175 - 36 / $$.radius : 0.8) * $$.radius / h : 0;
	            }
	            translate = "translate(" + x * ratio + ',' + y * ratio + ")";
	        } else if (updated && hasGauge && $$.filterTargetsToShow($$.data.targets).length > 1) {
	            var y1 = Math.sin(updated.endAngle - Math.PI / 2);
	            x = Math.cos(updated.endAngle - Math.PI / 2) * ($$.radiusExpanded + 25);
	            y = y1 * ($$.radiusExpanded + 15 - Math.abs(y1 * 10)) + 3;
	            translate = "translate(" + x + ',' + y + ")";
	        }
	        return translate;
	    };
	
	    c3_chart_internal_fn.getArcRatio = function (d) {
	        var $$ = this,
	            config = $$.config,
	            whole = Math.PI * ($$.hasType('gauge') && !config.gauge_fullCircle ? 1 : 2);
	        return d ? (d.endAngle - d.startAngle) / whole : null;
	    };
	
	    c3_chart_internal_fn.convertToArcData = function (d) {
	        return this.addName({
	            id: d.data.id,
	            value: d.value,
	            ratio: this.getArcRatio(d),
	            index: d.index
	        });
	    };
	
	    c3_chart_internal_fn.textForArcLabel = function (d) {
	        var $$ = this,
	            updated,
	            value,
	            ratio,
	            id,
	            format;
	        if (!$$.shouldShowArcLabel()) {
	            return "";
	        }
	        updated = $$.updateAngle(d);
	        value = updated ? updated.value : null;
	        ratio = $$.getArcRatio(updated);
	        id = d.data.id;
	        if (!$$.hasType('gauge') && !$$.meetsArcLabelThreshold(ratio)) {
	            return "";
	        }
	        format = $$.getArcLabelFormat();
	        return format ? format(value, ratio, id) : $$.defaultArcValueFormat(value, ratio);
	    };
	
	    c3_chart_internal_fn.textForGaugeMinMax = function (value, isMax) {
	        var $$ = this,
	            format = $$.getGaugeLabelExtents();
	
	        return format ? format(value, isMax) : value;
	    };
	
	    c3_chart_internal_fn.expandArc = function (targetIds) {
	        var $$ = this,
	            interval;
	
	        // MEMO: avoid to cancel transition
	        if ($$.transiting) {
	            interval = window.setInterval(function () {
	                if (!$$.transiting) {
	                    window.clearInterval(interval);
	                    if ($$.legend.selectAll('.c3-legend-item-focused').size() > 0) {
	                        $$.expandArc(targetIds);
	                    }
	                }
	            }, 10);
	            return;
	        }
	
	        targetIds = $$.mapToTargetIds(targetIds);
	
	        $$.svg.selectAll($$.selectorTargets(targetIds, '.' + CLASS.chartArc)).each(function (d) {
	            if (!$$.shouldExpand(d.data.id)) {
	                return;
	            }
	            $$.d3.select(this).selectAll('path').transition().duration($$.expandDuration(d.data.id)).attr("d", $$.svgArcExpanded).transition().duration($$.expandDuration(d.data.id) * 2).attr("d", $$.svgArcExpandedSub).each(function (d) {
	                if ($$.isDonutType(d.data)) ;
	            });
	        });
	    };
	
	    c3_chart_internal_fn.unexpandArc = function (targetIds) {
	        var $$ = this;
	
	        if ($$.transiting) {
	            return;
	        }
	
	        targetIds = $$.mapToTargetIds(targetIds);
	
	        $$.svg.selectAll($$.selectorTargets(targetIds, '.' + CLASS.chartArc)).selectAll('path').transition().duration(function (d) {
	            return $$.expandDuration(d.data.id);
	        }).attr("d", $$.svgArc);
	        $$.svg.selectAll('.' + CLASS.arc);
	    };
	
	    c3_chart_internal_fn.expandDuration = function (id) {
	        var $$ = this,
	            config = $$.config;
	
	        if ($$.isDonutType(id)) {
	            return config.donut_expand_duration;
	        } else if ($$.isGaugeType(id)) {
	            return config.gauge_expand_duration;
	        } else if ($$.isPieType(id)) {
	            return config.pie_expand_duration;
	        } else {
	            return 50;
	        }
	    };
	
	    c3_chart_internal_fn.shouldExpand = function (id) {
	        var $$ = this,
	            config = $$.config;
	        return $$.isDonutType(id) && config.donut_expand || $$.isGaugeType(id) && config.gauge_expand || $$.isPieType(id) && config.pie_expand;
	    };
	
	    c3_chart_internal_fn.shouldShowArcLabel = function () {
	        var $$ = this,
	            config = $$.config,
	            shouldShow = true;
	        if ($$.hasType('donut')) {
	            shouldShow = config.donut_label_show;
	        } else if ($$.hasType('pie')) {
	            shouldShow = config.pie_label_show;
	        }
	        // when gauge, always true
	        return shouldShow;
	    };
	
	    c3_chart_internal_fn.meetsArcLabelThreshold = function (ratio) {
	        var $$ = this,
	            config = $$.config,
	            threshold = $$.hasType('donut') ? config.donut_label_threshold : config.pie_label_threshold;
	        return ratio >= threshold;
	    };
	
	    c3_chart_internal_fn.getArcLabelFormat = function () {
	        var $$ = this,
	            config = $$.config,
	            format = config.pie_label_format;
	        if ($$.hasType('gauge')) {
	            format = config.gauge_label_format;
	        } else if ($$.hasType('donut')) {
	            format = config.donut_label_format;
	        }
	        return format;
	    };
	
	    c3_chart_internal_fn.getGaugeLabelExtents = function () {
	        var $$ = this,
	            config = $$.config;
	        return config.gauge_label_extents;
	    };
	
	    c3_chart_internal_fn.getArcTitle = function () {
	        var $$ = this;
	        return $$.hasType('donut') ? $$.config.donut_title : "";
	    };
	
	    c3_chart_internal_fn.updateTargetsForArc = function (targets) {
	        var $$ = this,
	            main = $$.main,
	            mainPieUpdate,
	            mainPieEnter,
	            classChartArc = $$.classChartArc.bind($$),
	            classArcs = $$.classArcs.bind($$),
	            classFocus = $$.classFocus.bind($$);
	        mainPieUpdate = main.select('.' + CLASS.chartArcs).selectAll('.' + CLASS.chartArc).data($$.pie(targets)).attr("class", function (d) {
	            return classChartArc(d) + classFocus(d.data);
	        });
	        mainPieEnter = mainPieUpdate.enter().append("g").attr("class", classChartArc);
	        mainPieEnter.append('g').attr('class', classArcs);
	        mainPieEnter.append("text").attr("dy", $$.hasType('gauge') ? "-.1em" : ".35em").style("opacity", 0).style("text-anchor", "middle").style("pointer-events", "none");
	        // MEMO: can not keep same color..., but not bad to update color in redraw
	        //mainPieUpdate.exit().remove();
	    };
	
	    c3_chart_internal_fn.initArc = function () {
	        var $$ = this;
	        $$.arcs = $$.main.select('.' + CLASS.chart).append("g").attr("class", CLASS.chartArcs).attr("transform", $$.getTranslate('arc'));
	        $$.arcs.append('text').attr('class', CLASS.chartArcsTitle).style("text-anchor", "middle").text($$.getArcTitle());
	    };
	
	    c3_chart_internal_fn.redrawArc = function (duration, durationForExit, withTransform) {
	        var $$ = this,
	            d3 = $$.d3,
	            config = $$.config,
	            main = $$.main,
	            mainArc,
	            backgroundArc,
	            mainArcLabelLine,
	            hasGaugeType = $$.hasType('gauge');
	        mainArc = main.selectAll('.' + CLASS.arcs).selectAll('.' + CLASS.arc).data($$.arcData.bind($$));
	        mainArc.enter().append('path').attr("class", $$.classArc.bind($$)).style("fill", function (d) {
	            return $$.color(d.data);
	        }).style("cursor", function (d) {
	            return config.interaction_enabled && config.data_selection_isselectable(d) ? "pointer" : null;
	        }).each(function (d) {
	            if ($$.isGaugeType(d.data)) {
	                d.startAngle = d.endAngle = config.gauge_startingAngle;
	            }
	            this._current = d;
	        });
	        if (hasGaugeType) {
	            mainArcLabelLine = main.selectAll('.' + CLASS.arcs).selectAll('.' + CLASS.arcLabelLine).data($$.arcData.bind($$));
	            mainArcLabelLine.enter().append('rect').attr("class", function (d) {
	                return CLASS.arcLabelLine + ' ' + CLASS.target + ' ' + CLASS.target + '-' + d.data.id;
	            });
	            if ($$.filterTargetsToShow($$.data.targets).length === 1) {
	                mainArcLabelLine.style("display", "none");
	            } else {
	                mainArcLabelLine.style("fill", function (d) {
	                    return config.color_pattern.length > 0 ? $$.levelColor(d.data.values[0].value) : $$.color(d.data);
	                }).style("display", config.gauge_labelLine_show ? "" : "none").each(function (d) {
	                    var lineLength = 0,
	                        lineThickness = 2,
	                        x = 0,
	                        y = 0,
	                        transform = "";
	                    if ($$.hiddenTargetIds.indexOf(d.data.id) < 0) {
	                        var updated = $$.updateAngle(d),
	                            innerLineLength = $$.gaugeArcWidth / $$.filterTargetsToShow($$.data.targets).length * (updated.index + 1),
	                            lineAngle = updated.endAngle - Math.PI / 2,
	                            arcInnerRadius = $$.radius - innerLineLength,
	                            linePositioningAngle = lineAngle - (arcInnerRadius === 0 ? 0 : 1 / arcInnerRadius);
	                        lineLength = $$.radiusExpanded - $$.radius + innerLineLength;
	                        x = Math.cos(linePositioningAngle) * arcInnerRadius;
	                        y = Math.sin(linePositioningAngle) * arcInnerRadius;
	                        transform = "rotate(" + lineAngle * 180 / Math.PI + ", " + x + ", " + y + ")";
	                    }
	                    d3.select(this).attr({ x: x, y: y, width: lineLength, height: lineThickness, transform: transform }).style("stroke-dasharray", "0, " + (lineLength + lineThickness) + ", 0");
	                });
	            }
	        }
	        mainArc.attr("transform", function (d) {
	            return !$$.isGaugeType(d.data) && withTransform ? "scale(0)" : "";
	        }).on('mouseover', config.interaction_enabled ? function (d) {
	            var updated, arcData;
	            if ($$.transiting) {
	                // skip while transiting
	                return;
	            }
	            updated = $$.updateAngle(d);
	            if (updated) {
	                arcData = $$.convertToArcData(updated);
	                // transitions
	                $$.expandArc(updated.data.id);
	                $$.api.focus(updated.data.id);
	                $$.toggleFocusLegend(updated.data.id, true);
	                $$.config.data_onmouseover(arcData, this);
	            }
	        } : null).on('mousemove', config.interaction_enabled ? function (d) {
	            var updated = $$.updateAngle(d),
	                arcData,
	                selectedData;
	            if (updated) {
	                arcData = $$.convertToArcData(updated), selectedData = [arcData];
	                $$.showTooltip(selectedData, this);
	            }
	        } : null).on('mouseout', config.interaction_enabled ? function (d) {
	            var updated, arcData;
	            if ($$.transiting) {
	                // skip while transiting
	                return;
	            }
	            updated = $$.updateAngle(d);
	            if (updated) {
	                arcData = $$.convertToArcData(updated);
	                // transitions
	                $$.unexpandArc(updated.data.id);
	                $$.api.revert();
	                $$.revertLegend();
	                $$.hideTooltip();
	                $$.config.data_onmouseout(arcData, this);
	            }
	        } : null).on('click', config.interaction_enabled ? function (d, i) {
	            var updated = $$.updateAngle(d),
	                arcData;
	            if (updated) {
	                arcData = $$.convertToArcData(updated);
	                if ($$.toggleShape) {
	                    $$.toggleShape(this, arcData, i);
	                }
	                $$.config.data_onclick.call($$.api, arcData, this);
	            }
	        } : null).each(function () {
	            $$.transiting = true;
	        }).transition().duration(duration).attrTween("d", function (d) {
	            var updated = $$.updateAngle(d),
	                interpolate;
	            if (!updated) {
	                return function () {
	                    return "M 0 0";
	                };
	            }
	            //                if (this._current === d) {
	            //                    this._current = {
	            //                        startAngle: Math.PI*2,
	            //                        endAngle: Math.PI*2,
	            //                    };
	            //                }
	            if (isNaN(this._current.startAngle)) {
	                this._current.startAngle = 0;
	            }
	            if (isNaN(this._current.endAngle)) {
	                this._current.endAngle = this._current.startAngle;
	            }
	            interpolate = d3.interpolate(this._current, updated);
	            this._current = interpolate(0);
	            return function (t) {
	                var interpolated = interpolate(t);
	                interpolated.data = d.data; // data.id will be updated by interporator
	                return $$.getArc(interpolated, true);
	            };
	        }).attr("transform", withTransform ? "scale(1)" : "").style("fill", function (d) {
	            return $$.levelColor ? $$.levelColor(d.data.values[0].value) : $$.color(d.data.id);
	        }) // Where gauge reading color would receive customization.
	        .call($$.endall, function () {
	            $$.transiting = false;
	        });
	        mainArc.exit().transition().duration(durationForExit).style('opacity', 0).remove();
	        main.selectAll('.' + CLASS.chartArc).select('text').style("opacity", 0).attr('class', function (d) {
	            return $$.isGaugeType(d.data) ? CLASS.gaugeValue : '';
	        }).text($$.textForArcLabel.bind($$)).attr("transform", $$.transformForArcLabel.bind($$)).style('font-size', function (d) {
	            return $$.isGaugeType(d.data) && $$.filterTargetsToShow($$.data.targets).length === 1 ? Math.round($$.radius / 5) + 'px' : '';
	        }).transition().duration(duration).style("opacity", function (d) {
	            return $$.isTargetToShow(d.data.id) && $$.isArcType(d.data) ? 1 : 0;
	        });
	        main.select('.' + CLASS.chartArcsTitle).style("opacity", $$.hasType('donut') || hasGaugeType ? 1 : 0);
	
	        if (hasGaugeType) {
	            var index = 0;
	            backgroundArc = $$.arcs.select('g.' + CLASS.chartArcsBackground).selectAll('path.' + CLASS.chartArcsBackground).data($$.data.targets);
	            backgroundArc.enter().append("path");
	            backgroundArc.attr("class", function (d, i) {
	                return CLASS.chartArcsBackground + ' ' + CLASS.chartArcsBackground + '-' + i;
	            }).attr("d", function (d1) {
	                if ($$.hiddenTargetIds.indexOf(d1.id) >= 0) {
	                    return "M 0 0";
	                }
	
	                var d = {
	                    data: [{ value: config.gauge_max }],
	                    startAngle: config.gauge_startingAngle,
	                    endAngle: -1 * config.gauge_startingAngle * (config.gauge_fullCircle ? Math.PI : 1),
	                    index: index++
	                };
	                return $$.getArc(d, true, true);
	            });
	            backgroundArc.exit().remove();
	
	            $$.arcs.select('.' + CLASS.chartArcsGaugeUnit).attr("dy", ".75em").text(config.gauge_label_show ? config.gauge_units : '');
	            $$.arcs.select('.' + CLASS.chartArcsGaugeMin).attr("dx", -1 * ($$.innerRadius + ($$.radius - $$.innerRadius) / (config.gauge_fullCircle ? 1 : 2)) + "px").attr("dy", "1.2em").text(config.gauge_label_show ? $$.textForGaugeMinMax(config.gauge_min, false) : '');
	            $$.arcs.select('.' + CLASS.chartArcsGaugeMax).attr("dx", $$.innerRadius + ($$.radius - $$.innerRadius) / (config.gauge_fullCircle ? 1 : 2) + "px").attr("dy", "1.2em").text(config.gauge_label_show ? $$.textForGaugeMinMax(config.gauge_max, true) : '');
	        }
	    };
	    c3_chart_internal_fn.initGauge = function () {
	        var arcs = this.arcs;
	        if (this.hasType('gauge')) {
	            arcs.append('g').attr("class", CLASS.chartArcsBackground);
	            arcs.append("text").attr("class", CLASS.chartArcsGaugeUnit).style("text-anchor", "middle").style("pointer-events", "none");
	            arcs.append("text").attr("class", CLASS.chartArcsGaugeMin).style("text-anchor", "middle").style("pointer-events", "none");
	            arcs.append("text").attr("class", CLASS.chartArcsGaugeMax).style("text-anchor", "middle").style("pointer-events", "none");
	        }
	    };
	    c3_chart_internal_fn.getGaugeLabelHeight = function () {
	        return this.config.gauge_label_show ? 20 : 0;
	    };
	
	    c3_chart_internal_fn.hasCaches = function (ids) {
	        for (var i = 0; i < ids.length; i++) {
	            if (!(ids[i] in this.cache)) {
	                return false;
	            }
	        }
	        return true;
	    };
	    c3_chart_internal_fn.addCache = function (id, target) {
	        this.cache[id] = this.cloneTarget(target);
	    };
	    c3_chart_internal_fn.getCaches = function (ids) {
	        var targets = [],
	            i;
	        for (i = 0; i < ids.length; i++) {
	            if (ids[i] in this.cache) {
	                targets.push(this.cloneTarget(this.cache[ids[i]]));
	            }
	        }
	        return targets;
	    };
	
	    c3_chart_internal_fn.categoryName = function (i) {
	        var config = this.config;
	        return i < config.axis_x_categories.length ? config.axis_x_categories[i] : i;
	    };
	
	    c3_chart_internal_fn.generateClass = function (prefix, targetId) {
	        return " " + prefix + " " + prefix + this.getTargetSelectorSuffix(targetId);
	    };
	    c3_chart_internal_fn.classText = function (d) {
	        return this.generateClass(CLASS.text, d.index);
	    };
	    c3_chart_internal_fn.classTexts = function (d) {
	        return this.generateClass(CLASS.texts, d.id);
	    };
	    c3_chart_internal_fn.classShape = function (d) {
	        return this.generateClass(CLASS.shape, d.index);
	    };
	    c3_chart_internal_fn.classShapes = function (d) {
	        return this.generateClass(CLASS.shapes, d.id);
	    };
	    c3_chart_internal_fn.classLine = function (d) {
	        return this.classShape(d) + this.generateClass(CLASS.line, d.id);
	    };
	    c3_chart_internal_fn.classLines = function (d) {
	        return this.classShapes(d) + this.generateClass(CLASS.lines, d.id);
	    };
	    c3_chart_internal_fn.classCircle = function (d) {
	        return this.classShape(d) + this.generateClass(CLASS.circle, d.index);
	    };
	    c3_chart_internal_fn.classCircles = function (d) {
	        return this.classShapes(d) + this.generateClass(CLASS.circles, d.id);
	    };
	    c3_chart_internal_fn.classBar = function (d) {
	        return this.classShape(d) + this.generateClass(CLASS.bar, d.index);
	    };
	    c3_chart_internal_fn.classBars = function (d) {
	        return this.classShapes(d) + this.generateClass(CLASS.bars, d.id);
	    };
	    c3_chart_internal_fn.classArc = function (d) {
	        return this.classShape(d.data) + this.generateClass(CLASS.arc, d.data.id);
	    };
	    c3_chart_internal_fn.classArcs = function (d) {
	        return this.classShapes(d.data) + this.generateClass(CLASS.arcs, d.data.id);
	    };
	    c3_chart_internal_fn.classArea = function (d) {
	        return this.classShape(d) + this.generateClass(CLASS.area, d.id);
	    };
	    c3_chart_internal_fn.classAreas = function (d) {
	        return this.classShapes(d) + this.generateClass(CLASS.areas, d.id);
	    };
	    c3_chart_internal_fn.classRegion = function (d, i) {
	        return this.generateClass(CLASS.region, i) + ' ' + ('class' in d ? d['class'] : '');
	    };
	    c3_chart_internal_fn.classEvent = function (d) {
	        return this.generateClass(CLASS.eventRect, d.index);
	    };
	    c3_chart_internal_fn.classTarget = function (id) {
	        var $$ = this;
	        var additionalClassSuffix = $$.config.data_classes[id],
	            additionalClass = '';
	        if (additionalClassSuffix) {
	            additionalClass = ' ' + CLASS.target + '-' + additionalClassSuffix;
	        }
	        return $$.generateClass(CLASS.target, id) + additionalClass;
	    };
	    c3_chart_internal_fn.classFocus = function (d) {
	        return this.classFocused(d) + this.classDefocused(d);
	    };
	    c3_chart_internal_fn.classFocused = function (d) {
	        return ' ' + (this.focusedTargetIds.indexOf(d.id) >= 0 ? CLASS.focused : '');
	    };
	    c3_chart_internal_fn.classDefocused = function (d) {
	        return ' ' + (this.defocusedTargetIds.indexOf(d.id) >= 0 ? CLASS.defocused : '');
	    };
	    c3_chart_internal_fn.classChartText = function (d) {
	        return CLASS.chartText + this.classTarget(d.id);
	    };
	    c3_chart_internal_fn.classChartLine = function (d) {
	        return CLASS.chartLine + this.classTarget(d.id);
	    };
	    c3_chart_internal_fn.classChartBar = function (d) {
	        return CLASS.chartBar + this.classTarget(d.id);
	    };
	    c3_chart_internal_fn.classChartArc = function (d) {
	        return CLASS.chartArc + this.classTarget(d.data.id);
	    };
	    c3_chart_internal_fn.getTargetSelectorSuffix = function (targetId) {
	        return targetId || targetId === 0 ? ('-' + targetId).replace(/[\s?!@#$%^&*()_=+,.<>'":;\[\]\/|~`{}\\]/g, '-') : '';
	    };
	    c3_chart_internal_fn.selectorTarget = function (id, prefix) {
	        return (prefix || '') + '.' + CLASS.target + this.getTargetSelectorSuffix(id);
	    };
	    c3_chart_internal_fn.selectorTargets = function (ids, prefix) {
	        var $$ = this;
	        ids = ids || [];
	        return ids.length ? ids.map(function (id) {
	            return $$.selectorTarget(id, prefix);
	        }) : null;
	    };
	    c3_chart_internal_fn.selectorLegend = function (id) {
	        return '.' + CLASS.legendItem + this.getTargetSelectorSuffix(id);
	    };
	    c3_chart_internal_fn.selectorLegends = function (ids) {
	        var $$ = this;
	        return ids && ids.length ? ids.map(function (id) {
	            return $$.selectorLegend(id);
	        }) : null;
	    };
	
	    c3_chart_internal_fn.getClipPath = function (id) {
	        var isIE9 = window.navigator.appVersion.toLowerCase().indexOf("msie 9.") >= 0;
	        return "url(" + (isIE9 ? "" : document.URL.split('#')[0]) + "#" + id + ")";
	    };
	    c3_chart_internal_fn.appendClip = function (parent, id) {
	        return parent.append("clipPath").attr("id", id).append("rect");
	    };
	    c3_chart_internal_fn.getAxisClipX = function (forHorizontal) {
	        // axis line width + padding for left
	        var left = Math.max(30, this.margin.left);
	        return forHorizontal ? -(1 + left) : -(left - 1);
	    };
	    c3_chart_internal_fn.getAxisClipY = function (forHorizontal) {
	        return forHorizontal ? -20 : -this.margin.top;
	    };
	    c3_chart_internal_fn.getXAxisClipX = function () {
	        var $$ = this;
	        return $$.getAxisClipX(!$$.config.axis_rotated);
	    };
	    c3_chart_internal_fn.getXAxisClipY = function () {
	        var $$ = this;
	        return $$.getAxisClipY(!$$.config.axis_rotated);
	    };
	    c3_chart_internal_fn.getYAxisClipX = function () {
	        var $$ = this;
	        return $$.config.axis_y_inner ? -1 : $$.getAxisClipX($$.config.axis_rotated);
	    };
	    c3_chart_internal_fn.getYAxisClipY = function () {
	        var $$ = this;
	        return $$.getAxisClipY($$.config.axis_rotated);
	    };
	    c3_chart_internal_fn.getAxisClipWidth = function (forHorizontal) {
	        var $$ = this,
	            left = Math.max(30, $$.margin.left),
	            right = Math.max(30, $$.margin.right);
	        // width + axis line width + padding for left/right
	        return forHorizontal ? $$.width + 2 + left + right : $$.margin.left + 20;
	    };
	    c3_chart_internal_fn.getAxisClipHeight = function (forHorizontal) {
	        // less than 20 is not enough to show the axis label 'outer' without legend
	        return (forHorizontal ? this.margin.bottom : this.margin.top + this.height) + 20;
	    };
	    c3_chart_internal_fn.getXAxisClipWidth = function () {
	        var $$ = this;
	        return $$.getAxisClipWidth(!$$.config.axis_rotated);
	    };
	    c3_chart_internal_fn.getXAxisClipHeight = function () {
	        var $$ = this;
	        return $$.getAxisClipHeight(!$$.config.axis_rotated);
	    };
	    c3_chart_internal_fn.getYAxisClipWidth = function () {
	        var $$ = this;
	        return $$.getAxisClipWidth($$.config.axis_rotated) + ($$.config.axis_y_inner ? 20 : 0);
	    };
	    c3_chart_internal_fn.getYAxisClipHeight = function () {
	        var $$ = this;
	        return $$.getAxisClipHeight($$.config.axis_rotated);
	    };
	
	    c3_chart_internal_fn.generateColor = function () {
	        var $$ = this,
	            config = $$.config,
	            d3 = $$.d3,
	            colors = config.data_colors,
	            pattern = notEmpty(config.color_pattern) ? config.color_pattern : d3.scale.category10().range(),
	            callback = config.data_color,
	            ids = [];
	
	        return function (d) {
	            var id = d.id || d.data && d.data.id || d,
	                color;
	
	            // if callback function is provided
	            if (colors[id] instanceof Function) {
	                color = colors[id](d);
	            }
	            // if specified, choose that color
	            else if (colors[id]) {
	                    color = colors[id];
	                }
	                // if not specified, choose from pattern
	                else {
	                        if (ids.indexOf(id) < 0) {
	                            ids.push(id);
	                        }
	                        color = pattern[ids.indexOf(id) % pattern.length];
	                        colors[id] = color;
	                    }
	            return callback instanceof Function ? callback(color, d) : color;
	        };
	    };
	    c3_chart_internal_fn.generateLevelColor = function () {
	        var $$ = this,
	            config = $$.config,
	            colors = config.color_pattern,
	            threshold = config.color_threshold,
	            asValue = threshold.unit === 'value',
	            values = threshold.values && threshold.values.length ? threshold.values : [],
	            max = threshold.max || 100;
	        return notEmpty(config.color_threshold) ? function (value) {
	            var i,
	                v,
	                color = colors[colors.length - 1];
	            for (i = 0; i < values.length; i++) {
	                v = asValue ? value : value * 100 / max;
	                if (v < values[i]) {
	                    color = colors[i];
	                    break;
	                }
	            }
	            return color;
	        } : null;
	    };
	
	    c3_chart_internal_fn.getDefaultConfig = function () {
	        var config = {
	            bindto: '#chart',
	            svg_classname: undefined,
	            size_width: undefined,
	            size_height: undefined,
	            padding_left: undefined,
	            padding_right: undefined,
	            padding_top: undefined,
	            padding_bottom: undefined,
	            resize_auto: true,
	            zoom_enabled: false,
	            zoom_extent: undefined,
	            zoom_privileged: false,
	            zoom_rescale: false,
	            zoom_onzoom: function zoom_onzoom() {},
	            zoom_onzoomstart: function zoom_onzoomstart() {},
	            zoom_onzoomend: function zoom_onzoomend() {},
	            zoom_x_min: undefined,
	            zoom_x_max: undefined,
	            interaction_brighten: true,
	            interaction_enabled: true,
	            onmouseover: function onmouseover() {},
	            onmouseout: function onmouseout() {},
	            onresize: function onresize() {},
	            onresized: function onresized() {},
	            oninit: function oninit() {},
	            onrendered: function onrendered() {},
	            transition_duration: 350,
	            data_x: undefined,
	            data_xs: {},
	            data_xFormat: '%Y-%m-%d',
	            data_xLocaltime: true,
	            data_xSort: true,
	            data_idConverter: function data_idConverter(id) {
	                return id;
	            },
	            data_names: {},
	            data_classes: {},
	            data_groups: [],
	            data_axes: {},
	            data_type: undefined,
	            data_types: {},
	            data_labels: {},
	            data_order: 'desc',
	            data_regions: {},
	            data_color: undefined,
	            data_colors: {},
	            data_hide: false,
	            data_filter: undefined,
	            data_selection_enabled: false,
	            data_selection_grouped: false,
	            data_selection_isselectable: function data_selection_isselectable() {
	                return true;
	            },
	            data_selection_multiple: true,
	            data_selection_draggable: false,
	            data_onclick: function data_onclick() {},
	            data_onmouseover: function data_onmouseover() {},
	            data_onmouseout: function data_onmouseout() {},
	            data_onselected: function data_onselected() {},
	            data_onunselected: function data_onunselected() {},
	            data_url: undefined,
	            data_headers: undefined,
	            data_json: undefined,
	            data_rows: undefined,
	            data_columns: undefined,
	            data_mimeType: undefined,
	            data_keys: undefined,
	            // configuration for no plot-able data supplied.
	            data_empty_label_text: "",
	            // subchart
	            subchart_show: false,
	            subchart_size_height: 60,
	            subchart_axis_x_show: true,
	            subchart_onbrush: function subchart_onbrush() {},
	            // color
	            color_pattern: [],
	            color_threshold: {},
	            // legend
	            legend_show: true,
	            legend_hide: false,
	            legend_position: 'bottom',
	            legend_inset_anchor: 'top-left',
	            legend_inset_x: 10,
	            legend_inset_y: 0,
	            legend_inset_step: undefined,
	            legend_item_onclick: undefined,
	            legend_item_onmouseover: undefined,
	            legend_item_onmouseout: undefined,
	            legend_equally: false,
	            legend_padding: 0,
	            legend_item_tile_width: 10,
	            legend_item_tile_height: 10,
	            // axis
	            axis_rotated: false,
	            axis_x_show: true,
	            axis_x_type: 'indexed',
	            axis_x_localtime: true,
	            axis_x_categories: [],
	            axis_x_tick_centered: false,
	            axis_x_tick_format: undefined,
	            axis_x_tick_culling: {},
	            axis_x_tick_culling_max: 10,
	            axis_x_tick_count: undefined,
	            axis_x_tick_fit: true,
	            axis_x_tick_values: null,
	            axis_x_tick_rotate: 0,
	            axis_x_tick_outer: true,
	            axis_x_tick_multiline: true,
	            axis_x_tick_multilineMax: 0,
	            axis_x_tick_width: null,
	            axis_x_max: undefined,
	            axis_x_min: undefined,
	            axis_x_padding: {},
	            axis_x_height: undefined,
	            axis_x_extent: undefined,
	            axis_x_label: {},
	            axis_x_inner: undefined,
	            axis_y_show: true,
	            axis_y_type: undefined,
	            axis_y_max: undefined,
	            axis_y_min: undefined,
	            axis_y_inverted: false,
	            axis_y_center: undefined,
	            axis_y_inner: undefined,
	            axis_y_label: {},
	            axis_y_tick_format: undefined,
	            axis_y_tick_outer: true,
	            axis_y_tick_values: null,
	            axis_y_tick_rotate: 0,
	            axis_y_tick_count: undefined,
	            axis_y_tick_time_value: undefined,
	            axis_y_tick_time_interval: undefined,
	            axis_y_padding: {},
	            axis_y_default: undefined,
	            axis_y2_show: false,
	            axis_y2_max: undefined,
	            axis_y2_min: undefined,
	            axis_y2_inverted: false,
	            axis_y2_center: undefined,
	            axis_y2_inner: undefined,
	            axis_y2_label: {},
	            axis_y2_tick_format: undefined,
	            axis_y2_tick_outer: true,
	            axis_y2_tick_values: null,
	            axis_y2_tick_count: undefined,
	            axis_y2_padding: {},
	            axis_y2_default: undefined,
	            // grid
	            grid_x_show: false,
	            grid_x_type: 'tick',
	            grid_x_lines: [],
	            grid_y_show: false,
	            // not used
	            // grid_y_type: 'tick',
	            grid_y_lines: [],
	            grid_y_ticks: 10,
	            grid_focus_show: true,
	            grid_lines_front: true,
	            // point - point of each data
	            point_show: true,
	            point_r: 2.5,
	            point_sensitivity: 10,
	            point_focus_expand_enabled: true,
	            point_focus_expand_r: undefined,
	            point_select_r: undefined,
	            // line
	            line_connectNull: false,
	            line_step_type: 'step',
	            // bar
	            bar_width: undefined,
	            bar_width_ratio: 0.6,
	            bar_width_max: undefined,
	            bar_zerobased: true,
	            bar_space: 0,
	            // area
	            area_zerobased: true,
	            area_above: false,
	            // pie
	            pie_label_show: true,
	            pie_label_format: undefined,
	            pie_label_threshold: 0.05,
	            pie_label_ratio: undefined,
	            pie_expand: {},
	            pie_expand_duration: 50,
	            // gauge
	            gauge_fullCircle: false,
	            gauge_label_show: true,
	            gauge_labelLine_show: true,
	            gauge_label_format: undefined,
	            gauge_min: 0,
	            gauge_max: 100,
	            gauge_startingAngle: -1 * Math.PI / 2,
	            gauge_label_extents: undefined,
	            gauge_units: undefined,
	            gauge_width: undefined,
	            gauge_arcs_minWidth: 5,
	            gauge_expand: {},
	            gauge_expand_duration: 50,
	            // donut
	            donut_label_show: true,
	            donut_label_format: undefined,
	            donut_label_threshold: 0.05,
	            donut_label_ratio: undefined,
	            donut_width: undefined,
	            donut_title: "",
	            donut_expand: {},
	            donut_expand_duration: 50,
	            // spline
	            spline_interpolation_type: 'cardinal',
	            // region - region to change style
	            regions: [],
	            // tooltip - show when mouseover on each data
	            tooltip_show: true,
	            tooltip_grouped: true,
	            tooltip_order: undefined,
	            tooltip_format_title: undefined,
	            tooltip_format_name: undefined,
	            tooltip_format_value: undefined,
	            tooltip_position: undefined,
	            tooltip_contents: function tooltip_contents(d, defaultTitleFormat, defaultValueFormat, color) {
	                return this.getTooltipContent ? this.getTooltipContent(d, defaultTitleFormat, defaultValueFormat, color) : '';
	            },
	            tooltip_init_show: false,
	            tooltip_init_x: 0,
	            tooltip_init_position: { top: '0px', left: '50px' },
	            tooltip_onshow: function tooltip_onshow() {},
	            tooltip_onhide: function tooltip_onhide() {},
	            // title
	            title_text: undefined,
	            title_padding: {
	                top: 0,
	                right: 0,
	                bottom: 0,
	                left: 0
	            },
	            title_position: 'top-center'
	        };
	
	        Object.keys(this.additionalConfig).forEach(function (key) {
	            config[key] = this.additionalConfig[key];
	        }, this);
	
	        return config;
	    };
	    c3_chart_internal_fn.additionalConfig = {};
	
	    c3_chart_internal_fn.loadConfig = function (config) {
	        var this_config = this.config,
	            target,
	            keys,
	            read;
	        function find() {
	            var key = keys.shift();
	            //        console.log("key =>", key, ", target =>", target);
	            if (key && target && (typeof target === 'undefined' ? 'undefined' : _typeof(target)) === 'object' && key in target) {
	                target = target[key];
	                return find();
	            } else if (!key) {
	                return target;
	            } else {
	                return undefined;
	            }
	        }
	        Object.keys(this_config).forEach(function (key) {
	            target = config;
	            keys = key.split('_');
	            read = find();
	            //        console.log("CONFIG : ", key, read);
	            if (isDefined(read)) {
	                this_config[key] = read;
	            }
	        });
	    };
	
	    c3_chart_internal_fn.convertUrlToData = function (url, mimeType, headers, keys, done) {
	        var $$ = this,
	            type = mimeType ? mimeType : 'csv';
	        var req = $$.d3.xhr(url);
	        if (headers) {
	            Object.keys(headers).forEach(function (header) {
	                req.header(header, headers[header]);
	            });
	        }
	        req.get(function (error, data) {
	            var d;
	            var dataResponse = data.response || data.responseText; // Fixes IE9 XHR issue; see #1345
	            if (!data) {
	                throw new Error(error.responseURL + ' ' + error.status + ' (' + error.statusText + ')');
	            }
	            if (type === 'json') {
	                d = $$.convertJsonToData(JSON.parse(dataResponse), keys);
	            } else if (type === 'tsv') {
	                d = $$.convertTsvToData(dataResponse);
	            } else {
	                d = $$.convertCsvToData(dataResponse);
	            }
	            done.call($$, d);
	        });
	    };
	    c3_chart_internal_fn.convertXsvToData = function (xsv, parser) {
	        var rows = parser.parseRows(xsv),
	            d;
	        if (rows.length === 1) {
	            d = [{}];
	            rows[0].forEach(function (id) {
	                d[0][id] = null;
	            });
	        } else {
	            d = parser.parse(xsv);
	        }
	        return d;
	    };
	    c3_chart_internal_fn.convertCsvToData = function (csv) {
	        return this.convertXsvToData(csv, this.d3.csv);
	    };
	    c3_chart_internal_fn.convertTsvToData = function (tsv) {
	        return this.convertXsvToData(tsv, this.d3.tsv);
	    };
	    c3_chart_internal_fn.convertJsonToData = function (json, keys) {
	        var $$ = this,
	            new_rows = [],
	            targetKeys,
	            data;
	        if (keys) {
	            // when keys specified, json would be an array that includes objects
	            if (keys.x) {
	                targetKeys = keys.value.concat(keys.x);
	                $$.config.data_x = keys.x;
	            } else {
	                targetKeys = keys.value;
	            }
	            new_rows.push(targetKeys);
	            json.forEach(function (o) {
	                var new_row = [];
	                targetKeys.forEach(function (key) {
	                    // convert undefined to null because undefined data will be removed in convertDataToTargets()
	                    var v = $$.findValueInJson(o, key);
	                    if (isUndefined(v)) {
	                        v = null;
	                    }
	                    new_row.push(v);
	                });
	                new_rows.push(new_row);
	            });
	            data = $$.convertRowsToData(new_rows);
	        } else {
	            Object.keys(json).forEach(function (key) {
	                new_rows.push([key].concat(json[key]));
	            });
	            data = $$.convertColumnsToData(new_rows);
	        }
	        return data;
	    };
	    c3_chart_internal_fn.findValueInJson = function (object, path) {
	        path = path.replace(/\[(\w+)\]/g, '.$1'); // convert indexes to properties (replace [] with .)
	        path = path.replace(/^\./, ''); // strip a leading dot
	        var pathArray = path.split('.');
	        for (var i = 0; i < pathArray.length; ++i) {
	            var k = pathArray[i];
	            if (k in object) {
	                object = object[k];
	            } else {
	                return;
	            }
	        }
	        return object;
	    };
	
	    /**
	     * Converts the rows to normalized data.
	     * @param {any[][]} rows The row data
	     * @return {Object[]}
	     */
	    c3_chart_internal_fn.convertRowsToData = function (rows) {
	        var newRows = [];
	        var keys = rows[0];
	
	        for (var i = 1; i < rows.length; i++) {
	            var newRow = {};
	            for (var j = 0; j < rows[i].length; j++) {
	                if (isUndefined(rows[i][j])) {
	                    throw new Error("Source data is missing a component at (" + i + "," + j + ")!");
	                }
	                newRow[keys[j]] = rows[i][j];
	            }
	            newRows.push(newRow);
	        }
	        return newRows;
	    };
	
	    /**
	     * Converts the columns to normalized data.
	     * @param {any[][]} columns The column data
	     * @return {Object[]}
	     */
	    c3_chart_internal_fn.convertColumnsToData = function (columns) {
	        var newRows = [];
	
	        for (var i = 0; i < columns.length; i++) {
	            var key = columns[i][0];
	            for (var j = 1; j < columns[i].length; j++) {
	                if (isUndefined(newRows[j - 1])) {
	                    newRows[j - 1] = {};
	                }
	                if (isUndefined(columns[i][j])) {
	                    throw new Error("Source data is missing a component at (" + i + "," + j + ")!");
	                }
	                newRows[j - 1][key] = columns[i][j];
	            }
	        }
	
	        return newRows;
	    };
	
	    c3_chart_internal_fn.convertDataToTargets = function (data, appendXs) {
	        var $$ = this,
	            config = $$.config,
	            ids = $$.d3.keys(data[0]).filter($$.isNotX, $$),
	            xs = $$.d3.keys(data[0]).filter($$.isX, $$),
	            targets;
	
	        // save x for update data by load when custom x and c3.x API
	        ids.forEach(function (id) {
	            var xKey = $$.getXKey(id);
	
	            if ($$.isCustomX() || $$.isTimeSeries()) {
	                // if included in input data
	                if (xs.indexOf(xKey) >= 0) {
	                    $$.data.xs[id] = (appendXs && $$.data.xs[id] ? $$.data.xs[id] : []).concat(data.map(function (d) {
	                        return d[xKey];
	                    }).filter(isValue).map(function (rawX, i) {
	                        return $$.generateTargetX(rawX, id, i);
	                    }));
	                }
	                // if not included in input data, find from preloaded data of other id's x
	                else if (config.data_x) {
	                        $$.data.xs[id] = $$.getOtherTargetXs();
	                    }
	                    // if not included in input data, find from preloaded data
	                    else if (notEmpty(config.data_xs)) {
	                            $$.data.xs[id] = $$.getXValuesOfXKey(xKey, $$.data.targets);
	                        }
	                // MEMO: if no x included, use same x of current will be used
	            } else {
	                $$.data.xs[id] = data.map(function (d, i) {
	                    return i;
	                });
	            }
	        });
	
	        // check x is defined
	        ids.forEach(function (id) {
	            if (!$$.data.xs[id]) {
	                throw new Error('x is not defined for id = "' + id + '".');
	            }
	        });
	
	        // convert to target
	        targets = ids.map(function (id, index) {
	            var convertedId = config.data_idConverter(id);
	            return {
	                id: convertedId,
	                id_org: id,
	                values: data.map(function (d, i) {
	                    var xKey = $$.getXKey(id),
	                        rawX = d[xKey],
	                        value = d[id] !== null && !isNaN(d[id]) ? +d[id] : null,
	                        x;
	                    // use x as categories if custom x and categorized
	                    if ($$.isCustomX() && $$.isCategorized() && !isUndefined(rawX)) {
	                        if (index === 0 && i === 0) {
	                            config.axis_x_categories = [];
	                        }
	                        x = config.axis_x_categories.indexOf(rawX);
	                        if (x === -1) {
	                            x = config.axis_x_categories.length;
	                            config.axis_x_categories.push(rawX);
	                        }
	                    } else {
	                        x = $$.generateTargetX(rawX, id, i);
	                    }
	                    // mark as x = undefined if value is undefined and filter to remove after mapped
	                    if (isUndefined(d[id]) || $$.data.xs[id].length <= i) {
	                        x = undefined;
	                    }
	                    return { x: x, value: value, id: convertedId };
	                }).filter(function (v) {
	                    return isDefined(v.x);
	                })
	            };
	        });
	
	        // finish targets
	        targets.forEach(function (t) {
	            var i;
	            // sort values by its x
	            if (config.data_xSort) {
	                t.values = t.values.sort(function (v1, v2) {
	                    var x1 = v1.x || v1.x === 0 ? v1.x : Infinity,
	                        x2 = v2.x || v2.x === 0 ? v2.x : Infinity;
	                    return x1 - x2;
	                });
	            }
	            // indexing each value
	            i = 0;
	            t.values.forEach(function (v) {
	                v.index = i++;
	            });
	            // this needs to be sorted because its index and value.index is identical
	            $$.data.xs[t.id].sort(function (v1, v2) {
	                return v1 - v2;
	            });
	        });
	
	        // cache information about values
	        $$.hasNegativeValue = $$.hasNegativeValueInTargets(targets);
	        $$.hasPositiveValue = $$.hasPositiveValueInTargets(targets);
	
	        // set target types
	        if (config.data_type) {
	            $$.setTargetType($$.mapToIds(targets).filter(function (id) {
	                return !(id in config.data_types);
	            }), config.data_type);
	        }
	
	        // cache as original id keyed
	        targets.forEach(function (d) {
	            $$.addCache(d.id_org, d);
	        });
	
	        return targets;
	    };
	
	    c3_chart_internal_fn.isX = function (key) {
	        var $$ = this,
	            config = $$.config;
	        return config.data_x && key === config.data_x || notEmpty(config.data_xs) && hasValue(config.data_xs, key);
	    };
	    c3_chart_internal_fn.isNotX = function (key) {
	        return !this.isX(key);
	    };
	    c3_chart_internal_fn.getXKey = function (id) {
	        var $$ = this,
	            config = $$.config;
	        return config.data_x ? config.data_x : notEmpty(config.data_xs) ? config.data_xs[id] : null;
	    };
	    c3_chart_internal_fn.getXValuesOfXKey = function (key, targets) {
	        var $$ = this,
	            xValues,
	            ids = targets && notEmpty(targets) ? $$.mapToIds(targets) : [];
	        ids.forEach(function (id) {
	            if ($$.getXKey(id) === key) {
	                xValues = $$.data.xs[id];
	            }
	        });
	        return xValues;
	    };
	    c3_chart_internal_fn.getIndexByX = function (x) {
	        var $$ = this,
	            data = $$.filterByX($$.data.targets, x);
	        return data.length ? data[0].index : null;
	    };
	    c3_chart_internal_fn.getXValue = function (id, i) {
	        var $$ = this;
	        return id in $$.data.xs && $$.data.xs[id] && isValue($$.data.xs[id][i]) ? $$.data.xs[id][i] : i;
	    };
	    c3_chart_internal_fn.getOtherTargetXs = function () {
	        var $$ = this,
	            idsForX = Object.keys($$.data.xs);
	        return idsForX.length ? $$.data.xs[idsForX[0]] : null;
	    };
	    c3_chart_internal_fn.getOtherTargetX = function (index) {
	        var xs = this.getOtherTargetXs();
	        return xs && index < xs.length ? xs[index] : null;
	    };
	    c3_chart_internal_fn.addXs = function (xs) {
	        var $$ = this;
	        Object.keys(xs).forEach(function (id) {
	            $$.config.data_xs[id] = xs[id];
	        });
	    };
	    c3_chart_internal_fn.hasMultipleX = function (xs) {
	        return this.d3.set(Object.keys(xs).map(function (id) {
	            return xs[id];
	        })).size() > 1;
	    };
	    c3_chart_internal_fn.isMultipleX = function () {
	        return notEmpty(this.config.data_xs) || !this.config.data_xSort || this.hasType('scatter');
	    };
	    c3_chart_internal_fn.addName = function (data) {
	        var $$ = this,
	            name;
	        if (data) {
	            name = $$.config.data_names[data.id];
	            data.name = name !== undefined ? name : data.id;
	        }
	        return data;
	    };
	    c3_chart_internal_fn.getValueOnIndex = function (values, index) {
	        var valueOnIndex = values.filter(function (v) {
	            return v.index === index;
	        });
	        return valueOnIndex.length ? valueOnIndex[0] : null;
	    };
	    c3_chart_internal_fn.updateTargetX = function (targets, x) {
	        var $$ = this;
	        targets.forEach(function (t) {
	            t.values.forEach(function (v, i) {
	                v.x = $$.generateTargetX(x[i], t.id, i);
	            });
	            $$.data.xs[t.id] = x;
	        });
	    };
	    c3_chart_internal_fn.updateTargetXs = function (targets, xs) {
	        var $$ = this;
	        targets.forEach(function (t) {
	            if (xs[t.id]) {
	                $$.updateTargetX([t], xs[t.id]);
	            }
	        });
	    };
	    c3_chart_internal_fn.generateTargetX = function (rawX, id, index) {
	        var $$ = this,
	            x;
	        if ($$.isTimeSeries()) {
	            x = rawX ? $$.parseDate(rawX) : $$.parseDate($$.getXValue(id, index));
	        } else if ($$.isCustomX() && !$$.isCategorized()) {
	            x = isValue(rawX) ? +rawX : $$.getXValue(id, index);
	        } else {
	            x = index;
	        }
	        return x;
	    };
	    c3_chart_internal_fn.cloneTarget = function (target) {
	        return {
	            id: target.id,
	            id_org: target.id_org,
	            values: target.values.map(function (d) {
	                return { x: d.x, value: d.value, id: d.id };
	            })
	        };
	    };
	    c3_chart_internal_fn.updateXs = function () {
	        var $$ = this;
	        if ($$.data.targets.length) {
	            $$.xs = [];
	            $$.data.targets[0].values.forEach(function (v) {
	                $$.xs[v.index] = v.x;
	            });
	        }
	    };
	    c3_chart_internal_fn.getPrevX = function (i) {
	        var x = this.xs[i - 1];
	        return typeof x !== 'undefined' ? x : null;
	    };
	    c3_chart_internal_fn.getNextX = function (i) {
	        var x = this.xs[i + 1];
	        return typeof x !== 'undefined' ? x : null;
	    };
	    c3_chart_internal_fn.getMaxDataCount = function () {
	        var $$ = this;
	        return $$.d3.max($$.data.targets, function (t) {
	            return t.values.length;
	        });
	    };
	    c3_chart_internal_fn.getMaxDataCountTarget = function (targets) {
	        var length = targets.length,
	            max = 0,
	            maxTarget;
	        if (length > 1) {
	            targets.forEach(function (t) {
	                if (t.values.length > max) {
	                    maxTarget = t;
	                    max = t.values.length;
	                }
	            });
	        } else {
	            maxTarget = length ? targets[0] : null;
	        }
	        return maxTarget;
	    };
	    c3_chart_internal_fn.getEdgeX = function (targets) {
	        var $$ = this;
	        return !targets.length ? [0, 0] : [$$.d3.min(targets, function (t) {
	            return t.values[0].x;
	        }), $$.d3.max(targets, function (t) {
	            return t.values[t.values.length - 1].x;
	        })];
	    };
	    c3_chart_internal_fn.mapToIds = function (targets) {
	        return targets.map(function (d) {
	            return d.id;
	        });
	    };
	    c3_chart_internal_fn.mapToTargetIds = function (ids) {
	        var $$ = this;
	        return ids ? [].concat(ids) : $$.mapToIds($$.data.targets);
	    };
	    c3_chart_internal_fn.hasTarget = function (targets, id) {
	        var ids = this.mapToIds(targets),
	            i;
	        for (i = 0; i < ids.length; i++) {
	            if (ids[i] === id) {
	                return true;
	            }
	        }
	        return false;
	    };
	    c3_chart_internal_fn.isTargetToShow = function (targetId) {
	        return this.hiddenTargetIds.indexOf(targetId) < 0;
	    };
	    c3_chart_internal_fn.isLegendToShow = function (targetId) {
	        return this.hiddenLegendIds.indexOf(targetId) < 0;
	    };
	    c3_chart_internal_fn.filterTargetsToShow = function (targets) {
	        var $$ = this;
	        return targets.filter(function (t) {
	            return $$.isTargetToShow(t.id);
	        });
	    };
	    c3_chart_internal_fn.mapTargetsToUniqueXs = function (targets) {
	        var $$ = this;
	        var xs = $$.d3.set($$.d3.merge(targets.map(function (t) {
	            return t.values.map(function (v) {
	                return +v.x;
	            });
	        }))).values();
	        xs = $$.isTimeSeries() ? xs.map(function (x) {
	            return new Date(+x);
	        }) : xs.map(function (x) {
	            return +x;
	        });
	        return xs.sort(function (a, b) {
	            return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
	        });
	    };
	    c3_chart_internal_fn.addHiddenTargetIds = function (targetIds) {
	        targetIds = targetIds instanceof Array ? targetIds : new Array(targetIds);
	        for (var i = 0; i < targetIds.length; i++) {
	            if (this.hiddenTargetIds.indexOf(targetIds[i]) < 0) {
	                this.hiddenTargetIds = this.hiddenTargetIds.concat(targetIds[i]);
	            }
	        }
	    };
	    c3_chart_internal_fn.removeHiddenTargetIds = function (targetIds) {
	        this.hiddenTargetIds = this.hiddenTargetIds.filter(function (id) {
	            return targetIds.indexOf(id) < 0;
	        });
	    };
	    c3_chart_internal_fn.addHiddenLegendIds = function (targetIds) {
	        targetIds = targetIds instanceof Array ? targetIds : new Array(targetIds);
	        for (var i = 0; i < targetIds.length; i++) {
	            if (this.hiddenLegendIds.indexOf(targetIds[i]) < 0) {
	                this.hiddenLegendIds = this.hiddenLegendIds.concat(targetIds[i]);
	            }
	        }
	    };
	    c3_chart_internal_fn.removeHiddenLegendIds = function (targetIds) {
	        this.hiddenLegendIds = this.hiddenLegendIds.filter(function (id) {
	            return targetIds.indexOf(id) < 0;
	        });
	    };
	    c3_chart_internal_fn.getValuesAsIdKeyed = function (targets) {
	        var ys = {};
	        targets.forEach(function (t) {
	            ys[t.id] = [];
	            t.values.forEach(function (v) {
	                ys[t.id].push(v.value);
	            });
	        });
	        return ys;
	    };
	    c3_chart_internal_fn.checkValueInTargets = function (targets, checker) {
	        var ids = Object.keys(targets),
	            i,
	            j,
	            values;
	        for (i = 0; i < ids.length; i++) {
	            values = targets[ids[i]].values;
	            for (j = 0; j < values.length; j++) {
	                if (checker(values[j].value)) {
	                    return true;
	                }
	            }
	        }
	        return false;
	    };
	    c3_chart_internal_fn.hasNegativeValueInTargets = function (targets) {
	        return this.checkValueInTargets(targets, function (v) {
	            return v < 0;
	        });
	    };
	    c3_chart_internal_fn.hasPositiveValueInTargets = function (targets) {
	        return this.checkValueInTargets(targets, function (v) {
	            return v > 0;
	        });
	    };
	    c3_chart_internal_fn.isOrderDesc = function () {
	        var config = this.config;
	        return typeof config.data_order === 'string' && config.data_order.toLowerCase() === 'desc';
	    };
	    c3_chart_internal_fn.isOrderAsc = function () {
	        var config = this.config;
	        return typeof config.data_order === 'string' && config.data_order.toLowerCase() === 'asc';
	    };
	    c3_chart_internal_fn.getOrderFunction = function () {
	        var $$ = this,
	            config = $$.config,
	            orderAsc = $$.isOrderAsc(),
	            orderDesc = $$.isOrderDesc();
	        if (orderAsc || orderDesc) {
	            return function (t1, t2) {
	                var reducer = function reducer(p, c) {
	                    return p + Math.abs(c.value);
	                };
	                var t1Sum = t1.values.reduce(reducer, 0),
	                    t2Sum = t2.values.reduce(reducer, 0);
	                return orderDesc ? t2Sum - t1Sum : t1Sum - t2Sum;
	            };
	        } else if (isFunction(config.data_order)) {
	            return config.data_order;
	        } else if (isArray(config.data_order)) {
	            var order = config.data_order;
	            return function (t1, t2) {
	                return order.indexOf(t1.id) - order.indexOf(t2.id);
	            };
	        }
	    };
	    c3_chart_internal_fn.orderTargets = function (targets) {
	        var fct = this.getOrderFunction();
	        if (fct) {
	            targets.sort(fct);
	            if (this.isOrderAsc() || this.isOrderDesc()) {
	                targets.reverse();
	            }
	        }
	        return targets;
	    };
	    c3_chart_internal_fn.filterByX = function (targets, x) {
	        return this.d3.merge(targets.map(function (t) {
	            return t.values;
	        })).filter(function (v) {
	            return v.x - x === 0;
	        });
	    };
	    c3_chart_internal_fn.filterRemoveNull = function (data) {
	        return data.filter(function (d) {
	            return isValue(d.value);
	        });
	    };
	    c3_chart_internal_fn.filterByXDomain = function (targets, xDomain) {
	        return targets.map(function (t) {
	            return {
	                id: t.id,
	                id_org: t.id_org,
	                values: t.values.filter(function (v) {
	                    return xDomain[0] <= v.x && v.x <= xDomain[1];
	                })
	            };
	        });
	    };
	    c3_chart_internal_fn.hasDataLabel = function () {
	        var config = this.config;
	        if (typeof config.data_labels === 'boolean' && config.data_labels) {
	            return true;
	        } else if (_typeof(config.data_labels) === 'object' && notEmpty(config.data_labels)) {
	            return true;
	        }
	        return false;
	    };
	    c3_chart_internal_fn.getDataLabelLength = function (min, max, key) {
	        var $$ = this,
	            lengths = [0, 0],
	            paddingCoef = 1.3;
	        $$.selectChart.select('svg').selectAll('.dummy').data([min, max]).enter().append('text').text(function (d) {
	            return $$.dataLabelFormat(d.id)(d);
	        }).each(function (d, i) {
	            lengths[i] = this.getBoundingClientRect()[key] * paddingCoef;
	        }).remove();
	        return lengths;
	    };
	    c3_chart_internal_fn.isNoneArc = function (d) {
	        return this.hasTarget(this.data.targets, d.id);
	    }, c3_chart_internal_fn.isArc = function (d) {
	        return 'data' in d && this.hasTarget(this.data.targets, d.data.id);
	    };
	    c3_chart_internal_fn.findSameXOfValues = function (values, index) {
	        var i,
	            targetX = values[index].x,
	            sames = [];
	        for (i = index - 1; i >= 0; i--) {
	            if (targetX !== values[i].x) {
	                break;
	            }
	            sames.push(values[i]);
	        }
	        for (i = index; i < values.length; i++) {
	            if (targetX !== values[i].x) {
	                break;
	            }
	            sames.push(values[i]);
	        }
	        return sames;
	    };
	
	    c3_chart_internal_fn.findClosestFromTargets = function (targets, pos) {
	        var $$ = this,
	            candidates;
	
	        // map to array of closest points of each target
	        candidates = targets.map(function (target) {
	            return $$.findClosest(target.values, pos);
	        });
	
	        // decide closest point and return
	        return $$.findClosest(candidates, pos);
	    };
	    c3_chart_internal_fn.findClosest = function (values, pos) {
	        var $$ = this,
	            minDist = $$.config.point_sensitivity,
	            closest;
	
	        // find mouseovering bar
	        values.filter(function (v) {
	            return v && $$.isBarType(v.id);
	        }).forEach(function (v) {
	            var shape = $$.main.select('.' + CLASS.bars + $$.getTargetSelectorSuffix(v.id) + ' .' + CLASS.bar + '-' + v.index).node();
	            if (!closest && $$.isWithinBar(shape)) {
	                closest = v;
	            }
	        });
	
	        // find closest point from non-bar
	        values.filter(function (v) {
	            return v && !$$.isBarType(v.id);
	        }).forEach(function (v) {
	            var d = $$.dist(v, pos);
	            if (d < minDist) {
	                minDist = d;
	                closest = v;
	            }
	        });
	
	        return closest;
	    };
	    c3_chart_internal_fn.dist = function (data, pos) {
	        var $$ = this,
	            config = $$.config,
	            xIndex = config.axis_rotated ? 1 : 0,
	            yIndex = config.axis_rotated ? 0 : 1,
	            y = $$.circleY(data, data.index),
	            x = $$.x(data.x);
	        return Math.sqrt(Math.pow(x - pos[xIndex], 2) + Math.pow(y - pos[yIndex], 2));
	    };
	    c3_chart_internal_fn.convertValuesToStep = function (values) {
	        var converted = [].concat(values),
	            i;
	
	        if (!this.isCategorized()) {
	            return values;
	        }
	
	        for (i = values.length + 1; 0 < i; i--) {
	            converted[i] = converted[i - 1];
	        }
	
	        converted[0] = {
	            x: converted[0].x - 1,
	            value: converted[0].value,
	            id: converted[0].id
	        };
	        converted[values.length + 1] = {
	            x: converted[values.length].x + 1,
	            value: converted[values.length].value,
	            id: converted[values.length].id
	        };
	
	        return converted;
	    };
	    c3_chart_internal_fn.updateDataAttributes = function (name, attrs) {
	        var $$ = this,
	            config = $$.config,
	            current = config['data_' + name];
	        if (typeof attrs === 'undefined') {
	            return current;
	        }
	        Object.keys(attrs).forEach(function (id) {
	            current[id] = attrs[id];
	        });
	        $$.redraw({ withLegend: true });
	        return current;
	    };
	
	    c3_chart_internal_fn.load = function (targets, args) {
	        var $$ = this;
	        if (targets) {
	            // filter loading targets if needed
	            if (args.filter) {
	                targets = targets.filter(args.filter);
	            }
	            // set type if args.types || args.type specified
	            if (args.type || args.types) {
	                targets.forEach(function (t) {
	                    var type = args.types && args.types[t.id] ? args.types[t.id] : args.type;
	                    $$.setTargetType(t.id, type);
	                });
	            }
	            // Update/Add data
	            $$.data.targets.forEach(function (d) {
	                for (var i = 0; i < targets.length; i++) {
	                    if (d.id === targets[i].id) {
	                        d.values = targets[i].values;
	                        targets.splice(i, 1);
	                        break;
	                    }
	                }
	            });
	            $$.data.targets = $$.data.targets.concat(targets); // add remained
	        }
	
	        // Set targets
	        $$.updateTargets($$.data.targets);
	
	        // Redraw with new targets
	        $$.redraw({ withUpdateOrgXDomain: true, withUpdateXDomain: true, withLegend: true });
	
	        if (args.done) {
	            args.done();
	        }
	    };
	    c3_chart_internal_fn.loadFromArgs = function (args) {
	        var $$ = this;
	        if (args.data) {
	            $$.load($$.convertDataToTargets(args.data), args);
	        } else if (args.url) {
	            $$.convertUrlToData(args.url, args.mimeType, args.headers, args.keys, function (data) {
	                $$.load($$.convertDataToTargets(data), args);
	            });
	        } else if (args.json) {
	            $$.load($$.convertDataToTargets($$.convertJsonToData(args.json, args.keys)), args);
	        } else if (args.rows) {
	            $$.load($$.convertDataToTargets($$.convertRowsToData(args.rows)), args);
	        } else if (args.columns) {
	            $$.load($$.convertDataToTargets($$.convertColumnsToData(args.columns)), args);
	        } else {
	            $$.load(null, args);
	        }
	    };
	    c3_chart_internal_fn.unload = function (targetIds, done) {
	        var $$ = this;
	        if (!done) {
	            done = function done() {};
	        }
	        // filter existing target
	        targetIds = targetIds.filter(function (id) {
	            return $$.hasTarget($$.data.targets, id);
	        });
	        // If no target, call done and return
	        if (!targetIds || targetIds.length === 0) {
	            done();
	            return;
	        }
	        $$.svg.selectAll(targetIds.map(function (id) {
	            return $$.selectorTarget(id);
	        })).transition().style('opacity', 0).remove().call($$.endall, done);
	        targetIds.forEach(function (id) {
	            // Reset fadein for future load
	            $$.withoutFadeIn[id] = false;
	            // Remove target's elements
	            if ($$.legend) {
	                $$.legend.selectAll('.' + CLASS.legendItem + $$.getTargetSelectorSuffix(id)).remove();
	            }
	            // Remove target
	            $$.data.targets = $$.data.targets.filter(function (t) {
	                return t.id !== id;
	            });
	        });
	    };
	
	    c3_chart_internal_fn.getYDomainMin = function (targets) {
	        var $$ = this,
	            config = $$.config,
	            ids = $$.mapToIds(targets),
	            ys = $$.getValuesAsIdKeyed(targets),
	            j,
	            k,
	            baseId,
	            idsInGroup,
	            id,
	            hasNegativeValue;
	        if (config.data_groups.length > 0) {
	            hasNegativeValue = $$.hasNegativeValueInTargets(targets);
	            for (j = 0; j < config.data_groups.length; j++) {
	                // Determine baseId
	                idsInGroup = config.data_groups[j].filter(function (id) {
	                    return ids.indexOf(id) >= 0;
	                });
	                if (idsInGroup.length === 0) {
	                    continue;
	                }
	                baseId = idsInGroup[0];
	                // Consider negative values
	                if (hasNegativeValue && ys[baseId]) {
	                    ys[baseId].forEach(function (v, i) {
	                        ys[baseId][i] = v < 0 ? v : 0;
	                    });
	                }
	                // Compute min
	                for (k = 1; k < idsInGroup.length; k++) {
	                    id = idsInGroup[k];
	                    if (!ys[id]) {
	                        continue;
	                    }
	                    ys[id].forEach(function (v, i) {
	                        if ($$.axis.getId(id) === $$.axis.getId(baseId) && ys[baseId] && !(hasNegativeValue && +v > 0)) {
	                            ys[baseId][i] += +v;
	                        }
	                    });
	                }
	            }
	        }
	        return $$.d3.min(Object.keys(ys).map(function (key) {
	            return $$.d3.min(ys[key]);
	        }));
	    };
	    c3_chart_internal_fn.getYDomainMax = function (targets) {
	        var $$ = this,
	            config = $$.config,
	            ids = $$.mapToIds(targets),
	            ys = $$.getValuesAsIdKeyed(targets),
	            j,
	            k,
	            baseId,
	            idsInGroup,
	            id,
	            hasPositiveValue;
	        if (config.data_groups.length > 0) {
	            hasPositiveValue = $$.hasPositiveValueInTargets(targets);
	            for (j = 0; j < config.data_groups.length; j++) {
	                // Determine baseId
	                idsInGroup = config.data_groups[j].filter(function (id) {
	                    return ids.indexOf(id) >= 0;
	                });
	                if (idsInGroup.length === 0) {
	                    continue;
	                }
	                baseId = idsInGroup[0];
	                // Consider positive values
	                if (hasPositiveValue && ys[baseId]) {
	                    ys[baseId].forEach(function (v, i) {
	                        ys[baseId][i] = v > 0 ? v : 0;
	                    });
	                }
	                // Compute max
	                for (k = 1; k < idsInGroup.length; k++) {
	                    id = idsInGroup[k];
	                    if (!ys[id]) {
	                        continue;
	                    }
	                    ys[id].forEach(function (v, i) {
	                        if ($$.axis.getId(id) === $$.axis.getId(baseId) && ys[baseId] && !(hasPositiveValue && +v < 0)) {
	                            ys[baseId][i] += +v;
	                        }
	                    });
	                }
	            }
	        }
	        return $$.d3.max(Object.keys(ys).map(function (key) {
	            return $$.d3.max(ys[key]);
	        }));
	    };
	    c3_chart_internal_fn.getYDomain = function (targets, axisId, xDomain) {
	        var $$ = this,
	            config = $$.config,
	            targetsByAxisId = targets.filter(function (t) {
	            return $$.axis.getId(t.id) === axisId;
	        }),
	            yTargets = xDomain ? $$.filterByXDomain(targetsByAxisId, xDomain) : targetsByAxisId,
	            yMin = axisId === 'y2' ? config.axis_y2_min : config.axis_y_min,
	            yMax = axisId === 'y2' ? config.axis_y2_max : config.axis_y_max,
	            yDomainMin = $$.getYDomainMin(yTargets),
	            yDomainMax = $$.getYDomainMax(yTargets),
	            domain,
	            domainLength,
	            padding,
	            padding_top,
	            padding_bottom,
	            center = axisId === 'y2' ? config.axis_y2_center : config.axis_y_center,
	            yDomainAbs,
	            lengths,
	            diff,
	            ratio,
	            isAllPositive,
	            isAllNegative,
	            isZeroBased = $$.hasType('bar', yTargets) && config.bar_zerobased || $$.hasType('area', yTargets) && config.area_zerobased,
	            isInverted = axisId === 'y2' ? config.axis_y2_inverted : config.axis_y_inverted,
	            showHorizontalDataLabel = $$.hasDataLabel() && config.axis_rotated,
	            showVerticalDataLabel = $$.hasDataLabel() && !config.axis_rotated;
	
	        // MEMO: avoid inverting domain unexpectedly
	        yDomainMin = isValue(yMin) ? yMin : isValue(yMax) ? yDomainMin < yMax ? yDomainMin : yMax - 10 : yDomainMin;
	        yDomainMax = isValue(yMax) ? yMax : isValue(yMin) ? yMin < yDomainMax ? yDomainMax : yMin + 10 : yDomainMax;
	
	        if (yTargets.length === 0) {
	            // use current domain if target of axisId is none
	            return axisId === 'y2' ? $$.y2.domain() : $$.y.domain();
	        }
	        if (isNaN(yDomainMin)) {
	            // set minimum to zero when not number
	            yDomainMin = 0;
	        }
	        if (isNaN(yDomainMax)) {
	            // set maximum to have same value as yDomainMin
	            yDomainMax = yDomainMin;
	        }
	        if (yDomainMin === yDomainMax) {
	            yDomainMin < 0 ? yDomainMax = 0 : yDomainMin = 0;
	        }
	        isAllPositive = yDomainMin >= 0 && yDomainMax >= 0;
	        isAllNegative = yDomainMin <= 0 && yDomainMax <= 0;
	
	        // Cancel zerobased if axis_*_min / axis_*_max specified
	        if (isValue(yMin) && isAllPositive || isValue(yMax) && isAllNegative) {
	            isZeroBased = false;
	        }
	
	        // Bar/Area chart should be 0-based if all positive|negative
	        if (isZeroBased) {
	            if (isAllPositive) {
	                yDomainMin = 0;
	            }
	            if (isAllNegative) {
	                yDomainMax = 0;
	            }
	        }
	
	        domainLength = Math.abs(yDomainMax - yDomainMin);
	        padding = padding_top = padding_bottom = domainLength * 0.1;
	
	        if (typeof center !== 'undefined') {
	            yDomainAbs = Math.max(Math.abs(yDomainMin), Math.abs(yDomainMax));
	            yDomainMax = center + yDomainAbs;
	            yDomainMin = center - yDomainAbs;
	        }
	        // add padding for data label
	        if (showHorizontalDataLabel) {
	            lengths = $$.getDataLabelLength(yDomainMin, yDomainMax, 'width');
	            diff = diffDomain($$.y.range());
	            ratio = [lengths[0] / diff, lengths[1] / diff];
	            padding_top += domainLength * (ratio[1] / (1 - ratio[0] - ratio[1]));
	            padding_bottom += domainLength * (ratio[0] / (1 - ratio[0] - ratio[1]));
	        } else if (showVerticalDataLabel) {
	            lengths = $$.getDataLabelLength(yDomainMin, yDomainMax, 'height');
	            padding_top += $$.axis.convertPixelsToAxisPadding(lengths[1], domainLength);
	            padding_bottom += $$.axis.convertPixelsToAxisPadding(lengths[0], domainLength);
	        }
	        if (axisId === 'y' && notEmpty(config.axis_y_padding)) {
	            padding_top = $$.axis.getPadding(config.axis_y_padding, 'top', padding_top, domainLength);
	            padding_bottom = $$.axis.getPadding(config.axis_y_padding, 'bottom', padding_bottom, domainLength);
	        }
	        if (axisId === 'y2' && notEmpty(config.axis_y2_padding)) {
	            padding_top = $$.axis.getPadding(config.axis_y2_padding, 'top', padding_top, domainLength);
	            padding_bottom = $$.axis.getPadding(config.axis_y2_padding, 'bottom', padding_bottom, domainLength);
	        }
	        // Bar/Area chart should be 0-based if all positive|negative
	        if (isZeroBased) {
	            if (isAllPositive) {
	                padding_bottom = yDomainMin;
	            }
	            if (isAllNegative) {
	                padding_top = -yDomainMax;
	            }
	        }
	        domain = [yDomainMin - padding_bottom, yDomainMax + padding_top];
	        return isInverted ? domain.reverse() : domain;
	    };
	    c3_chart_internal_fn.getXDomainMin = function (targets) {
	        var $$ = this,
	            config = $$.config;
	        return isDefined(config.axis_x_min) ? $$.isTimeSeries() ? this.parseDate(config.axis_x_min) : config.axis_x_min : $$.d3.min(targets, function (t) {
	            return $$.d3.min(t.values, function (v) {
	                return v.x;
	            });
	        });
	    };
	    c3_chart_internal_fn.getXDomainMax = function (targets) {
	        var $$ = this,
	            config = $$.config;
	        return isDefined(config.axis_x_max) ? $$.isTimeSeries() ? this.parseDate(config.axis_x_max) : config.axis_x_max : $$.d3.max(targets, function (t) {
	            return $$.d3.max(t.values, function (v) {
	                return v.x;
	            });
	        });
	    };
	    c3_chart_internal_fn.getXDomainPadding = function (domain) {
	        var $$ = this,
	            config = $$.config,
	            diff = domain[1] - domain[0],
	            maxDataCount,
	            padding,
	            paddingLeft,
	            paddingRight;
	        if ($$.isCategorized()) {
	            padding = 0;
	        } else if ($$.hasType('bar')) {
	            maxDataCount = $$.getMaxDataCount();
	            padding = maxDataCount > 1 ? diff / (maxDataCount - 1) / 2 : 0.5;
	        } else {
	            padding = diff * 0.01;
	        }
	        if (_typeof(config.axis_x_padding) === 'object' && notEmpty(config.axis_x_padding)) {
	            paddingLeft = isValue(config.axis_x_padding.left) ? config.axis_x_padding.left : padding;
	            paddingRight = isValue(config.axis_x_padding.right) ? config.axis_x_padding.right : padding;
	        } else if (typeof config.axis_x_padding === 'number') {
	            paddingLeft = paddingRight = config.axis_x_padding;
	        } else {
	            paddingLeft = paddingRight = padding;
	        }
	        return { left: paddingLeft, right: paddingRight };
	    };
	    c3_chart_internal_fn.getXDomain = function (targets) {
	        var $$ = this,
	            xDomain = [$$.getXDomainMin(targets), $$.getXDomainMax(targets)],
	            firstX = xDomain[0],
	            lastX = xDomain[1],
	            padding = $$.getXDomainPadding(xDomain),
	            min = 0,
	            max = 0;
	        // show center of x domain if min and max are the same
	        if (firstX - lastX === 0 && !$$.isCategorized()) {
	            if ($$.isTimeSeries()) {
	                firstX = new Date(firstX.getTime() * 0.5);
	                lastX = new Date(lastX.getTime() * 1.5);
	            } else {
	                firstX = firstX === 0 ? 1 : firstX * 0.5;
	                lastX = lastX === 0 ? -1 : lastX * 1.5;
	            }
	        }
	        if (firstX || firstX === 0) {
	            min = $$.isTimeSeries() ? new Date(firstX.getTime() - padding.left) : firstX - padding.left;
	        }
	        if (lastX || lastX === 0) {
	            max = $$.isTimeSeries() ? new Date(lastX.getTime() + padding.right) : lastX + padding.right;
	        }
	        return [min, max];
	    };
	    c3_chart_internal_fn.updateXDomain = function (targets, withUpdateXDomain, withUpdateOrgXDomain, withTrim, domain) {
	        var $$ = this,
	            config = $$.config;
	
	        if (withUpdateOrgXDomain) {
	            $$.x.domain(domain ? domain : $$.d3.extent($$.getXDomain(targets)));
	            $$.orgXDomain = $$.x.domain();
	            if (config.zoom_enabled) {
	                $$.zoom.scale($$.x).updateScaleExtent();
	            }
	            $$.subX.domain($$.x.domain());
	            if ($$.brush) {
	                $$.brush.scale($$.subX);
	            }
	        }
	        if (withUpdateXDomain) {
	            $$.x.domain(domain ? domain : !$$.brush || $$.brush.empty() ? $$.orgXDomain : $$.brush.extent());
	            if (config.zoom_enabled) {
	                $$.zoom.scale($$.x).updateScaleExtent();
	            }
	        }
	
	        // Trim domain when too big by zoom mousemove event
	        if (withTrim) {
	            $$.x.domain($$.trimXDomain($$.x.orgDomain()));
	        }
	
	        return $$.x.domain();
	    };
	    c3_chart_internal_fn.trimXDomain = function (domain) {
	        var zoomDomain = this.getZoomDomain(),
	            min = zoomDomain[0],
	            max = zoomDomain[1];
	        if (domain[0] <= min) {
	            domain[1] = +domain[1] + (min - domain[0]);
	            domain[0] = min;
	        }
	        if (max <= domain[1]) {
	            domain[0] = +domain[0] - (domain[1] - max);
	            domain[1] = max;
	        }
	        return domain;
	    };
	
	    c3_chart_internal_fn.drag = function (mouse) {
	        var $$ = this,
	            config = $$.config,
	            main = $$.main,
	            d3 = $$.d3;
	        var sx, sy, mx, my, minX, maxX, minY, maxY;
	
	        if ($$.hasArcType()) {
	            return;
	        }
	        if (!config.data_selection_enabled) {
	            return;
	        } // do nothing if not selectable
	        if (config.zoom_enabled && !$$.zoom.altDomain) {
	            return;
	        } // skip if zoomable because of conflict drag dehavior
	        if (!config.data_selection_multiple) {
	            return;
	        } // skip when single selection because drag is used for multiple selection
	
	        sx = $$.dragStart[0];
	        sy = $$.dragStart[1];
	        mx = mouse[0];
	        my = mouse[1];
	        minX = Math.min(sx, mx);
	        maxX = Math.max(sx, mx);
	        minY = config.data_selection_grouped ? $$.margin.top : Math.min(sy, my);
	        maxY = config.data_selection_grouped ? $$.height : Math.max(sy, my);
	
	        main.select('.' + CLASS.dragarea).attr('x', minX).attr('y', minY).attr('width', maxX - minX).attr('height', maxY - minY);
	        // TODO: binary search when multiple xs
	        main.selectAll('.' + CLASS.shapes).selectAll('.' + CLASS.shape).filter(function (d) {
	            return config.data_selection_isselectable(d);
	        }).each(function (d, i) {
	            var shape = d3.select(this),
	                isSelected = shape.classed(CLASS.SELECTED),
	                isIncluded = shape.classed(CLASS.INCLUDED),
	                _x,
	                _y,
	                _w,
	                _h,
	                toggle,
	                isWithin = false,
	                box;
	            if (shape.classed(CLASS.circle)) {
	                _x = shape.attr("cx") * 1;
	                _y = shape.attr("cy") * 1;
	                toggle = $$.togglePoint;
	                isWithin = minX < _x && _x < maxX && minY < _y && _y < maxY;
	            } else if (shape.classed(CLASS.bar)) {
	                box = getPathBox(this);
	                _x = box.x;
	                _y = box.y;
	                _w = box.width;
	                _h = box.height;
	                toggle = $$.togglePath;
	                isWithin = !(maxX < _x || _x + _w < minX) && !(maxY < _y || _y + _h < minY);
	            } else {
	                // line/area selection not supported yet
	                return;
	            }
	            if (isWithin ^ isIncluded) {
	                shape.classed(CLASS.INCLUDED, !isIncluded);
	                // TODO: included/unincluded callback here
	                shape.classed(CLASS.SELECTED, !isSelected);
	                toggle.call($$, !isSelected, shape, d, i);
	            }
	        });
	    };
	
	    c3_chart_internal_fn.dragstart = function (mouse) {
	        var $$ = this,
	            config = $$.config;
	        if ($$.hasArcType()) {
	            return;
	        }
	        if (!config.data_selection_enabled) {
	            return;
	        } // do nothing if not selectable
	        $$.dragStart = mouse;
	        $$.main.select('.' + CLASS.chart).append('rect').attr('class', CLASS.dragarea).style('opacity', 0.1);
	        $$.dragging = true;
	    };
	
	    c3_chart_internal_fn.dragend = function () {
	        var $$ = this,
	            config = $$.config;
	        if ($$.hasArcType()) {
	            return;
	        }
	        if (!config.data_selection_enabled) {
	            return;
	        } // do nothing if not selectable
	        $$.main.select('.' + CLASS.dragarea).transition().duration(100).style('opacity', 0).remove();
	        $$.main.selectAll('.' + CLASS.shape).classed(CLASS.INCLUDED, false);
	        $$.dragging = false;
	    };
	
	    c3_chart_internal_fn.getYFormat = function (forArc) {
	        var $$ = this,
	            formatForY = forArc && !$$.hasType('gauge') ? $$.defaultArcValueFormat : $$.yFormat,
	            formatForY2 = forArc && !$$.hasType('gauge') ? $$.defaultArcValueFormat : $$.y2Format;
	        return function (v, ratio, id) {
	            var format = $$.axis.getId(id) === 'y2' ? formatForY2 : formatForY;
	            return format.call($$, v, ratio);
	        };
	    };
	    c3_chart_internal_fn.yFormat = function (v) {
	        var $$ = this,
	            config = $$.config,
	            format = config.axis_y_tick_format ? config.axis_y_tick_format : $$.defaultValueFormat;
	        return format(v);
	    };
	    c3_chart_internal_fn.y2Format = function (v) {
	        var $$ = this,
	            config = $$.config,
	            format = config.axis_y2_tick_format ? config.axis_y2_tick_format : $$.defaultValueFormat;
	        return format(v);
	    };
	    c3_chart_internal_fn.defaultValueFormat = function (v) {
	        return isValue(v) ? +v : "";
	    };
	    c3_chart_internal_fn.defaultArcValueFormat = function (v, ratio) {
	        return (ratio * 100).toFixed(1) + '%';
	    };
	    c3_chart_internal_fn.dataLabelFormat = function (targetId) {
	        var $$ = this,
	            data_labels = $$.config.data_labels,
	            format,
	            defaultFormat = function defaultFormat(v) {
	            return isValue(v) ? +v : "";
	        };
	        // find format according to axis id
	        if (typeof data_labels.format === 'function') {
	            format = data_labels.format;
	        } else if (_typeof(data_labels.format) === 'object') {
	            if (data_labels.format[targetId]) {
	                format = data_labels.format[targetId] === true ? defaultFormat : data_labels.format[targetId];
	            } else {
	                format = function format() {
	                    return '';
	                };
	            }
	        } else {
	            format = defaultFormat;
	        }
	        return format;
	    };
	
	    c3_chart_internal_fn.initGrid = function () {
	        var $$ = this,
	            config = $$.config,
	            d3 = $$.d3;
	        $$.grid = $$.main.append('g').attr("clip-path", $$.clipPathForGrid).attr('class', CLASS.grid);
	        if (config.grid_x_show) {
	            $$.grid.append("g").attr("class", CLASS.xgrids);
	        }
	        if (config.grid_y_show) {
	            $$.grid.append('g').attr('class', CLASS.ygrids);
	        }
	        if (config.grid_focus_show) {
	            $$.grid.append('g').attr("class", CLASS.xgridFocus).append('line').attr('class', CLASS.xgridFocus);
	        }
	        $$.xgrid = d3.selectAll([]);
	        if (!config.grid_lines_front) {
	            $$.initGridLines();
	        }
	    };
	    c3_chart_internal_fn.initGridLines = function () {
	        var $$ = this,
	            d3 = $$.d3;
	        $$.gridLines = $$.main.append('g').attr("clip-path", $$.clipPathForGrid).attr('class', CLASS.grid + ' ' + CLASS.gridLines);
	        $$.gridLines.append('g').attr("class", CLASS.xgridLines);
	        $$.gridLines.append('g').attr('class', CLASS.ygridLines);
	        $$.xgridLines = d3.selectAll([]);
	    };
	    c3_chart_internal_fn.updateXGrid = function (withoutUpdate) {
	        var $$ = this,
	            config = $$.config,
	            d3 = $$.d3,
	            xgridData = $$.generateGridData(config.grid_x_type, $$.x),
	            tickOffset = $$.isCategorized() ? $$.xAxis.tickOffset() : 0;
	
	        $$.xgridAttr = config.axis_rotated ? {
	            'x1': 0,
	            'x2': $$.width,
	            'y1': function y1(d) {
	                return $$.x(d) - tickOffset;
	            },
	            'y2': function y2(d) {
	                return $$.x(d) - tickOffset;
	            }
	        } : {
	            'x1': function x1(d) {
	                return $$.x(d) + tickOffset;
	            },
	            'x2': function x2(d) {
	                return $$.x(d) + tickOffset;
	            },
	            'y1': 0,
	            'y2': $$.height
	        };
	
	        $$.xgrid = $$.main.select('.' + CLASS.xgrids).selectAll('.' + CLASS.xgrid).data(xgridData);
	        $$.xgrid.enter().append('line').attr("class", CLASS.xgrid);
	        if (!withoutUpdate) {
	            $$.xgrid.attr($$.xgridAttr).style("opacity", function () {
	                return +d3.select(this).attr(config.axis_rotated ? 'y1' : 'x1') === (config.axis_rotated ? $$.height : 0) ? 0 : 1;
	            });
	        }
	        $$.xgrid.exit().remove();
	    };
	
	    c3_chart_internal_fn.updateYGrid = function () {
	        var $$ = this,
	            config = $$.config,
	            gridValues = $$.yAxis.tickValues() || $$.y.ticks(config.grid_y_ticks);
	        $$.ygrid = $$.main.select('.' + CLASS.ygrids).selectAll('.' + CLASS.ygrid).data(gridValues);
	        $$.ygrid.enter().append('line').attr('class', CLASS.ygrid);
	        $$.ygrid.attr("x1", config.axis_rotated ? $$.y : 0).attr("x2", config.axis_rotated ? $$.y : $$.width).attr("y1", config.axis_rotated ? 0 : $$.y).attr("y2", config.axis_rotated ? $$.height : $$.y);
	        $$.ygrid.exit().remove();
	        $$.smoothLines($$.ygrid, 'grid');
	    };
	
	    c3_chart_internal_fn.gridTextAnchor = function (d) {
	        return d.position ? d.position : "end";
	    };
	    c3_chart_internal_fn.gridTextDx = function (d) {
	        return d.position === 'start' ? 4 : d.position === 'middle' ? 0 : -4;
	    };
	    c3_chart_internal_fn.xGridTextX = function (d) {
	        return d.position === 'start' ? -this.height : d.position === 'middle' ? -this.height / 2 : 0;
	    };
	    c3_chart_internal_fn.yGridTextX = function (d) {
	        return d.position === 'start' ? 0 : d.position === 'middle' ? this.width / 2 : this.width;
	    };
	    c3_chart_internal_fn.updateGrid = function (duration) {
	        var $$ = this,
	            main = $$.main,
	            config = $$.config,
	            xgridLine,
	            ygridLine,
	            yv;
	
	        // hide if arc type
	        $$.grid.style('visibility', $$.hasArcType() ? 'hidden' : 'visible');
	
	        main.select('line.' + CLASS.xgridFocus).style("visibility", "hidden");
	        if (config.grid_x_show) {
	            $$.updateXGrid();
	        }
	        $$.xgridLines = main.select('.' + CLASS.xgridLines).selectAll('.' + CLASS.xgridLine).data(config.grid_x_lines);
	        // enter
	        xgridLine = $$.xgridLines.enter().append('g').attr("class", function (d) {
	            return CLASS.xgridLine + (d['class'] ? ' ' + d['class'] : '');
	        });
	        xgridLine.append('line').style("opacity", 0);
	        xgridLine.append('text').attr("text-anchor", $$.gridTextAnchor).attr("transform", config.axis_rotated ? "" : "rotate(-90)").attr('dx', $$.gridTextDx).attr('dy', -5).style("opacity", 0);
	        // udpate
	        // done in d3.transition() of the end of this function
	        // exit
	        $$.xgridLines.exit().transition().duration(duration).style("opacity", 0).remove();
	
	        // Y-Grid
	        if (config.grid_y_show) {
	            $$.updateYGrid();
	        }
	        $$.ygridLines = main.select('.' + CLASS.ygridLines).selectAll('.' + CLASS.ygridLine).data(config.grid_y_lines);
	        // enter
	        ygridLine = $$.ygridLines.enter().append('g').attr("class", function (d) {
	            return CLASS.ygridLine + (d['class'] ? ' ' + d['class'] : '');
	        });
	        ygridLine.append('line').style("opacity", 0);
	        ygridLine.append('text').attr("text-anchor", $$.gridTextAnchor).attr("transform", config.axis_rotated ? "rotate(-90)" : "").attr('dx', $$.gridTextDx).attr('dy', -5).style("opacity", 0);
	        // update
	        yv = $$.yv.bind($$);
	        $$.ygridLines.select('line').transition().duration(duration).attr("x1", config.axis_rotated ? yv : 0).attr("x2", config.axis_rotated ? yv : $$.width).attr("y1", config.axis_rotated ? 0 : yv).attr("y2", config.axis_rotated ? $$.height : yv).style("opacity", 1);
	        $$.ygridLines.select('text').transition().duration(duration).attr("x", config.axis_rotated ? $$.xGridTextX.bind($$) : $$.yGridTextX.bind($$)).attr("y", yv).text(function (d) {
	            return d.text;
	        }).style("opacity", 1);
	        // exit
	        $$.ygridLines.exit().transition().duration(duration).style("opacity", 0).remove();
	    };
	    c3_chart_internal_fn.redrawGrid = function (withTransition) {
	        var $$ = this,
	            config = $$.config,
	            xv = $$.xv.bind($$),
	            lines = $$.xgridLines.select('line'),
	            texts = $$.xgridLines.select('text');
	        return [(withTransition ? lines.transition() : lines).attr("x1", config.axis_rotated ? 0 : xv).attr("x2", config.axis_rotated ? $$.width : xv).attr("y1", config.axis_rotated ? xv : 0).attr("y2", config.axis_rotated ? xv : $$.height).style("opacity", 1), (withTransition ? texts.transition() : texts).attr("x", config.axis_rotated ? $$.yGridTextX.bind($$) : $$.xGridTextX.bind($$)).attr("y", xv).text(function (d) {
	            return d.text;
	        }).style("opacity", 1)];
	    };
	    c3_chart_internal_fn.showXGridFocus = function (selectedData) {
	        var $$ = this,
	            config = $$.config,
	            dataToShow = selectedData.filter(function (d) {
	            return d && isValue(d.value);
	        }),
	            focusEl = $$.main.selectAll('line.' + CLASS.xgridFocus),
	            xx = $$.xx.bind($$);
	        if (!config.tooltip_show) {
	            return;
	        }
	        // Hide when scatter plot exists
	        if ($$.hasType('scatter') || $$.hasArcType()) {
	            return;
	        }
	        focusEl.style("visibility", "visible").data([dataToShow[0]]).attr(config.axis_rotated ? 'y1' : 'x1', xx).attr(config.axis_rotated ? 'y2' : 'x2', xx);
	        $$.smoothLines(focusEl, 'grid');
	    };
	    c3_chart_internal_fn.hideXGridFocus = function () {
	        this.main.select('line.' + CLASS.xgridFocus).style("visibility", "hidden");
	    };
	    c3_chart_internal_fn.updateXgridFocus = function () {
	        var $$ = this,
	            config = $$.config;
	        $$.main.select('line.' + CLASS.xgridFocus).attr("x1", config.axis_rotated ? 0 : -10).attr("x2", config.axis_rotated ? $$.width : -10).attr("y1", config.axis_rotated ? -10 : 0).attr("y2", config.axis_rotated ? -10 : $$.height);
	    };
	    c3_chart_internal_fn.generateGridData = function (type, scale) {
	        var $$ = this,
	            gridData = [],
	            xDomain,
	            firstYear,
	            lastYear,
	            i,
	            tickNum = $$.main.select("." + CLASS.axisX).selectAll('.tick').size();
	        if (type === 'year') {
	            xDomain = $$.getXDomain();
	            firstYear = xDomain[0].getFullYear();
	            lastYear = xDomain[1].getFullYear();
	            for (i = firstYear; i <= lastYear; i++) {
	                gridData.push(new Date(i + '-01-01 00:00:00'));
	            }
	        } else {
	            gridData = scale.ticks(10);
	            if (gridData.length > tickNum) {
	                // use only int
	                gridData = gridData.filter(function (d) {
	                    return ("" + d).indexOf('.') < 0;
	                });
	            }
	        }
	        return gridData;
	    };
	    c3_chart_internal_fn.getGridFilterToRemove = function (params) {
	        return params ? function (line) {
	            var found = false;
	            [].concat(params).forEach(function (param) {
	                if ('value' in param && line.value === param.value || 'class' in param && line['class'] === param['class']) {
	                    found = true;
	                }
	            });
	            return found;
	        } : function () {
	            return true;
	        };
	    };
	    c3_chart_internal_fn.removeGridLines = function (params, forX) {
	        var $$ = this,
	            config = $$.config,
	            toRemove = $$.getGridFilterToRemove(params),
	            toShow = function toShow(line) {
	            return !toRemove(line);
	        },
	            classLines = forX ? CLASS.xgridLines : CLASS.ygridLines,
	            classLine = forX ? CLASS.xgridLine : CLASS.ygridLine;
	        $$.main.select('.' + classLines).selectAll('.' + classLine).filter(toRemove).transition().duration(config.transition_duration).style('opacity', 0).remove();
	        if (forX) {
	            config.grid_x_lines = config.grid_x_lines.filter(toShow);
	        } else {
	            config.grid_y_lines = config.grid_y_lines.filter(toShow);
	        }
	    };
	
	    c3_chart_internal_fn.initEventRect = function () {
	        var $$ = this;
	        $$.main.select('.' + CLASS.chart).append("g").attr("class", CLASS.eventRects).style('fill-opacity', 0);
	    };
	    c3_chart_internal_fn.redrawEventRect = function () {
	        var $$ = this,
	            config = $$.config,
	            eventRectUpdate,
	            maxDataCountTarget,
	            isMultipleX = $$.isMultipleX();
	
	        // rects for mouseover
	        var eventRects = $$.main.select('.' + CLASS.eventRects).style('cursor', config.zoom_enabled ? config.axis_rotated ? 'ns-resize' : 'ew-resize' : null).classed(CLASS.eventRectsMultiple, isMultipleX).classed(CLASS.eventRectsSingle, !isMultipleX);
	
	        // clear old rects
	        eventRects.selectAll('.' + CLASS.eventRect).remove();
	
	        // open as public variable
	        $$.eventRect = eventRects.selectAll('.' + CLASS.eventRect);
	
	        if (isMultipleX) {
	            eventRectUpdate = $$.eventRect.data([0]);
	            // enter : only one rect will be added
	            $$.generateEventRectsForMultipleXs(eventRectUpdate.enter());
	            // update
	            $$.updateEventRect(eventRectUpdate);
	            // exit : not needed because always only one rect exists
	        } else {
	            // Set data and update $$.eventRect
	            maxDataCountTarget = $$.getMaxDataCountTarget($$.data.targets);
	            eventRects.datum(maxDataCountTarget ? maxDataCountTarget.values : []);
	            $$.eventRect = eventRects.selectAll('.' + CLASS.eventRect);
	            eventRectUpdate = $$.eventRect.data(function (d) {
	                return d;
	            });
	            // enter
	            $$.generateEventRectsForSingleX(eventRectUpdate.enter());
	            // update
	            $$.updateEventRect(eventRectUpdate);
	            // exit
	            eventRectUpdate.exit().remove();
	        }
	    };
	    c3_chart_internal_fn.updateEventRect = function (eventRectUpdate) {
	        var $$ = this,
	            config = $$.config,
	            x,
	            y,
	            w,
	            h,
	            rectW,
	            rectX;
	
	        // set update selection if null
	        eventRectUpdate = eventRectUpdate || $$.eventRect.data(function (d) {
	            return d;
	        });
	
	        if ($$.isMultipleX()) {
	            // TODO: rotated not supported yet
	            x = 0;
	            y = 0;
	            w = $$.width;
	            h = $$.height;
	        } else {
	            if (($$.isCustomX() || $$.isTimeSeries()) && !$$.isCategorized()) {
	
	                // update index for x that is used by prevX and nextX
	                $$.updateXs();
	
	                rectW = function rectW(d) {
	                    var prevX = $$.getPrevX(d.index),
	                        nextX = $$.getNextX(d.index);
	
	                    // if there this is a single data point make the eventRect full width (or height)
	                    if (prevX === null && nextX === null) {
	                        return config.axis_rotated ? $$.height : $$.width;
	                    }
	
	                    if (prevX === null) {
	                        prevX = $$.x.domain()[0];
	                    }
	                    if (nextX === null) {
	                        nextX = $$.x.domain()[1];
	                    }
	
	                    return Math.max(0, ($$.x(nextX) - $$.x(prevX)) / 2);
	                };
	                rectX = function rectX(d) {
	                    var prevX = $$.getPrevX(d.index),
	                        nextX = $$.getNextX(d.index),
	                        thisX = $$.data.xs[d.id][d.index];
	
	                    // if there this is a single data point position the eventRect at 0
	                    if (prevX === null && nextX === null) {
	                        return 0;
	                    }
	
	                    if (prevX === null) {
	                        prevX = $$.x.domain()[0];
	                    }
	
	                    return ($$.x(thisX) + $$.x(prevX)) / 2;
	                };
	            } else {
	                rectW = $$.getEventRectWidth();
	                rectX = function rectX(d) {
	                    return $$.x(d.x) - rectW / 2;
	                };
	            }
	            x = config.axis_rotated ? 0 : rectX;
	            y = config.axis_rotated ? rectX : 0;
	            w = config.axis_rotated ? $$.width : rectW;
	            h = config.axis_rotated ? rectW : $$.height;
	        }
	
	        eventRectUpdate.attr('class', $$.classEvent.bind($$)).attr("x", x).attr("y", y).attr("width", w).attr("height", h);
	    };
	    c3_chart_internal_fn.generateEventRectsForSingleX = function (eventRectEnter) {
	        var $$ = this,
	            d3 = $$.d3,
	            config = $$.config;
	        eventRectEnter.append("rect").attr("class", $$.classEvent.bind($$)).style("cursor", config.data_selection_enabled && config.data_selection_grouped ? "pointer" : null).on('mouseover', function (d) {
	            var index = d.index;
	
	            if ($$.dragging || $$.flowing) {
	                return;
	            } // do nothing while dragging/flowing
	            if ($$.hasArcType()) {
	                return;
	            }
	
	            // Expand shapes for selection
	            if (config.point_focus_expand_enabled) {
	                $$.expandCircles(index, null, true);
	            }
	            $$.expandBars(index, null, true);
	
	            // Call event handler
	            $$.main.selectAll('.' + CLASS.shape + '-' + index).each(function (d) {
	                config.data_onmouseover.call($$.api, d);
	            });
	        }).on('mouseout', function (d) {
	            var index = d.index;
	            if (!$$.config) {
	                return;
	            } // chart is destroyed
	            if ($$.hasArcType()) {
	                return;
	            }
	            $$.hideXGridFocus();
	            $$.hideTooltip();
	            // Undo expanded shapes
	            $$.unexpandCircles();
	            $$.unexpandBars();
	            // Call event handler
	            $$.main.selectAll('.' + CLASS.shape + '-' + index).each(function (d) {
	                config.data_onmouseout.call($$.api, d);
	            });
	        }).on('mousemove', function (d) {
	            var selectedData,
	                index = d.index,
	                eventRect = $$.svg.select('.' + CLASS.eventRect + '-' + index);
	
	            if ($$.dragging || $$.flowing) {
	                return;
	            } // do nothing while dragging/flowing
	            if ($$.hasArcType()) {
	                return;
	            }
	
	            if ($$.isStepType(d) && $$.config.line_step_type === 'step-after' && d3.mouse(this)[0] < $$.x($$.getXValue(d.id, index))) {
	                index -= 1;
	            }
	
	            // Show tooltip
	            selectedData = $$.filterTargetsToShow($$.data.targets).map(function (t) {
	                return $$.addName($$.getValueOnIndex(t.values, index));
	            });
	
	            if (config.tooltip_grouped) {
	                $$.showTooltip(selectedData, this);
	                $$.showXGridFocus(selectedData);
	            }
	
	            if (config.tooltip_grouped && (!config.data_selection_enabled || config.data_selection_grouped)) {
	                return;
	            }
	
	            $$.main.selectAll('.' + CLASS.shape + '-' + index).each(function () {
	                d3.select(this).classed(CLASS.EXPANDED, true);
	                if (config.data_selection_enabled) {
	                    eventRect.style('cursor', config.data_selection_grouped ? 'pointer' : null);
	                }
	                if (!config.tooltip_grouped) {
	                    $$.hideXGridFocus();
	                    $$.hideTooltip();
	                    if (!config.data_selection_grouped) {
	                        $$.unexpandCircles(index);
	                        $$.unexpandBars(index);
	                    }
	                }
	            }).filter(function (d) {
	                return $$.isWithinShape(this, d);
	            }).each(function (d) {
	                if (config.data_selection_enabled && (config.data_selection_grouped || config.data_selection_isselectable(d))) {
	                    eventRect.style('cursor', 'pointer');
	                }
	                if (!config.tooltip_grouped) {
	                    $$.showTooltip([d], this);
	                    $$.showXGridFocus([d]);
	                    if (config.point_focus_expand_enabled) {
	                        $$.expandCircles(index, d.id, true);
	                    }
	                    $$.expandBars(index, d.id, true);
	                }
	            });
	        }).on('click', function (d) {
	            var index = d.index;
	            if ($$.hasArcType() || !$$.toggleShape) {
	                return;
	            }
	            if ($$.cancelClick) {
	                $$.cancelClick = false;
	                return;
	            }
	            if ($$.isStepType(d) && config.line_step_type === 'step-after' && d3.mouse(this)[0] < $$.x($$.getXValue(d.id, index))) {
	                index -= 1;
	            }
	            $$.main.selectAll('.' + CLASS.shape + '-' + index).each(function (d) {
	                if (config.data_selection_grouped || $$.isWithinShape(this, d)) {
	                    $$.toggleShape(this, d, index);
	                    $$.config.data_onclick.call($$.api, d, this);
	                }
	            });
	        }).call(config.data_selection_draggable && $$.drag ? d3.behavior.drag().origin(Object).on('drag', function () {
	            $$.drag(d3.mouse(this));
	        }).on('dragstart', function () {
	            $$.dragstart(d3.mouse(this));
	        }).on('dragend', function () {
	            $$.dragend();
	        }) : function () {});
	    };
	
	    c3_chart_internal_fn.generateEventRectsForMultipleXs = function (eventRectEnter) {
	        var $$ = this,
	            d3 = $$.d3,
	            config = $$.config;
	
	        function mouseout() {
	            $$.svg.select('.' + CLASS.eventRect).style('cursor', null);
	            $$.hideXGridFocus();
	            $$.hideTooltip();
	            $$.unexpandCircles();
	            $$.unexpandBars();
	        }
	
	        eventRectEnter.append('rect').attr('x', 0).attr('y', 0).attr('width', $$.width).attr('height', $$.height).attr('class', CLASS.eventRect).on('mouseout', function () {
	            if (!$$.config) {
	                return;
	            } // chart is destroyed
	            if ($$.hasArcType()) {
	                return;
	            }
	            mouseout();
	        }).on('mousemove', function () {
	            var targetsToShow = $$.filterTargetsToShow($$.data.targets);
	            var mouse, closest, sameXData, selectedData;
	
	            if ($$.dragging) {
	                return;
	            } // do nothing when dragging
	            if ($$.hasArcType(targetsToShow)) {
	                return;
	            }
	
	            mouse = d3.mouse(this);
	            closest = $$.findClosestFromTargets(targetsToShow, mouse);
	
	            if ($$.mouseover && (!closest || closest.id !== $$.mouseover.id)) {
	                config.data_onmouseout.call($$.api, $$.mouseover);
	                $$.mouseover = undefined;
	            }
	
	            if (!closest) {
	                mouseout();
	                return;
	            }
	
	            if ($$.isScatterType(closest) || !config.tooltip_grouped) {
	                sameXData = [closest];
	            } else {
	                sameXData = $$.filterByX(targetsToShow, closest.x);
	            }
	
	            // show tooltip when cursor is close to some point
	            selectedData = sameXData.map(function (d) {
	                return $$.addName(d);
	            });
	            $$.showTooltip(selectedData, this);
	
	            // expand points
	            if (config.point_focus_expand_enabled) {
	                $$.expandCircles(closest.index, closest.id, true);
	            }
	            $$.expandBars(closest.index, closest.id, true);
	
	            // Show xgrid focus line
	            $$.showXGridFocus(selectedData);
	
	            // Show cursor as pointer if point is close to mouse position
	            if ($$.isBarType(closest.id) || $$.dist(closest, mouse) < config.point_sensitivity) {
	                $$.svg.select('.' + CLASS.eventRect).style('cursor', 'pointer');
	                if (!$$.mouseover) {
	                    config.data_onmouseover.call($$.api, closest);
	                    $$.mouseover = closest;
	                }
	            }
	        }).on('click', function () {
	            var targetsToShow = $$.filterTargetsToShow($$.data.targets);
	            var mouse, closest;
	            if ($$.hasArcType(targetsToShow)) {
	                return;
	            }
	
	            mouse = d3.mouse(this);
	            closest = $$.findClosestFromTargets(targetsToShow, mouse);
	            if (!closest) {
	                return;
	            }
	            // select if selection enabled
	            if ($$.isBarType(closest.id) || $$.dist(closest, mouse) < config.point_sensitivity) {
	                $$.main.selectAll('.' + CLASS.shapes + $$.getTargetSelectorSuffix(closest.id)).selectAll('.' + CLASS.shape + '-' + closest.index).each(function () {
	                    if (config.data_selection_grouped || $$.isWithinShape(this, closest)) {
	                        $$.toggleShape(this, closest, closest.index);
	                        $$.config.data_onclick.call($$.api, closest, this);
	                    }
	                });
	            }
	        }).call(config.data_selection_draggable && $$.drag ? d3.behavior.drag().origin(Object).on('drag', function () {
	            $$.drag(d3.mouse(this));
	        }).on('dragstart', function () {
	            $$.dragstart(d3.mouse(this));
	        }).on('dragend', function () {
	            $$.dragend();
	        }) : function () {});
	    };
	    c3_chart_internal_fn.dispatchEvent = function (type, index, mouse) {
	        var $$ = this,
	            selector = '.' + CLASS.eventRect + (!$$.isMultipleX() ? '-' + index : ''),
	            eventRect = $$.main.select(selector).node(),
	            box = eventRect.getBoundingClientRect(),
	            x = box.left + (mouse ? mouse[0] : 0),
	            y = box.top + (mouse ? mouse[1] : 0),
	            event = document.createEvent("MouseEvents");
	
	        event.initMouseEvent(type, true, true, window, 0, x, y, x, y, false, false, false, false, 0, null);
	        eventRect.dispatchEvent(event);
	    };
	
	    c3_chart_internal_fn.initLegend = function () {
	        var $$ = this;
	        $$.legendItemTextBox = {};
	        $$.legendHasRendered = false;
	        $$.legend = $$.svg.append("g").attr("transform", $$.getTranslate('legend'));
	        if (!$$.config.legend_show) {
	            $$.legend.style('visibility', 'hidden');
	            $$.hiddenLegendIds = $$.mapToIds($$.data.targets);
	            return;
	        }
	        // MEMO: call here to update legend box and tranlate for all
	        // MEMO: translate will be upated by this, so transform not needed in updateLegend()
	        $$.updateLegendWithDefaults();
	    };
	    c3_chart_internal_fn.updateLegendWithDefaults = function () {
	        var $$ = this;
	        $$.updateLegend($$.mapToIds($$.data.targets), { withTransform: false, withTransitionForTransform: false, withTransition: false });
	    };
	    c3_chart_internal_fn.updateSizeForLegend = function (legendHeight, legendWidth) {
	        var $$ = this,
	            config = $$.config,
	            insetLegendPosition = {
	            top: $$.isLegendTop ? $$.getCurrentPaddingTop() + config.legend_inset_y + 5.5 : $$.currentHeight - legendHeight - $$.getCurrentPaddingBottom() - config.legend_inset_y,
	            left: $$.isLegendLeft ? $$.getCurrentPaddingLeft() + config.legend_inset_x + 0.5 : $$.currentWidth - legendWidth - $$.getCurrentPaddingRight() - config.legend_inset_x + 0.5
	        };
	
	        $$.margin3 = {
	            top: $$.isLegendRight ? 0 : $$.isLegendInset ? insetLegendPosition.top : $$.currentHeight - legendHeight,
	            right: NaN,
	            bottom: 0,
	            left: $$.isLegendRight ? $$.currentWidth - legendWidth : $$.isLegendInset ? insetLegendPosition.left : 0
	        };
	    };
	    c3_chart_internal_fn.transformLegend = function (withTransition) {
	        var $$ = this;
	        (withTransition ? $$.legend.transition() : $$.legend).attr("transform", $$.getTranslate('legend'));
	    };
	    c3_chart_internal_fn.updateLegendStep = function (step) {
	        this.legendStep = step;
	    };
	    c3_chart_internal_fn.updateLegendItemWidth = function (w) {
	        this.legendItemWidth = w;
	    };
	    c3_chart_internal_fn.updateLegendItemHeight = function (h) {
	        this.legendItemHeight = h;
	    };
	    c3_chart_internal_fn.getLegendWidth = function () {
	        var $$ = this;
	        return $$.config.legend_show ? $$.isLegendRight || $$.isLegendInset ? $$.legendItemWidth * ($$.legendStep + 1) : $$.currentWidth : 0;
	    };
	    c3_chart_internal_fn.getLegendHeight = function () {
	        var $$ = this,
	            h = 0;
	        if ($$.config.legend_show) {
	            if ($$.isLegendRight) {
	                h = $$.currentHeight;
	            } else {
	                h = Math.max(20, $$.legendItemHeight) * ($$.legendStep + 1);
	            }
	        }
	        return h;
	    };
	    c3_chart_internal_fn.opacityForLegend = function (legendItem) {
	        return legendItem.classed(CLASS.legendItemHidden) ? null : 1;
	    };
	    c3_chart_internal_fn.opacityForUnfocusedLegend = function (legendItem) {
	        return legendItem.classed(CLASS.legendItemHidden) ? null : 0.3;
	    };
	    c3_chart_internal_fn.toggleFocusLegend = function (targetIds, focus) {
	        var $$ = this;
	        targetIds = $$.mapToTargetIds(targetIds);
	        $$.legend.selectAll('.' + CLASS.legendItem).filter(function (id) {
	            return targetIds.indexOf(id) >= 0;
	        }).classed(CLASS.legendItemFocused, focus).transition().duration(100).style('opacity', function () {
	            var opacity = focus ? $$.opacityForLegend : $$.opacityForUnfocusedLegend;
	            return opacity.call($$, $$.d3.select(this));
	        });
	    };
	    c3_chart_internal_fn.revertLegend = function () {
	        var $$ = this,
	            d3 = $$.d3;
	        $$.legend.selectAll('.' + CLASS.legendItem).classed(CLASS.legendItemFocused, false).transition().duration(100).style('opacity', function () {
	            return $$.opacityForLegend(d3.select(this));
	        });
	    };
	    c3_chart_internal_fn.showLegend = function (targetIds) {
	        var $$ = this,
	            config = $$.config;
	        if (!config.legend_show) {
	            config.legend_show = true;
	            $$.legend.style('visibility', 'visible');
	            if (!$$.legendHasRendered) {
	                $$.updateLegendWithDefaults();
	            }
	        }
	        $$.removeHiddenLegendIds(targetIds);
	        $$.legend.selectAll($$.selectorLegends(targetIds)).style('visibility', 'visible').transition().style('opacity', function () {
	            return $$.opacityForLegend($$.d3.select(this));
	        });
	    };
	    c3_chart_internal_fn.hideLegend = function (targetIds) {
	        var $$ = this,
	            config = $$.config;
	        if (config.legend_show && isEmpty(targetIds)) {
	            config.legend_show = false;
	            $$.legend.style('visibility', 'hidden');
	        }
	        $$.addHiddenLegendIds(targetIds);
	        $$.legend.selectAll($$.selectorLegends(targetIds)).style('opacity', 0).style('visibility', 'hidden');
	    };
	    c3_chart_internal_fn.clearLegendItemTextBoxCache = function () {
	        this.legendItemTextBox = {};
	    };
	    c3_chart_internal_fn.updateLegend = function (targetIds, options, transitions) {
	        var $$ = this,
	            config = $$.config;
	        var xForLegend, xForLegendText, xForLegendRect, yForLegend, yForLegendText, yForLegendRect, x1ForLegendTile, x2ForLegendTile, yForLegendTile;
	        var paddingTop = 4,
	            paddingRight = 10,
	            maxWidth = 0,
	            maxHeight = 0,
	            posMin = 10,
	            tileWidth = config.legend_item_tile_width + 5;
	        var l,
	            totalLength = 0,
	            offsets = {},
	            widths = {},
	            heights = {},
	            margins = [0],
	            steps = {},
	            step = 0;
	        var withTransition, withTransitionForTransform;
	        var texts, rects, tiles, background;
	
	        // Skip elements when their name is set to null
	        targetIds = targetIds.filter(function (id) {
	            return !isDefined(config.data_names[id]) || config.data_names[id] !== null;
	        });
	
	        options = options || {};
	        withTransition = getOption(options, "withTransition", true);
	        withTransitionForTransform = getOption(options, "withTransitionForTransform", true);
	
	        function getTextBox(textElement, id) {
	            if (!$$.legendItemTextBox[id]) {
	                $$.legendItemTextBox[id] = $$.getTextRect(textElement.textContent, CLASS.legendItem, textElement);
	            }
	            return $$.legendItemTextBox[id];
	        }
	
	        function updatePositions(textElement, id, index) {
	            var reset = index === 0,
	                isLast = index === targetIds.length - 1,
	                box = getTextBox(textElement, id),
	                itemWidth = box.width + tileWidth + (isLast && !($$.isLegendRight || $$.isLegendInset) ? 0 : paddingRight) + config.legend_padding,
	                itemHeight = box.height + paddingTop,
	                itemLength = $$.isLegendRight || $$.isLegendInset ? itemHeight : itemWidth,
	                areaLength = $$.isLegendRight || $$.isLegendInset ? $$.getLegendHeight() : $$.getLegendWidth(),
	                margin,
	                maxLength;
	
	            // MEMO: care about condifion of step, totalLength
	            function updateValues(id, withoutStep) {
	                if (!withoutStep) {
	                    margin = (areaLength - totalLength - itemLength) / 2;
	                    if (margin < posMin) {
	                        margin = (areaLength - itemLength) / 2;
	                        totalLength = 0;
	                        step++;
	                    }
	                }
	                steps[id] = step;
	                margins[step] = $$.isLegendInset ? 10 : margin;
	                offsets[id] = totalLength;
	                totalLength += itemLength;
	            }
	
	            if (reset) {
	                totalLength = 0;
	                step = 0;
	                maxWidth = 0;
	                maxHeight = 0;
	            }
	
	            if (config.legend_show && !$$.isLegendToShow(id)) {
	                widths[id] = heights[id] = steps[id] = offsets[id] = 0;
	                return;
	            }
	
	            widths[id] = itemWidth;
	            heights[id] = itemHeight;
	
	            if (!maxWidth || itemWidth >= maxWidth) {
	                maxWidth = itemWidth;
	            }
	            if (!maxHeight || itemHeight >= maxHeight) {
	                maxHeight = itemHeight;
	            }
	            maxLength = $$.isLegendRight || $$.isLegendInset ? maxHeight : maxWidth;
	
	            if (config.legend_equally) {
	                Object.keys(widths).forEach(function (id) {
	                    widths[id] = maxWidth;
	                });
	                Object.keys(heights).forEach(function (id) {
	                    heights[id] = maxHeight;
	                });
	                margin = (areaLength - maxLength * targetIds.length) / 2;
	                if (margin < posMin) {
	                    totalLength = 0;
	                    step = 0;
	                    targetIds.forEach(function (id) {
	                        updateValues(id);
	                    });
	                } else {
	                    updateValues(id, true);
	                }
	            } else {
	                updateValues(id);
	            }
	        }
	
	        if ($$.isLegendInset) {
	            step = config.legend_inset_step ? config.legend_inset_step : targetIds.length;
	            $$.updateLegendStep(step);
	        }
	
	        if ($$.isLegendRight) {
	            xForLegend = function xForLegend(id) {
	                return maxWidth * steps[id];
	            };
	            yForLegend = function yForLegend(id) {
	                return margins[steps[id]] + offsets[id];
	            };
	        } else if ($$.isLegendInset) {
	            xForLegend = function xForLegend(id) {
	                return maxWidth * steps[id] + 10;
	            };
	            yForLegend = function yForLegend(id) {
	                return margins[steps[id]] + offsets[id];
	            };
	        } else {
	            xForLegend = function xForLegend(id) {
	                return margins[steps[id]] + offsets[id];
	            };
	            yForLegend = function yForLegend(id) {
	                return maxHeight * steps[id];
	            };
	        }
	        xForLegendText = function xForLegendText(id, i) {
	            return xForLegend(id, i) + 4 + config.legend_item_tile_width;
	        };
	        yForLegendText = function yForLegendText(id, i) {
	            return yForLegend(id, i) + 9;
	        };
	        xForLegendRect = function xForLegendRect(id, i) {
	            return xForLegend(id, i);
	        };
	        yForLegendRect = function yForLegendRect(id, i) {
	            return yForLegend(id, i) - 5;
	        };
	        x1ForLegendTile = function x1ForLegendTile(id, i) {
	            return xForLegend(id, i) - 2;
	        };
	        x2ForLegendTile = function x2ForLegendTile(id, i) {
	            return xForLegend(id, i) - 2 + config.legend_item_tile_width;
	        };
	        yForLegendTile = function yForLegendTile(id, i) {
	            return yForLegend(id, i) + 4;
	        };
	
	        // Define g for legend area
	        l = $$.legend.selectAll('.' + CLASS.legendItem).data(targetIds).enter().append('g').attr('class', function (id) {
	            return $$.generateClass(CLASS.legendItem, id);
	        }).style('visibility', function (id) {
	            return $$.isLegendToShow(id) ? 'visible' : 'hidden';
	        }).style('cursor', 'pointer').on('click', function (id) {
	            if (config.legend_item_onclick) {
	                config.legend_item_onclick.call($$, id);
	            } else {
	                if ($$.d3.event.altKey) {
	                    $$.api.hide();
	                    $$.api.show(id);
	                } else {
	                    $$.api.toggle(id);
	                    $$.isTargetToShow(id) ? $$.api.focus(id) : $$.api.revert();
	                }
	            }
	        }).on('mouseover', function (id) {
	            if (config.legend_item_onmouseover) {
	                config.legend_item_onmouseover.call($$, id);
	            } else {
	                $$.d3.select(this).classed(CLASS.legendItemFocused, true);
	                if (!$$.transiting && $$.isTargetToShow(id)) {
	                    $$.api.focus(id);
	                }
	            }
	        }).on('mouseout', function (id) {
	            if (config.legend_item_onmouseout) {
	                config.legend_item_onmouseout.call($$, id);
	            } else {
	                $$.d3.select(this).classed(CLASS.legendItemFocused, false);
	                $$.api.revert();
	            }
	        });
	        l.append('text').text(function (id) {
	            return isDefined(config.data_names[id]) ? config.data_names[id] : id;
	        }).each(function (id, i) {
	            updatePositions(this, id, i);
	        }).style("pointer-events", "none").attr('x', $$.isLegendRight || $$.isLegendInset ? xForLegendText : -200).attr('y', $$.isLegendRight || $$.isLegendInset ? -200 : yForLegendText);
	        l.append('rect').attr("class", CLASS.legendItemEvent).style('fill-opacity', 0).attr('x', $$.isLegendRight || $$.isLegendInset ? xForLegendRect : -200).attr('y', $$.isLegendRight || $$.isLegendInset ? -200 : yForLegendRect);
	        l.append('line').attr('class', CLASS.legendItemTile).style('stroke', $$.color).style("pointer-events", "none").attr('x1', $$.isLegendRight || $$.isLegendInset ? x1ForLegendTile : -200).attr('y1', $$.isLegendRight || $$.isLegendInset ? -200 : yForLegendTile).attr('x2', $$.isLegendRight || $$.isLegendInset ? x2ForLegendTile : -200).attr('y2', $$.isLegendRight || $$.isLegendInset ? -200 : yForLegendTile).attr('stroke-width', config.legend_item_tile_height);
	
	        // Set background for inset legend
	        background = $$.legend.select('.' + CLASS.legendBackground + ' rect');
	        if ($$.isLegendInset && maxWidth > 0 && background.size() === 0) {
	            background = $$.legend.insert('g', '.' + CLASS.legendItem).attr("class", CLASS.legendBackground).append('rect');
	        }
	
	        texts = $$.legend.selectAll('text').data(targetIds).text(function (id) {
	            return isDefined(config.data_names[id]) ? config.data_names[id] : id;
	        }) // MEMO: needed for update
	        .each(function (id, i) {
	            updatePositions(this, id, i);
	        });
	        (withTransition ? texts.transition() : texts).attr('x', xForLegendText).attr('y', yForLegendText);
	
	        rects = $$.legend.selectAll('rect.' + CLASS.legendItemEvent).data(targetIds);
	        (withTransition ? rects.transition() : rects).attr('width', function (id) {
	            return widths[id];
	        }).attr('height', function (id) {
	            return heights[id];
	        }).attr('x', xForLegendRect).attr('y', yForLegendRect);
	
	        tiles = $$.legend.selectAll('line.' + CLASS.legendItemTile).data(targetIds);
	        (withTransition ? tiles.transition() : tiles).style('stroke', $$.levelColor ? function (id) {
	            return $$.levelColor($$.cache[id].values[0].value);
	        } : $$.color).attr('x1', x1ForLegendTile).attr('y1', yForLegendTile).attr('x2', x2ForLegendTile).attr('y2', yForLegendTile);
	
	        if (background) {
	            (withTransition ? background.transition() : background).attr('height', $$.getLegendHeight() - 12).attr('width', maxWidth * (step + 1) + 10);
	        }
	
	        // toggle legend state
	        $$.legend.selectAll('.' + CLASS.legendItem).classed(CLASS.legendItemHidden, function (id) {
	            return !$$.isTargetToShow(id);
	        });
	
	        // Update all to reflect change of legend
	        $$.updateLegendItemWidth(maxWidth);
	        $$.updateLegendItemHeight(maxHeight);
	        $$.updateLegendStep(step);
	        // Update size and scale
	        $$.updateSizes();
	        $$.updateScales();
	        $$.updateSvgSize();
	        // Update g positions
	        $$.transformAll(withTransitionForTransform, transitions);
	        $$.legendHasRendered = true;
	    };
	
	    c3_chart_internal_fn.initRegion = function () {
	        var $$ = this;
	        $$.region = $$.main.append('g').attr("clip-path", $$.clipPath).attr("class", CLASS.regions);
	    };
	    c3_chart_internal_fn.updateRegion = function (duration) {
	        var $$ = this,
	            config = $$.config;
	
	        // hide if arc type
	        $$.region.style('visibility', $$.hasArcType() ? 'hidden' : 'visible');
	
	        $$.mainRegion = $$.main.select('.' + CLASS.regions).selectAll('.' + CLASS.region).data(config.regions);
	        $$.mainRegion.enter().append('g').append('rect').style("fill-opacity", 0);
	        $$.mainRegion.attr('class', $$.classRegion.bind($$));
	        $$.mainRegion.exit().transition().duration(duration).style("opacity", 0).remove();
	    };
	    c3_chart_internal_fn.redrawRegion = function (withTransition) {
	        var $$ = this,
	            regions = $$.mainRegion.selectAll('rect').each(function () {
	            // data is binded to g and it's not transferred to rect (child node) automatically,
	            // then data of each rect has to be updated manually.
	            // TODO: there should be more efficient way to solve this?
	            var parentData = $$.d3.select(this.parentNode).datum();
	            $$.d3.select(this).datum(parentData);
	        }),
	            x = $$.regionX.bind($$),
	            y = $$.regionY.bind($$),
	            w = $$.regionWidth.bind($$),
	            h = $$.regionHeight.bind($$);
	        return [(withTransition ? regions.transition() : regions).attr("x", x).attr("y", y).attr("width", w).attr("height", h).style("fill-opacity", function (d) {
	            return isValue(d.opacity) ? d.opacity : 0.1;
	        })];
	    };
	    c3_chart_internal_fn.regionX = function (d) {
	        var $$ = this,
	            config = $$.config,
	            xPos,
	            yScale = d.axis === 'y' ? $$.y : $$.y2;
	        if (d.axis === 'y' || d.axis === 'y2') {
	            xPos = config.axis_rotated ? 'start' in d ? yScale(d.start) : 0 : 0;
	        } else {
	            xPos = config.axis_rotated ? 0 : 'start' in d ? $$.x($$.isTimeSeries() ? $$.parseDate(d.start) : d.start) : 0;
	        }
	        return xPos;
	    };
	    c3_chart_internal_fn.regionY = function (d) {
	        var $$ = this,
	            config = $$.config,
	            yPos,
	            yScale = d.axis === 'y' ? $$.y : $$.y2;
	        if (d.axis === 'y' || d.axis === 'y2') {
	            yPos = config.axis_rotated ? 0 : 'end' in d ? yScale(d.end) : 0;
	        } else {
	            yPos = config.axis_rotated ? 'start' in d ? $$.x($$.isTimeSeries() ? $$.parseDate(d.start) : d.start) : 0 : 0;
	        }
	        return yPos;
	    };
	    c3_chart_internal_fn.regionWidth = function (d) {
	        var $$ = this,
	            config = $$.config,
	            start = $$.regionX(d),
	            end,
	            yScale = d.axis === 'y' ? $$.y : $$.y2;
	        if (d.axis === 'y' || d.axis === 'y2') {
	            end = config.axis_rotated ? 'end' in d ? yScale(d.end) : $$.width : $$.width;
	        } else {
	            end = config.axis_rotated ? $$.width : 'end' in d ? $$.x($$.isTimeSeries() ? $$.parseDate(d.end) : d.end) : $$.width;
	        }
	        return end < start ? 0 : end - start;
	    };
	    c3_chart_internal_fn.regionHeight = function (d) {
	        var $$ = this,
	            config = $$.config,
	            start = this.regionY(d),
	            end,
	            yScale = d.axis === 'y' ? $$.y : $$.y2;
	        if (d.axis === 'y' || d.axis === 'y2') {
	            end = config.axis_rotated ? $$.height : 'start' in d ? yScale(d.start) : $$.height;
	        } else {
	            end = config.axis_rotated ? 'end' in d ? $$.x($$.isTimeSeries() ? $$.parseDate(d.end) : d.end) : $$.height : $$.height;
	        }
	        return end < start ? 0 : end - start;
	    };
	    c3_chart_internal_fn.isRegionOnX = function (d) {
	        return !d.axis || d.axis === 'x';
	    };
	
	    c3_chart_internal_fn.getScale = function (min, max, forTimeseries) {
	        return (forTimeseries ? this.d3.time.scale() : this.d3.scale.linear()).range([min, max]);
	    };
	    c3_chart_internal_fn.getX = function (min, max, domain, offset) {
	        var $$ = this,
	            scale = $$.getScale(min, max, $$.isTimeSeries()),
	            _scale = domain ? scale.domain(domain) : scale,
	            key;
	        // Define customized scale if categorized axis
	        if ($$.isCategorized()) {
	            offset = offset || function () {
	                return 0;
	            };
	            scale = function scale(d, raw) {
	                var v = _scale(d) + offset(d);
	                return raw ? v : Math.ceil(v);
	            };
	        } else {
	            scale = function scale(d, raw) {
	                var v = _scale(d);
	                return raw ? v : Math.ceil(v);
	            };
	        }
	        // define functions
	        for (key in _scale) {
	            scale[key] = _scale[key];
	        }
	        scale.orgDomain = function () {
	            return _scale.domain();
	        };
	        // define custom domain() for categorized axis
	        if ($$.isCategorized()) {
	            scale.domain = function (domain) {
	                if (!arguments.length) {
	                    domain = this.orgDomain();
	                    return [domain[0], domain[1] + 1];
	                }
	                _scale.domain(domain);
	                return scale;
	            };
	        }
	        return scale;
	    };
	    c3_chart_internal_fn.getY = function (min, max, domain) {
	        var scale = this.getScale(min, max, this.isTimeSeriesY());
	        if (domain) {
	            scale.domain(domain);
	        }
	        return scale;
	    };
	    c3_chart_internal_fn.getYScale = function (id) {
	        return this.axis.getId(id) === 'y2' ? this.y2 : this.y;
	    };
	    c3_chart_internal_fn.getSubYScale = function (id) {
	        return this.axis.getId(id) === 'y2' ? this.subY2 : this.subY;
	    };
	    c3_chart_internal_fn.updateScales = function () {
	        var $$ = this,
	            config = $$.config,
	            forInit = !$$.x;
	        // update edges
	        $$.xMin = config.axis_rotated ? 1 : 0;
	        $$.xMax = config.axis_rotated ? $$.height : $$.width;
	        $$.yMin = config.axis_rotated ? 0 : $$.height;
	        $$.yMax = config.axis_rotated ? $$.width : 1;
	        $$.subXMin = $$.xMin;
	        $$.subXMax = $$.xMax;
	        $$.subYMin = config.axis_rotated ? 0 : $$.height2;
	        $$.subYMax = config.axis_rotated ? $$.width2 : 1;
	        // update scales
	        $$.x = $$.getX($$.xMin, $$.xMax, forInit ? undefined : $$.x.orgDomain(), function () {
	            return $$.xAxis.tickOffset();
	        });
	        $$.y = $$.getY($$.yMin, $$.yMax, forInit ? config.axis_y_default : $$.y.domain());
	        $$.y2 = $$.getY($$.yMin, $$.yMax, forInit ? config.axis_y2_default : $$.y2.domain());
	        $$.subX = $$.getX($$.xMin, $$.xMax, $$.orgXDomain, function (d) {
	            return d % 1 ? 0 : $$.subXAxis.tickOffset();
	        });
	        $$.subY = $$.getY($$.subYMin, $$.subYMax, forInit ? config.axis_y_default : $$.subY.domain());
	        $$.subY2 = $$.getY($$.subYMin, $$.subYMax, forInit ? config.axis_y2_default : $$.subY2.domain());
	        // update axes
	        $$.xAxisTickFormat = $$.axis.getXAxisTickFormat();
	        $$.xAxisTickValues = $$.axis.getXAxisTickValues();
	        $$.yAxisTickValues = $$.axis.getYAxisTickValues();
	        $$.y2AxisTickValues = $$.axis.getY2AxisTickValues();
	
	        $$.xAxis = $$.axis.getXAxis($$.x, $$.xOrient, $$.xAxisTickFormat, $$.xAxisTickValues, config.axis_x_tick_outer);
	        $$.subXAxis = $$.axis.getXAxis($$.subX, $$.subXOrient, $$.xAxisTickFormat, $$.xAxisTickValues, config.axis_x_tick_outer);
	        $$.yAxis = $$.axis.getYAxis($$.y, $$.yOrient, config.axis_y_tick_format, $$.yAxisTickValues, config.axis_y_tick_outer);
	        $$.y2Axis = $$.axis.getYAxis($$.y2, $$.y2Orient, config.axis_y2_tick_format, $$.y2AxisTickValues, config.axis_y2_tick_outer);
	
	        // Set initialized scales to brush and zoom
	        if (!forInit) {
	            if ($$.brush) {
	                $$.brush.scale($$.subX);
	            }
	            if (config.zoom_enabled) {
	                $$.zoom.scale($$.x);
	            }
	        }
	        // update for arc
	        if ($$.updateArc) {
	            $$.updateArc();
	        }
	    };
	
	    c3_chart_internal_fn.selectPoint = function (target, d, i) {
	        var $$ = this,
	            config = $$.config,
	            cx = (config.axis_rotated ? $$.circleY : $$.circleX).bind($$),
	            cy = (config.axis_rotated ? $$.circleX : $$.circleY).bind($$),
	            r = $$.pointSelectR.bind($$);
	        config.data_onselected.call($$.api, d, target.node());
	        // add selected-circle on low layer g
	        $$.main.select('.' + CLASS.selectedCircles + $$.getTargetSelectorSuffix(d.id)).selectAll('.' + CLASS.selectedCircle + '-' + i).data([d]).enter().append('circle').attr("class", function () {
	            return $$.generateClass(CLASS.selectedCircle, i);
	        }).attr("cx", cx).attr("cy", cy).attr("stroke", function () {
	            return $$.color(d);
	        }).attr("r", function (d) {
	            return $$.pointSelectR(d) * 1.4;
	        }).transition().duration(100).attr("r", r);
	    };
	    c3_chart_internal_fn.unselectPoint = function (target, d, i) {
	        var $$ = this;
	        $$.config.data_onunselected.call($$.api, d, target.node());
	        // remove selected-circle from low layer g
	        $$.main.select('.' + CLASS.selectedCircles + $$.getTargetSelectorSuffix(d.id)).selectAll('.' + CLASS.selectedCircle + '-' + i).transition().duration(100).attr('r', 0).remove();
	    };
	    c3_chart_internal_fn.togglePoint = function (selected, target, d, i) {
	        selected ? this.selectPoint(target, d, i) : this.unselectPoint(target, d, i);
	    };
	    c3_chart_internal_fn.selectPath = function (target, d) {
	        var $$ = this;
	        $$.config.data_onselected.call($$, d, target.node());
	        if ($$.config.interaction_brighten) {
	            target.transition().duration(100).style("fill", function () {
	                return $$.d3.rgb($$.color(d)).brighter(0.75);
	            });
	        }
	    };
	    c3_chart_internal_fn.unselectPath = function (target, d) {
	        var $$ = this;
	        $$.config.data_onunselected.call($$, d, target.node());
	        if ($$.config.interaction_brighten) {
	            target.transition().duration(100).style("fill", function () {
	                return $$.color(d);
	            });
	        }
	    };
	    c3_chart_internal_fn.togglePath = function (selected, target, d, i) {
	        selected ? this.selectPath(target, d, i) : this.unselectPath(target, d, i);
	    };
	    c3_chart_internal_fn.getToggle = function (that, d) {
	        var $$ = this,
	            toggle;
	        if (that.nodeName === 'circle') {
	            if ($$.isStepType(d)) {
	                // circle is hidden in step chart, so treat as within the click area
	                toggle = function toggle() {}; // TODO: how to select step chart?
	            } else {
	                toggle = $$.togglePoint;
	            }
	        } else if (that.nodeName === 'path') {
	            toggle = $$.togglePath;
	        }
	        return toggle;
	    };
	    c3_chart_internal_fn.toggleShape = function (that, d, i) {
	        var $$ = this,
	            d3 = $$.d3,
	            config = $$.config,
	            shape = d3.select(that),
	            isSelected = shape.classed(CLASS.SELECTED),
	            toggle = $$.getToggle(that, d).bind($$);
	
	        if (config.data_selection_enabled && config.data_selection_isselectable(d)) {
	            if (!config.data_selection_multiple) {
	                $$.main.selectAll('.' + CLASS.shapes + (config.data_selection_grouped ? $$.getTargetSelectorSuffix(d.id) : "")).selectAll('.' + CLASS.shape).each(function (d, i) {
	                    var shape = d3.select(this);
	                    if (shape.classed(CLASS.SELECTED)) {
	                        toggle(false, shape.classed(CLASS.SELECTED, false), d, i);
	                    }
	                });
	            }
	            shape.classed(CLASS.SELECTED, !isSelected);
	            toggle(!isSelected, shape, d, i);
	        }
	    };
	
	    c3_chart_internal_fn.initBar = function () {
	        var $$ = this;
	        $$.main.select('.' + CLASS.chart).append("g").attr("class", CLASS.chartBars);
	    };
	    c3_chart_internal_fn.updateTargetsForBar = function (targets) {
	        var $$ = this,
	            config = $$.config,
	            mainBarUpdate,
	            mainBarEnter,
	            classChartBar = $$.classChartBar.bind($$),
	            classBars = $$.classBars.bind($$),
	            classFocus = $$.classFocus.bind($$);
	        mainBarUpdate = $$.main.select('.' + CLASS.chartBars).selectAll('.' + CLASS.chartBar).data(targets).attr('class', function (d) {
	            return classChartBar(d) + classFocus(d);
	        });
	        mainBarEnter = mainBarUpdate.enter().append('g').attr('class', classChartBar).style("pointer-events", "none");
	        // Bars for each data
	        mainBarEnter.append('g').attr("class", classBars).style("cursor", function (d) {
	            return config.data_selection_isselectable(d) ? "pointer" : null;
	        });
	    };
	    c3_chart_internal_fn.updateBar = function (durationForExit) {
	        var $$ = this,
	            barData = $$.barData.bind($$),
	            classBar = $$.classBar.bind($$),
	            initialOpacity = $$.initialOpacity.bind($$),
	            color = function color(d) {
	            return $$.color(d.id);
	        };
	        $$.mainBar = $$.main.selectAll('.' + CLASS.bars).selectAll('.' + CLASS.bar).data(barData);
	        $$.mainBar.enter().append('path').attr("class", classBar).style("stroke", color).style("fill", color);
	        $$.mainBar.style("opacity", initialOpacity);
	        $$.mainBar.exit().transition().duration(durationForExit).remove();
	    };
	    c3_chart_internal_fn.redrawBar = function (drawBar, withTransition) {
	        return [(withTransition ? this.mainBar.transition(Math.random().toString()) : this.mainBar).attr('d', drawBar).style("stroke", this.color).style("fill", this.color).style("opacity", 1)];
	    };
	    c3_chart_internal_fn.getBarW = function (axis, barTargetsNum) {
	        var $$ = this,
	            config = $$.config,
	            w = typeof config.bar_width === 'number' ? config.bar_width : barTargetsNum ? axis.tickInterval() * config.bar_width_ratio / barTargetsNum : 0;
	        return config.bar_width_max && w > config.bar_width_max ? config.bar_width_max : w;
	    };
	    c3_chart_internal_fn.getBars = function (i, id) {
	        var $$ = this;
	        return (id ? $$.main.selectAll('.' + CLASS.bars + $$.getTargetSelectorSuffix(id)) : $$.main).selectAll('.' + CLASS.bar + (isValue(i) ? '-' + i : ''));
	    };
	    c3_chart_internal_fn.expandBars = function (i, id, reset) {
	        var $$ = this;
	        if (reset) {
	            $$.unexpandBars();
	        }
	        $$.getBars(i, id).classed(CLASS.EXPANDED, true);
	    };
	    c3_chart_internal_fn.unexpandBars = function (i) {
	        var $$ = this;
	        $$.getBars(i).classed(CLASS.EXPANDED, false);
	    };
	    c3_chart_internal_fn.generateDrawBar = function (barIndices, isSub) {
	        var $$ = this,
	            config = $$.config,
	            getPoints = $$.generateGetBarPoints(barIndices, isSub);
	        return function (d, i) {
	            // 4 points that make a bar
	            var points = getPoints(d, i);
	
	            // switch points if axis is rotated, not applicable for sub chart
	            var indexX = config.axis_rotated ? 1 : 0;
	            var indexY = config.axis_rotated ? 0 : 1;
	
	            var path = 'M ' + points[0][indexX] + ',' + points[0][indexY] + ' ' + 'L' + points[1][indexX] + ',' + points[1][indexY] + ' ' + 'L' + points[2][indexX] + ',' + points[2][indexY] + ' ' + 'L' + points[3][indexX] + ',' + points[3][indexY] + ' ' + 'z';
	
	            return path;
	        };
	    };
	    c3_chart_internal_fn.generateGetBarPoints = function (barIndices, isSub) {
	        var $$ = this,
	            axis = isSub ? $$.subXAxis : $$.xAxis,
	            barTargetsNum = barIndices.__max__ + 1,
	            barW = $$.getBarW(axis, barTargetsNum),
	            barX = $$.getShapeX(barW, barTargetsNum, barIndices, !!isSub),
	            barY = $$.getShapeY(!!isSub),
	            barOffset = $$.getShapeOffset($$.isBarType, barIndices, !!isSub),
	            barSpaceOffset = barW * ($$.config.bar_space / 2),
	            yScale = isSub ? $$.getSubYScale : $$.getYScale;
	        return function (d, i) {
	            var y0 = yScale.call($$, d.id)(0),
	                offset = barOffset(d, i) || y0,
	                // offset is for stacked bar chart
	            posX = barX(d),
	                posY = barY(d);
	            // fix posY not to overflow opposite quadrant
	            if ($$.config.axis_rotated) {
	                if (0 < d.value && posY < y0 || d.value < 0 && y0 < posY) {
	                    posY = y0;
	                }
	            }
	            // 4 points that make a bar
	            return [[posX + barSpaceOffset, offset], [posX + barSpaceOffset, posY - (y0 - offset)], [posX + barW - barSpaceOffset, posY - (y0 - offset)], [posX + barW - barSpaceOffset, offset]];
	        };
	    };
	    c3_chart_internal_fn.isWithinBar = function (that) {
	        var mouse = this.d3.mouse(that),
	            box = that.getBoundingClientRect(),
	            seg0 = that.pathSegList.getItem(0),
	            seg1 = that.pathSegList.getItem(1),
	            x = Math.min(seg0.x, seg1.x),
	            y = Math.min(seg0.y, seg1.y),
	            w = box.width,
	            h = box.height,
	            offset = 2,
	            sx = x - offset,
	            ex = x + w + offset,
	            sy = y + h + offset,
	            ey = y - offset;
	        return sx < mouse[0] && mouse[0] < ex && ey < mouse[1] && mouse[1] < sy;
	    };
	
	    c3_chart_internal_fn.getShapeIndices = function (typeFilter) {
	        var $$ = this,
	            config = $$.config,
	            indices = {},
	            i = 0,
	            j,
	            k;
	        $$.filterTargetsToShow($$.data.targets.filter(typeFilter, $$)).forEach(function (d) {
	            for (j = 0; j < config.data_groups.length; j++) {
	                if (config.data_groups[j].indexOf(d.id) < 0) {
	                    continue;
	                }
	                for (k = 0; k < config.data_groups[j].length; k++) {
	                    if (config.data_groups[j][k] in indices) {
	                        indices[d.id] = indices[config.data_groups[j][k]];
	                        break;
	                    }
	                }
	            }
	            if (isUndefined(indices[d.id])) {
	                indices[d.id] = i++;
	            }
	        });
	        indices.__max__ = i - 1;
	        return indices;
	    };
	    c3_chart_internal_fn.getShapeX = function (offset, targetsNum, indices, isSub) {
	        var $$ = this,
	            scale = isSub ? $$.subX : $$.x;
	        return function (d) {
	            var index = d.id in indices ? indices[d.id] : 0;
	            return d.x || d.x === 0 ? scale(d.x) - offset * (targetsNum / 2 - index) : 0;
	        };
	    };
	    c3_chart_internal_fn.getShapeY = function (isSub) {
	        var $$ = this;
	        return function (d) {
	            var scale = isSub ? $$.getSubYScale(d.id) : $$.getYScale(d.id);
	            return scale(d.value);
	        };
	    };
	    c3_chart_internal_fn.getShapeOffset = function (typeFilter, indices, isSub) {
	        var $$ = this,
	            targets = $$.orderTargets($$.filterTargetsToShow($$.data.targets.filter(typeFilter, $$))),
	            targetIds = targets.map(function (t) {
	            return t.id;
	        });
	        return function (d, i) {
	            var scale = isSub ? $$.getSubYScale(d.id) : $$.getYScale(d.id),
	                y0 = scale(0),
	                offset = y0;
	            targets.forEach(function (t) {
	                var values = $$.isStepType(d) ? $$.convertValuesToStep(t.values) : t.values;
	                if (t.id === d.id || indices[t.id] !== indices[d.id]) {
	                    return;
	                }
	                if (targetIds.indexOf(t.id) < targetIds.indexOf(d.id)) {
	                    // check if the x values line up
	                    if (typeof values[i] === 'undefined' || +values[i].x !== +d.x) {
	                        // "+" for timeseries
	                        // if not, try to find the value that does line up
	                        i = -1;
	                        values.forEach(function (v, j) {
	                            if (v.x === d.x) {
	                                i = j;
	                            }
	                        });
	                    }
	                    if (i in values && values[i].value * d.value >= 0) {
	                        offset += scale(values[i].value) - y0;
	                    }
	                }
	            });
	            return offset;
	        };
	    };
	    c3_chart_internal_fn.isWithinShape = function (that, d) {
	        var $$ = this,
	            shape = $$.d3.select(that),
	            isWithin;
	        if (!$$.isTargetToShow(d.id)) {
	            isWithin = false;
	        } else if (that.nodeName === 'circle') {
	            isWithin = $$.isStepType(d) ? $$.isWithinStep(that, $$.getYScale(d.id)(d.value)) : $$.isWithinCircle(that, $$.pointSelectR(d) * 1.5);
	        } else if (that.nodeName === 'path') {
	            isWithin = shape.classed(CLASS.bar) ? $$.isWithinBar(that) : true;
	        }
	        return isWithin;
	    };
	
	    c3_chart_internal_fn.getInterpolate = function (d) {
	        var $$ = this,
	            interpolation = $$.isInterpolationType($$.config.spline_interpolation_type) ? $$.config.spline_interpolation_type : 'cardinal';
	        return $$.isSplineType(d) ? interpolation : $$.isStepType(d) ? $$.config.line_step_type : "linear";
	    };
	
	    c3_chart_internal_fn.initLine = function () {
	        var $$ = this;
	        $$.main.select('.' + CLASS.chart).append("g").attr("class", CLASS.chartLines);
	    };
	    c3_chart_internal_fn.updateTargetsForLine = function (targets) {
	        var $$ = this,
	            config = $$.config,
	            mainLineUpdate,
	            mainLineEnter,
	            classChartLine = $$.classChartLine.bind($$),
	            classLines = $$.classLines.bind($$),
	            classAreas = $$.classAreas.bind($$),
	            classCircles = $$.classCircles.bind($$),
	            classFocus = $$.classFocus.bind($$);
	        mainLineUpdate = $$.main.select('.' + CLASS.chartLines).selectAll('.' + CLASS.chartLine).data(targets).attr('class', function (d) {
	            return classChartLine(d) + classFocus(d);
	        });
	        mainLineEnter = mainLineUpdate.enter().append('g').attr('class', classChartLine).style('opacity', 0).style("pointer-events", "none");
	        // Lines for each data
	        mainLineEnter.append('g').attr("class", classLines);
	        // Areas
	        mainLineEnter.append('g').attr('class', classAreas);
	        // Circles for each data point on lines
	        mainLineEnter.append('g').attr("class", function (d) {
	            return $$.generateClass(CLASS.selectedCircles, d.id);
	        });
	        mainLineEnter.append('g').attr("class", classCircles).style("cursor", function (d) {
	            return config.data_selection_isselectable(d) ? "pointer" : null;
	        });
	        // Update date for selected circles
	        targets.forEach(function (t) {
	            $$.main.selectAll('.' + CLASS.selectedCircles + $$.getTargetSelectorSuffix(t.id)).selectAll('.' + CLASS.selectedCircle).each(function (d) {
	                d.value = t.values[d.index].value;
	            });
	        });
	        // MEMO: can not keep same color...
	        //mainLineUpdate.exit().remove();
	    };
	    c3_chart_internal_fn.updateLine = function (durationForExit) {
	        var $$ = this;
	        $$.mainLine = $$.main.selectAll('.' + CLASS.lines).selectAll('.' + CLASS.line).data($$.lineData.bind($$));
	        $$.mainLine.enter().append('path').attr('class', $$.classLine.bind($$)).style("stroke", $$.color);
	        $$.mainLine.style("opacity", $$.initialOpacity.bind($$)).style('shape-rendering', function (d) {
	            return $$.isStepType(d) ? 'crispEdges' : '';
	        }).attr('transform', null);
	        $$.mainLine.exit().transition().duration(durationForExit).style('opacity', 0).remove();
	    };
	    c3_chart_internal_fn.redrawLine = function (drawLine, withTransition) {
	        return [(withTransition ? this.mainLine.transition(Math.random().toString()) : this.mainLine).attr("d", drawLine).style("stroke", this.color).style("opacity", 1)];
	    };
	    c3_chart_internal_fn.generateDrawLine = function (lineIndices, isSub) {
	        var $$ = this,
	            config = $$.config,
	            line = $$.d3.svg.line(),
	            getPoints = $$.generateGetLinePoints(lineIndices, isSub),
	            yScaleGetter = isSub ? $$.getSubYScale : $$.getYScale,
	            xValue = function xValue(d) {
	            return (isSub ? $$.subxx : $$.xx).call($$, d);
	        },
	            yValue = function yValue(d, i) {
	            return config.data_groups.length > 0 ? getPoints(d, i)[0][1] : yScaleGetter.call($$, d.id)(d.value);
	        };
	
	        line = config.axis_rotated ? line.x(yValue).y(xValue) : line.x(xValue).y(yValue);
	        if (!config.line_connectNull) {
	            line = line.defined(function (d) {
	                return d.value != null;
	            });
	        }
	        return function (d) {
	            var values = config.line_connectNull ? $$.filterRemoveNull(d.values) : d.values,
	                x = isSub ? $$.subX : $$.x,
	                y = yScaleGetter.call($$, d.id),
	                x0 = 0,
	                y0 = 0,
	                path;
	            if ($$.isLineType(d)) {
	                if (config.data_regions[d.id]) {
	                    path = $$.lineWithRegions(values, x, y, config.data_regions[d.id]);
	                } else {
	                    if ($$.isStepType(d)) {
	                        values = $$.convertValuesToStep(values);
	                    }
	                    path = line.interpolate($$.getInterpolate(d))(values);
	                }
	            } else {
	                if (values[0]) {
	                    x0 = x(values[0].x);
	                    y0 = y(values[0].value);
	                }
	                path = config.axis_rotated ? "M " + y0 + " " + x0 : "M " + x0 + " " + y0;
	            }
	            return path ? path : "M 0 0";
	        };
	    };
	    c3_chart_internal_fn.generateGetLinePoints = function (lineIndices, isSub) {
	        // partial duplication of generateGetBarPoints
	        var $$ = this,
	            config = $$.config,
	            lineTargetsNum = lineIndices.__max__ + 1,
	            x = $$.getShapeX(0, lineTargetsNum, lineIndices, !!isSub),
	            y = $$.getShapeY(!!isSub),
	            lineOffset = $$.getShapeOffset($$.isLineType, lineIndices, !!isSub),
	            yScale = isSub ? $$.getSubYScale : $$.getYScale;
	        return function (d, i) {
	            var y0 = yScale.call($$, d.id)(0),
	                offset = lineOffset(d, i) || y0,
	                // offset is for stacked area chart
	            posX = x(d),
	                posY = y(d);
	            // fix posY not to overflow opposite quadrant
	            if (config.axis_rotated) {
	                if (0 < d.value && posY < y0 || d.value < 0 && y0 < posY) {
	                    posY = y0;
	                }
	            }
	            // 1 point that marks the line position
	            return [[posX, posY - (y0 - offset)], [posX, posY - (y0 - offset)], // needed for compatibility
	            [posX, posY - (y0 - offset)], // needed for compatibility
	            [posX, posY - (y0 - offset)] // needed for compatibility
	            ];
	        };
	    };
	
	    c3_chart_internal_fn.lineWithRegions = function (d, x, y, _regions) {
	        var $$ = this,
	            config = $$.config,
	            prev = -1,
	            i,
	            j,
	            s = "M",
	            sWithRegion,
	            xp,
	            yp,
	            dx,
	            dy,
	            dd,
	            diff,
	            diffx2,
	            xOffset = $$.isCategorized() ? 0.5 : 0,
	            xValue,
	            yValue,
	            regions = [];
	
	        function isWithinRegions(x, regions) {
	            var i;
	            for (i = 0; i < regions.length; i++) {
	                if (regions[i].start < x && x <= regions[i].end) {
	                    return true;
	                }
	            }
	            return false;
	        }
	
	        // Check start/end of regions
	        if (isDefined(_regions)) {
	            for (i = 0; i < _regions.length; i++) {
	                regions[i] = {};
	                if (isUndefined(_regions[i].start)) {
	                    regions[i].start = d[0].x;
	                } else {
	                    regions[i].start = $$.isTimeSeries() ? $$.parseDate(_regions[i].start) : _regions[i].start;
	                }
	                if (isUndefined(_regions[i].end)) {
	                    regions[i].end = d[d.length - 1].x;
	                } else {
	                    regions[i].end = $$.isTimeSeries() ? $$.parseDate(_regions[i].end) : _regions[i].end;
	                }
	            }
	        }
	
	        // Set scales
	        xValue = config.axis_rotated ? function (d) {
	            return y(d.value);
	        } : function (d) {
	            return x(d.x);
	        };
	        yValue = config.axis_rotated ? function (d) {
	            return x(d.x);
	        } : function (d) {
	            return y(d.value);
	        };
	
	        // Define svg generator function for region
	        function generateM(points) {
	            return 'M' + points[0][0] + ' ' + points[0][1] + ' ' + points[1][0] + ' ' + points[1][1];
	        }
	        if ($$.isTimeSeries()) {
	            sWithRegion = function sWithRegion(d0, d1, j, diff) {
	                var x0 = d0.x.getTime(),
	                    x_diff = d1.x - d0.x,
	                    xv0 = new Date(x0 + x_diff * j),
	                    xv1 = new Date(x0 + x_diff * (j + diff)),
	                    points;
	                if (config.axis_rotated) {
	                    points = [[y(yp(j)), x(xv0)], [y(yp(j + diff)), x(xv1)]];
	                } else {
	                    points = [[x(xv0), y(yp(j))], [x(xv1), y(yp(j + diff))]];
	                }
	                return generateM(points);
	            };
	        } else {
	            sWithRegion = function sWithRegion(d0, d1, j, diff) {
	                var points;
	                if (config.axis_rotated) {
	                    points = [[y(yp(j), true), x(xp(j))], [y(yp(j + diff), true), x(xp(j + diff))]];
	                } else {
	                    points = [[x(xp(j), true), y(yp(j))], [x(xp(j + diff), true), y(yp(j + diff))]];
	                }
	                return generateM(points);
	            };
	        }
	
	        // Generate
	        for (i = 0; i < d.length; i++) {
	
	            // Draw as normal
	            if (isUndefined(regions) || !isWithinRegions(d[i].x, regions)) {
	                s += " " + xValue(d[i]) + " " + yValue(d[i]);
	            }
	            // Draw with region // TODO: Fix for horizotal charts
	            else {
	                    xp = $$.getScale(d[i - 1].x + xOffset, d[i].x + xOffset, $$.isTimeSeries());
	                    yp = $$.getScale(d[i - 1].value, d[i].value);
	
	                    dx = x(d[i].x) - x(d[i - 1].x);
	                    dy = y(d[i].value) - y(d[i - 1].value);
	                    dd = Math.sqrt(Math.pow(dx, 2) + Math.pow(dy, 2));
	                    diff = 2 / dd;
	                    diffx2 = diff * 2;
	
	                    for (j = diff; j <= 1; j += diffx2) {
	                        s += sWithRegion(d[i - 1], d[i], j, diff);
	                    }
	                }
	            prev = d[i].x;
	        }
	
	        return s;
	    };
	
	    c3_chart_internal_fn.updateArea = function (durationForExit) {
	        var $$ = this,
	            d3 = $$.d3;
	        $$.mainArea = $$.main.selectAll('.' + CLASS.areas).selectAll('.' + CLASS.area).data($$.lineData.bind($$));
	        $$.mainArea.enter().append('path').attr("class", $$.classArea.bind($$)).style("fill", $$.color).style("opacity", function () {
	            $$.orgAreaOpacity = +d3.select(this).style('opacity');return 0;
	        });
	        $$.mainArea.style("opacity", $$.orgAreaOpacity);
	        $$.mainArea.exit().transition().duration(durationForExit).style('opacity', 0).remove();
	    };
	    c3_chart_internal_fn.redrawArea = function (drawArea, withTransition) {
	        return [(withTransition ? this.mainArea.transition(Math.random().toString()) : this.mainArea).attr("d", drawArea).style("fill", this.color).style("opacity", this.orgAreaOpacity)];
	    };
	    c3_chart_internal_fn.generateDrawArea = function (areaIndices, isSub) {
	        var $$ = this,
	            config = $$.config,
	            area = $$.d3.svg.area(),
	            getPoints = $$.generateGetAreaPoints(areaIndices, isSub),
	            yScaleGetter = isSub ? $$.getSubYScale : $$.getYScale,
	            xValue = function xValue(d) {
	            return (isSub ? $$.subxx : $$.xx).call($$, d);
	        },
	            value0 = function value0(d, i) {
	            return config.data_groups.length > 0 ? getPoints(d, i)[0][1] : yScaleGetter.call($$, d.id)($$.getAreaBaseValue(d.id));
	        },
	            value1 = function value1(d, i) {
	            return config.data_groups.length > 0 ? getPoints(d, i)[1][1] : yScaleGetter.call($$, d.id)(d.value);
	        };
	
	        area = config.axis_rotated ? area.x0(value0).x1(value1).y(xValue) : area.x(xValue).y0(config.area_above ? 0 : value0).y1(value1);
	        if (!config.line_connectNull) {
	            area = area.defined(function (d) {
	                return d.value !== null;
	            });
	        }
	
	        return function (d) {
	            var values = config.line_connectNull ? $$.filterRemoveNull(d.values) : d.values,
	                x0 = 0,
	                y0 = 0,
	                path;
	            if ($$.isAreaType(d)) {
	                if ($$.isStepType(d)) {
	                    values = $$.convertValuesToStep(values);
	                }
	                path = area.interpolate($$.getInterpolate(d))(values);
	            } else {
	                if (values[0]) {
	                    x0 = $$.x(values[0].x);
	                    y0 = $$.getYScale(d.id)(values[0].value);
	                }
	                path = config.axis_rotated ? "M " + y0 + " " + x0 : "M " + x0 + " " + y0;
	            }
	            return path ? path : "M 0 0";
	        };
	    };
	    c3_chart_internal_fn.getAreaBaseValue = function () {
	        return 0;
	    };
	    c3_chart_internal_fn.generateGetAreaPoints = function (areaIndices, isSub) {
	        // partial duplication of generateGetBarPoints
	        var $$ = this,
	            config = $$.config,
	            areaTargetsNum = areaIndices.__max__ + 1,
	            x = $$.getShapeX(0, areaTargetsNum, areaIndices, !!isSub),
	            y = $$.getShapeY(!!isSub),
	            areaOffset = $$.getShapeOffset($$.isAreaType, areaIndices, !!isSub),
	            yScale = isSub ? $$.getSubYScale : $$.getYScale;
	        return function (d, i) {
	            var y0 = yScale.call($$, d.id)(0),
	                offset = areaOffset(d, i) || y0,
	                // offset is for stacked area chart
	            posX = x(d),
	                posY = y(d);
	            // fix posY not to overflow opposite quadrant
	            if (config.axis_rotated) {
	                if (0 < d.value && posY < y0 || d.value < 0 && y0 < posY) {
	                    posY = y0;
	                }
	            }
	            // 1 point that marks the area position
	            return [[posX, offset], [posX, posY - (y0 - offset)], [posX, posY - (y0 - offset)], // needed for compatibility
	            [posX, offset] // needed for compatibility
	            ];
	        };
	    };
	
	    c3_chart_internal_fn.updateCircle = function () {
	        var $$ = this;
	        $$.mainCircle = $$.main.selectAll('.' + CLASS.circles).selectAll('.' + CLASS.circle).data($$.lineOrScatterData.bind($$));
	        $$.mainCircle.enter().append("circle").attr("class", $$.classCircle.bind($$)).attr("r", $$.pointR.bind($$)).style("fill", $$.color);
	        $$.mainCircle.style("opacity", $$.initialOpacityForCircle.bind($$));
	        $$.mainCircle.exit().remove();
	    };
	    c3_chart_internal_fn.redrawCircle = function (cx, cy, withTransition) {
	        var selectedCircles = this.main.selectAll('.' + CLASS.selectedCircle);
	        return [(withTransition ? this.mainCircle.transition(Math.random().toString()) : this.mainCircle).style('opacity', this.opacityForCircle.bind(this)).style("fill", this.color).attr("cx", cx).attr("cy", cy), (withTransition ? selectedCircles.transition(Math.random().toString()) : selectedCircles).attr("cx", cx).attr("cy", cy)];
	    };
	    c3_chart_internal_fn.circleX = function (d) {
	        return d.x || d.x === 0 ? this.x(d.x) : null;
	    };
	    c3_chart_internal_fn.updateCircleY = function () {
	        var $$ = this,
	            lineIndices,
	            getPoints;
	        if ($$.config.data_groups.length > 0) {
	            lineIndices = $$.getShapeIndices($$.isLineType), getPoints = $$.generateGetLinePoints(lineIndices);
	            $$.circleY = function (d, i) {
	                return getPoints(d, i)[0][1];
	            };
	        } else {
	            $$.circleY = function (d) {
	                return $$.getYScale(d.id)(d.value);
	            };
	        }
	    };
	    c3_chart_internal_fn.getCircles = function (i, id) {
	        var $$ = this;
	        return (id ? $$.main.selectAll('.' + CLASS.circles + $$.getTargetSelectorSuffix(id)) : $$.main).selectAll('.' + CLASS.circle + (isValue(i) ? '-' + i : ''));
	    };
	    c3_chart_internal_fn.expandCircles = function (i, id, reset) {
	        var $$ = this,
	            r = $$.pointExpandedR.bind($$);
	        if (reset) {
	            $$.unexpandCircles();
	        }
	        $$.getCircles(i, id).classed(CLASS.EXPANDED, true).attr('r', r);
	    };
	    c3_chart_internal_fn.unexpandCircles = function (i) {
	        var $$ = this,
	            r = $$.pointR.bind($$);
	        $$.getCircles(i).filter(function () {
	            return $$.d3.select(this).classed(CLASS.EXPANDED);
	        }).classed(CLASS.EXPANDED, false).attr('r', r);
	    };
	    c3_chart_internal_fn.pointR = function (d) {
	        var $$ = this,
	            config = $$.config;
	        return $$.isStepType(d) ? 0 : isFunction(config.point_r) ? config.point_r(d) : config.point_r;
	    };
	    c3_chart_internal_fn.pointExpandedR = function (d) {
	        var $$ = this,
	            config = $$.config;
	        if (config.point_focus_expand_enabled) {
	            return isFunction(config.point_focus_expand_r) ? config.point_focus_expand_r(d) : config.point_focus_expand_r ? config.point_focus_expand_r : $$.pointR(d) * 1.75;
	        } else {
	            return $$.pointR(d);
	        }
	    };
	    c3_chart_internal_fn.pointSelectR = function (d) {
	        var $$ = this,
	            config = $$.config;
	        return isFunction(config.point_select_r) ? config.point_select_r(d) : config.point_select_r ? config.point_select_r : $$.pointR(d) * 4;
	    };
	    c3_chart_internal_fn.isWithinCircle = function (that, r) {
	        var d3 = this.d3,
	            mouse = d3.mouse(that),
	            d3_this = d3.select(that),
	            cx = +d3_this.attr("cx"),
	            cy = +d3_this.attr("cy");
	        return Math.sqrt(Math.pow(cx - mouse[0], 2) + Math.pow(cy - mouse[1], 2)) < r;
	    };
	    c3_chart_internal_fn.isWithinStep = function (that, y) {
	        return Math.abs(y - this.d3.mouse(that)[1]) < 30;
	    };
	
	    c3_chart_internal_fn.getCurrentWidth = function () {
	        var $$ = this,
	            config = $$.config;
	        return config.size_width ? config.size_width : $$.getParentWidth();
	    };
	    c3_chart_internal_fn.getCurrentHeight = function () {
	        var $$ = this,
	            config = $$.config,
	            h = config.size_height ? config.size_height : $$.getParentHeight();
	        return h > 0 ? h : 320 / ($$.hasType('gauge') && !config.gauge_fullCircle ? 2 : 1);
	    };
	    c3_chart_internal_fn.getCurrentPaddingTop = function () {
	        var $$ = this,
	            config = $$.config,
	            padding = isValue(config.padding_top) ? config.padding_top : 0;
	        if ($$.title && $$.title.node()) {
	            padding += $$.getTitlePadding();
	        }
	        return padding;
	    };
	    c3_chart_internal_fn.getCurrentPaddingBottom = function () {
	        var config = this.config;
	        return isValue(config.padding_bottom) ? config.padding_bottom : 0;
	    };
	    c3_chart_internal_fn.getCurrentPaddingLeft = function (withoutRecompute) {
	        var $$ = this,
	            config = $$.config;
	        if (isValue(config.padding_left)) {
	            return config.padding_left;
	        } else if (config.axis_rotated) {
	            return !config.axis_x_show || config.axis_x_inner ? 1 : Math.max(ceil10($$.getAxisWidthByAxisId('x', withoutRecompute)), 40);
	        } else if (!config.axis_y_show || config.axis_y_inner) {
	            // && !config.axis_rotated
	            return $$.axis.getYAxisLabelPosition().isOuter ? 30 : 1;
	        } else {
	            return ceil10($$.getAxisWidthByAxisId('y', withoutRecompute));
	        }
	    };
	    c3_chart_internal_fn.getCurrentPaddingRight = function () {
	        var $$ = this,
	            config = $$.config,
	            defaultPadding = 10,
	            legendWidthOnRight = $$.isLegendRight ? $$.getLegendWidth() + 20 : 0;
	        if (isValue(config.padding_right)) {
	            return config.padding_right + 1; // 1 is needed not to hide tick line
	        } else if (config.axis_rotated) {
	            return defaultPadding + legendWidthOnRight;
	        } else if (!config.axis_y2_show || config.axis_y2_inner) {
	            // && !config.axis_rotated
	            return 2 + legendWidthOnRight + ($$.axis.getY2AxisLabelPosition().isOuter ? 20 : 0);
	        } else {
	            return ceil10($$.getAxisWidthByAxisId('y2')) + legendWidthOnRight;
	        }
	    };
	
	    c3_chart_internal_fn.getParentRectValue = function (key) {
	        var parent = this.selectChart.node(),
	            v;
	        while (parent && parent.tagName !== 'BODY') {
	            try {
	                v = parent.getBoundingClientRect()[key];
	            } catch (e) {
	                if (key === 'width') {
	                    // In IE in certain cases getBoundingClientRect
	                    // will cause an "unspecified error"
	                    v = parent.offsetWidth;
	                }
	            }
	            if (v) {
	                break;
	            }
	            parent = parent.parentNode;
	        }
	        return v;
	    };
	    c3_chart_internal_fn.getParentWidth = function () {
	        return this.getParentRectValue('width');
	    };
	    c3_chart_internal_fn.getParentHeight = function () {
	        var h = this.selectChart.style('height');
	        return h.indexOf('px') > 0 ? +h.replace('px', '') : 0;
	    };
	
	    c3_chart_internal_fn.getSvgLeft = function (withoutRecompute) {
	        var $$ = this,
	            config = $$.config,
	            hasLeftAxisRect = config.axis_rotated || !config.axis_rotated && !config.axis_y_inner,
	            leftAxisClass = config.axis_rotated ? CLASS.axisX : CLASS.axisY,
	            leftAxis = $$.main.select('.' + leftAxisClass).node(),
	            svgRect = leftAxis && hasLeftAxisRect ? leftAxis.getBoundingClientRect() : { right: 0 },
	            chartRect = $$.selectChart.node().getBoundingClientRect(),
	            hasArc = $$.hasArcType(),
	            svgLeft = svgRect.right - chartRect.left - (hasArc ? 0 : $$.getCurrentPaddingLeft(withoutRecompute));
	        return svgLeft > 0 ? svgLeft : 0;
	    };
	
	    c3_chart_internal_fn.getAxisWidthByAxisId = function (id, withoutRecompute) {
	        var $$ = this,
	            position = $$.axis.getLabelPositionById(id);
	        return $$.axis.getMaxTickWidth(id, withoutRecompute) + (position.isInner ? 20 : 40);
	    };
	    c3_chart_internal_fn.getHorizontalAxisHeight = function (axisId) {
	        var $$ = this,
	            config = $$.config,
	            h = 30;
	        if (axisId === 'x' && !config.axis_x_show) {
	            return 8;
	        }
	        if (axisId === 'x' && config.axis_x_height) {
	            return config.axis_x_height;
	        }
	        if (axisId === 'y' && !config.axis_y_show) {
	            return config.legend_show && !$$.isLegendRight && !$$.isLegendInset ? 10 : 1;
	        }
	        if (axisId === 'y2' && !config.axis_y2_show) {
	            return $$.rotated_padding_top;
	        }
	        // Calculate x axis height when tick rotated
	        if (axisId === 'x' && !config.axis_rotated && config.axis_x_tick_rotate) {
	            h = 30 + $$.axis.getMaxTickWidth(axisId) * Math.cos(Math.PI * (90 - config.axis_x_tick_rotate) / 180);
	        }
	        // Calculate y axis height when tick rotated
	        if (axisId === 'y' && config.axis_rotated && config.axis_y_tick_rotate) {
	            h = 30 + $$.axis.getMaxTickWidth(axisId) * Math.cos(Math.PI * (90 - config.axis_y_tick_rotate) / 180);
	        }
	        return h + ($$.axis.getLabelPositionById(axisId).isInner ? 0 : 10) + (axisId === 'y2' ? -10 : 0);
	    };
	
	    c3_chart_internal_fn.getEventRectWidth = function () {
	        return Math.max(0, this.xAxis.tickInterval());
	    };
	
	    c3_chart_internal_fn.initBrush = function () {
	        var $$ = this,
	            d3 = $$.d3;
	        $$.brush = d3.svg.brush().on("brush", function () {
	            $$.redrawForBrush();
	        });
	        $$.brush.update = function () {
	            if ($$.context) {
	                $$.context.select('.' + CLASS.brush).call(this);
	            }
	            return this;
	        };
	        $$.brush.scale = function (scale) {
	            return $$.config.axis_rotated ? this.y(scale) : this.x(scale);
	        };
	    };
	    c3_chart_internal_fn.initSubchart = function () {
	        var $$ = this,
	            config = $$.config,
	            context = $$.context = $$.svg.append("g").attr("transform", $$.getTranslate('context')),
	            visibility = config.subchart_show ? 'visible' : 'hidden';
	
	        context.style('visibility', visibility);
	
	        // Define g for chart area
	        context.append('g').attr("clip-path", $$.clipPathForSubchart).attr('class', CLASS.chart);
	
	        // Define g for bar chart area
	        context.select('.' + CLASS.chart).append("g").attr("class", CLASS.chartBars);
	
	        // Define g for line chart area
	        context.select('.' + CLASS.chart).append("g").attr("class", CLASS.chartLines);
	
	        // Add extent rect for Brush
	        context.append("g").attr("clip-path", $$.clipPath).attr("class", CLASS.brush).call($$.brush);
	
	        // ATTENTION: This must be called AFTER chart added
	        // Add Axis
	        $$.axes.subx = context.append("g").attr("class", CLASS.axisX).attr("transform", $$.getTranslate('subx')).attr("clip-path", config.axis_rotated ? "" : $$.clipPathForXAxis).style("visibility", config.subchart_axis_x_show ? visibility : 'hidden');
	    };
	    c3_chart_internal_fn.updateTargetsForSubchart = function (targets) {
	        var $$ = this,
	            context = $$.context,
	            config = $$.config,
	            contextLineEnter,
	            contextLineUpdate,
	            contextBarEnter,
	            contextBarUpdate,
	            classChartBar = $$.classChartBar.bind($$),
	            classBars = $$.classBars.bind($$),
	            classChartLine = $$.classChartLine.bind($$),
	            classLines = $$.classLines.bind($$),
	            classAreas = $$.classAreas.bind($$);
	
	        if (config.subchart_show) {
	            //-- Bar --//
	            contextBarUpdate = context.select('.' + CLASS.chartBars).selectAll('.' + CLASS.chartBar).data(targets).attr('class', classChartBar);
	            contextBarEnter = contextBarUpdate.enter().append('g').style('opacity', 0).attr('class', classChartBar);
	            // Bars for each data
	            contextBarEnter.append('g').attr("class", classBars);
	
	            //-- Line --//
	            contextLineUpdate = context.select('.' + CLASS.chartLines).selectAll('.' + CLASS.chartLine).data(targets).attr('class', classChartLine);
	            contextLineEnter = contextLineUpdate.enter().append('g').style('opacity', 0).attr('class', classChartLine);
	            // Lines for each data
	            contextLineEnter.append("g").attr("class", classLines);
	            // Area
	            contextLineEnter.append("g").attr("class", classAreas);
	
	            //-- Brush --//
	            context.selectAll('.' + CLASS.brush + ' rect').attr(config.axis_rotated ? "width" : "height", config.axis_rotated ? $$.width2 : $$.height2);
	        }
	    };
	    c3_chart_internal_fn.updateBarForSubchart = function (durationForExit) {
	        var $$ = this;
	        $$.contextBar = $$.context.selectAll('.' + CLASS.bars).selectAll('.' + CLASS.bar).data($$.barData.bind($$));
	        $$.contextBar.enter().append('path').attr("class", $$.classBar.bind($$)).style("stroke", 'none').style("fill", $$.color);
	        $$.contextBar.style("opacity", $$.initialOpacity.bind($$));
	        $$.contextBar.exit().transition().duration(durationForExit).style('opacity', 0).remove();
	    };
	    c3_chart_internal_fn.redrawBarForSubchart = function (drawBarOnSub, withTransition, duration) {
	        (withTransition ? this.contextBar.transition(Math.random().toString()).duration(duration) : this.contextBar).attr('d', drawBarOnSub).style('opacity', 1);
	    };
	    c3_chart_internal_fn.updateLineForSubchart = function (durationForExit) {
	        var $$ = this;
	        $$.contextLine = $$.context.selectAll('.' + CLASS.lines).selectAll('.' + CLASS.line).data($$.lineData.bind($$));
	        $$.contextLine.enter().append('path').attr('class', $$.classLine.bind($$)).style('stroke', $$.color);
	        $$.contextLine.style("opacity", $$.initialOpacity.bind($$));
	        $$.contextLine.exit().transition().duration(durationForExit).style('opacity', 0).remove();
	    };
	    c3_chart_internal_fn.redrawLineForSubchart = function (drawLineOnSub, withTransition, duration) {
	        (withTransition ? this.contextLine.transition(Math.random().toString()).duration(duration) : this.contextLine).attr("d", drawLineOnSub).style('opacity', 1);
	    };
	    c3_chart_internal_fn.updateAreaForSubchart = function (durationForExit) {
	        var $$ = this,
	            d3 = $$.d3;
	        $$.contextArea = $$.context.selectAll('.' + CLASS.areas).selectAll('.' + CLASS.area).data($$.lineData.bind($$));
	        $$.contextArea.enter().append('path').attr("class", $$.classArea.bind($$)).style("fill", $$.color).style("opacity", function () {
	            $$.orgAreaOpacity = +d3.select(this).style('opacity');return 0;
	        });
	        $$.contextArea.style("opacity", 0);
	        $$.contextArea.exit().transition().duration(durationForExit).style('opacity', 0).remove();
	    };
	    c3_chart_internal_fn.redrawAreaForSubchart = function (drawAreaOnSub, withTransition, duration) {
	        (withTransition ? this.contextArea.transition(Math.random().toString()).duration(duration) : this.contextArea).attr("d", drawAreaOnSub).style("fill", this.color).style("opacity", this.orgAreaOpacity);
	    };
	    c3_chart_internal_fn.redrawSubchart = function (withSubchart, transitions, duration, durationForExit, areaIndices, barIndices, lineIndices) {
	        var $$ = this,
	            d3 = $$.d3,
	            config = $$.config,
	            drawAreaOnSub,
	            drawBarOnSub,
	            drawLineOnSub;
	
	        $$.context.style('visibility', config.subchart_show ? 'visible' : 'hidden');
	
	        // subchart
	        if (config.subchart_show) {
	            // reflect main chart to extent on subchart if zoomed
	            if (d3.event && d3.event.type === 'zoom') {
	                $$.brush.extent($$.x.orgDomain()).update();
	            }
	            // update subchart elements if needed
	            if (withSubchart) {
	
	                // extent rect
	                if (!$$.brush.empty()) {
	                    $$.brush.extent($$.x.orgDomain()).update();
	                }
	                // setup drawer - MEMO: this must be called after axis updated
	                drawAreaOnSub = $$.generateDrawArea(areaIndices, true);
	                drawBarOnSub = $$.generateDrawBar(barIndices, true);
	                drawLineOnSub = $$.generateDrawLine(lineIndices, true);
	
	                $$.updateBarForSubchart(duration);
	                $$.updateLineForSubchart(duration);
	                $$.updateAreaForSubchart(duration);
	
	                $$.redrawBarForSubchart(drawBarOnSub, duration, duration);
	                $$.redrawLineForSubchart(drawLineOnSub, duration, duration);
	                $$.redrawAreaForSubchart(drawAreaOnSub, duration, duration);
	            }
	        }
	    };
	    c3_chart_internal_fn.redrawForBrush = function () {
	        var $$ = this,
	            x = $$.x;
	        $$.redraw({
	            withTransition: false,
	            withY: $$.config.zoom_rescale,
	            withSubchart: false,
	            withUpdateXDomain: true,
	            withDimension: false
	        });
	        $$.config.subchart_onbrush.call($$.api, x.orgDomain());
	    };
	    c3_chart_internal_fn.transformContext = function (withTransition, transitions) {
	        var $$ = this,
	            subXAxis;
	        if (transitions && transitions.axisSubX) {
	            subXAxis = transitions.axisSubX;
	        } else {
	            subXAxis = $$.context.select('.' + CLASS.axisX);
	            if (withTransition) {
	                subXAxis = subXAxis.transition();
	            }
	        }
	        $$.context.attr("transform", $$.getTranslate('context'));
	        subXAxis.attr("transform", $$.getTranslate('subx'));
	    };
	    c3_chart_internal_fn.getDefaultExtent = function () {
	        var $$ = this,
	            config = $$.config,
	            extent = isFunction(config.axis_x_extent) ? config.axis_x_extent($$.getXDomain($$.data.targets)) : config.axis_x_extent;
	        if ($$.isTimeSeries()) {
	            extent = [$$.parseDate(extent[0]), $$.parseDate(extent[1])];
	        }
	        return extent;
	    };
	
	    c3_chart_internal_fn.initText = function () {
	        var $$ = this;
	        $$.main.select('.' + CLASS.chart).append("g").attr("class", CLASS.chartTexts);
	        $$.mainText = $$.d3.selectAll([]);
	    };
	    c3_chart_internal_fn.updateTargetsForText = function (targets) {
	        var $$ = this,
	            mainTextUpdate,
	            mainTextEnter,
	            classChartText = $$.classChartText.bind($$),
	            classTexts = $$.classTexts.bind($$),
	            classFocus = $$.classFocus.bind($$);
	        mainTextUpdate = $$.main.select('.' + CLASS.chartTexts).selectAll('.' + CLASS.chartText).data(targets).attr('class', function (d) {
	            return classChartText(d) + classFocus(d);
	        });
	        mainTextEnter = mainTextUpdate.enter().append('g').attr('class', classChartText).style('opacity', 0).style("pointer-events", "none");
	        mainTextEnter.append('g').attr('class', classTexts);
	    };
	    c3_chart_internal_fn.updateText = function (durationForExit) {
	        var $$ = this,
	            config = $$.config,
	            barOrLineData = $$.barOrLineData.bind($$),
	            classText = $$.classText.bind($$);
	        $$.mainText = $$.main.selectAll('.' + CLASS.texts).selectAll('.' + CLASS.text).data(barOrLineData);
	        $$.mainText.enter().append('text').attr("class", classText).attr('text-anchor', function (d) {
	            return config.axis_rotated ? d.value < 0 ? 'end' : 'start' : 'middle';
	        }).style("stroke", 'none').style("fill", function (d) {
	            return $$.color(d);
	        }).style("fill-opacity", 0);
	        $$.mainText.text(function (d, i, j) {
	            return $$.dataLabelFormat(d.id)(d.value, d.id, i, j);
	        });
	        $$.mainText.exit().transition().duration(durationForExit).style('fill-opacity', 0).remove();
	    };
	    c3_chart_internal_fn.redrawText = function (xForText, yForText, forFlow, withTransition) {
	        return [(withTransition ? this.mainText.transition() : this.mainText).attr('x', xForText).attr('y', yForText).style("fill", this.color).style("fill-opacity", forFlow ? 0 : this.opacityForText.bind(this))];
	    };
	    c3_chart_internal_fn.getTextRect = function (text, cls, element) {
	        var dummy = this.d3.select('body').append('div').classed('c3', true),
	            svg = dummy.append("svg").style('visibility', 'hidden').style('position', 'fixed').style('top', 0).style('left', 0),
	            font = this.d3.select(element).style('font'),
	            rect;
	        svg.selectAll('.dummy').data([text]).enter().append('text').classed(cls ? cls : "", true).style('font', font).text(text).each(function () {
	            rect = this.getBoundingClientRect();
	        });
	        dummy.remove();
	        return rect;
	    };
	    c3_chart_internal_fn.generateXYForText = function (areaIndices, barIndices, lineIndices, forX) {
	        var $$ = this,
	            getAreaPoints = $$.generateGetAreaPoints(areaIndices, false),
	            getBarPoints = $$.generateGetBarPoints(barIndices, false),
	            getLinePoints = $$.generateGetLinePoints(lineIndices, false),
	            getter = forX ? $$.getXForText : $$.getYForText;
	        return function (d, i) {
	            var getPoints = $$.isAreaType(d) ? getAreaPoints : $$.isBarType(d) ? getBarPoints : getLinePoints;
	            return getter.call($$, getPoints(d, i), d, this);
	        };
	    };
	    c3_chart_internal_fn.getXForText = function (points, d, textElement) {
	        var $$ = this,
	            box = textElement.getBoundingClientRect(),
	            xPos,
	            padding;
	        if ($$.config.axis_rotated) {
	            padding = $$.isBarType(d) ? 4 : 6;
	            xPos = points[2][1] + padding * (d.value < 0 ? -1 : 1);
	        } else {
	            xPos = $$.hasType('bar') ? (points[2][0] + points[0][0]) / 2 : points[0][0];
	        }
	        // show labels regardless of the domain if value is null
	        if (d.value === null) {
	            if (xPos > $$.width) {
	                xPos = $$.width - box.width;
	            } else if (xPos < 0) {
	                xPos = 4;
	            }
	        }
	        return xPos;
	    };
	    c3_chart_internal_fn.getYForText = function (points, d, textElement) {
	        var $$ = this,
	            box = textElement.getBoundingClientRect(),
	            yPos;
	        if ($$.config.axis_rotated) {
	            yPos = (points[0][0] + points[2][0] + box.height * 0.6) / 2;
	        } else {
	            yPos = points[2][1];
	            if (d.value < 0 || d.value === 0 && !$$.hasPositiveValue) {
	                yPos += box.height;
	                if ($$.isBarType(d) && $$.isSafari()) {
	                    yPos -= 3;
	                } else if (!$$.isBarType(d) && $$.isChrome()) {
	                    yPos += 3;
	                }
	            } else {
	                yPos += $$.isBarType(d) ? -3 : -6;
	            }
	        }
	        // show labels regardless of the domain if value is null
	        if (d.value === null && !$$.config.axis_rotated) {
	            if (yPos < box.height) {
	                yPos = box.height;
	            } else if (yPos > this.height) {
	                yPos = this.height - 4;
	            }
	        }
	        return yPos;
	    };
	
	    c3_chart_internal_fn.initTitle = function () {
	        var $$ = this;
	        $$.title = $$.svg.append("text").text($$.config.title_text).attr("class", $$.CLASS.title);
	    };
	    c3_chart_internal_fn.redrawTitle = function () {
	        var $$ = this;
	        $$.title.attr("x", $$.xForTitle.bind($$)).attr("y", $$.yForTitle.bind($$));
	    };
	    c3_chart_internal_fn.xForTitle = function () {
	        var $$ = this,
	            config = $$.config,
	            position = config.title_position || 'left',
	            x;
	        if (position.indexOf('right') >= 0) {
	            x = $$.currentWidth - $$.getTextRect($$.title.node().textContent, $$.CLASS.title, $$.title.node()).width - config.title_padding.right;
	        } else if (position.indexOf('center') >= 0) {
	            x = ($$.currentWidth - $$.getTextRect($$.title.node().textContent, $$.CLASS.title, $$.title.node()).width) / 2;
	        } else {
	            // left
	            x = config.title_padding.left;
	        }
	        return x;
	    };
	    c3_chart_internal_fn.yForTitle = function () {
	        var $$ = this;
	        return $$.config.title_padding.top + $$.getTextRect($$.title.node().textContent, $$.CLASS.title, $$.title.node()).height;
	    };
	    c3_chart_internal_fn.getTitlePadding = function () {
	        var $$ = this;
	        return $$.yForTitle() + $$.config.title_padding.bottom;
	    };
	
	    c3_chart_internal_fn.initTooltip = function () {
	        var $$ = this,
	            config = $$.config,
	            i;
	        $$.tooltip = $$.selectChart.style("position", "relative").append("div").attr('class', CLASS.tooltipContainer).style("position", "absolute").style("pointer-events", "none").style("display", "none");
	        // Show tooltip if needed
	        if (config.tooltip_init_show) {
	            if ($$.isTimeSeries() && isString(config.tooltip_init_x)) {
	                config.tooltip_init_x = $$.parseDate(config.tooltip_init_x);
	                for (i = 0; i < $$.data.targets[0].values.length; i++) {
	                    if ($$.data.targets[0].values[i].x - config.tooltip_init_x === 0) {
	                        break;
	                    }
	                }
	                config.tooltip_init_x = i;
	            }
	            $$.tooltip.html(config.tooltip_contents.call($$, $$.data.targets.map(function (d) {
	                return $$.addName(d.values[config.tooltip_init_x]);
	            }), $$.axis.getXAxisTickFormat(), $$.getYFormat($$.hasArcType()), $$.color));
	            $$.tooltip.style("top", config.tooltip_init_position.top).style("left", config.tooltip_init_position.left).style("display", "block");
	        }
	    };
	    c3_chart_internal_fn.getTooltipSortFunction = function () {
	        var $$ = this,
	            config = $$.config;
	
	        if (config.data_groups.length === 0 || config.tooltip_order !== undefined) {
	            // if data are not grouped or if an order is specified
	            // for the tooltip values we sort them by their values
	
	            var order = config.tooltip_order;
	            if (order === undefined) {
	                order = config.data_order;
	            }
	
	            var valueOf = function valueOf(obj) {
	                return obj ? obj.value : null;
	            };
	
	            // if data are not grouped, we sort them by their value
	            if (isString(order) && order.toLowerCase() === 'asc') {
	                return function (a, b) {
	                    return valueOf(a) - valueOf(b);
	                };
	            } else if (isString(order) && order.toLowerCase() === 'desc') {
	                return function (a, b) {
	                    return valueOf(b) - valueOf(a);
	                };
	            } else if (isFunction(order)) {
	
	                // if the function is from data_order we need
	                // to wrap the returned function in order to format
	                // the sorted value to the expected format
	
	                var sortFunction = order;
	
	                if (config.tooltip_order === undefined) {
	                    sortFunction = function sortFunction(a, b) {
	                        return order(a ? {
	                            id: a.id,
	                            values: [a]
	                        } : null, b ? {
	                            id: b.id,
	                            values: [b]
	                        } : null);
	                    };
	                }
	
	                return sortFunction;
	            } else if (isArray(order)) {
	                return function (a, b) {
	                    return order.indexOf(a.id) - order.indexOf(b.id);
	                };
	            }
	        } else {
	            // if data are grouped, we follow the order of grouped targets
	            var ids = $$.orderTargets($$.data.targets).map(function (i) {
	                return i.id;
	            });
	
	            // if it was either asc or desc we need to invert the order
	            // returned by orderTargets
	            if ($$.isOrderAsc() || $$.isOrderDesc()) {
	                ids = ids.reverse();
	            }
	
	            return function (a, b) {
	                return ids.indexOf(a.id) - ids.indexOf(b.id);
	            };
	        }
	    };
	    c3_chart_internal_fn.getTooltipContent = function (d, defaultTitleFormat, defaultValueFormat, color) {
	        var $$ = this,
	            config = $$.config,
	            titleFormat = config.tooltip_format_title || defaultTitleFormat,
	            nameFormat = config.tooltip_format_name || function (name) {
	            return name;
	        },
	            valueFormat = config.tooltip_format_value || defaultValueFormat,
	            text,
	            i,
	            title,
	            value,
	            name,
	            bgcolor;
	
	        var tooltipSortFunction = this.getTooltipSortFunction();
	        if (tooltipSortFunction) {
	            d.sort(tooltipSortFunction);
	        }
	
	        for (i = 0; i < d.length; i++) {
	            if (!(d[i] && (d[i].value || d[i].value === 0))) {
	                continue;
	            }
	
	            if (!text) {
	                title = sanitise(titleFormat ? titleFormat(d[i].x) : d[i].x);
	                text = "<table class='" + $$.CLASS.tooltip + "'>" + (title || title === 0 ? "<tr><th colspan='2'>" + title + "</th></tr>" : "");
	            }
	
	            value = sanitise(valueFormat(d[i].value, d[i].ratio, d[i].id, d[i].index, d));
	            if (value !== undefined) {
	                // Skip elements when their name is set to null
	                if (d[i].name === null) {
	                    continue;
	                }
	                name = sanitise(nameFormat(d[i].name, d[i].ratio, d[i].id, d[i].index));
	                bgcolor = $$.levelColor ? $$.levelColor(d[i].value) : color(d[i].id);
	
	                text += "<tr class='" + $$.CLASS.tooltipName + "-" + $$.getTargetSelectorSuffix(d[i].id) + "'>";
	                text += "<td class='name'><span style='background-color:" + bgcolor + "'></span>" + name + "</td>";
	                text += "<td class='value'>" + value + "</td>";
	                text += "</tr>";
	            }
	        }
	        return text + "</table>";
	    };
	    c3_chart_internal_fn.tooltipPosition = function (dataToShow, tWidth, tHeight, element) {
	        var $$ = this,
	            config = $$.config,
	            d3 = $$.d3;
	        var svgLeft, tooltipLeft, tooltipRight, tooltipTop, chartRight;
	        var forArc = $$.hasArcType(),
	            mouse = d3.mouse(element);
	        // Determin tooltip position
	        if (forArc) {
	            tooltipLeft = ($$.width - ($$.isLegendRight ? $$.getLegendWidth() : 0)) / 2 + mouse[0];
	            tooltipTop = ($$.hasType('gauge') ? $$.height : $$.height / 2) + mouse[1] + 20;
	        } else {
	            svgLeft = $$.getSvgLeft(true);
	            if (config.axis_rotated) {
	                tooltipLeft = svgLeft + mouse[0] + 100;
	                tooltipRight = tooltipLeft + tWidth;
	                chartRight = $$.currentWidth - $$.getCurrentPaddingRight();
	                tooltipTop = $$.x(dataToShow[0].x) + 20;
	            } else {
	                tooltipLeft = svgLeft + $$.getCurrentPaddingLeft(true) + $$.x(dataToShow[0].x) + 20;
	                tooltipRight = tooltipLeft + tWidth;
	                chartRight = svgLeft + $$.currentWidth - $$.getCurrentPaddingRight();
	                tooltipTop = mouse[1] + 15;
	            }
	
	            if (tooltipRight > chartRight) {
	                // 20 is needed for Firefox to keep tooltip width
	                tooltipLeft -= tooltipRight - chartRight + 20;
	            }
	            if (tooltipTop + tHeight > $$.currentHeight) {
	                tooltipTop -= tHeight + 30;
	            }
	        }
	        if (tooltipTop < 0) {
	            tooltipTop = 0;
	        }
	        return { top: tooltipTop, left: tooltipLeft };
	    };
	    c3_chart_internal_fn.showTooltip = function (selectedData, element) {
	        var $$ = this,
	            config = $$.config;
	        var tWidth, tHeight, position;
	        var forArc = $$.hasArcType(),
	            dataToShow = selectedData.filter(function (d) {
	            return d && isValue(d.value);
	        }),
	            positionFunction = config.tooltip_position || c3_chart_internal_fn.tooltipPosition;
	        if (dataToShow.length === 0 || !config.tooltip_show) {
	            return;
	        }
	        $$.tooltip.html(config.tooltip_contents.call($$, selectedData, $$.axis.getXAxisTickFormat(), $$.getYFormat(forArc), $$.color)).style("display", "block");
	
	        // Get tooltip dimensions
	        tWidth = $$.tooltip.property('offsetWidth');
	        tHeight = $$.tooltip.property('offsetHeight');
	
	        position = positionFunction.call(this, dataToShow, tWidth, tHeight, element);
	        // Set tooltip
	        $$.tooltip.style("top", position.top + "px").style("left", position.left + 'px');
	    };
	    c3_chart_internal_fn.hideTooltip = function () {
	        this.tooltip.style("display", "none");
	    };
	
	    c3_chart_internal_fn.setTargetType = function (targetIds, type) {
	        var $$ = this,
	            config = $$.config;
	        $$.mapToTargetIds(targetIds).forEach(function (id) {
	            $$.withoutFadeIn[id] = type === config.data_types[id];
	            config.data_types[id] = type;
	        });
	        if (!targetIds) {
	            config.data_type = type;
	        }
	    };
	    c3_chart_internal_fn.hasType = function (type, targets) {
	        var $$ = this,
	            types = $$.config.data_types,
	            has = false;
	        targets = targets || $$.data.targets;
	        if (targets && targets.length) {
	            targets.forEach(function (target) {
	                var t = types[target.id];
	                if (t && t.indexOf(type) >= 0 || !t && type === 'line') {
	                    has = true;
	                }
	            });
	        } else if (Object.keys(types).length) {
	            Object.keys(types).forEach(function (id) {
	                if (types[id] === type) {
	                    has = true;
	                }
	            });
	        } else {
	            has = $$.config.data_type === type;
	        }
	        return has;
	    };
	    c3_chart_internal_fn.hasArcType = function (targets) {
	        return this.hasType('pie', targets) || this.hasType('donut', targets) || this.hasType('gauge', targets);
	    };
	    c3_chart_internal_fn.isLineType = function (d) {
	        var config = this.config,
	            id = isString(d) ? d : d.id;
	        return !config.data_types[id] || ['line', 'spline', 'area', 'area-spline', 'step', 'area-step'].indexOf(config.data_types[id]) >= 0;
	    };
	    c3_chart_internal_fn.isStepType = function (d) {
	        var id = isString(d) ? d : d.id;
	        return ['step', 'area-step'].indexOf(this.config.data_types[id]) >= 0;
	    };
	    c3_chart_internal_fn.isSplineType = function (d) {
	        var id = isString(d) ? d : d.id;
	        return ['spline', 'area-spline'].indexOf(this.config.data_types[id]) >= 0;
	    };
	    c3_chart_internal_fn.isAreaType = function (d) {
	        var id = isString(d) ? d : d.id;
	        return ['area', 'area-spline', 'area-step'].indexOf(this.config.data_types[id]) >= 0;
	    };
	    c3_chart_internal_fn.isBarType = function (d) {
	        var id = isString(d) ? d : d.id;
	        return this.config.data_types[id] === 'bar';
	    };
	    c3_chart_internal_fn.isScatterType = function (d) {
	        var id = isString(d) ? d : d.id;
	        return this.config.data_types[id] === 'scatter';
	    };
	    c3_chart_internal_fn.isPieType = function (d) {
	        var id = isString(d) ? d : d.id;
	        return this.config.data_types[id] === 'pie';
	    };
	    c3_chart_internal_fn.isGaugeType = function (d) {
	        var id = isString(d) ? d : d.id;
	        return this.config.data_types[id] === 'gauge';
	    };
	    c3_chart_internal_fn.isDonutType = function (d) {
	        var id = isString(d) ? d : d.id;
	        return this.config.data_types[id] === 'donut';
	    };
	    c3_chart_internal_fn.isArcType = function (d) {
	        return this.isPieType(d) || this.isDonutType(d) || this.isGaugeType(d);
	    };
	    c3_chart_internal_fn.lineData = function (d) {
	        return this.isLineType(d) ? [d] : [];
	    };
	    c3_chart_internal_fn.arcData = function (d) {
	        return this.isArcType(d.data) ? [d] : [];
	    };
	    /* not used
	     function scatterData(d) {
	     return isScatterType(d) ? d.values : [];
	     }
	     */
	    c3_chart_internal_fn.barData = function (d) {
	        return this.isBarType(d) ? d.values : [];
	    };
	    c3_chart_internal_fn.lineOrScatterData = function (d) {
	        return this.isLineType(d) || this.isScatterType(d) ? d.values : [];
	    };
	    c3_chart_internal_fn.barOrLineData = function (d) {
	        return this.isBarType(d) || this.isLineType(d) ? d.values : [];
	    };
	    c3_chart_internal_fn.isInterpolationType = function (type) {
	        return ['linear', 'linear-closed', 'basis', 'basis-open', 'basis-closed', 'bundle', 'cardinal', 'cardinal-open', 'cardinal-closed', 'monotone'].indexOf(type) >= 0;
	    };
	
	    c3_chart_internal_fn.isSafari = function () {
	        var ua = window.navigator.userAgent;
	        return ua.indexOf('Safari') >= 0 && ua.indexOf('Chrome') < 0;
	    };
	    c3_chart_internal_fn.isChrome = function () {
	        var ua = window.navigator.userAgent;
	        return ua.indexOf('Chrome') >= 0;
	    };
	
	    c3_chart_internal_fn.initZoom = function () {
	        var $$ = this,
	            d3 = $$.d3,
	            config = $$.config,
	            startEvent;
	
	        $$.zoom = d3.behavior.zoom().on("zoomstart", function () {
	            startEvent = d3.event.sourceEvent;
	            $$.zoom.altDomain = d3.event.sourceEvent.altKey ? $$.x.orgDomain() : null;
	            config.zoom_onzoomstart.call($$.api, d3.event.sourceEvent);
	        }).on("zoom", function () {
	            $$.redrawForZoom.call($$);
	        }).on('zoomend', function () {
	            var event = d3.event.sourceEvent;
	            // if click, do nothing. otherwise, click interaction will be canceled.
	            if (event && startEvent.clientX === event.clientX && startEvent.clientY === event.clientY) {
	                return;
	            }
	            $$.redrawEventRect();
	            $$.updateZoom();
	            config.zoom_onzoomend.call($$.api, $$.x.orgDomain());
	        });
	        $$.zoom.scale = function (scale) {
	            return config.axis_rotated ? this.y(scale) : this.x(scale);
	        };
	        $$.zoom.orgScaleExtent = function () {
	            var extent = config.zoom_extent ? config.zoom_extent : [1, 10];
	            return [extent[0], Math.max($$.getMaxDataCount() / extent[1], extent[1])];
	        };
	        $$.zoom.updateScaleExtent = function () {
	            var ratio = diffDomain($$.x.orgDomain()) / diffDomain($$.getZoomDomain()),
	                extent = this.orgScaleExtent();
	            this.scaleExtent([extent[0] * ratio, extent[1] * ratio]);
	            return this;
	        };
	    };
	    c3_chart_internal_fn.getZoomDomain = function () {
	        var $$ = this,
	            config = $$.config,
	            d3 = $$.d3,
	            min = d3.min([$$.orgXDomain[0], config.zoom_x_min]),
	            max = d3.max([$$.orgXDomain[1], config.zoom_x_max]);
	        return [min, max];
	    };
	    c3_chart_internal_fn.updateZoom = function () {
	        var $$ = this,
	            z = $$.config.zoom_enabled ? $$.zoom : function () {};
	        $$.main.select('.' + CLASS.zoomRect).call(z).on("dblclick.zoom", null);
	        $$.main.selectAll('.' + CLASS.eventRect).call(z).on("dblclick.zoom", null);
	    };
	    c3_chart_internal_fn.redrawForZoom = function () {
	        var $$ = this,
	            d3 = $$.d3,
	            config = $$.config,
	            zoom = $$.zoom,
	            x = $$.x;
	        if (!config.zoom_enabled) {
	            return;
	        }
	        if ($$.filterTargetsToShow($$.data.targets).length === 0) {
	            return;
	        }
	        if (d3.event.sourceEvent.type === 'mousemove' && zoom.altDomain) {
	            x.domain(zoom.altDomain);
	            zoom.scale(x).updateScaleExtent();
	            return;
	        }
	        if ($$.isCategorized() && x.orgDomain()[0] === $$.orgXDomain[0]) {
	            x.domain([$$.orgXDomain[0] - 1e-10, x.orgDomain()[1]]);
	        }
	        $$.redraw({
	            withTransition: false,
	            withY: config.zoom_rescale,
	            withSubchart: false,
	            withEventRect: false,
	            withDimension: false
	        });
	        if (d3.event.sourceEvent.type === 'mousemove') {
	            $$.cancelClick = true;
	        }
	        config.zoom_onzoom.call($$.api, x.orgDomain());
	    };
	
	    return c3;
	
	})));


/***/ }),
/* 1850 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;!function() {
	  var d3 = {
	    version: "3.5.17"
	  };
	  var d3_arraySlice = [].slice, d3_array = function(list) {
	    return d3_arraySlice.call(list);
	  };
	  var d3_document = this.document;
	  function d3_documentElement(node) {
	    return node && (node.ownerDocument || node.document || node).documentElement;
	  }
	  function d3_window(node) {
	    return node && (node.ownerDocument && node.ownerDocument.defaultView || node.document && node || node.defaultView);
	  }
	  if (d3_document) {
	    try {
	      d3_array(d3_document.documentElement.childNodes)[0].nodeType;
	    } catch (e) {
	      d3_array = function(list) {
	        var i = list.length, array = new Array(i);
	        while (i--) array[i] = list[i];
	        return array;
	      };
	    }
	  }
	  if (!Date.now) Date.now = function() {
	    return +new Date();
	  };
	  if (d3_document) {
	    try {
	      d3_document.createElement("DIV").style.setProperty("opacity", 0, "");
	    } catch (error) {
	      var d3_element_prototype = this.Element.prototype, d3_element_setAttribute = d3_element_prototype.setAttribute, d3_element_setAttributeNS = d3_element_prototype.setAttributeNS, d3_style_prototype = this.CSSStyleDeclaration.prototype, d3_style_setProperty = d3_style_prototype.setProperty;
	      d3_element_prototype.setAttribute = function(name, value) {
	        d3_element_setAttribute.call(this, name, value + "");
	      };
	      d3_element_prototype.setAttributeNS = function(space, local, value) {
	        d3_element_setAttributeNS.call(this, space, local, value + "");
	      };
	      d3_style_prototype.setProperty = function(name, value, priority) {
	        d3_style_setProperty.call(this, name, value + "", priority);
	      };
	    }
	  }
	  d3.ascending = d3_ascending;
	  function d3_ascending(a, b) {
	    return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
	  }
	  d3.descending = function(a, b) {
	    return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
	  };
	  d3.min = function(array, f) {
	    var i = -1, n = array.length, a, b;
	    if (arguments.length === 1) {
	      while (++i < n) if ((b = array[i]) != null && b >= b) {
	        a = b;
	        break;
	      }
	      while (++i < n) if ((b = array[i]) != null && a > b) a = b;
	    } else {
	      while (++i < n) if ((b = f.call(array, array[i], i)) != null && b >= b) {
	        a = b;
	        break;
	      }
	      while (++i < n) if ((b = f.call(array, array[i], i)) != null && a > b) a = b;
	    }
	    return a;
	  };
	  d3.max = function(array, f) {
	    var i = -1, n = array.length, a, b;
	    if (arguments.length === 1) {
	      while (++i < n) if ((b = array[i]) != null && b >= b) {
	        a = b;
	        break;
	      }
	      while (++i < n) if ((b = array[i]) != null && b > a) a = b;
	    } else {
	      while (++i < n) if ((b = f.call(array, array[i], i)) != null && b >= b) {
	        a = b;
	        break;
	      }
	      while (++i < n) if ((b = f.call(array, array[i], i)) != null && b > a) a = b;
	    }
	    return a;
	  };
	  d3.extent = function(array, f) {
	    var i = -1, n = array.length, a, b, c;
	    if (arguments.length === 1) {
	      while (++i < n) if ((b = array[i]) != null && b >= b) {
	        a = c = b;
	        break;
	      }
	      while (++i < n) if ((b = array[i]) != null) {
	        if (a > b) a = b;
	        if (c < b) c = b;
	      }
	    } else {
	      while (++i < n) if ((b = f.call(array, array[i], i)) != null && b >= b) {
	        a = c = b;
	        break;
	      }
	      while (++i < n) if ((b = f.call(array, array[i], i)) != null) {
	        if (a > b) a = b;
	        if (c < b) c = b;
	      }
	    }
	    return [ a, c ];
	  };
	  function d3_number(x) {
	    return x === null ? NaN : +x;
	  }
	  function d3_numeric(x) {
	    return !isNaN(x);
	  }
	  d3.sum = function(array, f) {
	    var s = 0, n = array.length, a, i = -1;
	    if (arguments.length === 1) {
	      while (++i < n) if (d3_numeric(a = +array[i])) s += a;
	    } else {
	      while (++i < n) if (d3_numeric(a = +f.call(array, array[i], i))) s += a;
	    }
	    return s;
	  };
	  d3.mean = function(array, f) {
	    var s = 0, n = array.length, a, i = -1, j = n;
	    if (arguments.length === 1) {
	      while (++i < n) if (d3_numeric(a = d3_number(array[i]))) s += a; else --j;
	    } else {
	      while (++i < n) if (d3_numeric(a = d3_number(f.call(array, array[i], i)))) s += a; else --j;
	    }
	    if (j) return s / j;
	  };
	  d3.quantile = function(values, p) {
	    var H = (values.length - 1) * p + 1, h = Math.floor(H), v = +values[h - 1], e = H - h;
	    return e ? v + e * (values[h] - v) : v;
	  };
	  d3.median = function(array, f) {
	    var numbers = [], n = array.length, a, i = -1;
	    if (arguments.length === 1) {
	      while (++i < n) if (d3_numeric(a = d3_number(array[i]))) numbers.push(a);
	    } else {
	      while (++i < n) if (d3_numeric(a = d3_number(f.call(array, array[i], i)))) numbers.push(a);
	    }
	    if (numbers.length) return d3.quantile(numbers.sort(d3_ascending), .5);
	  };
	  d3.variance = function(array, f) {
	    var n = array.length, m = 0, a, d, s = 0, i = -1, j = 0;
	    if (arguments.length === 1) {
	      while (++i < n) {
	        if (d3_numeric(a = d3_number(array[i]))) {
	          d = a - m;
	          m += d / ++j;
	          s += d * (a - m);
	        }
	      }
	    } else {
	      while (++i < n) {
	        if (d3_numeric(a = d3_number(f.call(array, array[i], i)))) {
	          d = a - m;
	          m += d / ++j;
	          s += d * (a - m);
	        }
	      }
	    }
	    if (j > 1) return s / (j - 1);
	  };
	  d3.deviation = function() {
	    var v = d3.variance.apply(this, arguments);
	    return v ? Math.sqrt(v) : v;
	  };
	  function d3_bisector(compare) {
	    return {
	      left: function(a, x, lo, hi) {
	        if (arguments.length < 3) lo = 0;
	        if (arguments.length < 4) hi = a.length;
	        while (lo < hi) {
	          var mid = lo + hi >>> 1;
	          if (compare(a[mid], x) < 0) lo = mid + 1; else hi = mid;
	        }
	        return lo;
	      },
	      right: function(a, x, lo, hi) {
	        if (arguments.length < 3) lo = 0;
	        if (arguments.length < 4) hi = a.length;
	        while (lo < hi) {
	          var mid = lo + hi >>> 1;
	          if (compare(a[mid], x) > 0) hi = mid; else lo = mid + 1;
	        }
	        return lo;
	      }
	    };
	  }
	  var d3_bisect = d3_bisector(d3_ascending);
	  d3.bisectLeft = d3_bisect.left;
	  d3.bisect = d3.bisectRight = d3_bisect.right;
	  d3.bisector = function(f) {
	    return d3_bisector(f.length === 1 ? function(d, x) {
	      return d3_ascending(f(d), x);
	    } : f);
	  };
	  d3.shuffle = function(array, i0, i1) {
	    if ((m = arguments.length) < 3) {
	      i1 = array.length;
	      if (m < 2) i0 = 0;
	    }
	    var m = i1 - i0, t, i;
	    while (m) {
	      i = Math.random() * m-- | 0;
	      t = array[m + i0], array[m + i0] = array[i + i0], array[i + i0] = t;
	    }
	    return array;
	  };
	  d3.permute = function(array, indexes) {
	    var i = indexes.length, permutes = new Array(i);
	    while (i--) permutes[i] = array[indexes[i]];
	    return permutes;
	  };
	  d3.pairs = function(array) {
	    var i = 0, n = array.length - 1, p0, p1 = array[0], pairs = new Array(n < 0 ? 0 : n);
	    while (i < n) pairs[i] = [ p0 = p1, p1 = array[++i] ];
	    return pairs;
	  };
	  d3.transpose = function(matrix) {
	    if (!(n = matrix.length)) return [];
	    for (var i = -1, m = d3.min(matrix, d3_transposeLength), transpose = new Array(m); ++i < m; ) {
	      for (var j = -1, n, row = transpose[i] = new Array(n); ++j < n; ) {
	        row[j] = matrix[j][i];
	      }
	    }
	    return transpose;
	  };
	  function d3_transposeLength(d) {
	    return d.length;
	  }
	  d3.zip = function() {
	    return d3.transpose(arguments);
	  };
	  d3.keys = function(map) {
	    var keys = [];
	    for (var key in map) keys.push(key);
	    return keys;
	  };
	  d3.values = function(map) {
	    var values = [];
	    for (var key in map) values.push(map[key]);
	    return values;
	  };
	  d3.entries = function(map) {
	    var entries = [];
	    for (var key in map) entries.push({
	      key: key,
	      value: map[key]
	    });
	    return entries;
	  };
	  d3.merge = function(arrays) {
	    var n = arrays.length, m, i = -1, j = 0, merged, array;
	    while (++i < n) j += arrays[i].length;
	    merged = new Array(j);
	    while (--n >= 0) {
	      array = arrays[n];
	      m = array.length;
	      while (--m >= 0) {
	        merged[--j] = array[m];
	      }
	    }
	    return merged;
	  };
	  var abs = Math.abs;
	  d3.range = function(start, stop, step) {
	    if (arguments.length < 3) {
	      step = 1;
	      if (arguments.length < 2) {
	        stop = start;
	        start = 0;
	      }
	    }
	    if ((stop - start) / step === Infinity) throw new Error("infinite range");
	    var range = [], k = d3_range_integerScale(abs(step)), i = -1, j;
	    start *= k, stop *= k, step *= k;
	    if (step < 0) while ((j = start + step * ++i) > stop) range.push(j / k); else while ((j = start + step * ++i) < stop) range.push(j / k);
	    return range;
	  };
	  function d3_range_integerScale(x) {
	    var k = 1;
	    while (x * k % 1) k *= 10;
	    return k;
	  }
	  function d3_class(ctor, properties) {
	    for (var key in properties) {
	      Object.defineProperty(ctor.prototype, key, {
	        value: properties[key],
	        enumerable: false
	      });
	    }
	  }
	  d3.map = function(object, f) {
	    var map = new d3_Map();
	    if (object instanceof d3_Map) {
	      object.forEach(function(key, value) {
	        map.set(key, value);
	      });
	    } else if (Array.isArray(object)) {
	      var i = -1, n = object.length, o;
	      if (arguments.length === 1) while (++i < n) map.set(i, object[i]); else while (++i < n) map.set(f.call(object, o = object[i], i), o);
	    } else {
	      for (var key in object) map.set(key, object[key]);
	    }
	    return map;
	  };
	  function d3_Map() {
	    this._ = Object.create(null);
	  }
	  var d3_map_proto = "__proto__", d3_map_zero = "\x00";
	  d3_class(d3_Map, {
	    has: d3_map_has,
	    get: function(key) {
	      return this._[d3_map_escape(key)];
	    },
	    set: function(key, value) {
	      return this._[d3_map_escape(key)] = value;
	    },
	    remove: d3_map_remove,
	    keys: d3_map_keys,
	    values: function() {
	      var values = [];
	      for (var key in this._) values.push(this._[key]);
	      return values;
	    },
	    entries: function() {
	      var entries = [];
	      for (var key in this._) entries.push({
	        key: d3_map_unescape(key),
	        value: this._[key]
	      });
	      return entries;
	    },
	    size: d3_map_size,
	    empty: d3_map_empty,
	    forEach: function(f) {
	      for (var key in this._) f.call(this, d3_map_unescape(key), this._[key]);
	    }
	  });
	  function d3_map_escape(key) {
	    return (key += "") === d3_map_proto || key[0] === d3_map_zero ? d3_map_zero + key : key;
	  }
	  function d3_map_unescape(key) {
	    return (key += "")[0] === d3_map_zero ? key.slice(1) : key;
	  }
	  function d3_map_has(key) {
	    return d3_map_escape(key) in this._;
	  }
	  function d3_map_remove(key) {
	    return (key = d3_map_escape(key)) in this._ && delete this._[key];
	  }
	  function d3_map_keys() {
	    var keys = [];
	    for (var key in this._) keys.push(d3_map_unescape(key));
	    return keys;
	  }
	  function d3_map_size() {
	    var size = 0;
	    for (var key in this._) ++size;
	    return size;
	  }
	  function d3_map_empty() {
	    for (var key in this._) return false;
	    return true;
	  }
	  d3.nest = function() {
	    var nest = {}, keys = [], sortKeys = [], sortValues, rollup;
	    function map(mapType, array, depth) {
	      if (depth >= keys.length) return rollup ? rollup.call(nest, array) : sortValues ? array.sort(sortValues) : array;
	      var i = -1, n = array.length, key = keys[depth++], keyValue, object, setter, valuesByKey = new d3_Map(), values;
	      while (++i < n) {
	        if (values = valuesByKey.get(keyValue = key(object = array[i]))) {
	          values.push(object);
	        } else {
	          valuesByKey.set(keyValue, [ object ]);
	        }
	      }
	      if (mapType) {
	        object = mapType();
	        setter = function(keyValue, values) {
	          object.set(keyValue, map(mapType, values, depth));
	        };
	      } else {
	        object = {};
	        setter = function(keyValue, values) {
	          object[keyValue] = map(mapType, values, depth);
	        };
	      }
	      valuesByKey.forEach(setter);
	      return object;
	    }
	    function entries(map, depth) {
	      if (depth >= keys.length) return map;
	      var array = [], sortKey = sortKeys[depth++];
	      map.forEach(function(key, keyMap) {
	        array.push({
	          key: key,
	          values: entries(keyMap, depth)
	        });
	      });
	      return sortKey ? array.sort(function(a, b) {
	        return sortKey(a.key, b.key);
	      }) : array;
	    }
	    nest.map = function(array, mapType) {
	      return map(mapType, array, 0);
	    };
	    nest.entries = function(array) {
	      return entries(map(d3.map, array, 0), 0);
	    };
	    nest.key = function(d) {
	      keys.push(d);
	      return nest;
	    };
	    nest.sortKeys = function(order) {
	      sortKeys[keys.length - 1] = order;
	      return nest;
	    };
	    nest.sortValues = function(order) {
	      sortValues = order;
	      return nest;
	    };
	    nest.rollup = function(f) {
	      rollup = f;
	      return nest;
	    };
	    return nest;
	  };
	  d3.set = function(array) {
	    var set = new d3_Set();
	    if (array) for (var i = 0, n = array.length; i < n; ++i) set.add(array[i]);
	    return set;
	  };
	  function d3_Set() {
	    this._ = Object.create(null);
	  }
	  d3_class(d3_Set, {
	    has: d3_map_has,
	    add: function(key) {
	      this._[d3_map_escape(key += "")] = true;
	      return key;
	    },
	    remove: d3_map_remove,
	    values: d3_map_keys,
	    size: d3_map_size,
	    empty: d3_map_empty,
	    forEach: function(f) {
	      for (var key in this._) f.call(this, d3_map_unescape(key));
	    }
	  });
	  d3.behavior = {};
	  function d3_identity(d) {
	    return d;
	  }
	  d3.rebind = function(target, source) {
	    var i = 1, n = arguments.length, method;
	    while (++i < n) target[method = arguments[i]] = d3_rebind(target, source, source[method]);
	    return target;
	  };
	  function d3_rebind(target, source, method) {
	    return function() {
	      var value = method.apply(source, arguments);
	      return value === source ? target : value;
	    };
	  }
	  function d3_vendorSymbol(object, name) {
	    if (name in object) return name;
	    name = name.charAt(0).toUpperCase() + name.slice(1);
	    for (var i = 0, n = d3_vendorPrefixes.length; i < n; ++i) {
	      var prefixName = d3_vendorPrefixes[i] + name;
	      if (prefixName in object) return prefixName;
	    }
	  }
	  var d3_vendorPrefixes = [ "webkit", "ms", "moz", "Moz", "o", "O" ];
	  function d3_noop() {}
	  d3.dispatch = function() {
	    var dispatch = new d3_dispatch(), i = -1, n = arguments.length;
	    while (++i < n) dispatch[arguments[i]] = d3_dispatch_event(dispatch);
	    return dispatch;
	  };
	  function d3_dispatch() {}
	  d3_dispatch.prototype.on = function(type, listener) {
	    var i = type.indexOf("."), name = "";
	    if (i >= 0) {
	      name = type.slice(i + 1);
	      type = type.slice(0, i);
	    }
	    if (type) return arguments.length < 2 ? this[type].on(name) : this[type].on(name, listener);
	    if (arguments.length === 2) {
	      if (listener == null) for (type in this) {
	        if (this.hasOwnProperty(type)) this[type].on(name, null);
	      }
	      return this;
	    }
	  };
	  function d3_dispatch_event(dispatch) {
	    var listeners = [], listenerByName = new d3_Map();
	    function event() {
	      var z = listeners, i = -1, n = z.length, l;
	      while (++i < n) if (l = z[i].on) l.apply(this, arguments);
	      return dispatch;
	    }
	    event.on = function(name, listener) {
	      var l = listenerByName.get(name), i;
	      if (arguments.length < 2) return l && l.on;
	      if (l) {
	        l.on = null;
	        listeners = listeners.slice(0, i = listeners.indexOf(l)).concat(listeners.slice(i + 1));
	        listenerByName.remove(name);
	      }
	      if (listener) listeners.push(listenerByName.set(name, {
	        on: listener
	      }));
	      return dispatch;
	    };
	    return event;
	  }
	  d3.event = null;
	  function d3_eventPreventDefault() {
	    d3.event.preventDefault();
	  }
	  function d3_eventSource() {
	    var e = d3.event, s;
	    while (s = e.sourceEvent) e = s;
	    return e;
	  }
	  function d3_eventDispatch(target) {
	    var dispatch = new d3_dispatch(), i = 0, n = arguments.length;
	    while (++i < n) dispatch[arguments[i]] = d3_dispatch_event(dispatch);
	    dispatch.of = function(thiz, argumentz) {
	      return function(e1) {
	        try {
	          var e0 = e1.sourceEvent = d3.event;
	          e1.target = target;
	          d3.event = e1;
	          dispatch[e1.type].apply(thiz, argumentz);
	        } finally {
	          d3.event = e0;
	        }
	      };
	    };
	    return dispatch;
	  }
	  d3.requote = function(s) {
	    return s.replace(d3_requote_re, "\\$&");
	  };
	  var d3_requote_re = /[\\\^\$\*\+\?\|\[\]\(\)\.\{\}]/g;
	  var d3_subclass = {}.__proto__ ? function(object, prototype) {
	    object.__proto__ = prototype;
	  } : function(object, prototype) {
	    for (var property in prototype) object[property] = prototype[property];
	  };
	  function d3_selection(groups) {
	    d3_subclass(groups, d3_selectionPrototype);
	    return groups;
	  }
	  var d3_select = function(s, n) {
	    return n.querySelector(s);
	  }, d3_selectAll = function(s, n) {
	    return n.querySelectorAll(s);
	  }, d3_selectMatches = function(n, s) {
	    var d3_selectMatcher = n.matches || n[d3_vendorSymbol(n, "matchesSelector")];
	    d3_selectMatches = function(n, s) {
	      return d3_selectMatcher.call(n, s);
	    };
	    return d3_selectMatches(n, s);
	  };
	  if (typeof Sizzle === "function") {
	    d3_select = function(s, n) {
	      return Sizzle(s, n)[0] || null;
	    };
	    d3_selectAll = Sizzle;
	    d3_selectMatches = Sizzle.matchesSelector;
	  }
	  d3.selection = function() {
	    return d3.select(d3_document.documentElement);
	  };
	  var d3_selectionPrototype = d3.selection.prototype = [];
	  d3_selectionPrototype.select = function(selector) {
	    var subgroups = [], subgroup, subnode, group, node;
	    selector = d3_selection_selector(selector);
	    for (var j = -1, m = this.length; ++j < m; ) {
	      subgroups.push(subgroup = []);
	      subgroup.parentNode = (group = this[j]).parentNode;
	      for (var i = -1, n = group.length; ++i < n; ) {
	        if (node = group[i]) {
	          subgroup.push(subnode = selector.call(node, node.__data__, i, j));
	          if (subnode && "__data__" in node) subnode.__data__ = node.__data__;
	        } else {
	          subgroup.push(null);
	        }
	      }
	    }
	    return d3_selection(subgroups);
	  };
	  function d3_selection_selector(selector) {
	    return typeof selector === "function" ? selector : function() {
	      return d3_select(selector, this);
	    };
	  }
	  d3_selectionPrototype.selectAll = function(selector) {
	    var subgroups = [], subgroup, node;
	    selector = d3_selection_selectorAll(selector);
	    for (var j = -1, m = this.length; ++j < m; ) {
	      for (var group = this[j], i = -1, n = group.length; ++i < n; ) {
	        if (node = group[i]) {
	          subgroups.push(subgroup = d3_array(selector.call(node, node.__data__, i, j)));
	          subgroup.parentNode = node;
	        }
	      }
	    }
	    return d3_selection(subgroups);
	  };
	  function d3_selection_selectorAll(selector) {
	    return typeof selector === "function" ? selector : function() {
	      return d3_selectAll(selector, this);
	    };
	  }
	  var d3_nsXhtml = "http://www.w3.org/1999/xhtml";
	  var d3_nsPrefix = {
	    svg: "http://www.w3.org/2000/svg",
	    xhtml: d3_nsXhtml,
	    xlink: "http://www.w3.org/1999/xlink",
	    xml: "http://www.w3.org/XML/1998/namespace",
	    xmlns: "http://www.w3.org/2000/xmlns/"
	  };
	  d3.ns = {
	    prefix: d3_nsPrefix,
	    qualify: function(name) {
	      var i = name.indexOf(":"), prefix = name;
	      if (i >= 0 && (prefix = name.slice(0, i)) !== "xmlns") name = name.slice(i + 1);
	      return d3_nsPrefix.hasOwnProperty(prefix) ? {
	        space: d3_nsPrefix[prefix],
	        local: name
	      } : name;
	    }
	  };
	  d3_selectionPrototype.attr = function(name, value) {
	    if (arguments.length < 2) {
	      if (typeof name === "string") {
	        var node = this.node();
	        name = d3.ns.qualify(name);
	        return name.local ? node.getAttributeNS(name.space, name.local) : node.getAttribute(name);
	      }
	      for (value in name) this.each(d3_selection_attr(value, name[value]));
	      return this;
	    }
	    return this.each(d3_selection_attr(name, value));
	  };
	  function d3_selection_attr(name, value) {
	    name = d3.ns.qualify(name);
	    function attrNull() {
	      this.removeAttribute(name);
	    }
	    function attrNullNS() {
	      this.removeAttributeNS(name.space, name.local);
	    }
	    function attrConstant() {
	      this.setAttribute(name, value);
	    }
	    function attrConstantNS() {
	      this.setAttributeNS(name.space, name.local, value);
	    }
	    function attrFunction() {
	      var x = value.apply(this, arguments);
	      if (x == null) this.removeAttribute(name); else this.setAttribute(name, x);
	    }
	    function attrFunctionNS() {
	      var x = value.apply(this, arguments);
	      if (x == null) this.removeAttributeNS(name.space, name.local); else this.setAttributeNS(name.space, name.local, x);
	    }
	    return value == null ? name.local ? attrNullNS : attrNull : typeof value === "function" ? name.local ? attrFunctionNS : attrFunction : name.local ? attrConstantNS : attrConstant;
	  }
	  function d3_collapse(s) {
	    return s.trim().replace(/\s+/g, " ");
	  }
	  d3_selectionPrototype.classed = function(name, value) {
	    if (arguments.length < 2) {
	      if (typeof name === "string") {
	        var node = this.node(), n = (name = d3_selection_classes(name)).length, i = -1;
	        if (value = node.classList) {
	          while (++i < n) if (!value.contains(name[i])) return false;
	        } else {
	          value = node.getAttribute("class");
	          while (++i < n) if (!d3_selection_classedRe(name[i]).test(value)) return false;
	        }
	        return true;
	      }
	      for (value in name) this.each(d3_selection_classed(value, name[value]));
	      return this;
	    }
	    return this.each(d3_selection_classed(name, value));
	  };
	  function d3_selection_classedRe(name) {
	    return new RegExp("(?:^|\\s+)" + d3.requote(name) + "(?:\\s+|$)", "g");
	  }
	  function d3_selection_classes(name) {
	    return (name + "").trim().split(/^|\s+/);
	  }
	  function d3_selection_classed(name, value) {
	    name = d3_selection_classes(name).map(d3_selection_classedName);
	    var n = name.length;
	    function classedConstant() {
	      var i = -1;
	      while (++i < n) name[i](this, value);
	    }
	    function classedFunction() {
	      var i = -1, x = value.apply(this, arguments);
	      while (++i < n) name[i](this, x);
	    }
	    return typeof value === "function" ? classedFunction : classedConstant;
	  }
	  function d3_selection_classedName(name) {
	    var re = d3_selection_classedRe(name);
	    return function(node, value) {
	      if (c = node.classList) return value ? c.add(name) : c.remove(name);
	      var c = node.getAttribute("class") || "";
	      if (value) {
	        re.lastIndex = 0;
	        if (!re.test(c)) node.setAttribute("class", d3_collapse(c + " " + name));
	      } else {
	        node.setAttribute("class", d3_collapse(c.replace(re, " ")));
	      }
	    };
	  }
	  d3_selectionPrototype.style = function(name, value, priority) {
	    var n = arguments.length;
	    if (n < 3) {
	      if (typeof name !== "string") {
	        if (n < 2) value = "";
	        for (priority in name) this.each(d3_selection_style(priority, name[priority], value));
	        return this;
	      }
	      if (n < 2) {
	        var node = this.node();
	        return d3_window(node).getComputedStyle(node, null).getPropertyValue(name);
	      }
	      priority = "";
	    }
	    return this.each(d3_selection_style(name, value, priority));
	  };
	  function d3_selection_style(name, value, priority) {
	    function styleNull() {
	      this.style.removeProperty(name);
	    }
	    function styleConstant() {
	      this.style.setProperty(name, value, priority);
	    }
	    function styleFunction() {
	      var x = value.apply(this, arguments);
	      if (x == null) this.style.removeProperty(name); else this.style.setProperty(name, x, priority);
	    }
	    return value == null ? styleNull : typeof value === "function" ? styleFunction : styleConstant;
	  }
	  d3_selectionPrototype.property = function(name, value) {
	    if (arguments.length < 2) {
	      if (typeof name === "string") return this.node()[name];
	      for (value in name) this.each(d3_selection_property(value, name[value]));
	      return this;
	    }
	    return this.each(d3_selection_property(name, value));
	  };
	  function d3_selection_property(name, value) {
	    function propertyNull() {
	      delete this[name];
	    }
	    function propertyConstant() {
	      this[name] = value;
	    }
	    function propertyFunction() {
	      var x = value.apply(this, arguments);
	      if (x == null) delete this[name]; else this[name] = x;
	    }
	    return value == null ? propertyNull : typeof value === "function" ? propertyFunction : propertyConstant;
	  }
	  d3_selectionPrototype.text = function(value) {
	    return arguments.length ? this.each(typeof value === "function" ? function() {
	      var v = value.apply(this, arguments);
	      this.textContent = v == null ? "" : v;
	    } : value == null ? function() {
	      this.textContent = "";
	    } : function() {
	      this.textContent = value;
	    }) : this.node().textContent;
	  };
	  d3_selectionPrototype.html = function(value) {
	    return arguments.length ? this.each(typeof value === "function" ? function() {
	      var v = value.apply(this, arguments);
	      this.innerHTML = v == null ? "" : v;
	    } : value == null ? function() {
	      this.innerHTML = "";
	    } : function() {
	      this.innerHTML = value;
	    }) : this.node().innerHTML;
	  };
	  d3_selectionPrototype.append = function(name) {
	    name = d3_selection_creator(name);
	    return this.select(function() {
	      return this.appendChild(name.apply(this, arguments));
	    });
	  };
	  function d3_selection_creator(name) {
	    function create() {
	      var document = this.ownerDocument, namespace = this.namespaceURI;
	      return namespace === d3_nsXhtml && document.documentElement.namespaceURI === d3_nsXhtml ? document.createElement(name) : document.createElementNS(namespace, name);
	    }
	    function createNS() {
	      return this.ownerDocument.createElementNS(name.space, name.local);
	    }
	    return typeof name === "function" ? name : (name = d3.ns.qualify(name)).local ? createNS : create;
	  }
	  d3_selectionPrototype.insert = function(name, before) {
	    name = d3_selection_creator(name);
	    before = d3_selection_selector(before);
	    return this.select(function() {
	      return this.insertBefore(name.apply(this, arguments), before.apply(this, arguments) || null);
	    });
	  };
	  d3_selectionPrototype.remove = function() {
	    return this.each(d3_selectionRemove);
	  };
	  function d3_selectionRemove() {
	    var parent = this.parentNode;
	    if (parent) parent.removeChild(this);
	  }
	  d3_selectionPrototype.data = function(value, key) {
	    var i = -1, n = this.length, group, node;
	    if (!arguments.length) {
	      value = new Array(n = (group = this[0]).length);
	      while (++i < n) {
	        if (node = group[i]) {
	          value[i] = node.__data__;
	        }
	      }
	      return value;
	    }
	    function bind(group, groupData) {
	      var i, n = group.length, m = groupData.length, n0 = Math.min(n, m), updateNodes = new Array(m), enterNodes = new Array(m), exitNodes = new Array(n), node, nodeData;
	      if (key) {
	        var nodeByKeyValue = new d3_Map(), keyValues = new Array(n), keyValue;
	        for (i = -1; ++i < n; ) {
	          if (node = group[i]) {
	            if (nodeByKeyValue.has(keyValue = key.call(node, node.__data__, i))) {
	              exitNodes[i] = node;
	            } else {
	              nodeByKeyValue.set(keyValue, node);
	            }
	            keyValues[i] = keyValue;
	          }
	        }
	        for (i = -1; ++i < m; ) {
	          if (!(node = nodeByKeyValue.get(keyValue = key.call(groupData, nodeData = groupData[i], i)))) {
	            enterNodes[i] = d3_selection_dataNode(nodeData);
	          } else if (node !== true) {
	            updateNodes[i] = node;
	            node.__data__ = nodeData;
	          }
	          nodeByKeyValue.set(keyValue, true);
	        }
	        for (i = -1; ++i < n; ) {
	          if (i in keyValues && nodeByKeyValue.get(keyValues[i]) !== true) {
	            exitNodes[i] = group[i];
	          }
	        }
	      } else {
	        for (i = -1; ++i < n0; ) {
	          node = group[i];
	          nodeData = groupData[i];
	          if (node) {
	            node.__data__ = nodeData;
	            updateNodes[i] = node;
	          } else {
	            enterNodes[i] = d3_selection_dataNode(nodeData);
	          }
	        }
	        for (;i < m; ++i) {
	          enterNodes[i] = d3_selection_dataNode(groupData[i]);
	        }
	        for (;i < n; ++i) {
	          exitNodes[i] = group[i];
	        }
	      }
	      enterNodes.update = updateNodes;
	      enterNodes.parentNode = updateNodes.parentNode = exitNodes.parentNode = group.parentNode;
	      enter.push(enterNodes);
	      update.push(updateNodes);
	      exit.push(exitNodes);
	    }
	    var enter = d3_selection_enter([]), update = d3_selection([]), exit = d3_selection([]);
	    if (typeof value === "function") {
	      while (++i < n) {
	        bind(group = this[i], value.call(group, group.parentNode.__data__, i));
	      }
	    } else {
	      while (++i < n) {
	        bind(group = this[i], value);
	      }
	    }
	    update.enter = function() {
	      return enter;
	    };
	    update.exit = function() {
	      return exit;
	    };
	    return update;
	  };
	  function d3_selection_dataNode(data) {
	    return {
	      __data__: data
	    };
	  }
	  d3_selectionPrototype.datum = function(value) {
	    return arguments.length ? this.property("__data__", value) : this.property("__data__");
	  };
	  d3_selectionPrototype.filter = function(filter) {
	    var subgroups = [], subgroup, group, node;
	    if (typeof filter !== "function") filter = d3_selection_filter(filter);
	    for (var j = 0, m = this.length; j < m; j++) {
	      subgroups.push(subgroup = []);
	      subgroup.parentNode = (group = this[j]).parentNode;
	      for (var i = 0, n = group.length; i < n; i++) {
	        if ((node = group[i]) && filter.call(node, node.__data__, i, j)) {
	          subgroup.push(node);
	        }
	      }
	    }
	    return d3_selection(subgroups);
	  };
	  function d3_selection_filter(selector) {
	    return function() {
	      return d3_selectMatches(this, selector);
	    };
	  }
	  d3_selectionPrototype.order = function() {
	    for (var j = -1, m = this.length; ++j < m; ) {
	      for (var group = this[j], i = group.length - 1, next = group[i], node; --i >= 0; ) {
	        if (node = group[i]) {
	          if (next && next !== node.nextSibling) next.parentNode.insertBefore(node, next);
	          next = node;
	        }
	      }
	    }
	    return this;
	  };
	  d3_selectionPrototype.sort = function(comparator) {
	    comparator = d3_selection_sortComparator.apply(this, arguments);
	    for (var j = -1, m = this.length; ++j < m; ) this[j].sort(comparator);
	    return this.order();
	  };
	  function d3_selection_sortComparator(comparator) {
	    if (!arguments.length) comparator = d3_ascending;
	    return function(a, b) {
	      return a && b ? comparator(a.__data__, b.__data__) : !a - !b;
	    };
	  }
	  d3_selectionPrototype.each = function(callback) {
	    return d3_selection_each(this, function(node, i, j) {
	      callback.call(node, node.__data__, i, j);
	    });
	  };
	  function d3_selection_each(groups, callback) {
	    for (var j = 0, m = groups.length; j < m; j++) {
	      for (var group = groups[j], i = 0, n = group.length, node; i < n; i++) {
	        if (node = group[i]) callback(node, i, j);
	      }
	    }
	    return groups;
	  }
	  d3_selectionPrototype.call = function(callback) {
	    var args = d3_array(arguments);
	    callback.apply(args[0] = this, args);
	    return this;
	  };
	  d3_selectionPrototype.empty = function() {
	    return !this.node();
	  };
	  d3_selectionPrototype.node = function() {
	    for (var j = 0, m = this.length; j < m; j++) {
	      for (var group = this[j], i = 0, n = group.length; i < n; i++) {
	        var node = group[i];
	        if (node) return node;
	      }
	    }
	    return null;
	  };
	  d3_selectionPrototype.size = function() {
	    var n = 0;
	    d3_selection_each(this, function() {
	      ++n;
	    });
	    return n;
	  };
	  function d3_selection_enter(selection) {
	    d3_subclass(selection, d3_selection_enterPrototype);
	    return selection;
	  }
	  var d3_selection_enterPrototype = [];
	  d3.selection.enter = d3_selection_enter;
	  d3.selection.enter.prototype = d3_selection_enterPrototype;
	  d3_selection_enterPrototype.append = d3_selectionPrototype.append;
	  d3_selection_enterPrototype.empty = d3_selectionPrototype.empty;
	  d3_selection_enterPrototype.node = d3_selectionPrototype.node;
	  d3_selection_enterPrototype.call = d3_selectionPrototype.call;
	  d3_selection_enterPrototype.size = d3_selectionPrototype.size;
	  d3_selection_enterPrototype.select = function(selector) {
	    var subgroups = [], subgroup, subnode, upgroup, group, node;
	    for (var j = -1, m = this.length; ++j < m; ) {
	      upgroup = (group = this[j]).update;
	      subgroups.push(subgroup = []);
	      subgroup.parentNode = group.parentNode;
	      for (var i = -1, n = group.length; ++i < n; ) {
	        if (node = group[i]) {
	          subgroup.push(upgroup[i] = subnode = selector.call(group.parentNode, node.__data__, i, j));
	          subnode.__data__ = node.__data__;
	        } else {
	          subgroup.push(null);
	        }
	      }
	    }
	    return d3_selection(subgroups);
	  };
	  d3_selection_enterPrototype.insert = function(name, before) {
	    if (arguments.length < 2) before = d3_selection_enterInsertBefore(this);
	    return d3_selectionPrototype.insert.call(this, name, before);
	  };
	  function d3_selection_enterInsertBefore(enter) {
	    var i0, j0;
	    return function(d, i, j) {
	      var group = enter[j].update, n = group.length, node;
	      if (j != j0) j0 = j, i0 = 0;
	      if (i >= i0) i0 = i + 1;
	      while (!(node = group[i0]) && ++i0 < n) ;
	      return node;
	    };
	  }
	  d3.select = function(node) {
	    var group;
	    if (typeof node === "string") {
	      group = [ d3_select(node, d3_document) ];
	      group.parentNode = d3_document.documentElement;
	    } else {
	      group = [ node ];
	      group.parentNode = d3_documentElement(node);
	    }
	    return d3_selection([ group ]);
	  };
	  d3.selectAll = function(nodes) {
	    var group;
	    if (typeof nodes === "string") {
	      group = d3_array(d3_selectAll(nodes, d3_document));
	      group.parentNode = d3_document.documentElement;
	    } else {
	      group = d3_array(nodes);
	      group.parentNode = null;
	    }
	    return d3_selection([ group ]);
	  };
	  d3_selectionPrototype.on = function(type, listener, capture) {
	    var n = arguments.length;
	    if (n < 3) {
	      if (typeof type !== "string") {
	        if (n < 2) listener = false;
	        for (capture in type) this.each(d3_selection_on(capture, type[capture], listener));
	        return this;
	      }
	      if (n < 2) return (n = this.node()["__on" + type]) && n._;
	      capture = false;
	    }
	    return this.each(d3_selection_on(type, listener, capture));
	  };
	  function d3_selection_on(type, listener, capture) {
	    var name = "__on" + type, i = type.indexOf("."), wrap = d3_selection_onListener;
	    if (i > 0) type = type.slice(0, i);
	    var filter = d3_selection_onFilters.get(type);
	    if (filter) type = filter, wrap = d3_selection_onFilter;
	    function onRemove() {
	      var l = this[name];
	      if (l) {
	        this.removeEventListener(type, l, l.$);
	        delete this[name];
	      }
	    }
	    function onAdd() {
	      var l = wrap(listener, d3_array(arguments));
	      onRemove.call(this);
	      this.addEventListener(type, this[name] = l, l.$ = capture);
	      l._ = listener;
	    }
	    function removeAll() {
	      var re = new RegExp("^__on([^.]+)" + d3.requote(type) + "$"), match;
	      for (var name in this) {
	        if (match = name.match(re)) {
	          var l = this[name];
	          this.removeEventListener(match[1], l, l.$);
	          delete this[name];
	        }
	      }
	    }
	    return i ? listener ? onAdd : onRemove : listener ? d3_noop : removeAll;
	  }
	  var d3_selection_onFilters = d3.map({
	    mouseenter: "mouseover",
	    mouseleave: "mouseout"
	  });
	  if (d3_document) {
	    d3_selection_onFilters.forEach(function(k) {
	      if ("on" + k in d3_document) d3_selection_onFilters.remove(k);
	    });
	  }
	  function d3_selection_onListener(listener, argumentz) {
	    return function(e) {
	      var o = d3.event;
	      d3.event = e;
	      argumentz[0] = this.__data__;
	      try {
	        listener.apply(this, argumentz);
	      } finally {
	        d3.event = o;
	      }
	    };
	  }
	  function d3_selection_onFilter(listener, argumentz) {
	    var l = d3_selection_onListener(listener, argumentz);
	    return function(e) {
	      var target = this, related = e.relatedTarget;
	      if (!related || related !== target && !(related.compareDocumentPosition(target) & 8)) {
	        l.call(target, e);
	      }
	    };
	  }
	  var d3_event_dragSelect, d3_event_dragId = 0;
	  function d3_event_dragSuppress(node) {
	    var name = ".dragsuppress-" + ++d3_event_dragId, click = "click" + name, w = d3.select(d3_window(node)).on("touchmove" + name, d3_eventPreventDefault).on("dragstart" + name, d3_eventPreventDefault).on("selectstart" + name, d3_eventPreventDefault);
	    if (d3_event_dragSelect == null) {
	      d3_event_dragSelect = "onselectstart" in node ? false : d3_vendorSymbol(node.style, "userSelect");
	    }
	    if (d3_event_dragSelect) {
	      var style = d3_documentElement(node).style, select = style[d3_event_dragSelect];
	      style[d3_event_dragSelect] = "none";
	    }
	    return function(suppressClick) {
	      w.on(name, null);
	      if (d3_event_dragSelect) style[d3_event_dragSelect] = select;
	      if (suppressClick) {
	        var off = function() {
	          w.on(click, null);
	        };
	        w.on(click, function() {
	          d3_eventPreventDefault();
	          off();
	        }, true);
	        setTimeout(off, 0);
	      }
	    };
	  }
	  d3.mouse = function(container) {
	    return d3_mousePoint(container, d3_eventSource());
	  };
	  var d3_mouse_bug44083 = this.navigator && /WebKit/.test(this.navigator.userAgent) ? -1 : 0;
	  function d3_mousePoint(container, e) {
	    if (e.changedTouches) e = e.changedTouches[0];
	    var svg = container.ownerSVGElement || container;
	    if (svg.createSVGPoint) {
	      var point = svg.createSVGPoint();
	      if (d3_mouse_bug44083 < 0) {
	        var window = d3_window(container);
	        if (window.scrollX || window.scrollY) {
	          svg = d3.select("body").append("svg").style({
	            position: "absolute",
	            top: 0,
	            left: 0,
	            margin: 0,
	            padding: 0,
	            border: "none"
	          }, "important");
	          var ctm = svg[0][0].getScreenCTM();
	          d3_mouse_bug44083 = !(ctm.f || ctm.e);
	          svg.remove();
	        }
	      }
	      if (d3_mouse_bug44083) point.x = e.pageX, point.y = e.pageY; else point.x = e.clientX, 
	      point.y = e.clientY;
	      point = point.matrixTransform(container.getScreenCTM().inverse());
	      return [ point.x, point.y ];
	    }
	    var rect = container.getBoundingClientRect();
	    return [ e.clientX - rect.left - container.clientLeft, e.clientY - rect.top - container.clientTop ];
	  }
	  d3.touch = function(container, touches, identifier) {
	    if (arguments.length < 3) identifier = touches, touches = d3_eventSource().changedTouches;
	    if (touches) for (var i = 0, n = touches.length, touch; i < n; ++i) {
	      if ((touch = touches[i]).identifier === identifier) {
	        return d3_mousePoint(container, touch);
	      }
	    }
	  };
	  d3.behavior.drag = function() {
	    var event = d3_eventDispatch(drag, "drag", "dragstart", "dragend"), origin = null, mousedown = dragstart(d3_noop, d3.mouse, d3_window, "mousemove", "mouseup"), touchstart = dragstart(d3_behavior_dragTouchId, d3.touch, d3_identity, "touchmove", "touchend");
	    function drag() {
	      this.on("mousedown.drag", mousedown).on("touchstart.drag", touchstart);
	    }
	    function dragstart(id, position, subject, move, end) {
	      return function() {
	        var that = this, target = d3.event.target.correspondingElement || d3.event.target, parent = that.parentNode, dispatch = event.of(that, arguments), dragged = 0, dragId = id(), dragName = ".drag" + (dragId == null ? "" : "-" + dragId), dragOffset, dragSubject = d3.select(subject(target)).on(move + dragName, moved).on(end + dragName, ended), dragRestore = d3_event_dragSuppress(target), position0 = position(parent, dragId);
	        if (origin) {
	          dragOffset = origin.apply(that, arguments);
	          dragOffset = [ dragOffset.x - position0[0], dragOffset.y - position0[1] ];
	        } else {
	          dragOffset = [ 0, 0 ];
	        }
	        dispatch({
	          type: "dragstart"
	        });
	        function moved() {
	          var position1 = position(parent, dragId), dx, dy;
	          if (!position1) return;
	          dx = position1[0] - position0[0];
	          dy = position1[1] - position0[1];
	          dragged |= dx | dy;
	          position0 = position1;
	          dispatch({
	            type: "drag",
	            x: position1[0] + dragOffset[0],
	            y: position1[1] + dragOffset[1],
	            dx: dx,
	            dy: dy
	          });
	        }
	        function ended() {
	          if (!position(parent, dragId)) return;
	          dragSubject.on(move + dragName, null).on(end + dragName, null);
	          dragRestore(dragged);
	          dispatch({
	            type: "dragend"
	          });
	        }
	      };
	    }
	    drag.origin = function(x) {
	      if (!arguments.length) return origin;
	      origin = x;
	      return drag;
	    };
	    return d3.rebind(drag, event, "on");
	  };
	  function d3_behavior_dragTouchId() {
	    return d3.event.changedTouches[0].identifier;
	  }
	  d3.touches = function(container, touches) {
	    if (arguments.length < 2) touches = d3_eventSource().touches;
	    return touches ? d3_array(touches).map(function(touch) {
	      var point = d3_mousePoint(container, touch);
	      point.identifier = touch.identifier;
	      return point;
	    }) : [];
	  };
	  var ε = 1e-6, ε2 = ε * ε, π = Math.PI, τ = 2 * π, τε = τ - ε, halfπ = π / 2, d3_radians = π / 180, d3_degrees = 180 / π;
	  function d3_sgn(x) {
	    return x > 0 ? 1 : x < 0 ? -1 : 0;
	  }
	  function d3_cross2d(a, b, c) {
	    return (b[0] - a[0]) * (c[1] - a[1]) - (b[1] - a[1]) * (c[0] - a[0]);
	  }
	  function d3_acos(x) {
	    return x > 1 ? 0 : x < -1 ? π : Math.acos(x);
	  }
	  function d3_asin(x) {
	    return x > 1 ? halfπ : x < -1 ? -halfπ : Math.asin(x);
	  }
	  function d3_sinh(x) {
	    return ((x = Math.exp(x)) - 1 / x) / 2;
	  }
	  function d3_cosh(x) {
	    return ((x = Math.exp(x)) + 1 / x) / 2;
	  }
	  function d3_tanh(x) {
	    return ((x = Math.exp(2 * x)) - 1) / (x + 1);
	  }
	  function d3_haversin(x) {
	    return (x = Math.sin(x / 2)) * x;
	  }
	  var ρ = Math.SQRT2, ρ2 = 2, ρ4 = 4;
	  d3.interpolateZoom = function(p0, p1) {
	    var ux0 = p0[0], uy0 = p0[1], w0 = p0[2], ux1 = p1[0], uy1 = p1[1], w1 = p1[2], dx = ux1 - ux0, dy = uy1 - uy0, d2 = dx * dx + dy * dy, i, S;
	    if (d2 < ε2) {
	      S = Math.log(w1 / w0) / ρ;
	      i = function(t) {
	        return [ ux0 + t * dx, uy0 + t * dy, w0 * Math.exp(ρ * t * S) ];
	      };
	    } else {
	      var d1 = Math.sqrt(d2), b0 = (w1 * w1 - w0 * w0 + ρ4 * d2) / (2 * w0 * ρ2 * d1), b1 = (w1 * w1 - w0 * w0 - ρ4 * d2) / (2 * w1 * ρ2 * d1), r0 = Math.log(Math.sqrt(b0 * b0 + 1) - b0), r1 = Math.log(Math.sqrt(b1 * b1 + 1) - b1);
	      S = (r1 - r0) / ρ;
	      i = function(t) {
	        var s = t * S, coshr0 = d3_cosh(r0), u = w0 / (ρ2 * d1) * (coshr0 * d3_tanh(ρ * s + r0) - d3_sinh(r0));
	        return [ ux0 + u * dx, uy0 + u * dy, w0 * coshr0 / d3_cosh(ρ * s + r0) ];
	      };
	    }
	    i.duration = S * 1e3;
	    return i;
	  };
	  d3.behavior.zoom = function() {
	    var view = {
	      x: 0,
	      y: 0,
	      k: 1
	    }, translate0, center0, center, size = [ 960, 500 ], scaleExtent = d3_behavior_zoomInfinity, duration = 250, zooming = 0, mousedown = "mousedown.zoom", mousemove = "mousemove.zoom", mouseup = "mouseup.zoom", mousewheelTimer, touchstart = "touchstart.zoom", touchtime, event = d3_eventDispatch(zoom, "zoomstart", "zoom", "zoomend"), x0, x1, y0, y1;
	    if (!d3_behavior_zoomWheel) {
	      d3_behavior_zoomWheel = "onwheel" in d3_document ? (d3_behavior_zoomDelta = function() {
	        return -d3.event.deltaY * (d3.event.deltaMode ? 120 : 1);
	      }, "wheel") : "onmousewheel" in d3_document ? (d3_behavior_zoomDelta = function() {
	        return d3.event.wheelDelta;
	      }, "mousewheel") : (d3_behavior_zoomDelta = function() {
	        return -d3.event.detail;
	      }, "MozMousePixelScroll");
	    }
	    function zoom(g) {
	      g.on(mousedown, mousedowned).on(d3_behavior_zoomWheel + ".zoom", mousewheeled).on("dblclick.zoom", dblclicked).on(touchstart, touchstarted);
	    }
	    zoom.event = function(g) {
	      g.each(function() {
	        var dispatch = event.of(this, arguments), view1 = view;
	        if (d3_transitionInheritId) {
	          d3.select(this).transition().each("start.zoom", function() {
	            view = this.__chart__ || {
	              x: 0,
	              y: 0,
	              k: 1
	            };
	            zoomstarted(dispatch);
	          }).tween("zoom:zoom", function() {
	            var dx = size[0], dy = size[1], cx = center0 ? center0[0] : dx / 2, cy = center0 ? center0[1] : dy / 2, i = d3.interpolateZoom([ (cx - view.x) / view.k, (cy - view.y) / view.k, dx / view.k ], [ (cx - view1.x) / view1.k, (cy - view1.y) / view1.k, dx / view1.k ]);
	            return function(t) {
	              var l = i(t), k = dx / l[2];
	              this.__chart__ = view = {
	                x: cx - l[0] * k,
	                y: cy - l[1] * k,
	                k: k
	              };
	              zoomed(dispatch);
	            };
	          }).each("interrupt.zoom", function() {
	            zoomended(dispatch);
	          }).each("end.zoom", function() {
	            zoomended(dispatch);
	          });
	        } else {
	          this.__chart__ = view;
	          zoomstarted(dispatch);
	          zoomed(dispatch);
	          zoomended(dispatch);
	        }
	      });
	    };
	    zoom.translate = function(_) {
	      if (!arguments.length) return [ view.x, view.y ];
	      view = {
	        x: +_[0],
	        y: +_[1],
	        k: view.k
	      };
	      rescale();
	      return zoom;
	    };
	    zoom.scale = function(_) {
	      if (!arguments.length) return view.k;
	      view = {
	        x: view.x,
	        y: view.y,
	        k: null
	      };
	      scaleTo(+_);
	      rescale();
	      return zoom;
	    };
	    zoom.scaleExtent = function(_) {
	      if (!arguments.length) return scaleExtent;
	      scaleExtent = _ == null ? d3_behavior_zoomInfinity : [ +_[0], +_[1] ];
	      return zoom;
	    };
	    zoom.center = function(_) {
	      if (!arguments.length) return center;
	      center = _ && [ +_[0], +_[1] ];
	      return zoom;
	    };
	    zoom.size = function(_) {
	      if (!arguments.length) return size;
	      size = _ && [ +_[0], +_[1] ];
	      return zoom;
	    };
	    zoom.duration = function(_) {
	      if (!arguments.length) return duration;
	      duration = +_;
	      return zoom;
	    };
	    zoom.x = function(z) {
	      if (!arguments.length) return x1;
	      x1 = z;
	      x0 = z.copy();
	      view = {
	        x: 0,
	        y: 0,
	        k: 1
	      };
	      return zoom;
	    };
	    zoom.y = function(z) {
	      if (!arguments.length) return y1;
	      y1 = z;
	      y0 = z.copy();
	      view = {
	        x: 0,
	        y: 0,
	        k: 1
	      };
	      return zoom;
	    };
	    function location(p) {
	      return [ (p[0] - view.x) / view.k, (p[1] - view.y) / view.k ];
	    }
	    function point(l) {
	      return [ l[0] * view.k + view.x, l[1] * view.k + view.y ];
	    }
	    function scaleTo(s) {
	      view.k = Math.max(scaleExtent[0], Math.min(scaleExtent[1], s));
	    }
	    function translateTo(p, l) {
	      l = point(l);
	      view.x += p[0] - l[0];
	      view.y += p[1] - l[1];
	    }
	    function zoomTo(that, p, l, k) {
	      that.__chart__ = {
	        x: view.x,
	        y: view.y,
	        k: view.k
	      };
	      scaleTo(Math.pow(2, k));
	      translateTo(center0 = p, l);
	      that = d3.select(that);
	      if (duration > 0) that = that.transition().duration(duration);
	      that.call(zoom.event);
	    }
	    function rescale() {
	      if (x1) x1.domain(x0.range().map(function(x) {
	        return (x - view.x) / view.k;
	      }).map(x0.invert));
	      if (y1) y1.domain(y0.range().map(function(y) {
	        return (y - view.y) / view.k;
	      }).map(y0.invert));
	    }
	    function zoomstarted(dispatch) {
	      if (!zooming++) dispatch({
	        type: "zoomstart"
	      });
	    }
	    function zoomed(dispatch) {
	      rescale();
	      dispatch({
	        type: "zoom",
	        scale: view.k,
	        translate: [ view.x, view.y ]
	      });
	    }
	    function zoomended(dispatch) {
	      if (!--zooming) dispatch({
	        type: "zoomend"
	      }), center0 = null;
	    }
	    function mousedowned() {
	      var that = this, dispatch = event.of(that, arguments), dragged = 0, subject = d3.select(d3_window(that)).on(mousemove, moved).on(mouseup, ended), location0 = location(d3.mouse(that)), dragRestore = d3_event_dragSuppress(that);
	      d3_selection_interrupt.call(that);
	      zoomstarted(dispatch);
	      function moved() {
	        dragged = 1;
	        translateTo(d3.mouse(that), location0);
	        zoomed(dispatch);
	      }
	      function ended() {
	        subject.on(mousemove, null).on(mouseup, null);
	        dragRestore(dragged);
	        zoomended(dispatch);
	      }
	    }
	    function touchstarted() {
	      var that = this, dispatch = event.of(that, arguments), locations0 = {}, distance0 = 0, scale0, zoomName = ".zoom-" + d3.event.changedTouches[0].identifier, touchmove = "touchmove" + zoomName, touchend = "touchend" + zoomName, targets = [], subject = d3.select(that), dragRestore = d3_event_dragSuppress(that);
	      started();
	      zoomstarted(dispatch);
	      subject.on(mousedown, null).on(touchstart, started);
	      function relocate() {
	        var touches = d3.touches(that);
	        scale0 = view.k;
	        touches.forEach(function(t) {
	          if (t.identifier in locations0) locations0[t.identifier] = location(t);
	        });
	        return touches;
	      }
	      function started() {
	        var target = d3.event.target;
	        d3.select(target).on(touchmove, moved).on(touchend, ended);
	        targets.push(target);
	        var changed = d3.event.changedTouches;
	        for (var i = 0, n = changed.length; i < n; ++i) {
	          locations0[changed[i].identifier] = null;
	        }
	        var touches = relocate(), now = Date.now();
	        if (touches.length === 1) {
	          if (now - touchtime < 500) {
	            var p = touches[0];
	            zoomTo(that, p, locations0[p.identifier], Math.floor(Math.log(view.k) / Math.LN2) + 1);
	            d3_eventPreventDefault();
	          }
	          touchtime = now;
	        } else if (touches.length > 1) {
	          var p = touches[0], q = touches[1], dx = p[0] - q[0], dy = p[1] - q[1];
	          distance0 = dx * dx + dy * dy;
	        }
	      }
	      function moved() {
	        var touches = d3.touches(that), p0, l0, p1, l1;
	        d3_selection_interrupt.call(that);
	        for (var i = 0, n = touches.length; i < n; ++i, l1 = null) {
	          p1 = touches[i];
	          if (l1 = locations0[p1.identifier]) {
	            if (l0) break;
	            p0 = p1, l0 = l1;
	          }
	        }
	        if (l1) {
	          var distance1 = (distance1 = p1[0] - p0[0]) * distance1 + (distance1 = p1[1] - p0[1]) * distance1, scale1 = distance0 && Math.sqrt(distance1 / distance0);
	          p0 = [ (p0[0] + p1[0]) / 2, (p0[1] + p1[1]) / 2 ];
	          l0 = [ (l0[0] + l1[0]) / 2, (l0[1] + l1[1]) / 2 ];
	          scaleTo(scale1 * scale0);
	        }
	        touchtime = null;
	        translateTo(p0, l0);
	        zoomed(dispatch);
	      }
	      function ended() {
	        if (d3.event.touches.length) {
	          var changed = d3.event.changedTouches;
	          for (var i = 0, n = changed.length; i < n; ++i) {
	            delete locations0[changed[i].identifier];
	          }
	          for (var identifier in locations0) {
	            return void relocate();
	          }
	        }
	        d3.selectAll(targets).on(zoomName, null);
	        subject.on(mousedown, mousedowned).on(touchstart, touchstarted);
	        dragRestore();
	        zoomended(dispatch);
	      }
	    }
	    function mousewheeled() {
	      var dispatch = event.of(this, arguments);
	      if (mousewheelTimer) clearTimeout(mousewheelTimer); else d3_selection_interrupt.call(this), 
	      translate0 = location(center0 = center || d3.mouse(this)), zoomstarted(dispatch);
	      mousewheelTimer = setTimeout(function() {
	        mousewheelTimer = null;
	        zoomended(dispatch);
	      }, 50);
	      d3_eventPreventDefault();
	      scaleTo(Math.pow(2, d3_behavior_zoomDelta() * .002) * view.k);
	      translateTo(center0, translate0);
	      zoomed(dispatch);
	    }
	    function dblclicked() {
	      var p = d3.mouse(this), k = Math.log(view.k) / Math.LN2;
	      zoomTo(this, p, location(p), d3.event.shiftKey ? Math.ceil(k) - 1 : Math.floor(k) + 1);
	    }
	    return d3.rebind(zoom, event, "on");
	  };
	  var d3_behavior_zoomInfinity = [ 0, Infinity ], d3_behavior_zoomDelta, d3_behavior_zoomWheel;
	  d3.color = d3_color;
	  function d3_color() {}
	  d3_color.prototype.toString = function() {
	    return this.rgb() + "";
	  };
	  d3.hsl = d3_hsl;
	  function d3_hsl(h, s, l) {
	    return this instanceof d3_hsl ? void (this.h = +h, this.s = +s, this.l = +l) : arguments.length < 2 ? h instanceof d3_hsl ? new d3_hsl(h.h, h.s, h.l) : d3_rgb_parse("" + h, d3_rgb_hsl, d3_hsl) : new d3_hsl(h, s, l);
	  }
	  var d3_hslPrototype = d3_hsl.prototype = new d3_color();
	  d3_hslPrototype.brighter = function(k) {
	    k = Math.pow(.7, arguments.length ? k : 1);
	    return new d3_hsl(this.h, this.s, this.l / k);
	  };
	  d3_hslPrototype.darker = function(k) {
	    k = Math.pow(.7, arguments.length ? k : 1);
	    return new d3_hsl(this.h, this.s, k * this.l);
	  };
	  d3_hslPrototype.rgb = function() {
	    return d3_hsl_rgb(this.h, this.s, this.l);
	  };
	  function d3_hsl_rgb(h, s, l) {
	    var m1, m2;
	    h = isNaN(h) ? 0 : (h %= 360) < 0 ? h + 360 : h;
	    s = isNaN(s) ? 0 : s < 0 ? 0 : s > 1 ? 1 : s;
	    l = l < 0 ? 0 : l > 1 ? 1 : l;
	    m2 = l <= .5 ? l * (1 + s) : l + s - l * s;
	    m1 = 2 * l - m2;
	    function v(h) {
	      if (h > 360) h -= 360; else if (h < 0) h += 360;
	      if (h < 60) return m1 + (m2 - m1) * h / 60;
	      if (h < 180) return m2;
	      if (h < 240) return m1 + (m2 - m1) * (240 - h) / 60;
	      return m1;
	    }
	    function vv(h) {
	      return Math.round(v(h) * 255);
	    }
	    return new d3_rgb(vv(h + 120), vv(h), vv(h - 120));
	  }
	  d3.hcl = d3_hcl;
	  function d3_hcl(h, c, l) {
	    return this instanceof d3_hcl ? void (this.h = +h, this.c = +c, this.l = +l) : arguments.length < 2 ? h instanceof d3_hcl ? new d3_hcl(h.h, h.c, h.l) : h instanceof d3_lab ? d3_lab_hcl(h.l, h.a, h.b) : d3_lab_hcl((h = d3_rgb_lab((h = d3.rgb(h)).r, h.g, h.b)).l, h.a, h.b) : new d3_hcl(h, c, l);
	  }
	  var d3_hclPrototype = d3_hcl.prototype = new d3_color();
	  d3_hclPrototype.brighter = function(k) {
	    return new d3_hcl(this.h, this.c, Math.min(100, this.l + d3_lab_K * (arguments.length ? k : 1)));
	  };
	  d3_hclPrototype.darker = function(k) {
	    return new d3_hcl(this.h, this.c, Math.max(0, this.l - d3_lab_K * (arguments.length ? k : 1)));
	  };
	  d3_hclPrototype.rgb = function() {
	    return d3_hcl_lab(this.h, this.c, this.l).rgb();
	  };
	  function d3_hcl_lab(h, c, l) {
	    if (isNaN(h)) h = 0;
	    if (isNaN(c)) c = 0;
	    return new d3_lab(l, Math.cos(h *= d3_radians) * c, Math.sin(h) * c);
	  }
	  d3.lab = d3_lab;
	  function d3_lab(l, a, b) {
	    return this instanceof d3_lab ? void (this.l = +l, this.a = +a, this.b = +b) : arguments.length < 2 ? l instanceof d3_lab ? new d3_lab(l.l, l.a, l.b) : l instanceof d3_hcl ? d3_hcl_lab(l.h, l.c, l.l) : d3_rgb_lab((l = d3_rgb(l)).r, l.g, l.b) : new d3_lab(l, a, b);
	  }
	  var d3_lab_K = 18;
	  var d3_lab_X = .95047, d3_lab_Y = 1, d3_lab_Z = 1.08883;
	  var d3_labPrototype = d3_lab.prototype = new d3_color();
	  d3_labPrototype.brighter = function(k) {
	    return new d3_lab(Math.min(100, this.l + d3_lab_K * (arguments.length ? k : 1)), this.a, this.b);
	  };
	  d3_labPrototype.darker = function(k) {
	    return new d3_lab(Math.max(0, this.l - d3_lab_K * (arguments.length ? k : 1)), this.a, this.b);
	  };
	  d3_labPrototype.rgb = function() {
	    return d3_lab_rgb(this.l, this.a, this.b);
	  };
	  function d3_lab_rgb(l, a, b) {
	    var y = (l + 16) / 116, x = y + a / 500, z = y - b / 200;
	    x = d3_lab_xyz(x) * d3_lab_X;
	    y = d3_lab_xyz(y) * d3_lab_Y;
	    z = d3_lab_xyz(z) * d3_lab_Z;
	    return new d3_rgb(d3_xyz_rgb(3.2404542 * x - 1.5371385 * y - .4985314 * z), d3_xyz_rgb(-.969266 * x + 1.8760108 * y + .041556 * z), d3_xyz_rgb(.0556434 * x - .2040259 * y + 1.0572252 * z));
	  }
	  function d3_lab_hcl(l, a, b) {
	    return l > 0 ? new d3_hcl(Math.atan2(b, a) * d3_degrees, Math.sqrt(a * a + b * b), l) : new d3_hcl(NaN, NaN, l);
	  }
	  function d3_lab_xyz(x) {
	    return x > .206893034 ? x * x * x : (x - 4 / 29) / 7.787037;
	  }
	  function d3_xyz_lab(x) {
	    return x > .008856 ? Math.pow(x, 1 / 3) : 7.787037 * x + 4 / 29;
	  }
	  function d3_xyz_rgb(r) {
	    return Math.round(255 * (r <= .00304 ? 12.92 * r : 1.055 * Math.pow(r, 1 / 2.4) - .055));
	  }
	  d3.rgb = d3_rgb;
	  function d3_rgb(r, g, b) {
	    return this instanceof d3_rgb ? void (this.r = ~~r, this.g = ~~g, this.b = ~~b) : arguments.length < 2 ? r instanceof d3_rgb ? new d3_rgb(r.r, r.g, r.b) : d3_rgb_parse("" + r, d3_rgb, d3_hsl_rgb) : new d3_rgb(r, g, b);
	  }
	  function d3_rgbNumber(value) {
	    return new d3_rgb(value >> 16, value >> 8 & 255, value & 255);
	  }
	  function d3_rgbString(value) {
	    return d3_rgbNumber(value) + "";
	  }
	  var d3_rgbPrototype = d3_rgb.prototype = new d3_color();
	  d3_rgbPrototype.brighter = function(k) {
	    k = Math.pow(.7, arguments.length ? k : 1);
	    var r = this.r, g = this.g, b = this.b, i = 30;
	    if (!r && !g && !b) return new d3_rgb(i, i, i);
	    if (r && r < i) r = i;
	    if (g && g < i) g = i;
	    if (b && b < i) b = i;
	    return new d3_rgb(Math.min(255, r / k), Math.min(255, g / k), Math.min(255, b / k));
	  };
	  d3_rgbPrototype.darker = function(k) {
	    k = Math.pow(.7, arguments.length ? k : 1);
	    return new d3_rgb(k * this.r, k * this.g, k * this.b);
	  };
	  d3_rgbPrototype.hsl = function() {
	    return d3_rgb_hsl(this.r, this.g, this.b);
	  };
	  d3_rgbPrototype.toString = function() {
	    return "#" + d3_rgb_hex(this.r) + d3_rgb_hex(this.g) + d3_rgb_hex(this.b);
	  };
	  function d3_rgb_hex(v) {
	    return v < 16 ? "0" + Math.max(0, v).toString(16) : Math.min(255, v).toString(16);
	  }
	  function d3_rgb_parse(format, rgb, hsl) {
	    var r = 0, g = 0, b = 0, m1, m2, color;
	    m1 = /([a-z]+)\((.*)\)/.exec(format = format.toLowerCase());
	    if (m1) {
	      m2 = m1[2].split(",");
	      switch (m1[1]) {
	       case "hsl":
	        {
	          return hsl(parseFloat(m2[0]), parseFloat(m2[1]) / 100, parseFloat(m2[2]) / 100);
	        }
	
	       case "rgb":
	        {
	          return rgb(d3_rgb_parseNumber(m2[0]), d3_rgb_parseNumber(m2[1]), d3_rgb_parseNumber(m2[2]));
	        }
	      }
	    }
	    if (color = d3_rgb_names.get(format)) {
	      return rgb(color.r, color.g, color.b);
	    }
	    if (format != null && format.charAt(0) === "#" && !isNaN(color = parseInt(format.slice(1), 16))) {
	      if (format.length === 4) {
	        r = (color & 3840) >> 4;
	        r = r >> 4 | r;
	        g = color & 240;
	        g = g >> 4 | g;
	        b = color & 15;
	        b = b << 4 | b;
	      } else if (format.length === 7) {
	        r = (color & 16711680) >> 16;
	        g = (color & 65280) >> 8;
	        b = color & 255;
	      }
	    }
	    return rgb(r, g, b);
	  }
	  function d3_rgb_hsl(r, g, b) {
	    var min = Math.min(r /= 255, g /= 255, b /= 255), max = Math.max(r, g, b), d = max - min, h, s, l = (max + min) / 2;
	    if (d) {
	      s = l < .5 ? d / (max + min) : d / (2 - max - min);
	      if (r == max) h = (g - b) / d + (g < b ? 6 : 0); else if (g == max) h = (b - r) / d + 2; else h = (r - g) / d + 4;
	      h *= 60;
	    } else {
	      h = NaN;
	      s = l > 0 && l < 1 ? 0 : h;
	    }
	    return new d3_hsl(h, s, l);
	  }
	  function d3_rgb_lab(r, g, b) {
	    r = d3_rgb_xyz(r);
	    g = d3_rgb_xyz(g);
	    b = d3_rgb_xyz(b);
	    var x = d3_xyz_lab((.4124564 * r + .3575761 * g + .1804375 * b) / d3_lab_X), y = d3_xyz_lab((.2126729 * r + .7151522 * g + .072175 * b) / d3_lab_Y), z = d3_xyz_lab((.0193339 * r + .119192 * g + .9503041 * b) / d3_lab_Z);
	    return d3_lab(116 * y - 16, 500 * (x - y), 200 * (y - z));
	  }
	  function d3_rgb_xyz(r) {
	    return (r /= 255) <= .04045 ? r / 12.92 : Math.pow((r + .055) / 1.055, 2.4);
	  }
	  function d3_rgb_parseNumber(c) {
	    var f = parseFloat(c);
	    return c.charAt(c.length - 1) === "%" ? Math.round(f * 2.55) : f;
	  }
	  var d3_rgb_names = d3.map({
	    aliceblue: 15792383,
	    antiquewhite: 16444375,
	    aqua: 65535,
	    aquamarine: 8388564,
	    azure: 15794175,
	    beige: 16119260,
	    bisque: 16770244,
	    black: 0,
	    blanchedalmond: 16772045,
	    blue: 255,
	    blueviolet: 9055202,
	    brown: 10824234,
	    burlywood: 14596231,
	    cadetblue: 6266528,
	    chartreuse: 8388352,
	    chocolate: 13789470,
	    coral: 16744272,
	    cornflowerblue: 6591981,
	    cornsilk: 16775388,
	    crimson: 14423100,
	    cyan: 65535,
	    darkblue: 139,
	    darkcyan: 35723,
	    darkgoldenrod: 12092939,
	    darkgray: 11119017,
	    darkgreen: 25600,
	    darkgrey: 11119017,
	    darkkhaki: 12433259,
	    darkmagenta: 9109643,
	    darkolivegreen: 5597999,
	    darkorange: 16747520,
	    darkorchid: 10040012,
	    darkred: 9109504,
	    darksalmon: 15308410,
	    darkseagreen: 9419919,
	    darkslateblue: 4734347,
	    darkslategray: 3100495,
	    darkslategrey: 3100495,
	    darkturquoise: 52945,
	    darkviolet: 9699539,
	    deeppink: 16716947,
	    deepskyblue: 49151,
	    dimgray: 6908265,
	    dimgrey: 6908265,
	    dodgerblue: 2003199,
	    firebrick: 11674146,
	    floralwhite: 16775920,
	    forestgreen: 2263842,
	    fuchsia: 16711935,
	    gainsboro: 14474460,
	    ghostwhite: 16316671,
	    gold: 16766720,
	    goldenrod: 14329120,
	    gray: 8421504,
	    green: 32768,
	    greenyellow: 11403055,
	    grey: 8421504,
	    honeydew: 15794160,
	    hotpink: 16738740,
	    indianred: 13458524,
	    indigo: 4915330,
	    ivory: 16777200,
	    khaki: 15787660,
	    lavender: 15132410,
	    lavenderblush: 16773365,
	    lawngreen: 8190976,
	    lemonchiffon: 16775885,
	    lightblue: 11393254,
	    lightcoral: 15761536,
	    lightcyan: 14745599,
	    lightgoldenrodyellow: 16448210,
	    lightgray: 13882323,
	    lightgreen: 9498256,
	    lightgrey: 13882323,
	    lightpink: 16758465,
	    lightsalmon: 16752762,
	    lightseagreen: 2142890,
	    lightskyblue: 8900346,
	    lightslategray: 7833753,
	    lightslategrey: 7833753,
	    lightsteelblue: 11584734,
	    lightyellow: 16777184,
	    lime: 65280,
	    limegreen: 3329330,
	    linen: 16445670,
	    magenta: 16711935,
	    maroon: 8388608,
	    mediumaquamarine: 6737322,
	    mediumblue: 205,
	    mediumorchid: 12211667,
	    mediumpurple: 9662683,
	    mediumseagreen: 3978097,
	    mediumslateblue: 8087790,
	    mediumspringgreen: 64154,
	    mediumturquoise: 4772300,
	    mediumvioletred: 13047173,
	    midnightblue: 1644912,
	    mintcream: 16121850,
	    mistyrose: 16770273,
	    moccasin: 16770229,
	    navajowhite: 16768685,
	    navy: 128,
	    oldlace: 16643558,
	    olive: 8421376,
	    olivedrab: 7048739,
	    orange: 16753920,
	    orangered: 16729344,
	    orchid: 14315734,
	    palegoldenrod: 15657130,
	    palegreen: 10025880,
	    paleturquoise: 11529966,
	    palevioletred: 14381203,
	    papayawhip: 16773077,
	    peachpuff: 16767673,
	    peru: 13468991,
	    pink: 16761035,
	    plum: 14524637,
	    powderblue: 11591910,
	    purple: 8388736,
	    rebeccapurple: 6697881,
	    red: 16711680,
	    rosybrown: 12357519,
	    royalblue: 4286945,
	    saddlebrown: 9127187,
	    salmon: 16416882,
	    sandybrown: 16032864,
	    seagreen: 3050327,
	    seashell: 16774638,
	    sienna: 10506797,
	    silver: 12632256,
	    skyblue: 8900331,
	    slateblue: 6970061,
	    slategray: 7372944,
	    slategrey: 7372944,
	    snow: 16775930,
	    springgreen: 65407,
	    steelblue: 4620980,
	    tan: 13808780,
	    teal: 32896,
	    thistle: 14204888,
	    tomato: 16737095,
	    turquoise: 4251856,
	    violet: 15631086,
	    wheat: 16113331,
	    white: 16777215,
	    whitesmoke: 16119285,
	    yellow: 16776960,
	    yellowgreen: 10145074
	  });
	  d3_rgb_names.forEach(function(key, value) {
	    d3_rgb_names.set(key, d3_rgbNumber(value));
	  });
	  function d3_functor(v) {
	    return typeof v === "function" ? v : function() {
	      return v;
	    };
	  }
	  d3.functor = d3_functor;
	  d3.xhr = d3_xhrType(d3_identity);
	  function d3_xhrType(response) {
	    return function(url, mimeType, callback) {
	      if (arguments.length === 2 && typeof mimeType === "function") callback = mimeType, 
	      mimeType = null;
	      return d3_xhr(url, mimeType, response, callback);
	    };
	  }
	  function d3_xhr(url, mimeType, response, callback) {
	    var xhr = {}, dispatch = d3.dispatch("beforesend", "progress", "load", "error"), headers = {}, request = new XMLHttpRequest(), responseType = null;
	    if (this.XDomainRequest && !("withCredentials" in request) && /^(http(s)?:)?\/\//.test(url)) request = new XDomainRequest();
	    "onload" in request ? request.onload = request.onerror = respond : request.onreadystatechange = function() {
	      request.readyState > 3 && respond();
	    };
	    function respond() {
	      var status = request.status, result;
	      if (!status && d3_xhrHasResponse(request) || status >= 200 && status < 300 || status === 304) {
	        try {
	          result = response.call(xhr, request);
	        } catch (e) {
	          dispatch.error.call(xhr, e);
	          return;
	        }
	        dispatch.load.call(xhr, result);
	      } else {
	        dispatch.error.call(xhr, request);
	      }
	    }
	    request.onprogress = function(event) {
	      var o = d3.event;
	      d3.event = event;
	      try {
	        dispatch.progress.call(xhr, request);
	      } finally {
	        d3.event = o;
	      }
	    };
	    xhr.header = function(name, value) {
	      name = (name + "").toLowerCase();
	      if (arguments.length < 2) return headers[name];
	      if (value == null) delete headers[name]; else headers[name] = value + "";
	      return xhr;
	    };
	    xhr.mimeType = function(value) {
	      if (!arguments.length) return mimeType;
	      mimeType = value == null ? null : value + "";
	      return xhr;
	    };
	    xhr.responseType = function(value) {
	      if (!arguments.length) return responseType;
	      responseType = value;
	      return xhr;
	    };
	    xhr.response = function(value) {
	      response = value;
	      return xhr;
	    };
	    [ "get", "post" ].forEach(function(method) {
	      xhr[method] = function() {
	        return xhr.send.apply(xhr, [ method ].concat(d3_array(arguments)));
	      };
	    });
	    xhr.send = function(method, data, callback) {
	      if (arguments.length === 2 && typeof data === "function") callback = data, data = null;
	      request.open(method, url, true);
	      if (mimeType != null && !("accept" in headers)) headers["accept"] = mimeType + ",*/*";
	      if (request.setRequestHeader) for (var name in headers) request.setRequestHeader(name, headers[name]);
	      if (mimeType != null && request.overrideMimeType) request.overrideMimeType(mimeType);
	      if (responseType != null) request.responseType = responseType;
	      if (callback != null) xhr.on("error", callback).on("load", function(request) {
	        callback(null, request);
	      });
	      dispatch.beforesend.call(xhr, request);
	      request.send(data == null ? null : data);
	      return xhr;
	    };
	    xhr.abort = function() {
	      request.abort();
	      return xhr;
	    };
	    d3.rebind(xhr, dispatch, "on");
	    return callback == null ? xhr : xhr.get(d3_xhr_fixCallback(callback));
	  }
	  function d3_xhr_fixCallback(callback) {
	    return callback.length === 1 ? function(error, request) {
	      callback(error == null ? request : null);
	    } : callback;
	  }
	  function d3_xhrHasResponse(request) {
	    var type = request.responseType;
	    return type && type !== "text" ? request.response : request.responseText;
	  }
	  d3.dsv = function(delimiter, mimeType) {
	    var reFormat = new RegExp('["' + delimiter + "\n]"), delimiterCode = delimiter.charCodeAt(0);
	    function dsv(url, row, callback) {
	      if (arguments.length < 3) callback = row, row = null;
	      var xhr = d3_xhr(url, mimeType, row == null ? response : typedResponse(row), callback);
	      xhr.row = function(_) {
	        return arguments.length ? xhr.response((row = _) == null ? response : typedResponse(_)) : row;
	      };
	      return xhr;
	    }
	    function response(request) {
	      return dsv.parse(request.responseText);
	    }
	    function typedResponse(f) {
	      return function(request) {
	        return dsv.parse(request.responseText, f);
	      };
	    }
	    dsv.parse = function(text, f) {
	      var o;
	      return dsv.parseRows(text, function(row, i) {
	        if (o) return o(row, i - 1);
	        var a = new Function("d", "return {" + row.map(function(name, i) {
	          return JSON.stringify(name) + ": d[" + i + "]";
	        }).join(",") + "}");
	        o = f ? function(row, i) {
	          return f(a(row), i);
	        } : a;
	      });
	    };
	    dsv.parseRows = function(text, f) {
	      var EOL = {}, EOF = {}, rows = [], N = text.length, I = 0, n = 0, t, eol;
	      function token() {
	        if (I >= N) return EOF;
	        if (eol) return eol = false, EOL;
	        var j = I;
	        if (text.charCodeAt(j) === 34) {
	          var i = j;
	          while (i++ < N) {
	            if (text.charCodeAt(i) === 34) {
	              if (text.charCodeAt(i + 1) !== 34) break;
	              ++i;
	            }
	          }
	          I = i + 2;
	          var c = text.charCodeAt(i + 1);
	          if (c === 13) {
	            eol = true;
	            if (text.charCodeAt(i + 2) === 10) ++I;
	          } else if (c === 10) {
	            eol = true;
	          }
	          return text.slice(j + 1, i).replace(/""/g, '"');
	        }
	        while (I < N) {
	          var c = text.charCodeAt(I++), k = 1;
	          if (c === 10) eol = true; else if (c === 13) {
	            eol = true;
	            if (text.charCodeAt(I) === 10) ++I, ++k;
	          } else if (c !== delimiterCode) continue;
	          return text.slice(j, I - k);
	        }
	        return text.slice(j);
	      }
	      while ((t = token()) !== EOF) {
	        var a = [];
	        while (t !== EOL && t !== EOF) {
	          a.push(t);
	          t = token();
	        }
	        if (f && (a = f(a, n++)) == null) continue;
	        rows.push(a);
	      }
	      return rows;
	    };
	    dsv.format = function(rows) {
	      if (Array.isArray(rows[0])) return dsv.formatRows(rows);
	      var fieldSet = new d3_Set(), fields = [];
	      rows.forEach(function(row) {
	        for (var field in row) {
	          if (!fieldSet.has(field)) {
	            fields.push(fieldSet.add(field));
	          }
	        }
	      });
	      return [ fields.map(formatValue).join(delimiter) ].concat(rows.map(function(row) {
	        return fields.map(function(field) {
	          return formatValue(row[field]);
	        }).join(delimiter);
	      })).join("\n");
	    };
	    dsv.formatRows = function(rows) {
	      return rows.map(formatRow).join("\n");
	    };
	    function formatRow(row) {
	      return row.map(formatValue).join(delimiter);
	    }
	    function formatValue(text) {
	      return reFormat.test(text) ? '"' + text.replace(/\"/g, '""') + '"' : text;
	    }
	    return dsv;
	  };
	  d3.csv = d3.dsv(",", "text/csv");
	  d3.tsv = d3.dsv("	", "text/tab-separated-values");
	  var d3_timer_queueHead, d3_timer_queueTail, d3_timer_interval, d3_timer_timeout, d3_timer_frame = this[d3_vendorSymbol(this, "requestAnimationFrame")] || function(callback) {
	    setTimeout(callback, 17);
	  };
	  d3.timer = function() {
	    d3_timer.apply(this, arguments);
	  };
	  function d3_timer(callback, delay, then) {
	    var n = arguments.length;
	    if (n < 2) delay = 0;
	    if (n < 3) then = Date.now();
	    var time = then + delay, timer = {
	      c: callback,
	      t: time,
	      n: null
	    };
	    if (d3_timer_queueTail) d3_timer_queueTail.n = timer; else d3_timer_queueHead = timer;
	    d3_timer_queueTail = timer;
	    if (!d3_timer_interval) {
	      d3_timer_timeout = clearTimeout(d3_timer_timeout);
	      d3_timer_interval = 1;
	      d3_timer_frame(d3_timer_step);
	    }
	    return timer;
	  }
	  function d3_timer_step() {
	    var now = d3_timer_mark(), delay = d3_timer_sweep() - now;
	    if (delay > 24) {
	      if (isFinite(delay)) {
	        clearTimeout(d3_timer_timeout);
	        d3_timer_timeout = setTimeout(d3_timer_step, delay);
	      }
	      d3_timer_interval = 0;
	    } else {
	      d3_timer_interval = 1;
	      d3_timer_frame(d3_timer_step);
	    }
	  }
	  d3.timer.flush = function() {
	    d3_timer_mark();
	    d3_timer_sweep();
	  };
	  function d3_timer_mark() {
	    var now = Date.now(), timer = d3_timer_queueHead;
	    while (timer) {
	      if (now >= timer.t && timer.c(now - timer.t)) timer.c = null;
	      timer = timer.n;
	    }
	    return now;
	  }
	  function d3_timer_sweep() {
	    var t0, t1 = d3_timer_queueHead, time = Infinity;
	    while (t1) {
	      if (t1.c) {
	        if (t1.t < time) time = t1.t;
	        t1 = (t0 = t1).n;
	      } else {
	        t1 = t0 ? t0.n = t1.n : d3_timer_queueHead = t1.n;
	      }
	    }
	    d3_timer_queueTail = t0;
	    return time;
	  }
	  function d3_format_precision(x, p) {
	    return p - (x ? Math.ceil(Math.log(x) / Math.LN10) : 1);
	  }
	  d3.round = function(x, n) {
	    return n ? Math.round(x * (n = Math.pow(10, n))) / n : Math.round(x);
	  };
	  var d3_formatPrefixes = [ "y", "z", "a", "f", "p", "n", "µ", "m", "", "k", "M", "G", "T", "P", "E", "Z", "Y" ].map(d3_formatPrefix);
	  d3.formatPrefix = function(value, precision) {
	    var i = 0;
	    if (value = +value) {
	      if (value < 0) value *= -1;
	      if (precision) value = d3.round(value, d3_format_precision(value, precision));
	      i = 1 + Math.floor(1e-12 + Math.log(value) / Math.LN10);
	      i = Math.max(-24, Math.min(24, Math.floor((i - 1) / 3) * 3));
	    }
	    return d3_formatPrefixes[8 + i / 3];
	  };
	  function d3_formatPrefix(d, i) {
	    var k = Math.pow(10, abs(8 - i) * 3);
	    return {
	      scale: i > 8 ? function(d) {
	        return d / k;
	      } : function(d) {
	        return d * k;
	      },
	      symbol: d
	    };
	  }
	  function d3_locale_numberFormat(locale) {
	    var locale_decimal = locale.decimal, locale_thousands = locale.thousands, locale_grouping = locale.grouping, locale_currency = locale.currency, formatGroup = locale_grouping && locale_thousands ? function(value, width) {
	      var i = value.length, t = [], j = 0, g = locale_grouping[0], length = 0;
	      while (i > 0 && g > 0) {
	        if (length + g + 1 > width) g = Math.max(1, width - length);
	        t.push(value.substring(i -= g, i + g));
	        if ((length += g + 1) > width) break;
	        g = locale_grouping[j = (j + 1) % locale_grouping.length];
	      }
	      return t.reverse().join(locale_thousands);
	    } : d3_identity;
	    return function(specifier) {
	      var match = d3_format_re.exec(specifier), fill = match[1] || " ", align = match[2] || ">", sign = match[3] || "-", symbol = match[4] || "", zfill = match[5], width = +match[6], comma = match[7], precision = match[8], type = match[9], scale = 1, prefix = "", suffix = "", integer = false, exponent = true;
	      if (precision) precision = +precision.substring(1);
	      if (zfill || fill === "0" && align === "=") {
	        zfill = fill = "0";
	        align = "=";
	      }
	      switch (type) {
	       case "n":
	        comma = true;
	        type = "g";
	        break;
	
	       case "%":
	        scale = 100;
	        suffix = "%";
	        type = "f";
	        break;
	
	       case "p":
	        scale = 100;
	        suffix = "%";
	        type = "r";
	        break;
	
	       case "b":
	       case "o":
	       case "x":
	       case "X":
	        if (symbol === "#") prefix = "0" + type.toLowerCase();
	
	       case "c":
	        exponent = false;
	
	       case "d":
	        integer = true;
	        precision = 0;
	        break;
	
	       case "s":
	        scale = -1;
	        type = "r";
	        break;
	      }
	      if (symbol === "$") prefix = locale_currency[0], suffix = locale_currency[1];
	      if (type == "r" && !precision) type = "g";
	      if (precision != null) {
	        if (type == "g") precision = Math.max(1, Math.min(21, precision)); else if (type == "e" || type == "f") precision = Math.max(0, Math.min(20, precision));
	      }
	      type = d3_format_types.get(type) || d3_format_typeDefault;
	      var zcomma = zfill && comma;
	      return function(value) {
	        var fullSuffix = suffix;
	        if (integer && value % 1) return "";
	        var negative = value < 0 || value === 0 && 1 / value < 0 ? (value = -value, "-") : sign === "-" ? "" : sign;
	        if (scale < 0) {
	          var unit = d3.formatPrefix(value, precision);
	          value = unit.scale(value);
	          fullSuffix = unit.symbol + suffix;
	        } else {
	          value *= scale;
	        }
	        value = type(value, precision);
	        var i = value.lastIndexOf("."), before, after;
	        if (i < 0) {
	          var j = exponent ? value.lastIndexOf("e") : -1;
	          if (j < 0) before = value, after = ""; else before = value.substring(0, j), after = value.substring(j);
	        } else {
	          before = value.substring(0, i);
	          after = locale_decimal + value.substring(i + 1);
	        }
	        if (!zfill && comma) before = formatGroup(before, Infinity);
	        var length = prefix.length + before.length + after.length + (zcomma ? 0 : negative.length), padding = length < width ? new Array(length = width - length + 1).join(fill) : "";
	        if (zcomma) before = formatGroup(padding + before, padding.length ? width - after.length : Infinity);
	        negative += prefix;
	        value = before + after;
	        return (align === "<" ? negative + value + padding : align === ">" ? padding + negative + value : align === "^" ? padding.substring(0, length >>= 1) + negative + value + padding.substring(length) : negative + (zcomma ? value : padding + value)) + fullSuffix;
	      };
	    };
	  }
	  var d3_format_re = /(?:([^{])?([<>=^]))?([+\- ])?([$#])?(0)?(\d+)?(,)?(\.-?\d+)?([a-z%])?/i;
	  var d3_format_types = d3.map({
	    b: function(x) {
	      return x.toString(2);
	    },
	    c: function(x) {
	      return String.fromCharCode(x);
	    },
	    o: function(x) {
	      return x.toString(8);
	    },
	    x: function(x) {
	      return x.toString(16);
	    },
	    X: function(x) {
	      return x.toString(16).toUpperCase();
	    },
	    g: function(x, p) {
	      return x.toPrecision(p);
	    },
	    e: function(x, p) {
	      return x.toExponential(p);
	    },
	    f: function(x, p) {
	      return x.toFixed(p);
	    },
	    r: function(x, p) {
	      return (x = d3.round(x, d3_format_precision(x, p))).toFixed(Math.max(0, Math.min(20, d3_format_precision(x * (1 + 1e-15), p))));
	    }
	  });
	  function d3_format_typeDefault(x) {
	    return x + "";
	  }
	  var d3_time = d3.time = {}, d3_date = Date;
	  function d3_date_utc() {
	    this._ = new Date(arguments.length > 1 ? Date.UTC.apply(this, arguments) : arguments[0]);
	  }
	  d3_date_utc.prototype = {
	    getDate: function() {
	      return this._.getUTCDate();
	    },
	    getDay: function() {
	      return this._.getUTCDay();
	    },
	    getFullYear: function() {
	      return this._.getUTCFullYear();
	    },
	    getHours: function() {
	      return this._.getUTCHours();
	    },
	    getMilliseconds: function() {
	      return this._.getUTCMilliseconds();
	    },
	    getMinutes: function() {
	      return this._.getUTCMinutes();
	    },
	    getMonth: function() {
	      return this._.getUTCMonth();
	    },
	    getSeconds: function() {
	      return this._.getUTCSeconds();
	    },
	    getTime: function() {
	      return this._.getTime();
	    },
	    getTimezoneOffset: function() {
	      return 0;
	    },
	    valueOf: function() {
	      return this._.valueOf();
	    },
	    setDate: function() {
	      d3_time_prototype.setUTCDate.apply(this._, arguments);
	    },
	    setDay: function() {
	      d3_time_prototype.setUTCDay.apply(this._, arguments);
	    },
	    setFullYear: function() {
	      d3_time_prototype.setUTCFullYear.apply(this._, arguments);
	    },
	    setHours: function() {
	      d3_time_prototype.setUTCHours.apply(this._, arguments);
	    },
	    setMilliseconds: function() {
	      d3_time_prototype.setUTCMilliseconds.apply(this._, arguments);
	    },
	    setMinutes: function() {
	      d3_time_prototype.setUTCMinutes.apply(this._, arguments);
	    },
	    setMonth: function() {
	      d3_time_prototype.setUTCMonth.apply(this._, arguments);
	    },
	    setSeconds: function() {
	      d3_time_prototype.setUTCSeconds.apply(this._, arguments);
	    },
	    setTime: function() {
	      d3_time_prototype.setTime.apply(this._, arguments);
	    }
	  };
	  var d3_time_prototype = Date.prototype;
	  function d3_time_interval(local, step, number) {
	    function round(date) {
	      var d0 = local(date), d1 = offset(d0, 1);
	      return date - d0 < d1 - date ? d0 : d1;
	    }
	    function ceil(date) {
	      step(date = local(new d3_date(date - 1)), 1);
	      return date;
	    }
	    function offset(date, k) {
	      step(date = new d3_date(+date), k);
	      return date;
	    }
	    function range(t0, t1, dt) {
	      var time = ceil(t0), times = [];
	      if (dt > 1) {
	        while (time < t1) {
	          if (!(number(time) % dt)) times.push(new Date(+time));
	          step(time, 1);
	        }
	      } else {
	        while (time < t1) times.push(new Date(+time)), step(time, 1);
	      }
	      return times;
	    }
	    function range_utc(t0, t1, dt) {
	      try {
	        d3_date = d3_date_utc;
	        var utc = new d3_date_utc();
	        utc._ = t0;
	        return range(utc, t1, dt);
	      } finally {
	        d3_date = Date;
	      }
	    }
	    local.floor = local;
	    local.round = round;
	    local.ceil = ceil;
	    local.offset = offset;
	    local.range = range;
	    var utc = local.utc = d3_time_interval_utc(local);
	    utc.floor = utc;
	    utc.round = d3_time_interval_utc(round);
	    utc.ceil = d3_time_interval_utc(ceil);
	    utc.offset = d3_time_interval_utc(offset);
	    utc.range = range_utc;
	    return local;
	  }
	  function d3_time_interval_utc(method) {
	    return function(date, k) {
	      try {
	        d3_date = d3_date_utc;
	        var utc = new d3_date_utc();
	        utc._ = date;
	        return method(utc, k)._;
	      } finally {
	        d3_date = Date;
	      }
	    };
	  }
	  d3_time.year = d3_time_interval(function(date) {
	    date = d3_time.day(date);
	    date.setMonth(0, 1);
	    return date;
	  }, function(date, offset) {
	    date.setFullYear(date.getFullYear() + offset);
	  }, function(date) {
	    return date.getFullYear();
	  });
	  d3_time.years = d3_time.year.range;
	  d3_time.years.utc = d3_time.year.utc.range;
	  d3_time.day = d3_time_interval(function(date) {
	    var day = new d3_date(2e3, 0);
	    day.setFullYear(date.getFullYear(), date.getMonth(), date.getDate());
	    return day;
	  }, function(date, offset) {
	    date.setDate(date.getDate() + offset);
	  }, function(date) {
	    return date.getDate() - 1;
	  });
	  d3_time.days = d3_time.day.range;
	  d3_time.days.utc = d3_time.day.utc.range;
	  d3_time.dayOfYear = function(date) {
	    var year = d3_time.year(date);
	    return Math.floor((date - year - (date.getTimezoneOffset() - year.getTimezoneOffset()) * 6e4) / 864e5);
	  };
	  [ "sunday", "monday", "tuesday", "wednesday", "thursday", "friday", "saturday" ].forEach(function(day, i) {
	    i = 7 - i;
	    var interval = d3_time[day] = d3_time_interval(function(date) {
	      (date = d3_time.day(date)).setDate(date.getDate() - (date.getDay() + i) % 7);
	      return date;
	    }, function(date, offset) {
	      date.setDate(date.getDate() + Math.floor(offset) * 7);
	    }, function(date) {
	      var day = d3_time.year(date).getDay();
	      return Math.floor((d3_time.dayOfYear(date) + (day + i) % 7) / 7) - (day !== i);
	    });
	    d3_time[day + "s"] = interval.range;
	    d3_time[day + "s"].utc = interval.utc.range;
	    d3_time[day + "OfYear"] = function(date) {
	      var day = d3_time.year(date).getDay();
	      return Math.floor((d3_time.dayOfYear(date) + (day + i) % 7) / 7);
	    };
	  });
	  d3_time.week = d3_time.sunday;
	  d3_time.weeks = d3_time.sunday.range;
	  d3_time.weeks.utc = d3_time.sunday.utc.range;
	  d3_time.weekOfYear = d3_time.sundayOfYear;
	  function d3_locale_timeFormat(locale) {
	    var locale_dateTime = locale.dateTime, locale_date = locale.date, locale_time = locale.time, locale_periods = locale.periods, locale_days = locale.days, locale_shortDays = locale.shortDays, locale_months = locale.months, locale_shortMonths = locale.shortMonths;
	    function d3_time_format(template) {
	      var n = template.length;
	      function format(date) {
	        var string = [], i = -1, j = 0, c, p, f;
	        while (++i < n) {
	          if (template.charCodeAt(i) === 37) {
	            string.push(template.slice(j, i));
	            if ((p = d3_time_formatPads[c = template.charAt(++i)]) != null) c = template.charAt(++i);
	            if (f = d3_time_formats[c]) c = f(date, p == null ? c === "e" ? " " : "0" : p);
	            string.push(c);
	            j = i + 1;
	          }
	        }
	        string.push(template.slice(j, i));
	        return string.join("");
	      }
	      format.parse = function(string) {
	        var d = {
	          y: 1900,
	          m: 0,
	          d: 1,
	          H: 0,
	          M: 0,
	          S: 0,
	          L: 0,
	          Z: null
	        }, i = d3_time_parse(d, template, string, 0);
	        if (i != string.length) return null;
	        if ("p" in d) d.H = d.H % 12 + d.p * 12;
	        var localZ = d.Z != null && d3_date !== d3_date_utc, date = new (localZ ? d3_date_utc : d3_date)();
	        if ("j" in d) date.setFullYear(d.y, 0, d.j); else if ("W" in d || "U" in d) {
	          if (!("w" in d)) d.w = "W" in d ? 1 : 0;
	          date.setFullYear(d.y, 0, 1);
	          date.setFullYear(d.y, 0, "W" in d ? (d.w + 6) % 7 + d.W * 7 - (date.getDay() + 5) % 7 : d.w + d.U * 7 - (date.getDay() + 6) % 7);
	        } else date.setFullYear(d.y, d.m, d.d);
	        date.setHours(d.H + (d.Z / 100 | 0), d.M + d.Z % 100, d.S, d.L);
	        return localZ ? date._ : date;
	      };
	      format.toString = function() {
	        return template;
	      };
	      return format;
	    }
	    function d3_time_parse(date, template, string, j) {
	      var c, p, t, i = 0, n = template.length, m = string.length;
	      while (i < n) {
	        if (j >= m) return -1;
	        c = template.charCodeAt(i++);
	        if (c === 37) {
	          t = template.charAt(i++);
	          p = d3_time_parsers[t in d3_time_formatPads ? template.charAt(i++) : t];
	          if (!p || (j = p(date, string, j)) < 0) return -1;
	        } else if (c != string.charCodeAt(j++)) {
	          return -1;
	        }
	      }
	      return j;
	    }
	    d3_time_format.utc = function(template) {
	      var local = d3_time_format(template);
	      function format(date) {
	        try {
	          d3_date = d3_date_utc;
	          var utc = new d3_date();
	          utc._ = date;
	          return local(utc);
	        } finally {
	          d3_date = Date;
	        }
	      }
	      format.parse = function(string) {
	        try {
	          d3_date = d3_date_utc;
	          var date = local.parse(string);
	          return date && date._;
	        } finally {
	          d3_date = Date;
	        }
	      };
	      format.toString = local.toString;
	      return format;
	    };
	    d3_time_format.multi = d3_time_format.utc.multi = d3_time_formatMulti;
	    var d3_time_periodLookup = d3.map(), d3_time_dayRe = d3_time_formatRe(locale_days), d3_time_dayLookup = d3_time_formatLookup(locale_days), d3_time_dayAbbrevRe = d3_time_formatRe(locale_shortDays), d3_time_dayAbbrevLookup = d3_time_formatLookup(locale_shortDays), d3_time_monthRe = d3_time_formatRe(locale_months), d3_time_monthLookup = d3_time_formatLookup(locale_months), d3_time_monthAbbrevRe = d3_time_formatRe(locale_shortMonths), d3_time_monthAbbrevLookup = d3_time_formatLookup(locale_shortMonths);
	    locale_periods.forEach(function(p, i) {
	      d3_time_periodLookup.set(p.toLowerCase(), i);
	    });
	    var d3_time_formats = {
	      a: function(d) {
	        return locale_shortDays[d.getDay()];
	      },
	      A: function(d) {
	        return locale_days[d.getDay()];
	      },
	      b: function(d) {
	        return locale_shortMonths[d.getMonth()];
	      },
	      B: function(d) {
	        return locale_months[d.getMonth()];
	      },
	      c: d3_time_format(locale_dateTime),
	      d: function(d, p) {
	        return d3_time_formatPad(d.getDate(), p, 2);
	      },
	      e: function(d, p) {
	        return d3_time_formatPad(d.getDate(), p, 2);
	      },
	      H: function(d, p) {
	        return d3_time_formatPad(d.getHours(), p, 2);
	      },
	      I: function(d, p) {
	        return d3_time_formatPad(d.getHours() % 12 || 12, p, 2);
	      },
	      j: function(d, p) {
	        return d3_time_formatPad(1 + d3_time.dayOfYear(d), p, 3);
	      },
	      L: function(d, p) {
	        return d3_time_formatPad(d.getMilliseconds(), p, 3);
	      },
	      m: function(d, p) {
	        return d3_time_formatPad(d.getMonth() + 1, p, 2);
	      },
	      M: function(d, p) {
	        return d3_time_formatPad(d.getMinutes(), p, 2);
	      },
	      p: function(d) {
	        return locale_periods[+(d.getHours() >= 12)];
	      },
	      S: function(d, p) {
	        return d3_time_formatPad(d.getSeconds(), p, 2);
	      },
	      U: function(d, p) {
	        return d3_time_formatPad(d3_time.sundayOfYear(d), p, 2);
	      },
	      w: function(d) {
	        return d.getDay();
	      },
	      W: function(d, p) {
	        return d3_time_formatPad(d3_time.mondayOfYear(d), p, 2);
	      },
	      x: d3_time_format(locale_date),
	      X: d3_time_format(locale_time),
	      y: function(d, p) {
	        return d3_time_formatPad(d.getFullYear() % 100, p, 2);
	      },
	      Y: function(d, p) {
	        return d3_time_formatPad(d.getFullYear() % 1e4, p, 4);
	      },
	      Z: d3_time_zone,
	      "%": function() {
	        return "%";
	      }
	    };
	    var d3_time_parsers = {
	      a: d3_time_parseWeekdayAbbrev,
	      A: d3_time_parseWeekday,
	      b: d3_time_parseMonthAbbrev,
	      B: d3_time_parseMonth,
	      c: d3_time_parseLocaleFull,
	      d: d3_time_parseDay,
	      e: d3_time_parseDay,
	      H: d3_time_parseHour24,
	      I: d3_time_parseHour24,
	      j: d3_time_parseDayOfYear,
	      L: d3_time_parseMilliseconds,
	      m: d3_time_parseMonthNumber,
	      M: d3_time_parseMinutes,
	      p: d3_time_parseAmPm,
	      S: d3_time_parseSeconds,
	      U: d3_time_parseWeekNumberSunday,
	      w: d3_time_parseWeekdayNumber,
	      W: d3_time_parseWeekNumberMonday,
	      x: d3_time_parseLocaleDate,
	      X: d3_time_parseLocaleTime,
	      y: d3_time_parseYear,
	      Y: d3_time_parseFullYear,
	      Z: d3_time_parseZone,
	      "%": d3_time_parseLiteralPercent
	    };
	    function d3_time_parseWeekdayAbbrev(date, string, i) {
	      d3_time_dayAbbrevRe.lastIndex = 0;
	      var n = d3_time_dayAbbrevRe.exec(string.slice(i));
	      return n ? (date.w = d3_time_dayAbbrevLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
	    }
	    function d3_time_parseWeekday(date, string, i) {
	      d3_time_dayRe.lastIndex = 0;
	      var n = d3_time_dayRe.exec(string.slice(i));
	      return n ? (date.w = d3_time_dayLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
	    }
	    function d3_time_parseMonthAbbrev(date, string, i) {
	      d3_time_monthAbbrevRe.lastIndex = 0;
	      var n = d3_time_monthAbbrevRe.exec(string.slice(i));
	      return n ? (date.m = d3_time_monthAbbrevLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
	    }
	    function d3_time_parseMonth(date, string, i) {
	      d3_time_monthRe.lastIndex = 0;
	      var n = d3_time_monthRe.exec(string.slice(i));
	      return n ? (date.m = d3_time_monthLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
	    }
	    function d3_time_parseLocaleFull(date, string, i) {
	      return d3_time_parse(date, d3_time_formats.c.toString(), string, i);
	    }
	    function d3_time_parseLocaleDate(date, string, i) {
	      return d3_time_parse(date, d3_time_formats.x.toString(), string, i);
	    }
	    function d3_time_parseLocaleTime(date, string, i) {
	      return d3_time_parse(date, d3_time_formats.X.toString(), string, i);
	    }
	    function d3_time_parseAmPm(date, string, i) {
	      var n = d3_time_periodLookup.get(string.slice(i, i += 2).toLowerCase());
	      return n == null ? -1 : (date.p = n, i);
	    }
	    return d3_time_format;
	  }
	  var d3_time_formatPads = {
	    "-": "",
	    _: " ",
	    "0": "0"
	  }, d3_time_numberRe = /^\s*\d+/, d3_time_percentRe = /^%/;
	  function d3_time_formatPad(value, fill, width) {
	    var sign = value < 0 ? "-" : "", string = (sign ? -value : value) + "", length = string.length;
	    return sign + (length < width ? new Array(width - length + 1).join(fill) + string : string);
	  }
	  function d3_time_formatRe(names) {
	    return new RegExp("^(?:" + names.map(d3.requote).join("|") + ")", "i");
	  }
	  function d3_time_formatLookup(names) {
	    var map = new d3_Map(), i = -1, n = names.length;
	    while (++i < n) map.set(names[i].toLowerCase(), i);
	    return map;
	  }
	  function d3_time_parseWeekdayNumber(date, string, i) {
	    d3_time_numberRe.lastIndex = 0;
	    var n = d3_time_numberRe.exec(string.slice(i, i + 1));
	    return n ? (date.w = +n[0], i + n[0].length) : -1;
	  }
	  function d3_time_parseWeekNumberSunday(date, string, i) {
	    d3_time_numberRe.lastIndex = 0;
	    var n = d3_time_numberRe.exec(string.slice(i));
	    return n ? (date.U = +n[0], i + n[0].length) : -1;
	  }
	  function d3_time_parseWeekNumberMonday(date, string, i) {
	    d3_time_numberRe.lastIndex = 0;
	    var n = d3_time_numberRe.exec(string.slice(i));
	    return n ? (date.W = +n[0], i + n[0].length) : -1;
	  }
	  function d3_time_parseFullYear(date, string, i) {
	    d3_time_numberRe.lastIndex = 0;
	    var n = d3_time_numberRe.exec(string.slice(i, i + 4));
	    return n ? (date.y = +n[0], i + n[0].length) : -1;
	  }
	  function d3_time_parseYear(date, string, i) {
	    d3_time_numberRe.lastIndex = 0;
	    var n = d3_time_numberRe.exec(string.slice(i, i + 2));
	    return n ? (date.y = d3_time_expandYear(+n[0]), i + n[0].length) : -1;
	  }
	  function d3_time_parseZone(date, string, i) {
	    return /^[+-]\d{4}$/.test(string = string.slice(i, i + 5)) ? (date.Z = -string, 
	    i + 5) : -1;
	  }
	  function d3_time_expandYear(d) {
	    return d + (d > 68 ? 1900 : 2e3);
	  }
	  function d3_time_parseMonthNumber(date, string, i) {
	    d3_time_numberRe.lastIndex = 0;
	    var n = d3_time_numberRe.exec(string.slice(i, i + 2));
	    return n ? (date.m = n[0] - 1, i + n[0].length) : -1;
	  }
	  function d3_time_parseDay(date, string, i) {
	    d3_time_numberRe.lastIndex = 0;
	    var n = d3_time_numberRe.exec(string.slice(i, i + 2));
	    return n ? (date.d = +n[0], i + n[0].length) : -1;
	  }
	  function d3_time_parseDayOfYear(date, string, i) {
	    d3_time_numberRe.lastIndex = 0;
	    var n = d3_time_numberRe.exec(string.slice(i, i + 3));
	    return n ? (date.j = +n[0], i + n[0].length) : -1;
	  }
	  function d3_time_parseHour24(date, string, i) {
	    d3_time_numberRe.lastIndex = 0;
	    var n = d3_time_numberRe.exec(string.slice(i, i + 2));
	    return n ? (date.H = +n[0], i + n[0].length) : -1;
	  }
	  function d3_time_parseMinutes(date, string, i) {
	    d3_time_numberRe.lastIndex = 0;
	    var n = d3_time_numberRe.exec(string.slice(i, i + 2));
	    return n ? (date.M = +n[0], i + n[0].length) : -1;
	  }
	  function d3_time_parseSeconds(date, string, i) {
	    d3_time_numberRe.lastIndex = 0;
	    var n = d3_time_numberRe.exec(string.slice(i, i + 2));
	    return n ? (date.S = +n[0], i + n[0].length) : -1;
	  }
	  function d3_time_parseMilliseconds(date, string, i) {
	    d3_time_numberRe.lastIndex = 0;
	    var n = d3_time_numberRe.exec(string.slice(i, i + 3));
	    return n ? (date.L = +n[0], i + n[0].length) : -1;
	  }
	  function d3_time_zone(d) {
	    var z = d.getTimezoneOffset(), zs = z > 0 ? "-" : "+", zh = abs(z) / 60 | 0, zm = abs(z) % 60;
	    return zs + d3_time_formatPad(zh, "0", 2) + d3_time_formatPad(zm, "0", 2);
	  }
	  function d3_time_parseLiteralPercent(date, string, i) {
	    d3_time_percentRe.lastIndex = 0;
	    var n = d3_time_percentRe.exec(string.slice(i, i + 1));
	    return n ? i + n[0].length : -1;
	  }
	  function d3_time_formatMulti(formats) {
	    var n = formats.length, i = -1;
	    while (++i < n) formats[i][0] = this(formats[i][0]);
	    return function(date) {
	      var i = 0, f = formats[i];
	      while (!f[1](date)) f = formats[++i];
	      return f[0](date);
	    };
	  }
	  d3.locale = function(locale) {
	    return {
	      numberFormat: d3_locale_numberFormat(locale),
	      timeFormat: d3_locale_timeFormat(locale)
	    };
	  };
	  var d3_locale_enUS = d3.locale({
	    decimal: ".",
	    thousands: ",",
	    grouping: [ 3 ],
	    currency: [ "$", "" ],
	    dateTime: "%a %b %e %X %Y",
	    date: "%m/%d/%Y",
	    time: "%H:%M:%S",
	    periods: [ "AM", "PM" ],
	    days: [ "Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday" ],
	    shortDays: [ "Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat" ],
	    months: [ "January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December" ],
	    shortMonths: [ "Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec" ]
	  });
	  d3.format = d3_locale_enUS.numberFormat;
	  d3.geo = {};
	  function d3_adder() {}
	  d3_adder.prototype = {
	    s: 0,
	    t: 0,
	    add: function(y) {
	      d3_adderSum(y, this.t, d3_adderTemp);
	      d3_adderSum(d3_adderTemp.s, this.s, this);
	      if (this.s) this.t += d3_adderTemp.t; else this.s = d3_adderTemp.t;
	    },
	    reset: function() {
	      this.s = this.t = 0;
	    },
	    valueOf: function() {
	      return this.s;
	    }
	  };
	  var d3_adderTemp = new d3_adder();
	  function d3_adderSum(a, b, o) {
	    var x = o.s = a + b, bv = x - a, av = x - bv;
	    o.t = a - av + (b - bv);
	  }
	  d3.geo.stream = function(object, listener) {
	    if (object && d3_geo_streamObjectType.hasOwnProperty(object.type)) {
	      d3_geo_streamObjectType[object.type](object, listener);
	    } else {
	      d3_geo_streamGeometry(object, listener);
	    }
	  };
	  function d3_geo_streamGeometry(geometry, listener) {
	    if (geometry && d3_geo_streamGeometryType.hasOwnProperty(geometry.type)) {
	      d3_geo_streamGeometryType[geometry.type](geometry, listener);
	    }
	  }
	  var d3_geo_streamObjectType = {
	    Feature: function(feature, listener) {
	      d3_geo_streamGeometry(feature.geometry, listener);
	    },
	    FeatureCollection: function(object, listener) {
	      var features = object.features, i = -1, n = features.length;
	      while (++i < n) d3_geo_streamGeometry(features[i].geometry, listener);
	    }
	  };
	  var d3_geo_streamGeometryType = {
	    Sphere: function(object, listener) {
	      listener.sphere();
	    },
	    Point: function(object, listener) {
	      object = object.coordinates;
	      listener.point(object[0], object[1], object[2]);
	    },
	    MultiPoint: function(object, listener) {
	      var coordinates = object.coordinates, i = -1, n = coordinates.length;
	      while (++i < n) object = coordinates[i], listener.point(object[0], object[1], object[2]);
	    },
	    LineString: function(object, listener) {
	      d3_geo_streamLine(object.coordinates, listener, 0);
	    },
	    MultiLineString: function(object, listener) {
	      var coordinates = object.coordinates, i = -1, n = coordinates.length;
	      while (++i < n) d3_geo_streamLine(coordinates[i], listener, 0);
	    },
	    Polygon: function(object, listener) {
	      d3_geo_streamPolygon(object.coordinates, listener);
	    },
	    MultiPolygon: function(object, listener) {
	      var coordinates = object.coordinates, i = -1, n = coordinates.length;
	      while (++i < n) d3_geo_streamPolygon(coordinates[i], listener);
	    },
	    GeometryCollection: function(object, listener) {
	      var geometries = object.geometries, i = -1, n = geometries.length;
	      while (++i < n) d3_geo_streamGeometry(geometries[i], listener);
	    }
	  };
	  function d3_geo_streamLine(coordinates, listener, closed) {
	    var i = -1, n = coordinates.length - closed, coordinate;
	    listener.lineStart();
	    while (++i < n) coordinate = coordinates[i], listener.point(coordinate[0], coordinate[1], coordinate[2]);
	    listener.lineEnd();
	  }
	  function d3_geo_streamPolygon(coordinates, listener) {
	    var i = -1, n = coordinates.length;
	    listener.polygonStart();
	    while (++i < n) d3_geo_streamLine(coordinates[i], listener, 1);
	    listener.polygonEnd();
	  }
	  d3.geo.area = function(object) {
	    d3_geo_areaSum = 0;
	    d3.geo.stream(object, d3_geo_area);
	    return d3_geo_areaSum;
	  };
	  var d3_geo_areaSum, d3_geo_areaRingSum = new d3_adder();
	  var d3_geo_area = {
	    sphere: function() {
	      d3_geo_areaSum += 4 * π;
	    },
	    point: d3_noop,
	    lineStart: d3_noop,
	    lineEnd: d3_noop,
	    polygonStart: function() {
	      d3_geo_areaRingSum.reset();
	      d3_geo_area.lineStart = d3_geo_areaRingStart;
	    },
	    polygonEnd: function() {
	      var area = 2 * d3_geo_areaRingSum;
	      d3_geo_areaSum += area < 0 ? 4 * π + area : area;
	      d3_geo_area.lineStart = d3_geo_area.lineEnd = d3_geo_area.point = d3_noop;
	    }
	  };
	  function d3_geo_areaRingStart() {
	    var λ00, φ00, λ0, cosφ0, sinφ0;
	    d3_geo_area.point = function(λ, φ) {
	      d3_geo_area.point = nextPoint;
	      λ0 = (λ00 = λ) * d3_radians, cosφ0 = Math.cos(φ = (φ00 = φ) * d3_radians / 2 + π / 4), 
	      sinφ0 = Math.sin(φ);
	    };
	    function nextPoint(λ, φ) {
	      λ *= d3_radians;
	      φ = φ * d3_radians / 2 + π / 4;
	      var dλ = λ - λ0, sdλ = dλ >= 0 ? 1 : -1, adλ = sdλ * dλ, cosφ = Math.cos(φ), sinφ = Math.sin(φ), k = sinφ0 * sinφ, u = cosφ0 * cosφ + k * Math.cos(adλ), v = k * sdλ * Math.sin(adλ);
	      d3_geo_areaRingSum.add(Math.atan2(v, u));
	      λ0 = λ, cosφ0 = cosφ, sinφ0 = sinφ;
	    }
	    d3_geo_area.lineEnd = function() {
	      nextPoint(λ00, φ00);
	    };
	  }
	  function d3_geo_cartesian(spherical) {
	    var λ = spherical[0], φ = spherical[1], cosφ = Math.cos(φ);
	    return [ cosφ * Math.cos(λ), cosφ * Math.sin(λ), Math.sin(φ) ];
	  }
	  function d3_geo_cartesianDot(a, b) {
	    return a[0] * b[0] + a[1] * b[1] + a[2] * b[2];
	  }
	  function d3_geo_cartesianCross(a, b) {
	    return [ a[1] * b[2] - a[2] * b[1], a[2] * b[0] - a[0] * b[2], a[0] * b[1] - a[1] * b[0] ];
	  }
	  function d3_geo_cartesianAdd(a, b) {
	    a[0] += b[0];
	    a[1] += b[1];
	    a[2] += b[2];
	  }
	  function d3_geo_cartesianScale(vector, k) {
	    return [ vector[0] * k, vector[1] * k, vector[2] * k ];
	  }
	  function d3_geo_cartesianNormalize(d) {
	    var l = Math.sqrt(d[0] * d[0] + d[1] * d[1] + d[2] * d[2]);
	    d[0] /= l;
	    d[1] /= l;
	    d[2] /= l;
	  }
	  function d3_geo_spherical(cartesian) {
	    return [ Math.atan2(cartesian[1], cartesian[0]), d3_asin(cartesian[2]) ];
	  }
	  function d3_geo_sphericalEqual(a, b) {
	    return abs(a[0] - b[0]) < ε && abs(a[1] - b[1]) < ε;
	  }
	  d3.geo.bounds = function() {
	    var λ0, φ0, λ1, φ1, λ_, λ__, φ__, p0, dλSum, ranges, range;
	    var bound = {
	      point: point,
	      lineStart: lineStart,
	      lineEnd: lineEnd,
	      polygonStart: function() {
	        bound.point = ringPoint;
	        bound.lineStart = ringStart;
	        bound.lineEnd = ringEnd;
	        dλSum = 0;
	        d3_geo_area.polygonStart();
	      },
	      polygonEnd: function() {
	        d3_geo_area.polygonEnd();
	        bound.point = point;
	        bound.lineStart = lineStart;
	        bound.lineEnd = lineEnd;
	        if (d3_geo_areaRingSum < 0) λ0 = -(λ1 = 180), φ0 = -(φ1 = 90); else if (dλSum > ε) φ1 = 90; else if (dλSum < -ε) φ0 = -90;
	        range[0] = λ0, range[1] = λ1;
	      }
	    };
	    function point(λ, φ) {
	      ranges.push(range = [ λ0 = λ, λ1 = λ ]);
	      if (φ < φ0) φ0 = φ;
	      if (φ > φ1) φ1 = φ;
	    }
	    function linePoint(λ, φ) {
	      var p = d3_geo_cartesian([ λ * d3_radians, φ * d3_radians ]);
	      if (p0) {
	        var normal = d3_geo_cartesianCross(p0, p), equatorial = [ normal[1], -normal[0], 0 ], inflection = d3_geo_cartesianCross(equatorial, normal);
	        d3_geo_cartesianNormalize(inflection);
	        inflection = d3_geo_spherical(inflection);
	        var dλ = λ - λ_, s = dλ > 0 ? 1 : -1, λi = inflection[0] * d3_degrees * s, antimeridian = abs(dλ) > 180;
	        if (antimeridian ^ (s * λ_ < λi && λi < s * λ)) {
	          var φi = inflection[1] * d3_degrees;
	          if (φi > φ1) φ1 = φi;
	        } else if (λi = (λi + 360) % 360 - 180, antimeridian ^ (s * λ_ < λi && λi < s * λ)) {
	          var φi = -inflection[1] * d3_degrees;
	          if (φi < φ0) φ0 = φi;
	        } else {
	          if (φ < φ0) φ0 = φ;
	          if (φ > φ1) φ1 = φ;
	        }
	        if (antimeridian) {
	          if (λ < λ_) {
	            if (angle(λ0, λ) > angle(λ0, λ1)) λ1 = λ;
	          } else {
	            if (angle(λ, λ1) > angle(λ0, λ1)) λ0 = λ;
	          }
	        } else {
	          if (λ1 >= λ0) {
	            if (λ < λ0) λ0 = λ;
	            if (λ > λ1) λ1 = λ;
	          } else {
	            if (λ > λ_) {
	              if (angle(λ0, λ) > angle(λ0, λ1)) λ1 = λ;
	            } else {
	              if (angle(λ, λ1) > angle(λ0, λ1)) λ0 = λ;
	            }
	          }
	        }
	      } else {
	        point(λ, φ);
	      }
	      p0 = p, λ_ = λ;
	    }
	    function lineStart() {
	      bound.point = linePoint;
	    }
	    function lineEnd() {
	      range[0] = λ0, range[1] = λ1;
	      bound.point = point;
	      p0 = null;
	    }
	    function ringPoint(λ, φ) {
	      if (p0) {
	        var dλ = λ - λ_;
	        dλSum += abs(dλ) > 180 ? dλ + (dλ > 0 ? 360 : -360) : dλ;
	      } else λ__ = λ, φ__ = φ;
	      d3_geo_area.point(λ, φ);
	      linePoint(λ, φ);
	    }
	    function ringStart() {
	      d3_geo_area.lineStart();
	    }
	    function ringEnd() {
	      ringPoint(λ__, φ__);
	      d3_geo_area.lineEnd();
	      if (abs(dλSum) > ε) λ0 = -(λ1 = 180);
	      range[0] = λ0, range[1] = λ1;
	      p0 = null;
	    }
	    function angle(λ0, λ1) {
	      return (λ1 -= λ0) < 0 ? λ1 + 360 : λ1;
	    }
	    function compareRanges(a, b) {
	      return a[0] - b[0];
	    }
	    function withinRange(x, range) {
	      return range[0] <= range[1] ? range[0] <= x && x <= range[1] : x < range[0] || range[1] < x;
	    }
	    return function(feature) {
	      φ1 = λ1 = -(λ0 = φ0 = Infinity);
	      ranges = [];
	      d3.geo.stream(feature, bound);
	      var n = ranges.length;
	      if (n) {
	        ranges.sort(compareRanges);
	        for (var i = 1, a = ranges[0], b, merged = [ a ]; i < n; ++i) {
	          b = ranges[i];
	          if (withinRange(b[0], a) || withinRange(b[1], a)) {
	            if (angle(a[0], b[1]) > angle(a[0], a[1])) a[1] = b[1];
	            if (angle(b[0], a[1]) > angle(a[0], a[1])) a[0] = b[0];
	          } else {
	            merged.push(a = b);
	          }
	        }
	        var best = -Infinity, dλ;
	        for (var n = merged.length - 1, i = 0, a = merged[n], b; i <= n; a = b, ++i) {
	          b = merged[i];
	          if ((dλ = angle(a[1], b[0])) > best) best = dλ, λ0 = b[0], λ1 = a[1];
	        }
	      }
	      ranges = range = null;
	      return λ0 === Infinity || φ0 === Infinity ? [ [ NaN, NaN ], [ NaN, NaN ] ] : [ [ λ0, φ0 ], [ λ1, φ1 ] ];
	    };
	  }();
	  d3.geo.centroid = function(object) {
	    d3_geo_centroidW0 = d3_geo_centroidW1 = d3_geo_centroidX0 = d3_geo_centroidY0 = d3_geo_centroidZ0 = d3_geo_centroidX1 = d3_geo_centroidY1 = d3_geo_centroidZ1 = d3_geo_centroidX2 = d3_geo_centroidY2 = d3_geo_centroidZ2 = 0;
	    d3.geo.stream(object, d3_geo_centroid);
	    var x = d3_geo_centroidX2, y = d3_geo_centroidY2, z = d3_geo_centroidZ2, m = x * x + y * y + z * z;
	    if (m < ε2) {
	      x = d3_geo_centroidX1, y = d3_geo_centroidY1, z = d3_geo_centroidZ1;
	      if (d3_geo_centroidW1 < ε) x = d3_geo_centroidX0, y = d3_geo_centroidY0, z = d3_geo_centroidZ0;
	      m = x * x + y * y + z * z;
	      if (m < ε2) return [ NaN, NaN ];
	    }
	    return [ Math.atan2(y, x) * d3_degrees, d3_asin(z / Math.sqrt(m)) * d3_degrees ];
	  };
	  var d3_geo_centroidW0, d3_geo_centroidW1, d3_geo_centroidX0, d3_geo_centroidY0, d3_geo_centroidZ0, d3_geo_centroidX1, d3_geo_centroidY1, d3_geo_centroidZ1, d3_geo_centroidX2, d3_geo_centroidY2, d3_geo_centroidZ2;
	  var d3_geo_centroid = {
	    sphere: d3_noop,
	    point: d3_geo_centroidPoint,
	    lineStart: d3_geo_centroidLineStart,
	    lineEnd: d3_geo_centroidLineEnd,
	    polygonStart: function() {
	      d3_geo_centroid.lineStart = d3_geo_centroidRingStart;
	    },
	    polygonEnd: function() {
	      d3_geo_centroid.lineStart = d3_geo_centroidLineStart;
	    }
	  };
	  function d3_geo_centroidPoint(λ, φ) {
	    λ *= d3_radians;
	    var cosφ = Math.cos(φ *= d3_radians);
	    d3_geo_centroidPointXYZ(cosφ * Math.cos(λ), cosφ * Math.sin(λ), Math.sin(φ));
	  }
	  function d3_geo_centroidPointXYZ(x, y, z) {
	    ++d3_geo_centroidW0;
	    d3_geo_centroidX0 += (x - d3_geo_centroidX0) / d3_geo_centroidW0;
	    d3_geo_centroidY0 += (y - d3_geo_centroidY0) / d3_geo_centroidW0;
	    d3_geo_centroidZ0 += (z - d3_geo_centroidZ0) / d3_geo_centroidW0;
	  }
	  function d3_geo_centroidLineStart() {
	    var x0, y0, z0;
	    d3_geo_centroid.point = function(λ, φ) {
	      λ *= d3_radians;
	      var cosφ = Math.cos(φ *= d3_radians);
	      x0 = cosφ * Math.cos(λ);
	      y0 = cosφ * Math.sin(λ);
	      z0 = Math.sin(φ);
	      d3_geo_centroid.point = nextPoint;
	      d3_geo_centroidPointXYZ(x0, y0, z0);
	    };
	    function nextPoint(λ, φ) {
	      λ *= d3_radians;
	      var cosφ = Math.cos(φ *= d3_radians), x = cosφ * Math.cos(λ), y = cosφ * Math.sin(λ), z = Math.sin(φ), w = Math.atan2(Math.sqrt((w = y0 * z - z0 * y) * w + (w = z0 * x - x0 * z) * w + (w = x0 * y - y0 * x) * w), x0 * x + y0 * y + z0 * z);
	      d3_geo_centroidW1 += w;
	      d3_geo_centroidX1 += w * (x0 + (x0 = x));
	      d3_geo_centroidY1 += w * (y0 + (y0 = y));
	      d3_geo_centroidZ1 += w * (z0 + (z0 = z));
	      d3_geo_centroidPointXYZ(x0, y0, z0);
	    }
	  }
	  function d3_geo_centroidLineEnd() {
	    d3_geo_centroid.point = d3_geo_centroidPoint;
	  }
	  function d3_geo_centroidRingStart() {
	    var λ00, φ00, x0, y0, z0;
	    d3_geo_centroid.point = function(λ, φ) {
	      λ00 = λ, φ00 = φ;
	      d3_geo_centroid.point = nextPoint;
	      λ *= d3_radians;
	      var cosφ = Math.cos(φ *= d3_radians);
	      x0 = cosφ * Math.cos(λ);
	      y0 = cosφ * Math.sin(λ);
	      z0 = Math.sin(φ);
	      d3_geo_centroidPointXYZ(x0, y0, z0);
	    };
	    d3_geo_centroid.lineEnd = function() {
	      nextPoint(λ00, φ00);
	      d3_geo_centroid.lineEnd = d3_geo_centroidLineEnd;
	      d3_geo_centroid.point = d3_geo_centroidPoint;
	    };
	    function nextPoint(λ, φ) {
	      λ *= d3_radians;
	      var cosφ = Math.cos(φ *= d3_radians), x = cosφ * Math.cos(λ), y = cosφ * Math.sin(λ), z = Math.sin(φ), cx = y0 * z - z0 * y, cy = z0 * x - x0 * z, cz = x0 * y - y0 * x, m = Math.sqrt(cx * cx + cy * cy + cz * cz), u = x0 * x + y0 * y + z0 * z, v = m && -d3_acos(u) / m, w = Math.atan2(m, u);
	      d3_geo_centroidX2 += v * cx;
	      d3_geo_centroidY2 += v * cy;
	      d3_geo_centroidZ2 += v * cz;
	      d3_geo_centroidW1 += w;
	      d3_geo_centroidX1 += w * (x0 + (x0 = x));
	      d3_geo_centroidY1 += w * (y0 + (y0 = y));
	      d3_geo_centroidZ1 += w * (z0 + (z0 = z));
	      d3_geo_centroidPointXYZ(x0, y0, z0);
	    }
	  }
	  function d3_geo_compose(a, b) {
	    function compose(x, y) {
	      return x = a(x, y), b(x[0], x[1]);
	    }
	    if (a.invert && b.invert) compose.invert = function(x, y) {
	      return x = b.invert(x, y), x && a.invert(x[0], x[1]);
	    };
	    return compose;
	  }
	  function d3_true() {
	    return true;
	  }
	  function d3_geo_clipPolygon(segments, compare, clipStartInside, interpolate, listener) {
	    var subject = [], clip = [];
	    segments.forEach(function(segment) {
	      if ((n = segment.length - 1) <= 0) return;
	      var n, p0 = segment[0], p1 = segment[n];
	      if (d3_geo_sphericalEqual(p0, p1)) {
	        listener.lineStart();
	        for (var i = 0; i < n; ++i) listener.point((p0 = segment[i])[0], p0[1]);
	        listener.lineEnd();
	        return;
	      }
	      var a = new d3_geo_clipPolygonIntersection(p0, segment, null, true), b = new d3_geo_clipPolygonIntersection(p0, null, a, false);
	      a.o = b;
	      subject.push(a);
	      clip.push(b);
	      a = new d3_geo_clipPolygonIntersection(p1, segment, null, false);
	      b = new d3_geo_clipPolygonIntersection(p1, null, a, true);
	      a.o = b;
	      subject.push(a);
	      clip.push(b);
	    });
	    clip.sort(compare);
	    d3_geo_clipPolygonLinkCircular(subject);
	    d3_geo_clipPolygonLinkCircular(clip);
	    if (!subject.length) return;
	    for (var i = 0, entry = clipStartInside, n = clip.length; i < n; ++i) {
	      clip[i].e = entry = !entry;
	    }
	    var start = subject[0], points, point;
	    while (1) {
	      var current = start, isSubject = true;
	      while (current.v) if ((current = current.n) === start) return;
	      points = current.z;
	      listener.lineStart();
	      do {
	        current.v = current.o.v = true;
	        if (current.e) {
	          if (isSubject) {
	            for (var i = 0, n = points.length; i < n; ++i) listener.point((point = points[i])[0], point[1]);
	          } else {
	            interpolate(current.x, current.n.x, 1, listener);
	          }
	          current = current.n;
	        } else {
	          if (isSubject) {
	            points = current.p.z;
	            for (var i = points.length - 1; i >= 0; --i) listener.point((point = points[i])[0], point[1]);
	          } else {
	            interpolate(current.x, current.p.x, -1, listener);
	          }
	          current = current.p;
	        }
	        current = current.o;
	        points = current.z;
	        isSubject = !isSubject;
	      } while (!current.v);
	      listener.lineEnd();
	    }
	  }
	  function d3_geo_clipPolygonLinkCircular(array) {
	    if (!(n = array.length)) return;
	    var n, i = 0, a = array[0], b;
	    while (++i < n) {
	      a.n = b = array[i];
	      b.p = a;
	      a = b;
	    }
	    a.n = b = array[0];
	    b.p = a;
	  }
	  function d3_geo_clipPolygonIntersection(point, points, other, entry) {
	    this.x = point;
	    this.z = points;
	    this.o = other;
	    this.e = entry;
	    this.v = false;
	    this.n = this.p = null;
	  }
	  function d3_geo_clip(pointVisible, clipLine, interpolate, clipStart) {
	    return function(rotate, listener) {
	      var line = clipLine(listener), rotatedClipStart = rotate.invert(clipStart[0], clipStart[1]);
	      var clip = {
	        point: point,
	        lineStart: lineStart,
	        lineEnd: lineEnd,
	        polygonStart: function() {
	          clip.point = pointRing;
	          clip.lineStart = ringStart;
	          clip.lineEnd = ringEnd;
	          segments = [];
	          polygon = [];
	        },
	        polygonEnd: function() {
	          clip.point = point;
	          clip.lineStart = lineStart;
	          clip.lineEnd = lineEnd;
	          segments = d3.merge(segments);
	          var clipStartInside = d3_geo_pointInPolygon(rotatedClipStart, polygon);
	          if (segments.length) {
	            if (!polygonStarted) listener.polygonStart(), polygonStarted = true;
	            d3_geo_clipPolygon(segments, d3_geo_clipSort, clipStartInside, interpolate, listener);
	          } else if (clipStartInside) {
	            if (!polygonStarted) listener.polygonStart(), polygonStarted = true;
	            listener.lineStart();
	            interpolate(null, null, 1, listener);
	            listener.lineEnd();
	          }
	          if (polygonStarted) listener.polygonEnd(), polygonStarted = false;
	          segments = polygon = null;
	        },
	        sphere: function() {
	          listener.polygonStart();
	          listener.lineStart();
	          interpolate(null, null, 1, listener);
	          listener.lineEnd();
	          listener.polygonEnd();
	        }
	      };
	      function point(λ, φ) {
	        var point = rotate(λ, φ);
	        if (pointVisible(λ = point[0], φ = point[1])) listener.point(λ, φ);
	      }
	      function pointLine(λ, φ) {
	        var point = rotate(λ, φ);
	        line.point(point[0], point[1]);
	      }
	      function lineStart() {
	        clip.point = pointLine;
	        line.lineStart();
	      }
	      function lineEnd() {
	        clip.point = point;
	        line.lineEnd();
	      }
	      var segments;
	      var buffer = d3_geo_clipBufferListener(), ringListener = clipLine(buffer), polygonStarted = false, polygon, ring;
	      function pointRing(λ, φ) {
	        ring.push([ λ, φ ]);
	        var point = rotate(λ, φ);
	        ringListener.point(point[0], point[1]);
	      }
	      function ringStart() {
	        ringListener.lineStart();
	        ring = [];
	      }
	      function ringEnd() {
	        pointRing(ring[0][0], ring[0][1]);
	        ringListener.lineEnd();
	        var clean = ringListener.clean(), ringSegments = buffer.buffer(), segment, n = ringSegments.length;
	        ring.pop();
	        polygon.push(ring);
	        ring = null;
	        if (!n) return;
	        if (clean & 1) {
	          segment = ringSegments[0];
	          var n = segment.length - 1, i = -1, point;
	          if (n > 0) {
	            if (!polygonStarted) listener.polygonStart(), polygonStarted = true;
	            listener.lineStart();
	            while (++i < n) listener.point((point = segment[i])[0], point[1]);
	            listener.lineEnd();
	          }
	          return;
	        }
	        if (n > 1 && clean & 2) ringSegments.push(ringSegments.pop().concat(ringSegments.shift()));
	        segments.push(ringSegments.filter(d3_geo_clipSegmentLength1));
	      }
	      return clip;
	    };
	  }
	  function d3_geo_clipSegmentLength1(segment) {
	    return segment.length > 1;
	  }
	  function d3_geo_clipBufferListener() {
	    var lines = [], line;
	    return {
	      lineStart: function() {
	        lines.push(line = []);
	      },
	      point: function(λ, φ) {
	        line.push([ λ, φ ]);
	      },
	      lineEnd: d3_noop,
	      buffer: function() {
	        var buffer = lines;
	        lines = [];
	        line = null;
	        return buffer;
	      },
	      rejoin: function() {
	        if (lines.length > 1) lines.push(lines.pop().concat(lines.shift()));
	      }
	    };
	  }
	  function d3_geo_clipSort(a, b) {
	    return ((a = a.x)[0] < 0 ? a[1] - halfπ - ε : halfπ - a[1]) - ((b = b.x)[0] < 0 ? b[1] - halfπ - ε : halfπ - b[1]);
	  }
	  var d3_geo_clipAntimeridian = d3_geo_clip(d3_true, d3_geo_clipAntimeridianLine, d3_geo_clipAntimeridianInterpolate, [ -π, -π / 2 ]);
	  function d3_geo_clipAntimeridianLine(listener) {
	    var λ0 = NaN, φ0 = NaN, sλ0 = NaN, clean;
	    return {
	      lineStart: function() {
	        listener.lineStart();
	        clean = 1;
	      },
	      point: function(λ1, φ1) {
	        var sλ1 = λ1 > 0 ? π : -π, dλ = abs(λ1 - λ0);
	        if (abs(dλ - π) < ε) {
	          listener.point(λ0, φ0 = (φ0 + φ1) / 2 > 0 ? halfπ : -halfπ);
	          listener.point(sλ0, φ0);
	          listener.lineEnd();
	          listener.lineStart();
	          listener.point(sλ1, φ0);
	          listener.point(λ1, φ0);
	          clean = 0;
	        } else if (sλ0 !== sλ1 && dλ >= π) {
	          if (abs(λ0 - sλ0) < ε) λ0 -= sλ0 * ε;
	          if (abs(λ1 - sλ1) < ε) λ1 -= sλ1 * ε;
	          φ0 = d3_geo_clipAntimeridianIntersect(λ0, φ0, λ1, φ1);
	          listener.point(sλ0, φ0);
	          listener.lineEnd();
	          listener.lineStart();
	          listener.point(sλ1, φ0);
	          clean = 0;
	        }
	        listener.point(λ0 = λ1, φ0 = φ1);
	        sλ0 = sλ1;
	      },
	      lineEnd: function() {
	        listener.lineEnd();
	        λ0 = φ0 = NaN;
	      },
	      clean: function() {
	        return 2 - clean;
	      }
	    };
	  }
	  function d3_geo_clipAntimeridianIntersect(λ0, φ0, λ1, φ1) {
	    var cosφ0, cosφ1, sinλ0_λ1 = Math.sin(λ0 - λ1);
	    return abs(sinλ0_λ1) > ε ? Math.atan((Math.sin(φ0) * (cosφ1 = Math.cos(φ1)) * Math.sin(λ1) - Math.sin(φ1) * (cosφ0 = Math.cos(φ0)) * Math.sin(λ0)) / (cosφ0 * cosφ1 * sinλ0_λ1)) : (φ0 + φ1) / 2;
	  }
	  function d3_geo_clipAntimeridianInterpolate(from, to, direction, listener) {
	    var φ;
	    if (from == null) {
	      φ = direction * halfπ;
	      listener.point(-π, φ);
	      listener.point(0, φ);
	      listener.point(π, φ);
	      listener.point(π, 0);
	      listener.point(π, -φ);
	      listener.point(0, -φ);
	      listener.point(-π, -φ);
	      listener.point(-π, 0);
	      listener.point(-π, φ);
	    } else if (abs(from[0] - to[0]) > ε) {
	      var s = from[0] < to[0] ? π : -π;
	      φ = direction * s / 2;
	      listener.point(-s, φ);
	      listener.point(0, φ);
	      listener.point(s, φ);
	    } else {
	      listener.point(to[0], to[1]);
	    }
	  }
	  function d3_geo_pointInPolygon(point, polygon) {
	    var meridian = point[0], parallel = point[1], meridianNormal = [ Math.sin(meridian), -Math.cos(meridian), 0 ], polarAngle = 0, winding = 0;
	    d3_geo_areaRingSum.reset();
	    for (var i = 0, n = polygon.length; i < n; ++i) {
	      var ring = polygon[i], m = ring.length;
	      if (!m) continue;
	      var point0 = ring[0], λ0 = point0[0], φ0 = point0[1] / 2 + π / 4, sinφ0 = Math.sin(φ0), cosφ0 = Math.cos(φ0), j = 1;
	      while (true) {
	        if (j === m) j = 0;
	        point = ring[j];
	        var λ = point[0], φ = point[1] / 2 + π / 4, sinφ = Math.sin(φ), cosφ = Math.cos(φ), dλ = λ - λ0, sdλ = dλ >= 0 ? 1 : -1, adλ = sdλ * dλ, antimeridian = adλ > π, k = sinφ0 * sinφ;
	        d3_geo_areaRingSum.add(Math.atan2(k * sdλ * Math.sin(adλ), cosφ0 * cosφ + k * Math.cos(adλ)));
	        polarAngle += antimeridian ? dλ + sdλ * τ : dλ;
	        if (antimeridian ^ λ0 >= meridian ^ λ >= meridian) {
	          var arc = d3_geo_cartesianCross(d3_geo_cartesian(point0), d3_geo_cartesian(point));
	          d3_geo_cartesianNormalize(arc);
	          var intersection = d3_geo_cartesianCross(meridianNormal, arc);
	          d3_geo_cartesianNormalize(intersection);
	          var φarc = (antimeridian ^ dλ >= 0 ? -1 : 1) * d3_asin(intersection[2]);
	          if (parallel > φarc || parallel === φarc && (arc[0] || arc[1])) {
	            winding += antimeridian ^ dλ >= 0 ? 1 : -1;
	          }
	        }
	        if (!j++) break;
	        λ0 = λ, sinφ0 = sinφ, cosφ0 = cosφ, point0 = point;
	      }
	    }
	    return (polarAngle < -ε || polarAngle < ε && d3_geo_areaRingSum < -ε) ^ winding & 1;
	  }
	  function d3_geo_clipCircle(radius) {
	    var cr = Math.cos(radius), smallRadius = cr > 0, notHemisphere = abs(cr) > ε, interpolate = d3_geo_circleInterpolate(radius, 6 * d3_radians);
	    return d3_geo_clip(visible, clipLine, interpolate, smallRadius ? [ 0, -radius ] : [ -π, radius - π ]);
	    function visible(λ, φ) {
	      return Math.cos(λ) * Math.cos(φ) > cr;
	    }
	    function clipLine(listener) {
	      var point0, c0, v0, v00, clean;
	      return {
	        lineStart: function() {
	          v00 = v0 = false;
	          clean = 1;
	        },
	        point: function(λ, φ) {
	          var point1 = [ λ, φ ], point2, v = visible(λ, φ), c = smallRadius ? v ? 0 : code(λ, φ) : v ? code(λ + (λ < 0 ? π : -π), φ) : 0;
	          if (!point0 && (v00 = v0 = v)) listener.lineStart();
	          if (v !== v0) {
	            point2 = intersect(point0, point1);
	            if (d3_geo_sphericalEqual(point0, point2) || d3_geo_sphericalEqual(point1, point2)) {
	              point1[0] += ε;
	              point1[1] += ε;
	              v = visible(point1[0], point1[1]);
	            }
	          }
	          if (v !== v0) {
	            clean = 0;
	            if (v) {
	              listener.lineStart();
	              point2 = intersect(point1, point0);
	              listener.point(point2[0], point2[1]);
	            } else {
	              point2 = intersect(point0, point1);
	              listener.point(point2[0], point2[1]);
	              listener.lineEnd();
	            }
	            point0 = point2;
	          } else if (notHemisphere && point0 && smallRadius ^ v) {
	            var t;
	            if (!(c & c0) && (t = intersect(point1, point0, true))) {
	              clean = 0;
	              if (smallRadius) {
	                listener.lineStart();
	                listener.point(t[0][0], t[0][1]);
	                listener.point(t[1][0], t[1][1]);
	                listener.lineEnd();
	              } else {
	                listener.point(t[1][0], t[1][1]);
	                listener.lineEnd();
	                listener.lineStart();
	                listener.point(t[0][0], t[0][1]);
	              }
	            }
	          }
	          if (v && (!point0 || !d3_geo_sphericalEqual(point0, point1))) {
	            listener.point(point1[0], point1[1]);
	          }
	          point0 = point1, v0 = v, c0 = c;
	        },
	        lineEnd: function() {
	          if (v0) listener.lineEnd();
	          point0 = null;
	        },
	        clean: function() {
	          return clean | (v00 && v0) << 1;
	        }
	      };
	    }
	    function intersect(a, b, two) {
	      var pa = d3_geo_cartesian(a), pb = d3_geo_cartesian(b);
	      var n1 = [ 1, 0, 0 ], n2 = d3_geo_cartesianCross(pa, pb), n2n2 = d3_geo_cartesianDot(n2, n2), n1n2 = n2[0], determinant = n2n2 - n1n2 * n1n2;
	      if (!determinant) return !two && a;
	      var c1 = cr * n2n2 / determinant, c2 = -cr * n1n2 / determinant, n1xn2 = d3_geo_cartesianCross(n1, n2), A = d3_geo_cartesianScale(n1, c1), B = d3_geo_cartesianScale(n2, c2);
	      d3_geo_cartesianAdd(A, B);
	      var u = n1xn2, w = d3_geo_cartesianDot(A, u), uu = d3_geo_cartesianDot(u, u), t2 = w * w - uu * (d3_geo_cartesianDot(A, A) - 1);
	      if (t2 < 0) return;
	      var t = Math.sqrt(t2), q = d3_geo_cartesianScale(u, (-w - t) / uu);
	      d3_geo_cartesianAdd(q, A);
	      q = d3_geo_spherical(q);
	      if (!two) return q;
	      var λ0 = a[0], λ1 = b[0], φ0 = a[1], φ1 = b[1], z;
	      if (λ1 < λ0) z = λ0, λ0 = λ1, λ1 = z;
	      var δλ = λ1 - λ0, polar = abs(δλ - π) < ε, meridian = polar || δλ < ε;
	      if (!polar && φ1 < φ0) z = φ0, φ0 = φ1, φ1 = z;
	      if (meridian ? polar ? φ0 + φ1 > 0 ^ q[1] < (abs(q[0] - λ0) < ε ? φ0 : φ1) : φ0 <= q[1] && q[1] <= φ1 : δλ > π ^ (λ0 <= q[0] && q[0] <= λ1)) {
	        var q1 = d3_geo_cartesianScale(u, (-w + t) / uu);
	        d3_geo_cartesianAdd(q1, A);
	        return [ q, d3_geo_spherical(q1) ];
	      }
	    }
	    function code(λ, φ) {
	      var r = smallRadius ? radius : π - radius, code = 0;
	      if (λ < -r) code |= 1; else if (λ > r) code |= 2;
	      if (φ < -r) code |= 4; else if (φ > r) code |= 8;
	      return code;
	    }
	  }
	  function d3_geom_clipLine(x0, y0, x1, y1) {
	    return function(line) {
	      var a = line.a, b = line.b, ax = a.x, ay = a.y, bx = b.x, by = b.y, t0 = 0, t1 = 1, dx = bx - ax, dy = by - ay, r;
	      r = x0 - ax;
	      if (!dx && r > 0) return;
	      r /= dx;
	      if (dx < 0) {
	        if (r < t0) return;
	        if (r < t1) t1 = r;
	      } else if (dx > 0) {
	        if (r > t1) return;
	        if (r > t0) t0 = r;
	      }
	      r = x1 - ax;
	      if (!dx && r < 0) return;
	      r /= dx;
	      if (dx < 0) {
	        if (r > t1) return;
	        if (r > t0) t0 = r;
	      } else if (dx > 0) {
	        if (r < t0) return;
	        if (r < t1) t1 = r;
	      }
	      r = y0 - ay;
	      if (!dy && r > 0) return;
	      r /= dy;
	      if (dy < 0) {
	        if (r < t0) return;
	        if (r < t1) t1 = r;
	      } else if (dy > 0) {
	        if (r > t1) return;
	        if (r > t0) t0 = r;
	      }
	      r = y1 - ay;
	      if (!dy && r < 0) return;
	      r /= dy;
	      if (dy < 0) {
	        if (r > t1) return;
	        if (r > t0) t0 = r;
	      } else if (dy > 0) {
	        if (r < t0) return;
	        if (r < t1) t1 = r;
	      }
	      if (t0 > 0) line.a = {
	        x: ax + t0 * dx,
	        y: ay + t0 * dy
	      };
	      if (t1 < 1) line.b = {
	        x: ax + t1 * dx,
	        y: ay + t1 * dy
	      };
	      return line;
	    };
	  }
	  var d3_geo_clipExtentMAX = 1e9;
	  d3.geo.clipExtent = function() {
	    var x0, y0, x1, y1, stream, clip, clipExtent = {
	      stream: function(output) {
	        if (stream) stream.valid = false;
	        stream = clip(output);
	        stream.valid = true;
	        return stream;
	      },
	      extent: function(_) {
	        if (!arguments.length) return [ [ x0, y0 ], [ x1, y1 ] ];
	        clip = d3_geo_clipExtent(x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1]);
	        if (stream) stream.valid = false, stream = null;
	        return clipExtent;
	      }
	    };
	    return clipExtent.extent([ [ 0, 0 ], [ 960, 500 ] ]);
	  };
	  function d3_geo_clipExtent(x0, y0, x1, y1) {
	    return function(listener) {
	      var listener_ = listener, bufferListener = d3_geo_clipBufferListener(), clipLine = d3_geom_clipLine(x0, y0, x1, y1), segments, polygon, ring;
	      var clip = {
	        point: point,
	        lineStart: lineStart,
	        lineEnd: lineEnd,
	        polygonStart: function() {
	          listener = bufferListener;
	          segments = [];
	          polygon = [];
	          clean = true;
	        },
	        polygonEnd: function() {
	          listener = listener_;
	          segments = d3.merge(segments);
	          var clipStartInside = insidePolygon([ x0, y1 ]), inside = clean && clipStartInside, visible = segments.length;
	          if (inside || visible) {
	            listener.polygonStart();
	            if (inside) {
	              listener.lineStart();
	              interpolate(null, null, 1, listener);
	              listener.lineEnd();
	            }
	            if (visible) {
	              d3_geo_clipPolygon(segments, compare, clipStartInside, interpolate, listener);
	            }
	            listener.polygonEnd();
	          }
	          segments = polygon = ring = null;
	        }
	      };
	      function insidePolygon(p) {
	        var wn = 0, n = polygon.length, y = p[1];
	        for (var i = 0; i < n; ++i) {
	          for (var j = 1, v = polygon[i], m = v.length, a = v[0], b; j < m; ++j) {
	            b = v[j];
	            if (a[1] <= y) {
	              if (b[1] > y && d3_cross2d(a, b, p) > 0) ++wn;
	            } else {
	              if (b[1] <= y && d3_cross2d(a, b, p) < 0) --wn;
	            }
	            a = b;
	          }
	        }
	        return wn !== 0;
	      }
	      function interpolate(from, to, direction, listener) {
	        var a = 0, a1 = 0;
	        if (from == null || (a = corner(from, direction)) !== (a1 = corner(to, direction)) || comparePoints(from, to) < 0 ^ direction > 0) {
	          do {
	            listener.point(a === 0 || a === 3 ? x0 : x1, a > 1 ? y1 : y0);
	          } while ((a = (a + direction + 4) % 4) !== a1);
	        } else {
	          listener.point(to[0], to[1]);
	        }
	      }
	      function pointVisible(x, y) {
	        return x0 <= x && x <= x1 && y0 <= y && y <= y1;
	      }
	      function point(x, y) {
	        if (pointVisible(x, y)) listener.point(x, y);
	      }
	      var x__, y__, v__, x_, y_, v_, first, clean;
	      function lineStart() {
	        clip.point = linePoint;
	        if (polygon) polygon.push(ring = []);
	        first = true;
	        v_ = false;
	        x_ = y_ = NaN;
	      }
	      function lineEnd() {
	        if (segments) {
	          linePoint(x__, y__);
	          if (v__ && v_) bufferListener.rejoin();
	          segments.push(bufferListener.buffer());
	        }
	        clip.point = point;
	        if (v_) listener.lineEnd();
	      }
	      function linePoint(x, y) {
	        x = Math.max(-d3_geo_clipExtentMAX, Math.min(d3_geo_clipExtentMAX, x));
	        y = Math.max(-d3_geo_clipExtentMAX, Math.min(d3_geo_clipExtentMAX, y));
	        var v = pointVisible(x, y);
	        if (polygon) ring.push([ x, y ]);
	        if (first) {
	          x__ = x, y__ = y, v__ = v;
	          first = false;
	          if (v) {
	            listener.lineStart();
	            listener.point(x, y);
	          }
	        } else {
	          if (v && v_) listener.point(x, y); else {
	            var l = {
	              a: {
	                x: x_,
	                y: y_
	              },
	              b: {
	                x: x,
	                y: y
	              }
	            };
	            if (clipLine(l)) {
	              if (!v_) {
	                listener.lineStart();
	                listener.point(l.a.x, l.a.y);
	              }
	              listener.point(l.b.x, l.b.y);
	              if (!v) listener.lineEnd();
	              clean = false;
	            } else if (v) {
	              listener.lineStart();
	              listener.point(x, y);
	              clean = false;
	            }
	          }
	        }
	        x_ = x, y_ = y, v_ = v;
	      }
	      return clip;
	    };
	    function corner(p, direction) {
	      return abs(p[0] - x0) < ε ? direction > 0 ? 0 : 3 : abs(p[0] - x1) < ε ? direction > 0 ? 2 : 1 : abs(p[1] - y0) < ε ? direction > 0 ? 1 : 0 : direction > 0 ? 3 : 2;
	    }
	    function compare(a, b) {
	      return comparePoints(a.x, b.x);
	    }
	    function comparePoints(a, b) {
	      var ca = corner(a, 1), cb = corner(b, 1);
	      return ca !== cb ? ca - cb : ca === 0 ? b[1] - a[1] : ca === 1 ? a[0] - b[0] : ca === 2 ? a[1] - b[1] : b[0] - a[0];
	    }
	  }
	  function d3_geo_conic(projectAt) {
	    var φ0 = 0, φ1 = π / 3, m = d3_geo_projectionMutator(projectAt), p = m(φ0, φ1);
	    p.parallels = function(_) {
	      if (!arguments.length) return [ φ0 / π * 180, φ1 / π * 180 ];
	      return m(φ0 = _[0] * π / 180, φ1 = _[1] * π / 180);
	    };
	    return p;
	  }
	  function d3_geo_conicEqualArea(φ0, φ1) {
	    var sinφ0 = Math.sin(φ0), n = (sinφ0 + Math.sin(φ1)) / 2, C = 1 + sinφ0 * (2 * n - sinφ0), ρ0 = Math.sqrt(C) / n;
	    function forward(λ, φ) {
	      var ρ = Math.sqrt(C - 2 * n * Math.sin(φ)) / n;
	      return [ ρ * Math.sin(λ *= n), ρ0 - ρ * Math.cos(λ) ];
	    }
	    forward.invert = function(x, y) {
	      var ρ0_y = ρ0 - y;
	      return [ Math.atan2(x, ρ0_y) / n, d3_asin((C - (x * x + ρ0_y * ρ0_y) * n * n) / (2 * n)) ];
	    };
	    return forward;
	  }
	  (d3.geo.conicEqualArea = function() {
	    return d3_geo_conic(d3_geo_conicEqualArea);
	  }).raw = d3_geo_conicEqualArea;
	  d3.geo.albers = function() {
	    return d3.geo.conicEqualArea().rotate([ 96, 0 ]).center([ -.6, 38.7 ]).parallels([ 29.5, 45.5 ]).scale(1070);
	  };
	  d3.geo.albersUsa = function() {
	    var lower48 = d3.geo.albers();
	    var alaska = d3.geo.conicEqualArea().rotate([ 154, 0 ]).center([ -2, 58.5 ]).parallels([ 55, 65 ]);
	    var hawaii = d3.geo.conicEqualArea().rotate([ 157, 0 ]).center([ -3, 19.9 ]).parallels([ 8, 18 ]);
	    var point, pointStream = {
	      point: function(x, y) {
	        point = [ x, y ];
	      }
	    }, lower48Point, alaskaPoint, hawaiiPoint;
	    function albersUsa(coordinates) {
	      var x = coordinates[0], y = coordinates[1];
	      point = null;
	      (lower48Point(x, y), point) || (alaskaPoint(x, y), point) || hawaiiPoint(x, y);
	      return point;
	    }
	    albersUsa.invert = function(coordinates) {
	      var k = lower48.scale(), t = lower48.translate(), x = (coordinates[0] - t[0]) / k, y = (coordinates[1] - t[1]) / k;
	      return (y >= .12 && y < .234 && x >= -.425 && x < -.214 ? alaska : y >= .166 && y < .234 && x >= -.214 && x < -.115 ? hawaii : lower48).invert(coordinates);
	    };
	    albersUsa.stream = function(stream) {
	      var lower48Stream = lower48.stream(stream), alaskaStream = alaska.stream(stream), hawaiiStream = hawaii.stream(stream);
	      return {
	        point: function(x, y) {
	          lower48Stream.point(x, y);
	          alaskaStream.point(x, y);
	          hawaiiStream.point(x, y);
	        },
	        sphere: function() {
	          lower48Stream.sphere();
	          alaskaStream.sphere();
	          hawaiiStream.sphere();
	        },
	        lineStart: function() {
	          lower48Stream.lineStart();
	          alaskaStream.lineStart();
	          hawaiiStream.lineStart();
	        },
	        lineEnd: function() {
	          lower48Stream.lineEnd();
	          alaskaStream.lineEnd();
	          hawaiiStream.lineEnd();
	        },
	        polygonStart: function() {
	          lower48Stream.polygonStart();
	          alaskaStream.polygonStart();
	          hawaiiStream.polygonStart();
	        },
	        polygonEnd: function() {
	          lower48Stream.polygonEnd();
	          alaskaStream.polygonEnd();
	          hawaiiStream.polygonEnd();
	        }
	      };
	    };
	    albersUsa.precision = function(_) {
	      if (!arguments.length) return lower48.precision();
	      lower48.precision(_);
	      alaska.precision(_);
	      hawaii.precision(_);
	      return albersUsa;
	    };
	    albersUsa.scale = function(_) {
	      if (!arguments.length) return lower48.scale();
	      lower48.scale(_);
	      alaska.scale(_ * .35);
	      hawaii.scale(_);
	      return albersUsa.translate(lower48.translate());
	    };
	    albersUsa.translate = function(_) {
	      if (!arguments.length) return lower48.translate();
	      var k = lower48.scale(), x = +_[0], y = +_[1];
	      lower48Point = lower48.translate(_).clipExtent([ [ x - .455 * k, y - .238 * k ], [ x + .455 * k, y + .238 * k ] ]).stream(pointStream).point;
	      alaskaPoint = alaska.translate([ x - .307 * k, y + .201 * k ]).clipExtent([ [ x - .425 * k + ε, y + .12 * k + ε ], [ x - .214 * k - ε, y + .234 * k - ε ] ]).stream(pointStream).point;
	      hawaiiPoint = hawaii.translate([ x - .205 * k, y + .212 * k ]).clipExtent([ [ x - .214 * k + ε, y + .166 * k + ε ], [ x - .115 * k - ε, y + .234 * k - ε ] ]).stream(pointStream).point;
	      return albersUsa;
	    };
	    return albersUsa.scale(1070);
	  };
	  var d3_geo_pathAreaSum, d3_geo_pathAreaPolygon, d3_geo_pathArea = {
	    point: d3_noop,
	    lineStart: d3_noop,
	    lineEnd: d3_noop,
	    polygonStart: function() {
	      d3_geo_pathAreaPolygon = 0;
	      d3_geo_pathArea.lineStart = d3_geo_pathAreaRingStart;
	    },
	    polygonEnd: function() {
	      d3_geo_pathArea.lineStart = d3_geo_pathArea.lineEnd = d3_geo_pathArea.point = d3_noop;
	      d3_geo_pathAreaSum += abs(d3_geo_pathAreaPolygon / 2);
	    }
	  };
	  function d3_geo_pathAreaRingStart() {
	    var x00, y00, x0, y0;
	    d3_geo_pathArea.point = function(x, y) {
	      d3_geo_pathArea.point = nextPoint;
	      x00 = x0 = x, y00 = y0 = y;
	    };
	    function nextPoint(x, y) {
	      d3_geo_pathAreaPolygon += y0 * x - x0 * y;
	      x0 = x, y0 = y;
	    }
	    d3_geo_pathArea.lineEnd = function() {
	      nextPoint(x00, y00);
	    };
	  }
	  var d3_geo_pathBoundsX0, d3_geo_pathBoundsY0, d3_geo_pathBoundsX1, d3_geo_pathBoundsY1;
	  var d3_geo_pathBounds = {
	    point: d3_geo_pathBoundsPoint,
	    lineStart: d3_noop,
	    lineEnd: d3_noop,
	    polygonStart: d3_noop,
	    polygonEnd: d3_noop
	  };
	  function d3_geo_pathBoundsPoint(x, y) {
	    if (x < d3_geo_pathBoundsX0) d3_geo_pathBoundsX0 = x;
	    if (x > d3_geo_pathBoundsX1) d3_geo_pathBoundsX1 = x;
	    if (y < d3_geo_pathBoundsY0) d3_geo_pathBoundsY0 = y;
	    if (y > d3_geo_pathBoundsY1) d3_geo_pathBoundsY1 = y;
	  }
	  function d3_geo_pathBuffer() {
	    var pointCircle = d3_geo_pathBufferCircle(4.5), buffer = [];
	    var stream = {
	      point: point,
	      lineStart: function() {
	        stream.point = pointLineStart;
	      },
	      lineEnd: lineEnd,
	      polygonStart: function() {
	        stream.lineEnd = lineEndPolygon;
	      },
	      polygonEnd: function() {
	        stream.lineEnd = lineEnd;
	        stream.point = point;
	      },
	      pointRadius: function(_) {
	        pointCircle = d3_geo_pathBufferCircle(_);
	        return stream;
	      },
	      result: function() {
	        if (buffer.length) {
	          var result = buffer.join("");
	          buffer = [];
	          return result;
	        }
	      }
	    };
	    function point(x, y) {
	      buffer.push("M", x, ",", y, pointCircle);
	    }
	    function pointLineStart(x, y) {
	      buffer.push("M", x, ",", y);
	      stream.point = pointLine;
	    }
	    function pointLine(x, y) {
	      buffer.push("L", x, ",", y);
	    }
	    function lineEnd() {
	      stream.point = point;
	    }
	    function lineEndPolygon() {
	      buffer.push("Z");
	    }
	    return stream;
	  }
	  function d3_geo_pathBufferCircle(radius) {
	    return "m0," + radius + "a" + radius + "," + radius + " 0 1,1 0," + -2 * radius + "a" + radius + "," + radius + " 0 1,1 0," + 2 * radius + "z";
	  }
	  var d3_geo_pathCentroid = {
	    point: d3_geo_pathCentroidPoint,
	    lineStart: d3_geo_pathCentroidLineStart,
	    lineEnd: d3_geo_pathCentroidLineEnd,
	    polygonStart: function() {
	      d3_geo_pathCentroid.lineStart = d3_geo_pathCentroidRingStart;
	    },
	    polygonEnd: function() {
	      d3_geo_pathCentroid.point = d3_geo_pathCentroidPoint;
	      d3_geo_pathCentroid.lineStart = d3_geo_pathCentroidLineStart;
	      d3_geo_pathCentroid.lineEnd = d3_geo_pathCentroidLineEnd;
	    }
	  };
	  function d3_geo_pathCentroidPoint(x, y) {
	    d3_geo_centroidX0 += x;
	    d3_geo_centroidY0 += y;
	    ++d3_geo_centroidZ0;
	  }
	  function d3_geo_pathCentroidLineStart() {
	    var x0, y0;
	    d3_geo_pathCentroid.point = function(x, y) {
	      d3_geo_pathCentroid.point = nextPoint;
	      d3_geo_pathCentroidPoint(x0 = x, y0 = y);
	    };
	    function nextPoint(x, y) {
	      var dx = x - x0, dy = y - y0, z = Math.sqrt(dx * dx + dy * dy);
	      d3_geo_centroidX1 += z * (x0 + x) / 2;
	      d3_geo_centroidY1 += z * (y0 + y) / 2;
	      d3_geo_centroidZ1 += z;
	      d3_geo_pathCentroidPoint(x0 = x, y0 = y);
	    }
	  }
	  function d3_geo_pathCentroidLineEnd() {
	    d3_geo_pathCentroid.point = d3_geo_pathCentroidPoint;
	  }
	  function d3_geo_pathCentroidRingStart() {
	    var x00, y00, x0, y0;
	    d3_geo_pathCentroid.point = function(x, y) {
	      d3_geo_pathCentroid.point = nextPoint;
	      d3_geo_pathCentroidPoint(x00 = x0 = x, y00 = y0 = y);
	    };
	    function nextPoint(x, y) {
	      var dx = x - x0, dy = y - y0, z = Math.sqrt(dx * dx + dy * dy);
	      d3_geo_centroidX1 += z * (x0 + x) / 2;
	      d3_geo_centroidY1 += z * (y0 + y) / 2;
	      d3_geo_centroidZ1 += z;
	      z = y0 * x - x0 * y;
	      d3_geo_centroidX2 += z * (x0 + x);
	      d3_geo_centroidY2 += z * (y0 + y);
	      d3_geo_centroidZ2 += z * 3;
	      d3_geo_pathCentroidPoint(x0 = x, y0 = y);
	    }
	    d3_geo_pathCentroid.lineEnd = function() {
	      nextPoint(x00, y00);
	    };
	  }
	  function d3_geo_pathContext(context) {
	    var pointRadius = 4.5;
	    var stream = {
	      point: point,
	      lineStart: function() {
	        stream.point = pointLineStart;
	      },
	      lineEnd: lineEnd,
	      polygonStart: function() {
	        stream.lineEnd = lineEndPolygon;
	      },
	      polygonEnd: function() {
	        stream.lineEnd = lineEnd;
	        stream.point = point;
	      },
	      pointRadius: function(_) {
	        pointRadius = _;
	        return stream;
	      },
	      result: d3_noop
	    };
	    function point(x, y) {
	      context.moveTo(x + pointRadius, y);
	      context.arc(x, y, pointRadius, 0, τ);
	    }
	    function pointLineStart(x, y) {
	      context.moveTo(x, y);
	      stream.point = pointLine;
	    }
	    function pointLine(x, y) {
	      context.lineTo(x, y);
	    }
	    function lineEnd() {
	      stream.point = point;
	    }
	    function lineEndPolygon() {
	      context.closePath();
	    }
	    return stream;
	  }
	  function d3_geo_resample(project) {
	    var δ2 = .5, cosMinDistance = Math.cos(30 * d3_radians), maxDepth = 16;
	    function resample(stream) {
	      return (maxDepth ? resampleRecursive : resampleNone)(stream);
	    }
	    function resampleNone(stream) {
	      return d3_geo_transformPoint(stream, function(x, y) {
	        x = project(x, y);
	        stream.point(x[0], x[1]);
	      });
	    }
	    function resampleRecursive(stream) {
	      var λ00, φ00, x00, y00, a00, b00, c00, λ0, x0, y0, a0, b0, c0;
	      var resample = {
	        point: point,
	        lineStart: lineStart,
	        lineEnd: lineEnd,
	        polygonStart: function() {
	          stream.polygonStart();
	          resample.lineStart = ringStart;
	        },
	        polygonEnd: function() {
	          stream.polygonEnd();
	          resample.lineStart = lineStart;
	        }
	      };
	      function point(x, y) {
	        x = project(x, y);
	        stream.point(x[0], x[1]);
	      }
	      function lineStart() {
	        x0 = NaN;
	        resample.point = linePoint;
	        stream.lineStart();
	      }
	      function linePoint(λ, φ) {
	        var c = d3_geo_cartesian([ λ, φ ]), p = project(λ, φ);
	        resampleLineTo(x0, y0, λ0, a0, b0, c0, x0 = p[0], y0 = p[1], λ0 = λ, a0 = c[0], b0 = c[1], c0 = c[2], maxDepth, stream);
	        stream.point(x0, y0);
	      }
	      function lineEnd() {
	        resample.point = point;
	        stream.lineEnd();
	      }
	      function ringStart() {
	        lineStart();
	        resample.point = ringPoint;
	        resample.lineEnd = ringEnd;
	      }
	      function ringPoint(λ, φ) {
	        linePoint(λ00 = λ, φ00 = φ), x00 = x0, y00 = y0, a00 = a0, b00 = b0, c00 = c0;
	        resample.point = linePoint;
	      }
	      function ringEnd() {
	        resampleLineTo(x0, y0, λ0, a0, b0, c0, x00, y00, λ00, a00, b00, c00, maxDepth, stream);
	        resample.lineEnd = lineEnd;
	        lineEnd();
	      }
	      return resample;
	    }
	    function resampleLineTo(x0, y0, λ0, a0, b0, c0, x1, y1, λ1, a1, b1, c1, depth, stream) {
	      var dx = x1 - x0, dy = y1 - y0, d2 = dx * dx + dy * dy;
	      if (d2 > 4 * δ2 && depth--) {
	        var a = a0 + a1, b = b0 + b1, c = c0 + c1, m = Math.sqrt(a * a + b * b + c * c), φ2 = Math.asin(c /= m), λ2 = abs(abs(c) - 1) < ε || abs(λ0 - λ1) < ε ? (λ0 + λ1) / 2 : Math.atan2(b, a), p = project(λ2, φ2), x2 = p[0], y2 = p[1], dx2 = x2 - x0, dy2 = y2 - y0, dz = dy * dx2 - dx * dy2;
	        if (dz * dz / d2 > δ2 || abs((dx * dx2 + dy * dy2) / d2 - .5) > .3 || a0 * a1 + b0 * b1 + c0 * c1 < cosMinDistance) {
	          resampleLineTo(x0, y0, λ0, a0, b0, c0, x2, y2, λ2, a /= m, b /= m, c, depth, stream);
	          stream.point(x2, y2);
	          resampleLineTo(x2, y2, λ2, a, b, c, x1, y1, λ1, a1, b1, c1, depth, stream);
	        }
	      }
	    }
	    resample.precision = function(_) {
	      if (!arguments.length) return Math.sqrt(δ2);
	      maxDepth = (δ2 = _ * _) > 0 && 16;
	      return resample;
	    };
	    return resample;
	  }
	  d3.geo.path = function() {
	    var pointRadius = 4.5, projection, context, projectStream, contextStream, cacheStream;
	    function path(object) {
	      if (object) {
	        if (typeof pointRadius === "function") contextStream.pointRadius(+pointRadius.apply(this, arguments));
	        if (!cacheStream || !cacheStream.valid) cacheStream = projectStream(contextStream);
	        d3.geo.stream(object, cacheStream);
	      }
	      return contextStream.result();
	    }
	    path.area = function(object) {
	      d3_geo_pathAreaSum = 0;
	      d3.geo.stream(object, projectStream(d3_geo_pathArea));
	      return d3_geo_pathAreaSum;
	    };
	    path.centroid = function(object) {
	      d3_geo_centroidX0 = d3_geo_centroidY0 = d3_geo_centroidZ0 = d3_geo_centroidX1 = d3_geo_centroidY1 = d3_geo_centroidZ1 = d3_geo_centroidX2 = d3_geo_centroidY2 = d3_geo_centroidZ2 = 0;
	      d3.geo.stream(object, projectStream(d3_geo_pathCentroid));
	      return d3_geo_centroidZ2 ? [ d3_geo_centroidX2 / d3_geo_centroidZ2, d3_geo_centroidY2 / d3_geo_centroidZ2 ] : d3_geo_centroidZ1 ? [ d3_geo_centroidX1 / d3_geo_centroidZ1, d3_geo_centroidY1 / d3_geo_centroidZ1 ] : d3_geo_centroidZ0 ? [ d3_geo_centroidX0 / d3_geo_centroidZ0, d3_geo_centroidY0 / d3_geo_centroidZ0 ] : [ NaN, NaN ];
	    };
	    path.bounds = function(object) {
	      d3_geo_pathBoundsX1 = d3_geo_pathBoundsY1 = -(d3_geo_pathBoundsX0 = d3_geo_pathBoundsY0 = Infinity);
	      d3.geo.stream(object, projectStream(d3_geo_pathBounds));
	      return [ [ d3_geo_pathBoundsX0, d3_geo_pathBoundsY0 ], [ d3_geo_pathBoundsX1, d3_geo_pathBoundsY1 ] ];
	    };
	    path.projection = function(_) {
	      if (!arguments.length) return projection;
	      projectStream = (projection = _) ? _.stream || d3_geo_pathProjectStream(_) : d3_identity;
	      return reset();
	    };
	    path.context = function(_) {
	      if (!arguments.length) return context;
	      contextStream = (context = _) == null ? new d3_geo_pathBuffer() : new d3_geo_pathContext(_);
	      if (typeof pointRadius !== "function") contextStream.pointRadius(pointRadius);
	      return reset();
	    };
	    path.pointRadius = function(_) {
	      if (!arguments.length) return pointRadius;
	      pointRadius = typeof _ === "function" ? _ : (contextStream.pointRadius(+_), +_);
	      return path;
	    };
	    function reset() {
	      cacheStream = null;
	      return path;
	    }
	    return path.projection(d3.geo.albersUsa()).context(null);
	  };
	  function d3_geo_pathProjectStream(project) {
	    var resample = d3_geo_resample(function(x, y) {
	      return project([ x * d3_degrees, y * d3_degrees ]);
	    });
	    return function(stream) {
	      return d3_geo_projectionRadians(resample(stream));
	    };
	  }
	  d3.geo.transform = function(methods) {
	    return {
	      stream: function(stream) {
	        var transform = new d3_geo_transform(stream);
	        for (var k in methods) transform[k] = methods[k];
	        return transform;
	      }
	    };
	  };
	  function d3_geo_transform(stream) {
	    this.stream = stream;
	  }
	  d3_geo_transform.prototype = {
	    point: function(x, y) {
	      this.stream.point(x, y);
	    },
	    sphere: function() {
	      this.stream.sphere();
	    },
	    lineStart: function() {
	      this.stream.lineStart();
	    },
	    lineEnd: function() {
	      this.stream.lineEnd();
	    },
	    polygonStart: function() {
	      this.stream.polygonStart();
	    },
	    polygonEnd: function() {
	      this.stream.polygonEnd();
	    }
	  };
	  function d3_geo_transformPoint(stream, point) {
	    return {
	      point: point,
	      sphere: function() {
	        stream.sphere();
	      },
	      lineStart: function() {
	        stream.lineStart();
	      },
	      lineEnd: function() {
	        stream.lineEnd();
	      },
	      polygonStart: function() {
	        stream.polygonStart();
	      },
	      polygonEnd: function() {
	        stream.polygonEnd();
	      }
	    };
	  }
	  d3.geo.projection = d3_geo_projection;
	  d3.geo.projectionMutator = d3_geo_projectionMutator;
	  function d3_geo_projection(project) {
	    return d3_geo_projectionMutator(function() {
	      return project;
	    })();
	  }
	  function d3_geo_projectionMutator(projectAt) {
	    var project, rotate, projectRotate, projectResample = d3_geo_resample(function(x, y) {
	      x = project(x, y);
	      return [ x[0] * k + δx, δy - x[1] * k ];
	    }), k = 150, x = 480, y = 250, λ = 0, φ = 0, δλ = 0, δφ = 0, δγ = 0, δx, δy, preclip = d3_geo_clipAntimeridian, postclip = d3_identity, clipAngle = null, clipExtent = null, stream;
	    function projection(point) {
	      point = projectRotate(point[0] * d3_radians, point[1] * d3_radians);
	      return [ point[0] * k + δx, δy - point[1] * k ];
	    }
	    function invert(point) {
	      point = projectRotate.invert((point[0] - δx) / k, (δy - point[1]) / k);
	      return point && [ point[0] * d3_degrees, point[1] * d3_degrees ];
	    }
	    projection.stream = function(output) {
	      if (stream) stream.valid = false;
	      stream = d3_geo_projectionRadians(preclip(rotate, projectResample(postclip(output))));
	      stream.valid = true;
	      return stream;
	    };
	    projection.clipAngle = function(_) {
	      if (!arguments.length) return clipAngle;
	      preclip = _ == null ? (clipAngle = _, d3_geo_clipAntimeridian) : d3_geo_clipCircle((clipAngle = +_) * d3_radians);
	      return invalidate();
	    };
	    projection.clipExtent = function(_) {
	      if (!arguments.length) return clipExtent;
	      clipExtent = _;
	      postclip = _ ? d3_geo_clipExtent(_[0][0], _[0][1], _[1][0], _[1][1]) : d3_identity;
	      return invalidate();
	    };
	    projection.scale = function(_) {
	      if (!arguments.length) return k;
	      k = +_;
	      return reset();
	    };
	    projection.translate = function(_) {
	      if (!arguments.length) return [ x, y ];
	      x = +_[0];
	      y = +_[1];
	      return reset();
	    };
	    projection.center = function(_) {
	      if (!arguments.length) return [ λ * d3_degrees, φ * d3_degrees ];
	      λ = _[0] % 360 * d3_radians;
	      φ = _[1] % 360 * d3_radians;
	      return reset();
	    };
	    projection.rotate = function(_) {
	      if (!arguments.length) return [ δλ * d3_degrees, δφ * d3_degrees, δγ * d3_degrees ];
	      δλ = _[0] % 360 * d3_radians;
	      δφ = _[1] % 360 * d3_radians;
	      δγ = _.length > 2 ? _[2] % 360 * d3_radians : 0;
	      return reset();
	    };
	    d3.rebind(projection, projectResample, "precision");
	    function reset() {
	      projectRotate = d3_geo_compose(rotate = d3_geo_rotation(δλ, δφ, δγ), project);
	      var center = project(λ, φ);
	      δx = x - center[0] * k;
	      δy = y + center[1] * k;
	      return invalidate();
	    }
	    function invalidate() {
	      if (stream) stream.valid = false, stream = null;
	      return projection;
	    }
	    return function() {
	      project = projectAt.apply(this, arguments);
	      projection.invert = project.invert && invert;
	      return reset();
	    };
	  }
	  function d3_geo_projectionRadians(stream) {
	    return d3_geo_transformPoint(stream, function(x, y) {
	      stream.point(x * d3_radians, y * d3_radians);
	    });
	  }
	  function d3_geo_equirectangular(λ, φ) {
	    return [ λ, φ ];
	  }
	  (d3.geo.equirectangular = function() {
	    return d3_geo_projection(d3_geo_equirectangular);
	  }).raw = d3_geo_equirectangular.invert = d3_geo_equirectangular;
	  d3.geo.rotation = function(rotate) {
	    rotate = d3_geo_rotation(rotate[0] % 360 * d3_radians, rotate[1] * d3_radians, rotate.length > 2 ? rotate[2] * d3_radians : 0);
	    function forward(coordinates) {
	      coordinates = rotate(coordinates[0] * d3_radians, coordinates[1] * d3_radians);
	      return coordinates[0] *= d3_degrees, coordinates[1] *= d3_degrees, coordinates;
	    }
	    forward.invert = function(coordinates) {
	      coordinates = rotate.invert(coordinates[0] * d3_radians, coordinates[1] * d3_radians);
	      return coordinates[0] *= d3_degrees, coordinates[1] *= d3_degrees, coordinates;
	    };
	    return forward;
	  };
	  function d3_geo_identityRotation(λ, φ) {
	    return [ λ > π ? λ - τ : λ < -π ? λ + τ : λ, φ ];
	  }
	  d3_geo_identityRotation.invert = d3_geo_equirectangular;
	  function d3_geo_rotation(δλ, δφ, δγ) {
	    return δλ ? δφ || δγ ? d3_geo_compose(d3_geo_rotationλ(δλ), d3_geo_rotationφγ(δφ, δγ)) : d3_geo_rotationλ(δλ) : δφ || δγ ? d3_geo_rotationφγ(δφ, δγ) : d3_geo_identityRotation;
	  }
	  function d3_geo_forwardRotationλ(δλ) {
	    return function(λ, φ) {
	      return λ += δλ, [ λ > π ? λ - τ : λ < -π ? λ + τ : λ, φ ];
	    };
	  }
	  function d3_geo_rotationλ(δλ) {
	    var rotation = d3_geo_forwardRotationλ(δλ);
	    rotation.invert = d3_geo_forwardRotationλ(-δλ);
	    return rotation;
	  }
	  function d3_geo_rotationφγ(δφ, δγ) {
	    var cosδφ = Math.cos(δφ), sinδφ = Math.sin(δφ), cosδγ = Math.cos(δγ), sinδγ = Math.sin(δγ);
	    function rotation(λ, φ) {
	      var cosφ = Math.cos(φ), x = Math.cos(λ) * cosφ, y = Math.sin(λ) * cosφ, z = Math.sin(φ), k = z * cosδφ + x * sinδφ;
	      return [ Math.atan2(y * cosδγ - k * sinδγ, x * cosδφ - z * sinδφ), d3_asin(k * cosδγ + y * sinδγ) ];
	    }
	    rotation.invert = function(λ, φ) {
	      var cosφ = Math.cos(φ), x = Math.cos(λ) * cosφ, y = Math.sin(λ) * cosφ, z = Math.sin(φ), k = z * cosδγ - y * sinδγ;
	      return [ Math.atan2(y * cosδγ + z * sinδγ, x * cosδφ + k * sinδφ), d3_asin(k * cosδφ - x * sinδφ) ];
	    };
	    return rotation;
	  }
	  d3.geo.circle = function() {
	    var origin = [ 0, 0 ], angle, precision = 6, interpolate;
	    function circle() {
	      var center = typeof origin === "function" ? origin.apply(this, arguments) : origin, rotate = d3_geo_rotation(-center[0] * d3_radians, -center[1] * d3_radians, 0).invert, ring = [];
	      interpolate(null, null, 1, {
	        point: function(x, y) {
	          ring.push(x = rotate(x, y));
	          x[0] *= d3_degrees, x[1] *= d3_degrees;
	        }
	      });
	      return {
	        type: "Polygon",
	        coordinates: [ ring ]
	      };
	    }
	    circle.origin = function(x) {
	      if (!arguments.length) return origin;
	      origin = x;
	      return circle;
	    };
	    circle.angle = function(x) {
	      if (!arguments.length) return angle;
	      interpolate = d3_geo_circleInterpolate((angle = +x) * d3_radians, precision * d3_radians);
	      return circle;
	    };
	    circle.precision = function(_) {
	      if (!arguments.length) return precision;
	      interpolate = d3_geo_circleInterpolate(angle * d3_radians, (precision = +_) * d3_radians);
	      return circle;
	    };
	    return circle.angle(90);
	  };
	  function d3_geo_circleInterpolate(radius, precision) {
	    var cr = Math.cos(radius), sr = Math.sin(radius);
	    return function(from, to, direction, listener) {
	      var step = direction * precision;
	      if (from != null) {
	        from = d3_geo_circleAngle(cr, from);
	        to = d3_geo_circleAngle(cr, to);
	        if (direction > 0 ? from < to : from > to) from += direction * τ;
	      } else {
	        from = radius + direction * τ;
	        to = radius - .5 * step;
	      }
	      for (var point, t = from; direction > 0 ? t > to : t < to; t -= step) {
	        listener.point((point = d3_geo_spherical([ cr, -sr * Math.cos(t), -sr * Math.sin(t) ]))[0], point[1]);
	      }
	    };
	  }
	  function d3_geo_circleAngle(cr, point) {
	    var a = d3_geo_cartesian(point);
	    a[0] -= cr;
	    d3_geo_cartesianNormalize(a);
	    var angle = d3_acos(-a[1]);
	    return ((-a[2] < 0 ? -angle : angle) + 2 * Math.PI - ε) % (2 * Math.PI);
	  }
	  d3.geo.distance = function(a, b) {
	    var Δλ = (b[0] - a[0]) * d3_radians, φ0 = a[1] * d3_radians, φ1 = b[1] * d3_radians, sinΔλ = Math.sin(Δλ), cosΔλ = Math.cos(Δλ), sinφ0 = Math.sin(φ0), cosφ0 = Math.cos(φ0), sinφ1 = Math.sin(φ1), cosφ1 = Math.cos(φ1), t;
	    return Math.atan2(Math.sqrt((t = cosφ1 * sinΔλ) * t + (t = cosφ0 * sinφ1 - sinφ0 * cosφ1 * cosΔλ) * t), sinφ0 * sinφ1 + cosφ0 * cosφ1 * cosΔλ);
	  };
	  d3.geo.graticule = function() {
	    var x1, x0, X1, X0, y1, y0, Y1, Y0, dx = 10, dy = dx, DX = 90, DY = 360, x, y, X, Y, precision = 2.5;
	    function graticule() {
	      return {
	        type: "MultiLineString",
	        coordinates: lines()
	      };
	    }
	    function lines() {
	      return d3.range(Math.ceil(X0 / DX) * DX, X1, DX).map(X).concat(d3.range(Math.ceil(Y0 / DY) * DY, Y1, DY).map(Y)).concat(d3.range(Math.ceil(x0 / dx) * dx, x1, dx).filter(function(x) {
	        return abs(x % DX) > ε;
	      }).map(x)).concat(d3.range(Math.ceil(y0 / dy) * dy, y1, dy).filter(function(y) {
	        return abs(y % DY) > ε;
	      }).map(y));
	    }
	    graticule.lines = function() {
	      return lines().map(function(coordinates) {
	        return {
	          type: "LineString",
	          coordinates: coordinates
	        };
	      });
	    };
	    graticule.outline = function() {
	      return {
	        type: "Polygon",
	        coordinates: [ X(X0).concat(Y(Y1).slice(1), X(X1).reverse().slice(1), Y(Y0).reverse().slice(1)) ]
	      };
	    };
	    graticule.extent = function(_) {
	      if (!arguments.length) return graticule.minorExtent();
	      return graticule.majorExtent(_).minorExtent(_);
	    };
	    graticule.majorExtent = function(_) {
	      if (!arguments.length) return [ [ X0, Y0 ], [ X1, Y1 ] ];
	      X0 = +_[0][0], X1 = +_[1][0];
	      Y0 = +_[0][1], Y1 = +_[1][1];
	      if (X0 > X1) _ = X0, X0 = X1, X1 = _;
	      if (Y0 > Y1) _ = Y0, Y0 = Y1, Y1 = _;
	      return graticule.precision(precision);
	    };
	    graticule.minorExtent = function(_) {
	      if (!arguments.length) return [ [ x0, y0 ], [ x1, y1 ] ];
	      x0 = +_[0][0], x1 = +_[1][0];
	      y0 = +_[0][1], y1 = +_[1][1];
	      if (x0 > x1) _ = x0, x0 = x1, x1 = _;
	      if (y0 > y1) _ = y0, y0 = y1, y1 = _;
	      return graticule.precision(precision);
	    };
	    graticule.step = function(_) {
	      if (!arguments.length) return graticule.minorStep();
	      return graticule.majorStep(_).minorStep(_);
	    };
	    graticule.majorStep = function(_) {
	      if (!arguments.length) return [ DX, DY ];
	      DX = +_[0], DY = +_[1];
	      return graticule;
	    };
	    graticule.minorStep = function(_) {
	      if (!arguments.length) return [ dx, dy ];
	      dx = +_[0], dy = +_[1];
	      return graticule;
	    };
	    graticule.precision = function(_) {
	      if (!arguments.length) return precision;
	      precision = +_;
	      x = d3_geo_graticuleX(y0, y1, 90);
	      y = d3_geo_graticuleY(x0, x1, precision);
	      X = d3_geo_graticuleX(Y0, Y1, 90);
	      Y = d3_geo_graticuleY(X0, X1, precision);
	      return graticule;
	    };
	    return graticule.majorExtent([ [ -180, -90 + ε ], [ 180, 90 - ε ] ]).minorExtent([ [ -180, -80 - ε ], [ 180, 80 + ε ] ]);
	  };
	  function d3_geo_graticuleX(y0, y1, dy) {
	    var y = d3.range(y0, y1 - ε, dy).concat(y1);
	    return function(x) {
	      return y.map(function(y) {
	        return [ x, y ];
	      });
	    };
	  }
	  function d3_geo_graticuleY(x0, x1, dx) {
	    var x = d3.range(x0, x1 - ε, dx).concat(x1);
	    return function(y) {
	      return x.map(function(x) {
	        return [ x, y ];
	      });
	    };
	  }
	  function d3_source(d) {
	    return d.source;
	  }
	  function d3_target(d) {
	    return d.target;
	  }
	  d3.geo.greatArc = function() {
	    var source = d3_source, source_, target = d3_target, target_;
	    function greatArc() {
	      return {
	        type: "LineString",
	        coordinates: [ source_ || source.apply(this, arguments), target_ || target.apply(this, arguments) ]
	      };
	    }
	    greatArc.distance = function() {
	      return d3.geo.distance(source_ || source.apply(this, arguments), target_ || target.apply(this, arguments));
	    };
	    greatArc.source = function(_) {
	      if (!arguments.length) return source;
	      source = _, source_ = typeof _ === "function" ? null : _;
	      return greatArc;
	    };
	    greatArc.target = function(_) {
	      if (!arguments.length) return target;
	      target = _, target_ = typeof _ === "function" ? null : _;
	      return greatArc;
	    };
	    greatArc.precision = function() {
	      return arguments.length ? greatArc : 0;
	    };
	    return greatArc;
	  };
	  d3.geo.interpolate = function(source, target) {
	    return d3_geo_interpolate(source[0] * d3_radians, source[1] * d3_radians, target[0] * d3_radians, target[1] * d3_radians);
	  };
	  function d3_geo_interpolate(x0, y0, x1, y1) {
	    var cy0 = Math.cos(y0), sy0 = Math.sin(y0), cy1 = Math.cos(y1), sy1 = Math.sin(y1), kx0 = cy0 * Math.cos(x0), ky0 = cy0 * Math.sin(x0), kx1 = cy1 * Math.cos(x1), ky1 = cy1 * Math.sin(x1), d = 2 * Math.asin(Math.sqrt(d3_haversin(y1 - y0) + cy0 * cy1 * d3_haversin(x1 - x0))), k = 1 / Math.sin(d);
	    var interpolate = d ? function(t) {
	      var B = Math.sin(t *= d) * k, A = Math.sin(d - t) * k, x = A * kx0 + B * kx1, y = A * ky0 + B * ky1, z = A * sy0 + B * sy1;
	      return [ Math.atan2(y, x) * d3_degrees, Math.atan2(z, Math.sqrt(x * x + y * y)) * d3_degrees ];
	    } : function() {
	      return [ x0 * d3_degrees, y0 * d3_degrees ];
	    };
	    interpolate.distance = d;
	    return interpolate;
	  }
	  d3.geo.length = function(object) {
	    d3_geo_lengthSum = 0;
	    d3.geo.stream(object, d3_geo_length);
	    return d3_geo_lengthSum;
	  };
	  var d3_geo_lengthSum;
	  var d3_geo_length = {
	    sphere: d3_noop,
	    point: d3_noop,
	    lineStart: d3_geo_lengthLineStart,
	    lineEnd: d3_noop,
	    polygonStart: d3_noop,
	    polygonEnd: d3_noop
	  };
	  function d3_geo_lengthLineStart() {
	    var λ0, sinφ0, cosφ0;
	    d3_geo_length.point = function(λ, φ) {
	      λ0 = λ * d3_radians, sinφ0 = Math.sin(φ *= d3_radians), cosφ0 = Math.cos(φ);
	      d3_geo_length.point = nextPoint;
	    };
	    d3_geo_length.lineEnd = function() {
	      d3_geo_length.point = d3_geo_length.lineEnd = d3_noop;
	    };
	    function nextPoint(λ, φ) {
	      var sinφ = Math.sin(φ *= d3_radians), cosφ = Math.cos(φ), t = abs((λ *= d3_radians) - λ0), cosΔλ = Math.cos(t);
	      d3_geo_lengthSum += Math.atan2(Math.sqrt((t = cosφ * Math.sin(t)) * t + (t = cosφ0 * sinφ - sinφ0 * cosφ * cosΔλ) * t), sinφ0 * sinφ + cosφ0 * cosφ * cosΔλ);
	      λ0 = λ, sinφ0 = sinφ, cosφ0 = cosφ;
	    }
	  }
	  function d3_geo_azimuthal(scale, angle) {
	    function azimuthal(λ, φ) {
	      var cosλ = Math.cos(λ), cosφ = Math.cos(φ), k = scale(cosλ * cosφ);
	      return [ k * cosφ * Math.sin(λ), k * Math.sin(φ) ];
	    }
	    azimuthal.invert = function(x, y) {
	      var ρ = Math.sqrt(x * x + y * y), c = angle(ρ), sinc = Math.sin(c), cosc = Math.cos(c);
	      return [ Math.atan2(x * sinc, ρ * cosc), Math.asin(ρ && y * sinc / ρ) ];
	    };
	    return azimuthal;
	  }
	  var d3_geo_azimuthalEqualArea = d3_geo_azimuthal(function(cosλcosφ) {
	    return Math.sqrt(2 / (1 + cosλcosφ));
	  }, function(ρ) {
	    return 2 * Math.asin(ρ / 2);
	  });
	  (d3.geo.azimuthalEqualArea = function() {
	    return d3_geo_projection(d3_geo_azimuthalEqualArea);
	  }).raw = d3_geo_azimuthalEqualArea;
	  var d3_geo_azimuthalEquidistant = d3_geo_azimuthal(function(cosλcosφ) {
	    var c = Math.acos(cosλcosφ);
	    return c && c / Math.sin(c);
	  }, d3_identity);
	  (d3.geo.azimuthalEquidistant = function() {
	    return d3_geo_projection(d3_geo_azimuthalEquidistant);
	  }).raw = d3_geo_azimuthalEquidistant;
	  function d3_geo_conicConformal(φ0, φ1) {
	    var cosφ0 = Math.cos(φ0), t = function(φ) {
	      return Math.tan(π / 4 + φ / 2);
	    }, n = φ0 === φ1 ? Math.sin(φ0) : Math.log(cosφ0 / Math.cos(φ1)) / Math.log(t(φ1) / t(φ0)), F = cosφ0 * Math.pow(t(φ0), n) / n;
	    if (!n) return d3_geo_mercator;
	    function forward(λ, φ) {
	      if (F > 0) {
	        if (φ < -halfπ + ε) φ = -halfπ + ε;
	      } else {
	        if (φ > halfπ - ε) φ = halfπ - ε;
	      }
	      var ρ = F / Math.pow(t(φ), n);
	      return [ ρ * Math.sin(n * λ), F - ρ * Math.cos(n * λ) ];
	    }
	    forward.invert = function(x, y) {
	      var ρ0_y = F - y, ρ = d3_sgn(n) * Math.sqrt(x * x + ρ0_y * ρ0_y);
	      return [ Math.atan2(x, ρ0_y) / n, 2 * Math.atan(Math.pow(F / ρ, 1 / n)) - halfπ ];
	    };
	    return forward;
	  }
	  (d3.geo.conicConformal = function() {
	    return d3_geo_conic(d3_geo_conicConformal);
	  }).raw = d3_geo_conicConformal;
	  function d3_geo_conicEquidistant(φ0, φ1) {
	    var cosφ0 = Math.cos(φ0), n = φ0 === φ1 ? Math.sin(φ0) : (cosφ0 - Math.cos(φ1)) / (φ1 - φ0), G = cosφ0 / n + φ0;
	    if (abs(n) < ε) return d3_geo_equirectangular;
	    function forward(λ, φ) {
	      var ρ = G - φ;
	      return [ ρ * Math.sin(n * λ), G - ρ * Math.cos(n * λ) ];
	    }
	    forward.invert = function(x, y) {
	      var ρ0_y = G - y;
	      return [ Math.atan2(x, ρ0_y) / n, G - d3_sgn(n) * Math.sqrt(x * x + ρ0_y * ρ0_y) ];
	    };
	    return forward;
	  }
	  (d3.geo.conicEquidistant = function() {
	    return d3_geo_conic(d3_geo_conicEquidistant);
	  }).raw = d3_geo_conicEquidistant;
	  var d3_geo_gnomonic = d3_geo_azimuthal(function(cosλcosφ) {
	    return 1 / cosλcosφ;
	  }, Math.atan);
	  (d3.geo.gnomonic = function() {
	    return d3_geo_projection(d3_geo_gnomonic);
	  }).raw = d3_geo_gnomonic;
	  function d3_geo_mercator(λ, φ) {
	    return [ λ, Math.log(Math.tan(π / 4 + φ / 2)) ];
	  }
	  d3_geo_mercator.invert = function(x, y) {
	    return [ x, 2 * Math.atan(Math.exp(y)) - halfπ ];
	  };
	  function d3_geo_mercatorProjection(project) {
	    var m = d3_geo_projection(project), scale = m.scale, translate = m.translate, clipExtent = m.clipExtent, clipAuto;
	    m.scale = function() {
	      var v = scale.apply(m, arguments);
	      return v === m ? clipAuto ? m.clipExtent(null) : m : v;
	    };
	    m.translate = function() {
	      var v = translate.apply(m, arguments);
	      return v === m ? clipAuto ? m.clipExtent(null) : m : v;
	    };
	    m.clipExtent = function(_) {
	      var v = clipExtent.apply(m, arguments);
	      if (v === m) {
	        if (clipAuto = _ == null) {
	          var k = π * scale(), t = translate();
	          clipExtent([ [ t[0] - k, t[1] - k ], [ t[0] + k, t[1] + k ] ]);
	        }
	      } else if (clipAuto) {
	        v = null;
	      }
	      return v;
	    };
	    return m.clipExtent(null);
	  }
	  (d3.geo.mercator = function() {
	    return d3_geo_mercatorProjection(d3_geo_mercator);
	  }).raw = d3_geo_mercator;
	  var d3_geo_orthographic = d3_geo_azimuthal(function() {
	    return 1;
	  }, Math.asin);
	  (d3.geo.orthographic = function() {
	    return d3_geo_projection(d3_geo_orthographic);
	  }).raw = d3_geo_orthographic;
	  var d3_geo_stereographic = d3_geo_azimuthal(function(cosλcosφ) {
	    return 1 / (1 + cosλcosφ);
	  }, function(ρ) {
	    return 2 * Math.atan(ρ);
	  });
	  (d3.geo.stereographic = function() {
	    return d3_geo_projection(d3_geo_stereographic);
	  }).raw = d3_geo_stereographic;
	  function d3_geo_transverseMercator(λ, φ) {
	    return [ Math.log(Math.tan(π / 4 + φ / 2)), -λ ];
	  }
	  d3_geo_transverseMercator.invert = function(x, y) {
	    return [ -y, 2 * Math.atan(Math.exp(x)) - halfπ ];
	  };
	  (d3.geo.transverseMercator = function() {
	    var projection = d3_geo_mercatorProjection(d3_geo_transverseMercator), center = projection.center, rotate = projection.rotate;
	    projection.center = function(_) {
	      return _ ? center([ -_[1], _[0] ]) : (_ = center(), [ _[1], -_[0] ]);
	    };
	    projection.rotate = function(_) {
	      return _ ? rotate([ _[0], _[1], _.length > 2 ? _[2] + 90 : 90 ]) : (_ = rotate(), 
	      [ _[0], _[1], _[2] - 90 ]);
	    };
	    return rotate([ 0, 0, 90 ]);
	  }).raw = d3_geo_transverseMercator;
	  d3.geom = {};
	  function d3_geom_pointX(d) {
	    return d[0];
	  }
	  function d3_geom_pointY(d) {
	    return d[1];
	  }
	  d3.geom.hull = function(vertices) {
	    var x = d3_geom_pointX, y = d3_geom_pointY;
	    if (arguments.length) return hull(vertices);
	    function hull(data) {
	      if (data.length < 3) return [];
	      var fx = d3_functor(x), fy = d3_functor(y), i, n = data.length, points = [], flippedPoints = [];
	      for (i = 0; i < n; i++) {
	        points.push([ +fx.call(this, data[i], i), +fy.call(this, data[i], i), i ]);
	      }
	      points.sort(d3_geom_hullOrder);
	      for (i = 0; i < n; i++) flippedPoints.push([ points[i][0], -points[i][1] ]);
	      var upper = d3_geom_hullUpper(points), lower = d3_geom_hullUpper(flippedPoints);
	      var skipLeft = lower[0] === upper[0], skipRight = lower[lower.length - 1] === upper[upper.length - 1], polygon = [];
	      for (i = upper.length - 1; i >= 0; --i) polygon.push(data[points[upper[i]][2]]);
	      for (i = +skipLeft; i < lower.length - skipRight; ++i) polygon.push(data[points[lower[i]][2]]);
	      return polygon;
	    }
	    hull.x = function(_) {
	      return arguments.length ? (x = _, hull) : x;
	    };
	    hull.y = function(_) {
	      return arguments.length ? (y = _, hull) : y;
	    };
	    return hull;
	  };
	  function d3_geom_hullUpper(points) {
	    var n = points.length, hull = [ 0, 1 ], hs = 2;
	    for (var i = 2; i < n; i++) {
	      while (hs > 1 && d3_cross2d(points[hull[hs - 2]], points[hull[hs - 1]], points[i]) <= 0) --hs;
	      hull[hs++] = i;
	    }
	    return hull.slice(0, hs);
	  }
	  function d3_geom_hullOrder(a, b) {
	    return a[0] - b[0] || a[1] - b[1];
	  }
	  d3.geom.polygon = function(coordinates) {
	    d3_subclass(coordinates, d3_geom_polygonPrototype);
	    return coordinates;
	  };
	  var d3_geom_polygonPrototype = d3.geom.polygon.prototype = [];
	  d3_geom_polygonPrototype.area = function() {
	    var i = -1, n = this.length, a, b = this[n - 1], area = 0;
	    while (++i < n) {
	      a = b;
	      b = this[i];
	      area += a[1] * b[0] - a[0] * b[1];
	    }
	    return area * .5;
	  };
	  d3_geom_polygonPrototype.centroid = function(k) {
	    var i = -1, n = this.length, x = 0, y = 0, a, b = this[n - 1], c;
	    if (!arguments.length) k = -1 / (6 * this.area());
	    while (++i < n) {
	      a = b;
	      b = this[i];
	      c = a[0] * b[1] - b[0] * a[1];
	      x += (a[0] + b[0]) * c;
	      y += (a[1] + b[1]) * c;
	    }
	    return [ x * k, y * k ];
	  };
	  d3_geom_polygonPrototype.clip = function(subject) {
	    var input, closed = d3_geom_polygonClosed(subject), i = -1, n = this.length - d3_geom_polygonClosed(this), j, m, a = this[n - 1], b, c, d;
	    while (++i < n) {
	      input = subject.slice();
	      subject.length = 0;
	      b = this[i];
	      c = input[(m = input.length - closed) - 1];
	      j = -1;
	      while (++j < m) {
	        d = input[j];
	        if (d3_geom_polygonInside(d, a, b)) {
	          if (!d3_geom_polygonInside(c, a, b)) {
	            subject.push(d3_geom_polygonIntersect(c, d, a, b));
	          }
	          subject.push(d);
	        } else if (d3_geom_polygonInside(c, a, b)) {
	          subject.push(d3_geom_polygonIntersect(c, d, a, b));
	        }
	        c = d;
	      }
	      if (closed) subject.push(subject[0]);
	      a = b;
	    }
	    return subject;
	  };
	  function d3_geom_polygonInside(p, a, b) {
	    return (b[0] - a[0]) * (p[1] - a[1]) < (b[1] - a[1]) * (p[0] - a[0]);
	  }
	  function d3_geom_polygonIntersect(c, d, a, b) {
	    var x1 = c[0], x3 = a[0], x21 = d[0] - x1, x43 = b[0] - x3, y1 = c[1], y3 = a[1], y21 = d[1] - y1, y43 = b[1] - y3, ua = (x43 * (y1 - y3) - y43 * (x1 - x3)) / (y43 * x21 - x43 * y21);
	    return [ x1 + ua * x21, y1 + ua * y21 ];
	  }
	  function d3_geom_polygonClosed(coordinates) {
	    var a = coordinates[0], b = coordinates[coordinates.length - 1];
	    return !(a[0] - b[0] || a[1] - b[1]);
	  }
	  var d3_geom_voronoiEdges, d3_geom_voronoiCells, d3_geom_voronoiBeaches, d3_geom_voronoiBeachPool = [], d3_geom_voronoiFirstCircle, d3_geom_voronoiCircles, d3_geom_voronoiCirclePool = [];
	  function d3_geom_voronoiBeach() {
	    d3_geom_voronoiRedBlackNode(this);
	    this.edge = this.site = this.circle = null;
	  }
	  function d3_geom_voronoiCreateBeach(site) {
	    var beach = d3_geom_voronoiBeachPool.pop() || new d3_geom_voronoiBeach();
	    beach.site = site;
	    return beach;
	  }
	  function d3_geom_voronoiDetachBeach(beach) {
	    d3_geom_voronoiDetachCircle(beach);
	    d3_geom_voronoiBeaches.remove(beach);
	    d3_geom_voronoiBeachPool.push(beach);
	    d3_geom_voronoiRedBlackNode(beach);
	  }
	  function d3_geom_voronoiRemoveBeach(beach) {
	    var circle = beach.circle, x = circle.x, y = circle.cy, vertex = {
	      x: x,
	      y: y
	    }, previous = beach.P, next = beach.N, disappearing = [ beach ];
	    d3_geom_voronoiDetachBeach(beach);
	    var lArc = previous;
	    while (lArc.circle && abs(x - lArc.circle.x) < ε && abs(y - lArc.circle.cy) < ε) {
	      previous = lArc.P;
	      disappearing.unshift(lArc);
	      d3_geom_voronoiDetachBeach(lArc);
	      lArc = previous;
	    }
	    disappearing.unshift(lArc);
	    d3_geom_voronoiDetachCircle(lArc);
	    var rArc = next;
	    while (rArc.circle && abs(x - rArc.circle.x) < ε && abs(y - rArc.circle.cy) < ε) {
	      next = rArc.N;
	      disappearing.push(rArc);
	      d3_geom_voronoiDetachBeach(rArc);
	      rArc = next;
	    }
	    disappearing.push(rArc);
	    d3_geom_voronoiDetachCircle(rArc);
	    var nArcs = disappearing.length, iArc;
	    for (iArc = 1; iArc < nArcs; ++iArc) {
	      rArc = disappearing[iArc];
	      lArc = disappearing[iArc - 1];
	      d3_geom_voronoiSetEdgeEnd(rArc.edge, lArc.site, rArc.site, vertex);
	    }
	    lArc = disappearing[0];
	    rArc = disappearing[nArcs - 1];
	    rArc.edge = d3_geom_voronoiCreateEdge(lArc.site, rArc.site, null, vertex);
	    d3_geom_voronoiAttachCircle(lArc);
	    d3_geom_voronoiAttachCircle(rArc);
	  }
	  function d3_geom_voronoiAddBeach(site) {
	    var x = site.x, directrix = site.y, lArc, rArc, dxl, dxr, node = d3_geom_voronoiBeaches._;
	    while (node) {
	      dxl = d3_geom_voronoiLeftBreakPoint(node, directrix) - x;
	      if (dxl > ε) node = node.L; else {
	        dxr = x - d3_geom_voronoiRightBreakPoint(node, directrix);
	        if (dxr > ε) {
	          if (!node.R) {
	            lArc = node;
	            break;
	          }
	          node = node.R;
	        } else {
	          if (dxl > -ε) {
	            lArc = node.P;
	            rArc = node;
	          } else if (dxr > -ε) {
	            lArc = node;
	            rArc = node.N;
	          } else {
	            lArc = rArc = node;
	          }
	          break;
	        }
	      }
	    }
	    var newArc = d3_geom_voronoiCreateBeach(site);
	    d3_geom_voronoiBeaches.insert(lArc, newArc);
	    if (!lArc && !rArc) return;
	    if (lArc === rArc) {
	      d3_geom_voronoiDetachCircle(lArc);
	      rArc = d3_geom_voronoiCreateBeach(lArc.site);
	      d3_geom_voronoiBeaches.insert(newArc, rArc);
	      newArc.edge = rArc.edge = d3_geom_voronoiCreateEdge(lArc.site, newArc.site);
	      d3_geom_voronoiAttachCircle(lArc);
	      d3_geom_voronoiAttachCircle(rArc);
	      return;
	    }
	    if (!rArc) {
	      newArc.edge = d3_geom_voronoiCreateEdge(lArc.site, newArc.site);
	      return;
	    }
	    d3_geom_voronoiDetachCircle(lArc);
	    d3_geom_voronoiDetachCircle(rArc);
	    var lSite = lArc.site, ax = lSite.x, ay = lSite.y, bx = site.x - ax, by = site.y - ay, rSite = rArc.site, cx = rSite.x - ax, cy = rSite.y - ay, d = 2 * (bx * cy - by * cx), hb = bx * bx + by * by, hc = cx * cx + cy * cy, vertex = {
	      x: (cy * hb - by * hc) / d + ax,
	      y: (bx * hc - cx * hb) / d + ay
	    };
	    d3_geom_voronoiSetEdgeEnd(rArc.edge, lSite, rSite, vertex);
	    newArc.edge = d3_geom_voronoiCreateEdge(lSite, site, null, vertex);
	    rArc.edge = d3_geom_voronoiCreateEdge(site, rSite, null, vertex);
	    d3_geom_voronoiAttachCircle(lArc);
	    d3_geom_voronoiAttachCircle(rArc);
	  }
	  function d3_geom_voronoiLeftBreakPoint(arc, directrix) {
	    var site = arc.site, rfocx = site.x, rfocy = site.y, pby2 = rfocy - directrix;
	    if (!pby2) return rfocx;
	    var lArc = arc.P;
	    if (!lArc) return -Infinity;
	    site = lArc.site;
	    var lfocx = site.x, lfocy = site.y, plby2 = lfocy - directrix;
	    if (!plby2) return lfocx;
	    var hl = lfocx - rfocx, aby2 = 1 / pby2 - 1 / plby2, b = hl / plby2;
	    if (aby2) return (-b + Math.sqrt(b * b - 2 * aby2 * (hl * hl / (-2 * plby2) - lfocy + plby2 / 2 + rfocy - pby2 / 2))) / aby2 + rfocx;
	    return (rfocx + lfocx) / 2;
	  }
	  function d3_geom_voronoiRightBreakPoint(arc, directrix) {
	    var rArc = arc.N;
	    if (rArc) return d3_geom_voronoiLeftBreakPoint(rArc, directrix);
	    var site = arc.site;
	    return site.y === directrix ? site.x : Infinity;
	  }
	  function d3_geom_voronoiCell(site) {
	    this.site = site;
	    this.edges = [];
	  }
	  d3_geom_voronoiCell.prototype.prepare = function() {
	    var halfEdges = this.edges, iHalfEdge = halfEdges.length, edge;
	    while (iHalfEdge--) {
	      edge = halfEdges[iHalfEdge].edge;
	      if (!edge.b || !edge.a) halfEdges.splice(iHalfEdge, 1);
	    }
	    halfEdges.sort(d3_geom_voronoiHalfEdgeOrder);
	    return halfEdges.length;
	  };
	  function d3_geom_voronoiCloseCells(extent) {
	    var x0 = extent[0][0], x1 = extent[1][0], y0 = extent[0][1], y1 = extent[1][1], x2, y2, x3, y3, cells = d3_geom_voronoiCells, iCell = cells.length, cell, iHalfEdge, halfEdges, nHalfEdges, start, end;
	    while (iCell--) {
	      cell = cells[iCell];
	      if (!cell || !cell.prepare()) continue;
	      halfEdges = cell.edges;
	      nHalfEdges = halfEdges.length;
	      iHalfEdge = 0;
	      while (iHalfEdge < nHalfEdges) {
	        end = halfEdges[iHalfEdge].end(), x3 = end.x, y3 = end.y;
	        start = halfEdges[++iHalfEdge % nHalfEdges].start(), x2 = start.x, y2 = start.y;
	        if (abs(x3 - x2) > ε || abs(y3 - y2) > ε) {
	          halfEdges.splice(iHalfEdge, 0, new d3_geom_voronoiHalfEdge(d3_geom_voronoiCreateBorderEdge(cell.site, end, abs(x3 - x0) < ε && y1 - y3 > ε ? {
	            x: x0,
	            y: abs(x2 - x0) < ε ? y2 : y1
	          } : abs(y3 - y1) < ε && x1 - x3 > ε ? {
	            x: abs(y2 - y1) < ε ? x2 : x1,
	            y: y1
	          } : abs(x3 - x1) < ε && y3 - y0 > ε ? {
	            x: x1,
	            y: abs(x2 - x1) < ε ? y2 : y0
	          } : abs(y3 - y0) < ε && x3 - x0 > ε ? {
	            x: abs(y2 - y0) < ε ? x2 : x0,
	            y: y0
	          } : null), cell.site, null));
	          ++nHalfEdges;
	        }
	      }
	    }
	  }
	  function d3_geom_voronoiHalfEdgeOrder(a, b) {
	    return b.angle - a.angle;
	  }
	  function d3_geom_voronoiCircle() {
	    d3_geom_voronoiRedBlackNode(this);
	    this.x = this.y = this.arc = this.site = this.cy = null;
	  }
	  function d3_geom_voronoiAttachCircle(arc) {
	    var lArc = arc.P, rArc = arc.N;
	    if (!lArc || !rArc) return;
	    var lSite = lArc.site, cSite = arc.site, rSite = rArc.site;
	    if (lSite === rSite) return;
	    var bx = cSite.x, by = cSite.y, ax = lSite.x - bx, ay = lSite.y - by, cx = rSite.x - bx, cy = rSite.y - by;
	    var d = 2 * (ax * cy - ay * cx);
	    if (d >= -ε2) return;
	    var ha = ax * ax + ay * ay, hc = cx * cx + cy * cy, x = (cy * ha - ay * hc) / d, y = (ax * hc - cx * ha) / d, cy = y + by;
	    var circle = d3_geom_voronoiCirclePool.pop() || new d3_geom_voronoiCircle();
	    circle.arc = arc;
	    circle.site = cSite;
	    circle.x = x + bx;
	    circle.y = cy + Math.sqrt(x * x + y * y);
	    circle.cy = cy;
	    arc.circle = circle;
	    var before = null, node = d3_geom_voronoiCircles._;
	    while (node) {
	      if (circle.y < node.y || circle.y === node.y && circle.x <= node.x) {
	        if (node.L) node = node.L; else {
	          before = node.P;
	          break;
	        }
	      } else {
	        if (node.R) node = node.R; else {
	          before = node;
	          break;
	        }
	      }
	    }
	    d3_geom_voronoiCircles.insert(before, circle);
	    if (!before) d3_geom_voronoiFirstCircle = circle;
	  }
	  function d3_geom_voronoiDetachCircle(arc) {
	    var circle = arc.circle;
	    if (circle) {
	      if (!circle.P) d3_geom_voronoiFirstCircle = circle.N;
	      d3_geom_voronoiCircles.remove(circle);
	      d3_geom_voronoiCirclePool.push(circle);
	      d3_geom_voronoiRedBlackNode(circle);
	      arc.circle = null;
	    }
	  }
	  function d3_geom_voronoiClipEdges(extent) {
	    var edges = d3_geom_voronoiEdges, clip = d3_geom_clipLine(extent[0][0], extent[0][1], extent[1][0], extent[1][1]), i = edges.length, e;
	    while (i--) {
	      e = edges[i];
	      if (!d3_geom_voronoiConnectEdge(e, extent) || !clip(e) || abs(e.a.x - e.b.x) < ε && abs(e.a.y - e.b.y) < ε) {
	        e.a = e.b = null;
	        edges.splice(i, 1);
	      }
	    }
	  }
	  function d3_geom_voronoiConnectEdge(edge, extent) {
	    var vb = edge.b;
	    if (vb) return true;
	    var va = edge.a, x0 = extent[0][0], x1 = extent[1][0], y0 = extent[0][1], y1 = extent[1][1], lSite = edge.l, rSite = edge.r, lx = lSite.x, ly = lSite.y, rx = rSite.x, ry = rSite.y, fx = (lx + rx) / 2, fy = (ly + ry) / 2, fm, fb;
	    if (ry === ly) {
	      if (fx < x0 || fx >= x1) return;
	      if (lx > rx) {
	        if (!va) va = {
	          x: fx,
	          y: y0
	        }; else if (va.y >= y1) return;
	        vb = {
	          x: fx,
	          y: y1
	        };
	      } else {
	        if (!va) va = {
	          x: fx,
	          y: y1
	        }; else if (va.y < y0) return;
	        vb = {
	          x: fx,
	          y: y0
	        };
	      }
	    } else {
	      fm = (lx - rx) / (ry - ly);
	      fb = fy - fm * fx;
	      if (fm < -1 || fm > 1) {
	        if (lx > rx) {
	          if (!va) va = {
	            x: (y0 - fb) / fm,
	            y: y0
	          }; else if (va.y >= y1) return;
	          vb = {
	            x: (y1 - fb) / fm,
	            y: y1
	          };
	        } else {
	          if (!va) va = {
	            x: (y1 - fb) / fm,
	            y: y1
	          }; else if (va.y < y0) return;
	          vb = {
	            x: (y0 - fb) / fm,
	            y: y0
	          };
	        }
	      } else {
	        if (ly < ry) {
	          if (!va) va = {
	            x: x0,
	            y: fm * x0 + fb
	          }; else if (va.x >= x1) return;
	          vb = {
	            x: x1,
	            y: fm * x1 + fb
	          };
	        } else {
	          if (!va) va = {
	            x: x1,
	            y: fm * x1 + fb
	          }; else if (va.x < x0) return;
	          vb = {
	            x: x0,
	            y: fm * x0 + fb
	          };
	        }
	      }
	    }
	    edge.a = va;
	    edge.b = vb;
	    return true;
	  }
	  function d3_geom_voronoiEdge(lSite, rSite) {
	    this.l = lSite;
	    this.r = rSite;
	    this.a = this.b = null;
	  }
	  function d3_geom_voronoiCreateEdge(lSite, rSite, va, vb) {
	    var edge = new d3_geom_voronoiEdge(lSite, rSite);
	    d3_geom_voronoiEdges.push(edge);
	    if (va) d3_geom_voronoiSetEdgeEnd(edge, lSite, rSite, va);
	    if (vb) d3_geom_voronoiSetEdgeEnd(edge, rSite, lSite, vb);
	    d3_geom_voronoiCells[lSite.i].edges.push(new d3_geom_voronoiHalfEdge(edge, lSite, rSite));
	    d3_geom_voronoiCells[rSite.i].edges.push(new d3_geom_voronoiHalfEdge(edge, rSite, lSite));
	    return edge;
	  }
	  function d3_geom_voronoiCreateBorderEdge(lSite, va, vb) {
	    var edge = new d3_geom_voronoiEdge(lSite, null);
	    edge.a = va;
	    edge.b = vb;
	    d3_geom_voronoiEdges.push(edge);
	    return edge;
	  }
	  function d3_geom_voronoiSetEdgeEnd(edge, lSite, rSite, vertex) {
	    if (!edge.a && !edge.b) {
	      edge.a = vertex;
	      edge.l = lSite;
	      edge.r = rSite;
	    } else if (edge.l === rSite) {
	      edge.b = vertex;
	    } else {
	      edge.a = vertex;
	    }
	  }
	  function d3_geom_voronoiHalfEdge(edge, lSite, rSite) {
	    var va = edge.a, vb = edge.b;
	    this.edge = edge;
	    this.site = lSite;
	    this.angle = rSite ? Math.atan2(rSite.y - lSite.y, rSite.x - lSite.x) : edge.l === lSite ? Math.atan2(vb.x - va.x, va.y - vb.y) : Math.atan2(va.x - vb.x, vb.y - va.y);
	  }
	  d3_geom_voronoiHalfEdge.prototype = {
	    start: function() {
	      return this.edge.l === this.site ? this.edge.a : this.edge.b;
	    },
	    end: function() {
	      return this.edge.l === this.site ? this.edge.b : this.edge.a;
	    }
	  };
	  function d3_geom_voronoiRedBlackTree() {
	    this._ = null;
	  }
	  function d3_geom_voronoiRedBlackNode(node) {
	    node.U = node.C = node.L = node.R = node.P = node.N = null;
	  }
	  d3_geom_voronoiRedBlackTree.prototype = {
	    insert: function(after, node) {
	      var parent, grandpa, uncle;
	      if (after) {
	        node.P = after;
	        node.N = after.N;
	        if (after.N) after.N.P = node;
	        after.N = node;
	        if (after.R) {
	          after = after.R;
	          while (after.L) after = after.L;
	          after.L = node;
	        } else {
	          after.R = node;
	        }
	        parent = after;
	      } else if (this._) {
	        after = d3_geom_voronoiRedBlackFirst(this._);
	        node.P = null;
	        node.N = after;
	        after.P = after.L = node;
	        parent = after;
	      } else {
	        node.P = node.N = null;
	        this._ = node;
	        parent = null;
	      }
	      node.L = node.R = null;
	      node.U = parent;
	      node.C = true;
	      after = node;
	      while (parent && parent.C) {
	        grandpa = parent.U;
	        if (parent === grandpa.L) {
	          uncle = grandpa.R;
	          if (uncle && uncle.C) {
	            parent.C = uncle.C = false;
	            grandpa.C = true;
	            after = grandpa;
	          } else {
	            if (after === parent.R) {
	              d3_geom_voronoiRedBlackRotateLeft(this, parent);
	              after = parent;
	              parent = after.U;
	            }
	            parent.C = false;
	            grandpa.C = true;
	            d3_geom_voronoiRedBlackRotateRight(this, grandpa);
	          }
	        } else {
	          uncle = grandpa.L;
	          if (uncle && uncle.C) {
	            parent.C = uncle.C = false;
	            grandpa.C = true;
	            after = grandpa;
	          } else {
	            if (after === parent.L) {
	              d3_geom_voronoiRedBlackRotateRight(this, parent);
	              after = parent;
	              parent = after.U;
	            }
	            parent.C = false;
	            grandpa.C = true;
	            d3_geom_voronoiRedBlackRotateLeft(this, grandpa);
	          }
	        }
	        parent = after.U;
	      }
	      this._.C = false;
	    },
	    remove: function(node) {
	      if (node.N) node.N.P = node.P;
	      if (node.P) node.P.N = node.N;
	      node.N = node.P = null;
	      var parent = node.U, sibling, left = node.L, right = node.R, next, red;
	      if (!left) next = right; else if (!right) next = left; else next = d3_geom_voronoiRedBlackFirst(right);
	      if (parent) {
	        if (parent.L === node) parent.L = next; else parent.R = next;
	      } else {
	        this._ = next;
	      }
	      if (left && right) {
	        red = next.C;
	        next.C = node.C;
	        next.L = left;
	        left.U = next;
	        if (next !== right) {
	          parent = next.U;
	          next.U = node.U;
	          node = next.R;
	          parent.L = node;
	          next.R = right;
	          right.U = next;
	        } else {
	          next.U = parent;
	          parent = next;
	          node = next.R;
	        }
	      } else {
	        red = node.C;
	        node = next;
	      }
	      if (node) node.U = parent;
	      if (red) return;
	      if (node && node.C) {
	        node.C = false;
	        return;
	      }
	      do {
	        if (node === this._) break;
	        if (node === parent.L) {
	          sibling = parent.R;
	          if (sibling.C) {
	            sibling.C = false;
	            parent.C = true;
	            d3_geom_voronoiRedBlackRotateLeft(this, parent);
	            sibling = parent.R;
	          }
	          if (sibling.L && sibling.L.C || sibling.R && sibling.R.C) {
	            if (!sibling.R || !sibling.R.C) {
	              sibling.L.C = false;
	              sibling.C = true;
	              d3_geom_voronoiRedBlackRotateRight(this, sibling);
	              sibling = parent.R;
	            }
	            sibling.C = parent.C;
	            parent.C = sibling.R.C = false;
	            d3_geom_voronoiRedBlackRotateLeft(this, parent);
	            node = this._;
	            break;
	          }
	        } else {
	          sibling = parent.L;
	          if (sibling.C) {
	            sibling.C = false;
	            parent.C = true;
	            d3_geom_voronoiRedBlackRotateRight(this, parent);
	            sibling = parent.L;
	          }
	          if (sibling.L && sibling.L.C || sibling.R && sibling.R.C) {
	            if (!sibling.L || !sibling.L.C) {
	              sibling.R.C = false;
	              sibling.C = true;
	              d3_geom_voronoiRedBlackRotateLeft(this, sibling);
	              sibling = parent.L;
	            }
	            sibling.C = parent.C;
	            parent.C = sibling.L.C = false;
	            d3_geom_voronoiRedBlackRotateRight(this, parent);
	            node = this._;
	            break;
	          }
	        }
	        sibling.C = true;
	        node = parent;
	        parent = parent.U;
	      } while (!node.C);
	      if (node) node.C = false;
	    }
	  };
	  function d3_geom_voronoiRedBlackRotateLeft(tree, node) {
	    var p = node, q = node.R, parent = p.U;
	    if (parent) {
	      if (parent.L === p) parent.L = q; else parent.R = q;
	    } else {
	      tree._ = q;
	    }
	    q.U = parent;
	    p.U = q;
	    p.R = q.L;
	    if (p.R) p.R.U = p;
	    q.L = p;
	  }
	  function d3_geom_voronoiRedBlackRotateRight(tree, node) {
	    var p = node, q = node.L, parent = p.U;
	    if (parent) {
	      if (parent.L === p) parent.L = q; else parent.R = q;
	    } else {
	      tree._ = q;
	    }
	    q.U = parent;
	    p.U = q;
	    p.L = q.R;
	    if (p.L) p.L.U = p;
	    q.R = p;
	  }
	  function d3_geom_voronoiRedBlackFirst(node) {
	    while (node.L) node = node.L;
	    return node;
	  }
	  function d3_geom_voronoi(sites, bbox) {
	    var site = sites.sort(d3_geom_voronoiVertexOrder).pop(), x0, y0, circle;
	    d3_geom_voronoiEdges = [];
	    d3_geom_voronoiCells = new Array(sites.length);
	    d3_geom_voronoiBeaches = new d3_geom_voronoiRedBlackTree();
	    d3_geom_voronoiCircles = new d3_geom_voronoiRedBlackTree();
	    while (true) {
	      circle = d3_geom_voronoiFirstCircle;
	      if (site && (!circle || site.y < circle.y || site.y === circle.y && site.x < circle.x)) {
	        if (site.x !== x0 || site.y !== y0) {
	          d3_geom_voronoiCells[site.i] = new d3_geom_voronoiCell(site);
	          d3_geom_voronoiAddBeach(site);
	          x0 = site.x, y0 = site.y;
	        }
	        site = sites.pop();
	      } else if (circle) {
	        d3_geom_voronoiRemoveBeach(circle.arc);
	      } else {
	        break;
	      }
	    }
	    if (bbox) d3_geom_voronoiClipEdges(bbox), d3_geom_voronoiCloseCells(bbox);
	    var diagram = {
	      cells: d3_geom_voronoiCells,
	      edges: d3_geom_voronoiEdges
	    };
	    d3_geom_voronoiBeaches = d3_geom_voronoiCircles = d3_geom_voronoiEdges = d3_geom_voronoiCells = null;
	    return diagram;
	  }
	  function d3_geom_voronoiVertexOrder(a, b) {
	    return b.y - a.y || b.x - a.x;
	  }
	  d3.geom.voronoi = function(points) {
	    var x = d3_geom_pointX, y = d3_geom_pointY, fx = x, fy = y, clipExtent = d3_geom_voronoiClipExtent;
	    if (points) return voronoi(points);
	    function voronoi(data) {
	      var polygons = new Array(data.length), x0 = clipExtent[0][0], y0 = clipExtent[0][1], x1 = clipExtent[1][0], y1 = clipExtent[1][1];
	      d3_geom_voronoi(sites(data), clipExtent).cells.forEach(function(cell, i) {
	        var edges = cell.edges, site = cell.site, polygon = polygons[i] = edges.length ? edges.map(function(e) {
	          var s = e.start();
	          return [ s.x, s.y ];
	        }) : site.x >= x0 && site.x <= x1 && site.y >= y0 && site.y <= y1 ? [ [ x0, y1 ], [ x1, y1 ], [ x1, y0 ], [ x0, y0 ] ] : [];
	        polygon.point = data[i];
	      });
	      return polygons;
	    }
	    function sites(data) {
	      return data.map(function(d, i) {
	        return {
	          x: Math.round(fx(d, i) / ε) * ε,
	          y: Math.round(fy(d, i) / ε) * ε,
	          i: i
	        };
	      });
	    }
	    voronoi.links = function(data) {
	      return d3_geom_voronoi(sites(data)).edges.filter(function(edge) {
	        return edge.l && edge.r;
	      }).map(function(edge) {
	        return {
	          source: data[edge.l.i],
	          target: data[edge.r.i]
	        };
	      });
	    };
	    voronoi.triangles = function(data) {
	      var triangles = [];
	      d3_geom_voronoi(sites(data)).cells.forEach(function(cell, i) {
	        var site = cell.site, edges = cell.edges.sort(d3_geom_voronoiHalfEdgeOrder), j = -1, m = edges.length, e0, s0, e1 = edges[m - 1].edge, s1 = e1.l === site ? e1.r : e1.l;
	        while (++j < m) {
	          e0 = e1;
	          s0 = s1;
	          e1 = edges[j].edge;
	          s1 = e1.l === site ? e1.r : e1.l;
	          if (i < s0.i && i < s1.i && d3_geom_voronoiTriangleArea(site, s0, s1) < 0) {
	            triangles.push([ data[i], data[s0.i], data[s1.i] ]);
	          }
	        }
	      });
	      return triangles;
	    };
	    voronoi.x = function(_) {
	      return arguments.length ? (fx = d3_functor(x = _), voronoi) : x;
	    };
	    voronoi.y = function(_) {
	      return arguments.length ? (fy = d3_functor(y = _), voronoi) : y;
	    };
	    voronoi.clipExtent = function(_) {
	      if (!arguments.length) return clipExtent === d3_geom_voronoiClipExtent ? null : clipExtent;
	      clipExtent = _ == null ? d3_geom_voronoiClipExtent : _;
	      return voronoi;
	    };
	    voronoi.size = function(_) {
	      if (!arguments.length) return clipExtent === d3_geom_voronoiClipExtent ? null : clipExtent && clipExtent[1];
	      return voronoi.clipExtent(_ && [ [ 0, 0 ], _ ]);
	    };
	    return voronoi;
	  };
	  var d3_geom_voronoiClipExtent = [ [ -1e6, -1e6 ], [ 1e6, 1e6 ] ];
	  function d3_geom_voronoiTriangleArea(a, b, c) {
	    return (a.x - c.x) * (b.y - a.y) - (a.x - b.x) * (c.y - a.y);
	  }
	  d3.geom.delaunay = function(vertices) {
	    return d3.geom.voronoi().triangles(vertices);
	  };
	  d3.geom.quadtree = function(points, x1, y1, x2, y2) {
	    var x = d3_geom_pointX, y = d3_geom_pointY, compat;
	    if (compat = arguments.length) {
	      x = d3_geom_quadtreeCompatX;
	      y = d3_geom_quadtreeCompatY;
	      if (compat === 3) {
	        y2 = y1;
	        x2 = x1;
	        y1 = x1 = 0;
	      }
	      return quadtree(points);
	    }
	    function quadtree(data) {
	      var d, fx = d3_functor(x), fy = d3_functor(y), xs, ys, i, n, x1_, y1_, x2_, y2_;
	      if (x1 != null) {
	        x1_ = x1, y1_ = y1, x2_ = x2, y2_ = y2;
	      } else {
	        x2_ = y2_ = -(x1_ = y1_ = Infinity);
	        xs = [], ys = [];
	        n = data.length;
	        if (compat) for (i = 0; i < n; ++i) {
	          d = data[i];
	          if (d.x < x1_) x1_ = d.x;
	          if (d.y < y1_) y1_ = d.y;
	          if (d.x > x2_) x2_ = d.x;
	          if (d.y > y2_) y2_ = d.y;
	          xs.push(d.x);
	          ys.push(d.y);
	        } else for (i = 0; i < n; ++i) {
	          var x_ = +fx(d = data[i], i), y_ = +fy(d, i);
	          if (x_ < x1_) x1_ = x_;
	          if (y_ < y1_) y1_ = y_;
	          if (x_ > x2_) x2_ = x_;
	          if (y_ > y2_) y2_ = y_;
	          xs.push(x_);
	          ys.push(y_);
	        }
	      }
	      var dx = x2_ - x1_, dy = y2_ - y1_;
	      if (dx > dy) y2_ = y1_ + dx; else x2_ = x1_ + dy;
	      function insert(n, d, x, y, x1, y1, x2, y2) {
	        if (isNaN(x) || isNaN(y)) return;
	        if (n.leaf) {
	          var nx = n.x, ny = n.y;
	          if (nx != null) {
	            if (abs(nx - x) + abs(ny - y) < .01) {
	              insertChild(n, d, x, y, x1, y1, x2, y2);
	            } else {
	              var nPoint = n.point;
	              n.x = n.y = n.point = null;
	              insertChild(n, nPoint, nx, ny, x1, y1, x2, y2);
	              insertChild(n, d, x, y, x1, y1, x2, y2);
	            }
	          } else {
	            n.x = x, n.y = y, n.point = d;
	          }
	        } else {
	          insertChild(n, d, x, y, x1, y1, x2, y2);
	        }
	      }
	      function insertChild(n, d, x, y, x1, y1, x2, y2) {
	        var xm = (x1 + x2) * .5, ym = (y1 + y2) * .5, right = x >= xm, below = y >= ym, i = below << 1 | right;
	        n.leaf = false;
	        n = n.nodes[i] || (n.nodes[i] = d3_geom_quadtreeNode());
	        if (right) x1 = xm; else x2 = xm;
	        if (below) y1 = ym; else y2 = ym;
	        insert(n, d, x, y, x1, y1, x2, y2);
	      }
	      var root = d3_geom_quadtreeNode();
	      root.add = function(d) {
	        insert(root, d, +fx(d, ++i), +fy(d, i), x1_, y1_, x2_, y2_);
	      };
	      root.visit = function(f) {
	        d3_geom_quadtreeVisit(f, root, x1_, y1_, x2_, y2_);
	      };
	      root.find = function(point) {
	        return d3_geom_quadtreeFind(root, point[0], point[1], x1_, y1_, x2_, y2_);
	      };
	      i = -1;
	      if (x1 == null) {
	        while (++i < n) {
	          insert(root, data[i], xs[i], ys[i], x1_, y1_, x2_, y2_);
	        }
	        --i;
	      } else data.forEach(root.add);
	      xs = ys = data = d = null;
	      return root;
	    }
	    quadtree.x = function(_) {
	      return arguments.length ? (x = _, quadtree) : x;
	    };
	    quadtree.y = function(_) {
	      return arguments.length ? (y = _, quadtree) : y;
	    };
	    quadtree.extent = function(_) {
	      if (!arguments.length) return x1 == null ? null : [ [ x1, y1 ], [ x2, y2 ] ];
	      if (_ == null) x1 = y1 = x2 = y2 = null; else x1 = +_[0][0], y1 = +_[0][1], x2 = +_[1][0], 
	      y2 = +_[1][1];
	      return quadtree;
	    };
	    quadtree.size = function(_) {
	      if (!arguments.length) return x1 == null ? null : [ x2 - x1, y2 - y1 ];
	      if (_ == null) x1 = y1 = x2 = y2 = null; else x1 = y1 = 0, x2 = +_[0], y2 = +_[1];
	      return quadtree;
	    };
	    return quadtree;
	  };
	  function d3_geom_quadtreeCompatX(d) {
	    return d.x;
	  }
	  function d3_geom_quadtreeCompatY(d) {
	    return d.y;
	  }
	  function d3_geom_quadtreeNode() {
	    return {
	      leaf: true,
	      nodes: [],
	      point: null,
	      x: null,
	      y: null
	    };
	  }
	  function d3_geom_quadtreeVisit(f, node, x1, y1, x2, y2) {
	    if (!f(node, x1, y1, x2, y2)) {
	      var sx = (x1 + x2) * .5, sy = (y1 + y2) * .5, children = node.nodes;
	      if (children[0]) d3_geom_quadtreeVisit(f, children[0], x1, y1, sx, sy);
	      if (children[1]) d3_geom_quadtreeVisit(f, children[1], sx, y1, x2, sy);
	      if (children[2]) d3_geom_quadtreeVisit(f, children[2], x1, sy, sx, y2);
	      if (children[3]) d3_geom_quadtreeVisit(f, children[3], sx, sy, x2, y2);
	    }
	  }
	  function d3_geom_quadtreeFind(root, x, y, x0, y0, x3, y3) {
	    var minDistance2 = Infinity, closestPoint;
	    (function find(node, x1, y1, x2, y2) {
	      if (x1 > x3 || y1 > y3 || x2 < x0 || y2 < y0) return;
	      if (point = node.point) {
	        var point, dx = x - node.x, dy = y - node.y, distance2 = dx * dx + dy * dy;
	        if (distance2 < minDistance2) {
	          var distance = Math.sqrt(minDistance2 = distance2);
	          x0 = x - distance, y0 = y - distance;
	          x3 = x + distance, y3 = y + distance;
	          closestPoint = point;
	        }
	      }
	      var children = node.nodes, xm = (x1 + x2) * .5, ym = (y1 + y2) * .5, right = x >= xm, below = y >= ym;
	      for (var i = below << 1 | right, j = i + 4; i < j; ++i) {
	        if (node = children[i & 3]) switch (i & 3) {
	         case 0:
	          find(node, x1, y1, xm, ym);
	          break;
	
	         case 1:
	          find(node, xm, y1, x2, ym);
	          break;
	
	         case 2:
	          find(node, x1, ym, xm, y2);
	          break;
	
	         case 3:
	          find(node, xm, ym, x2, y2);
	          break;
	        }
	      }
	    })(root, x0, y0, x3, y3);
	    return closestPoint;
	  }
	  d3.interpolateRgb = d3_interpolateRgb;
	  function d3_interpolateRgb(a, b) {
	    a = d3.rgb(a);
	    b = d3.rgb(b);
	    var ar = a.r, ag = a.g, ab = a.b, br = b.r - ar, bg = b.g - ag, bb = b.b - ab;
	    return function(t) {
	      return "#" + d3_rgb_hex(Math.round(ar + br * t)) + d3_rgb_hex(Math.round(ag + bg * t)) + d3_rgb_hex(Math.round(ab + bb * t));
	    };
	  }
	  d3.interpolateObject = d3_interpolateObject;
	  function d3_interpolateObject(a, b) {
	    var i = {}, c = {}, k;
	    for (k in a) {
	      if (k in b) {
	        i[k] = d3_interpolate(a[k], b[k]);
	      } else {
	        c[k] = a[k];
	      }
	    }
	    for (k in b) {
	      if (!(k in a)) {
	        c[k] = b[k];
	      }
	    }
	    return function(t) {
	      for (k in i) c[k] = i[k](t);
	      return c;
	    };
	  }
	  d3.interpolateNumber = d3_interpolateNumber;
	  function d3_interpolateNumber(a, b) {
	    a = +a, b = +b;
	    return function(t) {
	      return a * (1 - t) + b * t;
	    };
	  }
	  d3.interpolateString = d3_interpolateString;
	  function d3_interpolateString(a, b) {
	    var bi = d3_interpolate_numberA.lastIndex = d3_interpolate_numberB.lastIndex = 0, am, bm, bs, i = -1, s = [], q = [];
	    a = a + "", b = b + "";
	    while ((am = d3_interpolate_numberA.exec(a)) && (bm = d3_interpolate_numberB.exec(b))) {
	      if ((bs = bm.index) > bi) {
	        bs = b.slice(bi, bs);
	        if (s[i]) s[i] += bs; else s[++i] = bs;
	      }
	      if ((am = am[0]) === (bm = bm[0])) {
	        if (s[i]) s[i] += bm; else s[++i] = bm;
	      } else {
	        s[++i] = null;
	        q.push({
	          i: i,
	          x: d3_interpolateNumber(am, bm)
	        });
	      }
	      bi = d3_interpolate_numberB.lastIndex;
	    }
	    if (bi < b.length) {
	      bs = b.slice(bi);
	      if (s[i]) s[i] += bs; else s[++i] = bs;
	    }
	    return s.length < 2 ? q[0] ? (b = q[0].x, function(t) {
	      return b(t) + "";
	    }) : function() {
	      return b;
	    } : (b = q.length, function(t) {
	      for (var i = 0, o; i < b; ++i) s[(o = q[i]).i] = o.x(t);
	      return s.join("");
	    });
	  }
	  var d3_interpolate_numberA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, d3_interpolate_numberB = new RegExp(d3_interpolate_numberA.source, "g");
	  d3.interpolate = d3_interpolate;
	  function d3_interpolate(a, b) {
	    var i = d3.interpolators.length, f;
	    while (--i >= 0 && !(f = d3.interpolators[i](a, b))) ;
	    return f;
	  }
	  d3.interpolators = [ function(a, b) {
	    var t = typeof b;
	    return (t === "string" ? d3_rgb_names.has(b.toLowerCase()) || /^(#|rgb\(|hsl\()/i.test(b) ? d3_interpolateRgb : d3_interpolateString : b instanceof d3_color ? d3_interpolateRgb : Array.isArray(b) ? d3_interpolateArray : t === "object" && isNaN(b) ? d3_interpolateObject : d3_interpolateNumber)(a, b);
	  } ];
	  d3.interpolateArray = d3_interpolateArray;
	  function d3_interpolateArray(a, b) {
	    var x = [], c = [], na = a.length, nb = b.length, n0 = Math.min(a.length, b.length), i;
	    for (i = 0; i < n0; ++i) x.push(d3_interpolate(a[i], b[i]));
	    for (;i < na; ++i) c[i] = a[i];
	    for (;i < nb; ++i) c[i] = b[i];
	    return function(t) {
	      for (i = 0; i < n0; ++i) c[i] = x[i](t);
	      return c;
	    };
	  }
	  var d3_ease_default = function() {
	    return d3_identity;
	  };
	  var d3_ease = d3.map({
	    linear: d3_ease_default,
	    poly: d3_ease_poly,
	    quad: function() {
	      return d3_ease_quad;
	    },
	    cubic: function() {
	      return d3_ease_cubic;
	    },
	    sin: function() {
	      return d3_ease_sin;
	    },
	    exp: function() {
	      return d3_ease_exp;
	    },
	    circle: function() {
	      return d3_ease_circle;
	    },
	    elastic: d3_ease_elastic,
	    back: d3_ease_back,
	    bounce: function() {
	      return d3_ease_bounce;
	    }
	  });
	  var d3_ease_mode = d3.map({
	    "in": d3_identity,
	    out: d3_ease_reverse,
	    "in-out": d3_ease_reflect,
	    "out-in": function(f) {
	      return d3_ease_reflect(d3_ease_reverse(f));
	    }
	  });
	  d3.ease = function(name) {
	    var i = name.indexOf("-"), t = i >= 0 ? name.slice(0, i) : name, m = i >= 0 ? name.slice(i + 1) : "in";
	    t = d3_ease.get(t) || d3_ease_default;
	    m = d3_ease_mode.get(m) || d3_identity;
	    return d3_ease_clamp(m(t.apply(null, d3_arraySlice.call(arguments, 1))));
	  };
	  function d3_ease_clamp(f) {
	    return function(t) {
	      return t <= 0 ? 0 : t >= 1 ? 1 : f(t);
	    };
	  }
	  function d3_ease_reverse(f) {
	    return function(t) {
	      return 1 - f(1 - t);
	    };
	  }
	  function d3_ease_reflect(f) {
	    return function(t) {
	      return .5 * (t < .5 ? f(2 * t) : 2 - f(2 - 2 * t));
	    };
	  }
	  function d3_ease_quad(t) {
	    return t * t;
	  }
	  function d3_ease_cubic(t) {
	    return t * t * t;
	  }
	  function d3_ease_cubicInOut(t) {
	    if (t <= 0) return 0;
	    if (t >= 1) return 1;
	    var t2 = t * t, t3 = t2 * t;
	    return 4 * (t < .5 ? t3 : 3 * (t - t2) + t3 - .75);
	  }
	  function d3_ease_poly(e) {
	    return function(t) {
	      return Math.pow(t, e);
	    };
	  }
	  function d3_ease_sin(t) {
	    return 1 - Math.cos(t * halfπ);
	  }
	  function d3_ease_exp(t) {
	    return Math.pow(2, 10 * (t - 1));
	  }
	  function d3_ease_circle(t) {
	    return 1 - Math.sqrt(1 - t * t);
	  }
	  function d3_ease_elastic(a, p) {
	    var s;
	    if (arguments.length < 2) p = .45;
	    if (arguments.length) s = p / τ * Math.asin(1 / a); else a = 1, s = p / 4;
	    return function(t) {
	      return 1 + a * Math.pow(2, -10 * t) * Math.sin((t - s) * τ / p);
	    };
	  }
	  function d3_ease_back(s) {
	    if (!s) s = 1.70158;
	    return function(t) {
	      return t * t * ((s + 1) * t - s);
	    };
	  }
	  function d3_ease_bounce(t) {
	    return t < 1 / 2.75 ? 7.5625 * t * t : t < 2 / 2.75 ? 7.5625 * (t -= 1.5 / 2.75) * t + .75 : t < 2.5 / 2.75 ? 7.5625 * (t -= 2.25 / 2.75) * t + .9375 : 7.5625 * (t -= 2.625 / 2.75) * t + .984375;
	  }
	  d3.interpolateHcl = d3_interpolateHcl;
	  function d3_interpolateHcl(a, b) {
	    a = d3.hcl(a);
	    b = d3.hcl(b);
	    var ah = a.h, ac = a.c, al = a.l, bh = b.h - ah, bc = b.c - ac, bl = b.l - al;
	    if (isNaN(bc)) bc = 0, ac = isNaN(ac) ? b.c : ac;
	    if (isNaN(bh)) bh = 0, ah = isNaN(ah) ? b.h : ah; else if (bh > 180) bh -= 360; else if (bh < -180) bh += 360;
	    return function(t) {
	      return d3_hcl_lab(ah + bh * t, ac + bc * t, al + bl * t) + "";
	    };
	  }
	  d3.interpolateHsl = d3_interpolateHsl;
	  function d3_interpolateHsl(a, b) {
	    a = d3.hsl(a);
	    b = d3.hsl(b);
	    var ah = a.h, as = a.s, al = a.l, bh = b.h - ah, bs = b.s - as, bl = b.l - al;
	    if (isNaN(bs)) bs = 0, as = isNaN(as) ? b.s : as;
	    if (isNaN(bh)) bh = 0, ah = isNaN(ah) ? b.h : ah; else if (bh > 180) bh -= 360; else if (bh < -180) bh += 360;
	    return function(t) {
	      return d3_hsl_rgb(ah + bh * t, as + bs * t, al + bl * t) + "";
	    };
	  }
	  d3.interpolateLab = d3_interpolateLab;
	  function d3_interpolateLab(a, b) {
	    a = d3.lab(a);
	    b = d3.lab(b);
	    var al = a.l, aa = a.a, ab = a.b, bl = b.l - al, ba = b.a - aa, bb = b.b - ab;
	    return function(t) {
	      return d3_lab_rgb(al + bl * t, aa + ba * t, ab + bb * t) + "";
	    };
	  }
	  d3.interpolateRound = d3_interpolateRound;
	  function d3_interpolateRound(a, b) {
	    b -= a;
	    return function(t) {
	      return Math.round(a + b * t);
	    };
	  }
	  d3.transform = function(string) {
	    var g = d3_document.createElementNS(d3.ns.prefix.svg, "g");
	    return (d3.transform = function(string) {
	      if (string != null) {
	        g.setAttribute("transform", string);
	        var t = g.transform.baseVal.consolidate();
	      }
	      return new d3_transform(t ? t.matrix : d3_transformIdentity);
	    })(string);
	  };
	  function d3_transform(m) {
	    var r0 = [ m.a, m.b ], r1 = [ m.c, m.d ], kx = d3_transformNormalize(r0), kz = d3_transformDot(r0, r1), ky = d3_transformNormalize(d3_transformCombine(r1, r0, -kz)) || 0;
	    if (r0[0] * r1[1] < r1[0] * r0[1]) {
	      r0[0] *= -1;
	      r0[1] *= -1;
	      kx *= -1;
	      kz *= -1;
	    }
	    this.rotate = (kx ? Math.atan2(r0[1], r0[0]) : Math.atan2(-r1[0], r1[1])) * d3_degrees;
	    this.translate = [ m.e, m.f ];
	    this.scale = [ kx, ky ];
	    this.skew = ky ? Math.atan2(kz, ky) * d3_degrees : 0;
	  }
	  d3_transform.prototype.toString = function() {
	    return "translate(" + this.translate + ")rotate(" + this.rotate + ")skewX(" + this.skew + ")scale(" + this.scale + ")";
	  };
	  function d3_transformDot(a, b) {
	    return a[0] * b[0] + a[1] * b[1];
	  }
	  function d3_transformNormalize(a) {
	    var k = Math.sqrt(d3_transformDot(a, a));
	    if (k) {
	      a[0] /= k;
	      a[1] /= k;
	    }
	    return k;
	  }
	  function d3_transformCombine(a, b, k) {
	    a[0] += k * b[0];
	    a[1] += k * b[1];
	    return a;
	  }
	  var d3_transformIdentity = {
	    a: 1,
	    b: 0,
	    c: 0,
	    d: 1,
	    e: 0,
	    f: 0
	  };
	  d3.interpolateTransform = d3_interpolateTransform;
	  function d3_interpolateTransformPop(s) {
	    return s.length ? s.pop() + "," : "";
	  }
	  function d3_interpolateTranslate(ta, tb, s, q) {
	    if (ta[0] !== tb[0] || ta[1] !== tb[1]) {
	      var i = s.push("translate(", null, ",", null, ")");
	      q.push({
	        i: i - 4,
	        x: d3_interpolateNumber(ta[0], tb[0])
	      }, {
	        i: i - 2,
	        x: d3_interpolateNumber(ta[1], tb[1])
	      });
	    } else if (tb[0] || tb[1]) {
	      s.push("translate(" + tb + ")");
	    }
	  }
	  function d3_interpolateRotate(ra, rb, s, q) {
	    if (ra !== rb) {
	      if (ra - rb > 180) rb += 360; else if (rb - ra > 180) ra += 360;
	      q.push({
	        i: s.push(d3_interpolateTransformPop(s) + "rotate(", null, ")") - 2,
	        x: d3_interpolateNumber(ra, rb)
	      });
	    } else if (rb) {
	      s.push(d3_interpolateTransformPop(s) + "rotate(" + rb + ")");
	    }
	  }
	  function d3_interpolateSkew(wa, wb, s, q) {
	    if (wa !== wb) {
	      q.push({
	        i: s.push(d3_interpolateTransformPop(s) + "skewX(", null, ")") - 2,
	        x: d3_interpolateNumber(wa, wb)
	      });
	    } else if (wb) {
	      s.push(d3_interpolateTransformPop(s) + "skewX(" + wb + ")");
	    }
	  }
	  function d3_interpolateScale(ka, kb, s, q) {
	    if (ka[0] !== kb[0] || ka[1] !== kb[1]) {
	      var i = s.push(d3_interpolateTransformPop(s) + "scale(", null, ",", null, ")");
	      q.push({
	        i: i - 4,
	        x: d3_interpolateNumber(ka[0], kb[0])
	      }, {
	        i: i - 2,
	        x: d3_interpolateNumber(ka[1], kb[1])
	      });
	    } else if (kb[0] !== 1 || kb[1] !== 1) {
	      s.push(d3_interpolateTransformPop(s) + "scale(" + kb + ")");
	    }
	  }
	  function d3_interpolateTransform(a, b) {
	    var s = [], q = [];
	    a = d3.transform(a), b = d3.transform(b);
	    d3_interpolateTranslate(a.translate, b.translate, s, q);
	    d3_interpolateRotate(a.rotate, b.rotate, s, q);
	    d3_interpolateSkew(a.skew, b.skew, s, q);
	    d3_interpolateScale(a.scale, b.scale, s, q);
	    a = b = null;
	    return function(t) {
	      var i = -1, n = q.length, o;
	      while (++i < n) s[(o = q[i]).i] = o.x(t);
	      return s.join("");
	    };
	  }
	  function d3_uninterpolateNumber(a, b) {
	    b = (b -= a = +a) || 1 / b;
	    return function(x) {
	      return (x - a) / b;
	    };
	  }
	  function d3_uninterpolateClamp(a, b) {
	    b = (b -= a = +a) || 1 / b;
	    return function(x) {
	      return Math.max(0, Math.min(1, (x - a) / b));
	    };
	  }
	  d3.layout = {};
	  d3.layout.bundle = function() {
	    return function(links) {
	      var paths = [], i = -1, n = links.length;
	      while (++i < n) paths.push(d3_layout_bundlePath(links[i]));
	      return paths;
	    };
	  };
	  function d3_layout_bundlePath(link) {
	    var start = link.source, end = link.target, lca = d3_layout_bundleLeastCommonAncestor(start, end), points = [ start ];
	    while (start !== lca) {
	      start = start.parent;
	      points.push(start);
	    }
	    var k = points.length;
	    while (end !== lca) {
	      points.splice(k, 0, end);
	      end = end.parent;
	    }
	    return points;
	  }
	  function d3_layout_bundleAncestors(node) {
	    var ancestors = [], parent = node.parent;
	    while (parent != null) {
	      ancestors.push(node);
	      node = parent;
	      parent = parent.parent;
	    }
	    ancestors.push(node);
	    return ancestors;
	  }
	  function d3_layout_bundleLeastCommonAncestor(a, b) {
	    if (a === b) return a;
	    var aNodes = d3_layout_bundleAncestors(a), bNodes = d3_layout_bundleAncestors(b), aNode = aNodes.pop(), bNode = bNodes.pop(), sharedNode = null;
	    while (aNode === bNode) {
	      sharedNode = aNode;
	      aNode = aNodes.pop();
	      bNode = bNodes.pop();
	    }
	    return sharedNode;
	  }
	  d3.layout.chord = function() {
	    var chord = {}, chords, groups, matrix, n, padding = 0, sortGroups, sortSubgroups, sortChords;
	    function relayout() {
	      var subgroups = {}, groupSums = [], groupIndex = d3.range(n), subgroupIndex = [], k, x, x0, i, j;
	      chords = [];
	      groups = [];
	      k = 0, i = -1;
	      while (++i < n) {
	        x = 0, j = -1;
	        while (++j < n) {
	          x += matrix[i][j];
	        }
	        groupSums.push(x);
	        subgroupIndex.push(d3.range(n));
	        k += x;
	      }
	      if (sortGroups) {
	        groupIndex.sort(function(a, b) {
	          return sortGroups(groupSums[a], groupSums[b]);
	        });
	      }
	      if (sortSubgroups) {
	        subgroupIndex.forEach(function(d, i) {
	          d.sort(function(a, b) {
	            return sortSubgroups(matrix[i][a], matrix[i][b]);
	          });
	        });
	      }
	      k = (τ - padding * n) / k;
	      x = 0, i = -1;
	      while (++i < n) {
	        x0 = x, j = -1;
	        while (++j < n) {
	          var di = groupIndex[i], dj = subgroupIndex[di][j], v = matrix[di][dj], a0 = x, a1 = x += v * k;
	          subgroups[di + "-" + dj] = {
	            index: di,
	            subindex: dj,
	            startAngle: a0,
	            endAngle: a1,
	            value: v
	          };
	        }
	        groups[di] = {
	          index: di,
	          startAngle: x0,
	          endAngle: x,
	          value: groupSums[di]
	        };
	        x += padding;
	      }
	      i = -1;
	      while (++i < n) {
	        j = i - 1;
	        while (++j < n) {
	          var source = subgroups[i + "-" + j], target = subgroups[j + "-" + i];
	          if (source.value || target.value) {
	            chords.push(source.value < target.value ? {
	              source: target,
	              target: source
	            } : {
	              source: source,
	              target: target
	            });
	          }
	        }
	      }
	      if (sortChords) resort();
	    }
	    function resort() {
	      chords.sort(function(a, b) {
	        return sortChords((a.source.value + a.target.value) / 2, (b.source.value + b.target.value) / 2);
	      });
	    }
	    chord.matrix = function(x) {
	      if (!arguments.length) return matrix;
	      n = (matrix = x) && matrix.length;
	      chords = groups = null;
	      return chord;
	    };
	    chord.padding = function(x) {
	      if (!arguments.length) return padding;
	      padding = x;
	      chords = groups = null;
	      return chord;
	    };
	    chord.sortGroups = function(x) {
	      if (!arguments.length) return sortGroups;
	      sortGroups = x;
	      chords = groups = null;
	      return chord;
	    };
	    chord.sortSubgroups = function(x) {
	      if (!arguments.length) return sortSubgroups;
	      sortSubgroups = x;
	      chords = null;
	      return chord;
	    };
	    chord.sortChords = function(x) {
	      if (!arguments.length) return sortChords;
	      sortChords = x;
	      if (chords) resort();
	      return chord;
	    };
	    chord.chords = function() {
	      if (!chords) relayout();
	      return chords;
	    };
	    chord.groups = function() {
	      if (!groups) relayout();
	      return groups;
	    };
	    return chord;
	  };
	  d3.layout.force = function() {
	    var force = {}, event = d3.dispatch("start", "tick", "end"), timer, size = [ 1, 1 ], drag, alpha, friction = .9, linkDistance = d3_layout_forceLinkDistance, linkStrength = d3_layout_forceLinkStrength, charge = -30, chargeDistance2 = d3_layout_forceChargeDistance2, gravity = .1, theta2 = .64, nodes = [], links = [], distances, strengths, charges;
	    function repulse(node) {
	      return function(quad, x1, _, x2) {
	        if (quad.point !== node) {
	          var dx = quad.cx - node.x, dy = quad.cy - node.y, dw = x2 - x1, dn = dx * dx + dy * dy;
	          if (dw * dw / theta2 < dn) {
	            if (dn < chargeDistance2) {
	              var k = quad.charge / dn;
	              node.px -= dx * k;
	              node.py -= dy * k;
	            }
	            return true;
	          }
	          if (quad.point && dn && dn < chargeDistance2) {
	            var k = quad.pointCharge / dn;
	            node.px -= dx * k;
	            node.py -= dy * k;
	          }
	        }
	        return !quad.charge;
	      };
	    }
	    force.tick = function() {
	      if ((alpha *= .99) < .005) {
	        timer = null;
	        event.end({
	          type: "end",
	          alpha: alpha = 0
	        });
	        return true;
	      }
	      var n = nodes.length, m = links.length, q, i, o, s, t, l, k, x, y;
	      for (i = 0; i < m; ++i) {
	        o = links[i];
	        s = o.source;
	        t = o.target;
	        x = t.x - s.x;
	        y = t.y - s.y;
	        if (l = x * x + y * y) {
	          l = alpha * strengths[i] * ((l = Math.sqrt(l)) - distances[i]) / l;
	          x *= l;
	          y *= l;
	          t.x -= x * (k = s.weight + t.weight ? s.weight / (s.weight + t.weight) : .5);
	          t.y -= y * k;
	          s.x += x * (k = 1 - k);
	          s.y += y * k;
	        }
	      }
	      if (k = alpha * gravity) {
	        x = size[0] / 2;
	        y = size[1] / 2;
	        i = -1;
	        if (k) while (++i < n) {
	          o = nodes[i];
	          o.x += (x - o.x) * k;
	          o.y += (y - o.y) * k;
	        }
	      }
	      if (charge) {
	        d3_layout_forceAccumulate(q = d3.geom.quadtree(nodes), alpha, charges);
	        i = -1;
	        while (++i < n) {
	          if (!(o = nodes[i]).fixed) {
	            q.visit(repulse(o));
	          }
	        }
	      }
	      i = -1;
	      while (++i < n) {
	        o = nodes[i];
	        if (o.fixed) {
	          o.x = o.px;
	          o.y = o.py;
	        } else {
	          o.x -= (o.px - (o.px = o.x)) * friction;
	          o.y -= (o.py - (o.py = o.y)) * friction;
	        }
	      }
	      event.tick({
	        type: "tick",
	        alpha: alpha
	      });
	    };
	    force.nodes = function(x) {
	      if (!arguments.length) return nodes;
	      nodes = x;
	      return force;
	    };
	    force.links = function(x) {
	      if (!arguments.length) return links;
	      links = x;
	      return force;
	    };
	    force.size = function(x) {
	      if (!arguments.length) return size;
	      size = x;
	      return force;
	    };
	    force.linkDistance = function(x) {
	      if (!arguments.length) return linkDistance;
	      linkDistance = typeof x === "function" ? x : +x;
	      return force;
	    };
	    force.distance = force.linkDistance;
	    force.linkStrength = function(x) {
	      if (!arguments.length) return linkStrength;
	      linkStrength = typeof x === "function" ? x : +x;
	      return force;
	    };
	    force.friction = function(x) {
	      if (!arguments.length) return friction;
	      friction = +x;
	      return force;
	    };
	    force.charge = function(x) {
	      if (!arguments.length) return charge;
	      charge = typeof x === "function" ? x : +x;
	      return force;
	    };
	    force.chargeDistance = function(x) {
	      if (!arguments.length) return Math.sqrt(chargeDistance2);
	      chargeDistance2 = x * x;
	      return force;
	    };
	    force.gravity = function(x) {
	      if (!arguments.length) return gravity;
	      gravity = +x;
	      return force;
	    };
	    force.theta = function(x) {
	      if (!arguments.length) return Math.sqrt(theta2);
	      theta2 = x * x;
	      return force;
	    };
	    force.alpha = function(x) {
	      if (!arguments.length) return alpha;
	      x = +x;
	      if (alpha) {
	        if (x > 0) {
	          alpha = x;
	        } else {
	          timer.c = null, timer.t = NaN, timer = null;
	          event.end({
	            type: "end",
	            alpha: alpha = 0
	          });
	        }
	      } else if (x > 0) {
	        event.start({
	          type: "start",
	          alpha: alpha = x
	        });
	        timer = d3_timer(force.tick);
	      }
	      return force;
	    };
	    force.start = function() {
	      var i, n = nodes.length, m = links.length, w = size[0], h = size[1], neighbors, o;
	      for (i = 0; i < n; ++i) {
	        (o = nodes[i]).index = i;
	        o.weight = 0;
	      }
	      for (i = 0; i < m; ++i) {
	        o = links[i];
	        if (typeof o.source == "number") o.source = nodes[o.source];
	        if (typeof o.target == "number") o.target = nodes[o.target];
	        ++o.source.weight;
	        ++o.target.weight;
	      }
	      for (i = 0; i < n; ++i) {
	        o = nodes[i];
	        if (isNaN(o.x)) o.x = position("x", w);
	        if (isNaN(o.y)) o.y = position("y", h);
	        if (isNaN(o.px)) o.px = o.x;
	        if (isNaN(o.py)) o.py = o.y;
	      }
	      distances = [];
	      if (typeof linkDistance === "function") for (i = 0; i < m; ++i) distances[i] = +linkDistance.call(this, links[i], i); else for (i = 0; i < m; ++i) distances[i] = linkDistance;
	      strengths = [];
	      if (typeof linkStrength === "function") for (i = 0; i < m; ++i) strengths[i] = +linkStrength.call(this, links[i], i); else for (i = 0; i < m; ++i) strengths[i] = linkStrength;
	      charges = [];
	      if (typeof charge === "function") for (i = 0; i < n; ++i) charges[i] = +charge.call(this, nodes[i], i); else for (i = 0; i < n; ++i) charges[i] = charge;
	      function position(dimension, size) {
	        if (!neighbors) {
	          neighbors = new Array(n);
	          for (j = 0; j < n; ++j) {
	            neighbors[j] = [];
	          }
	          for (j = 0; j < m; ++j) {
	            var o = links[j];
	            neighbors[o.source.index].push(o.target);
	            neighbors[o.target.index].push(o.source);
	          }
	        }
	        var candidates = neighbors[i], j = -1, l = candidates.length, x;
	        while (++j < l) if (!isNaN(x = candidates[j][dimension])) return x;
	        return Math.random() * size;
	      }
	      return force.resume();
	    };
	    force.resume = function() {
	      return force.alpha(.1);
	    };
	    force.stop = function() {
	      return force.alpha(0);
	    };
	    force.drag = function() {
	      if (!drag) drag = d3.behavior.drag().origin(d3_identity).on("dragstart.force", d3_layout_forceDragstart).on("drag.force", dragmove).on("dragend.force", d3_layout_forceDragend);
	      if (!arguments.length) return drag;
	      this.on("mouseover.force", d3_layout_forceMouseover).on("mouseout.force", d3_layout_forceMouseout).call(drag);
	    };
	    function dragmove(d) {
	      d.px = d3.event.x, d.py = d3.event.y;
	      force.resume();
	    }
	    return d3.rebind(force, event, "on");
	  };
	  function d3_layout_forceDragstart(d) {
	    d.fixed |= 2;
	  }
	  function d3_layout_forceDragend(d) {
	    d.fixed &= ~6;
	  }
	  function d3_layout_forceMouseover(d) {
	    d.fixed |= 4;
	    d.px = d.x, d.py = d.y;
	  }
	  function d3_layout_forceMouseout(d) {
	    d.fixed &= ~4;
	  }
	  function d3_layout_forceAccumulate(quad, alpha, charges) {
	    var cx = 0, cy = 0;
	    quad.charge = 0;
	    if (!quad.leaf) {
	      var nodes = quad.nodes, n = nodes.length, i = -1, c;
	      while (++i < n) {
	        c = nodes[i];
	        if (c == null) continue;
	        d3_layout_forceAccumulate(c, alpha, charges);
	        quad.charge += c.charge;
	        cx += c.charge * c.cx;
	        cy += c.charge * c.cy;
	      }
	    }
	    if (quad.point) {
	      if (!quad.leaf) {
	        quad.point.x += Math.random() - .5;
	        quad.point.y += Math.random() - .5;
	      }
	      var k = alpha * charges[quad.point.index];
	      quad.charge += quad.pointCharge = k;
	      cx += k * quad.point.x;
	      cy += k * quad.point.y;
	    }
	    quad.cx = cx / quad.charge;
	    quad.cy = cy / quad.charge;
	  }
	  var d3_layout_forceLinkDistance = 20, d3_layout_forceLinkStrength = 1, d3_layout_forceChargeDistance2 = Infinity;
	  d3.layout.hierarchy = function() {
	    var sort = d3_layout_hierarchySort, children = d3_layout_hierarchyChildren, value = d3_layout_hierarchyValue;
	    function hierarchy(root) {
	      var stack = [ root ], nodes = [], node;
	      root.depth = 0;
	      while ((node = stack.pop()) != null) {
	        nodes.push(node);
	        if ((childs = children.call(hierarchy, node, node.depth)) && (n = childs.length)) {
	          var n, childs, child;
	          while (--n >= 0) {
	            stack.push(child = childs[n]);
	            child.parent = node;
	            child.depth = node.depth + 1;
	          }
	          if (value) node.value = 0;
	          node.children = childs;
	        } else {
	          if (value) node.value = +value.call(hierarchy, node, node.depth) || 0;
	          delete node.children;
	        }
	      }
	      d3_layout_hierarchyVisitAfter(root, function(node) {
	        var childs, parent;
	        if (sort && (childs = node.children)) childs.sort(sort);
	        if (value && (parent = node.parent)) parent.value += node.value;
	      });
	      return nodes;
	    }
	    hierarchy.sort = function(x) {
	      if (!arguments.length) return sort;
	      sort = x;
	      return hierarchy;
	    };
	    hierarchy.children = function(x) {
	      if (!arguments.length) return children;
	      children = x;
	      return hierarchy;
	    };
	    hierarchy.value = function(x) {
	      if (!arguments.length) return value;
	      value = x;
	      return hierarchy;
	    };
	    hierarchy.revalue = function(root) {
	      if (value) {
	        d3_layout_hierarchyVisitBefore(root, function(node) {
	          if (node.children) node.value = 0;
	        });
	        d3_layout_hierarchyVisitAfter(root, function(node) {
	          var parent;
	          if (!node.children) node.value = +value.call(hierarchy, node, node.depth) || 0;
	          if (parent = node.parent) parent.value += node.value;
	        });
	      }
	      return root;
	    };
	    return hierarchy;
	  };
	  function d3_layout_hierarchyRebind(object, hierarchy) {
	    d3.rebind(object, hierarchy, "sort", "children", "value");
	    object.nodes = object;
	    object.links = d3_layout_hierarchyLinks;
	    return object;
	  }
	  function d3_layout_hierarchyVisitBefore(node, callback) {
	    var nodes = [ node ];
	    while ((node = nodes.pop()) != null) {
	      callback(node);
	      if ((children = node.children) && (n = children.length)) {
	        var n, children;
	        while (--n >= 0) nodes.push(children[n]);
	      }
	    }
	  }
	  function d3_layout_hierarchyVisitAfter(node, callback) {
	    var nodes = [ node ], nodes2 = [];
	    while ((node = nodes.pop()) != null) {
	      nodes2.push(node);
	      if ((children = node.children) && (n = children.length)) {
	        var i = -1, n, children;
	        while (++i < n) nodes.push(children[i]);
	      }
	    }
	    while ((node = nodes2.pop()) != null) {
	      callback(node);
	    }
	  }
	  function d3_layout_hierarchyChildren(d) {
	    return d.children;
	  }
	  function d3_layout_hierarchyValue(d) {
	    return d.value;
	  }
	  function d3_layout_hierarchySort(a, b) {
	    return b.value - a.value;
	  }
	  function d3_layout_hierarchyLinks(nodes) {
	    return d3.merge(nodes.map(function(parent) {
	      return (parent.children || []).map(function(child) {
	        return {
	          source: parent,
	          target: child
	        };
	      });
	    }));
	  }
	  d3.layout.partition = function() {
	    var hierarchy = d3.layout.hierarchy(), size = [ 1, 1 ];
	    function position(node, x, dx, dy) {
	      var children = node.children;
	      node.x = x;
	      node.y = node.depth * dy;
	      node.dx = dx;
	      node.dy = dy;
	      if (children && (n = children.length)) {
	        var i = -1, n, c, d;
	        dx = node.value ? dx / node.value : 0;
	        while (++i < n) {
	          position(c = children[i], x, d = c.value * dx, dy);
	          x += d;
	        }
	      }
	    }
	    function depth(node) {
	      var children = node.children, d = 0;
	      if (children && (n = children.length)) {
	        var i = -1, n;
	        while (++i < n) d = Math.max(d, depth(children[i]));
	      }
	      return 1 + d;
	    }
	    function partition(d, i) {
	      var nodes = hierarchy.call(this, d, i);
	      position(nodes[0], 0, size[0], size[1] / depth(nodes[0]));
	      return nodes;
	    }
	    partition.size = function(x) {
	      if (!arguments.length) return size;
	      size = x;
	      return partition;
	    };
	    return d3_layout_hierarchyRebind(partition, hierarchy);
	  };
	  d3.layout.pie = function() {
	    var value = Number, sort = d3_layout_pieSortByValue, startAngle = 0, endAngle = τ, padAngle = 0;
	    function pie(data) {
	      var n = data.length, values = data.map(function(d, i) {
	        return +value.call(pie, d, i);
	      }), a = +(typeof startAngle === "function" ? startAngle.apply(this, arguments) : startAngle), da = (typeof endAngle === "function" ? endAngle.apply(this, arguments) : endAngle) - a, p = Math.min(Math.abs(da) / n, +(typeof padAngle === "function" ? padAngle.apply(this, arguments) : padAngle)), pa = p * (da < 0 ? -1 : 1), sum = d3.sum(values), k = sum ? (da - n * pa) / sum : 0, index = d3.range(n), arcs = [], v;
	      if (sort != null) index.sort(sort === d3_layout_pieSortByValue ? function(i, j) {
	        return values[j] - values[i];
	      } : function(i, j) {
	        return sort(data[i], data[j]);
	      });
	      index.forEach(function(i) {
	        arcs[i] = {
	          data: data[i],
	          value: v = values[i],
	          startAngle: a,
	          endAngle: a += v * k + pa,
	          padAngle: p
	        };
	      });
	      return arcs;
	    }
	    pie.value = function(_) {
	      if (!arguments.length) return value;
	      value = _;
	      return pie;
	    };
	    pie.sort = function(_) {
	      if (!arguments.length) return sort;
	      sort = _;
	      return pie;
	    };
	    pie.startAngle = function(_) {
	      if (!arguments.length) return startAngle;
	      startAngle = _;
	      return pie;
	    };
	    pie.endAngle = function(_) {
	      if (!arguments.length) return endAngle;
	      endAngle = _;
	      return pie;
	    };
	    pie.padAngle = function(_) {
	      if (!arguments.length) return padAngle;
	      padAngle = _;
	      return pie;
	    };
	    return pie;
	  };
	  var d3_layout_pieSortByValue = {};
	  d3.layout.stack = function() {
	    var values = d3_identity, order = d3_layout_stackOrderDefault, offset = d3_layout_stackOffsetZero, out = d3_layout_stackOut, x = d3_layout_stackX, y = d3_layout_stackY;
	    function stack(data, index) {
	      if (!(n = data.length)) return data;
	      var series = data.map(function(d, i) {
	        return values.call(stack, d, i);
	      });
	      var points = series.map(function(d) {
	        return d.map(function(v, i) {
	          return [ x.call(stack, v, i), y.call(stack, v, i) ];
	        });
	      });
	      var orders = order.call(stack, points, index);
	      series = d3.permute(series, orders);
	      points = d3.permute(points, orders);
	      var offsets = offset.call(stack, points, index);
	      var m = series[0].length, n, i, j, o;
	      for (j = 0; j < m; ++j) {
	        out.call(stack, series[0][j], o = offsets[j], points[0][j][1]);
	        for (i = 1; i < n; ++i) {
	          out.call(stack, series[i][j], o += points[i - 1][j][1], points[i][j][1]);
	        }
	      }
	      return data;
	    }
	    stack.values = function(x) {
	      if (!arguments.length) return values;
	      values = x;
	      return stack;
	    };
	    stack.order = function(x) {
	      if (!arguments.length) return order;
	      order = typeof x === "function" ? x : d3_layout_stackOrders.get(x) || d3_layout_stackOrderDefault;
	      return stack;
	    };
	    stack.offset = function(x) {
	      if (!arguments.length) return offset;
	      offset = typeof x === "function" ? x : d3_layout_stackOffsets.get(x) || d3_layout_stackOffsetZero;
	      return stack;
	    };
	    stack.x = function(z) {
	      if (!arguments.length) return x;
	      x = z;
	      return stack;
	    };
	    stack.y = function(z) {
	      if (!arguments.length) return y;
	      y = z;
	      return stack;
	    };
	    stack.out = function(z) {
	      if (!arguments.length) return out;
	      out = z;
	      return stack;
	    };
	    return stack;
	  };
	  function d3_layout_stackX(d) {
	    return d.x;
	  }
	  function d3_layout_stackY(d) {
	    return d.y;
	  }
	  function d3_layout_stackOut(d, y0, y) {
	    d.y0 = y0;
	    d.y = y;
	  }
	  var d3_layout_stackOrders = d3.map({
	    "inside-out": function(data) {
	      var n = data.length, i, j, max = data.map(d3_layout_stackMaxIndex), sums = data.map(d3_layout_stackReduceSum), index = d3.range(n).sort(function(a, b) {
	        return max[a] - max[b];
	      }), top = 0, bottom = 0, tops = [], bottoms = [];
	      for (i = 0; i < n; ++i) {
	        j = index[i];
	        if (top < bottom) {
	          top += sums[j];
	          tops.push(j);
	        } else {
	          bottom += sums[j];
	          bottoms.push(j);
	        }
	      }
	      return bottoms.reverse().concat(tops);
	    },
	    reverse: function(data) {
	      return d3.range(data.length).reverse();
	    },
	    "default": d3_layout_stackOrderDefault
	  });
	  var d3_layout_stackOffsets = d3.map({
	    silhouette: function(data) {
	      var n = data.length, m = data[0].length, sums = [], max = 0, i, j, o, y0 = [];
	      for (j = 0; j < m; ++j) {
	        for (i = 0, o = 0; i < n; i++) o += data[i][j][1];
	        if (o > max) max = o;
	        sums.push(o);
	      }
	      for (j = 0; j < m; ++j) {
	        y0[j] = (max - sums[j]) / 2;
	      }
	      return y0;
	    },
	    wiggle: function(data) {
	      var n = data.length, x = data[0], m = x.length, i, j, k, s1, s2, s3, dx, o, o0, y0 = [];
	      y0[0] = o = o0 = 0;
	      for (j = 1; j < m; ++j) {
	        for (i = 0, s1 = 0; i < n; ++i) s1 += data[i][j][1];
	        for (i = 0, s2 = 0, dx = x[j][0] - x[j - 1][0]; i < n; ++i) {
	          for (k = 0, s3 = (data[i][j][1] - data[i][j - 1][1]) / (2 * dx); k < i; ++k) {
	            s3 += (data[k][j][1] - data[k][j - 1][1]) / dx;
	          }
	          s2 += s3 * data[i][j][1];
	        }
	        y0[j] = o -= s1 ? s2 / s1 * dx : 0;
	        if (o < o0) o0 = o;
	      }
	      for (j = 0; j < m; ++j) y0[j] -= o0;
	      return y0;
	    },
	    expand: function(data) {
	      var n = data.length, m = data[0].length, k = 1 / n, i, j, o, y0 = [];
	      for (j = 0; j < m; ++j) {
	        for (i = 0, o = 0; i < n; i++) o += data[i][j][1];
	        if (o) for (i = 0; i < n; i++) data[i][j][1] /= o; else for (i = 0; i < n; i++) data[i][j][1] = k;
	      }
	      for (j = 0; j < m; ++j) y0[j] = 0;
	      return y0;
	    },
	    zero: d3_layout_stackOffsetZero
	  });
	  function d3_layout_stackOrderDefault(data) {
	    return d3.range(data.length);
	  }
	  function d3_layout_stackOffsetZero(data) {
	    var j = -1, m = data[0].length, y0 = [];
	    while (++j < m) y0[j] = 0;
	    return y0;
	  }
	  function d3_layout_stackMaxIndex(array) {
	    var i = 1, j = 0, v = array[0][1], k, n = array.length;
	    for (;i < n; ++i) {
	      if ((k = array[i][1]) > v) {
	        j = i;
	        v = k;
	      }
	    }
	    return j;
	  }
	  function d3_layout_stackReduceSum(d) {
	    return d.reduce(d3_layout_stackSum, 0);
	  }
	  function d3_layout_stackSum(p, d) {
	    return p + d[1];
	  }
	  d3.layout.histogram = function() {
	    var frequency = true, valuer = Number, ranger = d3_layout_histogramRange, binner = d3_layout_histogramBinSturges;
	    function histogram(data, i) {
	      var bins = [], values = data.map(valuer, this), range = ranger.call(this, values, i), thresholds = binner.call(this, range, values, i), bin, i = -1, n = values.length, m = thresholds.length - 1, k = frequency ? 1 : 1 / n, x;
	      while (++i < m) {
	        bin = bins[i] = [];
	        bin.dx = thresholds[i + 1] - (bin.x = thresholds[i]);
	        bin.y = 0;
	      }
	      if (m > 0) {
	        i = -1;
	        while (++i < n) {
	          x = values[i];
	          if (x >= range[0] && x <= range[1]) {
	            bin = bins[d3.bisect(thresholds, x, 1, m) - 1];
	            bin.y += k;
	            bin.push(data[i]);
	          }
	        }
	      }
	      return bins;
	    }
	    histogram.value = function(x) {
	      if (!arguments.length) return valuer;
	      valuer = x;
	      return histogram;
	    };
	    histogram.range = function(x) {
	      if (!arguments.length) return ranger;
	      ranger = d3_functor(x);
	      return histogram;
	    };
	    histogram.bins = function(x) {
	      if (!arguments.length) return binner;
	      binner = typeof x === "number" ? function(range) {
	        return d3_layout_histogramBinFixed(range, x);
	      } : d3_functor(x);
	      return histogram;
	    };
	    histogram.frequency = function(x) {
	      if (!arguments.length) return frequency;
	      frequency = !!x;
	      return histogram;
	    };
	    return histogram;
	  };
	  function d3_layout_histogramBinSturges(range, values) {
	    return d3_layout_histogramBinFixed(range, Math.ceil(Math.log(values.length) / Math.LN2 + 1));
	  }
	  function d3_layout_histogramBinFixed(range, n) {
	    var x = -1, b = +range[0], m = (range[1] - b) / n, f = [];
	    while (++x <= n) f[x] = m * x + b;
	    return f;
	  }
	  function d3_layout_histogramRange(values) {
	    return [ d3.min(values), d3.max(values) ];
	  }
	  d3.layout.pack = function() {
	    var hierarchy = d3.layout.hierarchy().sort(d3_layout_packSort), padding = 0, size = [ 1, 1 ], radius;
	    function pack(d, i) {
	      var nodes = hierarchy.call(this, d, i), root = nodes[0], w = size[0], h = size[1], r = radius == null ? Math.sqrt : typeof radius === "function" ? radius : function() {
	        return radius;
	      };
	      root.x = root.y = 0;
	      d3_layout_hierarchyVisitAfter(root, function(d) {
	        d.r = +r(d.value);
	      });
	      d3_layout_hierarchyVisitAfter(root, d3_layout_packSiblings);
	      if (padding) {
	        var dr = padding * (radius ? 1 : Math.max(2 * root.r / w, 2 * root.r / h)) / 2;
	        d3_layout_hierarchyVisitAfter(root, function(d) {
	          d.r += dr;
	        });
	        d3_layout_hierarchyVisitAfter(root, d3_layout_packSiblings);
	        d3_layout_hierarchyVisitAfter(root, function(d) {
	          d.r -= dr;
	        });
	      }
	      d3_layout_packTransform(root, w / 2, h / 2, radius ? 1 : 1 / Math.max(2 * root.r / w, 2 * root.r / h));
	      return nodes;
	    }
	    pack.size = function(_) {
	      if (!arguments.length) return size;
	      size = _;
	      return pack;
	    };
	    pack.radius = function(_) {
	      if (!arguments.length) return radius;
	      radius = _ == null || typeof _ === "function" ? _ : +_;
	      return pack;
	    };
	    pack.padding = function(_) {
	      if (!arguments.length) return padding;
	      padding = +_;
	      return pack;
	    };
	    return d3_layout_hierarchyRebind(pack, hierarchy);
	  };
	  function d3_layout_packSort(a, b) {
	    return a.value - b.value;
	  }
	  function d3_layout_packInsert(a, b) {
	    var c = a._pack_next;
	    a._pack_next = b;
	    b._pack_prev = a;
	    b._pack_next = c;
	    c._pack_prev = b;
	  }
	  function d3_layout_packSplice(a, b) {
	    a._pack_next = b;
	    b._pack_prev = a;
	  }
	  function d3_layout_packIntersects(a, b) {
	    var dx = b.x - a.x, dy = b.y - a.y, dr = a.r + b.r;
	    return .999 * dr * dr > dx * dx + dy * dy;
	  }
	  function d3_layout_packSiblings(node) {
	    if (!(nodes = node.children) || !(n = nodes.length)) return;
	    var nodes, xMin = Infinity, xMax = -Infinity, yMin = Infinity, yMax = -Infinity, a, b, c, i, j, k, n;
	    function bound(node) {
	      xMin = Math.min(node.x - node.r, xMin);
	      xMax = Math.max(node.x + node.r, xMax);
	      yMin = Math.min(node.y - node.r, yMin);
	      yMax = Math.max(node.y + node.r, yMax);
	    }
	    nodes.forEach(d3_layout_packLink);
	    a = nodes[0];
	    a.x = -a.r;
	    a.y = 0;
	    bound(a);
	    if (n > 1) {
	      b = nodes[1];
	      b.x = b.r;
	      b.y = 0;
	      bound(b);
	      if (n > 2) {
	        c = nodes[2];
	        d3_layout_packPlace(a, b, c);
	        bound(c);
	        d3_layout_packInsert(a, c);
	        a._pack_prev = c;
	        d3_layout_packInsert(c, b);
	        b = a._pack_next;
	        for (i = 3; i < n; i++) {
	          d3_layout_packPlace(a, b, c = nodes[i]);
	          var isect = 0, s1 = 1, s2 = 1;
	          for (j = b._pack_next; j !== b; j = j._pack_next, s1++) {
	            if (d3_layout_packIntersects(j, c)) {
	              isect = 1;
	              break;
	            }
	          }
	          if (isect == 1) {
	            for (k = a._pack_prev; k !== j._pack_prev; k = k._pack_prev, s2++) {
	              if (d3_layout_packIntersects(k, c)) {
	                break;
	              }
	            }
	          }
	          if (isect) {
	            if (s1 < s2 || s1 == s2 && b.r < a.r) d3_layout_packSplice(a, b = j); else d3_layout_packSplice(a = k, b);
	            i--;
	          } else {
	            d3_layout_packInsert(a, c);
	            b = c;
	            bound(c);
	          }
	        }
	      }
	    }
	    var cx = (xMin + xMax) / 2, cy = (yMin + yMax) / 2, cr = 0;
	    for (i = 0; i < n; i++) {
	      c = nodes[i];
	      c.x -= cx;
	      c.y -= cy;
	      cr = Math.max(cr, c.r + Math.sqrt(c.x * c.x + c.y * c.y));
	    }
	    node.r = cr;
	    nodes.forEach(d3_layout_packUnlink);
	  }
	  function d3_layout_packLink(node) {
	    node._pack_next = node._pack_prev = node;
	  }
	  function d3_layout_packUnlink(node) {
	    delete node._pack_next;
	    delete node._pack_prev;
	  }
	  function d3_layout_packTransform(node, x, y, k) {
	    var children = node.children;
	    node.x = x += k * node.x;
	    node.y = y += k * node.y;
	    node.r *= k;
	    if (children) {
	      var i = -1, n = children.length;
	      while (++i < n) d3_layout_packTransform(children[i], x, y, k);
	    }
	  }
	  function d3_layout_packPlace(a, b, c) {
	    var db = a.r + c.r, dx = b.x - a.x, dy = b.y - a.y;
	    if (db && (dx || dy)) {
	      var da = b.r + c.r, dc = dx * dx + dy * dy;
	      da *= da;
	      db *= db;
	      var x = .5 + (db - da) / (2 * dc), y = Math.sqrt(Math.max(0, 2 * da * (db + dc) - (db -= dc) * db - da * da)) / (2 * dc);
	      c.x = a.x + x * dx + y * dy;
	      c.y = a.y + x * dy - y * dx;
	    } else {
	      c.x = a.x + db;
	      c.y = a.y;
	    }
	  }
	  d3.layout.tree = function() {
	    var hierarchy = d3.layout.hierarchy().sort(null).value(null), separation = d3_layout_treeSeparation, size = [ 1, 1 ], nodeSize = null;
	    function tree(d, i) {
	      var nodes = hierarchy.call(this, d, i), root0 = nodes[0], root1 = wrapTree(root0);
	      d3_layout_hierarchyVisitAfter(root1, firstWalk), root1.parent.m = -root1.z;
	      d3_layout_hierarchyVisitBefore(root1, secondWalk);
	      if (nodeSize) d3_layout_hierarchyVisitBefore(root0, sizeNode); else {
	        var left = root0, right = root0, bottom = root0;
	        d3_layout_hierarchyVisitBefore(root0, function(node) {
	          if (node.x < left.x) left = node;
	          if (node.x > right.x) right = node;
	          if (node.depth > bottom.depth) bottom = node;
	        });
	        var tx = separation(left, right) / 2 - left.x, kx = size[0] / (right.x + separation(right, left) / 2 + tx), ky = size[1] / (bottom.depth || 1);
	        d3_layout_hierarchyVisitBefore(root0, function(node) {
	          node.x = (node.x + tx) * kx;
	          node.y = node.depth * ky;
	        });
	      }
	      return nodes;
	    }
	    function wrapTree(root0) {
	      var root1 = {
	        A: null,
	        children: [ root0 ]
	      }, queue = [ root1 ], node1;
	      while ((node1 = queue.pop()) != null) {
	        for (var children = node1.children, child, i = 0, n = children.length; i < n; ++i) {
	          queue.push((children[i] = child = {
	            _: children[i],
	            parent: node1,
	            children: (child = children[i].children) && child.slice() || [],
	            A: null,
	            a: null,
	            z: 0,
	            m: 0,
	            c: 0,
	            s: 0,
	            t: null,
	            i: i
	          }).a = child);
	        }
	      }
	      return root1.children[0];
	    }
	    function firstWalk(v) {
	      var children = v.children, siblings = v.parent.children, w = v.i ? siblings[v.i - 1] : null;
	      if (children.length) {
	        d3_layout_treeShift(v);
	        var midpoint = (children[0].z + children[children.length - 1].z) / 2;
	        if (w) {
	          v.z = w.z + separation(v._, w._);
	          v.m = v.z - midpoint;
	        } else {
	          v.z = midpoint;
	        }
	      } else if (w) {
	        v.z = w.z + separation(v._, w._);
	      }
	      v.parent.A = apportion(v, w, v.parent.A || siblings[0]);
	    }
	    function secondWalk(v) {
	      v._.x = v.z + v.parent.m;
	      v.m += v.parent.m;
	    }
	    function apportion(v, w, ancestor) {
	      if (w) {
	        var vip = v, vop = v, vim = w, vom = vip.parent.children[0], sip = vip.m, sop = vop.m, sim = vim.m, som = vom.m, shift;
	        while (vim = d3_layout_treeRight(vim), vip = d3_layout_treeLeft(vip), vim && vip) {
	          vom = d3_layout_treeLeft(vom);
	          vop = d3_layout_treeRight(vop);
	          vop.a = v;
	          shift = vim.z + sim - vip.z - sip + separation(vim._, vip._);
	          if (shift > 0) {
	            d3_layout_treeMove(d3_layout_treeAncestor(vim, v, ancestor), v, shift);
	            sip += shift;
	            sop += shift;
	          }
	          sim += vim.m;
	          sip += vip.m;
	          som += vom.m;
	          sop += vop.m;
	        }
	        if (vim && !d3_layout_treeRight(vop)) {
	          vop.t = vim;
	          vop.m += sim - sop;
	        }
	        if (vip && !d3_layout_treeLeft(vom)) {
	          vom.t = vip;
	          vom.m += sip - som;
	          ancestor = v;
	        }
	      }
	      return ancestor;
	    }
	    function sizeNode(node) {
	      node.x *= size[0];
	      node.y = node.depth * size[1];
	    }
	    tree.separation = function(x) {
	      if (!arguments.length) return separation;
	      separation = x;
	      return tree;
	    };
	    tree.size = function(x) {
	      if (!arguments.length) return nodeSize ? null : size;
	      nodeSize = (size = x) == null ? sizeNode : null;
	      return tree;
	    };
	    tree.nodeSize = function(x) {
	      if (!arguments.length) return nodeSize ? size : null;
	      nodeSize = (size = x) == null ? null : sizeNode;
	      return tree;
	    };
	    return d3_layout_hierarchyRebind(tree, hierarchy);
	  };
	  function d3_layout_treeSeparation(a, b) {
	    return a.parent == b.parent ? 1 : 2;
	  }
	  function d3_layout_treeLeft(v) {
	    var children = v.children;
	    return children.length ? children[0] : v.t;
	  }
	  function d3_layout_treeRight(v) {
	    var children = v.children, n;
	    return (n = children.length) ? children[n - 1] : v.t;
	  }
	  function d3_layout_treeMove(wm, wp, shift) {
	    var change = shift / (wp.i - wm.i);
	    wp.c -= change;
	    wp.s += shift;
	    wm.c += change;
	    wp.z += shift;
	    wp.m += shift;
	  }
	  function d3_layout_treeShift(v) {
	    var shift = 0, change = 0, children = v.children, i = children.length, w;
	    while (--i >= 0) {
	      w = children[i];
	      w.z += shift;
	      w.m += shift;
	      shift += w.s + (change += w.c);
	    }
	  }
	  function d3_layout_treeAncestor(vim, v, ancestor) {
	    return vim.a.parent === v.parent ? vim.a : ancestor;
	  }
	  d3.layout.cluster = function() {
	    var hierarchy = d3.layout.hierarchy().sort(null).value(null), separation = d3_layout_treeSeparation, size = [ 1, 1 ], nodeSize = false;
	    function cluster(d, i) {
	      var nodes = hierarchy.call(this, d, i), root = nodes[0], previousNode, x = 0;
	      d3_layout_hierarchyVisitAfter(root, function(node) {
	        var children = node.children;
	        if (children && children.length) {
	          node.x = d3_layout_clusterX(children);
	          node.y = d3_layout_clusterY(children);
	        } else {
	          node.x = previousNode ? x += separation(node, previousNode) : 0;
	          node.y = 0;
	          previousNode = node;
	        }
	      });
	      var left = d3_layout_clusterLeft(root), right = d3_layout_clusterRight(root), x0 = left.x - separation(left, right) / 2, x1 = right.x + separation(right, left) / 2;
	      d3_layout_hierarchyVisitAfter(root, nodeSize ? function(node) {
	        node.x = (node.x - root.x) * size[0];
	        node.y = (root.y - node.y) * size[1];
	      } : function(node) {
	        node.x = (node.x - x0) / (x1 - x0) * size[0];
	        node.y = (1 - (root.y ? node.y / root.y : 1)) * size[1];
	      });
	      return nodes;
	    }
	    cluster.separation = function(x) {
	      if (!arguments.length) return separation;
	      separation = x;
	      return cluster;
	    };
	    cluster.size = function(x) {
	      if (!arguments.length) return nodeSize ? null : size;
	      nodeSize = (size = x) == null;
	      return cluster;
	    };
	    cluster.nodeSize = function(x) {
	      if (!arguments.length) return nodeSize ? size : null;
	      nodeSize = (size = x) != null;
	      return cluster;
	    };
	    return d3_layout_hierarchyRebind(cluster, hierarchy);
	  };
	  function d3_layout_clusterY(children) {
	    return 1 + d3.max(children, function(child) {
	      return child.y;
	    });
	  }
	  function d3_layout_clusterX(children) {
	    return children.reduce(function(x, child) {
	      return x + child.x;
	    }, 0) / children.length;
	  }
	  function d3_layout_clusterLeft(node) {
	    var children = node.children;
	    return children && children.length ? d3_layout_clusterLeft(children[0]) : node;
	  }
	  function d3_layout_clusterRight(node) {
	    var children = node.children, n;
	    return children && (n = children.length) ? d3_layout_clusterRight(children[n - 1]) : node;
	  }
	  d3.layout.treemap = function() {
	    var hierarchy = d3.layout.hierarchy(), round = Math.round, size = [ 1, 1 ], padding = null, pad = d3_layout_treemapPadNull, sticky = false, stickies, mode = "squarify", ratio = .5 * (1 + Math.sqrt(5));
	    function scale(children, k) {
	      var i = -1, n = children.length, child, area;
	      while (++i < n) {
	        area = (child = children[i]).value * (k < 0 ? 0 : k);
	        child.area = isNaN(area) || area <= 0 ? 0 : area;
	      }
	    }
	    function squarify(node) {
	      var children = node.children;
	      if (children && children.length) {
	        var rect = pad(node), row = [], remaining = children.slice(), child, best = Infinity, score, u = mode === "slice" ? rect.dx : mode === "dice" ? rect.dy : mode === "slice-dice" ? node.depth & 1 ? rect.dy : rect.dx : Math.min(rect.dx, rect.dy), n;
	        scale(remaining, rect.dx * rect.dy / node.value);
	        row.area = 0;
	        while ((n = remaining.length) > 0) {
	          row.push(child = remaining[n - 1]);
	          row.area += child.area;
	          if (mode !== "squarify" || (score = worst(row, u)) <= best) {
	            remaining.pop();
	            best = score;
	          } else {
	            row.area -= row.pop().area;
	            position(row, u, rect, false);
	            u = Math.min(rect.dx, rect.dy);
	            row.length = row.area = 0;
	            best = Infinity;
	          }
	        }
	        if (row.length) {
	          position(row, u, rect, true);
	          row.length = row.area = 0;
	        }
	        children.forEach(squarify);
	      }
	    }
	    function stickify(node) {
	      var children = node.children;
	      if (children && children.length) {
	        var rect = pad(node), remaining = children.slice(), child, row = [];
	        scale(remaining, rect.dx * rect.dy / node.value);
	        row.area = 0;
	        while (child = remaining.pop()) {
	          row.push(child);
	          row.area += child.area;
	          if (child.z != null) {
	            position(row, child.z ? rect.dx : rect.dy, rect, !remaining.length);
	            row.length = row.area = 0;
	          }
	        }
	        children.forEach(stickify);
	      }
	    }
	    function worst(row, u) {
	      var s = row.area, r, rmax = 0, rmin = Infinity, i = -1, n = row.length;
	      while (++i < n) {
	        if (!(r = row[i].area)) continue;
	        if (r < rmin) rmin = r;
	        if (r > rmax) rmax = r;
	      }
	      s *= s;
	      u *= u;
	      return s ? Math.max(u * rmax * ratio / s, s / (u * rmin * ratio)) : Infinity;
	    }
	    function position(row, u, rect, flush) {
	      var i = -1, n = row.length, x = rect.x, y = rect.y, v = u ? round(row.area / u) : 0, o;
	      if (u == rect.dx) {
	        if (flush || v > rect.dy) v = rect.dy;
	        while (++i < n) {
	          o = row[i];
	          o.x = x;
	          o.y = y;
	          o.dy = v;
	          x += o.dx = Math.min(rect.x + rect.dx - x, v ? round(o.area / v) : 0);
	        }
	        o.z = true;
	        o.dx += rect.x + rect.dx - x;
	        rect.y += v;
	        rect.dy -= v;
	      } else {
	        if (flush || v > rect.dx) v = rect.dx;
	        while (++i < n) {
	          o = row[i];
	          o.x = x;
	          o.y = y;
	          o.dx = v;
	          y += o.dy = Math.min(rect.y + rect.dy - y, v ? round(o.area / v) : 0);
	        }
	        o.z = false;
	        o.dy += rect.y + rect.dy - y;
	        rect.x += v;
	        rect.dx -= v;
	      }
	    }
	    function treemap(d) {
	      var nodes = stickies || hierarchy(d), root = nodes[0];
	      root.x = root.y = 0;
	      if (root.value) root.dx = size[0], root.dy = size[1]; else root.dx = root.dy = 0;
	      if (stickies) hierarchy.revalue(root);
	      scale([ root ], root.dx * root.dy / root.value);
	      (stickies ? stickify : squarify)(root);
	      if (sticky) stickies = nodes;
	      return nodes;
	    }
	    treemap.size = function(x) {
	      if (!arguments.length) return size;
	      size = x;
	      return treemap;
	    };
	    treemap.padding = function(x) {
	      if (!arguments.length) return padding;
	      function padFunction(node) {
	        var p = x.call(treemap, node, node.depth);
	        return p == null ? d3_layout_treemapPadNull(node) : d3_layout_treemapPad(node, typeof p === "number" ? [ p, p, p, p ] : p);
	      }
	      function padConstant(node) {
	        return d3_layout_treemapPad(node, x);
	      }
	      var type;
	      pad = (padding = x) == null ? d3_layout_treemapPadNull : (type = typeof x) === "function" ? padFunction : type === "number" ? (x = [ x, x, x, x ], 
	      padConstant) : padConstant;
	      return treemap;
	    };
	    treemap.round = function(x) {
	      if (!arguments.length) return round != Number;
	      round = x ? Math.round : Number;
	      return treemap;
	    };
	    treemap.sticky = function(x) {
	      if (!arguments.length) return sticky;
	      sticky = x;
	      stickies = null;
	      return treemap;
	    };
	    treemap.ratio = function(x) {
	      if (!arguments.length) return ratio;
	      ratio = x;
	      return treemap;
	    };
	    treemap.mode = function(x) {
	      if (!arguments.length) return mode;
	      mode = x + "";
	      return treemap;
	    };
	    return d3_layout_hierarchyRebind(treemap, hierarchy);
	  };
	  function d3_layout_treemapPadNull(node) {
	    return {
	      x: node.x,
	      y: node.y,
	      dx: node.dx,
	      dy: node.dy
	    };
	  }
	  function d3_layout_treemapPad(node, padding) {
	    var x = node.x + padding[3], y = node.y + padding[0], dx = node.dx - padding[1] - padding[3], dy = node.dy - padding[0] - padding[2];
	    if (dx < 0) {
	      x += dx / 2;
	      dx = 0;
	    }
	    if (dy < 0) {
	      y += dy / 2;
	      dy = 0;
	    }
	    return {
	      x: x,
	      y: y,
	      dx: dx,
	      dy: dy
	    };
	  }
	  d3.random = {
	    normal: function(µ, σ) {
	      var n = arguments.length;
	      if (n < 2) σ = 1;
	      if (n < 1) µ = 0;
	      return function() {
	        var x, y, r;
	        do {
	          x = Math.random() * 2 - 1;
	          y = Math.random() * 2 - 1;
	          r = x * x + y * y;
	        } while (!r || r > 1);
	        return µ + σ * x * Math.sqrt(-2 * Math.log(r) / r);
	      };
	    },
	    logNormal: function() {
	      var random = d3.random.normal.apply(d3, arguments);
	      return function() {
	        return Math.exp(random());
	      };
	    },
	    bates: function(m) {
	      var random = d3.random.irwinHall(m);
	      return function() {
	        return random() / m;
	      };
	    },
	    irwinHall: function(m) {
	      return function() {
	        for (var s = 0, j = 0; j < m; j++) s += Math.random();
	        return s;
	      };
	    }
	  };
	  d3.scale = {};
	  function d3_scaleExtent(domain) {
	    var start = domain[0], stop = domain[domain.length - 1];
	    return start < stop ? [ start, stop ] : [ stop, start ];
	  }
	  function d3_scaleRange(scale) {
	    return scale.rangeExtent ? scale.rangeExtent() : d3_scaleExtent(scale.range());
	  }
	  function d3_scale_bilinear(domain, range, uninterpolate, interpolate) {
	    var u = uninterpolate(domain[0], domain[1]), i = interpolate(range[0], range[1]);
	    return function(x) {
	      return i(u(x));
	    };
	  }
	  function d3_scale_nice(domain, nice) {
	    var i0 = 0, i1 = domain.length - 1, x0 = domain[i0], x1 = domain[i1], dx;
	    if (x1 < x0) {
	      dx = i0, i0 = i1, i1 = dx;
	      dx = x0, x0 = x1, x1 = dx;
	    }
	    domain[i0] = nice.floor(x0);
	    domain[i1] = nice.ceil(x1);
	    return domain;
	  }
	  function d3_scale_niceStep(step) {
	    return step ? {
	      floor: function(x) {
	        return Math.floor(x / step) * step;
	      },
	      ceil: function(x) {
	        return Math.ceil(x / step) * step;
	      }
	    } : d3_scale_niceIdentity;
	  }
	  var d3_scale_niceIdentity = {
	    floor: d3_identity,
	    ceil: d3_identity
	  };
	  function d3_scale_polylinear(domain, range, uninterpolate, interpolate) {
	    var u = [], i = [], j = 0, k = Math.min(domain.length, range.length) - 1;
	    if (domain[k] < domain[0]) {
	      domain = domain.slice().reverse();
	      range = range.slice().reverse();
	    }
	    while (++j <= k) {
	      u.push(uninterpolate(domain[j - 1], domain[j]));
	      i.push(interpolate(range[j - 1], range[j]));
	    }
	    return function(x) {
	      var j = d3.bisect(domain, x, 1, k) - 1;
	      return i[j](u[j](x));
	    };
	  }
	  d3.scale.linear = function() {
	    return d3_scale_linear([ 0, 1 ], [ 0, 1 ], d3_interpolate, false);
	  };
	  function d3_scale_linear(domain, range, interpolate, clamp) {
	    var output, input;
	    function rescale() {
	      var linear = Math.min(domain.length, range.length) > 2 ? d3_scale_polylinear : d3_scale_bilinear, uninterpolate = clamp ? d3_uninterpolateClamp : d3_uninterpolateNumber;
	      output = linear(domain, range, uninterpolate, interpolate);
	      input = linear(range, domain, uninterpolate, d3_interpolate);
	      return scale;
	    }
	    function scale(x) {
	      return output(x);
	    }
	    scale.invert = function(y) {
	      return input(y);
	    };
	    scale.domain = function(x) {
	      if (!arguments.length) return domain;
	      domain = x.map(Number);
	      return rescale();
	    };
	    scale.range = function(x) {
	      if (!arguments.length) return range;
	      range = x;
	      return rescale();
	    };
	    scale.rangeRound = function(x) {
	      return scale.range(x).interpolate(d3_interpolateRound);
	    };
	    scale.clamp = function(x) {
	      if (!arguments.length) return clamp;
	      clamp = x;
	      return rescale();
	    };
	    scale.interpolate = function(x) {
	      if (!arguments.length) return interpolate;
	      interpolate = x;
	      return rescale();
	    };
	    scale.ticks = function(m) {
	      return d3_scale_linearTicks(domain, m);
	    };
	    scale.tickFormat = function(m, format) {
	      return d3_scale_linearTickFormat(domain, m, format);
	    };
	    scale.nice = function(m) {
	      d3_scale_linearNice(domain, m);
	      return rescale();
	    };
	    scale.copy = function() {
	      return d3_scale_linear(domain, range, interpolate, clamp);
	    };
	    return rescale();
	  }
	  function d3_scale_linearRebind(scale, linear) {
	    return d3.rebind(scale, linear, "range", "rangeRound", "interpolate", "clamp");
	  }
	  function d3_scale_linearNice(domain, m) {
	    d3_scale_nice(domain, d3_scale_niceStep(d3_scale_linearTickRange(domain, m)[2]));
	    d3_scale_nice(domain, d3_scale_niceStep(d3_scale_linearTickRange(domain, m)[2]));
	    return domain;
	  }
	  function d3_scale_linearTickRange(domain, m) {
	    if (m == null) m = 10;
	    var extent = d3_scaleExtent(domain), span = extent[1] - extent[0], step = Math.pow(10, Math.floor(Math.log(span / m) / Math.LN10)), err = m / span * step;
	    if (err <= .15) step *= 10; else if (err <= .35) step *= 5; else if (err <= .75) step *= 2;
	    extent[0] = Math.ceil(extent[0] / step) * step;
	    extent[1] = Math.floor(extent[1] / step) * step + step * .5;
	    extent[2] = step;
	    return extent;
	  }
	  function d3_scale_linearTicks(domain, m) {
	    return d3.range.apply(d3, d3_scale_linearTickRange(domain, m));
	  }
	  function d3_scale_linearTickFormat(domain, m, format) {
	    var range = d3_scale_linearTickRange(domain, m);
	    if (format) {
	      var match = d3_format_re.exec(format);
	      match.shift();
	      if (match[8] === "s") {
	        var prefix = d3.formatPrefix(Math.max(abs(range[0]), abs(range[1])));
	        if (!match[7]) match[7] = "." + d3_scale_linearPrecision(prefix.scale(range[2]));
	        match[8] = "f";
	        format = d3.format(match.join(""));
	        return function(d) {
	          return format(prefix.scale(d)) + prefix.symbol;
	        };
	      }
	      if (!match[7]) match[7] = "." + d3_scale_linearFormatPrecision(match[8], range);
	      format = match.join("");
	    } else {
	      format = ",." + d3_scale_linearPrecision(range[2]) + "f";
	    }
	    return d3.format(format);
	  }
	  var d3_scale_linearFormatSignificant = {
	    s: 1,
	    g: 1,
	    p: 1,
	    r: 1,
	    e: 1
	  };
	  function d3_scale_linearPrecision(value) {
	    return -Math.floor(Math.log(value) / Math.LN10 + .01);
	  }
	  function d3_scale_linearFormatPrecision(type, range) {
	    var p = d3_scale_linearPrecision(range[2]);
	    return type in d3_scale_linearFormatSignificant ? Math.abs(p - d3_scale_linearPrecision(Math.max(abs(range[0]), abs(range[1])))) + +(type !== "e") : p - (type === "%") * 2;
	  }
	  d3.scale.log = function() {
	    return d3_scale_log(d3.scale.linear().domain([ 0, 1 ]), 10, true, [ 1, 10 ]);
	  };
	  function d3_scale_log(linear, base, positive, domain) {
	    function log(x) {
	      return (positive ? Math.log(x < 0 ? 0 : x) : -Math.log(x > 0 ? 0 : -x)) / Math.log(base);
	    }
	    function pow(x) {
	      return positive ? Math.pow(base, x) : -Math.pow(base, -x);
	    }
	    function scale(x) {
	      return linear(log(x));
	    }
	    scale.invert = function(x) {
	      return pow(linear.invert(x));
	    };
	    scale.domain = function(x) {
	      if (!arguments.length) return domain;
	      positive = x[0] >= 0;
	      linear.domain((domain = x.map(Number)).map(log));
	      return scale;
	    };
	    scale.base = function(_) {
	      if (!arguments.length) return base;
	      base = +_;
	      linear.domain(domain.map(log));
	      return scale;
	    };
	    scale.nice = function() {
	      var niced = d3_scale_nice(domain.map(log), positive ? Math : d3_scale_logNiceNegative);
	      linear.domain(niced);
	      domain = niced.map(pow);
	      return scale;
	    };
	    scale.ticks = function() {
	      var extent = d3_scaleExtent(domain), ticks = [], u = extent[0], v = extent[1], i = Math.floor(log(u)), j = Math.ceil(log(v)), n = base % 1 ? 2 : base;
	      if (isFinite(j - i)) {
	        if (positive) {
	          for (;i < j; i++) for (var k = 1; k < n; k++) ticks.push(pow(i) * k);
	          ticks.push(pow(i));
	        } else {
	          ticks.push(pow(i));
	          for (;i++ < j; ) for (var k = n - 1; k > 0; k--) ticks.push(pow(i) * k);
	        }
	        for (i = 0; ticks[i] < u; i++) {}
	        for (j = ticks.length; ticks[j - 1] > v; j--) {}
	        ticks = ticks.slice(i, j);
	      }
	      return ticks;
	    };
	    scale.tickFormat = function(n, format) {
	      if (!arguments.length) return d3_scale_logFormat;
	      if (arguments.length < 2) format = d3_scale_logFormat; else if (typeof format !== "function") format = d3.format(format);
	      var k = Math.max(1, base * n / scale.ticks().length);
	      return function(d) {
	        var i = d / pow(Math.round(log(d)));
	        if (i * base < base - .5) i *= base;
	        return i <= k ? format(d) : "";
	      };
	    };
	    scale.copy = function() {
	      return d3_scale_log(linear.copy(), base, positive, domain);
	    };
	    return d3_scale_linearRebind(scale, linear);
	  }
	  var d3_scale_logFormat = d3.format(".0e"), d3_scale_logNiceNegative = {
	    floor: function(x) {
	      return -Math.ceil(-x);
	    },
	    ceil: function(x) {
	      return -Math.floor(-x);
	    }
	  };
	  d3.scale.pow = function() {
	    return d3_scale_pow(d3.scale.linear(), 1, [ 0, 1 ]);
	  };
	  function d3_scale_pow(linear, exponent, domain) {
	    var powp = d3_scale_powPow(exponent), powb = d3_scale_powPow(1 / exponent);
	    function scale(x) {
	      return linear(powp(x));
	    }
	    scale.invert = function(x) {
	      return powb(linear.invert(x));
	    };
	    scale.domain = function(x) {
	      if (!arguments.length) return domain;
	      linear.domain((domain = x.map(Number)).map(powp));
	      return scale;
	    };
	    scale.ticks = function(m) {
	      return d3_scale_linearTicks(domain, m);
	    };
	    scale.tickFormat = function(m, format) {
	      return d3_scale_linearTickFormat(domain, m, format);
	    };
	    scale.nice = function(m) {
	      return scale.domain(d3_scale_linearNice(domain, m));
	    };
	    scale.exponent = function(x) {
	      if (!arguments.length) return exponent;
	      powp = d3_scale_powPow(exponent = x);
	      powb = d3_scale_powPow(1 / exponent);
	      linear.domain(domain.map(powp));
	      return scale;
	    };
	    scale.copy = function() {
	      return d3_scale_pow(linear.copy(), exponent, domain);
	    };
	    return d3_scale_linearRebind(scale, linear);
	  }
	  function d3_scale_powPow(e) {
	    return function(x) {
	      return x < 0 ? -Math.pow(-x, e) : Math.pow(x, e);
	    };
	  }
	  d3.scale.sqrt = function() {
	    return d3.scale.pow().exponent(.5);
	  };
	  d3.scale.ordinal = function() {
	    return d3_scale_ordinal([], {
	      t: "range",
	      a: [ [] ]
	    });
	  };
	  function d3_scale_ordinal(domain, ranger) {
	    var index, range, rangeBand;
	    function scale(x) {
	      return range[((index.get(x) || (ranger.t === "range" ? index.set(x, domain.push(x)) : NaN)) - 1) % range.length];
	    }
	    function steps(start, step) {
	      return d3.range(domain.length).map(function(i) {
	        return start + step * i;
	      });
	    }
	    scale.domain = function(x) {
	      if (!arguments.length) return domain;
	      domain = [];
	      index = new d3_Map();
	      var i = -1, n = x.length, xi;
	      while (++i < n) if (!index.has(xi = x[i])) index.set(xi, domain.push(xi));
	      return scale[ranger.t].apply(scale, ranger.a);
	    };
	    scale.range = function(x) {
	      if (!arguments.length) return range;
	      range = x;
	      rangeBand = 0;
	      ranger = {
	        t: "range",
	        a: arguments
	      };
	      return scale;
	    };
	    scale.rangePoints = function(x, padding) {
	      if (arguments.length < 2) padding = 0;
	      var start = x[0], stop = x[1], step = domain.length < 2 ? (start = (start + stop) / 2, 
	      0) : (stop - start) / (domain.length - 1 + padding);
	      range = steps(start + step * padding / 2, step);
	      rangeBand = 0;
	      ranger = {
	        t: "rangePoints",
	        a: arguments
	      };
	      return scale;
	    };
	    scale.rangeRoundPoints = function(x, padding) {
	      if (arguments.length < 2) padding = 0;
	      var start = x[0], stop = x[1], step = domain.length < 2 ? (start = stop = Math.round((start + stop) / 2), 
	      0) : (stop - start) / (domain.length - 1 + padding) | 0;
	      range = steps(start + Math.round(step * padding / 2 + (stop - start - (domain.length - 1 + padding) * step) / 2), step);
	      rangeBand = 0;
	      ranger = {
	        t: "rangeRoundPoints",
	        a: arguments
	      };
	      return scale;
	    };
	    scale.rangeBands = function(x, padding, outerPadding) {
	      if (arguments.length < 2) padding = 0;
	      if (arguments.length < 3) outerPadding = padding;
	      var reverse = x[1] < x[0], start = x[reverse - 0], stop = x[1 - reverse], step = (stop - start) / (domain.length - padding + 2 * outerPadding);
	      range = steps(start + step * outerPadding, step);
	      if (reverse) range.reverse();
	      rangeBand = step * (1 - padding);
	      ranger = {
	        t: "rangeBands",
	        a: arguments
	      };
	      return scale;
	    };
	    scale.rangeRoundBands = function(x, padding, outerPadding) {
	      if (arguments.length < 2) padding = 0;
	      if (arguments.length < 3) outerPadding = padding;
	      var reverse = x[1] < x[0], start = x[reverse - 0], stop = x[1 - reverse], step = Math.floor((stop - start) / (domain.length - padding + 2 * outerPadding));
	      range = steps(start + Math.round((stop - start - (domain.length - padding) * step) / 2), step);
	      if (reverse) range.reverse();
	      rangeBand = Math.round(step * (1 - padding));
	      ranger = {
	        t: "rangeRoundBands",
	        a: arguments
	      };
	      return scale;
	    };
	    scale.rangeBand = function() {
	      return rangeBand;
	    };
	    scale.rangeExtent = function() {
	      return d3_scaleExtent(ranger.a[0]);
	    };
	    scale.copy = function() {
	      return d3_scale_ordinal(domain, ranger);
	    };
	    return scale.domain(domain);
	  }
	  d3.scale.category10 = function() {
	    return d3.scale.ordinal().range(d3_category10);
	  };
	  d3.scale.category20 = function() {
	    return d3.scale.ordinal().range(d3_category20);
	  };
	  d3.scale.category20b = function() {
	    return d3.scale.ordinal().range(d3_category20b);
	  };
	  d3.scale.category20c = function() {
	    return d3.scale.ordinal().range(d3_category20c);
	  };
	  var d3_category10 = [ 2062260, 16744206, 2924588, 14034728, 9725885, 9197131, 14907330, 8355711, 12369186, 1556175 ].map(d3_rgbString);
	  var d3_category20 = [ 2062260, 11454440, 16744206, 16759672, 2924588, 10018698, 14034728, 16750742, 9725885, 12955861, 9197131, 12885140, 14907330, 16234194, 8355711, 13092807, 12369186, 14408589, 1556175, 10410725 ].map(d3_rgbString);
	  var d3_category20b = [ 3750777, 5395619, 7040719, 10264286, 6519097, 9216594, 11915115, 13556636, 9202993, 12426809, 15186514, 15190932, 8666169, 11356490, 14049643, 15177372, 8077683, 10834324, 13528509, 14589654 ].map(d3_rgbString);
	  var d3_category20c = [ 3244733, 7057110, 10406625, 13032431, 15095053, 16616764, 16625259, 16634018, 3253076, 7652470, 10607003, 13101504, 7695281, 10394312, 12369372, 14342891, 6513507, 9868950, 12434877, 14277081 ].map(d3_rgbString);
	  d3.scale.quantile = function() {
	    return d3_scale_quantile([], []);
	  };
	  function d3_scale_quantile(domain, range) {
	    var thresholds;
	    function rescale() {
	      var k = 0, q = range.length;
	      thresholds = [];
	      while (++k < q) thresholds[k - 1] = d3.quantile(domain, k / q);
	      return scale;
	    }
	    function scale(x) {
	      if (!isNaN(x = +x)) return range[d3.bisect(thresholds, x)];
	    }
	    scale.domain = function(x) {
	      if (!arguments.length) return domain;
	      domain = x.map(d3_number).filter(d3_numeric).sort(d3_ascending);
	      return rescale();
	    };
	    scale.range = function(x) {
	      if (!arguments.length) return range;
	      range = x;
	      return rescale();
	    };
	    scale.quantiles = function() {
	      return thresholds;
	    };
	    scale.invertExtent = function(y) {
	      y = range.indexOf(y);
	      return y < 0 ? [ NaN, NaN ] : [ y > 0 ? thresholds[y - 1] : domain[0], y < thresholds.length ? thresholds[y] : domain[domain.length - 1] ];
	    };
	    scale.copy = function() {
	      return d3_scale_quantile(domain, range);
	    };
	    return rescale();
	  }
	  d3.scale.quantize = function() {
	    return d3_scale_quantize(0, 1, [ 0, 1 ]);
	  };
	  function d3_scale_quantize(x0, x1, range) {
	    var kx, i;
	    function scale(x) {
	      return range[Math.max(0, Math.min(i, Math.floor(kx * (x - x0))))];
	    }
	    function rescale() {
	      kx = range.length / (x1 - x0);
	      i = range.length - 1;
	      return scale;
	    }
	    scale.domain = function(x) {
	      if (!arguments.length) return [ x0, x1 ];
	      x0 = +x[0];
	      x1 = +x[x.length - 1];
	      return rescale();
	    };
	    scale.range = function(x) {
	      if (!arguments.length) return range;
	      range = x;
	      return rescale();
	    };
	    scale.invertExtent = function(y) {
	      y = range.indexOf(y);
	      y = y < 0 ? NaN : y / kx + x0;
	      return [ y, y + 1 / kx ];
	    };
	    scale.copy = function() {
	      return d3_scale_quantize(x0, x1, range);
	    };
	    return rescale();
	  }
	  d3.scale.threshold = function() {
	    return d3_scale_threshold([ .5 ], [ 0, 1 ]);
	  };
	  function d3_scale_threshold(domain, range) {
	    function scale(x) {
	      if (x <= x) return range[d3.bisect(domain, x)];
	    }
	    scale.domain = function(_) {
	      if (!arguments.length) return domain;
	      domain = _;
	      return scale;
	    };
	    scale.range = function(_) {
	      if (!arguments.length) return range;
	      range = _;
	      return scale;
	    };
	    scale.invertExtent = function(y) {
	      y = range.indexOf(y);
	      return [ domain[y - 1], domain[y] ];
	    };
	    scale.copy = function() {
	      return d3_scale_threshold(domain, range);
	    };
	    return scale;
	  }
	  d3.scale.identity = function() {
	    return d3_scale_identity([ 0, 1 ]);
	  };
	  function d3_scale_identity(domain) {
	    function identity(x) {
	      return +x;
	    }
	    identity.invert = identity;
	    identity.domain = identity.range = function(x) {
	      if (!arguments.length) return domain;
	      domain = x.map(identity);
	      return identity;
	    };
	    identity.ticks = function(m) {
	      return d3_scale_linearTicks(domain, m);
	    };
	    identity.tickFormat = function(m, format) {
	      return d3_scale_linearTickFormat(domain, m, format);
	    };
	    identity.copy = function() {
	      return d3_scale_identity(domain);
	    };
	    return identity;
	  }
	  d3.svg = {};
	  function d3_zero() {
	    return 0;
	  }
	  d3.svg.arc = function() {
	    var innerRadius = d3_svg_arcInnerRadius, outerRadius = d3_svg_arcOuterRadius, cornerRadius = d3_zero, padRadius = d3_svg_arcAuto, startAngle = d3_svg_arcStartAngle, endAngle = d3_svg_arcEndAngle, padAngle = d3_svg_arcPadAngle;
	    function arc() {
	      var r0 = Math.max(0, +innerRadius.apply(this, arguments)), r1 = Math.max(0, +outerRadius.apply(this, arguments)), a0 = startAngle.apply(this, arguments) - halfπ, a1 = endAngle.apply(this, arguments) - halfπ, da = Math.abs(a1 - a0), cw = a0 > a1 ? 0 : 1;
	      if (r1 < r0) rc = r1, r1 = r0, r0 = rc;
	      if (da >= τε) return circleSegment(r1, cw) + (r0 ? circleSegment(r0, 1 - cw) : "") + "Z";
	      var rc, cr, rp, ap, p0 = 0, p1 = 0, x0, y0, x1, y1, x2, y2, x3, y3, path = [];
	      if (ap = (+padAngle.apply(this, arguments) || 0) / 2) {
	        rp = padRadius === d3_svg_arcAuto ? Math.sqrt(r0 * r0 + r1 * r1) : +padRadius.apply(this, arguments);
	        if (!cw) p1 *= -1;
	        if (r1) p1 = d3_asin(rp / r1 * Math.sin(ap));
	        if (r0) p0 = d3_asin(rp / r0 * Math.sin(ap));
	      }
	      if (r1) {
	        x0 = r1 * Math.cos(a0 + p1);
	        y0 = r1 * Math.sin(a0 + p1);
	        x1 = r1 * Math.cos(a1 - p1);
	        y1 = r1 * Math.sin(a1 - p1);
	        var l1 = Math.abs(a1 - a0 - 2 * p1) <= π ? 0 : 1;
	        if (p1 && d3_svg_arcSweep(x0, y0, x1, y1) === cw ^ l1) {
	          var h1 = (a0 + a1) / 2;
	          x0 = r1 * Math.cos(h1);
	          y0 = r1 * Math.sin(h1);
	          x1 = y1 = null;
	        }
	      } else {
	        x0 = y0 = 0;
	      }
	      if (r0) {
	        x2 = r0 * Math.cos(a1 - p0);
	        y2 = r0 * Math.sin(a1 - p0);
	        x3 = r0 * Math.cos(a0 + p0);
	        y3 = r0 * Math.sin(a0 + p0);
	        var l0 = Math.abs(a0 - a1 + 2 * p0) <= π ? 0 : 1;
	        if (p0 && d3_svg_arcSweep(x2, y2, x3, y3) === 1 - cw ^ l0) {
	          var h0 = (a0 + a1) / 2;
	          x2 = r0 * Math.cos(h0);
	          y2 = r0 * Math.sin(h0);
	          x3 = y3 = null;
	        }
	      } else {
	        x2 = y2 = 0;
	      }
	      if (da > ε && (rc = Math.min(Math.abs(r1 - r0) / 2, +cornerRadius.apply(this, arguments))) > .001) {
	        cr = r0 < r1 ^ cw ? 0 : 1;
	        var rc1 = rc, rc0 = rc;
	        if (da < π) {
	          var oc = x3 == null ? [ x2, y2 ] : x1 == null ? [ x0, y0 ] : d3_geom_polygonIntersect([ x0, y0 ], [ x3, y3 ], [ x1, y1 ], [ x2, y2 ]), ax = x0 - oc[0], ay = y0 - oc[1], bx = x1 - oc[0], by = y1 - oc[1], kc = 1 / Math.sin(Math.acos((ax * bx + ay * by) / (Math.sqrt(ax * ax + ay * ay) * Math.sqrt(bx * bx + by * by))) / 2), lc = Math.sqrt(oc[0] * oc[0] + oc[1] * oc[1]);
	          rc0 = Math.min(rc, (r0 - lc) / (kc - 1));
	          rc1 = Math.min(rc, (r1 - lc) / (kc + 1));
	        }
	        if (x1 != null) {
	          var t30 = d3_svg_arcCornerTangents(x3 == null ? [ x2, y2 ] : [ x3, y3 ], [ x0, y0 ], r1, rc1, cw), t12 = d3_svg_arcCornerTangents([ x1, y1 ], [ x2, y2 ], r1, rc1, cw);
	          if (rc === rc1) {
	            path.push("M", t30[0], "A", rc1, ",", rc1, " 0 0,", cr, " ", t30[1], "A", r1, ",", r1, " 0 ", 1 - cw ^ d3_svg_arcSweep(t30[1][0], t30[1][1], t12[1][0], t12[1][1]), ",", cw, " ", t12[1], "A", rc1, ",", rc1, " 0 0,", cr, " ", t12[0]);
	          } else {
	            path.push("M", t30[0], "A", rc1, ",", rc1, " 0 1,", cr, " ", t12[0]);
	          }
	        } else {
	          path.push("M", x0, ",", y0);
	        }
	        if (x3 != null) {
	          var t03 = d3_svg_arcCornerTangents([ x0, y0 ], [ x3, y3 ], r0, -rc0, cw), t21 = d3_svg_arcCornerTangents([ x2, y2 ], x1 == null ? [ x0, y0 ] : [ x1, y1 ], r0, -rc0, cw);
	          if (rc === rc0) {
	            path.push("L", t21[0], "A", rc0, ",", rc0, " 0 0,", cr, " ", t21[1], "A", r0, ",", r0, " 0 ", cw ^ d3_svg_arcSweep(t21[1][0], t21[1][1], t03[1][0], t03[1][1]), ",", 1 - cw, " ", t03[1], "A", rc0, ",", rc0, " 0 0,", cr, " ", t03[0]);
	          } else {
	            path.push("L", t21[0], "A", rc0, ",", rc0, " 0 0,", cr, " ", t03[0]);
	          }
	        } else {
	          path.push("L", x2, ",", y2);
	        }
	      } else {
	        path.push("M", x0, ",", y0);
	        if (x1 != null) path.push("A", r1, ",", r1, " 0 ", l1, ",", cw, " ", x1, ",", y1);
	        path.push("L", x2, ",", y2);
	        if (x3 != null) path.push("A", r0, ",", r0, " 0 ", l0, ",", 1 - cw, " ", x3, ",", y3);
	      }
	      path.push("Z");
	      return path.join("");
	    }
	    function circleSegment(r1, cw) {
	      return "M0," + r1 + "A" + r1 + "," + r1 + " 0 1," + cw + " 0," + -r1 + "A" + r1 + "," + r1 + " 0 1," + cw + " 0," + r1;
	    }
	    arc.innerRadius = function(v) {
	      if (!arguments.length) return innerRadius;
	      innerRadius = d3_functor(v);
	      return arc;
	    };
	    arc.outerRadius = function(v) {
	      if (!arguments.length) return outerRadius;
	      outerRadius = d3_functor(v);
	      return arc;
	    };
	    arc.cornerRadius = function(v) {
	      if (!arguments.length) return cornerRadius;
	      cornerRadius = d3_functor(v);
	      return arc;
	    };
	    arc.padRadius = function(v) {
	      if (!arguments.length) return padRadius;
	      padRadius = v == d3_svg_arcAuto ? d3_svg_arcAuto : d3_functor(v);
	      return arc;
	    };
	    arc.startAngle = function(v) {
	      if (!arguments.length) return startAngle;
	      startAngle = d3_functor(v);
	      return arc;
	    };
	    arc.endAngle = function(v) {
	      if (!arguments.length) return endAngle;
	      endAngle = d3_functor(v);
	      return arc;
	    };
	    arc.padAngle = function(v) {
	      if (!arguments.length) return padAngle;
	      padAngle = d3_functor(v);
	      return arc;
	    };
	    arc.centroid = function() {
	      var r = (+innerRadius.apply(this, arguments) + +outerRadius.apply(this, arguments)) / 2, a = (+startAngle.apply(this, arguments) + +endAngle.apply(this, arguments)) / 2 - halfπ;
	      return [ Math.cos(a) * r, Math.sin(a) * r ];
	    };
	    return arc;
	  };
	  var d3_svg_arcAuto = "auto";
	  function d3_svg_arcInnerRadius(d) {
	    return d.innerRadius;
	  }
	  function d3_svg_arcOuterRadius(d) {
	    return d.outerRadius;
	  }
	  function d3_svg_arcStartAngle(d) {
	    return d.startAngle;
	  }
	  function d3_svg_arcEndAngle(d) {
	    return d.endAngle;
	  }
	  function d3_svg_arcPadAngle(d) {
	    return d && d.padAngle;
	  }
	  function d3_svg_arcSweep(x0, y0, x1, y1) {
	    return (x0 - x1) * y0 - (y0 - y1) * x0 > 0 ? 0 : 1;
	  }
	  function d3_svg_arcCornerTangents(p0, p1, r1, rc, cw) {
	    var x01 = p0[0] - p1[0], y01 = p0[1] - p1[1], lo = (cw ? rc : -rc) / Math.sqrt(x01 * x01 + y01 * y01), ox = lo * y01, oy = -lo * x01, x1 = p0[0] + ox, y1 = p0[1] + oy, x2 = p1[0] + ox, y2 = p1[1] + oy, x3 = (x1 + x2) / 2, y3 = (y1 + y2) / 2, dx = x2 - x1, dy = y2 - y1, d2 = dx * dx + dy * dy, r = r1 - rc, D = x1 * y2 - x2 * y1, d = (dy < 0 ? -1 : 1) * Math.sqrt(Math.max(0, r * r * d2 - D * D)), cx0 = (D * dy - dx * d) / d2, cy0 = (-D * dx - dy * d) / d2, cx1 = (D * dy + dx * d) / d2, cy1 = (-D * dx + dy * d) / d2, dx0 = cx0 - x3, dy0 = cy0 - y3, dx1 = cx1 - x3, dy1 = cy1 - y3;
	    if (dx0 * dx0 + dy0 * dy0 > dx1 * dx1 + dy1 * dy1) cx0 = cx1, cy0 = cy1;
	    return [ [ cx0 - ox, cy0 - oy ], [ cx0 * r1 / r, cy0 * r1 / r ] ];
	  }
	  function d3_svg_line(projection) {
	    var x = d3_geom_pointX, y = d3_geom_pointY, defined = d3_true, interpolate = d3_svg_lineLinear, interpolateKey = interpolate.key, tension = .7;
	    function line(data) {
	      var segments = [], points = [], i = -1, n = data.length, d, fx = d3_functor(x), fy = d3_functor(y);
	      function segment() {
	        segments.push("M", interpolate(projection(points), tension));
	      }
	      while (++i < n) {
	        if (defined.call(this, d = data[i], i)) {
	          points.push([ +fx.call(this, d, i), +fy.call(this, d, i) ]);
	        } else if (points.length) {
	          segment();
	          points = [];
	        }
	      }
	      if (points.length) segment();
	      return segments.length ? segments.join("") : null;
	    }
	    line.x = function(_) {
	      if (!arguments.length) return x;
	      x = _;
	      return line;
	    };
	    line.y = function(_) {
	      if (!arguments.length) return y;
	      y = _;
	      return line;
	    };
	    line.defined = function(_) {
	      if (!arguments.length) return defined;
	      defined = _;
	      return line;
	    };
	    line.interpolate = function(_) {
	      if (!arguments.length) return interpolateKey;
	      if (typeof _ === "function") interpolateKey = interpolate = _; else interpolateKey = (interpolate = d3_svg_lineInterpolators.get(_) || d3_svg_lineLinear).key;
	      return line;
	    };
	    line.tension = function(_) {
	      if (!arguments.length) return tension;
	      tension = _;
	      return line;
	    };
	    return line;
	  }
	  d3.svg.line = function() {
	    return d3_svg_line(d3_identity);
	  };
	  var d3_svg_lineInterpolators = d3.map({
	    linear: d3_svg_lineLinear,
	    "linear-closed": d3_svg_lineLinearClosed,
	    step: d3_svg_lineStep,
	    "step-before": d3_svg_lineStepBefore,
	    "step-after": d3_svg_lineStepAfter,
	    basis: d3_svg_lineBasis,
	    "basis-open": d3_svg_lineBasisOpen,
	    "basis-closed": d3_svg_lineBasisClosed,
	    bundle: d3_svg_lineBundle,
	    cardinal: d3_svg_lineCardinal,
	    "cardinal-open": d3_svg_lineCardinalOpen,
	    "cardinal-closed": d3_svg_lineCardinalClosed,
	    monotone: d3_svg_lineMonotone
	  });
	  d3_svg_lineInterpolators.forEach(function(key, value) {
	    value.key = key;
	    value.closed = /-closed$/.test(key);
	  });
	  function d3_svg_lineLinear(points) {
	    return points.length > 1 ? points.join("L") : points + "Z";
	  }
	  function d3_svg_lineLinearClosed(points) {
	    return points.join("L") + "Z";
	  }
	  function d3_svg_lineStep(points) {
	    var i = 0, n = points.length, p = points[0], path = [ p[0], ",", p[1] ];
	    while (++i < n) path.push("H", (p[0] + (p = points[i])[0]) / 2, "V", p[1]);
	    if (n > 1) path.push("H", p[0]);
	    return path.join("");
	  }
	  function d3_svg_lineStepBefore(points) {
	    var i = 0, n = points.length, p = points[0], path = [ p[0], ",", p[1] ];
	    while (++i < n) path.push("V", (p = points[i])[1], "H", p[0]);
	    return path.join("");
	  }
	  function d3_svg_lineStepAfter(points) {
	    var i = 0, n = points.length, p = points[0], path = [ p[0], ",", p[1] ];
	    while (++i < n) path.push("H", (p = points[i])[0], "V", p[1]);
	    return path.join("");
	  }
	  function d3_svg_lineCardinalOpen(points, tension) {
	    return points.length < 4 ? d3_svg_lineLinear(points) : points[1] + d3_svg_lineHermite(points.slice(1, -1), d3_svg_lineCardinalTangents(points, tension));
	  }
	  function d3_svg_lineCardinalClosed(points, tension) {
	    return points.length < 3 ? d3_svg_lineLinearClosed(points) : points[0] + d3_svg_lineHermite((points.push(points[0]), 
	    points), d3_svg_lineCardinalTangents([ points[points.length - 2] ].concat(points, [ points[1] ]), tension));
	  }
	  function d3_svg_lineCardinal(points, tension) {
	    return points.length < 3 ? d3_svg_lineLinear(points) : points[0] + d3_svg_lineHermite(points, d3_svg_lineCardinalTangents(points, tension));
	  }
	  function d3_svg_lineHermite(points, tangents) {
	    if (tangents.length < 1 || points.length != tangents.length && points.length != tangents.length + 2) {
	      return d3_svg_lineLinear(points);
	    }
	    var quad = points.length != tangents.length, path = "", p0 = points[0], p = points[1], t0 = tangents[0], t = t0, pi = 1;
	    if (quad) {
	      path += "Q" + (p[0] - t0[0] * 2 / 3) + "," + (p[1] - t0[1] * 2 / 3) + "," + p[0] + "," + p[1];
	      p0 = points[1];
	      pi = 2;
	    }
	    if (tangents.length > 1) {
	      t = tangents[1];
	      p = points[pi];
	      pi++;
	      path += "C" + (p0[0] + t0[0]) + "," + (p0[1] + t0[1]) + "," + (p[0] - t[0]) + "," + (p[1] - t[1]) + "," + p[0] + "," + p[1];
	      for (var i = 2; i < tangents.length; i++, pi++) {
	        p = points[pi];
	        t = tangents[i];
	        path += "S" + (p[0] - t[0]) + "," + (p[1] - t[1]) + "," + p[0] + "," + p[1];
	      }
	    }
	    if (quad) {
	      var lp = points[pi];
	      path += "Q" + (p[0] + t[0] * 2 / 3) + "," + (p[1] + t[1] * 2 / 3) + "," + lp[0] + "," + lp[1];
	    }
	    return path;
	  }
	  function d3_svg_lineCardinalTangents(points, tension) {
	    var tangents = [], a = (1 - tension) / 2, p0, p1 = points[0], p2 = points[1], i = 1, n = points.length;
	    while (++i < n) {
	      p0 = p1;
	      p1 = p2;
	      p2 = points[i];
	      tangents.push([ a * (p2[0] - p0[0]), a * (p2[1] - p0[1]) ]);
	    }
	    return tangents;
	  }
	  function d3_svg_lineBasis(points) {
	    if (points.length < 3) return d3_svg_lineLinear(points);
	    var i = 1, n = points.length, pi = points[0], x0 = pi[0], y0 = pi[1], px = [ x0, x0, x0, (pi = points[1])[0] ], py = [ y0, y0, y0, pi[1] ], path = [ x0, ",", y0, "L", d3_svg_lineDot4(d3_svg_lineBasisBezier3, px), ",", d3_svg_lineDot4(d3_svg_lineBasisBezier3, py) ];
	    points.push(points[n - 1]);
	    while (++i <= n) {
	      pi = points[i];
	      px.shift();
	      px.push(pi[0]);
	      py.shift();
	      py.push(pi[1]);
	      d3_svg_lineBasisBezier(path, px, py);
	    }
	    points.pop();
	    path.push("L", pi);
	    return path.join("");
	  }
	  function d3_svg_lineBasisOpen(points) {
	    if (points.length < 4) return d3_svg_lineLinear(points);
	    var path = [], i = -1, n = points.length, pi, px = [ 0 ], py = [ 0 ];
	    while (++i < 3) {
	      pi = points[i];
	      px.push(pi[0]);
	      py.push(pi[1]);
	    }
	    path.push(d3_svg_lineDot4(d3_svg_lineBasisBezier3, px) + "," + d3_svg_lineDot4(d3_svg_lineBasisBezier3, py));
	    --i;
	    while (++i < n) {
	      pi = points[i];
	      px.shift();
	      px.push(pi[0]);
	      py.shift();
	      py.push(pi[1]);
	      d3_svg_lineBasisBezier(path, px, py);
	    }
	    return path.join("");
	  }
	  function d3_svg_lineBasisClosed(points) {
	    var path, i = -1, n = points.length, m = n + 4, pi, px = [], py = [];
	    while (++i < 4) {
	      pi = points[i % n];
	      px.push(pi[0]);
	      py.push(pi[1]);
	    }
	    path = [ d3_svg_lineDot4(d3_svg_lineBasisBezier3, px), ",", d3_svg_lineDot4(d3_svg_lineBasisBezier3, py) ];
	    --i;
	    while (++i < m) {
	      pi = points[i % n];
	      px.shift();
	      px.push(pi[0]);
	      py.shift();
	      py.push(pi[1]);
	      d3_svg_lineBasisBezier(path, px, py);
	    }
	    return path.join("");
	  }
	  function d3_svg_lineBundle(points, tension) {
	    var n = points.length - 1;
	    if (n) {
	      var x0 = points[0][0], y0 = points[0][1], dx = points[n][0] - x0, dy = points[n][1] - y0, i = -1, p, t;
	      while (++i <= n) {
	        p = points[i];
	        t = i / n;
	        p[0] = tension * p[0] + (1 - tension) * (x0 + t * dx);
	        p[1] = tension * p[1] + (1 - tension) * (y0 + t * dy);
	      }
	    }
	    return d3_svg_lineBasis(points);
	  }
	  function d3_svg_lineDot4(a, b) {
	    return a[0] * b[0] + a[1] * b[1] + a[2] * b[2] + a[3] * b[3];
	  }
	  var d3_svg_lineBasisBezier1 = [ 0, 2 / 3, 1 / 3, 0 ], d3_svg_lineBasisBezier2 = [ 0, 1 / 3, 2 / 3, 0 ], d3_svg_lineBasisBezier3 = [ 0, 1 / 6, 2 / 3, 1 / 6 ];
	  function d3_svg_lineBasisBezier(path, x, y) {
	    path.push("C", d3_svg_lineDot4(d3_svg_lineBasisBezier1, x), ",", d3_svg_lineDot4(d3_svg_lineBasisBezier1, y), ",", d3_svg_lineDot4(d3_svg_lineBasisBezier2, x), ",", d3_svg_lineDot4(d3_svg_lineBasisBezier2, y), ",", d3_svg_lineDot4(d3_svg_lineBasisBezier3, x), ",", d3_svg_lineDot4(d3_svg_lineBasisBezier3, y));
	  }
	  function d3_svg_lineSlope(p0, p1) {
	    return (p1[1] - p0[1]) / (p1[0] - p0[0]);
	  }
	  function d3_svg_lineFiniteDifferences(points) {
	    var i = 0, j = points.length - 1, m = [], p0 = points[0], p1 = points[1], d = m[0] = d3_svg_lineSlope(p0, p1);
	    while (++i < j) {
	      m[i] = (d + (d = d3_svg_lineSlope(p0 = p1, p1 = points[i + 1]))) / 2;
	    }
	    m[i] = d;
	    return m;
	  }
	  function d3_svg_lineMonotoneTangents(points) {
	    var tangents = [], d, a, b, s, m = d3_svg_lineFiniteDifferences(points), i = -1, j = points.length - 1;
	    while (++i < j) {
	      d = d3_svg_lineSlope(points[i], points[i + 1]);
	      if (abs(d) < ε) {
	        m[i] = m[i + 1] = 0;
	      } else {
	        a = m[i] / d;
	        b = m[i + 1] / d;
	        s = a * a + b * b;
	        if (s > 9) {
	          s = d * 3 / Math.sqrt(s);
	          m[i] = s * a;
	          m[i + 1] = s * b;
	        }
	      }
	    }
	    i = -1;
	    while (++i <= j) {
	      s = (points[Math.min(j, i + 1)][0] - points[Math.max(0, i - 1)][0]) / (6 * (1 + m[i] * m[i]));
	      tangents.push([ s || 0, m[i] * s || 0 ]);
	    }
	    return tangents;
	  }
	  function d3_svg_lineMonotone(points) {
	    return points.length < 3 ? d3_svg_lineLinear(points) : points[0] + d3_svg_lineHermite(points, d3_svg_lineMonotoneTangents(points));
	  }
	  d3.svg.line.radial = function() {
	    var line = d3_svg_line(d3_svg_lineRadial);
	    line.radius = line.x, delete line.x;
	    line.angle = line.y, delete line.y;
	    return line;
	  };
	  function d3_svg_lineRadial(points) {
	    var point, i = -1, n = points.length, r, a;
	    while (++i < n) {
	      point = points[i];
	      r = point[0];
	      a = point[1] - halfπ;
	      point[0] = r * Math.cos(a);
	      point[1] = r * Math.sin(a);
	    }
	    return points;
	  }
	  function d3_svg_area(projection) {
	    var x0 = d3_geom_pointX, x1 = d3_geom_pointX, y0 = 0, y1 = d3_geom_pointY, defined = d3_true, interpolate = d3_svg_lineLinear, interpolateKey = interpolate.key, interpolateReverse = interpolate, L = "L", tension = .7;
	    function area(data) {
	      var segments = [], points0 = [], points1 = [], i = -1, n = data.length, d, fx0 = d3_functor(x0), fy0 = d3_functor(y0), fx1 = x0 === x1 ? function() {
	        return x;
	      } : d3_functor(x1), fy1 = y0 === y1 ? function() {
	        return y;
	      } : d3_functor(y1), x, y;
	      function segment() {
	        segments.push("M", interpolate(projection(points1), tension), L, interpolateReverse(projection(points0.reverse()), tension), "Z");
	      }
	      while (++i < n) {
	        if (defined.call(this, d = data[i], i)) {
	          points0.push([ x = +fx0.call(this, d, i), y = +fy0.call(this, d, i) ]);
	          points1.push([ +fx1.call(this, d, i), +fy1.call(this, d, i) ]);
	        } else if (points0.length) {
	          segment();
	          points0 = [];
	          points1 = [];
	        }
	      }
	      if (points0.length) segment();
	      return segments.length ? segments.join("") : null;
	    }
	    area.x = function(_) {
	      if (!arguments.length) return x1;
	      x0 = x1 = _;
	      return area;
	    };
	    area.x0 = function(_) {
	      if (!arguments.length) return x0;
	      x0 = _;
	      return area;
	    };
	    area.x1 = function(_) {
	      if (!arguments.length) return x1;
	      x1 = _;
	      return area;
	    };
	    area.y = function(_) {
	      if (!arguments.length) return y1;
	      y0 = y1 = _;
	      return area;
	    };
	    area.y0 = function(_) {
	      if (!arguments.length) return y0;
	      y0 = _;
	      return area;
	    };
	    area.y1 = function(_) {
	      if (!arguments.length) return y1;
	      y1 = _;
	      return area;
	    };
	    area.defined = function(_) {
	      if (!arguments.length) return defined;
	      defined = _;
	      return area;
	    };
	    area.interpolate = function(_) {
	      if (!arguments.length) return interpolateKey;
	      if (typeof _ === "function") interpolateKey = interpolate = _; else interpolateKey = (interpolate = d3_svg_lineInterpolators.get(_) || d3_svg_lineLinear).key;
	      interpolateReverse = interpolate.reverse || interpolate;
	      L = interpolate.closed ? "M" : "L";
	      return area;
	    };
	    area.tension = function(_) {
	      if (!arguments.length) return tension;
	      tension = _;
	      return area;
	    };
	    return area;
	  }
	  d3_svg_lineStepBefore.reverse = d3_svg_lineStepAfter;
	  d3_svg_lineStepAfter.reverse = d3_svg_lineStepBefore;
	  d3.svg.area = function() {
	    return d3_svg_area(d3_identity);
	  };
	  d3.svg.area.radial = function() {
	    var area = d3_svg_area(d3_svg_lineRadial);
	    area.radius = area.x, delete area.x;
	    area.innerRadius = area.x0, delete area.x0;
	    area.outerRadius = area.x1, delete area.x1;
	    area.angle = area.y, delete area.y;
	    area.startAngle = area.y0, delete area.y0;
	    area.endAngle = area.y1, delete area.y1;
	    return area;
	  };
	  d3.svg.chord = function() {
	    var source = d3_source, target = d3_target, radius = d3_svg_chordRadius, startAngle = d3_svg_arcStartAngle, endAngle = d3_svg_arcEndAngle;
	    function chord(d, i) {
	      var s = subgroup(this, source, d, i), t = subgroup(this, target, d, i);
	      return "M" + s.p0 + arc(s.r, s.p1, s.a1 - s.a0) + (equals(s, t) ? curve(s.r, s.p1, s.r, s.p0) : curve(s.r, s.p1, t.r, t.p0) + arc(t.r, t.p1, t.a1 - t.a0) + curve(t.r, t.p1, s.r, s.p0)) + "Z";
	    }
	    function subgroup(self, f, d, i) {
	      var subgroup = f.call(self, d, i), r = radius.call(self, subgroup, i), a0 = startAngle.call(self, subgroup, i) - halfπ, a1 = endAngle.call(self, subgroup, i) - halfπ;
	      return {
	        r: r,
	        a0: a0,
	        a1: a1,
	        p0: [ r * Math.cos(a0), r * Math.sin(a0) ],
	        p1: [ r * Math.cos(a1), r * Math.sin(a1) ]
	      };
	    }
	    function equals(a, b) {
	      return a.a0 == b.a0 && a.a1 == b.a1;
	    }
	    function arc(r, p, a) {
	      return "A" + r + "," + r + " 0 " + +(a > π) + ",1 " + p;
	    }
	    function curve(r0, p0, r1, p1) {
	      return "Q 0,0 " + p1;
	    }
	    chord.radius = function(v) {
	      if (!arguments.length) return radius;
	      radius = d3_functor(v);
	      return chord;
	    };
	    chord.source = function(v) {
	      if (!arguments.length) return source;
	      source = d3_functor(v);
	      return chord;
	    };
	    chord.target = function(v) {
	      if (!arguments.length) return target;
	      target = d3_functor(v);
	      return chord;
	    };
	    chord.startAngle = function(v) {
	      if (!arguments.length) return startAngle;
	      startAngle = d3_functor(v);
	      return chord;
	    };
	    chord.endAngle = function(v) {
	      if (!arguments.length) return endAngle;
	      endAngle = d3_functor(v);
	      return chord;
	    };
	    return chord;
	  };
	  function d3_svg_chordRadius(d) {
	    return d.radius;
	  }
	  d3.svg.diagonal = function() {
	    var source = d3_source, target = d3_target, projection = d3_svg_diagonalProjection;
	    function diagonal(d, i) {
	      var p0 = source.call(this, d, i), p3 = target.call(this, d, i), m = (p0.y + p3.y) / 2, p = [ p0, {
	        x: p0.x,
	        y: m
	      }, {
	        x: p3.x,
	        y: m
	      }, p3 ];
	      p = p.map(projection);
	      return "M" + p[0] + "C" + p[1] + " " + p[2] + " " + p[3];
	    }
	    diagonal.source = function(x) {
	      if (!arguments.length) return source;
	      source = d3_functor(x);
	      return diagonal;
	    };
	    diagonal.target = function(x) {
	      if (!arguments.length) return target;
	      target = d3_functor(x);
	      return diagonal;
	    };
	    diagonal.projection = function(x) {
	      if (!arguments.length) return projection;
	      projection = x;
	      return diagonal;
	    };
	    return diagonal;
	  };
	  function d3_svg_diagonalProjection(d) {
	    return [ d.x, d.y ];
	  }
	  d3.svg.diagonal.radial = function() {
	    var diagonal = d3.svg.diagonal(), projection = d3_svg_diagonalProjection, projection_ = diagonal.projection;
	    diagonal.projection = function(x) {
	      return arguments.length ? projection_(d3_svg_diagonalRadialProjection(projection = x)) : projection;
	    };
	    return diagonal;
	  };
	  function d3_svg_diagonalRadialProjection(projection) {
	    return function() {
	      var d = projection.apply(this, arguments), r = d[0], a = d[1] - halfπ;
	      return [ r * Math.cos(a), r * Math.sin(a) ];
	    };
	  }
	  d3.svg.symbol = function() {
	    var type = d3_svg_symbolType, size = d3_svg_symbolSize;
	    function symbol(d, i) {
	      return (d3_svg_symbols.get(type.call(this, d, i)) || d3_svg_symbolCircle)(size.call(this, d, i));
	    }
	    symbol.type = function(x) {
	      if (!arguments.length) return type;
	      type = d3_functor(x);
	      return symbol;
	    };
	    symbol.size = function(x) {
	      if (!arguments.length) return size;
	      size = d3_functor(x);
	      return symbol;
	    };
	    return symbol;
	  };
	  function d3_svg_symbolSize() {
	    return 64;
	  }
	  function d3_svg_symbolType() {
	    return "circle";
	  }
	  function d3_svg_symbolCircle(size) {
	    var r = Math.sqrt(size / π);
	    return "M0," + r + "A" + r + "," + r + " 0 1,1 0," + -r + "A" + r + "," + r + " 0 1,1 0," + r + "Z";
	  }
	  var d3_svg_symbols = d3.map({
	    circle: d3_svg_symbolCircle,
	    cross: function(size) {
	      var r = Math.sqrt(size / 5) / 2;
	      return "M" + -3 * r + "," + -r + "H" + -r + "V" + -3 * r + "H" + r + "V" + -r + "H" + 3 * r + "V" + r + "H" + r + "V" + 3 * r + "H" + -r + "V" + r + "H" + -3 * r + "Z";
	    },
	    diamond: function(size) {
	      var ry = Math.sqrt(size / (2 * d3_svg_symbolTan30)), rx = ry * d3_svg_symbolTan30;
	      return "M0," + -ry + "L" + rx + ",0" + " 0," + ry + " " + -rx + ",0" + "Z";
	    },
	    square: function(size) {
	      var r = Math.sqrt(size) / 2;
	      return "M" + -r + "," + -r + "L" + r + "," + -r + " " + r + "," + r + " " + -r + "," + r + "Z";
	    },
	    "triangle-down": function(size) {
	      var rx = Math.sqrt(size / d3_svg_symbolSqrt3), ry = rx * d3_svg_symbolSqrt3 / 2;
	      return "M0," + ry + "L" + rx + "," + -ry + " " + -rx + "," + -ry + "Z";
	    },
	    "triangle-up": function(size) {
	      var rx = Math.sqrt(size / d3_svg_symbolSqrt3), ry = rx * d3_svg_symbolSqrt3 / 2;
	      return "M0," + -ry + "L" + rx + "," + ry + " " + -rx + "," + ry + "Z";
	    }
	  });
	  d3.svg.symbolTypes = d3_svg_symbols.keys();
	  var d3_svg_symbolSqrt3 = Math.sqrt(3), d3_svg_symbolTan30 = Math.tan(30 * d3_radians);
	  d3_selectionPrototype.transition = function(name) {
	    var id = d3_transitionInheritId || ++d3_transitionId, ns = d3_transitionNamespace(name), subgroups = [], subgroup, node, transition = d3_transitionInherit || {
	      time: Date.now(),
	      ease: d3_ease_cubicInOut,
	      delay: 0,
	      duration: 250
	    };
	    for (var j = -1, m = this.length; ++j < m; ) {
	      subgroups.push(subgroup = []);
	      for (var group = this[j], i = -1, n = group.length; ++i < n; ) {
	        if (node = group[i]) d3_transitionNode(node, i, ns, id, transition);
	        subgroup.push(node);
	      }
	    }
	    return d3_transition(subgroups, ns, id);
	  };
	  d3_selectionPrototype.interrupt = function(name) {
	    return this.each(name == null ? d3_selection_interrupt : d3_selection_interruptNS(d3_transitionNamespace(name)));
	  };
	  var d3_selection_interrupt = d3_selection_interruptNS(d3_transitionNamespace());
	  function d3_selection_interruptNS(ns) {
	    return function() {
	      var lock, activeId, active;
	      if ((lock = this[ns]) && (active = lock[activeId = lock.active])) {
	        active.timer.c = null;
	        active.timer.t = NaN;
	        if (--lock.count) delete lock[activeId]; else delete this[ns];
	        lock.active += .5;
	        active.event && active.event.interrupt.call(this, this.__data__, active.index);
	      }
	    };
	  }
	  function d3_transition(groups, ns, id) {
	    d3_subclass(groups, d3_transitionPrototype);
	    groups.namespace = ns;
	    groups.id = id;
	    return groups;
	  }
	  var d3_transitionPrototype = [], d3_transitionId = 0, d3_transitionInheritId, d3_transitionInherit;
	  d3_transitionPrototype.call = d3_selectionPrototype.call;
	  d3_transitionPrototype.empty = d3_selectionPrototype.empty;
	  d3_transitionPrototype.node = d3_selectionPrototype.node;
	  d3_transitionPrototype.size = d3_selectionPrototype.size;
	  d3.transition = function(selection, name) {
	    return selection && selection.transition ? d3_transitionInheritId ? selection.transition(name) : selection : d3.selection().transition(selection);
	  };
	  d3.transition.prototype = d3_transitionPrototype;
	  d3_transitionPrototype.select = function(selector) {
	    var id = this.id, ns = this.namespace, subgroups = [], subgroup, subnode, node;
	    selector = d3_selection_selector(selector);
	    for (var j = -1, m = this.length; ++j < m; ) {
	      subgroups.push(subgroup = []);
	      for (var group = this[j], i = -1, n = group.length; ++i < n; ) {
	        if ((node = group[i]) && (subnode = selector.call(node, node.__data__, i, j))) {
	          if ("__data__" in node) subnode.__data__ = node.__data__;
	          d3_transitionNode(subnode, i, ns, id, node[ns][id]);
	          subgroup.push(subnode);
	        } else {
	          subgroup.push(null);
	        }
	      }
	    }
	    return d3_transition(subgroups, ns, id);
	  };
	  d3_transitionPrototype.selectAll = function(selector) {
	    var id = this.id, ns = this.namespace, subgroups = [], subgroup, subnodes, node, subnode, transition;
	    selector = d3_selection_selectorAll(selector);
	    for (var j = -1, m = this.length; ++j < m; ) {
	      for (var group = this[j], i = -1, n = group.length; ++i < n; ) {
	        if (node = group[i]) {
	          transition = node[ns][id];
	          subnodes = selector.call(node, node.__data__, i, j);
	          subgroups.push(subgroup = []);
	          for (var k = -1, o = subnodes.length; ++k < o; ) {
	            if (subnode = subnodes[k]) d3_transitionNode(subnode, k, ns, id, transition);
	            subgroup.push(subnode);
	          }
	        }
	      }
	    }
	    return d3_transition(subgroups, ns, id);
	  };
	  d3_transitionPrototype.filter = function(filter) {
	    var subgroups = [], subgroup, group, node;
	    if (typeof filter !== "function") filter = d3_selection_filter(filter);
	    for (var j = 0, m = this.length; j < m; j++) {
	      subgroups.push(subgroup = []);
	      for (var group = this[j], i = 0, n = group.length; i < n; i++) {
	        if ((node = group[i]) && filter.call(node, node.__data__, i, j)) {
	          subgroup.push(node);
	        }
	      }
	    }
	    return d3_transition(subgroups, this.namespace, this.id);
	  };
	  d3_transitionPrototype.tween = function(name, tween) {
	    var id = this.id, ns = this.namespace;
	    if (arguments.length < 2) return this.node()[ns][id].tween.get(name);
	    return d3_selection_each(this, tween == null ? function(node) {
	      node[ns][id].tween.remove(name);
	    } : function(node) {
	      node[ns][id].tween.set(name, tween);
	    });
	  };
	  function d3_transition_tween(groups, name, value, tween) {
	    var id = groups.id, ns = groups.namespace;
	    return d3_selection_each(groups, typeof value === "function" ? function(node, i, j) {
	      node[ns][id].tween.set(name, tween(value.call(node, node.__data__, i, j)));
	    } : (value = tween(value), function(node) {
	      node[ns][id].tween.set(name, value);
	    }));
	  }
	  d3_transitionPrototype.attr = function(nameNS, value) {
	    if (arguments.length < 2) {
	      for (value in nameNS) this.attr(value, nameNS[value]);
	      return this;
	    }
	    var interpolate = nameNS == "transform" ? d3_interpolateTransform : d3_interpolate, name = d3.ns.qualify(nameNS);
	    function attrNull() {
	      this.removeAttribute(name);
	    }
	    function attrNullNS() {
	      this.removeAttributeNS(name.space, name.local);
	    }
	    function attrTween(b) {
	      return b == null ? attrNull : (b += "", function() {
	        var a = this.getAttribute(name), i;
	        return a !== b && (i = interpolate(a, b), function(t) {
	          this.setAttribute(name, i(t));
	        });
	      });
	    }
	    function attrTweenNS(b) {
	      return b == null ? attrNullNS : (b += "", function() {
	        var a = this.getAttributeNS(name.space, name.local), i;
	        return a !== b && (i = interpolate(a, b), function(t) {
	          this.setAttributeNS(name.space, name.local, i(t));
	        });
	      });
	    }
	    return d3_transition_tween(this, "attr." + nameNS, value, name.local ? attrTweenNS : attrTween);
	  };
	  d3_transitionPrototype.attrTween = function(nameNS, tween) {
	    var name = d3.ns.qualify(nameNS);
	    function attrTween(d, i) {
	      var f = tween.call(this, d, i, this.getAttribute(name));
	      return f && function(t) {
	        this.setAttribute(name, f(t));
	      };
	    }
	    function attrTweenNS(d, i) {
	      var f = tween.call(this, d, i, this.getAttributeNS(name.space, name.local));
	      return f && function(t) {
	        this.setAttributeNS(name.space, name.local, f(t));
	      };
	    }
	    return this.tween("attr." + nameNS, name.local ? attrTweenNS : attrTween);
	  };
	  d3_transitionPrototype.style = function(name, value, priority) {
	    var n = arguments.length;
	    if (n < 3) {
	      if (typeof name !== "string") {
	        if (n < 2) value = "";
	        for (priority in name) this.style(priority, name[priority], value);
	        return this;
	      }
	      priority = "";
	    }
	    function styleNull() {
	      this.style.removeProperty(name);
	    }
	    function styleString(b) {
	      return b == null ? styleNull : (b += "", function() {
	        var a = d3_window(this).getComputedStyle(this, null).getPropertyValue(name), i;
	        return a !== b && (i = d3_interpolate(a, b), function(t) {
	          this.style.setProperty(name, i(t), priority);
	        });
	      });
	    }
	    return d3_transition_tween(this, "style." + name, value, styleString);
	  };
	  d3_transitionPrototype.styleTween = function(name, tween, priority) {
	    if (arguments.length < 3) priority = "";
	    function styleTween(d, i) {
	      var f = tween.call(this, d, i, d3_window(this).getComputedStyle(this, null).getPropertyValue(name));
	      return f && function(t) {
	        this.style.setProperty(name, f(t), priority);
	      };
	    }
	    return this.tween("style." + name, styleTween);
	  };
	  d3_transitionPrototype.text = function(value) {
	    return d3_transition_tween(this, "text", value, d3_transition_text);
	  };
	  function d3_transition_text(b) {
	    if (b == null) b = "";
	    return function() {
	      this.textContent = b;
	    };
	  }
	  d3_transitionPrototype.remove = function() {
	    var ns = this.namespace;
	    return this.each("end.transition", function() {
	      var p;
	      if (this[ns].count < 2 && (p = this.parentNode)) p.removeChild(this);
	    });
	  };
	  d3_transitionPrototype.ease = function(value) {
	    var id = this.id, ns = this.namespace;
	    if (arguments.length < 1) return this.node()[ns][id].ease;
	    if (typeof value !== "function") value = d3.ease.apply(d3, arguments);
	    return d3_selection_each(this, function(node) {
	      node[ns][id].ease = value;
	    });
	  };
	  d3_transitionPrototype.delay = function(value) {
	    var id = this.id, ns = this.namespace;
	    if (arguments.length < 1) return this.node()[ns][id].delay;
	    return d3_selection_each(this, typeof value === "function" ? function(node, i, j) {
	      node[ns][id].delay = +value.call(node, node.__data__, i, j);
	    } : (value = +value, function(node) {
	      node[ns][id].delay = value;
	    }));
	  };
	  d3_transitionPrototype.duration = function(value) {
	    var id = this.id, ns = this.namespace;
	    if (arguments.length < 1) return this.node()[ns][id].duration;
	    return d3_selection_each(this, typeof value === "function" ? function(node, i, j) {
	      node[ns][id].duration = Math.max(1, value.call(node, node.__data__, i, j));
	    } : (value = Math.max(1, value), function(node) {
	      node[ns][id].duration = value;
	    }));
	  };
	  d3_transitionPrototype.each = function(type, listener) {
	    var id = this.id, ns = this.namespace;
	    if (arguments.length < 2) {
	      var inherit = d3_transitionInherit, inheritId = d3_transitionInheritId;
	      try {
	        d3_transitionInheritId = id;
	        d3_selection_each(this, function(node, i, j) {
	          d3_transitionInherit = node[ns][id];
	          type.call(node, node.__data__, i, j);
	        });
	      } finally {
	        d3_transitionInherit = inherit;
	        d3_transitionInheritId = inheritId;
	      }
	    } else {
	      d3_selection_each(this, function(node) {
	        var transition = node[ns][id];
	        (transition.event || (transition.event = d3.dispatch("start", "end", "interrupt"))).on(type, listener);
	      });
	    }
	    return this;
	  };
	  d3_transitionPrototype.transition = function() {
	    var id0 = this.id, id1 = ++d3_transitionId, ns = this.namespace, subgroups = [], subgroup, group, node, transition;
	    for (var j = 0, m = this.length; j < m; j++) {
	      subgroups.push(subgroup = []);
	      for (var group = this[j], i = 0, n = group.length; i < n; i++) {
	        if (node = group[i]) {
	          transition = node[ns][id0];
	          d3_transitionNode(node, i, ns, id1, {
	            time: transition.time,
	            ease: transition.ease,
	            delay: transition.delay + transition.duration,
	            duration: transition.duration
	          });
	        }
	        subgroup.push(node);
	      }
	    }
	    return d3_transition(subgroups, ns, id1);
	  };
	  function d3_transitionNamespace(name) {
	    return name == null ? "__transition__" : "__transition_" + name + "__";
	  }
	  function d3_transitionNode(node, i, ns, id, inherit) {
	    var lock = node[ns] || (node[ns] = {
	      active: 0,
	      count: 0
	    }), transition = lock[id], time, timer, duration, ease, tweens;
	    function schedule(elapsed) {
	      var delay = transition.delay;
	      timer.t = delay + time;
	      if (delay <= elapsed) return start(elapsed - delay);
	      timer.c = start;
	    }
	    function start(elapsed) {
	      var activeId = lock.active, active = lock[activeId];
	      if (active) {
	        active.timer.c = null;
	        active.timer.t = NaN;
	        --lock.count;
	        delete lock[activeId];
	        active.event && active.event.interrupt.call(node, node.__data__, active.index);
	      }
	      for (var cancelId in lock) {
	        if (+cancelId < id) {
	          var cancel = lock[cancelId];
	          cancel.timer.c = null;
	          cancel.timer.t = NaN;
	          --lock.count;
	          delete lock[cancelId];
	        }
	      }
	      timer.c = tick;
	      d3_timer(function() {
	        if (timer.c && tick(elapsed || 1)) {
	          timer.c = null;
	          timer.t = NaN;
	        }
	        return 1;
	      }, 0, time);
	      lock.active = id;
	      transition.event && transition.event.start.call(node, node.__data__, i);
	      tweens = [];
	      transition.tween.forEach(function(key, value) {
	        if (value = value.call(node, node.__data__, i)) {
	          tweens.push(value);
	        }
	      });
	      ease = transition.ease;
	      duration = transition.duration;
	    }
	    function tick(elapsed) {
	      var t = elapsed / duration, e = ease(t), n = tweens.length;
	      while (n > 0) {
	        tweens[--n].call(node, e);
	      }
	      if (t >= 1) {
	        transition.event && transition.event.end.call(node, node.__data__, i);
	        if (--lock.count) delete lock[id]; else delete node[ns];
	        return 1;
	      }
	    }
	    if (!transition) {
	      time = inherit.time;
	      timer = d3_timer(schedule, 0, time);
	      transition = lock[id] = {
	        tween: new d3_Map(),
	        time: time,
	        timer: timer,
	        delay: inherit.delay,
	        duration: inherit.duration,
	        ease: inherit.ease,
	        index: i
	      };
	      inherit = null;
	      ++lock.count;
	    }
	  }
	  d3.svg.axis = function() {
	    var scale = d3.scale.linear(), orient = d3_svg_axisDefaultOrient, innerTickSize = 6, outerTickSize = 6, tickPadding = 3, tickArguments_ = [ 10 ], tickValues = null, tickFormat_;
	    function axis(g) {
	      g.each(function() {
	        var g = d3.select(this);
	        var scale0 = this.__chart__ || scale, scale1 = this.__chart__ = scale.copy();
	        var ticks = tickValues == null ? scale1.ticks ? scale1.ticks.apply(scale1, tickArguments_) : scale1.domain() : tickValues, tickFormat = tickFormat_ == null ? scale1.tickFormat ? scale1.tickFormat.apply(scale1, tickArguments_) : d3_identity : tickFormat_, tick = g.selectAll(".tick").data(ticks, scale1), tickEnter = tick.enter().insert("g", ".domain").attr("class", "tick").style("opacity", ε), tickExit = d3.transition(tick.exit()).style("opacity", ε).remove(), tickUpdate = d3.transition(tick.order()).style("opacity", 1), tickSpacing = Math.max(innerTickSize, 0) + tickPadding, tickTransform;
	        var range = d3_scaleRange(scale1), path = g.selectAll(".domain").data([ 0 ]), pathUpdate = (path.enter().append("path").attr("class", "domain"), 
	        d3.transition(path));
	        tickEnter.append("line");
	        tickEnter.append("text");
	        var lineEnter = tickEnter.select("line"), lineUpdate = tickUpdate.select("line"), text = tick.select("text").text(tickFormat), textEnter = tickEnter.select("text"), textUpdate = tickUpdate.select("text"), sign = orient === "top" || orient === "left" ? -1 : 1, x1, x2, y1, y2;
	        if (orient === "bottom" || orient === "top") {
	          tickTransform = d3_svg_axisX, x1 = "x", y1 = "y", x2 = "x2", y2 = "y2";
	          text.attr("dy", sign < 0 ? "0em" : ".71em").style("text-anchor", "middle");
	          pathUpdate.attr("d", "M" + range[0] + "," + sign * outerTickSize + "V0H" + range[1] + "V" + sign * outerTickSize);
	        } else {
	          tickTransform = d3_svg_axisY, x1 = "y", y1 = "x", x2 = "y2", y2 = "x2";
	          text.attr("dy", ".32em").style("text-anchor", sign < 0 ? "end" : "start");
	          pathUpdate.attr("d", "M" + sign * outerTickSize + "," + range[0] + "H0V" + range[1] + "H" + sign * outerTickSize);
	        }
	        lineEnter.attr(y2, sign * innerTickSize);
	        textEnter.attr(y1, sign * tickSpacing);
	        lineUpdate.attr(x2, 0).attr(y2, sign * innerTickSize);
	        textUpdate.attr(x1, 0).attr(y1, sign * tickSpacing);
	        if (scale1.rangeBand) {
	          var x = scale1, dx = x.rangeBand() / 2;
	          scale0 = scale1 = function(d) {
	            return x(d) + dx;
	          };
	        } else if (scale0.rangeBand) {
	          scale0 = scale1;
	        } else {
	          tickExit.call(tickTransform, scale1, scale0);
	        }
	        tickEnter.call(tickTransform, scale0, scale1);
	        tickUpdate.call(tickTransform, scale1, scale1);
	      });
	    }
	    axis.scale = function(x) {
	      if (!arguments.length) return scale;
	      scale = x;
	      return axis;
	    };
	    axis.orient = function(x) {
	      if (!arguments.length) return orient;
	      orient = x in d3_svg_axisOrients ? x + "" : d3_svg_axisDefaultOrient;
	      return axis;
	    };
	    axis.ticks = function() {
	      if (!arguments.length) return tickArguments_;
	      tickArguments_ = d3_array(arguments);
	      return axis;
	    };
	    axis.tickValues = function(x) {
	      if (!arguments.length) return tickValues;
	      tickValues = x;
	      return axis;
	    };
	    axis.tickFormat = function(x) {
	      if (!arguments.length) return tickFormat_;
	      tickFormat_ = x;
	      return axis;
	    };
	    axis.tickSize = function(x) {
	      var n = arguments.length;
	      if (!n) return innerTickSize;
	      innerTickSize = +x;
	      outerTickSize = +arguments[n - 1];
	      return axis;
	    };
	    axis.innerTickSize = function(x) {
	      if (!arguments.length) return innerTickSize;
	      innerTickSize = +x;
	      return axis;
	    };
	    axis.outerTickSize = function(x) {
	      if (!arguments.length) return outerTickSize;
	      outerTickSize = +x;
	      return axis;
	    };
	    axis.tickPadding = function(x) {
	      if (!arguments.length) return tickPadding;
	      tickPadding = +x;
	      return axis;
	    };
	    axis.tickSubdivide = function() {
	      return arguments.length && axis;
	    };
	    return axis;
	  };
	  var d3_svg_axisDefaultOrient = "bottom", d3_svg_axisOrients = {
	    top: 1,
	    right: 1,
	    bottom: 1,
	    left: 1
	  };
	  function d3_svg_axisX(selection, x0, x1) {
	    selection.attr("transform", function(d) {
	      var v0 = x0(d);
	      return "translate(" + (isFinite(v0) ? v0 : x1(d)) + ",0)";
	    });
	  }
	  function d3_svg_axisY(selection, y0, y1) {
	    selection.attr("transform", function(d) {
	      var v0 = y0(d);
	      return "translate(0," + (isFinite(v0) ? v0 : y1(d)) + ")";
	    });
	  }
	  d3.svg.brush = function() {
	    var event = d3_eventDispatch(brush, "brushstart", "brush", "brushend"), x = null, y = null, xExtent = [ 0, 0 ], yExtent = [ 0, 0 ], xExtentDomain, yExtentDomain, xClamp = true, yClamp = true, resizes = d3_svg_brushResizes[0];
	    function brush(g) {
	      g.each(function() {
	        var g = d3.select(this).style("pointer-events", "all").style("-webkit-tap-highlight-color", "rgba(0,0,0,0)").on("mousedown.brush", brushstart).on("touchstart.brush", brushstart);
	        var background = g.selectAll(".background").data([ 0 ]);
	        background.enter().append("rect").attr("class", "background").style("visibility", "hidden").style("cursor", "crosshair");
	        g.selectAll(".extent").data([ 0 ]).enter().append("rect").attr("class", "extent").style("cursor", "move");
	        var resize = g.selectAll(".resize").data(resizes, d3_identity);
	        resize.exit().remove();
	        resize.enter().append("g").attr("class", function(d) {
	          return "resize " + d;
	        }).style("cursor", function(d) {
	          return d3_svg_brushCursor[d];
	        }).append("rect").attr("x", function(d) {
	          return /[ew]$/.test(d) ? -3 : null;
	        }).attr("y", function(d) {
	          return /^[ns]/.test(d) ? -3 : null;
	        }).attr("width", 6).attr("height", 6).style("visibility", "hidden");
	        resize.style("display", brush.empty() ? "none" : null);
	        var gUpdate = d3.transition(g), backgroundUpdate = d3.transition(background), range;
	        if (x) {
	          range = d3_scaleRange(x);
	          backgroundUpdate.attr("x", range[0]).attr("width", range[1] - range[0]);
	          redrawX(gUpdate);
	        }
	        if (y) {
	          range = d3_scaleRange(y);
	          backgroundUpdate.attr("y", range[0]).attr("height", range[1] - range[0]);
	          redrawY(gUpdate);
	        }
	        redraw(gUpdate);
	      });
	    }
	    brush.event = function(g) {
	      g.each(function() {
	        var event_ = event.of(this, arguments), extent1 = {
	          x: xExtent,
	          y: yExtent,
	          i: xExtentDomain,
	          j: yExtentDomain
	        }, extent0 = this.__chart__ || extent1;
	        this.__chart__ = extent1;
	        if (d3_transitionInheritId) {
	          d3.select(this).transition().each("start.brush", function() {
	            xExtentDomain = extent0.i;
	            yExtentDomain = extent0.j;
	            xExtent = extent0.x;
	            yExtent = extent0.y;
	            event_({
	              type: "brushstart"
	            });
	          }).tween("brush:brush", function() {
	            var xi = d3_interpolateArray(xExtent, extent1.x), yi = d3_interpolateArray(yExtent, extent1.y);
	            xExtentDomain = yExtentDomain = null;
	            return function(t) {
	              xExtent = extent1.x = xi(t);
	              yExtent = extent1.y = yi(t);
	              event_({
	                type: "brush",
	                mode: "resize"
	              });
	            };
	          }).each("end.brush", function() {
	            xExtentDomain = extent1.i;
	            yExtentDomain = extent1.j;
	            event_({
	              type: "brush",
	              mode: "resize"
	            });
	            event_({
	              type: "brushend"
	            });
	          });
	        } else {
	          event_({
	            type: "brushstart"
	          });
	          event_({
	            type: "brush",
	            mode: "resize"
	          });
	          event_({
	            type: "brushend"
	          });
	        }
	      });
	    };
	    function redraw(g) {
	      g.selectAll(".resize").attr("transform", function(d) {
	        return "translate(" + xExtent[+/e$/.test(d)] + "," + yExtent[+/^s/.test(d)] + ")";
	      });
	    }
	    function redrawX(g) {
	      g.select(".extent").attr("x", xExtent[0]);
	      g.selectAll(".extent,.n>rect,.s>rect").attr("width", xExtent[1] - xExtent[0]);
	    }
	    function redrawY(g) {
	      g.select(".extent").attr("y", yExtent[0]);
	      g.selectAll(".extent,.e>rect,.w>rect").attr("height", yExtent[1] - yExtent[0]);
	    }
	    function brushstart() {
	      var target = this, eventTarget = d3.select(d3.event.target), event_ = event.of(target, arguments), g = d3.select(target), resizing = eventTarget.datum(), resizingX = !/^(n|s)$/.test(resizing) && x, resizingY = !/^(e|w)$/.test(resizing) && y, dragging = eventTarget.classed("extent"), dragRestore = d3_event_dragSuppress(target), center, origin = d3.mouse(target), offset;
	      var w = d3.select(d3_window(target)).on("keydown.brush", keydown).on("keyup.brush", keyup);
	      if (d3.event.changedTouches) {
	        w.on("touchmove.brush", brushmove).on("touchend.brush", brushend);
	      } else {
	        w.on("mousemove.brush", brushmove).on("mouseup.brush", brushend);
	      }
	      g.interrupt().selectAll("*").interrupt();
	      if (dragging) {
	        origin[0] = xExtent[0] - origin[0];
	        origin[1] = yExtent[0] - origin[1];
	      } else if (resizing) {
	        var ex = +/w$/.test(resizing), ey = +/^n/.test(resizing);
	        offset = [ xExtent[1 - ex] - origin[0], yExtent[1 - ey] - origin[1] ];
	        origin[0] = xExtent[ex];
	        origin[1] = yExtent[ey];
	      } else if (d3.event.altKey) center = origin.slice();
	      g.style("pointer-events", "none").selectAll(".resize").style("display", null);
	      d3.select("body").style("cursor", eventTarget.style("cursor"));
	      event_({
	        type: "brushstart"
	      });
	      brushmove();
	      function keydown() {
	        if (d3.event.keyCode == 32) {
	          if (!dragging) {
	            center = null;
	            origin[0] -= xExtent[1];
	            origin[1] -= yExtent[1];
	            dragging = 2;
	          }
	          d3_eventPreventDefault();
	        }
	      }
	      function keyup() {
	        if (d3.event.keyCode == 32 && dragging == 2) {
	          origin[0] += xExtent[1];
	          origin[1] += yExtent[1];
	          dragging = 0;
	          d3_eventPreventDefault();
	        }
	      }
	      function brushmove() {
	        var point = d3.mouse(target), moved = false;
	        if (offset) {
	          point[0] += offset[0];
	          point[1] += offset[1];
	        }
	        if (!dragging) {
	          if (d3.event.altKey) {
	            if (!center) center = [ (xExtent[0] + xExtent[1]) / 2, (yExtent[0] + yExtent[1]) / 2 ];
	            origin[0] = xExtent[+(point[0] < center[0])];
	            origin[1] = yExtent[+(point[1] < center[1])];
	          } else center = null;
	        }
	        if (resizingX && move1(point, x, 0)) {
	          redrawX(g);
	          moved = true;
	        }
	        if (resizingY && move1(point, y, 1)) {
	          redrawY(g);
	          moved = true;
	        }
	        if (moved) {
	          redraw(g);
	          event_({
	            type: "brush",
	            mode: dragging ? "move" : "resize"
	          });
	        }
	      }
	      function move1(point, scale, i) {
	        var range = d3_scaleRange(scale), r0 = range[0], r1 = range[1], position = origin[i], extent = i ? yExtent : xExtent, size = extent[1] - extent[0], min, max;
	        if (dragging) {
	          r0 -= position;
	          r1 -= size + position;
	        }
	        min = (i ? yClamp : xClamp) ? Math.max(r0, Math.min(r1, point[i])) : point[i];
	        if (dragging) {
	          max = (min += position) + size;
	        } else {
	          if (center) position = Math.max(r0, Math.min(r1, 2 * center[i] - min));
	          if (position < min) {
	            max = min;
	            min = position;
	          } else {
	            max = position;
	          }
	        }
	        if (extent[0] != min || extent[1] != max) {
	          if (i) yExtentDomain = null; else xExtentDomain = null;
	          extent[0] = min;
	          extent[1] = max;
	          return true;
	        }
	      }
	      function brushend() {
	        brushmove();
	        g.style("pointer-events", "all").selectAll(".resize").style("display", brush.empty() ? "none" : null);
	        d3.select("body").style("cursor", null);
	        w.on("mousemove.brush", null).on("mouseup.brush", null).on("touchmove.brush", null).on("touchend.brush", null).on("keydown.brush", null).on("keyup.brush", null);
	        dragRestore();
	        event_({
	          type: "brushend"
	        });
	      }
	    }
	    brush.x = function(z) {
	      if (!arguments.length) return x;
	      x = z;
	      resizes = d3_svg_brushResizes[!x << 1 | !y];
	      return brush;
	    };
	    brush.y = function(z) {
	      if (!arguments.length) return y;
	      y = z;
	      resizes = d3_svg_brushResizes[!x << 1 | !y];
	      return brush;
	    };
	    brush.clamp = function(z) {
	      if (!arguments.length) return x && y ? [ xClamp, yClamp ] : x ? xClamp : y ? yClamp : null;
	      if (x && y) xClamp = !!z[0], yClamp = !!z[1]; else if (x) xClamp = !!z; else if (y) yClamp = !!z;
	      return brush;
	    };
	    brush.extent = function(z) {
	      var x0, x1, y0, y1, t;
	      if (!arguments.length) {
	        if (x) {
	          if (xExtentDomain) {
	            x0 = xExtentDomain[0], x1 = xExtentDomain[1];
	          } else {
	            x0 = xExtent[0], x1 = xExtent[1];
	            if (x.invert) x0 = x.invert(x0), x1 = x.invert(x1);
	            if (x1 < x0) t = x0, x0 = x1, x1 = t;
	          }
	        }
	        if (y) {
	          if (yExtentDomain) {
	            y0 = yExtentDomain[0], y1 = yExtentDomain[1];
	          } else {
	            y0 = yExtent[0], y1 = yExtent[1];
	            if (y.invert) y0 = y.invert(y0), y1 = y.invert(y1);
	            if (y1 < y0) t = y0, y0 = y1, y1 = t;
	          }
	        }
	        return x && y ? [ [ x0, y0 ], [ x1, y1 ] ] : x ? [ x0, x1 ] : y && [ y0, y1 ];
	      }
	      if (x) {
	        x0 = z[0], x1 = z[1];
	        if (y) x0 = x0[0], x1 = x1[0];
	        xExtentDomain = [ x0, x1 ];
	        if (x.invert) x0 = x(x0), x1 = x(x1);
	        if (x1 < x0) t = x0, x0 = x1, x1 = t;
	        if (x0 != xExtent[0] || x1 != xExtent[1]) xExtent = [ x0, x1 ];
	      }
	      if (y) {
	        y0 = z[0], y1 = z[1];
	        if (x) y0 = y0[1], y1 = y1[1];
	        yExtentDomain = [ y0, y1 ];
	        if (y.invert) y0 = y(y0), y1 = y(y1);
	        if (y1 < y0) t = y0, y0 = y1, y1 = t;
	        if (y0 != yExtent[0] || y1 != yExtent[1]) yExtent = [ y0, y1 ];
	      }
	      return brush;
	    };
	    brush.clear = function() {
	      if (!brush.empty()) {
	        xExtent = [ 0, 0 ], yExtent = [ 0, 0 ];
	        xExtentDomain = yExtentDomain = null;
	      }
	      return brush;
	    };
	    brush.empty = function() {
	      return !!x && xExtent[0] == xExtent[1] || !!y && yExtent[0] == yExtent[1];
	    };
	    return d3.rebind(brush, event, "on");
	  };
	  var d3_svg_brushCursor = {
	    n: "ns-resize",
	    e: "ew-resize",
	    s: "ns-resize",
	    w: "ew-resize",
	    nw: "nwse-resize",
	    ne: "nesw-resize",
	    se: "nwse-resize",
	    sw: "nesw-resize"
	  };
	  var d3_svg_brushResizes = [ [ "n", "e", "s", "w", "nw", "ne", "se", "sw" ], [ "e", "w" ], [ "n", "s" ], [] ];
	  var d3_time_format = d3_time.format = d3_locale_enUS.timeFormat;
	  var d3_time_formatUtc = d3_time_format.utc;
	  var d3_time_formatIso = d3_time_formatUtc("%Y-%m-%dT%H:%M:%S.%LZ");
	  d3_time_format.iso = Date.prototype.toISOString && +new Date("2000-01-01T00:00:00.000Z") ? d3_time_formatIsoNative : d3_time_formatIso;
	  function d3_time_formatIsoNative(date) {
	    return date.toISOString();
	  }
	  d3_time_formatIsoNative.parse = function(string) {
	    var date = new Date(string);
	    return isNaN(date) ? null : date;
	  };
	  d3_time_formatIsoNative.toString = d3_time_formatIso.toString;
	  d3_time.second = d3_time_interval(function(date) {
	    return new d3_date(Math.floor(date / 1e3) * 1e3);
	  }, function(date, offset) {
	    date.setTime(date.getTime() + Math.floor(offset) * 1e3);
	  }, function(date) {
	    return date.getSeconds();
	  });
	  d3_time.seconds = d3_time.second.range;
	  d3_time.seconds.utc = d3_time.second.utc.range;
	  d3_time.minute = d3_time_interval(function(date) {
	    return new d3_date(Math.floor(date / 6e4) * 6e4);
	  }, function(date, offset) {
	    date.setTime(date.getTime() + Math.floor(offset) * 6e4);
	  }, function(date) {
	    return date.getMinutes();
	  });
	  d3_time.minutes = d3_time.minute.range;
	  d3_time.minutes.utc = d3_time.minute.utc.range;
	  d3_time.hour = d3_time_interval(function(date) {
	    var timezone = date.getTimezoneOffset() / 60;
	    return new d3_date((Math.floor(date / 36e5 - timezone) + timezone) * 36e5);
	  }, function(date, offset) {
	    date.setTime(date.getTime() + Math.floor(offset) * 36e5);
	  }, function(date) {
	    return date.getHours();
	  });
	  d3_time.hours = d3_time.hour.range;
	  d3_time.hours.utc = d3_time.hour.utc.range;
	  d3_time.month = d3_time_interval(function(date) {
	    date = d3_time.day(date);
	    date.setDate(1);
	    return date;
	  }, function(date, offset) {
	    date.setMonth(date.getMonth() + offset);
	  }, function(date) {
	    return date.getMonth();
	  });
	  d3_time.months = d3_time.month.range;
	  d3_time.months.utc = d3_time.month.utc.range;
	  function d3_time_scale(linear, methods, format) {
	    function scale(x) {
	      return linear(x);
	    }
	    scale.invert = function(x) {
	      return d3_time_scaleDate(linear.invert(x));
	    };
	    scale.domain = function(x) {
	      if (!arguments.length) return linear.domain().map(d3_time_scaleDate);
	      linear.domain(x);
	      return scale;
	    };
	    function tickMethod(extent, count) {
	      var span = extent[1] - extent[0], target = span / count, i = d3.bisect(d3_time_scaleSteps, target);
	      return i == d3_time_scaleSteps.length ? [ methods.year, d3_scale_linearTickRange(extent.map(function(d) {
	        return d / 31536e6;
	      }), count)[2] ] : !i ? [ d3_time_scaleMilliseconds, d3_scale_linearTickRange(extent, count)[2] ] : methods[target / d3_time_scaleSteps[i - 1] < d3_time_scaleSteps[i] / target ? i - 1 : i];
	    }
	    scale.nice = function(interval, skip) {
	      var domain = scale.domain(), extent = d3_scaleExtent(domain), method = interval == null ? tickMethod(extent, 10) : typeof interval === "number" && tickMethod(extent, interval);
	      if (method) interval = method[0], skip = method[1];
	      function skipped(date) {
	        return !isNaN(date) && !interval.range(date, d3_time_scaleDate(+date + 1), skip).length;
	      }
	      return scale.domain(d3_scale_nice(domain, skip > 1 ? {
	        floor: function(date) {
	          while (skipped(date = interval.floor(date))) date = d3_time_scaleDate(date - 1);
	          return date;
	        },
	        ceil: function(date) {
	          while (skipped(date = interval.ceil(date))) date = d3_time_scaleDate(+date + 1);
	          return date;
	        }
	      } : interval));
	    };
	    scale.ticks = function(interval, skip) {
	      var extent = d3_scaleExtent(scale.domain()), method = interval == null ? tickMethod(extent, 10) : typeof interval === "number" ? tickMethod(extent, interval) : !interval.range && [ {
	        range: interval
	      }, skip ];
	      if (method) interval = method[0], skip = method[1];
	      return interval.range(extent[0], d3_time_scaleDate(+extent[1] + 1), skip < 1 ? 1 : skip);
	    };
	    scale.tickFormat = function() {
	      return format;
	    };
	    scale.copy = function() {
	      return d3_time_scale(linear.copy(), methods, format);
	    };
	    return d3_scale_linearRebind(scale, linear);
	  }
	  function d3_time_scaleDate(t) {
	    return new Date(t);
	  }
	  var d3_time_scaleSteps = [ 1e3, 5e3, 15e3, 3e4, 6e4, 3e5, 9e5, 18e5, 36e5, 108e5, 216e5, 432e5, 864e5, 1728e5, 6048e5, 2592e6, 7776e6, 31536e6 ];
	  var d3_time_scaleLocalMethods = [ [ d3_time.second, 1 ], [ d3_time.second, 5 ], [ d3_time.second, 15 ], [ d3_time.second, 30 ], [ d3_time.minute, 1 ], [ d3_time.minute, 5 ], [ d3_time.minute, 15 ], [ d3_time.minute, 30 ], [ d3_time.hour, 1 ], [ d3_time.hour, 3 ], [ d3_time.hour, 6 ], [ d3_time.hour, 12 ], [ d3_time.day, 1 ], [ d3_time.day, 2 ], [ d3_time.week, 1 ], [ d3_time.month, 1 ], [ d3_time.month, 3 ], [ d3_time.year, 1 ] ];
	  var d3_time_scaleLocalFormat = d3_time_format.multi([ [ ".%L", function(d) {
	    return d.getMilliseconds();
	  } ], [ ":%S", function(d) {
	    return d.getSeconds();
	  } ], [ "%I:%M", function(d) {
	    return d.getMinutes();
	  } ], [ "%I %p", function(d) {
	    return d.getHours();
	  } ], [ "%a %d", function(d) {
	    return d.getDay() && d.getDate() != 1;
	  } ], [ "%b %d", function(d) {
	    return d.getDate() != 1;
	  } ], [ "%B", function(d) {
	    return d.getMonth();
	  } ], [ "%Y", d3_true ] ]);
	  var d3_time_scaleMilliseconds = {
	    range: function(start, stop, step) {
	      return d3.range(Math.ceil(start / step) * step, +stop, step).map(d3_time_scaleDate);
	    },
	    floor: d3_identity,
	    ceil: d3_identity
	  };
	  d3_time_scaleLocalMethods.year = d3_time.year;
	  d3_time.scale = function() {
	    return d3_time_scale(d3.scale.linear(), d3_time_scaleLocalMethods, d3_time_scaleLocalFormat);
	  };
	  var d3_time_scaleUtcMethods = d3_time_scaleLocalMethods.map(function(m) {
	    return [ m[0].utc, m[1] ];
	  });
	  var d3_time_scaleUtcFormat = d3_time_formatUtc.multi([ [ ".%L", function(d) {
	    return d.getUTCMilliseconds();
	  } ], [ ":%S", function(d) {
	    return d.getUTCSeconds();
	  } ], [ "%I:%M", function(d) {
	    return d.getUTCMinutes();
	  } ], [ "%I %p", function(d) {
	    return d.getUTCHours();
	  } ], [ "%a %d", function(d) {
	    return d.getUTCDay() && d.getUTCDate() != 1;
	  } ], [ "%b %d", function(d) {
	    return d.getUTCDate() != 1;
	  } ], [ "%B", function(d) {
	    return d.getUTCMonth();
	  } ], [ "%Y", d3_true ] ]);
	  d3_time_scaleUtcMethods.year = d3_time.year.utc;
	  d3_time.scale.utc = function() {
	    return d3_time_scale(d3.scale.linear(), d3_time_scaleUtcMethods, d3_time_scaleUtcFormat);
	  };
	  d3.text = d3_xhrType(function(request) {
	    return request.responseText;
	  });
	  d3.json = function(url, callback) {
	    return d3_xhr(url, "application/json", d3_json, callback);
	  };
	  function d3_json(request) {
	    return JSON.parse(request.responseText);
	  }
	  d3.html = function(url, callback) {
	    return d3_xhr(url, "text/html", d3_html, callback);
	  };
	  function d3_html(request) {
	    var range = d3_document.createRange();
	    range.selectNode(d3_document.body);
	    return range.createContextualFragment(request.responseText);
	  }
	  d3.xml = d3_xhrType(function(request) {
	    return request.responseXML;
	  });
	  if (true) this.d3 = d3, !(__WEBPACK_AMD_DEFINE_FACTORY__ = (d3), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)); else if (typeof module === "object" && module.exports) module.exports = d3; else this.d3 = d3;
	}();

/***/ }),
/* 1851 */
/***/ (function(module, exports, __webpack_require__) {

	var each = __webpack_require__(1834);
	
	module.exports = extendDeep;
	
	function extendDeep(target){
	  for (var i = 1; i < arguments.length; i++) {
	    each(arguments[i], function(prop, key){
	      if (( typeof target[key] !== 'undefined' && typeof prop !== 'undefined' ) &&
	          ( typeof target[key] === 'object'    && typeof prop === 'object' ) &&
	          ( target[key] !== null               && prop !== null )) {
	            extendDeep(target[key], prop);
	      }
	      else {
	        target[key] = prop;
	      }
	    });
	  }
	  return target;
	}


/***/ }),
/* 1852 */
/***/ (function(module, exports) {

	module.exports = function(startDate, endDate){
	  var timeDiff = Math.abs(new Date(startDate).getTime() - new Date(endDate).getTime());
	  var months = [
	    'Jan',
	    'Feb',
	    'Mar',
	    'Apr',
	    'May',
	    'June',
	    'July',
	    'Aug',
	    'Sept',
	    'Oct',
	    'Nov',
	    'Dec'
	  ];
	
	  // Yearly (31536000000) + Monthly
	  if (timeDiff >= 2419200000) {
	    return function(ms){
	      var date = new Date(ms);
	      return months[date.getMonth()] + ' ' + date.getFullYear();
	    };
	  }
	  // Daily
	  else if (timeDiff >= 86400000) {
	    return function(ms){
	      var date = new Date(ms);
	      return months[date.getMonth()] + ' ' + date.getDate();
	    };
	  }
	  // Hourly
	  else if (timeDiff >= 3600000) {
	    return '%I:%M %p';
	  }
	  // Minutely
	  else {
	    return '%I:%M:%S %p';
	  }
	};


/***/ }),
/* 1853 */
/***/ (function(module, exports, __webpack_require__) {

	var d3 = __webpack_require__(1850);
	
	var isDateString = __webpack_require__(1846);
	
	module.exports = function(cols){
	  var self = this,
	      chart = this.view._artifacts.c3,
	      columns = [],
	      domNode = this.el().querySelector('.' + this.theme() + '-rendering'),
	      legendWidth = 120;
	
	  var pagination = this.view._artifacts.pagination = {
	    hidden: [],
	    labels: [],
	    position: 0,
	    range: Math.round((domNode.offsetHeight - 78) / 20),
	    total: 0
	  };
	
	  // Reduce threshold for donut/pie charts
	  if (this.type() === 'donut' || this.type() === 'pie') {
	    pagination.range = pagination.range >= 5 ? 5 : pagination.range;
	  }
	
	  for (var i = 0; i < cols.length; i++) {
	    if (cols[i][0] !== 'x' && !isDateString(cols[i][1])) {
	      columns.push(cols[i][0]);
	    }
	  }
	
	  var legendEl = d3.select(domNode)
	    .append('svg')
	    .attr({
	      'class': 'keen-c3-legend',
	      'height': domNode.offsetHeight - 10,
	      'width': legendWidth
	    })
	    .style({
	      'right': -legendWidth + 'px',
	      'top': '10px'
	    });
	
	  var legendItems = legendEl
	    .append('g')
	    .attr('class', 'keen-c3-legend-items');
	
	  var paginateElOffset = 20 * pagination.range;
	  var paginateEl = legendEl
	    .append('g')
	    .attr({
	      'class': 'keen-c3-legend-pagination',
	      'transform': function(){
	        return 'translate(2, ' + paginateElOffset + ')'
	      }
	    });
	
	  paginateData();
	
	  function paginateData(){
	    pagination.labels = columns.slice(pagination.position, pagination.position + pagination.range);
	    pagination.total = columns.length;
	    renderLegendComponent.call(self, pagination.labels);
	    if (pagination.total > pagination.range) {
	      renderPaginationComponent.call(self);
	    }
	    chart.resize();
	  }
	
	  function renderLegendComponent(){
	    legendItems
	      .selectAll('g')
	      .remove();
	
	    var legendItemList = legendItems
	      .selectAll('g')
	      .data(pagination.labels);
	
	    legendItemList.enter()
	        .append('g')
	        .attr('transform', function(id, i){
	          return 'translate(0, ' + (20 * i) + ')'
	        })
	      .attr('data-id', function (id) { return id; })
	      .style('opacity', function(id){
	        var isHidden = pagination.hidden.indexOf(id);
	        return isHidden < 0 ? 1 : .35;
	      })
	      .each(function (id) {
	        d3.select(this)
	          .append('text')
	          .attr({
	            'font-size': 12,
	            'pointer-events': 'none',
	            'x': 15,
	            'y': 9
	          })
	          .text(id)
	          .text(function(id){
	            if (d3.select(this).node().getBBox().width > 105) {
	              return id.length <= 15 ? id : id.substring(0, 12) + '...';
	            }
	            else {
	              return id;
	            }
	          });
	        d3.select(this)
	          .append('rect')
	          .attr({
	            'height': 14,
	            'width': 110,
	            'x': 0,
	            'y': 0
	          })
	          .style({
	            'cursor': 'pointer',
	            'fill-opacity': 0
	          });
	        d3.select(this)
	          .append('rect')
	          .attr({
	            'fill': chart.color(id),
	            'height': 10,
	            'pointer-events': 'none',
	            'rx': 5,
	            'ry': 5,
	            'width': 10,
	            'x': 0,
	            'y': 0
	          });
	      })
	      .on('mouseover', function (id, i) {
	          chart.focus(id);
	          // show a tooltip overlay w/ full value
	          if (id.length > 15) {
	            d3.select(domNode)
	              .append('div')
	              .attr('class', 'keen-c3-legend-label-overlay')
	              .style({
	                'max-width': '75%',
	                'right': -legendWidth + 'px',
	                'top': (5 + (i+1) * 20) + 'px'
	              })
	              .html(id)
	              .append('div')
	                .attr('class', 'keen-c3-legend-label-overlay-pointer');
	          }
	      })
	      .on('mouseout', function (id) {
	        chart.revert();
	        // clear out the tooltip overlay
	        d3.select(self.el().querySelector('.' + self.theme() + '-rendering .keen-c3-legend-label-overlay'))
	          .remove();
	      })
	      .on('click', function (id) {
	        d3.select(this).style('opacity', function(){
	          var isHidden = pagination.hidden.indexOf(id);
	          if (isHidden < 0) {
	            pagination.hidden.push(id);
	            return .35;
	          }
	          else {
	            pagination.hidden.splice(isHidden, 1);
	            return 1;
	          }
	        });
	        chart.toggle(id);
	      });
	
	    legendItemList.exit().remove();
	  }
	
	  function renderPaginationComponent(){
	    paginateEl
	      .selectAll('g')
	      .remove();
	
	    paginateEl
	        .selectAll('g')
	        .data([
	          { direction: 'reverse', path_d: 'M0 10 L10 0 L20 10 Z' },
	          { direction: 'forward', path_d: 'M0 0 L10 10 L20 0 Z' }
	        ])
	        .enter()
	        .append('g')
	        .attr('transform', function(id, i){
	          return 'translate(' + (i * 20) + ', 0)'
	        })
	        .each(function(id){
	          d3.select(this)
	            .append('path')
	            .attr('d', function(d){
	              return d.path_d;
	            })
	            .style({
	              'cursor': 'pointer',
	              'fill': '#D7D7D7',
	              'stroke': 'none'
	            })
	            .on('mouseover', function (id) {
	              d3.select(this).style('fill', '#4D4D4D');
	            })
	            .on('mouseout', function (id) {
	              d3.select(this).style('fill', '#D7D7D7');
	            })
	            .on('click', function (d) {
	              if (d.direction === 'forward') {
	                if (pagination.position + pagination.range < pagination.total) {
	                  pagination.position = pagination.position + pagination.range;
	                }
	              }
	              else {
	                if (pagination.position - pagination.range >= 0) {
	                  pagination.position = pagination.position - pagination.range;
	                }
	              }
	              paginateData();
	              clearSelectedText();
	            });
	        });
	  }
	
	  function clearSelectedText() {
	    var selection;
	    if (document.selection && document.selection.empty) {
	      selection = document.selection;
	      selection.empty();
	    }
	    else if (window.getSelection) {
	      selection = window.getSelection();
	      selection.removeAllRanges();
	    }
	  }
	
	};


/***/ }),
/* 1854 */
/***/ (function(module, exports, __webpack_require__) {

	var escapeHtml = __webpack_require__(1847);
	
	module.exports = function (d, defaultTitleFormat, defaultValueFormat, color) {
	  var bgcolor,
	      name,
	      nameFormat,
	      text,
	      title,
	      titleFormat,
	      value,
	      valueFormat;
	
	  // Set config options or defaults
	  nameFormat = this.config.tooltip_format_name || function (name) { return name; };
	  titleFormat = this.config.tooltip_format_title || defaultTitleFormat;
	  valueFormat = this.config.tooltip_format_value || defaultValueFormat;
	
	  // Reverse list to match legend
	  for (var i = 0; i < d.length; i++) {
	    if (! (d[i] && (d[i].value || d[i].value === 0))) { continue; }
	    if (! text) {
	      title = titleFormat ? titleFormat(d[i].x) : d[i].x;
	      text = "<table class='" + this.CLASS.tooltip + "'>" + (title || title === 0 ? "<tr><th colspan='2'>" + escapeHtml(title) + "</th></tr>" : "");
	    }
	    name = nameFormat(d[i].name);
	    value = valueFormat(d[i].value, d[i].ratio, d[i].id, d[i].index);
	    bgcolor = this.levelColor ? this.levelColor(d[i].value) : color(d[i].id);
	    if (value) {
	      text += "<tr class='" + this.CLASS.tooltipName + "-" + d[i].id + "'>";
	      text +=   "<td class='name'><span style='background-color:" + bgcolor + "'></span>" + escapeHtml(name) + "</td>";
	      text +=   "<td class='value'>" + escapeHtml(value) + "</td>";
	      text += "</tr>";
	    }
	  }
	  return text + "</table>";
	};


/***/ }),
/* 1855 */
/***/ (function(module, exports, __webpack_require__) {

	var escapeHtml = __webpack_require__(1847);
	
	module.exports = {
	  render: function(text){
	    var outer = document.createElement('div');
	    var inner = document.createElement('div');
	    var msg = document.createElement('span');
	    var height = this.height() || 140;
	
	    var titleContainer = document.createElement('div');
	    var notesContainer = document.createElement('div');
	
	    outer.className = this.theme();
	    inner.className = this.theme() + '-message';
	    inner.style.width = this.width() + 'px';
	
	    // Create title and notes for message
	    titleContainer.className = this.theme() + '-title';
	    titleContainer.innerHTML = escapeHtml(this.title() || '');
	    notesContainer.className = this.theme() + '-notes';
	    notesContainer.innerHTML = escapeHtml(this.notes() || '');
	
	    msg.innerHTML = escapeHtml(text) || '';
	    inner.appendChild(msg);
	    outer.appendChild(titleContainer);
	    outer.appendChild(inner);
	    outer.appendChild(notesContainer);
	
	    this.el().innerHTML = '';
	    this.el().appendChild(outer);
	
	    var actualInnerHeight = height - titleContainer.offsetHeight - notesContainer.offsetHeight;
	    inner.style.height = actualInnerHeight + 'px';
	    inner.style.paddingTop = (actualInnerHeight / 2 - 12) + 'px';
	  },
	  update: function(){
	    // no special update handling
	    this.render();
	  },
	  destroy: function(){
	    // no special clean-up
	  }
	};


/***/ }),
/* 1856 */
/***/ (function(module, exports, __webpack_require__) {

	var prettyNumber = __webpack_require__(1857);
	var escapeHtml = __webpack_require__(1847);
	
	module.exports = {
	  render: function(){
	    var color = this.colors()[0],
	        theme = this.theme(),
	        title = this.title(),
	        value = '-',
	        height = this.height() || 140,
	        width = this.width(),
	        opts = this.chartOptions(),
	        html = '',
	        prefix = '',
	        suffix = '',
	        formattedNum,
	        valueEl;
	
	    if (typeof this.data()[1][1] === 'number') {
	      value = this.data()[1][1];
	    }
	
	    formattedNum = value;
	    if ( (typeof opts['prettyNumber'] === 'undefined' || opts['prettyNumber'] === true)
	      && !isNaN(parseInt(value)) ) {
	        formattedNum = prettyNumber(value);
	    }
	
	    if (opts['prefix']) {
	      prefix = '<span class="' + theme + '-metric-prefix">' + opts['prefix'] + '</span>';
	    }
	    if (opts['suffix']) {
	      suffix = '<span class="' + theme + '-metric-suffix">' + opts['suffix'] + '</span>';
	    }
	
	    html += '<div class="' + theme + '">';
	    html +=   '<div class="' + theme + '-metric" style="background-color: ' + color + '; width: ' + (width ? width + 'px' : 'auto') + ';" title="' + escapeHtml(value) + '">';
	    html +=     '<span class="' + theme + '-metric-value">' + prefix + escapeHtml(formattedNum) + suffix + '</span>';
	    if (title) {
	      html +=   '<span class="' + theme + '-metric-title">' + escapeHtml(title) + '</span>';
	    }
	    html +=   '</div>';
	    html += '</div>';
	
	    this.el().innerHTML = html;
	    valueEl = this.el().querySelector('.' + theme + '-metric-value');
	    valueEl.style.paddingTop = ((height - this.el().offsetHeight) / 2) + 'px';
	    this.el().querySelector('.' + theme + '-metric').style.height = height + 'px';
	  },
	  update: function(){
	    // no special update handling
	    this.render();
	  },
	  destroy: function(){
	    // no special clean-up
	  }
	};


/***/ }),
/* 1857 */
/***/ (function(module, exports) {

	module.exports = prettyNumber;
	
	function prettyNumber(input) {
	  // If it has 3 or fewer sig figs already, just return the number.
	  var input = Number(input),
	      sciNo = input.toPrecision(3),
	      prefix = '',
	      suffixes = ['', 'k', 'M', 'B', 'T'];
	
	  if (Number(sciNo) == input && String(input).length <= 4) {
	    return String(input);
	  }
	
	  if (Math.abs(input) >= 1000000000000000) {
	    return sciNo;
	  }
	
	  if (input >= 1 || input <= -1) {
	    if (input < 0){
	      //Pull off the negative side and stash that.
	      input = -input;
	      prefix = '-';
	    }
	    return prefix + recurse(input, 0);
	  }
	  else {
	    return input.toPrecision(3);
	  }
	
	  function recurse(input, iteration) {
	    var input = String(input);
	    var split = input.split('.');
	    // If there's a dot
	    if (split.length > 1) {
	      // Keep the left hand side only
	      input = split[0];
	      var rhs = split[1];
	      // If the left-hand side is too short, pad until it has 3 digits
	      if (input.length == 2 && rhs.length > 0) {
	        // Pad with right-hand side if possible
	        if (rhs.length > 0) {
	          input = input + '.' + rhs.charAt(0);
	        }
	        // Pad with zeroes if you must
	        else {
	          input += '0';
	        }
	      }
	      else if (input.length == 1 && rhs.length > 0) {
	        input = input + '.' + rhs.charAt(0);
	        // Pad with right-hand side if possible
	        if (rhs.length > 1) {
	          input += rhs.charAt(1);
	        }
	        // Pad with zeroes if you must
	        else {
	          input += '0';
	        }
	      }
	    }
	    var numNumerals = input.length;
	    // if it has a period, then numNumerals is 1 smaller than the string length:
	    if (input.split('.').length > 1) {
	      numNumerals--;
	    }
	    if (numNumerals <= 3) {
	      return String(input) + suffixes[iteration];
	    }
	    else {
	      return recurse(Number(input) / 1000, iteration + 1);
	    }
	  }
	}


/***/ }),
/* 1858 */
/***/ (function(module, exports, __webpack_require__) {

	var each = __webpack_require__(1834);
	var escapeHtml = __webpack_require__(1847);
	
	var defaults = {
	  height: undefined,
	  width: undefined,
	  stickyHeader: true,
	  stickyFooter: false
	};
	
	function _generateTableRows(dataset, colWidths, colAligns) {
	  var html = '';
	  for (var i = 0; i < dataset.length; i++) {
	    if (i > 0) {
	      html +=   '<tr>';
	      for (var j = 0; j < dataset[i].length; j++) {
	        html +=   '<td style="min-width: '+ (10 * colWidths[j]) +'px; text-align: ' + colAligns[j] + ';">' + escapeHtml(dataset[i][j]) + '</td>';
	      }
	      html +=   '</tr>';
	    }
	  }
	  return html;
	}
	
	module.exports = {
	  render: function(){
	    var dataset = this.data(),
	        el = this.el(),
	        height = (this.height() || defaults.height) - this.el().offsetHeight,
	        theme = this.theme(),
	        width = this.width() || defaults.width;
	
	    var html = '',
	        colAligns = new Array(dataset[0].length),
	        colWidths = new Array(dataset[0].length),
	        fixedHeader;
	
	    var isEmpty = dataset.length === 1 && dataset[0].length === 0;
	    if (isEmpty) {
	      this.message('No data to display');
	      return;
	    }
	
	    // Calculate max column widths
	    each(dataset, function(row){
	      each(row, function(cell, i){
	        if (!colWidths[i]) {
	          colWidths[i] = 0;
	        }
	        colAligns[i] = (typeof cell === 'number') ? 'right' : 'left';
	        colWidths[i] = (String(cell).length > colWidths[i]) ? String(cell).length : colWidths[i];
	      });
	    });
	
	    // Open wrapper
	    html += '<div class="' + theme + '-table" style="height: '+(height ? height+'px' : 'auto')+'; width: '+(width ? width+'px' : 'auto')+';">';
	
	    // Static, scrollable table
	    html +=   '<table class="' + theme + '-table-dataset">';
	    html +=     '<thead>';
	    html +=       '<tr>';
	    for (var i = 0; i < dataset[0].length; i++) {
	      html +=       '<th style="width: '+ (10 * colWidths[i]) +'px; text-align: ' + colAligns[i] + ';">' + escapeHtml(dataset[0][i]) + '</th>';
	    }
	    html +=       '</tr>';
	    html +=     '</thead>';
	    // Table data
	    html +=     '<tbody>';
	    html +=     _generateTableRows.bind(this, dataset, colWidths, colAligns)();
	    html +=     '</tbody>';
	    html +=   '</table>';
	
	    // Fixed table (header)
	    html +=   '<table class="' + theme + '-table-fixed-header">';
	    html +=     '<thead>';
	    html +=       '<tr>';
	    for (var i = 0; i < dataset[0].length; i++) {
	      html +=       '<th style="min-width: '+ (10 * colWidths[i]) +'px; text-align: ' + colAligns[i] + ';">' + escapeHtml(dataset[0][i]) + '</th>';
	    }
	    html +=       '</tr>';
	    html +=     '</thead>';
	    html +=   '</table>';
	
	    // Close wrapper
	    html += '</div>';
	
	    // Inject HTML string
	    el.querySelector('.' + theme + '-rendering').innerHTML = html;
	
	    fixedHeader = el.querySelector('.' + theme + '-table-fixed-header');
	    el.querySelector('.' + theme + '-table').onscroll = function(e){
	      fixedHeader.style.top = e.target.scrollTop + 'px';
	    };
	  },
	  update: function(){
	    // no special update handling
	    this.render();
	  },
	  destroy: function(){
	    var el = this.el().querySelector('.' + this.theme() + '-table')
	    if (el && el.onscroll) {
	      el.onscroll = undefined;
	    }
	  }
	};


/***/ }),
/* 1859 */
/***/ (function(module, exports) {

	module.exports = {
	  render: function(){
	    var html = '',
	        artifacts = this.view._artifacts.spinner = {},
	        height = this.height() || 35,
	        offsetPadding = (height - 35) / 2,
	        prefixes = ['webkit', 'Moz', 'ms', 'O'],
	        radius = this.view._artifacts.radius = 0,
	        spinner;
	
	    // Build DOM element
	    html += '<div class="' + this.theme() + '">';
	    html +=   '<div class="keen-spinner-container" style="height: ' + height + 'px; padding-top: ' + offsetPadding + 'px;">';
	    html +=     '<div class="keen-spinner-indicator"></div>';
	    html +=   '</div>';
	    html += '</div>';
	    this.el().innerHTML = html;
	
	    spinner = this.el().querySelector('.keen-spinner-indicator');
	    if (spinner.style.animationName === undefined) {
	      radius = 0;
	      artifacts.interval = setInterval(function(){
	        radius = (radius === 350) ? 0 : radius + 10;
	        for (var i = 0; i < prefixes.length; i++) {
	          spinner.style[prefixes[i]] = 'rotate(' + artifacts.radius + 'deg)';
	        }
	      }, 15);
	    }
	  },
	  update: function(){
	    // no special update handling
	    this.render();
	  },
	  destroy: function(){
	    if (this.view._artifacts.spinner) {
	      if (this.view._artifacts.spinner.interval) {
	        clearInterval(this.view._artifacts.spinner.interval);
	      }
	      this.view._artifacts.spinner.radius = 0;
	      try {
	        delete this.view._artifacts.spinner;
	      }
	      catch (e) {
	        this.view._artifacts.spinner = undefined;
	      }
	    }
	    this.el().innerHTML = '';
	  }
	};


/***/ }),
/* 1860 */
/***/ (function(module, exports) {

	module.exports = {
		"name": "keen-js",
		"version": "4.3.0",
		"license": "MIT",
		"main": "lib/index.js",
		"style": "style/index.css",
		"repository": {
			"type": "git",
			"url": "https://github.com/keen/keen-js.git"
		},
		"scripts": {
			"start": "gulp with-tests",
			"test": "gulp test:cli"
		},
		"bugs": "https://github.com/keen/keen-js/issues",
		"author": "Dustin Larimer <dustin@keen.io> (https://keen.io/)",
		"contributors": [
			"Dustin Larimer <dustin@keen.io> (https://github.com/dustinlarimer)",
			"Joanne Cheng <joanne@keen.io> (http://joannecheng.me)"
		],
		"dependencies": {
			"keen-analysis": "1.3.0",
			"keen-dataviz": "https://github.com/theopolisme/keen-dataviz.js.git#master",
			"keen-tracking": "1.4.0"
		},
		"devDependencies": {
			"browserify": "^8.0.3",
			"chai": "^1.10.0",
			"chai-spies": "^0.5.1",
			"del": "^1.1.0",
			"event-stream": "^3.1.7",
			"gulp": "^3.8.10",
			"gulp-awspublish": "0.0.23",
			"gulp-connect": "^2.2.0",
			"gulp-minify-css": "^1.2.4",
			"gulp-mocha": "^2.0.0",
			"gulp-mocha-phantomjs": "^0.11.0",
			"gulp-postcss": "^7.0.0",
			"gulp-remove-empty-lines": "0.0.2",
			"gulp-rename": "^1.2.0",
			"gulp-strip-comments": "^1.0.1",
			"gulp-uglify": "^1.5.4",
			"gulp-util": "^3.0.1",
			"karma": "^0.12.28",
			"karma-chrome-launcher": "^0.1.7",
			"karma-firefox-launcher": "^0.1.3",
			"karma-mocha": "^0.2.0",
			"karma-nyan-reporter": "0.0.50",
			"karma-requirejs": "^0.2.2",
			"karma-safari-launcher": "^0.1.1",
			"karma-sauce-launcher": "^0.2.10",
			"karma-sinon": "^1.0.4",
			"lodash.template": "^2.4.1",
			"mocha": "^2.4.5",
			"moment": "^2.8.4",
			"nock": "^0.51.0",
			"phantomjs": "^1.9.17",
			"postcss-cssnext": "^3.0.2",
			"postcss-import": "^10.0.0",
			"postcss-reporter": "^5.0.0",
			"pump": "^1.0.1",
			"requirejs": "^2.2.0",
			"sinon": "^1.17.3",
			"vinyl-transform": "^1.0.0"
		}
	};

/***/ }),
/* 1861 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _alt = __webpack_require__(975);
	
	var _alt2 = _interopRequireDefault(_alt);
	
	var _keyBy = __webpack_require__(990);
	
	var _keyBy2 = _interopRequireDefault(_keyBy);
	
	var _AnalyticsUtil = __webpack_require__(1862);
	
	var _AnalyticsUtil2 = _interopRequireDefault(_AnalyticsUtil);
	
	var _AnalyticsActions = __webpack_require__(1863);
	
	var _AnalyticsActions2 = _interopRequireDefault(_AnalyticsActions);
	
	var _UserStore = __webpack_require__(974);
	
	var _UserStore2 = _interopRequireDefault(_UserStore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var AnalyticsStore = function () {
	  function AnalyticsStore() {
	    _classCallCheck(this, AnalyticsStore);
	
	    this.bindActions(_AnalyticsActions2.default);
	
	    this.state = {
	      isFetching: false,
	      eventBucketOverviews: {},
	      eventBucketSales: {},
	      eventTicketSales: {},
	      passBucketSales: {},
	      passBucketsOverview: {}, // indexed by event bucket id
	      isFetchingPassBucketsOverview: false,
	      attendeeAnalytics: {}, // indexed by event bucket id
	      isFetchingAttendeeAnalytics: false,
	      geoAnalytics: {}, // indexed by event bucket id
	      eventSalesAnalytics: {}, // indexed by event bucket id
	      eventSalesAnalyticsLoadingInterval: null,
	      eventPassesAnalytics: {}, // indexed by event bucket id
	      passSalesAnalytics: {}, // indexed by event bucket id
	      isFetchingPassSalesAnalytics: false,
	      eventSalesDetailAnalytics: {}, // indexed by event
	      salesAnalytics: {}, // indexed by event bucket id
	      eventTicketAnalytics: {}, // indexed by event bucket id
	      recurringPassAnalytics: {}, // indexed by event bucket id,
	      isFetchingRenewalAnalytics: false,
	      expiredPassAnalytics: {}, // indexed by event bucket id,
	      isFetchingExpiredPassAnalytics: false,
	      newSubscriptionAnalytics: {}, // indexed by event bucket id
	      isFetchingNewSubscriptionAnalytics: false,
	      recurringPassOverview: {}, // indexed by event bucket id,
	      isFetchingRecurringPassOverview: false
	    };
	
	    this.exportPublicMethods({
	      getEventTicketSalesById: this.getEventTicketSalesById.bind(this),
	      getEventBucketSalesById: this.getEventBucketSalesById.bind(this),
	      getEventBucketOverview: this.getEventBucketOverview.bind(this),
	      getPassBucketSalesById: this.getPassBucketSalesById.bind(this),
	      getPassBucketsOverview: this.getPassBucketsOverview.bind(this),
	      getAttendeeAnalytics: this.getAttendeeAnalytics.bind(this),
	      getAttendeeAnalyticsForVenue: this.getAttendeeAnalyticsForVenue.bind(this),
	      getAttendeeAnalyticsForTag: this.getAttendeeAnalyticsForTag.bind(this),
	      getGeoAnalytics: this.getGeoAnalytics.bind(this),
	      getEventSalesAnalytics: this.getEventSalesAnalytics.bind(this),
	      getEventSalesDetailAnalytics: this.getEventSalesDetailAnalytics.bind(this),
	      getEventPassesAnalytics: this.getEventPassesAnalytics.bind(this),
	      getPassSalesAnalytics: this.getPassSalesAnalytics.bind(this),
	      getSalesAnalytics: this.getSalesAnalytics.bind(this),
	      getEventTicketAnalytics: this.getEventTicketAnalytics.bind(this),
	      getRecurringPassAnalytics: this.getRecurringPassAnalytics.bind(this),
	      getExpiredPassAnalytics: this.getExpiredPassAnalytics.bind(this),
	      getNewSubscriptionAnalytics: this.getNewSubscriptionAnalytics.bind(this),
	      getRecurringPassOverview: this.getRecurringPassOverview.bind(this),
	
	      getIsFetchingPassBucketsOverview: this.getIsFetchingPassBucketsOverview.bind(this),
	      getIsFetchingRenewalAnalytics: this.getIsFetchingRenewalAnalytics.bind(this),
	      getIsFetchingExpiredPassAnalytics: this.getIsFetchingExpiredPassAnalytics.bind(this),
	      getIsFetchingNewSubscriptionAnalytics: this.getIsFetchingNewSubscriptionAnalytics.bind(this),
	      getIsFetchingRecurringPassOverview: this.getIsFetchingRecurringPassOverview.bind(this),
	      getIsFetchingAttendeeAnalytics: this.getIsFetchingAttendeeAnalytics.bind(this)
	    });
	  }
	
	  _createClass(AnalyticsStore, [{
	    key: "getEventTicketSalesById",
	    value: function getEventTicketSalesById(id) {
	      return this.state.eventTicketSales[id];
	    }
	  }, {
	    key: "getEventBucketSalesById",
	    value: function getEventBucketSalesById(id) {
	      return this.state.eventBucketSales[id];
	    }
	  }, {
	    key: "getEventBucketOverview",
	    value: function getEventBucketOverview(id) {
	      return this.state.eventBucketOverviews[id];
	    }
	  }, {
	    key: "getPassBucketSalesById",
	    value: function getPassBucketSalesById(id) {
	      return this.state.passBucketSales[id];
	    }
	  }, {
	    key: "getPassBucketsOverview",
	    value: function getPassBucketsOverview(eventBucketId) {
	      return this.state.passBucketsOverview[eventBucketId];
	    }
	  }, {
	    key: "getAttendeeAnalytics",
	    value: function getAttendeeAnalytics(eventBucketId) {
	      return this.state.attendeeAnalytics[eventBucketId];
	    }
	  }, {
	    key: "getAttendeeAnalyticsForVenue",
	    value: function getAttendeeAnalyticsForVenue(eventBucketId, venueId) {
	      return this.state.attendeeAnalytics[eventBucketId + "-" + venueId];
	    }
	  }, {
	    key: "getAttendeeAnalyticsForTag",
	    value: function getAttendeeAnalyticsForTag(eventBucketId, tagId) {
	      return this.state.attendeeAnalytics[eventBucketId + "-" + tagId];
	    }
	  }, {
	    key: "getGeoAnalytics",
	    value: function getGeoAnalytics(eventBucketId) {
	      return this.state.geoAnalytics[eventBucketId];
	    }
	  }, {
	    key: "getEventSalesAnalytics",
	    value: function getEventSalesAnalytics(eventBucketId) {
	      return this.state.eventSalesAnalytics[eventBucketId];
	    }
	  }, {
	    key: "getEventSalesDetailAnalytics",
	    value: function getEventSalesDetailAnalytics(eventId) {
	      return this.state.eventSalesDetailAnalytics[eventId];
	    }
	  }, {
	    key: "getEventPassesAnalytics",
	    value: function getEventPassesAnalytics(eventBucketId) {
	      return this.state.eventPassesAnalytics[eventBucketId];
	    }
	  }, {
	    key: "getPassSalesAnalytics",
	    value: function getPassSalesAnalytics(eventBucketId) {
	      return this.state.passSalesAnalytics[eventBucketId];
	    }
	  }, {
	    key: "getSalesAnalytics",
	    value: function getSalesAnalytics(eventBucketId) {
	      return this.state.salesAnalytics[eventBucketId];
	    }
	  }, {
	    key: "getEventTicketAnalytics",
	    value: function getEventTicketAnalytics(eventBucketId) {
	      return this.state.eventTicketAnalytics[eventBucketId];
	    }
	  }, {
	    key: "getRecurringPassAnalytics",
	    value: function getRecurringPassAnalytics(eventBucketId) {
	      return this.state.recurringPassAnalytics[eventBucketId];
	    }
	  }, {
	    key: "getExpiredPassAnalytics",
	    value: function getExpiredPassAnalytics(eventBucketId) {
	      return this.state.expiredPassAnalytics[eventBucketId];
	    }
	  }, {
	    key: "getNewSubscriptionAnalytics",
	    value: function getNewSubscriptionAnalytics(eventBucketId) {
	      return this.state.newSubscriptionAnalytics[eventBucketId];
	    }
	  }, {
	    key: "getRecurringPassOverview",
	    value: function getRecurringPassOverview(eventBucketId) {
	      return this.state.recurringPassOverview[eventBucketId];
	    }
	  }, {
	    key: "getIsFetchingPassBucketsOverview",
	    value: function getIsFetchingPassBucketsOverview() {
	      return this.state.isFetchingPassBucketsOverview;
	    }
	  }, {
	    key: "getIsFetchingRenewalAnalytics",
	    value: function getIsFetchingRenewalAnalytics() {
	      return this.state.isFetchingRenewalAnalytics;
	    }
	  }, {
	    key: "getIsFetchingExpiredPassAnalytics",
	    value: function getIsFetchingExpiredPassAnalytics() {
	      return this.state.isFetchingExpiredPassAnalytics;
	    }
	  }, {
	    key: "getIsFetchingNewSubscriptionAnalytics",
	    value: function getIsFetchingNewSubscriptionAnalytics() {
	      return this.state.isFetchingNewSubscriptionAnalytics;
	    }
	  }, {
	    key: "getIsFetchingRecurringPassOverview",
	    value: function getIsFetchingRecurringPassOverview() {
	      return this.state.isFetchingRecurringPassOverview;
	    }
	  }, {
	    key: "getIsFetchingAttendeeAnalytics",
	    value: function getIsFetchingAttendeeAnalytics() {
	      return this.state.isFetchingAttendeeAnalytics;
	    }
	  }, {
	    key: "onFetchEventBucketOverview",
	    value: function onFetchEventBucketOverview(eventBucketId) {
	      _AnalyticsUtil2.default.fetchEventBucketOverview(_UserStore2.default.getState().apiKey, eventBucketId).then(function (data) {
	        _AnalyticsActions2.default.updateEventBucketOverview(eventBucketId, data);
	      }).catch(_AnalyticsActions2.default.fetchFailed);
	    }
	  }, {
	    key: "onFetchEventBucketSales",
	    value: function onFetchEventBucketSales(eventBucketId) {
	      _AnalyticsUtil2.default.fetchEventBucketSales(_UserStore2.default.getState().apiKey, eventBucketId).then(function (data) {
	        _AnalyticsActions2.default.updateEventBucketSales(eventBucketId, data.sales);
	      }).catch(_AnalyticsActions2.default.fetchFailed);
	    }
	  }, {
	    key: "onFetchEventTicketSales",
	    value: function onFetchEventTicketSales(eventId) {
	      _AnalyticsUtil2.default.fetchEventTicketSales(_UserStore2.default.getState().apiKey, eventId).then(function (data) {
	        _AnalyticsActions2.default.updateEventTicketSales(eventId, data.sales);
	      }).catch(_AnalyticsActions2.default.fetchFailed);
	    }
	  }, {
	    key: "onFetchPassBucketSales",
	    value: function onFetchPassBucketSales(passBucketId) {
	      _AnalyticsUtil2.default.fetchPassBucketSales(_UserStore2.default.getState().apiKey, passBucketId).then(function (data) {
	        _AnalyticsActions2.default.updatePassBucketSales(passBucketId, data.sales);
	      }).catch(_AnalyticsActions2.default.fetchFailed);
	    }
	  }, {
	    key: "onFetchPassBucketsOverview",
	    value: function onFetchPassBucketsOverview(_ref) {
	      var _this = this;
	
	      var eventBucketId = _ref.eventBucketId;
	      var filterState = _ref.filterState;
	      var startDate = _ref.startDate;
	      var endDate = _ref.endDate;
	      var allTime = _ref.allTime;
	
	      this.setState({ isFetchingPassBucketsOverview: true });
	      _AnalyticsUtil2.default.fetchPassBucketsOverview(_UserStore2.default.getState().apiKey, eventBucketId, filterState, startDate, endDate, allTime).then(function (data) {
	        _this.setState({ isFetchingPassBucketsOverview: false });
	        _AnalyticsActions2.default.updatePassBucketsOverview(eventBucketId, data);
	      }).catch(_AnalyticsActions2.default.fetchFailed);
	    }
	  }, {
	    key: "onFetchPassSalesAnalytics",
	    value: function onFetchPassSalesAnalytics(_ref2) {
	      var _this2 = this;
	
	      var eventBucketId = _ref2.eventBucketId;
	      var isMembership = _ref2.isMembership;
	      var filterState = _ref2.filterState;
	      var startDate = _ref2.startDate;
	      var endDate = _ref2.endDate;
	      var allTime = _ref2.allTime;
	
	      this.setState({ isFetchingPassSalesAnalytics: true });
	      _AnalyticsUtil2.default.fetchPassSalesAnalytics(_UserStore2.default.getState().apiKey, eventBucketId, isMembership, filterState, startDate, endDate, allTime).then(function (data) {
	        _this2.setState({ isFetchingPassSalesAnalytics: false });
	        _AnalyticsActions2.default.updatePassSalesAnalytics(eventBucketId, data);
	      }).catch(_AnalyticsActions2.default.fetchFailed);
	    }
	  }, {
	    key: "onFetchAttendeeAnalytics",
	    value: function onFetchAttendeeAnalytics(_ref3) {
	      var _this3 = this;
	
	      var eventBucketId = _ref3.eventBucketId;
	      var filterState = _ref3.filterState;
	      var startDate = _ref3.startDate;
	      var endDate = _ref3.endDate;
	      var allTime = _ref3.allTime;
	
	      this.setState({ isFetchingAttendeeAnalytics: true });
	      _AnalyticsUtil2.default.fetchAttendeeAnalytics(_UserStore2.default.getState().apiKey, eventBucketId, filterState, startDate, endDate, allTime).then(function (data) {
	        _this3.setState({ isFetchingAttendeeAnalytics: false });
	        _AnalyticsActions2.default.updateAttendeeAnalytics(eventBucketId, data);
	      }).catch(_AnalyticsActions2.default.fetchFailed);
	    }
	  }, {
	    key: "onFetchAttendeeAnalyticsForVenue",
	    value: function onFetchAttendeeAnalyticsForVenue(_ref4) {
	      var eventBucketId = _ref4.eventBucketId;
	      var venueId = _ref4.venueId;
	
	      _AnalyticsUtil2.default.fetchAttendeeAnalytics(_UserStore2.default.getState().apiKey, eventBucketId, { venue: venueId }).then(function (data) {
	        _AnalyticsActions2.default.updateAttendeeAnalytics(eventBucketId + "-" + venueId, data);
	      }).catch(_AnalyticsActions2.default.fetchFailed);
	    }
	  }, {
	    key: "onFetchAttendeeAnalyticsForTag",
	    value: function onFetchAttendeeAnalyticsForTag(_ref5) {
	      var eventBucketId = _ref5.eventBucketId;
	      var tagId = _ref5.tagId;
	
	      _AnalyticsUtil2.default.fetchAttendeeAnalytics(_UserStore2.default.getState().apiKey, eventBucketId, { tag: tagId }).then(function (data) {
	        _AnalyticsActions2.default.updateAttendeeAnalytics(eventBucketId + "-" + tagId, data);
	      }).catch(_AnalyticsActions2.default.fetchFailed);
	    }
	  }, {
	    key: "onFetchGeoAnalytics",
	    value: function onFetchGeoAnalytics(eventBucketId) {
	      _AnalyticsUtil2.default.fetchGeoAnalytics(_UserStore2.default.getState().apiKey, eventBucketId).then(function (data) {
	        _AnalyticsActions2.default.updateGeoAnalytics(eventBucketId, data);
	      }).catch(_AnalyticsActions2.default.fetchFailed);
	    }
	  }, {
	    key: "onFetchEventSalesAnalytics",
	    value: function onFetchEventSalesAnalytics(_ref6) {
	      var _this4 = this;
	
	      var eventBucketId = _ref6.eventBucketId;
	      var startDate = _ref6.startDate;
	      var endDate = _ref6.endDate;
	      var allTime = _ref6.allTime;
	
	      if (this.state.eventSalesAnalyticsLoadingInterval) {
	        _AnalyticsActions2.default.clearFetchEventSalesAnalyticsInterval();
	      }
	
	      var fetch = function fetch() {
	        return _AnalyticsUtil2.default.fetchEventSalesAnalytics(_UserStore2.default.getState().apiKey, eventBucketId, startDate, endDate, allTime);
	      };
	
	      fetch().then(function (data) {
	        if (!data.loadingCache) {
	          _AnalyticsActions2.default.updateEventSalesAnalytics(eventBucketId, data);
	          return;
	        }
	
	        // start watching for the cache to be filled
	        var intervalId = setInterval(function () {
	          fetch().then(function (data) {
	            // no data yet, keep checking
	            if (data.loadingCache) return;
	
	            // cache has been filled and we have the data!
	            _AnalyticsActions2.default.clearFetchEventSalesAnalyticsInterval();
	            _AnalyticsActions2.default.updateEventSalesAnalytics(eventBucketId, data);
	          }).catch(function (err) {
	            _AnalyticsActions2.default.clearFetchEventSalesAnalyticsInterval();
	            _AnalyticsActions2.default.fetchFailed(err);
	          });
	        }, 1000 * 5); // 5 seconds
	
	        _this4.setState({ eventSalesAnalyticsLoadingInterval: intervalId });
	      }).catch(_AnalyticsActions2.default.fetchFailed);
	    }
	  }, {
	    key: "onClearFetchEventSalesAnalyticsInterval",
	    value: function onClearFetchEventSalesAnalyticsInterval() {
	      if (!this.state.eventSalesAnalyticsLoadingInterval) return;
	
	      clearInterval(this.state.eventSalesAnalyticsLoadingInterval);
	      this.setState({
	        eventSalesAnalyticsLoadingInterval: null
	      });
	    }
	  }, {
	    key: "onFetchEventSalesDetailAnalytics",
	    value: function onFetchEventSalesDetailAnalytics(eventId) {
	      _AnalyticsUtil2.default.fetchEventSalesDetailAnalytics(_UserStore2.default.getState().apiKey, eventId).then(function (data) {
	        _AnalyticsActions2.default.updateEventSalesDetailAnalytics(eventId, data);
	      }).catch(_AnalyticsActions2.default.fetchFailed);
	    }
	  }, {
	    key: "onFetchEventPassesAnalytics",
	    value: function onFetchEventPassesAnalytics(_ref7) {
	      var eventBucketId = _ref7.eventBucketId;
	      var isMembership = _ref7.isMembership;
	      var startDate = _ref7.startDate;
	      var endDate = _ref7.endDate;
	      var allTime = _ref7.allTime;
	
	      _AnalyticsUtil2.default.fetchEventPassesAnalytics(_UserStore2.default.getState().apiKey, eventBucketId, isMembership, startDate, endDate, allTime).then(function (data) {
	        _AnalyticsActions2.default.updateEventPassesAnalytics(eventBucketId, data);
	      }).catch(_AnalyticsActions2.default.fetchFailed);
	    }
	  }, {
	    key: "onFetchSalesAnalytics",
	    value: function onFetchSalesAnalytics(options) {
	      var _this5 = this;
	
	      this.setState({ isFetching: true });
	      _AnalyticsUtil2.default.fetchSalesAnalytics(_UserStore2.default.getState().apiKey, options).then(function (data) {
	        _this5.setState({ isFetching: false });
	        _AnalyticsActions2.default.updateSalesAnalytics(options.event_bucket, data);
	      }).catch(_AnalyticsActions2.default.fetchFailed);
	    }
	  }, {
	    key: "onFetchEventTicketAnalytics",
	    value: function onFetchEventTicketAnalytics(_ref8) {
	      var _this6 = this;
	
	      var eventBucketId = _ref8.eventBucketId;
	      var filter2State = _ref8.filter2State;
	      var startDate = _ref8.startDate;
	      var endDate = _ref8.endDate;
	      var allTime = _ref8.allTime;
	
	      this.setState({ isFetching: true });
	      _AnalyticsUtil2.default.fetchEventTicketAnalytics(_UserStore2.default.getState().apiKey, eventBucketId, filter2State, startDate, endDate, allTime).then(function (data) {
	        _this6.setState({ isFetching: false });
	        _AnalyticsActions2.default.updateEventTicketAnalytics(eventBucketId, data);
	      }).catch(_AnalyticsActions2.default.fetchFailed);
	    }
	  }, {
	    key: "onFetchRecurringPassAnalytics",
	    value: function onFetchRecurringPassAnalytics(_ref9) {
	      var _this7 = this;
	
	      var eventBucketId = _ref9.eventBucketId;
	      var _ref9$isMembership = _ref9.isMembership;
	      var isMembership = _ref9$isMembership === undefined ? false : _ref9$isMembership;
	      var startDate = _ref9.startDate;
	      var endDate = _ref9.endDate;
	      var allTime = _ref9.allTime;
	
	      this.setState({ isFetchingRenewalAnalytics: true });
	      _AnalyticsUtil2.default.fetchRecurringPassAnalytics(_UserStore2.default.getState().apiKey, eventBucketId, isMembership, startDate, endDate, allTime).then(function (data) {
	        _this7.setState({ isFetchingRenewalAnalytics: false });
	        _AnalyticsActions2.default.updateRecurringPassAnalytics(eventBucketId, data);
	      }).catch(_AnalyticsActions2.default.fetchFailed);
	    }
	  }, {
	    key: "onFetchExpiredPassAnalytics",
	    value: function onFetchExpiredPassAnalytics(_ref10) {
	      var _this8 = this;
	
	      var eventBucketId = _ref10.eventBucketId;
	      var isMembership = _ref10.isMembership;
	      var startDate = _ref10.startDate;
	      var endDate = _ref10.endDate;
	      var allTime = _ref10.allTime;
	
	      this.setState({ isFetchingExpiredPassAnalytics: true });
	      _AnalyticsUtil2.default.fetchExpiredPassAnalytics(_UserStore2.default.getState().apiKey, eventBucketId, isMembership, startDate, endDate, allTime).then(function (data) {
	        _this8.setState({ isFetchingExpiredPassAnalytics: false });
	        _AnalyticsActions2.default.updateExpiredPassAnalytics(eventBucketId, data);
	      }).catch(_AnalyticsActions2.default.fetchFailed);
	    }
	  }, {
	    key: "onFetchNewSubscriptionAnalytics",
	    value: function onFetchNewSubscriptionAnalytics(_ref11) {
	      var _this9 = this;
	
	      var eventBucketId = _ref11.eventBucketId;
	      var isMembership = _ref11.isMembership;
	      var startDate = _ref11.startDate;
	      var endDate = _ref11.endDate;
	      var allTime = _ref11.allTime;
	
	      this.setState({ isFetchingNewSubscriptionAnalytics: true });
	      _AnalyticsUtil2.default.fetchNewSubscriptionAnalytics(_UserStore2.default.getState().apiKey, eventBucketId, isMembership, startDate, endDate, allTime).then(function (data) {
	        _this9.setState({ isFetchingNewSubscriptionAnalytics: false });
	        _AnalyticsActions2.default.updateNewSubscriptionAnalytics(eventBucketId, data);
	      }).catch(_AnalyticsActions2.default.fetchFailed);
	    }
	  }, {
	    key: "onFetchRecurringPassOverview",
	    value: function onFetchRecurringPassOverview(_ref12) {
	      var _this10 = this;
	
	      var eventBucketId = _ref12.eventBucketId;
	      var _ref12$isMembership = _ref12.isMembership;
	      var isMembership = _ref12$isMembership === undefined ? false : _ref12$isMembership;
	      var startDate = _ref12.startDate;
	      var endDate = _ref12.endDate;
	      var allTime = _ref12.allTime;
	
	      this.setState({ isFetchingRecurringPassOverview: true });
	      _AnalyticsUtil2.default.fetchRecurringPassOverview(_UserStore2.default.getState().apiKey, eventBucketId, isMembership, startDate, endDate, allTime).then(function (data) {
	        _this10.setState({ isFetchingRecurringPassOverview: false });
	        _AnalyticsActions2.default.updateRecurringPassOverview(eventBucketId, data);
	      }).catch(_AnalyticsActions2.default.fetchFailed);
	    }
	  }, {
	    key: "onUpdateEventTicketSales",
	    value: function onUpdateEventTicketSales(data) {
	      this.state.eventTicketSales[data.id] = data.saleData;
	      this.setState(this.state);
	    }
	  }, {
	    key: "onUpdateEventBucketOverview",
	    value: function onUpdateEventBucketOverview(data) {
	      this.state.eventBucketOverviews[data.id] = data.overview;
	      this.setState(this.state);
	    }
	  }, {
	    key: "onUpdateEventBucketSales",
	    value: function onUpdateEventBucketSales(data) {
	      this.state.eventBucketSales[data.id] = data.saleData;
	      this.setState(this.state);
	    }
	  }, {
	    key: "onUpdatePassBucketSales",
	    value: function onUpdatePassBucketSales(data) {
	      this.state.passBucketSales[data.id] = data.saleData;
	      this.setState(this.state);
	    }
	  }, {
	    key: "onUpdatePassBucketsOverview",
	    value: function onUpdatePassBucketsOverview(data) {
	      this.state.passBucketsOverview[data.id] = data.overview;
	      this.setState(this.state);
	    }
	  }, {
	    key: "onUpdateAttendeeAnalytics",
	    value: function onUpdateAttendeeAnalytics(data) {
	      this.state.attendeeAnalytics[data.id] = data.overview;
	      this.setState(this.state);
	    }
	  }, {
	    key: "onUpdateGeoAnalytics",
	    value: function onUpdateGeoAnalytics(data) {
	      this.state.geoAnalytics[data.id] = data.overview;
	      this.setState(this.state);
	    }
	  }, {
	    key: "onUpdateEventSalesAnalytics",
	    value: function onUpdateEventSalesAnalytics(data) {
	      this.state.eventSalesAnalytics[data.id] = data.overview;
	      this.setState(this.state);
	    }
	  }, {
	    key: "onUpdateEventSalesDetailAnalytics",
	    value: function onUpdateEventSalesDetailAnalytics(data) {
	      this.state.eventSalesDetailAnalytics[data.id] = data.overview;
	      this.setState(this.state);
	    }
	  }, {
	    key: "onUpdateEventPassesAnalytics",
	    value: function onUpdateEventPassesAnalytics(data) {
	      this.state.eventPassesAnalytics[data.id] = data.overview;
	      this.setState(this.state);
	    }
	  }, {
	    key: "onUpdatePassSalesAnalytics",
	    value: function onUpdatePassSalesAnalytics(data) {
	      this.state.passSalesAnalytics[data.id] = data.overview;
	      this.setState(this.state);
	    }
	  }, {
	    key: "onUpdateSalesAnalytics",
	    value: function onUpdateSalesAnalytics(data) {
	      this.state.salesAnalytics[data.id] = data.overview;
	      this.setState(this.state);
	    }
	  }, {
	    key: "onUpdateEventTicketAnalytics",
	    value: function onUpdateEventTicketAnalytics(data) {
	      this.state.eventTicketAnalytics[data.id] = data.overview;
	      this.setState(this.state);
	    }
	  }, {
	    key: "onUpdateRecurringPassAnalytics",
	    value: function onUpdateRecurringPassAnalytics(data) {
	      this.state.recurringPassAnalytics[data.id] = data.overview;
	      this.setState(this.state);
	    }
	  }, {
	    key: "onUpdateExpiredPassAnalytics",
	    value: function onUpdateExpiredPassAnalytics(data) {
	      this.state.expiredPassAnalytics[data.id] = data.overview;
	      this.setState(this.state);
	    }
	  }, {
	    key: "onUpdateNewSubscriptionAnalytics",
	    value: function onUpdateNewSubscriptionAnalytics(data) {
	      this.state.newSubscriptionAnalytics[data.id] = data.overview;
	      this.setState(this.state);
	    }
	  }, {
	    key: "onUpdateRecurringPassOverview",
	    value: function onUpdateRecurringPassOverview(data) {
	      this.state.recurringPassOverview[data.id] = data.overview;
	      this.setState(this.state);
	    }
	  }, {
	    key: "onFetchFailed",
	    value: function onFetchFailed(e) {
	      alert("Fetching analytics data failed: " + e.message);
	      throw e;
	    }
	  }]);
	
	  return AnalyticsStore;
	}();
	
	exports.default = _alt2.default.createStore(AnalyticsStore, "AnalyticsStore");
	module.exports = exports["default"];

/***/ }),
/* 1862 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _merge = __webpack_require__(732);
	
	var _merge2 = _interopRequireDefault(_merge);
	
	var _api = __webpack_require__(1160);
	
	var _api2 = _interopRequireDefault(_api);
	
	var _config = __webpack_require__(1173);
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  fetchEventTicketSales: function fetchEventTicketSales(apiKey, event) {
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "GET",
	        endpoint: "charts/ticket_sales",
	        qs: { event: event },
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response);
	      });
	    });
	  },
	  fetchEventBucketSales: function fetchEventBucketSales(apiKey, eventBucket) {
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "GET",
	        endpoint: "charts/sales",
	        qs: { event_bucket: eventBucket },
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response);
	      });
	    });
	  },
	  fetchEventBucketOverview: function fetchEventBucketOverview(apiKey, eventBucket) {
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "GET",
	        endpoint: "charts/overview",
	        qs: { event_bucket: eventBucket },
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response);
	      });
	    });
	  },
	  fetchPassBucketsOverview: function fetchPassBucketsOverview(apiKey, eventBucket, filterState, startDate, endDate, allTime) {
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "GET",
	        endpoint: "charts/pass_sales",
	        qs: {
	          event_bucket: eventBucket,
	          filter_state: filterState,
	          start_date: startDate,
	          end_date: endDate,
	          all_time: allTime
	        },
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response);
	      });
	    });
	  },
	  fetchPassSalesAnalytics: function fetchPassSalesAnalytics(apiKey, eventBucket) {
	    var isMembership = arguments.length <= 2 || arguments[2] === undefined ? false : arguments[2];
	    var filterState = arguments[3];
	    var startDate = arguments[4];
	    var endDate = arguments[5];
	    var allTime = arguments[6];
	
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "POST",
	        endpoint: "analytics/pass_sales",
	        qs: {
	          event_bucket: eventBucket,
	          is_membership: isMembership,
	          filter_state: filterState,
	          start_date: startDate,
	          end_date: endDate,
	          all_time: allTime
	        },
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response);
	      });
	    });
	  },
	  fetchAttendeeAnalytics: function fetchAttendeeAnalytics(apiKey, eventBucket, filterState, startDate, endDate, allTime) {
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "POST",
	        endpoint: "analytics/attendees",
	        qs: {
	          event_bucket: eventBucket,
	          filter_state: filterState,
	          start_date: startDate,
	          end_date: endDate,
	          all_time: allTime
	        },
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response);
	      });
	    });
	  },
	  fetchGeoAnalytics: function fetchGeoAnalytics(apiKey, eventBucket) {
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "POST",
	        endpoint: "analytics/geo",
	        qs: { event_bucket: eventBucket },
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response);
	      });
	    });
	  },
	  fetchEventSalesAnalytics: function fetchEventSalesAnalytics(apiKey, eventBucket, startDate, endDate, allTime) {
	
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "POST",
	        endpoint: "analytics/sales_by_event",
	        qs: {
	          event_bucket: eventBucket,
	          start_date: startDate,
	          end_date: endDate,
	          all_time: allTime
	        },
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response);
	      });
	    });
	  },
	  fetchEventSalesDetailAnalytics: function fetchEventSalesDetailAnalytics(apiKey, event) {
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "POST",
	        endpoint: "analytics/sales_detail_by_event",
	        qs: { event: event },
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response);
	      });
	    });
	  },
	  fetchEventPassesAnalytics: function fetchEventPassesAnalytics(apiKey, eventBucket, isMembership, startDate, endDate, allTime) {
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "POST",
	        endpoint: "analytics/passes_by_event",
	        qs: {
	          event_bucket: eventBucket,
	          is_membership: isMembership,
	          start_date: startDate,
	          end_date: endDate,
	          all_time: allTime
	        },
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response);
	      });
	    });
	  },
	  fetchSalesAnalytics: function fetchSalesAnalytics(apiKey, options) {
	
	    // all_time needs to be its own parameter in order to trigger 
	    // slow responses precompute caching
	    var allTime = options.all_time;
	    var processedOptions = _extends({}, options);
	
	    processedOptions.all_time = undefined;
	
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "POST",
	        endpoint: "analytics/sales",
	        qs: { conditions: JSON.stringify(processedOptions), all_time: allTime },
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response);
	      });
	    });
	  },
	  fetchEventTicketAnalytics: function fetchEventTicketAnalytics(apiKey, eventBucketId, filter2State, startDate, endDate, allTime) {
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "POST",
	        endpoint: "analytics/tickets_by_event",
	        qs: {
	          event_bucket: eventBucketId,
	          filter2_state: filter2State,
	          start_date: startDate,
	          end_date: endDate,
	          all_time: allTime
	        },
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response);
	      });
	    });
	  },
	  fetchRecurringPassAnalytics: function fetchRecurringPassAnalytics(apiKey, eventBucket) {
	    var isMembership = arguments.length <= 2 || arguments[2] === undefined ? false : arguments[2];
	    var startDate = arguments[3];
	    var endDate = arguments[4];
	    var allTime = arguments[5];
	
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "POST",
	        endpoint: "analytics/recurring_pass/upcoming",
	        qs: {
	          event_bucket: eventBucket,
	          is_membership: isMembership,
	          start_date: startDate,
	          end_date: endDate,
	          all_time: allTime
	        },
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response);
	      });
	    });
	  },
	  fetchExpiredPassAnalytics: function fetchExpiredPassAnalytics(apiKey, eventBucket) {
	    var isMembership = arguments.length <= 2 || arguments[2] === undefined ? false : arguments[2];
	    var startDate = arguments[3];
	    var endDate = arguments[4];
	    var allTime = arguments[5];
	
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "POST",
	        endpoint: "analytics/recurring_pass/expired_passes",
	        qs: {
	          event_bucket: eventBucket,
	          is_membership: isMembership,
	          start_date: startDate,
	          end_date: endDate,
	          all_time: allTime
	        },
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response);
	      });
	    });
	  },
	  fetchNewSubscriptionAnalytics: function fetchNewSubscriptionAnalytics(apiKey, eventBucket) {
	    var isMembership = arguments.length <= 2 || arguments[2] === undefined ? false : arguments[2];
	    var startDate = arguments[3];
	    var endDate = arguments[4];
	    var allTime = arguments[5];
	
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "POST",
	        endpoint: "analytics/recurring_pass/new_subscriptions",
	        qs: {
	          event_bucket: eventBucket,
	          is_membership: isMembership,
	          start_date: startDate,
	          end_date: endDate,
	          all_time: allTime
	        },
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response);
	      });
	    });
	  },
	  fetchRecurringPassOverview: function fetchRecurringPassOverview(apiKey, eventBucket) {
	    var isMembership = arguments.length <= 2 || arguments[2] === undefined ? false : arguments[2];
	    var startDate = arguments[3];
	    var endDate = arguments[4];
	    var allTime = arguments[5];
	
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "POST",
	        endpoint: "analytics/recurring_pass/overview",
	        qs: {
	          event_bucket: eventBucket,
	          is_membership: isMembership,
	          start_date: startDate,
	          end_date: endDate,
	          all_time: allTime
	        },
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response);
	      });
	    });
	  }
	};
	module.exports = exports["default"];

/***/ }),
/* 1863 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _alt = __webpack_require__(975);
	
	var _alt2 = _interopRequireDefault(_alt);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var AnalyticsActions = function () {
	  function AnalyticsActions() {
	    _classCallCheck(this, AnalyticsActions);
	
	    this.generateActions("fetchEventTicketSales", "fetchEventBucketOverview", "fetchEventBucketSales", "fetchPassBucketSales", "fetchGeoAnalytics", "clearFetchEventSalesAnalyticsInterval", "fetchEventSalesDetailAnalytics", "fetchSalesAnalytics", "fetchFailed");
	  }
	
	  _createClass(AnalyticsActions, [{
	    key: "updateEventTicketSales",
	    value: function updateEventTicketSales(id, saleData) {
	      return { id: id, saleData: saleData };
	    }
	  }, {
	    key: "updateEventBucketSales",
	    value: function updateEventBucketSales(id, saleData) {
	      return { id: id, saleData: saleData };
	    }
	  }, {
	    key: "updateEventBucketOverview",
	    value: function updateEventBucketOverview(id, overview) {
	      return { id: id, overview: overview };
	    }
	  }, {
	    key: "updatePassBucketSales",
	    value: function updatePassBucketSales(id, saleData) {
	      return { id: id, saleData: saleData };
	    }
	  }, {
	    key: "updatePassBucketsOverview",
	    value: function updatePassBucketsOverview(id, overview) {
	      return { id: id, overview: overview };
	    }
	  }, {
	    key: "updateAttendeeAnalytics",
	    value: function updateAttendeeAnalytics(id, overview) {
	      return { id: id, overview: overview };
	    }
	  }, {
	    key: "updateGeoAnalytics",
	    value: function updateGeoAnalytics(id, overview) {
	      return { id: id, overview: overview };
	    }
	  }, {
	    key: "updateEventSalesAnalytics",
	    value: function updateEventSalesAnalytics(id, overview) {
	      return { id: id, overview: overview };
	    }
	  }, {
	    key: "updateEventSalesDetailAnalytics",
	    value: function updateEventSalesDetailAnalytics(id, overview) {
	      return { id: id, overview: overview };
	    }
	  }, {
	    key: "updateEventPassesAnalytics",
	    value: function updateEventPassesAnalytics(id, overview) {
	      return { id: id, overview: overview };
	    }
	  }, {
	    key: "updatePassSalesAnalytics",
	    value: function updatePassSalesAnalytics(id, overview) {
	      return { id: id, overview: overview };
	    }
	  }, {
	    key: "updateSalesAnalytics",
	    value: function updateSalesAnalytics(id, overview) {
	      return { id: id, overview: overview };
	    }
	  }, {
	    key: "updateEventTicketAnalytics",
	    value: function updateEventTicketAnalytics(id, overview) {
	      return { id: id, overview: overview };
	    }
	  }, {
	    key: "updateRecurringPassAnalytics",
	    value: function updateRecurringPassAnalytics(id, overview) {
	      return { id: id, overview: overview };
	    }
	  }, {
	    key: "updateExpiredPassAnalytics",
	    value: function updateExpiredPassAnalytics(id, overview) {
	      return { id: id, overview: overview };
	    }
	  }, {
	    key: "updateNewSubscriptionAnalytics",
	    value: function updateNewSubscriptionAnalytics(id, overview) {
	      return { id: id, overview: overview };
	    }
	  }, {
	    key: "updateRecurringPassOverview",
	    value: function updateRecurringPassOverview(id, overview) {
	      return { id: id, overview: overview };
	    }
	  }, {
	    key: "fetchEventSalesAnalytics",
	    value: function fetchEventSalesAnalytics(_ref) {
	      var eventBucketId = _ref.eventBucketId;
	      var startDate = _ref.startDate;
	      var endDate = _ref.endDate;
	      var allTime = _ref.allTime;
	
	      return { eventBucketId: eventBucketId, startDate: startDate, endDate: endDate, allTime: allTime };
	    }
	  }, {
	    key: "fetchPassBucketsOverview",
	    value: function fetchPassBucketsOverview(_ref2) {
	      var eventBucketId = _ref2.eventBucketId;
	      var filterState = _ref2.filterState;
	      var startDate = _ref2.startDate;
	      var endDate = _ref2.endDate;
	      var allTime = _ref2.allTime;
	
	      return { eventBucketId: eventBucketId, filterState: filterState, startDate: startDate, endDate: endDate, allTime: allTime };
	    }
	  }, {
	    key: "fetchEventPassesAnalytics",
	    value: function fetchEventPassesAnalytics(_ref3) {
	      var eventBucketId = _ref3.eventBucketId;
	      var isMembership = _ref3.isMembership;
	      var startDate = _ref3.startDate;
	      var endDate = _ref3.endDate;
	      var allTime = _ref3.allTime;
	
	      return { eventBucketId: eventBucketId, isMembership: isMembership, startDate: startDate, endDate: endDate, allTime: allTime };
	    }
	  }, {
	    key: "fetchPassSalesAnalytics",
	    value: function fetchPassSalesAnalytics(_ref4) {
	      var eventBucketId = _ref4.eventBucketId;
	      var isMembership = _ref4.isMembership;
	      var filterState = _ref4.filterState;
	      var startDate = _ref4.startDate;
	      var endDate = _ref4.endDate;
	      var allTime = _ref4.allTime;
	
	      return { eventBucketId: eventBucketId, isMembership: isMembership, filterState: filterState, startDate: startDate, endDate: endDate, allTime: allTime };
	    }
	  }, {
	    key: "fetchRecurringPassAnalytics",
	    value: function fetchRecurringPassAnalytics(_ref5) {
	      var eventBucketId = _ref5.eventBucketId;
	      var isMembership = _ref5.isMembership;
	      var startDate = _ref5.startDate;
	      var endDate = _ref5.endDate;
	      var allTime = _ref5.allTime;
	
	      return { eventBucketId: eventBucketId, isMembership: isMembership, startDate: startDate, endDate: endDate, allTime: allTime };
	    }
	  }, {
	    key: "fetchExpiredPassAnalytics",
	    value: function fetchExpiredPassAnalytics(_ref6) {
	      var eventBucketId = _ref6.eventBucketId;
	      var isMembership = _ref6.isMembership;
	      var startDate = _ref6.startDate;
	      var endDate = _ref6.endDate;
	      var allTime = _ref6.allTime;
	
	      return { eventBucketId: eventBucketId, isMembership: isMembership, startDate: startDate, endDate: endDate, allTime: allTime };
	    }
	  }, {
	    key: "fetchNewSubscriptionAnalytics",
	    value: function fetchNewSubscriptionAnalytics(_ref7) {
	      var eventBucketId = _ref7.eventBucketId;
	      var isMembership = _ref7.isMembership;
	      var startDate = _ref7.startDate;
	      var endDate = _ref7.endDate;
	      var allTime = _ref7.allTime;
	
	      return { eventBucketId: eventBucketId, isMembership: isMembership, startDate: startDate, endDate: endDate, allTime: allTime };
	    }
	  }, {
	    key: "fetchRecurringPassOverview",
	    value: function fetchRecurringPassOverview(_ref8) {
	      var eventBucketId = _ref8.eventBucketId;
	      var isMembership = _ref8.isMembership;
	      var startDate = _ref8.startDate;
	      var endDate = _ref8.endDate;
	      var allTime = _ref8.allTime;
	
	      return { eventBucketId: eventBucketId, isMembership: isMembership, startDate: startDate, endDate: endDate, allTime: allTime };
	    }
	  }, {
	    key: "fetchAttendeeAnalytics",
	    value: function fetchAttendeeAnalytics(_ref9) {
	      var eventBucketId = _ref9.eventBucketId;
	      var filterState = _ref9.filterState;
	      var startDate = _ref9.startDate;
	      var endDate = _ref9.endDate;
	      var allTime = _ref9.allTime;
	
	      return { eventBucketId: eventBucketId, filterState: filterState, startDate: startDate, endDate: endDate, allTime: allTime };
	    }
	  }, {
	    key: "fetchEventTicketAnalytics",
	    value: function fetchEventTicketAnalytics(_ref10) {
	      var eventBucketId = _ref10.eventBucketId;
	      var filter2State = _ref10.filter2State;
	      var startDate = _ref10.startDate;
	      var endDate = _ref10.endDate;
	      var allTime = _ref10.allTime;
	
	      return { eventBucketId: eventBucketId, filter2State: filter2State, startDate: startDate, endDate: endDate, allTime: allTime };
	    }
	  }, {
	    key: "fetchAttendeeAnalyticsForVenue",
	    value: function fetchAttendeeAnalyticsForVenue(eventBucketId, venueId) {
	      return { eventBucketId: eventBucketId, venueId: venueId };
	    }
	  }, {
	    key: "fetchAttendeeAnalyticsForTag",
	    value: function fetchAttendeeAnalyticsForTag(eventBucketId, tagId) {
	      return { eventBucketId: eventBucketId, tagId: tagId };
	    }
	  }]);
	
	  return AnalyticsActions;
	}();
	
	exports.default = _alt2.default.createActions(AnalyticsActions);
	module.exports = exports["default"];

/***/ }),
/* 1864 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	module.exports = function () {
	  return new Worker(__webpack_require__.p + "2a16550bba935c0274be.worker.js");
	};

/***/ }),
/* 1865 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _materialUi = __webpack_require__(576);
	
	var _qs = __webpack_require__(1206);
	
	var _qs2 = _interopRequireDefault(_qs);
	
	var _info = __webpack_require__(1661);
	
	var _info2 = _interopRequireDefault(_info);
	
	var _UserStore = __webpack_require__(974);
	
	var _UserStore2 = _interopRequireDefault(_UserStore);
	
	var _WatchUtil = __webpack_require__(1866);
	
	var _WatchUtil2 = _interopRequireDefault(_WatchUtil);
	
	var _config = __webpack_require__(1173);
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ViewLiveVirtualButton = function (_React$Component) {
	  _inherits(ViewLiveVirtualButton, _React$Component);
	
	  function ViewLiveVirtualButton(props) {
	    _classCallCheck(this, ViewLiveVirtualButton);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(ViewLiveVirtualButton).call(this, props));
	
	    _this.state = {
	      infoHovered: false,
	      open: false,
	      anchorEl: null
	    };
	
	    _this._onClick = _this._onClick.bind(_this);
	    _this._onClose = _this._onClose.bind(_this);
	    _this.view = _this.view.bind(_this);
	    return _this;
	  }
	
	  _createClass(ViewLiveVirtualButton, [{
	    key: "_onClick",
	    value: function _onClick(e) {
	      e.preventDefault();
	
	      this.setState({
	        open: true,
	        anchorEl: e.currentTarget
	      });
	    }
	  }, {
	    key: "_onClose",
	    value: function _onClose() {
	      this.setState({ open: false });
	    }
	  }, {
	    key: "view",
	    value: function view(adminPreview) {
	      var _this2 = this;
	
	      if (!adminPreview) {
	        window.open("" + this.props.href + (this.props.href.indexOf("?") !== -1 ? "&" : "?") + "__admin_preview__=exit", "_blank");
	        return;
	      }
	
	      var w = window.open("", "_blank");
	      _WatchUtil2.default.adminPreviewOnSite(_UserStore2.default.getState().apiKey, !!this.props.godMode).then(function (data) {
	        w.location = "" + _this2.props.href + (_this2.props.href.indexOf("?") !== -1 ? "&" : "?") + "__admin_preview__=" + btoa(JSON.stringify(data));
	        w.focus();
	      }).catch(function (e) {
	        return window.alert("Failed to preview: " + e.message);
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this3 = this;
	
	      var _props = this.props;
	      var style = _props.style;
	      var label = _props.label;
	      var href = _props.href;
	      var godMode = _props.godMode;
	
	      var rest = _objectWithoutProperties(_props, ["style", "label", "href", "godMode"]);
	
	      return _react2.default.createElement(
	        "div",
	        { style: Object.assign({ display: "inline-block" }, style) },
	        _react2.default.createElement(_materialUi.RaisedButton, _extends({ label: label, onTouchTap: this._onClick }, rest)),
	        _react2.default.createElement(
	          _materialUi.Popover,
	          {
	            open: this.state.open,
	            anchorEl: this.state.anchorEl,
	            onRequestClose: this._onClose,
	            anchorOrigin: { horizontal: "right", vertical: "bottom" },
	            targetOrigin: { horizontal: "right", vertical: "top" }
	          },
	          _react2.default.createElement(
	            _materialUi.Menu,
	            { desktop: true },
	            _react2.default.createElement(_materialUi.MenuItem, {
	              primaryText: "View as audience",
	              onTouchTap: function onTouchTap() {
	                return _this3.view(false);
	              }
	            }),
	            _react2.default.createElement(_materialUi.MenuItem, {
	              primaryText: _react2.default.createElement(
	                "span",
	                null,
	                "View as admin preview",
	                " ",
	                _react2.default.createElement(
	                  "a",
	                  {
	                    href: "https://help.eventive.org/en/articles/4502687-test-your-virtual-screenings-using-admin-preview-for-quality-assurance",
	                    target: "_blank",
	                    onTouchTap: function onTouchTap(e) {
	                      return e.stopPropagation();
	                    },
	                    onMouseEnter: function onMouseEnter() {
	                      return _this3.setState({ infoHovered: true });
	                    },
	                    onMouseLeave: function onMouseLeave() {
	                      return _this3.setState({ infoHovered: false });
	                    }
	                  },
	                  _react2.default.createElement(
	                    "span",
	                    {
	                      style: {
	                        display: "inline-block",
	                        backgroundColor: this.state.infoHovered ? "#4ABFFF" : "#0187d0",
	                        transition: "background-color 0.1s ease-in-out",
	                        color: "#fff",
	                        textDecoration: "none",
	                        height: 20,
	                        width: 20,
	                        minWidth: 20,
	                        marginLeft: 5,
	                        borderRadius: "100%",
	                        fontWeight: "bold",
	                        lineHeight: "20px",
	                        textAlign: "center"
	                      }
	                    },
	                    "?"
	                  )
	                )
	              ),
	              onTouchTap: function onTouchTap() {
	                return _this3.view(true);
	              }
	            })
	          )
	        )
	      );
	    }
	  }]);
	
	  return ViewLiveVirtualButton;
	}(_react2.default.Component);
	
	exports.default = ViewLiveVirtualButton;
	module.exports = exports["default"];

/***/ }),
/* 1866 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _api = __webpack_require__(1160);
	
	var _api2 = _interopRequireDefault(_api);
	
	var _queryString = __webpack_require__(513);
	
	var _queryString2 = _interopRequireDefault(_queryString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  adminPreviewOnSite: function adminPreviewOnSite(apiKey, godMode) {
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "POST",
	        endpoint: "watch/admin_preview_on_site",
	        json: godMode ? { god_mode: true } : undefined,
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response);
	      });
	    });
	  }
	};
	module.exports = exports["default"];

/***/ }),
/* 1867 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _alt = __webpack_require__(975);
	
	var _alt2 = _interopRequireDefault(_alt);
	
	var _keyBy = __webpack_require__(990);
	
	var _keyBy2 = _interopRequireDefault(_keyBy);
	
	var _values = __webpack_require__(1214);
	
	var _values2 = _interopRequireDefault(_values);
	
	var _EventBucketActions = __webpack_require__(1218);
	
	var _EventBucketActions2 = _interopRequireDefault(_EventBucketActions);
	
	var _PassBucketUtil = __webpack_require__(1868);
	
	var _PassBucketUtil2 = _interopRequireDefault(_PassBucketUtil);
	
	var _PassBucketActions = __webpack_require__(1869);
	
	var _PassBucketActions2 = _interopRequireDefault(_PassBucketActions);
	
	var _UserStore = __webpack_require__(974);
	
	var _UserStore2 = _interopRequireDefault(_UserStore);
	
	var _GlobalNotificationActions = __webpack_require__(1182);
	
	var _GlobalNotificationActions2 = _interopRequireDefault(_GlobalNotificationActions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var PassBucketStore = function () {
	  function PassBucketStore() {
	    _classCallCheck(this, PassBucketStore);
	
	    this.bindActions(_PassBucketActions2.default);
	
	    this.state = {
	      passBuckets: {},
	      newPassBucketId: null,
	      isFetching: false
	    };
	
	    this.exportPublicMethods({
	      getPassBucketById: this.getPassBucketById.bind(this),
	      getPassBucketsForEventBucket: this.getPassBucketsForEventBucket.bind(this),
	      getAllPassBuckets: this.getAllPassBuckets.bind(this),
	      getMembershipsForEventBucket: this.getMembershipsForEventBucket.bind(this),
	      getPassBucketsAndMembershipsForEventBucket: this.getPassBucketsAndMembershipsForEventBucket.bind(this)
	    });
	  }
	
	  _createClass(PassBucketStore, [{
	    key: "getPassBucketById",
	    value: function getPassBucketById(id) {
	      return this.state.passBuckets[id];
	    }
	  }, {
	    key: "getPassBucketsForEventBucket",
	    value: function getPassBucketsForEventBucket(id) {
	      return (0, _values2.default)(this.state.passBuckets).filter(function (p) {
	        return p.event_bucket === id && !p.is_membership;
	      });
	    }
	  }, {
	    key: "getMembershipsForEventBucket",
	    value: function getMembershipsForEventBucket(id) {
	      return (0, _values2.default)(this.state.passBuckets).filter(function (p) {
	        return p.event_bucket === id && p.is_membership;
	      });
	    }
	  }, {
	    key: "getPassBucketsAndMembershipsForEventBucket",
	    value: function getPassBucketsAndMembershipsForEventBucket(id) {
	      return (0, _values2.default)(this.state.passBuckets).filter(function (p) {
	        return p.event_bucket === id;
	      });
	    }
	  }, {
	    key: "getAllPassBuckets",
	    value: function getAllPassBuckets() {
	      var _this = this;
	
	      var bucketIds = Object.keys(this.state.passBuckets);
	      var allPassBuckets = bucketIds.map(function (id) {
	        return _this.state.passBuckets[id];
	      });
	      return allPassBuckets;
	    }
	  }, {
	    key: "onFetchAllForEventBucket",
	    value: function onFetchAllForEventBucket(eventBucket) {
	      var _this2 = this;
	
	      this.setState({ isFetching: true });
	      _PassBucketUtil2.default.fetchAllForEventBucket(_UserStore2.default.getState().apiKey, eventBucket).then(function (data) {
	        _PassBucketActions2.default.updatePassBuckets((0, _keyBy2.default)(data, "id"));
	        _this2.setState({ isFetching: false });
	      }).catch(_PassBucketActions2.default.fetchFailed);
	    }
	  }, {
	    key: "onFetchAll",
	    value: function onFetchAll() {
	      var _this3 = this;
	
	      this.setState({ isFetching: true });
	      _PassBucketUtil2.default.fetchAll(_UserStore2.default.getState().apiKey).then(function (data) {
	        _PassBucketActions2.default.updatePassBuckets((0, _keyBy2.default)(data, "id"));
	        _this3.setState({ isFetching: false });
	      }).catch(_PassBucketActions2.default.fetchFailed);
	    }
	  }, {
	    key: "onFetchOne",
	    value: function onFetchOne(id) {
	      _PassBucketUtil2.default.fetchOne(_UserStore2.default.getState().apiKey, id).then(function (data) {
	        _PassBucketActions2.default.updatePassBucket(id, data);
	      }).catch(_PassBucketActions2.default.fetchFailed);
	    }
	  }, {
	    key: "onEdit",
	    value: function onEdit(newData) {
	      _PassBucketUtil2.default.edit(_UserStore2.default.getState().apiKey, newData.id, newData.values).then(function (data) {
	        window.Intercom("trackEvent", "edit-pass-bucket");
	
	        _PassBucketActions2.default.updatePassBucket(newData.id, data);
	        _EventBucketActions2.default.fetchOne(data.event_bucket);
	      }).catch(_PassBucketActions2.default.editFailed);
	    }
	  }, {
	    key: "onDelete",
	    value: function onDelete(id) {
	      var _this4 = this;
	
	      _PassBucketUtil2.default.delete(_UserStore2.default.getState().apiKey, id).then(function (data) {
	        _EventBucketActions2.default.fetchOne(_this4.state.passBuckets[id].event_bucket);
	        _PassBucketActions2.default.updatePassBucket(id, undefined);
	      }).catch(_PassBucketActions2.default.editFailed);
	    }
	  }, {
	    key: "onCreate",
	    value: function onCreate(newData) {
	      var _this5 = this;
	
	      this.setState({
	        newPassBucketId: null
	      });
	
	      _PassBucketUtil2.default.create(_UserStore2.default.getState().apiKey, newData).then(function (data) {
	        _PassBucketActions2.default.updatePassBucket(data.id, data);
	        _EventBucketActions2.default.fetchOne(data.event_bucket);
	        _this5.setState({
	          newPassBucketId: data.id
	        });
	      }).catch(_PassBucketActions2.default.editFailed);
	    }
	  }, {
	    key: "onDuplicate",
	    value: function onDuplicate(id) {
	      var _this6 = this;
	
	      this.setState({
	        newPassBucketId: null
	      });
	
	      _PassBucketUtil2.default.duplicate(_UserStore2.default.getState().apiKey, id).then(function (data) {
	        _PassBucketActions2.default.updatePassBucket(data.id, data);
	        _EventBucketActions2.default.fetchOne(data.event_bucket);
	        _this6.setState({
	          newPassBucketId: data.id
	        });
	      }).catch(_PassBucketActions2.default.editFailed);
	    }
	  }, {
	    key: "onUpdatePassBuckets",
	    value: function onUpdatePassBuckets(passBuckets) {
	      var newBuckets = Object.assign({}, this.state.passBuckets, passBuckets);
	      this.setState({ passBuckets: newBuckets });
	    }
	  }, {
	    key: "onUpdatePassBucket",
	    value: function onUpdatePassBucket(data) {
	      if (!data.passBucket) {
	        delete this.state.passBuckets[data.id];
	      } else {
	        this.state.passBuckets[data.id] = data.passBucket;
	      }
	      this.state.newPassBucketId = null;
	      this.setState(this.state);
	    }
	  }, {
	    key: "onFetchFailed",
	    value: function onFetchFailed(e) {
	      console.error("Fetching pass bucket failed:", e);
	      _GlobalNotificationActions2.default.notify.defer("Fetching pass bucket failed: " + e.message);
	      throw e;
	    }
	  }, {
	    key: "onEditFailed",
	    value: function onEditFailed(e) {
	      alert("Edit failed: " + e.message);
	    }
	  }]);
	
	  return PassBucketStore;
	}();
	
	exports.default = _alt2.default.createStore(PassBucketStore, "PassBucketStore");
	module.exports = exports["default"];

/***/ }),
/* 1868 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _merge = __webpack_require__(732);
	
	var _merge2 = _interopRequireDefault(_merge);
	
	var _api = __webpack_require__(1160);
	
	var _api2 = _interopRequireDefault(_api);
	
	var _config = __webpack_require__(1173);
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  fetchAllForEventBucket: function fetchAllForEventBucket(apiKey, eventBucket) {
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "GET",
	        endpoint: "event_buckets/" + eventBucket + "/pass_buckets",
	        qs: { include_hidden: true },
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response.pass_buckets);
	      });
	    });
	  },
	  fetchAll: function fetchAll(apiKey) {
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "GET",
	        endpoint: "pass_buckets/",
	        qs: { include_hidden: true },
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response.pass_buckets);
	      });
	    });
	  },
	  fetchOne: function fetchOne(apiKey, passBucket) {
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "GET",
	        endpoint: "pass_buckets/" + passBucket,
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response);
	      });
	    });
	  },
	  edit: function edit(apiKey, passBucket, values) {
	    if (values.rules) {
	      values.rules = JSON.stringify(values.rules);
	    }
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "POST",
	        endpoint: "pass_buckets/" + passBucket,
	        json: values,
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response);
	      });
	    });
	  },
	  delete: function _delete(apiKey, passBucket) {
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "DELETE",
	        endpoint: "pass_buckets/" + passBucket,
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response);
	      });
	    });
	  },
	  create: function create(apiKey, values) {
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "POST",
	        endpoint: "pass_buckets",
	        json: values,
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response);
	      });
	    });
	  },
	  duplicate: function duplicate(apiKey, id) {
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "POST",
	        endpoint: "pass_buckets/" + id + "/duplicate",
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response);
	      });
	    });
	  }
	};
	module.exports = exports["default"];

/***/ }),
/* 1869 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _alt = __webpack_require__(975);
	
	var _alt2 = _interopRequireDefault(_alt);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var PassBucketActions = function () {
	  function PassBucketActions() {
	    _classCallCheck(this, PassBucketActions);
	
	    this.generateActions("create", "duplicate", "delete", "updatePassBuckets", "fetchAllForEventBucket", "fetchAll", "fetchOne", "fetchFailed", "editFailed");
	  }
	
	  _createClass(PassBucketActions, [{
	    key: "edit",
	    value: function edit(id, values) {
	      return { id: id, values: values };
	    }
	  }, {
	    key: "updatePassBucket",
	    value: function updatePassBucket(id, passBucket) {
	      return { id: id, passBucket: passBucket };
	    }
	  }]);
	
	  return PassBucketActions;
	}();
	
	exports.default = _alt2.default.createActions(PassBucketActions);
	module.exports = exports["default"];

/***/ }),
/* 1870 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _momentTimezone = __webpack_require__(1185);
	
	var _momentTimezone2 = _interopRequireDefault(_momentTimezone);
	
	var _connectToStores = __webpack_require__(1226);
	
	var _connectToStores2 = _interopRequireDefault(_connectToStores);
	
	var _EventBucketActions = __webpack_require__(1218);
	
	var _EventBucketActions2 = _interopRequireDefault(_EventBucketActions);
	
	var _EventBucketStore = __webpack_require__(1593);
	
	var _EventBucketStore2 = _interopRequireDefault(_EventBucketStore);
	
	var _workingIndicator = __webpack_require__(1664);
	
	var _workingIndicator2 = _interopRequireDefault(_workingIndicator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var NewEventBucket = function (_React$Component) {
	  _inherits(NewEventBucket, _React$Component);
	
	  function NewEventBucket(props) {
	    _classCallCheck(this, NewEventBucket);
	
	    return _possibleConstructorReturn(this, Object.getPrototypeOf(NewEventBucket).call(this, props));
	  }
	
	  _createClass(NewEventBucket, [{
	    key: "componentWillMount",
	    value: function componentWillMount() {
	      if (this.props.location.query.force || window.confirm("Are you sure you'd like to create a new event bucket?")) {
	        _EventBucketActions2.default.create({
	          name: "Unnamed Event Bucket",
	          timezone: _momentTimezone2.default.tz.guess()
	        });
	      } else {
	        this.context.router.goBack();
	      }
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(props) {
	      if (props.newEventBucketId) {
	        this.context.router.replace("/event_buckets/" + props.newEventBucketId + "/settings");
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement(_workingIndicator2.default, { fullPage: true });
	    }
	  }], [{
	    key: "getStores",
	    value: function getStores() {
	      return [_EventBucketStore2.default];
	    }
	  }, {
	    key: "getPropsFromStores",
	    value: function getPropsFromStores() {
	      return {
	        newEventBucketId: _EventBucketStore2.default.getState().newEventBucketId
	      };
	    }
	  }, {
	    key: "contextTypes",
	    get: function get() {
	      return {
	        router: _react2.default.PropTypes.object
	      };
	    }
	  }]);
	
	  return NewEventBucket;
	}(_react2.default.Component);
	
	exports.default = (0, _connectToStores2.default)(NewEventBucket);
	module.exports = exports["default"];

/***/ }),
/* 1871 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";Object.defineProperty(exports,"__esModule",{value:true});var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(300);var _react2=_interopRequireDefault(_react);var _get=__webpack_require__(1004);var _get2=_interopRequireDefault(_get);var _set=__webpack_require__(1188);var _set2=_interopRequireDefault(_set);var _isEqual=__webpack_require__(924);var _isEqual2=_interopRequireDefault(_isEqual);var _juration=__webpack_require__(1772);var _juration2=_interopRequireDefault(_juration);var _reactCodemirror=__webpack_require__(1751);var _reactCodemirror2=_interopRequireDefault(_reactCodemirror);__webpack_require__(1754);var _momentTimezone=__webpack_require__(1185);var _momentTimezone2=_interopRequireDefault(_momentTimezone);var _reactSelect=__webpack_require__(953);var _reactSelect2=_interopRequireDefault(_reactSelect);var _materialUi=__webpack_require__(576);var _colors=__webpack_require__(821);var _styles=__webpack_require__(917);var _reactRouter=__webpack_require__(486);var _util=__webpack_require__(1183);var _workingIndicator=__webpack_require__(1664);var _workingIndicator2=_interopRequireDefault(_workingIndicator);var _base=__webpack_require__(1755);var _base2=_interopRequireDefault(_base);var _backButton=__webpack_require__(1872);var _backButton2=_interopRequireDefault(_backButton);var _label=__webpack_require__(1682);var _label2=_interopRequireDefault(_label);var _infoNotice=__webpack_require__(1599);var _infoNotice2=_interopRequireDefault(_infoNotice);var _selectField=__webpack_require__(1683);var _selectField2=_interopRequireDefault(_selectField);var _currencyField=__webpack_require__(1747);var _currencyField2=_interopRequireDefault(_currencyField);var _percentField=__webpack_require__(1873);var _percentField2=_interopRequireDefault(_percentField);var _inlineNoticeLabel=__webpack_require__(1222);var _inlineNoticeLabel2=_interopRequireDefault(_inlineNoticeLabel);var _injectedSelect=__webpack_require__(1874);var _injectedSelect2=_interopRequireDefault(_injectedSelect);var _linkLike=__webpack_require__(973);var _linkLike2=_interopRequireDefault(_linkLike);var _durationField=__webpack_require__(2054);var _durationField2=_interopRequireDefault(_durationField);var _virtualContentEditor=__webpack_require__(2055);var _virtualContentEditor2=_interopRequireDefault(_virtualContentEditor);var _connectToStores=__webpack_require__(1226);var _connectToStores2=_interopRequireDefault(_connectToStores);var _EventBucketActions=__webpack_require__(1218);var _EventBucketActions2=_interopRequireDefault(_EventBucketActions);var _EventBucketStore=__webpack_require__(1593);var _EventBucketStore2=_interopRequireDefault(_EventBucketStore);var _UserStore=__webpack_require__(974);var _UserStore2=_interopRequireDefault(_UserStore);var _imageDropzone=__webpack_require__(2058);var _imageDropzone2=_interopRequireDefault(_imageDropzone);var _datetimeField=__webpack_require__(2061);var _datetimeField2=_interopRequireDefault(_datetimeField);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var EventBucketSettings=function(_React$Component){_inherits(EventBucketSettings,_React$Component);function EventBucketSettings(props){_classCallCheck(this,EventBucketSettings);var _this=_possibleConstructorReturn(this,Object.getPrototypeOf(EventBucketSettings).call(this,props));_this.state={bucket:{},dirty:false,values:{name:"",timezone:"",frontend_url:"",custom_domain:"",frontend_config:{},frontend_config_text:""},showCustomDomainField:false,showSubdomainStatus:false,showConfigEditor:false,showRushLinePriceEditor:false,showTaxEditor:false,showGstVatEditor:false,showFeeCapEditor:false,isSaving:false,lastUpdatedAt:null,currentMoment:(0,_momentTimezone2.default)(),showAdditionalSettingsModal:false,showFeeAndTaxSettings:false,showVirtualSettings:false};_this.onChange=_this.onChange.bind(_this);_this.onCustomDomainCheck=_this.onCustomDomainCheck.bind(_this);_this.onSubdomainChange=_this.onSubdomainChange.bind(_this);_this.save=_this.save.bind(_this);_this.duplicate=_this.duplicate.bind(_this);_this.delete=_this.delete.bind(_this);_this.updateTime=_this.updateTime.bind(_this);_this.archive=_this.archive.bind(_this);return _this;}_createClass(EventBucketSettings,[{key:"getStyles",value:function getStyles(){return{actions:{marginTop:10},progress:{marginBottom:50},subdomainField:{width:165},subdomainSuffix:{fontSize:16,fontWeight:"bold"},subdomainStatus:{color:"rgba(33, 33, 33, 0.498039)"},subdomainStatusIndicator:{display:"inline-block",width:10,height:10,borderRadius:5000,marginRight:5},label:{color:"rgba(33, 33, 33, 0.498039)",fontSize:12,marginBottom:5},timezoneContainer:{marginTop:10,width:256}};}},{key:"onChange",value:function onChange(id,e,checked){this.onChangeValue(id,typeof checked!=="undefined"?!(0,_get2.default)(this.state.values,id):e.target.value);}},{key:"onChangeValue",value:function onChangeValue(id,value){this.state.dirty=true;(0,_set2.default)(this.state.values,id,value);this.setState(this.state);}},{key:"onCustomDomainCheck",value:function onCustomDomainCheck(e){var _this2=this;this.setState({showCustomDomainField:!this.state.showCustomDomainField},function(){_this2.onChangeValue("custom_domain","");});}},{key:"onSubdomainChange",value:function onSubdomainChange(e){var value=e.target.value;// Block new subdomains from using "_" character. This character is not supported
	// for HTTPS subdomains on iOS Safari.
	if(value!==this.state.bucket.frontend_url){value=value.replace(/_/g,"");}this.onChangeValue("frontend_url",value);this.setState({showSubdomainStatus:true});if(value){_EventBucketActions2.default.testSubdomain(this.props.params.eventBucketId,value);}}},{key:"save",value:function save(){var values=Object.assign({},this.state.values);try{var parsedConfig=JSON.parse(values.frontend_config_text);delete values.frontend_config_text;if(!(0,_isEqual2.default)(parsedConfig,this.state.bucket.frontend_config)){// If text was manually edited, use that
	values.frontend_config=JSON.stringify(parsedConfig);}else if(!(0,_isEqual2.default)(values.frontend_config,this.state.bucket.frontend_config)){// If frontend config object has been edited, use that
	values.frontend_config=JSON.stringify(values.frontend_config);}else{// Fall through - no frontend config update
	delete values.frontend_config;}}catch(e){// Alert malformed JSON
	alert("Error in advanced configuration: "+e.message);return;}this.setState({isSaving:true,lastUpdatedAt:this.state.bucket.updated_at});_EventBucketActions2.default.edit.defer(this.props.params.eventBucketId,values);window.scrollTo(0,0);}},{key:"duplicate",value:function duplicate(){this.context.router.push("/event_buckets/"+this.props.params.eventBucketId+"/settings/duplicate");}},{key:"delete",value:function _delete(){if(window.confirm("ARE YOU SURE? This will destroy everything related to the bucket, including events, passes, and tickets.\n\nIf it is possible, Event Bucket Recovery after deletion will incur a $250 fee.")){_EventBucketActions2.default.delete(this.props.params.eventBucketId);this.context.router.push("/welcome");}}},{key:"archive",value:function archive(){if(window.confirm("Are you sure?")){this.onChangeValue("mode","archived");this.save();}}},{key:"updateTime",value:function updateTime(){this.setState({currentMoment:(0,_momentTimezone2.default)()});}},{key:"componentDidMount",value:function componentDidMount(){var _this3=this;_EventBucketActions2.default.fetchOne(this.props.params.eventBucketId);this.componentWillReceiveProps(this.props);this.timezoneInterval=setInterval(this.updateTime,1000);this.updateTime();this.context.router.setRouteLeaveHook(this.props.route,function(){if(_this3.state.dirty){return"Are you sure you wish to leave the event bucket editor? Your changes will not be saved.";}});}},{key:"componentWillUnmount",value:function componentWillUnmount(){clearInterval(this.timezoneInterval);}},{key:"componentWillReceiveProps",value:function componentWillReceiveProps(newProps){var bucket=newProps.getEventBucketById(newProps.params.eventBucketId);if(Object.keys(this.state.values).length===0||this.state.bucket.id!==newProps.params.eventBucketId||bucket&&bucket.updated_at!==this.state.lastUpdatedAt){this.setState({bucket:bucket,dirty:false,isSaving:false,showSubdomainStatus:false,lastUpdatedAt:bucket&&bucket.updated_at,showCustomDomainField:bucket&&!!bucket.custom_domain,showCutoffEditor:bucket&&!!bucket.ticket_sales_cutoff,values:bucket?{name:bucket.name,timezone:bucket.timezone,class:bucket.class,mode:bucket.mode,schedule_enabled:bucket.schedule_enabled,schedule_include_virtual:bucket.schedule_include_virtual,film_guide_enabled:bucket.film_guide_enabled,donations_enabled:bucket.donations_enabled,standalone_ticket_sales_enabled:bucket.standalone_ticket_sales_enabled,standalone_ticket_sales_locked:bucket.standalone_ticket_sales_locked,standalone_ticket_sales_locked_password:bucket.standalone_ticket_sales_locked_password,passholder_ticket_required_default:bucket.passholder_ticket_required_default,passholder_one_click:bucket.passholder_one_click,passholder_order_email_confirmation:bucket.passholder_order_email_confirmation,passholder_web_orders_allowed:bucket.passholder_web_orders_allowed,passholder_instant_ticket_oversell_allowed:bucket.passholder_instant_ticket_oversell_allowed,passholder_transfer_allowed:bucket.passholder_transfer_allowed,absorb_fee_percent:bucket.absorb_fee_percent,absorb_donation_fees:bucket.absorb_donation_fees,absorb_ticket_fees:bucket.absorb_ticket_fees,absorb_pass_fees:bucket.absorb_pass_fees,ticket_sales_cutoff:bucket.ticket_sales_cutoff,ticket_transfer_for_all_users_disabled:bucket.ticket_transfer_for_all_users_disabled,fee_cap:bucket.fee_cap,virtual_fee_amount:bucket.virtual_fee_amount,fee_at_box_office:bucket.fee_at_box_office,tax_percent:bucket.tax_percent,tax_for:bucket.tax_for,tax_at_box_office:bucket.tax_at_box_office,gst_vat_percent:bucket.gst_vat_percent,rush_line_enabled:bucket.rush_line_enabled,rush_line_default_price:bucket.rush_line_default_price,box_office_auto_open:bucket.box_office_auto_open,box_office_auto_populate:bucket.box_office_auto_populate,box_office_ticket_printer:bucket.box_office_ticket_printer,box_office_shift_tracking:bucket.box_office_shift_tracking,box_office_show_mark_scanned:bucket.box_office_show_mark_scanned,box_office_use_boca:bucket.box_office_use_boca,box_office_service_fee:bucket.box_office_service_fee,credits_enabled:bucket.credits_enabled,credits_face_price:bucket.credits_face_price,credits_levels:bucket.credits_levels?bucket.credits_levels.length?bucket.credits_levels:[{}]:[],credits_discount:bucket.credits_discount,credits_allowed_pass_buckets:bucket.credits_allowed_pass_buckets,virtual_festival_config:bucket.virtual_festival_config||{},virtual_content_preroll:bucket.virtual_content_preroll,virtual_content_postroll:bucket.virtual_content_postroll,enable_order_all_starred:bucket.enable_order_all_starred,enable_guest_checkout:bucket.enable_guest_checkout,enable_cart:bucket.enable_cart,enable_balloting:bucket.enable_balloting,enable_custom_event_ids:bucket.enable_custom_event_ids,enable_eventival_login:bucket.enable_eventival_login,enable_nfc:bucket.enable_nfc,enable_virtual_festival:bucket.enable_virtual_festival,defer_all_unlock_fees:bucket.defer_all_unlock_fees,enable_title_delivery:bucket.enable_title_delivery,title_delivery_config:bucket.title_delivery_config||{},frontend_url:(0,_get2.default)(bucket,"frontend_url",""),custom_domain:(0,_get2.default)(bucket,"custom_domain",""),frontend_config:JSON.parse(JSON.stringify((0,_get2.default)(bucket,"frontend_config",{}))),frontend_config_text:JSON.stringify((0,_get2.default)(bucket,"frontend_config",{}),null,2)}:{}});}}},{key:"render",value:function render(){var _this4=this;var styles=this.getStyles();var isVirtualExpired=(_UserStore2.default.getUser()||{}).virtual_festival_plan_status==="expired"&&!_UserStore2.default.isGod()&&this.state.values.enable_virtual_festival;var showBoxOfficeFeeSettings=(this.state.bucket||{}).pricing_plan==="sundance"||(this.state.bucket||{}).pricing_plan==="cphdox";var saveButton=_react2.default.createElement(_materialUi.RaisedButton,{label:isVirtualExpired?"Cannot save since Eventive Virtual expired":this.state.dirty?"Save changes":"No changes to save",primary:true,disabled:!this.state.dirty||isVirtualExpired,onTouchTap:this.save});if(this.state.isSaving||!this.state.bucket){return _react2.default.createElement(_workingIndicator2.default,{fullPage:true});}var subdomainResults=this.props.getSubdomainTestResultsByEventBucketId(this.props.params.eventBucketId),subdomainStatus=(0,_get2.default)(subdomainResults,this.state.values.frontend_url,false);return _react2.default.createElement("div",null,this.props.children/* for configurator modal */,_react2.default.createElement("div",null,_react2.default.createElement(_backButton2.default,{label:"Event bucket",location:"/event_buckets/"+this.props.params.eventBucketId}),_react2.default.createElement("span",{style:{marginLeft:7}},saveButton)),_react2.default.createElement("h1",{className:"page-title"},(0,_get2.default)(this.state,"values.name","")," Settings"),_UserStore2.default.hasPermission("edit_event_bucket")?_react2.default.createElement("div",null,_react2.default.createElement(_infoNotice2.default,{style:{marginTop:20}},"Check out our"," ",_react2.default.createElement("a",{href:"http://help.eventive.org/events-and-tickets/create-event-buckets",target:"_blank"},"guide to creating event buckets"),"."),_react2.default.createElement("div",null,_react2.default.createElement(_materialUi.TextField,{value:(0,_get2.default)(this.state,"values.name",""),floatingLabelText:"Name",floatingLabelFixed:true,onChange:function onChange(e){return _this4.onChangeValue("name",e.target.value);}})),_react2.default.createElement("div",null,_react2.default.createElement(_materialUi.TextField,{style:styles.subdomainField,value:(0,_get2.default)(this.state,"values.frontend_url",""),floatingLabelText:"Subdomain",floatingLabelFixed:true,onChange:this.onSubdomainChange}),_react2.default.createElement("span",{style:styles.subdomainSuffix},".eventive.org"),this.state.showSubdomainStatus?_react2.default.createElement("div",{style:styles.subdomainStatus},_react2.default.createElement("span",{style:Object.assign({},styles.subdomainStatusIndicator,{backgroundColor:subdomainStatus===true?_colors.green500:subdomainStatus===false?_colors.yellow500:_colors.red500})}),subdomainStatus===true?"Looks good!":subdomainStatus===false?"Checking...":subdomainStatus):null),_react2.default.createElement("div",{style:styles.timezoneContainer},_react2.default.createElement("div",{style:styles.label},"Timezone"),_react2.default.createElement(_reactSelect2.default,{placeholder:"None selected",value:(0,_get2.default)(this.state,"values.timezone",""),autosize:true,options:_momentTimezone2.default.tz.names().map(function(n){return{label:n+" ("+_this4.state.currentMoment.tz(n).format("LT")+")",value:n};}),onChange:function onChange(option){_this4.onChangeValue("timezone",option?option.value:"");}})),_react2.default.createElement("div",{style:{marginTop:20}},_react2.default.createElement("h3",null,"Site features"),_react2.default.createElement("div",{style:{marginBottom:10}},this.state.isEditingMode?_react2.default.createElement("div",{style:{}},_react2.default.createElement("div",{style:{marginBottom:5}},"Event bucket mode:",_react2.default.createElement(_linkLike2.default,{style:{marginLeft:10},onTouchTap:function onTouchTap(){return _this4.setState({isEditingMode:false});}},"Never mind")),_react2.default.createElement(_materialUi.RadioButtonGroup,{name:"mode",style:{marginLeft:"0em"},valueSelected:this.state.values.mode,onChange:function onChange(e,v){_this4.setState({isEditingMode:false},function(){_this4.onChangeValue("mode",v);});}},_react2.default.createElement(_materialUi.RadioButton,{value:"default",label:_react2.default.createElement("span",null,_react2.default.createElement("strong",null,"Default"),": All features enabled. Sell both passes & standalone tickets.")}),_react2.default.createElement(_materialUi.RadioButton,{value:"pass_only",label:_react2.default.createElement("span",null,_react2.default.createElement("strong",null,"Pass only"),": Sell passes but no standalone tickets. Ticket reservations for passholders.")}),_react2.default.createElement(_materialUi.RadioButton,{value:"standalone_ticket_only",label:_react2.default.createElement("span",null,_react2.default.createElement("strong",null,"Standalone tickets only"),": Sell only standalone tickets. No passes.")}),_react2.default.createElement(_materialUi.RadioButton,{value:"box_office_only",label:_react2.default.createElement("span",null,_react2.default.createElement("strong",null,"Box office only"),": No online sales. Only box office / rush line.")}),_react2.default.createElement(_materialUi.RadioButton,{value:"sales_disabled",label:_react2.default.createElement("span",null,_react2.default.createElement("strong",null,"All sales disabled"),": No online or box office sales.")}),_react2.default.createElement(_materialUi.RadioButton,{value:"archived",label:_react2.default.createElement("span",null,_react2.default.createElement("strong",null,"Archived"),": Sales disabled. Moved to the \"Archive\" section.")}))):_react2.default.createElement("div",null,"Event bucket mode:"," ",_react2.default.createElement("strong",null,(0,_util.capitalize)((this.state.values.mode||"").replace(/_/g," ").replace("ticket","tickets")// "Standalone ticket only" => "Standalone tickets only"
	))," ","\xB7"," ",_react2.default.createElement(_linkLike2.default,{onTouchTap:function onTouchTap(){return _this4.setState({isEditingMode:true});}},"Change mode"))),_react2.default.createElement("div",null,_react2.default.createElement(_materialUi.Checkbox,{label:isVirtualExpired?"Eventive Virtual expired –⁠ contact us":"Eventive Virtual activated",checked:this.state.values.enable_virtual_festival||false,disabled:true})),_react2.default.createElement("div",null,_react2.default.createElement(_materialUi.Checkbox,{label:"Native schedule publicly visible",checked:this.state.values.schedule_enabled||false,onCheck:this.onChange.bind(this,"schedule_enabled")})),_react2.default.createElement("div",null,_react2.default.createElement(_materialUi.Checkbox,{label:"Native film guide publicly visible",checked:this.state.values.film_guide_enabled||false,onCheck:this.onChange.bind(this,"film_guide_enabled")})),this.state.values.mode!=="pass_only"?_react2.default.createElement("div",null,_react2.default.createElement(_materialUi.Checkbox,{label:"Standalone tickets on sale to public",checked:this.state.values.standalone_ticket_sales_enabled||false,onCheck:this.onChange.bind(this,"standalone_ticket_sales_enabled")})):null,_react2.default.createElement("div",null,_react2.default.createElement(_materialUi.Checkbox,{label:"Accept donations on site",checked:this.state.values.donations_enabled||false,onCheck:this.onChange.bind(this,"donations_enabled")}),this.state.values.donations_enabled?_react2.default.createElement("div",{style:{marginLeft:40}},this.state.values.donations_enabled!==this.state.bucket.donations_enabled?_react2.default.createElement("i",null,"Save your changes to view a link to the donations page."):_react2.default.createElement("div",null,_react2.default.createElement("a",{target:"_blank",href:this.state.bucket&&this.state.bucket.urls.donate},"Direct donation link"),"\xA0\xB7\xA0",_react2.default.createElement(_reactRouter.Link,{to:"/event_buckets/"+this.state.bucket.id+"/settings/configurator/donations"},"Configure in Configurator"))):null),_react2.default.createElement("div",null,_react2.default.createElement(_materialUi.Checkbox,{label:"Accept gift card purchases on site",checked:(0,_get2.default)(this.state.values,"frontend_config.gift_cards_frontend_enabled",false),onCheck:this.onChange.bind(this,"frontend_config.gift_cards_frontend_enabled")}),this.state.values.frontend_config.gift_cards_enabled&&this.state.values.frontend_config.gift_cards_frontend_enabled?_react2.default.createElement("div",{style:{marginLeft:40}},this.state.values.frontend_config.gift_cards_frontend_enabled!==this.state.bucket.frontend_config.gift_cards_frontend_enabled?_react2.default.createElement("i",null,"Save changes to edit gift card information in configurator"):_react2.default.createElement(_reactRouter.Link,{to:"/event_buckets/"+this.state.bucket.id+"/settings/configurator/gift_cards"},"Configure in Configurator")):null),_UserStore2.default.isGod()?_react2.default.createElement("div",null,_react2.default.createElement(_materialUi.Checkbox,{label:"Add a membership section on site",checked:(0,_get2.default)(this.state.values,"frontend_config.memberships_enabled",false),onCheck:this.onChange.bind(this,"frontend_config.memberships_enabled")}),this.state.values.frontend_config.memberships_enabled?_react2.default.createElement("div",{style:{marginLeft:40}},this.state.values.frontend_config.memberships_enabled!==this.state.bucket.frontend_config.memberships_enabled?_react2.default.createElement("i",null,"Save changes to edit membership information in configurator"):_react2.default.createElement(_reactRouter.Link,{to:"/event_buckets/"+this.state.bucket.id+"/settings/configurator/memberships"},"Configure in Configurator")):null):null)):null,this.state.values.enable_virtual_festival?_react2.default.createElement("div",{style:{marginTop:20}},_react2.default.createElement("h3",null,"Eventive Virtual settings"),_react2.default.createElement("div",null,"Customize your Eventive Virtual channel and its discoverability on the Eventive platform."),_react2.default.createElement("div",{style:{marginTop:10}},_react2.default.createElement(_materialUi.RaisedButton,{label:"Open Eventive Virtual settings",onTouchTap:function onTouchTap(){return _this4.setState({showVirtualSettings:true});}}))):null,_UserStore2.default.hasPermission(["edit_event_bucket","manage_configurator"])?_react2.default.createElement("div",{style:{marginTop:20}},_react2.default.createElement("h3",null,"Configurator"),_react2.default.createElement("div",null,"Customize every aspect of your customers' experiences."),_react2.default.createElement("div",{style:{marginTop:10}},_react2.default.createElement(_materialUi.RaisedButton,{style:{marginRight:7},label:"Launch configurator",primary:true,onTouchTap:function onTouchTap(){return _this4.context.router.push("/event_buckets/"+_this4.state.bucket.id+"/settings/configurator");}}),this.state.showConfigEditor?_react2.default.createElement(_materialUi.RaisedButton,{style:{marginBottom:10},label:"Hide advanced editor",onTouchTap:function onTouchTap(){return _this4.setState({showConfigEditor:false});}}):_react2.default.createElement(_materialUi.RaisedButton,{label:"Show advanced editor",onTouchTap:function onTouchTap(){return _this4.setState({showConfigEditor:true});}})),this.state.showConfigEditor?_react2.default.createElement("div",null,_react2.default.createElement(_reactCodemirror2.default,{style:{border:"1px solid #ccc;"},value:(0,_get2.default)(this.state,"values.frontend_config_text",""),onChange:this.onChangeValue.bind(this,"frontend_config_text"),options:{lineWrapping:true,lineNumbers:true,tabSize:2,indentUnit:2,mode:{name:"javascript",json:true}}})):null):null,_react2.default.createElement("div",{style:{marginTop:20}},_react2.default.createElement("h3",null,"Fee & tax settings"),_react2.default.createElement("div",null,"Configure how fees and taxes are charged or passed on to your customers."),_react2.default.createElement("div",{style:{marginTop:10}},_react2.default.createElement(_materialUi.RaisedButton,{label:"Open fee & tax settings",onTouchTap:function onTouchTap(){return _this4.setState({showFeeAndTaxSettings:true});}}))),_UserStore2.default.hasPermission(["edit_event_bucket","manage_embed_wizard"])?_react2.default.createElement("div",{style:{marginTop:20}},_react2.default.createElement("h3",null,"Embed in your website"),_react2.default.createElement("div",null,"Embed fully functional components of your Eventive native site within your own website."),_react2.default.createElement("div",{style:{marginTop:10}},_react2.default.createElement(_materialUi.RaisedButton,{label:"Open embed wizard",onTouchTap:function onTouchTap(){return _this4.context.router.push("/event_buckets/"+_this4.state.bucket.id+"/settings/embed");}}),_react2.default.createElement(_materialUi.RaisedButton,{style:{marginLeft:7},label:_react2.default.createElement("span",null,"Open Eventive Everywhere"," ",_react2.default.createElement(_inlineNoticeLabel2.default,{style:{marginLeft:5},label:"Advanced"})),onTouchTap:function onTouchTap(){return _this4.context.router.push("/event_buckets/"+_this4.state.bucket.id+"/settings/everywhere");}}))):null,_UserStore2.default.hasPermission("edit_event_bucket")?_react2.default.createElement("div",null,_react2.default.createElement("div",{style:{marginTop:20,marginBottom:30}},_react2.default.createElement("h3",null,"Additional settings"),_react2.default.createElement("div",null,"More options to make your event bucket yours."),_react2.default.createElement("div",{style:{marginTop:10}},_react2.default.createElement(_materialUi.RaisedButton,{label:"Open additional settings",onTouchTap:function onTouchTap(){return _this4.setState({showAdditionalSettingsModal:true});}}))),_react2.default.createElement("div",{style:styles.actions},saveButton,_react2.default.createElement(_materialUi.RaisedButton,{label:"Duplicate",onTouchTap:this.duplicate,disabled:this.state.dirty,style:{marginLeft:7}}),this.state.values.mode!=="archived"&&_react2.default.createElement(_materialUi.RaisedButton,{label:"Archive Event Bucket",style:{marginLeft:7},onTouchTap:this.archive}),_UserStore2.default.isGod()&&_react2.default.createElement(_materialUi.RaisedButton,{label:"Delete event bucket",style:{marginLeft:7},onTouchTap:this.delete}))):null,_react2.default.createElement(_base2.default,{open:this.state.showFeeAndTaxSettings,onRequestClose:function onRequestClose(){return _this4.setState({showFeeAndTaxSettings:false});},hideTitleAndFooterBorders:true,showCloseButton:true},_react2.default.createElement("div",null,_react2.default.createElement("h2",null,"Fee and tax settings"),_UserStore2.default.hasPermission("manage_financial")?_react2.default.createElement("div",{style:{marginTop:20}},_react2.default.createElement("h3",null,"Physical event & pass sales customer-facing fees"),_react2.default.createElement("div",null,_react2.default.createElement(_materialUi.RadioButtonGroup,{name:"fee_absorption",valueSelected:this.state.values.absorb_fee_percent===100?"absorb":this.state.values.absorb_fee_percent===0?"customer":"split",onChange:function onChange(e,v){return _this4.onChangeValue("absorb_fee_percent",v==="absorb"?100:v==="split"?50:0);}},_react2.default.createElement(_materialUi.RadioButton,{value:"customer",label:"Pass fees on to customer"}),_react2.default.createElement(_materialUi.RadioButton,{value:"absorb",label:"Absorb fees"}),_react2.default.createElement(_materialUi.RadioButton,{value:"split",label:"Split fees"})),[100,0].indexOf(this.state.values.absorb_fee_percent)===-1?_react2.default.createElement("div",null,_react2.default.createElement("div",null,_react2.default.createElement(_label2.default,null,"Percent of fee to absorb"),_react2.default.createElement("div",null,"0%"," ",_react2.default.createElement(_materialUi.Slider,{min:0,max:100,step:1,style:{margin:"-24px 10px -52px",width:256,display:"inline-block"},value:(0,_get2.default)(this.state,"values.absorb_fee_percent",0),onChange:function onChange(e,value){return _this4.onChangeValue("absorb_fee_percent",value);}})," ","100%")),_react2.default.createElement("div",{style:{marginTop:10}},"With your current settings, customers will pay"," ",_react2.default.createElement("b",null,100-(0,_get2.default)(this.state,"values.absorb_fee_percent",0),"%")," ","of the fee.")):null),this.state.values.absorb_fee_percent!==100?_react2.default.createElement("div",null,_react2.default.createElement(_materialUi.Checkbox,{style:{marginTop:15},label:"Cap max fee per transaction",checked:this.state.values.fee_cap||this.state.showFeeCapEditor,onCheck:function onCheck(e,checked){_this4.setState({showFeeCapEditor:checked},function(){!checked&&_this4.onChangeValue("fee_cap",0);});}}),this.state.showFeeCapEditor||this.state.values.fee_cap?_react2.default.createElement(_currencyField2.default,{floatingLabelText:"Max fee per transaction",floatingLabelFixed:true,placeholder:"$0.00",value:this.state.values.fee_cap,onChange:function onChange(e){return _this4.setState({showFeeCapEditor:true},function(){return _this4.onChangeValue("fee_cap",e.target.value);});},style:{marginBottom:15}}):null):null,this.state.values.donations_enabled&&this.state.values.absorb_fee_percent!==100?_react2.default.createElement(_materialUi.Checkbox,{label:"Absorb donation fees",checked:this.state.values.absorb_donation_fees,onCheck:this.onChange.bind(this,"absorb_donation_fees")}):null,this.state.values.absorb_fee_percent!==100?_react2.default.createElement(_materialUi.Checkbox,{label:"Absorb fees on ticket sales",checked:this.state.values.absorb_ticket_fees,onCheck:this.onChange.bind(this,"absorb_ticket_fees")}):null,this.state.values.absorb_fee_percent!==100?_react2.default.createElement(_materialUi.Checkbox,{label:"Absorb fees on pass sales",checked:this.state.values.absorb_pass_fees,onCheck:this.onChange.bind(this,"absorb_pass_fees")}):null):null,_UserStore2.default.hasPermission("manage_financial")&&this.state.values.enable_virtual_festival?_react2.default.createElement("div",{style:{marginTop:20}},_react2.default.createElement("h3",null,"Virtual screening customer-facing fees"),_react2.default.createElement(_materialUi.RadioButtonGroup,{name:"virtual_fees",valueSelected:this.state.values.virtual_fee_amount===-1?"passon":this.state.values.virtual_fee_amount||this.state.showVirtualFeeEditor?"fee":"nofee",onChange:function onChange(e,v){return _this4.setState({showVirtualFeeEditor:v==="fee"},function(){_this4.onChangeValue("virtual_fee_amount",v==="nofee"?0:v==="passon"?-1:125);});}},[_react2.default.createElement(_materialUi.RadioButton,{value:"nofee",label:"No additional fees (recommended)"}),_react2.default.createElement(_materialUi.RadioButton,{value:"fee",label:"Add a fee for virtual unlocks"}),_UserStore2.default.isGod()&&_react2.default.createElement(_materialUi.RadioButton,{value:"passon",label:"[GOD ONLY/REQUIRES CUSTOM AGREEMENT] Pass on exact ticketing transaction fee"})].filter(function(x){return!!x;})),this.state.values.virtual_fee_amount!==-1&&(this.state.showVirtualFeeEditor||this.state.values.virtual_fee_amount)?_react2.default.createElement(_currencyField2.default,{floatingLabelText:"Virtual ticket unlock customer fee",floatingLabelFixed:true,placeholder:"$0.00",value:this.state.values.virtual_fee_amount,onChange:function onChange(e){return _this4.setState({showVirtualFeeEditor:true},function(){return _this4.onChangeValue("virtual_fee_amount",e.target.value);});}}):null):null,showBoxOfficeFeeSettings?_react2.default.createElement("div",{style:{marginTop:20}},_react2.default.createElement("h3",null,"Fees at the box office"),_react2.default.createElement(_materialUi.Checkbox,{style:{},label:"Pass on fees to customer at the box office",checked:this.state.values.fee_at_box_office,onCheck:function onCheck(){return _this4.onChangeValue("fee_at_box_office",!_this4.state.values.fee_at_box_office);}})):null,_UserStore2.default.hasPermission("manage_financial")?_react2.default.createElement("div",{style:{marginTop:20}},_react2.default.createElement("h3",null,"Sales tax"),_react2.default.createElement(_materialUi.Checkbox,{label:"Add sales tax",checked:this.state.values.tax_percent||this.state.showTaxEditor,onCheck:function onCheck(e,checked){_this4.setState({showTaxEditor:checked},function(){!checked&&_this4.onChangeValue("tax_percent",0);});}}),this.state.showTaxEditor||this.state.values.tax_percent?_react2.default.createElement("div",{style:{marginBottom:15}},_react2.default.createElement(_percentField2.default,{floatingLabelText:"Sales tax percent",floatingLabelFixed:true,placeholder:"0.00%",value:this.state.values.tax_percent,onChange:function onChange(e){return _this4.setState({showTaxEditor:true},function(){return _this4.onChangeValue("tax_percent",e.target.value);});}}),function(){var types=["pass","ticket","item"],isAll=types.every(function(t){return _this4.state.values.tax_for.indexOf(t)!==-1;});return _react2.default.createElement("div",null,_react2.default.createElement(_label2.default,null,"Charge tax on"),_react2.default.createElement(_materialUi.RadioButtonGroup,{name:"tax_for",valueSelected:isAll?"all":"some",onChange:function onChange(e,v){return _this4.onChangeValue("tax_for",v==="some"?[]:types);}},_react2.default.createElement(_materialUi.RadioButton,{value:"all",label:"All order types"}),_react2.default.createElement(_materialUi.RadioButton,{value:"some",label:"Some order types"})),!isAll?_react2.default.createElement("div",{style:{marginTop:"0.5em"}},types.map(function(t){return _react2.default.createElement(_materialUi.Checkbox,{style:{marginLeft:"3em"},label:(0,_util.capitalize)(t)+" orders",checked:_this4.state.values.tax_for.indexOf(t)!==-1,onCheck:function onCheck(){var index=_this4.state.values.tax_for.indexOf(t);if(index===-1){_this4.state.values.tax_for.push(t);}else{_this4.state.values.tax_for.splice(index,1);}_this4.onChangeValue("tax_for",_this4.state.values.tax_for);}});})):null,_react2.default.createElement(_materialUi.Checkbox,{style:{marginTop:15},label:"Charge sales tax at Box Office in addition to online",checked:_this4.state.values.tax_at_box_office,onCheck:function onCheck(){return _this4.onChangeValue("tax_at_box_office",!_this4.state.values.tax_at_box_office);}}));}()):null,_react2.default.createElement(_materialUi.Checkbox,{style:{},label:"Report GST/VAT (in generated reports)",checked:this.state.values.gst_vat_percent||this.state.showGstVatEditor,onCheck:function onCheck(e,checked){_this4.setState({showGstVatEditor:checked},function(){!checked&&_this4.onChangeValue("gst_vat_percent",0);});}}),this.state.showGstVatEditor||this.state.values.gst_vat_percent?_react2.default.createElement(_percentField2.default,{floatingLabelText:"GST/VAT percent",floatingLabelFixed:true,placeholder:"0.00%",value:this.state.values.gst_vat_percent,onChange:function onChange(e){return _this4.setState({showGstVatEditor:true},function(){return _this4.onChangeValue("gst_vat_percent",e.target.value);});}}):null):null,_react2.default.createElement("div",{style:{marginTop:20}},saveButton,_react2.default.createElement(_materialUi.RaisedButton,{label:"Close",style:{marginLeft:7},onTouchTap:function onTouchTap(){return _this4.setState({showFeeAndTaxSettings:false});}})))),_react2.default.createElement(_base2.default,{open:this.state.showVirtualSettings,onRequestClose:function onRequestClose(){return _this4.setState({showVirtualSettings:false});},hideTitleAndFooterBorders:true,showCloseButton:true},_react2.default.createElement("div",null,_react2.default.createElement("h2",null,"Eventive Virtual settings"),_react2.default.createElement("div",null,_react2.default.createElement("div",{style:{marginTop:20,border:"1px solid "+_styles.colors.blue100,backgroundColor:_styles.colors.blue50,padding:"1em 1.5em",borderRadius:"1em"}},_react2.default.createElement("h3",null,"Channel discovery"),_react2.default.createElement("div",null,"Promote this event bucket channel in the Eventive Discovery Portal and reach over two million film fans."),_react2.default.createElement(_materialUi.Checkbox,{style:{marginTop:"0.5em"},label:"Yes, promote in public Eventive Discovery Portal",checked:(0,_get2.default)(this.state,"values.frontend_config.virtual_festival_show_in_directory",false),onCheck:function onCheck(e,checked){_this4.onChangeValue("frontend_config.virtual_festival_show_in_directory",checked);}}),(0,_get2.default)(this.state,"values.frontend_config.virtual_festival_show_in_directory",false)?_react2.default.createElement("div",null,_react2.default.createElement("div",null,_react2.default.createElement(_materialUi.TextField,{floatingLabelText:"Channel title ("+(0,_get2.default)(this.state,"values.frontend_config.virtual_festival_display_name","").length+"/40)",floatingLabelFixed:true,style:{width:"100%"},placeholder:"Shown in Discovery Portal. Up to 40 characters.",value:(0,_get2.default)(this.state,"values.frontend_config.virtual_festival_display_name","").slice(0,40),onChange:function onChange(e){_this4.onChangeValue("frontend_config.virtual_festival_display_name",e.target.value.slice(0,40).replace(/(\n|\s+)/g," "));}})),_react2.default.createElement("div",{style:{display:"flex",justifyContent:"space-between"}},_react2.default.createElement("div",{style:{flex:1,marginRight:"2em"}},_react2.default.createElement(_selectField2.default,{label:"Channel type",placeholder:"Choose channel type",value:(0,_get2.default)(this.state,"values.frontend_config.virtual_festival_discovery_type",""),options:[{label:"Film festival / screening series",value:"film_festival"},{label:"Single film release",value:"single_film"},{label:"Arthouse / virtual cinema",value:"cinema"},{label:"Special event",value:"special_event"},{label:"Repertory catalog",value:"repertory_catalog"}],onChange:function onChange(option){_this4.onChangeValue("frontend_config.virtual_festival_discovery_type",option?option.value:"");}}),_react2.default.createElement(_selectField2.default,{label:"Channel tags (up to 5)",placeholder:"Add tags to help viewers find your channel",multi:true,value:(0,_get2.default)(this.state,"values.frontend_config.virtual_festival_discovery_tags",""),options:// prettier-ignore
	["Accessible","Action","Adventure","American Indian","Animation","Anime","Arab ","Arthouse","Black","Canadian","Children","Christian","Classic","Comedy","Community","Documentary","Drama","Environmental","Epic","Experimental","Faith and Spirituality","Family","Fantasy","Film Market","Fitness","Food and Wine","French","Gender Issues","General Interest","Horror","Indian","International ","Irish","Italian","Jewish","Latino","LGBTQ","Local Filmmakers","Mind and Body","Mountain","Music","Musicals","Mystery","New Filmmakers","News","Outdoors","Performing Arts","Period Piece","Podcast","Reality TV","Science","Science Fiction","Shorts","Social Justice","Sports","Talk Shows","Television","Thrillers","Video Games","Web / New Media","Westerns","Women","Young Filmmakers"].map(function(x){return{label:x,value:x};}),onChange:function onChange(v){_this4.onChangeValue("frontend_config.virtual_festival_discovery_tags",v?v.map(function(x){return x.value;}).slice(0,5):[]);}})),_react2.default.createElement("div",{style:{flex:1}},_react2.default.createElement(_label2.default,null,"Channel feature graphic"),_react2.default.createElement("div",{style:{}},(0,_get2.default)(this.state,"values.frontend_config.virtual_festival_image","")?_react2.default.createElement("div",null,_react2.default.createElement("img",{src:(0,_get2.default)(this.state,"values.frontend_config.virtual_festival_image",""),style:{display:"block",height:75,border:"1px solid #ccc",marginBottom:2}}),_react2.default.createElement(_linkLike2.default,{onTouchTap:function onTouchTap(){return _this4.onChangeValue("frontend_config.virtual_festival_image","");}},"Replace with new graphic")):_react2.default.createElement(_imageDropzone2.default,{crop:{width:1920,height:1080},style:{fontSize:"0.75em",lineHeight:"1.25",padding:"30px 10px",border:"1px dashed #ccc",cursor:"pointer",backgroundColor:"rgba(255,255,255,1)",textAlign:"center"},onDrop:function onDrop(files){_EventBucketActions2.default.uploadFile(_this4.props.params.eventBucketId,"virtual_festival_image",files[0],function(_ref){var url=_ref.url;_this4.onChangeValue("frontend_config.virtual_festival_image",url);});}},_react2.default.createElement("div",{style:{fontSize:12,marginBottom:5}},"Drop an image here, or click to select.",_react2.default.createElement("br",null),_react2.default.createElement("strong",null,"Required in order to be displayed in Portal.")))))),_react2.default.createElement("div",null,_react2.default.createElement(_materialUi.TextField,{floatingLabelText:"Channel short description ("+(0,_get2.default)(this.state,"values.frontend_config.virtual_festival_discovery_short_description","").length+"/300)",floatingLabelFixed:true,style:{width:"100%"},multiLine:2,placeholder:"Up to 300 characters. Shown in Discovery Portal, TV apps, social media, and more.",value:(0,_get2.default)(this.state,"values.frontend_config.virtual_festival_discovery_short_description",""),onChange:function onChange(e){_this4.onChangeValue("frontend_config.virtual_festival_discovery_short_description",e.target.value.slice(0,300).replace(/(\n|\s+)/g," "));}})),_react2.default.createElement("div",{style:{display:"flex"}},_react2.default.createElement("div",{style:{flex:"1 1 0%",marginRight:"2em"}},_react2.default.createElement(_label2.default,null,"Channel promotion geography"),_react2.default.createElement("div",{style:{marginBottom:"1em"}},"If your channel should only be promoted to particular geographic regions, indicate so here."),_react2.default.createElement(_materialUi.Checkbox,{style:{marginTop:"1em"},label:"Channel is geographically focused",checked:(0,_get2.default)(this.state,"values.frontend_config.virtual_festival_discovery_geographic_regions",false),onCheck:function onCheck(e,checked){_this4.onChangeValue("frontend_config.virtual_festival_discovery_geographic_regions",checked?[]:false);}}),(0,_get2.default)(this.state,"values.frontend_config.virtual_festival_discovery_geographic_regions",false)?_react2.default.createElement(_injectedSelect2.default,{value:(0,_get2.default)(this.state,"values.frontend_config.virtual_festival_discovery_geographic_regions",[]),style:{marginTop:"1em"},types:["regions","countries","continents"],placeholderText:"Select regions/states, countries, etc...",multi:true,noResultsText:_react2.default.createElement("span",null,"No regions found. Try entering a continent, country, or province."),labelFormatter:function labelFormatter(v){return v.name;},onChange:function onChange(selected){return _this4.onChangeValue("frontend_config.virtual_festival_discovery_geographic_regions",selected);},eventBucketId:this.props.params.eventBucketId}):null),_react2.default.createElement("div",{style:{flex:"1 1 0%"}},_react2.default.createElement(_label2.default,null,"Channel availability dates"),_react2.default.createElement("div",null,"If your channel is only available during a particular time window, indicate so here."),_react2.default.createElement(_materialUi.Checkbox,{style:{marginTop:"1em"},label:"Channel is date-restricted",checked:(0,_get2.default)(this.state,"values.frontend_config.virtual_festival_discovery_dates",false),onCheck:function onCheck(e,checked){_this4.onChangeValue("frontend_config.virtual_festival_discovery_dates",(0,_get2.default)(_this4.state,"values.frontend_config.virtual_festival_discovery_dates")?false:{start:(0,_momentTimezone2.default)().add(2,"weeks").startOf("day").format("MM-DD-YYYY"),end:(0,_momentTimezone2.default)().add(3,"weeks").startOf("day").format("MM-DD-YYYY")});}}),(0,_get2.default)(this.state,"values.frontend_config.virtual_festival_discovery_dates",false)?_react2.default.createElement("div",{style:{}},_react2.default.createElement(_datetimeField2.default,{value:(0,_get2.default)(this.state,"values.frontend_config.virtual_festival_discovery_dates.start",""),label:"Start date",hideTime:true,useMoment:true,unclearable:true,onChange:function onChange(e,v){return _this4.onChangeValue("frontend_config.virtual_festival_discovery_dates.start",v.format("MM-DD-YYYY"));},style:{display:"inline-block",marginRight:24}}),_react2.default.createElement(_datetimeField2.default,{value:(0,_get2.default)(this.state,"values.frontend_config.virtual_festival_discovery_dates.end",""),label:"End date",hideTime:true,useMoment:true,unclearable:true,onChange:function onChange(e,v){return _this4.onChangeValue("frontend_config.virtual_festival_discovery_dates.end",v.format("MM-DD-YYYY"));},style:{display:"inline-block"}})):null))):null),_react2.default.createElement("h3",{style:{marginTop:20}},"Viewing duration restrictions"),_react2.default.createElement("div",null,"When customers unlock a virtual screening, they will have the \"unlock window\" duration to begin watching. Once they start watching (i.e., click \"Play\"), they will have the \"watch window\" duration to play the content."),_react2.default.createElement("div",null,_react2.default.createElement(_durationField2.default,{value:(0,_get2.default)(this.state,"values.virtual_festival_config.unlock_interval",""),floatingLabelText:"Unlock window",floatingLabelFixed:true,onChange:function onChange(e){return _this4.onChangeValue("virtual_festival_config.unlock_interval",e.target.value);}}),_react2.default.createElement(_durationField2.default,{style:{marginLeft:"1em"},value:(0,_get2.default)(this.state,"values.virtual_festival_config.watch_interval",""),floatingLabelText:"Watch window",floatingLabelFixed:true,onChange:function onChange(e){return _this4.onChangeValue("virtual_festival_config.watch_interval",e.target.value);}})),_UserStore2.default.isGod()?_react2.default.createElement("div",{style:{marginTop:5}},_react2.default.createElement(_materialUi.Checkbox,{label:"[GOD ONLY] Cut off watch window immediately at availability window end",checked:(0,_get2.default)(this.state,"values.virtual_festival_config.cutoff_watch_at_availability_end",false),onCheck:function onCheck(e,checked){_this4.onChangeValue("virtual_festival_config.cutoff_watch_at_availability_end",checked);}})):null,_react2.default.createElement("h3",{style:{marginTop:20}},"Catalog settings"),_react2.default.createElement("div",null,"Customize what appears on your channel's main catalog page."),_react2.default.createElement("div",null,_react2.default.createElement(_injectedSelect2.default,{style:{maxWidthc:"50%"},value:(0,_get2.default)(this.state,"values.virtual_festival_config.tag_section_order",[]),types:["visibleTags"],multi:true,label:"Display section order",placeholderText:"Default: All sections shown",labelFormatter:function labelFormatter(b){return b.name;},eventBucketId:this.state.bucket.id,onChange:function onChange(selected){_this4.onChangeValue("virtual_festival_config.tag_section_order",selected);}}),_react2.default.createElement(_materialUi.Checkbox,{style:{marginTop:"1em"},label:"Alphabetize screenings within each display section",checked:(0,_get2.default)(this.state,"values.virtual_festival_config.tag_section_alphabetize",false),onCheck:function onCheck(e,checked){_this4.onChangeValue("virtual_festival_config.tag_section_alphabetize",checked);}}),_react2.default.createElement(_materialUi.Checkbox,{label:"Prioritize position of certain screenings within display sections",checked:(0,_get2.default)(this.state,"values.virtual_festival_config.tag_section_use_priority_sort",false),onCheck:function onCheck(e,checked){_this4.onChangeValue("virtual_festival_config.tag_section_use_priority_sort",checked);}}),(0,_get2.default)(this.state,"values.virtual_festival_config.tag_section_use_priority_sort")?_react2.default.createElement("div",{style:{marginLeft:"3em"}},_react2.default.createElement("div",{style:{fontStyle:"italic",marginBottom:"-0.25em",color:"rgb(33, 33, 33)"}},"Screenings added below will be sorted to the beginning of every display section they are visible within."),_react2.default.createElement(_injectedSelect2.default,{style:{maxWidth:"100%"},value:this.state.values.virtual_festival_config.tag_section_priority_sort_events,types:["events"],multi:true,label:"Priority screening order",placeholderText:"No priority screenings added, will use default order",labelFormatter:function labelFormatter(e){return e.name;},filterBy:function filterBy(e){return!!e.is_virtual;},eventBucketId:this.state.bucket.id,onChange:function onChange(selected){_this4.onChangeValue("virtual_festival_config.tag_section_priority_sort_events",selected);}})):null,_react2.default.createElement("div",{style:{marginTop:"1em"}},_react2.default.createElement("strong",null,"Did you know?")," You can customize the display mode of each section (poster view, cover view, and more) independently via the \"Tags\" section in the lefthand sidebar.")),_react2.default.createElement("h3",{style:{marginTop:20}},"System notification emails"),_react2.default.createElement("div",null,"Configure automated system emails sent about virtual screenings in this event bucket."),_react2.default.createElement("div",{style:{marginTop:"0.5em"}},_react2.default.createElement(_materialUi.Checkbox,{label:"Send notification email 10 minutes before pre-ordered content becomes available",checked:true,disabled:true}),_react2.default.createElement(_materialUi.Checkbox,{label:"Send warning email 24 hours before any still-unwatched ticket is going to expire",checked:(0,_get2.default)(this.state,"values.virtual_festival_config.send_expiring_reminders",false),onCheck:function onCheck(e,checked){_this4.onChangeValue("virtual_festival_config.send_expiring_reminders",checked);}})),_react2.default.createElement("h3",{style:{marginTop:20}},"Default pre-roll and post-roll content"),_react2.default.createElement("div",null,"Configure your default pre-roll and post-roll content. You can override these on a per-screening basis."),_react2.default.createElement("div",{style:{marginTop:10}},_react2.default.createElement(_label2.default,null,"Pre-roll virtual content"),_react2.default.createElement("div",{style:{width:"100%",overflowX:"auto",margin:"-10px 0"}},_react2.default.createElement(_virtualContentEditor2.default,{style:{width:"min-content",margin:"0 -10px"},useBeta:(0,_get2.default)(this.state,"values.virtual_festival_config.use_beta_vod_flow"),value:(0,_get2.default)(this.state,"values.virtual_content_preroll"),onChange:function onChange(v){return _this4.onChangeValue("virtual_content_preroll",v);}}))),_react2.default.createElement("div",{style:{marginTop:15}},_react2.default.createElement(_label2.default,null,"Post-roll virtual content"),_react2.default.createElement("div",{style:{width:"100%",overflowX:"auto",margin:"-10px 0"}},_react2.default.createElement(_virtualContentEditor2.default,{style:{width:"min-content",margin:"0 -10px"},useBeta:(0,_get2.default)(this.state,"values.virtual_festival_config.use_beta_vod_flow"),value:(0,_get2.default)(this.state,"values.virtual_content_postroll"),onChange:function onChange(v){return _this4.onChangeValue("virtual_content_postroll",v);}})))),_react2.default.createElement("div",null,_react2.default.createElement("h3",{style:{marginTop:20}},"Hybrid integration",_react2.default.createElement(_inlineNoticeLabel2.default,{label:"Beta",style:{verticalAlign:2,marginLeft:6,fontWeight:"bold"}})),_react2.default.createElement("div",{style:{marginBottom:5}},"Settings for integrated in-person and virtual screenings."),_react2.default.createElement("div",null,_react2.default.createElement(_materialUi.Checkbox,{label:"Display virtual screenings in native schedule alongside physical events",checked:this.state.values.schedule_include_virtual||false,onCheck:this.onChange.bind(this,"schedule_include_virtual")}))),_react2.default.createElement("div",{style:{marginTop:30}},saveButton,_react2.default.createElement(_materialUi.RaisedButton,{label:"Close",style:{marginLeft:7},onTouchTap:function onTouchTap(){return _this4.setState({showVirtualSettings:false});}})))),_react2.default.createElement(_base2.default,{open:this.state.showAdditionalSettingsModal,onRequestClose:function onRequestClose(){return _this4.setState({showAdditionalSettingsModal:false});},hideTitleAndFooterBorders:true,showCloseButton:true},_react2.default.createElement("div",null,_react2.default.createElement("h2",null,"Additional settings"),_react2.default.createElement("div",{style:{marginTop:20}},_react2.default.createElement("h3",null,"Pass settings"),_react2.default.createElement("div",null,_react2.default.createElement(_materialUi.Checkbox,{label:"By default, require passholders to reserve tickets (overridable on a per-pass-bucket or per-event basis)",checked:this.state.values.passholder_ticket_required_default||false,onCheck:this.onChange.bind(this,"passholder_ticket_required_default")})),_react2.default.createElement("div",null,_react2.default.createElement(_materialUi.Checkbox,{label:"Allow passholders to order tickets online",checked:this.state.values.passholder_web_orders_allowed||false,onCheck:this.onChange.bind(this,"passholder_web_orders_allowed")})),_react2.default.createElement("div",null,_react2.default.createElement(_materialUi.Checkbox,{label:"Email ticket order confirmations to passholders",checked:this.state.values.passholder_order_email_confirmation||false,onCheck:this.onChange.bind(this,"passholder_order_email_confirmation")})),_react2.default.createElement("div",null,_react2.default.createElement(_materialUi.Checkbox,{label:"Allow pass transfers",checked:this.state.values.passholder_transfer_allowed||false,onCheck:this.onChange.bind(this,"passholder_transfer_allowed")}))),this.state.values.mode!=="pass_only"?_react2.default.createElement("div",{style:{marginTop:20}},_react2.default.createElement("h3",null,"Lock standalone tickets"),_react2.default.createElement("div",null,"By default, when standalone tickets are enabled, anyone can order them.",_react2.default.createElement("br",null),"If you \"lock\" standalone tickets, users have to enter a password before they're allowed to buy tickets."),_react2.default.createElement("div",{style:{marginTop:10}},_react2.default.createElement(_materialUi.Checkbox,{label:"Standalone ticket sales locked",checked:this.state.values.standalone_ticket_sales_locked||false,onCheck:this.onChange.bind(this,"standalone_ticket_sales_locked")})),this.state.values.standalone_ticket_sales_locked?_react2.default.createElement("div",null,_react2.default.createElement(_materialUi.TextField,{value:(0,_get2.default)(this.state,"values.standalone_ticket_sales_locked_password",""),floatingLabelText:"Standalone ticket sales password",floatingLabelFixed:true,hintText:"\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022",onChange:function onChange(e){return _this4.onChangeValue("standalone_ticket_sales_locked_password",e.target.value);}})):null):null,_react2.default.createElement("div",{style:{marginTop:20}},_react2.default.createElement("h3",null,"Rush line settings"),_react2.default.createElement("div",null,"Settings related to selling tickets at the door using Rush Line mode on the"," ",_react2.default.createElement("a",{href:"https://help.eventive.org/eventive-scanner",target:"_blank"},"Eventive Scanner"),"."),_react2.default.createElement("div",{style:{marginTop:10}},_react2.default.createElement(_materialUi.Checkbox,{label:"Enable Rush Line ticket sales & pass scanning",checked:this.state.values.rush_line_enabled||false,onCheck:this.onChange.bind(this,"rush_line_enabled")})),_react2.default.createElement("div",null,_react2.default.createElement(_materialUi.Checkbox,{label:"Set a default rush line ticket price",checked:this.state.values.rush_line_default_price||this.state.showRushLinePriceEditor,onCheck:function onCheck(e,checked){_this4.setState({showRushLinePriceEditor:checked},function(){!checked&&_this4.onChangeValue("rush_line_default_price",null);});}}),this.state.showRushLinePriceEditor||this.state.values.rush_line_default_price?_react2.default.createElement(_currencyField2.default,{floatingLabelText:"Default rush line ticket price",floatingLabelFixed:true,placeholder:"$0.00",value:this.state.values.rush_line_default_price,onChange:function onChange(e){return _this4.setState({showRushLinePriceEditor:true},function(){return _this4.onChangeValue("rush_line_default_price",e.target.value);});}}):null)),_react2.default.createElement("div",{style:{marginTop:20}},_react2.default.createElement("h3",null,"Box office settings"),_react2.default.createElement("div",null,"Settings related to selling tickets, passes, & items using the"," ",_react2.default.createElement(_reactRouter.Link,{to:"/event_buckets/"+this.state.bucket.id+"/box_office"},"Eventive Box Office"),"."),_react2.default.createElement("div",{style:{marginTop:10}},_react2.default.createElement(_materialUi.Checkbox,{label:"Auto-open PDF tickets/pass labels for printing after placing an order",checked:this.state.values.box_office_auto_open,onCheck:function onCheck(e,checked){_this4.onChangeValue("box_office_auto_open",checked);}}),_react2.default.createElement(_materialUi.Checkbox,{label:"Auto-populate the previous order's event when selling single tickets to a single event",checked:this.state.values.box_office_auto_populate,onCheck:function onCheck(e,checked){_this4.onChangeValue("box_office_auto_populate",checked);}}),_react2.default.createElement(_materialUi.Checkbox,{label:"Generate ticket-sized (2.5\" x 6\") tickets for printing, instead of letter-sized",checked:this.state.values.box_office_ticket_printer,onCheck:function onCheck(e,checked){_this4.onChangeValue("box_office_ticket_printer",checked);}}),this.state.values.box_office_ticket_printer?_react2.default.createElement(_materialUi.Checkbox,{label:"Use Boca format for box office tickets",checked:this.state.values.box_office_use_boca,onCheck:function onCheck(e,checked){_this4.onChangeValue("box_office_use_boca",checked);}}):null,_react2.default.createElement(_materialUi.Checkbox,{label:"Show per-transaction option to mark box office tickets as scanned immediately",checked:this.state.values.box_office_show_mark_scanned,onCheck:function onCheck(e,checked){_this4.onChangeValue("box_office_show_mark_scanned",checked);}}),_react2.default.createElement(_materialUi.Checkbox,{label:"Enable box office shift tracking (cash in/out)",checked:this.state.values.box_office_shift_tracking,onCheck:function onCheck(e,checked){_this4.onChangeValue("box_office_shift_tracking",checked);}}),function(){var addFee=_this4.state.values.box_office_service_fee||_this4.state.showBoxOfficeServiceFee;return _react2.default.createElement("div",null,_react2.default.createElement(_materialUi.Checkbox,{label:"Add box office per-item service fee",checked:addFee,onCheck:function onCheck(){_this4.setState({showBoxOfficeServiceFee:!addFee},function(){if(!_this4.state.showBoxOfficeServiceFee)_this4.onChangeValue("box_office_service_fee",0);});}}),addFee?_react2.default.createElement(_currencyField2.default,{floatingLabelText:"Box office service fee",floatingLabelFixed:true,placeholder:"$0.00",style:{marginTop:"-0.5em",marginLeft:"2.5em"},value:_this4.state.values.box_office_service_fee,onChange:function onChange(e){return _this4.onChangeValue("box_office_service_fee",e.target.value);}}):null);}())),_react2.default.createElement("div",{style:{marginTop:20}},_react2.default.createElement("h3",null,"Custom native site domain"),_react2.default.createElement(_materialUi.Checkbox,{label:"Custom native site domain enabled",style:{marginBottom:10},checked:this.state.showCustomDomainField,onCheck:this.onCustomDomainCheck}),this.state.showCustomDomainField?_react2.default.createElement("div",null,_react2.default.createElement("div",null,"A custom domain must be a subdomain on another domain which you control; for example, \"events.yourorganization.com\". After entering the domain here, please contact your Eventive account represenative. We will then provide a CNAME record that you will need to add to your domain's DNS configuration."),_react2.default.createElement(_materialUi.TextField,{value:(0,_get2.default)(this.state,"values.custom_domain",""),floatingLabelText:"Custom domain",floatingLabelFixed:true,onChange:function onChange(e){return _this4.onChangeValue("custom_domain",e.target.value);}})):null),_react2.default.createElement("div",{style:{marginTop:20}},_react2.default.createElement("h3",null,"Advanced ticketing settings"),_react2.default.createElement(_materialUi.Checkbox,{label:"Allow passholder at-the-door instant ticket oversell",checked:this.state.values.passholder_instant_ticket_oversell_allowed,onCheck:function onCheck(e,checked){_this4.onChangeValue("passholder_instant_ticket_oversell_allowed",checked);}}),_react2.default.createElement(_materialUi.Checkbox,{label:_react2.default.createElement("span",null,"Close online ticket sales prior to event start time"," ",_react2.default.createElement("i",null,"(not recommended)")),checked:this.state.showCutoffEditor,onCheck:function onCheck(e,checked){_this4.setState({showCutoffEditor:!_this4.state.showCutoffEditor},function(){return _this4.onChangeValue("ticket_sales_cutoff",_this4.state.showCutoffEditor?30*60*1000/* 30 min */:0);});}}),this.state.showCutoffEditor?_react2.default.createElement("div",{style:{marginLeft:40}},_react2.default.createElement("div",null,"Online sales will close"," ",_react2.default.createElement("strong",null,_juration2.default.stringify(this.state.values.ticket_sales_cutoff/1000))," ","(editable below) before each event start time and show as \"Box office only\". You can customize the error message shown to customers by editing the \"Box office only error message\" in the Configurator."),_react2.default.createElement(_durationField2.default,{value:(0,_get2.default)(this.state,"values.ticket_sales_cutoff",""),floatingLabelText:"Ticket sales cutoff",floatingLabelFixed:true,onChange:function onChange(e){return _this4.onChangeValue("ticket_sales_cutoff",e.target.value);}})):null,_react2.default.createElement(_materialUi.Checkbox,{label:_react2.default.createElement("span",null,"Disable standalone ticket transfer for all users"," ",_react2.default.createElement("i",null,"(not recommended)")),style:{marginBottom:10},checked:this.state.values.ticket_transfer_for_all_users_disabled,onCheck:function onCheck(e,checked){_this4.onChangeValue("ticket_transfer_for_all_users_disabled",checked);}})),this.state.values.credits_enabled?_react2.default.createElement("div",{style:{marginTop:20}},_react2.default.createElement("h3",null,"Credits"),_react2.default.createElement(_currencyField2.default,{floatingLabelText:"Face credit price (undiscounted)",floatingLabelFixed:true,placeholder:"$0.00",style:{marginTop:"-0.75em"},value:this.state.values.credits_face_price,onChange:function onChange(e){return _this4.onChangeValue("credits_face_price",e.target.value);}}),_react2.default.createElement(_label2.default,null,"Levels"),_react2.default.createElement("div",{style:{margin:"-1.5em -3em 0"}},_react2.default.createElement("ul",{style:{listStyle:"none"}},this.state.values.credits_levels.map(function(v,i){return _react2.default.createElement("li",{style:{marginBottom:"-0.5em",fontSize:16}},"Quantity:\xA0",_react2.default.createElement(_materialUi.TextField,{name:"credits_levels_quantity-"+i,placeholder:"",value:v.quantity,style:{marginLeft:5,width:50},onChange:function onChange(e){_this4.state.values.credits_levels[i].quantity=e.target.value;_this4.onChangeValue("credits_levels",_this4.state.values.credits_levels);}}),"for",_react2.default.createElement(_currencyField2.default,{name:"credits_levels_price-"+i,placeholder:"$0.00",value:v.price,onChange:function onChange(e){_this4.state.values.credits_levels[i].price=e.target.value;_this4.onChangeValue("credits_levels",_this4.state.values.credits_levels);},style:{marginLeft:7,width:150,maxWidth:"25%"}}),_react2.default.createElement(_materialUi.FlatButton,{style:{marginLeft:7,minWidth:30},label:"\xD7",onTouchTap:function onTouchTap(){_this4.state.values.credits_levels.splice(i,1);_this4.onChangeValue("credits_levels",_this4.state.values.credits_levels);}}));}),_react2.default.createElement("li",{style:{marginTop:"1em"}},_react2.default.createElement(_materialUi.RaisedButton,{label:"Add another level",onTouchTap:function onTouchTap(){return _this4.onChangeValue("credits_levels",_this4.state.values.credits_levels.concat({}));}})))),_react2.default.createElement("div",null,_react2.default.createElement(_injectedSelect2.default,{style:{maxWidth:"50%"},value:this.state.values.credits_allowed_pass_buckets,types:["pass_buckets"],multi:true,label:"Specific pass buckets allowed to purchase credits",placeholderText:"Default: All customers allowed to purchase credits",labelFormatter:function labelFormatter(b){return b.name;},eventBucketId:this.state.bucket.id,onChange:function onChange(selected){_this4.onChangeValue("credits_allowed_pass_buckets",selected);}})),_react2.default.createElement("div",null,_react2.default.createElement(_materialUi.TextField,{floatingLabelText:"Credits discount percentage (0-1)",floatingLabelFixed:true,value:this.state.values.credits_discount.percent_off,onChange:function onChange(e){_this4.state.values.credits_discount.percent_off=e.target.value;_this4.onChangeValue("credits_discount",_this4.state.values.credits_discount);}}),_react2.default.createElement(_injectedSelect2.default,{style:{maxWidth:"50%"},value:this.state.values.credits_discount.pass_buckets,types:["pass_buckets"],multi:true,label:"Credits discount applicable pass buckets",labelFormatter:function labelFormatter(b){return b.name;},eventBucketId:this.state.bucket.id,onChange:function onChange(selected){_this4.state.values.credits_discount.pass_buckets=selected;_this4.onChangeValue("credits_discount",_this4.state.values.credits_discount);}}))):null,_UserStore2.default.isGod()?_react2.default.createElement("div",{style:{marginTop:20}},_react2.default.createElement("h3",null,"Advanced options ",_react2.default.createElement(_inlineNoticeLabel2.default,{label:"God only"})),_react2.default.createElement("div",null,_react2.default.createElement(_materialUi.SelectField,{value:this.state.values.class,onChange:function onChange(e,i,value){return _this4.onChangeValue("class",value);},style:{marginTop:"-0.5em",marginBottom:"0.5em"}},_react2.default.createElement(_materialUi.MenuItem,{value:"festival",primaryText:"Festival"}),_react2.default.createElement(_materialUi.MenuItem,{value:"yearround",primaryText:"Year-round"}))),_react2.default.createElement(_materialUi.Checkbox,{label:"Enable order-all-starred option via schedule",checked:this.state.values.enable_order_all_starred,onCheck:function onCheck(e,checked){_this4.onChangeValue("enable_order_all_starred",checked);}}),_react2.default.createElement(_materialUi.Checkbox,{label:"Enable guest checkout",checked:this.state.values.enable_guest_checkout,onCheck:function onCheck(e,checked){_this4.onChangeValue("enable_guest_checkout",checked);}}),_react2.default.createElement(_materialUi.Checkbox,{label:"Enable cart",checked:this.state.values.enable_cart,onCheck:function onCheck(e,checked){_this4.onChangeValue("enable_cart",checked);}}),_react2.default.createElement(_materialUi.Checkbox,{label:"Enable ticket credits",checked:this.state.values.credits_enabled,onCheck:function onCheck(e,checked){_this4.onChangeValue("credits_enabled",checked);}}),_react2.default.createElement(_materialUi.Checkbox,{label:"Enable balloting",checked:this.state.values.enable_balloting,onCheck:function onCheck(e,checked){_this4.onChangeValue("enable_balloting",checked);}}),_react2.default.createElement(_materialUi.Checkbox,{label:"Enable custom event IDs",checked:this.state.values.enable_custom_event_ids,onCheck:function onCheck(e,checked){_this4.onChangeValue("enable_custom_event_ids",checked);}}),_react2.default.createElement(_materialUi.Checkbox,{label:"Enable Eventival login",checked:this.state.values.enable_eventival_login,onCheck:function onCheck(e,checked){_this4.onChangeValue("enable_eventival_login",checked);}}),_react2.default.createElement(_materialUi.Checkbox,{label:"Enable NFC badges at check-in",checked:this.state.values.enable_nfc,onCheck:function onCheck(e,checked){_this4.onChangeValue("enable_nfc",checked);}}),_react2.default.createElement(_materialUi.Checkbox,{label:"Enable Print Traffic / Title Delivery mode",style:{marginTop:10},checked:this.state.values.enable_title_delivery,onCheck:function onCheck(e,checked){_this4.onChangeValue("enable_title_delivery",checked);}}),this.state.values.enable_title_delivery?_react2.default.createElement("div",{style:{marginLeft:"2.5rem",marginTop:"-0.5rem"}},_react2.default.createElement(_label2.default,null,"Print delivery mode"),function(){var value=_this4.state.values&&_this4.state.values.title_delivery_config&&_this4.state.values.title_delivery_config.accepted_print_formats&&_this4.state.values.title_delivery_config.accepted_print_formats[0];return _react2.default.createElement("div",null,_react2.default.createElement(_materialUi.RadioButtonGroup,{name:"mode",style:{marginLeft:"0em"},valueSelected:value,onChange:function onChange(e,v){var values=_this4.state.values;values.title_delivery_config.accepted_print_formats=[v];_this4.setState({dirty:true,values:values});}},_react2.default.createElement(_materialUi.RadioButton,{value:"dcp",label:"DCP"}),_react2.default.createElement(_materialUi.RadioButton,{value:"digital_file",label:"Digital file (non-DCP)"})));}()):null,_react2.default.createElement(_materialUi.Checkbox,{label:"Enable Eventive Virtual",style:{marginTop:10,marginBottom:0},checked:this.state.values.enable_virtual_festival,onCheck:function onCheck(e,checked){_this4.onChangeValue("enable_virtual_festival",checked);}}),_react2.default.createElement(_materialUi.Checkbox,{label:"[REQUIRES CUSTOM AGREEMENT] Defer all unlock fees",checked:this.state.values.defer_all_unlock_fees,onCheck:function onCheck(e,checked){_this4.onChangeValue("defer_all_unlock_fees",checked);}}),_react2.default.createElement(_materialUi.Checkbox,{label:"Eventive Virtual enable watermarking",checked:(0,_get2.default)(this.state.values,"virtual_festival_config.watermark_enabled",false),onCheck:function onCheck(e,checked){_this4.onChangeValue("virtual_festival_config.watermark_enabled",checked);}}),(0,_get2.default)(this.state.values,"virtual_festival_config.watermark_enabled",false)?_react2.default.createElement("div",null,_react2.default.createElement(_materialUi.TextField,{style:{marginLeft:"2.5em",marginTop:"-0.5em"},floatingLabelText:"Watermark title",floatingLabelFixed:true,value:(0,_get2.default)(this.state.values,"virtual_festival_config.watermark_title"),onChange:function onChange(e){_this4.onChangeValue("virtual_festival_config.watermark_title",e.target.value);}}),_react2.default.createElement(_materialUi.SelectField,{value:(0,_get2.default)(this.state.values,"virtual_festival_config.watermark_location"),onChange:function onChange(e,i,value){return _this4.onChangeValue("virtual_festival_config.watermark_location",value);},style:{marginLeft:"1em",verticalAlign:-2,width:160}},_react2.default.createElement(_materialUi.MenuItem,{value:"bottom-right",primaryText:"Bottom right"}),_react2.default.createElement(_materialUi.MenuItem,{value:"top-left",primaryText:"Top left"}))):null):null,_react2.default.createElement("div",{style:{marginTop:20}},saveButton,_react2.default.createElement(_materialUi.RaisedButton,{label:"Close",style:{marginLeft:7},onTouchTap:function onTouchTap(){return _this4.setState({showAdditionalSettingsModal:false});}})))));}}],[{key:"getStores",value:function getStores(){return[_EventBucketStore2.default];}},{key:"getPropsFromStores",value:function getPropsFromStores(){return{getEventBucketById:_EventBucketStore2.default.getEventBucketById,getSubdomainTestResultsByEventBucketId:_EventBucketStore2.default.getSubdomainTestResultsByEventBucketId};}},{key:"contextTypes",get:function get(){return{router:_react2.default.PropTypes.object,muiTheme:_react2.default.PropTypes.object};}}]);return EventBucketSettings;}(_react2.default.Component);exports.default=(0,_connectToStores2.default)(EventBucketSettings);module.exports=exports["default"];

/***/ }),
/* 1872 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _materialUi = __webpack_require__(576);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var BackButton = function BackButton(_ref, context) {
	  var location = _ref.location;
	  var arrowStyle = _ref.arrowStyle;
	  var onTouchTap = _ref.onTouchTap;
	  var label = _ref.label;
	
	  var rest = _objectWithoutProperties(_ref, ["location", "arrowStyle", "onTouchTap", "label"]);
	
	  function _onTouchTap() {
	    if (location) {
	      context.router.push(location);
	    } else if (onTouchTap) {
	      onTouchTap();
	    } else {
	      context.router.goBack();
	    }
	  }
	
	  return _react2.default.createElement(_materialUi.RaisedButton, _extends({
	    label: _react2.default.createElement(
	      "span",
	      null,
	      _react2.default.createElement(
	        "span",
	        { style: arrowStyle || { fontSize: "1.4em", verticalAlign: -1 } },
	        "\u2039"
	      ),
	      " ",
	      label
	    ),
	    onTouchTap: _onTouchTap
	  }, rest));
	};
	
	BackButton.contextTypes = { router: _react2.default.PropTypes.object };
	
	exports.default = BackButton;
	module.exports = exports["default"];

/***/ }),
/* 1873 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _materialUi = __webpack_require__(576);
	
	var _util = __webpack_require__(1183);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * Display percent (0.0000 - 1.0000) in user-friendly X.XX% format.
	 */
	var PercentField = function (_React$Component) {
	  _inherits(PercentField, _React$Component);
	
	  function PercentField(props) {
	    _classCallCheck(this, PercentField);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(PercentField).call(this, props));
	
	    _this.state = {
	      editedValue: null
	    };
	
	    _this._handleInputChange = _this._handleInputChange.bind(_this);
	    _this._handleInputBlur = _this._handleInputBlur.bind(_this);
	    return _this;
	  }
	
	  _createClass(PercentField, [{
	    key: "_handleInputChange",
	    value: function _handleInputChange(e) {
	      var value = e.target.value;
	
	
	      this.setState({
	        editedValue: value
	      });
	
	      this.props.onChange({
	        target: {
	          value: value.replace(/[^0-9\.]/g, "") / 100
	        }
	      });
	    }
	  }, {
	    key: "_handleInputBlur",
	    value: function _handleInputBlur() {
	      this.setState({ editedValue: null });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _props = this.props;
	      var value = _props.value;
	      var onChange = _props.onChange;
	      var onBlur = _props.onBlur;
	      var placeholder = _props.placeholder;
	      var props = _objectWithoutProperties(_props, ["value", "onChange", "onBlur", "placeholder"]);
	      var editedValue = this.state.editedValue;
	
	
	      return _react2.default.createElement(_materialUi.TextField, _extends({
	        value: editedValue !== null ? editedValue : value ? "" + (0, _util.formatPercent)(value) : "",
	        onChange: this._handleInputChange,
	        onBlur: this._handleInputBlur,
	        placeholder: placeholder || "0%"
	      }, props));
	    }
	  }]);
	
	  return PercentField;
	}(_react2.default.Component);
	
	exports.default = PercentField;
	module.exports = exports["default"];

/***/ }),
/* 1874 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _get = __webpack_require__(1004);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _findIndex = __webpack_require__(1402);
	
	var _findIndex2 = _interopRequireDefault(_findIndex);
	
	var _reactSelect = __webpack_require__(953);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	var _reactBeautifulDnd = __webpack_require__(1875);
	
	var _config = __webpack_require__(1173);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _connectToStores = __webpack_require__(1226);
	
	var _connectToStores2 = _interopRequireDefault(_connectToStores);
	
	var _UserStore = __webpack_require__(974);
	
	var _UserStore2 = _interopRequireDefault(_UserStore);
	
	var _PassBucketActions = __webpack_require__(1869);
	
	var _PassBucketActions2 = _interopRequireDefault(_PassBucketActions);
	
	var _PassBucketStore = __webpack_require__(1867);
	
	var _PassBucketStore2 = _interopRequireDefault(_PassBucketStore);
	
	var _EventActions = __webpack_require__(2031);
	
	var _EventActions2 = _interopRequireDefault(_EventActions);
	
	var _EventStore = __webpack_require__(2032);
	
	var _EventStore2 = _interopRequireDefault(_EventStore);
	
	var _VenueActions = __webpack_require__(2035);
	
	var _VenueActions2 = _interopRequireDefault(_VenueActions);
	
	var _VenueStore = __webpack_require__(2036);
	
	var _VenueStore2 = _interopRequireDefault(_VenueStore);
	
	var _TagActions = __webpack_require__(2038);
	
	var _TagActions2 = _interopRequireDefault(_TagActions);
	
	var _TagStore = __webpack_require__(2039);
	
	var _TagStore2 = _interopRequireDefault(_TagStore);
	
	var _CouponActions = __webpack_require__(2041);
	
	var _CouponActions2 = _interopRequireDefault(_CouponActions);
	
	var _CouponStore = __webpack_require__(2042);
	
	var _CouponStore2 = _interopRequireDefault(_CouponStore);
	
	var _ItemBucketActions = __webpack_require__(2044);
	
	var _ItemBucketActions2 = _interopRequireDefault(_ItemBucketActions);
	
	var _ItemBucketStore = __webpack_require__(2045);
	
	var _ItemBucketStore2 = _interopRequireDefault(_ItemBucketStore);
	
	var _FilmActions = __webpack_require__(1764);
	
	var _FilmActions2 = _interopRequireDefault(_FilmActions);
	
	var _FilmStore = __webpack_require__(1765);
	
	var _FilmStore2 = _interopRequireDefault(_FilmStore);
	
	var _PassActions = __webpack_require__(2047);
	
	var _PassActions2 = _interopRequireDefault(_PassActions);
	
	var _PassStore = __webpack_require__(2048);
	
	var _PassStore2 = _interopRequireDefault(_PassStore);
	
	var _EventBucketActions = __webpack_require__(1218);
	
	var _EventBucketActions2 = _interopRequireDefault(_EventBucketActions);
	
	var _EventBucketStore = __webpack_require__(1593);
	
	var _EventBucketStore2 = _interopRequireDefault(_EventBucketStore);
	
	var _SystemStatesStore = __webpack_require__(1211);
	
	var _SystemStatesStore2 = _interopRequireDefault(_SystemStatesStore);
	
	var _inlineButton = __webpack_require__(1674);
	
	var _inlineButton2 = _interopRequireDefault(_inlineButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var InjectedSelect = function (_React$Component) {
	  _inherits(InjectedSelect, _React$Component);
	
	  function InjectedSelect(props) {
	    _classCallCheck(this, InjectedSelect);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(InjectedSelect).call(this, props));
	
	    _initialiseProps.call(_this);
	
	    _this.state = {
	      objects: {},
	      fetchedEventBuckets: [],
	      isReordering: false,
	      reorderingHeight: null,
	      hasMounted: false
	    };
	
	    _this.renderValue = _this.renderValue.bind(_this);
	    _this.onRemove = _this.onRemove.bind(_this);
	    _this.onValueChange = _this.onValueChange.bind(_this);
	    return _this;
	  }
	
	  _createClass(InjectedSelect, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.componentWillReceiveProps(this.props);
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(newProps) {
	      var _this2 = this;
	
	      var _props = this.props;
	      var types = _props.types;
	      var type = _props.type;
	      var eventBucketId = _props.eventBucketId;
	      var skipFetch = _props.skipFetch;
	      var excludeOlder = _props.excludeOlder;
	
	      if (typeof type !== "undefined") {
	        types = (types || []).concat([type]);
	      }
	      if (!eventBucketId) {
	        if (types.indexOf("event_buckets") !== -1) {
	          eventBucketId = [_EventBucketStore2.default.getEventBuckets()[0].id];
	        } else {
	          return;
	        }
	      }
	
	      var load = function load(eventBucketId) {
	        var needsFetch = _this2.state.fetchedEventBuckets.indexOf(eventBucketId) === -1;
	        if (!skipFetch && needsFetch) {
	          if (types.indexOf("venues") !== -1) {
	            _VenueActions2.default.fetchAllForBucket.defer(eventBucketId);
	          }
	          if (types.indexOf("pass_buckets") !== -1 || types.indexOf("memberships") !== -1) {
	            _PassBucketActions2.default.fetchAllForEventBucket.defer(eventBucketId);
	          }
	          if (types.indexOf("all_pass_buckets") !== -1) {
	            _PassBucketActions2.default.fetchAll.defer();
	          }
	          if (types.indexOf("events") !== -1 || types.indexOf("ticket_buckets") !== -1) {
	            var excludeOlderEvents = excludeOlder ? true : false;
	            _EventActions2.default.fetchAllForBucket.defer(eventBucketId, false, excludeOlderEvents);
	          }
	          if (types.indexOf("tags") !== -1) {
	            _TagActions2.default.fetchAllForBucket.defer(eventBucketId);
	          }
	          if (types.indexOf("visibleTags") !== -1) {
	            _TagActions2.default.fetchAllForBucket.defer(eventBucketId);
	          }
	          if (types.indexOf("coupons") !== -1) {
	            _CouponActions2.default.fetchAllForBucket.defer(eventBucketId);
	          }
	          if (types.indexOf("item_buckets") !== -1 || types.indexOf("item_bucket.variants") !== -1) {
	            _ItemBucketActions2.default.fetchAllForEventBucket.defer(eventBucketId);
	          }
	          if (types.indexOf("films") !== -1) {
	            _FilmActions2.default.fetchAllForEventBucket.defer(eventBucketId);
	          }
	          if (types.indexOf("passes") !== -1 || types.indexOf("membership_passes") !== -1) {
	            _PassActions2.default.fetchAllForEventBucket.defer(eventBucketId);
	          }
	          if (types.indexOf("event_buckets") !== -1) {
	            _EventBucketActions2.default.fetchAll.defer();
	          }
	        }
	
	        var getVenuesForEventBucket = newProps.getVenuesForEventBucket;
	        var getPassBucketsForEventBucket = newProps.getPassBucketsForEventBucket;
	        var getMembershipsForEventBucket = newProps.getMembershipsForEventBucket;
	        var getPassMembershipsForEventBucket = newProps.getPassMembershipsForEventBucket;
	        var getAllPassBuckets = newProps.getAllPassBuckets;
	        var getEventsForEventBucket = newProps.getEventsForEventBucket;
	        var getTagsForEventBucket = newProps.getTagsForEventBucket;
	        var getCouponsForEventBucket = newProps.getCouponsForEventBucket;
	        var getItemBucketsForEventBucket = newProps.getItemBucketsForEventBucket;
	        var getFilmsForEventBucket = newProps.getFilmsForEventBucket;
	        var getPassesForEventBucket = newProps.getPassesForEventBucket;
	        var getEventBuckets = newProps.getEventBuckets;
	        var objects = {};
	
	        if (types.indexOf("venues") !== -1) {
	          objects.venues = getVenuesForEventBucket(eventBucketId);
	        }
	        if (types.indexOf("pass_buckets") !== -1) {
	          objects.pass_buckets = getPassBucketsForEventBucket(eventBucketId);
	        }
	        if (types.indexOf("memberships") !== -1) {
	          objects.memberships = getMembershipsForEventBucket(eventBucketId);
	        }
	        if (types.indexOf("all_pass_buckets") !== -1) {
	          objects.all_pass_buckets = getAllPassBuckets();
	        }
	        if (types.indexOf("events") !== -1) {
	          objects.events = getEventsForEventBucket(eventBucketId);
	        }
	        if (types.indexOf("ticket_buckets") !== -1) {
	          var event = newProps.eventId && _EventStore2.default.getEventById(newProps.eventId),
	              events = newProps.eventId ? event ? [event] : [] : getEventsForEventBucket(eventBucketId);
	
	          objects.ticket_buckets = [].concat.apply([], events.map(function (event) {
	            return event.ticket_buckets.map(function (b) {
	              return Object.assign({}, b, { event: event });
	            });
	          }));
	        }
	        if (types.indexOf("ticket_bucket.variants") !== -1) {
	          objects["item_bucket.variants"] = (_EventStore2.default.getTicketBucketWithEventById(newProps.ticketBucketId) || {
	            variants: []
	          }).variants;
	        }
	        if (types.indexOf("tags") !== -1) {
	          objects.tags = getTagsForEventBucket(eventBucketId);
	        }
	        if (types.indexOf("visibleTags") !== -1) {
	          objects.visibleTags = getTagsForEventBucket(eventBucketId, true);
	        }
	        if (types.indexOf("coupons") !== -1) {
	          objects.coupons = getCouponsForEventBucket(eventBucketId);
	        }
	        if (types.indexOf("item_buckets") !== -1) {
	          objects.item_buckets = getItemBucketsForEventBucket(eventBucketId);
	        }
	        if (types.indexOf("item_bucket.variants") !== -1) {
	          objects["item_bucket.variants"] = (_ItemBucketStore2.default.getItemBucketById(newProps.itemBucketId) || {
	            variants: []
	          }).variants;
	        }
	        if (types.indexOf("films") !== -1) {
	          objects.films = getFilmsForEventBucket(eventBucketId);
	        }
	        if (types.indexOf("passes") !== -1) {
	          objects.passes = getPassesForEventBucket(eventBucketId);
	        }
	        if (types.indexOf("membership_passes") !== -1) {
	          objects.membership_passes = getPassMembershipsForEventBucket(eventBucketId);
	        }
	        if (types.indexOf("event_buckets") !== -1) {
	          objects.event_buckets = getEventBuckets();
	        }
	
	        return objects;
	      };
	
	      if (typeof eventBucketId === "string") {
	        eventBucketId = [eventBucketId];
	      }
	      var objects = {};
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = eventBucketId[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var id = _step.value;
	
	          var bucketObjects = load(id);
	          for (var k in bucketObjects) {
	            objects[k] = (objects[k] || []).concat(bucketObjects[k]);
	          }
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	
	      var locationData = _SystemStatesStore2.default.getLocationData();
	      if (types.indexOf("continents") !== -1) {
	        objects.continents = locationData.continents.map(function (_ref) {
	          var name = _ref.name;
	          var code = _ref.code;
	          return {
	            name: name,
	            id: code
	          };
	        });
	      }
	      if (types.indexOf("countries") !== -1) {
	        objects.countries = locationData.countries.map(function (_ref2) {
	          var name = _ref2.name;
	          var code = _ref2.code;
	          return {
	            name: name,
	            id: code
	          };
	        });
	      }
	      if (types.indexOf("regions") !== -1) {
	        objects.regions = locationData.regions.map(function (_ref3) {
	          var name = _ref3.name;
	          var code = _ref3.code;
	          return {
	            name: name,
	            id: code
	          };
	        });
	      }
	
	      this.setState({
	        objects: objects,
	        fetchedEventBuckets: this.state.fetchedEventBuckets.concat(eventBucketId)
	      });
	
	      if ((newProps.focus || newProps.autoFocus) && this.select) {
	        setTimeout(function () {
	          return _this2.select && _this2.select.focus();
	        }, 0);
	      }
	
	      setTimeout(function () {
	        _this2.setState({ hasMounted: true });
	      }, 0);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this3 = this;
	
	      var _props2 = this.props;
	      var autoFocus = _props2.autoFocus;
	      var focus = _props2.focus;
	      var style = _props2.style;
	      var label = _props2.label;
	      var creatable = _props2.creatable;
	      var creatablePromptText = _props2.creatablePromptText;
	      var creatableShowNewOptionAtTop = _props2.creatableShowNewOptionAtTop;
	      var onCreateSelect = _props2.onCreateSelect;
	      var labelFormatter = _props2.labelFormatter;
	      var isDisabledFunction = _props2.isDisabledFunction;
	      var filterBy = _props2.filterBy;
	      var multi = _props2.multi;
	      var noResultsText = _props2.noResultsText;
	      var placeholderText = _props2.placeholderText;
	      var value = _props2.value;
	      var changeValueFunction = _props2.changeValueFunction;
	      var sortFunction = _props2.sortFunction;
	      var injectOptions = _props2.injectOptions;
	      var onChange = _props2.onChange;
	      var sortDisabledToEnd = _props2.sortDisabledToEnd;
	      var labelToFilterString = _props2.labelToFilterString;
	      var isFetching = _props2.isFetching;
	      var rest = _objectWithoutProperties(_props2, ["autoFocus", "focus", "style", "label", "creatable", "creatablePromptText", "creatableShowNewOptionAtTop", "onCreateSelect", "labelFormatter", "isDisabledFunction", "filterBy", "multi", "noResultsText", "placeholderText", "value", "changeValueFunction", "sortFunction", "injectOptions", "onChange", "sortDisabledToEnd", "labelToFilterString", "isFetching"]);
	      var _state = this.state;
	      var objects = _state.objects;
	      var isReordering = _state.isReordering;
	      var reorderingHeight = _state.reorderingHeight;
	      var hasMounted = _state.hasMounted;
	
	
	      var allOptions = this.getOptions();
	
	      if (sortFunction) {
	        allOptions.sort(sortFunction);
	      }
	
	      if (sortDisabledToEnd) {
	        allOptions = allOptions.filter(function (o) {
	          return !o.disabled;
	        }).concat(allOptions.filter(function (o) {
	          return o.disabled;
	        }));
	      }
	
	      if (_UserStore2.default.isGod() && !isFetching && hasMounted) {
	        // Include any old deleted options too. This way the god user can have easy visibility
	        // and delete them if needed.
	        var currentlySelected = value ? Array.isArray(value) ? value : [value] : [];
	        var deletedValues = currentlySelected.filter(function (o) {
	          return !allOptions.find(function (a) {
	            return a.value === o;
	          });
	        });
	        allOptions = allOptions.concat(deletedValues.map(function (v, i) {
	          return {
	            value: v,
	            label: "DELETED (" + v + ")",
	            isDeleted: true,
	            rawValue: {},
	            filterableLabel: ""
	          };
	        }));
	      }
	
	      var SelectComponent = creatable ? _reactSelect.Creatable : _reactSelect2.default;
	      return _react2.default.createElement(
	        "div",
	        { style: style },
	        label ? _react2.default.createElement(
	          "div",
	          {
	            style: {
	              fontSize: 12,
	              color: "rgba(33, 33, 33, 0.498039)",
	              marginBottom: 5,
	              marginTop: 10,
	              display: "flex"
	            }
	          },
	          _react2.default.createElement(
	            "span",
	            { style: { flex: 1 } },
	            label
	          ),
	          isReordering || multi && Array.isArray(value) && value.filter(function (v) {
	            return allOptions.find(function (o) {
	              return o.value === v;
	            });
	          }).length >= 2 ? _react2.default.createElement(
	            "span",
	            null,
	            isReordering ? _react2.default.createElement(
	              "span",
	              { style: { marginRight: 5 } },
	              "Drag to re-order"
	            ) : "",
	            !this.props.disabled ? _react2.default.createElement(_inlineButton2.default, {
	              label: isReordering ? "Finish re-ordering" : _react2.default.createElement(
	                "span",
	                { style: { position: "relative", paddingLeft: 14 } },
	                _react2.default.createElement(
	                  "svg",
	                  {
	                    viewBox: "0 0 24 24",
	                    fill: "currentColor",
	                    width: 12,
	                    height: 12,
	                    style: {
	                      position: "absolute",
	                      left: 0,
	                      top: 1
	                    }
	                  },
	                  _react2.default.createElement("path", { d: "M0 0h24v24H0z", fill: "none" }),
	                  _react2.default.createElement("path", { d: "M3 15h18v-2H3v2zm0 4h18v-2H3v2zm0-8h18V9H3v2zm0-6v2h18V5H3z" })
	                ),
	                "Adjust order"
	              ),
	              onClick: function onClick() {
	                _this3.setState({ isReordering: !isReordering });
	              }
	            }) : null
	          ) : null
	        ) : null,
	        _react2.default.createElement(
	          _reactBeautifulDnd.DragDropContext,
	          {
	            onDragStart: this.onDragStart,
	            onDragEnd: this.onDragEnd
	          },
	          _react2.default.createElement(
	            "div",
	            {
	              style: {
	                position: "relative",
	                height: isReordering ? reorderingHeight : null
	              }
	            },
	            _react2.default.createElement(
	              _reactBeautifulDnd.Droppable,
	              { droppableId: "select-container", direction: "vertical" },
	              function (provided) {
	                return _react2.default.createElement(
	                  "div",
	                  _extends({
	                    className: isReordering ? "droppable" : "droppable-inactive",
	                    style: isReordering ? { height: "100%" } : undefined,
	                    ref: provided.innerRef
	                  }, provided.droppableProps),
	                  _react2.default.createElement(SelectComponent, _extends({
	                    autosize: true,
	                    multi: multi,
	                    openOnFocus: true,
	                    promptTextCreator: creatablePromptText,
	                    onNewOptionClick: onCreateSelect,
	                    showNewOptionAtTop: creatableShowNewOptionAtTop,
	                    placeholder: placeholderText || "None selected",
	                    noResultsText: noResultsText || "No results found",
	                    value: multi && !Array.isArray(value) ? [value] : value,
	                    options: allOptions,
	                    clearable: isReordering ? false : undefined,
	                    menuRenderer: isReordering ? function () {} : function (props) {
	                      var options = props.options.slice(0, /*50*/500);
	                      return (0, _reactSelect.defaultMenuRenderer)(_extends({}, props, {
	                        options: options
	                      }));
	                    },
	                    filterOption: labelToFilterString ? function (o, f) {
	                      return o.filterableLabel.indexOf(f.replace(/[^a-zA-Z0-9]/g, "").toLowerCase()) !== -1;
	                    } : undefined,
	                    ref: function ref(r) {
	                      _this3.select = r;
	                    },
	                    onChange: _this3.onValueChange,
	                    valueComponent: isReordering ? _this3.renderValue : undefined
	                  }, rest))
	                );
	              }
	            )
	          )
	        )
	      );
	    }
	  }], [{
	    key: "getStores",
	    value: function getStores() {
	      return [_PassBucketStore2.default, _EventStore2.default, _VenueStore2.default, _TagStore2.default, _CouponStore2.default, _ItemBucketStore2.default, _FilmStore2.default, _PassStore2.default, _EventBucketStore2.default, _SystemStatesStore2.default];
	    }
	  }, {
	    key: "getPropsFromStores",
	    value: function getPropsFromStores() {
	      return {
	        getPassBucketsForEventBucket: _PassBucketStore2.default.getPassBucketsForEventBucket,
	        getAllPassBuckets: _PassBucketStore2.default.getAllPassBuckets,
	        getMembershipsForEventBucket: _PassBucketStore2.default.getMembershipsForEventBucket,
	        getEventsForEventBucket: _EventStore2.default.getEventsForEventBucket,
	        getVenuesForEventBucket: _VenueStore2.default.getVenuesForEventBucket,
	        getTagsForEventBucket: _TagStore2.default.getTagsForEventBucket,
	        getCouponsForEventBucket: _CouponStore2.default.getCouponsForEventBucket,
	        getItemBucketsForEventBucket: _ItemBucketStore2.default.getItemBucketsForEventBucket,
	        getFilmsForEventBucket: _FilmStore2.default.getFilmsForEventBucket,
	        getPassesForEventBucket: _PassStore2.default.getPassesForEventBucket,
	        getPassMembershipsForEventBucket: _PassStore2.default.getMembershipsForEventBucket,
	        getEventBuckets: _EventBucketStore2.default.getEventBuckets,
	        isFetching: _PassBucketStore2.default.getState().isFetching || _EventStore2.default.getState().isFetching || _VenueStore2.default.getState().isFetching || _TagStore2.default.getState().isFetching || _CouponStore2.default.getState().isFetching || _ItemBucketStore2.default.getState().isFetching || _FilmStore2.default.getState().isFetching || _PassStore2.default.getState().isFetching || _EventBucketStore2.default.getState().isFetching
	      };
	    }
	  }]);
	
	  return InjectedSelect;
	}(_react2.default.Component);
	
	var _initialiseProps = function _initialiseProps() {
	  var _this4 = this;
	
	  this.renderValue = function (props) {
	    var children = props.children;
	    var option = props.value;
	    var values = props.values;
	
	    var index = (0, _findIndex2.default)(values, option);
	    return _react2.default.createElement(
	      _reactBeautifulDnd.Draggable,
	      {
	        draggableId: option.value,
	        type: "select-option",
	        index: index
	      },
	      function (provided) {
	        return _react2.default.createElement(
	          "div",
	          _extends({
	            ref: provided.innerRef
	          }, provided.draggableProps, provided.dragHandleProps, {
	            style: _extends({}, provided.draggableProps.style, {
	              position: "static",
	              padding: 2.5
	            })
	          }),
	          _react2.default.createElement(
	            "div",
	            { className: "Select-value" },
	            _react2.default.createElement(
	              "span",
	              {
	                className: "Select-value-icon",
	                "aria-hidden": "true",
	                onClick: _this4.onRemove(values, index)
	              },
	              "\xD7"
	            ),
	            _react2.default.createElement(
	              "span",
	              { className: "Select-value-label" },
	              children
	            )
	          )
	        );
	      }
	    );
	  };
	
	  this.onRemove = function (values, index) {
	    return function () {
	      values.splice(index, 1);
	      _this4.onValueChange(values);
	    };
	  };
	
	  this.onValueChange = function (selected) {
	    var _props3 = _this4.props;
	    var multi = _props3.multi;
	    var changeValueFunction = _props3.changeValueFunction;
	    var onChange = _props3.onChange;
	    // Custom changeValue processor (e.g. in order to get the entire object instead of just the ID)
	
	    if (changeValueFunction) {
	      if (multi) {
	        onChange(selected ? selected.map(function (s) {
	          return changeValueFunction(s.rawValue);
	        }) : []);
	      } else {
	        onChange(selected ? changeValueFunction(selected.rawValue) : null);
	      }
	
	      // Select multi
	    } else if (multi) {
	      onChange(selected ? selected.map(function (s) {
	        return s && s.value;
	      }) : []);
	
	      // Single item
	    } else {
	      onChange(selected ? selected.value : null);
	    }
	  };
	
	  this.onDragStart = function () {
	    _this4.setState({ reorderingHeight: _this4.select.control.offsetHeight });
	  };
	
	  this.onDragEnd = function (dropResult) {
	    _this4.setState({ reorderingHeight: null });
	    var destination = dropResult.destination;
	    var source = dropResult.source;
	
	    if (!destination || !source) {
	      return;
	    }
	    var destinationIndex = destination.index;
	    var sourceIndex = source.index;
	    var value = _this4.props.value;
	
	    var selected = !Array.isArray(value) ? [value] : value;
	    var temp = selected[sourceIndex];
	    selected.splice(sourceIndex, 1);
	    selected.splice(destinationIndex, 0, temp);
	    var options = _this4.getOptions();
	    _this4.onValueChange(selected.map(function (id) {
	      return options.find(function (option) {
	        return option.value === id;
	      });
	    }).filter(function (x) {
	      return !!x;
	    }));
	  };
	
	  this.getOptions = function () {
	    var _props4 = _this4.props;
	    var labelFormatter = _props4.labelFormatter;
	    var isDisabledFunction = _props4.isDisabledFunction;
	    var filterBy = _props4.filterBy;
	    var injectOptions = _props4.injectOptions;
	    var labelToFilterString = _props4.labelToFilterString;
	    var objects = _this4.state.objects;
	
	
	    return [].concat.apply([], Object.keys(objects).map(function (type) {
	      var formatter = typeof labelFormatter === "function" ? labelFormatter : labelFormatter[type];
	
	      return (injectOptions || []).concat(objects[type].filter(function (o) {
	        return filterBy ? filterBy(o) : true;
	      }).map(function (o) {
	        var disabled = isDisabledFunction && isDisabledFunction(o);
	        return {
	          label: formatter(o, disabled),
	          disabled: disabled,
	          value: o.id,
	          rawValue: o,
	          filterableLabel: labelToFilterString ? (labelToFilterString(o) || "").replace(/[^a-zA-Z0-9]/g, "").toLowerCase() : undefined
	        };
	      }));
	    }));
	  };
	};
	
	exports.default = (0, _connectToStores2.default)(InjectedSelect);
	module.exports = exports["default"];

/***/ }),
/* 1875 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _dragDropContext = __webpack_require__(1876);
	
	Object.defineProperty(exports, 'DragDropContext', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_dragDropContext).default;
	  }
	});
	
	var _droppable = __webpack_require__(1956);
	
	Object.defineProperty(exports, 'Droppable', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_droppable).default;
	  }
	});
	
	var _draggable = __webpack_require__(1992);
	
	Object.defineProperty(exports, 'Draggable', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_draggable).default;
	  }
	});
	Object.defineProperty(exports, 'resetServerContext', {
	  enumerable: true,
	  get: function get() {
	    return _dragDropContext.resetServerContext;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 1876 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _dragDropContext = __webpack_require__(1877);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_dragDropContext).default;
	  }
	});
	Object.defineProperty(exports, 'resetServerContext', {
	  enumerable: true,
	  get: function get() {
	    return _dragDropContext.resetServerContext;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 1877 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.resetServerContext = undefined;
	
	var _classCallCheck2 = __webpack_require__(1878);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(1879);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(1883);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _DragDropContext$chil;
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(956);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _createStore = __webpack_require__(1886);
	
	var _createStore2 = _interopRequireDefault(_createStore);
	
	var _hookCaller = __webpack_require__(1937);
	
	var _hookCaller2 = _interopRequireDefault(_hookCaller);
	
	var _dimensionMarshal = __webpack_require__(1939);
	
	var _dimensionMarshal2 = _interopRequireDefault(_dimensionMarshal);
	
	var _styleMarshal = __webpack_require__(1940);
	
	var _styleMarshal2 = _interopRequireDefault(_styleMarshal);
	
	var _canStartDrag = __webpack_require__(1943);
	
	var _canStartDrag2 = _interopRequireDefault(_canStartDrag);
	
	var _scrollWindow = __webpack_require__(1944);
	
	var _scrollWindow2 = _interopRequireDefault(_scrollWindow);
	
	var _announcer = __webpack_require__(1945);
	
	var _announcer2 = _interopRequireDefault(_announcer);
	
	var _autoScroller = __webpack_require__(1946);
	
	var _autoScroller2 = _interopRequireDefault(_autoScroller);
	
	var _contextKeys = __webpack_require__(1952);
	
	var _actionCreators = __webpack_require__(1953);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var resetServerContext = exports.resetServerContext = function resetServerContext() {
	  (0, _styleMarshal.resetStyleContext)();
	};
	
	var DragDropContext = function (_React$Component) {
	  (0, _inherits3.default)(DragDropContext, _React$Component);
	
	  function DragDropContext() {
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, DragDropContext);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.canLift = function (id) {
	      return (0, _canStartDrag2.default)(_this.store.getState(), id);
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  DragDropContext.prototype.getChildContext = function getChildContext() {
	    var _ref;
	
	    return _ref = {}, _ref[_contextKeys.storeKey] = this.store, _ref[_contextKeys.dimensionMarshalKey] = this.dimensionMarshal, _ref[_contextKeys.styleContextKey] = this.styleMarshal.styleContext, _ref[_contextKeys.canLiftContextKey] = this.canLift, _ref;
	  };
	
	  DragDropContext.prototype.componentWillMount = function componentWillMount() {
	    var _this2 = this;
	
	    this.store = (0, _createStore2.default)();
	
	    this.announcer = (0, _announcer2.default)();
	
	    this.hookCaller = (0, _hookCaller2.default)(this.announcer.announce);
	
	    this.styleMarshal = (0, _styleMarshal2.default)();
	
	    var callbacks = {
	      cancel: function cancel() {
	        _this2.store.dispatch((0, _actionCreators.clean)());
	      },
	      publishDraggable: function publishDraggable(dimension) {
	        _this2.store.dispatch((0, _actionCreators.publishDraggableDimension)(dimension));
	      },
	      publishDroppable: function publishDroppable(dimension) {
	        _this2.store.dispatch((0, _actionCreators.publishDroppableDimension)(dimension));
	      },
	      bulkPublish: function bulkPublish(droppables, draggables) {
	        _this2.store.dispatch((0, _actionCreators.bulkPublishDimensions)(droppables, draggables));
	      },
	      updateDroppableScroll: function updateDroppableScroll(id, newScroll) {
	        _this2.store.dispatch((0, _actionCreators.updateDroppableDimensionScroll)(id, newScroll));
	      },
	      updateDroppableIsEnabled: function updateDroppableIsEnabled(id, isEnabled) {
	        _this2.store.dispatch((0, _actionCreators.updateDroppableDimensionIsEnabled)(id, isEnabled));
	      }
	    };
	    this.dimensionMarshal = (0, _dimensionMarshal2.default)(callbacks);
	    this.autoScroller = (0, _autoScroller2.default)({
	      scrollWindow: _scrollWindow2.default,
	      scrollDroppable: this.dimensionMarshal.scrollDroppable,
	      move: function move(id, client, viewport, shouldAnimate) {
	        _this2.store.dispatch((0, _actionCreators.move)(id, client, viewport, shouldAnimate));
	      }
	    });
	
	    var previous = this.store.getState();
	
	    this.unsubscribe = this.store.subscribe(function () {
	      var current = _this2.store.getState();
	      var previousInThisExecution = previous;
	      var isPhaseChanging = current.phase !== previous.phase;
	
	      previous = current;
	
	      if (isPhaseChanging) {
	        _this2.styleMarshal.onPhaseChange(current);
	      }
	
	      var isDragEnding = previousInThisExecution.phase === 'DRAGGING' && current.phase !== 'DRAGGING';
	
	      if (isDragEnding) {
	        _this2.dimensionMarshal.onPhaseChange(current);
	      }
	
	      var hooks = {
	        onDragStart: _this2.props.onDragStart,
	        onDragEnd: _this2.props.onDragEnd,
	        onDragUpdate: _this2.props.onDragUpdate
	      };
	      _this2.hookCaller.onStateChange(hooks, previousInThisExecution, current);
	
	      if (isPhaseChanging && !isDragEnding) {
	        _this2.dimensionMarshal.onPhaseChange(current);
	      }
	
	      _this2.autoScroller.onStateChange(previousInThisExecution, current);
	    });
	  };
	
	  DragDropContext.prototype.componentDidMount = function componentDidMount() {
	    this.styleMarshal.mount();
	    this.announcer.mount();
	  };
	
	  DragDropContext.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.unsubscribe();
	    this.styleMarshal.unmount();
	    this.announcer.unmount();
	  };
	
	  DragDropContext.prototype.render = function render() {
	    return this.props.children;
	  };
	
	  return DragDropContext;
	}(_react2.default.Component);
	
	DragDropContext.childContextTypes = (_DragDropContext$chil = {}, _DragDropContext$chil[_contextKeys.storeKey] = _propTypes2.default.shape({
	  dispatch: _propTypes2.default.func.isRequired,
	  subscribe: _propTypes2.default.func.isRequired,
	  getState: _propTypes2.default.func.isRequired
	}).isRequired, _DragDropContext$chil[_contextKeys.dimensionMarshalKey] = _propTypes2.default.object.isRequired, _DragDropContext$chil[_contextKeys.styleContextKey] = _propTypes2.default.string.isRequired, _DragDropContext$chil[_contextKeys.canLiftContextKey] = _propTypes2.default.func.isRequired, _DragDropContext$chil);
	exports.default = DragDropContext;

/***/ }),
/* 1878 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	exports.default = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};

/***/ }),
/* 1879 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _typeof2 = __webpack_require__(1880);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }
	
	  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
	};

/***/ }),
/* 1880 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _iterator = __webpack_require__(1881);
	
	var _iterator2 = _interopRequireDefault(_iterator);
	
	var _symbol = __webpack_require__(1882);
	
	var _symbol2 = _interopRequireDefault(_symbol);
	
	var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
	  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
	} : function (obj) {
	  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
	};

/***/ }),
/* 1881 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1265), __esModule: true };

/***/ }),
/* 1882 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1294), __esModule: true };

/***/ }),
/* 1883 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _setPrototypeOf = __webpack_require__(1884);
	
	var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);
	
	var _create = __webpack_require__(1885);
	
	var _create2 = _interopRequireDefault(_create);
	
	var _typeof2 = __webpack_require__(1880);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
	  }
	
	  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      enumerable: false,
	      writable: true,
	      configurable: true
	    }
	  });
	  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
	};

/***/ }),
/* 1884 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1311), __esModule: true };

/***/ }),
/* 1885 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1315), __esModule: true };

/***/ }),
/* 1886 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof2 = __webpack_require__(1880);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _redux = __webpack_require__(1887);
	
	var _reduxThunk = __webpack_require__(1896);
	
	var _reduxThunk2 = _interopRequireDefault(_reduxThunk);
	
	var _reducer = __webpack_require__(1897);
	
	var _reducer2 = _interopRequireDefault(_reducer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var composeEnhancers = (typeof window === 'undefined' ? 'undefined' : (0, _typeof3.default)(window)) === 'object' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : _redux.compose;
	
	exports.default = function () {
	  return (0, _redux.createStore)(_reducer2.default, composeEnhancers((0, _redux.applyMiddleware)(_reduxThunk2.default)));
	};

/***/ }),
/* 1887 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.compose = exports.applyMiddleware = exports.bindActionCreators = exports.combineReducers = exports.createStore = undefined;
	
	var _createStore = __webpack_require__(1888);
	
	var _createStore2 = _interopRequireDefault(_createStore);
	
	var _combineReducers = __webpack_require__(1891);
	
	var _combineReducers2 = _interopRequireDefault(_combineReducers);
	
	var _bindActionCreators = __webpack_require__(1893);
	
	var _bindActionCreators2 = _interopRequireDefault(_bindActionCreators);
	
	var _applyMiddleware = __webpack_require__(1894);
	
	var _applyMiddleware2 = _interopRequireDefault(_applyMiddleware);
	
	var _compose = __webpack_require__(1895);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	var _warning = __webpack_require__(1892);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/*
	* This is a dummy function to check if the function name has been altered by minification.
	* If the function has been minified and NODE_ENV !== 'production', warn the user.
	*/
	function isCrushed() {}
	
	if (false) {
	  (0, _warning2['default'])('You are currently using minified code outside of NODE_ENV === \'production\'. ' + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or DefinePlugin for webpack (http://stackoverflow.com/questions/30030031) ' + 'to ensure you have the correct code for your production build.');
	}
	
	exports.createStore = _createStore2['default'];
	exports.combineReducers = _combineReducers2['default'];
	exports.bindActionCreators = _bindActionCreators2['default'];
	exports.applyMiddleware = _applyMiddleware2['default'];
	exports.compose = _compose2['default'];

/***/ }),
/* 1888 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.ActionTypes = undefined;
	exports['default'] = createStore;
	
	var _isPlainObject = __webpack_require__(795);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _symbolObservable = __webpack_require__(1889);
	
	var _symbolObservable2 = _interopRequireDefault(_symbolObservable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * These are private action types reserved by Redux.
	 * For any unknown actions, you must return the current state.
	 * If the current state is undefined, you must return the initial state.
	 * Do not reference these action types directly in your code.
	 */
	var ActionTypes = exports.ActionTypes = {
	  INIT: '@@redux/INIT'
	
	  /**
	   * Creates a Redux store that holds the state tree.
	   * The only way to change the data in the store is to call `dispatch()` on it.
	   *
	   * There should only be a single store in your app. To specify how different
	   * parts of the state tree respond to actions, you may combine several reducers
	   * into a single reducer function by using `combineReducers`.
	   *
	   * @param {Function} reducer A function that returns the next state tree, given
	   * the current state tree and the action to handle.
	   *
	   * @param {any} [preloadedState] The initial state. You may optionally specify it
	   * to hydrate the state from the server in universal apps, or to restore a
	   * previously serialized user session.
	   * If you use `combineReducers` to produce the root reducer function, this must be
	   * an object with the same shape as `combineReducers` keys.
	   *
	   * @param {Function} [enhancer] The store enhancer. You may optionally specify it
	   * to enhance the store with third-party capabilities such as middleware,
	   * time travel, persistence, etc. The only store enhancer that ships with Redux
	   * is `applyMiddleware()`.
	   *
	   * @returns {Store} A Redux store that lets you read the state, dispatch actions
	   * and subscribe to changes.
	   */
	};function createStore(reducer, preloadedState, enhancer) {
	  var _ref2;
	
	  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
	    enhancer = preloadedState;
	    preloadedState = undefined;
	  }
	
	  if (typeof enhancer !== 'undefined') {
	    if (typeof enhancer !== 'function') {
	      throw new Error('Expected the enhancer to be a function.');
	    }
	
	    return enhancer(createStore)(reducer, preloadedState);
	  }
	
	  if (typeof reducer !== 'function') {
	    throw new Error('Expected the reducer to be a function.');
	  }
	
	  var currentReducer = reducer;
	  var currentState = preloadedState;
	  var currentListeners = [];
	  var nextListeners = currentListeners;
	  var isDispatching = false;
	
	  function ensureCanMutateNextListeners() {
	    if (nextListeners === currentListeners) {
	      nextListeners = currentListeners.slice();
	    }
	  }
	
	  /**
	   * Reads the state tree managed by the store.
	   *
	   * @returns {any} The current state tree of your application.
	   */
	  function getState() {
	    return currentState;
	  }
	
	  /**
	   * Adds a change listener. It will be called any time an action is dispatched,
	   * and some part of the state tree may potentially have changed. You may then
	   * call `getState()` to read the current state tree inside the callback.
	   *
	   * You may call `dispatch()` from a change listener, with the following
	   * caveats:
	   *
	   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
	   * If you subscribe or unsubscribe while the listeners are being invoked, this
	   * will not have any effect on the `dispatch()` that is currently in progress.
	   * However, the next `dispatch()` call, whether nested or not, will use a more
	   * recent snapshot of the subscription list.
	   *
	   * 2. The listener should not expect to see all state changes, as the state
	   * might have been updated multiple times during a nested `dispatch()` before
	   * the listener is called. It is, however, guaranteed that all subscribers
	   * registered before the `dispatch()` started will be called with the latest
	   * state by the time it exits.
	   *
	   * @param {Function} listener A callback to be invoked on every dispatch.
	   * @returns {Function} A function to remove this change listener.
	   */
	  function subscribe(listener) {
	    if (typeof listener !== 'function') {
	      throw new Error('Expected listener to be a function.');
	    }
	
	    var isSubscribed = true;
	
	    ensureCanMutateNextListeners();
	    nextListeners.push(listener);
	
	    return function unsubscribe() {
	      if (!isSubscribed) {
	        return;
	      }
	
	      isSubscribed = false;
	
	      ensureCanMutateNextListeners();
	      var index = nextListeners.indexOf(listener);
	      nextListeners.splice(index, 1);
	    };
	  }
	
	  /**
	   * Dispatches an action. It is the only way to trigger a state change.
	   *
	   * The `reducer` function, used to create the store, will be called with the
	   * current state tree and the given `action`. Its return value will
	   * be considered the **next** state of the tree, and the change listeners
	   * will be notified.
	   *
	   * The base implementation only supports plain object actions. If you want to
	   * dispatch a Promise, an Observable, a thunk, or something else, you need to
	   * wrap your store creating function into the corresponding middleware. For
	   * example, see the documentation for the `redux-thunk` package. Even the
	   * middleware will eventually dispatch plain object actions using this method.
	   *
	   * @param {Object} action A plain object representing “what changed”. It is
	   * a good idea to keep actions serializable so you can record and replay user
	   * sessions, or use the time travelling `redux-devtools`. An action must have
	   * a `type` property which may not be `undefined`. It is a good idea to use
	   * string constants for action types.
	   *
	   * @returns {Object} For convenience, the same action object you dispatched.
	   *
	   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
	   * return something else (for example, a Promise you can await).
	   */
	  function dispatch(action) {
	    if (!(0, _isPlainObject2['default'])(action)) {
	      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
	    }
	
	    if (typeof action.type === 'undefined') {
	      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
	    }
	
	    if (isDispatching) {
	      throw new Error('Reducers may not dispatch actions.');
	    }
	
	    try {
	      isDispatching = true;
	      currentState = currentReducer(currentState, action);
	    } finally {
	      isDispatching = false;
	    }
	
	    var listeners = currentListeners = nextListeners;
	    for (var i = 0; i < listeners.length; i++) {
	      var listener = listeners[i];
	      listener();
	    }
	
	    return action;
	  }
	
	  /**
	   * Replaces the reducer currently used by the store to calculate the state.
	   *
	   * You might need this if your app implements code splitting and you want to
	   * load some of the reducers dynamically. You might also need this if you
	   * implement a hot reloading mechanism for Redux.
	   *
	   * @param {Function} nextReducer The reducer for the store to use instead.
	   * @returns {void}
	   */
	  function replaceReducer(nextReducer) {
	    if (typeof nextReducer !== 'function') {
	      throw new Error('Expected the nextReducer to be a function.');
	    }
	
	    currentReducer = nextReducer;
	    dispatch({ type: ActionTypes.INIT });
	  }
	
	  /**
	   * Interoperability point for observable/reactive libraries.
	   * @returns {observable} A minimal observable of state changes.
	   * For more information, see the observable proposal:
	   * https://github.com/tc39/proposal-observable
	   */
	  function observable() {
	    var _ref;
	
	    var outerSubscribe = subscribe;
	    return _ref = {
	      /**
	       * The minimal observable subscription method.
	       * @param {Object} observer Any object that can be used as an observer.
	       * The observer object should have a `next` method.
	       * @returns {subscription} An object with an `unsubscribe` method that can
	       * be used to unsubscribe the observable from the store, and prevent further
	       * emission of values from the observable.
	       */
	      subscribe: function subscribe(observer) {
	        if (typeof observer !== 'object') {
	          throw new TypeError('Expected the observer to be an object.');
	        }
	
	        function observeState() {
	          if (observer.next) {
	            observer.next(getState());
	          }
	        }
	
	        observeState();
	        var unsubscribe = outerSubscribe(observeState);
	        return { unsubscribe: unsubscribe };
	      }
	    }, _ref[_symbolObservable2['default']] = function () {
	      return this;
	    }, _ref;
	  }
	
	  // When a store is created, an "INIT" action is dispatched so that every
	  // reducer returns their initial state. This effectively populates
	  // the initial state tree.
	  dispatch({ type: ActionTypes.INIT });
	
	  return _ref2 = {
	    dispatch: dispatch,
	    subscribe: subscribe,
	    getState: getState,
	    replaceReducer: replaceReducer
	  }, _ref2[_symbolObservable2['default']] = observable, _ref2;
	}

/***/ }),
/* 1889 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, module) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ponyfill = __webpack_require__(1890);
	
	var _ponyfill2 = _interopRequireDefault(_ponyfill);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var root; /* global window */
	
	
	if (typeof self !== 'undefined') {
	  root = self;
	} else if (typeof window !== 'undefined') {
	  root = window;
	} else if (typeof global !== 'undefined') {
	  root = global;
	} else if (true) {
	  root = module;
	} else {
	  root = Function('return this')();
	}
	
	var result = (0, _ponyfill2['default'])(root);
	exports['default'] = result;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(485)(module)))

/***/ }),
/* 1890 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports['default'] = symbolObservablePonyfill;
	function symbolObservablePonyfill(root) {
		var result;
		var _Symbol = root.Symbol;
	
		if (typeof _Symbol === 'function') {
			if (_Symbol.observable) {
				result = _Symbol.observable;
			} else {
				result = _Symbol('observable');
				_Symbol.observable = result;
			}
		} else {
			result = '@@observable';
		}
	
		return result;
	};

/***/ }),
/* 1891 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = combineReducers;
	
	var _createStore = __webpack_require__(1888);
	
	var _isPlainObject = __webpack_require__(795);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _warning = __webpack_require__(1892);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function getUndefinedStateErrorMessage(key, action) {
	  var actionType = action && action.type;
	  var actionName = actionType && '"' + actionType.toString() + '"' || 'an action';
	
	  return 'Given action ' + actionName + ', reducer "' + key + '" returned undefined. ' + 'To ignore an action, you must explicitly return the previous state. ' + 'If you want this reducer to hold no value, you can return null instead of undefined.';
	}
	
	function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
	  var reducerKeys = Object.keys(reducers);
	  var argumentName = action && action.type === _createStore.ActionTypes.INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';
	
	  if (reducerKeys.length === 0) {
	    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
	  }
	
	  if (!(0, _isPlainObject2['default'])(inputState)) {
	    return 'The ' + argumentName + ' has unexpected type of "' + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
	  }
	
	  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
	    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
	  });
	
	  unexpectedKeys.forEach(function (key) {
	    unexpectedKeyCache[key] = true;
	  });
	
	  if (unexpectedKeys.length > 0) {
	    return 'Unexpected ' + (unexpectedKeys.length > 1 ? 'keys' : 'key') + ' ' + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + '. ') + 'Expected to find one of the known reducer keys instead: ' + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
	  }
	}
	
	function assertReducerShape(reducers) {
	  Object.keys(reducers).forEach(function (key) {
	    var reducer = reducers[key];
	    var initialState = reducer(undefined, { type: _createStore.ActionTypes.INIT });
	
	    if (typeof initialState === 'undefined') {
	      throw new Error('Reducer "' + key + '" returned undefined during initialization. ' + 'If the state passed to the reducer is undefined, you must ' + 'explicitly return the initial state. The initial state may ' + 'not be undefined. If you don\'t want to set a value for this reducer, ' + 'you can use null instead of undefined.');
	    }
	
	    var type = '@@redux/PROBE_UNKNOWN_ACTION_' + Math.random().toString(36).substring(7).split('').join('.');
	    if (typeof reducer(undefined, { type: type }) === 'undefined') {
	      throw new Error('Reducer "' + key + '" returned undefined when probed with a random type. ' + ('Don\'t try to handle ' + _createStore.ActionTypes.INIT + ' or other actions in "redux/*" ') + 'namespace. They are considered private. Instead, you must return the ' + 'current state for any unknown actions, unless it is undefined, ' + 'in which case you must return the initial state, regardless of the ' + 'action type. The initial state may not be undefined, but can be null.');
	    }
	  });
	}
	
	/**
	 * Turns an object whose values are different reducer functions, into a single
	 * reducer function. It will call every child reducer, and gather their results
	 * into a single state object, whose keys correspond to the keys of the passed
	 * reducer functions.
	 *
	 * @param {Object} reducers An object whose values correspond to different
	 * reducer functions that need to be combined into one. One handy way to obtain
	 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
	 * undefined for any action. Instead, they should return their initial state
	 * if the state passed to them was undefined, and the current state for any
	 * unrecognized action.
	 *
	 * @returns {Function} A reducer function that invokes every reducer inside the
	 * passed object, and builds a state object with the same shape.
	 */
	function combineReducers(reducers) {
	  var reducerKeys = Object.keys(reducers);
	  var finalReducers = {};
	  for (var i = 0; i < reducerKeys.length; i++) {
	    var key = reducerKeys[i];
	
	    if (false) {
	      if (typeof reducers[key] === 'undefined') {
	        (0, _warning2['default'])('No reducer provided for key "' + key + '"');
	      }
	    }
	
	    if (typeof reducers[key] === 'function') {
	      finalReducers[key] = reducers[key];
	    }
	  }
	  var finalReducerKeys = Object.keys(finalReducers);
	
	  var unexpectedKeyCache = void 0;
	  if (false) {
	    unexpectedKeyCache = {};
	  }
	
	  var shapeAssertionError = void 0;
	  try {
	    assertReducerShape(finalReducers);
	  } catch (e) {
	    shapeAssertionError = e;
	  }
	
	  return function combination() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var action = arguments[1];
	
	    if (shapeAssertionError) {
	      throw shapeAssertionError;
	    }
	
	    if (false) {
	      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);
	      if (warningMessage) {
	        (0, _warning2['default'])(warningMessage);
	      }
	    }
	
	    var hasChanged = false;
	    var nextState = {};
	    for (var _i = 0; _i < finalReducerKeys.length; _i++) {
	      var _key = finalReducerKeys[_i];
	      var reducer = finalReducers[_key];
	      var previousStateForKey = state[_key];
	      var nextStateForKey = reducer(previousStateForKey, action);
	      if (typeof nextStateForKey === 'undefined') {
	        var errorMessage = getUndefinedStateErrorMessage(_key, action);
	        throw new Error(errorMessage);
	      }
	      nextState[_key] = nextStateForKey;
	      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
	    }
	    return hasChanged ? nextState : state;
	  };
	}

/***/ }),
/* 1892 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = warning;
	/**
	 * Prints a warning in the console if it exists.
	 *
	 * @param {String} message The warning message.
	 * @returns {void}
	 */
	function warning(message) {
	  /* eslint-disable no-console */
	  if (typeof console !== 'undefined' && typeof console.error === 'function') {
	    console.error(message);
	  }
	  /* eslint-enable no-console */
	  try {
	    // This error was thrown as a convenience so that if you enable
	    // "break on all exceptions" in your console,
	    // it would pause the execution at this line.
	    throw new Error(message);
	    /* eslint-disable no-empty */
	  } catch (e) {}
	  /* eslint-enable no-empty */
	}

/***/ }),
/* 1893 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = bindActionCreators;
	function bindActionCreator(actionCreator, dispatch) {
	  return function () {
	    return dispatch(actionCreator.apply(undefined, arguments));
	  };
	}
	
	/**
	 * Turns an object whose values are action creators, into an object with the
	 * same keys, but with every function wrapped into a `dispatch` call so they
	 * may be invoked directly. This is just a convenience method, as you can call
	 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
	 *
	 * For convenience, you can also pass a single function as the first argument,
	 * and get a function in return.
	 *
	 * @param {Function|Object} actionCreators An object whose values are action
	 * creator functions. One handy way to obtain it is to use ES6 `import * as`
	 * syntax. You may also pass a single function.
	 *
	 * @param {Function} dispatch The `dispatch` function available on your Redux
	 * store.
	 *
	 * @returns {Function|Object} The object mimicking the original object, but with
	 * every action creator wrapped into the `dispatch` call. If you passed a
	 * function as `actionCreators`, the return value will also be a single
	 * function.
	 */
	function bindActionCreators(actionCreators, dispatch) {
	  if (typeof actionCreators === 'function') {
	    return bindActionCreator(actionCreators, dispatch);
	  }
	
	  if (typeof actionCreators !== 'object' || actionCreators === null) {
	    throw new Error('bindActionCreators expected an object or a function, instead received ' + (actionCreators === null ? 'null' : typeof actionCreators) + '. ' + 'Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');
	  }
	
	  var keys = Object.keys(actionCreators);
	  var boundActionCreators = {};
	  for (var i = 0; i < keys.length; i++) {
	    var key = keys[i];
	    var actionCreator = actionCreators[key];
	    if (typeof actionCreator === 'function') {
	      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
	    }
	  }
	  return boundActionCreators;
	}

/***/ }),
/* 1894 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports['default'] = applyMiddleware;
	
	var _compose = __webpack_require__(1895);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * Creates a store enhancer that applies middleware to the dispatch method
	 * of the Redux store. This is handy for a variety of tasks, such as expressing
	 * asynchronous actions in a concise manner, or logging every action payload.
	 *
	 * See `redux-thunk` package as an example of the Redux middleware.
	 *
	 * Because middleware is potentially asynchronous, this should be the first
	 * store enhancer in the composition chain.
	 *
	 * Note that each middleware will be given the `dispatch` and `getState` functions
	 * as named arguments.
	 *
	 * @param {...Function} middlewares The middleware chain to be applied.
	 * @returns {Function} A store enhancer applying the middleware.
	 */
	function applyMiddleware() {
	  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
	    middlewares[_key] = arguments[_key];
	  }
	
	  return function (createStore) {
	    return function (reducer, preloadedState, enhancer) {
	      var store = createStore(reducer, preloadedState, enhancer);
	      var _dispatch = store.dispatch;
	      var chain = [];
	
	      var middlewareAPI = {
	        getState: store.getState,
	        dispatch: function dispatch(action) {
	          return _dispatch(action);
	        }
	      };
	      chain = middlewares.map(function (middleware) {
	        return middleware(middlewareAPI);
	      });
	      _dispatch = _compose2['default'].apply(undefined, chain)(store.dispatch);
	
	      return _extends({}, store, {
	        dispatch: _dispatch
	      });
	    };
	  };
	}

/***/ }),
/* 1895 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = compose;
	/**
	 * Composes single-argument functions from right to left. The rightmost
	 * function can take multiple arguments as it provides the signature for
	 * the resulting composite function.
	 *
	 * @param {...Function} funcs The functions to compose.
	 * @returns {Function} A function obtained by composing the argument functions
	 * from right to left. For example, compose(f, g, h) is identical to doing
	 * (...args) => f(g(h(...args))).
	 */
	
	function compose() {
	  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
	    funcs[_key] = arguments[_key];
	  }
	
	  if (funcs.length === 0) {
	    return function (arg) {
	      return arg;
	    };
	  }
	
	  if (funcs.length === 1) {
	    return funcs[0];
	  }
	
	  return funcs.reduce(function (a, b) {
	    return function () {
	      return a(b.apply(undefined, arguments));
	    };
	  });
	}

/***/ }),
/* 1896 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	function createThunkMiddleware(extraArgument) {
	  return function (_ref) {
	    var dispatch = _ref.dispatch,
	        getState = _ref.getState;
	    return function (next) {
	      return function (action) {
	        if (typeof action === 'function') {
	          return action(dispatch, getState, extraArgument);
	        }
	
	        return next(action);
	      };
	    };
	  };
	}
	
	var thunk = createThunkMiddleware();
	thunk.withExtraArgument = createThunkMiddleware;
	
	exports['default'] = thunk;

/***/ }),
/* 1897 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(1898);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _extends6 = __webpack_require__(1901);
	
	var _extends7 = _interopRequireDefault(_extends6);
	
	var _memoizeOne = __webpack_require__(1903);
	
	var _memoizeOne2 = _interopRequireDefault(_memoizeOne);
	
	var _position = __webpack_require__(1904);
	
	var _noImpact = __webpack_require__(1905);
	
	var _getDragImpact = __webpack_require__(1906);
	
	var _getDragImpact2 = _interopRequireDefault(_getDragImpact);
	
	var _moveToNextIndex = __webpack_require__(1924);
	
	var _moveToNextIndex2 = _interopRequireDefault(_moveToNextIndex);
	
	var _moveCrossAxis = __webpack_require__(1931);
	
	var _moveCrossAxis2 = _interopRequireDefault(_moveCrossAxis);
	
	var _dimension3 = __webpack_require__(1913);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var noDimensions = {
	  request: null,
	  draggable: {},
	  droppable: {}
	};
	
	var origin = { x: 0, y: 0 };
	
	var clean = (0, _memoizeOne2.default)(function () {
	  var phase = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'IDLE';
	  return {
	    phase: phase,
	    drag: null,
	    drop: null,
	    dimension: noDimensions
	  };
	});
	
	var canPublishDimension = function canPublishDimension(phase) {
	  return ['IDLE', 'DROP_ANIMATING', 'DROP_COMPLETE'].indexOf(phase) === -1;
	};
	
	var move = function move(_ref) {
	  var state = _ref.state,
	      clientSelection = _ref.clientSelection,
	      shouldAnimate = _ref.shouldAnimate,
	      proposedViewport = _ref.viewport,
	      impact = _ref.impact,
	      scrollJumpRequest = _ref.scrollJumpRequest;
	
	  if (state.phase !== 'DRAGGING') {
	    console.error('cannot move while not dragging');
	    return clean();
	  }
	
	  var last = state.drag;
	
	  if (last == null) {
	    console.error('cannot move if there is no drag information');
	    return clean();
	  }
	
	  var previous = last.current;
	  var initial = last.initial;
	  var viewport = proposedViewport || previous.viewport;
	  var currentWindowScroll = viewport.scroll;
	
	  var client = function () {
	    var offset = (0, _position.subtract)(clientSelection, initial.client.selection);
	
	    var result = {
	      offset: offset,
	      selection: clientSelection,
	      center: (0, _position.add)(offset, initial.client.center)
	    };
	    return result;
	  }();
	
	  var page = {
	    selection: (0, _position.add)(client.selection, currentWindowScroll),
	    offset: (0, _position.add)(client.offset, currentWindowScroll),
	    center: (0, _position.add)(client.center, currentWindowScroll)
	  };
	
	  var current = {
	    client: client,
	    page: page,
	    shouldAnimate: shouldAnimate,
	    viewport: viewport,
	    hasCompletedFirstBulkPublish: previous.hasCompletedFirstBulkPublish
	  };
	
	  var newImpact = impact || (0, _getDragImpact2.default)({
	    pageCenter: page.center,
	    draggable: state.dimension.draggable[initial.descriptor.id],
	    draggables: state.dimension.draggable,
	    droppables: state.dimension.droppable,
	    previousImpact: last.impact,
	    viewport: viewport
	  });
	
	  var drag = {
	    initial: initial,
	    impact: newImpact,
	    current: current,
	    scrollJumpRequest: scrollJumpRequest
	  };
	
	  return (0, _extends7.default)({}, state, {
	    drag: drag
	  });
	};
	
	var updateStateAfterDimensionChange = function updateStateAfterDimensionChange(newState, impact) {
	  if (newState.phase === 'COLLECTING_INITIAL_DIMENSIONS') {
	    return newState;
	  }
	
	  if (newState.phase !== 'DRAGGING') {
	    return newState;
	  }
	
	  if (!newState.drag) {
	    console.error('cannot update a draggable dimension in an existing drag as there is invalid drag state');
	    return clean();
	  }
	
	  return move({
	    state: newState,
	
	    clientSelection: newState.drag.current.client.selection,
	    shouldAnimate: newState.drag.current.shouldAnimate,
	    impact: impact
	  });
	};
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : clean('IDLE');
	  var action = arguments[1];
	
	  if (action.type === 'CLEAN') {
	    return clean();
	  }
	
	  if (action.type === 'PREPARE') {
	    return clean('PREPARING');
	  }
	
	  if (action.type === 'REQUEST_DIMENSIONS') {
	    if (state.phase !== 'PREPARING') {
	      console.error('trying to start a lift while not preparing for a lift');
	      return clean();
	    }
	
	    var request = action.payload;
	
	    return {
	      phase: 'COLLECTING_INITIAL_DIMENSIONS',
	      drag: null,
	      drop: null,
	      dimension: {
	        request: request,
	        draggable: {},
	        droppable: {}
	      }
	    };
	  }
	
	  if (action.type === 'PUBLISH_DRAGGABLE_DIMENSION') {
	    var _extends2;
	
	    var dimension = action.payload;
	
	    if (!canPublishDimension(state.phase)) {
	      console.warn('dimensions rejected as no longer allowing dimension capture in phase', state.phase);
	      return state;
	    }
	
	    var newState = (0, _extends7.default)({}, state, {
	      dimension: {
	        request: state.dimension.request,
	        droppable: state.dimension.droppable,
	        draggable: (0, _extends7.default)({}, state.dimension.draggable, (_extends2 = {}, _extends2[dimension.descriptor.id] = dimension, _extends2))
	      }
	    });
	
	    return updateStateAfterDimensionChange(newState);
	  }
	
	  if (action.type === 'PUBLISH_DROPPABLE_DIMENSION') {
	    var _extends3;
	
	    var _dimension = action.payload;
	
	    if (!canPublishDimension(state.phase)) {
	      console.warn('dimensions rejected as no longer allowing dimension capture in phase', state.phase);
	      return state;
	    }
	
	    var _newState = (0, _extends7.default)({}, state, {
	      dimension: {
	        request: state.dimension.request,
	        draggable: state.dimension.draggable,
	        droppable: (0, _extends7.default)({}, state.dimension.droppable, (_extends3 = {}, _extends3[_dimension.descriptor.id] = _dimension, _extends3))
	      }
	    });
	
	    return updateStateAfterDimensionChange(_newState);
	  }
	
	  if (action.type === 'BULK_DIMENSION_PUBLISH') {
	    var draggables = action.payload.draggables;
	    var droppables = action.payload.droppables;
	
	    if (!canPublishDimension(state.phase)) {
	      console.warn('dimensions rejected as no longer allowing dimension capture in phase', state.phase);
	      return state;
	    }
	
	    var newDraggables = draggables.reduce(function (previous, current) {
	      previous[current.descriptor.id] = current;
	      return previous;
	    }, {});
	
	    var newDroppables = droppables.reduce(function (previous, current) {
	      previous[current.descriptor.id] = current;
	      return previous;
	    }, {});
	
	    var drag = function () {
	      var existing = state.drag;
	      if (!existing) {
	        return null;
	      }
	
	      if (existing.current.hasCompletedFirstBulkPublish) {
	        return existing;
	      }
	
	      var newDrag = (0, _extends7.default)({}, existing, {
	        current: (0, _extends7.default)({}, existing.current, {
	          hasCompletedFirstBulkPublish: true
	        })
	      });
	
	      return newDrag;
	    }();
	
	    var _newState2 = (0, _extends7.default)({}, state, {
	      drag: drag,
	      dimension: {
	        request: state.dimension.request,
	        draggable: (0, _extends7.default)({}, state.dimension.draggable, newDraggables),
	        droppable: (0, _extends7.default)({}, state.dimension.droppable, newDroppables)
	      }
	    });
	
	    return updateStateAfterDimensionChange(_newState2);
	  }
	
	  if (action.type === 'COMPLETE_LIFT') {
	    if (state.phase !== 'COLLECTING_INITIAL_DIMENSIONS') {
	      console.error('trying complete lift without collecting dimensions');
	      return state;
	    }
	
	    var _action$payload = action.payload,
	        id = _action$payload.id,
	        client = _action$payload.client,
	        _viewport = _action$payload.viewport,
	        autoScrollMode = _action$payload.autoScrollMode;
	
	    var page = {
	      selection: (0, _position.add)(client.selection, _viewport.scroll),
	      center: (0, _position.add)(client.center, _viewport.scroll)
	    };
	
	    var draggable = state.dimension.draggable[id];
	
	    if (!draggable) {
	      console.error('could not find draggable in store after lift');
	      return clean();
	    }
	
	    var descriptor = draggable.descriptor;
	
	    var initial = {
	      descriptor: descriptor,
	      autoScrollMode: autoScrollMode,
	      client: client,
	      page: page,
	      viewport: _viewport
	    };
	
	    var current = {
	      client: {
	        selection: client.selection,
	        center: client.center,
	        offset: origin
	      },
	      page: {
	        selection: page.selection,
	        center: page.center,
	        offset: origin
	      },
	      viewport: _viewport,
	      hasCompletedFirstBulkPublish: false,
	      shouldAnimate: false
	    };
	
	    var home = state.dimension.droppable[descriptor.droppableId];
	
	    if (!home) {
	      console.error('Cannot find home dimension for initial lift');
	      return clean();
	    }
	
	    var destination = {
	      index: descriptor.index,
	      droppableId: descriptor.droppableId
	    };
	
	    var _impact = {
	      movement: _noImpact.noMovement,
	      direction: home.axis.direction,
	      destination: destination
	    };
	
	    return (0, _extends7.default)({}, state, {
	      phase: 'DRAGGING',
	      drag: {
	        initial: initial,
	        current: current,
	        impact: _impact,
	        scrollJumpRequest: null
	      }
	    });
	  }
	
	  if (action.type === 'UPDATE_DROPPABLE_DIMENSION_SCROLL') {
	    var _extends4;
	
	    if (state.phase !== 'DRAGGING') {
	      console.error('cannot update a droppable dimensions scroll when not dragging');
	      return clean();
	    }
	
	    var _drag = state.drag;
	
	    if (_drag == null) {
	      console.error('invalid store state');
	      return clean();
	    }
	
	    var _action$payload2 = action.payload,
	        _id = _action$payload2.id,
	        offset = _action$payload2.offset;
	
	
	    var target = state.dimension.droppable[_id];
	
	    if (!target) {
	      console.warn('cannot update scroll for droppable as it has not yet been collected');
	      return state;
	    }
	
	    var _dimension2 = (0, _dimension3.scrollDroppable)(target, offset);
	
	    var _impact2 = _drag.initial.autoScrollMode === 'JUMP' ? _drag.impact : null;
	
	    var _newState3 = (0, _extends7.default)({}, state, {
	      dimension: {
	        request: state.dimension.request,
	        draggable: state.dimension.draggable,
	        droppable: (0, _extends7.default)({}, state.dimension.droppable, (_extends4 = {}, _extends4[_id] = _dimension2, _extends4))
	      }
	    });
	
	    return updateStateAfterDimensionChange(_newState3, _impact2);
	  }
	
	  if (action.type === 'UPDATE_DROPPABLE_DIMENSION_IS_ENABLED') {
	    var _extends5;
	
	    if (!(0, _keys2.default)(state.dimension.droppable).length) {
	      return state;
	    }
	
	    var _action$payload3 = action.payload,
	        _id2 = _action$payload3.id,
	        isEnabled = _action$payload3.isEnabled;
	
	    var _target = state.dimension.droppable[_id2];
	
	    if (!_target) {
	      console.warn('cannot update enabled state for droppable as it has not yet been collected');
	      return state;
	    }
	
	    if (_target.isEnabled === isEnabled) {
	      console.warn('trying to set droppable isEnabled to ' + String(isEnabled) + ' but it is already ' + String(isEnabled));
	      return state;
	    }
	
	    var updatedDroppableDimension = (0, _extends7.default)({}, _target, {
	      isEnabled: isEnabled
	    });
	
	    var result = (0, _extends7.default)({}, state, {
	      dimension: (0, _extends7.default)({}, state.dimension, {
	        droppable: (0, _extends7.default)({}, state.dimension.droppable, (_extends5 = {}, _extends5[_id2] = updatedDroppableDimension, _extends5))
	      })
	    });
	
	    return updateStateAfterDimensionChange(result);
	  }
	
	  if (action.type === 'MOVE') {
	    var _action$payload4 = action.payload,
	        _client = _action$payload4.client,
	        _viewport2 = _action$payload4.viewport,
	        _shouldAnimate = _action$payload4.shouldAnimate;
	
	    var _drag2 = state.drag;
	
	    if (!_drag2) {
	      console.error('Cannot move while there is no drag state');
	      return state;
	    }
	
	    var _impact3 = function () {
	      if (!_drag2.current.hasCompletedFirstBulkPublish) {
	        return _drag2.impact;
	      }
	
	      if (_drag2.initial.autoScrollMode === 'JUMP') {
	        return _drag2.impact;
	      }
	
	      return null;
	    }();
	
	    return move({
	      state: state,
	      clientSelection: _client,
	      viewport: _viewport2,
	      shouldAnimate: _shouldAnimate,
	      impact: _impact3
	    });
	  }
	
	  if (action.type === 'MOVE_BY_WINDOW_SCROLL') {
	    var _viewport3 = action.payload.viewport;
	
	    var _drag3 = state.drag;
	
	    if (!_drag3) {
	      console.error('cannot move with window scrolling if no current drag');
	      return clean();
	    }
	
	    if ((0, _position.isEqual)(_viewport3.scroll, _drag3.current.viewport.scroll)) {
	      return state;
	    }
	
	    var isJumpScrolling = _drag3.initial.autoScrollMode === 'JUMP';
	
	    var _impact4 = isJumpScrolling ? _drag3.impact : null;
	
	    return move({
	      state: state,
	      clientSelection: _drag3.current.client.selection,
	      viewport: _viewport3,
	      shouldAnimate: false,
	      impact: _impact4
	    });
	  }
	
	  if (action.type === 'MOVE_FORWARD' || action.type === 'MOVE_BACKWARD') {
	    if (state.phase !== 'DRAGGING') {
	      console.error('cannot move while not dragging', action);
	      return clean();
	    }
	
	    if (!state.drag) {
	      console.error('cannot move if there is no drag information');
	      return clean();
	    }
	
	    var existing = state.drag;
	    var isMovingForward = action.type === 'MOVE_FORWARD';
	
	    if (!existing.impact.destination) {
	      console.error('cannot move if there is no previous destination');
	      return clean();
	    }
	
	    var droppable = state.dimension.droppable[existing.impact.destination.droppableId];
	
	    var _result = (0, _moveToNextIndex2.default)({
	      isMovingForward: isMovingForward,
	      draggableId: existing.initial.descriptor.id,
	      droppable: droppable,
	      draggables: state.dimension.draggable,
	      previousPageCenter: existing.current.page.center,
	      previousImpact: existing.impact,
	      viewport: existing.current.viewport
	    });
	
	    if (!_result) {
	      return state;
	    }
	
	    var _impact5 = _result.impact;
	    var _page = _result.pageCenter;
	    var _client2 = (0, _position.subtract)(_page, existing.current.viewport.scroll);
	
	    return move({
	      state: state,
	      impact: _impact5,
	      clientSelection: _client2,
	      shouldAnimate: true,
	      scrollJumpRequest: _result.scrollJumpRequest
	    });
	  }
	
	  if (action.type === 'CROSS_AXIS_MOVE_FORWARD' || action.type === 'CROSS_AXIS_MOVE_BACKWARD') {
	    if (state.phase !== 'DRAGGING') {
	      console.error('cannot move cross axis when not dragging');
	      return clean();
	    }
	
	    if (!state.drag) {
	      console.error('cannot move cross axis if there is no drag information');
	      return clean();
	    }
	
	    if (!state.drag.impact.destination) {
	      console.error('cannot move cross axis if not in a droppable');
	      return clean();
	    }
	
	    var _current = state.drag.current;
	    var _descriptor = state.drag.initial.descriptor;
	    var draggableId = _descriptor.id;
	    var center = _current.page.center;
	    var droppableId = state.drag.impact.destination.droppableId;
	    var _home = {
	      index: _descriptor.index,
	      droppableId: _descriptor.droppableId
	    };
	
	    var _result2 = (0, _moveCrossAxis2.default)({
	      isMovingForward: action.type === 'CROSS_AXIS_MOVE_FORWARD',
	      pageCenter: center,
	      draggableId: draggableId,
	      droppableId: droppableId,
	      home: _home,
	      draggables: state.dimension.draggable,
	      droppables: state.dimension.droppable,
	      previousImpact: state.drag.impact,
	      viewport: _current.viewport
	    });
	
	    if (!_result2) {
	      return state;
	    }
	
	    var _page2 = _result2.pageCenter;
	    var _client3 = (0, _position.subtract)(_page2, _current.viewport.scroll);
	
	    return move({
	      state: state,
	      clientSelection: _client3,
	      impact: _result2.impact,
	      shouldAnimate: true
	    });
	  }
	
	  if (action.type === 'DROP_ANIMATE') {
	    var _action$payload5 = action.payload,
	        newHomeOffset = _action$payload5.newHomeOffset,
	        _impact6 = _action$payload5.impact,
	        _result3 = _action$payload5.result;
	
	
	    if (state.phase !== 'DRAGGING') {
	      console.error('cannot animate drop while not dragging', action);
	      return state;
	    }
	
	    if (!state.drag) {
	      console.error('cannot animate drop - invalid drag state');
	      return clean();
	    }
	
	    var pending = {
	      newHomeOffset: newHomeOffset,
	      result: _result3,
	      impact: _impact6
	    };
	
	    return {
	      phase: 'DROP_ANIMATING',
	      drag: null,
	      drop: {
	        pending: pending,
	        result: null
	      },
	      dimension: state.dimension
	    };
	  }
	
	  if (action.type === 'DROP_COMPLETE') {
	    var _result4 = action.payload;
	
	    return {
	      phase: 'DROP_COMPLETE',
	      drag: null,
	      drop: {
	        pending: null,
	        result: _result4
	      },
	      dimension: noDimensions
	    };
	  }
	
	  return state;
	};

/***/ }),
/* 1898 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1899), __esModule: true };

/***/ }),
/* 1899 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1900);
	module.exports = __webpack_require__(1244).Object.keys;

/***/ }),
/* 1900 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.14 Object.keys(O)
	var toObject = __webpack_require__(1234)
	  , $keys    = __webpack_require__(1276);
	
	__webpack_require__(1242)('keys', function(){
	  return function keys(it){
	    return $keys(toObject(it));
	  };
	});

/***/ }),
/* 1901 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _assign = __webpack_require__(1902);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _assign2.default || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	
	  return target;
	};

/***/ }),
/* 1902 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1318), __esModule: true };

/***/ }),
/* 1903 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (resultFn) {
	  var isEqual = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : simpleIsEqual;
	
	  var lastThis = void 0;
	  var lastArgs = [];
	  var lastResult = void 0;
	  var calledOnce = false;
	
	  var isNewArgEqualToLast = function isNewArgEqualToLast(newArg, index) {
	    return isEqual(newArg, lastArgs[index]);
	  };
	
	  var result = function result() {
	    for (var _len = arguments.length, newArgs = Array(_len), _key = 0; _key < _len; _key++) {
	      newArgs[_key] = arguments[_key];
	    }
	
	    if (calledOnce && lastThis === this && newArgs.length === lastArgs.length && newArgs.every(isNewArgEqualToLast)) {
	      return lastResult;
	    }
	
	    calledOnce = true;
	    lastThis = this;
	    lastArgs = newArgs;
	    lastResult = resultFn.apply(this, newArgs);
	    return lastResult;
	  };
	
	  return result;
	};
	
	var simpleIsEqual = function simpleIsEqual(a, b) {
	  return a === b;
	};

/***/ }),
/* 1904 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var add = exports.add = function add(point1, point2) {
	  return {
	    x: point1.x + point2.x,
	    y: point1.y + point2.y
	  };
	};
	
	var subtract = exports.subtract = function subtract(point1, point2) {
	  return {
	    x: point1.x - point2.x,
	    y: point1.y - point2.y
	  };
	};
	
	var isEqual = exports.isEqual = function isEqual(point1, point2) {
	  return point1.x === point2.x && point1.y === point2.y;
	};
	
	var negate = exports.negate = function negate(point) {
	  return {
	    x: point.x !== 0 ? -point.x : 0,
	    y: point.y !== 0 ? -point.y : 0
	  };
	};
	
	var absolute = exports.absolute = function absolute(point) {
	  return {
	    x: Math.abs(point.x),
	    y: Math.abs(point.y)
	  };
	};
	
	var patch = exports.patch = function patch(line, value) {
	  var _ref;
	
	  var otherValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
	  return _ref = {}, _ref[line] = value, _ref[line === 'x' ? 'y' : 'x'] = otherValue, _ref;
	};
	
	var distance = exports.distance = function distance(point1, point2) {
	  return Math.sqrt(Math.pow(point2.x - point1.x, 2) + Math.pow(point2.y - point1.y, 2));
	};
	
	var closest = exports.closest = function closest(target, points) {
	  return Math.min.apply(Math, points.map(function (point) {
	    return distance(target, point);
	  }));
	};
	
	var apply = exports.apply = function apply(fn) {
	  return function (point) {
	    return {
	      x: fn(point.x),
	      y: fn(point.y)
	    };
	  };
	};

/***/ }),
/* 1905 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	
	var origin = { x: 0, y: 0 };
	
	var noMovement = exports.noMovement = {
	  displaced: [],
	  amount: origin,
	  isBeyondStartPosition: false
	};
	
	var noImpact = {
	  movement: noMovement,
	  direction: null,
	  destination: null
	};
	
	exports.default = noImpact;

/***/ }),
/* 1906 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getDroppableOver = __webpack_require__(1907);
	
	var _getDroppableOver2 = _interopRequireDefault(_getDroppableOver);
	
	var _getDraggablesInsideDroppable = __webpack_require__(1909);
	
	var _getDraggablesInsideDroppable2 = _interopRequireDefault(_getDraggablesInsideDroppable);
	
	var _noImpact = __webpack_require__(1905);
	
	var _noImpact2 = _interopRequireDefault(_noImpact);
	
	var _inHomeList = __webpack_require__(1916);
	
	var _inHomeList2 = _interopRequireDefault(_inHomeList);
	
	var _inForeignList = __webpack_require__(1923);
	
	var _inForeignList2 = _interopRequireDefault(_inForeignList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	  var pageCenter = _ref.pageCenter,
	      draggable = _ref.draggable,
	      draggables = _ref.draggables,
	      droppables = _ref.droppables,
	      previousImpact = _ref.previousImpact,
	      viewport = _ref.viewport;
	
	  var previousDroppableOverId = previousImpact.destination && previousImpact.destination.droppableId;
	
	  var destinationId = (0, _getDroppableOver2.default)({
	    target: pageCenter,
	    draggable: draggable,
	    draggables: draggables,
	    droppables: droppables,
	    previousDroppableOverId: previousDroppableOverId
	  });
	
	  if (!destinationId) {
	    return _noImpact2.default;
	  }
	
	  var destination = droppables[destinationId];
	
	  if (!destination.isEnabled) {
	    return _noImpact2.default;
	  }
	
	  var home = droppables[draggable.descriptor.droppableId];
	  var isWithinHomeDroppable = home.descriptor.id === destinationId;
	  var insideDestination = (0, _getDraggablesInsideDroppable2.default)(destination, draggables);
	
	  if (isWithinHomeDroppable) {
	    return (0, _inHomeList2.default)({
	      pageCenter: pageCenter,
	      draggable: draggable,
	      home: home,
	      insideHome: insideDestination,
	      previousImpact: previousImpact || _noImpact2.default,
	      viewport: viewport
	    });
	  }
	
	  return (0, _inForeignList2.default)({
	    pageCenter: pageCenter,
	    draggable: draggable,
	    destination: destination,
	    insideDestination: insideDestination,
	    previousImpact: previousImpact || _noImpact2.default,
	    viewport: viewport
	  });
	};

/***/ }),
/* 1907 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(1898);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _memoizeOne = __webpack_require__(1903);
	
	var _memoizeOne2 = _interopRequireDefault(_memoizeOne);
	
	var _getArea = __webpack_require__(1908);
	
	var _getArea2 = _interopRequireDefault(_getArea);
	
	var _getDraggablesInsideDroppable = __webpack_require__(1909);
	
	var _getDraggablesInsideDroppable2 = _interopRequireDefault(_getDraggablesInsideDroppable);
	
	var _isPositionInFrame = __webpack_require__(1910);
	
	var _isPositionInFrame2 = _interopRequireDefault(_isPositionInFrame);
	
	var _position = __webpack_require__(1904);
	
	var _spacing = __webpack_require__(1912);
	
	var _dimension = __webpack_require__(1913);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getRequiredGrowth = (0, _memoizeOne2.default)(function (draggable, draggables, droppable) {
	
	  var getResult = function getResult(existingSpace) {
	    var requiredSpace = draggable.page.marginBox[droppable.axis.size];
	
	    if (requiredSpace <= existingSpace) {
	      return null;
	    }
	    var requiredGrowth = (0, _position.patch)(droppable.axis.line, requiredSpace - existingSpace);
	
	    return requiredGrowth;
	  };
	
	  var dimensions = (0, _getDraggablesInsideDroppable2.default)(droppable, draggables);
	
	  if (!dimensions.length) {
	    var _existingSpace = droppable.page.marginBox[droppable.axis.size];
	    return getResult(_existingSpace);
	  }
	
	  var endOfDraggables = dimensions[dimensions.length - 1].page.marginBox[droppable.axis.end];
	  var endOfDroppable = droppable.page.marginBox[droppable.axis.end];
	  var existingSpace = endOfDroppable - endOfDraggables;
	
	  return getResult(existingSpace);
	});
	
	var getWithGrowth = (0, _memoizeOne2.default)(function (area, growth) {
	  return (0, _getArea2.default)((0, _spacing.expandByPosition)(area, growth));
	});
	
	var getClippedAreaWithPlaceholder = function getClippedAreaWithPlaceholder(_ref) {
	  var draggable = _ref.draggable,
	      draggables = _ref.draggables,
	      droppable = _ref.droppable,
	      previousDroppableOverId = _ref.previousDroppableOverId;
	
	  var isHome = draggable.descriptor.droppableId === droppable.descriptor.id;
	  var wasOver = Boolean(previousDroppableOverId && previousDroppableOverId === droppable.descriptor.id);
	  var clipped = droppable.viewport.clipped;
	
	  if (!clipped) {
	    return clipped;
	  }
	
	  if (isHome || !wasOver) {
	    return clipped;
	  }
	
	  var requiredGrowth = getRequiredGrowth(draggable, draggables, droppable);
	
	  if (!requiredGrowth) {
	    return clipped;
	  }
	
	  var subjectWithGrowth = getWithGrowth(clipped, requiredGrowth);
	  var closestScrollable = droppable.viewport.closestScrollable;
	
	  if (!closestScrollable) {
	    return subjectWithGrowth;
	  }
	
	  if (!closestScrollable.shouldClipSubject) {
	    return subjectWithGrowth;
	  }
	
	  return (0, _dimension.clip)(closestScrollable.frame, subjectWithGrowth);
	};
	
	exports.default = function (_ref2) {
	  var target = _ref2.target,
	      draggable = _ref2.draggable,
	      draggables = _ref2.draggables,
	      droppables = _ref2.droppables,
	      previousDroppableOverId = _ref2.previousDroppableOverId;
	
	  var maybe = (0, _keys2.default)(droppables).map(function (id) {
	    return droppables[id];
	  }).filter(function (droppable) {
	    return droppable.isEnabled;
	  }).find(function (droppable) {
	    var withPlaceholder = getClippedAreaWithPlaceholder({
	      draggable: draggable, draggables: draggables, droppable: droppable, previousDroppableOverId: previousDroppableOverId
	    });
	
	    if (!withPlaceholder) {
	      return false;
	    }
	
	    return (0, _isPositionInFrame2.default)(withPlaceholder)(target);
	  });
	
	  return maybe ? maybe.descriptor.id : null;
	};

/***/ }),
/* 1908 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (_ref) {
	  var top = _ref.top,
	      right = _ref.right,
	      bottom = _ref.bottom,
	      left = _ref.left;
	  return {
	    top: top,
	    right: right,
	    bottom: bottom,
	    left: left,
	    width: right - left,
	    height: bottom - top,
	    center: {
	      x: (right + left) / 2,
	      y: (bottom + top) / 2
	    }
	  };
	};

/***/ }),
/* 1909 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(1898);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _memoizeOne = __webpack_require__(1903);
	
	var _memoizeOne2 = _interopRequireDefault(_memoizeOne);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _memoizeOne2.default)(function (droppable, draggables) {
	  return (0, _keys2.default)(draggables).map(function (id) {
	    return draggables[id];
	  }).filter(function (draggable) {
	    return droppable.descriptor.id === draggable.descriptor.droppableId;
	  }).sort(function (a, b) {
	    return a.descriptor.index - b.descriptor.index;
	  });
	});

/***/ }),
/* 1910 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isWithin = __webpack_require__(1911);
	
	var _isWithin2 = _interopRequireDefault(_isWithin);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (frame) {
	  var isWithinVertical = (0, _isWithin2.default)(frame.top, frame.bottom);
	  var isWithinHorizontal = (0, _isWithin2.default)(frame.left, frame.right);
	
	  return function (point) {
	    return isWithinVertical(point.y) && isWithinVertical(point.y) && isWithinHorizontal(point.x) && isWithinHorizontal(point.x);
	  };
	};

/***/ }),
/* 1911 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (lowerBound, upperBound) {
	  return function (value) {
	    return value <= upperBound && value >= lowerBound;
	  };
	};

/***/ }),
/* 1912 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var offsetByPosition = exports.offsetByPosition = function offsetByPosition(spacing, point) {
	  return {
	    top: spacing.top + point.y,
	    left: spacing.left + point.x,
	    bottom: spacing.bottom + point.y,
	    right: spacing.right + point.x
	  };
	};
	
	var expandByPosition = exports.expandByPosition = function expandByPosition(spacing, position) {
	  return {
	    top: spacing.top - position.y,
	    left: spacing.left - position.x,
	
	    right: spacing.right + position.x,
	    bottom: spacing.bottom + position.y
	  };
	};
	
	var expandBySpacing = exports.expandBySpacing = function expandBySpacing(spacing1, spacing2) {
	  return {
	    top: spacing1.top - spacing2.top,
	    left: spacing1.left - spacing2.left,
	
	    bottom: spacing1.bottom + spacing2.bottom,
	    right: spacing1.right + spacing2.right
	  };
	};
	
	var shrinkBySpacing = exports.shrinkBySpacing = function shrinkBySpacing(spacing1, spacing2) {
	  return {
	    top: spacing1.top + spacing2.top,
	    left: spacing1.left + spacing2.left,
	
	    bottom: spacing1.bottom - spacing2.bottom,
	    right: spacing1.right - spacing2.right
	  };
	};
	
	var isEqual = exports.isEqual = function isEqual(spacing1, spacing2) {
	  return spacing1.top === spacing2.top && spacing1.right === spacing2.right && spacing1.bottom === spacing2.bottom && spacing1.left === spacing2.left;
	};
	
	var getCorners = exports.getCorners = function getCorners(spacing) {
	  return [{ x: spacing.left, y: spacing.top }, { x: spacing.right, y: spacing.top }, { x: spacing.left, y: spacing.bottom }, { x: spacing.right, y: spacing.bottom }];
	};

/***/ }),
/* 1913 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getDroppableDimension = exports.scrollDroppable = exports.clip = exports.getDraggableDimension = exports.noSpacing = undefined;
	
	var _extends2 = __webpack_require__(1901);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _axis = __webpack_require__(1914);
	
	var _getArea = __webpack_require__(1908);
	
	var _getArea2 = _interopRequireDefault(_getArea);
	
	var _spacing = __webpack_require__(1912);
	
	var _position = __webpack_require__(1904);
	
	var _getMaxScroll = __webpack_require__(1915);
	
	var _getMaxScroll2 = _interopRequireDefault(_getMaxScroll);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var origin = { x: 0, y: 0 };
	
	var noSpacing = exports.noSpacing = {
	  top: 0,
	  right: 0,
	  bottom: 0,
	  left: 0
	};
	
	var getDraggableDimension = exports.getDraggableDimension = function getDraggableDimension(_ref) {
	  var descriptor = _ref.descriptor,
	      paddingBox = _ref.paddingBox,
	      _ref$margin = _ref.margin,
	      margin = _ref$margin === undefined ? noSpacing : _ref$margin,
	      _ref$windowScroll = _ref.windowScroll,
	      windowScroll = _ref$windowScroll === undefined ? origin : _ref$windowScroll;
	
	  var pagePaddingBox = (0, _spacing.offsetByPosition)(paddingBox, windowScroll);
	
	  var dimension = {
	    descriptor: descriptor,
	    placeholder: {
	      margin: margin,
	      paddingBox: paddingBox
	    },
	
	    client: {
	      paddingBox: paddingBox,
	      marginBox: (0, _getArea2.default)((0, _spacing.expandBySpacing)(paddingBox, margin))
	    },
	
	    page: {
	      paddingBox: (0, _getArea2.default)(pagePaddingBox),
	      marginBox: (0, _getArea2.default)((0, _spacing.expandBySpacing)(pagePaddingBox, margin))
	    }
	  };
	
	  return dimension;
	};
	
	var clip = exports.clip = function clip(frame, subject) {
	  var result = (0, _getArea2.default)({
	    top: Math.max(subject.top, frame.top),
	    right: Math.min(subject.right, frame.right),
	    bottom: Math.min(subject.bottom, frame.bottom),
	    left: Math.max(subject.left, frame.left)
	  });
	
	  if (result.width <= 0 || result.height <= 0) {
	    return null;
	  }
	
	  return result;
	};
	
	var scrollDroppable = exports.scrollDroppable = function scrollDroppable(droppable, newScroll) {
	  if (!droppable.viewport.closestScrollable) {
	    console.error('Cannot scroll droppble that does not have a closest scrollable');
	    return droppable;
	  }
	
	  var existingScrollable = droppable.viewport.closestScrollable;
	
	  var frame = existingScrollable.frame;
	
	  var scrollDiff = (0, _position.subtract)(newScroll, existingScrollable.scroll.initial);
	
	  var scrollDisplacement = (0, _position.negate)(scrollDiff);
	
	  var closestScrollable = {
	    frame: existingScrollable.frame,
	    shouldClipSubject: existingScrollable.shouldClipSubject,
	    scroll: {
	      initial: existingScrollable.scroll.initial,
	      current: newScroll,
	      diff: {
	        value: scrollDiff,
	        displacement: scrollDisplacement
	      },
	
	      max: existingScrollable.scroll.max
	    }
	  };
	
	  var displacedSubject = (0, _spacing.offsetByPosition)(droppable.viewport.subject, scrollDisplacement);
	
	  var clipped = closestScrollable.shouldClipSubject ? clip(frame, displacedSubject) : (0, _getArea2.default)(displacedSubject);
	
	  var viewport = {
	    closestScrollable: closestScrollable,
	    subject: droppable.viewport.subject,
	    clipped: clipped
	  };
	
	  return (0, _extends3.default)({}, droppable, {
	    viewport: viewport
	  });
	};
	
	var getDroppableDimension = exports.getDroppableDimension = function getDroppableDimension(_ref2) {
	  var descriptor = _ref2.descriptor,
	      paddingBox = _ref2.paddingBox,
	      closest = _ref2.closest,
	      _ref2$direction = _ref2.direction,
	      direction = _ref2$direction === undefined ? 'vertical' : _ref2$direction,
	      _ref2$margin = _ref2.margin,
	      margin = _ref2$margin === undefined ? noSpacing : _ref2$margin,
	      _ref2$padding = _ref2.padding,
	      padding = _ref2$padding === undefined ? noSpacing : _ref2$padding,
	      _ref2$windowScroll = _ref2.windowScroll,
	      windowScroll = _ref2$windowScroll === undefined ? origin : _ref2$windowScroll,
	      _ref2$isEnabled = _ref2.isEnabled,
	      isEnabled = _ref2$isEnabled === undefined ? true : _ref2$isEnabled;
	
	  var client = {
	    paddingBox: paddingBox,
	    marginBox: (0, _getArea2.default)((0, _spacing.expandBySpacing)(paddingBox, margin)),
	    contentBox: (0, _getArea2.default)((0, _spacing.shrinkBySpacing)(paddingBox, padding))
	  };
	  var page = {
	    marginBox: (0, _getArea2.default)((0, _spacing.offsetByPosition)(client.marginBox, windowScroll)),
	    paddingBox: (0, _getArea2.default)((0, _spacing.offsetByPosition)(client.paddingBox, windowScroll)),
	    contentBox: (0, _getArea2.default)((0, _spacing.offsetByPosition)(client.contentBox, windowScroll))
	  };
	  var subject = page.marginBox;
	
	  var closestScrollable = function () {
	    if (!closest) {
	      return null;
	    }
	
	    var frame = (0, _getArea2.default)((0, _spacing.offsetByPosition)(closest.framePaddingBox, windowScroll));
	
	    var maxScroll = (0, _getMaxScroll2.default)({
	      scrollHeight: closest.scrollHeight,
	      scrollWidth: closest.scrollWidth,
	      height: frame.height,
	      width: frame.width
	    });
	
	    var result = {
	      frame: frame,
	      shouldClipSubject: closest.shouldClipSubject,
	      scroll: {
	        initial: closest.scroll,
	
	        current: closest.scroll,
	        max: maxScroll,
	        diff: {
	          value: origin,
	          displacement: origin
	        }
	      }
	    };
	
	    return result;
	  }();
	
	  var clipped = closestScrollable && closestScrollable.shouldClipSubject ? clip(closestScrollable.frame, subject) : subject;
	
	  var viewport = {
	    closestScrollable: closestScrollable,
	    subject: subject,
	    clipped: clipped
	  };
	
	  var dimension = {
	    descriptor: descriptor,
	    isEnabled: isEnabled,
	    axis: direction === 'vertical' ? _axis.vertical : _axis.horizontal,
	    client: client,
	    page: page,
	    viewport: viewport
	  };
	
	  return dimension;
	};

/***/ }),
/* 1914 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var vertical = exports.vertical = {
	  direction: 'vertical',
	  line: 'y',
	  crossAxisLine: 'x',
	  start: 'top',
	  end: 'bottom',
	  size: 'height',
	  crossAxisStart: 'left',
	  crossAxisEnd: 'right',
	  crossAxisSize: 'width'
	};
	
	var horizontal = exports.horizontal = {
	  direction: 'horizontal',
	  line: 'x',
	  crossAxisLine: 'y',
	  start: 'left',
	  end: 'right',
	  size: 'width',
	  crossAxisStart: 'top',
	  crossAxisEnd: 'bottom',
	  crossAxisSize: 'height'
	};

/***/ }),
/* 1915 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _position = __webpack_require__(1904);
	
	exports.default = function (_ref) {
	  var scrollHeight = _ref.scrollHeight,
	      scrollWidth = _ref.scrollWidth,
	      height = _ref.height,
	      width = _ref.width;
	
	  var maxScroll = (0, _position.subtract)({ x: scrollWidth, y: scrollHeight }, { x: width, y: height });
	
	  var adjustedMaxScroll = {
	    x: Math.max(0, maxScroll.x),
	    y: Math.max(0, maxScroll.y)
	  };
	
	  return adjustedMaxScroll;
	};

/***/ }),
/* 1916 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _position = __webpack_require__(1904);
	
	var _getDisplacement = __webpack_require__(1917);
	
	var _getDisplacement2 = _interopRequireDefault(_getDisplacement);
	
	var _withDroppableScroll = __webpack_require__(1922);
	
	var _withDroppableScroll2 = _interopRequireDefault(_withDroppableScroll);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	  var pageCenter = _ref.pageCenter,
	      draggable = _ref.draggable,
	      home = _ref.home,
	      insideHome = _ref.insideHome,
	      previousImpact = _ref.previousImpact,
	      viewport = _ref.viewport;
	
	  var axis = home.axis;
	
	  var originalCenter = draggable.page.paddingBox.center;
	
	  var currentCenter = (0, _withDroppableScroll2.default)(home, pageCenter);
	
	  var isBeyondStartPosition = currentCenter[axis.line] - originalCenter[axis.line] > 0;
	
	  var amount = (0, _position.patch)(axis.line, draggable.client.marginBox[axis.size]);
	
	  var displaced = insideHome.filter(function (child) {
	    if (child === draggable) {
	      return false;
	    }
	
	    var area = child.page.paddingBox;
	
	    if (isBeyondStartPosition) {
	      if (area.center[axis.line] < originalCenter[axis.line]) {
	        return false;
	      }
	
	      return currentCenter[axis.line] > area[axis.start];
	    }
	
	    if (originalCenter[axis.line] < area.center[axis.line]) {
	      return false;
	    }
	
	    return currentCenter[axis.line] < area[axis.end];
	  }).map(function (dimension) {
	    return (0, _getDisplacement2.default)({
	      draggable: dimension,
	      destination: home,
	      previousImpact: previousImpact,
	      viewport: viewport.subject
	    });
	  });
	
	  var ordered = isBeyondStartPosition ? displaced.reverse() : displaced;
	  var index = function () {
	    var startIndex = insideHome.indexOf(draggable);
	    var length = ordered.length;
	    if (!length) {
	      return startIndex;
	    }
	
	    if (isBeyondStartPosition) {
	      return startIndex + length;
	    }
	
	    return startIndex - length;
	  }();
	
	  var movement = {
	    amount: amount,
	    displaced: ordered,
	    isBeyondStartPosition: isBeyondStartPosition
	  };
	
	  var impact = {
	    movement: movement,
	    direction: axis.direction,
	    destination: {
	      droppableId: home.descriptor.id,
	      index: index
	    }
	  };
	
	  return impact;
	};

/***/ }),
/* 1917 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getDisplacementMap = __webpack_require__(1918);
	
	var _getDisplacementMap2 = _interopRequireDefault(_getDisplacementMap);
	
	var _isVisible = __webpack_require__(1919);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	  var draggable = _ref.draggable,
	      destination = _ref.destination,
	      previousImpact = _ref.previousImpact,
	      viewport = _ref.viewport;
	
	  var id = draggable.descriptor.id;
	  var map = (0, _getDisplacementMap2.default)(previousImpact.movement.displaced);
	
	  var isVisible = (0, _isVisible.isPartiallyVisible)({
	    target: draggable.page.marginBox,
	    destination: destination,
	    viewport: viewport
	  });
	
	  var shouldAnimate = function () {
	    if (!isVisible) {
	      return false;
	    }
	
	    var previous = map[id];
	
	    if (!previous) {
	      return true;
	    }
	
	    return previous.shouldAnimate;
	  }();
	
	  var displacement = {
	    draggableId: id,
	    isVisible: isVisible,
	    shouldAnimate: shouldAnimate
	  };
	
	  return displacement;
	};

/***/ }),
/* 1918 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _memoizeOne = __webpack_require__(1903);
	
	var _memoizeOne2 = _interopRequireDefault(_memoizeOne);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _memoizeOne2.default)(function (displaced) {
	  return displaced.reduce(function (map, displacement) {
	    map[displacement.draggableId] = displacement;
	    return map;
	  }, {});
	});

/***/ }),
/* 1919 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.isTotallyVisible = exports.isPartiallyVisible = undefined;
	
	var _isPartiallyVisibleThroughFrame = __webpack_require__(1920);
	
	var _isPartiallyVisibleThroughFrame2 = _interopRequireDefault(_isPartiallyVisibleThroughFrame);
	
	var _isTotallyVisibleThroughFrame = __webpack_require__(1921);
	
	var _isTotallyVisibleThroughFrame2 = _interopRequireDefault(_isTotallyVisibleThroughFrame);
	
	var _spacing = __webpack_require__(1912);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var origin = { x: 0, y: 0 };
	
	var isVisible = function isVisible(_ref) {
	  var target = _ref.target,
	      destination = _ref.destination,
	      viewport = _ref.viewport,
	      isVisibleThroughFrameFn = _ref.isVisibleThroughFrameFn;
	
	  var displacement = destination.viewport.closestScrollable ? destination.viewport.closestScrollable.scroll.diff.displacement : origin;
	  var withDisplacement = (0, _spacing.offsetByPosition)(target, displacement);
	
	  if (!destination.viewport.clipped) {
	    return false;
	  }
	
	  var isVisibleInDroppable = isVisibleThroughFrameFn(destination.viewport.clipped)(withDisplacement);
	
	  var isVisibleInViewport = isVisibleThroughFrameFn(viewport)(withDisplacement);
	
	  return isVisibleInDroppable && isVisibleInViewport;
	};
	
	var isPartiallyVisible = exports.isPartiallyVisible = function isPartiallyVisible(_ref2) {
	  var target = _ref2.target,
	      destination = _ref2.destination,
	      viewport = _ref2.viewport;
	  return isVisible({
	    target: target,
	    destination: destination,
	    viewport: viewport,
	    isVisibleThroughFrameFn: _isPartiallyVisibleThroughFrame2.default
	  });
	};
	
	var isTotallyVisible = exports.isTotallyVisible = function isTotallyVisible(_ref3) {
	  var target = _ref3.target,
	      destination = _ref3.destination,
	      viewport = _ref3.viewport;
	  return isVisible({
	    target: target,
	    destination: destination,
	    viewport: viewport,
	    isVisibleThroughFrameFn: _isTotallyVisibleThroughFrame2.default
	  });
	};

/***/ }),
/* 1920 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isWithin = __webpack_require__(1911);
	
	var _isWithin2 = _interopRequireDefault(_isWithin);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (frame) {
	  var isWithinVertical = (0, _isWithin2.default)(frame.top, frame.bottom);
	  var isWithinHorizontal = (0, _isWithin2.default)(frame.left, frame.right);
	
	  return function (subject) {
	    var isContained = isWithinVertical(subject.top) && isWithinVertical(subject.bottom) && isWithinHorizontal(subject.left) && isWithinHorizontal(subject.right);
	
	    if (isContained) {
	      return true;
	    }
	
	    var isPartiallyVisibleVertically = isWithinVertical(subject.top) || isWithinVertical(subject.bottom);
	    var isPartiallyVisibleHorizontally = isWithinHorizontal(subject.left) || isWithinHorizontal(subject.right);
	
	    var isPartiallyContained = isPartiallyVisibleVertically && isPartiallyVisibleHorizontally;
	
	    if (isPartiallyContained) {
	      return true;
	    }
	
	    var isBiggerVertically = subject.top < frame.top && subject.bottom > frame.bottom;
	    var isBiggerHorizontally = subject.left < frame.left && subject.right > frame.right;
	
	    var isTargetBiggerThanFrame = isBiggerVertically && isBiggerHorizontally;
	
	    if (isTargetBiggerThanFrame) {
	      return true;
	    }
	
	    var isTargetBiggerOnOneAxis = isBiggerVertically && isPartiallyVisibleHorizontally || isBiggerHorizontally && isPartiallyVisibleVertically;
	
	    return isTargetBiggerOnOneAxis;
	  };
	};

/***/ }),
/* 1921 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isWithin = __webpack_require__(1911);
	
	var _isWithin2 = _interopRequireDefault(_isWithin);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (frame) {
	  var isWithinVertical = (0, _isWithin2.default)(frame.top, frame.bottom);
	  var isWithinHorizontal = (0, _isWithin2.default)(frame.left, frame.right);
	
	  return function (subject) {
	    var isContained = isWithinVertical(subject.top) && isWithinVertical(subject.bottom) && isWithinHorizontal(subject.left) && isWithinHorizontal(subject.right);
	
	    return isContained;
	  };
	};

/***/ }),
/* 1922 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _position = __webpack_require__(1904);
	
	exports.default = function (droppable, point) {
	  var closestScrollable = droppable.viewport.closestScrollable;
	  if (!closestScrollable) {
	    return point;
	  }
	
	  return (0, _position.add)(point, closestScrollable.scroll.diff.value);
	};

/***/ }),
/* 1923 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _position = __webpack_require__(1904);
	
	var _getDisplacement = __webpack_require__(1917);
	
	var _getDisplacement2 = _interopRequireDefault(_getDisplacement);
	
	var _withDroppableScroll = __webpack_require__(1922);
	
	var _withDroppableScroll2 = _interopRequireDefault(_withDroppableScroll);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	  var pageCenter = _ref.pageCenter,
	      draggable = _ref.draggable,
	      destination = _ref.destination,
	      insideDestination = _ref.insideDestination,
	      previousImpact = _ref.previousImpact,
	      viewport = _ref.viewport;
	
	  var axis = destination.axis;
	
	  var currentCenter = (0, _withDroppableScroll2.default)(destination, pageCenter);
	
	  var displaced = insideDestination.filter(function (child) {
	    var threshold = child.page.paddingBox[axis.end];
	    return threshold > currentCenter[axis.line];
	  }).map(function (dimension) {
	    return (0, _getDisplacement2.default)({
	      draggable: dimension,
	      destination: destination,
	      previousImpact: previousImpact,
	      viewport: viewport.subject
	    });
	  });
	
	  var newIndex = insideDestination.length - displaced.length;
	
	  var movement = {
	    amount: (0, _position.patch)(axis.line, draggable.page.marginBox[axis.size]),
	    displaced: displaced,
	    isBeyondStartPosition: false
	  };
	
	  var impact = {
	    movement: movement,
	    direction: axis.direction,
	    destination: {
	      droppableId: destination.descriptor.id,
	      index: newIndex
	    }
	  };
	
	  return impact;
	};

/***/ }),
/* 1924 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _inHomeList = __webpack_require__(1925);
	
	var _inHomeList2 = _interopRequireDefault(_inHomeList);
	
	var _inForeignList = __webpack_require__(1930);
	
	var _inForeignList2 = _interopRequireDefault(_inForeignList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (args) {
	  var draggableId = args.draggableId,
	      draggables = args.draggables,
	      droppable = args.droppable;
	
	
	  var draggable = draggables[draggableId];
	  var isInHomeList = draggable.descriptor.droppableId === droppable.descriptor.id;
	
	  if (!droppable.isEnabled) {
	    return null;
	  }
	
	  if (isInHomeList) {
	    return (0, _inHomeList2.default)(args);
	  }
	
	  return (0, _inForeignList2.default)(args);
	};

/***/ }),
/* 1925 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getDraggablesInsideDroppable = __webpack_require__(1909);
	
	var _getDraggablesInsideDroppable2 = _interopRequireDefault(_getDraggablesInsideDroppable);
	
	var _position = __webpack_require__(1904);
	
	var _withDroppableDisplacement = __webpack_require__(1926);
	
	var _withDroppableDisplacement2 = _interopRequireDefault(_withDroppableDisplacement);
	
	var _isTotallyVisibleInNewLocation = __webpack_require__(1927);
	
	var _isTotallyVisibleInNewLocation2 = _interopRequireDefault(_isTotallyVisibleInNewLocation);
	
	var _moveToEdge = __webpack_require__(1928);
	
	var _moveToEdge2 = _interopRequireDefault(_moveToEdge);
	
	var _getForcedDisplacement = __webpack_require__(1929);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	  var isMovingForward = _ref.isMovingForward,
	      draggableId = _ref.draggableId,
	      previousPageCenter = _ref.previousPageCenter,
	      previousImpact = _ref.previousImpact,
	      droppable = _ref.droppable,
	      draggables = _ref.draggables,
	      viewport = _ref.viewport;
	
	  var location = previousImpact.destination;
	
	  if (!location) {
	    console.error('cannot move to next index when there is not previous destination');
	    return null;
	  }
	
	  var draggable = draggables[draggableId];
	  var axis = droppable.axis;
	
	  var insideDroppable = (0, _getDraggablesInsideDroppable2.default)(droppable, draggables);
	
	  var startIndex = draggable.descriptor.index;
	  var currentIndex = location.index;
	  var proposedIndex = isMovingForward ? currentIndex + 1 : currentIndex - 1;
	
	  if (startIndex === -1) {
	    console.error('could not find draggable inside current droppable');
	    return null;
	  }
	
	  if (proposedIndex > insideDroppable.length - 1) {
	    return null;
	  }
	
	  if (proposedIndex < 0) {
	    return null;
	  }
	
	  var destination = insideDroppable[proposedIndex];
	  var isMovingTowardStart = isMovingForward && proposedIndex <= startIndex || !isMovingForward && proposedIndex >= startIndex;
	
	  var edge = function () {
	    if (!isMovingTowardStart) {
	      return isMovingForward ? 'end' : 'start';
	    }
	
	    return isMovingForward ? 'start' : 'end';
	  }();
	
	  var newPageCenter = (0, _moveToEdge2.default)({
	    source: draggable.page.paddingBox,
	    sourceEdge: edge,
	    destination: destination.page.paddingBox,
	    destinationEdge: edge,
	    destinationAxis: droppable.axis
	  });
	
	  var isVisibleInNewLocation = (0, _isTotallyVisibleInNewLocation2.default)({
	    draggable: draggable,
	    destination: droppable,
	    newPageCenter: newPageCenter,
	    viewport: viewport.subject
	  });
	
	  var displaced = function () {
	    if (isMovingTowardStart) {
	      return (0, _getForcedDisplacement.withFirstRemoved)({
	        dragging: draggableId,
	        isVisibleInNewLocation: isVisibleInNewLocation,
	        previousImpact: previousImpact,
	        droppable: droppable,
	        draggables: draggables
	      });
	    }
	    return (0, _getForcedDisplacement.withFirstAdded)({
	      add: destination.descriptor.id,
	      previousImpact: previousImpact,
	      droppable: droppable,
	      draggables: draggables,
	      viewport: viewport
	    });
	  }();
	
	  var newImpact = {
	    movement: {
	      displaced: displaced,
	      amount: (0, _position.patch)(axis.line, draggable.page.marginBox[axis.size]),
	      isBeyondStartPosition: proposedIndex > startIndex
	    },
	    destination: {
	      droppableId: droppable.descriptor.id,
	      index: proposedIndex
	    },
	    direction: droppable.axis.direction
	  };
	
	  if (isVisibleInNewLocation) {
	    return {
	      pageCenter: (0, _withDroppableDisplacement2.default)(droppable, newPageCenter),
	      impact: newImpact,
	      scrollJumpRequest: null
	    };
	  }
	
	  var distance = (0, _position.subtract)(newPageCenter, previousPageCenter);
	  var distanceWithScroll = (0, _withDroppableDisplacement2.default)(droppable, distance);
	
	  return {
	    pageCenter: previousPageCenter,
	    impact: newImpact,
	    scrollJumpRequest: distanceWithScroll
	  };
	};

/***/ }),
/* 1926 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _position = __webpack_require__(1904);
	
	exports.default = function (droppable, point) {
	  var closestScrollable = droppable.viewport.closestScrollable;
	  if (!closestScrollable) {
	    return point;
	  }
	
	  return (0, _position.add)(point, closestScrollable.scroll.diff.displacement);
	};

/***/ }),
/* 1927 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _position = __webpack_require__(1904);
	
	var _spacing = __webpack_require__(1912);
	
	var _isVisible = __webpack_require__(1919);
	
	exports.default = function (_ref) {
	  var draggable = _ref.draggable,
	      destination = _ref.destination,
	      newPageCenter = _ref.newPageCenter,
	      viewport = _ref.viewport;
	
	  var diff = (0, _position.subtract)(newPageCenter, draggable.page.paddingBox.center);
	  var shifted = (0, _spacing.offsetByPosition)(draggable.page.paddingBox, diff);
	
	  return (0, _isVisible.isTotallyVisible)({
	    target: shifted,
	    destination: destination,
	    viewport: viewport
	  });
	};

/***/ }),
/* 1928 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _position = __webpack_require__(1904);
	
	exports.default = function (_ref) {
	  var source = _ref.source,
	      sourceEdge = _ref.sourceEdge,
	      destination = _ref.destination,
	      destinationEdge = _ref.destinationEdge,
	      destinationAxis = _ref.destinationAxis;
	
	  var getCorner = function getCorner(area) {
	    return (0, _position.patch)(destinationAxis.line, area[destinationAxis[destinationEdge]], area[destinationAxis.crossAxisStart]);
	  };
	
	  var corner = getCorner(destination);
	
	  var centerDiff = (0, _position.absolute)((0, _position.subtract)(source.center, getCorner(source)));
	
	  var signed = (0, _position.patch)(destinationAxis.line, (sourceEdge === 'end' ? -1 : 1) * centerDiff[destinationAxis.line], centerDiff[destinationAxis.crossAxisLine]);
	
	  return (0, _position.add)(corner, signed);
	};

/***/ }),
/* 1929 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.withFirstRemoved = exports.withFirstAdded = undefined;
	
	var _getDisplacement = __webpack_require__(1917);
	
	var _getDisplacement2 = _interopRequireDefault(_getDisplacement);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var withFirstAdded = exports.withFirstAdded = function withFirstAdded(_ref) {
	  var add = _ref.add,
	      previousImpact = _ref.previousImpact,
	      droppable = _ref.droppable,
	      draggables = _ref.draggables,
	      viewport = _ref.viewport;
	
	  var newDisplacement = {
	    draggableId: add,
	    isVisible: true,
	    shouldAnimate: true
	  };
	
	  var added = [newDisplacement].concat(previousImpact.movement.displaced);
	
	  var withUpdatedVisibility = added.map(function (current) {
	    if (current === newDisplacement) {
	      return current;
	    }
	
	    var updated = (0, _getDisplacement2.default)({
	      draggable: draggables[current.draggableId],
	      destination: droppable,
	      previousImpact: previousImpact,
	      viewport: viewport.subject
	    });
	
	    return updated;
	  });
	
	  return withUpdatedVisibility;
	};
	
	var forceVisibleDisplacement = function forceVisibleDisplacement(current) {
	  if (current.isVisible) {
	    return current;
	  }
	
	  return {
	    draggableId: current.draggableId,
	    isVisible: true,
	    shouldAnimate: false
	  };
	};
	
	var withFirstRemoved = exports.withFirstRemoved = function withFirstRemoved(_ref2) {
	  var dragging = _ref2.dragging,
	      isVisibleInNewLocation = _ref2.isVisibleInNewLocation,
	      previousImpact = _ref2.previousImpact,
	      droppable = _ref2.droppable,
	      draggables = _ref2.draggables;
	
	  var last = previousImpact.movement.displaced;
	  if (!last.length) {
	    console.error('cannot remove displacement from empty list');
	    return [];
	  }
	
	  var withFirstRestored = last.slice(1, last.length);
	
	  if (!withFirstRestored.length) {
	    return withFirstRestored;
	  }
	
	  if (isVisibleInNewLocation) {
	    return withFirstRestored;
	  }
	
	  var axis = droppable.axis;
	
	  var sizeOfRestored = draggables[last[0].draggableId].page.marginBox[axis.size];
	  var sizeOfDragging = draggables[dragging].page.marginBox[axis.size];
	  var buffer = sizeOfRestored + sizeOfDragging;
	
	  var withUpdatedVisibility = withFirstRestored.map(function (displacement, index) {
	    if (index === 0) {
	      return forceVisibleDisplacement(displacement);
	    }
	
	    if (buffer > 0) {
	      var current = draggables[displacement.draggableId];
	      var size = current.page.marginBox[axis.size];
	      buffer -= size;
	
	      return forceVisibleDisplacement(displacement);
	    }
	
	    return {
	      draggableId: displacement.draggableId,
	      isVisible: false,
	      shouldAnimate: false
	    };
	  });
	
	  return withUpdatedVisibility;
	};

/***/ }),
/* 1930 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getDraggablesInsideDroppable = __webpack_require__(1909);
	
	var _getDraggablesInsideDroppable2 = _interopRequireDefault(_getDraggablesInsideDroppable);
	
	var _position = __webpack_require__(1904);
	
	var _withDroppableDisplacement = __webpack_require__(1926);
	
	var _withDroppableDisplacement2 = _interopRequireDefault(_withDroppableDisplacement);
	
	var _moveToEdge = __webpack_require__(1928);
	
	var _moveToEdge2 = _interopRequireDefault(_moveToEdge);
	
	var _isTotallyVisibleInNewLocation = __webpack_require__(1927);
	
	var _isTotallyVisibleInNewLocation2 = _interopRequireDefault(_isTotallyVisibleInNewLocation);
	
	var _getForcedDisplacement = __webpack_require__(1929);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	  var isMovingForward = _ref.isMovingForward,
	      draggableId = _ref.draggableId,
	      previousImpact = _ref.previousImpact,
	      previousPageCenter = _ref.previousPageCenter,
	      droppable = _ref.droppable,
	      draggables = _ref.draggables,
	      viewport = _ref.viewport;
	
	  if (!previousImpact.destination) {
	    console.error('cannot move to next index when there is not previous destination');
	    return null;
	  }
	
	  var location = previousImpact.destination;
	  var draggable = draggables[draggableId];
	  var axis = droppable.axis;
	
	  var insideForeignDroppable = (0, _getDraggablesInsideDroppable2.default)(droppable, draggables);
	
	  var currentIndex = location.index;
	  var proposedIndex = isMovingForward ? currentIndex + 1 : currentIndex - 1;
	  var lastIndex = insideForeignDroppable.length - 1;
	
	  if (proposedIndex > insideForeignDroppable.length) {
	    return null;
	  }
	
	  if (proposedIndex < 0) {
	    return null;
	  }
	
	  var movingRelativeTo = insideForeignDroppable[Math.min(proposedIndex, lastIndex)];
	
	  var isMovingPastLastIndex = proposedIndex > lastIndex;
	  var sourceEdge = 'start';
	  var destinationEdge = function () {
	    if (isMovingPastLastIndex) {
	      return 'end';
	    }
	
	    return 'start';
	  }();
	
	  var newPageCenter = (0, _moveToEdge2.default)({
	    source: draggable.page.paddingBox,
	    sourceEdge: sourceEdge,
	    destination: movingRelativeTo.page.marginBox,
	    destinationEdge: destinationEdge,
	    destinationAxis: droppable.axis
	  });
	
	  var isVisibleInNewLocation = (0, _isTotallyVisibleInNewLocation2.default)({
	    draggable: draggable,
	    destination: droppable,
	    newPageCenter: newPageCenter,
	    viewport: viewport.subject
	  });
	
	  var displaced = function () {
	    if (isMovingForward) {
	      return (0, _getForcedDisplacement.withFirstRemoved)({
	        dragging: draggableId,
	        isVisibleInNewLocation: isVisibleInNewLocation,
	        previousImpact: previousImpact,
	        droppable: droppable,
	        draggables: draggables
	      });
	    }
	    return (0, _getForcedDisplacement.withFirstAdded)({
	      add: movingRelativeTo.descriptor.id,
	      previousImpact: previousImpact,
	      droppable: droppable,
	      draggables: draggables,
	      viewport: viewport
	    });
	  }();
	
	  var newImpact = {
	    movement: {
	      displaced: displaced,
	      amount: (0, _position.patch)(axis.line, draggable.page.marginBox[axis.size]),
	
	      isBeyondStartPosition: false
	    },
	    destination: {
	      droppableId: droppable.descriptor.id,
	      index: proposedIndex
	    },
	    direction: droppable.axis.direction
	  };
	
	  if (isVisibleInNewLocation) {
	    return {
	      pageCenter: (0, _withDroppableDisplacement2.default)(droppable, newPageCenter),
	      impact: newImpact,
	      scrollJumpRequest: null
	    };
	  }
	
	  var distanceMoving = (0, _position.subtract)(newPageCenter, previousPageCenter);
	  var distanceWithScroll = (0, _withDroppableDisplacement2.default)(droppable, distanceMoving);
	
	  return {
	    pageCenter: previousPageCenter,
	    impact: newImpact,
	    scrollJumpRequest: distanceWithScroll
	  };
	};

/***/ }),
/* 1931 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getBestCrossAxisDroppable = __webpack_require__(1932);
	
	var _getBestCrossAxisDroppable2 = _interopRequireDefault(_getBestCrossAxisDroppable);
	
	var _getClosestDraggable = __webpack_require__(1933);
	
	var _getClosestDraggable2 = _interopRequireDefault(_getClosestDraggable);
	
	var _moveToNewDroppable = __webpack_require__(1934);
	
	var _moveToNewDroppable2 = _interopRequireDefault(_moveToNewDroppable);
	
	var _noImpact = __webpack_require__(1905);
	
	var _noImpact2 = _interopRequireDefault(_noImpact);
	
	var _getDraggablesInsideDroppable = __webpack_require__(1909);
	
	var _getDraggablesInsideDroppable2 = _interopRequireDefault(_getDraggablesInsideDroppable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	  var isMovingForward = _ref.isMovingForward,
	      pageCenter = _ref.pageCenter,
	      draggableId = _ref.draggableId,
	      droppableId = _ref.droppableId,
	      home = _ref.home,
	      draggables = _ref.draggables,
	      droppables = _ref.droppables,
	      previousImpact = _ref.previousImpact,
	      viewport = _ref.viewport;
	
	  var draggable = draggables[draggableId];
	  var source = droppables[droppableId];
	
	  var destination = (0, _getBestCrossAxisDroppable2.default)({
	    isMovingForward: isMovingForward,
	    pageCenter: pageCenter,
	    source: source,
	    droppables: droppables,
	    viewport: viewport
	  });
	
	  if (!destination) {
	    return null;
	  }
	
	  var insideDestination = (0, _getDraggablesInsideDroppable2.default)(destination, draggables);
	
	  var target = (0, _getClosestDraggable2.default)({
	    axis: destination.axis,
	    pageCenter: pageCenter,
	    destination: destination,
	    insideDestination: insideDestination,
	    viewport: viewport
	  });
	
	  if (insideDestination.length && !target) {
	    return null;
	  }
	
	  return (0, _moveToNewDroppable2.default)({
	    pageCenter: pageCenter,
	    destination: destination,
	    draggable: draggable,
	    target: target,
	    insideDestination: insideDestination,
	    home: home,
	    previousImpact: previousImpact || _noImpact2.default,
	    viewport: viewport
	  });
	};

/***/ }),
/* 1932 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(1898);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _position = __webpack_require__(1904);
	
	var _isWithin = __webpack_require__(1911);
	
	var _isWithin2 = _interopRequireDefault(_isWithin);
	
	var _spacing = __webpack_require__(1912);
	
	var _isPartiallyVisibleThroughFrame = __webpack_require__(1920);
	
	var _isPartiallyVisibleThroughFrame2 = _interopRequireDefault(_isPartiallyVisibleThroughFrame);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getSafeClipped = function getSafeClipped(droppable) {
	  var area = droppable.viewport.clipped;
	
	  if (!area) {
	    throw new Error('cannot get clipped area from droppable');
	  }
	  return area;
	};
	
	exports.default = function (_ref) {
	  var isMovingForward = _ref.isMovingForward,
	      pageCenter = _ref.pageCenter,
	      source = _ref.source,
	      droppables = _ref.droppables,
	      viewport = _ref.viewport;
	
	  var sourceClipped = source.viewport.clipped;
	
	  if (!sourceClipped) {
	    return null;
	  }
	
	  var axis = source.axis;
	  var isBetweenSourceClipped = (0, _isWithin2.default)(sourceClipped[axis.start], sourceClipped[axis.end]);
	
	  var candidates = (0, _keys2.default)(droppables).map(function (id) {
	    return droppables[id];
	  }).filter(function (droppable) {
	    return droppable !== source;
	  }).filter(function (droppable) {
	    return droppable.isEnabled;
	  }).filter(function (droppable) {
	    var clipped = droppable.viewport.clipped;
	
	    if (!clipped) {
	      return false;
	    }
	
	    return (0, _isPartiallyVisibleThroughFrame2.default)(viewport.subject)(clipped);
	  }).filter(function (droppable) {
	    var targetClipped = getSafeClipped(droppable);
	
	    if (isMovingForward) {
	      return sourceClipped[axis.crossAxisEnd] <= targetClipped[axis.crossAxisStart];
	    }
	
	    return targetClipped[axis.crossAxisEnd] <= sourceClipped[axis.crossAxisStart];
	  }).filter(function (droppable) {
	    var targetClipped = getSafeClipped(droppable);
	
	    var isBetweenDestinationClipped = (0, _isWithin2.default)(targetClipped[axis.start], targetClipped[axis.end]);
	
	    return isBetweenSourceClipped(targetClipped[axis.start]) || isBetweenSourceClipped(targetClipped[axis.end]) || isBetweenDestinationClipped(sourceClipped[axis.start]) || isBetweenDestinationClipped(sourceClipped[axis.end]);
	  }).sort(function (a, b) {
	    var first = getSafeClipped(a)[axis.crossAxisStart];
	    var second = getSafeClipped(b)[axis.crossAxisStart];
	
	    if (isMovingForward) {
	      return first - second;
	    }
	    return second - first;
	  }).filter(function (droppable, index, array) {
	    return getSafeClipped(droppable)[axis.crossAxisStart] === getSafeClipped(array[0])[axis.crossAxisStart];
	  });
	
	  if (!candidates.length) {
	    return null;
	  }
	
	  if (candidates.length === 1) {
	    return candidates[0];
	  }
	
	  var contains = candidates.filter(function (droppable) {
	    var isWithinDroppable = (0, _isWithin2.default)(getSafeClipped(droppable)[axis.start], getSafeClipped(droppable)[axis.end]);
	    return isWithinDroppable(pageCenter[axis.line]);
	  });
	
	  if (contains.length === 1) {
	    return contains[0];
	  }
	
	  if (contains.length > 1) {
	    return contains.sort(function (a, b) {
	      return getSafeClipped(a)[axis.start] - getSafeClipped(b)[axis.start];
	    })[0];
	  }
	
	  return candidates.sort(function (a, b) {
	    var first = (0, _position.closest)(pageCenter, (0, _spacing.getCorners)(getSafeClipped(a)));
	    var second = (0, _position.closest)(pageCenter, (0, _spacing.getCorners)(getSafeClipped(b)));
	
	    if (first !== second) {
	      return first - second;
	    }
	
	    return getSafeClipped(a)[axis.start] - getSafeClipped(b)[axis.start];
	  })[0];
	};

/***/ }),
/* 1933 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _position = __webpack_require__(1904);
	
	var _isVisible = __webpack_require__(1919);
	
	var _withDroppableDisplacement = __webpack_require__(1926);
	
	var _withDroppableDisplacement2 = _interopRequireDefault(_withDroppableDisplacement);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	  var axis = _ref.axis,
	      viewport = _ref.viewport,
	      pageCenter = _ref.pageCenter,
	      destination = _ref.destination,
	      insideDestination = _ref.insideDestination;
	
	  if (!insideDestination.length) {
	    return null;
	  }
	
	  var result = insideDestination.filter(function (draggable) {
	    return (0, _isVisible.isTotallyVisible)({
	      target: draggable.page.marginBox,
	      destination: destination,
	      viewport: viewport.subject
	    });
	  }).sort(function (a, b) {
	    var distanceToA = (0, _position.distance)(pageCenter, (0, _withDroppableDisplacement2.default)(destination, a.page.marginBox.center));
	    var distanceToB = (0, _position.distance)(pageCenter, (0, _withDroppableDisplacement2.default)(destination, b.page.marginBox.center));
	
	    if (distanceToA < distanceToB) {
	      return -1;
	    }
	
	    if (distanceToB < distanceToA) {
	      return 1;
	    }
	
	    return a.page.marginBox[axis.start] - b.page.marginBox[axis.start];
	  });
	
	  return result.length ? result[0] : null;
	};

/***/ }),
/* 1934 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toHomeList = __webpack_require__(1935);
	
	var _toHomeList2 = _interopRequireDefault(_toHomeList);
	
	var _toForeignList = __webpack_require__(1936);
	
	var _toForeignList2 = _interopRequireDefault(_toForeignList);
	
	var _position = __webpack_require__(1904);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	  var pageCenter = _ref.pageCenter,
	      destination = _ref.destination,
	      draggable = _ref.draggable,
	      target = _ref.target,
	      home = _ref.home,
	      insideDestination = _ref.insideDestination,
	      previousImpact = _ref.previousImpact,
	      viewport = _ref.viewport;
	
	  var amount = (0, _position.patch)(destination.axis.line, draggable.client.marginBox[destination.axis.size]);
	
	  if (destination.descriptor.id === draggable.descriptor.droppableId) {
	    return (0, _toHomeList2.default)({
	      amount: amount,
	      originalIndex: home.index,
	      target: target,
	      insideDroppable: insideDestination,
	      draggable: draggable,
	      droppable: destination,
	      previousImpact: previousImpact,
	      viewport: viewport
	    });
	  }
	
	  return (0, _toForeignList2.default)({
	    amount: amount,
	    pageCenter: pageCenter,
	    target: target,
	    insideDroppable: insideDestination,
	    draggable: draggable,
	    droppable: destination,
	    previousImpact: previousImpact,
	    viewport: viewport
	  });
	};

/***/ }),
/* 1935 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _moveToEdge = __webpack_require__(1928);
	
	var _moveToEdge2 = _interopRequireDefault(_moveToEdge);
	
	var _getDisplacement = __webpack_require__(1917);
	
	var _getDisplacement2 = _interopRequireDefault(_getDisplacement);
	
	var _withDroppableDisplacement = __webpack_require__(1926);
	
	var _withDroppableDisplacement2 = _interopRequireDefault(_withDroppableDisplacement);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	  var amount = _ref.amount,
	      originalIndex = _ref.originalIndex,
	      target = _ref.target,
	      insideDroppable = _ref.insideDroppable,
	      draggable = _ref.draggable,
	      droppable = _ref.droppable,
	      previousImpact = _ref.previousImpact,
	      viewport = _ref.viewport;
	
	  if (!target) {
	    console.error('there will always be a target in the original list');
	    return null;
	  }
	
	  var axis = droppable.axis;
	  var targetIndex = insideDroppable.indexOf(target);
	
	  if (targetIndex === -1) {
	    console.error('unable to find target in destination droppable');
	    return null;
	  }
	
	  if (targetIndex === originalIndex) {
	    var _newCenter = draggable.page.paddingBox.center;
	    var _newImpact = {
	      movement: {
	        displaced: [],
	        amount: amount,
	        isBeyondStartPosition: false
	      },
	      direction: droppable.axis.direction,
	      destination: {
	        droppableId: droppable.descriptor.id,
	        index: originalIndex
	      }
	    };
	
	    return {
	      pageCenter: (0, _withDroppableDisplacement2.default)(droppable, _newCenter),
	      impact: _newImpact
	    };
	  }
	
	  var isMovingPastOriginalIndex = targetIndex > originalIndex;
	  var edge = isMovingPastOriginalIndex ? 'end' : 'start';
	
	  var newCenter = (0, _moveToEdge2.default)({
	    source: draggable.page.paddingBox,
	    sourceEdge: edge,
	    destination: isMovingPastOriginalIndex ? target.page.paddingBox : target.page.marginBox,
	    destinationEdge: edge,
	    destinationAxis: axis
	  });
	
	  var modified = function () {
	    if (!isMovingPastOriginalIndex) {
	      return insideDroppable.slice(targetIndex, originalIndex);
	    }
	
	    var from = originalIndex + 1;
	
	    var to = targetIndex + 1;
	
	    return insideDroppable.slice(from, to).reverse();
	  }();
	
	  var displaced = modified.map(function (dimension) {
	    return (0, _getDisplacement2.default)({
	      draggable: dimension,
	      destination: droppable,
	      previousImpact: previousImpact,
	      viewport: viewport.subject
	    });
	  });
	
	  var newImpact = {
	    movement: {
	      displaced: displaced,
	      amount: amount,
	      isBeyondStartPosition: isMovingPastOriginalIndex
	    },
	    direction: axis.direction,
	    destination: {
	      droppableId: droppable.descriptor.id,
	      index: targetIndex
	    }
	  };
	
	  return {
	    pageCenter: (0, _withDroppableDisplacement2.default)(droppable, newCenter),
	    impact: newImpact
	  };
	};

/***/ }),
/* 1936 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _moveToEdge = __webpack_require__(1928);
	
	var _moveToEdge2 = _interopRequireDefault(_moveToEdge);
	
	var _getDisplacement = __webpack_require__(1917);
	
	var _getDisplacement2 = _interopRequireDefault(_getDisplacement);
	
	var _withDroppableDisplacement = __webpack_require__(1926);
	
	var _withDroppableDisplacement2 = _interopRequireDefault(_withDroppableDisplacement);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	  var amount = _ref.amount,
	      pageCenter = _ref.pageCenter,
	      target = _ref.target,
	      insideDroppable = _ref.insideDroppable,
	      draggable = _ref.draggable,
	      droppable = _ref.droppable,
	      previousImpact = _ref.previousImpact,
	      viewport = _ref.viewport;
	
	  var axis = droppable.axis;
	  var isGoingBeforeTarget = Boolean(target && pageCenter[droppable.axis.line] < target.page.marginBox.center[droppable.axis.line]);
	
	  if (!target) {
	
	    var _newCenter = (0, _moveToEdge2.default)({
	      source: draggable.page.paddingBox,
	      sourceEdge: 'start',
	      destination: droppable.page.contentBox,
	      destinationEdge: 'start',
	      destinationAxis: axis
	    });
	
	    var _newImpact = {
	      movement: {
	        displaced: [],
	        amount: amount,
	        isBeyondStartPosition: false
	      },
	      direction: axis.direction,
	      destination: {
	        droppableId: droppable.descriptor.id,
	        index: 0
	      }
	    };
	
	    return {
	      pageCenter: (0, _withDroppableDisplacement2.default)(droppable, _newCenter),
	      impact: _newImpact
	    };
	  }
	
	  var targetIndex = insideDroppable.indexOf(target);
	  var proposedIndex = isGoingBeforeTarget ? targetIndex : targetIndex + 1;
	
	  if (targetIndex === -1) {
	    console.error('could not find target inside destination');
	    return null;
	  }
	
	  var newCenter = (0, _moveToEdge2.default)({
	    source: draggable.page.paddingBox,
	    sourceEdge: 'start',
	    destination: target.page.marginBox,
	    destinationEdge: isGoingBeforeTarget ? 'start' : 'end',
	    destinationAxis: axis
	  });
	
	  var displaced = insideDroppable.slice(proposedIndex, insideDroppable.length).map(function (dimension) {
	    return (0, _getDisplacement2.default)({
	      draggable: dimension,
	      destination: droppable,
	      viewport: viewport.subject,
	      previousImpact: previousImpact
	    });
	  });
	
	  var newImpact = {
	    movement: {
	      displaced: displaced,
	      amount: amount,
	      isBeyondStartPosition: false
	    },
	    direction: axis.direction,
	    destination: {
	      droppableId: droppable.descriptor.id,
	      index: proposedIndex
	    }
	  };
	
	  return {
	    pageCenter: (0, _withDroppableDisplacement2.default)(droppable, newCenter),
	    impact: newImpact
	  };
	};

/***/ }),
/* 1937 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(1901);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _messagePreset = __webpack_require__(1938);
	
	var _messagePreset2 = _interopRequireDefault(_messagePreset);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var notDragging = {
	  isDragging: false,
	  start: null,
	  lastDestination: null,
	  hasMovedFromStartLocation: false
	};
	
	var areLocationsEqual = function areLocationsEqual(current, next) {
	  if (current == null && next == null) {
	    return true;
	  }
	
	  if (current == null || next == null) {
	    return false;
	  }
	
	  return current.droppableId === next.droppableId && current.index === next.index;
	};
	
	var getAnnouncerForConsumer = function getAnnouncerForConsumer(announce) {
	  var wasCalled = false;
	  var isExpired = false;
	
	  setTimeout(function () {
	    isExpired = true;
	  });
	
	  var result = function result(message) {
	    if (wasCalled) {
	      console.warn('Announcement already made. Not making a second announcement');
	      return;
	    }
	
	    if (isExpired) {
	      console.warn('\n        Announcements cannot be made asynchronously.\n        Default message has already been announced.\n      ');
	      return;
	    }
	
	    wasCalled = true;
	    announce(message);
	  };
	
	  result.wasCalled = function () {
	    return wasCalled;
	  };
	
	  return result;
	};
	
	exports.default = function (announce) {
	  var state = notDragging;
	
	  var setState = function setState(partial) {
	    var newState = (0, _extends3.default)({}, state, partial);
	    state = newState;
	  };
	
	  var getDragStart = function getDragStart(appState) {
	    if (!appState.drag) {
	      return null;
	    }
	
	    var descriptor = appState.drag.initial.descriptor;
	    var home = appState.dimension.droppable[descriptor.droppableId];
	
	    if (!home) {
	      return null;
	    }
	
	    var source = {
	      index: descriptor.index,
	      droppableId: descriptor.droppableId
	    };
	
	    var start = {
	      draggableId: descriptor.id,
	      type: home.descriptor.type,
	      source: source
	    };
	
	    return start;
	  };
	
	  var execute = function execute(hook, data, getDefaultMessage) {
	    if (!hook) {
	      announce(getDefaultMessage(data));
	      return;
	    }
	
	    var managed = getAnnouncerForConsumer(announce);
	    var provided = {
	      announce: managed
	    };
	
	    hook(data, provided);
	
	    if (!managed.wasCalled()) {
	      announce(getDefaultMessage(data));
	    }
	  };
	
	  var onDrag = function onDrag(current, onDragUpdate) {
	    if (!state.isDragging) {
	      console.error('Cannot process dragging update if drag has not started');
	      return;
	    }
	
	    var drag = current.drag;
	    var start = getDragStart(current);
	    if (!start || !drag) {
	      console.error('Cannot update drag when there is invalid state');
	      return;
	    }
	
	    var destination = drag.impact.destination;
	    var update = {
	      draggableId: start.draggableId,
	      type: start.type,
	      source: start.source,
	      destination: destination
	    };
	
	    if (!state.hasMovedFromStartLocation) {
	      if (areLocationsEqual(start.source, destination)) {
	        return;
	      }
	
	      setState({
	        lastDestination: destination,
	        hasMovedFromStartLocation: true
	      });
	
	      execute(onDragUpdate, update, _messagePreset2.default.onDragUpdate);
	
	      return;
	    }
	
	    if (areLocationsEqual(state.lastDestination, destination)) {
	      return;
	    }
	
	    setState({
	      lastDestination: destination
	    });
	
	    execute(onDragUpdate, update, _messagePreset2.default.onDragUpdate);
	  };
	
	  var onStateChange = function onStateChange(hooks, previous, current) {
	    var onDragStart = hooks.onDragStart,
	        onDragUpdate = hooks.onDragUpdate,
	        onDragEnd = hooks.onDragEnd;
	
	    var currentPhase = current.phase;
	    var previousPhase = previous.phase;
	
	    if (currentPhase === 'DRAGGING' && previousPhase === 'DRAGGING') {
	      onDrag(current, onDragUpdate);
	      return;
	    }
	
	    if (state.isDragging) {
	      setState(notDragging);
	    }
	
	    if (currentPhase === previousPhase) {
	      return;
	    }
	
	    if (currentPhase === 'DRAGGING' && previousPhase !== 'DRAGGING') {
	      var _start = getDragStart(current);
	
	      if (!_start) {
	        console.error('Unable to publish onDragStart');
	        return;
	      }
	
	      setState({
	        isDragging: true,
	        hasMovedFromStartLocation: false,
	        start: _start
	      });
	
	      execute(onDragStart, _start, _messagePreset2.default.onDragStart);
	      return;
	    }
	
	    if (currentPhase === 'DROP_COMPLETE' && previousPhase !== 'DROP_COMPLETE') {
	      if (!current.drop || !current.drop.result) {
	        console.error('cannot fire onDragEnd hook without drag state', { current: current, previous: previous });
	        return;
	      }
	      var result = current.drop.result;
	
	      execute(onDragEnd, result, _messagePreset2.default.onDragEnd);
	      return;
	    }
	
	    if (currentPhase === 'IDLE' && previousPhase === 'DRAGGING') {
	      if (!previous.drag) {
	        console.error('cannot fire onDragEnd for cancel because cannot find previous drag');
	        return;
	      }
	
	      var descriptor = previous.drag.initial.descriptor;
	      var home = previous.dimension.droppable[descriptor.droppableId];
	
	      if (!home) {
	        console.error('cannot find dimension for home droppable');
	        return;
	      }
	
	      var source = {
	        index: descriptor.index,
	        droppableId: descriptor.droppableId
	      };
	      var _result = {
	        draggableId: descriptor.id,
	        type: home.descriptor.type,
	        source: source,
	        destination: null,
	        reason: 'CANCEL'
	      };
	
	      execute(onDragEnd, _result, _messagePreset2.default.onDragEnd);
	      return;
	    }
	
	    if (currentPhase === 'IDLE' && previousPhase === 'DROP_ANIMATING') {
	      if (!previous.drop || !previous.drop.pending) {
	        console.error('cannot fire onDragEnd for cancel because cannot find previous pending drop');
	        return;
	      }
	
	      var _result2 = {
	        draggableId: previous.drop.pending.result.draggableId,
	        type: previous.drop.pending.result.type,
	        source: previous.drop.pending.result.source,
	        destination: null,
	        reason: 'CANCEL'
	      };
	
	      execute(onDragEnd, _result2, _messagePreset2.default.onDragEnd);
	    }
	  };
	
	  var caller = {
	    onStateChange: onStateChange
	  };
	
	  return caller;
	};

/***/ }),
/* 1938 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var onDragStart = function onDragStart(start) {
	  return '\n  You have lifted an item in position ' + (start.source.index + 1) + '.\n  Use the arrow keys to move, space bar to drop, and escape to cancel.\n';
	};
	
	var onDragUpdate = function onDragUpdate(update) {
	  if (!update.destination) {
	    return 'You are currently not dragging over a droppable area';
	  }
	
	  if (update.source.droppableId === update.destination.droppableId) {
	    return 'You have moved the item to position ' + (update.destination.index + 1);
	  }
	
	  return '\n    You have moved the item from list ' + update.source.droppableId + ' in position ' + (update.source.index + 1) + '\n    to list ' + update.destination.droppableId + ' in position ' + (update.destination.index + 1) + '\n  ';
	};
	
	var onDragEnd = function onDragEnd(result) {
	  if (result.reason === 'CANCEL') {
	    return '\n      Movement cancelled.\n      The item has returned to its starting position of ' + (result.source.index + 1) + '\n    ';
	  }
	
	  if (!result.destination) {
	    return '\n      The item has been dropped while not over a droppable location.\n      The item has returned to its starting position of ' + (result.source.index + 1) + '\n    ';
	  }
	
	  if (result.source.droppableId === result.destination.droppableId) {
	    if (result.source.index === result.destination.index) {
	      return '\n        You have dropped the item.\n        It has been dropped on its starting position of ' + (result.source.index + 1) + '\n      ';
	    }
	
	    return '\n      You have dropped the item.\n      It has moved from position ' + (result.source.index + 1) + ' to ' + (result.destination.index + 1) + '\n    ';
	  }
	
	  return '\n    You have dropped the item.\n    It has moved from position ' + (result.source.index + 1) + ' in list ' + result.source.droppableId + '\n    to position ' + (result.destination.index + 1) + ' in list ' + result.destination.droppableId + '\n  ';
	};
	
	var preset = {
	  onDragStart: onDragStart, onDragUpdate: onDragUpdate, onDragEnd: onDragEnd
	};
	
	exports.default = preset;

/***/ }),
/* 1939 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(1898);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _extends4 = __webpack_require__(1901);
	
	var _extends5 = _interopRequireDefault(_extends4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (callbacks) {
	  var state = {
	    droppables: {},
	    draggables: {},
	    isCollecting: false,
	    scrollOptions: null,
	    request: null,
	    frameId: null
	  };
	
	  var setState = function setState(partial) {
	    var newState = (0, _extends5.default)({}, state, partial);
	    state = newState;
	  };
	
	  var cancel = function cancel() {
	    var _console;
	
	    (_console = console).error.apply(_console, arguments);
	
	    if (!state.isCollecting) {
	      return;
	    }
	
	    stopCollecting();
	    callbacks.cancel();
	  };
	
	  var registerDraggable = function registerDraggable(descriptor, getDimension) {
	    var _extends2;
	
	    var id = descriptor.id;
	
	    if (!state.droppables[descriptor.droppableId]) {
	      cancel('Cannot register Draggable ' + id + ' as there is no entry for the Droppable ' + descriptor.droppableId);
	      return;
	    }
	
	    var entry = {
	      descriptor: descriptor,
	      getDimension: getDimension
	    };
	    var draggables = (0, _extends5.default)({}, state.draggables, (_extends2 = {}, _extends2[id] = entry, _extends2));
	
	    setState({
	      draggables: draggables
	    });
	
	    if (!state.isCollecting) {
	      return;
	    }
	
	    console.warn('Adding a draggable during a drag is currently not supported');
	  };
	
	  var registerDroppable = function registerDroppable(descriptor, droppableCallbacks) {
	    var _extends3;
	
	    var id = descriptor.id;
	
	    var entry = {
	      descriptor: descriptor,
	      callbacks: droppableCallbacks
	    };
	
	    var droppables = (0, _extends5.default)({}, state.droppables, (_extends3 = {}, _extends3[id] = entry, _extends3));
	
	    setState({
	      droppables: droppables
	    });
	
	    if (!state.isCollecting) {
	      return;
	    }
	
	    console.warn('Currently not supporting updating Droppables during a drag');
	  };
	
	  var updateDroppableIsEnabled = function updateDroppableIsEnabled(id, isEnabled) {
	    if (!state.droppables[id]) {
	      cancel('Cannot update the scroll on Droppable ' + id + ' as it is not registered');
	      return;
	    }
	
	    if (!state.isCollecting) {
	      return;
	    }
	    callbacks.updateDroppableIsEnabled(id, isEnabled);
	  };
	
	  var updateDroppableScroll = function updateDroppableScroll(id, newScroll) {
	    if (!state.droppables[id]) {
	      cancel('Cannot update the scroll on Droppable ' + id + ' as it is not registered');
	      return;
	    }
	
	    if (!state.isCollecting) {
	      return;
	    }
	    callbacks.updateDroppableScroll(id, newScroll);
	  };
	
	  var scrollDroppable = function scrollDroppable(id, change) {
	    var entry = state.droppables[id];
	    if (!entry) {
	      return;
	    }
	
	    if (!state.isCollecting) {
	      return;
	    }
	
	    entry.callbacks.scroll(change);
	  };
	
	  var unregisterDraggable = function unregisterDraggable(descriptor) {
	    var entry = state.draggables[descriptor.id];
	
	    if (!entry) {
	      cancel('Cannot unregister Draggable with id ' + descriptor.id + ' as it is not registered');
	      return;
	    }
	
	    if (entry.descriptor !== descriptor) {
	      return;
	    }
	
	    var newMap = (0, _extends5.default)({}, state.draggables);
	    delete newMap[descriptor.id];
	
	    setState({
	      draggables: newMap
	    });
	
	    if (!state.isCollecting) {
	      return;
	    }
	
	    console.warn('currently not supporting unmounting a Draggable during a drag');
	  };
	
	  var unregisterDroppable = function unregisterDroppable(descriptor) {
	    var entry = state.droppables[descriptor.id];
	
	    if (!entry) {
	      cancel('Cannot unregister Droppable with id ' + descriptor.id + ' as as it is not registered');
	      return;
	    }
	
	    if (entry.descriptor !== descriptor) {
	      return;
	    }
	
	    var newMap = (0, _extends5.default)({}, state.droppables);
	    delete newMap[descriptor.id];
	
	    setState({
	      droppables: newMap
	    });
	
	    if (!state.isCollecting) {
	      return;
	    }
	
	    console.warn('currently not supporting unmounting a Droppable during a drag');
	  };
	
	  var getToBeCollected = function getToBeCollected() {
	    var draggables = state.draggables;
	    var droppables = state.droppables;
	    var request = state.request;
	
	    if (!request) {
	      console.error('cannot find request in state');
	      return [];
	    }
	    var draggableId = request.draggableId;
	    var descriptor = draggables[draggableId].descriptor;
	    var home = droppables[descriptor.droppableId].descriptor;
	
	    var draggablesToBeCollected = (0, _keys2.default)(draggables).map(function (id) {
	      return draggables[id].descriptor;
	    }).filter(function (item) {
	      return item.id !== descriptor.id;
	    }).filter(function (item) {
	      var entry = droppables[item.droppableId];
	
	      if (!entry) {
	        console.warn('Orphan Draggable found ' + item.id + ' which says it belongs to unknown Droppable ' + item.droppableId);
	        return false;
	      }
	
	      return entry.descriptor.type === home.type;
	    });
	
	    var droppablesToBeCollected = (0, _keys2.default)(droppables).map(function (id) {
	      return droppables[id].descriptor;
	    }).filter(function (item) {
	      return item.id !== home.id;
	    }).filter(function (item) {
	      var droppable = droppables[item.id].descriptor;
	      return droppable.type === home.type;
	    });
	
	    var toBeCollected = [].concat(droppablesToBeCollected, draggablesToBeCollected);
	
	    return toBeCollected;
	  };
	
	  var processPrimaryDimensions = function processPrimaryDimensions(request) {
	    if (state.isCollecting) {
	      cancel('Cannot start capturing dimensions for a drag it is already dragging');
	      return;
	    }
	
	    if (!request) {
	      cancel('Cannot start capturing dimensions with an invalid request', request);
	      return;
	    }
	
	    var draggableId = request.draggableId;
	
	    setState({
	      isCollecting: true,
	      request: request
	    });
	
	    var draggables = state.draggables;
	    var droppables = state.droppables;
	    var draggableEntry = draggables[draggableId];
	
	    if (!draggableEntry) {
	      cancel('Cannot find Draggable with id ' + draggableId + ' to start collecting dimensions');
	      return;
	    }
	
	    var homeEntry = droppables[draggableEntry.descriptor.droppableId];
	
	    if (!homeEntry) {
	      cancel('\n        Cannot find home Droppable [id:' + draggableEntry.descriptor.droppableId + ']\n        for Draggable [id:' + request.draggableId + ']\n      ');
	      return;
	    }
	
	    var home = homeEntry.callbacks.getDimension();
	    var draggable = draggableEntry.getDimension();
	
	    callbacks.publishDroppable(home);
	    callbacks.publishDraggable(draggable);
	
	    homeEntry.callbacks.watchScroll(request.scrollOptions);
	  };
	
	  var setFrameId = function setFrameId(frameId) {
	    setState({
	      frameId: frameId
	    });
	  };
	
	  var processSecondaryDimensions = function processSecondaryDimensions(requestInAppState) {
	    if (!state.isCollecting) {
	      cancel('Cannot collect secondary dimensions when collection is not occurring');
	      return;
	    }
	
	    var request = state.request;
	
	    if (!request) {
	      cancel('Cannot process secondary dimensions without a request');
	      return;
	    }
	
	    if (!requestInAppState) {
	      cancel('Cannot process secondary dimensions without a request on the state');
	      return;
	    }
	
	    if (requestInAppState.draggableId !== request.draggableId) {
	      cancel('Cannot process secondary dimensions as local request does not match app state');
	      return;
	    }
	
	    var toBeCollected = getToBeCollected();
	
	    var collectFrameId = requestAnimationFrame(function () {
	      var toBePublishedBuffer = toBeCollected.map(function (descriptor) {
	        if (descriptor.type) {
	          return state.droppables[descriptor.id].callbacks.getDimension();
	        }
	
	        return state.draggables[descriptor.id].getDimension();
	      });
	
	      var publishFrameId = requestAnimationFrame(function () {
	        var toBePublished = toBePublishedBuffer.reduce(function (previous, dimension) {
	          if (dimension.placeholder) {
	            previous.draggables.push(dimension);
	          } else {
	            previous.droppables.push(dimension);
	          }
	          return previous;
	        }, { draggables: [], droppables: [] });
	
	        callbacks.bulkPublish(toBePublished.droppables, toBePublished.draggables);
	
	        toBePublished.droppables.forEach(function (dimension) {
	          var entry = state.droppables[dimension.descriptor.id];
	          entry.callbacks.watchScroll(request.scrollOptions);
	        });
	
	        setFrameId(null);
	      });
	
	      setFrameId(publishFrameId);
	    });
	
	    setFrameId(collectFrameId);
	  };
	
	  var stopCollecting = function stopCollecting() {
	    (0, _keys2.default)(state.droppables).forEach(function (id) {
	      return state.droppables[id].callbacks.unwatchScroll();
	    });
	
	    if (state.frameId) {
	      cancelAnimationFrame(state.frameId);
	    }
	
	    setState({
	      isCollecting: false,
	      request: null,
	      frameId: null
	    });
	  };
	
	  var onPhaseChange = function onPhaseChange(current) {
	    var phase = current.phase;
	
	    if (phase === 'COLLECTING_INITIAL_DIMENSIONS') {
	      processPrimaryDimensions(current.dimension.request);
	      return;
	    }
	
	    if (phase === 'DRAGGING') {
	      processSecondaryDimensions(current.dimension.request);
	      return;
	    }
	
	    if (phase === 'DROP_ANIMATING' || phase === 'DROP_COMPLETE') {
	      if (state.isCollecting) {
	        stopCollecting();
	      }
	      return;
	    }
	
	    if (phase === 'IDLE') {
	      if (state.isCollecting) {
	        stopCollecting();
	      }
	    }
	  };
	
	  var marshal = {
	    registerDraggable: registerDraggable,
	    unregisterDraggable: unregisterDraggable,
	    registerDroppable: registerDroppable,
	    unregisterDroppable: unregisterDroppable,
	    updateDroppableIsEnabled: updateDroppableIsEnabled,
	    scrollDroppable: scrollDroppable,
	    updateDroppableScroll: updateDroppableScroll,
	    onPhaseChange: onPhaseChange
	  };
	
	  return marshal;
	};

/***/ }),
/* 1940 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.resetStyleContext = undefined;
	
	var _memoizeOne = __webpack_require__(1903);
	
	var _memoizeOne2 = _interopRequireDefault(_memoizeOne);
	
	var _getStyles = __webpack_require__(1941);
	
	var _getStyles2 = _interopRequireDefault(_getStyles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var count = 0;
	
	var prefix = 'data-react-beautiful-dnd';
	
	var resetStyleContext = exports.resetStyleContext = function resetStyleContext() {
	  count = 0;
	};
	
	exports.default = function () {
	  var context = '' + count++;
	  var styles = (0, _getStyles2.default)(context);
	
	  var state = {
	    el: null
	  };
	
	  var setState = function setState(newState) {
	    state = newState;
	  };
	
	  var setStyle = (0, _memoizeOne2.default)(function (proposed) {
	    if (!state.el) {
	      console.error('cannot set style of style tag if not mounted');
	      return;
	    }
	
	    state.el.innerHTML = proposed;
	  });
	
	  var mount = function mount() {
	    if (state.el) {
	      console.error('Style marshal already mounted');
	      return;
	    }
	
	    var el = document.createElement('style');
	    el.type = 'text/css';
	
	    el.setAttribute(prefix, context);
	    var head = document.querySelector('head');
	
	    if (!head) {
	      throw new Error('Cannot find the head to append a style to');
	    }
	
	    head.appendChild(el);
	    setState({
	      el: el
	    });
	
	    setStyle(styles.resting);
	  };
	
	  var onPhaseChange = function onPhaseChange(current) {
	    if (!state.el) {
	      console.error('cannot update styles until style marshal is mounted');
	      return;
	    }
	
	    var phase = current.phase;
	
	    if (phase === 'DRAGGING') {
	      setStyle(styles.dragging);
	      return;
	    }
	
	    if (phase === 'DROP_ANIMATING') {
	      if (!current.drop || !current.drop.pending) {
	        console.error('Invalid state found in style-marshal');
	        return;
	      }
	
	      var reason = current.drop.pending.result.reason;
	
	      if (reason === 'DROP') {
	        setStyle(styles.dropAnimating);
	        return;
	      }
	      setStyle(styles.userCancel);
	      return;
	    }
	
	    setStyle(styles.resting);
	  };
	
	  var unmount = function unmount() {
	    if (!state.el) {
	      console.error('Cannot unmount style marshal as it is already unmounted');
	      return;
	    }
	    var previous = state.el;
	
	    setState({
	      el: null
	    });
	
	    if (!previous.parentNode) {
	      console.error('Cannot unmount style marshal as cannot find parent');
	      return;
	    }
	
	    previous.parentNode.removeChild(previous);
	  };
	
	  var marshal = {
	    onPhaseChange: onPhaseChange,
	    styleContext: context,
	    mount: mount,
	    unmount: unmount
	  };
	
	  return marshal;
	};

/***/ }),
/* 1941 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _animation = __webpack_require__(1942);
	
	var prefix = 'data-react-beautiful-dnd';
	
	exports.default = function (styleContext) {
	  var dragHandleSelector = '[' + prefix + '-drag-handle="' + styleContext + '"]';
	  var draggableSelector = '[' + prefix + '-draggable="' + styleContext + '"]';
	  var droppableSelector = '[' + prefix + '-droppable="' + styleContext + '"]';
	
	  var dragHandleStyles = {
	    base: '\n      ' + dragHandleSelector + ' {\n        -webkit-touch-callout: none;\n        -webkit-tap-highlight-color: rgba(0,0,0,0);\n        touch-action: manipulation;\n      }\n    ',
	    grabCursor: '\n      ' + dragHandleSelector + ' {\n        cursor: -webkit-grab;\n        cursor: grab;\n      }\n    ',
	    blockPointerEvents: '\n      ' + dragHandleSelector + ' {\n        pointer-events: none;\n      }\n    '
	  };
	
	  var draggableStyles = {
	    animateMovement: '\n      ' + draggableSelector + ' {\n        transition: ' + _animation.css.outOfTheWay + ';\n      }\n    '
	  };
	
	  var droppableStyles = {
	    base: '\n      ' + droppableSelector + ' {\n        overflow-anchor: none;\n      }\n    '
	  };
	
	  var bodyStyles = {
	    whileActiveDragging: '\n      body {\n        cursor: grabbing;\n        cursor: -webkit-grabbing;\n        user-select: none;\n        -webkit-user-select: none;\n        -moz-user-select: none;\n        -ms-user-select: none;\n      }\n    '
	  };
	
	  var base = [dragHandleStyles.base, droppableStyles.base];
	
	  var resting = [].concat(base, [dragHandleStyles.grabCursor]).join('');
	
	  var dragging = [].concat(base, [dragHandleStyles.blockPointerEvents, draggableStyles.animateMovement, bodyStyles.whileActiveDragging]).join('');
	
	  var dropAnimating = [].concat(base, [dragHandleStyles.grabCursor, draggableStyles.animateMovement]).join('');
	
	  var userCancel = [].concat(base, [draggableStyles.animateMovement]).join('');
	
	  return { resting: resting, dragging: dragging, dropAnimating: dropAnimating, userCancel: userCancel };
	};

/***/ }),
/* 1942 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.css = exports.physics = undefined;
	
	var _extends2 = __webpack_require__(1901);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var physics = exports.physics = function () {
	  var base = {
	    stiffness: 1000,
	    damping: 60,
	
	    precision: 0.99
	  };
	
	  var standard = (0, _extends3.default)({}, base);
	
	  var fast = (0, _extends3.default)({}, base, {
	    stiffness: base.stiffness * 2
	  });
	
	  return { standard: standard, fast: fast };
	}();
	
	var css = exports.css = {
	  outOfTheWay: 'transform 0.2s cubic-bezier(0.2, 0, 0, 1)'
	};

/***/ }),
/* 1943 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (state, id) {
	  var phase = state.phase;
	
	  if (phase === 'IDLE' || phase === 'DROP_COMPLETE') {
	    return true;
	  }
	
	  if (phase === 'PREPARING' || phase === 'COLLECTING_INITIAL_DIMENSIONS' || phase === 'DRAGGING') {
	    return false;
	  }
	
	  if (phase === 'DROP_ANIMATING') {
	    if (!state.drop || !state.drop.pending) {
	      console.error('Invalid state shape for drop animating');
	      return false;
	    }
	
	    if (state.drop.pending.result.draggableId === id) {
	      return false;
	    }
	
	    return state.drop.pending.result.reason === 'DROP';
	  }
	
	  console.warn('unhandled phase ' + phase + ' in canLift check');
	  return false;
	};

/***/ }),
/* 1944 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (change) {
	  window.scrollBy(change.x, change.y);
	};

/***/ }),
/* 1945 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(1902);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var count = 0;
	
	var visuallyHidden = {
	  position: 'absolute',
	  width: '1px',
	  height: '1px',
	  margin: '-1px',
	  border: '0',
	  padding: '0',
	  overflow: 'hidden',
	  clip: 'rect(0 0 0 0)',
	
	  'clip-path': 'inset(100%)'
	};
	
	exports.default = function () {
	  var id = 'react-beautiful-dnd-announcement-' + count++;
	
	  var state = {
	    el: null
	  };
	
	  var setState = function setState(newState) {
	    state = newState;
	  };
	
	  var announce = function announce(message) {
	    var el = state.el;
	    if (!el) {
	      console.error('Cannot announce to unmounted node');
	      return;
	    }
	
	    el.textContent = message;
	  };
	
	  var mount = function mount() {
	    if (state.el) {
	      console.error('Announcer already mounted');
	      return;
	    }
	
	    var el = document.createElement('div');
	
	    el.id = id;
	
	    el.setAttribute('aria-live', 'assertive');
	    el.setAttribute('role', 'log');
	
	    el.setAttribute('aria-atomic', 'true');
	
	    (0, _assign2.default)(el.style, visuallyHidden);
	
	    if (!document.body) {
	      throw new Error('Cannot find the head to append a style to');
	    }
	
	    document.body.appendChild(el);
	    setState({
	      el: el
	    });
	  };
	
	  var unmount = function unmount() {
	    if (!state.el) {
	      console.error('Will not unmount annoucer as it is already unmounted');
	      return;
	    }
	    var node = state.el;
	
	    setState({
	      el: null
	    });
	
	    if (!node.parentNode) {
	      console.error('Cannot unmount style marshal as cannot find parent');
	      return;
	    }
	
	    node.parentNode.removeChild(node);
	  };
	
	  var announcer = {
	    announce: announce,
	    id: id,
	    mount: mount,
	    unmount: unmount
	  };
	
	  return announcer;
	};

/***/ }),
/* 1946 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _fluidScroller = __webpack_require__(1947);
	
	var _fluidScroller2 = _interopRequireDefault(_fluidScroller);
	
	var _jumpScroller = __webpack_require__(1951);
	
	var _jumpScroller2 = _interopRequireDefault(_jumpScroller);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	  var scrollDroppable = _ref.scrollDroppable,
	      scrollWindow = _ref.scrollWindow,
	      move = _ref.move;
	
	  var fluidScroll = (0, _fluidScroller2.default)({
	    scrollWindow: scrollWindow,
	    scrollDroppable: scrollDroppable
	  });
	
	  var jumpScroll = (0, _jumpScroller2.default)({
	    move: move,
	    scrollWindow: scrollWindow,
	    scrollDroppable: scrollDroppable
	  });
	
	  var onStateChange = function onStateChange(previous, current) {
	    if (current.phase === 'DRAGGING') {
	      if (!current.drag) {
	        console.error('invalid drag state');
	        return;
	      }
	
	      if (current.drag.initial.autoScrollMode === 'FLUID') {
	        fluidScroll(current);
	        return;
	      }
	
	      if (!current.drag.scrollJumpRequest) {
	        return;
	      }
	
	      jumpScroll(current);
	      return;
	    }
	
	    if (previous.phase === 'DRAGGING' && current.phase !== 'DRAGGING') {
	      fluidScroll.cancel();
	    }
	  };
	
	  var marshal = {
	    onStateChange: onStateChange
	  };
	
	  return marshal;
	};

/***/ }),
/* 1947 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getPixelThresholds = exports.config = undefined;
	
	var _rafSchd = __webpack_require__(1948);
	
	var _rafSchd2 = _interopRequireDefault(_rafSchd);
	
	var _position = __webpack_require__(1904);
	
	var _getBestScrollableDroppable = __webpack_require__(1949);
	
	var _getBestScrollableDroppable2 = _interopRequireDefault(_getBestScrollableDroppable);
	
	var _axis = __webpack_require__(1914);
	
	var _canScroll = __webpack_require__(1950);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var config = exports.config = {
	  startFrom: 0.25,
	  maxSpeedAt: 0.05,
	
	  maxScrollSpeed: 28,
	
	  ease: function ease(percentage) {
	    return Math.pow(percentage, 2);
	  }
	};
	
	var origin = { x: 0, y: 0 };
	
	var clean = (0, _position.apply)(function (value) {
	  return value === 0 ? 0 : value;
	});
	
	var getPixelThresholds = exports.getPixelThresholds = function getPixelThresholds(container, axis) {
	  var startFrom = container[axis.size] * config.startFrom;
	  var maxSpeedAt = container[axis.size] * config.maxSpeedAt;
	  var accelerationPlane = startFrom - maxSpeedAt;
	
	  var thresholds = {
	    startFrom: startFrom,
	    maxSpeedAt: maxSpeedAt,
	    accelerationPlane: accelerationPlane
	  };
	
	  return thresholds;
	};
	
	var getSpeed = function getSpeed(distance, thresholds) {
	  if (distance >= thresholds.startFrom) {
	    return 0;
	  }
	
	  if (distance <= thresholds.maxSpeedAt) {
	    return config.maxScrollSpeed;
	  }
	
	  var distancePastStart = thresholds.startFrom - distance;
	  var percentage = distancePastStart / thresholds.accelerationPlane;
	  var transformed = config.ease(percentage);
	
	  var speed = config.maxScrollSpeed * transformed;
	
	  return speed;
	};
	
	var adjustForSizeLimits = function adjustForSizeLimits(_ref) {
	  var container = _ref.container,
	      subject = _ref.subject,
	      proposedScroll = _ref.proposedScroll;
	
	  var isTooBigVertically = subject.height > container.height;
	  var isTooBigHorizontally = subject.width > container.width;
	
	  if (!isTooBigHorizontally && !isTooBigVertically) {
	    return proposedScroll;
	  }
	
	  if (isTooBigHorizontally && isTooBigVertically) {
	    return null;
	  }
	
	  return {
	    x: isTooBigHorizontally ? 0 : proposedScroll.x,
	    y: isTooBigVertically ? 0 : proposedScroll.y
	  };
	};
	
	var getRequiredScroll = function getRequiredScroll(_ref2) {
	  var container = _ref2.container,
	      subject = _ref2.subject,
	      center = _ref2.center;
	
	  var distance = {
	    top: center.y - container.top,
	    right: container.right - center.x,
	    bottom: container.bottom - center.y,
	    left: center.x - container.left
	  };
	
	  var y = function () {
	    var thresholds = getPixelThresholds(container, _axis.vertical);
	    var isCloserToBottom = distance.bottom < distance.top;
	
	    if (isCloserToBottom) {
	      return getSpeed(distance.bottom, thresholds);
	    }
	
	    return -1 * getSpeed(distance.top, thresholds);
	  }();
	
	  var x = function () {
	    var thresholds = getPixelThresholds(container, _axis.horizontal);
	    var isCloserToRight = distance.right < distance.left;
	
	    if (isCloserToRight) {
	      return getSpeed(distance.right, thresholds);
	    }
	
	    return -1 * getSpeed(distance.left, thresholds);
	  }();
	
	  var required = clean({ x: x, y: y });
	
	  if ((0, _position.isEqual)(required, origin)) {
	    return null;
	  }
	
	  var limited = adjustForSizeLimits({
	    container: container,
	    subject: subject,
	    proposedScroll: required
	  });
	
	  if (!limited) {
	    return null;
	  }
	
	  return (0, _position.isEqual)(limited, origin) ? null : limited;
	};
	
	var withPlaceholder = function withPlaceholder(droppable, draggable) {
	  var closest = droppable.viewport.closestScrollable;
	
	  if (!closest) {
	    return null;
	  }
	
	  var isOverHome = droppable.descriptor.id === draggable.descriptor.droppableId;
	  var max = closest.scroll.max;
	  var current = closest.scroll.current;
	
	  if (isOverHome) {
	    return { max: max, current: current };
	  }
	
	  var spaceForPlaceholder = (0, _position.patch)(droppable.axis.line, draggable.placeholder.paddingBox[droppable.axis.size]);
	
	  var newMax = (0, _position.add)(max, spaceForPlaceholder);
	
	  var newCurrent = {
	    x: Math.min(current.x, newMax.x),
	    y: Math.min(current.y, newMax.y)
	  };
	
	  return {
	    max: newMax,
	    current: newCurrent
	  };
	};
	
	exports.default = function (_ref3) {
	  var scrollWindow = _ref3.scrollWindow,
	      scrollDroppable = _ref3.scrollDroppable;
	
	  var scheduleWindowScroll = (0, _rafSchd2.default)(scrollWindow);
	  var scheduleDroppableScroll = (0, _rafSchd2.default)(scrollDroppable);
	
	  var scroller = function scroller(state) {
	    var drag = state.drag;
	    if (!drag) {
	      console.error('Invalid drag state');
	      return;
	    }
	
	    var center = drag.current.page.center;
	
	    var draggable = state.dimension.draggable[drag.initial.descriptor.id];
	    var subject = draggable.page.marginBox;
	    var viewport = drag.current.viewport;
	    var requiredWindowScroll = getRequiredScroll({
	      container: viewport.subject,
	      subject: subject,
	      center: center
	    });
	
	    if (requiredWindowScroll && (0, _canScroll.canScrollWindow)(viewport, requiredWindowScroll)) {
	      scheduleWindowScroll(requiredWindowScroll);
	      return;
	    }
	
	    var droppable = (0, _getBestScrollableDroppable2.default)({
	      center: center,
	      destination: drag.impact.destination,
	      droppables: state.dimension.droppable
	    });
	
	    if (!droppable) {
	      return;
	    }
	
	    var closestScrollable = droppable.viewport.closestScrollable;
	
	    if (!closestScrollable) {
	      return;
	    }
	
	    var requiredFrameScroll = getRequiredScroll({
	      container: closestScrollable.frame,
	      subject: subject,
	      center: center
	    });
	
	    if (!requiredFrameScroll) {
	      return;
	    }
	
	    var result = withPlaceholder(droppable, draggable);
	
	    if (!result) {
	      return;
	    }
	
	    var canScrollDroppable = (0, _canScroll.canPartiallyScroll)({
	      max: result.max,
	      current: result.current,
	      change: requiredFrameScroll
	    });
	
	    if (canScrollDroppable) {
	      scheduleDroppableScroll(droppable.descriptor.id, requiredFrameScroll);
	    }
	  };
	
	  scroller.cancel = function () {
	    scheduleWindowScroll.cancel();
	    scheduleDroppableScroll.cancel();
	  };
	
	  return scroller;
	};

/***/ }),
/* 1948 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (fn) {
	  var lastArgs = [];
	  var frameId = null;
	
	  var wrapperFn = function wrapperFn() {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    lastArgs = args;
	
	    if (frameId) {
	      return frameId;
	    }
	
	    frameId = requestAnimationFrame(function () {
	      frameId = null;
	      fn.apply(undefined, lastArgs);
	    });
	
	    return frameId;
	  };
	
	  wrapperFn.cancel = function () {
	    if (!frameId) {
	      return;
	    }
	
	    cancelAnimationFrame(frameId);
	    frameId = null;
	  };
	
	  var resultFn = wrapperFn;
	
	  return resultFn;
	};

/***/ }),
/* 1949 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(1898);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _memoizeOne = __webpack_require__(1903);
	
	var _memoizeOne2 = _interopRequireDefault(_memoizeOne);
	
	var _isPositionInFrame = __webpack_require__(1910);
	
	var _isPositionInFrame2 = _interopRequireDefault(_isPositionInFrame);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getScrollableDroppables = (0, _memoizeOne2.default)(function (droppables) {
	  return (0, _keys2.default)(droppables).map(function (id) {
	    return droppables[id];
	  }).filter(function (droppable) {
	    if (!droppable.isEnabled) {
	      return false;
	    }
	
	    if (!droppable.viewport.closestScrollable) {
	      return false;
	    }
	
	    return true;
	  });
	});
	
	var getScrollableDroppableOver = function getScrollableDroppableOver(target, droppables) {
	  var maybe = getScrollableDroppables(droppables).find(function (droppable) {
	    if (!droppable.viewport.closestScrollable) {
	      throw new Error('Invalid result');
	    }
	    return (0, _isPositionInFrame2.default)(droppable.viewport.closestScrollable.frame)(target);
	  });
	
	  return maybe;
	};
	
	exports.default = function (_ref) {
	  var center = _ref.center,
	      destination = _ref.destination,
	      droppables = _ref.droppables;
	
	
	  if (destination) {
	    var _dimension = droppables[destination.droppableId];
	    if (!_dimension.viewport.closestScrollable) {
	      return null;
	    }
	    return _dimension;
	  }
	
	  var dimension = getScrollableDroppableOver(center, droppables);
	
	  return dimension;
	};

/***/ }),
/* 1950 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getDroppableOverlap = exports.getWindowOverlap = exports.canScrollDroppable = exports.canScrollWindow = exports.canPartiallyScroll = exports.getOverlap = undefined;
	
	var _position = __webpack_require__(1904);
	
	var origin = { x: 0, y: 0 };
	
	var smallestSigned = (0, _position.apply)(function (value) {
	  if (value === 0) {
	    return 0;
	  }
	  return value > 0 ? 1 : -1;
	});
	
	var getOverlap = exports.getOverlap = function () {
	  var getRemainder = function getRemainder(target, max) {
	    if (target < 0) {
	      return target;
	    }
	    if (target > max) {
	      return target - max;
	    }
	    return 0;
	  };
	
	  return function (_ref) {
	    var current = _ref.current,
	        max = _ref.max,
	        change = _ref.change;
	
	    var targetScroll = (0, _position.add)(current, change);
	
	    var overlap = {
	      x: getRemainder(targetScroll.x, max.x),
	      y: getRemainder(targetScroll.y, max.y)
	    };
	
	    if ((0, _position.isEqual)(overlap, origin)) {
	      return null;
	    }
	
	    return overlap;
	  };
	}();
	
	var canPartiallyScroll = exports.canPartiallyScroll = function canPartiallyScroll(_ref2) {
	  var max = _ref2.max,
	      current = _ref2.current,
	      change = _ref2.change;
	
	  var smallestChange = smallestSigned(change);
	
	  var overlap = getOverlap({
	    max: max, current: current, change: smallestChange
	  });
	
	  if (!overlap) {
	    return true;
	  }
	
	  if (smallestChange.x !== 0 && overlap.x === 0) {
	    return true;
	  }
	
	  if (smallestChange.y !== 0 && overlap.y === 0) {
	    return true;
	  }
	
	  return false;
	};
	
	var canScrollWindow = exports.canScrollWindow = function canScrollWindow(viewport, change) {
	  return canPartiallyScroll({
	    current: viewport.scroll,
	    max: viewport.maxScroll,
	    change: change
	  });
	};
	
	var canScrollDroppable = exports.canScrollDroppable = function canScrollDroppable(droppable, change) {
	  var closestScrollable = droppable.viewport.closestScrollable;
	
	  if (!closestScrollable) {
	    return false;
	  }
	
	  return canPartiallyScroll({
	    current: closestScrollable.scroll.current,
	    max: closestScrollable.scroll.max,
	    change: change
	  });
	};
	
	var getWindowOverlap = exports.getWindowOverlap = function getWindowOverlap(viewport, change) {
	  if (!canScrollWindow(viewport, change)) {
	    return null;
	  }
	
	  var max = viewport.maxScroll;
	  var current = viewport.scroll;
	
	  return getOverlap({
	    current: current,
	    max: max,
	    change: change
	  });
	};
	
	var getDroppableOverlap = exports.getDroppableOverlap = function getDroppableOverlap(droppable, change) {
	  if (!canScrollDroppable(droppable, change)) {
	    return null;
	  }
	
	  var closestScrollable = droppable.viewport.closestScrollable;
	
	  if (!closestScrollable) {
	    return null;
	  }
	
	  return getOverlap({
	    current: closestScrollable.scroll.current,
	    max: closestScrollable.scroll.max,
	    change: change
	  });
	};

/***/ }),
/* 1951 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _position = __webpack_require__(1904);
	
	var _canScroll = __webpack_require__(1950);
	
	exports.default = function (_ref) {
	  var move = _ref.move,
	      scrollDroppable = _ref.scrollDroppable,
	      scrollWindow = _ref.scrollWindow;
	
	  var moveByOffset = function moveByOffset(state, offset) {
	    var drag = state.drag;
	    if (!drag) {
	      console.error('Cannot move by offset when not dragging');
	      return;
	    }
	
	    var client = (0, _position.add)(drag.current.client.selection, offset);
	    move(drag.initial.descriptor.id, client, drag.current.viewport, true);
	  };
	
	  var scrollDroppableAsMuchAsItCan = function scrollDroppableAsMuchAsItCan(droppable, change) {
	    if (!(0, _canScroll.canScrollDroppable)(droppable, change)) {
	      return change;
	    }
	
	    var overlap = (0, _canScroll.getDroppableOverlap)(droppable, change);
	
	    if (!overlap) {
	      scrollDroppable(droppable.descriptor.id, change);
	      return null;
	    }
	
	    var whatTheDroppableCanScroll = (0, _position.subtract)(change, overlap);
	    scrollDroppable(droppable.descriptor.id, whatTheDroppableCanScroll);
	
	    var remainder = (0, _position.subtract)(change, whatTheDroppableCanScroll);
	    return remainder;
	  };
	
	  var scrollWindowAsMuchAsItCan = function scrollWindowAsMuchAsItCan(viewport, change) {
	    if (!(0, _canScroll.canScrollWindow)(viewport, change)) {
	      return change;
	    }
	
	    var overlap = (0, _canScroll.getWindowOverlap)(viewport, change);
	
	    if (!overlap) {
	      scrollWindow(change);
	      return null;
	    }
	
	    var whatTheWindowCanScroll = (0, _position.subtract)(change, overlap);
	    scrollWindow(whatTheWindowCanScroll);
	
	    var remainder = (0, _position.subtract)(change, whatTheWindowCanScroll);
	    return remainder;
	  };
	
	  var jumpScroller = function jumpScroller(state) {
	    var drag = state.drag;
	
	    if (!drag) {
	      return;
	    }
	
	    var request = drag.scrollJumpRequest;
	
	    if (!request) {
	      return;
	    }
	
	    var destination = drag.impact.destination;
	
	    if (!destination) {
	      console.error('Cannot perform a jump scroll when there is no destination');
	      return;
	    }
	
	    var droppableRemainder = scrollDroppableAsMuchAsItCan(state.dimension.droppable[destination.droppableId], request);
	
	    if (!droppableRemainder) {
	      return;
	    }
	
	    var viewport = drag.current.viewport;
	    var windowRemainder = scrollWindowAsMuchAsItCan(viewport, droppableRemainder);
	
	    if (!windowRemainder) {
	      return;
	    }
	
	    moveByOffset(state, windowRemainder);
	  };
	
	  return jumpScroller;
	};

/***/ }),
/* 1952 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var prefix = function prefix(key) {
	  return 'private-react-beautiful-dnd-key-do-not-use-' + key;
	};
	
	var storeKey = exports.storeKey = prefix('store');
	var droppableIdKey = exports.droppableIdKey = prefix('droppable-id');
	var dimensionMarshalKey = exports.dimensionMarshalKey = prefix('dimension-marshal');
	var styleContextKey = exports.styleContextKey = prefix('style-context');
	var canLiftContextKey = exports.canLiftContextKey = prefix('can-lift');

/***/ }),
/* 1953 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.lift = exports.dropAnimationFinished = exports.cancel = exports.drop = exports.completeDrop = exports.prepare = exports.clean = exports.crossAxisMoveBackward = exports.crossAxisMoveForward = exports.moveForward = exports.moveBackward = exports.moveByWindowScroll = exports.move = exports.updateDroppableDimensionIsEnabled = exports.updateDroppableDimensionScroll = exports.bulkPublishDimensions = exports.publishDroppableDimension = exports.publishDraggableDimension = exports.completeLift = exports.requestDimensions = undefined;
	
	var _noImpact = __webpack_require__(1905);
	
	var _noImpact2 = _interopRequireDefault(_noImpact);
	
	var _withDroppableDisplacement = __webpack_require__(1926);
	
	var _withDroppableDisplacement2 = _interopRequireDefault(_withDroppableDisplacement);
	
	var _getNewHomeClientCenter = __webpack_require__(1954);
	
	var _getNewHomeClientCenter2 = _interopRequireDefault(_getNewHomeClientCenter);
	
	var _position = __webpack_require__(1904);
	
	var _timings = __webpack_require__(1955);
	
	var timings = _interopRequireWildcard(_timings);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var origin = { x: 0, y: 0 };
	
	var getScrollDiff = function getScrollDiff(_ref) {
	  var initial = _ref.initial,
	      current = _ref.current,
	      droppable = _ref.droppable;
	
	  var windowScrollDiff = (0, _position.subtract)(initial.viewport.scroll, current.viewport.scroll);
	
	  if (!droppable) {
	    return windowScrollDiff;
	  }
	
	  return (0, _withDroppableDisplacement2.default)(droppable, windowScrollDiff);
	};
	
	var requestDimensions = exports.requestDimensions = function requestDimensions(request) {
	  return {
	    type: 'REQUEST_DIMENSIONS',
	    payload: request
	  };
	};
	
	var completeLift = exports.completeLift = function completeLift(id, client, viewport, autoScrollMode) {
	  return {
	    type: 'COMPLETE_LIFT',
	    payload: {
	      id: id,
	      client: client,
	      viewport: viewport,
	      autoScrollMode: autoScrollMode
	    }
	  };
	};
	
	var publishDraggableDimension = exports.publishDraggableDimension = function publishDraggableDimension(dimension) {
	  return {
	    type: 'PUBLISH_DRAGGABLE_DIMENSION',
	    payload: dimension
	  };
	};
	
	var publishDroppableDimension = exports.publishDroppableDimension = function publishDroppableDimension(dimension) {
	  return {
	    type: 'PUBLISH_DROPPABLE_DIMENSION',
	    payload: dimension
	  };
	};
	
	var bulkPublishDimensions = exports.bulkPublishDimensions = function bulkPublishDimensions(droppables, draggables) {
	  return {
	    type: 'BULK_DIMENSION_PUBLISH',
	    payload: {
	      droppables: droppables,
	      draggables: draggables
	    }
	  };
	};
	
	var updateDroppableDimensionScroll = exports.updateDroppableDimensionScroll = function updateDroppableDimensionScroll(id, offset) {
	  return {
	    type: 'UPDATE_DROPPABLE_DIMENSION_SCROLL',
	    payload: {
	      id: id,
	      offset: offset
	    }
	  };
	};
	
	var updateDroppableDimensionIsEnabled = exports.updateDroppableDimensionIsEnabled = function updateDroppableDimensionIsEnabled(id, isEnabled) {
	  return {
	    type: 'UPDATE_DROPPABLE_DIMENSION_IS_ENABLED',
	    payload: {
	      id: id,
	      isEnabled: isEnabled
	    }
	  };
	};
	
	var move = exports.move = function move(id, client, viewport) {
	  var shouldAnimate = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
	  return {
	    type: 'MOVE',
	    payload: {
	      id: id,
	      client: client,
	      viewport: viewport,
	      shouldAnimate: shouldAnimate
	    }
	  };
	};
	
	var moveByWindowScroll = exports.moveByWindowScroll = function moveByWindowScroll(id, viewport) {
	  return {
	    type: 'MOVE_BY_WINDOW_SCROLL',
	    payload: {
	      id: id,
	      viewport: viewport
	    }
	  };
	};
	
	var moveBackward = exports.moveBackward = function moveBackward(id) {
	  return {
	    type: 'MOVE_BACKWARD',
	    payload: id
	  };
	};
	
	var moveForward = exports.moveForward = function moveForward(id) {
	  return {
	    type: 'MOVE_FORWARD',
	    payload: id
	  };
	};
	
	var crossAxisMoveForward = exports.crossAxisMoveForward = function crossAxisMoveForward(id) {
	  return {
	    type: 'CROSS_AXIS_MOVE_FORWARD',
	    payload: id
	  };
	};
	
	var crossAxisMoveBackward = exports.crossAxisMoveBackward = function crossAxisMoveBackward(id) {
	  return {
	    type: 'CROSS_AXIS_MOVE_BACKWARD',
	    payload: id
	  };
	};
	
	var clean = exports.clean = function clean() {
	  return {
	    type: 'CLEAN',
	    payload: null
	  };
	};
	
	var prepare = exports.prepare = function prepare() {
	  return {
	    type: 'PREPARE',
	    payload: null
	  };
	};
	
	var animateDrop = function animateDrop(_ref2) {
	  var newHomeOffset = _ref2.newHomeOffset,
	      impact = _ref2.impact,
	      result = _ref2.result;
	  return {
	    type: 'DROP_ANIMATE',
	    payload: {
	      newHomeOffset: newHomeOffset,
	      impact: impact,
	      result: result
	    }
	  };
	};
	
	var completeDrop = exports.completeDrop = function completeDrop(result) {
	  return {
	    type: 'DROP_COMPLETE',
	    payload: result
	  };
	};
	
	var drop = exports.drop = function drop() {
	  return function (dispatch, getState) {
	    var state = getState();
	
	    if (state.phase === 'PREPARING' || state.phase === 'COLLECTING_INITIAL_DIMENSIONS') {
	      dispatch(clean());
	      return;
	    }
	
	    if (state.phase !== 'DRAGGING') {
	      console.error('not able to drop in phase: \'' + state.phase + '\'');
	      dispatch(clean());
	      return;
	    }
	
	    if (!state.drag) {
	      console.error('not able to drop when there is invalid drag state', state);
	      dispatch(clean());
	      return;
	    }
	
	    var _state$drag = state.drag,
	        impact = _state$drag.impact,
	        initial = _state$drag.initial,
	        current = _state$drag.current;
	
	    var descriptor = initial.descriptor;
	    var draggable = state.dimension.draggable[initial.descriptor.id];
	    var home = state.dimension.droppable[draggable.descriptor.droppableId];
	    var destination = impact.destination ? state.dimension.droppable[impact.destination.droppableId] : null;
	
	    var source = {
	      droppableId: descriptor.droppableId,
	      index: descriptor.index
	    };
	
	    var result = {
	      draggableId: descriptor.id,
	      type: home.descriptor.type,
	      source: source,
	      destination: impact.destination,
	      reason: 'DROP'
	    };
	
	    var newCenter = (0, _getNewHomeClientCenter2.default)({
	      movement: impact.movement,
	      draggable: draggable,
	      draggables: state.dimension.draggable,
	      destination: destination
	    });
	
	    var clientOffset = (0, _position.subtract)(newCenter, draggable.client.marginBox.center);
	    var scrollDiff = getScrollDiff({
	      initial: initial,
	      current: current,
	      droppable: destination || home
	    });
	    var newHomeOffset = (0, _position.add)(clientOffset, scrollDiff);
	
	    var isAnimationRequired = !(0, _position.isEqual)(current.client.offset, newHomeOffset);
	
	    if (!isAnimationRequired) {
	      dispatch(completeDrop(result));
	      return;
	    }
	
	    dispatch(animateDrop({
	      newHomeOffset: newHomeOffset,
	      impact: impact,
	      result: result
	    }));
	  };
	};
	
	var cancel = exports.cancel = function cancel() {
	  return function (dispatch, getState) {
	    var state = getState();
	
	    if (state.phase !== 'DRAGGING') {
	      dispatch(clean());
	      return;
	    }
	
	    if (!state.drag) {
	      console.error('invalid drag state', state);
	      dispatch(clean());
	      return;
	    }
	
	    var _state$drag2 = state.drag,
	        initial = _state$drag2.initial,
	        current = _state$drag2.current;
	
	    var descriptor = initial.descriptor;
	    var home = state.dimension.droppable[descriptor.droppableId];
	
	    var source = {
	      index: descriptor.index,
	      droppableId: descriptor.droppableId
	    };
	
	    var result = {
	      draggableId: descriptor.id,
	      type: home.descriptor.type,
	      source: source,
	
	      destination: null,
	      reason: 'CANCEL'
	    };
	
	    var isAnimationRequired = !(0, _position.isEqual)(current.client.offset, origin);
	
	    if (!isAnimationRequired) {
	      dispatch(completeDrop(result));
	      return;
	    }
	
	    var scrollDiff = getScrollDiff({ initial: initial, current: current, droppable: home });
	
	    dispatch(animateDrop({
	      newHomeOffset: scrollDiff,
	      impact: _noImpact2.default,
	      result: result
	    }));
	  };
	};
	
	var dropAnimationFinished = exports.dropAnimationFinished = function dropAnimationFinished() {
	  return function (dispatch, getState) {
	    var state = getState();
	
	    if (state.phase !== 'DROP_ANIMATING') {
	      console.error('cannot end drop that is no longer animating', state);
	      dispatch(clean());
	      return;
	    }
	
	    if (!state.drop || !state.drop.pending) {
	      console.error('cannot end drop that has no pending state', state);
	      dispatch(clean());
	      return;
	    }
	
	    dispatch(completeDrop(state.drop.pending.result));
	  };
	};
	
	var lift = exports.lift = function lift(id, client, viewport, autoScrollMode) {
	  return function (dispatch, getState) {
	    var initial = getState();
	
	    if (initial.phase === 'DROP_ANIMATING') {
	      if (!initial.drop || !initial.drop.pending) {
	        console.error('cannot flush drop animation if there is no pending');
	        dispatch(clean());
	      } else {
	        dispatch(completeDrop(initial.drop.pending.result));
	      }
	    }
	
	    dispatch(prepare());
	
	    setTimeout(function () {
	      var state = getState();
	
	      if (state.phase !== 'PREPARING') {
	        return;
	      }
	
	      var scrollOptions = {
	        shouldPublishImmediately: autoScrollMode === 'JUMP'
	      };
	      var request = {
	        draggableId: id,
	        scrollOptions: scrollOptions
	      };
	      dispatch(requestDimensions(request));
	
	      setTimeout(function () {
	        var newState = getState();
	
	        if (newState.phase !== 'COLLECTING_INITIAL_DIMENSIONS') {
	          return;
	        }
	
	        dispatch(completeLift(id, client, viewport, autoScrollMode));
	        timings.finish('LIFT');
	      });
	    });
	  };
	};

/***/ }),
/* 1954 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _moveToEdge = __webpack_require__(1928);
	
	var _moveToEdge2 = _interopRequireDefault(_moveToEdge);
	
	var _getDraggablesInsideDroppable = __webpack_require__(1909);
	
	var _getDraggablesInsideDroppable2 = _interopRequireDefault(_getDraggablesInsideDroppable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	  var movement = _ref.movement,
	      draggable = _ref.draggable,
	      draggables = _ref.draggables,
	      destination = _ref.destination;
	
	  var homeCenter = draggable.client.marginBox.center;
	
	  if (destination == null) {
	    return homeCenter;
	  }
	
	  var displaced = movement.displaced,
	      isBeyondStartPosition = movement.isBeyondStartPosition;
	
	  var axis = destination.axis;
	
	  var isWithinHomeDroppable = destination.descriptor.id === draggable.descriptor.droppableId;
	
	  if (isWithinHomeDroppable && !displaced.length) {
	    return homeCenter;
	  }
	
	  var draggablesInDestination = (0, _getDraggablesInsideDroppable2.default)(destination, draggables);
	
	  var destinationFragment = function () {
	    if (isWithinHomeDroppable) {
	      return draggables[displaced[0].draggableId].client.marginBox;
	    }
	
	    if (displaced.length) {
	      return draggables[displaced[0].draggableId].client.marginBox;
	    }
	
	    if (draggablesInDestination.length) {
	      return draggablesInDestination[draggablesInDestination.length - 1].client.marginBox;
	    }
	
	    return destination.client.contentBox;
	  }();
	
	  var _ref2 = function () {
	    if (isWithinHomeDroppable) {
	      if (isBeyondStartPosition) {
	        return { sourceEdge: 'end', destinationEdge: 'end' };
	      }
	
	      return { sourceEdge: 'start', destinationEdge: 'start' };
	    }
	
	    if (!displaced.length && draggablesInDestination.length) {
	      return { sourceEdge: 'start', destinationEdge: 'end' };
	    }
	
	    return { sourceEdge: 'start', destinationEdge: 'start' };
	  }(),
	      sourceEdge = _ref2.sourceEdge,
	      destinationEdge = _ref2.destinationEdge;
	
	  var source = draggable.client.marginBox;
	
	  var targetCenter = (0, _moveToEdge2.default)({
	    source: source,
	    sourceEdge: sourceEdge,
	    destination: destinationFragment,
	    destinationEdge: destinationEdge,
	    destinationAxis: axis
	  });
	
	  return targetCenter;
	};

/***/ }),
/* 1955 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	
	var records = {};
	
	var flag = '__react-beautiful-dnd-debug-timings-hook__';
	
	var isTimingsEnabled = function isTimingsEnabled() {
	  return Boolean(window[flag]);
	};
	
	if (false) {
	  console.log('Set window[\'' + flag + '\'] = true to enable timings');
	}
	
	var start = exports.start = function start(key) {
	  if (!isTimingsEnabled()) {
	    return;
	  }
	  var now = performance.now();
	
	  records[key] = now;
	};
	
	var finish = exports.finish = function finish(key) {
	  if (!isTimingsEnabled()) {
	    return;
	  }
	  var now = performance.now();
	
	  var previous = records[key];
	
	  if (previous == null) {
	    console.error('cannot finish timing as no previous time found');
	    return;
	  }
	
	  var result = now - previous;
	
	  console.log('%cTiming (' + key + '): %c' + result + ' %cms', 'font-weight: bold;', 'color: blue;', 'color: grey;');
	};

/***/ }),
/* 1956 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _connectedDroppable = __webpack_require__(1957);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_connectedDroppable).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 1957 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.makeSelector = undefined;
	
	var _reactRedux = __webpack_require__(1958);
	
	var _reselect = __webpack_require__(1983);
	
	var _memoizeOne = __webpack_require__(1903);
	
	var _memoizeOne2 = _interopRequireDefault(_memoizeOne);
	
	var _contextKeys = __webpack_require__(1952);
	
	var _selectors = __webpack_require__(1984);
	
	var _droppable = __webpack_require__(1985);
	
	var _droppable2 = _interopRequireDefault(_droppable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var makeSelector = exports.makeSelector = function makeSelector() {
	  var idSelector = function idSelector(state, ownProps) {
	    return ownProps.droppableId;
	  };
	  var isDropDisabledSelector = function isDropDisabledSelector(state, ownProps) {
	    return ownProps.isDropDisabled || false;
	  };
	
	  var getIsDraggingOver = (0, _memoizeOne2.default)(function (id, destination) {
	    if (!destination) {
	      return false;
	    }
	    return destination.droppableId === id;
	  });
	
	  var getPlaceholder = (0, _memoizeOne2.default)(function (id, destination, draggable) {
	    if (!draggable) {
	      return null;
	    }
	
	    if (!destination) {
	      return null;
	    }
	
	    if (id === draggable.descriptor.droppableId) {
	      return null;
	    }
	
	    if (id !== destination.droppableId) {
	      return null;
	    }
	
	    return draggable.placeholder;
	  });
	
	  var getMapProps = (0, _memoizeOne2.default)(function (isDraggingOver, draggingOverWith, placeholder) {
	    return {
	      isDraggingOver: isDraggingOver,
	      draggingOverWith: draggingOverWith,
	      placeholder: placeholder
	    };
	  });
	
	  return (0, _reselect.createSelector)([_selectors.phaseSelector, _selectors.dragSelector, _selectors.draggingDraggableSelector, _selectors.pendingDropSelector, idSelector, isDropDisabledSelector], function (phase, drag, draggable, pending, id, isDropDisabled) {
	    if (isDropDisabled) {
	      return getMapProps(false, null, null);
	    }
	
	    if (phase === 'DRAGGING') {
	      if (!drag) {
	        console.error('cannot determine dragging over as there is not drag');
	        return getMapProps(false, null, null);
	      }
	
	      var isDraggingOver = getIsDraggingOver(id, drag.impact.destination);
	      var draggingOverWith = isDraggingOver ? drag.initial.descriptor.id : null;
	
	      var placeholder = getPlaceholder(id, drag.impact.destination, draggable);
	
	      return getMapProps(isDraggingOver, draggingOverWith, placeholder);
	    }
	
	    if (phase === 'DROP_ANIMATING') {
	      if (!pending) {
	        console.error('cannot determine dragging over as there is no pending result');
	        return getMapProps(false, null, null);
	      }
	
	      var _isDraggingOver = getIsDraggingOver(id, pending.impact.destination);
	      var _draggingOverWith = _isDraggingOver ? pending.result.draggableId : null;
	
	      var _placeholder = getPlaceholder(id, pending.result.destination, draggable);
	      return getMapProps(_isDraggingOver, _draggingOverWith, _placeholder);
	    }
	
	    return getMapProps(false, null, null);
	  });
	};
	
	var makeMapStateToProps = function makeMapStateToProps() {
	  var selector = makeSelector();
	  return function (state, props) {
	    return selector(state, props);
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(makeMapStateToProps, null, null, { storeKey: _contextKeys.storeKey })(_droppable2.default);

/***/ }),
/* 1958 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1488);
	
	var _interopRequireWildcard = __webpack_require__(1959);
	
	exports.__esModule = true;
	
	var _Provider = _interopRequireWildcard(__webpack_require__(1960));
	
	exports.Provider = _Provider.default;
	exports.createProvider = _Provider.createProvider;
	
	var _connectAdvanced = _interopRequireDefault(__webpack_require__(1964));
	
	exports.connectAdvanced = _connectAdvanced.default;
	
	var _connect = _interopRequireDefault(__webpack_require__(1970));
	
	exports.connect = _connect.default;

/***/ }),
/* 1959 */
/***/ (function(module, exports, __webpack_require__) {

	var _typeof = __webpack_require__(1496)["default"];
	
	function _getRequireWildcardCache(nodeInterop) {
	  if (typeof WeakMap !== "function") return null;
	  var cacheBabelInterop = new WeakMap();
	  var cacheNodeInterop = new WeakMap();
	  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
	    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
	  })(nodeInterop);
	}
	
	function _interopRequireWildcard(obj, nodeInterop) {
	  if (!nodeInterop && obj && obj.__esModule) {
	    return obj;
	  }
	
	  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return {
	      "default": obj
	    };
	  }
	
	  var cache = _getRequireWildcardCache(nodeInterop);
	
	  if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }
	
	  var newObj = {};
	  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
	
	  for (var key in obj) {
	    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
	
	      if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }
	
	  newObj["default"] = obj;
	
	  if (cache) {
	    cache.set(obj, newObj);
	  }
	
	  return newObj;
	}
	
	module.exports = _interopRequireWildcard;
	module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),
/* 1960 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(1959);
	
	var _interopRequireDefault = __webpack_require__(1488);
	
	exports.__esModule = true;
	exports.createProvider = createProvider;
	exports.default = void 0;
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(1961));
	
	var _react = _interopRequireWildcard(__webpack_require__(300));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(956));
	
	var _PropTypes = __webpack_require__(1962);
	
	var _warning = _interopRequireDefault(__webpack_require__(1963));
	
	var prefixUnsafeLifecycleMethods = typeof _react.default.forwardRef !== "undefined";
	var didWarnAboutReceivingStore = false;
	
	function warnAboutReceivingStore() {
	  if (didWarnAboutReceivingStore) {
	    return;
	  }
	
	  didWarnAboutReceivingStore = true;
	  (0, _warning.default)('<Provider> does not support changing `store` on the fly. ' + 'It is most likely that you see this error because you updated to ' + 'Redux 2.x and React Redux 2.x which no longer hot reload reducers ' + 'automatically. See https://github.com/reduxjs/react-redux/releases/' + 'tag/v2.0.0 for the migration instructions.');
	}
	
	function createProvider(storeKey) {
	  var _Provider$childContex;
	
	  if (storeKey === void 0) {
	    storeKey = 'store';
	  }
	
	  var subscriptionKey = storeKey + "Subscription";
	
	  var Provider =
	  /*#__PURE__*/
	  function (_Component) {
	    (0, _inheritsLoose2.default)(Provider, _Component);
	    var _proto = Provider.prototype;
	
	    _proto.getChildContext = function getChildContext() {
	      var _ref;
	
	      return _ref = {}, _ref[storeKey] = this[storeKey], _ref[subscriptionKey] = null, _ref;
	    };
	
	    function Provider(props, context) {
	      var _this;
	
	      _this = _Component.call(this, props, context) || this;
	      _this[storeKey] = props.store;
	      return _this;
	    }
	
	    _proto.render = function render() {
	      return _react.Children.only(this.props.children);
	    };
	
	    return Provider;
	  }(_react.Component);
	
	  if (false) {
	    // Use UNSAFE_ event name where supported
	    var eventName = prefixUnsafeLifecycleMethods ? 'UNSAFE_componentWillReceiveProps' : 'componentWillReceiveProps';
	
	    Provider.prototype[eventName] = function (nextProps) {
	      if (this[storeKey] !== nextProps.store) {
	        warnAboutReceivingStore();
	      }
	    };
	  }
	
	  Provider.propTypes = {
	    store: _PropTypes.storeShape.isRequired,
	    children: _propTypes.default.element.isRequired
	  };
	  Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[storeKey] = _PropTypes.storeShape.isRequired, _Provider$childContex[subscriptionKey] = _PropTypes.subscriptionShape, _Provider$childContex);
	  return Provider;
	}
	
	var _default = createProvider();
	
	exports.default = _default;

/***/ }),
/* 1961 */
/***/ (function(module, exports, __webpack_require__) {

	var setPrototypeOf = __webpack_require__(1503);
	
	function _inheritsLoose(subClass, superClass) {
	  subClass.prototype = Object.create(superClass.prototype);
	  subClass.prototype.constructor = subClass;
	  setPrototypeOf(subClass, superClass);
	}
	
	module.exports = _inheritsLoose;
	module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),
/* 1962 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1488);
	
	exports.__esModule = true;
	exports.storeShape = exports.subscriptionShape = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(956));
	
	var subscriptionShape = _propTypes.default.shape({
	  trySubscribe: _propTypes.default.func.isRequired,
	  tryUnsubscribe: _propTypes.default.func.isRequired,
	  notifyNestedSubs: _propTypes.default.func.isRequired,
	  isSubscribed: _propTypes.default.func.isRequired
	});
	
	exports.subscriptionShape = subscriptionShape;
	
	var storeShape = _propTypes.default.shape({
	  subscribe: _propTypes.default.func.isRequired,
	  dispatch: _propTypes.default.func.isRequired,
	  getState: _propTypes.default.func.isRequired
	});
	
	exports.storeShape = storeShape;

/***/ }),
/* 1963 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = warning;
	
	/**
	 * Prints a warning in the console if it exists.
	 *
	 * @param {String} message The warning message.
	 * @returns {void}
	 */
	function warning(message) {
	  /* eslint-disable no-console */
	  if (typeof console !== 'undefined' && typeof console.error === 'function') {
	    console.error(message);
	  }
	  /* eslint-enable no-console */
	
	
	  try {
	    // This error was thrown as a convenience so that if you enable
	    // "break on all exceptions" in your console,
	    // it would pause the execution at this line.
	    throw new Error(message);
	    /* eslint-disable no-empty */
	  } catch (e) {}
	  /* eslint-enable no-empty */
	
	}

/***/ }),
/* 1964 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(1959);
	
	var _interopRequireDefault = __webpack_require__(1488);
	
	exports.__esModule = true;
	exports.default = connectAdvanced;
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(1961));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(1505));
	
	var _extends2 = _interopRequireDefault(__webpack_require__(1965));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(1966));
	
	var _hoistNonReactStatics = _interopRequireDefault(__webpack_require__(1967));
	
	var _invariant = _interopRequireDefault(__webpack_require__(1968));
	
	var _react = _interopRequireWildcard(__webpack_require__(300));
	
	var _reactIs = __webpack_require__(326);
	
	var _Subscription = _interopRequireDefault(__webpack_require__(1969));
	
	var _PropTypes = __webpack_require__(1962);
	
	var prefixUnsafeLifecycleMethods = typeof _react.default.forwardRef !== "undefined";
	var hotReloadingVersion = 0;
	var dummyState = {};
	
	function noop() {}
	
	function makeSelectorStateful(sourceSelector, store) {
	  // wrap the selector in an object that tracks its results between runs.
	  var selector = {
	    run: function runComponentSelector(props) {
	      try {
	        var nextProps = sourceSelector(store.getState(), props);
	
	        if (nextProps !== selector.props || selector.error) {
	          selector.shouldComponentUpdate = true;
	          selector.props = nextProps;
	          selector.error = null;
	        }
	      } catch (error) {
	        selector.shouldComponentUpdate = true;
	        selector.error = error;
	      }
	    }
	  };
	  return selector;
	}
	
	function connectAdvanced(
	/*
	  selectorFactory is a func that is responsible for returning the selector function used to
	  compute new props from state, props, and dispatch. For example:
	     export default connectAdvanced((dispatch, options) => (state, props) => ({
	      thing: state.things[props.thingId],
	      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
	    }))(YourComponent)
	   Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
	  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
	  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
	   Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
	  props. Do not use connectAdvanced directly without memoizing results between calls to your
	  selector, otherwise the Connect component will re-render on every state or props change.
	*/
	selectorFactory, // options object:
	_ref) {
	  var _contextTypes, _childContextTypes;
	
	  if (_ref === void 0) {
	    _ref = {};
	  }
	
	  var _ref2 = _ref,
	      _ref2$getDisplayName = _ref2.getDisplayName,
	      getDisplayName = _ref2$getDisplayName === void 0 ? function (name) {
	    return "ConnectAdvanced(" + name + ")";
	  } : _ref2$getDisplayName,
	      _ref2$methodName = _ref2.methodName,
	      methodName = _ref2$methodName === void 0 ? 'connectAdvanced' : _ref2$methodName,
	      _ref2$renderCountProp = _ref2.renderCountProp,
	      renderCountProp = _ref2$renderCountProp === void 0 ? undefined : _ref2$renderCountProp,
	      _ref2$shouldHandleSta = _ref2.shouldHandleStateChanges,
	      shouldHandleStateChanges = _ref2$shouldHandleSta === void 0 ? true : _ref2$shouldHandleSta,
	      _ref2$storeKey = _ref2.storeKey,
	      storeKey = _ref2$storeKey === void 0 ? 'store' : _ref2$storeKey,
	      _ref2$withRef = _ref2.withRef,
	      withRef = _ref2$withRef === void 0 ? false : _ref2$withRef,
	      connectOptions = (0, _objectWithoutPropertiesLoose2.default)(_ref2, ["getDisplayName", "methodName", "renderCountProp", "shouldHandleStateChanges", "storeKey", "withRef"]);
	  var subscriptionKey = storeKey + 'Subscription';
	  var version = hotReloadingVersion++;
	  var contextTypes = (_contextTypes = {}, _contextTypes[storeKey] = _PropTypes.storeShape, _contextTypes[subscriptionKey] = _PropTypes.subscriptionShape, _contextTypes);
	  var childContextTypes = (_childContextTypes = {}, _childContextTypes[subscriptionKey] = _PropTypes.subscriptionShape, _childContextTypes);
	  return function wrapWithConnect(WrappedComponent) {
	    (0, _invariant.default)((0, _reactIs.isValidElementType)(WrappedComponent), "You must pass a component to the function returned by " + (methodName + ". Instead received " + JSON.stringify(WrappedComponent)));
	    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
	    var displayName = getDisplayName(wrappedComponentName);
	    var selectorFactoryOptions = (0, _extends2.default)({}, connectOptions, {
	      getDisplayName: getDisplayName,
	      methodName: methodName,
	      renderCountProp: renderCountProp,
	      shouldHandleStateChanges: shouldHandleStateChanges,
	      storeKey: storeKey,
	      withRef: withRef,
	      displayName: displayName,
	      wrappedComponentName: wrappedComponentName,
	      WrappedComponent: WrappedComponent // TODO Actually fix our use of componentWillReceiveProps
	
	      /* eslint-disable react/no-deprecated */
	
	    });
	
	    var Connect =
	    /*#__PURE__*/
	    function (_Component) {
	      (0, _inheritsLoose2.default)(Connect, _Component);
	
	      function Connect(props, context) {
	        var _this;
	
	        _this = _Component.call(this, props, context) || this;
	        _this.version = version;
	        _this.state = {};
	        _this.renderCount = 0;
	        _this.store = props[storeKey] || context[storeKey];
	        _this.propsMode = Boolean(props[storeKey]);
	        _this.setWrappedInstance = _this.setWrappedInstance.bind((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)));
	        (0, _invariant.default)(_this.store, "Could not find \"" + storeKey + "\" in either the context or props of " + ("\"" + displayName + "\". Either wrap the root component in a <Provider>, ") + ("or explicitly pass \"" + storeKey + "\" as a prop to \"" + displayName + "\"."));
	
	        _this.initSelector();
	
	        _this.initSubscription();
	
	        return _this;
	      }
	
	      var _proto = Connect.prototype;
	
	      _proto.getChildContext = function getChildContext() {
	        var _ref3;
	
	        // If this component received store from props, its subscription should be transparent
	        // to any descendants receiving store+subscription from context; it passes along
	        // subscription passed to it. Otherwise, it shadows the parent subscription, which allows
	        // Connect to control ordering of notifications to flow top-down.
	        var subscription = this.propsMode ? null : this.subscription;
	        return _ref3 = {}, _ref3[subscriptionKey] = subscription || this.context[subscriptionKey], _ref3;
	      };
	
	      _proto.componentDidMount = function componentDidMount() {
	        if (!shouldHandleStateChanges) return; // componentWillMount fires during server side rendering, but componentDidMount and
	        // componentWillUnmount do not. Because of this, trySubscribe happens during ...didMount.
	        // Otherwise, unsubscription would never take place during SSR, causing a memory leak.
	        // To handle the case where a child component may have triggered a state change by
	        // dispatching an action in its componentWillMount, we have to re-run the select and maybe
	        // re-render.
	
	        this.subscription.trySubscribe();
	        this.selector.run(this.props);
	        if (this.selector.shouldComponentUpdate) this.forceUpdate();
	      }; // Note: this is renamed below to the UNSAFE_ version in React >=16.3.0
	
	
	      _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	        this.selector.run(nextProps);
	      };
	
	      _proto.shouldComponentUpdate = function shouldComponentUpdate() {
	        return this.selector.shouldComponentUpdate;
	      };
	
	      _proto.componentWillUnmount = function componentWillUnmount() {
	        if (this.subscription) this.subscription.tryUnsubscribe();
	        this.subscription = null;
	        this.notifyNestedSubs = noop;
	        this.store = null;
	        this.selector.run = noop;
	        this.selector.shouldComponentUpdate = false;
	      };
	
	      _proto.getWrappedInstance = function getWrappedInstance() {
	        (0, _invariant.default)(withRef, "To access the wrapped instance, you need to specify " + ("{ withRef: true } in the options argument of the " + methodName + "() call."));
	        return this.wrappedInstance;
	      };
	
	      _proto.setWrappedInstance = function setWrappedInstance(ref) {
	        this.wrappedInstance = ref;
	      };
	
	      _proto.initSelector = function initSelector() {
	        var sourceSelector = selectorFactory(this.store.dispatch, selectorFactoryOptions);
	        this.selector = makeSelectorStateful(sourceSelector, this.store);
	        this.selector.run(this.props);
	      };
	
	      _proto.initSubscription = function initSubscription() {
	        if (!shouldHandleStateChanges) return; // parentSub's source should match where store came from: props vs. context. A component
	        // connected to the store via props shouldn't use subscription from context, or vice versa.
	
	        var parentSub = (this.propsMode ? this.props : this.context)[subscriptionKey];
	        this.subscription = new _Subscription.default(this.store, parentSub, this.onStateChange.bind(this)); // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
	        // the middle of the notification loop, where `this.subscription` will then be null. An
	        // extra null check every change can be avoided by copying the method onto `this` and then
	        // replacing it with a no-op on unmount. This can probably be avoided if Subscription's
	        // listeners logic is changed to not call listeners that have been unsubscribed in the
	        // middle of the notification loop.
	
	        this.notifyNestedSubs = this.subscription.notifyNestedSubs.bind(this.subscription);
	      };
	
	      _proto.onStateChange = function onStateChange() {
	        this.selector.run(this.props);
	
	        if (!this.selector.shouldComponentUpdate) {
	          this.notifyNestedSubs();
	        } else {
	          this.componentDidUpdate = this.notifyNestedSubsOnComponentDidUpdate;
	          this.setState(dummyState);
	        }
	      };
	
	      _proto.notifyNestedSubsOnComponentDidUpdate = function notifyNestedSubsOnComponentDidUpdate() {
	        // `componentDidUpdate` is conditionally implemented when `onStateChange` determines it
	        // needs to notify nested subs. Once called, it unimplements itself until further state
	        // changes occur. Doing it this way vs having a permanent `componentDidUpdate` that does
	        // a boolean check every time avoids an extra method call most of the time, resulting
	        // in some perf boost.
	        this.componentDidUpdate = undefined;
	        this.notifyNestedSubs();
	      };
	
	      _proto.isSubscribed = function isSubscribed() {
	        return Boolean(this.subscription) && this.subscription.isSubscribed();
	      };
	
	      _proto.addExtraProps = function addExtraProps(props) {
	        if (!withRef && !renderCountProp && !(this.propsMode && this.subscription)) return props; // make a shallow copy so that fields added don't leak to the original selector.
	        // this is especially important for 'ref' since that's a reference back to the component
	        // instance. a singleton memoized selector would then be holding a reference to the
	        // instance, preventing the instance from being garbage collected, and that would be bad
	
	        var withExtras = (0, _extends2.default)({}, props);
	        if (withRef) withExtras.ref = this.setWrappedInstance;
	        if (renderCountProp) withExtras[renderCountProp] = this.renderCount++;
	        if (this.propsMode && this.subscription) withExtras[subscriptionKey] = this.subscription;
	        return withExtras;
	      };
	
	      _proto.render = function render() {
	        var selector = this.selector;
	        selector.shouldComponentUpdate = false;
	
	        if (selector.error) {
	          throw selector.error;
	        } else {
	          return (0, _react.createElement)(WrappedComponent, this.addExtraProps(selector.props));
	        }
	      };
	
	      return Connect;
	    }(_react.Component);
	
	    if (prefixUnsafeLifecycleMethods) {
	      // Use UNSAFE_ event name where supported
	      Connect.prototype.UNSAFE_componentWillReceiveProps = Connect.prototype.componentWillReceiveProps;
	      delete Connect.prototype.componentWillReceiveProps;
	    }
	    /* eslint-enable react/no-deprecated */
	
	
	    Connect.WrappedComponent = WrappedComponent;
	    Connect.displayName = displayName;
	    Connect.childContextTypes = childContextTypes;
	    Connect.contextTypes = contextTypes;
	    Connect.propTypes = contextTypes;
	
	    if (false) {
	      // Use UNSAFE_ event name where supported
	      var eventName = prefixUnsafeLifecycleMethods ? 'UNSAFE_componentWillUpdate' : 'componentWillUpdate';
	
	      Connect.prototype[eventName] = function componentWillUpdate() {
	        var _this2 = this;
	
	        // We are hot reloading!
	        if (this.version !== version) {
	          this.version = version;
	          this.initSelector(); // If any connected descendants don't hot reload (and resubscribe in the process), their
	          // listeners will be lost when we unsubscribe. Unfortunately, by copying over all
	          // listeners, this does mean that the old versions of connected descendants will still be
	          // notified of state changes; however, their onStateChange function is a no-op so this
	          // isn't a huge deal.
	
	          var oldListeners = [];
	
	          if (this.subscription) {
	            oldListeners = this.subscription.listeners.get();
	            this.subscription.tryUnsubscribe();
	          }
	
	          this.initSubscription();
	
	          if (shouldHandleStateChanges) {
	            this.subscription.trySubscribe();
	            oldListeners.forEach(function (listener) {
	              return _this2.subscription.listeners.subscribe(listener);
	            });
	          }
	        }
	      };
	    }
	
	    return (0, _hoistNonReactStatics.default)(Connect, WrappedComponent);
	  };
	}

/***/ }),
/* 1965 */
/***/ (function(module, exports) {

	function _extends() {
	  module.exports = _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];
	
	      for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }
	
	    return target;
	  };
	
	  module.exports["default"] = module.exports, module.exports.__esModule = true;
	  return _extends.apply(this, arguments);
	}
	
	module.exports = _extends;
	module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),
/* 1966 */
/***/ (function(module, exports) {

	function _objectWithoutPropertiesLoose(source, excluded) {
	  if (source == null) return {};
	  var target = {};
	  var sourceKeys = Object.keys(source);
	  var key, i;
	
	  for (i = 0; i < sourceKeys.length; i++) {
	    key = sourceKeys[i];
	    if (excluded.indexOf(key) >= 0) continue;
	    target[key] = source[key];
	  }
	
	  return target;
	}
	
	module.exports = _objectWithoutPropertiesLoose;
	module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),
/* 1967 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var reactIs = __webpack_require__(326);
	
	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	var REACT_STATICS = {
	  childContextTypes: true,
	  contextType: true,
	  contextTypes: true,
	  defaultProps: true,
	  displayName: true,
	  getDefaultProps: true,
	  getDerivedStateFromError: true,
	  getDerivedStateFromProps: true,
	  mixins: true,
	  propTypes: true,
	  type: true
	};
	var KNOWN_STATICS = {
	  name: true,
	  length: true,
	  prototype: true,
	  caller: true,
	  callee: true,
	  arguments: true,
	  arity: true
	};
	var FORWARD_REF_STATICS = {
	  '$$typeof': true,
	  render: true,
	  defaultProps: true,
	  displayName: true,
	  propTypes: true
	};
	var MEMO_STATICS = {
	  '$$typeof': true,
	  compare: true,
	  defaultProps: true,
	  displayName: true,
	  propTypes: true,
	  type: true
	};
	var TYPE_STATICS = {};
	TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
	TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;
	
	function getStatics(component) {
	  // React v16.11 and below
	  if (reactIs.isMemo(component)) {
	    return MEMO_STATICS;
	  } // React v16.12 and above
	
	
	  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
	}
	
	var defineProperty = Object.defineProperty;
	var getOwnPropertyNames = Object.getOwnPropertyNames;
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	var getPrototypeOf = Object.getPrototypeOf;
	var objectPrototype = Object.prototype;
	function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
	  if (typeof sourceComponent !== 'string') {
	    // don't hoist over string (html) components
	    if (objectPrototype) {
	      var inheritedComponent = getPrototypeOf(sourceComponent);
	
	      if (inheritedComponent && inheritedComponent !== objectPrototype) {
	        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
	      }
	    }
	
	    var keys = getOwnPropertyNames(sourceComponent);
	
	    if (getOwnPropertySymbols) {
	      keys = keys.concat(getOwnPropertySymbols(sourceComponent));
	    }
	
	    var targetStatics = getStatics(targetComponent);
	    var sourceStatics = getStatics(sourceComponent);
	
	    for (var i = 0; i < keys.length; ++i) {
	      var key = keys[i];
	
	      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
	        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
	
	        try {
	          // Avoid failures from read-only properties
	          defineProperty(targetComponent, key, descriptor);
	        } catch (e) {}
	      }
	    }
	  }
	
	  return targetComponent;
	}
	
	module.exports = hoistNonReactStatics;


/***/ }),
/* 1968 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var invariant = function(condition, format, a, b, c, d, e, f) {
	  if (false) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  }
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error(
	        'Minified exception occurred; use the non-minified dev environment ' +
	        'for the full error message and additional helpful warnings.'
	      );
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(
	        format.replace(/%s/g, function() { return args[argIndex++]; })
	      );
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	};
	
	module.exports = invariant;


/***/ }),
/* 1969 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	// encapsulates the subscription logic for connecting a component to the redux store, as
	// well as nesting subscriptions of descendant components, so that we can ensure the
	// ancestor components re-render before descendants
	var CLEARED = null;
	var nullListeners = {
	  notify: function notify() {}
	};
	
	function createListenerCollection() {
	  // the current/next pattern is copied from redux's createStore code.
	  // TODO: refactor+expose that code to be reusable here?
	  var current = [];
	  var next = [];
	  return {
	    clear: function clear() {
	      next = CLEARED;
	      current = CLEARED;
	    },
	    notify: function notify() {
	      var listeners = current = next;
	
	      for (var i = 0; i < listeners.length; i++) {
	        listeners[i]();
	      }
	    },
	    get: function get() {
	      return next;
	    },
	    subscribe: function subscribe(listener) {
	      var isSubscribed = true;
	      if (next === current) next = current.slice();
	      next.push(listener);
	      return function unsubscribe() {
	        if (!isSubscribed || current === CLEARED) return;
	        isSubscribed = false;
	        if (next === current) next = current.slice();
	        next.splice(next.indexOf(listener), 1);
	      };
	    }
	  };
	}
	
	var Subscription =
	/*#__PURE__*/
	function () {
	  function Subscription(store, parentSub, onStateChange) {
	    this.store = store;
	    this.parentSub = parentSub;
	    this.onStateChange = onStateChange;
	    this.unsubscribe = null;
	    this.listeners = nullListeners;
	  }
	
	  var _proto = Subscription.prototype;
	
	  _proto.addNestedSub = function addNestedSub(listener) {
	    this.trySubscribe();
	    return this.listeners.subscribe(listener);
	  };
	
	  _proto.notifyNestedSubs = function notifyNestedSubs() {
	    this.listeners.notify();
	  };
	
	  _proto.isSubscribed = function isSubscribed() {
	    return Boolean(this.unsubscribe);
	  };
	
	  _proto.trySubscribe = function trySubscribe() {
	    if (!this.unsubscribe) {
	      this.unsubscribe = this.parentSub ? this.parentSub.addNestedSub(this.onStateChange) : this.store.subscribe(this.onStateChange);
	      this.listeners = createListenerCollection();
	    }
	  };
	
	  _proto.tryUnsubscribe = function tryUnsubscribe() {
	    if (this.unsubscribe) {
	      this.unsubscribe();
	      this.unsubscribe = null;
	      this.listeners.clear();
	      this.listeners = nullListeners;
	    }
	  };
	
	  return Subscription;
	}();
	
	exports.default = Subscription;

/***/ }),
/* 1970 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1488);
	
	exports.__esModule = true;
	exports.createConnect = createConnect;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(1965));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(1966));
	
	var _connectAdvanced = _interopRequireDefault(__webpack_require__(1964));
	
	var _shallowEqual = _interopRequireDefault(__webpack_require__(1971));
	
	var _mapDispatchToProps = _interopRequireDefault(__webpack_require__(1972));
	
	var _mapStateToProps = _interopRequireDefault(__webpack_require__(1979));
	
	var _mergeProps = _interopRequireDefault(__webpack_require__(1980));
	
	var _selectorFactory = _interopRequireDefault(__webpack_require__(1981));
	
	/*
	  connect is a facade over connectAdvanced. It turns its args into a compatible
	  selectorFactory, which has the signature:
	
	    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
	  
	  connect passes its args to connectAdvanced as options, which will in turn pass them to
	  selectorFactory each time a Connect component instance is instantiated or hot reloaded.
	
	  selectorFactory returns a final props selector from its mapStateToProps,
	  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
	  mergePropsFactories, and pure args.
	
	  The resulting final props selector is called by the Connect component instance whenever
	  it receives new props or store state.
	 */
	function match(arg, factories, name) {
	  for (var i = factories.length - 1; i >= 0; i--) {
	    var result = factories[i](arg);
	    if (result) return result;
	  }
	
	  return function (dispatch, options) {
	    throw new Error("Invalid value of type " + typeof arg + " for " + name + " argument when connecting component " + options.wrappedComponentName + ".");
	  };
	}
	
	function strictEqual(a, b) {
	  return a === b;
	} // createConnect with default args builds the 'official' connect behavior. Calling it with
	// different options opens up some testing and extensibility scenarios
	
	
	function createConnect(_temp) {
	  var _ref = _temp === void 0 ? {} : _temp,
	      _ref$connectHOC = _ref.connectHOC,
	      connectHOC = _ref$connectHOC === void 0 ? _connectAdvanced.default : _ref$connectHOC,
	      _ref$mapStateToPropsF = _ref.mapStateToPropsFactories,
	      mapStateToPropsFactories = _ref$mapStateToPropsF === void 0 ? _mapStateToProps.default : _ref$mapStateToPropsF,
	      _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories,
	      mapDispatchToPropsFactories = _ref$mapDispatchToPro === void 0 ? _mapDispatchToProps.default : _ref$mapDispatchToPro,
	      _ref$mergePropsFactor = _ref.mergePropsFactories,
	      mergePropsFactories = _ref$mergePropsFactor === void 0 ? _mergeProps.default : _ref$mergePropsFactor,
	      _ref$selectorFactory = _ref.selectorFactory,
	      selectorFactory = _ref$selectorFactory === void 0 ? _selectorFactory.default : _ref$selectorFactory;
	
	  return function connect(mapStateToProps, mapDispatchToProps, mergeProps, _ref2) {
	    if (_ref2 === void 0) {
	      _ref2 = {};
	    }
	
	    var _ref3 = _ref2,
	        _ref3$pure = _ref3.pure,
	        pure = _ref3$pure === void 0 ? true : _ref3$pure,
	        _ref3$areStatesEqual = _ref3.areStatesEqual,
	        areStatesEqual = _ref3$areStatesEqual === void 0 ? strictEqual : _ref3$areStatesEqual,
	        _ref3$areOwnPropsEqua = _ref3.areOwnPropsEqual,
	        areOwnPropsEqual = _ref3$areOwnPropsEqua === void 0 ? _shallowEqual.default : _ref3$areOwnPropsEqua,
	        _ref3$areStatePropsEq = _ref3.areStatePropsEqual,
	        areStatePropsEqual = _ref3$areStatePropsEq === void 0 ? _shallowEqual.default : _ref3$areStatePropsEq,
	        _ref3$areMergedPropsE = _ref3.areMergedPropsEqual,
	        areMergedPropsEqual = _ref3$areMergedPropsE === void 0 ? _shallowEqual.default : _ref3$areMergedPropsE,
	        extraOptions = (0, _objectWithoutPropertiesLoose2.default)(_ref3, ["pure", "areStatesEqual", "areOwnPropsEqual", "areStatePropsEqual", "areMergedPropsEqual"]);
	    var initMapStateToProps = match(mapStateToProps, mapStateToPropsFactories, 'mapStateToProps');
	    var initMapDispatchToProps = match(mapDispatchToProps, mapDispatchToPropsFactories, 'mapDispatchToProps');
	    var initMergeProps = match(mergeProps, mergePropsFactories, 'mergeProps');
	    return connectHOC(selectorFactory, (0, _extends2.default)({
	      // used in error messages
	      methodName: 'connect',
	      // used to compute Connect's displayName from the wrapped component's displayName.
	      getDisplayName: function getDisplayName(name) {
	        return "Connect(" + name + ")";
	      },
	      // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
	      shouldHandleStateChanges: Boolean(mapStateToProps),
	      // passed through to selectorFactory
	      initMapStateToProps: initMapStateToProps,
	      initMapDispatchToProps: initMapDispatchToProps,
	      initMergeProps: initMergeProps,
	      pure: pure,
	      areStatesEqual: areStatesEqual,
	      areOwnPropsEqual: areOwnPropsEqual,
	      areStatePropsEqual: areStatePropsEqual,
	      areMergedPropsEqual: areMergedPropsEqual
	    }, extraOptions));
	  };
	}
	
	var _default = createConnect();
	
	exports.default = _default;

/***/ }),
/* 1971 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = shallowEqual;
	var hasOwn = Object.prototype.hasOwnProperty;
	
	function is(x, y) {
	  if (x === y) {
	    return x !== 0 || y !== 0 || 1 / x === 1 / y;
	  } else {
	    return x !== x && y !== y;
	  }
	}
	
	function shallowEqual(objA, objB) {
	  if (is(objA, objB)) return true;
	
	  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	  if (keysA.length !== keysB.length) return false;
	
	  for (var i = 0; i < keysA.length; i++) {
	    if (!hasOwn.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
	      return false;
	    }
	  }
	
	  return true;
	}

/***/ }),
/* 1972 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.whenMapDispatchToPropsIsFunction = whenMapDispatchToPropsIsFunction;
	exports.whenMapDispatchToPropsIsMissing = whenMapDispatchToPropsIsMissing;
	exports.whenMapDispatchToPropsIsObject = whenMapDispatchToPropsIsObject;
	exports.default = void 0;
	
	var _redux = __webpack_require__(1973);
	
	var _wrapMapToProps = __webpack_require__(1976);
	
	function whenMapDispatchToPropsIsFunction(mapDispatchToProps) {
	  return typeof mapDispatchToProps === 'function' ? (0, _wrapMapToProps.wrapMapToPropsFunc)(mapDispatchToProps, 'mapDispatchToProps') : undefined;
	}
	
	function whenMapDispatchToPropsIsMissing(mapDispatchToProps) {
	  return !mapDispatchToProps ? (0, _wrapMapToProps.wrapMapToPropsConstant)(function (dispatch) {
	    return {
	      dispatch: dispatch
	    };
	  }) : undefined;
	}
	
	function whenMapDispatchToPropsIsObject(mapDispatchToProps) {
	  return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? (0, _wrapMapToProps.wrapMapToPropsConstant)(function (dispatch) {
	    return (0, _redux.bindActionCreators)(mapDispatchToProps, dispatch);
	  }) : undefined;
	}
	
	var _default = [whenMapDispatchToPropsIsFunction, whenMapDispatchToPropsIsMissing, whenMapDispatchToPropsIsObject];
	exports.default = _default;

/***/ }),
/* 1973 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var $$observable = _interopDefault(__webpack_require__(1974));
	
	/**
	 * These are private action types reserved by Redux.
	 * For any unknown actions, you must return the current state.
	 * If the current state is undefined, you must return the initial state.
	 * Do not reference these action types directly in your code.
	 */
	var randomString = function randomString() {
	  return Math.random().toString(36).substring(7).split('').join('.');
	};
	
	var ActionTypes = {
	  INIT: "@@redux/INIT" + randomString(),
	  REPLACE: "@@redux/REPLACE" + randomString(),
	  PROBE_UNKNOWN_ACTION: function PROBE_UNKNOWN_ACTION() {
	    return "@@redux/PROBE_UNKNOWN_ACTION" + randomString();
	  }
	};
	
	/**
	 * @param {any} obj The object to inspect.
	 * @returns {boolean} True if the argument appears to be a plain object.
	 */
	function isPlainObject(obj) {
	  if (typeof obj !== 'object' || obj === null) return false;
	  var proto = obj;
	
	  while (Object.getPrototypeOf(proto) !== null) {
	    proto = Object.getPrototypeOf(proto);
	  }
	
	  return Object.getPrototypeOf(obj) === proto;
	}
	
	/**
	 * Creates a Redux store that holds the state tree.
	 * The only way to change the data in the store is to call `dispatch()` on it.
	 *
	 * There should only be a single store in your app. To specify how different
	 * parts of the state tree respond to actions, you may combine several reducers
	 * into a single reducer function by using `combineReducers`.
	 *
	 * @param {Function} reducer A function that returns the next state tree, given
	 * the current state tree and the action to handle.
	 *
	 * @param {any} [preloadedState] The initial state. You may optionally specify it
	 * to hydrate the state from the server in universal apps, or to restore a
	 * previously serialized user session.
	 * If you use `combineReducers` to produce the root reducer function, this must be
	 * an object with the same shape as `combineReducers` keys.
	 *
	 * @param {Function} [enhancer] The store enhancer. You may optionally specify it
	 * to enhance the store with third-party capabilities such as middleware,
	 * time travel, persistence, etc. The only store enhancer that ships with Redux
	 * is `applyMiddleware()`.
	 *
	 * @returns {Store} A Redux store that lets you read the state, dispatch actions
	 * and subscribe to changes.
	 */
	
	function createStore(reducer, preloadedState, enhancer) {
	  var _ref2;
	
	  if (typeof preloadedState === 'function' && typeof enhancer === 'function' || typeof enhancer === 'function' && typeof arguments[3] === 'function') {
	    throw new Error('It looks like you are passing several store enhancers to ' + 'createStore(). This is not supported. Instead, compose them ' + 'together to a single function.');
	  }
	
	  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
	    enhancer = preloadedState;
	    preloadedState = undefined;
	  }
	
	  if (typeof enhancer !== 'undefined') {
	    if (typeof enhancer !== 'function') {
	      throw new Error('Expected the enhancer to be a function.');
	    }
	
	    return enhancer(createStore)(reducer, preloadedState);
	  }
	
	  if (typeof reducer !== 'function') {
	    throw new Error('Expected the reducer to be a function.');
	  }
	
	  var currentReducer = reducer;
	  var currentState = preloadedState;
	  var currentListeners = [];
	  var nextListeners = currentListeners;
	  var isDispatching = false;
	  /**
	   * This makes a shallow copy of currentListeners so we can use
	   * nextListeners as a temporary list while dispatching.
	   *
	   * This prevents any bugs around consumers calling
	   * subscribe/unsubscribe in the middle of a dispatch.
	   */
	
	  function ensureCanMutateNextListeners() {
	    if (nextListeners === currentListeners) {
	      nextListeners = currentListeners.slice();
	    }
	  }
	  /**
	   * Reads the state tree managed by the store.
	   *
	   * @returns {any} The current state tree of your application.
	   */
	
	
	  function getState() {
	    if (isDispatching) {
	      throw new Error('You may not call store.getState() while the reducer is executing. ' + 'The reducer has already received the state as an argument. ' + 'Pass it down from the top reducer instead of reading it from the store.');
	    }
	
	    return currentState;
	  }
	  /**
	   * Adds a change listener. It will be called any time an action is dispatched,
	   * and some part of the state tree may potentially have changed. You may then
	   * call `getState()` to read the current state tree inside the callback.
	   *
	   * You may call `dispatch()` from a change listener, with the following
	   * caveats:
	   *
	   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
	   * If you subscribe or unsubscribe while the listeners are being invoked, this
	   * will not have any effect on the `dispatch()` that is currently in progress.
	   * However, the next `dispatch()` call, whether nested or not, will use a more
	   * recent snapshot of the subscription list.
	   *
	   * 2. The listener should not expect to see all state changes, as the state
	   * might have been updated multiple times during a nested `dispatch()` before
	   * the listener is called. It is, however, guaranteed that all subscribers
	   * registered before the `dispatch()` started will be called with the latest
	   * state by the time it exits.
	   *
	   * @param {Function} listener A callback to be invoked on every dispatch.
	   * @returns {Function} A function to remove this change listener.
	   */
	
	
	  function subscribe(listener) {
	    if (typeof listener !== 'function') {
	      throw new Error('Expected the listener to be a function.');
	    }
	
	    if (isDispatching) {
	      throw new Error('You may not call store.subscribe() while the reducer is executing. ' + 'If you would like to be notified after the store has been updated, subscribe from a ' + 'component and invoke store.getState() in the callback to access the latest state. ' + 'See https://redux.js.org/api-reference/store#subscribelistener for more details.');
	    }
	
	    var isSubscribed = true;
	    ensureCanMutateNextListeners();
	    nextListeners.push(listener);
	    return function unsubscribe() {
	      if (!isSubscribed) {
	        return;
	      }
	
	      if (isDispatching) {
	        throw new Error('You may not unsubscribe from a store listener while the reducer is executing. ' + 'See https://redux.js.org/api-reference/store#subscribelistener for more details.');
	      }
	
	      isSubscribed = false;
	      ensureCanMutateNextListeners();
	      var index = nextListeners.indexOf(listener);
	      nextListeners.splice(index, 1);
	      currentListeners = null;
	    };
	  }
	  /**
	   * Dispatches an action. It is the only way to trigger a state change.
	   *
	   * The `reducer` function, used to create the store, will be called with the
	   * current state tree and the given `action`. Its return value will
	   * be considered the **next** state of the tree, and the change listeners
	   * will be notified.
	   *
	   * The base implementation only supports plain object actions. If you want to
	   * dispatch a Promise, an Observable, a thunk, or something else, you need to
	   * wrap your store creating function into the corresponding middleware. For
	   * example, see the documentation for the `redux-thunk` package. Even the
	   * middleware will eventually dispatch plain object actions using this method.
	   *
	   * @param {Object} action A plain object representing “what changed”. It is
	   * a good idea to keep actions serializable so you can record and replay user
	   * sessions, or use the time travelling `redux-devtools`. An action must have
	   * a `type` property which may not be `undefined`. It is a good idea to use
	   * string constants for action types.
	   *
	   * @returns {Object} For convenience, the same action object you dispatched.
	   *
	   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
	   * return something else (for example, a Promise you can await).
	   */
	
	
	  function dispatch(action) {
	    if (!isPlainObject(action)) {
	      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
	    }
	
	    if (typeof action.type === 'undefined') {
	      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
	    }
	
	    if (isDispatching) {
	      throw new Error('Reducers may not dispatch actions.');
	    }
	
	    try {
	      isDispatching = true;
	      currentState = currentReducer(currentState, action);
	    } finally {
	      isDispatching = false;
	    }
	
	    var listeners = currentListeners = nextListeners;
	
	    for (var i = 0; i < listeners.length; i++) {
	      var listener = listeners[i];
	      listener();
	    }
	
	    return action;
	  }
	  /**
	   * Replaces the reducer currently used by the store to calculate the state.
	   *
	   * You might need this if your app implements code splitting and you want to
	   * load some of the reducers dynamically. You might also need this if you
	   * implement a hot reloading mechanism for Redux.
	   *
	   * @param {Function} nextReducer The reducer for the store to use instead.
	   * @returns {void}
	   */
	
	
	  function replaceReducer(nextReducer) {
	    if (typeof nextReducer !== 'function') {
	      throw new Error('Expected the nextReducer to be a function.');
	    }
	
	    currentReducer = nextReducer; // This action has a similiar effect to ActionTypes.INIT.
	    // Any reducers that existed in both the new and old rootReducer
	    // will receive the previous state. This effectively populates
	    // the new state tree with any relevant data from the old one.
	
	    dispatch({
	      type: ActionTypes.REPLACE
	    });
	  }
	  /**
	   * Interoperability point for observable/reactive libraries.
	   * @returns {observable} A minimal observable of state changes.
	   * For more information, see the observable proposal:
	   * https://github.com/tc39/proposal-observable
	   */
	
	
	  function observable() {
	    var _ref;
	
	    var outerSubscribe = subscribe;
	    return _ref = {
	      /**
	       * The minimal observable subscription method.
	       * @param {Object} observer Any object that can be used as an observer.
	       * The observer object should have a `next` method.
	       * @returns {subscription} An object with an `unsubscribe` method that can
	       * be used to unsubscribe the observable from the store, and prevent further
	       * emission of values from the observable.
	       */
	      subscribe: function subscribe(observer) {
	        if (typeof observer !== 'object' || observer === null) {
	          throw new TypeError('Expected the observer to be an object.');
	        }
	
	        function observeState() {
	          if (observer.next) {
	            observer.next(getState());
	          }
	        }
	
	        observeState();
	        var unsubscribe = outerSubscribe(observeState);
	        return {
	          unsubscribe: unsubscribe
	        };
	      }
	    }, _ref[$$observable] = function () {
	      return this;
	    }, _ref;
	  } // When a store is created, an "INIT" action is dispatched so that every
	  // reducer returns their initial state. This effectively populates
	  // the initial state tree.
	
	
	  dispatch({
	    type: ActionTypes.INIT
	  });
	  return _ref2 = {
	    dispatch: dispatch,
	    subscribe: subscribe,
	    getState: getState,
	    replaceReducer: replaceReducer
	  }, _ref2[$$observable] = observable, _ref2;
	}
	
	/**
	 * Prints a warning in the console if it exists.
	 *
	 * @param {String} message The warning message.
	 * @returns {void}
	 */
	function warning(message) {
	  /* eslint-disable no-console */
	  if (typeof console !== 'undefined' && typeof console.error === 'function') {
	    console.error(message);
	  }
	  /* eslint-enable no-console */
	
	
	  try {
	    // This error was thrown as a convenience so that if you enable
	    // "break on all exceptions" in your console,
	    // it would pause the execution at this line.
	    throw new Error(message);
	  } catch (e) {} // eslint-disable-line no-empty
	
	}
	
	function getUndefinedStateErrorMessage(key, action) {
	  var actionType = action && action.type;
	  var actionDescription = actionType && "action \"" + String(actionType) + "\"" || 'an action';
	  return "Given " + actionDescription + ", reducer \"" + key + "\" returned undefined. " + "To ignore an action, you must explicitly return the previous state. " + "If you want this reducer to hold no value, you can return null instead of undefined.";
	}
	
	function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
	  var reducerKeys = Object.keys(reducers);
	  var argumentName = action && action.type === ActionTypes.INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';
	
	  if (reducerKeys.length === 0) {
	    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
	  }
	
	  if (!isPlainObject(inputState)) {
	    return "The " + argumentName + " has unexpected type of \"" + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + "\". Expected argument to be an object with the following " + ("keys: \"" + reducerKeys.join('", "') + "\"");
	  }
	
	  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
	    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
	  });
	  unexpectedKeys.forEach(function (key) {
	    unexpectedKeyCache[key] = true;
	  });
	  if (action && action.type === ActionTypes.REPLACE) return;
	
	  if (unexpectedKeys.length > 0) {
	    return "Unexpected " + (unexpectedKeys.length > 1 ? 'keys' : 'key') + " " + ("\"" + unexpectedKeys.join('", "') + "\" found in " + argumentName + ". ") + "Expected to find one of the known reducer keys instead: " + ("\"" + reducerKeys.join('", "') + "\". Unexpected keys will be ignored.");
	  }
	}
	
	function assertReducerShape(reducers) {
	  Object.keys(reducers).forEach(function (key) {
	    var reducer = reducers[key];
	    var initialState = reducer(undefined, {
	      type: ActionTypes.INIT
	    });
	
	    if (typeof initialState === 'undefined') {
	      throw new Error("Reducer \"" + key + "\" returned undefined during initialization. " + "If the state passed to the reducer is undefined, you must " + "explicitly return the initial state. The initial state may " + "not be undefined. If you don't want to set a value for this reducer, " + "you can use null instead of undefined.");
	    }
	
	    if (typeof reducer(undefined, {
	      type: ActionTypes.PROBE_UNKNOWN_ACTION()
	    }) === 'undefined') {
	      throw new Error("Reducer \"" + key + "\" returned undefined when probed with a random type. " + ("Don't try to handle " + ActionTypes.INIT + " or other actions in \"redux/*\" ") + "namespace. They are considered private. Instead, you must return the " + "current state for any unknown actions, unless it is undefined, " + "in which case you must return the initial state, regardless of the " + "action type. The initial state may not be undefined, but can be null.");
	    }
	  });
	}
	/**
	 * Turns an object whose values are different reducer functions, into a single
	 * reducer function. It will call every child reducer, and gather their results
	 * into a single state object, whose keys correspond to the keys of the passed
	 * reducer functions.
	 *
	 * @param {Object} reducers An object whose values correspond to different
	 * reducer functions that need to be combined into one. One handy way to obtain
	 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
	 * undefined for any action. Instead, they should return their initial state
	 * if the state passed to them was undefined, and the current state for any
	 * unrecognized action.
	 *
	 * @returns {Function} A reducer function that invokes every reducer inside the
	 * passed object, and builds a state object with the same shape.
	 */
	
	
	function combineReducers(reducers) {
	  var reducerKeys = Object.keys(reducers);
	  var finalReducers = {};
	
	  for (var i = 0; i < reducerKeys.length; i++) {
	    var key = reducerKeys[i];
	
	    if (false) {
	      if (typeof reducers[key] === 'undefined') {
	        warning("No reducer provided for key \"" + key + "\"");
	      }
	    }
	
	    if (typeof reducers[key] === 'function') {
	      finalReducers[key] = reducers[key];
	    }
	  }
	
	  var finalReducerKeys = Object.keys(finalReducers); // This is used to make sure we don't warn about the same
	  // keys multiple times.
	
	  var unexpectedKeyCache;
	
	  if (false) {
	    unexpectedKeyCache = {};
	  }
	
	  var shapeAssertionError;
	
	  try {
	    assertReducerShape(finalReducers);
	  } catch (e) {
	    shapeAssertionError = e;
	  }
	
	  return function combination(state, action) {
	    if (state === void 0) {
	      state = {};
	    }
	
	    if (shapeAssertionError) {
	      throw shapeAssertionError;
	    }
	
	    if (false) {
	      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);
	
	      if (warningMessage) {
	        warning(warningMessage);
	      }
	    }
	
	    var hasChanged = false;
	    var nextState = {};
	
	    for (var _i = 0; _i < finalReducerKeys.length; _i++) {
	      var _key = finalReducerKeys[_i];
	      var reducer = finalReducers[_key];
	      var previousStateForKey = state[_key];
	      var nextStateForKey = reducer(previousStateForKey, action);
	
	      if (typeof nextStateForKey === 'undefined') {
	        var errorMessage = getUndefinedStateErrorMessage(_key, action);
	        throw new Error(errorMessage);
	      }
	
	      nextState[_key] = nextStateForKey;
	      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
	    }
	
	    hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
	    return hasChanged ? nextState : state;
	  };
	}
	
	function bindActionCreator(actionCreator, dispatch) {
	  return function () {
	    return dispatch(actionCreator.apply(this, arguments));
	  };
	}
	/**
	 * Turns an object whose values are action creators, into an object with the
	 * same keys, but with every function wrapped into a `dispatch` call so they
	 * may be invoked directly. This is just a convenience method, as you can call
	 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
	 *
	 * For convenience, you can also pass an action creator as the first argument,
	 * and get a dispatch wrapped function in return.
	 *
	 * @param {Function|Object} actionCreators An object whose values are action
	 * creator functions. One handy way to obtain it is to use ES6 `import * as`
	 * syntax. You may also pass a single function.
	 *
	 * @param {Function} dispatch The `dispatch` function available on your Redux
	 * store.
	 *
	 * @returns {Function|Object} The object mimicking the original object, but with
	 * every action creator wrapped into the `dispatch` call. If you passed a
	 * function as `actionCreators`, the return value will also be a single
	 * function.
	 */
	
	
	function bindActionCreators(actionCreators, dispatch) {
	  if (typeof actionCreators === 'function') {
	    return bindActionCreator(actionCreators, dispatch);
	  }
	
	  if (typeof actionCreators !== 'object' || actionCreators === null) {
	    throw new Error("bindActionCreators expected an object or a function, instead received " + (actionCreators === null ? 'null' : typeof actionCreators) + ". " + "Did you write \"import ActionCreators from\" instead of \"import * as ActionCreators from\"?");
	  }
	
	  var boundActionCreators = {};
	
	  for (var key in actionCreators) {
	    var actionCreator = actionCreators[key];
	
	    if (typeof actionCreator === 'function') {
	      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
	    }
	  }
	
	  return boundActionCreators;
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }
	
	  return obj;
	}
	
	function ownKeys(object, enumerableOnly) {
	  var keys = Object.keys(object);
	
	  if (Object.getOwnPropertySymbols) {
	    keys.push.apply(keys, Object.getOwnPropertySymbols(object));
	  }
	
	  if (enumerableOnly) keys = keys.filter(function (sym) {
	    return Object.getOwnPropertyDescriptor(object, sym).enumerable;
	  });
	  return keys;
	}
	
	function _objectSpread2(target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i] != null ? arguments[i] : {};
	
	    if (i % 2) {
	      ownKeys(source, true).forEach(function (key) {
	        _defineProperty(target, key, source[key]);
	      });
	    } else if (Object.getOwnPropertyDescriptors) {
	      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
	    } else {
	      ownKeys(source).forEach(function (key) {
	        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
	      });
	    }
	  }
	
	  return target;
	}
	
	/**
	 * Composes single-argument functions from right to left. The rightmost
	 * function can take multiple arguments as it provides the signature for
	 * the resulting composite function.
	 *
	 * @param {...Function} funcs The functions to compose.
	 * @returns {Function} A function obtained by composing the argument functions
	 * from right to left. For example, compose(f, g, h) is identical to doing
	 * (...args) => f(g(h(...args))).
	 */
	function compose() {
	  for (var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++) {
	    funcs[_key] = arguments[_key];
	  }
	
	  if (funcs.length === 0) {
	    return function (arg) {
	      return arg;
	    };
	  }
	
	  if (funcs.length === 1) {
	    return funcs[0];
	  }
	
	  return funcs.reduce(function (a, b) {
	    return function () {
	      return a(b.apply(void 0, arguments));
	    };
	  });
	}
	
	/**
	 * Creates a store enhancer that applies middleware to the dispatch method
	 * of the Redux store. This is handy for a variety of tasks, such as expressing
	 * asynchronous actions in a concise manner, or logging every action payload.
	 *
	 * See `redux-thunk` package as an example of the Redux middleware.
	 *
	 * Because middleware is potentially asynchronous, this should be the first
	 * store enhancer in the composition chain.
	 *
	 * Note that each middleware will be given the `dispatch` and `getState` functions
	 * as named arguments.
	 *
	 * @param {...Function} middlewares The middleware chain to be applied.
	 * @returns {Function} A store enhancer applying the middleware.
	 */
	
	function applyMiddleware() {
	  for (var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++) {
	    middlewares[_key] = arguments[_key];
	  }
	
	  return function (createStore) {
	    return function () {
	      var store = createStore.apply(void 0, arguments);
	
	      var _dispatch = function dispatch() {
	        throw new Error('Dispatching while constructing your middleware is not allowed. ' + 'Other middleware would not be applied to this dispatch.');
	      };
	
	      var middlewareAPI = {
	        getState: store.getState,
	        dispatch: function dispatch() {
	          return _dispatch.apply(void 0, arguments);
	        }
	      };
	      var chain = middlewares.map(function (middleware) {
	        return middleware(middlewareAPI);
	      });
	      _dispatch = compose.apply(void 0, chain)(store.dispatch);
	      return _objectSpread2({}, store, {
	        dispatch: _dispatch
	      });
	    };
	  };
	}
	
	/*
	 * This is a dummy function to check if the function name has been altered by minification.
	 * If the function has been minified and NODE_ENV !== 'production', warn the user.
	 */
	
	function isCrushed() {}
	
	if (false) {
	  warning('You are currently using minified code outside of NODE_ENV === "production". ' + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or setting mode to production in webpack (https://webpack.js.org/concepts/mode/) ' + 'to ensure you have the correct code for your production build.');
	}
	
	exports.__DO_NOT_USE__ActionTypes = ActionTypes;
	exports.applyMiddleware = applyMiddleware;
	exports.bindActionCreators = bindActionCreators;
	exports.combineReducers = combineReducers;
	exports.compose = compose;
	exports.createStore = createStore;


/***/ }),
/* 1974 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, module) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ponyfill = __webpack_require__(1975);
	
	var _ponyfill2 = _interopRequireDefault(_ponyfill);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var root; /* global window */
	
	
	if (typeof self !== 'undefined') {
	  root = self;
	} else if (typeof window !== 'undefined') {
	  root = window;
	} else if (typeof global !== 'undefined') {
	  root = global;
	} else if (true) {
	  root = module;
	} else {
	  root = Function('return this')();
	}
	
	var result = (0, _ponyfill2['default'])(root);
	exports['default'] = result;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(485)(module)))

/***/ }),
/* 1975 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports['default'] = symbolObservablePonyfill;
	function symbolObservablePonyfill(root) {
		var result;
		var _Symbol = root.Symbol;
	
		if (typeof _Symbol === 'function') {
			if (_Symbol.observable) {
				result = _Symbol.observable;
			} else {
				result = _Symbol('observable');
				_Symbol.observable = result;
			}
		} else {
			result = '@@observable';
		}
	
		return result;
	};

/***/ }),
/* 1976 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1488);
	
	exports.__esModule = true;
	exports.wrapMapToPropsConstant = wrapMapToPropsConstant;
	exports.getDependsOnOwnProps = getDependsOnOwnProps;
	exports.wrapMapToPropsFunc = wrapMapToPropsFunc;
	
	var _verifyPlainObject = _interopRequireDefault(__webpack_require__(1977));
	
	function wrapMapToPropsConstant(getConstant) {
	  return function initConstantSelector(dispatch, options) {
	    var constant = getConstant(dispatch, options);
	
	    function constantSelector() {
	      return constant;
	    }
	
	    constantSelector.dependsOnOwnProps = false;
	    return constantSelector;
	  };
	} // dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
	// to the mapToProps function being wrapped. It is also used by makePurePropsSelector to determine
	// whether mapToProps needs to be invoked when props have changed.
	// 
	// A length of one signals that mapToProps does not depend on props from the parent component.
	// A length of zero is assumed to mean mapToProps is getting args via arguments or ...args and
	// therefore not reporting its length accurately..
	
	
	function getDependsOnOwnProps(mapToProps) {
	  return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
	} // Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
	// this function wraps mapToProps in a proxy function which does several things:
	// 
	//  * Detects whether the mapToProps function being called depends on props, which
	//    is used by selectorFactory to decide if it should reinvoke on props changes.
	//    
	//  * On first call, handles mapToProps if returns another function, and treats that
	//    new function as the true mapToProps for subsequent calls.
	//    
	//  * On first call, verifies the first result is a plain object, in order to warn
	//    the developer that their mapToProps function is not returning a valid result.
	//    
	
	
	function wrapMapToPropsFunc(mapToProps, methodName) {
	  return function initProxySelector(dispatch, _ref) {
	    var displayName = _ref.displayName;
	
	    var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
	      return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
	    }; // allow detectFactoryAndVerify to get ownProps
	
	
	    proxy.dependsOnOwnProps = true;
	
	    proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
	      proxy.mapToProps = mapToProps;
	      proxy.dependsOnOwnProps = getDependsOnOwnProps(mapToProps);
	      var props = proxy(stateOrDispatch, ownProps);
	
	      if (typeof props === 'function') {
	        proxy.mapToProps = props;
	        proxy.dependsOnOwnProps = getDependsOnOwnProps(props);
	        props = proxy(stateOrDispatch, ownProps);
	      }
	
	      if (false) (0, _verifyPlainObject.default)(props, displayName, methodName);
	      return props;
	    };
	
	    return proxy;
	  };
	}

/***/ }),
/* 1977 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1488);
	
	exports.__esModule = true;
	exports.default = verifyPlainObject;
	
	var _isPlainObject = _interopRequireDefault(__webpack_require__(1978));
	
	var _warning = _interopRequireDefault(__webpack_require__(1963));
	
	function verifyPlainObject(value, displayName, methodName) {
	  if (!(0, _isPlainObject.default)(value)) {
	    (0, _warning.default)(methodName + "() in " + displayName + " must return a plain object. Instead received " + value + ".");
	  }
	}

/***/ }),
/* 1978 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = isPlainObject;
	
	/**
	 * @param {any} obj The object to inspect.
	 * @returns {boolean} True if the argument appears to be a plain object.
	 */
	function isPlainObject(obj) {
	  if (typeof obj !== 'object' || obj === null) return false;
	  var proto = Object.getPrototypeOf(obj);
	  if (proto === null) return true;
	  var baseProto = proto;
	
	  while (Object.getPrototypeOf(baseProto) !== null) {
	    baseProto = Object.getPrototypeOf(baseProto);
	  }
	
	  return proto === baseProto;
	}

/***/ }),
/* 1979 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.whenMapStateToPropsIsFunction = whenMapStateToPropsIsFunction;
	exports.whenMapStateToPropsIsMissing = whenMapStateToPropsIsMissing;
	exports.default = void 0;
	
	var _wrapMapToProps = __webpack_require__(1976);
	
	function whenMapStateToPropsIsFunction(mapStateToProps) {
	  return typeof mapStateToProps === 'function' ? (0, _wrapMapToProps.wrapMapToPropsFunc)(mapStateToProps, 'mapStateToProps') : undefined;
	}
	
	function whenMapStateToPropsIsMissing(mapStateToProps) {
	  return !mapStateToProps ? (0, _wrapMapToProps.wrapMapToPropsConstant)(function () {
	    return {};
	  }) : undefined;
	}
	
	var _default = [whenMapStateToPropsIsFunction, whenMapStateToPropsIsMissing];
	exports.default = _default;

/***/ }),
/* 1980 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1488);
	
	exports.__esModule = true;
	exports.defaultMergeProps = defaultMergeProps;
	exports.wrapMergePropsFunc = wrapMergePropsFunc;
	exports.whenMergePropsIsFunction = whenMergePropsIsFunction;
	exports.whenMergePropsIsOmitted = whenMergePropsIsOmitted;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(1965));
	
	var _verifyPlainObject = _interopRequireDefault(__webpack_require__(1977));
	
	function defaultMergeProps(stateProps, dispatchProps, ownProps) {
	  return (0, _extends2.default)({}, ownProps, stateProps, dispatchProps);
	}
	
	function wrapMergePropsFunc(mergeProps) {
	  return function initMergePropsProxy(dispatch, _ref) {
	    var displayName = _ref.displayName,
	        pure = _ref.pure,
	        areMergedPropsEqual = _ref.areMergedPropsEqual;
	    var hasRunOnce = false;
	    var mergedProps;
	    return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
	      var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	
	      if (hasRunOnce) {
	        if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
	      } else {
	        hasRunOnce = true;
	        mergedProps = nextMergedProps;
	        if (false) (0, _verifyPlainObject.default)(mergedProps, displayName, 'mergeProps');
	      }
	
	      return mergedProps;
	    };
	  };
	}
	
	function whenMergePropsIsFunction(mergeProps) {
	  return typeof mergeProps === 'function' ? wrapMergePropsFunc(mergeProps) : undefined;
	}
	
	function whenMergePropsIsOmitted(mergeProps) {
	  return !mergeProps ? function () {
	    return defaultMergeProps;
	  } : undefined;
	}
	
	var _default = [whenMergePropsIsFunction, whenMergePropsIsOmitted];
	exports.default = _default;

/***/ }),
/* 1981 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1488);
	
	exports.__esModule = true;
	exports.impureFinalPropsSelectorFactory = impureFinalPropsSelectorFactory;
	exports.pureFinalPropsSelectorFactory = pureFinalPropsSelectorFactory;
	exports.default = finalPropsSelectorFactory;
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(1966));
	
	var _verifySubselectors = _interopRequireDefault(__webpack_require__(1982));
	
	function impureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
	  return function impureFinalPropsSelector(state, ownProps) {
	    return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
	  };
	}
	
	function pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
	  var areStatesEqual = _ref.areStatesEqual,
	      areOwnPropsEqual = _ref.areOwnPropsEqual,
	      areStatePropsEqual = _ref.areStatePropsEqual;
	  var hasRunAtLeastOnce = false;
	  var state;
	  var ownProps;
	  var stateProps;
	  var dispatchProps;
	  var mergedProps;
	
	  function handleFirstCall(firstState, firstOwnProps) {
	    state = firstState;
	    ownProps = firstOwnProps;
	    stateProps = mapStateToProps(state, ownProps);
	    dispatchProps = mapDispatchToProps(dispatch, ownProps);
	    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	    hasRunAtLeastOnce = true;
	    return mergedProps;
	  }
	
	  function handleNewPropsAndNewState() {
	    stateProps = mapStateToProps(state, ownProps);
	    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
	    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	    return mergedProps;
	  }
	
	  function handleNewProps() {
	    if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
	    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
	    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	    return mergedProps;
	  }
	
	  function handleNewState() {
	    var nextStateProps = mapStateToProps(state, ownProps);
	    var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
	    stateProps = nextStateProps;
	    if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	    return mergedProps;
	  }
	
	  function handleSubsequentCalls(nextState, nextOwnProps) {
	    var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
	    var stateChanged = !areStatesEqual(nextState, state);
	    state = nextState;
	    ownProps = nextOwnProps;
	    if (propsChanged && stateChanged) return handleNewPropsAndNewState();
	    if (propsChanged) return handleNewProps();
	    if (stateChanged) return handleNewState();
	    return mergedProps;
	  }
	
	  return function pureFinalPropsSelector(nextState, nextOwnProps) {
	    return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
	  };
	} // TODO: Add more comments
	// If pure is true, the selector returned by selectorFactory will memoize its results,
	// allowing connectAdvanced's shouldComponentUpdate to return false if final
	// props have not changed. If false, the selector will always return a new
	// object and shouldComponentUpdate will always return true.
	
	
	function finalPropsSelectorFactory(dispatch, _ref2) {
	  var initMapStateToProps = _ref2.initMapStateToProps,
	      initMapDispatchToProps = _ref2.initMapDispatchToProps,
	      initMergeProps = _ref2.initMergeProps,
	      options = (0, _objectWithoutPropertiesLoose2.default)(_ref2, ["initMapStateToProps", "initMapDispatchToProps", "initMergeProps"]);
	  var mapStateToProps = initMapStateToProps(dispatch, options);
	  var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
	  var mergeProps = initMergeProps(dispatch, options);
	
	  if (false) {
	    (0, _verifySubselectors.default)(mapStateToProps, mapDispatchToProps, mergeProps, options.displayName);
	  }
	
	  var selectorFactory = options.pure ? pureFinalPropsSelectorFactory : impureFinalPropsSelectorFactory;
	  return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
	}

/***/ }),
/* 1982 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1488);
	
	exports.__esModule = true;
	exports.default = verifySubselectors;
	
	var _warning = _interopRequireDefault(__webpack_require__(1963));
	
	function verify(selector, methodName, displayName) {
	  if (!selector) {
	    throw new Error("Unexpected value for " + methodName + " in " + displayName + ".");
	  } else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
	    if (!selector.hasOwnProperty('dependsOnOwnProps')) {
	      (0, _warning.default)("The selector for " + methodName + " of " + displayName + " did not specify a value for dependsOnOwnProps.");
	    }
	  }
	}
	
	function verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
	  verify(mapStateToProps, 'mapStateToProps', displayName);
	  verify(mapDispatchToProps, 'mapDispatchToProps', displayName);
	  verify(mergeProps, 'mergeProps', displayName);
	}

/***/ }),
/* 1983 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.defaultMemoize = defaultMemoize;
	exports.createSelectorCreator = createSelectorCreator;
	exports.createStructuredSelector = createStructuredSelector;
	function defaultEqualityCheck(a, b) {
	  return a === b;
	}
	
	function areArgumentsShallowlyEqual(equalityCheck, prev, next) {
	  if (prev === null || next === null || prev.length !== next.length) {
	    return false;
	  }
	
	  // Do this in a for loop (and not a `forEach` or an `every`) so we can determine equality as fast as possible.
	  var length = prev.length;
	  for (var i = 0; i < length; i++) {
	    if (!equalityCheck(prev[i], next[i])) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	function defaultMemoize(func) {
	  var equalityCheck = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultEqualityCheck;
	
	  var lastArgs = null;
	  var lastResult = null;
	  // we reference arguments instead of spreading them for performance reasons
	  return function () {
	    if (!areArgumentsShallowlyEqual(equalityCheck, lastArgs, arguments)) {
	      // apply arguments instead of spreading for performance.
	      lastResult = func.apply(null, arguments);
	    }
	
	    lastArgs = arguments;
	    return lastResult;
	  };
	}
	
	function getDependencies(funcs) {
	  var dependencies = Array.isArray(funcs[0]) ? funcs[0] : funcs;
	
	  if (!dependencies.every(function (dep) {
	    return typeof dep === 'function';
	  })) {
	    var dependencyTypes = dependencies.map(function (dep) {
	      return typeof dep;
	    }).join(', ');
	    throw new Error('Selector creators expect all input-selectors to be functions, ' + ('instead received the following types: [' + dependencyTypes + ']'));
	  }
	
	  return dependencies;
	}
	
	function createSelectorCreator(memoize) {
	  for (var _len = arguments.length, memoizeOptions = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    memoizeOptions[_key - 1] = arguments[_key];
	  }
	
	  return function () {
	    for (var _len2 = arguments.length, funcs = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	      funcs[_key2] = arguments[_key2];
	    }
	
	    var recomputations = 0;
	    var resultFunc = funcs.pop();
	    var dependencies = getDependencies(funcs);
	
	    var memoizedResultFunc = memoize.apply(undefined, [function () {
	      recomputations++;
	      // apply arguments instead of spreading for performance.
	      return resultFunc.apply(null, arguments);
	    }].concat(memoizeOptions));
	
	    // If a selector is called with the exact same arguments we don't need to traverse our dependencies again.
	    var selector = defaultMemoize(function () {
	      var params = [];
	      var length = dependencies.length;
	
	      for (var i = 0; i < length; i++) {
	        // apply arguments instead of spreading and mutate a local list of params for performance.
	        params.push(dependencies[i].apply(null, arguments));
	      }
	
	      // apply arguments instead of spreading for performance.
	      return memoizedResultFunc.apply(null, params);
	    });
	
	    selector.resultFunc = resultFunc;
	    selector.recomputations = function () {
	      return recomputations;
	    };
	    selector.resetRecomputations = function () {
	      return recomputations = 0;
	    };
	    return selector;
	  };
	}
	
	var createSelector = exports.createSelector = createSelectorCreator(defaultMemoize);
	
	function createStructuredSelector(selectors) {
	  var selectorCreator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : createSelector;
	
	  if (typeof selectors !== 'object') {
	    throw new Error('createStructuredSelector expects first argument to be an object ' + ('where each property is a selector, instead received a ' + typeof selectors));
	  }
	  var objectKeys = Object.keys(selectors);
	  return selectorCreator(objectKeys.map(function (key) {
	    return selectors[key];
	  }), function () {
	    for (var _len3 = arguments.length, values = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
	      values[_key3] = arguments[_key3];
	    }
	
	    return values.reduce(function (composition, value, index) {
	      composition[objectKeys[index]] = value;
	      return composition;
	    }, {});
	  });
	}

/***/ }),
/* 1984 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.draggingDraggableSelector = exports.dragSelector = exports.pendingDropSelector = exports.phaseSelector = undefined;
	
	var _reselect = __webpack_require__(1983);
	
	var phaseSelector = exports.phaseSelector = function phaseSelector(state) {
	  return state.phase;
	};
	
	var pendingDropSelector = exports.pendingDropSelector = function pendingDropSelector(state) {
	  if (!state.drop || !state.drop.pending) {
	    return null;
	  }
	  return state.drop.pending;
	};
	
	var dragSelector = exports.dragSelector = function dragSelector(state) {
	  return state.drag;
	};
	
	var draggableMapSelector = function draggableMapSelector(state) {
	  return state.dimension.draggable;
	};
	
	var draggingDraggableSelector = exports.draggingDraggableSelector = (0, _reselect.createSelector)([phaseSelector, dragSelector, pendingDropSelector, draggableMapSelector], function (phase, drag, pending, draggables) {
	  if (phase === 'DRAGGING') {
	    if (!drag) {
	      console.error('cannot get placeholder dimensions as there is an invalid drag state');
	      return null;
	    }
	
	    var draggable = draggables[drag.initial.descriptor.id];
	    return draggable;
	  }
	
	  if (phase === 'DROP_ANIMATING') {
	    if (!pending) {
	      console.error('cannot get placeholder dimensions as there is an invalid drag state');
	      return null;
	    }
	
	    if (!pending.result.destination) {
	      return null;
	    }
	
	    var _draggable = draggables[pending.result.draggableId];
	    return _draggable;
	  }
	
	  return null;
	});

/***/ }),
/* 1985 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(1878);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(1879);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(1883);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _Droppable$contextTyp, _Droppable$childConte;
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(956);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _droppableDimensionPublisher = __webpack_require__(1986);
	
	var _droppableDimensionPublisher2 = _interopRequireDefault(_droppableDimensionPublisher);
	
	var _placeholder = __webpack_require__(1990);
	
	var _placeholder2 = _interopRequireDefault(_placeholder);
	
	var _contextKeys = __webpack_require__(1952);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Droppable = function (_Component) {
	  (0, _inherits3.default)(Droppable, _Component);
	
	  function Droppable(props, context) {
	    (0, _classCallCheck3.default)(this, Droppable);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, _Component.call(this, props, context));
	
	    _this.state = {
	      ref: null
	    };
	
	    _this.setRef = function (ref) {
	      if (ref === null) {
	        return;
	      }
	
	      if (ref === _this.state.ref) {
	        return;
	      }
	
	      _this.setState({
	        ref: ref
	      });
	    };
	
	    _this.styleContext = context[_contextKeys.styleContextKey];
	    return _this;
	  }
	
	  Droppable.prototype.getChildContext = function getChildContext() {
	    var _value;
	
	    var value = (_value = {}, _value[_contextKeys.droppableIdKey] = this.props.droppableId, _value);
	    return value;
	  };
	
	  Droppable.prototype.getPlaceholder = function getPlaceholder() {
	    if (!this.props.placeholder) {
	      return null;
	    }
	
	    return _react2.default.createElement(_placeholder2.default, { placeholder: this.props.placeholder });
	  };
	
	  Droppable.prototype.render = function render() {
	    var _props = this.props,
	        children = _props.children,
	        direction = _props.direction,
	        droppableId = _props.droppableId,
	        ignoreContainerClipping = _props.ignoreContainerClipping,
	        isDraggingOver = _props.isDraggingOver,
	        isDropDisabled = _props.isDropDisabled,
	        draggingOverWith = _props.draggingOverWith,
	        type = _props.type;
	
	    var provided = {
	      innerRef: this.setRef,
	      placeholder: this.getPlaceholder(),
	      droppableProps: {
	        'data-react-beautiful-dnd-droppable': this.styleContext
	      }
	    };
	    var snapshot = {
	      isDraggingOver: isDraggingOver,
	      draggingOverWith: draggingOverWith
	    };
	
	    return _react2.default.createElement(
	      _droppableDimensionPublisher2.default,
	      {
	        droppableId: droppableId,
	        type: type,
	        direction: direction,
	        ignoreContainerClipping: ignoreContainerClipping,
	        isDropDisabled: isDropDisabled,
	        targetRef: this.state.ref
	      },
	      children(provided, snapshot)
	    );
	  };
	
	  return Droppable;
	}(_react.Component);
	
	Droppable.defaultProps = {
	  type: 'DEFAULT',
	  isDropDisabled: false,
	  direction: 'vertical',
	  ignoreContainerClipping: false
	};
	Droppable.contextTypes = (_Droppable$contextTyp = {}, _Droppable$contextTyp[_contextKeys.styleContextKey] = _propTypes2.default.string.isRequired, _Droppable$contextTyp);
	Droppable.childContextTypes = (_Droppable$childConte = {}, _Droppable$childConte[_contextKeys.droppableIdKey] = _propTypes2.default.string.isRequired, _Droppable$childConte);
	exports.default = Droppable;

/***/ }),
/* 1986 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _droppableDimensionPublisher = __webpack_require__(1987);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_droppableDimensionPublisher).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 1987 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(1878);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(1879);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(1883);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _DroppableDimensionPu;
	
	var _react = __webpack_require__(300);
	
	var _propTypes = __webpack_require__(956);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _memoizeOne = __webpack_require__(1903);
	
	var _memoizeOne2 = _interopRequireDefault(_memoizeOne);
	
	var _rafSchd = __webpack_require__(1948);
	
	var _rafSchd2 = _interopRequireDefault(_rafSchd);
	
	var _getWindowScroll = __webpack_require__(1988);
	
	var _getWindowScroll2 = _interopRequireDefault(_getWindowScroll);
	
	var _getArea = __webpack_require__(1908);
	
	var _getArea2 = _interopRequireDefault(_getArea);
	
	var _dimension = __webpack_require__(1913);
	
	var _getClosestScrollable = __webpack_require__(1989);
	
	var _getClosestScrollable2 = _interopRequireDefault(_getClosestScrollable);
	
	var _contextKeys = __webpack_require__(1952);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var origin = { x: 0, y: 0 };
	
	var DroppableDimensionPublisher = function (_Component) {
	  (0, _inherits3.default)(DroppableDimensionPublisher, _Component);
	
	  function DroppableDimensionPublisher(props, context) {
	    (0, _classCallCheck3.default)(this, DroppableDimensionPublisher);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, _Component.call(this, props, context));
	
	    _this.closestScrollable = null;
	    _this.isWatchingScroll = false;
	    _this.scrollOptions = null;
	    _this.publishedDescriptor = null;
	
	    _this.getClosestScroll = function () {
	      if (!_this.closestScrollable) {
	        return origin;
	      }
	
	      var offset = {
	        x: _this.closestScrollable.scrollLeft,
	        y: _this.closestScrollable.scrollTop
	      };
	
	      return offset;
	    };
	
	    _this.memoizedUpdateScroll = (0, _memoizeOne2.default)(function (x, y) {
	      if (!_this.publishedDescriptor) {
	        console.error('Cannot update scroll on unpublished droppable');
	        return;
	      }
	
	      var newScroll = { x: x, y: y };
	      var marshal = _this.context[_contextKeys.dimensionMarshalKey];
	      marshal.updateDroppableScroll(_this.publishedDescriptor.id, newScroll);
	    });
	
	    _this.updateScroll = function () {
	      var offset = _this.getClosestScroll();
	      _this.memoizedUpdateScroll(offset.x, offset.y);
	    };
	
	    _this.scheduleScrollUpdate = (0, _rafSchd2.default)(_this.updateScroll);
	
	    _this.onClosestScroll = function () {
	      if (!_this.scrollOptions) {
	        console.error('Cannot find scroll options while scrolling');
	        return;
	      }
	      if (_this.scrollOptions.shouldPublishImmediately) {
	        _this.updateScroll();
	        return;
	      }
	      _this.scheduleScrollUpdate();
	    };
	
	    _this.scroll = function (change) {
	      if (_this.closestScrollable == null) {
	        console.error('Cannot scroll a droppable with no closest scrollable');
	        return;
	      }
	
	      if (!_this.isWatchingScroll) {
	        console.error('Updating Droppable scroll while not watching for updates');
	        return;
	      }
	
	      _this.closestScrollable.scrollTop += change.y;
	      _this.closestScrollable.scrollLeft += change.x;
	    };
	
	    _this.watchScroll = function (options) {
	      if (!_this.props.targetRef) {
	        console.error('cannot watch droppable scroll if not in the dom');
	        return;
	      }
	
	      if (_this.closestScrollable == null) {
	        return;
	      }
	
	      if (_this.isWatchingScroll) {
	        return;
	      }
	
	      _this.isWatchingScroll = true;
	      _this.scrollOptions = options;
	      _this.closestScrollable.addEventListener('scroll', _this.onClosestScroll, { passive: true });
	    };
	
	    _this.unwatchScroll = function () {
	      if (!_this.isWatchingScroll) {
	        return;
	      }
	
	      _this.isWatchingScroll = false;
	      _this.scrollOptions = null;
	      _this.scheduleScrollUpdate.cancel();
	
	      if (!_this.closestScrollable) {
	        console.error('cannot unbind event listener if element is null');
	        return;
	      }
	
	      _this.closestScrollable.removeEventListener('scroll', _this.onClosestScroll);
	    };
	
	    _this.getMemoizedDescriptor = (0, _memoizeOne2.default)(function (id, type) {
	      return {
	        id: id,
	        type: type
	      };
	    });
	
	    _this.unpublish = function () {
	      if (!_this.publishedDescriptor) {
	        console.error('cannot unpublish descriptor when none is published');
	        return;
	      }
	
	      var marshal = _this.context[_contextKeys.dimensionMarshalKey];
	      marshal.unregisterDroppable(_this.publishedDescriptor);
	      _this.publishedDescriptor = null;
	    };
	
	    _this.publish = function (descriptor) {
	      if (descriptor === _this.publishedDescriptor) {
	        return;
	      }
	
	      if (_this.publishedDescriptor) {
	        _this.unpublish();
	      }
	
	      var marshal = _this.context[_contextKeys.dimensionMarshalKey];
	      marshal.registerDroppable(descriptor, _this.callbacks);
	      _this.publishedDescriptor = descriptor;
	    };
	
	    _this.getDimension = function () {
	      var _this$props = _this.props,
	          direction = _this$props.direction,
	          ignoreContainerClipping = _this$props.ignoreContainerClipping,
	          isDropDisabled = _this$props.isDropDisabled,
	          targetRef = _this$props.targetRef;
	
	
	      if (!targetRef) {
	        throw new Error('DimensionPublisher cannot calculate a dimension when not attached to the DOM');
	      }
	
	      if (_this.isWatchingScroll) {
	        throw new Error('Attempting to recapture Droppable dimension while already watching scroll on previous capture');
	      }
	
	      var descriptor = _this.publishedDescriptor;
	
	      if (!descriptor) {
	        throw new Error('Cannot get dimension for unpublished droppable');
	      }
	
	      _this.closestScrollable = (0, _getClosestScrollable2.default)(targetRef);
	      var style = window.getComputedStyle(targetRef);
	
	      var margin = {
	        top: parseInt(style.marginTop, 10),
	        right: parseInt(style.marginRight, 10),
	        bottom: parseInt(style.marginBottom, 10),
	        left: parseInt(style.marginLeft, 10)
	      };
	      var padding = {
	        top: parseInt(style.paddingTop, 10),
	        right: parseInt(style.paddingRight, 10),
	        bottom: parseInt(style.paddingBottom, 10),
	        left: parseInt(style.paddingLeft, 10)
	      };
	
	      var paddingBox = (0, _getArea2.default)(targetRef.getBoundingClientRect());
	
	      var closest = function () {
	        var closestScrollable = _this.closestScrollable;
	
	        if (!closestScrollable) {
	          return null;
	        }
	
	        var framePaddingBox = (0, _getArea2.default)(closestScrollable.getBoundingClientRect());
	        var scroll = _this.getClosestScroll();
	        var scrollWidth = closestScrollable.scrollWidth;
	        var scrollHeight = closestScrollable.scrollHeight;
	
	        return {
	          framePaddingBox: framePaddingBox,
	          scrollWidth: scrollWidth,
	          scrollHeight: scrollHeight,
	          scroll: scroll,
	          shouldClipSubject: !ignoreContainerClipping
	        };
	      }();
	
	      var dimension = (0, _dimension.getDroppableDimension)({
	        descriptor: descriptor,
	        direction: direction,
	        paddingBox: paddingBox,
	        closest: closest,
	        margin: margin,
	        padding: padding,
	        windowScroll: (0, _getWindowScroll2.default)(),
	        isEnabled: !isDropDisabled
	      });
	
	      return dimension;
	    };
	
	    var callbacks = {
	      getDimension: _this.getDimension,
	      watchScroll: _this.watchScroll,
	      unwatchScroll: _this.unwatchScroll,
	      scroll: _this.scroll
	    };
	    _this.callbacks = callbacks;
	    return _this;
	  }
	
	  DroppableDimensionPublisher.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    if (!nextProps.targetRef) {
	      console.error('Cannot update droppable dimension publisher without a target ref');
	      return;
	    }
	
	    var droppableId = nextProps.droppableId,
	        type = nextProps.type;
	
	    var descriptor = this.getMemoizedDescriptor(droppableId, type);
	
	    this.publish(descriptor);
	
	    if (this.props.isDropDisabled === nextProps.isDropDisabled) {
	      return;
	    }
	
	    var marshal = this.context[_contextKeys.dimensionMarshalKey];
	    marshal.updateDroppableIsEnabled(nextProps.droppableId, !nextProps.isDropDisabled);
	  };
	
	  DroppableDimensionPublisher.prototype.componentWillUnmount = function componentWillUnmount() {
	    if (this.isWatchingScroll) {
	      console.warn('unmounting droppable while it was watching scroll');
	      this.unwatchScroll();
	    }
	
	    this.unpublish();
	  };
	
	  DroppableDimensionPublisher.prototype.render = function render() {
	    return this.props.children;
	  };
	
	  return DroppableDimensionPublisher;
	}(_react.Component);
	
	DroppableDimensionPublisher.contextTypes = (_DroppableDimensionPu = {}, _DroppableDimensionPu[_contextKeys.dimensionMarshalKey] = _propTypes2.default.object.isRequired, _DroppableDimensionPu);
	exports.default = DroppableDimensionPublisher;

/***/ }),
/* 1988 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function () {
	  return {
	    x: window.pageXOffset,
	    y: window.pageYOffset
	  };
	};

/***/ }),
/* 1989 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var isScrollable = function isScrollable() {
	  for (var _len = arguments.length, values = Array(_len), _key = 0; _key < _len; _key++) {
	    values[_key] = arguments[_key];
	  }
	
	  return values.some(function (value) {
	    return value === 'auto' || value === 'scroll';
	  });
	};
	
	var isElementScrollable = function isElementScrollable(el) {
	  var style = window.getComputedStyle(el);
	  return isScrollable(style.overflow, style.overflowY, style.overflowX);
	};
	
	var getClosestScrollable = function getClosestScrollable(el) {
	  if (el == null) {
	    return null;
	  }
	
	  if (!isElementScrollable(el)) {
	    return getClosestScrollable(el.parentElement);
	  }
	
	  return el;
	};
	
	exports.default = getClosestScrollable;

/***/ }),
/* 1990 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _placeholder = __webpack_require__(1991);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_placeholder).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 1991 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(1878);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(1879);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(1883);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Placeholder = function (_PureComponent) {
	  (0, _inherits3.default)(Placeholder, _PureComponent);
	
	  function Placeholder() {
	    (0, _classCallCheck3.default)(this, Placeholder);
	    return (0, _possibleConstructorReturn3.default)(this, _PureComponent.apply(this, arguments));
	  }
	
	  Placeholder.prototype.render = function render() {
	    var placeholder = this.props.placeholder;
	    var _placeholder$margin = placeholder.margin,
	        top = _placeholder$margin.top,
	        left = _placeholder$margin.left,
	        bottom = _placeholder$margin.bottom,
	        right = _placeholder$margin.right;
	    var _placeholder$paddingB = placeholder.paddingBox,
	        width = _placeholder$paddingB.width,
	        height = _placeholder$paddingB.height;
	
	
	    var style = {
	      width: width,
	      height: height,
	      marginTop: top,
	      marginLeft: left,
	      marginBottom: bottom,
	      marginRight: right,
	      pointerEvents: 'none',
	      boxSizing: 'border-box'
	    };
	    return _react2.default.createElement('div', { style: style });
	  };
	
	  return Placeholder;
	}(_react.PureComponent);
	
	exports.default = Placeholder;

/***/ }),
/* 1992 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _connectedDraggable = __webpack_require__(1993);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_connectedDraggable).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 1993 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.makeSelector = undefined;
	
	var _memoizeOne = __webpack_require__(1903);
	
	var _memoizeOne2 = _interopRequireDefault(_memoizeOne);
	
	var _reactRedux = __webpack_require__(1958);
	
	var _reselect = __webpack_require__(1983);
	
	var _draggable = __webpack_require__(1994);
	
	var _draggable2 = _interopRequireDefault(_draggable);
	
	var _contextKeys = __webpack_require__(1952);
	
	var _position = __webpack_require__(1904);
	
	var _getDisplacementMap = __webpack_require__(1918);
	
	var _getDisplacementMap2 = _interopRequireDefault(_getDisplacementMap);
	
	var _actionCreators = __webpack_require__(1953);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var origin = { x: 0, y: 0 };
	
	var defaultMapProps = {
	  isDropAnimating: false,
	  isDragging: false,
	  offset: origin,
	  shouldAnimateDragMovement: false,
	
	  shouldAnimateDisplacement: true,
	
	  dimension: null,
	  direction: null,
	  draggingOver: null
	};
	
	var makeSelector = exports.makeSelector = function makeSelector() {
	  var memoizedOffset = (0, _memoizeOne2.default)(function (x, y) {
	    return {
	      x: x, y: y
	    };
	  });
	
	  var getNotDraggingProps = (0, _memoizeOne2.default)(function (offset, shouldAnimateDisplacement) {
	    return {
	      isDropAnimating: false,
	      isDragging: false,
	      offset: offset,
	      shouldAnimateDisplacement: shouldAnimateDisplacement,
	
	      shouldAnimateDragMovement: false,
	      dimension: null,
	      direction: null,
	      draggingOver: null
	    };
	  });
	
	  var getDraggingProps = (0, _memoizeOne2.default)(function (offset, shouldAnimateDragMovement, dimension, direction, draggingOver) {
	    return {
	      isDragging: true,
	      isDropAnimating: false,
	      shouldAnimateDisplacement: false,
	      offset: offset,
	      shouldAnimateDragMovement: shouldAnimateDragMovement,
	      dimension: dimension,
	      direction: direction,
	      draggingOver: draggingOver
	    };
	  });
	
	  var draggingSelector = function draggingSelector(state, ownProps) {
	    if (state.phase !== 'DRAGGING' && state.phase !== 'DROP_ANIMATING') {
	      return null;
	    }
	
	    if (state.phase === 'DRAGGING') {
	      if (!state.drag) {
	        console.error('invalid drag state found in selector');
	        return null;
	      }
	
	      if (state.drag.initial.descriptor.id !== ownProps.draggableId) {
	        return null;
	      }
	
	      var offset = state.drag.current.client.offset;
	      var dimension = state.dimension.draggable[ownProps.draggableId];
	      var _direction = state.drag.impact.direction;
	      var shouldAnimateDragMovement = state.drag.current.shouldAnimate;
	      var _draggingOver = state.drag.impact.destination ? state.drag.impact.destination.droppableId : null;
	
	      return getDraggingProps(memoizedOffset(offset.x, offset.y), shouldAnimateDragMovement, dimension, _direction, _draggingOver);
	    }
	
	    var pending = state.drop && state.drop.pending;
	
	    if (!pending) {
	      console.error('cannot provide props for dropping item when there is invalid state');
	      return null;
	    }
	
	    if (pending.result.draggableId !== ownProps.draggableId) {
	      return null;
	    }
	
	    var draggingOver = pending.result.destination ? pending.result.destination.droppableId : null;
	    var direction = pending.impact.direction ? pending.impact.direction : null;
	
	    return {
	      isDragging: false,
	      isDropAnimating: true,
	      offset: pending.newHomeOffset,
	
	      dimension: state.dimension.draggable[ownProps.draggableId],
	      draggingOver: draggingOver,
	      direction: direction,
	
	      shouldAnimateDragMovement: false,
	
	      shouldAnimateDisplacement: false
	    };
	  };
	
	  var getOutOfTheWayMovement = function getOutOfTheWayMovement(id, movement) {
	    var map = (0, _getDisplacementMap2.default)(movement.displaced);
	    var displacement = map[id];
	
	    if (!displacement) {
	      return null;
	    }
	
	    if (!displacement.isVisible) {
	      return null;
	    }
	
	    var amount = movement.isBeyondStartPosition ? (0, _position.negate)(movement.amount) : movement.amount;
	
	    return getNotDraggingProps(memoizedOffset(amount.x, amount.y), displacement.shouldAnimate);
	  };
	
	  var movingOutOfTheWaySelector = function movingOutOfTheWaySelector(state, ownProps) {
	    if (state.phase !== 'DRAGGING' && state.phase !== 'DROP_ANIMATING') {
	      return null;
	    }
	
	    if (state.phase === 'DRAGGING') {
	      if (!state.drag) {
	        console.error('cannot correctly move item out of the way when there is invalid state');
	        return null;
	      }
	
	      if (state.drag.initial.descriptor.id === ownProps.draggableId) {
	        return null;
	      }
	
	      return getOutOfTheWayMovement(ownProps.draggableId, state.drag.impact.movement);
	    }
	
	    if (!state.drop || !state.drop.pending) {
	      console.error('cannot provide props for dropping item when there is invalid state');
	      return null;
	    }
	
	    if (state.drop.pending.result.draggableId === ownProps.draggableId) {
	      return null;
	    }
	
	    return getOutOfTheWayMovement(ownProps.draggableId, state.drop.pending.impact.movement);
	  };
	
	  return (0, _reselect.createSelector)([draggingSelector, movingOutOfTheWaySelector], function (dragging, movingOutOfTheWay) {
	    if (dragging) {
	      return dragging;
	    }
	
	    if (movingOutOfTheWay) {
	      return movingOutOfTheWay;
	    }
	
	    return defaultMapProps;
	  });
	};
	
	var makeMapStateToProps = function makeMapStateToProps() {
	  var selector = makeSelector();
	
	  return function (state, props) {
	    return selector(state, props);
	  };
	};
	
	var mapDispatchToProps = {
	  lift: _actionCreators.lift,
	  move: _actionCreators.move,
	  moveForward: _actionCreators.moveForward,
	  moveBackward: _actionCreators.moveBackward,
	  crossAxisMoveForward: _actionCreators.crossAxisMoveForward,
	  crossAxisMoveBackward: _actionCreators.crossAxisMoveBackward,
	  moveByWindowScroll: _actionCreators.moveByWindowScroll,
	  drop: _actionCreators.drop,
	  dropAnimationFinished: _actionCreators.dropAnimationFinished,
	  cancel: _actionCreators.cancel
	};
	
	exports.default = (0, _reactRedux.connect)(makeMapStateToProps, mapDispatchToProps, null, { storeKey: _contextKeys.storeKey })(_draggable2.default);

/***/ }),
/* 1994 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.zIndexOptions = undefined;
	
	var _classCallCheck2 = __webpack_require__(1878);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(1879);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(1883);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _Draggable$contextTyp;
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(956);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _memoizeOne = __webpack_require__(1903);
	
	var _memoizeOne2 = _interopRequireDefault(_memoizeOne);
	
	var _invariant = __webpack_require__(1995);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _draggableDimensionPublisher = __webpack_require__(1996);
	
	var _draggableDimensionPublisher2 = _interopRequireDefault(_draggableDimensionPublisher);
	
	var _moveable = __webpack_require__(1998);
	
	var _moveable2 = _interopRequireDefault(_moveable);
	
	var _dragHandle = __webpack_require__(2015);
	
	var _dragHandle2 = _interopRequireDefault(_dragHandle);
	
	var _getViewport = __webpack_require__(2030);
	
	var _getViewport2 = _interopRequireDefault(_getViewport);
	
	var _getCenterPosition = __webpack_require__(2028);
	
	var _getCenterPosition2 = _interopRequireDefault(_getCenterPosition);
	
	var _placeholder = __webpack_require__(1990);
	
	var _placeholder2 = _interopRequireDefault(_placeholder);
	
	var _contextKeys = __webpack_require__(1952);
	
	var _timings = __webpack_require__(1955);
	
	var timings = _interopRequireWildcard(_timings);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var zIndexOptions = exports.zIndexOptions = {
	  dragging: 5000,
	  dropAnimating: 4500
	};
	
	var Draggable = function (_Component) {
	  (0, _inherits3.default)(Draggable, _Component);
	
	  function Draggable(props, context) {
	    (0, _classCallCheck3.default)(this, Draggable);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, _Component.call(this, props, context));
	
	    _this.state = {
	      ref: null
	    };
	
	    _this.onMoveEnd = function () {
	      if (!_this.props.isDropAnimating) {
	        return;
	      }
	
	      _this.props.dropAnimationFinished();
	    };
	
	    _this.onLift = function (options) {
	      timings.start('LIFT');
	      _this.throwIfCannotDrag();
	      var client = options.client,
	          autoScrollMode = options.autoScrollMode;
	      var _this$props = _this.props,
	          lift = _this$props.lift,
	          draggableId = _this$props.draggableId;
	      var ref = _this.state.ref;
	
	
	      if (!ref) {
	        throw new Error('cannot lift at this time');
	      }
	
	      var initial = {
	        selection: client,
	        center: (0, _getCenterPosition2.default)(ref)
	      };
	
	      lift(draggableId, initial, (0, _getViewport2.default)(), autoScrollMode);
	    };
	
	    _this.onMove = function (client) {
	      _this.throwIfCannotDrag();
	
	      var _this$props2 = _this.props,
	          draggableId = _this$props2.draggableId,
	          dimension = _this$props2.dimension,
	          move = _this$props2.move;
	
	      if (!dimension) {
	        return;
	      }
	
	      move(draggableId, client, (0, _getViewport2.default)());
	    };
	
	    _this.onMoveForward = function () {
	      _this.throwIfCannotDrag();
	      _this.props.moveForward(_this.props.draggableId);
	    };
	
	    _this.onMoveBackward = function () {
	      _this.throwIfCannotDrag();
	      _this.props.moveBackward(_this.props.draggableId);
	    };
	
	    _this.onCrossAxisMoveForward = function () {
	      _this.throwIfCannotDrag();
	      _this.props.crossAxisMoveForward(_this.props.draggableId);
	    };
	
	    _this.onCrossAxisMoveBackward = function () {
	      _this.throwIfCannotDrag();
	      _this.props.crossAxisMoveBackward(_this.props.draggableId);
	    };
	
	    _this.onWindowScroll = function () {
	      _this.throwIfCannotDrag();
	      _this.props.moveByWindowScroll(_this.props.draggableId, (0, _getViewport2.default)());
	    };
	
	    _this.onDrop = function () {
	      _this.throwIfCannotDrag();
	      _this.props.drop();
	    };
	
	    _this.onCancel = function () {
	      _this.props.cancel();
	    };
	
	    _this.setRef = function (ref) {
	      if (ref === null) {
	        return;
	      }
	
	      if (ref === _this.state.ref) {
	        return;
	      }
	
	      _this.setState({
	        ref: ref
	      });
	    };
	
	    _this.getDraggableRef = function () {
	      return _this.state.ref;
	    };
	
	    _this.getDraggingStyle = (0, _memoizeOne2.default)(function (dimension, isDropAnimating, movementStyle) {
	      var _dimension$client$pad = dimension.client.paddingBox,
	          width = _dimension$client$pad.width,
	          height = _dimension$client$pad.height,
	          top = _dimension$client$pad.top,
	          left = _dimension$client$pad.left;
	
	      var style = {
	        position: 'fixed',
	        boxSizing: 'border-box',
	        zIndex: isDropAnimating ? zIndexOptions.dropAnimating : zIndexOptions.dragging,
	        width: width,
	        height: height,
	        top: top,
	        left: left,
	        margin: 0,
	        pointerEvents: 'none',
	        transition: 'none',
	        transform: movementStyle.transform ? '' + movementStyle.transform : null
	      };
	      return style;
	    });
	    _this.getNotDraggingStyle = (0, _memoizeOne2.default)(function (movementStyle, shouldAnimateDisplacement) {
	      var style = {
	        transform: movementStyle.transform,
	
	        transition: shouldAnimateDisplacement ? null : 'none'
	      };
	      return style;
	    });
	    _this.getProvided = (0, _memoizeOne2.default)(function (isDragging, isDropAnimating, shouldAnimateDisplacement, dimension, dragHandleProps, movementStyle) {
	      var useDraggingStyle = isDragging || isDropAnimating;
	
	      var draggableStyle = function () {
	        if (!useDraggingStyle) {
	          return _this.getNotDraggingStyle(movementStyle, shouldAnimateDisplacement);
	        }
	
	        (0, _invariant2.default)(dimension, 'draggable dimension required for dragging');
	
	        return _this.getDraggingStyle(dimension, isDropAnimating, movementStyle);
	      }();
	
	      var provided = {
	        innerRef: _this.setRef,
	        draggableProps: {
	          'data-react-beautiful-dnd-draggable': _this.styleContext,
	          style: draggableStyle
	        },
	        dragHandleProps: dragHandleProps,
	        placeholder: useDraggingStyle ? _this.getPlaceholder() : null
	      };
	      return provided;
	    });
	    _this.getSnapshot = (0, _memoizeOne2.default)(function (isDragging, isDropAnimating, draggingOver) {
	      return {
	        isDragging: isDragging || isDropAnimating,
	        draggingOver: draggingOver
	      };
	    });
	    _this.getSpeed = (0, _memoizeOne2.default)(function (isDragging, shouldAnimateDragMovement, isDropAnimating) {
	      if (isDropAnimating) {
	        return 'STANDARD';
	      }
	
	      if (isDragging && shouldAnimateDragMovement) {
	        return 'FAST';
	      }
	
	      return 'INSTANT';
	    });
	
	
	    var callbacks = {
	      onLift: _this.onLift,
	      onMove: _this.onMove,
	      onDrop: _this.onDrop,
	      onCancel: _this.onCancel,
	      onMoveBackward: _this.onMoveBackward,
	      onMoveForward: _this.onMoveForward,
	      onCrossAxisMoveForward: _this.onCrossAxisMoveForward,
	      onCrossAxisMoveBackward: _this.onCrossAxisMoveBackward,
	      onWindowScroll: _this.onWindowScroll
	    };
	
	    _this.callbacks = callbacks;
	    _this.styleContext = context[_contextKeys.styleContextKey];
	    return _this;
	  }
	
	  Draggable.prototype.throwIfCannotDrag = function throwIfCannotDrag() {
	    (0, _invariant2.default)(this.state.ref, 'Draggable: cannot drag as no DOM node has been provided');
	    (0, _invariant2.default)(!this.props.isDragDisabled, 'Draggable: cannot drag as dragging is not enabled');
	  };
	
	  Draggable.prototype.getPlaceholder = function getPlaceholder() {
	    var dimension = this.props.dimension;
	    (0, _invariant2.default)(dimension, 'cannot get a drag placeholder when not dragging');
	
	    return _react2.default.createElement(_placeholder2.default, { placeholder: dimension.placeholder });
	  };
	
	  Draggable.prototype.render = function render() {
	    var _this2 = this;
	
	    var _props = this.props,
	        draggableId = _props.draggableId,
	        index = _props.index,
	        offset = _props.offset,
	        isDragging = _props.isDragging,
	        isDropAnimating = _props.isDropAnimating,
	        isDragDisabled = _props.isDragDisabled,
	        dimension = _props.dimension,
	        draggingOver = _props.draggingOver,
	        direction = _props.direction,
	        shouldAnimateDragMovement = _props.shouldAnimateDragMovement,
	        shouldAnimateDisplacement = _props.shouldAnimateDisplacement,
	        disableInteractiveElementBlocking = _props.disableInteractiveElementBlocking,
	        children = _props.children;
	
	    var droppableId = this.context[_contextKeys.droppableIdKey];
	
	    var speed = this.getSpeed(isDragging, shouldAnimateDragMovement, isDropAnimating);
	
	    return _react2.default.createElement(
	      _draggableDimensionPublisher2.default,
	      {
	        draggableId: draggableId,
	        droppableId: droppableId,
	        index: index,
	        targetRef: this.state.ref
	      },
	      _react2.default.createElement(
	        _moveable2.default,
	        {
	          speed: speed,
	          destination: offset,
	          onMoveEnd: this.onMoveEnd
	        },
	        function (movementStyle) {
	          return _react2.default.createElement(
	            _dragHandle2.default,
	            {
	              draggableId: draggableId,
	              isDragging: isDragging,
	              direction: direction,
	              isEnabled: !isDragDisabled,
	              callbacks: _this2.callbacks,
	              getDraggableRef: _this2.getDraggableRef,
	
	              canDragInteractiveElements: disableInteractiveElementBlocking
	            },
	            function (dragHandleProps) {
	              return children(_this2.getProvided(isDragging, isDropAnimating, shouldAnimateDisplacement, dimension, dragHandleProps, movementStyle), _this2.getSnapshot(isDragging, isDropAnimating, draggingOver));
	            }
	          );
	        }
	      )
	    );
	  };
	
	  return Draggable;
	}(_react.Component);
	
	Draggable.defaultProps = {
	  isDragDisabled: false,
	
	  disableInteractiveElementBlocking: false
	};
	Draggable.contextTypes = (_Draggable$contextTyp = {}, _Draggable$contextTyp[_contextKeys.droppableIdKey] = _propTypes2.default.string.isRequired, _Draggable$contextTyp[_contextKeys.styleContextKey] = _propTypes2.default.string.isRequired, _Draggable$contextTyp);
	exports.default = Draggable;

/***/ }),
/* 1995 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var invariant = function(condition, format, a, b, c, d, e, f) {
	  if (false) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  }
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error(
	        'Minified exception occurred; use the non-minified dev environment ' +
	        'for the full error message and additional helpful warnings.'
	      );
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(
	        format.replace(/%s/g, function() { return args[argIndex++]; })
	      );
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	};
	
	module.exports = invariant;


/***/ }),
/* 1996 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _draggableDimensionPublisher = __webpack_require__(1997);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_draggableDimensionPublisher).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 1997 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(1878);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(1879);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(1883);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _DraggableDimensionPu;
	
	var _react = __webpack_require__(300);
	
	var _propTypes = __webpack_require__(956);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _memoizeOne = __webpack_require__(1903);
	
	var _memoizeOne2 = _interopRequireDefault(_memoizeOne);
	
	var _getWindowScroll = __webpack_require__(1988);
	
	var _getWindowScroll2 = _interopRequireDefault(_getWindowScroll);
	
	var _dimension = __webpack_require__(1913);
	
	var _contextKeys = __webpack_require__(1952);
	
	var _getArea = __webpack_require__(1908);
	
	var _getArea2 = _interopRequireDefault(_getArea);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DraggableDimensionPublisher = function (_Component) {
	  (0, _inherits3.default)(DraggableDimensionPublisher, _Component);
	
	  function DraggableDimensionPublisher() {
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, DraggableDimensionPublisher);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.publishedDescriptor = null, _this.getMemoizedDescriptor = (0, _memoizeOne2.default)(function (id, droppableId, index) {
	      return {
	        id: id,
	        droppableId: droppableId,
	        index: index
	      };
	    }), _this.unpublish = function () {
	      if (!_this.publishedDescriptor) {
	        console.error('cannot unpublish descriptor when none is published');
	        return;
	      }
	
	      var marshal = _this.context[_contextKeys.dimensionMarshalKey];
	      marshal.unregisterDraggable(_this.publishedDescriptor);
	      _this.publishedDescriptor = null;
	    }, _this.publish = function (descriptor) {
	      if (descriptor === _this.publishedDescriptor) {
	        return;
	      }
	
	      if (_this.publishedDescriptor) {
	        _this.unpublish();
	      }
	
	      var marshal = _this.context[_contextKeys.dimensionMarshalKey];
	      marshal.registerDraggable(descriptor, _this.getDimension);
	      _this.publishedDescriptor = descriptor;
	    }, _this.getDimension = function () {
	      var targetRef = _this.props.targetRef;
	
	      if (!targetRef) {
	        throw new Error('DraggableDimensionPublisher cannot calculate a dimension when not attached to the DOM');
	      }
	
	      var descriptor = _this.publishedDescriptor;
	
	      if (!descriptor) {
	        throw new Error('Cannot get dimension for unpublished draggable');
	      }
	
	      var style = window.getComputedStyle(targetRef);
	
	      var margin = {
	        top: parseInt(style.marginTop, 10),
	        right: parseInt(style.marginRight, 10),
	        bottom: parseInt(style.marginBottom, 10),
	        left: parseInt(style.marginLeft, 10)
	      };
	
	      var paddingBox = (0, _getArea2.default)(targetRef.getBoundingClientRect());
	
	      var dimension = (0, _dimension.getDraggableDimension)({
	        descriptor: descriptor,
	        paddingBox: paddingBox,
	        margin: margin,
	        windowScroll: (0, _getWindowScroll2.default)()
	      });
	
	      return dimension;
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  DraggableDimensionPublisher.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    var draggableId = nextProps.draggableId,
	        droppableId = nextProps.droppableId,
	        index = nextProps.index,
	        targetRef = nextProps.targetRef;
	
	
	    if (!targetRef) {
	      console.error('Updating draggable dimension handler without a targetRef');
	      return;
	    }
	
	    var descriptor = this.getMemoizedDescriptor(draggableId, droppableId, index);
	
	    this.publish(descriptor);
	  };
	
	  DraggableDimensionPublisher.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.unpublish();
	  };
	
	  DraggableDimensionPublisher.prototype.render = function render() {
	    return this.props.children;
	  };
	
	  return DraggableDimensionPublisher;
	}(_react.Component);
	
	DraggableDimensionPublisher.contextTypes = (_DraggableDimensionPu = {}, _DraggableDimensionPu[_contextKeys.dimensionMarshalKey] = _propTypes2.default.object.isRequired, _DraggableDimensionPu);
	exports.default = DraggableDimensionPublisher;

/***/ }),
/* 1998 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _moveable = __webpack_require__(1999);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_moveable).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 1999 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(1878);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(1879);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(1883);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactMotion = __webpack_require__(2000);
	
	var _animation = __webpack_require__(1942);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var origin = {
	  x: 0,
	  y: 0
	};
	
	var noMovement = {
	  transform: null
	};
	
	var isAtOrigin = function isAtOrigin(point) {
	  return point.x === origin.x && point.y === origin.y;
	};
	
	var getStyle = function getStyle(isNotMoving, x, y) {
	  if (isNotMoving) {
	    return noMovement;
	  }
	
	  var point = { x: x, y: y };
	
	  if (isAtOrigin(point)) {
	    return noMovement;
	  }
	  var style = {
	    transform: 'translate(' + point.x + 'px, ' + point.y + 'px)'
	  };
	  return style;
	};
	
	var Movable = function (_Component) {
	  (0, _inherits3.default)(Movable, _Component);
	
	  function Movable() {
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Movable);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.onRest = function () {
	      var onMoveEnd = _this.props.onMoveEnd;
	
	
	      if (!onMoveEnd) {
	        return;
	      }
	
	      setTimeout(function () {
	        return onMoveEnd();
	      });
	    }, _this.getFinal = function () {
	      var destination = _this.props.destination;
	      var speed = _this.props.speed;
	
	      if (speed === 'INSTANT') {
	        return destination;
	      }
	
	      var selected = speed === 'FAST' ? _animation.physics.fast : _animation.physics.standard;
	
	      return {
	        x: (0, _reactMotion.spring)(destination.x, selected),
	        y: (0, _reactMotion.spring)(destination.y, selected)
	      };
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  Movable.prototype.render = function render() {
	    var _this2 = this;
	
	    var final = this.getFinal();
	
	    var isNotMoving = isAtOrigin(final);
	
	    return _react2.default.createElement(
	      _reactMotion.Motion,
	      { defaultStyle: origin, style: final, onRest: this.onRest },
	      function (current) {
	        return _this2.props.children(getStyle(isNotMoving, current.x, current.y));
	      }
	    );
	  };
	
	  return Movable;
	}(_react.Component);
	
	Movable.defaultProps = {
	  destination: origin
	};
	exports.default = Movable;

/***/ }),
/* 2000 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	function _interopRequire(obj) { return obj && obj.__esModule ? obj['default'] : obj; }
	
	var _Motion = __webpack_require__(2001);
	
	exports.Motion = _interopRequire(_Motion);
	
	var _StaggeredMotion = __webpack_require__(2009);
	
	exports.StaggeredMotion = _interopRequire(_StaggeredMotion);
	
	var _TransitionMotion = __webpack_require__(2010);
	
	exports.TransitionMotion = _interopRequire(_TransitionMotion);
	
	var _spring = __webpack_require__(2012);
	
	exports.spring = _interopRequire(_spring);
	
	var _presets = __webpack_require__(2013);
	
	exports.presets = _interopRequire(_presets);
	
	var _stripStyle = __webpack_require__(2003);
	
	exports.stripStyle = _interopRequire(_stripStyle);
	
	// deprecated, dummy warning function
	
	var _reorderKeys = __webpack_require__(2014);
	
	exports.reorderKeys = _interopRequire(_reorderKeys);

/***/ }),
/* 2001 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _mapToZero = __webpack_require__(2002);
	
	var _mapToZero2 = _interopRequireDefault(_mapToZero);
	
	var _stripStyle = __webpack_require__(2003);
	
	var _stripStyle2 = _interopRequireDefault(_stripStyle);
	
	var _stepper3 = __webpack_require__(2004);
	
	var _stepper4 = _interopRequireDefault(_stepper3);
	
	var _performanceNow = __webpack_require__(2005);
	
	var _performanceNow2 = _interopRequireDefault(_performanceNow);
	
	var _raf = __webpack_require__(2006);
	
	var _raf2 = _interopRequireDefault(_raf);
	
	var _shouldStopAnimation = __webpack_require__(2008);
	
	var _shouldStopAnimation2 = _interopRequireDefault(_shouldStopAnimation);
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(956);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var msPerFrame = 1000 / 60;
	
	var Motion = (function (_React$Component) {
	  _inherits(Motion, _React$Component);
	
	  _createClass(Motion, null, [{
	    key: 'propTypes',
	    value: {
	      // TOOD: warn against putting a config in here
	      defaultStyle: _propTypes2['default'].objectOf(_propTypes2['default'].number),
	      style: _propTypes2['default'].objectOf(_propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].object])).isRequired,
	      children: _propTypes2['default'].func.isRequired,
	      onRest: _propTypes2['default'].func
	    },
	    enumerable: true
	  }]);
	
	  function Motion(props) {
	    var _this = this;
	
	    _classCallCheck(this, Motion);
	
	    _React$Component.call(this, props);
	    this.wasAnimating = false;
	    this.animationID = null;
	    this.prevTime = 0;
	    this.accumulatedTime = 0;
	    this.unreadPropStyle = null;
	
	    this.clearUnreadPropStyle = function (destStyle) {
	      var dirty = false;
	      var _state = _this.state;
	      var currentStyle = _state.currentStyle;
	      var currentVelocity = _state.currentVelocity;
	      var lastIdealStyle = _state.lastIdealStyle;
	      var lastIdealVelocity = _state.lastIdealVelocity;
	
	      for (var key in destStyle) {
	        if (!Object.prototype.hasOwnProperty.call(destStyle, key)) {
	          continue;
	        }
	
	        var styleValue = destStyle[key];
	        if (typeof styleValue === 'number') {
	          if (!dirty) {
	            dirty = true;
	            currentStyle = _extends({}, currentStyle);
	            currentVelocity = _extends({}, currentVelocity);
	            lastIdealStyle = _extends({}, lastIdealStyle);
	            lastIdealVelocity = _extends({}, lastIdealVelocity);
	          }
	
	          currentStyle[key] = styleValue;
	          currentVelocity[key] = 0;
	          lastIdealStyle[key] = styleValue;
	          lastIdealVelocity[key] = 0;
	        }
	      }
	
	      if (dirty) {
	        _this.setState({ currentStyle: currentStyle, currentVelocity: currentVelocity, lastIdealStyle: lastIdealStyle, lastIdealVelocity: lastIdealVelocity });
	      }
	    };
	
	    this.startAnimationIfNecessary = function () {
	      // TODO: when config is {a: 10} and dest is {a: 10} do we raf once and
	      // call cb? No, otherwise accidental parent rerender causes cb trigger
	      _this.animationID = _raf2['default'](function (timestamp) {
	        // check if we need to animate in the first place
	        var propsStyle = _this.props.style;
	        if (_shouldStopAnimation2['default'](_this.state.currentStyle, propsStyle, _this.state.currentVelocity)) {
	          if (_this.wasAnimating && _this.props.onRest) {
	            _this.props.onRest();
	          }
	
	          // no need to cancel animationID here; shouldn't have any in flight
	          _this.animationID = null;
	          _this.wasAnimating = false;
	          _this.accumulatedTime = 0;
	          return;
	        }
	
	        _this.wasAnimating = true;
	
	        var currentTime = timestamp || _performanceNow2['default']();
	        var timeDelta = currentTime - _this.prevTime;
	        _this.prevTime = currentTime;
	        _this.accumulatedTime = _this.accumulatedTime + timeDelta;
	        // more than 10 frames? prolly switched browser tab. Restart
	        if (_this.accumulatedTime > msPerFrame * 10) {
	          _this.accumulatedTime = 0;
	        }
	
	        if (_this.accumulatedTime === 0) {
	          // no need to cancel animationID here; shouldn't have any in flight
	          _this.animationID = null;
	          _this.startAnimationIfNecessary();
	          return;
	        }
	
	        var currentFrameCompletion = (_this.accumulatedTime - Math.floor(_this.accumulatedTime / msPerFrame) * msPerFrame) / msPerFrame;
	        var framesToCatchUp = Math.floor(_this.accumulatedTime / msPerFrame);
	
	        var newLastIdealStyle = {};
	        var newLastIdealVelocity = {};
	        var newCurrentStyle = {};
	        var newCurrentVelocity = {};
	
	        for (var key in propsStyle) {
	          if (!Object.prototype.hasOwnProperty.call(propsStyle, key)) {
	            continue;
	          }
	
	          var styleValue = propsStyle[key];
	          if (typeof styleValue === 'number') {
	            newCurrentStyle[key] = styleValue;
	            newCurrentVelocity[key] = 0;
	            newLastIdealStyle[key] = styleValue;
	            newLastIdealVelocity[key] = 0;
	          } else {
	            var newLastIdealStyleValue = _this.state.lastIdealStyle[key];
	            var newLastIdealVelocityValue = _this.state.lastIdealVelocity[key];
	            for (var i = 0; i < framesToCatchUp; i++) {
	              var _stepper = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);
	
	              newLastIdealStyleValue = _stepper[0];
	              newLastIdealVelocityValue = _stepper[1];
	            }
	
	            var _stepper2 = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);
	
	            var nextIdealX = _stepper2[0];
	            var nextIdealV = _stepper2[1];
	
	            newCurrentStyle[key] = newLastIdealStyleValue + (nextIdealX - newLastIdealStyleValue) * currentFrameCompletion;
	            newCurrentVelocity[key] = newLastIdealVelocityValue + (nextIdealV - newLastIdealVelocityValue) * currentFrameCompletion;
	            newLastIdealStyle[key] = newLastIdealStyleValue;
	            newLastIdealVelocity[key] = newLastIdealVelocityValue;
	          }
	        }
	
	        _this.animationID = null;
	        // the amount we're looped over above
	        _this.accumulatedTime -= framesToCatchUp * msPerFrame;
	
	        _this.setState({
	          currentStyle: newCurrentStyle,
	          currentVelocity: newCurrentVelocity,
	          lastIdealStyle: newLastIdealStyle,
	          lastIdealVelocity: newLastIdealVelocity
	        });
	
	        _this.unreadPropStyle = null;
	
	        _this.startAnimationIfNecessary();
	      });
	    };
	
	    this.state = this.defaultState();
	  }
	
	  Motion.prototype.defaultState = function defaultState() {
	    var _props = this.props;
	    var defaultStyle = _props.defaultStyle;
	    var style = _props.style;
	
	    var currentStyle = defaultStyle || _stripStyle2['default'](style);
	    var currentVelocity = _mapToZero2['default'](currentStyle);
	    return {
	      currentStyle: currentStyle,
	      currentVelocity: currentVelocity,
	      lastIdealStyle: currentStyle,
	      lastIdealVelocity: currentVelocity
	    };
	  };
	
	  // it's possible that currentStyle's value is stale: if props is immediately
	  // changed from 0 to 400 to spring(0) again, the async currentStyle is still
	  // at 0 (didn't have time to tick and interpolate even once). If we naively
	  // compare currentStyle with destVal it'll be 0 === 0 (no animation, stop).
	  // In reality currentStyle should be 400
	
	  Motion.prototype.componentDidMount = function componentDidMount() {
	    this.prevTime = _performanceNow2['default']();
	    this.startAnimationIfNecessary();
	  };
	
	  Motion.prototype.componentWillReceiveProps = function componentWillReceiveProps(props) {
	    if (this.unreadPropStyle != null) {
	      // previous props haven't had the chance to be set yet; set them here
	      this.clearUnreadPropStyle(this.unreadPropStyle);
	    }
	
	    this.unreadPropStyle = props.style;
	    if (this.animationID == null) {
	      this.prevTime = _performanceNow2['default']();
	      this.startAnimationIfNecessary();
	    }
	  };
	
	  Motion.prototype.componentWillUnmount = function componentWillUnmount() {
	    if (this.animationID != null) {
	      _raf2['default'].cancel(this.animationID);
	      this.animationID = null;
	    }
	  };
	
	  Motion.prototype.render = function render() {
	    var renderedChildren = this.props.children(this.state.currentStyle);
	    return renderedChildren && _react2['default'].Children.only(renderedChildren);
	  };
	
	  return Motion;
	})(_react2['default'].Component);
	
	exports['default'] = Motion;
	module.exports = exports['default'];
	
	// after checking for unreadPropStyle != null, we manually go set the
	// non-interpolating values (those that are a number, without a spring
	// config)

/***/ }),
/* 2002 */
/***/ (function(module, exports) {

	
	
	// currently used to initiate the velocity style object to 0
	'use strict';
	
	exports.__esModule = true;
	exports['default'] = mapToZero;
	
	function mapToZero(obj) {
	  var ret = {};
	  for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      ret[key] = 0;
	    }
	  }
	  return ret;
	}
	
	module.exports = exports['default'];

/***/ }),
/* 2003 */
/***/ (function(module, exports) {

	
	// turn {x: {val: 1, stiffness: 1, damping: 2}, y: 2} generated by
	// `{x: spring(1, {stiffness: 1, damping: 2}), y: 2}` into {x: 1, y: 2}
	
	'use strict';
	
	exports.__esModule = true;
	exports['default'] = stripStyle;
	
	function stripStyle(style) {
	  var ret = {};
	  for (var key in style) {
	    if (!Object.prototype.hasOwnProperty.call(style, key)) {
	      continue;
	    }
	    ret[key] = typeof style[key] === 'number' ? style[key] : style[key].val;
	  }
	  return ret;
	}
	
	module.exports = exports['default'];

/***/ }),
/* 2004 */
/***/ (function(module, exports) {

	
	
	// stepper is used a lot. Saves allocation to return the same array wrapper.
	// This is fine and danger-free against mutations because the callsite
	// immediately destructures it and gets the numbers inside without passing the
	"use strict";
	
	exports.__esModule = true;
	exports["default"] = stepper;
	
	var reusedTuple = [0, 0];
	
	function stepper(secondPerFrame, x, v, destX, k, b, precision) {
	  // Spring stiffness, in kg / s^2
	
	  // for animations, destX is really spring length (spring at rest). initial
	  // position is considered as the stretched/compressed position of a spring
	  var Fspring = -k * (x - destX);
	
	  // Damping, in kg / s
	  var Fdamper = -b * v;
	
	  // usually we put mass here, but for animation purposes, specifying mass is a
	  // bit redundant. you could simply adjust k and b accordingly
	  // let a = (Fspring + Fdamper) / mass;
	  var a = Fspring + Fdamper;
	
	  var newV = v + a * secondPerFrame;
	  var newX = x + newV * secondPerFrame;
	
	  if (Math.abs(newV) < precision && Math.abs(newX - destX) < precision) {
	    reusedTuple[0] = destX;
	    reusedTuple[1] = 0;
	    return reusedTuple;
	  }
	
	  reusedTuple[0] = newX;
	  reusedTuple[1] = newV;
	  return reusedTuple;
	}
	
	module.exports = exports["default"];
	// array reference around.

/***/ }),
/* 2005 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {// Generated by CoffeeScript 1.7.1
	(function() {
	  var getNanoSeconds, hrtime, loadTime;
	
	  if ((typeof performance !== "undefined" && performance !== null) && performance.now) {
	    module.exports = function() {
	      return performance.now();
	    };
	  } else if ((typeof process !== "undefined" && process !== null) && process.hrtime) {
	    module.exports = function() {
	      return (getNanoSeconds() - loadTime) / 1e6;
	    };
	    hrtime = process.hrtime;
	    getNanoSeconds = function() {
	      var hr;
	      hr = hrtime();
	      return hr[0] * 1e9 + hr[1];
	    };
	    loadTime = getNanoSeconds();
	  } else if (Date.now) {
	    module.exports = function() {
	      return Date.now() - loadTime;
	    };
	    loadTime = Date.now();
	  } else {
	    module.exports = function() {
	      return new Date().getTime() - loadTime;
	    };
	    loadTime = new Date().getTime();
	  }
	
	}).call(this);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(294)))

/***/ }),
/* 2006 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var now = __webpack_require__(2007)
	  , root = typeof window === 'undefined' ? global : window
	  , vendors = ['moz', 'webkit']
	  , suffix = 'AnimationFrame'
	  , raf = root['request' + suffix]
	  , caf = root['cancel' + suffix] || root['cancelRequest' + suffix]
	
	for(var i = 0; !raf && i < vendors.length; i++) {
	  raf = root[vendors[i] + 'Request' + suffix]
	  caf = root[vendors[i] + 'Cancel' + suffix]
	      || root[vendors[i] + 'CancelRequest' + suffix]
	}
	
	// Some versions of FF have rAF but not cAF
	if(!raf || !caf) {
	  var last = 0
	    , id = 0
	    , queue = []
	    , frameDuration = 1000 / 60
	
	  raf = function(callback) {
	    if(queue.length === 0) {
	      var _now = now()
	        , next = Math.max(0, frameDuration - (_now - last))
	      last = next + _now
	      setTimeout(function() {
	        var cp = queue.slice(0)
	        // Clear queue here to prevent
	        // callbacks from appending listeners
	        // to the current frame's queue
	        queue.length = 0
	        for(var i = 0; i < cp.length; i++) {
	          if(!cp[i].cancelled) {
	            try{
	              cp[i].callback(last)
	            } catch(e) {
	              setTimeout(function() { throw e }, 0)
	            }
	          }
	        }
	      }, Math.round(next))
	    }
	    queue.push({
	      handle: ++id,
	      callback: callback,
	      cancelled: false
	    })
	    return id
	  }
	
	  caf = function(handle) {
	    for(var i = 0; i < queue.length; i++) {
	      if(queue[i].handle === handle) {
	        queue[i].cancelled = true
	      }
	    }
	  }
	}
	
	module.exports = function(fn) {
	  // Wrap in a new function to prevent
	  // `cancel` potentially being assigned
	  // to the native rAF function
	  return raf.call(root, fn)
	}
	module.exports.cancel = function() {
	  caf.apply(root, arguments)
	}
	module.exports.polyfill = function(object) {
	  if (!object) {
	    object = root;
	  }
	  object.requestAnimationFrame = raf
	  object.cancelAnimationFrame = caf
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 2007 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {// Generated by CoffeeScript 1.12.2
	(function() {
	  var getNanoSeconds, hrtime, loadTime, moduleLoadTime, nodeLoadTime, upTime;
	
	  if ((typeof performance !== "undefined" && performance !== null) && performance.now) {
	    module.exports = function() {
	      return performance.now();
	    };
	  } else if ((typeof process !== "undefined" && process !== null) && process.hrtime) {
	    module.exports = function() {
	      return (getNanoSeconds() - nodeLoadTime) / 1e6;
	    };
	    hrtime = process.hrtime;
	    getNanoSeconds = function() {
	      var hr;
	      hr = hrtime();
	      return hr[0] * 1e9 + hr[1];
	    };
	    moduleLoadTime = getNanoSeconds();
	    upTime = process.uptime() * 1e9;
	    nodeLoadTime = moduleLoadTime - upTime;
	  } else if (Date.now) {
	    module.exports = function() {
	      return Date.now() - loadTime;
	    };
	    loadTime = Date.now();
	  } else {
	    module.exports = function() {
	      return new Date().getTime() - loadTime;
	    };
	    loadTime = new Date().getTime();
	  }
	
	}).call(this);
	
	//# sourceMappingURL=performance-now.js.map
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(294)))

/***/ }),
/* 2008 */
/***/ (function(module, exports) {

	
	
	// usage assumption: currentStyle values have already been rendered but it says
	// nothing of whether currentStyle is stale (see unreadPropStyle)
	'use strict';
	
	exports.__esModule = true;
	exports['default'] = shouldStopAnimation;
	
	function shouldStopAnimation(currentStyle, style, currentVelocity) {
	  for (var key in style) {
	    if (!Object.prototype.hasOwnProperty.call(style, key)) {
	      continue;
	    }
	
	    if (currentVelocity[key] !== 0) {
	      return false;
	    }
	
	    var styleValue = typeof style[key] === 'number' ? style[key] : style[key].val;
	    // stepper will have already taken care of rounding precision errors, so
	    // won't have such thing as 0.9999 !=== 1
	    if (currentStyle[key] !== styleValue) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	module.exports = exports['default'];

/***/ }),
/* 2009 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _mapToZero = __webpack_require__(2002);
	
	var _mapToZero2 = _interopRequireDefault(_mapToZero);
	
	var _stripStyle = __webpack_require__(2003);
	
	var _stripStyle2 = _interopRequireDefault(_stripStyle);
	
	var _stepper3 = __webpack_require__(2004);
	
	var _stepper4 = _interopRequireDefault(_stepper3);
	
	var _performanceNow = __webpack_require__(2005);
	
	var _performanceNow2 = _interopRequireDefault(_performanceNow);
	
	var _raf = __webpack_require__(2006);
	
	var _raf2 = _interopRequireDefault(_raf);
	
	var _shouldStopAnimation = __webpack_require__(2008);
	
	var _shouldStopAnimation2 = _interopRequireDefault(_shouldStopAnimation);
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(956);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var msPerFrame = 1000 / 60;
	
	function shouldStopAnimationAll(currentStyles, styles, currentVelocities) {
	  for (var i = 0; i < currentStyles.length; i++) {
	    if (!_shouldStopAnimation2['default'](currentStyles[i], styles[i], currentVelocities[i])) {
	      return false;
	    }
	  }
	  return true;
	}
	
	var StaggeredMotion = (function (_React$Component) {
	  _inherits(StaggeredMotion, _React$Component);
	
	  _createClass(StaggeredMotion, null, [{
	    key: 'propTypes',
	    value: {
	      // TOOD: warn against putting a config in here
	      defaultStyles: _propTypes2['default'].arrayOf(_propTypes2['default'].objectOf(_propTypes2['default'].number)),
	      styles: _propTypes2['default'].func.isRequired,
	      children: _propTypes2['default'].func.isRequired
	    },
	    enumerable: true
	  }]);
	
	  function StaggeredMotion(props) {
	    var _this = this;
	
	    _classCallCheck(this, StaggeredMotion);
	
	    _React$Component.call(this, props);
	    this.animationID = null;
	    this.prevTime = 0;
	    this.accumulatedTime = 0;
	    this.unreadPropStyles = null;
	
	    this.clearUnreadPropStyle = function (unreadPropStyles) {
	      var _state = _this.state;
	      var currentStyles = _state.currentStyles;
	      var currentVelocities = _state.currentVelocities;
	      var lastIdealStyles = _state.lastIdealStyles;
	      var lastIdealVelocities = _state.lastIdealVelocities;
	
	      var someDirty = false;
	      for (var i = 0; i < unreadPropStyles.length; i++) {
	        var unreadPropStyle = unreadPropStyles[i];
	        var dirty = false;
	
	        for (var key in unreadPropStyle) {
	          if (!Object.prototype.hasOwnProperty.call(unreadPropStyle, key)) {
	            continue;
	          }
	
	          var styleValue = unreadPropStyle[key];
	          if (typeof styleValue === 'number') {
	            if (!dirty) {
	              dirty = true;
	              someDirty = true;
	              currentStyles[i] = _extends({}, currentStyles[i]);
	              currentVelocities[i] = _extends({}, currentVelocities[i]);
	              lastIdealStyles[i] = _extends({}, lastIdealStyles[i]);
	              lastIdealVelocities[i] = _extends({}, lastIdealVelocities[i]);
	            }
	            currentStyles[i][key] = styleValue;
	            currentVelocities[i][key] = 0;
	            lastIdealStyles[i][key] = styleValue;
	            lastIdealVelocities[i][key] = 0;
	          }
	        }
	      }
	
	      if (someDirty) {
	        _this.setState({ currentStyles: currentStyles, currentVelocities: currentVelocities, lastIdealStyles: lastIdealStyles, lastIdealVelocities: lastIdealVelocities });
	      }
	    };
	
	    this.startAnimationIfNecessary = function () {
	      // TODO: when config is {a: 10} and dest is {a: 10} do we raf once and
	      // call cb? No, otherwise accidental parent rerender causes cb trigger
	      _this.animationID = _raf2['default'](function (timestamp) {
	        var destStyles = _this.props.styles(_this.state.lastIdealStyles);
	
	        // check if we need to animate in the first place
	        if (shouldStopAnimationAll(_this.state.currentStyles, destStyles, _this.state.currentVelocities)) {
	          // no need to cancel animationID here; shouldn't have any in flight
	          _this.animationID = null;
	          _this.accumulatedTime = 0;
	          return;
	        }
	
	        var currentTime = timestamp || _performanceNow2['default']();
	        var timeDelta = currentTime - _this.prevTime;
	        _this.prevTime = currentTime;
	        _this.accumulatedTime = _this.accumulatedTime + timeDelta;
	        // more than 10 frames? prolly switched browser tab. Restart
	        if (_this.accumulatedTime > msPerFrame * 10) {
	          _this.accumulatedTime = 0;
	        }
	
	        if (_this.accumulatedTime === 0) {
	          // no need to cancel animationID here; shouldn't have any in flight
	          _this.animationID = null;
	          _this.startAnimationIfNecessary();
	          return;
	        }
	
	        var currentFrameCompletion = (_this.accumulatedTime - Math.floor(_this.accumulatedTime / msPerFrame) * msPerFrame) / msPerFrame;
	        var framesToCatchUp = Math.floor(_this.accumulatedTime / msPerFrame);
	
	        var newLastIdealStyles = [];
	        var newLastIdealVelocities = [];
	        var newCurrentStyles = [];
	        var newCurrentVelocities = [];
	
	        for (var i = 0; i < destStyles.length; i++) {
	          var destStyle = destStyles[i];
	          var newCurrentStyle = {};
	          var newCurrentVelocity = {};
	          var newLastIdealStyle = {};
	          var newLastIdealVelocity = {};
	
	          for (var key in destStyle) {
	            if (!Object.prototype.hasOwnProperty.call(destStyle, key)) {
	              continue;
	            }
	
	            var styleValue = destStyle[key];
	            if (typeof styleValue === 'number') {
	              newCurrentStyle[key] = styleValue;
	              newCurrentVelocity[key] = 0;
	              newLastIdealStyle[key] = styleValue;
	              newLastIdealVelocity[key] = 0;
	            } else {
	              var newLastIdealStyleValue = _this.state.lastIdealStyles[i][key];
	              var newLastIdealVelocityValue = _this.state.lastIdealVelocities[i][key];
	              for (var j = 0; j < framesToCatchUp; j++) {
	                var _stepper = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);
	
	                newLastIdealStyleValue = _stepper[0];
	                newLastIdealVelocityValue = _stepper[1];
	              }
	
	              var _stepper2 = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);
	
	              var nextIdealX = _stepper2[0];
	              var nextIdealV = _stepper2[1];
	
	              newCurrentStyle[key] = newLastIdealStyleValue + (nextIdealX - newLastIdealStyleValue) * currentFrameCompletion;
	              newCurrentVelocity[key] = newLastIdealVelocityValue + (nextIdealV - newLastIdealVelocityValue) * currentFrameCompletion;
	              newLastIdealStyle[key] = newLastIdealStyleValue;
	              newLastIdealVelocity[key] = newLastIdealVelocityValue;
	            }
	          }
	
	          newCurrentStyles[i] = newCurrentStyle;
	          newCurrentVelocities[i] = newCurrentVelocity;
	          newLastIdealStyles[i] = newLastIdealStyle;
	          newLastIdealVelocities[i] = newLastIdealVelocity;
	        }
	
	        _this.animationID = null;
	        // the amount we're looped over above
	        _this.accumulatedTime -= framesToCatchUp * msPerFrame;
	
	        _this.setState({
	          currentStyles: newCurrentStyles,
	          currentVelocities: newCurrentVelocities,
	          lastIdealStyles: newLastIdealStyles,
	          lastIdealVelocities: newLastIdealVelocities
	        });
	
	        _this.unreadPropStyles = null;
	
	        _this.startAnimationIfNecessary();
	      });
	    };
	
	    this.state = this.defaultState();
	  }
	
	  StaggeredMotion.prototype.defaultState = function defaultState() {
	    var _props = this.props;
	    var defaultStyles = _props.defaultStyles;
	    var styles = _props.styles;
	
	    var currentStyles = defaultStyles || styles().map(_stripStyle2['default']);
	    var currentVelocities = currentStyles.map(function (currentStyle) {
	      return _mapToZero2['default'](currentStyle);
	    });
	    return {
	      currentStyles: currentStyles,
	      currentVelocities: currentVelocities,
	      lastIdealStyles: currentStyles,
	      lastIdealVelocities: currentVelocities
	    };
	  };
	
	  StaggeredMotion.prototype.componentDidMount = function componentDidMount() {
	    this.prevTime = _performanceNow2['default']();
	    this.startAnimationIfNecessary();
	  };
	
	  StaggeredMotion.prototype.componentWillReceiveProps = function componentWillReceiveProps(props) {
	    if (this.unreadPropStyles != null) {
	      // previous props haven't had the chance to be set yet; set them here
	      this.clearUnreadPropStyle(this.unreadPropStyles);
	    }
	
	    this.unreadPropStyles = props.styles(this.state.lastIdealStyles);
	    if (this.animationID == null) {
	      this.prevTime = _performanceNow2['default']();
	      this.startAnimationIfNecessary();
	    }
	  };
	
	  StaggeredMotion.prototype.componentWillUnmount = function componentWillUnmount() {
	    if (this.animationID != null) {
	      _raf2['default'].cancel(this.animationID);
	      this.animationID = null;
	    }
	  };
	
	  StaggeredMotion.prototype.render = function render() {
	    var renderedChildren = this.props.children(this.state.currentStyles);
	    return renderedChildren && _react2['default'].Children.only(renderedChildren);
	  };
	
	  return StaggeredMotion;
	})(_react2['default'].Component);
	
	exports['default'] = StaggeredMotion;
	module.exports = exports['default'];
	
	// it's possible that currentStyle's value is stale: if props is immediately
	// changed from 0 to 400 to spring(0) again, the async currentStyle is still
	// at 0 (didn't have time to tick and interpolate even once). If we naively
	// compare currentStyle with destVal it'll be 0 === 0 (no animation, stop).
	// In reality currentStyle should be 400
	
	// after checking for unreadPropStyles != null, we manually go set the
	// non-interpolating values (those that are a number, without a spring
	// config)

/***/ }),
/* 2010 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _mapToZero = __webpack_require__(2002);
	
	var _mapToZero2 = _interopRequireDefault(_mapToZero);
	
	var _stripStyle = __webpack_require__(2003);
	
	var _stripStyle2 = _interopRequireDefault(_stripStyle);
	
	var _stepper3 = __webpack_require__(2004);
	
	var _stepper4 = _interopRequireDefault(_stepper3);
	
	var _mergeDiff = __webpack_require__(2011);
	
	var _mergeDiff2 = _interopRequireDefault(_mergeDiff);
	
	var _performanceNow = __webpack_require__(2005);
	
	var _performanceNow2 = _interopRequireDefault(_performanceNow);
	
	var _raf = __webpack_require__(2006);
	
	var _raf2 = _interopRequireDefault(_raf);
	
	var _shouldStopAnimation = __webpack_require__(2008);
	
	var _shouldStopAnimation2 = _interopRequireDefault(_shouldStopAnimation);
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(956);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var msPerFrame = 1000 / 60;
	
	// the children function & (potential) styles function asks as param an
	// Array<TransitionPlainStyle>, where each TransitionPlainStyle is of the format
	// {key: string, data?: any, style: PlainStyle}. However, the way we keep
	// internal states doesn't contain such a data structure (check the state and
	// TransitionMotionState). So when children function and others ask for such
	// data we need to generate them on the fly by combining mergedPropsStyles and
	// currentStyles/lastIdealStyles
	function rehydrateStyles(mergedPropsStyles, unreadPropStyles, plainStyles) {
	  // Copy the value to a `const` so that Flow understands that the const won't
	  // change and will be non-nullable in the callback below.
	  var cUnreadPropStyles = unreadPropStyles;
	  if (cUnreadPropStyles == null) {
	    return mergedPropsStyles.map(function (mergedPropsStyle, i) {
	      return {
	        key: mergedPropsStyle.key,
	        data: mergedPropsStyle.data,
	        style: plainStyles[i]
	      };
	    });
	  }
	  return mergedPropsStyles.map(function (mergedPropsStyle, i) {
	    for (var j = 0; j < cUnreadPropStyles.length; j++) {
	      if (cUnreadPropStyles[j].key === mergedPropsStyle.key) {
	        return {
	          key: cUnreadPropStyles[j].key,
	          data: cUnreadPropStyles[j].data,
	          style: plainStyles[i]
	        };
	      }
	    }
	    return { key: mergedPropsStyle.key, data: mergedPropsStyle.data, style: plainStyles[i] };
	  });
	}
	
	function shouldStopAnimationAll(currentStyles, destStyles, currentVelocities, mergedPropsStyles) {
	  if (mergedPropsStyles.length !== destStyles.length) {
	    return false;
	  }
	
	  for (var i = 0; i < mergedPropsStyles.length; i++) {
	    if (mergedPropsStyles[i].key !== destStyles[i].key) {
	      return false;
	    }
	  }
	
	  // we have the invariant that mergedPropsStyles and
	  // currentStyles/currentVelocities/last* are synced in terms of cells, see
	  // mergeAndSync comment for more info
	  for (var i = 0; i < mergedPropsStyles.length; i++) {
	    if (!_shouldStopAnimation2['default'](currentStyles[i], destStyles[i].style, currentVelocities[i])) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	// core key merging logic
	
	// things to do: say previously merged style is {a, b}, dest style (prop) is {b,
	// c}, previous current (interpolating) style is {a, b}
	// **invariant**: current[i] corresponds to merged[i] in terms of key
	
	// steps:
	// turn merged style into {a?, b, c}
	//    add c, value of c is destStyles.c
	//    maybe remove a, aka call willLeave(a), then merged is either {b, c} or {a, b, c}
	// turn current (interpolating) style from {a, b} into {a?, b, c}
	//    maybe remove a
	//    certainly add c, value of c is willEnter(c)
	// loop over merged and construct new current
	// dest doesn't change, that's owner's
	function mergeAndSync(willEnter, willLeave, didLeave, oldMergedPropsStyles, destStyles, oldCurrentStyles, oldCurrentVelocities, oldLastIdealStyles, oldLastIdealVelocities) {
	  var newMergedPropsStyles = _mergeDiff2['default'](oldMergedPropsStyles, destStyles, function (oldIndex, oldMergedPropsStyle) {
	    var leavingStyle = willLeave(oldMergedPropsStyle);
	    if (leavingStyle == null) {
	      didLeave({ key: oldMergedPropsStyle.key, data: oldMergedPropsStyle.data });
	      return null;
	    }
	    if (_shouldStopAnimation2['default'](oldCurrentStyles[oldIndex], leavingStyle, oldCurrentVelocities[oldIndex])) {
	      didLeave({ key: oldMergedPropsStyle.key, data: oldMergedPropsStyle.data });
	      return null;
	    }
	    return { key: oldMergedPropsStyle.key, data: oldMergedPropsStyle.data, style: leavingStyle };
	  });
	
	  var newCurrentStyles = [];
	  var newCurrentVelocities = [];
	  var newLastIdealStyles = [];
	  var newLastIdealVelocities = [];
	  for (var i = 0; i < newMergedPropsStyles.length; i++) {
	    var newMergedPropsStyleCell = newMergedPropsStyles[i];
	    var foundOldIndex = null;
	    for (var j = 0; j < oldMergedPropsStyles.length; j++) {
	      if (oldMergedPropsStyles[j].key === newMergedPropsStyleCell.key) {
	        foundOldIndex = j;
	        break;
	      }
	    }
	    // TODO: key search code
	    if (foundOldIndex == null) {
	      var plainStyle = willEnter(newMergedPropsStyleCell);
	      newCurrentStyles[i] = plainStyle;
	      newLastIdealStyles[i] = plainStyle;
	
	      var velocity = _mapToZero2['default'](newMergedPropsStyleCell.style);
	      newCurrentVelocities[i] = velocity;
	      newLastIdealVelocities[i] = velocity;
	    } else {
	      newCurrentStyles[i] = oldCurrentStyles[foundOldIndex];
	      newLastIdealStyles[i] = oldLastIdealStyles[foundOldIndex];
	      newCurrentVelocities[i] = oldCurrentVelocities[foundOldIndex];
	      newLastIdealVelocities[i] = oldLastIdealVelocities[foundOldIndex];
	    }
	  }
	
	  return [newMergedPropsStyles, newCurrentStyles, newCurrentVelocities, newLastIdealStyles, newLastIdealVelocities];
	}
	
	var TransitionMotion = (function (_React$Component) {
	  _inherits(TransitionMotion, _React$Component);
	
	  _createClass(TransitionMotion, null, [{
	    key: 'propTypes',
	    value: {
	      defaultStyles: _propTypes2['default'].arrayOf(_propTypes2['default'].shape({
	        key: _propTypes2['default'].string.isRequired,
	        data: _propTypes2['default'].any,
	        style: _propTypes2['default'].objectOf(_propTypes2['default'].number).isRequired
	      })),
	      styles: _propTypes2['default'].oneOfType([_propTypes2['default'].func, _propTypes2['default'].arrayOf(_propTypes2['default'].shape({
	        key: _propTypes2['default'].string.isRequired,
	        data: _propTypes2['default'].any,
	        style: _propTypes2['default'].objectOf(_propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].object])).isRequired
	      }))]).isRequired,
	      children: _propTypes2['default'].func.isRequired,
	      willEnter: _propTypes2['default'].func,
	      willLeave: _propTypes2['default'].func,
	      didLeave: _propTypes2['default'].func
	    },
	    enumerable: true
	  }, {
	    key: 'defaultProps',
	    value: {
	      willEnter: function willEnter(styleThatEntered) {
	        return _stripStyle2['default'](styleThatEntered.style);
	      },
	      // recall: returning null makes the current unmounting TransitionStyle
	      // disappear immediately
	      willLeave: function willLeave() {
	        return null;
	      },
	      didLeave: function didLeave() {}
	    },
	    enumerable: true
	  }]);
	
	  function TransitionMotion(props) {
	    var _this = this;
	
	    _classCallCheck(this, TransitionMotion);
	
	    _React$Component.call(this, props);
	    this.unmounting = false;
	    this.animationID = null;
	    this.prevTime = 0;
	    this.accumulatedTime = 0;
	    this.unreadPropStyles = null;
	
	    this.clearUnreadPropStyle = function (unreadPropStyles) {
	      var _mergeAndSync = mergeAndSync(_this.props.willEnter, _this.props.willLeave, _this.props.didLeave, _this.state.mergedPropsStyles, unreadPropStyles, _this.state.currentStyles, _this.state.currentVelocities, _this.state.lastIdealStyles, _this.state.lastIdealVelocities);
	
	      var mergedPropsStyles = _mergeAndSync[0];
	      var currentStyles = _mergeAndSync[1];
	      var currentVelocities = _mergeAndSync[2];
	      var lastIdealStyles = _mergeAndSync[3];
	      var lastIdealVelocities = _mergeAndSync[4];
	
	      for (var i = 0; i < unreadPropStyles.length; i++) {
	        var unreadPropStyle = unreadPropStyles[i].style;
	        var dirty = false;
	
	        for (var key in unreadPropStyle) {
	          if (!Object.prototype.hasOwnProperty.call(unreadPropStyle, key)) {
	            continue;
	          }
	
	          var styleValue = unreadPropStyle[key];
	          if (typeof styleValue === 'number') {
	            if (!dirty) {
	              dirty = true;
	              currentStyles[i] = _extends({}, currentStyles[i]);
	              currentVelocities[i] = _extends({}, currentVelocities[i]);
	              lastIdealStyles[i] = _extends({}, lastIdealStyles[i]);
	              lastIdealVelocities[i] = _extends({}, lastIdealVelocities[i]);
	              mergedPropsStyles[i] = {
	                key: mergedPropsStyles[i].key,
	                data: mergedPropsStyles[i].data,
	                style: _extends({}, mergedPropsStyles[i].style)
	              };
	            }
	            currentStyles[i][key] = styleValue;
	            currentVelocities[i][key] = 0;
	            lastIdealStyles[i][key] = styleValue;
	            lastIdealVelocities[i][key] = 0;
	            mergedPropsStyles[i].style[key] = styleValue;
	          }
	        }
	      }
	
	      // unlike the other 2 components, we can't detect staleness and optionally
	      // opt out of setState here. each style object's data might contain new
	      // stuff we're not/cannot compare
	      _this.setState({
	        currentStyles: currentStyles,
	        currentVelocities: currentVelocities,
	        mergedPropsStyles: mergedPropsStyles,
	        lastIdealStyles: lastIdealStyles,
	        lastIdealVelocities: lastIdealVelocities
	      });
	    };
	
	    this.startAnimationIfNecessary = function () {
	      if (_this.unmounting) {
	        return;
	      }
	
	      // TODO: when config is {a: 10} and dest is {a: 10} do we raf once and
	      // call cb? No, otherwise accidental parent rerender causes cb trigger
	      _this.animationID = _raf2['default'](function (timestamp) {
	        // https://github.com/chenglou/react-motion/pull/420
	        // > if execution passes the conditional if (this.unmounting), then
	        // executes async defaultRaf and after that component unmounts and after
	        // that the callback of defaultRaf is called, then setState will be called
	        // on unmounted component.
	        if (_this.unmounting) {
	          return;
	        }
	
	        var propStyles = _this.props.styles;
	        var destStyles = typeof propStyles === 'function' ? propStyles(rehydrateStyles(_this.state.mergedPropsStyles, _this.unreadPropStyles, _this.state.lastIdealStyles)) : propStyles;
	
	        // check if we need to animate in the first place
	        if (shouldStopAnimationAll(_this.state.currentStyles, destStyles, _this.state.currentVelocities, _this.state.mergedPropsStyles)) {
	          // no need to cancel animationID here; shouldn't have any in flight
	          _this.animationID = null;
	          _this.accumulatedTime = 0;
	          return;
	        }
	
	        var currentTime = timestamp || _performanceNow2['default']();
	        var timeDelta = currentTime - _this.prevTime;
	        _this.prevTime = currentTime;
	        _this.accumulatedTime = _this.accumulatedTime + timeDelta;
	        // more than 10 frames? prolly switched browser tab. Restart
	        if (_this.accumulatedTime > msPerFrame * 10) {
	          _this.accumulatedTime = 0;
	        }
	
	        if (_this.accumulatedTime === 0) {
	          // no need to cancel animationID here; shouldn't have any in flight
	          _this.animationID = null;
	          _this.startAnimationIfNecessary();
	          return;
	        }
	
	        var currentFrameCompletion = (_this.accumulatedTime - Math.floor(_this.accumulatedTime / msPerFrame) * msPerFrame) / msPerFrame;
	        var framesToCatchUp = Math.floor(_this.accumulatedTime / msPerFrame);
	
	        var _mergeAndSync2 = mergeAndSync(_this.props.willEnter, _this.props.willLeave, _this.props.didLeave, _this.state.mergedPropsStyles, destStyles, _this.state.currentStyles, _this.state.currentVelocities, _this.state.lastIdealStyles, _this.state.lastIdealVelocities);
	
	        var newMergedPropsStyles = _mergeAndSync2[0];
	        var newCurrentStyles = _mergeAndSync2[1];
	        var newCurrentVelocities = _mergeAndSync2[2];
	        var newLastIdealStyles = _mergeAndSync2[3];
	        var newLastIdealVelocities = _mergeAndSync2[4];
	
	        for (var i = 0; i < newMergedPropsStyles.length; i++) {
	          var newMergedPropsStyle = newMergedPropsStyles[i].style;
	          var newCurrentStyle = {};
	          var newCurrentVelocity = {};
	          var newLastIdealStyle = {};
	          var newLastIdealVelocity = {};
	
	          for (var key in newMergedPropsStyle) {
	            if (!Object.prototype.hasOwnProperty.call(newMergedPropsStyle, key)) {
	              continue;
	            }
	
	            var styleValue = newMergedPropsStyle[key];
	            if (typeof styleValue === 'number') {
	              newCurrentStyle[key] = styleValue;
	              newCurrentVelocity[key] = 0;
	              newLastIdealStyle[key] = styleValue;
	              newLastIdealVelocity[key] = 0;
	            } else {
	              var newLastIdealStyleValue = newLastIdealStyles[i][key];
	              var newLastIdealVelocityValue = newLastIdealVelocities[i][key];
	              for (var j = 0; j < framesToCatchUp; j++) {
	                var _stepper = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);
	
	                newLastIdealStyleValue = _stepper[0];
	                newLastIdealVelocityValue = _stepper[1];
	              }
	
	              var _stepper2 = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);
	
	              var nextIdealX = _stepper2[0];
	              var nextIdealV = _stepper2[1];
	
	              newCurrentStyle[key] = newLastIdealStyleValue + (nextIdealX - newLastIdealStyleValue) * currentFrameCompletion;
	              newCurrentVelocity[key] = newLastIdealVelocityValue + (nextIdealV - newLastIdealVelocityValue) * currentFrameCompletion;
	              newLastIdealStyle[key] = newLastIdealStyleValue;
	              newLastIdealVelocity[key] = newLastIdealVelocityValue;
	            }
	          }
	
	          newLastIdealStyles[i] = newLastIdealStyle;
	          newLastIdealVelocities[i] = newLastIdealVelocity;
	          newCurrentStyles[i] = newCurrentStyle;
	          newCurrentVelocities[i] = newCurrentVelocity;
	        }
	
	        _this.animationID = null;
	        // the amount we're looped over above
	        _this.accumulatedTime -= framesToCatchUp * msPerFrame;
	
	        _this.setState({
	          currentStyles: newCurrentStyles,
	          currentVelocities: newCurrentVelocities,
	          lastIdealStyles: newLastIdealStyles,
	          lastIdealVelocities: newLastIdealVelocities,
	          mergedPropsStyles: newMergedPropsStyles
	        });
	
	        _this.unreadPropStyles = null;
	
	        _this.startAnimationIfNecessary();
	      });
	    };
	
	    this.state = this.defaultState();
	  }
	
	  TransitionMotion.prototype.defaultState = function defaultState() {
	    var _props = this.props;
	    var defaultStyles = _props.defaultStyles;
	    var styles = _props.styles;
	    var willEnter = _props.willEnter;
	    var willLeave = _props.willLeave;
	    var didLeave = _props.didLeave;
	
	    var destStyles = typeof styles === 'function' ? styles(defaultStyles) : styles;
	
	    // this is special. for the first time around, we don't have a comparison
	    // between last (no last) and current merged props. we'll compute last so:
	    // say default is {a, b} and styles (dest style) is {b, c}, we'll
	    // fabricate last as {a, b}
	    var oldMergedPropsStyles = undefined;
	    if (defaultStyles == null) {
	      oldMergedPropsStyles = destStyles;
	    } else {
	      oldMergedPropsStyles = defaultStyles.map(function (defaultStyleCell) {
	        // TODO: key search code
	        for (var i = 0; i < destStyles.length; i++) {
	          if (destStyles[i].key === defaultStyleCell.key) {
	            return destStyles[i];
	          }
	        }
	        return defaultStyleCell;
	      });
	    }
	    var oldCurrentStyles = defaultStyles == null ? destStyles.map(function (s) {
	      return _stripStyle2['default'](s.style);
	    }) : defaultStyles.map(function (s) {
	      return _stripStyle2['default'](s.style);
	    });
	    var oldCurrentVelocities = defaultStyles == null ? destStyles.map(function (s) {
	      return _mapToZero2['default'](s.style);
	    }) : defaultStyles.map(function (s) {
	      return _mapToZero2['default'](s.style);
	    });
	
	    var _mergeAndSync3 = mergeAndSync(
	    // Because this is an old-style createReactClass component, Flow doesn't
	    // understand that the willEnter and willLeave props have default values
	    // and will always be present.
	    willEnter, willLeave, didLeave, oldMergedPropsStyles, destStyles, oldCurrentStyles, oldCurrentVelocities, oldCurrentStyles, // oldLastIdealStyles really
	    oldCurrentVelocities);
	
	    var mergedPropsStyles = _mergeAndSync3[0];
	    var currentStyles = _mergeAndSync3[1];
	    var currentVelocities = _mergeAndSync3[2];
	    var lastIdealStyles = _mergeAndSync3[3];
	    var lastIdealVelocities = _mergeAndSync3[4];
	    // oldLastIdealVelocities really
	
	    return {
	      currentStyles: currentStyles,
	      currentVelocities: currentVelocities,
	      lastIdealStyles: lastIdealStyles,
	      lastIdealVelocities: lastIdealVelocities,
	      mergedPropsStyles: mergedPropsStyles
	    };
	  };
	
	  // after checking for unreadPropStyles != null, we manually go set the
	  // non-interpolating values (those that are a number, without a spring
	  // config)
	
	  TransitionMotion.prototype.componentDidMount = function componentDidMount() {
	    this.prevTime = _performanceNow2['default']();
	    this.startAnimationIfNecessary();
	  };
	
	  TransitionMotion.prototype.componentWillReceiveProps = function componentWillReceiveProps(props) {
	    if (this.unreadPropStyles) {
	      // previous props haven't had the chance to be set yet; set them here
	      this.clearUnreadPropStyle(this.unreadPropStyles);
	    }
	
	    var styles = props.styles;
	    if (typeof styles === 'function') {
	      this.unreadPropStyles = styles(rehydrateStyles(this.state.mergedPropsStyles, this.unreadPropStyles, this.state.lastIdealStyles));
	    } else {
	      this.unreadPropStyles = styles;
	    }
	
	    if (this.animationID == null) {
	      this.prevTime = _performanceNow2['default']();
	      this.startAnimationIfNecessary();
	    }
	  };
	
	  TransitionMotion.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.unmounting = true;
	    if (this.animationID != null) {
	      _raf2['default'].cancel(this.animationID);
	      this.animationID = null;
	    }
	  };
	
	  TransitionMotion.prototype.render = function render() {
	    var hydratedStyles = rehydrateStyles(this.state.mergedPropsStyles, this.unreadPropStyles, this.state.currentStyles);
	    var renderedChildren = this.props.children(hydratedStyles);
	    return renderedChildren && _react2['default'].Children.only(renderedChildren);
	  };
	
	  return TransitionMotion;
	})(_react2['default'].Component);
	
	exports['default'] = TransitionMotion;
	module.exports = exports['default'];
	
	// list of styles, each containing interpolating values. Part of what's passed
	// to children function. Notice that this is
	// Array<ActualInterpolatingStyleObject>, without the wrapper that is {key: ...,
	// data: ... style: ActualInterpolatingStyleObject}. Only mergedPropsStyles
	// contains the key & data info (so that we only have a single source of truth
	// for these, and to save space). Check the comment for `rehydrateStyles` to
	// see how we regenerate the entirety of what's passed to children function
	
	// the array that keeps track of currently rendered stuff! Including stuff
	// that you've unmounted but that's still animating. This is where it lives
	
	// it's possible that currentStyle's value is stale: if props is immediately
	// changed from 0 to 400 to spring(0) again, the async currentStyle is still
	// at 0 (didn't have time to tick and interpolate even once). If we naively
	// compare currentStyle with destVal it'll be 0 === 0 (no animation, stop).
	// In reality currentStyle should be 400

/***/ }),
/* 2011 */
/***/ (function(module, exports) {

	
	
	// core keys merging algorithm. If previous render's keys are [a, b], and the
	// next render's [c, b, d], what's the final merged keys and ordering?
	
	// - c and a must both be before b
	// - b before d
	// - ordering between a and c ambiguous
	
	// this reduces to merging two partially ordered lists (e.g. lists where not
	// every item has a definite ordering, like comparing a and c above). For the
	// ambiguous ordering we deterministically choose to place the next render's
	// item after the previous'; so c after a
	
	// this is called a topological sorting. Except the existing algorithms don't
	// work well with js bc of the amount of allocation, and isn't optimized for our
	// current use-case bc the runtime is linear in terms of edges (see wiki for
	// meaning), which is huge when two lists have many common elements
	'use strict';
	
	exports.__esModule = true;
	exports['default'] = mergeDiff;
	
	function mergeDiff(prev, next, onRemove) {
	  // bookkeeping for easier access of a key's index below. This is 2 allocations +
	  // potentially triggering chrome hash map mode for objs (so it might be faster
	
	  var prevKeyIndex = {};
	  for (var i = 0; i < prev.length; i++) {
	    prevKeyIndex[prev[i].key] = i;
	  }
	  var nextKeyIndex = {};
	  for (var i = 0; i < next.length; i++) {
	    nextKeyIndex[next[i].key] = i;
	  }
	
	  // first, an overly elaborate way of merging prev and next, eliminating
	  // duplicates (in terms of keys). If there's dupe, keep the item in next).
	  // This way of writing it saves allocations
	  var ret = [];
	  for (var i = 0; i < next.length; i++) {
	    ret[i] = next[i];
	  }
	  for (var i = 0; i < prev.length; i++) {
	    if (!Object.prototype.hasOwnProperty.call(nextKeyIndex, prev[i].key)) {
	      // this is called my TM's `mergeAndSync`, which calls willLeave. We don't
	      // merge in keys that the user desires to kill
	      var fill = onRemove(i, prev[i]);
	      if (fill != null) {
	        ret.push(fill);
	      }
	    }
	  }
	
	  // now all the items all present. Core sorting logic to have the right order
	  return ret.sort(function (a, b) {
	    var nextOrderA = nextKeyIndex[a.key];
	    var nextOrderB = nextKeyIndex[b.key];
	    var prevOrderA = prevKeyIndex[a.key];
	    var prevOrderB = prevKeyIndex[b.key];
	
	    if (nextOrderA != null && nextOrderB != null) {
	      // both keys in next
	      return nextKeyIndex[a.key] - nextKeyIndex[b.key];
	    } else if (prevOrderA != null && prevOrderB != null) {
	      // both keys in prev
	      return prevKeyIndex[a.key] - prevKeyIndex[b.key];
	    } else if (nextOrderA != null) {
	      // key a in next, key b in prev
	
	      // how to determine the order between a and b? We find a "pivot" (term
	      // abuse), a key present in both prev and next, that is sandwiched between
	      // a and b. In the context of our above example, if we're comparing a and
	      // d, b's (the only) pivot
	      for (var i = 0; i < next.length; i++) {
	        var pivot = next[i].key;
	        if (!Object.prototype.hasOwnProperty.call(prevKeyIndex, pivot)) {
	          continue;
	        }
	
	        if (nextOrderA < nextKeyIndex[pivot] && prevOrderB > prevKeyIndex[pivot]) {
	          return -1;
	        } else if (nextOrderA > nextKeyIndex[pivot] && prevOrderB < prevKeyIndex[pivot]) {
	          return 1;
	        }
	      }
	      // pluggable. default to: next bigger than prev
	      return 1;
	    }
	    // prevOrderA, nextOrderB
	    for (var i = 0; i < next.length; i++) {
	      var pivot = next[i].key;
	      if (!Object.prototype.hasOwnProperty.call(prevKeyIndex, pivot)) {
	        continue;
	      }
	      if (nextOrderB < nextKeyIndex[pivot] && prevOrderA > prevKeyIndex[pivot]) {
	        return 1;
	      } else if (nextOrderB > nextKeyIndex[pivot] && prevOrderA < prevKeyIndex[pivot]) {
	        return -1;
	      }
	    }
	    // pluggable. default to: next bigger than prev
	    return -1;
	  });
	}
	
	module.exports = exports['default'];
	// to loop through and find a key's index each time), but I no longer care

/***/ }),
/* 2012 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports['default'] = spring;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _presets = __webpack_require__(2013);
	
	var _presets2 = _interopRequireDefault(_presets);
	
	var defaultConfig = _extends({}, _presets2['default'].noWobble, {
	  precision: 0.01
	});
	
	function spring(val, config) {
	  return _extends({}, defaultConfig, config, { val: val });
	}
	
	module.exports = exports['default'];

/***/ }),
/* 2013 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = {
	  noWobble: { stiffness: 170, damping: 26 }, // the default, if nothing provided
	  gentle: { stiffness: 120, damping: 14 },
	  wobbly: { stiffness: 180, damping: 12 },
	  stiff: { stiffness: 210, damping: 20 }
	};
	module.exports = exports["default"];

/***/ }),
/* 2014 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = reorderKeys;
	
	var hasWarned = false;
	
	function reorderKeys() {
	  if (false) {
	    if (!hasWarned) {
	      hasWarned = true;
	      console.error('`reorderKeys` has been removed, since it is no longer needed for TransitionMotion\'s new styles array API.');
	    }
	  }
	}
	
	module.exports = exports['default'];

/***/ }),
/* 2015 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _dragHandle = __webpack_require__(2016);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_dragHandle).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 2016 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(1878);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(1879);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(1883);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _DragHandle$contextTy;
	
	var _react = __webpack_require__(300);
	
	var _propTypes = __webpack_require__(956);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _memoizeOne = __webpack_require__(1903);
	
	var _memoizeOne2 = _interopRequireDefault(_memoizeOne);
	
	var _contextKeys = __webpack_require__(1952);
	
	var _shouldAllowDraggingFromTarget = __webpack_require__(2017);
	
	var _shouldAllowDraggingFromTarget2 = _interopRequireDefault(_shouldAllowDraggingFromTarget);
	
	var _createMouseSensor = __webpack_require__(2018);
	
	var _createMouseSensor2 = _interopRequireDefault(_createMouseSensor);
	
	var _createKeyboardSensor = __webpack_require__(2027);
	
	var _createKeyboardSensor2 = _interopRequireDefault(_createKeyboardSensor);
	
	var _createTouchSensor = __webpack_require__(2029);
	
	var _createTouchSensor2 = _interopRequireDefault(_createTouchSensor);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var preventHtml5Dnd = function preventHtml5Dnd(event) {
	  event.preventDefault();
	};
	
	var DragHandle = function (_Component) {
	  (0, _inherits3.default)(DragHandle, _Component);
	
	  function DragHandle(props, context) {
	    (0, _classCallCheck3.default)(this, DragHandle);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, _Component.call(this, props, context));
	
	    _this.onKeyDown = function (event) {
	      if (_this.mouseSensor.isCapturing()) {
	        return;
	      }
	
	      _this.keyboardSensor.onKeyDown(event, _this.props);
	    };
	
	    _this.onMouseDown = function (event) {
	      if (_this.keyboardSensor.isCapturing() || _this.mouseSensor.isCapturing()) {
	        return;
	      }
	
	      _this.mouseSensor.onMouseDown(event);
	    };
	
	    _this.onTouchStart = function (event) {
	      if (_this.mouseSensor.isCapturing() || _this.keyboardSensor.isCapturing()) {
	        console.error('mouse or keyboard already listening when attempting to touch drag');
	        return;
	      }
	
	      _this.touchSensor.onTouchStart(event);
	    };
	
	    _this.onTouchMove = function (event) {
	      _this.touchSensor.onTouchMove(event);
	    };
	
	    _this.canStartCapturing = function (event) {
	      if (_this.isAnySensorCapturing()) {
	        return false;
	      }
	
	      if (!_this.canLift(_this.props.draggableId)) {
	        return false;
	      }
	
	      return (0, _shouldAllowDraggingFromTarget2.default)(event, _this.props);
	    };
	
	    _this.isAnySensorCapturing = function () {
	      return _this.sensors.some(function (sensor) {
	        return sensor.isCapturing();
	      });
	    };
	
	    _this.getProvided = (0, _memoizeOne2.default)(function (isEnabled) {
	      if (!isEnabled) {
	        return null;
	      }
	
	      var provided = {
	        onMouseDown: _this.onMouseDown,
	        onKeyDown: _this.onKeyDown,
	        onTouchStart: _this.onTouchStart,
	        onTouchMove: _this.onTouchMove,
	        tabIndex: 0,
	        'data-react-beautiful-dnd-drag-handle': _this.styleContext,
	
	        'aria-roledescription': 'Draggable item. Press space bar to lift',
	        draggable: false,
	        onDragStart: preventHtml5Dnd
	      };
	
	      return provided;
	    });
	
	
	    var args = {
	      callbacks: _this.props.callbacks,
	      getDraggableRef: _this.props.getDraggableRef,
	      canStartCapturing: _this.canStartCapturing
	    };
	
	    _this.mouseSensor = (0, _createMouseSensor2.default)(args);
	    _this.keyboardSensor = (0, _createKeyboardSensor2.default)(args);
	    _this.touchSensor = (0, _createTouchSensor2.default)(args);
	    _this.sensors = [_this.mouseSensor, _this.keyboardSensor, _this.touchSensor];
	    _this.styleContext = context[_contextKeys.styleContextKey];
	
	    _this.canLift = context[_contextKeys.canLiftContextKey];
	    return _this;
	  }
	
	  DragHandle.prototype.componentWillUnmount = function componentWillUnmount() {
	    var _this2 = this;
	
	    this.sensors.forEach(function (sensor) {
	      var wasDragging = sensor.isDragging();
	
	      sensor.unmount();
	
	      if (wasDragging) {
	        _this2.props.callbacks.onCancel();
	      }
	    });
	  };
	
	  DragHandle.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    var _this3 = this;
	
	    var isCapturing = this.isAnySensorCapturing();
	
	    if (!isCapturing) {
	      return;
	    }
	
	    var isDragStopping = this.props.isDragging && !nextProps.isDragging;
	
	    if (isDragStopping) {
	      this.sensors.forEach(function (sensor) {
	        if (sensor.isCapturing()) {
	          sensor.kill();
	        }
	      });
	      return;
	    }
	
	    if (!nextProps.isEnabled) {
	      this.sensors.forEach(function (sensor) {
	        if (sensor.isCapturing()) {
	          var wasDragging = sensor.isDragging();
	
	          sensor.kill();
	
	          if (wasDragging) {
	            _this3.props.callbacks.onCancel();
	          }
	        }
	      });
	    }
	  };
	
	  DragHandle.prototype.render = function render() {
	    var _props = this.props,
	        children = _props.children,
	        isEnabled = _props.isEnabled;
	
	
	    return children(this.getProvided(isEnabled));
	  };
	
	  return DragHandle;
	}(_react.Component);
	
	DragHandle.contextTypes = (_DragHandle$contextTy = {}, _DragHandle$contextTy[_contextKeys.styleContextKey] = _propTypes2.default.string.isRequired, _DragHandle$contextTy[_contextKeys.canLiftContextKey] = _propTypes2.default.func.isRequired, _DragHandle$contextTy);
	exports.default = DragHandle;

/***/ }),
/* 2017 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var interactiveTagNames = exports.interactiveTagNames = {
	  input: true,
	  button: true,
	  textarea: true,
	  select: true,
	  option: true,
	  optgroup: true,
	  video: true,
	  audio: true
	};
	
	var isAnInteractiveElement = function isAnInteractiveElement(parent, current) {
	  if (current == null) {
	    return false;
	  }
	
	  var hasAnInteractiveTag = Boolean(interactiveTagNames[current.tagName.toLowerCase()]);
	
	  if (hasAnInteractiveTag) {
	    return true;
	  }
	
	  var attribute = current.getAttribute('contenteditable');
	  if (attribute === 'true' || attribute === '') {
	    return true;
	  }
	
	  if (current === parent) {
	    return false;
	  }
	
	  return isAnInteractiveElement(parent, current.parentElement);
	};
	
	exports.default = function (event, props) {
	  if (props.canDragInteractiveElements) {
	    return true;
	  }
	
	  var target = event.target,
	      currentTarget = event.currentTarget;
	
	  if (!(target instanceof HTMLElement) || !(currentTarget instanceof HTMLElement)) {
	    return true;
	  }
	
	  return !isAnInteractiveElement(currentTarget, target);
	};

/***/ }),
/* 2018 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createScheduler = __webpack_require__(2019);
	
	var _createScheduler2 = _interopRequireDefault(_createScheduler);
	
	var _isSloppyClickThresholdExceeded = __webpack_require__(2020);
	
	var _isSloppyClickThresholdExceeded2 = _interopRequireDefault(_isSloppyClickThresholdExceeded);
	
	var _getWindowFromRef = __webpack_require__(2021);
	
	var _getWindowFromRef2 = _interopRequireDefault(_getWindowFromRef);
	
	var _keyCodes = __webpack_require__(2022);
	
	var keyCodes = _interopRequireWildcard(_keyCodes);
	
	var _preventStandardKeyEvents = __webpack_require__(2023);
	
	var _preventStandardKeyEvents2 = _interopRequireDefault(_preventStandardKeyEvents);
	
	var _createPostDragEventPreventer = __webpack_require__(2024);
	
	var _createPostDragEventPreventer2 = _interopRequireDefault(_createPostDragEventPreventer);
	
	var _bindEvents = __webpack_require__(2025);
	
	var _createEventMarshal = __webpack_require__(2026);
	
	var _createEventMarshal2 = _interopRequireDefault(_createEventMarshal);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var primaryButton = 0;
	var noop = function noop() {};
	
	var mouseDownMarshal = (0, _createEventMarshal2.default)();
	
	exports.default = function (_ref) {
	  var callbacks = _ref.callbacks,
	      getDraggableRef = _ref.getDraggableRef,
	      canStartCapturing = _ref.canStartCapturing;
	
	  var state = {
	    isDragging: false,
	    pending: null
	  };
	  var setState = function setState(newState) {
	    state = newState;
	  };
	  var isDragging = function isDragging() {
	    return state.isDragging;
	  };
	  var isCapturing = function isCapturing() {
	    return Boolean(state.pending || state.isDragging);
	  };
	  var schedule = (0, _createScheduler2.default)(callbacks);
	  var getWindow = function getWindow() {
	    return (0, _getWindowFromRef2.default)(getDraggableRef());
	  };
	  var postDragEventPreventer = (0, _createPostDragEventPreventer2.default)(getWindow);
	
	  var startDragging = function startDragging() {
	    var fn = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : noop;
	
	    setState({
	      pending: null,
	      isDragging: true
	    });
	    fn();
	  };
	  var stopDragging = function stopDragging() {
	    var fn = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : noop;
	    var shouldBlockClick = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	    schedule.cancel();
	    unbindWindowEvents();
	    mouseDownMarshal.reset();
	    if (shouldBlockClick) {
	      postDragEventPreventer.preventNext();
	    }
	    setState({
	      isDragging: false,
	      pending: null
	    });
	    fn();
	  };
	  var startPendingDrag = function startPendingDrag(point) {
	    setState({ pending: point, isDragging: false });
	    bindWindowEvents();
	  };
	  var stopPendingDrag = function stopPendingDrag() {
	    stopDragging(noop, false);
	  };
	
	  var kill = function kill() {
	    var fn = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : noop;
	
	    if (state.pending) {
	      stopPendingDrag();
	      return;
	    }
	    stopDragging(fn);
	  };
	
	  var unmount = function unmount() {
	    kill();
	    postDragEventPreventer.abort();
	  };
	
	  var cancel = function cancel() {
	    kill(callbacks.onCancel);
	  };
	
	  var windowBindings = [{
	    eventName: 'mousemove',
	    fn: function fn(event) {
	      var button = event.button,
	          clientX = event.clientX,
	          clientY = event.clientY;
	
	      if (button !== primaryButton) {
	        return;
	      }
	
	      var point = {
	        x: clientX,
	        y: clientY
	      };
	
	      if (state.isDragging) {
	        event.preventDefault();
	        schedule.move(point);
	        return;
	      }
	
	      if (!state.pending) {
	        console.error('invalid state');
	        return;
	      }
	
	      if (!(0, _isSloppyClickThresholdExceeded2.default)(state.pending, point)) {
	        return;
	      }
	
	      event.preventDefault();
	      startDragging(function () {
	        return callbacks.onLift({
	          client: point,
	          autoScrollMode: 'FLUID'
	        });
	      });
	    }
	  }, {
	    eventName: 'mouseup',
	    fn: function fn(event) {
	      if (state.pending) {
	        stopPendingDrag();
	        return;
	      }
	
	      event.preventDefault();
	      stopDragging(callbacks.onDrop);
	    }
	  }, {
	    eventName: 'mousedown',
	    fn: function fn(event) {
	      if (state.isDragging) {
	        event.preventDefault();
	      }
	
	      stopDragging(callbacks.onCancel);
	    }
	  }, {
	    eventName: 'keydown',
	    fn: function fn(event) {
	      if (!state.isDragging) {
	        cancel();
	        return;
	      }
	
	      if (event.keyCode === keyCodes.escape) {
	        event.preventDefault();
	        cancel();
	        return;
	      }
	
	      (0, _preventStandardKeyEvents2.default)(event);
	    }
	  }, {
	    eventName: 'resize',
	    fn: cancel
	  }, {
	    eventName: 'scroll',
	
	    options: { passive: true },
	    fn: function fn() {
	      if (state.pending) {
	        stopPendingDrag();
	        return;
	      }
	      schedule.windowScrollMove();
	    }
	  }, {
	    eventName: 'webkitmouseforcechanged',
	    fn: function fn(event) {
	      if (event.webkitForce == null || MouseEvent.WEBKIT_FORCE_AT_FORCE_MOUSE_DOWN == null) {
	        console.error('handling a mouse force changed event when it is not supported');
	        return;
	      }
	
	      var forcePressThreshold = MouseEvent.WEBKIT_FORCE_AT_FORCE_MOUSE_DOWN;
	      var isForcePressing = event.webkitForce >= forcePressThreshold;
	
	      if (isForcePressing) {
	        cancel();
	      }
	    }
	  }];
	
	  var bindWindowEvents = function bindWindowEvents() {
	    var win = getWindow();
	    (0, _bindEvents.bindEvents)(win, windowBindings, { capture: true });
	  };
	
	  var unbindWindowEvents = function unbindWindowEvents() {
	    var win = getWindow();
	    (0, _bindEvents.unbindEvents)(win, windowBindings, { capture: true });
	  };
	
	  var onMouseDown = function onMouseDown(event) {
	    if (mouseDownMarshal.isHandled()) {
	      return;
	    }
	
	    if (!canStartCapturing(event)) {
	      return;
	    }
	
	    if (isCapturing()) {
	      console.error('should not be able to perform a mouse down while a drag or pending drag is occurring');
	      cancel();
	      return;
	    }
	
	    var button = event.button,
	        clientX = event.clientX,
	        clientY = event.clientY;
	
	    if (button !== primaryButton) {
	      return;
	    }
	
	    mouseDownMarshal.handle();
	
	    event.preventDefault();
	
	    var point = {
	      x: clientX,
	      y: clientY
	    };
	
	    startPendingDrag(point);
	  };
	
	  var sensor = {
	    onMouseDown: onMouseDown,
	    kill: kill,
	    isCapturing: isCapturing,
	    isDragging: isDragging,
	    unmount: unmount
	  };
	
	  return sensor;
	};

/***/ }),
/* 2019 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _memoizeOne = __webpack_require__(1903);
	
	var _memoizeOne2 = _interopRequireDefault(_memoizeOne);
	
	var _rafSchd = __webpack_require__(1948);
	
	var _rafSchd2 = _interopRequireDefault(_rafSchd);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (callbacks) {
	  var memoizedMove = (0, _memoizeOne2.default)(function (x, y) {
	    var point = { x: x, y: y };
	    callbacks.onMove(point);
	  });
	
	  var move = (0, _rafSchd2.default)(function (point) {
	    return memoizedMove(point.x, point.y);
	  });
	  var moveForward = (0, _rafSchd2.default)(callbacks.onMoveForward);
	  var moveBackward = (0, _rafSchd2.default)(callbacks.onMoveBackward);
	  var crossAxisMoveForward = (0, _rafSchd2.default)(callbacks.onCrossAxisMoveForward);
	  var crossAxisMoveBackward = (0, _rafSchd2.default)(callbacks.onCrossAxisMoveBackward);
	  var windowScrollMove = (0, _rafSchd2.default)(callbacks.onWindowScroll);
	
	  var cancel = function cancel() {
	
	    move.cancel();
	    moveForward.cancel();
	    moveBackward.cancel();
	    crossAxisMoveForward.cancel();
	    crossAxisMoveBackward.cancel();
	    windowScrollMove.cancel();
	  };
	
	  return {
	    move: move,
	    moveForward: moveForward,
	    moveBackward: moveBackward,
	    crossAxisMoveForward: crossAxisMoveForward,
	    crossAxisMoveBackward: crossAxisMoveBackward,
	    windowScrollMove: windowScrollMove,
	    cancel: cancel
	  };
	};

/***/ }),
/* 2020 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var sloppyClickThreshold = exports.sloppyClickThreshold = 5;
	
	exports.default = function (original, current) {
	  return Math.abs(current.x - original.x) >= sloppyClickThreshold || Math.abs(current.y - original.y) >= sloppyClickThreshold;
	};

/***/ }),
/* 2021 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (ref) {
	  return ref ? ref.ownerDocument.defaultView : window;
	};

/***/ }),
/* 2022 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var tab = exports.tab = 9;
	var enter = exports.enter = 13;
	var escape = exports.escape = 27;
	var space = exports.space = 32;
	var pageUp = exports.pageUp = 33;
	var pageDown = exports.pageDown = 34;
	var end = exports.end = 35;
	var home = exports.home = 36;
	var arrowLeft = exports.arrowLeft = 37;
	var arrowUp = exports.arrowUp = 38;
	var arrowRight = exports.arrowRight = 39;
	var arrowDown = exports.arrowDown = 40;

/***/ }),
/* 2023 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _preventedKeys;
	
	var _keyCodes = __webpack_require__(2022);
	
	var keyCodes = _interopRequireWildcard(_keyCodes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var preventedKeys = (_preventedKeys = {}, _preventedKeys[keyCodes.enter] = true, _preventedKeys[keyCodes.tab] = true, _preventedKeys);
	
	exports.default = function (event) {
	  if (preventedKeys[event.keyCode]) {
	    event.preventDefault();
	  }
	};

/***/ }),
/* 2024 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _bindEvents = __webpack_require__(2025);
	
	exports.default = function (getWindow) {
	  var isBound = false;
	
	  var bind = function bind() {
	    if (isBound) {
	      return;
	    }
	    isBound = true;
	    (0, _bindEvents.bindEvents)(getWindow(), pointerEvents, { capture: true });
	  };
	
	  var unbind = function unbind() {
	    if (!isBound) {
	      return;
	    }
	    isBound = false;
	    (0, _bindEvents.unbindEvents)(getWindow(), pointerEvents, { capture: true });
	  };
	
	  var pointerEvents = [{
	    eventName: 'click',
	    fn: function fn(event) {
	      event.preventDefault();
	      unbind();
	    }
	  }, {
	    eventName: 'mousedown',
	
	    fn: unbind
	  }, {
	    eventName: 'touchstart',
	    fn: unbind
	  }];
	
	  var preventNext = function preventNext() {
	    if (isBound) {
	      unbind();
	    }
	
	    bind();
	  };
	
	  var preventer = {
	    preventNext: preventNext,
	    abort: unbind
	  };
	
	  return preventer;
	};

/***/ }),
/* 2025 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.unbindEvents = exports.bindEvents = undefined;
	
	var _extends2 = __webpack_require__(1901);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var bindEvents = exports.bindEvents = function bindEvents(el, bindings, sharedOptions) {
	  bindings.forEach(function (binding) {
	    var options = (0, _extends3.default)({}, sharedOptions, binding.options);
	
	    el.addEventListener(binding.eventName, binding.fn, options);
	  });
	};
	
	var unbindEvents = exports.unbindEvents = function unbindEvents(el, bindings, sharedOptions) {
	  bindings.forEach(function (binding) {
	    var options = (0, _extends3.default)({}, sharedOptions, binding.options);
	
	    el.removeEventListener(binding.eventName, binding.fn, options);
	  });
	};

/***/ }),
/* 2026 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function () {
	  var isMouseDownHandled = false;
	
	  var handle = function handle() {
	    if (isMouseDownHandled) {
	      console.error('Cannot handle mouse down as it is already handled');
	      return;
	    }
	    isMouseDownHandled = true;
	  };
	
	  var isHandled = function isHandled() {
	    return isMouseDownHandled;
	  };
	
	  var reset = function reset() {
	    isMouseDownHandled = false;
	  };
	
	  return {
	    handle: handle,
	    isHandled: isHandled,
	    reset: reset
	  };
	};

/***/ }),
/* 2027 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _scrollJumpKeys;
	
	var _createScheduler = __webpack_require__(2019);
	
	var _createScheduler2 = _interopRequireDefault(_createScheduler);
	
	var _preventStandardKeyEvents = __webpack_require__(2023);
	
	var _preventStandardKeyEvents2 = _interopRequireDefault(_preventStandardKeyEvents);
	
	var _keyCodes = __webpack_require__(2022);
	
	var keyCodes = _interopRequireWildcard(_keyCodes);
	
	var _getWindowFromRef = __webpack_require__(2021);
	
	var _getWindowFromRef2 = _interopRequireDefault(_getWindowFromRef);
	
	var _getCenterPosition = __webpack_require__(2028);
	
	var _getCenterPosition2 = _interopRequireDefault(_getCenterPosition);
	
	var _bindEvents = __webpack_require__(2025);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var scrollJumpKeys = (_scrollJumpKeys = {}, _scrollJumpKeys[keyCodes.pageDown] = true, _scrollJumpKeys[keyCodes.pageUp] = true, _scrollJumpKeys[keyCodes.home] = true, _scrollJumpKeys[keyCodes.end] = true, _scrollJumpKeys);
	
	var noop = function noop() {};
	
	exports.default = function (_ref) {
	  var callbacks = _ref.callbacks,
	      getDraggableRef = _ref.getDraggableRef,
	      canStartCapturing = _ref.canStartCapturing;
	
	  var state = {
	    isDragging: false
	  };
	  var setState = function setState(newState) {
	    state = newState;
	  };
	  var getWindow = function getWindow() {
	    return (0, _getWindowFromRef2.default)(getDraggableRef());
	  };
	
	  var startDragging = function startDragging() {
	    var fn = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : noop;
	
	    setState({
	      isDragging: true
	    });
	    bindWindowEvents();
	    fn();
	  };
	  var stopDragging = function stopDragging() {
	    var fn = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : noop;
	
	    schedule.cancel();
	    unbindWindowEvents();
	    setState({ isDragging: false });
	    fn();
	  };
	  var kill = function kill() {
	    return stopDragging();
	  };
	  var cancel = function cancel() {
	    stopDragging(callbacks.onCancel);
	  };
	  var isDragging = function isDragging() {
	    return state.isDragging;
	  };
	  var schedule = (0, _createScheduler2.default)(callbacks);
	
	  var onKeyDown = function onKeyDown(event, props) {
	    var direction = props.direction;
	
	    if (!isDragging()) {
	      if (event.defaultPrevented) {
	        return;
	      }
	
	      if (!canStartCapturing(event)) {
	        return;
	      }
	
	      if (event.keyCode !== keyCodes.space) {
	        return;
	      }
	
	      var ref = getDraggableRef();
	
	      if (!ref) {
	        console.error('cannot start a keyboard drag without a draggable ref');
	        return;
	      }
	
	      var center = (0, _getCenterPosition2.default)(ref);
	
	      event.preventDefault();
	      startDragging(function () {
	        return callbacks.onLift({
	          client: center,
	          autoScrollMode: 'JUMP'
	        });
	      });
	      return;
	    }
	
	    if (event.keyCode === keyCodes.escape) {
	      event.preventDefault();
	      cancel();
	      return;
	    }
	
	    if (event.keyCode === keyCodes.space) {
	      event.preventDefault();
	      stopDragging(callbacks.onDrop);
	      return;
	    }
	
	    if (!direction) {
	      console.error('Cannot handle keyboard movement event if direction is not provided');
	
	      event.preventDefault();
	      cancel();
	      return;
	    }
	
	    var executeBasedOnDirection = function executeBasedOnDirection(fns) {
	      if (direction === 'vertical') {
	        fns.vertical();
	        return;
	      }
	      fns.horizontal();
	    };
	
	    if (event.keyCode === keyCodes.arrowDown) {
	      event.preventDefault();
	      executeBasedOnDirection({
	        vertical: schedule.moveForward,
	        horizontal: schedule.crossAxisMoveForward
	      });
	      return;
	    }
	
	    if (event.keyCode === keyCodes.arrowUp) {
	      event.preventDefault();
	      executeBasedOnDirection({
	        vertical: schedule.moveBackward,
	        horizontal: schedule.crossAxisMoveBackward
	      });
	      return;
	    }
	
	    if (event.keyCode === keyCodes.arrowRight) {
	      event.preventDefault();
	      executeBasedOnDirection({
	        vertical: schedule.crossAxisMoveForward,
	        horizontal: schedule.moveForward
	      });
	      return;
	    }
	
	    if (event.keyCode === keyCodes.arrowLeft) {
	      event.preventDefault();
	      executeBasedOnDirection({
	        vertical: schedule.crossAxisMoveBackward,
	        horizontal: schedule.moveBackward
	      });
	    }
	
	    if (scrollJumpKeys[event.keyCode]) {
	      event.preventDefault();
	      return;
	    }
	
	    (0, _preventStandardKeyEvents2.default)(event);
	  };
	
	  var windowBindings = [{
	    eventName: 'mousedown',
	    fn: cancel
	  }, {
	    eventName: 'mouseup',
	    fn: cancel
	  }, {
	    eventName: 'click',
	    fn: cancel
	  }, {
	    eventName: 'touchstart',
	    fn: cancel
	  }, {
	    eventName: 'resize',
	    fn: cancel
	  }, {
	    eventName: 'wheel',
	    fn: cancel
	  }, {
	    eventName: 'scroll',
	    fn: callbacks.onWindowScroll
	  }];
	
	  var bindWindowEvents = function bindWindowEvents() {
	    (0, _bindEvents.bindEvents)(getWindow(), windowBindings, { capture: true });
	  };
	
	  var unbindWindowEvents = function unbindWindowEvents() {
	    (0, _bindEvents.unbindEvents)(getWindow(), windowBindings, { capture: true });
	  };
	
	  var sensor = {
	    onKeyDown: onKeyDown,
	    kill: kill,
	    isDragging: isDragging,
	
	    isCapturing: isDragging,
	
	    unmount: kill
	  };
	
	  return sensor;
	};

/***/ }),
/* 2028 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getArea = __webpack_require__(1908);
	
	var _getArea2 = _interopRequireDefault(_getArea);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (el) {
	  return (0, _getArea2.default)(el.getBoundingClientRect()).center;
	};

/***/ }),
/* 2029 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.forcePressThreshold = exports.timeForLongPress = undefined;
	
	var _extends2 = __webpack_require__(1901);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _createScheduler = __webpack_require__(2019);
	
	var _createScheduler2 = _interopRequireDefault(_createScheduler);
	
	var _getWindowFromRef = __webpack_require__(2021);
	
	var _getWindowFromRef2 = _interopRequireDefault(_getWindowFromRef);
	
	var _createPostDragEventPreventer = __webpack_require__(2024);
	
	var _createPostDragEventPreventer2 = _interopRequireDefault(_createPostDragEventPreventer);
	
	var _createEventMarshal = __webpack_require__(2026);
	
	var _createEventMarshal2 = _interopRequireDefault(_createEventMarshal);
	
	var _bindEvents = __webpack_require__(2025);
	
	var _keyCodes = __webpack_require__(2022);
	
	var keyCodes = _interopRequireWildcard(_keyCodes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var timeForLongPress = exports.timeForLongPress = 150;
	var forcePressThreshold = exports.forcePressThreshold = 0.15;
	var touchStartMarshal = (0, _createEventMarshal2.default)();
	
	var noop = function noop() {};
	
	var initial = {
	  isDragging: false,
	  pending: null,
	  hasMoved: false,
	  longPressTimerId: null
	};
	
	exports.default = function (_ref) {
	  var callbacks = _ref.callbacks,
	      getDraggableRef = _ref.getDraggableRef,
	      canStartCapturing = _ref.canStartCapturing;
	
	  var state = initial;
	
	  var getWindow = function getWindow() {
	    return (0, _getWindowFromRef2.default)(getDraggableRef());
	  };
	  var setState = function setState(partial) {
	    state = (0, _extends3.default)({}, state, partial);
	  };
	  var isDragging = function isDragging() {
	    return state.isDragging;
	  };
	  var isCapturing = function isCapturing() {
	    return Boolean(state.pending || state.isDragging || state.longPressTimerId);
	  };
	  var schedule = (0, _createScheduler2.default)(callbacks);
	  var postDragEventPreventer = (0, _createPostDragEventPreventer2.default)(getWindow);
	
	  var startDragging = function startDragging() {
	    var pending = state.pending;
	
	    if (!pending) {
	      console.error('cannot start a touch drag without a pending position');
	      kill();
	      return;
	    }
	
	    setState({
	      isDragging: true,
	
	      hasMoved: false,
	
	      pending: null,
	      longPressTimerId: null
	    });
	
	    callbacks.onLift({
	      client: pending,
	      autoScrollMode: 'FLUID'
	    });
	  };
	  var stopDragging = function stopDragging() {
	    var fn = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : noop;
	
	    schedule.cancel();
	    touchStartMarshal.reset();
	    unbindWindowEvents();
	    postDragEventPreventer.preventNext();
	    setState(initial);
	    fn();
	  };
	
	  var startPendingDrag = function startPendingDrag(event) {
	    var touch = event.touches[0];
	    var clientX = touch.clientX,
	        clientY = touch.clientY;
	
	    var point = {
	      x: clientX,
	      y: clientY
	    };
	
	    var longPressTimerId = setTimeout(startDragging, timeForLongPress);
	
	    setState({
	      longPressTimerId: longPressTimerId,
	      pending: point,
	      isDragging: false,
	      hasMoved: false
	    });
	    bindWindowEvents();
	  };
	
	  var stopPendingDrag = function stopPendingDrag() {
	    clearTimeout(state.longPressTimerId);
	    schedule.cancel();
	    touchStartMarshal.reset();
	    unbindWindowEvents();
	
	    setState(initial);
	  };
	
	  var kill = function kill() {
	    var fn = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : noop;
	
	    if (state.pending) {
	      stopPendingDrag();
	      return;
	    }
	    stopDragging(fn);
	  };
	
	  var unmount = function unmount() {
	    kill();
	    postDragEventPreventer.abort();
	  };
	
	  var cancel = function cancel() {
	    kill(callbacks.onCancel);
	  };
	
	  var windowBindings = [{
	    eventName: 'touchmove',
	
	    options: { passive: false },
	    fn: function fn(event) {
	      if (!state.isDragging) {
	        stopPendingDrag();
	        return;
	      }
	
	      if (!state.hasMoved) {
	        setState({
	          hasMoved: true
	        });
	      }
	
	      var _event$touches$ = event.touches[0],
	          clientX = _event$touches$.clientX,
	          clientY = _event$touches$.clientY;
	
	
	      var point = {
	        x: clientX,
	        y: clientY
	      };
	
	      event.preventDefault();
	      schedule.move(point);
	    }
	  }, {
	    eventName: 'touchend',
	    fn: function fn(event) {
	      if (!state.isDragging) {
	        stopPendingDrag();
	        return;
	      }
	
	      event.preventDefault();
	      stopDragging(callbacks.onDrop);
	    }
	  }, {
	    eventName: 'touchcancel',
	    fn: function fn(event) {
	      if (!state.isDragging) {
	        stopPendingDrag();
	        return;
	      }
	
	      event.preventDefault();
	      stopDragging(callbacks.onCancel);
	    }
	  }, {
	    eventName: 'touchstart',
	    fn: cancel
	  }, {
	    eventName: 'orientationchange',
	    fn: cancel
	  }, {
	    eventName: 'resize',
	    fn: cancel
	  }, {
	    eventName: 'scroll',
	    options: { passive: true },
	    fn: function fn() {
	      if (state.pending) {
	        stopPendingDrag();
	        return;
	      }
	      schedule.windowScrollMove();
	    }
	  }, {
	    eventName: 'contextmenu',
	    fn: function fn(event) {
	      event.preventDefault();
	    }
	  }, {
	    eventName: 'keydown',
	    fn: function fn(event) {
	      if (!state.isDragging) {
	        cancel();
	        return;
	      }
	
	      if (event.keyCode === keyCodes.escape) {
	        event.preventDefault();
	      }
	      cancel();
	    }
	  }, {
	    eventName: 'touchforcechange',
	    fn: function fn(event) {
	      if (state.hasMoved) {
	        event.preventDefault();
	        return;
	      }
	
	      var touch = event.touches[0];
	
	      if (touch.force >= forcePressThreshold) {
	        cancel();
	      }
	    }
	  }];
	
	  var bindWindowEvents = function bindWindowEvents() {
	    (0, _bindEvents.bindEvents)(getWindow(), windowBindings, { capture: true });
	  };
	
	  var unbindWindowEvents = function unbindWindowEvents() {
	    (0, _bindEvents.unbindEvents)(getWindow(), windowBindings, { capture: true });
	  };
	
	  var onTouchStart = function onTouchStart(event) {
	    if (touchStartMarshal.isHandled()) {
	      return;
	    }
	
	    if (!canStartCapturing(event)) {
	      return;
	    }
	
	    if (isCapturing()) {
	      console.error('should not be able to perform a touch start while a drag or pending drag is occurring');
	      cancel();
	      return;
	    }
	
	    touchStartMarshal.handle();
	
	    startPendingDrag(event);
	  };
	
	  var onTouchMove = function onTouchMove() {
	    if (state.pending) {
	      stopPendingDrag();
	    }
	  };
	
	  var sensor = {
	    onTouchStart: onTouchStart,
	    onTouchMove: onTouchMove,
	    kill: kill,
	    isCapturing: isCapturing,
	    isDragging: isDragging,
	    unmount: unmount
	  };
	
	  return sensor;
	};

/***/ }),
/* 2030 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getArea = __webpack_require__(1908);
	
	var _getArea2 = _interopRequireDefault(_getArea);
	
	var _getWindowScroll = __webpack_require__(1988);
	
	var _getWindowScroll2 = _interopRequireDefault(_getWindowScroll);
	
	var _getMaxScroll = __webpack_require__(1915);
	
	var _getMaxScroll2 = _interopRequireDefault(_getMaxScroll);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  var scroll = (0, _getWindowScroll2.default)();
	
	  var top = scroll.y;
	  var left = scroll.x;
	
	  var doc = document.documentElement;
	
	  var width = doc.clientWidth;
	  var height = doc.clientHeight;
	
	  var right = left + width;
	  var bottom = top + height;
	
	  var subject = (0, _getArea2.default)({
	    top: top, left: left, right: right, bottom: bottom
	  });
	
	  var maxScroll = (0, _getMaxScroll2.default)({
	    scrollHeight: doc.scrollHeight,
	    scrollWidth: doc.scrollWidth,
	    width: subject.width,
	    height: subject.height
	  });
	
	  var viewport = {
	    subject: subject,
	    maxScroll: maxScroll,
	    scroll: scroll
	  };
	
	  return viewport;
	};

/***/ }),
/* 2031 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _alt = __webpack_require__(975);
	
	var _alt2 = _interopRequireDefault(_alt);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var EventActions = function () {
	  function EventActions() {
	    _classCallCheck(this, EventActions);
	
	    this.generateActions("create", "duplicate", "updateEvents", "fetchOne", "fetchFailed", "fetchAvailability", "editFailed");
	  }
	
	  _createClass(EventActions, [{
	    key: "fetchAllForBucket",
	    value: function fetchAllForBucket(eventBucketId, includeScanCounts, excludeOlderEvents) {
	      return { eventBucketId: eventBucketId, includeScanCounts: includeScanCounts, excludeOlderEvents: excludeOlderEvents };
	    }
	  }, {
	    key: "fetchAllForVenueInBucket",
	    value: function fetchAllForVenueInBucket(venueId, eventBucketId, includeScanCounts) {
	      return { venueId: venueId, eventBucketId: eventBucketId, includeScanCounts: includeScanCounts };
	    }
	  }, {
	    key: "updateEvent",
	    value: function updateEvent(id, event) {
	      return { id: id, event: event };
	    }
	  }, {
	    key: "edit",
	    value: function edit(id, values, applyRecurring) {
	      return { id: id, values: values, applyRecurring: applyRecurring };
	    }
	  }, {
	    key: "editImage",
	    value: function editImage(id, field, file) {
	      return { id: id, field: field, file: file };
	    }
	  }, {
	    key: "delete",
	    value: function _delete(id, applyRecurring) {
	      return { id: id, applyRecurring: applyRecurring };
	    }
	  }]);
	
	  return EventActions;
	}();
	
	exports.default = _alt2.default.createActions(EventActions);
	module.exports = exports["default"];

/***/ }),
/* 2032 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _alt = __webpack_require__(975);
	
	var _alt2 = _interopRequireDefault(_alt);
	
	var _keyBy = __webpack_require__(990);
	
	var _keyBy2 = _interopRequireDefault(_keyBy);
	
	var _values = __webpack_require__(1214);
	
	var _values2 = _interopRequireDefault(_values);
	
	var _extend = __webpack_require__(1212);
	
	var _extend2 = _interopRequireDefault(_extend);
	
	var _lodash = __webpack_require__(2033);
	
	var _EventUtil = __webpack_require__(2034);
	
	var _EventUtil2 = _interopRequireDefault(_EventUtil);
	
	var _EventActions = __webpack_require__(2031);
	
	var _EventActions2 = _interopRequireDefault(_EventActions);
	
	var _EventBucketActions = __webpack_require__(1218);
	
	var _EventBucketActions2 = _interopRequireDefault(_EventBucketActions);
	
	var _GlobalNotificationActions = __webpack_require__(1182);
	
	var _GlobalNotificationActions2 = _interopRequireDefault(_GlobalNotificationActions);
	
	var _UserStore = __webpack_require__(974);
	
	var _UserStore2 = _interopRequireDefault(_UserStore);
	
	var _util = __webpack_require__(1183);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var EventStore = function () {
	  function EventStore() {
	    _classCallCheck(this, EventStore);
	
	    this.bindActions(_EventActions2.default);
	
	    this.state = {
	      events: {},
	      availability: {},
	      isFetching: false,
	      newEventId: null
	    };
	
	    this.exportPublicMethods({
	      getEventById: this.getEventById.bind(this),
	      getTicketBucketWithEventById: this.getTicketBucketWithEventById.bind(this),
	      getEventsForEventBucket: this.getEventsForEventBucket.bind(this),
	      getEventsForVenue: this.getEventsForVenue.bind(this)
	    });
	  }
	
	  _createClass(EventStore, [{
	    key: "getEventById",
	    value: function getEventById(id) {
	      return this.state.events[id];
	    }
	  }, {
	    key: "getTicketBucketWithEventById",
	    value: function getTicketBucketWithEventById(ticketBucketId) {
	      var event = (0, _values2.default)(this.state.events).find(function (e) {
	        return e.ticket_buckets.some(function (b) {
	          return b.id === ticketBucketId;
	        });
	      });
	      if (event) {
	        var bucket = Object.assign({}, event.ticket_buckets.find(function (b) {
	          return b.id === ticketBucketId;
	        }));
	        bucket.event = event;
	        return bucket;
	      }
	      return null;
	    }
	  }, {
	    key: "getEventsForEventBucket",
	    value: function getEventsForEventBucket(id) {
	      return (0, _values2.default)(this.state.events).filter(function (p) {
	        return p.event_bucket === id;
	      });
	    }
	  }, {
	    key: "getEventsForVenue",
	    value: function getEventsForVenue(id) {
	      return (0, _values2.default)(this.state.events).filter(function (p) {
	        return p.venue.id === id;
	      });
	    }
	  }, {
	    key: "onFetchOne",
	    value: function onFetchOne(id) {
	      var _this = this;
	
	      this.setState({ isFetching: true });
	      _EventUtil2.default.fetchOne(_UserStore2.default.getState().apiKey, id).then(function (data) {
	        _EventActions2.default.updateEvent(id, data);
	        _this.setState({ isFetching: false });
	      }).catch(_EventActions2.default.fetchFailed);
	    }
	  }, {
	    key: "onFetchAllForBucket",
	    value: function onFetchAllForBucket(options) {
	      var _this2 = this;
	
	      this.setState({ isFetching: true });
	      _EventUtil2.default.fetchAllForBucket(_UserStore2.default.getState().apiKey, options.eventBucketId, options.includeScanCounts, options.excludeOlderEvents).then(function (data) {
	        _EventActions2.default.updateEvents((0, _keyBy2.default)(data, "id"));
	        _this2.setState({ isFetching: false });
	      }).catch(_EventActions2.default.fetchFailed);
	    }
	  }, {
	    key: "onFetchAllForVenueInBucket",
	    value: function onFetchAllForVenueInBucket(options) {
	      var _this3 = this;
	
	      this.setState({ isFetching: true });
	      _EventUtil2.default.fetchAllForVenueInBucket(_UserStore2.default.getState().apiKey, options.venueId, options.eventBucketId, options.includeScanCounts).then(function (data) {
	        _EventActions2.default.updateEvents((0, _keyBy2.default)(data, "id"));
	        _this3.setState({ isFetching: false });
	      }).catch(_EventActions2.default.fetchFailed);
	    }
	  }, {
	    key: "onFetchAvailability",
	    value: function onFetchAvailability(options) {
	      var _this4 = this;
	
	      _EventUtil2.default.fetchAvailability(_UserStore2.default.getState().apiKey, options.eventBucketId, options.eventIds).then(function (data) {
	        _this4.setState(function (prevState) {
	          var newAvailability = (0, _lodash.assignIn)(_this4.state.availability, data.ticketBucketAvailability);
	
	          return _extends({}, prevState, {
	            availability: newAvailability
	          });
	        });
	      }).catch(function (err) {
	        console.error("Failed to fetch availability:", err);
	        _GlobalNotificationActions2.default.notify.defer("Failed to fetch availability: " + err.message);
	      });
	    }
	  }, {
	    key: "onEdit",
	    value: function onEdit(newData) {
	      _EventUtil2.default.edit(_UserStore2.default.getState().apiKey, newData.id, newData.values, newData.applyRecurring).then(function (data) {
	        _EventActions2.default.updateEvent(newData.id, data);
	        _EventBucketActions2.default.fetchOne(data.event_bucket);
	        _GlobalNotificationActions2.default.notify.defer("All changes saved successfully.");
	      }).catch(_EventActions2.default.editFailed);
	    }
	  }, {
	    key: "onEditImage",
	    value: function onEditImage(_ref) {
	      var _this5 = this;
	
	      var id = _ref.id;
	      var field = _ref.field;
	      var file = _ref.file;
	
	      this.setState({ uploadingImageField: field });
	      _EventUtil2.default.editImage(_UserStore2.default.getState().apiKey, id, field, file).then(function (data) {
	        _EventActions2.default.updateEvent(id, data);
	        _this5.setState({ uploadingImageField: null });
	      }).catch(_EventActions2.default.editFailed);
	    }
	  }, {
	    key: "onDelete",
	    value: function onDelete(_ref2) {
	      var _this6 = this;
	
	      var id = _ref2.id;
	      var applyRecurring = _ref2.applyRecurring;
	
	      _EventUtil2.default.delete(_UserStore2.default.getState().apiKey, id, applyRecurring).then(function (data) {
	        var bucket = _this6.state.events[id].event_bucket;
	        var isVirtual = _this6.state.events[id].is_virtual;
	
	        _EventBucketActions2.default.fetchOne(bucket);
	        _EventActions2.default.updateEvent(id, undefined);
	        _EventActions2.default.fetchAllForBucket(bucket);
	        _util.history.push("/event_buckets/" + bucket + (isVirtual ? "/virtual_festival" : "/events"));
	      }).catch(_EventActions2.default.editFailed);
	    }
	  }, {
	    key: "onCreate",
	    value: function onCreate(newData) {
	      var _this7 = this;
	
	      this.setState({
	        newEventId: null
	      });
	
	      _EventUtil2.default.create(_UserStore2.default.getState().apiKey, newData).then(function (data) {
	        _EventActions2.default.updateEvent(data.id, data);
	        _EventBucketActions2.default.fetchOne(data.event_bucket);
	        _this7.setState({
	          newEventId: data.id
	        });
	      }).catch(_EventActions2.default.editFailed);
	    }
	  }, {
	    key: "onDuplicate",
	    value: function onDuplicate(id) {
	      var _this8 = this;
	
	      this.setState({
	        newEventId: null
	      });
	
	      _EventUtil2.default.duplicate(_UserStore2.default.getState().apiKey, id).then(function (data) {
	        _EventActions2.default.updateEvent(data.id, data);
	        _EventBucketActions2.default.fetchOne(data.event_bucket);
	        _this8.setState({
	          newEventId: data.id
	        });
	      }).catch(_EventActions2.default.editFailed);
	    }
	  }, {
	    key: "onUpdateEvent",
	    value: function onUpdateEvent(data) {
	      if (!data.event) {
	        delete this.state.events[data.id];
	      } else {
	        this.state.events[data.id] = data.event;
	      }
	      this.state.newEventId = null;
	      this.setState(this.state);
	    }
	  }, {
	    key: "onUpdateEvents",
	    value: function onUpdateEvents(events) {
	      var _this9 = this;
	
	      this.setState(function (prevState) {
	        var newEvents = (0, _lodash.assignIn)(_this9.state.events, events);
	        return _extends({}, prevState, {
	          events: newEvents
	        });
	      });
	    }
	  }, {
	    key: "onFetchFailed",
	    value: function onFetchFailed(e) {
	      console.error("Fetching event failed:", e);
	      _GlobalNotificationActions2.default.notify.defer("Fetching event failed: " + e.message);
	      throw e;
	    }
	  }, {
	    key: "onEditFailed",
	    value: function onEditFailed(e) {
	      alert("Edit failed: " + e.message);
	
	      // trigger event update to allow resubmit
	      this.state.events[e._event].updated_at = Date.now();
	      this.setState({ events: this.state.events });
	    }
	  }]);
	
	  return EventStore;
	}();
	
	exports.default = _alt2.default.createStore(EventStore, "EventStore");
	module.exports = exports["default"];

/***/ }),
/* 2033 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(global, module) {/**
	 * @license
	 * Lodash <https://lodash.com/>
	 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	;(function() {
	
	  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
	  var undefined;
	
	  /** Used as the semantic version number. */
	  var VERSION = '4.17.21';
	
	  /** Used as the size to enable large array optimizations. */
	  var LARGE_ARRAY_SIZE = 200;
	
	  /** Error message constants. */
	  var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
	      FUNC_ERROR_TEXT = 'Expected a function',
	      INVALID_TEMPL_VAR_ERROR_TEXT = 'Invalid `variable` option passed into `_.template`';
	
	  /** Used to stand-in for `undefined` hash values. */
	  var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	  /** Used as the maximum memoize cache size. */
	  var MAX_MEMOIZE_SIZE = 500;
	
	  /** Used as the internal argument placeholder. */
	  var PLACEHOLDER = '__lodash_placeholder__';
	
	  /** Used to compose bitmasks for cloning. */
	  var CLONE_DEEP_FLAG = 1,
	      CLONE_FLAT_FLAG = 2,
	      CLONE_SYMBOLS_FLAG = 4;
	
	  /** Used to compose bitmasks for value comparisons. */
	  var COMPARE_PARTIAL_FLAG = 1,
	      COMPARE_UNORDERED_FLAG = 2;
	
	  /** Used to compose bitmasks for function metadata. */
	  var WRAP_BIND_FLAG = 1,
	      WRAP_BIND_KEY_FLAG = 2,
	      WRAP_CURRY_BOUND_FLAG = 4,
	      WRAP_CURRY_FLAG = 8,
	      WRAP_CURRY_RIGHT_FLAG = 16,
	      WRAP_PARTIAL_FLAG = 32,
	      WRAP_PARTIAL_RIGHT_FLAG = 64,
	      WRAP_ARY_FLAG = 128,
	      WRAP_REARG_FLAG = 256,
	      WRAP_FLIP_FLAG = 512;
	
	  /** Used as default options for `_.truncate`. */
	  var DEFAULT_TRUNC_LENGTH = 30,
	      DEFAULT_TRUNC_OMISSION = '...';
	
	  /** Used to detect hot functions by number of calls within a span of milliseconds. */
	  var HOT_COUNT = 800,
	      HOT_SPAN = 16;
	
	  /** Used to indicate the type of lazy iteratees. */
	  var LAZY_FILTER_FLAG = 1,
	      LAZY_MAP_FLAG = 2,
	      LAZY_WHILE_FLAG = 3;
	
	  /** Used as references for various `Number` constants. */
	  var INFINITY = 1 / 0,
	      MAX_SAFE_INTEGER = 9007199254740991,
	      MAX_INTEGER = 1.7976931348623157e+308,
	      NAN = 0 / 0;
	
	  /** Used as references for the maximum length and index of an array. */
	  var MAX_ARRAY_LENGTH = 4294967295,
	      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
	      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
	
	  /** Used to associate wrap methods with their bit flags. */
	  var wrapFlags = [
	    ['ary', WRAP_ARY_FLAG],
	    ['bind', WRAP_BIND_FLAG],
	    ['bindKey', WRAP_BIND_KEY_FLAG],
	    ['curry', WRAP_CURRY_FLAG],
	    ['curryRight', WRAP_CURRY_RIGHT_FLAG],
	    ['flip', WRAP_FLIP_FLAG],
	    ['partial', WRAP_PARTIAL_FLAG],
	    ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
	    ['rearg', WRAP_REARG_FLAG]
	  ];
	
	  /** `Object#toString` result references. */
	  var argsTag = '[object Arguments]',
	      arrayTag = '[object Array]',
	      asyncTag = '[object AsyncFunction]',
	      boolTag = '[object Boolean]',
	      dateTag = '[object Date]',
	      domExcTag = '[object DOMException]',
	      errorTag = '[object Error]',
	      funcTag = '[object Function]',
	      genTag = '[object GeneratorFunction]',
	      mapTag = '[object Map]',
	      numberTag = '[object Number]',
	      nullTag = '[object Null]',
	      objectTag = '[object Object]',
	      promiseTag = '[object Promise]',
	      proxyTag = '[object Proxy]',
	      regexpTag = '[object RegExp]',
	      setTag = '[object Set]',
	      stringTag = '[object String]',
	      symbolTag = '[object Symbol]',
	      undefinedTag = '[object Undefined]',
	      weakMapTag = '[object WeakMap]',
	      weakSetTag = '[object WeakSet]';
	
	  var arrayBufferTag = '[object ArrayBuffer]',
	      dataViewTag = '[object DataView]',
	      float32Tag = '[object Float32Array]',
	      float64Tag = '[object Float64Array]',
	      int8Tag = '[object Int8Array]',
	      int16Tag = '[object Int16Array]',
	      int32Tag = '[object Int32Array]',
	      uint8Tag = '[object Uint8Array]',
	      uint8ClampedTag = '[object Uint8ClampedArray]',
	      uint16Tag = '[object Uint16Array]',
	      uint32Tag = '[object Uint32Array]';
	
	  /** Used to match empty string literals in compiled template source. */
	  var reEmptyStringLeading = /\b__p \+= '';/g,
	      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
	      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
	
	  /** Used to match HTML entities and HTML characters. */
	  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
	      reUnescapedHtml = /[&<>"']/g,
	      reHasEscapedHtml = RegExp(reEscapedHtml.source),
	      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
	
	  /** Used to match template delimiters. */
	  var reEscape = /<%-([\s\S]+?)%>/g,
	      reEvaluate = /<%([\s\S]+?)%>/g,
	      reInterpolate = /<%=([\s\S]+?)%>/g;
	
	  /** Used to match property names within property paths. */
	  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
	      reIsPlainProp = /^\w*$/,
	      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
	
	  /**
	   * Used to match `RegExp`
	   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	   */
	  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
	      reHasRegExpChar = RegExp(reRegExpChar.source);
	
	  /** Used to match leading whitespace. */
	  var reTrimStart = /^\s+/;
	
	  /** Used to match a single whitespace character. */
	  var reWhitespace = /\s/;
	
	  /** Used to match wrap detail comments. */
	  var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
	      reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
	      reSplitDetails = /,? & /;
	
	  /** Used to match words composed of alphanumeric characters. */
	  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
	
	  /**
	   * Used to validate the `validate` option in `_.template` variable.
	   *
	   * Forbids characters which could potentially change the meaning of the function argument definition:
	   * - "()," (modification of function parameters)
	   * - "=" (default value)
	   * - "[]{}" (destructuring of function parameters)
	   * - "/" (beginning of a comment)
	   * - whitespace
	   */
	  var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;
	
	  /** Used to match backslashes in property paths. */
	  var reEscapeChar = /\\(\\)?/g;
	
	  /**
	   * Used to match
	   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
	   */
	  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
	
	  /** Used to match `RegExp` flags from their coerced string values. */
	  var reFlags = /\w*$/;
	
	  /** Used to detect bad signed hexadecimal string values. */
	  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	  /** Used to detect binary string values. */
	  var reIsBinary = /^0b[01]+$/i;
	
	  /** Used to detect host constructors (Safari). */
	  var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	  /** Used to detect octal string values. */
	  var reIsOctal = /^0o[0-7]+$/i;
	
	  /** Used to detect unsigned integer values. */
	  var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	  /** Used to match Latin Unicode letters (excluding mathematical operators). */
	  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
	
	  /** Used to ensure capturing order of template delimiters. */
	  var reNoMatch = /($^)/;
	
	  /** Used to match unescaped characters in compiled string literals. */
	  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
	
	  /** Used to compose unicode character classes. */
	  var rsAstralRange = '\\ud800-\\udfff',
	      rsComboMarksRange = '\\u0300-\\u036f',
	      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
	      rsComboSymbolsRange = '\\u20d0-\\u20ff',
	      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
	      rsDingbatRange = '\\u2700-\\u27bf',
	      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
	      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
	      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
	      rsPunctuationRange = '\\u2000-\\u206f',
	      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
	      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
	      rsVarRange = '\\ufe0e\\ufe0f',
	      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
	
	  /** Used to compose unicode capture groups. */
	  var rsApos = "['\u2019]",
	      rsAstral = '[' + rsAstralRange + ']',
	      rsBreak = '[' + rsBreakRange + ']',
	      rsCombo = '[' + rsComboRange + ']',
	      rsDigits = '\\d+',
	      rsDingbat = '[' + rsDingbatRange + ']',
	      rsLower = '[' + rsLowerRange + ']',
	      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
	      rsFitz = '\\ud83c[\\udffb-\\udfff]',
	      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
	      rsNonAstral = '[^' + rsAstralRange + ']',
	      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
	      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
	      rsUpper = '[' + rsUpperRange + ']',
	      rsZWJ = '\\u200d';
	
	  /** Used to compose unicode regexes. */
	  var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
	      rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
	      rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
	      rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
	      reOptMod = rsModifier + '?',
	      rsOptVar = '[' + rsVarRange + ']?',
	      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
	      rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
	      rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
	      rsSeq = rsOptVar + reOptMod + rsOptJoin,
	      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
	      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';
	
	  /** Used to match apostrophes. */
	  var reApos = RegExp(rsApos, 'g');
	
	  /**
	   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
	   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
	   */
	  var reComboMark = RegExp(rsCombo, 'g');
	
	  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
	  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');
	
	  /** Used to match complex or compound words. */
	  var reUnicodeWord = RegExp([
	    rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
	    rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
	    rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
	    rsUpper + '+' + rsOptContrUpper,
	    rsOrdUpper,
	    rsOrdLower,
	    rsDigits,
	    rsEmoji
	  ].join('|'), 'g');
	
	  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
	  var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');
	
	  /** Used to detect strings that need a more robust regexp to match words. */
	  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
	
	  /** Used to assign default `context` object properties. */
	  var contextProps = [
	    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
	    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
	    'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array',
	    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
	    '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
	  ];
	
	  /** Used to make template sourceURLs easier to identify. */
	  var templateCounter = -1;
	
	  /** Used to identify `toStringTag` values of typed arrays. */
	  var typedArrayTags = {};
	  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	  typedArrayTags[uint32Tag] = true;
	  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	  typedArrayTags[setTag] = typedArrayTags[stringTag] =
	  typedArrayTags[weakMapTag] = false;
	
	  /** Used to identify `toStringTag` values supported by `_.clone`. */
	  var cloneableTags = {};
	  cloneableTags[argsTag] = cloneableTags[arrayTag] =
	  cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
	  cloneableTags[boolTag] = cloneableTags[dateTag] =
	  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
	  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
	  cloneableTags[int32Tag] = cloneableTags[mapTag] =
	  cloneableTags[numberTag] = cloneableTags[objectTag] =
	  cloneableTags[regexpTag] = cloneableTags[setTag] =
	  cloneableTags[stringTag] = cloneableTags[symbolTag] =
	  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
	  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
	  cloneableTags[errorTag] = cloneableTags[funcTag] =
	  cloneableTags[weakMapTag] = false;
	
	  /** Used to map Latin Unicode letters to basic Latin letters. */
	  var deburredLetters = {
	    // Latin-1 Supplement block.
	    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
	    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
	    '\xc7': 'C',  '\xe7': 'c',
	    '\xd0': 'D',  '\xf0': 'd',
	    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
	    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
	    '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
	    '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
	    '\xd1': 'N',  '\xf1': 'n',
	    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
	    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
	    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
	    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
	    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
	    '\xc6': 'Ae', '\xe6': 'ae',
	    '\xde': 'Th', '\xfe': 'th',
	    '\xdf': 'ss',
	    // Latin Extended-A block.
	    '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
	    '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
	    '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
	    '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
	    '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
	    '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
	    '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
	    '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
	    '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
	    '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
	    '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
	    '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
	    '\u0134': 'J',  '\u0135': 'j',
	    '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
	    '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
	    '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
	    '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
	    '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
	    '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
	    '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
	    '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
	    '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
	    '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
	    '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
	    '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
	    '\u0163': 't',  '\u0165': 't', '\u0167': 't',
	    '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
	    '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
	    '\u0174': 'W',  '\u0175': 'w',
	    '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
	    '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
	    '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
	    '\u0132': 'IJ', '\u0133': 'ij',
	    '\u0152': 'Oe', '\u0153': 'oe',
	    '\u0149': "'n", '\u017f': 's'
	  };
	
	  /** Used to map characters to HTML entities. */
	  var htmlEscapes = {
	    '&': '&amp;',
	    '<': '&lt;',
	    '>': '&gt;',
	    '"': '&quot;',
	    "'": '&#39;'
	  };
	
	  /** Used to map HTML entities to characters. */
	  var htmlUnescapes = {
	    '&amp;': '&',
	    '&lt;': '<',
	    '&gt;': '>',
	    '&quot;': '"',
	    '&#39;': "'"
	  };
	
	  /** Used to escape characters for inclusion in compiled string literals. */
	  var stringEscapes = {
	    '\\': '\\',
	    "'": "'",
	    '\n': 'n',
	    '\r': 'r',
	    '\u2028': 'u2028',
	    '\u2029': 'u2029'
	  };
	
	  /** Built-in method references without a dependency on `root`. */
	  var freeParseFloat = parseFloat,
	      freeParseInt = parseInt;
	
	  /** Detect free variable `global` from Node.js. */
	  var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	  /** Detect free variable `self`. */
	  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	  /** Used as a reference to the global object. */
	  var root = freeGlobal || freeSelf || Function('return this')();
	
	  /** Detect free variable `exports`. */
	  var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	  /** Detect free variable `module`. */
	  var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	  /** Detect the popular CommonJS extension `module.exports`. */
	  var moduleExports = freeModule && freeModule.exports === freeExports;
	
	  /** Detect free variable `process` from Node.js. */
	  var freeProcess = moduleExports && freeGlobal.process;
	
	  /** Used to access faster Node.js helpers. */
	  var nodeUtil = (function() {
	    try {
	      // Use `util.types` for Node.js 10+.
	      var types = freeModule && freeModule.require && freeModule.require('util').types;
	
	      if (types) {
	        return types;
	      }
	
	      // Legacy `process.binding('util')` for Node.js < 10.
	      return freeProcess && freeProcess.binding && freeProcess.binding('util');
	    } catch (e) {}
	  }());
	
	  /* Node.js helper references. */
	  var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
	      nodeIsDate = nodeUtil && nodeUtil.isDate,
	      nodeIsMap = nodeUtil && nodeUtil.isMap,
	      nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
	      nodeIsSet = nodeUtil && nodeUtil.isSet,
	      nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
	
	  /*--------------------------------------------------------------------------*/
	
	  /**
	   * A faster alternative to `Function#apply`, this function invokes `func`
	   * with the `this` binding of `thisArg` and the arguments of `args`.
	   *
	   * @private
	   * @param {Function} func The function to invoke.
	   * @param {*} thisArg The `this` binding of `func`.
	   * @param {Array} args The arguments to invoke `func` with.
	   * @returns {*} Returns the result of `func`.
	   */
	  function apply(func, thisArg, args) {
	    switch (args.length) {
	      case 0: return func.call(thisArg);
	      case 1: return func.call(thisArg, args[0]);
	      case 2: return func.call(thisArg, args[0], args[1]);
	      case 3: return func.call(thisArg, args[0], args[1], args[2]);
	    }
	    return func.apply(thisArg, args);
	  }
	
	  /**
	   * A specialized version of `baseAggregator` for arrays.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} setter The function to set `accumulator` values.
	   * @param {Function} iteratee The iteratee to transform keys.
	   * @param {Object} accumulator The initial aggregated object.
	   * @returns {Function} Returns `accumulator`.
	   */
	  function arrayAggregator(array, setter, iteratee, accumulator) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      var value = array[index];
	      setter(accumulator, value, iteratee(value), array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.forEach` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayEach(array, iteratee) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (iteratee(array[index], index, array) === false) {
	        break;
	      }
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.forEachRight` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayEachRight(array, iteratee) {
	    var length = array == null ? 0 : array.length;
	
	    while (length--) {
	      if (iteratee(array[length], length, array) === false) {
	        break;
	      }
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.every` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {boolean} Returns `true` if all elements pass the predicate check,
	   *  else `false`.
	   */
	  function arrayEvery(array, predicate) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (!predicate(array[index], index, array)) {
	        return false;
	      }
	    }
	    return true;
	  }
	
	  /**
	   * A specialized version of `_.filter` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {Array} Returns the new filtered array.
	   */
	  function arrayFilter(array, predicate) {
	    var index = -1,
	        length = array == null ? 0 : array.length,
	        resIndex = 0,
	        result = [];
	
	    while (++index < length) {
	      var value = array[index];
	      if (predicate(value, index, array)) {
	        result[resIndex++] = value;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * A specialized version of `_.includes` for arrays without support for
	   * specifying an index to search from.
	   *
	   * @private
	   * @param {Array} [array] The array to inspect.
	   * @param {*} target The value to search for.
	   * @returns {boolean} Returns `true` if `target` is found, else `false`.
	   */
	  function arrayIncludes(array, value) {
	    var length = array == null ? 0 : array.length;
	    return !!length && baseIndexOf(array, value, 0) > -1;
	  }
	
	  /**
	   * This function is like `arrayIncludes` except that it accepts a comparator.
	   *
	   * @private
	   * @param {Array} [array] The array to inspect.
	   * @param {*} target The value to search for.
	   * @param {Function} comparator The comparator invoked per element.
	   * @returns {boolean} Returns `true` if `target` is found, else `false`.
	   */
	  function arrayIncludesWith(array, value, comparator) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (comparator(value, array[index])) {
	        return true;
	      }
	    }
	    return false;
	  }
	
	  /**
	   * A specialized version of `_.map` for arrays without support for iteratee
	   * shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns the new mapped array.
	   */
	  function arrayMap(array, iteratee) {
	    var index = -1,
	        length = array == null ? 0 : array.length,
	        result = Array(length);
	
	    while (++index < length) {
	      result[index] = iteratee(array[index], index, array);
	    }
	    return result;
	  }
	
	  /**
	   * Appends the elements of `values` to `array`.
	   *
	   * @private
	   * @param {Array} array The array to modify.
	   * @param {Array} values The values to append.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayPush(array, values) {
	    var index = -1,
	        length = values.length,
	        offset = array.length;
	
	    while (++index < length) {
	      array[offset + index] = values[index];
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.reduce` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} [accumulator] The initial value.
	   * @param {boolean} [initAccum] Specify using the first element of `array` as
	   *  the initial value.
	   * @returns {*} Returns the accumulated value.
	   */
	  function arrayReduce(array, iteratee, accumulator, initAccum) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    if (initAccum && length) {
	      accumulator = array[++index];
	    }
	    while (++index < length) {
	      accumulator = iteratee(accumulator, array[index], index, array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.reduceRight` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} [accumulator] The initial value.
	   * @param {boolean} [initAccum] Specify using the last element of `array` as
	   *  the initial value.
	   * @returns {*} Returns the accumulated value.
	   */
	  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
	    var length = array == null ? 0 : array.length;
	    if (initAccum && length) {
	      accumulator = array[--length];
	    }
	    while (length--) {
	      accumulator = iteratee(accumulator, array[length], length, array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.some` for arrays without support for iteratee
	   * shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {boolean} Returns `true` if any element passes the predicate check,
	   *  else `false`.
	   */
	  function arraySome(array, predicate) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (predicate(array[index], index, array)) {
	        return true;
	      }
	    }
	    return false;
	  }
	
	  /**
	   * Gets the size of an ASCII `string`.
	   *
	   * @private
	   * @param {string} string The string inspect.
	   * @returns {number} Returns the string size.
	   */
	  var asciiSize = baseProperty('length');
	
	  /**
	   * Converts an ASCII `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function asciiToArray(string) {
	    return string.split('');
	  }
	
	  /**
	   * Splits an ASCII `string` into an array of its words.
	   *
	   * @private
	   * @param {string} The string to inspect.
	   * @returns {Array} Returns the words of `string`.
	   */
	  function asciiWords(string) {
	    return string.match(reAsciiWord) || [];
	  }
	
	  /**
	   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
	   * without support for iteratee shorthands, which iterates over `collection`
	   * using `eachFunc`.
	   *
	   * @private
	   * @param {Array|Object} collection The collection to inspect.
	   * @param {Function} predicate The function invoked per iteration.
	   * @param {Function} eachFunc The function to iterate over `collection`.
	   * @returns {*} Returns the found element or its key, else `undefined`.
	   */
	  function baseFindKey(collection, predicate, eachFunc) {
	    var result;
	    eachFunc(collection, function(value, key, collection) {
	      if (predicate(value, key, collection)) {
	        result = key;
	        return false;
	      }
	    });
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.findIndex` and `_.findLastIndex` without
	   * support for iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {Function} predicate The function invoked per iteration.
	   * @param {number} fromIndex The index to search from.
	   * @param {boolean} [fromRight] Specify iterating from right to left.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseFindIndex(array, predicate, fromIndex, fromRight) {
	    var length = array.length,
	        index = fromIndex + (fromRight ? 1 : -1);
	
	    while ((fromRight ? index-- : ++index < length)) {
	      if (predicate(array[index], index, array)) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseIndexOf(array, value, fromIndex) {
	    return value === value
	      ? strictIndexOf(array, value, fromIndex)
	      : baseFindIndex(array, baseIsNaN, fromIndex);
	  }
	
	  /**
	   * This function is like `baseIndexOf` except that it accepts a comparator.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @param {Function} comparator The comparator invoked per element.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseIndexOfWith(array, value, fromIndex, comparator) {
	    var index = fromIndex - 1,
	        length = array.length;
	
	    while (++index < length) {
	      if (comparator(array[index], value)) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * The base implementation of `_.isNaN` without support for number objects.
	   *
	   * @private
	   * @param {*} value The value to check.
	   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	   */
	  function baseIsNaN(value) {
	    return value !== value;
	  }
	
	  /**
	   * The base implementation of `_.mean` and `_.meanBy` without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {number} Returns the mean.
	   */
	  function baseMean(array, iteratee) {
	    var length = array == null ? 0 : array.length;
	    return length ? (baseSum(array, iteratee) / length) : NAN;
	  }
	
	  /**
	   * The base implementation of `_.property` without support for deep paths.
	   *
	   * @private
	   * @param {string} key The key of the property to get.
	   * @returns {Function} Returns the new accessor function.
	   */
	  function baseProperty(key) {
	    return function(object) {
	      return object == null ? undefined : object[key];
	    };
	  }
	
	  /**
	   * The base implementation of `_.propertyOf` without support for deep paths.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @returns {Function} Returns the new accessor function.
	   */
	  function basePropertyOf(object) {
	    return function(key) {
	      return object == null ? undefined : object[key];
	    };
	  }
	
	  /**
	   * The base implementation of `_.reduce` and `_.reduceRight`, without support
	   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
	   *
	   * @private
	   * @param {Array|Object} collection The collection to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} accumulator The initial value.
	   * @param {boolean} initAccum Specify using the first or last element of
	   *  `collection` as the initial value.
	   * @param {Function} eachFunc The function to iterate over `collection`.
	   * @returns {*} Returns the accumulated value.
	   */
	  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
	    eachFunc(collection, function(value, index, collection) {
	      accumulator = initAccum
	        ? (initAccum = false, value)
	        : iteratee(accumulator, value, index, collection);
	    });
	    return accumulator;
	  }
	
	  /**
	   * The base implementation of `_.sortBy` which uses `comparer` to define the
	   * sort order of `array` and replaces criteria objects with their corresponding
	   * values.
	   *
	   * @private
	   * @param {Array} array The array to sort.
	   * @param {Function} comparer The function to define sort order.
	   * @returns {Array} Returns `array`.
	   */
	  function baseSortBy(array, comparer) {
	    var length = array.length;
	
	    array.sort(comparer);
	    while (length--) {
	      array[length] = array[length].value;
	    }
	    return array;
	  }
	
	  /**
	   * The base implementation of `_.sum` and `_.sumBy` without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {number} Returns the sum.
	   */
	  function baseSum(array, iteratee) {
	    var result,
	        index = -1,
	        length = array.length;
	
	    while (++index < length) {
	      var current = iteratee(array[index]);
	      if (current !== undefined) {
	        result = result === undefined ? current : (result + current);
	      }
	    }
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.times` without support for iteratee shorthands
	   * or max array length checks.
	   *
	   * @private
	   * @param {number} n The number of times to invoke `iteratee`.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns the array of results.
	   */
	  function baseTimes(n, iteratee) {
	    var index = -1,
	        result = Array(n);
	
	    while (++index < n) {
	      result[index] = iteratee(index);
	    }
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
	   * of key-value pairs for `object` corresponding to the property names of `props`.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @param {Array} props The property names to get values for.
	   * @returns {Object} Returns the key-value pairs.
	   */
	  function baseToPairs(object, props) {
	    return arrayMap(props, function(key) {
	      return [key, object[key]];
	    });
	  }
	
	  /**
	   * The base implementation of `_.trim`.
	   *
	   * @private
	   * @param {string} string The string to trim.
	   * @returns {string} Returns the trimmed string.
	   */
	  function baseTrim(string) {
	    return string
	      ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
	      : string;
	  }
	
	  /**
	   * The base implementation of `_.unary` without support for storing metadata.
	   *
	   * @private
	   * @param {Function} func The function to cap arguments for.
	   * @returns {Function} Returns the new capped function.
	   */
	  function baseUnary(func) {
	    return function(value) {
	      return func(value);
	    };
	  }
	
	  /**
	   * The base implementation of `_.values` and `_.valuesIn` which creates an
	   * array of `object` property values corresponding to the property names
	   * of `props`.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @param {Array} props The property names to get values for.
	   * @returns {Object} Returns the array of property values.
	   */
	  function baseValues(object, props) {
	    return arrayMap(props, function(key) {
	      return object[key];
	    });
	  }
	
	  /**
	   * Checks if a `cache` value for `key` exists.
	   *
	   * @private
	   * @param {Object} cache The cache to query.
	   * @param {string} key The key of the entry to check.
	   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	   */
	  function cacheHas(cache, key) {
	    return cache.has(key);
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
	   * that is not found in the character symbols.
	   *
	   * @private
	   * @param {Array} strSymbols The string symbols to inspect.
	   * @param {Array} chrSymbols The character symbols to find.
	   * @returns {number} Returns the index of the first unmatched string symbol.
	   */
	  function charsStartIndex(strSymbols, chrSymbols) {
	    var index = -1,
	        length = strSymbols.length;
	
	    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
	    return index;
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
	   * that is not found in the character symbols.
	   *
	   * @private
	   * @param {Array} strSymbols The string symbols to inspect.
	   * @param {Array} chrSymbols The character symbols to find.
	   * @returns {number} Returns the index of the last unmatched string symbol.
	   */
	  function charsEndIndex(strSymbols, chrSymbols) {
	    var index = strSymbols.length;
	
	    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
	    return index;
	  }
	
	  /**
	   * Gets the number of `placeholder` occurrences in `array`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} placeholder The placeholder to search for.
	   * @returns {number} Returns the placeholder count.
	   */
	  function countHolders(array, placeholder) {
	    var length = array.length,
	        result = 0;
	
	    while (length--) {
	      if (array[length] === placeholder) {
	        ++result;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
	   * letters to basic Latin letters.
	   *
	   * @private
	   * @param {string} letter The matched letter to deburr.
	   * @returns {string} Returns the deburred letter.
	   */
	  var deburrLetter = basePropertyOf(deburredLetters);
	
	  /**
	   * Used by `_.escape` to convert characters to HTML entities.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @returns {string} Returns the escaped character.
	   */
	  var escapeHtmlChar = basePropertyOf(htmlEscapes);
	
	  /**
	   * Used by `_.template` to escape characters for inclusion in compiled string literals.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @returns {string} Returns the escaped character.
	   */
	  function escapeStringChar(chr) {
	    return '\\' + stringEscapes[chr];
	  }
	
	  /**
	   * Gets the value at `key` of `object`.
	   *
	   * @private
	   * @param {Object} [object] The object to query.
	   * @param {string} key The key of the property to get.
	   * @returns {*} Returns the property value.
	   */
	  function getValue(object, key) {
	    return object == null ? undefined : object[key];
	  }
	
	  /**
	   * Checks if `string` contains Unicode symbols.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
	   */
	  function hasUnicode(string) {
	    return reHasUnicode.test(string);
	  }
	
	  /**
	   * Checks if `string` contains a word composed of Unicode symbols.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {boolean} Returns `true` if a word is found, else `false`.
	   */
	  function hasUnicodeWord(string) {
	    return reHasUnicodeWord.test(string);
	  }
	
	  /**
	   * Converts `iterator` to an array.
	   *
	   * @private
	   * @param {Object} iterator The iterator to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function iteratorToArray(iterator) {
	    var data,
	        result = [];
	
	    while (!(data = iterator.next()).done) {
	      result.push(data.value);
	    }
	    return result;
	  }
	
	  /**
	   * Converts `map` to its key-value pairs.
	   *
	   * @private
	   * @param {Object} map The map to convert.
	   * @returns {Array} Returns the key-value pairs.
	   */
	  function mapToArray(map) {
	    var index = -1,
	        result = Array(map.size);
	
	    map.forEach(function(value, key) {
	      result[++index] = [key, value];
	    });
	    return result;
	  }
	
	  /**
	   * Creates a unary function that invokes `func` with its argument transformed.
	   *
	   * @private
	   * @param {Function} func The function to wrap.
	   * @param {Function} transform The argument transform.
	   * @returns {Function} Returns the new function.
	   */
	  function overArg(func, transform) {
	    return function(arg) {
	      return func(transform(arg));
	    };
	  }
	
	  /**
	   * Replaces all `placeholder` elements in `array` with an internal placeholder
	   * and returns an array of their indexes.
	   *
	   * @private
	   * @param {Array} array The array to modify.
	   * @param {*} placeholder The placeholder to replace.
	   * @returns {Array} Returns the new array of placeholder indexes.
	   */
	  function replaceHolders(array, placeholder) {
	    var index = -1,
	        length = array.length,
	        resIndex = 0,
	        result = [];
	
	    while (++index < length) {
	      var value = array[index];
	      if (value === placeholder || value === PLACEHOLDER) {
	        array[index] = PLACEHOLDER;
	        result[resIndex++] = index;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * Converts `set` to an array of its values.
	   *
	   * @private
	   * @param {Object} set The set to convert.
	   * @returns {Array} Returns the values.
	   */
	  function setToArray(set) {
	    var index = -1,
	        result = Array(set.size);
	
	    set.forEach(function(value) {
	      result[++index] = value;
	    });
	    return result;
	  }
	
	  /**
	   * Converts `set` to its value-value pairs.
	   *
	   * @private
	   * @param {Object} set The set to convert.
	   * @returns {Array} Returns the value-value pairs.
	   */
	  function setToPairs(set) {
	    var index = -1,
	        result = Array(set.size);
	
	    set.forEach(function(value) {
	      result[++index] = [value, value];
	    });
	    return result;
	  }
	
	  /**
	   * A specialized version of `_.indexOf` which performs strict equality
	   * comparisons of values, i.e. `===`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function strictIndexOf(array, value, fromIndex) {
	    var index = fromIndex - 1,
	        length = array.length;
	
	    while (++index < length) {
	      if (array[index] === value) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * A specialized version of `_.lastIndexOf` which performs strict equality
	   * comparisons of values, i.e. `===`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function strictLastIndexOf(array, value, fromIndex) {
	    var index = fromIndex + 1;
	    while (index--) {
	      if (array[index] === value) {
	        return index;
	      }
	    }
	    return index;
	  }
	
	  /**
	   * Gets the number of symbols in `string`.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {number} Returns the string size.
	   */
	  function stringSize(string) {
	    return hasUnicode(string)
	      ? unicodeSize(string)
	      : asciiSize(string);
	  }
	
	  /**
	   * Converts `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function stringToArray(string) {
	    return hasUnicode(string)
	      ? unicodeToArray(string)
	      : asciiToArray(string);
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
	   * character of `string`.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {number} Returns the index of the last non-whitespace character.
	   */
	  function trimmedEndIndex(string) {
	    var index = string.length;
	
	    while (index-- && reWhitespace.test(string.charAt(index))) {}
	    return index;
	  }
	
	  /**
	   * Used by `_.unescape` to convert HTML entities to characters.
	   *
	   * @private
	   * @param {string} chr The matched character to unescape.
	   * @returns {string} Returns the unescaped character.
	   */
	  var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
	
	  /**
	   * Gets the size of a Unicode `string`.
	   *
	   * @private
	   * @param {string} string The string inspect.
	   * @returns {number} Returns the string size.
	   */
	  function unicodeSize(string) {
	    var result = reUnicode.lastIndex = 0;
	    while (reUnicode.test(string)) {
	      ++result;
	    }
	    return result;
	  }
	
	  /**
	   * Converts a Unicode `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function unicodeToArray(string) {
	    return string.match(reUnicode) || [];
	  }
	
	  /**
	   * Splits a Unicode `string` into an array of its words.
	   *
	   * @private
	   * @param {string} The string to inspect.
	   * @returns {Array} Returns the words of `string`.
	   */
	  function unicodeWords(string) {
	    return string.match(reUnicodeWord) || [];
	  }
	
	  /*--------------------------------------------------------------------------*/
	
	  /**
	   * Create a new pristine `lodash` function using the `context` object.
	   *
	   * @static
	   * @memberOf _
	   * @since 1.1.0
	   * @category Util
	   * @param {Object} [context=root] The context object.
	   * @returns {Function} Returns a new `lodash` function.
	   * @example
	   *
	   * _.mixin({ 'foo': _.constant('foo') });
	   *
	   * var lodash = _.runInContext();
	   * lodash.mixin({ 'bar': lodash.constant('bar') });
	   *
	   * _.isFunction(_.foo);
	   * // => true
	   * _.isFunction(_.bar);
	   * // => false
	   *
	   * lodash.isFunction(lodash.foo);
	   * // => false
	   * lodash.isFunction(lodash.bar);
	   * // => true
	   *
	   * // Create a suped-up `defer` in Node.js.
	   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
	   */
	  var runInContext = (function runInContext(context) {
	    context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));
	
	    /** Built-in constructor references. */
	    var Array = context.Array,
	        Date = context.Date,
	        Error = context.Error,
	        Function = context.Function,
	        Math = context.Math,
	        Object = context.Object,
	        RegExp = context.RegExp,
	        String = context.String,
	        TypeError = context.TypeError;
	
	    /** Used for built-in method references. */
	    var arrayProto = Array.prototype,
	        funcProto = Function.prototype,
	        objectProto = Object.prototype;
	
	    /** Used to detect overreaching core-js shims. */
	    var coreJsData = context['__core-js_shared__'];
	
	    /** Used to resolve the decompiled source of functions. */
	    var funcToString = funcProto.toString;
	
	    /** Used to check objects for own properties. */
	    var hasOwnProperty = objectProto.hasOwnProperty;
	
	    /** Used to generate unique IDs. */
	    var idCounter = 0;
	
	    /** Used to detect methods masquerading as native. */
	    var maskSrcKey = (function() {
	      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	      return uid ? ('Symbol(src)_1.' + uid) : '';
	    }());
	
	    /**
	     * Used to resolve the
	     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	     * of values.
	     */
	    var nativeObjectToString = objectProto.toString;
	
	    /** Used to infer the `Object` constructor. */
	    var objectCtorString = funcToString.call(Object);
	
	    /** Used to restore the original `_` reference in `_.noConflict`. */
	    var oldDash = root._;
	
	    /** Used to detect if a method is native. */
	    var reIsNative = RegExp('^' +
	      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	    );
	
	    /** Built-in value references. */
	    var Buffer = moduleExports ? context.Buffer : undefined,
	        Symbol = context.Symbol,
	        Uint8Array = context.Uint8Array,
	        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
	        getPrototype = overArg(Object.getPrototypeOf, Object),
	        objectCreate = Object.create,
	        propertyIsEnumerable = objectProto.propertyIsEnumerable,
	        splice = arrayProto.splice,
	        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined,
	        symIterator = Symbol ? Symbol.iterator : undefined,
	        symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	    var defineProperty = (function() {
	      try {
	        var func = getNative(Object, 'defineProperty');
	        func({}, '', {});
	        return func;
	      } catch (e) {}
	    }());
	
	    /** Mocked built-ins. */
	    var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
	        ctxNow = Date && Date.now !== root.Date.now && Date.now,
	        ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
	
	    /* Built-in method references for those with the same name as other `lodash` methods. */
	    var nativeCeil = Math.ceil,
	        nativeFloor = Math.floor,
	        nativeGetSymbols = Object.getOwnPropertySymbols,
	        nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
	        nativeIsFinite = context.isFinite,
	        nativeJoin = arrayProto.join,
	        nativeKeys = overArg(Object.keys, Object),
	        nativeMax = Math.max,
	        nativeMin = Math.min,
	        nativeNow = Date.now,
	        nativeParseInt = context.parseInt,
	        nativeRandom = Math.random,
	        nativeReverse = arrayProto.reverse;
	
	    /* Built-in method references that are verified to be native. */
	    var DataView = getNative(context, 'DataView'),
	        Map = getNative(context, 'Map'),
	        Promise = getNative(context, 'Promise'),
	        Set = getNative(context, 'Set'),
	        WeakMap = getNative(context, 'WeakMap'),
	        nativeCreate = getNative(Object, 'create');
	
	    /** Used to store function metadata. */
	    var metaMap = WeakMap && new WeakMap;
	
	    /** Used to lookup unminified function names. */
	    var realNames = {};
	
	    /** Used to detect maps, sets, and weakmaps. */
	    var dataViewCtorString = toSource(DataView),
	        mapCtorString = toSource(Map),
	        promiseCtorString = toSource(Promise),
	        setCtorString = toSource(Set),
	        weakMapCtorString = toSource(WeakMap);
	
	    /** Used to convert symbols to primitives and strings. */
	    var symbolProto = Symbol ? Symbol.prototype : undefined,
	        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
	        symbolToString = symbolProto ? symbolProto.toString : undefined;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a `lodash` object which wraps `value` to enable implicit method
	     * chain sequences. Methods that operate on and return arrays, collections,
	     * and functions can be chained together. Methods that retrieve a single value
	     * or may return a primitive value will automatically end the chain sequence
	     * and return the unwrapped value. Otherwise, the value must be unwrapped
	     * with `_#value`.
	     *
	     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
	     * enabled using `_.chain`.
	     *
	     * The execution of chained methods is lazy, that is, it's deferred until
	     * `_#value` is implicitly or explicitly called.
	     *
	     * Lazy evaluation allows several methods to support shortcut fusion.
	     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
	     * the creation of intermediate arrays and can greatly reduce the number of
	     * iteratee executions. Sections of a chain sequence qualify for shortcut
	     * fusion if the section is applied to an array and iteratees accept only
	     * one argument. The heuristic for whether a section qualifies for shortcut
	     * fusion is subject to change.
	     *
	     * Chaining is supported in custom builds as long as the `_#value` method is
	     * directly or indirectly included in the build.
	     *
	     * In addition to lodash methods, wrappers have `Array` and `String` methods.
	     *
	     * The wrapper `Array` methods are:
	     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
	     *
	     * The wrapper `String` methods are:
	     * `replace` and `split`
	     *
	     * The wrapper methods that support shortcut fusion are:
	     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
	     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
	     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
	     *
	     * The chainable wrapper methods are:
	     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
	     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
	     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
	     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
	     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
	     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
	     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
	     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
	     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
	     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
	     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
	     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
	     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
	     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
	     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
	     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
	     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
	     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
	     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
	     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
	     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
	     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
	     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
	     * `zipObject`, `zipObjectDeep`, and `zipWith`
	     *
	     * The wrapper methods that are **not** chainable by default are:
	     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
	     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
	     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
	     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
	     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
	     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
	     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
	     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
	     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
	     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
	     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
	     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
	     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
	     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
	     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
	     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
	     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
	     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
	     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
	     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
	     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
	     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
	     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
	     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
	     * `upperFirst`, `value`, and `words`
	     *
	     * @name _
	     * @constructor
	     * @category Seq
	     * @param {*} value The value to wrap in a `lodash` instance.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var wrapped = _([1, 2, 3]);
	     *
	     * // Returns an unwrapped value.
	     * wrapped.reduce(_.add);
	     * // => 6
	     *
	     * // Returns a wrapped value.
	     * var squares = wrapped.map(square);
	     *
	     * _.isArray(squares);
	     * // => false
	     *
	     * _.isArray(squares.value());
	     * // => true
	     */
	    function lodash(value) {
	      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
	        if (value instanceof LodashWrapper) {
	          return value;
	        }
	        if (hasOwnProperty.call(value, '__wrapped__')) {
	          return wrapperClone(value);
	        }
	      }
	      return new LodashWrapper(value);
	    }
	
	    /**
	     * The base implementation of `_.create` without support for assigning
	     * properties to the created object.
	     *
	     * @private
	     * @param {Object} proto The object to inherit from.
	     * @returns {Object} Returns the new object.
	     */
	    var baseCreate = (function() {
	      function object() {}
	      return function(proto) {
	        if (!isObject(proto)) {
	          return {};
	        }
	        if (objectCreate) {
	          return objectCreate(proto);
	        }
	        object.prototype = proto;
	        var result = new object;
	        object.prototype = undefined;
	        return result;
	      };
	    }());
	
	    /**
	     * The function whose prototype chain sequence wrappers inherit from.
	     *
	     * @private
	     */
	    function baseLodash() {
	      // No operation performed.
	    }
	
	    /**
	     * The base constructor for creating `lodash` wrapper objects.
	     *
	     * @private
	     * @param {*} value The value to wrap.
	     * @param {boolean} [chainAll] Enable explicit method chain sequences.
	     */
	    function LodashWrapper(value, chainAll) {
	      this.__wrapped__ = value;
	      this.__actions__ = [];
	      this.__chain__ = !!chainAll;
	      this.__index__ = 0;
	      this.__values__ = undefined;
	    }
	
	    /**
	     * By default, the template delimiters used by lodash are like those in
	     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
	     * following template settings to use alternative delimiters.
	     *
	     * @static
	     * @memberOf _
	     * @type {Object}
	     */
	    lodash.templateSettings = {
	
	      /**
	       * Used to detect `data` property values to be HTML-escaped.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'escape': reEscape,
	
	      /**
	       * Used to detect code to be evaluated.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'evaluate': reEvaluate,
	
	      /**
	       * Used to detect `data` property values to inject.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'interpolate': reInterpolate,
	
	      /**
	       * Used to reference the data object in the template text.
	       *
	       * @memberOf _.templateSettings
	       * @type {string}
	       */
	      'variable': '',
	
	      /**
	       * Used to import variables into the compiled template.
	       *
	       * @memberOf _.templateSettings
	       * @type {Object}
	       */
	      'imports': {
	
	        /**
	         * A reference to the `lodash` function.
	         *
	         * @memberOf _.templateSettings.imports
	         * @type {Function}
	         */
	        '_': lodash
	      }
	    };
	
	    // Ensure wrappers are instances of `baseLodash`.
	    lodash.prototype = baseLodash.prototype;
	    lodash.prototype.constructor = lodash;
	
	    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
	    LodashWrapper.prototype.constructor = LodashWrapper;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
	     *
	     * @private
	     * @constructor
	     * @param {*} value The value to wrap.
	     */
	    function LazyWrapper(value) {
	      this.__wrapped__ = value;
	      this.__actions__ = [];
	      this.__dir__ = 1;
	      this.__filtered__ = false;
	      this.__iteratees__ = [];
	      this.__takeCount__ = MAX_ARRAY_LENGTH;
	      this.__views__ = [];
	    }
	
	    /**
	     * Creates a clone of the lazy wrapper object.
	     *
	     * @private
	     * @name clone
	     * @memberOf LazyWrapper
	     * @returns {Object} Returns the cloned `LazyWrapper` object.
	     */
	    function lazyClone() {
	      var result = new LazyWrapper(this.__wrapped__);
	      result.__actions__ = copyArray(this.__actions__);
	      result.__dir__ = this.__dir__;
	      result.__filtered__ = this.__filtered__;
	      result.__iteratees__ = copyArray(this.__iteratees__);
	      result.__takeCount__ = this.__takeCount__;
	      result.__views__ = copyArray(this.__views__);
	      return result;
	    }
	
	    /**
	     * Reverses the direction of lazy iteration.
	     *
	     * @private
	     * @name reverse
	     * @memberOf LazyWrapper
	     * @returns {Object} Returns the new reversed `LazyWrapper` object.
	     */
	    function lazyReverse() {
	      if (this.__filtered__) {
	        var result = new LazyWrapper(this);
	        result.__dir__ = -1;
	        result.__filtered__ = true;
	      } else {
	        result = this.clone();
	        result.__dir__ *= -1;
	      }
	      return result;
	    }
	
	    /**
	     * Extracts the unwrapped value from its lazy wrapper.
	     *
	     * @private
	     * @name value
	     * @memberOf LazyWrapper
	     * @returns {*} Returns the unwrapped value.
	     */
	    function lazyValue() {
	      var array = this.__wrapped__.value(),
	          dir = this.__dir__,
	          isArr = isArray(array),
	          isRight = dir < 0,
	          arrLength = isArr ? array.length : 0,
	          view = getView(0, arrLength, this.__views__),
	          start = view.start,
	          end = view.end,
	          length = end - start,
	          index = isRight ? end : (start - 1),
	          iteratees = this.__iteratees__,
	          iterLength = iteratees.length,
	          resIndex = 0,
	          takeCount = nativeMin(length, this.__takeCount__);
	
	      if (!isArr || (!isRight && arrLength == length && takeCount == length)) {
	        return baseWrapperValue(array, this.__actions__);
	      }
	      var result = [];
	
	      outer:
	      while (length-- && resIndex < takeCount) {
	        index += dir;
	
	        var iterIndex = -1,
	            value = array[index];
	
	        while (++iterIndex < iterLength) {
	          var data = iteratees[iterIndex],
	              iteratee = data.iteratee,
	              type = data.type,
	              computed = iteratee(value);
	
	          if (type == LAZY_MAP_FLAG) {
	            value = computed;
	          } else if (!computed) {
	            if (type == LAZY_FILTER_FLAG) {
	              continue outer;
	            } else {
	              break outer;
	            }
	          }
	        }
	        result[resIndex++] = value;
	      }
	      return result;
	    }
	
	    // Ensure `LazyWrapper` is an instance of `baseLodash`.
	    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
	    LazyWrapper.prototype.constructor = LazyWrapper;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a hash object.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function Hash(entries) {
	      var index = -1,
	          length = entries == null ? 0 : entries.length;
	
	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the hash.
	     *
	     * @private
	     * @name clear
	     * @memberOf Hash
	     */
	    function hashClear() {
	      this.__data__ = nativeCreate ? nativeCreate(null) : {};
	      this.size = 0;
	    }
	
	    /**
	     * Removes `key` and its value from the hash.
	     *
	     * @private
	     * @name delete
	     * @memberOf Hash
	     * @param {Object} hash The hash to modify.
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function hashDelete(key) {
	      var result = this.has(key) && delete this.__data__[key];
	      this.size -= result ? 1 : 0;
	      return result;
	    }
	
	    /**
	     * Gets the hash value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf Hash
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function hashGet(key) {
	      var data = this.__data__;
	      if (nativeCreate) {
	        var result = data[key];
	        return result === HASH_UNDEFINED ? undefined : result;
	      }
	      return hasOwnProperty.call(data, key) ? data[key] : undefined;
	    }
	
	    /**
	     * Checks if a hash value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf Hash
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function hashHas(key) {
	      var data = this.__data__;
	      return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
	    }
	
	    /**
	     * Sets the hash `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf Hash
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the hash instance.
	     */
	    function hashSet(key, value) {
	      var data = this.__data__;
	      this.size += this.has(key) ? 0 : 1;
	      data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	      return this;
	    }
	
	    // Add methods to `Hash`.
	    Hash.prototype.clear = hashClear;
	    Hash.prototype['delete'] = hashDelete;
	    Hash.prototype.get = hashGet;
	    Hash.prototype.has = hashHas;
	    Hash.prototype.set = hashSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an list cache object.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function ListCache(entries) {
	      var index = -1,
	          length = entries == null ? 0 : entries.length;
	
	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the list cache.
	     *
	     * @private
	     * @name clear
	     * @memberOf ListCache
	     */
	    function listCacheClear() {
	      this.__data__ = [];
	      this.size = 0;
	    }
	
	    /**
	     * Removes `key` and its value from the list cache.
	     *
	     * @private
	     * @name delete
	     * @memberOf ListCache
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function listCacheDelete(key) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);
	
	      if (index < 0) {
	        return false;
	      }
	      var lastIndex = data.length - 1;
	      if (index == lastIndex) {
	        data.pop();
	      } else {
	        splice.call(data, index, 1);
	      }
	      --this.size;
	      return true;
	    }
	
	    /**
	     * Gets the list cache value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf ListCache
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function listCacheGet(key) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);
	
	      return index < 0 ? undefined : data[index][1];
	    }
	
	    /**
	     * Checks if a list cache value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf ListCache
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function listCacheHas(key) {
	      return assocIndexOf(this.__data__, key) > -1;
	    }
	
	    /**
	     * Sets the list cache `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf ListCache
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the list cache instance.
	     */
	    function listCacheSet(key, value) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);
	
	      if (index < 0) {
	        ++this.size;
	        data.push([key, value]);
	      } else {
	        data[index][1] = value;
	      }
	      return this;
	    }
	
	    // Add methods to `ListCache`.
	    ListCache.prototype.clear = listCacheClear;
	    ListCache.prototype['delete'] = listCacheDelete;
	    ListCache.prototype.get = listCacheGet;
	    ListCache.prototype.has = listCacheHas;
	    ListCache.prototype.set = listCacheSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a map cache object to store key-value pairs.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function MapCache(entries) {
	      var index = -1,
	          length = entries == null ? 0 : entries.length;
	
	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the map.
	     *
	     * @private
	     * @name clear
	     * @memberOf MapCache
	     */
	    function mapCacheClear() {
	      this.size = 0;
	      this.__data__ = {
	        'hash': new Hash,
	        'map': new (Map || ListCache),
	        'string': new Hash
	      };
	    }
	
	    /**
	     * Removes `key` and its value from the map.
	     *
	     * @private
	     * @name delete
	     * @memberOf MapCache
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function mapCacheDelete(key) {
	      var result = getMapData(this, key)['delete'](key);
	      this.size -= result ? 1 : 0;
	      return result;
	    }
	
	    /**
	     * Gets the map value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf MapCache
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function mapCacheGet(key) {
	      return getMapData(this, key).get(key);
	    }
	
	    /**
	     * Checks if a map value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf MapCache
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function mapCacheHas(key) {
	      return getMapData(this, key).has(key);
	    }
	
	    /**
	     * Sets the map `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf MapCache
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the map cache instance.
	     */
	    function mapCacheSet(key, value) {
	      var data = getMapData(this, key),
	          size = data.size;
	
	      data.set(key, value);
	      this.size += data.size == size ? 0 : 1;
	      return this;
	    }
	
	    // Add methods to `MapCache`.
	    MapCache.prototype.clear = mapCacheClear;
	    MapCache.prototype['delete'] = mapCacheDelete;
	    MapCache.prototype.get = mapCacheGet;
	    MapCache.prototype.has = mapCacheHas;
	    MapCache.prototype.set = mapCacheSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     *
	     * Creates an array cache object to store unique values.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [values] The values to cache.
	     */
	    function SetCache(values) {
	      var index = -1,
	          length = values == null ? 0 : values.length;
	
	      this.__data__ = new MapCache;
	      while (++index < length) {
	        this.add(values[index]);
	      }
	    }
	
	    /**
	     * Adds `value` to the array cache.
	     *
	     * @private
	     * @name add
	     * @memberOf SetCache
	     * @alias push
	     * @param {*} value The value to cache.
	     * @returns {Object} Returns the cache instance.
	     */
	    function setCacheAdd(value) {
	      this.__data__.set(value, HASH_UNDEFINED);
	      return this;
	    }
	
	    /**
	     * Checks if `value` is in the array cache.
	     *
	     * @private
	     * @name has
	     * @memberOf SetCache
	     * @param {*} value The value to search for.
	     * @returns {number} Returns `true` if `value` is found, else `false`.
	     */
	    function setCacheHas(value) {
	      return this.__data__.has(value);
	    }
	
	    // Add methods to `SetCache`.
	    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
	    SetCache.prototype.has = setCacheHas;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a stack cache object to store key-value pairs.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function Stack(entries) {
	      var data = this.__data__ = new ListCache(entries);
	      this.size = data.size;
	    }
	
	    /**
	     * Removes all key-value entries from the stack.
	     *
	     * @private
	     * @name clear
	     * @memberOf Stack
	     */
	    function stackClear() {
	      this.__data__ = new ListCache;
	      this.size = 0;
	    }
	
	    /**
	     * Removes `key` and its value from the stack.
	     *
	     * @private
	     * @name delete
	     * @memberOf Stack
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function stackDelete(key) {
	      var data = this.__data__,
	          result = data['delete'](key);
	
	      this.size = data.size;
	      return result;
	    }
	
	    /**
	     * Gets the stack value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf Stack
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function stackGet(key) {
	      return this.__data__.get(key);
	    }
	
	    /**
	     * Checks if a stack value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf Stack
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function stackHas(key) {
	      return this.__data__.has(key);
	    }
	
	    /**
	     * Sets the stack `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf Stack
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the stack cache instance.
	     */
	    function stackSet(key, value) {
	      var data = this.__data__;
	      if (data instanceof ListCache) {
	        var pairs = data.__data__;
	        if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
	          pairs.push([key, value]);
	          this.size = ++data.size;
	          return this;
	        }
	        data = this.__data__ = new MapCache(pairs);
	      }
	      data.set(key, value);
	      this.size = data.size;
	      return this;
	    }
	
	    // Add methods to `Stack`.
	    Stack.prototype.clear = stackClear;
	    Stack.prototype['delete'] = stackDelete;
	    Stack.prototype.get = stackGet;
	    Stack.prototype.has = stackHas;
	    Stack.prototype.set = stackSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an array of the enumerable property names of the array-like `value`.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @param {boolean} inherited Specify returning inherited property names.
	     * @returns {Array} Returns the array of property names.
	     */
	    function arrayLikeKeys(value, inherited) {
	      var isArr = isArray(value),
	          isArg = !isArr && isArguments(value),
	          isBuff = !isArr && !isArg && isBuffer(value),
	          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
	          skipIndexes = isArr || isArg || isBuff || isType,
	          result = skipIndexes ? baseTimes(value.length, String) : [],
	          length = result.length;
	
	      for (var key in value) {
	        if ((inherited || hasOwnProperty.call(value, key)) &&
	            !(skipIndexes && (
	               // Safari 9 has enumerable `arguments.length` in strict mode.
	               key == 'length' ||
	               // Node.js 0.10 has enumerable non-index properties on buffers.
	               (isBuff && (key == 'offset' || key == 'parent')) ||
	               // PhantomJS 2 has enumerable non-index properties on typed arrays.
	               (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
	               // Skip index properties.
	               isIndex(key, length)
	            ))) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * A specialized version of `_.sample` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to sample.
	     * @returns {*} Returns the random element.
	     */
	    function arraySample(array) {
	      var length = array.length;
	      return length ? array[baseRandom(0, length - 1)] : undefined;
	    }
	
	    /**
	     * A specialized version of `_.sampleSize` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to sample.
	     * @param {number} n The number of elements to sample.
	     * @returns {Array} Returns the random elements.
	     */
	    function arraySampleSize(array, n) {
	      return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
	    }
	
	    /**
	     * A specialized version of `_.shuffle` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     */
	    function arrayShuffle(array) {
	      return shuffleSelf(copyArray(array));
	    }
	
	    /**
	     * This function is like `assignValue` except that it doesn't assign
	     * `undefined` values.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function assignMergeValue(object, key, value) {
	      if ((value !== undefined && !eq(object[key], value)) ||
	          (value === undefined && !(key in object))) {
	        baseAssignValue(object, key, value);
	      }
	    }
	
	    /**
	     * Assigns `value` to `key` of `object` if the existing value is not equivalent
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function assignValue(object, key, value) {
	      var objValue = object[key];
	      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
	          (value === undefined && !(key in object))) {
	        baseAssignValue(object, key, value);
	      }
	    }
	
	    /**
	     * Gets the index at which the `key` is found in `array` of key-value pairs.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {*} key The key to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     */
	    function assocIndexOf(array, key) {
	      var length = array.length;
	      while (length--) {
	        if (eq(array[length][0], key)) {
	          return length;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * Aggregates elements of `collection` on `accumulator` with keys transformed
	     * by `iteratee` and values set by `setter`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} setter The function to set `accumulator` values.
	     * @param {Function} iteratee The iteratee to transform keys.
	     * @param {Object} accumulator The initial aggregated object.
	     * @returns {Function} Returns `accumulator`.
	     */
	    function baseAggregator(collection, setter, iteratee, accumulator) {
	      baseEach(collection, function(value, key, collection) {
	        setter(accumulator, value, iteratee(value), collection);
	      });
	      return accumulator;
	    }
	
	    /**
	     * The base implementation of `_.assign` without support for multiple sources
	     * or `customizer` functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @returns {Object} Returns `object`.
	     */
	    function baseAssign(object, source) {
	      return object && copyObject(source, keys(source), object);
	    }
	
	    /**
	     * The base implementation of `_.assignIn` without support for multiple sources
	     * or `customizer` functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @returns {Object} Returns `object`.
	     */
	    function baseAssignIn(object, source) {
	      return object && copyObject(source, keysIn(source), object);
	    }
	
	    /**
	     * The base implementation of `assignValue` and `assignMergeValue` without
	     * value checks.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function baseAssignValue(object, key, value) {
	      if (key == '__proto__' && defineProperty) {
	        defineProperty(object, key, {
	          'configurable': true,
	          'enumerable': true,
	          'value': value,
	          'writable': true
	        });
	      } else {
	        object[key] = value;
	      }
	    }
	
	    /**
	     * The base implementation of `_.at` without support for individual paths.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {string[]} paths The property paths to pick.
	     * @returns {Array} Returns the picked elements.
	     */
	    function baseAt(object, paths) {
	      var index = -1,
	          length = paths.length,
	          result = Array(length),
	          skip = object == null;
	
	      while (++index < length) {
	        result[index] = skip ? undefined : get(object, paths[index]);
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.clamp` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {number} number The number to clamp.
	     * @param {number} [lower] The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the clamped number.
	     */
	    function baseClamp(number, lower, upper) {
	      if (number === number) {
	        if (upper !== undefined) {
	          number = number <= upper ? number : upper;
	        }
	        if (lower !== undefined) {
	          number = number >= lower ? number : lower;
	        }
	      }
	      return number;
	    }
	
	    /**
	     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
	     * traversed objects.
	     *
	     * @private
	     * @param {*} value The value to clone.
	     * @param {boolean} bitmask The bitmask flags.
	     *  1 - Deep clone
	     *  2 - Flatten inherited properties
	     *  4 - Clone symbols
	     * @param {Function} [customizer] The function to customize cloning.
	     * @param {string} [key] The key of `value`.
	     * @param {Object} [object] The parent object of `value`.
	     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
	     * @returns {*} Returns the cloned value.
	     */
	    function baseClone(value, bitmask, customizer, key, object, stack) {
	      var result,
	          isDeep = bitmask & CLONE_DEEP_FLAG,
	          isFlat = bitmask & CLONE_FLAT_FLAG,
	          isFull = bitmask & CLONE_SYMBOLS_FLAG;
	
	      if (customizer) {
	        result = object ? customizer(value, key, object, stack) : customizer(value);
	      }
	      if (result !== undefined) {
	        return result;
	      }
	      if (!isObject(value)) {
	        return value;
	      }
	      var isArr = isArray(value);
	      if (isArr) {
	        result = initCloneArray(value);
	        if (!isDeep) {
	          return copyArray(value, result);
	        }
	      } else {
	        var tag = getTag(value),
	            isFunc = tag == funcTag || tag == genTag;
	
	        if (isBuffer(value)) {
	          return cloneBuffer(value, isDeep);
	        }
	        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
	          result = (isFlat || isFunc) ? {} : initCloneObject(value);
	          if (!isDeep) {
	            return isFlat
	              ? copySymbolsIn(value, baseAssignIn(result, value))
	              : copySymbols(value, baseAssign(result, value));
	          }
	        } else {
	          if (!cloneableTags[tag]) {
	            return object ? value : {};
	          }
	          result = initCloneByTag(value, tag, isDeep);
	        }
	      }
	      // Check for circular references and return its corresponding clone.
	      stack || (stack = new Stack);
	      var stacked = stack.get(value);
	      if (stacked) {
	        return stacked;
	      }
	      stack.set(value, result);
	
	      if (isSet(value)) {
	        value.forEach(function(subValue) {
	          result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
	        });
	      } else if (isMap(value)) {
	        value.forEach(function(subValue, key) {
	          result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
	        });
	      }
	
	      var keysFunc = isFull
	        ? (isFlat ? getAllKeysIn : getAllKeys)
	        : (isFlat ? keysIn : keys);
	
	      var props = isArr ? undefined : keysFunc(value);
	      arrayEach(props || value, function(subValue, key) {
	        if (props) {
	          key = subValue;
	          subValue = value[key];
	        }
	        // Recursively populate clone (susceptible to call stack limits).
	        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.conforms` which doesn't clone `source`.
	     *
	     * @private
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseConforms(source) {
	      var props = keys(source);
	      return function(object) {
	        return baseConformsTo(object, source, props);
	      };
	    }
	
	    /**
	     * The base implementation of `_.conformsTo` which accepts `props` to check.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
	     */
	    function baseConformsTo(object, source, props) {
	      var length = props.length;
	      if (object == null) {
	        return !length;
	      }
	      object = Object(object);
	      while (length--) {
	        var key = props[length],
	            predicate = source[key],
	            value = object[key];
	
	        if ((value === undefined && !(key in object)) || !predicate(value)) {
	          return false;
	        }
	      }
	      return true;
	    }
	
	    /**
	     * The base implementation of `_.delay` and `_.defer` which accepts `args`
	     * to provide to `func`.
	     *
	     * @private
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @param {Array} args The arguments to provide to `func`.
	     * @returns {number|Object} Returns the timer id or timeout object.
	     */
	    function baseDelay(func, wait, args) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return setTimeout(function() { func.apply(undefined, args); }, wait);
	    }
	
	    /**
	     * The base implementation of methods like `_.difference` without support
	     * for excluding multiple arrays or iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Array} values The values to exclude.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     */
	    function baseDifference(array, values, iteratee, comparator) {
	      var index = -1,
	          includes = arrayIncludes,
	          isCommon = true,
	          length = array.length,
	          result = [],
	          valuesLength = values.length;
	
	      if (!length) {
	        return result;
	      }
	      if (iteratee) {
	        values = arrayMap(values, baseUnary(iteratee));
	      }
	      if (comparator) {
	        includes = arrayIncludesWith;
	        isCommon = false;
	      }
	      else if (values.length >= LARGE_ARRAY_SIZE) {
	        includes = cacheHas;
	        isCommon = false;
	        values = new SetCache(values);
	      }
	      outer:
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee == null ? value : iteratee(value);
	
	        value = (comparator || value !== 0) ? value : 0;
	        if (isCommon && computed === computed) {
	          var valuesIndex = valuesLength;
	          while (valuesIndex--) {
	            if (values[valuesIndex] === computed) {
	              continue outer;
	            }
	          }
	          result.push(value);
	        }
	        else if (!includes(values, computed, comparator)) {
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.forEach` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     */
	    var baseEach = createBaseEach(baseForOwn);
	
	    /**
	     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     */
	    var baseEachRight = createBaseEach(baseForOwnRight, true);
	
	    /**
	     * The base implementation of `_.every` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`
	     */
	    function baseEvery(collection, predicate) {
	      var result = true;
	      baseEach(collection, function(value, index, collection) {
	        result = !!predicate(value, index, collection);
	        return result;
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of methods like `_.max` and `_.min` which accepts a
	     * `comparator` to determine the extremum value.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The iteratee invoked per iteration.
	     * @param {Function} comparator The comparator used to compare values.
	     * @returns {*} Returns the extremum value.
	     */
	    function baseExtremum(array, iteratee, comparator) {
	      var index = -1,
	          length = array.length;
	
	      while (++index < length) {
	        var value = array[index],
	            current = iteratee(value);
	
	        if (current != null && (computed === undefined
	              ? (current === current && !isSymbol(current))
	              : comparator(current, computed)
	            )) {
	          var computed = current,
	              result = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.fill` without an iteratee call guard.
	     *
	     * @private
	     * @param {Array} array The array to fill.
	     * @param {*} value The value to fill `array` with.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns `array`.
	     */
	    function baseFill(array, value, start, end) {
	      var length = array.length;
	
	      start = toInteger(start);
	      if (start < 0) {
	        start = -start > length ? 0 : (length + start);
	      }
	      end = (end === undefined || end > length) ? length : toInteger(end);
	      if (end < 0) {
	        end += length;
	      }
	      end = start > end ? 0 : toLength(end);
	      while (start < end) {
	        array[start++] = value;
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.filter` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     */
	    function baseFilter(collection, predicate) {
	      var result = [];
	      baseEach(collection, function(value, index, collection) {
	        if (predicate(value, index, collection)) {
	          result.push(value);
	        }
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.flatten` with support for restricting flattening.
	     *
	     * @private
	     * @param {Array} array The array to flatten.
	     * @param {number} depth The maximum recursion depth.
	     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
	     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
	     * @param {Array} [result=[]] The initial result value.
	     * @returns {Array} Returns the new flattened array.
	     */
	    function baseFlatten(array, depth, predicate, isStrict, result) {
	      var index = -1,
	          length = array.length;
	
	      predicate || (predicate = isFlattenable);
	      result || (result = []);
	
	      while (++index < length) {
	        var value = array[index];
	        if (depth > 0 && predicate(value)) {
	          if (depth > 1) {
	            // Recursively flatten arrays (susceptible to call stack limits).
	            baseFlatten(value, depth - 1, predicate, isStrict, result);
	          } else {
	            arrayPush(result, value);
	          }
	        } else if (!isStrict) {
	          result[result.length] = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `baseForOwn` which iterates over `object`
	     * properties returned by `keysFunc` and invokes `iteratee` for each property.
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @returns {Object} Returns `object`.
	     */
	    var baseFor = createBaseFor();
	
	    /**
	     * This function is like `baseFor` except that it iterates over properties
	     * in the opposite order.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @returns {Object} Returns `object`.
	     */
	    var baseForRight = createBaseFor(true);
	
	    /**
	     * The base implementation of `_.forOwn` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForOwn(object, iteratee) {
	      return object && baseFor(object, iteratee, keys);
	    }
	
	    /**
	     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForOwnRight(object, iteratee) {
	      return object && baseForRight(object, iteratee, keys);
	    }
	
	    /**
	     * The base implementation of `_.functions` which creates an array of
	     * `object` function property names filtered from `props`.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Array} props The property names to filter.
	     * @returns {Array} Returns the function names.
	     */
	    function baseFunctions(object, props) {
	      return arrayFilter(props, function(key) {
	        return isFunction(object[key]);
	      });
	    }
	
	    /**
	     * The base implementation of `_.get` without support for default values.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to get.
	     * @returns {*} Returns the resolved value.
	     */
	    function baseGet(object, path) {
	      path = castPath(path, object);
	
	      var index = 0,
	          length = path.length;
	
	      while (object != null && index < length) {
	        object = object[toKey(path[index++])];
	      }
	      return (index && index == length) ? object : undefined;
	    }
	
	    /**
	     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
	     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
	     * symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @param {Function} symbolsFunc The function to get the symbols of `object`.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
	      var result = keysFunc(object);
	      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
	    }
	
	    /**
	     * The base implementation of `getTag` without fallbacks for buggy environments.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the `toStringTag`.
	     */
	    function baseGetTag(value) {
	      if (value == null) {
	        return value === undefined ? undefinedTag : nullTag;
	      }
	      return (symToStringTag && symToStringTag in Object(value))
	        ? getRawTag(value)
	        : objectToString(value);
	    }
	
	    /**
	     * The base implementation of `_.gt` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than `other`,
	     *  else `false`.
	     */
	    function baseGt(value, other) {
	      return value > other;
	    }
	
	    /**
	     * The base implementation of `_.has` without support for deep paths.
	     *
	     * @private
	     * @param {Object} [object] The object to query.
	     * @param {Array|string} key The key to check.
	     * @returns {boolean} Returns `true` if `key` exists, else `false`.
	     */
	    function baseHas(object, key) {
	      return object != null && hasOwnProperty.call(object, key);
	    }
	
	    /**
	     * The base implementation of `_.hasIn` without support for deep paths.
	     *
	     * @private
	     * @param {Object} [object] The object to query.
	     * @param {Array|string} key The key to check.
	     * @returns {boolean} Returns `true` if `key` exists, else `false`.
	     */
	    function baseHasIn(object, key) {
	      return object != null && key in Object(object);
	    }
	
	    /**
	     * The base implementation of `_.inRange` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {number} number The number to check.
	     * @param {number} start The start of the range.
	     * @param {number} end The end of the range.
	     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
	     */
	    function baseInRange(number, start, end) {
	      return number >= nativeMin(start, end) && number < nativeMax(start, end);
	    }
	
	    /**
	     * The base implementation of methods like `_.intersection`, without support
	     * for iteratee shorthands, that accepts an array of arrays to inspect.
	     *
	     * @private
	     * @param {Array} arrays The arrays to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of shared values.
	     */
	    function baseIntersection(arrays, iteratee, comparator) {
	      var includes = comparator ? arrayIncludesWith : arrayIncludes,
	          length = arrays[0].length,
	          othLength = arrays.length,
	          othIndex = othLength,
	          caches = Array(othLength),
	          maxLength = Infinity,
	          result = [];
	
	      while (othIndex--) {
	        var array = arrays[othIndex];
	        if (othIndex && iteratee) {
	          array = arrayMap(array, baseUnary(iteratee));
	        }
	        maxLength = nativeMin(array.length, maxLength);
	        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
	          ? new SetCache(othIndex && array)
	          : undefined;
	      }
	      array = arrays[0];
	
	      var index = -1,
	          seen = caches[0];
	
	      outer:
	      while (++index < length && result.length < maxLength) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        value = (comparator || value !== 0) ? value : 0;
	        if (!(seen
	              ? cacheHas(seen, computed)
	              : includes(result, computed, comparator)
	            )) {
	          othIndex = othLength;
	          while (--othIndex) {
	            var cache = caches[othIndex];
	            if (!(cache
	                  ? cacheHas(cache, computed)
	                  : includes(arrays[othIndex], computed, comparator))
	                ) {
	              continue outer;
	            }
	          }
	          if (seen) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.invert` and `_.invertBy` which inverts
	     * `object` with values transformed by `iteratee` and set by `setter`.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} setter The function to set `accumulator` values.
	     * @param {Function} iteratee The iteratee to transform values.
	     * @param {Object} accumulator The initial inverted object.
	     * @returns {Function} Returns `accumulator`.
	     */
	    function baseInverter(object, setter, iteratee, accumulator) {
	      baseForOwn(object, function(value, key, object) {
	        setter(accumulator, iteratee(value), key, object);
	      });
	      return accumulator;
	    }
	
	    /**
	     * The base implementation of `_.invoke` without support for individual
	     * method arguments.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {Array} args The arguments to invoke the method with.
	     * @returns {*} Returns the result of the invoked method.
	     */
	    function baseInvoke(object, path, args) {
	      path = castPath(path, object);
	      object = parent(object, path);
	      var func = object == null ? object : object[toKey(last(path))];
	      return func == null ? undefined : apply(func, object, args);
	    }
	
	    /**
	     * The base implementation of `_.isArguments`.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	     */
	    function baseIsArguments(value) {
	      return isObjectLike(value) && baseGetTag(value) == argsTag;
	    }
	
	    /**
	     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
	     */
	    function baseIsArrayBuffer(value) {
	      return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
	    }
	
	    /**
	     * The base implementation of `_.isDate` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
	     */
	    function baseIsDate(value) {
	      return isObjectLike(value) && baseGetTag(value) == dateTag;
	    }
	
	    /**
	     * The base implementation of `_.isEqual` which supports partial comparisons
	     * and tracks traversed objects.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @param {boolean} bitmask The bitmask flags.
	     *  1 - Unordered comparison
	     *  2 - Partial comparison
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     */
	    function baseIsEqual(value, other, bitmask, customizer, stack) {
	      if (value === other) {
	        return true;
	      }
	      if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
	        return value !== value && other !== other;
	      }
	      return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
	    }
	
	    /**
	     * A specialized version of `baseIsEqual` for arrays and objects which performs
	     * deep comparisons and tracks traversed objects enabling objects with circular
	     * references to be compared.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
	      var objIsArr = isArray(object),
	          othIsArr = isArray(other),
	          objTag = objIsArr ? arrayTag : getTag(object),
	          othTag = othIsArr ? arrayTag : getTag(other);
	
	      objTag = objTag == argsTag ? objectTag : objTag;
	      othTag = othTag == argsTag ? objectTag : othTag;
	
	      var objIsObj = objTag == objectTag,
	          othIsObj = othTag == objectTag,
	          isSameTag = objTag == othTag;
	
	      if (isSameTag && isBuffer(object)) {
	        if (!isBuffer(other)) {
	          return false;
	        }
	        objIsArr = true;
	        objIsObj = false;
	      }
	      if (isSameTag && !objIsObj) {
	        stack || (stack = new Stack);
	        return (objIsArr || isTypedArray(object))
	          ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
	          : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
	      }
	      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
	        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
	        if (objIsWrapped || othIsWrapped) {
	          var objUnwrapped = objIsWrapped ? object.value() : object,
	              othUnwrapped = othIsWrapped ? other.value() : other;
	
	          stack || (stack = new Stack);
	          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
	        }
	      }
	      if (!isSameTag) {
	        return false;
	      }
	      stack || (stack = new Stack);
	      return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
	    }
	
	    /**
	     * The base implementation of `_.isMap` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	     */
	    function baseIsMap(value) {
	      return isObjectLike(value) && getTag(value) == mapTag;
	    }
	
	    /**
	     * The base implementation of `_.isMatch` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @param {Array} matchData The property names, values, and compare flags to match.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     */
	    function baseIsMatch(object, source, matchData, customizer) {
	      var index = matchData.length,
	          length = index,
	          noCustomizer = !customizer;
	
	      if (object == null) {
	        return !length;
	      }
	      object = Object(object);
	      while (index--) {
	        var data = matchData[index];
	        if ((noCustomizer && data[2])
	              ? data[1] !== object[data[0]]
	              : !(data[0] in object)
	            ) {
	          return false;
	        }
	      }
	      while (++index < length) {
	        data = matchData[index];
	        var key = data[0],
	            objValue = object[key],
	            srcValue = data[1];
	
	        if (noCustomizer && data[2]) {
	          if (objValue === undefined && !(key in object)) {
	            return false;
	          }
	        } else {
	          var stack = new Stack;
	          if (customizer) {
	            var result = customizer(objValue, srcValue, key, object, source, stack);
	          }
	          if (!(result === undefined
	                ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
	                : result
	              )) {
	            return false;
	          }
	        }
	      }
	      return true;
	    }
	
	    /**
	     * The base implementation of `_.isNative` without bad shim checks.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a native function,
	     *  else `false`.
	     */
	    function baseIsNative(value) {
	      if (!isObject(value) || isMasked(value)) {
	        return false;
	      }
	      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
	      return pattern.test(toSource(value));
	    }
	
	    /**
	     * The base implementation of `_.isRegExp` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
	     */
	    function baseIsRegExp(value) {
	      return isObjectLike(value) && baseGetTag(value) == regexpTag;
	    }
	
	    /**
	     * The base implementation of `_.isSet` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	     */
	    function baseIsSet(value) {
	      return isObjectLike(value) && getTag(value) == setTag;
	    }
	
	    /**
	     * The base implementation of `_.isTypedArray` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	     */
	    function baseIsTypedArray(value) {
	      return isObjectLike(value) &&
	        isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
	    }
	
	    /**
	     * The base implementation of `_.iteratee`.
	     *
	     * @private
	     * @param {*} [value=_.identity] The value to convert to an iteratee.
	     * @returns {Function} Returns the iteratee.
	     */
	    function baseIteratee(value) {
	      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
	      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
	      if (typeof value == 'function') {
	        return value;
	      }
	      if (value == null) {
	        return identity;
	      }
	      if (typeof value == 'object') {
	        return isArray(value)
	          ? baseMatchesProperty(value[0], value[1])
	          : baseMatches(value);
	      }
	      return property(value);
	    }
	
	    /**
	     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function baseKeys(object) {
	      if (!isPrototype(object)) {
	        return nativeKeys(object);
	      }
	      var result = [];
	      for (var key in Object(object)) {
	        if (hasOwnProperty.call(object, key) && key != 'constructor') {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function baseKeysIn(object) {
	      if (!isObject(object)) {
	        return nativeKeysIn(object);
	      }
	      var isProto = isPrototype(object),
	          result = [];
	
	      for (var key in object) {
	        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.lt` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than `other`,
	     *  else `false`.
	     */
	    function baseLt(value, other) {
	      return value < other;
	    }
	
	    /**
	     * The base implementation of `_.map` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array} Returns the new mapped array.
	     */
	    function baseMap(collection, iteratee) {
	      var index = -1,
	          result = isArrayLike(collection) ? Array(collection.length) : [];
	
	      baseEach(collection, function(value, key, collection) {
	        result[++index] = iteratee(value, key, collection);
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.matches` which doesn't clone `source`.
	     *
	     * @private
	     * @param {Object} source The object of property values to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseMatches(source) {
	      var matchData = getMatchData(source);
	      if (matchData.length == 1 && matchData[0][2]) {
	        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
	      }
	      return function(object) {
	        return object === source || baseIsMatch(object, source, matchData);
	      };
	    }
	
	    /**
	     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
	     *
	     * @private
	     * @param {string} path The path of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseMatchesProperty(path, srcValue) {
	      if (isKey(path) && isStrictComparable(srcValue)) {
	        return matchesStrictComparable(toKey(path), srcValue);
	      }
	      return function(object) {
	        var objValue = get(object, path);
	        return (objValue === undefined && objValue === srcValue)
	          ? hasIn(object, path)
	          : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
	      };
	    }
	
	    /**
	     * The base implementation of `_.merge` without support for multiple sources.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {number} srcIndex The index of `source`.
	     * @param {Function} [customizer] The function to customize merged values.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     */
	    function baseMerge(object, source, srcIndex, customizer, stack) {
	      if (object === source) {
	        return;
	      }
	      baseFor(source, function(srcValue, key) {
	        stack || (stack = new Stack);
	        if (isObject(srcValue)) {
	          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
	        }
	        else {
	          var newValue = customizer
	            ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
	            : undefined;
	
	          if (newValue === undefined) {
	            newValue = srcValue;
	          }
	          assignMergeValue(object, key, newValue);
	        }
	      }, keysIn);
	    }
	
	    /**
	     * A specialized version of `baseMerge` for arrays and objects which performs
	     * deep merges and tracks traversed objects enabling objects with circular
	     * references to be merged.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {string} key The key of the value to merge.
	     * @param {number} srcIndex The index of `source`.
	     * @param {Function} mergeFunc The function to merge values.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     */
	    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
	      var objValue = safeGet(object, key),
	          srcValue = safeGet(source, key),
	          stacked = stack.get(srcValue);
	
	      if (stacked) {
	        assignMergeValue(object, key, stacked);
	        return;
	      }
	      var newValue = customizer
	        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
	        : undefined;
	
	      var isCommon = newValue === undefined;
	
	      if (isCommon) {
	        var isArr = isArray(srcValue),
	            isBuff = !isArr && isBuffer(srcValue),
	            isTyped = !isArr && !isBuff && isTypedArray(srcValue);
	
	        newValue = srcValue;
	        if (isArr || isBuff || isTyped) {
	          if (isArray(objValue)) {
	            newValue = objValue;
	          }
	          else if (isArrayLikeObject(objValue)) {
	            newValue = copyArray(objValue);
	          }
	          else if (isBuff) {
	            isCommon = false;
	            newValue = cloneBuffer(srcValue, true);
	          }
	          else if (isTyped) {
	            isCommon = false;
	            newValue = cloneTypedArray(srcValue, true);
	          }
	          else {
	            newValue = [];
	          }
	        }
	        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
	          newValue = objValue;
	          if (isArguments(objValue)) {
	            newValue = toPlainObject(objValue);
	          }
	          else if (!isObject(objValue) || isFunction(objValue)) {
	            newValue = initCloneObject(srcValue);
	          }
	        }
	        else {
	          isCommon = false;
	        }
	      }
	      if (isCommon) {
	        // Recursively merge objects and arrays (susceptible to call stack limits).
	        stack.set(srcValue, newValue);
	        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
	        stack['delete'](srcValue);
	      }
	      assignMergeValue(object, key, newValue);
	    }
	
	    /**
	     * The base implementation of `_.nth` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {Array} array The array to query.
	     * @param {number} n The index of the element to return.
	     * @returns {*} Returns the nth element of `array`.
	     */
	    function baseNth(array, n) {
	      var length = array.length;
	      if (!length) {
	        return;
	      }
	      n += n < 0 ? length : 0;
	      return isIndex(n, length) ? array[n] : undefined;
	    }
	
	    /**
	     * The base implementation of `_.orderBy` without param guards.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
	     * @param {string[]} orders The sort orders of `iteratees`.
	     * @returns {Array} Returns the new sorted array.
	     */
	    function baseOrderBy(collection, iteratees, orders) {
	      if (iteratees.length) {
	        iteratees = arrayMap(iteratees, function(iteratee) {
	          if (isArray(iteratee)) {
	            return function(value) {
	              return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
	            }
	          }
	          return iteratee;
	        });
	      } else {
	        iteratees = [identity];
	      }
	
	      var index = -1;
	      iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
	
	      var result = baseMap(collection, function(value, key, collection) {
	        var criteria = arrayMap(iteratees, function(iteratee) {
	          return iteratee(value);
	        });
	        return { 'criteria': criteria, 'index': ++index, 'value': value };
	      });
	
	      return baseSortBy(result, function(object, other) {
	        return compareMultiple(object, other, orders);
	      });
	    }
	
	    /**
	     * The base implementation of `_.pick` without support for individual
	     * property identifiers.
	     *
	     * @private
	     * @param {Object} object The source object.
	     * @param {string[]} paths The property paths to pick.
	     * @returns {Object} Returns the new object.
	     */
	    function basePick(object, paths) {
	      return basePickBy(object, paths, function(value, path) {
	        return hasIn(object, path);
	      });
	    }
	
	    /**
	     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The source object.
	     * @param {string[]} paths The property paths to pick.
	     * @param {Function} predicate The function invoked per property.
	     * @returns {Object} Returns the new object.
	     */
	    function basePickBy(object, paths, predicate) {
	      var index = -1,
	          length = paths.length,
	          result = {};
	
	      while (++index < length) {
	        var path = paths[index],
	            value = baseGet(object, path);
	
	        if (predicate(value, path)) {
	          baseSet(result, castPath(path, object), value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * A specialized version of `baseProperty` which supports deep paths.
	     *
	     * @private
	     * @param {Array|string} path The path of the property to get.
	     * @returns {Function} Returns the new accessor function.
	     */
	    function basePropertyDeep(path) {
	      return function(object) {
	        return baseGet(object, path);
	      };
	    }
	
	    /**
	     * The base implementation of `_.pullAllBy` without support for iteratee
	     * shorthands.
	     *
	     * @private
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns `array`.
	     */
	    function basePullAll(array, values, iteratee, comparator) {
	      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
	          index = -1,
	          length = values.length,
	          seen = array;
	
	      if (array === values) {
	        values = copyArray(values);
	      }
	      if (iteratee) {
	        seen = arrayMap(array, baseUnary(iteratee));
	      }
	      while (++index < length) {
	        var fromIndex = 0,
	            value = values[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
	          if (seen !== array) {
	            splice.call(seen, fromIndex, 1);
	          }
	          splice.call(array, fromIndex, 1);
	        }
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.pullAt` without support for individual
	     * indexes or capturing the removed elements.
	     *
	     * @private
	     * @param {Array} array The array to modify.
	     * @param {number[]} indexes The indexes of elements to remove.
	     * @returns {Array} Returns `array`.
	     */
	    function basePullAt(array, indexes) {
	      var length = array ? indexes.length : 0,
	          lastIndex = length - 1;
	
	      while (length--) {
	        var index = indexes[length];
	        if (length == lastIndex || index !== previous) {
	          var previous = index;
	          if (isIndex(index)) {
	            splice.call(array, index, 1);
	          } else {
	            baseUnset(array, index);
	          }
	        }
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.random` without support for returning
	     * floating-point numbers.
	     *
	     * @private
	     * @param {number} lower The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the random number.
	     */
	    function baseRandom(lower, upper) {
	      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
	    }
	
	    /**
	     * The base implementation of `_.range` and `_.rangeRight` which doesn't
	     * coerce arguments.
	     *
	     * @private
	     * @param {number} start The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} step The value to increment or decrement by.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Array} Returns the range of numbers.
	     */
	    function baseRange(start, end, step, fromRight) {
	      var index = -1,
	          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
	          result = Array(length);
	
	      while (length--) {
	        result[fromRight ? length : ++index] = start;
	        start += step;
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.repeat` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {string} string The string to repeat.
	     * @param {number} n The number of times to repeat the string.
	     * @returns {string} Returns the repeated string.
	     */
	    function baseRepeat(string, n) {
	      var result = '';
	      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
	        return result;
	      }
	      // Leverage the exponentiation by squaring algorithm for a faster repeat.
	      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
	      do {
	        if (n % 2) {
	          result += string;
	        }
	        n = nativeFloor(n / 2);
	        if (n) {
	          string += string;
	        }
	      } while (n);
	
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @returns {Function} Returns the new function.
	     */
	    function baseRest(func, start) {
	      return setToString(overRest(func, start, identity), func + '');
	    }
	
	    /**
	     * The base implementation of `_.sample`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to sample.
	     * @returns {*} Returns the random element.
	     */
	    function baseSample(collection) {
	      return arraySample(values(collection));
	    }
	
	    /**
	     * The base implementation of `_.sampleSize` without param guards.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to sample.
	     * @param {number} n The number of elements to sample.
	     * @returns {Array} Returns the random elements.
	     */
	    function baseSampleSize(collection, n) {
	      var array = values(collection);
	      return shuffleSelf(array, baseClamp(n, 0, array.length));
	    }
	
	    /**
	     * The base implementation of `_.set`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @param {Function} [customizer] The function to customize path creation.
	     * @returns {Object} Returns `object`.
	     */
	    function baseSet(object, path, value, customizer) {
	      if (!isObject(object)) {
	        return object;
	      }
	      path = castPath(path, object);
	
	      var index = -1,
	          length = path.length,
	          lastIndex = length - 1,
	          nested = object;
	
	      while (nested != null && ++index < length) {
	        var key = toKey(path[index]),
	            newValue = value;
	
	        if (key === '__proto__' || key === 'constructor' || key === 'prototype') {
	          return object;
	        }
	
	        if (index != lastIndex) {
	          var objValue = nested[key];
	          newValue = customizer ? customizer(objValue, key, nested) : undefined;
	          if (newValue === undefined) {
	            newValue = isObject(objValue)
	              ? objValue
	              : (isIndex(path[index + 1]) ? [] : {});
	          }
	        }
	        assignValue(nested, key, newValue);
	        nested = nested[key];
	      }
	      return object;
	    }
	
	    /**
	     * The base implementation of `setData` without support for hot loop shorting.
	     *
	     * @private
	     * @param {Function} func The function to associate metadata with.
	     * @param {*} data The metadata.
	     * @returns {Function} Returns `func`.
	     */
	    var baseSetData = !metaMap ? identity : function(func, data) {
	      metaMap.set(func, data);
	      return func;
	    };
	
	    /**
	     * The base implementation of `setToString` without support for hot loop shorting.
	     *
	     * @private
	     * @param {Function} func The function to modify.
	     * @param {Function} string The `toString` result.
	     * @returns {Function} Returns `func`.
	     */
	    var baseSetToString = !defineProperty ? identity : function(func, string) {
	      return defineProperty(func, 'toString', {
	        'configurable': true,
	        'enumerable': false,
	        'value': constant(string),
	        'writable': true
	      });
	    };
	
	    /**
	     * The base implementation of `_.shuffle`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     */
	    function baseShuffle(collection) {
	      return shuffleSelf(values(collection));
	    }
	
	    /**
	     * The base implementation of `_.slice` without an iteratee call guard.
	     *
	     * @private
	     * @param {Array} array The array to slice.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function baseSlice(array, start, end) {
	      var index = -1,
	          length = array.length;
	
	      if (start < 0) {
	        start = -start > length ? 0 : (length + start);
	      }
	      end = end > length ? length : end;
	      if (end < 0) {
	        end += length;
	      }
	      length = start > end ? 0 : ((end - start) >>> 0);
	      start >>>= 0;
	
	      var result = Array(length);
	      while (++index < length) {
	        result[index] = array[index + start];
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.some` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     */
	    function baseSome(collection, predicate) {
	      var result;
	
	      baseEach(collection, function(value, index, collection) {
	        result = predicate(value, index, collection);
	        return !result;
	      });
	      return !!result;
	    }
	
	    /**
	     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
	     * performs a binary search of `array` to determine the index at which `value`
	     * should be inserted into `array` in order to maintain its sort order.
	     *
	     * @private
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     */
	    function baseSortedIndex(array, value, retHighest) {
	      var low = 0,
	          high = array == null ? low : array.length;
	
	      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
	        while (low < high) {
	          var mid = (low + high) >>> 1,
	              computed = array[mid];
	
	          if (computed !== null && !isSymbol(computed) &&
	              (retHighest ? (computed <= value) : (computed < value))) {
	            low = mid + 1;
	          } else {
	            high = mid;
	          }
	        }
	        return high;
	      }
	      return baseSortedIndexBy(array, value, identity, retHighest);
	    }
	
	    /**
	     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
	     * which invokes `iteratee` for `value` and each element of `array` to compute
	     * their sort ranking. The iteratee is invoked with one argument; (value).
	     *
	     * @private
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} iteratee The iteratee invoked per element.
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     */
	    function baseSortedIndexBy(array, value, iteratee, retHighest) {
	      var low = 0,
	          high = array == null ? 0 : array.length;
	      if (high === 0) {
	        return 0;
	      }
	
	      value = iteratee(value);
	      var valIsNaN = value !== value,
	          valIsNull = value === null,
	          valIsSymbol = isSymbol(value),
	          valIsUndefined = value === undefined;
	
	      while (low < high) {
	        var mid = nativeFloor((low + high) / 2),
	            computed = iteratee(array[mid]),
	            othIsDefined = computed !== undefined,
	            othIsNull = computed === null,
	            othIsReflexive = computed === computed,
	            othIsSymbol = isSymbol(computed);
	
	        if (valIsNaN) {
	          var setLow = retHighest || othIsReflexive;
	        } else if (valIsUndefined) {
	          setLow = othIsReflexive && (retHighest || othIsDefined);
	        } else if (valIsNull) {
	          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
	        } else if (valIsSymbol) {
	          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
	        } else if (othIsNull || othIsSymbol) {
	          setLow = false;
	        } else {
	          setLow = retHighest ? (computed <= value) : (computed < value);
	        }
	        if (setLow) {
	          low = mid + 1;
	        } else {
	          high = mid;
	        }
	      }
	      return nativeMin(high, MAX_ARRAY_INDEX);
	    }
	
	    /**
	     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
	     * support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     */
	    function baseSortedUniq(array, iteratee) {
	      var index = -1,
	          length = array.length,
	          resIndex = 0,
	          result = [];
	
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        if (!index || !eq(computed, seen)) {
	          var seen = computed;
	          result[resIndex++] = value === 0 ? 0 : value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.toNumber` which doesn't ensure correct
	     * conversions of binary, hexadecimal, or octal string values.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {number} Returns the number.
	     */
	    function baseToNumber(value) {
	      if (typeof value == 'number') {
	        return value;
	      }
	      if (isSymbol(value)) {
	        return NAN;
	      }
	      return +value;
	    }
	
	    /**
	     * The base implementation of `_.toString` which doesn't convert nullish
	     * values to empty strings.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {string} Returns the string.
	     */
	    function baseToString(value) {
	      // Exit early for strings to avoid a performance hit in some environments.
	      if (typeof value == 'string') {
	        return value;
	      }
	      if (isArray(value)) {
	        // Recursively convert values (susceptible to call stack limits).
	        return arrayMap(value, baseToString) + '';
	      }
	      if (isSymbol(value)) {
	        return symbolToString ? symbolToString.call(value) : '';
	      }
	      var result = (value + '');
	      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	    }
	
	    /**
	     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     */
	    function baseUniq(array, iteratee, comparator) {
	      var index = -1,
	          includes = arrayIncludes,
	          length = array.length,
	          isCommon = true,
	          result = [],
	          seen = result;
	
	      if (comparator) {
	        isCommon = false;
	        includes = arrayIncludesWith;
	      }
	      else if (length >= LARGE_ARRAY_SIZE) {
	        var set = iteratee ? null : createSet(array);
	        if (set) {
	          return setToArray(set);
	        }
	        isCommon = false;
	        includes = cacheHas;
	        seen = new SetCache;
	      }
	      else {
	        seen = iteratee ? [] : result;
	      }
	      outer:
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        value = (comparator || value !== 0) ? value : 0;
	        if (isCommon && computed === computed) {
	          var seenIndex = seen.length;
	          while (seenIndex--) {
	            if (seen[seenIndex] === computed) {
	              continue outer;
	            }
	          }
	          if (iteratee) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	        else if (!includes(seen, computed, comparator)) {
	          if (seen !== result) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.unset`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The property path to unset.
	     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
	     */
	    function baseUnset(object, path) {
	      path = castPath(path, object);
	      object = parent(object, path);
	      return object == null || delete object[toKey(last(path))];
	    }
	
	    /**
	     * The base implementation of `_.update`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to update.
	     * @param {Function} updater The function to produce the updated value.
	     * @param {Function} [customizer] The function to customize path creation.
	     * @returns {Object} Returns `object`.
	     */
	    function baseUpdate(object, path, updater, customizer) {
	      return baseSet(object, path, updater(baseGet(object, path)), customizer);
	    }
	
	    /**
	     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
	     * without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to query.
	     * @param {Function} predicate The function invoked per iteration.
	     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function baseWhile(array, predicate, isDrop, fromRight) {
	      var length = array.length,
	          index = fromRight ? length : -1;
	
	      while ((fromRight ? index-- : ++index < length) &&
	        predicate(array[index], index, array)) {}
	
	      return isDrop
	        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
	        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
	    }
	
	    /**
	     * The base implementation of `wrapperValue` which returns the result of
	     * performing a sequence of actions on the unwrapped `value`, where each
	     * successive action is supplied the return value of the previous.
	     *
	     * @private
	     * @param {*} value The unwrapped value.
	     * @param {Array} actions Actions to perform to resolve the unwrapped value.
	     * @returns {*} Returns the resolved value.
	     */
	    function baseWrapperValue(value, actions) {
	      var result = value;
	      if (result instanceof LazyWrapper) {
	        result = result.value();
	      }
	      return arrayReduce(actions, function(result, action) {
	        return action.func.apply(action.thisArg, arrayPush([result], action.args));
	      }, result);
	    }
	
	    /**
	     * The base implementation of methods like `_.xor`, without support for
	     * iteratee shorthands, that accepts an array of arrays to inspect.
	     *
	     * @private
	     * @param {Array} arrays The arrays to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of values.
	     */
	    function baseXor(arrays, iteratee, comparator) {
	      var length = arrays.length;
	      if (length < 2) {
	        return length ? baseUniq(arrays[0]) : [];
	      }
	      var index = -1,
	          result = Array(length);
	
	      while (++index < length) {
	        var array = arrays[index],
	            othIndex = -1;
	
	        while (++othIndex < length) {
	          if (othIndex != index) {
	            result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
	          }
	        }
	      }
	      return baseUniq(baseFlatten(result, 1), iteratee, comparator);
	    }
	
	    /**
	     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
	     *
	     * @private
	     * @param {Array} props The property identifiers.
	     * @param {Array} values The property values.
	     * @param {Function} assignFunc The function to assign values.
	     * @returns {Object} Returns the new object.
	     */
	    function baseZipObject(props, values, assignFunc) {
	      var index = -1,
	          length = props.length,
	          valsLength = values.length,
	          result = {};
	
	      while (++index < length) {
	        var value = index < valsLength ? values[index] : undefined;
	        assignFunc(result, props[index], value);
	      }
	      return result;
	    }
	
	    /**
	     * Casts `value` to an empty array if it's not an array like object.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {Array|Object} Returns the cast array-like object.
	     */
	    function castArrayLikeObject(value) {
	      return isArrayLikeObject(value) ? value : [];
	    }
	
	    /**
	     * Casts `value` to `identity` if it's not a function.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {Function} Returns cast function.
	     */
	    function castFunction(value) {
	      return typeof value == 'function' ? value : identity;
	    }
	
	    /**
	     * Casts `value` to a path array if it's not one.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @param {Object} [object] The object to query keys on.
	     * @returns {Array} Returns the cast property path array.
	     */
	    function castPath(value, object) {
	      if (isArray(value)) {
	        return value;
	      }
	      return isKey(value, object) ? [value] : stringToPath(toString(value));
	    }
	
	    /**
	     * A `baseRest` alias which can be replaced with `identity` by module
	     * replacement plugins.
	     *
	     * @private
	     * @type {Function}
	     * @param {Function} func The function to apply a rest parameter to.
	     * @returns {Function} Returns the new function.
	     */
	    var castRest = baseRest;
	
	    /**
	     * Casts `array` to a slice if it's needed.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {number} start The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the cast slice.
	     */
	    function castSlice(array, start, end) {
	      var length = array.length;
	      end = end === undefined ? length : end;
	      return (!start && end >= length) ? array : baseSlice(array, start, end);
	    }
	
	    /**
	     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
	     *
	     * @private
	     * @param {number|Object} id The timer id or timeout object of the timer to clear.
	     */
	    var clearTimeout = ctxClearTimeout || function(id) {
	      return root.clearTimeout(id);
	    };
	
	    /**
	     * Creates a clone of  `buffer`.
	     *
	     * @private
	     * @param {Buffer} buffer The buffer to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Buffer} Returns the cloned buffer.
	     */
	    function cloneBuffer(buffer, isDeep) {
	      if (isDeep) {
	        return buffer.slice();
	      }
	      var length = buffer.length,
	          result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
	
	      buffer.copy(result);
	      return result;
	    }
	
	    /**
	     * Creates a clone of `arrayBuffer`.
	     *
	     * @private
	     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
	     * @returns {ArrayBuffer} Returns the cloned array buffer.
	     */
	    function cloneArrayBuffer(arrayBuffer) {
	      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
	      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
	      return result;
	    }
	
	    /**
	     * Creates a clone of `dataView`.
	     *
	     * @private
	     * @param {Object} dataView The data view to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned data view.
	     */
	    function cloneDataView(dataView, isDeep) {
	      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
	      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
	    }
	
	    /**
	     * Creates a clone of `regexp`.
	     *
	     * @private
	     * @param {Object} regexp The regexp to clone.
	     * @returns {Object} Returns the cloned regexp.
	     */
	    function cloneRegExp(regexp) {
	      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
	      result.lastIndex = regexp.lastIndex;
	      return result;
	    }
	
	    /**
	     * Creates a clone of the `symbol` object.
	     *
	     * @private
	     * @param {Object} symbol The symbol object to clone.
	     * @returns {Object} Returns the cloned symbol object.
	     */
	    function cloneSymbol(symbol) {
	      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
	    }
	
	    /**
	     * Creates a clone of `typedArray`.
	     *
	     * @private
	     * @param {Object} typedArray The typed array to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned typed array.
	     */
	    function cloneTypedArray(typedArray, isDeep) {
	      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
	      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
	    }
	
	    /**
	     * Compares values to sort them in ascending order.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {number} Returns the sort order indicator for `value`.
	     */
	    function compareAscending(value, other) {
	      if (value !== other) {
	        var valIsDefined = value !== undefined,
	            valIsNull = value === null,
	            valIsReflexive = value === value,
	            valIsSymbol = isSymbol(value);
	
	        var othIsDefined = other !== undefined,
	            othIsNull = other === null,
	            othIsReflexive = other === other,
	            othIsSymbol = isSymbol(other);
	
	        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
	            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
	            (valIsNull && othIsDefined && othIsReflexive) ||
	            (!valIsDefined && othIsReflexive) ||
	            !valIsReflexive) {
	          return 1;
	        }
	        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
	            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
	            (othIsNull && valIsDefined && valIsReflexive) ||
	            (!othIsDefined && valIsReflexive) ||
	            !othIsReflexive) {
	          return -1;
	        }
	      }
	      return 0;
	    }
	
	    /**
	     * Used by `_.orderBy` to compare multiple properties of a value to another
	     * and stable sort them.
	     *
	     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
	     * specify an order of "desc" for descending or "asc" for ascending sort order
	     * of corresponding values.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {boolean[]|string[]} orders The order to sort by for each property.
	     * @returns {number} Returns the sort order indicator for `object`.
	     */
	    function compareMultiple(object, other, orders) {
	      var index = -1,
	          objCriteria = object.criteria,
	          othCriteria = other.criteria,
	          length = objCriteria.length,
	          ordersLength = orders.length;
	
	      while (++index < length) {
	        var result = compareAscending(objCriteria[index], othCriteria[index]);
	        if (result) {
	          if (index >= ordersLength) {
	            return result;
	          }
	          var order = orders[index];
	          return result * (order == 'desc' ? -1 : 1);
	        }
	      }
	      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
	      // that causes it, under certain circumstances, to provide the same value for
	      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
	      // for more details.
	      //
	      // This also ensures a stable sort in V8 and other engines.
	      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
	      return object.index - other.index;
	    }
	
	    /**
	     * Creates an array that is the composition of partially applied arguments,
	     * placeholders, and provided arguments into a single array of arguments.
	     *
	     * @private
	     * @param {Array} args The provided arguments.
	     * @param {Array} partials The arguments to prepend to those provided.
	     * @param {Array} holders The `partials` placeholder indexes.
	     * @params {boolean} [isCurried] Specify composing for a curried function.
	     * @returns {Array} Returns the new array of composed arguments.
	     */
	    function composeArgs(args, partials, holders, isCurried) {
	      var argsIndex = -1,
	          argsLength = args.length,
	          holdersLength = holders.length,
	          leftIndex = -1,
	          leftLength = partials.length,
	          rangeLength = nativeMax(argsLength - holdersLength, 0),
	          result = Array(leftLength + rangeLength),
	          isUncurried = !isCurried;
	
	      while (++leftIndex < leftLength) {
	        result[leftIndex] = partials[leftIndex];
	      }
	      while (++argsIndex < holdersLength) {
	        if (isUncurried || argsIndex < argsLength) {
	          result[holders[argsIndex]] = args[argsIndex];
	        }
	      }
	      while (rangeLength--) {
	        result[leftIndex++] = args[argsIndex++];
	      }
	      return result;
	    }
	
	    /**
	     * This function is like `composeArgs` except that the arguments composition
	     * is tailored for `_.partialRight`.
	     *
	     * @private
	     * @param {Array} args The provided arguments.
	     * @param {Array} partials The arguments to append to those provided.
	     * @param {Array} holders The `partials` placeholder indexes.
	     * @params {boolean} [isCurried] Specify composing for a curried function.
	     * @returns {Array} Returns the new array of composed arguments.
	     */
	    function composeArgsRight(args, partials, holders, isCurried) {
	      var argsIndex = -1,
	          argsLength = args.length,
	          holdersIndex = -1,
	          holdersLength = holders.length,
	          rightIndex = -1,
	          rightLength = partials.length,
	          rangeLength = nativeMax(argsLength - holdersLength, 0),
	          result = Array(rangeLength + rightLength),
	          isUncurried = !isCurried;
	
	      while (++argsIndex < rangeLength) {
	        result[argsIndex] = args[argsIndex];
	      }
	      var offset = argsIndex;
	      while (++rightIndex < rightLength) {
	        result[offset + rightIndex] = partials[rightIndex];
	      }
	      while (++holdersIndex < holdersLength) {
	        if (isUncurried || argsIndex < argsLength) {
	          result[offset + holders[holdersIndex]] = args[argsIndex++];
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Copies the values of `source` to `array`.
	     *
	     * @private
	     * @param {Array} source The array to copy values from.
	     * @param {Array} [array=[]] The array to copy values to.
	     * @returns {Array} Returns `array`.
	     */
	    function copyArray(source, array) {
	      var index = -1,
	          length = source.length;
	
	      array || (array = Array(length));
	      while (++index < length) {
	        array[index] = source[index];
	      }
	      return array;
	    }
	
	    /**
	     * Copies properties of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy properties from.
	     * @param {Array} props The property identifiers to copy.
	     * @param {Object} [object={}] The object to copy properties to.
	     * @param {Function} [customizer] The function to customize copied values.
	     * @returns {Object} Returns `object`.
	     */
	    function copyObject(source, props, object, customizer) {
	      var isNew = !object;
	      object || (object = {});
	
	      var index = -1,
	          length = props.length;
	
	      while (++index < length) {
	        var key = props[index];
	
	        var newValue = customizer
	          ? customizer(object[key], source[key], key, object, source)
	          : undefined;
	
	        if (newValue === undefined) {
	          newValue = source[key];
	        }
	        if (isNew) {
	          baseAssignValue(object, key, newValue);
	        } else {
	          assignValue(object, key, newValue);
	        }
	      }
	      return object;
	    }
	
	    /**
	     * Copies own symbols of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy symbols from.
	     * @param {Object} [object={}] The object to copy symbols to.
	     * @returns {Object} Returns `object`.
	     */
	    function copySymbols(source, object) {
	      return copyObject(source, getSymbols(source), object);
	    }
	
	    /**
	     * Copies own and inherited symbols of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy symbols from.
	     * @param {Object} [object={}] The object to copy symbols to.
	     * @returns {Object} Returns `object`.
	     */
	    function copySymbolsIn(source, object) {
	      return copyObject(source, getSymbolsIn(source), object);
	    }
	
	    /**
	     * Creates a function like `_.groupBy`.
	     *
	     * @private
	     * @param {Function} setter The function to set accumulator values.
	     * @param {Function} [initializer] The accumulator object initializer.
	     * @returns {Function} Returns the new aggregator function.
	     */
	    function createAggregator(setter, initializer) {
	      return function(collection, iteratee) {
	        var func = isArray(collection) ? arrayAggregator : baseAggregator,
	            accumulator = initializer ? initializer() : {};
	
	        return func(collection, setter, getIteratee(iteratee, 2), accumulator);
	      };
	    }
	
	    /**
	     * Creates a function like `_.assign`.
	     *
	     * @private
	     * @param {Function} assigner The function to assign values.
	     * @returns {Function} Returns the new assigner function.
	     */
	    function createAssigner(assigner) {
	      return baseRest(function(object, sources) {
	        var index = -1,
	            length = sources.length,
	            customizer = length > 1 ? sources[length - 1] : undefined,
	            guard = length > 2 ? sources[2] : undefined;
	
	        customizer = (assigner.length > 3 && typeof customizer == 'function')
	          ? (length--, customizer)
	          : undefined;
	
	        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	          customizer = length < 3 ? undefined : customizer;
	          length = 1;
	        }
	        object = Object(object);
	        while (++index < length) {
	          var source = sources[index];
	          if (source) {
	            assigner(object, source, index, customizer);
	          }
	        }
	        return object;
	      });
	    }
	
	    /**
	     * Creates a `baseEach` or `baseEachRight` function.
	     *
	     * @private
	     * @param {Function} eachFunc The function to iterate over a collection.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new base function.
	     */
	    function createBaseEach(eachFunc, fromRight) {
	      return function(collection, iteratee) {
	        if (collection == null) {
	          return collection;
	        }
	        if (!isArrayLike(collection)) {
	          return eachFunc(collection, iteratee);
	        }
	        var length = collection.length,
	            index = fromRight ? length : -1,
	            iterable = Object(collection);
	
	        while ((fromRight ? index-- : ++index < length)) {
	          if (iteratee(iterable[index], index, iterable) === false) {
	            break;
	          }
	        }
	        return collection;
	      };
	    }
	
	    /**
	     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new base function.
	     */
	    function createBaseFor(fromRight) {
	      return function(object, iteratee, keysFunc) {
	        var index = -1,
	            iterable = Object(object),
	            props = keysFunc(object),
	            length = props.length;
	
	        while (length--) {
	          var key = props[fromRight ? length : ++index];
	          if (iteratee(iterable[key], key, iterable) === false) {
	            break;
	          }
	        }
	        return object;
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with the optional `this`
	     * binding of `thisArg`.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createBind(func, bitmask, thisArg) {
	      var isBind = bitmask & WRAP_BIND_FLAG,
	          Ctor = createCtor(func);
	
	      function wrapper() {
	        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	        return fn.apply(isBind ? thisArg : this, arguments);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a function like `_.lowerFirst`.
	     *
	     * @private
	     * @param {string} methodName The name of the `String` case method to use.
	     * @returns {Function} Returns the new case function.
	     */
	    function createCaseFirst(methodName) {
	      return function(string) {
	        string = toString(string);
	
	        var strSymbols = hasUnicode(string)
	          ? stringToArray(string)
	          : undefined;
	
	        var chr = strSymbols
	          ? strSymbols[0]
	          : string.charAt(0);
	
	        var trailing = strSymbols
	          ? castSlice(strSymbols, 1).join('')
	          : string.slice(1);
	
	        return chr[methodName]() + trailing;
	      };
	    }
	
	    /**
	     * Creates a function like `_.camelCase`.
	     *
	     * @private
	     * @param {Function} callback The function to combine each word.
	     * @returns {Function} Returns the new compounder function.
	     */
	    function createCompounder(callback) {
	      return function(string) {
	        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
	      };
	    }
	
	    /**
	     * Creates a function that produces an instance of `Ctor` regardless of
	     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
	     *
	     * @private
	     * @param {Function} Ctor The constructor to wrap.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createCtor(Ctor) {
	      return function() {
	        // Use a `switch` statement to work with class constructors. See
	        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
	        // for more details.
	        var args = arguments;
	        switch (args.length) {
	          case 0: return new Ctor;
	          case 1: return new Ctor(args[0]);
	          case 2: return new Ctor(args[0], args[1]);
	          case 3: return new Ctor(args[0], args[1], args[2]);
	          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
	          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
	          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
	          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
	        }
	        var thisBinding = baseCreate(Ctor.prototype),
	            result = Ctor.apply(thisBinding, args);
	
	        // Mimic the constructor's `return` behavior.
	        // See https://es5.github.io/#x13.2.2 for more details.
	        return isObject(result) ? result : thisBinding;
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to enable currying.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {number} arity The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createCurry(func, bitmask, arity) {
	      var Ctor = createCtor(func);
	
	      function wrapper() {
	        var length = arguments.length,
	            args = Array(length),
	            index = length,
	            placeholder = getHolder(wrapper);
	
	        while (index--) {
	          args[index] = arguments[index];
	        }
	        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
	          ? []
	          : replaceHolders(args, placeholder);
	
	        length -= holders.length;
	        if (length < arity) {
	          return createRecurry(
	            func, bitmask, createHybrid, wrapper.placeholder, undefined,
	            args, holders, undefined, undefined, arity - length);
	        }
	        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	        return apply(fn, this, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a `_.find` or `_.findLast` function.
	     *
	     * @private
	     * @param {Function} findIndexFunc The function to find the collection index.
	     * @returns {Function} Returns the new find function.
	     */
	    function createFind(findIndexFunc) {
	      return function(collection, predicate, fromIndex) {
	        var iterable = Object(collection);
	        if (!isArrayLike(collection)) {
	          var iteratee = getIteratee(predicate, 3);
	          collection = keys(collection);
	          predicate = function(key) { return iteratee(iterable[key], key, iterable); };
	        }
	        var index = findIndexFunc(collection, predicate, fromIndex);
	        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
	      };
	    }
	
	    /**
	     * Creates a `_.flow` or `_.flowRight` function.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new flow function.
	     */
	    function createFlow(fromRight) {
	      return flatRest(function(funcs) {
	        var length = funcs.length,
	            index = length,
	            prereq = LodashWrapper.prototype.thru;
	
	        if (fromRight) {
	          funcs.reverse();
	        }
	        while (index--) {
	          var func = funcs[index];
	          if (typeof func != 'function') {
	            throw new TypeError(FUNC_ERROR_TEXT);
	          }
	          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
	            var wrapper = new LodashWrapper([], true);
	          }
	        }
	        index = wrapper ? index : length;
	        while (++index < length) {
	          func = funcs[index];
	
	          var funcName = getFuncName(func),
	              data = funcName == 'wrapper' ? getData(func) : undefined;
	
	          if (data && isLaziable(data[0]) &&
	                data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
	                !data[4].length && data[9] == 1
	              ) {
	            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
	          } else {
	            wrapper = (func.length == 1 && isLaziable(func))
	              ? wrapper[funcName]()
	              : wrapper.thru(func);
	          }
	        }
	        return function() {
	          var args = arguments,
	              value = args[0];
	
	          if (wrapper && args.length == 1 && isArray(value)) {
	            return wrapper.plant(value).value();
	          }
	          var index = 0,
	              result = length ? funcs[index].apply(this, args) : value;
	
	          while (++index < length) {
	            result = funcs[index].call(this, result);
	          }
	          return result;
	        };
	      });
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with optional `this`
	     * binding of `thisArg`, partial application, and currying.
	     *
	     * @private
	     * @param {Function|string} func The function or method name to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to prepend to those provided to
	     *  the new function.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [partialsRight] The arguments to append to those provided
	     *  to the new function.
	     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
	      var isAry = bitmask & WRAP_ARY_FLAG,
	          isBind = bitmask & WRAP_BIND_FLAG,
	          isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
	          isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
	          isFlip = bitmask & WRAP_FLIP_FLAG,
	          Ctor = isBindKey ? undefined : createCtor(func);
	
	      function wrapper() {
	        var length = arguments.length,
	            args = Array(length),
	            index = length;
	
	        while (index--) {
	          args[index] = arguments[index];
	        }
	        if (isCurried) {
	          var placeholder = getHolder(wrapper),
	              holdersCount = countHolders(args, placeholder);
	        }
	        if (partials) {
	          args = composeArgs(args, partials, holders, isCurried);
	        }
	        if (partialsRight) {
	          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
	        }
	        length -= holdersCount;
	        if (isCurried && length < arity) {
	          var newHolders = replaceHolders(args, placeholder);
	          return createRecurry(
	            func, bitmask, createHybrid, wrapper.placeholder, thisArg,
	            args, newHolders, argPos, ary, arity - length
	          );
	        }
	        var thisBinding = isBind ? thisArg : this,
	            fn = isBindKey ? thisBinding[func] : func;
	
	        length = args.length;
	        if (argPos) {
	          args = reorder(args, argPos);
	        } else if (isFlip && length > 1) {
	          args.reverse();
	        }
	        if (isAry && ary < length) {
	          args.length = ary;
	        }
	        if (this && this !== root && this instanceof wrapper) {
	          fn = Ctor || createCtor(fn);
	        }
	        return fn.apply(thisBinding, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a function like `_.invertBy`.
	     *
	     * @private
	     * @param {Function} setter The function to set accumulator values.
	     * @param {Function} toIteratee The function to resolve iteratees.
	     * @returns {Function} Returns the new inverter function.
	     */
	    function createInverter(setter, toIteratee) {
	      return function(object, iteratee) {
	        return baseInverter(object, setter, toIteratee(iteratee), {});
	      };
	    }
	
	    /**
	     * Creates a function that performs a mathematical operation on two values.
	     *
	     * @private
	     * @param {Function} operator The function to perform the operation.
	     * @param {number} [defaultValue] The value used for `undefined` arguments.
	     * @returns {Function} Returns the new mathematical operation function.
	     */
	    function createMathOperation(operator, defaultValue) {
	      return function(value, other) {
	        var result;
	        if (value === undefined && other === undefined) {
	          return defaultValue;
	        }
	        if (value !== undefined) {
	          result = value;
	        }
	        if (other !== undefined) {
	          if (result === undefined) {
	            return other;
	          }
	          if (typeof value == 'string' || typeof other == 'string') {
	            value = baseToString(value);
	            other = baseToString(other);
	          } else {
	            value = baseToNumber(value);
	            other = baseToNumber(other);
	          }
	          result = operator(value, other);
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Creates a function like `_.over`.
	     *
	     * @private
	     * @param {Function} arrayFunc The function to iterate over iteratees.
	     * @returns {Function} Returns the new over function.
	     */
	    function createOver(arrayFunc) {
	      return flatRest(function(iteratees) {
	        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
	        return baseRest(function(args) {
	          var thisArg = this;
	          return arrayFunc(iteratees, function(iteratee) {
	            return apply(iteratee, thisArg, args);
	          });
	        });
	      });
	    }
	
	    /**
	     * Creates the padding for `string` based on `length`. The `chars` string
	     * is truncated if the number of characters exceeds `length`.
	     *
	     * @private
	     * @param {number} length The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padding for `string`.
	     */
	    function createPadding(length, chars) {
	      chars = chars === undefined ? ' ' : baseToString(chars);
	
	      var charsLength = chars.length;
	      if (charsLength < 2) {
	        return charsLength ? baseRepeat(chars, length) : chars;
	      }
	      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
	      return hasUnicode(chars)
	        ? castSlice(stringToArray(result), 0, length).join('')
	        : result.slice(0, length);
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with the `this` binding
	     * of `thisArg` and `partials` prepended to the arguments it receives.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {Array} partials The arguments to prepend to those provided to
	     *  the new function.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createPartial(func, bitmask, thisArg, partials) {
	      var isBind = bitmask & WRAP_BIND_FLAG,
	          Ctor = createCtor(func);
	
	      function wrapper() {
	        var argsIndex = -1,
	            argsLength = arguments.length,
	            leftIndex = -1,
	            leftLength = partials.length,
	            args = Array(leftLength + argsLength),
	            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	
	        while (++leftIndex < leftLength) {
	          args[leftIndex] = partials[leftIndex];
	        }
	        while (argsLength--) {
	          args[leftIndex++] = arguments[++argsIndex];
	        }
	        return apply(fn, isBind ? thisArg : this, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a `_.range` or `_.rangeRight` function.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new range function.
	     */
	    function createRange(fromRight) {
	      return function(start, end, step) {
	        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
	          end = step = undefined;
	        }
	        // Ensure the sign of `-0` is preserved.
	        start = toFinite(start);
	        if (end === undefined) {
	          end = start;
	          start = 0;
	        } else {
	          end = toFinite(end);
	        }
	        step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
	        return baseRange(start, end, step, fromRight);
	      };
	    }
	
	    /**
	     * Creates a function that performs a relational operation on two values.
	     *
	     * @private
	     * @param {Function} operator The function to perform the operation.
	     * @returns {Function} Returns the new relational operation function.
	     */
	    function createRelationalOperation(operator) {
	      return function(value, other) {
	        if (!(typeof value == 'string' && typeof other == 'string')) {
	          value = toNumber(value);
	          other = toNumber(other);
	        }
	        return operator(value, other);
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to continue currying.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {Function} wrapFunc The function to create the `func` wrapper.
	     * @param {*} placeholder The placeholder value.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to prepend to those provided to
	     *  the new function.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
	      var isCurry = bitmask & WRAP_CURRY_FLAG,
	          newHolders = isCurry ? holders : undefined,
	          newHoldersRight = isCurry ? undefined : holders,
	          newPartials = isCurry ? partials : undefined,
	          newPartialsRight = isCurry ? undefined : partials;
	
	      bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
	      bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
	
	      if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
	        bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
	      }
	      var newData = [
	        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
	        newHoldersRight, argPos, ary, arity
	      ];
	
	      var result = wrapFunc.apply(undefined, newData);
	      if (isLaziable(func)) {
	        setData(result, newData);
	      }
	      result.placeholder = placeholder;
	      return setWrapToString(result, func, bitmask);
	    }
	
	    /**
	     * Creates a function like `_.round`.
	     *
	     * @private
	     * @param {string} methodName The name of the `Math` method to use when rounding.
	     * @returns {Function} Returns the new round function.
	     */
	    function createRound(methodName) {
	      var func = Math[methodName];
	      return function(number, precision) {
	        number = toNumber(number);
	        precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
	        if (precision && nativeIsFinite(number)) {
	          // Shift with exponential notation to avoid floating-point issues.
	          // See [MDN](https://mdn.io/round#Examples) for more details.
	          var pair = (toString(number) + 'e').split('e'),
	              value = func(pair[0] + 'e' + (+pair[1] + precision));
	
	          pair = (toString(value) + 'e').split('e');
	          return +(pair[0] + 'e' + (+pair[1] - precision));
	        }
	        return func(number);
	      };
	    }
	
	    /**
	     * Creates a set object of `values`.
	     *
	     * @private
	     * @param {Array} values The values to add to the set.
	     * @returns {Object} Returns the new set.
	     */
	    var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
	      return new Set(values);
	    };
	
	    /**
	     * Creates a `_.toPairs` or `_.toPairsIn` function.
	     *
	     * @private
	     * @param {Function} keysFunc The function to get the keys of a given object.
	     * @returns {Function} Returns the new pairs function.
	     */
	    function createToPairs(keysFunc) {
	      return function(object) {
	        var tag = getTag(object);
	        if (tag == mapTag) {
	          return mapToArray(object);
	        }
	        if (tag == setTag) {
	          return setToPairs(object);
	        }
	        return baseToPairs(object, keysFunc(object));
	      };
	    }
	
	    /**
	     * Creates a function that either curries or invokes `func` with optional
	     * `this` binding and partially applied arguments.
	     *
	     * @private
	     * @param {Function|string} func The function or method name to wrap.
	     * @param {number} bitmask The bitmask flags.
	     *    1 - `_.bind`
	     *    2 - `_.bindKey`
	     *    4 - `_.curry` or `_.curryRight` of a bound function
	     *    8 - `_.curry`
	     *   16 - `_.curryRight`
	     *   32 - `_.partial`
	     *   64 - `_.partialRight`
	     *  128 - `_.rearg`
	     *  256 - `_.ary`
	     *  512 - `_.flip`
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to be partially applied.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
	      var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
	      if (!isBindKey && typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var length = partials ? partials.length : 0;
	      if (!length) {
	        bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
	        partials = holders = undefined;
	      }
	      ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
	      arity = arity === undefined ? arity : toInteger(arity);
	      length -= holders ? holders.length : 0;
	
	      if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
	        var partialsRight = partials,
	            holdersRight = holders;
	
	        partials = holders = undefined;
	      }
	      var data = isBindKey ? undefined : getData(func);
	
	      var newData = [
	        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
	        argPos, ary, arity
	      ];
	
	      if (data) {
	        mergeData(newData, data);
	      }
	      func = newData[0];
	      bitmask = newData[1];
	      thisArg = newData[2];
	      partials = newData[3];
	      holders = newData[4];
	      arity = newData[9] = newData[9] === undefined
	        ? (isBindKey ? 0 : func.length)
	        : nativeMax(newData[9] - length, 0);
	
	      if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
	        bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
	      }
	      if (!bitmask || bitmask == WRAP_BIND_FLAG) {
	        var result = createBind(func, bitmask, thisArg);
	      } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
	        result = createCurry(func, bitmask, arity);
	      } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
	        result = createPartial(func, bitmask, thisArg, partials);
	      } else {
	        result = createHybrid.apply(undefined, newData);
	      }
	      var setter = data ? baseSetData : setData;
	      return setWrapToString(setter(result, newData), func, bitmask);
	    }
	
	    /**
	     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
	     * of source objects to the destination object for all destination properties
	     * that resolve to `undefined`.
	     *
	     * @private
	     * @param {*} objValue The destination value.
	     * @param {*} srcValue The source value.
	     * @param {string} key The key of the property to assign.
	     * @param {Object} object The parent object of `objValue`.
	     * @returns {*} Returns the value to assign.
	     */
	    function customDefaultsAssignIn(objValue, srcValue, key, object) {
	      if (objValue === undefined ||
	          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
	        return srcValue;
	      }
	      return objValue;
	    }
	
	    /**
	     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
	     * objects into destination objects that are passed thru.
	     *
	     * @private
	     * @param {*} objValue The destination value.
	     * @param {*} srcValue The source value.
	     * @param {string} key The key of the property to merge.
	     * @param {Object} object The parent object of `objValue`.
	     * @param {Object} source The parent object of `srcValue`.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     * @returns {*} Returns the value to assign.
	     */
	    function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
	      if (isObject(objValue) && isObject(srcValue)) {
	        // Recursively merge objects and arrays (susceptible to call stack limits).
	        stack.set(srcValue, objValue);
	        baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
	        stack['delete'](srcValue);
	      }
	      return objValue;
	    }
	
	    /**
	     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
	     * objects.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @param {string} key The key of the property to inspect.
	     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
	     */
	    function customOmitClone(value) {
	      return isPlainObject(value) ? undefined : value;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for arrays with support for
	     * partial deep comparisons.
	     *
	     * @private
	     * @param {Array} array The array to compare.
	     * @param {Array} other The other array to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `array` and `other` objects.
	     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	     */
	    function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	          arrLength = array.length,
	          othLength = other.length;
	
	      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
	        return false;
	      }
	      // Check that cyclic values are equal.
	      var arrStacked = stack.get(array);
	      var othStacked = stack.get(other);
	      if (arrStacked && othStacked) {
	        return arrStacked == other && othStacked == array;
	      }
	      var index = -1,
	          result = true,
	          seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;
	
	      stack.set(array, other);
	      stack.set(other, array);
	
	      // Ignore non-index properties.
	      while (++index < arrLength) {
	        var arrValue = array[index],
	            othValue = other[index];
	
	        if (customizer) {
	          var compared = isPartial
	            ? customizer(othValue, arrValue, index, other, array, stack)
	            : customizer(arrValue, othValue, index, array, other, stack);
	        }
	        if (compared !== undefined) {
	          if (compared) {
	            continue;
	          }
	          result = false;
	          break;
	        }
	        // Recursively compare arrays (susceptible to call stack limits).
	        if (seen) {
	          if (!arraySome(other, function(othValue, othIndex) {
	                if (!cacheHas(seen, othIndex) &&
	                    (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
	                  return seen.push(othIndex);
	                }
	              })) {
	            result = false;
	            break;
	          }
	        } else if (!(
	              arrValue === othValue ||
	                equalFunc(arrValue, othValue, bitmask, customizer, stack)
	            )) {
	          result = false;
	          break;
	        }
	      }
	      stack['delete'](array);
	      stack['delete'](other);
	      return result;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for comparing objects of
	     * the same `toStringTag`.
	     *
	     * **Note:** This function only supports comparing values with tags of
	     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {string} tag The `toStringTag` of the objects to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
	      switch (tag) {
	        case dataViewTag:
	          if ((object.byteLength != other.byteLength) ||
	              (object.byteOffset != other.byteOffset)) {
	            return false;
	          }
	          object = object.buffer;
	          other = other.buffer;
	
	        case arrayBufferTag:
	          if ((object.byteLength != other.byteLength) ||
	              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
	            return false;
	          }
	          return true;
	
	        case boolTag:
	        case dateTag:
	        case numberTag:
	          // Coerce booleans to `1` or `0` and dates to milliseconds.
	          // Invalid dates are coerced to `NaN`.
	          return eq(+object, +other);
	
	        case errorTag:
	          return object.name == other.name && object.message == other.message;
	
	        case regexpTag:
	        case stringTag:
	          // Coerce regexes to strings and treat strings, primitives and objects,
	          // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
	          // for more details.
	          return object == (other + '');
	
	        case mapTag:
	          var convert = mapToArray;
	
	        case setTag:
	          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
	          convert || (convert = setToArray);
	
	          if (object.size != other.size && !isPartial) {
	            return false;
	          }
	          // Assume cyclic values are equal.
	          var stacked = stack.get(object);
	          if (stacked) {
	            return stacked == other;
	          }
	          bitmask |= COMPARE_UNORDERED_FLAG;
	
	          // Recursively compare objects (susceptible to call stack limits).
	          stack.set(object, other);
	          var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
	          stack['delete'](object);
	          return result;
	
	        case symbolTag:
	          if (symbolValueOf) {
	            return symbolValueOf.call(object) == symbolValueOf.call(other);
	          }
	      }
	      return false;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for objects with support for
	     * partial deep comparisons.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	          objProps = getAllKeys(object),
	          objLength = objProps.length,
	          othProps = getAllKeys(other),
	          othLength = othProps.length;
	
	      if (objLength != othLength && !isPartial) {
	        return false;
	      }
	      var index = objLength;
	      while (index--) {
	        var key = objProps[index];
	        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
	          return false;
	        }
	      }
	      // Check that cyclic values are equal.
	      var objStacked = stack.get(object);
	      var othStacked = stack.get(other);
	      if (objStacked && othStacked) {
	        return objStacked == other && othStacked == object;
	      }
	      var result = true;
	      stack.set(object, other);
	      stack.set(other, object);
	
	      var skipCtor = isPartial;
	      while (++index < objLength) {
	        key = objProps[index];
	        var objValue = object[key],
	            othValue = other[key];
	
	        if (customizer) {
	          var compared = isPartial
	            ? customizer(othValue, objValue, key, other, object, stack)
	            : customizer(objValue, othValue, key, object, other, stack);
	        }
	        // Recursively compare objects (susceptible to call stack limits).
	        if (!(compared === undefined
	              ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
	              : compared
	            )) {
	          result = false;
	          break;
	        }
	        skipCtor || (skipCtor = key == 'constructor');
	      }
	      if (result && !skipCtor) {
	        var objCtor = object.constructor,
	            othCtor = other.constructor;
	
	        // Non `Object` object instances with different constructors are not equal.
	        if (objCtor != othCtor &&
	            ('constructor' in object && 'constructor' in other) &&
	            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	          result = false;
	        }
	      }
	      stack['delete'](object);
	      stack['delete'](other);
	      return result;
	    }
	
	    /**
	     * A specialized version of `baseRest` which flattens the rest array.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @returns {Function} Returns the new function.
	     */
	    function flatRest(func) {
	      return setToString(overRest(func, undefined, flatten), func + '');
	    }
	
	    /**
	     * Creates an array of own enumerable property names and symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function getAllKeys(object) {
	      return baseGetAllKeys(object, keys, getSymbols);
	    }
	
	    /**
	     * Creates an array of own and inherited enumerable property names and
	     * symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function getAllKeysIn(object) {
	      return baseGetAllKeys(object, keysIn, getSymbolsIn);
	    }
	
	    /**
	     * Gets metadata for `func`.
	     *
	     * @private
	     * @param {Function} func The function to query.
	     * @returns {*} Returns the metadata for `func`.
	     */
	    var getData = !metaMap ? noop : function(func) {
	      return metaMap.get(func);
	    };
	
	    /**
	     * Gets the name of `func`.
	     *
	     * @private
	     * @param {Function} func The function to query.
	     * @returns {string} Returns the function name.
	     */
	    function getFuncName(func) {
	      var result = (func.name + ''),
	          array = realNames[result],
	          length = hasOwnProperty.call(realNames, result) ? array.length : 0;
	
	      while (length--) {
	        var data = array[length],
	            otherFunc = data.func;
	        if (otherFunc == null || otherFunc == func) {
	          return data.name;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Gets the argument placeholder value for `func`.
	     *
	     * @private
	     * @param {Function} func The function to inspect.
	     * @returns {*} Returns the placeholder value.
	     */
	    function getHolder(func) {
	      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
	      return object.placeholder;
	    }
	
	    /**
	     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
	     * this function returns the custom method, otherwise it returns `baseIteratee`.
	     * If arguments are provided, the chosen function is invoked with them and
	     * its result is returned.
	     *
	     * @private
	     * @param {*} [value] The value to convert to an iteratee.
	     * @param {number} [arity] The arity of the created iteratee.
	     * @returns {Function} Returns the chosen function or its result.
	     */
	    function getIteratee() {
	      var result = lodash.iteratee || iteratee;
	      result = result === iteratee ? baseIteratee : result;
	      return arguments.length ? result(arguments[0], arguments[1]) : result;
	    }
	
	    /**
	     * Gets the data for `map`.
	     *
	     * @private
	     * @param {Object} map The map to query.
	     * @param {string} key The reference key.
	     * @returns {*} Returns the map data.
	     */
	    function getMapData(map, key) {
	      var data = map.__data__;
	      return isKeyable(key)
	        ? data[typeof key == 'string' ? 'string' : 'hash']
	        : data.map;
	    }
	
	    /**
	     * Gets the property names, values, and compare flags of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the match data of `object`.
	     */
	    function getMatchData(object) {
	      var result = keys(object),
	          length = result.length;
	
	      while (length--) {
	        var key = result[length],
	            value = object[key];
	
	        result[length] = [key, value, isStrictComparable(value)];
	      }
	      return result;
	    }
	
	    /**
	     * Gets the native function at `key` of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {string} key The key of the method to get.
	     * @returns {*} Returns the function if it's native, else `undefined`.
	     */
	    function getNative(object, key) {
	      var value = getValue(object, key);
	      return baseIsNative(value) ? value : undefined;
	    }
	
	    /**
	     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the raw `toStringTag`.
	     */
	    function getRawTag(value) {
	      var isOwn = hasOwnProperty.call(value, symToStringTag),
	          tag = value[symToStringTag];
	
	      try {
	        value[symToStringTag] = undefined;
	        var unmasked = true;
	      } catch (e) {}
	
	      var result = nativeObjectToString.call(value);
	      if (unmasked) {
	        if (isOwn) {
	          value[symToStringTag] = tag;
	        } else {
	          delete value[symToStringTag];
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Creates an array of the own enumerable symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of symbols.
	     */
	    var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
	      if (object == null) {
	        return [];
	      }
	      object = Object(object);
	      return arrayFilter(nativeGetSymbols(object), function(symbol) {
	        return propertyIsEnumerable.call(object, symbol);
	      });
	    };
	
	    /**
	     * Creates an array of the own and inherited enumerable symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of symbols.
	     */
	    var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
	      var result = [];
	      while (object) {
	        arrayPush(result, getSymbols(object));
	        object = getPrototype(object);
	      }
	      return result;
	    };
	
	    /**
	     * Gets the `toStringTag` of `value`.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the `toStringTag`.
	     */
	    var getTag = baseGetTag;
	
	    // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
	    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	        (Map && getTag(new Map) != mapTag) ||
	        (Promise && getTag(Promise.resolve()) != promiseTag) ||
	        (Set && getTag(new Set) != setTag) ||
	        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	      getTag = function(value) {
	        var result = baseGetTag(value),
	            Ctor = result == objectTag ? value.constructor : undefined,
	            ctorString = Ctor ? toSource(Ctor) : '';
	
	        if (ctorString) {
	          switch (ctorString) {
	            case dataViewCtorString: return dataViewTag;
	            case mapCtorString: return mapTag;
	            case promiseCtorString: return promiseTag;
	            case setCtorString: return setTag;
	            case weakMapCtorString: return weakMapTag;
	          }
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Gets the view, applying any `transforms` to the `start` and `end` positions.
	     *
	     * @private
	     * @param {number} start The start of the view.
	     * @param {number} end The end of the view.
	     * @param {Array} transforms The transformations to apply to the view.
	     * @returns {Object} Returns an object containing the `start` and `end`
	     *  positions of the view.
	     */
	    function getView(start, end, transforms) {
	      var index = -1,
	          length = transforms.length;
	
	      while (++index < length) {
	        var data = transforms[index],
	            size = data.size;
	
	        switch (data.type) {
	          case 'drop':      start += size; break;
	          case 'dropRight': end -= size; break;
	          case 'take':      end = nativeMin(end, start + size); break;
	          case 'takeRight': start = nativeMax(start, end - size); break;
	        }
	      }
	      return { 'start': start, 'end': end };
	    }
	
	    /**
	     * Extracts wrapper details from the `source` body comment.
	     *
	     * @private
	     * @param {string} source The source to inspect.
	     * @returns {Array} Returns the wrapper details.
	     */
	    function getWrapDetails(source) {
	      var match = source.match(reWrapDetails);
	      return match ? match[1].split(reSplitDetails) : [];
	    }
	
	    /**
	     * Checks if `path` exists on `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @param {Function} hasFunc The function to check properties.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     */
	    function hasPath(object, path, hasFunc) {
	      path = castPath(path, object);
	
	      var index = -1,
	          length = path.length,
	          result = false;
	
	      while (++index < length) {
	        var key = toKey(path[index]);
	        if (!(result = object != null && hasFunc(object, key))) {
	          break;
	        }
	        object = object[key];
	      }
	      if (result || ++index != length) {
	        return result;
	      }
	      length = object == null ? 0 : object.length;
	      return !!length && isLength(length) && isIndex(key, length) &&
	        (isArray(object) || isArguments(object));
	    }
	
	    /**
	     * Initializes an array clone.
	     *
	     * @private
	     * @param {Array} array The array to clone.
	     * @returns {Array} Returns the initialized clone.
	     */
	    function initCloneArray(array) {
	      var length = array.length,
	          result = new array.constructor(length);
	
	      // Add properties assigned by `RegExp#exec`.
	      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
	        result.index = array.index;
	        result.input = array.input;
	      }
	      return result;
	    }
	
	    /**
	     * Initializes an object clone.
	     *
	     * @private
	     * @param {Object} object The object to clone.
	     * @returns {Object} Returns the initialized clone.
	     */
	    function initCloneObject(object) {
	      return (typeof object.constructor == 'function' && !isPrototype(object))
	        ? baseCreate(getPrototype(object))
	        : {};
	    }
	
	    /**
	     * Initializes an object clone based on its `toStringTag`.
	     *
	     * **Note:** This function only supports cloning values with tags of
	     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
	     *
	     * @private
	     * @param {Object} object The object to clone.
	     * @param {string} tag The `toStringTag` of the object to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the initialized clone.
	     */
	    function initCloneByTag(object, tag, isDeep) {
	      var Ctor = object.constructor;
	      switch (tag) {
	        case arrayBufferTag:
	          return cloneArrayBuffer(object);
	
	        case boolTag:
	        case dateTag:
	          return new Ctor(+object);
	
	        case dataViewTag:
	          return cloneDataView(object, isDeep);
	
	        case float32Tag: case float64Tag:
	        case int8Tag: case int16Tag: case int32Tag:
	        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
	          return cloneTypedArray(object, isDeep);
	
	        case mapTag:
	          return new Ctor;
	
	        case numberTag:
	        case stringTag:
	          return new Ctor(object);
	
	        case regexpTag:
	          return cloneRegExp(object);
	
	        case setTag:
	          return new Ctor;
	
	        case symbolTag:
	          return cloneSymbol(object);
	      }
	    }
	
	    /**
	     * Inserts wrapper `details` in a comment at the top of the `source` body.
	     *
	     * @private
	     * @param {string} source The source to modify.
	     * @returns {Array} details The details to insert.
	     * @returns {string} Returns the modified source.
	     */
	    function insertWrapDetails(source, details) {
	      var length = details.length;
	      if (!length) {
	        return source;
	      }
	      var lastIndex = length - 1;
	      details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
	      details = details.join(length > 2 ? ', ' : ' ');
	      return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
	    }
	
	    /**
	     * Checks if `value` is a flattenable `arguments` object or array.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
	     */
	    function isFlattenable(value) {
	      return isArray(value) || isArguments(value) ||
	        !!(spreadableSymbol && value && value[spreadableSymbol]);
	    }
	
	    /**
	     * Checks if `value` is a valid array-like index.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	     */
	    function isIndex(value, length) {
	      var type = typeof value;
	      length = length == null ? MAX_SAFE_INTEGER : length;
	
	      return !!length &&
	        (type == 'number' ||
	          (type != 'symbol' && reIsUint.test(value))) &&
	            (value > -1 && value % 1 == 0 && value < length);
	    }
	
	    /**
	     * Checks if the given arguments are from an iteratee call.
	     *
	     * @private
	     * @param {*} value The potential iteratee value argument.
	     * @param {*} index The potential iteratee index or key argument.
	     * @param {*} object The potential iteratee object argument.
	     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
	     *  else `false`.
	     */
	    function isIterateeCall(value, index, object) {
	      if (!isObject(object)) {
	        return false;
	      }
	      var type = typeof index;
	      if (type == 'number'
	            ? (isArrayLike(object) && isIndex(index, object.length))
	            : (type == 'string' && index in object)
	          ) {
	        return eq(object[index], value);
	      }
	      return false;
	    }
	
	    /**
	     * Checks if `value` is a property name and not a property path.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @param {Object} [object] The object to query keys on.
	     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	     */
	    function isKey(value, object) {
	      if (isArray(value)) {
	        return false;
	      }
	      var type = typeof value;
	      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
	          value == null || isSymbol(value)) {
	        return true;
	      }
	      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
	        (object != null && value in Object(object));
	    }
	
	    /**
	     * Checks if `value` is suitable for use as unique object key.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	     */
	    function isKeyable(value) {
	      var type = typeof value;
	      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	        ? (value !== '__proto__')
	        : (value === null);
	    }
	
	    /**
	     * Checks if `func` has a lazy counterpart.
	     *
	     * @private
	     * @param {Function} func The function to check.
	     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
	     *  else `false`.
	     */
	    function isLaziable(func) {
	      var funcName = getFuncName(func),
	          other = lodash[funcName];
	
	      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
	        return false;
	      }
	      if (func === other) {
	        return true;
	      }
	      var data = getData(other);
	      return !!data && func === data[0];
	    }
	
	    /**
	     * Checks if `func` has its source masked.
	     *
	     * @private
	     * @param {Function} func The function to check.
	     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	     */
	    function isMasked(func) {
	      return !!maskSrcKey && (maskSrcKey in func);
	    }
	
	    /**
	     * Checks if `func` is capable of being masked.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
	     */
	    var isMaskable = coreJsData ? isFunction : stubFalse;
	
	    /**
	     * Checks if `value` is likely a prototype object.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	     */
	    function isPrototype(value) {
	      var Ctor = value && value.constructor,
	          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	      return value === proto;
	    }
	
	    /**
	     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` if suitable for strict
	     *  equality comparisons, else `false`.
	     */
	    function isStrictComparable(value) {
	      return value === value && !isObject(value);
	    }
	
	    /**
	     * A specialized version of `matchesProperty` for source values suitable
	     * for strict equality comparisons, i.e. `===`.
	     *
	     * @private
	     * @param {string} key The key of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function matchesStrictComparable(key, srcValue) {
	      return function(object) {
	        if (object == null) {
	          return false;
	        }
	        return object[key] === srcValue &&
	          (srcValue !== undefined || (key in Object(object)));
	      };
	    }
	
	    /**
	     * A specialized version of `_.memoize` which clears the memoized function's
	     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
	     *
	     * @private
	     * @param {Function} func The function to have its output memoized.
	     * @returns {Function} Returns the new memoized function.
	     */
	    function memoizeCapped(func) {
	      var result = memoize(func, function(key) {
	        if (cache.size === MAX_MEMOIZE_SIZE) {
	          cache.clear();
	        }
	        return key;
	      });
	
	      var cache = result.cache;
	      return result;
	    }
	
	    /**
	     * Merges the function metadata of `source` into `data`.
	     *
	     * Merging metadata reduces the number of wrappers used to invoke a function.
	     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
	     * may be applied regardless of execution order. Methods like `_.ary` and
	     * `_.rearg` modify function arguments, making the order in which they are
	     * executed important, preventing the merging of metadata. However, we make
	     * an exception for a safe combined case where curried functions have `_.ary`
	     * and or `_.rearg` applied.
	     *
	     * @private
	     * @param {Array} data The destination metadata.
	     * @param {Array} source The source metadata.
	     * @returns {Array} Returns `data`.
	     */
	    function mergeData(data, source) {
	      var bitmask = data[1],
	          srcBitmask = source[1],
	          newBitmask = bitmask | srcBitmask,
	          isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
	
	      var isCombo =
	        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
	        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
	        ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));
	
	      // Exit early if metadata can't be merged.
	      if (!(isCommon || isCombo)) {
	        return data;
	      }
	      // Use source `thisArg` if available.
	      if (srcBitmask & WRAP_BIND_FLAG) {
	        data[2] = source[2];
	        // Set when currying a bound function.
	        newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
	      }
	      // Compose partial arguments.
	      var value = source[3];
	      if (value) {
	        var partials = data[3];
	        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
	        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
	      }
	      // Compose partial right arguments.
	      value = source[5];
	      if (value) {
	        partials = data[5];
	        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
	        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
	      }
	      // Use source `argPos` if available.
	      value = source[7];
	      if (value) {
	        data[7] = value;
	      }
	      // Use source `ary` if it's smaller.
	      if (srcBitmask & WRAP_ARY_FLAG) {
	        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
	      }
	      // Use source `arity` if one is not provided.
	      if (data[9] == null) {
	        data[9] = source[9];
	      }
	      // Use source `func` and merge bitmasks.
	      data[0] = source[0];
	      data[1] = newBitmask;
	
	      return data;
	    }
	
	    /**
	     * This function is like
	     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	     * except that it includes inherited enumerable properties.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function nativeKeysIn(object) {
	      var result = [];
	      if (object != null) {
	        for (var key in Object(object)) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Converts `value` to a string using `Object.prototype.toString`.
	     *
	     * @private
	     * @param {*} value The value to convert.
	     * @returns {string} Returns the converted string.
	     */
	    function objectToString(value) {
	      return nativeObjectToString.call(value);
	    }
	
	    /**
	     * A specialized version of `baseRest` which transforms the rest array.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @param {Function} transform The rest array transform.
	     * @returns {Function} Returns the new function.
	     */
	    function overRest(func, start, transform) {
	      start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
	      return function() {
	        var args = arguments,
	            index = -1,
	            length = nativeMax(args.length - start, 0),
	            array = Array(length);
	
	        while (++index < length) {
	          array[index] = args[start + index];
	        }
	        index = -1;
	        var otherArgs = Array(start + 1);
	        while (++index < start) {
	          otherArgs[index] = args[index];
	        }
	        otherArgs[start] = transform(array);
	        return apply(func, this, otherArgs);
	      };
	    }
	
	    /**
	     * Gets the parent value at `path` of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array} path The path to get the parent value of.
	     * @returns {*} Returns the parent value.
	     */
	    function parent(object, path) {
	      return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
	    }
	
	    /**
	     * Reorder `array` according to the specified indexes where the element at
	     * the first index is assigned as the first element, the element at
	     * the second index is assigned as the second element, and so on.
	     *
	     * @private
	     * @param {Array} array The array to reorder.
	     * @param {Array} indexes The arranged array indexes.
	     * @returns {Array} Returns `array`.
	     */
	    function reorder(array, indexes) {
	      var arrLength = array.length,
	          length = nativeMin(indexes.length, arrLength),
	          oldArray = copyArray(array);
	
	      while (length--) {
	        var index = indexes[length];
	        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
	      }
	      return array;
	    }
	
	    /**
	     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {string} key The key of the property to get.
	     * @returns {*} Returns the property value.
	     */
	    function safeGet(object, key) {
	      if (key === 'constructor' && typeof object[key] === 'function') {
	        return;
	      }
	
	      if (key == '__proto__') {
	        return;
	      }
	
	      return object[key];
	    }
	
	    /**
	     * Sets metadata for `func`.
	     *
	     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
	     * period of time, it will trip its breaker and transition to an identity
	     * function to avoid garbage collection pauses in V8. See
	     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
	     * for more details.
	     *
	     * @private
	     * @param {Function} func The function to associate metadata with.
	     * @param {*} data The metadata.
	     * @returns {Function} Returns `func`.
	     */
	    var setData = shortOut(baseSetData);
	
	    /**
	     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
	     *
	     * @private
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @returns {number|Object} Returns the timer id or timeout object.
	     */
	    var setTimeout = ctxSetTimeout || function(func, wait) {
	      return root.setTimeout(func, wait);
	    };
	
	    /**
	     * Sets the `toString` method of `func` to return `string`.
	     *
	     * @private
	     * @param {Function} func The function to modify.
	     * @param {Function} string The `toString` result.
	     * @returns {Function} Returns `func`.
	     */
	    var setToString = shortOut(baseSetToString);
	
	    /**
	     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
	     * with wrapper details in a comment at the top of the source body.
	     *
	     * @private
	     * @param {Function} wrapper The function to modify.
	     * @param {Function} reference The reference function.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @returns {Function} Returns `wrapper`.
	     */
	    function setWrapToString(wrapper, reference, bitmask) {
	      var source = (reference + '');
	      return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
	    }
	
	    /**
	     * Creates a function that'll short out and invoke `identity` instead
	     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
	     * milliseconds.
	     *
	     * @private
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new shortable function.
	     */
	    function shortOut(func) {
	      var count = 0,
	          lastCalled = 0;
	
	      return function() {
	        var stamp = nativeNow(),
	            remaining = HOT_SPAN - (stamp - lastCalled);
	
	        lastCalled = stamp;
	        if (remaining > 0) {
	          if (++count >= HOT_COUNT) {
	            return arguments[0];
	          }
	        } else {
	          count = 0;
	        }
	        return func.apply(undefined, arguments);
	      };
	    }
	
	    /**
	     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
	     *
	     * @private
	     * @param {Array} array The array to shuffle.
	     * @param {number} [size=array.length] The size of `array`.
	     * @returns {Array} Returns `array`.
	     */
	    function shuffleSelf(array, size) {
	      var index = -1,
	          length = array.length,
	          lastIndex = length - 1;
	
	      size = size === undefined ? length : size;
	      while (++index < size) {
	        var rand = baseRandom(index, lastIndex),
	            value = array[rand];
	
	        array[rand] = array[index];
	        array[index] = value;
	      }
	      array.length = size;
	      return array;
	    }
	
	    /**
	     * Converts `string` to a property path array.
	     *
	     * @private
	     * @param {string} string The string to convert.
	     * @returns {Array} Returns the property path array.
	     */
	    var stringToPath = memoizeCapped(function(string) {
	      var result = [];
	      if (string.charCodeAt(0) === 46 /* . */) {
	        result.push('');
	      }
	      string.replace(rePropName, function(match, number, quote, subString) {
	        result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
	      });
	      return result;
	    });
	
	    /**
	     * Converts `value` to a string key if it's not a string or symbol.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {string|symbol} Returns the key.
	     */
	    function toKey(value) {
	      if (typeof value == 'string' || isSymbol(value)) {
	        return value;
	      }
	      var result = (value + '');
	      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	    }
	
	    /**
	     * Converts `func` to its source code.
	     *
	     * @private
	     * @param {Function} func The function to convert.
	     * @returns {string} Returns the source code.
	     */
	    function toSource(func) {
	      if (func != null) {
	        try {
	          return funcToString.call(func);
	        } catch (e) {}
	        try {
	          return (func + '');
	        } catch (e) {}
	      }
	      return '';
	    }
	
	    /**
	     * Updates wrapper `details` based on `bitmask` flags.
	     *
	     * @private
	     * @returns {Array} details The details to modify.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @returns {Array} Returns `details`.
	     */
	    function updateWrapDetails(details, bitmask) {
	      arrayEach(wrapFlags, function(pair) {
	        var value = '_.' + pair[0];
	        if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
	          details.push(value);
	        }
	      });
	      return details.sort();
	    }
	
	    /**
	     * Creates a clone of `wrapper`.
	     *
	     * @private
	     * @param {Object} wrapper The wrapper to clone.
	     * @returns {Object} Returns the cloned wrapper.
	     */
	    function wrapperClone(wrapper) {
	      if (wrapper instanceof LazyWrapper) {
	        return wrapper.clone();
	      }
	      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
	      result.__actions__ = copyArray(wrapper.__actions__);
	      result.__index__  = wrapper.__index__;
	      result.__values__ = wrapper.__values__;
	      return result;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an array of elements split into groups the length of `size`.
	     * If `array` can't be split evenly, the final chunk will be the remaining
	     * elements.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to process.
	     * @param {number} [size=1] The length of each chunk
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the new array of chunks.
	     * @example
	     *
	     * _.chunk(['a', 'b', 'c', 'd'], 2);
	     * // => [['a', 'b'], ['c', 'd']]
	     *
	     * _.chunk(['a', 'b', 'c', 'd'], 3);
	     * // => [['a', 'b', 'c'], ['d']]
	     */
	    function chunk(array, size, guard) {
	      if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
	        size = 1;
	      } else {
	        size = nativeMax(toInteger(size), 0);
	      }
	      var length = array == null ? 0 : array.length;
	      if (!length || size < 1) {
	        return [];
	      }
	      var index = 0,
	          resIndex = 0,
	          result = Array(nativeCeil(length / size));
	
	      while (index < length) {
	        result[resIndex++] = baseSlice(array, index, (index += size));
	      }
	      return result;
	    }
	
	    /**
	     * Creates an array with all falsey values removed. The values `false`, `null`,
	     * `0`, `""`, `undefined`, and `NaN` are falsey.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to compact.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.compact([0, 1, false, 2, '', 3]);
	     * // => [1, 2, 3]
	     */
	    function compact(array) {
	      var index = -1,
	          length = array == null ? 0 : array.length,
	          resIndex = 0,
	          result = [];
	
	      while (++index < length) {
	        var value = array[index];
	        if (value) {
	          result[resIndex++] = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Creates a new array concatenating `array` with any additional arrays
	     * and/or values.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to concatenate.
	     * @param {...*} [values] The values to concatenate.
	     * @returns {Array} Returns the new concatenated array.
	     * @example
	     *
	     * var array = [1];
	     * var other = _.concat(array, 2, [3], [[4]]);
	     *
	     * console.log(other);
	     * // => [1, 2, 3, [4]]
	     *
	     * console.log(array);
	     * // => [1]
	     */
	    function concat() {
	      var length = arguments.length;
	      if (!length) {
	        return [];
	      }
	      var args = Array(length - 1),
	          array = arguments[0],
	          index = length;
	
	      while (index--) {
	        args[index - 1] = arguments[index];
	      }
	      return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
	    }
	
	    /**
	     * Creates an array of `array` values not included in the other given arrays
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. The order and references of result values are
	     * determined by the first array.
	     *
	     * **Note:** Unlike `_.pullAll`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.without, _.xor
	     * @example
	     *
	     * _.difference([2, 1], [2, 3]);
	     * // => [1]
	     */
	    var difference = baseRest(function(array, values) {
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
	        : [];
	    });
	
	    /**
	     * This method is like `_.difference` except that it accepts `iteratee` which
	     * is invoked for each element of `array` and `values` to generate the criterion
	     * by which they're compared. The order and references of result values are
	     * determined by the first array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
	     * // => [{ 'x': 2 }]
	     */
	    var differenceBy = baseRest(function(array, values) {
	      var iteratee = last(values);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2))
	        : [];
	    });
	
	    /**
	     * This method is like `_.difference` except that it accepts `comparator`
	     * which is invoked to compare elements of `array` to `values`. The order and
	     * references of result values are determined by the first array. The comparator
	     * is invoked with two arguments: (arrVal, othVal).
	     *
	     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     *
	     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
	     * // => [{ 'x': 2, 'y': 1 }]
	     */
	    var differenceWith = baseRest(function(array, values) {
	      var comparator = last(values);
	      if (isArrayLikeObject(comparator)) {
	        comparator = undefined;
	      }
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
	        : [];
	    });
	
	    /**
	     * Creates a slice of `array` with `n` elements dropped from the beginning.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to drop.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.drop([1, 2, 3]);
	     * // => [2, 3]
	     *
	     * _.drop([1, 2, 3], 2);
	     * // => [3]
	     *
	     * _.drop([1, 2, 3], 5);
	     * // => []
	     *
	     * _.drop([1, 2, 3], 0);
	     * // => [1, 2, 3]
	     */
	    function drop(array, n, guard) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      return baseSlice(array, n < 0 ? 0 : n, length);
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements dropped from the end.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to drop.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.dropRight([1, 2, 3]);
	     * // => [1, 2]
	     *
	     * _.dropRight([1, 2, 3], 2);
	     * // => [1]
	     *
	     * _.dropRight([1, 2, 3], 5);
	     * // => []
	     *
	     * _.dropRight([1, 2, 3], 0);
	     * // => [1, 2, 3]
	     */
	    function dropRight(array, n, guard) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      n = length - n;
	      return baseSlice(array, 0, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` excluding elements dropped from the end.
	     * Elements are dropped until `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.dropRightWhile(users, function(o) { return !o.active; });
	     * // => objects for ['barney']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.dropRightWhile(users, ['active', false]);
	     * // => objects for ['barney']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.dropRightWhile(users, 'active');
	     * // => objects for ['barney', 'fred', 'pebbles']
	     */
	    function dropRightWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), true, true)
	        : [];
	    }
	
	    /**
	     * Creates a slice of `array` excluding elements dropped from the beginning.
	     * Elements are dropped until `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.dropWhile(users, function(o) { return !o.active; });
	     * // => objects for ['pebbles']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.dropWhile(users, { 'user': 'barney', 'active': false });
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.dropWhile(users, ['active', false]);
	     * // => objects for ['pebbles']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.dropWhile(users, 'active');
	     * // => objects for ['barney', 'fred', 'pebbles']
	     */
	    function dropWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), true)
	        : [];
	    }
	
	    /**
	     * Fills elements of `array` with `value` from `start` up to, but not
	     * including, `end`.
	     *
	     * **Note:** This method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Array
	     * @param {Array} array The array to fill.
	     * @param {*} value The value to fill `array` with.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _.fill(array, 'a');
	     * console.log(array);
	     * // => ['a', 'a', 'a']
	     *
	     * _.fill(Array(3), 2);
	     * // => [2, 2, 2]
	     *
	     * _.fill([4, 6, 8, 10], '*', 1, 3);
	     * // => [4, '*', '*', 10]
	     */
	    function fill(array, value, start, end) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
	        start = 0;
	        end = length;
	      }
	      return baseFill(array, value, start, end);
	    }
	
	    /**
	     * This method is like `_.find` except that it returns the index of the first
	     * element `predicate` returns truthy for instead of the element itself.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {number} Returns the index of the found element, else `-1`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.findIndex(users, function(o) { return o.user == 'barney'; });
	     * // => 0
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findIndex(users, { 'user': 'fred', 'active': false });
	     * // => 1
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findIndex(users, ['active', false]);
	     * // => 0
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findIndex(users, 'active');
	     * // => 2
	     */
	    function findIndex(array, predicate, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = fromIndex == null ? 0 : toInteger(fromIndex);
	      if (index < 0) {
	        index = nativeMax(length + index, 0);
	      }
	      return baseFindIndex(array, getIteratee(predicate, 3), index);
	    }
	
	    /**
	     * This method is like `_.findIndex` except that it iterates over elements
	     * of `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=array.length-1] The index to search from.
	     * @returns {number} Returns the index of the found element, else `-1`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
	     * // => 2
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
	     * // => 0
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findLastIndex(users, ['active', false]);
	     * // => 2
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findLastIndex(users, 'active');
	     * // => 0
	     */
	    function findLastIndex(array, predicate, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = length - 1;
	      if (fromIndex !== undefined) {
	        index = toInteger(fromIndex);
	        index = fromIndex < 0
	          ? nativeMax(length + index, 0)
	          : nativeMin(index, length - 1);
	      }
	      return baseFindIndex(array, getIteratee(predicate, 3), index, true);
	    }
	
	    /**
	     * Flattens `array` a single level deep.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * _.flatten([1, [2, [3, [4]], 5]]);
	     * // => [1, 2, [3, [4]], 5]
	     */
	    function flatten(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseFlatten(array, 1) : [];
	    }
	
	    /**
	     * Recursively flattens `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * _.flattenDeep([1, [2, [3, [4]], 5]]);
	     * // => [1, 2, 3, 4, 5]
	     */
	    function flattenDeep(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseFlatten(array, INFINITY) : [];
	    }
	
	    /**
	     * Recursively flatten `array` up to `depth` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.4.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @param {number} [depth=1] The maximum recursion depth.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * var array = [1, [2, [3, [4]], 5]];
	     *
	     * _.flattenDepth(array, 1);
	     * // => [1, 2, [3, [4]], 5]
	     *
	     * _.flattenDepth(array, 2);
	     * // => [1, 2, 3, [4], 5]
	     */
	    function flattenDepth(array, depth) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      depth = depth === undefined ? 1 : toInteger(depth);
	      return baseFlatten(array, depth);
	    }
	
	    /**
	     * The inverse of `_.toPairs`; this method returns an object composed
	     * from key-value `pairs`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} pairs The key-value pairs.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.fromPairs([['a', 1], ['b', 2]]);
	     * // => { 'a': 1, 'b': 2 }
	     */
	    function fromPairs(pairs) {
	      var index = -1,
	          length = pairs == null ? 0 : pairs.length,
	          result = {};
	
	      while (++index < length) {
	        var pair = pairs[index];
	        result[pair[0]] = pair[1];
	      }
	      return result;
	    }
	
	    /**
	     * Gets the first element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @alias first
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {*} Returns the first element of `array`.
	     * @example
	     *
	     * _.head([1, 2, 3]);
	     * // => 1
	     *
	     * _.head([]);
	     * // => undefined
	     */
	    function head(array) {
	      return (array && array.length) ? array[0] : undefined;
	    }
	
	    /**
	     * Gets the index at which the first occurrence of `value` is found in `array`
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. If `fromIndex` is negative, it's used as the
	     * offset from the end of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.indexOf([1, 2, 1, 2], 2);
	     * // => 1
	     *
	     * // Search from the `fromIndex`.
	     * _.indexOf([1, 2, 1, 2], 2, 2);
	     * // => 3
	     */
	    function indexOf(array, value, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = fromIndex == null ? 0 : toInteger(fromIndex);
	      if (index < 0) {
	        index = nativeMax(length + index, 0);
	      }
	      return baseIndexOf(array, value, index);
	    }
	
	    /**
	     * Gets all but the last element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.initial([1, 2, 3]);
	     * // => [1, 2]
	     */
	    function initial(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseSlice(array, 0, -1) : [];
	    }
	
	    /**
	     * Creates an array of unique values that are included in all given arrays
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. The order and references of result values are
	     * determined by the first array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * _.intersection([2, 1], [2, 3]);
	     * // => [2]
	     */
	    var intersection = baseRest(function(arrays) {
	      var mapped = arrayMap(arrays, castArrayLikeObject);
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped)
	        : [];
	    });
	
	    /**
	     * This method is like `_.intersection` except that it accepts `iteratee`
	     * which is invoked for each element of each `arrays` to generate the criterion
	     * by which they're compared. The order and references of result values are
	     * determined by the first array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [2.1]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }]
	     */
	    var intersectionBy = baseRest(function(arrays) {
	      var iteratee = last(arrays),
	          mapped = arrayMap(arrays, castArrayLikeObject);
	
	      if (iteratee === last(mapped)) {
	        iteratee = undefined;
	      } else {
	        mapped.pop();
	      }
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped, getIteratee(iteratee, 2))
	        : [];
	    });
	
	    /**
	     * This method is like `_.intersection` except that it accepts `comparator`
	     * which is invoked to compare elements of `arrays`. The order and references
	     * of result values are determined by the first array. The comparator is
	     * invoked with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.intersectionWith(objects, others, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }]
	     */
	    var intersectionWith = baseRest(function(arrays) {
	      var comparator = last(arrays),
	          mapped = arrayMap(arrays, castArrayLikeObject);
	
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      if (comparator) {
	        mapped.pop();
	      }
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped, undefined, comparator)
	        : [];
	    });
	
	    /**
	     * Converts all elements in `array` into a string separated by `separator`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to convert.
	     * @param {string} [separator=','] The element separator.
	     * @returns {string} Returns the joined string.
	     * @example
	     *
	     * _.join(['a', 'b', 'c'], '~');
	     * // => 'a~b~c'
	     */
	    function join(array, separator) {
	      return array == null ? '' : nativeJoin.call(array, separator);
	    }
	
	    /**
	     * Gets the last element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {*} Returns the last element of `array`.
	     * @example
	     *
	     * _.last([1, 2, 3]);
	     * // => 3
	     */
	    function last(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? array[length - 1] : undefined;
	    }
	
	    /**
	     * This method is like `_.indexOf` except that it iterates over elements of
	     * `array` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=array.length-1] The index to search from.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.lastIndexOf([1, 2, 1, 2], 2);
	     * // => 3
	     *
	     * // Search from the `fromIndex`.
	     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
	     * // => 1
	     */
	    function lastIndexOf(array, value, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = length;
	      if (fromIndex !== undefined) {
	        index = toInteger(fromIndex);
	        index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
	      }
	      return value === value
	        ? strictLastIndexOf(array, value, index)
	        : baseFindIndex(array, baseIsNaN, index, true);
	    }
	
	    /**
	     * Gets the element at index `n` of `array`. If `n` is negative, the nth
	     * element from the end is returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.11.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=0] The index of the element to return.
	     * @returns {*} Returns the nth element of `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'd'];
	     *
	     * _.nth(array, 1);
	     * // => 'b'
	     *
	     * _.nth(array, -2);
	     * // => 'c';
	     */
	    function nth(array, n) {
	      return (array && array.length) ? baseNth(array, toInteger(n)) : undefined;
	    }
	
	    /**
	     * Removes all given values from `array` using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
	     * to remove elements from an array by predicate.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {...*} [values] The values to remove.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
	     *
	     * _.pull(array, 'a', 'c');
	     * console.log(array);
	     * // => ['b', 'b']
	     */
	    var pull = baseRest(pullAll);
	
	    /**
	     * This method is like `_.pull` except that it accepts an array of values to remove.
	     *
	     * **Note:** Unlike `_.difference`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
	     *
	     * _.pullAll(array, ['a', 'c']);
	     * console.log(array);
	     * // => ['b', 'b']
	     */
	    function pullAll(array, values) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values)
	        : array;
	    }
	
	    /**
	     * This method is like `_.pullAll` except that it accepts `iteratee` which is
	     * invoked for each element of `array` and `values` to generate the criterion
	     * by which they're compared. The iteratee is invoked with one argument: (value).
	     *
	     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
	     *
	     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
	     * console.log(array);
	     * // => [{ 'x': 2 }]
	     */
	    function pullAllBy(array, values, iteratee) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values, getIteratee(iteratee, 2))
	        : array;
	    }
	
	    /**
	     * This method is like `_.pullAll` except that it accepts `comparator` which
	     * is invoked to compare elements of `array` to `values`. The comparator is
	     * invoked with two arguments: (arrVal, othVal).
	     *
	     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
	     *
	     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
	     * console.log(array);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
	     */
	    function pullAllWith(array, values, comparator) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values, undefined, comparator)
	        : array;
	    }
	
	    /**
	     * Removes elements from `array` corresponding to `indexes` and returns an
	     * array of removed elements.
	     *
	     * **Note:** Unlike `_.at`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
	     * @returns {Array} Returns the new array of removed elements.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'd'];
	     * var pulled = _.pullAt(array, [1, 3]);
	     *
	     * console.log(array);
	     * // => ['a', 'c']
	     *
	     * console.log(pulled);
	     * // => ['b', 'd']
	     */
	    var pullAt = flatRest(function(array, indexes) {
	      var length = array == null ? 0 : array.length,
	          result = baseAt(array, indexes);
	
	      basePullAt(array, arrayMap(indexes, function(index) {
	        return isIndex(index, length) ? +index : index;
	      }).sort(compareAscending));
	
	      return result;
	    });
	
	    /**
	     * Removes all elements from `array` that `predicate` returns truthy for
	     * and returns an array of the removed elements. The predicate is invoked
	     * with three arguments: (value, index, array).
	     *
	     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
	     * to pull elements from an array by value.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new array of removed elements.
	     * @example
	     *
	     * var array = [1, 2, 3, 4];
	     * var evens = _.remove(array, function(n) {
	     *   return n % 2 == 0;
	     * });
	     *
	     * console.log(array);
	     * // => [1, 3]
	     *
	     * console.log(evens);
	     * // => [2, 4]
	     */
	    function remove(array, predicate) {
	      var result = [];
	      if (!(array && array.length)) {
	        return result;
	      }
	      var index = -1,
	          indexes = [],
	          length = array.length;
	
	      predicate = getIteratee(predicate, 3);
	      while (++index < length) {
	        var value = array[index];
	        if (predicate(value, index, array)) {
	          result.push(value);
	          indexes.push(index);
	        }
	      }
	      basePullAt(array, indexes);
	      return result;
	    }
	
	    /**
	     * Reverses `array` so that the first element becomes the last, the second
	     * element becomes the second to last, and so on.
	     *
	     * **Note:** This method mutates `array` and is based on
	     * [`Array#reverse`](https://mdn.io/Array/reverse).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _.reverse(array);
	     * // => [3, 2, 1]
	     *
	     * console.log(array);
	     * // => [3, 2, 1]
	     */
	    function reverse(array) {
	      return array == null ? array : nativeReverse.call(array);
	    }
	
	    /**
	     * Creates a slice of `array` from `start` up to, but not including, `end`.
	     *
	     * **Note:** This method is used instead of
	     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
	     * returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to slice.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function slice(array, start, end) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
	        start = 0;
	        end = length;
	      }
	      else {
	        start = start == null ? 0 : toInteger(start);
	        end = end === undefined ? length : toInteger(end);
	      }
	      return baseSlice(array, start, end);
	    }
	
	    /**
	     * Uses a binary search to determine the lowest index at which `value`
	     * should be inserted into `array` in order to maintain its sort order.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * _.sortedIndex([30, 50], 40);
	     * // => 1
	     */
	    function sortedIndex(array, value) {
	      return baseSortedIndex(array, value);
	    }
	
	    /**
	     * This method is like `_.sortedIndex` except that it accepts `iteratee`
	     * which is invoked for `value` and each element of `array` to compute their
	     * sort ranking. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * var objects = [{ 'x': 4 }, { 'x': 5 }];
	     *
	     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
	     * // => 0
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
	     * // => 0
	     */
	    function sortedIndexBy(array, value, iteratee) {
	      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
	    }
	
	    /**
	     * This method is like `_.indexOf` except that it performs a binary
	     * search on a sorted `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
	     * // => 1
	     */
	    function sortedIndexOf(array, value) {
	      var length = array == null ? 0 : array.length;
	      if (length) {
	        var index = baseSortedIndex(array, value);
	        if (index < length && eq(array[index], value)) {
	          return index;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * This method is like `_.sortedIndex` except that it returns the highest
	     * index at which `value` should be inserted into `array` in order to
	     * maintain its sort order.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
	     * // => 4
	     */
	    function sortedLastIndex(array, value) {
	      return baseSortedIndex(array, value, true);
	    }
	
	    /**
	     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
	     * which is invoked for `value` and each element of `array` to compute their
	     * sort ranking. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * var objects = [{ 'x': 4 }, { 'x': 5 }];
	     *
	     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
	     * // => 1
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
	     * // => 1
	     */
	    function sortedLastIndexBy(array, value, iteratee) {
	      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
	    }
	
	    /**
	     * This method is like `_.lastIndexOf` except that it performs a binary
	     * search on a sorted `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
	     * // => 3
	     */
	    function sortedLastIndexOf(array, value) {
	      var length = array == null ? 0 : array.length;
	      if (length) {
	        var index = baseSortedIndex(array, value, true) - 1;
	        if (eq(array[index], value)) {
	          return index;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * This method is like `_.uniq` except that it's designed and optimized
	     * for sorted arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.sortedUniq([1, 1, 2]);
	     * // => [1, 2]
	     */
	    function sortedUniq(array) {
	      return (array && array.length)
	        ? baseSortedUniq(array)
	        : [];
	    }
	
	    /**
	     * This method is like `_.uniqBy` except that it's designed and optimized
	     * for sorted arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
	     * // => [1.1, 2.3]
	     */
	    function sortedUniqBy(array, iteratee) {
	      return (array && array.length)
	        ? baseSortedUniq(array, getIteratee(iteratee, 2))
	        : [];
	    }
	
	    /**
	     * Gets all but the first element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.tail([1, 2, 3]);
	     * // => [2, 3]
	     */
	    function tail(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseSlice(array, 1, length) : [];
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements taken from the beginning.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to take.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.take([1, 2, 3]);
	     * // => [1]
	     *
	     * _.take([1, 2, 3], 2);
	     * // => [1, 2]
	     *
	     * _.take([1, 2, 3], 5);
	     * // => [1, 2, 3]
	     *
	     * _.take([1, 2, 3], 0);
	     * // => []
	     */
	    function take(array, n, guard) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      return baseSlice(array, 0, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements taken from the end.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to take.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.takeRight([1, 2, 3]);
	     * // => [3]
	     *
	     * _.takeRight([1, 2, 3], 2);
	     * // => [2, 3]
	     *
	     * _.takeRight([1, 2, 3], 5);
	     * // => [1, 2, 3]
	     *
	     * _.takeRight([1, 2, 3], 0);
	     * // => []
	     */
	    function takeRight(array, n, guard) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      n = length - n;
	      return baseSlice(array, n < 0 ? 0 : n, length);
	    }
	
	    /**
	     * Creates a slice of `array` with elements taken from the end. Elements are
	     * taken until `predicate` returns falsey. The predicate is invoked with
	     * three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.takeRightWhile(users, function(o) { return !o.active; });
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
	     * // => objects for ['pebbles']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.takeRightWhile(users, ['active', false]);
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.takeRightWhile(users, 'active');
	     * // => []
	     */
	    function takeRightWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), false, true)
	        : [];
	    }
	
	    /**
	     * Creates a slice of `array` with elements taken from the beginning. Elements
	     * are taken until `predicate` returns falsey. The predicate is invoked with
	     * three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.takeWhile(users, function(o) { return !o.active; });
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.takeWhile(users, { 'user': 'barney', 'active': false });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.takeWhile(users, ['active', false]);
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.takeWhile(users, 'active');
	     * // => []
	     */
	    function takeWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3))
	        : [];
	    }
	
	    /**
	     * Creates an array of unique values, in order, from all given arrays using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * _.union([2], [1, 2]);
	     * // => [2, 1]
	     */
	    var union = baseRest(function(arrays) {
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
	    });
	
	    /**
	     * This method is like `_.union` except that it accepts `iteratee` which is
	     * invoked for each element of each `arrays` to generate the criterion by
	     * which uniqueness is computed. Result values are chosen from the first
	     * array in which the value occurs. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
	     * // => [2.1, 1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }, { 'x': 2 }]
	     */
	    var unionBy = baseRest(function(arrays) {
	      var iteratee = last(arrays);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
	    });
	
	    /**
	     * This method is like `_.union` except that it accepts `comparator` which
	     * is invoked to compare elements of `arrays`. Result values are chosen from
	     * the first array in which the value occurs. The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.unionWith(objects, others, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
	     */
	    var unionWith = baseRest(function(arrays) {
	      var comparator = last(arrays);
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
	    });
	
	    /**
	     * Creates a duplicate-free version of an array, using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons, in which only the first occurrence of each element
	     * is kept. The order of result values is determined by the order they occur
	     * in the array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.uniq([2, 1, 2]);
	     * // => [2, 1]
	     */
	    function uniq(array) {
	      return (array && array.length) ? baseUniq(array) : [];
	    }
	
	    /**
	     * This method is like `_.uniq` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * uniqueness is computed. The order of result values is determined by the
	     * order they occur in the array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
	     * // => [2.1, 1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }, { 'x': 2 }]
	     */
	    function uniqBy(array, iteratee) {
	      return (array && array.length) ? baseUniq(array, getIteratee(iteratee, 2)) : [];
	    }
	
	    /**
	     * This method is like `_.uniq` except that it accepts `comparator` which
	     * is invoked to compare elements of `array`. The order of result values is
	     * determined by the order they occur in the array.The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.uniqWith(objects, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
	     */
	    function uniqWith(array, comparator) {
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      return (array && array.length) ? baseUniq(array, undefined, comparator) : [];
	    }
	
	    /**
	     * This method is like `_.zip` except that it accepts an array of grouped
	     * elements and creates an array regrouping the elements to their pre-zip
	     * configuration.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.2.0
	     * @category Array
	     * @param {Array} array The array of grouped elements to process.
	     * @returns {Array} Returns the new array of regrouped elements.
	     * @example
	     *
	     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
	     * // => [['a', 1, true], ['b', 2, false]]
	     *
	     * _.unzip(zipped);
	     * // => [['a', 'b'], [1, 2], [true, false]]
	     */
	    function unzip(array) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      var length = 0;
	      array = arrayFilter(array, function(group) {
	        if (isArrayLikeObject(group)) {
	          length = nativeMax(group.length, length);
	          return true;
	        }
	      });
	      return baseTimes(length, function(index) {
	        return arrayMap(array, baseProperty(index));
	      });
	    }
	
	    /**
	     * This method is like `_.unzip` except that it accepts `iteratee` to specify
	     * how regrouped values should be combined. The iteratee is invoked with the
	     * elements of each group: (...group).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Array
	     * @param {Array} array The array of grouped elements to process.
	     * @param {Function} [iteratee=_.identity] The function to combine
	     *  regrouped values.
	     * @returns {Array} Returns the new array of regrouped elements.
	     * @example
	     *
	     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
	     * // => [[1, 10, 100], [2, 20, 200]]
	     *
	     * _.unzipWith(zipped, _.add);
	     * // => [3, 30, 300]
	     */
	    function unzipWith(array, iteratee) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      var result = unzip(array);
	      if (iteratee == null) {
	        return result;
	      }
	      return arrayMap(result, function(group) {
	        return apply(iteratee, undefined, group);
	      });
	    }
	
	    /**
	     * Creates an array excluding all given values using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * **Note:** Unlike `_.pull`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...*} [values] The values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.difference, _.xor
	     * @example
	     *
	     * _.without([2, 1, 2, 3], 1, 2);
	     * // => [3]
	     */
	    var without = baseRest(function(array, values) {
	      return isArrayLikeObject(array)
	        ? baseDifference(array, values)
	        : [];
	    });
	
	    /**
	     * Creates an array of unique values that is the
	     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
	     * of the given arrays. The order of result values is determined by the order
	     * they occur in the arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.difference, _.without
	     * @example
	     *
	     * _.xor([2, 1], [2, 3]);
	     * // => [1, 3]
	     */
	    var xor = baseRest(function(arrays) {
	      return baseXor(arrayFilter(arrays, isArrayLikeObject));
	    });
	
	    /**
	     * This method is like `_.xor` except that it accepts `iteratee` which is
	     * invoked for each element of each `arrays` to generate the criterion by
	     * which by which they're compared. The order of result values is determined
	     * by the order they occur in the arrays. The iteratee is invoked with one
	     * argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [1.2, 3.4]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 2 }]
	     */
	    var xorBy = baseRest(function(arrays) {
	      var iteratee = last(arrays);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
	    });
	
	    /**
	     * This method is like `_.xor` except that it accepts `comparator` which is
	     * invoked to compare elements of `arrays`. The order of result values is
	     * determined by the order they occur in the arrays. The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.xorWith(objects, others, _.isEqual);
	     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
	     */
	    var xorWith = baseRest(function(arrays) {
	      var comparator = last(arrays);
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
	    });
	
	    /**
	     * Creates an array of grouped elements, the first of which contains the
	     * first elements of the given arrays, the second of which contains the
	     * second elements of the given arrays, and so on.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to process.
	     * @returns {Array} Returns the new array of grouped elements.
	     * @example
	     *
	     * _.zip(['a', 'b'], [1, 2], [true, false]);
	     * // => [['a', 1, true], ['b', 2, false]]
	     */
	    var zip = baseRest(unzip);
	
	    /**
	     * This method is like `_.fromPairs` except that it accepts two arrays,
	     * one of property identifiers and one of corresponding values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.4.0
	     * @category Array
	     * @param {Array} [props=[]] The property identifiers.
	     * @param {Array} [values=[]] The property values.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.zipObject(['a', 'b'], [1, 2]);
	     * // => { 'a': 1, 'b': 2 }
	     */
	    function zipObject(props, values) {
	      return baseZipObject(props || [], values || [], assignValue);
	    }
	
	    /**
	     * This method is like `_.zipObject` except that it supports property paths.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.1.0
	     * @category Array
	     * @param {Array} [props=[]] The property identifiers.
	     * @param {Array} [values=[]] The property values.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
	     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
	     */
	    function zipObjectDeep(props, values) {
	      return baseZipObject(props || [], values || [], baseSet);
	    }
	
	    /**
	     * This method is like `_.zip` except that it accepts `iteratee` to specify
	     * how grouped values should be combined. The iteratee is invoked with the
	     * elements of each group: (...group).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to process.
	     * @param {Function} [iteratee=_.identity] The function to combine
	     *  grouped values.
	     * @returns {Array} Returns the new array of grouped elements.
	     * @example
	     *
	     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
	     *   return a + b + c;
	     * });
	     * // => [111, 222]
	     */
	    var zipWith = baseRest(function(arrays) {
	      var length = arrays.length,
	          iteratee = length > 1 ? arrays[length - 1] : undefined;
	
	      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
	      return unzipWith(arrays, iteratee);
	    });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
	     * chain sequences enabled. The result of such sequences must be unwrapped
	     * with `_#value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.3.0
	     * @category Seq
	     * @param {*} value The value to wrap.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36 },
	     *   { 'user': 'fred',    'age': 40 },
	     *   { 'user': 'pebbles', 'age': 1 }
	     * ];
	     *
	     * var youngest = _
	     *   .chain(users)
	     *   .sortBy('age')
	     *   .map(function(o) {
	     *     return o.user + ' is ' + o.age;
	     *   })
	     *   .head()
	     *   .value();
	     * // => 'pebbles is 1'
	     */
	    function chain(value) {
	      var result = lodash(value);
	      result.__chain__ = true;
	      return result;
	    }
	
	    /**
	     * This method invokes `interceptor` and returns `value`. The interceptor
	     * is invoked with one argument; (value). The purpose of this method is to
	     * "tap into" a method chain sequence in order to modify intermediate results.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @param {*} value The value to provide to `interceptor`.
	     * @param {Function} interceptor The function to invoke.
	     * @returns {*} Returns `value`.
	     * @example
	     *
	     * _([1, 2, 3])
	     *  .tap(function(array) {
	     *    // Mutate input array.
	     *    array.pop();
	     *  })
	     *  .reverse()
	     *  .value();
	     * // => [2, 1]
	     */
	    function tap(value, interceptor) {
	      interceptor(value);
	      return value;
	    }
	
	    /**
	     * This method is like `_.tap` except that it returns the result of `interceptor`.
	     * The purpose of this method is to "pass thru" values replacing intermediate
	     * results in a method chain sequence.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Seq
	     * @param {*} value The value to provide to `interceptor`.
	     * @param {Function} interceptor The function to invoke.
	     * @returns {*} Returns the result of `interceptor`.
	     * @example
	     *
	     * _('  abc  ')
	     *  .chain()
	     *  .trim()
	     *  .thru(function(value) {
	     *    return [value];
	     *  })
	     *  .value();
	     * // => ['abc']
	     */
	    function thru(value, interceptor) {
	      return interceptor(value);
	    }
	
	    /**
	     * This method is the wrapper version of `_.at`.
	     *
	     * @name at
	     * @memberOf _
	     * @since 1.0.0
	     * @category Seq
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
	     *
	     * _(object).at(['a[0].b.c', 'a[1]']).value();
	     * // => [3, 4]
	     */
	    var wrapperAt = flatRest(function(paths) {
	      var length = paths.length,
	          start = length ? paths[0] : 0,
	          value = this.__wrapped__,
	          interceptor = function(object) { return baseAt(object, paths); };
	
	      if (length > 1 || this.__actions__.length ||
	          !(value instanceof LazyWrapper) || !isIndex(start)) {
	        return this.thru(interceptor);
	      }
	      value = value.slice(start, +start + (length ? 1 : 0));
	      value.__actions__.push({
	        'func': thru,
	        'args': [interceptor],
	        'thisArg': undefined
	      });
	      return new LodashWrapper(value, this.__chain__).thru(function(array) {
	        if (length && !array.length) {
	          array.push(undefined);
	        }
	        return array;
	      });
	    });
	
	    /**
	     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
	     *
	     * @name chain
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 }
	     * ];
	     *
	     * // A sequence without explicit chaining.
	     * _(users).head();
	     * // => { 'user': 'barney', 'age': 36 }
	     *
	     * // A sequence with explicit chaining.
	     * _(users)
	     *   .chain()
	     *   .head()
	     *   .pick('user')
	     *   .value();
	     * // => { 'user': 'barney' }
	     */
	    function wrapperChain() {
	      return chain(this);
	    }
	
	    /**
	     * Executes the chain sequence and returns the wrapped result.
	     *
	     * @name commit
	     * @memberOf _
	     * @since 3.2.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2];
	     * var wrapped = _(array).push(3);
	     *
	     * console.log(array);
	     * // => [1, 2]
	     *
	     * wrapped = wrapped.commit();
	     * console.log(array);
	     * // => [1, 2, 3]
	     *
	     * wrapped.last();
	     * // => 3
	     *
	     * console.log(array);
	     * // => [1, 2, 3]
	     */
	    function wrapperCommit() {
	      return new LodashWrapper(this.value(), this.__chain__);
	    }
	
	    /**
	     * Gets the next value on a wrapped object following the
	     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
	     *
	     * @name next
	     * @memberOf _
	     * @since 4.0.0
	     * @category Seq
	     * @returns {Object} Returns the next iterator value.
	     * @example
	     *
	     * var wrapped = _([1, 2]);
	     *
	     * wrapped.next();
	     * // => { 'done': false, 'value': 1 }
	     *
	     * wrapped.next();
	     * // => { 'done': false, 'value': 2 }
	     *
	     * wrapped.next();
	     * // => { 'done': true, 'value': undefined }
	     */
	    function wrapperNext() {
	      if (this.__values__ === undefined) {
	        this.__values__ = toArray(this.value());
	      }
	      var done = this.__index__ >= this.__values__.length,
	          value = done ? undefined : this.__values__[this.__index__++];
	
	      return { 'done': done, 'value': value };
	    }
	
	    /**
	     * Enables the wrapper to be iterable.
	     *
	     * @name Symbol.iterator
	     * @memberOf _
	     * @since 4.0.0
	     * @category Seq
	     * @returns {Object} Returns the wrapper object.
	     * @example
	     *
	     * var wrapped = _([1, 2]);
	     *
	     * wrapped[Symbol.iterator]() === wrapped;
	     * // => true
	     *
	     * Array.from(wrapped);
	     * // => [1, 2]
	     */
	    function wrapperToIterator() {
	      return this;
	    }
	
	    /**
	     * Creates a clone of the chain sequence planting `value` as the wrapped value.
	     *
	     * @name plant
	     * @memberOf _
	     * @since 3.2.0
	     * @category Seq
	     * @param {*} value The value to plant.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var wrapped = _([1, 2]).map(square);
	     * var other = wrapped.plant([3, 4]);
	     *
	     * other.value();
	     * // => [9, 16]
	     *
	     * wrapped.value();
	     * // => [1, 4]
	     */
	    function wrapperPlant(value) {
	      var result,
	          parent = this;
	
	      while (parent instanceof baseLodash) {
	        var clone = wrapperClone(parent);
	        clone.__index__ = 0;
	        clone.__values__ = undefined;
	        if (result) {
	          previous.__wrapped__ = clone;
	        } else {
	          result = clone;
	        }
	        var previous = clone;
	        parent = parent.__wrapped__;
	      }
	      previous.__wrapped__ = value;
	      return result;
	    }
	
	    /**
	     * This method is the wrapper version of `_.reverse`.
	     *
	     * **Note:** This method mutates the wrapped array.
	     *
	     * @name reverse
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _(array).reverse().value()
	     * // => [3, 2, 1]
	     *
	     * console.log(array);
	     * // => [3, 2, 1]
	     */
	    function wrapperReverse() {
	      var value = this.__wrapped__;
	      if (value instanceof LazyWrapper) {
	        var wrapped = value;
	        if (this.__actions__.length) {
	          wrapped = new LazyWrapper(this);
	        }
	        wrapped = wrapped.reverse();
	        wrapped.__actions__.push({
	          'func': thru,
	          'args': [reverse],
	          'thisArg': undefined
	        });
	        return new LodashWrapper(wrapped, this.__chain__);
	      }
	      return this.thru(reverse);
	    }
	
	    /**
	     * Executes the chain sequence to resolve the unwrapped value.
	     *
	     * @name value
	     * @memberOf _
	     * @since 0.1.0
	     * @alias toJSON, valueOf
	     * @category Seq
	     * @returns {*} Returns the resolved unwrapped value.
	     * @example
	     *
	     * _([1, 2, 3]).value();
	     * // => [1, 2, 3]
	     */
	    function wrapperValue() {
	      return baseWrapperValue(this.__wrapped__, this.__actions__);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The corresponding value of
	     * each key is the number of times the key was returned by `iteratee`. The
	     * iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * _.countBy([6.1, 4.2, 6.3], Math.floor);
	     * // => { '4': 1, '6': 2 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.countBy(['one', 'two', 'three'], 'length');
	     * // => { '3': 2, '5': 1 }
	     */
	    var countBy = createAggregator(function(result, value, key) {
	      if (hasOwnProperty.call(result, key)) {
	        ++result[key];
	      } else {
	        baseAssignValue(result, key, 1);
	      }
	    });
	
	    /**
	     * Checks if `predicate` returns truthy for **all** elements of `collection`.
	     * Iteration is stopped once `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index|key, collection).
	     *
	     * **Note:** This method returns `true` for
	     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
	     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
	     * elements of empty collections.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`.
	     * @example
	     *
	     * _.every([true, 1, null, 'yes'], Boolean);
	     * // => false
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': false },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.every(users, { 'user': 'barney', 'active': false });
	     * // => false
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.every(users, ['active', false]);
	     * // => true
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.every(users, 'active');
	     * // => false
	     */
	    function every(collection, predicate, guard) {
	      var func = isArray(collection) ? arrayEvery : baseEvery;
	      if (guard && isIterateeCall(collection, predicate, guard)) {
	        predicate = undefined;
	      }
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Iterates over elements of `collection`, returning an array of all elements
	     * `predicate` returns truthy for. The predicate is invoked with three
	     * arguments: (value, index|key, collection).
	     *
	     * **Note:** Unlike `_.remove`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     * @see _.reject
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * _.filter(users, function(o) { return !o.active; });
	     * // => objects for ['fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.filter(users, { 'age': 36, 'active': true });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.filter(users, ['active', false]);
	     * // => objects for ['fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.filter(users, 'active');
	     * // => objects for ['barney']
	     *
	     * // Combining several predicates using `_.overEvery` or `_.overSome`.
	     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
	     * // => objects for ['fred', 'barney']
	     */
	    function filter(collection, predicate) {
	      var func = isArray(collection) ? arrayFilter : baseFilter;
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Iterates over elements of `collection`, returning the first element
	     * `predicate` returns truthy for. The predicate is invoked with three
	     * arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36, 'active': true },
	     *   { 'user': 'fred',    'age': 40, 'active': false },
	     *   { 'user': 'pebbles', 'age': 1,  'active': true }
	     * ];
	     *
	     * _.find(users, function(o) { return o.age < 40; });
	     * // => object for 'barney'
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.find(users, { 'age': 1, 'active': true });
	     * // => object for 'pebbles'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.find(users, ['active', false]);
	     * // => object for 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.find(users, 'active');
	     * // => object for 'barney'
	     */
	    var find = createFind(findIndex);
	
	    /**
	     * This method is like `_.find` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=collection.length-1] The index to search from.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * _.findLast([1, 2, 3, 4], function(n) {
	     *   return n % 2 == 1;
	     * });
	     * // => 3
	     */
	    var findLast = createFind(findLastIndex);
	
	    /**
	     * Creates a flattened array of values by running each element in `collection`
	     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
	     * with three arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [n, n];
	     * }
	     *
	     * _.flatMap([1, 2], duplicate);
	     * // => [1, 1, 2, 2]
	     */
	    function flatMap(collection, iteratee) {
	      return baseFlatten(map(collection, iteratee), 1);
	    }
	
	    /**
	     * This method is like `_.flatMap` except that it recursively flattens the
	     * mapped results.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [[[n, n]]];
	     * }
	     *
	     * _.flatMapDeep([1, 2], duplicate);
	     * // => [1, 1, 2, 2]
	     */
	    function flatMapDeep(collection, iteratee) {
	      return baseFlatten(map(collection, iteratee), INFINITY);
	    }
	
	    /**
	     * This method is like `_.flatMap` except that it recursively flattens the
	     * mapped results up to `depth` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {number} [depth=1] The maximum recursion depth.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [[[n, n]]];
	     * }
	     *
	     * _.flatMapDepth([1, 2], duplicate, 2);
	     * // => [[1, 1], [2, 2]]
	     */
	    function flatMapDepth(collection, iteratee, depth) {
	      depth = depth === undefined ? 1 : toInteger(depth);
	      return baseFlatten(map(collection, iteratee), depth);
	    }
	
	    /**
	     * Iterates over elements of `collection` and invokes `iteratee` for each element.
	     * The iteratee is invoked with three arguments: (value, index|key, collection).
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * **Note:** As with other "Collections" methods, objects with a "length"
	     * property are iterated like arrays. To avoid this behavior use `_.forIn`
	     * or `_.forOwn` for object iteration.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @alias each
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     * @see _.forEachRight
	     * @example
	     *
	     * _.forEach([1, 2], function(value) {
	     *   console.log(value);
	     * });
	     * // => Logs `1` then `2`.
	     *
	     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	     */
	    function forEach(collection, iteratee) {
	      var func = isArray(collection) ? arrayEach : baseEach;
	      return func(collection, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * This method is like `_.forEach` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @alias eachRight
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     * @see _.forEach
	     * @example
	     *
	     * _.forEachRight([1, 2], function(value) {
	     *   console.log(value);
	     * });
	     * // => Logs `2` then `1`.
	     */
	    function forEachRight(collection, iteratee) {
	      var func = isArray(collection) ? arrayEachRight : baseEachRight;
	      return func(collection, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The order of grouped values
	     * is determined by the order they occur in `collection`. The corresponding
	     * value of each key is an array of elements responsible for generating the
	     * key. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
	     * // => { '4': [4.2], '6': [6.1, 6.3] }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.groupBy(['one', 'two', 'three'], 'length');
	     * // => { '3': ['one', 'two'], '5': ['three'] }
	     */
	    var groupBy = createAggregator(function(result, value, key) {
	      if (hasOwnProperty.call(result, key)) {
	        result[key].push(value);
	      } else {
	        baseAssignValue(result, key, [value]);
	      }
	    });
	
	    /**
	     * Checks if `value` is in `collection`. If `collection` is a string, it's
	     * checked for a substring of `value`, otherwise
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * is used for equality comparisons. If `fromIndex` is negative, it's used as
	     * the offset from the end of `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
	     * @returns {boolean} Returns `true` if `value` is found, else `false`.
	     * @example
	     *
	     * _.includes([1, 2, 3], 1);
	     * // => true
	     *
	     * _.includes([1, 2, 3], 1, 2);
	     * // => false
	     *
	     * _.includes({ 'a': 1, 'b': 2 }, 1);
	     * // => true
	     *
	     * _.includes('abcd', 'bc');
	     * // => true
	     */
	    function includes(collection, value, fromIndex, guard) {
	      collection = isArrayLike(collection) ? collection : values(collection);
	      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;
	
	      var length = collection.length;
	      if (fromIndex < 0) {
	        fromIndex = nativeMax(length + fromIndex, 0);
	      }
	      return isString(collection)
	        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
	        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
	    }
	
	    /**
	     * Invokes the method at `path` of each element in `collection`, returning
	     * an array of the results of each invoked method. Any additional arguments
	     * are provided to each invoked method. If `path` is a function, it's invoked
	     * for, and `this` bound to, each element in `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array|Function|string} path The path of the method to invoke or
	     *  the function invoked per iteration.
	     * @param {...*} [args] The arguments to invoke each method with.
	     * @returns {Array} Returns the array of results.
	     * @example
	     *
	     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
	     * // => [[1, 5, 7], [1, 2, 3]]
	     *
	     * _.invokeMap([123, 456], String.prototype.split, '');
	     * // => [['1', '2', '3'], ['4', '5', '6']]
	     */
	    var invokeMap = baseRest(function(collection, path, args) {
	      var index = -1,
	          isFunc = typeof path == 'function',
	          result = isArrayLike(collection) ? Array(collection.length) : [];
	
	      baseEach(collection, function(value) {
	        result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
	      });
	      return result;
	    });
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The corresponding value of
	     * each key is the last element responsible for generating the key. The
	     * iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * var array = [
	     *   { 'dir': 'left', 'code': 97 },
	     *   { 'dir': 'right', 'code': 100 }
	     * ];
	     *
	     * _.keyBy(array, function(o) {
	     *   return String.fromCharCode(o.code);
	     * });
	     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
	     *
	     * _.keyBy(array, 'dir');
	     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
	     */
	    var keyBy = createAggregator(function(result, value, key) {
	      baseAssignValue(result, key, value);
	    });
	
	    /**
	     * Creates an array of values by running each element in `collection` thru
	     * `iteratee`. The iteratee is invoked with three arguments:
	     * (value, index|key, collection).
	     *
	     * Many lodash methods are guarded to work as iteratees for methods like
	     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
	     *
	     * The guarded methods are:
	     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
	     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
	     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
	     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new mapped array.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * _.map([4, 8], square);
	     * // => [16, 64]
	     *
	     * _.map({ 'a': 4, 'b': 8 }, square);
	     * // => [16, 64] (iteration order is not guaranteed)
	     *
	     * var users = [
	     *   { 'user': 'barney' },
	     *   { 'user': 'fred' }
	     * ];
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.map(users, 'user');
	     * // => ['barney', 'fred']
	     */
	    function map(collection, iteratee) {
	      var func = isArray(collection) ? arrayMap : baseMap;
	      return func(collection, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * This method is like `_.sortBy` except that it allows specifying the sort
	     * orders of the iteratees to sort by. If `orders` is unspecified, all values
	     * are sorted in ascending order. Otherwise, specify an order of "desc" for
	     * descending or "asc" for ascending sort order of corresponding values.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
	     *  The iteratees to sort by.
	     * @param {string[]} [orders] The sort orders of `iteratees`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'fred',   'age': 48 },
	     *   { 'user': 'barney', 'age': 34 },
	     *   { 'user': 'fred',   'age': 40 },
	     *   { 'user': 'barney', 'age': 36 }
	     * ];
	     *
	     * // Sort by `user` in ascending order and by `age` in descending order.
	     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
	     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
	     */
	    function orderBy(collection, iteratees, orders, guard) {
	      if (collection == null) {
	        return [];
	      }
	      if (!isArray(iteratees)) {
	        iteratees = iteratees == null ? [] : [iteratees];
	      }
	      orders = guard ? undefined : orders;
	      if (!isArray(orders)) {
	        orders = orders == null ? [] : [orders];
	      }
	      return baseOrderBy(collection, iteratees, orders);
	    }
	
	    /**
	     * Creates an array of elements split into two groups, the first of which
	     * contains elements `predicate` returns truthy for, the second of which
	     * contains elements `predicate` returns falsey for. The predicate is
	     * invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the array of grouped elements.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36, 'active': false },
	     *   { 'user': 'fred',    'age': 40, 'active': true },
	     *   { 'user': 'pebbles', 'age': 1,  'active': false }
	     * ];
	     *
	     * _.partition(users, function(o) { return o.active; });
	     * // => objects for [['fred'], ['barney', 'pebbles']]
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.partition(users, { 'age': 1, 'active': false });
	     * // => objects for [['pebbles'], ['barney', 'fred']]
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.partition(users, ['active', false]);
	     * // => objects for [['barney', 'pebbles'], ['fred']]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.partition(users, 'active');
	     * // => objects for [['fred'], ['barney', 'pebbles']]
	     */
	    var partition = createAggregator(function(result, value, key) {
	      result[key ? 0 : 1].push(value);
	    }, function() { return [[], []]; });
	
	    /**
	     * Reduces `collection` to a value which is the accumulated result of running
	     * each element in `collection` thru `iteratee`, where each successive
	     * invocation is supplied the return value of the previous. If `accumulator`
	     * is not given, the first element of `collection` is used as the initial
	     * value. The iteratee is invoked with four arguments:
	     * (accumulator, value, index|key, collection).
	     *
	     * Many lodash methods are guarded to work as iteratees for methods like
	     * `_.reduce`, `_.reduceRight`, and `_.transform`.
	     *
	     * The guarded methods are:
	     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
	     * and `sortBy`
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @returns {*} Returns the accumulated value.
	     * @see _.reduceRight
	     * @example
	     *
	     * _.reduce([1, 2], function(sum, n) {
	     *   return sum + n;
	     * }, 0);
	     * // => 3
	     *
	     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
	     *   (result[value] || (result[value] = [])).push(key);
	     *   return result;
	     * }, {});
	     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
	     */
	    function reduce(collection, iteratee, accumulator) {
	      var func = isArray(collection) ? arrayReduce : baseReduce,
	          initAccum = arguments.length < 3;
	
	      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
	    }
	
	    /**
	     * This method is like `_.reduce` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @returns {*} Returns the accumulated value.
	     * @see _.reduce
	     * @example
	     *
	     * var array = [[0, 1], [2, 3], [4, 5]];
	     *
	     * _.reduceRight(array, function(flattened, other) {
	     *   return flattened.concat(other);
	     * }, []);
	     * // => [4, 5, 2, 3, 0, 1]
	     */
	    function reduceRight(collection, iteratee, accumulator) {
	      var func = isArray(collection) ? arrayReduceRight : baseReduce,
	          initAccum = arguments.length < 3;
	
	      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
	    }
	
	    /**
	     * The opposite of `_.filter`; this method returns the elements of `collection`
	     * that `predicate` does **not** return truthy for.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     * @see _.filter
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': false },
	     *   { 'user': 'fred',   'age': 40, 'active': true }
	     * ];
	     *
	     * _.reject(users, function(o) { return !o.active; });
	     * // => objects for ['fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.reject(users, { 'age': 40, 'active': true });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.reject(users, ['active', false]);
	     * // => objects for ['fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.reject(users, 'active');
	     * // => objects for ['barney']
	     */
	    function reject(collection, predicate) {
	      var func = isArray(collection) ? arrayFilter : baseFilter;
	      return func(collection, negate(getIteratee(predicate, 3)));
	    }
	
	    /**
	     * Gets a random element from `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to sample.
	     * @returns {*} Returns the random element.
	     * @example
	     *
	     * _.sample([1, 2, 3, 4]);
	     * // => 2
	     */
	    function sample(collection) {
	      var func = isArray(collection) ? arraySample : baseSample;
	      return func(collection);
	    }
	
	    /**
	     * Gets `n` random elements at unique keys from `collection` up to the
	     * size of `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to sample.
	     * @param {number} [n=1] The number of elements to sample.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the random elements.
	     * @example
	     *
	     * _.sampleSize([1, 2, 3], 2);
	     * // => [3, 1]
	     *
	     * _.sampleSize([1, 2, 3], 4);
	     * // => [2, 3, 1]
	     */
	    function sampleSize(collection, n, guard) {
	      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
	        n = 1;
	      } else {
	        n = toInteger(n);
	      }
	      var func = isArray(collection) ? arraySampleSize : baseSampleSize;
	      return func(collection, n);
	    }
	
	    /**
	     * Creates an array of shuffled values, using a version of the
	     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     * @example
	     *
	     * _.shuffle([1, 2, 3, 4]);
	     * // => [4, 1, 3, 2]
	     */
	    function shuffle(collection) {
	      var func = isArray(collection) ? arrayShuffle : baseShuffle;
	      return func(collection);
	    }
	
	    /**
	     * Gets the size of `collection` by returning its length for array-like
	     * values or the number of own enumerable string keyed properties for objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to inspect.
	     * @returns {number} Returns the collection size.
	     * @example
	     *
	     * _.size([1, 2, 3]);
	     * // => 3
	     *
	     * _.size({ 'a': 1, 'b': 2 });
	     * // => 2
	     *
	     * _.size('pebbles');
	     * // => 7
	     */
	    function size(collection) {
	      if (collection == null) {
	        return 0;
	      }
	      if (isArrayLike(collection)) {
	        return isString(collection) ? stringSize(collection) : collection.length;
	      }
	      var tag = getTag(collection);
	      if (tag == mapTag || tag == setTag) {
	        return collection.size;
	      }
	      return baseKeys(collection).length;
	    }
	
	    /**
	     * Checks if `predicate` returns truthy for **any** element of `collection`.
	     * Iteration is stopped once `predicate` returns truthy. The predicate is
	     * invoked with three arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     * @example
	     *
	     * _.some([null, 0, 'yes', false], Boolean);
	     * // => true
	     *
	     * var users = [
	     *   { 'user': 'barney', 'active': true },
	     *   { 'user': 'fred',   'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.some(users, { 'user': 'barney', 'active': false });
	     * // => false
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.some(users, ['active', false]);
	     * // => true
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.some(users, 'active');
	     * // => true
	     */
	    function some(collection, predicate, guard) {
	      var func = isArray(collection) ? arraySome : baseSome;
	      if (guard && isIterateeCall(collection, predicate, guard)) {
	        predicate = undefined;
	      }
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Creates an array of elements, sorted in ascending order by the results of
	     * running each element in a collection thru each iteratee. This method
	     * performs a stable sort, that is, it preserves the original sort order of
	     * equal elements. The iteratees are invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {...(Function|Function[])} [iteratees=[_.identity]]
	     *  The iteratees to sort by.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'fred',   'age': 48 },
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 30 },
	     *   { 'user': 'barney', 'age': 34 }
	     * ];
	     *
	     * _.sortBy(users, [function(o) { return o.user; }]);
	     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
	     *
	     * _.sortBy(users, ['user', 'age']);
	     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
	     */
	    var sortBy = baseRest(function(collection, iteratees) {
	      if (collection == null) {
	        return [];
	      }
	      var length = iteratees.length;
	      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
	        iteratees = [];
	      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
	        iteratees = [iteratees[0]];
	      }
	      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
	    });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Gets the timestamp of the number of milliseconds that have elapsed since
	     * the Unix epoch (1 January 1970 00:00:00 UTC).
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Date
	     * @returns {number} Returns the timestamp.
	     * @example
	     *
	     * _.defer(function(stamp) {
	     *   console.log(_.now() - stamp);
	     * }, _.now());
	     * // => Logs the number of milliseconds it took for the deferred invocation.
	     */
	    var now = ctxNow || function() {
	      return root.Date.now();
	    };
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * The opposite of `_.before`; this method creates a function that invokes
	     * `func` once it's called `n` or more times.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {number} n The number of calls before `func` is invoked.
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * var saves = ['profile', 'settings'];
	     *
	     * var done = _.after(saves.length, function() {
	     *   console.log('done saving!');
	     * });
	     *
	     * _.forEach(saves, function(type) {
	     *   asyncSave({ 'type': type, 'complete': done });
	     * });
	     * // => Logs 'done saving!' after the two async saves have completed.
	     */
	    function after(n, func) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      n = toInteger(n);
	      return function() {
	        if (--n < 1) {
	          return func.apply(this, arguments);
	        }
	      };
	    }
	
	    /**
	     * Creates a function that invokes `func`, with up to `n` arguments,
	     * ignoring any additional arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to cap arguments for.
	     * @param {number} [n=func.length] The arity cap.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new capped function.
	     * @example
	     *
	     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
	     * // => [6, 8, 10]
	     */
	    function ary(func, n, guard) {
	      n = guard ? undefined : n;
	      n = (func && n == null) ? func.length : n;
	      return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
	    }
	
	    /**
	     * Creates a function that invokes `func`, with the `this` binding and arguments
	     * of the created function, while it's called less than `n` times. Subsequent
	     * calls to the created function return the result of the last `func` invocation.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {number} n The number of calls at which `func` is no longer invoked.
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * jQuery(element).on('click', _.before(5, addContactToList));
	     * // => Allows adding up to 4 contacts to the list.
	     */
	    function before(n, func) {
	      var result;
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      n = toInteger(n);
	      return function() {
	        if (--n > 0) {
	          result = func.apply(this, arguments);
	        }
	        if (n <= 1) {
	          func = undefined;
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of `thisArg`
	     * and `partials` prepended to the arguments it receives.
	     *
	     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
	     * may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
	     * property of bound functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to bind.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new bound function.
	     * @example
	     *
	     * function greet(greeting, punctuation) {
	     *   return greeting + ' ' + this.user + punctuation;
	     * }
	     *
	     * var object = { 'user': 'fred' };
	     *
	     * var bound = _.bind(greet, object, 'hi');
	     * bound('!');
	     * // => 'hi fred!'
	     *
	     * // Bound with placeholders.
	     * var bound = _.bind(greet, object, _, '!');
	     * bound('hi');
	     * // => 'hi fred!'
	     */
	    var bind = baseRest(function(func, thisArg, partials) {
	      var bitmask = WRAP_BIND_FLAG;
	      if (partials.length) {
	        var holders = replaceHolders(partials, getHolder(bind));
	        bitmask |= WRAP_PARTIAL_FLAG;
	      }
	      return createWrap(func, bitmask, thisArg, partials, holders);
	    });
	
	    /**
	     * Creates a function that invokes the method at `object[key]` with `partials`
	     * prepended to the arguments it receives.
	     *
	     * This method differs from `_.bind` by allowing bound functions to reference
	     * methods that may be redefined or don't yet exist. See
	     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
	     * for more details.
	     *
	     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.10.0
	     * @category Function
	     * @param {Object} object The object to invoke the method on.
	     * @param {string} key The key of the method.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new bound function.
	     * @example
	     *
	     * var object = {
	     *   'user': 'fred',
	     *   'greet': function(greeting, punctuation) {
	     *     return greeting + ' ' + this.user + punctuation;
	     *   }
	     * };
	     *
	     * var bound = _.bindKey(object, 'greet', 'hi');
	     * bound('!');
	     * // => 'hi fred!'
	     *
	     * object.greet = function(greeting, punctuation) {
	     *   return greeting + 'ya ' + this.user + punctuation;
	     * };
	     *
	     * bound('!');
	     * // => 'hiya fred!'
	     *
	     * // Bound with placeholders.
	     * var bound = _.bindKey(object, 'greet', _, '!');
	     * bound('hi');
	     * // => 'hiya fred!'
	     */
	    var bindKey = baseRest(function(object, key, partials) {
	      var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
	      if (partials.length) {
	        var holders = replaceHolders(partials, getHolder(bindKey));
	        bitmask |= WRAP_PARTIAL_FLAG;
	      }
	      return createWrap(key, bitmask, object, partials, holders);
	    });
	
	    /**
	     * Creates a function that accepts arguments of `func` and either invokes
	     * `func` returning its result, if at least `arity` number of arguments have
	     * been provided, or returns a function that accepts the remaining `func`
	     * arguments, and so on. The arity of `func` may be specified if `func.length`
	     * is not sufficient.
	     *
	     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
	     * may be used as a placeholder for provided arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of curried functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Function
	     * @param {Function} func The function to curry.
	     * @param {number} [arity=func.length] The arity of `func`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new curried function.
	     * @example
	     *
	     * var abc = function(a, b, c) {
	     *   return [a, b, c];
	     * };
	     *
	     * var curried = _.curry(abc);
	     *
	     * curried(1)(2)(3);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2)(3);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2, 3);
	     * // => [1, 2, 3]
	     *
	     * // Curried with placeholders.
	     * curried(1)(_, 3)(2);
	     * // => [1, 2, 3]
	     */
	    function curry(func, arity, guard) {
	      arity = guard ? undefined : arity;
	      var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
	      result.placeholder = curry.placeholder;
	      return result;
	    }
	
	    /**
	     * This method is like `_.curry` except that arguments are applied to `func`
	     * in the manner of `_.partialRight` instead of `_.partial`.
	     *
	     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for provided arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of curried functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to curry.
	     * @param {number} [arity=func.length] The arity of `func`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new curried function.
	     * @example
	     *
	     * var abc = function(a, b, c) {
	     *   return [a, b, c];
	     * };
	     *
	     * var curried = _.curryRight(abc);
	     *
	     * curried(3)(2)(1);
	     * // => [1, 2, 3]
	     *
	     * curried(2, 3)(1);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2, 3);
	     * // => [1, 2, 3]
	     *
	     * // Curried with placeholders.
	     * curried(3)(1, _)(2);
	     * // => [1, 2, 3]
	     */
	    function curryRight(func, arity, guard) {
	      arity = guard ? undefined : arity;
	      var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
	      result.placeholder = curryRight.placeholder;
	      return result;
	    }
	
	    /**
	     * Creates a debounced function that delays invoking `func` until after `wait`
	     * milliseconds have elapsed since the last time the debounced function was
	     * invoked. The debounced function comes with a `cancel` method to cancel
	     * delayed `func` invocations and a `flush` method to immediately invoke them.
	     * Provide `options` to indicate whether `func` should be invoked on the
	     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
	     * with the last arguments provided to the debounced function. Subsequent
	     * calls to the debounced function return the result of the last `func`
	     * invocation.
	     *
	     * **Note:** If `leading` and `trailing` options are `true`, `func` is
	     * invoked on the trailing edge of the timeout only if the debounced function
	     * is invoked more than once during the `wait` timeout.
	     *
	     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	     *
	     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	     * for details over the differences between `_.debounce` and `_.throttle`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to debounce.
	     * @param {number} [wait=0] The number of milliseconds to delay.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.leading=false]
	     *  Specify invoking on the leading edge of the timeout.
	     * @param {number} [options.maxWait]
	     *  The maximum time `func` is allowed to be delayed before it's invoked.
	     * @param {boolean} [options.trailing=true]
	     *  Specify invoking on the trailing edge of the timeout.
	     * @returns {Function} Returns the new debounced function.
	     * @example
	     *
	     * // Avoid costly calculations while the window size is in flux.
	     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	     *
	     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
	     * jQuery(element).on('click', _.debounce(sendMail, 300, {
	     *   'leading': true,
	     *   'trailing': false
	     * }));
	     *
	     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
	     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
	     * var source = new EventSource('/stream');
	     * jQuery(source).on('message', debounced);
	     *
	     * // Cancel the trailing debounced invocation.
	     * jQuery(window).on('popstate', debounced.cancel);
	     */
	    function debounce(func, wait, options) {
	      var lastArgs,
	          lastThis,
	          maxWait,
	          result,
	          timerId,
	          lastCallTime,
	          lastInvokeTime = 0,
	          leading = false,
	          maxing = false,
	          trailing = true;
	
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      wait = toNumber(wait) || 0;
	      if (isObject(options)) {
	        leading = !!options.leading;
	        maxing = 'maxWait' in options;
	        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
	        trailing = 'trailing' in options ? !!options.trailing : trailing;
	      }
	
	      function invokeFunc(time) {
	        var args = lastArgs,
	            thisArg = lastThis;
	
	        lastArgs = lastThis = undefined;
	        lastInvokeTime = time;
	        result = func.apply(thisArg, args);
	        return result;
	      }
	
	      function leadingEdge(time) {
	        // Reset any `maxWait` timer.
	        lastInvokeTime = time;
	        // Start the timer for the trailing edge.
	        timerId = setTimeout(timerExpired, wait);
	        // Invoke the leading edge.
	        return leading ? invokeFunc(time) : result;
	      }
	
	      function remainingWait(time) {
	        var timeSinceLastCall = time - lastCallTime,
	            timeSinceLastInvoke = time - lastInvokeTime,
	            timeWaiting = wait - timeSinceLastCall;
	
	        return maxing
	          ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
	          : timeWaiting;
	      }
	
	      function shouldInvoke(time) {
	        var timeSinceLastCall = time - lastCallTime,
	            timeSinceLastInvoke = time - lastInvokeTime;
	
	        // Either this is the first call, activity has stopped and we're at the
	        // trailing edge, the system time has gone backwards and we're treating
	        // it as the trailing edge, or we've hit the `maxWait` limit.
	        return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
	          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
	      }
	
	      function timerExpired() {
	        var time = now();
	        if (shouldInvoke(time)) {
	          return trailingEdge(time);
	        }
	        // Restart the timer.
	        timerId = setTimeout(timerExpired, remainingWait(time));
	      }
	
	      function trailingEdge(time) {
	        timerId = undefined;
	
	        // Only invoke if we have `lastArgs` which means `func` has been
	        // debounced at least once.
	        if (trailing && lastArgs) {
	          return invokeFunc(time);
	        }
	        lastArgs = lastThis = undefined;
	        return result;
	      }
	
	      function cancel() {
	        if (timerId !== undefined) {
	          clearTimeout(timerId);
	        }
	        lastInvokeTime = 0;
	        lastArgs = lastCallTime = lastThis = timerId = undefined;
	      }
	
	      function flush() {
	        return timerId === undefined ? result : trailingEdge(now());
	      }
	
	      function debounced() {
	        var time = now(),
	            isInvoking = shouldInvoke(time);
	
	        lastArgs = arguments;
	        lastThis = this;
	        lastCallTime = time;
	
	        if (isInvoking) {
	          if (timerId === undefined) {
	            return leadingEdge(lastCallTime);
	          }
	          if (maxing) {
	            // Handle invocations in a tight loop.
	            clearTimeout(timerId);
	            timerId = setTimeout(timerExpired, wait);
	            return invokeFunc(lastCallTime);
	          }
	        }
	        if (timerId === undefined) {
	          timerId = setTimeout(timerExpired, wait);
	        }
	        return result;
	      }
	      debounced.cancel = cancel;
	      debounced.flush = flush;
	      return debounced;
	    }
	
	    /**
	     * Defers invoking the `func` until the current call stack has cleared. Any
	     * additional arguments are provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to defer.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {number} Returns the timer id.
	     * @example
	     *
	     * _.defer(function(text) {
	     *   console.log(text);
	     * }, 'deferred');
	     * // => Logs 'deferred' after one millisecond.
	     */
	    var defer = baseRest(function(func, args) {
	      return baseDelay(func, 1, args);
	    });
	
	    /**
	     * Invokes `func` after `wait` milliseconds. Any additional arguments are
	     * provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {number} Returns the timer id.
	     * @example
	     *
	     * _.delay(function(text) {
	     *   console.log(text);
	     * }, 1000, 'later');
	     * // => Logs 'later' after one second.
	     */
	    var delay = baseRest(function(func, wait, args) {
	      return baseDelay(func, toNumber(wait) || 0, args);
	    });
	
	    /**
	     * Creates a function that invokes `func` with arguments reversed.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to flip arguments for.
	     * @returns {Function} Returns the new flipped function.
	     * @example
	     *
	     * var flipped = _.flip(function() {
	     *   return _.toArray(arguments);
	     * });
	     *
	     * flipped('a', 'b', 'c', 'd');
	     * // => ['d', 'c', 'b', 'a']
	     */
	    function flip(func) {
	      return createWrap(func, WRAP_FLIP_FLAG);
	    }
	
	    /**
	     * Creates a function that memoizes the result of `func`. If `resolver` is
	     * provided, it determines the cache key for storing the result based on the
	     * arguments provided to the memoized function. By default, the first argument
	     * provided to the memoized function is used as the map cache key. The `func`
	     * is invoked with the `this` binding of the memoized function.
	     *
	     * **Note:** The cache is exposed as the `cache` property on the memoized
	     * function. Its creation may be customized by replacing the `_.memoize.Cache`
	     * constructor with one whose instances implement the
	     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
	     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to have its output memoized.
	     * @param {Function} [resolver] The function to resolve the cache key.
	     * @returns {Function} Returns the new memoized function.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     * var other = { 'c': 3, 'd': 4 };
	     *
	     * var values = _.memoize(_.values);
	     * values(object);
	     * // => [1, 2]
	     *
	     * values(other);
	     * // => [3, 4]
	     *
	     * object.a = 2;
	     * values(object);
	     * // => [1, 2]
	     *
	     * // Modify the result cache.
	     * values.cache.set(object, ['a', 'b']);
	     * values(object);
	     * // => ['a', 'b']
	     *
	     * // Replace `_.memoize.Cache`.
	     * _.memoize.Cache = WeakMap;
	     */
	    function memoize(func, resolver) {
	      if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var memoized = function() {
	        var args = arguments,
	            key = resolver ? resolver.apply(this, args) : args[0],
	            cache = memoized.cache;
	
	        if (cache.has(key)) {
	          return cache.get(key);
	        }
	        var result = func.apply(this, args);
	        memoized.cache = cache.set(key, result) || cache;
	        return result;
	      };
	      memoized.cache = new (memoize.Cache || MapCache);
	      return memoized;
	    }
	
	    // Expose `MapCache`.
	    memoize.Cache = MapCache;
	
	    /**
	     * Creates a function that negates the result of the predicate `func`. The
	     * `func` predicate is invoked with the `this` binding and arguments of the
	     * created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} predicate The predicate to negate.
	     * @returns {Function} Returns the new negated function.
	     * @example
	     *
	     * function isEven(n) {
	     *   return n % 2 == 0;
	     * }
	     *
	     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
	     * // => [1, 3, 5]
	     */
	    function negate(predicate) {
	      if (typeof predicate != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return function() {
	        var args = arguments;
	        switch (args.length) {
	          case 0: return !predicate.call(this);
	          case 1: return !predicate.call(this, args[0]);
	          case 2: return !predicate.call(this, args[0], args[1]);
	          case 3: return !predicate.call(this, args[0], args[1], args[2]);
	        }
	        return !predicate.apply(this, args);
	      };
	    }
	
	    /**
	     * Creates a function that is restricted to invoking `func` once. Repeat calls
	     * to the function return the value of the first invocation. The `func` is
	     * invoked with the `this` binding and arguments of the created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * var initialize = _.once(createApplication);
	     * initialize();
	     * initialize();
	     * // => `createApplication` is invoked once
	     */
	    function once(func) {
	      return before(2, func);
	    }
	
	    /**
	     * Creates a function that invokes `func` with its arguments transformed.
	     *
	     * @static
	     * @since 4.0.0
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to wrap.
	     * @param {...(Function|Function[])} [transforms=[_.identity]]
	     *  The argument transforms.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * function doubled(n) {
	     *   return n * 2;
	     * }
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var func = _.overArgs(function(x, y) {
	     *   return [x, y];
	     * }, [square, doubled]);
	     *
	     * func(9, 3);
	     * // => [81, 6]
	     *
	     * func(10, 5);
	     * // => [100, 10]
	     */
	    var overArgs = castRest(function(func, transforms) {
	      transforms = (transforms.length == 1 && isArray(transforms[0]))
	        ? arrayMap(transforms[0], baseUnary(getIteratee()))
	        : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
	
	      var funcsLength = transforms.length;
	      return baseRest(function(args) {
	        var index = -1,
	            length = nativeMin(args.length, funcsLength);
	
	        while (++index < length) {
	          args[index] = transforms[index].call(this, args[index]);
	        }
	        return apply(func, this, args);
	      });
	    });
	
	    /**
	     * Creates a function that invokes `func` with `partials` prepended to the
	     * arguments it receives. This method is like `_.bind` except it does **not**
	     * alter the `this` binding.
	     *
	     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of partially
	     * applied functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.2.0
	     * @category Function
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new partially applied function.
	     * @example
	     *
	     * function greet(greeting, name) {
	     *   return greeting + ' ' + name;
	     * }
	     *
	     * var sayHelloTo = _.partial(greet, 'hello');
	     * sayHelloTo('fred');
	     * // => 'hello fred'
	     *
	     * // Partially applied with placeholders.
	     * var greetFred = _.partial(greet, _, 'fred');
	     * greetFred('hi');
	     * // => 'hi fred'
	     */
	    var partial = baseRest(function(func, partials) {
	      var holders = replaceHolders(partials, getHolder(partial));
	      return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
	    });
	
	    /**
	     * This method is like `_.partial` except that partially applied arguments
	     * are appended to the arguments it receives.
	     *
	     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of partially
	     * applied functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Function
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new partially applied function.
	     * @example
	     *
	     * function greet(greeting, name) {
	     *   return greeting + ' ' + name;
	     * }
	     *
	     * var greetFred = _.partialRight(greet, 'fred');
	     * greetFred('hi');
	     * // => 'hi fred'
	     *
	     * // Partially applied with placeholders.
	     * var sayHelloTo = _.partialRight(greet, 'hello', _);
	     * sayHelloTo('fred');
	     * // => 'hello fred'
	     */
	    var partialRight = baseRest(function(func, partials) {
	      var holders = replaceHolders(partials, getHolder(partialRight));
	      return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
	    });
	
	    /**
	     * Creates a function that invokes `func` with arguments arranged according
	     * to the specified `indexes` where the argument value at the first index is
	     * provided as the first argument, the argument value at the second index is
	     * provided as the second argument, and so on.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to rearrange arguments for.
	     * @param {...(number|number[])} indexes The arranged argument indexes.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var rearged = _.rearg(function(a, b, c) {
	     *   return [a, b, c];
	     * }, [2, 0, 1]);
	     *
	     * rearged('b', 'c', 'a')
	     * // => ['a', 'b', 'c']
	     */
	    var rearg = flatRest(function(func, indexes) {
	      return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
	    });
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of the
	     * created function and arguments from `start` and beyond provided as
	     * an array.
	     *
	     * **Note:** This method is based on the
	     * [rest parameter](https://mdn.io/rest_parameters).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var say = _.rest(function(what, names) {
	     *   return what + ' ' + _.initial(names).join(', ') +
	     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
	     * });
	     *
	     * say('hello', 'fred', 'barney', 'pebbles');
	     * // => 'hello fred, barney, & pebbles'
	     */
	    function rest(func, start) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      start = start === undefined ? start : toInteger(start);
	      return baseRest(func, start);
	    }
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of the
	     * create function and an array of arguments much like
	     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
	     *
	     * **Note:** This method is based on the
	     * [spread operator](https://mdn.io/spread_operator).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Function
	     * @param {Function} func The function to spread arguments over.
	     * @param {number} [start=0] The start position of the spread.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var say = _.spread(function(who, what) {
	     *   return who + ' says ' + what;
	     * });
	     *
	     * say(['fred', 'hello']);
	     * // => 'fred says hello'
	     *
	     * var numbers = Promise.all([
	     *   Promise.resolve(40),
	     *   Promise.resolve(36)
	     * ]);
	     *
	     * numbers.then(_.spread(function(x, y) {
	     *   return x + y;
	     * }));
	     * // => a Promise of 76
	     */
	    function spread(func, start) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      start = start == null ? 0 : nativeMax(toInteger(start), 0);
	      return baseRest(function(args) {
	        var array = args[start],
	            otherArgs = castSlice(args, 0, start);
	
	        if (array) {
	          arrayPush(otherArgs, array);
	        }
	        return apply(func, this, otherArgs);
	      });
	    }
	
	    /**
	     * Creates a throttled function that only invokes `func` at most once per
	     * every `wait` milliseconds. The throttled function comes with a `cancel`
	     * method to cancel delayed `func` invocations and a `flush` method to
	     * immediately invoke them. Provide `options` to indicate whether `func`
	     * should be invoked on the leading and/or trailing edge of the `wait`
	     * timeout. The `func` is invoked with the last arguments provided to the
	     * throttled function. Subsequent calls to the throttled function return the
	     * result of the last `func` invocation.
	     *
	     * **Note:** If `leading` and `trailing` options are `true`, `func` is
	     * invoked on the trailing edge of the timeout only if the throttled function
	     * is invoked more than once during the `wait` timeout.
	     *
	     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	     *
	     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	     * for details over the differences between `_.throttle` and `_.debounce`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to throttle.
	     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.leading=true]
	     *  Specify invoking on the leading edge of the timeout.
	     * @param {boolean} [options.trailing=true]
	     *  Specify invoking on the trailing edge of the timeout.
	     * @returns {Function} Returns the new throttled function.
	     * @example
	     *
	     * // Avoid excessively updating the position while scrolling.
	     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
	     *
	     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
	     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
	     * jQuery(element).on('click', throttled);
	     *
	     * // Cancel the trailing throttled invocation.
	     * jQuery(window).on('popstate', throttled.cancel);
	     */
	    function throttle(func, wait, options) {
	      var leading = true,
	          trailing = true;
	
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      if (isObject(options)) {
	        leading = 'leading' in options ? !!options.leading : leading;
	        trailing = 'trailing' in options ? !!options.trailing : trailing;
	      }
	      return debounce(func, wait, {
	        'leading': leading,
	        'maxWait': wait,
	        'trailing': trailing
	      });
	    }
	
	    /**
	     * Creates a function that accepts up to one argument, ignoring any
	     * additional arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to cap arguments for.
	     * @returns {Function} Returns the new capped function.
	     * @example
	     *
	     * _.map(['6', '8', '10'], _.unary(parseInt));
	     * // => [6, 8, 10]
	     */
	    function unary(func) {
	      return ary(func, 1);
	    }
	
	    /**
	     * Creates a function that provides `value` to `wrapper` as its first
	     * argument. Any additional arguments provided to the function are appended
	     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
	     * binding of the created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {*} value The value to wrap.
	     * @param {Function} [wrapper=identity] The wrapper function.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var p = _.wrap(_.escape, function(func, text) {
	     *   return '<p>' + func(text) + '</p>';
	     * });
	     *
	     * p('fred, barney, & pebbles');
	     * // => '<p>fred, barney, &amp; pebbles</p>'
	     */
	    function wrap(value, wrapper) {
	      return partial(castFunction(wrapper), value);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Casts `value` as an array if it's not one.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.4.0
	     * @category Lang
	     * @param {*} value The value to inspect.
	     * @returns {Array} Returns the cast array.
	     * @example
	     *
	     * _.castArray(1);
	     * // => [1]
	     *
	     * _.castArray({ 'a': 1 });
	     * // => [{ 'a': 1 }]
	     *
	     * _.castArray('abc');
	     * // => ['abc']
	     *
	     * _.castArray(null);
	     * // => [null]
	     *
	     * _.castArray(undefined);
	     * // => [undefined]
	     *
	     * _.castArray();
	     * // => []
	     *
	     * var array = [1, 2, 3];
	     * console.log(_.castArray(array) === array);
	     * // => true
	     */
	    function castArray() {
	      if (!arguments.length) {
	        return [];
	      }
	      var value = arguments[0];
	      return isArray(value) ? value : [value];
	    }
	
	    /**
	     * Creates a shallow clone of `value`.
	     *
	     * **Note:** This method is loosely based on the
	     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
	     * and supports cloning arrays, array buffers, booleans, date objects, maps,
	     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
	     * arrays. The own enumerable properties of `arguments` objects are cloned
	     * as plain objects. An empty object is returned for uncloneable values such
	     * as error objects, functions, DOM nodes, and WeakMaps.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to clone.
	     * @returns {*} Returns the cloned value.
	     * @see _.cloneDeep
	     * @example
	     *
	     * var objects = [{ 'a': 1 }, { 'b': 2 }];
	     *
	     * var shallow = _.clone(objects);
	     * console.log(shallow[0] === objects[0]);
	     * // => true
	     */
	    function clone(value) {
	      return baseClone(value, CLONE_SYMBOLS_FLAG);
	    }
	
	    /**
	     * This method is like `_.clone` except that it accepts `customizer` which
	     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
	     * cloning is handled by the method instead. The `customizer` is invoked with
	     * up to four arguments; (value [, index|key, object, stack]).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to clone.
	     * @param {Function} [customizer] The function to customize cloning.
	     * @returns {*} Returns the cloned value.
	     * @see _.cloneDeepWith
	     * @example
	     *
	     * function customizer(value) {
	     *   if (_.isElement(value)) {
	     *     return value.cloneNode(false);
	     *   }
	     * }
	     *
	     * var el = _.cloneWith(document.body, customizer);
	     *
	     * console.log(el === document.body);
	     * // => false
	     * console.log(el.nodeName);
	     * // => 'BODY'
	     * console.log(el.childNodes.length);
	     * // => 0
	     */
	    function cloneWith(value, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
	    }
	
	    /**
	     * This method is like `_.clone` except that it recursively clones `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Lang
	     * @param {*} value The value to recursively clone.
	     * @returns {*} Returns the deep cloned value.
	     * @see _.clone
	     * @example
	     *
	     * var objects = [{ 'a': 1 }, { 'b': 2 }];
	     *
	     * var deep = _.cloneDeep(objects);
	     * console.log(deep[0] === objects[0]);
	     * // => false
	     */
	    function cloneDeep(value) {
	      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
	    }
	
	    /**
	     * This method is like `_.cloneWith` except that it recursively clones `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to recursively clone.
	     * @param {Function} [customizer] The function to customize cloning.
	     * @returns {*} Returns the deep cloned value.
	     * @see _.cloneWith
	     * @example
	     *
	     * function customizer(value) {
	     *   if (_.isElement(value)) {
	     *     return value.cloneNode(true);
	     *   }
	     * }
	     *
	     * var el = _.cloneDeepWith(document.body, customizer);
	     *
	     * console.log(el === document.body);
	     * // => false
	     * console.log(el.nodeName);
	     * // => 'BODY'
	     * console.log(el.childNodes.length);
	     * // => 20
	     */
	    function cloneDeepWith(value, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
	    }
	
	    /**
	     * Checks if `object` conforms to `source` by invoking the predicate
	     * properties of `source` with the corresponding property values of `object`.
	     *
	     * **Note:** This method is equivalent to `_.conforms` when `source` is
	     * partially applied.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.14.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     *
	     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
	     * // => true
	     *
	     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
	     * // => false
	     */
	    function conformsTo(object, source) {
	      return source == null || baseConformsTo(object, source, keys(source));
	    }
	
	    /**
	     * Performs a
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * comparison between two values to determine if they are equivalent.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     * var other = { 'a': 1 };
	     *
	     * _.eq(object, object);
	     * // => true
	     *
	     * _.eq(object, other);
	     * // => false
	     *
	     * _.eq('a', 'a');
	     * // => true
	     *
	     * _.eq('a', Object('a'));
	     * // => false
	     *
	     * _.eq(NaN, NaN);
	     * // => true
	     */
	    function eq(value, other) {
	      return value === other || (value !== value && other !== other);
	    }
	
	    /**
	     * Checks if `value` is greater than `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than `other`,
	     *  else `false`.
	     * @see _.lt
	     * @example
	     *
	     * _.gt(3, 1);
	     * // => true
	     *
	     * _.gt(3, 3);
	     * // => false
	     *
	     * _.gt(1, 3);
	     * // => false
	     */
	    var gt = createRelationalOperation(baseGt);
	
	    /**
	     * Checks if `value` is greater than or equal to `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than or equal to
	     *  `other`, else `false`.
	     * @see _.lte
	     * @example
	     *
	     * _.gte(3, 1);
	     * // => true
	     *
	     * _.gte(3, 3);
	     * // => true
	     *
	     * _.gte(1, 3);
	     * // => false
	     */
	    var gte = createRelationalOperation(function(value, other) {
	      return value >= other;
	    });
	
	    /**
	     * Checks if `value` is likely an `arguments` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	     *  else `false`.
	     * @example
	     *
	     * _.isArguments(function() { return arguments; }());
	     * // => true
	     *
	     * _.isArguments([1, 2, 3]);
	     * // => false
	     */
	    var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
	      return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
	        !propertyIsEnumerable.call(value, 'callee');
	    };
	
	    /**
	     * Checks if `value` is classified as an `Array` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	     * @example
	     *
	     * _.isArray([1, 2, 3]);
	     * // => true
	     *
	     * _.isArray(document.body.children);
	     * // => false
	     *
	     * _.isArray('abc');
	     * // => false
	     *
	     * _.isArray(_.noop);
	     * // => false
	     */
	    var isArray = Array.isArray;
	
	    /**
	     * Checks if `value` is classified as an `ArrayBuffer` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
	     * @example
	     *
	     * _.isArrayBuffer(new ArrayBuffer(2));
	     * // => true
	     *
	     * _.isArrayBuffer(new Array(2));
	     * // => false
	     */
	    var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
	
	    /**
	     * Checks if `value` is array-like. A value is considered array-like if it's
	     * not a function and has a `value.length` that's an integer greater than or
	     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	     * @example
	     *
	     * _.isArrayLike([1, 2, 3]);
	     * // => true
	     *
	     * _.isArrayLike(document.body.children);
	     * // => true
	     *
	     * _.isArrayLike('abc');
	     * // => true
	     *
	     * _.isArrayLike(_.noop);
	     * // => false
	     */
	    function isArrayLike(value) {
	      return value != null && isLength(value.length) && !isFunction(value);
	    }
	
	    /**
	     * This method is like `_.isArrayLike` except that it also checks if `value`
	     * is an object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array-like object,
	     *  else `false`.
	     * @example
	     *
	     * _.isArrayLikeObject([1, 2, 3]);
	     * // => true
	     *
	     * _.isArrayLikeObject(document.body.children);
	     * // => true
	     *
	     * _.isArrayLikeObject('abc');
	     * // => false
	     *
	     * _.isArrayLikeObject(_.noop);
	     * // => false
	     */
	    function isArrayLikeObject(value) {
	      return isObjectLike(value) && isArrayLike(value);
	    }
	
	    /**
	     * Checks if `value` is classified as a boolean primitive or object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
	     * @example
	     *
	     * _.isBoolean(false);
	     * // => true
	     *
	     * _.isBoolean(null);
	     * // => false
	     */
	    function isBoolean(value) {
	      return value === true || value === false ||
	        (isObjectLike(value) && baseGetTag(value) == boolTag);
	    }
	
	    /**
	     * Checks if `value` is a buffer.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	     * @example
	     *
	     * _.isBuffer(new Buffer(2));
	     * // => true
	     *
	     * _.isBuffer(new Uint8Array(2));
	     * // => false
	     */
	    var isBuffer = nativeIsBuffer || stubFalse;
	
	    /**
	     * Checks if `value` is classified as a `Date` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
	     * @example
	     *
	     * _.isDate(new Date);
	     * // => true
	     *
	     * _.isDate('Mon April 23 2012');
	     * // => false
	     */
	    var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
	
	    /**
	     * Checks if `value` is likely a DOM element.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
	     * @example
	     *
	     * _.isElement(document.body);
	     * // => true
	     *
	     * _.isElement('<body>');
	     * // => false
	     */
	    function isElement(value) {
	      return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
	    }
	
	    /**
	     * Checks if `value` is an empty object, collection, map, or set.
	     *
	     * Objects are considered empty if they have no own enumerable string keyed
	     * properties.
	     *
	     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
	     * jQuery-like collections are considered empty if they have a `length` of `0`.
	     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
	     * @example
	     *
	     * _.isEmpty(null);
	     * // => true
	     *
	     * _.isEmpty(true);
	     * // => true
	     *
	     * _.isEmpty(1);
	     * // => true
	     *
	     * _.isEmpty([1, 2, 3]);
	     * // => false
	     *
	     * _.isEmpty({ 'a': 1 });
	     * // => false
	     */
	    function isEmpty(value) {
	      if (value == null) {
	        return true;
	      }
	      if (isArrayLike(value) &&
	          (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
	            isBuffer(value) || isTypedArray(value) || isArguments(value))) {
	        return !value.length;
	      }
	      var tag = getTag(value);
	      if (tag == mapTag || tag == setTag) {
	        return !value.size;
	      }
	      if (isPrototype(value)) {
	        return !baseKeys(value).length;
	      }
	      for (var key in value) {
	        if (hasOwnProperty.call(value, key)) {
	          return false;
	        }
	      }
	      return true;
	    }
	
	    /**
	     * Performs a deep comparison between two values to determine if they are
	     * equivalent.
	     *
	     * **Note:** This method supports comparing arrays, array buffers, booleans,
	     * date objects, error objects, maps, numbers, `Object` objects, regexes,
	     * sets, strings, symbols, and typed arrays. `Object` objects are compared
	     * by their own, not inherited, enumerable properties. Functions and DOM
	     * nodes are compared by strict equality, i.e. `===`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     * var other = { 'a': 1 };
	     *
	     * _.isEqual(object, other);
	     * // => true
	     *
	     * object === other;
	     * // => false
	     */
	    function isEqual(value, other) {
	      return baseIsEqual(value, other);
	    }
	
	    /**
	     * This method is like `_.isEqual` except that it accepts `customizer` which
	     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
	     * are handled by the method instead. The `customizer` is invoked with up to
	     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * function isGreeting(value) {
	     *   return /^h(?:i|ello)$/.test(value);
	     * }
	     *
	     * function customizer(objValue, othValue) {
	     *   if (isGreeting(objValue) && isGreeting(othValue)) {
	     *     return true;
	     *   }
	     * }
	     *
	     * var array = ['hello', 'goodbye'];
	     * var other = ['hi', 'goodbye'];
	     *
	     * _.isEqualWith(array, other, customizer);
	     * // => true
	     */
	    function isEqualWith(value, other, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      var result = customizer ? customizer(value, other) : undefined;
	      return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
	    }
	
	    /**
	     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
	     * `SyntaxError`, `TypeError`, or `URIError` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
	     * @example
	     *
	     * _.isError(new Error);
	     * // => true
	     *
	     * _.isError(Error);
	     * // => false
	     */
	    function isError(value) {
	      if (!isObjectLike(value)) {
	        return false;
	      }
	      var tag = baseGetTag(value);
	      return tag == errorTag || tag == domExcTag ||
	        (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
	    }
	
	    /**
	     * Checks if `value` is a finite primitive number.
	     *
	     * **Note:** This method is based on
	     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
	     * @example
	     *
	     * _.isFinite(3);
	     * // => true
	     *
	     * _.isFinite(Number.MIN_VALUE);
	     * // => true
	     *
	     * _.isFinite(Infinity);
	     * // => false
	     *
	     * _.isFinite('3');
	     * // => false
	     */
	    function isFinite(value) {
	      return typeof value == 'number' && nativeIsFinite(value);
	    }
	
	    /**
	     * Checks if `value` is classified as a `Function` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	     * @example
	     *
	     * _.isFunction(_);
	     * // => true
	     *
	     * _.isFunction(/abc/);
	     * // => false
	     */
	    function isFunction(value) {
	      if (!isObject(value)) {
	        return false;
	      }
	      // The use of `Object#toString` avoids issues with the `typeof` operator
	      // in Safari 9 which returns 'object' for typed arrays and other constructors.
	      var tag = baseGetTag(value);
	      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
	    }
	
	    /**
	     * Checks if `value` is an integer.
	     *
	     * **Note:** This method is based on
	     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
	     * @example
	     *
	     * _.isInteger(3);
	     * // => true
	     *
	     * _.isInteger(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isInteger(Infinity);
	     * // => false
	     *
	     * _.isInteger('3');
	     * // => false
	     */
	    function isInteger(value) {
	      return typeof value == 'number' && value == toInteger(value);
	    }
	
	    /**
	     * Checks if `value` is a valid array-like length.
	     *
	     * **Note:** This method is loosely based on
	     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	     * @example
	     *
	     * _.isLength(3);
	     * // => true
	     *
	     * _.isLength(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isLength(Infinity);
	     * // => false
	     *
	     * _.isLength('3');
	     * // => false
	     */
	    function isLength(value) {
	      return typeof value == 'number' &&
	        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	    }
	
	    /**
	     * Checks if `value` is the
	     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	     * @example
	     *
	     * _.isObject({});
	     * // => true
	     *
	     * _.isObject([1, 2, 3]);
	     * // => true
	     *
	     * _.isObject(_.noop);
	     * // => true
	     *
	     * _.isObject(null);
	     * // => false
	     */
	    function isObject(value) {
	      var type = typeof value;
	      return value != null && (type == 'object' || type == 'function');
	    }
	
	    /**
	     * Checks if `value` is object-like. A value is object-like if it's not `null`
	     * and has a `typeof` result of "object".
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	     * @example
	     *
	     * _.isObjectLike({});
	     * // => true
	     *
	     * _.isObjectLike([1, 2, 3]);
	     * // => true
	     *
	     * _.isObjectLike(_.noop);
	     * // => false
	     *
	     * _.isObjectLike(null);
	     * // => false
	     */
	    function isObjectLike(value) {
	      return value != null && typeof value == 'object';
	    }
	
	    /**
	     * Checks if `value` is classified as a `Map` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	     * @example
	     *
	     * _.isMap(new Map);
	     * // => true
	     *
	     * _.isMap(new WeakMap);
	     * // => false
	     */
	    var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
	
	    /**
	     * Performs a partial deep comparison between `object` and `source` to
	     * determine if `object` contains equivalent property values.
	     *
	     * **Note:** This method is equivalent to `_.matches` when `source` is
	     * partially applied.
	     *
	     * Partial comparisons will match empty array and empty object `source`
	     * values against any array or object value, respectively. See `_.isEqual`
	     * for a list of supported value comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     *
	     * _.isMatch(object, { 'b': 2 });
	     * // => true
	     *
	     * _.isMatch(object, { 'b': 1 });
	     * // => false
	     */
	    function isMatch(object, source) {
	      return object === source || baseIsMatch(object, source, getMatchData(source));
	    }
	
	    /**
	     * This method is like `_.isMatch` except that it accepts `customizer` which
	     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
	     * are handled by the method instead. The `customizer` is invoked with five
	     * arguments: (objValue, srcValue, index|key, object, source).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     * @example
	     *
	     * function isGreeting(value) {
	     *   return /^h(?:i|ello)$/.test(value);
	     * }
	     *
	     * function customizer(objValue, srcValue) {
	     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
	     *     return true;
	     *   }
	     * }
	     *
	     * var object = { 'greeting': 'hello' };
	     * var source = { 'greeting': 'hi' };
	     *
	     * _.isMatchWith(object, source, customizer);
	     * // => true
	     */
	    function isMatchWith(object, source, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return baseIsMatch(object, source, getMatchData(source), customizer);
	    }
	
	    /**
	     * Checks if `value` is `NaN`.
	     *
	     * **Note:** This method is based on
	     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
	     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
	     * `undefined` and other non-number values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	     * @example
	     *
	     * _.isNaN(NaN);
	     * // => true
	     *
	     * _.isNaN(new Number(NaN));
	     * // => true
	     *
	     * isNaN(undefined);
	     * // => true
	     *
	     * _.isNaN(undefined);
	     * // => false
	     */
	    function isNaN(value) {
	      // An `NaN` primitive is the only value that is not equal to itself.
	      // Perform the `toStringTag` check first to avoid errors with some
	      // ActiveX objects in IE.
	      return isNumber(value) && value != +value;
	    }
	
	    /**
	     * Checks if `value` is a pristine native function.
	     *
	     * **Note:** This method can't reliably detect native functions in the presence
	     * of the core-js package because core-js circumvents this kind of detection.
	     * Despite multiple requests, the core-js maintainer has made it clear: any
	     * attempt to fix the detection will be obstructed. As a result, we're left
	     * with little choice but to throw an error. Unfortunately, this also affects
	     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
	     * which rely on core-js.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a native function,
	     *  else `false`.
	     * @example
	     *
	     * _.isNative(Array.prototype.push);
	     * // => true
	     *
	     * _.isNative(_);
	     * // => false
	     */
	    function isNative(value) {
	      if (isMaskable(value)) {
	        throw new Error(CORE_ERROR_TEXT);
	      }
	      return baseIsNative(value);
	    }
	
	    /**
	     * Checks if `value` is `null`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
	     * @example
	     *
	     * _.isNull(null);
	     * // => true
	     *
	     * _.isNull(void 0);
	     * // => false
	     */
	    function isNull(value) {
	      return value === null;
	    }
	
	    /**
	     * Checks if `value` is `null` or `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
	     * @example
	     *
	     * _.isNil(null);
	     * // => true
	     *
	     * _.isNil(void 0);
	     * // => true
	     *
	     * _.isNil(NaN);
	     * // => false
	     */
	    function isNil(value) {
	      return value == null;
	    }
	
	    /**
	     * Checks if `value` is classified as a `Number` primitive or object.
	     *
	     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
	     * classified as numbers, use the `_.isFinite` method.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
	     * @example
	     *
	     * _.isNumber(3);
	     * // => true
	     *
	     * _.isNumber(Number.MIN_VALUE);
	     * // => true
	     *
	     * _.isNumber(Infinity);
	     * // => true
	     *
	     * _.isNumber('3');
	     * // => false
	     */
	    function isNumber(value) {
	      return typeof value == 'number' ||
	        (isObjectLike(value) && baseGetTag(value) == numberTag);
	    }
	
	    /**
	     * Checks if `value` is a plain object, that is, an object created by the
	     * `Object` constructor or one with a `[[Prototype]]` of `null`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.8.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * _.isPlainObject(new Foo);
	     * // => false
	     *
	     * _.isPlainObject([1, 2, 3]);
	     * // => false
	     *
	     * _.isPlainObject({ 'x': 0, 'y': 0 });
	     * // => true
	     *
	     * _.isPlainObject(Object.create(null));
	     * // => true
	     */
	    function isPlainObject(value) {
	      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
	        return false;
	      }
	      var proto = getPrototype(value);
	      if (proto === null) {
	        return true;
	      }
	      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
	      return typeof Ctor == 'function' && Ctor instanceof Ctor &&
	        funcToString.call(Ctor) == objectCtorString;
	    }
	
	    /**
	     * Checks if `value` is classified as a `RegExp` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
	     * @example
	     *
	     * _.isRegExp(/abc/);
	     * // => true
	     *
	     * _.isRegExp('/abc/');
	     * // => false
	     */
	    var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
	
	    /**
	     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
	     * double precision number which isn't the result of a rounded unsafe integer.
	     *
	     * **Note:** This method is based on
	     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
	     * @example
	     *
	     * _.isSafeInteger(3);
	     * // => true
	     *
	     * _.isSafeInteger(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isSafeInteger(Infinity);
	     * // => false
	     *
	     * _.isSafeInteger('3');
	     * // => false
	     */
	    function isSafeInteger(value) {
	      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
	    }
	
	    /**
	     * Checks if `value` is classified as a `Set` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	     * @example
	     *
	     * _.isSet(new Set);
	     * // => true
	     *
	     * _.isSet(new WeakSet);
	     * // => false
	     */
	    var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
	
	    /**
	     * Checks if `value` is classified as a `String` primitive or object.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
	     * @example
	     *
	     * _.isString('abc');
	     * // => true
	     *
	     * _.isString(1);
	     * // => false
	     */
	    function isString(value) {
	      return typeof value == 'string' ||
	        (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
	    }
	
	    /**
	     * Checks if `value` is classified as a `Symbol` primitive or object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	     * @example
	     *
	     * _.isSymbol(Symbol.iterator);
	     * // => true
	     *
	     * _.isSymbol('abc');
	     * // => false
	     */
	    function isSymbol(value) {
	      return typeof value == 'symbol' ||
	        (isObjectLike(value) && baseGetTag(value) == symbolTag);
	    }
	
	    /**
	     * Checks if `value` is classified as a typed array.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	     * @example
	     *
	     * _.isTypedArray(new Uint8Array);
	     * // => true
	     *
	     * _.isTypedArray([]);
	     * // => false
	     */
	    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
	
	    /**
	     * Checks if `value` is `undefined`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
	     * @example
	     *
	     * _.isUndefined(void 0);
	     * // => true
	     *
	     * _.isUndefined(null);
	     * // => false
	     */
	    function isUndefined(value) {
	      return value === undefined;
	    }
	
	    /**
	     * Checks if `value` is classified as a `WeakMap` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
	     * @example
	     *
	     * _.isWeakMap(new WeakMap);
	     * // => true
	     *
	     * _.isWeakMap(new Map);
	     * // => false
	     */
	    function isWeakMap(value) {
	      return isObjectLike(value) && getTag(value) == weakMapTag;
	    }
	
	    /**
	     * Checks if `value` is classified as a `WeakSet` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
	     * @example
	     *
	     * _.isWeakSet(new WeakSet);
	     * // => true
	     *
	     * _.isWeakSet(new Set);
	     * // => false
	     */
	    function isWeakSet(value) {
	      return isObjectLike(value) && baseGetTag(value) == weakSetTag;
	    }
	
	    /**
	     * Checks if `value` is less than `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than `other`,
	     *  else `false`.
	     * @see _.gt
	     * @example
	     *
	     * _.lt(1, 3);
	     * // => true
	     *
	     * _.lt(3, 3);
	     * // => false
	     *
	     * _.lt(3, 1);
	     * // => false
	     */
	    var lt = createRelationalOperation(baseLt);
	
	    /**
	     * Checks if `value` is less than or equal to `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than or equal to
	     *  `other`, else `false`.
	     * @see _.gte
	     * @example
	     *
	     * _.lte(1, 3);
	     * // => true
	     *
	     * _.lte(3, 3);
	     * // => true
	     *
	     * _.lte(3, 1);
	     * // => false
	     */
	    var lte = createRelationalOperation(function(value, other) {
	      return value <= other;
	    });
	
	    /**
	     * Converts `value` to an array.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {Array} Returns the converted array.
	     * @example
	     *
	     * _.toArray({ 'a': 1, 'b': 2 });
	     * // => [1, 2]
	     *
	     * _.toArray('abc');
	     * // => ['a', 'b', 'c']
	     *
	     * _.toArray(1);
	     * // => []
	     *
	     * _.toArray(null);
	     * // => []
	     */
	    function toArray(value) {
	      if (!value) {
	        return [];
	      }
	      if (isArrayLike(value)) {
	        return isString(value) ? stringToArray(value) : copyArray(value);
	      }
	      if (symIterator && value[symIterator]) {
	        return iteratorToArray(value[symIterator]());
	      }
	      var tag = getTag(value),
	          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);
	
	      return func(value);
	    }
	
	    /**
	     * Converts `value` to a finite number.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.12.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted number.
	     * @example
	     *
	     * _.toFinite(3.2);
	     * // => 3.2
	     *
	     * _.toFinite(Number.MIN_VALUE);
	     * // => 5e-324
	     *
	     * _.toFinite(Infinity);
	     * // => 1.7976931348623157e+308
	     *
	     * _.toFinite('3.2');
	     * // => 3.2
	     */
	    function toFinite(value) {
	      if (!value) {
	        return value === 0 ? value : 0;
	      }
	      value = toNumber(value);
	      if (value === INFINITY || value === -INFINITY) {
	        var sign = (value < 0 ? -1 : 1);
	        return sign * MAX_INTEGER;
	      }
	      return value === value ? value : 0;
	    }
	
	    /**
	     * Converts `value` to an integer.
	     *
	     * **Note:** This method is loosely based on
	     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toInteger(3.2);
	     * // => 3
	     *
	     * _.toInteger(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toInteger(Infinity);
	     * // => 1.7976931348623157e+308
	     *
	     * _.toInteger('3.2');
	     * // => 3
	     */
	    function toInteger(value) {
	      var result = toFinite(value),
	          remainder = result % 1;
	
	      return result === result ? (remainder ? result - remainder : result) : 0;
	    }
	
	    /**
	     * Converts `value` to an integer suitable for use as the length of an
	     * array-like object.
	     *
	     * **Note:** This method is based on
	     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toLength(3.2);
	     * // => 3
	     *
	     * _.toLength(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toLength(Infinity);
	     * // => 4294967295
	     *
	     * _.toLength('3.2');
	     * // => 3
	     */
	    function toLength(value) {
	      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
	    }
	
	    /**
	     * Converts `value` to a number.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to process.
	     * @returns {number} Returns the number.
	     * @example
	     *
	     * _.toNumber(3.2);
	     * // => 3.2
	     *
	     * _.toNumber(Number.MIN_VALUE);
	     * // => 5e-324
	     *
	     * _.toNumber(Infinity);
	     * // => Infinity
	     *
	     * _.toNumber('3.2');
	     * // => 3.2
	     */
	    function toNumber(value) {
	      if (typeof value == 'number') {
	        return value;
	      }
	      if (isSymbol(value)) {
	        return NAN;
	      }
	      if (isObject(value)) {
	        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	        value = isObject(other) ? (other + '') : other;
	      }
	      if (typeof value != 'string') {
	        return value === 0 ? value : +value;
	      }
	      value = baseTrim(value);
	      var isBinary = reIsBinary.test(value);
	      return (isBinary || reIsOctal.test(value))
	        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	        : (reIsBadHex.test(value) ? NAN : +value);
	    }
	
	    /**
	     * Converts `value` to a plain object flattening inherited enumerable string
	     * keyed properties of `value` to own properties of the plain object.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {Object} Returns the converted plain object.
	     * @example
	     *
	     * function Foo() {
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.assign({ 'a': 1 }, new Foo);
	     * // => { 'a': 1, 'b': 2 }
	     *
	     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
	     * // => { 'a': 1, 'b': 2, 'c': 3 }
	     */
	    function toPlainObject(value) {
	      return copyObject(value, keysIn(value));
	    }
	
	    /**
	     * Converts `value` to a safe integer. A safe integer can be compared and
	     * represented correctly.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toSafeInteger(3.2);
	     * // => 3
	     *
	     * _.toSafeInteger(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toSafeInteger(Infinity);
	     * // => 9007199254740991
	     *
	     * _.toSafeInteger('3.2');
	     * // => 3
	     */
	    function toSafeInteger(value) {
	      return value
	        ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER)
	        : (value === 0 ? value : 0);
	    }
	
	    /**
	     * Converts `value` to a string. An empty string is returned for `null`
	     * and `undefined` values. The sign of `-0` is preserved.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.toString(null);
	     * // => ''
	     *
	     * _.toString(-0);
	     * // => '-0'
	     *
	     * _.toString([1, 2, 3]);
	     * // => '1,2,3'
	     */
	    function toString(value) {
	      return value == null ? '' : baseToString(value);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Assigns own enumerable string keyed properties of source objects to the
	     * destination object. Source objects are applied from left to right.
	     * Subsequent sources overwrite property assignments of previous sources.
	     *
	     * **Note:** This method mutates `object` and is loosely based on
	     * [`Object.assign`](https://mdn.io/Object/assign).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.10.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.assignIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * function Bar() {
	     *   this.c = 3;
	     * }
	     *
	     * Foo.prototype.b = 2;
	     * Bar.prototype.d = 4;
	     *
	     * _.assign({ 'a': 0 }, new Foo, new Bar);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    var assign = createAssigner(function(object, source) {
	      if (isPrototype(source) || isArrayLike(source)) {
	        copyObject(source, keys(source), object);
	        return;
	      }
	      for (var key in source) {
	        if (hasOwnProperty.call(source, key)) {
	          assignValue(object, key, source[key]);
	        }
	      }
	    });
	
	    /**
	     * This method is like `_.assign` except that it iterates over own and
	     * inherited source properties.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias extend
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.assign
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * function Bar() {
	     *   this.c = 3;
	     * }
	     *
	     * Foo.prototype.b = 2;
	     * Bar.prototype.d = 4;
	     *
	     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
	     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
	     */
	    var assignIn = createAssigner(function(object, source) {
	      copyObject(source, keysIn(source), object);
	    });
	
	    /**
	     * This method is like `_.assignIn` except that it accepts `customizer`
	     * which is invoked to produce the assigned values. If `customizer` returns
	     * `undefined`, assignment is handled by the method instead. The `customizer`
	     * is invoked with five arguments: (objValue, srcValue, key, object, source).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias extendWith
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @see _.assignWith
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   return _.isUndefined(objValue) ? srcValue : objValue;
	     * }
	     *
	     * var defaults = _.partialRight(_.assignInWith, customizer);
	     *
	     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
	      copyObject(source, keysIn(source), object, customizer);
	    });
	
	    /**
	     * This method is like `_.assign` except that it accepts `customizer`
	     * which is invoked to produce the assigned values. If `customizer` returns
	     * `undefined`, assignment is handled by the method instead. The `customizer`
	     * is invoked with five arguments: (objValue, srcValue, key, object, source).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @see _.assignInWith
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   return _.isUndefined(objValue) ? srcValue : objValue;
	     * }
	     *
	     * var defaults = _.partialRight(_.assignWith, customizer);
	     *
	     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
	      copyObject(source, keys(source), object, customizer);
	    });
	
	    /**
	     * Creates an array of values corresponding to `paths` of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Array} Returns the picked values.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
	     *
	     * _.at(object, ['a[0].b.c', 'a[1]']);
	     * // => [3, 4]
	     */
	    var at = flatRest(baseAt);
	
	    /**
	     * Creates an object that inherits from the `prototype` object. If a
	     * `properties` object is given, its own enumerable string keyed properties
	     * are assigned to the created object.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.3.0
	     * @category Object
	     * @param {Object} prototype The object to inherit from.
	     * @param {Object} [properties] The properties to assign to the object.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * function Shape() {
	     *   this.x = 0;
	     *   this.y = 0;
	     * }
	     *
	     * function Circle() {
	     *   Shape.call(this);
	     * }
	     *
	     * Circle.prototype = _.create(Shape.prototype, {
	     *   'constructor': Circle
	     * });
	     *
	     * var circle = new Circle;
	     * circle instanceof Circle;
	     * // => true
	     *
	     * circle instanceof Shape;
	     * // => true
	     */
	    function create(prototype, properties) {
	      var result = baseCreate(prototype);
	      return properties == null ? result : baseAssign(result, properties);
	    }
	
	    /**
	     * Assigns own and inherited enumerable string keyed properties of source
	     * objects to the destination object for all destination properties that
	     * resolve to `undefined`. Source objects are applied from left to right.
	     * Once a property is set, additional values of the same property are ignored.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.defaultsDeep
	     * @example
	     *
	     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var defaults = baseRest(function(object, sources) {
	      object = Object(object);
	
	      var index = -1;
	      var length = sources.length;
	      var guard = length > 2 ? sources[2] : undefined;
	
	      if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	        length = 1;
	      }
	
	      while (++index < length) {
	        var source = sources[index];
	        var props = keysIn(source);
	        var propsIndex = -1;
	        var propsLength = props.length;
	
	        while (++propsIndex < propsLength) {
	          var key = props[propsIndex];
	          var value = object[key];
	
	          if (value === undefined ||
	              (eq(value, objectProto[key]) && !hasOwnProperty.call(object, key))) {
	            object[key] = source[key];
	          }
	        }
	      }
	
	      return object;
	    });
	
	    /**
	     * This method is like `_.defaults` except that it recursively assigns
	     * default properties.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.defaults
	     * @example
	     *
	     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
	     * // => { 'a': { 'b': 2, 'c': 3 } }
	     */
	    var defaultsDeep = baseRest(function(args) {
	      args.push(undefined, customDefaultsMerge);
	      return apply(mergeWith, undefined, args);
	    });
	
	    /**
	     * This method is like `_.find` except that it returns the key of the first
	     * element `predicate` returns truthy for instead of the element itself.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {string|undefined} Returns the key of the matched element,
	     *  else `undefined`.
	     * @example
	     *
	     * var users = {
	     *   'barney':  { 'age': 36, 'active': true },
	     *   'fred':    { 'age': 40, 'active': false },
	     *   'pebbles': { 'age': 1,  'active': true }
	     * };
	     *
	     * _.findKey(users, function(o) { return o.age < 40; });
	     * // => 'barney' (iteration order is not guaranteed)
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findKey(users, { 'age': 1, 'active': true });
	     * // => 'pebbles'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findKey(users, ['active', false]);
	     * // => 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findKey(users, 'active');
	     * // => 'barney'
	     */
	    function findKey(object, predicate) {
	      return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
	    }
	
	    /**
	     * This method is like `_.findKey` except that it iterates over elements of
	     * a collection in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {string|undefined} Returns the key of the matched element,
	     *  else `undefined`.
	     * @example
	     *
	     * var users = {
	     *   'barney':  { 'age': 36, 'active': true },
	     *   'fred':    { 'age': 40, 'active': false },
	     *   'pebbles': { 'age': 1,  'active': true }
	     * };
	     *
	     * _.findLastKey(users, function(o) { return o.age < 40; });
	     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findLastKey(users, { 'age': 36, 'active': true });
	     * // => 'barney'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findLastKey(users, ['active', false]);
	     * // => 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findLastKey(users, 'active');
	     * // => 'pebbles'
	     */
	    function findLastKey(object, predicate) {
	      return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
	    }
	
	    /**
	     * Iterates over own and inherited enumerable string keyed properties of an
	     * object and invokes `iteratee` for each property. The iteratee is invoked
	     * with three arguments: (value, key, object). Iteratee functions may exit
	     * iteration early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forInRight
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forIn(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
	     */
	    function forIn(object, iteratee) {
	      return object == null
	        ? object
	        : baseFor(object, getIteratee(iteratee, 3), keysIn);
	    }
	
	    /**
	     * This method is like `_.forIn` except that it iterates over properties of
	     * `object` in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forInRight(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
	     */
	    function forInRight(object, iteratee) {
	      return object == null
	        ? object
	        : baseForRight(object, getIteratee(iteratee, 3), keysIn);
	    }
	
	    /**
	     * Iterates over own enumerable string keyed properties of an object and
	     * invokes `iteratee` for each property. The iteratee is invoked with three
	     * arguments: (value, key, object). Iteratee functions may exit iteration
	     * early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forOwnRight
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forOwn(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	     */
	    function forOwn(object, iteratee) {
	      return object && baseForOwn(object, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * This method is like `_.forOwn` except that it iterates over properties of
	     * `object` in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forOwn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forOwnRight(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
	     */
	    function forOwnRight(object, iteratee) {
	      return object && baseForOwnRight(object, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * Creates an array of function property names from own enumerable properties
	     * of `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @returns {Array} Returns the function names.
	     * @see _.functionsIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = _.constant('a');
	     *   this.b = _.constant('b');
	     * }
	     *
	     * Foo.prototype.c = _.constant('c');
	     *
	     * _.functions(new Foo);
	     * // => ['a', 'b']
	     */
	    function functions(object) {
	      return object == null ? [] : baseFunctions(object, keys(object));
	    }
	
	    /**
	     * Creates an array of function property names from own and inherited
	     * enumerable properties of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @returns {Array} Returns the function names.
	     * @see _.functions
	     * @example
	     *
	     * function Foo() {
	     *   this.a = _.constant('a');
	     *   this.b = _.constant('b');
	     * }
	     *
	     * Foo.prototype.c = _.constant('c');
	     *
	     * _.functionsIn(new Foo);
	     * // => ['a', 'b', 'c']
	     */
	    function functionsIn(object) {
	      return object == null ? [] : baseFunctions(object, keysIn(object));
	    }
	
	    /**
	     * Gets the value at `path` of `object`. If the resolved value is
	     * `undefined`, the `defaultValue` is returned in its place.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to get.
	     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.get(object, 'a[0].b.c');
	     * // => 3
	     *
	     * _.get(object, ['a', '0', 'b', 'c']);
	     * // => 3
	     *
	     * _.get(object, 'a.b.c', 'default');
	     * // => 'default'
	     */
	    function get(object, path, defaultValue) {
	      var result = object == null ? undefined : baseGet(object, path);
	      return result === undefined ? defaultValue : result;
	    }
	
	    /**
	     * Checks if `path` is a direct property of `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     * @example
	     *
	     * var object = { 'a': { 'b': 2 } };
	     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
	     *
	     * _.has(object, 'a');
	     * // => true
	     *
	     * _.has(object, 'a.b');
	     * // => true
	     *
	     * _.has(object, ['a', 'b']);
	     * // => true
	     *
	     * _.has(other, 'a');
	     * // => false
	     */
	    function has(object, path) {
	      return object != null && hasPath(object, path, baseHas);
	    }
	
	    /**
	     * Checks if `path` is a direct or inherited property of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     * @example
	     *
	     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
	     *
	     * _.hasIn(object, 'a');
	     * // => true
	     *
	     * _.hasIn(object, 'a.b');
	     * // => true
	     *
	     * _.hasIn(object, ['a', 'b']);
	     * // => true
	     *
	     * _.hasIn(object, 'b');
	     * // => false
	     */
	    function hasIn(object, path) {
	      return object != null && hasPath(object, path, baseHasIn);
	    }
	
	    /**
	     * Creates an object composed of the inverted keys and values of `object`.
	     * If `object` contains duplicate values, subsequent values overwrite
	     * property assignments of previous values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.7.0
	     * @category Object
	     * @param {Object} object The object to invert.
	     * @returns {Object} Returns the new inverted object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2, 'c': 1 };
	     *
	     * _.invert(object);
	     * // => { '1': 'c', '2': 'b' }
	     */
	    var invert = createInverter(function(result, value, key) {
	      if (value != null &&
	          typeof value.toString != 'function') {
	        value = nativeObjectToString.call(value);
	      }
	
	      result[value] = key;
	    }, constant(identity));
	
	    /**
	     * This method is like `_.invert` except that the inverted object is generated
	     * from the results of running each element of `object` thru `iteratee`. The
	     * corresponding inverted value of each inverted key is an array of keys
	     * responsible for generating the inverted value. The iteratee is invoked
	     * with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.1.0
	     * @category Object
	     * @param {Object} object The object to invert.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Object} Returns the new inverted object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2, 'c': 1 };
	     *
	     * _.invertBy(object);
	     * // => { '1': ['a', 'c'], '2': ['b'] }
	     *
	     * _.invertBy(object, function(value) {
	     *   return 'group' + value;
	     * });
	     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
	     */
	    var invertBy = createInverter(function(result, value, key) {
	      if (value != null &&
	          typeof value.toString != 'function') {
	        value = nativeObjectToString.call(value);
	      }
	
	      if (hasOwnProperty.call(result, value)) {
	        result[value].push(key);
	      } else {
	        result[value] = [key];
	      }
	    }, getIteratee);
	
	    /**
	     * Invokes the method at `path` of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {*} Returns the result of the invoked method.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
	     *
	     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
	     * // => [2, 3]
	     */
	    var invoke = baseRest(baseInvoke);
	
	    /**
	     * Creates an array of the own enumerable property names of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects. See the
	     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	     * for more details.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.keys(new Foo);
	     * // => ['a', 'b'] (iteration order is not guaranteed)
	     *
	     * _.keys('hi');
	     * // => ['0', '1']
	     */
	    function keys(object) {
	      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	    }
	
	    /**
	     * Creates an array of the own and inherited enumerable property names of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.keysIn(new Foo);
	     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	     */
	    function keysIn(object) {
	      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
	    }
	
	    /**
	     * The opposite of `_.mapValues`; this method creates an object with the
	     * same values as `object` and keys generated by running each own enumerable
	     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
	     * with three arguments: (value, key, object).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns the new mapped object.
	     * @see _.mapValues
	     * @example
	     *
	     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
	     *   return key + value;
	     * });
	     * // => { 'a1': 1, 'b2': 2 }
	     */
	    function mapKeys(object, iteratee) {
	      var result = {};
	      iteratee = getIteratee(iteratee, 3);
	
	      baseForOwn(object, function(value, key, object) {
	        baseAssignValue(result, iteratee(value, key, object), value);
	      });
	      return result;
	    }
	
	    /**
	     * Creates an object with the same keys as `object` and values generated
	     * by running each own enumerable string keyed property of `object` thru
	     * `iteratee`. The iteratee is invoked with three arguments:
	     * (value, key, object).
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns the new mapped object.
	     * @see _.mapKeys
	     * @example
	     *
	     * var users = {
	     *   'fred':    { 'user': 'fred',    'age': 40 },
	     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
	     * };
	     *
	     * _.mapValues(users, function(o) { return o.age; });
	     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.mapValues(users, 'age');
	     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	     */
	    function mapValues(object, iteratee) {
	      var result = {};
	      iteratee = getIteratee(iteratee, 3);
	
	      baseForOwn(object, function(value, key, object) {
	        baseAssignValue(result, key, iteratee(value, key, object));
	      });
	      return result;
	    }
	
	    /**
	     * This method is like `_.assign` except that it recursively merges own and
	     * inherited enumerable string keyed properties of source objects into the
	     * destination object. Source properties that resolve to `undefined` are
	     * skipped if a destination value exists. Array and plain object properties
	     * are merged recursively. Other objects and value types are overridden by
	     * assignment. Source objects are applied from left to right. Subsequent
	     * sources overwrite property assignments of previous sources.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {
	     *   'a': [{ 'b': 2 }, { 'd': 4 }]
	     * };
	     *
	     * var other = {
	     *   'a': [{ 'c': 3 }, { 'e': 5 }]
	     * };
	     *
	     * _.merge(object, other);
	     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
	     */
	    var merge = createAssigner(function(object, source, srcIndex) {
	      baseMerge(object, source, srcIndex);
	    });
	
	    /**
	     * This method is like `_.merge` except that it accepts `customizer` which
	     * is invoked to produce the merged values of the destination and source
	     * properties. If `customizer` returns `undefined`, merging is handled by the
	     * method instead. The `customizer` is invoked with six arguments:
	     * (objValue, srcValue, key, object, source, stack).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} customizer The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   if (_.isArray(objValue)) {
	     *     return objValue.concat(srcValue);
	     *   }
	     * }
	     *
	     * var object = { 'a': [1], 'b': [2] };
	     * var other = { 'a': [3], 'b': [4] };
	     *
	     * _.mergeWith(object, other, customizer);
	     * // => { 'a': [1, 3], 'b': [2, 4] }
	     */
	    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
	      baseMerge(object, source, srcIndex, customizer);
	    });
	
	    /**
	     * The opposite of `_.pick`; this method creates an object composed of the
	     * own and inherited enumerable property paths of `object` that are not omitted.
	     *
	     * **Note:** This method is considerably slower than `_.pick`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {...(string|string[])} [paths] The property paths to omit.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.omit(object, ['a', 'c']);
	     * // => { 'b': '2' }
	     */
	    var omit = flatRest(function(object, paths) {
	      var result = {};
	      if (object == null) {
	        return result;
	      }
	      var isDeep = false;
	      paths = arrayMap(paths, function(path) {
	        path = castPath(path, object);
	        isDeep || (isDeep = path.length > 1);
	        return path;
	      });
	      copyObject(object, getAllKeysIn(object), result);
	      if (isDeep) {
	        result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
	      }
	      var length = paths.length;
	      while (length--) {
	        baseUnset(result, paths[length]);
	      }
	      return result;
	    });
	
	    /**
	     * The opposite of `_.pickBy`; this method creates an object composed of
	     * the own and inherited enumerable string keyed properties of `object` that
	     * `predicate` doesn't return truthy for. The predicate is invoked with two
	     * arguments: (value, key).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {Function} [predicate=_.identity] The function invoked per property.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.omitBy(object, _.isNumber);
	     * // => { 'b': '2' }
	     */
	    function omitBy(object, predicate) {
	      return pickBy(object, negate(getIteratee(predicate)));
	    }
	
	    /**
	     * Creates an object composed of the picked `object` properties.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.pick(object, ['a', 'c']);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    var pick = flatRest(function(object, paths) {
	      return object == null ? {} : basePick(object, paths);
	    });
	
	    /**
	     * Creates an object composed of the `object` properties `predicate` returns
	     * truthy for. The predicate is invoked with two arguments: (value, key).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {Function} [predicate=_.identity] The function invoked per property.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.pickBy(object, _.isNumber);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    function pickBy(object, predicate) {
	      if (object == null) {
	        return {};
	      }
	      var props = arrayMap(getAllKeysIn(object), function(prop) {
	        return [prop];
	      });
	      predicate = getIteratee(predicate);
	      return basePickBy(object, props, function(value, path) {
	        return predicate(value, path[0]);
	      });
	    }
	
	    /**
	     * This method is like `_.get` except that if the resolved value is a
	     * function it's invoked with the `this` binding of its parent object and
	     * its result is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to resolve.
	     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
	     *
	     * _.result(object, 'a[0].b.c1');
	     * // => 3
	     *
	     * _.result(object, 'a[0].b.c2');
	     * // => 4
	     *
	     * _.result(object, 'a[0].b.c3', 'default');
	     * // => 'default'
	     *
	     * _.result(object, 'a[0].b.c3', _.constant('default'));
	     * // => 'default'
	     */
	    function result(object, path, defaultValue) {
	      path = castPath(path, object);
	
	      var index = -1,
	          length = path.length;
	
	      // Ensure the loop is entered when path is empty.
	      if (!length) {
	        length = 1;
	        object = undefined;
	      }
	      while (++index < length) {
	        var value = object == null ? undefined : object[toKey(path[index])];
	        if (value === undefined) {
	          index = length;
	          value = defaultValue;
	        }
	        object = isFunction(value) ? value.call(object) : value;
	      }
	      return object;
	    }
	
	    /**
	     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
	     * it's created. Arrays are created for missing index properties while objects
	     * are created for all other missing properties. Use `_.setWith` to customize
	     * `path` creation.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.set(object, 'a[0].b.c', 4);
	     * console.log(object.a[0].b.c);
	     * // => 4
	     *
	     * _.set(object, ['x', '0', 'y', 'z'], 5);
	     * console.log(object.x[0].y.z);
	     * // => 5
	     */
	    function set(object, path, value) {
	      return object == null ? object : baseSet(object, path, value);
	    }
	
	    /**
	     * This method is like `_.set` except that it accepts `customizer` which is
	     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
	     * path creation is handled by the method instead. The `customizer` is invoked
	     * with three arguments: (nsValue, key, nsObject).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {};
	     *
	     * _.setWith(object, '[0][1]', 'a', Object);
	     * // => { '0': { '1': 'a' } }
	     */
	    function setWith(object, path, value, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return object == null ? object : baseSet(object, path, value, customizer);
	    }
	
	    /**
	     * Creates an array of own enumerable string keyed-value pairs for `object`
	     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
	     * entries are returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias entries
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the key-value pairs.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.toPairs(new Foo);
	     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
	     */
	    var toPairs = createToPairs(keys);
	
	    /**
	     * Creates an array of own and inherited enumerable string keyed-value pairs
	     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
	     * or set, its entries are returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias entriesIn
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the key-value pairs.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.toPairsIn(new Foo);
	     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
	     */
	    var toPairsIn = createToPairs(keysIn);
	
	    /**
	     * An alternative to `_.reduce`; this method transforms `object` to a new
	     * `accumulator` object which is the result of running each of its own
	     * enumerable string keyed properties thru `iteratee`, with each invocation
	     * potentially mutating the `accumulator` object. If `accumulator` is not
	     * provided, a new object with the same `[[Prototype]]` will be used. The
	     * iteratee is invoked with four arguments: (accumulator, value, key, object).
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The custom accumulator value.
	     * @returns {*} Returns the accumulated value.
	     * @example
	     *
	     * _.transform([2, 3, 4], function(result, n) {
	     *   result.push(n *= n);
	     *   return n % 2 == 0;
	     * }, []);
	     * // => [4, 9]
	     *
	     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
	     *   (result[value] || (result[value] = [])).push(key);
	     * }, {});
	     * // => { '1': ['a', 'c'], '2': ['b'] }
	     */
	    function transform(object, iteratee, accumulator) {
	      var isArr = isArray(object),
	          isArrLike = isArr || isBuffer(object) || isTypedArray(object);
	
	      iteratee = getIteratee(iteratee, 4);
	      if (accumulator == null) {
	        var Ctor = object && object.constructor;
	        if (isArrLike) {
	          accumulator = isArr ? new Ctor : [];
	        }
	        else if (isObject(object)) {
	          accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
	        }
	        else {
	          accumulator = {};
	        }
	      }
	      (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
	        return iteratee(accumulator, value, index, object);
	      });
	      return accumulator;
	    }
	
	    /**
	     * Removes the property at `path` of `object`.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to unset.
	     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
	     * _.unset(object, 'a[0].b.c');
	     * // => true
	     *
	     * console.log(object);
	     * // => { 'a': [{ 'b': {} }] };
	     *
	     * _.unset(object, ['a', '0', 'b', 'c']);
	     * // => true
	     *
	     * console.log(object);
	     * // => { 'a': [{ 'b': {} }] };
	     */
	    function unset(object, path) {
	      return object == null ? true : baseUnset(object, path);
	    }
	
	    /**
	     * This method is like `_.set` except that accepts `updater` to produce the
	     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
	     * is invoked with one argument: (value).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {Function} updater The function to produce the updated value.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
	     * console.log(object.a[0].b.c);
	     * // => 9
	     *
	     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
	     * console.log(object.x[0].y.z);
	     * // => 0
	     */
	    function update(object, path, updater) {
	      return object == null ? object : baseUpdate(object, path, castFunction(updater));
	    }
	
	    /**
	     * This method is like `_.update` except that it accepts `customizer` which is
	     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
	     * path creation is handled by the method instead. The `customizer` is invoked
	     * with three arguments: (nsValue, key, nsObject).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {Function} updater The function to produce the updated value.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {};
	     *
	     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
	     * // => { '0': { '1': 'a' } }
	     */
	    function updateWith(object, path, updater, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
	    }
	
	    /**
	     * Creates an array of the own enumerable string keyed property values of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property values.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.values(new Foo);
	     * // => [1, 2] (iteration order is not guaranteed)
	     *
	     * _.values('hi');
	     * // => ['h', 'i']
	     */
	    function values(object) {
	      return object == null ? [] : baseValues(object, keys(object));
	    }
	
	    /**
	     * Creates an array of the own and inherited enumerable string keyed property
	     * values of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property values.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.valuesIn(new Foo);
	     * // => [1, 2, 3] (iteration order is not guaranteed)
	     */
	    function valuesIn(object) {
	      return object == null ? [] : baseValues(object, keysIn(object));
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Clamps `number` within the inclusive `lower` and `upper` bounds.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Number
	     * @param {number} number The number to clamp.
	     * @param {number} [lower] The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the clamped number.
	     * @example
	     *
	     * _.clamp(-10, -5, 5);
	     * // => -5
	     *
	     * _.clamp(10, -5, 5);
	     * // => 5
	     */
	    function clamp(number, lower, upper) {
	      if (upper === undefined) {
	        upper = lower;
	        lower = undefined;
	      }
	      if (upper !== undefined) {
	        upper = toNumber(upper);
	        upper = upper === upper ? upper : 0;
	      }
	      if (lower !== undefined) {
	        lower = toNumber(lower);
	        lower = lower === lower ? lower : 0;
	      }
	      return baseClamp(toNumber(number), lower, upper);
	    }
	
	    /**
	     * Checks if `n` is between `start` and up to, but not including, `end`. If
	     * `end` is not specified, it's set to `start` with `start` then set to `0`.
	     * If `start` is greater than `end` the params are swapped to support
	     * negative ranges.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.3.0
	     * @category Number
	     * @param {number} number The number to check.
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
	     * @see _.range, _.rangeRight
	     * @example
	     *
	     * _.inRange(3, 2, 4);
	     * // => true
	     *
	     * _.inRange(4, 8);
	     * // => true
	     *
	     * _.inRange(4, 2);
	     * // => false
	     *
	     * _.inRange(2, 2);
	     * // => false
	     *
	     * _.inRange(1.2, 2);
	     * // => true
	     *
	     * _.inRange(5.2, 4);
	     * // => false
	     *
	     * _.inRange(-3, -2, -6);
	     * // => true
	     */
	    function inRange(number, start, end) {
	      start = toFinite(start);
	      if (end === undefined) {
	        end = start;
	        start = 0;
	      } else {
	        end = toFinite(end);
	      }
	      number = toNumber(number);
	      return baseInRange(number, start, end);
	    }
	
	    /**
	     * Produces a random number between the inclusive `lower` and `upper` bounds.
	     * If only one argument is provided a number between `0` and the given number
	     * is returned. If `floating` is `true`, or either `lower` or `upper` are
	     * floats, a floating-point number is returned instead of an integer.
	     *
	     * **Note:** JavaScript follows the IEEE-754 standard for resolving
	     * floating-point values which can produce unexpected results.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.7.0
	     * @category Number
	     * @param {number} [lower=0] The lower bound.
	     * @param {number} [upper=1] The upper bound.
	     * @param {boolean} [floating] Specify returning a floating-point number.
	     * @returns {number} Returns the random number.
	     * @example
	     *
	     * _.random(0, 5);
	     * // => an integer between 0 and 5
	     *
	     * _.random(5);
	     * // => also an integer between 0 and 5
	     *
	     * _.random(5, true);
	     * // => a floating-point number between 0 and 5
	     *
	     * _.random(1.2, 5.2);
	     * // => a floating-point number between 1.2 and 5.2
	     */
	    function random(lower, upper, floating) {
	      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
	        upper = floating = undefined;
	      }
	      if (floating === undefined) {
	        if (typeof upper == 'boolean') {
	          floating = upper;
	          upper = undefined;
	        }
	        else if (typeof lower == 'boolean') {
	          floating = lower;
	          lower = undefined;
	        }
	      }
	      if (lower === undefined && upper === undefined) {
	        lower = 0;
	        upper = 1;
	      }
	      else {
	        lower = toFinite(lower);
	        if (upper === undefined) {
	          upper = lower;
	          lower = 0;
	        } else {
	          upper = toFinite(upper);
	        }
	      }
	      if (lower > upper) {
	        var temp = lower;
	        lower = upper;
	        upper = temp;
	      }
	      if (floating || lower % 1 || upper % 1) {
	        var rand = nativeRandom();
	        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
	      }
	      return baseRandom(lower, upper);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the camel cased string.
	     * @example
	     *
	     * _.camelCase('Foo Bar');
	     * // => 'fooBar'
	     *
	     * _.camelCase('--foo-bar--');
	     * // => 'fooBar'
	     *
	     * _.camelCase('__FOO_BAR__');
	     * // => 'fooBar'
	     */
	    var camelCase = createCompounder(function(result, word, index) {
	      word = word.toLowerCase();
	      return result + (index ? capitalize(word) : word);
	    });
	
	    /**
	     * Converts the first character of `string` to upper case and the remaining
	     * to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to capitalize.
	     * @returns {string} Returns the capitalized string.
	     * @example
	     *
	     * _.capitalize('FRED');
	     * // => 'Fred'
	     */
	    function capitalize(string) {
	      return upperFirst(toString(string).toLowerCase());
	    }
	
	    /**
	     * Deburrs `string` by converting
	     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
	     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
	     * letters to basic Latin letters and removing
	     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to deburr.
	     * @returns {string} Returns the deburred string.
	     * @example
	     *
	     * _.deburr('déjà vu');
	     * // => 'deja vu'
	     */
	    function deburr(string) {
	      string = toString(string);
	      return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
	    }
	
	    /**
	     * Checks if `string` ends with the given target string.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {string} [target] The string to search for.
	     * @param {number} [position=string.length] The position to search up to.
	     * @returns {boolean} Returns `true` if `string` ends with `target`,
	     *  else `false`.
	     * @example
	     *
	     * _.endsWith('abc', 'c');
	     * // => true
	     *
	     * _.endsWith('abc', 'b');
	     * // => false
	     *
	     * _.endsWith('abc', 'b', 2);
	     * // => true
	     */
	    function endsWith(string, target, position) {
	      string = toString(string);
	      target = baseToString(target);
	
	      var length = string.length;
	      position = position === undefined
	        ? length
	        : baseClamp(toInteger(position), 0, length);
	
	      var end = position;
	      position -= target.length;
	      return position >= 0 && string.slice(position, end) == target;
	    }
	
	    /**
	     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
	     * corresponding HTML entities.
	     *
	     * **Note:** No other characters are escaped. To escape additional
	     * characters use a third-party library like [_he_](https://mths.be/he).
	     *
	     * Though the ">" character is escaped for symmetry, characters like
	     * ">" and "/" don't need escaping in HTML and have no special meaning
	     * unless they're part of a tag or unquoted attribute value. See
	     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
	     * (under "semi-related fun fact") for more details.
	     *
	     * When working with HTML you should always
	     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
	     * XSS vectors.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to escape.
	     * @returns {string} Returns the escaped string.
	     * @example
	     *
	     * _.escape('fred, barney, & pebbles');
	     * // => 'fred, barney, &amp; pebbles'
	     */
	    function escape(string) {
	      string = toString(string);
	      return (string && reHasUnescapedHtml.test(string))
	        ? string.replace(reUnescapedHtml, escapeHtmlChar)
	        : string;
	    }
	
	    /**
	     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
	     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to escape.
	     * @returns {string} Returns the escaped string.
	     * @example
	     *
	     * _.escapeRegExp('[lodash](https://lodash.com/)');
	     * // => '\[lodash\]\(https://lodash\.com/\)'
	     */
	    function escapeRegExp(string) {
	      string = toString(string);
	      return (string && reHasRegExpChar.test(string))
	        ? string.replace(reRegExpChar, '\\$&')
	        : string;
	    }
	
	    /**
	     * Converts `string` to
	     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the kebab cased string.
	     * @example
	     *
	     * _.kebabCase('Foo Bar');
	     * // => 'foo-bar'
	     *
	     * _.kebabCase('fooBar');
	     * // => 'foo-bar'
	     *
	     * _.kebabCase('__FOO_BAR__');
	     * // => 'foo-bar'
	     */
	    var kebabCase = createCompounder(function(result, word, index) {
	      return result + (index ? '-' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Converts `string`, as space separated words, to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the lower cased string.
	     * @example
	     *
	     * _.lowerCase('--Foo-Bar--');
	     * // => 'foo bar'
	     *
	     * _.lowerCase('fooBar');
	     * // => 'foo bar'
	     *
	     * _.lowerCase('__FOO_BAR__');
	     * // => 'foo bar'
	     */
	    var lowerCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Converts the first character of `string` to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.lowerFirst('Fred');
	     * // => 'fred'
	     *
	     * _.lowerFirst('FRED');
	     * // => 'fRED'
	     */
	    var lowerFirst = createCaseFirst('toLowerCase');
	
	    /**
	     * Pads `string` on the left and right sides if it's shorter than `length`.
	     * Padding characters are truncated if they can't be evenly divided by `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.pad('abc', 8);
	     * // => '  abc   '
	     *
	     * _.pad('abc', 8, '_-');
	     * // => '_-abc_-_'
	     *
	     * _.pad('abc', 3);
	     * // => 'abc'
	     */
	    function pad(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      if (!length || strLength >= length) {
	        return string;
	      }
	      var mid = (length - strLength) / 2;
	      return (
	        createPadding(nativeFloor(mid), chars) +
	        string +
	        createPadding(nativeCeil(mid), chars)
	      );
	    }
	
	    /**
	     * Pads `string` on the right side if it's shorter than `length`. Padding
	     * characters are truncated if they exceed `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.padEnd('abc', 6);
	     * // => 'abc   '
	     *
	     * _.padEnd('abc', 6, '_-');
	     * // => 'abc_-_'
	     *
	     * _.padEnd('abc', 3);
	     * // => 'abc'
	     */
	    function padEnd(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      return (length && strLength < length)
	        ? (string + createPadding(length - strLength, chars))
	        : string;
	    }
	
	    /**
	     * Pads `string` on the left side if it's shorter than `length`. Padding
	     * characters are truncated if they exceed `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.padStart('abc', 6);
	     * // => '   abc'
	     *
	     * _.padStart('abc', 6, '_-');
	     * // => '_-_abc'
	     *
	     * _.padStart('abc', 3);
	     * // => 'abc'
	     */
	    function padStart(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      return (length && strLength < length)
	        ? (createPadding(length - strLength, chars) + string)
	        : string;
	    }
	
	    /**
	     * Converts `string` to an integer of the specified radix. If `radix` is
	     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
	     * hexadecimal, in which case a `radix` of `16` is used.
	     *
	     * **Note:** This method aligns with the
	     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category String
	     * @param {string} string The string to convert.
	     * @param {number} [radix=10] The radix to interpret `value` by.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.parseInt('08');
	     * // => 8
	     *
	     * _.map(['6', '08', '10'], _.parseInt);
	     * // => [6, 8, 10]
	     */
	    function parseInt(string, radix, guard) {
	      if (guard || radix == null) {
	        radix = 0;
	      } else if (radix) {
	        radix = +radix;
	      }
	      return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
	    }
	
	    /**
	     * Repeats the given string `n` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to repeat.
	     * @param {number} [n=1] The number of times to repeat the string.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the repeated string.
	     * @example
	     *
	     * _.repeat('*', 3);
	     * // => '***'
	     *
	     * _.repeat('abc', 2);
	     * // => 'abcabc'
	     *
	     * _.repeat('abc', 0);
	     * // => ''
	     */
	    function repeat(string, n, guard) {
	      if ((guard ? isIterateeCall(string, n, guard) : n === undefined)) {
	        n = 1;
	      } else {
	        n = toInteger(n);
	      }
	      return baseRepeat(toString(string), n);
	    }
	
	    /**
	     * Replaces matches for `pattern` in `string` with `replacement`.
	     *
	     * **Note:** This method is based on
	     * [`String#replace`](https://mdn.io/String/replace).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to modify.
	     * @param {RegExp|string} pattern The pattern to replace.
	     * @param {Function|string} replacement The match replacement.
	     * @returns {string} Returns the modified string.
	     * @example
	     *
	     * _.replace('Hi Fred', 'Fred', 'Barney');
	     * // => 'Hi Barney'
	     */
	    function replace() {
	      var args = arguments,
	          string = toString(args[0]);
	
	      return args.length < 3 ? string : string.replace(args[1], args[2]);
	    }
	
	    /**
	     * Converts `string` to
	     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the snake cased string.
	     * @example
	     *
	     * _.snakeCase('Foo Bar');
	     * // => 'foo_bar'
	     *
	     * _.snakeCase('fooBar');
	     * // => 'foo_bar'
	     *
	     * _.snakeCase('--FOO-BAR--');
	     * // => 'foo_bar'
	     */
	    var snakeCase = createCompounder(function(result, word, index) {
	      return result + (index ? '_' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Splits `string` by `separator`.
	     *
	     * **Note:** This method is based on
	     * [`String#split`](https://mdn.io/String/split).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to split.
	     * @param {RegExp|string} separator The separator pattern to split by.
	     * @param {number} [limit] The length to truncate results to.
	     * @returns {Array} Returns the string segments.
	     * @example
	     *
	     * _.split('a-b-c', '-', 2);
	     * // => ['a', 'b']
	     */
	    function split(string, separator, limit) {
	      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
	        separator = limit = undefined;
	      }
	      limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
	      if (!limit) {
	        return [];
	      }
	      string = toString(string);
	      if (string && (
	            typeof separator == 'string' ||
	            (separator != null && !isRegExp(separator))
	          )) {
	        separator = baseToString(separator);
	        if (!separator && hasUnicode(string)) {
	          return castSlice(stringToArray(string), 0, limit);
	        }
	      }
	      return string.split(separator, limit);
	    }
	
	    /**
	     * Converts `string` to
	     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.1.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the start cased string.
	     * @example
	     *
	     * _.startCase('--foo-bar--');
	     * // => 'Foo Bar'
	     *
	     * _.startCase('fooBar');
	     * // => 'Foo Bar'
	     *
	     * _.startCase('__FOO_BAR__');
	     * // => 'FOO BAR'
	     */
	    var startCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + upperFirst(word);
	    });
	
	    /**
	     * Checks if `string` starts with the given target string.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {string} [target] The string to search for.
	     * @param {number} [position=0] The position to search from.
	     * @returns {boolean} Returns `true` if `string` starts with `target`,
	     *  else `false`.
	     * @example
	     *
	     * _.startsWith('abc', 'a');
	     * // => true
	     *
	     * _.startsWith('abc', 'b');
	     * // => false
	     *
	     * _.startsWith('abc', 'b', 1);
	     * // => true
	     */
	    function startsWith(string, target, position) {
	      string = toString(string);
	      position = position == null
	        ? 0
	        : baseClamp(toInteger(position), 0, string.length);
	
	      target = baseToString(target);
	      return string.slice(position, position + target.length) == target;
	    }
	
	    /**
	     * Creates a compiled template function that can interpolate data properties
	     * in "interpolate" delimiters, HTML-escape interpolated data properties in
	     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
	     * properties may be accessed as free variables in the template. If a setting
	     * object is given, it takes precedence over `_.templateSettings` values.
	     *
	     * **Note:** In the development build `_.template` utilizes
	     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
	     * for easier debugging.
	     *
	     * For more information on precompiling templates see
	     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
	     *
	     * For more information on Chrome extension sandboxes see
	     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The template string.
	     * @param {Object} [options={}] The options object.
	     * @param {RegExp} [options.escape=_.templateSettings.escape]
	     *  The HTML "escape" delimiter.
	     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
	     *  The "evaluate" delimiter.
	     * @param {Object} [options.imports=_.templateSettings.imports]
	     *  An object to import into the template as free variables.
	     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
	     *  The "interpolate" delimiter.
	     * @param {string} [options.sourceURL='lodash.templateSources[n]']
	     *  The sourceURL of the compiled template.
	     * @param {string} [options.variable='obj']
	     *  The data object variable name.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the compiled template function.
	     * @example
	     *
	     * // Use the "interpolate" delimiter to create a compiled template.
	     * var compiled = _.template('hello <%= user %>!');
	     * compiled({ 'user': 'fred' });
	     * // => 'hello fred!'
	     *
	     * // Use the HTML "escape" delimiter to escape data property values.
	     * var compiled = _.template('<b><%- value %></b>');
	     * compiled({ 'value': '<script>' });
	     * // => '<b>&lt;script&gt;</b>'
	     *
	     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
	     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
	     * compiled({ 'users': ['fred', 'barney'] });
	     * // => '<li>fred</li><li>barney</li>'
	     *
	     * // Use the internal `print` function in "evaluate" delimiters.
	     * var compiled = _.template('<% print("hello " + user); %>!');
	     * compiled({ 'user': 'barney' });
	     * // => 'hello barney!'
	     *
	     * // Use the ES template literal delimiter as an "interpolate" delimiter.
	     * // Disable support by replacing the "interpolate" delimiter.
	     * var compiled = _.template('hello ${ user }!');
	     * compiled({ 'user': 'pebbles' });
	     * // => 'hello pebbles!'
	     *
	     * // Use backslashes to treat delimiters as plain text.
	     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
	     * compiled({ 'value': 'ignored' });
	     * // => '<%- value %>'
	     *
	     * // Use the `imports` option to import `jQuery` as `jq`.
	     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
	     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
	     * compiled({ 'users': ['fred', 'barney'] });
	     * // => '<li>fred</li><li>barney</li>'
	     *
	     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
	     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
	     * compiled(data);
	     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
	     *
	     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
	     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
	     * compiled.source;
	     * // => function(data) {
	     * //   var __t, __p = '';
	     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
	     * //   return __p;
	     * // }
	     *
	     * // Use custom template delimiters.
	     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
	     * var compiled = _.template('hello {{ user }}!');
	     * compiled({ 'user': 'mustache' });
	     * // => 'hello mustache!'
	     *
	     * // Use the `source` property to inline compiled templates for meaningful
	     * // line numbers in error messages and stack traces.
	     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
	     *   var JST = {\
	     *     "main": ' + _.template(mainText).source + '\
	     *   };\
	     * ');
	     */
	    function template(string, options, guard) {
	      // Based on John Resig's `tmpl` implementation
	      // (http://ejohn.org/blog/javascript-micro-templating/)
	      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
	      var settings = lodash.templateSettings;
	
	      if (guard && isIterateeCall(string, options, guard)) {
	        options = undefined;
	      }
	      string = toString(string);
	      options = assignInWith({}, options, settings, customDefaultsAssignIn);
	
	      var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
	          importsKeys = keys(imports),
	          importsValues = baseValues(imports, importsKeys);
	
	      var isEscaping,
	          isEvaluating,
	          index = 0,
	          interpolate = options.interpolate || reNoMatch,
	          source = "__p += '";
	
	      // Compile the regexp to match each delimiter.
	      var reDelimiters = RegExp(
	        (options.escape || reNoMatch).source + '|' +
	        interpolate.source + '|' +
	        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
	        (options.evaluate || reNoMatch).source + '|$'
	      , 'g');
	
	      // Use a sourceURL for easier debugging.
	      // The sourceURL gets injected into the source that's eval-ed, so be careful
	      // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
	      // and escape the comment, thus injecting code that gets evaled.
	      var sourceURL = '//# sourceURL=' +
	        (hasOwnProperty.call(options, 'sourceURL')
	          ? (options.sourceURL + '').replace(/\s/g, ' ')
	          : ('lodash.templateSources[' + (++templateCounter) + ']')
	        ) + '\n';
	
	      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
	        interpolateValue || (interpolateValue = esTemplateValue);
	
	        // Escape characters that can't be included in string literals.
	        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
	
	        // Replace delimiters with snippets.
	        if (escapeValue) {
	          isEscaping = true;
	          source += "' +\n__e(" + escapeValue + ") +\n'";
	        }
	        if (evaluateValue) {
	          isEvaluating = true;
	          source += "';\n" + evaluateValue + ";\n__p += '";
	        }
	        if (interpolateValue) {
	          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
	        }
	        index = offset + match.length;
	
	        // The JS engine embedded in Adobe products needs `match` returned in
	        // order to produce the correct `offset` value.
	        return match;
	      });
	
	      source += "';\n";
	
	      // If `variable` is not specified wrap a with-statement around the generated
	      // code to add the data object to the top of the scope chain.
	      var variable = hasOwnProperty.call(options, 'variable') && options.variable;
	      if (!variable) {
	        source = 'with (obj) {\n' + source + '\n}\n';
	      }
	      // Throw an error if a forbidden character was found in `variable`, to prevent
	      // potential command injection attacks.
	      else if (reForbiddenIdentifierChars.test(variable)) {
	        throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
	      }
	
	      // Cleanup code by stripping empty strings.
	      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
	        .replace(reEmptyStringMiddle, '$1')
	        .replace(reEmptyStringTrailing, '$1;');
	
	      // Frame code as the function body.
	      source = 'function(' + (variable || 'obj') + ') {\n' +
	        (variable
	          ? ''
	          : 'obj || (obj = {});\n'
	        ) +
	        "var __t, __p = ''" +
	        (isEscaping
	           ? ', __e = _.escape'
	           : ''
	        ) +
	        (isEvaluating
	          ? ', __j = Array.prototype.join;\n' +
	            "function print() { __p += __j.call(arguments, '') }\n"
	          : ';\n'
	        ) +
	        source +
	        'return __p\n}';
	
	      var result = attempt(function() {
	        return Function(importsKeys, sourceURL + 'return ' + source)
	          .apply(undefined, importsValues);
	      });
	
	      // Provide the compiled function's source by its `toString` method or
	      // the `source` property as a convenience for inlining compiled templates.
	      result.source = source;
	      if (isError(result)) {
	        throw result;
	      }
	      return result;
	    }
	
	    /**
	     * Converts `string`, as a whole, to lower case just like
	     * [String#toLowerCase](https://mdn.io/toLowerCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the lower cased string.
	     * @example
	     *
	     * _.toLower('--Foo-Bar--');
	     * // => '--foo-bar--'
	     *
	     * _.toLower('fooBar');
	     * // => 'foobar'
	     *
	     * _.toLower('__FOO_BAR__');
	     * // => '__foo_bar__'
	     */
	    function toLower(value) {
	      return toString(value).toLowerCase();
	    }
	
	    /**
	     * Converts `string`, as a whole, to upper case just like
	     * [String#toUpperCase](https://mdn.io/toUpperCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the upper cased string.
	     * @example
	     *
	     * _.toUpper('--foo-bar--');
	     * // => '--FOO-BAR--'
	     *
	     * _.toUpper('fooBar');
	     * // => 'FOOBAR'
	     *
	     * _.toUpper('__foo_bar__');
	     * // => '__FOO_BAR__'
	     */
	    function toUpper(value) {
	      return toString(value).toUpperCase();
	    }
	
	    /**
	     * Removes leading and trailing whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trim('  abc  ');
	     * // => 'abc'
	     *
	     * _.trim('-_-abc-_-', '_-');
	     * // => 'abc'
	     *
	     * _.map(['  foo  ', '  bar  '], _.trim);
	     * // => ['foo', 'bar']
	     */
	    function trim(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return baseTrim(string);
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          chrSymbols = stringToArray(chars),
	          start = charsStartIndex(strSymbols, chrSymbols),
	          end = charsEndIndex(strSymbols, chrSymbols) + 1;
	
	      return castSlice(strSymbols, start, end).join('');
	    }
	
	    /**
	     * Removes trailing whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trimEnd('  abc  ');
	     * // => '  abc'
	     *
	     * _.trimEnd('-_-abc-_-', '_-');
	     * // => '-_-abc'
	     */
	    function trimEnd(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return string.slice(0, trimmedEndIndex(string) + 1);
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
	
	      return castSlice(strSymbols, 0, end).join('');
	    }
	
	    /**
	     * Removes leading whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trimStart('  abc  ');
	     * // => 'abc  '
	     *
	     * _.trimStart('-_-abc-_-', '_-');
	     * // => 'abc-_-'
	     */
	    function trimStart(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return string.replace(reTrimStart, '');
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          start = charsStartIndex(strSymbols, stringToArray(chars));
	
	      return castSlice(strSymbols, start).join('');
	    }
	
	    /**
	     * Truncates `string` if it's longer than the given maximum string length.
	     * The last characters of the truncated string are replaced with the omission
	     * string which defaults to "...".
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to truncate.
	     * @param {Object} [options={}] The options object.
	     * @param {number} [options.length=30] The maximum string length.
	     * @param {string} [options.omission='...'] The string to indicate text is omitted.
	     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
	     * @returns {string} Returns the truncated string.
	     * @example
	     *
	     * _.truncate('hi-diddly-ho there, neighborino');
	     * // => 'hi-diddly-ho there, neighbo...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'length': 24,
	     *   'separator': ' '
	     * });
	     * // => 'hi-diddly-ho there,...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'length': 24,
	     *   'separator': /,? +/
	     * });
	     * // => 'hi-diddly-ho there...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'omission': ' [...]'
	     * });
	     * // => 'hi-diddly-ho there, neig [...]'
	     */
	    function truncate(string, options) {
	      var length = DEFAULT_TRUNC_LENGTH,
	          omission = DEFAULT_TRUNC_OMISSION;
	
	      if (isObject(options)) {
	        var separator = 'separator' in options ? options.separator : separator;
	        length = 'length' in options ? toInteger(options.length) : length;
	        omission = 'omission' in options ? baseToString(options.omission) : omission;
	      }
	      string = toString(string);
	
	      var strLength = string.length;
	      if (hasUnicode(string)) {
	        var strSymbols = stringToArray(string);
	        strLength = strSymbols.length;
	      }
	      if (length >= strLength) {
	        return string;
	      }
	      var end = length - stringSize(omission);
	      if (end < 1) {
	        return omission;
	      }
	      var result = strSymbols
	        ? castSlice(strSymbols, 0, end).join('')
	        : string.slice(0, end);
	
	      if (separator === undefined) {
	        return result + omission;
	      }
	      if (strSymbols) {
	        end += (result.length - end);
	      }
	      if (isRegExp(separator)) {
	        if (string.slice(end).search(separator)) {
	          var match,
	              substring = result;
	
	          if (!separator.global) {
	            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
	          }
	          separator.lastIndex = 0;
	          while ((match = separator.exec(substring))) {
	            var newEnd = match.index;
	          }
	          result = result.slice(0, newEnd === undefined ? end : newEnd);
	        }
	      } else if (string.indexOf(baseToString(separator), end) != end) {
	        var index = result.lastIndexOf(separator);
	        if (index > -1) {
	          result = result.slice(0, index);
	        }
	      }
	      return result + omission;
	    }
	
	    /**
	     * The inverse of `_.escape`; this method converts the HTML entities
	     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
	     * their corresponding characters.
	     *
	     * **Note:** No other HTML entities are unescaped. To unescape additional
	     * HTML entities use a third-party library like [_he_](https://mths.be/he).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.6.0
	     * @category String
	     * @param {string} [string=''] The string to unescape.
	     * @returns {string} Returns the unescaped string.
	     * @example
	     *
	     * _.unescape('fred, barney, &amp; pebbles');
	     * // => 'fred, barney, & pebbles'
	     */
	    function unescape(string) {
	      string = toString(string);
	      return (string && reHasEscapedHtml.test(string))
	        ? string.replace(reEscapedHtml, unescapeHtmlChar)
	        : string;
	    }
	
	    /**
	     * Converts `string`, as space separated words, to upper case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the upper cased string.
	     * @example
	     *
	     * _.upperCase('--foo-bar');
	     * // => 'FOO BAR'
	     *
	     * _.upperCase('fooBar');
	     * // => 'FOO BAR'
	     *
	     * _.upperCase('__foo_bar__');
	     * // => 'FOO BAR'
	     */
	    var upperCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + word.toUpperCase();
	    });
	
	    /**
	     * Converts the first character of `string` to upper case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.upperFirst('fred');
	     * // => 'Fred'
	     *
	     * _.upperFirst('FRED');
	     * // => 'FRED'
	     */
	    var upperFirst = createCaseFirst('toUpperCase');
	
	    /**
	     * Splits `string` into an array of its words.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {RegExp|string} [pattern] The pattern to match words.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the words of `string`.
	     * @example
	     *
	     * _.words('fred, barney, & pebbles');
	     * // => ['fred', 'barney', 'pebbles']
	     *
	     * _.words('fred, barney, & pebbles', /[^, ]+/g);
	     * // => ['fred', 'barney', '&', 'pebbles']
	     */
	    function words(string, pattern, guard) {
	      string = toString(string);
	      pattern = guard ? undefined : pattern;
	
	      if (pattern === undefined) {
	        return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
	      }
	      return string.match(pattern) || [];
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Attempts to invoke `func`, returning either the result or the caught error
	     * object. Any additional arguments are provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Function} func The function to attempt.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {*} Returns the `func` result or error object.
	     * @example
	     *
	     * // Avoid throwing errors for invalid selectors.
	     * var elements = _.attempt(function(selector) {
	     *   return document.querySelectorAll(selector);
	     * }, '>_>');
	     *
	     * if (_.isError(elements)) {
	     *   elements = [];
	     * }
	     */
	    var attempt = baseRest(function(func, args) {
	      try {
	        return apply(func, undefined, args);
	      } catch (e) {
	        return isError(e) ? e : new Error(e);
	      }
	    });
	
	    /**
	     * Binds methods of an object to the object itself, overwriting the existing
	     * method.
	     *
	     * **Note:** This method doesn't set the "length" property of bound functions.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {Object} object The object to bind and assign the bound methods to.
	     * @param {...(string|string[])} methodNames The object method names to bind.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var view = {
	     *   'label': 'docs',
	     *   'click': function() {
	     *     console.log('clicked ' + this.label);
	     *   }
	     * };
	     *
	     * _.bindAll(view, ['click']);
	     * jQuery(element).on('click', view.click);
	     * // => Logs 'clicked docs' when clicked.
	     */
	    var bindAll = flatRest(function(object, methodNames) {
	      arrayEach(methodNames, function(key) {
	        key = toKey(key);
	        baseAssignValue(object, key, bind(object[key], object));
	      });
	      return object;
	    });
	
	    /**
	     * Creates a function that iterates over `pairs` and invokes the corresponding
	     * function of the first predicate to return truthy. The predicate-function
	     * pairs are invoked with the `this` binding and arguments of the created
	     * function.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {Array} pairs The predicate-function pairs.
	     * @returns {Function} Returns the new composite function.
	     * @example
	     *
	     * var func = _.cond([
	     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
	     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
	     *   [_.stubTrue,                      _.constant('no match')]
	     * ]);
	     *
	     * func({ 'a': 1, 'b': 2 });
	     * // => 'matches A'
	     *
	     * func({ 'a': 0, 'b': 1 });
	     * // => 'matches B'
	     *
	     * func({ 'a': '1', 'b': '2' });
	     * // => 'no match'
	     */
	    function cond(pairs) {
	      var length = pairs == null ? 0 : pairs.length,
	          toIteratee = getIteratee();
	
	      pairs = !length ? [] : arrayMap(pairs, function(pair) {
	        if (typeof pair[1] != 'function') {
	          throw new TypeError(FUNC_ERROR_TEXT);
	        }
	        return [toIteratee(pair[0]), pair[1]];
	      });
	
	      return baseRest(function(args) {
	        var index = -1;
	        while (++index < length) {
	          var pair = pairs[index];
	          if (apply(pair[0], this, args)) {
	            return apply(pair[1], this, args);
	          }
	        }
	      });
	    }
	
	    /**
	     * Creates a function that invokes the predicate properties of `source` with
	     * the corresponding property values of a given object, returning `true` if
	     * all predicates return truthy, else `false`.
	     *
	     * **Note:** The created function is equivalent to `_.conformsTo` with
	     * `source` partially applied.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 2, 'b': 1 },
	     *   { 'a': 1, 'b': 2 }
	     * ];
	     *
	     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
	     * // => [{ 'a': 1, 'b': 2 }]
	     */
	    function conforms(source) {
	      return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that returns `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Util
	     * @param {*} value The value to return from the new function.
	     * @returns {Function} Returns the new constant function.
	     * @example
	     *
	     * var objects = _.times(2, _.constant({ 'a': 1 }));
	     *
	     * console.log(objects);
	     * // => [{ 'a': 1 }, { 'a': 1 }]
	     *
	     * console.log(objects[0] === objects[1]);
	     * // => true
	     */
	    function constant(value) {
	      return function() {
	        return value;
	      };
	    }
	
	    /**
	     * Checks `value` to determine whether a default value should be returned in
	     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
	     * or `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.14.0
	     * @category Util
	     * @param {*} value The value to check.
	     * @param {*} defaultValue The default value.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * _.defaultTo(1, 10);
	     * // => 1
	     *
	     * _.defaultTo(undefined, 10);
	     * // => 10
	     */
	    function defaultTo(value, defaultValue) {
	      return (value == null || value !== value) ? defaultValue : value;
	    }
	
	    /**
	     * Creates a function that returns the result of invoking the given functions
	     * with the `this` binding of the created function, where each successive
	     * invocation is supplied the return value of the previous.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [funcs] The functions to invoke.
	     * @returns {Function} Returns the new composite function.
	     * @see _.flowRight
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var addSquare = _.flow([_.add, square]);
	     * addSquare(1, 2);
	     * // => 9
	     */
	    var flow = createFlow();
	
	    /**
	     * This method is like `_.flow` except that it creates a function that
	     * invokes the given functions from right to left.
	     *
	     * @static
	     * @since 3.0.0
	     * @memberOf _
	     * @category Util
	     * @param {...(Function|Function[])} [funcs] The functions to invoke.
	     * @returns {Function} Returns the new composite function.
	     * @see _.flow
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var addSquare = _.flowRight([square, _.add]);
	     * addSquare(1, 2);
	     * // => 9
	     */
	    var flowRight = createFlow(true);
	
	    /**
	     * This method returns the first argument it receives.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {*} value Any value.
	     * @returns {*} Returns `value`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     *
	     * console.log(_.identity(object) === object);
	     * // => true
	     */
	    function identity(value) {
	      return value;
	    }
	
	    /**
	     * Creates a function that invokes `func` with the arguments of the created
	     * function. If `func` is a property name, the created function returns the
	     * property value for a given element. If `func` is an array or object, the
	     * created function returns `true` for elements that contain the equivalent
	     * source properties, otherwise it returns `false`.
	     *
	     * @static
	     * @since 4.0.0
	     * @memberOf _
	     * @category Util
	     * @param {*} [func=_.identity] The value to convert to a callback.
	     * @returns {Function} Returns the callback.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
	     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.filter(users, _.iteratee(['user', 'fred']));
	     * // => [{ 'user': 'fred', 'age': 40 }]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.map(users, _.iteratee('user'));
	     * // => ['barney', 'fred']
	     *
	     * // Create custom iteratee shorthands.
	     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
	     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
	     *     return func.test(string);
	     *   };
	     * });
	     *
	     * _.filter(['abc', 'def'], /ef/);
	     * // => ['def']
	     */
	    function iteratee(func) {
	      return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that performs a partial deep comparison between a given
	     * object and `source`, returning `true` if the given object has equivalent
	     * property values, else `false`.
	     *
	     * **Note:** The created function is equivalent to `_.isMatch` with `source`
	     * partially applied.
	     *
	     * Partial comparisons will match empty array and empty object `source`
	     * values against any array or object value, respectively. See `_.isEqual`
	     * for a list of supported value comparisons.
	     *
	     * **Note:** Multiple values can be checked by combining several matchers
	     * using `_.overSome`
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Object} source The object of property values to match.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 1, 'b': 2, 'c': 3 },
	     *   { 'a': 4, 'b': 5, 'c': 6 }
	     * ];
	     *
	     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
	     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
	     *
	     * // Checking for several possible values
	     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
	     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
	     */
	    function matches(source) {
	      return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that performs a partial deep comparison between the
	     * value at `path` of a given object to `srcValue`, returning `true` if the
	     * object value is equivalent, else `false`.
	     *
	     * **Note:** Partial comparisons will match empty array and empty object
	     * `srcValue` values against any array or object value, respectively. See
	     * `_.isEqual` for a list of supported value comparisons.
	     *
	     * **Note:** Multiple values can be checked by combining several matchers
	     * using `_.overSome`
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Util
	     * @param {Array|string} path The path of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 1, 'b': 2, 'c': 3 },
	     *   { 'a': 4, 'b': 5, 'c': 6 }
	     * ];
	     *
	     * _.find(objects, _.matchesProperty('a', 4));
	     * // => { 'a': 4, 'b': 5, 'c': 6 }
	     *
	     * // Checking for several possible values
	     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
	     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
	     */
	    function matchesProperty(path, srcValue) {
	      return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that invokes the method at `path` of a given object.
	     * Any additional arguments are provided to the invoked method.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Util
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Function} Returns the new invoker function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': { 'b': _.constant(2) } },
	     *   { 'a': { 'b': _.constant(1) } }
	     * ];
	     *
	     * _.map(objects, _.method('a.b'));
	     * // => [2, 1]
	     *
	     * _.map(objects, _.method(['a', 'b']));
	     * // => [2, 1]
	     */
	    var method = baseRest(function(path, args) {
	      return function(object) {
	        return baseInvoke(object, path, args);
	      };
	    });
	
	    /**
	     * The opposite of `_.method`; this method creates a function that invokes
	     * the method at a given path of `object`. Any additional arguments are
	     * provided to the invoked method.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Util
	     * @param {Object} object The object to query.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Function} Returns the new invoker function.
	     * @example
	     *
	     * var array = _.times(3, _.constant),
	     *     object = { 'a': array, 'b': array, 'c': array };
	     *
	     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
	     * // => [2, 0]
	     *
	     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
	     * // => [2, 0]
	     */
	    var methodOf = baseRest(function(object, args) {
	      return function(path) {
	        return baseInvoke(object, path, args);
	      };
	    });
	
	    /**
	     * Adds all own enumerable string keyed function properties of a source
	     * object to the destination object. If `object` is a function, then methods
	     * are added to its prototype as well.
	     *
	     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
	     * avoid conflicts caused by modifying the original.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {Function|Object} [object=lodash] The destination object.
	     * @param {Object} source The object of functions to add.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
	     * @returns {Function|Object} Returns `object`.
	     * @example
	     *
	     * function vowels(string) {
	     *   return _.filter(string, function(v) {
	     *     return /[aeiou]/i.test(v);
	     *   });
	     * }
	     *
	     * _.mixin({ 'vowels': vowels });
	     * _.vowels('fred');
	     * // => ['e']
	     *
	     * _('fred').vowels().value();
	     * // => ['e']
	     *
	     * _.mixin({ 'vowels': vowels }, { 'chain': false });
	     * _('fred').vowels();
	     * // => ['e']
	     */
	    function mixin(object, source, options) {
	      var props = keys(source),
	          methodNames = baseFunctions(source, props);
	
	      if (options == null &&
	          !(isObject(source) && (methodNames.length || !props.length))) {
	        options = source;
	        source = object;
	        object = this;
	        methodNames = baseFunctions(source, keys(source));
	      }
	      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
	          isFunc = isFunction(object);
	
	      arrayEach(methodNames, function(methodName) {
	        var func = source[methodName];
	        object[methodName] = func;
	        if (isFunc) {
	          object.prototype[methodName] = function() {
	            var chainAll = this.__chain__;
	            if (chain || chainAll) {
	              var result = object(this.__wrapped__),
	                  actions = result.__actions__ = copyArray(this.__actions__);
	
	              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
	              result.__chain__ = chainAll;
	              return result;
	            }
	            return func.apply(object, arrayPush([this.value()], arguments));
	          };
	        }
	      });
	
	      return object;
	    }
	
	    /**
	     * Reverts the `_` variable to its previous value and returns a reference to
	     * the `lodash` function.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @returns {Function} Returns the `lodash` function.
	     * @example
	     *
	     * var lodash = _.noConflict();
	     */
	    function noConflict() {
	      if (root._ === this) {
	        root._ = oldDash;
	      }
	      return this;
	    }
	
	    /**
	     * This method returns `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.3.0
	     * @category Util
	     * @example
	     *
	     * _.times(2, _.noop);
	     * // => [undefined, undefined]
	     */
	    function noop() {
	      // No operation performed.
	    }
	
	    /**
	     * Creates a function that gets the argument at index `n`. If `n` is negative,
	     * the nth argument from the end is returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {number} [n=0] The index of the argument to return.
	     * @returns {Function} Returns the new pass-thru function.
	     * @example
	     *
	     * var func = _.nthArg(1);
	     * func('a', 'b', 'c', 'd');
	     * // => 'b'
	     *
	     * var func = _.nthArg(-2);
	     * func('a', 'b', 'c', 'd');
	     * // => 'c'
	     */
	    function nthArg(n) {
	      n = toInteger(n);
	      return baseRest(function(args) {
	        return baseNth(args, n);
	      });
	    }
	
	    /**
	     * Creates a function that invokes `iteratees` with the arguments it receives
	     * and returns their results.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [iteratees=[_.identity]]
	     *  The iteratees to invoke.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.over([Math.max, Math.min]);
	     *
	     * func(1, 2, 3, 4);
	     * // => [4, 1]
	     */
	    var over = createOver(arrayMap);
	
	    /**
	     * Creates a function that checks if **all** of the `predicates` return
	     * truthy when invoked with the arguments it receives.
	     *
	     * Following shorthands are possible for providing predicates.
	     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
	     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [predicates=[_.identity]]
	     *  The predicates to check.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.overEvery([Boolean, isFinite]);
	     *
	     * func('1');
	     * // => true
	     *
	     * func(null);
	     * // => false
	     *
	     * func(NaN);
	     * // => false
	     */
	    var overEvery = createOver(arrayEvery);
	
	    /**
	     * Creates a function that checks if **any** of the `predicates` return
	     * truthy when invoked with the arguments it receives.
	     *
	     * Following shorthands are possible for providing predicates.
	     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
	     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [predicates=[_.identity]]
	     *  The predicates to check.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.overSome([Boolean, isFinite]);
	     *
	     * func('1');
	     * // => true
	     *
	     * func(null);
	     * // => true
	     *
	     * func(NaN);
	     * // => false
	     *
	     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
	     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
	     */
	    var overSome = createOver(arraySome);
	
	    /**
	     * Creates a function that returns the value at `path` of a given object.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Util
	     * @param {Array|string} path The path of the property to get.
	     * @returns {Function} Returns the new accessor function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': { 'b': 2 } },
	     *   { 'a': { 'b': 1 } }
	     * ];
	     *
	     * _.map(objects, _.property('a.b'));
	     * // => [2, 1]
	     *
	     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
	     * // => [1, 2]
	     */
	    function property(path) {
	      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
	    }
	
	    /**
	     * The opposite of `_.property`; this method creates a function that returns
	     * the value at a given path of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Object} object The object to query.
	     * @returns {Function} Returns the new accessor function.
	     * @example
	     *
	     * var array = [0, 1, 2],
	     *     object = { 'a': array, 'b': array, 'c': array };
	     *
	     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
	     * // => [2, 0]
	     *
	     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
	     * // => [2, 0]
	     */
	    function propertyOf(object) {
	      return function(path) {
	        return object == null ? undefined : baseGet(object, path);
	      };
	    }
	
	    /**
	     * Creates an array of numbers (positive and/or negative) progressing from
	     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
	     * `start` is specified without an `end` or `step`. If `end` is not specified,
	     * it's set to `start` with `start` then set to `0`.
	     *
	     * **Note:** JavaScript follows the IEEE-754 standard for resolving
	     * floating-point values which can produce unexpected results.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} [step=1] The value to increment or decrement by.
	     * @returns {Array} Returns the range of numbers.
	     * @see _.inRange, _.rangeRight
	     * @example
	     *
	     * _.range(4);
	     * // => [0, 1, 2, 3]
	     *
	     * _.range(-4);
	     * // => [0, -1, -2, -3]
	     *
	     * _.range(1, 5);
	     * // => [1, 2, 3, 4]
	     *
	     * _.range(0, 20, 5);
	     * // => [0, 5, 10, 15]
	     *
	     * _.range(0, -4, -1);
	     * // => [0, -1, -2, -3]
	     *
	     * _.range(1, 4, 0);
	     * // => [1, 1, 1]
	     *
	     * _.range(0);
	     * // => []
	     */
	    var range = createRange();
	
	    /**
	     * This method is like `_.range` except that it populates values in
	     * descending order.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} [step=1] The value to increment or decrement by.
	     * @returns {Array} Returns the range of numbers.
	     * @see _.inRange, _.range
	     * @example
	     *
	     * _.rangeRight(4);
	     * // => [3, 2, 1, 0]
	     *
	     * _.rangeRight(-4);
	     * // => [-3, -2, -1, 0]
	     *
	     * _.rangeRight(1, 5);
	     * // => [4, 3, 2, 1]
	     *
	     * _.rangeRight(0, 20, 5);
	     * // => [15, 10, 5, 0]
	     *
	     * _.rangeRight(0, -4, -1);
	     * // => [-3, -2, -1, 0]
	     *
	     * _.rangeRight(1, 4, 0);
	     * // => [1, 1, 1]
	     *
	     * _.rangeRight(0);
	     * // => []
	     */
	    var rangeRight = createRange(true);
	
	    /**
	     * This method returns a new empty array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {Array} Returns the new empty array.
	     * @example
	     *
	     * var arrays = _.times(2, _.stubArray);
	     *
	     * console.log(arrays);
	     * // => [[], []]
	     *
	     * console.log(arrays[0] === arrays[1]);
	     * // => false
	     */
	    function stubArray() {
	      return [];
	    }
	
	    /**
	     * This method returns `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {boolean} Returns `false`.
	     * @example
	     *
	     * _.times(2, _.stubFalse);
	     * // => [false, false]
	     */
	    function stubFalse() {
	      return false;
	    }
	
	    /**
	     * This method returns a new empty object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {Object} Returns the new empty object.
	     * @example
	     *
	     * var objects = _.times(2, _.stubObject);
	     *
	     * console.log(objects);
	     * // => [{}, {}]
	     *
	     * console.log(objects[0] === objects[1]);
	     * // => false
	     */
	    function stubObject() {
	      return {};
	    }
	
	    /**
	     * This method returns an empty string.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {string} Returns the empty string.
	     * @example
	     *
	     * _.times(2, _.stubString);
	     * // => ['', '']
	     */
	    function stubString() {
	      return '';
	    }
	
	    /**
	     * This method returns `true`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {boolean} Returns `true`.
	     * @example
	     *
	     * _.times(2, _.stubTrue);
	     * // => [true, true]
	     */
	    function stubTrue() {
	      return true;
	    }
	
	    /**
	     * Invokes the iteratee `n` times, returning an array of the results of
	     * each invocation. The iteratee is invoked with one argument; (index).
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {number} n The number of times to invoke `iteratee`.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the array of results.
	     * @example
	     *
	     * _.times(3, String);
	     * // => ['0', '1', '2']
	     *
	     *  _.times(4, _.constant(0));
	     * // => [0, 0, 0, 0]
	     */
	    function times(n, iteratee) {
	      n = toInteger(n);
	      if (n < 1 || n > MAX_SAFE_INTEGER) {
	        return [];
	      }
	      var index = MAX_ARRAY_LENGTH,
	          length = nativeMin(n, MAX_ARRAY_LENGTH);
	
	      iteratee = getIteratee(iteratee);
	      n -= MAX_ARRAY_LENGTH;
	
	      var result = baseTimes(length, iteratee);
	      while (++index < n) {
	        iteratee(index);
	      }
	      return result;
	    }
	
	    /**
	     * Converts `value` to a property path array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {*} value The value to convert.
	     * @returns {Array} Returns the new property path array.
	     * @example
	     *
	     * _.toPath('a.b.c');
	     * // => ['a', 'b', 'c']
	     *
	     * _.toPath('a[0].b.c');
	     * // => ['a', '0', 'b', 'c']
	     */
	    function toPath(value) {
	      if (isArray(value)) {
	        return arrayMap(value, toKey);
	      }
	      return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
	    }
	
	    /**
	     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {string} [prefix=''] The value to prefix the ID with.
	     * @returns {string} Returns the unique ID.
	     * @example
	     *
	     * _.uniqueId('contact_');
	     * // => 'contact_104'
	     *
	     * _.uniqueId();
	     * // => '105'
	     */
	    function uniqueId(prefix) {
	      var id = ++idCounter;
	      return toString(prefix) + id;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Adds two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.4.0
	     * @category Math
	     * @param {number} augend The first number in an addition.
	     * @param {number} addend The second number in an addition.
	     * @returns {number} Returns the total.
	     * @example
	     *
	     * _.add(6, 4);
	     * // => 10
	     */
	    var add = createMathOperation(function(augend, addend) {
	      return augend + addend;
	    }, 0);
	
	    /**
	     * Computes `number` rounded up to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round up.
	     * @param {number} [precision=0] The precision to round up to.
	     * @returns {number} Returns the rounded up number.
	     * @example
	     *
	     * _.ceil(4.006);
	     * // => 5
	     *
	     * _.ceil(6.004, 2);
	     * // => 6.01
	     *
	     * _.ceil(6040, -2);
	     * // => 6100
	     */
	    var ceil = createRound('ceil');
	
	    /**
	     * Divide two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {number} dividend The first number in a division.
	     * @param {number} divisor The second number in a division.
	     * @returns {number} Returns the quotient.
	     * @example
	     *
	     * _.divide(6, 4);
	     * // => 1.5
	     */
	    var divide = createMathOperation(function(dividend, divisor) {
	      return dividend / divisor;
	    }, 1);
	
	    /**
	     * Computes `number` rounded down to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round down.
	     * @param {number} [precision=0] The precision to round down to.
	     * @returns {number} Returns the rounded down number.
	     * @example
	     *
	     * _.floor(4.006);
	     * // => 4
	     *
	     * _.floor(0.046, 2);
	     * // => 0.04
	     *
	     * _.floor(4060, -2);
	     * // => 4000
	     */
	    var floor = createRound('floor');
	
	    /**
	     * Computes the maximum value of `array`. If `array` is empty or falsey,
	     * `undefined` is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {*} Returns the maximum value.
	     * @example
	     *
	     * _.max([4, 2, 8, 6]);
	     * // => 8
	     *
	     * _.max([]);
	     * // => undefined
	     */
	    function max(array) {
	      return (array && array.length)
	        ? baseExtremum(array, identity, baseGt)
	        : undefined;
	    }
	
	    /**
	     * This method is like `_.max` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * the value is ranked. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {*} Returns the maximum value.
	     * @example
	     *
	     * var objects = [{ 'n': 1 }, { 'n': 2 }];
	     *
	     * _.maxBy(objects, function(o) { return o.n; });
	     * // => { 'n': 2 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.maxBy(objects, 'n');
	     * // => { 'n': 2 }
	     */
	    function maxBy(array, iteratee) {
	      return (array && array.length)
	        ? baseExtremum(array, getIteratee(iteratee, 2), baseGt)
	        : undefined;
	    }
	
	    /**
	     * Computes the mean of the values in `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {number} Returns the mean.
	     * @example
	     *
	     * _.mean([4, 2, 8, 6]);
	     * // => 5
	     */
	    function mean(array) {
	      return baseMean(array, identity);
	    }
	
	    /**
	     * This method is like `_.mean` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the value to be averaged.
	     * The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the mean.
	     * @example
	     *
	     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
	     *
	     * _.meanBy(objects, function(o) { return o.n; });
	     * // => 5
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.meanBy(objects, 'n');
	     * // => 5
	     */
	    function meanBy(array, iteratee) {
	      return baseMean(array, getIteratee(iteratee, 2));
	    }
	
	    /**
	     * Computes the minimum value of `array`. If `array` is empty or falsey,
	     * `undefined` is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {*} Returns the minimum value.
	     * @example
	     *
	     * _.min([4, 2, 8, 6]);
	     * // => 2
	     *
	     * _.min([]);
	     * // => undefined
	     */
	    function min(array) {
	      return (array && array.length)
	        ? baseExtremum(array, identity, baseLt)
	        : undefined;
	    }
	
	    /**
	     * This method is like `_.min` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * the value is ranked. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {*} Returns the minimum value.
	     * @example
	     *
	     * var objects = [{ 'n': 1 }, { 'n': 2 }];
	     *
	     * _.minBy(objects, function(o) { return o.n; });
	     * // => { 'n': 1 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.minBy(objects, 'n');
	     * // => { 'n': 1 }
	     */
	    function minBy(array, iteratee) {
	      return (array && array.length)
	        ? baseExtremum(array, getIteratee(iteratee, 2), baseLt)
	        : undefined;
	    }
	
	    /**
	     * Multiply two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {number} multiplier The first number in a multiplication.
	     * @param {number} multiplicand The second number in a multiplication.
	     * @returns {number} Returns the product.
	     * @example
	     *
	     * _.multiply(6, 4);
	     * // => 24
	     */
	    var multiply = createMathOperation(function(multiplier, multiplicand) {
	      return multiplier * multiplicand;
	    }, 1);
	
	    /**
	     * Computes `number` rounded to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round.
	     * @param {number} [precision=0] The precision to round to.
	     * @returns {number} Returns the rounded number.
	     * @example
	     *
	     * _.round(4.006);
	     * // => 4
	     *
	     * _.round(4.006, 2);
	     * // => 4.01
	     *
	     * _.round(4060, -2);
	     * // => 4100
	     */
	    var round = createRound('round');
	
	    /**
	     * Subtract two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {number} minuend The first number in a subtraction.
	     * @param {number} subtrahend The second number in a subtraction.
	     * @returns {number} Returns the difference.
	     * @example
	     *
	     * _.subtract(6, 4);
	     * // => 2
	     */
	    var subtract = createMathOperation(function(minuend, subtrahend) {
	      return minuend - subtrahend;
	    }, 0);
	
	    /**
	     * Computes the sum of the values in `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.4.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {number} Returns the sum.
	     * @example
	     *
	     * _.sum([4, 2, 8, 6]);
	     * // => 20
	     */
	    function sum(array) {
	      return (array && array.length)
	        ? baseSum(array, identity)
	        : 0;
	    }
	
	    /**
	     * This method is like `_.sum` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the value to be summed.
	     * The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the sum.
	     * @example
	     *
	     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
	     *
	     * _.sumBy(objects, function(o) { return o.n; });
	     * // => 20
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sumBy(objects, 'n');
	     * // => 20
	     */
	    function sumBy(array, iteratee) {
	      return (array && array.length)
	        ? baseSum(array, getIteratee(iteratee, 2))
	        : 0;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    // Add methods that return wrapped values in chain sequences.
	    lodash.after = after;
	    lodash.ary = ary;
	    lodash.assign = assign;
	    lodash.assignIn = assignIn;
	    lodash.assignInWith = assignInWith;
	    lodash.assignWith = assignWith;
	    lodash.at = at;
	    lodash.before = before;
	    lodash.bind = bind;
	    lodash.bindAll = bindAll;
	    lodash.bindKey = bindKey;
	    lodash.castArray = castArray;
	    lodash.chain = chain;
	    lodash.chunk = chunk;
	    lodash.compact = compact;
	    lodash.concat = concat;
	    lodash.cond = cond;
	    lodash.conforms = conforms;
	    lodash.constant = constant;
	    lodash.countBy = countBy;
	    lodash.create = create;
	    lodash.curry = curry;
	    lodash.curryRight = curryRight;
	    lodash.debounce = debounce;
	    lodash.defaults = defaults;
	    lodash.defaultsDeep = defaultsDeep;
	    lodash.defer = defer;
	    lodash.delay = delay;
	    lodash.difference = difference;
	    lodash.differenceBy = differenceBy;
	    lodash.differenceWith = differenceWith;
	    lodash.drop = drop;
	    lodash.dropRight = dropRight;
	    lodash.dropRightWhile = dropRightWhile;
	    lodash.dropWhile = dropWhile;
	    lodash.fill = fill;
	    lodash.filter = filter;
	    lodash.flatMap = flatMap;
	    lodash.flatMapDeep = flatMapDeep;
	    lodash.flatMapDepth = flatMapDepth;
	    lodash.flatten = flatten;
	    lodash.flattenDeep = flattenDeep;
	    lodash.flattenDepth = flattenDepth;
	    lodash.flip = flip;
	    lodash.flow = flow;
	    lodash.flowRight = flowRight;
	    lodash.fromPairs = fromPairs;
	    lodash.functions = functions;
	    lodash.functionsIn = functionsIn;
	    lodash.groupBy = groupBy;
	    lodash.initial = initial;
	    lodash.intersection = intersection;
	    lodash.intersectionBy = intersectionBy;
	    lodash.intersectionWith = intersectionWith;
	    lodash.invert = invert;
	    lodash.invertBy = invertBy;
	    lodash.invokeMap = invokeMap;
	    lodash.iteratee = iteratee;
	    lodash.keyBy = keyBy;
	    lodash.keys = keys;
	    lodash.keysIn = keysIn;
	    lodash.map = map;
	    lodash.mapKeys = mapKeys;
	    lodash.mapValues = mapValues;
	    lodash.matches = matches;
	    lodash.matchesProperty = matchesProperty;
	    lodash.memoize = memoize;
	    lodash.merge = merge;
	    lodash.mergeWith = mergeWith;
	    lodash.method = method;
	    lodash.methodOf = methodOf;
	    lodash.mixin = mixin;
	    lodash.negate = negate;
	    lodash.nthArg = nthArg;
	    lodash.omit = omit;
	    lodash.omitBy = omitBy;
	    lodash.once = once;
	    lodash.orderBy = orderBy;
	    lodash.over = over;
	    lodash.overArgs = overArgs;
	    lodash.overEvery = overEvery;
	    lodash.overSome = overSome;
	    lodash.partial = partial;
	    lodash.partialRight = partialRight;
	    lodash.partition = partition;
	    lodash.pick = pick;
	    lodash.pickBy = pickBy;
	    lodash.property = property;
	    lodash.propertyOf = propertyOf;
	    lodash.pull = pull;
	    lodash.pullAll = pullAll;
	    lodash.pullAllBy = pullAllBy;
	    lodash.pullAllWith = pullAllWith;
	    lodash.pullAt = pullAt;
	    lodash.range = range;
	    lodash.rangeRight = rangeRight;
	    lodash.rearg = rearg;
	    lodash.reject = reject;
	    lodash.remove = remove;
	    lodash.rest = rest;
	    lodash.reverse = reverse;
	    lodash.sampleSize = sampleSize;
	    lodash.set = set;
	    lodash.setWith = setWith;
	    lodash.shuffle = shuffle;
	    lodash.slice = slice;
	    lodash.sortBy = sortBy;
	    lodash.sortedUniq = sortedUniq;
	    lodash.sortedUniqBy = sortedUniqBy;
	    lodash.split = split;
	    lodash.spread = spread;
	    lodash.tail = tail;
	    lodash.take = take;
	    lodash.takeRight = takeRight;
	    lodash.takeRightWhile = takeRightWhile;
	    lodash.takeWhile = takeWhile;
	    lodash.tap = tap;
	    lodash.throttle = throttle;
	    lodash.thru = thru;
	    lodash.toArray = toArray;
	    lodash.toPairs = toPairs;
	    lodash.toPairsIn = toPairsIn;
	    lodash.toPath = toPath;
	    lodash.toPlainObject = toPlainObject;
	    lodash.transform = transform;
	    lodash.unary = unary;
	    lodash.union = union;
	    lodash.unionBy = unionBy;
	    lodash.unionWith = unionWith;
	    lodash.uniq = uniq;
	    lodash.uniqBy = uniqBy;
	    lodash.uniqWith = uniqWith;
	    lodash.unset = unset;
	    lodash.unzip = unzip;
	    lodash.unzipWith = unzipWith;
	    lodash.update = update;
	    lodash.updateWith = updateWith;
	    lodash.values = values;
	    lodash.valuesIn = valuesIn;
	    lodash.without = without;
	    lodash.words = words;
	    lodash.wrap = wrap;
	    lodash.xor = xor;
	    lodash.xorBy = xorBy;
	    lodash.xorWith = xorWith;
	    lodash.zip = zip;
	    lodash.zipObject = zipObject;
	    lodash.zipObjectDeep = zipObjectDeep;
	    lodash.zipWith = zipWith;
	
	    // Add aliases.
	    lodash.entries = toPairs;
	    lodash.entriesIn = toPairsIn;
	    lodash.extend = assignIn;
	    lodash.extendWith = assignInWith;
	
	    // Add methods to `lodash.prototype`.
	    mixin(lodash, lodash);
	
	    /*------------------------------------------------------------------------*/
	
	    // Add methods that return unwrapped values in chain sequences.
	    lodash.add = add;
	    lodash.attempt = attempt;
	    lodash.camelCase = camelCase;
	    lodash.capitalize = capitalize;
	    lodash.ceil = ceil;
	    lodash.clamp = clamp;
	    lodash.clone = clone;
	    lodash.cloneDeep = cloneDeep;
	    lodash.cloneDeepWith = cloneDeepWith;
	    lodash.cloneWith = cloneWith;
	    lodash.conformsTo = conformsTo;
	    lodash.deburr = deburr;
	    lodash.defaultTo = defaultTo;
	    lodash.divide = divide;
	    lodash.endsWith = endsWith;
	    lodash.eq = eq;
	    lodash.escape = escape;
	    lodash.escapeRegExp = escapeRegExp;
	    lodash.every = every;
	    lodash.find = find;
	    lodash.findIndex = findIndex;
	    lodash.findKey = findKey;
	    lodash.findLast = findLast;
	    lodash.findLastIndex = findLastIndex;
	    lodash.findLastKey = findLastKey;
	    lodash.floor = floor;
	    lodash.forEach = forEach;
	    lodash.forEachRight = forEachRight;
	    lodash.forIn = forIn;
	    lodash.forInRight = forInRight;
	    lodash.forOwn = forOwn;
	    lodash.forOwnRight = forOwnRight;
	    lodash.get = get;
	    lodash.gt = gt;
	    lodash.gte = gte;
	    lodash.has = has;
	    lodash.hasIn = hasIn;
	    lodash.head = head;
	    lodash.identity = identity;
	    lodash.includes = includes;
	    lodash.indexOf = indexOf;
	    lodash.inRange = inRange;
	    lodash.invoke = invoke;
	    lodash.isArguments = isArguments;
	    lodash.isArray = isArray;
	    lodash.isArrayBuffer = isArrayBuffer;
	    lodash.isArrayLike = isArrayLike;
	    lodash.isArrayLikeObject = isArrayLikeObject;
	    lodash.isBoolean = isBoolean;
	    lodash.isBuffer = isBuffer;
	    lodash.isDate = isDate;
	    lodash.isElement = isElement;
	    lodash.isEmpty = isEmpty;
	    lodash.isEqual = isEqual;
	    lodash.isEqualWith = isEqualWith;
	    lodash.isError = isError;
	    lodash.isFinite = isFinite;
	    lodash.isFunction = isFunction;
	    lodash.isInteger = isInteger;
	    lodash.isLength = isLength;
	    lodash.isMap = isMap;
	    lodash.isMatch = isMatch;
	    lodash.isMatchWith = isMatchWith;
	    lodash.isNaN = isNaN;
	    lodash.isNative = isNative;
	    lodash.isNil = isNil;
	    lodash.isNull = isNull;
	    lodash.isNumber = isNumber;
	    lodash.isObject = isObject;
	    lodash.isObjectLike = isObjectLike;
	    lodash.isPlainObject = isPlainObject;
	    lodash.isRegExp = isRegExp;
	    lodash.isSafeInteger = isSafeInteger;
	    lodash.isSet = isSet;
	    lodash.isString = isString;
	    lodash.isSymbol = isSymbol;
	    lodash.isTypedArray = isTypedArray;
	    lodash.isUndefined = isUndefined;
	    lodash.isWeakMap = isWeakMap;
	    lodash.isWeakSet = isWeakSet;
	    lodash.join = join;
	    lodash.kebabCase = kebabCase;
	    lodash.last = last;
	    lodash.lastIndexOf = lastIndexOf;
	    lodash.lowerCase = lowerCase;
	    lodash.lowerFirst = lowerFirst;
	    lodash.lt = lt;
	    lodash.lte = lte;
	    lodash.max = max;
	    lodash.maxBy = maxBy;
	    lodash.mean = mean;
	    lodash.meanBy = meanBy;
	    lodash.min = min;
	    lodash.minBy = minBy;
	    lodash.stubArray = stubArray;
	    lodash.stubFalse = stubFalse;
	    lodash.stubObject = stubObject;
	    lodash.stubString = stubString;
	    lodash.stubTrue = stubTrue;
	    lodash.multiply = multiply;
	    lodash.nth = nth;
	    lodash.noConflict = noConflict;
	    lodash.noop = noop;
	    lodash.now = now;
	    lodash.pad = pad;
	    lodash.padEnd = padEnd;
	    lodash.padStart = padStart;
	    lodash.parseInt = parseInt;
	    lodash.random = random;
	    lodash.reduce = reduce;
	    lodash.reduceRight = reduceRight;
	    lodash.repeat = repeat;
	    lodash.replace = replace;
	    lodash.result = result;
	    lodash.round = round;
	    lodash.runInContext = runInContext;
	    lodash.sample = sample;
	    lodash.size = size;
	    lodash.snakeCase = snakeCase;
	    lodash.some = some;
	    lodash.sortedIndex = sortedIndex;
	    lodash.sortedIndexBy = sortedIndexBy;
	    lodash.sortedIndexOf = sortedIndexOf;
	    lodash.sortedLastIndex = sortedLastIndex;
	    lodash.sortedLastIndexBy = sortedLastIndexBy;
	    lodash.sortedLastIndexOf = sortedLastIndexOf;
	    lodash.startCase = startCase;
	    lodash.startsWith = startsWith;
	    lodash.subtract = subtract;
	    lodash.sum = sum;
	    lodash.sumBy = sumBy;
	    lodash.template = template;
	    lodash.times = times;
	    lodash.toFinite = toFinite;
	    lodash.toInteger = toInteger;
	    lodash.toLength = toLength;
	    lodash.toLower = toLower;
	    lodash.toNumber = toNumber;
	    lodash.toSafeInteger = toSafeInteger;
	    lodash.toString = toString;
	    lodash.toUpper = toUpper;
	    lodash.trim = trim;
	    lodash.trimEnd = trimEnd;
	    lodash.trimStart = trimStart;
	    lodash.truncate = truncate;
	    lodash.unescape = unescape;
	    lodash.uniqueId = uniqueId;
	    lodash.upperCase = upperCase;
	    lodash.upperFirst = upperFirst;
	
	    // Add aliases.
	    lodash.each = forEach;
	    lodash.eachRight = forEachRight;
	    lodash.first = head;
	
	    mixin(lodash, (function() {
	      var source = {};
	      baseForOwn(lodash, function(func, methodName) {
	        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
	          source[methodName] = func;
	        }
	      });
	      return source;
	    }()), { 'chain': false });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * The semantic version number.
	     *
	     * @static
	     * @memberOf _
	     * @type {string}
	     */
	    lodash.VERSION = VERSION;
	
	    // Assign default placeholders.
	    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
	      lodash[methodName].placeholder = lodash;
	    });
	
	    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
	    arrayEach(['drop', 'take'], function(methodName, index) {
	      LazyWrapper.prototype[methodName] = function(n) {
	        n = n === undefined ? 1 : nativeMax(toInteger(n), 0);
	
	        var result = (this.__filtered__ && !index)
	          ? new LazyWrapper(this)
	          : this.clone();
	
	        if (result.__filtered__) {
	          result.__takeCount__ = nativeMin(n, result.__takeCount__);
	        } else {
	          result.__views__.push({
	            'size': nativeMin(n, MAX_ARRAY_LENGTH),
	            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
	          });
	        }
	        return result;
	      };
	
	      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
	        return this.reverse()[methodName](n).reverse();
	      };
	    });
	
	    // Add `LazyWrapper` methods that accept an `iteratee` value.
	    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
	      var type = index + 1,
	          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
	
	      LazyWrapper.prototype[methodName] = function(iteratee) {
	        var result = this.clone();
	        result.__iteratees__.push({
	          'iteratee': getIteratee(iteratee, 3),
	          'type': type
	        });
	        result.__filtered__ = result.__filtered__ || isFilter;
	        return result;
	      };
	    });
	
	    // Add `LazyWrapper` methods for `_.head` and `_.last`.
	    arrayEach(['head', 'last'], function(methodName, index) {
	      var takeName = 'take' + (index ? 'Right' : '');
	
	      LazyWrapper.prototype[methodName] = function() {
	        return this[takeName](1).value()[0];
	      };
	    });
	
	    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
	    arrayEach(['initial', 'tail'], function(methodName, index) {
	      var dropName = 'drop' + (index ? '' : 'Right');
	
	      LazyWrapper.prototype[methodName] = function() {
	        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
	      };
	    });
	
	    LazyWrapper.prototype.compact = function() {
	      return this.filter(identity);
	    };
	
	    LazyWrapper.prototype.find = function(predicate) {
	      return this.filter(predicate).head();
	    };
	
	    LazyWrapper.prototype.findLast = function(predicate) {
	      return this.reverse().find(predicate);
	    };
	
	    LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
	      if (typeof path == 'function') {
	        return new LazyWrapper(this);
	      }
	      return this.map(function(value) {
	        return baseInvoke(value, path, args);
	      });
	    });
	
	    LazyWrapper.prototype.reject = function(predicate) {
	      return this.filter(negate(getIteratee(predicate)));
	    };
	
	    LazyWrapper.prototype.slice = function(start, end) {
	      start = toInteger(start);
	
	      var result = this;
	      if (result.__filtered__ && (start > 0 || end < 0)) {
	        return new LazyWrapper(result);
	      }
	      if (start < 0) {
	        result = result.takeRight(-start);
	      } else if (start) {
	        result = result.drop(start);
	      }
	      if (end !== undefined) {
	        end = toInteger(end);
	        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
	      }
	      return result;
	    };
	
	    LazyWrapper.prototype.takeRightWhile = function(predicate) {
	      return this.reverse().takeWhile(predicate).reverse();
	    };
	
	    LazyWrapper.prototype.toArray = function() {
	      return this.take(MAX_ARRAY_LENGTH);
	    };
	
	    // Add `LazyWrapper` methods to `lodash.prototype`.
	    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
	      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
	          isTaker = /^(?:head|last)$/.test(methodName),
	          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
	          retUnwrapped = isTaker || /^find/.test(methodName);
	
	      if (!lodashFunc) {
	        return;
	      }
	      lodash.prototype[methodName] = function() {
	        var value = this.__wrapped__,
	            args = isTaker ? [1] : arguments,
	            isLazy = value instanceof LazyWrapper,
	            iteratee = args[0],
	            useLazy = isLazy || isArray(value);
	
	        var interceptor = function(value) {
	          var result = lodashFunc.apply(lodash, arrayPush([value], args));
	          return (isTaker && chainAll) ? result[0] : result;
	        };
	
	        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
	          // Avoid lazy use if the iteratee has a "length" value other than `1`.
	          isLazy = useLazy = false;
	        }
	        var chainAll = this.__chain__,
	            isHybrid = !!this.__actions__.length,
	            isUnwrapped = retUnwrapped && !chainAll,
	            onlyLazy = isLazy && !isHybrid;
	
	        if (!retUnwrapped && useLazy) {
	          value = onlyLazy ? value : new LazyWrapper(this);
	          var result = func.apply(value, args);
	          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
	          return new LodashWrapper(result, chainAll);
	        }
	        if (isUnwrapped && onlyLazy) {
	          return func.apply(this, args);
	        }
	        result = this.thru(interceptor);
	        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
	      };
	    });
	
	    // Add `Array` methods to `lodash.prototype`.
	    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
	      var func = arrayProto[methodName],
	          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
	          retUnwrapped = /^(?:pop|shift)$/.test(methodName);
	
	      lodash.prototype[methodName] = function() {
	        var args = arguments;
	        if (retUnwrapped && !this.__chain__) {
	          var value = this.value();
	          return func.apply(isArray(value) ? value : [], args);
	        }
	        return this[chainName](function(value) {
	          return func.apply(isArray(value) ? value : [], args);
	        });
	      };
	    });
	
	    // Map minified method names to their real names.
	    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
	      var lodashFunc = lodash[methodName];
	      if (lodashFunc) {
	        var key = lodashFunc.name + '';
	        if (!hasOwnProperty.call(realNames, key)) {
	          realNames[key] = [];
	        }
	        realNames[key].push({ 'name': methodName, 'func': lodashFunc });
	      }
	    });
	
	    realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [{
	      'name': 'wrapper',
	      'func': undefined
	    }];
	
	    // Add methods to `LazyWrapper`.
	    LazyWrapper.prototype.clone = lazyClone;
	    LazyWrapper.prototype.reverse = lazyReverse;
	    LazyWrapper.prototype.value = lazyValue;
	
	    // Add chain sequence methods to the `lodash` wrapper.
	    lodash.prototype.at = wrapperAt;
	    lodash.prototype.chain = wrapperChain;
	    lodash.prototype.commit = wrapperCommit;
	    lodash.prototype.next = wrapperNext;
	    lodash.prototype.plant = wrapperPlant;
	    lodash.prototype.reverse = wrapperReverse;
	    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
	
	    // Add lazy aliases.
	    lodash.prototype.first = lodash.prototype.head;
	
	    if (symIterator) {
	      lodash.prototype[symIterator] = wrapperToIterator;
	    }
	    return lodash;
	  });
	
	  /*--------------------------------------------------------------------------*/
	
	  // Export lodash.
	  var _ = runInContext();
	
	  // Some AMD build optimizers, like r.js, check for condition patterns like:
	  if (true) {
	    // Expose Lodash on the global object to prevent errors when Lodash is
	    // loaded by a script tag in the presence of an AMD loader.
	    // See http://requirejs.org/docs/errors.html#mismatch for more details.
	    // Use `_.noConflict` to remove Lodash from the global object.
	    root._ = _;
	
	    // Define as an anonymous module so, through path mapping, it can be
	    // referenced as the "underscore" module.
	    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	      return _;
	    }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  }
	  // Check for `exports` after `define` in case a build optimizer adds it.
	  else if (freeModule) {
	    // Export for Node.js.
	    (freeModule.exports = _)._ = _;
	    // Export for CommonJS support.
	    freeExports._ = _;
	  }
	  else {
	    // Export to the global object.
	    root._ = _;
	  }
	}.call(this));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(485)(module)))

/***/ }),
/* 2034 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _api = __webpack_require__(1160);
	
	var _api2 = _interopRequireDefault(_api);
	
	var _queryString = __webpack_require__(513);
	
	var _queryString2 = _interopRequireDefault(_queryString);
	
	var _qs = __webpack_require__(1206);
	
	var _qs2 = _interopRequireDefault(_qs);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  fetchOne: function fetchOne(apiKey, event) {
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "GET",
	        endpoint: "events/" + event,
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response);
	      });
	    });
	  },
	  fetchAvailability: function fetchAvailability(apiKey, bucket, eventIds) {
	    var json = {};
	
	    if (eventIds) {
	      json.event_ids = eventIds;
	    }
	
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "POST",
	        endpoint: "box_office/" + bucket + "/availability",
	        json: json,
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response);
	      });
	    });
	  },
	  fetchAllForBucket: function fetchAllForBucket(apiKey, bucket, includeScanCounts, excludeOlderEvents) {
	    var queryString = {};
	    queryString.include_scan_counts = includeScanCounts ? true : undefined;
	    queryString.exclude_older_events = excludeOlderEvents ? true : undefined;
	
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "GET",
	        endpoint: "event_buckets/" + bucket + "/events",
	        api_key: apiKey,
	        qs: Object.keys(queryString).length > 0 ? queryString : undefined
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response.events);
	      });
	    });
	  },
	  fetchAllForVenueInBucket: function fetchAllForVenueInBucket(apiKey, venue, bucket, includeScanCounts) {
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "GET",
	        endpoint: "event_buckets/" + bucket + "/events",
	        api_key: apiKey,
	        qs: includeScanCounts ? {
	          include_scan_counts: true,
	          conditions: JSON.stringify({
	            venue: venue
	          })
	        } : undefined
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response.events);
	      });
	    });
	  },
	  fetchAllByTag: function fetchAllByTag(apiKey, eventBucket, tag) {
	    var params = arguments.length <= 3 || arguments[3] === undefined ? {} : arguments[3];
	
	    var newParams = _extends({}, params);
	
	    if (params.sorted && params.sorted.length !== 0) {
	      newParams = _extends({}, newParams, { sortedId: params.sorted[0].id, sortedIsDesc: params.sorted[0].desc });
	    }
	
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "GET",
	        endpoint: "/event_buckets/" + eventBucket + "/tags/" + tag + "/events?" + _qs2.default.stringify(newParams),
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response);
	      });
	    });
	  },
	  edit: function edit(apiKey, event, values, applyRecurring) {
	    console.log(applyRecurring);
	    if (values.rules) {
	      values.rules = JSON.stringify(values.rules);
	    }
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "POST",
	        endpoint: "events/" + event + (applyRecurring ? "?" + _queryString2.default.stringify({ apply_recurring: applyRecurring }) : ""),
	        json: values,
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          err._event = event;
	          return reject(err);
	        }
	        resolve(response);
	      });
	    });
	  },
	  editImage: function editImage(apiKey, event, field, file) {
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "POST",
	        endpoint: "events/" + event,
	        fileField: field,
	        file: file,
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          err._event = event;
	          return reject(err);
	        }
	        resolve(response);
	      });
	    });
	  },
	  delete: function _delete(apiKey, event, applyRecurring) {
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "DELETE",
	        endpoint: "events/" + event + (applyRecurring ? "?" + _queryString2.default.stringify({ apply_recurring: applyRecurring }) : ""),
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response);
	      });
	    });
	  },
	  duplicate: function duplicate(apiKey, event) {
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "POST",
	        endpoint: "events/" + event + "/duplicate",
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          err._event = event;
	          return reject(err);
	        }
	        resolve(response);
	      });
	    });
	  },
	  create: function create(apiKey, values) {
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "POST",
	        endpoint: "events",
	        json: values,
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response);
	      });
	    });
	  }
	};
	module.exports = exports["default"];

/***/ }),
/* 2035 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _alt = __webpack_require__(975);
	
	var _alt2 = _interopRequireDefault(_alt);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var VenueActions = function () {
	  function VenueActions() {
	    _classCallCheck(this, VenueActions);
	
	    this.generateActions("create", "delete", "updateVenues", "fetchOne", "fetchUses", "fetchAllForBucket", "fetchFailed", "editFailed");
	  }
	
	  _createClass(VenueActions, [{
	    key: "updateVenue",
	    value: function updateVenue(id, venue) {
	      return { id: id, venue: venue };
	    }
	  }, {
	    key: "edit",
	    value: function edit(id, values, stage) {
	      return { id: id, values: values, stage: stage };
	    }
	  }]);
	
	  return VenueActions;
	}();
	
	exports.default = _alt2.default.createActions(VenueActions);
	module.exports = exports["default"];

/***/ }),
/* 2036 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _alt = __webpack_require__(975);
	
	var _alt2 = _interopRequireDefault(_alt);
	
	var _keyBy = __webpack_require__(990);
	
	var _keyBy2 = _interopRequireDefault(_keyBy);
	
	var _values = __webpack_require__(1214);
	
	var _values2 = _interopRequireDefault(_values);
	
	var _extend = __webpack_require__(1212);
	
	var _extend2 = _interopRequireDefault(_extend);
	
	var _VenueUtil = __webpack_require__(2037);
	
	var _VenueUtil2 = _interopRequireDefault(_VenueUtil);
	
	var _VenueActions = __webpack_require__(2035);
	
	var _VenueActions2 = _interopRequireDefault(_VenueActions);
	
	var _EventBucketActions = __webpack_require__(1218);
	
	var _EventBucketActions2 = _interopRequireDefault(_EventBucketActions);
	
	var _UserStore = __webpack_require__(974);
	
	var _UserStore2 = _interopRequireDefault(_UserStore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var VenueStore = function () {
	  function VenueStore() {
	    _classCallCheck(this, VenueStore);
	
	    this.bindActions(_VenueActions2.default);
	
	    this.state = {
	      venues: {},
	      isSaving: false,
	      newVenueId: null,
	      stagedData: {},
	      isFetching: false
	    };
	
	    this.exportPublicMethods({
	      getVenueById: this.getVenueById.bind(this),
	      getVenuesForEventBucket: this.getVenuesForEventBucket.bind(this),
	      isVenueComscoreEnabled: this.isVenueComscoreEnabled.bind(this)
	    });
	  }
	
	  _createClass(VenueStore, [{
	    key: "getVenueById",
	    value: function getVenueById(id) {
	      return this.state.venues[id];
	    }
	  }, {
	    key: "getVenuesForEventBucket",
	    value: function getVenuesForEventBucket(id) {
	      return (0, _values2.default)(this.state.venues).filter(function (v) {
	        return v.event_bucket === id;
	      });
	    }
	  }, {
	    key: "isVenueComscoreEnabled",
	    value: function isVenueComscoreEnabled(id) {
	      return this.state.venues[id].comscore_include === false ? false : true;
	    }
	  }, {
	    key: "onFetchOne",
	    value: function onFetchOne(id) {
	      _VenueUtil2.default.fetchOne(_UserStore2.default.getState().apiKey, id).then(function (data) {
	        _VenueActions2.default.updateVenue(id, data);
	      }).catch(_VenueActions2.default.fetchFailed);
	    }
	  }, {
	    key: "onFetchAllForBucket",
	    value: function onFetchAllForBucket(eventBucket) {
	      var _this = this;
	
	      this.setState({ isFetching: true });
	      _VenueUtil2.default.fetchAllForBucket(_UserStore2.default.getState().apiKey, eventBucket).then(function (data) {
	        _VenueActions2.default.updateVenues((0, _keyBy2.default)(data, "id"));
	        _this.setState({ isFetching: false });
	      }).catch(_VenueActions2.default.fetchFailed);
	    }
	  }, {
	    key: "onEdit",
	    value: function onEdit(newData) {
	      var _this2 = this;
	
	      // Stage edit for next submit
	      if (newData.stage) {
	        this.setState({ stagedData: _defineProperty({}, newData.id, newData.values) });
	        return;
	      }
	
	      if (this.state.stagedData[newData.id]) {
	        newData.values = Object.assign(this.state.stagedData[newData.id], newData.values);
	        delete this.state.stagedData[newData.id];
	      }
	
	      this.setState({ isSaving: true });
	      _VenueUtil2.default.edit(_UserStore2.default.getState().apiKey, newData.id, newData.values).then(function (data) {
	        _this2.setState({ isSaving: false });
	        _VenueActions2.default.updateVenue(newData.id, data);
	        _EventBucketActions2.default.fetchOne(data.event_bucket);
	      }).catch(_VenueActions2.default.editFailed);
	    }
	  }, {
	    key: "onDelete",
	    value: function onDelete(id) {
	      var _this3 = this;
	
	      _VenueUtil2.default.delete(_UserStore2.default.getState().apiKey, id).then(function (data) {
	        _EventBucketActions2.default.fetchOne(_this3.state.venues[id].event_bucket);
	        _VenueActions2.default.updateVenue(id, undefined);
	      }).catch(_VenueActions2.default.editFailed);
	    }
	  }, {
	    key: "onCreate",
	    value: function onCreate(newData) {
	      var _this4 = this;
	
	      this.setState({
	        newVenueId: null
	      });
	
	      _VenueUtil2.default.create(_UserStore2.default.getState().apiKey, newData).then(function (data) {
	        _VenueActions2.default.updateVenue(data.id, data);
	        _EventBucketActions2.default.fetchOne(data.event_bucket);
	        _this4.setState({
	          newVenueId: data.id
	        });
	      }).catch(_VenueActions2.default.editFailed);
	    }
	  }, {
	    key: "onUpdateVenue",
	    value: function onUpdateVenue(data) {
	      if (!data.venue) {
	        delete this.state.venues[data.id];
	      } else {
	        this.state.venues[data.id] = data.venue;
	      }
	      this.state.newVenueId = null;
	      this.setState(this.state);
	    }
	  }, {
	    key: "onUpdateVenues",
	    value: function onUpdateVenues(venues) {
	      (0, _extend2.default)(this.state.venues, venues);
	      this.setState(this.state);
	    }
	  }, {
	    key: "onFetchFailed",
	    value: function onFetchFailed(e) {
	      alert("Fetching venue failed: " + e.message);
	      throw e;
	    }
	  }, {
	    key: "onEditFailed",
	    value: function onEditFailed(e) {
	      this.setState({ isSaving: false });
	      alert("Edit failed: " + e.message);
	      throw e;
	    }
	  }]);
	
	  return VenueStore;
	}();
	
	exports.default = _alt2.default.createStore(VenueStore, "VenueStore");
	module.exports = exports["default"];

/***/ }),
/* 2037 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _merge = __webpack_require__(732);
	
	var _merge2 = _interopRequireDefault(_merge);
	
	var _api = __webpack_require__(1160);
	
	var _api2 = _interopRequireDefault(_api);
	
	var _config = __webpack_require__(1173);
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  fetchOne: function fetchOne(apiKey, venue) {
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "GET",
	        endpoint: "venues/" + venue,
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response);
	      });
	    });
	  },
	  fetchAllForBucket: function fetchAllForBucket(apiKey, bucket) {
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "GET",
	        endpoint: "event_buckets/" + bucket + "/venues",
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response.venues);
	      });
	    });
	  },
	  edit: function edit(apiKey, venue, values) {
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "POST",
	        endpoint: "venues/" + venue,
	        json: values,
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response);
	      });
	    });
	  },
	  delete: function _delete(apiKey, venue) {
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "DELETE",
	        endpoint: "venues/" + venue,
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response);
	      });
	    });
	  },
	  create: function create(apiKey, values) {
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "POST",
	        endpoint: "venues",
	        json: values,
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response);
	      });
	    });
	  }
	};
	module.exports = exports["default"];

/***/ }),
/* 2038 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _alt = __webpack_require__(975);
	
	var _alt2 = _interopRequireDefault(_alt);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var TagActions = function () {
	  function TagActions() {
	    _classCallCheck(this, TagActions);
	
	    this.generateActions("create", "delete", "updateTags", "fetchOne", "fetchUses", "fetchAllForBucket", "fetchVisibleTagsForBucket", "fetchFailed", "editFailed", "fetchPresetColors");
	  }
	
	  _createClass(TagActions, [{
	    key: "updateTag",
	    value: function updateTag(id, tag) {
	      return { id: id, tag: tag };
	    }
	  }, {
	    key: "edit",
	    value: function edit(id, values) {
	      return { id: id, values: values };
	    }
	  }]);
	
	  return TagActions;
	}();
	
	exports.default = _alt2.default.createActions(TagActions);
	module.exports = exports["default"];

/***/ }),
/* 2039 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _alt = __webpack_require__(975);
	
	var _alt2 = _interopRequireDefault(_alt);
	
	var _keyBy = __webpack_require__(990);
	
	var _keyBy2 = _interopRequireDefault(_keyBy);
	
	var _values = __webpack_require__(1214);
	
	var _values2 = _interopRequireDefault(_values);
	
	var _extend = __webpack_require__(1212);
	
	var _extend2 = _interopRequireDefault(_extend);
	
	var _TagUtil = __webpack_require__(2040);
	
	var _TagUtil2 = _interopRequireDefault(_TagUtil);
	
	var _TagActions = __webpack_require__(2038);
	
	var _TagActions2 = _interopRequireDefault(_TagActions);
	
	var _EventBucketActions = __webpack_require__(1218);
	
	var _EventBucketActions2 = _interopRequireDefault(_EventBucketActions);
	
	var _UserStore = __webpack_require__(974);
	
	var _UserStore2 = _interopRequireDefault(_UserStore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var TagStore = function () {
	  function TagStore() {
	    _classCallCheck(this, TagStore);
	
	    this.bindActions(_TagActions2.default);
	
	    this.state = {
	      tags: {},
	      presetColors: [], // list of possible colors
	      isSaving: false,
	      newTagId: null,
	      isFetching: false
	    };
	
	    this.exportPublicMethods({
	      getTagById: this.getTagById.bind(this),
	      getTagsForEventBucket: this.getTagsForEventBucket.bind(this)
	    });
	  }
	
	  _createClass(TagStore, [{
	    key: "getTagById",
	    value: function getTagById(id) {
	      return this.state.tags[id];
	    }
	  }, {
	    key: "getTagsForEventBucket",
	    value: function getTagsForEventBucket(id) {
	      var hideHidden = arguments.length <= 1 || arguments[1] === undefined ? false : arguments[1];
	
	      var tags = (0, _values2.default)(this.state.tags).filter(function (v) {
	        return v.event_bucket === id;
	      });
	
	      if (hideHidden) {
	        tags = tags.filter(function (tag) {
	          return tag.visible;
	        });
	      }
	
	      return tags;
	    }
	  }, {
	    key: "onFetchPresetColors",
	    value: function onFetchPresetColors() {
	      var _this = this;
	
	      _TagUtil2.default.fetchPresetColors(_UserStore2.default.getState().apiKey).then(function (data) {
	        _this.setState({ presetColors: data.colors });
	      }).catch(_TagActions2.default.fetchFailed);
	    }
	  }, {
	    key: "onFetchOne",
	    value: function onFetchOne(id) {
	      _TagUtil2.default.fetchOne(_UserStore2.default.getState().apiKey, id).then(function (data) {
	        _TagActions2.default.updateTag(id, data);
	      }).catch(_TagActions2.default.fetchFailed);
	    }
	  }, {
	    key: "onFetchAllForBucket",
	    value: function onFetchAllForBucket(eventBucket) {
	      var _this2 = this;
	
	      this.setState({ isFetching: true });
	      _TagUtil2.default.fetchAllForBucket(_UserStore2.default.getState().apiKey, eventBucket).then(function (data) {
	        _TagActions2.default.updateTags((0, _keyBy2.default)(data, "id"));
	        _this2.setState({ isFetching: false });
	      }).catch(_TagActions2.default.fetchFailed);
	    }
	  }, {
	    key: "onEdit",
	    value: function onEdit(newData) {
	      var _this3 = this;
	
	      this.setState({ isSaving: true });
	      _TagUtil2.default.edit(_UserStore2.default.getState().apiKey, newData.id, newData.values).then(function (data) {
	        _this3.setState({ isSaving: false });
	        _TagActions2.default.updateTag(newData.id, data);
	        _EventBucketActions2.default.fetchOne(data.event_bucket);
	      }).catch(_TagActions2.default.editFailed);
	    }
	  }, {
	    key: "onDelete",
	    value: function onDelete(id) {
	      var _this4 = this;
	
	      _TagUtil2.default.delete(_UserStore2.default.getState().apiKey, id).then(function (data) {
	        _EventBucketActions2.default.fetchOne(_this4.state.tags[id].event_bucket);
	        _TagActions2.default.updateTag(id, undefined);
	      }).catch(_TagActions2.default.editFailed);
	    }
	  }, {
	    key: "onCreate",
	    value: function onCreate(newData) {
	      var _this5 = this;
	
	      this.setState({
	        newTagId: null
	      });
	
	      _TagUtil2.default.create(_UserStore2.default.getState().apiKey, newData).then(function (data) {
	        _TagActions2.default.updateTag(data.id, data);
	        _EventBucketActions2.default.fetchOne(data.event_bucket);
	        _this5.setState({
	          newTagId: data.id
	        });
	      }).catch(_TagActions2.default.editFailed);
	    }
	  }, {
	    key: "onUpdateTag",
	    value: function onUpdateTag(data) {
	      if (!data.tag) {
	        delete this.state.tags[data.id];
	      } else {
	        this.state.tags[data.id] = data.tag;
	      }
	      this.state.newTagId = null;
	      this.setState(this.state);
	    }
	  }, {
	    key: "onUpdateTags",
	    value: function onUpdateTags(tags) {
	      (0, _extend2.default)(this.state.tags, tags);
	      this.setState(this.state);
	    }
	  }, {
	    key: "onFetchFailed",
	    value: function onFetchFailed(e) {
	      alert("Fetching tag failed: " + e.message);
	      throw e;
	    }
	  }, {
	    key: "onEditFailed",
	    value: function onEditFailed(e) {
	      this.setState({ isSaving: false });
	      alert("Edit failed: " + e.message);
	      throw e;
	    }
	  }]);
	
	  return TagStore;
	}();
	
	exports.default = _alt2.default.createStore(TagStore, "TagStore");
	module.exports = exports["default"];

/***/ }),
/* 2040 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _merge = __webpack_require__(732);
	
	var _merge2 = _interopRequireDefault(_merge);
	
	var _api = __webpack_require__(1160);
	
	var _api2 = _interopRequireDefault(_api);
	
	var _config = __webpack_require__(1173);
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  fetchPresetColors: function fetchPresetColors(apiKey) {
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "GET",
	        endpoint: "tags/_preset_colors",
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response);
	      });
	    });
	  },
	  fetchOne: function fetchOne(apiKey, tag) {
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "GET",
	        endpoint: "tags/" + tag,
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response);
	      });
	    });
	  },
	  fetchAllForBucket: function fetchAllForBucket(apiKey, bucket) {
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "GET",
	        endpoint: "event_buckets/" + bucket + "/tags",
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response.tags);
	      });
	    });
	  },
	  edit: function edit(apiKey, tag, values) {
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "POST",
	        endpoint: "tags/" + tag,
	        json: values,
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response);
	      });
	    });
	  },
	  delete: function _delete(apiKey, tag) {
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "DELETE",
	        endpoint: "tags/" + tag,
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response);
	      });
	    });
	  },
	  create: function create(apiKey, values) {
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "POST",
	        endpoint: "tags",
	        json: values,
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response);
	      });
	    });
	  }
	};
	module.exports = exports["default"];

/***/ }),
/* 2041 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _alt = __webpack_require__(975);
	
	var _alt2 = _interopRequireDefault(_alt);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var CouponActions = function () {
	  function CouponActions() {
	    _classCallCheck(this, CouponActions);
	
	    this.generateActions("create", "delete", "updateCoupons", "fetchOne", "fetchUses", "fetchAllForBucket", "fetchFailed", "editFailed");
	  }
	
	  _createClass(CouponActions, [{
	    key: "updateCoupon",
	    value: function updateCoupon(id, coupon) {
	      return { id: id, coupon: coupon };
	    }
	  }, {
	    key: "edit",
	    value: function edit(id, values) {
	      return { id: id, values: values };
	    }
	  }]);
	
	  return CouponActions;
	}();
	
	exports.default = _alt2.default.createActions(CouponActions);
	module.exports = exports["default"];

/***/ }),
/* 2042 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _alt = __webpack_require__(975);
	
	var _alt2 = _interopRequireDefault(_alt);
	
	var _keyBy = __webpack_require__(990);
	
	var _keyBy2 = _interopRequireDefault(_keyBy);
	
	var _values = __webpack_require__(1214);
	
	var _values2 = _interopRequireDefault(_values);
	
	var _extend = __webpack_require__(1212);
	
	var _extend2 = _interopRequireDefault(_extend);
	
	var _CouponUtil = __webpack_require__(2043);
	
	var _CouponUtil2 = _interopRequireDefault(_CouponUtil);
	
	var _CouponActions = __webpack_require__(2041);
	
	var _CouponActions2 = _interopRequireDefault(_CouponActions);
	
	var _EventBucketActions = __webpack_require__(1218);
	
	var _EventBucketActions2 = _interopRequireDefault(_EventBucketActions);
	
	var _UserStore = __webpack_require__(974);
	
	var _UserStore2 = _interopRequireDefault(_UserStore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var CouponStore = function () {
	  function CouponStore() {
	    _classCallCheck(this, CouponStore);
	
	    this.bindActions(_CouponActions2.default);
	
	    this.state = {
	      coupons: {},
	      couponUses: {},
	      newCouponId: null,
	      isFetching: false
	    };
	
	    this.exportPublicMethods({
	      getCouponById: this.getCouponById.bind(this),
	      getCouponUsesById: this.getCouponUsesById.bind(this),
	      getCouponsForEventBucket: this.getCouponsForEventBucket.bind(this)
	    });
	  }
	
	  _createClass(CouponStore, [{
	    key: "getCouponById",
	    value: function getCouponById(id) {
	      return this.state.coupons[id];
	    }
	  }, {
	    key: "getCouponUsesById",
	    value: function getCouponUsesById(id) {
	      return this.state.couponUses[id] || [];
	    }
	  }, {
	    key: "getCouponsForEventBucket",
	    value: function getCouponsForEventBucket(id) {
	      return (0, _values2.default)(this.state.coupons).filter(function (c) {
	        return c.event_bucket === id;
	      });
	    }
	  }, {
	    key: "onFetchOne",
	    value: function onFetchOne(id) {
	      var _this = this;
	
	      this.setState({ isFetching: true });
	      _CouponUtil2.default.fetchOne(_UserStore2.default.getState().apiKey, id).then(function (data) {
	        _CouponActions2.default.updateCoupon(id, data);
	        _this.setState({ isFetching: false });
	      }).catch(_CouponActions2.default.fetchFailed);
	    }
	  }, {
	    key: "onFetchUses",
	    value: function onFetchUses(id) {
	      var _this2 = this;
	
	      this.setState({ isFetchingUses: true });
	      _CouponUtil2.default.fetchUses(_UserStore2.default.getState().apiKey, id).then(function (data) {
	        _this2.state.couponUses[id] = data;
	        _this2.state.isFetchingUses = false;
	        _this2.setState(_this2.state);
	      }).catch(_CouponActions2.default.fetchFailed);
	    }
	  }, {
	    key: "onFetchAllForBucket",
	    value: function onFetchAllForBucket(eventBucket) {
	      var _this3 = this;
	
	      this.setState({ isFetching: true });
	      _CouponUtil2.default.fetchAllForBucket(_UserStore2.default.getState().apiKey, eventBucket).then(function (data) {
	        _CouponActions2.default.updateCoupons((0, _keyBy2.default)(data, "id"));
	        _this3.setState({ isFetching: false });
	      }).catch(_CouponActions2.default.fetchFailed);
	    }
	  }, {
	    key: "onEdit",
	    value: function onEdit(newData) {
	      _CouponUtil2.default.edit(_UserStore2.default.getState().apiKey, newData.id, newData.values).then(function (data) {
	        _CouponActions2.default.updateCoupon(newData.id, data);
	        _EventBucketActions2.default.fetchOne(data.event_bucket);
	      }).catch(_CouponActions2.default.editFailed);
	    }
	  }, {
	    key: "onDelete",
	    value: function onDelete(id) {
	      var _this4 = this;
	
	      _CouponUtil2.default.delete(_UserStore2.default.getState().apiKey, id).then(function (data) {
	        _EventBucketActions2.default.fetchOne(_this4.state.coupons[id].event_bucket);
	        _CouponActions2.default.updateCoupon(id, undefined);
	      }).catch(_CouponActions2.default.editFailed);
	    }
	  }, {
	    key: "onCreate",
	    value: function onCreate(newData) {
	      var _this5 = this;
	
	      this.setState({
	        newCouponId: null
	      });
	
	      _CouponUtil2.default.create(_UserStore2.default.getState().apiKey, newData).then(function (data) {
	        _CouponActions2.default.updateCoupon(data.id, data);
	        _EventBucketActions2.default.fetchOne(data.event_bucket);
	        _this5.setState({
	          newCouponId: data.id
	        });
	      }).catch(_CouponActions2.default.editFailed);
	    }
	  }, {
	    key: "onUpdateCoupon",
	    value: function onUpdateCoupon(data) {
	      if (!data.coupon) {
	        delete this.state.coupons[data.id];
	      } else {
	        this.state.coupons[data.id] = data.coupon;
	      }
	      this.state.newCouponId = null;
	      this.setState(this.state);
	    }
	  }, {
	    key: "onUpdateCoupons",
	    value: function onUpdateCoupons(coupons) {
	      (0, _extend2.default)(this.state.coupons, coupons);
	      this.setState(this.state);
	    }
	  }, {
	    key: "onFetchFailed",
	    value: function onFetchFailed(e) {
	      alert("Fetching coupon failed: " + e.message);
	      throw e;
	    }
	  }, {
	    key: "onEditFailed",
	    value: function onEditFailed(e) {
	      alert("Edit failed: " + e.message);
	      throw e;
	    }
	  }]);
	
	  return CouponStore;
	}();
	
	exports.default = _alt2.default.createStore(CouponStore, "CouponStore");
	module.exports = exports["default"];

/***/ }),
/* 2043 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _merge = __webpack_require__(732);
	
	var _merge2 = _interopRequireDefault(_merge);
	
	var _api = __webpack_require__(1160);
	
	var _api2 = _interopRequireDefault(_api);
	
	var _config = __webpack_require__(1173);
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  fetchOne: function fetchOne(apiKey, coupon) {
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "GET",
	        endpoint: "coupons/" + coupon,
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response);
	      });
	    });
	  },
	  fetchUses: function fetchUses(apiKey, coupon) {
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "GET",
	        endpoint: "coupons/" + coupon + "/uses?limit=all",
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response.uses);
	      });
	    });
	  },
	  fetchAllForBucket: function fetchAllForBucket(apiKey, bucket) {
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "GET",
	        endpoint: "event_buckets/" + bucket + "/coupons",
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response.coupons);
	      });
	    });
	  },
	  edit: function edit(apiKey, coupon, values) {
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "POST",
	        endpoint: "coupons/" + coupon,
	        json: values,
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response);
	      });
	    });
	  },
	  delete: function _delete(apiKey, coupon) {
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "DELETE",
	        endpoint: "coupons/" + coupon,
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response);
	      });
	    });
	  },
	  create: function create(apiKey, values) {
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "POST",
	        endpoint: "coupons",
	        json: values,
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response);
	      });
	    });
	  }
	};
	module.exports = exports["default"];

/***/ }),
/* 2044 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _alt = __webpack_require__(975);
	
	var _alt2 = _interopRequireDefault(_alt);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ItemBucketActions = function () {
	  function ItemBucketActions() {
	    _classCallCheck(this, ItemBucketActions);
	
	    this.generateActions("create", "delete", "updateItemBuckets", "fetchAllForEventBucket", "fetchOne", "fetchFailed", "editFailed");
	  }
	
	  _createClass(ItemBucketActions, [{
	    key: "edit",
	    value: function edit(id, values) {
	      return { id: id, values: values };
	    }
	  }, {
	    key: "updateItemBucket",
	    value: function updateItemBucket(id, itemBucket) {
	      return { id: id, itemBucket: itemBucket };
	    }
	  }]);
	
	  return ItemBucketActions;
	}();
	
	exports.default = _alt2.default.createActions(ItemBucketActions);
	module.exports = exports["default"];

/***/ }),
/* 2045 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _alt = __webpack_require__(975);
	
	var _alt2 = _interopRequireDefault(_alt);
	
	var _keyBy = __webpack_require__(990);
	
	var _keyBy2 = _interopRequireDefault(_keyBy);
	
	var _values = __webpack_require__(1214);
	
	var _values2 = _interopRequireDefault(_values);
	
	var _EventBucketActions = __webpack_require__(1218);
	
	var _EventBucketActions2 = _interopRequireDefault(_EventBucketActions);
	
	var _ItemBucketUtil = __webpack_require__(2046);
	
	var _ItemBucketUtil2 = _interopRequireDefault(_ItemBucketUtil);
	
	var _ItemBucketActions = __webpack_require__(2044);
	
	var _ItemBucketActions2 = _interopRequireDefault(_ItemBucketActions);
	
	var _UserStore = __webpack_require__(974);
	
	var _UserStore2 = _interopRequireDefault(_UserStore);
	
	var _GlobalNotificationActions = __webpack_require__(1182);
	
	var _GlobalNotificationActions2 = _interopRequireDefault(_GlobalNotificationActions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ItemBucketStore = function () {
	  function ItemBucketStore() {
	    _classCallCheck(this, ItemBucketStore);
	
	    this.bindActions(_ItemBucketActions2.default);
	
	    this.state = {
	      itemBuckets: {},
	      newItemBucketId: null,
	      isFetching: false
	    };
	
	    this.exportPublicMethods({
	      getItemBucketById: this.getItemBucketById.bind(this),
	      getItemBucketsForEventBucket: this.getItemBucketsForEventBucket.bind(this)
	    });
	  }
	
	  _createClass(ItemBucketStore, [{
	    key: "getItemBucketById",
	    value: function getItemBucketById(id) {
	      return this.state.itemBuckets[id];
	    }
	  }, {
	    key: "getItemBucketsForEventBucket",
	    value: function getItemBucketsForEventBucket(id) {
	      return (0, _values2.default)(this.state.itemBuckets).filter(function (p) {
	        return p.event_bucket === id;
	      });
	    }
	  }, {
	    key: "onFetchAllForEventBucket",
	    value: function onFetchAllForEventBucket(eventBucket) {
	      var _this = this;
	
	      this.setState({ isFetching: true });
	      _ItemBucketUtil2.default.fetchAllForEventBucket(_UserStore2.default.getState().apiKey, eventBucket).then(function (data) {
	        _ItemBucketActions2.default.updateItemBuckets((0, _keyBy2.default)(data, "id"));
	        _this.setState({ isFetching: false });
	      }).catch(_ItemBucketActions2.default.fetchFailed);
	    }
	  }, {
	    key: "onFetchOne",
	    value: function onFetchOne(id) {
	      _ItemBucketUtil2.default.fetchOne(_UserStore2.default.getState().apiKey, id).then(function (data) {
	        _ItemBucketActions2.default.updateItemBucket(id, data);
	      }).catch(_ItemBucketActions2.default.fetchFailed);
	    }
	  }, {
	    key: "onEdit",
	    value: function onEdit(newData) {
	      _ItemBucketUtil2.default.edit(_UserStore2.default.getState().apiKey, newData.id, newData.values).then(function (data) {
	        window.Intercom("trackEvent", "edit-item-bucket");
	
	        _ItemBucketActions2.default.updateItemBucket(newData.id, data);
	        _EventBucketActions2.default.fetchOne(data.event_bucket);
	      }).catch(_ItemBucketActions2.default.editFailed);
	    }
	  }, {
	    key: "onDelete",
	    value: function onDelete(id) {
	      var _this2 = this;
	
	      _ItemBucketUtil2.default.delete(_UserStore2.default.getState().apiKey, id).then(function (data) {
	        _EventBucketActions2.default.fetchOne(_this2.state.itemBuckets[id].event_bucket);
	        _ItemBucketActions2.default.updateItemBucket(id, undefined);
	      }).catch(_ItemBucketActions2.default.editFailed);
	    }
	  }, {
	    key: "onCreate",
	    value: function onCreate(newData) {
	      var _this3 = this;
	
	      this.setState({
	        newItemBucketId: null
	      });
	
	      _ItemBucketUtil2.default.create(_UserStore2.default.getState().apiKey, newData).then(function (data) {
	        _ItemBucketActions2.default.updateItemBucket(data.id, data);
	        _EventBucketActions2.default.fetchOne(data.event_bucket);
	        _this3.setState({
	          newItemBucketId: data.id
	        });
	      }).catch(_ItemBucketActions2.default.editFailed);
	    }
	  }, {
	    key: "onUpdateItemBuckets",
	    value: function onUpdateItemBuckets(itemBuckets) {
	      this.setState({ itemBuckets: itemBuckets });
	    }
	  }, {
	    key: "onUpdateItemBucket",
	    value: function onUpdateItemBucket(data) {
	      if (!data.itemBucket) {
	        delete this.state.itemBuckets[data.id];
	      } else {
	        this.state.itemBuckets[data.id] = data.itemBucket;
	      }
	      this.state.newItemBucketId = null;
	      this.setState(this.state);
	    }
	  }, {
	    key: "onFetchFailed",
	    value: function onFetchFailed(e) {
	      console.error("Fetching item bucket failed:", e);
	      _GlobalNotificationActions2.default.notify.defer("Fetching item bucket failed: " + e.message);
	      throw e;
	    }
	  }, {
	    key: "onEditFailed",
	    value: function onEditFailed(e) {
	      alert("Edit failed: " + e.message);
	    }
	  }]);
	
	  return ItemBucketStore;
	}();
	
	exports.default = _alt2.default.createStore(ItemBucketStore, "ItemBucketStore");
	module.exports = exports["default"];

/***/ }),
/* 2046 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _merge = __webpack_require__(732);
	
	var _merge2 = _interopRequireDefault(_merge);
	
	var _api = __webpack_require__(1160);
	
	var _api2 = _interopRequireDefault(_api);
	
	var _config = __webpack_require__(1173);
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  fetchAllForEventBucket: function fetchAllForEventBucket(apiKey, eventBucket) {
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "GET",
	        endpoint: "event_buckets/" + eventBucket + "/item_buckets",
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response.item_buckets);
	      });
	    });
	  },
	  fetchOne: function fetchOne(apiKey, itemBucket) {
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "GET",
	        endpoint: "item_buckets/" + itemBucket,
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response);
	      });
	    });
	  },
	  edit: function edit(apiKey, itemBucket, values) {
	    if (values.rules) {
	      values.rules = JSON.stringify(values.rules);
	    }
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "POST",
	        endpoint: "item_buckets/" + itemBucket,
	        json: values,
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response);
	      });
	    });
	  },
	  delete: function _delete(apiKey, itemBucket) {
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "DELETE",
	        endpoint: "item_buckets/" + itemBucket,
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response);
	      });
	    });
	  },
	  create: function create(apiKey, values) {
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "POST",
	        endpoint: "item_buckets",
	        json: values,
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response);
	      });
	    });
	  }
	};
	module.exports = exports["default"];

/***/ }),
/* 2047 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _alt = __webpack_require__(975);
	
	var _alt2 = _interopRequireDefault(_alt);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var PassActions = function () {
	  function PassActions() {
	    _classCallCheck(this, PassActions);
	
	    this.generateActions("updatePasses", "fetchAllForPerson", "fetchAllForPassBucket", "fetchAllForEventBucket", "fetchAllForEventBucketIncludingGlobal", "fetchOne", "fetchPassSubscription", "fetchAutocomplete", "fetchFailed", "delete", "deletePasses", "deleteFailed", "refundPass", "editFailed", "bulkTransferPasses", "bulkCancelPassTransfers", "cancelTransfer");
	  }
	
	  _createClass(PassActions, [{
	    key: "fetchPassTransferHistory",
	    value: function fetchPassTransferHistory(passId, eventBucketId) {
	      return { passId: passId, eventBucketId: eventBucketId };
	    }
	  }, {
	    key: "updatePass",
	    value: function updatePass(id, pass) {
	      return { id: id, pass: pass };
	    }
	  }, {
	    key: "updatePassSubscription",
	    value: function updatePassSubscription(id, pass_subscription) {
	      return { id: id, pass_subscription: pass_subscription };
	    }
	  }, {
	    key: "updateAutocomplete",
	    value: function updateAutocomplete(data) {
	      return { data: data };
	    }
	  }, {
	    key: "edit",
	    value: function edit(id, values) {
	      return { id: id, values: values };
	    }
	  }, {
	    key: "transfer",
	    value: function transfer(id, recipient) {
	      return { id: id, recipient: recipient };
	    }
	  }, {
	    key: "editPassSubscription",
	    value: function editPassSubscription(id, values) {
	      return { id: id, values: values };
	    }
	  }]);
	
	  return PassActions;
	}();
	
	exports.default = _alt2.default.createActions(PassActions);
	module.exports = exports["default"];

/***/ }),
/* 2048 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _alt = __webpack_require__(975);
	
	var _alt2 = _interopRequireDefault(_alt);
	
	var _keyBy = __webpack_require__(990);
	
	var _keyBy2 = _interopRequireDefault(_keyBy);
	
	var _extend = __webpack_require__(1212);
	
	var _extend2 = _interopRequireDefault(_extend);
	
	var _values = __webpack_require__(1214);
	
	var _values2 = _interopRequireDefault(_values);
	
	var _PassUtil = __webpack_require__(2049);
	
	var _PassUtil2 = _interopRequireDefault(_PassUtil);
	
	var _PassActions = __webpack_require__(2047);
	
	var _PassActions2 = _interopRequireDefault(_PassActions);
	
	var _UserStore = __webpack_require__(974);
	
	var _UserStore2 = _interopRequireDefault(_UserStore);
	
	var _OrderStore = __webpack_require__(2050);
	
	var _OrderStore2 = _interopRequireDefault(_OrderStore);
	
	var _OrderActions = __webpack_require__(1220);
	
	var _OrderActions2 = _interopRequireDefault(_OrderActions);
	
	var _LedgerActions = __webpack_require__(2052);
	
	var _LedgerActions2 = _interopRequireDefault(_LedgerActions);
	
	var _OrderUtil = __webpack_require__(2051);
	
	var _OrderUtil2 = _interopRequireDefault(_OrderUtil);
	
	var _GlobalNotificationActions = __webpack_require__(1182);
	
	var _GlobalNotificationActions2 = _interopRequireDefault(_GlobalNotificationActions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var PassStore = function () {
	  function PassStore() {
	    _classCallCheck(this, PassStore);
	
	    this.bindActions(_PassActions2.default);
	
	    this.state = {
	      passes: {},
	      deletedPasses: {},
	      passesAutocomplete: [],
	      passSubscriptions: {},
	      eventBucketPassesIncludingGlobal: {},
	      passTransferHistory: [],
	      passTransferHistorySinglePass: {},
	      isFetching: false,
	      isEditing: false
	    };
	
	    this.exportPublicMethods({
	      getPassById: this.getPassById.bind(this),
	      getPassSubscriptionById: this.getPassSubscriptionById.bind(this),
	      getPassesForPerson: this.getPassesForPerson.bind(this),
	      getPassesForPassBucket: this.getPassesForPassBucket.bind(this),
	      getPassesForEventBucket: this.getPassesForEventBucket.bind(this),
	      getPassesForEventBucketIncludingGlobal: this.getPassesForEventBucketIncludingGlobal.bind(this),
	      getPassesAutocomplete: this.getPassesAutocomplete.bind(this),
	      getPassTransferHistory: this.getPassTransferHistory.bind(this),
	      getPassTransferHistorySinglePass: this.getPassTransferHistorySinglePass.bind(this),
	      getMembershipsForEventBucket: this.getMembershipsForEventBucket.bind(this)
	    });
	  }
	
	  _createClass(PassStore, [{
	    key: "getPassById",
	    value: function getPassById(id) {
	      return this.state.passes[id];
	    }
	  }, {
	    key: "getPassSubscriptionById",
	    value: function getPassSubscriptionById(id) {
	      return this.state.passSubscriptions[id];
	    }
	  }, {
	    key: "getPassesForPerson",
	    value: function getPassesForPerson(id, eventBucket) {
	      return (0, _values2.default)(this.state.passes).filter(function (p) {
	        if (eventBucket && p.event_bucket !== eventBucket) {
	          return false;
	        }
	        return p.person && p.person.id === id;
	      });
	    }
	  }, {
	    key: "getPassesForPassBucket",
	    value: function getPassesForPassBucket(id) {
	      return (0, _values2.default)(this.state.passes).filter(function (p) {
	        return p.pass_bucket.id === id;
	      });
	    }
	  }, {
	    key: "getPassesForEventBucket",
	    value: function getPassesForEventBucket(id) {
	      return (0, _values2.default)(this.state.passes).filter(function (p) {
	        return p.event_bucket === id && !p.pass_bucket.is_membership;
	      });
	    }
	  }, {
	    key: "getMembershipsForEventBucket",
	    value: function getMembershipsForEventBucket(id) {
	      return (0, _values2.default)(this.state.passes).filter(function (p) {
	        return p.event_bucket === id && p.pass_bucket.is_membership;
	      });
	    }
	  }, {
	    key: "getPassesForEventBucketIncludingGlobal",
	    value: function getPassesForEventBucketIncludingGlobal(id) {
	      var _this = this;
	
	      return this.state.eventBucketPassesIncludingGlobal[id] ? this.state.eventBucketPassesIncludingGlobal[id].map(function (passId) {
	        return _this.state.passes[passId];
	      }).filter(function (p) {
	        if (!p) {
	          return false;
	        }
	
	        if (p.is_active === false || p.pass_bucket && p.pass_bucket.hide_from_users) {
	          // This drives Box Office UI - hide hidden or disabled passes
	          return false;
	        }
	
	        return true;
	      }) : [];
	    }
	  }, {
	    key: "getPassesAutocomplete",
	    value: function getPassesAutocomplete() {
	      return this.state.passesAutocomplete;
	    }
	  }, {
	    key: "getPassTransferHistory",
	    value: function getPassTransferHistory() {
	      return this.state.passTransferHistory;
	    }
	  }, {
	    key: "getPassTransferHistorySinglePass",
	    value: function getPassTransferHistorySinglePass() {
	      return this.state.passTransferHistorySinglePass;
	    }
	  }, {
	    key: "onFetchAllForPassBucket",
	    value: function onFetchAllForPassBucket(bucketId) {
	      var _this2 = this;
	
	      this.setState({ isFetching: true });
	      _PassUtil2.default.fetchAllForPassBucket(_UserStore2.default.getState().apiKey, bucketId).then(function (data) {
	        _PassActions2.default.updatePasses((0, _keyBy2.default)(data, "id"));
	        _this2.setState({ isFetching: false });
	      }).catch(_PassActions2.default.fetchFailed);
	    }
	  }, {
	    key: "onFetchAllForPerson",
	    value: function onFetchAllForPerson(personId) {
	      var _this3 = this;
	
	      this.setState({ isFetching: true });
	      _PassUtil2.default.fetchAllForPerson(_UserStore2.default.getState().apiKey, personId).then(function (data) {
	        _PassActions2.default.updatePasses((0, _keyBy2.default)(data, "id"));
	        _this3.setState({ isFetching: false });
	      }).catch(_PassActions2.default.fetchFailed);
	    }
	  }, {
	    key: "onFetchAllForEventBucket",
	    value: function onFetchAllForEventBucket(eventBucketId) {
	      var _this4 = this;
	
	      this.setState({ isFetching: true });
	      _PassUtil2.default.fetchAllForEventBucket(_UserStore2.default.getState().apiKey, eventBucketId).then(function (data) {
	        _PassActions2.default.updatePasses((0, _keyBy2.default)(data, "id"));
	        _this4.setState({ isFetching: false });
	      }).catch(_PassActions2.default.fetchFailed);
	    }
	  }, {
	    key: "onFetchAllForEventBucketIncludingGlobal",
	    value: function onFetchAllForEventBucketIncludingGlobal(eventBucketId) {
	      var _this5 = this;
	
	      this.setState({ isFetching: true });
	      _PassUtil2.default.fetchAllForEventBucketIncludingGlobal(_UserStore2.default.getState().apiKey, eventBucketId).then(function (data) {
	        _this5.state.eventBucketPassesIncludingGlobal[eventBucketId] = data.map(function (d) {
	          return d.id;
	        });
	        _this5.setState({
	          eventBucketPassesIncludingGlobal: _this5.state.eventBucketPassesIncludingGlobal,
	          isFetching: false
	        });
	        _PassActions2.default.updatePasses((0, _keyBy2.default)(data, "id"));
	      }).catch(_PassActions2.default.fetchFailed);
	    }
	  }, {
	    key: "onFetchOne",
	    value: function onFetchOne(id) {
	      var _this6 = this;
	
	      this.setState({ isFetching: true });
	      _PassUtil2.default.fetchOne(_UserStore2.default.getState().apiKey, id).then(function (data) {
	        _PassActions2.default.updatePass(id, data);
	        _this6.setState({ isFetching: false });
	      }).catch(_PassActions2.default.fetchFailed);
	    }
	  }, {
	    key: "onFetchPassSubscription",
	    value: function onFetchPassSubscription(id) {
	      _PassUtil2.default.fetchPassSubscription(_UserStore2.default.getState().apiKey, id).then(function (data) {
	        _PassActions2.default.updatePassSubscription(id, data);
	      }).catch(_PassActions2.default.fetchFailed);
	    }
	  }, {
	    key: "onFetchAutocomplete",
	    value: function onFetchAutocomplete(values) {
	      var _this7 = this;
	
	      this.setState({ isFetching: true });
	      _PassUtil2.default.fetchAutocomplete(_UserStore2.default.getState().apiKey, values[0], values[1]).then(function (data) {
	        _PassActions2.default.updateAutocomplete(data);
	        _this7.setState({ isFetching: true });
	      }).catch(_PassActions2.default.fetchFailed);
	    }
	  }, {
	    key: "onFetchPassTransferHistory",
	    value: function onFetchPassTransferHistory(ids) {
	      var _this8 = this;
	
	      this.setState({ isFetching: true });
	      _PassUtil2.default.fetchPassTransferHistory(_UserStore2.default.getState().apiKey, ids.passId, ids.eventBucketId).then(function (data) {
	        _this8.setState({ passTransferHistory: data.history, passTransferHistorySinglePass: data.pass, isFetching: false });
	      }).catch(_PassActions2.default.fetchFailed);
	    }
	  }, {
	    key: "onUpdateAutocomplete",
	    value: function onUpdateAutocomplete(data) {
	      if (!data) {
	        this.state.passesAutocomplete = [];
	      } else {
	        this.state.passesAutocomplete = data.data.passes;
	      }
	      this.setState(this.state);
	    }
	  }, {
	    key: "onEdit",
	    value: function onEdit(data) {
	      var _this9 = this;
	
	      this.setState({ isEditing: true });
	      _PassUtil2.default.edit(_UserStore2.default.getState().apiKey, data.id, data.values).then(function (data) {
	        _PassActions2.default.updatePass(data.id, data);
	
	        // Dispatch order update if order has been fetched previously
	        // (to propagate updated pass if viewing orders page).
	        var order = _OrderStore2.default.getState().orders[data.order];
	        if (order) {
	          _OrderActions2.default.fetchOne(data.order);
	        }
	
	        _this9.setState({ isEditing: false });
	      }).catch(_PassActions2.default.editFailed);
	    }
	  }, {
	    key: "onDeletePasses",
	    value: function onDeletePasses(form) {
	      var _this10 = this;
	
	      this.setState({ isFetching: true });
	
	      var passes = _extends({}, this.state.passes);
	      _PassUtil2.default.deleteBulk(_UserStore2.default.getState().apiKey, _UserStore2.default.getCredentials().api_key, form).then(function (data) {
	        data.passIds.map(function (passId) {
	          _this10.state.deletedPasses[passId] = true;
	        });
	
	        _this10.setState({
	          isFetching: false,
	          passes: passes,
	          deletedPasses: _this10.state.deletedPasses
	        });
	      }).catch(_PassActions2.default.fetchFailed);
	    }
	  }, {
	    key: "onRefundPass",
	    value: function onRefundPass(_ref) {
	      var _this11 = this;
	
	      var orderId = _ref.orderId;
	      var options = _ref.options;
	
	      _OrderUtil2.default.refund(_UserStore2.default.getState().apiKey, orderId, {
	        refunds: options
	      }).then(function (data) {
	        console.log(data);
	        for (var option in options) {
	          if (!option.startsWith("PASS")) continue;
	
	          var optionData = options[option];
	
	          var passId = option.replace("PASS-", "");
	
	          if (optionData.delete) {
	            _this11.state.deletedPasses[passId] = true;
	          }
	
	          _OrderActions2.default.updateOrder(data);
	          _LedgerActions2.default.fetchLedgerTransactionsForOrder.defer(orderId); // force ledger update
	
	          _this11.setState({
	            deletedPasses: _this11.state.deletedPasses
	          });
	        }
	      }).catch(_PassActions2.default.fetchFailed);
	    }
	  }, {
	    key: "onBulkTransferPasses",
	    value: function onBulkTransferPasses(form) {
	      var _this12 = this;
	
	      this.setState({ isFetching: true });
	
	      var passes = _extends({}, this.state.passes);
	      _PassUtil2.default.transferBulk(_UserStore2.default.getState().apiKey, form).then(function (data) {
	        data.transfers.map(function (pass) {
	          delete passes[pass.id];
	          passes[pass.id] = _extends({}, pass);
	        });
	
	        _this12.setState({ isFetching: false, passes: passes });
	      }).catch(_PassActions2.default.fetchFailed);
	    }
	  }, {
	    key: "onTransfer",
	    value: function onTransfer(_ref2) {
	      var id = _ref2.id;
	      var recipient = _ref2.recipient;
	
	      _PassUtil2.default.transfer(_UserStore2.default.getState().apiKey, id, recipient).then(function (data) {
	        _PassActions2.default.updatePass(data.id, data);
	
	        // Dispatch order update if order has been fetched previously
	        // (to propagate updated pass if viewing orders page).
	        var order = _OrderStore2.default.getState().orders[data.order];
	        if (order) {
	          _OrderActions2.default.fetchOne(data.order);
	        }
	      }).catch(_PassActions2.default.editFailed);
	    }
	  }, {
	    key: "onCancelTransfer",
	    value: function onCancelTransfer(id) {
	      _PassUtil2.default.cancelTransfer(_UserStore2.default.getState().apiKey, id).then(function (data) {
	        _PassActions2.default.updatePass(data.id, data);
	
	        // Dispatch order update if order has been fetched previously
	        // (to propagate updated pass if viewing orders page).
	        var order = _OrderStore2.default.getState().orders[data.order];
	        if (order) {
	          _OrderActions2.default.fetchOne(data.order);
	        }
	      }).catch(_PassActions2.default.editFailed);
	    }
	  }, {
	    key: "onBulkCancelPassTransfers",
	    value: function onBulkCancelPassTransfers(passIds) {
	      var _this13 = this;
	
	      this.setState({ isFetching: true });
	
	      var passes = _extends({}, this.state.passes);
	      _PassUtil2.default.cancelTransfersBulk(_UserStore2.default.getState().apiKey, passIds).then(function (data) {
	        data.passes.map(function (pass) {
	          delete passes[pass.id];
	          passes[pass.id] = _extends({}, pass);
	        });
	
	        _this13.setState({ isFetching: false, passes: passes });
	      }).catch(_PassActions2.default.fetchFailed);
	    }
	  }, {
	    key: "onDelete",
	    value: function onDelete(id) {
	      var _this14 = this;
	
	      _PassUtil2.default.delete(_UserStore2.default.getState().apiKey, _UserStore2.default.getCredentials().api_key, id).then(function (data) {
	        delete _this14.state.passes[id];
	        _this14.state.deletedPasses[id] = true;
	        _this14.setState(_this14.state);
	      }).catch(_PassActions2.default.deleteFailed);
	    }
	  }, {
	    key: "onUpdatePass",
	    value: function onUpdatePass(data) {
	      this.state.passes[data.id] = data.pass;
	      this.setState(this.state);
	    }
	  }, {
	    key: "onUpdatePasses",
	    value: function onUpdatePasses(passes) {
	      (0, _extend2.default)(this.state.passes, passes);
	      this.setState({ passes: this.state.passes });
	    }
	  }, {
	    key: "onUpdatePassSubscription",
	    value: function onUpdatePassSubscription(data) {
	      this.state.passSubscriptions[data.id] = data.pass_subscription;
	      this.setState({ passSubscriptions: this.state.passSubscriptions });
	    }
	  }, {
	    key: "onEditPassSubscription",
	    value: function onEditPassSubscription(data) {
	      var _this15 = this;
	
	      this.setState({ isEditing: true });
	
	      _PassUtil2.default.editPassSubscription(_UserStore2.default.getState().apiKey, data.id, data.values).then(function (data) {
	        _PassActions2.default.updatePassSubscription(data.id, data);
	
	        // Dispatch pass updates
	        data.passes.map(function (p) {
	          return p.id;
	        }).map(function (passId) {
	          _PassActions2.default.updatePass(passId, Object.assign({}, _this15.getPassById(passId), {
	            pass_subscription: data
	          }));
	        });
	
	        // Dispatch order updates if order has been fetched previously
	        // (to propagate updated pass renewal statuses if viewing orders page).
	        data.orders.map(function (orderId) {
	          var order = _OrderStore2.default.getState().orders[orderId];
	          if (order) {
	            _OrderActions2.default.fetchOne(orderId);
	          }
	        });
	
	        _this15.setState({ isEditing: false });
	      }).catch(_PassActions2.default.editFailed);
	    }
	  }, {
	    key: "onFetchFailed",
	    value: function onFetchFailed(e) {
	      this.setState({ isFetching: false });
	      console.error("Fetching pass failed:", e);
	      _GlobalNotificationActions2.default.notify.defer("Fetching pass failed: " + e.message);
	      throw e;
	    }
	  }, {
	    key: "onEditFailed",
	    value: function onEditFailed(e) {
	      this.setState({ isEditing: false });
	      alert("Edit failed: " + e.message);
	      // throw e;
	    }
	  }, {
	    key: "onDeleteFailed",
	    value: function onDeleteFailed(e) {
	      alert("Delete failed: " + e.message);
	      throw e;
	    }
	  }]);
	
	  return PassStore;
	}();
	
	exports.default = _alt2.default.createStore(PassStore, "PassStore");
	module.exports = exports["default"];

/***/ }),
/* 2049 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _merge = __webpack_require__(732);
	
	var _merge2 = _interopRequireDefault(_merge);
	
	var _api = __webpack_require__(1160);
	
	var _api2 = _interopRequireDefault(_api);
	
	var _config = __webpack_require__(1173);
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  fetchAllForPassBucket: function fetchAllForPassBucket(apiKey, passBucket) {
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "GET",
	        endpoint: "pass_buckets/" + passBucket + "/passes",
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response.passes);
	      });
	    });
	  },
	  fetchAllForPerson: function fetchAllForPerson(apiKey, person) {
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "GET",
	        endpoint: "people/" + person + "/passes",
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response.passes);
	      });
	    });
	  },
	  fetchAllForEventBucket: function fetchAllForEventBucket(apiKey, eventBucket) {
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "GET",
	        endpoint: "event_buckets/" + eventBucket + "/passes",
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response.passes);
	      });
	    });
	  },
	  fetchAllForEventBucketIncludingGlobal: function fetchAllForEventBucketIncludingGlobal(apiKey, eventBucket) {
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "GET",
	        endpoint: "event_buckets/" + eventBucket + "/passes_including_global",
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response.passes);
	      });
	    });
	  },
	  fetchOne: function fetchOne(apiKey, pass) {
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "GET",
	        endpoint: "passes/" + pass,
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response);
	      });
	    });
	  },
	  fetchPassSubscription: function fetchPassSubscription(apiKey, passSubscription) {
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "GET",
	        endpoint: "pass_subscriptions/" + passSubscription,
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response);
	      });
	    });
	  },
	  fetchAutocomplete: function fetchAutocomplete(apiKey, query, eventBucket) {
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "GET",
	        endpoint: "passes/autocomplete?event_bucket=" + eventBucket + "&query=" + query,
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response);
	      });
	    });
	  },
	  fetchPassTransferHistory: function fetchPassTransferHistory(apiKey, passId, eventBucketId) {
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "GET",
	        endpoint: "passes/" + passId + "/history?event_bucket=" + eventBucketId,
	        api_key: apiKey
	
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response);
	      });
	    });
	  },
	  edit: function edit(apiKey, pass, values) {
	    if (values.supplementary_data && typeof values.supplementary_data !== "string") {
	      values.supplementary_data = JSON.stringify(values.supplementary_data);
	    }
	
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "POST",
	        endpoint: "passes/" + pass,
	        json: values,
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response);
	      });
	    });
	  },
	  transfer: function transfer(apiKey, pass, recipient) {
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "POST",
	        endpoint: "passes/" + pass + "/transfer",
	        json: { destination_email: recipient },
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response);
	      });
	    });
	  },
	  transferBulk: function transferBulk(apiKey, data) {
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "POST",
	        endpoint: "passes/transfer",
	        json: data,
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response);
	      });
	    });
	  },
	  cancelTransfer: function cancelTransfer(apiKey, pass) {
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "POST",
	        endpoint: "passes/" + pass + "/cancel_transfer",
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response);
	      });
	    });
	  },
	  cancelTransfersBulk: function cancelTransfersBulk(apiKey, passIds) {
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "POST",
	        endpoint: "passes/cancel_transfers",
	        json: {
	          pass_ids: passIds
	        },
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response);
	      });
	    });
	  },
	  delete: function _delete(apiKey, accountToken, pass) {
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "DELETE",
	        endpoint: "passes/" + pass,
	        api_key: apiKey,
	        qs: {
	          token: accountToken
	        }
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response);
	      });
	    });
	  },
	  deleteBulk: function deleteBulk(apiKey, accountToken, data) {
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "DELETE",
	        endpoint: "passes/delete",
	        json: data,
	        api_key: apiKey,
	        qs: {
	          token: accountToken
	        }
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response);
	      });
	    });
	  },
	  editPassSubscription: function editPassSubscription(apiKey, passSubscription, values) {
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "POST",
	        endpoint: "pass_subscriptions/" + passSubscription,
	        json: values,
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response);
	      });
	    });
	  }
	};
	module.exports = exports["default"];

/***/ }),
/* 2050 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _alt = __webpack_require__(975);
	
	var _alt2 = _interopRequireDefault(_alt);
	
	var _keyBy = __webpack_require__(990);
	
	var _keyBy2 = _interopRequireDefault(_keyBy);
	
	var _extend = __webpack_require__(1212);
	
	var _extend2 = _interopRequireDefault(_extend);
	
	var _values = __webpack_require__(1214);
	
	var _values2 = _interopRequireDefault(_values);
	
	var _OrderUtil = __webpack_require__(2051);
	
	var _OrderUtil2 = _interopRequireDefault(_OrderUtil);
	
	var _OrderActions = __webpack_require__(1220);
	
	var _OrderActions2 = _interopRequireDefault(_OrderActions);
	
	var _LedgerActions = __webpack_require__(2052);
	
	var _LedgerActions2 = _interopRequireDefault(_LedgerActions);
	
	var _UserStore = __webpack_require__(974);
	
	var _UserStore2 = _interopRequireDefault(_UserStore);
	
	var _GiftCardUtil = __webpack_require__(2053);
	
	var _GiftCardUtil2 = _interopRequireDefault(_GiftCardUtil);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var OrderStore = function () {
	  function OrderStore() {
	    _classCallCheck(this, OrderStore);
	
	    this.bindActions(_OrderActions2.default);
	
	    this.state = {
	      orders: {},
	      lastOrderId: null,
	      isFetchingMore: false,
	      haveFetchedAll: false,
	      resendConfirmationErrorMessage: null,
	      refundErrorMessage: null,
	      refundSuccess: false
	    };
	
	    this.exportPublicMethods({
	      getOrdersForEventBucket: this.getOrdersForEventBucket.bind(this),
	      getOrdersForPerson: this.getOrdersForPerson.bind(this)
	    });
	  }
	
	  _createClass(OrderStore, [{
	    key: "getOrdersForEventBucket",
	    value: function getOrdersForEventBucket(id) {
	      return (0, _values2.default)(this.state.orders).filter(function (o) {
	        return o.event_bucket.id === id;
	      });
	    }
	  }, {
	    key: "getOrdersForPerson",
	    value: function getOrdersForPerson(id, eventBucket) {
	      return (0, _values2.default)(this.state.orders).filter(function (o) {
	        if (eventBucket && o.event_bucket.id !== eventBucket) {
	          return false;
	        }
	        return o.person && o.person.id === id;
	      });
	    }
	  }, {
	    key: "onReset",
	    value: function onReset() {
	      this.setState({
	        orders: {},
	        lastOrderId: null,
	        isFetchingMore: false,
	        haveFetchedAll: false,
	        resendConfirmationErrorMessage: null,
	        refundErrorMessage: null
	      });
	    }
	  }, {
	    key: "onFetchAllForEventBucket",
	    value: function onFetchAllForEventBucket(eventBucket) {
	      _OrderUtil2.default.fetchAll(_UserStore2.default.getState().apiKey, eventBucket).then(function (data) {
	        _OrderActions2.default.updateOrders((0, _keyBy2.default)(data, "id"));
	      }).catch(_OrderActions2.default.fetchFailed);
	    }
	  }, {
	    key: "onFetchAllForPerson",
	    value: function onFetchAllForPerson(personId) {
	      _OrderUtil2.default.fetchAllForPerson(_UserStore2.default.getState().apiKey, personId).then(function (data) {
	        _OrderActions2.default.updateOrders((0, _keyBy2.default)(data, "id"));
	      }).catch(_OrderActions2.default.fetchFailed);
	    }
	  }, {
	    key: "onFetchAll",
	    value: function onFetchAll() {
	      _OrderUtil2.default.fetchAll(_UserStore2.default.getState().apiKey).then(function (data) {
	        _OrderActions2.default.updateOrders((0, _keyBy2.default)(data, "id"));
	      }).catch(_OrderActions2.default.fetchFailed);
	    }
	  }, {
	    key: "onFetchOne",
	    value: function onFetchOne(id) {
	      _OrderUtil2.default.fetchOne(_UserStore2.default.getState().apiKey, id).then(function (data) {
	        _OrderActions2.default.updateOrder(data);
	      }).catch(_OrderActions2.default.fetchFailed);
	    }
	  }, {
	    key: "onFetchMore",
	    value: function onFetchMore(data) {
	      var _this = this;
	
	      var top = data.top;
	      var limit = data.limit;
	      var eventBucket = data.eventBucket;
	      var godOrders = data.godOrders;
	
	
	      this.setState({
	        isFetchingMore: true
	      });
	
	      _OrderUtil2.default.fetchMore(_UserStore2.default.getState().apiKey, eventBucket, top ? null : this.state.lastOrderId, limit, { godOrders: godOrders }).then(function (data) {
	        var orders = data.orders;
	        var lastId = orders.length && orders[orders.length - 1].id;
	        _this.setState({
	          lastOrderId: lastId,
	          isFetchingMore: false,
	          haveFetchedAll: data.reached_end || !top && (orders.length === 0 || lastId === _this.state.lastOrderId)
	        });
	        _OrderActions2.default.updateOrders((0, _keyBy2.default)(orders, "id"));
	      }).catch(_OrderActions2.default.fetchFailed);
	    }
	  }, {
	    key: "onEdit",
	    value: function onEdit(newData) {
	      _OrderUtil2.default.edit(_UserStore2.default.getState().apiKey, newData.id, newData.values).then(function (data) {
	        _OrderActions2.default.updateOrder(data);
	      }).catch(_OrderActions2.default.editFailed);
	    }
	  }, {
	    key: "onUpdateOrder",
	    value: function onUpdateOrder(data) {
	      this.state.orders[data.id] = data;
	      this.setState(this.state);
	    }
	  }, {
	    key: "onUpdateOrders",
	    value: function onUpdateOrders(data) {
	      if (!data) {
	        this.state.orders = {};
	      } else {
	        (0, _extend2.default)(this.state.orders, data);
	      }
	      this.setState(this.state);
	    }
	  }, {
	    key: "onResendConfirmation",
	    value: function onResendConfirmation(options) {
	      var _this2 = this;
	
	      if (typeof options === "string") {
	        options = { id: options };
	      }
	
	      _OrderUtil2.default.resendConfirmation(_UserStore2.default.getState().apiKey, options).then(function (data) {
	        data[options.bulk_person ? "bulkResent" : "confirmationResent"] = options.bulk_person || Date.now();
	        _OrderActions2.default.updateOrder(data);
	      }).catch(function (err) {
	        _this2.state.orders[options.id][options.bulk_person ? "bulkResent" : "confirmationResent"] = Date.now();
	        _this2.state.resendConfirmationErrorMessage = err.message;
	        _this2.setState(_this2.state);
	      });
	    }
	  }, {
	    key: "onResendGiftNotification",
	    value: function onResendGiftNotification(orderId) {
	      var _this3 = this;
	
	      _GiftCardUtil2.default.resendGiftNotification(_UserStore2.default.getState().apiKey, orderId).then(function () {
	        _this3.state.orders[orderId].confirmationResent = Date.now();
	        _this3.setState(_this3.state);
	      }).catch(function (err) {
	        _this3.state.orders[orderId].confirmationResent = Date.now();
	        _this3.state.resendConfirmationErrorMessage = err.message;
	        _this3.setState(_this3.state);
	      });
	    }
	  }, {
	    key: "onResendConfirmationFailed",
	    value: function onResendConfirmationFailed(err) {
	      this.setState({ resendConfirmationErrorMessage: err.message });
	    }
	  }, {
	    key: "onRefund",
	    value: function onRefund(_ref) {
	      var _this4 = this;
	
	      var id = _ref.id;
	      var amount = _ref.amount;
	
	      _OrderUtil2.default.refund(_UserStore2.default.getState().apiKey, id, amount).then(function (data) {
	        _OrderActions2.default.updateOrder(data);
	        _LedgerActions2.default.fetchLedgerTransactionsForOrder.defer(id); // force ledger update
	        _this4.setState({ refundSuccess: true });
	      }).catch(_OrderActions2.default.refundFailed);
	    }
	  }, {
	    key: "onRefundFailed",
	    value: function onRefundFailed(err) {
	      this.setState({ refundErrorMessage: err.message });
	    }
	  }, {
	    key: "onDownloadReceipt",
	    value: function onDownloadReceipt(orderId) {
	      _OrderUtil2.default.downloadReceipt(orderId);
	    }
	  }, {
	    key: "onDownloadDonationReceipt",
	    value: function onDownloadDonationReceipt(orderId) {
	      _OrderUtil2.default.downloadDonationReceipt(orderId);
	    }
	  }, {
	    key: "onClearErrors",
	    value: function onClearErrors() {
	      this.setState({
	        resendConfirmationErrorMessage: null,
	        refundErrorMessage: null,
	        refundSuccess: false
	      });
	    }
	  }, {
	    key: "onFetchFailed",
	    value: function onFetchFailed(e) {
	      alert("Fetching order failed: " + e.message);
	      throw e;
	    }
	  }]);
	
	  return OrderStore;
	}();
	
	exports.default = _alt2.default.createStore(OrderStore, "OrderStore");
	module.exports = exports["default"];

/***/ }),
/* 2051 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _merge = __webpack_require__(732);
	
	var _merge2 = _interopRequireDefault(_merge);
	
	var _api = __webpack_require__(1160);
	
	var _api2 = _interopRequireDefault(_api);
	
	var _config = __webpack_require__(1173);
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  fetchAll: function fetchAll(apiKey, eventBucket) {
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "GET",
	        endpoint: "orders",
	        qs: eventBucket ? {
	          conditions: JSON.stringify({
	            event_bucket: eventBucket
	          })
	        } : undefined,
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response.orders);
	      });
	    });
	  },
	  fetchAllForPerson: function fetchAllForPerson(apiKey, person) {
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "GET",
	        endpoint: "people/" + person + "/orders",
	        qs: { limit: "all" },
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response.orders);
	      });
	    });
	  },
	  fetchMore: function fetchMore(apiKey, eventBucket, startingId, limit, _ref) {
	    var godOrders = _ref.godOrders;
	
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "GET",
	        endpoint: "orders",
	        qs: {
	          conditions: JSON.stringify(Object.assign({}, eventBucket && { event_bucket: eventBucket }, startingId && { _id: { $lt: startingId } })),
	          limit: limit,
	          god_orders: godOrders ? true : undefined
	        },
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response);
	      });
	    });
	  },
	  fetchOne: function fetchOne(apiKey, id) {
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "GET",
	        endpoint: "orders/" + id,
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response);
	      });
	    });
	  },
	  resendConfirmation: function resendConfirmation(apiKey, options) {
	    options = Object.assign({}, options);
	    var _options = options;
	    var id = _options.id;
	
	    delete options.id;
	
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "POST",
	        endpoint: "orders/" + id + "/resend",
	        json: options,
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response);
	      });
	    });
	  },
	  generateRefundOptions: function generateRefundOptions(apiKey, id) {
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "POST",
	        endpoint: "orders/" + id + "/refund_options",
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response);
	      });
	    });
	  },
	  refund: function refund(apiKey, id, amount) {
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "POST",
	        endpoint: "orders/" + id + "/refund",
	        api_key: apiKey,
	        json: (typeof amount === "undefined" ? "undefined" : _typeof(amount)) === "object" ? amount : {
	          amount: amount
	        }
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response);
	      });
	    });
	  },
	  edit: function edit(apiKey, order, values) {
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "POST",
	        endpoint: "orders/" + order,
	        json: values,
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response);
	      });
	    });
	  },
	  downloadReceipt: function downloadReceipt(orderId) {
	    window.open(_config2.default.endpoint + "orders/" + orderId + "/receipt.pdf");
	  },
	  downloadDonationReceipt: function downloadDonationReceipt(orderId) {
	    window.open(_config2.default.endpoint + "orders/" + orderId + "/donation-receipt.pdf");
	  }
	};
	module.exports = exports["default"];

/***/ }),
/* 2052 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _alt = __webpack_require__(975);
	
	var _alt2 = _interopRequireDefault(_alt);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var LedgerActions = function LedgerActions() {
	  _classCallCheck(this, LedgerActions);
	
	  this.generateActions("fetchLedgerTransactionsForOrder", "fetchLedgerAnalyticsTransactions", "fetchLedgerBoxOfficeTransactions", "fetchLedgerVenueTransactions", "fetchLedgerBoxOfficeReport", "fetchLedgerVenueReport", "fetchLedgerTransactionReport", "fetchFailed");
	};
	
	exports.default = _alt2.default.createActions(LedgerActions);
	module.exports = exports["default"];

/***/ }),
/* 2053 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _api = __webpack_require__(1160);
	
	var _api2 = _interopRequireDefault(_api);
	
	var _config = __webpack_require__(1173);
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  fetchAll: function fetchAll(apiKey) {
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "GET",
	        endpoint: "gift_cards",
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response.gift_cards);
	      });
	    });
	  },
	  create: function create(apiKey, body) {
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "POST",
	        endpoint: "gift_cards",
	        json: body,
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response);
	      });
	    });
	  },
	  delete: function _delete(apiKey, id) {
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "DELETE",
	        endpoint: "gift_cards/" + id,
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response);
	      });
	    });
	  },
	  fetchCSV: function fetchCSV(apiKey) {
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "GET",
	        endpoint: "gift_cards/csv",
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response);
	      });
	    });
	  },
	  resendGiftNotification: function resendGiftNotification(apiKey, orderId) {
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "POST",
	        endpoint: "gift_cards/notification",
	        json: {
	          order_id: orderId
	        },
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response);
	      });
	    });
	  },
	  adjustGiftCard: function adjustGiftCard(apiKey, request) {
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "POST",
	        endpoint: "gift_cards/adjust",
	        json: request,
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response);
	      });
	    });
	  }
	};
	module.exports = exports["default"];

/***/ }),
/* 2054 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _materialUi = __webpack_require__(576);
	
	var _juration = __webpack_require__(1772);
	
	var _juration2 = _interopRequireDefault(_juration);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * Display duration input fields in a user-friendly "xx hours, xyz minutes, etc..." format while
	 * persisting in milliseconds. A thin wrapper around material-ui's <TextField/>.
	 */
	var DurationField = function (_React$Component) {
	  _inherits(DurationField, _React$Component);
	
	  function DurationField(props) {
	    _classCallCheck(this, DurationField);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(DurationField).call(this, props));
	
	    _this.state = {
	      editedValue: null
	    };
	
	    _this._handleInputChange = _this._handleInputChange.bind(_this);
	    _this._handleInputBlur = _this._handleInputBlur.bind(_this);
	    return _this;
	  }
	
	  _createClass(DurationField, [{
	    key: "_handleInputChange",
	    value: function _handleInputChange(e) {
	      var value = e.target.value;
	
	
	      this.setState({
	        editedValue: value
	      });
	
	      try {
	        var finalValue = _juration2.default.parse(value) * 1000; // juration outputs in seconds
	        this.props.onChange({
	          target: {
	            value: finalValue
	          }
	        });
	      } catch (e) {
	        // Swallow parse errors
	      }
	    }
	  }, {
	    key: "_handleInputBlur",
	    value: function _handleInputBlur() {
	      this.setState({ editedValue: null });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _props = this.props;
	      var value = _props.value;
	      var onChange = _props.onChange;
	      var onBlur = _props.onBlur;
	      var placeholder = _props.placeholder;
	      var props = _objectWithoutProperties(_props, ["value", "onChange", "onBlur", "placeholder"]);
	      var editedValue = this.state.editedValue;
	
	
	      return _react2.default.createElement(_materialUi.TextField, _extends({
	        value: editedValue !== null ? editedValue : _juration2.default.stringify(value / 1000) || (placeholder ? "" : "0 seconds") // juration takes seconds as input
	        , onChange: this._handleInputChange,
	        onBlur: this._handleInputBlur,
	        placeholder: placeholder
	      }, props));
	    }
	  }]);
	
	  return DurationField;
	}(_react2.default.Component);
	
	exports.default = DurationField;
	module.exports = exports["default"];

/***/ }),
/* 2055 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _materialUi = __webpack_require__(576);
	
	var _connectToStores = __webpack_require__(1226);
	
	var _connectToStores2 = _interopRequireDefault(_connectToStores);
	
	var _VirtualContentStore = __webpack_require__(1768);
	
	var _VirtualContentStore2 = _interopRequireDefault(_VirtualContentStore);
	
	var _VirtualContentActions = __webpack_require__(1767);
	
	var _VirtualContentActions2 = _interopRequireDefault(_VirtualContentActions);
	
	var _virtualContentUploader = __webpack_require__(1771);
	
	var _virtualContentUploader2 = _interopRequireDefault(_virtualContentUploader);
	
	var _virtualContentPreview = __webpack_require__(1781);
	
	var _virtualContentPreview2 = _interopRequireDefault(_virtualContentPreview);
	
	var _orderablePanel = __webpack_require__(2056);
	
	var _orderablePanel2 = _interopRequireDefault(_orderablePanel);
	
	var _workingIndicator = __webpack_require__(1664);
	
	var _workingIndicator2 = _interopRequireDefault(_workingIndicator);
	
	var _linkLike = __webpack_require__(973);
	
	var _linkLike2 = _interopRequireDefault(_linkLike);
	
	var _filmTable = __webpack_require__(1763);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var VirtualContentEditor = function (_React$Component) {
	  _inherits(VirtualContentEditor, _React$Component);
	
	  function VirtualContentEditor(props) {
	    _classCallCheck(this, VirtualContentEditor);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(VirtualContentEditor).call(this, props));
	
	    _this.state = {
	      isAdding: false,
	      showPreviewForVirtualContent: false
	    };
	
	    _this.remove = _this.remove.bind(_this);
	    _this.add = _this.add.bind(_this);
	    _this.shiftPosition = _this.shiftPosition.bind(_this);
	    return _this;
	  }
	
	  _createClass(VirtualContentEditor, [{
	    key: "componentWillMount",
	    value: function componentWillMount() {
	      if (this.props.value && this.props.value.length) {
	        _VirtualContentActions2.default.fetchByIds.defer(this.props.value);
	      }
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(newProps) {
	      var _this2 = this;
	
	      if (!this.props.value && newProps.value || newProps.value && newProps.value.some(function (v) {
	        return _this2.props.value.indexOf(v) === -1;
	      })) {
	        _VirtualContentActions2.default.fetchByIds.defer(newProps.value);
	      }
	    }
	  }, {
	    key: "remove",
	    value: function remove(id) {
	      var value = [].concat(_toConsumableArray(this.props.value)).filter(function (v) {
	        return v !== id;
	      });
	      this.props.onChange(value);
	    }
	  }, {
	    key: "add",
	    value: function add(id) {
	      var value = this.props.value.indexOf(id) === -1 ? [].concat(_toConsumableArray(this.props.value), [id]) : this.props.value;
	      this.props.onChange(value);
	    }
	  }, {
	    key: "shiftPosition",
	    value: function shiftPosition(idx, direction) {
	      var value = [].concat(_toConsumableArray(this.props.value));
	      console.log(value);
	      value.splice(idx + direction, 0, value.splice(idx, 1)[0]);
	      console.log(value);
	      this.props.onChange(value);
	    }
	  }, {
	    key: "getStyles",
	    value: function getStyles() {
	      return {
	        container: {
	          margin: -10,
	          display: "flex"
	        },
	        item: {
	          display: "flex",
	          flexDirection: "column",
	          alignItems: "center",
	          justifyContent: "center",
	          border: "1px solid #ccc",
	          borderRadius: "0.5em",
	          padding: 20,
	          margin: 10,
	          width: 200,
	          maxWidth: "100%",
	          textAlign: "center"
	        }
	      };
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this3 = this;
	
	      var styles = this.getStyles();
	      var entries = this.props.value ? this.props.value.map(function (id) {
	        return _VirtualContentStore2.default.getVirtualContentById(id);
	      }) : [];
	
	      return _react2.default.createElement(
	        "div",
	        {
	          style: Object.assign({}, styles.container, !this.state.isAdding && entries.length === 0 && { margin: -10 }, this.props.style)
	        },
	        this.state.showPreviewForVirtualContent ? _react2.default.createElement(_virtualContentPreview2.default, {
	          virtualContentId: this.state.showPreviewForVirtualContent,
	          onRequestClose: function onRequestClose() {
	            _this3.setState({ showPreviewForVirtualContent: null });
	          }
	        }) : null,
	        entries.map(function (virtualContent, i) {
	          if (!virtualContent) {
	            return _react2.default.createElement(
	              "div",
	              { key: _this3.props.value[i], style: styles.item },
	              _react2.default.createElement(_workingIndicator2.default, null)
	            );
	          }
	          return _react2.default.createElement(
	            _orderablePanel2.default,
	            {
	              key: virtualContent.id,
	              keyval: i,
	              style: styles.item,
	              onDelete: function onDelete() {
	                return _this3.remove(virtualContent.id);
	              },
	              onShiftPosition: _this3.shiftPosition,
	              canShiftUp: i > 0,
	              canShiftDown: i < entries.length - 1,
	              direction: "horizontal"
	            },
	            _react2.default.createElement(
	              "div",
	              {
	                style: { textAlign: "center", marginBottom: 5, maxWidth: 200 }
	              },
	              _react2.default.createElement(
	                "div",
	                { style: { wordBreak: "break-word" } },
	                virtualContent.label || "Unlabeled content",
	                " "
	              ),
	              virtualContent.type === "vod" ? _react2.default.createElement(
	                "div",
	                null,
	                _react2.default.createElement(_filmTable.Status, { virtual_content: virtualContent, detailed: true })
	              ) : null,
	              _react2.default.createElement(
	                "div",
	                null,
	                _react2.default.createElement(
	                  _linkLike2.default,
	                  {
	                    onTouchTap: function onTouchTap() {
	                      return _this3.setState({
	                        showPreviewForVirtualContent: virtualContent.id
	                      });
	                    }
	                  },
	                  "View preview"
	                )
	              )
	            )
	          );
	        }),
	        this.state.isAdding ? _react2.default.createElement(
	          "div",
	          {
	            key: "uploader",
	            style: Object.assign({}, styles.item, { width: 300 })
	          },
	          _react2.default.createElement(_virtualContentUploader2.default, {
	            useBeta: this.props.useBeta,
	            onSuccess: function onSuccess(_ref) {
	              var id = _ref.id;
	
	              _this3.add(id);
	              _this3.setState({ isAdding: false });
	            }
	          })
	        ) : _react2.default.createElement(
	          "div",
	          {
	            key: "uploader",
	            style: _extends({}, styles.item, { border: "none", padding: 0 })
	          },
	          _react2.default.createElement(_materialUi.RaisedButton, {
	            label: "Add virtual content",
	            primary: true,
	            onClick: function onClick() {
	              return _this3.setState({ isAdding: true });
	            }
	          })
	        )
	      );
	    }
	  }], [{
	    key: "getStores",
	    value: function getStores() {
	      return [_VirtualContentStore2.default];
	    }
	  }, {
	    key: "getPropsFromStores",
	    value: function getPropsFromStores() {
	      return _VirtualContentStore2.default.getState();
	    }
	  }]);
	
	  return VirtualContentEditor;
	}(_react2.default.Component);
	
	exports.default = (0, _connectToStores2.default)(VirtualContentEditor);
	module.exports = exports["default"];

/***/ }),
/* 2056 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _materialUi = __webpack_require__(576);
	
	var _delete = __webpack_require__(2057);
	
	var _delete2 = _interopRequireDefault(_delete);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _class = function (_React$Component) {
	  _inherits(_class, _React$Component);
	
	  function _class(props) {
	    _classCallCheck(this, _class);
	
	    return _possibleConstructorReturn(this, Object.getPrototypeOf(_class).call(this, props));
	  }
	
	  _createClass(_class, [{
	    key: "getStyles",
	    value: function getStyles() {
	      return {
	        orderablepanel: {
	          marginRight: 30,
	          marginBottom: 15,
	          padding: 20,
	          border: "1px solid #ccc",
	          display: "flex",
	          flexDirection: "column",
	          justifyContent: "space-between",
	          maxWidth: 370
	        }
	      };
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var styles = this.getStyles();
	      return _react2.default.createElement(
	        "div",
	        { style: Object.assign({}, styles.orderablepanel, this.props.style) },
	        _react2.default.createElement(
	          "div",
	          { style: { flex: 1 } },
	          this.props.children
	        ),
	        _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement(_materialUi.RaisedButton, {
	            label: "Remove",
	            onClick: function onClick() {
	              return _this2.props.onDelete(_this2.props.keyval);
	            },
	            style: { marginTop: 10 }
	          }),
	          _react2.default.createElement(_materialUi.RaisedButton, {
	            label: this.props.direction === "horizontal" ? "◀" : "▲",
	            style: { minWidth: 30, marginLeft: 7 },
	            disabled: !this.props.canShiftUp,
	            onTouchTap: function onTouchTap() {
	              return _this2.props.onShiftPosition(_this2.props.keyval, -1);
	            }
	          }),
	          _react2.default.createElement(_materialUi.RaisedButton, {
	            label: this.props.direction === "horizontal" ? "▶" : "▼",
	            style: { minWidth: 30, marginLeft: 7 },
	            disabled: !this.props.canShiftDown,
	            onTouchTap: function onTouchTap() {
	              return _this2.props.onShiftPosition(_this2.props.keyval, 1);
	            }
	          })
	        )
	      );
	    }
	  }]);
	
	  return _class;
	}(_react2.default.Component);
	
	exports.default = _class;
	module.exports = exports["default"];

/***/ }),
/* 2057 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(608);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(615);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionDelete = function ActionDelete(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z' })
	  );
	};
	ActionDelete = (0, _pure2.default)(ActionDelete);
	ActionDelete.displayName = 'ActionDelete';
	ActionDelete.muiName = 'SvgIcon';
	
	exports.default = ActionDelete;

/***/ }),
/* 2058 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _radium = __webpack_require__(1600);
	
	var _radium2 = _interopRequireDefault(_radium);
	
	var _materialUi = __webpack_require__(576);
	
	var _reactDropzone = __webpack_require__(1780);
	
	var _reactDropzone2 = _interopRequireDefault(_reactDropzone);
	
	var _cropperjs = __webpack_require__(2059);
	
	var _cropperjs2 = _interopRequireDefault(_cropperjs);
	
	__webpack_require__(2060);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Polyfill toBlob() for Safari
	
	
	var ImageDropzone = function (_React$Component) {
	  _inherits(ImageDropzone, _React$Component);
	
	  function ImageDropzone(props) {
	    _classCallCheck(this, ImageDropzone);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(ImageDropzone).call(this, props));
	
	    _this.state = {
	      droppedImage: null,
	      cropper: null,
	      fromImageUrl: false
	    };
	
	    _this._onDrop = _this._onDrop.bind(_this);
	    _this._onCropCancel = _this._onCropCancel.bind(_this);
	    _this._onCropSubmit = _this._onCropSubmit.bind(_this);
	    return _this;
	  }
	
	  // Public method
	
	
	  _createClass(ImageDropzone, [{
	    key: "showCropperForImage",
	    value: function showCropperForImage(image) {
	      this._onDrop([{
	        preview: image
	      }], { fromImageUrl: true });
	    }
	  }, {
	    key: "_onDrop",
	    value: function _onDrop(files) {
	      var opts = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	
	      if (!files || !files.length || !files[0]) {
	        return;
	      }
	
	      if (!(this.props.crop || this.props.allowEdit) || files[0].type === "image/gif") {
	        // Don't allow gif cropping, not supported by cropper.js
	        this.props.onDrop(files);
	      } else {
	        this.setState({
	          droppedImage: files[0]
	        }, function () {
	          var cropper = new _cropperjs2.default(this._image, {
	            viewMode: 1, // Don't allow crop to include empty space
	            aspectRatio: this.props.crop && this.props.crop.width && this.props.crop.width / this.props.crop.height,
	            autoCropArea: !(this.props.crop && this.props.crop.width) && this.props.allowEdit || !this.props.autoCropArea ? 1 : this.props.autoCropArea // default to full image if no required crop
	          });
	          this.setState({
	            cropper: cropper,
	            fromImageUrl: opts.fromImageUrl
	          });
	        });
	      }
	    }
	  }, {
	    key: "_onCropCancel",
	    value: function _onCropCancel() {
	      this.setState({
	        droppedImage: null
	      });
	    }
	  }, {
	    key: "_onCropSubmit",
	    value: function _onCropSubmit() {
	      var _this2 = this;
	
	      var handleBlob = function handleBlob(blob) {
	        _this2.props.onDrop([blob], { fromImageUrl: _this2.state.fromImageUrl });
	        _this2.setState({
	          droppedImage: null,
	          cropper: null
	        });
	      };
	
	      if (this.props.dataUrl) {
	        // This is slow, so we defer the dataUrl rendering til after we hide the modal
	        // to make it *seem* instantaneous...
	        this.setState({ droppedImage: null }, function () {
	          setTimeout(function () {
	            handleBlob(_this2.state.cropper.getCroppedCanvas().toDataURL());
	          }, 0);
	        });
	      } else {
	        this.state.cropper.getCroppedCanvas().toBlob(handleBlob);
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this3 = this;
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          _materialUi.Dialog,
	          {
	            title: "Crop image",
	            openImmediately: true,
	            actions: [_react2.default.createElement(_materialUi.FlatButton, { label: "Cancel", onTouchTap: this._onCropCancel }), _react2.default.createElement(_materialUi.FlatButton, { label: "Upload", onTouchTap: this._onCropSubmit })],
	            modal: true,
	            open: !!this.state.droppedImage,
	            onRequestClose: this._handleCropCancel
	          },
	          _react2.default.createElement(
	            "div",
	            { style: { width: "100%", height: "300px" } },
	            this.state.droppedImage ? _react2.default.createElement("img", {
	              src: this.state.droppedImage.preview,
	              style: {
	                maxHeight: "100%",
	                margin: "0 auto",
	                display: "block"
	              },
	              ref: function ref(c) {
	                return _this3._image = c;
	              }
	            }) : null
	          )
	        ),
	        _react2.default.createElement(
	          _reactDropzone2.default,
	          { style: {}, onDrop: this._onDrop },
	          _react2.default.createElement(
	            "div",
	            { style: this.props.style },
	            this.props.children,
	            this.props.crop && !this.props.hideCropTip ? _react2.default.createElement(
	              "div",
	              { style: { fontSize: "0.9em" } },
	              "Recommended size: ",
	              this.props.crop.width,
	              " x",
	              " ",
	              this.props.crop.height,
	              " px."
	            ) : null
	          )
	        )
	      );
	    }
	  }]);
	
	  return ImageDropzone;
	}(_react2.default.Component);
	
	exports.default = (0, _radium2.default)(ImageDropzone);
	module.exports = exports["default"];

/***/ }),
/* 2059 */
/***/ (function(module, exports, __webpack_require__) {

	/*!
	 * Cropper.js v0.8.0
	 * https://github.com/fengyuanchen/cropperjs
	 *
	 * Copyright (c) 2015-2016 Fengyuan Chen
	 * Released under the MIT license
	 *
	 * Date: 2016-08-18T03:01:29.515Z
	 */
	
	(function webpackUniversalModuleDefinition(root, factory) {
		if(true)
			module.exports = factory();
		else if(typeof define === 'function' && define.amd)
			define([], factory);
		else {
			var a = factory();
			for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
		}
	})(this, function() {
	return /******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	/******/
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	/******/
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	/******/
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	/******/
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	/******/
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	/******/
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	/******/
	/******/
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	/******/
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	/******/
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	/******/
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ([
	/* 0 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
		
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		
		var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
		
		var _defaults = __webpack_require__(1);
		
		var _defaults2 = _interopRequireDefault(_defaults);
		
		var _template = __webpack_require__(2);
		
		var _template2 = _interopRequireDefault(_template);
		
		var _render = __webpack_require__(3);
		
		var _render2 = _interopRequireDefault(_render);
		
		var _preview = __webpack_require__(5);
		
		var _preview2 = _interopRequireDefault(_preview);
		
		var _events = __webpack_require__(6);
		
		var _events2 = _interopRequireDefault(_events);
		
		var _handlers = __webpack_require__(7);
		
		var _handlers2 = _interopRequireDefault(_handlers);
		
		var _change = __webpack_require__(8);
		
		var _change2 = _interopRequireDefault(_change);
		
		var _methods = __webpack_require__(9);
		
		var _methods2 = _interopRequireDefault(_methods);
		
		var _utilities = __webpack_require__(4);
		
		var $ = _interopRequireWildcard(_utilities);
		
		function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
		
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
		
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
		
		// Constants
		var NAMESPACE = 'cropper';
		
		// Classes
		var CLASS_HIDDEN = NAMESPACE + '-hidden';
		
		// Events
		var EVENT_ERROR = 'error';
		var EVENT_LOAD = 'load';
		var EVENT_READY = 'ready';
		var EVENT_CROP = 'crop';
		
		// RegExps
		var REGEXP_DATA_URL = /^data:/;
		var REGEXP_DATA_URL_JPEG = /^data:image\/jpeg.*;base64,/;
		
		var AnotherCropper = void 0;
		
		var Cropper = function () {
		  function Cropper(element, options) {
		    _classCallCheck(this, Cropper);
		
		    var self = this;
		
		    self.element = element;
		    self.options = $.extend({}, _defaults2.default, $.isPlainObject(options) && options);
		    self.loaded = false;
		    self.ready = false;
		    self.complete = false;
		    self.rotated = false;
		    self.cropped = false;
		    self.disabled = false;
		    self.replaced = false;
		    self.limited = false;
		    self.wheeling = false;
		    self.isImg = false;
		    self.originalUrl = '';
		    self.canvasData = null;
		    self.cropBoxData = null;
		    self.previews = null;
		    self.init();
		  }
		
		  _createClass(Cropper, [{
		    key: 'init',
		    value: function init() {
		      var self = this;
		      var element = self.element;
		      var tagName = element.tagName.toLowerCase();
		      var url = void 0;
		
		      if ($.getData(element, NAMESPACE)) {
		        return;
		      }
		
		      $.setData(element, NAMESPACE, self);
		
		      if (tagName === 'img') {
		        self.isImg = true;
		
		        // e.g.: "img/picture.jpg"
		        self.originalUrl = url = element.getAttribute('src');
		
		        // Stop when it's a blank image
		        if (!url) {
		          return;
		        }
		
		        // e.g.: "http://example.com/img/picture.jpg"
		        url = element.src;
		      } else if (tagName === 'canvas' && window.HTMLCanvasElement) {
		        url = element.toDataURL();
		      }
		
		      self.load(url);
		    }
		  }, {
		    key: 'load',
		    value: function load(url) {
		      var self = this;
		      var options = self.options;
		      var element = self.element;
		
		      if (!url) {
		        return;
		      }
		
		      self.url = url;
		      self.imageData = {};
		
		      if (!options.checkOrientation || !window.ArrayBuffer) {
		        self.clone();
		        return;
		      }
		
		      // XMLHttpRequest disallows to open a Data URL in some browsers like IE11 and Safari
		      if (REGEXP_DATA_URL.test(url)) {
		        if (REGEXP_DATA_URL_JPEG) {
		          self.read($.dataURLToArrayBuffer(url));
		        } else {
		          self.clone();
		        }
		        return;
		      }
		
		      var xhr = new XMLHttpRequest();
		
		      xhr.onerror = xhr.onabort = function () {
		        self.clone();
		      };
		
		      xhr.onload = function () {
		        self.read(xhr.response);
		      };
		
		      if (options.checkCrossOrigin && $.isCrossOriginURL(url) && element.crossOrigin) {
		        url = $.addTimestamp(url);
		      }
		
		      xhr.open('get', url);
		      xhr.responseType = 'arraybuffer';
		      xhr.send();
		    }
		  }, {
		    key: 'read',
		    value: function read(arrayBuffer) {
		      var self = this;
		      var options = self.options;
		      var orientation = $.getOrientation(arrayBuffer);
		      var imageData = self.imageData;
		      var rotate = 0;
		      var scaleX = 1;
		      var scaleY = 1;
		
		      if (orientation > 1) {
		        self.url = $.arrayBufferToDataURL(arrayBuffer);
		
		        switch (orientation) {
		
		          // flip horizontal
		          case 2:
		            scaleX = -1;
		            break;
		
		          // rotate left 180°
		          case 3:
		            rotate = -180;
		            break;
		
		          // flip vertical
		          case 4:
		            scaleY = -1;
		            break;
		
		          // flip vertical + rotate right 90°
		          case 5:
		            rotate = 90;
		            scaleY = -1;
		            break;
		
		          // rotate right 90°
		          case 6:
		            rotate = 90;
		            break;
		
		          // flip horizontal + rotate right 90°
		          case 7:
		            rotate = 90;
		            scaleX = -1;
		            break;
		
		          // rotate left 90°
		          case 8:
		            rotate = -90;
		            break;
		        }
		      }
		
		      if (options.rotatable) {
		        imageData.rotate = rotate;
		      }
		
		      if (options.scalable) {
		        imageData.scaleX = scaleX;
		        imageData.scaleY = scaleY;
		      }
		
		      self.clone();
		    }
		  }, {
		    key: 'clone',
		    value: function clone() {
		      var self = this;
		      var element = self.element;
		      var url = self.url;
		      var crossOrigin = void 0;
		      var crossOriginUrl = void 0;
		      var start = void 0;
		      var stop = void 0;
		
		      if (self.options.checkCrossOrigin && $.isCrossOriginURL(url)) {
		        crossOrigin = element.crossOrigin;
		
		        if (crossOrigin) {
		          crossOriginUrl = url;
		        } else {
		          crossOrigin = 'anonymous';
		
		          // Bust cache when there is not a "crossOrigin" property
		          crossOriginUrl = $.addTimestamp(url);
		        }
		      }
		
		      self.crossOrigin = crossOrigin;
		      self.crossOriginUrl = crossOriginUrl;
		
		      var image = $.createElement('img');
		
		      if (crossOrigin) {
		        image.crossOrigin = crossOrigin;
		      }
		
		      image.src = crossOriginUrl || url;
		      self.image = image;
		      self.onStart = start = $.proxy(self.start, self);
		      self.onStop = stop = $.proxy(self.stop, self);
		
		      if (self.isImg) {
		        if (element.complete) {
		          self.start();
		        } else {
		          $.addListener(element, EVENT_LOAD, start);
		        }
		      } else {
		        $.addListener(image, EVENT_LOAD, start);
		        $.addListener(image, EVENT_ERROR, stop);
		        $.addClass(image, 'cropper-hide');
		        element.parentNode.insertBefore(image, element.nextSibling);
		      }
		    }
		  }, {
		    key: 'start',
		    value: function start(event) {
		      var self = this;
		      var image = self.isImg ? self.element : self.image;
		
		      if (event) {
		        $.removeListener(image, EVENT_LOAD, self.onStart);
		        $.removeListener(image, EVENT_ERROR, self.onStop);
		      }
		
		      $.getImageSize(image, function (naturalWidth, naturalHeight) {
		        $.extend(self.imageData, {
		          naturalWidth: naturalWidth,
		          naturalHeight: naturalHeight,
		          aspectRatio: naturalWidth / naturalHeight
		        });
		
		        self.loaded = true;
		        self.build();
		      });
		    }
		  }, {
		    key: 'stop',
		    value: function stop() {
		      var self = this;
		      var image = self.image;
		
		      $.removeListener(image, EVENT_LOAD, self.onStart);
		      $.removeListener(image, EVENT_ERROR, self.onStop);
		
		      $.removeChild(image);
		      self.image = null;
		    }
		  }, {
		    key: 'build',
		    value: function build() {
		      var self = this;
		      var options = self.options;
		      var element = self.element;
		      var image = self.image;
		      var container = void 0;
		      var cropper = void 0;
		      var canvas = void 0;
		      var dragBox = void 0;
		      var cropBox = void 0;
		      var face = void 0;
		
		      if (!self.loaded) {
		        return;
		      }
		
		      // Unbuild first when replace
		      if (self.ready) {
		        self.unbuild();
		      }
		
		      var template = $.createElement('div');
		      template.innerHTML = _template2.default;
		
		      // Create cropper elements
		      self.container = container = element.parentNode;
		      self.cropper = cropper = $.getByClass(template, 'cropper-container')[0];
		      self.canvas = canvas = $.getByClass(cropper, 'cropper-canvas')[0];
		      self.dragBox = dragBox = $.getByClass(cropper, 'cropper-drag-box')[0];
		      self.cropBox = cropBox = $.getByClass(cropper, 'cropper-crop-box')[0];
		      self.viewBox = $.getByClass(cropper, 'cropper-view-box')[0];
		      self.face = face = $.getByClass(cropBox, 'cropper-face')[0];
		
		      $.appendChild(canvas, image);
		
		      // Hide the original image
		      $.addClass(element, CLASS_HIDDEN);
		
		      // Inserts the cropper after to the current image
		      container.insertBefore(cropper, element.nextSibling);
		
		      // Show the image if is hidden
		      if (!self.isImg) {
		        $.removeClass(image, 'cropper-hide');
		      }
		
		      self.initPreview();
		      self.bind();
		
		      options.aspectRatio = Math.max(0, options.aspectRatio) || NaN;
		      options.viewMode = Math.max(0, Math.min(3, Math.round(options.viewMode))) || 0;
		
		      if (options.autoCrop) {
		        self.cropped = true;
		
		        if (options.modal) {
		          $.addClass(dragBox, 'cropper-modal');
		        }
		      } else {
		        $.addClass(cropBox, CLASS_HIDDEN);
		      }
		
		      if (!options.guides) {
		        $.addClass($.getByClass(cropBox, 'cropper-dashed'), CLASS_HIDDEN);
		      }
		
		      if (!options.center) {
		        $.addClass($.getByClass(cropBox, 'cropper-center'), CLASS_HIDDEN);
		      }
		
		      if (options.background) {
		        $.addClass(cropper, 'cropper-bg');
		      }
		
		      if (!options.highlight) {
		        $.addClass(face, 'cropper-invisible');
		      }
		
		      if (options.cropBoxMovable) {
		        $.addClass(face, 'cropper-move');
		        $.setData(face, 'action', 'all');
		      }
		
		      if (!options.cropBoxResizable) {
		        $.addClass($.getByClass(cropBox, 'cropper-line'), CLASS_HIDDEN);
		        $.addClass($.getByClass(cropBox, 'cropper-point'), CLASS_HIDDEN);
		      }
		
		      self.setDragMode(options.dragMode);
		      self.render();
		      self.ready = true;
		      self.setData(options.data);
		
		      // Call the "ready" option asynchronously to keep "image.cropper" is defined
		      setTimeout(function () {
		        if ($.isFunction(options.ready)) {
		          $.addListener(element, EVENT_READY, options.ready, true);
		        }
		
		        $.dispatchEvent(element, EVENT_READY);
		        $.dispatchEvent(element, EVENT_CROP, self.getData());
		
		        self.complete = true;
		      }, 0);
		    }
		  }, {
		    key: 'unbuild',
		    value: function unbuild() {
		      var self = this;
		
		      if (!self.ready) {
		        return;
		      }
		
		      self.ready = false;
		      self.complete = false;
		      self.initialImageData = null;
		
		      // Clear `initialCanvasData` is necessary when replace
		      self.initialCanvasData = null;
		      self.initialCropBoxData = null;
		      self.containerData = null;
		      self.canvasData = null;
		
		      // Clear `cropBoxData` is necessary when replace
		      self.cropBoxData = null;
		      self.unbind();
		
		      self.resetPreview();
		      self.previews = null;
		
		      self.viewBox = null;
		      self.cropBox = null;
		      self.dragBox = null;
		      self.canvas = null;
		      self.container = null;
		
		      $.removeChild(self.cropper);
		      self.cropper = null;
		    }
		  }], [{
		    key: 'noConflict',
		    value: function noConflict() {
		      window.Cropper = AnotherCropper;
		      return Cropper;
		    }
		  }, {
		    key: 'setDefaults',
		    value: function setDefaults(options) {
		      $.extend(_defaults2.default, $.isPlainObject(options) && options);
		    }
		  }]);
		
		  return Cropper;
		}();
		
		$.extend(Cropper.prototype, _render2.default);
		$.extend(Cropper.prototype, _preview2.default);
		$.extend(Cropper.prototype, _events2.default);
		$.extend(Cropper.prototype, _handlers2.default);
		$.extend(Cropper.prototype, _change2.default);
		$.extend(Cropper.prototype, _methods2.default);
		
		if (typeof window !== 'undefined') {
		  AnotherCropper = window.Cropper;
		  window.Cropper = Cropper;
		}
		
		exports.default = Cropper;
	
	/***/ },
	/* 1 */
	/***/ function(module, exports) {
	
		'use strict';
		
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.default = {
		  // Define the view mode of the cropper
		  viewMode: 0, // 0, 1, 2, 3
		
		  // Define the dragging mode of the cropper
		  dragMode: 'crop', // 'crop', 'move' or 'none'
		
		  // Define the aspect ratio of the crop box
		  aspectRatio: NaN,
		
		  // An object with the previous cropping result data
		  data: null,
		
		  // A selector for adding extra containers to preview
		  preview: '',
		
		  // Re-render the cropper when resize the window
		  responsive: true,
		
		  // Restore the cropped area after resize the window
		  restore: true,
		
		  // Check if the current image is a cross-origin image
		  checkCrossOrigin: true,
		
		  // Check the current image's Exif Orientation information
		  checkOrientation: true,
		
		  // Show the black modal
		  modal: true,
		
		  // Show the dashed lines for guiding
		  guides: true,
		
		  // Show the center indicator for guiding
		  center: true,
		
		  // Show the white modal to highlight the crop box
		  highlight: true,
		
		  // Show the grid background
		  background: true,
		
		  // Enable to crop the image automatically when initialize
		  autoCrop: true,
		
		  // Define the percentage of automatic cropping area when initializes
		  autoCropArea: 0.8,
		
		  // Enable to move the image
		  movable: true,
		
		  // Enable to rotate the image
		  rotatable: true,
		
		  // Enable to scale the image
		  scalable: true,
		
		  // Enable to zoom the image
		  zoomable: true,
		
		  // Enable to zoom the image by dragging touch
		  zoomOnTouch: true,
		
		  // Enable to zoom the image by wheeling mouse
		  zoomOnWheel: true,
		
		  // Define zoom ratio when zoom the image by wheeling mouse
		  wheelZoomRatio: 0.1,
		
		  // Enable to move the crop box
		  cropBoxMovable: true,
		
		  // Enable to resize the crop box
		  cropBoxResizable: true,
		
		  // Toggle drag mode between "crop" and "move" when click twice on the cropper
		  toggleDragModeOnDblclick: true,
		
		  // Size limitation
		  minCanvasWidth: 0,
		  minCanvasHeight: 0,
		  minCropBoxWidth: 0,
		  minCropBoxHeight: 0,
		  minContainerWidth: 200,
		  minContainerHeight: 100,
		
		  // Shortcuts of events
		  ready: null,
		  cropstart: null,
		  cropmove: null,
		  cropend: null,
		  crop: null,
		  zoom: null
		};
	
	/***/ },
	/* 2 */
	/***/ function(module, exports) {
	
		'use strict';
		
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.default = '<div class="cropper-container">' + '<div class="cropper-wrap-box">' + '<div class="cropper-canvas"></div>' + '</div>' + '<div class="cropper-drag-box"></div>' + '<div class="cropper-crop-box">' + '<span class="cropper-view-box"></span>' + '<span class="cropper-dashed dashed-h"></span>' + '<span class="cropper-dashed dashed-v"></span>' + '<span class="cropper-center"></span>' + '<span class="cropper-face"></span>' + '<span class="cropper-line line-e" data-action="e"></span>' + '<span class="cropper-line line-n" data-action="n"></span>' + '<span class="cropper-line line-w" data-action="w"></span>' + '<span class="cropper-line line-s" data-action="s"></span>' + '<span class="cropper-point point-e" data-action="e"></span>' + '<span class="cropper-point point-n" data-action="n"></span>' + '<span class="cropper-point point-w" data-action="w"></span>' + '<span class="cropper-point point-s" data-action="s"></span>' + '<span class="cropper-point point-ne" data-action="ne"></span>' + '<span class="cropper-point point-nw" data-action="nw"></span>' + '<span class="cropper-point point-sw" data-action="sw"></span>' + '<span class="cropper-point point-se" data-action="se"></span>' + '</div>' + '</div>';
	
	/***/ },
	/* 3 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
		
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		
		var _utilities = __webpack_require__(4);
		
		var $ = _interopRequireWildcard(_utilities);
		
		function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
		
		exports.default = {
		  render: function render() {
		    var self = this;
		
		    self.initContainer();
		    self.initCanvas();
		    self.initCropBox();
		
		    self.renderCanvas();
		
		    if (self.cropped) {
		      self.renderCropBox();
		    }
		  },
		  initContainer: function initContainer() {
		    var self = this;
		    var options = self.options;
		    var element = self.element;
		    var container = self.container;
		    var cropper = self.cropper;
		    var containerData = void 0;
		
		    $.addClass(cropper, 'cropper-hidden');
		    $.removeClass(element, 'cropper-hidden');
		
		    self.containerData = containerData = {
		      width: Math.max(container.offsetWidth, Number(options.minContainerWidth) || 200),
		      height: Math.max(container.offsetHeight, Number(options.minContainerHeight) || 100)
		    };
		
		    $.setStyle(cropper, {
		      width: containerData.width,
		      height: containerData.height
		    });
		
		    $.addClass(element, 'cropper-hidden');
		    $.removeClass(cropper, 'cropper-hidden');
		  },
		
		
		  // Canvas (image wrapper)
		  initCanvas: function initCanvas() {
		    var self = this;
		    var viewMode = self.options.viewMode;
		    var containerData = self.containerData;
		    var imageData = self.imageData;
		    var rotated = Math.abs(imageData.rotate) === 90;
		    var naturalWidth = rotated ? imageData.naturalHeight : imageData.naturalWidth;
		    var naturalHeight = rotated ? imageData.naturalWidth : imageData.naturalHeight;
		    var aspectRatio = naturalWidth / naturalHeight;
		    var canvasWidth = containerData.width;
		    var canvasHeight = containerData.height;
		
		    if (containerData.height * aspectRatio > containerData.width) {
		      if (viewMode === 3) {
		        canvasWidth = containerData.height * aspectRatio;
		      } else {
		        canvasHeight = containerData.width / aspectRatio;
		      }
		    } else if (viewMode === 3) {
		      canvasHeight = containerData.width / aspectRatio;
		    } else {
		      canvasWidth = containerData.height * aspectRatio;
		    }
		
		    var canvasData = {
		      naturalWidth: naturalWidth,
		      naturalHeight: naturalHeight,
		      aspectRatio: aspectRatio,
		      width: canvasWidth,
		      height: canvasHeight
		    };
		
		    canvasData.oldLeft = canvasData.left = (containerData.width - canvasWidth) / 2;
		    canvasData.oldTop = canvasData.top = (containerData.height - canvasHeight) / 2;
		
		    self.canvasData = canvasData;
		    self.limited = viewMode === 1 || viewMode === 2;
		    self.limitCanvas(true, true);
		    self.initialImageData = $.extend({}, imageData);
		    self.initialCanvasData = $.extend({}, canvasData);
		  },
		  limitCanvas: function limitCanvas(sizeLimited, positionLimited) {
		    var self = this;
		    var options = self.options;
		    var viewMode = options.viewMode;
		    var containerData = self.containerData;
		    var canvasData = self.canvasData;
		    var aspectRatio = canvasData.aspectRatio;
		    var cropBoxData = self.cropBoxData;
		    var cropped = self.cropped && cropBoxData;
		    var minCanvasWidth = void 0;
		    var minCanvasHeight = void 0;
		    var newCanvasLeft = void 0;
		    var newCanvasTop = void 0;
		
		    if (sizeLimited) {
		      minCanvasWidth = Number(options.minCanvasWidth) || 0;
		      minCanvasHeight = Number(options.minCanvasHeight) || 0;
		
		      if (viewMode > 1) {
		        minCanvasWidth = Math.max(minCanvasWidth, containerData.width);
		        minCanvasHeight = Math.max(minCanvasHeight, containerData.height);
		
		        if (viewMode === 3) {
		          if (minCanvasHeight * aspectRatio > minCanvasWidth) {
		            minCanvasWidth = minCanvasHeight * aspectRatio;
		          } else {
		            minCanvasHeight = minCanvasWidth / aspectRatio;
		          }
		        }
		      } else if (viewMode > 0) {
		        if (minCanvasWidth) {
		          minCanvasWidth = Math.max(minCanvasWidth, cropped ? cropBoxData.width : 0);
		        } else if (minCanvasHeight) {
		          minCanvasHeight = Math.max(minCanvasHeight, cropped ? cropBoxData.height : 0);
		        } else if (cropped) {
		          minCanvasWidth = cropBoxData.width;
		          minCanvasHeight = cropBoxData.height;
		
		          if (minCanvasHeight * aspectRatio > minCanvasWidth) {
		            minCanvasWidth = minCanvasHeight * aspectRatio;
		          } else {
		            minCanvasHeight = minCanvasWidth / aspectRatio;
		          }
		        }
		      }
		
		      if (minCanvasWidth && minCanvasHeight) {
		        if (minCanvasHeight * aspectRatio > minCanvasWidth) {
		          minCanvasHeight = minCanvasWidth / aspectRatio;
		        } else {
		          minCanvasWidth = minCanvasHeight * aspectRatio;
		        }
		      } else if (minCanvasWidth) {
		        minCanvasHeight = minCanvasWidth / aspectRatio;
		      } else if (minCanvasHeight) {
		        minCanvasWidth = minCanvasHeight * aspectRatio;
		      }
		
		      canvasData.minWidth = minCanvasWidth;
		      canvasData.minHeight = minCanvasHeight;
		      canvasData.maxWidth = Infinity;
		      canvasData.maxHeight = Infinity;
		    }
		
		    if (positionLimited) {
		      if (viewMode) {
		        newCanvasLeft = containerData.width - canvasData.width;
		        newCanvasTop = containerData.height - canvasData.height;
		
		        canvasData.minLeft = Math.min(0, newCanvasLeft);
		        canvasData.minTop = Math.min(0, newCanvasTop);
		        canvasData.maxLeft = Math.max(0, newCanvasLeft);
		        canvasData.maxTop = Math.max(0, newCanvasTop);
		
		        if (cropped && self.limited) {
		          canvasData.minLeft = Math.min(cropBoxData.left, cropBoxData.left + (cropBoxData.width - canvasData.width));
		          canvasData.minTop = Math.min(cropBoxData.top, cropBoxData.top + (cropBoxData.height - canvasData.height));
		          canvasData.maxLeft = cropBoxData.left;
		          canvasData.maxTop = cropBoxData.top;
		
		          if (viewMode === 2) {
		            if (canvasData.width >= containerData.width) {
		              canvasData.minLeft = Math.min(0, newCanvasLeft);
		              canvasData.maxLeft = Math.max(0, newCanvasLeft);
		            }
		
		            if (canvasData.height >= containerData.height) {
		              canvasData.minTop = Math.min(0, newCanvasTop);
		              canvasData.maxTop = Math.max(0, newCanvasTop);
		            }
		          }
		        }
		      } else {
		        canvasData.minLeft = -canvasData.width;
		        canvasData.minTop = -canvasData.height;
		        canvasData.maxLeft = containerData.width;
		        canvasData.maxTop = containerData.height;
		      }
		    }
		  },
		  renderCanvas: function renderCanvas(changed) {
		    var self = this;
		    var canvasData = self.canvasData;
		    var imageData = self.imageData;
		    var rotate = imageData.rotate;
		    var aspectRatio = void 0;
		    var rotatedData = void 0;
		
		    if (self.rotated) {
		      self.rotated = false;
		
		      // Computes rotated sizes with image sizes
		      rotatedData = $.getRotatedSizes({
		        width: imageData.width,
		        height: imageData.height,
		        degree: rotate
		      });
		
		      aspectRatio = rotatedData.width / rotatedData.height;
		
		      if (aspectRatio !== canvasData.aspectRatio) {
		        canvasData.left -= (rotatedData.width - canvasData.width) / 2;
		        canvasData.top -= (rotatedData.height - canvasData.height) / 2;
		        canvasData.width = rotatedData.width;
		        canvasData.height = rotatedData.height;
		        canvasData.aspectRatio = aspectRatio;
		        canvasData.naturalWidth = imageData.naturalWidth;
		        canvasData.naturalHeight = imageData.naturalHeight;
		
		        // Computes rotated sizes with natural image sizes
		        if (rotate % 180) {
		          rotatedData = $.getRotatedSizes({
		            width: imageData.naturalWidth,
		            height: imageData.naturalHeight,
		            degree: rotate
		          });
		
		          canvasData.naturalWidth = rotatedData.width;
		          canvasData.naturalHeight = rotatedData.height;
		        }
		
		        self.limitCanvas(true, false);
		      }
		    }
		
		    if (canvasData.width > canvasData.maxWidth || canvasData.width < canvasData.minWidth) {
		      canvasData.left = canvasData.oldLeft;
		    }
		
		    if (canvasData.height > canvasData.maxHeight || canvasData.height < canvasData.minHeight) {
		      canvasData.top = canvasData.oldTop;
		    }
		
		    canvasData.width = Math.min(Math.max(canvasData.width, canvasData.minWidth), canvasData.maxWidth);
		    canvasData.height = Math.min(Math.max(canvasData.height, canvasData.minHeight), canvasData.maxHeight);
		
		    self.limitCanvas(false, true);
		
		    canvasData.oldLeft = canvasData.left = Math.min(Math.max(canvasData.left, canvasData.minLeft), canvasData.maxLeft);
		    canvasData.oldTop = canvasData.top = Math.min(Math.max(canvasData.top, canvasData.minTop), canvasData.maxTop);
		
		    $.setStyle(self.canvas, {
		      width: canvasData.width,
		      height: canvasData.height,
		      left: canvasData.left,
		      top: canvasData.top
		    });
		
		    self.renderImage();
		
		    if (self.cropped && self.limited) {
		      self.limitCropBox(true, true);
		    }
		
		    if (changed) {
		      self.output();
		    }
		  },
		  renderImage: function renderImage(changed) {
		    var self = this;
		    var canvasData = self.canvasData;
		    var imageData = self.imageData;
		    var newImageData = void 0;
		    var reversedData = void 0;
		    var reversedWidth = void 0;
		    var reversedHeight = void 0;
		
		    if (imageData.rotate) {
		      reversedData = $.getRotatedSizes({
		        width: canvasData.width,
		        height: canvasData.height,
		        degree: imageData.rotate,
		        aspectRatio: imageData.aspectRatio
		      }, true);
		
		      reversedWidth = reversedData.width;
		      reversedHeight = reversedData.height;
		
		      newImageData = {
		        width: reversedWidth,
		        height: reversedHeight,
		        left: (canvasData.width - reversedWidth) / 2,
		        top: (canvasData.height - reversedHeight) / 2
		      };
		    }
		
		    $.extend(imageData, newImageData || {
		      width: canvasData.width,
		      height: canvasData.height,
		      left: 0,
		      top: 0
		    });
		
		    var transform = $.getTransform(imageData);
		
		    $.setStyle(self.image, {
		      width: imageData.width,
		      height: imageData.height,
		      marginLeft: imageData.left,
		      marginTop: imageData.top,
		      WebkitTransform: transform,
		      msTransform: transform,
		      transform: transform
		    });
		
		    if (changed) {
		      self.output();
		    }
		  },
		  initCropBox: function initCropBox() {
		    var self = this;
		    var options = self.options;
		    var aspectRatio = options.aspectRatio;
		    var autoCropArea = Number(options.autoCropArea) || 0.8;
		    var canvasData = self.canvasData;
		    var cropBoxData = {
		      width: canvasData.width,
		      height: canvasData.height
		    };
		
		    if (aspectRatio) {
		      if (canvasData.height * aspectRatio > canvasData.width) {
		        cropBoxData.height = cropBoxData.width / aspectRatio;
		      } else {
		        cropBoxData.width = cropBoxData.height * aspectRatio;
		      }
		    }
		
		    self.cropBoxData = cropBoxData;
		    self.limitCropBox(true, true);
		
		    // Initialize auto crop area
		    cropBoxData.width = Math.min(Math.max(cropBoxData.width, cropBoxData.minWidth), cropBoxData.maxWidth);
		    cropBoxData.height = Math.min(Math.max(cropBoxData.height, cropBoxData.minHeight), cropBoxData.maxHeight);
		
		    // The width/height of auto crop area must large than "minWidth/Height"
		    cropBoxData.width = Math.max(cropBoxData.minWidth, cropBoxData.width * autoCropArea);
		    cropBoxData.height = Math.max(cropBoxData.minHeight, cropBoxData.height * autoCropArea);
		    cropBoxData.oldLeft = cropBoxData.left = canvasData.left + (canvasData.width - cropBoxData.width) / 2;
		    cropBoxData.oldTop = cropBoxData.top = canvasData.top + (canvasData.height - cropBoxData.height) / 2;
		
		    self.initialCropBoxData = $.extend({}, cropBoxData);
		  },
		  limitCropBox: function limitCropBox(sizeLimited, positionLimited) {
		    var self = this;
		    var options = self.options;
		    var aspectRatio = options.aspectRatio;
		    var containerData = self.containerData;
		    var canvasData = self.canvasData;
		    var cropBoxData = self.cropBoxData;
		    var limited = self.limited;
		    var minCropBoxWidth = void 0;
		    var minCropBoxHeight = void 0;
		    var maxCropBoxWidth = void 0;
		    var maxCropBoxHeight = void 0;
		
		    if (sizeLimited) {
		      minCropBoxWidth = Number(options.minCropBoxWidth) || 0;
		      minCropBoxHeight = Number(options.minCropBoxHeight) || 0;
		
		      // The min/maxCropBoxWidth/Height must be less than containerWidth/Height
		      minCropBoxWidth = Math.min(minCropBoxWidth, containerData.width);
		      minCropBoxHeight = Math.min(minCropBoxHeight, containerData.height);
		      maxCropBoxWidth = Math.min(containerData.width, limited ? canvasData.width : containerData.width);
		      maxCropBoxHeight = Math.min(containerData.height, limited ? canvasData.height : containerData.height);
		
		      if (aspectRatio) {
		        if (minCropBoxWidth && minCropBoxHeight) {
		          if (minCropBoxHeight * aspectRatio > minCropBoxWidth) {
		            minCropBoxHeight = minCropBoxWidth / aspectRatio;
		          } else {
		            minCropBoxWidth = minCropBoxHeight * aspectRatio;
		          }
		        } else if (minCropBoxWidth) {
		          minCropBoxHeight = minCropBoxWidth / aspectRatio;
		        } else if (minCropBoxHeight) {
		          minCropBoxWidth = minCropBoxHeight * aspectRatio;
		        }
		
		        if (maxCropBoxHeight * aspectRatio > maxCropBoxWidth) {
		          maxCropBoxHeight = maxCropBoxWidth / aspectRatio;
		        } else {
		          maxCropBoxWidth = maxCropBoxHeight * aspectRatio;
		        }
		      }
		
		      // The minWidth/Height must be less than maxWidth/Height
		      cropBoxData.minWidth = Math.min(minCropBoxWidth, maxCropBoxWidth);
		      cropBoxData.minHeight = Math.min(minCropBoxHeight, maxCropBoxHeight);
		      cropBoxData.maxWidth = maxCropBoxWidth;
		      cropBoxData.maxHeight = maxCropBoxHeight;
		    }
		
		    if (positionLimited) {
		      if (limited) {
		        cropBoxData.minLeft = Math.max(0, canvasData.left);
		        cropBoxData.minTop = Math.max(0, canvasData.top);
		        cropBoxData.maxLeft = Math.min(containerData.width, canvasData.left + canvasData.width) - cropBoxData.width;
		        cropBoxData.maxTop = Math.min(containerData.height, canvasData.top + canvasData.height) - cropBoxData.height;
		      } else {
		        cropBoxData.minLeft = 0;
		        cropBoxData.minTop = 0;
		        cropBoxData.maxLeft = containerData.width - cropBoxData.width;
		        cropBoxData.maxTop = containerData.height - cropBoxData.height;
		      }
		    }
		  },
		  renderCropBox: function renderCropBox() {
		    var self = this;
		    var options = self.options;
		    var containerData = self.containerData;
		    var cropBoxData = self.cropBoxData;
		
		    if (cropBoxData.width > cropBoxData.maxWidth || cropBoxData.width < cropBoxData.minWidth) {
		      cropBoxData.left = cropBoxData.oldLeft;
		    }
		
		    if (cropBoxData.height > cropBoxData.maxHeight || cropBoxData.height < cropBoxData.minHeight) {
		      cropBoxData.top = cropBoxData.oldTop;
		    }
		
		    cropBoxData.width = Math.min(Math.max(cropBoxData.width, cropBoxData.minWidth), cropBoxData.maxWidth);
		    cropBoxData.height = Math.min(Math.max(cropBoxData.height, cropBoxData.minHeight), cropBoxData.maxHeight);
		
		    self.limitCropBox(false, true);
		
		    cropBoxData.oldLeft = cropBoxData.left = Math.min(Math.max(cropBoxData.left, cropBoxData.minLeft), cropBoxData.maxLeft);
		    cropBoxData.oldTop = cropBoxData.top = Math.min(Math.max(cropBoxData.top, cropBoxData.minTop), cropBoxData.maxTop);
		
		    if (options.movable && options.cropBoxMovable) {
		      // Turn to move the canvas when the crop box is equal to the container
		      $.setData(self.face, 'action', cropBoxData.width === containerData.width && cropBoxData.height === containerData.height ? 'move' : 'all');
		    }
		
		    $.setStyle(self.cropBox, {
		      width: cropBoxData.width,
		      height: cropBoxData.height,
		      left: cropBoxData.left,
		      top: cropBoxData.top
		    });
		
		    if (self.cropped && self.limited) {
		      self.limitCanvas(true, true);
		    }
		
		    if (!self.disabled) {
		      self.output();
		    }
		  },
		  output: function output() {
		    var self = this;
		
		    self.preview();
		
		    if (self.complete) {
		      $.dispatchEvent(self.element, 'crop', self.getData());
		    }
		  }
		};
	
	/***/ },
	/* 4 */
	/***/ function(module, exports) {
	
		'use strict';
		
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		
		var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
		
		exports.typeOf = typeOf;
		exports.isNumber = isNumber;
		exports.isUndefined = isUndefined;
		exports.isObject = isObject;
		exports.isPlainObject = isPlainObject;
		exports.isFunction = isFunction;
		exports.isArray = isArray;
		exports.toArray = toArray;
		exports.trim = trim;
		exports.each = each;
		exports.extend = extend;
		exports.proxy = proxy;
		exports.setStyle = setStyle;
		exports.hasClass = hasClass;
		exports.addClass = addClass;
		exports.removeClass = removeClass;
		exports.toggleClass = toggleClass;
		exports.hyphenate = hyphenate;
		exports.getData = getData;
		exports.setData = setData;
		exports.removeData = removeData;
		exports.removeListener = removeListener;
		exports.dispatchEvent = dispatchEvent;
		exports.getEvent = getEvent;
		exports.getOffset = getOffset;
		exports.getTouchesCenter = getTouchesCenter;
		exports.getByTag = getByTag;
		exports.getByClass = getByClass;
		exports.createElement = createElement;
		exports.appendChild = appendChild;
		exports.removeChild = removeChild;
		exports.empty = empty;
		exports.isCrossOriginURL = isCrossOriginURL;
		exports.addTimestamp = addTimestamp;
		exports.getImageSize = getImageSize;
		exports.getTransform = getTransform;
		exports.getRotatedSizes = getRotatedSizes;
		exports.getSourceCanvas = getSourceCanvas;
		exports.getStringFromCharCode = getStringFromCharCode;
		exports.getOrientation = getOrientation;
		exports.dataURLToArrayBuffer = dataURLToArrayBuffer;
		exports.arrayBufferToDataURL = arrayBufferToDataURL;
		// RegExps
		var REGEXP_DATA_URL_HEAD = /^data:([^;]+);base64,/;
		var REGEXP_HYPHENATE = /([a-z\d])([A-Z])/g;
		var REGEXP_ORIGINS = /^(https?:)\/\/([^:\/\?#]+):?(\d*)/i;
		var REGEXP_SPACES = /\s+/;
		var REGEXP_SUFFIX = /^(width|height|left|top|marginLeft|marginTop)$/;
		var REGEXP_TRIM = /^\s+(.*)\s+$/;
		var REGEXP_USERAGENT = /(Macintosh|iPhone|iPod|iPad).*AppleWebKit/i;
		var navigator = window.navigator;
		var IS_SAFARI_OR_UIWEBVIEW = navigator && REGEXP_USERAGENT.test(navigator.userAgent);
		
		// Utilities
		var objectProto = Object.prototype;
		var toString = objectProto.toString;
		var hasOwnProperty = objectProto.hasOwnProperty;
		var slice = Array.prototype.slice;
		var fromCharCode = String.fromCharCode;
		
		function typeOf(obj) {
		  return toString.call(obj).slice(8, -1).toLowerCase();
		}
		
		function isNumber(num) {
		  return typeof num === 'number' && !isNaN(num);
		}
		
		function isUndefined(obj) {
		  return typeof obj === 'undefined';
		}
		
		function isObject(obj) {
		  return (typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) === 'object' && obj !== null;
		}
		
		function isPlainObject(obj) {
		  if (!isObject(obj)) {
		    return false;
		  }
		
		  try {
		    var _constructor = obj.constructor;
		    var prototype = _constructor.prototype;
		
		    return _constructor && prototype && hasOwnProperty.call(prototype, 'isPrototypeOf');
		  } catch (e) {
		    return false;
		  }
		}
		
		function isFunction(fn) {
		  return typeOf(fn) === 'function';
		}
		
		function isArray(arr) {
		  return Array.isArray ? Array.isArray(arr) : typeOf(arr) === 'array';
		}
		
		function toArray(obj, offset) {
		  offset = offset >= 0 ? offset : 0;
		
		  if (Array.from) {
		    return Array.from(obj).slice(offset);
		  }
		
		  return slice.call(obj, offset);
		}
		
		function trim(str) {
		  if (typeof str === 'string') {
		    str = str.trim ? str.trim() : str.replace(REGEXP_TRIM, '$1');
		  }
		
		  return str;
		}
		
		function each(obj, callback) {
		  if (obj && isFunction(callback)) {
		    var i = void 0;
		
		    if (isArray(obj) || isNumber(obj.length) /* array-like */) {
		        var length = obj.length;
		
		        for (i = 0; i < length; i++) {
		          if (callback.call(obj, obj[i], i, obj) === false) {
		            break;
		          }
		        }
		      } else if (isObject(obj)) {
		      Object.keys(obj).forEach(function (key) {
		        callback.call(obj, obj[key], key, obj);
		      });
		    }
		  }
		
		  return obj;
		}
		
		function extend() {
		  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
		    args[_key] = arguments[_key];
		  }
		
		  var deep = args[0] === true;
		  var data = deep ? args[1] : args[0];
		
		  if (args.length > 1) {
		    // if (Object.assign) {
		    //   return Object.assign.apply(Object, args);
		    // }
		
		    args.shift();
		
		    args.forEach(function (arg) {
		      if (isObject(arg)) {
		        Object.keys(arg).forEach(function (key) {
		          if (deep && isObject(data[key])) {
		            extend(true, data[key], arg[key]);
		          } else {
		            data[key] = arg[key];
		          }
		        });
		      }
		    });
		  }
		
		  return data;
		}
		
		function proxy(fn, context) {
		  for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
		    args[_key2 - 2] = arguments[_key2];
		  }
		
		  return function () {
		    for (var _len3 = arguments.length, args2 = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
		      args2[_key3] = arguments[_key3];
		    }
		
		    return fn.apply(context, args.concat(args2));
		  };
		}
		
		function setStyle(element, styles) {
		  var style = element.style;
		
		  each(styles, function (value, property) {
		    if (REGEXP_SUFFIX.test(property) && isNumber(value)) {
		      value += 'px';
		    }
		
		    style[property] = value;
		  });
		}
		
		function hasClass(element, value) {
		  return element.classList ? element.classList.contains(value) : element.className.indexOf(value) > -1;
		}
		
		function addClass(element, value) {
		  if (isNumber(element.length)) {
		    each(element, function (elem) {
		      addClass(elem, value);
		    });
		    return;
		  }
		
		  if (element.classList) {
		    element.classList.add(value);
		    return;
		  }
		
		  var className = trim(element.className);
		
		  if (!className) {
		    element.className = value;
		  } else if (className.indexOf(value) < 0) {
		    element.className = className + ' ' + value;
		  }
		}
		
		function removeClass(element, value) {
		  if (isNumber(element.length)) {
		    each(element, function (elem) {
		      removeClass(elem, value);
		    });
		    return;
		  }
		
		  if (element.classList) {
		    element.classList.remove(value);
		    return;
		  }
		
		  if (element.className.indexOf(value) >= 0) {
		    element.className = element.className.replace(value, '');
		  }
		}
		
		function toggleClass(element, value, added) {
		  if (isNumber(element.length)) {
		    each(element, function (elem) {
		      toggleClass(elem, value, added);
		    });
		    return;
		  }
		
		  // IE10-11 doesn't support the second parameter of `classList.toggle`
		  if (added) {
		    addClass(element, value);
		  } else {
		    removeClass(element, value);
		  }
		}
		
		function hyphenate(str) {
		  return str.replace(REGEXP_HYPHENATE, '$1-$2').toLowerCase();
		}
		
		function getData(element, name) {
		  if (isObject(element[name])) {
		    return element[name];
		  } else if (element.dataset) {
		    return element.dataset[name];
		  }
		
		  return element.getAttribute('data-' + hyphenate(name));
		}
		
		function setData(element, name, data) {
		  if (isObject(data)) {
		    element[name] = data;
		  } else if (element.dataset) {
		    element.dataset[name] = data;
		  } else {
		    element.setAttribute('data-' + hyphenate(name), data);
		  }
		}
		
		function removeData(element, name) {
		  if (isObject(element[name])) {
		    delete element[name];
		  } else if (element.dataset) {
		    delete element.dataset[name];
		  } else {
		    element.removeAttribute('data-' + hyphenate(name));
		  }
		}
		
		function removeListener(element, type, handler) {
		  var types = trim(type).split(REGEXP_SPACES);
		
		  if (types.length > 1) {
		    each(types, function (t) {
		      removeListener(element, t, handler);
		    });
		    return;
		  }
		
		  if (element.removeEventListener) {
		    element.removeEventListener(type, handler, false);
		  } else if (element.detachEvent) {
		    element.detachEvent('on' + type, handler);
		  }
		}
		
		function addListener(element, type, _handler, once) {
		  var types = trim(type).split(REGEXP_SPACES);
		  var originalHandler = _handler;
		
		  if (types.length > 1) {
		    each(types, function (t) {
		      addListener(element, t, _handler);
		    });
		    return;
		  }
		
		  if (once) {
		    _handler = function handler() {
		      for (var _len4 = arguments.length, args = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
		        args[_key4] = arguments[_key4];
		      }
		
		      removeListener(element, type, _handler);
		
		      return originalHandler.apply(element, args);
		    };
		  }
		
		  if (element.addEventListener) {
		    element.addEventListener(type, _handler, false);
		  } else if (element.attachEvent) {
		    element.attachEvent('on${type}', _handler);
		  }
		}
		
		exports.addListener = addListener;
		function dispatchEvent(element, type, data) {
		  if (element.dispatchEvent) {
		    var event = void 0;
		
		    // Event and CustomEvent on IE9-11 are global objects, not constructors
		    if (isFunction(Event) && isFunction(CustomEvent)) {
		      if (isUndefined(data)) {
		        event = new Event(type, {
		          bubbles: true,
		          cancelable: true
		        });
		      } else {
		        event = new CustomEvent(type, {
		          detail: data,
		          bubbles: true,
		          cancelable: true
		        });
		      }
		    } else if (isUndefined(data)) {
		      event = document.createEvent('Event');
		      event.initEvent(type, true, true);
		    } else {
		      event = document.createEvent('CustomEvent');
		      event.initCustomEvent(type, true, true, data);
		    }
		
		    // IE9+
		    return element.dispatchEvent(event);
		  } else if (element.fireEvent) {
		    // IE6-10 (native events only)
		    return element.fireEvent('on' + type);
		  }
		
		  return true;
		}
		
		function getEvent(event) {
		  var e = event || window.event;
		
		  // Fix target property (IE8)
		  if (!e.target) {
		    e.target = e.srcElement || document;
		  }
		
		  if (!isNumber(e.pageX) && isNumber(e.clientX)) {
		    var eventDoc = event.target.ownerDocument || document;
		    var doc = eventDoc.documentElement;
		    var body = eventDoc.body;
		
		    e.pageX = e.clientX + ((doc && doc.scrollLeft || body && body.scrollLeft || 0) - (doc && doc.clientLeft || body && body.clientLeft || 0));
		    e.pageY = e.clientY + ((doc && doc.scrollTop || body && body.scrollTop || 0) - (doc && doc.clientTop || body && body.clientTop || 0));
		  }
		
		  return e;
		}
		
		function getOffset(element) {
		  var doc = document.documentElement;
		  var box = element.getBoundingClientRect();
		
		  return {
		    left: box.left + ((window.scrollX || doc && doc.scrollLeft || 0) - (doc && doc.clientLeft || 0)),
		    top: box.top + ((window.scrollY || doc && doc.scrollTop || 0) - (doc && doc.clientTop || 0))
		  };
		}
		
		function getTouchesCenter(touches) {
		  var length = touches.length;
		  var pageX = 0;
		  var pageY = 0;
		
		  if (length) {
		    each(touches, function (touch) {
		      pageX += touch.pageX;
		      pageY += touch.pageY;
		    });
		
		    pageX /= length;
		    pageY /= length;
		  }
		
		  return {
		    pageX: pageX,
		    pageY: pageY
		  };
		}
		
		function getByTag(element, tagName) {
		  return element.getElementsByTagName(tagName);
		}
		
		function getByClass(element, className) {
		  return element.getElementsByClassName ? element.getElementsByClassName(className) : element.querySelectorAll('.' + className);
		}
		
		function createElement(tagName) {
		  return document.createElement(tagName);
		}
		
		function appendChild(element, elem) {
		  element.appendChild(elem);
		}
		
		function removeChild(element) {
		  if (element.parentNode) {
		    element.parentNode.removeChild(element);
		  }
		}
		
		function empty(element) {
		  while (element.firstChild) {
		    element.removeChild(element.firstChild);
		  }
		}
		
		function isCrossOriginURL(url) {
		  var parts = url.match(REGEXP_ORIGINS);
		
		  return parts && (parts[1] !== location.protocol || parts[2] !== location.hostname || parts[3] !== location.port);
		}
		
		function addTimestamp(url) {
		  var timestamp = 'timestamp=' + new Date().getTime();
		
		  return url + (url.indexOf('?') === -1 ? '?' : '&') + timestamp;
		}
		
		function getImageSize(image, callback) {
		  // Modern browsers (ignore Safari)
		  if (image.naturalWidth && !IS_SAFARI_OR_UIWEBVIEW) {
		    callback(image.naturalWidth, image.naturalHeight);
		    return;
		  }
		
		  // IE8: Don't use `new Image()` here
		  var newImage = createElement('img');
		
		  newImage.onload = function load() {
		    callback(this.width, this.height);
		  };
		
		  newImage.src = image.src;
		}
		
		function getTransform(data) {
		  var transforms = [];
		  var rotate = data.rotate;
		  var scaleX = data.scaleX;
		  var scaleY = data.scaleY;
		
		  // Rotate should come first before scale to match orientation transform
		  if (isNumber(rotate) && rotate !== 0) {
		    transforms.push('rotate(' + rotate + 'deg)');
		  }
		
		  if (isNumber(scaleX) && scaleX !== 1) {
		    transforms.push('scaleX(' + scaleX + ')');
		  }
		
		  if (isNumber(scaleY) && scaleY !== 1) {
		    transforms.push('scaleY(' + scaleY + ')');
		  }
		
		  return transforms.length ? transforms.join(' ') : 'none';
		}
		
		function getRotatedSizes(data, reversed) {
		  var deg = Math.abs(data.degree) % 180;
		  var arc = (deg > 90 ? 180 - deg : deg) * Math.PI / 180;
		  var sinArc = Math.sin(arc);
		  var cosArc = Math.cos(arc);
		  var width = data.width;
		  var height = data.height;
		  var aspectRatio = data.aspectRatio;
		  var newWidth = void 0;
		  var newHeight = void 0;
		
		  if (!reversed) {
		    newWidth = width * cosArc + height * sinArc;
		    newHeight = width * sinArc + height * cosArc;
		  } else {
		    newWidth = width / (cosArc + sinArc / aspectRatio);
		    newHeight = newWidth / aspectRatio;
		  }
		
		  return {
		    width: newWidth,
		    height: newHeight
		  };
		}
		
		function getSourceCanvas(image, data) {
		  var canvas = createElement('canvas');
		  var context = canvas.getContext('2d');
		  var dstX = 0;
		  var dstY = 0;
		  var dstWidth = data.naturalWidth;
		  var dstHeight = data.naturalHeight;
		  var rotate = data.rotate;
		  var scaleX = data.scaleX;
		  var scaleY = data.scaleY;
		  var scalable = isNumber(scaleX) && isNumber(scaleY) && (scaleX !== 1 || scaleY !== 1);
		  var rotatable = isNumber(rotate) && rotate !== 0;
		  var advanced = rotatable || scalable;
		  var canvasWidth = dstWidth * Math.abs(scaleX);
		  var canvasHeight = dstHeight * Math.abs(scaleY);
		  var translateX = void 0;
		  var translateY = void 0;
		  var rotated = void 0;
		
		  if (scalable) {
		    translateX = canvasWidth / 2;
		    translateY = canvasHeight / 2;
		  }
		
		  if (rotatable) {
		    rotated = getRotatedSizes({
		      width: canvasWidth,
		      height: canvasHeight,
		      degree: rotate
		    });
		
		    canvasWidth = rotated.width;
		    canvasHeight = rotated.height;
		    translateX = canvasWidth / 2;
		    translateY = canvasHeight / 2;
		  }
		
		  canvas.width = canvasWidth;
		  canvas.height = canvasHeight;
		
		  if (advanced) {
		    dstX = -dstWidth / 2;
		    dstY = -dstHeight / 2;
		
		    context.save();
		    context.translate(translateX, translateY);
		  }
		
		  // Rotate should come first before scale as in the "getTransform" function
		  if (rotatable) {
		    context.rotate(rotate * Math.PI / 180);
		  }
		
		  if (scalable) {
		    context.scale(scaleX, scaleY);
		  }
		
		  context.drawImage(image, Math.floor(dstX), Math.floor(dstY), Math.floor(dstWidth), Math.floor(dstHeight));
		
		  if (advanced) {
		    context.restore();
		  }
		
		  return canvas;
		}
		
		function getStringFromCharCode(dataView, start, length) {
		  var str = '';
		  var i = start;
		
		  for (length += start; i < length; i++) {
		    str += fromCharCode(dataView.getUint8(i));
		  }
		
		  return str;
		}
		
		function getOrientation(arrayBuffer) {
		  var dataView = new DataView(arrayBuffer);
		  var length = dataView.byteLength;
		  var orientation = void 0;
		  var exifIDCode = void 0;
		  var tiffOffset = void 0;
		  var firstIFDOffset = void 0;
		  var littleEndian = void 0;
		  var endianness = void 0;
		  var app1Start = void 0;
		  var ifdStart = void 0;
		  var offset = void 0;
		  var i = void 0;
		
		  // Only handle JPEG image (start by 0xFFD8)
		  if (dataView.getUint8(0) === 0xFF && dataView.getUint8(1) === 0xD8) {
		    offset = 2;
		
		    while (offset < length) {
		      if (dataView.getUint8(offset) === 0xFF && dataView.getUint8(offset + 1) === 0xE1) {
		        app1Start = offset;
		        break;
		      }
		
		      offset++;
		    }
		  }
		
		  if (app1Start) {
		    exifIDCode = app1Start + 4;
		    tiffOffset = app1Start + 10;
		
		    if (getStringFromCharCode(dataView, exifIDCode, 4) === 'Exif') {
		      endianness = dataView.getUint16(tiffOffset);
		      littleEndian = endianness === 0x4949;
		
		      if (littleEndian || endianness === 0x4D4D /* bigEndian */) {
		          if (dataView.getUint16(tiffOffset + 2, littleEndian) === 0x002A) {
		            firstIFDOffset = dataView.getUint32(tiffOffset + 4, littleEndian);
		
		            if (firstIFDOffset >= 0x00000008) {
		              ifdStart = tiffOffset + firstIFDOffset;
		            }
		          }
		        }
		    }
		  }
		
		  if (ifdStart) {
		    length = dataView.getUint16(ifdStart, littleEndian);
		
		    for (i = 0; i < length; i++) {
		      offset = ifdStart + i * 12 + 2;
		
		      if (dataView.getUint16(offset, littleEndian) === 0x0112 /* Orientation */) {
		          // 8 is the offset of the current tag's value
		          offset += 8;
		
		          // Get the original orientation value
		          orientation = dataView.getUint16(offset, littleEndian);
		
		          // Override the orientation with its default value for Safari
		          if (IS_SAFARI_OR_UIWEBVIEW) {
		            dataView.setUint16(offset, 1, littleEndian);
		          }
		
		          break;
		        }
		    }
		  }
		
		  return orientation;
		}
		
		function dataURLToArrayBuffer(dataURL) {
		  var base64 = dataURL.replace(REGEXP_DATA_URL_HEAD, '');
		  var binary = atob(base64);
		  var length = binary.length;
		  var arrayBuffer = new ArrayBuffer(length);
		  var dataView = new Uint8Array(arrayBuffer);
		  var i = void 0;
		
		  for (i = 0; i < length; i++) {
		    dataView[i] = binary.charCodeAt(i);
		  }
		
		  return arrayBuffer;
		}
		
		// Only available for JPEG image
		function arrayBufferToDataURL(arrayBuffer) {
		  var dataView = new Uint8Array(arrayBuffer);
		  var length = dataView.length;
		  var base64 = '';
		  var i = void 0;
		
		  for (i = 0; i < length; i++) {
		    base64 += fromCharCode(dataView[i]);
		  }
		
		  return 'data:image/jpeg;base64,' + btoa(base64);
		}
	
	/***/ },
	/* 5 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
		
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		
		var _utilities = __webpack_require__(4);
		
		var $ = _interopRequireWildcard(_utilities);
		
		function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
		
		var DATA_PREVIEW = 'preview';
		
		exports.default = {
		  initPreview: function initPreview() {
		    var self = this;
		    var preview = self.options.preview;
		    var image = $.createElement('img');
		    var crossOrigin = self.crossOrigin;
		    var url = crossOrigin ? self.crossOriginUrl : self.url;
		
		    if (crossOrigin) {
		      image.crossOrigin = crossOrigin;
		    }
		
		    image.src = url;
		    $.appendChild(self.viewBox, image);
		    self.image2 = image;
		
		    if (!preview) {
		      return;
		    }
		
		    var previews = document.querySelectorAll(preview);
		
		    self.previews = previews;
		
		    $.each(previews, function (element) {
		      var img = $.createElement('img');
		
		      // Save the original size for recover
		      $.setData(element, DATA_PREVIEW, {
		        width: element.offsetWidth,
		        height: element.offsetHeight,
		        html: element.innerHTML
		      });
		
		      if (crossOrigin) {
		        img.crossOrigin = crossOrigin;
		      }
		
		      img.src = url;
		
		      /**
		       * Override img element styles
		       * Add `display:block` to avoid margin top issue
		       * Add `height:auto` to override `height` attribute on IE8
		       * (Occur only when margin-top <= -height)
		       */
		
		      img.style.cssText = 'display:block;' + 'width:100%;' + 'height:auto;' + 'min-width:0!important;' + 'min-height:0!important;' + 'max-width:none!important;' + 'max-height:none!important;' + 'image-orientation:0deg!important;"';
		
		      $.empty(element);
		      $.appendChild(element, img);
		    });
		  },
		  resetPreview: function resetPreview() {
		    $.each(this.previews, function (element) {
		      var data = $.getData(element, DATA_PREVIEW);
		
		      $.setStyle(element, {
		        width: data.width,
		        height: data.height
		      });
		
		      element.innerHTML = data.html;
		      $.removeData(element, DATA_PREVIEW);
		    });
		  },
		  preview: function preview() {
		    var self = this;
		    var imageData = self.imageData;
		    var canvasData = self.canvasData;
		    var cropBoxData = self.cropBoxData;
		    var cropBoxWidth = cropBoxData.width;
		    var cropBoxHeight = cropBoxData.height;
		    var width = imageData.width;
		    var height = imageData.height;
		    var left = cropBoxData.left - canvasData.left - imageData.left;
		    var top = cropBoxData.top - canvasData.top - imageData.top;
		    var transform = $.getTransform(imageData);
		    var transforms = {
		      WebkitTransform: transform,
		      msTransform: transform,
		      transform: transform
		    };
		
		    if (!self.cropped || self.disabled) {
		      return;
		    }
		
		    $.setStyle(self.image2, $.extend({
		      width: width,
		      height: height,
		      marginLeft: -left,
		      marginTop: -top
		    }, transforms));
		
		    $.each(self.previews, function (element) {
		      var data = $.getData(element, DATA_PREVIEW);
		      var originalWidth = data.width;
		      var originalHeight = data.height;
		      var newWidth = originalWidth;
		      var newHeight = originalHeight;
		      var ratio = 1;
		
		      if (cropBoxWidth) {
		        ratio = originalWidth / cropBoxWidth;
		        newHeight = cropBoxHeight * ratio;
		      }
		
		      if (cropBoxHeight && newHeight > originalHeight) {
		        ratio = originalHeight / cropBoxHeight;
		        newWidth = cropBoxWidth * ratio;
		        newHeight = originalHeight;
		      }
		
		      $.setStyle(element, {
		        width: newWidth,
		        height: newHeight
		      });
		
		      $.setStyle($.getByTag(element, 'img')[0], $.extend({
		        width: width * ratio,
		        height: height * ratio,
		        marginLeft: -left * ratio,
		        marginTop: -top * ratio
		      }, transforms));
		    });
		  }
		};
	
	/***/ },
	/* 6 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
		
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		
		var _utilities = __webpack_require__(4);
		
		var $ = _interopRequireWildcard(_utilities);
		
		function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
		
		// Events
		var EVENT_MOUSE_DOWN = 'mousedown touchstart pointerdown MSPointerDown';
		var EVENT_MOUSE_MOVE = 'mousemove touchmove pointermove MSPointerMove';
		var EVENT_MOUSE_UP = 'mouseup touchend touchcancel pointerup pointercancel' + ' MSPointerUp MSPointerCancel';
		var EVENT_WHEEL = 'wheel mousewheel DOMMouseScroll';
		var EVENT_DBLCLICK = 'dblclick';
		var EVENT_RESIZE = 'resize';
		var EVENT_CROP_START = 'cropstart';
		var EVENT_CROP_MOVE = 'cropmove';
		var EVENT_CROP_END = 'cropend';
		var EVENT_CROP = 'crop';
		var EVENT_ZOOM = 'zoom';
		
		exports.default = {
		  bind: function bind() {
		    var self = this;
		    var options = self.options;
		    var element = self.element;
		    var cropper = self.cropper;
		
		    if ($.isFunction(options.cropstart)) {
		      $.addListener(element, EVENT_CROP_START, options.cropstart);
		    }
		
		    if ($.isFunction(options.cropmove)) {
		      $.addListener(element, EVENT_CROP_MOVE, options.cropmove);
		    }
		
		    if ($.isFunction(options.cropend)) {
		      $.addListener(element, EVENT_CROP_END, options.cropend);
		    }
		
		    if ($.isFunction(options.crop)) {
		      $.addListener(element, EVENT_CROP, options.crop);
		    }
		
		    if ($.isFunction(options.zoom)) {
		      $.addListener(element, EVENT_ZOOM, options.zoom);
		    }
		
		    $.addListener(cropper, EVENT_MOUSE_DOWN, self.onCropStart = $.proxy(self.cropStart, self));
		
		    if (options.zoomable && options.zoomOnWheel) {
		      $.addListener(cropper, EVENT_WHEEL, self.onWheel = $.proxy(self.wheel, self));
		    }
		
		    if (options.toggleDragModeOnDblclick) {
		      $.addListener(cropper, EVENT_DBLCLICK, self.onDblclick = $.proxy(self.dblclick, self));
		    }
		
		    $.addListener(document, EVENT_MOUSE_MOVE, self.onCropMove = $.proxy(self.cropMove, self));
		    $.addListener(document, EVENT_MOUSE_UP, self.onCropEnd = $.proxy(self.cropEnd, self));
		
		    if (options.responsive) {
		      $.addListener(window, EVENT_RESIZE, self.onResize = $.proxy(self.resize, self));
		    }
		  },
		  unbind: function unbind() {
		    var self = this;
		    var options = self.options;
		    var element = self.element;
		    var cropper = self.cropper;
		
		    if ($.isFunction(options.cropstart)) {
		      $.removeListener(element, EVENT_CROP_START, options.cropstart);
		    }
		
		    if ($.isFunction(options.cropmove)) {
		      $.removeListener(element, EVENT_CROP_MOVE, options.cropmove);
		    }
		
		    if ($.isFunction(options.cropend)) {
		      $.removeListener(element, EVENT_CROP_END, options.cropend);
		    }
		
		    if ($.isFunction(options.crop)) {
		      $.removeListener(element, EVENT_CROP, options.crop);
		    }
		
		    if ($.isFunction(options.zoom)) {
		      $.removeListener(element, EVENT_ZOOM, options.zoom);
		    }
		
		    $.removeListener(cropper, EVENT_MOUSE_DOWN, self.onCropStart);
		
		    if (options.zoomable && options.zoomOnWheel) {
		      $.removeListener(cropper, EVENT_WHEEL, self.onWheel);
		    }
		
		    if (options.toggleDragModeOnDblclick) {
		      $.removeListener(cropper, EVENT_DBLCLICK, self.onDblclick);
		    }
		
		    $.removeListener(document, EVENT_MOUSE_MOVE, self.onCropMove);
		    $.removeListener(document, EVENT_MOUSE_UP, self.onCropEnd);
		
		    if (options.responsive) {
		      $.removeListener(window, EVENT_RESIZE, self.onResize);
		    }
		  }
		};
	
	/***/ },
	/* 7 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
		
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.REGEXP_ACTIONS = undefined;
		
		var _utilities = __webpack_require__(4);
		
		var $ = _interopRequireWildcard(_utilities);
		
		function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
		
		var REGEXP_ACTIONS = exports.REGEXP_ACTIONS = /^(e|w|s|n|se|sw|ne|nw|all|crop|move|zoom)$/;
		
		exports.default = {
		  resize: function resize() {
		    var self = this;
		    var restore = self.options.restore;
		    var container = self.container;
		    var containerData = self.containerData;
		
		    // Check `container` is necessary for IE8
		    if (self.disabled || !containerData) {
		      return;
		    }
		
		    var ratio = container.offsetWidth / containerData.width;
		    var canvasData = void 0;
		    var cropBoxData = void 0;
		
		    // Resize when width changed or height changed
		    if (ratio !== 1 || container.offsetHeight !== containerData.height) {
		      if (restore) {
		        canvasData = self.getCanvasData();
		        cropBoxData = self.getCropBoxData();
		      }
		
		      self.render();
		
		      if (restore) {
		        self.setCanvasData($.each(canvasData, function (n, i) {
		          canvasData[i] = n * ratio;
		        }));
		        self.setCropBoxData($.each(cropBoxData, function (n, i) {
		          cropBoxData[i] = n * ratio;
		        }));
		      }
		    }
		  },
		  dblclick: function dblclick() {
		    var self = this;
		
		    if (self.disabled) {
		      return;
		    }
		
		    self.setDragMode($.hasClass(self.dragBox, 'cropper-crop') ? 'move' : 'crop');
		  },
		  wheel: function wheel(event) {
		    var self = this;
		    var e = $.getEvent(event);
		    var ratio = Number(self.options.wheelZoomRatio) || 0.1;
		    var delta = 1;
		
		    if (self.disabled) {
		      return;
		    }
		
		    e.preventDefault();
		
		    // Limit wheel speed to prevent zoom too fast (#21)
		    if (self.wheeling) {
		      return;
		    }
		
		    self.wheeling = true;
		
		    setTimeout(function () {
		      self.wheeling = false;
		    }, 50);
		
		    if (e.deltaY) {
		      delta = e.deltaY > 0 ? 1 : -1;
		    } else if (e.wheelDelta) {
		      delta = -e.wheelDelta / 120;
		    } else if (e.detail) {
		      delta = e.detail > 0 ? 1 : -1;
		    }
		
		    self.zoom(-delta * ratio, e);
		  },
		  cropStart: function cropStart(event) {
		    var self = this;
		    var options = self.options;
		    var e = $.getEvent(event);
		    var touches = e.touches;
		    var touchesLength = void 0;
		    var touch = void 0;
		    var action = void 0;
		
		    if (self.disabled) {
		      return;
		    }
		
		    if (touches) {
		      touchesLength = touches.length;
		
		      if (touchesLength > 1) {
		        if (options.zoomable && options.zoomOnTouch && touchesLength === 2) {
		          touch = touches[1];
		          self.startX2 = touch.pageX;
		          self.startY2 = touch.pageY;
		          action = 'zoom';
		        } else {
		          return;
		        }
		      }
		
		      touch = touches[0];
		    }
		
		    action = action || $.getData(e.target, 'action');
		
		    if (REGEXP_ACTIONS.test(action)) {
		      if ($.dispatchEvent(self.element, 'cropstart', {
		        originalEvent: e,
		        action: action
		      }) === false) {
		        return;
		      }
		
		      e.preventDefault();
		
		      self.action = action;
		      self.cropping = false;
		
		      self.startX = touch ? touch.pageX : e.pageX;
		      self.startY = touch ? touch.pageY : e.pageY;
		
		      if (action === 'crop') {
		        self.cropping = true;
		        $.addClass(self.dragBox, 'cropper-modal');
		      }
		    }
		  },
		  cropMove: function cropMove(event) {
		    var self = this;
		    var options = self.options;
		    var e = $.getEvent(event);
		    var touches = e.touches;
		    var action = self.action;
		    var touchesLength = void 0;
		    var touch = void 0;
		
		    if (self.disabled) {
		      return;
		    }
		
		    if (touches) {
		      touchesLength = touches.length;
		
		      if (touchesLength > 1) {
		        if (options.zoomable && options.zoomOnTouch && touchesLength === 2) {
		          touch = touches[1];
		          self.endX2 = touch.pageX;
		          self.endY2 = touch.pageY;
		        } else {
		          return;
		        }
		      }
		
		      touch = touches[0];
		    }
		
		    if (action) {
		      if ($.dispatchEvent(self.element, 'cropmove', {
		        originalEvent: e,
		        action: action
		      }) === false) {
		        return;
		      }
		
		      e.preventDefault();
		
		      self.endX = touch ? touch.pageX : e.pageX;
		      self.endY = touch ? touch.pageY : e.pageY;
		
		      self.change(e.shiftKey, action === 'zoom' ? e : null);
		    }
		  },
		  cropEnd: function cropEnd(event) {
		    var self = this;
		    var options = self.options;
		    var e = $.getEvent(event);
		    var action = self.action;
		
		    if (self.disabled) {
		      return;
		    }
		
		    if (action) {
		      e.preventDefault();
		
		      if (self.cropping) {
		        self.cropping = false;
		        $.toggleClass(self.dragBox, 'cropper-modal', self.cropped && options.modal);
		      }
		
		      self.action = '';
		
		      $.dispatchEvent(self.element, 'cropend', {
		        originalEvent: e,
		        action: action
		      });
		    }
		  }
		};
	
	/***/ },
	/* 8 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
		
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		
		var _utilities = __webpack_require__(4);
		
		var $ = _interopRequireWildcard(_utilities);
		
		function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
		
		// Actions
		var ACTION_EAST = 'e';
		var ACTION_WEST = 'w';
		var ACTION_SOUTH = 's';
		var ACTION_NORTH = 'n';
		var ACTION_SOUTH_EAST = 'se';
		var ACTION_SOUTH_WEST = 'sw';
		var ACTION_NORTH_EAST = 'ne';
		var ACTION_NORTH_WEST = 'nw';
		
		exports.default = {
		  change: function change(shiftKey, originalEvent) {
		    var self = this;
		    var options = self.options;
		    var containerData = self.containerData;
		    var canvasData = self.canvasData;
		    var cropBoxData = self.cropBoxData;
		    var aspectRatio = options.aspectRatio;
		    var action = self.action;
		    var width = cropBoxData.width;
		    var height = cropBoxData.height;
		    var left = cropBoxData.left;
		    var top = cropBoxData.top;
		    var right = left + width;
		    var bottom = top + height;
		    var minLeft = 0;
		    var minTop = 0;
		    var maxWidth = containerData.width;
		    var maxHeight = containerData.height;
		    var renderable = true;
		    var offset = void 0;
		
		    // Locking aspect ratio in "free mode" by holding shift key
		    if (!aspectRatio && shiftKey) {
		      aspectRatio = width && height ? width / height : 1;
		    }
		
		    if (self.limited) {
		      minLeft = cropBoxData.minLeft;
		      minTop = cropBoxData.minTop;
		      maxWidth = minLeft + Math.min(containerData.width, canvasData.left + canvasData.width);
		      maxHeight = minTop + Math.min(containerData.height, canvasData.top + canvasData.height);
		    }
		
		    var range = {
		      x: self.endX - self.startX,
		      y: self.endY - self.startY
		    };
		
		    if (aspectRatio) {
		      range.X = range.y * aspectRatio;
		      range.Y = range.x / aspectRatio;
		    }
		
		    switch (action) {
		      // Move crop box
		      case 'all':
		        left += range.x;
		        top += range.y;
		        break;
		
		      // Resize crop box
		      case ACTION_EAST:
		        if (range.x >= 0 && (right >= maxWidth || aspectRatio && (top <= minTop || bottom >= maxHeight))) {
		          renderable = false;
		          break;
		        }
		
		        width += range.x;
		
		        if (aspectRatio) {
		          height = width / aspectRatio;
		          top -= range.Y / 2;
		        }
		
		        if (width < 0) {
		          action = ACTION_WEST;
		          width = 0;
		        }
		
		        break;
		
		      case ACTION_NORTH:
		        if (range.y <= 0 && (top <= minTop || aspectRatio && (left <= minLeft || right >= maxWidth))) {
		          renderable = false;
		          break;
		        }
		
		        height -= range.y;
		        top += range.y;
		
		        if (aspectRatio) {
		          width = height * aspectRatio;
		          left += range.X / 2;
		        }
		
		        if (height < 0) {
		          action = ACTION_SOUTH;
		          height = 0;
		        }
		
		        break;
		
		      case ACTION_WEST:
		        if (range.x <= 0 && (left <= minLeft || aspectRatio && (top <= minTop || bottom >= maxHeight))) {
		          renderable = false;
		          break;
		        }
		
		        width -= range.x;
		        left += range.x;
		
		        if (aspectRatio) {
		          height = width / aspectRatio;
		          top += range.Y / 2;
		        }
		
		        if (width < 0) {
		          action = ACTION_EAST;
		          width = 0;
		        }
		
		        break;
		
		      case ACTION_SOUTH:
		        if (range.y >= 0 && (bottom >= maxHeight || aspectRatio && (left <= minLeft || right >= maxWidth))) {
		          renderable = false;
		          break;
		        }
		
		        height += range.y;
		
		        if (aspectRatio) {
		          width = height * aspectRatio;
		          left -= range.X / 2;
		        }
		
		        if (height < 0) {
		          action = ACTION_NORTH;
		          height = 0;
		        }
		
		        break;
		
		      case ACTION_NORTH_EAST:
		        if (aspectRatio) {
		          if (range.y <= 0 && (top <= minTop || right >= maxWidth)) {
		            renderable = false;
		            break;
		          }
		
		          height -= range.y;
		          top += range.y;
		          width = height * aspectRatio;
		        } else {
		          if (range.x >= 0) {
		            if (right < maxWidth) {
		              width += range.x;
		            } else if (range.y <= 0 && top <= minTop) {
		              renderable = false;
		            }
		          } else {
		            width += range.x;
		          }
		
		          if (range.y <= 0) {
		            if (top > minTop) {
		              height -= range.y;
		              top += range.y;
		            }
		          } else {
		            height -= range.y;
		            top += range.y;
		          }
		        }
		
		        if (width < 0 && height < 0) {
		          action = ACTION_SOUTH_WEST;
		          height = 0;
		          width = 0;
		        } else if (width < 0) {
		          action = ACTION_NORTH_WEST;
		          width = 0;
		        } else if (height < 0) {
		          action = ACTION_SOUTH_EAST;
		          height = 0;
		        }
		
		        break;
		
		      case ACTION_NORTH_WEST:
		        if (aspectRatio) {
		          if (range.y <= 0 && (top <= minTop || left <= minLeft)) {
		            renderable = false;
		            break;
		          }
		
		          height -= range.y;
		          top += range.y;
		          width = height * aspectRatio;
		          left += range.X;
		        } else {
		          if (range.x <= 0) {
		            if (left > minLeft) {
		              width -= range.x;
		              left += range.x;
		            } else if (range.y <= 0 && top <= minTop) {
		              renderable = false;
		            }
		          } else {
		            width -= range.x;
		            left += range.x;
		          }
		
		          if (range.y <= 0) {
		            if (top > minTop) {
		              height -= range.y;
		              top += range.y;
		            }
		          } else {
		            height -= range.y;
		            top += range.y;
		          }
		        }
		
		        if (width < 0 && height < 0) {
		          action = ACTION_SOUTH_EAST;
		          height = 0;
		          width = 0;
		        } else if (width < 0) {
		          action = ACTION_NORTH_EAST;
		          width = 0;
		        } else if (height < 0) {
		          action = ACTION_SOUTH_WEST;
		          height = 0;
		        }
		
		        break;
		
		      case ACTION_SOUTH_WEST:
		        if (aspectRatio) {
		          if (range.x <= 0 && (left <= minLeft || bottom >= maxHeight)) {
		            renderable = false;
		            break;
		          }
		
		          width -= range.x;
		          left += range.x;
		          height = width / aspectRatio;
		        } else {
		          if (range.x <= 0) {
		            if (left > minLeft) {
		              width -= range.x;
		              left += range.x;
		            } else if (range.y >= 0 && bottom >= maxHeight) {
		              renderable = false;
		            }
		          } else {
		            width -= range.x;
		            left += range.x;
		          }
		
		          if (range.y >= 0) {
		            if (bottom < maxHeight) {
		              height += range.y;
		            }
		          } else {
		            height += range.y;
		          }
		        }
		
		        if (width < 0 && height < 0) {
		          action = ACTION_NORTH_EAST;
		          height = 0;
		          width = 0;
		        } else if (width < 0) {
		          action = ACTION_SOUTH_EAST;
		          width = 0;
		        } else if (height < 0) {
		          action = ACTION_NORTH_WEST;
		          height = 0;
		        }
		
		        break;
		
		      case ACTION_SOUTH_EAST:
		        if (aspectRatio) {
		          if (range.x >= 0 && (right >= maxWidth || bottom >= maxHeight)) {
		            renderable = false;
		            break;
		          }
		
		          width += range.x;
		          height = width / aspectRatio;
		        } else {
		          if (range.x >= 0) {
		            if (right < maxWidth) {
		              width += range.x;
		            } else if (range.y >= 0 && bottom >= maxHeight) {
		              renderable = false;
		            }
		          } else {
		            width += range.x;
		          }
		
		          if (range.y >= 0) {
		            if (bottom < maxHeight) {
		              height += range.y;
		            }
		          } else {
		            height += range.y;
		          }
		        }
		
		        if (width < 0 && height < 0) {
		          action = ACTION_NORTH_WEST;
		          height = 0;
		          width = 0;
		        } else if (width < 0) {
		          action = ACTION_SOUTH_WEST;
		          width = 0;
		        } else if (height < 0) {
		          action = ACTION_NORTH_EAST;
		          height = 0;
		        }
		
		        break;
		
		      // Move canvas
		      case 'move':
		        self.move(range.x, range.y);
		        renderable = false;
		        break;
		
		      // Zoom canvas
		      case 'zoom':
		        self.zoom(function (x1, y1, x2, y2) {
		          var z1 = Math.sqrt(x1 * x1 + y1 * y1);
		          var z2 = Math.sqrt(x2 * x2 + y2 * y2);
		
		          return (z2 - z1) / z1;
		        }(Math.abs(self.startX - self.startX2), Math.abs(self.startY - self.startY2), Math.abs(self.endX - self.endX2), Math.abs(self.endY - self.endY2)), originalEvent);
		        self.startX2 = self.endX2;
		        self.startY2 = self.endY2;
		        renderable = false;
		        break;
		
		      // Create crop box
		      case 'crop':
		        if (!range.x || !range.y) {
		          renderable = false;
		          break;
		        }
		
		        offset = $.getOffset(self.cropper);
		        left = self.startX - offset.left;
		        top = self.startY - offset.top;
		        width = cropBoxData.minWidth;
		        height = cropBoxData.minHeight;
		
		        if (range.x > 0) {
		          action = range.y > 0 ? ACTION_SOUTH_EAST : ACTION_NORTH_EAST;
		        } else if (range.x < 0) {
		          left -= width;
		          action = range.y > 0 ? ACTION_SOUTH_WEST : ACTION_NORTH_WEST;
		        }
		
		        if (range.y < 0) {
		          top -= height;
		        }
		
		        // Show the crop box if is hidden
		        if (!self.cropped) {
		          $.removeClass(self.cropBox, 'cropper-hidden');
		          self.cropped = true;
		
		          if (self.limited) {
		            self.limitCropBox(true, true);
		          }
		        }
		
		        break;
		
		      // No default
		    }
		
		    if (renderable) {
		      cropBoxData.width = width;
		      cropBoxData.height = height;
		      cropBoxData.left = left;
		      cropBoxData.top = top;
		      self.action = action;
		
		      self.renderCropBox();
		    }
		
		    // Override
		    self.startX = self.endX;
		    self.startY = self.endY;
		  }
		};
	
	/***/ },
	/* 9 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
		
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		
		var _utilities = __webpack_require__(4);
		
		var $ = _interopRequireWildcard(_utilities);
		
		function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
		
		function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
		
		exports.default = {
		  // Show the crop box manually
		  crop: function crop() {
		    var self = this;
		
		    if (self.ready && !self.disabled) {
		      if (!self.cropped) {
		        self.cropped = true;
		        self.limitCropBox(true, true);
		
		        if (self.options.modal) {
		          $.addClass(self.dragBox, 'cropper-modal');
		        }
		
		        $.removeClass(self.cropBox, 'cropper-hidden');
		      }
		
		      self.setCropBoxData(self.initialCropBoxData);
		    }
		
		    return self;
		  },
		
		
		  // Reset the image and crop box to their initial states
		  reset: function reset() {
		    var self = this;
		
		    if (self.ready && !self.disabled) {
		      self.imageData = $.extend({}, self.initialImageData);
		      self.canvasData = $.extend({}, self.initialCanvasData);
		      self.cropBoxData = $.extend({}, self.initialCropBoxData);
		
		      self.renderCanvas();
		
		      if (self.cropped) {
		        self.renderCropBox();
		      }
		    }
		
		    return self;
		  },
		
		
		  // Clear the crop box
		  clear: function clear() {
		    var self = this;
		
		    if (self.cropped && !self.disabled) {
		      $.extend(self.cropBoxData, {
		        left: 0,
		        top: 0,
		        width: 0,
		        height: 0
		      });
		
		      self.cropped = false;
		      self.renderCropBox();
		
		      self.limitCanvas();
		
		      // Render canvas after crop box rendered
		      self.renderCanvas();
		
		      $.removeClass(self.dragBox, 'cropper-modal');
		      $.addClass(self.cropBox, 'cropper-hidden');
		    }
		
		    return self;
		  },
		
		
		  /**
		   * Replace the image's src and rebuild the cropper
		   *
		   * @param {String} url
		   * @param {Boolean} onlyColorChanged (optional)
		   */
		  replace: function replace(url, onlyColorChanged) {
		    var self = this;
		
		    if (!self.disabled && url) {
		      if (self.isImg) {
		        self.element.src = url;
		      }
		
		      if (onlyColorChanged) {
		        self.url = url;
		        self.image.src = url;
		
		        if (self.ready) {
		          self.image2.src = url;
		
		          $.each(self.previews, function (element) {
		            $.getByTag(element, 'img')[0].src = url;
		          });
		        }
		      } else {
		        if (self.isImg) {
		          self.replaced = true;
		        }
		
		        // Clear previous data
		        self.options.data = null;
		        self.load(url);
		      }
		    }
		
		    return self;
		  },
		
		
		  // Enable (unfreeze) the cropper
		  enable: function enable() {
		    var self = this;
		
		    if (self.ready) {
		      self.disabled = false;
		      $.removeClass(self.cropper, 'cropper-disabled');
		    }
		
		    return self;
		  },
		
		
		  // Disable (freeze) the cropper
		  disable: function disable() {
		    var self = this;
		
		    if (self.ready) {
		      self.disabled = true;
		      $.addClass(self.cropper, 'cropper-disabled');
		    }
		
		    return self;
		  },
		
		
		  // Destroy the cropper and remove the instance from the image
		  destroy: function destroy() {
		    var self = this;
		    var element = self.element;
		    var image = self.image;
		
		    if (self.loaded) {
		      if (self.isImg && self.replaced) {
		        element.src = self.originalUrl;
		      }
		
		      self.unbuild();
		      $.removeClass(element, 'cropper-hidden');
		    } else if (self.isImg) {
		      $.removeListener(element, 'load', self.start);
		    } else if (image) {
		      $.removeChild(image);
		    }
		
		    $.removeData(element, 'cropper');
		
		    return self;
		  },
		
		
		  /**
		   * Move the canvas with relative offsets
		   *
		   * @param {Number} offsetX
		   * @param {Number} offsetY (optional)
		   */
		  move: function move(offsetX, offsetY) {
		    var self = this;
		    var canvasData = self.canvasData;
		
		    return self.moveTo($.isUndefined(offsetX) ? offsetX : canvasData.left + Number(offsetX), $.isUndefined(offsetY) ? offsetY : canvasData.top + Number(offsetY));
		  },
		
		
		  /**
		   * Move the canvas to an absolute point
		   *
		   * @param {Number} x
		   * @param {Number} y (optional)
		   */
		  moveTo: function moveTo(x, y) {
		    var self = this;
		    var canvasData = self.canvasData;
		    var changed = false;
		
		    // If "y" is not present, its default value is "x"
		    if ($.isUndefined(y)) {
		      y = x;
		    }
		
		    x = Number(x);
		    y = Number(y);
		
		    if (self.ready && !self.disabled && self.options.movable) {
		      if ($.isNumber(x)) {
		        canvasData.left = x;
		        changed = true;
		      }
		
		      if ($.isNumber(y)) {
		        canvasData.top = y;
		        changed = true;
		      }
		
		      if (changed) {
		        self.renderCanvas(true);
		      }
		    }
		
		    return self;
		  },
		
		
		  /**
		   * Zoom the canvas with a relative ratio
		   *
		   * @param {Number} ratio
		   * @param {Event} _originalEvent (private)
		   */
		  zoom: function zoom(ratio, _originalEvent) {
		    var self = this;
		    var canvasData = self.canvasData;
		
		    ratio = Number(ratio);
		
		    if (ratio < 0) {
		      ratio = 1 / (1 - ratio);
		    } else {
		      ratio = 1 + ratio;
		    }
		
		    return self.zoomTo(canvasData.width * ratio / canvasData.naturalWidth, _originalEvent);
		  },
		
		
		  /**
		   * Zoom the canvas to an absolute ratio
		   *
		   * @param {Number} ratio
		   * @param {Event} _originalEvent (private)
		   */
		  zoomTo: function zoomTo(ratio, _originalEvent) {
		    var self = this;
		    var options = self.options;
		    var canvasData = self.canvasData;
		    var width = canvasData.width;
		    var height = canvasData.height;
		    var naturalWidth = canvasData.naturalWidth;
		    var naturalHeight = canvasData.naturalHeight;
		    var newWidth = void 0;
		    var newHeight = void 0;
		    var offset = void 0;
		    var center = void 0;
		
		    ratio = Number(ratio);
		
		    if (ratio >= 0 && self.ready && !self.disabled && options.zoomable) {
		      newWidth = naturalWidth * ratio;
		      newHeight = naturalHeight * ratio;
		
		      if ($.dispatchEvent(self.element, 'zoom', {
		        originalEvent: _originalEvent,
		        oldRatio: width / naturalWidth,
		        ratio: newWidth / naturalWidth
		      }) === false) {
		        return self;
		      }
		
		      if (_originalEvent) {
		        offset = $.getOffset(self.cropper);
		        center = _originalEvent.touches ? $.getTouchesCenter(_originalEvent.touches) : {
		          pageX: _originalEvent.pageX,
		          pageY: _originalEvent.pageY
		        };
		
		        // Zoom from the triggering point of the event
		        canvasData.left -= (newWidth - width) * ((center.pageX - offset.left - canvasData.left) / width);
		        canvasData.top -= (newHeight - height) * ((center.pageY - offset.top - canvasData.top) / height);
		      } else {
		        // Zoom from the center of the canvas
		        canvasData.left -= (newWidth - width) / 2;
		        canvasData.top -= (newHeight - height) / 2;
		      }
		
		      canvasData.width = newWidth;
		      canvasData.height = newHeight;
		      self.renderCanvas(true);
		    }
		
		    return self;
		  },
		
		
		  /**
		   * Rotate the canvas with a relative degree
		   *
		   * @param {Number} degree
		   */
		  rotate: function rotate(degree) {
		    var self = this;
		
		    return self.rotateTo((self.imageData.rotate || 0) + Number(degree));
		  },
		
		
		  /**
		   * Rotate the canvas to an absolute degree
		   * https://developer.mozilla.org/en-US/docs/Web/CSS/transform-function#rotate()
		   *
		   * @param {Number} degree
		   */
		  rotateTo: function rotateTo(degree) {
		    var self = this;
		
		    degree = Number(degree);
		
		    if ($.isNumber(degree) && self.ready && !self.disabled && self.options.rotatable) {
		      self.imageData.rotate = degree % 360;
		      self.rotated = true;
		      self.renderCanvas(true);
		    }
		
		    return self;
		  },
		
		
		  /**
		   * Scale the image
		   * https://developer.mozilla.org/en-US/docs/Web/CSS/transform-function#scale()
		   *
		   * @param {Number} scaleX
		   * @param {Number} scaleY (optional)
		   */
		  scale: function scale(scaleX, scaleY) {
		    var self = this;
		    var imageData = self.imageData;
		    var changed = false;
		
		    // If "scaleY" is not present, its default value is "scaleX"
		    if ($.isUndefined(scaleY)) {
		      scaleY = scaleX;
		    }
		
		    scaleX = Number(scaleX);
		    scaleY = Number(scaleY);
		
		    if (self.ready && !self.disabled && self.options.scalable) {
		      if ($.isNumber(scaleX)) {
		        imageData.scaleX = scaleX;
		        changed = true;
		      }
		
		      if ($.isNumber(scaleY)) {
		        imageData.scaleY = scaleY;
		        changed = true;
		      }
		
		      if (changed) {
		        self.renderImage(true);
		      }
		    }
		
		    return self;
		  },
		
		
		  /**
		   * Scale the abscissa of the image
		   *
		   * @param {Number} scaleX
		   */
		  scaleX: function scaleX(_scaleX) {
		    var self = this;
		    var scaleY = self.imageData.scaleY;
		
		    return self.scale(_scaleX, $.isNumber(scaleY) ? scaleY : 1);
		  },
		
		
		  /**
		   * Scale the ordinate of the image
		   *
		   * @param {Number} scaleY
		   */
		  scaleY: function scaleY(_scaleY) {
		    var self = this;
		    var scaleX = self.imageData.scaleX;
		
		    return self.scale($.isNumber(scaleX) ? scaleX : 1, _scaleY);
		  },
		
		
		  /**
		   * Get the cropped area position and size data (base on the original image)
		   *
		   * @param {Boolean} rounded (optional)
		   * @return {Object} data
		   */
		  getData: function getData(rounded) {
		    var self = this;
		    var options = self.options;
		    var imageData = self.imageData;
		    var canvasData = self.canvasData;
		    var cropBoxData = self.cropBoxData;
		    var ratio = void 0;
		    var data = void 0;
		
		    if (self.ready && self.cropped) {
		      data = {
		        x: cropBoxData.left - canvasData.left,
		        y: cropBoxData.top - canvasData.top,
		        width: cropBoxData.width,
		        height: cropBoxData.height
		      };
		
		      ratio = imageData.width / imageData.naturalWidth;
		
		      $.each(data, function (n, i) {
		        n /= ratio;
		        data[i] = rounded ? Math.round(n) : n;
		      });
		    } else {
		      data = {
		        x: 0,
		        y: 0,
		        width: 0,
		        height: 0
		      };
		    }
		
		    if (options.rotatable) {
		      data.rotate = imageData.rotate || 0;
		    }
		
		    if (options.scalable) {
		      data.scaleX = imageData.scaleX || 1;
		      data.scaleY = imageData.scaleY || 1;
		    }
		
		    return data;
		  },
		
		
		  /**
		   * Set the cropped area position and size with new data
		   *
		   * @param {Object} data
		   */
		  setData: function setData(data) {
		    var self = this;
		    var options = self.options;
		    var imageData = self.imageData;
		    var canvasData = self.canvasData;
		    var cropBoxData = {};
		    var rotated = void 0;
		    var scaled = void 0;
		    var ratio = void 0;
		
		    if ($.isFunction(data)) {
		      data = data.call(self.element);
		    }
		
		    if (self.ready && !self.disabled && $.isPlainObject(data)) {
		      if (options.rotatable) {
		        if ($.isNumber(data.rotate) && data.rotate !== imageData.rotate) {
		          imageData.rotate = data.rotate;
		          self.rotated = rotated = true;
		        }
		      }
		
		      if (options.scalable) {
		        if ($.isNumber(data.scaleX) && data.scaleX !== imageData.scaleX) {
		          imageData.scaleX = data.scaleX;
		          scaled = true;
		        }
		
		        if ($.isNumber(data.scaleY) && data.scaleY !== imageData.scaleY) {
		          imageData.scaleY = data.scaleY;
		          scaled = true;
		        }
		      }
		
		      if (rotated) {
		        self.renderCanvas();
		      } else if (scaled) {
		        self.renderImage();
		      }
		
		      ratio = imageData.width / imageData.naturalWidth;
		
		      if ($.isNumber(data.x)) {
		        cropBoxData.left = data.x * ratio + canvasData.left;
		      }
		
		      if ($.isNumber(data.y)) {
		        cropBoxData.top = data.y * ratio + canvasData.top;
		      }
		
		      if ($.isNumber(data.width)) {
		        cropBoxData.width = data.width * ratio;
		      }
		
		      if ($.isNumber(data.height)) {
		        cropBoxData.height = data.height * ratio;
		      }
		
		      self.setCropBoxData(cropBoxData);
		    }
		
		    return self;
		  },
		
		
		  /**
		   * Get the container size data
		   *
		   * @return {Object} data
		   */
		  getContainerData: function getContainerData() {
		    var self = this;
		
		    return self.ready ? self.containerData : {};
		  },
		
		
		  /**
		   * Get the image position and size data
		   *
		   * @return {Object} data
		   */
		  getImageData: function getImageData() {
		    var self = this;
		
		    return self.loaded ? self.imageData : {};
		  },
		
		
		  /**
		   * Get the canvas position and size data
		   *
		   * @return {Object} data
		   */
		  getCanvasData: function getCanvasData() {
		    var self = this;
		    var canvasData = self.canvasData;
		    var data = {};
		
		    if (self.ready) {
		      $.each(['left', 'top', 'width', 'height', 'naturalWidth', 'naturalHeight'], function (n) {
		        data[n] = canvasData[n];
		      });
		    }
		
		    return data;
		  },
		
		
		  /**
		   * Set the canvas position and size with new data
		   *
		   * @param {Object} data
		   */
		  setCanvasData: function setCanvasData(data) {
		    var self = this;
		    var canvasData = self.canvasData;
		    var aspectRatio = canvasData.aspectRatio;
		
		    if ($.isFunction(data)) {
		      data = data.call(self.element);
		    }
		
		    if (self.ready && !self.disabled && $.isPlainObject(data)) {
		      if ($.isNumber(data.left)) {
		        canvasData.left = data.left;
		      }
		
		      if ($.isNumber(data.top)) {
		        canvasData.top = data.top;
		      }
		
		      if ($.isNumber(data.width)) {
		        canvasData.width = data.width;
		        canvasData.height = data.width / aspectRatio;
		      } else if ($.isNumber(data.height)) {
		        canvasData.height = data.height;
		        canvasData.width = data.height * aspectRatio;
		      }
		
		      self.renderCanvas(true);
		    }
		
		    return self;
		  },
		
		
		  /**
		   * Get the crop box position and size data
		   *
		   * @return {Object} data
		   */
		  getCropBoxData: function getCropBoxData() {
		    var self = this;
		    var cropBoxData = self.cropBoxData;
		    var data = void 0;
		
		    if (self.ready && self.cropped) {
		      data = {
		        left: cropBoxData.left,
		        top: cropBoxData.top,
		        width: cropBoxData.width,
		        height: cropBoxData.height
		      };
		    }
		
		    return data || {};
		  },
		
		
		  /**
		   * Set the crop box position and size with new data
		   *
		   * @param {Object} data
		   */
		  setCropBoxData: function setCropBoxData(data) {
		    var self = this;
		    var cropBoxData = self.cropBoxData;
		    var aspectRatio = self.options.aspectRatio;
		    var widthChanged = void 0;
		    var heightChanged = void 0;
		
		    if ($.isFunction(data)) {
		      data = data.call(self.element);
		    }
		
		    if (self.ready && self.cropped && !self.disabled && $.isPlainObject(data)) {
		      if ($.isNumber(data.left)) {
		        cropBoxData.left = data.left;
		      }
		
		      if ($.isNumber(data.top)) {
		        cropBoxData.top = data.top;
		      }
		
		      if ($.isNumber(data.width)) {
		        widthChanged = true;
		        cropBoxData.width = data.width;
		      }
		
		      if ($.isNumber(data.height)) {
		        heightChanged = true;
		        cropBoxData.height = data.height;
		      }
		
		      if (aspectRatio) {
		        if (widthChanged) {
		          cropBoxData.height = cropBoxData.width / aspectRatio;
		        } else if (heightChanged) {
		          cropBoxData.width = cropBoxData.height * aspectRatio;
		        }
		      }
		
		      self.renderCropBox();
		    }
		
		    return self;
		  },
		
		
		  /**
		   * Get a canvas drawn the cropped image
		   *
		   * @param {Object} options (optional)
		   * @return {HTMLCanvasElement} canvas
		   */
		  getCroppedCanvas: function getCroppedCanvas(options) {
		    var self = this;
		
		    if (!self.ready || !window.HTMLCanvasElement) {
		      return null;
		    }
		
		    // Return the whole canvas if not cropped
		    if (!self.cropped) {
		      return $.getSourceCanvas(self.image, self.imageData);
		    }
		
		    if (!$.isPlainObject(options)) {
		      options = {};
		    }
		
		    var data = self.getData();
		    var originalWidth = data.width;
		    var originalHeight = data.height;
		    var aspectRatio = originalWidth / originalHeight;
		    var scaledWidth = void 0;
		    var scaledHeight = void 0;
		    var scaledRatio = void 0;
		
		    if ($.isPlainObject(options)) {
		      scaledWidth = options.width;
		      scaledHeight = options.height;
		
		      if (scaledWidth) {
		        scaledHeight = scaledWidth / aspectRatio;
		        scaledRatio = scaledWidth / originalWidth;
		      } else if (scaledHeight) {
		        scaledWidth = scaledHeight * aspectRatio;
		        scaledRatio = scaledHeight / originalHeight;
		      }
		    }
		
		    // The canvas element will use `Math.floor` on a float number, so floor first
		    var canvasWidth = Math.floor(scaledWidth || originalWidth);
		    var canvasHeight = Math.floor(scaledHeight || originalHeight);
		
		    var canvas = $.createElement('canvas');
		    var context = canvas.getContext('2d');
		
		    canvas.width = canvasWidth;
		    canvas.height = canvasHeight;
		
		    if (options.fillColor) {
		      context.fillStyle = options.fillColor;
		      context.fillRect(0, 0, canvasWidth, canvasHeight);
		    }
		
		    // https://developer.mozilla.org/en-US/docs/Web/API/CanvasRenderingContext2D.drawImage
		    var parameters = function () {
		      var source = $.getSourceCanvas(self.image, self.imageData);
		      var sourceWidth = source.width;
		      var sourceHeight = source.height;
		      var canvasData = self.canvasData;
		      var params = [source];
		
		      // Source canvas
		      var srcX = data.x + canvasData.naturalWidth * (Math.abs(data.scaleX || 1) - 1) / 2;
		      var srcY = data.y + canvasData.naturalHeight * (Math.abs(data.scaleY || 1) - 1) / 2;
		      var srcWidth = void 0;
		      var srcHeight = void 0;
		
		      // Destination canvas
		      var dstX = void 0;
		      var dstY = void 0;
		      var dstWidth = void 0;
		      var dstHeight = void 0;
		
		      if (srcX <= -originalWidth || srcX > sourceWidth) {
		        srcX = srcWidth = dstX = dstWidth = 0;
		      } else if (srcX <= 0) {
		        dstX = -srcX;
		        srcX = 0;
		        srcWidth = dstWidth = Math.min(sourceWidth, originalWidth + srcX);
		      } else if (srcX <= sourceWidth) {
		        dstX = 0;
		        srcWidth = dstWidth = Math.min(originalWidth, sourceWidth - srcX);
		      }
		
		      if (srcWidth <= 0 || srcY <= -originalHeight || srcY > sourceHeight) {
		        srcY = srcHeight = dstY = dstHeight = 0;
		      } else if (srcY <= 0) {
		        dstY = -srcY;
		        srcY = 0;
		        srcHeight = dstHeight = Math.min(sourceHeight, originalHeight + srcY);
		      } else if (srcY <= sourceHeight) {
		        dstY = 0;
		        srcHeight = dstHeight = Math.min(originalHeight, sourceHeight - srcY);
		      }
		
		      params.push(Math.floor(srcX), Math.floor(srcY), Math.floor(srcWidth), Math.floor(srcHeight));
		
		      // Scale destination sizes
		      if (scaledRatio) {
		        dstX *= scaledRatio;
		        dstY *= scaledRatio;
		        dstWidth *= scaledRatio;
		        dstHeight *= scaledRatio;
		      }
		
		      // Avoid "IndexSizeError" in IE and Firefox
		      if (dstWidth > 0 && dstHeight > 0) {
		        params.push(Math.floor(dstX), Math.floor(dstY), Math.floor(dstWidth), Math.floor(dstHeight));
		      }
		
		      return params;
		    }();
		
		    context.drawImage.apply(context, _toConsumableArray(parameters));
		
		    return canvas;
		  },
		
		
		  /**
		   * Change the aspect ratio of the crop box
		   *
		   * @param {Number} aspectRatio
		   */
		  setAspectRatio: function setAspectRatio(aspectRatio) {
		    var self = this;
		    var options = self.options;
		
		    if (!self.disabled && !$.isUndefined(aspectRatio)) {
		      // 0 -> NaN
		      options.aspectRatio = Math.max(0, aspectRatio) || NaN;
		
		      if (self.ready) {
		        self.initCropBox();
		
		        if (self.cropped) {
		          self.renderCropBox();
		        }
		      }
		    }
		
		    return self;
		  },
		
		
		  /**
		   * Change the drag mode
		   *
		   * @param {String} mode (optional)
		   */
		  setDragMode: function setDragMode(mode) {
		    var self = this;
		    var options = self.options;
		    var dragBox = self.dragBox;
		    var face = self.face;
		    var croppable = void 0;
		    var movable = void 0;
		
		    if (self.loaded && !self.disabled) {
		      croppable = mode === 'crop';
		      movable = options.movable && mode === 'move';
		      mode = croppable || movable ? mode : 'none';
		
		      $.setData(dragBox, 'action', mode);
		      $.toggleClass(dragBox, 'cropper-crop', croppable);
		      $.toggleClass(dragBox, 'cropper-move', movable);
		
		      if (!options.cropBoxMovable) {
		        // Sync drag mode to crop box when it is not movable
		        $.setData(face, 'action', mode);
		        $.toggleClass(face, 'cropper-crop', croppable);
		        $.toggleClass(face, 'cropper-move', movable);
		      }
		    }
		
		    return self;
		  }
		};
	
	/***/ }
	/******/ ])
	});
	;
	//# sourceMappingURL=cropper.js.map

/***/ }),
/* 2060 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*
	 * JavaScript Canvas to Blob
	 * https://github.com/blueimp/JavaScript-Canvas-to-Blob
	 *
	 * Copyright 2012, Sebastian Tschan
	 * https://blueimp.net
	 *
	 * Licensed under the MIT license:
	 * http://www.opensource.org/licenses/MIT
	 *
	 * Based on stackoverflow user Stoive's code snippet:
	 * http://stackoverflow.com/q/4998908
	 */
	
	/*global window, atob, Blob, ArrayBuffer, Uint8Array, define, module */
	
	;(function (window) {
	  'use strict'
	
	  var CanvasPrototype = window.HTMLCanvasElement &&
	                          window.HTMLCanvasElement.prototype
	  var hasBlobConstructor = window.Blob && (function () {
	    try {
	      return Boolean(new Blob())
	    } catch (e) {
	      return false
	    }
	  }())
	  var hasArrayBufferViewSupport = hasBlobConstructor && window.Uint8Array &&
	    (function () {
	      try {
	        return new Blob([new Uint8Array(100)]).size === 100
	      } catch (e) {
	        return false
	      }
	    }())
	  var BlobBuilder = window.BlobBuilder || window.WebKitBlobBuilder ||
	                      window.MozBlobBuilder || window.MSBlobBuilder
	  var dataURIPattern = /^data:((.*?)(;charset=.*?)?)(;base64)?,/
	  var dataURLtoBlob = (hasBlobConstructor || BlobBuilder) && window.atob &&
	    window.ArrayBuffer && window.Uint8Array &&
	    function (dataURI) {
	      var matches,
	        mediaType,
	        isBase64,
	        dataString,
	        byteString,
	        arrayBuffer,
	        intArray,
	        i,
	        bb
	      // Parse the dataURI components as per RFC 2397
	      matches = dataURI.match(dataURIPattern)
	      if (!matches) {
	        throw new Error('invalid data URI')
	      }
	      // Default to text/plain;charset=US-ASCII
	      mediaType = matches[2]
	        ? matches[1]
	        : 'text/plain' + (matches[3] || ';charset=US-ASCII')
	      isBase64 = !!matches[4]
	      dataString = dataURI.slice(matches[0].length)
	      if (isBase64) {
	        // Convert base64 to raw binary data held in a string:
	        byteString = atob(dataString)
	      } else {
	        // Convert base64/URLEncoded data component to raw binary:
	        byteString = decodeURIComponent(dataString)
	      }
	      // Write the bytes of the string to an ArrayBuffer:
	      arrayBuffer = new ArrayBuffer(byteString.length)
	      intArray = new Uint8Array(arrayBuffer)
	      for (i = 0; i < byteString.length; i += 1) {
	        intArray[i] = byteString.charCodeAt(i)
	      }
	      // Write the ArrayBuffer (or ArrayBufferView) to a blob:
	      if (hasBlobConstructor) {
	        return new Blob(
	          [hasArrayBufferViewSupport ? intArray : arrayBuffer],
	          {type: mediaType}
	        )
	      }
	      bb = new BlobBuilder()
	      bb.append(arrayBuffer)
	      return bb.getBlob(mediaType)
	    }
	  if (window.HTMLCanvasElement && !CanvasPrototype.toBlob) {
	    if (CanvasPrototype.mozGetAsFile) {
	      CanvasPrototype.toBlob = function (callback, type, quality) {
	        if (quality && CanvasPrototype.toDataURL && dataURLtoBlob) {
	          callback(dataURLtoBlob(this.toDataURL(type, quality)))
	        } else {
	          callback(this.mozGetAsFile('blob', type))
	        }
	      }
	    } else if (CanvasPrototype.toDataURL && dataURLtoBlob) {
	      CanvasPrototype.toBlob = function (callback, type, quality) {
	        callback(dataURLtoBlob(this.toDataURL(type, quality)))
	      }
	    }
	  }
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
	      return dataURLtoBlob
	    }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
	  } else if (typeof module === 'object' && module.exports) {
	    module.exports = dataURLtoBlob
	  } else {
	    window.dataURLtoBlob = dataURLtoBlob
	  }
	}(window))


/***/ }),
/* 2061 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _datetimePicker = __webpack_require__(2062);
	
	var _datetimePicker2 = _interopRequireDefault(_datetimePicker);
	
	var _label = __webpack_require__(1682);
	
	var _label2 = _interopRequireDefault(_label);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	exports.default = function (_ref) {
	  var label = _ref.label;
	  var style = _ref.style;
	
	  var rest = _objectWithoutProperties(_ref, ["label", "style"]);
	
	  return React.createElement(
	    "div",
	    { style: style },
	    React.createElement(
	      _label2.default,
	      { style: { marginBottom: -10 } },
	      label
	    ),
	    React.createElement(_datetimePicker2.default, rest)
	  );
	};
	
	module.exports = exports["default"];

/***/ }),
/* 2062 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.timezoneDelta = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _momentTimezone = __webpack_require__(1185);
	
	var _momentTimezone2 = _interopRequireDefault(_momentTimezone);
	
	var _materialUi = __webpack_require__(576);
	
	var _chronoNode = __webpack_require__(2063);
	
	var _chronoNode2 = _interopRequireDefault(_chronoNode);
	
	var _reactDatepicker = __webpack_require__(2099);
	
	var _reactDatepicker2 = _interopRequireDefault(_reactDatepicker);
	
	__webpack_require__(2103);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var timezoneDelta = exports.timezoneDelta = function timezoneDelta(v, tz) {
	  return _momentTimezone2.default.tz.zone(tz).parse(v.toISOString()) - _momentTimezone2.default.tz.zone(_momentTimezone2.default.tz.guess()).parse(v.toISOString());
	};
	
	var DATE_PICKER_STYLE = {
	  display: "inline-block"
	};
	
	var TIME_PICKER_STYLE = {
	  display: "inline-block",
	  marginLeft: 7
	};
	
	var CLEAR_STYLE = {
	  cursor: "pointer",
	  marginLeft: 7,
	  color: "#ccc",
	  verticalAlign: -6,
	  borderBottom: "1px solid #e0e0e0"
	};
	
	var DateTimePicker = function (_React$Component) {
	  _inherits(DateTimePicker, _React$Component);
	
	  function DateTimePicker(props) {
	    _classCallCheck(this, DateTimePicker);
	
	    return _possibleConstructorReturn(this, Object.getPrototypeOf(DateTimePicker).call(this, props));
	  }
	
	  _createClass(DateTimePicker, [{
	    key: "_coerceToDate",
	    value: function _coerceToDate(v) {
	      if (!v) {
	        return null;
	      }
	      return v instanceof Date ? v : new Date(v);
	    }
	  }, {
	    key: "onChange",
	    value: function onChange(typeChanged, changed) {
	      if (!changed) {
	        return;
	      }
	
	      var newValue = (0, _momentTimezone2.default)(this.props.value ? this._coerceToDate(this.props.value) : (0, _momentTimezone2.default)().startOf("day").toDate());
	
	      if (this.props.timezone) {
	        newValue = (0, _momentTimezone2.default)(newValue || this.props.value).tz(this.props.timezone);
	      } else {
	        newValue = newValue.toDate();
	      }
	
	      if (this.props.timezone) {
	        if (typeChanged === "date") {
	          newValue.year(changed.get("year"));
	          newValue.month(changed.get("month"));
	          newValue.date(changed.get("date"));
	        } else if (typeChanged === "time") {
	          newValue.hour(changed.get("hours"));
	          newValue.minute(changed.get("minutes"));
	        }
	      } else {
	        if (typeChanged === "date") {
	          newValue.setFullYear(changed.get("year"));
	          newValue.setMonth(changed.get("month"));
	          newValue.setDate(changed.get("date"));
	        } else if (typeChanged === "time") {
	          newValue.setHours(changed.get("hours"));
	          newValue.setMinutes(changed.get("minutes"));
	        }
	      }
	
	      if (this.props.timezone) {
	        if (!this.props.useMoment) {
	          newValue = newValue.toDate();
	        }
	      } else if (this.props.useMoment) {
	        newValue = (0, _momentTimezone2.default)(newValue);
	      }
	
	      this.props.onChange(null, newValue);
	    }
	  }, {
	    key: "onChangeRaw",
	    value: function onChangeRaw(typeChanged, v) {
	      // Append timezone to Chrono input if missing to ensure consistent parsing
	      // of timezone with appropriate offset.
	      var tzString = this.props.timezone ? (0, _momentTimezone2.default)(this.props.value).tz(this.props.timezone).format("z") : undefined;
	      if (v.indexOf(tzString) === -1) {
	        v += " " + tzString;
	      }
	
	      var parsed = _chronoNode2.default.parseDate(v, this.props.value);
	      if (parsed) {
	        var d = (0, _momentTimezone2.default)(parsed);
	        if (this.props.timezone) {
	          d = d.tz(this.props.timezone);
	        }
	        this.onChange(typeChanged, d);
	      }
	    }
	  }, {
	    key: "onBlur",
	    value: function onBlur(date, event) {
	      if (this.datePicker) {
	        this.datePicker.setSelected(date, event, false);
	      }
	      if (this.timePicker) {
	        this.timePicker.setSelected(date, event, false);
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var isDifferentTimezone = !!this.props.timezone && _momentTimezone2.default.tz.guess() !== this.props.timezone;
	      var value = this.props.value && (0, _momentTimezone2.default)(this._coerceToDate(this.props.value));
	      if (value && this.props.timezone) {
	        value = value.tz(this.props.timezone);
	      }
	
	      return _react2.default.createElement(
	        "div",
	        { className: "eventive-datepicker__wrapper" },
	        !this.props.hideDate ? _react2.default.createElement(_reactDatepicker2.default, {
	          selected: value,
	          onChange: this.onChange.bind(this, "date"),
	          onChangeRaw: function onChangeRaw(e, v) {
	            return _this2.onChangeRaw("date", v);
	          },
	          onBlur: this.onBlur.bind(this, value),
	          placeholderText: this.props.placeholder,
	          customInput: _react2.default.createElement(_materialUi.TextField, { style: { width: 90 } }),
	          ref: function ref(r) {
	            _this2.datePicker = r;
	          }
	        }) : null,
	        !this.props.hideTime ? _react2.default.createElement(_reactDatepicker2.default, {
	          selected: value,
	          onChange: this.onChange.bind(this, "time"),
	          onChangeRaw: function onChangeRaw(e, v) {
	            return _this2.onChangeRaw("time", v);
	          },
	          onBlur: this.onBlur.bind(this, value),
	          showTimeSelect: true,
	          showTimeSelectOnly: true,
	          timeIntervals: 15,
	          disabledKeyboardNavigation: true,
	          dateFormat: isDifferentTimezone ? "h:mma z" : "h:mma",
	          customInput: _react2.default.createElement(_materialUi.TextField, { style: { width: isDifferentTimezone ? 100 : 70 } }),
	          ref: function ref(r) {
	            _this2.timePicker = r;
	          }
	        }) : null,
	        !this.props.unclearable && _react2.default.createElement(
	          "span",
	          {
	            style: CLEAR_STYLE,
	            onTouchTap: function onTouchTap() {
	              return _this2.props.onChange(null, null);
	            }
	          },
	          "clear"
	        )
	      );
	    }
	  }]);
	
	  return DateTimePicker;
	}(_react2.default.Component);
	
	exports.default = DateTimePicker;

/***/ }),
/* 2063 */
/***/ (function(module, exports, __webpack_require__) {

	
	var options = exports.options = __webpack_require__(2064);
	
	exports.parser = __webpack_require__(2065);
	exports.refiner = __webpack_require__(2091);
	
	exports.Parser = exports.parser.Parser;
	exports.Refiner = exports.refiner.Refiner;
	exports.Filter = exports.refiner.Filter;
	
	exports.ParsedResult = __webpack_require__(2067).ParsedResult;
	exports.ParsedComponents = __webpack_require__(2067).ParsedComponents;
	
	var Chrono = function(option) {
	
	    option = option || exports.options.casualOption();
	
	    this.option = option;
	    this.parsers = new Object(option.parsers);
	    this.refiners = new Object(option.refiners);
	}
	
	
	Chrono.prototype.parse = function(text, refDate, opt) {
	
	    refDate = refDate || new Date();
	    opt = opt || {};
	
	    var allResults = [];
	
	    this.parsers.forEach(function (parser) {
	        var results = parser.execute(text, refDate, opt);
	        allResults = allResults.concat(results);
	    });
	
	    allResults.sort(function(a, b) {
	        return a.index - b.index;
	    });
	    
	    this.refiners.forEach(function (refiner) {
	        allResults = refiner.refine(text, allResults, opt);
	    });
	    
	    return allResults;
	};
	
	
	Chrono.prototype.parseDate = function(text, refDate, opt) {
	    var results = this.parse(text, refDate, opt);
	    if (results.length > 0) {
	        return results[0].start.date();
	    }
	    return null;
	}
	
	exports.Chrono = Chrono;
	exports.strict = new Chrono( options.strictOption() );
	exports.casual = new Chrono( options.casualOption() );
	
	exports.parse = function () {
	    return exports.casual.parse.apply(exports.casual, arguments);
	}
	
	exports.parseDate = function () {
	    return exports.casual.parseDate.apply(exports.casual, arguments);
	}


/***/ }),
/* 2064 */
/***/ (function(module, exports, __webpack_require__) {

	var parser = __webpack_require__(2065);
	var refiner = __webpack_require__(2091);
	
	function baseOption(strictMode) {
	
	    return {
	        parsers: [
	
	            // EN
	            new parser.ENISOFormatParser(strictMode),
	            new parser.ENDeadlineFormatParser(strictMode),
	            new parser.ENMonthNameLittleEndianParser(strictMode),
	            new parser.ENMonthNameMiddleEndianParser(strictMode),
	            new parser.ENMonthNameParser(strictMode),
	            new parser.ENSlashDateFormatParser(strictMode),
	            new parser.ENSlashDateFormatStartWithYearParser(strictMode),
	            new parser.ENSlashMonthFormatParser(strictMode),
	            new parser.ENTimeAgoFormatParser(strictMode),
	            new parser.ENTimeExpressionParser(strictMode),
	
	            // JP
	            new parser.JPStandardParser(strictMode),
	
	            // ES
	            new parser.ESTimeAgoFormatParser(strictMode),
	            new parser.ESDeadlineFormatParser(strictMode),
	            new parser.ESTimeExpressionParser(strictMode),
	            new parser.ESMonthNameLittleEndianParser(strictMode),
	            new parser.ESSlashDateFormatParser(strictMode),
	        ],
	
	        refiners: [
	            // Removing overlaping first
	            new refiner.OverlapRemovalRefiner(),
	
	            // ETC
	            new refiner.ENMergeDateTimeRefiner(),
	            new refiner.ENMergeDateRangeRefiner(),
	            new refiner.JPMergeDateRangeRefiner(),
	
	            // Extract additional info later
	            new refiner.ExtractTimezoneOffsetRefiner(),
	            new refiner.ExtractTimezoneAbbrRefiner(),
	            new refiner.UnlikelyFormatFilter()
	        ]
	    }
	}
	
	
	
	exports.strictOption = function () {
	    return baseOption(true);
	};
	
	
	exports.casualOption = function () {
	
	    var options = baseOption(false);
	
	    // EN
	    options.parsers.unshift(new parser.ENCasualDateParser());
	    options.parsers.unshift(new parser.ENWeekdayParser());
	
	    // JP
	    options.parsers.unshift(new parser.JPCasualDateParser());
	
	    // ES
	    options.parsers.unshift(new parser.ESCasualDateParser());
	    options.parsers.unshift(new parser.ESWeekdayParser());
	
	
	    return options;
	};


/***/ }),
/* 2065 */
/***/ (function(module, exports, __webpack_require__) {

	
	function Parser(strictMode) {
	
	    this.isStrictMode = function() { return (strictMode == true) };
	
	    this.pattern = function() { return /./i; }
	
	    this.extract = function(text, ref, match, opt){ return null; }
	
	    this.execute = function(text, ref, opt) {
	
	        var results = [];
	        var regex = this.pattern();
	
	        var remainingText = text;
	        var match = regex.exec(remainingText);
	
	        while (match) {
	
	            // Calculate match index on the full text;
	            match.index += text.length - remainingText.length;
	
	            var result = this.extract(text, ref, match, opt);
	            if (result) {
	
	                // If success, start from the end of the result
	                remainingText = text.substring(result.index + result.text.length);
	
	                if (!this.isStrictMode() || result.hasPossibleDates()) {
	                    results.push(result);
	                }
	
	            } else {
	                // If fail, move on by 1
	                remainingText = text.substring(match.index + 1);
	            }
	
	            match = regex.exec(remainingText);
	        }
	
	        if (this.refiners) {
	            this.refiners.forEach(function () {
	                results = refiner.refine(results, text, options);
	            });
	        }
	
	        return results;
	    }
	}
	
	exports.Parser = Parser;
	
	exports.ENISOFormatParser = __webpack_require__(2066).Parser;
	exports.ENDeadlineFormatParser = __webpack_require__(2068).Parser;
	exports.ENMonthNameLittleEndianParser = __webpack_require__(2070).Parser;
	exports.ENMonthNameMiddleEndianParser = __webpack_require__(2071).Parser;
	exports.ENMonthNameParser = __webpack_require__(2072).Parser;
	exports.ENSlashDateFormatParser = __webpack_require__(2073).Parser;
	exports.ENSlashDateFormatStartWithYearParser = __webpack_require__(2074).Parser;
	exports.ENSlashMonthFormatParser = __webpack_require__(2075).Parser;
	exports.ENTimeAgoFormatParser = __webpack_require__(2076).Parser;
	exports.ENTimeExpressionParser = __webpack_require__(2077).Parser;
	exports.ENWeekdayParser = __webpack_require__(2078).Parser;
	exports.ENCasualDateParser = __webpack_require__(2079).Parser;
	
	exports.JPStandardParser = __webpack_require__(2080).Parser;
	exports.JPCasualDateParser = __webpack_require__(2082).Parser;
	
	
	exports.ESCasualDateParser = __webpack_require__(2083).Parser;
	exports.ESDeadlineFormatParser = __webpack_require__(2084).Parser;
	exports.ESTimeAgoFormatParser = __webpack_require__(2085).Parser;
	exports.ESTimeExpressionParser = __webpack_require__(2086).Parser;
	exports.ESWeekdayParser = __webpack_require__(2087).Parser;
	exports.ESMonthNameLittleEndianParser = __webpack_require__(2088).Parser;
	exports.ESSlashDateFormatParser = __webpack_require__(2090).Parser;


/***/ }),
/* 2066 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	    ISO 8601
	    http://www.w3.org/TR/NOTE-datetime
	    - YYYY-MM-DD
	    - YYYY-MM-DDThh:mmTZD
	    - YYYY-MM-DDThh:mm:ssTZD
	    - YYYY-MM-DDThh:mm:ss.sTZD 
	    - TZD = (Z or +hh:mm or -hh:mm)
	*/
	var moment = __webpack_require__(1021);
	var Parser = __webpack_require__(2065).Parser;
	var ParsedResult = __webpack_require__(2067).ParsedResult;
	
	var PATTERN = new RegExp('(\\W|^)' 
	            + '([0-9]{4})\\-([0-9]{1,2})\\-([0-9]{1,2})'
	            + '(?:T' //..
	                + '([0-9]{1,2}):([0-9]{1,2})' // hh:mm
	                + '(?::([0-9]{1,2})(?:\\.(\\d{1,4}))?)?' // :ss.s
	                + '(?:Z|([+-]\\d{2}):?(\\d{2})?)?' // TZD (Z or ±hh:mm or ±hhmm or ±hh)
	            + ')?'  //..
	            + '(?=\\W|$)', 'i');
	
	var YEAR_NUMBER_GROUP = 2;
	var MONTH_NUMBER_GROUP = 3;
	var DATE_NUMBER_GROUP  = 4;
	var HOUR_NUMBER_GROUP  = 5;
	var MINUTE_NUMBER_GROUP = 6;
	var SECOND_NUMBER_GROUP = 7;
	var MILLISECOND_NUMBER_GROUP = 8;
	var TZD_HOUR_OFFSET_GROUP = 9;
	var TZD_MINUTE_OFFSET_GROUP = 10;
	
	exports.Parser = function ENISOFormatParser(){
	    Parser.apply(this, arguments);
	    
	    this.pattern = function() { return PATTERN; }
	    
	    this.extract = function(text, ref, match, opt){ 
	        
	        var text = match[0].substr(match[1].length);
	        var index = match.index + match[1].length;
	
	        var result = new ParsedResult({
	            text: text,
	            index: index,
	            ref: ref,
	        })
	        
	        result.start.assign('year', parseInt(match[YEAR_NUMBER_GROUP]));
	        result.start.assign('month', parseInt(match[MONTH_NUMBER_GROUP]));
	        result.start.assign('day', parseInt(match[DATE_NUMBER_GROUP]));
	
	        if (moment(result.start.get('month')) > 12 || moment(result.start.get('month')) < 1 ||
	            moment(result.start.get('day')) > 31 || moment(result.start.get('day')) < 1) {
	            return null;
	        }
	
	        if (match[HOUR_NUMBER_GROUP] != null) {
	            
	            result.start.assign('hour',
	                    parseInt(match[HOUR_NUMBER_GROUP]));
	            result.start.assign('minute',
	                    parseInt(match[MINUTE_NUMBER_GROUP]));
	
	            if (match[SECOND_NUMBER_GROUP] != null) {
	
	                result.start.assign('second',
	                        parseInt(match[SECOND_NUMBER_GROUP]));
	            }
	
	            if (match[MILLISECOND_NUMBER_GROUP] != null) {
	
	                result.start.assign('millisecond',
	                        parseInt(match[MILLISECOND_NUMBER_GROUP]));
	            }
	
	            if (match[TZD_HOUR_OFFSET_GROUP] == null) {
	
	                result.start.assign('timezoneOffset', 0);
	            } else {
	
	                var minuteOffset = 0;
	                var hourOffset = parseInt(match[TZD_HOUR_OFFSET_GROUP]);
	                if (match[TZD_MINUTE_OFFSET_GROUP] != null)
	                    minuteOffset = parseInt(match[TZD_MINUTE_OFFSET_GROUP]);
	
	                var offset = hourOffset * 60;
	                if (offset < 0) {
	                    offset -= minuteOffset;
	                } else {
	                    offset += minuteOffset;
	                }
	
	                result.start.assign('timezoneOffset', offset);
	            }
	        }
	        
	        result.tags['ENISOFormatParser'] = true;
	        return result;
	    };
	
	}
	


/***/ }),
/* 2067 */
/***/ (function(module, exports, __webpack_require__) {

	var moment = __webpack_require__(1021);
	
	function ParsedResult(result){
	    result = result || {};
	
	    this.ref   = result.ref;
	    this.index = result.index;
	    this.text  = result.text;
	    this.tags  = result.tags || {};
	
	    this.start = new ParsedComponents(result.start, result.ref)
	    if(result.end){
	        this.end = new ParsedComponents(result.end, result.ref)
	    }
	}
	
	ParsedResult.prototype.clone = function() {
	    var result = new ParsedResult(this);
	    result.tags = JSON.parse(JSON.stringify(this.tags));
	    result.start = this.start.clone();
	    if (this.end) {
	        result.end = this.end.clone();
	    }
	}
	
	ParsedResult.prototype.hasPossibleDates = function() {
	    return this.start.isPossibleDate() && (!this.end || this.end.isPossibleDate());
	}
	
	
	function ParsedComponents (components, ref){
	
	    this.knownValues = {};
	    this.impliedValues = {};
	
	    if (components) {
	        for (key in components) {
	            this.knownValues[key] = components[key];
	        }
	    }
	
	    if (ref) {
	        ref = moment(ref);
	        this.imply('day', ref.date())
	        this.imply('month', ref.month() + 1)
	        this.imply('year', ref.year())
	    }
	    
	
	    this.imply('hour', 12);
	    this.imply('minute', 0);
	    this.imply('second', 0);
	    this.imply('millisecond', 0);
	}
	
	ParsedComponents.prototype.clone = function () {
	    var component = new ParsedComponents();
	    component.knownValues = JSON.parse(JSON.stringify(this.knownValues));
	    component.impliedValues = JSON.parse(JSON.stringify(this.impliedValues));
	    return component;
	};
	
	ParsedComponents.prototype.get = function(component, value) {
	    if (component in this.knownValues) return this.knownValues[component];
	    if (component in this.impliedValues) return this.impliedValues[component];
	};
	
	ParsedComponents.prototype.assign = function(component, value) {
	    this.knownValues[component] = value;
	    delete this.impliedValues[component];
	};
	
	ParsedComponents.prototype.imply = function(component, value) {
	    if (component in this.knownValues) return;
	    this.impliedValues[component] = value;
	};
	
	ParsedComponents.prototype.isCertain = function(component) {
	    return component in this.knownValues;
	};
	
	ParsedComponents.prototype.isPossibleDate = function() {
	    
	    var dateMoment = this.moment();
	
	    if (dateMoment.get('year') != this.get('year')) return false;
	    if (dateMoment.get('month') != this.get('month')-1) return false;
	    if (dateMoment.get('date') != this.get('day')) return false;
	    if (dateMoment.get('hour') != this.get('hour')) return false;
	    if (dateMoment.get('minute') != this.get('minute')) return false;
	
	    return true;
	}
	
	ParsedComponents.prototype.date = function() {
	    var dateMoment = this.moment();
	    return dateMoment.toDate();
	};
	
	ParsedComponents.prototype.moment = function() {
	    var dateMoment = moment();
	
	    dateMoment.set('year', this.get('year'));
	    dateMoment.set('month', this.get('month')-1);
	    dateMoment.set('date', this.get('day'));
	    dateMoment.set('hour', this.get('hour'));
	    dateMoment.set('minute', this.get('minute'));
	    dateMoment.set('second', this.get('second'));
	    dateMoment.set('millisecond', this.get('millisecond'));
	
	    // Javascript Date Object return minus timezone offset
	    var currentTimezoneOffset = dateMoment.utcOffset();
	    var targetTimezoneOffset = this.isCertain('timezoneOffset') ? 
	        this.get('timezoneOffset') : currentTimezoneOffset;
	
	    var adjustTimezoneOffset = targetTimezoneOffset - currentTimezoneOffset;
	    dateMoment.add(-adjustTimezoneOffset, 'minutes');
	
	    return dateMoment;
	}
	
	
	
	exports.ParsedComponents = ParsedComponents;
	exports.ParsedResult = ParsedResult;


/***/ }),
/* 2068 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	
	
	*/
	
	var moment = __webpack_require__(1021);
	var Parser = __webpack_require__(2065).Parser;
	var ParsedResult = __webpack_require__(2067).ParsedResult;
	var util  = __webpack_require__(2069);
	
	var PATTERN = new RegExp('(\\W|^)' +
	    '(within|in)\\s*' +
	    '('+ util.INTEGER_WORDS_PATTERN + '|[0-9]+|an?(?:\\s*few)?|half(?:\\s*an?)?)\\s*' +
	    '(seconds?|min(?:ute)?s?|hours?|days?|weeks?|months?|years?)\\s*' +
	    '(?=\\W|$)', 'i'
	);
	
	var STRICT_PATTERN = new RegExp('(\\W|^)' +
	    '(within|in)\\s*' +
	    '('+ util.INTEGER_WORDS_PATTERN + '|[0-9]+|an?)\\s*' +
	    '(seconds?|minutes?|hours?|days?)\\s*' +
	    '(?=\\W|$)', 'i'
	);
	
	exports.Parser = function ENDeadlineFormatParser(){
	    Parser.apply(this, arguments);
	
	    this.pattern = function() {
	        return this.isStrictMode()? STRICT_PATTERN : PATTERN;
	    };
	
	    this.extract = function(text, ref, match, opt){
	
	        var index = match.index + match[1].length;
	        var text  = match[0];
	        text  = match[0].substr(match[1].length, match[0].length - match[1].length);
	
	        var result = new ParsedResult({
	            index: index,
	            text: text,
	            ref: ref
	        });
	
	        var num = match[3].toLowerCase();
	        if (util.INTEGER_WORDS[num] !== undefined) {
	            num = util.INTEGER_WORDS[num];
	        } else if (num === 'a' || num === 'an'){
	            num = 1;
	        } else if (num.match(/few/i)){
	            num = 3;
	        } else if (num.match(/half/i)) {
	            num = 0.5;
	        } else {
	            num = parseInt(num);
	        }
	
	        var date = moment(ref);
	        if (match[4].match(/day|week|month|year/i)) {
	
	            if (match[4].match(/day/i)) {
	                date.add(num, 'd');
	            } else if (match[4].match(/week/i)) {
	                date.add(num * 7, 'd');
	            } else if (match[4].match(/month/i)) {
	                date.add(num, 'month');
	            } else if (match[4].match(/year/i)) {
	                date.add(num, 'year');
	            }
	
	            result.start.assign('year', date.year());
	            result.start.assign('month', date.month() + 1);
	            result.start.assign('day', date.date());
	            return result;
	        }
	
	        if (match[4].match(/hour/i)) {
	
	            date.add(num, 'hour');
	
	        } else if (match[4].match(/min/i)) {
	
	            date.add(num, 'minute');
	
	        } else if (match[4].match(/second/i)) {
	
	            date.add(num, 'second');
	        }
	
	        result.start.imply('year', date.year());
	        result.start.imply('month', date.month() + 1);
	        result.start.imply('day', date.date());
	        result.start.assign('hour', date.hour());
	        result.start.assign('minute', date.minute());
	        result.start.assign('second', date.second());
	        result.tags['ENDeadlineFormatParser'] = true;
	        return result;
	    };
	};


/***/ }),
/* 2069 */
/***/ (function(module, exports) {

	exports.WEEKDAY_OFFSET = { 
	    'sunday': 0, 
	    'sun': 0, 
	    'monday': 1, 
	    'mon': 1,
	    'tuesday': 2, 
	    'tue':2, 
	    'wednesday': 3, 
	    'wed': 3, 
	    'thursday': 4, 
	    'thur': 4, 
	    'thu': 4,
	    'friday': 5, 
	    'fri': 5,
	    'saturday': 6, 
	    'sat': 6
	};
	    
	exports.MONTH_OFFSET = { 
	    'january': 1,
	    'jan': 1,
	    'jan.': 1,
	    'february': 2,
	    'feb': 2,
	    'feb.': 2,
	    'march': 3,
	    'mar': 3,
	    'mar.': 3,
	    'april': 4,
	    'apr': 4,
	    'apr.': 4,
	    'may': 5,
	    'june': 6,
	    'jun': 6,
	    'jun.': 6,
	    'july': 7,
	    'jul': 7,
	    'jul.': 7,
	    'august': 8,
	    'aug': 8,
	    'aug.': 8,
	    'september': 9,
	    'sep': 9,
	    'sep.': 9,
	    'sept': 9,
	    'sept.': 9,
	    'october': 10,
	    'oct': 10,
	    'oct.': 10,
	    'november': 11,
	    'nov': 11,
	    'nov.': 11,
	    'december': 12,
	    'dec': 12,
	    'dec.': 12
	};
	
	exports.INTEGER_WORDS_PATTERN = '(?:one|two|three|four|five|six|seven|eight|nine|ten|eleven|twelve)';
	exports.INTEGER_WORDS = {
	    'one' : 1,
	    'two' : 2,
	    'three' : 3,
	    'four' : 4,
	    'five' : 5,
	    'six' : 6,
	    'seven' : 7,
	    'eight' : 8,
	    'nine' : 9,
	    'ten' : 10,
	    'eleven' : 11,
	    'twelve' : 12
	};


/***/ }),
/* 2070 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	    
	    
	*/
	
	var moment = __webpack_require__(1021);
	
	var Parser = __webpack_require__(2065).Parser;
	var ParsedResult = __webpack_require__(2067).ParsedResult;
	var util  = __webpack_require__(2069);
	    
	var PATTERN = new RegExp('(\\W|^)' +
	        '(?:(Sunday|Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|Sun|Mon|Tue|Wed|Thu|Fri|Sat)\\s*,?\\s*)?' + 
	        '([0-9]{1,2})(?:st|nd|rd|th)?' + 
	        '(?:\\s*(?:to|\\-|\\–|until|through|till|\\s)\\s*([0-9]{1,2})(?:st|nd|rd|th)?)?\\s*(?:of)?\\s*' + 
	        '(Jan(?:uary|\\.)?|Feb(?:ruary|\\.)?|Mar(?:ch|\\.)?|Apr(?:il|\\.)?|May|Jun(?:e|\\.)?|Jul(?:y|\\.)?|Aug(?:ust|\\.)?|Sep(?:tember|\\.)?|Oct(?:ober|\\.)?|Nov(?:ember|\\.)?|Dec(?:ember|\\.)?)' +
	        '(?:' +
	            ',?\\s*([0-9]{2,4}(?![^\\s]\\d))' +
	            '(\\s*BE)?' +
	        ')?' +
	        '(?=\\W|$)', 'i'
	    );
	
	var WEEKDAY_GROUP = 2;
	var DATE_GROUP = 3;
	var DATE_TO_GROUP = 4;
	var MONTH_NAME_GROUP = 5;
	var YEAR_GROUP = 6;
	var YEAR_BE_GROUP = 7;
	
	exports.Parser = function ENMonthNameLittleEndianParser(){
	    Parser.apply(this, arguments);
	    
	    this.pattern = function() { return PATTERN; }
	    
	    this.extract = function(text, ref, match, opt){ 
	
	        var result = new ParsedResult({
	            text: match[0].substr(match[1].length, match[0].length - match[1].length),
	            index: match.index + match[1].length,
	            ref: ref,
	        });
	
	        var month = match[MONTH_NAME_GROUP];
	        month = util.MONTH_OFFSET[month.toLowerCase()];
	
	        var day = match[DATE_GROUP];
	        day = parseInt(day);
	
	        var year = null;
	        if (match[YEAR_GROUP]) {
	            year = match[YEAR_GROUP];
	            year = parseInt(year);
	
	            if(match[YEAR_BE_GROUP]){ 
	                //BC
	                year = year - 543;
	
	            } else if (year < 100){ 
	
	                year = year + 2000;
	            }
	        }
	
	        if(year){
	            result.start.assign('day', day);
	            result.start.assign('month', month);
	            result.start.assign('year', year);
	        } else {
	            
	            //Find the most appropriated year
	            var refMoment = moment(ref);
	            refMoment.month(month - 1);
	            refMoment.date(day);
	            refMoment.year(moment(ref).year());
	
	            var nextYear = refMoment.clone().add(1, 'y');
	            var lastYear = refMoment.clone().add(-1, 'y');
	            if( Math.abs(nextYear.diff(moment(ref))) < Math.abs(refMoment.diff(moment(ref))) ){  
	                refMoment = nextYear;
	            }
	            else if( Math.abs(lastYear.diff(moment(ref))) < Math.abs(refMoment.diff(moment(ref))) ){ 
	                refMoment = lastYear;
	            }
	
	            result.start.assign('day', day);
	            result.start.assign('month', month);
	            result.start.imply('year', refMoment.year());
	        }
	        
	        // Weekday component
	        if (match[WEEKDAY_GROUP]) {
	            var weekday = match[WEEKDAY_GROUP];
	            weekday = util.WEEKDAY_OFFSET[weekday.toLowerCase()]
	            result.start.assign('weekday', weekday);
	        }
	
	        // Text can be 'range' value. Such as '12 - 13 January 2012'
	        if (match[DATE_TO_GROUP]) {
	            result.end = result.start.clone();
	            result.end.assign('day', parseInt(match[DATE_TO_GROUP]));
	        }
	
	        result.tags['ENMonthNameLittleEndianParser'] = true;
	        return result;
	    };
	}
	


/***/ }),
/* 2071 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	    
	    The parser for parsing US's date format that begin with month's name.
	    
	    EX. 
	        - January 13
	        - January 13, 2012
	        - January 13 - 15, 2012
	        - Tuesday, January 13, 2012
	
	    Watch out for:
	        - January 12:00
	        - January 12.44
	        - January 1222344
	*/
	
	var moment = __webpack_require__(1021);
	
	var Parser = __webpack_require__(2065).Parser;
	var ParsedResult = __webpack_require__(2067).ParsedResult;
	var util  = __webpack_require__(2069);
	    
	var PATTERN = new RegExp('(\\W|^)' +
	    '(?:' +
	        '(Sunday|Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|Sun\\.?|Mon\\.?|Tue\\.?|Wed\\.?|Thu\\.?|Fri\\.?|Sat\\.?)' + 
	    '\\s*,?\\s*)?' +
	    '(Jan\\.?|January|Feb\\.?|February|Mar\\.?|March|Apr\\.?|April|May\\.?|Jun\\.?|June|Jul\\.?|July|Aug\\.?|August|Sep\\.?|Sept\\.?|September|Oct\\.?|October|Nov\\.?|November|Dec\\.?|December)' + 
	    '\\s*' +
	    '([0-9]{1,2})(?:st|nd|rd|th)?\\s*' + 
	    '(?:' + 
	        '(?:to|\\-)\\s*' + 
	        '([0-9]{1,2})(?:st|nd|rd|th)?\\s*' + 
	    ')?' + 
	    '(?:' +
	        '\\s*,?\\s*([0-9]{4})(\\s*BE)?\\s*' +
	    ')?' + 
	    '(?=\\W|$)(?!\\:\\d)', 'i');
	
	var WEEKDAY_GROUP = 2;
	var MONTH_NAME_GROUP = 3;
	var DATE_GROUP = 4;
	var DATE_TO_GROUP = 5;
	var YEAR_GROUP = 6;
	var YEAR_BE_GROUP = 7;
	
	exports.Parser = function ENMonthNameMiddleEndianParser(){
	    Parser.apply(this, arguments);
	
	    this.pattern = function() { return PATTERN; }
	    
	    this.extract = function(text, ref, match, opt){
	
	        if (text.indexOf('5 May 12:00') >= 0) {
	            console.log(match)
	        }
	
	        var result = new ParsedResult({
	            text: match[0].substr(match[1].length, match[0].length - match[1].length),
	            index: match.index + match[1].length,
	            ref: ref,
	        });
	
	        
	        var month = match[MONTH_NAME_GROUP];
	        month = util.MONTH_OFFSET[month.toLowerCase()];
	
	        var day = match[DATE_GROUP];
	        day = parseInt(day);
	
	        var year = null;
	        if (match[YEAR_GROUP]) {
	            year = match[YEAR_GROUP];
	            year = parseInt(year);
	
	            if(match[YEAR_BE_GROUP]){ 
	                //BC
	                year = year - 543;
	
	            } else if (year < 100){ 
	
	                year = year + 2000;
	            }
	        }
	
	        if(year){
	            result.start.assign('day', day);
	            result.start.assign('month', month);
	            result.start.assign('year', year);
	        } else {
	            
	            //Find the most appropriated year
	            var refMoment = moment(ref);
	            refMoment.month(month - 1);
	            refMoment.date(day);
	
	            var nextYear = refMoment.clone().add(1, 'y');
	            var lastYear = refMoment.clone().add(-1, 'y');
	            if( Math.abs(nextYear.diff(moment(ref))) < Math.abs(refMoment.diff(moment(ref))) ){  
	                refMoment = nextYear;
	            }
	            else if( Math.abs(lastYear.diff(moment(ref))) < Math.abs(refMoment.diff(moment(ref))) ){ 
	                refMoment = lastYear;
	            }
	
	            result.start.assign('day', day);
	            result.start.assign('month', month);
	            result.start.imply('year', refMoment.year());
	        }
	        
	        // Weekday component
	        if (match[WEEKDAY_GROUP]) {
	            var weekday = match[WEEKDAY_GROUP];
	            weekday = util.WEEKDAY_OFFSET[weekday.toLowerCase()]
	            result.start.assign('weekday', weekday);
	        }
	
	        // Text can be 'range' value. Such as 'January 12 - 13, 2012'
	        if (match[DATE_TO_GROUP]) {
	            result.end = result.start.clone();
	            result.end.assign('day', parseInt(match[DATE_TO_GROUP]));
	        }
	
	        result.tags['ENMonthNameMiddleEndianParser'] = true;
	        return result;
	    }
	}
	


/***/ }),
/* 2072 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	    
	    The parser for parsing month name and year.
	    
	    EX. 
	        - January
	        - January 2012
	        - January, 2012
	*/
	
	var moment = __webpack_require__(1021);
	
	var Parser = __webpack_require__(2065).Parser;
	var ParsedResult = __webpack_require__(2067).ParsedResult;
	var util  = __webpack_require__(2069);
	
	var PATTERN = new RegExp('(^|\\D\\s+|[^\\w\\s])' +
	    '(Jan\\.?|January|Feb\\.?|February|Mar\\.?|March|Apr\\.?|April|May\\.?|Jun\\.?|June|Jul\\.?|July|Aug\\.?|August|Sep\\.?|Sept\\.?|September|Oct\\.?|October|Nov\\.?|November|Dec\\.?|December)' + 
	    '\\s*' +
	    '(?:' +
	        ',?\\s*([0-9]{4})(\\s*BE)?' +
	    ')?' +
	    '(?=[^\\s\\w]|$)', 'i');
	
	var MONTH_NAME_GROUP = 2;
	var YEAR_GROUP = 3;
	var YEAR_BE_GROUP = 4;
	
	exports.Parser = function ENMonthNameParser(){
	    Parser.apply(this, arguments);
	
	    this.pattern = function() { return PATTERN; }
	    
	    this.extract = function(text, ref, match, opt){
	        var result = new ParsedResult({
	            text: match[0].substr(match[1].length, match[0].length - match[1].length),
	            index: match.index + match[1].length,
	            ref: ref,
	        });
	
	        
	        var month = match[MONTH_NAME_GROUP];
	        month = util.MONTH_OFFSET[month.toLowerCase()];
	
	        var day = 1;
	
	        var year = null;
	        if (match[YEAR_GROUP]) {
	            year = match[YEAR_GROUP];
	            year = parseInt(year);
	
	            if(match[YEAR_BE_GROUP]){ 
	                //BC
	                year = year - 543;
	
	            } else if (year < 100){ 
	
	                year = year + 2000;
	            }
	        }
	
	        if(year){
	            result.start.imply('day', day);
	            result.start.assign('month', month);
	            result.start.assign('year', year);
	        } else {
	            
	            //Find the most appropriated year
	            var refMoment = moment(ref);
	            refMoment.month(month - 1);
	            refMoment.date(day);
	
	            var nextYear = refMoment.clone().add(1, 'y');
	            var lastYear = refMoment.clone().add(-1, 'y');
	            if( Math.abs(nextYear.diff(moment(ref))) < Math.abs(refMoment.diff(moment(ref))) ){  
	                refMoment = nextYear;
	            }
	            else if( Math.abs(lastYear.diff(moment(ref))) < Math.abs(refMoment.diff(moment(ref))) ){ 
	                refMoment = lastYear;
	            }
	
	            result.start.imply('day', day);
	            result.start.assign('month', month);
	            result.start.imply('year', refMoment.year());
	        }
	
	        result.tags['ENMonthNameParser'] = true;
	        return result;
	    }
	}
	


/***/ }),
/* 2073 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	    Date format with slash "/" (also "-" and ".") between numbers 
	    - Tuesday 11/3/2015
	    - 11/3/2015
	    - 11/3
	*/
	var moment = __webpack_require__(1021);
	var Parser = __webpack_require__(2065).Parser;
	var ParsedResult = __webpack_require__(2067).ParsedResult;
	
	var PATTERN = new RegExp('(\\W|^)' + 
	    '(?:' + 
	        '((?:sun|mon|tues?|wed(?:nes)?|thu(?:rs?)?|fri|sat(?:ur)?)(?:day)?)' +
	        '\\s*\\,?\\s*' +
	    ')?' + 
	    '([0-9]{1,2})[\\/\\.\\-]([0-9]{1,2})' + 
	    '(?:' + 
	        '[\\/\\.\\-]' + 
	        '([0-9]{4}|[0-9]{2})' + 
	    ')?' + 
	    '(\\W|$)', 'i');
	
	var DAYS_OFFSET = { 'sunday': 0, 'sun': 0, 'monday': 1, 'mon': 1,'tuesday': 2, 'wednesday': 3, 'wed': 3,
	    'thursday': 4, 'thur': 4,'friday': 5, 'fri': 5,'saturday': 6, 'sat': 6,}
	
	
	var OPENNING_GROUP = 1;
	var ENDING_GROUP = 6;
	
	var WEEKDAY_GROUP = 2;
	var MONTH_GROUP = 3;
	var DAY_GROUP = 4;
	var YEAR_GROUP = 5;
	
	exports.Parser = function ENSlashDateFormatParser(argument) {
	    Parser.apply(this, arguments);
	
	    this.pattern = function () { return PATTERN; };
	    this.extract = function(text, ref, match, opt){
	        
	        if(match[OPENNING_GROUP] == '/' || match[ENDING_GROUP] == '/') {
	            // Long skip, if there is some overlapping like:
	            // XX[/YY/ZZ]
	            // [XX/YY/]ZZ
	            match.index += match[0].length
	            return;
	        }
	
	        var index = match.index + match[OPENNING_GROUP].length;
	        var text = match[0].substr(match[OPENNING_GROUP].length, match[0].length - match[ENDING_GROUP].length);
	
	
	        var result = new ParsedResult({
	            text: text,
	            index: index,
	            ref: ref,
	        });
	            
	        if(text.match(/^\d\.\d$/)) return;
	        if(text.match(/^\d\.\d{1,2}\.\d{1,2}$/)) return;
	        
	        // MM/dd -> OK
	        // MM.dd -> NG
	        if(!match[YEAR_GROUP] && match[0].indexOf('/') < 0) return;
	
	        var date = null;
	        var year = match[YEAR_GROUP] || moment(ref).year() + '';
	        var month = match[MONTH_GROUP];
	        var day   = match[DAY_GROUP];
	        
	        month = parseInt(month);
	        day  = parseInt(day);
	        year = parseInt(year);
	
	        if(month < 1 || month > 12) {
	            if(month > 12) {
	                // dd/mm/yyyy date format if day looks like a month, and month
	                // looks like a day.
	                if (day >= 1 && day <= 12 && month >= 13 && month <= 31) {
	                    // unambiguous
	                    var tday = month;
	                    month = day;
	                    day = tday;
	                }
	                else {
	                    // both month and day are <= 12
	                    return null;
	                }
	            }
	        }
	        if(day < 1 || day > 31) return null;
	
	        if(year < 100){
	            if (year > 50) {
	                year = year + 1900; 
	            } else {
	                year = year + 2000; 
	            }
	        }
	
	        result.start.assign('day', day);
	        result.start.assign('month', month);
	        result.start.assign('year', year);
	
	        //Day of week
	        if(match[WEEKDAY_GROUP]) {
	            result.start.assign('weekday', DAYS_OFFSET[match[WEEKDAY_GROUP].toLowerCase()]);
	        }
	
	        result.tags['ENSlashDateFormatParser'] = true;
	        return result;
	    };
	};


/***/ }),
/* 2074 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	    Date format with slash "/" between numbers like ENSlashDateFormatParser,
	    but this parser expect year before month and date. 
	    - YYYY/MM/DD
	    - YYYY-MM-DD
	    - YYYY.MM.DD
	*/
	var moment = __webpack_require__(1021);
	var Parser = __webpack_require__(2065).Parser;
	var ParsedResult = __webpack_require__(2067).ParsedResult;
	
	var PATTERN = new RegExp('(\\W|^)' 
	            + '([0-9]{4})[\\-\\.\\/]([0-9]{1,2})[\\-\\.\\/]([0-9]{1,2})'
	            + '(?=\\W|$)', 'i');
	
	var YEAR_NUMBER_GROUP = 2;
	var MONTH_NUMBER_GROUP = 3;
	var DATE_NUMBER_GROUP  = 4;
	
	exports.Parser = function ENSlashDateFormatStartWithYearParser(){
	    Parser.apply(this, arguments);
	    
	    this.pattern = function() { return PATTERN; }
	    
	    this.extract = function(text, ref, match, opt){
	
	        var text = match[0].substr(match[1].length);
	        var index = match.index + match[1].length;
	
	        var result = new ParsedResult({
	            text: text,
	            index: index,
	            ref: ref,
	        })
	        
	        result.start.assign('year', parseInt(match[YEAR_NUMBER_GROUP]));
	        result.start.assign('month', parseInt(match[MONTH_NUMBER_GROUP]));
	        result.start.assign('day', parseInt(match[DATE_NUMBER_GROUP]));
	
	        if (moment(result.start.get('month')) > 12 || moment(result.start.get('month')) < 1 ||
	            moment(result.start.get('day')) > 31 || moment(result.start.get('day')) < 1) {
	            return null;
	        }
	        
	        result.tags['ENDateFormatParser'] = true;
	        return result;
	    };
	}


/***/ }),
/* 2075 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	    Month/Year date format with slash "/" (also "-" and ".") between numbers 
	    - 11/05
	    - 06/2005
	*/
	var moment = __webpack_require__(1021);
	var Parser = __webpack_require__(2065).Parser;
	var ParsedResult = __webpack_require__(2067).ParsedResult;
	
	var PATTERN = new RegExp('(^|[^\\d/]\\s+|[^\\w\\s])' +
	    '([0-9]|0[1-9]|1[012])/([0-9]{4})' + 
	    '([^\\d/]|$)', 'i');
	
	var OPENNING_GROUP = 1;
	var ENDING_GROUP = 4;
	
	var MONTH_GROUP = 2;
	var YEAR_GROUP = 3;
	
	exports.Parser = function ENSlashMonthFormatParser(argument) {
	    Parser.apply(this, arguments);
	
	    this.pattern = function () { return PATTERN; };
	    this.extract = function(text, ref, match, opt){
	        
	        var index = match.index + match[OPENNING_GROUP].length;
	        var text = match[0].substr(match[OPENNING_GROUP].length, match[0].length - (1 + match[ENDING_GROUP].length)).trim();
	
	        var result = new ParsedResult({
	            text: text,
	            index: index,
	            ref: ref,
	        });
	
	        var date = null;
	        var year = match[YEAR_GROUP] ;
	        var month = match[MONTH_GROUP];
	        var day   = 1;
	        
	        month = parseInt(month);
	        year = parseInt(year);
	
	        result.start.imply('day', day);
	        result.start.assign('month', month);
	        result.start.assign('year', year);
	
	        result.tags['ENSlashMonthFormatParser'] = true;
	        return result;
	    };
	};


/***/ }),
/* 2076 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	
	
	*/
	
	var moment = __webpack_require__(1021);
	var Parser = __webpack_require__(2065).Parser;
	var ParsedResult = __webpack_require__(2067).ParsedResult;
	var util  = __webpack_require__(2069);
	
	var PATTERN = new RegExp('' +
	    '(\\W|^)' +
	    '(?:within\\s*)?' +
	    '(' + util.INTEGER_WORDS_PATTERN + '|[0-9]+|an?(?:\\s*few)?|half(?:\\s*an?)?)\\s*' +
	    '(seconds?|min(?:ute)?s?|hours?|weeks?|days?|months?|years?)\\s*' +
	    '(?:ago|before|earlier)(?=(?:\\W|$))', 'i');
	
	var STRICT_PATTERN = new RegExp('' +
	    '(\\W|^)' +
	    '(?:within\\s*)?' +
	    '([0-9]+|an?)\\s*' +
	    '(seconds?|minutes?|hours?|days?)\\s*' +
	    'ago(?=(?:\\W|$))', 'i');
	
	exports.Parser = function ENTimeAgoFormatParser(){
	    Parser.apply(this, arguments);
	
	    this.pattern = function() {
	        return this.isStrictMode()? STRICT_PATTERN : PATTERN;
	    };
	
	    this.extract = function(text, ref, match, opt){
	
	        if (match.index > 0 && text[match.index-1].match(/\w/)) return null;
	
	        var text = match[0];
	        text  = match[0].substr(match[1].length, match[0].length - match[1].length);
	        index = match.index + match[1].length;
	
	        var result = new ParsedResult({
	            index: index,
	            text: text,
	            ref: ref
	        });
	
	        var num = match[2].toLowerCase() ;
	        if (util.INTEGER_WORDS[num] !== undefined) {
	            num = util.INTEGER_WORDS[num];
	        } else if(num === 'a' || num === 'an'){
	            num = 1;
	        } else if (num.match(/few/)) {
	            num = 3;
	        } else if (num.match(/half/)) {
	            num = 0.5;
	        } else {
	            num = parseInt(num);
	        }
	
	        var date = moment(ref);
	
	        if (match[3].match(/hour|min|second/i)) {
	            if (match[3].match(/hour/i)) {
	
	                date.add(-num, 'hour');
	
	            } else if (match[3].match(/min/i)) {
	
	                date.add(-num, 'minute');
	
	            } else if (match[3].match(/second/i)) {
	
	                date.add(-num, 'second');
	            }
	
	            result.start.imply('day', date.date());
	            result.start.imply('month', date.month() + 1);
	            result.start.imply('year', date.year());
	            result.start.assign('hour', date.hour());
	            result.start.assign('minute', date.minute());
	            result.start.assign('second', date.second());
	            result.tags['ENTimeAgoFormatParser'] = true;
	            return result;
	        }
	
	        if (match[3].match(/week/i)) {
	            date.add(-num, 'week');
	
	            result.start.imply('day', date.date());
	            result.start.imply('month', date.month() + 1);
	            result.start.imply('year', date.year());
	            result.start.imply('weekday', date.day());
	            return result;
	        }
	
	        if (match[3].match(/day/i)) {
	            date.add(-num, 'd');
	        }
	
	        if (match[3].match(/month/i)) {
	            date.add(-num, 'month');
	        }
	
	        if (match[3].match(/year/i)) {
	
	            date.add(-num, 'year');
	        }
	
	        result.start.assign('day', date.date());
	        result.start.assign('month', date.month() + 1);
	        result.start.assign('year', date.year());
	        return result;
	
	    };
	}


/***/ }),
/* 2077 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	
	
	*/
	
	var moment = __webpack_require__(1021);
	var Parser = __webpack_require__(2065).Parser;
	var ParsedResult = __webpack_require__(2067).ParsedResult;
	var ParsedComponents = __webpack_require__(2067).ParsedComponents;
	
	var FIRST_REG_PATTERN  = new RegExp("(^|\\s|T)" +
	    "(?:(?:at|from)\\s*)?" + 
	    "(\\d{1,4}|noon|midnight)" + 
	    "(?:" + 
	        "(?:\\.|\\:|\\：)(\\d{1,2})" + 
	        "(?:" + 
	            "(?:\\:|\\：)(\\d{2})" + 
	        ")?" + 
	    ")?" + 
	    "(?:\\s*(A\\.M\\.|P\\.M\\.|AM?|PM?))?" + 
	    "(?=\\W|$)", 'i');
	
	
	var SECOND_REG_PATTERN = new RegExp("^\\s*" + 
	    "(\\-|\\–|\\~|\\〜|to|\\?)\\s*" + 
	    "(\\d{1,4})" +
	    "(?:" + 
	        "(?:\\.|\\:|\\：)(\\d{1,2})" + 
	        "(?:" + 
	            "(?:\\.|\\:|\\：)(\\d{1,2})" + 
	        ")?" + 
	    ")?" + 
	    "(?:\\s*(A\\.M\\.|P\\.M\\.|AM?|PM?))?" + 
	    "(?=\\W|$)", 'i');
	
	var HOUR_GROUP    = 2;
	var MINUTE_GROUP  = 3;
	var SECOND_GROUP  = 4;
	var AM_PM_HOUR_GROUP = 5;
	
	
	exports.Parser = function ENTimeExpressionParser(){
	    Parser.apply(this, arguments);
	
	    this.pattern = function() { return FIRST_REG_PATTERN; }
	    
	    this.extract = function(text, ref, match, opt){ 
	        
	        // This pattern can be overlaped Ex. [12] AM, 1[2] AM
	        if (match.index > 0 && text[match.index-1].match(/\w/)) return null;
	        var refMoment = moment(ref);
	        var result = new ParsedResult();
	        result.ref = ref;
	        result.index = match.index + match[1].length;
	        result.text  = match[0].substring(match[1].length);
	        result.tags['ENTimeExpressionParser'] = true;
	
	        result.start.imply('day',   refMoment.date());
	        result.start.imply('month', refMoment.month()+1);
	        result.start.imply('year',  refMoment.year());
	        
	        var hour = 0;
	        var minute = 0;
	        var meridiem = -1;
	
	        // ----- Second
	        if(match[SECOND_GROUP] != null){ 
	            var second = parseInt(match[SECOND_GROUP]);
	            if(second >= 60) return null;
	
	            result.start.assign('second', second);
	        }
	        
	        // ----- Hours
	        if (match[HOUR_GROUP].toLowerCase() == "noon"){
	            meridiem = 1; 
	            hour = 12;
	        } else if (match[HOUR_GROUP].toLowerCase() == "midnight") {
	            meridiem = 0; 
	            hour = 0;
	        } else {
	            hour = parseInt(match[HOUR_GROUP]);
	        }
	        
	        // ----- Minutes
	        if(match[MINUTE_GROUP] != null){ 
	            minute = parseInt(match[MINUTE_GROUP]);
	        } else if(hour > 100) { 
	            minute = hour%100;
	            hour   = parseInt(hour/100);
	        } 
	        
	        if(minute >= 60) {
	            return null;
	        }
	
	        if(hour > 24) {
	            return null;
	        }
	        if (hour >= 12) { 
	            meridiem = 1;
	        }
	
	        // ----- AM & PM  
	        if(match[AM_PM_HOUR_GROUP] != null) {
	            if(hour > 12) return null;
	            var ampm = match[AM_PM_HOUR_GROUP][0].toLowerCase();
	            if(ampm == "a"){
	                meridiem = 0; 
	                if(hour == 12) hour = 0;
	            }
	            
	            if(ampm == "p"){
	                meridiem = 1; 
	                if(hour != 12) hour += 12;
	            }
	        } 
	
	        result.start.assign('hour', hour);
	        result.start.assign('minute', minute);
	
	        if (meridiem >= 0) {
	            result.start.assign('meridiem', meridiem);
	        } else {
	            if (hour < 12) {
	                result.start.imply('meridiem', 0);
	            } else {
	                result.start.imply('meridiem', 1);
	            }
	        }
	        
	        // ==============================================================
	        //                  Extracting the 'to' chunk
	        // ==============================================================
	        match = SECOND_REG_PATTERN.exec(text.substring(result.index + result.text.length));
	        if (!match) {
	            // Not accept number only result
	            if (result.text.match(/^\d+$/)) { 
	                return null;
	            }
	            return result;
	        }
	
	
	
	        // Pattern "YY.YY -XXXX" is more like timezone offset
	        if (match[0].match(/^\s*(\+|\-)\s*\d{3,4}$/)) {
	            return result;
	        }
	
	        if(result.end == null){
	            result.end = new ParsedComponents(null, result.start.date());
	        }
	
	        var hour = 0;
	        var minute = 0;
	        var meridiem = -1;
	
	        // ----- Second
	        if(match[SECOND_GROUP] != null){ 
	            var second = parseInt(match[SECOND_GROUP]);
	            if(second >= 60) return null;
	
	            result.end.assign('second', second);
	        }
	
	        hour = parseInt(match[2]);
	        
	        // ----- Minute
	        if (match[MINUTE_GROUP]!= null) {
	            
	            minute = parseInt(match[MINUTE_GROUP]);
	            if(minute >= 60) return result;
	            
	        } else if (hour > 100) {
	
	            minute = hour%100;
	            hour   = parseInt(hour/100);
	        }
	
	        if(minute >= 60) {
	            return null;
	        }
	
	        if(hour > 24) {
	            return null;
	        }
	        if (hour >= 12) { 
	            meridiem = 1;
	        }
	        
	        // ----- AM & PM 
	        if (match[AM_PM_HOUR_GROUP] != null){
	
	            if (hour > 12) return null;
	
	            if(match[AM_PM_HOUR_GROUP][0].toLowerCase() == "a"){
	                meridiem = 0; 
	                if(hour == 12) {
	                    hour = 0;
	                    if (!result.end.isCertain('day')) {
	                        result.end.imply('day', result.end.get('day') + 1);
	                    }
	                }
	            }
	            
	            if(match[AM_PM_HOUR_GROUP][0].toLowerCase() == "p"){
	                meridiem = 1; 
	                if(hour != 12) hour += 12;
	            }
	            
	            if (!result.start.isCertain('meridiem')) {
	                if (meridiem == 0) {
	                    
	                    result.start.imply('meridiem', 0);
	                    
	                    if (result.start.get('hour') == 12) {
	                        result.start.assign('hour', 0);
	                    }
	
	                } else {
	
	                    result.start.imply('meridiem', 1);
	                    
	                    if (result.start.get('hour') != 12) {
	                        result.start.assign('hour', result.start.get('hour') + 12); 
	                    }
	                }
	            }
	        }
	
	        result.text = result.text + match[0];
	        result.end.assign('hour', hour);
	        result.end.assign('minute', minute);
	        if (meridiem >= 0) {
	            result.end.assign('meridiem', meridiem);
	        } else {
	            var startAtPM = result.start.isCertain('meridiem') && result.start.get('meridiem') == 1;
	            if (startAtPM && result.start.get('hour') > hour) {
	                // 10pm - 1 (am)
	                result.end.imply('meridiem', 0);
	
	            } else if (hour > 12) {
	                result.end.imply('meridiem', 1);
	            }
	        }
	
	        if (result.end.date().getTime() < result.start.date().getTime()) {
	            result.end.imply('day', result.end.get('day') + 1)
	        }
	        
	        return result;
	    }
	}
	


/***/ }),
/* 2078 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	
	
	*/
	var moment = __webpack_require__(1021);
	var Parser = __webpack_require__(2065).Parser;
	var ParsedResult = __webpack_require__(2067).ParsedResult;
	
	var DAYS_OFFSET = { 'sunday': 0, 'sun': 0, 'monday': 1, 'mon': 1,'tuesday': 2, 'tues':2, 'tue':2, 'wednesday': 3, 'wed': 3,
	    'thursday': 4, 'thurs':4, 'thur': 4, 'thu': 4,'friday': 5, 'fri': 5,'saturday': 6, 'sat': 6};
	
	var PATTERN = new RegExp('(\\W|^)' +
	    '(?:(?:\\,|\\(|\\（)\\s*)?' +
	    '(?:(this|last|next)\\s*)?' +
	    '(' + Object.keys(DAYS_OFFSET).join('|') + ')' +
	    '(?:\\s*(?:\\,|\\)|\\）))?' +
	    '(?:\\s*(this|last|next)\\s*week)?' +
	    '(?=\\W|$)', 'i');
	
	var PREFIX_GROUP = 2;
	var WEEKDAY_GROUP = 3;
	var POSTFIX_GROUP = 4;
	
	exports.Parser = function ENWeekdayParser() {
	    Parser.apply(this, arguments);
	
	    this.pattern = function() { return PATTERN; };
	
	    this.extract = function(text, ref, match, opt){
	        var index = match.index + match[1].length;
	        var text = match[0].substr(match[1].length, match[0].length - match[1].length);
	        var result = new ParsedResult({
	            index: index,
	            text: text,
	            ref: ref,
	        });
	
	        var dayOfWeek = match[WEEKDAY_GROUP].toLowerCase();
	        var offset = DAYS_OFFSET[dayOfWeek];
	        if(offset === undefined) return null;
	
	        var startMoment = moment(ref);
	        var prefix = match[PREFIX_GROUP];
	        var postfix = match[POSTFIX_GROUP];
	
	        if (prefix || postfix) {
	            var norm = prefix || postfix;
	            norm = norm.toLowerCase();
	
	            if(norm == 'last')
	                startMoment.day(offset - 7);
	            else if(norm == 'next')
	                startMoment.day(offset + 7);
	            else if(norm== 'this')
	                startMoment.day(offset);
	        } else{
	            var refOffset = startMoment.day();
	            if ( opt.forwardDatesOnly && refOffset > offset ) {
	              startMoment.day(offset + 7);
	            } else if (!opt.forwardDatesOnly && Math.abs(offset - 7 - refOffset) < Math.abs(offset - refOffset)) {
	              startMoment.day(offset - 7);
	            } else if (!opt.forwardDatesOnly && Math.abs(offset + 7 - refOffset) < Math.abs(offset - refOffset)) {
	              startMoment.day(offset + 7);
	            } else {
	              startMoment.day(offset);
	            }
	        }
	
	        result.start.assign('weekday', offset);
	        result.start.imply('day', startMoment.date());
	        result.start.imply('month', startMoment.month() + 1);
	        result.start.imply('year', startMoment.year());
	        return result;
	    }
	};
	


/***/ }),
/* 2079 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	
	
	*/
	
	var moment = __webpack_require__(1021);
	var Parser = __webpack_require__(2065).Parser;
	var ParsedResult = __webpack_require__(2067).ParsedResult;
	
	var PATTERN = /(\W|^)(now|today|tonight|tomorrow|tmr|yesterday|last\s*night|this\s*(morning|afternoon|evening))(?=\W|$)/i;
	
	exports.Parser = function ENCasualDateParser(){
	
	    Parser.apply(this, arguments);
	
	    this.pattern = function() { return PATTERN; }
	
	    this.extract = function(text, ref, match, opt){
	
	        var text = match[0].substr(match[1].length);
	        var index = match.index + match[1].length;
	        var result = new ParsedResult({
	            index: index,
	            text: text,
	            ref: ref,
	        });
	
	        var refMoment = moment(ref);
	        var startMoment = refMoment.clone();
	        var lowerText = text.toLowerCase();
	
	        if(lowerText == 'tonight'){
	            // Normally means this coming midnight
	            result.start.imply('hour', 22);
	            result.start.imply('meridiem', 1);
	
	        } else if(lowerText == 'tomorrow' || lowerText == 'tmr'){
	
	            // Check not "Tomorrow" on late night
	            if(refMoment.hour() > 1) {
	                startMoment.add(1, 'day');
	            }
	
	        } else if(lowerText == 'yesterday') {
	
	            startMoment.add(-1, 'day');
	        }
	        else if(lowerText.match(/last\s*night/)) {
	
	            result.start.imply('hour', 0);
	            if (refMoment.hour() > 6) {
	                startMoment.add(-1, 'day');
	            }
	
	        } else if (lowerText.match("this")) {
	
	            var secondMatch = match[3].toLowerCase();
	            if (secondMatch == "afternoon") {
	
	                result.start.imply('hour', 15);
	
	            } else if (secondMatch == "evening") {
	
	                result.start.imply('hour', 18);
	
	            } else if (secondMatch == "morning") {
	
	                result.start.imply('hour', 6);
	            }
	
	        } else if (lowerText.match("now")) {
	
	          result.start.imply('hour', refMoment.hour());
	          result.start.imply('minute', refMoment.minute());
	          result.start.imply('second', refMoment.second());
	          result.start.imply('millisecond', refMoment.millisecond());
	
	        }
	
	        result.start.assign('day', startMoment.date())
	        result.start.assign('month', startMoment.month() + 1)
	        result.start.assign('year', startMoment.year())
	        result.tags['ENCasualDateParser'] = true;
	        return result;
	    }
	}


/***/ }),
/* 2080 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	    
	    
	*/
	
	var moment = __webpack_require__(1021);
	
	var Parser = __webpack_require__(2065).Parser;
	var ParsedResult = __webpack_require__(2067).ParsedResult;
	
	var util  = __webpack_require__(2081); 
	var PATTERN = /(?:(同|((昭和|平成)?([0-9０-９]{2,4})))年\s*)?([0-9０-９]{1,2})月\s*([0-9０-９]{1,2})日/i;
	  
	var YEAR_GROUP        = 2;
	var ERA_GROUP         = 3;
	var YEAR_NUMBER_GROUP = 4;
	var MONTH_GROUP       = 5;
	var DAY_GROUP         = 6;
	
	exports.Parser = function JPStandardParser(){
	    Parser.apply(this, arguments);
	    
	    this.pattern = function() { return PATTERN; }
	    
	    this.extract = function(text, ref, match, opt){ 
	
	        var startMoment = moment(ref);
	        var result = new ParsedResult({
	            text: match[0],
	            index: match.index,
	            ref: ref,
	        });
	        
	        var month = match[MONTH_GROUP];
	        month = util.toHankaku(month);
	        month = parseInt(month);
	
	        var day = match[DAY_GROUP];
	        day = util.toHankaku(day);
	        day = parseInt(day);
	
	        startMoment.set('date', day);
	        startMoment.set('month', month - 1);
	        result.start.assign('day', startMoment.date());
	        result.start.assign('month', startMoment.month() + 1);
	            
	        if (!match[YEAR_GROUP]) {
	            
	            //Find the most appropriated year
	            startMoment.year(moment(ref).year());
	            var nextYear = startMoment.clone().add(1, 'y');
	            var lastYear = startMoment.clone().add(-1, 'y');
	            if( Math.abs(nextYear.diff(moment(ref))) < Math.abs(startMoment.diff(moment(ref))) ){  
	                startMoment = nextYear;
	            }
	            else if( Math.abs(lastYear.diff(moment(ref))) < Math.abs(startMoment.diff(moment(ref))) ){ 
	                startMoment = lastYear;
	            }
	
	            result.start.assign('day', startMoment.date());
	            result.start.assign('month', startMoment.month() + 1);
	            result.start.imply('year', startMoment.year());
	
	        } else if (match[YEAR_GROUP].match('同年')) {
	
	            result.start.assign('year', startMoment.year());
	
	        } else {
	            var year = match[YEAR_NUMBER_GROUP];
	            year = util.toHankaku(year);
	            year = parseInt(year);
	
	            if (match[ERA_GROUP] == '平成') {
	                year += 1988;
	            } else if (match[ERA_GROUP] == '昭和') {
	                year += 1925;
	            }
	
	            result.start.assign('year', year);
	        }
	        
	
	        result.tags['JPStandardParser'] = true;
	        return result;
	    };
	
	}
	


/***/ }),
/* 2081 */
/***/ (function(module, exports) {

	
	
	/**
	 * to-hankaku.js
	 * convert to ascii code strings.
	 *
	 * @version 1.0.1
	 * @author think49
	 * @url https://gist.github.com/964592
	 * @license http://www.opensource.org/licenses/mit-license.php (The MIT License)
	 */
	 
	exports.toHankaku = (function (String, fromCharCode) {
	 
	    function toHankaku (string) {
	        return String(string).replace(/\u2019/g, '\u0027').replace(/\u201D/g, '\u0022').replace(/\u3000/g, '\u0020').replace(/\uFFE5/g, '\u00A5').replace(/[\uFF01\uFF03-\uFF06\uFF08\uFF09\uFF0C-\uFF19\uFF1C-\uFF1F\uFF21-\uFF3B\uFF3D\uFF3F\uFF41-\uFF5B\uFF5D\uFF5E]/g, alphaNum);
	    }
	 
	    function alphaNum (token) {
	        return fromCharCode(token.charCodeAt(0) - 65248);
	    }
	 
	    return toHankaku;
	})(String, String.fromCharCode);
	
	/**
	 * to-zenkaku.js
	 * convert to multi byte strings.
	 *
	 * @version 1.0.2
	 * @author think49
	 * @url https://gist.github.com/964592
	 * @license http://www.opensource.org/licenses/mit-license.php (The MIT License)
	 */
	exports.toZenkaku = (function (String, fromCharCode) {
	 
	    function toZenkaku (string) {
	        return String(string).replace(/\u0020/g, '\u3000').replace(/\u0022/g, '\u201D').replace(/\u0027/g, '\u2019').replace(/\u00A5/g, '\uFFE5').replace(/[!#-&(),-9\u003C-?A-[\u005D_a-{}~]/g, alphaNum);
	    }
	 
	    function alphaNum (token) {
	        return fromCharCode(token.charCodeAt(0) + 65248);
	    }
	 
	    return toZenkaku;
	})(String, String.fromCharCode);

/***/ }),
/* 2082 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	    
	    
	*/
	
	var moment = __webpack_require__(1021);
	var Parser = __webpack_require__(2065).Parser;
	var ParsedResult = __webpack_require__(2067).ParsedResult;
	
	var PATTERN = /今日|当日|昨日|明日|今夜|今夕|今晩|今朝/i;
	
	exports.Parser = function JPCasualDateParser(){
	    
	    Parser.apply(this, arguments);
	        
	    this.pattern = function() { return PATTERN; }
	    
	    this.extract = function(text, ref, match, opt){ 
	        
	        var index = match.index;
	        var text = match[0];
	        var result = new ParsedResult({
	            index: index,
	            text: text,
	            ref: ref,
	        });
	
	        var refMoment = moment(ref);
	        var startMoment = refMoment.clone();
	
	        if(text == '今夜' || text == '今夕' || text == '今晩'){
	            // Normally means this coming midnight 
	            result.start.imply('hour', 22);
	            result.start.imply('meridiem', 1);
	
	        } else if(text == '明日'){
	
	            // Check not "Tomorrow" on late night
	            if(refMoment.hour() > 4) {
	                startMoment.add(1, 'day');
	            }
	
	        } else if(text == '昨日') {
	
	            startMoment.add(-1, 'day');
	
	        } else if (text.match("今朝")) {
	
	            result.start.imply('hour', 6);
	            result.start.imply('meridiem', 0);
	        }
	
	        result.start.assign('day', startMoment.date())
	        result.start.assign('month', startMoment.month() + 1)
	        result.start.assign('year', startMoment.year())
	        result.tags['JPCasualDateParser'] = true;
	        return result;
	    }
	}
	


/***/ }),
/* 2083 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	
	
	*/
	
	var moment = __webpack_require__(1021);
	var Parser = __webpack_require__(2065).Parser;
	var ParsedResult = __webpack_require__(2067).ParsedResult;
	
	/*
	  Valid patterns:
	  - esta mañana -> today in the morning
	  - esta tarde -> today in the afternoon/evening
	  - esta noche -> tonight
	  - ayer por la mañana -> yesterday in the morning
	  - ayer por la tarde -> yesterday in the afternoon/evening
	  - ayer por la noche -> yesterday at night
	  - mañana por la mañana -> tomorrow in the morning
	  - mañana por la tarde -> tomorrow in the afternoon/evening
	  - mañana por la noche -> tomorrow at night
	  - anoche -> tomorrow at night
	  - hoy -> today
	  - ayer -> yesterday
	  - mañana -> tomorrow
	 */
	var PATTERN = /(\W|^)(ahora|esta\s*(mañana|tarde|noche)|(ayer|mañana)\s*por\s*la\s*(mañana|tarde|noche)|hoy|mañana|ayer|anoche)(?=\W|$)/i;
	
	exports.Parser = function ESCasualDateParser(){
	
	    Parser.apply(this, arguments);
	
	    this.pattern = function() { return PATTERN; }
	
	    this.extract = function(text, ref, match, opt){
	
	        var text = match[0].substr(match[1].length);
	        var index = match.index + match[1].length;
	        var result = new ParsedResult({
	            index: index,
	            text: text,
	            ref: ref,
	        });
	
	        var refMoment = moment(ref);
	        var startMoment = refMoment.clone();
	        var lowerText = text.toLowerCase().replace(/\s+/g, ' ');
	
	        if(lowerText == 'mañana'){
	
	            // Check not "Tomorrow" on late night
	            if(refMoment.hour() > 1) {
	                startMoment.add(1, 'day');
	            }
	
	        } else if(lowerText == 'ayer') {
	
	            startMoment.add(-1, 'day');
	        }
	        else if(lowerText == 'anoche') {
	
	            result.start.imply('hour', 0);
	            if (refMoment.hour() > 6) {
	                startMoment.add(-1, 'day');
	            }
	
	        } else if (lowerText.match("esta")) {
	
	            var secondMatch = match[3].toLowerCase();
	            if (secondMatch == "tarde") {
	
	                result.start.imply('hour', 18);
	
	            } else if (secondMatch == "mañana") {
	
	                result.start.imply('hour', 6);
	
	            } else if (secondMatch == "noche") {
	
	              // Normally means this coming midnight
	              result.start.imply('hour', 22);
	              result.start.imply('meridiem', 1);
	
	            }
	        } else if (lowerText.match(/por\s*la/)) {
	
	            var firstMatch = match[4].toLowerCase();
	            if (firstMatch === 'ayer') {
	
	              startMoment.add(-1, 'day');
	
	            } else if (firstMatch === 'mañana') {
	
	              startMoment.add(1, 'day');
	
	            }
	
	            var secondMatch = match[5].toLowerCase();
	            if (secondMatch == "tarde") {
	
	                result.start.imply('hour', 18);
	
	            } else if (secondMatch == "mañana") {
	
	                result.start.imply('hour', 9);
	
	            } else if (secondMatch == "noche") {
	
	              // Normally means this coming midnight
	              result.start.imply('hour', 22);
	              result.start.imply('meridiem', 1);
	
	            }
	
	        } else if (lowerText.match("ahora")) {
	
	          result.start.imply('hour', refMoment.hour());
	          result.start.imply('minute', refMoment.minute());
	          result.start.imply('second', refMoment.second());
	          result.start.imply('millisecond', refMoment.millisecond());
	
	        }
	
	        result.start.assign('day', startMoment.date())
	        result.start.assign('month', startMoment.month() + 1)
	        result.start.assign('year', startMoment.year())
	        result.tags['ESCasualDateParser'] = true;
	        return result;
	    }
	}


/***/ }),
/* 2084 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	
	
	*/
	
	var moment = __webpack_require__(1021);
	var Parser = __webpack_require__(2065).Parser;
	var ParsedResult = __webpack_require__(2067).ParsedResult;
	
	var PATTERN = /(\W|^)(dentro\s*de|en)\s*([0-9]+|medi[oa]|una?)\s*(minutos?|horas?|d[ií]as?)\s*(?=(?:\W|$))/i;
	
	exports.Parser = function ESDeadlineFormatParser(){
	    Parser.apply(this, arguments);
	
	    this.pattern = function() { return PATTERN; }
	
	    this.extract = function(text, ref, match, opt){
	
	        var index = match.index + match[1].length;
	        var text  = match[0];
	        text  = match[0].substr(match[1].length, match[0].length - match[1].length);
	
	        var result = new ParsedResult({
	            index: index,
	            text: text,
	            ref: ref,
	        });
	
	        var num = parseInt(match[3]);
	        if (isNaN(num)) {
	          if (match[3].match(/medi/)) {
	            num = 0.5;
	          } else {
	            num = 1;
	          }
	        }
	
	        var date = moment(ref);
	        if (match[4].match(/d[ií]a/)) {
	            date.add(num, 'd');
	
	            result.start.assign('year', date.year());
	            result.start.assign('month', date.month() + 1);
	            result.start.assign('day', date.date());
	            return result;
	        }
	
	
	        if (match[4].match(/hora/)) {
	
	            date.add(num, 'hour');
	
	        } else if (match[4].match(/minuto/)) {
	
	            date.add(num, 'minute');
	        }
	
	        result.start.imply('year', date.year());
	        result.start.imply('month', date.month() + 1);
	        result.start.imply('day', date.date());
	        result.start.assign('hour', date.hour());
	        result.start.assign('minute', date.minute());
	        result.tags['ESDeadlineFormatParser'] = true;
	        return result;
	    };
	}


/***/ }),
/* 2085 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	
	
	*/
	
	var moment = __webpack_require__(1021);
	var Parser = __webpack_require__(2065).Parser;
	var ParsedResult = __webpack_require__(2067).ParsedResult;
	
	var PATTERN = /(\W|^)hace\s*([0-9]+|medi[oa]|una?)\s*(minutos?|horas?|semanas?|d[ií]as?|mes(es)?|años?)(?=(?:\W|$))/i;
	
	exports.Parser = function ESTimeAgoFormatParser(){
	    Parser.apply(this, arguments);
	
	    this.pattern = function() {
	        return PATTERN;
	    }
	
	    this.extract = function(text, ref, match, opt){
	
	        if (match.index > 0 && text[match.index-1].match(/\w/)) return null;
	
	        var text = match[0];
	        text  = match[0].substr(match[1].length, match[0].length - match[1].length);
	        index = match.index + match[1].length;
	
	        var result = new ParsedResult({
	            index: index,
	            text: text,
	            ref: ref,
	        });
	
	        var num = parseInt(match[2]);
	        if (isNaN(num)) {
	          if (match[2].match(/medi/)) {
	            num = 0.5;
	          } else {
	            num = 1;
	          }
	        }
	
	        var date = moment(ref);
	
	        if (match[3].match(/hora/) || match[3].match(/minuto/)) {
	            if (match[3].match(/hora/)) {
	
	                date.add(-num, 'hour');
	
	            } else if (match[3].match(/minuto/)) {
	
	                date.add(-num, 'minute');
	            }
	
	            result.start.imply('day', date.date());
	            result.start.imply('month', date.month() + 1);
	            result.start.imply('year', date.year());
	            result.start.assign('hour', date.hour());
	            result.start.assign('minute', date.minute());
	            result.tags['ESTimeAgoFormatParser'] = true;
	            return result;
	        }
	
	        if (match[3].match(/semana/)) {
	            date.add(-num, 'week');
	
	            result.start.imply('day', date.date());
	            result.start.imply('month', date.month() + 1);
	            result.start.imply('year', date.year());
	            result.start.imply('weekday', date.day());
	            return result;
	        }
	
	        if (match[3].match(/d[ií]a/)) {
	            date.add(-num, 'd');
	        }
	
	        if (match[3].match(/mes/)) {
	            date.add(-num, 'month');
	        }
	
	        if (match[3].match(/año/)) {
	
	            date.add(-num, 'year');
	        }
	
	        result.start.assign('day', date.date());
	        result.start.assign('month', date.month() + 1);
	        result.start.assign('year', date.year());
	        return result;
	
	    };
	}


/***/ }),
/* 2086 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	
	
	*/
	
	var moment = __webpack_require__(1021);
	var Parser = __webpack_require__(2065).Parser;
	var ParsedResult = __webpack_require__(2067).ParsedResult;
	var ParsedComponents = __webpack_require__(2067).ParsedComponents;
	
	var FIRST_REG_PATTERN  = new RegExp("(^|\\s|T)" +
	    "(?:(?:a las?|al?|desde|de)\\s*)?" +
	    "(\\d{1,4}|mediod[ií]a|medianoche)" +
	    "(?:" +
	        "(?:\\.|\\:|\\：)(\\d{1,2})" +
	        "(?:" +
	            "(?:\\:|\\：)(\\d{2})" +
	        ")?" +
	    ")?" +
	    "(?:\\s*(A\\.M\\.|P\\.M\\.|AM?|PM?))?" +
	    "(?=\\W|$)", 'i');
	
	
	var SECOND_REG_PATTERN = new RegExp("^\\s*" +
	    "(\\-|\\–|\\~|\\〜|a(?:\s*las)?|\\?)\\s*" +
	    "(\\d{1,4})" +
	    "(?:" +
	        "(?:\\.|\\:|\\：)(\\d{1,2})" +
	        "(?:" +
	            "(?:\\.|\\:|\\：)(\\d{1,2})" +
	        ")?" +
	    ")?" +
	    "(?:\\s*(A\\.M\\.|P\\.M\\.|AM?|PM?))?" +
	    "(?=\\W|$)", 'i');
	
	var HOUR_GROUP    = 2;
	var MINUTE_GROUP  = 3;
	var SECOND_GROUP  = 4;
	var AM_PM_HOUR_GROUP = 5;
	
	exports.Parser = function ESTimeExpressionParser(){
	    Parser.apply(this, arguments);
	
	    this.pattern = function() { return FIRST_REG_PATTERN; }
	
	    this.extract = function(text, ref, match, opt){
	
	        // This pattern can be overlaped Ex. [12] AM, 1[2] AM
	        if (match.index > 0 && text[match.index-1].match(/\w/)) return null;
	        var refMoment = moment(ref);
	        var result = new ParsedResult();
	        result.ref = ref;
	        result.index = match.index + match[1].length;
	        result.text  = match[0].substring(match[1].length);
	        result.tags['ESTimeExpressionParser'] = true;
	
	        result.start.imply('day',   refMoment.date());
	        result.start.imply('month', refMoment.month()+1);
	        result.start.imply('year',  refMoment.year());
	
	        var hour = 0;
	        var minute = 0;
	        var meridiem = -1;
	
	        // ----- Second
	        if(match[SECOND_GROUP] != null){
	            var second = parseInt(match[SECOND_GROUP]);
	            if(second >= 60) return null;
	
	            result.start.assign('second', second);
	        }
	
	        // ----- Hours
	        if (match[HOUR_GROUP].toLowerCase().match(/mediod/)){
	            meridiem = 1;
	            hour = 12;
	        } else if (match[HOUR_GROUP].toLowerCase() == "medianoche") {
	            meridiem = 0;
	            hour = 0;
	        } else {
	            hour = parseInt(match[HOUR_GROUP]);
	        }
	
	        // ----- Minutes
	        if(match[MINUTE_GROUP] != null){
	            minute = parseInt(match[MINUTE_GROUP]);
	        } else if(hour > 100) {
	            minute = hour%100;
	            hour   = parseInt(hour/100);
	        }
	
	        if(minute >= 60) {
	            return null;
	        }
	
	        if(hour > 24) {
	            return null;
	        }
	        if (hour >= 12) {
	            meridiem = 1;
	        }
	
	        // ----- AM & PM
	        if(match[AM_PM_HOUR_GROUP] != null) {
	            if(hour > 12) return null;
	            var ampm = match[AM_PM_HOUR_GROUP][0].toLowerCase();
	            if(ampm == "a"){
	                meridiem = 0;
	                if(hour == 12) hour = 0;
	            }
	
	            if(ampm == "p"){
	                meridiem = 1;
	                if(hour != 12) hour += 12;
	            }
	        }
	        result.start.assign('hour', hour);
	        result.start.assign('minute', minute);
	        if (meridiem >= 0) {
	            result.start.assign('meridiem', meridiem);
	        }
	
	        // ==============================================================
	        //                  Extracting the 'to' chunk
	        // ==============================================================
	        match = SECOND_REG_PATTERN.exec(text.substring(result.index + result.text.length));
	        if (!match) {
	            // Not accept number only result
	            if (result.text.match(/^\d+$/)) {
	                return null;
	            }
	            return result;
	        }
	
	
	
	        // Pattern "YY.YY -XXXX" is more like timezone offset
	        if (match[0].match(/^\s*(\+|\-)\s*\d{3,4}$/)) {
	            return result;
	        }
	
	        if(result.end == null){
	            result.end = new ParsedComponents(null, result.start.date());
	        }
	
	        var hour = 0;
	        var minute = 0;
	        var meridiem = -1;
	
	        // ----- Second
	        if(match[SECOND_GROUP] != null){
	            var second = parseInt(match[SECOND_GROUP]);
	            if(second >= 60) return null;
	
	            result.end.assign('second', second);
	        }
	
	        hour = parseInt(match[2]);
	
	        // ----- Minute
	        if (match[MINUTE_GROUP]!= null) {
	
	            minute = parseInt(match[MINUTE_GROUP]);
	            if(minute >= 60) return result;
	
	        } else if (hour > 100) {
	
	            minute = hour%100;
	            hour   = parseInt(hour/100);
	        }
	
	        if(minute >= 60) {
	            return null;
	        }
	
	        if(hour > 24) {
	            return null;
	        }
	        if (hour >= 12) {
	            meridiem = 1;
	        }
	
	        // ----- AM & PM
	        if (match[AM_PM_HOUR_GROUP] != null){
	
	            if (hour > 12) return null;
	
	            if(match[AM_PM_HOUR_GROUP][0].toLowerCase() == "a"){
	                meridiem = 0;
	                if(hour == 12) {
	                    hour = 0;
	                    if (!result.end.isCertain('day')) {
	                        result.end.imply('day', result.end.get('day') + 1);
	                    }
	                }
	            }
	
	            if(match[AM_PM_HOUR_GROUP][0].toLowerCase() == "p"){
	                meridiem = 1;
	                if(hour != 12) hour += 12;
	            }
	
	            if (!result.start.isCertain('meridiem')) {
	                if (meridiem == 0) {
	
	                    result.start.imply('meridiem', 0);
	
	                    if (result.start.get('hour') == 12) {
	                        result.start.assign('hour', 0);
	                    }
	
	                } else {
	
	                    result.start.imply('meridiem', 1);
	
	                    if (result.start.get('hour') != 12) {
	                        result.start.assign('hour', result.start.get('hour') + 12);
	                    }
	                }
	            }
	
	        } else if(hour >= 12) {
	            meridiem = 1;
	        }
	
	        result.text = result.text + match[0];
	        result.end.assign('hour', hour);
	        result.end.assign('minute', minute);
	        if (meridiem >= 0) {
	            result.end.assign('meridiem', meridiem);
	        }
	
	        if (result.end.date().getTime() < result.start.date().getTime()) {
	            result.end.imply('day', result.end.get('day') + 1)
	        }
	
	        return result;
	    }
	}


/***/ }),
/* 2087 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	
	
	*/
	var moment = __webpack_require__(1021);
	var Parser = __webpack_require__(2065).Parser;
	var ParsedResult = __webpack_require__(2067).ParsedResult;
	
	var DAYS_OFFSET = { 'domingo': 0, 'dom': 0, 'lunes': 1, 'lun': 1, 'martes': 2, 'mar':2, 'miercoles': 3, 'miércoles': 3, 'mie': 3,
	    'jueves': 4, 'jue': 4, 'viernes': 5, 'vier': 5, 'sabado': 6, 'sábado': 6, 'sab': 6,}
	
	var PATTERN = new RegExp('(\\W|^)' +
	    '(?:(?:\\,|\\(|\\（)\\s*)?' +
	    '(?:(este|pasado|pr[oó]ximo)\\s*)?' +
	    '(' + Object.keys(DAYS_OFFSET).join('|') + ')' +
	    '(?:\\s*(?:\\,|\\)|\\）))?' +
	    '(?:\\s*(este|pasado|pr[óo]ximo)\\s*week)?' +
	    '(?=\\W|$)', 'i');
	
	var PREFIX_GROUP = 2;
	var WEEKDAY_GROUP = 3;
	var POSTFIX_GROUP = 4;
	
	exports.Parser = function ESWeekdayParser() {
	    Parser.apply(this, arguments);
	
	    this.pattern = function() { return PATTERN; }
	
	    this.extract = function(text, ref, match, opt){
	        var index = match.index + match[1].length;
	        var text = match[0].substr(match[1].length, match[0].length - match[1].length);
	        var result = new ParsedResult({
	            index: index,
	            text: text,
	            ref: ref,
	        });
	
	        var dayOfWeek = match[WEEKDAY_GROUP].toLowerCase();
	        var offset = DAYS_OFFSET[dayOfWeek];
	        if(offset === undefined) return null;
	
	        var startMoment = moment(ref);
	        var prefix = match[PREFIX_GROUP];
	        var postfix = match[POSTFIX_GROUP];
	
	        if (prefix || postfix) {
	            var norm = prefix || postfix;
	            norm = norm.toLowerCase();
	
	            if(norm == 'pasado')
	                startMoment.day(offset - 7)
	            else if(norm == 'próximo' || norm == 'proximo')
	                startMoment.day(offset + 7)
	            else if(norm== 'este')
	                startMoment.day(offset);
	        } else{
	            var refOffset = startMoment.day();
	            if ( opt.forwardDatesOnly && refOffset > offset ) {
	              startMoment.day(offset + 7);
	            } else if (!opt.forwardDatesOnly && Math.abs(offset - 7 - refOffset) < Math.abs(offset - refOffset)) {
	              startMoment.day(offset - 7);
	            } else if (!opt.forwardDatesOnly && Math.abs(offset + 7 - refOffset) < Math.abs(offset - refOffset)) {
	              startMoment.day(offset + 7);
	            } else {
	              startMoment.day(offset);
	            }
	        }
	
	        result.start.assign('weekday', offset);
	        result.start.imply('day', startMoment.date())
	        result.start.imply('month', startMoment.month() + 1)
	        result.start.imply('year', startMoment.year())
	        return result;
	    }
	}


/***/ }),
/* 2088 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	
	
	*/
	
	var moment = __webpack_require__(1021);
	
	var Parser = __webpack_require__(2065).Parser;
	var ParsedResult = __webpack_require__(2067).ParsedResult;
	
	var util  = __webpack_require__(2089);
	
	var DAYS_OFFSET = util.WEEKDAY_OFFSET;
	
	var PATTERN = new RegExp('(\\W|^)' +
	        '(?:(Domingo|Lunes|Martes|Miércoles|Miercoles|Jueves|Viernes|Sábado|Sabado|Dom|Lun|Mar|Mie|Jue|Vie|Sab)\\s*,?\\s*)?' +
	        '([0-9]{1,2})(?:º|ª|°)?' +
	        '(?:\\s*(?:desde|de|\\-|\\–|al?|hasta|\\s)\\s*([0-9]{1,2})(?:º|ª|°)?)?\\s*(?:de)?\\s*' +
	        '(Ene(?:ro|\\.)?|Feb(?:rero|\\.)?|Mar(?:zo|\\.)?|Abr(?:il|\\.)?|May(?:o|\\.)?|Jun(?:io|\\.)?|Jul(?:io|\\.)?|Ago(?:sto|\\.)?|Sep(?:tiembre|\\.)?|Oct(?:ubre|\\.)?|Nov(?:iembre|\\.)?|Dic(?:iembre|\\.)?)' +
	        '(?:\\s*(?:del?)?(\\s*[0-9]{2,4}(?![^\\s]\\d))(\\s*AC)?)?' +
	        '(?=\\W|$)', 'i'
	    );
	
	var WEEKDAY_GROUP = 2;
	var DATE_GROUP = 3;
	var DATE_TO_GROUP = 4;
	var MONTH_NAME_GROUP = 5;
	var YEAR_GROUP = 6;
	var YEAR_BE_GROUP = 7;
	
	exports.Parser = function ESMonthNameLittleEndianParser(){
	    Parser.apply(this, arguments);
	
	    this.pattern = function() { return PATTERN; }
	
	    this.extract = function(text, ref, match, opt){
	
	        var result = new ParsedResult({
	            text: match[0].substr(match[1].length, match[0].length - match[1].length),
	            index: match.index + match[1].length,
	            ref: ref,
	        });
	
	        var month = match[MONTH_NAME_GROUP];
	        month = util.MONTH_OFFSET[month.toLowerCase()];
	
	        var day = match[DATE_GROUP];
	        day = parseInt(day);
	
	        var year = null;
	        if (match[YEAR_GROUP]) {
	            year = match[YEAR_GROUP];
	            year = parseInt(year);
	
	            if(match[YEAR_BE_GROUP]){
	                //BC
	                year = year - 543;
	
	            } else if (year < 100){
	
	                year = year + 2000;
	            }
	        }
	
	        if(year){
	            result.start.assign('day', day);
	            result.start.assign('month', month);
	            result.start.assign('year', year);
	        } else {
	
	            //Find the most appropriated year
	            var refMoment = moment(ref);
	            refMoment.month(month - 1);
	            refMoment.date(day);
	            refMoment.year(moment(ref).year());
	
	            var nextYear = refMoment.clone().add(1, 'y');
	            var lastYear = refMoment.clone().add(-1, 'y');
	            if( Math.abs(nextYear.diff(moment(ref))) < Math.abs(refMoment.diff(moment(ref))) ){
	                refMoment = nextYear;
	            }
	            else if( Math.abs(lastYear.diff(moment(ref))) < Math.abs(refMoment.diff(moment(ref))) ){
	                refMoment = lastYear;
	            }
	
	            result.start.assign('day', day);
	            result.start.assign('month', month);
	            result.start.imply('year', refMoment.year());
	        }
	
	        // Weekday component
	        if (match[WEEKDAY_GROUP]) {
	            var weekday = match[WEEKDAY_GROUP];
	            weekday = util.WEEKDAY_OFFSET[weekday.toLowerCase()]
	            result.start.assign('weekday', weekday);
	        }
	
	        // Text can be 'range' value. Such as '12 - 13 January 2012'
	        if (match[DATE_TO_GROUP]) {
	            result.end = result.start.clone();
	            result.end.assign('day', parseInt(match[DATE_TO_GROUP]));
	        }
	
	        result.tags['ESMonthNameLittleEndianParser'] = true;
	        return result;
	    };
	}


/***/ }),
/* 2089 */
/***/ (function(module, exports) {

	exports.WEEKDAY_OFFSET = {
	    'domingo': 0,
	    'dom': 0,
	    'lunes': 1,
	    'lun': 1,
	    'martes': 2,
	    'mar':2,
	    'miércoles': 3,
	    'miercoles': 3,
	    'mie': 3,
	    'jueves': 4,
	    'jue': 4,
	    'viernes': 5,
	    'vie': 5,
	    'sábado': 6,
	    'sabado': 6,
	    'sab': 6,}
	
	exports.MONTH_OFFSET = {
	    'enero': 1,
	    'ene': 1,
	    'ene.': 1,
	    'febrero': 2,
	    'feb': 2,
	    'feb.': 2,
	    'marzo': 3,
	    'mar': 3,
	    'mar.': 3,
	    'abril': 4,
	    'abr': 4,
	    'abr.': 4,
	    'mayo': 5,
	    'may': 5,
	    'may.': 5,
	    'junio': 6,
	    'jun': 6,
	    'jun.': 6,
	    'julio': 7,
	    'jul': 7,
	    'jul.': 7,
	    'agosto': 8,
	    'ago': 8,
	    'ago.': 8,
	    'septiembre': 9,
	    'sep': 9,
	    'sept': 9,
	    'sep.': 9,
	    'sept.': 9,
	    'octubre': 10,
	    'oct': 10,
	    'oct.': 10,
	    'noviembre': 11,
	    'nov': 11,
	    'nov.': 11,
	    'diciembre': 12,
	    'dic': 12,
	    'dic.': 12,
	}


/***/ }),
/* 2090 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	    Date format with slash "/" (also "-" and ".") between numbers
	    - Martes 3/11/2015
	    - 3/11/2015
	    - 3/11
	*/
	var moment = __webpack_require__(1021);
	var Parser = __webpack_require__(2065).Parser;
	var ParsedResult = __webpack_require__(2067).ParsedResult;
	
	var PATTERN = new RegExp('(\\W|^)' +
	    '(?:' +
	        '((?:domingo|dom|lunes|lun|martes|mar|mi[ée]rcoles|mie|jueves|jue|viernes|vie|s[áa]bado|sab))' +
	        '\\s*\\,?\\s*' +
	    ')?' +
	    '([0-9]{1,2})[\\/\\.\\-]([0-9]{1,2})' +
	    '(?:' +
	        '[\\/\\.\\-]' +
	        '([0-9]{4}|[0-9]{2})' +
	    ')?' +
	    '(\\W|$)', 'i');
	
	var DAYS_OFFSET = { 'domingo': 0, 'dom': 0, 'lunes': 1, 'lun': 1, 'martes': 2, 'mar': 2, 'miercoles': 3, 'miércoles': 3, 'mie': 3,
	    'jueves': 4, 'jue': 4, 'viernes': 5, 'vier': 5, 'sábado': 6, 'sabado': 6, 'sab': 6,}
	
	
	var OPENNING_GROUP = 1;
	var ENDING_GROUP = 6;
	
	// in Spanish we use day/month/year
	var WEEKDAY_GROUP = 2;
	var MONTH_GROUP = 4;
	var DAY_GROUP = 3;
	var YEAR_GROUP = 5;
	
	exports.Parser = function ESSlashDateFormatParser(argument) {
	    Parser.apply(this, arguments);
	
	    this.pattern = function () { return PATTERN; };
	    this.extract = function(text, ref, match, opt){
	
	        if(match[OPENNING_GROUP] == '/' || match[ENDING_GROUP] == '/') {
	            // Long skip, if there is some overlapping like:
	            // XX[/YY/ZZ]
	            // [XX/YY/]ZZ
	            match.index += match[0].length
	            return;
	        }
	
	        var index = match.index + match[OPENNING_GROUP].length;
	        var text = match[0].substr(match[OPENNING_GROUP].length, match[0].length - match[ENDING_GROUP].length);
	
	
	        var result = new ParsedResult({
	            text: text,
	            index: index,
	            ref: ref,
	        });
	
	        if(text.match(/^\d\.\d$/)) return;
	        if(text.match(/^\d\.\d{1,2}\.\d{1,2}$/)) return;
	
	        // MM/dd -> OK
	        // MM.dd -> NG
	        if(!match[YEAR_GROUP] && match[0].indexOf('/') < 0) return;
	
	        var date = null;
	        var year = match[YEAR_GROUP] || moment(ref).year() + '';
	        var month = match[MONTH_GROUP];
	        var day   = match[DAY_GROUP];
	
	        month = parseInt(month);
	        day  = parseInt(day);
	        year = parseInt(year);
	
	        if(month < 1 || month > 12) {
	            if(month > 12) {
	                // dd/mm/yyyy date format if day looks like a month, and month
	                // looks like a day.
	                if (day >= 1 && day <= 12 && month >= 13 && month <= 31) {
	                    // unambiguous
	                    var tday = month;
	                    month = day;
	                    day = tday;
	                }
	                else {
	                    // both month and day are <= 12
	                    return null;
	                }
	            }
	        }
	        if(day < 1 || day > 31) return null;
	
	        if(year < 100){
	            if(year > 50){
	                year = year + 2500 - 543; //BE
	            }else{
	                year = year + 2000; //AD
	            }
	        }
	
	        result.start.assign('day', day);
	        result.start.assign('month', month);
	        result.start.assign('year', year);
	
	        //Day of week
	        if(match[WEEKDAY_GROUP]) {
	            result.start.assign('weekday', DAYS_OFFSET[match[WEEKDAY_GROUP].toLowerCase()]);
	        }
	
	        result.tags['ESSlashDateFormatParser'] = true;
	        return result;
	    };
	};


/***/ }),
/* 2091 */
/***/ (function(module, exports, __webpack_require__) {

	
	exports.Refiner = function Refiner() { 
	
	    this.refine = function(text, results, opt) { return results; };
	}
	
	exports.Filter = function Filter() { 
	    
	    exports.Refiner.call(this);
	
	    this.isValid = function(text, result, opt) { return true; }
	    this.refine = function(text, results, opt) { 
	
	        var filteredResult = [];
	        for (var i=0; i < results.length; i++) {
	
	            var result = results[i];
	            if (this.isValid(text, result, opt)) {
	                filteredResult.push(result);
	            }
	        }
	
	        return filteredResult;
	    }
	}
	
	
	// Common refiners
	exports.OverlapRemovalRefiner = __webpack_require__(2092).Refiner;
	exports.ExtractTimezoneOffsetRefiner = __webpack_require__(2093).Refiner;
	exports.ExtractTimezoneAbbrRefiner = __webpack_require__(2094).Refiner;
	exports.UnlikelyFormatFilter = __webpack_require__(2095).Refiner;
	
	// EN refiners
	exports.ENMergeDateTimeRefiner = __webpack_require__(2096).Refiner;
	exports.ENMergeDateRangeRefiner = __webpack_require__(2097).Refiner;
	
	// JP refiners
	exports.JPMergeDateRangeRefiner = __webpack_require__(2098).Refiner;
	


/***/ }),
/* 2092 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	  
	*/
	var Refiner = __webpack_require__(2091).Refiner;
	
	exports.Refiner = function OverlapRemovalRefiner() {
		Refiner.call(this);
		
	
		this.refine = function(text, results, opt) { 
	
	        if (results.length < 2) return results;
	        
	        var filteredResults = [];
	        var prevResult = results[0];
	        
	        for (var i=1; i<results.length; i++){
	            
	            var result = results[i];
	            
	            // If overlap, compare the length and discard the shorter one
	            if (result.index < prevResult.index + prevResult.text.length) {
	
	                if (result.text.length > prevResult.text.length){
	                    prevResult = result;
	                }
	                
	            } else {
	                filteredResults.push(prevResult);
	                prevResult = result;
	            }
	        }
	        
	        // The last one
	        if (prevResult != null) {
	            filteredResults.push(prevResult);
	        }
	
	        return filteredResults;
	    }
	}

/***/ }),
/* 2093 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	  
	*/
	var Refiner = __webpack_require__(2091).Refiner;
	
	
	var TIMEZONE_OFFSET_PATTERN = new RegExp("^\\s*(GMT|UTC)?(\\+|\\-)(\\d{1,2}):?(\\d{2})", 'i');
	var TIMEZONE_OFFSET_SIGN_GROUP = 2;
	var TIMEZONE_OFFSET_HOUR_OFFSET_GROUP = 3;
	var TIMEZONE_OFFSET_MINUTE_OFFSET_GROUP = 4;
	
	exports.Refiner = function ExtractTimezoneOffsetRefiner() {
	    Refiner.call(this);
	
	    this.refine = function(text, results, opt) {
	
	        results.forEach(function(result) {
	
	            if (result.start.isCertain('timezoneOffset')) {
	                return;
	            }
	
	            var match = TIMEZONE_OFFSET_PATTERN.exec(text.substring(result.index + result.text.length));
	            if (!match) {
	                return;
	            }
	
	            var hourOffset = parseInt(match[TIMEZONE_OFFSET_HOUR_OFFSET_GROUP]);
	            var minuteOffset = parseInt(match[TIMEZONE_OFFSET_MINUTE_OFFSET_GROUP]);
	            var timezoneOffset = hourOffset * 60 + minuteOffset;
	            if (match[TIMEZONE_OFFSET_SIGN_GROUP] === '-') {
	                timezoneOffset = -timezoneOffset;
	            }
	
	            if (result.end != null) {
	                result.end.assign('timezoneOffset', timezoneOffset);
	            }
	
	            result.start.assign('timezoneOffset', timezoneOffset);
	            result.text += match[0];
	            result.tags['ExtractTimezoneOffsetRefiner'] = true;
	        });
	
	        return results;
	    }
	}


/***/ }),
/* 2094 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	  
	*/
	var Refiner = __webpack_require__(2091).Refiner;
	
	// Map ABBR -> Offset in minute
	var TIMEZONE_ABBR_MAP = {};
	var TIMEZONE_NAME_PATTERN = new RegExp("^\\s*\\(?([A-Z]{2,4})\\)?(?=\\W|$)", 'i');
	
	exports.Refiner = function ExtractTimezoneAbbrRefiner() {
		Refiner.call(this);
	
		this.refine = function(text, results, opt) {
	
			results.forEach(function(result) {
	
	            if (!result.tags['ENTimeExpressionParser']) {
	                return;
	            }
	
	            var match = TIMEZONE_NAME_PATTERN.exec(text.substring(result.index + result.text.length));
	            if (match) {
	                var timezoneAbbr = match[1].toUpperCase();
	                if (TIMEZONE_ABBR_MAP[timezoneAbbr] === undefined) {
	                    return;
	                }
	
	                var timezoneOffset = TIMEZONE_ABBR_MAP[timezoneAbbr];
	                if (!result.start.isCertain('timezoneOffset')) {
	                    result.start.assign('timezoneOffset', timezoneOffset);
	                }
	
	                if (result.end != null && !result.end.isCertain('timezoneOffset')) {
	                    result.end.assign('timezoneOffset', timezoneOffset);
	                }
	
	                result.text += match[0];
	                result.tags['ExtractTimezoneAbbrRefiner'] = true;
	            }
			});
	
	        return results;
		}
	}
	
	// TODO: Move this to some configuration
	TIMEZONE_ABBR_MAP = {"ACDT":630,"ACST":570,"ADT":-180,"AEDT":660,"AEST":600,"AFT":270,"AKDT":-480,"AKST":-540,"ALMT":360,"AMST":-180,"AMT":-240,"ANAST":720,"ANAT":720,"AQTT":300,"ART":-180,"AST":-240,"AWDT":540,"AWST":480,"AZOST":0,"AZOT":-60,"AZST":300,"AZT":240,"BNT":480,"BOT":-240,"BRST":-120,"BRT":-180,"BST":60,"BTT":360,"CAST":480,"CAT":120,"CCT":390,"CDT":-300,"CEST":120,"CET":60,"CHADT":825,"CHAST":765,"CKT":-600,"CLST":-180,"CLT":-240,"COT":-300,"CST":-360,"CVT":-60,"CXT":420,"ChST":600,"DAVT":420,"EASST":-300,"EAST":-360,"EAT":180,"ECT":-300,"EDT":-240,"EEST":180,"EET":120,"EGST":0,"EGT":-60,"EST":-300,"ET":-300,"FJST":780,"FJT":720,"FKST":-180,"FKT":-240,"FNT":-120,"GALT":-360,"GAMT":-540,"GET":240,"GFT":-180,"GILT":720,"GMT":0,"GST":240,"GYT":-240,"HAA":-180,"HAC":-300,"HADT":-540,"HAE":-240,"HAP":-420,"HAR":-360,"HAST":-600,"HAT":-90,"HAY":-480,"HKT":480,"HLV":-210,"HNA":-240,"HNC":-360,"HNE":-300,"HNP":-480,"HNR":-420,"HNT":-150,"HNY":-540,"HOVT":420,"ICT":420,"IDT":180,"IOT":360,"IRDT":270,"IRKST":540,"IRKT":540,"IRST":210,"IST":60,"JST":540,"KGT":360,"KRAST":480,"KRAT":480,"KST":540,"KUYT":240,"LHDT":660,"LHST":630,"LINT":840,"MAGST":720,"MAGT":720,"MART":-510,"MAWT":300,"MDT":-360,"MESZ":120,"MEZ":60,"MHT":720,"MMT":390,"MSD":240,"MSK":240,"MST":-420,"MUT":240,"MVT":300,"MYT":480,"NCT":660,"NDT":-90,"NFT":690,"NOVST":420,"NOVT":360,"NPT":345,"NST":-150,"NUT":-660,"NZDT":780,"NZST":720,"OMSST":420,"OMST":420,"PDT":-420,"PET":-300,"PETST":720,"PETT":720,"PGT":600,"PHOT":780,"PHT":480,"PKT":300,"PMDT":-120,"PMST":-180,"PONT":660,"PST":-480,"PT":-480,"PWT":540,"PYST":-180,"PYT":-240,"RET":240,"SAMT":240,"SAST":120,"SBT":660,"SCT":240,"SGT":480,"SRT":-180,"SST":-660,"TAHT":-600,"TFT":300,"TJT":300,"TKT":780,"TLT":540,"TMT":300,"TVT":720,"ULAT":480,"UTC":0,"UYST":-120,"UYT":-180,"UZT":300,"VET":-210,"VLAST":660,"VLAT":660,"VUT":660,"WAST":120,"WAT":60,"WEST":60,"WESZ":60,"WET":0,"WEZ":0,"WFT":720,"WGST":-120,"WGT":-180,"WIB":420,"WIT":540,"WITA":480,"WST":780,"WT":0,"YAKST":600,"YAKT":600,"YAPT":600,"YEKST":360,"YEKT":360}

/***/ }),
/* 2095 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	  
	*/
	var Filter = __webpack_require__(2091).Filter;
	
	exports.Refiner = function UnlikelyFormatFilter() {
	    Filter.call(this);
	    
	
	    this.isValid = function(text, result, opt) { 
	
	        if (result.text.replace(' ','').match(/^\d*(\.\d*)?$/)) {
	            return false;
	        }
	
	        return true; 
	    }
	}

/***/ }),
/* 2096 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	    
	*/
	var ParsedComponents = __webpack_require__(2067).ParsedComponents;
	var Refiner = __webpack_require__(2091).Refiner;
	
	
	
	var PATTERN = new RegExp("^\\s*(T|at|on|of|,|-)?\\s*$");
	
	function isDateOnly(result) {
	    return !result.start.isCertain('hour');
	}
	    
	function isTimeOnly(result) {
	    return !result.start.isCertain('month') && !result.start.isCertain('weekday');
	}
	
	
	function isAbleToMerge(text, prevResult, curResult) {
	    var textBetween = text.substring(prevResult.index + prevResult.text.length, curResult.index);
	    return textBetween.match(PATTERN);
	}
	
	function mergeResult(text, dateResult, timeResult){
	
	    var beginDate = dateResult.start;
	    var beginTime = timeResult.start;
	        
	    var beginDateTime = beginDate.clone();
	    beginDateTime.assign('hour', beginTime.get('hour'));
	    beginDateTime.assign('minute', beginTime.get('minute'));
	    beginDateTime.assign('second', beginTime.get('second'));
	        
	    if (beginTime.isCertain('meridiem')) {
	        beginDateTime.assign('meridiem', beginTime.get('meridiem'));
	    } else if (
	        beginTime.get('meridiem') !== undefined &&
	        beginDateTime.get('meridiem') === undefined
	    ) {
	        beginDateTime.imply('meridiem', beginTime.get('meridiem'));
	    }
	
	    if (beginDateTime.get('meridiem') == 1 && beginDateTime.get('hour') < 12) {
	        beginDateTime.assign('hour', beginDateTime.get('hour') + 12);
	    }
	
	    if (dateResult.end != null || timeResult.end != null) {
	        
	        var endDate   = dateResult.end == null ? dateResult.start : dateResult.end;            
	        var endTime   = timeResult.end == null ? timeResult.start : timeResult.end;
	
	        var endDateTime = endDate.clone();
	        endDateTime.assign('hour', endTime.get('hour'));
	        endDateTime.assign('minute', endTime.get('minute'));
	        endDateTime.assign('second', endTime.get('second'));
	        
	        if (endTime.isCertain('meridiem')) {
	            endDateTime.assign('meridiem', endTime.get('meridiem'));
	        } else if (beginTime.get('meridiem') != null) {
	            endDateTime.imply('meridiem', endTime.get('meridiem'));
	        }
	        
	        if (dateResult.end == null && endDateTime.date().getTime() < beginDateTime.date().getTime()) {
	            // Ex. 9pm - 1am
	            if (endDateTime.isCertain('day')) {
	                endDateTime.assign('day', endDateTime.get('day') + 1);
	            } else {
	                endDateTime.imply('day', endDateTime.get('day') + 1);
	            }
	        }
	
	        dateResult.end = endDateTime;
	    }
	
	    dateResult.start = beginDateTime;    
	
	    var startIndex = Math.min(dateResult.index, timeResult.index);
	    var endIndex = Math.max(
	            dateResult.index + dateResult.text.length, 
	            timeResult.index + timeResult.text.length);
	    
	    dateResult.index = startIndex;
	    dateResult.text  = text.substring(startIndex, endIndex);
	
	    for (var tag in timeResult.tags) {
	        dateResult.tags[tag] = true;
	    }
	    dateResult.tags['ENMergeDateAndTimeRefiner'] = true;
	    return dateResult;
	}
	
	exports.Refiner = function ENMergeDateTimeRefiner() {
	    Refiner.call(this);
	
	
	    this.refine = function(text, results, opt) { 
	
	        if (results.length < 2) return results;
	
	        var mergedResult = [];
	        var currResult = null;
	        var prevResult = null;
	
	        for (var i = 1; i < results.length; i++) {
	
	            currResult = results[i];
	            prevResult = results[i-1];
	            
	            if (isDateOnly(prevResult) && isTimeOnly(currResult) 
	                    && isAbleToMerge(text, prevResult, currResult)) {
	                
	                prevResult = mergeResult(text, prevResult, currResult);
	                currResult = null;
	                i += 1;
	                
	            } else if (isDateOnly(currResult) && isTimeOnly(prevResult)
	                    && isAbleToMerge(text, prevResult, currResult)) {
	                
	                prevResult = mergeResult(text, currResult, prevResult);
	                currResult = null;
	                i += 1;
	            }
	            
	            mergedResult.push(prevResult);
	        }
	
	        if (currResult != null) {
	            mergedResult.push(currResult);
	        }
	
	        return mergedResult;
	    }
	}

/***/ }),
/* 2097 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	  
	*/
	var Refiner = __webpack_require__(2091).Refiner;
	
	exports.Refiner = function ENMergeDateRangeRefiner() {
	    Refiner.call(this);
	
	    this.pattern = function () { return /^\s*(to|\-)\s*$/i };
	
	    this.refine = function(text, results, opt) {
	
	        if (results.length < 2) return results;
	        
	        var mergedResult = [];
	        var currResult = null;
	        var prevResult = null;
	        
	        for (var i=1; i<results.length; i++){
	            
	            currResult = results[i];
	            prevResult = results[i-1];
	            
	            if (!prevResult.end && !currResult.end 
	                && this.isAbleToMerge(text, prevResult, currResult)) {
	              
	                prevResult = this.mergeResult(text, prevResult, currResult);
	                currResult = null;
	                i += 1;
	            }
	            
	            mergedResult.push(prevResult);
	        }
	        
	        if (currResult != null) {
	            mergedResult.push(currResult);
	        }
	
	
	        return mergedResult;
	    };
	
	    this.isAbleToMerge = function(text, result1, result2) {
	        var begin = result1.index + result1.text.length;
	        var end   = result2.index;
	        var textBetween = text.substring(begin,end);
	
	        return textBetween.match(this.pattern());
	    };
	
	    this.isWeekdayResult = function (result) {
	        return result.start.isCertain('weekday') && !result.start.isCertain('day');
	    };
	
	    this.mergeResult = function(text, fromResult, toResult) {
	
	        if (!this.isWeekdayResult(fromResult) && !this.isWeekdayResult(toResult)) {
	
	            for (var key in toResult.start.knownValues) {
	                if (!fromResult.start.isCertain(key)) {
	                    fromResult.start.assign(key, toResult.start.get(key));
	                }
	            }
	
	            for (var key in fromResult.start.knownValues) {
	                if (!toResult.start.isCertain(key)) {
	                    toResult.start.assign(key, fromResult.start.get(key));
	                }
	            }
	        }
	
	        if (fromResult.start.date().getTime() > toResult.start.date()) {
	            var tmp = toResult;
	            toResult = fromResult;
	            fromResult = tmp;
	        }
	        
	        fromResult.end = toResult.start;
	
	        
	
	        for (var tag in toResult.tags) {
	            fromResult.tags[tag] = true;
	        }
	
	            
	        var startIndex = Math.min(fromResult.index, toResult.index);
	        var endIndex = Math.max(
	            fromResult.index + fromResult.text.length, 
	            toResult.index + toResult.text.length);
	            
	        fromResult.index = startIndex;
	        fromResult.text  = text.substring(startIndex, endIndex);
	        fromResult.tags[this.constructor.name] = true;
	        return fromResult;
	    }
	};
	


/***/ }),
/* 2098 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	  
	*/
	var ENMergeDateRangeRefiner = __webpack_require__(2097).Refiner;
	
	exports.Refiner = function JPMergeDateRangeRefiner() {
	    ENMergeDateRangeRefiner.call(this);
	
	    this.pattern = function () { return /^\s*(から|ー)\s*$/i };
	}
	


/***/ }),
/* 2099 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var React = _interopDefault(__webpack_require__(300));
	var PropTypes = _interopDefault(__webpack_require__(956));
	var classnames = _interopDefault(__webpack_require__(958));
	var onClickOutside = _interopDefault(__webpack_require__(2100));
	var moment = _interopDefault(__webpack_require__(1021));
	var reactPopper = __webpack_require__(2101);
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
	  return typeof obj;
	} : function (obj) {
	  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
	};
	
	
	
	
	
	
	
	
	
	var classCallCheck = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};
	
	var createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }
	
	  return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) defineProperties(Constructor, staticProps);
	    return Constructor;
	  };
	}();
	
	
	
	
	
	
	
	
	
	var inherits = function (subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	  }
	
	  subClass.prototype = Object.create(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      enumerable: false,
	      writable: true,
	      configurable: true
	    }
	  });
	  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	};
	
	
	
	
	
	
	
	
	
	
	
	var possibleConstructorReturn = function (self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }
	
	  return call && (typeof call === "object" || typeof call === "function") ? call : self;
	};
	
	function generateYears(year, noOfYear, minDate, maxDate) {
	  var list = [];
	  for (var i = 0; i < 2 * noOfYear + 1; i++) {
	    var newYear = year + noOfYear - i;
	    var isInRange = true;
	
	    if (minDate) {
	      isInRange = minDate.year() <= newYear;
	    }
	
	    if (maxDate && isInRange) {
	      isInRange = maxDate.year() >= newYear;
	    }
	
	    if (isInRange) {
	      list.push(newYear);
	    }
	  }
	
	  return list;
	}
	
	var YearDropdownOptions = function (_React$Component) {
	  inherits(YearDropdownOptions, _React$Component);
	
	  function YearDropdownOptions(props) {
	    classCallCheck(this, YearDropdownOptions);
	
	    var _this = possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.renderOptions = function () {
	      var selectedYear = _this.props.year;
	      var options = _this.state.yearsList.map(function (year) {
	        return React.createElement(
	          "div",
	          {
	            className: selectedYear === year ? "react-datepicker__year-option --selected_year" : "react-datepicker__year-option",
	            key: year,
	            ref: year,
	            onClick: _this.onChange.bind(_this, year)
	          },
	          selectedYear === year ? React.createElement(
	            "span",
	            { className: "react-datepicker__year-option--selected" },
	            "\u2713"
	          ) : "",
	          year
	        );
	      });
	
	      var minYear = _this.props.minDate ? _this.props.minDate.year() : null;
	      var maxYear = _this.props.maxDate ? _this.props.maxDate.year() : null;
	
	      if (!maxYear || !_this.state.yearsList.find(function (year) {
	        return year === maxYear;
	      })) {
	        options.unshift(React.createElement(
	          "div",
	          {
	            className: "react-datepicker__year-option",
	            ref: "upcoming",
	            key: "upcoming",
	            onClick: _this.incrementYears
	          },
	          React.createElement("a", { className: "react-datepicker__navigation react-datepicker__navigation--years react-datepicker__navigation--years-upcoming" })
	        ));
	      }
	
	      if (!minYear || !_this.state.yearsList.find(function (year) {
	        return year === minYear;
	      })) {
	        options.push(React.createElement(
	          "div",
	          {
	            className: "react-datepicker__year-option",
	            ref: "previous",
	            key: "previous",
	            onClick: _this.decrementYears
	          },
	          React.createElement("a", { className: "react-datepicker__navigation react-datepicker__navigation--years react-datepicker__navigation--years-previous" })
	        ));
	      }
	
	      return options;
	    };
	
	    _this.onChange = function (year) {
	      _this.props.onChange(year);
	    };
	
	    _this.handleClickOutside = function () {
	      _this.props.onCancel();
	    };
	
	    _this.shiftYears = function (amount) {
	      var years = _this.state.yearsList.map(function (year) {
	        return year + amount;
	      });
	
	      _this.setState({
	        yearsList: years
	      });
	    };
	
	    _this.incrementYears = function () {
	      return _this.shiftYears(1);
	    };
	
	    _this.decrementYears = function () {
	      return _this.shiftYears(-1);
	    };
	
	    var yearDropdownItemNumber = props.yearDropdownItemNumber,
	        scrollableYearDropdown = props.scrollableYearDropdown;
	
	    var noOfYear = yearDropdownItemNumber || (scrollableYearDropdown ? 10 : 5);
	
	    _this.state = {
	      yearsList: generateYears(_this.props.year, noOfYear, _this.props.minDate, _this.props.maxDate)
	    };
	    return _this;
	  }
	
	  YearDropdownOptions.prototype.render = function render() {
	    var dropdownClass = classnames({
	      "react-datepicker__year-dropdown": true,
	      "react-datepicker__year-dropdown--scrollable": this.props.scrollableYearDropdown
	    });
	
	    return React.createElement(
	      "div",
	      { className: dropdownClass },
	      this.renderOptions()
	    );
	  };
	
	  return YearDropdownOptions;
	}(React.Component);
	
	YearDropdownOptions.propTypes = {
	  minDate: PropTypes.object,
	  maxDate: PropTypes.object,
	  onCancel: PropTypes.func.isRequired,
	  onChange: PropTypes.func.isRequired,
	  scrollableYearDropdown: PropTypes.bool,
	  year: PropTypes.number.isRequired,
	  yearDropdownItemNumber: PropTypes.number
	};
	
	var dayOfWeekCodes = {
	  1: "mon",
	  2: "tue",
	  3: "wed",
	  4: "thu",
	  5: "fri",
	  6: "sat",
	  7: "sun"
	};
	
	// These functions are not exported so
	// that we avoid magic strings like 'days'
	function set$1(date, unit, to) {
	  return date.set(unit, to);
	}
	
	function add(date, amount, unit) {
	  return date.add(amount, unit);
	}
	
	function subtract(date, amount, unit) {
	  return date.subtract(amount, unit);
	}
	
	function get$1(date, unit) {
	  return date.get(unit);
	}
	
	function getStartOf(date, unit) {
	  return date.startOf(unit);
	}
	
	// ** Date Constructors **
	
	function newDate(point) {
	  return moment(point);
	}
	
	function newDateWithOffset(utcOffset) {
	  return moment().utc().utcOffset(utcOffset);
	}
	
	function now(maybeFixedUtcOffset) {
	  if (maybeFixedUtcOffset == null) {
	    return newDate();
	  }
	  return newDateWithOffset(maybeFixedUtcOffset);
	}
	
	function cloneDate(date) {
	  return date.clone();
	}
	
	function parseDate(value, _ref) {
	  var dateFormat = _ref.dateFormat,
	      locale = _ref.locale;
	
	  var m = moment(value, dateFormat, locale || moment.locale(), true);
	  return m.isValid() ? m : null;
	}
	
	// ** Date "Reflection" **
	
	function isMoment(date) {
	  return moment.isMoment(date);
	}
	
	function isDate(date) {
	  return moment.isDate(date);
	}
	
	// ** Date Formatting **
	
	function formatDate(date, format) {
	  return date.format(format);
	}
	
	function safeDateFormat(date, _ref2) {
	  var dateFormat = _ref2.dateFormat,
	      locale = _ref2.locale;
	
	  return date && date.clone().locale(locale || moment.locale()).format(Array.isArray(dateFormat) ? dateFormat[0] : dateFormat) || "";
	}
	
	// ** Date Setters **
	
	function setTime(date, _ref3) {
	  var hour = _ref3.hour,
	      minute = _ref3.minute,
	      second = _ref3.second;
	
	  date.set({ hour: hour, minute: minute, second: second });
	  return date;
	}
	
	function setMonth(date, month) {
	  return set$1(date, "month", month);
	}
	
	function setYear(date, year) {
	  return set$1(date, "year", year);
	}
	
	
	
	// ** Date Getters **
	
	function getSecond(date) {
	  return get$1(date, "second");
	}
	
	function getMinute(date) {
	  return get$1(date, "minute");
	}
	
	function getHour(date) {
	  return get$1(date, "hour");
	}
	
	// Returns day of week
	function getDay(date) {
	  return get$1(date, "day");
	}
	
	function getWeek(date) {
	  return get$1(date, "week");
	}
	
	function getMonth(date) {
	  return get$1(date, "month");
	}
	
	function getYear(date) {
	  return get$1(date, "year");
	}
	
	// Returns day of month
	function getDate(date) {
	  return get$1(date, "date");
	}
	
	
	
	function getDayOfWeekCode(day) {
	  return dayOfWeekCodes[day.isoWeekday()];
	}
	
	// *** Start of ***
	
	function getStartOfDay(date) {
	  return getStartOf(date, "day");
	}
	
	function getStartOfWeek(date) {
	  return getStartOf(date, "week");
	}
	function getStartOfMonth(date) {
	  return getStartOf(date, "month");
	}
	
	function getStartOfDate(date) {
	  return getStartOf(date, "date");
	}
	
	// *** End of ***
	
	
	
	
	
	// ** Date Math **
	
	// *** Addition ***
	
	function addMinutes(date, amount) {
	  return add(date, amount, "minutes");
	}
	
	function addHours(date, amount) {
	  return add(date, amount, "hours");
	}
	
	function addDays(date, amount) {
	  return add(date, amount, "days");
	}
	
	function addWeeks(date, amount) {
	  return add(date, amount, "weeks");
	}
	
	function addMonths(date, amount) {
	  return add(date, amount, "months");
	}
	
	function addYears(date, amount) {
	  return add(date, amount, "years");
	}
	
	// *** Subtraction ***
	function subtractDays(date, amount) {
	  return subtract(date, amount, "days");
	}
	
	function subtractWeeks(date, amount) {
	  return subtract(date, amount, "weeks");
	}
	
	function subtractMonths(date, amount) {
	  return subtract(date, amount, "months");
	}
	
	function subtractYears(date, amount) {
	  return subtract(date, amount, "years");
	}
	
	// ** Date Comparison **
	
	function isBefore(date1, date2) {
	  return date1.isBefore(date2);
	}
	
	function isAfter(date1, date2) {
	  return date1.isAfter(date2);
	}
	
	
	
	function isSameYear(date1, date2) {
	  if (date1 && date2) {
	    return date1.isSame(date2, "year");
	  } else {
	    return !date1 && !date2;
	  }
	}
	
	function isSameMonth(date1, date2) {
	  if (date1 && date2) {
	    return date1.isSame(date2, "month");
	  } else {
	    return !date1 && !date2;
	  }
	}
	
	function isSameDay(moment1, moment2) {
	  if (moment1 && moment2) {
	    return moment1.isSame(moment2, "day");
	  } else {
	    return !moment1 && !moment2;
	  }
	}
	
	
	
	function isDayInRange(day, startDate, endDate) {
	  var before = startDate.clone().startOf("day").subtract(1, "seconds");
	  var after = endDate.clone().startOf("day").add(1, "seconds");
	  return day.clone().startOf("day").isBetween(before, after);
	}
	
	// *** Diffing ***
	
	
	
	// ** Date Localization **
	
	function localizeDate(date, locale) {
	  return date.clone().locale(locale || moment.locale());
	}
	
	
	
	
	
	
	
	function getLocaleData(date) {
	  return date.localeData();
	}
	
	function getLocaleDataForLocale(locale) {
	  return moment.localeData(locale);
	}
	
	function getWeekdayMinInLocale(locale, date) {
	  return locale.weekdaysMin(date);
	}
	
	function getWeekdayShortInLocale(locale, date) {
	  return locale.weekdaysShort(date);
	}
	
	// TODO what is this format exactly?
	function getMonthInLocale(locale, date, format) {
	  return locale.months(date, format);
	}
	
	function getMonthShortInLocale(locale, date) {
	  return locale.monthsShort(date);
	}
	
	// ** Utils for some components **
	
	function isDayDisabled(day) {
	  var _ref4 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	      minDate = _ref4.minDate,
	      maxDate = _ref4.maxDate,
	      excludeDates = _ref4.excludeDates,
	      includeDates = _ref4.includeDates,
	      filterDate = _ref4.filterDate;
	
	  return minDate && day.isBefore(minDate, "day") || maxDate && day.isAfter(maxDate, "day") || excludeDates && excludeDates.some(function (excludeDate) {
	    return isSameDay(day, excludeDate);
	  }) || includeDates && !includeDates.some(function (includeDate) {
	    return isSameDay(day, includeDate);
	  }) || filterDate && !filterDate(day.clone()) || false;
	}
	
	function isTimeDisabled(time, disabledTimes) {
	  var l = disabledTimes.length;
	  for (var i = 0; i < l; i++) {
	    if (disabledTimes[i].get("hours") === time.get("hours") && disabledTimes[i].get("minutes") === time.get("minutes")) {
	      return true;
	    }
	  }
	
	  return false;
	}
	
	function isTimeInDisabledRange(time, _ref5) {
	  var minTime = _ref5.minTime,
	      maxTime = _ref5.maxTime;
	
	  if (!minTime || !maxTime) {
	    throw new Error("Both minTime and maxTime props required");
	  }
	
	  var base = moment().hours(0).minutes(0).seconds(0);
	  var baseTime = base.clone().hours(time.get("hours")).minutes(time.get("minutes"));
	  var min = base.clone().hours(minTime.get("hours")).minutes(minTime.get("minutes"));
	  var max = base.clone().hours(maxTime.get("hours")).minutes(maxTime.get("minutes"));
	
	  return !(baseTime.isSameOrAfter(min) && baseTime.isSameOrBefore(max));
	}
	
	function allDaysDisabledBefore(day, unit) {
	  var _ref6 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
	      minDate = _ref6.minDate,
	      includeDates = _ref6.includeDates;
	
	  var dateBefore = day.clone().subtract(1, unit);
	  return minDate && dateBefore.isBefore(minDate, unit) || includeDates && includeDates.every(function (includeDate) {
	    return dateBefore.isBefore(includeDate, unit);
	  }) || false;
	}
	
	function allDaysDisabledAfter(day, unit) {
	  var _ref7 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
	      maxDate = _ref7.maxDate,
	      includeDates = _ref7.includeDates;
	
	  var dateAfter = day.clone().add(1, unit);
	  return maxDate && dateAfter.isAfter(maxDate, unit) || includeDates && includeDates.every(function (includeDate) {
	    return dateAfter.isAfter(includeDate, unit);
	  }) || false;
	}
	
	function getEffectiveMinDate(_ref8) {
	  var minDate = _ref8.minDate,
	      includeDates = _ref8.includeDates;
	
	  if (includeDates && minDate) {
	    return moment.min(includeDates.filter(function (includeDate) {
	      return minDate.isSameOrBefore(includeDate, "day");
	    }));
	  } else if (includeDates) {
	    return moment.min(includeDates);
	  } else {
	    return minDate;
	  }
	}
	
	function getEffectiveMaxDate(_ref9) {
	  var maxDate = _ref9.maxDate,
	      includeDates = _ref9.includeDates;
	
	  if (includeDates && maxDate) {
	    return moment.max(includeDates.filter(function (includeDate) {
	      return maxDate.isSameOrAfter(includeDate, "day");
	    }));
	  } else if (includeDates) {
	    return moment.max(includeDates);
	  } else {
	    return maxDate;
	  }
	}
	
	function getHightLightDaysMap() {
	  var highlightDates = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	  var defaultClassName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "react-datepicker__day--highlighted";
	
	  var dateClasses = new Map();
	  for (var i = 0, len = highlightDates.length; i < len; i++) {
	    var obj = highlightDates[i];
	    if (isMoment(obj)) {
	      var key = obj.format("MM.DD.YYYY");
	      var classNamesArr = dateClasses.get(key) || [];
	      if (!classNamesArr.includes(defaultClassName)) {
	        classNamesArr.push(defaultClassName);
	        dateClasses.set(key, classNamesArr);
	      }
	    } else if ((typeof obj === "undefined" ? "undefined" : _typeof(obj)) === "object") {
	      var keys = Object.keys(obj);
	      var className = keys[0];
	      var arrOfMoments = obj[keys[0]];
	      if (typeof className === "string" && arrOfMoments.constructor === Array) {
	        for (var k = 0, _len = arrOfMoments.length; k < _len; k++) {
	          var _key = arrOfMoments[k].format("MM.DD.YYYY");
	          var _classNamesArr = dateClasses.get(_key) || [];
	          if (!_classNamesArr.includes(className)) {
	            _classNamesArr.push(className);
	            dateClasses.set(_key, _classNamesArr);
	          }
	        }
	      }
	    }
	  }
	
	  return dateClasses;
	}
	
	function timesToInjectAfter(startOfDay, currentTime, currentMultiplier, intervals, injectedTimes) {
	  var l = injectedTimes.length;
	  var times = [];
	  for (var i = 0; i < l; i++) {
	    var injectedTime = addMinutes(addHours(cloneDate(startOfDay), getHour(injectedTimes[i])), getMinute(injectedTimes[i]));
	    var nextTime = addMinutes(cloneDate(startOfDay), (currentMultiplier + 1) * intervals);
	
	    if (injectedTime.isBetween(currentTime, nextTime)) {
	      times.push(injectedTimes[i]);
	    }
	  }
	
	  return times;
	}
	
	var WrappedYearDropdownOptions = onClickOutside(YearDropdownOptions);
	
	var YearDropdown = function (_React$Component) {
	  inherits(YearDropdown, _React$Component);
	
	  function YearDropdown() {
	    var _temp, _this, _ret;
	
	    classCallCheck(this, YearDropdown);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
	      dropdownVisible: false
	    }, _this.renderSelectOptions = function () {
	      var minYear = _this.props.minDate ? getYear(_this.props.minDate) : 1900;
	      var maxYear = _this.props.maxDate ? getYear(_this.props.maxDate) : 2100;
	
	      var options = [];
	      for (var i = minYear; i <= maxYear; i++) {
	        options.push(React.createElement(
	          "option",
	          { key: i, value: i },
	          i
	        ));
	      }
	      return options;
	    }, _this.onSelectChange = function (e) {
	      _this.onChange(e.target.value);
	    }, _this.renderSelectMode = function () {
	      return React.createElement(
	        "select",
	        {
	          value: _this.props.year,
	          className: "react-datepicker__year-select",
	          onChange: _this.onSelectChange
	        },
	        _this.renderSelectOptions()
	      );
	    }, _this.renderReadView = function (visible) {
	      return React.createElement(
	        "div",
	        {
	          key: "read",
	          style: { visibility: visible ? "visible" : "hidden" },
	          className: "react-datepicker__year-read-view",
	          onClick: function onClick(event) {
	            return _this.toggleDropdown(event);
	          }
	        },
	        React.createElement("span", { className: "react-datepicker__year-read-view--down-arrow" }),
	        React.createElement(
	          "span",
	          { className: "react-datepicker__year-read-view--selected-year" },
	          _this.props.year
	        )
	      );
	    }, _this.renderDropdown = function () {
	      return React.createElement(WrappedYearDropdownOptions, {
	        key: "dropdown",
	        ref: "options",
	        year: _this.props.year,
	        onChange: _this.onChange,
	        onCancel: _this.toggleDropdown,
	        minDate: _this.props.minDate,
	        maxDate: _this.props.maxDate,
	        scrollableYearDropdown: _this.props.scrollableYearDropdown,
	        yearDropdownItemNumber: _this.props.yearDropdownItemNumber
	      });
	    }, _this.renderScrollMode = function () {
	      var dropdownVisible = _this.state.dropdownVisible;
	
	      var result = [_this.renderReadView(!dropdownVisible)];
	      if (dropdownVisible) {
	        result.unshift(_this.renderDropdown());
	      }
	      return result;
	    }, _this.onChange = function (year) {
	      _this.toggleDropdown();
	      if (year === _this.props.year) return;
	      _this.props.onChange(year);
	    }, _this.toggleDropdown = function (event) {
	      _this.setState({
	        dropdownVisible: !_this.state.dropdownVisible
	      }, function () {
	        if (_this.props.adjustDateOnChange) {
	          _this.handleYearChange(_this.props.date, event);
	        }
	      });
	    }, _this.handleYearChange = function (date, event) {
	      _this.onSelect(date, event);
	      _this.setOpen();
	    }, _this.onSelect = function (date, event) {
	      if (_this.props.onSelect) {
	        _this.props.onSelect(date, event);
	      }
	    }, _this.setOpen = function () {
	      if (_this.props.setOpen) {
	        _this.props.setOpen(true);
	      }
	    }, _temp), possibleConstructorReturn(_this, _ret);
	  }
	
	  YearDropdown.prototype.render = function render() {
	    var renderedDropdown = void 0;
	    switch (this.props.dropdownMode) {
	      case "scroll":
	        renderedDropdown = this.renderScrollMode();
	        break;
	      case "select":
	        renderedDropdown = this.renderSelectMode();
	        break;
	    }
	
	    return React.createElement(
	      "div",
	      {
	        className: "react-datepicker__year-dropdown-container react-datepicker__year-dropdown-container--" + this.props.dropdownMode
	      },
	      renderedDropdown
	    );
	  };
	
	  return YearDropdown;
	}(React.Component);
	
	YearDropdown.propTypes = {
	  adjustDateOnChange: PropTypes.bool,
	  dropdownMode: PropTypes.oneOf(["scroll", "select"]).isRequired,
	  maxDate: PropTypes.object,
	  minDate: PropTypes.object,
	  onChange: PropTypes.func.isRequired,
	  scrollableYearDropdown: PropTypes.bool,
	  year: PropTypes.number.isRequired,
	  yearDropdownItemNumber: PropTypes.number,
	  date: PropTypes.object,
	  onSelect: PropTypes.func,
	  setOpen: PropTypes.func
	};
	
	var MonthDropdownOptions = function (_React$Component) {
	  inherits(MonthDropdownOptions, _React$Component);
	
	  function MonthDropdownOptions() {
	    var _temp, _this, _ret;
	
	    classCallCheck(this, MonthDropdownOptions);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.renderOptions = function () {
	      return _this.props.monthNames.map(function (month, i) {
	        return React.createElement(
	          "div",
	          {
	            className: _this.props.month === i ? "react-datepicker__month-option --selected_month" : "react-datepicker__month-option",
	            key: month,
	            ref: month,
	            onClick: _this.onChange.bind(_this, i)
	          },
	          _this.props.month === i ? React.createElement(
	            "span",
	            { className: "react-datepicker__month-option--selected" },
	            "\u2713"
	          ) : "",
	          month
	        );
	      });
	    }, _this.onChange = function (month) {
	      return _this.props.onChange(month);
	    }, _this.handleClickOutside = function () {
	      return _this.props.onCancel();
	    }, _temp), possibleConstructorReturn(_this, _ret);
	  }
	
	  MonthDropdownOptions.prototype.render = function render() {
	    return React.createElement(
	      "div",
	      { className: "react-datepicker__month-dropdown" },
	      this.renderOptions()
	    );
	  };
	
	  return MonthDropdownOptions;
	}(React.Component);
	
	MonthDropdownOptions.propTypes = {
	  onCancel: PropTypes.func.isRequired,
	  onChange: PropTypes.func.isRequired,
	  month: PropTypes.number.isRequired,
	  monthNames: PropTypes.arrayOf(PropTypes.string.isRequired).isRequired
	};
	
	var WrappedMonthDropdownOptions = onClickOutside(MonthDropdownOptions);
	
	var MonthDropdown = function (_React$Component) {
	  inherits(MonthDropdown, _React$Component);
	
	  function MonthDropdown() {
	    var _temp, _this, _ret;
	
	    classCallCheck(this, MonthDropdown);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
	      dropdownVisible: false
	    }, _this.renderSelectOptions = function (monthNames) {
	      return monthNames.map(function (M, i) {
	        return React.createElement(
	          "option",
	          { key: i, value: i },
	          M
	        );
	      });
	    }, _this.renderSelectMode = function (monthNames) {
	      return React.createElement(
	        "select",
	        {
	          value: _this.props.month,
	          className: "react-datepicker__month-select",
	          onChange: function onChange(e) {
	            return _this.onChange(e.target.value);
	          }
	        },
	        _this.renderSelectOptions(monthNames)
	      );
	    }, _this.renderReadView = function (visible, monthNames) {
	      return React.createElement(
	        "div",
	        {
	          key: "read",
	          style: { visibility: visible ? "visible" : "hidden" },
	          className: "react-datepicker__month-read-view",
	          onClick: _this.toggleDropdown
	        },
	        React.createElement("span", { className: "react-datepicker__month-read-view--down-arrow" }),
	        React.createElement(
	          "span",
	          { className: "react-datepicker__month-read-view--selected-month" },
	          monthNames[_this.props.month]
	        )
	      );
	    }, _this.renderDropdown = function (monthNames) {
	      return React.createElement(WrappedMonthDropdownOptions, {
	        key: "dropdown",
	        ref: "options",
	        month: _this.props.month,
	        monthNames: monthNames,
	        onChange: _this.onChange,
	        onCancel: _this.toggleDropdown
	      });
	    }, _this.renderScrollMode = function (monthNames) {
	      var dropdownVisible = _this.state.dropdownVisible;
	
	      var result = [_this.renderReadView(!dropdownVisible, monthNames)];
	      if (dropdownVisible) {
	        result.unshift(_this.renderDropdown(monthNames));
	      }
	      return result;
	    }, _this.onChange = function (month) {
	      _this.toggleDropdown();
	      if (month !== _this.props.month) {
	        _this.props.onChange(month);
	      }
	    }, _this.toggleDropdown = function () {
	      return _this.setState({
	        dropdownVisible: !_this.state.dropdownVisible
	      });
	    }, _temp), possibleConstructorReturn(_this, _ret);
	  }
	
	  MonthDropdown.prototype.render = function render() {
	    var _this2 = this;
	
	    var localeData = getLocaleDataForLocale(this.props.locale);
	    var monthNames = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11].map(this.props.useShortMonthInDropdown ? function (M) {
	      return getMonthShortInLocale(localeData, newDate({ M: M }));
	    } : function (M) {
	      return getMonthInLocale(localeData, newDate({ M: M }), _this2.props.dateFormat);
	    });
	
	    var renderedDropdown = void 0;
	    switch (this.props.dropdownMode) {
	      case "scroll":
	        renderedDropdown = this.renderScrollMode(monthNames);
	        break;
	      case "select":
	        renderedDropdown = this.renderSelectMode(monthNames);
	        break;
	    }
	
	    return React.createElement(
	      "div",
	      {
	        className: "react-datepicker__month-dropdown-container react-datepicker__month-dropdown-container--" + this.props.dropdownMode
	      },
	      renderedDropdown
	    );
	  };
	
	  return MonthDropdown;
	}(React.Component);
	
	MonthDropdown.propTypes = {
	  dropdownMode: PropTypes.oneOf(["scroll", "select"]).isRequired,
	  locale: PropTypes.string,
	  dateFormat: PropTypes.string.isRequired,
	  month: PropTypes.number.isRequired,
	  onChange: PropTypes.func.isRequired,
	  useShortMonthInDropdown: PropTypes.bool
	};
	
	function generateMonthYears(minDate, maxDate) {
	  var list = [];
	
	  var currDate = getStartOfMonth(cloneDate(minDate));
	  var lastDate = getStartOfMonth(cloneDate(maxDate));
	
	  while (!isAfter(currDate, lastDate)) {
	    list.push(cloneDate(currDate));
	
	    addMonths(currDate, 1);
	  }
	
	  return list;
	}
	
	var MonthYearDropdownOptions = function (_React$Component) {
	  inherits(MonthYearDropdownOptions, _React$Component);
	
	  function MonthYearDropdownOptions(props) {
	    classCallCheck(this, MonthYearDropdownOptions);
	
	    var _this = possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.renderOptions = function () {
	      return _this.state.monthYearsList.map(function (monthYear) {
	        var monthYearPoint = monthYear.valueOf();
	
	        var isSameMonthYear = isSameYear(_this.props.date, monthYear) && isSameMonth(_this.props.date, monthYear);
	
	        return React.createElement(
	          "div",
	          {
	            className: isSameMonthYear ? "react-datepicker__month-year-option --selected_month-year" : "react-datepicker__month-year-option",
	            key: monthYearPoint,
	            ref: monthYearPoint,
	            onClick: _this.onChange.bind(_this, monthYearPoint)
	          },
	          isSameMonthYear ? React.createElement(
	            "span",
	            { className: "react-datepicker__month-year-option--selected" },
	            "\u2713"
	          ) : "",
	          formatDate(monthYear, _this.props.dateFormat)
	        );
	      });
	    };
	
	    _this.onChange = function (monthYear) {
	      return _this.props.onChange(monthYear);
	    };
	
	    _this.handleClickOutside = function () {
	      _this.props.onCancel();
	    };
	
	    _this.state = {
	      monthYearsList: generateMonthYears(_this.props.minDate, _this.props.maxDate)
	    };
	    return _this;
	  }
	
	  MonthYearDropdownOptions.prototype.render = function render() {
	    var dropdownClass = classnames({
	      "react-datepicker__month-year-dropdown": true,
	      "react-datepicker__month-year-dropdown--scrollable": this.props.scrollableMonthYearDropdown
	    });
	
	    return React.createElement(
	      "div",
	      { className: dropdownClass },
	      this.renderOptions()
	    );
	  };
	
	  return MonthYearDropdownOptions;
	}(React.Component);
	
	MonthYearDropdownOptions.propTypes = {
	  minDate: PropTypes.object.isRequired,
	  maxDate: PropTypes.object.isRequired,
	  onCancel: PropTypes.func.isRequired,
	  onChange: PropTypes.func.isRequired,
	  scrollableMonthYearDropdown: PropTypes.bool,
	  date: PropTypes.object.isRequired,
	  dateFormat: PropTypes.string.isRequired
	};
	
	var WrappedMonthYearDropdownOptions = onClickOutside(MonthYearDropdownOptions);
	
	var MonthYearDropdown = function (_React$Component) {
	  inherits(MonthYearDropdown, _React$Component);
	
	  function MonthYearDropdown() {
	    var _temp, _this, _ret;
	
	    classCallCheck(this, MonthYearDropdown);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
	      dropdownVisible: false
	    }, _this.renderSelectOptions = function () {
	      var currDate = getStartOfMonth(localizeDate(_this.props.minDate, _this.props.locale));
	      var lastDate = getStartOfMonth(localizeDate(_this.props.maxDate, _this.props.locale));
	
	      var options = [];
	
	      while (!isAfter(currDate, lastDate)) {
	        var timepoint = currDate.valueOf();
	        options.push(React.createElement(
	          "option",
	          { key: timepoint, value: timepoint },
	          formatDate(currDate, _this.props.dateFormat)
	        ));
	
	        addMonths(currDate, 1);
	      }
	
	      return options;
	    }, _this.onSelectChange = function (e) {
	      _this.onChange(e.target.value);
	    }, _this.renderSelectMode = function () {
	      return React.createElement(
	        "select",
	        {
	          value: getStartOfMonth(_this.props.date).valueOf(),
	          className: "react-datepicker__month-year-select",
	          onChange: _this.onSelectChange
	        },
	        _this.renderSelectOptions()
	      );
	    }, _this.renderReadView = function (visible) {
	      var yearMonth = formatDate(localizeDate(newDate(_this.props.date), _this.props.locale), _this.props.dateFormat);
	
	      return React.createElement(
	        "div",
	        {
	          key: "read",
	          style: { visibility: visible ? "visible" : "hidden" },
	          className: "react-datepicker__month-year-read-view",
	          onClick: function onClick(event) {
	            return _this.toggleDropdown(event);
	          }
	        },
	        React.createElement("span", { className: "react-datepicker__month-year-read-view--down-arrow" }),
	        React.createElement(
	          "span",
	          { className: "react-datepicker__month-year-read-view--selected-month-year" },
	          yearMonth
	        )
	      );
	    }, _this.renderDropdown = function () {
	      return React.createElement(WrappedMonthYearDropdownOptions, {
	        key: "dropdown",
	        ref: "options",
	        date: _this.props.date,
	        dateFormat: _this.props.dateFormat,
	        onChange: _this.onChange,
	        onCancel: _this.toggleDropdown,
	        minDate: localizeDate(_this.props.minDate, _this.props.locale),
	        maxDate: localizeDate(_this.props.maxDate, _this.props.locale),
	        scrollableMonthYearDropdown: _this.props.scrollableMonthYearDropdown
	      });
	    }, _this.renderScrollMode = function () {
	      var dropdownVisible = _this.state.dropdownVisible;
	
	      var result = [_this.renderReadView(!dropdownVisible)];
	      if (dropdownVisible) {
	        result.unshift(_this.renderDropdown());
	      }
	      return result;
	    }, _this.onChange = function (monthYearPoint) {
	      _this.toggleDropdown();
	
	      var changedDate = newDate(parseInt(monthYearPoint));
	
	      if (isSameYear(_this.props.date, changedDate) && isSameMonth(_this.props.date, changedDate)) {
	        return;
	      }
	
	      _this.props.onChange(changedDate);
	    }, _this.toggleDropdown = function () {
	      return _this.setState({
	        dropdownVisible: !_this.state.dropdownVisible
	      });
	    }, _temp), possibleConstructorReturn(_this, _ret);
	  }
	
	  MonthYearDropdown.prototype.render = function render() {
	    var renderedDropdown = void 0;
	    switch (this.props.dropdownMode) {
	      case "scroll":
	        renderedDropdown = this.renderScrollMode();
	        break;
	      case "select":
	        renderedDropdown = this.renderSelectMode();
	        break;
	    }
	
	    return React.createElement(
	      "div",
	      {
	        className: "react-datepicker__month-year-dropdown-container react-datepicker__month-year-dropdown-container--" + this.props.dropdownMode
	      },
	      renderedDropdown
	    );
	  };
	
	  return MonthYearDropdown;
	}(React.Component);
	
	MonthYearDropdown.propTypes = {
	  dropdownMode: PropTypes.oneOf(["scroll", "select"]).isRequired,
	  dateFormat: PropTypes.string.isRequired,
	  locale: PropTypes.string,
	  maxDate: PropTypes.object.isRequired,
	  minDate: PropTypes.object.isRequired,
	  date: PropTypes.object.isRequired,
	  onChange: PropTypes.func.isRequired,
	  scrollableMonthYearDropdown: PropTypes.bool
	};
	
	var Day = function (_React$Component) {
	  inherits(Day, _React$Component);
	
	  function Day() {
	    var _temp, _this, _ret;
	
	    classCallCheck(this, Day);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleClick = function (event) {
	      if (!_this.isDisabled() && _this.props.onClick) {
	        _this.props.onClick(event);
	      }
	    }, _this.handleMouseEnter = function (event) {
	      if (!_this.isDisabled() && _this.props.onMouseEnter) {
	        _this.props.onMouseEnter(event);
	      }
	    }, _this.isSameDay = function (other) {
	      return isSameDay(_this.props.day, other);
	    }, _this.isKeyboardSelected = function () {
	      return !_this.props.inline && !_this.isSameDay(_this.props.selected) && _this.isSameDay(_this.props.preSelection);
	    }, _this.isDisabled = function () {
	      return isDayDisabled(_this.props.day, _this.props);
	    }, _this.getHighLightedClass = function (defaultClassName) {
	      var _this$props = _this.props,
	          day = _this$props.day,
	          highlightDates = _this$props.highlightDates;
	
	
	      if (!highlightDates) {
	        return false;
	      }
	
	      // Looking for className in the Map of {'day string, 'className'}
	      var dayStr = day.format("MM.DD.YYYY");
	      return highlightDates.get(dayStr);
	    }, _this.isInRange = function () {
	      var _this$props2 = _this.props,
	          day = _this$props2.day,
	          startDate = _this$props2.startDate,
	          endDate = _this$props2.endDate;
	
	      if (!startDate || !endDate) {
	        return false;
	      }
	      return isDayInRange(day, startDate, endDate);
	    }, _this.isInSelectingRange = function () {
	      var _this$props3 = _this.props,
	          day = _this$props3.day,
	          selectsStart = _this$props3.selectsStart,
	          selectsEnd = _this$props3.selectsEnd,
	          selectingDate = _this$props3.selectingDate,
	          startDate = _this$props3.startDate,
	          endDate = _this$props3.endDate;
	
	
	      if (!(selectsStart || selectsEnd) || !selectingDate || _this.isDisabled()) {
	        return false;
	      }
	
	      if (selectsStart && endDate && selectingDate.isSameOrBefore(endDate)) {
	        return isDayInRange(day, selectingDate, endDate);
	      }
	
	      if (selectsEnd && startDate && selectingDate.isSameOrAfter(startDate)) {
	        return isDayInRange(day, startDate, selectingDate);
	      }
	
	      return false;
	    }, _this.isSelectingRangeStart = function () {
	      if (!_this.isInSelectingRange()) {
	        return false;
	      }
	
	      var _this$props4 = _this.props,
	          day = _this$props4.day,
	          selectingDate = _this$props4.selectingDate,
	          startDate = _this$props4.startDate,
	          selectsStart = _this$props4.selectsStart;
	
	
	      if (selectsStart) {
	        return isSameDay(day, selectingDate);
	      } else {
	        return isSameDay(day, startDate);
	      }
	    }, _this.isSelectingRangeEnd = function () {
	      if (!_this.isInSelectingRange()) {
	        return false;
	      }
	
	      var _this$props5 = _this.props,
	          day = _this$props5.day,
	          selectingDate = _this$props5.selectingDate,
	          endDate = _this$props5.endDate,
	          selectsEnd = _this$props5.selectsEnd;
	
	
	      if (selectsEnd) {
	        return isSameDay(day, selectingDate);
	      } else {
	        return isSameDay(day, endDate);
	      }
	    }, _this.isRangeStart = function () {
	      var _this$props6 = _this.props,
	          day = _this$props6.day,
	          startDate = _this$props6.startDate,
	          endDate = _this$props6.endDate;
	
	      if (!startDate || !endDate) {
	        return false;
	      }
	      return isSameDay(startDate, day);
	    }, _this.isRangeEnd = function () {
	      var _this$props7 = _this.props,
	          day = _this$props7.day,
	          startDate = _this$props7.startDate,
	          endDate = _this$props7.endDate;
	
	      if (!startDate || !endDate) {
	        return false;
	      }
	      return isSameDay(endDate, day);
	    }, _this.isWeekend = function () {
	      var weekday = getDay(_this.props.day);
	      return weekday === 0 || weekday === 6;
	    }, _this.isOutsideMonth = function () {
	      return _this.props.month !== undefined && _this.props.month !== getMonth(_this.props.day);
	    }, _this.getClassNames = function (date) {
	      var dayClassName = _this.props.dayClassName ? _this.props.dayClassName(date) : undefined;
	      return classnames("react-datepicker__day", dayClassName, "react-datepicker__day--" + getDayOfWeekCode(_this.props.day), {
	        "react-datepicker__day--disabled": _this.isDisabled(),
	        "react-datepicker__day--selected": _this.isSameDay(_this.props.selected),
	        "react-datepicker__day--keyboard-selected": _this.isKeyboardSelected(),
	        "react-datepicker__day--range-start": _this.isRangeStart(),
	        "react-datepicker__day--range-end": _this.isRangeEnd(),
	        "react-datepicker__day--in-range": _this.isInRange(),
	        "react-datepicker__day--in-selecting-range": _this.isInSelectingRange(),
	        "react-datepicker__day--selecting-range-start": _this.isSelectingRangeStart(),
	        "react-datepicker__day--selecting-range-end": _this.isSelectingRangeEnd(),
	        "react-datepicker__day--today": _this.isSameDay(now(_this.props.utcOffset)),
	        "react-datepicker__day--weekend": _this.isWeekend(),
	        "react-datepicker__day--outside-month": _this.isOutsideMonth()
	      }, _this.getHighLightedClass("react-datepicker__day--highlighted"));
	    }, _temp), possibleConstructorReturn(_this, _ret);
	  }
	
	  Day.prototype.render = function render() {
	    return React.createElement(
	      "div",
	      {
	        className: this.getClassNames(this.props.day),
	        onClick: this.handleClick,
	        onMouseEnter: this.handleMouseEnter,
	        "aria-label": "day-" + getDate(this.props.day),
	        role: "option"
	      },
	      getDate(this.props.day)
	    );
	  };
	
	  return Day;
	}(React.Component);
	
	Day.propTypes = {
	  day: PropTypes.object.isRequired,
	  dayClassName: PropTypes.func,
	  endDate: PropTypes.object,
	  highlightDates: PropTypes.instanceOf(Map),
	  inline: PropTypes.bool,
	  month: PropTypes.number,
	  onClick: PropTypes.func,
	  onMouseEnter: PropTypes.func,
	  preSelection: PropTypes.object,
	  selected: PropTypes.object,
	  selectingDate: PropTypes.object,
	  selectsEnd: PropTypes.bool,
	  selectsStart: PropTypes.bool,
	  startDate: PropTypes.object,
	  utcOffset: PropTypes.number
	};
	
	var WeekNumber = function (_React$Component) {
	  inherits(WeekNumber, _React$Component);
	
	  function WeekNumber() {
	    var _temp, _this, _ret;
	
	    classCallCheck(this, WeekNumber);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleClick = function (event) {
	      if (_this.props.onClick) {
	        _this.props.onClick(event);
	      }
	    }, _temp), possibleConstructorReturn(_this, _ret);
	  }
	
	  WeekNumber.prototype.render = function render() {
	    var weekNumberClasses = {
	      "react-datepicker__week-number": true,
	      "react-datepicker__week-number--clickable": !!this.props.onClick
	    };
	    return React.createElement(
	      "div",
	      {
	        className: classnames(weekNumberClasses),
	        "aria-label": "week-" + this.props.weekNumber,
	        onClick: this.handleClick
	      },
	      this.props.weekNumber
	    );
	  };
	
	  return WeekNumber;
	}(React.Component);
	
	WeekNumber.propTypes = {
	  weekNumber: PropTypes.number.isRequired,
	  onClick: PropTypes.func
	};
	
	var Week = function (_React$Component) {
	  inherits(Week, _React$Component);
	
	  function Week() {
	    var _temp, _this, _ret;
	
	    classCallCheck(this, Week);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleDayClick = function (day, event) {
	      if (_this.props.onDayClick) {
	        _this.props.onDayClick(day, event);
	      }
	    }, _this.handleDayMouseEnter = function (day) {
	      if (_this.props.onDayMouseEnter) {
	        _this.props.onDayMouseEnter(day);
	      }
	    }, _this.handleWeekClick = function (day, weekNumber, event) {
	      if (typeof _this.props.onWeekSelect === "function") {
	        _this.props.onWeekSelect(day, weekNumber, event);
	      }
	    }, _this.formatWeekNumber = function (startOfWeek) {
	      if (_this.props.formatWeekNumber) {
	        return _this.props.formatWeekNumber(startOfWeek);
	      }
	      return getWeek(startOfWeek);
	    }, _this.renderDays = function () {
	      var startOfWeek = getStartOfWeek(cloneDate(_this.props.day));
	      var days = [];
	      var weekNumber = _this.formatWeekNumber(startOfWeek);
	      if (_this.props.showWeekNumber) {
	        var onClickAction = _this.props.onWeekSelect ? _this.handleWeekClick.bind(_this, startOfWeek, weekNumber) : undefined;
	        days.push(React.createElement(WeekNumber, { key: "W", weekNumber: weekNumber, onClick: onClickAction }));
	      }
	      return days.concat([0, 1, 2, 3, 4, 5, 6].map(function (offset) {
	        var day = addDays(cloneDate(startOfWeek), offset);
	        return React.createElement(Day, {
	          key: offset,
	          day: day,
	          month: _this.props.month,
	          onClick: _this.handleDayClick.bind(_this, day),
	          onMouseEnter: _this.handleDayMouseEnter.bind(_this, day),
	          minDate: _this.props.minDate,
	          maxDate: _this.props.maxDate,
	          excludeDates: _this.props.excludeDates,
	          includeDates: _this.props.includeDates,
	          inline: _this.props.inline,
	          highlightDates: _this.props.highlightDates,
	          selectingDate: _this.props.selectingDate,
	          filterDate: _this.props.filterDate,
	          preSelection: _this.props.preSelection,
	          selected: _this.props.selected,
	          selectsStart: _this.props.selectsStart,
	          selectsEnd: _this.props.selectsEnd,
	          startDate: _this.props.startDate,
	          endDate: _this.props.endDate,
	          dayClassName: _this.props.dayClassName,
	          utcOffset: _this.props.utcOffset
	        });
	      }));
	    }, _temp), possibleConstructorReturn(_this, _ret);
	  }
	
	  Week.prototype.render = function render() {
	    return React.createElement(
	      "div",
	      { className: "react-datepicker__week" },
	      this.renderDays()
	    );
	  };
	
	  return Week;
	}(React.Component);
	
	Week.propTypes = {
	  day: PropTypes.object.isRequired,
	  dayClassName: PropTypes.func,
	  endDate: PropTypes.object,
	  excludeDates: PropTypes.array,
	  filterDate: PropTypes.func,
	  formatWeekNumber: PropTypes.func,
	  highlightDates: PropTypes.instanceOf(Map),
	  includeDates: PropTypes.array,
	  inline: PropTypes.bool,
	  maxDate: PropTypes.object,
	  minDate: PropTypes.object,
	  month: PropTypes.number,
	  onDayClick: PropTypes.func,
	  onDayMouseEnter: PropTypes.func,
	  onWeekSelect: PropTypes.func,
	  preSelection: PropTypes.object,
	  selected: PropTypes.object,
	  selectingDate: PropTypes.object,
	  selectsEnd: PropTypes.bool,
	  selectsStart: PropTypes.bool,
	  showWeekNumber: PropTypes.bool,
	  startDate: PropTypes.object,
	  utcOffset: PropTypes.number
	};
	
	var FIXED_HEIGHT_STANDARD_WEEK_COUNT = 6;
	
	var Month = function (_React$Component) {
	  inherits(Month, _React$Component);
	
	  function Month() {
	    var _temp, _this, _ret;
	
	    classCallCheck(this, Month);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleDayClick = function (day, event) {
	      if (_this.props.onDayClick) {
	        _this.props.onDayClick(day, event);
	      }
	    }, _this.handleDayMouseEnter = function (day) {
	      if (_this.props.onDayMouseEnter) {
	        _this.props.onDayMouseEnter(day);
	      }
	    }, _this.handleMouseLeave = function () {
	      if (_this.props.onMouseLeave) {
	        _this.props.onMouseLeave();
	      }
	    }, _this.isWeekInMonth = function (startOfWeek) {
	      var day = _this.props.day;
	      var endOfWeek = addDays(cloneDate(startOfWeek), 6);
	      return isSameMonth(startOfWeek, day) || isSameMonth(endOfWeek, day);
	    }, _this.renderWeeks = function () {
	      var weeks = [];
	      var isFixedHeight = _this.props.fixedHeight;
	      var currentWeekStart = getStartOfWeek(getStartOfMonth(cloneDate(_this.props.day)));
	      var i = 0;
	      var breakAfterNextPush = false;
	
	      while (true) {
	        weeks.push(React.createElement(Week, {
	          key: i,
	          day: currentWeekStart,
	          month: getMonth(_this.props.day),
	          onDayClick: _this.handleDayClick,
	          onDayMouseEnter: _this.handleDayMouseEnter,
	          onWeekSelect: _this.props.onWeekSelect,
	          formatWeekNumber: _this.props.formatWeekNumber,
	          minDate: _this.props.minDate,
	          maxDate: _this.props.maxDate,
	          excludeDates: _this.props.excludeDates,
	          includeDates: _this.props.includeDates,
	          inline: _this.props.inline,
	          highlightDates: _this.props.highlightDates,
	          selectingDate: _this.props.selectingDate,
	          filterDate: _this.props.filterDate,
	          preSelection: _this.props.preSelection,
	          selected: _this.props.selected,
	          selectsStart: _this.props.selectsStart,
	          selectsEnd: _this.props.selectsEnd,
	          showWeekNumber: _this.props.showWeekNumbers,
	          startDate: _this.props.startDate,
	          endDate: _this.props.endDate,
	          dayClassName: _this.props.dayClassName,
	          utcOffset: _this.props.utcOffset
	        }));
	
	        if (breakAfterNextPush) break;
	
	        i++;
	        currentWeekStart = addWeeks(cloneDate(currentWeekStart), 1);
	
	        // If one of these conditions is true, we will either break on this week
	        // or break on the next week
	        var isFixedAndFinalWeek = isFixedHeight && i >= FIXED_HEIGHT_STANDARD_WEEK_COUNT;
	        var isNonFixedAndOutOfMonth = !isFixedHeight && !_this.isWeekInMonth(currentWeekStart);
	
	        if (isFixedAndFinalWeek || isNonFixedAndOutOfMonth) {
	          if (_this.props.peekNextMonth) {
	            breakAfterNextPush = true;
	          } else {
	            break;
	          }
	        }
	      }
	
	      return weeks;
	    }, _this.getClassNames = function () {
	      var _this$props = _this.props,
	          selectingDate = _this$props.selectingDate,
	          selectsStart = _this$props.selectsStart,
	          selectsEnd = _this$props.selectsEnd;
	
	      return classnames("react-datepicker__month", {
	        "react-datepicker__month--selecting-range": selectingDate && (selectsStart || selectsEnd)
	      });
	    }, _temp), possibleConstructorReturn(_this, _ret);
	  }
	
	  Month.prototype.render = function render() {
	    return React.createElement(
	      "div",
	      {
	        className: this.getClassNames(),
	        onMouseLeave: this.handleMouseLeave,
	        role: "listbox"
	      },
	      this.renderWeeks()
	    );
	  };
	
	  return Month;
	}(React.Component);
	
	Month.propTypes = {
	  day: PropTypes.object.isRequired,
	  dayClassName: PropTypes.func,
	  endDate: PropTypes.object,
	  excludeDates: PropTypes.array,
	  filterDate: PropTypes.func,
	  fixedHeight: PropTypes.bool,
	  formatWeekNumber: PropTypes.func,
	  highlightDates: PropTypes.instanceOf(Map),
	  includeDates: PropTypes.array,
	  inline: PropTypes.bool,
	  maxDate: PropTypes.object,
	  minDate: PropTypes.object,
	  onDayClick: PropTypes.func,
	  onDayMouseEnter: PropTypes.func,
	  onMouseLeave: PropTypes.func,
	  onWeekSelect: PropTypes.func,
	  peekNextMonth: PropTypes.bool,
	  preSelection: PropTypes.object,
	  selected: PropTypes.object,
	  selectingDate: PropTypes.object,
	  selectsEnd: PropTypes.bool,
	  selectsStart: PropTypes.bool,
	  showWeekNumbers: PropTypes.bool,
	  startDate: PropTypes.object,
	  utcOffset: PropTypes.number
	};
	
	var Time = function (_React$Component) {
	  inherits(Time, _React$Component);
	
	  function Time() {
	    var _temp, _this, _ret;
	
	    classCallCheck(this, Time);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleClick = function (time) {
	      if ((_this.props.minTime || _this.props.maxTime) && isTimeInDisabledRange(time, _this.props) || _this.props.excludeTimes && isTimeDisabled(time, _this.props.excludeTimes) || _this.props.includeTimes && !isTimeDisabled(time, _this.props.includeTimes)) {
	        return;
	      }
	
	      _this.props.onChange(time);
	    }, _this.liClasses = function (time, currH, currM) {
	      var classes = ["react-datepicker__time-list-item"];
	
	      if (currH === getHour(time) && currM === getMinute(time)) {
	        classes.push("react-datepicker__time-list-item--selected");
	      }
	      if ((_this.props.minTime || _this.props.maxTime) && isTimeInDisabledRange(time, _this.props) || _this.props.excludeTimes && isTimeDisabled(time, _this.props.excludeTimes) || _this.props.includeTimes && !isTimeDisabled(time, _this.props.includeTimes)) {
	        classes.push("react-datepicker__time-list-item--disabled");
	      }
	      if (_this.props.injectTimes && (getHour(time) * 60 + getMinute(time)) % _this.props.intervals !== 0) {
	        classes.push("react-datepicker__time-list-item--injected");
	      }
	
	      return classes.join(" ");
	    }, _this.renderTimes = function () {
	      var times = [];
	      var format = _this.props.format ? _this.props.format : "hh:mm A";
	      var intervals = _this.props.intervals;
	      var activeTime = _this.props.selected ? _this.props.selected : newDate();
	      var currH = getHour(activeTime);
	      var currM = getMinute(activeTime);
	      var base = getStartOfDay(newDate());
	      var multiplier = 1440 / intervals;
	      var sortedInjectTimes = _this.props.injectTimes && _this.props.injectTimes.sort(function (a, b) {
	        return a - b;
	      });
	      for (var i = 0; i < multiplier; i++) {
	        var currentTime = addMinutes(cloneDate(base), i * intervals);
	        times.push(currentTime);
	
	        if (sortedInjectTimes) {
	          var timesToInject = timesToInjectAfter(base, currentTime, i, intervals, sortedInjectTimes);
	          times = times.concat(timesToInject);
	        }
	      }
	
	      return times.map(function (time, i) {
	        return React.createElement(
	          "li",
	          {
	            key: i,
	            onClick: _this.handleClick.bind(_this, time),
	            className: _this.liClasses(time, currH, currM)
	          },
	          formatDate(time, format)
	        );
	      });
	    }, _temp), possibleConstructorReturn(_this, _ret);
	  }
	
	  Time.prototype.componentDidMount = function componentDidMount() {
	    // code to ensure selected time will always be in focus within time window when it first appears
	    var multiplier = 60 / this.props.intervals;
	    var currH = this.props.selected ? getHour(this.props.selected) : getHour(newDate());
	    this.list.scrollTop = 30 * (multiplier * currH);
	  };
	
	  Time.prototype.render = function render() {
	    var _this2 = this;
	
	    var height = null;
	    if (this.props.monthRef) {
	      height = this.props.monthRef.clientHeight - 39;
	    }
	
	    return React.createElement(
	      "div",
	      {
	        className: "react-datepicker__time-container " + (this.props.todayButton ? "react-datepicker__time-container--with-today-button" : "")
	      },
	      React.createElement(
	        "div",
	        { className: "react-datepicker__header react-datepicker__header--time" },
	        React.createElement(
	          "div",
	          { className: "react-datepicker-time__header" },
	          this.props.timeCaption
	        )
	      ),
	      React.createElement(
	        "div",
	        { className: "react-datepicker__time" },
	        React.createElement(
	          "div",
	          { className: "react-datepicker__time-box" },
	          React.createElement(
	            "ul",
	            {
	              className: "react-datepicker__time-list",
	              ref: function ref(list) {
	                _this2.list = list;
	              },
	              style: height ? { height: height } : {}
	            },
	            this.renderTimes.bind(this)()
	          )
	        )
	      )
	    );
	  };
	
	  createClass(Time, null, [{
	    key: "defaultProps",
	    get: function get$$1() {
	      return {
	        intervals: 30,
	        onTimeChange: function onTimeChange() {},
	        todayButton: null,
	        timeCaption: "Time"
	      };
	    }
	  }]);
	  return Time;
	}(React.Component);
	
	Time.propTypes = {
	  format: PropTypes.string,
	  includeTimes: PropTypes.array,
	  intervals: PropTypes.number,
	  selected: PropTypes.object,
	  onChange: PropTypes.func,
	  todayButton: PropTypes.string,
	  minTime: PropTypes.object,
	  maxTime: PropTypes.object,
	  excludeTimes: PropTypes.array,
	  monthRef: PropTypes.object,
	  timeCaption: PropTypes.string,
	  injectTimes: PropTypes.array
	};
	
	var DROPDOWN_FOCUS_CLASSNAMES = ["react-datepicker__year-select", "react-datepicker__month-select", "react-datepicker__month-year-select"];
	
	var isDropdownSelect = function isDropdownSelect() {
	  var element = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  var classNames = (element.className || "").split(/\s+/);
	  return DROPDOWN_FOCUS_CLASSNAMES.some(function (testClassname) {
	    return classNames.indexOf(testClassname) >= 0;
	  });
	};
	
	var Calendar = function (_React$Component) {
	  inherits(Calendar, _React$Component);
	  createClass(Calendar, null, [{
	    key: "defaultProps",
	    get: function get$$1() {
	      return {
	        onDropdownFocus: function onDropdownFocus() {},
	        monthsShown: 1,
	        forceShowMonthNavigation: false,
	        timeCaption: "Time"
	      };
	    }
	  }]);
	
	  function Calendar(props) {
	    classCallCheck(this, Calendar);
	
	    var _this = possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.handleClickOutside = function (event) {
	      _this.props.onClickOutside(event);
	    };
	
	    _this.handleDropdownFocus = function (event) {
	      if (isDropdownSelect(event.target)) {
	        _this.props.onDropdownFocus();
	      }
	    };
	
	    _this.getDateInView = function () {
	      var _this$props = _this.props,
	          preSelection = _this$props.preSelection,
	          selected = _this$props.selected,
	          openToDate = _this$props.openToDate,
	          utcOffset = _this$props.utcOffset;
	
	      var minDate = getEffectiveMinDate(_this.props);
	      var maxDate = getEffectiveMaxDate(_this.props);
	      var current = now(utcOffset);
	      var initialDate = openToDate || selected || preSelection;
	      if (initialDate) {
	        return initialDate;
	      } else {
	        if (minDate && isBefore(current, minDate)) {
	          return minDate;
	        } else if (maxDate && isAfter(current, maxDate)) {
	          return maxDate;
	        }
	      }
	      return current;
	    };
	
	    _this.localizeDate = function (date) {
	      return localizeDate(date, _this.props.locale);
	    };
	
	    _this.increaseMonth = function () {
	      _this.setState({
	        date: addMonths(cloneDate(_this.state.date), 1)
	      }, function () {
	        return _this.handleMonthChange(_this.state.date);
	      });
	    };
	
	    _this.decreaseMonth = function () {
	      _this.setState({
	        date: subtractMonths(cloneDate(_this.state.date), 1)
	      }, function () {
	        return _this.handleMonthChange(_this.state.date);
	      });
	    };
	
	    _this.handleDayClick = function (day, event) {
	      return _this.props.onSelect(day, event);
	    };
	
	    _this.handleDayMouseEnter = function (day) {
	      return _this.setState({ selectingDate: day });
	    };
	
	    _this.handleMonthMouseLeave = function () {
	      return _this.setState({ selectingDate: null });
	    };
	
	    _this.handleYearChange = function (date) {
	      if (_this.props.onYearChange) {
	        _this.props.onYearChange(date);
	      }
	    };
	
	    _this.handleMonthChange = function (date) {
	      if (_this.props.onMonthChange) {
	        _this.props.onMonthChange(date);
	      }
	      if (_this.props.adjustDateOnChange) {
	        if (_this.props.onSelect) {
	          _this.props.onSelect(date);
	        }
	        if (_this.props.setOpen) {
	          _this.props.setOpen(true);
	        }
	      }
	    };
	
	    _this.handleMonthYearChange = function (date) {
	      _this.handleYearChange(date);
	      _this.handleMonthChange(date);
	    };
	
	    _this.changeYear = function (year) {
	      _this.setState({
	        date: setYear(cloneDate(_this.state.date), year)
	      }, function () {
	        return _this.handleYearChange(_this.state.date);
	      });
	    };
	
	    _this.changeMonth = function (month) {
	      _this.setState({
	        date: setMonth(cloneDate(_this.state.date), month)
	      }, function () {
	        return _this.handleMonthChange(_this.state.date);
	      });
	    };
	
	    _this.changeMonthYear = function (monthYear) {
	      _this.setState({
	        date: setYear(setMonth(cloneDate(_this.state.date), getMonth(monthYear)), getYear(monthYear))
	      }, function () {
	        return _this.handleMonthYearChange(_this.state.date);
	      });
	    };
	
	    _this.header = function () {
	      var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.state.date;
	
	      var startOfWeek = getStartOfWeek(cloneDate(date));
	      var dayNames = [];
	      if (_this.props.showWeekNumbers) {
	        dayNames.push(React.createElement(
	          "div",
	          { key: "W", className: "react-datepicker__day-name" },
	          _this.props.weekLabel || "#"
	        ));
	      }
	      return dayNames.concat([0, 1, 2, 3, 4, 5, 6].map(function (offset) {
	        var day = addDays(cloneDate(startOfWeek), offset);
	        var localeData = getLocaleData(day);
	        var weekDayName = _this.props.useWeekdaysShort ? getWeekdayShortInLocale(localeData, day) : getWeekdayMinInLocale(localeData, day);
	        return React.createElement(
	          "div",
	          { key: offset, className: "react-datepicker__day-name" },
	          weekDayName
	        );
	      }));
	    };
	
	    _this.renderPreviousMonthButton = function () {
	      var allPrevDaysDisabled = allDaysDisabledBefore(_this.state.date, "month", _this.props);
	
	      if (!_this.props.forceShowMonthNavigation && !_this.props.showDisabledMonthNavigation && allPrevDaysDisabled || _this.props.showTimeSelectOnly) {
	        return;
	      }
	
	      var classes = ["react-datepicker__navigation", "react-datepicker__navigation--previous"];
	
	      var clickHandler = _this.decreaseMonth;
	
	      if (allPrevDaysDisabled && _this.props.showDisabledMonthNavigation) {
	        classes.push("react-datepicker__navigation--previous--disabled");
	        clickHandler = null;
	      }
	
	      return React.createElement("button", {
	        type: "button",
	        className: classes.join(" "),
	        onClick: clickHandler
	      });
	    };
	
	    _this.renderNextMonthButton = function () {
	      var allNextDaysDisabled = allDaysDisabledAfter(_this.state.date, "month", _this.props);
	
	      if (!_this.props.forceShowMonthNavigation && !_this.props.showDisabledMonthNavigation && allNextDaysDisabled || _this.props.showTimeSelectOnly) {
	        return;
	      }
	
	      var classes = ["react-datepicker__navigation", "react-datepicker__navigation--next"];
	      if (_this.props.showTimeSelect) {
	        classes.push("react-datepicker__navigation--next--with-time");
	      }
	      if (_this.props.todayButton) {
	        classes.push("react-datepicker__navigation--next--with-today-button");
	      }
	
	      var clickHandler = _this.increaseMonth;
	
	      if (allNextDaysDisabled && _this.props.showDisabledMonthNavigation) {
	        classes.push("react-datepicker__navigation--next--disabled");
	        clickHandler = null;
	      }
	
	      return React.createElement("button", {
	        type: "button",
	        className: classes.join(" "),
	        onClick: clickHandler
	      });
	    };
	
	    _this.renderCurrentMonth = function () {
	      var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.state.date;
	
	      var classes = ["react-datepicker__current-month"];
	
	      if (_this.props.showYearDropdown) {
	        classes.push("react-datepicker__current-month--hasYearDropdown");
	      }
	      if (_this.props.showMonthDropdown) {
	        classes.push("react-datepicker__current-month--hasMonthDropdown");
	      }
	      if (_this.props.showMonthYearDropdown) {
	        classes.push("react-datepicker__current-month--hasMonthYearDropdown");
	      }
	      return React.createElement(
	        "div",
	        { className: classes.join(" ") },
	        formatDate(date, _this.props.dateFormat)
	      );
	    };
	
	    _this.renderYearDropdown = function () {
	      var overrideHide = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	      if (!_this.props.showYearDropdown || overrideHide) {
	        return;
	      }
	      return React.createElement(YearDropdown, {
	        adjustDateOnChange: _this.props.adjustDateOnChange,
	        date: _this.state.date,
	        onSelect: _this.props.onSelect,
	        setOpen: _this.props.setOpen,
	        dropdownMode: _this.props.dropdownMode,
	        onChange: _this.changeYear,
	        minDate: _this.props.minDate,
	        maxDate: _this.props.maxDate,
	        year: getYear(_this.state.date),
	        scrollableYearDropdown: _this.props.scrollableYearDropdown,
	        yearDropdownItemNumber: _this.props.yearDropdownItemNumber
	      });
	    };
	
	    _this.renderMonthDropdown = function () {
	      var overrideHide = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	      if (!_this.props.showMonthDropdown || overrideHide) {
	        return;
	      }
	      return React.createElement(MonthDropdown, {
	        dropdownMode: _this.props.dropdownMode,
	        locale: _this.props.locale,
	        dateFormat: _this.props.dateFormat,
	        onChange: _this.changeMonth,
	        month: getMonth(_this.state.date),
	        useShortMonthInDropdown: _this.props.useShortMonthInDropdown
	      });
	    };
	
	    _this.renderMonthYearDropdown = function () {
	      var overrideHide = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	      if (!_this.props.showMonthYearDropdown || overrideHide) {
	        return;
	      }
	      return React.createElement(MonthYearDropdown, {
	        dropdownMode: _this.props.dropdownMode,
	        locale: _this.props.locale,
	        dateFormat: _this.props.dateFormat,
	        onChange: _this.changeMonthYear,
	        minDate: _this.props.minDate,
	        maxDate: _this.props.maxDate,
	        date: _this.state.date,
	        scrollableMonthYearDropdown: _this.props.scrollableMonthYearDropdown
	      });
	    };
	
	    _this.renderTodayButton = function () {
	      if (!_this.props.todayButton || _this.props.showTimeSelectOnly) {
	        return;
	      }
	      return React.createElement(
	        "div",
	        {
	          className: "react-datepicker__today-button",
	          onClick: function onClick(e) {
	            return _this.props.onSelect(getStartOfDate(now(_this.props.utcOffset)), e);
	          }
	        },
	        _this.props.todayButton
	      );
	    };
	
	    _this.renderMonths = function () {
	      if (_this.props.showTimeSelectOnly) {
	        return;
	      }
	
	      var monthList = [];
	      for (var i = 0; i < _this.props.monthsShown; ++i) {
	        var monthDate = addMonths(cloneDate(_this.state.date), i);
	        var monthKey = "month-" + i;
	        monthList.push(React.createElement(
	          "div",
	          {
	            key: monthKey,
	            ref: function ref(div) {
	              _this.monthContainer = div;
	            },
	            className: "react-datepicker__month-container"
	          },
	          React.createElement(
	            "div",
	            { className: "react-datepicker__header" },
	            _this.renderCurrentMonth(monthDate),
	            React.createElement(
	              "div",
	              {
	                className: "react-datepicker__header__dropdown react-datepicker__header__dropdown--" + _this.props.dropdownMode,
	                onFocus: _this.handleDropdownFocus
	              },
	              _this.renderMonthDropdown(i !== 0),
	              _this.renderMonthYearDropdown(i !== 0),
	              _this.renderYearDropdown(i !== 0)
	            ),
	            React.createElement(
	              "div",
	              { className: "react-datepicker__day-names" },
	              _this.header(monthDate)
	            )
	          ),
	          React.createElement(Month, {
	            day: monthDate,
	            dayClassName: _this.props.dayClassName,
	            onDayClick: _this.handleDayClick,
	            onDayMouseEnter: _this.handleDayMouseEnter,
	            onMouseLeave: _this.handleMonthMouseLeave,
	            onWeekSelect: _this.props.onWeekSelect,
	            formatWeekNumber: _this.props.formatWeekNumber,
	            minDate: _this.props.minDate,
	            maxDate: _this.props.maxDate,
	            excludeDates: _this.props.excludeDates,
	            highlightDates: _this.props.highlightDates,
	            selectingDate: _this.state.selectingDate,
	            includeDates: _this.props.includeDates,
	            inline: _this.props.inline,
	            fixedHeight: _this.props.fixedHeight,
	            filterDate: _this.props.filterDate,
	            preSelection: _this.props.preSelection,
	            selected: _this.props.selected,
	            selectsStart: _this.props.selectsStart,
	            selectsEnd: _this.props.selectsEnd,
	            showWeekNumbers: _this.props.showWeekNumbers,
	            startDate: _this.props.startDate,
	            endDate: _this.props.endDate,
	            peekNextMonth: _this.props.peekNextMonth,
	            utcOffset: _this.props.utcOffset
	          })
	        ));
	      }
	      return monthList;
	    };
	
	    _this.renderTimeSection = function () {
	      if (_this.props.showTimeSelect) {
	        return React.createElement(Time, {
	          selected: _this.props.selected,
	          onChange: _this.props.onTimeChange,
	          format: _this.props.timeFormat,
	          includeTimes: _this.props.includeTimes,
	          intervals: _this.props.timeIntervals,
	          minTime: _this.props.minTime,
	          maxTime: _this.props.maxTime,
	          excludeTimes: _this.props.excludeTimes,
	          timeCaption: _this.props.timeCaption,
	          todayButton: _this.props.todayButton,
	          showMonthDropdown: _this.props.showMonthDropdown,
	          showMonthYearDropdown: _this.props.showMonthYearDropdown,
	          showYearDropdown: _this.props.showYearDropdown,
	          withPortal: _this.props.withPortal,
	          monthRef: _this.state.monthContainer,
	          injectTimes: _this.props.injectTimes
	        });
	      }
	    };
	
	    _this.state = {
	      date: _this.localizeDate(_this.getDateInView()),
	      selectingDate: null,
	      monthContainer: _this.monthContainer
	    };
	    return _this;
	  }
	
	  Calendar.prototype.componentDidMount = function componentDidMount() {
	    var _this2 = this;
	
	    // monthContainer height is needed in time component
	    // to determine the height for the ul in the time component
	    // setState here so height is given after final component
	    // layout is rendered
	    if (this.props.showTimeSelect) {
	      this.assignMonthContainer = function () {
	        _this2.setState({ monthContainer: _this2.monthContainer });
	      }();
	    }
	  };
	
	  Calendar.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    if (nextProps.preSelection && !isSameDay(nextProps.preSelection, this.props.preSelection)) {
	      this.setState({
	        date: this.localizeDate(nextProps.preSelection)
	      });
	    } else if (nextProps.openToDate && !isSameDay(nextProps.openToDate, this.props.openToDate)) {
	      this.setState({
	        date: this.localizeDate(nextProps.openToDate)
	      });
	    }
	  };
	
	  Calendar.prototype.render = function render() {
	    return React.createElement(
	      "div",
	      {
	        className: classnames("react-datepicker", this.props.className, {
	          "react-datepicker--time-only": this.props.showTimeSelectOnly
	        })
	      },
	      React.createElement("div", { className: "react-datepicker__triangle" }),
	      this.renderPreviousMonthButton(),
	      this.renderNextMonthButton(),
	      this.renderMonths(),
	      this.renderTodayButton(),
	      this.renderTimeSection(),
	      this.props.children
	    );
	  };
	
	  return Calendar;
	}(React.Component);
	
	Calendar.propTypes = {
	  adjustDateOnChange: PropTypes.bool,
	  className: PropTypes.string,
	  children: PropTypes.node,
	  dateFormat: PropTypes.oneOfType([PropTypes.string, PropTypes.array]).isRequired,
	  dayClassName: PropTypes.func,
	  dropdownMode: PropTypes.oneOf(["scroll", "select"]),
	  endDate: PropTypes.object,
	  excludeDates: PropTypes.array,
	  filterDate: PropTypes.func,
	  fixedHeight: PropTypes.bool,
	  formatWeekNumber: PropTypes.func,
	  highlightDates: PropTypes.instanceOf(Map),
	  includeDates: PropTypes.array,
	  includeTimes: PropTypes.array,
	  injectTimes: PropTypes.array,
	  inline: PropTypes.bool,
	  locale: PropTypes.string,
	  maxDate: PropTypes.object,
	  minDate: PropTypes.object,
	  monthsShown: PropTypes.number,
	  onClickOutside: PropTypes.func.isRequired,
	  onMonthChange: PropTypes.func,
	  onYearChange: PropTypes.func,
	  forceShowMonthNavigation: PropTypes.bool,
	  onDropdownFocus: PropTypes.func,
	  onSelect: PropTypes.func.isRequired,
	  onWeekSelect: PropTypes.func,
	  showTimeSelect: PropTypes.bool,
	  showTimeSelectOnly: PropTypes.bool,
	  timeFormat: PropTypes.string,
	  timeIntervals: PropTypes.number,
	  onTimeChange: PropTypes.func,
	  minTime: PropTypes.object,
	  maxTime: PropTypes.object,
	  excludeTimes: PropTypes.array,
	  timeCaption: PropTypes.string,
	  openToDate: PropTypes.object,
	  peekNextMonth: PropTypes.bool,
	  scrollableYearDropdown: PropTypes.bool,
	  scrollableMonthYearDropdown: PropTypes.bool,
	  preSelection: PropTypes.object,
	  selected: PropTypes.object,
	  selectsEnd: PropTypes.bool,
	  selectsStart: PropTypes.bool,
	  showMonthDropdown: PropTypes.bool,
	  showMonthYearDropdown: PropTypes.bool,
	  showWeekNumbers: PropTypes.bool,
	  showYearDropdown: PropTypes.bool,
	  startDate: PropTypes.object,
	  todayButton: PropTypes.string,
	  useWeekdaysShort: PropTypes.bool,
	  withPortal: PropTypes.bool,
	  utcOffset: PropTypes.number,
	  weekLabel: PropTypes.string,
	  yearDropdownItemNumber: PropTypes.number,
	  setOpen: PropTypes.func,
	  useShortMonthInDropdown: PropTypes.bool,
	  showDisabledMonthNavigation: PropTypes.bool
	};
	
	var popperPlacementPositions = ["auto", "auto-left", "auto-right", "bottom", "bottom-end", "bottom-start", "left", "left-end", "left-start", "right", "right-end", "right-start", "top", "top-end", "top-start"];
	
	var PopperComponent = function (_React$Component) {
	  inherits(PopperComponent, _React$Component);
	
	  function PopperComponent() {
	    classCallCheck(this, PopperComponent);
	    return possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  PopperComponent.prototype.render = function render() {
	    var _props = this.props,
	        className = _props.className,
	        hidePopper = _props.hidePopper,
	        popperComponent = _props.popperComponent,
	        popperModifiers = _props.popperModifiers,
	        popperPlacement = _props.popperPlacement,
	        targetComponent = _props.targetComponent;
	
	
	    var popper = void 0;
	
	    if (!hidePopper) {
	      var classes = classnames("react-datepicker-popper", className);
	      popper = React.createElement(
	        reactPopper.Popper,
	        {
	          className: classes,
	          modifiers: popperModifiers,
	          placement: popperPlacement
	        },
	        popperComponent
	      );
	    }
	
	    if (this.props.popperContainer) {
	      popper = React.createElement(this.props.popperContainer, {}, popper);
	    }
	
	    return React.createElement(
	      reactPopper.Manager,
	      null,
	      React.createElement(
	        reactPopper.Target,
	        { className: "react-datepicker-wrapper" },
	        targetComponent
	      ),
	      popper
	    );
	  };
	
	  createClass(PopperComponent, null, [{
	    key: "defaultProps",
	    get: function get$$1() {
	      return {
	        hidePopper: true,
	        popperModifiers: {
	          preventOverflow: {
	            enabled: true,
	            escapeWithReference: true,
	            boundariesElement: "viewport"
	          }
	        },
	        popperPlacement: "bottom-start"
	      };
	    }
	  }]);
	  return PopperComponent;
	}(React.Component);
	
	PopperComponent.propTypes = {
	  className: PropTypes.string,
	  hidePopper: PropTypes.bool,
	  popperComponent: PropTypes.element,
	  popperModifiers: PropTypes.object, // <datepicker/> props
	  popperPlacement: PropTypes.oneOf(popperPlacementPositions), // <datepicker/> props
	  popperContainer: PropTypes.func,
	  targetComponent: PropTypes.element
	};
	
	var outsideClickIgnoreClass = "react-datepicker-ignore-onclickoutside";
	var WrappedCalendar = onClickOutside(Calendar);
	
	// Compares dates year+month combinations
	function hasPreSelectionChanged(date1, date2) {
	  if (date1 && date2) {
	    return getMonth(date1) !== getMonth(date2) || getYear(date1) !== getYear(date2);
	  }
	
	  return date1 !== date2;
	}
	
	/**
	 * General datepicker component.
	 */
	
	var DatePicker = function (_React$Component) {
	  inherits(DatePicker, _React$Component);
	  createClass(DatePicker, null, [{
	    key: "defaultProps",
	    get: function get$$1() {
	      return {
	        allowSameDay: false,
	        dateFormat: "L",
	        dateFormatCalendar: "MMMM YYYY",
	        onChange: function onChange() {},
	
	        disabled: false,
	        disabledKeyboardNavigation: false,
	        dropdownMode: "scroll",
	        onFocus: function onFocus() {},
	        onBlur: function onBlur() {},
	        onKeyDown: function onKeyDown() {},
	        onSelect: function onSelect() {},
	        onClickOutside: function onClickOutside$$1() {},
	        onMonthChange: function onMonthChange() {},
	
	        preventOpenOnFocus: false,
	        onYearChange: function onYearChange() {},
	
	        monthsShown: 1,
	        withPortal: false,
	        shouldCloseOnSelect: true,
	        showTimeSelect: false,
	        timeIntervals: 30,
	        timeCaption: "Time"
	      };
	    }
	  }]);
	
	  function DatePicker(props) {
	    classCallCheck(this, DatePicker);
	
	    var _this = possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.getPreSelection = function () {
	      return _this.props.openToDate ? newDate(_this.props.openToDate) : _this.props.selectsEnd && _this.props.startDate ? newDate(_this.props.startDate) : _this.props.selectsStart && _this.props.endDate ? newDate(_this.props.endDate) : now(_this.props.utcOffset);
	    };
	
	    _this.calcInitialState = function () {
	      var defaultPreSelection = _this.getPreSelection();
	      var minDate = getEffectiveMinDate(_this.props);
	      var maxDate = getEffectiveMaxDate(_this.props);
	      var boundedPreSelection = minDate && isBefore(defaultPreSelection, minDate) ? minDate : maxDate && isAfter(defaultPreSelection, maxDate) ? maxDate : defaultPreSelection;
	      return {
	        open: _this.props.startOpen || false,
	        preventFocus: false,
	        preSelection: _this.props.selected ? newDate(_this.props.selected) : boundedPreSelection,
	        // transforming highlighted days (perhaps nested array)
	        // to flat Map for faster access in day.jsx
	        highlightDates: getHightLightDaysMap(_this.props.highlightDates),
	        focused: false
	      };
	    };
	
	    _this.clearPreventFocusTimeout = function () {
	      if (_this.preventFocusTimeout) {
	        clearTimeout(_this.preventFocusTimeout);
	      }
	    };
	
	    _this.setFocus = function () {
	      if (_this.input && _this.input.focus) {
	        _this.input.focus();
	      }
	    };
	
	    _this.setOpen = function (open) {
	      _this.setState({
	        open: open,
	        preSelection: open && _this.state.open ? _this.state.preSelection : _this.calcInitialState().preSelection
	      });
	    };
	
	    _this.handleFocus = function (event) {
	      if (!_this.state.preventFocus) {
	        _this.props.onFocus(event);
	        if (!_this.props.preventOpenOnFocus) {
	          _this.setOpen(true);
	        }
	      }
	      _this.setState({ focused: true });
	    };
	
	    _this.cancelFocusInput = function () {
	      clearTimeout(_this.inputFocusTimeout);
	      _this.inputFocusTimeout = null;
	    };
	
	    _this.deferFocusInput = function () {
	      _this.cancelFocusInput();
	      _this.inputFocusTimeout = setTimeout(function () {
	        return _this.setFocus();
	      }, 1);
	    };
	
	    _this.handleDropdownFocus = function () {
	      _this.cancelFocusInput();
	    };
	
	    _this.handleBlur = function (event) {
	      if (_this.state.open) {
	        _this.deferFocusInput();
	      } else {
	        _this.props.onBlur(event);
	      }
	      _this.setState({ focused: false });
	    };
	
	    _this.handleCalendarClickOutside = function (event) {
	      if (!_this.props.inline) {
	        _this.setOpen(false);
	      }
	      _this.props.onClickOutside(event);
	      if (_this.props.withPortal) {
	        event.preventDefault();
	      }
	    };
	
	    _this.handleChange = function () {
	      for (var _len = arguments.length, allArgs = Array(_len), _key = 0; _key < _len; _key++) {
	        allArgs[_key] = arguments[_key];
	      }
	
	      var event = allArgs[0];
	      if (_this.props.onChangeRaw) {
	        _this.props.onChangeRaw.apply(_this, allArgs);
	        if (typeof event.isDefaultPrevented !== "function" || event.isDefaultPrevented()) {
	          return;
	        }
	      }
	      _this.setState({ inputValue: event.target.value });
	      var date = parseDate(event.target.value, _this.props);
	      if (date || !event.target.value) {
	        _this.setSelected(date, event, true);
	      }
	    };
	
	    _this.handleSelect = function (date, event) {
	      // Preventing onFocus event to fix issue
	      // https://github.com/Hacker0x01/react-datepicker/issues/628
	      _this.setState({ preventFocus: true }, function () {
	        _this.preventFocusTimeout = setTimeout(function () {
	          return _this.setState({ preventFocus: false });
	        }, 50);
	        return _this.preventFocusTimeout;
	      });
	      _this.setSelected(date, event);
	      if (!_this.props.shouldCloseOnSelect || _this.props.showTimeSelect) {
	        _this.setPreSelection(date);
	      } else if (!_this.props.inline) {
	        _this.setOpen(false);
	      }
	    };
	
	    _this.setSelected = function (date, event, keepInput) {
	      var changedDate = date;
	
	      if (changedDate !== null && isDayDisabled(changedDate, _this.props)) {
	        return;
	      }
	
	      if (!isSameDay(_this.props.selected, changedDate) || _this.props.allowSameDay) {
	        if (changedDate !== null) {
	          if (_this.props.selected) {
	            var selected = _this.props.selected;
	            if (keepInput) selected = newDate(changedDate);
	            changedDate = setTime(newDate(changedDate), {
	              hour: getHour(selected),
	              minute: getMinute(selected),
	              second: getSecond(selected)
	            });
	          }
	          _this.setState({
	            preSelection: changedDate
	          });
	        }
	        _this.props.onChange(changedDate, event);
	      }
	
	      _this.props.onSelect(changedDate, event);
	
	      if (!keepInput) {
	        _this.setState({ inputValue: null });
	      }
	    };
	
	    _this.setPreSelection = function (date) {
	      var isDateRangePresent = typeof _this.props.minDate !== "undefined" && typeof _this.props.maxDate !== "undefined";
	      var isValidDateSelection = isDateRangePresent && date ? isDayInRange(date, _this.props.minDate, _this.props.maxDate) : true;
	      if (isValidDateSelection) {
	        _this.setState({
	          preSelection: date
	        });
	      }
	    };
	
	    _this.handleTimeChange = function (time) {
	      var selected = _this.props.selected ? _this.props.selected : _this.getPreSelection();
	      var changedDate = setTime(cloneDate(selected), {
	        hour: getHour(time),
	        minute: getMinute(time)
	      });
	
	      _this.setState({
	        preSelection: changedDate
	      });
	
	      _this.props.onChange(changedDate);
	      _this.setOpen(false);
	      _this.setState({ inputValue: null });
	    };
	
	    _this.onInputClick = function () {
	      if (!_this.props.disabled) {
	        _this.setOpen(true);
	      }
	    };
	
	    _this.onInputKeyDown = function (event) {
	      _this.props.onKeyDown(event);
	      var eventKey = event.key;
	      if (!_this.state.open && !_this.props.inline && !_this.props.preventOpenOnFocus) {
	        if (eventKey !== "Enter" && eventKey !== "Escape" && eventKey !== "Tab") {
	          _this.onInputClick();
	        }
	        return;
	      }
	      var copy = newDate(_this.state.preSelection);
	      if (eventKey === "Enter") {
	        event.preventDefault();
	        if (isMoment(_this.state.preSelection) || isDate(_this.state.preSelection)) {
	          _this.handleSelect(copy, event);
	          !_this.props.shouldCloseOnSelect && _this.setPreSelection(copy);
	        } else {
	          _this.setOpen(false);
	        }
	      } else if (eventKey === "Escape") {
	        event.preventDefault();
	        _this.setOpen(false);
	      } else if (eventKey === "Tab") {
	        _this.setOpen(false);
	      } else if (!_this.props.disabledKeyboardNavigation) {
	        var newSelection = void 0;
	        switch (eventKey) {
	          case "ArrowLeft":
	            event.preventDefault();
	            newSelection = subtractDays(copy, 1);
	            break;
	          case "ArrowRight":
	            event.preventDefault();
	            newSelection = addDays(copy, 1);
	            break;
	          case "ArrowUp":
	            event.preventDefault();
	            newSelection = subtractWeeks(copy, 1);
	            break;
	          case "ArrowDown":
	            event.preventDefault();
	            newSelection = addWeeks(copy, 1);
	            break;
	          case "PageUp":
	            event.preventDefault();
	            newSelection = subtractMonths(copy, 1);
	            break;
	          case "PageDown":
	            event.preventDefault();
	            newSelection = addMonths(copy, 1);
	            break;
	          case "Home":
	            event.preventDefault();
	            newSelection = subtractYears(copy, 1);
	            break;
	          case "End":
	            event.preventDefault();
	            newSelection = addYears(copy, 1);
	            break;
	        }
	        if (_this.props.adjustDateOnChange) {
	          _this.setSelected(newSelection);
	        }
	        _this.setPreSelection(newSelection);
	      }
	    };
	
	    _this.onClearClick = function (event) {
	      if (event) {
	        if (event.preventDefault) {
	          event.preventDefault();
	        }
	      }
	      _this.props.onChange(null, event);
	      _this.setState({ inputValue: null });
	    };
	
	    _this.clear = function () {
	      _this.onClearClick();
	    };
	
	    _this.renderCalendar = function () {
	      if (!_this.props.inline && (!_this.state.open || _this.props.disabled)) {
	        return null;
	      }
	      return React.createElement(
	        WrappedCalendar,
	        {
	          ref: function ref(elem) {
	            _this.calendar = elem;
	          },
	          locale: _this.props.locale,
	          adjustDateOnChange: _this.props.adjustDateOnChange,
	          setOpen: _this.setOpen,
	          dateFormat: _this.props.dateFormatCalendar,
	          useWeekdaysShort: _this.props.useWeekdaysShort,
	          dropdownMode: _this.props.dropdownMode,
	          selected: _this.props.selected,
	          preSelection: _this.state.preSelection,
	          onSelect: _this.handleSelect,
	          onWeekSelect: _this.props.onWeekSelect,
	          openToDate: _this.props.openToDate,
	          minDate: _this.props.minDate,
	          maxDate: _this.props.maxDate,
	          selectsStart: _this.props.selectsStart,
	          selectsEnd: _this.props.selectsEnd,
	          startDate: _this.props.startDate,
	          endDate: _this.props.endDate,
	          excludeDates: _this.props.excludeDates,
	          filterDate: _this.props.filterDate,
	          onClickOutside: _this.handleCalendarClickOutside,
	          formatWeekNumber: _this.props.formatWeekNumber,
	          highlightDates: _this.state.highlightDates,
	          includeDates: _this.props.includeDates,
	          includeTimes: _this.props.includeTimes,
	          injectTimes: _this.props.injectTimes,
	          inline: _this.props.inline,
	          peekNextMonth: _this.props.peekNextMonth,
	          showMonthDropdown: _this.props.showMonthDropdown,
	          useShortMonthInDropdown: _this.props.useShortMonthInDropdown,
	          showMonthYearDropdown: _this.props.showMonthYearDropdown,
	          showWeekNumbers: _this.props.showWeekNumbers,
	          showYearDropdown: _this.props.showYearDropdown,
	          withPortal: _this.props.withPortal,
	          forceShowMonthNavigation: _this.props.forceShowMonthNavigation,
	          showDisabledMonthNavigation: _this.props.showDisabledMonthNavigation,
	          scrollableYearDropdown: _this.props.scrollableYearDropdown,
	          scrollableMonthYearDropdown: _this.props.scrollableMonthYearDropdown,
	          todayButton: _this.props.todayButton,
	          weekLabel: _this.props.weekLabel,
	          utcOffset: _this.props.utcOffset,
	          outsideClickIgnoreClass: outsideClickIgnoreClass,
	          fixedHeight: _this.props.fixedHeight,
	          monthsShown: _this.props.monthsShown,
	          onDropdownFocus: _this.handleDropdownFocus,
	          onMonthChange: _this.props.onMonthChange,
	          onYearChange: _this.props.onYearChange,
	          dayClassName: _this.props.dayClassName,
	          showTimeSelect: _this.props.showTimeSelect,
	          showTimeSelectOnly: _this.props.showTimeSelectOnly,
	          onTimeChange: _this.handleTimeChange,
	          timeFormat: _this.props.timeFormat,
	          timeIntervals: _this.props.timeIntervals,
	          minTime: _this.props.minTime,
	          maxTime: _this.props.maxTime,
	          excludeTimes: _this.props.excludeTimes,
	          timeCaption: _this.props.timeCaption,
	          className: _this.props.calendarClassName,
	          yearDropdownItemNumber: _this.props.yearDropdownItemNumber
	        },
	        _this.props.children
	      );
	    };
	
	    _this.renderDateInput = function () {
	      var _classnames, _React$cloneElement;
	
	      var className = classnames(_this.props.className, (_classnames = {}, _classnames[outsideClickIgnoreClass] = _this.state.open, _classnames));
	
	      var customInput = _this.props.customInput || React.createElement("input", { type: "text" });
	      var customInputRef = _this.props.customInputRef || "ref";
	      var inputValue = typeof _this.props.value === "string" ? _this.props.value : typeof _this.state.inputValue === "string" ? _this.state.inputValue : safeDateFormat(_this.props.selected, _this.props);
	
	      return React.cloneElement(customInput, (_React$cloneElement = {}, _React$cloneElement[customInputRef] = function (input) {
	        _this.input = input;
	      }, _React$cloneElement.value = inputValue, _React$cloneElement.onBlur = _this.handleBlur, _React$cloneElement.onChange = _this.handleChange, _React$cloneElement.onClick = _this.onInputClick, _React$cloneElement.onFocus = _this.handleFocus, _React$cloneElement.onKeyDown = _this.onInputKeyDown, _React$cloneElement.id = _this.props.id, _React$cloneElement.name = _this.props.name, _React$cloneElement.autoFocus = _this.props.autoFocus, _React$cloneElement.placeholder = _this.props.placeholderText, _React$cloneElement.disabled = _this.props.disabled, _React$cloneElement.autoComplete = _this.props.autoComplete, _React$cloneElement.className = className, _React$cloneElement.title = _this.props.title, _React$cloneElement.readOnly = _this.props.readOnly, _React$cloneElement.required = _this.props.required, _React$cloneElement.tabIndex = _this.props.tabIndex, _React$cloneElement));
	    };
	
	    _this.renderClearButton = function () {
	      if (_this.props.isClearable && _this.props.selected != null) {
	        return React.createElement("button", {
	          className: "react-datepicker__close-icon",
	          onClick: _this.onClearClick,
	          title: _this.props.clearButtonTitle,
	          tabIndex: -1
	        });
	      } else {
	        return null;
	      }
	    };
	
	    _this.state = _this.calcInitialState();
	    return _this;
	  }
	
	  DatePicker.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    if (this.props.inline && hasPreSelectionChanged(this.props.selected, nextProps.selected)) {
	      this.setPreSelection(nextProps.selected);
	    }
	    if (this.props.highlightDates !== nextProps.highlightDates) {
	      this.setState({
	        highlightDates: getHightLightDaysMap(nextProps.highlightDates)
	      });
	    }
	    if (!this.state.focused) this.setState({ inputValue: null });
	  };
	
	  DatePicker.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.clearPreventFocusTimeout();
	  };
	
	  DatePicker.prototype.render = function render() {
	    var calendar = this.renderCalendar();
	
	    if (this.props.inline && !this.props.withPortal) {
	      return calendar;
	    }
	
	    if (this.props.withPortal) {
	      return React.createElement(
	        "div",
	        null,
	        !this.props.inline ? React.createElement(
	          "div",
	          { className: "react-datepicker__input-container" },
	          this.renderDateInput(),
	          this.renderClearButton()
	        ) : null,
	        this.state.open || this.props.inline ? React.createElement(
	          "div",
	          { className: "react-datepicker__portal" },
	          calendar
	        ) : null
	      );
	    }
	
	    return React.createElement(PopperComponent, {
	      className: this.props.popperClassName,
	      hidePopper: !this.state.open || this.props.disabled,
	      popperModifiers: this.props.popperModifiers,
	      targetComponent: React.createElement(
	        "div",
	        { className: "react-datepicker__input-container" },
	        this.renderDateInput(),
	        this.renderClearButton()
	      ),
	      popperContainer: this.props.popperContainer,
	      popperComponent: calendar,
	      popperPlacement: this.props.popperPlacement
	    });
	  };
	
	  return DatePicker;
	}(React.Component);
	
	DatePicker.propTypes = {
	  adjustDateOnChange: PropTypes.bool,
	  allowSameDay: PropTypes.bool,
	  autoComplete: PropTypes.string,
	  autoFocus: PropTypes.bool,
	  calendarClassName: PropTypes.string,
	  children: PropTypes.node,
	  className: PropTypes.string,
	  customInput: PropTypes.element,
	  customInputRef: PropTypes.string,
	  // eslint-disable-next-line react/no-unused-prop-types
	  dateFormat: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
	  dateFormatCalendar: PropTypes.string,
	  dayClassName: PropTypes.func,
	  disabled: PropTypes.bool,
	  disabledKeyboardNavigation: PropTypes.bool,
	  dropdownMode: PropTypes.oneOf(["scroll", "select"]).isRequired,
	  endDate: PropTypes.object,
	  excludeDates: PropTypes.array,
	  filterDate: PropTypes.func,
	  fixedHeight: PropTypes.bool,
	  formatWeekNumber: PropTypes.func,
	  highlightDates: PropTypes.array,
	  id: PropTypes.string,
	  includeDates: PropTypes.array,
	  includeTimes: PropTypes.array,
	  injectTimes: PropTypes.array,
	  inline: PropTypes.bool,
	  isClearable: PropTypes.bool,
	  locale: PropTypes.string,
	  maxDate: PropTypes.object,
	  minDate: PropTypes.object,
	  monthsShown: PropTypes.number,
	  name: PropTypes.string,
	  onBlur: PropTypes.func,
	  onChange: PropTypes.func.isRequired,
	  onSelect: PropTypes.func,
	  onWeekSelect: PropTypes.func,
	  onClickOutside: PropTypes.func,
	  onChangeRaw: PropTypes.func,
	  onFocus: PropTypes.func,
	  onKeyDown: PropTypes.func,
	  onMonthChange: PropTypes.func,
	  onYearChange: PropTypes.func,
	  openToDate: PropTypes.object,
	  peekNextMonth: PropTypes.bool,
	  placeholderText: PropTypes.string,
	  popperContainer: PropTypes.func,
	  popperClassName: PropTypes.string, // <PopperComponent/> props
	  popperModifiers: PropTypes.object, // <PopperComponent/> props
	  popperPlacement: PropTypes.oneOf(popperPlacementPositions), // <PopperComponent/> props
	  preventOpenOnFocus: PropTypes.bool,
	  readOnly: PropTypes.bool,
	  required: PropTypes.bool,
	  scrollableYearDropdown: PropTypes.bool,
	  scrollableMonthYearDropdown: PropTypes.bool,
	  selected: PropTypes.object,
	  selectsEnd: PropTypes.bool,
	  selectsStart: PropTypes.bool,
	  showMonthDropdown: PropTypes.bool,
	  showMonthYearDropdown: PropTypes.bool,
	  showWeekNumbers: PropTypes.bool,
	  showYearDropdown: PropTypes.bool,
	  forceShowMonthNavigation: PropTypes.bool,
	  showDisabledMonthNavigation: PropTypes.bool,
	  startDate: PropTypes.object,
	  startOpen: PropTypes.bool,
	  tabIndex: PropTypes.number,
	  timeCaption: PropTypes.string,
	  title: PropTypes.string,
	  todayButton: PropTypes.string,
	  useWeekdaysShort: PropTypes.bool,
	  utcOffset: PropTypes.number,
	  value: PropTypes.string,
	  weekLabel: PropTypes.string,
	  withPortal: PropTypes.bool,
	  yearDropdownItemNumber: PropTypes.number,
	  shouldCloseOnSelect: PropTypes.bool,
	  showTimeSelect: PropTypes.bool,
	  showTimeSelectOnly: PropTypes.bool,
	  timeFormat: PropTypes.string,
	  timeIntervals: PropTypes.number,
	  minTime: PropTypes.object,
	  maxTime: PropTypes.object,
	  excludeTimes: PropTypes.array,
	  useShortMonthInDropdown: PropTypes.bool,
	  clearButtonTitle: PropTypes.string
	};
	
	module.exports = DatePicker;


/***/ }),
/* 2100 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	var react = __webpack_require__(300);
	var reactDom = __webpack_require__(332);
	
	function _inheritsLoose(subClass, superClass) {
	  subClass.prototype = Object.create(superClass.prototype);
	  subClass.prototype.constructor = subClass;
	  subClass.__proto__ = superClass;
	}
	
	function _objectWithoutProperties(source, excluded) {
	  if (source == null) return {};
	  var target = {};
	  var sourceKeys = Object.keys(source);
	  var key, i;
	
	  for (i = 0; i < sourceKeys.length; i++) {
	    key = sourceKeys[i];
	    if (excluded.indexOf(key) >= 0) continue;
	    target[key] = source[key];
	  }
	
	  if (Object.getOwnPropertySymbols) {
	    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
	
	    for (i = 0; i < sourceSymbolKeys.length; i++) {
	      key = sourceSymbolKeys[i];
	      if (excluded.indexOf(key) >= 0) continue;
	      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
	      target[key] = source[key];
	    }
	  }
	
	  return target;
	}
	
	/**
	 * Check whether some DOM node is our Component's node.
	 */
	function isNodeFound(current, componentNode, ignoreClass) {
	  if (current === componentNode) {
	    return true;
	  } // SVG <use/> elements do not technically reside in the rendered DOM, so
	  // they do not have classList directly, but they offer a link to their
	  // corresponding element, which can have classList. This extra check is for
	  // that case.
	  // See: http://www.w3.org/TR/SVG11/struct.html#InterfaceSVGUseElement
	  // Discussion: https://github.com/Pomax/react-onclickoutside/pull/17
	
	
	  if (current.correspondingElement) {
	    return current.correspondingElement.classList.contains(ignoreClass);
	  }
	
	  return current.classList.contains(ignoreClass);
	}
	/**
	 * Try to find our node in a hierarchy of nodes, returning the document
	 * node as highest node if our node is not found in the path up.
	 */
	
	function findHighest(current, componentNode, ignoreClass) {
	  if (current === componentNode) {
	    return true;
	  } // If source=local then this event came from 'somewhere'
	  // inside and should be ignored. We could handle this with
	  // a layered approach, too, but that requires going back to
	  // thinking in terms of Dom node nesting, running counter
	  // to React's 'you shouldn't care about the DOM' philosophy.
	
	
	  while (current.parentNode) {
	    if (isNodeFound(current, componentNode, ignoreClass)) {
	      return true;
	    }
	
	    current = current.parentNode;
	  }
	
	  return current;
	}
	/**
	 * Check if the browser scrollbar was clicked
	 */
	
	function clickedScrollbar(evt) {
	  return document.documentElement.clientWidth <= evt.clientX || document.documentElement.clientHeight <= evt.clientY;
	}
	
	// ideally will get replaced with external dep
	// when rafrex/detect-passive-events#4 and rafrex/detect-passive-events#5 get merged in
	var testPassiveEventSupport = function testPassiveEventSupport() {
	  if (typeof window === 'undefined' || typeof window.addEventListener !== 'function') {
	    return;
	  }
	
	  var passive = false;
	  var options = Object.defineProperty({}, 'passive', {
	    get: function get() {
	      passive = true;
	    }
	  });
	
	  var noop = function noop() {};
	
	  window.addEventListener('testPassiveEventSupport', noop, options);
	  window.removeEventListener('testPassiveEventSupport', noop, options);
	  return passive;
	};
	
	function autoInc(seed) {
	  if (seed === void 0) {
	    seed = 0;
	  }
	
	  return function () {
	    return ++seed;
	  };
	}
	
	var uid = autoInc();
	
	var passiveEventSupport;
	var handlersMap = {};
	var enabledInstances = {};
	var touchEvents = ['touchstart', 'touchmove'];
	var IGNORE_CLASS_NAME = 'ignore-react-onclickoutside';
	/**
	 * Options for addEventHandler and removeEventHandler
	 */
	
	function getEventHandlerOptions(instance, eventName) {
	  var handlerOptions = null;
	  var isTouchEvent = touchEvents.indexOf(eventName) !== -1;
	
	  if (isTouchEvent && passiveEventSupport) {
	    handlerOptions = {
	      passive: !instance.props.preventDefault
	    };
	  }
	
	  return handlerOptions;
	}
	/**
	 * This function generates the HOC function that you'll use
	 * in order to impart onOutsideClick listening to an
	 * arbitrary component. It gets called at the end of the
	 * bootstrapping code to yield an instance of the
	 * onClickOutsideHOC function defined inside setupHOC().
	 */
	
	
	function onClickOutsideHOC(WrappedComponent, config) {
	  var _class, _temp;
	
	  var componentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
	  return _temp = _class =
	  /*#__PURE__*/
	  function (_Component) {
	    _inheritsLoose(onClickOutside, _Component);
	
	    function onClickOutside(props) {
	      var _this;
	
	      _this = _Component.call(this, props) || this;
	
	      _this.__outsideClickHandler = function (event) {
	        if (typeof _this.__clickOutsideHandlerProp === 'function') {
	          _this.__clickOutsideHandlerProp(event);
	
	          return;
	        }
	
	        var instance = _this.getInstance();
	
	        if (typeof instance.props.handleClickOutside === 'function') {
	          instance.props.handleClickOutside(event);
	          return;
	        }
	
	        if (typeof instance.handleClickOutside === 'function') {
	          instance.handleClickOutside(event);
	          return;
	        }
	
	        throw new Error("WrappedComponent: " + componentName + " lacks a handleClickOutside(event) function for processing outside click events.");
	      };
	
	      _this.enableOnClickOutside = function () {
	        if (typeof document === 'undefined' || enabledInstances[_this._uid]) {
	          return;
	        }
	
	        if (typeof passiveEventSupport === 'undefined') {
	          passiveEventSupport = testPassiveEventSupport();
	        }
	
	        enabledInstances[_this._uid] = true;
	        var events = _this.props.eventTypes;
	
	        if (!events.forEach) {
	          events = [events];
	        }
	
	        handlersMap[_this._uid] = function (event) {
	          if (_this.componentNode === null) return;
	
	          if (_this.props.preventDefault) {
	            event.preventDefault();
	          }
	
	          if (_this.props.stopPropagation) {
	            event.stopPropagation();
	          }
	
	          if (_this.props.excludeScrollbar && clickedScrollbar(event)) return;
	          var current = event.target;
	
	          if (findHighest(current, _this.componentNode, _this.props.outsideClickIgnoreClass) !== document) {
	            return;
	          }
	
	          _this.__outsideClickHandler(event);
	        };
	
	        events.forEach(function (eventName) {
	          document.addEventListener(eventName, handlersMap[_this._uid], getEventHandlerOptions(_this, eventName));
	        });
	      };
	
	      _this.disableOnClickOutside = function () {
	        delete enabledInstances[_this._uid];
	        var fn = handlersMap[_this._uid];
	
	        if (fn && typeof document !== 'undefined') {
	          var events = _this.props.eventTypes;
	
	          if (!events.forEach) {
	            events = [events];
	          }
	
	          events.forEach(function (eventName) {
	            return document.removeEventListener(eventName, fn, getEventHandlerOptions(_this, eventName));
	          });
	          delete handlersMap[_this._uid];
	        }
	      };
	
	      _this.getRef = function (ref) {
	        return _this.instanceRef = ref;
	      };
	
	      _this._uid = uid();
	      return _this;
	    }
	    /**
	     * Access the WrappedComponent's instance.
	     */
	
	
	    var _proto = onClickOutside.prototype;
	
	    _proto.getInstance = function getInstance() {
	      if (!WrappedComponent.prototype.isReactComponent) {
	        return this;
	      }
	
	      var ref = this.instanceRef;
	      return ref.getInstance ? ref.getInstance() : ref;
	    };
	
	    /**
	     * Add click listeners to the current document,
	     * linked to this component's state.
	     */
	    _proto.componentDidMount = function componentDidMount() {
	      // If we are in an environment without a DOM such
	      // as shallow rendering or snapshots then we exit
	      // early to prevent any unhandled errors being thrown.
	      if (typeof document === 'undefined' || !document.createElement) {
	        return;
	      }
	
	      var instance = this.getInstance();
	
	      if (config && typeof config.handleClickOutside === 'function') {
	        this.__clickOutsideHandlerProp = config.handleClickOutside(instance);
	
	        if (typeof this.__clickOutsideHandlerProp !== 'function') {
	          throw new Error("WrappedComponent: " + componentName + " lacks a function for processing outside click events specified by the handleClickOutside config option.");
	        }
	      }
	
	      this.componentNode = reactDom.findDOMNode(this.getInstance()); // return early so we dont initiate onClickOutside
	
	      if (this.props.disableOnClickOutside) return;
	      this.enableOnClickOutside();
	    };
	
	    _proto.componentDidUpdate = function componentDidUpdate() {
	      this.componentNode = reactDom.findDOMNode(this.getInstance());
	    };
	    /**
	     * Remove all document's event listeners for this component
	     */
	
	
	    _proto.componentWillUnmount = function componentWillUnmount() {
	      this.disableOnClickOutside();
	    };
	    /**
	     * Can be called to explicitly enable event listening
	     * for clicks and touches outside of this element.
	     */
	
	
	    /**
	     * Pass-through render
	     */
	    _proto.render = function render() {
	      // eslint-disable-next-line no-unused-vars
	      var _props = this.props,
	          excludeScrollbar = _props.excludeScrollbar,
	          props = _objectWithoutProperties(_props, ["excludeScrollbar"]);
	
	      if (WrappedComponent.prototype.isReactComponent) {
	        props.ref = this.getRef;
	      } else {
	        props.wrappedRef = this.getRef;
	      }
	
	      props.disableOnClickOutside = this.disableOnClickOutside;
	      props.enableOnClickOutside = this.enableOnClickOutside;
	      return react.createElement(WrappedComponent, props);
	    };
	
	    return onClickOutside;
	  }(react.Component), _class.displayName = "OnClickOutside(" + componentName + ")", _class.defaultProps = {
	    eventTypes: ['mousedown', 'touchstart'],
	    excludeScrollbar: config && config.excludeScrollbar || false,
	    outsideClickIgnoreClass: IGNORE_CLASS_NAME,
	    preventDefault: false,
	    stopPropagation: false
	  }, _class.getClass = function () {
	    return WrappedComponent.getClass ? WrappedComponent.getClass() : WrappedComponent;
	  }, _temp;
	}
	
	exports.IGNORE_CLASS_NAME = IGNORE_CLASS_NAME;
	exports['default'] = onClickOutsideHOC;


/***/ }),
/* 2101 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var react = __webpack_require__(300);
	var PropTypes = _interopDefault(__webpack_require__(956));
	var PopperJS = _interopDefault(__webpack_require__(2102));
	
	var classCallCheck = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};
	
	var createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }
	
	  return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) defineProperties(Constructor, staticProps);
	    return Constructor;
	  };
	}();
	
	var _extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	
	  return target;
	};
	
	var inherits = function (subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	  }
	
	  subClass.prototype = Object.create(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      enumerable: false,
	      writable: true,
	      configurable: true
	    }
	  });
	  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	};
	
	var objectWithoutProperties = function (obj, keys) {
	  var target = {};
	
	  for (var i in obj) {
	    if (keys.indexOf(i) >= 0) continue;
	    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	    target[i] = obj[i];
	  }
	
	  return target;
	};
	
	var possibleConstructorReturn = function (self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }
	
	  return call && (typeof call === "object" || typeof call === "function") ? call : self;
	};
	
	var Manager = function (_Component) {
	  inherits(Manager, _Component);
	
	  function Manager() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    classCallCheck(this, Manager);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = Manager.__proto__ || Object.getPrototypeOf(Manager)).call.apply(_ref, [this].concat(args))), _this), _this._setTargetNode = function (node) {
	      _this._targetNode = node;
	    }, _this._getTargetNode = function () {
	      return _this._targetNode;
	    }, _temp), possibleConstructorReturn(_this, _ret);
	  }
	
	  createClass(Manager, [{
	    key: 'getChildContext',
	    value: function getChildContext() {
	      return {
	        popperManager: {
	          setTargetNode: this._setTargetNode,
	          getTargetNode: this._getTargetNode
	        }
	      };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          tag = _props.tag,
	          children = _props.children,
	          restProps = objectWithoutProperties(_props, ['tag', 'children']);
	
	      if (tag !== false) {
	        return react.createElement(tag, restProps, children);
	      } else {
	        return children;
	      }
	    }
	  }]);
	  return Manager;
	}(react.Component);
	
	Manager.childContextTypes = {
	  popperManager: PropTypes.object.isRequired
	};
	Manager.defaultProps = {
	  tag: 'div'
	};
	Manager.propTypes =  false ? {
	  tag: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
	  children: PropTypes.oneOfType([PropTypes.node, PropTypes.func])
	} : {};
	
	var Target = function Target(props, context) {
	  var _props$component = props.component,
	      component = _props$component === undefined ? 'div' : _props$component,
	      innerRef = props.innerRef,
	      children = props.children,
	      restProps = objectWithoutProperties(props, ['component', 'innerRef', 'children']);
	  var popperManager = context.popperManager;
	
	  var targetRef = function targetRef(node) {
	    popperManager.setTargetNode(node);
	    if (typeof innerRef === 'function') {
	      innerRef(node);
	    }
	  };
	
	  if (typeof children === 'function') {
	    var targetProps = { ref: targetRef };
	    return children({ targetProps: targetProps, restProps: restProps });
	  }
	
	  var componentProps = _extends({}, restProps);
	
	  if (typeof component === 'string') {
	    componentProps.ref = targetRef;
	  } else {
	    componentProps.innerRef = targetRef;
	  }
	
	  return react.createElement(component, componentProps, children);
	};
	
	Target.contextTypes = {
	  popperManager: PropTypes.object.isRequired
	};
	
	Target.propTypes = {
	  component: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
	  innerRef: PropTypes.func,
	  children: PropTypes.oneOfType([PropTypes.node, PropTypes.func])
	};
	
	var placements = PopperJS.placements;
	
	var Popper = function (_Component) {
	  inherits(Popper, _Component);
	
	  function Popper() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    classCallCheck(this, Popper);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = Popper.__proto__ || Object.getPrototypeOf(Popper)).call.apply(_ref, [this].concat(args))), _this), _this.state = {}, _this._setArrowNode = function (node) {
	      _this._arrowNode = node;
	    }, _this._getTargetNode = function () {
	      if (_this.props.target) {
	        return _this.props.target;
	      } else if (!_this.context.popperManager || !_this.context.popperManager.getTargetNode()) {
	        throw new Error('Target missing. Popper must be given a target from the Popper Manager, or as a prop.');
	      }
	      return _this.context.popperManager.getTargetNode();
	    }, _this._getOffsets = function (data) {
	      return Object.keys(data.offsets).map(function (key) {
	        return data.offsets[key];
	      });
	    }, _this._isDataDirty = function (data) {
	      if (_this.state.data) {
	        return JSON.stringify(_this._getOffsets(_this.state.data)) !== JSON.stringify(_this._getOffsets(data));
	      } else {
	        return true;
	      }
	    }, _this._updateStateModifier = {
	      enabled: true,
	      order: 900,
	      fn: function fn(data) {
	        if (_this._isDataDirty(data)) {
	          _this.setState({ data: data });
	        }
	        return data;
	      }
	    }, _this._getPopperStyle = function () {
	      var data = _this.state.data;
	
	
	      if (!_this._popper || !data) {
	        return {
	          position: 'absolute',
	          pointerEvents: 'none',
	          opacity: 0
	        };
	      }
	
	      return _extends({
	        position: data.offsets.popper.position
	      }, data.styles);
	    }, _this._getPopperPlacement = function () {
	      return _this.state.data ? _this.state.data.placement : undefined;
	    }, _this._getPopperHide = function () {
	      return !!_this.state.data && _this.state.data.hide ? '' : undefined;
	    }, _this._getArrowStyle = function () {
	      if (!_this.state.data || !_this.state.data.offsets.arrow) {
	        return {};
	      } else {
	        var _this$state$data$offs = _this.state.data.offsets.arrow,
	            top = _this$state$data$offs.top,
	            left = _this$state$data$offs.left;
	
	        return { top: top, left: left };
	      }
	    }, _this._handlePopperRef = function (node) {
	      _this._popperNode = node;
	      if (node) {
	        _this._createPopper();
	      } else {
	        _this._destroyPopper();
	      }
	      if (_this.props.innerRef) {
	        _this.props.innerRef(node);
	      }
	    }, _this._scheduleUpdate = function () {
	      _this._popper && _this._popper.scheduleUpdate();
	    }, _temp), possibleConstructorReturn(_this, _ret);
	  }
	
	  createClass(Popper, [{
	    key: 'getChildContext',
	    value: function getChildContext() {
	      return {
	        popper: {
	          setArrowNode: this._setArrowNode,
	          getArrowStyle: this._getArrowStyle
	        }
	      };
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(lastProps) {
	      if (lastProps.placement !== this.props.placement || lastProps.eventsEnabled !== this.props.eventsEnabled || lastProps.target !== this.props.target) {
	        this._destroyPopper();
	        this._createPopper();
	      }
	      if (lastProps.children !== this.props.children) {
	        this._scheduleUpdate();
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this._destroyPopper();
	    }
	  }, {
	    key: '_createPopper',
	    value: function _createPopper() {
	      var _this2 = this;
	
	      var _props = this.props,
	          placement = _props.placement,
	          eventsEnabled = _props.eventsEnabled;
	
	      var modifiers = _extends({}, this.props.modifiers, {
	        applyStyle: { enabled: false },
	        updateState: this._updateStateModifier
	      });
	      if (this._arrowNode) {
	        modifiers.arrow = _extends({}, this.props.modifiers.arrow || {}, {
	          element: this._arrowNode
	        });
	      }
	      this._popper = new PopperJS(this._getTargetNode(), this._popperNode, {
	        placement: placement,
	        eventsEnabled: eventsEnabled,
	        modifiers: modifiers
	      });
	
	      // TODO: look into setTimeout scheduleUpdate call, without it, the popper will not position properly on creation
	      setTimeout(function () {
	        return _this2._scheduleUpdate();
	      });
	    }
	  }, {
	    key: '_destroyPopper',
	    value: function _destroyPopper() {
	      if (this._popper) {
	        this._popper.destroy();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          component = _props2.component,
	          innerRef = _props2.innerRef,
	          placement = _props2.placement,
	          eventsEnabled = _props2.eventsEnabled,
	          modifiers = _props2.modifiers,
	          children = _props2.children,
	          restProps = objectWithoutProperties(_props2, ['component', 'innerRef', 'placement', 'eventsEnabled', 'modifiers', 'children']);
	
	      var popperStyle = this._getPopperStyle();
	      var popperPlacement = this._getPopperPlacement();
	      var popperHide = this._getPopperHide();
	
	      if (typeof children === 'function') {
	        var popperProps = {
	          ref: this._handlePopperRef,
	          style: popperStyle,
	          'data-placement': popperPlacement,
	          'data-x-out-of-boundaries': popperHide
	        };
	        return children({
	          popperProps: popperProps,
	          restProps: restProps,
	          scheduleUpdate: this._scheduleUpdate
	        });
	      }
	
	      var componentProps = _extends({}, restProps, {
	        style: _extends({}, restProps.style, popperStyle),
	        'data-placement': popperPlacement,
	        'data-x-out-of-boundaries': popperHide
	      });
	
	      if (typeof component === 'string') {
	        componentProps.ref = this._handlePopperRef;
	      } else {
	        componentProps.innerRef = this._handlePopperRef;
	      }
	
	      return react.createElement(component, componentProps, children);
	    }
	  }]);
	  return Popper;
	}(react.Component);
	
	Popper.contextTypes = {
	  popperManager: PropTypes.object
	};
	Popper.childContextTypes = {
	  popper: PropTypes.object.isRequired
	};
	Popper.defaultProps = {
	  component: 'div',
	  placement: 'bottom',
	  eventsEnabled: true,
	  modifiers: {}
	};
	Popper.propTypes =  false ? {
	  component: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
	  innerRef: PropTypes.func,
	  placement: PropTypes.oneOf(placements),
	  eventsEnabled: PropTypes.bool,
	  modifiers: PropTypes.object,
	  children: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
	  target: PropTypes.oneOfType([
	  // the following check is needed for SSR
	  PropTypes.instanceOf(typeof Element !== 'undefined' ? Element : Object), PropTypes.shape({
	    getBoundingClientRect: PropTypes.func.isRequired,
	    clientWidth: PropTypes.number.isRequired,
	    clientHeight: PropTypes.number.isRequired
	  })])
	} : {};
	
	var Arrow = function Arrow(props, context) {
	  var _props$component = props.component,
	      component = _props$component === undefined ? 'span' : _props$component,
	      innerRef = props.innerRef,
	      children = props.children,
	      restProps = objectWithoutProperties(props, ['component', 'innerRef', 'children']);
	  var popper = context.popper;
	
	  var arrowRef = function arrowRef(node) {
	    popper.setArrowNode(node);
	    if (typeof innerRef === 'function') {
	      innerRef(node);
	    }
	  };
	  var arrowStyle = popper.getArrowStyle();
	
	  if (typeof children === 'function') {
	    var arrowProps = {
	      ref: arrowRef,
	      style: arrowStyle
	    };
	    return children({ arrowProps: arrowProps, restProps: restProps });
	  }
	
	  var componentProps = _extends({}, restProps, {
	    style: _extends({}, arrowStyle, restProps.style)
	  });
	
	  if (typeof component === 'string') {
	    componentProps.ref = arrowRef;
	  } else {
	    componentProps.innerRef = arrowRef;
	  }
	
	  return react.createElement(component, componentProps, children);
	};
	
	Arrow.contextTypes = {
	  popper: PropTypes.object.isRequired
	};
	
	Arrow.propTypes = {
	  component: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
	  innerRef: PropTypes.func,
	  children: PropTypes.oneOfType([PropTypes.node, PropTypes.func])
	};
	
	exports.Manager = Manager;
	exports.Target = Target;
	exports.Popper = Popper;
	exports.placements = placements;
	exports.Arrow = Arrow;
	//# sourceMappingURL=react-popper.js.map


/***/ }),
/* 2102 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/**!
	 * @fileOverview Kickass library to create and place poppers near their reference elements.
	 * @version 1.15.0
	 * @license
	 * Copyright (c) 2016 Federico Zivolo and contributors
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining a copy
	 * of this software and associated documentation files (the "Software"), to deal
	 * in the Software without restriction, including without limitation the rights
	 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	 * copies of the Software, and to permit persons to whom the Software is
	 * furnished to do so, subject to the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be included in all
	 * copies or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
	 * SOFTWARE.
	 */
	(function (global, factory) {
		 true ? module.exports = factory() :
		typeof define === 'function' && define.amd ? define(factory) :
		(global.Popper = factory());
	}(this, (function () { 'use strict';
	
	var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined';
	
	var longerTimeoutBrowsers = ['Edge', 'Trident', 'Firefox'];
	var timeoutDuration = 0;
	for (var i = 0; i < longerTimeoutBrowsers.length; i += 1) {
	  if (isBrowser && navigator.userAgent.indexOf(longerTimeoutBrowsers[i]) >= 0) {
	    timeoutDuration = 1;
	    break;
	  }
	}
	
	function microtaskDebounce(fn) {
	  var called = false;
	  return function () {
	    if (called) {
	      return;
	    }
	    called = true;
	    window.Promise.resolve().then(function () {
	      called = false;
	      fn();
	    });
	  };
	}
	
	function taskDebounce(fn) {
	  var scheduled = false;
	  return function () {
	    if (!scheduled) {
	      scheduled = true;
	      setTimeout(function () {
	        scheduled = false;
	        fn();
	      }, timeoutDuration);
	    }
	  };
	}
	
	var supportsMicroTasks = isBrowser && window.Promise;
	
	/**
	* Create a debounced version of a method, that's asynchronously deferred
	* but called in the minimum time possible.
	*
	* @method
	* @memberof Popper.Utils
	* @argument {Function} fn
	* @returns {Function}
	*/
	var debounce = supportsMicroTasks ? microtaskDebounce : taskDebounce;
	
	/**
	 * Check if the given variable is a function
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Any} functionToCheck - variable to check
	 * @returns {Boolean} answer to: is a function?
	 */
	function isFunction(functionToCheck) {
	  var getType = {};
	  return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
	}
	
	/**
	 * Get CSS computed property of the given element
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Eement} element
	 * @argument {String} property
	 */
	function getStyleComputedProperty(element, property) {
	  if (element.nodeType !== 1) {
	    return [];
	  }
	  // NOTE: 1 DOM access here
	  var window = element.ownerDocument.defaultView;
	  var css = window.getComputedStyle(element, null);
	  return property ? css[property] : css;
	}
	
	/**
	 * Returns the parentNode or the host of the element
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @returns {Element} parent
	 */
	function getParentNode(element) {
	  if (element.nodeName === 'HTML') {
	    return element;
	  }
	  return element.parentNode || element.host;
	}
	
	/**
	 * Returns the scrolling parent of the given element
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @returns {Element} scroll parent
	 */
	function getScrollParent(element) {
	  // Return body, `getScroll` will take care to get the correct `scrollTop` from it
	  if (!element) {
	    return document.body;
	  }
	
	  switch (element.nodeName) {
	    case 'HTML':
	    case 'BODY':
	      return element.ownerDocument.body;
	    case '#document':
	      return element.body;
	  }
	
	  // Firefox want us to check `-x` and `-y` variations as well
	
	  var _getStyleComputedProp = getStyleComputedProperty(element),
	      overflow = _getStyleComputedProp.overflow,
	      overflowX = _getStyleComputedProp.overflowX,
	      overflowY = _getStyleComputedProp.overflowY;
	
	  if (/(auto|scroll|overlay)/.test(overflow + overflowY + overflowX)) {
	    return element;
	  }
	
	  return getScrollParent(getParentNode(element));
	}
	
	var isIE11 = isBrowser && !!(window.MSInputMethodContext && document.documentMode);
	var isIE10 = isBrowser && /MSIE 10/.test(navigator.userAgent);
	
	/**
	 * Determines if the browser is Internet Explorer
	 * @method
	 * @memberof Popper.Utils
	 * @param {Number} version to check
	 * @returns {Boolean} isIE
	 */
	function isIE(version) {
	  if (version === 11) {
	    return isIE11;
	  }
	  if (version === 10) {
	    return isIE10;
	  }
	  return isIE11 || isIE10;
	}
	
	/**
	 * Returns the offset parent of the given element
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @returns {Element} offset parent
	 */
	function getOffsetParent(element) {
	  if (!element) {
	    return document.documentElement;
	  }
	
	  var noOffsetParent = isIE(10) ? document.body : null;
	
	  // NOTE: 1 DOM access here
	  var offsetParent = element.offsetParent || null;
	  // Skip hidden elements which don't have an offsetParent
	  while (offsetParent === noOffsetParent && element.nextElementSibling) {
	    offsetParent = (element = element.nextElementSibling).offsetParent;
	  }
	
	  var nodeName = offsetParent && offsetParent.nodeName;
	
	  if (!nodeName || nodeName === 'BODY' || nodeName === 'HTML') {
	    return element ? element.ownerDocument.documentElement : document.documentElement;
	  }
	
	  // .offsetParent will return the closest TH, TD or TABLE in case
	  // no offsetParent is present, I hate this job...
	  if (['TH', 'TD', 'TABLE'].indexOf(offsetParent.nodeName) !== -1 && getStyleComputedProperty(offsetParent, 'position') === 'static') {
	    return getOffsetParent(offsetParent);
	  }
	
	  return offsetParent;
	}
	
	function isOffsetContainer(element) {
	  var nodeName = element.nodeName;
	
	  if (nodeName === 'BODY') {
	    return false;
	  }
	  return nodeName === 'HTML' || getOffsetParent(element.firstElementChild) === element;
	}
	
	/**
	 * Finds the root node (document, shadowDOM root) of the given element
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} node
	 * @returns {Element} root node
	 */
	function getRoot(node) {
	  if (node.parentNode !== null) {
	    return getRoot(node.parentNode);
	  }
	
	  return node;
	}
	
	/**
	 * Finds the offset parent common to the two provided nodes
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element1
	 * @argument {Element} element2
	 * @returns {Element} common offset parent
	 */
	function findCommonOffsetParent(element1, element2) {
	  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
	  if (!element1 || !element1.nodeType || !element2 || !element2.nodeType) {
	    return document.documentElement;
	  }
	
	  // Here we make sure to give as "start" the element that comes first in the DOM
	  var order = element1.compareDocumentPosition(element2) & Node.DOCUMENT_POSITION_FOLLOWING;
	  var start = order ? element1 : element2;
	  var end = order ? element2 : element1;
	
	  // Get common ancestor container
	  var range = document.createRange();
	  range.setStart(start, 0);
	  range.setEnd(end, 0);
	  var commonAncestorContainer = range.commonAncestorContainer;
	
	  // Both nodes are inside #document
	
	  if (element1 !== commonAncestorContainer && element2 !== commonAncestorContainer || start.contains(end)) {
	    if (isOffsetContainer(commonAncestorContainer)) {
	      return commonAncestorContainer;
	    }
	
	    return getOffsetParent(commonAncestorContainer);
	  }
	
	  // one of the nodes is inside shadowDOM, find which one
	  var element1root = getRoot(element1);
	  if (element1root.host) {
	    return findCommonOffsetParent(element1root.host, element2);
	  } else {
	    return findCommonOffsetParent(element1, getRoot(element2).host);
	  }
	}
	
	/**
	 * Gets the scroll value of the given element in the given side (top and left)
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @argument {String} side `top` or `left`
	 * @returns {number} amount of scrolled pixels
	 */
	function getScroll(element) {
	  var side = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'top';
	
	  var upperSide = side === 'top' ? 'scrollTop' : 'scrollLeft';
	  var nodeName = element.nodeName;
	
	  if (nodeName === 'BODY' || nodeName === 'HTML') {
	    var html = element.ownerDocument.documentElement;
	    var scrollingElement = element.ownerDocument.scrollingElement || html;
	    return scrollingElement[upperSide];
	  }
	
	  return element[upperSide];
	}
	
	/*
	 * Sum or subtract the element scroll values (left and top) from a given rect object
	 * @method
	 * @memberof Popper.Utils
	 * @param {Object} rect - Rect object you want to change
	 * @param {HTMLElement} element - The element from the function reads the scroll values
	 * @param {Boolean} subtract - set to true if you want to subtract the scroll values
	 * @return {Object} rect - The modifier rect object
	 */
	function includeScroll(rect, element) {
	  var subtract = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	  var scrollTop = getScroll(element, 'top');
	  var scrollLeft = getScroll(element, 'left');
	  var modifier = subtract ? -1 : 1;
	  rect.top += scrollTop * modifier;
	  rect.bottom += scrollTop * modifier;
	  rect.left += scrollLeft * modifier;
	  rect.right += scrollLeft * modifier;
	  return rect;
	}
	
	/*
	 * Helper to detect borders of a given element
	 * @method
	 * @memberof Popper.Utils
	 * @param {CSSStyleDeclaration} styles
	 * Result of `getStyleComputedProperty` on the given element
	 * @param {String} axis - `x` or `y`
	 * @return {number} borders - The borders size of the given axis
	 */
	
	function getBordersSize(styles, axis) {
	  var sideA = axis === 'x' ? 'Left' : 'Top';
	  var sideB = sideA === 'Left' ? 'Right' : 'Bottom';
	
	  return parseFloat(styles['border' + sideA + 'Width'], 10) + parseFloat(styles['border' + sideB + 'Width'], 10);
	}
	
	function getSize(axis, body, html, computedStyle) {
	  return Math.max(body['offset' + axis], body['scroll' + axis], html['client' + axis], html['offset' + axis], html['scroll' + axis], isIE(10) ? parseInt(html['offset' + axis]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Top' : 'Left')]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Bottom' : 'Right')]) : 0);
	}
	
	function getWindowSizes(document) {
	  var body = document.body;
	  var html = document.documentElement;
	  var computedStyle = isIE(10) && getComputedStyle(html);
	
	  return {
	    height: getSize('Height', body, html, computedStyle),
	    width: getSize('Width', body, html, computedStyle)
	  };
	}
	
	var classCallCheck = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};
	
	var createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }
	
	  return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) defineProperties(Constructor, staticProps);
	    return Constructor;
	  };
	}();
	
	
	
	
	
	var defineProperty = function (obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }
	
	  return obj;
	};
	
	var _extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	
	  return target;
	};
	
	/**
	 * Given element offsets, generate an output similar to getBoundingClientRect
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Object} offsets
	 * @returns {Object} ClientRect like output
	 */
	function getClientRect(offsets) {
	  return _extends({}, offsets, {
	    right: offsets.left + offsets.width,
	    bottom: offsets.top + offsets.height
	  });
	}
	
	/**
	 * Get bounding client rect of given element
	 * @method
	 * @memberof Popper.Utils
	 * @param {HTMLElement} element
	 * @return {Object} client rect
	 */
	function getBoundingClientRect(element) {
	  var rect = {};
	
	  // IE10 10 FIX: Please, don't ask, the element isn't
	  // considered in DOM in some circumstances...
	  // This isn't reproducible in IE10 compatibility mode of IE11
	  try {
	    if (isIE(10)) {
	      rect = element.getBoundingClientRect();
	      var scrollTop = getScroll(element, 'top');
	      var scrollLeft = getScroll(element, 'left');
	      rect.top += scrollTop;
	      rect.left += scrollLeft;
	      rect.bottom += scrollTop;
	      rect.right += scrollLeft;
	    } else {
	      rect = element.getBoundingClientRect();
	    }
	  } catch (e) {}
	
	  var result = {
	    left: rect.left,
	    top: rect.top,
	    width: rect.right - rect.left,
	    height: rect.bottom - rect.top
	  };
	
	  // subtract scrollbar size from sizes
	  var sizes = element.nodeName === 'HTML' ? getWindowSizes(element.ownerDocument) : {};
	  var width = sizes.width || element.clientWidth || result.right - result.left;
	  var height = sizes.height || element.clientHeight || result.bottom - result.top;
	
	  var horizScrollbar = element.offsetWidth - width;
	  var vertScrollbar = element.offsetHeight - height;
	
	  // if an hypothetical scrollbar is detected, we must be sure it's not a `border`
	  // we make this check conditional for performance reasons
	  if (horizScrollbar || vertScrollbar) {
	    var styles = getStyleComputedProperty(element);
	    horizScrollbar -= getBordersSize(styles, 'x');
	    vertScrollbar -= getBordersSize(styles, 'y');
	
	    result.width -= horizScrollbar;
	    result.height -= vertScrollbar;
	  }
	
	  return getClientRect(result);
	}
	
	function getOffsetRectRelativeToArbitraryNode(children, parent) {
	  var fixedPosition = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	  var isIE10 = isIE(10);
	  var isHTML = parent.nodeName === 'HTML';
	  var childrenRect = getBoundingClientRect(children);
	  var parentRect = getBoundingClientRect(parent);
	  var scrollParent = getScrollParent(children);
	
	  var styles = getStyleComputedProperty(parent);
	  var borderTopWidth = parseFloat(styles.borderTopWidth, 10);
	  var borderLeftWidth = parseFloat(styles.borderLeftWidth, 10);
	
	  // In cases where the parent is fixed, we must ignore negative scroll in offset calc
	  if (fixedPosition && isHTML) {
	    parentRect.top = Math.max(parentRect.top, 0);
	    parentRect.left = Math.max(parentRect.left, 0);
	  }
	  var offsets = getClientRect({
	    top: childrenRect.top - parentRect.top - borderTopWidth,
	    left: childrenRect.left - parentRect.left - borderLeftWidth,
	    width: childrenRect.width,
	    height: childrenRect.height
	  });
	  offsets.marginTop = 0;
	  offsets.marginLeft = 0;
	
	  // Subtract margins of documentElement in case it's being used as parent
	  // we do this only on HTML because it's the only element that behaves
	  // differently when margins are applied to it. The margins are included in
	  // the box of the documentElement, in the other cases not.
	  if (!isIE10 && isHTML) {
	    var marginTop = parseFloat(styles.marginTop, 10);
	    var marginLeft = parseFloat(styles.marginLeft, 10);
	
	    offsets.top -= borderTopWidth - marginTop;
	    offsets.bottom -= borderTopWidth - marginTop;
	    offsets.left -= borderLeftWidth - marginLeft;
	    offsets.right -= borderLeftWidth - marginLeft;
	
	    // Attach marginTop and marginLeft because in some circumstances we may need them
	    offsets.marginTop = marginTop;
	    offsets.marginLeft = marginLeft;
	  }
	
	  if (isIE10 && !fixedPosition ? parent.contains(scrollParent) : parent === scrollParent && scrollParent.nodeName !== 'BODY') {
	    offsets = includeScroll(offsets, parent);
	  }
	
	  return offsets;
	}
	
	function getViewportOffsetRectRelativeToArtbitraryNode(element) {
	  var excludeScroll = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	  var html = element.ownerDocument.documentElement;
	  var relativeOffset = getOffsetRectRelativeToArbitraryNode(element, html);
	  var width = Math.max(html.clientWidth, window.innerWidth || 0);
	  var height = Math.max(html.clientHeight, window.innerHeight || 0);
	
	  var scrollTop = !excludeScroll ? getScroll(html) : 0;
	  var scrollLeft = !excludeScroll ? getScroll(html, 'left') : 0;
	
	  var offset = {
	    top: scrollTop - relativeOffset.top + relativeOffset.marginTop,
	    left: scrollLeft - relativeOffset.left + relativeOffset.marginLeft,
	    width: width,
	    height: height
	  };
	
	  return getClientRect(offset);
	}
	
	/**
	 * Check if the given element is fixed or is inside a fixed parent
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @argument {Element} customContainer
	 * @returns {Boolean} answer to "isFixed?"
	 */
	function isFixed(element) {
	  var nodeName = element.nodeName;
	  if (nodeName === 'BODY' || nodeName === 'HTML') {
	    return false;
	  }
	  if (getStyleComputedProperty(element, 'position') === 'fixed') {
	    return true;
	  }
	  var parentNode = getParentNode(element);
	  if (!parentNode) {
	    return false;
	  }
	  return isFixed(parentNode);
	}
	
	/**
	 * Finds the first parent of an element that has a transformed property defined
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @returns {Element} first transformed parent or documentElement
	 */
	
	function getFixedPositionOffsetParent(element) {
	  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
	  if (!element || !element.parentElement || isIE()) {
	    return document.documentElement;
	  }
	  var el = element.parentElement;
	  while (el && getStyleComputedProperty(el, 'transform') === 'none') {
	    el = el.parentElement;
	  }
	  return el || document.documentElement;
	}
	
	/**
	 * Computed the boundaries limits and return them
	 * @method
	 * @memberof Popper.Utils
	 * @param {HTMLElement} popper
	 * @param {HTMLElement} reference
	 * @param {number} padding
	 * @param {HTMLElement} boundariesElement - Element used to define the boundaries
	 * @param {Boolean} fixedPosition - Is in fixed position mode
	 * @returns {Object} Coordinates of the boundaries
	 */
	function getBoundaries(popper, reference, padding, boundariesElement) {
	  var fixedPosition = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
	
	  // NOTE: 1 DOM access here
	
	  var boundaries = { top: 0, left: 0 };
	  var offsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, reference);
	
	  // Handle viewport case
	  if (boundariesElement === 'viewport') {
	    boundaries = getViewportOffsetRectRelativeToArtbitraryNode(offsetParent, fixedPosition);
	  } else {
	    // Handle other cases based on DOM element used as boundaries
	    var boundariesNode = void 0;
	    if (boundariesElement === 'scrollParent') {
	      boundariesNode = getScrollParent(getParentNode(reference));
	      if (boundariesNode.nodeName === 'BODY') {
	        boundariesNode = popper.ownerDocument.documentElement;
	      }
	    } else if (boundariesElement === 'window') {
	      boundariesNode = popper.ownerDocument.documentElement;
	    } else {
	      boundariesNode = boundariesElement;
	    }
	
	    var offsets = getOffsetRectRelativeToArbitraryNode(boundariesNode, offsetParent, fixedPosition);
	
	    // In case of HTML, we need a different computation
	    if (boundariesNode.nodeName === 'HTML' && !isFixed(offsetParent)) {
	      var _getWindowSizes = getWindowSizes(popper.ownerDocument),
	          height = _getWindowSizes.height,
	          width = _getWindowSizes.width;
	
	      boundaries.top += offsets.top - offsets.marginTop;
	      boundaries.bottom = height + offsets.top;
	      boundaries.left += offsets.left - offsets.marginLeft;
	      boundaries.right = width + offsets.left;
	    } else {
	      // for all the other DOM elements, this one is good
	      boundaries = offsets;
	    }
	  }
	
	  // Add paddings
	  padding = padding || 0;
	  var isPaddingNumber = typeof padding === 'number';
	  boundaries.left += isPaddingNumber ? padding : padding.left || 0;
	  boundaries.top += isPaddingNumber ? padding : padding.top || 0;
	  boundaries.right -= isPaddingNumber ? padding : padding.right || 0;
	  boundaries.bottom -= isPaddingNumber ? padding : padding.bottom || 0;
	
	  return boundaries;
	}
	
	function getArea(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return width * height;
	}
	
	/**
	 * Utility used to transform the `auto` placement to the placement with more
	 * available space.
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Object} data - The data object generated by update method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function computeAutoPlacement(placement, refRect, popper, reference, boundariesElement) {
	  var padding = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;
	
	  if (placement.indexOf('auto') === -1) {
	    return placement;
	  }
	
	  var boundaries = getBoundaries(popper, reference, padding, boundariesElement);
	
	  var rects = {
	    top: {
	      width: boundaries.width,
	      height: refRect.top - boundaries.top
	    },
	    right: {
	      width: boundaries.right - refRect.right,
	      height: boundaries.height
	    },
	    bottom: {
	      width: boundaries.width,
	      height: boundaries.bottom - refRect.bottom
	    },
	    left: {
	      width: refRect.left - boundaries.left,
	      height: boundaries.height
	    }
	  };
	
	  var sortedAreas = Object.keys(rects).map(function (key) {
	    return _extends({
	      key: key
	    }, rects[key], {
	      area: getArea(rects[key])
	    });
	  }).sort(function (a, b) {
	    return b.area - a.area;
	  });
	
	  var filteredAreas = sortedAreas.filter(function (_ref2) {
	    var width = _ref2.width,
	        height = _ref2.height;
	    return width >= popper.clientWidth && height >= popper.clientHeight;
	  });
	
	  var computedPlacement = filteredAreas.length > 0 ? filteredAreas[0].key : sortedAreas[0].key;
	
	  var variation = placement.split('-')[1];
	
	  return computedPlacement + (variation ? '-' + variation : '');
	}
	
	/**
	 * Get offsets to the reference element
	 * @method
	 * @memberof Popper.Utils
	 * @param {Object} state
	 * @param {Element} popper - the popper element
	 * @param {Element} reference - the reference element (the popper will be relative to this)
	 * @param {Element} fixedPosition - is in fixed position mode
	 * @returns {Object} An object containing the offsets which will be applied to the popper
	 */
	function getReferenceOffsets(state, popper, reference) {
	  var fixedPosition = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
	
	  var commonOffsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, reference);
	  return getOffsetRectRelativeToArbitraryNode(reference, commonOffsetParent, fixedPosition);
	}
	
	/**
	 * Get the outer sizes of the given element (offset size + margins)
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @returns {Object} object containing width and height properties
	 */
	function getOuterSizes(element) {
	  var window = element.ownerDocument.defaultView;
	  var styles = window.getComputedStyle(element);
	  var x = parseFloat(styles.marginTop || 0) + parseFloat(styles.marginBottom || 0);
	  var y = parseFloat(styles.marginLeft || 0) + parseFloat(styles.marginRight || 0);
	  var result = {
	    width: element.offsetWidth + y,
	    height: element.offsetHeight + x
	  };
	  return result;
	}
	
	/**
	 * Get the opposite placement of the given one
	 * @method
	 * @memberof Popper.Utils
	 * @argument {String} placement
	 * @returns {String} flipped placement
	 */
	function getOppositePlacement(placement) {
	  var hash = { left: 'right', right: 'left', bottom: 'top', top: 'bottom' };
	  return placement.replace(/left|right|bottom|top/g, function (matched) {
	    return hash[matched];
	  });
	}
	
	/**
	 * Get offsets to the popper
	 * @method
	 * @memberof Popper.Utils
	 * @param {Object} position - CSS position the Popper will get applied
	 * @param {HTMLElement} popper - the popper element
	 * @param {Object} referenceOffsets - the reference offsets (the popper will be relative to this)
	 * @param {String} placement - one of the valid placement options
	 * @returns {Object} popperOffsets - An object containing the offsets which will be applied to the popper
	 */
	function getPopperOffsets(popper, referenceOffsets, placement) {
	  placement = placement.split('-')[0];
	
	  // Get popper node sizes
	  var popperRect = getOuterSizes(popper);
	
	  // Add position, width and height to our offsets object
	  var popperOffsets = {
	    width: popperRect.width,
	    height: popperRect.height
	  };
	
	  // depending by the popper placement we have to compute its offsets slightly differently
	  var isHoriz = ['right', 'left'].indexOf(placement) !== -1;
	  var mainSide = isHoriz ? 'top' : 'left';
	  var secondarySide = isHoriz ? 'left' : 'top';
	  var measurement = isHoriz ? 'height' : 'width';
	  var secondaryMeasurement = !isHoriz ? 'height' : 'width';
	
	  popperOffsets[mainSide] = referenceOffsets[mainSide] + referenceOffsets[measurement] / 2 - popperRect[measurement] / 2;
	  if (placement === secondarySide) {
	    popperOffsets[secondarySide] = referenceOffsets[secondarySide] - popperRect[secondaryMeasurement];
	  } else {
	    popperOffsets[secondarySide] = referenceOffsets[getOppositePlacement(secondarySide)];
	  }
	
	  return popperOffsets;
	}
	
	/**
	 * Mimics the `find` method of Array
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Array} arr
	 * @argument prop
	 * @argument value
	 * @returns index or -1
	 */
	function find(arr, check) {
	  // use native find if supported
	  if (Array.prototype.find) {
	    return arr.find(check);
	  }
	
	  // use `filter` to obtain the same behavior of `find`
	  return arr.filter(check)[0];
	}
	
	/**
	 * Return the index of the matching object
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Array} arr
	 * @argument prop
	 * @argument value
	 * @returns index or -1
	 */
	function findIndex(arr, prop, value) {
	  // use native findIndex if supported
	  if (Array.prototype.findIndex) {
	    return arr.findIndex(function (cur) {
	      return cur[prop] === value;
	    });
	  }
	
	  // use `find` + `indexOf` if `findIndex` isn't supported
	  var match = find(arr, function (obj) {
	    return obj[prop] === value;
	  });
	  return arr.indexOf(match);
	}
	
	/**
	 * Loop trough the list of modifiers and run them in order,
	 * each of them will then edit the data object.
	 * @method
	 * @memberof Popper.Utils
	 * @param {dataObject} data
	 * @param {Array} modifiers
	 * @param {String} ends - Optional modifier name used as stopper
	 * @returns {dataObject}
	 */
	function runModifiers(modifiers, data, ends) {
	  var modifiersToRun = ends === undefined ? modifiers : modifiers.slice(0, findIndex(modifiers, 'name', ends));
	
	  modifiersToRun.forEach(function (modifier) {
	    if (modifier['function']) {
	      // eslint-disable-line dot-notation
	      console.warn('`modifier.function` is deprecated, use `modifier.fn`!');
	    }
	    var fn = modifier['function'] || modifier.fn; // eslint-disable-line dot-notation
	    if (modifier.enabled && isFunction(fn)) {
	      // Add properties to offsets to make them a complete clientRect object
	      // we do this before each modifier to make sure the previous one doesn't
	      // mess with these values
	      data.offsets.popper = getClientRect(data.offsets.popper);
	      data.offsets.reference = getClientRect(data.offsets.reference);
	
	      data = fn(data, modifier);
	    }
	  });
	
	  return data;
	}
	
	/**
	 * Updates the position of the popper, computing the new offsets and applying
	 * the new style.<br />
	 * Prefer `scheduleUpdate` over `update` because of performance reasons.
	 * @method
	 * @memberof Popper
	 */
	function update() {
	  // if popper is destroyed, don't perform any further update
	  if (this.state.isDestroyed) {
	    return;
	  }
	
	  var data = {
	    instance: this,
	    styles: {},
	    arrowStyles: {},
	    attributes: {},
	    flipped: false,
	    offsets: {}
	  };
	
	  // compute reference element offsets
	  data.offsets.reference = getReferenceOffsets(this.state, this.popper, this.reference, this.options.positionFixed);
	
	  // compute auto placement, store placement inside the data object,
	  // modifiers will be able to edit `placement` if needed
	  // and refer to originalPlacement to know the original value
	  data.placement = computeAutoPlacement(this.options.placement, data.offsets.reference, this.popper, this.reference, this.options.modifiers.flip.boundariesElement, this.options.modifiers.flip.padding);
	
	  // store the computed placement inside `originalPlacement`
	  data.originalPlacement = data.placement;
	
	  data.positionFixed = this.options.positionFixed;
	
	  // compute the popper offsets
	  data.offsets.popper = getPopperOffsets(this.popper, data.offsets.reference, data.placement);
	
	  data.offsets.popper.position = this.options.positionFixed ? 'fixed' : 'absolute';
	
	  // run the modifiers
	  data = runModifiers(this.modifiers, data);
	
	  // the first `update` will call `onCreate` callback
	  // the other ones will call `onUpdate` callback
	  if (!this.state.isCreated) {
	    this.state.isCreated = true;
	    this.options.onCreate(data);
	  } else {
	    this.options.onUpdate(data);
	  }
	}
	
	/**
	 * Helper used to know if the given modifier is enabled.
	 * @method
	 * @memberof Popper.Utils
	 * @returns {Boolean}
	 */
	function isModifierEnabled(modifiers, modifierName) {
	  return modifiers.some(function (_ref) {
	    var name = _ref.name,
	        enabled = _ref.enabled;
	    return enabled && name === modifierName;
	  });
	}
	
	/**
	 * Get the prefixed supported property name
	 * @method
	 * @memberof Popper.Utils
	 * @argument {String} property (camelCase)
	 * @returns {String} prefixed property (camelCase or PascalCase, depending on the vendor prefix)
	 */
	function getSupportedPropertyName(property) {
	  var prefixes = [false, 'ms', 'Webkit', 'Moz', 'O'];
	  var upperProp = property.charAt(0).toUpperCase() + property.slice(1);
	
	  for (var i = 0; i < prefixes.length; i++) {
	    var prefix = prefixes[i];
	    var toCheck = prefix ? '' + prefix + upperProp : property;
	    if (typeof document.body.style[toCheck] !== 'undefined') {
	      return toCheck;
	    }
	  }
	  return null;
	}
	
	/**
	 * Destroys the popper.
	 * @method
	 * @memberof Popper
	 */
	function destroy() {
	  this.state.isDestroyed = true;
	
	  // touch DOM only if `applyStyle` modifier is enabled
	  if (isModifierEnabled(this.modifiers, 'applyStyle')) {
	    this.popper.removeAttribute('x-placement');
	    this.popper.style.position = '';
	    this.popper.style.top = '';
	    this.popper.style.left = '';
	    this.popper.style.right = '';
	    this.popper.style.bottom = '';
	    this.popper.style.willChange = '';
	    this.popper.style[getSupportedPropertyName('transform')] = '';
	  }
	
	  this.disableEventListeners();
	
	  // remove the popper if user explicity asked for the deletion on destroy
	  // do not use `remove` because IE11 doesn't support it
	  if (this.options.removeOnDestroy) {
	    this.popper.parentNode.removeChild(this.popper);
	  }
	  return this;
	}
	
	/**
	 * Get the window associated with the element
	 * @argument {Element} element
	 * @returns {Window}
	 */
	function getWindow(element) {
	  var ownerDocument = element.ownerDocument;
	  return ownerDocument ? ownerDocument.defaultView : window;
	}
	
	function attachToScrollParents(scrollParent, event, callback, scrollParents) {
	  var isBody = scrollParent.nodeName === 'BODY';
	  var target = isBody ? scrollParent.ownerDocument.defaultView : scrollParent;
	  target.addEventListener(event, callback, { passive: true });
	
	  if (!isBody) {
	    attachToScrollParents(getScrollParent(target.parentNode), event, callback, scrollParents);
	  }
	  scrollParents.push(target);
	}
	
	/**
	 * Setup needed event listeners used to update the popper position
	 * @method
	 * @memberof Popper.Utils
	 * @private
	 */
	function setupEventListeners(reference, options, state, updateBound) {
	  // Resize event listener on window
	  state.updateBound = updateBound;
	  getWindow(reference).addEventListener('resize', state.updateBound, { passive: true });
	
	  // Scroll event listener on scroll parents
	  var scrollElement = getScrollParent(reference);
	  attachToScrollParents(scrollElement, 'scroll', state.updateBound, state.scrollParents);
	  state.scrollElement = scrollElement;
	  state.eventsEnabled = true;
	
	  return state;
	}
	
	/**
	 * It will add resize/scroll events and start recalculating
	 * position of the popper element when they are triggered.
	 * @method
	 * @memberof Popper
	 */
	function enableEventListeners() {
	  if (!this.state.eventsEnabled) {
	    this.state = setupEventListeners(this.reference, this.options, this.state, this.scheduleUpdate);
	  }
	}
	
	/**
	 * Remove event listeners used to update the popper position
	 * @method
	 * @memberof Popper.Utils
	 * @private
	 */
	function removeEventListeners(reference, state) {
	  // Remove resize event listener on window
	  getWindow(reference).removeEventListener('resize', state.updateBound);
	
	  // Remove scroll event listener on scroll parents
	  state.scrollParents.forEach(function (target) {
	    target.removeEventListener('scroll', state.updateBound);
	  });
	
	  // Reset state
	  state.updateBound = null;
	  state.scrollParents = [];
	  state.scrollElement = null;
	  state.eventsEnabled = false;
	  return state;
	}
	
	/**
	 * It will remove resize/scroll events and won't recalculate popper position
	 * when they are triggered. It also won't trigger `onUpdate` callback anymore,
	 * unless you call `update` method manually.
	 * @method
	 * @memberof Popper
	 */
	function disableEventListeners() {
	  if (this.state.eventsEnabled) {
	    cancelAnimationFrame(this.scheduleUpdate);
	    this.state = removeEventListeners(this.reference, this.state);
	  }
	}
	
	/**
	 * Tells if a given input is a number
	 * @method
	 * @memberof Popper.Utils
	 * @param {*} input to check
	 * @return {Boolean}
	 */
	function isNumeric(n) {
	  return n !== '' && !isNaN(parseFloat(n)) && isFinite(n);
	}
	
	/**
	 * Set the style to the given popper
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element - Element to apply the style to
	 * @argument {Object} styles
	 * Object with a list of properties and values which will be applied to the element
	 */
	function setStyles(element, styles) {
	  Object.keys(styles).forEach(function (prop) {
	    var unit = '';
	    // add unit if the value is numeric and is one of the following
	    if (['width', 'height', 'top', 'right', 'bottom', 'left'].indexOf(prop) !== -1 && isNumeric(styles[prop])) {
	      unit = 'px';
	    }
	    element.style[prop] = styles[prop] + unit;
	  });
	}
	
	/**
	 * Set the attributes to the given popper
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element - Element to apply the attributes to
	 * @argument {Object} styles
	 * Object with a list of properties and values which will be applied to the element
	 */
	function setAttributes(element, attributes) {
	  Object.keys(attributes).forEach(function (prop) {
	    var value = attributes[prop];
	    if (value !== false) {
	      element.setAttribute(prop, attributes[prop]);
	    } else {
	      element.removeAttribute(prop);
	    }
	  });
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by `update` method
	 * @argument {Object} data.styles - List of style properties - values to apply to popper element
	 * @argument {Object} data.attributes - List of attribute properties - values to apply to popper element
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The same data object
	 */
	function applyStyle(data) {
	  // any property present in `data.styles` will be applied to the popper,
	  // in this way we can make the 3rd party modifiers add custom styles to it
	  // Be aware, modifiers could override the properties defined in the previous
	  // lines of this modifier!
	  setStyles(data.instance.popper, data.styles);
	
	  // any property present in `data.attributes` will be applied to the popper,
	  // they will be set as HTML attributes of the element
	  setAttributes(data.instance.popper, data.attributes);
	
	  // if arrowElement is defined and arrowStyles has some properties
	  if (data.arrowElement && Object.keys(data.arrowStyles).length) {
	    setStyles(data.arrowElement, data.arrowStyles);
	  }
	
	  return data;
	}
	
	/**
	 * Set the x-placement attribute before everything else because it could be used
	 * to add margins to the popper margins needs to be calculated to get the
	 * correct popper offsets.
	 * @method
	 * @memberof Popper.modifiers
	 * @param {HTMLElement} reference - The reference element used to position the popper
	 * @param {HTMLElement} popper - The HTML element used as popper
	 * @param {Object} options - Popper.js options
	 */
	function applyStyleOnLoad(reference, popper, options, modifierOptions, state) {
	  // compute reference element offsets
	  var referenceOffsets = getReferenceOffsets(state, popper, reference, options.positionFixed);
	
	  // compute auto placement, store placement inside the data object,
	  // modifiers will be able to edit `placement` if needed
	  // and refer to originalPlacement to know the original value
	  var placement = computeAutoPlacement(options.placement, referenceOffsets, popper, reference, options.modifiers.flip.boundariesElement, options.modifiers.flip.padding);
	
	  popper.setAttribute('x-placement', placement);
	
	  // Apply `position` to popper before anything else because
	  // without the position applied we can't guarantee correct computations
	  setStyles(popper, { position: options.positionFixed ? 'fixed' : 'absolute' });
	
	  return options;
	}
	
	/**
	 * @function
	 * @memberof Popper.Utils
	 * @argument {Object} data - The data object generated by `update` method
	 * @argument {Boolean} shouldRound - If the offsets should be rounded at all
	 * @returns {Object} The popper's position offsets rounded
	 *
	 * The tale of pixel-perfect positioning. It's still not 100% perfect, but as
	 * good as it can be within reason.
	 * Discussion here: https://github.com/FezVrasta/popper.js/pull/715
	 *
	 * Low DPI screens cause a popper to be blurry if not using full pixels (Safari
	 * as well on High DPI screens).
	 *
	 * Firefox prefers no rounding for positioning and does not have blurriness on
	 * high DPI screens.
	 *
	 * Only horizontal placement and left/right values need to be considered.
	 */
	function getRoundedOffsets(data, shouldRound) {
	  var _data$offsets = data.offsets,
	      popper = _data$offsets.popper,
	      reference = _data$offsets.reference;
	  var round = Math.round,
	      floor = Math.floor;
	
	  var noRound = function noRound(v) {
	    return v;
	  };
	
	  var referenceWidth = round(reference.width);
	  var popperWidth = round(popper.width);
	
	  var isVertical = ['left', 'right'].indexOf(data.placement) !== -1;
	  var isVariation = data.placement.indexOf('-') !== -1;
	  var sameWidthParity = referenceWidth % 2 === popperWidth % 2;
	  var bothOddWidth = referenceWidth % 2 === 1 && popperWidth % 2 === 1;
	
	  var horizontalToInteger = !shouldRound ? noRound : isVertical || isVariation || sameWidthParity ? round : floor;
	  var verticalToInteger = !shouldRound ? noRound : round;
	
	  return {
	    left: horizontalToInteger(bothOddWidth && !isVariation && shouldRound ? popper.left - 1 : popper.left),
	    top: verticalToInteger(popper.top),
	    bottom: verticalToInteger(popper.bottom),
	    right: horizontalToInteger(popper.right)
	  };
	}
	
	var isFirefox = isBrowser && /Firefox/i.test(navigator.userAgent);
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by `update` method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function computeStyle(data, options) {
	  var x = options.x,
	      y = options.y;
	  var popper = data.offsets.popper;
	
	  // Remove this legacy support in Popper.js v2
	
	  var legacyGpuAccelerationOption = find(data.instance.modifiers, function (modifier) {
	    return modifier.name === 'applyStyle';
	  }).gpuAcceleration;
	  if (legacyGpuAccelerationOption !== undefined) {
	    console.warn('WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!');
	  }
	  var gpuAcceleration = legacyGpuAccelerationOption !== undefined ? legacyGpuAccelerationOption : options.gpuAcceleration;
	
	  var offsetParent = getOffsetParent(data.instance.popper);
	  var offsetParentRect = getBoundingClientRect(offsetParent);
	
	  // Styles
	  var styles = {
	    position: popper.position
	  };
	
	  var offsets = getRoundedOffsets(data, window.devicePixelRatio < 2 || !isFirefox);
	
	  var sideA = x === 'bottom' ? 'top' : 'bottom';
	  var sideB = y === 'right' ? 'left' : 'right';
	
	  // if gpuAcceleration is set to `true` and transform is supported,
	  //  we use `translate3d` to apply the position to the popper we
	  // automatically use the supported prefixed version if needed
	  var prefixedProperty = getSupportedPropertyName('transform');
	
	  // now, let's make a step back and look at this code closely (wtf?)
	  // If the content of the popper grows once it's been positioned, it
	  // may happen that the popper gets misplaced because of the new content
	  // overflowing its reference element
	  // To avoid this problem, we provide two options (x and y), which allow
	  // the consumer to define the offset origin.
	  // If we position a popper on top of a reference element, we can set
	  // `x` to `top` to make the popper grow towards its top instead of
	  // its bottom.
	  var left = void 0,
	      top = void 0;
	  if (sideA === 'bottom') {
	    // when offsetParent is <html> the positioning is relative to the bottom of the screen (excluding the scrollbar)
	    // and not the bottom of the html element
	    if (offsetParent.nodeName === 'HTML') {
	      top = -offsetParent.clientHeight + offsets.bottom;
	    } else {
	      top = -offsetParentRect.height + offsets.bottom;
	    }
	  } else {
	    top = offsets.top;
	  }
	  if (sideB === 'right') {
	    if (offsetParent.nodeName === 'HTML') {
	      left = -offsetParent.clientWidth + offsets.right;
	    } else {
	      left = -offsetParentRect.width + offsets.right;
	    }
	  } else {
	    left = offsets.left;
	  }
	  if (gpuAcceleration && prefixedProperty) {
	    styles[prefixedProperty] = 'translate3d(' + left + 'px, ' + top + 'px, 0)';
	    styles[sideA] = 0;
	    styles[sideB] = 0;
	    styles.willChange = 'transform';
	  } else {
	    // othwerise, we use the standard `top`, `left`, `bottom` and `right` properties
	    var invertTop = sideA === 'bottom' ? -1 : 1;
	    var invertLeft = sideB === 'right' ? -1 : 1;
	    styles[sideA] = top * invertTop;
	    styles[sideB] = left * invertLeft;
	    styles.willChange = sideA + ', ' + sideB;
	  }
	
	  // Attributes
	  var attributes = {
	    'x-placement': data.placement
	  };
	
	  // Update `data` attributes, styles and arrowStyles
	  data.attributes = _extends({}, attributes, data.attributes);
	  data.styles = _extends({}, styles, data.styles);
	  data.arrowStyles = _extends({}, data.offsets.arrow, data.arrowStyles);
	
	  return data;
	}
	
	/**
	 * Helper used to know if the given modifier depends from another one.<br />
	 * It checks if the needed modifier is listed and enabled.
	 * @method
	 * @memberof Popper.Utils
	 * @param {Array} modifiers - list of modifiers
	 * @param {String} requestingName - name of requesting modifier
	 * @param {String} requestedName - name of requested modifier
	 * @returns {Boolean}
	 */
	function isModifierRequired(modifiers, requestingName, requestedName) {
	  var requesting = find(modifiers, function (_ref) {
	    var name = _ref.name;
	    return name === requestingName;
	  });
	
	  var isRequired = !!requesting && modifiers.some(function (modifier) {
	    return modifier.name === requestedName && modifier.enabled && modifier.order < requesting.order;
	  });
	
	  if (!isRequired) {
	    var _requesting = '`' + requestingName + '`';
	    var requested = '`' + requestedName + '`';
	    console.warn(requested + ' modifier is required by ' + _requesting + ' modifier in order to work, be sure to include it before ' + _requesting + '!');
	  }
	  return isRequired;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by update method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function arrow(data, options) {
	  var _data$offsets$arrow;
	
	  // arrow depends on keepTogether in order to work
	  if (!isModifierRequired(data.instance.modifiers, 'arrow', 'keepTogether')) {
	    return data;
	  }
	
	  var arrowElement = options.element;
	
	  // if arrowElement is a string, suppose it's a CSS selector
	  if (typeof arrowElement === 'string') {
	    arrowElement = data.instance.popper.querySelector(arrowElement);
	
	    // if arrowElement is not found, don't run the modifier
	    if (!arrowElement) {
	      return data;
	    }
	  } else {
	    // if the arrowElement isn't a query selector we must check that the
	    // provided DOM node is child of its popper node
	    if (!data.instance.popper.contains(arrowElement)) {
	      console.warn('WARNING: `arrow.element` must be child of its popper element!');
	      return data;
	    }
	  }
	
	  var placement = data.placement.split('-')[0];
	  var _data$offsets = data.offsets,
	      popper = _data$offsets.popper,
	      reference = _data$offsets.reference;
	
	  var isVertical = ['left', 'right'].indexOf(placement) !== -1;
	
	  var len = isVertical ? 'height' : 'width';
	  var sideCapitalized = isVertical ? 'Top' : 'Left';
	  var side = sideCapitalized.toLowerCase();
	  var altSide = isVertical ? 'left' : 'top';
	  var opSide = isVertical ? 'bottom' : 'right';
	  var arrowElementSize = getOuterSizes(arrowElement)[len];
	
	  //
	  // extends keepTogether behavior making sure the popper and its
	  // reference have enough pixels in conjunction
	  //
	
	  // top/left side
	  if (reference[opSide] - arrowElementSize < popper[side]) {
	    data.offsets.popper[side] -= popper[side] - (reference[opSide] - arrowElementSize);
	  }
	  // bottom/right side
	  if (reference[side] + arrowElementSize > popper[opSide]) {
	    data.offsets.popper[side] += reference[side] + arrowElementSize - popper[opSide];
	  }
	  data.offsets.popper = getClientRect(data.offsets.popper);
	
	  // compute center of the popper
	  var center = reference[side] + reference[len] / 2 - arrowElementSize / 2;
	
	  // Compute the sideValue using the updated popper offsets
	  // take popper margin in account because we don't have this info available
	  var css = getStyleComputedProperty(data.instance.popper);
	  var popperMarginSide = parseFloat(css['margin' + sideCapitalized], 10);
	  var popperBorderSide = parseFloat(css['border' + sideCapitalized + 'Width'], 10);
	  var sideValue = center - data.offsets.popper[side] - popperMarginSide - popperBorderSide;
	
	  // prevent arrowElement from being placed not contiguously to its popper
	  sideValue = Math.max(Math.min(popper[len] - arrowElementSize, sideValue), 0);
	
	  data.arrowElement = arrowElement;
	  data.offsets.arrow = (_data$offsets$arrow = {}, defineProperty(_data$offsets$arrow, side, Math.round(sideValue)), defineProperty(_data$offsets$arrow, altSide, ''), _data$offsets$arrow);
	
	  return data;
	}
	
	/**
	 * Get the opposite placement variation of the given one
	 * @method
	 * @memberof Popper.Utils
	 * @argument {String} placement variation
	 * @returns {String} flipped placement variation
	 */
	function getOppositeVariation(variation) {
	  if (variation === 'end') {
	    return 'start';
	  } else if (variation === 'start') {
	    return 'end';
	  }
	  return variation;
	}
	
	/**
	 * List of accepted placements to use as values of the `placement` option.<br />
	 * Valid placements are:
	 * - `auto`
	 * - `top`
	 * - `right`
	 * - `bottom`
	 * - `left`
	 *
	 * Each placement can have a variation from this list:
	 * - `-start`
	 * - `-end`
	 *
	 * Variations are interpreted easily if you think of them as the left to right
	 * written languages. Horizontally (`top` and `bottom`), `start` is left and `end`
	 * is right.<br />
	 * Vertically (`left` and `right`), `start` is top and `end` is bottom.
	 *
	 * Some valid examples are:
	 * - `top-end` (on top of reference, right aligned)
	 * - `right-start` (on right of reference, top aligned)
	 * - `bottom` (on bottom, centered)
	 * - `auto-end` (on the side with more space available, alignment depends by placement)
	 *
	 * @static
	 * @type {Array}
	 * @enum {String}
	 * @readonly
	 * @method placements
	 * @memberof Popper
	 */
	var placements = ['auto-start', 'auto', 'auto-end', 'top-start', 'top', 'top-end', 'right-start', 'right', 'right-end', 'bottom-end', 'bottom', 'bottom-start', 'left-end', 'left', 'left-start'];
	
	// Get rid of `auto` `auto-start` and `auto-end`
	var validPlacements = placements.slice(3);
	
	/**
	 * Given an initial placement, returns all the subsequent placements
	 * clockwise (or counter-clockwise).
	 *
	 * @method
	 * @memberof Popper.Utils
	 * @argument {String} placement - A valid placement (it accepts variations)
	 * @argument {Boolean} counter - Set to true to walk the placements counterclockwise
	 * @returns {Array} placements including their variations
	 */
	function clockwise(placement) {
	  var counter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	  var index = validPlacements.indexOf(placement);
	  var arr = validPlacements.slice(index + 1).concat(validPlacements.slice(0, index));
	  return counter ? arr.reverse() : arr;
	}
	
	var BEHAVIORS = {
	  FLIP: 'flip',
	  CLOCKWISE: 'clockwise',
	  COUNTERCLOCKWISE: 'counterclockwise'
	};
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by update method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function flip(data, options) {
	  // if `inner` modifier is enabled, we can't use the `flip` modifier
	  if (isModifierEnabled(data.instance.modifiers, 'inner')) {
	    return data;
	  }
	
	  if (data.flipped && data.placement === data.originalPlacement) {
	    // seems like flip is trying to loop, probably there's not enough space on any of the flippable sides
	    return data;
	  }
	
	  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, options.boundariesElement, data.positionFixed);
	
	  var placement = data.placement.split('-')[0];
	  var placementOpposite = getOppositePlacement(placement);
	  var variation = data.placement.split('-')[1] || '';
	
	  var flipOrder = [];
	
	  switch (options.behavior) {
	    case BEHAVIORS.FLIP:
	      flipOrder = [placement, placementOpposite];
	      break;
	    case BEHAVIORS.CLOCKWISE:
	      flipOrder = clockwise(placement);
	      break;
	    case BEHAVIORS.COUNTERCLOCKWISE:
	      flipOrder = clockwise(placement, true);
	      break;
	    default:
	      flipOrder = options.behavior;
	  }
	
	  flipOrder.forEach(function (step, index) {
	    if (placement !== step || flipOrder.length === index + 1) {
	      return data;
	    }
	
	    placement = data.placement.split('-')[0];
	    placementOpposite = getOppositePlacement(placement);
	
	    var popperOffsets = data.offsets.popper;
	    var refOffsets = data.offsets.reference;
	
	    // using floor because the reference offsets may contain decimals we are not going to consider here
	    var floor = Math.floor;
	    var overlapsRef = placement === 'left' && floor(popperOffsets.right) > floor(refOffsets.left) || placement === 'right' && floor(popperOffsets.left) < floor(refOffsets.right) || placement === 'top' && floor(popperOffsets.bottom) > floor(refOffsets.top) || placement === 'bottom' && floor(popperOffsets.top) < floor(refOffsets.bottom);
	
	    var overflowsLeft = floor(popperOffsets.left) < floor(boundaries.left);
	    var overflowsRight = floor(popperOffsets.right) > floor(boundaries.right);
	    var overflowsTop = floor(popperOffsets.top) < floor(boundaries.top);
	    var overflowsBottom = floor(popperOffsets.bottom) > floor(boundaries.bottom);
	
	    var overflowsBoundaries = placement === 'left' && overflowsLeft || placement === 'right' && overflowsRight || placement === 'top' && overflowsTop || placement === 'bottom' && overflowsBottom;
	
	    // flip the variation if required
	    var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;
	
	    // flips variation if reference element overflows boundaries
	    var flippedVariationByRef = !!options.flipVariations && (isVertical && variation === 'start' && overflowsLeft || isVertical && variation === 'end' && overflowsRight || !isVertical && variation === 'start' && overflowsTop || !isVertical && variation === 'end' && overflowsBottom);
	
	    // flips variation if popper content overflows boundaries
	    var flippedVariationByContent = !!options.flipVariationsByContent && (isVertical && variation === 'start' && overflowsRight || isVertical && variation === 'end' && overflowsLeft || !isVertical && variation === 'start' && overflowsBottom || !isVertical && variation === 'end' && overflowsTop);
	
	    var flippedVariation = flippedVariationByRef || flippedVariationByContent;
	
	    if (overlapsRef || overflowsBoundaries || flippedVariation) {
	      // this boolean to detect any flip loop
	      data.flipped = true;
	
	      if (overlapsRef || overflowsBoundaries) {
	        placement = flipOrder[index + 1];
	      }
	
	      if (flippedVariation) {
	        variation = getOppositeVariation(variation);
	      }
	
	      data.placement = placement + (variation ? '-' + variation : '');
	
	      // this object contains `position`, we want to preserve it along with
	      // any additional property we may add in the future
	      data.offsets.popper = _extends({}, data.offsets.popper, getPopperOffsets(data.instance.popper, data.offsets.reference, data.placement));
	
	      data = runModifiers(data.instance.modifiers, data, 'flip');
	    }
	  });
	  return data;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by update method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function keepTogether(data) {
	  var _data$offsets = data.offsets,
	      popper = _data$offsets.popper,
	      reference = _data$offsets.reference;
	
	  var placement = data.placement.split('-')[0];
	  var floor = Math.floor;
	  var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;
	  var side = isVertical ? 'right' : 'bottom';
	  var opSide = isVertical ? 'left' : 'top';
	  var measurement = isVertical ? 'width' : 'height';
	
	  if (popper[side] < floor(reference[opSide])) {
	    data.offsets.popper[opSide] = floor(reference[opSide]) - popper[measurement];
	  }
	  if (popper[opSide] > floor(reference[side])) {
	    data.offsets.popper[opSide] = floor(reference[side]);
	  }
	
	  return data;
	}
	
	/**
	 * Converts a string containing value + unit into a px value number
	 * @function
	 * @memberof {modifiers~offset}
	 * @private
	 * @argument {String} str - Value + unit string
	 * @argument {String} measurement - `height` or `width`
	 * @argument {Object} popperOffsets
	 * @argument {Object} referenceOffsets
	 * @returns {Number|String}
	 * Value in pixels, or original string if no values were extracted
	 */
	function toValue(str, measurement, popperOffsets, referenceOffsets) {
	  // separate value from unit
	  var split = str.match(/((?:\-|\+)?\d*\.?\d*)(.*)/);
	  var value = +split[1];
	  var unit = split[2];
	
	  // If it's not a number it's an operator, I guess
	  if (!value) {
	    return str;
	  }
	
	  if (unit.indexOf('%') === 0) {
	    var element = void 0;
	    switch (unit) {
	      case '%p':
	        element = popperOffsets;
	        break;
	      case '%':
	      case '%r':
	      default:
	        element = referenceOffsets;
	    }
	
	    var rect = getClientRect(element);
	    return rect[measurement] / 100 * value;
	  } else if (unit === 'vh' || unit === 'vw') {
	    // if is a vh or vw, we calculate the size based on the viewport
	    var size = void 0;
	    if (unit === 'vh') {
	      size = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
	    } else {
	      size = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
	    }
	    return size / 100 * value;
	  } else {
	    // if is an explicit pixel unit, we get rid of the unit and keep the value
	    // if is an implicit unit, it's px, and we return just the value
	    return value;
	  }
	}
	
	/**
	 * Parse an `offset` string to extrapolate `x` and `y` numeric offsets.
	 * @function
	 * @memberof {modifiers~offset}
	 * @private
	 * @argument {String} offset
	 * @argument {Object} popperOffsets
	 * @argument {Object} referenceOffsets
	 * @argument {String} basePlacement
	 * @returns {Array} a two cells array with x and y offsets in numbers
	 */
	function parseOffset(offset, popperOffsets, referenceOffsets, basePlacement) {
	  var offsets = [0, 0];
	
	  // Use height if placement is left or right and index is 0 otherwise use width
	  // in this way the first offset will use an axis and the second one
	  // will use the other one
	  var useHeight = ['right', 'left'].indexOf(basePlacement) !== -1;
	
	  // Split the offset string to obtain a list of values and operands
	  // The regex addresses values with the plus or minus sign in front (+10, -20, etc)
	  var fragments = offset.split(/(\+|\-)/).map(function (frag) {
	    return frag.trim();
	  });
	
	  // Detect if the offset string contains a pair of values or a single one
	  // they could be separated by comma or space
	  var divider = fragments.indexOf(find(fragments, function (frag) {
	    return frag.search(/,|\s/) !== -1;
	  }));
	
	  if (fragments[divider] && fragments[divider].indexOf(',') === -1) {
	    console.warn('Offsets separated by white space(s) are deprecated, use a comma (,) instead.');
	  }
	
	  // If divider is found, we divide the list of values and operands to divide
	  // them by ofset X and Y.
	  var splitRegex = /\s*,\s*|\s+/;
	  var ops = divider !== -1 ? [fragments.slice(0, divider).concat([fragments[divider].split(splitRegex)[0]]), [fragments[divider].split(splitRegex)[1]].concat(fragments.slice(divider + 1))] : [fragments];
	
	  // Convert the values with units to absolute pixels to allow our computations
	  ops = ops.map(function (op, index) {
	    // Most of the units rely on the orientation of the popper
	    var measurement = (index === 1 ? !useHeight : useHeight) ? 'height' : 'width';
	    var mergeWithPrevious = false;
	    return op
	    // This aggregates any `+` or `-` sign that aren't considered operators
	    // e.g.: 10 + +5 => [10, +, +5]
	    .reduce(function (a, b) {
	      if (a[a.length - 1] === '' && ['+', '-'].indexOf(b) !== -1) {
	        a[a.length - 1] = b;
	        mergeWithPrevious = true;
	        return a;
	      } else if (mergeWithPrevious) {
	        a[a.length - 1] += b;
	        mergeWithPrevious = false;
	        return a;
	      } else {
	        return a.concat(b);
	      }
	    }, [])
	    // Here we convert the string values into number values (in px)
	    .map(function (str) {
	      return toValue(str, measurement, popperOffsets, referenceOffsets);
	    });
	  });
	
	  // Loop trough the offsets arrays and execute the operations
	  ops.forEach(function (op, index) {
	    op.forEach(function (frag, index2) {
	      if (isNumeric(frag)) {
	        offsets[index] += frag * (op[index2 - 1] === '-' ? -1 : 1);
	      }
	    });
	  });
	  return offsets;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by update method
	 * @argument {Object} options - Modifiers configuration and options
	 * @argument {Number|String} options.offset=0
	 * The offset value as described in the modifier description
	 * @returns {Object} The data object, properly modified
	 */
	function offset(data, _ref) {
	  var offset = _ref.offset;
	  var placement = data.placement,
	      _data$offsets = data.offsets,
	      popper = _data$offsets.popper,
	      reference = _data$offsets.reference;
	
	  var basePlacement = placement.split('-')[0];
	
	  var offsets = void 0;
	  if (isNumeric(+offset)) {
	    offsets = [+offset, 0];
	  } else {
	    offsets = parseOffset(offset, popper, reference, basePlacement);
	  }
	
	  if (basePlacement === 'left') {
	    popper.top += offsets[0];
	    popper.left -= offsets[1];
	  } else if (basePlacement === 'right') {
	    popper.top += offsets[0];
	    popper.left += offsets[1];
	  } else if (basePlacement === 'top') {
	    popper.left += offsets[0];
	    popper.top -= offsets[1];
	  } else if (basePlacement === 'bottom') {
	    popper.left += offsets[0];
	    popper.top += offsets[1];
	  }
	
	  data.popper = popper;
	  return data;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by `update` method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function preventOverflow(data, options) {
	  var boundariesElement = options.boundariesElement || getOffsetParent(data.instance.popper);
	
	  // If offsetParent is the reference element, we really want to
	  // go one step up and use the next offsetParent as reference to
	  // avoid to make this modifier completely useless and look like broken
	  if (data.instance.reference === boundariesElement) {
	    boundariesElement = getOffsetParent(boundariesElement);
	  }
	
	  // NOTE: DOM access here
	  // resets the popper's position so that the document size can be calculated excluding
	  // the size of the popper element itself
	  var transformProp = getSupportedPropertyName('transform');
	  var popperStyles = data.instance.popper.style; // assignment to help minification
	  var top = popperStyles.top,
	      left = popperStyles.left,
	      transform = popperStyles[transformProp];
	
	  popperStyles.top = '';
	  popperStyles.left = '';
	  popperStyles[transformProp] = '';
	
	  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, boundariesElement, data.positionFixed);
	
	  // NOTE: DOM access here
	  // restores the original style properties after the offsets have been computed
	  popperStyles.top = top;
	  popperStyles.left = left;
	  popperStyles[transformProp] = transform;
	
	  options.boundaries = boundaries;
	
	  var order = options.priority;
	  var popper = data.offsets.popper;
	
	  var check = {
	    primary: function primary(placement) {
	      var value = popper[placement];
	      if (popper[placement] < boundaries[placement] && !options.escapeWithReference) {
	        value = Math.max(popper[placement], boundaries[placement]);
	      }
	      return defineProperty({}, placement, value);
	    },
	    secondary: function secondary(placement) {
	      var mainSide = placement === 'right' ? 'left' : 'top';
	      var value = popper[mainSide];
	      if (popper[placement] > boundaries[placement] && !options.escapeWithReference) {
	        value = Math.min(popper[mainSide], boundaries[placement] - (placement === 'right' ? popper.width : popper.height));
	      }
	      return defineProperty({}, mainSide, value);
	    }
	  };
	
	  order.forEach(function (placement) {
	    var side = ['left', 'top'].indexOf(placement) !== -1 ? 'primary' : 'secondary';
	    popper = _extends({}, popper, check[side](placement));
	  });
	
	  data.offsets.popper = popper;
	
	  return data;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by `update` method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function shift(data) {
	  var placement = data.placement;
	  var basePlacement = placement.split('-')[0];
	  var shiftvariation = placement.split('-')[1];
	
	  // if shift shiftvariation is specified, run the modifier
	  if (shiftvariation) {
	    var _data$offsets = data.offsets,
	        reference = _data$offsets.reference,
	        popper = _data$offsets.popper;
	
	    var isVertical = ['bottom', 'top'].indexOf(basePlacement) !== -1;
	    var side = isVertical ? 'left' : 'top';
	    var measurement = isVertical ? 'width' : 'height';
	
	    var shiftOffsets = {
	      start: defineProperty({}, side, reference[side]),
	      end: defineProperty({}, side, reference[side] + reference[measurement] - popper[measurement])
	    };
	
	    data.offsets.popper = _extends({}, popper, shiftOffsets[shiftvariation]);
	  }
	
	  return data;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by update method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function hide(data) {
	  if (!isModifierRequired(data.instance.modifiers, 'hide', 'preventOverflow')) {
	    return data;
	  }
	
	  var refRect = data.offsets.reference;
	  var bound = find(data.instance.modifiers, function (modifier) {
	    return modifier.name === 'preventOverflow';
	  }).boundaries;
	
	  if (refRect.bottom < bound.top || refRect.left > bound.right || refRect.top > bound.bottom || refRect.right < bound.left) {
	    // Avoid unnecessary DOM access if visibility hasn't changed
	    if (data.hide === true) {
	      return data;
	    }
	
	    data.hide = true;
	    data.attributes['x-out-of-boundaries'] = '';
	  } else {
	    // Avoid unnecessary DOM access if visibility hasn't changed
	    if (data.hide === false) {
	      return data;
	    }
	
	    data.hide = false;
	    data.attributes['x-out-of-boundaries'] = false;
	  }
	
	  return data;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by `update` method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function inner(data) {
	  var placement = data.placement;
	  var basePlacement = placement.split('-')[0];
	  var _data$offsets = data.offsets,
	      popper = _data$offsets.popper,
	      reference = _data$offsets.reference;
	
	  var isHoriz = ['left', 'right'].indexOf(basePlacement) !== -1;
	
	  var subtractLength = ['top', 'left'].indexOf(basePlacement) === -1;
	
	  popper[isHoriz ? 'left' : 'top'] = reference[basePlacement] - (subtractLength ? popper[isHoriz ? 'width' : 'height'] : 0);
	
	  data.placement = getOppositePlacement(placement);
	  data.offsets.popper = getClientRect(popper);
	
	  return data;
	}
	
	/**
	 * Modifier function, each modifier can have a function of this type assigned
	 * to its `fn` property.<br />
	 * These functions will be called on each update, this means that you must
	 * make sure they are performant enough to avoid performance bottlenecks.
	 *
	 * @function ModifierFn
	 * @argument {dataObject} data - The data object generated by `update` method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {dataObject} The data object, properly modified
	 */
	
	/**
	 * Modifiers are plugins used to alter the behavior of your poppers.<br />
	 * Popper.js uses a set of 9 modifiers to provide all the basic functionalities
	 * needed by the library.
	 *
	 * Usually you don't want to override the `order`, `fn` and `onLoad` props.
	 * All the other properties are configurations that could be tweaked.
	 * @namespace modifiers
	 */
	var modifiers = {
	  /**
	   * Modifier used to shift the popper on the start or end of its reference
	   * element.<br />
	   * It will read the variation of the `placement` property.<br />
	   * It can be one either `-end` or `-start`.
	   * @memberof modifiers
	   * @inner
	   */
	  shift: {
	    /** @prop {number} order=100 - Index used to define the order of execution */
	    order: 100,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: shift
	  },
	
	  /**
	   * The `offset` modifier can shift your popper on both its axis.
	   *
	   * It accepts the following units:
	   * - `px` or unit-less, interpreted as pixels
	   * - `%` or `%r`, percentage relative to the length of the reference element
	   * - `%p`, percentage relative to the length of the popper element
	   * - `vw`, CSS viewport width unit
	   * - `vh`, CSS viewport height unit
	   *
	   * For length is intended the main axis relative to the placement of the popper.<br />
	   * This means that if the placement is `top` or `bottom`, the length will be the
	   * `width`. In case of `left` or `right`, it will be the `height`.
	   *
	   * You can provide a single value (as `Number` or `String`), or a pair of values
	   * as `String` divided by a comma or one (or more) white spaces.<br />
	   * The latter is a deprecated method because it leads to confusion and will be
	   * removed in v2.<br />
	   * Additionally, it accepts additions and subtractions between different units.
	   * Note that multiplications and divisions aren't supported.
	   *
	   * Valid examples are:
	   * ```
	   * 10
	   * '10%'
	   * '10, 10'
	   * '10%, 10'
	   * '10 + 10%'
	   * '10 - 5vh + 3%'
	   * '-10px + 5vh, 5px - 6%'
	   * ```
	   * > **NB**: If you desire to apply offsets to your poppers in a way that may make them overlap
	   * > with their reference element, unfortunately, you will have to disable the `flip` modifier.
	   * > You can read more on this at this [issue](https://github.com/FezVrasta/popper.js/issues/373).
	   *
	   * @memberof modifiers
	   * @inner
	   */
	  offset: {
	    /** @prop {number} order=200 - Index used to define the order of execution */
	    order: 200,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: offset,
	    /** @prop {Number|String} offset=0
	     * The offset value as described in the modifier description
	     */
	    offset: 0
	  },
	
	  /**
	   * Modifier used to prevent the popper from being positioned outside the boundary.
	   *
	   * A scenario exists where the reference itself is not within the boundaries.<br />
	   * We can say it has "escaped the boundaries" — or just "escaped".<br />
	   * In this case we need to decide whether the popper should either:
	   *
	   * - detach from the reference and remain "trapped" in the boundaries, or
	   * - if it should ignore the boundary and "escape with its reference"
	   *
	   * When `escapeWithReference` is set to`true` and reference is completely
	   * outside its boundaries, the popper will overflow (or completely leave)
	   * the boundaries in order to remain attached to the edge of the reference.
	   *
	   * @memberof modifiers
	   * @inner
	   */
	  preventOverflow: {
	    /** @prop {number} order=300 - Index used to define the order of execution */
	    order: 300,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: preventOverflow,
	    /**
	     * @prop {Array} [priority=['left','right','top','bottom']]
	     * Popper will try to prevent overflow following these priorities by default,
	     * then, it could overflow on the left and on top of the `boundariesElement`
	     */
	    priority: ['left', 'right', 'top', 'bottom'],
	    /**
	     * @prop {number} padding=5
	     * Amount of pixel used to define a minimum distance between the boundaries
	     * and the popper. This makes sure the popper always has a little padding
	     * between the edges of its container
	     */
	    padding: 5,
	    /**
	     * @prop {String|HTMLElement} boundariesElement='scrollParent'
	     * Boundaries used by the modifier. Can be `scrollParent`, `window`,
	     * `viewport` or any DOM element.
	     */
	    boundariesElement: 'scrollParent'
	  },
	
	  /**
	   * Modifier used to make sure the reference and its popper stay near each other
	   * without leaving any gap between the two. Especially useful when the arrow is
	   * enabled and you want to ensure that it points to its reference element.
	   * It cares only about the first axis. You can still have poppers with margin
	   * between the popper and its reference element.
	   * @memberof modifiers
	   * @inner
	   */
	  keepTogether: {
	    /** @prop {number} order=400 - Index used to define the order of execution */
	    order: 400,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: keepTogether
	  },
	
	  /**
	   * This modifier is used to move the `arrowElement` of the popper to make
	   * sure it is positioned between the reference element and its popper element.
	   * It will read the outer size of the `arrowElement` node to detect how many
	   * pixels of conjunction are needed.
	   *
	   * It has no effect if no `arrowElement` is provided.
	   * @memberof modifiers
	   * @inner
	   */
	  arrow: {
	    /** @prop {number} order=500 - Index used to define the order of execution */
	    order: 500,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: arrow,
	    /** @prop {String|HTMLElement} element='[x-arrow]' - Selector or node used as arrow */
	    element: '[x-arrow]'
	  },
	
	  /**
	   * Modifier used to flip the popper's placement when it starts to overlap its
	   * reference element.
	   *
	   * Requires the `preventOverflow` modifier before it in order to work.
	   *
	   * **NOTE:** this modifier will interrupt the current update cycle and will
	   * restart it if it detects the need to flip the placement.
	   * @memberof modifiers
	   * @inner
	   */
	  flip: {
	    /** @prop {number} order=600 - Index used to define the order of execution */
	    order: 600,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: flip,
	    /**
	     * @prop {String|Array} behavior='flip'
	     * The behavior used to change the popper's placement. It can be one of
	     * `flip`, `clockwise`, `counterclockwise` or an array with a list of valid
	     * placements (with optional variations)
	     */
	    behavior: 'flip',
	    /**
	     * @prop {number} padding=5
	     * The popper will flip if it hits the edges of the `boundariesElement`
	     */
	    padding: 5,
	    /**
	     * @prop {String|HTMLElement} boundariesElement='viewport'
	     * The element which will define the boundaries of the popper position.
	     * The popper will never be placed outside of the defined boundaries
	     * (except if `keepTogether` is enabled)
	     */
	    boundariesElement: 'viewport',
	    /**
	     * @prop {Boolean} flipVariations=false
	     * The popper will switch placement variation between `-start` and `-end` when
	     * the reference element overlaps its boundaries.
	     *
	     * The original placement should have a set variation.
	     */
	    flipVariations: false,
	    /**
	     * @prop {Boolean} flipVariationsByContent=false
	     * The popper will switch placement variation between `-start` and `-end` when
	     * the popper element overlaps its reference boundaries.
	     *
	     * The original placement should have a set variation.
	     */
	    flipVariationsByContent: false
	  },
	
	  /**
	   * Modifier used to make the popper flow toward the inner of the reference element.
	   * By default, when this modifier is disabled, the popper will be placed outside
	   * the reference element.
	   * @memberof modifiers
	   * @inner
	   */
	  inner: {
	    /** @prop {number} order=700 - Index used to define the order of execution */
	    order: 700,
	    /** @prop {Boolean} enabled=false - Whether the modifier is enabled or not */
	    enabled: false,
	    /** @prop {ModifierFn} */
	    fn: inner
	  },
	
	  /**
	   * Modifier used to hide the popper when its reference element is outside of the
	   * popper boundaries. It will set a `x-out-of-boundaries` attribute which can
	   * be used to hide with a CSS selector the popper when its reference is
	   * out of boundaries.
	   *
	   * Requires the `preventOverflow` modifier before it in order to work.
	   * @memberof modifiers
	   * @inner
	   */
	  hide: {
	    /** @prop {number} order=800 - Index used to define the order of execution */
	    order: 800,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: hide
	  },
	
	  /**
	   * Computes the style that will be applied to the popper element to gets
	   * properly positioned.
	   *
	   * Note that this modifier will not touch the DOM, it just prepares the styles
	   * so that `applyStyle` modifier can apply it. This separation is useful
	   * in case you need to replace `applyStyle` with a custom implementation.
	   *
	   * This modifier has `850` as `order` value to maintain backward compatibility
	   * with previous versions of Popper.js. Expect the modifiers ordering method
	   * to change in future major versions of the library.
	   *
	   * @memberof modifiers
	   * @inner
	   */
	  computeStyle: {
	    /** @prop {number} order=850 - Index used to define the order of execution */
	    order: 850,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: computeStyle,
	    /**
	     * @prop {Boolean} gpuAcceleration=true
	     * If true, it uses the CSS 3D transformation to position the popper.
	     * Otherwise, it will use the `top` and `left` properties
	     */
	    gpuAcceleration: true,
	    /**
	     * @prop {string} [x='bottom']
	     * Where to anchor the X axis (`bottom` or `top`). AKA X offset origin.
	     * Change this if your popper should grow in a direction different from `bottom`
	     */
	    x: 'bottom',
	    /**
	     * @prop {string} [x='left']
	     * Where to anchor the Y axis (`left` or `right`). AKA Y offset origin.
	     * Change this if your popper should grow in a direction different from `right`
	     */
	    y: 'right'
	  },
	
	  /**
	   * Applies the computed styles to the popper element.
	   *
	   * All the DOM manipulations are limited to this modifier. This is useful in case
	   * you want to integrate Popper.js inside a framework or view library and you
	   * want to delegate all the DOM manipulations to it.
	   *
	   * Note that if you disable this modifier, you must make sure the popper element
	   * has its position set to `absolute` before Popper.js can do its work!
	   *
	   * Just disable this modifier and define your own to achieve the desired effect.
	   *
	   * @memberof modifiers
	   * @inner
	   */
	  applyStyle: {
	    /** @prop {number} order=900 - Index used to define the order of execution */
	    order: 900,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: applyStyle,
	    /** @prop {Function} */
	    onLoad: applyStyleOnLoad,
	    /**
	     * @deprecated since version 1.10.0, the property moved to `computeStyle` modifier
	     * @prop {Boolean} gpuAcceleration=true
	     * If true, it uses the CSS 3D transformation to position the popper.
	     * Otherwise, it will use the `top` and `left` properties
	     */
	    gpuAcceleration: undefined
	  }
	};
	
	/**
	 * The `dataObject` is an object containing all the information used by Popper.js.
	 * This object is passed to modifiers and to the `onCreate` and `onUpdate` callbacks.
	 * @name dataObject
	 * @property {Object} data.instance The Popper.js instance
	 * @property {String} data.placement Placement applied to popper
	 * @property {String} data.originalPlacement Placement originally defined on init
	 * @property {Boolean} data.flipped True if popper has been flipped by flip modifier
	 * @property {Boolean} data.hide True if the reference element is out of boundaries, useful to know when to hide the popper
	 * @property {HTMLElement} data.arrowElement Node used as arrow by arrow modifier
	 * @property {Object} data.styles Any CSS property defined here will be applied to the popper. It expects the JavaScript nomenclature (eg. `marginBottom`)
	 * @property {Object} data.arrowStyles Any CSS property defined here will be applied to the popper arrow. It expects the JavaScript nomenclature (eg. `marginBottom`)
	 * @property {Object} data.boundaries Offsets of the popper boundaries
	 * @property {Object} data.offsets The measurements of popper, reference and arrow elements
	 * @property {Object} data.offsets.popper `top`, `left`, `width`, `height` values
	 * @property {Object} data.offsets.reference `top`, `left`, `width`, `height` values
	 * @property {Object} data.offsets.arrow] `top` and `left` offsets, only one of them will be different from 0
	 */
	
	/**
	 * Default options provided to Popper.js constructor.<br />
	 * These can be overridden using the `options` argument of Popper.js.<br />
	 * To override an option, simply pass an object with the same
	 * structure of the `options` object, as the 3rd argument. For example:
	 * ```
	 * new Popper(ref, pop, {
	 *   modifiers: {
	 *     preventOverflow: { enabled: false }
	 *   }
	 * })
	 * ```
	 * @type {Object}
	 * @static
	 * @memberof Popper
	 */
	var Defaults = {
	  /**
	   * Popper's placement.
	   * @prop {Popper.placements} placement='bottom'
	   */
	  placement: 'bottom',
	
	  /**
	   * Set this to true if you want popper to position it self in 'fixed' mode
	   * @prop {Boolean} positionFixed=false
	   */
	  positionFixed: false,
	
	  /**
	   * Whether events (resize, scroll) are initially enabled.
	   * @prop {Boolean} eventsEnabled=true
	   */
	  eventsEnabled: true,
	
	  /**
	   * Set to true if you want to automatically remove the popper when
	   * you call the `destroy` method.
	   * @prop {Boolean} removeOnDestroy=false
	   */
	  removeOnDestroy: false,
	
	  /**
	   * Callback called when the popper is created.<br />
	   * By default, it is set to no-op.<br />
	   * Access Popper.js instance with `data.instance`.
	   * @prop {onCreate}
	   */
	  onCreate: function onCreate() {},
	
	  /**
	   * Callback called when the popper is updated. This callback is not called
	   * on the initialization/creation of the popper, but only on subsequent
	   * updates.<br />
	   * By default, it is set to no-op.<br />
	   * Access Popper.js instance with `data.instance`.
	   * @prop {onUpdate}
	   */
	  onUpdate: function onUpdate() {},
	
	  /**
	   * List of modifiers used to modify the offsets before they are applied to the popper.
	   * They provide most of the functionalities of Popper.js.
	   * @prop {modifiers}
	   */
	  modifiers: modifiers
	};
	
	/**
	 * @callback onCreate
	 * @param {dataObject} data
	 */
	
	/**
	 * @callback onUpdate
	 * @param {dataObject} data
	 */
	
	// Utils
	// Methods
	var Popper = function () {
	  /**
	   * Creates a new Popper.js instance.
	   * @class Popper
	   * @param {Element|referenceObject} reference - The reference element used to position the popper
	   * @param {Element} popper - The HTML / XML element used as the popper
	   * @param {Object} options - Your custom options to override the ones defined in [Defaults](#defaults)
	   * @return {Object} instance - The generated Popper.js instance
	   */
	  function Popper(reference, popper) {
	    var _this = this;
	
	    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    classCallCheck(this, Popper);
	
	    this.scheduleUpdate = function () {
	      return requestAnimationFrame(_this.update);
	    };
	
	    // make update() debounced, so that it only runs at most once-per-tick
	    this.update = debounce(this.update.bind(this));
	
	    // with {} we create a new object with the options inside it
	    this.options = _extends({}, Popper.Defaults, options);
	
	    // init state
	    this.state = {
	      isDestroyed: false,
	      isCreated: false,
	      scrollParents: []
	    };
	
	    // get reference and popper elements (allow jQuery wrappers)
	    this.reference = reference && reference.jquery ? reference[0] : reference;
	    this.popper = popper && popper.jquery ? popper[0] : popper;
	
	    // Deep merge modifiers options
	    this.options.modifiers = {};
	    Object.keys(_extends({}, Popper.Defaults.modifiers, options.modifiers)).forEach(function (name) {
	      _this.options.modifiers[name] = _extends({}, Popper.Defaults.modifiers[name] || {}, options.modifiers ? options.modifiers[name] : {});
	    });
	
	    // Refactoring modifiers' list (Object => Array)
	    this.modifiers = Object.keys(this.options.modifiers).map(function (name) {
	      return _extends({
	        name: name
	      }, _this.options.modifiers[name]);
	    })
	    // sort the modifiers by order
	    .sort(function (a, b) {
	      return a.order - b.order;
	    });
	
	    // modifiers have the ability to execute arbitrary code when Popper.js get inited
	    // such code is executed in the same order of its modifier
	    // they could add new properties to their options configuration
	    // BE AWARE: don't add options to `options.modifiers.name` but to `modifierOptions`!
	    this.modifiers.forEach(function (modifierOptions) {
	      if (modifierOptions.enabled && isFunction(modifierOptions.onLoad)) {
	        modifierOptions.onLoad(_this.reference, _this.popper, _this.options, modifierOptions, _this.state);
	      }
	    });
	
	    // fire the first update to position the popper in the right place
	    this.update();
	
	    var eventsEnabled = this.options.eventsEnabled;
	    if (eventsEnabled) {
	      // setup event listeners, they will take care of update the position in specific situations
	      this.enableEventListeners();
	    }
	
	    this.state.eventsEnabled = eventsEnabled;
	  }
	
	  // We can't use class properties because they don't get listed in the
	  // class prototype and break stuff like Sinon stubs
	
	
	  createClass(Popper, [{
	    key: 'update',
	    value: function update$$1() {
	      return update.call(this);
	    }
	  }, {
	    key: 'destroy',
	    value: function destroy$$1() {
	      return destroy.call(this);
	    }
	  }, {
	    key: 'enableEventListeners',
	    value: function enableEventListeners$$1() {
	      return enableEventListeners.call(this);
	    }
	  }, {
	    key: 'disableEventListeners',
	    value: function disableEventListeners$$1() {
	      return disableEventListeners.call(this);
	    }
	
	    /**
	     * Schedules an update. It will run on the next UI update available.
	     * @method scheduleUpdate
	     * @memberof Popper
	     */
	
	
	    /**
	     * Collection of utilities useful when writing custom modifiers.
	     * Starting from version 1.7, this method is available only if you
	     * include `popper-utils.js` before `popper.js`.
	     *
	     * **DEPRECATION**: This way to access PopperUtils is deprecated
	     * and will be removed in v2! Use the PopperUtils module directly instead.
	     * Due to the high instability of the methods contained in Utils, we can't
	     * guarantee them to follow semver. Use them at your own risk!
	     * @static
	     * @private
	     * @type {Object}
	     * @deprecated since version 1.8
	     * @member Utils
	     * @memberof Popper
	     */
	
	  }]);
	  return Popper;
	}();
	
	/**
	 * The `referenceObject` is an object that provides an interface compatible with Popper.js
	 * and lets you use it as replacement of a real DOM node.<br />
	 * You can use this method to position a popper relatively to a set of coordinates
	 * in case you don't have a DOM node to use as reference.
	 *
	 * ```
	 * new Popper(referenceObject, popperNode);
	 * ```
	 *
	 * NB: This feature isn't supported in Internet Explorer 10.
	 * @name referenceObject
	 * @property {Function} data.getBoundingClientRect
	 * A function that returns a set of coordinates compatible with the native `getBoundingClientRect` method.
	 * @property {number} data.clientWidth
	 * An ES6 getter that will return the width of the virtual reference element.
	 * @property {number} data.clientHeight
	 * An ES6 getter that will return the height of the virtual reference element.
	 */
	
	
	Popper.Utils = (typeof window !== 'undefined' ? window : global).PopperUtils;
	Popper.placements = placements;
	Popper.Defaults = Defaults;
	
	return Popper;
	
	})));
	//# sourceMappingURL=popper.js.map
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 2103 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(2104);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(1718)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../css-loader/index.js!./react-datepicker.css", function() {
				var newContent = require("!!./../../css-loader/index.js!./react-datepicker.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2104 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1717)();
	// imports
	
	
	// module
	exports.push([module.id, ".react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle,.react-datepicker-popper[data-placement^=top] .react-datepicker__triangle,.react-datepicker__month-read-view--down-arrow,.react-datepicker__month-year-read-view--down-arrow,.react-datepicker__year-read-view--down-arrow{margin-left:-8px;position:absolute}.react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle,.react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle:before,.react-datepicker-popper[data-placement^=top] .react-datepicker__triangle,.react-datepicker-popper[data-placement^=top] .react-datepicker__triangle:before,.react-datepicker__month-read-view--down-arrow,.react-datepicker__month-read-view--down-arrow:before,.react-datepicker__month-year-read-view--down-arrow,.react-datepicker__month-year-read-view--down-arrow:before,.react-datepicker__year-read-view--down-arrow,.react-datepicker__year-read-view--down-arrow:before{box-sizing:content-box;position:absolute;border:8px solid transparent;height:0;width:1px}.react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle:before,.react-datepicker-popper[data-placement^=top] .react-datepicker__triangle:before,.react-datepicker__month-read-view--down-arrow:before,.react-datepicker__month-year-read-view--down-arrow:before,.react-datepicker__year-read-view--down-arrow:before{content:\"\";z-index:-1;border-width:8px;left:-8px;border-bottom-color:#aeaeae}.react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle{top:0;margin-top:-8px}.react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle,.react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle:before{border-top:none;border-bottom-color:#f0f0f0}.react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle:before{top:-1px;border-bottom-color:#aeaeae}.react-datepicker-popper[data-placement^=top] .react-datepicker__triangle,.react-datepicker__month-read-view--down-arrow,.react-datepicker__month-year-read-view--down-arrow,.react-datepicker__year-read-view--down-arrow{bottom:0;margin-bottom:-8px}.react-datepicker-popper[data-placement^=top] .react-datepicker__triangle,.react-datepicker-popper[data-placement^=top] .react-datepicker__triangle:before,.react-datepicker__month-read-view--down-arrow,.react-datepicker__month-read-view--down-arrow:before,.react-datepicker__month-year-read-view--down-arrow,.react-datepicker__month-year-read-view--down-arrow:before,.react-datepicker__year-read-view--down-arrow,.react-datepicker__year-read-view--down-arrow:before{border-bottom:none;border-top-color:#fff}.react-datepicker-popper[data-placement^=top] .react-datepicker__triangle:before,.react-datepicker__month-read-view--down-arrow:before,.react-datepicker__month-year-read-view--down-arrow:before,.react-datepicker__year-read-view--down-arrow:before{bottom:-1px;border-top-color:#aeaeae}.react-datepicker,.react-datepicker-wrapper{display:inline-block}.react-datepicker{font-family:Helvetica Neue,Helvetica,Arial,sans-serif;font-size:.8rem;background-color:#fff;color:#000;border:1px solid #aeaeae;border-radius:.3rem;position:relative}.react-datepicker--time-only .react-datepicker__triangle{left:35px}.react-datepicker--time-only .react-datepicker__time-container{border-left:0}.react-datepicker--time-only .react-datepicker__time,.react-datepicker--time-only .react-datepicker__time-box{border-radius:.3rem}.react-datepicker__triangle{position:absolute;left:50px}.react-datepicker-popper{z-index:1}.react-datepicker-popper[data-placement^=bottom]{margin-top:10px}.react-datepicker-popper[data-placement^=top]{margin-bottom:10px}.react-datepicker-popper[data-placement^=right]{margin-left:8px}.react-datepicker-popper[data-placement^=right] .react-datepicker__triangle{left:auto;right:42px}.react-datepicker-popper[data-placement^=left]{margin-right:8px}.react-datepicker-popper[data-placement^=left] .react-datepicker__triangle{left:42px;right:auto}.react-datepicker__header{text-align:center;background-color:#f0f0f0;border-bottom:1px solid #aeaeae;border-top-left-radius:.3rem;border-top-right-radius:.3rem;padding-top:8px;position:relative}.react-datepicker__header--time{padding-bottom:8px;padding-left:5px;padding-right:5px}.react-datepicker__month-dropdown-container--scroll,.react-datepicker__month-dropdown-container--select,.react-datepicker__month-year-dropdown-container--scroll,.react-datepicker__month-year-dropdown-container--select,.react-datepicker__year-dropdown-container--scroll,.react-datepicker__year-dropdown-container--select{display:inline-block;margin:0 2px}.react-datepicker-time__header,.react-datepicker__current-month{margin-top:0;color:#000;font-weight:700;font-size:.944rem}.react-datepicker-time__header{text-overflow:ellipsis;white-space:nowrap;overflow:hidden}.react-datepicker__navigation{background:none;line-height:1.7rem;text-align:center;cursor:pointer;position:absolute;top:10px;width:0;padding:0;border:.45rem solid transparent;z-index:1}.react-datepicker__navigation--previous{left:10px;border-right-color:#ccc}.react-datepicker__navigation--previous:hover{border-right-color:#b3b3b3}.react-datepicker__navigation--previous--disabled,.react-datepicker__navigation--previous--disabled:hover{border-right-color:#e6e6e6;cursor:default}.react-datepicker__navigation--next{right:10px;border-left-color:#ccc}.react-datepicker__navigation--next--with-time:not(.react-datepicker__navigation--next--with-today-button){right:80px}.react-datepicker__navigation--next:hover{border-left-color:#b3b3b3}.react-datepicker__navigation--next--disabled,.react-datepicker__navigation--next--disabled:hover{border-left-color:#e6e6e6;cursor:default}.react-datepicker__navigation--years{position:relative;top:0;display:block;margin-left:auto;margin-right:auto}.react-datepicker__navigation--years-previous{top:4px;border-top-color:#ccc}.react-datepicker__navigation--years-previous:hover{border-top-color:#b3b3b3}.react-datepicker__navigation--years-upcoming{top:-4px;border-bottom-color:#ccc}.react-datepicker__navigation--years-upcoming:hover{border-bottom-color:#b3b3b3}.react-datepicker__month-container{float:left}.react-datepicker__month{margin:.4rem;text-align:center}.react-datepicker__time-container{float:right;border-left:1px solid #aeaeae;width:70px}.react-datepicker__time-container--with-today-button{display:inline;border:1px solid #aeaeae;border-radius:.3rem;position:absolute;right:-72px;top:0}.react-datepicker__time-container .react-datepicker__time{position:relative;background:#fff}.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box{width:70px;overflow-x:hidden;margin:0 auto;text-align:center}.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list{list-style:none;margin:0;height:calc(195px + 0.85rem);overflow-y:scroll;padding-right:30px;width:100%;box-sizing:content-box}.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item{padding:5px 10px}.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item:hover{cursor:pointer;background-color:#f0f0f0}.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--selected{background-color:#216ba5;color:#fff;font-weight:700}.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--selected:hover{background-color:#216ba5}.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--disabled{color:#ccc}.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--disabled:hover{cursor:default;background-color:transparent}.react-datepicker__week-number{color:#ccc;display:inline-block;width:1.7rem;line-height:1.7rem;text-align:center;margin:.166rem}.react-datepicker__week-number.react-datepicker__week-number--clickable{cursor:pointer}.react-datepicker__week-number.react-datepicker__week-number--clickable:hover{border-radius:.3rem;background-color:#f0f0f0}.react-datepicker__day-names,.react-datepicker__week{white-space:nowrap}.react-datepicker__day,.react-datepicker__day-name,.react-datepicker__time-name{color:#000;display:inline-block;width:1.7rem;line-height:1.7rem;text-align:center;margin:.166rem}.react-datepicker__day{cursor:pointer}.react-datepicker__day:hover{border-radius:.3rem;background-color:#f0f0f0}.react-datepicker__day--today{font-weight:700}.react-datepicker__day--highlighted{border-radius:.3rem;background-color:#3dcc4a;color:#fff}.react-datepicker__day--highlighted:hover{background-color:#32be3f}.react-datepicker__day--highlighted-custom-1{color:#f0f}.react-datepicker__day--highlighted-custom-2{color:green}.react-datepicker__day--in-range,.react-datepicker__day--in-selecting-range,.react-datepicker__day--selected{border-radius:.3rem;background-color:#216ba5;color:#fff}.react-datepicker__day--in-range:hover,.react-datepicker__day--in-selecting-range:hover,.react-datepicker__day--selected:hover{background-color:#1d5d90}.react-datepicker__day--keyboard-selected{border-radius:.3rem;background-color:#2a87d0;color:#fff}.react-datepicker__day--keyboard-selected:hover{background-color:#1d5d90}.react-datepicker__day--in-selecting-range:not(.react-datepicker__day--in-range){background-color:rgba(33,107,165,.5)}.react-datepicker__month--selecting-range .react-datepicker__day--in-range:not(.react-datepicker__day--in-selecting-range){background-color:#f0f0f0;color:#000}.react-datepicker__day--disabled{cursor:default;color:#ccc}.react-datepicker__day--disabled:hover{background-color:transparent}.react-datepicker__input-container{position:relative;display:inline-block}.react-datepicker__month-read-view,.react-datepicker__month-year-read-view,.react-datepicker__year-read-view{border:1px solid transparent;border-radius:.3rem}.react-datepicker__month-read-view:hover,.react-datepicker__month-year-read-view:hover,.react-datepicker__year-read-view:hover{cursor:pointer}.react-datepicker__month-read-view:hover .react-datepicker__month-read-view--down-arrow,.react-datepicker__month-read-view:hover .react-datepicker__year-read-view--down-arrow,.react-datepicker__month-year-read-view:hover .react-datepicker__month-read-view--down-arrow,.react-datepicker__month-year-read-view:hover .react-datepicker__year-read-view--down-arrow,.react-datepicker__year-read-view:hover .react-datepicker__month-read-view--down-arrow,.react-datepicker__year-read-view:hover .react-datepicker__year-read-view--down-arrow{border-top-color:#b3b3b3}.react-datepicker__month-read-view--down-arrow,.react-datepicker__month-year-read-view--down-arrow,.react-datepicker__year-read-view--down-arrow{border-top-color:#ccc;float:right;margin-left:20px;top:8px;position:relative;border-width:.45rem}.react-datepicker__month-dropdown,.react-datepicker__month-year-dropdown,.react-datepicker__year-dropdown{background-color:#f0f0f0;position:absolute;width:50%;left:25%;top:30px;z-index:1;text-align:center;border-radius:.3rem;border:1px solid #aeaeae}.react-datepicker__month-dropdown:hover,.react-datepicker__month-year-dropdown:hover,.react-datepicker__year-dropdown:hover{cursor:pointer}.react-datepicker__month-dropdown--scrollable,.react-datepicker__month-year-dropdown--scrollable,.react-datepicker__year-dropdown--scrollable{height:150px;overflow-y:scroll}.react-datepicker__month-option,.react-datepicker__month-year-option,.react-datepicker__year-option{line-height:20px;width:100%;display:block;margin-left:auto;margin-right:auto}.react-datepicker__month-option:first-of-type,.react-datepicker__month-year-option:first-of-type,.react-datepicker__year-option:first-of-type{border-top-left-radius:.3rem;border-top-right-radius:.3rem}.react-datepicker__month-option:last-of-type,.react-datepicker__month-year-option:last-of-type,.react-datepicker__year-option:last-of-type{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;border-bottom-left-radius:.3rem;border-bottom-right-radius:.3rem}.react-datepicker__month-option:hover,.react-datepicker__month-year-option:hover,.react-datepicker__year-option:hover{background-color:#ccc}.react-datepicker__month-option:hover .react-datepicker__navigation--years-upcoming,.react-datepicker__month-year-option:hover .react-datepicker__navigation--years-upcoming,.react-datepicker__year-option:hover .react-datepicker__navigation--years-upcoming{border-bottom-color:#b3b3b3}.react-datepicker__month-option:hover .react-datepicker__navigation--years-previous,.react-datepicker__month-year-option:hover .react-datepicker__navigation--years-previous,.react-datepicker__year-option:hover .react-datepicker__navigation--years-previous{border-top-color:#b3b3b3}.react-datepicker__month-option--selected,.react-datepicker__month-year-option--selected,.react-datepicker__year-option--selected{position:absolute;left:15px}.react-datepicker__close-icon{background-color:transparent;border:0;cursor:pointer;display:inline-block;height:0;outline:0;padding:0;vertical-align:middle}.react-datepicker__close-icon:after{background-color:#216ba5;border-radius:50%;bottom:0;box-sizing:border-box;color:#fff;content:\"\\D7\";cursor:pointer;font-size:12px;height:16px;width:16px;line-height:1;margin:-8px auto 0;padding:2px;position:absolute;right:7px;text-align:center;top:50%}.react-datepicker__today-button{background:#f0f0f0;border-top:1px solid #aeaeae;cursor:pointer;text-align:center;font-weight:700;padding:5px 0;clear:left}.react-datepicker__portal{position:fixed;width:100vw;height:100vh;background-color:rgba(0,0,0,.8);left:0;top:0;justify-content:center;align-items:center;display:flex;z-index:2147483647}.react-datepicker__portal .react-datepicker__day,.react-datepicker__portal .react-datepicker__day-name,.react-datepicker__portal .react-datepicker__time-name{width:3rem;line-height:3rem}@media (max-height:550px),(max-width:400px){.react-datepicker__portal .react-datepicker__day,.react-datepicker__portal .react-datepicker__day-name,.react-datepicker__portal .react-datepicker__time-name{width:2rem;line-height:2rem}}.react-datepicker__portal .react-datepicker-time__header,.react-datepicker__portal .react-datepicker__current-month{font-size:1.44rem}.react-datepicker__portal .react-datepicker__navigation{border:.81rem solid transparent}.react-datepicker__portal .react-datepicker__navigation--previous{border-right-color:#ccc}.react-datepicker__portal .react-datepicker__navigation--previous:hover{border-right-color:#b3b3b3}.react-datepicker__portal .react-datepicker__navigation--previous--disabled,.react-datepicker__portal .react-datepicker__navigation--previous--disabled:hover{border-right-color:#e6e6e6;cursor:default}.react-datepicker__portal .react-datepicker__navigation--next{border-left-color:#ccc}.react-datepicker__portal .react-datepicker__navigation--next:hover{border-left-color:#b3b3b3}.react-datepicker__portal .react-datepicker__navigation--next--disabled,.react-datepicker__portal .react-datepicker__navigation--next--disabled:hover{border-left-color:#e6e6e6;cursor:default}", ""]);
	
	// exports


/***/ }),
/* 2105 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(332);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _materialUi = __webpack_require__(576);
	
	var _set = __webpack_require__(1188);
	
	var _set2 = _interopRequireDefault(_set);
	
	var _get = __webpack_require__(1004);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _cloneDeep = __webpack_require__(1189);
	
	var _cloneDeep2 = _interopRequireDefault(_cloneDeep);
	
	var _mapValues = __webpack_require__(1480);
	
	var _mapValues2 = _interopRequireDefault(_mapValues);
	
	var _throttle = __webpack_require__(641);
	
	var _throttle2 = _interopRequireDefault(_throttle);
	
	var _configuratorSection = __webpack_require__(2106);
	
	var _configuratorSection2 = _interopRequireDefault(_configuratorSection);
	
	var _connectToStores = __webpack_require__(1226);
	
	var _connectToStores2 = _interopRequireDefault(_connectToStores);
	
	var _EventBucketActions = __webpack_require__(1218);
	
	var _EventBucketActions2 = _interopRequireDefault(_EventBucketActions);
	
	var _EventBucketStore = __webpack_require__(1593);
	
	var _EventBucketStore2 = _interopRequireDefault(_EventBucketStore);
	
	var _UserStore = __webpack_require__(974);
	
	var _UserStore2 = _interopRequireDefault(_UserStore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var EventBucketConfigurator = function (_React$Component) {
	  _inherits(EventBucketConfigurator, _React$Component);
	
	  function EventBucketConfigurator(props) {
	    _classCallCheck(this, EventBucketConfigurator);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(EventBucketConfigurator).call(this, props));
	
	    _this.state = {
	      iframeLoading: true,
	      tabIndex: null,
	      currentSection: null,
	      eventBucket: null,
	      currentForcedBucket: null,
	      config: null,
	      hasUnsavedChanges: false,
	      isSaving: false,
	      lastUpdated: null,
	      fullWidthControls: false,
	      forceFullWidthControls: false,
	      iframeWidth: null
	    };
	
	    _this.changeTab = _this.changeTab.bind(_this);
	    _this.onTabChange = _this.onTabChange.bind(_this);
	
	    _this._postMessage = _this._postMessage.bind(_this);
	
	    // Debounced to prevent laggy UI (e.g. while typing text)
	    _this.updatePreview = (0, _throttle2.default)(_this.updatePreview.bind(_this), 250);
	
	    _this.onConfigFocus = _this.onConfigFocus.bind(_this);
	    _this.onConfigBlur = _this.onConfigBlur.bind(_this);
	    _this.onConfigChange = _this.onConfigChange.bind(_this);
	    _this.onForcePreview = _this.onForcePreview.bind(_this);
	    _this.onEndForcePreview = _this.onEndForcePreview.bind(_this);
	
	    _this.close = _this.close.bind(_this);
	    _this.save = _this.save.bind(_this);
	    _this.toggleFullWidth = _this.toggleFullWidth.bind(_this);
	
	    _this.onResize = _this.onResize.bind(_this);
	
	    _this.iframe = null;
	    _this.container = null;
	    _this.sectionContainer = null;
	    return _this;
	  }
	
	  _createClass(EventBucketConfigurator, [{
	    key: "changeTab",
	
	
	    // Actually change the tab displayed in UI
	    value: function changeTab(key, props) {
	      var _this2 = this;
	
	      props = props || this.props;
	
	      var index = props.getConfigSchema(props.params.eventBucketId).sections.findIndex(function (s) {
	        return s.key === key;
	      });
	
	      this.setState({
	        tabIndex: index,
	        currentSection: props.getConfigSchema(props.params.eventBucketId).sections[index]
	      }, function () {
	        // Scroll to top of section
	        _reactDom2.default.findDOMNode(_this2.sectionContainer).parentNode.scrollTop = 0;
	
	        _this2.onConfigFocus(_this2.state.currentSection.key, _this2.state.currentSection);
	      });
	    }
	
	    // When the user attempts to change tabs - push the new url
	
	  }, {
	    key: "onTabChange",
	    value: function onTabChange(tabIndex, props) {
	      props = props || this.props;
	
	      // https://github.com/callemall/material-ui/issues/2189
	      if (typeof tabIndex !== "number") {
	        return;
	      }
	
	      var key = props.getConfigSchema(props.params.eventBucketId).sections[tabIndex].key;
	      this.context.router.push("/event_buckets/" + props.params.eventBucketId + "/settings/configurator/" + key);
	    }
	  }, {
	    key: "_postMessage",
	    value: function _postMessage(name, data) {
	      if (!this.iframe) {
	        return;
	      }
	
	      var targetWindow = this.iframe.contentWindow;
	
	      targetWindow.postMessage({
	        name: name,
	        value: data
	      }, (undefined) || this.state.eventBucket.urls.root);
	    }
	  }, {
	    key: "updatePreview",
	    value: function updatePreview() {
	      this._postMessage("tenant-update", this.state.config);
	    }
	  }, {
	    key: "onConfigFocus",
	    value: function onConfigFocus(key) {
	      var item = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	      var value = arguments.length <= 2 || arguments[2] === undefined ? {} : arguments[2];
	
	      if (key === "menus") {
	        this._postMessage("open-left-nav");
	      } else if (item.preview_location) {
	        var location = (0, _cloneDeep2.default)(item.preview_location);
	        if (item.preview_location.dynamic) {
	          location.params = (0, _mapValues2.default)(location.params, function (v) {
	            // Support @value|property_name for dynamic values based on
	            // the focused config item's value.
	            var VALUE_KEY = "@value|";
	            if (v.indexOf(VALUE_KEY) === 0) {
	              return value[v.substring(VALUE_KEY.length)];
	            }
	
	            return v;
	          });
	        }
	
	        this._postMessage("go-to-location", location);
	      } else if (this.state.currentSection.key !== "menus") {
	        this._postMessage("close-left-nav");
	      }
	
	      this.setState({
	        fullWidthControls: ["misc", "virtual"].includes(this.state.currentSection.key)
	      });
	    }
	  }, {
	    key: "onConfigBlur",
	    value: function onConfigBlur(key) {
	      var item = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	
	      if (item.preview_blur_location) {
	        this._postMessage("go-to-location", item.preview_blur_location);
	      }
	    }
	  }, {
	    key: "onConfigChange",
	    value: function onConfigChange(key, value) {
	      var _this3 = this;
	
	      var options = arguments.length <= 2 || arguments[2] === undefined ? {} : arguments[2];
	
	      if (options.file) {
	        this.onConfigFileUpload(key, value);
	        return;
	      }
	
	      var config = Object.assign({}, this.state.config);
	      (0, _set2.default)(config, key, value);
	      this.setState({ config: config, hasUnsavedChanges: true }, function () {
	        _this3.updatePreview();
	      });
	    }
	  }, {
	    key: "onConfigFileUpload",
	    value: function onConfigFileUpload(key, file) {
	      _EventBucketActions2.default.uploadFile(this.props.params.eventBucketId, key, file);
	    }
	  }, {
	    key: "onForcePreview",
	    value: function onForcePreview(settings, item) {
	      var _this4 = this;
	
	      this.setState({
	        currentForcedBucket: Object.assign({}, this.state.currentForcedBucket, settings)
	      }, function () {
	        var tempBucket = Object.assign({}, _this4.state.eventBucket, _this4.state.currentForcedBucket);
	        _this4._postMessage("force-event-bucket", tempBucket);
	        // trigger refresh
	        if (item) {
	          _this4.onConfigFocus(item.key, item, (0, _get2.default)(_this4.state.config, item.key));
	        }
	      });
	    }
	  }, {
	    key: "onEndForcePreview",
	    value: function onEndForcePreview(settings) {
	      var _this5 = this;
	
	      var newForcedBucket = Object.assign({}, this.state.currentForcedBucket);
	
	      Object.keys(settings).map(function (k) {
	        delete newForcedBucket[k];
	      });
	
	      this.setState({
	        currentForcedBucket: Object.keys(newForcedBucket).length ? newForcedBucket : null
	      }, function () {
	        _this5._postMessage("force-event-bucket", _this5.state.currentForcedBucket || _this5.state.eventBucket);
	      });
	    }
	  }, {
	    key: "close",
	    value: function close() {
	      this.context.router.push("/event_buckets/" + this.props.params.eventBucketId + "/settings");
	    }
	  }, {
	    key: "save",
	    value: function save() {
	      this.setState({
	        isSaving: true,
	        lastUpdated: this.state.eventBucket.updated_at
	      });
	
	      _EventBucketActions2.default.edit(this.props.params.eventBucketId, {
	        frontend_config: JSON.stringify(this.state.config)
	      });
	    }
	  }, {
	    key: "toggleFullWidth",
	    value: function toggleFullWidth() {
	      this.setState({
	        forceFullWidthControls: !this.state.forceFullWidthControls
	      });
	    }
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var _this6 = this;
	
	      this.context.router.setRouteLeaveHook(this.props.route, function (nextLocation) {
	        if (_this6.state.hasUnsavedChanges && (!nextLocation || nextLocation.pathname.indexOf("configurator") === -1)) {
	          return "Are you sure you wish to leave the configurator? Your changes will not be saved.";
	        }
	      });
	
	      window.addEventListener("resize", this.onResize);
	
	      _EventBucketActions2.default.fetchOne.defer(this.props.params.eventBucketId);
	      _EventBucketActions2.default.fetchConfigSchema.defer();
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      window.removeEventListener("resize", this.onResize);
	    }
	  }, {
	    key: "onResize",
	    value: function onResize() {
	      if (this.container) {
	        this.setState({
	          iframeWidth: this.container.clientWidth * 1.3 - 300
	        });
	      }
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(props) {
	      var _this7 = this;
	
	      var bucket = props.getEventBucketById(props.params.eventBucketId),
	          schema = props.getConfigSchema(props.params.eventBucketId);
	
	      // Handle tab change, or force select if none specified
	      if (bucket && schema && schema.sections) {
	        if (!props.params.tab) {
	          this.onTabChange(0, props);
	        }
	        if (props.params.tab && (!this.state.currentSection || props.params.tab !== this.props.params.tab)) {
	          this.changeTab(props.params.tab, props);
	        }
	      }
	
	      if (bucket && schema && schema.sections && !this.state.eventBucket) {
	        this.setState({
	          eventBucket: bucket,
	          config: (0, _cloneDeep2.default)(bucket.frontend_config)
	        }, function () {
	          // Force initial refresh to sync
	          _this7.iframe.onload = function () {
	            _this7.setState({ iframeLoading: false });
	            _this7.changeTab(_this7.props.params.tab);
	            _this7.updatePreview();
	          };
	
	          // Rescale iframe appropriately
	          _this7.onResize();
	        });
	
	        // Update any modified files
	      } else if (bucket && bucket.UPLOADED_FILES) {
	        var config = (0, _cloneDeep2.default)(this.state.config),
	            modified = Object.assign(config, bucket.UPLOADED_FILES);
	        this.setState({ config: modified, hasUnsavedChanges: true }, function () {
	          _this7.updatePreview();
	        });
	      } else if (bucket && this.state.lastUpdated && bucket.updated_at !== this.state.lastUpdated) {
	        // Edit completed successfully
	        this.setState({ hasUnsavedChanges: false }, function () {
	          _this7.close();
	        });
	      }
	    }
	  }, {
	    key: "getStyles",
	    value: function getStyles() {
	      return {
	        dialog: {
	          width: "95%",
	          maxWidth: "none",
	          overflow: "hidden"
	        },
	        dialogBody: {
	          padding: 0
	        },
	        loading: {
	          textAlign: "center",
	          paddingTop: "30vh",
	          paddingBottom: "30vh"
	        },
	        bodyClear: {
	          width: "100%",
	          height: "90vh",
	          backgroundColor: "#fff"
	        },
	        controls: {
	          position: "fixed",
	          top: 0,
	          left: 0,
	          width: "100%",
	          height: "100%",
	          overflowY: "scroll",
	          overflowX: "hidden"
	        },
	        tabItemContainer: {
	          position: "fixed",
	          top: 0,
	          zIndex: 10
	        },
	        inkBar: {
	          position: "fixed",
	          top: 50,
	          zIndex: 1,
	          borderBottom: "1px solid #ccc"
	        },
	        contentContainer: {
	          width: 300,
	          backgroundColor: "#fff",
	          marginTop: 48
	        },
	        fullWidthContentContainer: {
	          width: "100%"
	        },
	        controlView: {
	          padding: 10,
	          overflow: "scroll"
	        },
	        iframe: {
	          position: "absolute",
	          top: 50,
	          right: 0,
	          height: "133%",
	          width: "100%",
	          transform: "scale(0.7)",
	          transformOrigin: "top right",
	          border: 0,
	          backgroundColor: "#fff",
	          borderLeft: "1px solid #ccc"
	        },
	        iframeLoading: {
	          textAlign: "center",
	          lineHeight: "100vh",
	          fontSize: 30
	        },
	        fullWidthControlsIframe: {
	          display: "none"
	        },
	        actions: {
	          position: "absolute",
	          bottom: 0,
	          right: 0,
	          padding: 20,
	          backgroundColor: "rgba(0,0,0,0.5)",
	          borderTopLeftRadius: 10
	        },
	        fullWidthToggle: {
	          textAlign: "center",
	          fontSize: 10,
	          position: "fixed",
	          bottom: 7,
	          left: 10,
	          backgroundColor: "white",
	          zIndex: 99999,
	          padding: "2px 5px",
	          borderRadius: 4,
	          border: "1px solid #ccc",
	          MozUserSelect: "none",
	          WebkitUserSelect: "none",
	          msUserSelect: "none",
	          cursor: "pointer",
	          textTransform: "uppercase"
	        }
	      };
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this8 = this;
	
	      var styles = this.getStyles();
	      var _state = this.state;
	      var iframeLoading = _state.iframeLoading;
	      var tabIndex = _state.tabIndex;
	      var isSaving = _state.isSaving;
	      var eventBucket = _state.eventBucket;
	      var config = _state.config;
	      var fullWidthControls = _state.fullWidthControls;
	      var forceFullWidthControls = _state.forceFullWidthControls;
	      var configSchema = this.props.getConfigSchema(this.props.params.eventBucketId);
	
	      var isFullWidth = fullWidthControls || forceFullWidthControls;
	
	      return _react2.default.createElement(
	        _materialUi.Dialog,
	        {
	          modal: true,
	          contentStyle: styles.dialog,
	          bodyStyle: styles.dialogBody,
	          open: true
	        },
	        isSaving ? _react2.default.createElement(
	          "div",
	          { style: styles.loading },
	          "Saving..."
	        ) : config && configSchema ? _react2.default.createElement(
	          "div",
	          {
	            className: "EventBucketConfigurator--container",
	            ref: function ref(r) {
	              _this8.container = r;
	            }
	          },
	          _react2.default.createElement("div", { style: styles.bodyClear }),
	          _react2.default.createElement(
	            "div",
	            {
	              style: Object.assign(styles.controls, isFullWidth && styles.fullWidthControls)
	            },
	            _react2.default.createElement(
	              _materialUi.Tabs,
	              {
	                onChange: function onChange(index) {
	                  return _this8.onTabChange(index);
	                },
	                value: tabIndex,
	                tabItemContainerStyle: Object.assign(styles.tabItemContainer, isFullWidth && styles.fullWidthTabItemContainer),
	                inkBarStyle: styles.inkBar,
	                contentContainerStyle: Object.assign(styles.contentContainer, isFullWidth && styles.fullWidthContentContainer),
	                ref: function ref(r) {
	                  _this8.sectionContainer = r;
	                }
	              },
	              configSchema.sections.map(function (section, i) {
	                return _react2.default.createElement(
	                  _materialUi.Tab,
	                  { label: section.name, value: i, key: i },
	                  _react2.default.createElement(_configuratorSection2.default, {
	                    eventBucket: eventBucket,
	                    schema: section,
	                    config: config,
	                    onConfigChange: _this8.onConfigChange,
	                    onConfigFocus: _this8.onConfigFocus,
	                    onConfigBlur: _this8.onConfigBlur,
	                    onForcePreview: _this8.onForcePreview,
	                    onEndForcePreview: _this8.onEndForcePreview,
	                    isFullWidth: isFullWidth,
	                    isGod: _UserStore2.default.isGod(),
	                    isEnterprise: _UserStore2.default.isEnterprise()
	                  }),
	                  _react2.default.createElement(
	                    "div",
	                    {
	                      style: styles.fullWidthToggle,
	                      onTouchTap: _this8.toggleFullWidth
	                    },
	                    "Full width controls"
	                  )
	                );
	              })
	            )
	          ),
	          _react2.default.createElement("iframe", {
	            ref: function ref(r) {
	              _this8.iframe = r;
	            },
	            src: (undefined) || eventBucket.urls.root,
	            style: Object.assign(styles.iframe, isFullWidth && styles.fullWidthControlsIframe, { width: this.state.iframeWidth })
	          }),
	          iframeLoading ? _react2.default.createElement(
	            "div",
	            { style: styles.iframe },
	            _react2.default.createElement(
	              "div",
	              { style: styles.iframeLoading },
	              "Loading live preview..."
	            )
	          ) : null,
	          _react2.default.createElement(
	            "div",
	            { style: styles.actions },
	            _react2.default.createElement(_materialUi.RaisedButton, { label: "Discard changes", onTouchTap: this.close }),
	            _react2.default.createElement(_materialUi.RaisedButton, {
	              label: "Save",
	              primary: true,
	              onTouchTap: this.save,
	              style: { marginLeft: 7 }
	            })
	          )
	        ) : _react2.default.createElement(
	          "div",
	          { style: styles.loading },
	          "Loading..."
	        )
	      );
	    }
	  }], [{
	    key: "getStores",
	    value: function getStores() {
	      return [_EventBucketStore2.default, _UserStore2.default];
	    }
	  }, {
	    key: "getPropsFromStores",
	    value: function getPropsFromStores() {
	      return {
	        getEventBucketById: _EventBucketStore2.default.getEventBucketById,
	        getConfigSchema: _EventBucketStore2.default.getConfigSchema
	      };
	    }
	  }, {
	    key: "contextTypes",
	    get: function get() {
	      return {
	        router: _react2.default.PropTypes.object
	      };
	    }
	  }]);
	
	  return EventBucketConfigurator;
	}(_react2.default.Component);
	
	exports.default = (0, _connectToStores2.default)(EventBucketConfigurator);
	module.exports = exports["default"];

/***/ }),
/* 2106 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _materialUi = __webpack_require__(576);
	
	var _configuratorItem = __webpack_require__(2107);
	
	var _configuratorItem2 = _interopRequireDefault(_configuratorItem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ConfiguratorSection = function (_React$Component) {
	  _inherits(ConfiguratorSection, _React$Component);
	
	  function ConfiguratorSection() {
	    _classCallCheck(this, ConfiguratorSection);
	
	    return _possibleConstructorReturn(this, Object.getPrototypeOf(ConfiguratorSection).apply(this, arguments));
	  }
	
	  _createClass(ConfiguratorSection, [{
	    key: "getStyles",
	    value: function getStyles() {
	      return {
	        wrapper: {
	          padding: "15px 15px 30px"
	        },
	        fullWidthWrapper: {
	          padding: 30
	        },
	        description: {
	          fontSize: 12,
	          marginBottom: 15
	        }
	      };
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var styles = this.getStyles();
	      var _props = this.props;
	      var schema = _props.schema;
	      var config = _props.config;
	      var isFullWidth = _props.isFullWidth;
	      var isGod = _props.isGod;
	      var isEnterprise = _props.isEnterprise;
	
	
	      return _react2.default.createElement(
	        "div",
	        {
	          style: Object.assign(styles.wrapper, isFullWidth && styles.fullWidthWrapper)
	        },
	        _react2.default.createElement(
	          "div",
	          { style: styles.description },
	          schema.description
	        ),
	        schema.items.map(function (item) {
	          return _react2.default.createElement(_configuratorItem2.default, {
	            key: item.key,
	            eventBucket: _this2.props.eventBucket,
	            item: item,
	            config: config,
	            isFullWidth: isFullWidth,
	            onConfigChange: _this2.props.onConfigChange,
	            onConfigFocus: _this2.props.onConfigFocus,
	            onConfigBlur: _this2.props.onConfigBlur,
	            onForcePreview: _this2.props.onForcePreview,
	            onEndForcePreview: _this2.props.onEndForcePreview,
	            isGod: isGod,
	            isEnterprise: isEnterprise
	          });
	        })
	      );
	    }
	  }]);
	
	  return ConfiguratorSection;
	}(_react2.default.Component);
	
	exports.default = ConfiguratorSection;
	module.exports = exports["default"];

/***/ }),
/* 2107 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _get = __webpack_require__(1004);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _clone = __webpack_require__(2108);
	
	var _clone2 = _interopRequireDefault(_clone);
	
	var _materialUi = __webpack_require__(576);
	
	var _rcColorPicker = __webpack_require__(2109);
	
	var _rcColorPicker2 = _interopRequireDefault(_rcColorPicker);
	
	var _reactCodemirror = __webpack_require__(1751);
	
	var _reactCodemirror2 = _interopRequireDefault(_reactCodemirror);
	
	__webpack_require__(2166);
	
	var _quillEditor = __webpack_require__(2169);
	
	var _quillEditor2 = _interopRequireDefault(_quillEditor);
	
	var _configuratorInjectedSelect = __webpack_require__(2187);
	
	var _configuratorInjectedSelect2 = _interopRequireDefault(_configuratorInjectedSelect);
	
	var _imageDropzone = __webpack_require__(2058);
	
	var _imageDropzone2 = _interopRequireDefault(_imageDropzone);
	
	var _currencyField = __webpack_require__(1747);
	
	var _currencyField2 = _interopRequireDefault(_currencyField);
	
	var _quantityEditor = __webpack_require__(2191);
	
	var _quantityEditor2 = _interopRequireDefault(_quantityEditor);
	
	var _infoNotice = __webpack_require__(1599);
	
	var _infoNotice2 = _interopRequireDefault(_infoNotice);
	
	var _PassBucketStore = __webpack_require__(1867);
	
	var _PassBucketStore2 = _interopRequireDefault(_PassBucketStore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// This is janky...
	
	
	var ConfiguratorItem = function (_React$Component) {
	  _inherits(ConfiguratorItem, _React$Component);
	
	  function ConfiguratorItem(props) {
	    _classCallCheck(this, ConfiguratorItem);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(ConfiguratorItem).call(this, props));
	
	    _this.state = {
	      htmlRawMode: false,
	      forcePreviewMode: false,
	      isFocused: false
	    };
	    return _this;
	  }
	
	  _createClass(ConfiguratorItem, [{
	    key: "getStyles",
	    value: function getStyles() {
	      return {
	        wrapper: {
	          margin: "20px 0"
	        },
	        thinWraper: {
	          // when lacking a name
	          margin: 0
	        },
	        thinnestWrapper: {
	          // when lacking a description too
	          marginTop: -10,
	          marginBottom: 20
	        },
	        subheader: {
	          marginBottom: 20
	        },
	        label: {
	          fontWeight: "bold"
	        },
	        subitemLabel: {
	          fontSize: 12
	        },
	        mapLabel: {
	          fontSize: 14,
	          marginTop: 15,
	          marginBottom: -10,
	          fontWeight: "bold",
	          textTransform: "uppercase"
	        },
	        description: {
	          fontSize: 12,
	          marginBottom: 5
	        },
	        insertables: {
	          fontSize: 12
	        },
	        insertable: {
	          textDecoration: "underline",
	          cursor: "pointer",
	          margin: "0 2px"
	        },
	        checkboxLabel: {
	          marginLeft: -10,
	          fontSize: 12
	        },
	        editorSwitcher: {
	          textDecoration: "underline",
	          fontSize: 12,
	          cursor: "pointer"
	        },
	        forcePreviewLink: {
	          textDecoration: "underline",
	          cursor: "pointer",
	          marginBottom: 10
	        },
	        arrayAddableLink: {
	          textDecoration: "underline",
	          cursor: "pointer"
	        },
	        arrayAddableAddAnother: {
	          marginTop: 10
	        },
	        deleteImageLink: {
	          display: "block",
	          textDecoration: "underline",
	          cursor: "pointer"
	        }
	      };
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var styles = this.getStyles();
	      var _props = this.props;
	      var item = _props.item;
	      var config = _props.config;
	      var eventBucket = _props.eventBucket;
	      var isSubitem = _props.isSubitem;
	      var subitemParent = _props.subitemParent;
	      var subitemDefault = _props.subitemDefault;
	      var subitemMappedFromValue = _props.subitemMappedFromValue;
	      var isGod = _props.isGod;
	      var isEnterprise = _props.isEnterprise;
	      var value = (0, _get2.default)(config, isSubitem ? subitemParent + "." + item.key : item.key);
	
	      if (item.god_only && !isGod) {
	        return null;
	      }
	
	      if (item.enterprise_only && !isEnterprise) {
	        return null;
	      }
	
	      if (item.show_only_if) {
	        var showOnlyIfOkay = Object.keys(item.show_only_if).every(function (key) {
	          if (key && key[0] === "#") {
	            // event bucket value (format: `#.xxx`)
	            return (0, _get2.default)(eventBucket, key.substring(2)) === item.show_only_if[key];
	          }
	
	          var injectedKey = key.replace(/^\@/, subitemParent); // local reference
	          var val = (0, _get2.default)(config, injectedKey);
	          return item.show_only_if[key] === val || item.show_only_if[key] === "$$any$$" && !!val;
	        });
	        if (!showOnlyIfOkay) {
	          return null;
	        }
	      }
	
	      // Default inject from pass bucket for subsection
	      if (!value && isSubitem && item.default_inject && item.default_inject.objects === "pass_buckets") {
	        var _ret = function () {
	          var fixedCode = (subitemMappedFromValue || "").replace(/--.+$/, "");
	          var injectFrom = _PassBucketStore2.default.getPassBucketsForEventBucket(eventBucket.id).find(function (b) {
	            return b.code === fixedCode;
	          });
	          if (injectFrom) {
	            value = (0, _get2.default)(injectFrom, item.default_inject.inject);
	          }
	          if (!value) {
	            return {
	              v: _react2.default.createElement("div", null)
	            };
	          } // wait for value to load before rendering
	        }();
	
	        if ((typeof _ret === "undefined" ? "undefined" : _typeof(_ret)) === "object") return _ret.v;
	      }
	
	      // Inject defaults if no value
	      if (!value && subitemDefault) {
	        value = subitemDefault[item.key];
	      }
	
	      var component = _react2.default.createElement("div", null);
	
	      if (item.type === "subheader") {
	        return _react2.default.createElement(
	          "div",
	          { style: styles.subheader },
	          _react2.default.createElement(
	            "div",
	            { style: Object.assign(styles.label) },
	            item.name
	          ),
	          _react2.default.createElement(
	            "div",
	            { style: styles.description },
	            item.description
	          )
	        );
	
	        // STRING
	      } else if (item.type === "string") {
	        component = _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement(_materialUi.TextField, {
	            name: item.key
	            /* workaround for https://github.com/callemall/material-ui/issues/4430#issuecomment-239175166 */
	            , defaultValue: value ? value : undefined,
	            ref: function ref(r) {
	              _this2.textField = r;
	            },
	            style: { marginTop: -15 },
	            fullWidth: true,
	            multiLine: !item.oneline,
	            placeholder: item.placeholder,
	            onFocus: function onFocus() {
	              _this2.setState({ isFocused: true });
	            },
	            onBlur: function onBlur() {
	              _this2.setState({ isFocused: false });
	            },
	            onChange: function onChange(e) {
	              e.stopPropagation(); // https://github.com/callemall/material-ui/issues/2189
	              _this2.props.onConfigChange(item.key, e.target.value);
	            }
	          }),
	          item.insertables && item.insertables.length ? _react2.default.createElement(
	            "div",
	            { style: styles.insertables },
	            "Insert:",
	            item.insertables.map(function (insertable) {
	              return _react2.default.createElement(
	                "span",
	                {
	                  key: insertable.label,
	                  style: styles.insertable,
	                  onTouchTap: function onTouchTap() {
	                    var content = value + insertable.value;
	                    if (_this2.textField) {
	                      _this2.textField.getInputNode().value = content;
	                      _this2.textField.focus();
	                    } else {
	                      _this2.props.onConfigChange(item.key, content);
	                    }
	                  }
	                },
	                insertable.label
	              );
	            })
	          ) : null
	        );
	
	        // COLOR
	      } else if (item.type === "color") {
	        component = _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement(_rcColorPicker2.default, {
	            animation: "slide-up",
	            color: value,
	            alpha: 100,
	            onChange: function onChange(colors) {
	              _this2.props.onConfigChange(item.key, colors.color);
	            }
	          })
	        );
	
	        // DROPDOWN
	      } else if (item.type === "dropdown") {
	        component = _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement(
	            _materialUi.SelectField,
	            {
	              value: value || "",
	              onChange: function onChange(e, i, value) {
	                e.stopPropagation(); // https://github.com/callemall/material-ui/issues/2189
	                _this2.props.onConfigChange(item.key, value);
	              }
	            },
	            item.options.map(function (o) {
	              return _react2.default.createElement(_materialUi.MenuItem, { value: o.value, primaryText: o.label });
	            })
	          )
	        );
	
	        // BOOLEAN
	      } else if (item.type === "boolean") {
	        component = _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement(_materialUi.Checkbox, {
	            checked: value,
	            label: item.checkbox_label,
	            labelStyle: styles.checkboxLabel,
	            onCheck: function onCheck(e, isChecked) {
	              e.stopPropagation(); // https://github.com/callemall/material-ui/issues/2189
	              _this2.props.onConfigChange(item.key, !value);
	            }
	          })
	        );
	
	        // IMAGE
	      } else if (item.type === "image") {
	        component = _react2.default.createElement(
	          "div",
	          null,
	          value ? _react2.default.createElement("img", {
	            src: value,
	            style: {
	              maxHeight: 150,
	              maxWidth: "100%",
	              backgroundColor: "hsla(31,15%,50%,.1)"
	            }
	          }) : null,
	          _react2.default.createElement(
	            _imageDropzone2.default,
	            {
	              crop: item.crop,
	              style: {
	                height: "auto",
	                fontSize: "0.75em",
	                lineHeight: "1.25",
	                padding: 10,
	                border: "1px dashed #ccc",
	                cursor: "pointer"
	              },
	              onDrop: function onDrop(files) {
	                _this2.props.onConfigChange(item.key, files[0], { file: true });
	              }
	            },
	            _react2.default.createElement(
	              "div",
	              null,
	              "Drop an image here, or click to select.",
	              value ? _react2.default.createElement(
	                "a",
	                {
	                  style: styles.deleteImageLink,
	                  onTouchTap: function onTouchTap() {
	                    _this2.props.onConfigChange(item.key, "");
	                  }
	                },
	                "[Delete current image]"
	              ) : null
	            )
	          )
	        );
	
	        // HTML
	      } else if (item.type === "html") {
	        component = _react2.default.createElement(_quillEditor2.default, {
	          value: value,
	          inlineBasicOnly: item.inline_basic_only,
	          bounds: ".EventBucketConfigurator--container",
	          onChange: function onChange(content) {
	            _this2.props.onConfigChange(item.key, content);
	          },
	          sanitizeEmpty: true
	        });
	
	        if (item.allow_raw_editor || item.force_raw_editor) {
	          (function () {
	            var htmlRawMode = _this2.state.htmlRawMode;
	            var rawEditor = _react2.default.createElement(
	              "div",
	              null,
	              _react2.default.createElement(
	                "style",
	                null,
	                "\n                .CodeMirror {\n                  border: 1px solid #ccc;\n                  height: 150px;\n                }\n              "
	              ),
	              _react2.default.createElement(_reactCodemirror2.default, {
	                value: value,
	                onChange: function onChange(content) {
	                  _this2.props.onConfigChange(item.key, content);
	                },
	                options: {
	                  lineWrapping: true,
	                  lineNumbers: true,
	                  mode: { name: "htmlmixed" }
	                }
	              })
	            );
	
	            if (value && value.indexOf("eventive:allow-unsafe-embed") !== -1) {
	              htmlRawMode = true;
	            }
	
	            component = _react2.default.createElement(
	              "div",
	              null,
	              !item.force_raw_editor ? _react2.default.createElement(
	                "span",
	                {
	                  style: styles.editorSwitcher,
	                  onTouchTap: function onTouchTap() {
	                    return _this2.setState({ htmlRawMode: !htmlRawMode });
	                  }
	                },
	                "Switch to ",
	                htmlRawMode ? "visual" : "raw",
	                " editor"
	              ) : null,
	              item.force_raw_editor || htmlRawMode ? rawEditor : component
	            );
	          })();
	        }
	
	        // CURRENCY
	      } else if (item.type === "currency") {
	        component = _react2.default.createElement(_currencyField2.default, {
	          name: item.key,
	          value: value,
	          placeholder: "$0.00",
	          style: { marginTop: -15 },
	          onFocus: function onFocus() {
	            _this2.setState({ isFocused: true });
	          },
	          onBlur: function onBlur() {
	            _this2.setState({ isFocused: false });
	          },
	          onChange: function onChange(e) {
	            _this2.props.onConfigChange(item.key, e.target.value);
	          }
	        });
	
	        // QUANTITY
	      } else if (item.type === "quantity") {
	        component = _react2.default.createElement(_quantityEditor2.default, {
	          name: item.key,
	          quantity: value,
	          min: item.min,
	          max: item.max,
	          style: { marginTop: -10, marginLeft: -15 },
	          onFocus: function onFocus() {
	            _this2.setState({ isFocused: true });
	          },
	          onBlur: function onBlur() {
	            _this2.setState({ isFocused: false });
	          },
	          updateQuantity: function updateQuantity(q) {
	            _this2.props.onConfigChange(item.key, q);
	          }
	        });
	
	        // INJECTED
	      } else if (item.inject) {
	        component = _react2.default.createElement(_configuratorInjectedSelect2.default, {
	          inject: item.inject,
	          eventBucket: eventBucket,
	          type: item.type,
	          repeatable: item.repeatable,
	          repeatableKey: item.repeatable && subitemParent && subitemParent.replace(/[^0-9]/g, ""),
	          value: value,
	          onChange: function onChange(selected) {
	            _this2.props.onConfigChange(item.key, selected);
	          }
	        });
	
	        // MAP
	        // This mean that the items takes another config item that is an array and for each item in the array,
	        // generates a new set of items. Basically used to configure "each one" of a particular item.
	      } else if (item.map || item.type === "array_addable") {
	        (function () {
	          var arrayToMap = void 0,
	              isArrayAddable = item.type === "array_addable";
	
	          if (item.map) {
	            if (item.map.indexOf(".") !== -1) {
	              if (Array.isArray((0, _get2.default)(config, item.map))) {
	                arrayToMap = (0, _get2.default)(config, item.map);
	              } else {
	                (function () {
	                  // Assume it is nested, then, and capture all the nested fields.
	                  var _item$map$split = item.map.split(".");
	
	                  var _item$map$split2 = _slicedToArray(_item$map$split, 2);
	
	                  var container = _item$map$split2[0];
	                  var subfield = _item$map$split2[1];
	
	                  arrayToMap = [].concat.apply([], (config[container] || []).map(function (c) {
	                    return c[subfield];
	                  }));
	                })();
	              }
	            } else {
	              arrayToMap = config[item.map] || [];
	            }
	          } else {
	            arrayToMap = value || [];
	          }
	
	          var subitemDefault = (0, _get2.default)(config, item.key + "--default");
	
	          component = _react2.default.createElement(
	            "div",
	            null,
	            arrayToMap.map(function (otherItemValue, i) {
	              var labelContents = void 0;
	
	              if (isArrayAddable) {
	                labelContents = _react2.default.createElement(
	                  "span",
	                  null,
	                  item.type_label || "item",
	                  " #",
	                  i + 1,
	                  " (",
	                  _react2.default.createElement(
	                    "a",
	                    {
	                      style: styles.arrayAddableLink,
	                      onTouchTap: function onTouchTap() {
	                        var modified = (0, _clone2.default)(value);
	                        modified.splice(i, 1);
	                        _this2.props.onConfigChange(item.key, modified);
	                      }
	                    },
	                    "Delete ",
	                    item.type_label || "item"
	                  ),
	                  ")"
	                );
	              } else {
	                labelContents = otherItemValue;
	              }
	
	              var triggerFocus = function triggerFocus() {
	                _this2.props.onConfigFocus(item.key, item, otherItemValue || {});
	              };
	              var triggerBlur = function triggerBlur() {
	                !_this2.state.isFocused && _this2.props.onConfigBlur(item.key, item);
	              };
	
	              return _react2.default.createElement(
	                "div",
	                { onMouseEnter: triggerFocus, onMouseLeave: triggerFocus },
	                _react2.default.createElement(
	                  "div",
	                  { style: styles.mapLabel },
	                  labelContents
	                ),
	                item.items.map(function (subitem) {
	                  return _react2.default.createElement(ConfiguratorItem, {
	                    item: subitem,
	                    config: config,
	                    eventBucket: eventBucket,
	                    isSubitem: true,
	                    subitemParent: "" + (_this2.props.subitemParent ? _this2.props.subitemParent + "." : "") + (isArrayAddable ? item.key + "[" + i + "]" : item.key + "." + otherItemValue),
	                    subitemMappedFromValue: otherItemValue,
	                    subitemDefault: subitemDefault,
	                    onConfigFocus: _this2.props.onConfigFocus,
	                    onConfigBlur: _this2.props.onConfigBlur,
	                    onConfigChange: function onConfigChange(key, value) {
	                      _this2.props.onConfigChange(isArrayAddable ? item.key + "[" + i + "]." + key : item.key + "." + otherItemValue + "." + key, value);
	                      if (subitem.trigger_preview_on_change) {
	                        triggerFocus();
	                      }
	                    }
	                  });
	                })
	              );
	            }),
	            isArrayAddable ? _react2.default.createElement(_materialUi.RaisedButton, {
	              style: styles.arrayAddableAddAnother,
	              label: "Add another " + (item.type_label || "item"),
	              onTouchTap: function onTouchTap() {
	                var modified = (0, _clone2.default)(value) || [],
	                    defaultValue = (0, _get2.default)(config, item.key + "--default");
	                modified.push(defaultValue ? (0, _clone2.default)(defaultValue) : {});
	                _this2.props.onConfigChange(item.key, modified);
	              }
	            }) : null
	          );
	        })();
	      }
	
	      var forcePreviewLink = null;
	      if (item.force_preview) {
	        (function () {
	          var forcePreviewMode = _this2.state.forcePreviewMode;
	
	
	          forcePreviewLink = _react2.default.createElement(
	            "div",
	            {
	              style: styles.forcePreviewLink,
	              title: "Temporarily make the site appear in a mode in which this setting would apply.",
	              onTouchTap: function onTouchTap() {
	                if (!forcePreviewMode) {
	                  _this2.setState({ forcePreviewMode: true });
	                  _this2.props.onForcePreview(item.force_preview, item);
	                } else {
	                  _this2.setState({ forcePreviewMode: false });
	                  _this2.props.onEndForcePreview(item.force_preview, item);
	                }
	              }
	            },
	            "(",
	            forcePreviewMode ? "stop previewing" : "preview",
	            " on site)"
	          );
	        })();
	      }
	
	      var infoNotice = null;
	      if (item.info_notice) {
	        infoNotice = _react2.default.createElement(
	          _infoNotice2.default,
	          { style: { marginTop: 0, marginBottom: 5 } },
	          _react2.default.createElement("span", { dangerouslySetInnerHTML: { __html: item.info_notice } })
	        );
	      }
	
	      return _react2.default.createElement(
	        "div",
	        {
	          style: item.name ? styles.wrapper : item.description ? styles.thinWraper : styles.thinnestWrapper,
	          onMouseEnter: function onMouseEnter() {
	            _this2.props.onConfigFocus(item.key, item);
	          },
	          onMouseLeave: function onMouseLeave() {
	            !_this2.state.isFocused && _this2.props.onConfigBlur(item.key, item);
	          }
	        },
	        _react2.default.createElement(
	          "div",
	          {
	            style: Object.assign(styles.label, isSubitem && styles.subitemLabel)
	          },
	          item.name
	        ),
	        _react2.default.createElement(
	          "div",
	          { style: styles.description },
	          item.description,
	          forcePreviewLink,
	          infoNotice
	        ),
	        component
	      );
	    }
	  }]);
	
	  return ConfiguratorItem;
	}(_react2.default.Component);
	
	exports.default = ConfiguratorItem;
	module.exports = exports["default"];

/***/ }),
/* 2108 */
/***/ (function(module, exports, __webpack_require__) {

	var baseClone = __webpack_require__(1190);
	
	/** Used to compose bitmasks for cloning. */
	var CLONE_SYMBOLS_FLAG = 4;
	
	/**
	 * Creates a shallow clone of `value`.
	 *
	 * **Note:** This method is loosely based on the
	 * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
	 * and supports cloning arrays, array buffers, booleans, date objects, maps,
	 * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
	 * arrays. The own enumerable properties of `arguments` objects are cloned
	 * as plain objects. An empty object is returned for uncloneable values such
	 * as error objects, functions, DOM nodes, and WeakMaps.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to clone.
	 * @returns {*} Returns the cloned value.
	 * @see _.cloneDeep
	 * @example
	 *
	 * var objects = [{ 'a': 1 }, { 'b': 2 }];
	 *
	 * var shallow = _.clone(objects);
	 * console.log(shallow[0] === objects[0]);
	 * // => true
	 */
	function clone(value) {
	  return baseClone(value, CLONE_SYMBOLS_FLAG);
	}
	
	module.exports = clone;


/***/ }),
/* 2109 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(2110);
	module.exports.Panel = __webpack_require__(2144);

/***/ }),
/* 2110 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(332);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _rcTrigger = __webpack_require__(2111);
	
	var _rcTrigger2 = _interopRequireDefault(_rcTrigger);
	
	var _Panel = __webpack_require__(2144);
	
	var _Panel2 = _interopRequireDefault(_Panel);
	
	var _placements = __webpack_require__(2165);
	
	var _placements2 = _interopRequireDefault(_placements);
	
	function refFn(field, component) {
	  this[field] = component;
	}
	
	function prevent(e) {
	  e.preventDefault();
	}
	
	var ColorPicker = (function (_React$Component) {
	  _inherits(ColorPicker, _React$Component);
	
	  function ColorPicker(props) {
	    var _this = this;
	
	    _classCallCheck(this, ColorPicker);
	
	    _get(Object.getPrototypeOf(ColorPicker.prototype), 'constructor', this).call(this, props);
	
	    this.state = {
	      color: props.color || props.defaultColor,
	      alpha: props.alpha || props.defaultAlpha,
	      open: false
	    };
	
	    var events = ['onTriggerClick', 'onChange', 'onBlur', 'getPickerElement', 'getRootDOMNode', 'getTriggerDOMNode', 'onVisibleChange', 'setOpen', 'open', 'close', 'focus'];
	
	    events.forEach(function (e) {
	      _this[e] = _this[e].bind(_this);
	    });
	
	    this.savePickerPanelRef = refFn.bind(this, 'pickerPanelInstance');
	    this.saveTriggerRef = refFn.bind(this, 'triggerInstance');
	  }
	
	  _createClass(ColorPicker, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.color) {
	        this.setState({
	          color: nextProps.color
	        });
	      }
	      if (nextProps.alpha !== null && nextProps.alpha !== undefined) {
	        this.setState({
	          alpha: nextProps.alpha
	        });
	      }
	    }
	  }, {
	    key: 'onTriggerClick',
	    value: function onTriggerClick() {
	      this.setState({
	        open: !this.state.open
	      });
	    }
	  }, {
	    key: 'onChange',
	    value: function onChange(colors) {
	      this.setState({
	        color: colors.color,
	        alpha: colors.alpha
	      });
	      this.props.onChange(colors);
	    }
	  }, {
	    key: 'onBlur',
	    value: function onBlur() {
	      this.setState({
	        open: false
	      });
	    }
	  }, {
	    key: 'onVisibleChange',
	    value: function onVisibleChange(open) {
	      var _this2 = this;
	
	      this.setOpen(open, function () {
	        if (open) {
	          _reactDom2['default'].findDOMNode(_this2.pickerPanelInstance).focus();
	        }
	      });
	    }
	  }, {
	    key: 'setOpen',
	    value: function setOpen(open, callback) {
	      var _props = this.props;
	      var onOpen = _props.onOpen;
	      var onClose = _props.onClose;
	
	      if (this.state.open !== open) {
	        this.setState({
	          open: open
	        }, callback);
	        var _event = {
	          open: open
	        };
	        if (open) {
	          onOpen(_event);
	        } else {
	          onClose(_event);
	        }
	      }
	    }
	  }, {
	    key: 'getRootDOMNode',
	    value: function getRootDOMNode() {
	      return _reactDom2['default'].findDOMNode(this);
	    }
	  }, {
	    key: 'getTriggerDOMNode',
	    value: function getTriggerDOMNode() {
	      return _reactDom2['default'].findDOMNode(this.triggerInstance);
	    }
	  }, {
	    key: 'getPickerElement',
	    value: function getPickerElement() {
	      // const state = this.state;
	      return _react2['default'].createElement(_Panel2['default'], {
	        ref: this.savePickerPanelRef,
	        defaultColor: this.state.color,
	        alpha: this.state.alpha,
	        prefixCls: this.props.prefixCls + '-panel',
	        onChange: this.onChange,
	        onBlur: this.onBlur,
	        mode: this.props.mode
	      });
	    }
	  }, {
	    key: 'open',
	    value: function open(callback) {
	      this.setOpen(true, callback);
	    }
	  }, {
	    key: 'close',
	    value: function close(callback) {
	      this.setOpen(false, callback);
	    }
	  }, {
	    key: 'focus',
	    value: function focus() {
	      if (!this.state.open) {
	        _reactDom2['default'].findDOMNode(this).focus();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var props = this.props;
	      var state = this.state;
	      var classes = [props.prefixCls + '-wrap'];
	      if (state.open) {
	        classes.push(props.prefixCls + '-open');
	      }
	
	      var children = props.children;
	
	      if (children) {
	        children = _react2['default'].cloneElement(children, {
	          ref: this.saveTriggerRef,
	          unselectable: true,
	          style: {
	            opacity: this.state.alpha / 100,
	            backgroundColor: this.state.color
	          },
	          onClick: this.onTriggerClick,
	          onMouseDown: prevent
	        });
	      }
	
	      var prefixCls = props.prefixCls;
	      var placement = props.placement;
	      var style = props.style;
	      var getCalendarContainer = props.getCalendarContainer;
	      var align = props.align;
	      var animation = props.animation;
	      var disabled = props.disabled;
	      var transitionName = props.transitionName;
	
	      return _react2['default'].createElement(
	        'div',
	        { className: classes.join(' ') },
	        _react2['default'].createElement(
	          _rcTrigger2['default'],
	          {
	            popup: this.getPickerElement(),
	            popupAlign: align,
	            builtinPlacements: _placements2['default'],
	            popupPlacement: placement,
	            action: disabled ? [] : ['click'],
	            destroyPopupOnHide: true,
	            getPopupContainer: getCalendarContainer,
	            popupStyle: style,
	            popupAnimation: animation,
	            popupTransitionName: transitionName,
	            popupVisible: state.open,
	            onPopupVisibleChange: this.onVisibleChange,
	            prefixCls: prefixCls },
	          children
	        )
	      );
	    }
	  }]);
	
	  return ColorPicker;
	})(_react2['default'].Component);
	
	exports['default'] = ColorPicker;
	
	ColorPicker.propTypes = {
	  defaultColor: _react.PropTypes.string,
	  defaultAlpha: _react.PropTypes.number,
	  // can custom
	  color: _react.PropTypes.string,
	  alpha: _react.PropTypes.number,
	  onChange: _react.PropTypes.func,
	  onOpen: _react.PropTypes.func,
	  onClose: _react.PropTypes.func,
	  prefixCls: _react.PropTypes.string.isRequired,
	  children: _react.PropTypes.node.isRequired,
	  mode: _react.PropTypes.oneOf(['RGB', 'HSL', 'HSB']),
	  placement: _react.PropTypes.oneOf(['topLeft', 'topRight', 'bottomLeft', 'bottomRight']),
	  style: _react.PropTypes.object
	};
	
	ColorPicker.defaultProps = {
	  defaultColor: '#F00',
	  defaultAlpha: 100,
	  onChange: function onChange() {},
	  onOpen: function onOpen() {},
	  onClose: function onClose() {},
	  prefixCls: 'rc-color-picker',
	  children: _react2['default'].createElement('span', { className: 'rc-color-picker-trigger' }),
	  placement: 'topLeft',
	  style: {}
	};
	module.exports = exports['default'];

/***/ }),
/* 2111 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(2112);

/***/ }),
/* 2112 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(332);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _contains = __webpack_require__(2113);
	
	var _contains2 = _interopRequireDefault(_contains);
	
	var _addEventListener = __webpack_require__(2114);
	
	var _addEventListener2 = _interopRequireDefault(_addEventListener);
	
	var _Popup = __webpack_require__(2118);
	
	var _Popup2 = _interopRequireDefault(_Popup);
	
	var _utils = __webpack_require__(2142);
	
	var _getContainerRenderMixin = __webpack_require__(2143);
	
	var _getContainerRenderMixin2 = _interopRequireDefault(_getContainerRenderMixin);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function noop() {}
	
	function returnEmptyString() {
	  return '';
	}
	
	var ALL_HANDLERS = ['onClick', 'onMouseDown', 'onTouchStart', 'onMouseEnter', 'onMouseLeave', 'onFocus', 'onBlur'];
	
	var Trigger = _react2["default"].createClass({
	  displayName: 'Trigger',
	
	  propTypes: {
	    children: _react.PropTypes.any,
	    action: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.arrayOf(_react.PropTypes.string)]),
	    showAction: _react.PropTypes.any,
	    hideAction: _react.PropTypes.any,
	    getPopupClassNameFromAlign: _react.PropTypes.any,
	    onPopupVisibleChange: _react.PropTypes.func,
	    afterPopupVisibleChange: _react.PropTypes.func,
	    popup: _react.PropTypes.oneOfType([_react.PropTypes.node, _react.PropTypes.func]).isRequired,
	    popupStyle: _react.PropTypes.object,
	    prefixCls: _react.PropTypes.string,
	    popupClassName: _react.PropTypes.string,
	    popupPlacement: _react.PropTypes.string,
	    builtinPlacements: _react.PropTypes.object,
	    popupTransitionName: _react.PropTypes.string,
	    popupAnimation: _react.PropTypes.any,
	    mouseEnterDelay: _react.PropTypes.number,
	    mouseLeaveDelay: _react.PropTypes.number,
	    zIndex: _react.PropTypes.number,
	    focusDelay: _react.PropTypes.number,
	    blurDelay: _react.PropTypes.number,
	    getPopupContainer: _react.PropTypes.func,
	    destroyPopupOnHide: _react.PropTypes.bool,
	    mask: _react.PropTypes.bool,
	    onPopupAlign: _react.PropTypes.func,
	    popupAlign: _react.PropTypes.object,
	    popupVisible: _react.PropTypes.bool,
	    maskTransitionName: _react.PropTypes.string,
	    maskAnimation: _react.PropTypes.string
	  },
	
	  mixins: [(0, _getContainerRenderMixin2["default"])({
	    autoMount: false,
	
	    isVisible: function isVisible(instance) {
	      return instance.state.popupVisible;
	    },
	    getContainer: function getContainer(instance) {
	      var popupContainer = document.createElement('div');
	      var mountNode = instance.props.getPopupContainer ? instance.props.getPopupContainer((0, _reactDom.findDOMNode)(instance)) : document.body;
	      mountNode.appendChild(popupContainer);
	      return popupContainer;
	    },
	    getComponent: function getComponent(instance) {
	      var props = instance.props;
	      var state = instance.state;
	
	      var mouseProps = {};
	      if (instance.isMouseEnterToShow()) {
	        mouseProps.onMouseEnter = instance.onPopupMouseEnter;
	      }
	      if (instance.isMouseLeaveToHide()) {
	        mouseProps.onMouseLeave = instance.onPopupMouseLeave;
	      }
	      return _react2["default"].createElement(
	        _Popup2["default"],
	        _extends({
	          prefixCls: props.prefixCls,
	          destroyPopupOnHide: props.destroyPopupOnHide,
	          visible: state.popupVisible,
	          className: props.popupClassName,
	          action: props.action,
	          align: instance.getPopupAlign(),
	          onAlign: props.onPopupAlign,
	          animation: props.popupAnimation,
	          getClassNameFromAlign: instance.getPopupClassNameFromAlign
	        }, mouseProps, {
	          getRootDomNode: instance.getRootDomNode,
	          style: props.popupStyle,
	          mask: props.mask,
	          zIndex: props.zIndex,
	          transitionName: props.popupTransitionName,
	          maskAnimation: props.maskAnimation,
	          maskTransitionName: props.maskTransitionName
	        }),
	        typeof props.popup === 'function' ? props.popup() : props.popup
	      );
	    }
	  })],
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      prefixCls: 'rc-trigger-popup',
	      getPopupClassNameFromAlign: returnEmptyString,
	      onPopupVisibleChange: noop,
	      afterPopupVisibleChange: noop,
	      onPopupAlign: noop,
	      popupClassName: '',
	      mouseEnterDelay: 0,
	      mouseLeaveDelay: 0.1,
	      focusDelay: 0,
	      blurDelay: 0.15,
	      popupStyle: {},
	      destroyPopupOnHide: false,
	      popupAlign: {},
	      defaultPopupVisible: false,
	      mask: false,
	      action: [],
	      showAction: [],
	      hideAction: []
	    };
	  },
	  getInitialState: function getInitialState() {
	    var props = this.props;
	    var popupVisible = void 0;
	    if ('popupVisible' in props) {
	      popupVisible = !!props.popupVisible;
	    } else {
	      popupVisible = !!props.defaultPopupVisible;
	    }
	    return {
	      popupVisible: popupVisible
	    };
	  },
	  componentWillMount: function componentWillMount() {
	    var _this = this;
	
	    ALL_HANDLERS.forEach(function (h) {
	      _this['fire' + h] = function (e) {
	        _this.fireEvents(h, e);
	      };
	    });
	  },
	  componentDidMount: function componentDidMount() {
	    this.componentDidUpdate({}, {
	      popupVisible: this.state.popupVisible
	    });
	  },
	  componentWillReceiveProps: function componentWillReceiveProps(_ref) {
	    var popupVisible = _ref.popupVisible;
	
	    if (popupVisible !== undefined) {
	      this.setState({
	        popupVisible: popupVisible
	      });
	    }
	  },
	  componentDidUpdate: function componentDidUpdate(_, prevState) {
	    var props = this.props;
	    var state = this.state;
	    this.renderComponent(function () {
	      if (prevState.popupVisible !== state.popupVisible) {
	        props.afterPopupVisibleChange(state.popupVisible);
	      }
	    });
	    if (this.isClickToHide()) {
	      if (state.popupVisible) {
	        if (!this.clickOutsideHandler) {
	          this.clickOutsideHandler = (0, _addEventListener2["default"])(document, 'mousedown', this.onDocumentClick);
	          this.touchOutsideHandler = (0, _addEventListener2["default"])(document, 'touchstart', this.onDocumentClick);
	        }
	        return;
	      }
	    }
	    if (this.clickOutsideHandler) {
	      this.clickOutsideHandler.remove();
	      this.touchOutsideHandler.remove();
	      this.clickOutsideHandler = null;
	      this.touchOutsideHandler = null;
	    }
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    this.clearDelayTimer();
	    if (this.clickOutsideHandler) {
	      this.clickOutsideHandler.remove();
	      this.touchOutsideHandler.remove();
	      this.clickOutsideHandler = null;
	      this.touchOutsideHandler = null;
	    }
	  },
	  onMouseEnter: function onMouseEnter(e) {
	    this.fireEvents('onMouseEnter', e);
	    this.delaySetPopupVisible(true, this.props.mouseEnterDelay);
	  },
	  onMouseLeave: function onMouseLeave(e) {
	    this.fireEvents('onMouseLeave', e);
	    this.delaySetPopupVisible(false, this.props.mouseLeaveDelay);
	  },
	  onPopupMouseEnter: function onPopupMouseEnter() {
	    this.clearDelayTimer();
	  },
	  onPopupMouseLeave: function onPopupMouseLeave(e) {
	    // https://github.com/react-component/trigger/pull/13
	    // react bug?
	    if (e.relatedTarget && !e.relatedTarget.setTimeout && this._component && (0, _contains2["default"])(this._component.getPopupDomNode(), e.relatedTarget)) {
	      return;
	    }
	    this.delaySetPopupVisible(false, this.props.mouseLeaveDelay);
	  },
	  onFocus: function onFocus(e) {
	    this.fireEvents('onFocus', e);
	    // incase focusin and focusout
	    this.clearDelayTimer();
	    if (this.isFocusToShow()) {
	      this.focusTime = Date.now();
	      this.delaySetPopupVisible(true, this.props.focusDelay);
	    }
	  },
	  onMouseDown: function onMouseDown(e) {
	    this.fireEvents('onMouseDown', e);
	    this.preClickTime = Date.now();
	  },
	  onTouchStart: function onTouchStart(e) {
	    this.fireEvents('onTouchStart', e);
	    this.preTouchTime = Date.now();
	  },
	  onBlur: function onBlur(e) {
	    this.fireEvents('onBlur', e);
	    this.clearDelayTimer();
	    if (this.isBlurToHide()) {
	      this.delaySetPopupVisible(false, this.props.blurDelay);
	    }
	  },
	  onClick: function onClick(event) {
	    this.fireEvents('onClick', event);
	    // focus will trigger click
	    if (this.focusTime) {
	      var preTime = void 0;
	      if (this.preClickTime && this.preTouchTime) {
	        preTime = Math.min(this.preClickTime, this.preTouchTime);
	      } else if (this.preClickTime) {
	        preTime = this.preClickTime;
	      } else if (this.preTouchTime) {
	        preTime = this.preTouchTime;
	      }
	      if (Math.abs(preTime - this.focusTime) < 20) {
	        return;
	      }
	      this.focusTime = 0;
	    }
	    this.preClickTime = 0;
	    this.preTouchTime = 0;
	    event.preventDefault();
	    var nextVisible = !this.state.popupVisible;
	    if (this.isClickToHide() && !nextVisible || nextVisible && this.isClickToShow()) {
	      this.setPopupVisible(!this.state.popupVisible);
	    }
	  },
	  onDocumentClick: function onDocumentClick(event) {
	    var target = event.target;
	    var root = (0, _reactDom.findDOMNode)(this);
	    var popupNode = this.getPopupDomNode();
	    if (!(0, _contains2["default"])(root, target) && !(0, _contains2["default"])(popupNode, target)) {
	      this.setPopupVisible(false);
	    }
	  },
	  getPopupDomNode: function getPopupDomNode() {
	    // for test
	    if (this._component) {
	      return this._component.isMounted() ? this._component.getPopupDomNode() : null;
	    }
	    return null;
	  },
	  getRootDomNode: function getRootDomNode() {
	    return _reactDom2["default"].findDOMNode(this);
	  },
	  getPopupClassNameFromAlign: function getPopupClassNameFromAlign(align) {
	    var className = [];
	    var props = this.props;
	    var popupPlacement = props.popupPlacement;
	    var builtinPlacements = props.builtinPlacements;
	    var prefixCls = props.prefixCls;
	
	    if (popupPlacement && builtinPlacements) {
	      className.push((0, _utils.getPopupClassNameFromAlign)(builtinPlacements, prefixCls, align));
	    }
	    if (props.getPopupClassNameFromAlign) {
	      className.push(props.getPopupClassNameFromAlign(align));
	    }
	    return className.join(' ');
	  },
	  getPopupAlign: function getPopupAlign() {
	    var props = this.props;
	    var popupPlacement = props.popupPlacement;
	    var popupAlign = props.popupAlign;
	    var builtinPlacements = props.builtinPlacements;
	
	    if (popupPlacement && builtinPlacements) {
	      return (0, _utils.getAlignFromPlacement)(builtinPlacements, popupPlacement, popupAlign);
	    }
	    return popupAlign;
	  },
	  setPopupVisible: function setPopupVisible(popupVisible) {
	    this.clearDelayTimer();
	    if (this.state.popupVisible !== popupVisible) {
	      if (!('popupVisible' in this.props)) {
	        this.setState({
	          popupVisible: popupVisible
	        });
	      }
	      this.props.onPopupVisibleChange(popupVisible);
	    }
	  },
	  delaySetPopupVisible: function delaySetPopupVisible(visible, delayS) {
	    var _this2 = this;
	
	    var delay = delayS * 1000;
	    this.clearDelayTimer();
	    if (delay) {
	      this.delayTimer = setTimeout(function () {
	        _this2.setPopupVisible(visible);
	        _this2.clearDelayTimer();
	      }, delay);
	    } else {
	      this.setPopupVisible(visible);
	    }
	  },
	  clearDelayTimer: function clearDelayTimer() {
	    if (this.delayTimer) {
	      clearTimeout(this.delayTimer);
	      this.delayTimer = null;
	    }
	  },
	  createTwoChains: function createTwoChains(event) {
	    var childPros = this.props.children.props;
	    var props = this.props;
	    if (childPros[event] && props[event]) {
	      return this['fire' + event];
	    }
	    return childPros[event] || props[event];
	  },
	  isClickToShow: function isClickToShow() {
	    var _props = this.props;
	    var action = _props.action;
	    var showAction = _props.showAction;
	
	    return action.indexOf('click') !== -1 || showAction.indexOf('click') !== -1;
	  },
	  isClickToHide: function isClickToHide() {
	    var _props2 = this.props;
	    var action = _props2.action;
	    var hideAction = _props2.hideAction;
	
	    return action.indexOf('click') !== -1 || hideAction.indexOf('click') !== -1;
	  },
	  isMouseEnterToShow: function isMouseEnterToShow() {
	    var _props3 = this.props;
	    var action = _props3.action;
	    var showAction = _props3.showAction;
	
	    return action.indexOf('hover') !== -1 || showAction.indexOf('mouseEnter') !== -1;
	  },
	  isMouseLeaveToHide: function isMouseLeaveToHide() {
	    var _props4 = this.props;
	    var action = _props4.action;
	    var hideAction = _props4.hideAction;
	
	    return action.indexOf('hover') !== -1 || hideAction.indexOf('mouseLeave') !== -1;
	  },
	  isFocusToShow: function isFocusToShow() {
	    var _props5 = this.props;
	    var action = _props5.action;
	    var showAction = _props5.showAction;
	
	    return action.indexOf('focus') !== -1 || showAction.indexOf('focus') !== -1;
	  },
	  isBlurToHide: function isBlurToHide() {
	    var _props6 = this.props;
	    var action = _props6.action;
	    var hideAction = _props6.hideAction;
	
	    return action.indexOf('focus') !== -1 || hideAction.indexOf('blur') !== -1;
	  },
	  forcePopupAlign: function forcePopupAlign() {
	    if (this.state.popupVisible && this.popupInstance && this.popupInstance.alignInstance) {
	      this.popupInstance.alignInstance.forceAlign();
	    }
	  },
	  fireEvents: function fireEvents(type, e) {
	    var childCallback = this.props.children.props[type];
	    if (childCallback) {
	      childCallback(e);
	    }
	    var callback = this.props[type];
	    if (callback) {
	      callback(e);
	    }
	  },
	  render: function render() {
	    var props = this.props;
	    var children = props.children;
	    var child = _react2["default"].Children.only(children);
	    var newChildProps = {};
	
	    if (this.isClickToHide() || this.isClickToShow()) {
	      newChildProps.onClick = this.onClick;
	      newChildProps.onMouseDown = this.onMouseDown;
	      newChildProps.onTouchStart = this.onTouchStart;
	    } else {
	      newChildProps.onClick = this.createTwoChains('onClick');
	      newChildProps.onMouseDown = this.createTwoChains('onMouseDown');
	      newChildProps.onTouchStart = this.createTwoChains('onTouchStart');
	    }
	    if (this.isMouseEnterToShow()) {
	      newChildProps.onMouseEnter = this.onMouseEnter;
	    } else {
	      newChildProps.onMouseEnter = this.createTwoChains('onMouseEnter');
	    }
	    if (this.isMouseLeaveToHide()) {
	      newChildProps.onMouseLeave = this.onMouseLeave;
	    } else {
	      newChildProps.onMouseLeave = this.createTwoChains('onMouseLeave');
	    }
	    if (this.isFocusToShow() || this.isBlurToHide()) {
	      newChildProps.onFocus = this.onFocus;
	      newChildProps.onBlur = this.onBlur;
	    } else {
	      newChildProps.onFocus = this.createTwoChains('onFocus');
	      newChildProps.onBlur = this.createTwoChains('onBlur');
	    }
	
	    return _react2["default"].cloneElement(child, newChildProps);
	  }
	});
	
	exports["default"] = Trigger;
	module.exports = exports['default'];

/***/ }),
/* 2113 */
/***/ (function(module, exports) {

	"use strict";
	
	module.exports = function contains(root, n) {
	  var node = n;
	  while (node) {
	    if (node === root) {
	      return true;
	    }
	    node = node.parentNode;
	  }
	
	  return false;
	};

/***/ }),
/* 2114 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = addEventListenerWrap;
	
	var _addDomEventListener = __webpack_require__(2115);
	
	var _addDomEventListener2 = _interopRequireDefault(_addDomEventListener);
	
	var _reactDom = __webpack_require__(332);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function addEventListenerWrap(target, eventType, cb) {
	  /* eslint camelcase: 2 */
	  var callback = _reactDom2["default"].unstable_batchedUpdates ? function run(e) {
	    _reactDom2["default"].unstable_batchedUpdates(cb, e);
	  } : cb;
	  return (0, _addDomEventListener2["default"])(target, eventType, callback);
	}
	module.exports = exports['default'];

/***/ }),
/* 2115 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = addEventListener;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _EventObject = __webpack_require__(2116);
	
	var _EventObject2 = _interopRequireDefault(_EventObject);
	
	function addEventListener(target, eventType, callback) {
	  function wrapCallback(e) {
	    var ne = new _EventObject2['default'](e);
	    callback.call(target, ne);
	  }
	
	  if (target.addEventListener) {
	    target.addEventListener(eventType, wrapCallback, false);
	    return {
	      remove: function remove() {
	        target.removeEventListener(eventType, wrapCallback, false);
	      }
	    };
	  } else if (target.attachEvent) {
	    target.attachEvent('on' + eventType, wrapCallback);
	    return {
	      remove: function remove() {
	        target.detachEvent('on' + eventType, wrapCallback);
	      }
	    };
	  }
	}
	
	module.exports = exports['default'];

/***/ }),
/* 2116 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @ignore
	 * event object for dom
	 * @author yiminghe@gmail.com
	 */
	
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _EventBaseObject = __webpack_require__(2117);
	
	var _EventBaseObject2 = _interopRequireDefault(_EventBaseObject);
	
	var _objectAssign = __webpack_require__(302);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var TRUE = true;
	var FALSE = false;
	var commonProps = ['altKey', 'bubbles', 'cancelable', 'ctrlKey', 'currentTarget', 'eventPhase', 'metaKey', 'shiftKey', 'target', 'timeStamp', 'view', 'type'];
	
	function isNullOrUndefined(w) {
	  return w === null || w === undefined;
	}
	
	var eventNormalizers = [{
	  reg: /^key/,
	  props: ['char', 'charCode', 'key', 'keyCode', 'which'],
	  fix: function fix(event, nativeEvent) {
	    if (isNullOrUndefined(event.which)) {
	      event.which = !isNullOrUndefined(nativeEvent.charCode) ? nativeEvent.charCode : nativeEvent.keyCode;
	    }
	
	    // add metaKey to non-Mac browsers (use ctrl for PC 's and Meta for Macs)
	    if (event.metaKey === undefined) {
	      event.metaKey = event.ctrlKey;
	    }
	  }
	}, {
	  reg: /^touch/,
	  props: ['touches', 'changedTouches', 'targetTouches']
	}, {
	  reg: /^hashchange$/,
	  props: ['newURL', 'oldURL']
	}, {
	  reg: /^gesturechange$/i,
	  props: ['rotation', 'scale']
	}, {
	  reg: /^(mousewheel|DOMMouseScroll)$/,
	  props: [],
	  fix: function fix(event, nativeEvent) {
	    var deltaX = undefined;
	    var deltaY = undefined;
	    var delta = undefined;
	    var wheelDelta = nativeEvent.wheelDelta;
	    var axis = nativeEvent.axis;
	    var wheelDeltaY = nativeEvent.wheelDeltaY;
	    var wheelDeltaX = nativeEvent.wheelDeltaX;
	    var detail = nativeEvent.detail;
	
	    // ie/webkit
	    if (wheelDelta) {
	      delta = wheelDelta / 120;
	    }
	
	    // gecko
	    if (detail) {
	      // press control e.detail == 1 else e.detail == 3
	      delta = 0 - (detail % 3 === 0 ? detail / 3 : detail);
	    }
	
	    // Gecko
	    if (axis !== undefined) {
	      if (axis === event.HORIZONTAL_AXIS) {
	        deltaY = 0;
	        deltaX = 0 - delta;
	      } else if (axis === event.VERTICAL_AXIS) {
	        deltaX = 0;
	        deltaY = delta;
	      }
	    }
	
	    // Webkit
	    if (wheelDeltaY !== undefined) {
	      deltaY = wheelDeltaY / 120;
	    }
	    if (wheelDeltaX !== undefined) {
	      deltaX = -1 * wheelDeltaX / 120;
	    }
	
	    // 默认 deltaY (ie)
	    if (!deltaX && !deltaY) {
	      deltaY = delta;
	    }
	
	    if (deltaX !== undefined) {
	      /**
	       * deltaX of mousewheel event
	       * @property deltaX
	       * @member Event.DomEvent.Object
	       */
	      event.deltaX = deltaX;
	    }
	
	    if (deltaY !== undefined) {
	      /**
	       * deltaY of mousewheel event
	       * @property deltaY
	       * @member Event.DomEvent.Object
	       */
	      event.deltaY = deltaY;
	    }
	
	    if (delta !== undefined) {
	      /**
	       * delta of mousewheel event
	       * @property delta
	       * @member Event.DomEvent.Object
	       */
	      event.delta = delta;
	    }
	  }
	}, {
	  reg: /^mouse|contextmenu|click|mspointer|(^DOMMouseScroll$)/i,
	  props: ['buttons', 'clientX', 'clientY', 'button', 'offsetX', 'relatedTarget', 'which', 'fromElement', 'toElement', 'offsetY', 'pageX', 'pageY', 'screenX', 'screenY'],
	  fix: function fix(event, nativeEvent) {
	    var eventDoc = undefined;
	    var doc = undefined;
	    var body = undefined;
	    var target = event.target;
	    var button = nativeEvent.button;
	
	    // Calculate pageX/Y if missing and clientX/Y available
	    if (target && isNullOrUndefined(event.pageX) && !isNullOrUndefined(nativeEvent.clientX)) {
	      eventDoc = target.ownerDocument || document;
	      doc = eventDoc.documentElement;
	      body = eventDoc.body;
	      event.pageX = nativeEvent.clientX + (doc && doc.scrollLeft || body && body.scrollLeft || 0) - (doc && doc.clientLeft || body && body.clientLeft || 0);
	      event.pageY = nativeEvent.clientY + (doc && doc.scrollTop || body && body.scrollTop || 0) - (doc && doc.clientTop || body && body.clientTop || 0);
	    }
	
	    // which for click: 1 === left; 2 === middle; 3 === right
	    // do not use button
	    if (!event.which && button !== undefined) {
	      if (button & 1) {
	        event.which = 1;
	      } else if (button & 2) {
	        event.which = 3;
	      } else if (button & 4) {
	        event.which = 2;
	      } else {
	        event.which = 0;
	      }
	    }
	
	    // add relatedTarget, if necessary
	    if (!event.relatedTarget && event.fromElement) {
	      event.relatedTarget = event.fromElement === target ? event.toElement : event.fromElement;
	    }
	
	    return event;
	  }
	}];
	
	function retTrue() {
	  return TRUE;
	}
	
	function retFalse() {
	  return FALSE;
	}
	
	function DomEventObject(nativeEvent) {
	  var type = nativeEvent.type;
	
	  var isNative = typeof nativeEvent.stopPropagation === 'function' || typeof nativeEvent.cancelBubble === 'boolean';
	
	  _EventBaseObject2['default'].call(this);
	
	  this.nativeEvent = nativeEvent;
	
	  // in case dom event has been mark as default prevented by lower dom node
	  var isDefaultPrevented = retFalse;
	  if ('defaultPrevented' in nativeEvent) {
	    isDefaultPrevented = nativeEvent.defaultPrevented ? retTrue : retFalse;
	  } else if ('getPreventDefault' in nativeEvent) {
	    // https://bugzilla.mozilla.org/show_bug.cgi?id=691151
	    isDefaultPrevented = nativeEvent.getPreventDefault() ? retTrue : retFalse;
	  } else if ('returnValue' in nativeEvent) {
	    isDefaultPrevented = nativeEvent.returnValue === FALSE ? retTrue : retFalse;
	  }
	
	  this.isDefaultPrevented = isDefaultPrevented;
	
	  var fixFns = [];
	  var fixFn = undefined;
	  var l = undefined;
	  var prop = undefined;
	  var props = commonProps.concat();
	
	  eventNormalizers.forEach(function (normalizer) {
	    if (type.match(normalizer.reg)) {
	      props = props.concat(normalizer.props);
	      if (normalizer.fix) {
	        fixFns.push(normalizer.fix);
	      }
	    }
	  });
	
	  l = props.length;
	
	  // clone properties of the original event object
	  while (l) {
	    prop = props[--l];
	    this[prop] = nativeEvent[prop];
	  }
	
	  // fix target property, if necessary
	  if (!this.target && isNative) {
	    this.target = nativeEvent.srcElement || document; // srcElement might not be defined either
	  }
	
	  // check if target is a text node (safari)
	  if (this.target && this.target.nodeType === 3) {
	    this.target = this.target.parentNode;
	  }
	
	  l = fixFns.length;
	
	  while (l) {
	    fixFn = fixFns[--l];
	    fixFn(this, nativeEvent);
	  }
	
	  this.timeStamp = nativeEvent.timeStamp || Date.now();
	}
	
	var EventBaseObjectProto = _EventBaseObject2['default'].prototype;
	
	(0, _objectAssign2['default'])(DomEventObject.prototype, EventBaseObjectProto, {
	  constructor: DomEventObject,
	
	  preventDefault: function preventDefault() {
	    var e = this.nativeEvent;
	
	    // if preventDefault exists run it on the original event
	    if (e.preventDefault) {
	      e.preventDefault();
	    } else {
	      // otherwise set the returnValue property of the original event to FALSE (IE)
	      e.returnValue = FALSE;
	    }
	
	    EventBaseObjectProto.preventDefault.call(this);
	  },
	
	  stopPropagation: function stopPropagation() {
	    var e = this.nativeEvent;
	
	    // if stopPropagation exists run it on the original event
	    if (e.stopPropagation) {
	      e.stopPropagation();
	    } else {
	      // otherwise set the cancelBubble property of the original event to TRUE (IE)
	      e.cancelBubble = TRUE;
	    }
	
	    EventBaseObjectProto.stopPropagation.call(this);
	  }
	});
	
	exports['default'] = DomEventObject;
	module.exports = exports['default'];

/***/ }),
/* 2117 */
/***/ (function(module, exports) {

	/**
	 * @ignore
	 * base event object for custom and dom event.
	 * @author yiminghe@gmail.com
	 */
	
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	function returnFalse() {
	  return false;
	}
	
	function returnTrue() {
	  return true;
	}
	
	function EventBaseObject() {
	  this.timeStamp = Date.now();
	  this.target = undefined;
	  this.currentTarget = undefined;
	}
	
	EventBaseObject.prototype = {
	  isEventObject: 1,
	
	  constructor: EventBaseObject,
	
	  isDefaultPrevented: returnFalse,
	
	  isPropagationStopped: returnFalse,
	
	  isImmediatePropagationStopped: returnFalse,
	
	  preventDefault: function preventDefault() {
	    this.isDefaultPrevented = returnTrue;
	  },
	
	  stopPropagation: function stopPropagation() {
	    this.isPropagationStopped = returnTrue;
	  },
	
	  stopImmediatePropagation: function stopImmediatePropagation() {
	    this.isImmediatePropagationStopped = returnTrue;
	    // fixed 1.2
	    // call stopPropagation implicitly
	    this.stopPropagation();
	  },
	
	  halt: function halt(immediate) {
	    if (immediate) {
	      this.stopImmediatePropagation();
	    } else {
	      this.stopPropagation();
	    }
	    this.preventDefault();
	  }
	};
	
	exports["default"] = EventBaseObject;
	module.exports = exports["default"];

/***/ }),
/* 2118 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(332);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _rcAlign = __webpack_require__(2119);
	
	var _rcAlign2 = _interopRequireDefault(_rcAlign);
	
	var _rcAnimate = __webpack_require__(2131);
	
	var _rcAnimate2 = _interopRequireDefault(_rcAnimate);
	
	var _PopupInner = __webpack_require__(2140);
	
	var _PopupInner2 = _interopRequireDefault(_PopupInner);
	
	var _LazyRenderBox = __webpack_require__(2141);
	
	var _LazyRenderBox2 = _interopRequireDefault(_LazyRenderBox);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var Popup = _react2["default"].createClass({
	  displayName: 'Popup',
	
	  propTypes: {
	    visible: _react.PropTypes.bool,
	    style: _react.PropTypes.object,
	    getClassNameFromAlign: _react.PropTypes.func,
	    onAlign: _react.PropTypes.func,
	    getRootDomNode: _react.PropTypes.func,
	    onMouseEnter: _react.PropTypes.func,
	    align: _react.PropTypes.any,
	    destroyPopupOnHide: _react.PropTypes.bool,
	    className: _react.PropTypes.string,
	    prefixCls: _react.PropTypes.string,
	    onMouseLeave: _react.PropTypes.func
	  },
	
	  componentDidMount: function componentDidMount() {
	    this.rootNode = this.getPopupDomNode();
	  },
	  onAlign: function onAlign(popupDomNode, align) {
	    var props = this.props;
	    var alignClassName = props.getClassNameFromAlign(props.align);
	    var currentAlignClassName = props.getClassNameFromAlign(align);
	    if (alignClassName !== currentAlignClassName) {
	      this.currentAlignClassName = currentAlignClassName;
	      popupDomNode.className = this.getClassName(currentAlignClassName);
	    }
	    props.onAlign(popupDomNode, align);
	  },
	  getPopupDomNode: function getPopupDomNode() {
	    return _reactDom2["default"].findDOMNode(this.refs.popup);
	  },
	  getTarget: function getTarget() {
	    return this.props.getRootDomNode();
	  },
	  getMaskTransitionName: function getMaskTransitionName() {
	    var props = this.props;
	    var transitionName = props.maskTransitionName;
	    var animation = props.maskAnimation;
	    if (!transitionName && animation) {
	      transitionName = props.prefixCls + '-' + animation;
	    }
	    return transitionName;
	  },
	  getTransitionName: function getTransitionName() {
	    var props = this.props;
	    var transitionName = props.transitionName;
	    if (!transitionName && props.animation) {
	      transitionName = props.prefixCls + '-' + props.animation;
	    }
	    return transitionName;
	  },
	  getClassName: function getClassName(currentAlignClassName) {
	    return this.props.prefixCls + ' ' + this.props.className + ' ' + currentAlignClassName;
	  },
	  getPopupElement: function getPopupElement() {
	    var props = this.props;
	    var align = props.align;
	    var style = props.style;
	    var visible = props.visible;
	    var prefixCls = props.prefixCls;
	    var destroyPopupOnHide = props.destroyPopupOnHide;
	
	    var className = this.getClassName(this.currentAlignClassName || props.getClassNameFromAlign(align));
	    var hiddenClassName = prefixCls + '-hidden';
	    if (!visible) {
	      this.currentAlignClassName = null;
	    }
	    var newStyle = _extends({}, style, this.getZIndexStyle());
	    var popupInnerProps = {
	      className: className,
	      prefixCls: prefixCls,
	      ref: 'popup',
	      onMouseEnter: props.onMouseEnter,
	      onMouseLeave: props.onMouseLeave,
	      style: newStyle
	    };
	    if (destroyPopupOnHide) {
	      return _react2["default"].createElement(
	        _rcAnimate2["default"],
	        {
	          component: '',
	          exclusive: true,
	          transitionAppear: true,
	          transitionName: this.getTransitionName()
	        },
	        visible ? _react2["default"].createElement(
	          _rcAlign2["default"],
	          {
	            target: this.getTarget,
	            key: 'popup',
	            ref: this.saveAlign,
	            monitorWindowResize: true,
	            align: align,
	            onAlign: this.onAlign
	          },
	          _react2["default"].createElement(
	            _PopupInner2["default"],
	            _extends({
	              visible: true
	            }, popupInnerProps),
	            props.children
	          )
	        ) : null
	      );
	    }
	    return _react2["default"].createElement(
	      _rcAnimate2["default"],
	      {
	        component: '',
	        exclusive: true,
	        transitionAppear: true,
	        transitionName: this.getTransitionName(),
	        showProp: 'xVisible'
	      },
	      _react2["default"].createElement(
	        _rcAlign2["default"],
	        {
	          target: this.getTarget,
	          key: 'popup',
	          ref: this.saveAlign,
	          monitorWindowResize: true,
	          xVisible: visible,
	          childrenProps: { visible: 'xVisible' },
	          disabled: !visible,
	          align: align,
	          onAlign: this.onAlign
	        },
	        _react2["default"].createElement(
	          _PopupInner2["default"],
	          _extends({
	            hiddenClassName: hiddenClassName
	          }, popupInnerProps),
	          props.children
	        )
	      )
	    );
	  },
	  getZIndexStyle: function getZIndexStyle() {
	    var style = {};
	    var props = this.props;
	    if (props.zIndex !== undefined) {
	      style.zIndex = props.zIndex;
	    }
	    return style;
	  },
	  getMaskElement: function getMaskElement() {
	    var props = this.props;
	    var maskElement = void 0;
	    if (props.mask) {
	      var maskTransition = this.getMaskTransitionName();
	      maskElement = _react2["default"].createElement(_LazyRenderBox2["default"], {
	        style: this.getZIndexStyle(),
	        key: 'mask',
	        className: props.prefixCls + '-mask',
	        hiddenClassName: props.prefixCls + '-mask-hidden',
	        visible: props.visible
	      });
	      if (maskTransition) {
	        maskElement = _react2["default"].createElement(
	          _rcAnimate2["default"],
	          {
	            key: 'mask',
	            showProp: 'visible',
	            transitionAppear: true,
	            component: '',
	            transitionName: maskTransition
	          },
	          maskElement
	        );
	      }
	    }
	    return maskElement;
	  },
	  saveAlign: function saveAlign(align) {
	    this.alignInstance = align;
	  },
	  render: function render() {
	    return _react2["default"].createElement(
	      'div',
	      null,
	      this.getMaskElement(),
	      this.getPopupElement()
	    );
	  }
	});
	
	exports["default"] = Popup;
	module.exports = exports['default'];

/***/ }),
/* 2119 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Align = __webpack_require__(2120);
	
	var _Align2 = _interopRequireDefault(_Align);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	exports["default"] = _Align2["default"]; // export this package's api
	
	module.exports = exports['default'];

/***/ }),
/* 2120 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(332);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _domAlign = __webpack_require__(2121);
	
	var _domAlign2 = _interopRequireDefault(_domAlign);
	
	var _addEventListener = __webpack_require__(2129);
	
	var _addEventListener2 = _interopRequireDefault(_addEventListener);
	
	var _isWindow = __webpack_require__(2130);
	
	var _isWindow2 = _interopRequireDefault(_isWindow);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function buffer(fn, ms) {
	  var timer = void 0;
	
	  function clear() {
	    if (timer) {
	      clearTimeout(timer);
	      timer = null;
	    }
	  }
	
	  function bufferFn() {
	    clear();
	    timer = setTimeout(fn, ms);
	  }
	
	  bufferFn.clear = clear;
	
	  return bufferFn;
	}
	
	var Align = _react2["default"].createClass({
	  displayName: 'Align',
	
	  propTypes: {
	    childrenProps: _react.PropTypes.object,
	    align: _react.PropTypes.object.isRequired,
	    target: _react.PropTypes.func,
	    onAlign: _react.PropTypes.func,
	    monitorBufferTime: _react.PropTypes.number,
	    monitorWindowResize: _react.PropTypes.bool,
	    disabled: _react.PropTypes.bool,
	    children: _react.PropTypes.any
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      target: function target() {
	        return window;
	      },
	      onAlign: function onAlign() {},
	
	      monitorBufferTime: 50,
	      monitorWindowResize: false,
	      disabled: false
	    };
	  },
	  componentDidMount: function componentDidMount() {
	    var props = this.props;
	    // if parent ref not attached .... use document.getElementById
	    this.forceAlign();
	    if (!props.disabled && props.monitorWindowResize) {
	      this.startMonitorWindowResize();
	    }
	  },
	  componentDidUpdate: function componentDidUpdate(prevProps) {
	    var reAlign = false;
	    var props = this.props;
	
	    if (!props.disabled) {
	      if (prevProps.disabled || prevProps.align !== props.align) {
	        reAlign = true;
	      } else {
	        var lastTarget = prevProps.target();
	        var currentTarget = props.target();
	        if ((0, _isWindow2["default"])(lastTarget) && (0, _isWindow2["default"])(currentTarget)) {
	          reAlign = false;
	        } else if (lastTarget !== currentTarget) {
	          reAlign = true;
	        }
	      }
	    }
	
	    if (reAlign) {
	      this.forceAlign();
	    }
	
	    if (props.monitorWindowResize && !props.disabled) {
	      this.startMonitorWindowResize();
	    } else {
	      this.stopMonitorWindowResize();
	    }
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    this.stopMonitorWindowResize();
	  },
	  startMonitorWindowResize: function startMonitorWindowResize() {
	    if (!this.resizeHandler) {
	      this.bufferMonitor = buffer(this.forceAlign, this.props.monitorBufferTime);
	      this.resizeHandler = (0, _addEventListener2["default"])(window, 'resize', this.bufferMonitor);
	    }
	  },
	  stopMonitorWindowResize: function stopMonitorWindowResize() {
	    if (this.resizeHandler) {
	      this.bufferMonitor.clear();
	      this.resizeHandler.remove();
	      this.resizeHandler = null;
	    }
	  },
	  forceAlign: function forceAlign() {
	    var props = this.props;
	    if (!props.disabled) {
	      var source = _reactDom2["default"].findDOMNode(this);
	      props.onAlign(source, (0, _domAlign2["default"])(source, props.target(), props.align));
	    }
	  },
	  render: function render() {
	    var _props = this.props;
	    var childrenProps = _props.childrenProps;
	    var children = _props.children;
	
	    var child = _react2["default"].Children.only(children);
	    if (childrenProps) {
	      var newProps = {};
	      for (var prop in childrenProps) {
	        if (childrenProps.hasOwnProperty(prop)) {
	          newProps[prop] = this.props[childrenProps[prop]];
	        }
	      }
	      return _react2["default"].cloneElement(child, newProps);
	    }
	    return child;
	  }
	});
	
	exports["default"] = Align;
	module.exports = exports['default'];

/***/ }),
/* 2121 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * align dom node flexibly
	 * @author yiminghe@gmail.com
	 */
	
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _utils = __webpack_require__(2122);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	var _getOffsetParent = __webpack_require__(2123);
	
	var _getOffsetParent2 = _interopRequireDefault(_getOffsetParent);
	
	var _getVisibleRectForElement = __webpack_require__(2124);
	
	var _getVisibleRectForElement2 = _interopRequireDefault(_getVisibleRectForElement);
	
	var _adjustForViewport = __webpack_require__(2125);
	
	var _adjustForViewport2 = _interopRequireDefault(_adjustForViewport);
	
	var _getRegion = __webpack_require__(2126);
	
	var _getRegion2 = _interopRequireDefault(_getRegion);
	
	var _getElFuturePos = __webpack_require__(2127);
	
	var _getElFuturePos2 = _interopRequireDefault(_getElFuturePos);
	
	// http://yiminghe.iteye.com/blog/1124720
	
	function isFailX(elFuturePos, elRegion, visibleRect) {
	  return elFuturePos.left < visibleRect.left || elFuturePos.left + elRegion.width > visibleRect.right;
	}
	
	function isFailY(elFuturePos, elRegion, visibleRect) {
	  return elFuturePos.top < visibleRect.top || elFuturePos.top + elRegion.height > visibleRect.bottom;
	}
	
	function isCompleteFailX(elFuturePos, elRegion, visibleRect) {
	  return elFuturePos.left > visibleRect.right || elFuturePos.left + elRegion.width < visibleRect.left;
	}
	
	function isCompleteFailY(elFuturePos, elRegion, visibleRect) {
	  return elFuturePos.top > visibleRect.bottom || elFuturePos.top + elRegion.height < visibleRect.top;
	}
	
	function flip(points, reg, map) {
	  var ret = [];
	  _utils2['default'].each(points, function (p) {
	    ret.push(p.replace(reg, function (m) {
	      return map[m];
	    }));
	  });
	  return ret;
	}
	
	function flipOffset(offset, index) {
	  offset[index] = -offset[index];
	  return offset;
	}
	
	function convertOffset(str, offsetLen) {
	  var n = undefined;
	  if (/%$/.test(str)) {
	    n = parseInt(str.substring(0, str.length - 1), 10) / 100 * offsetLen;
	  } else {
	    n = parseInt(str, 10);
	  }
	  return n || 0;
	}
	
	function normalizeOffset(offset, el) {
	  offset[0] = convertOffset(offset[0], el.width);
	  offset[1] = convertOffset(offset[1], el.height);
	}
	
	function domAlign(el, refNode, align) {
	  var points = align.points;
	  var offset = align.offset || [0, 0];
	  var targetOffset = align.targetOffset || [0, 0];
	  var overflow = align.overflow;
	  var target = align.target || refNode;
	  var source = align.source || el;
	  offset = [].concat(offset);
	  targetOffset = [].concat(targetOffset);
	  overflow = overflow || {};
	  var newOverflowCfg = {};
	
	  var fail = 0;
	  // 当前节点可以被放置的显示区域
	  var visibleRect = (0, _getVisibleRectForElement2['default'])(source);
	  // 当前节点所占的区域, left/top/width/height
	  var elRegion = (0, _getRegion2['default'])(source);
	  // 参照节点所占的区域, left/top/width/height
	  var refNodeRegion = (0, _getRegion2['default'])(target);
	  // 将 offset 转换成数值，支持百分比
	  normalizeOffset(offset, elRegion);
	  normalizeOffset(targetOffset, refNodeRegion);
	  // 当前节点将要被放置的位置
	  var elFuturePos = (0, _getElFuturePos2['default'])(elRegion, refNodeRegion, points, offset, targetOffset);
	  // 当前节点将要所处的区域
	  var newElRegion = _utils2['default'].merge(elRegion, elFuturePos);
	
	  // 如果可视区域不能完全放置当前节点时允许调整
	  if (visibleRect && (overflow.adjustX || overflow.adjustY)) {
	    if (overflow.adjustX) {
	      // 如果横向不能放下
	      if (isFailX(elFuturePos, elRegion, visibleRect)) {
	        // 对齐位置反下
	        var newPoints = flip(points, /[lr]/ig, {
	          l: 'r',
	          r: 'l'
	        });
	        // 偏移量也反下
	        var newOffset = flipOffset(offset, 0);
	        var newTargetOffset = flipOffset(targetOffset, 0);
	        var newElFuturePos = (0, _getElFuturePos2['default'])(elRegion, refNodeRegion, newPoints, newOffset, newTargetOffset);
	        if (!isCompleteFailX(newElFuturePos, elRegion, visibleRect)) {
	          fail = 1;
	          points = newPoints;
	          offset = newOffset;
	          targetOffset = newTargetOffset;
	        }
	      }
	    }
	
	    if (overflow.adjustY) {
	      // 如果纵向不能放下
	      if (isFailY(elFuturePos, elRegion, visibleRect)) {
	        // 对齐位置反下
	        var newPoints = flip(points, /[tb]/ig, {
	          t: 'b',
	          b: 't'
	        });
	        // 偏移量也反下
	        var newOffset = flipOffset(offset, 1);
	        var newTargetOffset = flipOffset(targetOffset, 1);
	        var newElFuturePos = (0, _getElFuturePos2['default'])(elRegion, refNodeRegion, newPoints, newOffset, newTargetOffset);
	        if (!isCompleteFailY(newElFuturePos, elRegion, visibleRect)) {
	          fail = 1;
	          points = newPoints;
	          offset = newOffset;
	          targetOffset = newTargetOffset;
	        }
	      }
	    }
	
	    // 如果失败，重新计算当前节点将要被放置的位置
	    if (fail) {
	      elFuturePos = (0, _getElFuturePos2['default'])(elRegion, refNodeRegion, points, offset, targetOffset);
	      _utils2['default'].mix(newElRegion, elFuturePos);
	    }
	
	    // 检查反下后的位置是否可以放下了
	    // 如果仍然放不下只有指定了可以调整当前方向才调整
	    newOverflowCfg.adjustX = overflow.adjustX && isFailX(elFuturePos, elRegion, visibleRect);
	
	    newOverflowCfg.adjustY = overflow.adjustY && isFailY(elFuturePos, elRegion, visibleRect);
	
	    // 确实要调整，甚至可能会调整高度宽度
	    if (newOverflowCfg.adjustX || newOverflowCfg.adjustY) {
	      newElRegion = (0, _adjustForViewport2['default'])(elFuturePos, elRegion, visibleRect, newOverflowCfg);
	    }
	  }
	
	  // need judge to in case set fixed with in css on height auto element
	  if (newElRegion.width !== elRegion.width) {
	    _utils2['default'].css(source, 'width', source.width() + newElRegion.width - elRegion.width);
	  }
	
	  if (newElRegion.height !== elRegion.height) {
	    _utils2['default'].css(source, 'height', source.height() + newElRegion.height - elRegion.height);
	  }
	
	  // https://github.com/kissyteam/kissy/issues/190
	  // http://localhost:8888/kissy/src/overlay/demo/other/relative_align/align.html
	  // 相对于屏幕位置没变，而 left/top 变了
	  // 例如 <div 'relative'><el absolute></div>
	  _utils2['default'].offset(source, {
	    left: newElRegion.left,
	    top: newElRegion.top
	  }, {
	    useCssRight: align.useCssRight,
	    useCssBottom: align.useCssBottom
	  });
	
	  return {
	    points: points,
	    offset: offset,
	    targetOffset: targetOffset,
	    overflow: newOverflowCfg
	  };
	}
	
	domAlign.__getOffsetParent = _getOffsetParent2['default'];
	
	domAlign.__getVisibleRectForElement = _getVisibleRectForElement2['default'];
	
	exports['default'] = domAlign;
	
	/**
	 *  2012-04-26 yiminghe@gmail.com
	 *   - 优化智能对齐算法
	 *   - 慎用 resizeXX
	 *
	 *  2011-07-13 yiminghe@gmail.com note:
	 *   - 增加智能对齐，以及大小调整选项
	 **/
	module.exports = exports['default'];

/***/ }),
/* 2122 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var RE_NUM = /[\-+]?(?:\d*\.|)\d+(?:[eE][\-+]?\d+|)/.source;
	
	var getComputedStyleX = undefined;
	
	function css(el, name, v) {
	  var value = v;
	  if (typeof name === 'object') {
	    for (var i in name) {
	      if (name.hasOwnProperty(i)) {
	        css(el, i, name[i]);
	      }
	    }
	    return undefined;
	  }
	  if (typeof value !== 'undefined') {
	    if (typeof value === 'number') {
	      value = value + 'px';
	    }
	    el.style[name] = value;
	    return undefined;
	  }
	  return getComputedStyleX(el, name);
	}
	
	function getClientPosition(elem) {
	  var box = undefined;
	  var x = undefined;
	  var y = undefined;
	  var doc = elem.ownerDocument;
	  var body = doc.body;
	  var docElem = doc && doc.documentElement;
	  // 根据 GBS 最新数据，A-Grade Browsers 都已支持 getBoundingClientRect 方法，不用再考虑传统的实现方式
	  box = elem.getBoundingClientRect();
	
	  // 注：jQuery 还考虑减去 docElem.clientLeft/clientTop
	  // 但测试发现，这样反而会导致当 html 和 body 有边距/边框样式时，获取的值不正确
	  // 此外，ie6 会忽略 html 的 margin 值，幸运地是没有谁会去设置 html 的 margin
	
	  x = box.left;
	  y = box.top;
	
	  // In IE, most of the time, 2 extra pixels are added to the top and left
	  // due to the implicit 2-pixel inset border.  In IE6/7 quirks mode and
	  // IE6 standards mode, this border can be overridden by setting the
	  // document element's border to zero -- thus, we cannot rely on the
	  // offset always being 2 pixels.
	
	  // In quirks mode, the offset can be determined by querying the body's
	  // clientLeft/clientTop, but in standards mode, it is found by querying
	  // the document element's clientLeft/clientTop.  Since we already called
	  // getClientBoundingRect we have already forced a reflow, so it is not
	  // too expensive just to query them all.
	
	  // ie 下应该减去窗口的边框吧，毕竟默认 absolute 都是相对窗口定位的
	  // 窗口边框标准是设 documentElement ,quirks 时设置 body
	  // 最好禁止在 body 和 html 上边框 ，但 ie < 9 html 默认有 2px ，减去
	  // 但是非 ie 不可能设置窗口边框，body html 也不是窗口 ,ie 可以通过 html,body 设置
	  // 标准 ie 下 docElem.clientTop 就是 border-top
	  // ie7 html 即窗口边框改变不了。永远为 2
	  // 但标准 firefox/chrome/ie9 下 docElem.clientTop 是窗口边框，即使设了 border-top 也为 0
	
	  x -= docElem.clientLeft || body.clientLeft || 0;
	  y -= docElem.clientTop || body.clientTop || 0;
	
	  return { left: x, top: y };
	}
	
	function getScroll(w, top) {
	  var ret = w['page' + (top ? 'Y' : 'X') + 'Offset'];
	  var method = 'scroll' + (top ? 'Top' : 'Left');
	  if (typeof ret !== 'number') {
	    var d = w.document;
	    // ie6,7,8 standard mode
	    ret = d.documentElement[method];
	    if (typeof ret !== 'number') {
	      // quirks mode
	      ret = d.body[method];
	    }
	  }
	  return ret;
	}
	
	function getScrollLeft(w) {
	  return getScroll(w);
	}
	
	function getScrollTop(w) {
	  return getScroll(w, true);
	}
	
	function getOffset(el) {
	  var pos = getClientPosition(el);
	  var doc = el.ownerDocument;
	  var w = doc.defaultView || doc.parentWindow;
	  pos.left += getScrollLeft(w);
	  pos.top += getScrollTop(w);
	  return pos;
	}
	function _getComputedStyle(elem, name, cs) {
	  var computedStyle = cs;
	  var val = '';
	  var d = elem.ownerDocument;
	  computedStyle = computedStyle || d.defaultView.getComputedStyle(elem, null);
	
	  // https://github.com/kissyteam/kissy/issues/61
	  if (computedStyle) {
	    val = computedStyle.getPropertyValue(name) || computedStyle[name];
	  }
	
	  return val;
	}
	
	var _RE_NUM_NO_PX = new RegExp('^(' + RE_NUM + ')(?!px)[a-z%]+$', 'i');
	var RE_POS = /^(top|right|bottom|left)$/;
	var CURRENT_STYLE = 'currentStyle';
	var RUNTIME_STYLE = 'runtimeStyle';
	var LEFT = 'left';
	var PX = 'px';
	
	function _getComputedStyleIE(elem, name) {
	  // currentStyle maybe null
	  // http://msdn.microsoft.com/en-us/library/ms535231.aspx
	  var ret = elem[CURRENT_STYLE] && elem[CURRENT_STYLE][name];
	
	  // 当 width/height 设置为百分比时，通过 pixelLeft 方式转换的 width/height 值
	  // 一开始就处理了! CUSTOM_STYLE.height,CUSTOM_STYLE.width ,cssHook 解决@2011-08-19
	  // 在 ie 下不对，需要直接用 offset 方式
	  // borderWidth 等值也有问题，但考虑到 borderWidth 设为百分比的概率很小，这里就不考虑了
	
	  // From the awesome hack by Dean Edwards
	  // http://erik.eae.net/archives/2007/07/27/18.54.15/#comment-102291
	  // If we're not dealing with a regular pixel number
	  // but a number that has a weird ending, we need to convert it to pixels
	  // exclude left right for relativity
	  if (_RE_NUM_NO_PX.test(ret) && !RE_POS.test(name)) {
	    // Remember the original values
	    var style = elem.style;
	    var left = style[LEFT];
	    var rsLeft = elem[RUNTIME_STYLE][LEFT];
	
	    // prevent flashing of content
	    elem[RUNTIME_STYLE][LEFT] = elem[CURRENT_STYLE][LEFT];
	
	    // Put in the new values to get a computed value out
	    style[LEFT] = name === 'fontSize' ? '1em' : ret || 0;
	    ret = style.pixelLeft + PX;
	
	    // Revert the changed values
	    style[LEFT] = left;
	
	    elem[RUNTIME_STYLE][LEFT] = rsLeft;
	  }
	  return ret === '' ? 'auto' : ret;
	}
	
	if (typeof window !== 'undefined') {
	  getComputedStyleX = window.getComputedStyle ? _getComputedStyle : _getComputedStyleIE;
	}
	
	function getOffsetDirection(dir, option) {
	  if (dir === 'left') {
	    return option.useCssRight ? 'right' : dir;
	  }
	  return option.useCssBottom ? 'bottom' : dir;
	}
	
	function oppositeOffsetDirection(dir) {
	  if (dir === 'left') {
	    return 'right';
	  } else if (dir === 'right') {
	    return 'left';
	  } else if (dir === 'top') {
	    return 'bottom';
	  } else if (dir === 'bottom') {
	    return 'top';
	  }
	}
	
	// 设置 elem 相对 elem.ownerDocument 的坐标
	function setOffset(elem, offset, option) {
	  // set position first, in-case top/left are set even on static elem
	  if (css(elem, 'position') === 'static') {
	    elem.style.position = 'relative';
	  }
	  var presetH = -999;
	  var presetV = -999;
	  var horizontalProperty = getOffsetDirection('left', option);
	  var verticalProperty = getOffsetDirection('top', option);
	  var oppositeHorizontalProperty = oppositeOffsetDirection(horizontalProperty);
	  var oppositeVerticalProperty = oppositeOffsetDirection(verticalProperty);
	
	  if (horizontalProperty !== 'left') {
	    presetH = 999;
	  }
	
	  if (verticalProperty !== 'top') {
	    presetV = 999;
	  }
	
	  if ('left' in offset) {
	    elem.style[oppositeHorizontalProperty] = '';
	    elem.style[horizontalProperty] = presetH + 'px';
	  }
	  if ('top' in offset) {
	    elem.style[oppositeVerticalProperty] = '';
	    elem.style[verticalProperty] = presetV + 'px';
	  }
	  var old = getOffset(elem);
	  var ret = {};
	  var key = undefined;
	  for (key in offset) {
	    if (offset.hasOwnProperty(key)) {
	      var dir = getOffsetDirection(key, option);
	      var preset = key === 'left' ? presetH : presetV;
	      if (dir === key) {
	        ret[dir] = preset + offset[key] - old[key];
	      } else {
	        ret[dir] = preset + old[key] - offset[key];
	      }
	    }
	  }
	  css(elem, ret);
	}
	
	function each(arr, fn) {
	  for (var i = 0; i < arr.length; i++) {
	    fn(arr[i]);
	  }
	}
	
	function isBorderBoxFn(elem) {
	  return getComputedStyleX(elem, 'boxSizing') === 'border-box';
	}
	
	var BOX_MODELS = ['margin', 'border', 'padding'];
	var CONTENT_INDEX = -1;
	var PADDING_INDEX = 2;
	var BORDER_INDEX = 1;
	var MARGIN_INDEX = 0;
	
	function swap(elem, options, callback) {
	  var old = {};
	  var style = elem.style;
	  var name = undefined;
	
	  // Remember the old values, and insert the new ones
	  for (name in options) {
	    if (options.hasOwnProperty(name)) {
	      old[name] = style[name];
	      style[name] = options[name];
	    }
	  }
	
	  callback.call(elem);
	
	  // Revert the old values
	  for (name in options) {
	    if (options.hasOwnProperty(name)) {
	      style[name] = old[name];
	    }
	  }
	}
	
	function getPBMWidth(elem, props, which) {
	  var value = 0;
	  var prop = undefined;
	  var j = undefined;
	  var i = undefined;
	  for (j = 0; j < props.length; j++) {
	    prop = props[j];
	    if (prop) {
	      for (i = 0; i < which.length; i++) {
	        var cssProp = undefined;
	        if (prop === 'border') {
	          cssProp = prop + which[i] + 'Width';
	        } else {
	          cssProp = prop + which[i];
	        }
	        value += parseFloat(getComputedStyleX(elem, cssProp)) || 0;
	      }
	    }
	  }
	  return value;
	}
	
	/**
	 * A crude way of determining if an object is a window
	 * @member util
	 */
	function isWindow(obj) {
	  // must use == for ie8
	  /* eslint eqeqeq:0 */
	  return obj !== null && obj !== undefined && obj == obj.window;
	}
	
	var domUtils = {};
	
	each(['Width', 'Height'], function (name) {
	  domUtils['doc' + name] = function (refWin) {
	    var d = refWin.document;
	    return Math.max(
	    // firefox chrome documentElement.scrollHeight< body.scrollHeight
	    // ie standard mode : documentElement.scrollHeight> body.scrollHeight
	    d.documentElement['scroll' + name],
	    // quirks : documentElement.scrollHeight 最大等于可视窗口多一点？
	    d.body['scroll' + name], domUtils['viewport' + name](d));
	  };
	
	  domUtils['viewport' + name] = function (win) {
	    // pc browser includes scrollbar in window.innerWidth
	    var prop = 'client' + name;
	    var doc = win.document;
	    var body = doc.body;
	    var documentElement = doc.documentElement;
	    var documentElementProp = documentElement[prop];
	    // 标准模式取 documentElement
	    // backcompat 取 body
	    return doc.compatMode === 'CSS1Compat' && documentElementProp || body && body[prop] || documentElementProp;
	  };
	});
	
	/*
	 得到元素的大小信息
	 @param elem
	 @param name
	 @param {String} [extra]  'padding' : (css width) + padding
	 'border' : (css width) + padding + border
	 'margin' : (css width) + padding + border + margin
	 */
	function getWH(elem, name, ex) {
	  var extra = ex;
	  if (isWindow(elem)) {
	    return name === 'width' ? domUtils.viewportWidth(elem) : domUtils.viewportHeight(elem);
	  } else if (elem.nodeType === 9) {
	    return name === 'width' ? domUtils.docWidth(elem) : domUtils.docHeight(elem);
	  }
	  var which = name === 'width' ? ['Left', 'Right'] : ['Top', 'Bottom'];
	  var borderBoxValue = name === 'width' ? elem.offsetWidth : elem.offsetHeight;
	  var computedStyle = getComputedStyleX(elem);
	  var isBorderBox = isBorderBoxFn(elem, computedStyle);
	  var cssBoxValue = 0;
	  if (borderBoxValue === null || borderBoxValue === undefined || borderBoxValue <= 0) {
	    borderBoxValue = undefined;
	    // Fall back to computed then un computed css if necessary
	    cssBoxValue = getComputedStyleX(elem, name);
	    if (cssBoxValue === null || cssBoxValue === undefined || Number(cssBoxValue) < 0) {
	      cssBoxValue = elem.style[name] || 0;
	    }
	    // Normalize '', auto, and prepare for extra
	    cssBoxValue = parseFloat(cssBoxValue) || 0;
	  }
	  if (extra === undefined) {
	    extra = isBorderBox ? BORDER_INDEX : CONTENT_INDEX;
	  }
	  var borderBoxValueOrIsBorderBox = borderBoxValue !== undefined || isBorderBox;
	  var val = borderBoxValue || cssBoxValue;
	  if (extra === CONTENT_INDEX) {
	    if (borderBoxValueOrIsBorderBox) {
	      return val - getPBMWidth(elem, ['border', 'padding'], which, computedStyle);
	    }
	    return cssBoxValue;
	  } else if (borderBoxValueOrIsBorderBox) {
	    if (extra === BORDER_INDEX) {
	      return val;
	    }
	    return val + (extra === PADDING_INDEX ? -getPBMWidth(elem, ['border'], which, computedStyle) : getPBMWidth(elem, ['margin'], which, computedStyle));
	  }
	  return cssBoxValue + getPBMWidth(elem, BOX_MODELS.slice(extra), which, computedStyle);
	}
	
	var cssShow = { position: 'absolute', visibility: 'hidden', display: 'block' };
	
	// fix #119 : https://github.com/kissyteam/kissy/issues/119
	function getWHIgnoreDisplay() {
	  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	    args[_key] = arguments[_key];
	  }
	
	  var val = undefined;
	  var elem = args[0];
	  // in case elem is window
	  // elem.offsetWidth === undefined
	  if (elem.offsetWidth !== 0) {
	    val = getWH.apply(undefined, args);
	  } else {
	    swap(elem, cssShow, function () {
	      val = getWH.apply(undefined, args);
	    });
	  }
	  return val;
	}
	
	each(['width', 'height'], function (name) {
	  var first = name.charAt(0).toUpperCase() + name.slice(1);
	  domUtils['outer' + first] = function (el, includeMargin) {
	    return el && getWHIgnoreDisplay(el, name, includeMargin ? MARGIN_INDEX : BORDER_INDEX);
	  };
	  var which = name === 'width' ? ['Left', 'Right'] : ['Top', 'Bottom'];
	
	  domUtils[name] = function (elem, v) {
	    var val = v;
	    if (val !== undefined) {
	      if (elem) {
	        var computedStyle = getComputedStyleX(elem);
	        var isBorderBox = isBorderBoxFn(elem);
	        if (isBorderBox) {
	          val += getPBMWidth(elem, ['padding', 'border'], which, computedStyle);
	        }
	        return css(elem, name, val);
	      }
	      return undefined;
	    }
	    return elem && getWHIgnoreDisplay(elem, name, CONTENT_INDEX);
	  };
	});
	
	function mix(to, from) {
	  for (var i in from) {
	    if (from.hasOwnProperty(i)) {
	      to[i] = from[i];
	    }
	  }
	  return to;
	}
	
	var utils = {
	  getWindow: function getWindow(node) {
	    if (node && node.document && node.setTimeout) {
	      return node;
	    }
	    var doc = node.ownerDocument || node;
	    return doc.defaultView || doc.parentWindow;
	  },
	  offset: function offset(el, value, option) {
	    if (typeof value !== 'undefined') {
	      setOffset(el, value, option || {});
	    } else {
	      return getOffset(el);
	    }
	  },
	  isWindow: isWindow,
	  each: each,
	  css: css,
	  clone: function clone(obj) {
	    var i = undefined;
	    var ret = {};
	    for (i in obj) {
	      if (obj.hasOwnProperty(i)) {
	        ret[i] = obj[i];
	      }
	    }
	    var overflow = obj.overflow;
	    if (overflow) {
	      for (i in obj) {
	        if (obj.hasOwnProperty(i)) {
	          ret.overflow[i] = obj.overflow[i];
	        }
	      }
	    }
	    return ret;
	  },
	  mix: mix,
	  getWindowScrollLeft: function getWindowScrollLeft(w) {
	    return getScrollLeft(w);
	  },
	  getWindowScrollTop: function getWindowScrollTop(w) {
	    return getScrollTop(w);
	  },
	  merge: function merge() {
	    var ret = {};
	
	    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	      args[_key2] = arguments[_key2];
	    }
	
	    for (var i = 0; i < args.length; i++) {
	      utils.mix(ret, args[i]);
	    }
	    return ret;
	  },
	  viewportWidth: 0,
	  viewportHeight: 0
	};
	
	mix(utils, domUtils);
	
	exports['default'] = utils;
	module.exports = exports['default'];

/***/ }),
/* 2123 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _utils = __webpack_require__(2122);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	/**
	 * 得到会导致元素显示不全的祖先元素
	 */
	
	function getOffsetParent(element) {
	  // ie 这个也不是完全可行
	  /*
	   <div style="width: 50px;height: 100px;overflow: hidden">
	   <div style="width: 50px;height: 100px;position: relative;" id="d6">
	   元素 6 高 100px 宽 50px<br/>
	   </div>
	   </div>
	   */
	  // element.offsetParent does the right thing in ie7 and below. Return parent with layout!
	  //  In other browsers it only includes elements with position absolute, relative or
	  // fixed, not elements with overflow set to auto or scroll.
	  //        if (UA.ie && ieMode < 8) {
	  //            return element.offsetParent;
	  //        }
	  // 统一的 offsetParent 方法
	  var doc = element.ownerDocument;
	  var body = doc.body;
	  var parent = undefined;
	  var positionStyle = _utils2['default'].css(element, 'position');
	  var skipStatic = positionStyle === 'fixed' || positionStyle === 'absolute';
	
	  if (!skipStatic) {
	    return element.nodeName.toLowerCase() === 'html' ? null : element.parentNode;
	  }
	
	  for (parent = element.parentNode; parent && parent !== body; parent = parent.parentNode) {
	    positionStyle = _utils2['default'].css(parent, 'position');
	    if (positionStyle !== 'static') {
	      return parent;
	    }
	  }
	  return null;
	}
	
	exports['default'] = getOffsetParent;
	module.exports = exports['default'];

/***/ }),
/* 2124 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _utils = __webpack_require__(2122);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	var _getOffsetParent = __webpack_require__(2123);
	
	var _getOffsetParent2 = _interopRequireDefault(_getOffsetParent);
	
	/**
	 * 获得元素的显示部分的区域
	 */
	function getVisibleRectForElement(element) {
	  var visibleRect = {
	    left: 0,
	    right: Infinity,
	    top: 0,
	    bottom: Infinity
	  };
	  var el = (0, _getOffsetParent2['default'])(element);
	  var scrollX = undefined;
	  var scrollY = undefined;
	  var winSize = undefined;
	  var doc = element.ownerDocument;
	  var win = doc.defaultView || doc.parentWindow;
	  var body = doc.body;
	  var documentElement = doc.documentElement;
	
	  // Determine the size of the visible rect by climbing the dom accounting for
	  // all scrollable containers.
	  while (el) {
	    // clientWidth is zero for inline block elements in ie.
	    if ((navigator.userAgent.indexOf('MSIE') === -1 || el.clientWidth !== 0) &&
	    // body may have overflow set on it, yet we still get the entire
	    // viewport. In some browsers, el.offsetParent may be
	    // document.documentElement, so check for that too.
	    el !== body && el !== documentElement && _utils2['default'].css(el, 'overflow') !== 'visible') {
	      var pos = _utils2['default'].offset(el);
	      // add border
	      pos.left += el.clientLeft;
	      pos.top += el.clientTop;
	      visibleRect.top = Math.max(visibleRect.top, pos.top);
	      visibleRect.right = Math.min(visibleRect.right,
	      // consider area without scrollBar
	      pos.left + el.clientWidth);
	      visibleRect.bottom = Math.min(visibleRect.bottom, pos.top + el.clientHeight);
	      visibleRect.left = Math.max(visibleRect.left, pos.left);
	    } else if (el === body || el === documentElement) {
	      break;
	    }
	    el = (0, _getOffsetParent2['default'])(el);
	  }
	
	  // Clip by window's viewport.
	  scrollX = _utils2['default'].getWindowScrollLeft(win);
	  scrollY = _utils2['default'].getWindowScrollTop(win);
	  visibleRect.left = Math.max(visibleRect.left, scrollX);
	  visibleRect.top = Math.max(visibleRect.top, scrollY);
	  winSize = {
	    width: _utils2['default'].viewportWidth(win),
	    height: _utils2['default'].viewportHeight(win)
	  };
	  visibleRect.right = Math.min(visibleRect.right, scrollX + winSize.width);
	  visibleRect.bottom = Math.min(visibleRect.bottom, scrollY + winSize.height);
	  return visibleRect.top >= 0 && visibleRect.left >= 0 && visibleRect.bottom > visibleRect.top && visibleRect.right > visibleRect.left ? visibleRect : null;
	}
	
	exports['default'] = getVisibleRectForElement;
	module.exports = exports['default'];

/***/ }),
/* 2125 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _utils = __webpack_require__(2122);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	function adjustForViewport(elFuturePos, elRegion, visibleRect, overflow) {
	  var pos = _utils2['default'].clone(elFuturePos);
	  var size = {
	    width: elRegion.width,
	    height: elRegion.height
	  };
	
	  if (overflow.adjustX && pos.left < visibleRect.left) {
	    pos.left = visibleRect.left;
	  }
	
	  // Left edge inside and right edge outside viewport, try to resize it.
	  if (overflow.resizeWidth && pos.left >= visibleRect.left && pos.left + size.width > visibleRect.right) {
	    size.width -= pos.left + size.width - visibleRect.right;
	  }
	
	  // Right edge outside viewport, try to move it.
	  if (overflow.adjustX && pos.left + size.width > visibleRect.right) {
	    // 保证左边界和可视区域左边界对齐
	    pos.left = Math.max(visibleRect.right - size.width, visibleRect.left);
	  }
	
	  // Top edge outside viewport, try to move it.
	  if (overflow.adjustY && pos.top < visibleRect.top) {
	    pos.top = visibleRect.top;
	  }
	
	  // Top edge inside and bottom edge outside viewport, try to resize it.
	  if (overflow.resizeHeight && pos.top >= visibleRect.top && pos.top + size.height > visibleRect.bottom) {
	    size.height -= pos.top + size.height - visibleRect.bottom;
	  }
	
	  // Bottom edge outside viewport, try to move it.
	  if (overflow.adjustY && pos.top + size.height > visibleRect.bottom) {
	    // 保证上边界和可视区域上边界对齐
	    pos.top = Math.max(visibleRect.bottom - size.height, visibleRect.top);
	  }
	
	  return _utils2['default'].mix(pos, size);
	}
	
	exports['default'] = adjustForViewport;
	module.exports = exports['default'];

/***/ }),
/* 2126 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _utils = __webpack_require__(2122);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	function getRegion(node) {
	  var offset = undefined;
	  var w = undefined;
	  var h = undefined;
	  if (!_utils2['default'].isWindow(node) && node.nodeType !== 9) {
	    offset = _utils2['default'].offset(node);
	    w = _utils2['default'].outerWidth(node);
	    h = _utils2['default'].outerHeight(node);
	  } else {
	    var win = _utils2['default'].getWindow(node);
	    offset = {
	      left: _utils2['default'].getWindowScrollLeft(win),
	      top: _utils2['default'].getWindowScrollTop(win)
	    };
	    w = _utils2['default'].viewportWidth(win);
	    h = _utils2['default'].viewportHeight(win);
	  }
	  offset.width = w;
	  offset.height = h;
	  return offset;
	}
	
	exports['default'] = getRegion;
	module.exports = exports['default'];

/***/ }),
/* 2127 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _getAlignOffset = __webpack_require__(2128);
	
	var _getAlignOffset2 = _interopRequireDefault(_getAlignOffset);
	
	function getElFuturePos(elRegion, refNodeRegion, points, offset, targetOffset) {
	  var xy = undefined;
	  var diff = undefined;
	  var p1 = undefined;
	  var p2 = undefined;
	
	  xy = {
	    left: elRegion.left,
	    top: elRegion.top
	  };
	
	  p1 = (0, _getAlignOffset2['default'])(refNodeRegion, points[1]);
	  p2 = (0, _getAlignOffset2['default'])(elRegion, points[0]);
	
	  diff = [p2.left - p1.left, p2.top - p1.top];
	
	  return {
	    left: xy.left - diff[0] + offset[0] - targetOffset[0],
	    top: xy.top - diff[1] + offset[1] - targetOffset[1]
	  };
	}
	
	exports['default'] = getElFuturePos;
	module.exports = exports['default'];

/***/ }),
/* 2128 */
/***/ (function(module, exports) {

	/**
	 * 获取 node 上的 align 对齐点 相对于页面的坐标
	 */
	
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	function getAlignOffset(region, align) {
	  var V = align.charAt(0);
	  var H = align.charAt(1);
	  var w = region.width;
	  var h = region.height;
	  var x = undefined;
	  var y = undefined;
	
	  x = region.left;
	  y = region.top;
	
	  if (V === 'c') {
	    y += h / 2;
	  } else if (V === 'b') {
	    y += h;
	  }
	
	  if (H === 'c') {
	    x += w / 2;
	  } else if (H === 'r') {
	    x += w;
	  }
	
	  return {
	    left: x,
	    top: y
	  };
	}
	
	exports['default'] = getAlignOffset;
	module.exports = exports['default'];

/***/ }),
/* 2129 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = addEventListenerWrap;
	
	var _addDomEventListener = __webpack_require__(2115);
	
	var _addDomEventListener2 = _interopRequireDefault(_addDomEventListener);
	
	var _reactDom = __webpack_require__(332);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function addEventListenerWrap(target, eventType, cb) {
	  /* eslint camelcase: 2 */
	  var callback = _reactDom2["default"].unstable_batchedUpdates ? function run(e) {
	    _reactDom2["default"].unstable_batchedUpdates(cb, e);
	  } : cb;
	  return (0, _addDomEventListener2["default"])(target, eventType, callback);
	}
	module.exports = exports['default'];

/***/ }),
/* 2130 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = isWindow;
	function isWindow(obj) {
	  /* eslint no-eq-null: 0 */
	  /* eslint eqeqeq: 0 */
	  return obj != null && obj == obj.window;
	}
	module.exports = exports['default'];

/***/ }),
/* 2131 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// export this package's api
	module.exports = __webpack_require__(2132);

/***/ }),
/* 2132 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ChildrenUtils = __webpack_require__(2133);
	
	var _AnimateChild = __webpack_require__(2134);
	
	var _AnimateChild2 = _interopRequireDefault(_AnimateChild);
	
	var _util = __webpack_require__(2139);
	
	var _util2 = _interopRequireDefault(_util);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var defaultKey = 'rc_animate_' + Date.now();
	
	
	function getChildrenFromProps(props) {
	  var children = props.children;
	  if (_react2["default"].isValidElement(children)) {
	    if (!children.key) {
	      return _react2["default"].cloneElement(children, {
	        key: defaultKey
	      });
	    }
	  }
	  return children;
	}
	
	function noop() {}
	
	var Animate = _react2["default"].createClass({
	  displayName: 'Animate',
	
	  propTypes: {
	    component: _react2["default"].PropTypes.any,
	    animation: _react2["default"].PropTypes.object,
	    transitionName: _react2["default"].PropTypes.oneOfType([_react2["default"].PropTypes.string, _react2["default"].PropTypes.object]),
	    transitionEnter: _react2["default"].PropTypes.bool,
	    transitionAppear: _react2["default"].PropTypes.bool,
	    exclusive: _react2["default"].PropTypes.bool,
	    transitionLeave: _react2["default"].PropTypes.bool,
	    onEnd: _react2["default"].PropTypes.func,
	    onEnter: _react2["default"].PropTypes.func,
	    onLeave: _react2["default"].PropTypes.func,
	    onAppear: _react2["default"].PropTypes.func,
	    showProp: _react2["default"].PropTypes.string
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      animation: {},
	      component: 'span',
	      transitionEnter: true,
	      transitionLeave: true,
	      transitionAppear: false,
	      onEnd: noop,
	      onEnter: noop,
	      onLeave: noop,
	      onAppear: noop
	    };
	  },
	  getInitialState: function getInitialState() {
	    this.currentlyAnimatingKeys = {};
	    this.keysToEnter = [];
	    this.keysToLeave = [];
	    return {
	      children: (0, _ChildrenUtils.toArrayChildren)(getChildrenFromProps(this.props))
	    };
	  },
	  componentDidMount: function componentDidMount() {
	    var _this = this;
	
	    var showProp = this.props.showProp;
	    var children = this.state.children;
	    if (showProp) {
	      children = children.filter(function (child) {
	        return !!child.props[showProp];
	      });
	    }
	    children.forEach(function (child) {
	      if (child) {
	        _this.performAppear(child.key);
	      }
	    });
	  },
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    var _this2 = this;
	
	    this.nextProps = nextProps;
	    var nextChildren = (0, _ChildrenUtils.toArrayChildren)(getChildrenFromProps(nextProps));
	    var props = this.props;
	    // exclusive needs immediate response
	    if (props.exclusive) {
	      Object.keys(this.currentlyAnimatingKeys).forEach(function (key) {
	        _this2.stop(key);
	      });
	    }
	    var showProp = props.showProp;
	    var currentlyAnimatingKeys = this.currentlyAnimatingKeys;
	    // last props children if exclusive
	    var currentChildren = props.exclusive ? (0, _ChildrenUtils.toArrayChildren)(getChildrenFromProps(props)) : this.state.children;
	    // in case destroy in showProp mode
	    var newChildren = [];
	    if (showProp) {
	      currentChildren.forEach(function (currentChild) {
	        var nextChild = currentChild && (0, _ChildrenUtils.findChildInChildrenByKey)(nextChildren, currentChild.key);
	        var newChild = void 0;
	        if ((!nextChild || !nextChild.props[showProp]) && currentChild.props[showProp]) {
	          newChild = _react2["default"].cloneElement(nextChild || currentChild, _defineProperty({}, showProp, true));
	        } else {
	          newChild = nextChild;
	        }
	        if (newChild) {
	          newChildren.push(newChild);
	        }
	      });
	      nextChildren.forEach(function (nextChild) {
	        if (!nextChild || !(0, _ChildrenUtils.findChildInChildrenByKey)(currentChildren, nextChild.key)) {
	          newChildren.push(nextChild);
	        }
	      });
	    } else {
	      newChildren = (0, _ChildrenUtils.mergeChildren)(currentChildren, nextChildren);
	    }
	
	    // need render to avoid update
	    this.setState({
	      children: newChildren
	    });
	
	    nextChildren.forEach(function (child) {
	      var key = child && child.key;
	      if (child && currentlyAnimatingKeys[key]) {
	        return;
	      }
	      var hasPrev = child && (0, _ChildrenUtils.findChildInChildrenByKey)(currentChildren, key);
	      if (showProp) {
	        var showInNext = child.props[showProp];
	        if (hasPrev) {
	          var showInNow = (0, _ChildrenUtils.findShownChildInChildrenByKey)(currentChildren, key, showProp);
	          if (!showInNow && showInNext) {
	            _this2.keysToEnter.push(key);
	          }
	        } else if (showInNext) {
	          _this2.keysToEnter.push(key);
	        }
	      } else if (!hasPrev) {
	        _this2.keysToEnter.push(key);
	      }
	    });
	
	    currentChildren.forEach(function (child) {
	      var key = child && child.key;
	      if (child && currentlyAnimatingKeys[key]) {
	        return;
	      }
	      var hasNext = child && (0, _ChildrenUtils.findChildInChildrenByKey)(nextChildren, key);
	      if (showProp) {
	        var showInNow = child.props[showProp];
	        if (hasNext) {
	          var showInNext = (0, _ChildrenUtils.findShownChildInChildrenByKey)(nextChildren, key, showProp);
	          if (!showInNext && showInNow) {
	            _this2.keysToLeave.push(key);
	          }
	        } else if (showInNow) {
	          _this2.keysToLeave.push(key);
	        }
	      } else if (!hasNext) {
	        _this2.keysToLeave.push(key);
	      }
	    });
	  },
	  componentDidUpdate: function componentDidUpdate() {
	    var keysToEnter = this.keysToEnter;
	    this.keysToEnter = [];
	    keysToEnter.forEach(this.performEnter);
	    var keysToLeave = this.keysToLeave;
	    this.keysToLeave = [];
	    keysToLeave.forEach(this.performLeave);
	  },
	  performEnter: function performEnter(key) {
	    // may already remove by exclusive
	    if (this.refs[key]) {
	      this.currentlyAnimatingKeys[key] = true;
	      this.refs[key].componentWillEnter(this.handleDoneAdding.bind(this, key, 'enter'));
	    }
	  },
	  performAppear: function performAppear(key) {
	    if (this.refs[key]) {
	      this.currentlyAnimatingKeys[key] = true;
	      this.refs[key].componentWillAppear(this.handleDoneAdding.bind(this, key, 'appear'));
	    }
	  },
	  handleDoneAdding: function handleDoneAdding(key, type) {
	    var props = this.props;
	    delete this.currentlyAnimatingKeys[key];
	    // if update on exclusive mode, skip check
	    if (props.exclusive && props !== this.nextProps) {
	      return;
	    }
	    var currentChildren = (0, _ChildrenUtils.toArrayChildren)(getChildrenFromProps(props));
	    if (!this.isValidChildByKey(currentChildren, key)) {
	      // exclusive will not need this
	      this.performLeave(key);
	    } else {
	      if (type === 'appear') {
	        if (_util2["default"].allowAppearCallback(props)) {
	          props.onAppear(key);
	          props.onEnd(key, true);
	        }
	      } else {
	        if (_util2["default"].allowEnterCallback(props)) {
	          props.onEnter(key);
	          props.onEnd(key, true);
	        }
	      }
	    }
	  },
	  performLeave: function performLeave(key) {
	    // may already remove by exclusive
	    if (this.refs[key]) {
	      this.currentlyAnimatingKeys[key] = true;
	      this.refs[key].componentWillLeave(this.handleDoneLeaving.bind(this, key));
	    }
	  },
	  handleDoneLeaving: function handleDoneLeaving(key) {
	    var props = this.props;
	    delete this.currentlyAnimatingKeys[key];
	    // if update on exclusive mode, skip check
	    if (props.exclusive && props !== this.nextProps) {
	      return;
	    }
	    var currentChildren = (0, _ChildrenUtils.toArrayChildren)(getChildrenFromProps(props));
	    // in case state change is too fast
	    if (this.isValidChildByKey(currentChildren, key)) {
	      this.performEnter(key);
	    } else {
	      var end = function end() {
	        if (_util2["default"].allowLeaveCallback(props)) {
	          props.onLeave(key);
	          props.onEnd(key, false);
	        }
	      };
	      /* eslint react/no-is-mounted:0 */
	      if (this.isMounted() && !(0, _ChildrenUtils.isSameChildren)(this.state.children, currentChildren, props.showProp)) {
	        this.setState({
	          children: currentChildren
	        }, end);
	      } else {
	        end();
	      }
	    }
	  },
	  isValidChildByKey: function isValidChildByKey(currentChildren, key) {
	    var showProp = this.props.showProp;
	    if (showProp) {
	      return (0, _ChildrenUtils.findShownChildInChildrenByKey)(currentChildren, key, showProp);
	    }
	    return (0, _ChildrenUtils.findChildInChildrenByKey)(currentChildren, key);
	  },
	  stop: function stop(key) {
	    delete this.currentlyAnimatingKeys[key];
	    var component = this.refs[key];
	    if (component) {
	      component.stop();
	    }
	  },
	  render: function render() {
	    var props = this.props;
	    this.nextProps = props;
	    var stateChildren = this.state.children;
	    var children = null;
	    if (stateChildren) {
	      children = stateChildren.map(function (child) {
	        if (child === null || child === undefined) {
	          return child;
	        }
	        if (!child.key) {
	          throw new Error('must set key for <rc-animate> children');
	        }
	        return _react2["default"].createElement(
	          _AnimateChild2["default"],
	          {
	            key: child.key,
	            ref: child.key,
	            animation: props.animation,
	            transitionName: props.transitionName,
	            transitionEnter: props.transitionEnter,
	            transitionAppear: props.transitionAppear,
	            transitionLeave: props.transitionLeave
	          },
	          child
	        );
	      });
	    }
	    var Component = props.component;
	    if (Component) {
	      var passedProps = props;
	      if (typeof Component === 'string') {
	        passedProps = {
	          className: props.className,
	          style: props.style
	        };
	      }
	      return _react2["default"].createElement(
	        Component,
	        passedProps,
	        children
	      );
	    }
	    return children[0] || null;
	  }
	});
	
	exports["default"] = Animate;
	module.exports = exports['default'];

/***/ }),
/* 2133 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.toArrayChildren = toArrayChildren;
	exports.findChildInChildrenByKey = findChildInChildrenByKey;
	exports.findShownChildInChildrenByKey = findShownChildInChildrenByKey;
	exports.findHiddenChildInChildrenByKey = findHiddenChildInChildrenByKey;
	exports.isSameChildren = isSameChildren;
	exports.mergeChildren = mergeChildren;
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function toArrayChildren(children) {
	  var ret = [];
	  _react2["default"].Children.forEach(children, function (child) {
	    ret.push(child);
	  });
	  return ret;
	}
	
	function findChildInChildrenByKey(children, key) {
	  var ret = null;
	  if (children) {
	    children.forEach(function (child) {
	      if (ret) {
	        return;
	      }
	      if (child && child.key === key) {
	        ret = child;
	      }
	    });
	  }
	  return ret;
	}
	
	function findShownChildInChildrenByKey(children, key, showProp) {
	  var ret = null;
	  if (children) {
	    children.forEach(function (child) {
	      if (child && child.key === key && child.props[showProp]) {
	        if (ret) {
	          throw new Error('two child with same key for <rc-animate> children');
	        }
	        ret = child;
	      }
	    });
	  }
	  return ret;
	}
	
	function findHiddenChildInChildrenByKey(children, key, showProp) {
	  var found = 0;
	  if (children) {
	    children.forEach(function (child) {
	      if (found) {
	        return;
	      }
	      found = child && child.key === key && !child.props[showProp];
	    });
	  }
	  return found;
	}
	
	function isSameChildren(c1, c2, showProp) {
	  var same = c1.length === c2.length;
	  if (same) {
	    c1.forEach(function (child, index) {
	      var child2 = c2[index];
	      if (child && child2) {
	        if (child && !child2 || !child && child2) {
	          same = false;
	        } else if (child.key !== child2.key) {
	          same = false;
	        } else if (showProp && child.props[showProp] !== child2.props[showProp]) {
	          same = false;
	        }
	      }
	    });
	  }
	  return same;
	}
	
	function mergeChildren(prev, next) {
	  var ret = [];
	
	  // For each key of `next`, the list of keys to insert before that key in
	  // the combined list
	  var nextChildrenPending = {};
	  var pendingChildren = [];
	  prev.forEach(function (child) {
	    if (child && findChildInChildrenByKey(next, child.key)) {
	      if (pendingChildren.length) {
	        nextChildrenPending[child.key] = pendingChildren;
	        pendingChildren = [];
	      }
	    } else {
	      pendingChildren.push(child);
	    }
	  });
	
	  next.forEach(function (child) {
	    if (child && nextChildrenPending.hasOwnProperty(child.key)) {
	      ret = ret.concat(nextChildrenPending[child.key]);
	    }
	    ret.push(child);
	  });
	
	  ret = ret.concat(pendingChildren);
	
	  return ret;
	}

/***/ }),
/* 2134 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(332);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _cssAnimation = __webpack_require__(2135);
	
	var _cssAnimation2 = _interopRequireDefault(_cssAnimation);
	
	var _util = __webpack_require__(2139);
	
	var _util2 = _interopRequireDefault(_util);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var transitionMap = {
	  enter: 'transitionEnter',
	  appear: 'transitionAppear',
	  leave: 'transitionLeave'
	};
	
	var AnimateChild = _react2["default"].createClass({
	  displayName: 'AnimateChild',
	
	  propTypes: {
	    children: _react2["default"].PropTypes.any
	  },
	
	  componentWillUnmount: function componentWillUnmount() {
	    this.stop();
	  },
	  componentWillEnter: function componentWillEnter(done) {
	    if (_util2["default"].isEnterSupported(this.props)) {
	      this.transition('enter', done);
	    } else {
	      done();
	    }
	  },
	  componentWillAppear: function componentWillAppear(done) {
	    if (_util2["default"].isAppearSupported(this.props)) {
	      this.transition('appear', done);
	    } else {
	      done();
	    }
	  },
	  componentWillLeave: function componentWillLeave(done) {
	    if (_util2["default"].isLeaveSupported(this.props)) {
	      this.transition('leave', done);
	    } else {
	      // always sync, do not interupt with react component life cycle
	      // update hidden -> animate hidden ->
	      // didUpdate -> animate leave -> unmount (if animate is none)
	      done();
	    }
	  },
	  transition: function transition(animationType, finishCallback) {
	    var _this = this;
	
	    var node = _reactDom2["default"].findDOMNode(this);
	    var props = this.props;
	    var transitionName = props.transitionName;
	    var nameIsObj = (typeof transitionName === 'undefined' ? 'undefined' : _typeof(transitionName)) === 'object';
	    this.stop();
	    var end = function end() {
	      _this.stopper = null;
	      finishCallback();
	    };
	    if ((_cssAnimation.isCssAnimationSupported || !props.animation[animationType]) && transitionName && props[transitionMap[animationType]]) {
	      var name = nameIsObj ? transitionName[animationType] : transitionName + '-' + animationType;
	      this.stopper = (0, _cssAnimation2["default"])(node, name, end);
	    } else {
	      this.stopper = props.animation[animationType](node, end);
	    }
	  },
	  stop: function stop() {
	    var stopper = this.stopper;
	    if (stopper) {
	      this.stopper = null;
	      stopper.stop();
	    }
	  },
	  render: function render() {
	    return this.props.children;
	  }
	});
	
	exports["default"] = AnimateChild;
	module.exports = exports['default'];

/***/ }),
/* 2135 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Event = __webpack_require__(2136);
	
	var _Event2 = _interopRequireDefault(_Event);
	
	var _componentClasses = __webpack_require__(2137);
	
	var _componentClasses2 = _interopRequireDefault(_componentClasses);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var isCssAnimationSupported = _Event2["default"].endEvents.length !== 0;
	
	
	var capitalPrefixes = ['Webkit', 'Moz', 'O',
	// ms is special .... !
	'ms'];
	var prefixes = ['-webkit-', '-moz-', '-o-', 'ms-', ''];
	
	function getStyleProperty(node, name) {
	  var style = window.getComputedStyle(node);
	
	  var ret = '';
	  for (var i = 0; i < prefixes.length; i++) {
	    ret = style.getPropertyValue(prefixes[i] + name);
	    if (ret) {
	      break;
	    }
	  }
	  return ret;
	}
	
	function fixBrowserByTimeout(node) {
	  if (isCssAnimationSupported) {
	    var transitionDelay = parseFloat(getStyleProperty(node, 'transition-delay')) || 0;
	    var transitionDuration = parseFloat(getStyleProperty(node, 'transition-duration')) || 0;
	    var animationDelay = parseFloat(getStyleProperty(node, 'animation-delay')) || 0;
	    var animationDuration = parseFloat(getStyleProperty(node, 'animation-duration')) || 0;
	    var time = Math.max(transitionDuration + transitionDelay, animationDuration + animationDelay);
	    // sometimes, browser bug
	    node.rcEndAnimTimeout = setTimeout(function () {
	      node.rcEndAnimTimeout = null;
	      if (node.rcEndListener) {
	        node.rcEndListener();
	      }
	    }, time * 1000 + 200);
	  }
	}
	
	function clearBrowserBugTimeout(node) {
	  if (node.rcEndAnimTimeout) {
	    clearTimeout(node.rcEndAnimTimeout);
	    node.rcEndAnimTimeout = null;
	  }
	}
	
	var cssAnimation = function cssAnimation(node, transitionName, endCallback) {
	  var className = transitionName;
	  var activeClassName = className + '-active';
	  var end = endCallback;
	  var start = void 0;
	  var active = void 0;
	  var nodeClasses = (0, _componentClasses2["default"])(node);
	
	  if (endCallback && Object.prototype.toString.call(endCallback) === '[object Object]') {
	    end = endCallback.end;
	    start = endCallback.start;
	    active = endCallback.active;
	  }
	
	  if (node.rcEndListener) {
	    node.rcEndListener();
	  }
	
	  node.rcEndListener = function (e) {
	    if (e && e.target !== node) {
	      return;
	    }
	
	    if (node.rcAnimTimeout) {
	      clearTimeout(node.rcAnimTimeout);
	      node.rcAnimTimeout = null;
	    }
	
	    clearBrowserBugTimeout(node);
	
	    nodeClasses.remove(className);
	    nodeClasses.remove(activeClassName);
	
	    _Event2["default"].removeEndEventListener(node, node.rcEndListener);
	    node.rcEndListener = null;
	
	    // Usually this optional end is used for informing an owner of
	    // a leave animation and telling it to remove the child.
	    if (end) {
	      end();
	    }
	  };
	
	  _Event2["default"].addEndEventListener(node, node.rcEndListener);
	
	  if (start) {
	    start();
	  }
	  nodeClasses.add(className);
	
	  node.rcAnimTimeout = setTimeout(function () {
	    node.rcAnimTimeout = null;
	    nodeClasses.add(activeClassName);
	    if (active) {
	      setTimeout(active, 0);
	    }
	    fixBrowserByTimeout(node);
	    // 30ms for firefox
	  }, 30);
	
	  return {
	    stop: function stop() {
	      if (node.rcEndListener) {
	        node.rcEndListener();
	      }
	    }
	  };
	};
	
	cssAnimation.style = function (node, style, callback) {
	  if (node.rcEndListener) {
	    node.rcEndListener();
	  }
	
	  node.rcEndListener = function (e) {
	    if (e && e.target !== node) {
	      return;
	    }
	
	    if (node.rcAnimTimeout) {
	      clearTimeout(node.rcAnimTimeout);
	      node.rcAnimTimeout = null;
	    }
	
	    clearBrowserBugTimeout(node);
	
	    _Event2["default"].removeEndEventListener(node, node.rcEndListener);
	    node.rcEndListener = null;
	
	    // Usually this optional callback is used for informing an owner of
	    // a leave animation and telling it to remove the child.
	    if (callback) {
	      callback();
	    }
	  };
	
	  _Event2["default"].addEndEventListener(node, node.rcEndListener);
	
	  node.rcAnimTimeout = setTimeout(function () {
	    for (var s in style) {
	      if (style.hasOwnProperty(s)) {
	        node.style[s] = style[s];
	      }
	    }
	    node.rcAnimTimeout = null;
	    fixBrowserByTimeout(node);
	  }, 0);
	};
	
	cssAnimation.setTransition = function (node, p, value) {
	  var property = p;
	  var v = value;
	  if (value === undefined) {
	    v = property;
	    property = '';
	  }
	  property = property || '';
	  capitalPrefixes.forEach(function (prefix) {
	    node.style[prefix + 'Transition' + property] = v;
	  });
	};
	
	cssAnimation.isCssAnimationSupported = isCssAnimationSupported;
	
	exports["default"] = cssAnimation;
	module.exports = exports['default'];

/***/ }),
/* 2136 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var EVENT_NAME_MAP = {
	  transitionend: {
	    transition: 'transitionend',
	    WebkitTransition: 'webkitTransitionEnd',
	    MozTransition: 'mozTransitionEnd',
	    OTransition: 'oTransitionEnd',
	    msTransition: 'MSTransitionEnd'
	  },
	
	  animationend: {
	    animation: 'animationend',
	    WebkitAnimation: 'webkitAnimationEnd',
	    MozAnimation: 'mozAnimationEnd',
	    OAnimation: 'oAnimationEnd',
	    msAnimation: 'MSAnimationEnd'
	  }
	};
	
	var endEvents = [];
	
	function detectEvents() {
	  var testEl = document.createElement('div');
	  var style = testEl.style;
	
	  if (!('AnimationEvent' in window)) {
	    delete EVENT_NAME_MAP.animationend.animation;
	  }
	
	  if (!('TransitionEvent' in window)) {
	    delete EVENT_NAME_MAP.transitionend.transition;
	  }
	
	  for (var baseEventName in EVENT_NAME_MAP) {
	    if (EVENT_NAME_MAP.hasOwnProperty(baseEventName)) {
	      var baseEvents = EVENT_NAME_MAP[baseEventName];
	      for (var styleName in baseEvents) {
	        if (styleName in style) {
	          endEvents.push(baseEvents[styleName]);
	          break;
	        }
	      }
	    }
	  }
	}
	
	if (typeof window !== 'undefined' && typeof document !== 'undefined') {
	  detectEvents();
	}
	
	function addEventListener(node, eventName, eventListener) {
	  node.addEventListener(eventName, eventListener, false);
	}
	
	function removeEventListener(node, eventName, eventListener) {
	  node.removeEventListener(eventName, eventListener, false);
	}
	
	var TransitionEvents = {
	  addEndEventListener: function addEndEventListener(node, eventListener) {
	    if (endEvents.length === 0) {
	      window.setTimeout(eventListener, 0);
	      return;
	    }
	    endEvents.forEach(function (endEvent) {
	      addEventListener(node, endEvent, eventListener);
	    });
	  },
	
	
	  endEvents: endEvents,
	
	  removeEndEventListener: function removeEndEventListener(node, eventListener) {
	    if (endEvents.length === 0) {
	      return;
	    }
	    endEvents.forEach(function (endEvent) {
	      removeEventListener(node, endEvent, eventListener);
	    });
	  }
	};
	
	exports["default"] = TransitionEvents;
	module.exports = exports['default'];

/***/ }),
/* 2137 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Module dependencies.
	 */
	
	try {
	  var index = __webpack_require__(2138);
	} catch (err) {
	  var index = __webpack_require__(2138);
	}
	
	/**
	 * Whitespace regexp.
	 */
	
	var re = /\s+/;
	
	/**
	 * toString reference.
	 */
	
	var toString = Object.prototype.toString;
	
	/**
	 * Wrap `el` in a `ClassList`.
	 *
	 * @param {Element} el
	 * @return {ClassList}
	 * @api public
	 */
	
	module.exports = function(el){
	  return new ClassList(el);
	};
	
	/**
	 * Initialize a new ClassList for `el`.
	 *
	 * @param {Element} el
	 * @api private
	 */
	
	function ClassList(el) {
	  if (!el || !el.nodeType) {
	    throw new Error('A DOM element reference is required');
	  }
	  this.el = el;
	  this.list = el.classList;
	}
	
	/**
	 * Add class `name` if not already present.
	 *
	 * @param {String} name
	 * @return {ClassList}
	 * @api public
	 */
	
	ClassList.prototype.add = function(name){
	  // classList
	  if (this.list) {
	    this.list.add(name);
	    return this;
	  }
	
	  // fallback
	  var arr = this.array();
	  var i = index(arr, name);
	  if (!~i) arr.push(name);
	  this.el.className = arr.join(' ');
	  return this;
	};
	
	/**
	 * Remove class `name` when present, or
	 * pass a regular expression to remove
	 * any which match.
	 *
	 * @param {String|RegExp} name
	 * @return {ClassList}
	 * @api public
	 */
	
	ClassList.prototype.remove = function(name){
	  if ('[object RegExp]' == toString.call(name)) {
	    return this.removeMatching(name);
	  }
	
	  // classList
	  if (this.list) {
	    this.list.remove(name);
	    return this;
	  }
	
	  // fallback
	  var arr = this.array();
	  var i = index(arr, name);
	  if (~i) arr.splice(i, 1);
	  this.el.className = arr.join(' ');
	  return this;
	};
	
	/**
	 * Remove all classes matching `re`.
	 *
	 * @param {RegExp} re
	 * @return {ClassList}
	 * @api private
	 */
	
	ClassList.prototype.removeMatching = function(re){
	  var arr = this.array();
	  for (var i = 0; i < arr.length; i++) {
	    if (re.test(arr[i])) {
	      this.remove(arr[i]);
	    }
	  }
	  return this;
	};
	
	/**
	 * Toggle class `name`, can force state via `force`.
	 *
	 * For browsers that support classList, but do not support `force` yet,
	 * the mistake will be detected and corrected.
	 *
	 * @param {String} name
	 * @param {Boolean} force
	 * @return {ClassList}
	 * @api public
	 */
	
	ClassList.prototype.toggle = function(name, force){
	  // classList
	  if (this.list) {
	    if ("undefined" !== typeof force) {
	      if (force !== this.list.toggle(name, force)) {
	        this.list.toggle(name); // toggle again to correct
	      }
	    } else {
	      this.list.toggle(name);
	    }
	    return this;
	  }
	
	  // fallback
	  if ("undefined" !== typeof force) {
	    if (!force) {
	      this.remove(name);
	    } else {
	      this.add(name);
	    }
	  } else {
	    if (this.has(name)) {
	      this.remove(name);
	    } else {
	      this.add(name);
	    }
	  }
	
	  return this;
	};
	
	/**
	 * Return an array of classes.
	 *
	 * @return {Array}
	 * @api public
	 */
	
	ClassList.prototype.array = function(){
	  var className = this.el.getAttribute('class') || '';
	  var str = className.replace(/^\s+|\s+$/g, '');
	  var arr = str.split(re);
	  if ('' === arr[0]) arr.shift();
	  return arr;
	};
	
	/**
	 * Check if class `name` is present.
	 *
	 * @param {String} name
	 * @return {ClassList}
	 * @api public
	 */
	
	ClassList.prototype.has =
	ClassList.prototype.contains = function(name){
	  return this.list
	    ? this.list.contains(name)
	    : !! ~index(this.array(), name);
	};


/***/ }),
/* 2138 */
/***/ (function(module, exports) {

	module.exports = function(arr, obj){
	  if (arr.indexOf) return arr.indexOf(obj);
	  for (var i = 0; i < arr.length; ++i) {
	    if (arr[i] === obj) return i;
	  }
	  return -1;
	};

/***/ }),
/* 2139 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var util = {
	  isAppearSupported: function isAppearSupported(props) {
	    return props.transitionName && props.transitionAppear || props.animation.appear;
	  },
	  isEnterSupported: function isEnterSupported(props) {
	    return props.transitionName && props.transitionEnter || props.animation.enter;
	  },
	  isLeaveSupported: function isLeaveSupported(props) {
	    return props.transitionName && props.transitionLeave || props.animation.leave;
	  },
	  allowAppearCallback: function allowAppearCallback(props) {
	    return props.transitionAppear || props.animation.appear;
	  },
	  allowEnterCallback: function allowEnterCallback(props) {
	    return props.transitionEnter || props.animation.enter;
	  },
	  allowLeaveCallback: function allowLeaveCallback(props) {
	    return props.transitionLeave || props.animation.leave;
	  }
	};
	exports["default"] = util;
	module.exports = exports['default'];

/***/ }),
/* 2140 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _LazyRenderBox = __webpack_require__(2141);
	
	var _LazyRenderBox2 = _interopRequireDefault(_LazyRenderBox);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var PopupInner = _react2["default"].createClass({
	  displayName: 'PopupInner',
	
	  propTypes: {
	    hiddenClassName: _react.PropTypes.string,
	    className: _react.PropTypes.string,
	    prefixCls: _react.PropTypes.string,
	    onMouseEnter: _react.PropTypes.func,
	    onMouseLeave: _react.PropTypes.func,
	    children: _react.PropTypes.any
	  },
	  render: function render() {
	    var props = this.props;
	    var className = props.className;
	    if (!props.visible) {
	      className += ' ' + props.hiddenClassName;
	    }
	    return _react2["default"].createElement(
	      'div',
	      {
	        className: className,
	        onMouseEnter: props.onMouseEnter,
	        onMouseLeave: props.onMouseLeave,
	        style: props.style
	      },
	      _react2["default"].createElement(
	        _LazyRenderBox2["default"],
	        { className: props.prefixCls + '-content', visible: props.visible },
	        props.children
	      )
	    );
	  }
	});
	
	exports["default"] = PopupInner;
	module.exports = exports['default'];

/***/ }),
/* 2141 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var LazyRenderBox = _react2["default"].createClass({
	  displayName: 'LazyRenderBox',
	
	  propTypes: {
	    children: _react.PropTypes.any,
	    className: _react.PropTypes.string,
	    visible: _react.PropTypes.bool,
	    hiddenClassName: _react.PropTypes.string
	  },
	  shouldComponentUpdate: function shouldComponentUpdate(nextProps) {
	    return nextProps.hiddenClassName || nextProps.visible;
	  },
	  render: function render() {
	    var _props = this.props;
	    var hiddenClassName = _props.hiddenClassName;
	    var visible = _props.visible;
	
	    var props = _objectWithoutProperties(_props, ['hiddenClassName', 'visible']);
	
	    if (hiddenClassName || _react2["default"].Children.count(props.children) > 1) {
	      if (!visible && hiddenClassName) {
	        props.className += ' ' + hiddenClassName;
	      }
	      return _react2["default"].createElement('div', props);
	    }
	
	    return _react2["default"].Children.only(props.children);
	  }
	});
	
	exports["default"] = LazyRenderBox;
	module.exports = exports['default'];

/***/ }),
/* 2142 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.getAlignFromPlacement = getAlignFromPlacement;
	exports.getPopupClassNameFromAlign = getPopupClassNameFromAlign;
	function isPointsEq(a1, a2) {
	  return a1[0] === a2[0] && a1[1] === a2[1];
	}
	
	function getAlignFromPlacement(builtinPlacements, placementStr, align) {
	  var baseAlign = builtinPlacements[placementStr] || {};
	  return _extends({}, baseAlign, align);
	}
	
	function getPopupClassNameFromAlign(builtinPlacements, prefixCls, align) {
	  var points = align.points;
	  for (var placement in builtinPlacements) {
	    if (builtinPlacements.hasOwnProperty(placement)) {
	      if (isPointsEq(builtinPlacements[placement].points, points)) {
	        return prefixCls + '-placement-' + placement;
	      }
	    }
	  }
	  return '';
	}

/***/ }),
/* 2143 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports["default"] = getContainerRenderMixin;
	
	var _reactDom = __webpack_require__(332);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function defaultGetContainer() {
	  var container = document.createElement('div');
	  document.body.appendChild(container);
	  return container;
	}
	
	function getContainerRenderMixin(config) {
	  var _config$autoMount = config.autoMount;
	  var autoMount = _config$autoMount === undefined ? true : _config$autoMount;
	  var _config$autoDestroy = config.autoDestroy;
	  var autoDestroy = _config$autoDestroy === undefined ? true : _config$autoDestroy;
	  var isVisible = config.isVisible;
	  var getComponent = config.getComponent;
	  var _config$getContainer = config.getContainer;
	  var getContainer = _config$getContainer === undefined ? defaultGetContainer : _config$getContainer;
	
	
	  var mixin = void 0;
	
	  function _renderComponent(instance, componentArg, ready) {
	    if (!isVisible || instance._component || isVisible(instance)) {
	      if (!instance._container) {
	        instance._container = getContainer(instance);
	      }
	      _reactDom2["default"].unstable_renderSubtreeIntoContainer(instance, getComponent(instance, componentArg), instance._container, function callback() {
	        instance._component = this;
	        if (ready) {
	          ready.call(this);
	        }
	      });
	    }
	  }
	
	  if (autoMount) {
	    mixin = _extends({}, mixin, {
	      componentDidMount: function componentDidMount() {
	        _renderComponent(this);
	      },
	      componentDidUpdate: function componentDidUpdate() {
	        _renderComponent(this);
	      }
	    });
	  }
	
	  if (!autoMount || !autoDestroy) {
	    mixin = _extends({}, mixin, {
	      renderComponent: function renderComponent(componentArg, ready) {
	        _renderComponent(this, componentArg, ready);
	      }
	    });
	  }
	
	  function _removeContainer(instance) {
	    if (instance._container) {
	      var container = instance._container;
	      _reactDom2["default"].unmountComponentAtNode(container);
	      container.parentNode.removeChild(container);
	      instance._container = null;
	    }
	  }
	
	  if (autoDestroy) {
	    mixin = _extends({}, mixin, {
	      componentWillUnmount: function componentWillUnmount() {
	        _removeContainer(this);
	      }
	    });
	  } else {
	    mixin = _extends({}, mixin, {
	      removeContainer: function removeContainer() {
	        _removeContainer(this);
	      }
	    });
	  }
	
	  return mixin;
	}
	module.exports = exports['default'];

/***/ }),
/* 2144 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x2, _x3, _x4) { var _again = true; _function: while (_again) { var object = _x2, property = _x3, receiver = _x4; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x2 = parent; _x3 = property; _x4 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _colr = __webpack_require__(2145);
	
	var _colr2 = _interopRequireDefault(_colr);
	
	var _Board = __webpack_require__(2147);
	
	var _Board2 = _interopRequireDefault(_Board);
	
	var _Preview = __webpack_require__(2160);
	
	var _Preview2 = _interopRequireDefault(_Preview);
	
	var _Ribbon = __webpack_require__(2161);
	
	var _Ribbon2 = _interopRequireDefault(_Ribbon);
	
	var _Alpha = __webpack_require__(2162);
	
	var _Alpha2 = _interopRequireDefault(_Alpha);
	
	var _Params = __webpack_require__(2163);
	
	var _Params2 = _interopRequireDefault(_Params);
	
	var _utilsValidationColor = __webpack_require__(2164);
	
	var _utilsValidationColor2 = _interopRequireDefault(_utilsValidationColor);
	
	function noop() {}
	
	var colr = new _colr2['default']();
	
	var Panel = (function (_React$Component) {
	  _inherits(Panel, _React$Component);
	
	  function Panel(props) {
	    var _this = this;
	
	    _classCallCheck(this, Panel);
	
	    _get(Object.getPrototypeOf(Panel.prototype), 'constructor', this).call(this, props);
	
	    var color = props.color || props.defaultColor;
	    var hsv = colr.fromHex(color).toHsvObject();
	
	    this.state = {
	      paramsHsv: hsv,
	      hsv: hsv,
	      alpha: props.alpha || props.defaultAlpha
	    };
	
	    var events = ['onChange', 'onAlphaChange', 'onFocus', 'onBlur', 'onSystemColorPickerOpen'];
	    // bind methods
	    events.forEach(function (m) {
	      _this[m] = _this[m].bind(_this);
	    });
	  }
	
	  _createClass(Panel, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.color) {
	        var hsv = colr.fromHex(nextProps.color).toHsvObject();
	        this.setState({
	          hsv: hsv
	        });
	      }
	      if (nextProps.alpha !== undefined) {
	        this.setState({
	          alpha: nextProps.alpha
	        });
	      }
	    }
	  }, {
	    key: 'onChange',
	    value: function onChange(hsvObject) {
	      var syncParams = arguments.length <= 1 || arguments[1] === undefined ? true : arguments[1];
	
	      var hsv = hsvObject;
	      var state = {
	        hsv: hsv
	      };
	      if (syncParams) {
	        state.paramsHsv = hsv;
	      }
	      this.setState(state);
	
	      var ret = {
	        color: this.getHexColor(hsv),
	        hsv: hsv,
	        alpha: this.state.alpha
	      };
	      this.props.onChange(ret);
	    }
	  }, {
	    key: 'onSystemColorPickerOpen',
	    value: function onSystemColorPickerOpen(e) {
	      // only work with broswer which support color input
	      if (e.target.type === 'color') {
	        this.systemColorPickerOpen = true;
	      }
	    }
	  }, {
	    key: 'onAlphaChange',
	    value: function onAlphaChange(alpha) {
	      if (this.props.alpha === undefined) {
	        this.setState({
	          alpha: alpha
	        });
	      }
	      this.props.onChange({
	        color: this.getHexColor(),
	        hsv: this.state.hsv,
	        alpha: alpha
	      });
	    }
	  }, {
	    key: 'onFocus',
	    value: function onFocus() {
	      if (this._blurTimer) {
	        clearTimeout(this._blurTimer);
	        this._blurTimer = null;
	      } else {
	        this.props.onFocus();
	      }
	    }
	  }, {
	    key: 'onBlur',
	    value: function onBlur() {
	      var _this2 = this;
	
	      if (this._blurTimer) {
	        clearTimeout(this._blurTimer);
	      }
	      this._blurTimer = setTimeout(function () {
	        // if is system color picker open, then stop run blur
	        if (_this2.systemColorPickerOpen) {
	          _this2.systemColorPickerOpen = false;
	          return;
	        }
	
	        _this2.props.onBlur();
	      }, 100);
	    }
	  }, {
	    key: 'getHexColor',
	    value: function getHexColor(hsv) {
	      return colr.fromHsvObject(hsv || this.state.hsv).toHex();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var prefixCls = this.props.prefixCls;
	      var hsv = this.state.hsv;
	      var alpha = this.state.alpha;
	      return _react2['default'].createElement(
	        'div',
	        {
	          className: prefixCls,
	          style: this.props.style,
	          onFocus: this.onFocus,
	          onBlur: this.onBlur,
	          tabIndex: '0'
	        },
	        _react2['default'].createElement(
	          'div',
	          { className: prefixCls + '-' + 'inner' },
	          _react2['default'].createElement(_Board2['default'], {
	            rootPrefixCls: prefixCls,
	            hsv: hsv,
	            onChange: this.onChange
	          }),
	          _react2['default'].createElement(
	            'div',
	            { className: prefixCls + '-' + 'wrap' },
	            _react2['default'].createElement(
	              'div',
	              { className: prefixCls + '-' + 'wrap-ribbon' },
	              _react2['default'].createElement(_Ribbon2['default'], {
	                rootPrefixCls: prefixCls,
	                hsv: hsv,
	                onChange: this.onChange
	              })
	            ),
	            _react2['default'].createElement(
	              'div',
	              { className: prefixCls + '-' + 'wrap-alpha' },
	              _react2['default'].createElement(_Alpha2['default'], {
	                rootPrefixCls: prefixCls,
	                alpha: alpha,
	                hsv: hsv,
	                onChange: this.onAlphaChange
	              })
	            ),
	            _react2['default'].createElement(
	              'div',
	              { className: prefixCls + '-' + 'wrap-preview' },
	              _react2['default'].createElement(_Preview2['default'], {
	                rootPrefixCls: prefixCls,
	                alpha: alpha,
	                onChange: this.onChange,
	                onInputClick: this.onSystemColorPickerOpen,
	                hsv: hsv
	              })
	            )
	          ),
	          _react2['default'].createElement(
	            'div',
	            { className: prefixCls + '-' + 'wrap', style: { height: 40, marginTop: 6 } },
	            _react2['default'].createElement(_Params2['default'], {
	              rootPrefixCls: prefixCls,
	              hsv: this.state.paramsHsv,
	              alpha: alpha,
	              onAlphaChange: this.onAlphaChange,
	              onChange: this.onChange,
	              mode: this.props.mode
	            })
	          )
	        )
	      );
	    }
	  }]);
	
	  return Panel;
	})(_react2['default'].Component);
	
	exports['default'] = Panel;
	
	Panel.propTypes = {
	  defaultAlpha: _react.PropTypes.number,
	  defaultColor: _utilsValidationColor2['default'],
	  // can custom
	  prefixCls: _react.PropTypes.string,
	  color: _utilsValidationColor2['default'],
	  alpha: _react.PropTypes.number,
	  style: _react.PropTypes.object,
	  onChange: _react.PropTypes.func,
	  onFocus: _react.PropTypes.func,
	  onBlur: _react.PropTypes.func,
	  mode: _react.PropTypes.oneOf(['RGB', 'HSL', 'HSB'])
	};
	
	Panel.defaultProps = {
	  prefixCls: 'rc-color-picker-panel',
	  defaultColor: '#ff0000',
	  defaultAlpha: 100,
	  style: {},
	  onChange: noop,
	  onFocus: noop,
	  onBlur: noop,
	  mode: 'RGB'
	};
	module.exports = exports['default'];

/***/ }),
/* 2145 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	
	/*
	 * DEPENDENCIES
	 */
	
	var convert = __webpack_require__(2146);
	
	
	/*
	 * CONSTRUCTOR
	 */
	
	function Colr () {
	  if ((this instanceof Colr) === false) { return new Colr(); }
	  this._ = {};
	}
	
	
	/*
	 * STATIC METHODS
	 */
	
	Colr.fromHex = function (hex) {
	  return (new Colr()).fromHex(hex);
	};
	
	Colr.fromGrayscale = function (value) {
	  return (new Colr()).fromGrayscale(value);
	};
	
	Colr.fromRgb = function (r, g, b) {
	  return (new Colr()).fromRgb(r, g, b);
	};
	
	Colr.fromRgbArray = function (arr) {
	  return (new Colr()).fromRgb(arr[0], arr[1], arr[2]);
	};
	
	Colr.fromRgbObject = function (obj) {
	  return (new Colr()).fromRgb(obj.r, obj.g, obj.b);
	};
	Colr.fromHsl = function (h, s, l) {
	  return (new Colr()).fromHsl(h, s, l);
	};
	
	Colr.fromHslArray = function (arr) {
	  return (new Colr()).fromHsl(arr[0], arr[1], arr[2]);
	};
	
	Colr.fromHslObject = function (obj) {
	  return (new Colr()).fromHsl(obj.h, obj.s, obj.l);
	};
	
	Colr.fromHsv = function (h, s, v) {
	  return (new Colr()).fromHsv(h, s, v);
	};
	
	Colr.fromHsvArray = function (arr) {
	  return (new Colr()).fromHsv(arr[0], arr[1], arr[2]);
	};
	
	Colr.fromHsvObject = function (obj) {
	  return (new Colr()).fromHsv(obj.h, obj.s, obj.v);
	};
	
	
	/*
	 * IMPORTERS
	 */
	
	// HEX
	
	Colr.prototype.fromHex = function (input) {
	  var value = convert.hex.rgb(input);
	  this._ = { rgb: value };
	  return this;
	};
	
	// GRAYSCALE
	
	Colr.prototype.fromGrayscale = function (input) {
	  input = clampByte(input);
	  var value = convert.grayscale.rgb(input);
	  this._ = { rgb: value };
	  return this;
	};
	
	// RGB
	
	Colr.prototype.fromRgb = function (r, g, b) {
	  if (typeof(r) !== 'number' || typeof(g) !== 'number' || typeof(b) !== 'number') {
	    throw new Error('Arguments must be numbers');
	  }
	  var value = clampRgb(r, g, b);
	  this._ = { rgb: value };
	  return this;
	};
	
	Colr.prototype.fromRgbArray = function (arr) {
	  return this.fromRgb(arr[0], arr[1], arr[2]);
	};
	
	Colr.prototype.fromRgbObject = function (obj) {
	  return this.fromRgb(obj.r, obj.g, obj.b);
	};
	
	// HSL
	
	Colr.prototype.fromHsl = function (h, s, l) {
	  if (typeof(h) !== 'number' || typeof(s) !== 'number' || typeof(l) !== 'number') {
	    throw new Error('Arguments must be numbers');
	  }
	  this._ = { hsl: clampHsx(h, s, l) };
	  return this;
	};
	
	Colr.prototype.fromHslArray = function (arr) {
	  return this.fromHsl(arr[0], arr[1], arr[2]);
	};
	
	Colr.prototype.fromHslObject = function (obj) {
	  return this.fromHsl(obj.h, obj.s, obj.l);
	};
	
	// HSV
	
	Colr.prototype.fromHsv = function (h, s, v) {
	  if (typeof(h) !== 'number' || typeof(s) !== 'number' || typeof(v) !== 'number') {
	    throw new Error('Arguments must be numbers');
	  }
	  this._ = { hsv: clampHsx(h, s, v) };
	  return this;
	};
	
	Colr.prototype.fromHsvArray = function (arr) {
	  return this.fromHsv(arr[0], arr[1], arr[2]);
	};
	
	Colr.prototype.fromHsvObject = function (obj) {
	  return this.fromHsv(obj.h, obj.s, obj.v);
	};
	
	
	/*
	 * EXPORTERS
	 */
	
	// HEX
	
	Colr.prototype.toHex = function () {
	  var cached = this._.hex;
	  if (cached !== undefined) { return cached; }
	
	  var input;
	  var cachedFrom = this._.rgb;
	
	  if (cachedFrom !== undefined) { input = cachedFrom; }
	  else { input = this.toRawRgbArray(); }
	
	  input[0] = Math.round(input[0]);
	  input[1] = Math.round(input[1]);
	  input[2] = Math.round(input[2]);
	
	  var value = convert.rgb.hex(input);
	  this._.hex = value;
	
	  return value;
	};
	
	// GRAYSCALE
	
	Colr.prototype.toGrayscale = function () {
	  var cached = this._.grayscale;
	  if (cached !== undefined) { return cached; }
	
	  var input;
	  var cachedFrom = this._.rgb;
	
	  if (cachedFrom !== undefined) { input = cachedFrom; }
	  else { input = this.toRawRgbArray(); }
	
	  var value = convert.rgb.grayscale(input);
	  this._.grayscale = value;
	  return value;
	};
	
	// RGB
	
	Colr.prototype.toRawRgbArray = function () {
	  var cached = this._.rgb;
	  if (cached !== undefined) { return cached; }
	
	  var value;
	
	  if ((value = this._.hsv) !== undefined) {
	    value = convert.hsv.rgb(value);
	  } else if ((value = this._.hsl) !== undefined) {
	    value = convert.hsl.rgb(value);
	  } else {
	    throw new Error('No data to convert');
	  }
	
	  this._.rgb = value;
	  return value;
	};
	
	Colr.prototype.toRawRgbObject = function () {
	  var arr = this.toRawRgbArray();
	  return { r: arr[0], g: arr[1], b: arr[2] };
	};
	
	Colr.prototype.toRgbArray = function () {
	  var arr = this.toRawRgbArray();
	  return [ Math.round(arr[0]), Math.round(arr[1]), Math.round(arr[2]) ];
	};
	
	Colr.prototype.toRgbObject = function () {
	  var arr = this.toRgbArray();
	  return { r: arr[0], g: arr[1], b: arr[2] };
	};
	
	// HSL
	
	Colr.prototype.toRawHslArray = function () {
	  var cached = this._.hsl;
	  if (cached !== undefined) { return cached; }
	
	  var value;
	
	  if ((value = this._.hsv) !== undefined) {
	    value = convert.hsv.hsl(value);
	  } else if ((value = this._.rgb) !== undefined) {
	    value = convert.rgb.hsl(value);
	  } else {
	    throw new Error('No data to convert');
	  }
	
	  this._.hsl = value;
	  return value;
	};
	
	Colr.prototype.toRawHslObject = function () {
	  var arr = this.toRawHslArray();
	  return { h: arr[0], s: arr[1], l: arr[2] };
	};
	
	Colr.prototype.toHslArray = function () {
	  var arr = this.toRawHslArray();
	  return [ Math.round(arr[0]), Math.round(arr[1]), Math.round(arr[2]) ];
	};
	
	Colr.prototype.toHslObject = function () {
	  var arr = this.toHslArray();
	  return { h: arr[0], s: arr[1], l: arr[2] };
	};
	
	// HSV
	
	Colr.prototype.toRawHsvArray = function () {
	  var cached = this._.hsv;
	  if (cached !== undefined) { return cached; }
	
	  var value;
	
	  if ((value = this._.hsl) !== undefined) {
	    value = convert.hsl.hsv(value);
	  } else if ((value = this._.rgb) !== undefined) {
	    value = convert.rgb.hsv(value);
	  } else {
	    throw new Error('No data to convert');
	  }
	
	  this._.hsv = value;
	  return value;
	};
	
	Colr.prototype.toRawHsvObject = function () {
	  var arr = this.toRawHsvArray();
	  return { h: arr[0], s: arr[1], v: arr[2] };
	};
	
	Colr.prototype.toHsvArray = function () {
	  var arr = this.toRawHsvArray();
	  return [ Math.round(arr[0]), Math.round(arr[1]), Math.round(arr[2]) ];
	};
	
	Colr.prototype.toHsvObject = function () {
	  var arr = this.toHsvArray();
	  return { h: arr[0], s: arr[1], v: arr[2] };
	};
	
	
	/*
	 * MODIFIERS
	 */
	
	Colr.prototype.lighten = function (amount) {
	  var hsl = this.toRawHslArray();
	  hsl[2] = clampPercentage(hsl[2] + amount);
	  this._ = { hsl: hsl };
	  return this;
	};
	
	Colr.prototype.darken = function (amount) {
	  var hsl = this.toRawHslArray();
	  hsl[2] = clampPercentage(hsl[2] - amount);
	  this._ = { hsl: hsl };
	  return this;
	};
	
	/*
	 * MISC
	 */
	
	Colr.prototype.clone = function () {
	  var colr = new Colr();
	  colr._.hex = this._.hex;
	  colr._.grayscale = this._.grayscale;
	
	  if (this._.rgb !== undefined) {
	    colr._.rgb = this._.rgb.slice(0);
	  }
	  if (this._.hsv !== undefined) {
	    colr._.hsv = this._.hsv.slice(0);
	  }
	  if (this._.hsl !== undefined) {
	    colr._.hsl = this._.hsl.slice(0);
	  }
	
	  return colr;
	};
	
	/*
	 * UTILS
	 */
	
	function clampPercentage (val) {
	  return Math.max(Math.min(val, 100), 0);
	}
	
	function clampByte (byte) {
	  return Math.max(Math.min(byte, 255), 0);
	}
	
	function clampRgb (r, g, b) {
	  return [
	    Math.max(Math.min(r, 255), 0),
	    Math.max(Math.min(g, 255), 0),
	    Math.max(Math.min(b, 255), 0),
	  ];
	}
	
	function clampHsx (h, s, x) {
	  return [
	    Math.max(Math.min(h, 360), 0),
	    Math.max(Math.min(s, 100), 0),
	    Math.max(Math.min(x, 100), 0),
	  ];
	}
	
	
	module.exports = Colr;


/***/ }),
/* 2146 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = {
	  grayscale: {
	    rgb: grayscale2rgb
	  },
	  hex: {
	    rgb: hex2rgb,
	  },
	  rgb: {
	    hsl: rgb2hsl,
	    hsv: rgb2hsv,
	    hex: rgb2hex,
	    grayscale: rgb2grayscale
	  },
	  hsl: {
	    rgb: hsl2rgb,
	    hsv: hsl2hsv,
	  },
	  hsv: {
	    rgb: hsv2rgb,
	    hsl: hsv2hsl,
	  },
	};
	
	// convert a charcode to a hex val
	function hexVal (c) {
	  return (
	    c < 58 ? c - 48 : // 0 - 9
	    c < 71 ? c - 55 : // A - F
	    c - 87            // a - f
	  );
	}
	
	function hex2rgb (hex) {
	  var i = hex[0] === '#' ? 1 : 0;
	  var len = hex.length;
	
	  if (len - i < 3) {
	    throw new Error('hex input must be at least three chars long');
	  }
	
	  var r, g, b;
	
	  var h1 = hexVal(hex.charCodeAt(0+i));
	  var h2 = hexVal(hex.charCodeAt(1+i));
	  var h3 = hexVal(hex.charCodeAt(2+i));
	
	  if (len - i >= 6) {
	    r = (h1 << 4) + h2;
	    g = (h3 << 4) + hexVal(hex.charCodeAt(3+i));
	    b = (hexVal(hex.charCodeAt(4+i)) << 4) + hexVal(hex.charCodeAt(5+i));
	  } else {
	    r = (h1 << 4) + h1;
	    g = (h2 << 4) + h2;
	    b = (h3 << 4) + h3;
	  }
	
	  if (r < 0 || r > 255 || g < 0 || g > 255 || b < 0 || b > 255) {
	    throw new Error('hex input is invalid');
	  }
	
	  return [r, g, b];
	}
	
	
	function rgb2hex (rgb) {
	  return '#' + (
	    '000000' +
	    ((rgb[0] << 16) +
	     (rgb[1] << 8) +
	      rgb[2]
	    ).toString(16)
	  ).slice(-6);
	}
	
	function rgb2hsl (rgb) {
	  var r = rgb[0] / 255;
	  var g = rgb[1] / 255;
	  var b = rgb[2] / 255;
	
	  var min = Math.min(r, g, b);
	  var max = Math.max(r, g, b);
	  var delta = max - min;
	  var h, s, l;
	
	  if (max === min) {
	    h = 0;
	  } else if (r === max) {
	    h = (g - b) / delta;
	  } else if (g === max) {
	    h = 2 + (b - r) / delta;
	  } else if (b === max) {
	    h = 4 + (r - g) / delta;
	  }
	
	  h = Math.min(h * 60, 360);
	
	  if (h < 0) {
	    h += 360;
	  }
	
	  l = (min + max) / 2;
	
	  if (max === min) {
	    s = 0;
	  } else if (l <= 0.5) {
	    s = delta / (max + min);
	  } else {
	    s = delta / (2 - max - min);
	  }
	
	  return [h, s * 100, l * 100];
	}
	
	function rgb2hsv(rgb) {
	  var r = rgb[0];
	  var g = rgb[1];
	  var b = rgb[2];
	  var min = Math.min(r, g, b);
	  var max = Math.max(r, g, b);
	  var delta = max - min;
	  var h, s, v;
	
	  if (max === 0) {
	    s = 0;
	  } else {
	    s = delta / max * 100;
	  }
	
	  if (max === min) {
	    h = 0;
	  } else if (r === max) {
	    h = (g - b) / delta;
	  } else if (g === max) {
	    h = 2 + (b - r) / delta;
	  } else if (b === max) {
	    h = 4 + (r - g) / delta;
	  }
	
	  h = Math.min(h * 60, 360);
	
	  if (h < 0) {
	    h += 360;
	  }
	
	  v = (max / 255) * 100;
	
	  return [h, s, v];
	}
	
	function hsl2rgb (hsl) {
	  var h = hsl[0] / 360;
	  var s = hsl[1] / 100;
	  var l = hsl[2] / 100;
	
	  var r, g, b;
	
	  if (s === 0) { // monochrome
	    r = g = b = l;
	
	  } else {
	    var q = l < 0.5 ? l * (s + 1) : l + s - l * s;
	    var p = 2 * l - q;
	    var t;
	
	    // red
	    t = h + 1/3;
	    if      (t < 0) { t += 1; }
	    else if (t > 1) { t -= 1; }
	    if      (t < 1/6)  { r = p + (q - p) * t * 6; }
	    else if (t < 1/2 ) { r = q; }
	    else if (t < 2/3 ) { r = p + (q - p) * (2/3 - t) * 6; }
	    else               { r = p; }
	
	    // green
	    t = h;
	    if      (t < 0) { t += 1; }
	    else if (t > 1) { t -= 1; }
	    if      (t < 1/6)  { g = p + (q - p) * t * 6; }
	    else if (t < 1/2 ) { g = q; }
	    else if (t < 2/3 ) { g = p + (q - p) * (2/3 - t) * 6; }
	    else               { g = p; }
	
	    // blue
	    t = h - 1/3;
	    if      (t < 0) { t += 1; }
	    else if (t > 1) { t -= 1; }
	    if      (t < 1/6)  { b = p + (q - p) * t * 6; }
	    else if (t < 1/2 ) { b = q; }
	    else if (t < 2/3 ) { b = p + (q - p) * (2/3 - t) * 6; }
	    else               { b = p; }
	  }
	
	  return [r * 255, g * 255, b * 255];
	}
	
	function hsl2hsv(hsl) {
	  var h = hsl[0];
	  var s = hsl[1] / 100;
	  var l = hsl[2] / 100;
	  var sv, v;
	
	  if (s === 0) {
	    return [h, 0, l * 100];
	  }
	
	  if (l === 0) {
	    return [h, 0, 0];
	  }
	
	  l *= 2;
	  s *= (l <= 1) ? l : 2 - l;
	  v = (l + s) / 2;
	  sv = (2 * s) / (l + s);
	  return [h, sv * 100, v * 100];
	}
	
	function hsv2rgb(hsv) {
	  var h = hsv[0] / 60;
	  var s = hsv[1] / 100;
	  var v = hsv[2] / 100;
	
	  var hi = Math.floor(h) % 6;
	
	  var f = h - Math.floor(h);
	  var p = 255 * v * (1 - s);
	  var q = 255 * v * (1 - (s * f));
	  var t = 255 * v * (1 - (s * (1 - f)));
	      v = 255 * v;
	
	  switch(hi) {
	    case 0:
	      return [v, t, p];
	    case 1:
	      return [q, v, p];
	    case 2:
	      return [p, v, t];
	    case 3:
	      return [p, q, v];
	    case 4:
	      return [t, p, v];
	    case 5:
	      return [v, p, q];
	  }
	}
	
	function hsv2hsl(hsv) {
	  var h = hsv[0];
	  var s = hsv[1] / 100;
	  var v = hsv[2] / 100;
	  var sl, l;
	
	  if (s === 0) {
	    return [h, 0, v * 100];
	  }
	
	  if (v === 0) {
	    return [h, 0, 0];
	  }
	
	  l = (2 - s) * v;
	  sl = s * v;
	  sl /= (l <= 1) ? l : 2 - l;
	  l /= 2;
	  return [h, sl * 100, l * 100];
	}
	
	function grayscale2rgb (value) {
	  return [value, value, value];
	}
	
	function rgb2grayscale (rgb) {
	  return (rgb[0] * 299 + rgb[1] * 587 + rgb[2] * 114) / 1000;
	}


/***/ }),
/* 2147 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _colr = __webpack_require__(2145);
	
	var _colr2 = _interopRequireDefault(_colr);
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(332);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _rcUtil = __webpack_require__(2148);
	
	var _rcUtil2 = _interopRequireDefault(_rcUtil);
	
	var colr = new _colr2['default']();
	
	var WIDTH = 200;
	var HEIGHT = 150;
	
	var Board = (function (_React$Component) {
	  _inherits(Board, _React$Component);
	
	  function Board(props) {
	    var _this = this;
	
	    _classCallCheck(this, Board);
	
	    _get(Object.getPrototypeOf(Board.prototype), 'constructor', this).call(this, props);
	    var events = ['onBoardMouseDown', 'onBoardDrag', 'onBoardDragEnd', 'onBoardTouchStart', 'onBoardTouchMove', 'onBoardTouchEnd'];
	    events.forEach(function (m) {
	      _this[m] = _this[m].bind(_this);
	    });
	  }
	
	  _createClass(Board, [{
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.removeListeners();
	      this.removeTouchListeners();
	    }
	  }, {
	    key: 'onBoardMouseDown',
	    value: function onBoardMouseDown(e) {
	      var x = e.clientX;
	      var y = e.clientY;
	      this.pointMoveTo({
	        x: x,
	        y: y
	      });
	      this.dragListener = _rcUtil2['default'].Dom.addEventListener(window, 'mousemove', this.onBoardDrag);
	      this.dragUpListener = _rcUtil2['default'].Dom.addEventListener(window, 'mouseup', this.onBoardDragEnd);
	    }
	  }, {
	    key: 'onBoardTouchStart',
	    value: function onBoardTouchStart(e) {
	      if (e.touches.length !== 1) {
	        return;
	      }
	
	      var x = e.targetTouches[0].clientX;
	      var y = e.targetTouches[0].clientY;
	      this.pointMoveTo({
	        x: x,
	        y: y
	      });
	      this.touchMoveListener = _rcUtil2['default'].Dom.addEventListener(window, 'touchmove', this.onBoardTouchMove);
	      this.touchEndListener = _rcUtil2['default'].Dom.addEventListener(window, 'touchend', this.onBoardTouchEnd);
	    }
	  }, {
	    key: 'onBoardTouchMove',
	    value: function onBoardTouchMove(e) {
	      if (e.preventDefault) {
	        e.preventDefault();
	      }
	
	      var x = e.targetTouches[0].clientX;
	      var y = e.targetTouches[0].clientY;
	      this.pointMoveTo({
	        x: x,
	        y: y
	      });
	    }
	  }, {
	    key: 'onBoardTouchEnd',
	    value: function onBoardTouchEnd() {
	      this.removeTouchListeners();
	    }
	  }, {
	    key: 'onBoardDrag',
	    value: function onBoardDrag(e) {
	      var x = e.clientX;
	      var y = e.clientY;
	      this.pointMoveTo({
	        x: x,
	        y: y
	      });
	    }
	  }, {
	    key: 'onBoardDragEnd',
	    value: function onBoardDragEnd(e) {
	      var x = e.clientX;
	      var y = e.clientY;
	      this.pointMoveTo({
	        x: x,
	        y: y
	      });
	      this.removeListeners();
	    }
	  }, {
	    key: 'getPrefixCls',
	    value: function getPrefixCls() {
	      return this.props.rootPrefixCls + '-board';
	    }
	  }, {
	    key: 'removeTouchListeners',
	    value: function removeTouchListeners() {
	      if (this.touchMoveListener) {
	        this.touchMoveListener.remove();
	        this.touchMoveListener = null;
	      }
	      if (this.touchEndListener) {
	        this.touchEndListener.remove();
	        this.touchEndListener = null;
	      }
	    }
	  }, {
	    key: 'removeListeners',
	    value: function removeListeners() {
	      if (this.dragListener) {
	        this.dragListener.remove();
	        this.dragListener = null;
	      }
	      if (this.dragUpListener) {
	        this.dragUpListener.remove();
	        this.dragUpListener = null;
	      }
	    }
	
	    /**
	     * 移动光标位置到
	     * @param  {object} pos X Y 全局坐标点
	     * @return {undefined}
	     */
	  }, {
	    key: 'pointMoveTo',
	    value: function pointMoveTo(pos) {
	      var rect = _reactDom2['default'].findDOMNode(this).getBoundingClientRect();
	      var left = pos.x - rect.left;
	      var top = pos.y - rect.top;
	
	      left = Math.max(0, left);
	      left = Math.min(left, WIDTH);
	      top = Math.max(0, top);
	      top = Math.min(top, HEIGHT);
	
	      var hsv = {
	        h: this.props.hsv.h,
	        s: parseInt(left / WIDTH * 100, 10),
	        v: parseInt((1 - top / HEIGHT) * 100, 10)
	      };
	      this.props.onChange(hsv);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var prefixCls = this.getPrefixCls();
	      var hsv = this.props.hsv;
	      var hueHsv = [hsv.h, 100, 100];
	      var hueColor = colr.fromHsvArray(hueHsv).toHex();
	      var x = hsv.s / 100 * WIDTH - 4;
	      var y = (1 - hsv.v / 100) * HEIGHT - 4;
	      return _react2['default'].createElement(
	        'div',
	        { className: prefixCls },
	        _react2['default'].createElement(
	          'div',
	          { className: prefixCls + '-' + 'hsv', style: { backgroundColor: hueColor } },
	          _react2['default'].createElement('div', { className: prefixCls + '-' + 'value' }),
	          _react2['default'].createElement('div', { className: prefixCls + '-' + 'saturation' })
	        ),
	        _react2['default'].createElement('span', { style: { left: x, top: y } }),
	        _react2['default'].createElement('div', {
	          className: prefixCls + '-' + 'handler',
	          onMouseDown: this.onBoardMouseDown,
	          onTouchStart: this.onBoardTouchStart
	        })
	      );
	    }
	  }]);
	
	  return Board;
	})(_react2['default'].Component);
	
	exports['default'] = Board;
	
	Board.propTypes = {
	  hsv: _react2['default'].PropTypes.object,
	  onChange: _react2['default'].PropTypes.func,
	  rootPrefixCls: _react2['default'].PropTypes.string
	};
	module.exports = exports['default'];

/***/ }),
/* 2148 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = {
	  guid: __webpack_require__(2149),
	  classSet: __webpack_require__(2150),
	  joinClasses: __webpack_require__(2151),
	  KeyCode: __webpack_require__(2152),
	  PureRenderMixin: __webpack_require__(2153),
	  shallowEqual: __webpack_require__(2154),
	  createChainedFunction: __webpack_require__(2155),
	  Dom: {
	    addEventListener: __webpack_require__(2156),
	    contains: __webpack_require__(2157)
	  },
	  Children: {
	    toArray: __webpack_require__(2158),
	    mapSelf: __webpack_require__(2159)
	  }
	};


/***/ }),
/* 2149 */
/***/ (function(module, exports) {

	var seed = 0;
	module.exports = function () {
	  return Date.now() + '_' + (seed++);
	};


/***/ }),
/* 2150 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(958);


/***/ }),
/* 2151 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-2014, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This file contains an unmodified version of:
	 * https://github.com/facebook/react/blob/v0.12.0/src/utils/joinClasses.js
	 *
	 * This source code is licensed under the BSD-style license found here:
	 * https://github.com/facebook/react/blob/v0.12.0/LICENSE
	 * An additional grant of patent rights can be found here:
	 * https://github.com/facebook/react/blob/v0.12.0/PATENTS
	 */
	
	"use strict";
	
	/**
	 * Combines multiple className strings into one.
	 * http://jsperf.com/joinclasses-args-vs-array
	 *
	 * @param {...?string} classes
	 * @return {string}
	 */
	
	function joinClasses(className /*, ... */ ) {
	  if (!className) {
	    className = '';
	  }
	  var nextClass;
	  var argLength = arguments.length;
	  if (argLength > 1) {
	    for (var ii = 1; ii < argLength; ii++) {
	      nextClass = arguments[ii];
	      if (nextClass) {
	        className = (className ? className + ' ' : '') + nextClass;
	      }
	    }
	  }
	  return className;
	}
	
	module.exports = joinClasses;


/***/ }),
/* 2152 */
/***/ (function(module, exports) {

	/**
	 * @ignore
	 * some key-codes definition and utils from closure-library
	 * @author yiminghe@gmail.com
	 */
	
	var KeyCode = {
	  /**
	   * MAC_ENTER
	   */
	  MAC_ENTER: 3,
	  /**
	   * BACKSPACE
	   */
	  BACKSPACE: 8,
	  /**
	   * TAB
	   */
	  TAB: 9,
	  /**
	   * NUMLOCK on FF/Safari Mac
	   */
	  NUM_CENTER: 12, // NUMLOCK on FF/Safari Mac
	  /**
	   * ENTER
	   */
	  ENTER: 13,
	  /**
	   * SHIFT
	   */
	  SHIFT: 16,
	  /**
	   * CTRL
	   */
	  CTRL: 17,
	  /**
	   * ALT
	   */
	  ALT: 18,
	  /**
	   * PAUSE
	   */
	  PAUSE: 19,
	  /**
	   * CAPS_LOCK
	   */
	  CAPS_LOCK: 20,
	  /**
	   * ESC
	   */
	  ESC: 27,
	  /**
	   * SPACE
	   */
	  SPACE: 32,
	  /**
	   * PAGE_UP
	   */
	  PAGE_UP: 33, // also NUM_NORTH_EAST
	  /**
	   * PAGE_DOWN
	   */
	  PAGE_DOWN: 34, // also NUM_SOUTH_EAST
	  /**
	   * END
	   */
	  END: 35, // also NUM_SOUTH_WEST
	  /**
	   * HOME
	   */
	  HOME: 36, // also NUM_NORTH_WEST
	  /**
	   * LEFT
	   */
	  LEFT: 37, // also NUM_WEST
	  /**
	   * UP
	   */
	  UP: 38, // also NUM_NORTH
	  /**
	   * RIGHT
	   */
	  RIGHT: 39, // also NUM_EAST
	  /**
	   * DOWN
	   */
	  DOWN: 40, // also NUM_SOUTH
	  /**
	   * PRINT_SCREEN
	   */
	  PRINT_SCREEN: 44,
	  /**
	   * INSERT
	   */
	  INSERT: 45, // also NUM_INSERT
	  /**
	   * DELETE
	   */
	  DELETE: 46, // also NUM_DELETE
	  /**
	   * ZERO
	   */
	  ZERO: 48,
	  /**
	   * ONE
	   */
	  ONE: 49,
	  /**
	   * TWO
	   */
	  TWO: 50,
	  /**
	   * THREE
	   */
	  THREE: 51,
	  /**
	   * FOUR
	   */
	  FOUR: 52,
	  /**
	   * FIVE
	   */
	  FIVE: 53,
	  /**
	   * SIX
	   */
	  SIX: 54,
	  /**
	   * SEVEN
	   */
	  SEVEN: 55,
	  /**
	   * EIGHT
	   */
	  EIGHT: 56,
	  /**
	   * NINE
	   */
	  NINE: 57,
	  /**
	   * QUESTION_MARK
	   */
	  QUESTION_MARK: 63, // needs localization
	  /**
	   * A
	   */
	  A: 65,
	  /**
	   * B
	   */
	  B: 66,
	  /**
	   * C
	   */
	  C: 67,
	  /**
	   * D
	   */
	  D: 68,
	  /**
	   * E
	   */
	  E: 69,
	  /**
	   * F
	   */
	  F: 70,
	  /**
	   * G
	   */
	  G: 71,
	  /**
	   * H
	   */
	  H: 72,
	  /**
	   * I
	   */
	  I: 73,
	  /**
	   * J
	   */
	  J: 74,
	  /**
	   * K
	   */
	  K: 75,
	  /**
	   * L
	   */
	  L: 76,
	  /**
	   * M
	   */
	  M: 77,
	  /**
	   * N
	   */
	  N: 78,
	  /**
	   * O
	   */
	  O: 79,
	  /**
	   * P
	   */
	  P: 80,
	  /**
	   * Q
	   */
	  Q: 81,
	  /**
	   * R
	   */
	  R: 82,
	  /**
	   * S
	   */
	  S: 83,
	  /**
	   * T
	   */
	  T: 84,
	  /**
	   * U
	   */
	  U: 85,
	  /**
	   * V
	   */
	  V: 86,
	  /**
	   * W
	   */
	  W: 87,
	  /**
	   * X
	   */
	  X: 88,
	  /**
	   * Y
	   */
	  Y: 89,
	  /**
	   * Z
	   */
	  Z: 90,
	  /**
	   * META
	   */
	  META: 91, // WIN_KEY_LEFT
	  /**
	   * WIN_KEY_RIGHT
	   */
	  WIN_KEY_RIGHT: 92,
	  /**
	   * CONTEXT_MENU
	   */
	  CONTEXT_MENU: 93,
	  /**
	   * NUM_ZERO
	   */
	  NUM_ZERO: 96,
	  /**
	   * NUM_ONE
	   */
	  NUM_ONE: 97,
	  /**
	   * NUM_TWO
	   */
	  NUM_TWO: 98,
	  /**
	   * NUM_THREE
	   */
	  NUM_THREE: 99,
	  /**
	   * NUM_FOUR
	   */
	  NUM_FOUR: 100,
	  /**
	   * NUM_FIVE
	   */
	  NUM_FIVE: 101,
	  /**
	   * NUM_SIX
	   */
	  NUM_SIX: 102,
	  /**
	   * NUM_SEVEN
	   */
	  NUM_SEVEN: 103,
	  /**
	   * NUM_EIGHT
	   */
	  NUM_EIGHT: 104,
	  /**
	   * NUM_NINE
	   */
	  NUM_NINE: 105,
	  /**
	   * NUM_MULTIPLY
	   */
	  NUM_MULTIPLY: 106,
	  /**
	   * NUM_PLUS
	   */
	  NUM_PLUS: 107,
	  /**
	   * NUM_MINUS
	   */
	  NUM_MINUS: 109,
	  /**
	   * NUM_PERIOD
	   */
	  NUM_PERIOD: 110,
	  /**
	   * NUM_DIVISION
	   */
	  NUM_DIVISION: 111,
	  /**
	   * F1
	   */
	  F1: 112,
	  /**
	   * F2
	   */
	  F2: 113,
	  /**
	   * F3
	   */
	  F3: 114,
	  /**
	   * F4
	   */
	  F4: 115,
	  /**
	   * F5
	   */
	  F5: 116,
	  /**
	   * F6
	   */
	  F6: 117,
	  /**
	   * F7
	   */
	  F7: 118,
	  /**
	   * F8
	   */
	  F8: 119,
	  /**
	   * F9
	   */
	  F9: 120,
	  /**
	   * F10
	   */
	  F10: 121,
	  /**
	   * F11
	   */
	  F11: 122,
	  /**
	   * F12
	   */
	  F12: 123,
	  /**
	   * NUMLOCK
	   */
	  NUMLOCK: 144,
	  /**
	   * SEMICOLON
	   */
	  SEMICOLON: 186, // needs localization
	  /**
	   * DASH
	   */
	  DASH: 189, // needs localization
	  /**
	   * EQUALS
	   */
	  EQUALS: 187, // needs localization
	  /**
	   * COMMA
	   */
	  COMMA: 188, // needs localization
	  /**
	   * PERIOD
	   */
	  PERIOD: 190, // needs localization
	  /**
	   * SLASH
	   */
	  SLASH: 191, // needs localization
	  /**
	   * APOSTROPHE
	   */
	  APOSTROPHE: 192, // needs localization
	  /**
	   * SINGLE_QUOTE
	   */
	  SINGLE_QUOTE: 222, // needs localization
	  /**
	   * OPEN_SQUARE_BRACKET
	   */
	  OPEN_SQUARE_BRACKET: 219, // needs localization
	  /**
	   * BACKSLASH
	   */
	  BACKSLASH: 220, // needs localization
	  /**
	   * CLOSE_SQUARE_BRACKET
	   */
	  CLOSE_SQUARE_BRACKET: 221, // needs localization
	  /**
	   * WIN_KEY
	   */
	  WIN_KEY: 224,
	  /**
	   * MAC_FF_META
	   */
	  MAC_FF_META: 224, // Firefox (Gecko) fires this for the meta key instead of 91
	  /**
	   * WIN_IME
	   */
	  WIN_IME: 229
	};
	
	/*
	 whether text and modified key is entered at the same time.
	 */
	KeyCode.isTextModifyingKeyEvent = function (e) {
	  var keyCode = e.keyCode;
	  if (e.altKey && !e.ctrlKey || e.metaKey ||
	      // Function keys don't generate text
	    keyCode >= KeyCode.F1 && keyCode <= KeyCode.F12) {
	    return false;
	  }
	
	  // The following keys are quite harmless, even in combination with
	  // CTRL, ALT or SHIFT.
	  switch (keyCode) {
	    case KeyCode.ALT:
	    case KeyCode.CAPS_LOCK:
	    case KeyCode.CONTEXT_MENU:
	    case KeyCode.CTRL:
	    case KeyCode.DOWN:
	    case KeyCode.END:
	    case KeyCode.ESC:
	    case KeyCode.HOME:
	    case KeyCode.INSERT:
	    case KeyCode.LEFT:
	    case KeyCode.MAC_FF_META:
	    case KeyCode.META:
	    case KeyCode.NUMLOCK:
	    case KeyCode.NUM_CENTER:
	    case KeyCode.PAGE_DOWN:
	    case KeyCode.PAGE_UP:
	    case KeyCode.PAUSE:
	    case KeyCode.PRINT_SCREEN:
	    case KeyCode.RIGHT:
	    case KeyCode.SHIFT:
	    case KeyCode.UP:
	    case KeyCode.WIN_KEY:
	    case KeyCode.WIN_KEY_RIGHT:
	      return false;
	    default:
	      return true;
	  }
	};
	
	/*
	 whether character is entered.
	 */
	KeyCode.isCharacterKey = function (keyCode) {
	  if (keyCode >= KeyCode.ZERO &&
	    keyCode <= KeyCode.NINE) {
	    return true;
	  }
	
	  if (keyCode >= KeyCode.NUM_ZERO &&
	    keyCode <= KeyCode.NUM_MULTIPLY) {
	    return true;
	  }
	
	  if (keyCode >= KeyCode.A &&
	    keyCode <= KeyCode.Z) {
	    return true;
	  }
	
	  // Safari sends zero key code for non-latin characters.
	  if (window.navigation.userAgent.indexOf('WebKit') !== -1 && keyCode === 0) {
	    return true;
	  }
	
	  switch (keyCode) {
	    case KeyCode.SPACE:
	    case KeyCode.QUESTION_MARK:
	    case KeyCode.NUM_PLUS:
	    case KeyCode.NUM_MINUS:
	    case KeyCode.NUM_PERIOD:
	    case KeyCode.NUM_DIVISION:
	    case KeyCode.SEMICOLON:
	    case KeyCode.DASH:
	    case KeyCode.EQUALS:
	    case KeyCode.COMMA:
	    case KeyCode.PERIOD:
	    case KeyCode.SLASH:
	    case KeyCode.APOSTROPHE:
	    case KeyCode.SINGLE_QUOTE:
	    case KeyCode.OPEN_SQUARE_BRACKET:
	    case KeyCode.BACKSLASH:
	    case KeyCode.CLOSE_SQUARE_BRACKET:
	      return true;
	    default:
	      return false;
	  }
	};
	
	module.exports = KeyCode;


/***/ }),
/* 2153 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2014, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	* @providesModule ReactComponentWithPureRenderMixin
	*/
	
	"use strict";
	
	var shallowEqual = __webpack_require__(2154);
	
	/**
	 * If your React component's render function is "pure", e.g. it will render the
	 * same result given the same props and state, provide this Mixin for a
	 * considerable performance boost.
	 *
	 * Most React components have pure render functions.
	 *
	 * Example:
	 *
	 *   var ReactComponentWithPureRenderMixin =
	 *     require('ReactComponentWithPureRenderMixin');
	 *   React.createClass({
	 *     mixins: [ReactComponentWithPureRenderMixin],
	 *
	 *     render: function() {
	 *       return <div className={this.props.className}>foo</div>;
	 *     }
	 *   });
	 *
	 * Note: This only checks shallow equality for props and state. If these contain
	 * complex data structures this mixin may have false-negatives for deeper
	 * differences. Only mixin to components which have simple props and state, or
	 * use `forceUpdate()` when you know deep data structures have changed.
	 */
	var ReactComponentWithPureRenderMixin = {
	  shouldComponentUpdate: function(nextProps, nextState) {
	    return !shallowEqual(this.props, nextProps) ||
	           !shallowEqual(this.state, nextState);
	  }
	};
	
	module.exports = ReactComponentWithPureRenderMixin;


/***/ }),
/* 2154 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-2014, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule shallowEqual
	 */
	
	"use strict";
	
	/**
	 * Performs equality by iterating through keys on an object and returning
	 * false when any key has values which are not strictly equal between
	 * objA and objB. Returns true when the values of all keys are strictly equal.
	 *
	 * @return {boolean}
	 */
	function shallowEqual(objA, objB) {
	  if (objA === objB) {
	    return true;
	  }
	  var key;
	  // Test for A's keys different from B.
	  for (key in objA) {
	    if (objA.hasOwnProperty(key) &&
	        (!objB.hasOwnProperty(key) || objA[key] !== objB[key])) {
	      return false;
	    }
	  }
	  // Test for B's keys missing from A.
	  for (key in objB) {
	    if (objB.hasOwnProperty(key) && !objA.hasOwnProperty(key)) {
	      return false;
	    }
	  }
	  return true;
	}
	
	module.exports = shallowEqual;


/***/ }),
/* 2155 */
/***/ (function(module, exports) {

	/**
	 * Safe chained function
	 *
	 * Will only create a new function if needed,
	 * otherwise will pass back existing functions or null.
	 *
	 * @returns {function|null}
	 */
	function createChainedFunction() {
	  var args = arguments;
	
	  return function chainedFunction() {
	    for (var i = 0; i < args.length; i++) {
	      if (args[i] && args[i].apply) {
	        args[i].apply(this, arguments);
	      }
	    }
	  };
	}
	
	module.exports = createChainedFunction;


/***/ }),
/* 2156 */
/***/ (function(module, exports, __webpack_require__) {

	var addDOMEventListener = __webpack_require__(2115);
	
	module.exports = addDOMEventListener['default'] || addDOMEventListener;


/***/ }),
/* 2157 */
/***/ (function(module, exports) {

	module.exports = function (root, node) {
	  while (node) {
	    if (node === root) {
	      return true;
	    }
	    node = node.parentNode;
	  }
	
	  return false;
	};


/***/ }),
/* 2158 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(300);
	
	module.exports = function (children) {
	  var ret = [];
	  React.Children.forEach(children, function (c) {
	    ret.push(c);
	  });
	  return ret;
	};


/***/ }),
/* 2159 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(300);
	
	function mirror(o) {
	  return o;
	}
	
	module.exports = function (children) {
	  // return ReactFragment
	  return React.Children.map(children, mirror);
	};


/***/ }),
/* 2160 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _colr = __webpack_require__(2145);
	
	var _colr2 = _interopRequireDefault(_colr);
	
	var colr = new _colr2['default']();
	
	var Preview = (function (_React$Component) {
	  _inherits(Preview, _React$Component);
	
	  function Preview() {
	    _classCallCheck(this, Preview);
	
	    _get(Object.getPrototypeOf(Preview.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(Preview, [{
	    key: 'onChange',
	    value: function onChange(e) {
	      var value = e.target.value;
	      var color = colr.fromHex(value);
	      this.props.onChange(color.toHsvObject());
	      e.stopPropagation();
	    }
	  }, {
	    key: 'getPrefixCls',
	    value: function getPrefixCls() {
	      return this.props.rootPrefixCls + '-preview';
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var prefixCls = this.getPrefixCls();
	      var hex = colr.fromHsvObject(this.props.hsv).toHex();
	      return _react2['default'].createElement(
	        'div',
	        { className: prefixCls },
	        _react2['default'].createElement('span', { style: { backgroundColor: hex, opacity: this.props.alpha / 100 } }),
	        _react2['default'].createElement('input', {
	          type: 'color',
	          value: hex,
	          onChange: this.onChange.bind(this),
	          onClick: this.props.onInputClick
	        })
	      );
	    }
	  }]);
	
	  return Preview;
	})(_react2['default'].Component);
	
	exports['default'] = Preview;
	
	Preview.propTypes = {
	  rootPrefixCls: _react2['default'].PropTypes.string,
	  hsv: _react2['default'].PropTypes.object,
	  alpha: _react2['default'].PropTypes.number,
	  onChange: _react2['default'].PropTypes.func,
	  onInputClick: _react2['default'].PropTypes.func
	};
	module.exports = exports['default'];

/***/ }),
/* 2161 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(332);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _rcUtil = __webpack_require__(2148);
	
	var _rcUtil2 = _interopRequireDefault(_rcUtil);
	
	var Ribbon = (function (_React$Component) {
	  _inherits(Ribbon, _React$Component);
	
	  function Ribbon(props) {
	    var _this = this;
	
	    _classCallCheck(this, Ribbon);
	
	    _get(Object.getPrototypeOf(Ribbon.prototype), 'constructor', this).call(this, props);
	
	    var events = ['onMouseDown', 'onDrag', 'onDragEnd', 'pointMoveTo', '_setHuePosition'];
	    events.forEach(function (e) {
	      if (_this[e]) {
	        _this[e] = _this[e].bind(_this);
	      }
	    });
	  }
	
	  _createClass(Ribbon, [{
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.removeListeners();
	    }
	  }, {
	    key: 'onMouseDown',
	    value: function onMouseDown(e) {
	      var x = e.clientX;
	      var y = e.clientY;
	
	      this.pointMoveTo({
	        x: x, y: y
	      });
	
	      this.dragListener = _rcUtil2['default'].Dom.addEventListener(window, 'mousemove', this.onDrag);
	      this.dragUpListener = _rcUtil2['default'].Dom.addEventListener(window, 'mouseup', this.onDragEnd);
	    }
	  }, {
	    key: 'onDrag',
	    value: function onDrag(e) {
	      var x = e.clientX;
	      var y = e.clientY;
	      this.pointMoveTo({
	        x: x, y: y
	      });
	    }
	  }, {
	    key: 'onDragEnd',
	    value: function onDragEnd(e) {
	      var x = e.clientX;
	      var y = e.clientY;
	      this.pointMoveTo({
	        x: x, y: y
	      });
	      this.removeListeners();
	    }
	  }, {
	    key: 'getPrefixCls',
	    value: function getPrefixCls() {
	      return this.props.rootPrefixCls + '-ribbon';
	    }
	  }, {
	    key: 'pointMoveTo',
	    value: function pointMoveTo(coords) {
	      var rect = _reactDom2['default'].findDOMNode(this).getBoundingClientRect();
	      var width = rect.width;
	      var left = coords.x - rect.left;
	      left = Math.max(0, left);
	      left = Math.min(left, width);
	      var huePercent = left / width;
	      var hue = huePercent * 360;
	      // 新的对象, 避免引用
	      var hsv = _extends({}, this.props.hsv, {
	        h: hue
	      });
	      this.props.onChange(hsv);
	    }
	  }, {
	    key: 'removeListeners',
	    value: function removeListeners() {
	      if (this.dragListener) {
	        this.dragListener.remove();
	        this.dragListener = null;
	      }
	      if (this.dragUpListener) {
	        this.dragUpListener.remove();
	        this.dragUpListener = null;
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var prefixCls = this.getPrefixCls();
	      var HSV = this.props.hsv;
	      var hue = HSV.h;
	      var per = hue / 360 * 100;
	      return _react2['default'].createElement(
	        'div',
	        { className: prefixCls },
	        _react2['default'].createElement('span', { ref: 'point', style: { left: per + '%' } }),
	        _react2['default'].createElement('div', {
	          className: prefixCls + '-' + 'handler',
	          onMouseDown: this.onMouseDown
	        })
	      );
	    }
	  }]);
	
	  return Ribbon;
	})(_react2['default'].Component);
	
	exports['default'] = Ribbon;
	
	Ribbon.propTypes = {
	  rootPrefixCls: _react2['default'].PropTypes.string,
	  hsv: _react2['default'].PropTypes.object,
	  onChange: _react2['default'].PropTypes.func
	};
	module.exports = exports['default'];

/***/ }),
/* 2162 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(332);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _colr = __webpack_require__(2145);
	
	var _colr2 = _interopRequireDefault(_colr);
	
	var _rcUtil = __webpack_require__(2148);
	
	var _rcUtil2 = _interopRequireDefault(_rcUtil);
	
	var colr = new _colr2['default']();
	
	function rgbaColor(r, g, b, a) {
	  return 'rgba(' + [r, g, b, a / 100].join(',') + ')';
	}
	
	var Alpha = (function (_React$Component) {
	  _inherits(Alpha, _React$Component);
	
	  function Alpha(props) {
	    var _this = this;
	
	    _classCallCheck(this, Alpha);
	
	    _get(Object.getPrototypeOf(Alpha.prototype), 'constructor', this).call(this, props);
	    var events = ['onMouseDown', 'onDrag', 'onDragEnd', 'pointMoveTo', 'getBackground'];
	    events.forEach(function (e) {
	      _this[e] = _this[e].bind(_this);
	    });
	  }
	
	  _createClass(Alpha, [{
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.removeListeners();
	    }
	  }, {
	    key: 'onMouseDown',
	    value: function onMouseDown(e) {
	      var x = e.clientX;
	      var y = e.clientY;
	
	      this.pointMoveTo({
	        x: x, y: y
	      });
	
	      this.dragListener = _rcUtil2['default'].Dom.addEventListener(window, 'mousemove', this.onDrag);
	      this.dragUpListener = _rcUtil2['default'].Dom.addEventListener(window, 'mouseup', this.onDragEnd);
	    }
	  }, {
	    key: 'onDrag',
	    value: function onDrag(e) {
	      var x = e.clientX;
	      var y = e.clientY;
	      this.pointMoveTo({
	        x: x, y: y
	      });
	    }
	  }, {
	    key: 'onDragEnd',
	    value: function onDragEnd(e) {
	      var x = e.clientX;
	      var y = e.clientY;
	      this.pointMoveTo({
	        x: x, y: y
	      });
	      this.removeListeners();
	    }
	  }, {
	    key: 'getBackground',
	    value: function getBackground() {
	      var _colr$fromHsvObject$toRgbObject = colr.fromHsvObject(this.props.hsv).toRgbObject();
	
	      var r = _colr$fromHsvObject$toRgbObject.r;
	      var g = _colr$fromHsvObject$toRgbObject.g;
	      var b = _colr$fromHsvObject$toRgbObject.b;
	
	      var opacityGradient = 'linear-gradient(to right, ' + rgbaColor(r, g, b, 0) + ', ' + rgbaColor(r, g, b, 100) + ')';
	      return opacityGradient;
	    }
	  }, {
	    key: 'getPrefixCls',
	    value: function getPrefixCls() {
	      return this.props.rootPrefixCls + '-alpha';
	    }
	  }, {
	    key: 'pointMoveTo',
	    value: function pointMoveTo(coords) {
	      var rect = _reactDom2['default'].findDOMNode(this).getBoundingClientRect();
	      var width = rect.width;
	      var left = coords.x - rect.left;
	
	      left = Math.max(0, left);
	      left = Math.min(left, width);
	
	      var alpha = Math.floor(left / width * 100);
	
	      this.props.onChange(alpha);
	    }
	  }, {
	    key: 'removeListeners',
	    value: function removeListeners() {
	      if (this.dragListener) {
	        this.dragListener.remove();
	        this.dragListener = null;
	      }
	      if (this.dragUpListener) {
	        this.dragUpListener.remove();
	        this.dragUpListener = null;
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var prefixCls = this.getPrefixCls();
	      return _react2['default'].createElement(
	        'div',
	        { className: prefixCls },
	        _react2['default'].createElement('div', {
	          ref: 'bg',
	          className: prefixCls + '-' + 'bg',
	          style: { background: this.getBackground() }
	        }),
	        _react2['default'].createElement('span', { style: { left: this.props.alpha + '%' } }),
	        _react2['default'].createElement('div', {
	          className: prefixCls + '-' + 'handler',
	          onMouseDown: this.onMouseDown
	        })
	      );
	    }
	  }]);
	
	  return Alpha;
	})(_react2['default'].Component);
	
	exports['default'] = Alpha;
	
	Alpha.propTypes = {
	  hsv: _react2['default'].PropTypes.object,
	  onChange: _react2['default'].PropTypes.func,
	  rootPrefixCls: _react2['default'].PropTypes.string,
	  alpha: _react2['default'].PropTypes.number
	};
	module.exports = exports['default'];

/***/ }),
/* 2163 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _colr = __webpack_require__(2145);
	
	var _colr2 = _interopRequireDefault(_colr);
	
	var colr = new _colr2['default']();
	var modesMap = ['RGB', 'HSB', 'HSL'];
	
	var Params = (function (_React$Component) {
	  _inherits(Params, _React$Component);
	
	  function Params(props) {
	    var _this = this;
	
	    _classCallCheck(this, Params);
	
	    _get(Object.getPrototypeOf(Params.prototype), 'constructor', this).call(this, props);
	
	    var color = colr.fromHsvObject(props.hsv);
	
	    // 管理 input 的状态
	    this.state = {
	      mode: props.mode,
	      color: color,
	      hex: color.toHex().substr(1)
	    };
	
	    var events = ['onHexHandler', 'onAlphaHandler', 'onColorChannelChange', 'onModeChange', 'getChannelInRange', 'getColorByChannel'];
	
	    events.forEach(function (e) {
	      if (_this[e]) {
	        _this[e] = _this[e].bind(_this);
	      }
	    });
	  }
	
	  _createClass(Params, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.hsv !== this.props.hsv) {
	        var color = colr.fromHsvObject(nextProps.hsv);
	        this.setState({
	          hex: color.toHex().substr(1),
	          color: color
	        });
	      }
	    }
	  }, {
	    key: 'onHexHandler',
	    value: function onHexHandler(event) {
	      var value = event.target.value;
	      var color = null;
	      try {
	        color = _colr2['default'].fromHex(value);
	      } catch (e) {
	        /* eslint no-empty:0 */
	      }
	
	      if (color !== null) {
	        this.setState({
	          color: color,
	          hex: value
	        });
	        this.props.onChange(color.toHsvObject(), false);
	      } else {
	        this.setState({
	          hex: value
	        });
	      }
	    }
	  }, {
	    key: 'onModeChange',
	    value: function onModeChange() {
	      var mode = this.state.mode;
	      var modeIndex = (modesMap.indexOf(mode) + 1) % modesMap.length;
	      var state = this.state;
	
	      mode = modesMap[modeIndex];
	      var colorChannel = this.getColorChannel(state.color, mode);
	      this.setState({
	        mode: mode,
	        colorChannel: colorChannel
	      });
	    }
	  }, {
	    key: 'onAlphaHandler',
	    value: function onAlphaHandler(event) {
	      var alpha = parseInt(event.target.value, 10);
	      if (isNaN(alpha)) {
	        alpha = 0;
	      }
	      alpha = Math.max(0, alpha);
	      alpha = Math.min(alpha, 100);
	
	      this.setState({
	        alpha: alpha
	      });
	
	      this.props.onAlphaChange(alpha);
	    }
	  }, {
	    key: 'onColorChannelChange',
	    value: function onColorChannelChange(index, event) {
	      var value = this.getChannelInRange(event.target.value, index);
	      var colorChannel = this.getColorChannel();
	
	      colorChannel[index] = value;
	
	      var color = this.getColorByChannel(colorChannel);
	
	      this.setState({
	        hex: color.toHex().substr(1),
	        color: color
	      });
	      this.props.onChange(color.toHsvObject(), false);
	    }
	  }, {
	    key: 'getChannelInRange',
	    value: function getChannelInRange(value, index) {
	      var channelMap = {
	        RGB: [[0, 255], [0, 255], [0, 255]],
	        HSB: [[0, 360], [0, 100], [0, 100]],
	        HSL: [[0, 360], [0, 100], [0, 100]]
	      };
	      var mode = this.state.mode;
	      var range = channelMap[mode][index];
	      var result = parseInt(value, 10);
	      if (isNaN(result)) {
	        result = 0;
	      }
	      result = Math.max(range[0], result);
	      result = Math.min(result, range[1]);
	      return result;
	    }
	  }, {
	    key: 'getColorByChannel',
	    value: function getColorByChannel(colorChannel) {
	      var colorMode = this.state.mode;
	      var color = undefined;
	      switch (colorMode) {
	        case 'RGB':
	          color = colr.fromRgbArray(colorChannel);
	          break;
	        case 'HSB':
	          color = colr.fromHsvArray(colorChannel);
	          break;
	        case 'HSL':
	          color = colr.fromHslArray(colorChannel);
	          break;
	        default:
	          color = colr.fromRgbArray(colorChannel);
	      }
	      return color;
	    }
	  }, {
	    key: 'getPrefixCls',
	    value: function getPrefixCls() {
	      return this.props.rootPrefixCls + '-params';
	    }
	  }, {
	    key: 'getColorChannel',
	    value: function getColorChannel(colrInstance, mode) {
	      var color = colrInstance || this.state.color;
	      var colorMode = mode || this.state.mode;
	      var result = undefined;
	      switch (colorMode) {
	        case 'RGB':
	          result = color.toRgbArray();
	          break;
	        case 'HSB':
	          result = color.toHsvArray();
	          break;
	        case 'HSL':
	          result = color.toHslArray();
	          break;
	        default:
	          result = color.toRgbArray();
	      }
	      return result;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var prefixCls = this.getPrefixCls();
	      var colorChannel = this.getColorChannel();
	      return _react2['default'].createElement(
	        'div',
	        { className: prefixCls },
	        _react2['default'].createElement(
	          'div',
	          { className: prefixCls + '-' + 'input' },
	          _react2['default'].createElement('input', {
	            className: prefixCls + '-' + 'hex',
	            type: 'text',
	            maxLength: '6',
	            onChange: this.onHexHandler,
	            value: this.state.hex.toUpperCase()
	          }),
	          _react2['default'].createElement('input', { type: 'number', ref: 'channel_0',
	            value: colorChannel[0],
	            onChange: this.onColorChannelChange.bind(null, 0) }),
	          _react2['default'].createElement('input', { type: 'number', ref: 'channel_1',
	            value: colorChannel[1],
	            onChange: this.onColorChannelChange.bind(null, 1) }),
	          _react2['default'].createElement('input', { type: 'number', ref: 'channel_2',
	            value: colorChannel[2],
	            onChange: this.onColorChannelChange.bind(null, 2) }),
	          _react2['default'].createElement('input', { type: 'number',
	            value: this.props.alpha,
	            onChange: this.onAlphaHandler })
	        ),
	        _react2['default'].createElement(
	          'div',
	          { className: prefixCls + '-' + 'lable' },
	          _react2['default'].createElement(
	            'label',
	            { className: prefixCls + '-' + 'lable-hex' },
	            'Hex'
	          ),
	          _react2['default'].createElement(
	            'label',
	            { className: prefixCls + '-' + 'lable-number',
	              onClick: this.onModeChange
	            },
	            this.state.mode[0]
	          ),
	          _react2['default'].createElement(
	            'label',
	            { className: prefixCls + '-' + 'lable-number',
	              onClick: this.onModeChange
	            },
	            this.state.mode[1]
	          ),
	          _react2['default'].createElement(
	            'label',
	            { className: prefixCls + '-' + 'lable-number',
	              onClick: this.onModeChange
	            },
	            this.state.mode[2]
	          ),
	          _react2['default'].createElement(
	            'label',
	            { className: prefixCls + '-' + 'lable-alpha' },
	            'A'
	          )
	        )
	      );
	    }
	  }]);
	
	  return Params;
	})(_react2['default'].Component);
	
	exports['default'] = Params;
	
	Params.propTypes = {
	  onChange: _react2['default'].PropTypes.func,
	  hsv: _react2['default'].PropTypes.object,
	  alpha: _react2['default'].PropTypes.number,
	  rootPrefixCls: _react2['default'].PropTypes.string,
	  onAlphaChange: _react2['default'].PropTypes.func,
	  mode: _react2['default'].PropTypes.oneOf(modesMap)
	};
	
	Params.defaultProps = {
	  mode: modesMap[0]
	};
	module.exports = exports['default'];

/***/ }),
/* 2164 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function validationColor(props, propName, componentName) {
	  if (props[propName] && !/^#[0-9a-fA-F]{3,6}$/.test(props[propName])) {
	    return new Error(componentName + '.props.' + propName + ' Validation failed!');
	  }
	};

/***/ }),
/* 2165 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var autoAdjustOverflow = {
	  adjustX: 1,
	  adjustY: 1
	};
	
	var targetOffset = [0, 0];
	
	var placements = {
	  topLeft: {
	    points: ['bl', 'tl'],
	    overflow: autoAdjustOverflow,
	    offset: [0, -5],
	    targetOffset: targetOffset
	  },
	  topRight: {
	    points: ['br', 'tr'],
	    overflow: autoAdjustOverflow,
	    offset: [0, -5],
	    targetOffset: targetOffset
	  },
	  bottomLeft: {
	    points: ['tl', 'bl'],
	    overflow: autoAdjustOverflow,
	    offset: [0, 5],
	    targetOffset: targetOffset
	  },
	  bottomRight: {
	    points: ['tr', 'br'],
	    overflow: autoAdjustOverflow,
	    offset: [0, 5],
	    targetOffset: targetOffset
	  }
	};
	
	exports['default'] = placements;
	module.exports = exports['default'];

/***/ }),
/* 2166 */
/***/ (function(module, exports, __webpack_require__) {

	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: http://codemirror.net/LICENSE
	
	(function(mod) {
	  if (true) // CommonJS
	    mod(__webpack_require__(1753), __webpack_require__(2167), __webpack_require__(1754), __webpack_require__(2168));
	  else if (typeof define == "function" && define.amd) // AMD
	    define(["../../lib/codemirror", "../xml/xml", "../javascript/javascript", "../css/css"], mod);
	  else // Plain browser env
	    mod(CodeMirror);
	})(function(CodeMirror) {
	  "use strict";
	
	  var defaultTags = {
	    script: [
	      ["lang", /(javascript|babel)/i, "javascript"],
	      ["type", /^(?:text|application)\/(?:x-)?(?:java|ecma)script$|^$/i, "javascript"],
	      ["type", /./, "text/plain"],
	      [null, null, "javascript"]
	    ],
	    style:  [
	      ["lang", /^css$/i, "css"],
	      ["type", /^(text\/)?(x-)?(stylesheet|css)$/i, "css"],
	      ["type", /./, "text/plain"],
	      [null, null, "css"]
	    ]
	  };
	
	  function maybeBackup(stream, pat, style) {
	    var cur = stream.current(), close = cur.search(pat);
	    if (close > -1) {
	      stream.backUp(cur.length - close);
	    } else if (cur.match(/<\/?$/)) {
	      stream.backUp(cur.length);
	      if (!stream.match(pat, false)) stream.match(cur);
	    }
	    return style;
	  }
	
	  var attrRegexpCache = {};
	  function getAttrRegexp(attr) {
	    var regexp = attrRegexpCache[attr];
	    if (regexp) return regexp;
	    return attrRegexpCache[attr] = new RegExp("\\s+" + attr + "\\s*=\\s*('|\")?([^'\"]+)('|\")?\\s*");
	  }
	
	  function getAttrValue(text, attr) {
	    var match = text.match(getAttrRegexp(attr))
	    return match ? /^\s*(.*?)\s*$/.exec(match[2])[1] : ""
	  }
	
	  function getTagRegexp(tagName, anchored) {
	    return new RegExp((anchored ? "^" : "") + "<\/\s*" + tagName + "\s*>", "i");
	  }
	
	  function addTags(from, to) {
	    for (var tag in from) {
	      var dest = to[tag] || (to[tag] = []);
	      var source = from[tag];
	      for (var i = source.length - 1; i >= 0; i--)
	        dest.unshift(source[i])
	    }
	  }
	
	  function findMatchingMode(tagInfo, tagText) {
	    for (var i = 0; i < tagInfo.length; i++) {
	      var spec = tagInfo[i];
	      if (!spec[0] || spec[1].test(getAttrValue(tagText, spec[0]))) return spec[2];
	    }
	  }
	
	  CodeMirror.defineMode("htmlmixed", function (config, parserConfig) {
	    var htmlMode = CodeMirror.getMode(config, {
	      name: "xml",
	      htmlMode: true,
	      multilineTagIndentFactor: parserConfig.multilineTagIndentFactor,
	      multilineTagIndentPastTag: parserConfig.multilineTagIndentPastTag
	    });
	
	    var tags = {};
	    var configTags = parserConfig && parserConfig.tags, configScript = parserConfig && parserConfig.scriptTypes;
	    addTags(defaultTags, tags);
	    if (configTags) addTags(configTags, tags);
	    if (configScript) for (var i = configScript.length - 1; i >= 0; i--)
	      tags.script.unshift(["type", configScript[i].matches, configScript[i].mode])
	
	    function html(stream, state) {
	      var style = htmlMode.token(stream, state.htmlState), tag = /\btag\b/.test(style), tagName
	      if (tag && !/[<>\s\/]/.test(stream.current()) &&
	          (tagName = state.htmlState.tagName && state.htmlState.tagName.toLowerCase()) &&
	          tags.hasOwnProperty(tagName)) {
	        state.inTag = tagName + " "
	      } else if (state.inTag && tag && />$/.test(stream.current())) {
	        var inTag = /^([\S]+) (.*)/.exec(state.inTag)
	        state.inTag = null
	        var modeSpec = stream.current() == ">" && findMatchingMode(tags[inTag[1]], inTag[2])
	        var mode = CodeMirror.getMode(config, modeSpec)
	        var endTagA = getTagRegexp(inTag[1], true), endTag = getTagRegexp(inTag[1], false);
	        state.token = function (stream, state) {
	          if (stream.match(endTagA, false)) {
	            state.token = html;
	            state.localState = state.localMode = null;
	            return null;
	          }
	          return maybeBackup(stream, endTag, state.localMode.token(stream, state.localState));
	        };
	        state.localMode = mode;
	        state.localState = CodeMirror.startState(mode, htmlMode.indent(state.htmlState, ""));
	      } else if (state.inTag) {
	        state.inTag += stream.current()
	        if (stream.eol()) state.inTag += " "
	      }
	      return style;
	    };
	
	    return {
	      startState: function () {
	        var state = CodeMirror.startState(htmlMode);
	        return {token: html, inTag: null, localMode: null, localState: null, htmlState: state};
	      },
	
	      copyState: function (state) {
	        var local;
	        if (state.localState) {
	          local = CodeMirror.copyState(state.localMode, state.localState);
	        }
	        return {token: state.token, inTag: state.inTag,
	                localMode: state.localMode, localState: local,
	                htmlState: CodeMirror.copyState(htmlMode, state.htmlState)};
	      },
	
	      token: function (stream, state) {
	        return state.token(stream, state);
	      },
	
	      indent: function (state, textAfter) {
	        if (!state.localMode || /^\s*<\//.test(textAfter))
	          return htmlMode.indent(state.htmlState, textAfter);
	        else if (state.localMode.indent)
	          return state.localMode.indent(state.localState, textAfter);
	        else
	          return CodeMirror.Pass;
	      },
	
	      innerMode: function (state) {
	        return {state: state.localState || state.htmlState, mode: state.localMode || htmlMode};
	      }
	    };
	  }, "xml", "javascript", "css");
	
	  CodeMirror.defineMIME("text/html", "htmlmixed");
	});


/***/ }),
/* 2167 */
/***/ (function(module, exports, __webpack_require__) {

	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: http://codemirror.net/LICENSE
	
	(function(mod) {
	  if (true) // CommonJS
	    mod(__webpack_require__(1753));
	  else if (typeof define == "function" && define.amd) // AMD
	    define(["../../lib/codemirror"], mod);
	  else // Plain browser env
	    mod(CodeMirror);
	})(function(CodeMirror) {
	"use strict";
	
	var htmlConfig = {
	  autoSelfClosers: {'area': true, 'base': true, 'br': true, 'col': true, 'command': true,
	                    'embed': true, 'frame': true, 'hr': true, 'img': true, 'input': true,
	                    'keygen': true, 'link': true, 'meta': true, 'param': true, 'source': true,
	                    'track': true, 'wbr': true, 'menuitem': true},
	  implicitlyClosed: {'dd': true, 'li': true, 'optgroup': true, 'option': true, 'p': true,
	                     'rp': true, 'rt': true, 'tbody': true, 'td': true, 'tfoot': true,
	                     'th': true, 'tr': true},
	  contextGrabbers: {
	    'dd': {'dd': true, 'dt': true},
	    'dt': {'dd': true, 'dt': true},
	    'li': {'li': true},
	    'option': {'option': true, 'optgroup': true},
	    'optgroup': {'optgroup': true},
	    'p': {'address': true, 'article': true, 'aside': true, 'blockquote': true, 'dir': true,
	          'div': true, 'dl': true, 'fieldset': true, 'footer': true, 'form': true,
	          'h1': true, 'h2': true, 'h3': true, 'h4': true, 'h5': true, 'h6': true,
	          'header': true, 'hgroup': true, 'hr': true, 'menu': true, 'nav': true, 'ol': true,
	          'p': true, 'pre': true, 'section': true, 'table': true, 'ul': true},
	    'rp': {'rp': true, 'rt': true},
	    'rt': {'rp': true, 'rt': true},
	    'tbody': {'tbody': true, 'tfoot': true},
	    'td': {'td': true, 'th': true},
	    'tfoot': {'tbody': true},
	    'th': {'td': true, 'th': true},
	    'thead': {'tbody': true, 'tfoot': true},
	    'tr': {'tr': true}
	  },
	  doNotIndent: {"pre": true},
	  allowUnquoted: true,
	  allowMissing: true,
	  caseFold: true
	}
	
	var xmlConfig = {
	  autoSelfClosers: {},
	  implicitlyClosed: {},
	  contextGrabbers: {},
	  doNotIndent: {},
	  allowUnquoted: false,
	  allowMissing: false,
	  caseFold: false
	}
	
	CodeMirror.defineMode("xml", function(editorConf, config_) {
	  var indentUnit = editorConf.indentUnit
	  var config = {}
	  var defaults = config_.htmlMode ? htmlConfig : xmlConfig
	  for (var prop in defaults) config[prop] = defaults[prop]
	  for (var prop in config_) config[prop] = config_[prop]
	
	  // Return variables for tokenizers
	  var type, setStyle;
	
	  function inText(stream, state) {
	    function chain(parser) {
	      state.tokenize = parser;
	      return parser(stream, state);
	    }
	
	    var ch = stream.next();
	    if (ch == "<") {
	      if (stream.eat("!")) {
	        if (stream.eat("[")) {
	          if (stream.match("CDATA[")) return chain(inBlock("atom", "]]>"));
	          else return null;
	        } else if (stream.match("--")) {
	          return chain(inBlock("comment", "-->"));
	        } else if (stream.match("DOCTYPE", true, true)) {
	          stream.eatWhile(/[\w\._\-]/);
	          return chain(doctype(1));
	        } else {
	          return null;
	        }
	      } else if (stream.eat("?")) {
	        stream.eatWhile(/[\w\._\-]/);
	        state.tokenize = inBlock("meta", "?>");
	        return "meta";
	      } else {
	        type = stream.eat("/") ? "closeTag" : "openTag";
	        state.tokenize = inTag;
	        return "tag bracket";
	      }
	    } else if (ch == "&") {
	      var ok;
	      if (stream.eat("#")) {
	        if (stream.eat("x")) {
	          ok = stream.eatWhile(/[a-fA-F\d]/) && stream.eat(";");
	        } else {
	          ok = stream.eatWhile(/[\d]/) && stream.eat(";");
	        }
	      } else {
	        ok = stream.eatWhile(/[\w\.\-:]/) && stream.eat(";");
	      }
	      return ok ? "atom" : "error";
	    } else {
	      stream.eatWhile(/[^&<]/);
	      return null;
	    }
	  }
	  inText.isInText = true;
	
	  function inTag(stream, state) {
	    var ch = stream.next();
	    if (ch == ">" || (ch == "/" && stream.eat(">"))) {
	      state.tokenize = inText;
	      type = ch == ">" ? "endTag" : "selfcloseTag";
	      return "tag bracket";
	    } else if (ch == "=") {
	      type = "equals";
	      return null;
	    } else if (ch == "<") {
	      state.tokenize = inText;
	      state.state = baseState;
	      state.tagName = state.tagStart = null;
	      var next = state.tokenize(stream, state);
	      return next ? next + " tag error" : "tag error";
	    } else if (/[\'\"]/.test(ch)) {
	      state.tokenize = inAttribute(ch);
	      state.stringStartCol = stream.column();
	      return state.tokenize(stream, state);
	    } else {
	      stream.match(/^[^\s\u00a0=<>\"\']*[^\s\u00a0=<>\"\'\/]/);
	      return "word";
	    }
	  }
	
	  function inAttribute(quote) {
	    var closure = function(stream, state) {
	      while (!stream.eol()) {
	        if (stream.next() == quote) {
	          state.tokenize = inTag;
	          break;
	        }
	      }
	      return "string";
	    };
	    closure.isInAttribute = true;
	    return closure;
	  }
	
	  function inBlock(style, terminator) {
	    return function(stream, state) {
	      while (!stream.eol()) {
	        if (stream.match(terminator)) {
	          state.tokenize = inText;
	          break;
	        }
	        stream.next();
	      }
	      return style;
	    };
	  }
	  function doctype(depth) {
	    return function(stream, state) {
	      var ch;
	      while ((ch = stream.next()) != null) {
	        if (ch == "<") {
	          state.tokenize = doctype(depth + 1);
	          return state.tokenize(stream, state);
	        } else if (ch == ">") {
	          if (depth == 1) {
	            state.tokenize = inText;
	            break;
	          } else {
	            state.tokenize = doctype(depth - 1);
	            return state.tokenize(stream, state);
	          }
	        }
	      }
	      return "meta";
	    };
	  }
	
	  function Context(state, tagName, startOfLine) {
	    this.prev = state.context;
	    this.tagName = tagName;
	    this.indent = state.indented;
	    this.startOfLine = startOfLine;
	    if (config.doNotIndent.hasOwnProperty(tagName) || (state.context && state.context.noIndent))
	      this.noIndent = true;
	  }
	  function popContext(state) {
	    if (state.context) state.context = state.context.prev;
	  }
	  function maybePopContext(state, nextTagName) {
	    var parentTagName;
	    while (true) {
	      if (!state.context) {
	        return;
	      }
	      parentTagName = state.context.tagName;
	      if (!config.contextGrabbers.hasOwnProperty(parentTagName) ||
	          !config.contextGrabbers[parentTagName].hasOwnProperty(nextTagName)) {
	        return;
	      }
	      popContext(state);
	    }
	  }
	
	  function baseState(type, stream, state) {
	    if (type == "openTag") {
	      state.tagStart = stream.column();
	      return tagNameState;
	    } else if (type == "closeTag") {
	      return closeTagNameState;
	    } else {
	      return baseState;
	    }
	  }
	  function tagNameState(type, stream, state) {
	    if (type == "word") {
	      state.tagName = stream.current();
	      setStyle = "tag";
	      return attrState;
	    } else {
	      setStyle = "error";
	      return tagNameState;
	    }
	  }
	  function closeTagNameState(type, stream, state) {
	    if (type == "word") {
	      var tagName = stream.current();
	      if (state.context && state.context.tagName != tagName &&
	          config.implicitlyClosed.hasOwnProperty(state.context.tagName))
	        popContext(state);
	      if ((state.context && state.context.tagName == tagName) || config.matchClosing === false) {
	        setStyle = "tag";
	        return closeState;
	      } else {
	        setStyle = "tag error";
	        return closeStateErr;
	      }
	    } else {
	      setStyle = "error";
	      return closeStateErr;
	    }
	  }
	
	  function closeState(type, _stream, state) {
	    if (type != "endTag") {
	      setStyle = "error";
	      return closeState;
	    }
	    popContext(state);
	    return baseState;
	  }
	  function closeStateErr(type, stream, state) {
	    setStyle = "error";
	    return closeState(type, stream, state);
	  }
	
	  function attrState(type, _stream, state) {
	    if (type == "word") {
	      setStyle = "attribute";
	      return attrEqState;
	    } else if (type == "endTag" || type == "selfcloseTag") {
	      var tagName = state.tagName, tagStart = state.tagStart;
	      state.tagName = state.tagStart = null;
	      if (type == "selfcloseTag" ||
	          config.autoSelfClosers.hasOwnProperty(tagName)) {
	        maybePopContext(state, tagName);
	      } else {
	        maybePopContext(state, tagName);
	        state.context = new Context(state, tagName, tagStart == state.indented);
	      }
	      return baseState;
	    }
	    setStyle = "error";
	    return attrState;
	  }
	  function attrEqState(type, stream, state) {
	    if (type == "equals") return attrValueState;
	    if (!config.allowMissing) setStyle = "error";
	    return attrState(type, stream, state);
	  }
	  function attrValueState(type, stream, state) {
	    if (type == "string") return attrContinuedState;
	    if (type == "word" && config.allowUnquoted) {setStyle = "string"; return attrState;}
	    setStyle = "error";
	    return attrState(type, stream, state);
	  }
	  function attrContinuedState(type, stream, state) {
	    if (type == "string") return attrContinuedState;
	    return attrState(type, stream, state);
	  }
	
	  return {
	    startState: function(baseIndent) {
	      var state = {tokenize: inText,
	                   state: baseState,
	                   indented: baseIndent || 0,
	                   tagName: null, tagStart: null,
	                   context: null}
	      if (baseIndent != null) state.baseIndent = baseIndent
	      return state
	    },
	
	    token: function(stream, state) {
	      if (!state.tagName && stream.sol())
	        state.indented = stream.indentation();
	
	      if (stream.eatSpace()) return null;
	      type = null;
	      var style = state.tokenize(stream, state);
	      if ((style || type) && style != "comment") {
	        setStyle = null;
	        state.state = state.state(type || style, stream, state);
	        if (setStyle)
	          style = setStyle == "error" ? style + " error" : setStyle;
	      }
	      return style;
	    },
	
	    indent: function(state, textAfter, fullLine) {
	      var context = state.context;
	      // Indent multi-line strings (e.g. css).
	      if (state.tokenize.isInAttribute) {
	        if (state.tagStart == state.indented)
	          return state.stringStartCol + 1;
	        else
	          return state.indented + indentUnit;
	      }
	      if (context && context.noIndent) return CodeMirror.Pass;
	      if (state.tokenize != inTag && state.tokenize != inText)
	        return fullLine ? fullLine.match(/^(\s*)/)[0].length : 0;
	      // Indent the starts of attribute names.
	      if (state.tagName) {
	        if (config.multilineTagIndentPastTag !== false)
	          return state.tagStart + state.tagName.length + 2;
	        else
	          return state.tagStart + indentUnit * (config.multilineTagIndentFactor || 1);
	      }
	      if (config.alignCDATA && /<!\[CDATA\[/.test(textAfter)) return 0;
	      var tagAfter = textAfter && /^<(\/)?([\w_:\.-]*)/.exec(textAfter);
	      if (tagAfter && tagAfter[1]) { // Closing tag spotted
	        while (context) {
	          if (context.tagName == tagAfter[2]) {
	            context = context.prev;
	            break;
	          } else if (config.implicitlyClosed.hasOwnProperty(context.tagName)) {
	            context = context.prev;
	          } else {
	            break;
	          }
	        }
	      } else if (tagAfter) { // Opening tag spotted
	        while (context) {
	          var grabbers = config.contextGrabbers[context.tagName];
	          if (grabbers && grabbers.hasOwnProperty(tagAfter[2]))
	            context = context.prev;
	          else
	            break;
	        }
	      }
	      while (context && context.prev && !context.startOfLine)
	        context = context.prev;
	      if (context) return context.indent + indentUnit;
	      else return state.baseIndent || 0;
	    },
	
	    electricInput: /<\/[\s\w:]+>$/,
	    blockCommentStart: "<!--",
	    blockCommentEnd: "-->",
	
	    configuration: config.htmlMode ? "html" : "xml",
	    helperType: config.htmlMode ? "html" : "xml",
	
	    skipAttribute: function(state) {
	      if (state.state == attrValueState)
	        state.state = attrState
	    }
	  };
	});
	
	CodeMirror.defineMIME("text/xml", "xml");
	CodeMirror.defineMIME("application/xml", "xml");
	if (!CodeMirror.mimeModes.hasOwnProperty("text/html"))
	  CodeMirror.defineMIME("text/html", {name: "xml", htmlMode: true});
	
	});


/***/ }),
/* 2168 */
/***/ (function(module, exports, __webpack_require__) {

	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: http://codemirror.net/LICENSE
	
	(function(mod) {
	  if (true) // CommonJS
	    mod(__webpack_require__(1753));
	  else if (typeof define == "function" && define.amd) // AMD
	    define(["../../lib/codemirror"], mod);
	  else // Plain browser env
	    mod(CodeMirror);
	})(function(CodeMirror) {
	"use strict";
	
	CodeMirror.defineMode("css", function(config, parserConfig) {
	  var inline = parserConfig.inline
	  if (!parserConfig.propertyKeywords) parserConfig = CodeMirror.resolveMode("text/css");
	
	  var indentUnit = config.indentUnit,
	      tokenHooks = parserConfig.tokenHooks,
	      documentTypes = parserConfig.documentTypes || {},
	      mediaTypes = parserConfig.mediaTypes || {},
	      mediaFeatures = parserConfig.mediaFeatures || {},
	      mediaValueKeywords = parserConfig.mediaValueKeywords || {},
	      propertyKeywords = parserConfig.propertyKeywords || {},
	      nonStandardPropertyKeywords = parserConfig.nonStandardPropertyKeywords || {},
	      fontProperties = parserConfig.fontProperties || {},
	      counterDescriptors = parserConfig.counterDescriptors || {},
	      colorKeywords = parserConfig.colorKeywords || {},
	      valueKeywords = parserConfig.valueKeywords || {},
	      allowNested = parserConfig.allowNested,
	      supportsAtComponent = parserConfig.supportsAtComponent === true;
	
	  var type, override;
	  function ret(style, tp) { type = tp; return style; }
	
	  // Tokenizers
	
	  function tokenBase(stream, state) {
	    var ch = stream.next();
	    if (tokenHooks[ch]) {
	      var result = tokenHooks[ch](stream, state);
	      if (result !== false) return result;
	    }
	    if (ch == "@") {
	      stream.eatWhile(/[\w\\\-]/);
	      return ret("def", stream.current());
	    } else if (ch == "=" || (ch == "~" || ch == "|") && stream.eat("=")) {
	      return ret(null, "compare");
	    } else if (ch == "\"" || ch == "'") {
	      state.tokenize = tokenString(ch);
	      return state.tokenize(stream, state);
	    } else if (ch == "#") {
	      stream.eatWhile(/[\w\\\-]/);
	      return ret("atom", "hash");
	    } else if (ch == "!") {
	      stream.match(/^\s*\w*/);
	      return ret("keyword", "important");
	    } else if (/\d/.test(ch) || ch == "." && stream.eat(/\d/)) {
	      stream.eatWhile(/[\w.%]/);
	      return ret("number", "unit");
	    } else if (ch === "-") {
	      if (/[\d.]/.test(stream.peek())) {
	        stream.eatWhile(/[\w.%]/);
	        return ret("number", "unit");
	      } else if (stream.match(/^-[\w\\\-]+/)) {
	        stream.eatWhile(/[\w\\\-]/);
	        if (stream.match(/^\s*:/, false))
	          return ret("variable-2", "variable-definition");
	        return ret("variable-2", "variable");
	      } else if (stream.match(/^\w+-/)) {
	        return ret("meta", "meta");
	      }
	    } else if (/[,+>*\/]/.test(ch)) {
	      return ret(null, "select-op");
	    } else if (ch == "." && stream.match(/^-?[_a-z][_a-z0-9-]*/i)) {
	      return ret("qualifier", "qualifier");
	    } else if (/[:;{}\[\]\(\)]/.test(ch)) {
	      return ret(null, ch);
	    } else if ((ch == "u" && stream.match(/rl(-prefix)?\(/)) ||
	               (ch == "d" && stream.match("omain(")) ||
	               (ch == "r" && stream.match("egexp("))) {
	      stream.backUp(1);
	      state.tokenize = tokenParenthesized;
	      return ret("property", "word");
	    } else if (/[\w\\\-]/.test(ch)) {
	      stream.eatWhile(/[\w\\\-]/);
	      return ret("property", "word");
	    } else {
	      return ret(null, null);
	    }
	  }
	
	  function tokenString(quote) {
	    return function(stream, state) {
	      var escaped = false, ch;
	      while ((ch = stream.next()) != null) {
	        if (ch == quote && !escaped) {
	          if (quote == ")") stream.backUp(1);
	          break;
	        }
	        escaped = !escaped && ch == "\\";
	      }
	      if (ch == quote || !escaped && quote != ")") state.tokenize = null;
	      return ret("string", "string");
	    };
	  }
	
	  function tokenParenthesized(stream, state) {
	    stream.next(); // Must be '('
	    if (!stream.match(/\s*[\"\')]/, false))
	      state.tokenize = tokenString(")");
	    else
	      state.tokenize = null;
	    return ret(null, "(");
	  }
	
	  // Context management
	
	  function Context(type, indent, prev) {
	    this.type = type;
	    this.indent = indent;
	    this.prev = prev;
	  }
	
	  function pushContext(state, stream, type, indent) {
	    state.context = new Context(type, stream.indentation() + (indent === false ? 0 : indentUnit), state.context);
	    return type;
	  }
	
	  function popContext(state) {
	    if (state.context.prev)
	      state.context = state.context.prev;
	    return state.context.type;
	  }
	
	  function pass(type, stream, state) {
	    return states[state.context.type](type, stream, state);
	  }
	  function popAndPass(type, stream, state, n) {
	    for (var i = n || 1; i > 0; i--)
	      state.context = state.context.prev;
	    return pass(type, stream, state);
	  }
	
	  // Parser
	
	  function wordAsValue(stream) {
	    var word = stream.current().toLowerCase();
	    if (valueKeywords.hasOwnProperty(word))
	      override = "atom";
	    else if (colorKeywords.hasOwnProperty(word))
	      override = "keyword";
	    else
	      override = "variable";
	  }
	
	  var states = {};
	
	  states.top = function(type, stream, state) {
	    if (type == "{") {
	      return pushContext(state, stream, "block");
	    } else if (type == "}" && state.context.prev) {
	      return popContext(state);
	    } else if (supportsAtComponent && /@component/.test(type)) {
	      return pushContext(state, stream, "atComponentBlock");
	    } else if (/^@(-moz-)?document$/.test(type)) {
	      return pushContext(state, stream, "documentTypes");
	    } else if (/^@(media|supports|(-moz-)?document|import)$/.test(type)) {
	      return pushContext(state, stream, "atBlock");
	    } else if (/^@(font-face|counter-style)/.test(type)) {
	      state.stateArg = type;
	      return "restricted_atBlock_before";
	    } else if (/^@(-(moz|ms|o|webkit)-)?keyframes$/.test(type)) {
	      return "keyframes";
	    } else if (type && type.charAt(0) == "@") {
	      return pushContext(state, stream, "at");
	    } else if (type == "hash") {
	      override = "builtin";
	    } else if (type == "word") {
	      override = "tag";
	    } else if (type == "variable-definition") {
	      return "maybeprop";
	    } else if (type == "interpolation") {
	      return pushContext(state, stream, "interpolation");
	    } else if (type == ":") {
	      return "pseudo";
	    } else if (allowNested && type == "(") {
	      return pushContext(state, stream, "parens");
	    }
	    return state.context.type;
	  };
	
	  states.block = function(type, stream, state) {
	    if (type == "word") {
	      var word = stream.current().toLowerCase();
	      if (propertyKeywords.hasOwnProperty(word)) {
	        override = "property";
	        return "maybeprop";
	      } else if (nonStandardPropertyKeywords.hasOwnProperty(word)) {
	        override = "string-2";
	        return "maybeprop";
	      } else if (allowNested) {
	        override = stream.match(/^\s*:(?:\s|$)/, false) ? "property" : "tag";
	        return "block";
	      } else {
	        override += " error";
	        return "maybeprop";
	      }
	    } else if (type == "meta") {
	      return "block";
	    } else if (!allowNested && (type == "hash" || type == "qualifier")) {
	      override = "error";
	      return "block";
	    } else {
	      return states.top(type, stream, state);
	    }
	  };
	
	  states.maybeprop = function(type, stream, state) {
	    if (type == ":") return pushContext(state, stream, "prop");
	    return pass(type, stream, state);
	  };
	
	  states.prop = function(type, stream, state) {
	    if (type == ";") return popContext(state);
	    if (type == "{" && allowNested) return pushContext(state, stream, "propBlock");
	    if (type == "}" || type == "{") return popAndPass(type, stream, state);
	    if (type == "(") return pushContext(state, stream, "parens");
	
	    if (type == "hash" && !/^#([0-9a-fA-f]{3,4}|[0-9a-fA-f]{6}|[0-9a-fA-f]{8})$/.test(stream.current())) {
	      override += " error";
	    } else if (type == "word") {
	      wordAsValue(stream);
	    } else if (type == "interpolation") {
	      return pushContext(state, stream, "interpolation");
	    }
	    return "prop";
	  };
	
	  states.propBlock = function(type, _stream, state) {
	    if (type == "}") return popContext(state);
	    if (type == "word") { override = "property"; return "maybeprop"; }
	    return state.context.type;
	  };
	
	  states.parens = function(type, stream, state) {
	    if (type == "{" || type == "}") return popAndPass(type, stream, state);
	    if (type == ")") return popContext(state);
	    if (type == "(") return pushContext(state, stream, "parens");
	    if (type == "interpolation") return pushContext(state, stream, "interpolation");
	    if (type == "word") wordAsValue(stream);
	    return "parens";
	  };
	
	  states.pseudo = function(type, stream, state) {
	    if (type == "word") {
	      override = "variable-3";
	      return state.context.type;
	    }
	    return pass(type, stream, state);
	  };
	
	  states.documentTypes = function(type, stream, state) {
	    if (type == "word" && documentTypes.hasOwnProperty(stream.current())) {
	      override = "tag";
	      return state.context.type;
	    } else {
	      return states.atBlock(type, stream, state);
	    }
	  };
	
	  states.atBlock = function(type, stream, state) {
	    if (type == "(") return pushContext(state, stream, "atBlock_parens");
	    if (type == "}" || type == ";") return popAndPass(type, stream, state);
	    if (type == "{") return popContext(state) && pushContext(state, stream, allowNested ? "block" : "top");
	
	    if (type == "interpolation") return pushContext(state, stream, "interpolation");
	
	    if (type == "word") {
	      var word = stream.current().toLowerCase();
	      if (word == "only" || word == "not" || word == "and" || word == "or")
	        override = "keyword";
	      else if (mediaTypes.hasOwnProperty(word))
	        override = "attribute";
	      else if (mediaFeatures.hasOwnProperty(word))
	        override = "property";
	      else if (mediaValueKeywords.hasOwnProperty(word))
	        override = "keyword";
	      else if (propertyKeywords.hasOwnProperty(word))
	        override = "property";
	      else if (nonStandardPropertyKeywords.hasOwnProperty(word))
	        override = "string-2";
	      else if (valueKeywords.hasOwnProperty(word))
	        override = "atom";
	      else if (colorKeywords.hasOwnProperty(word))
	        override = "keyword";
	      else
	        override = "error";
	    }
	    return state.context.type;
	  };
	
	  states.atComponentBlock = function(type, stream, state) {
	    if (type == "}")
	      return popAndPass(type, stream, state);
	    if (type == "{")
	      return popContext(state) && pushContext(state, stream, allowNested ? "block" : "top", false);
	    if (type == "word")
	      override = "error";
	    return state.context.type;
	  };
	
	  states.atBlock_parens = function(type, stream, state) {
	    if (type == ")") return popContext(state);
	    if (type == "{" || type == "}") return popAndPass(type, stream, state, 2);
	    return states.atBlock(type, stream, state);
	  };
	
	  states.restricted_atBlock_before = function(type, stream, state) {
	    if (type == "{")
	      return pushContext(state, stream, "restricted_atBlock");
	    if (type == "word" && state.stateArg == "@counter-style") {
	      override = "variable";
	      return "restricted_atBlock_before";
	    }
	    return pass(type, stream, state);
	  };
	
	  states.restricted_atBlock = function(type, stream, state) {
	    if (type == "}") {
	      state.stateArg = null;
	      return popContext(state);
	    }
	    if (type == "word") {
	      if ((state.stateArg == "@font-face" && !fontProperties.hasOwnProperty(stream.current().toLowerCase())) ||
	          (state.stateArg == "@counter-style" && !counterDescriptors.hasOwnProperty(stream.current().toLowerCase())))
	        override = "error";
	      else
	        override = "property";
	      return "maybeprop";
	    }
	    return "restricted_atBlock";
	  };
	
	  states.keyframes = function(type, stream, state) {
	    if (type == "word") { override = "variable"; return "keyframes"; }
	    if (type == "{") return pushContext(state, stream, "top");
	    return pass(type, stream, state);
	  };
	
	  states.at = function(type, stream, state) {
	    if (type == ";") return popContext(state);
	    if (type == "{" || type == "}") return popAndPass(type, stream, state);
	    if (type == "word") override = "tag";
	    else if (type == "hash") override = "builtin";
	    return "at";
	  };
	
	  states.interpolation = function(type, stream, state) {
	    if (type == "}") return popContext(state);
	    if (type == "{" || type == ";") return popAndPass(type, stream, state);
	    if (type == "word") override = "variable";
	    else if (type != "variable" && type != "(" && type != ")") override = "error";
	    return "interpolation";
	  };
	
	  return {
	    startState: function(base) {
	      return {tokenize: null,
	              state: inline ? "block" : "top",
	              stateArg: null,
	              context: new Context(inline ? "block" : "top", base || 0, null)};
	    },
	
	    token: function(stream, state) {
	      if (!state.tokenize && stream.eatSpace()) return null;
	      var style = (state.tokenize || tokenBase)(stream, state);
	      if (style && typeof style == "object") {
	        type = style[1];
	        style = style[0];
	      }
	      override = style;
	      state.state = states[state.state](type, stream, state);
	      return override;
	    },
	
	    indent: function(state, textAfter) {
	      var cx = state.context, ch = textAfter && textAfter.charAt(0);
	      var indent = cx.indent;
	      if (cx.type == "prop" && (ch == "}" || ch == ")")) cx = cx.prev;
	      if (cx.prev) {
	        if (ch == "}" && (cx.type == "block" || cx.type == "top" ||
	                          cx.type == "interpolation" || cx.type == "restricted_atBlock")) {
	          // Resume indentation from parent context.
	          cx = cx.prev;
	          indent = cx.indent;
	        } else if (ch == ")" && (cx.type == "parens" || cx.type == "atBlock_parens") ||
	            ch == "{" && (cx.type == "at" || cx.type == "atBlock")) {
	          // Dedent relative to current context.
	          indent = Math.max(0, cx.indent - indentUnit);
	          cx = cx.prev;
	        }
	      }
	      return indent;
	    },
	
	    electricChars: "}",
	    blockCommentStart: "/*",
	    blockCommentEnd: "*/",
	    fold: "brace"
	  };
	});
	
	  function keySet(array) {
	    var keys = {};
	    for (var i = 0; i < array.length; ++i) {
	      keys[array[i]] = true;
	    }
	    return keys;
	  }
	
	  var documentTypes_ = [
	    "domain", "regexp", "url", "url-prefix"
	  ], documentTypes = keySet(documentTypes_);
	
	  var mediaTypes_ = [
	    "all", "aural", "braille", "handheld", "print", "projection", "screen",
	    "tty", "tv", "embossed"
	  ], mediaTypes = keySet(mediaTypes_);
	
	  var mediaFeatures_ = [
	    "width", "min-width", "max-width", "height", "min-height", "max-height",
	    "device-width", "min-device-width", "max-device-width", "device-height",
	    "min-device-height", "max-device-height", "aspect-ratio",
	    "min-aspect-ratio", "max-aspect-ratio", "device-aspect-ratio",
	    "min-device-aspect-ratio", "max-device-aspect-ratio", "color", "min-color",
	    "max-color", "color-index", "min-color-index", "max-color-index",
	    "monochrome", "min-monochrome", "max-monochrome", "resolution",
	    "min-resolution", "max-resolution", "scan", "grid", "orientation",
	    "device-pixel-ratio", "min-device-pixel-ratio", "max-device-pixel-ratio",
	    "pointer", "any-pointer", "hover", "any-hover"
	  ], mediaFeatures = keySet(mediaFeatures_);
	
	  var mediaValueKeywords_ = [
	    "landscape", "portrait", "none", "coarse", "fine", "on-demand", "hover",
	    "interlace", "progressive"
	  ], mediaValueKeywords = keySet(mediaValueKeywords_);
	
	  var propertyKeywords_ = [
	    "align-content", "align-items", "align-self", "alignment-adjust",
	    "alignment-baseline", "anchor-point", "animation", "animation-delay",
	    "animation-direction", "animation-duration", "animation-fill-mode",
	    "animation-iteration-count", "animation-name", "animation-play-state",
	    "animation-timing-function", "appearance", "azimuth", "backface-visibility",
	    "background", "background-attachment", "background-blend-mode", "background-clip",
	    "background-color", "background-image", "background-origin", "background-position",
	    "background-repeat", "background-size", "baseline-shift", "binding",
	    "bleed", "bookmark-label", "bookmark-level", "bookmark-state",
	    "bookmark-target", "border", "border-bottom", "border-bottom-color",
	    "border-bottom-left-radius", "border-bottom-right-radius",
	    "border-bottom-style", "border-bottom-width", "border-collapse",
	    "border-color", "border-image", "border-image-outset",
	    "border-image-repeat", "border-image-slice", "border-image-source",
	    "border-image-width", "border-left", "border-left-color",
	    "border-left-style", "border-left-width", "border-radius", "border-right",
	    "border-right-color", "border-right-style", "border-right-width",
	    "border-spacing", "border-style", "border-top", "border-top-color",
	    "border-top-left-radius", "border-top-right-radius", "border-top-style",
	    "border-top-width", "border-width", "bottom", "box-decoration-break",
	    "box-shadow", "box-sizing", "break-after", "break-before", "break-inside",
	    "caption-side", "clear", "clip", "color", "color-profile", "column-count",
	    "column-fill", "column-gap", "column-rule", "column-rule-color",
	    "column-rule-style", "column-rule-width", "column-span", "column-width",
	    "columns", "content", "counter-increment", "counter-reset", "crop", "cue",
	    "cue-after", "cue-before", "cursor", "direction", "display",
	    "dominant-baseline", "drop-initial-after-adjust",
	    "drop-initial-after-align", "drop-initial-before-adjust",
	    "drop-initial-before-align", "drop-initial-size", "drop-initial-value",
	    "elevation", "empty-cells", "fit", "fit-position", "flex", "flex-basis",
	    "flex-direction", "flex-flow", "flex-grow", "flex-shrink", "flex-wrap",
	    "float", "float-offset", "flow-from", "flow-into", "font", "font-feature-settings",
	    "font-family", "font-kerning", "font-language-override", "font-size", "font-size-adjust",
	    "font-stretch", "font-style", "font-synthesis", "font-variant",
	    "font-variant-alternates", "font-variant-caps", "font-variant-east-asian",
	    "font-variant-ligatures", "font-variant-numeric", "font-variant-position",
	    "font-weight", "grid", "grid-area", "grid-auto-columns", "grid-auto-flow",
	    "grid-auto-rows", "grid-column", "grid-column-end", "grid-column-gap",
	    "grid-column-start", "grid-gap", "grid-row", "grid-row-end", "grid-row-gap",
	    "grid-row-start", "grid-template", "grid-template-areas", "grid-template-columns",
	    "grid-template-rows", "hanging-punctuation", "height", "hyphens",
	    "icon", "image-orientation", "image-rendering", "image-resolution",
	    "inline-box-align", "justify-content", "left", "letter-spacing",
	    "line-break", "line-height", "line-stacking", "line-stacking-ruby",
	    "line-stacking-shift", "line-stacking-strategy", "list-style",
	    "list-style-image", "list-style-position", "list-style-type", "margin",
	    "margin-bottom", "margin-left", "margin-right", "margin-top",
	    "marker-offset", "marks", "marquee-direction", "marquee-loop",
	    "marquee-play-count", "marquee-speed", "marquee-style", "max-height",
	    "max-width", "min-height", "min-width", "move-to", "nav-down", "nav-index",
	    "nav-left", "nav-right", "nav-up", "object-fit", "object-position",
	    "opacity", "order", "orphans", "outline",
	    "outline-color", "outline-offset", "outline-style", "outline-width",
	    "overflow", "overflow-style", "overflow-wrap", "overflow-x", "overflow-y",
	    "padding", "padding-bottom", "padding-left", "padding-right", "padding-top",
	    "page", "page-break-after", "page-break-before", "page-break-inside",
	    "page-policy", "pause", "pause-after", "pause-before", "perspective",
	    "perspective-origin", "pitch", "pitch-range", "play-during", "position",
	    "presentation-level", "punctuation-trim", "quotes", "region-break-after",
	    "region-break-before", "region-break-inside", "region-fragment",
	    "rendering-intent", "resize", "rest", "rest-after", "rest-before", "richness",
	    "right", "rotation", "rotation-point", "ruby-align", "ruby-overhang",
	    "ruby-position", "ruby-span", "shape-image-threshold", "shape-inside", "shape-margin",
	    "shape-outside", "size", "speak", "speak-as", "speak-header",
	    "speak-numeral", "speak-punctuation", "speech-rate", "stress", "string-set",
	    "tab-size", "table-layout", "target", "target-name", "target-new",
	    "target-position", "text-align", "text-align-last", "text-decoration",
	    "text-decoration-color", "text-decoration-line", "text-decoration-skip",
	    "text-decoration-style", "text-emphasis", "text-emphasis-color",
	    "text-emphasis-position", "text-emphasis-style", "text-height",
	    "text-indent", "text-justify", "text-outline", "text-overflow", "text-shadow",
	    "text-size-adjust", "text-space-collapse", "text-transform", "text-underline-position",
	    "text-wrap", "top", "transform", "transform-origin", "transform-style",
	    "transition", "transition-delay", "transition-duration",
	    "transition-property", "transition-timing-function", "unicode-bidi",
	    "vertical-align", "visibility", "voice-balance", "voice-duration",
	    "voice-family", "voice-pitch", "voice-range", "voice-rate", "voice-stress",
	    "voice-volume", "volume", "white-space", "widows", "width", "word-break",
	    "word-spacing", "word-wrap", "z-index",
	    // SVG-specific
	    "clip-path", "clip-rule", "mask", "enable-background", "filter", "flood-color",
	    "flood-opacity", "lighting-color", "stop-color", "stop-opacity", "pointer-events",
	    "color-interpolation", "color-interpolation-filters",
	    "color-rendering", "fill", "fill-opacity", "fill-rule", "image-rendering",
	    "marker", "marker-end", "marker-mid", "marker-start", "shape-rendering", "stroke",
	    "stroke-dasharray", "stroke-dashoffset", "stroke-linecap", "stroke-linejoin",
	    "stroke-miterlimit", "stroke-opacity", "stroke-width", "text-rendering",
	    "baseline-shift", "dominant-baseline", "glyph-orientation-horizontal",
	    "glyph-orientation-vertical", "text-anchor", "writing-mode"
	  ], propertyKeywords = keySet(propertyKeywords_);
	
	  var nonStandardPropertyKeywords_ = [
	    "scrollbar-arrow-color", "scrollbar-base-color", "scrollbar-dark-shadow-color",
	    "scrollbar-face-color", "scrollbar-highlight-color", "scrollbar-shadow-color",
	    "scrollbar-3d-light-color", "scrollbar-track-color", "shape-inside",
	    "searchfield-cancel-button", "searchfield-decoration", "searchfield-results-button",
	    "searchfield-results-decoration", "zoom"
	  ], nonStandardPropertyKeywords = keySet(nonStandardPropertyKeywords_);
	
	  var fontProperties_ = [
	    "font-family", "src", "unicode-range", "font-variant", "font-feature-settings",
	    "font-stretch", "font-weight", "font-style"
	  ], fontProperties = keySet(fontProperties_);
	
	  var counterDescriptors_ = [
	    "additive-symbols", "fallback", "negative", "pad", "prefix", "range",
	    "speak-as", "suffix", "symbols", "system"
	  ], counterDescriptors = keySet(counterDescriptors_);
	
	  var colorKeywords_ = [
	    "aliceblue", "antiquewhite", "aqua", "aquamarine", "azure", "beige",
	    "bisque", "black", "blanchedalmond", "blue", "blueviolet", "brown",
	    "burlywood", "cadetblue", "chartreuse", "chocolate", "coral", "cornflowerblue",
	    "cornsilk", "crimson", "cyan", "darkblue", "darkcyan", "darkgoldenrod",
	    "darkgray", "darkgreen", "darkkhaki", "darkmagenta", "darkolivegreen",
	    "darkorange", "darkorchid", "darkred", "darksalmon", "darkseagreen",
	    "darkslateblue", "darkslategray", "darkturquoise", "darkviolet",
	    "deeppink", "deepskyblue", "dimgray", "dodgerblue", "firebrick",
	    "floralwhite", "forestgreen", "fuchsia", "gainsboro", "ghostwhite",
	    "gold", "goldenrod", "gray", "grey", "green", "greenyellow", "honeydew",
	    "hotpink", "indianred", "indigo", "ivory", "khaki", "lavender",
	    "lavenderblush", "lawngreen", "lemonchiffon", "lightblue", "lightcoral",
	    "lightcyan", "lightgoldenrodyellow", "lightgray", "lightgreen", "lightpink",
	    "lightsalmon", "lightseagreen", "lightskyblue", "lightslategray",
	    "lightsteelblue", "lightyellow", "lime", "limegreen", "linen", "magenta",
	    "maroon", "mediumaquamarine", "mediumblue", "mediumorchid", "mediumpurple",
	    "mediumseagreen", "mediumslateblue", "mediumspringgreen", "mediumturquoise",
	    "mediumvioletred", "midnightblue", "mintcream", "mistyrose", "moccasin",
	    "navajowhite", "navy", "oldlace", "olive", "olivedrab", "orange", "orangered",
	    "orchid", "palegoldenrod", "palegreen", "paleturquoise", "palevioletred",
	    "papayawhip", "peachpuff", "peru", "pink", "plum", "powderblue",
	    "purple", "rebeccapurple", "red", "rosybrown", "royalblue", "saddlebrown",
	    "salmon", "sandybrown", "seagreen", "seashell", "sienna", "silver", "skyblue",
	    "slateblue", "slategray", "snow", "springgreen", "steelblue", "tan",
	    "teal", "thistle", "tomato", "turquoise", "violet", "wheat", "white",
	    "whitesmoke", "yellow", "yellowgreen"
	  ], colorKeywords = keySet(colorKeywords_);
	
	  var valueKeywords_ = [
	    "above", "absolute", "activeborder", "additive", "activecaption", "afar",
	    "after-white-space", "ahead", "alias", "all", "all-scroll", "alphabetic", "alternate",
	    "always", "amharic", "amharic-abegede", "antialiased", "appworkspace",
	    "arabic-indic", "armenian", "asterisks", "attr", "auto", "avoid", "avoid-column", "avoid-page",
	    "avoid-region", "background", "backwards", "baseline", "below", "bidi-override", "binary",
	    "bengali", "blink", "block", "block-axis", "bold", "bolder", "border", "border-box",
	    "both", "bottom", "break", "break-all", "break-word", "bullets", "button", "button-bevel",
	    "buttonface", "buttonhighlight", "buttonshadow", "buttontext", "calc", "cambodian",
	    "capitalize", "caps-lock-indicator", "caption", "captiontext", "caret",
	    "cell", "center", "checkbox", "circle", "cjk-decimal", "cjk-earthly-branch",
	    "cjk-heavenly-stem", "cjk-ideographic", "clear", "clip", "close-quote",
	    "col-resize", "collapse", "color", "color-burn", "color-dodge", "column", "column-reverse",
	    "compact", "condensed", "contain", "content",
	    "content-box", "context-menu", "continuous", "copy", "counter", "counters", "cover", "crop",
	    "cross", "crosshair", "currentcolor", "cursive", "cyclic", "darken", "dashed", "decimal",
	    "decimal-leading-zero", "default", "default-button", "dense", "destination-atop",
	    "destination-in", "destination-out", "destination-over", "devanagari", "difference",
	    "disc", "discard", "disclosure-closed", "disclosure-open", "document",
	    "dot-dash", "dot-dot-dash",
	    "dotted", "double", "down", "e-resize", "ease", "ease-in", "ease-in-out", "ease-out",
	    "element", "ellipse", "ellipsis", "embed", "end", "ethiopic", "ethiopic-abegede",
	    "ethiopic-abegede-am-et", "ethiopic-abegede-gez", "ethiopic-abegede-ti-er",
	    "ethiopic-abegede-ti-et", "ethiopic-halehame-aa-er",
	    "ethiopic-halehame-aa-et", "ethiopic-halehame-am-et",
	    "ethiopic-halehame-gez", "ethiopic-halehame-om-et",
	    "ethiopic-halehame-sid-et", "ethiopic-halehame-so-et",
	    "ethiopic-halehame-ti-er", "ethiopic-halehame-ti-et", "ethiopic-halehame-tig",
	    "ethiopic-numeric", "ew-resize", "exclusion", "expanded", "extends", "extra-condensed",
	    "extra-expanded", "fantasy", "fast", "fill", "fixed", "flat", "flex", "flex-end", "flex-start", "footnotes",
	    "forwards", "from", "geometricPrecision", "georgian", "graytext", "grid", "groove",
	    "gujarati", "gurmukhi", "hand", "hangul", "hangul-consonant", "hard-light", "hebrew",
	    "help", "hidden", "hide", "higher", "highlight", "highlighttext",
	    "hiragana", "hiragana-iroha", "horizontal", "hsl", "hsla", "hue", "icon", "ignore",
	    "inactiveborder", "inactivecaption", "inactivecaptiontext", "infinite",
	    "infobackground", "infotext", "inherit", "initial", "inline", "inline-axis",
	    "inline-block", "inline-flex", "inline-grid", "inline-table", "inset", "inside", "intrinsic", "invert",
	    "italic", "japanese-formal", "japanese-informal", "justify", "kannada",
	    "katakana", "katakana-iroha", "keep-all", "khmer",
	    "korean-hangul-formal", "korean-hanja-formal", "korean-hanja-informal",
	    "landscape", "lao", "large", "larger", "left", "level", "lighter", "lighten",
	    "line-through", "linear", "linear-gradient", "lines", "list-item", "listbox", "listitem",
	    "local", "logical", "loud", "lower", "lower-alpha", "lower-armenian",
	    "lower-greek", "lower-hexadecimal", "lower-latin", "lower-norwegian",
	    "lower-roman", "lowercase", "ltr", "luminosity", "malayalam", "match", "matrix", "matrix3d",
	    "media-controls-background", "media-current-time-display",
	    "media-fullscreen-button", "media-mute-button", "media-play-button",
	    "media-return-to-realtime-button", "media-rewind-button",
	    "media-seek-back-button", "media-seek-forward-button", "media-slider",
	    "media-sliderthumb", "media-time-remaining-display", "media-volume-slider",
	    "media-volume-slider-container", "media-volume-sliderthumb", "medium",
	    "menu", "menulist", "menulist-button", "menulist-text",
	    "menulist-textfield", "menutext", "message-box", "middle", "min-intrinsic",
	    "mix", "mongolian", "monospace", "move", "multiple", "multiply", "myanmar", "n-resize",
	    "narrower", "ne-resize", "nesw-resize", "no-close-quote", "no-drop",
	    "no-open-quote", "no-repeat", "none", "normal", "not-allowed", "nowrap",
	    "ns-resize", "numbers", "numeric", "nw-resize", "nwse-resize", "oblique", "octal", "open-quote",
	    "optimizeLegibility", "optimizeSpeed", "oriya", "oromo", "outset",
	    "outside", "outside-shape", "overlay", "overline", "padding", "padding-box",
	    "painted", "page", "paused", "persian", "perspective", "plus-darker", "plus-lighter",
	    "pointer", "polygon", "portrait", "pre", "pre-line", "pre-wrap", "preserve-3d",
	    "progress", "push-button", "radial-gradient", "radio", "read-only",
	    "read-write", "read-write-plaintext-only", "rectangle", "region",
	    "relative", "repeat", "repeating-linear-gradient",
	    "repeating-radial-gradient", "repeat-x", "repeat-y", "reset", "reverse",
	    "rgb", "rgba", "ridge", "right", "rotate", "rotate3d", "rotateX", "rotateY",
	    "rotateZ", "round", "row", "row-resize", "row-reverse", "rtl", "run-in", "running",
	    "s-resize", "sans-serif", "saturation", "scale", "scale3d", "scaleX", "scaleY", "scaleZ", "screen",
	    "scroll", "scrollbar", "se-resize", "searchfield",
	    "searchfield-cancel-button", "searchfield-decoration",
	    "searchfield-results-button", "searchfield-results-decoration",
	    "semi-condensed", "semi-expanded", "separate", "serif", "show", "sidama",
	    "simp-chinese-formal", "simp-chinese-informal", "single",
	    "skew", "skewX", "skewY", "skip-white-space", "slide", "slider-horizontal",
	    "slider-vertical", "sliderthumb-horizontal", "sliderthumb-vertical", "slow",
	    "small", "small-caps", "small-caption", "smaller", "soft-light", "solid", "somali",
	    "source-atop", "source-in", "source-out", "source-over", "space", "space-around", "space-between", "spell-out", "square",
	    "square-button", "start", "static", "status-bar", "stretch", "stroke", "sub",
	    "subpixel-antialiased", "super", "sw-resize", "symbolic", "symbols", "table",
	    "table-caption", "table-cell", "table-column", "table-column-group",
	    "table-footer-group", "table-header-group", "table-row", "table-row-group",
	    "tamil",
	    "telugu", "text", "text-bottom", "text-top", "textarea", "textfield", "thai",
	    "thick", "thin", "threeddarkshadow", "threedface", "threedhighlight",
	    "threedlightshadow", "threedshadow", "tibetan", "tigre", "tigrinya-er",
	    "tigrinya-er-abegede", "tigrinya-et", "tigrinya-et-abegede", "to", "top",
	    "trad-chinese-formal", "trad-chinese-informal",
	    "translate", "translate3d", "translateX", "translateY", "translateZ",
	    "transparent", "ultra-condensed", "ultra-expanded", "underline", "up",
	    "upper-alpha", "upper-armenian", "upper-greek", "upper-hexadecimal",
	    "upper-latin", "upper-norwegian", "upper-roman", "uppercase", "urdu", "url",
	    "var", "vertical", "vertical-text", "visible", "visibleFill", "visiblePainted",
	    "visibleStroke", "visual", "w-resize", "wait", "wave", "wider",
	    "window", "windowframe", "windowtext", "words", "wrap", "wrap-reverse", "x-large", "x-small", "xor",
	    "xx-large", "xx-small"
	  ], valueKeywords = keySet(valueKeywords_);
	
	  var allWords = documentTypes_.concat(mediaTypes_).concat(mediaFeatures_).concat(mediaValueKeywords_)
	    .concat(propertyKeywords_).concat(nonStandardPropertyKeywords_).concat(colorKeywords_)
	    .concat(valueKeywords_);
	  CodeMirror.registerHelper("hintWords", "css", allWords);
	
	  function tokenCComment(stream, state) {
	    var maybeEnd = false, ch;
	    while ((ch = stream.next()) != null) {
	      if (maybeEnd && ch == "/") {
	        state.tokenize = null;
	        break;
	      }
	      maybeEnd = (ch == "*");
	    }
	    return ["comment", "comment"];
	  }
	
	  CodeMirror.defineMIME("text/css", {
	    documentTypes: documentTypes,
	    mediaTypes: mediaTypes,
	    mediaFeatures: mediaFeatures,
	    mediaValueKeywords: mediaValueKeywords,
	    propertyKeywords: propertyKeywords,
	    nonStandardPropertyKeywords: nonStandardPropertyKeywords,
	    fontProperties: fontProperties,
	    counterDescriptors: counterDescriptors,
	    colorKeywords: colorKeywords,
	    valueKeywords: valueKeywords,
	    tokenHooks: {
	      "/": function(stream, state) {
	        if (!stream.eat("*")) return false;
	        state.tokenize = tokenCComment;
	        return tokenCComment(stream, state);
	      }
	    },
	    name: "css"
	  });
	
	  CodeMirror.defineMIME("text/x-scss", {
	    mediaTypes: mediaTypes,
	    mediaFeatures: mediaFeatures,
	    mediaValueKeywords: mediaValueKeywords,
	    propertyKeywords: propertyKeywords,
	    nonStandardPropertyKeywords: nonStandardPropertyKeywords,
	    colorKeywords: colorKeywords,
	    valueKeywords: valueKeywords,
	    fontProperties: fontProperties,
	    allowNested: true,
	    tokenHooks: {
	      "/": function(stream, state) {
	        if (stream.eat("/")) {
	          stream.skipToEnd();
	          return ["comment", "comment"];
	        } else if (stream.eat("*")) {
	          state.tokenize = tokenCComment;
	          return tokenCComment(stream, state);
	        } else {
	          return ["operator", "operator"];
	        }
	      },
	      ":": function(stream) {
	        if (stream.match(/\s*\{/))
	          return [null, "{"];
	        return false;
	      },
	      "$": function(stream) {
	        stream.match(/^[\w-]+/);
	        if (stream.match(/^\s*:/, false))
	          return ["variable-2", "variable-definition"];
	        return ["variable-2", "variable"];
	      },
	      "#": function(stream) {
	        if (!stream.eat("{")) return false;
	        return [null, "interpolation"];
	      }
	    },
	    name: "css",
	    helperType: "scss"
	  });
	
	  CodeMirror.defineMIME("text/x-less", {
	    mediaTypes: mediaTypes,
	    mediaFeatures: mediaFeatures,
	    mediaValueKeywords: mediaValueKeywords,
	    propertyKeywords: propertyKeywords,
	    nonStandardPropertyKeywords: nonStandardPropertyKeywords,
	    colorKeywords: colorKeywords,
	    valueKeywords: valueKeywords,
	    fontProperties: fontProperties,
	    allowNested: true,
	    tokenHooks: {
	      "/": function(stream, state) {
	        if (stream.eat("/")) {
	          stream.skipToEnd();
	          return ["comment", "comment"];
	        } else if (stream.eat("*")) {
	          state.tokenize = tokenCComment;
	          return tokenCComment(stream, state);
	        } else {
	          return ["operator", "operator"];
	        }
	      },
	      "@": function(stream) {
	        if (stream.eat("{")) return [null, "interpolation"];
	        if (stream.match(/^(charset|document|font-face|import|(-(moz|ms|o|webkit)-)?keyframes|media|namespace|page|supports)\b/, false)) return false;
	        stream.eatWhile(/[\w\\\-]/);
	        if (stream.match(/^\s*:/, false))
	          return ["variable-2", "variable-definition"];
	        return ["variable-2", "variable"];
	      },
	      "&": function() {
	        return ["atom", "atom"];
	      }
	    },
	    name: "css",
	    helperType: "less"
	  });
	
	  CodeMirror.defineMIME("text/x-gss", {
	    documentTypes: documentTypes,
	    mediaTypes: mediaTypes,
	    mediaFeatures: mediaFeatures,
	    propertyKeywords: propertyKeywords,
	    nonStandardPropertyKeywords: nonStandardPropertyKeywords,
	    fontProperties: fontProperties,
	    counterDescriptors: counterDescriptors,
	    colorKeywords: colorKeywords,
	    valueKeywords: valueKeywords,
	    supportsAtComponent: true,
	    tokenHooks: {
	      "/": function(stream, state) {
	        if (!stream.eat("*")) return false;
	        state.tokenize = tokenCComment;
	        return tokenCComment(stream, state);
	      }
	    },
	    name: "css",
	    helperType: "gss"
	  });
	
	});


/***/ }),
/* 2169 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactQuill = __webpack_require__(2170);
	
	var _reactQuill2 = _interopRequireDefault(_reactQuill);
	
	var _cloneDeep = __webpack_require__(1189);
	
	var _cloneDeep2 = _interopRequireDefault(_cloneDeep);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DEBUG_EDITOR = false;
	
	//BEGIN allow image alignment styles
	var ImageFormatAttributesList = ["alt", "height", "width", "style"];
	var BaseImageFormat = _reactQuill.Quill.import("formats/image");
	
	var ImageFormat = function (_BaseImageFormat) {
	  _inherits(ImageFormat, _BaseImageFormat);
	
	  function ImageFormat() {
	    _classCallCheck(this, ImageFormat);
	
	    return _possibleConstructorReturn(this, Object.getPrototypeOf(ImageFormat).apply(this, arguments));
	  }
	
	  _createClass(ImageFormat, [{
	    key: "format",
	    value: function format(name, value) {
	      if (ImageFormatAttributesList.indexOf(name) > -1) {
	        if (value) {
	          this.domNode.setAttribute(name, value);
	        } else {
	          this.domNode.removeAttribute(name);
	        }
	      } else {
	        _get(Object.getPrototypeOf(ImageFormat.prototype), "format", this).call(this, name, value);
	      }
	    }
	  }], [{
	    key: "create",
	    value: function create(value) {
	      var node = _get(Object.getPrototypeOf(ImageFormat), "create", this).call(this, value);
	      if (typeof value === "string") {
	        node.setAttribute("src", this.sanitize(value));
	      }
	      return node;
	    }
	  }, {
	    key: "formats",
	    value: function formats(domNode) {
	      return ImageFormatAttributesList.reduce(function (formats, attribute) {
	        if (domNode.hasAttribute(attribute)) {
	          formats[attribute] = domNode.getAttribute(attribute);
	        }
	        return formats;
	      }, {});
	    }
	  }]);
	
	  return ImageFormat;
	}(BaseImageFormat);
	
	_reactQuill.Quill.register(ImageFormat, true);
	//END allow image alignment styles
	
	var ImageResize = __webpack_require__(2186).default;
	_reactQuill.Quill.register("modules/imageResize", ImageResize);
	
	var STYLES = {
	  quillTip: {
	    fontSize: 10,
	    lineHeight: "13px",
	    marginTop: 5
	  }
	};
	
	var STANDARD_FORMATS = ["background", "bold", "color", "code", "italic", "link", "size", "strike", "script", "underline", "blockquote", "header", "indent", "list", "bullet", "align", "direction", "code-block", "formula", "image", "video", "style", "width"];
	
	var STANDARD_MODULES = {
	  toolbar: [[{ size: [] }, { align: [] }], ["bold", "italic", "strike", "underline", { color: [] }, { background: [] }, "link"], [{ list: "ordered" }, { list: "bullet" }, { indent: "-1" }, { indent: "+1" }], ["image"], ["clean"]],
	  clipboard: {
	    matchVisual: false
	  },
	  imageResize: {}
	};
	
	var BASIC_FORMATS = ["bold", "italic", "strike", "underline", "link", "image", "video", "style", "width"];
	
	var BASIC_MODULES = {
	  toolbar: [["bold", "italic", "strike", "underline", "link", "clean"]],
	  clipboard: {
	    matchVisual: false
	  },
	  imageResize: {}
	};
	
	var QuillEditor = function (_React$Component) {
	  _inherits(QuillEditor, _React$Component);
	
	  function QuillEditor(props) {
	    _classCallCheck(this, QuillEditor);
	
	    // The Quill Editor sometimes auto-modifies its `value` when it first receives it.
	    // This can be problematic, as for example it modifies style attribute order and adds
	    // additional props to some tags that our XSS filter later removes, which then means that
	    // anytime someone loads the page, the Save Changes button will be enabled and the editor
	    // will be marked as dirty, even though the person never edited anything. So we wait a bit
	    // whenever the value changes before accepting QuillEditor onChange events.
	    // Ref: https://eventiveteam.slack.com/archives/C018EML35BR/p1629243984102100
	    var _this2 = _possibleConstructorReturn(this, Object.getPrototypeOf(QuillEditor).call(this, props));
	
	    _this2.hasLoaded = false;
	
	    _this2.onChange = _this2.onChange.bind(_this2);
	    return _this2;
	  }
	
	  _createClass(QuillEditor, [{
	    key: "onChange",
	    value: function onChange(value, delta, source, editor) {
	      DEBUG_EDITOR && console.log("QuillEditor: onChange", "source=", source);
	      if (!this.hasLoaded) {
	        DEBUG_EDITOR && console.log(" * skipping onChange bc hasLoaded=false");
	        return;
	      }
	
	      var html = editor.getHTML();
	
	      // Sanitize for diffing
	      html = html.replace(/style=""\s*/g, "");
	
	      // If the editor is empty, save just an empty string to the database,
	      // not the <p><br></p> stub that is generated by quill
	      // Santize empty input if santizeEmpty is set
	      if (this.props.sanitizeEmpty && editor.getLength() === 1) {
	        this.lastValue = html;
	        this.props.onChange("");
	      }
	
	      DEBUG_EDITOR && console.log("QuillEditor:  * firing onChange bc hasLoaded=true");
	      this.lastValue = html;
	      this.props.onChange(html);
	    }
	  }, {
	    key: "_delayMarkLoaded",
	    value: function _delayMarkLoaded() {
	      var _this3 = this;
	
	      clearTimeout(this.loadingTimeout);
	      this.loadingTimeout = setTimeout(function () {
	        DEBUG_EDITOR && console.log("QuillEditor: hasLoaded=true");
	        _this3.hasLoaded = true;
	      }, 100);
	    }
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this._delayMarkLoaded();
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(newProps) {
	      if (newProps.value !== this.props.value && (!this.lastValue || newProps.value !== this.lastValue)) {
	        DEBUG_EDITOR && console.log("QuillEditor: hasLoaded=false");
	        this.hasLoaded = false;
	        this._delayMarkLoaded();
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _props = this.props;
	      var _ = _props.onChange;
	      var value = _props.value;
	      var basic = _props.basic;
	      var withImages = _props.withImages;
	      var formats = _props.formats;
	      var inlineBasicOnly = _props.inlineBasicOnly;
	      var tipStyle = _props.tipStyle;
	
	      var rest = _objectWithoutProperties(_props, ["onChange", "value", "basic", "withImages", "formats", "inlineBasicOnly", "tipStyle"]);
	
	      basic = basic || inlineBasicOnly;
	      formats = formats || [];
	
	      var modules = (0, _cloneDeep2.default)(basic ? BASIC_MODULES : STANDARD_MODULES);
	      if (withImages && basic) {
	        modules.toolbar[0].splice(modules.toolbar[0].length - 1, 0, "image");
	      }
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(_reactQuill2.default, _extends({
	          theme: "snow",
	          value: value || "",
	          formats: (basic ? BASIC_FORMATS : STANDARD_FORMATS).concat(formats),
	          modules: modules,
	          onChange: this.onChange
	        }, rest)),
	        !basic && _react2.default.createElement(
	          "div",
	          { style: Object.assign({}, STYLES.quillTip, tipStyle) },
	          "Tip: Trying to paste without formatting? Use \u2318-Shift-V (Ctrl-Shift-V for PC) instead of the normal \u2318-V and Ctrl-V."
	        )
	      );
	    }
	  }]);
	
	  return QuillEditor;
	}(_react2.default.Component);
	
	exports.default = QuillEditor;
	module.exports = exports["default"];

/***/ }),
/* 2170 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	React-Quill v1.0.0
	https://github.com/zenoamaro/react-quill
	*/
	var Quill = __webpack_require__(2171);
	var Component = __webpack_require__(2172);
	
	module.exports = Component;
	module.exports.default = Component;
	module.exports.Quill = Quill;
	module.exports.Mixin = __webpack_require__(2177);
	module.exports.Toolbar = __webpack_require__(2181);


/***/ }),
/* 2171 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {/*!
	 * Quill Editor v1.3.7
	 * https://quilljs.com/
	 * Copyright (c) 2014, Jason Chen
	 * Copyright (c) 2013, salesforce.com
	 */
	(function webpackUniversalModuleDefinition(root, factory) {
		if(true)
			module.exports = factory();
		else if(typeof define === 'function' && define.amd)
			define([], factory);
		else if(typeof exports === 'object')
			exports["Quill"] = factory();
		else
			root["Quill"] = factory();
	})(typeof self !== 'undefined' ? self : this, function() {
	return /******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	/******/
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	/******/
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId]) {
	/******/ 			return installedModules[moduleId].exports;
	/******/ 		}
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			i: moduleId,
	/******/ 			l: false,
	/******/ 			exports: {}
	/******/ 		};
	/******/
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	/******/
	/******/ 		// Flag the module as loaded
	/******/ 		module.l = true;
	/******/
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	/******/
	/******/
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	/******/
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	/******/
	/******/ 	// define getter function for harmony exports
	/******/ 	__webpack_require__.d = function(exports, name, getter) {
	/******/ 		if(!__webpack_require__.o(exports, name)) {
	/******/ 			Object.defineProperty(exports, name, {
	/******/ 				configurable: false,
	/******/ 				enumerable: true,
	/******/ 				get: getter
	/******/ 			});
	/******/ 		}
	/******/ 	};
	/******/
	/******/ 	// getDefaultExport function for compatibility with non-harmony modules
	/******/ 	__webpack_require__.n = function(module) {
	/******/ 		var getter = module && module.__esModule ?
	/******/ 			function getDefault() { return module['default']; } :
	/******/ 			function getModuleExports() { return module; };
	/******/ 		__webpack_require__.d(getter, 'a', getter);
	/******/ 		return getter;
	/******/ 	};
	/******/
	/******/ 	// Object.prototype.hasOwnProperty.call
	/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
	/******/
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	/******/
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(__webpack_require__.s = 109);
	/******/ })
	/************************************************************************/
	/******/ ([
	/* 0 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var container_1 = __webpack_require__(17);
	var format_1 = __webpack_require__(18);
	var leaf_1 = __webpack_require__(19);
	var scroll_1 = __webpack_require__(45);
	var inline_1 = __webpack_require__(46);
	var block_1 = __webpack_require__(47);
	var embed_1 = __webpack_require__(48);
	var text_1 = __webpack_require__(49);
	var attributor_1 = __webpack_require__(12);
	var class_1 = __webpack_require__(32);
	var style_1 = __webpack_require__(33);
	var store_1 = __webpack_require__(31);
	var Registry = __webpack_require__(1);
	var Parchment = {
	    Scope: Registry.Scope,
	    create: Registry.create,
	    find: Registry.find,
	    query: Registry.query,
	    register: Registry.register,
	    Container: container_1.default,
	    Format: format_1.default,
	    Leaf: leaf_1.default,
	    Embed: embed_1.default,
	    Scroll: scroll_1.default,
	    Block: block_1.default,
	    Inline: inline_1.default,
	    Text: text_1.default,
	    Attributor: {
	        Attribute: attributor_1.default,
	        Class: class_1.default,
	        Style: style_1.default,
	        Store: store_1.default,
	    },
	};
	exports.default = Parchment;
	
	
	/***/ }),
	/* 1 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var ParchmentError = /** @class */ (function (_super) {
	    __extends(ParchmentError, _super);
	    function ParchmentError(message) {
	        var _this = this;
	        message = '[Parchment] ' + message;
	        _this = _super.call(this, message) || this;
	        _this.message = message;
	        _this.name = _this.constructor.name;
	        return _this;
	    }
	    return ParchmentError;
	}(Error));
	exports.ParchmentError = ParchmentError;
	var attributes = {};
	var classes = {};
	var tags = {};
	var types = {};
	exports.DATA_KEY = '__blot';
	var Scope;
	(function (Scope) {
	    Scope[Scope["TYPE"] = 3] = "TYPE";
	    Scope[Scope["LEVEL"] = 12] = "LEVEL";
	    Scope[Scope["ATTRIBUTE"] = 13] = "ATTRIBUTE";
	    Scope[Scope["BLOT"] = 14] = "BLOT";
	    Scope[Scope["INLINE"] = 7] = "INLINE";
	    Scope[Scope["BLOCK"] = 11] = "BLOCK";
	    Scope[Scope["BLOCK_BLOT"] = 10] = "BLOCK_BLOT";
	    Scope[Scope["INLINE_BLOT"] = 6] = "INLINE_BLOT";
	    Scope[Scope["BLOCK_ATTRIBUTE"] = 9] = "BLOCK_ATTRIBUTE";
	    Scope[Scope["INLINE_ATTRIBUTE"] = 5] = "INLINE_ATTRIBUTE";
	    Scope[Scope["ANY"] = 15] = "ANY";
	})(Scope = exports.Scope || (exports.Scope = {}));
	function create(input, value) {
	    var match = query(input);
	    if (match == null) {
	        throw new ParchmentError("Unable to create " + input + " blot");
	    }
	    var BlotClass = match;
	    var node = 
	    // @ts-ignore
	    input instanceof Node || input['nodeType'] === Node.TEXT_NODE ? input : BlotClass.create(value);
	    return new BlotClass(node, value);
	}
	exports.create = create;
	function find(node, bubble) {
	    if (bubble === void 0) { bubble = false; }
	    if (node == null)
	        return null;
	    // @ts-ignore
	    if (node[exports.DATA_KEY] != null)
	        return node[exports.DATA_KEY].blot;
	    if (bubble)
	        return find(node.parentNode, bubble);
	    return null;
	}
	exports.find = find;
	function query(query, scope) {
	    if (scope === void 0) { scope = Scope.ANY; }
	    var match;
	    if (typeof query === 'string') {
	        match = types[query] || attributes[query];
	        // @ts-ignore
	    }
	    else if (query instanceof Text || query['nodeType'] === Node.TEXT_NODE) {
	        match = types['text'];
	    }
	    else if (typeof query === 'number') {
	        if (query & Scope.LEVEL & Scope.BLOCK) {
	            match = types['block'];
	        }
	        else if (query & Scope.LEVEL & Scope.INLINE) {
	            match = types['inline'];
	        }
	    }
	    else if (query instanceof HTMLElement) {
	        var names = (query.getAttribute('class') || '').split(/\s+/);
	        for (var i in names) {
	            match = classes[names[i]];
	            if (match)
	                break;
	        }
	        match = match || tags[query.tagName];
	    }
	    if (match == null)
	        return null;
	    // @ts-ignore
	    if (scope & Scope.LEVEL & match.scope && scope & Scope.TYPE & match.scope)
	        return match;
	    return null;
	}
	exports.query = query;
	function register() {
	    var Definitions = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        Definitions[_i] = arguments[_i];
	    }
	    if (Definitions.length > 1) {
	        return Definitions.map(function (d) {
	            return register(d);
	        });
	    }
	    var Definition = Definitions[0];
	    if (typeof Definition.blotName !== 'string' && typeof Definition.attrName !== 'string') {
	        throw new ParchmentError('Invalid definition');
	    }
	    else if (Definition.blotName === 'abstract') {
	        throw new ParchmentError('Cannot register abstract class');
	    }
	    types[Definition.blotName || Definition.attrName] = Definition;
	    if (typeof Definition.keyName === 'string') {
	        attributes[Definition.keyName] = Definition;
	    }
	    else {
	        if (Definition.className != null) {
	            classes[Definition.className] = Definition;
	        }
	        if (Definition.tagName != null) {
	            if (Array.isArray(Definition.tagName)) {
	                Definition.tagName = Definition.tagName.map(function (tagName) {
	                    return tagName.toUpperCase();
	                });
	            }
	            else {
	                Definition.tagName = Definition.tagName.toUpperCase();
	            }
	            var tagNames = Array.isArray(Definition.tagName) ? Definition.tagName : [Definition.tagName];
	            tagNames.forEach(function (tag) {
	                if (tags[tag] == null || Definition.className == null) {
	                    tags[tag] = Definition;
	                }
	            });
	        }
	    }
	    return Definition;
	}
	exports.register = register;
	
	
	/***/ }),
	/* 2 */
	/***/ (function(module, exports, __webpack_require__) {
	
	var diff = __webpack_require__(51);
	var equal = __webpack_require__(11);
	var extend = __webpack_require__(3);
	var op = __webpack_require__(20);
	
	
	var NULL_CHARACTER = String.fromCharCode(0);  // Placeholder char for embed in diff()
	
	
	var Delta = function (ops) {
	  // Assume we are given a well formed ops
	  if (Array.isArray(ops)) {
	    this.ops = ops;
	  } else if (ops != null && Array.isArray(ops.ops)) {
	    this.ops = ops.ops;
	  } else {
	    this.ops = [];
	  }
	};
	
	
	Delta.prototype.insert = function (text, attributes) {
	  var newOp = {};
	  if (text.length === 0) return this;
	  newOp.insert = text;
	  if (attributes != null && typeof attributes === 'object' && Object.keys(attributes).length > 0) {
	    newOp.attributes = attributes;
	  }
	  return this.push(newOp);
	};
	
	Delta.prototype['delete'] = function (length) {
	  if (length <= 0) return this;
	  return this.push({ 'delete': length });
	};
	
	Delta.prototype.retain = function (length, attributes) {
	  if (length <= 0) return this;
	  var newOp = { retain: length };
	  if (attributes != null && typeof attributes === 'object' && Object.keys(attributes).length > 0) {
	    newOp.attributes = attributes;
	  }
	  return this.push(newOp);
	};
	
	Delta.prototype.push = function (newOp) {
	  var index = this.ops.length;
	  var lastOp = this.ops[index - 1];
	  newOp = extend(true, {}, newOp);
	  if (typeof lastOp === 'object') {
	    if (typeof newOp['delete'] === 'number' && typeof lastOp['delete'] === 'number') {
	      this.ops[index - 1] = { 'delete': lastOp['delete'] + newOp['delete'] };
	      return this;
	    }
	    // Since it does not matter if we insert before or after deleting at the same index,
	    // always prefer to insert first
	    if (typeof lastOp['delete'] === 'number' && newOp.insert != null) {
	      index -= 1;
	      lastOp = this.ops[index - 1];
	      if (typeof lastOp !== 'object') {
	        this.ops.unshift(newOp);
	        return this;
	      }
	    }
	    if (equal(newOp.attributes, lastOp.attributes)) {
	      if (typeof newOp.insert === 'string' && typeof lastOp.insert === 'string') {
	        this.ops[index - 1] = { insert: lastOp.insert + newOp.insert };
	        if (typeof newOp.attributes === 'object') this.ops[index - 1].attributes = newOp.attributes
	        return this;
	      } else if (typeof newOp.retain === 'number' && typeof lastOp.retain === 'number') {
	        this.ops[index - 1] = { retain: lastOp.retain + newOp.retain };
	        if (typeof newOp.attributes === 'object') this.ops[index - 1].attributes = newOp.attributes
	        return this;
	      }
	    }
	  }
	  if (index === this.ops.length) {
	    this.ops.push(newOp);
	  } else {
	    this.ops.splice(index, 0, newOp);
	  }
	  return this;
	};
	
	Delta.prototype.chop = function () {
	  var lastOp = this.ops[this.ops.length - 1];
	  if (lastOp && lastOp.retain && !lastOp.attributes) {
	    this.ops.pop();
	  }
	  return this;
	};
	
	Delta.prototype.filter = function (predicate) {
	  return this.ops.filter(predicate);
	};
	
	Delta.prototype.forEach = function (predicate) {
	  this.ops.forEach(predicate);
	};
	
	Delta.prototype.map = function (predicate) {
	  return this.ops.map(predicate);
	};
	
	Delta.prototype.partition = function (predicate) {
	  var passed = [], failed = [];
	  this.forEach(function(op) {
	    var target = predicate(op) ? passed : failed;
	    target.push(op);
	  });
	  return [passed, failed];
	};
	
	Delta.prototype.reduce = function (predicate, initial) {
	  return this.ops.reduce(predicate, initial);
	};
	
	Delta.prototype.changeLength = function () {
	  return this.reduce(function (length, elem) {
	    if (elem.insert) {
	      return length + op.length(elem);
	    } else if (elem.delete) {
	      return length - elem.delete;
	    }
	    return length;
	  }, 0);
	};
	
	Delta.prototype.length = function () {
	  return this.reduce(function (length, elem) {
	    return length + op.length(elem);
	  }, 0);
	};
	
	Delta.prototype.slice = function (start, end) {
	  start = start || 0;
	  if (typeof end !== 'number') end = Infinity;
	  var ops = [];
	  var iter = op.iterator(this.ops);
	  var index = 0;
	  while (index < end && iter.hasNext()) {
	    var nextOp;
	    if (index < start) {
	      nextOp = iter.next(start - index);
	    } else {
	      nextOp = iter.next(end - index);
	      ops.push(nextOp);
	    }
	    index += op.length(nextOp);
	  }
	  return new Delta(ops);
	};
	
	
	Delta.prototype.compose = function (other) {
	  var thisIter = op.iterator(this.ops);
	  var otherIter = op.iterator(other.ops);
	  var ops = [];
	  var firstOther = otherIter.peek();
	  if (firstOther != null && typeof firstOther.retain === 'number' && firstOther.attributes == null) {
	    var firstLeft = firstOther.retain;
	    while (thisIter.peekType() === 'insert' && thisIter.peekLength() <= firstLeft) {
	      firstLeft -= thisIter.peekLength();
	      ops.push(thisIter.next());
	    }
	    if (firstOther.retain - firstLeft > 0) {
	      otherIter.next(firstOther.retain - firstLeft);
	    }
	  }
	  var delta = new Delta(ops);
	  while (thisIter.hasNext() || otherIter.hasNext()) {
	    if (otherIter.peekType() === 'insert') {
	      delta.push(otherIter.next());
	    } else if (thisIter.peekType() === 'delete') {
	      delta.push(thisIter.next());
	    } else {
	      var length = Math.min(thisIter.peekLength(), otherIter.peekLength());
	      var thisOp = thisIter.next(length);
	      var otherOp = otherIter.next(length);
	      if (typeof otherOp.retain === 'number') {
	        var newOp = {};
	        if (typeof thisOp.retain === 'number') {
	          newOp.retain = length;
	        } else {
	          newOp.insert = thisOp.insert;
	        }
	        // Preserve null when composing with a retain, otherwise remove it for inserts
	        var attributes = op.attributes.compose(thisOp.attributes, otherOp.attributes, typeof thisOp.retain === 'number');
	        if (attributes) newOp.attributes = attributes;
	        delta.push(newOp);
	
	        // Optimization if rest of other is just retain
	        if (!otherIter.hasNext() && equal(delta.ops[delta.ops.length - 1], newOp)) {
	          var rest = new Delta(thisIter.rest());
	          return delta.concat(rest).chop();
	        }
	
	      // Other op should be delete, we could be an insert or retain
	      // Insert + delete cancels out
	      } else if (typeof otherOp['delete'] === 'number' && typeof thisOp.retain === 'number') {
	        delta.push(otherOp);
	      }
	    }
	  }
	  return delta.chop();
	};
	
	Delta.prototype.concat = function (other) {
	  var delta = new Delta(this.ops.slice());
	  if (other.ops.length > 0) {
	    delta.push(other.ops[0]);
	    delta.ops = delta.ops.concat(other.ops.slice(1));
	  }
	  return delta;
	};
	
	Delta.prototype.diff = function (other, index) {
	  if (this.ops === other.ops) {
	    return new Delta();
	  }
	  var strings = [this, other].map(function (delta) {
	    return delta.map(function (op) {
	      if (op.insert != null) {
	        return typeof op.insert === 'string' ? op.insert : NULL_CHARACTER;
	      }
	      var prep = (delta === other) ? 'on' : 'with';
	      throw new Error('diff() called ' + prep + ' non-document');
	    }).join('');
	  });
	  var delta = new Delta();
	  var diffResult = diff(strings[0], strings[1], index);
	  var thisIter = op.iterator(this.ops);
	  var otherIter = op.iterator(other.ops);
	  diffResult.forEach(function (component) {
	    var length = component[1].length;
	    while (length > 0) {
	      var opLength = 0;
	      switch (component[0]) {
	        case diff.INSERT:
	          opLength = Math.min(otherIter.peekLength(), length);
	          delta.push(otherIter.next(opLength));
	          break;
	        case diff.DELETE:
	          opLength = Math.min(length, thisIter.peekLength());
	          thisIter.next(opLength);
	          delta['delete'](opLength);
	          break;
	        case diff.EQUAL:
	          opLength = Math.min(thisIter.peekLength(), otherIter.peekLength(), length);
	          var thisOp = thisIter.next(opLength);
	          var otherOp = otherIter.next(opLength);
	          if (equal(thisOp.insert, otherOp.insert)) {
	            delta.retain(opLength, op.attributes.diff(thisOp.attributes, otherOp.attributes));
	          } else {
	            delta.push(otherOp)['delete'](opLength);
	          }
	          break;
	      }
	      length -= opLength;
	    }
	  });
	  return delta.chop();
	};
	
	Delta.prototype.eachLine = function (predicate, newline) {
	  newline = newline || '\n';
	  var iter = op.iterator(this.ops);
	  var line = new Delta();
	  var i = 0;
	  while (iter.hasNext()) {
	    if (iter.peekType() !== 'insert') return;
	    var thisOp = iter.peek();
	    var start = op.length(thisOp) - iter.peekLength();
	    var index = typeof thisOp.insert === 'string' ?
	      thisOp.insert.indexOf(newline, start) - start : -1;
	    if (index < 0) {
	      line.push(iter.next());
	    } else if (index > 0) {
	      line.push(iter.next(index));
	    } else {
	      if (predicate(line, iter.next(1).attributes || {}, i) === false) {
	        return;
	      }
	      i += 1;
	      line = new Delta();
	    }
	  }
	  if (line.length() > 0) {
	    predicate(line, {}, i);
	  }
	};
	
	Delta.prototype.transform = function (other, priority) {
	  priority = !!priority;
	  if (typeof other === 'number') {
	    return this.transformPosition(other, priority);
	  }
	  var thisIter = op.iterator(this.ops);
	  var otherIter = op.iterator(other.ops);
	  var delta = new Delta();
	  while (thisIter.hasNext() || otherIter.hasNext()) {
	    if (thisIter.peekType() === 'insert' && (priority || otherIter.peekType() !== 'insert')) {
	      delta.retain(op.length(thisIter.next()));
	    } else if (otherIter.peekType() === 'insert') {
	      delta.push(otherIter.next());
	    } else {
	      var length = Math.min(thisIter.peekLength(), otherIter.peekLength());
	      var thisOp = thisIter.next(length);
	      var otherOp = otherIter.next(length);
	      if (thisOp['delete']) {
	        // Our delete either makes their delete redundant or removes their retain
	        continue;
	      } else if (otherOp['delete']) {
	        delta.push(otherOp);
	      } else {
	        // We retain either their retain or insert
	        delta.retain(length, op.attributes.transform(thisOp.attributes, otherOp.attributes, priority));
	      }
	    }
	  }
	  return delta.chop();
	};
	
	Delta.prototype.transformPosition = function (index, priority) {
	  priority = !!priority;
	  var thisIter = op.iterator(this.ops);
	  var offset = 0;
	  while (thisIter.hasNext() && offset <= index) {
	    var length = thisIter.peekLength();
	    var nextType = thisIter.peekType();
	    thisIter.next();
	    if (nextType === 'delete') {
	      index -= Math.min(length, index - offset);
	      continue;
	    } else if (nextType === 'insert' && (offset < index || !priority)) {
	      index += length;
	    }
	    offset += length;
	  }
	  return index;
	};
	
	
	module.exports = Delta;
	
	
	/***/ }),
	/* 3 */
	/***/ (function(module, exports) {
	
	'use strict';
	
	var hasOwn = Object.prototype.hasOwnProperty;
	var toStr = Object.prototype.toString;
	var defineProperty = Object.defineProperty;
	var gOPD = Object.getOwnPropertyDescriptor;
	
	var isArray = function isArray(arr) {
		if (typeof Array.isArray === 'function') {
			return Array.isArray(arr);
		}
	
		return toStr.call(arr) === '[object Array]';
	};
	
	var isPlainObject = function isPlainObject(obj) {
		if (!obj || toStr.call(obj) !== '[object Object]') {
			return false;
		}
	
		var hasOwnConstructor = hasOwn.call(obj, 'constructor');
		var hasIsPrototypeOf = obj.constructor && obj.constructor.prototype && hasOwn.call(obj.constructor.prototype, 'isPrototypeOf');
		// Not own constructor property must be Object
		if (obj.constructor && !hasOwnConstructor && !hasIsPrototypeOf) {
			return false;
		}
	
		// Own properties are enumerated firstly, so to speed up,
		// if last one is own, then all properties are own.
		var key;
		for (key in obj) { /**/ }
	
		return typeof key === 'undefined' || hasOwn.call(obj, key);
	};
	
	// If name is '__proto__', and Object.defineProperty is available, define __proto__ as an own property on target
	var setProperty = function setProperty(target, options) {
		if (defineProperty && options.name === '__proto__') {
			defineProperty(target, options.name, {
				enumerable: true,
				configurable: true,
				value: options.newValue,
				writable: true
			});
		} else {
			target[options.name] = options.newValue;
		}
	};
	
	// Return undefined instead of __proto__ if '__proto__' is not an own property
	var getProperty = function getProperty(obj, name) {
		if (name === '__proto__') {
			if (!hasOwn.call(obj, name)) {
				return void 0;
			} else if (gOPD) {
				// In early versions of node, obj['__proto__'] is buggy when obj has
				// __proto__ as an own property. Object.getOwnPropertyDescriptor() works.
				return gOPD(obj, name).value;
			}
		}
	
		return obj[name];
	};
	
	module.exports = function extend() {
		var options, name, src, copy, copyIsArray, clone;
		var target = arguments[0];
		var i = 1;
		var length = arguments.length;
		var deep = false;
	
		// Handle a deep copy situation
		if (typeof target === 'boolean') {
			deep = target;
			target = arguments[1] || {};
			// skip the boolean and the target
			i = 2;
		}
		if (target == null || (typeof target !== 'object' && typeof target !== 'function')) {
			target = {};
		}
	
		for (; i < length; ++i) {
			options = arguments[i];
			// Only deal with non-null/undefined values
			if (options != null) {
				// Extend the base object
				for (name in options) {
					src = getProperty(target, name);
					copy = getProperty(options, name);
	
					// Prevent never-ending loop
					if (target !== copy) {
						// Recurse if we're merging plain objects or arrays
						if (deep && copy && (isPlainObject(copy) || (copyIsArray = isArray(copy)))) {
							if (copyIsArray) {
								copyIsArray = false;
								clone = src && isArray(src) ? src : [];
							} else {
								clone = src && isPlainObject(src) ? src : {};
							}
	
							// Never move original objects, clone them
							setProperty(target, { name: name, newValue: extend(deep, clone, copy) });
	
						// Don't bring in undefined values
						} else if (typeof copy !== 'undefined') {
							setProperty(target, { name: name, newValue: copy });
						}
					}
				}
			}
		}
	
		// Return the modified object
		return target;
	};
	
	
	/***/ }),
	/* 4 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.BlockEmbed = exports.bubbleFormats = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _extend = __webpack_require__(3);
	
	var _extend2 = _interopRequireDefault(_extend);
	
	var _quillDelta = __webpack_require__(2);
	
	var _quillDelta2 = _interopRequireDefault(_quillDelta);
	
	var _parchment = __webpack_require__(0);
	
	var _parchment2 = _interopRequireDefault(_parchment);
	
	var _break = __webpack_require__(16);
	
	var _break2 = _interopRequireDefault(_break);
	
	var _inline = __webpack_require__(6);
	
	var _inline2 = _interopRequireDefault(_inline);
	
	var _text = __webpack_require__(7);
	
	var _text2 = _interopRequireDefault(_text);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var NEWLINE_LENGTH = 1;
	
	var BlockEmbed = function (_Parchment$Embed) {
	  _inherits(BlockEmbed, _Parchment$Embed);
	
	  function BlockEmbed() {
	    _classCallCheck(this, BlockEmbed);
	
	    return _possibleConstructorReturn(this, (BlockEmbed.__proto__ || Object.getPrototypeOf(BlockEmbed)).apply(this, arguments));
	  }
	
	  _createClass(BlockEmbed, [{
	    key: 'attach',
	    value: function attach() {
	      _get(BlockEmbed.prototype.__proto__ || Object.getPrototypeOf(BlockEmbed.prototype), 'attach', this).call(this);
	      this.attributes = new _parchment2.default.Attributor.Store(this.domNode);
	    }
	  }, {
	    key: 'delta',
	    value: function delta() {
	      return new _quillDelta2.default().insert(this.value(), (0, _extend2.default)(this.formats(), this.attributes.values()));
	    }
	  }, {
	    key: 'format',
	    value: function format(name, value) {
	      var attribute = _parchment2.default.query(name, _parchment2.default.Scope.BLOCK_ATTRIBUTE);
	      if (attribute != null) {
	        this.attributes.attribute(attribute, value);
	      }
	    }
	  }, {
	    key: 'formatAt',
	    value: function formatAt(index, length, name, value) {
	      this.format(name, value);
	    }
	  }, {
	    key: 'insertAt',
	    value: function insertAt(index, value, def) {
	      if (typeof value === 'string' && value.endsWith('\n')) {
	        var block = _parchment2.default.create(Block.blotName);
	        this.parent.insertBefore(block, index === 0 ? this : this.next);
	        block.insertAt(0, value.slice(0, -1));
	      } else {
	        _get(BlockEmbed.prototype.__proto__ || Object.getPrototypeOf(BlockEmbed.prototype), 'insertAt', this).call(this, index, value, def);
	      }
	    }
	  }]);
	
	  return BlockEmbed;
	}(_parchment2.default.Embed);
	
	BlockEmbed.scope = _parchment2.default.Scope.BLOCK_BLOT;
	// It is important for cursor behavior BlockEmbeds use tags that are block level elements
	
	
	var Block = function (_Parchment$Block) {
	  _inherits(Block, _Parchment$Block);
	
	  function Block(domNode) {
	    _classCallCheck(this, Block);
	
	    var _this2 = _possibleConstructorReturn(this, (Block.__proto__ || Object.getPrototypeOf(Block)).call(this, domNode));
	
	    _this2.cache = {};
	    return _this2;
	  }
	
	  _createClass(Block, [{
	    key: 'delta',
	    value: function delta() {
	      if (this.cache.delta == null) {
	        this.cache.delta = this.descendants(_parchment2.default.Leaf).reduce(function (delta, leaf) {
	          if (leaf.length() === 0) {
	            return delta;
	          } else {
	            return delta.insert(leaf.value(), bubbleFormats(leaf));
	          }
	        }, new _quillDelta2.default()).insert('\n', bubbleFormats(this));
	      }
	      return this.cache.delta;
	    }
	  }, {
	    key: 'deleteAt',
	    value: function deleteAt(index, length) {
	      _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'deleteAt', this).call(this, index, length);
	      this.cache = {};
	    }
	  }, {
	    key: 'formatAt',
	    value: function formatAt(index, length, name, value) {
	      if (length <= 0) return;
	      if (_parchment2.default.query(name, _parchment2.default.Scope.BLOCK)) {
	        if (index + length === this.length()) {
	          this.format(name, value);
	        }
	      } else {
	        _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'formatAt', this).call(this, index, Math.min(length, this.length() - index - 1), name, value);
	      }
	      this.cache = {};
	    }
	  }, {
	    key: 'insertAt',
	    value: function insertAt(index, value, def) {
	      if (def != null) return _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'insertAt', this).call(this, index, value, def);
	      if (value.length === 0) return;
	      var lines = value.split('\n');
	      var text = lines.shift();
	      if (text.length > 0) {
	        if (index < this.length() - 1 || this.children.tail == null) {
	          _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'insertAt', this).call(this, Math.min(index, this.length() - 1), text);
	        } else {
	          this.children.tail.insertAt(this.children.tail.length(), text);
	        }
	        this.cache = {};
	      }
	      var block = this;
	      lines.reduce(function (index, line) {
	        block = block.split(index, true);
	        block.insertAt(0, line);
	        return line.length;
	      }, index + text.length);
	    }
	  }, {
	    key: 'insertBefore',
	    value: function insertBefore(blot, ref) {
	      var head = this.children.head;
	      _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'insertBefore', this).call(this, blot, ref);
	      if (head instanceof _break2.default) {
	        head.remove();
	      }
	      this.cache = {};
	    }
	  }, {
	    key: 'length',
	    value: function length() {
	      if (this.cache.length == null) {
	        this.cache.length = _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'length', this).call(this) + NEWLINE_LENGTH;
	      }
	      return this.cache.length;
	    }
	  }, {
	    key: 'moveChildren',
	    value: function moveChildren(target, ref) {
	      _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'moveChildren', this).call(this, target, ref);
	      this.cache = {};
	    }
	  }, {
	    key: 'optimize',
	    value: function optimize(context) {
	      _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'optimize', this).call(this, context);
	      this.cache = {};
	    }
	  }, {
	    key: 'path',
	    value: function path(index) {
	      return _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'path', this).call(this, index, true);
	    }
	  }, {
	    key: 'removeChild',
	    value: function removeChild(child) {
	      _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'removeChild', this).call(this, child);
	      this.cache = {};
	    }
	  }, {
	    key: 'split',
	    value: function split(index) {
	      var force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	      if (force && (index === 0 || index >= this.length() - NEWLINE_LENGTH)) {
	        var clone = this.clone();
	        if (index === 0) {
	          this.parent.insertBefore(clone, this);
	          return this;
	        } else {
	          this.parent.insertBefore(clone, this.next);
	          return clone;
	        }
	      } else {
	        var next = _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'split', this).call(this, index, force);
	        this.cache = {};
	        return next;
	      }
	    }
	  }]);
	
	  return Block;
	}(_parchment2.default.Block);
	
	Block.blotName = 'block';
	Block.tagName = 'P';
	Block.defaultChild = 'break';
	Block.allowedChildren = [_inline2.default, _parchment2.default.Embed, _text2.default];
	
	function bubbleFormats(blot) {
	  var formats = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  if (blot == null) return formats;
	  if (typeof blot.formats === 'function') {
	    formats = (0, _extend2.default)(formats, blot.formats());
	  }
	  if (blot.parent == null || blot.parent.blotName == 'scroll' || blot.parent.statics.scope !== blot.statics.scope) {
	    return formats;
	  }
	  return bubbleFormats(blot.parent, formats);
	}
	
	exports.bubbleFormats = bubbleFormats;
	exports.BlockEmbed = BlockEmbed;
	exports.default = Block;
	
	/***/ }),
	/* 5 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.overload = exports.expandConfig = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	__webpack_require__(50);
	
	var _quillDelta = __webpack_require__(2);
	
	var _quillDelta2 = _interopRequireDefault(_quillDelta);
	
	var _editor = __webpack_require__(14);
	
	var _editor2 = _interopRequireDefault(_editor);
	
	var _emitter3 = __webpack_require__(8);
	
	var _emitter4 = _interopRequireDefault(_emitter3);
	
	var _module = __webpack_require__(9);
	
	var _module2 = _interopRequireDefault(_module);
	
	var _parchment = __webpack_require__(0);
	
	var _parchment2 = _interopRequireDefault(_parchment);
	
	var _selection = __webpack_require__(15);
	
	var _selection2 = _interopRequireDefault(_selection);
	
	var _extend = __webpack_require__(3);
	
	var _extend2 = _interopRequireDefault(_extend);
	
	var _logger = __webpack_require__(10);
	
	var _logger2 = _interopRequireDefault(_logger);
	
	var _theme = __webpack_require__(34);
	
	var _theme2 = _interopRequireDefault(_theme);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var debug = (0, _logger2.default)('quill');
	
	var Quill = function () {
	  _createClass(Quill, null, [{
	    key: 'debug',
	    value: function debug(limit) {
	      if (limit === true) {
	        limit = 'log';
	      }
	      _logger2.default.level(limit);
	    }
	  }, {
	    key: 'find',
	    value: function find(node) {
	      return node.__quill || _parchment2.default.find(node);
	    }
	  }, {
	    key: 'import',
	    value: function _import(name) {
	      if (this.imports[name] == null) {
	        debug.error('Cannot import ' + name + '. Are you sure it was registered?');
	      }
	      return this.imports[name];
	    }
	  }, {
	    key: 'register',
	    value: function register(path, target) {
	      var _this = this;
	
	      var overwrite = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	      if (typeof path !== 'string') {
	        var name = path.attrName || path.blotName;
	        if (typeof name === 'string') {
	          // register(Blot | Attributor, overwrite)
	          this.register('formats/' + name, path, target);
	        } else {
	          Object.keys(path).forEach(function (key) {
	            _this.register(key, path[key], target);
	          });
	        }
	      } else {
	        if (this.imports[path] != null && !overwrite) {
	          debug.warn('Overwriting ' + path + ' with', target);
	        }
	        this.imports[path] = target;
	        if ((path.startsWith('blots/') || path.startsWith('formats/')) && target.blotName !== 'abstract') {
	          _parchment2.default.register(target);
	        } else if (path.startsWith('modules') && typeof target.register === 'function') {
	          target.register();
	        }
	      }
	    }
	  }]);
	
	  function Quill(container) {
	    var _this2 = this;
	
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    _classCallCheck(this, Quill);
	
	    this.options = expandConfig(container, options);
	    this.container = this.options.container;
	    if (this.container == null) {
	      return debug.error('Invalid Quill container', container);
	    }
	    if (this.options.debug) {
	      Quill.debug(this.options.debug);
	    }
	    var html = this.container.innerHTML.trim();
	    this.container.classList.add('ql-container');
	    this.container.innerHTML = '';
	    this.container.__quill = this;
	    this.root = this.addContainer('ql-editor');
	    this.root.classList.add('ql-blank');
	    this.root.setAttribute('data-gramm', false);
	    this.scrollingContainer = this.options.scrollingContainer || this.root;
	    this.emitter = new _emitter4.default();
	    this.scroll = _parchment2.default.create(this.root, {
	      emitter: this.emitter,
	      whitelist: this.options.formats
	    });
	    this.editor = new _editor2.default(this.scroll);
	    this.selection = new _selection2.default(this.scroll, this.emitter);
	    this.theme = new this.options.theme(this, this.options);
	    this.keyboard = this.theme.addModule('keyboard');
	    this.clipboard = this.theme.addModule('clipboard');
	    this.history = this.theme.addModule('history');
	    this.theme.init();
	    this.emitter.on(_emitter4.default.events.EDITOR_CHANGE, function (type) {
	      if (type === _emitter4.default.events.TEXT_CHANGE) {
	        _this2.root.classList.toggle('ql-blank', _this2.editor.isBlank());
	      }
	    });
	    this.emitter.on(_emitter4.default.events.SCROLL_UPDATE, function (source, mutations) {
	      var range = _this2.selection.lastRange;
	      var index = range && range.length === 0 ? range.index : undefined;
	      modify.call(_this2, function () {
	        return _this2.editor.update(null, mutations, index);
	      }, source);
	    });
	    var contents = this.clipboard.convert('<div class=\'ql-editor\' style="white-space: normal;">' + html + '<p><br></p></div>');
	    this.setContents(contents);
	    this.history.clear();
	    if (this.options.placeholder) {
	      this.root.setAttribute('data-placeholder', this.options.placeholder);
	    }
	    if (this.options.readOnly) {
	      this.disable();
	    }
	  }
	
	  _createClass(Quill, [{
	    key: 'addContainer',
	    value: function addContainer(container) {
	      var refNode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	
	      if (typeof container === 'string') {
	        var className = container;
	        container = document.createElement('div');
	        container.classList.add(className);
	      }
	      this.container.insertBefore(container, refNode);
	      return container;
	    }
	  }, {
	    key: 'blur',
	    value: function blur() {
	      this.selection.setRange(null);
	    }
	  }, {
	    key: 'deleteText',
	    value: function deleteText(index, length, source) {
	      var _this3 = this;
	
	      var _overload = overload(index, length, source);
	
	      var _overload2 = _slicedToArray(_overload, 4);
	
	      index = _overload2[0];
	      length = _overload2[1];
	      source = _overload2[3];
	
	      return modify.call(this, function () {
	        return _this3.editor.deleteText(index, length);
	      }, source, index, -1 * length);
	    }
	  }, {
	    key: 'disable',
	    value: function disable() {
	      this.enable(false);
	    }
	  }, {
	    key: 'enable',
	    value: function enable() {
	      var enabled = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	
	      this.scroll.enable(enabled);
	      this.container.classList.toggle('ql-disabled', !enabled);
	    }
	  }, {
	    key: 'focus',
	    value: function focus() {
	      var scrollTop = this.scrollingContainer.scrollTop;
	      this.selection.focus();
	      this.scrollingContainer.scrollTop = scrollTop;
	      this.scrollIntoView();
	    }
	  }, {
	    key: 'format',
	    value: function format(name, value) {
	      var _this4 = this;
	
	      var source = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _emitter4.default.sources.API;
	
	      return modify.call(this, function () {
	        var range = _this4.getSelection(true);
	        var change = new _quillDelta2.default();
	        if (range == null) {
	          return change;
	        } else if (_parchment2.default.query(name, _parchment2.default.Scope.BLOCK)) {
	          change = _this4.editor.formatLine(range.index, range.length, _defineProperty({}, name, value));
	        } else if (range.length === 0) {
	          _this4.selection.format(name, value);
	          return change;
	        } else {
	          change = _this4.editor.formatText(range.index, range.length, _defineProperty({}, name, value));
	        }
	        _this4.setSelection(range, _emitter4.default.sources.SILENT);
	        return change;
	      }, source);
	    }
	  }, {
	    key: 'formatLine',
	    value: function formatLine(index, length, name, value, source) {
	      var _this5 = this;
	
	      var formats = void 0;
	
	      var _overload3 = overload(index, length, name, value, source);
	
	      var _overload4 = _slicedToArray(_overload3, 4);
	
	      index = _overload4[0];
	      length = _overload4[1];
	      formats = _overload4[2];
	      source = _overload4[3];
	
	      return modify.call(this, function () {
	        return _this5.editor.formatLine(index, length, formats);
	      }, source, index, 0);
	    }
	  }, {
	    key: 'formatText',
	    value: function formatText(index, length, name, value, source) {
	      var _this6 = this;
	
	      var formats = void 0;
	
	      var _overload5 = overload(index, length, name, value, source);
	
	      var _overload6 = _slicedToArray(_overload5, 4);
	
	      index = _overload6[0];
	      length = _overload6[1];
	      formats = _overload6[2];
	      source = _overload6[3];
	
	      return modify.call(this, function () {
	        return _this6.editor.formatText(index, length, formats);
	      }, source, index, 0);
	    }
	  }, {
	    key: 'getBounds',
	    value: function getBounds(index) {
	      var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	
	      var bounds = void 0;
	      if (typeof index === 'number') {
	        bounds = this.selection.getBounds(index, length);
	      } else {
	        bounds = this.selection.getBounds(index.index, index.length);
	      }
	      var containerBounds = this.container.getBoundingClientRect();
	      return {
	        bottom: bounds.bottom - containerBounds.top,
	        height: bounds.height,
	        left: bounds.left - containerBounds.left,
	        right: bounds.right - containerBounds.left,
	        top: bounds.top - containerBounds.top,
	        width: bounds.width
	      };
	    }
	  }, {
	    key: 'getContents',
	    value: function getContents() {
	      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	      var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.getLength() - index;
	
	      var _overload7 = overload(index, length);
	
	      var _overload8 = _slicedToArray(_overload7, 2);
	
	      index = _overload8[0];
	      length = _overload8[1];
	
	      return this.editor.getContents(index, length);
	    }
	  }, {
	    key: 'getFormat',
	    value: function getFormat() {
	      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.getSelection(true);
	      var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	
	      if (typeof index === 'number') {
	        return this.editor.getFormat(index, length);
	      } else {
	        return this.editor.getFormat(index.index, index.length);
	      }
	    }
	  }, {
	    key: 'getIndex',
	    value: function getIndex(blot) {
	      return blot.offset(this.scroll);
	    }
	  }, {
	    key: 'getLength',
	    value: function getLength() {
	      return this.scroll.length();
	    }
	  }, {
	    key: 'getLeaf',
	    value: function getLeaf(index) {
	      return this.scroll.leaf(index);
	    }
	  }, {
	    key: 'getLine',
	    value: function getLine(index) {
	      return this.scroll.line(index);
	    }
	  }, {
	    key: 'getLines',
	    value: function getLines() {
	      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	      var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Number.MAX_VALUE;
	
	      if (typeof index !== 'number') {
	        return this.scroll.lines(index.index, index.length);
	      } else {
	        return this.scroll.lines(index, length);
	      }
	    }
	  }, {
	    key: 'getModule',
	    value: function getModule(name) {
	      return this.theme.modules[name];
	    }
	  }, {
	    key: 'getSelection',
	    value: function getSelection() {
	      var focus = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	      if (focus) this.focus();
	      this.update(); // Make sure we access getRange with editor in consistent state
	      return this.selection.getRange()[0];
	    }
	  }, {
	    key: 'getText',
	    value: function getText() {
	      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	      var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.getLength() - index;
	
	      var _overload9 = overload(index, length);
	
	      var _overload10 = _slicedToArray(_overload9, 2);
	
	      index = _overload10[0];
	      length = _overload10[1];
	
	      return this.editor.getText(index, length);
	    }
	  }, {
	    key: 'hasFocus',
	    value: function hasFocus() {
	      return this.selection.hasFocus();
	    }
	  }, {
	    key: 'insertEmbed',
	    value: function insertEmbed(index, embed, value) {
	      var _this7 = this;
	
	      var source = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : Quill.sources.API;
	
	      return modify.call(this, function () {
	        return _this7.editor.insertEmbed(index, embed, value);
	      }, source, index);
	    }
	  }, {
	    key: 'insertText',
	    value: function insertText(index, text, name, value, source) {
	      var _this8 = this;
	
	      var formats = void 0;
	
	      var _overload11 = overload(index, 0, name, value, source);
	
	      var _overload12 = _slicedToArray(_overload11, 4);
	
	      index = _overload12[0];
	      formats = _overload12[2];
	      source = _overload12[3];
	
	      return modify.call(this, function () {
	        return _this8.editor.insertText(index, text, formats);
	      }, source, index, text.length);
	    }
	  }, {
	    key: 'isEnabled',
	    value: function isEnabled() {
	      return !this.container.classList.contains('ql-disabled');
	    }
	  }, {
	    key: 'off',
	    value: function off() {
	      return this.emitter.off.apply(this.emitter, arguments);
	    }
	  }, {
	    key: 'on',
	    value: function on() {
	      return this.emitter.on.apply(this.emitter, arguments);
	    }
	  }, {
	    key: 'once',
	    value: function once() {
	      return this.emitter.once.apply(this.emitter, arguments);
	    }
	  }, {
	    key: 'pasteHTML',
	    value: function pasteHTML(index, html, source) {
	      this.clipboard.dangerouslyPasteHTML(index, html, source);
	    }
	  }, {
	    key: 'removeFormat',
	    value: function removeFormat(index, length, source) {
	      var _this9 = this;
	
	      var _overload13 = overload(index, length, source);
	
	      var _overload14 = _slicedToArray(_overload13, 4);
	
	      index = _overload14[0];
	      length = _overload14[1];
	      source = _overload14[3];
	
	      return modify.call(this, function () {
	        return _this9.editor.removeFormat(index, length);
	      }, source, index);
	    }
	  }, {
	    key: 'scrollIntoView',
	    value: function scrollIntoView() {
	      this.selection.scrollIntoView(this.scrollingContainer);
	    }
	  }, {
	    key: 'setContents',
	    value: function setContents(delta) {
	      var _this10 = this;
	
	      var source = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _emitter4.default.sources.API;
	
	      return modify.call(this, function () {
	        delta = new _quillDelta2.default(delta);
	        var length = _this10.getLength();
	        var deleted = _this10.editor.deleteText(0, length);
	        var applied = _this10.editor.applyDelta(delta);
	        var lastOp = applied.ops[applied.ops.length - 1];
	        if (lastOp != null && typeof lastOp.insert === 'string' && lastOp.insert[lastOp.insert.length - 1] === '\n') {
	          _this10.editor.deleteText(_this10.getLength() - 1, 1);
	          applied.delete(1);
	        }
	        var ret = deleted.compose(applied);
	        return ret;
	      }, source);
	    }
	  }, {
	    key: 'setSelection',
	    value: function setSelection(index, length, source) {
	      if (index == null) {
	        this.selection.setRange(null, length || Quill.sources.API);
	      } else {
	        var _overload15 = overload(index, length, source);
	
	        var _overload16 = _slicedToArray(_overload15, 4);
	
	        index = _overload16[0];
	        length = _overload16[1];
	        source = _overload16[3];
	
	        this.selection.setRange(new _selection.Range(index, length), source);
	        if (source !== _emitter4.default.sources.SILENT) {
	          this.selection.scrollIntoView(this.scrollingContainer);
	        }
	      }
	    }
	  }, {
	    key: 'setText',
	    value: function setText(text) {
	      var source = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _emitter4.default.sources.API;
	
	      var delta = new _quillDelta2.default().insert(text);
	      return this.setContents(delta, source);
	    }
	  }, {
	    key: 'update',
	    value: function update() {
	      var source = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _emitter4.default.sources.USER;
	
	      var change = this.scroll.update(source); // Will update selection before selection.update() does if text changes
	      this.selection.update(source);
	      return change;
	    }
	  }, {
	    key: 'updateContents',
	    value: function updateContents(delta) {
	      var _this11 = this;
	
	      var source = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _emitter4.default.sources.API;
	
	      return modify.call(this, function () {
	        delta = new _quillDelta2.default(delta);
	        return _this11.editor.applyDelta(delta, source);
	      }, source, true);
	    }
	  }]);
	
	  return Quill;
	}();
	
	Quill.DEFAULTS = {
	  bounds: null,
	  formats: null,
	  modules: {},
	  placeholder: '',
	  readOnly: false,
	  scrollingContainer: null,
	  strict: true,
	  theme: 'default'
	};
	Quill.events = _emitter4.default.events;
	Quill.sources = _emitter4.default.sources;
	// eslint-disable-next-line no-undef
	Quill.version =  false ? 'dev' : "1.3.7";
	
	Quill.imports = {
	  'delta': _quillDelta2.default,
	  'parchment': _parchment2.default,
	  'core/module': _module2.default,
	  'core/theme': _theme2.default
	};
	
	function expandConfig(container, userConfig) {
	  userConfig = (0, _extend2.default)(true, {
	    container: container,
	    modules: {
	      clipboard: true,
	      keyboard: true,
	      history: true
	    }
	  }, userConfig);
	  if (!userConfig.theme || userConfig.theme === Quill.DEFAULTS.theme) {
	    userConfig.theme = _theme2.default;
	  } else {
	    userConfig.theme = Quill.import('themes/' + userConfig.theme);
	    if (userConfig.theme == null) {
	      throw new Error('Invalid theme ' + userConfig.theme + '. Did you register it?');
	    }
	  }
	  var themeConfig = (0, _extend2.default)(true, {}, userConfig.theme.DEFAULTS);
	  [themeConfig, userConfig].forEach(function (config) {
	    config.modules = config.modules || {};
	    Object.keys(config.modules).forEach(function (module) {
	      if (config.modules[module] === true) {
	        config.modules[module] = {};
	      }
	    });
	  });
	  var moduleNames = Object.keys(themeConfig.modules).concat(Object.keys(userConfig.modules));
	  var moduleConfig = moduleNames.reduce(function (config, name) {
	    var moduleClass = Quill.import('modules/' + name);
	    if (moduleClass == null) {
	      debug.error('Cannot load ' + name + ' module. Are you sure you registered it?');
	    } else {
	      config[name] = moduleClass.DEFAULTS || {};
	    }
	    return config;
	  }, {});
	  // Special case toolbar shorthand
	  if (userConfig.modules != null && userConfig.modules.toolbar && userConfig.modules.toolbar.constructor !== Object) {
	    userConfig.modules.toolbar = {
	      container: userConfig.modules.toolbar
	    };
	  }
	  userConfig = (0, _extend2.default)(true, {}, Quill.DEFAULTS, { modules: moduleConfig }, themeConfig, userConfig);
	  ['bounds', 'container', 'scrollingContainer'].forEach(function (key) {
	    if (typeof userConfig[key] === 'string') {
	      userConfig[key] = document.querySelector(userConfig[key]);
	    }
	  });
	  userConfig.modules = Object.keys(userConfig.modules).reduce(function (config, name) {
	    if (userConfig.modules[name]) {
	      config[name] = userConfig.modules[name];
	    }
	    return config;
	  }, {});
	  return userConfig;
	}
	
	// Handle selection preservation and TEXT_CHANGE emission
	// common to modification APIs
	function modify(modifier, source, index, shift) {
	  if (this.options.strict && !this.isEnabled() && source === _emitter4.default.sources.USER) {
	    return new _quillDelta2.default();
	  }
	  var range = index == null ? null : this.getSelection();
	  var oldDelta = this.editor.delta;
	  var change = modifier();
	  if (range != null) {
	    if (index === true) index = range.index;
	    if (shift == null) {
	      range = shiftRange(range, change, source);
	    } else if (shift !== 0) {
	      range = shiftRange(range, index, shift, source);
	    }
	    this.setSelection(range, _emitter4.default.sources.SILENT);
	  }
	  if (change.length() > 0) {
	    var _emitter;
	
	    var args = [_emitter4.default.events.TEXT_CHANGE, change, oldDelta, source];
	    (_emitter = this.emitter).emit.apply(_emitter, [_emitter4.default.events.EDITOR_CHANGE].concat(args));
	    if (source !== _emitter4.default.sources.SILENT) {
	      var _emitter2;
	
	      (_emitter2 = this.emitter).emit.apply(_emitter2, args);
	    }
	  }
	  return change;
	}
	
	function overload(index, length, name, value, source) {
	  var formats = {};
	  if (typeof index.index === 'number' && typeof index.length === 'number') {
	    // Allow for throwaway end (used by insertText/insertEmbed)
	    if (typeof length !== 'number') {
	      source = value, value = name, name = length, length = index.length, index = index.index;
	    } else {
	      length = index.length, index = index.index;
	    }
	  } else if (typeof length !== 'number') {
	    source = value, value = name, name = length, length = 0;
	  }
	  // Handle format being object, two format name/value strings or excluded
	  if ((typeof name === 'undefined' ? 'undefined' : _typeof(name)) === 'object') {
	    formats = name;
	    source = value;
	  } else if (typeof name === 'string') {
	    if (value != null) {
	      formats[name] = value;
	    } else {
	      source = name;
	    }
	  }
	  // Handle optional source
	  source = source || _emitter4.default.sources.API;
	  return [index, length, formats, source];
	}
	
	function shiftRange(range, index, length, source) {
	  if (range == null) return null;
	  var start = void 0,
	      end = void 0;
	  if (index instanceof _quillDelta2.default) {
	    var _map = [range.index, range.index + range.length].map(function (pos) {
	      return index.transformPosition(pos, source !== _emitter4.default.sources.USER);
	    });
	
	    var _map2 = _slicedToArray(_map, 2);
	
	    start = _map2[0];
	    end = _map2[1];
	  } else {
	    var _map3 = [range.index, range.index + range.length].map(function (pos) {
	      if (pos < index || pos === index && source === _emitter4.default.sources.USER) return pos;
	      if (length >= 0) {
	        return pos + length;
	      } else {
	        return Math.max(index, pos + length);
	      }
	    });
	
	    var _map4 = _slicedToArray(_map3, 2);
	
	    start = _map4[0];
	    end = _map4[1];
	  }
	  return new _selection.Range(start, end - start);
	}
	
	exports.expandConfig = expandConfig;
	exports.overload = overload;
	exports.default = Quill;
	
	/***/ }),
	/* 6 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _text = __webpack_require__(7);
	
	var _text2 = _interopRequireDefault(_text);
	
	var _parchment = __webpack_require__(0);
	
	var _parchment2 = _interopRequireDefault(_parchment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Inline = function (_Parchment$Inline) {
	  _inherits(Inline, _Parchment$Inline);
	
	  function Inline() {
	    _classCallCheck(this, Inline);
	
	    return _possibleConstructorReturn(this, (Inline.__proto__ || Object.getPrototypeOf(Inline)).apply(this, arguments));
	  }
	
	  _createClass(Inline, [{
	    key: 'formatAt',
	    value: function formatAt(index, length, name, value) {
	      if (Inline.compare(this.statics.blotName, name) < 0 && _parchment2.default.query(name, _parchment2.default.Scope.BLOT)) {
	        var blot = this.isolate(index, length);
	        if (value) {
	          blot.wrap(name, value);
	        }
	      } else {
	        _get(Inline.prototype.__proto__ || Object.getPrototypeOf(Inline.prototype), 'formatAt', this).call(this, index, length, name, value);
	      }
	    }
	  }, {
	    key: 'optimize',
	    value: function optimize(context) {
	      _get(Inline.prototype.__proto__ || Object.getPrototypeOf(Inline.prototype), 'optimize', this).call(this, context);
	      if (this.parent instanceof Inline && Inline.compare(this.statics.blotName, this.parent.statics.blotName) > 0) {
	        var parent = this.parent.isolate(this.offset(), this.length());
	        this.moveChildren(parent);
	        parent.wrap(this);
	      }
	    }
	  }], [{
	    key: 'compare',
	    value: function compare(self, other) {
	      var selfIndex = Inline.order.indexOf(self);
	      var otherIndex = Inline.order.indexOf(other);
	      if (selfIndex >= 0 || otherIndex >= 0) {
	        return selfIndex - otherIndex;
	      } else if (self === other) {
	        return 0;
	      } else if (self < other) {
	        return -1;
	      } else {
	        return 1;
	      }
	    }
	  }]);
	
	  return Inline;
	}(_parchment2.default.Inline);
	
	Inline.allowedChildren = [Inline, _parchment2.default.Embed, _text2.default];
	// Lower index means deeper in the DOM tree, since not found (-1) is for embeds
	Inline.order = ['cursor', 'inline', // Must be lower
	'underline', 'strike', 'italic', 'bold', 'script', 'link', 'code' // Must be higher
	];
	
	exports.default = Inline;
	
	/***/ }),
	/* 7 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _parchment = __webpack_require__(0);
	
	var _parchment2 = _interopRequireDefault(_parchment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TextBlot = function (_Parchment$Text) {
	  _inherits(TextBlot, _Parchment$Text);
	
	  function TextBlot() {
	    _classCallCheck(this, TextBlot);
	
	    return _possibleConstructorReturn(this, (TextBlot.__proto__ || Object.getPrototypeOf(TextBlot)).apply(this, arguments));
	  }
	
	  return TextBlot;
	}(_parchment2.default.Text);
	
	exports.default = TextBlot;
	
	/***/ }),
	/* 8 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _eventemitter = __webpack_require__(54);
	
	var _eventemitter2 = _interopRequireDefault(_eventemitter);
	
	var _logger = __webpack_require__(10);
	
	var _logger2 = _interopRequireDefault(_logger);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var debug = (0, _logger2.default)('quill:events');
	
	var EVENTS = ['selectionchange', 'mousedown', 'mouseup', 'click'];
	
	EVENTS.forEach(function (eventName) {
	  document.addEventListener(eventName, function () {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    [].slice.call(document.querySelectorAll('.ql-container')).forEach(function (node) {
	      // TODO use WeakMap
	      if (node.__quill && node.__quill.emitter) {
	        var _node$__quill$emitter;
	
	        (_node$__quill$emitter = node.__quill.emitter).handleDOM.apply(_node$__quill$emitter, args);
	      }
	    });
	  });
	});
	
	var Emitter = function (_EventEmitter) {
	  _inherits(Emitter, _EventEmitter);
	
	  function Emitter() {
	    _classCallCheck(this, Emitter);
	
	    var _this = _possibleConstructorReturn(this, (Emitter.__proto__ || Object.getPrototypeOf(Emitter)).call(this));
	
	    _this.listeners = {};
	    _this.on('error', debug.error);
	    return _this;
	  }
	
	  _createClass(Emitter, [{
	    key: 'emit',
	    value: function emit() {
	      debug.log.apply(debug, arguments);
	      _get(Emitter.prototype.__proto__ || Object.getPrototypeOf(Emitter.prototype), 'emit', this).apply(this, arguments);
	    }
	  }, {
	    key: 'handleDOM',
	    value: function handleDOM(event) {
	      for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
	        args[_key2 - 1] = arguments[_key2];
	      }
	
	      (this.listeners[event.type] || []).forEach(function (_ref) {
	        var node = _ref.node,
	            handler = _ref.handler;
	
	        if (event.target === node || node.contains(event.target)) {
	          handler.apply(undefined, [event].concat(args));
	        }
	      });
	    }
	  }, {
	    key: 'listenDOM',
	    value: function listenDOM(eventName, node, handler) {
	      if (!this.listeners[eventName]) {
	        this.listeners[eventName] = [];
	      }
	      this.listeners[eventName].push({ node: node, handler: handler });
	    }
	  }]);
	
	  return Emitter;
	}(_eventemitter2.default);
	
	Emitter.events = {
	  EDITOR_CHANGE: 'editor-change',
	  SCROLL_BEFORE_UPDATE: 'scroll-before-update',
	  SCROLL_OPTIMIZE: 'scroll-optimize',
	  SCROLL_UPDATE: 'scroll-update',
	  SELECTION_CHANGE: 'selection-change',
	  TEXT_CHANGE: 'text-change'
	};
	Emitter.sources = {
	  API: 'api',
	  SILENT: 'silent',
	  USER: 'user'
	};
	
	exports.default = Emitter;
	
	/***/ }),
	/* 9 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Module = function Module(quill) {
	  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  _classCallCheck(this, Module);
	
	  this.quill = quill;
	  this.options = options;
	};
	
	Module.DEFAULTS = {};
	
	exports.default = Module;
	
	/***/ }),
	/* 10 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var levels = ['error', 'warn', 'log', 'info'];
	var level = 'warn';
	
	function debug(method) {
	  if (levels.indexOf(method) <= levels.indexOf(level)) {
	    var _console;
	
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    (_console = console)[method].apply(_console, args); // eslint-disable-line no-console
	  }
	}
	
	function namespace(ns) {
	  return levels.reduce(function (logger, method) {
	    logger[method] = debug.bind(console, method, ns);
	    return logger;
	  }, {});
	}
	
	debug.level = namespace.level = function (newLevel) {
	  level = newLevel;
	};
	
	exports.default = namespace;
	
	/***/ }),
	/* 11 */
	/***/ (function(module, exports, __webpack_require__) {
	
	var pSlice = Array.prototype.slice;
	var objectKeys = __webpack_require__(52);
	var isArguments = __webpack_require__(53);
	
	var deepEqual = module.exports = function (actual, expected, opts) {
	  if (!opts) opts = {};
	  // 7.1. All identical values are equivalent, as determined by ===.
	  if (actual === expected) {
	    return true;
	
	  } else if (actual instanceof Date && expected instanceof Date) {
	    return actual.getTime() === expected.getTime();
	
	  // 7.3. Other pairs that do not both pass typeof value == 'object',
	  // equivalence is determined by ==.
	  } else if (!actual || !expected || typeof actual != 'object' && typeof expected != 'object') {
	    return opts.strict ? actual === expected : actual == expected;
	
	  // 7.4. For all other Object pairs, including Array objects, equivalence is
	  // determined by having the same number of owned properties (as verified
	  // with Object.prototype.hasOwnProperty.call), the same set of keys
	  // (although not necessarily the same order), equivalent values for every
	  // corresponding key, and an identical 'prototype' property. Note: this
	  // accounts for both named and indexed properties on Arrays.
	  } else {
	    return objEquiv(actual, expected, opts);
	  }
	}
	
	function isUndefinedOrNull(value) {
	  return value === null || value === undefined;
	}
	
	function isBuffer (x) {
	  if (!x || typeof x !== 'object' || typeof x.length !== 'number') return false;
	  if (typeof x.copy !== 'function' || typeof x.slice !== 'function') {
	    return false;
	  }
	  if (x.length > 0 && typeof x[0] !== 'number') return false;
	  return true;
	}
	
	function objEquiv(a, b, opts) {
	  var i, key;
	  if (isUndefinedOrNull(a) || isUndefinedOrNull(b))
	    return false;
	  // an identical 'prototype' property.
	  if (a.prototype !== b.prototype) return false;
	  //~~~I've managed to break Object.keys through screwy arguments passing.
	  //   Converting to array solves the problem.
	  if (isArguments(a)) {
	    if (!isArguments(b)) {
	      return false;
	    }
	    a = pSlice.call(a);
	    b = pSlice.call(b);
	    return deepEqual(a, b, opts);
	  }
	  if (isBuffer(a)) {
	    if (!isBuffer(b)) {
	      return false;
	    }
	    if (a.length !== b.length) return false;
	    for (i = 0; i < a.length; i++) {
	      if (a[i] !== b[i]) return false;
	    }
	    return true;
	  }
	  try {
	    var ka = objectKeys(a),
	        kb = objectKeys(b);
	  } catch (e) {//happens when one is a string literal and the other isn't
	    return false;
	  }
	  // having the same number of owned properties (keys incorporates
	  // hasOwnProperty)
	  if (ka.length != kb.length)
	    return false;
	  //the same set of keys (although not necessarily the same order),
	  ka.sort();
	  kb.sort();
	  //~~~cheap key test
	  for (i = ka.length - 1; i >= 0; i--) {
	    if (ka[i] != kb[i])
	      return false;
	  }
	  //equivalent values for every corresponding key, and
	  //~~~possibly expensive deep test
	  for (i = ka.length - 1; i >= 0; i--) {
	    key = ka[i];
	    if (!deepEqual(a[key], b[key], opts)) return false;
	  }
	  return typeof a === typeof b;
	}
	
	
	/***/ }),
	/* 12 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var Registry = __webpack_require__(1);
	var Attributor = /** @class */ (function () {
	    function Attributor(attrName, keyName, options) {
	        if (options === void 0) { options = {}; }
	        this.attrName = attrName;
	        this.keyName = keyName;
	        var attributeBit = Registry.Scope.TYPE & Registry.Scope.ATTRIBUTE;
	        if (options.scope != null) {
	            // Ignore type bits, force attribute bit
	            this.scope = (options.scope & Registry.Scope.LEVEL) | attributeBit;
	        }
	        else {
	            this.scope = Registry.Scope.ATTRIBUTE;
	        }
	        if (options.whitelist != null)
	            this.whitelist = options.whitelist;
	    }
	    Attributor.keys = function (node) {
	        return [].map.call(node.attributes, function (item) {
	            return item.name;
	        });
	    };
	    Attributor.prototype.add = function (node, value) {
	        if (!this.canAdd(node, value))
	            return false;
	        node.setAttribute(this.keyName, value);
	        return true;
	    };
	    Attributor.prototype.canAdd = function (node, value) {
	        var match = Registry.query(node, Registry.Scope.BLOT & (this.scope | Registry.Scope.TYPE));
	        if (match == null)
	            return false;
	        if (this.whitelist == null)
	            return true;
	        if (typeof value === 'string') {
	            return this.whitelist.indexOf(value.replace(/["']/g, '')) > -1;
	        }
	        else {
	            return this.whitelist.indexOf(value) > -1;
	        }
	    };
	    Attributor.prototype.remove = function (node) {
	        node.removeAttribute(this.keyName);
	    };
	    Attributor.prototype.value = function (node) {
	        var value = node.getAttribute(this.keyName);
	        if (this.canAdd(node, value) && value) {
	            return value;
	        }
	        return '';
	    };
	    return Attributor;
	}());
	exports.default = Attributor;
	
	
	/***/ }),
	/* 13 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.Code = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _quillDelta = __webpack_require__(2);
	
	var _quillDelta2 = _interopRequireDefault(_quillDelta);
	
	var _parchment = __webpack_require__(0);
	
	var _parchment2 = _interopRequireDefault(_parchment);
	
	var _block = __webpack_require__(4);
	
	var _block2 = _interopRequireDefault(_block);
	
	var _inline = __webpack_require__(6);
	
	var _inline2 = _interopRequireDefault(_inline);
	
	var _text = __webpack_require__(7);
	
	var _text2 = _interopRequireDefault(_text);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Code = function (_Inline) {
	  _inherits(Code, _Inline);
	
	  function Code() {
	    _classCallCheck(this, Code);
	
	    return _possibleConstructorReturn(this, (Code.__proto__ || Object.getPrototypeOf(Code)).apply(this, arguments));
	  }
	
	  return Code;
	}(_inline2.default);
	
	Code.blotName = 'code';
	Code.tagName = 'CODE';
	
	var CodeBlock = function (_Block) {
	  _inherits(CodeBlock, _Block);
	
	  function CodeBlock() {
	    _classCallCheck(this, CodeBlock);
	
	    return _possibleConstructorReturn(this, (CodeBlock.__proto__ || Object.getPrototypeOf(CodeBlock)).apply(this, arguments));
	  }
	
	  _createClass(CodeBlock, [{
	    key: 'delta',
	    value: function delta() {
	      var _this3 = this;
	
	      var text = this.domNode.textContent;
	      if (text.endsWith('\n')) {
	        // Should always be true
	        text = text.slice(0, -1);
	      }
	      return text.split('\n').reduce(function (delta, frag) {
	        return delta.insert(frag).insert('\n', _this3.formats());
	      }, new _quillDelta2.default());
	    }
	  }, {
	    key: 'format',
	    value: function format(name, value) {
	      if (name === this.statics.blotName && value) return;
	
	      var _descendant = this.descendant(_text2.default, this.length() - 1),
	          _descendant2 = _slicedToArray(_descendant, 1),
	          text = _descendant2[0];
	
	      if (text != null) {
	        text.deleteAt(text.length() - 1, 1);
	      }
	      _get(CodeBlock.prototype.__proto__ || Object.getPrototypeOf(CodeBlock.prototype), 'format', this).call(this, name, value);
	    }
	  }, {
	    key: 'formatAt',
	    value: function formatAt(index, length, name, value) {
	      if (length === 0) return;
	      if (_parchment2.default.query(name, _parchment2.default.Scope.BLOCK) == null || name === this.statics.blotName && value === this.statics.formats(this.domNode)) {
	        return;
	      }
	      var nextNewline = this.newlineIndex(index);
	      if (nextNewline < 0 || nextNewline >= index + length) return;
	      var prevNewline = this.newlineIndex(index, true) + 1;
	      var isolateLength = nextNewline - prevNewline + 1;
	      var blot = this.isolate(prevNewline, isolateLength);
	      var next = blot.next;
	      blot.format(name, value);
	      if (next instanceof CodeBlock) {
	        next.formatAt(0, index - prevNewline + length - isolateLength, name, value);
	      }
	    }
	  }, {
	    key: 'insertAt',
	    value: function insertAt(index, value, def) {
	      if (def != null) return;
	
	      var _descendant3 = this.descendant(_text2.default, index),
	          _descendant4 = _slicedToArray(_descendant3, 2),
	          text = _descendant4[0],
	          offset = _descendant4[1];
	
	      text.insertAt(offset, value);
	    }
	  }, {
	    key: 'length',
	    value: function length() {
	      var length = this.domNode.textContent.length;
	      if (!this.domNode.textContent.endsWith('\n')) {
	        return length + 1;
	      }
	      return length;
	    }
	  }, {
	    key: 'newlineIndex',
	    value: function newlineIndex(searchIndex) {
	      var reverse = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	      if (!reverse) {
	        var offset = this.domNode.textContent.slice(searchIndex).indexOf('\n');
	        return offset > -1 ? searchIndex + offset : -1;
	      } else {
	        return this.domNode.textContent.slice(0, searchIndex).lastIndexOf('\n');
	      }
	    }
	  }, {
	    key: 'optimize',
	    value: function optimize(context) {
	      if (!this.domNode.textContent.endsWith('\n')) {
	        this.appendChild(_parchment2.default.create('text', '\n'));
	      }
	      _get(CodeBlock.prototype.__proto__ || Object.getPrototypeOf(CodeBlock.prototype), 'optimize', this).call(this, context);
	      var next = this.next;
	      if (next != null && next.prev === this && next.statics.blotName === this.statics.blotName && this.statics.formats(this.domNode) === next.statics.formats(next.domNode)) {
	        next.optimize(context);
	        next.moveChildren(this);
	        next.remove();
	      }
	    }
	  }, {
	    key: 'replace',
	    value: function replace(target) {
	      _get(CodeBlock.prototype.__proto__ || Object.getPrototypeOf(CodeBlock.prototype), 'replace', this).call(this, target);
	      [].slice.call(this.domNode.querySelectorAll('*')).forEach(function (node) {
	        var blot = _parchment2.default.find(node);
	        if (blot == null) {
	          node.parentNode.removeChild(node);
	        } else if (blot instanceof _parchment2.default.Embed) {
	          blot.remove();
	        } else {
	          blot.unwrap();
	        }
	      });
	    }
	  }], [{
	    key: 'create',
	    value: function create(value) {
	      var domNode = _get(CodeBlock.__proto__ || Object.getPrototypeOf(CodeBlock), 'create', this).call(this, value);
	      domNode.setAttribute('spellcheck', false);
	      return domNode;
	    }
	  }, {
	    key: 'formats',
	    value: function formats() {
	      return true;
	    }
	  }]);
	
	  return CodeBlock;
	}(_block2.default);
	
	CodeBlock.blotName = 'code-block';
	CodeBlock.tagName = 'PRE';
	CodeBlock.TAB = '  ';
	
	exports.Code = Code;
	exports.default = CodeBlock;
	
	/***/ }),
	/* 14 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _quillDelta = __webpack_require__(2);
	
	var _quillDelta2 = _interopRequireDefault(_quillDelta);
	
	var _op = __webpack_require__(20);
	
	var _op2 = _interopRequireDefault(_op);
	
	var _parchment = __webpack_require__(0);
	
	var _parchment2 = _interopRequireDefault(_parchment);
	
	var _code = __webpack_require__(13);
	
	var _code2 = _interopRequireDefault(_code);
	
	var _cursor = __webpack_require__(24);
	
	var _cursor2 = _interopRequireDefault(_cursor);
	
	var _block = __webpack_require__(4);
	
	var _block2 = _interopRequireDefault(_block);
	
	var _break = __webpack_require__(16);
	
	var _break2 = _interopRequireDefault(_break);
	
	var _clone = __webpack_require__(21);
	
	var _clone2 = _interopRequireDefault(_clone);
	
	var _deepEqual = __webpack_require__(11);
	
	var _deepEqual2 = _interopRequireDefault(_deepEqual);
	
	var _extend = __webpack_require__(3);
	
	var _extend2 = _interopRequireDefault(_extend);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ASCII = /^[ -~]*$/;
	
	var Editor = function () {
	  function Editor(scroll) {
	    _classCallCheck(this, Editor);
	
	    this.scroll = scroll;
	    this.delta = this.getDelta();
	  }
	
	  _createClass(Editor, [{
	    key: 'applyDelta',
	    value: function applyDelta(delta) {
	      var _this = this;
	
	      var consumeNextNewline = false;
	      this.scroll.update();
	      var scrollLength = this.scroll.length();
	      this.scroll.batchStart();
	      delta = normalizeDelta(delta);
	      delta.reduce(function (index, op) {
	        var length = op.retain || op.delete || op.insert.length || 1;
	        var attributes = op.attributes || {};
	        if (op.insert != null) {
	          if (typeof op.insert === 'string') {
	            var text = op.insert;
	            if (text.endsWith('\n') && consumeNextNewline) {
	              consumeNextNewline = false;
	              text = text.slice(0, -1);
	            }
	            if (index >= scrollLength && !text.endsWith('\n')) {
	              consumeNextNewline = true;
	            }
	            _this.scroll.insertAt(index, text);
	
	            var _scroll$line = _this.scroll.line(index),
	                _scroll$line2 = _slicedToArray(_scroll$line, 2),
	                line = _scroll$line2[0],
	                offset = _scroll$line2[1];
	
	            var formats = (0, _extend2.default)({}, (0, _block.bubbleFormats)(line));
	            if (line instanceof _block2.default) {
	              var _line$descendant = line.descendant(_parchment2.default.Leaf, offset),
	                  _line$descendant2 = _slicedToArray(_line$descendant, 1),
	                  leaf = _line$descendant2[0];
	
	              formats = (0, _extend2.default)(formats, (0, _block.bubbleFormats)(leaf));
	            }
	            attributes = _op2.default.attributes.diff(formats, attributes) || {};
	          } else if (_typeof(op.insert) === 'object') {
	            var key = Object.keys(op.insert)[0]; // There should only be one key
	            if (key == null) return index;
	            _this.scroll.insertAt(index, key, op.insert[key]);
	          }
	          scrollLength += length;
	        }
	        Object.keys(attributes).forEach(function (name) {
	          _this.scroll.formatAt(index, length, name, attributes[name]);
	        });
	        return index + length;
	      }, 0);
	      delta.reduce(function (index, op) {
	        if (typeof op.delete === 'number') {
	          _this.scroll.deleteAt(index, op.delete);
	          return index;
	        }
	        return index + (op.retain || op.insert.length || 1);
	      }, 0);
	      this.scroll.batchEnd();
	      return this.update(delta);
	    }
	  }, {
	    key: 'deleteText',
	    value: function deleteText(index, length) {
	      this.scroll.deleteAt(index, length);
	      return this.update(new _quillDelta2.default().retain(index).delete(length));
	    }
	  }, {
	    key: 'formatLine',
	    value: function formatLine(index, length) {
	      var _this2 = this;
	
	      var formats = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	      this.scroll.update();
	      Object.keys(formats).forEach(function (format) {
	        if (_this2.scroll.whitelist != null && !_this2.scroll.whitelist[format]) return;
	        var lines = _this2.scroll.lines(index, Math.max(length, 1));
	        var lengthRemaining = length;
	        lines.forEach(function (line) {
	          var lineLength = line.length();
	          if (!(line instanceof _code2.default)) {
	            line.format(format, formats[format]);
	          } else {
	            var codeIndex = index - line.offset(_this2.scroll);
	            var codeLength = line.newlineIndex(codeIndex + lengthRemaining) - codeIndex + 1;
	            line.formatAt(codeIndex, codeLength, format, formats[format]);
	          }
	          lengthRemaining -= lineLength;
	        });
	      });
	      this.scroll.optimize();
	      return this.update(new _quillDelta2.default().retain(index).retain(length, (0, _clone2.default)(formats)));
	    }
	  }, {
	    key: 'formatText',
	    value: function formatText(index, length) {
	      var _this3 = this;
	
	      var formats = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	      Object.keys(formats).forEach(function (format) {
	        _this3.scroll.formatAt(index, length, format, formats[format]);
	      });
	      return this.update(new _quillDelta2.default().retain(index).retain(length, (0, _clone2.default)(formats)));
	    }
	  }, {
	    key: 'getContents',
	    value: function getContents(index, length) {
	      return this.delta.slice(index, index + length);
	    }
	  }, {
	    key: 'getDelta',
	    value: function getDelta() {
	      return this.scroll.lines().reduce(function (delta, line) {
	        return delta.concat(line.delta());
	      }, new _quillDelta2.default());
	    }
	  }, {
	    key: 'getFormat',
	    value: function getFormat(index) {
	      var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	
	      var lines = [],
	          leaves = [];
	      if (length === 0) {
	        this.scroll.path(index).forEach(function (path) {
	          var _path = _slicedToArray(path, 1),
	              blot = _path[0];
	
	          if (blot instanceof _block2.default) {
	            lines.push(blot);
	          } else if (blot instanceof _parchment2.default.Leaf) {
	            leaves.push(blot);
	          }
	        });
	      } else {
	        lines = this.scroll.lines(index, length);
	        leaves = this.scroll.descendants(_parchment2.default.Leaf, index, length);
	      }
	      var formatsArr = [lines, leaves].map(function (blots) {
	        if (blots.length === 0) return {};
	        var formats = (0, _block.bubbleFormats)(blots.shift());
	        while (Object.keys(formats).length > 0) {
	          var blot = blots.shift();
	          if (blot == null) return formats;
	          formats = combineFormats((0, _block.bubbleFormats)(blot), formats);
	        }
	        return formats;
	      });
	      return _extend2.default.apply(_extend2.default, formatsArr);
	    }
	  }, {
	    key: 'getText',
	    value: function getText(index, length) {
	      return this.getContents(index, length).filter(function (op) {
	        return typeof op.insert === 'string';
	      }).map(function (op) {
	        return op.insert;
	      }).join('');
	    }
	  }, {
	    key: 'insertEmbed',
	    value: function insertEmbed(index, embed, value) {
	      this.scroll.insertAt(index, embed, value);
	      return this.update(new _quillDelta2.default().retain(index).insert(_defineProperty({}, embed, value)));
	    }
	  }, {
	    key: 'insertText',
	    value: function insertText(index, text) {
	      var _this4 = this;
	
	      var formats = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	      text = text.replace(/\r\n/g, '\n').replace(/\r/g, '\n');
	      this.scroll.insertAt(index, text);
	      Object.keys(formats).forEach(function (format) {
	        _this4.scroll.formatAt(index, text.length, format, formats[format]);
	      });
	      return this.update(new _quillDelta2.default().retain(index).insert(text, (0, _clone2.default)(formats)));
	    }
	  }, {
	    key: 'isBlank',
	    value: function isBlank() {
	      if (this.scroll.children.length == 0) return true;
	      if (this.scroll.children.length > 1) return false;
	      var block = this.scroll.children.head;
	      if (block.statics.blotName !== _block2.default.blotName) return false;
	      if (block.children.length > 1) return false;
	      return block.children.head instanceof _break2.default;
	    }
	  }, {
	    key: 'removeFormat',
	    value: function removeFormat(index, length) {
	      var text = this.getText(index, length);
	
	      var _scroll$line3 = this.scroll.line(index + length),
	          _scroll$line4 = _slicedToArray(_scroll$line3, 2),
	          line = _scroll$line4[0],
	          offset = _scroll$line4[1];
	
	      var suffixLength = 0,
	          suffix = new _quillDelta2.default();
	      if (line != null) {
	        if (!(line instanceof _code2.default)) {
	          suffixLength = line.length() - offset;
	        } else {
	          suffixLength = line.newlineIndex(offset) - offset + 1;
	        }
	        suffix = line.delta().slice(offset, offset + suffixLength - 1).insert('\n');
	      }
	      var contents = this.getContents(index, length + suffixLength);
	      var diff = contents.diff(new _quillDelta2.default().insert(text).concat(suffix));
	      var delta = new _quillDelta2.default().retain(index).concat(diff);
	      return this.applyDelta(delta);
	    }
	  }, {
	    key: 'update',
	    value: function update(change) {
	      var mutations = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	      var cursorIndex = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
	
	      var oldDelta = this.delta;
	      if (mutations.length === 1 && mutations[0].type === 'characterData' && mutations[0].target.data.match(ASCII) && _parchment2.default.find(mutations[0].target)) {
	        // Optimization for character changes
	        var textBlot = _parchment2.default.find(mutations[0].target);
	        var formats = (0, _block.bubbleFormats)(textBlot);
	        var index = textBlot.offset(this.scroll);
	        var oldValue = mutations[0].oldValue.replace(_cursor2.default.CONTENTS, '');
	        var oldText = new _quillDelta2.default().insert(oldValue);
	        var newText = new _quillDelta2.default().insert(textBlot.value());
	        var diffDelta = new _quillDelta2.default().retain(index).concat(oldText.diff(newText, cursorIndex));
	        change = diffDelta.reduce(function (delta, op) {
	          if (op.insert) {
	            return delta.insert(op.insert, formats);
	          } else {
	            return delta.push(op);
	          }
	        }, new _quillDelta2.default());
	        this.delta = oldDelta.compose(change);
	      } else {
	        this.delta = this.getDelta();
	        if (!change || !(0, _deepEqual2.default)(oldDelta.compose(change), this.delta)) {
	          change = oldDelta.diff(this.delta, cursorIndex);
	        }
	      }
	      return change;
	    }
	  }]);
	
	  return Editor;
	}();
	
	function combineFormats(formats, combined) {
	  return Object.keys(combined).reduce(function (merged, name) {
	    if (formats[name] == null) return merged;
	    if (combined[name] === formats[name]) {
	      merged[name] = combined[name];
	    } else if (Array.isArray(combined[name])) {
	      if (combined[name].indexOf(formats[name]) < 0) {
	        merged[name] = combined[name].concat([formats[name]]);
	      }
	    } else {
	      merged[name] = [combined[name], formats[name]];
	    }
	    return merged;
	  }, {});
	}
	
	function normalizeDelta(delta) {
	  return delta.reduce(function (delta, op) {
	    if (op.insert === 1) {
	      var attributes = (0, _clone2.default)(op.attributes);
	      delete attributes['image'];
	      return delta.insert({ image: op.attributes.image }, attributes);
	    }
	    if (op.attributes != null && (op.attributes.list === true || op.attributes.bullet === true)) {
	      op = (0, _clone2.default)(op);
	      if (op.attributes.list) {
	        op.attributes.list = 'ordered';
	      } else {
	        op.attributes.list = 'bullet';
	        delete op.attributes.bullet;
	      }
	    }
	    if (typeof op.insert === 'string') {
	      var text = op.insert.replace(/\r\n/g, '\n').replace(/\r/g, '\n');
	      return delta.insert(text, op.attributes);
	    }
	    return delta.push(op);
	  }, new _quillDelta2.default());
	}
	
	exports.default = Editor;
	
	/***/ }),
	/* 15 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.Range = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _parchment = __webpack_require__(0);
	
	var _parchment2 = _interopRequireDefault(_parchment);
	
	var _clone = __webpack_require__(21);
	
	var _clone2 = _interopRequireDefault(_clone);
	
	var _deepEqual = __webpack_require__(11);
	
	var _deepEqual2 = _interopRequireDefault(_deepEqual);
	
	var _emitter3 = __webpack_require__(8);
	
	var _emitter4 = _interopRequireDefault(_emitter3);
	
	var _logger = __webpack_require__(10);
	
	var _logger2 = _interopRequireDefault(_logger);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var debug = (0, _logger2.default)('quill:selection');
	
	var Range = function Range(index) {
	  var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	
	  _classCallCheck(this, Range);
	
	  this.index = index;
	  this.length = length;
	};
	
	var Selection = function () {
	  function Selection(scroll, emitter) {
	    var _this = this;
	
	    _classCallCheck(this, Selection);
	
	    this.emitter = emitter;
	    this.scroll = scroll;
	    this.composing = false;
	    this.mouseDown = false;
	    this.root = this.scroll.domNode;
	    this.cursor = _parchment2.default.create('cursor', this);
	    // savedRange is last non-null range
	    this.lastRange = this.savedRange = new Range(0, 0);
	    this.handleComposition();
	    this.handleDragging();
	    this.emitter.listenDOM('selectionchange', document, function () {
	      if (!_this.mouseDown) {
	        setTimeout(_this.update.bind(_this, _emitter4.default.sources.USER), 1);
	      }
	    });
	    this.emitter.on(_emitter4.default.events.EDITOR_CHANGE, function (type, delta) {
	      if (type === _emitter4.default.events.TEXT_CHANGE && delta.length() > 0) {
	        _this.update(_emitter4.default.sources.SILENT);
	      }
	    });
	    this.emitter.on(_emitter4.default.events.SCROLL_BEFORE_UPDATE, function () {
	      if (!_this.hasFocus()) return;
	      var native = _this.getNativeRange();
	      if (native == null) return;
	      if (native.start.node === _this.cursor.textNode) return; // cursor.restore() will handle
	      // TODO unclear if this has negative side effects
	      _this.emitter.once(_emitter4.default.events.SCROLL_UPDATE, function () {
	        try {
	          _this.setNativeRange(native.start.node, native.start.offset, native.end.node, native.end.offset);
	        } catch (ignored) {}
	      });
	    });
	    this.emitter.on(_emitter4.default.events.SCROLL_OPTIMIZE, function (mutations, context) {
	      if (context.range) {
	        var _context$range = context.range,
	            startNode = _context$range.startNode,
	            startOffset = _context$range.startOffset,
	            endNode = _context$range.endNode,
	            endOffset = _context$range.endOffset;
	
	        _this.setNativeRange(startNode, startOffset, endNode, endOffset);
	      }
	    });
	    this.update(_emitter4.default.sources.SILENT);
	  }
	
	  _createClass(Selection, [{
	    key: 'handleComposition',
	    value: function handleComposition() {
	      var _this2 = this;
	
	      this.root.addEventListener('compositionstart', function () {
	        _this2.composing = true;
	      });
	      this.root.addEventListener('compositionend', function () {
	        _this2.composing = false;
	        if (_this2.cursor.parent) {
	          var range = _this2.cursor.restore();
	          if (!range) return;
	          setTimeout(function () {
	            _this2.setNativeRange(range.startNode, range.startOffset, range.endNode, range.endOffset);
	          }, 1);
	        }
	      });
	    }
	  }, {
	    key: 'handleDragging',
	    value: function handleDragging() {
	      var _this3 = this;
	
	      this.emitter.listenDOM('mousedown', document.body, function () {
	        _this3.mouseDown = true;
	      });
	      this.emitter.listenDOM('mouseup', document.body, function () {
	        _this3.mouseDown = false;
	        _this3.update(_emitter4.default.sources.USER);
	      });
	    }
	  }, {
	    key: 'focus',
	    value: function focus() {
	      if (this.hasFocus()) return;
	      this.root.focus();
	      this.setRange(this.savedRange);
	    }
	  }, {
	    key: 'format',
	    value: function format(_format, value) {
	      if (this.scroll.whitelist != null && !this.scroll.whitelist[_format]) return;
	      this.scroll.update();
	      var nativeRange = this.getNativeRange();
	      if (nativeRange == null || !nativeRange.native.collapsed || _parchment2.default.query(_format, _parchment2.default.Scope.BLOCK)) return;
	      if (nativeRange.start.node !== this.cursor.textNode) {
	        var blot = _parchment2.default.find(nativeRange.start.node, false);
	        if (blot == null) return;
	        // TODO Give blot ability to not split
	        if (blot instanceof _parchment2.default.Leaf) {
	          var after = blot.split(nativeRange.start.offset);
	          blot.parent.insertBefore(this.cursor, after);
	        } else {
	          blot.insertBefore(this.cursor, nativeRange.start.node); // Should never happen
	        }
	        this.cursor.attach();
	      }
	      this.cursor.format(_format, value);
	      this.scroll.optimize();
	      this.setNativeRange(this.cursor.textNode, this.cursor.textNode.data.length);
	      this.update();
	    }
	  }, {
	    key: 'getBounds',
	    value: function getBounds(index) {
	      var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	
	      var scrollLength = this.scroll.length();
	      index = Math.min(index, scrollLength - 1);
	      length = Math.min(index + length, scrollLength - 1) - index;
	      var node = void 0,
	          _scroll$leaf = this.scroll.leaf(index),
	          _scroll$leaf2 = _slicedToArray(_scroll$leaf, 2),
	          leaf = _scroll$leaf2[0],
	          offset = _scroll$leaf2[1];
	      if (leaf == null) return null;
	
	      var _leaf$position = leaf.position(offset, true);
	
	      var _leaf$position2 = _slicedToArray(_leaf$position, 2);
	
	      node = _leaf$position2[0];
	      offset = _leaf$position2[1];
	
	      var range = document.createRange();
	      if (length > 0) {
	        range.setStart(node, offset);
	
	        var _scroll$leaf3 = this.scroll.leaf(index + length);
	
	        var _scroll$leaf4 = _slicedToArray(_scroll$leaf3, 2);
	
	        leaf = _scroll$leaf4[0];
	        offset = _scroll$leaf4[1];
	
	        if (leaf == null) return null;
	
	        var _leaf$position3 = leaf.position(offset, true);
	
	        var _leaf$position4 = _slicedToArray(_leaf$position3, 2);
	
	        node = _leaf$position4[0];
	        offset = _leaf$position4[1];
	
	        range.setEnd(node, offset);
	        return range.getBoundingClientRect();
	      } else {
	        var side = 'left';
	        var rect = void 0;
	        if (node instanceof Text) {
	          if (offset < node.data.length) {
	            range.setStart(node, offset);
	            range.setEnd(node, offset + 1);
	          } else {
	            range.setStart(node, offset - 1);
	            range.setEnd(node, offset);
	            side = 'right';
	          }
	          rect = range.getBoundingClientRect();
	        } else {
	          rect = leaf.domNode.getBoundingClientRect();
	          if (offset > 0) side = 'right';
	        }
	        return {
	          bottom: rect.top + rect.height,
	          height: rect.height,
	          left: rect[side],
	          right: rect[side],
	          top: rect.top,
	          width: 0
	        };
	      }
	    }
	  }, {
	    key: 'getNativeRange',
	    value: function getNativeRange() {
	      var selection = document.getSelection();
	      if (selection == null || selection.rangeCount <= 0) return null;
	      var nativeRange = selection.getRangeAt(0);
	      if (nativeRange == null) return null;
	      var range = this.normalizeNative(nativeRange);
	      debug.info('getNativeRange', range);
	      return range;
	    }
	  }, {
	    key: 'getRange',
	    value: function getRange() {
	      var normalized = this.getNativeRange();
	      if (normalized == null) return [null, null];
	      var range = this.normalizedToRange(normalized);
	      return [range, normalized];
	    }
	  }, {
	    key: 'hasFocus',
	    value: function hasFocus() {
	      return document.activeElement === this.root;
	    }
	  }, {
	    key: 'normalizedToRange',
	    value: function normalizedToRange(range) {
	      var _this4 = this;
	
	      var positions = [[range.start.node, range.start.offset]];
	      if (!range.native.collapsed) {
	        positions.push([range.end.node, range.end.offset]);
	      }
	      var indexes = positions.map(function (position) {
	        var _position = _slicedToArray(position, 2),
	            node = _position[0],
	            offset = _position[1];
	
	        var blot = _parchment2.default.find(node, true);
	        var index = blot.offset(_this4.scroll);
	        if (offset === 0) {
	          return index;
	        } else if (blot instanceof _parchment2.default.Container) {
	          return index + blot.length();
	        } else {
	          return index + blot.index(node, offset);
	        }
	      });
	      var end = Math.min(Math.max.apply(Math, _toConsumableArray(indexes)), this.scroll.length() - 1);
	      var start = Math.min.apply(Math, [end].concat(_toConsumableArray(indexes)));
	      return new Range(start, end - start);
	    }
	  }, {
	    key: 'normalizeNative',
	    value: function normalizeNative(nativeRange) {
	      if (!contains(this.root, nativeRange.startContainer) || !nativeRange.collapsed && !contains(this.root, nativeRange.endContainer)) {
	        return null;
	      }
	      var range = {
	        start: { node: nativeRange.startContainer, offset: nativeRange.startOffset },
	        end: { node: nativeRange.endContainer, offset: nativeRange.endOffset },
	        native: nativeRange
	      };
	      [range.start, range.end].forEach(function (position) {
	        var node = position.node,
	            offset = position.offset;
	        while (!(node instanceof Text) && node.childNodes.length > 0) {
	          if (node.childNodes.length > offset) {
	            node = node.childNodes[offset];
	            offset = 0;
	          } else if (node.childNodes.length === offset) {
	            node = node.lastChild;
	            offset = node instanceof Text ? node.data.length : node.childNodes.length + 1;
	          } else {
	            break;
	          }
	        }
	        position.node = node, position.offset = offset;
	      });
	      return range;
	    }
	  }, {
	    key: 'rangeToNative',
	    value: function rangeToNative(range) {
	      var _this5 = this;
	
	      var indexes = range.collapsed ? [range.index] : [range.index, range.index + range.length];
	      var args = [];
	      var scrollLength = this.scroll.length();
	      indexes.forEach(function (index, i) {
	        index = Math.min(scrollLength - 1, index);
	        var node = void 0,
	            _scroll$leaf5 = _this5.scroll.leaf(index),
	            _scroll$leaf6 = _slicedToArray(_scroll$leaf5, 2),
	            leaf = _scroll$leaf6[0],
	            offset = _scroll$leaf6[1];
	        var _leaf$position5 = leaf.position(offset, i !== 0);
	
	        var _leaf$position6 = _slicedToArray(_leaf$position5, 2);
	
	        node = _leaf$position6[0];
	        offset = _leaf$position6[1];
	
	        args.push(node, offset);
	      });
	      if (args.length < 2) {
	        args = args.concat(args);
	      }
	      return args;
	    }
	  }, {
	    key: 'scrollIntoView',
	    value: function scrollIntoView(scrollingContainer) {
	      var range = this.lastRange;
	      if (range == null) return;
	      var bounds = this.getBounds(range.index, range.length);
	      if (bounds == null) return;
	      var limit = this.scroll.length() - 1;
	
	      var _scroll$line = this.scroll.line(Math.min(range.index, limit)),
	          _scroll$line2 = _slicedToArray(_scroll$line, 1),
	          first = _scroll$line2[0];
	
	      var last = first;
	      if (range.length > 0) {
	        var _scroll$line3 = this.scroll.line(Math.min(range.index + range.length, limit));
	
	        var _scroll$line4 = _slicedToArray(_scroll$line3, 1);
	
	        last = _scroll$line4[0];
	      }
	      if (first == null || last == null) return;
	      var scrollBounds = scrollingContainer.getBoundingClientRect();
	      if (bounds.top < scrollBounds.top) {
	        scrollingContainer.scrollTop -= scrollBounds.top - bounds.top;
	      } else if (bounds.bottom > scrollBounds.bottom) {
	        scrollingContainer.scrollTop += bounds.bottom - scrollBounds.bottom;
	      }
	    }
	  }, {
	    key: 'setNativeRange',
	    value: function setNativeRange(startNode, startOffset) {
	      var endNode = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : startNode;
	      var endOffset = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : startOffset;
	      var force = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
	
	      debug.info('setNativeRange', startNode, startOffset, endNode, endOffset);
	      if (startNode != null && (this.root.parentNode == null || startNode.parentNode == null || endNode.parentNode == null)) {
	        return;
	      }
	      var selection = document.getSelection();
	      if (selection == null) return;
	      if (startNode != null) {
	        if (!this.hasFocus()) this.root.focus();
	        var native = (this.getNativeRange() || {}).native;
	        if (native == null || force || startNode !== native.startContainer || startOffset !== native.startOffset || endNode !== native.endContainer || endOffset !== native.endOffset) {
	
	          if (startNode.tagName == "BR") {
	            startOffset = [].indexOf.call(startNode.parentNode.childNodes, startNode);
	            startNode = startNode.parentNode;
	          }
	          if (endNode.tagName == "BR") {
	            endOffset = [].indexOf.call(endNode.parentNode.childNodes, endNode);
	            endNode = endNode.parentNode;
	          }
	          var range = document.createRange();
	          range.setStart(startNode, startOffset);
	          range.setEnd(endNode, endOffset);
	          selection.removeAllRanges();
	          selection.addRange(range);
	        }
	      } else {
	        selection.removeAllRanges();
	        this.root.blur();
	        document.body.focus(); // root.blur() not enough on IE11+Travis+SauceLabs (but not local VMs)
	      }
	    }
	  }, {
	    key: 'setRange',
	    value: function setRange(range) {
	      var force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	      var source = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _emitter4.default.sources.API;
	
	      if (typeof force === 'string') {
	        source = force;
	        force = false;
	      }
	      debug.info('setRange', range);
	      if (range != null) {
	        var args = this.rangeToNative(range);
	        this.setNativeRange.apply(this, _toConsumableArray(args).concat([force]));
	      } else {
	        this.setNativeRange(null);
	      }
	      this.update(source);
	    }
	  }, {
	    key: 'update',
	    value: function update() {
	      var source = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _emitter4.default.sources.USER;
	
	      var oldRange = this.lastRange;
	
	      var _getRange = this.getRange(),
	          _getRange2 = _slicedToArray(_getRange, 2),
	          lastRange = _getRange2[0],
	          nativeRange = _getRange2[1];
	
	      this.lastRange = lastRange;
	      if (this.lastRange != null) {
	        this.savedRange = this.lastRange;
	      }
	      if (!(0, _deepEqual2.default)(oldRange, this.lastRange)) {
	        var _emitter;
	
	        if (!this.composing && nativeRange != null && nativeRange.native.collapsed && nativeRange.start.node !== this.cursor.textNode) {
	          this.cursor.restore();
	        }
	        var args = [_emitter4.default.events.SELECTION_CHANGE, (0, _clone2.default)(this.lastRange), (0, _clone2.default)(oldRange), source];
	        (_emitter = this.emitter).emit.apply(_emitter, [_emitter4.default.events.EDITOR_CHANGE].concat(args));
	        if (source !== _emitter4.default.sources.SILENT) {
	          var _emitter2;
	
	          (_emitter2 = this.emitter).emit.apply(_emitter2, args);
	        }
	      }
	    }
	  }]);
	
	  return Selection;
	}();
	
	function contains(parent, descendant) {
	  try {
	    // Firefox inserts inaccessible nodes around video elements
	    descendant.parentNode;
	  } catch (e) {
	    return false;
	  }
	  // IE11 has bug with Text nodes
	  // https://connect.microsoft.com/IE/feedback/details/780874/node-contains-is-incorrect
	  if (descendant instanceof Text) {
	    descendant = descendant.parentNode;
	  }
	  return parent.contains(descendant);
	}
	
	exports.Range = Range;
	exports.default = Selection;
	
	/***/ }),
	/* 16 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _parchment = __webpack_require__(0);
	
	var _parchment2 = _interopRequireDefault(_parchment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Break = function (_Parchment$Embed) {
	  _inherits(Break, _Parchment$Embed);
	
	  function Break() {
	    _classCallCheck(this, Break);
	
	    return _possibleConstructorReturn(this, (Break.__proto__ || Object.getPrototypeOf(Break)).apply(this, arguments));
	  }
	
	  _createClass(Break, [{
	    key: 'insertInto',
	    value: function insertInto(parent, ref) {
	      if (parent.children.length === 0) {
	        _get(Break.prototype.__proto__ || Object.getPrototypeOf(Break.prototype), 'insertInto', this).call(this, parent, ref);
	      } else {
	        this.remove();
	      }
	    }
	  }, {
	    key: 'length',
	    value: function length() {
	      return 0;
	    }
	  }, {
	    key: 'value',
	    value: function value() {
	      return '';
	    }
	  }], [{
	    key: 'value',
	    value: function value() {
	      return undefined;
	    }
	  }]);
	
	  return Break;
	}(_parchment2.default.Embed);
	
	Break.blotName = 'break';
	Break.tagName = 'BR';
	
	exports.default = Break;
	
	/***/ }),
	/* 17 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var linked_list_1 = __webpack_require__(44);
	var shadow_1 = __webpack_require__(30);
	var Registry = __webpack_require__(1);
	var ContainerBlot = /** @class */ (function (_super) {
	    __extends(ContainerBlot, _super);
	    function ContainerBlot(domNode) {
	        var _this = _super.call(this, domNode) || this;
	        _this.build();
	        return _this;
	    }
	    ContainerBlot.prototype.appendChild = function (other) {
	        this.insertBefore(other);
	    };
	    ContainerBlot.prototype.attach = function () {
	        _super.prototype.attach.call(this);
	        this.children.forEach(function (child) {
	            child.attach();
	        });
	    };
	    ContainerBlot.prototype.build = function () {
	        var _this = this;
	        this.children = new linked_list_1.default();
	        // Need to be reversed for if DOM nodes already in order
	        [].slice
	            .call(this.domNode.childNodes)
	            .reverse()
	            .forEach(function (node) {
	            try {
	                var child = makeBlot(node);
	                _this.insertBefore(child, _this.children.head || undefined);
	            }
	            catch (err) {
	                if (err instanceof Registry.ParchmentError)
	                    return;
	                else
	                    throw err;
	            }
	        });
	    };
	    ContainerBlot.prototype.deleteAt = function (index, length) {
	        if (index === 0 && length === this.length()) {
	            return this.remove();
	        }
	        this.children.forEachAt(index, length, function (child, offset, length) {
	            child.deleteAt(offset, length);
	        });
	    };
	    ContainerBlot.prototype.descendant = function (criteria, index) {
	        var _a = this.children.find(index), child = _a[0], offset = _a[1];
	        if ((criteria.blotName == null && criteria(child)) ||
	            (criteria.blotName != null && child instanceof criteria)) {
	            return [child, offset];
	        }
	        else if (child instanceof ContainerBlot) {
	            return child.descendant(criteria, offset);
	        }
	        else {
	            return [null, -1];
	        }
	    };
	    ContainerBlot.prototype.descendants = function (criteria, index, length) {
	        if (index === void 0) { index = 0; }
	        if (length === void 0) { length = Number.MAX_VALUE; }
	        var descendants = [];
	        var lengthLeft = length;
	        this.children.forEachAt(index, length, function (child, index, length) {
	            if ((criteria.blotName == null && criteria(child)) ||
	                (criteria.blotName != null && child instanceof criteria)) {
	                descendants.push(child);
	            }
	            if (child instanceof ContainerBlot) {
	                descendants = descendants.concat(child.descendants(criteria, index, lengthLeft));
	            }
	            lengthLeft -= length;
	        });
	        return descendants;
	    };
	    ContainerBlot.prototype.detach = function () {
	        this.children.forEach(function (child) {
	            child.detach();
	        });
	        _super.prototype.detach.call(this);
	    };
	    ContainerBlot.prototype.formatAt = function (index, length, name, value) {
	        this.children.forEachAt(index, length, function (child, offset, length) {
	            child.formatAt(offset, length, name, value);
	        });
	    };
	    ContainerBlot.prototype.insertAt = function (index, value, def) {
	        var _a = this.children.find(index), child = _a[0], offset = _a[1];
	        if (child) {
	            child.insertAt(offset, value, def);
	        }
	        else {
	            var blot = def == null ? Registry.create('text', value) : Registry.create(value, def);
	            this.appendChild(blot);
	        }
	    };
	    ContainerBlot.prototype.insertBefore = function (childBlot, refBlot) {
	        if (this.statics.allowedChildren != null &&
	            !this.statics.allowedChildren.some(function (child) {
	                return childBlot instanceof child;
	            })) {
	            throw new Registry.ParchmentError("Cannot insert " + childBlot.statics.blotName + " into " + this.statics.blotName);
	        }
	        childBlot.insertInto(this, refBlot);
	    };
	    ContainerBlot.prototype.length = function () {
	        return this.children.reduce(function (memo, child) {
	            return memo + child.length();
	        }, 0);
	    };
	    ContainerBlot.prototype.moveChildren = function (targetParent, refNode) {
	        this.children.forEach(function (child) {
	            targetParent.insertBefore(child, refNode);
	        });
	    };
	    ContainerBlot.prototype.optimize = function (context) {
	        _super.prototype.optimize.call(this, context);
	        if (this.children.length === 0) {
	            if (this.statics.defaultChild != null) {
	                var child = Registry.create(this.statics.defaultChild);
	                this.appendChild(child);
	                child.optimize(context);
	            }
	            else {
	                this.remove();
	            }
	        }
	    };
	    ContainerBlot.prototype.path = function (index, inclusive) {
	        if (inclusive === void 0) { inclusive = false; }
	        var _a = this.children.find(index, inclusive), child = _a[0], offset = _a[1];
	        var position = [[this, index]];
	        if (child instanceof ContainerBlot) {
	            return position.concat(child.path(offset, inclusive));
	        }
	        else if (child != null) {
	            position.push([child, offset]);
	        }
	        return position;
	    };
	    ContainerBlot.prototype.removeChild = function (child) {
	        this.children.remove(child);
	    };
	    ContainerBlot.prototype.replace = function (target) {
	        if (target instanceof ContainerBlot) {
	            target.moveChildren(this);
	        }
	        _super.prototype.replace.call(this, target);
	    };
	    ContainerBlot.prototype.split = function (index, force) {
	        if (force === void 0) { force = false; }
	        if (!force) {
	            if (index === 0)
	                return this;
	            if (index === this.length())
	                return this.next;
	        }
	        var after = this.clone();
	        this.parent.insertBefore(after, this.next);
	        this.children.forEachAt(index, this.length(), function (child, offset, length) {
	            child = child.split(offset, force);
	            after.appendChild(child);
	        });
	        return after;
	    };
	    ContainerBlot.prototype.unwrap = function () {
	        this.moveChildren(this.parent, this.next);
	        this.remove();
	    };
	    ContainerBlot.prototype.update = function (mutations, context) {
	        var _this = this;
	        var addedNodes = [];
	        var removedNodes = [];
	        mutations.forEach(function (mutation) {
	            if (mutation.target === _this.domNode && mutation.type === 'childList') {
	                addedNodes.push.apply(addedNodes, mutation.addedNodes);
	                removedNodes.push.apply(removedNodes, mutation.removedNodes);
	            }
	        });
	        removedNodes.forEach(function (node) {
	            // Check node has actually been removed
	            // One exception is Chrome does not immediately remove IFRAMEs
	            // from DOM but MutationRecord is correct in its reported removal
	            if (node.parentNode != null &&
	                // @ts-ignore
	                node.tagName !== 'IFRAME' &&
	                document.body.compareDocumentPosition(node) & Node.DOCUMENT_POSITION_CONTAINED_BY) {
	                return;
	            }
	            var blot = Registry.find(node);
	            if (blot == null)
	                return;
	            if (blot.domNode.parentNode == null || blot.domNode.parentNode === _this.domNode) {
	                blot.detach();
	            }
	        });
	        addedNodes
	            .filter(function (node) {
	            return node.parentNode == _this.domNode;
	        })
	            .sort(function (a, b) {
	            if (a === b)
	                return 0;
	            if (a.compareDocumentPosition(b) & Node.DOCUMENT_POSITION_FOLLOWING) {
	                return 1;
	            }
	            return -1;
	        })
	            .forEach(function (node) {
	            var refBlot = null;
	            if (node.nextSibling != null) {
	                refBlot = Registry.find(node.nextSibling);
	            }
	            var blot = makeBlot(node);
	            if (blot.next != refBlot || blot.next == null) {
	                if (blot.parent != null) {
	                    blot.parent.removeChild(_this);
	                }
	                _this.insertBefore(blot, refBlot || undefined);
	            }
	        });
	    };
	    return ContainerBlot;
	}(shadow_1.default));
	function makeBlot(node) {
	    var blot = Registry.find(node);
	    if (blot == null) {
	        try {
	            blot = Registry.create(node);
	        }
	        catch (e) {
	            blot = Registry.create(Registry.Scope.INLINE);
	            [].slice.call(node.childNodes).forEach(function (child) {
	                // @ts-ignore
	                blot.domNode.appendChild(child);
	            });
	            if (node.parentNode) {
	                node.parentNode.replaceChild(blot.domNode, node);
	            }
	            blot.attach();
	        }
	    }
	    return blot;
	}
	exports.default = ContainerBlot;
	
	
	/***/ }),
	/* 18 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var attributor_1 = __webpack_require__(12);
	var store_1 = __webpack_require__(31);
	var container_1 = __webpack_require__(17);
	var Registry = __webpack_require__(1);
	var FormatBlot = /** @class */ (function (_super) {
	    __extends(FormatBlot, _super);
	    function FormatBlot(domNode) {
	        var _this = _super.call(this, domNode) || this;
	        _this.attributes = new store_1.default(_this.domNode);
	        return _this;
	    }
	    FormatBlot.formats = function (domNode) {
	        if (typeof this.tagName === 'string') {
	            return true;
	        }
	        else if (Array.isArray(this.tagName)) {
	            return domNode.tagName.toLowerCase();
	        }
	        return undefined;
	    };
	    FormatBlot.prototype.format = function (name, value) {
	        var format = Registry.query(name);
	        if (format instanceof attributor_1.default) {
	            this.attributes.attribute(format, value);
	        }
	        else if (value) {
	            if (format != null && (name !== this.statics.blotName || this.formats()[name] !== value)) {
	                this.replaceWith(name, value);
	            }
	        }
	    };
	    FormatBlot.prototype.formats = function () {
	        var formats = this.attributes.values();
	        var format = this.statics.formats(this.domNode);
	        if (format != null) {
	            formats[this.statics.blotName] = format;
	        }
	        return formats;
	    };
	    FormatBlot.prototype.replaceWith = function (name, value) {
	        var replacement = _super.prototype.replaceWith.call(this, name, value);
	        this.attributes.copy(replacement);
	        return replacement;
	    };
	    FormatBlot.prototype.update = function (mutations, context) {
	        var _this = this;
	        _super.prototype.update.call(this, mutations, context);
	        if (mutations.some(function (mutation) {
	            return mutation.target === _this.domNode && mutation.type === 'attributes';
	        })) {
	            this.attributes.build();
	        }
	    };
	    FormatBlot.prototype.wrap = function (name, value) {
	        var wrapper = _super.prototype.wrap.call(this, name, value);
	        if (wrapper instanceof FormatBlot && wrapper.statics.scope === this.statics.scope) {
	            this.attributes.move(wrapper);
	        }
	        return wrapper;
	    };
	    return FormatBlot;
	}(container_1.default));
	exports.default = FormatBlot;
	
	
	/***/ }),
	/* 19 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var shadow_1 = __webpack_require__(30);
	var Registry = __webpack_require__(1);
	var LeafBlot = /** @class */ (function (_super) {
	    __extends(LeafBlot, _super);
	    function LeafBlot() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    LeafBlot.value = function (domNode) {
	        return true;
	    };
	    LeafBlot.prototype.index = function (node, offset) {
	        if (this.domNode === node ||
	            this.domNode.compareDocumentPosition(node) & Node.DOCUMENT_POSITION_CONTAINED_BY) {
	            return Math.min(offset, 1);
	        }
	        return -1;
	    };
	    LeafBlot.prototype.position = function (index, inclusive) {
	        var offset = [].indexOf.call(this.parent.domNode.childNodes, this.domNode);
	        if (index > 0)
	            offset += 1;
	        return [this.parent.domNode, offset];
	    };
	    LeafBlot.prototype.value = function () {
	        var _a;
	        return _a = {}, _a[this.statics.blotName] = this.statics.value(this.domNode) || true, _a;
	    };
	    LeafBlot.scope = Registry.Scope.INLINE_BLOT;
	    return LeafBlot;
	}(shadow_1.default));
	exports.default = LeafBlot;
	
	
	/***/ }),
	/* 20 */
	/***/ (function(module, exports, __webpack_require__) {
	
	var equal = __webpack_require__(11);
	var extend = __webpack_require__(3);
	
	
	var lib = {
	  attributes: {
	    compose: function (a, b, keepNull) {
	      if (typeof a !== 'object') a = {};
	      if (typeof b !== 'object') b = {};
	      var attributes = extend(true, {}, b);
	      if (!keepNull) {
	        attributes = Object.keys(attributes).reduce(function (copy, key) {
	          if (attributes[key] != null) {
	            copy[key] = attributes[key];
	          }
	          return copy;
	        }, {});
	      }
	      for (var key in a) {
	        if (a[key] !== undefined && b[key] === undefined) {
	          attributes[key] = a[key];
	        }
	      }
	      return Object.keys(attributes).length > 0 ? attributes : undefined;
	    },
	
	    diff: function(a, b) {
	      if (typeof a !== 'object') a = {};
	      if (typeof b !== 'object') b = {};
	      var attributes = Object.keys(a).concat(Object.keys(b)).reduce(function (attributes, key) {
	        if (!equal(a[key], b[key])) {
	          attributes[key] = b[key] === undefined ? null : b[key];
	        }
	        return attributes;
	      }, {});
	      return Object.keys(attributes).length > 0 ? attributes : undefined;
	    },
	
	    transform: function (a, b, priority) {
	      if (typeof a !== 'object') return b;
	      if (typeof b !== 'object') return undefined;
	      if (!priority) return b;  // b simply overwrites us without priority
	      var attributes = Object.keys(b).reduce(function (attributes, key) {
	        if (a[key] === undefined) attributes[key] = b[key];  // null is a valid value
	        return attributes;
	      }, {});
	      return Object.keys(attributes).length > 0 ? attributes : undefined;
	    }
	  },
	
	  iterator: function (ops) {
	    return new Iterator(ops);
	  },
	
	  length: function (op) {
	    if (typeof op['delete'] === 'number') {
	      return op['delete'];
	    } else if (typeof op.retain === 'number') {
	      return op.retain;
	    } else {
	      return typeof op.insert === 'string' ? op.insert.length : 1;
	    }
	  }
	};
	
	
	function Iterator(ops) {
	  this.ops = ops;
	  this.index = 0;
	  this.offset = 0;
	};
	
	Iterator.prototype.hasNext = function () {
	  return this.peekLength() < Infinity;
	};
	
	Iterator.prototype.next = function (length) {
	  if (!length) length = Infinity;
	  var nextOp = this.ops[this.index];
	  if (nextOp) {
	    var offset = this.offset;
	    var opLength = lib.length(nextOp)
	    if (length >= opLength - offset) {
	      length = opLength - offset;
	      this.index += 1;
	      this.offset = 0;
	    } else {
	      this.offset += length;
	    }
	    if (typeof nextOp['delete'] === 'number') {
	      return { 'delete': length };
	    } else {
	      var retOp = {};
	      if (nextOp.attributes) {
	        retOp.attributes = nextOp.attributes;
	      }
	      if (typeof nextOp.retain === 'number') {
	        retOp.retain = length;
	      } else if (typeof nextOp.insert === 'string') {
	        retOp.insert = nextOp.insert.substr(offset, length);
	      } else {
	        // offset should === 0, length should === 1
	        retOp.insert = nextOp.insert;
	      }
	      return retOp;
	    }
	  } else {
	    return { retain: Infinity };
	  }
	};
	
	Iterator.prototype.peek = function () {
	  return this.ops[this.index];
	};
	
	Iterator.prototype.peekLength = function () {
	  if (this.ops[this.index]) {
	    // Should never return 0 if our index is being managed correctly
	    return lib.length(this.ops[this.index]) - this.offset;
	  } else {
	    return Infinity;
	  }
	};
	
	Iterator.prototype.peekType = function () {
	  if (this.ops[this.index]) {
	    if (typeof this.ops[this.index]['delete'] === 'number') {
	      return 'delete';
	    } else if (typeof this.ops[this.index].retain === 'number') {
	      return 'retain';
	    } else {
	      return 'insert';
	    }
	  }
	  return 'retain';
	};
	
	Iterator.prototype.rest = function () {
	  if (!this.hasNext()) {
	    return [];
	  } else if (this.offset === 0) {
	    return this.ops.slice(this.index);
	  } else {
	    var offset = this.offset;
	    var index = this.index;
	    var next = this.next();
	    var rest = this.ops.slice(this.index);
	    this.offset = offset;
	    this.index = index;
	    return [next].concat(rest);
	  }
	};
	
	
	module.exports = lib;
	
	
	/***/ }),
	/* 21 */
	/***/ (function(module, exports) {
	
	var clone = (function() {
	'use strict';
	
	function _instanceof(obj, type) {
	  return type != null && obj instanceof type;
	}
	
	var nativeMap;
	try {
	  nativeMap = Map;
	} catch(_) {
	  // maybe a reference error because no `Map`. Give it a dummy value that no
	  // value will ever be an instanceof.
	  nativeMap = function() {};
	}
	
	var nativeSet;
	try {
	  nativeSet = Set;
	} catch(_) {
	  nativeSet = function() {};
	}
	
	var nativePromise;
	try {
	  nativePromise = Promise;
	} catch(_) {
	  nativePromise = function() {};
	}
	
	/**
	 * Clones (copies) an Object using deep copying.
	 *
	 * This function supports circular references by default, but if you are certain
	 * there are no circular references in your object, you can save some CPU time
	 * by calling clone(obj, false).
	 *
	 * Caution: if `circular` is false and `parent` contains circular references,
	 * your program may enter an infinite loop and crash.
	 *
	 * @param `parent` - the object to be cloned
	 * @param `circular` - set to true if the object to be cloned may contain
	 *    circular references. (optional - true by default)
	 * @param `depth` - set to a number if the object is only to be cloned to
	 *    a particular depth. (optional - defaults to Infinity)
	 * @param `prototype` - sets the prototype to be used when cloning an object.
	 *    (optional - defaults to parent prototype).
	 * @param `includeNonEnumerable` - set to true if the non-enumerable properties
	 *    should be cloned as well. Non-enumerable properties on the prototype
	 *    chain will be ignored. (optional - false by default)
	*/
	function clone(parent, circular, depth, prototype, includeNonEnumerable) {
	  if (typeof circular === 'object') {
	    depth = circular.depth;
	    prototype = circular.prototype;
	    includeNonEnumerable = circular.includeNonEnumerable;
	    circular = circular.circular;
	  }
	  // maintain two arrays for circular references, where corresponding parents
	  // and children have the same index
	  var allParents = [];
	  var allChildren = [];
	
	  var useBuffer = typeof Buffer != 'undefined';
	
	  if (typeof circular == 'undefined')
	    circular = true;
	
	  if (typeof depth == 'undefined')
	    depth = Infinity;
	
	  // recurse this function so we don't reset allParents and allChildren
	  function _clone(parent, depth) {
	    // cloning null always returns null
	    if (parent === null)
	      return null;
	
	    if (depth === 0)
	      return parent;
	
	    var child;
	    var proto;
	    if (typeof parent != 'object') {
	      return parent;
	    }
	
	    if (_instanceof(parent, nativeMap)) {
	      child = new nativeMap();
	    } else if (_instanceof(parent, nativeSet)) {
	      child = new nativeSet();
	    } else if (_instanceof(parent, nativePromise)) {
	      child = new nativePromise(function (resolve, reject) {
	        parent.then(function(value) {
	          resolve(_clone(value, depth - 1));
	        }, function(err) {
	          reject(_clone(err, depth - 1));
	        });
	      });
	    } else if (clone.__isArray(parent)) {
	      child = [];
	    } else if (clone.__isRegExp(parent)) {
	      child = new RegExp(parent.source, __getRegExpFlags(parent));
	      if (parent.lastIndex) child.lastIndex = parent.lastIndex;
	    } else if (clone.__isDate(parent)) {
	      child = new Date(parent.getTime());
	    } else if (useBuffer && Buffer.isBuffer(parent)) {
	      if (Buffer.allocUnsafe) {
	        // Node.js >= 4.5.0
	        child = Buffer.allocUnsafe(parent.length);
	      } else {
	        // Older Node.js versions
	        child = new Buffer(parent.length);
	      }
	      parent.copy(child);
	      return child;
	    } else if (_instanceof(parent, Error)) {
	      child = Object.create(parent);
	    } else {
	      if (typeof prototype == 'undefined') {
	        proto = Object.getPrototypeOf(parent);
	        child = Object.create(proto);
	      }
	      else {
	        child = Object.create(prototype);
	        proto = prototype;
	      }
	    }
	
	    if (circular) {
	      var index = allParents.indexOf(parent);
	
	      if (index != -1) {
	        return allChildren[index];
	      }
	      allParents.push(parent);
	      allChildren.push(child);
	    }
	
	    if (_instanceof(parent, nativeMap)) {
	      parent.forEach(function(value, key) {
	        var keyChild = _clone(key, depth - 1);
	        var valueChild = _clone(value, depth - 1);
	        child.set(keyChild, valueChild);
	      });
	    }
	    if (_instanceof(parent, nativeSet)) {
	      parent.forEach(function(value) {
	        var entryChild = _clone(value, depth - 1);
	        child.add(entryChild);
	      });
	    }
	
	    for (var i in parent) {
	      var attrs;
	      if (proto) {
	        attrs = Object.getOwnPropertyDescriptor(proto, i);
	      }
	
	      if (attrs && attrs.set == null) {
	        continue;
	      }
	      child[i] = _clone(parent[i], depth - 1);
	    }
	
	    if (Object.getOwnPropertySymbols) {
	      var symbols = Object.getOwnPropertySymbols(parent);
	      for (var i = 0; i < symbols.length; i++) {
	        // Don't need to worry about cloning a symbol because it is a primitive,
	        // like a number or string.
	        var symbol = symbols[i];
	        var descriptor = Object.getOwnPropertyDescriptor(parent, symbol);
	        if (descriptor && !descriptor.enumerable && !includeNonEnumerable) {
	          continue;
	        }
	        child[symbol] = _clone(parent[symbol], depth - 1);
	        if (!descriptor.enumerable) {
	          Object.defineProperty(child, symbol, {
	            enumerable: false
	          });
	        }
	      }
	    }
	
	    if (includeNonEnumerable) {
	      var allPropertyNames = Object.getOwnPropertyNames(parent);
	      for (var i = 0; i < allPropertyNames.length; i++) {
	        var propertyName = allPropertyNames[i];
	        var descriptor = Object.getOwnPropertyDescriptor(parent, propertyName);
	        if (descriptor && descriptor.enumerable) {
	          continue;
	        }
	        child[propertyName] = _clone(parent[propertyName], depth - 1);
	        Object.defineProperty(child, propertyName, {
	          enumerable: false
	        });
	      }
	    }
	
	    return child;
	  }
	
	  return _clone(parent, depth);
	}
	
	/**
	 * Simple flat clone using prototype, accepts only objects, usefull for property
	 * override on FLAT configuration object (no nested props).
	 *
	 * USE WITH CAUTION! This may not behave as you wish if you do not know how this
	 * works.
	 */
	clone.clonePrototype = function clonePrototype(parent) {
	  if (parent === null)
	    return null;
	
	  var c = function () {};
	  c.prototype = parent;
	  return new c();
	};
	
	// private utility functions
	
	function __objToStr(o) {
	  return Object.prototype.toString.call(o);
	}
	clone.__objToStr = __objToStr;
	
	function __isDate(o) {
	  return typeof o === 'object' && __objToStr(o) === '[object Date]';
	}
	clone.__isDate = __isDate;
	
	function __isArray(o) {
	  return typeof o === 'object' && __objToStr(o) === '[object Array]';
	}
	clone.__isArray = __isArray;
	
	function __isRegExp(o) {
	  return typeof o === 'object' && __objToStr(o) === '[object RegExp]';
	}
	clone.__isRegExp = __isRegExp;
	
	function __getRegExpFlags(re) {
	  var flags = '';
	  if (re.global) flags += 'g';
	  if (re.ignoreCase) flags += 'i';
	  if (re.multiline) flags += 'm';
	  return flags;
	}
	clone.__getRegExpFlags = __getRegExpFlags;
	
	return clone;
	})();
	
	if (typeof module === 'object' && module.exports) {
	  module.exports = clone;
	}
	
	
	/***/ }),
	/* 22 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _parchment = __webpack_require__(0);
	
	var _parchment2 = _interopRequireDefault(_parchment);
	
	var _emitter = __webpack_require__(8);
	
	var _emitter2 = _interopRequireDefault(_emitter);
	
	var _block = __webpack_require__(4);
	
	var _block2 = _interopRequireDefault(_block);
	
	var _break = __webpack_require__(16);
	
	var _break2 = _interopRequireDefault(_break);
	
	var _code = __webpack_require__(13);
	
	var _code2 = _interopRequireDefault(_code);
	
	var _container = __webpack_require__(25);
	
	var _container2 = _interopRequireDefault(_container);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function isLine(blot) {
	  return blot instanceof _block2.default || blot instanceof _block.BlockEmbed;
	}
	
	var Scroll = function (_Parchment$Scroll) {
	  _inherits(Scroll, _Parchment$Scroll);
	
	  function Scroll(domNode, config) {
	    _classCallCheck(this, Scroll);
	
	    var _this = _possibleConstructorReturn(this, (Scroll.__proto__ || Object.getPrototypeOf(Scroll)).call(this, domNode));
	
	    _this.emitter = config.emitter;
	    if (Array.isArray(config.whitelist)) {
	      _this.whitelist = config.whitelist.reduce(function (whitelist, format) {
	        whitelist[format] = true;
	        return whitelist;
	      }, {});
	    }
	    // Some reason fixes composition issues with character languages in Windows/Chrome, Safari
	    _this.domNode.addEventListener('DOMNodeInserted', function () {});
	    _this.optimize();
	    _this.enable();
	    return _this;
	  }
	
	  _createClass(Scroll, [{
	    key: 'batchStart',
	    value: function batchStart() {
	      this.batch = true;
	    }
	  }, {
	    key: 'batchEnd',
	    value: function batchEnd() {
	      this.batch = false;
	      this.optimize();
	    }
	  }, {
	    key: 'deleteAt',
	    value: function deleteAt(index, length) {
	      var _line = this.line(index),
	          _line2 = _slicedToArray(_line, 2),
	          first = _line2[0],
	          offset = _line2[1];
	
	      var _line3 = this.line(index + length),
	          _line4 = _slicedToArray(_line3, 1),
	          last = _line4[0];
	
	      _get(Scroll.prototype.__proto__ || Object.getPrototypeOf(Scroll.prototype), 'deleteAt', this).call(this, index, length);
	      if (last != null && first !== last && offset > 0) {
	        if (first instanceof _block.BlockEmbed || last instanceof _block.BlockEmbed) {
	          this.optimize();
	          return;
	        }
	        if (first instanceof _code2.default) {
	          var newlineIndex = first.newlineIndex(first.length(), true);
	          if (newlineIndex > -1) {
	            first = first.split(newlineIndex + 1);
	            if (first === last) {
	              this.optimize();
	              return;
	            }
	          }
	        } else if (last instanceof _code2.default) {
	          var _newlineIndex = last.newlineIndex(0);
	          if (_newlineIndex > -1) {
	            last.split(_newlineIndex + 1);
	          }
	        }
	        var ref = last.children.head instanceof _break2.default ? null : last.children.head;
	        first.moveChildren(last, ref);
	        first.remove();
	      }
	      this.optimize();
	    }
	  }, {
	    key: 'enable',
	    value: function enable() {
	      var enabled = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	
	      this.domNode.setAttribute('contenteditable', enabled);
	    }
	  }, {
	    key: 'formatAt',
	    value: function formatAt(index, length, format, value) {
	      if (this.whitelist != null && !this.whitelist[format]) return;
	      _get(Scroll.prototype.__proto__ || Object.getPrototypeOf(Scroll.prototype), 'formatAt', this).call(this, index, length, format, value);
	      this.optimize();
	    }
	  }, {
	    key: 'insertAt',
	    value: function insertAt(index, value, def) {
	      if (def != null && this.whitelist != null && !this.whitelist[value]) return;
	      if (index >= this.length()) {
	        if (def == null || _parchment2.default.query(value, _parchment2.default.Scope.BLOCK) == null) {
	          var blot = _parchment2.default.create(this.statics.defaultChild);
	          this.appendChild(blot);
	          if (def == null && value.endsWith('\n')) {
	            value = value.slice(0, -1);
	          }
	          blot.insertAt(0, value, def);
	        } else {
	          var embed = _parchment2.default.create(value, def);
	          this.appendChild(embed);
	        }
	      } else {
	        _get(Scroll.prototype.__proto__ || Object.getPrototypeOf(Scroll.prototype), 'insertAt', this).call(this, index, value, def);
	      }
	      this.optimize();
	    }
	  }, {
	    key: 'insertBefore',
	    value: function insertBefore(blot, ref) {
	      if (blot.statics.scope === _parchment2.default.Scope.INLINE_BLOT) {
	        var wrapper = _parchment2.default.create(this.statics.defaultChild);
	        wrapper.appendChild(blot);
	        blot = wrapper;
	      }
	      _get(Scroll.prototype.__proto__ || Object.getPrototypeOf(Scroll.prototype), 'insertBefore', this).call(this, blot, ref);
	    }
	  }, {
	    key: 'leaf',
	    value: function leaf(index) {
	      return this.path(index).pop() || [null, -1];
	    }
	  }, {
	    key: 'line',
	    value: function line(index) {
	      if (index === this.length()) {
	        return this.line(index - 1);
	      }
	      return this.descendant(isLine, index);
	    }
	  }, {
	    key: 'lines',
	    value: function lines() {
	      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	      var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Number.MAX_VALUE;
	
	      var getLines = function getLines(blot, index, length) {
	        var lines = [],
	            lengthLeft = length;
	        blot.children.forEachAt(index, length, function (child, index, length) {
	          if (isLine(child)) {
	            lines.push(child);
	          } else if (child instanceof _parchment2.default.Container) {
	            lines = lines.concat(getLines(child, index, lengthLeft));
	          }
	          lengthLeft -= length;
	        });
	        return lines;
	      };
	      return getLines(this, index, length);
	    }
	  }, {
	    key: 'optimize',
	    value: function optimize() {
	      var mutations = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	      var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	      if (this.batch === true) return;
	      _get(Scroll.prototype.__proto__ || Object.getPrototypeOf(Scroll.prototype), 'optimize', this).call(this, mutations, context);
	      if (mutations.length > 0) {
	        this.emitter.emit(_emitter2.default.events.SCROLL_OPTIMIZE, mutations, context);
	      }
	    }
	  }, {
	    key: 'path',
	    value: function path(index) {
	      return _get(Scroll.prototype.__proto__ || Object.getPrototypeOf(Scroll.prototype), 'path', this).call(this, index).slice(1); // Exclude self
	    }
	  }, {
	    key: 'update',
	    value: function update(mutations) {
	      if (this.batch === true) return;
	      var source = _emitter2.default.sources.USER;
	      if (typeof mutations === 'string') {
	        source = mutations;
	      }
	      if (!Array.isArray(mutations)) {
	        mutations = this.observer.takeRecords();
	      }
	      if (mutations.length > 0) {
	        this.emitter.emit(_emitter2.default.events.SCROLL_BEFORE_UPDATE, source, mutations);
	      }
	      _get(Scroll.prototype.__proto__ || Object.getPrototypeOf(Scroll.prototype), 'update', this).call(this, mutations.concat([])); // pass copy
	      if (mutations.length > 0) {
	        this.emitter.emit(_emitter2.default.events.SCROLL_UPDATE, source, mutations);
	      }
	    }
	  }]);
	
	  return Scroll;
	}(_parchment2.default.Scroll);
	
	Scroll.blotName = 'scroll';
	Scroll.className = 'ql-editor';
	Scroll.tagName = 'DIV';
	Scroll.defaultChild = 'block';
	Scroll.allowedChildren = [_block2.default, _block.BlockEmbed, _container2.default];
	
	exports.default = Scroll;
	
	/***/ }),
	/* 23 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SHORTKEY = exports.default = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _clone = __webpack_require__(21);
	
	var _clone2 = _interopRequireDefault(_clone);
	
	var _deepEqual = __webpack_require__(11);
	
	var _deepEqual2 = _interopRequireDefault(_deepEqual);
	
	var _extend = __webpack_require__(3);
	
	var _extend2 = _interopRequireDefault(_extend);
	
	var _quillDelta = __webpack_require__(2);
	
	var _quillDelta2 = _interopRequireDefault(_quillDelta);
	
	var _op = __webpack_require__(20);
	
	var _op2 = _interopRequireDefault(_op);
	
	var _parchment = __webpack_require__(0);
	
	var _parchment2 = _interopRequireDefault(_parchment);
	
	var _quill = __webpack_require__(5);
	
	var _quill2 = _interopRequireDefault(_quill);
	
	var _logger = __webpack_require__(10);
	
	var _logger2 = _interopRequireDefault(_logger);
	
	var _module = __webpack_require__(9);
	
	var _module2 = _interopRequireDefault(_module);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var debug = (0, _logger2.default)('quill:keyboard');
	
	var SHORTKEY = /Mac/i.test(navigator.platform) ? 'metaKey' : 'ctrlKey';
	
	var Keyboard = function (_Module) {
	  _inherits(Keyboard, _Module);
	
	  _createClass(Keyboard, null, [{
	    key: 'match',
	    value: function match(evt, binding) {
	      binding = normalize(binding);
	      if (['altKey', 'ctrlKey', 'metaKey', 'shiftKey'].some(function (key) {
	        return !!binding[key] !== evt[key] && binding[key] !== null;
	      })) {
	        return false;
	      }
	      return binding.key === (evt.which || evt.keyCode);
	    }
	  }]);
	
	  function Keyboard(quill, options) {
	    _classCallCheck(this, Keyboard);
	
	    var _this = _possibleConstructorReturn(this, (Keyboard.__proto__ || Object.getPrototypeOf(Keyboard)).call(this, quill, options));
	
	    _this.bindings = {};
	    Object.keys(_this.options.bindings).forEach(function (name) {
	      if (name === 'list autofill' && quill.scroll.whitelist != null && !quill.scroll.whitelist['list']) {
	        return;
	      }
	      if (_this.options.bindings[name]) {
	        _this.addBinding(_this.options.bindings[name]);
	      }
	    });
	    _this.addBinding({ key: Keyboard.keys.ENTER, shiftKey: null }, handleEnter);
	    _this.addBinding({ key: Keyboard.keys.ENTER, metaKey: null, ctrlKey: null, altKey: null }, function () {});
	    if (/Firefox/i.test(navigator.userAgent)) {
	      // Need to handle delete and backspace for Firefox in the general case #1171
	      _this.addBinding({ key: Keyboard.keys.BACKSPACE }, { collapsed: true }, handleBackspace);
	      _this.addBinding({ key: Keyboard.keys.DELETE }, { collapsed: true }, handleDelete);
	    } else {
	      _this.addBinding({ key: Keyboard.keys.BACKSPACE }, { collapsed: true, prefix: /^.?$/ }, handleBackspace);
	      _this.addBinding({ key: Keyboard.keys.DELETE }, { collapsed: true, suffix: /^.?$/ }, handleDelete);
	    }
	    _this.addBinding({ key: Keyboard.keys.BACKSPACE }, { collapsed: false }, handleDeleteRange);
	    _this.addBinding({ key: Keyboard.keys.DELETE }, { collapsed: false }, handleDeleteRange);
	    _this.addBinding({ key: Keyboard.keys.BACKSPACE, altKey: null, ctrlKey: null, metaKey: null, shiftKey: null }, { collapsed: true, offset: 0 }, handleBackspace);
	    _this.listen();
	    return _this;
	  }
	
	  _createClass(Keyboard, [{
	    key: 'addBinding',
	    value: function addBinding(key) {
	      var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	      var handler = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	      var binding = normalize(key);
	      if (binding == null || binding.key == null) {
	        return debug.warn('Attempted to add invalid keyboard binding', binding);
	      }
	      if (typeof context === 'function') {
	        context = { handler: context };
	      }
	      if (typeof handler === 'function') {
	        handler = { handler: handler };
	      }
	      binding = (0, _extend2.default)(binding, context, handler);
	      this.bindings[binding.key] = this.bindings[binding.key] || [];
	      this.bindings[binding.key].push(binding);
	    }
	  }, {
	    key: 'listen',
	    value: function listen() {
	      var _this2 = this;
	
	      this.quill.root.addEventListener('keydown', function (evt) {
	        if (evt.defaultPrevented) return;
	        var which = evt.which || evt.keyCode;
	        var bindings = (_this2.bindings[which] || []).filter(function (binding) {
	          return Keyboard.match(evt, binding);
	        });
	        if (bindings.length === 0) return;
	        var range = _this2.quill.getSelection();
	        if (range == null || !_this2.quill.hasFocus()) return;
	
	        var _quill$getLine = _this2.quill.getLine(range.index),
	            _quill$getLine2 = _slicedToArray(_quill$getLine, 2),
	            line = _quill$getLine2[0],
	            offset = _quill$getLine2[1];
	
	        var _quill$getLeaf = _this2.quill.getLeaf(range.index),
	            _quill$getLeaf2 = _slicedToArray(_quill$getLeaf, 2),
	            leafStart = _quill$getLeaf2[0],
	            offsetStart = _quill$getLeaf2[1];
	
	        var _ref = range.length === 0 ? [leafStart, offsetStart] : _this2.quill.getLeaf(range.index + range.length),
	            _ref2 = _slicedToArray(_ref, 2),
	            leafEnd = _ref2[0],
	            offsetEnd = _ref2[1];
	
	        var prefixText = leafStart instanceof _parchment2.default.Text ? leafStart.value().slice(0, offsetStart) : '';
	        var suffixText = leafEnd instanceof _parchment2.default.Text ? leafEnd.value().slice(offsetEnd) : '';
	        var curContext = {
	          collapsed: range.length === 0,
	          empty: range.length === 0 && line.length() <= 1,
	          format: _this2.quill.getFormat(range),
	          offset: offset,
	          prefix: prefixText,
	          suffix: suffixText
	        };
	        var prevented = bindings.some(function (binding) {
	          if (binding.collapsed != null && binding.collapsed !== curContext.collapsed) return false;
	          if (binding.empty != null && binding.empty !== curContext.empty) return false;
	          if (binding.offset != null && binding.offset !== curContext.offset) return false;
	          if (Array.isArray(binding.format)) {
	            // any format is present
	            if (binding.format.every(function (name) {
	              return curContext.format[name] == null;
	            })) {
	              return false;
	            }
	          } else if (_typeof(binding.format) === 'object') {
	            // all formats must match
	            if (!Object.keys(binding.format).every(function (name) {
	              if (binding.format[name] === true) return curContext.format[name] != null;
	              if (binding.format[name] === false) return curContext.format[name] == null;
	              return (0, _deepEqual2.default)(binding.format[name], curContext.format[name]);
	            })) {
	              return false;
	            }
	          }
	          if (binding.prefix != null && !binding.prefix.test(curContext.prefix)) return false;
	          if (binding.suffix != null && !binding.suffix.test(curContext.suffix)) return false;
	          return binding.handler.call(_this2, range, curContext) !== true;
	        });
	        if (prevented) {
	          evt.preventDefault();
	        }
	      });
	    }
	  }]);
	
	  return Keyboard;
	}(_module2.default);
	
	Keyboard.keys = {
	  BACKSPACE: 8,
	  TAB: 9,
	  ENTER: 13,
	  ESCAPE: 27,
	  LEFT: 37,
	  UP: 38,
	  RIGHT: 39,
	  DOWN: 40,
	  DELETE: 46
	};
	
	Keyboard.DEFAULTS = {
	  bindings: {
	    'bold': makeFormatHandler('bold'),
	    'italic': makeFormatHandler('italic'),
	    'underline': makeFormatHandler('underline'),
	    'indent': {
	      // highlight tab or tab at beginning of list, indent or blockquote
	      key: Keyboard.keys.TAB,
	      format: ['blockquote', 'indent', 'list'],
	      handler: function handler(range, context) {
	        if (context.collapsed && context.offset !== 0) return true;
	        this.quill.format('indent', '+1', _quill2.default.sources.USER);
	      }
	    },
	    'outdent': {
	      key: Keyboard.keys.TAB,
	      shiftKey: true,
	      format: ['blockquote', 'indent', 'list'],
	      // highlight tab or tab at beginning of list, indent or blockquote
	      handler: function handler(range, context) {
	        if (context.collapsed && context.offset !== 0) return true;
	        this.quill.format('indent', '-1', _quill2.default.sources.USER);
	      }
	    },
	    'outdent backspace': {
	      key: Keyboard.keys.BACKSPACE,
	      collapsed: true,
	      shiftKey: null,
	      metaKey: null,
	      ctrlKey: null,
	      altKey: null,
	      format: ['indent', 'list'],
	      offset: 0,
	      handler: function handler(range, context) {
	        if (context.format.indent != null) {
	          this.quill.format('indent', '-1', _quill2.default.sources.USER);
	        } else if (context.format.list != null) {
	          this.quill.format('list', false, _quill2.default.sources.USER);
	        }
	      }
	    },
	    'indent code-block': makeCodeBlockHandler(true),
	    'outdent code-block': makeCodeBlockHandler(false),
	    'remove tab': {
	      key: Keyboard.keys.TAB,
	      shiftKey: true,
	      collapsed: true,
	      prefix: /\t$/,
	      handler: function handler(range) {
	        this.quill.deleteText(range.index - 1, 1, _quill2.default.sources.USER);
	      }
	    },
	    'tab': {
	      key: Keyboard.keys.TAB,
	      handler: function handler(range) {
	        this.quill.history.cutoff();
	        var delta = new _quillDelta2.default().retain(range.index).delete(range.length).insert('\t');
	        this.quill.updateContents(delta, _quill2.default.sources.USER);
	        this.quill.history.cutoff();
	        this.quill.setSelection(range.index + 1, _quill2.default.sources.SILENT);
	      }
	    },
	    'list empty enter': {
	      key: Keyboard.keys.ENTER,
	      collapsed: true,
	      format: ['list'],
	      empty: true,
	      handler: function handler(range, context) {
	        this.quill.format('list', false, _quill2.default.sources.USER);
	        if (context.format.indent) {
	          this.quill.format('indent', false, _quill2.default.sources.USER);
	        }
	      }
	    },
	    'checklist enter': {
	      key: Keyboard.keys.ENTER,
	      collapsed: true,
	      format: { list: 'checked' },
	      handler: function handler(range) {
	        var _quill$getLine3 = this.quill.getLine(range.index),
	            _quill$getLine4 = _slicedToArray(_quill$getLine3, 2),
	            line = _quill$getLine4[0],
	            offset = _quill$getLine4[1];
	
	        var formats = (0, _extend2.default)({}, line.formats(), { list: 'checked' });
	        var delta = new _quillDelta2.default().retain(range.index).insert('\n', formats).retain(line.length() - offset - 1).retain(1, { list: 'unchecked' });
	        this.quill.updateContents(delta, _quill2.default.sources.USER);
	        this.quill.setSelection(range.index + 1, _quill2.default.sources.SILENT);
	        this.quill.scrollIntoView();
	      }
	    },
	    'header enter': {
	      key: Keyboard.keys.ENTER,
	      collapsed: true,
	      format: ['header'],
	      suffix: /^$/,
	      handler: function handler(range, context) {
	        var _quill$getLine5 = this.quill.getLine(range.index),
	            _quill$getLine6 = _slicedToArray(_quill$getLine5, 2),
	            line = _quill$getLine6[0],
	            offset = _quill$getLine6[1];
	
	        var delta = new _quillDelta2.default().retain(range.index).insert('\n', context.format).retain(line.length() - offset - 1).retain(1, { header: null });
	        this.quill.updateContents(delta, _quill2.default.sources.USER);
	        this.quill.setSelection(range.index + 1, _quill2.default.sources.SILENT);
	        this.quill.scrollIntoView();
	      }
	    },
	    'list autofill': {
	      key: ' ',
	      collapsed: true,
	      format: { list: false },
	      prefix: /^\s*?(\d+\.|-|\*|\[ ?\]|\[x\])$/,
	      handler: function handler(range, context) {
	        var length = context.prefix.length;
	
	        var _quill$getLine7 = this.quill.getLine(range.index),
	            _quill$getLine8 = _slicedToArray(_quill$getLine7, 2),
	            line = _quill$getLine8[0],
	            offset = _quill$getLine8[1];
	
	        if (offset > length) return true;
	        var value = void 0;
	        switch (context.prefix.trim()) {
	          case '[]':case '[ ]':
	            value = 'unchecked';
	            break;
	          case '[x]':
	            value = 'checked';
	            break;
	          case '-':case '*':
	            value = 'bullet';
	            break;
	          default:
	            value = 'ordered';
	        }
	        this.quill.insertText(range.index, ' ', _quill2.default.sources.USER);
	        this.quill.history.cutoff();
	        var delta = new _quillDelta2.default().retain(range.index - offset).delete(length + 1).retain(line.length() - 2 - offset).retain(1, { list: value });
	        this.quill.updateContents(delta, _quill2.default.sources.USER);
	        this.quill.history.cutoff();
	        this.quill.setSelection(range.index - length, _quill2.default.sources.SILENT);
	      }
	    },
	    'code exit': {
	      key: Keyboard.keys.ENTER,
	      collapsed: true,
	      format: ['code-block'],
	      prefix: /\n\n$/,
	      suffix: /^\s+$/,
	      handler: function handler(range) {
	        var _quill$getLine9 = this.quill.getLine(range.index),
	            _quill$getLine10 = _slicedToArray(_quill$getLine9, 2),
	            line = _quill$getLine10[0],
	            offset = _quill$getLine10[1];
	
	        var delta = new _quillDelta2.default().retain(range.index + line.length() - offset - 2).retain(1, { 'code-block': null }).delete(1);
	        this.quill.updateContents(delta, _quill2.default.sources.USER);
	      }
	    },
	    'embed left': makeEmbedArrowHandler(Keyboard.keys.LEFT, false),
	    'embed left shift': makeEmbedArrowHandler(Keyboard.keys.LEFT, true),
	    'embed right': makeEmbedArrowHandler(Keyboard.keys.RIGHT, false),
	    'embed right shift': makeEmbedArrowHandler(Keyboard.keys.RIGHT, true)
	  }
	};
	
	function makeEmbedArrowHandler(key, shiftKey) {
	  var _ref3;
	
	  var where = key === Keyboard.keys.LEFT ? 'prefix' : 'suffix';
	  return _ref3 = {
	    key: key,
	    shiftKey: shiftKey,
	    altKey: null
	  }, _defineProperty(_ref3, where, /^$/), _defineProperty(_ref3, 'handler', function handler(range) {
	    var index = range.index;
	    if (key === Keyboard.keys.RIGHT) {
	      index += range.length + 1;
	    }
	
	    var _quill$getLeaf3 = this.quill.getLeaf(index),
	        _quill$getLeaf4 = _slicedToArray(_quill$getLeaf3, 1),
	        leaf = _quill$getLeaf4[0];
	
	    if (!(leaf instanceof _parchment2.default.Embed)) return true;
	    if (key === Keyboard.keys.LEFT) {
	      if (shiftKey) {
	        this.quill.setSelection(range.index - 1, range.length + 1, _quill2.default.sources.USER);
	      } else {
	        this.quill.setSelection(range.index - 1, _quill2.default.sources.USER);
	      }
	    } else {
	      if (shiftKey) {
	        this.quill.setSelection(range.index, range.length + 1, _quill2.default.sources.USER);
	      } else {
	        this.quill.setSelection(range.index + range.length + 1, _quill2.default.sources.USER);
	      }
	    }
	    return false;
	  }), _ref3;
	}
	
	function handleBackspace(range, context) {
	  if (range.index === 0 || this.quill.getLength() <= 1) return;
	
	  var _quill$getLine11 = this.quill.getLine(range.index),
	      _quill$getLine12 = _slicedToArray(_quill$getLine11, 1),
	      line = _quill$getLine12[0];
	
	  var formats = {};
	  if (context.offset === 0) {
	    var _quill$getLine13 = this.quill.getLine(range.index - 1),
	        _quill$getLine14 = _slicedToArray(_quill$getLine13, 1),
	        prev = _quill$getLine14[0];
	
	    if (prev != null && prev.length() > 1) {
	      var curFormats = line.formats();
	      var prevFormats = this.quill.getFormat(range.index - 1, 1);
	      formats = _op2.default.attributes.diff(curFormats, prevFormats) || {};
	    }
	  }
	  // Check for astral symbols
	  var length = /[\uD800-\uDBFF][\uDC00-\uDFFF]$/.test(context.prefix) ? 2 : 1;
	  this.quill.deleteText(range.index - length, length, _quill2.default.sources.USER);
	  if (Object.keys(formats).length > 0) {
	    this.quill.formatLine(range.index - length, length, formats, _quill2.default.sources.USER);
	  }
	  this.quill.focus();
	}
	
	function handleDelete(range, context) {
	  // Check for astral symbols
	  var length = /^[\uD800-\uDBFF][\uDC00-\uDFFF]/.test(context.suffix) ? 2 : 1;
	  if (range.index >= this.quill.getLength() - length) return;
	  var formats = {},
	      nextLength = 0;
	
	  var _quill$getLine15 = this.quill.getLine(range.index),
	      _quill$getLine16 = _slicedToArray(_quill$getLine15, 1),
	      line = _quill$getLine16[0];
	
	  if (context.offset >= line.length() - 1) {
	    var _quill$getLine17 = this.quill.getLine(range.index + 1),
	        _quill$getLine18 = _slicedToArray(_quill$getLine17, 1),
	        next = _quill$getLine18[0];
	
	    if (next) {
	      var curFormats = line.formats();
	      var nextFormats = this.quill.getFormat(range.index, 1);
	      formats = _op2.default.attributes.diff(curFormats, nextFormats) || {};
	      nextLength = next.length();
	    }
	  }
	  this.quill.deleteText(range.index, length, _quill2.default.sources.USER);
	  if (Object.keys(formats).length > 0) {
	    this.quill.formatLine(range.index + nextLength - 1, length, formats, _quill2.default.sources.USER);
	  }
	}
	
	function handleDeleteRange(range) {
	  var lines = this.quill.getLines(range);
	  var formats = {};
	  if (lines.length > 1) {
	    var firstFormats = lines[0].formats();
	    var lastFormats = lines[lines.length - 1].formats();
	    formats = _op2.default.attributes.diff(lastFormats, firstFormats) || {};
	  }
	  this.quill.deleteText(range, _quill2.default.sources.USER);
	  if (Object.keys(formats).length > 0) {
	    this.quill.formatLine(range.index, 1, formats, _quill2.default.sources.USER);
	  }
	  this.quill.setSelection(range.index, _quill2.default.sources.SILENT);
	  this.quill.focus();
	}
	
	function handleEnter(range, context) {
	  var _this3 = this;
	
	  if (range.length > 0) {
	    this.quill.scroll.deleteAt(range.index, range.length); // So we do not trigger text-change
	  }
	  var lineFormats = Object.keys(context.format).reduce(function (lineFormats, format) {
	    if (_parchment2.default.query(format, _parchment2.default.Scope.BLOCK) && !Array.isArray(context.format[format])) {
	      lineFormats[format] = context.format[format];
	    }
	    return lineFormats;
	  }, {});
	  this.quill.insertText(range.index, '\n', lineFormats, _quill2.default.sources.USER);
	  // Earlier scroll.deleteAt might have messed up our selection,
	  // so insertText's built in selection preservation is not reliable
	  this.quill.setSelection(range.index + 1, _quill2.default.sources.SILENT);
	  this.quill.focus();
	  Object.keys(context.format).forEach(function (name) {
	    if (lineFormats[name] != null) return;
	    if (Array.isArray(context.format[name])) return;
	    if (name === 'link') return;
	    _this3.quill.format(name, context.format[name], _quill2.default.sources.USER);
	  });
	}
	
	function makeCodeBlockHandler(indent) {
	  return {
	    key: Keyboard.keys.TAB,
	    shiftKey: !indent,
	    format: { 'code-block': true },
	    handler: function handler(range) {
	      var CodeBlock = _parchment2.default.query('code-block');
	      var index = range.index,
	          length = range.length;
	
	      var _quill$scroll$descend = this.quill.scroll.descendant(CodeBlock, index),
	          _quill$scroll$descend2 = _slicedToArray(_quill$scroll$descend, 2),
	          block = _quill$scroll$descend2[0],
	          offset = _quill$scroll$descend2[1];
	
	      if (block == null) return;
	      var scrollIndex = this.quill.getIndex(block);
	      var start = block.newlineIndex(offset, true) + 1;
	      var end = block.newlineIndex(scrollIndex + offset + length);
	      var lines = block.domNode.textContent.slice(start, end).split('\n');
	      offset = 0;
	      lines.forEach(function (line, i) {
	        if (indent) {
	          block.insertAt(start + offset, CodeBlock.TAB);
	          offset += CodeBlock.TAB.length;
	          if (i === 0) {
	            index += CodeBlock.TAB.length;
	          } else {
	            length += CodeBlock.TAB.length;
	          }
	        } else if (line.startsWith(CodeBlock.TAB)) {
	          block.deleteAt(start + offset, CodeBlock.TAB.length);
	          offset -= CodeBlock.TAB.length;
	          if (i === 0) {
	            index -= CodeBlock.TAB.length;
	          } else {
	            length -= CodeBlock.TAB.length;
	          }
	        }
	        offset += line.length + 1;
	      });
	      this.quill.update(_quill2.default.sources.USER);
	      this.quill.setSelection(index, length, _quill2.default.sources.SILENT);
	    }
	  };
	}
	
	function makeFormatHandler(format) {
	  return {
	    key: format[0].toUpperCase(),
	    shortKey: true,
	    handler: function handler(range, context) {
	      this.quill.format(format, !context.format[format], _quill2.default.sources.USER);
	    }
	  };
	}
	
	function normalize(binding) {
	  if (typeof binding === 'string' || typeof binding === 'number') {
	    return normalize({ key: binding });
	  }
	  if ((typeof binding === 'undefined' ? 'undefined' : _typeof(binding)) === 'object') {
	    binding = (0, _clone2.default)(binding, false);
	  }
	  if (typeof binding.key === 'string') {
	    if (Keyboard.keys[binding.key.toUpperCase()] != null) {
	      binding.key = Keyboard.keys[binding.key.toUpperCase()];
	    } else if (binding.key.length === 1) {
	      binding.key = binding.key.toUpperCase().charCodeAt(0);
	    } else {
	      return null;
	    }
	  }
	  if (binding.shortKey) {
	    binding[SHORTKEY] = binding.shortKey;
	    delete binding.shortKey;
	  }
	  return binding;
	}
	
	exports.default = Keyboard;
	exports.SHORTKEY = SHORTKEY;
	
	/***/ }),
	/* 24 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _parchment = __webpack_require__(0);
	
	var _parchment2 = _interopRequireDefault(_parchment);
	
	var _text = __webpack_require__(7);
	
	var _text2 = _interopRequireDefault(_text);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Cursor = function (_Parchment$Embed) {
	  _inherits(Cursor, _Parchment$Embed);
	
	  _createClass(Cursor, null, [{
	    key: 'value',
	    value: function value() {
	      return undefined;
	    }
	  }]);
	
	  function Cursor(domNode, selection) {
	    _classCallCheck(this, Cursor);
	
	    var _this = _possibleConstructorReturn(this, (Cursor.__proto__ || Object.getPrototypeOf(Cursor)).call(this, domNode));
	
	    _this.selection = selection;
	    _this.textNode = document.createTextNode(Cursor.CONTENTS);
	    _this.domNode.appendChild(_this.textNode);
	    _this._length = 0;
	    return _this;
	  }
	
	  _createClass(Cursor, [{
	    key: 'detach',
	    value: function detach() {
	      // super.detach() will also clear domNode.__blot
	      if (this.parent != null) this.parent.removeChild(this);
	    }
	  }, {
	    key: 'format',
	    value: function format(name, value) {
	      if (this._length !== 0) {
	        return _get(Cursor.prototype.__proto__ || Object.getPrototypeOf(Cursor.prototype), 'format', this).call(this, name, value);
	      }
	      var target = this,
	          index = 0;
	      while (target != null && target.statics.scope !== _parchment2.default.Scope.BLOCK_BLOT) {
	        index += target.offset(target.parent);
	        target = target.parent;
	      }
	      if (target != null) {
	        this._length = Cursor.CONTENTS.length;
	        target.optimize();
	        target.formatAt(index, Cursor.CONTENTS.length, name, value);
	        this._length = 0;
	      }
	    }
	  }, {
	    key: 'index',
	    value: function index(node, offset) {
	      if (node === this.textNode) return 0;
	      return _get(Cursor.prototype.__proto__ || Object.getPrototypeOf(Cursor.prototype), 'index', this).call(this, node, offset);
	    }
	  }, {
	    key: 'length',
	    value: function length() {
	      return this._length;
	    }
	  }, {
	    key: 'position',
	    value: function position() {
	      return [this.textNode, this.textNode.data.length];
	    }
	  }, {
	    key: 'remove',
	    value: function remove() {
	      _get(Cursor.prototype.__proto__ || Object.getPrototypeOf(Cursor.prototype), 'remove', this).call(this);
	      this.parent = null;
	    }
	  }, {
	    key: 'restore',
	    value: function restore() {
	      if (this.selection.composing || this.parent == null) return;
	      var textNode = this.textNode;
	      var range = this.selection.getNativeRange();
	      var restoreText = void 0,
	          start = void 0,
	          end = void 0;
	      if (range != null && range.start.node === textNode && range.end.node === textNode) {
	        var _ref = [textNode, range.start.offset, range.end.offset];
	        restoreText = _ref[0];
	        start = _ref[1];
	        end = _ref[2];
	      }
	      // Link format will insert text outside of anchor tag
	      while (this.domNode.lastChild != null && this.domNode.lastChild !== this.textNode) {
	        this.domNode.parentNode.insertBefore(this.domNode.lastChild, this.domNode);
	      }
	      if (this.textNode.data !== Cursor.CONTENTS) {
	        var text = this.textNode.data.split(Cursor.CONTENTS).join('');
	        if (this.next instanceof _text2.default) {
	          restoreText = this.next.domNode;
	          this.next.insertAt(0, text);
	          this.textNode.data = Cursor.CONTENTS;
	        } else {
	          this.textNode.data = text;
	          this.parent.insertBefore(_parchment2.default.create(this.textNode), this);
	          this.textNode = document.createTextNode(Cursor.CONTENTS);
	          this.domNode.appendChild(this.textNode);
	        }
	      }
	      this.remove();
	      if (start != null) {
	        var _map = [start, end].map(function (offset) {
	          return Math.max(0, Math.min(restoreText.data.length, offset - 1));
	        });
	
	        var _map2 = _slicedToArray(_map, 2);
	
	        start = _map2[0];
	        end = _map2[1];
	
	        return {
	          startNode: restoreText,
	          startOffset: start,
	          endNode: restoreText,
	          endOffset: end
	        };
	      }
	    }
	  }, {
	    key: 'update',
	    value: function update(mutations, context) {
	      var _this2 = this;
	
	      if (mutations.some(function (mutation) {
	        return mutation.type === 'characterData' && mutation.target === _this2.textNode;
	      })) {
	        var range = this.restore();
	        if (range) context.range = range;
	      }
	    }
	  }, {
	    key: 'value',
	    value: function value() {
	      return '';
	    }
	  }]);
	
	  return Cursor;
	}(_parchment2.default.Embed);
	
	Cursor.blotName = 'cursor';
	Cursor.className = 'ql-cursor';
	Cursor.tagName = 'span';
	Cursor.CONTENTS = '\uFEFF'; // Zero width no break space
	
	
	exports.default = Cursor;
	
	/***/ }),
	/* 25 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _parchment = __webpack_require__(0);
	
	var _parchment2 = _interopRequireDefault(_parchment);
	
	var _block = __webpack_require__(4);
	
	var _block2 = _interopRequireDefault(_block);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Container = function (_Parchment$Container) {
	  _inherits(Container, _Parchment$Container);
	
	  function Container() {
	    _classCallCheck(this, Container);
	
	    return _possibleConstructorReturn(this, (Container.__proto__ || Object.getPrototypeOf(Container)).apply(this, arguments));
	  }
	
	  return Container;
	}(_parchment2.default.Container);
	
	Container.allowedChildren = [_block2.default, _block.BlockEmbed, Container];
	
	exports.default = Container;
	
	/***/ }),
	/* 26 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ColorStyle = exports.ColorClass = exports.ColorAttributor = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _parchment = __webpack_require__(0);
	
	var _parchment2 = _interopRequireDefault(_parchment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ColorAttributor = function (_Parchment$Attributor) {
	  _inherits(ColorAttributor, _Parchment$Attributor);
	
	  function ColorAttributor() {
	    _classCallCheck(this, ColorAttributor);
	
	    return _possibleConstructorReturn(this, (ColorAttributor.__proto__ || Object.getPrototypeOf(ColorAttributor)).apply(this, arguments));
	  }
	
	  _createClass(ColorAttributor, [{
	    key: 'value',
	    value: function value(domNode) {
	      var value = _get(ColorAttributor.prototype.__proto__ || Object.getPrototypeOf(ColorAttributor.prototype), 'value', this).call(this, domNode);
	      if (!value.startsWith('rgb(')) return value;
	      value = value.replace(/^[^\d]+/, '').replace(/[^\d]+$/, '');
	      return '#' + value.split(',').map(function (component) {
	        return ('00' + parseInt(component).toString(16)).slice(-2);
	      }).join('');
	    }
	  }]);
	
	  return ColorAttributor;
	}(_parchment2.default.Attributor.Style);
	
	var ColorClass = new _parchment2.default.Attributor.Class('color', 'ql-color', {
	  scope: _parchment2.default.Scope.INLINE
	});
	var ColorStyle = new ColorAttributor('color', 'color', {
	  scope: _parchment2.default.Scope.INLINE
	});
	
	exports.ColorAttributor = ColorAttributor;
	exports.ColorClass = ColorClass;
	exports.ColorStyle = ColorStyle;
	
	/***/ }),
	/* 27 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.sanitize = exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _inline = __webpack_require__(6);
	
	var _inline2 = _interopRequireDefault(_inline);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Link = function (_Inline) {
	  _inherits(Link, _Inline);
	
	  function Link() {
	    _classCallCheck(this, Link);
	
	    return _possibleConstructorReturn(this, (Link.__proto__ || Object.getPrototypeOf(Link)).apply(this, arguments));
	  }
	
	  _createClass(Link, [{
	    key: 'format',
	    value: function format(name, value) {
	      if (name !== this.statics.blotName || !value) return _get(Link.prototype.__proto__ || Object.getPrototypeOf(Link.prototype), 'format', this).call(this, name, value);
	      value = this.constructor.sanitize(value);
	      this.domNode.setAttribute('href', value);
	    }
	  }], [{
	    key: 'create',
	    value: function create(value) {
	      var node = _get(Link.__proto__ || Object.getPrototypeOf(Link), 'create', this).call(this, value);
	      value = this.sanitize(value);
	      node.setAttribute('href', value);
	      node.setAttribute('rel', 'noopener noreferrer');
	      node.setAttribute('target', '_blank');
	      return node;
	    }
	  }, {
	    key: 'formats',
	    value: function formats(domNode) {
	      return domNode.getAttribute('href');
	    }
	  }, {
	    key: 'sanitize',
	    value: function sanitize(url) {
	      return _sanitize(url, this.PROTOCOL_WHITELIST) ? url : this.SANITIZED_URL;
	    }
	  }]);
	
	  return Link;
	}(_inline2.default);
	
	Link.blotName = 'link';
	Link.tagName = 'A';
	Link.SANITIZED_URL = 'about:blank';
	Link.PROTOCOL_WHITELIST = ['http', 'https', 'mailto', 'tel'];
	
	function _sanitize(url, protocols) {
	  var anchor = document.createElement('a');
	  anchor.href = url;
	  var protocol = anchor.href.slice(0, anchor.href.indexOf(':'));
	  return protocols.indexOf(protocol) > -1;
	}
	
	exports.default = Link;
	exports.sanitize = _sanitize;
	
	/***/ }),
	/* 28 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _keyboard = __webpack_require__(23);
	
	var _keyboard2 = _interopRequireDefault(_keyboard);
	
	var _dropdown = __webpack_require__(107);
	
	var _dropdown2 = _interopRequireDefault(_dropdown);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var optionsCounter = 0;
	
	function toggleAriaAttribute(element, attribute) {
	  element.setAttribute(attribute, !(element.getAttribute(attribute) === 'true'));
	}
	
	var Picker = function () {
	  function Picker(select) {
	    var _this = this;
	
	    _classCallCheck(this, Picker);
	
	    this.select = select;
	    this.container = document.createElement('span');
	    this.buildPicker();
	    this.select.style.display = 'none';
	    this.select.parentNode.insertBefore(this.container, this.select);
	
	    this.label.addEventListener('mousedown', function () {
	      _this.togglePicker();
	    });
	    this.label.addEventListener('keydown', function (event) {
	      switch (event.keyCode) {
	        // Allows the "Enter" key to open the picker
	        case _keyboard2.default.keys.ENTER:
	          _this.togglePicker();
	          break;
	
	        // Allows the "Escape" key to close the picker
	        case _keyboard2.default.keys.ESCAPE:
	          _this.escape();
	          event.preventDefault();
	          break;
	        default:
	      }
	    });
	    this.select.addEventListener('change', this.update.bind(this));
	  }
	
	  _createClass(Picker, [{
	    key: 'togglePicker',
	    value: function togglePicker() {
	      this.container.classList.toggle('ql-expanded');
	      // Toggle aria-expanded and aria-hidden to make the picker accessible
	      toggleAriaAttribute(this.label, 'aria-expanded');
	      toggleAriaAttribute(this.options, 'aria-hidden');
	    }
	  }, {
	    key: 'buildItem',
	    value: function buildItem(option) {
	      var _this2 = this;
	
	      var item = document.createElement('span');
	      item.tabIndex = '0';
	      item.setAttribute('role', 'button');
	
	      item.classList.add('ql-picker-item');
	      if (option.hasAttribute('value')) {
	        item.setAttribute('data-value', option.getAttribute('value'));
	      }
	      if (option.textContent) {
	        item.setAttribute('data-label', option.textContent);
	      }
	      item.addEventListener('click', function () {
	        _this2.selectItem(item, true);
	      });
	      item.addEventListener('keydown', function (event) {
	        switch (event.keyCode) {
	          // Allows the "Enter" key to select an item
	          case _keyboard2.default.keys.ENTER:
	            _this2.selectItem(item, true);
	            event.preventDefault();
	            break;
	
	          // Allows the "Escape" key to close the picker
	          case _keyboard2.default.keys.ESCAPE:
	            _this2.escape();
	            event.preventDefault();
	            break;
	          default:
	        }
	      });
	
	      return item;
	    }
	  }, {
	    key: 'buildLabel',
	    value: function buildLabel() {
	      var label = document.createElement('span');
	      label.classList.add('ql-picker-label');
	      label.innerHTML = _dropdown2.default;
	      label.tabIndex = '0';
	      label.setAttribute('role', 'button');
	      label.setAttribute('aria-expanded', 'false');
	      this.container.appendChild(label);
	      return label;
	    }
	  }, {
	    key: 'buildOptions',
	    value: function buildOptions() {
	      var _this3 = this;
	
	      var options = document.createElement('span');
	      options.classList.add('ql-picker-options');
	
	      // Don't want screen readers to read this until options are visible
	      options.setAttribute('aria-hidden', 'true');
	      options.tabIndex = '-1';
	
	      // Need a unique id for aria-controls
	      options.id = 'ql-picker-options-' + optionsCounter;
	      optionsCounter += 1;
	      this.label.setAttribute('aria-controls', options.id);
	
	      this.options = options;
	
	      [].slice.call(this.select.options).forEach(function (option) {
	        var item = _this3.buildItem(option);
	        options.appendChild(item);
	        if (option.selected === true) {
	          _this3.selectItem(item);
	        }
	      });
	      this.container.appendChild(options);
	    }
	  }, {
	    key: 'buildPicker',
	    value: function buildPicker() {
	      var _this4 = this;
	
	      [].slice.call(this.select.attributes).forEach(function (item) {
	        _this4.container.setAttribute(item.name, item.value);
	      });
	      this.container.classList.add('ql-picker');
	      this.label = this.buildLabel();
	      this.buildOptions();
	    }
	  }, {
	    key: 'escape',
	    value: function escape() {
	      var _this5 = this;
	
	      // Close menu and return focus to trigger label
	      this.close();
	      // Need setTimeout for accessibility to ensure that the browser executes
	      // focus on the next process thread and after any DOM content changes
	      setTimeout(function () {
	        return _this5.label.focus();
	      }, 1);
	    }
	  }, {
	    key: 'close',
	    value: function close() {
	      this.container.classList.remove('ql-expanded');
	      this.label.setAttribute('aria-expanded', 'false');
	      this.options.setAttribute('aria-hidden', 'true');
	    }
	  }, {
	    key: 'selectItem',
	    value: function selectItem(item) {
	      var trigger = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	      var selected = this.container.querySelector('.ql-selected');
	      if (item === selected) return;
	      if (selected != null) {
	        selected.classList.remove('ql-selected');
	      }
	      if (item == null) return;
	      item.classList.add('ql-selected');
	      this.select.selectedIndex = [].indexOf.call(item.parentNode.children, item);
	      if (item.hasAttribute('data-value')) {
	        this.label.setAttribute('data-value', item.getAttribute('data-value'));
	      } else {
	        this.label.removeAttribute('data-value');
	      }
	      if (item.hasAttribute('data-label')) {
	        this.label.setAttribute('data-label', item.getAttribute('data-label'));
	      } else {
	        this.label.removeAttribute('data-label');
	      }
	      if (trigger) {
	        if (typeof Event === 'function') {
	          this.select.dispatchEvent(new Event('change'));
	        } else if ((typeof Event === 'undefined' ? 'undefined' : _typeof(Event)) === 'object') {
	          // IE11
	          var event = document.createEvent('Event');
	          event.initEvent('change', true, true);
	          this.select.dispatchEvent(event);
	        }
	        this.close();
	      }
	    }
	  }, {
	    key: 'update',
	    value: function update() {
	      var option = void 0;
	      if (this.select.selectedIndex > -1) {
	        var item = this.container.querySelector('.ql-picker-options').children[this.select.selectedIndex];
	        option = this.select.options[this.select.selectedIndex];
	        this.selectItem(item);
	      } else {
	        this.selectItem(null);
	      }
	      var isActive = option != null && option !== this.select.querySelector('option[selected]');
	      this.label.classList.toggle('ql-active', isActive);
	    }
	  }]);
	
	  return Picker;
	}();
	
	exports.default = Picker;
	
	/***/ }),
	/* 29 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _parchment = __webpack_require__(0);
	
	var _parchment2 = _interopRequireDefault(_parchment);
	
	var _quill = __webpack_require__(5);
	
	var _quill2 = _interopRequireDefault(_quill);
	
	var _block = __webpack_require__(4);
	
	var _block2 = _interopRequireDefault(_block);
	
	var _break = __webpack_require__(16);
	
	var _break2 = _interopRequireDefault(_break);
	
	var _container = __webpack_require__(25);
	
	var _container2 = _interopRequireDefault(_container);
	
	var _cursor = __webpack_require__(24);
	
	var _cursor2 = _interopRequireDefault(_cursor);
	
	var _embed = __webpack_require__(35);
	
	var _embed2 = _interopRequireDefault(_embed);
	
	var _inline = __webpack_require__(6);
	
	var _inline2 = _interopRequireDefault(_inline);
	
	var _scroll = __webpack_require__(22);
	
	var _scroll2 = _interopRequireDefault(_scroll);
	
	var _text = __webpack_require__(7);
	
	var _text2 = _interopRequireDefault(_text);
	
	var _clipboard = __webpack_require__(55);
	
	var _clipboard2 = _interopRequireDefault(_clipboard);
	
	var _history = __webpack_require__(42);
	
	var _history2 = _interopRequireDefault(_history);
	
	var _keyboard = __webpack_require__(23);
	
	var _keyboard2 = _interopRequireDefault(_keyboard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_quill2.default.register({
	  'blots/block': _block2.default,
	  'blots/block/embed': _block.BlockEmbed,
	  'blots/break': _break2.default,
	  'blots/container': _container2.default,
	  'blots/cursor': _cursor2.default,
	  'blots/embed': _embed2.default,
	  'blots/inline': _inline2.default,
	  'blots/scroll': _scroll2.default,
	  'blots/text': _text2.default,
	
	  'modules/clipboard': _clipboard2.default,
	  'modules/history': _history2.default,
	  'modules/keyboard': _keyboard2.default
	});
	
	_parchment2.default.register(_block2.default, _break2.default, _cursor2.default, _inline2.default, _scroll2.default, _text2.default);
	
	exports.default = _quill2.default;
	
	/***/ }),
	/* 30 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var Registry = __webpack_require__(1);
	var ShadowBlot = /** @class */ (function () {
	    function ShadowBlot(domNode) {
	        this.domNode = domNode;
	        // @ts-ignore
	        this.domNode[Registry.DATA_KEY] = { blot: this };
	    }
	    Object.defineProperty(ShadowBlot.prototype, "statics", {
	        // Hack for accessing inherited static methods
	        get: function () {
	            return this.constructor;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    ShadowBlot.create = function (value) {
	        if (this.tagName == null) {
	            throw new Registry.ParchmentError('Blot definition missing tagName');
	        }
	        var node;
	        if (Array.isArray(this.tagName)) {
	            if (typeof value === 'string') {
	                value = value.toUpperCase();
	                if (parseInt(value).toString() === value) {
	                    value = parseInt(value);
	                }
	            }
	            if (typeof value === 'number') {
	                node = document.createElement(this.tagName[value - 1]);
	            }
	            else if (this.tagName.indexOf(value) > -1) {
	                node = document.createElement(value);
	            }
	            else {
	                node = document.createElement(this.tagName[0]);
	            }
	        }
	        else {
	            node = document.createElement(this.tagName);
	        }
	        if (this.className) {
	            node.classList.add(this.className);
	        }
	        return node;
	    };
	    ShadowBlot.prototype.attach = function () {
	        if (this.parent != null) {
	            this.scroll = this.parent.scroll;
	        }
	    };
	    ShadowBlot.prototype.clone = function () {
	        var domNode = this.domNode.cloneNode(false);
	        return Registry.create(domNode);
	    };
	    ShadowBlot.prototype.detach = function () {
	        if (this.parent != null)
	            this.parent.removeChild(this);
	        // @ts-ignore
	        delete this.domNode[Registry.DATA_KEY];
	    };
	    ShadowBlot.prototype.deleteAt = function (index, length) {
	        var blot = this.isolate(index, length);
	        blot.remove();
	    };
	    ShadowBlot.prototype.formatAt = function (index, length, name, value) {
	        var blot = this.isolate(index, length);
	        if (Registry.query(name, Registry.Scope.BLOT) != null && value) {
	            blot.wrap(name, value);
	        }
	        else if (Registry.query(name, Registry.Scope.ATTRIBUTE) != null) {
	            var parent = Registry.create(this.statics.scope);
	            blot.wrap(parent);
	            parent.format(name, value);
	        }
	    };
	    ShadowBlot.prototype.insertAt = function (index, value, def) {
	        var blot = def == null ? Registry.create('text', value) : Registry.create(value, def);
	        var ref = this.split(index);
	        this.parent.insertBefore(blot, ref);
	    };
	    ShadowBlot.prototype.insertInto = function (parentBlot, refBlot) {
	        if (refBlot === void 0) { refBlot = null; }
	        if (this.parent != null) {
	            this.parent.children.remove(this);
	        }
	        var refDomNode = null;
	        parentBlot.children.insertBefore(this, refBlot);
	        if (refBlot != null) {
	            refDomNode = refBlot.domNode;
	        }
	        if (this.domNode.parentNode != parentBlot.domNode ||
	            this.domNode.nextSibling != refDomNode) {
	            parentBlot.domNode.insertBefore(this.domNode, refDomNode);
	        }
	        this.parent = parentBlot;
	        this.attach();
	    };
	    ShadowBlot.prototype.isolate = function (index, length) {
	        var target = this.split(index);
	        target.split(length);
	        return target;
	    };
	    ShadowBlot.prototype.length = function () {
	        return 1;
	    };
	    ShadowBlot.prototype.offset = function (root) {
	        if (root === void 0) { root = this.parent; }
	        if (this.parent == null || this == root)
	            return 0;
	        return this.parent.children.offset(this) + this.parent.offset(root);
	    };
	    ShadowBlot.prototype.optimize = function (context) {
	        // TODO clean up once we use WeakMap
	        // @ts-ignore
	        if (this.domNode[Registry.DATA_KEY] != null) {
	            // @ts-ignore
	            delete this.domNode[Registry.DATA_KEY].mutations;
	        }
	    };
	    ShadowBlot.prototype.remove = function () {
	        if (this.domNode.parentNode != null) {
	            this.domNode.parentNode.removeChild(this.domNode);
	        }
	        this.detach();
	    };
	    ShadowBlot.prototype.replace = function (target) {
	        if (target.parent == null)
	            return;
	        target.parent.insertBefore(this, target.next);
	        target.remove();
	    };
	    ShadowBlot.prototype.replaceWith = function (name, value) {
	        var replacement = typeof name === 'string' ? Registry.create(name, value) : name;
	        replacement.replace(this);
	        return replacement;
	    };
	    ShadowBlot.prototype.split = function (index, force) {
	        return index === 0 ? this : this.next;
	    };
	    ShadowBlot.prototype.update = function (mutations, context) {
	        // Nothing to do by default
	    };
	    ShadowBlot.prototype.wrap = function (name, value) {
	        var wrapper = typeof name === 'string' ? Registry.create(name, value) : name;
	        if (this.parent != null) {
	            this.parent.insertBefore(wrapper, this.next);
	        }
	        wrapper.appendChild(this);
	        return wrapper;
	    };
	    ShadowBlot.blotName = 'abstract';
	    return ShadowBlot;
	}());
	exports.default = ShadowBlot;
	
	
	/***/ }),
	/* 31 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var attributor_1 = __webpack_require__(12);
	var class_1 = __webpack_require__(32);
	var style_1 = __webpack_require__(33);
	var Registry = __webpack_require__(1);
	var AttributorStore = /** @class */ (function () {
	    function AttributorStore(domNode) {
	        this.attributes = {};
	        this.domNode = domNode;
	        this.build();
	    }
	    AttributorStore.prototype.attribute = function (attribute, value) {
	        // verb
	        if (value) {
	            if (attribute.add(this.domNode, value)) {
	                if (attribute.value(this.domNode) != null) {
	                    this.attributes[attribute.attrName] = attribute;
	                }
	                else {
	                    delete this.attributes[attribute.attrName];
	                }
	            }
	        }
	        else {
	            attribute.remove(this.domNode);
	            delete this.attributes[attribute.attrName];
	        }
	    };
	    AttributorStore.prototype.build = function () {
	        var _this = this;
	        this.attributes = {};
	        var attributes = attributor_1.default.keys(this.domNode);
	        var classes = class_1.default.keys(this.domNode);
	        var styles = style_1.default.keys(this.domNode);
	        attributes
	            .concat(classes)
	            .concat(styles)
	            .forEach(function (name) {
	            var attr = Registry.query(name, Registry.Scope.ATTRIBUTE);
	            if (attr instanceof attributor_1.default) {
	                _this.attributes[attr.attrName] = attr;
	            }
	        });
	    };
	    AttributorStore.prototype.copy = function (target) {
	        var _this = this;
	        Object.keys(this.attributes).forEach(function (key) {
	            var value = _this.attributes[key].value(_this.domNode);
	            target.format(key, value);
	        });
	    };
	    AttributorStore.prototype.move = function (target) {
	        var _this = this;
	        this.copy(target);
	        Object.keys(this.attributes).forEach(function (key) {
	            _this.attributes[key].remove(_this.domNode);
	        });
	        this.attributes = {};
	    };
	    AttributorStore.prototype.values = function () {
	        var _this = this;
	        return Object.keys(this.attributes).reduce(function (attributes, name) {
	            attributes[name] = _this.attributes[name].value(_this.domNode);
	            return attributes;
	        }, {});
	    };
	    return AttributorStore;
	}());
	exports.default = AttributorStore;
	
	
	/***/ }),
	/* 32 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var attributor_1 = __webpack_require__(12);
	function match(node, prefix) {
	    var className = node.getAttribute('class') || '';
	    return className.split(/\s+/).filter(function (name) {
	        return name.indexOf(prefix + "-") === 0;
	    });
	}
	var ClassAttributor = /** @class */ (function (_super) {
	    __extends(ClassAttributor, _super);
	    function ClassAttributor() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    ClassAttributor.keys = function (node) {
	        return (node.getAttribute('class') || '').split(/\s+/).map(function (name) {
	            return name
	                .split('-')
	                .slice(0, -1)
	                .join('-');
	        });
	    };
	    ClassAttributor.prototype.add = function (node, value) {
	        if (!this.canAdd(node, value))
	            return false;
	        this.remove(node);
	        node.classList.add(this.keyName + "-" + value);
	        return true;
	    };
	    ClassAttributor.prototype.remove = function (node) {
	        var matches = match(node, this.keyName);
	        matches.forEach(function (name) {
	            node.classList.remove(name);
	        });
	        if (node.classList.length === 0) {
	            node.removeAttribute('class');
	        }
	    };
	    ClassAttributor.prototype.value = function (node) {
	        var result = match(node, this.keyName)[0] || '';
	        var value = result.slice(this.keyName.length + 1); // +1 for hyphen
	        return this.canAdd(node, value) ? value : '';
	    };
	    return ClassAttributor;
	}(attributor_1.default));
	exports.default = ClassAttributor;
	
	
	/***/ }),
	/* 33 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var attributor_1 = __webpack_require__(12);
	function camelize(name) {
	    var parts = name.split('-');
	    var rest = parts
	        .slice(1)
	        .map(function (part) {
	        return part[0].toUpperCase() + part.slice(1);
	    })
	        .join('');
	    return parts[0] + rest;
	}
	var StyleAttributor = /** @class */ (function (_super) {
	    __extends(StyleAttributor, _super);
	    function StyleAttributor() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    StyleAttributor.keys = function (node) {
	        return (node.getAttribute('style') || '').split(';').map(function (value) {
	            var arr = value.split(':');
	            return arr[0].trim();
	        });
	    };
	    StyleAttributor.prototype.add = function (node, value) {
	        if (!this.canAdd(node, value))
	            return false;
	        // @ts-ignore
	        node.style[camelize(this.keyName)] = value;
	        return true;
	    };
	    StyleAttributor.prototype.remove = function (node) {
	        // @ts-ignore
	        node.style[camelize(this.keyName)] = '';
	        if (!node.getAttribute('style')) {
	            node.removeAttribute('style');
	        }
	    };
	    StyleAttributor.prototype.value = function (node) {
	        // @ts-ignore
	        var value = node.style[camelize(this.keyName)];
	        return this.canAdd(node, value) ? value : '';
	    };
	    return StyleAttributor;
	}(attributor_1.default));
	exports.default = StyleAttributor;
	
	
	/***/ }),
	/* 34 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Theme = function () {
	  function Theme(quill, options) {
	    _classCallCheck(this, Theme);
	
	    this.quill = quill;
	    this.options = options;
	    this.modules = {};
	  }
	
	  _createClass(Theme, [{
	    key: 'init',
	    value: function init() {
	      var _this = this;
	
	      Object.keys(this.options.modules).forEach(function (name) {
	        if (_this.modules[name] == null) {
	          _this.addModule(name);
	        }
	      });
	    }
	  }, {
	    key: 'addModule',
	    value: function addModule(name) {
	      var moduleClass = this.quill.constructor.import('modules/' + name);
	      this.modules[name] = new moduleClass(this.quill, this.options.modules[name] || {});
	      return this.modules[name];
	    }
	  }]);
	
	  return Theme;
	}();
	
	Theme.DEFAULTS = {
	  modules: {}
	};
	Theme.themes = {
	  'default': Theme
	};
	
	exports.default = Theme;
	
	/***/ }),
	/* 35 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _parchment = __webpack_require__(0);
	
	var _parchment2 = _interopRequireDefault(_parchment);
	
	var _text = __webpack_require__(7);
	
	var _text2 = _interopRequireDefault(_text);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var GUARD_TEXT = '\uFEFF';
	
	var Embed = function (_Parchment$Embed) {
	  _inherits(Embed, _Parchment$Embed);
	
	  function Embed(node) {
	    _classCallCheck(this, Embed);
	
	    var _this = _possibleConstructorReturn(this, (Embed.__proto__ || Object.getPrototypeOf(Embed)).call(this, node));
	
	    _this.contentNode = document.createElement('span');
	    _this.contentNode.setAttribute('contenteditable', false);
	    [].slice.call(_this.domNode.childNodes).forEach(function (childNode) {
	      _this.contentNode.appendChild(childNode);
	    });
	    _this.leftGuard = document.createTextNode(GUARD_TEXT);
	    _this.rightGuard = document.createTextNode(GUARD_TEXT);
	    _this.domNode.appendChild(_this.leftGuard);
	    _this.domNode.appendChild(_this.contentNode);
	    _this.domNode.appendChild(_this.rightGuard);
	    return _this;
	  }
	
	  _createClass(Embed, [{
	    key: 'index',
	    value: function index(node, offset) {
	      if (node === this.leftGuard) return 0;
	      if (node === this.rightGuard) return 1;
	      return _get(Embed.prototype.__proto__ || Object.getPrototypeOf(Embed.prototype), 'index', this).call(this, node, offset);
	    }
	  }, {
	    key: 'restore',
	    value: function restore(node) {
	      var range = void 0,
	          textNode = void 0;
	      var text = node.data.split(GUARD_TEXT).join('');
	      if (node === this.leftGuard) {
	        if (this.prev instanceof _text2.default) {
	          var prevLength = this.prev.length();
	          this.prev.insertAt(prevLength, text);
	          range = {
	            startNode: this.prev.domNode,
	            startOffset: prevLength + text.length
	          };
	        } else {
	          textNode = document.createTextNode(text);
	          this.parent.insertBefore(_parchment2.default.create(textNode), this);
	          range = {
	            startNode: textNode,
	            startOffset: text.length
	          };
	        }
	      } else if (node === this.rightGuard) {
	        if (this.next instanceof _text2.default) {
	          this.next.insertAt(0, text);
	          range = {
	            startNode: this.next.domNode,
	            startOffset: text.length
	          };
	        } else {
	          textNode = document.createTextNode(text);
	          this.parent.insertBefore(_parchment2.default.create(textNode), this.next);
	          range = {
	            startNode: textNode,
	            startOffset: text.length
	          };
	        }
	      }
	      node.data = GUARD_TEXT;
	      return range;
	    }
	  }, {
	    key: 'update',
	    value: function update(mutations, context) {
	      var _this2 = this;
	
	      mutations.forEach(function (mutation) {
	        if (mutation.type === 'characterData' && (mutation.target === _this2.leftGuard || mutation.target === _this2.rightGuard)) {
	          var range = _this2.restore(mutation.target);
	          if (range) context.range = range;
	        }
	      });
	    }
	  }]);
	
	  return Embed;
	}(_parchment2.default.Embed);
	
	exports.default = Embed;
	
	/***/ }),
	/* 36 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.AlignStyle = exports.AlignClass = exports.AlignAttribute = undefined;
	
	var _parchment = __webpack_require__(0);
	
	var _parchment2 = _interopRequireDefault(_parchment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var config = {
	  scope: _parchment2.default.Scope.BLOCK,
	  whitelist: ['right', 'center', 'justify']
	};
	
	var AlignAttribute = new _parchment2.default.Attributor.Attribute('align', 'align', config);
	var AlignClass = new _parchment2.default.Attributor.Class('align', 'ql-align', config);
	var AlignStyle = new _parchment2.default.Attributor.Style('align', 'text-align', config);
	
	exports.AlignAttribute = AlignAttribute;
	exports.AlignClass = AlignClass;
	exports.AlignStyle = AlignStyle;
	
	/***/ }),
	/* 37 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.BackgroundStyle = exports.BackgroundClass = undefined;
	
	var _parchment = __webpack_require__(0);
	
	var _parchment2 = _interopRequireDefault(_parchment);
	
	var _color = __webpack_require__(26);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BackgroundClass = new _parchment2.default.Attributor.Class('background', 'ql-bg', {
	  scope: _parchment2.default.Scope.INLINE
	});
	var BackgroundStyle = new _color.ColorAttributor('background', 'background-color', {
	  scope: _parchment2.default.Scope.INLINE
	});
	
	exports.BackgroundClass = BackgroundClass;
	exports.BackgroundStyle = BackgroundStyle;
	
	/***/ }),
	/* 38 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.DirectionStyle = exports.DirectionClass = exports.DirectionAttribute = undefined;
	
	var _parchment = __webpack_require__(0);
	
	var _parchment2 = _interopRequireDefault(_parchment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var config = {
	  scope: _parchment2.default.Scope.BLOCK,
	  whitelist: ['rtl']
	};
	
	var DirectionAttribute = new _parchment2.default.Attributor.Attribute('direction', 'dir', config);
	var DirectionClass = new _parchment2.default.Attributor.Class('direction', 'ql-direction', config);
	var DirectionStyle = new _parchment2.default.Attributor.Style('direction', 'direction', config);
	
	exports.DirectionAttribute = DirectionAttribute;
	exports.DirectionClass = DirectionClass;
	exports.DirectionStyle = DirectionStyle;
	
	/***/ }),
	/* 39 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.FontClass = exports.FontStyle = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _parchment = __webpack_require__(0);
	
	var _parchment2 = _interopRequireDefault(_parchment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var config = {
	  scope: _parchment2.default.Scope.INLINE,
	  whitelist: ['serif', 'monospace']
	};
	
	var FontClass = new _parchment2.default.Attributor.Class('font', 'ql-font', config);
	
	var FontStyleAttributor = function (_Parchment$Attributor) {
	  _inherits(FontStyleAttributor, _Parchment$Attributor);
	
	  function FontStyleAttributor() {
	    _classCallCheck(this, FontStyleAttributor);
	
	    return _possibleConstructorReturn(this, (FontStyleAttributor.__proto__ || Object.getPrototypeOf(FontStyleAttributor)).apply(this, arguments));
	  }
	
	  _createClass(FontStyleAttributor, [{
	    key: 'value',
	    value: function value(node) {
	      return _get(FontStyleAttributor.prototype.__proto__ || Object.getPrototypeOf(FontStyleAttributor.prototype), 'value', this).call(this, node).replace(/["']/g, '');
	    }
	  }]);
	
	  return FontStyleAttributor;
	}(_parchment2.default.Attributor.Style);
	
	var FontStyle = new FontStyleAttributor('font', 'font-family', config);
	
	exports.FontStyle = FontStyle;
	exports.FontClass = FontClass;
	
	/***/ }),
	/* 40 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SizeStyle = exports.SizeClass = undefined;
	
	var _parchment = __webpack_require__(0);
	
	var _parchment2 = _interopRequireDefault(_parchment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SizeClass = new _parchment2.default.Attributor.Class('size', 'ql-size', {
	  scope: _parchment2.default.Scope.INLINE,
	  whitelist: ['small', 'large', 'huge']
	});
	var SizeStyle = new _parchment2.default.Attributor.Style('size', 'font-size', {
	  scope: _parchment2.default.Scope.INLINE,
	  whitelist: ['10px', '18px', '32px']
	});
	
	exports.SizeClass = SizeClass;
	exports.SizeStyle = SizeStyle;
	
	/***/ }),
	/* 41 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	module.exports = {
	  'align': {
	    '': __webpack_require__(76),
	    'center': __webpack_require__(77),
	    'right': __webpack_require__(78),
	    'justify': __webpack_require__(79)
	  },
	  'background': __webpack_require__(80),
	  'blockquote': __webpack_require__(81),
	  'bold': __webpack_require__(82),
	  'clean': __webpack_require__(83),
	  'code': __webpack_require__(58),
	  'code-block': __webpack_require__(58),
	  'color': __webpack_require__(84),
	  'direction': {
	    '': __webpack_require__(85),
	    'rtl': __webpack_require__(86)
	  },
	  'float': {
	    'center': __webpack_require__(87),
	    'full': __webpack_require__(88),
	    'left': __webpack_require__(89),
	    'right': __webpack_require__(90)
	  },
	  'formula': __webpack_require__(91),
	  'header': {
	    '1': __webpack_require__(92),
	    '2': __webpack_require__(93)
	  },
	  'italic': __webpack_require__(94),
	  'image': __webpack_require__(95),
	  'indent': {
	    '+1': __webpack_require__(96),
	    '-1': __webpack_require__(97)
	  },
	  'link': __webpack_require__(98),
	  'list': {
	    'ordered': __webpack_require__(99),
	    'bullet': __webpack_require__(100),
	    'check': __webpack_require__(101)
	  },
	  'script': {
	    'sub': __webpack_require__(102),
	    'super': __webpack_require__(103)
	  },
	  'strike': __webpack_require__(104),
	  'underline': __webpack_require__(105),
	  'video': __webpack_require__(106)
	};
	
	/***/ }),
	/* 42 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getLastChangeIndex = exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _parchment = __webpack_require__(0);
	
	var _parchment2 = _interopRequireDefault(_parchment);
	
	var _quill = __webpack_require__(5);
	
	var _quill2 = _interopRequireDefault(_quill);
	
	var _module = __webpack_require__(9);
	
	var _module2 = _interopRequireDefault(_module);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var History = function (_Module) {
	  _inherits(History, _Module);
	
	  function History(quill, options) {
	    _classCallCheck(this, History);
	
	    var _this = _possibleConstructorReturn(this, (History.__proto__ || Object.getPrototypeOf(History)).call(this, quill, options));
	
	    _this.lastRecorded = 0;
	    _this.ignoreChange = false;
	    _this.clear();
	    _this.quill.on(_quill2.default.events.EDITOR_CHANGE, function (eventName, delta, oldDelta, source) {
	      if (eventName !== _quill2.default.events.TEXT_CHANGE || _this.ignoreChange) return;
	      if (!_this.options.userOnly || source === _quill2.default.sources.USER) {
	        _this.record(delta, oldDelta);
	      } else {
	        _this.transform(delta);
	      }
	    });
	    _this.quill.keyboard.addBinding({ key: 'Z', shortKey: true }, _this.undo.bind(_this));
	    _this.quill.keyboard.addBinding({ key: 'Z', shortKey: true, shiftKey: true }, _this.redo.bind(_this));
	    if (/Win/i.test(navigator.platform)) {
	      _this.quill.keyboard.addBinding({ key: 'Y', shortKey: true }, _this.redo.bind(_this));
	    }
	    return _this;
	  }
	
	  _createClass(History, [{
	    key: 'change',
	    value: function change(source, dest) {
	      if (this.stack[source].length === 0) return;
	      var delta = this.stack[source].pop();
	      this.stack[dest].push(delta);
	      this.lastRecorded = 0;
	      this.ignoreChange = true;
	      this.quill.updateContents(delta[source], _quill2.default.sources.USER);
	      this.ignoreChange = false;
	      var index = getLastChangeIndex(delta[source]);
	      this.quill.setSelection(index);
	    }
	  }, {
	    key: 'clear',
	    value: function clear() {
	      this.stack = { undo: [], redo: [] };
	    }
	  }, {
	    key: 'cutoff',
	    value: function cutoff() {
	      this.lastRecorded = 0;
	    }
	  }, {
	    key: 'record',
	    value: function record(changeDelta, oldDelta) {
	      if (changeDelta.ops.length === 0) return;
	      this.stack.redo = [];
	      var undoDelta = this.quill.getContents().diff(oldDelta);
	      var timestamp = Date.now();
	      if (this.lastRecorded + this.options.delay > timestamp && this.stack.undo.length > 0) {
	        var delta = this.stack.undo.pop();
	        undoDelta = undoDelta.compose(delta.undo);
	        changeDelta = delta.redo.compose(changeDelta);
	      } else {
	        this.lastRecorded = timestamp;
	      }
	      this.stack.undo.push({
	        redo: changeDelta,
	        undo: undoDelta
	      });
	      if (this.stack.undo.length > this.options.maxStack) {
	        this.stack.undo.shift();
	      }
	    }
	  }, {
	    key: 'redo',
	    value: function redo() {
	      this.change('redo', 'undo');
	    }
	  }, {
	    key: 'transform',
	    value: function transform(delta) {
	      this.stack.undo.forEach(function (change) {
	        change.undo = delta.transform(change.undo, true);
	        change.redo = delta.transform(change.redo, true);
	      });
	      this.stack.redo.forEach(function (change) {
	        change.undo = delta.transform(change.undo, true);
	        change.redo = delta.transform(change.redo, true);
	      });
	    }
	  }, {
	    key: 'undo',
	    value: function undo() {
	      this.change('undo', 'redo');
	    }
	  }]);
	
	  return History;
	}(_module2.default);
	
	History.DEFAULTS = {
	  delay: 1000,
	  maxStack: 100,
	  userOnly: false
	};
	
	function endsWithNewlineChange(delta) {
	  var lastOp = delta.ops[delta.ops.length - 1];
	  if (lastOp == null) return false;
	  if (lastOp.insert != null) {
	    return typeof lastOp.insert === 'string' && lastOp.insert.endsWith('\n');
	  }
	  if (lastOp.attributes != null) {
	    return Object.keys(lastOp.attributes).some(function (attr) {
	      return _parchment2.default.query(attr, _parchment2.default.Scope.BLOCK) != null;
	    });
	  }
	  return false;
	}
	
	function getLastChangeIndex(delta) {
	  var deleteLength = delta.reduce(function (length, op) {
	    length += op.delete || 0;
	    return length;
	  }, 0);
	  var changeIndex = delta.length() - deleteLength;
	  if (endsWithNewlineChange(delta)) {
	    changeIndex -= 1;
	  }
	  return changeIndex;
	}
	
	exports.default = History;
	exports.getLastChangeIndex = getLastChangeIndex;
	
	/***/ }),
	/* 43 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.BaseTooltip = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _extend = __webpack_require__(3);
	
	var _extend2 = _interopRequireDefault(_extend);
	
	var _quillDelta = __webpack_require__(2);
	
	var _quillDelta2 = _interopRequireDefault(_quillDelta);
	
	var _emitter = __webpack_require__(8);
	
	var _emitter2 = _interopRequireDefault(_emitter);
	
	var _keyboard = __webpack_require__(23);
	
	var _keyboard2 = _interopRequireDefault(_keyboard);
	
	var _theme = __webpack_require__(34);
	
	var _theme2 = _interopRequireDefault(_theme);
	
	var _colorPicker = __webpack_require__(59);
	
	var _colorPicker2 = _interopRequireDefault(_colorPicker);
	
	var _iconPicker = __webpack_require__(60);
	
	var _iconPicker2 = _interopRequireDefault(_iconPicker);
	
	var _picker = __webpack_require__(28);
	
	var _picker2 = _interopRequireDefault(_picker);
	
	var _tooltip = __webpack_require__(61);
	
	var _tooltip2 = _interopRequireDefault(_tooltip);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ALIGNS = [false, 'center', 'right', 'justify'];
	
	var COLORS = ["#000000", "#e60000", "#ff9900", "#ffff00", "#008a00", "#0066cc", "#9933ff", "#ffffff", "#facccc", "#ffebcc", "#ffffcc", "#cce8cc", "#cce0f5", "#ebd6ff", "#bbbbbb", "#f06666", "#ffc266", "#ffff66", "#66b966", "#66a3e0", "#c285ff", "#888888", "#a10000", "#b26b00", "#b2b200", "#006100", "#0047b2", "#6b24b2", "#444444", "#5c0000", "#663d00", "#666600", "#003700", "#002966", "#3d1466"];
	
	var FONTS = [false, 'serif', 'monospace'];
	
	var HEADERS = ['1', '2', '3', false];
	
	var SIZES = ['small', false, 'large', 'huge'];
	
	var BaseTheme = function (_Theme) {
	  _inherits(BaseTheme, _Theme);
	
	  function BaseTheme(quill, options) {
	    _classCallCheck(this, BaseTheme);
	
	    var _this = _possibleConstructorReturn(this, (BaseTheme.__proto__ || Object.getPrototypeOf(BaseTheme)).call(this, quill, options));
	
	    var listener = function listener(e) {
	      if (!document.body.contains(quill.root)) {
	        return document.body.removeEventListener('click', listener);
	      }
	      if (_this.tooltip != null && !_this.tooltip.root.contains(e.target) && document.activeElement !== _this.tooltip.textbox && !_this.quill.hasFocus()) {
	        _this.tooltip.hide();
	      }
	      if (_this.pickers != null) {
	        _this.pickers.forEach(function (picker) {
	          if (!picker.container.contains(e.target)) {
	            picker.close();
	          }
	        });
	      }
	    };
	    quill.emitter.listenDOM('click', document.body, listener);
	    return _this;
	  }
	
	  _createClass(BaseTheme, [{
	    key: 'addModule',
	    value: function addModule(name) {
	      var module = _get(BaseTheme.prototype.__proto__ || Object.getPrototypeOf(BaseTheme.prototype), 'addModule', this).call(this, name);
	      if (name === 'toolbar') {
	        this.extendToolbar(module);
	      }
	      return module;
	    }
	  }, {
	    key: 'buildButtons',
	    value: function buildButtons(buttons, icons) {
	      buttons.forEach(function (button) {
	        var className = button.getAttribute('class') || '';
	        className.split(/\s+/).forEach(function (name) {
	          if (!name.startsWith('ql-')) return;
	          name = name.slice('ql-'.length);
	          if (icons[name] == null) return;
	          if (name === 'direction') {
	            button.innerHTML = icons[name][''] + icons[name]['rtl'];
	          } else if (typeof icons[name] === 'string') {
	            button.innerHTML = icons[name];
	          } else {
	            var value = button.value || '';
	            if (value != null && icons[name][value]) {
	              button.innerHTML = icons[name][value];
	            }
	          }
	        });
	      });
	    }
	  }, {
	    key: 'buildPickers',
	    value: function buildPickers(selects, icons) {
	      var _this2 = this;
	
	      this.pickers = selects.map(function (select) {
	        if (select.classList.contains('ql-align')) {
	          if (select.querySelector('option') == null) {
	            fillSelect(select, ALIGNS);
	          }
	          return new _iconPicker2.default(select, icons.align);
	        } else if (select.classList.contains('ql-background') || select.classList.contains('ql-color')) {
	          var format = select.classList.contains('ql-background') ? 'background' : 'color';
	          if (select.querySelector('option') == null) {
	            fillSelect(select, COLORS, format === 'background' ? '#ffffff' : '#000000');
	          }
	          return new _colorPicker2.default(select, icons[format]);
	        } else {
	          if (select.querySelector('option') == null) {
	            if (select.classList.contains('ql-font')) {
	              fillSelect(select, FONTS);
	            } else if (select.classList.contains('ql-header')) {
	              fillSelect(select, HEADERS);
	            } else if (select.classList.contains('ql-size')) {
	              fillSelect(select, SIZES);
	            }
	          }
	          return new _picker2.default(select);
	        }
	      });
	      var update = function update() {
	        _this2.pickers.forEach(function (picker) {
	          picker.update();
	        });
	      };
	      this.quill.on(_emitter2.default.events.EDITOR_CHANGE, update);
	    }
	  }]);
	
	  return BaseTheme;
	}(_theme2.default);
	
	BaseTheme.DEFAULTS = (0, _extend2.default)(true, {}, _theme2.default.DEFAULTS, {
	  modules: {
	    toolbar: {
	      handlers: {
	        formula: function formula() {
	          this.quill.theme.tooltip.edit('formula');
	        },
	        image: function image() {
	          var _this3 = this;
	
	          var fileInput = this.container.querySelector('input.ql-image[type=file]');
	          if (fileInput == null) {
	            fileInput = document.createElement('input');
	            fileInput.setAttribute('type', 'file');
	            fileInput.setAttribute('accept', 'image/png, image/gif, image/jpeg, image/bmp, image/x-icon');
	            fileInput.classList.add('ql-image');
	            fileInput.addEventListener('change', function () {
	              if (fileInput.files != null && fileInput.files[0] != null) {
	                var reader = new FileReader();
	                reader.onload = function (e) {
	                  var range = _this3.quill.getSelection(true);
	                  _this3.quill.updateContents(new _quillDelta2.default().retain(range.index).delete(range.length).insert({ image: e.target.result }), _emitter2.default.sources.USER);
	                  _this3.quill.setSelection(range.index + 1, _emitter2.default.sources.SILENT);
	                  fileInput.value = "";
	                };
	                reader.readAsDataURL(fileInput.files[0]);
	              }
	            });
	            this.container.appendChild(fileInput);
	          }
	          fileInput.click();
	        },
	        video: function video() {
	          this.quill.theme.tooltip.edit('video');
	        }
	      }
	    }
	  }
	});
	
	var BaseTooltip = function (_Tooltip) {
	  _inherits(BaseTooltip, _Tooltip);
	
	  function BaseTooltip(quill, boundsContainer) {
	    _classCallCheck(this, BaseTooltip);
	
	    var _this4 = _possibleConstructorReturn(this, (BaseTooltip.__proto__ || Object.getPrototypeOf(BaseTooltip)).call(this, quill, boundsContainer));
	
	    _this4.textbox = _this4.root.querySelector('input[type="text"]');
	    _this4.listen();
	    return _this4;
	  }
	
	  _createClass(BaseTooltip, [{
	    key: 'listen',
	    value: function listen() {
	      var _this5 = this;
	
	      this.textbox.addEventListener('keydown', function (event) {
	        if (_keyboard2.default.match(event, 'enter')) {
	          _this5.save();
	          event.preventDefault();
	        } else if (_keyboard2.default.match(event, 'escape')) {
	          _this5.cancel();
	          event.preventDefault();
	        }
	      });
	    }
	  }, {
	    key: 'cancel',
	    value: function cancel() {
	      this.hide();
	    }
	  }, {
	    key: 'edit',
	    value: function edit() {
	      var mode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'link';
	      var preview = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	
	      this.root.classList.remove('ql-hidden');
	      this.root.classList.add('ql-editing');
	      if (preview != null) {
	        this.textbox.value = preview;
	      } else if (mode !== this.root.getAttribute('data-mode')) {
	        this.textbox.value = '';
	      }
	      this.position(this.quill.getBounds(this.quill.selection.savedRange));
	      this.textbox.select();
	      this.textbox.setAttribute('placeholder', this.textbox.getAttribute('data-' + mode) || '');
	      this.root.setAttribute('data-mode', mode);
	    }
	  }, {
	    key: 'restoreFocus',
	    value: function restoreFocus() {
	      var scrollTop = this.quill.scrollingContainer.scrollTop;
	      this.quill.focus();
	      this.quill.scrollingContainer.scrollTop = scrollTop;
	    }
	  }, {
	    key: 'save',
	    value: function save() {
	      var value = this.textbox.value;
	      switch (this.root.getAttribute('data-mode')) {
	        case 'link':
	          {
	            var scrollTop = this.quill.root.scrollTop;
	            if (this.linkRange) {
	              this.quill.formatText(this.linkRange, 'link', value, _emitter2.default.sources.USER);
	              delete this.linkRange;
	            } else {
	              this.restoreFocus();
	              this.quill.format('link', value, _emitter2.default.sources.USER);
	            }
	            this.quill.root.scrollTop = scrollTop;
	            break;
	          }
	        case 'video':
	          {
	            value = extractVideoUrl(value);
	          } // eslint-disable-next-line no-fallthrough
	        case 'formula':
	          {
	            if (!value) break;
	            var range = this.quill.getSelection(true);
	            if (range != null) {
	              var index = range.index + range.length;
	              this.quill.insertEmbed(index, this.root.getAttribute('data-mode'), value, _emitter2.default.sources.USER);
	              if (this.root.getAttribute('data-mode') === 'formula') {
	                this.quill.insertText(index + 1, ' ', _emitter2.default.sources.USER);
	              }
	              this.quill.setSelection(index + 2, _emitter2.default.sources.USER);
	            }
	            break;
	          }
	        default:
	      }
	      this.textbox.value = '';
	      this.hide();
	    }
	  }]);
	
	  return BaseTooltip;
	}(_tooltip2.default);
	
	function extractVideoUrl(url) {
	  var match = url.match(/^(?:(https?):\/\/)?(?:(?:www|m)\.)?youtube\.com\/watch.*v=([a-zA-Z0-9_-]+)/) || url.match(/^(?:(https?):\/\/)?(?:(?:www|m)\.)?youtu\.be\/([a-zA-Z0-9_-]+)/);
	  if (match) {
	    return (match[1] || 'https') + '://www.youtube.com/embed/' + match[2] + '?showinfo=0';
	  }
	  if (match = url.match(/^(?:(https?):\/\/)?(?:www\.)?vimeo\.com\/(\d+)/)) {
	    // eslint-disable-line no-cond-assign
	    return (match[1] || 'https') + '://player.vimeo.com/video/' + match[2] + '/';
	  }
	  return url;
	}
	
	function fillSelect(select, values) {
	  var defaultValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	  values.forEach(function (value) {
	    var option = document.createElement('option');
	    if (value === defaultValue) {
	      option.setAttribute('selected', 'selected');
	    } else {
	      option.setAttribute('value', value);
	    }
	    select.appendChild(option);
	  });
	}
	
	exports.BaseTooltip = BaseTooltip;
	exports.default = BaseTheme;
	
	/***/ }),
	/* 44 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var LinkedList = /** @class */ (function () {
	    function LinkedList() {
	        this.head = this.tail = null;
	        this.length = 0;
	    }
	    LinkedList.prototype.append = function () {
	        var nodes = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            nodes[_i] = arguments[_i];
	        }
	        this.insertBefore(nodes[0], null);
	        if (nodes.length > 1) {
	            this.append.apply(this, nodes.slice(1));
	        }
	    };
	    LinkedList.prototype.contains = function (node) {
	        var cur, next = this.iterator();
	        while ((cur = next())) {
	            if (cur === node)
	                return true;
	        }
	        return false;
	    };
	    LinkedList.prototype.insertBefore = function (node, refNode) {
	        if (!node)
	            return;
	        node.next = refNode;
	        if (refNode != null) {
	            node.prev = refNode.prev;
	            if (refNode.prev != null) {
	                refNode.prev.next = node;
	            }
	            refNode.prev = node;
	            if (refNode === this.head) {
	                this.head = node;
	            }
	        }
	        else if (this.tail != null) {
	            this.tail.next = node;
	            node.prev = this.tail;
	            this.tail = node;
	        }
	        else {
	            node.prev = null;
	            this.head = this.tail = node;
	        }
	        this.length += 1;
	    };
	    LinkedList.prototype.offset = function (target) {
	        var index = 0, cur = this.head;
	        while (cur != null) {
	            if (cur === target)
	                return index;
	            index += cur.length();
	            cur = cur.next;
	        }
	        return -1;
	    };
	    LinkedList.prototype.remove = function (node) {
	        if (!this.contains(node))
	            return;
	        if (node.prev != null)
	            node.prev.next = node.next;
	        if (node.next != null)
	            node.next.prev = node.prev;
	        if (node === this.head)
	            this.head = node.next;
	        if (node === this.tail)
	            this.tail = node.prev;
	        this.length -= 1;
	    };
	    LinkedList.prototype.iterator = function (curNode) {
	        if (curNode === void 0) { curNode = this.head; }
	        // TODO use yield when we can
	        return function () {
	            var ret = curNode;
	            if (curNode != null)
	                curNode = curNode.next;
	            return ret;
	        };
	    };
	    LinkedList.prototype.find = function (index, inclusive) {
	        if (inclusive === void 0) { inclusive = false; }
	        var cur, next = this.iterator();
	        while ((cur = next())) {
	            var length = cur.length();
	            if (index < length ||
	                (inclusive && index === length && (cur.next == null || cur.next.length() !== 0))) {
	                return [cur, index];
	            }
	            index -= length;
	        }
	        return [null, 0];
	    };
	    LinkedList.prototype.forEach = function (callback) {
	        var cur, next = this.iterator();
	        while ((cur = next())) {
	            callback(cur);
	        }
	    };
	    LinkedList.prototype.forEachAt = function (index, length, callback) {
	        if (length <= 0)
	            return;
	        var _a = this.find(index), startNode = _a[0], offset = _a[1];
	        var cur, curIndex = index - offset, next = this.iterator(startNode);
	        while ((cur = next()) && curIndex < index + length) {
	            var curLength = cur.length();
	            if (index > curIndex) {
	                callback(cur, index - curIndex, Math.min(length, curIndex + curLength - index));
	            }
	            else {
	                callback(cur, 0, Math.min(curLength, index + length - curIndex));
	            }
	            curIndex += curLength;
	        }
	    };
	    LinkedList.prototype.map = function (callback) {
	        return this.reduce(function (memo, cur) {
	            memo.push(callback(cur));
	            return memo;
	        }, []);
	    };
	    LinkedList.prototype.reduce = function (callback, memo) {
	        var cur, next = this.iterator();
	        while ((cur = next())) {
	            memo = callback(memo, cur);
	        }
	        return memo;
	    };
	    return LinkedList;
	}());
	exports.default = LinkedList;
	
	
	/***/ }),
	/* 45 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var container_1 = __webpack_require__(17);
	var Registry = __webpack_require__(1);
	var OBSERVER_CONFIG = {
	    attributes: true,
	    characterData: true,
	    characterDataOldValue: true,
	    childList: true,
	    subtree: true,
	};
	var MAX_OPTIMIZE_ITERATIONS = 100;
	var ScrollBlot = /** @class */ (function (_super) {
	    __extends(ScrollBlot, _super);
	    function ScrollBlot(node) {
	        var _this = _super.call(this, node) || this;
	        _this.scroll = _this;
	        _this.observer = new MutationObserver(function (mutations) {
	            _this.update(mutations);
	        });
	        _this.observer.observe(_this.domNode, OBSERVER_CONFIG);
	        _this.attach();
	        return _this;
	    }
	    ScrollBlot.prototype.detach = function () {
	        _super.prototype.detach.call(this);
	        this.observer.disconnect();
	    };
	    ScrollBlot.prototype.deleteAt = function (index, length) {
	        this.update();
	        if (index === 0 && length === this.length()) {
	            this.children.forEach(function (child) {
	                child.remove();
	            });
	        }
	        else {
	            _super.prototype.deleteAt.call(this, index, length);
	        }
	    };
	    ScrollBlot.prototype.formatAt = function (index, length, name, value) {
	        this.update();
	        _super.prototype.formatAt.call(this, index, length, name, value);
	    };
	    ScrollBlot.prototype.insertAt = function (index, value, def) {
	        this.update();
	        _super.prototype.insertAt.call(this, index, value, def);
	    };
	    ScrollBlot.prototype.optimize = function (mutations, context) {
	        var _this = this;
	        if (mutations === void 0) { mutations = []; }
	        if (context === void 0) { context = {}; }
	        _super.prototype.optimize.call(this, context);
	        // We must modify mutations directly, cannot make copy and then modify
	        var records = [].slice.call(this.observer.takeRecords());
	        // Array.push currently seems to be implemented by a non-tail recursive function
	        // so we cannot just mutations.push.apply(mutations, this.observer.takeRecords());
	        while (records.length > 0)
	            mutations.push(records.pop());
	        // TODO use WeakMap
	        var mark = function (blot, markParent) {
	            if (markParent === void 0) { markParent = true; }
	            if (blot == null || blot === _this)
	                return;
	            if (blot.domNode.parentNode == null)
	                return;
	            // @ts-ignore
	            if (blot.domNode[Registry.DATA_KEY].mutations == null) {
	                // @ts-ignore
	                blot.domNode[Registry.DATA_KEY].mutations = [];
	            }
	            if (markParent)
	                mark(blot.parent);
	        };
	        var optimize = function (blot) {
	            // Post-order traversal
	            if (
	            // @ts-ignore
	            blot.domNode[Registry.DATA_KEY] == null ||
	                // @ts-ignore
	                blot.domNode[Registry.DATA_KEY].mutations == null) {
	                return;
	            }
	            if (blot instanceof container_1.default) {
	                blot.children.forEach(optimize);
	            }
	            blot.optimize(context);
	        };
	        var remaining = mutations;
	        for (var i = 0; remaining.length > 0; i += 1) {
	            if (i >= MAX_OPTIMIZE_ITERATIONS) {
	                throw new Error('[Parchment] Maximum optimize iterations reached');
	            }
	            remaining.forEach(function (mutation) {
	                var blot = Registry.find(mutation.target, true);
	                if (blot == null)
	                    return;
	                if (blot.domNode === mutation.target) {
	                    if (mutation.type === 'childList') {
	                        mark(Registry.find(mutation.previousSibling, false));
	                        [].forEach.call(mutation.addedNodes, function (node) {
	                            var child = Registry.find(node, false);
	                            mark(child, false);
	                            if (child instanceof container_1.default) {
	                                child.children.forEach(function (grandChild) {
	                                    mark(grandChild, false);
	                                });
	                            }
	                        });
	                    }
	                    else if (mutation.type === 'attributes') {
	                        mark(blot.prev);
	                    }
	                }
	                mark(blot);
	            });
	            this.children.forEach(optimize);
	            remaining = [].slice.call(this.observer.takeRecords());
	            records = remaining.slice();
	            while (records.length > 0)
	                mutations.push(records.pop());
	        }
	    };
	    ScrollBlot.prototype.update = function (mutations, context) {
	        var _this = this;
	        if (context === void 0) { context = {}; }
	        mutations = mutations || this.observer.takeRecords();
	        // TODO use WeakMap
	        mutations
	            .map(function (mutation) {
	            var blot = Registry.find(mutation.target, true);
	            if (blot == null)
	                return null;
	            // @ts-ignore
	            if (blot.domNode[Registry.DATA_KEY].mutations == null) {
	                // @ts-ignore
	                blot.domNode[Registry.DATA_KEY].mutations = [mutation];
	                return blot;
	            }
	            else {
	                // @ts-ignore
	                blot.domNode[Registry.DATA_KEY].mutations.push(mutation);
	                return null;
	            }
	        })
	            .forEach(function (blot) {
	            if (blot == null ||
	                blot === _this ||
	                //@ts-ignore
	                blot.domNode[Registry.DATA_KEY] == null)
	                return;
	            // @ts-ignore
	            blot.update(blot.domNode[Registry.DATA_KEY].mutations || [], context);
	        });
	        // @ts-ignore
	        if (this.domNode[Registry.DATA_KEY].mutations != null) {
	            // @ts-ignore
	            _super.prototype.update.call(this, this.domNode[Registry.DATA_KEY].mutations, context);
	        }
	        this.optimize(mutations, context);
	    };
	    ScrollBlot.blotName = 'scroll';
	    ScrollBlot.defaultChild = 'block';
	    ScrollBlot.scope = Registry.Scope.BLOCK_BLOT;
	    ScrollBlot.tagName = 'DIV';
	    return ScrollBlot;
	}(container_1.default));
	exports.default = ScrollBlot;
	
	
	/***/ }),
	/* 46 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var format_1 = __webpack_require__(18);
	var Registry = __webpack_require__(1);
	// Shallow object comparison
	function isEqual(obj1, obj2) {
	    if (Object.keys(obj1).length !== Object.keys(obj2).length)
	        return false;
	    // @ts-ignore
	    for (var prop in obj1) {
	        // @ts-ignore
	        if (obj1[prop] !== obj2[prop])
	            return false;
	    }
	    return true;
	}
	var InlineBlot = /** @class */ (function (_super) {
	    __extends(InlineBlot, _super);
	    function InlineBlot() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    InlineBlot.formats = function (domNode) {
	        if (domNode.tagName === InlineBlot.tagName)
	            return undefined;
	        return _super.formats.call(this, domNode);
	    };
	    InlineBlot.prototype.format = function (name, value) {
	        var _this = this;
	        if (name === this.statics.blotName && !value) {
	            this.children.forEach(function (child) {
	                if (!(child instanceof format_1.default)) {
	                    child = child.wrap(InlineBlot.blotName, true);
	                }
	                _this.attributes.copy(child);
	            });
	            this.unwrap();
	        }
	        else {
	            _super.prototype.format.call(this, name, value);
	        }
	    };
	    InlineBlot.prototype.formatAt = function (index, length, name, value) {
	        if (this.formats()[name] != null || Registry.query(name, Registry.Scope.ATTRIBUTE)) {
	            var blot = this.isolate(index, length);
	            blot.format(name, value);
	        }
	        else {
	            _super.prototype.formatAt.call(this, index, length, name, value);
	        }
	    };
	    InlineBlot.prototype.optimize = function (context) {
	        _super.prototype.optimize.call(this, context);
	        var formats = this.formats();
	        if (Object.keys(formats).length === 0) {
	            return this.unwrap(); // unformatted span
	        }
	        var next = this.next;
	        if (next instanceof InlineBlot && next.prev === this && isEqual(formats, next.formats())) {
	            next.moveChildren(this);
	            next.remove();
	        }
	    };
	    InlineBlot.blotName = 'inline';
	    InlineBlot.scope = Registry.Scope.INLINE_BLOT;
	    InlineBlot.tagName = 'SPAN';
	    return InlineBlot;
	}(format_1.default));
	exports.default = InlineBlot;
	
	
	/***/ }),
	/* 47 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var format_1 = __webpack_require__(18);
	var Registry = __webpack_require__(1);
	var BlockBlot = /** @class */ (function (_super) {
	    __extends(BlockBlot, _super);
	    function BlockBlot() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    BlockBlot.formats = function (domNode) {
	        var tagName = Registry.query(BlockBlot.blotName).tagName;
	        if (domNode.tagName === tagName)
	            return undefined;
	        return _super.formats.call(this, domNode);
	    };
	    BlockBlot.prototype.format = function (name, value) {
	        if (Registry.query(name, Registry.Scope.BLOCK) == null) {
	            return;
	        }
	        else if (name === this.statics.blotName && !value) {
	            this.replaceWith(BlockBlot.blotName);
	        }
	        else {
	            _super.prototype.format.call(this, name, value);
	        }
	    };
	    BlockBlot.prototype.formatAt = function (index, length, name, value) {
	        if (Registry.query(name, Registry.Scope.BLOCK) != null) {
	            this.format(name, value);
	        }
	        else {
	            _super.prototype.formatAt.call(this, index, length, name, value);
	        }
	    };
	    BlockBlot.prototype.insertAt = function (index, value, def) {
	        if (def == null || Registry.query(value, Registry.Scope.INLINE) != null) {
	            // Insert text or inline
	            _super.prototype.insertAt.call(this, index, value, def);
	        }
	        else {
	            var after = this.split(index);
	            var blot = Registry.create(value, def);
	            after.parent.insertBefore(blot, after);
	        }
	    };
	    BlockBlot.prototype.update = function (mutations, context) {
	        if (navigator.userAgent.match(/Trident/)) {
	            this.build();
	        }
	        else {
	            _super.prototype.update.call(this, mutations, context);
	        }
	    };
	    BlockBlot.blotName = 'block';
	    BlockBlot.scope = Registry.Scope.BLOCK_BLOT;
	    BlockBlot.tagName = 'P';
	    return BlockBlot;
	}(format_1.default));
	exports.default = BlockBlot;
	
	
	/***/ }),
	/* 48 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var leaf_1 = __webpack_require__(19);
	var EmbedBlot = /** @class */ (function (_super) {
	    __extends(EmbedBlot, _super);
	    function EmbedBlot() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    EmbedBlot.formats = function (domNode) {
	        return undefined;
	    };
	    EmbedBlot.prototype.format = function (name, value) {
	        // super.formatAt wraps, which is what we want in general,
	        // but this allows subclasses to overwrite for formats
	        // that just apply to particular embeds
	        _super.prototype.formatAt.call(this, 0, this.length(), name, value);
	    };
	    EmbedBlot.prototype.formatAt = function (index, length, name, value) {
	        if (index === 0 && length === this.length()) {
	            this.format(name, value);
	        }
	        else {
	            _super.prototype.formatAt.call(this, index, length, name, value);
	        }
	    };
	    EmbedBlot.prototype.formats = function () {
	        return this.statics.formats(this.domNode);
	    };
	    return EmbedBlot;
	}(leaf_1.default));
	exports.default = EmbedBlot;
	
	
	/***/ }),
	/* 49 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var leaf_1 = __webpack_require__(19);
	var Registry = __webpack_require__(1);
	var TextBlot = /** @class */ (function (_super) {
	    __extends(TextBlot, _super);
	    function TextBlot(node) {
	        var _this = _super.call(this, node) || this;
	        _this.text = _this.statics.value(_this.domNode);
	        return _this;
	    }
	    TextBlot.create = function (value) {
	        return document.createTextNode(value);
	    };
	    TextBlot.value = function (domNode) {
	        var text = domNode.data;
	        // @ts-ignore
	        if (text['normalize'])
	            text = text['normalize']();
	        return text;
	    };
	    TextBlot.prototype.deleteAt = function (index, length) {
	        this.domNode.data = this.text = this.text.slice(0, index) + this.text.slice(index + length);
	    };
	    TextBlot.prototype.index = function (node, offset) {
	        if (this.domNode === node) {
	            return offset;
	        }
	        return -1;
	    };
	    TextBlot.prototype.insertAt = function (index, value, def) {
	        if (def == null) {
	            this.text = this.text.slice(0, index) + value + this.text.slice(index);
	            this.domNode.data = this.text;
	        }
	        else {
	            _super.prototype.insertAt.call(this, index, value, def);
	        }
	    };
	    TextBlot.prototype.length = function () {
	        return this.text.length;
	    };
	    TextBlot.prototype.optimize = function (context) {
	        _super.prototype.optimize.call(this, context);
	        this.text = this.statics.value(this.domNode);
	        if (this.text.length === 0) {
	            this.remove();
	        }
	        else if (this.next instanceof TextBlot && this.next.prev === this) {
	            this.insertAt(this.length(), this.next.value());
	            this.next.remove();
	        }
	    };
	    TextBlot.prototype.position = function (index, inclusive) {
	        if (inclusive === void 0) { inclusive = false; }
	        return [this.domNode, index];
	    };
	    TextBlot.prototype.split = function (index, force) {
	        if (force === void 0) { force = false; }
	        if (!force) {
	            if (index === 0)
	                return this;
	            if (index === this.length())
	                return this.next;
	        }
	        var after = Registry.create(this.domNode.splitText(index));
	        this.parent.insertBefore(after, this.next);
	        this.text = this.statics.value(this.domNode);
	        return after;
	    };
	    TextBlot.prototype.update = function (mutations, context) {
	        var _this = this;
	        if (mutations.some(function (mutation) {
	            return mutation.type === 'characterData' && mutation.target === _this.domNode;
	        })) {
	            this.text = this.statics.value(this.domNode);
	        }
	    };
	    TextBlot.prototype.value = function () {
	        return this.text;
	    };
	    TextBlot.blotName = 'text';
	    TextBlot.scope = Registry.Scope.INLINE_BLOT;
	    return TextBlot;
	}(leaf_1.default));
	exports.default = TextBlot;
	
	
	/***/ }),
	/* 50 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	var elem = document.createElement('div');
	elem.classList.toggle('test-class', false);
	if (elem.classList.contains('test-class')) {
	  var _toggle = DOMTokenList.prototype.toggle;
	  DOMTokenList.prototype.toggle = function (token, force) {
	    if (arguments.length > 1 && !this.contains(token) === !force) {
	      return force;
	    } else {
	      return _toggle.call(this, token);
	    }
	  };
	}
	
	if (!String.prototype.startsWith) {
	  String.prototype.startsWith = function (searchString, position) {
	    position = position || 0;
	    return this.substr(position, searchString.length) === searchString;
	  };
	}
	
	if (!String.prototype.endsWith) {
	  String.prototype.endsWith = function (searchString, position) {
	    var subjectString = this.toString();
	    if (typeof position !== 'number' || !isFinite(position) || Math.floor(position) !== position || position > subjectString.length) {
	      position = subjectString.length;
	    }
	    position -= searchString.length;
	    var lastIndex = subjectString.indexOf(searchString, position);
	    return lastIndex !== -1 && lastIndex === position;
	  };
	}
	
	if (!Array.prototype.find) {
	  Object.defineProperty(Array.prototype, "find", {
	    value: function value(predicate) {
	      if (this === null) {
	        throw new TypeError('Array.prototype.find called on null or undefined');
	      }
	      if (typeof predicate !== 'function') {
	        throw new TypeError('predicate must be a function');
	      }
	      var list = Object(this);
	      var length = list.length >>> 0;
	      var thisArg = arguments[1];
	      var value;
	
	      for (var i = 0; i < length; i++) {
	        value = list[i];
	        if (predicate.call(thisArg, value, i, list)) {
	          return value;
	        }
	      }
	      return undefined;
	    }
	  });
	}
	
	document.addEventListener("DOMContentLoaded", function () {
	  // Disable resizing in Firefox
	  document.execCommand("enableObjectResizing", false, false);
	  // Disable automatic linkifying in IE11
	  document.execCommand("autoUrlDetect", false, false);
	});
	
	/***/ }),
	/* 51 */
	/***/ (function(module, exports) {
	
	/**
	 * This library modifies the diff-patch-match library by Neil Fraser
	 * by removing the patch and match functionality and certain advanced
	 * options in the diff function. The original license is as follows:
	 *
	 * ===
	 *
	 * Diff Match and Patch
	 *
	 * Copyright 2006 Google Inc.
	 * http://code.google.com/p/google-diff-match-patch/
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	
	/**
	 * The data structure representing a diff is an array of tuples:
	 * [[DIFF_DELETE, 'Hello'], [DIFF_INSERT, 'Goodbye'], [DIFF_EQUAL, ' world.']]
	 * which means: delete 'Hello', add 'Goodbye' and keep ' world.'
	 */
	var DIFF_DELETE = -1;
	var DIFF_INSERT = 1;
	var DIFF_EQUAL = 0;
	
	
	/**
	 * Find the differences between two texts.  Simplifies the problem by stripping
	 * any common prefix or suffix off the texts before diffing.
	 * @param {string} text1 Old string to be diffed.
	 * @param {string} text2 New string to be diffed.
	 * @param {Int} cursor_pos Expected edit position in text1 (optional)
	 * @return {Array} Array of diff tuples.
	 */
	function diff_main(text1, text2, cursor_pos) {
	  // Check for equality (speedup).
	  if (text1 == text2) {
	    if (text1) {
	      return [[DIFF_EQUAL, text1]];
	    }
	    return [];
	  }
	
	  // Check cursor_pos within bounds
	  if (cursor_pos < 0 || text1.length < cursor_pos) {
	    cursor_pos = null;
	  }
	
	  // Trim off common prefix (speedup).
	  var commonlength = diff_commonPrefix(text1, text2);
	  var commonprefix = text1.substring(0, commonlength);
	  text1 = text1.substring(commonlength);
	  text2 = text2.substring(commonlength);
	
	  // Trim off common suffix (speedup).
	  commonlength = diff_commonSuffix(text1, text2);
	  var commonsuffix = text1.substring(text1.length - commonlength);
	  text1 = text1.substring(0, text1.length - commonlength);
	  text2 = text2.substring(0, text2.length - commonlength);
	
	  // Compute the diff on the middle block.
	  var diffs = diff_compute_(text1, text2);
	
	  // Restore the prefix and suffix.
	  if (commonprefix) {
	    diffs.unshift([DIFF_EQUAL, commonprefix]);
	  }
	  if (commonsuffix) {
	    diffs.push([DIFF_EQUAL, commonsuffix]);
	  }
	  diff_cleanupMerge(diffs);
	  if (cursor_pos != null) {
	    diffs = fix_cursor(diffs, cursor_pos);
	  }
	  diffs = fix_emoji(diffs);
	  return diffs;
	};
	
	
	/**
	 * Find the differences between two texts.  Assumes that the texts do not
	 * have any common prefix or suffix.
	 * @param {string} text1 Old string to be diffed.
	 * @param {string} text2 New string to be diffed.
	 * @return {Array} Array of diff tuples.
	 */
	function diff_compute_(text1, text2) {
	  var diffs;
	
	  if (!text1) {
	    // Just add some text (speedup).
	    return [[DIFF_INSERT, text2]];
	  }
	
	  if (!text2) {
	    // Just delete some text (speedup).
	    return [[DIFF_DELETE, text1]];
	  }
	
	  var longtext = text1.length > text2.length ? text1 : text2;
	  var shorttext = text1.length > text2.length ? text2 : text1;
	  var i = longtext.indexOf(shorttext);
	  if (i != -1) {
	    // Shorter text is inside the longer text (speedup).
	    diffs = [[DIFF_INSERT, longtext.substring(0, i)],
	             [DIFF_EQUAL, shorttext],
	             [DIFF_INSERT, longtext.substring(i + shorttext.length)]];
	    // Swap insertions for deletions if diff is reversed.
	    if (text1.length > text2.length) {
	      diffs[0][0] = diffs[2][0] = DIFF_DELETE;
	    }
	    return diffs;
	  }
	
	  if (shorttext.length == 1) {
	    // Single character string.
	    // After the previous speedup, the character can't be an equality.
	    return [[DIFF_DELETE, text1], [DIFF_INSERT, text2]];
	  }
	
	  // Check to see if the problem can be split in two.
	  var hm = diff_halfMatch_(text1, text2);
	  if (hm) {
	    // A half-match was found, sort out the return data.
	    var text1_a = hm[0];
	    var text1_b = hm[1];
	    var text2_a = hm[2];
	    var text2_b = hm[3];
	    var mid_common = hm[4];
	    // Send both pairs off for separate processing.
	    var diffs_a = diff_main(text1_a, text2_a);
	    var diffs_b = diff_main(text1_b, text2_b);
	    // Merge the results.
	    return diffs_a.concat([[DIFF_EQUAL, mid_common]], diffs_b);
	  }
	
	  return diff_bisect_(text1, text2);
	};
	
	
	/**
	 * Find the 'middle snake' of a diff, split the problem in two
	 * and return the recursively constructed diff.
	 * See Myers 1986 paper: An O(ND) Difference Algorithm and Its Variations.
	 * @param {string} text1 Old string to be diffed.
	 * @param {string} text2 New string to be diffed.
	 * @return {Array} Array of diff tuples.
	 * @private
	 */
	function diff_bisect_(text1, text2) {
	  // Cache the text lengths to prevent multiple calls.
	  var text1_length = text1.length;
	  var text2_length = text2.length;
	  var max_d = Math.ceil((text1_length + text2_length) / 2);
	  var v_offset = max_d;
	  var v_length = 2 * max_d;
	  var v1 = new Array(v_length);
	  var v2 = new Array(v_length);
	  // Setting all elements to -1 is faster in Chrome & Firefox than mixing
	  // integers and undefined.
	  for (var x = 0; x < v_length; x++) {
	    v1[x] = -1;
	    v2[x] = -1;
	  }
	  v1[v_offset + 1] = 0;
	  v2[v_offset + 1] = 0;
	  var delta = text1_length - text2_length;
	  // If the total number of characters is odd, then the front path will collide
	  // with the reverse path.
	  var front = (delta % 2 != 0);
	  // Offsets for start and end of k loop.
	  // Prevents mapping of space beyond the grid.
	  var k1start = 0;
	  var k1end = 0;
	  var k2start = 0;
	  var k2end = 0;
	  for (var d = 0; d < max_d; d++) {
	    // Walk the front path one step.
	    for (var k1 = -d + k1start; k1 <= d - k1end; k1 += 2) {
	      var k1_offset = v_offset + k1;
	      var x1;
	      if (k1 == -d || (k1 != d && v1[k1_offset - 1] < v1[k1_offset + 1])) {
	        x1 = v1[k1_offset + 1];
	      } else {
	        x1 = v1[k1_offset - 1] + 1;
	      }
	      var y1 = x1 - k1;
	      while (x1 < text1_length && y1 < text2_length &&
	             text1.charAt(x1) == text2.charAt(y1)) {
	        x1++;
	        y1++;
	      }
	      v1[k1_offset] = x1;
	      if (x1 > text1_length) {
	        // Ran off the right of the graph.
	        k1end += 2;
	      } else if (y1 > text2_length) {
	        // Ran off the bottom of the graph.
	        k1start += 2;
	      } else if (front) {
	        var k2_offset = v_offset + delta - k1;
	        if (k2_offset >= 0 && k2_offset < v_length && v2[k2_offset] != -1) {
	          // Mirror x2 onto top-left coordinate system.
	          var x2 = text1_length - v2[k2_offset];
	          if (x1 >= x2) {
	            // Overlap detected.
	            return diff_bisectSplit_(text1, text2, x1, y1);
	          }
	        }
	      }
	    }
	
	    // Walk the reverse path one step.
	    for (var k2 = -d + k2start; k2 <= d - k2end; k2 += 2) {
	      var k2_offset = v_offset + k2;
	      var x2;
	      if (k2 == -d || (k2 != d && v2[k2_offset - 1] < v2[k2_offset + 1])) {
	        x2 = v2[k2_offset + 1];
	      } else {
	        x2 = v2[k2_offset - 1] + 1;
	      }
	      var y2 = x2 - k2;
	      while (x2 < text1_length && y2 < text2_length &&
	             text1.charAt(text1_length - x2 - 1) ==
	             text2.charAt(text2_length - y2 - 1)) {
	        x2++;
	        y2++;
	      }
	      v2[k2_offset] = x2;
	      if (x2 > text1_length) {
	        // Ran off the left of the graph.
	        k2end += 2;
	      } else if (y2 > text2_length) {
	        // Ran off the top of the graph.
	        k2start += 2;
	      } else if (!front) {
	        var k1_offset = v_offset + delta - k2;
	        if (k1_offset >= 0 && k1_offset < v_length && v1[k1_offset] != -1) {
	          var x1 = v1[k1_offset];
	          var y1 = v_offset + x1 - k1_offset;
	          // Mirror x2 onto top-left coordinate system.
	          x2 = text1_length - x2;
	          if (x1 >= x2) {
	            // Overlap detected.
	            return diff_bisectSplit_(text1, text2, x1, y1);
	          }
	        }
	      }
	    }
	  }
	  // Diff took too long and hit the deadline or
	  // number of diffs equals number of characters, no commonality at all.
	  return [[DIFF_DELETE, text1], [DIFF_INSERT, text2]];
	};
	
	
	/**
	 * Given the location of the 'middle snake', split the diff in two parts
	 * and recurse.
	 * @param {string} text1 Old string to be diffed.
	 * @param {string} text2 New string to be diffed.
	 * @param {number} x Index of split point in text1.
	 * @param {number} y Index of split point in text2.
	 * @return {Array} Array of diff tuples.
	 */
	function diff_bisectSplit_(text1, text2, x, y) {
	  var text1a = text1.substring(0, x);
	  var text2a = text2.substring(0, y);
	  var text1b = text1.substring(x);
	  var text2b = text2.substring(y);
	
	  // Compute both diffs serially.
	  var diffs = diff_main(text1a, text2a);
	  var diffsb = diff_main(text1b, text2b);
	
	  return diffs.concat(diffsb);
	};
	
	
	/**
	 * Determine the common prefix of two strings.
	 * @param {string} text1 First string.
	 * @param {string} text2 Second string.
	 * @return {number} The number of characters common to the start of each
	 *     string.
	 */
	function diff_commonPrefix(text1, text2) {
	  // Quick check for common null cases.
	  if (!text1 || !text2 || text1.charAt(0) != text2.charAt(0)) {
	    return 0;
	  }
	  // Binary search.
	  // Performance analysis: http://neil.fraser.name/news/2007/10/09/
	  var pointermin = 0;
	  var pointermax = Math.min(text1.length, text2.length);
	  var pointermid = pointermax;
	  var pointerstart = 0;
	  while (pointermin < pointermid) {
	    if (text1.substring(pointerstart, pointermid) ==
	        text2.substring(pointerstart, pointermid)) {
	      pointermin = pointermid;
	      pointerstart = pointermin;
	    } else {
	      pointermax = pointermid;
	    }
	    pointermid = Math.floor((pointermax - pointermin) / 2 + pointermin);
	  }
	  return pointermid;
	};
	
	
	/**
	 * Determine the common suffix of two strings.
	 * @param {string} text1 First string.
	 * @param {string} text2 Second string.
	 * @return {number} The number of characters common to the end of each string.
	 */
	function diff_commonSuffix(text1, text2) {
	  // Quick check for common null cases.
	  if (!text1 || !text2 ||
	      text1.charAt(text1.length - 1) != text2.charAt(text2.length - 1)) {
	    return 0;
	  }
	  // Binary search.
	  // Performance analysis: http://neil.fraser.name/news/2007/10/09/
	  var pointermin = 0;
	  var pointermax = Math.min(text1.length, text2.length);
	  var pointermid = pointermax;
	  var pointerend = 0;
	  while (pointermin < pointermid) {
	    if (text1.substring(text1.length - pointermid, text1.length - pointerend) ==
	        text2.substring(text2.length - pointermid, text2.length - pointerend)) {
	      pointermin = pointermid;
	      pointerend = pointermin;
	    } else {
	      pointermax = pointermid;
	    }
	    pointermid = Math.floor((pointermax - pointermin) / 2 + pointermin);
	  }
	  return pointermid;
	};
	
	
	/**
	 * Do the two texts share a substring which is at least half the length of the
	 * longer text?
	 * This speedup can produce non-minimal diffs.
	 * @param {string} text1 First string.
	 * @param {string} text2 Second string.
	 * @return {Array.<string>} Five element Array, containing the prefix of
	 *     text1, the suffix of text1, the prefix of text2, the suffix of
	 *     text2 and the common middle.  Or null if there was no match.
	 */
	function diff_halfMatch_(text1, text2) {
	  var longtext = text1.length > text2.length ? text1 : text2;
	  var shorttext = text1.length > text2.length ? text2 : text1;
	  if (longtext.length < 4 || shorttext.length * 2 < longtext.length) {
	    return null;  // Pointless.
	  }
	
	  /**
	   * Does a substring of shorttext exist within longtext such that the substring
	   * is at least half the length of longtext?
	   * Closure, but does not reference any external variables.
	   * @param {string} longtext Longer string.
	   * @param {string} shorttext Shorter string.
	   * @param {number} i Start index of quarter length substring within longtext.
	   * @return {Array.<string>} Five element Array, containing the prefix of
	   *     longtext, the suffix of longtext, the prefix of shorttext, the suffix
	   *     of shorttext and the common middle.  Or null if there was no match.
	   * @private
	   */
	  function diff_halfMatchI_(longtext, shorttext, i) {
	    // Start with a 1/4 length substring at position i as a seed.
	    var seed = longtext.substring(i, i + Math.floor(longtext.length / 4));
	    var j = -1;
	    var best_common = '';
	    var best_longtext_a, best_longtext_b, best_shorttext_a, best_shorttext_b;
	    while ((j = shorttext.indexOf(seed, j + 1)) != -1) {
	      var prefixLength = diff_commonPrefix(longtext.substring(i),
	                                           shorttext.substring(j));
	      var suffixLength = diff_commonSuffix(longtext.substring(0, i),
	                                           shorttext.substring(0, j));
	      if (best_common.length < suffixLength + prefixLength) {
	        best_common = shorttext.substring(j - suffixLength, j) +
	            shorttext.substring(j, j + prefixLength);
	        best_longtext_a = longtext.substring(0, i - suffixLength);
	        best_longtext_b = longtext.substring(i + prefixLength);
	        best_shorttext_a = shorttext.substring(0, j - suffixLength);
	        best_shorttext_b = shorttext.substring(j + prefixLength);
	      }
	    }
	    if (best_common.length * 2 >= longtext.length) {
	      return [best_longtext_a, best_longtext_b,
	              best_shorttext_a, best_shorttext_b, best_common];
	    } else {
	      return null;
	    }
	  }
	
	  // First check if the second quarter is the seed for a half-match.
	  var hm1 = diff_halfMatchI_(longtext, shorttext,
	                             Math.ceil(longtext.length / 4));
	  // Check again based on the third quarter.
	  var hm2 = diff_halfMatchI_(longtext, shorttext,
	                             Math.ceil(longtext.length / 2));
	  var hm;
	  if (!hm1 && !hm2) {
	    return null;
	  } else if (!hm2) {
	    hm = hm1;
	  } else if (!hm1) {
	    hm = hm2;
	  } else {
	    // Both matched.  Select the longest.
	    hm = hm1[4].length > hm2[4].length ? hm1 : hm2;
	  }
	
	  // A half-match was found, sort out the return data.
	  var text1_a, text1_b, text2_a, text2_b;
	  if (text1.length > text2.length) {
	    text1_a = hm[0];
	    text1_b = hm[1];
	    text2_a = hm[2];
	    text2_b = hm[3];
	  } else {
	    text2_a = hm[0];
	    text2_b = hm[1];
	    text1_a = hm[2];
	    text1_b = hm[3];
	  }
	  var mid_common = hm[4];
	  return [text1_a, text1_b, text2_a, text2_b, mid_common];
	};
	
	
	/**
	 * Reorder and merge like edit sections.  Merge equalities.
	 * Any edit section can move as long as it doesn't cross an equality.
	 * @param {Array} diffs Array of diff tuples.
	 */
	function diff_cleanupMerge(diffs) {
	  diffs.push([DIFF_EQUAL, '']);  // Add a dummy entry at the end.
	  var pointer = 0;
	  var count_delete = 0;
	  var count_insert = 0;
	  var text_delete = '';
	  var text_insert = '';
	  var commonlength;
	  while (pointer < diffs.length) {
	    switch (diffs[pointer][0]) {
	      case DIFF_INSERT:
	        count_insert++;
	        text_insert += diffs[pointer][1];
	        pointer++;
	        break;
	      case DIFF_DELETE:
	        count_delete++;
	        text_delete += diffs[pointer][1];
	        pointer++;
	        break;
	      case DIFF_EQUAL:
	        // Upon reaching an equality, check for prior redundancies.
	        if (count_delete + count_insert > 1) {
	          if (count_delete !== 0 && count_insert !== 0) {
	            // Factor out any common prefixies.
	            commonlength = diff_commonPrefix(text_insert, text_delete);
	            if (commonlength !== 0) {
	              if ((pointer - count_delete - count_insert) > 0 &&
	                  diffs[pointer - count_delete - count_insert - 1][0] ==
	                  DIFF_EQUAL) {
	                diffs[pointer - count_delete - count_insert - 1][1] +=
	                    text_insert.substring(0, commonlength);
	              } else {
	                diffs.splice(0, 0, [DIFF_EQUAL,
	                                    text_insert.substring(0, commonlength)]);
	                pointer++;
	              }
	              text_insert = text_insert.substring(commonlength);
	              text_delete = text_delete.substring(commonlength);
	            }
	            // Factor out any common suffixies.
	            commonlength = diff_commonSuffix(text_insert, text_delete);
	            if (commonlength !== 0) {
	              diffs[pointer][1] = text_insert.substring(text_insert.length -
	                  commonlength) + diffs[pointer][1];
	              text_insert = text_insert.substring(0, text_insert.length -
	                  commonlength);
	              text_delete = text_delete.substring(0, text_delete.length -
	                  commonlength);
	            }
	          }
	          // Delete the offending records and add the merged ones.
	          if (count_delete === 0) {
	            diffs.splice(pointer - count_insert,
	                count_delete + count_insert, [DIFF_INSERT, text_insert]);
	          } else if (count_insert === 0) {
	            diffs.splice(pointer - count_delete,
	                count_delete + count_insert, [DIFF_DELETE, text_delete]);
	          } else {
	            diffs.splice(pointer - count_delete - count_insert,
	                count_delete + count_insert, [DIFF_DELETE, text_delete],
	                [DIFF_INSERT, text_insert]);
	          }
	          pointer = pointer - count_delete - count_insert +
	                    (count_delete ? 1 : 0) + (count_insert ? 1 : 0) + 1;
	        } else if (pointer !== 0 && diffs[pointer - 1][0] == DIFF_EQUAL) {
	          // Merge this equality with the previous one.
	          diffs[pointer - 1][1] += diffs[pointer][1];
	          diffs.splice(pointer, 1);
	        } else {
	          pointer++;
	        }
	        count_insert = 0;
	        count_delete = 0;
	        text_delete = '';
	        text_insert = '';
	        break;
	    }
	  }
	  if (diffs[diffs.length - 1][1] === '') {
	    diffs.pop();  // Remove the dummy entry at the end.
	  }
	
	  // Second pass: look for single edits surrounded on both sides by equalities
	  // which can be shifted sideways to eliminate an equality.
	  // e.g: A<ins>BA</ins>C -> <ins>AB</ins>AC
	  var changes = false;
	  pointer = 1;
	  // Intentionally ignore the first and last element (don't need checking).
	  while (pointer < diffs.length - 1) {
	    if (diffs[pointer - 1][0] == DIFF_EQUAL &&
	        diffs[pointer + 1][0] == DIFF_EQUAL) {
	      // This is a single edit surrounded by equalities.
	      if (diffs[pointer][1].substring(diffs[pointer][1].length -
	          diffs[pointer - 1][1].length) == diffs[pointer - 1][1]) {
	        // Shift the edit over the previous equality.
	        diffs[pointer][1] = diffs[pointer - 1][1] +
	            diffs[pointer][1].substring(0, diffs[pointer][1].length -
	                                        diffs[pointer - 1][1].length);
	        diffs[pointer + 1][1] = diffs[pointer - 1][1] + diffs[pointer + 1][1];
	        diffs.splice(pointer - 1, 1);
	        changes = true;
	      } else if (diffs[pointer][1].substring(0, diffs[pointer + 1][1].length) ==
	          diffs[pointer + 1][1]) {
	        // Shift the edit over the next equality.
	        diffs[pointer - 1][1] += diffs[pointer + 1][1];
	        diffs[pointer][1] =
	            diffs[pointer][1].substring(diffs[pointer + 1][1].length) +
	            diffs[pointer + 1][1];
	        diffs.splice(pointer + 1, 1);
	        changes = true;
	      }
	    }
	    pointer++;
	  }
	  // If shifts were made, the diff needs reordering and another shift sweep.
	  if (changes) {
	    diff_cleanupMerge(diffs);
	  }
	};
	
	
	var diff = diff_main;
	diff.INSERT = DIFF_INSERT;
	diff.DELETE = DIFF_DELETE;
	diff.EQUAL = DIFF_EQUAL;
	
	module.exports = diff;
	
	/*
	 * Modify a diff such that the cursor position points to the start of a change:
	 * E.g.
	 *   cursor_normalize_diff([[DIFF_EQUAL, 'abc']], 1)
	 *     => [1, [[DIFF_EQUAL, 'a'], [DIFF_EQUAL, 'bc']]]
	 *   cursor_normalize_diff([[DIFF_INSERT, 'new'], [DIFF_DELETE, 'xyz']], 2)
	 *     => [2, [[DIFF_INSERT, 'new'], [DIFF_DELETE, 'xy'], [DIFF_DELETE, 'z']]]
	 *
	 * @param {Array} diffs Array of diff tuples
	 * @param {Int} cursor_pos Suggested edit position. Must not be out of bounds!
	 * @return {Array} A tuple [cursor location in the modified diff, modified diff]
	 */
	function cursor_normalize_diff (diffs, cursor_pos) {
	  if (cursor_pos === 0) {
	    return [DIFF_EQUAL, diffs];
	  }
	  for (var current_pos = 0, i = 0; i < diffs.length; i++) {
	    var d = diffs[i];
	    if (d[0] === DIFF_DELETE || d[0] === DIFF_EQUAL) {
	      var next_pos = current_pos + d[1].length;
	      if (cursor_pos === next_pos) {
	        return [i + 1, diffs];
	      } else if (cursor_pos < next_pos) {
	        // copy to prevent side effects
	        diffs = diffs.slice();
	        // split d into two diff changes
	        var split_pos = cursor_pos - current_pos;
	        var d_left = [d[0], d[1].slice(0, split_pos)];
	        var d_right = [d[0], d[1].slice(split_pos)];
	        diffs.splice(i, 1, d_left, d_right);
	        return [i + 1, diffs];
	      } else {
	        current_pos = next_pos;
	      }
	    }
	  }
	  throw new Error('cursor_pos is out of bounds!')
	}
	
	/*
	 * Modify a diff such that the edit position is "shifted" to the proposed edit location (cursor_position).
	 *
	 * Case 1)
	 *   Check if a naive shift is possible:
	 *     [0, X], [ 1, Y] -> [ 1, Y], [0, X]    (if X + Y === Y + X)
	 *     [0, X], [-1, Y] -> [-1, Y], [0, X]    (if X + Y === Y + X) - holds same result
	 * Case 2)
	 *   Check if the following shifts are possible:
	 *     [0, 'pre'], [ 1, 'prefix'] -> [ 1, 'pre'], [0, 'pre'], [ 1, 'fix']
	 *     [0, 'pre'], [-1, 'prefix'] -> [-1, 'pre'], [0, 'pre'], [-1, 'fix']
	 *         ^            ^
	 *         d          d_next
	 *
	 * @param {Array} diffs Array of diff tuples
	 * @param {Int} cursor_pos Suggested edit position. Must not be out of bounds!
	 * @return {Array} Array of diff tuples
	 */
	function fix_cursor (diffs, cursor_pos) {
	  var norm = cursor_normalize_diff(diffs, cursor_pos);
	  var ndiffs = norm[1];
	  var cursor_pointer = norm[0];
	  var d = ndiffs[cursor_pointer];
	  var d_next = ndiffs[cursor_pointer + 1];
	
	  if (d == null) {
	    // Text was deleted from end of original string,
	    // cursor is now out of bounds in new string
	    return diffs;
	  } else if (d[0] !== DIFF_EQUAL) {
	    // A modification happened at the cursor location.
	    // This is the expected outcome, so we can return the original diff.
	    return diffs;
	  } else {
	    if (d_next != null && d[1] + d_next[1] === d_next[1] + d[1]) {
	      // Case 1)
	      // It is possible to perform a naive shift
	      ndiffs.splice(cursor_pointer, 2, d_next, d)
	      return merge_tuples(ndiffs, cursor_pointer, 2)
	    } else if (d_next != null && d_next[1].indexOf(d[1]) === 0) {
	      // Case 2)
	      // d[1] is a prefix of d_next[1]
	      // We can assume that d_next[0] !== 0, since d[0] === 0
	      // Shift edit locations..
	      ndiffs.splice(cursor_pointer, 2, [d_next[0], d[1]], [0, d[1]]);
	      var suffix = d_next[1].slice(d[1].length);
	      if (suffix.length > 0) {
	        ndiffs.splice(cursor_pointer + 2, 0, [d_next[0], suffix]);
	      }
	      return merge_tuples(ndiffs, cursor_pointer, 3)
	    } else {
	      // Not possible to perform any modification
	      return diffs;
	    }
	  }
	}
	
	/*
	 * Check diff did not split surrogate pairs.
	 * Ex. [0, '\uD83D'], [-1, '\uDC36'], [1, '\uDC2F'] -> [-1, '\uD83D\uDC36'], [1, '\uD83D\uDC2F']
	 *     '\uD83D\uDC36' === '🐶', '\uD83D\uDC2F' === '🐯'
	 *
	 * @param {Array} diffs Array of diff tuples
	 * @return {Array} Array of diff tuples
	 */
	function fix_emoji (diffs) {
	  var compact = false;
	  var starts_with_pair_end = function(str) {
	    return str.charCodeAt(0) >= 0xDC00 && str.charCodeAt(0) <= 0xDFFF;
	  }
	  var ends_with_pair_start = function(str) {
	    return str.charCodeAt(str.length-1) >= 0xD800 && str.charCodeAt(str.length-1) <= 0xDBFF;
	  }
	  for (var i = 2; i < diffs.length; i += 1) {
	    if (diffs[i-2][0] === DIFF_EQUAL && ends_with_pair_start(diffs[i-2][1]) &&
	        diffs[i-1][0] === DIFF_DELETE && starts_with_pair_end(diffs[i-1][1]) &&
	        diffs[i][0] === DIFF_INSERT && starts_with_pair_end(diffs[i][1])) {
	      compact = true;
	
	      diffs[i-1][1] = diffs[i-2][1].slice(-1) + diffs[i-1][1];
	      diffs[i][1] = diffs[i-2][1].slice(-1) + diffs[i][1];
	
	      diffs[i-2][1] = diffs[i-2][1].slice(0, -1);
	    }
	  }
	  if (!compact) {
	    return diffs;
	  }
	  var fixed_diffs = [];
	  for (var i = 0; i < diffs.length; i += 1) {
	    if (diffs[i][1].length > 0) {
	      fixed_diffs.push(diffs[i]);
	    }
	  }
	  return fixed_diffs;
	}
	
	/*
	 * Try to merge tuples with their neigbors in a given range.
	 * E.g. [0, 'a'], [0, 'b'] -> [0, 'ab']
	 *
	 * @param {Array} diffs Array of diff tuples.
	 * @param {Int} start Position of the first element to merge (diffs[start] is also merged with diffs[start - 1]).
	 * @param {Int} length Number of consecutive elements to check.
	 * @return {Array} Array of merged diff tuples.
	 */
	function merge_tuples (diffs, start, length) {
	  // Check from (start-1) to (start+length).
	  for (var i = start + length - 1; i >= 0 && i >= start - 1; i--) {
	    if (i + 1 < diffs.length) {
	      var left_d = diffs[i];
	      var right_d = diffs[i+1];
	      if (left_d[0] === right_d[1]) {
	        diffs.splice(i, 2, [left_d[0], left_d[1] + right_d[1]]);
	      }
	    }
	  }
	  return diffs;
	}
	
	
	/***/ }),
	/* 52 */
	/***/ (function(module, exports) {
	
	exports = module.exports = typeof Object.keys === 'function'
	  ? Object.keys : shim;
	
	exports.shim = shim;
	function shim (obj) {
	  var keys = [];
	  for (var key in obj) keys.push(key);
	  return keys;
	}
	
	
	/***/ }),
	/* 53 */
	/***/ (function(module, exports) {
	
	var supportsArgumentsClass = (function(){
	  return Object.prototype.toString.call(arguments)
	})() == '[object Arguments]';
	
	exports = module.exports = supportsArgumentsClass ? supported : unsupported;
	
	exports.supported = supported;
	function supported(object) {
	  return Object.prototype.toString.call(object) == '[object Arguments]';
	};
	
	exports.unsupported = unsupported;
	function unsupported(object){
	  return object &&
	    typeof object == 'object' &&
	    typeof object.length == 'number' &&
	    Object.prototype.hasOwnProperty.call(object, 'callee') &&
	    !Object.prototype.propertyIsEnumerable.call(object, 'callee') ||
	    false;
	};
	
	
	/***/ }),
	/* 54 */
	/***/ (function(module, exports) {
	
	'use strict';
	
	var has = Object.prototype.hasOwnProperty
	  , prefix = '~';
	
	/**
	 * Constructor to create a storage for our `EE` objects.
	 * An `Events` instance is a plain object whose properties are event names.
	 *
	 * @constructor
	 * @api private
	 */
	function Events() {}
	
	//
	// We try to not inherit from `Object.prototype`. In some engines creating an
	// instance in this way is faster than calling `Object.create(null)` directly.
	// If `Object.create(null)` is not supported we prefix the event names with a
	// character to make sure that the built-in object properties are not
	// overridden or used as an attack vector.
	//
	if (Object.create) {
	  Events.prototype = Object.create(null);
	
	  //
	  // This hack is needed because the `__proto__` property is still inherited in
	  // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
	  //
	  if (!new Events().__proto__) prefix = false;
	}
	
	/**
	 * Representation of a single event listener.
	 *
	 * @param {Function} fn The listener function.
	 * @param {Mixed} context The context to invoke the listener with.
	 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
	 * @constructor
	 * @api private
	 */
	function EE(fn, context, once) {
	  this.fn = fn;
	  this.context = context;
	  this.once = once || false;
	}
	
	/**
	 * Minimal `EventEmitter` interface that is molded against the Node.js
	 * `EventEmitter` interface.
	 *
	 * @constructor
	 * @api public
	 */
	function EventEmitter() {
	  this._events = new Events();
	  this._eventsCount = 0;
	}
	
	/**
	 * Return an array listing the events for which the emitter has registered
	 * listeners.
	 *
	 * @returns {Array}
	 * @api public
	 */
	EventEmitter.prototype.eventNames = function eventNames() {
	  var names = []
	    , events
	    , name;
	
	  if (this._eventsCount === 0) return names;
	
	  for (name in (events = this._events)) {
	    if (has.call(events, name)) names.push(prefix ? name.slice(1) : name);
	  }
	
	  if (Object.getOwnPropertySymbols) {
	    return names.concat(Object.getOwnPropertySymbols(events));
	  }
	
	  return names;
	};
	
	/**
	 * Return the listeners registered for a given event.
	 *
	 * @param {String|Symbol} event The event name.
	 * @param {Boolean} exists Only check if there are listeners.
	 * @returns {Array|Boolean}
	 * @api public
	 */
	EventEmitter.prototype.listeners = function listeners(event, exists) {
	  var evt = prefix ? prefix + event : event
	    , available = this._events[evt];
	
	  if (exists) return !!available;
	  if (!available) return [];
	  if (available.fn) return [available.fn];
	
	  for (var i = 0, l = available.length, ee = new Array(l); i < l; i++) {
	    ee[i] = available[i].fn;
	  }
	
	  return ee;
	};
	
	/**
	 * Calls each of the listeners registered for a given event.
	 *
	 * @param {String|Symbol} event The event name.
	 * @returns {Boolean} `true` if the event had listeners, else `false`.
	 * @api public
	 */
	EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
	  var evt = prefix ? prefix + event : event;
	
	  if (!this._events[evt]) return false;
	
	  var listeners = this._events[evt]
	    , len = arguments.length
	    , args
	    , i;
	
	  if (listeners.fn) {
	    if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);
	
	    switch (len) {
	      case 1: return listeners.fn.call(listeners.context), true;
	      case 2: return listeners.fn.call(listeners.context, a1), true;
	      case 3: return listeners.fn.call(listeners.context, a1, a2), true;
	      case 4: return listeners.fn.call(listeners.context, a1, a2, a3), true;
	      case 5: return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
	      case 6: return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
	    }
	
	    for (i = 1, args = new Array(len -1); i < len; i++) {
	      args[i - 1] = arguments[i];
	    }
	
	    listeners.fn.apply(listeners.context, args);
	  } else {
	    var length = listeners.length
	      , j;
	
	    for (i = 0; i < length; i++) {
	      if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);
	
	      switch (len) {
	        case 1: listeners[i].fn.call(listeners[i].context); break;
	        case 2: listeners[i].fn.call(listeners[i].context, a1); break;
	        case 3: listeners[i].fn.call(listeners[i].context, a1, a2); break;
	        case 4: listeners[i].fn.call(listeners[i].context, a1, a2, a3); break;
	        default:
	          if (!args) for (j = 1, args = new Array(len -1); j < len; j++) {
	            args[j - 1] = arguments[j];
	          }
	
	          listeners[i].fn.apply(listeners[i].context, args);
	      }
	    }
	  }
	
	  return true;
	};
	
	/**
	 * Add a listener for a given event.
	 *
	 * @param {String|Symbol} event The event name.
	 * @param {Function} fn The listener function.
	 * @param {Mixed} [context=this] The context to invoke the listener with.
	 * @returns {EventEmitter} `this`.
	 * @api public
	 */
	EventEmitter.prototype.on = function on(event, fn, context) {
	  var listener = new EE(fn, context || this)
	    , evt = prefix ? prefix + event : event;
	
	  if (!this._events[evt]) this._events[evt] = listener, this._eventsCount++;
	  else if (!this._events[evt].fn) this._events[evt].push(listener);
	  else this._events[evt] = [this._events[evt], listener];
	
	  return this;
	};
	
	/**
	 * Add a one-time listener for a given event.
	 *
	 * @param {String|Symbol} event The event name.
	 * @param {Function} fn The listener function.
	 * @param {Mixed} [context=this] The context to invoke the listener with.
	 * @returns {EventEmitter} `this`.
	 * @api public
	 */
	EventEmitter.prototype.once = function once(event, fn, context) {
	  var listener = new EE(fn, context || this, true)
	    , evt = prefix ? prefix + event : event;
	
	  if (!this._events[evt]) this._events[evt] = listener, this._eventsCount++;
	  else if (!this._events[evt].fn) this._events[evt].push(listener);
	  else this._events[evt] = [this._events[evt], listener];
	
	  return this;
	};
	
	/**
	 * Remove the listeners of a given event.
	 *
	 * @param {String|Symbol} event The event name.
	 * @param {Function} fn Only remove the listeners that match this function.
	 * @param {Mixed} context Only remove the listeners that have this context.
	 * @param {Boolean} once Only remove one-time listeners.
	 * @returns {EventEmitter} `this`.
	 * @api public
	 */
	EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
	  var evt = prefix ? prefix + event : event;
	
	  if (!this._events[evt]) return this;
	  if (!fn) {
	    if (--this._eventsCount === 0) this._events = new Events();
	    else delete this._events[evt];
	    return this;
	  }
	
	  var listeners = this._events[evt];
	
	  if (listeners.fn) {
	    if (
	         listeners.fn === fn
	      && (!once || listeners.once)
	      && (!context || listeners.context === context)
	    ) {
	      if (--this._eventsCount === 0) this._events = new Events();
	      else delete this._events[evt];
	    }
	  } else {
	    for (var i = 0, events = [], length = listeners.length; i < length; i++) {
	      if (
	           listeners[i].fn !== fn
	        || (once && !listeners[i].once)
	        || (context && listeners[i].context !== context)
	      ) {
	        events.push(listeners[i]);
	      }
	    }
	
	    //
	    // Reset the array, or remove it completely if we have no more listeners.
	    //
	    if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
	    else if (--this._eventsCount === 0) this._events = new Events();
	    else delete this._events[evt];
	  }
	
	  return this;
	};
	
	/**
	 * Remove all listeners, or those of the specified event.
	 *
	 * @param {String|Symbol} [event] The event name.
	 * @returns {EventEmitter} `this`.
	 * @api public
	 */
	EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
	  var evt;
	
	  if (event) {
	    evt = prefix ? prefix + event : event;
	    if (this._events[evt]) {
	      if (--this._eventsCount === 0) this._events = new Events();
	      else delete this._events[evt];
	    }
	  } else {
	    this._events = new Events();
	    this._eventsCount = 0;
	  }
	
	  return this;
	};
	
	//
	// Alias methods names because people roll like that.
	//
	EventEmitter.prototype.off = EventEmitter.prototype.removeListener;
	EventEmitter.prototype.addListener = EventEmitter.prototype.on;
	
	//
	// This function doesn't apply anymore.
	//
	EventEmitter.prototype.setMaxListeners = function setMaxListeners() {
	  return this;
	};
	
	//
	// Expose the prefix.
	//
	EventEmitter.prefixed = prefix;
	
	//
	// Allow `EventEmitter` to be imported as module namespace.
	//
	EventEmitter.EventEmitter = EventEmitter;
	
	//
	// Expose the module.
	//
	if ('undefined' !== typeof module) {
	  module.exports = EventEmitter;
	}
	
	
	/***/ }),
	/* 55 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.matchText = exports.matchSpacing = exports.matchNewline = exports.matchBlot = exports.matchAttributor = exports.default = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _extend2 = __webpack_require__(3);
	
	var _extend3 = _interopRequireDefault(_extend2);
	
	var _quillDelta = __webpack_require__(2);
	
	var _quillDelta2 = _interopRequireDefault(_quillDelta);
	
	var _parchment = __webpack_require__(0);
	
	var _parchment2 = _interopRequireDefault(_parchment);
	
	var _quill = __webpack_require__(5);
	
	var _quill2 = _interopRequireDefault(_quill);
	
	var _logger = __webpack_require__(10);
	
	var _logger2 = _interopRequireDefault(_logger);
	
	var _module = __webpack_require__(9);
	
	var _module2 = _interopRequireDefault(_module);
	
	var _align = __webpack_require__(36);
	
	var _background = __webpack_require__(37);
	
	var _code = __webpack_require__(13);
	
	var _code2 = _interopRequireDefault(_code);
	
	var _color = __webpack_require__(26);
	
	var _direction = __webpack_require__(38);
	
	var _font = __webpack_require__(39);
	
	var _size = __webpack_require__(40);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var debug = (0, _logger2.default)('quill:clipboard');
	
	var DOM_KEY = '__ql-matcher';
	
	var CLIPBOARD_CONFIG = [[Node.TEXT_NODE, matchText], [Node.TEXT_NODE, matchNewline], ['br', matchBreak], [Node.ELEMENT_NODE, matchNewline], [Node.ELEMENT_NODE, matchBlot], [Node.ELEMENT_NODE, matchSpacing], [Node.ELEMENT_NODE, matchAttributor], [Node.ELEMENT_NODE, matchStyles], ['li', matchIndent], ['b', matchAlias.bind(matchAlias, 'bold')], ['i', matchAlias.bind(matchAlias, 'italic')], ['style', matchIgnore]];
	
	var ATTRIBUTE_ATTRIBUTORS = [_align.AlignAttribute, _direction.DirectionAttribute].reduce(function (memo, attr) {
	  memo[attr.keyName] = attr;
	  return memo;
	}, {});
	
	var STYLE_ATTRIBUTORS = [_align.AlignStyle, _background.BackgroundStyle, _color.ColorStyle, _direction.DirectionStyle, _font.FontStyle, _size.SizeStyle].reduce(function (memo, attr) {
	  memo[attr.keyName] = attr;
	  return memo;
	}, {});
	
	var Clipboard = function (_Module) {
	  _inherits(Clipboard, _Module);
	
	  function Clipboard(quill, options) {
	    _classCallCheck(this, Clipboard);
	
	    var _this = _possibleConstructorReturn(this, (Clipboard.__proto__ || Object.getPrototypeOf(Clipboard)).call(this, quill, options));
	
	    _this.quill.root.addEventListener('paste', _this.onPaste.bind(_this));
	    _this.container = _this.quill.addContainer('ql-clipboard');
	    _this.container.setAttribute('contenteditable', true);
	    _this.container.setAttribute('tabindex', -1);
	    _this.matchers = [];
	    CLIPBOARD_CONFIG.concat(_this.options.matchers).forEach(function (_ref) {
	      var _ref2 = _slicedToArray(_ref, 2),
	          selector = _ref2[0],
	          matcher = _ref2[1];
	
	      if (!options.matchVisual && matcher === matchSpacing) return;
	      _this.addMatcher(selector, matcher);
	    });
	    return _this;
	  }
	
	  _createClass(Clipboard, [{
	    key: 'addMatcher',
	    value: function addMatcher(selector, matcher) {
	      this.matchers.push([selector, matcher]);
	    }
	  }, {
	    key: 'convert',
	    value: function convert(html) {
	      if (typeof html === 'string') {
	        this.container.innerHTML = html.replace(/\>\r?\n +\</g, '><'); // Remove spaces between tags
	        return this.convert();
	      }
	      var formats = this.quill.getFormat(this.quill.selection.savedRange.index);
	      if (formats[_code2.default.blotName]) {
	        var text = this.container.innerText;
	        this.container.innerHTML = '';
	        return new _quillDelta2.default().insert(text, _defineProperty({}, _code2.default.blotName, formats[_code2.default.blotName]));
	      }
	
	      var _prepareMatching = this.prepareMatching(),
	          _prepareMatching2 = _slicedToArray(_prepareMatching, 2),
	          elementMatchers = _prepareMatching2[0],
	          textMatchers = _prepareMatching2[1];
	
	      var delta = traverse(this.container, elementMatchers, textMatchers);
	      // Remove trailing newline
	      if (deltaEndsWith(delta, '\n') && delta.ops[delta.ops.length - 1].attributes == null) {
	        delta = delta.compose(new _quillDelta2.default().retain(delta.length() - 1).delete(1));
	      }
	      debug.log('convert', this.container.innerHTML, delta);
	      this.container.innerHTML = '';
	      return delta;
	    }
	  }, {
	    key: 'dangerouslyPasteHTML',
	    value: function dangerouslyPasteHTML(index, html) {
	      var source = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _quill2.default.sources.API;
	
	      if (typeof index === 'string') {
	        this.quill.setContents(this.convert(index), html);
	        this.quill.setSelection(0, _quill2.default.sources.SILENT);
	      } else {
	        var paste = this.convert(html);
	        this.quill.updateContents(new _quillDelta2.default().retain(index).concat(paste), source);
	        this.quill.setSelection(index + paste.length(), _quill2.default.sources.SILENT);
	      }
	    }
	  }, {
	    key: 'onPaste',
	    value: function onPaste(e) {
	      var _this2 = this;
	
	      if (e.defaultPrevented || !this.quill.isEnabled()) return;
	      var range = this.quill.getSelection();
	      var delta = new _quillDelta2.default().retain(range.index);
	      var scrollTop = this.quill.scrollingContainer.scrollTop;
	      this.container.focus();
	      this.quill.selection.update(_quill2.default.sources.SILENT);
	      setTimeout(function () {
	        delta = delta.concat(_this2.convert()).delete(range.length);
	        _this2.quill.updateContents(delta, _quill2.default.sources.USER);
	        // range.length contributes to delta.length()
	        _this2.quill.setSelection(delta.length() - range.length, _quill2.default.sources.SILENT);
	        _this2.quill.scrollingContainer.scrollTop = scrollTop;
	        _this2.quill.focus();
	      }, 1);
	    }
	  }, {
	    key: 'prepareMatching',
	    value: function prepareMatching() {
	      var _this3 = this;
	
	      var elementMatchers = [],
	          textMatchers = [];
	      this.matchers.forEach(function (pair) {
	        var _pair = _slicedToArray(pair, 2),
	            selector = _pair[0],
	            matcher = _pair[1];
	
	        switch (selector) {
	          case Node.TEXT_NODE:
	            textMatchers.push(matcher);
	            break;
	          case Node.ELEMENT_NODE:
	            elementMatchers.push(matcher);
	            break;
	          default:
	            [].forEach.call(_this3.container.querySelectorAll(selector), function (node) {
	              // TODO use weakmap
	              node[DOM_KEY] = node[DOM_KEY] || [];
	              node[DOM_KEY].push(matcher);
	            });
	            break;
	        }
	      });
	      return [elementMatchers, textMatchers];
	    }
	  }]);
	
	  return Clipboard;
	}(_module2.default);
	
	Clipboard.DEFAULTS = {
	  matchers: [],
	  matchVisual: true
	};
	
	function applyFormat(delta, format, value) {
	  if ((typeof format === 'undefined' ? 'undefined' : _typeof(format)) === 'object') {
	    return Object.keys(format).reduce(function (delta, key) {
	      return applyFormat(delta, key, format[key]);
	    }, delta);
	  } else {
	    return delta.reduce(function (delta, op) {
	      if (op.attributes && op.attributes[format]) {
	        return delta.push(op);
	      } else {
	        return delta.insert(op.insert, (0, _extend3.default)({}, _defineProperty({}, format, value), op.attributes));
	      }
	    }, new _quillDelta2.default());
	  }
	}
	
	function computeStyle(node) {
	  if (node.nodeType !== Node.ELEMENT_NODE) return {};
	  var DOM_KEY = '__ql-computed-style';
	  return node[DOM_KEY] || (node[DOM_KEY] = window.getComputedStyle(node));
	}
	
	function deltaEndsWith(delta, text) {
	  var endText = "";
	  for (var i = delta.ops.length - 1; i >= 0 && endText.length < text.length; --i) {
	    var op = delta.ops[i];
	    if (typeof op.insert !== 'string') break;
	    endText = op.insert + endText;
	  }
	  return endText.slice(-1 * text.length) === text;
	}
	
	function isLine(node) {
	  if (node.childNodes.length === 0) return false; // Exclude embed blocks
	  var style = computeStyle(node);
	  return ['block', 'list-item'].indexOf(style.display) > -1;
	}
	
	function traverse(node, elementMatchers, textMatchers) {
	  // Post-order
	  if (node.nodeType === node.TEXT_NODE) {
	    return textMatchers.reduce(function (delta, matcher) {
	      return matcher(node, delta);
	    }, new _quillDelta2.default());
	  } else if (node.nodeType === node.ELEMENT_NODE) {
	    return [].reduce.call(node.childNodes || [], function (delta, childNode) {
	      var childrenDelta = traverse(childNode, elementMatchers, textMatchers);
	      if (childNode.nodeType === node.ELEMENT_NODE) {
	        childrenDelta = elementMatchers.reduce(function (childrenDelta, matcher) {
	          return matcher(childNode, childrenDelta);
	        }, childrenDelta);
	        childrenDelta = (childNode[DOM_KEY] || []).reduce(function (childrenDelta, matcher) {
	          return matcher(childNode, childrenDelta);
	        }, childrenDelta);
	      }
	      return delta.concat(childrenDelta);
	    }, new _quillDelta2.default());
	  } else {
	    return new _quillDelta2.default();
	  }
	}
	
	function matchAlias(format, node, delta) {
	  return applyFormat(delta, format, true);
	}
	
	function matchAttributor(node, delta) {
	  var attributes = _parchment2.default.Attributor.Attribute.keys(node);
	  var classes = _parchment2.default.Attributor.Class.keys(node);
	  var styles = _parchment2.default.Attributor.Style.keys(node);
	  var formats = {};
	  attributes.concat(classes).concat(styles).forEach(function (name) {
	    var attr = _parchment2.default.query(name, _parchment2.default.Scope.ATTRIBUTE);
	    if (attr != null) {
	      formats[attr.attrName] = attr.value(node);
	      if (formats[attr.attrName]) return;
	    }
	    attr = ATTRIBUTE_ATTRIBUTORS[name];
	    if (attr != null && (attr.attrName === name || attr.keyName === name)) {
	      formats[attr.attrName] = attr.value(node) || undefined;
	    }
	    attr = STYLE_ATTRIBUTORS[name];
	    if (attr != null && (attr.attrName === name || attr.keyName === name)) {
	      attr = STYLE_ATTRIBUTORS[name];
	      formats[attr.attrName] = attr.value(node) || undefined;
	    }
	  });
	  if (Object.keys(formats).length > 0) {
	    delta = applyFormat(delta, formats);
	  }
	  return delta;
	}
	
	function matchBlot(node, delta) {
	  var match = _parchment2.default.query(node);
	  if (match == null) return delta;
	  if (match.prototype instanceof _parchment2.default.Embed) {
	    var embed = {};
	    var value = match.value(node);
	    if (value != null) {
	      embed[match.blotName] = value;
	      delta = new _quillDelta2.default().insert(embed, match.formats(node));
	    }
	  } else if (typeof match.formats === 'function') {
	    delta = applyFormat(delta, match.blotName, match.formats(node));
	  }
	  return delta;
	}
	
	function matchBreak(node, delta) {
	  if (!deltaEndsWith(delta, '\n')) {
	    delta.insert('\n');
	  }
	  return delta;
	}
	
	function matchIgnore() {
	  return new _quillDelta2.default();
	}
	
	function matchIndent(node, delta) {
	  var match = _parchment2.default.query(node);
	  if (match == null || match.blotName !== 'list-item' || !deltaEndsWith(delta, '\n')) {
	    return delta;
	  }
	  var indent = -1,
	      parent = node.parentNode;
	  while (!parent.classList.contains('ql-clipboard')) {
	    if ((_parchment2.default.query(parent) || {}).blotName === 'list') {
	      indent += 1;
	    }
	    parent = parent.parentNode;
	  }
	  if (indent <= 0) return delta;
	  return delta.compose(new _quillDelta2.default().retain(delta.length() - 1).retain(1, { indent: indent }));
	}
	
	function matchNewline(node, delta) {
	  if (!deltaEndsWith(delta, '\n')) {
	    if (isLine(node) || delta.length() > 0 && node.nextSibling && isLine(node.nextSibling)) {
	      delta.insert('\n');
	    }
	  }
	  return delta;
	}
	
	function matchSpacing(node, delta) {
	  if (isLine(node) && node.nextElementSibling != null && !deltaEndsWith(delta, '\n\n')) {
	    var nodeHeight = node.offsetHeight + parseFloat(computeStyle(node).marginTop) + parseFloat(computeStyle(node).marginBottom);
	    if (node.nextElementSibling.offsetTop > node.offsetTop + nodeHeight * 1.5) {
	      delta.insert('\n');
	    }
	  }
	  return delta;
	}
	
	function matchStyles(node, delta) {
	  var formats = {};
	  var style = node.style || {};
	  if (style.fontStyle && computeStyle(node).fontStyle === 'italic') {
	    formats.italic = true;
	  }
	  if (style.fontWeight && (computeStyle(node).fontWeight.startsWith('bold') || parseInt(computeStyle(node).fontWeight) >= 700)) {
	    formats.bold = true;
	  }
	  if (Object.keys(formats).length > 0) {
	    delta = applyFormat(delta, formats);
	  }
	  if (parseFloat(style.textIndent || 0) > 0) {
	    // Could be 0.5in
	    delta = new _quillDelta2.default().insert('\t').concat(delta);
	  }
	  return delta;
	}
	
	function matchText(node, delta) {
	  var text = node.data;
	  // Word represents empty line with <o:p>&nbsp;</o:p>
	  if (node.parentNode.tagName === 'O:P') {
	    return delta.insert(text.trim());
	  }
	  if (text.trim().length === 0 && node.parentNode.classList.contains('ql-clipboard')) {
	    return delta;
	  }
	  if (!computeStyle(node.parentNode).whiteSpace.startsWith('pre')) {
	    // eslint-disable-next-line func-style
	    var replacer = function replacer(collapse, match) {
	      match = match.replace(/[^\u00a0]/g, ''); // \u00a0 is nbsp;
	      return match.length < 1 && collapse ? ' ' : match;
	    };
	    text = text.replace(/\r\n/g, ' ').replace(/\n/g, ' ');
	    text = text.replace(/\s\s+/g, replacer.bind(replacer, true)); // collapse whitespace
	    if (node.previousSibling == null && isLine(node.parentNode) || node.previousSibling != null && isLine(node.previousSibling)) {
	      text = text.replace(/^\s+/, replacer.bind(replacer, false));
	    }
	    if (node.nextSibling == null && isLine(node.parentNode) || node.nextSibling != null && isLine(node.nextSibling)) {
	      text = text.replace(/\s+$/, replacer.bind(replacer, false));
	    }
	  }
	  return delta.insert(text);
	}
	
	exports.default = Clipboard;
	exports.matchAttributor = matchAttributor;
	exports.matchBlot = matchBlot;
	exports.matchNewline = matchNewline;
	exports.matchSpacing = matchSpacing;
	exports.matchText = matchText;
	
	/***/ }),
	/* 56 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _inline = __webpack_require__(6);
	
	var _inline2 = _interopRequireDefault(_inline);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Bold = function (_Inline) {
	  _inherits(Bold, _Inline);
	
	  function Bold() {
	    _classCallCheck(this, Bold);
	
	    return _possibleConstructorReturn(this, (Bold.__proto__ || Object.getPrototypeOf(Bold)).apply(this, arguments));
	  }
	
	  _createClass(Bold, [{
	    key: 'optimize',
	    value: function optimize(context) {
	      _get(Bold.prototype.__proto__ || Object.getPrototypeOf(Bold.prototype), 'optimize', this).call(this, context);
	      if (this.domNode.tagName !== this.statics.tagName[0]) {
	        this.replaceWith(this.statics.blotName);
	      }
	    }
	  }], [{
	    key: 'create',
	    value: function create() {
	      return _get(Bold.__proto__ || Object.getPrototypeOf(Bold), 'create', this).call(this);
	    }
	  }, {
	    key: 'formats',
	    value: function formats() {
	      return true;
	    }
	  }]);
	
	  return Bold;
	}(_inline2.default);
	
	Bold.blotName = 'bold';
	Bold.tagName = ['STRONG', 'B'];
	
	exports.default = Bold;
	
	/***/ }),
	/* 57 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.addControls = exports.default = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _quillDelta = __webpack_require__(2);
	
	var _quillDelta2 = _interopRequireDefault(_quillDelta);
	
	var _parchment = __webpack_require__(0);
	
	var _parchment2 = _interopRequireDefault(_parchment);
	
	var _quill = __webpack_require__(5);
	
	var _quill2 = _interopRequireDefault(_quill);
	
	var _logger = __webpack_require__(10);
	
	var _logger2 = _interopRequireDefault(_logger);
	
	var _module = __webpack_require__(9);
	
	var _module2 = _interopRequireDefault(_module);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var debug = (0, _logger2.default)('quill:toolbar');
	
	var Toolbar = function (_Module) {
	  _inherits(Toolbar, _Module);
	
	  function Toolbar(quill, options) {
	    _classCallCheck(this, Toolbar);
	
	    var _this = _possibleConstructorReturn(this, (Toolbar.__proto__ || Object.getPrototypeOf(Toolbar)).call(this, quill, options));
	
	    if (Array.isArray(_this.options.container)) {
	      var container = document.createElement('div');
	      addControls(container, _this.options.container);
	      quill.container.parentNode.insertBefore(container, quill.container);
	      _this.container = container;
	    } else if (typeof _this.options.container === 'string') {
	      _this.container = document.querySelector(_this.options.container);
	    } else {
	      _this.container = _this.options.container;
	    }
	    if (!(_this.container instanceof HTMLElement)) {
	      var _ret;
	
	      return _ret = debug.error('Container required for toolbar', _this.options), _possibleConstructorReturn(_this, _ret);
	    }
	    _this.container.classList.add('ql-toolbar');
	    _this.controls = [];
	    _this.handlers = {};
	    Object.keys(_this.options.handlers).forEach(function (format) {
	      _this.addHandler(format, _this.options.handlers[format]);
	    });
	    [].forEach.call(_this.container.querySelectorAll('button, select'), function (input) {
	      _this.attach(input);
	    });
	    _this.quill.on(_quill2.default.events.EDITOR_CHANGE, function (type, range) {
	      if (type === _quill2.default.events.SELECTION_CHANGE) {
	        _this.update(range);
	      }
	    });
	    _this.quill.on(_quill2.default.events.SCROLL_OPTIMIZE, function () {
	      var _this$quill$selection = _this.quill.selection.getRange(),
	          _this$quill$selection2 = _slicedToArray(_this$quill$selection, 1),
	          range = _this$quill$selection2[0]; // quill.getSelection triggers update
	
	
	      _this.update(range);
	    });
	    return _this;
	  }
	
	  _createClass(Toolbar, [{
	    key: 'addHandler',
	    value: function addHandler(format, handler) {
	      this.handlers[format] = handler;
	    }
	  }, {
	    key: 'attach',
	    value: function attach(input) {
	      var _this2 = this;
	
	      var format = [].find.call(input.classList, function (className) {
	        return className.indexOf('ql-') === 0;
	      });
	      if (!format) return;
	      format = format.slice('ql-'.length);
	      if (input.tagName === 'BUTTON') {
	        input.setAttribute('type', 'button');
	      }
	      if (this.handlers[format] == null) {
	        if (this.quill.scroll.whitelist != null && this.quill.scroll.whitelist[format] == null) {
	          debug.warn('ignoring attaching to disabled format', format, input);
	          return;
	        }
	        if (_parchment2.default.query(format) == null) {
	          debug.warn('ignoring attaching to nonexistent format', format, input);
	          return;
	        }
	      }
	      var eventName = input.tagName === 'SELECT' ? 'change' : 'click';
	      input.addEventListener(eventName, function (e) {
	        var value = void 0;
	        if (input.tagName === 'SELECT') {
	          if (input.selectedIndex < 0) return;
	          var selected = input.options[input.selectedIndex];
	          if (selected.hasAttribute('selected')) {
	            value = false;
	          } else {
	            value = selected.value || false;
	          }
	        } else {
	          if (input.classList.contains('ql-active')) {
	            value = false;
	          } else {
	            value = input.value || !input.hasAttribute('value');
	          }
	          e.preventDefault();
	        }
	        _this2.quill.focus();
	
	        var _quill$selection$getR = _this2.quill.selection.getRange(),
	            _quill$selection$getR2 = _slicedToArray(_quill$selection$getR, 1),
	            range = _quill$selection$getR2[0];
	
	        if (_this2.handlers[format] != null) {
	          _this2.handlers[format].call(_this2, value);
	        } else if (_parchment2.default.query(format).prototype instanceof _parchment2.default.Embed) {
	          value = prompt('Enter ' + format);
	          if (!value) return;
	          _this2.quill.updateContents(new _quillDelta2.default().retain(range.index).delete(range.length).insert(_defineProperty({}, format, value)), _quill2.default.sources.USER);
	        } else {
	          _this2.quill.format(format, value, _quill2.default.sources.USER);
	        }
	        _this2.update(range);
	      });
	      // TODO use weakmap
	      this.controls.push([format, input]);
	    }
	  }, {
	    key: 'update',
	    value: function update(range) {
	      var formats = range == null ? {} : this.quill.getFormat(range);
	      this.controls.forEach(function (pair) {
	        var _pair = _slicedToArray(pair, 2),
	            format = _pair[0],
	            input = _pair[1];
	
	        if (input.tagName === 'SELECT') {
	          var option = void 0;
	          if (range == null) {
	            option = null;
	          } else if (formats[format] == null) {
	            option = input.querySelector('option[selected]');
	          } else if (!Array.isArray(formats[format])) {
	            var value = formats[format];
	            if (typeof value === 'string') {
	              value = value.replace(/\"/g, '\\"');
	            }
	            option = input.querySelector('option[value="' + value + '"]');
	          }
	          if (option == null) {
	            input.value = ''; // TODO make configurable?
	            input.selectedIndex = -1;
	          } else {
	            option.selected = true;
	          }
	        } else {
	          if (range == null) {
	            input.classList.remove('ql-active');
	          } else if (input.hasAttribute('value')) {
	            // both being null should match (default values)
	            // '1' should match with 1 (headers)
	            var isActive = formats[format] === input.getAttribute('value') || formats[format] != null && formats[format].toString() === input.getAttribute('value') || formats[format] == null && !input.getAttribute('value');
	            input.classList.toggle('ql-active', isActive);
	          } else {
	            input.classList.toggle('ql-active', formats[format] != null);
	          }
	        }
	      });
	    }
	  }]);
	
	  return Toolbar;
	}(_module2.default);
	
	Toolbar.DEFAULTS = {};
	
	function addButton(container, format, value) {
	  var input = document.createElement('button');
	  input.setAttribute('type', 'button');
	  input.classList.add('ql-' + format);
	  if (value != null) {
	    input.value = value;
	  }
	  container.appendChild(input);
	}
	
	function addControls(container, groups) {
	  if (!Array.isArray(groups[0])) {
	    groups = [groups];
	  }
	  groups.forEach(function (controls) {
	    var group = document.createElement('span');
	    group.classList.add('ql-formats');
	    controls.forEach(function (control) {
	      if (typeof control === 'string') {
	        addButton(group, control);
	      } else {
	        var format = Object.keys(control)[0];
	        var value = control[format];
	        if (Array.isArray(value)) {
	          addSelect(group, format, value);
	        } else {
	          addButton(group, format, value);
	        }
	      }
	    });
	    container.appendChild(group);
	  });
	}
	
	function addSelect(container, format, values) {
	  var input = document.createElement('select');
	  input.classList.add('ql-' + format);
	  values.forEach(function (value) {
	    var option = document.createElement('option');
	    if (value !== false) {
	      option.setAttribute('value', value);
	    } else {
	      option.setAttribute('selected', 'selected');
	    }
	    input.appendChild(option);
	  });
	  container.appendChild(input);
	}
	
	Toolbar.DEFAULTS = {
	  container: null,
	  handlers: {
	    clean: function clean() {
	      var _this3 = this;
	
	      var range = this.quill.getSelection();
	      if (range == null) return;
	      if (range.length == 0) {
	        var formats = this.quill.getFormat();
	        Object.keys(formats).forEach(function (name) {
	          // Clean functionality in existing apps only clean inline formats
	          if (_parchment2.default.query(name, _parchment2.default.Scope.INLINE) != null) {
	            _this3.quill.format(name, false);
	          }
	        });
	      } else {
	        this.quill.removeFormat(range, _quill2.default.sources.USER);
	      }
	    },
	    direction: function direction(value) {
	      var align = this.quill.getFormat()['align'];
	      if (value === 'rtl' && align == null) {
	        this.quill.format('align', 'right', _quill2.default.sources.USER);
	      } else if (!value && align === 'right') {
	        this.quill.format('align', false, _quill2.default.sources.USER);
	      }
	      this.quill.format('direction', value, _quill2.default.sources.USER);
	    },
	    indent: function indent(value) {
	      var range = this.quill.getSelection();
	      var formats = this.quill.getFormat(range);
	      var indent = parseInt(formats.indent || 0);
	      if (value === '+1' || value === '-1') {
	        var modifier = value === '+1' ? 1 : -1;
	        if (formats.direction === 'rtl') modifier *= -1;
	        this.quill.format('indent', indent + modifier, _quill2.default.sources.USER);
	      }
	    },
	    link: function link(value) {
	      if (value === true) {
	        value = prompt('Enter link URL:');
	      }
	      this.quill.format('link', value, _quill2.default.sources.USER);
	    },
	    list: function list(value) {
	      var range = this.quill.getSelection();
	      var formats = this.quill.getFormat(range);
	      if (value === 'check') {
	        if (formats['list'] === 'checked' || formats['list'] === 'unchecked') {
	          this.quill.format('list', false, _quill2.default.sources.USER);
	        } else {
	          this.quill.format('list', 'unchecked', _quill2.default.sources.USER);
	        }
	      } else {
	        this.quill.format('list', value, _quill2.default.sources.USER);
	      }
	    }
	  }
	};
	
	exports.default = Toolbar;
	exports.addControls = addControls;
	
	/***/ }),
	/* 58 */
	/***/ (function(module, exports) {
	
	module.exports = "<svg viewbox=\"0 0 18 18\"> <polyline class=\"ql-even ql-stroke\" points=\"5 7 3 9 5 11\"></polyline> <polyline class=\"ql-even ql-stroke\" points=\"13 7 15 9 13 11\"></polyline> <line class=ql-stroke x1=10 x2=8 y1=5 y2=13></line> </svg>";
	
	/***/ }),
	/* 59 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _picker = __webpack_require__(28);
	
	var _picker2 = _interopRequireDefault(_picker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ColorPicker = function (_Picker) {
	  _inherits(ColorPicker, _Picker);
	
	  function ColorPicker(select, label) {
	    _classCallCheck(this, ColorPicker);
	
	    var _this = _possibleConstructorReturn(this, (ColorPicker.__proto__ || Object.getPrototypeOf(ColorPicker)).call(this, select));
	
	    _this.label.innerHTML = label;
	    _this.container.classList.add('ql-color-picker');
	    [].slice.call(_this.container.querySelectorAll('.ql-picker-item'), 0, 7).forEach(function (item) {
	      item.classList.add('ql-primary');
	    });
	    return _this;
	  }
	
	  _createClass(ColorPicker, [{
	    key: 'buildItem',
	    value: function buildItem(option) {
	      var item = _get(ColorPicker.prototype.__proto__ || Object.getPrototypeOf(ColorPicker.prototype), 'buildItem', this).call(this, option);
	      item.style.backgroundColor = option.getAttribute('value') || '';
	      return item;
	    }
	  }, {
	    key: 'selectItem',
	    value: function selectItem(item, trigger) {
	      _get(ColorPicker.prototype.__proto__ || Object.getPrototypeOf(ColorPicker.prototype), 'selectItem', this).call(this, item, trigger);
	      var colorLabel = this.label.querySelector('.ql-color-label');
	      var value = item ? item.getAttribute('data-value') || '' : '';
	      if (colorLabel) {
	        if (colorLabel.tagName === 'line') {
	          colorLabel.style.stroke = value;
	        } else {
	          colorLabel.style.fill = value;
	        }
	      }
	    }
	  }]);
	
	  return ColorPicker;
	}(_picker2.default);
	
	exports.default = ColorPicker;
	
	/***/ }),
	/* 60 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _picker = __webpack_require__(28);
	
	var _picker2 = _interopRequireDefault(_picker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var IconPicker = function (_Picker) {
	  _inherits(IconPicker, _Picker);
	
	  function IconPicker(select, icons) {
	    _classCallCheck(this, IconPicker);
	
	    var _this = _possibleConstructorReturn(this, (IconPicker.__proto__ || Object.getPrototypeOf(IconPicker)).call(this, select));
	
	    _this.container.classList.add('ql-icon-picker');
	    [].forEach.call(_this.container.querySelectorAll('.ql-picker-item'), function (item) {
	      item.innerHTML = icons[item.getAttribute('data-value') || ''];
	    });
	    _this.defaultItem = _this.container.querySelector('.ql-selected');
	    _this.selectItem(_this.defaultItem);
	    return _this;
	  }
	
	  _createClass(IconPicker, [{
	    key: 'selectItem',
	    value: function selectItem(item, trigger) {
	      _get(IconPicker.prototype.__proto__ || Object.getPrototypeOf(IconPicker.prototype), 'selectItem', this).call(this, item, trigger);
	      item = item || this.defaultItem;
	      this.label.innerHTML = item.innerHTML;
	    }
	  }]);
	
	  return IconPicker;
	}(_picker2.default);
	
	exports.default = IconPicker;
	
	/***/ }),
	/* 61 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Tooltip = function () {
	  function Tooltip(quill, boundsContainer) {
	    var _this = this;
	
	    _classCallCheck(this, Tooltip);
	
	    this.quill = quill;
	    this.boundsContainer = boundsContainer || document.body;
	    this.root = quill.addContainer('ql-tooltip');
	    this.root.innerHTML = this.constructor.TEMPLATE;
	    if (this.quill.root === this.quill.scrollingContainer) {
	      this.quill.root.addEventListener('scroll', function () {
	        _this.root.style.marginTop = -1 * _this.quill.root.scrollTop + 'px';
	      });
	    }
	    this.hide();
	  }
	
	  _createClass(Tooltip, [{
	    key: 'hide',
	    value: function hide() {
	      this.root.classList.add('ql-hidden');
	    }
	  }, {
	    key: 'position',
	    value: function position(reference) {
	      var left = reference.left + reference.width / 2 - this.root.offsetWidth / 2;
	      // root.scrollTop should be 0 if scrollContainer !== root
	      var top = reference.bottom + this.quill.root.scrollTop;
	      this.root.style.left = left + 'px';
	      this.root.style.top = top + 'px';
	      this.root.classList.remove('ql-flip');
	      var containerBounds = this.boundsContainer.getBoundingClientRect();
	      var rootBounds = this.root.getBoundingClientRect();
	      var shift = 0;
	      if (rootBounds.right > containerBounds.right) {
	        shift = containerBounds.right - rootBounds.right;
	        this.root.style.left = left + shift + 'px';
	      }
	      if (rootBounds.left < containerBounds.left) {
	        shift = containerBounds.left - rootBounds.left;
	        this.root.style.left = left + shift + 'px';
	      }
	      if (rootBounds.bottom > containerBounds.bottom) {
	        var height = rootBounds.bottom - rootBounds.top;
	        var verticalShift = reference.bottom - reference.top + height;
	        this.root.style.top = top - verticalShift + 'px';
	        this.root.classList.add('ql-flip');
	      }
	      return shift;
	    }
	  }, {
	    key: 'show',
	    value: function show() {
	      this.root.classList.remove('ql-editing');
	      this.root.classList.remove('ql-hidden');
	    }
	  }]);
	
	  return Tooltip;
	}();
	
	exports.default = Tooltip;
	
	/***/ }),
	/* 62 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _extend = __webpack_require__(3);
	
	var _extend2 = _interopRequireDefault(_extend);
	
	var _emitter = __webpack_require__(8);
	
	var _emitter2 = _interopRequireDefault(_emitter);
	
	var _base = __webpack_require__(43);
	
	var _base2 = _interopRequireDefault(_base);
	
	var _link = __webpack_require__(27);
	
	var _link2 = _interopRequireDefault(_link);
	
	var _selection = __webpack_require__(15);
	
	var _icons = __webpack_require__(41);
	
	var _icons2 = _interopRequireDefault(_icons);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TOOLBAR_CONFIG = [[{ header: ['1', '2', '3', false] }], ['bold', 'italic', 'underline', 'link'], [{ list: 'ordered' }, { list: 'bullet' }], ['clean']];
	
	var SnowTheme = function (_BaseTheme) {
	  _inherits(SnowTheme, _BaseTheme);
	
	  function SnowTheme(quill, options) {
	    _classCallCheck(this, SnowTheme);
	
	    if (options.modules.toolbar != null && options.modules.toolbar.container == null) {
	      options.modules.toolbar.container = TOOLBAR_CONFIG;
	    }
	
	    var _this = _possibleConstructorReturn(this, (SnowTheme.__proto__ || Object.getPrototypeOf(SnowTheme)).call(this, quill, options));
	
	    _this.quill.container.classList.add('ql-snow');
	    return _this;
	  }
	
	  _createClass(SnowTheme, [{
	    key: 'extendToolbar',
	    value: function extendToolbar(toolbar) {
	      toolbar.container.classList.add('ql-snow');
	      this.buildButtons([].slice.call(toolbar.container.querySelectorAll('button')), _icons2.default);
	      this.buildPickers([].slice.call(toolbar.container.querySelectorAll('select')), _icons2.default);
	      this.tooltip = new SnowTooltip(this.quill, this.options.bounds);
	      if (toolbar.container.querySelector('.ql-link')) {
	        this.quill.keyboard.addBinding({ key: 'K', shortKey: true }, function (range, context) {
	          toolbar.handlers['link'].call(toolbar, !context.format.link);
	        });
	      }
	    }
	  }]);
	
	  return SnowTheme;
	}(_base2.default);
	
	SnowTheme.DEFAULTS = (0, _extend2.default)(true, {}, _base2.default.DEFAULTS, {
	  modules: {
	    toolbar: {
	      handlers: {
	        link: function link(value) {
	          if (value) {
	            var range = this.quill.getSelection();
	            if (range == null || range.length == 0) return;
	            var preview = this.quill.getText(range);
	            if (/^\S+@\S+\.\S+$/.test(preview) && preview.indexOf('mailto:') !== 0) {
	              preview = 'mailto:' + preview;
	            }
	            var tooltip = this.quill.theme.tooltip;
	            tooltip.edit('link', preview);
	          } else {
	            this.quill.format('link', false);
	          }
	        }
	      }
	    }
	  }
	});
	
	var SnowTooltip = function (_BaseTooltip) {
	  _inherits(SnowTooltip, _BaseTooltip);
	
	  function SnowTooltip(quill, bounds) {
	    _classCallCheck(this, SnowTooltip);
	
	    var _this2 = _possibleConstructorReturn(this, (SnowTooltip.__proto__ || Object.getPrototypeOf(SnowTooltip)).call(this, quill, bounds));
	
	    _this2.preview = _this2.root.querySelector('a.ql-preview');
	    return _this2;
	  }
	
	  _createClass(SnowTooltip, [{
	    key: 'listen',
	    value: function listen() {
	      var _this3 = this;
	
	      _get(SnowTooltip.prototype.__proto__ || Object.getPrototypeOf(SnowTooltip.prototype), 'listen', this).call(this);
	      this.root.querySelector('a.ql-action').addEventListener('click', function (event) {
	        if (_this3.root.classList.contains('ql-editing')) {
	          _this3.save();
	        } else {
	          _this3.edit('link', _this3.preview.textContent);
	        }
	        event.preventDefault();
	      });
	      this.root.querySelector('a.ql-remove').addEventListener('click', function (event) {
	        if (_this3.linkRange != null) {
	          var range = _this3.linkRange;
	          _this3.restoreFocus();
	          _this3.quill.formatText(range, 'link', false, _emitter2.default.sources.USER);
	          delete _this3.linkRange;
	        }
	        event.preventDefault();
	        _this3.hide();
	      });
	      this.quill.on(_emitter2.default.events.SELECTION_CHANGE, function (range, oldRange, source) {
	        if (range == null) return;
	        if (range.length === 0 && source === _emitter2.default.sources.USER) {
	          var _quill$scroll$descend = _this3.quill.scroll.descendant(_link2.default, range.index),
	              _quill$scroll$descend2 = _slicedToArray(_quill$scroll$descend, 2),
	              link = _quill$scroll$descend2[0],
	              offset = _quill$scroll$descend2[1];
	
	          if (link != null) {
	            _this3.linkRange = new _selection.Range(range.index - offset, link.length());
	            var preview = _link2.default.formats(link.domNode);
	            _this3.preview.textContent = preview;
	            _this3.preview.setAttribute('href', preview);
	            _this3.show();
	            _this3.position(_this3.quill.getBounds(_this3.linkRange));
	            return;
	          }
	        } else {
	          delete _this3.linkRange;
	        }
	        _this3.hide();
	      });
	    }
	  }, {
	    key: 'show',
	    value: function show() {
	      _get(SnowTooltip.prototype.__proto__ || Object.getPrototypeOf(SnowTooltip.prototype), 'show', this).call(this);
	      this.root.removeAttribute('data-mode');
	    }
	  }]);
	
	  return SnowTooltip;
	}(_base.BaseTooltip);
	
	SnowTooltip.TEMPLATE = ['<a class="ql-preview" rel="noopener noreferrer" target="_blank" href="about:blank"></a>', '<input type="text" data-formula="e=mc^2" data-link="https://quilljs.com" data-video="Embed URL">', '<a class="ql-action"></a>', '<a class="ql-remove"></a>'].join('');
	
	exports.default = SnowTheme;
	
	/***/ }),
	/* 63 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _core = __webpack_require__(29);
	
	var _core2 = _interopRequireDefault(_core);
	
	var _align = __webpack_require__(36);
	
	var _direction = __webpack_require__(38);
	
	var _indent = __webpack_require__(64);
	
	var _blockquote = __webpack_require__(65);
	
	var _blockquote2 = _interopRequireDefault(_blockquote);
	
	var _header = __webpack_require__(66);
	
	var _header2 = _interopRequireDefault(_header);
	
	var _list = __webpack_require__(67);
	
	var _list2 = _interopRequireDefault(_list);
	
	var _background = __webpack_require__(37);
	
	var _color = __webpack_require__(26);
	
	var _font = __webpack_require__(39);
	
	var _size = __webpack_require__(40);
	
	var _bold = __webpack_require__(56);
	
	var _bold2 = _interopRequireDefault(_bold);
	
	var _italic = __webpack_require__(68);
	
	var _italic2 = _interopRequireDefault(_italic);
	
	var _link = __webpack_require__(27);
	
	var _link2 = _interopRequireDefault(_link);
	
	var _script = __webpack_require__(69);
	
	var _script2 = _interopRequireDefault(_script);
	
	var _strike = __webpack_require__(70);
	
	var _strike2 = _interopRequireDefault(_strike);
	
	var _underline = __webpack_require__(71);
	
	var _underline2 = _interopRequireDefault(_underline);
	
	var _image = __webpack_require__(72);
	
	var _image2 = _interopRequireDefault(_image);
	
	var _video = __webpack_require__(73);
	
	var _video2 = _interopRequireDefault(_video);
	
	var _code = __webpack_require__(13);
	
	var _code2 = _interopRequireDefault(_code);
	
	var _formula = __webpack_require__(74);
	
	var _formula2 = _interopRequireDefault(_formula);
	
	var _syntax = __webpack_require__(75);
	
	var _syntax2 = _interopRequireDefault(_syntax);
	
	var _toolbar = __webpack_require__(57);
	
	var _toolbar2 = _interopRequireDefault(_toolbar);
	
	var _icons = __webpack_require__(41);
	
	var _icons2 = _interopRequireDefault(_icons);
	
	var _picker = __webpack_require__(28);
	
	var _picker2 = _interopRequireDefault(_picker);
	
	var _colorPicker = __webpack_require__(59);
	
	var _colorPicker2 = _interopRequireDefault(_colorPicker);
	
	var _iconPicker = __webpack_require__(60);
	
	var _iconPicker2 = _interopRequireDefault(_iconPicker);
	
	var _tooltip = __webpack_require__(61);
	
	var _tooltip2 = _interopRequireDefault(_tooltip);
	
	var _bubble = __webpack_require__(108);
	
	var _bubble2 = _interopRequireDefault(_bubble);
	
	var _snow = __webpack_require__(62);
	
	var _snow2 = _interopRequireDefault(_snow);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_core2.default.register({
	  'attributors/attribute/direction': _direction.DirectionAttribute,
	
	  'attributors/class/align': _align.AlignClass,
	  'attributors/class/background': _background.BackgroundClass,
	  'attributors/class/color': _color.ColorClass,
	  'attributors/class/direction': _direction.DirectionClass,
	  'attributors/class/font': _font.FontClass,
	  'attributors/class/size': _size.SizeClass,
	
	  'attributors/style/align': _align.AlignStyle,
	  'attributors/style/background': _background.BackgroundStyle,
	  'attributors/style/color': _color.ColorStyle,
	  'attributors/style/direction': _direction.DirectionStyle,
	  'attributors/style/font': _font.FontStyle,
	  'attributors/style/size': _size.SizeStyle
	}, true);
	
	_core2.default.register({
	  'formats/align': _align.AlignClass,
	  'formats/direction': _direction.DirectionClass,
	  'formats/indent': _indent.IndentClass,
	
	  'formats/background': _background.BackgroundStyle,
	  'formats/color': _color.ColorStyle,
	  'formats/font': _font.FontClass,
	  'formats/size': _size.SizeClass,
	
	  'formats/blockquote': _blockquote2.default,
	  'formats/code-block': _code2.default,
	  'formats/header': _header2.default,
	  'formats/list': _list2.default,
	
	  'formats/bold': _bold2.default,
	  'formats/code': _code.Code,
	  'formats/italic': _italic2.default,
	  'formats/link': _link2.default,
	  'formats/script': _script2.default,
	  'formats/strike': _strike2.default,
	  'formats/underline': _underline2.default,
	
	  'formats/image': _image2.default,
	  'formats/video': _video2.default,
	
	  'formats/list/item': _list.ListItem,
	
	  'modules/formula': _formula2.default,
	  'modules/syntax': _syntax2.default,
	  'modules/toolbar': _toolbar2.default,
	
	  'themes/bubble': _bubble2.default,
	  'themes/snow': _snow2.default,
	
	  'ui/icons': _icons2.default,
	  'ui/picker': _picker2.default,
	  'ui/icon-picker': _iconPicker2.default,
	  'ui/color-picker': _colorPicker2.default,
	  'ui/tooltip': _tooltip2.default
	}, true);
	
	exports.default = _core2.default;
	
	/***/ }),
	/* 64 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.IndentClass = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _parchment = __webpack_require__(0);
	
	var _parchment2 = _interopRequireDefault(_parchment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var IdentAttributor = function (_Parchment$Attributor) {
	  _inherits(IdentAttributor, _Parchment$Attributor);
	
	  function IdentAttributor() {
	    _classCallCheck(this, IdentAttributor);
	
	    return _possibleConstructorReturn(this, (IdentAttributor.__proto__ || Object.getPrototypeOf(IdentAttributor)).apply(this, arguments));
	  }
	
	  _createClass(IdentAttributor, [{
	    key: 'add',
	    value: function add(node, value) {
	      if (value === '+1' || value === '-1') {
	        var indent = this.value(node) || 0;
	        value = value === '+1' ? indent + 1 : indent - 1;
	      }
	      if (value === 0) {
	        this.remove(node);
	        return true;
	      } else {
	        return _get(IdentAttributor.prototype.__proto__ || Object.getPrototypeOf(IdentAttributor.prototype), 'add', this).call(this, node, value);
	      }
	    }
	  }, {
	    key: 'canAdd',
	    value: function canAdd(node, value) {
	      return _get(IdentAttributor.prototype.__proto__ || Object.getPrototypeOf(IdentAttributor.prototype), 'canAdd', this).call(this, node, value) || _get(IdentAttributor.prototype.__proto__ || Object.getPrototypeOf(IdentAttributor.prototype), 'canAdd', this).call(this, node, parseInt(value));
	    }
	  }, {
	    key: 'value',
	    value: function value(node) {
	      return parseInt(_get(IdentAttributor.prototype.__proto__ || Object.getPrototypeOf(IdentAttributor.prototype), 'value', this).call(this, node)) || undefined; // Don't return NaN
	    }
	  }]);
	
	  return IdentAttributor;
	}(_parchment2.default.Attributor.Class);
	
	var IndentClass = new IdentAttributor('indent', 'ql-indent', {
	  scope: _parchment2.default.Scope.BLOCK,
	  whitelist: [1, 2, 3, 4, 5, 6, 7, 8]
	});
	
	exports.IndentClass = IndentClass;
	
	/***/ }),
	/* 65 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _block = __webpack_require__(4);
	
	var _block2 = _interopRequireDefault(_block);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Blockquote = function (_Block) {
	  _inherits(Blockquote, _Block);
	
	  function Blockquote() {
	    _classCallCheck(this, Blockquote);
	
	    return _possibleConstructorReturn(this, (Blockquote.__proto__ || Object.getPrototypeOf(Blockquote)).apply(this, arguments));
	  }
	
	  return Blockquote;
	}(_block2.default);
	
	Blockquote.blotName = 'blockquote';
	Blockquote.tagName = 'blockquote';
	
	exports.default = Blockquote;
	
	/***/ }),
	/* 66 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _block = __webpack_require__(4);
	
	var _block2 = _interopRequireDefault(_block);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Header = function (_Block) {
	  _inherits(Header, _Block);
	
	  function Header() {
	    _classCallCheck(this, Header);
	
	    return _possibleConstructorReturn(this, (Header.__proto__ || Object.getPrototypeOf(Header)).apply(this, arguments));
	  }
	
	  _createClass(Header, null, [{
	    key: 'formats',
	    value: function formats(domNode) {
	      return this.tagName.indexOf(domNode.tagName) + 1;
	    }
	  }]);
	
	  return Header;
	}(_block2.default);
	
	Header.blotName = 'header';
	Header.tagName = ['H1', 'H2', 'H3', 'H4', 'H5', 'H6'];
	
	exports.default = Header;
	
	/***/ }),
	/* 67 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.ListItem = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _parchment = __webpack_require__(0);
	
	var _parchment2 = _interopRequireDefault(_parchment);
	
	var _block = __webpack_require__(4);
	
	var _block2 = _interopRequireDefault(_block);
	
	var _container = __webpack_require__(25);
	
	var _container2 = _interopRequireDefault(_container);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ListItem = function (_Block) {
	  _inherits(ListItem, _Block);
	
	  function ListItem() {
	    _classCallCheck(this, ListItem);
	
	    return _possibleConstructorReturn(this, (ListItem.__proto__ || Object.getPrototypeOf(ListItem)).apply(this, arguments));
	  }
	
	  _createClass(ListItem, [{
	    key: 'format',
	    value: function format(name, value) {
	      if (name === List.blotName && !value) {
	        this.replaceWith(_parchment2.default.create(this.statics.scope));
	      } else {
	        _get(ListItem.prototype.__proto__ || Object.getPrototypeOf(ListItem.prototype), 'format', this).call(this, name, value);
	      }
	    }
	  }, {
	    key: 'remove',
	    value: function remove() {
	      if (this.prev == null && this.next == null) {
	        this.parent.remove();
	      } else {
	        _get(ListItem.prototype.__proto__ || Object.getPrototypeOf(ListItem.prototype), 'remove', this).call(this);
	      }
	    }
	  }, {
	    key: 'replaceWith',
	    value: function replaceWith(name, value) {
	      this.parent.isolate(this.offset(this.parent), this.length());
	      if (name === this.parent.statics.blotName) {
	        this.parent.replaceWith(name, value);
	        return this;
	      } else {
	        this.parent.unwrap();
	        return _get(ListItem.prototype.__proto__ || Object.getPrototypeOf(ListItem.prototype), 'replaceWith', this).call(this, name, value);
	      }
	    }
	  }], [{
	    key: 'formats',
	    value: function formats(domNode) {
	      return domNode.tagName === this.tagName ? undefined : _get(ListItem.__proto__ || Object.getPrototypeOf(ListItem), 'formats', this).call(this, domNode);
	    }
	  }]);
	
	  return ListItem;
	}(_block2.default);
	
	ListItem.blotName = 'list-item';
	ListItem.tagName = 'LI';
	
	var List = function (_Container) {
	  _inherits(List, _Container);
	
	  _createClass(List, null, [{
	    key: 'create',
	    value: function create(value) {
	      var tagName = value === 'ordered' ? 'OL' : 'UL';
	      var node = _get(List.__proto__ || Object.getPrototypeOf(List), 'create', this).call(this, tagName);
	      if (value === 'checked' || value === 'unchecked') {
	        node.setAttribute('data-checked', value === 'checked');
	      }
	      return node;
	    }
	  }, {
	    key: 'formats',
	    value: function formats(domNode) {
	      if (domNode.tagName === 'OL') return 'ordered';
	      if (domNode.tagName === 'UL') {
	        if (domNode.hasAttribute('data-checked')) {
	          return domNode.getAttribute('data-checked') === 'true' ? 'checked' : 'unchecked';
	        } else {
	          return 'bullet';
	        }
	      }
	      return undefined;
	    }
	  }]);
	
	  function List(domNode) {
	    _classCallCheck(this, List);
	
	    var _this2 = _possibleConstructorReturn(this, (List.__proto__ || Object.getPrototypeOf(List)).call(this, domNode));
	
	    var listEventHandler = function listEventHandler(e) {
	      if (e.target.parentNode !== domNode) return;
	      var format = _this2.statics.formats(domNode);
	      var blot = _parchment2.default.find(e.target);
	      if (format === 'checked') {
	        blot.format('list', 'unchecked');
	      } else if (format === 'unchecked') {
	        blot.format('list', 'checked');
	      }
	    };
	
	    domNode.addEventListener('touchstart', listEventHandler);
	    domNode.addEventListener('mousedown', listEventHandler);
	    return _this2;
	  }
	
	  _createClass(List, [{
	    key: 'format',
	    value: function format(name, value) {
	      if (this.children.length > 0) {
	        this.children.tail.format(name, value);
	      }
	    }
	  }, {
	    key: 'formats',
	    value: function formats() {
	      // We don't inherit from FormatBlot
	      return _defineProperty({}, this.statics.blotName, this.statics.formats(this.domNode));
	    }
	  }, {
	    key: 'insertBefore',
	    value: function insertBefore(blot, ref) {
	      if (blot instanceof ListItem) {
	        _get(List.prototype.__proto__ || Object.getPrototypeOf(List.prototype), 'insertBefore', this).call(this, blot, ref);
	      } else {
	        var index = ref == null ? this.length() : ref.offset(this);
	        var after = this.split(index);
	        after.parent.insertBefore(blot, after);
	      }
	    }
	  }, {
	    key: 'optimize',
	    value: function optimize(context) {
	      _get(List.prototype.__proto__ || Object.getPrototypeOf(List.prototype), 'optimize', this).call(this, context);
	      var next = this.next;
	      if (next != null && next.prev === this && next.statics.blotName === this.statics.blotName && next.domNode.tagName === this.domNode.tagName && next.domNode.getAttribute('data-checked') === this.domNode.getAttribute('data-checked')) {
	        next.moveChildren(this);
	        next.remove();
	      }
	    }
	  }, {
	    key: 'replace',
	    value: function replace(target) {
	      if (target.statics.blotName !== this.statics.blotName) {
	        var item = _parchment2.default.create(this.statics.defaultChild);
	        target.moveChildren(item);
	        this.appendChild(item);
	      }
	      _get(List.prototype.__proto__ || Object.getPrototypeOf(List.prototype), 'replace', this).call(this, target);
	    }
	  }]);
	
	  return List;
	}(_container2.default);
	
	List.blotName = 'list';
	List.scope = _parchment2.default.Scope.BLOCK_BLOT;
	List.tagName = ['OL', 'UL'];
	List.defaultChild = 'list-item';
	List.allowedChildren = [ListItem];
	
	exports.ListItem = ListItem;
	exports.default = List;
	
	/***/ }),
	/* 68 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _bold = __webpack_require__(56);
	
	var _bold2 = _interopRequireDefault(_bold);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Italic = function (_Bold) {
	  _inherits(Italic, _Bold);
	
	  function Italic() {
	    _classCallCheck(this, Italic);
	
	    return _possibleConstructorReturn(this, (Italic.__proto__ || Object.getPrototypeOf(Italic)).apply(this, arguments));
	  }
	
	  return Italic;
	}(_bold2.default);
	
	Italic.blotName = 'italic';
	Italic.tagName = ['EM', 'I'];
	
	exports.default = Italic;
	
	/***/ }),
	/* 69 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _inline = __webpack_require__(6);
	
	var _inline2 = _interopRequireDefault(_inline);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Script = function (_Inline) {
	  _inherits(Script, _Inline);
	
	  function Script() {
	    _classCallCheck(this, Script);
	
	    return _possibleConstructorReturn(this, (Script.__proto__ || Object.getPrototypeOf(Script)).apply(this, arguments));
	  }
	
	  _createClass(Script, null, [{
	    key: 'create',
	    value: function create(value) {
	      if (value === 'super') {
	        return document.createElement('sup');
	      } else if (value === 'sub') {
	        return document.createElement('sub');
	      } else {
	        return _get(Script.__proto__ || Object.getPrototypeOf(Script), 'create', this).call(this, value);
	      }
	    }
	  }, {
	    key: 'formats',
	    value: function formats(domNode) {
	      if (domNode.tagName === 'SUB') return 'sub';
	      if (domNode.tagName === 'SUP') return 'super';
	      return undefined;
	    }
	  }]);
	
	  return Script;
	}(_inline2.default);
	
	Script.blotName = 'script';
	Script.tagName = ['SUB', 'SUP'];
	
	exports.default = Script;
	
	/***/ }),
	/* 70 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _inline = __webpack_require__(6);
	
	var _inline2 = _interopRequireDefault(_inline);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Strike = function (_Inline) {
	  _inherits(Strike, _Inline);
	
	  function Strike() {
	    _classCallCheck(this, Strike);
	
	    return _possibleConstructorReturn(this, (Strike.__proto__ || Object.getPrototypeOf(Strike)).apply(this, arguments));
	  }
	
	  return Strike;
	}(_inline2.default);
	
	Strike.blotName = 'strike';
	Strike.tagName = 'S';
	
	exports.default = Strike;
	
	/***/ }),
	/* 71 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _inline = __webpack_require__(6);
	
	var _inline2 = _interopRequireDefault(_inline);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Underline = function (_Inline) {
	  _inherits(Underline, _Inline);
	
	  function Underline() {
	    _classCallCheck(this, Underline);
	
	    return _possibleConstructorReturn(this, (Underline.__proto__ || Object.getPrototypeOf(Underline)).apply(this, arguments));
	  }
	
	  return Underline;
	}(_inline2.default);
	
	Underline.blotName = 'underline';
	Underline.tagName = 'U';
	
	exports.default = Underline;
	
	/***/ }),
	/* 72 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _parchment = __webpack_require__(0);
	
	var _parchment2 = _interopRequireDefault(_parchment);
	
	var _link = __webpack_require__(27);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ATTRIBUTES = ['alt', 'height', 'width'];
	
	var Image = function (_Parchment$Embed) {
	  _inherits(Image, _Parchment$Embed);
	
	  function Image() {
	    _classCallCheck(this, Image);
	
	    return _possibleConstructorReturn(this, (Image.__proto__ || Object.getPrototypeOf(Image)).apply(this, arguments));
	  }
	
	  _createClass(Image, [{
	    key: 'format',
	    value: function format(name, value) {
	      if (ATTRIBUTES.indexOf(name) > -1) {
	        if (value) {
	          this.domNode.setAttribute(name, value);
	        } else {
	          this.domNode.removeAttribute(name);
	        }
	      } else {
	        _get(Image.prototype.__proto__ || Object.getPrototypeOf(Image.prototype), 'format', this).call(this, name, value);
	      }
	    }
	  }], [{
	    key: 'create',
	    value: function create(value) {
	      var node = _get(Image.__proto__ || Object.getPrototypeOf(Image), 'create', this).call(this, value);
	      if (typeof value === 'string') {
	        node.setAttribute('src', this.sanitize(value));
	      }
	      return node;
	    }
	  }, {
	    key: 'formats',
	    value: function formats(domNode) {
	      return ATTRIBUTES.reduce(function (formats, attribute) {
	        if (domNode.hasAttribute(attribute)) {
	          formats[attribute] = domNode.getAttribute(attribute);
	        }
	        return formats;
	      }, {});
	    }
	  }, {
	    key: 'match',
	    value: function match(url) {
	      return (/\.(jpe?g|gif|png)$/.test(url) || /^data:image\/.+;base64/.test(url)
	      );
	    }
	  }, {
	    key: 'sanitize',
	    value: function sanitize(url) {
	      return (0, _link.sanitize)(url, ['http', 'https', 'data']) ? url : '//:0';
	    }
	  }, {
	    key: 'value',
	    value: function value(domNode) {
	      return domNode.getAttribute('src');
	    }
	  }]);
	
	  return Image;
	}(_parchment2.default.Embed);
	
	Image.blotName = 'image';
	Image.tagName = 'IMG';
	
	exports.default = Image;
	
	/***/ }),
	/* 73 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _block = __webpack_require__(4);
	
	var _link = __webpack_require__(27);
	
	var _link2 = _interopRequireDefault(_link);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ATTRIBUTES = ['height', 'width'];
	
	var Video = function (_BlockEmbed) {
	  _inherits(Video, _BlockEmbed);
	
	  function Video() {
	    _classCallCheck(this, Video);
	
	    return _possibleConstructorReturn(this, (Video.__proto__ || Object.getPrototypeOf(Video)).apply(this, arguments));
	  }
	
	  _createClass(Video, [{
	    key: 'format',
	    value: function format(name, value) {
	      if (ATTRIBUTES.indexOf(name) > -1) {
	        if (value) {
	          this.domNode.setAttribute(name, value);
	        } else {
	          this.domNode.removeAttribute(name);
	        }
	      } else {
	        _get(Video.prototype.__proto__ || Object.getPrototypeOf(Video.prototype), 'format', this).call(this, name, value);
	      }
	    }
	  }], [{
	    key: 'create',
	    value: function create(value) {
	      var node = _get(Video.__proto__ || Object.getPrototypeOf(Video), 'create', this).call(this, value);
	      node.setAttribute('frameborder', '0');
	      node.setAttribute('allowfullscreen', true);
	      node.setAttribute('src', this.sanitize(value));
	      return node;
	    }
	  }, {
	    key: 'formats',
	    value: function formats(domNode) {
	      return ATTRIBUTES.reduce(function (formats, attribute) {
	        if (domNode.hasAttribute(attribute)) {
	          formats[attribute] = domNode.getAttribute(attribute);
	        }
	        return formats;
	      }, {});
	    }
	  }, {
	    key: 'sanitize',
	    value: function sanitize(url) {
	      return _link2.default.sanitize(url);
	    }
	  }, {
	    key: 'value',
	    value: function value(domNode) {
	      return domNode.getAttribute('src');
	    }
	  }]);
	
	  return Video;
	}(_block.BlockEmbed);
	
	Video.blotName = 'video';
	Video.className = 'ql-video';
	Video.tagName = 'IFRAME';
	
	exports.default = Video;
	
	/***/ }),
	/* 74 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.FormulaBlot = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _embed = __webpack_require__(35);
	
	var _embed2 = _interopRequireDefault(_embed);
	
	var _quill = __webpack_require__(5);
	
	var _quill2 = _interopRequireDefault(_quill);
	
	var _module = __webpack_require__(9);
	
	var _module2 = _interopRequireDefault(_module);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormulaBlot = function (_Embed) {
	  _inherits(FormulaBlot, _Embed);
	
	  function FormulaBlot() {
	    _classCallCheck(this, FormulaBlot);
	
	    return _possibleConstructorReturn(this, (FormulaBlot.__proto__ || Object.getPrototypeOf(FormulaBlot)).apply(this, arguments));
	  }
	
	  _createClass(FormulaBlot, null, [{
	    key: 'create',
	    value: function create(value) {
	      var node = _get(FormulaBlot.__proto__ || Object.getPrototypeOf(FormulaBlot), 'create', this).call(this, value);
	      if (typeof value === 'string') {
	        window.katex.render(value, node, {
	          throwOnError: false,
	          errorColor: '#f00'
	        });
	        node.setAttribute('data-value', value);
	      }
	      return node;
	    }
	  }, {
	    key: 'value',
	    value: function value(domNode) {
	      return domNode.getAttribute('data-value');
	    }
	  }]);
	
	  return FormulaBlot;
	}(_embed2.default);
	
	FormulaBlot.blotName = 'formula';
	FormulaBlot.className = 'ql-formula';
	FormulaBlot.tagName = 'SPAN';
	
	var Formula = function (_Module) {
	  _inherits(Formula, _Module);
	
	  _createClass(Formula, null, [{
	    key: 'register',
	    value: function register() {
	      _quill2.default.register(FormulaBlot, true);
	    }
	  }]);
	
	  function Formula() {
	    _classCallCheck(this, Formula);
	
	    var _this2 = _possibleConstructorReturn(this, (Formula.__proto__ || Object.getPrototypeOf(Formula)).call(this));
	
	    if (window.katex == null) {
	      throw new Error('Formula module requires KaTeX.');
	    }
	    return _this2;
	  }
	
	  return Formula;
	}(_module2.default);
	
	exports.FormulaBlot = FormulaBlot;
	exports.default = Formula;
	
	/***/ }),
	/* 75 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.CodeToken = exports.CodeBlock = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _parchment = __webpack_require__(0);
	
	var _parchment2 = _interopRequireDefault(_parchment);
	
	var _quill = __webpack_require__(5);
	
	var _quill2 = _interopRequireDefault(_quill);
	
	var _module = __webpack_require__(9);
	
	var _module2 = _interopRequireDefault(_module);
	
	var _code = __webpack_require__(13);
	
	var _code2 = _interopRequireDefault(_code);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SyntaxCodeBlock = function (_CodeBlock) {
	  _inherits(SyntaxCodeBlock, _CodeBlock);
	
	  function SyntaxCodeBlock() {
	    _classCallCheck(this, SyntaxCodeBlock);
	
	    return _possibleConstructorReturn(this, (SyntaxCodeBlock.__proto__ || Object.getPrototypeOf(SyntaxCodeBlock)).apply(this, arguments));
	  }
	
	  _createClass(SyntaxCodeBlock, [{
	    key: 'replaceWith',
	    value: function replaceWith(block) {
	      this.domNode.textContent = this.domNode.textContent;
	      this.attach();
	      _get(SyntaxCodeBlock.prototype.__proto__ || Object.getPrototypeOf(SyntaxCodeBlock.prototype), 'replaceWith', this).call(this, block);
	    }
	  }, {
	    key: 'highlight',
	    value: function highlight(_highlight) {
	      var text = this.domNode.textContent;
	      if (this.cachedText !== text) {
	        if (text.trim().length > 0 || this.cachedText == null) {
	          this.domNode.innerHTML = _highlight(text);
	          this.domNode.normalize();
	          this.attach();
	        }
	        this.cachedText = text;
	      }
	    }
	  }]);
	
	  return SyntaxCodeBlock;
	}(_code2.default);
	
	SyntaxCodeBlock.className = 'ql-syntax';
	
	var CodeToken = new _parchment2.default.Attributor.Class('token', 'hljs', {
	  scope: _parchment2.default.Scope.INLINE
	});
	
	var Syntax = function (_Module) {
	  _inherits(Syntax, _Module);
	
	  _createClass(Syntax, null, [{
	    key: 'register',
	    value: function register() {
	      _quill2.default.register(CodeToken, true);
	      _quill2.default.register(SyntaxCodeBlock, true);
	    }
	  }]);
	
	  function Syntax(quill, options) {
	    _classCallCheck(this, Syntax);
	
	    var _this2 = _possibleConstructorReturn(this, (Syntax.__proto__ || Object.getPrototypeOf(Syntax)).call(this, quill, options));
	
	    if (typeof _this2.options.highlight !== 'function') {
	      throw new Error('Syntax module requires highlight.js. Please include the library on the page before Quill.');
	    }
	    var timer = null;
	    _this2.quill.on(_quill2.default.events.SCROLL_OPTIMIZE, function () {
	      clearTimeout(timer);
	      timer = setTimeout(function () {
	        _this2.highlight();
	        timer = null;
	      }, _this2.options.interval);
	    });
	    _this2.highlight();
	    return _this2;
	  }
	
	  _createClass(Syntax, [{
	    key: 'highlight',
	    value: function highlight() {
	      var _this3 = this;
	
	      if (this.quill.selection.composing) return;
	      this.quill.update(_quill2.default.sources.USER);
	      var range = this.quill.getSelection();
	      this.quill.scroll.descendants(SyntaxCodeBlock).forEach(function (code) {
	        code.highlight(_this3.options.highlight);
	      });
	      this.quill.update(_quill2.default.sources.SILENT);
	      if (range != null) {
	        this.quill.setSelection(range, _quill2.default.sources.SILENT);
	      }
	    }
	  }]);
	
	  return Syntax;
	}(_module2.default);
	
	Syntax.DEFAULTS = {
	  highlight: function () {
	    if (window.hljs == null) return null;
	    return function (text) {
	      var result = window.hljs.highlightAuto(text);
	      return result.value;
	    };
	  }(),
	  interval: 1000
	};
	
	exports.CodeBlock = SyntaxCodeBlock;
	exports.CodeToken = CodeToken;
	exports.default = Syntax;
	
	/***/ }),
	/* 76 */
	/***/ (function(module, exports) {
	
	module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=3 x2=15 y1=9 y2=9></line> <line class=ql-stroke x1=3 x2=13 y1=14 y2=14></line> <line class=ql-stroke x1=3 x2=9 y1=4 y2=4></line> </svg>";
	
	/***/ }),
	/* 77 */
	/***/ (function(module, exports) {
	
	module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=15 x2=3 y1=9 y2=9></line> <line class=ql-stroke x1=14 x2=4 y1=14 y2=14></line> <line class=ql-stroke x1=12 x2=6 y1=4 y2=4></line> </svg>";
	
	/***/ }),
	/* 78 */
	/***/ (function(module, exports) {
	
	module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=15 x2=3 y1=9 y2=9></line> <line class=ql-stroke x1=15 x2=5 y1=14 y2=14></line> <line class=ql-stroke x1=15 x2=9 y1=4 y2=4></line> </svg>";
	
	/***/ }),
	/* 79 */
	/***/ (function(module, exports) {
	
	module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=15 x2=3 y1=9 y2=9></line> <line class=ql-stroke x1=15 x2=3 y1=14 y2=14></line> <line class=ql-stroke x1=15 x2=3 y1=4 y2=4></line> </svg>";
	
	/***/ }),
	/* 80 */
	/***/ (function(module, exports) {
	
	module.exports = "<svg viewbox=\"0 0 18 18\"> <g class=\"ql-fill ql-color-label\"> <polygon points=\"6 6.868 6 6 5 6 5 7 5.942 7 6 6.868\"></polygon> <rect height=1 width=1 x=4 y=4></rect> <polygon points=\"6.817 5 6 5 6 6 6.38 6 6.817 5\"></polygon> <rect height=1 width=1 x=2 y=6></rect> <rect height=1 width=1 x=3 y=5></rect> <rect height=1 width=1 x=4 y=7></rect> <polygon points=\"4 11.439 4 11 3 11 3 12 3.755 12 4 11.439\"></polygon> <rect height=1 width=1 x=2 y=12></rect> <rect height=1 width=1 x=2 y=9></rect> <rect height=1 width=1 x=2 y=15></rect> <polygon points=\"4.63 10 4 10 4 11 4.192 11 4.63 10\"></polygon> <rect height=1 width=1 x=3 y=8></rect> <path d=M10.832,4.2L11,4.582V4H10.708A1.948,1.948,0,0,1,10.832,4.2Z></path> <path d=M7,4.582L7.168,4.2A1.929,1.929,0,0,1,7.292,4H7V4.582Z></path> <path d=M8,13H7.683l-0.351.8a1.933,1.933,0,0,1-.124.2H8V13Z></path> <rect height=1 width=1 x=12 y=2></rect> <rect height=1 width=1 x=11 y=3></rect> <path d=M9,3H8V3.282A1.985,1.985,0,0,1,9,3Z></path> <rect height=1 width=1 x=2 y=3></rect> <rect height=1 width=1 x=6 y=2></rect> <rect height=1 width=1 x=3 y=2></rect> <rect height=1 width=1 x=5 y=3></rect> <rect height=1 width=1 x=9 y=2></rect> <rect height=1 width=1 x=15 y=14></rect> <polygon points=\"13.447 10.174 13.469 10.225 13.472 10.232 13.808 11 14 11 14 10 13.37 10 13.447 10.174\"></polygon> <rect height=1 width=1 x=13 y=7></rect> <rect height=1 width=1 x=15 y=5></rect> <rect height=1 width=1 x=14 y=6></rect> <rect height=1 width=1 x=15 y=8></rect> <rect height=1 width=1 x=14 y=9></rect> <path d=M3.775,14H3v1H4V14.314A1.97,1.97,0,0,1,3.775,14Z></path> <rect height=1 width=1 x=14 y=3></rect> <polygon points=\"12 6.868 12 6 11.62 6 12 6.868\"></polygon> <rect height=1 width=1 x=15 y=2></rect> <rect height=1 width=1 x=12 y=5></rect> <rect height=1 width=1 x=13 y=4></rect> <polygon points=\"12.933 9 13 9 13 8 12.495 8 12.933 9\"></polygon> <rect height=1 width=1 x=9 y=14></rect> <rect height=1 width=1 x=8 y=15></rect> <path d=M6,14.926V15H7V14.316A1.993,1.993,0,0,1,6,14.926Z></path> <rect height=1 width=1 x=5 y=15></rect> <path d=M10.668,13.8L10.317,13H10v1h0.792A1.947,1.947,0,0,1,10.668,13.8Z></path> <rect height=1 width=1 x=11 y=15></rect> <path d=M14.332,12.2a1.99,1.99,0,0,1,.166.8H15V12H14.245Z></path> <rect height=1 width=1 x=14 y=15></rect> <rect height=1 width=1 x=15 y=11></rect> </g> <polyline class=ql-stroke points=\"5.5 13 9 5 12.5 13\"></polyline> <line class=ql-stroke x1=11.63 x2=6.38 y1=11 y2=11></line> </svg>";
	
	/***/ }),
	/* 81 */
	/***/ (function(module, exports) {
	
	module.exports = "<svg viewbox=\"0 0 18 18\"> <rect class=\"ql-fill ql-stroke\" height=3 width=3 x=4 y=5></rect> <rect class=\"ql-fill ql-stroke\" height=3 width=3 x=11 y=5></rect> <path class=\"ql-even ql-fill ql-stroke\" d=M7,8c0,4.031-3,5-3,5></path> <path class=\"ql-even ql-fill ql-stroke\" d=M14,8c0,4.031-3,5-3,5></path> </svg>";
	
	/***/ }),
	/* 82 */
	/***/ (function(module, exports) {
	
	module.exports = "<svg viewbox=\"0 0 18 18\"> <path class=ql-stroke d=M5,4H9.5A2.5,2.5,0,0,1,12,6.5v0A2.5,2.5,0,0,1,9.5,9H5A0,0,0,0,1,5,9V4A0,0,0,0,1,5,4Z></path> <path class=ql-stroke d=M5,9h5.5A2.5,2.5,0,0,1,13,11.5v0A2.5,2.5,0,0,1,10.5,14H5a0,0,0,0,1,0,0V9A0,0,0,0,1,5,9Z></path> </svg>";
	
	/***/ }),
	/* 83 */
	/***/ (function(module, exports) {
	
	module.exports = "<svg class=\"\" viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=5 x2=13 y1=3 y2=3></line> <line class=ql-stroke x1=6 x2=9.35 y1=12 y2=3></line> <line class=ql-stroke x1=11 x2=15 y1=11 y2=15></line> <line class=ql-stroke x1=15 x2=11 y1=11 y2=15></line> <rect class=ql-fill height=1 rx=0.5 ry=0.5 width=7 x=2 y=14></rect> </svg>";
	
	/***/ }),
	/* 84 */
	/***/ (function(module, exports) {
	
	module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=\"ql-color-label ql-stroke ql-transparent\" x1=3 x2=15 y1=15 y2=15></line> <polyline class=ql-stroke points=\"5.5 11 9 3 12.5 11\"></polyline> <line class=ql-stroke x1=11.63 x2=6.38 y1=9 y2=9></line> </svg>";
	
	/***/ }),
	/* 85 */
	/***/ (function(module, exports) {
	
	module.exports = "<svg viewbox=\"0 0 18 18\"> <polygon class=\"ql-stroke ql-fill\" points=\"3 11 5 9 3 7 3 11\"></polygon> <line class=\"ql-stroke ql-fill\" x1=15 x2=11 y1=4 y2=4></line> <path class=ql-fill d=M11,3a3,3,0,0,0,0,6h1V3H11Z></path> <rect class=ql-fill height=11 width=1 x=11 y=4></rect> <rect class=ql-fill height=11 width=1 x=13 y=4></rect> </svg>";
	
	/***/ }),
	/* 86 */
	/***/ (function(module, exports) {
	
	module.exports = "<svg viewbox=\"0 0 18 18\"> <polygon class=\"ql-stroke ql-fill\" points=\"15 12 13 10 15 8 15 12\"></polygon> <line class=\"ql-stroke ql-fill\" x1=9 x2=5 y1=4 y2=4></line> <path class=ql-fill d=M5,3A3,3,0,0,0,5,9H6V3H5Z></path> <rect class=ql-fill height=11 width=1 x=5 y=4></rect> <rect class=ql-fill height=11 width=1 x=7 y=4></rect> </svg>";
	
	/***/ }),
	/* 87 */
	/***/ (function(module, exports) {
	
	module.exports = "<svg viewbox=\"0 0 18 18\"> <path class=ql-fill d=M14,16H4a1,1,0,0,1,0-2H14A1,1,0,0,1,14,16Z /> <path class=ql-fill d=M14,4H4A1,1,0,0,1,4,2H14A1,1,0,0,1,14,4Z /> <rect class=ql-fill x=3 y=6 width=12 height=6 rx=1 ry=1 /> </svg>";
	
	/***/ }),
	/* 88 */
	/***/ (function(module, exports) {
	
	module.exports = "<svg viewbox=\"0 0 18 18\"> <path class=ql-fill d=M13,16H5a1,1,0,0,1,0-2h8A1,1,0,0,1,13,16Z /> <path class=ql-fill d=M13,4H5A1,1,0,0,1,5,2h8A1,1,0,0,1,13,4Z /> <rect class=ql-fill x=2 y=6 width=14 height=6 rx=1 ry=1 /> </svg>";
	
	/***/ }),
	/* 89 */
	/***/ (function(module, exports) {
	
	module.exports = "<svg viewbox=\"0 0 18 18\"> <path class=ql-fill d=M15,8H13a1,1,0,0,1,0-2h2A1,1,0,0,1,15,8Z /> <path class=ql-fill d=M15,12H13a1,1,0,0,1,0-2h2A1,1,0,0,1,15,12Z /> <path class=ql-fill d=M15,16H5a1,1,0,0,1,0-2H15A1,1,0,0,1,15,16Z /> <path class=ql-fill d=M15,4H5A1,1,0,0,1,5,2H15A1,1,0,0,1,15,4Z /> <rect class=ql-fill x=2 y=6 width=8 height=6 rx=1 ry=1 /> </svg>";
	
	/***/ }),
	/* 90 */
	/***/ (function(module, exports) {
	
	module.exports = "<svg viewbox=\"0 0 18 18\"> <path class=ql-fill d=M5,8H3A1,1,0,0,1,3,6H5A1,1,0,0,1,5,8Z /> <path class=ql-fill d=M5,12H3a1,1,0,0,1,0-2H5A1,1,0,0,1,5,12Z /> <path class=ql-fill d=M13,16H3a1,1,0,0,1,0-2H13A1,1,0,0,1,13,16Z /> <path class=ql-fill d=M13,4H3A1,1,0,0,1,3,2H13A1,1,0,0,1,13,4Z /> <rect class=ql-fill x=8 y=6 width=8 height=6 rx=1 ry=1 transform=\"translate(24 18) rotate(-180)\"/> </svg>";
	
	/***/ }),
	/* 91 */
	/***/ (function(module, exports) {
	
	module.exports = "<svg viewbox=\"0 0 18 18\"> <path class=ql-fill d=M11.759,2.482a2.561,2.561,0,0,0-3.53.607A7.656,7.656,0,0,0,6.8,6.2C6.109,9.188,5.275,14.677,4.15,14.927a1.545,1.545,0,0,0-1.3-.933A0.922,0.922,0,0,0,2,15.036S1.954,16,4.119,16s3.091-2.691,3.7-5.553c0.177-.826.36-1.726,0.554-2.6L8.775,6.2c0.381-1.421.807-2.521,1.306-2.676a1.014,1.014,0,0,0,1.02.56A0.966,0.966,0,0,0,11.759,2.482Z></path> <rect class=ql-fill height=1.6 rx=0.8 ry=0.8 width=5 x=5.15 y=6.2></rect> <path class=ql-fill d=M13.663,12.027a1.662,1.662,0,0,1,.266-0.276q0.193,0.069.456,0.138a2.1,2.1,0,0,0,.535.069,1.075,1.075,0,0,0,.767-0.3,1.044,1.044,0,0,0,.314-0.8,0.84,0.84,0,0,0-.238-0.619,0.8,0.8,0,0,0-.594-0.239,1.154,1.154,0,0,0-.781.3,4.607,4.607,0,0,0-.781,1q-0.091.15-.218,0.346l-0.246.38c-0.068-.288-0.137-0.582-0.212-0.885-0.459-1.847-2.494-.984-2.941-0.8-0.482.2-.353,0.647-0.094,0.529a0.869,0.869,0,0,1,1.281.585c0.217,0.751.377,1.436,0.527,2.038a5.688,5.688,0,0,1-.362.467,2.69,2.69,0,0,1-.264.271q-0.221-.08-0.471-0.147a2.029,2.029,0,0,0-.522-0.066,1.079,1.079,0,0,0-.768.3A1.058,1.058,0,0,0,9,15.131a0.82,0.82,0,0,0,.832.852,1.134,1.134,0,0,0,.787-0.3,5.11,5.11,0,0,0,.776-0.993q0.141-.219.215-0.34c0.046-.076.122-0.194,0.223-0.346a2.786,2.786,0,0,0,.918,1.726,2.582,2.582,0,0,0,2.376-.185c0.317-.181.212-0.565,0-0.494A0.807,0.807,0,0,1,14.176,15a5.159,5.159,0,0,1-.913-2.446l0,0Q13.487,12.24,13.663,12.027Z></path> </svg>";
	
	/***/ }),
	/* 92 */
	/***/ (function(module, exports) {
	
	module.exports = "<svg viewBox=\"0 0 18 18\"> <path class=ql-fill d=M10,4V14a1,1,0,0,1-2,0V10H3v4a1,1,0,0,1-2,0V4A1,1,0,0,1,3,4V8H8V4a1,1,0,0,1,2,0Zm6.06787,9.209H14.98975V7.59863a.54085.54085,0,0,0-.605-.60547h-.62744a1.01119,1.01119,0,0,0-.748.29688L11.645,8.56641a.5435.5435,0,0,0-.022.8584l.28613.30762a.53861.53861,0,0,0,.84717.0332l.09912-.08789a1.2137,1.2137,0,0,0,.2417-.35254h.02246s-.01123.30859-.01123.60547V13.209H12.041a.54085.54085,0,0,0-.605.60547v.43945a.54085.54085,0,0,0,.605.60547h4.02686a.54085.54085,0,0,0,.605-.60547v-.43945A.54085.54085,0,0,0,16.06787,13.209Z /> </svg>";
	
	/***/ }),
	/* 93 */
	/***/ (function(module, exports) {
	
	module.exports = "<svg viewBox=\"0 0 18 18\"> <path class=ql-fill d=M16.73975,13.81445v.43945a.54085.54085,0,0,1-.605.60547H11.855a.58392.58392,0,0,1-.64893-.60547V14.0127c0-2.90527,3.39941-3.42187,3.39941-4.55469a.77675.77675,0,0,0-.84717-.78125,1.17684,1.17684,0,0,0-.83594.38477c-.2749.26367-.561.374-.85791.13184l-.4292-.34082c-.30811-.24219-.38525-.51758-.1543-.81445a2.97155,2.97155,0,0,1,2.45361-1.17676,2.45393,2.45393,0,0,1,2.68408,2.40918c0,2.45312-3.1792,2.92676-3.27832,3.93848h2.79443A.54085.54085,0,0,1,16.73975,13.81445ZM9,3A.99974.99974,0,0,0,8,4V8H3V4A1,1,0,0,0,1,4V14a1,1,0,0,0,2,0V10H8v4a1,1,0,0,0,2,0V4A.99974.99974,0,0,0,9,3Z /> </svg>";
	
	/***/ }),
	/* 94 */
	/***/ (function(module, exports) {
	
	module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=7 x2=13 y1=4 y2=4></line> <line class=ql-stroke x1=5 x2=11 y1=14 y2=14></line> <line class=ql-stroke x1=8 x2=10 y1=14 y2=4></line> </svg>";
	
	/***/ }),
	/* 95 */
	/***/ (function(module, exports) {
	
	module.exports = "<svg viewbox=\"0 0 18 18\"> <rect class=ql-stroke height=10 width=12 x=3 y=4></rect> <circle class=ql-fill cx=6 cy=7 r=1></circle> <polyline class=\"ql-even ql-fill\" points=\"5 12 5 11 7 9 8 10 11 7 13 9 13 12 5 12\"></polyline> </svg>";
	
	/***/ }),
	/* 96 */
	/***/ (function(module, exports) {
	
	module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=3 x2=15 y1=14 y2=14></line> <line class=ql-stroke x1=3 x2=15 y1=4 y2=4></line> <line class=ql-stroke x1=9 x2=15 y1=9 y2=9></line> <polyline class=\"ql-fill ql-stroke\" points=\"3 7 3 11 5 9 3 7\"></polyline> </svg>";
	
	/***/ }),
	/* 97 */
	/***/ (function(module, exports) {
	
	module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=3 x2=15 y1=14 y2=14></line> <line class=ql-stroke x1=3 x2=15 y1=4 y2=4></line> <line class=ql-stroke x1=9 x2=15 y1=9 y2=9></line> <polyline class=ql-stroke points=\"5 7 5 11 3 9 5 7\"></polyline> </svg>";
	
	/***/ }),
	/* 98 */
	/***/ (function(module, exports) {
	
	module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=7 x2=11 y1=7 y2=11></line> <path class=\"ql-even ql-stroke\" d=M8.9,4.577a3.476,3.476,0,0,1,.36,4.679A3.476,3.476,0,0,1,4.577,8.9C3.185,7.5,2.035,6.4,4.217,4.217S7.5,3.185,8.9,4.577Z></path> <path class=\"ql-even ql-stroke\" d=M13.423,9.1a3.476,3.476,0,0,0-4.679-.36,3.476,3.476,0,0,0,.36,4.679c1.392,1.392,2.5,2.542,4.679.36S14.815,10.5,13.423,9.1Z></path> </svg>";
	
	/***/ }),
	/* 99 */
	/***/ (function(module, exports) {
	
	module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=7 x2=15 y1=4 y2=4></line> <line class=ql-stroke x1=7 x2=15 y1=9 y2=9></line> <line class=ql-stroke x1=7 x2=15 y1=14 y2=14></line> <line class=\"ql-stroke ql-thin\" x1=2.5 x2=4.5 y1=5.5 y2=5.5></line> <path class=ql-fill d=M3.5,6A0.5,0.5,0,0,1,3,5.5V3.085l-0.276.138A0.5,0.5,0,0,1,2.053,3c-0.124-.247-0.023-0.324.224-0.447l1-.5A0.5,0.5,0,0,1,4,2.5v3A0.5,0.5,0,0,1,3.5,6Z></path> <path class=\"ql-stroke ql-thin\" d=M4.5,10.5h-2c0-.234,1.85-1.076,1.85-2.234A0.959,0.959,0,0,0,2.5,8.156></path> <path class=\"ql-stroke ql-thin\" d=M2.5,14.846a0.959,0.959,0,0,0,1.85-.109A0.7,0.7,0,0,0,3.75,14a0.688,0.688,0,0,0,.6-0.736,0.959,0.959,0,0,0-1.85-.109></path> </svg>";
	
	/***/ }),
	/* 100 */
	/***/ (function(module, exports) {
	
	module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=6 x2=15 y1=4 y2=4></line> <line class=ql-stroke x1=6 x2=15 y1=9 y2=9></line> <line class=ql-stroke x1=6 x2=15 y1=14 y2=14></line> <line class=ql-stroke x1=3 x2=3 y1=4 y2=4></line> <line class=ql-stroke x1=3 x2=3 y1=9 y2=9></line> <line class=ql-stroke x1=3 x2=3 y1=14 y2=14></line> </svg>";
	
	/***/ }),
	/* 101 */
	/***/ (function(module, exports) {
	
	module.exports = "<svg class=\"\" viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=9 x2=15 y1=4 y2=4></line> <polyline class=ql-stroke points=\"3 4 4 5 6 3\"></polyline> <line class=ql-stroke x1=9 x2=15 y1=14 y2=14></line> <polyline class=ql-stroke points=\"3 14 4 15 6 13\"></polyline> <line class=ql-stroke x1=9 x2=15 y1=9 y2=9></line> <polyline class=ql-stroke points=\"3 9 4 10 6 8\"></polyline> </svg>";
	
	/***/ }),
	/* 102 */
	/***/ (function(module, exports) {
	
	module.exports = "<svg viewbox=\"0 0 18 18\"> <path class=ql-fill d=M15.5,15H13.861a3.858,3.858,0,0,0,1.914-2.975,1.8,1.8,0,0,0-1.6-1.751A1.921,1.921,0,0,0,12.021,11.7a0.50013,0.50013,0,1,0,.957.291h0a0.914,0.914,0,0,1,1.053-.725,0.81,0.81,0,0,1,.744.762c0,1.076-1.16971,1.86982-1.93971,2.43082A1.45639,1.45639,0,0,0,12,15.5a0.5,0.5,0,0,0,.5.5h3A0.5,0.5,0,0,0,15.5,15Z /> <path class=ql-fill d=M9.65,5.241a1,1,0,0,0-1.409.108L6,7.964,3.759,5.349A1,1,0,0,0,2.192,6.59178Q2.21541,6.6213,2.241,6.649L4.684,9.5,2.241,12.35A1,1,0,0,0,3.71,13.70722q0.02557-.02768.049-0.05722L6,11.036,8.241,13.65a1,1,0,1,0,1.567-1.24277Q9.78459,12.3777,9.759,12.35L7.316,9.5,9.759,6.651A1,1,0,0,0,9.65,5.241Z /> </svg>";
	
	/***/ }),
	/* 103 */
	/***/ (function(module, exports) {
	
	module.exports = "<svg viewbox=\"0 0 18 18\"> <path class=ql-fill d=M15.5,7H13.861a4.015,4.015,0,0,0,1.914-2.975,1.8,1.8,0,0,0-1.6-1.751A1.922,1.922,0,0,0,12.021,3.7a0.5,0.5,0,1,0,.957.291,0.917,0.917,0,0,1,1.053-.725,0.81,0.81,0,0,1,.744.762c0,1.077-1.164,1.925-1.934,2.486A1.423,1.423,0,0,0,12,7.5a0.5,0.5,0,0,0,.5.5h3A0.5,0.5,0,0,0,15.5,7Z /> <path class=ql-fill d=M9.651,5.241a1,1,0,0,0-1.41.108L6,7.964,3.759,5.349a1,1,0,1,0-1.519,1.3L4.683,9.5,2.241,12.35a1,1,0,1,0,1.519,1.3L6,11.036,8.241,13.65a1,1,0,0,0,1.519-1.3L7.317,9.5,9.759,6.651A1,1,0,0,0,9.651,5.241Z /> </svg>";
	
	/***/ }),
	/* 104 */
	/***/ (function(module, exports) {
	
	module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=\"ql-stroke ql-thin\" x1=15.5 x2=2.5 y1=8.5 y2=9.5></line> <path class=ql-fill d=M9.007,8C6.542,7.791,6,7.519,6,6.5,6,5.792,7.283,5,9,5c1.571,0,2.765.679,2.969,1.309a1,1,0,0,0,1.9-.617C13.356,4.106,11.354,3,9,3,6.2,3,4,4.538,4,6.5a3.2,3.2,0,0,0,.5,1.843Z></path> <path class=ql-fill d=M8.984,10C11.457,10.208,12,10.479,12,11.5c0,0.708-1.283,1.5-3,1.5-1.571,0-2.765-.679-2.969-1.309a1,1,0,1,0-1.9.617C4.644,13.894,6.646,15,9,15c2.8,0,5-1.538,5-3.5a3.2,3.2,0,0,0-.5-1.843Z></path> </svg>";
	
	/***/ }),
	/* 105 */
	/***/ (function(module, exports) {
	
	module.exports = "<svg viewbox=\"0 0 18 18\"> <path class=ql-stroke d=M5,3V9a4.012,4.012,0,0,0,4,4H9a4.012,4.012,0,0,0,4-4V3></path> <rect class=ql-fill height=1 rx=0.5 ry=0.5 width=12 x=3 y=15></rect> </svg>";
	
	/***/ }),
	/* 106 */
	/***/ (function(module, exports) {
	
	module.exports = "<svg viewbox=\"0 0 18 18\"> <rect class=ql-stroke height=12 width=12 x=3 y=3></rect> <rect class=ql-fill height=12 width=1 x=5 y=3></rect> <rect class=ql-fill height=12 width=1 x=12 y=3></rect> <rect class=ql-fill height=2 width=8 x=5 y=8></rect> <rect class=ql-fill height=1 width=3 x=3 y=5></rect> <rect class=ql-fill height=1 width=3 x=3 y=7></rect> <rect class=ql-fill height=1 width=3 x=3 y=10></rect> <rect class=ql-fill height=1 width=3 x=3 y=12></rect> <rect class=ql-fill height=1 width=3 x=12 y=5></rect> <rect class=ql-fill height=1 width=3 x=12 y=7></rect> <rect class=ql-fill height=1 width=3 x=12 y=10></rect> <rect class=ql-fill height=1 width=3 x=12 y=12></rect> </svg>";
	
	/***/ }),
	/* 107 */
	/***/ (function(module, exports) {
	
	module.exports = "<svg viewbox=\"0 0 18 18\"> <polygon class=ql-stroke points=\"7 11 9 13 11 11 7 11\"></polygon> <polygon class=ql-stroke points=\"7 7 9 5 11 7 7 7\"></polygon> </svg>";
	
	/***/ }),
	/* 108 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.BubbleTooltip = undefined;
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _extend = __webpack_require__(3);
	
	var _extend2 = _interopRequireDefault(_extend);
	
	var _emitter = __webpack_require__(8);
	
	var _emitter2 = _interopRequireDefault(_emitter);
	
	var _base = __webpack_require__(43);
	
	var _base2 = _interopRequireDefault(_base);
	
	var _selection = __webpack_require__(15);
	
	var _icons = __webpack_require__(41);
	
	var _icons2 = _interopRequireDefault(_icons);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TOOLBAR_CONFIG = [['bold', 'italic', 'link'], [{ header: 1 }, { header: 2 }, 'blockquote']];
	
	var BubbleTheme = function (_BaseTheme) {
	  _inherits(BubbleTheme, _BaseTheme);
	
	  function BubbleTheme(quill, options) {
	    _classCallCheck(this, BubbleTheme);
	
	    if (options.modules.toolbar != null && options.modules.toolbar.container == null) {
	      options.modules.toolbar.container = TOOLBAR_CONFIG;
	    }
	
	    var _this = _possibleConstructorReturn(this, (BubbleTheme.__proto__ || Object.getPrototypeOf(BubbleTheme)).call(this, quill, options));
	
	    _this.quill.container.classList.add('ql-bubble');
	    return _this;
	  }
	
	  _createClass(BubbleTheme, [{
	    key: 'extendToolbar',
	    value: function extendToolbar(toolbar) {
	      this.tooltip = new BubbleTooltip(this.quill, this.options.bounds);
	      this.tooltip.root.appendChild(toolbar.container);
	      this.buildButtons([].slice.call(toolbar.container.querySelectorAll('button')), _icons2.default);
	      this.buildPickers([].slice.call(toolbar.container.querySelectorAll('select')), _icons2.default);
	    }
	  }]);
	
	  return BubbleTheme;
	}(_base2.default);
	
	BubbleTheme.DEFAULTS = (0, _extend2.default)(true, {}, _base2.default.DEFAULTS, {
	  modules: {
	    toolbar: {
	      handlers: {
	        link: function link(value) {
	          if (!value) {
	            this.quill.format('link', false);
	          } else {
	            this.quill.theme.tooltip.edit();
	          }
	        }
	      }
	    }
	  }
	});
	
	var BubbleTooltip = function (_BaseTooltip) {
	  _inherits(BubbleTooltip, _BaseTooltip);
	
	  function BubbleTooltip(quill, bounds) {
	    _classCallCheck(this, BubbleTooltip);
	
	    var _this2 = _possibleConstructorReturn(this, (BubbleTooltip.__proto__ || Object.getPrototypeOf(BubbleTooltip)).call(this, quill, bounds));
	
	    _this2.quill.on(_emitter2.default.events.EDITOR_CHANGE, function (type, range, oldRange, source) {
	      if (type !== _emitter2.default.events.SELECTION_CHANGE) return;
	      if (range != null && range.length > 0 && source === _emitter2.default.sources.USER) {
	        _this2.show();
	        // Lock our width so we will expand beyond our offsetParent boundaries
	        _this2.root.style.left = '0px';
	        _this2.root.style.width = '';
	        _this2.root.style.width = _this2.root.offsetWidth + 'px';
	        var lines = _this2.quill.getLines(range.index, range.length);
	        if (lines.length === 1) {
	          _this2.position(_this2.quill.getBounds(range));
	        } else {
	          var lastLine = lines[lines.length - 1];
	          var index = _this2.quill.getIndex(lastLine);
	          var length = Math.min(lastLine.length() - 1, range.index + range.length - index);
	          var _bounds = _this2.quill.getBounds(new _selection.Range(index, length));
	          _this2.position(_bounds);
	        }
	      } else if (document.activeElement !== _this2.textbox && _this2.quill.hasFocus()) {
	        _this2.hide();
	      }
	    });
	    return _this2;
	  }
	
	  _createClass(BubbleTooltip, [{
	    key: 'listen',
	    value: function listen() {
	      var _this3 = this;
	
	      _get(BubbleTooltip.prototype.__proto__ || Object.getPrototypeOf(BubbleTooltip.prototype), 'listen', this).call(this);
	      this.root.querySelector('.ql-close').addEventListener('click', function () {
	        _this3.root.classList.remove('ql-editing');
	      });
	      this.quill.on(_emitter2.default.events.SCROLL_OPTIMIZE, function () {
	        // Let selection be restored by toolbar handlers before repositioning
	        setTimeout(function () {
	          if (_this3.root.classList.contains('ql-hidden')) return;
	          var range = _this3.quill.getSelection();
	          if (range != null) {
	            _this3.position(_this3.quill.getBounds(range));
	          }
	        }, 1);
	      });
	    }
	  }, {
	    key: 'cancel',
	    value: function cancel() {
	      this.show();
	    }
	  }, {
	    key: 'position',
	    value: function position(reference) {
	      var shift = _get(BubbleTooltip.prototype.__proto__ || Object.getPrototypeOf(BubbleTooltip.prototype), 'position', this).call(this, reference);
	      var arrow = this.root.querySelector('.ql-tooltip-arrow');
	      arrow.style.marginLeft = '';
	      if (shift === 0) return shift;
	      arrow.style.marginLeft = -1 * shift - arrow.offsetWidth / 2 + 'px';
	    }
	  }]);
	
	  return BubbleTooltip;
	}(_base.BaseTooltip);
	
	BubbleTooltip.TEMPLATE = ['<span class="ql-tooltip-arrow"></span>', '<div class="ql-tooltip-editor">', '<input type="text" data-formula="e=mc^2" data-link="https://quilljs.com" data-video="Embed URL">', '<a class="ql-close"></a>', '</div>'].join('');
	
	exports.BubbleTooltip = BubbleTooltip;
	exports.default = BubbleTheme;
	
	/***/ }),
	/* 109 */
	/***/ (function(module, exports, __webpack_require__) {
	
	module.exports = __webpack_require__(63);
	
	
	/***/ })
	/******/ ])["default"];
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1568).Buffer))

/***/ }),
/* 2172 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(300);
	var ReactDOM = __webpack_require__(332);
	var createClass = __webpack_require__(2173);
	var QuillMixin = __webpack_require__(2177);
	var find = __webpack_require__(1400);
	var some = __webpack_require__(2178);
	var isEqual = __webpack_require__(924);
	var T = __webpack_require__(956);
	var DOM = __webpack_require__(2180);
	
	var QuillComponent = createClass({
	
		displayName: 'Quill',
	
		mixins: [ QuillMixin ],
	
		propTypes: {
			id: T.string,
			className: T.string,
			theme: T.string,
			style: T.object,
			readOnly: T.bool,
			value: T.oneOfType([T.string, T.shape({ops: T.array})]),
			defaultValue: T.oneOfType([T.string, T.shape({ops: T.array})]),
			placeholder: T.string,
			tabIndex: T.number,
			bounds: T.oneOfType([T.string, T.element]),
			onChange: T.func,
			onChangeSelection: T.func,
			onFocus: T.func,
			onBlur: T.func,
			onKeyPress: T.func,
			onKeyDown: T.func,
			onKeyUp: T.func,
	
			modules: function(props) {
				var isNotObject = T.object.apply(this, arguments);
				if (isNotObject) return isNotObject;
	
				if (
					props.modules && 
					props.modules.toolbar &&
					props.modules.toolbar[0] &&
					props.modules.toolbar[0].type
				) return new Error(
					'Since v1.0.0, React Quill will not create a custom toolbar for you ' +
					'anymore. Create a toolbar explictly, or let Quill create one. ' +
					'See: https://github.com/zenoamaro/react-quill#upgrading-to-react-quill-v100'
				);
			},
	
			toolbar: function(props) {
				if ('toolbar' in props) return new Error(
					'The `toolbar` prop has been deprecated. Use `modules.toolbar` instead. ' +
					'See: https://github.com/zenoamaro/react-quill#upgrading-to-react-quill-v100'
				);
			},
	
			formats: function(props) {
				var isNotArrayOfString = T.arrayOf(T.string).apply(this, arguments);
	
				if (isNotArrayOfString) return new Error(
					'You cannot specify custom `formats` anymore. Use Parchment instead.  ' +
					'See: https://github.com/zenoamaro/react-quill#upgrading-to-react-quill-v100.'
				);
			},
	
			styles: function(props) {
				if ('styles' in props) return new Error(
					'The `styles` prop has been deprecated. Use custom stylesheets instead. ' +
					'See: https://github.com/zenoamaro/react-quill#upgrading-to-react-quill-v100.'
				);
			},
	
			pollInterval: function(props) {
				if ('pollInterval' in props) return new Error(
					'The `pollInterval` property does not have any effect anymore. ' +
					'You can safely remove it from your props.' +
					'See: https://github.com/zenoamaro/react-quill#upgrading-to-react-quill-v100.'
				);
			},
	
			children: function(props) {
				// Validate that the editor has only one child element and it is not a <textarea>
				var isNotASingleElement = T.element.apply(this, arguments);
				if (isNotASingleElement) return new Error(
					'The Quill editing area can only be composed of a single React element.'
				);
	
				if (React.Children.count(props.children)) {
					var child = React.Children.only(props.children);
					if (child.type === 'textarea') return new Error(
						'Quill does not support editing on a <textarea>. Use a <div> instead.'
					);
				}
			}
		},
			
		/*
		Changing one of these props should cause a full re-render.
		*/
		dirtyProps: [
			'modules',
			'formats',
			'bounds',
			'theme',
			'children',
		],
	
		/*
		Changing one of these props should cause a regular update.
		*/
		cleanProps: [
			'id',
			'className',
			'style',
			'placeholder',
			'tabIndex',
			'onChange',
			'onChangeSelection',
			'onFocus',
			'onBlur',
			'onKeyPress',
			'onKeyDown',
			'onKeyUp',
		],
	
		getDefaultProps: function() {
			return {
				theme: 'snow',
				modules: {},
			};
		},
	
		/*
		We consider the component to be controlled if `value` is being sent in props.
		*/
		isControlled: function() {
			return 'value' in this.props;
		},
	
		getInitialState: function() {
			return {
				generation: 0,
				value: this.isControlled()
					? this.props.value
					: this.props.defaultValue
			};
		},
	
		componentWillReceiveProps: function(nextProps, nextState) {
			var editor = this.editor;
	
			// If the component is unmounted and mounted too quickly
			// an error is thrown in setEditorContents since editor is
			// still undefined. Must check if editor is undefined
			// before performing this call.
			if (!editor) return;
			
			// Update only if we've been passed a new `value`.
			// This leaves components using `defaultValue` alone.
			if ('value' in nextProps) {
				var currentContents = this.getEditorContents();
				var nextContents = nextProps.value;
	
				if (nextContents === this.lastDeltaChangeSet) throw new Error(
					'You are passing the `delta` object from the `onChange` event back ' +
					'as `value`. You most probably want `editor.getContents()` instead. ' +
					'See: https://github.com/zenoamaro/react-quill#using-deltas'
				);
	
				// NOTE: Seeing that Quill is missing a way to prevent
				//       edits, we have to settle for a hybrid between
				//       controlled and uncontrolled mode. We can't prevent
				//       the change, but we'll still override content
				//       whenever `value` differs from current state.
				// NOTE: Comparing an HTML string and a Quill Delta will always trigger 
				//       a change, regardless of whether they represent the same document.
				if (!this.isEqualValue(nextContents, currentContents)) {
					this.setEditorContents(editor, nextContents);
				}
			}
			
			// We can update readOnly state in-place.
			if ('readOnly' in nextProps) {
				if (nextProps.readOnly !== this.props.readOnly) {
					this.setEditorReadOnly(editor, nextProps.readOnly);
				}
			}
	
			// If we need to regenerate the component, we can avoid a detailed
			// in-place update step, and just let everything rerender.
			if (this.shouldComponentRegenerate(nextProps, nextState)) {
				return this.regenerate();
			}
		},
	
		componentDidMount: function() {
			this.editor = this.createEditor(
				this.getEditingArea(),
				this.getEditorConfig()
			);
			// Restore editor from Quill's native formats in regeneration scenario
			if (this.quillDelta) {
				this.editor.setContents(this.quillDelta);
				this.editor.setSelection(this.quillSelection);		
				this.editor.focus();
				this.quillDelta = this.quillSelection = null;
				return;
			}
			if (this.state.value) {
				this.setEditorContents(this.editor, this.state.value);
				return;
			}
		},
	
		componentWillUnmount: function() {
			var editor; if ((editor = this.getEditor())) {
				this.unhookEditor(editor);
				this.editor = null;
			}
		},
	
		shouldComponentUpdate: function(nextProps, nextState) {
			var self = this;
	
			// If the component has been regenerated, we already know we should update.
			if (this.state.generation !== nextState.generation) {
				return true;
			}
			
			// Compare props that require React updating the DOM.
			return some(this.cleanProps, function(prop) {
				// Note that `isEqual` compares deeply, making it safe to perform
				// non-immutable updates, at the cost of performance.
				return !isEqual(nextProps[prop], self.props[prop]);
			});
		},
	
		shouldComponentRegenerate: function(nextProps, nextState) {
			var self = this;
			// Whenever a `dirtyProp` changes, the editor needs reinstantiation.
			return some(this.dirtyProps, function(prop) {
				// Note that `isEqual` compares deeply, making it safe to perform
				// non-immutable updates, at the cost of performance.
				return !isEqual(nextProps[prop], self.props[prop]);
			});
		},
	
		/*
		If we could not update settings from the new props in-place, we have to tear
		down everything and re-render from scratch.
		*/
		componentWillUpdate: function(nextProps, nextState) {
			if (this.state.generation !== nextState.generation) {
				this.componentWillUnmount();
			}
		},
	
		componentDidUpdate: function(prevProps, prevState) {
			if (this.state.generation !== prevState.generation) {
				this.componentDidMount();
			}
		},
	
		getEditorConfig: function() {
			return {
				bounds:       this.props.bounds,
				formats:      this.props.formats,
				modules:      this.props.modules,
				placeholder:  this.props.placeholder,
				readOnly:     this.props.readOnly,
	      			scrollingContainer: this.props.scrollingContainer,
				tabIndex:     this.props.tabIndex,
				theme:        this.props.theme,
			};
		},
	
		getEditor: function() {
			return this.editor;
		},
	
		getEditingArea: function () {
			return ReactDOM.findDOMNode(this.editingArea);
		},
	
		getEditorContents: function() {
			return this.state.value;
		},
	
		getEditorSelection: function() {
			return this.state.selection;
		},
	
		/*
		True if the value is a Delta instance or a Delta look-alike.
		*/
		isDelta: function(value) {
			return value && value.ops;
		},
	
		/*
		Special comparison function that knows how to compare Deltas.
		*/
		isEqualValue: function(value, nextValue) {
			if (this.isDelta(value) && this.isDelta(nextValue)) {
				return isEqual(value.ops, nextValue.ops);
			} else {
				return isEqual(value, nextValue);
			}
		},
	
		/*
		Regenerating the editor will cause the whole tree, including the container,
		to be cleaned up and re-rendered from scratch.
		*/
		regenerate: function() {
			// Cache selection and contents in Quill's native format to be restored later
			this.quillDelta = this.editor.getContents();
			this.quillSelection = this.editor.getSelection();
			this.setState({
				generation: this.state.generation + 1,
			});
		},
	
		/*
		Renders an editor area, unless it has been provided one to clone.
		*/
		renderEditingArea: function() {
			var self = this;
			var children = this.props.children;
	
			var properties = {
				key: this.state.generation,
				tabIndex: this.props.tabIndex,
				ref: function(element) { self.editingArea = element },
			};
	
			var customElement = React.Children.count(children)
				? React.Children.only(children)
				: null;
	
			var editingArea = customElement
				? React.cloneElement(customElement, properties)
				: DOM.div(properties);
	
			return editingArea;
		},
	
		render: function() {
			return DOM.div({
				id: this.props.id,
				style: this.props.style,
				key: this.state.generation,
				className: ['quill'].concat(this.props.className).join(' '),
				onKeyPress: this.props.onKeyPress,
				onKeyDown: this.props.onKeyDown,
				onKeyUp: this.props.onKeyUp },
				this.renderEditingArea()
			);
		},
	
		onEditorChangeText: function(value, delta, source, editor) {
			var currentContents = this.getEditorContents();
	
			// We keep storing the same type of value as what the user gives us,
			// so that value comparisons will be more stable and predictable.
			var nextContents = this.isDelta(currentContents)
				? editor.getContents()
				: editor.getHTML();
			
			if (!this.isEqualValue(nextContents, currentContents)) {
				// Taint this `delta` object, so we can recognize whether the user
				// is trying to send it back as `value`, preventing a likely loop.
				this.lastDeltaChangeSet = delta;
	
				this.setState({ value: nextContents });
	
				if (this.props.onChange) {
					this.props.onChange(value, delta, source, editor);
				}
			}
		},
	
		onEditorChangeSelection: function(nextSelection, source, editor) {
			var currentSelection = this.getEditorSelection();
			var hasGainedFocus = !currentSelection && nextSelection;
			var hasLostFocus = currentSelection && !nextSelection;
	
			if (isEqual(nextSelection, currentSelection)) {
				return;
			}
			
			this.setState({ selection: nextSelection });
			
			if (this.props.onChangeSelection) {
				this.props.onChangeSelection(nextSelection, source, editor);
			}
	
			if (hasGainedFocus && this.props.onFocus) {
				this.props.onFocus(nextSelection, source, editor);
			} else if (hasLostFocus && this.props.onBlur) {
				this.props.onBlur(currentSelection, source, editor);
			}
		},
	
		focus: function() {
			this.editor.focus();
		},
	
		blur: function() {
			this.setEditorSelection(this.editor, null);
		}
	
	});
	
	module.exports = QuillComponent;


/***/ }),
/* 2173 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var React = __webpack_require__(300);
	var factory = __webpack_require__(2174);
	
	if (typeof React === 'undefined') {
	  throw Error(
	    'create-react-class could not find the React object. If you are using script tags, ' +
	      'make sure that React is being loaded before create-react-class.'
	  );
	}
	
	// Hack to grab NoopUpdateQueue from isomorphic React
	var ReactNoopUpdateQueue = new React.Component().updater;
	
	module.exports = factory(
	  React.Component,
	  React.isValidElement,
	  ReactNoopUpdateQueue
	);


/***/ }),
/* 2174 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(302);
	
	var emptyObject = __webpack_require__(2175);
	var _invariant = __webpack_require__(2176);
	
	if (false) {
	  var warning = require('fbjs/lib/warning');
	}
	
	var MIXINS_KEY = 'mixins';
	
	// Helper function to allow the creation of anonymous functions which do not
	// have .name set to the name of the variable being assigned to.
	function identity(fn) {
	  return fn;
	}
	
	var ReactPropTypeLocationNames;
	if (false) {
	  ReactPropTypeLocationNames = {
	    prop: 'prop',
	    context: 'context',
	    childContext: 'child context'
	  };
	} else {
	  ReactPropTypeLocationNames = {};
	}
	
	function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
	  /**
	   * Policies that describe methods in `ReactClassInterface`.
	   */
	
	  var injectedMixins = [];
	
	  /**
	   * Composite components are higher-level components that compose other composite
	   * or host components.
	   *
	   * To create a new type of `ReactClass`, pass a specification of
	   * your new class to `React.createClass`. The only requirement of your class
	   * specification is that you implement a `render` method.
	   *
	   *   var MyComponent = React.createClass({
	   *     render: function() {
	   *       return <div>Hello World</div>;
	   *     }
	   *   });
	   *
	   * The class specification supports a specific protocol of methods that have
	   * special meaning (e.g. `render`). See `ReactClassInterface` for
	   * more the comprehensive protocol. Any other properties and methods in the
	   * class specification will be available on the prototype.
	   *
	   * @interface ReactClassInterface
	   * @internal
	   */
	  var ReactClassInterface = {
	    /**
	     * An array of Mixin objects to include when defining your component.
	     *
	     * @type {array}
	     * @optional
	     */
	    mixins: 'DEFINE_MANY',
	
	    /**
	     * An object containing properties and methods that should be defined on
	     * the component's constructor instead of its prototype (static methods).
	     *
	     * @type {object}
	     * @optional
	     */
	    statics: 'DEFINE_MANY',
	
	    /**
	     * Definition of prop types for this component.
	     *
	     * @type {object}
	     * @optional
	     */
	    propTypes: 'DEFINE_MANY',
	
	    /**
	     * Definition of context types for this component.
	     *
	     * @type {object}
	     * @optional
	     */
	    contextTypes: 'DEFINE_MANY',
	
	    /**
	     * Definition of context types this component sets for its children.
	     *
	     * @type {object}
	     * @optional
	     */
	    childContextTypes: 'DEFINE_MANY',
	
	    // ==== Definition methods ====
	
	    /**
	     * Invoked when the component is mounted. Values in the mapping will be set on
	     * `this.props` if that prop is not specified (i.e. using an `in` check).
	     *
	     * This method is invoked before `getInitialState` and therefore cannot rely
	     * on `this.state` or use `this.setState`.
	     *
	     * @return {object}
	     * @optional
	     */
	    getDefaultProps: 'DEFINE_MANY_MERGED',
	
	    /**
	     * Invoked once before the component is mounted. The return value will be used
	     * as the initial value of `this.state`.
	     *
	     *   getInitialState: function() {
	     *     return {
	     *       isOn: false,
	     *       fooBaz: new BazFoo()
	     *     }
	     *   }
	     *
	     * @return {object}
	     * @optional
	     */
	    getInitialState: 'DEFINE_MANY_MERGED',
	
	    /**
	     * @return {object}
	     * @optional
	     */
	    getChildContext: 'DEFINE_MANY_MERGED',
	
	    /**
	     * Uses props from `this.props` and state from `this.state` to render the
	     * structure of the component.
	     *
	     * No guarantees are made about when or how often this method is invoked, so
	     * it must not have side effects.
	     *
	     *   render: function() {
	     *     var name = this.props.name;
	     *     return <div>Hello, {name}!</div>;
	     *   }
	     *
	     * @return {ReactComponent}
	     * @required
	     */
	    render: 'DEFINE_ONCE',
	
	    // ==== Delegate methods ====
	
	    /**
	     * Invoked when the component is initially created and about to be mounted.
	     * This may have side effects, but any external subscriptions or data created
	     * by this method must be cleaned up in `componentWillUnmount`.
	     *
	     * @optional
	     */
	    componentWillMount: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component has been mounted and has a DOM representation.
	     * However, there is no guarantee that the DOM node is in the document.
	     *
	     * Use this as an opportunity to operate on the DOM when the component has
	     * been mounted (initialized and rendered) for the first time.
	     *
	     * @param {DOMElement} rootNode DOM element representing the component.
	     * @optional
	     */
	    componentDidMount: 'DEFINE_MANY',
	
	    /**
	     * Invoked before the component receives new props.
	     *
	     * Use this as an opportunity to react to a prop transition by updating the
	     * state using `this.setState`. Current props are accessed via `this.props`.
	     *
	     *   componentWillReceiveProps: function(nextProps, nextContext) {
	     *     this.setState({
	     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
	     *     });
	     *   }
	     *
	     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
	     * transition may cause a state change, but the opposite is not true. If you
	     * need it, you are probably looking for `componentWillUpdate`.
	     *
	     * @param {object} nextProps
	     * @optional
	     */
	    componentWillReceiveProps: 'DEFINE_MANY',
	
	    /**
	     * Invoked while deciding if the component should be updated as a result of
	     * receiving new props, state and/or context.
	     *
	     * Use this as an opportunity to `return false` when you're certain that the
	     * transition to the new props/state/context will not require a component
	     * update.
	     *
	     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
	     *     return !equal(nextProps, this.props) ||
	     *       !equal(nextState, this.state) ||
	     *       !equal(nextContext, this.context);
	     *   }
	     *
	     * @param {object} nextProps
	     * @param {?object} nextState
	     * @param {?object} nextContext
	     * @return {boolean} True if the component should update.
	     * @optional
	     */
	    shouldComponentUpdate: 'DEFINE_ONCE',
	
	    /**
	     * Invoked when the component is about to update due to a transition from
	     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
	     * and `nextContext`.
	     *
	     * Use this as an opportunity to perform preparation before an update occurs.
	     *
	     * NOTE: You **cannot** use `this.setState()` in this method.
	     *
	     * @param {object} nextProps
	     * @param {?object} nextState
	     * @param {?object} nextContext
	     * @param {ReactReconcileTransaction} transaction
	     * @optional
	     */
	    componentWillUpdate: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component's DOM representation has been updated.
	     *
	     * Use this as an opportunity to operate on the DOM when the component has
	     * been updated.
	     *
	     * @param {object} prevProps
	     * @param {?object} prevState
	     * @param {?object} prevContext
	     * @param {DOMElement} rootNode DOM element representing the component.
	     * @optional
	     */
	    componentDidUpdate: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component is about to be removed from its parent and have
	     * its DOM representation destroyed.
	     *
	     * Use this as an opportunity to deallocate any external resources.
	     *
	     * NOTE: There is no `componentDidUnmount` since your component will have been
	     * destroyed by that point.
	     *
	     * @optional
	     */
	    componentWillUnmount: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillMount`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillMount: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillReceiveProps`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillReceiveProps: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillUpdate`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillUpdate: 'DEFINE_MANY',
	
	    // ==== Advanced methods ====
	
	    /**
	     * Updates the component's currently mounted DOM representation.
	     *
	     * By default, this implements React's rendering and reconciliation algorithm.
	     * Sophisticated clients may wish to override this.
	     *
	     * @param {ReactReconcileTransaction} transaction
	     * @internal
	     * @overridable
	     */
	    updateComponent: 'OVERRIDE_BASE'
	  };
	
	  /**
	   * Similar to ReactClassInterface but for static methods.
	   */
	  var ReactClassStaticInterface = {
	    /**
	     * This method is invoked after a component is instantiated and when it
	     * receives new props. Return an object to update state in response to
	     * prop changes. Return null to indicate no change to state.
	     *
	     * If an object is returned, its keys will be merged into the existing state.
	     *
	     * @return {object || null}
	     * @optional
	     */
	    getDerivedStateFromProps: 'DEFINE_MANY_MERGED'
	  };
	
	  /**
	   * Mapping from class specification keys to special processing functions.
	   *
	   * Although these are declared like instance properties in the specification
	   * when defining classes using `React.createClass`, they are actually static
	   * and are accessible on the constructor instead of the prototype. Despite
	   * being static, they must be defined outside of the "statics" key under
	   * which all other static methods are defined.
	   */
	  var RESERVED_SPEC_KEYS = {
	    displayName: function(Constructor, displayName) {
	      Constructor.displayName = displayName;
	    },
	    mixins: function(Constructor, mixins) {
	      if (mixins) {
	        for (var i = 0; i < mixins.length; i++) {
	          mixSpecIntoComponent(Constructor, mixins[i]);
	        }
	      }
	    },
	    childContextTypes: function(Constructor, childContextTypes) {
	      if (false) {
	        validateTypeDef(Constructor, childContextTypes, 'childContext');
	      }
	      Constructor.childContextTypes = _assign(
	        {},
	        Constructor.childContextTypes,
	        childContextTypes
	      );
	    },
	    contextTypes: function(Constructor, contextTypes) {
	      if (false) {
	        validateTypeDef(Constructor, contextTypes, 'context');
	      }
	      Constructor.contextTypes = _assign(
	        {},
	        Constructor.contextTypes,
	        contextTypes
	      );
	    },
	    /**
	     * Special case getDefaultProps which should move into statics but requires
	     * automatic merging.
	     */
	    getDefaultProps: function(Constructor, getDefaultProps) {
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps = createMergedResultFunction(
	          Constructor.getDefaultProps,
	          getDefaultProps
	        );
	      } else {
	        Constructor.getDefaultProps = getDefaultProps;
	      }
	    },
	    propTypes: function(Constructor, propTypes) {
	      if (false) {
	        validateTypeDef(Constructor, propTypes, 'prop');
	      }
	      Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
	    },
	    statics: function(Constructor, statics) {
	      mixStaticSpecIntoComponent(Constructor, statics);
	    },
	    autobind: function() {}
	  };
	
	  function validateTypeDef(Constructor, typeDef, location) {
	    for (var propName in typeDef) {
	      if (typeDef.hasOwnProperty(propName)) {
	        // use a warning instead of an _invariant so components
	        // don't show up in prod but only in __DEV__
	        if (false) {
	          warning(
	            typeof typeDef[propName] === 'function',
	            '%s: %s type `%s` is invalid; it must be a function, usually from ' +
	              'React.PropTypes.',
	            Constructor.displayName || 'ReactClass',
	            ReactPropTypeLocationNames[location],
	            propName
	          );
	        }
	      }
	    }
	  }
	
	  function validateMethodOverride(isAlreadyDefined, name) {
	    var specPolicy = ReactClassInterface.hasOwnProperty(name)
	      ? ReactClassInterface[name]
	      : null;
	
	    // Disallow overriding of base class methods unless explicitly allowed.
	    if (ReactClassMixin.hasOwnProperty(name)) {
	      _invariant(
	        specPolicy === 'OVERRIDE_BASE',
	        'ReactClassInterface: You are attempting to override ' +
	          '`%s` from your class specification. Ensure that your method names ' +
	          'do not overlap with React methods.',
	        name
	      );
	    }
	
	    // Disallow defining methods more than once unless explicitly allowed.
	    if (isAlreadyDefined) {
	      _invariant(
	        specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED',
	        'ReactClassInterface: You are attempting to define ' +
	          '`%s` on your component more than once. This conflict may be due ' +
	          'to a mixin.',
	        name
	      );
	    }
	  }
	
	  /**
	   * Mixin helper which handles policy validation and reserved
	   * specification keys when building React classes.
	   */
	  function mixSpecIntoComponent(Constructor, spec) {
	    if (!spec) {
	      if (false) {
	        var typeofSpec = typeof spec;
	        var isMixinValid = typeofSpec === 'object' && spec !== null;
	
	        if (process.env.NODE_ENV !== 'production') {
	          warning(
	            isMixinValid,
	            "%s: You're attempting to include a mixin that is either null " +
	              'or not an object. Check the mixins included by the component, ' +
	              'as well as any mixins they include themselves. ' +
	              'Expected object but got %s.',
	            Constructor.displayName || 'ReactClass',
	            spec === null ? null : typeofSpec
	          );
	        }
	      }
	
	      return;
	    }
	
	    _invariant(
	      typeof spec !== 'function',
	      "ReactClass: You're attempting to " +
	        'use a component class or function as a mixin. Instead, just use a ' +
	        'regular object.'
	    );
	    _invariant(
	      !isValidElement(spec),
	      "ReactClass: You're attempting to " +
	        'use a component as a mixin. Instead, just use a regular object.'
	    );
	
	    var proto = Constructor.prototype;
	    var autoBindPairs = proto.__reactAutoBindPairs;
	
	    // By handling mixins before any other properties, we ensure the same
	    // chaining order is applied to methods with DEFINE_MANY policy, whether
	    // mixins are listed before or after these methods in the spec.
	    if (spec.hasOwnProperty(MIXINS_KEY)) {
	      RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
	    }
	
	    for (var name in spec) {
	      if (!spec.hasOwnProperty(name)) {
	        continue;
	      }
	
	      if (name === MIXINS_KEY) {
	        // We have already handled mixins in a special case above.
	        continue;
	      }
	
	      var property = spec[name];
	      var isAlreadyDefined = proto.hasOwnProperty(name);
	      validateMethodOverride(isAlreadyDefined, name);
	
	      if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
	        RESERVED_SPEC_KEYS[name](Constructor, property);
	      } else {
	        // Setup methods on prototype:
	        // The following member methods should not be automatically bound:
	        // 1. Expected ReactClass methods (in the "interface").
	        // 2. Overridden methods (that were mixed in).
	        var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
	        var isFunction = typeof property === 'function';
	        var shouldAutoBind =
	          isFunction &&
	          !isReactClassMethod &&
	          !isAlreadyDefined &&
	          spec.autobind !== false;
	
	        if (shouldAutoBind) {
	          autoBindPairs.push(name, property);
	          proto[name] = property;
	        } else {
	          if (isAlreadyDefined) {
	            var specPolicy = ReactClassInterface[name];
	
	            // These cases should already be caught by validateMethodOverride.
	            _invariant(
	              isReactClassMethod &&
	                (specPolicy === 'DEFINE_MANY_MERGED' ||
	                  specPolicy === 'DEFINE_MANY'),
	              'ReactClass: Unexpected spec policy %s for key %s ' +
	                'when mixing in component specs.',
	              specPolicy,
	              name
	            );
	
	            // For methods which are defined more than once, call the existing
	            // methods before calling the new property, merging if appropriate.
	            if (specPolicy === 'DEFINE_MANY_MERGED') {
	              proto[name] = createMergedResultFunction(proto[name], property);
	            } else if (specPolicy === 'DEFINE_MANY') {
	              proto[name] = createChainedFunction(proto[name], property);
	            }
	          } else {
	            proto[name] = property;
	            if (false) {
	              // Add verbose displayName to the function, which helps when looking
	              // at profiling tools.
	              if (typeof property === 'function' && spec.displayName) {
	                proto[name].displayName = spec.displayName + '_' + name;
	              }
	            }
	          }
	        }
	      }
	    }
	  }
	
	  function mixStaticSpecIntoComponent(Constructor, statics) {
	    if (!statics) {
	      return;
	    }
	
	    for (var name in statics) {
	      var property = statics[name];
	      if (!statics.hasOwnProperty(name)) {
	        continue;
	      }
	
	      var isReserved = name in RESERVED_SPEC_KEYS;
	      _invariant(
	        !isReserved,
	        'ReactClass: You are attempting to define a reserved ' +
	          'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' +
	          'as an instance property instead; it will still be accessible on the ' +
	          'constructor.',
	        name
	      );
	
	      var isAlreadyDefined = name in Constructor;
	      if (isAlreadyDefined) {
	        var specPolicy = ReactClassStaticInterface.hasOwnProperty(name)
	          ? ReactClassStaticInterface[name]
	          : null;
	
	        _invariant(
	          specPolicy === 'DEFINE_MANY_MERGED',
	          'ReactClass: You are attempting to define ' +
	            '`%s` on your component more than once. This conflict may be ' +
	            'due to a mixin.',
	          name
	        );
	
	        Constructor[name] = createMergedResultFunction(Constructor[name], property);
	
	        return;
	      }
	
	      Constructor[name] = property;
	    }
	  }
	
	  /**
	   * Merge two objects, but throw if both contain the same key.
	   *
	   * @param {object} one The first object, which is mutated.
	   * @param {object} two The second object
	   * @return {object} one after it has been mutated to contain everything in two.
	   */
	  function mergeIntoWithNoDuplicateKeys(one, two) {
	    _invariant(
	      one && two && typeof one === 'object' && typeof two === 'object',
	      'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.'
	    );
	
	    for (var key in two) {
	      if (two.hasOwnProperty(key)) {
	        _invariant(
	          one[key] === undefined,
	          'mergeIntoWithNoDuplicateKeys(): ' +
	            'Tried to merge two objects with the same key: `%s`. This conflict ' +
	            'may be due to a mixin; in particular, this may be caused by two ' +
	            'getInitialState() or getDefaultProps() methods returning objects ' +
	            'with clashing keys.',
	          key
	        );
	        one[key] = two[key];
	      }
	    }
	    return one;
	  }
	
	  /**
	   * Creates a function that invokes two functions and merges their return values.
	   *
	   * @param {function} one Function to invoke first.
	   * @param {function} two Function to invoke second.
	   * @return {function} Function that invokes the two argument functions.
	   * @private
	   */
	  function createMergedResultFunction(one, two) {
	    return function mergedResult() {
	      var a = one.apply(this, arguments);
	      var b = two.apply(this, arguments);
	      if (a == null) {
	        return b;
	      } else if (b == null) {
	        return a;
	      }
	      var c = {};
	      mergeIntoWithNoDuplicateKeys(c, a);
	      mergeIntoWithNoDuplicateKeys(c, b);
	      return c;
	    };
	  }
	
	  /**
	   * Creates a function that invokes two functions and ignores their return vales.
	   *
	   * @param {function} one Function to invoke first.
	   * @param {function} two Function to invoke second.
	   * @return {function} Function that invokes the two argument functions.
	   * @private
	   */
	  function createChainedFunction(one, two) {
	    return function chainedFunction() {
	      one.apply(this, arguments);
	      two.apply(this, arguments);
	    };
	  }
	
	  /**
	   * Binds a method to the component.
	   *
	   * @param {object} component Component whose method is going to be bound.
	   * @param {function} method Method to be bound.
	   * @return {function} The bound method.
	   */
	  function bindAutoBindMethod(component, method) {
	    var boundMethod = method.bind(component);
	    if (false) {
	      boundMethod.__reactBoundContext = component;
	      boundMethod.__reactBoundMethod = method;
	      boundMethod.__reactBoundArguments = null;
	      var componentName = component.constructor.displayName;
	      var _bind = boundMethod.bind;
	      boundMethod.bind = function(newThis) {
	        for (
	          var _len = arguments.length,
	            args = Array(_len > 1 ? _len - 1 : 0),
	            _key = 1;
	          _key < _len;
	          _key++
	        ) {
	          args[_key - 1] = arguments[_key];
	        }
	
	        // User is trying to bind() an autobound method; we effectively will
	        // ignore the value of "this" that the user is trying to use, so
	        // let's warn.
	        if (newThis !== component && newThis !== null) {
	          if (process.env.NODE_ENV !== 'production') {
	            warning(
	              false,
	              'bind(): React component methods may only be bound to the ' +
	                'component instance. See %s',
	              componentName
	            );
	          }
	        } else if (!args.length) {
	          if (process.env.NODE_ENV !== 'production') {
	            warning(
	              false,
	              'bind(): You are binding a component method to the component. ' +
	                'React does this for you automatically in a high-performance ' +
	                'way, so you can safely remove this call. See %s',
	              componentName
	            );
	          }
	          return boundMethod;
	        }
	        var reboundMethod = _bind.apply(boundMethod, arguments);
	        reboundMethod.__reactBoundContext = component;
	        reboundMethod.__reactBoundMethod = method;
	        reboundMethod.__reactBoundArguments = args;
	        return reboundMethod;
	      };
	    }
	    return boundMethod;
	  }
	
	  /**
	   * Binds all auto-bound methods in a component.
	   *
	   * @param {object} component Component whose method is going to be bound.
	   */
	  function bindAutoBindMethods(component) {
	    var pairs = component.__reactAutoBindPairs;
	    for (var i = 0; i < pairs.length; i += 2) {
	      var autoBindKey = pairs[i];
	      var method = pairs[i + 1];
	      component[autoBindKey] = bindAutoBindMethod(component, method);
	    }
	  }
	
	  var IsMountedPreMixin = {
	    componentDidMount: function() {
	      this.__isMounted = true;
	    }
	  };
	
	  var IsMountedPostMixin = {
	    componentWillUnmount: function() {
	      this.__isMounted = false;
	    }
	  };
	
	  /**
	   * Add more to the ReactClass base class. These are all legacy features and
	   * therefore not already part of the modern ReactComponent.
	   */
	  var ReactClassMixin = {
	    /**
	     * TODO: This will be deprecated because state should always keep a consistent
	     * type signature and the only use case for this, is to avoid that.
	     */
	    replaceState: function(newState, callback) {
	      this.updater.enqueueReplaceState(this, newState, callback);
	    },
	
	    /**
	     * Checks whether or not this composite component is mounted.
	     * @return {boolean} True if mounted, false otherwise.
	     * @protected
	     * @final
	     */
	    isMounted: function() {
	      if (false) {
	        warning(
	          this.__didWarnIsMounted,
	          '%s: isMounted is deprecated. Instead, make sure to clean up ' +
	            'subscriptions and pending requests in componentWillUnmount to ' +
	            'prevent memory leaks.',
	          (this.constructor && this.constructor.displayName) ||
	            this.name ||
	            'Component'
	        );
	        this.__didWarnIsMounted = true;
	      }
	      return !!this.__isMounted;
	    }
	  };
	
	  var ReactClassComponent = function() {};
	  _assign(
	    ReactClassComponent.prototype,
	    ReactComponent.prototype,
	    ReactClassMixin
	  );
	
	  /**
	   * Creates a composite component class given a class specification.
	   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
	   *
	   * @param {object} spec Class specification (which must define `render`).
	   * @return {function} Component constructor function.
	   * @public
	   */
	  function createClass(spec) {
	    // To keep our warnings more understandable, we'll use a little hack here to
	    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
	    // unnecessarily identify a class without displayName as 'Constructor'.
	    var Constructor = identity(function(props, context, updater) {
	      // This constructor gets overridden by mocks. The argument is used
	      // by mocks to assert on what gets mounted.
	
	      if (false) {
	        warning(
	          this instanceof Constructor,
	          'Something is calling a React component directly. Use a factory or ' +
	            'JSX instead. See: https://fb.me/react-legacyfactory'
	        );
	      }
	
	      // Wire up auto-binding
	      if (this.__reactAutoBindPairs.length) {
	        bindAutoBindMethods(this);
	      }
	
	      this.props = props;
	      this.context = context;
	      this.refs = emptyObject;
	      this.updater = updater || ReactNoopUpdateQueue;
	
	      this.state = null;
	
	      // ReactClasses doesn't have constructors. Instead, they use the
	      // getInitialState and componentWillMount methods for initialization.
	
	      var initialState = this.getInitialState ? this.getInitialState() : null;
	      if (false) {
	        // We allow auto-mocks to proceed as if they're returning null.
	        if (
	          initialState === undefined &&
	          this.getInitialState._isMockFunction
	        ) {
	          // This is probably bad practice. Consider warning here and
	          // deprecating this convenience.
	          initialState = null;
	        }
	      }
	      _invariant(
	        typeof initialState === 'object' && !Array.isArray(initialState),
	        '%s.getInitialState(): must return an object or null',
	        Constructor.displayName || 'ReactCompositeComponent'
	      );
	
	      this.state = initialState;
	    });
	    Constructor.prototype = new ReactClassComponent();
	    Constructor.prototype.constructor = Constructor;
	    Constructor.prototype.__reactAutoBindPairs = [];
	
	    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));
	
	    mixSpecIntoComponent(Constructor, IsMountedPreMixin);
	    mixSpecIntoComponent(Constructor, spec);
	    mixSpecIntoComponent(Constructor, IsMountedPostMixin);
	
	    // Initialize the defaultProps property after all mixins have been merged.
	    if (Constructor.getDefaultProps) {
	      Constructor.defaultProps = Constructor.getDefaultProps();
	    }
	
	    if (false) {
	      // This is a tag to indicate that the use of these method names is ok,
	      // since it's used with createClass. If it's not, then it's likely a
	      // mistake so we'll warn you to use the static property, property
	      // initializer or constructor respectively.
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps.isReactClassApproved = {};
	      }
	      if (Constructor.prototype.getInitialState) {
	        Constructor.prototype.getInitialState.isReactClassApproved = {};
	      }
	    }
	
	    _invariant(
	      Constructor.prototype.render,
	      'createClass(...): Class specification must implement a `render` method.'
	    );
	
	    if (false) {
	      warning(
	        !Constructor.prototype.componentShouldUpdate,
	        '%s has a method called ' +
	          'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' +
	          'The name is phrased as a question because the function is ' +
	          'expected to return a value.',
	        spec.displayName || 'A component'
	      );
	      warning(
	        !Constructor.prototype.componentWillRecieveProps,
	        '%s has a method called ' +
	          'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?',
	        spec.displayName || 'A component'
	      );
	      warning(
	        !Constructor.prototype.UNSAFE_componentWillRecieveProps,
	        '%s has a method called UNSAFE_componentWillRecieveProps(). ' +
	          'Did you mean UNSAFE_componentWillReceiveProps()?',
	        spec.displayName || 'A component'
	      );
	    }
	
	    // Reduce time spent doing lookups by setting these on the prototype.
	    for (var methodName in ReactClassInterface) {
	      if (!Constructor.prototype[methodName]) {
	        Constructor.prototype[methodName] = null;
	      }
	    }
	
	    return Constructor;
	  }
	
	  return createClass;
	}
	
	module.exports = factory;


/***/ }),
/* 2175 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var emptyObject = {};
	
	if (false) {
	  Object.freeze(emptyObject);
	}
	
	module.exports = emptyObject;

/***/ }),
/* 2176 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var validateFormat = function validateFormat(format) {};
	
	if (false) {
	  validateFormat = function validateFormat(format) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  };
	}
	
	function invariant(condition, format, a, b, c, d, e, f) {
	  validateFormat(format);
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(format.replace(/%s/g, function () {
	        return args[argIndex++];
	      }));
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	}
	
	module.exports = invariant;

/***/ }),
/* 2177 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var Quill = __webpack_require__(2171);
	
	var QuillMixin = {
	
		/**
		Creates an editor on the given element. The editor will
		be passed the configuration, have its events bound,
		*/
		createEditor: function($el, config) {
			var editor = new Quill($el, config);
			if (config.tabIndex !== undefined) {
				this.setEditorTabIndex(editor, config.tabIndex);
			}
			this.hookEditor(editor);
			return editor;
		},
	
		hookEditor: function(editor) {
			// Expose the editor on change events via a weaker,
			// unprivileged proxy object that does not allow
			// accidentally modifying editor state.
			var unprivilegedEditor = this.makeUnprivilegedEditor(editor);
	
			this.handleTextChange = function(delta, oldDelta, source) {
				if (this.onEditorChangeText) {
					this.onEditorChangeText(
						editor.root.innerHTML, delta, source,
						unprivilegedEditor
					);
					this.onEditorChangeSelection(
						editor.getSelection(), source,
						unprivilegedEditor
					);
				}
			}.bind(this);
	
			this.handleSelectionChange = function(range, oldRange, source) {
				if (this.onEditorChangeSelection) {
					this.onEditorChangeSelection(
						range, source,
						unprivilegedEditor
					);
				}
			}.bind(this);
	
			editor.on('text-change', this.handleTextChange);
			editor.on('selection-change', this.handleSelectionChange);
		},
	
		unhookEditor: function(editor) {
			editor.off('selection-change');
			editor.off('text-change');
		},
	
		setEditorReadOnly: function(editor, value) {
			value? editor.disable()
			     : editor.enable();
		},
	
		/*
		Replace the contents of the editor, but keep
		the previous selection hanging around so that
		the cursor won't move.
		*/
		setEditorContents: function(editor, value) {
			var sel = editor.getSelection();
	
			if (typeof value === 'string') {
				editor.setContents(editor.clipboard.convert(value));
			} else {
				editor.setContents(value);
			}
	
			if (sel && editor.hasFocus()) this.setEditorSelection(editor, sel);
		},
	
		setEditorSelection: function(editor, range) {
			if (range) {
				// Validate bounds before applying.
				var length = editor.getLength();
				range.index = Math.max(0, Math.min(range.index, length-1));
				range.length = Math.max(0, Math.min(range.length, (length-1) - range.index));
			}
			editor.setSelection(range);
		},
	
		setEditorTabIndex: function(editor, tabIndex) {
			if (editor.editor && editor.editor.scroll && editor.editor.scroll.domNode) {
				editor.editor.scroll.domNode.tabIndex = tabIndex;
			}
		},
	
		/*
		Returns an weaker, unprivileged proxy object that only
		exposes read-only accessors found on the editor instance,
		without any state-modificating methods.
		*/
		makeUnprivilegedEditor: function(editor) {
			var e = editor;
			return {
				getLength:    function(){ return e.getLength.apply(e, arguments); },
				getText:      function(){ return e.getText.apply(e, arguments); },
				getHTML:      function(){ return e.root.innerHTML },
				getContents:  function(){ return e.getContents.apply(e, arguments); },
				getSelection: function(){ return e.getSelection.apply(e, arguments); },
				getBounds:    function(){ return e.getBounds.apply(e, arguments); },
			};
		}
	
	};
	
	module.exports = QuillMixin;


/***/ }),
/* 2178 */
/***/ (function(module, exports, __webpack_require__) {

	var arraySome = __webpack_require__(931),
	    baseIteratee = __webpack_require__(997),
	    baseSome = __webpack_require__(2179),
	    isArray = __webpack_require__(789),
	    isIterateeCall = __webpack_require__(819);
	
	/**
	 * Checks if `predicate` returns truthy for **any** element of `collection`.
	 * Iteration is stopped once `predicate` returns truthy. The predicate is
	 * invoked with three arguments: (value, index|key, collection).
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [predicate=_.identity] The function invoked per iteration.
	 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	 * @returns {boolean} Returns `true` if any element passes the predicate check,
	 *  else `false`.
	 * @example
	 *
	 * _.some([null, 0, 'yes', false], Boolean);
	 * // => true
	 *
	 * var users = [
	 *   { 'user': 'barney', 'active': true },
	 *   { 'user': 'fred',   'active': false }
	 * ];
	 *
	 * // The `_.matches` iteratee shorthand.
	 * _.some(users, { 'user': 'barney', 'active': false });
	 * // => false
	 *
	 * // The `_.matchesProperty` iteratee shorthand.
	 * _.some(users, ['active', false]);
	 * // => true
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.some(users, 'active');
	 * // => true
	 */
	function some(collection, predicate, guard) {
	  var func = isArray(collection) ? arraySome : baseSome;
	  if (guard && isIterateeCall(collection, predicate, guard)) {
	    predicate = undefined;
	  }
	  return func(collection, baseIteratee(predicate, 3));
	}
	
	module.exports = some;


/***/ }),
/* 2179 */
/***/ (function(module, exports, __webpack_require__) {

	var baseEach = __webpack_require__(994);
	
	/**
	 * The base implementation of `_.some` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {boolean} Returns `true` if any element passes the predicate check,
	 *  else `false`.
	 */
	function baseSome(collection, predicate) {
	  var result;
	
	  baseEach(collection, function(value, index, collection) {
	    result = predicate(value, index, collection);
	    return !result;
	  });
	  return !!result;
	}
	
	module.exports = baseSome;


/***/ }),
/* 2180 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	(function(f) {
	  if (true) {
	    module.exports = f(__webpack_require__(300));
	    /* global define */
	  } else if (typeof define === 'function' && define.amd) {
	    define(['react'], f);
	  } else {
	    var g;
	    if (typeof window !== 'undefined') {
	      g = window;
	    } else if (typeof global !== 'undefined') {
	      g = global;
	    } else if (typeof self !== 'undefined') {
	      g = self;
	    } else {
	      g = this;
	    }
	
	    if (typeof g.React === 'undefined') {
	      throw Error('React module should be required before ReactDOMFactories');
	    }
	
	    g.ReactDOMFactories = f(g.React);
	  }
	})(function(React) {
	  /**
	   * Create a factory that creates HTML tag elements.
	   */
	  function createDOMFactory(type) {
	    var factory = React.createElement.bind(null, type);
	    // Expose the type on the factory and the prototype so that it can be
	    // easily accessed on elements. E.g. `<Foo />.type === Foo`.
	    // This should not be named `constructor` since this may not be the function
	    // that created the element, and it may not even be a constructor.
	    factory.type = type;
	    return factory;
	  };
	
	  /**
	   * Creates a mapping from supported HTML tags to `ReactDOMComponent` classes.
	   */
	  var ReactDOMFactories = {
	    a: createDOMFactory('a'),
	    abbr: createDOMFactory('abbr'),
	    address: createDOMFactory('address'),
	    area: createDOMFactory('area'),
	    article: createDOMFactory('article'),
	    aside: createDOMFactory('aside'),
	    audio: createDOMFactory('audio'),
	    b: createDOMFactory('b'),
	    base: createDOMFactory('base'),
	    bdi: createDOMFactory('bdi'),
	    bdo: createDOMFactory('bdo'),
	    big: createDOMFactory('big'),
	    blockquote: createDOMFactory('blockquote'),
	    body: createDOMFactory('body'),
	    br: createDOMFactory('br'),
	    button: createDOMFactory('button'),
	    canvas: createDOMFactory('canvas'),
	    caption: createDOMFactory('caption'),
	    cite: createDOMFactory('cite'),
	    code: createDOMFactory('code'),
	    col: createDOMFactory('col'),
	    colgroup: createDOMFactory('colgroup'),
	    data: createDOMFactory('data'),
	    datalist: createDOMFactory('datalist'),
	    dd: createDOMFactory('dd'),
	    del: createDOMFactory('del'),
	    details: createDOMFactory('details'),
	    dfn: createDOMFactory('dfn'),
	    dialog: createDOMFactory('dialog'),
	    div: createDOMFactory('div'),
	    dl: createDOMFactory('dl'),
	    dt: createDOMFactory('dt'),
	    em: createDOMFactory('em'),
	    embed: createDOMFactory('embed'),
	    fieldset: createDOMFactory('fieldset'),
	    figcaption: createDOMFactory('figcaption'),
	    figure: createDOMFactory('figure'),
	    footer: createDOMFactory('footer'),
	    form: createDOMFactory('form'),
	    h1: createDOMFactory('h1'),
	    h2: createDOMFactory('h2'),
	    h3: createDOMFactory('h3'),
	    h4: createDOMFactory('h4'),
	    h5: createDOMFactory('h5'),
	    h6: createDOMFactory('h6'),
	    head: createDOMFactory('head'),
	    header: createDOMFactory('header'),
	    hgroup: createDOMFactory('hgroup'),
	    hr: createDOMFactory('hr'),
	    html: createDOMFactory('html'),
	    i: createDOMFactory('i'),
	    iframe: createDOMFactory('iframe'),
	    img: createDOMFactory('img'),
	    input: createDOMFactory('input'),
	    ins: createDOMFactory('ins'),
	    kbd: createDOMFactory('kbd'),
	    keygen: createDOMFactory('keygen'),
	    label: createDOMFactory('label'),
	    legend: createDOMFactory('legend'),
	    li: createDOMFactory('li'),
	    link: createDOMFactory('link'),
	    main: createDOMFactory('main'),
	    map: createDOMFactory('map'),
	    mark: createDOMFactory('mark'),
	    menu: createDOMFactory('menu'),
	    menuitem: createDOMFactory('menuitem'),
	    meta: createDOMFactory('meta'),
	    meter: createDOMFactory('meter'),
	    nav: createDOMFactory('nav'),
	    noscript: createDOMFactory('noscript'),
	    object: createDOMFactory('object'),
	    ol: createDOMFactory('ol'),
	    optgroup: createDOMFactory('optgroup'),
	    option: createDOMFactory('option'),
	    output: createDOMFactory('output'),
	    p: createDOMFactory('p'),
	    param: createDOMFactory('param'),
	    picture: createDOMFactory('picture'),
	    pre: createDOMFactory('pre'),
	    progress: createDOMFactory('progress'),
	    q: createDOMFactory('q'),
	    rp: createDOMFactory('rp'),
	    rt: createDOMFactory('rt'),
	    ruby: createDOMFactory('ruby'),
	    s: createDOMFactory('s'),
	    samp: createDOMFactory('samp'),
	    script: createDOMFactory('script'),
	    section: createDOMFactory('section'),
	    select: createDOMFactory('select'),
	    small: createDOMFactory('small'),
	    source: createDOMFactory('source'),
	    span: createDOMFactory('span'),
	    strong: createDOMFactory('strong'),
	    style: createDOMFactory('style'),
	    sub: createDOMFactory('sub'),
	    summary: createDOMFactory('summary'),
	    sup: createDOMFactory('sup'),
	    table: createDOMFactory('table'),
	    tbody: createDOMFactory('tbody'),
	    td: createDOMFactory('td'),
	    textarea: createDOMFactory('textarea'),
	    tfoot: createDOMFactory('tfoot'),
	    th: createDOMFactory('th'),
	    thead: createDOMFactory('thead'),
	    time: createDOMFactory('time'),
	    title: createDOMFactory('title'),
	    tr: createDOMFactory('tr'),
	    track: createDOMFactory('track'),
	    u: createDOMFactory('u'),
	    ul: createDOMFactory('ul'),
	    var: createDOMFactory('var'),
	    video: createDOMFactory('video'),
	    wbr: createDOMFactory('wbr'),
	
	    // SVG
	    circle: createDOMFactory('circle'),
	    clipPath: createDOMFactory('clipPath'),
	    defs: createDOMFactory('defs'),
	    ellipse: createDOMFactory('ellipse'),
	    g: createDOMFactory('g'),
	    image: createDOMFactory('image'),
	    line: createDOMFactory('line'),
	    linearGradient: createDOMFactory('linearGradient'),
	    mask: createDOMFactory('mask'),
	    path: createDOMFactory('path'),
	    pattern: createDOMFactory('pattern'),
	    polygon: createDOMFactory('polygon'),
	    polyline: createDOMFactory('polyline'),
	    radialGradient: createDOMFactory('radialGradient'),
	    rect: createDOMFactory('rect'),
	    stop: createDOMFactory('stop'),
	    svg: createDOMFactory('svg'),
	    text: createDOMFactory('text'),
	    tspan: createDOMFactory('tspan'),
	  };
	
	  // due to wrapper and conditionals at the top, this will either become
	  // `module.exports ReactDOMFactories` if that is available,
	  // otherwise it will be defined via `define(['react'], ReactDOMFactories)`
	  // if that is available,
	  // otherwise it will be defined as global variable.
	  return ReactDOMFactories;
	});
	


/***/ }),
/* 2181 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	QuillToolbar is deprecated. Consider switching to the official Quill
	toolbar format, or providing your own toolbar instead. 
	See https://quilljs.com/docs/modules/toolbar
	*/
	
	'use strict';
	
	var React = __webpack_require__(300);
	var ReactDOMServer = __webpack_require__(2182);
	var createClass = __webpack_require__(2173);
	var find = __webpack_require__(1400);
	var isEqual = __webpack_require__(924);
	var T = __webpack_require__(956);
	var DOM = __webpack_require__(2180);
	
	var defaultColors = [
		'rgb(  0,   0,   0)', 'rgb(230,   0,   0)', 'rgb(255, 153,   0)',
		'rgb(255, 255,   0)', 'rgb(  0, 138,   0)', 'rgb(  0, 102, 204)',
		'rgb(153,  51, 255)', 'rgb(255, 255, 255)', 'rgb(250, 204, 204)',
		'rgb(255, 235, 204)', 'rgb(255, 255, 204)', 'rgb(204, 232, 204)',
		'rgb(204, 224, 245)', 'rgb(235, 214, 255)', 'rgb(187, 187, 187)',
		'rgb(240, 102, 102)', 'rgb(255, 194, 102)', 'rgb(255, 255, 102)',
		'rgb(102, 185, 102)', 'rgb(102, 163, 224)', 'rgb(194, 133, 255)',
		'rgb(136, 136, 136)', 'rgb(161,   0,   0)', 'rgb(178, 107,   0)',
		'rgb(178, 178,   0)', 'rgb(  0,  97,   0)', 'rgb(  0,  71, 178)',
		'rgb(107,  36, 178)', 'rgb( 68,  68,  68)', 'rgb( 92,   0,   0)',
		'rgb(102,  61,   0)', 'rgb(102, 102,   0)', 'rgb(  0,  55,   0)',
		'rgb(  0,  41, 102)', 'rgb( 61,  20,  10)',
	].map(function(color){ return { value: color } });
	
	var defaultItems = [
	
		{ label:'Formats', type:'group', items: [
			{ label:'Font', type:'font', items: [
				{ label:'Sans Serif',  value:'sans-serif', selected:true },
				{ label:'Serif',       value:'serif' },
				{ label:'Monospace',   value:'monospace' }
			]},
			{ label:'Size', type:'size', items: [
				{ label:'Small',  value:'10px' },
				{ label:'Normal', value:'13px', selected:true },
				{ label:'Large',  value:'18px' },
				{ label:'Huge',   value:'32px' }
			]},
			{ label:'Alignment', type:'align', items: [
				{ label:'', value:'', selected:true },
				{ label:'', value:'center' },
				{ label:'', value:'right' },
				{ label:'', value:'justify' }
			]}
		]},
	
		{ label:'Text', type:'group', items: [
			{ type:'bold', label:'Bold' },
			{ type:'italic', label:'Italic' },
			{ type:'strike', label:'Strike' },
			{ type:'underline', label:'Underline' },
			{ type:'color', label:'Color', items:defaultColors },
			{ type:'background', label:'Background color', items:defaultColors },
			{ type:'link', label:'Link' }
		]},
	
		{ label:'Blocks', type:'group', items: [
			{ type:'list', value:'bullet' },
			{ type:'list', value:'ordered' }
		]},
	
		{ label:'Blocks', type:'group', items: [
			{ type:'image', label:'Image' }
		]}
	
	];
	
	var QuillToolbar = createClass({
	
		displayName: 'Quill Toolbar',
	
		propTypes: {
			id:        T.string,
			className: T.string,
			style:     T.object,
			items:     T.array
		},
	
		getDefaultProps: function() {
			return {
				items: defaultItems
			};
		},
	
		componentDidMount: function() {
			console.warn(
				'QuillToolbar is deprecated. Consider switching to the official Quill ' +
				'toolbar format, or providing your own toolbar instead. ' +
				'See: https://github.com/zenoamaro/react-quill#upgrading-to-react-quill-v1-0-0'
			);
		},
	
		shouldComponentUpdate: function(nextProps, nextState) {
			return !isEqual(nextProps, this.props);
		},
	
		renderGroup: function(item, key) {
			return DOM.span({
				key: item.label || key,
				className:'ql-formats' },
				item.items.map(this.renderItem)
			);
		},
	
		renderChoiceItem: function(item, key) {
			return DOM.option({
				key: item.label || item.value || key,
				value: item.value },
				item.label
			);
		},
	
		renderChoices: function(item, key) {
			var choiceItems = item.items.map(this.renderChoiceItem);
			var selectedItem = find(item.items, function(item){ return item.selected });
			var attrs = {
				key: item.label || key,
				title: item.label,
				className: 'ql-'+item.type,
				value: selectedItem.value,
			};
			return DOM.select(attrs, choiceItems);
		},
	
		renderButton: function(item, key) {
			return DOM.button({
				type: 'button',
				key: item.label || item.value || key,
				value: item.value,
				className: 'ql-'+item.type,
				title: item.label },
				item.children
			);
		},
	
		renderAction: function(item, key) {
			return DOM.button({
				key: item.label || item.value || key,
				className: 'ql-'+item.type,
				title: item.label },
				item.children
			);
		},
	
		/* jshint maxcomplexity: false */
		renderItem: function(item, key) {
			switch (item.type) {
				case 'group':
					return this.renderGroup(item, key);
				case 'font':
				case 'header':
				case 'align':
				case 'size':
				case 'color':
				case 'background':
					return this.renderChoices(item, key);
				case 'bold':
				case 'italic':
				case 'underline':
				case 'strike':
				case 'link':
				case 'list':
				case 'bullet':
				case 'ordered':
				case 'indent':
				case 'image':
				case 'video':
					return this.renderButton(item, key);
				default:
					return this.renderAction(item, key);
			}
		},
	
		getClassName: function() {
			return 'quill-toolbar ' + (this.props.className||'');
		},
	
		render: function() {
			var children = this.props.items.map(this.renderItem);
			var html = children.map(ReactDOMServer.renderToStaticMarkup).join('');
			return DOM.div({
				id: this.props.id,
				className: this.getClassName(),
				style: this.props.style,
				dangerouslySetInnerHTML: { __html:html }
			});
		},
	
	});
	
	module.exports = QuillToolbar;
	QuillToolbar.defaultItems = defaultItems;
	QuillToolbar.defaultColors = defaultColors;


/***/ }),
/* 2182 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(2183);


/***/ }),
/* 2183 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactDefaultInjection = __webpack_require__(339);
	var ReactServerRendering = __webpack_require__(2184);
	var ReactVersion = __webpack_require__(473);
	
	ReactDefaultInjection.inject();
	
	var ReactDOMServer = {
	  renderToString: ReactServerRendering.renderToString,
	  renderToStaticMarkup: ReactServerRendering.renderToStaticMarkup,
	  version: ReactVersion
	};
	
	module.exports = ReactDOMServer;

/***/ }),
/* 2184 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	'use strict';
	
	var _prodInvariant = __webpack_require__(335);
	
	var React = __webpack_require__(301);
	var ReactDOMContainerInfo = __webpack_require__(469);
	var ReactDefaultBatchingStrategy = __webpack_require__(442);
	var ReactInstrumentation = __webpack_require__(365);
	var ReactMarkupChecksum = __webpack_require__(471);
	var ReactReconciler = __webpack_require__(362);
	var ReactServerBatchingStrategy = __webpack_require__(2185);
	var ReactServerRenderingTransaction = __webpack_require__(435);
	var ReactUpdates = __webpack_require__(359);
	
	var emptyObject = __webpack_require__(423);
	var instantiateReactComponent = __webpack_require__(420);
	var invariant = __webpack_require__(337);
	
	var pendingTransactions = 0;
	
	/**
	 * @param {ReactElement} element
	 * @return {string} the HTML markup
	 */
	function renderToStringImpl(element, makeStaticMarkup) {
	  var transaction;
	  try {
	    ReactUpdates.injection.injectBatchingStrategy(ReactServerBatchingStrategy);
	
	    transaction = ReactServerRenderingTransaction.getPooled(makeStaticMarkup);
	
	    pendingTransactions++;
	
	    return transaction.perform(function () {
	      var componentInstance = instantiateReactComponent(element, true);
	      var markup = ReactReconciler.mountComponent(componentInstance, transaction, null, ReactDOMContainerInfo(), emptyObject, 0 /* parentDebugID */
	      );
	      if (false) {
	        ReactInstrumentation.debugTool.onUnmountComponent(componentInstance._debugID);
	      }
	      if (!makeStaticMarkup) {
	        markup = ReactMarkupChecksum.addChecksumToMarkup(markup);
	      }
	      return markup;
	    }, null);
	  } finally {
	    pendingTransactions--;
	    ReactServerRenderingTransaction.release(transaction);
	    // Revert to the DOM batching strategy since these two renderers
	    // currently share these stateful modules.
	    if (!pendingTransactions) {
	      ReactUpdates.injection.injectBatchingStrategy(ReactDefaultBatchingStrategy);
	    }
	  }
	}
	
	/**
	 * Render a ReactElement to its initial HTML. This should only be used on the
	 * server.
	 * See https://facebook.github.io/react/docs/top-level-api.html#reactdomserver.rendertostring
	 */
	function renderToString(element) {
	  !React.isValidElement(element) ?  false ? invariant(false, 'renderToString(): You must pass a valid ReactElement.') : _prodInvariant('46') : void 0;
	  return renderToStringImpl(element, false);
	}
	
	/**
	 * Similar to renderToString, except this doesn't create extra DOM attributes
	 * such as data-react-id that React uses internally.
	 * See https://facebook.github.io/react/docs/top-level-api.html#reactdomserver.rendertostaticmarkup
	 */
	function renderToStaticMarkup(element) {
	  !React.isValidElement(element) ?  false ? invariant(false, 'renderToStaticMarkup(): You must pass a valid ReactElement.') : _prodInvariant('47') : void 0;
	  return renderToStringImpl(element, true);
	}
	
	module.exports = {
	  renderToString: renderToString,
	  renderToStaticMarkup: renderToStaticMarkup
	};

/***/ }),
/* 2185 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactServerBatchingStrategy = {
	  isBatchingUpdates: false,
	  batchedUpdates: function (callback) {
	    // Don't do anything here. During the server rendering we don't want to
	    // schedule any updates. We will simply ignore them.
	  }
	};
	
	module.exports = ReactServerBatchingStrategy;

/***/ }),
/* 2186 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var window = (window || {});
	window.Quill = __webpack_require__(2171);
	
	!function(t,e){ true?module.exports=e():"function"==typeof define&&define.amd?define([],e):"object"==typeof exports?exports.ImageResize=e():t.ImageResize=e()}(this,function(){return function(t){function e(o){if(n[o])return n[o].exports;var r=n[o]={i:o,l:!1,exports:{}};return t[o].call(r.exports,r,r.exports,e),r.l=!0,r.exports}var n={};return e.m=t,e.c=n,e.i=function(t){return t},e.d=function(t,n,o){e.o(t,n)||Object.defineProperty(t,n,{configurable:!1,enumerable:!0,get:o})},e.n=function(t){var n=t&&t.__esModule?function(){return t.default}:function(){return t};return e.d(n,"a",n),n},e.o=function(t,e){return Object.prototype.hasOwnProperty.call(t,e)},e.p="",e(e.s=38)}([function(t,e){function n(t){var e=typeof t;return null!=t&&("object"==e||"function"==e)}t.exports=n},function(t,e,n){var o=n(22),r="object"==typeof self&&self&&self.Object===Object&&self,i=o||r||Function("return this")();t.exports=i},function(t,e){function n(t){return null!=t&&"object"==typeof t}t.exports=n},function(t,e,n){function o(t){var e=-1,n=null==t?0:t.length;for(this.clear();++e<n;){var o=t[e];this.set(o[0],o[1])}}var r=n(75),i=n(76),a=n(77),s=n(78),u=n(79);o.prototype.clear=r,o.prototype.delete=i,o.prototype.get=a,o.prototype.has=s,o.prototype.set=u,t.exports=o},function(t,e,n){function o(t,e){for(var n=t.length;n--;)if(r(t[n][0],e))return n;return-1}var r=n(8);t.exports=o},function(t,e,n){function o(t){return null==t?void 0===t?u:s:c&&c in Object(t)?i(t):a(t)}var r=n(16),i=n(64),a=n(87),s="[object Null]",u="[object Undefined]",c=r?r.toStringTag:void 0;t.exports=o},function(t,e,n){function o(t,e){var n=t.__data__;return r(e)?n["string"==typeof e?"string":"hash"]:n.map}var r=n(73);t.exports=o},function(t,e,n){var o=n(11),r=o(Object,"create");t.exports=r},function(t,e){function n(t,e){return t===e||t!==t&&e!==e}t.exports=n},function(t,e,n){"use strict";function o(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}n.d(e,"a",function(){return r});var r=function t(e){o(this,t),this.onCreate=function(){},this.onDestroy=function(){},this.onUpdate=function(){},this.overlay=e.overlay,this.img=e.img,this.options=e.options,this.requestUpdate=e.onUpdate}},function(t,e,n){function o(t,e,n){"__proto__"==e&&r?r(t,e,{configurable:!0,enumerable:!0,value:n,writable:!0}):t[e]=n}var r=n(21);t.exports=o},function(t,e,n){function o(t,e){var n=i(t,e);return r(n)?n:void 0}var r=n(48),i=n(65);t.exports=o},function(t,e,n){function o(t){return null!=t&&i(t.length)&&!r(t)}var r=n(13),i=n(30);t.exports=o},function(t,e,n){function o(t){if(!i(t))return!1;var e=r(t);return e==s||e==u||e==a||e==c}var r=n(5),i=n(0),a="[object AsyncFunction]",s="[object Function]",u="[object GeneratorFunction]",c="[object Proxy]";t.exports=o},function(t,e){t.exports=function(t){return t.webpackPolyfill||(t.deprecate=function(){},t.paths=[],t.children||(t.children=[]),Object.defineProperty(t,"loaded",{enumerable:!0,get:function(){return t.l}}),Object.defineProperty(t,"id",{enumerable:!0,get:function(){return t.i}}),t.webpackPolyfill=1),t}},function(t,e,n){var o=n(11),r=n(1),i=o(r,"Map");t.exports=i},function(t,e,n){var o=n(1),r=o.Symbol;t.exports=r},function(t,e){function n(t,e,n){switch(n.length){case 0:return t.call(e);case 1:return t.call(e,n[0]);case 2:return t.call(e,n[0],n[1]);case 3:return t.call(e,n[0],n[1],n[2])}return t.apply(e,n)}t.exports=n},function(t,e,n){function o(t,e,n){(void 0===n||i(t[e],n))&&(void 0!==n||e in t)||r(t,e,n)}var r=n(10),i=n(8);t.exports=o},function(t,e,n){function o(t,e,n,l,f){t!==e&&a(e,function(a,c){if(u(a))f||(f=new r),s(t,e,c,n,o,l,f);else{var p=l?l(t[c],a,c+"",t,e,f):void 0;void 0===p&&(p=a),i(t,c,p)}},c)}var r=n(41),i=n(18),a=n(46),s=n(51),u=n(0),c=n(32);t.exports=o},function(t,e,n){function o(t,e){return a(i(t,e,r),t+"")}var r=n(26),i=n(89),a=n(90);t.exports=o},function(t,e,n){var o=n(11),r=function(){try{var t=o(Object,"defineProperty");return t({},"",{}),t}catch(t){}}();t.exports=r},function(t,e,n){(function(e){var n="object"==typeof e&&e&&e.Object===Object&&e;t.exports=n}).call(e,n(107))},function(t,e,n){var o=n(88),r=o(Object.getPrototypeOf,Object);t.exports=r},function(t,e){function n(t,e){return!!(e=null==e?o:e)&&("number"==typeof t||r.test(t))&&t>-1&&t%1==0&&t<e}var o=9007199254740991,r=/^(?:0|[1-9]\d*)$/;t.exports=n},function(t,e){function n(t){var e=t&&t.constructor;return t===("function"==typeof e&&e.prototype||o)}var o=Object.prototype;t.exports=n},function(t,e){function n(t){return t}t.exports=n},function(t,e,n){var o=n(47),r=n(2),i=Object.prototype,a=i.hasOwnProperty,s=i.propertyIsEnumerable,u=o(function(){return arguments}())?o:function(t){return r(t)&&a.call(t,"callee")&&!s.call(t,"callee")};t.exports=u},function(t,e){var n=Array.isArray;t.exports=n},function(t,e,n){(function(t){var o=n(1),r=n(102),i="object"==typeof e&&e&&!e.nodeType&&e,a=i&&"object"==typeof t&&t&&!t.nodeType&&t,s=a&&a.exports===i,u=s?o.Buffer:void 0,c=u?u.isBuffer:void 0,l=c||r;t.exports=l}).call(e,n(14)(t))},function(t,e){function n(t){return"number"==typeof t&&t>-1&&t%1==0&&t<=o}var o=9007199254740991;t.exports=n},function(t,e,n){var o=n(49),r=n(54),i=n(86),a=i&&i.isTypedArray,s=a?r(a):o;t.exports=s},function(t,e,n){function o(t){return a(t)?r(t,!0):i(t)}var r=n(43),i=n(50),a=n(12);t.exports=o},function(t,e,n){"use strict";e.a={modules:["DisplaySize","Toolbar","Resize"],overlayStyles:{position:"absolute",boxSizing:"border-box",border:"1px dashed #444"},handleStyles:{position:"absolute",height:"12px",width:"12px",backgroundColor:"white",border:"1px solid #777",boxSizing:"border-box",opacity:"0.80"},displayStyles:{position:"absolute",font:"12px/1.0 Arial, Helvetica, sans-serif",padding:"4px 8px",textAlign:"center",backgroundColor:"white",color:"#333",border:"1px solid #777",boxSizing:"border-box",opacity:"0.80",cursor:"default"},toolbarStyles:{position:"absolute",top:"-12px",right:"0",left:"0",height:"0",minWidth:"100px",font:"12px/1.0 Arial, Helvetica, sans-serif",textAlign:"center",color:"#333",boxSizing:"border-box",cursor:"default"},toolbarButtonStyles:{display:"inline-block",width:"24px",height:"24px",background:"white",border:"1px solid #999",verticalAlign:"middle"},toolbarButtonSvgStyles:{fill:"#444",stroke:"#444",strokeWidth:"2"}}},function(t,e,n){"use strict";function o(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function r(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function i(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}var a=n(9);n.d(e,"a",function(){return s});var s=function(t){function e(){var t,n,i,a;o(this,e);for(var s=arguments.length,u=Array(s),c=0;c<s;c++)u[c]=arguments[c];return n=i=r(this,(t=e.__proto__||Object.getPrototypeOf(e)).call.apply(t,[this].concat(u))),i.onCreate=function(){i.display=document.createElement("div"),Object.assign(i.display.style,i.options.displayStyles),i.overlay.appendChild(i.display)},i.onDestroy=function(){},i.onUpdate=function(){if(i.display&&i.img){var t=i.getCurrentSize();if(i.display.innerHTML=t.join(" &times; "),t[0]>120&&t[1]>30)Object.assign(i.display.style,{right:"4px",bottom:"4px",left:"auto"});else if("right"==i.img.style.float){var e=i.display.getBoundingClientRect();Object.assign(i.display.style,{right:"auto",bottom:"-"+(e.height+4)+"px",left:"-"+(e.width+4)+"px"})}else{var n=i.display.getBoundingClientRect();Object.assign(i.display.style,{right:"-"+(n.width+4)+"px",bottom:"-"+(n.height+4)+"px",left:"auto"})}}},i.getCurrentSize=function(){return[i.img.width,Math.round(i.img.width/i.img.naturalWidth*i.img.naturalHeight)]},a=n,r(i,a)}return i(e,t),e}(a.a)},function(t,e,n){"use strict";function o(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function r(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function i(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}var a=n(9);n.d(e,"a",function(){return s});var s=function(t){function e(){var t,n,i,a;o(this,e);for(var s=arguments.length,u=Array(s),c=0;c<s;c++)u[c]=arguments[c];return n=i=r(this,(t=e.__proto__||Object.getPrototypeOf(e)).call.apply(t,[this].concat(u))),i.onCreate=function(){i.boxes=[],i.addBox("nwse-resize"),i.addBox("nesw-resize"),i.addBox("nwse-resize"),i.addBox("nesw-resize"),i.positionBoxes()},i.onDestroy=function(){i.setCursor("")},i.positionBoxes=function(){var t=-parseFloat(i.options.handleStyles.width)/2+"px",e=-parseFloat(i.options.handleStyles.height)/2+"px";[{left:t,top:e},{right:t,top:e},{right:t,bottom:e},{left:t,bottom:e}].forEach(function(t,e){Object.assign(i.boxes[e].style,t)})},i.addBox=function(t){var e=document.createElement("div");Object.assign(e.style,i.options.handleStyles),e.style.cursor=t,e.style.width=i.options.handleStyles.width+"px",e.style.height=i.options.handleStyles.height+"px",e.addEventListener("mousedown",i.handleMousedown,!1),i.overlay.appendChild(e),i.boxes.push(e)},i.handleMousedown=function(t){i.dragBox=t.target,i.dragStartX=t.clientX,i.preDragWidth=i.img.width||i.img.naturalWidth,i.setCursor(i.dragBox.style.cursor),document.addEventListener("mousemove",i.handleDrag,!1),document.addEventListener("mouseup",i.handleMouseup,!1)},i.handleMouseup=function(){i.setCursor(""),document.removeEventListener("mousemove",i.handleDrag),document.removeEventListener("mouseup",i.handleMouseup)},i.handleDrag=function(t){if(i.img){var e=t.clientX-i.dragStartX;i.dragBox===i.boxes[0]||i.dragBox===i.boxes[3]?i.img.width=Math.round(i.preDragWidth-e):i.img.width=Math.round(i.preDragWidth+e),i.requestUpdate()}},i.setCursor=function(t){[document.body,i.img].forEach(function(e){e.style.cursor=t})},a=n,r(i,a)}return i(e,t),e}(a.a)},function(t,e,n){"use strict";function o(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function r(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function i(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}var a=n(105),s=n.n(a),u=n(104),c=n.n(u),l=n(106),f=n.n(l),p=n(9);n.d(e,"a",function(){return b});var d=window.Quill.imports.parchment,h=new d.Attributor.Style("float","float"),y=new d.Attributor.Style("margin","margin"),v=new d.Attributor.Style("display","display"),b=function(t){function e(){var t,n,i,a;o(this,e);for(var u=arguments.length,l=Array(u),p=0;p<u;p++)l[p]=arguments[p];return n=i=r(this,(t=e.__proto__||Object.getPrototypeOf(e)).call.apply(t,[this].concat(l))),i.onCreate=function(){i.toolbar=document.createElement("div"),Object.assign(i.toolbar.style,i.options.toolbarStyles),i.overlay.appendChild(i.toolbar),i._defineAlignments(),i._addToolbarButtons()},i.onDestroy=function(){},i.onUpdate=function(){},i._defineAlignments=function(){i.alignments=[{icon:s.a,apply:function(){v.add(i.img,"inline"),h.add(i.img,"left"),y.add(i.img,"0 1em 1em 0")},isApplied:function(){return"left"==h.value(i.img)}},{icon:c.a,apply:function(){v.add(i.img,"block"),h.remove(i.img),y.add(i.img,"auto")},isApplied:function(){return"auto"==y.value(i.img)}},{icon:f.a,apply:function(){v.add(i.img,"inline"),h.add(i.img,"right"),y.add(i.img,"0 0 1em 1em")},isApplied:function(){return"right"==h.value(i.img)}}]},i._addToolbarButtons=function(){var t=[];i.alignments.forEach(function(e,n){var o=document.createElement("span");t.push(o),o.innerHTML=e.icon,o.addEventListener("click",function(){t.forEach(function(t){return t.style.filter=""}),e.isApplied()?(h.remove(i.img),y.remove(i.img),v.remove(i.img)):(i._selectButton(o),e.apply()),i.requestUpdate()}),Object.assign(o.style,i.options.toolbarButtonStyles),n>0&&(o.style.borderLeftWidth="0"),Object.assign(o.children[0].style,i.options.toolbarButtonSvgStyles),e.isApplied()&&i._selectButton(o),i.toolbar.appendChild(o)})},i._selectButton=function(t){t.style.filter="invert(20%)"},a=n,r(i,a)}return i(e,t),e}(p.a)},function(t,e,n){var o=n(17),r=n(20),i=n(63),a=n(101),s=r(function(t){return t.push(void 0,i),o(a,void 0,t)});t.exports=s},function(t,e,n){"use strict";function o(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(e,"__esModule",{value:!0});var r=n(37),i=n.n(r),a=n(33),s=n(34),u=n(36),c=n(35),l={DisplaySize:s.a,Toolbar:u.a,Resize:c.a},f=function t(e){var n=this,r=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{};o(this,t),this.initializeModules=function(){n.removeModules(),n.modules=n.moduleClasses.map(function(t){return new(l[t]||t)(n)}),n.modules.forEach(function(t){t.onCreate()}),n.onUpdate()},this.onUpdate=function(){n.repositionElements(),n.modules.forEach(function(t){t.onUpdate()})},this.removeModules=function(){n.modules.forEach(function(t){t.onDestroy()}),n.modules=[]},this.handleClick=function(t){if(t.target&&t.target.tagName&&"IMG"===t.target.tagName.toUpperCase()){if(n.img===t.target)return;n.img&&n.hide(),n.show(t.target)}else n.img&&n.hide()},this.show=function(t){n.img=t,n.showOverlay(),n.initializeModules()},this.showOverlay=function(){n.overlay&&n.hideOverlay(),n.quill.setSelection(null),n.setUserSelect("none"),document.addEventListener("keyup",n.checkImage,!0),n.quill.root.addEventListener("input",n.checkImage,!0),n.overlay=document.createElement("div"),Object.assign(n.overlay.style,n.options.overlayStyles),n.quill.root.parentNode.appendChild(n.overlay),n.repositionElements()},this.hideOverlay=function(){n.overlay&&(n.quill.root.parentNode.removeChild(n.overlay),n.overlay=void 0,document.removeEventListener("keyup",n.checkImage),n.quill.root.removeEventListener("input",n.checkImage),n.setUserSelect(""))},this.repositionElements=function(){if(n.overlay&&n.img){var t=n.quill.root.parentNode,e=n.img.getBoundingClientRect(),o=t.getBoundingClientRect();Object.assign(n.overlay.style,{left:e.left-o.left-1+t.scrollLeft+"px",top:e.top-o.top+t.scrollTop+"px",width:e.width+"px",height:e.height+"px"})}},this.hide=function(){n.hideOverlay(),n.removeModules(),n.img=void 0},this.setUserSelect=function(t){["userSelect","mozUserSelect","webkitUserSelect","msUserSelect"].forEach(function(e){n.quill.root.style[e]=t,document.documentElement.style[e]=t})},this.checkImage=function(t){n.img&&(46!=t.keyCode&&8!=t.keyCode||window.Quill.find(n.img).deleteAt(0),n.hide())},this.quill=e;var s=!1;r.modules&&(s=r.modules.slice()),this.options=i()({},r,a.a),s!==!1&&(this.options.modules=s),document.execCommand("enableObjectResizing",!1,"false"),this.quill.root.addEventListener("click",this.handleClick,!1),this.quill.root.parentNode.style.position=this.quill.root.parentNode.style.position||"relative",this.moduleClasses=this.options.modules,console.log("this.options.modules",this.options.modules),this.modules=[]};e.default=f,window.Quill&&window.Quill.register("modules/imageResize",f)},function(t,e,n){function o(t){var e=-1,n=null==t?0:t.length;for(this.clear();++e<n;){var o=t[e];this.set(o[0],o[1])}}var r=n(66),i=n(67),a=n(68),s=n(69),u=n(70);o.prototype.clear=r,o.prototype.delete=i,o.prototype.get=a,o.prototype.has=s,o.prototype.set=u,t.exports=o},function(t,e,n){function o(t){var e=-1,n=null==t?0:t.length;for(this.clear();++e<n;){var o=t[e];this.set(o[0],o[1])}}var r=n(80),i=n(81),a=n(82),s=n(83),u=n(84);o.prototype.clear=r,o.prototype.delete=i,o.prototype.get=a,o.prototype.has=s,o.prototype.set=u,t.exports=o},function(t,e,n){function o(t){var e=this.__data__=new r(t);this.size=e.size}var r=n(3),i=n(92),a=n(93),s=n(94),u=n(95),c=n(96);o.prototype.clear=i,o.prototype.delete=a,o.prototype.get=s,o.prototype.has=u,o.prototype.set=c,t.exports=o},function(t,e,n){var o=n(1),r=o.Uint8Array;t.exports=r},function(t,e,n){function o(t,e){var n=a(t),o=!n&&i(t),l=!n&&!o&&s(t),p=!n&&!o&&!l&&c(t),d=n||o||l||p,h=d?r(t.length,String):[],y=h.length;for(var v in t)!e&&!f.call(t,v)||d&&("length"==v||l&&("offset"==v||"parent"==v)||p&&("buffer"==v||"byteLength"==v||"byteOffset"==v)||u(v,y))||h.push(v);return h}var r=n(53),i=n(27),a=n(28),s=n(29),u=n(24),c=n(31),l=Object.prototype,f=l.hasOwnProperty;t.exports=o},function(t,e,n){function o(t,e,n){var o=t[e];s.call(t,e)&&i(o,n)&&(void 0!==n||e in t)||r(t,e,n)}var r=n(10),i=n(8),a=Object.prototype,s=a.hasOwnProperty;t.exports=o},function(t,e,n){var o=n(0),r=Object.create,i=function(){function t(){}return function(e){if(!o(e))return{};if(r)return r(e);t.prototype=e;var n=new t;return t.prototype=void 0,n}}();t.exports=i},function(t,e,n){var o=n(62),r=o();t.exports=r},function(t,e,n){function o(t){return i(t)&&r(t)==a}var r=n(5),i=n(2),a="[object Arguments]";t.exports=o},function(t,e,n){function o(t){return!(!a(t)||i(t))&&(r(t)?d:u).test(s(t))}var r=n(13),i=n(74),a=n(0),s=n(97),u=/^\[object .+?Constructor\]$/,c=Function.prototype,l=Object.prototype,f=c.toString,p=l.hasOwnProperty,d=RegExp("^"+f.call(p).replace(/[\\^$.*+?()[\]{}|]/g,"\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g,"$1.*?")+"$");t.exports=o},function(t,e,n){function o(t){return a(t)&&i(t.length)&&!!s[r(t)]}var r=n(5),i=n(30),a=n(2),s={};s["[object Float32Array]"]=s["[object Float64Array]"]=s["[object Int8Array]"]=s["[object Int16Array]"]=s["[object Int32Array]"]=s["[object Uint8Array]"]=s["[object Uint8ClampedArray]"]=s["[object Uint16Array]"]=s["[object Uint32Array]"]=!0,s["[object Arguments]"]=s["[object Array]"]=s["[object ArrayBuffer]"]=s["[object Boolean]"]=s["[object DataView]"]=s["[object Date]"]=s["[object Error]"]=s["[object Function]"]=s["[object Map]"]=s["[object Number]"]=s["[object Object]"]=s["[object RegExp]"]=s["[object Set]"]=s["[object String]"]=s["[object WeakMap]"]=!1,t.exports=o},function(t,e,n){function o(t){if(!r(t))return a(t);var e=i(t),n=[];for(var o in t)("constructor"!=o||!e&&u.call(t,o))&&n.push(o);return n}var r=n(0),i=n(25),a=n(85),s=Object.prototype,u=s.hasOwnProperty;t.exports=o},function(t,e,n){function o(t,e,n,o,g,x,m){var _=t[n],j=e[n],w=m.get(j);if(w)return void r(t,n,w);var O=x?x(_,j,n+"",t,e,m):void 0,S=void 0===O;if(S){var E=l(j),A=!E&&p(j),z=!E&&!A&&v(j);O=j,E||A||z?l(_)?O=_:f(_)?O=s(_):A?(S=!1,O=i(j,!0)):z?(S=!1,O=a(j,!0)):O=[]:y(j)||c(j)?(O=_,c(_)?O=b(_):(!h(_)||o&&d(_))&&(O=u(j))):S=!1}S&&(m.set(j,O),g(O,j,o,x,m),m.delete(j)),r(t,n,O)}var r=n(18),i=n(56),a=n(57),s=n(58),u=n(71),c=n(27),l=n(28),f=n(99),p=n(29),d=n(13),h=n(0),y=n(100),v=n(31),b=n(103);t.exports=o},function(t,e,n){var o=n(98),r=n(21),i=n(26),a=r?function(t,e){return r(t,"toString",{configurable:!0,enumerable:!1,value:o(e),writable:!0})}:i;t.exports=a},function(t,e){function n(t,e){for(var n=-1,o=Array(t);++n<t;)o[n]=e(n);return o}t.exports=n},function(t,e){function n(t){return function(e){return t(e)}}t.exports=n},function(t,e,n){function o(t){var e=new t.constructor(t.byteLength);return new r(e).set(new r(t)),e}var r=n(42);t.exports=o},function(t,e,n){(function(t){function o(t,e){if(e)return t.slice();var n=t.length,o=c?c(n):new t.constructor(n);return t.copy(o),o}var r=n(1),i="object"==typeof e&&e&&!e.nodeType&&e,a=i&&"object"==typeof t&&t&&!t.nodeType&&t,s=a&&a.exports===i,u=s?r.Buffer:void 0,c=u?u.allocUnsafe:void 0;t.exports=o}).call(e,n(14)(t))},function(t,e,n){function o(t,e){var n=e?r(t.buffer):t.buffer;return new t.constructor(n,t.byteOffset,t.length)}var r=n(55);t.exports=o},function(t,e){function n(t,e){var n=-1,o=t.length;for(e||(e=Array(o));++n<o;)e[n]=t[n];return e}t.exports=n},function(t,e,n){function o(t,e,n,o){var a=!n;n||(n={});for(var s=-1,u=e.length;++s<u;){var c=e[s],l=o?o(n[c],t[c],c,n,t):void 0;void 0===l&&(l=t[c]),a?i(n,c,l):r(n,c,l)}return n}var r=n(44),i=n(10);t.exports=o},function(t,e,n){var o=n(1),r=o["__core-js_shared__"];t.exports=r},function(t,e,n){function o(t){return r(function(e,n){var o=-1,r=n.length,a=r>1?n[r-1]:void 0,s=r>2?n[2]:void 0;for(a=t.length>3&&"function"==typeof a?(r--,a):void 0,s&&i(n[0],n[1],s)&&(a=r<3?void 0:a,r=1),e=Object(e);++o<r;){var u=n[o];u&&t(e,u,o,a)}return e})}var r=n(20),i=n(72);t.exports=o},function(t,e){function n(t){return function(e,n,o){for(var r=-1,i=Object(e),a=o(e),s=a.length;s--;){var u=a[t?s:++r];if(n(i[u],u,i)===!1)break}return e}}t.exports=n},function(t,e,n){function o(t,e,n,a,s,u){return i(t)&&i(e)&&(u.set(e,t),r(t,e,void 0,o,u),u.delete(e)),t}var r=n(19),i=n(0);t.exports=o},function(t,e,n){function o(t){var e=a.call(t,u),n=t[u];try{t[u]=void 0}catch(t){}var o=s.call(t);return e?t[u]=n:delete t[u],o}var r=n(16),i=Object.prototype,a=i.hasOwnProperty,s=i.toString,u=r?r.toStringTag:void 0;t.exports=o},function(t,e){function n(t,e){return null==t?void 0:t[e]}t.exports=n},function(t,e,n){function o(){this.__data__=r?r(null):{},this.size=0}var r=n(7);t.exports=o},function(t,e){function n(t){var e=this.has(t)&&delete this.__data__[t];return this.size-=e?1:0,e}t.exports=n},function(t,e,n){function o(t){var e=this.__data__;if(r){var n=e[t];return n===i?void 0:n}return s.call(e,t)?e[t]:void 0}var r=n(7),i="__lodash_hash_undefined__",a=Object.prototype,s=a.hasOwnProperty;t.exports=o},function(t,e,n){function o(t){var e=this.__data__;return r?void 0!==e[t]:a.call(e,t)}var r=n(7),i=Object.prototype,a=i.hasOwnProperty;t.exports=o},function(t,e,n){function o(t,e){var n=this.__data__;return this.size+=this.has(t)?0:1,n[t]=r&&void 0===e?i:e,this}var r=n(7),i="__lodash_hash_undefined__";t.exports=o},function(t,e,n){function o(t){return"function"!=typeof t.constructor||a(t)?{}:r(i(t))}var r=n(45),i=n(23),a=n(25);t.exports=o},function(t,e,n){function o(t,e,n){if(!s(n))return!1;var o=typeof e;return!!("number"==o?i(n)&&a(e,n.length):"string"==o&&e in n)&&r(n[e],t)}var r=n(8),i=n(12),a=n(24),s=n(0);t.exports=o},function(t,e){function n(t){var e=typeof t;return"string"==e||"number"==e||"symbol"==e||"boolean"==e?"__proto__"!==t:null===t}t.exports=n},function(t,e,n){function o(t){return!!i&&i in t}var r=n(60),i=function(){var t=/[^.]+$/.exec(r&&r.keys&&r.keys.IE_PROTO||"");return t?"Symbol(src)_1."+t:""}();t.exports=o},function(t,e){function n(){this.__data__=[],this.size=0}t.exports=n},function(t,e,n){function o(t){var e=this.__data__,n=r(e,t);return!(n<0)&&(n==e.length-1?e.pop():a.call(e,n,1),--this.size,!0)}var r=n(4),i=Array.prototype,a=i.splice;t.exports=o},function(t,e,n){function o(t){var e=this.__data__,n=r(e,t);return n<0?void 0:e[n][1]}var r=n(4);t.exports=o},function(t,e,n){function o(t){return r(this.__data__,t)>-1}var r=n(4);t.exports=o},function(t,e,n){function o(t,e){var n=this.__data__,o=r(n,t);return o<0?(++this.size,n.push([t,e])):n[o][1]=e,this}var r=n(4);t.exports=o},function(t,e,n){function o(){this.size=0,this.__data__={hash:new r,map:new(a||i),string:new r}}var r=n(39),i=n(3),a=n(15);t.exports=o},function(t,e,n){function o(t){var e=r(this,t).delete(t);return this.size-=e?1:0,e}var r=n(6);t.exports=o},function(t,e,n){function o(t){return r(this,t).get(t)}var r=n(6);t.exports=o},function(t,e,n){function o(t){return r(this,t).has(t)}var r=n(6);t.exports=o},function(t,e,n){function o(t,e){var n=r(this,t),o=n.size;return n.set(t,e),this.size+=n.size==o?0:1,this}var r=n(6);t.exports=o},function(t,e){function n(t){var e=[];if(null!=t)for(var n in Object(t))e.push(n);return e}t.exports=n},function(t,e,n){(function(t){var o=n(22),r="object"==typeof e&&e&&!e.nodeType&&e,i=r&&"object"==typeof t&&t&&!t.nodeType&&t,a=i&&i.exports===r,s=a&&o.process,u=function(){try{return s&&s.binding&&s.binding("util")}catch(t){}}();t.exports=u}).call(e,n(14)(t))},function(t,e){function n(t){return r.call(t)}var o=Object.prototype,r=o.toString;t.exports=n},function(t,e){function n(t,e){return function(n){return t(e(n))}}t.exports=n},function(t,e,n){function o(t,e,n){return e=i(void 0===e?t.length-1:e,0),function(){for(var o=arguments,a=-1,s=i(o.length-e,0),u=Array(s);++a<s;)u[a]=o[e+a];a=-1;for(var c=Array(e+1);++a<e;)c[a]=o[a];return c[e]=n(u),r(t,this,c)}}var r=n(17),i=Math.max;t.exports=o},function(t,e,n){var o=n(52),r=n(91),i=r(o);t.exports=i},function(t,e){function n(t){var e=0,n=0;return function(){var a=i(),s=r-(a-n);if(n=a,s>0){if(++e>=o)return arguments[0]}else e=0;return t.apply(void 0,arguments)}}var o=800,r=16,i=Date.now;t.exports=n},function(t,e,n){function o(){this.__data__=new r,this.size=0}var r=n(3);t.exports=o},function(t,e){function n(t){var e=this.__data__,n=e.delete(t);return this.size=e.size,n}t.exports=n},function(t,e){function n(t){return this.__data__.get(t)}t.exports=n},function(t,e){function n(t){return this.__data__.has(t)}t.exports=n},function(t,e,n){function o(t,e){var n=this.__data__;if(n instanceof r){var o=n.__data__;if(!i||o.length<s-1)return o.push([t,e]),this.size=++n.size,this;n=this.__data__=new a(o)}return n.set(t,e),this.size=n.size,this}var r=n(3),i=n(15),a=n(40),s=200;t.exports=o},function(t,e){function n(t){if(null!=t){try{return r.call(t)}catch(t){}try{return t+""}catch(t){}}return""}var o=Function.prototype,r=o.toString;t.exports=n},function(t,e){function n(t){return function(){return t}}t.exports=n},function(t,e,n){function o(t){return i(t)&&r(t)}var r=n(12),i=n(2);t.exports=o},function(t,e,n){function o(t){if(!a(t)||r(t)!=s)return!1;var e=i(t);if(null===e)return!0;var n=f.call(e,"constructor")&&e.constructor;return"function"==typeof n&&n instanceof n&&l.call(n)==p}var r=n(5),i=n(23),a=n(2),s="[object Object]",u=Function.prototype,c=Object.prototype,l=u.toString,f=c.hasOwnProperty,p=l.call(Object);t.exports=o},function(t,e,n){var o=n(19),r=n(61),i=r(function(t,e,n,r){o(t,e,n,r)});t.exports=i},function(t,e){function n(){return!1}t.exports=n},function(t,e,n){function o(t){return r(t,i(t))}var r=n(59),i=n(32);t.exports=o},function(t,e){t.exports='<svg viewbox="0 0 18 18">\n  <line class="ql-stroke" x1="15" x2="3" y1="9" y2="9"></line>\n  <line class="ql-stroke" x1="14" x2="4" y1="14" y2="14"></line>\n  <line class="ql-stroke" x1="12" x2="6" y1="4" y2="4"></line>\n</svg>'},function(t,e){t.exports='<svg viewbox="0 0 18 18">\n  <line class="ql-stroke" x1="3" x2="15" y1="9" y2="9"></line>\n  <line class="ql-stroke" x1="3" x2="13" y1="14" y2="14"></line>\n  <line class="ql-stroke" x1="3" x2="9" y1="4" y2="4"></line>\n</svg>'},function(t,e){t.exports='<svg viewbox="0 0 18 18">\n  <line class="ql-stroke" x1="15" x2="3" y1="9" y2="9"></line>\n  <line class="ql-stroke" x1="15" x2="5" y1="14" y2="14"></line>\n  <line class="ql-stroke" x1="15" x2="9" y1="4" y2="4"></line>\n</svg>'},function(t,e){var n;n=function(){return this}();try{n=n||Function("return this")()||(0,eval)("this")}catch(t){"object"==typeof window&&(n=window)}t.exports=n}])});


/***/ }),
/* 2187 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _get = __webpack_require__(1004);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _clone = __webpack_require__(2108);
	
	var _clone2 = _interopRequireDefault(_clone);
	
	var _uniq = __webpack_require__(2188);
	
	var _uniq2 = _interopRequireDefault(_uniq);
	
	var _reactSelect = __webpack_require__(953);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	var _connectToStores = __webpack_require__(1226);
	
	var _connectToStores2 = _interopRequireDefault(_connectToStores);
	
	var _PassBucketActions = __webpack_require__(1869);
	
	var _PassBucketActions2 = _interopRequireDefault(_PassBucketActions);
	
	var _PassBucketStore = __webpack_require__(1867);
	
	var _PassBucketStore2 = _interopRequireDefault(_PassBucketStore);
	
	var _TagActions = __webpack_require__(2038);
	
	var _TagActions2 = _interopRequireDefault(_TagActions);
	
	var _TagStore = __webpack_require__(2039);
	
	var _TagStore2 = _interopRequireDefault(_TagStore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ConfiguratorInjectedSelect = function (_React$Component) {
	  _inherits(ConfiguratorInjectedSelect, _React$Component);
	
	  function ConfiguratorInjectedSelect(props) {
	    _classCallCheck(this, ConfiguratorInjectedSelect);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(ConfiguratorInjectedSelect).call(this, props));
	
	    _this.state = {
	      objects: []
	    };
	    return _this;
	  }
	
	  _createClass(ConfiguratorInjectedSelect, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var _props = this.props;
	      var inject = _props.inject;
	      var eventBucket = _props.eventBucket;
	
	      if (inject.objects === "pass_buckets" || inject.objects === "memberships") {
	        _PassBucketActions2.default.fetchAllForEventBucket.defer(eventBucket.id);
	      } else if (inject.objects === "tags") {
	        _TagActions2.default.fetchAllForBucket.defer(eventBucket.id);
	      }
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(newProps) {
	      var inject = newProps.inject;
	      var value = newProps.value;
	      var eventBucket = newProps.eventBucket;
	
	
	      if (inject.objects === "pass_buckets") {
	        this.setState({
	          objects: newProps.getPassBucketsForEventBucket(eventBucket.id)
	        });
	      } else if (inject.objects === "tags") {
	        this.setState({
	          objects: newProps.getTagsForEventBucket(eventBucket.id)
	        });
	      } else if (inject.objects === "memberships") {
	        this.setState({
	          objects: newProps.getMembershipsForEventBucket(eventBucket.id)
	        });
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _props2 = this.props;
	      var type = _props2.type;
	      var inject = _props2.inject;
	      var repeatable = _props2.repeatable;
	      var repeatableKey = _props2.repeatableKey;
	      var value = _props2.value;
	      var _onChange = _props2.onChange;
	      var objects = this.state.objects;
	
	      // Default value to empty array
	
	      if (repeatable && !value) {
	        value = [];
	      }
	
	      if (type === "multiselect") {
	        var _ret = function () {
	          var options = objects.map(function (o) {
	            return {
	              label: (0, _get2.default)(o, inject.label),
	              value: (0, _get2.default)(o, inject.value)
	            };
	          });
	
	          // For each selected value, clone it again
	          if (repeatable && value.length) {
	            options = options.concat([].concat.apply([], (0, _uniq2.default)(value.filter(function (x) {
	              return !!x;
	            }).map(function (v) {
	              return v.replace(/--.*$/, "");
	            })).map(function (v) {
	              var total = value.filter(function (val) {
	                return val.startsWith(v);
	              }).length,
	                  baseObject = options.find(function (o) {
	                return o.value === v;
	              });
	
	              if (!baseObject) {
	                return undefined;
	              }
	
	              return new Array(total).fill().map(function (_, i) {
	                var o = (0, _clone2.default)(baseObject);
	                o.value += "--" + repeatableKey + (i + 1);
	                return o;
	              });
	            }).filter(function (o) {
	              return !!o;
	            })));
	          }
	
	          return {
	            v: _react2.default.createElement(_reactSelect2.default, {
	              autosize: false,
	              multi: true,
	              placeholder: "None selected",
	              value: value,
	              options: options,
	              onChange: function onChange(selected) {
	                _onChange(selected ? selected.map(function (s) {
	                  return s.value;
	                }) : []);
	              }
	            })
	          };
	        }();
	
	        if ((typeof _ret === "undefined" ? "undefined" : _typeof(_ret)) === "object") return _ret.v;
	      }
	    }
	  }], [{
	    key: "getStores",
	    value: function getStores() {
	      return [_PassBucketStore2.default, _TagStore2.default];
	    }
	  }, {
	    key: "getPropsFromStores",
	    value: function getPropsFromStores() {
	      return {
	        getPassBucketsForEventBucket: _PassBucketStore2.default.getPassBucketsForEventBucket,
	        getTagsForEventBucket: _TagStore2.default.getTagsForEventBucket,
	        getMembershipsForEventBucket: _PassBucketStore2.default.getMembershipsForEventBucket
	      };
	    }
	  }]);
	
	  return ConfiguratorInjectedSelect;
	}(_react2.default.Component);
	
	exports.default = (0, _connectToStores2.default)(ConfiguratorInjectedSelect);
	module.exports = exports["default"];

/***/ }),
/* 2188 */
/***/ (function(module, exports, __webpack_require__) {

	var baseUniq = __webpack_require__(2189);
	
	/**
	 * Creates a duplicate-free version of an array, using
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * for equality comparisons, in which only the first occurrence of each element
	 * is kept. The order of result values is determined by the order they occur
	 * in the array.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Array
	 * @param {Array} array The array to inspect.
	 * @returns {Array} Returns the new duplicate free array.
	 * @example
	 *
	 * _.uniq([2, 1, 2]);
	 * // => [2, 1]
	 */
	function uniq(array) {
	  return (array && array.length) ? baseUniq(array) : [];
	}
	
	module.exports = uniq;


/***/ }),
/* 2189 */
/***/ (function(module, exports, __webpack_require__) {

	var SetCache = __webpack_require__(928),
	    arrayIncludes = __webpack_require__(1365),
	    arrayIncludesWith = __webpack_require__(1370),
	    cacheHas = __webpack_require__(932),
	    createSet = __webpack_require__(2190),
	    setToArray = __webpack_require__(935);
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/**
	 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {Function} [iteratee] The iteratee invoked per element.
	 * @param {Function} [comparator] The comparator invoked per element.
	 * @returns {Array} Returns the new duplicate free array.
	 */
	function baseUniq(array, iteratee, comparator) {
	  var index = -1,
	      includes = arrayIncludes,
	      length = array.length,
	      isCommon = true,
	      result = [],
	      seen = result;
	
	  if (comparator) {
	    isCommon = false;
	    includes = arrayIncludesWith;
	  }
	  else if (length >= LARGE_ARRAY_SIZE) {
	    var set = iteratee ? null : createSet(array);
	    if (set) {
	      return setToArray(set);
	    }
	    isCommon = false;
	    includes = cacheHas;
	    seen = new SetCache;
	  }
	  else {
	    seen = iteratee ? [] : result;
	  }
	  outer:
	  while (++index < length) {
	    var value = array[index],
	        computed = iteratee ? iteratee(value) : value;
	
	    value = (comparator || value !== 0) ? value : 0;
	    if (isCommon && computed === computed) {
	      var seenIndex = seen.length;
	      while (seenIndex--) {
	        if (seen[seenIndex] === computed) {
	          continue outer;
	        }
	      }
	      if (iteratee) {
	        seen.push(computed);
	      }
	      result.push(value);
	    }
	    else if (!includes(seen, computed, comparator)) {
	      if (seen !== result) {
	        seen.push(computed);
	      }
	      result.push(value);
	    }
	  }
	  return result;
	}
	
	module.exports = baseUniq;


/***/ }),
/* 2190 */
/***/ (function(module, exports, __webpack_require__) {

	var Set = __webpack_require__(946),
	    noop = __webpack_require__(1441),
	    setToArray = __webpack_require__(935);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/**
	 * Creates a set object of `values`.
	 *
	 * @private
	 * @param {Array} values The values to add to the set.
	 * @returns {Object} Returns the new set.
	 */
	var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
	  return new Set(values);
	};
	
	module.exports = createSet;


/***/ }),
/* 2191 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _materialUi = __webpack_require__(576);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var QuantityEditor = function (_React$Component) {
	  _inherits(QuantityEditor, _React$Component);
	
	  function QuantityEditor(props) {
	    _classCallCheck(this, QuantityEditor);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(QuantityEditor).call(this, props));
	
	    _this.state = {
	      quantity: props.quantity
	    };
	
	    _this.onChange = _this.onChange.bind(_this);
	    return _this;
	  }
	
	  _createClass(QuantityEditor, [{
	    key: "onChange",
	    value: function onChange(e) {
	      var quantity = e.target.value;
	
	      // Allow negative signs as an intermediate character
	      if (quantity === "-") {
	        return this.setState({ quantity: quantity });
	      }
	
	      // Ignore non-numeric characters
	      if (quantity && quantity != +quantity) {
	        return;
	      }
	
	      if (typeof quantity !== "undefined") {
	        // make whole
	        quantity = Math.ceil(quantity);
	
	        if (typeof this.props.max !== "undefined" && quantity > this.props.max) {
	          quantity = this.props.max;
	        } else if (typeof this.props.min !== "undefined" && quantity < this.props.min) {
	          quantity = this.props.min;
	        }
	        this.props.updateQuantity(quantity);
	      }
	
	      this.setState({ quantity: quantity });
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(newProps) {
	      if (newProps.quantity !== this.state.quantity) {
	        this.setState({ quantity: newProps.quantity });
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        "div",
	        { style: this.props.style },
	        _react2.default.createElement(_materialUi.IconButton, {
	          iconStyle: { fontSize: 12 },
	          iconClassName: "icon-minus",
	          onTouchTap: function onTouchTap() {
	            return _this2.onChange({ target: { value: _this2.state.quantity - 1 } });
	          },
	          disabled: this.state.quantity === this.props.min
	        }),
	        _react2.default.createElement(_materialUi.TextField, {
	          name: "quantity",
	          value: this.state.quantity,
	          onChange: this.onChange,
	          style: { width: 20 }
	        }),
	        _react2.default.createElement(_materialUi.IconButton, {
	          iconStyle: { fontSize: 12 },
	          iconClassName: "icon-plus",
	          onTouchTap: function onTouchTap() {
	            return _this2.onChange({ target: { value: _this2.state.quantity + 1 } });
	          },
	          disabled: this.state.quantity === this.props.max
	        })
	      );
	    }
	  }]);
	
	  return QuantityEditor;
	}(_react2.default.Component);
	
	exports.default = QuantityEditor;
	module.exports = exports["default"];

/***/ }),
/* 2192 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _materialUi = __webpack_require__(576);
	
	var _reactClickToSelect = __webpack_require__(2193);
	
	var _reactClickToSelect2 = _interopRequireDefault(_reactClickToSelect);
	
	var _rcColorPicker = __webpack_require__(2109);
	
	var _rcColorPicker2 = _interopRequireDefault(_rcColorPicker);
	
	var _colr = __webpack_require__(2145);
	
	var _colr2 = _interopRequireDefault(_colr);
	
	var _base = __webpack_require__(1755);
	
	var _base2 = _interopRequireDefault(_base);
	
	var _workingIndicator = __webpack_require__(1664);
	
	var _workingIndicator2 = _interopRequireDefault(_workingIndicator);
	
	var _label = __webpack_require__(1682);
	
	var _label2 = _interopRequireDefault(_label);
	
	var _selectField = __webpack_require__(1683);
	
	var _selectField2 = _interopRequireDefault(_selectField);
	
	var _infoNotice = __webpack_require__(1599);
	
	var _infoNotice2 = _interopRequireDefault(_infoNotice);
	
	var _connectToStores = __webpack_require__(1226);
	
	var _connectToStores2 = _interopRequireDefault(_connectToStores);
	
	var _EventBucketActions = __webpack_require__(1218);
	
	var _EventBucketActions2 = _interopRequireDefault(_EventBucketActions);
	
	var _EventBucketStore = __webpack_require__(1593);
	
	var _EventBucketStore2 = _interopRequireDefault(_EventBucketStore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var EMBED_PAGES = [{ label: "Schedule", value: "schedule", inlineLabel: "schedule" }, { label: "Pass sales", value: "passes/buy", inlineLabel: "pass sales" }, { label: "Membership sales", value: "memberships/buy", inlineLabel: "membership sales" }, { label: "Film guide", value: "films", inlineLabel: "film guide" }, { label: "Welcome page", value: "welcome", inlineLabel: "site" }, { label: "Donation page", value: "donate", inlineLabel: "donation page" }];
	
	var VIEW_MODES = [{ label: "Compact view", value: "compact" }, { label: "Extended view", value: "extended" }, { label: "Timeline view", value: "timeline" }, { label: "Cover view", value: "cover" }, { label: "Grid view", value: "grid" }];
	
	var EventBucketEmbed = function (_React$Component) {
	  _inherits(EventBucketEmbed, _React$Component);
	
	  function EventBucketEmbed(props) {
	    _classCallCheck(this, EventBucketEmbed);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(EventBucketEmbed).call(this, props));
	
	    _this.state = {
	      defaultViewMode: VIEW_MODES[0].value,
	      defaultPage: EMBED_PAGES[0].value,
	      color: "#ffffff",
	      invertTextColor: false,
	      showCustomContent: false,
	      alpha: 0,
	      colr: new _colr2.default()
	    };
	
	    _this.close = _this.close.bind(_this);
	    return _this;
	  }
	
	  _createClass(EventBucketEmbed, [{
	    key: "getStyles",
	    value: function getStyles() {
	      return {
	        pre: {
	          wordWrap: "break-word",
	          whiteSpace: "pre-wrap",
	          padding: "10px",
	          border: "1px solid #ccc",
	          borderRadius: "5px",
	          fontFamily: "monospace",
	          marginTop: "1em",
	          display: "block",
	          minHeight: 100
	        }
	      };
	    }
	  }, {
	    key: "close",
	    value: function close() {
	      this.context.router.push("/event_buckets/" + this.props.params.eventBucketId + "/settings");
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var styles = this.getStyles(),
	          bucket = this.props.getEventBucketById(this.props.params.eventBucketId);
	
	      var query = this.state.defaultPage === "schedule" ? "?viewMode=" + this.state.defaultViewMode : "";
	      var path = this.state.defaultPage;
	
	      return _react2.default.createElement(
	        _base2.default,
	        {
	          title: "Embed wizard",
	          hideTitleAndFooterBorders: true,
	          useMuiDefaultStyle: true,
	          openImmediately: true,
	          actions: [_react2.default.createElement(_materialUi.FlatButton, { label: "Close", onTouchTap: this.close })],
	          modal: true,
	          open: true,
	          onRequestClose: this.close
	        },
	        !bucket ? _react2.default.createElement(_workingIndicator2.default, { fullPage: true }) : _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement(
	            _infoNotice2.default,
	            { style: { marginBottom: 15, fontSize: 12 } },
	            "Check out our",
	            " ",
	            _react2.default.createElement(
	              "a",
	              {
	                href: "http://help.eventive.org/integrations/embed-eventive-on-your-website",
	                target: "_blank"
	              },
	              "guide to embedding Eventive"
	            ),
	            "."
	          ),
	          "Configure, then copy and paste the following HTML code where you'd like the embed to appear.",
	          _react2.default.createElement(_selectField2.default, {
	            label: "Page to embed",
	            clearable: false,
	            value: this.state.defaultPage,
	            options: EMBED_PAGES,
	            onChange: function onChange(o) {
	              return _this2.setState({ defaultPage: o.value });
	            },
	            style: { width: 256 }
	          }),
	          this.state.defaultPage === "schedule" ? _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(_selectField2.default, {
	              label: "Default embedded schedule view mode",
	              clearable: false,
	              value: this.state.defaultViewMode,
	              options: VIEW_MODES,
	              onChange: function onChange(o) {
	                return _this2.setState({ defaultViewMode: o.value });
	              },
	              style: { width: 256 }
	            })
	          ) : null,
	          this.state.defaultPage === "schedule" || this.state.defaultPage === "films" ? _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(
	              _label2.default,
	              null,
	              "Custom content"
	            ),
	            _react2.default.createElement(_materialUi.Checkbox, {
	              checked: this.state.showCustomContent,
	              label: "Include custom content (set via Configurator) in embed",
	              style: { marginTop: -5, marginLeft: -3 },
	              labelStyle: { fontSize: "0.8em", marginLeft: -10 },
	              onCheck: function onCheck(e, isChecked) {
	                _this2.setState({ showCustomContent: isChecked });
	              }
	            })
	          ) : null,
	          _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(
	              _label2.default,
	              null,
	              "Background color"
	            ),
	            _react2.default.createElement(_materialUi.Checkbox, {
	              checked: this.state.alpha === 0,
	              label: "Transparent background",
	              style: { marginTop: -5, marginLeft: -3 },
	              labelStyle: { fontSize: "0.8em", marginLeft: -10 },
	              onCheck: function onCheck(e, isChecked) {
	                _this2.setState({ alpha: isChecked ? 0 : 100 });
	              }
	            }),
	            this.state.alpha !== 0 ? _react2.default.createElement(
	              "div",
	              null,
	              _react2.default.createElement(
	                "span",
	                {
	                  style: {
	                    verticalAlign: 8,
	                    fontSize: "0.8em",
	                    marginRight: 5
	                  }
	                },
	                "Select color:"
	              ),
	              _react2.default.createElement(_rcColorPicker2.default, {
	                animation: "slide-up",
	                color: this.state.color,
	                alpha: this.state.alpha,
	                defaultAlpha: this.state.alpha,
	                onChange: function onChange(_ref) {
	                  var color = _ref.color;
	                  var alpha = _ref.alpha;
	
	                  _this2.setState({ color: color, alpha: alpha });
	                }
	              })
	            ) : null
	          ),
	          _react2.default.createElement(
	            _reactClickToSelect2.default,
	            null,
	            _react2.default.createElement(
	              "pre",
	              { style: styles.pre },
	              "<a id=\"eventive-embed\" href=\"" + bucket.urls.root + path + query + (this.state.showCustomContent ? (query.indexOf("?") === -1 ? "?" : "&") + "showCustomContent=true" : "") + "\"" + (this.state.invertTextColor ? " data-text-color=\"#fff\"" : "") + (this.state.alpha !== 0 ? " data-background-color=\"rgba(" + this.state.colr.fromHex(this.state.color).toRgbArray().join(", ") + ", " + this.state.alpha / 100 + ")\"" : "") + ">View " + bucket.name + " " + EMBED_PAGES.find(function (p) {
	                return p.value === path;
	              }).inlineLabel + ".</a><script type=\"text/javascript\" src=\"" + bucket.urls.root + "embed.js\"></script>"
	            )
	          )
	        )
	      );
	    }
	  }], [{
	    key: "getStores",
	    value: function getStores() {
	      return [_EventBucketStore2.default];
	    }
	  }, {
	    key: "getPropsFromStores",
	    value: function getPropsFromStores() {
	      return {
	        getEventBucketById: _EventBucketStore2.default.getEventBucketById
	      };
	    }
	  }, {
	    key: "contextTypes",
	    get: function get() {
	      return {
	        router: _react2.default.PropTypes.object
	      };
	    }
	  }]);
	
	  return EventBucketEmbed;
	}(_react2.default.Component);
	
	exports.default = (0, _connectToStores2.default)(EventBucketEmbed);
	module.exports = exports["default"];

/***/ }),
/* 2193 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(300);
	
	/**
	 * This component is wrapped around any part of a page.
	 * When that part of the page is clicked, it selects
	 * the text within.
	 */
	var ClickToSelect = React.createClass({
	  propTypes: {
	    children: React.PropTypes.any.isRequired
	  },
	  select: function(e) {
	    e.preventDefault();
	    var range = document.createRange(),
	      sel = window.getSelection();
	    range.selectNodeContents(this._target);
	    sel.removeAllRanges();
	    sel.addRange(range);
	  },
	  render: function() {
	    var self = this;
	    return React.createElement(
	      'div',
	      {
	        onClick: this.select,
	        ref: function(target) {
	          self._target = target;
	        }
	      },
	      this.props.children);
	  }
	});
	
	module.exports = ClickToSelect;


/***/ }),
/* 2194 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _materialUi = __webpack_require__(576);
	
	var _base = __webpack_require__(1755);
	
	var _base2 = _interopRequireDefault(_base);
	
	var _workingIndicator = __webpack_require__(1664);
	
	var _workingIndicator2 = _interopRequireDefault(_workingIndicator);
	
	var _infoNotice = __webpack_require__(1599);
	
	var _infoNotice2 = _interopRequireDefault(_infoNotice);
	
	var _linkLike = __webpack_require__(973);
	
	var _linkLike2 = _interopRequireDefault(_linkLike);
	
	var _label = __webpack_require__(1682);
	
	var _label2 = _interopRequireDefault(_label);
	
	var _connectToStores = __webpack_require__(1226);
	
	var _connectToStores2 = _interopRequireDefault(_connectToStores);
	
	var _EventBucketActions = __webpack_require__(1218);
	
	var _EventBucketActions2 = _interopRequireDefault(_EventBucketActions);
	
	var _EventBucketStore = __webpack_require__(1593);
	
	var _EventBucketStore2 = _interopRequireDefault(_EventBucketStore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var EventBucketDuplicate = function (_React$Component) {
	  _inherits(EventBucketDuplicate, _React$Component);
	
	  function EventBucketDuplicate(props) {
	    _classCallCheck(this, EventBucketDuplicate);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(EventBucketDuplicate).call(this, props));
	
	    var options = [{ label: "Event bucket settings and design", disabled: true }, { label: "Pass buckets", field: "pass_buckets" }, {
	      label: "Events/virtual screenings and ticket buckets",
	      field: "events"
	    }, { label: "Films", field: "films" }, { label: "Tags", field: "tags" }, { label: "Venues", field: "venues" }, { label: "Item buckets", field: "item_buckets" }, { label: "Discounts", field: "coupons" }, { label: "Mailings", field: "mailings" }];
	
	    var selected = {
	      pass_buckets: true,
	      tags: true,
	      venues: true
	    };
	
	    _this.state = {
	      options: options,
	      selected: selected
	    };
	
	    _this.close = _this.close.bind(_this);
	    _this.duplicate = _this.duplicate.bind(_this);
	    return _this;
	  }
	
	  _createClass(EventBucketDuplicate, [{
	    key: "getStyles",
	    value: function getStyles() {
	      return {};
	    }
	  }, {
	    key: "close",
	    value: function close() {
	      this.context.router.push("/event_buckets/" + this.props.params.eventBucketId + "/settings");
	    }
	  }, {
	    key: "duplicate",
	    value: function duplicate() {
	      var _this2 = this;
	
	      _EventBucketActions2.default.duplicate(this.props.params.eventBucketId, {
	        fields: Object.keys(this.state.selected).filter(function (k) {
	          return !!_this2.state.selected[k];
	        })
	      });
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(props) {
	      if (props.newEventBucketId) {
	        window.scrollTo(0, 0);
	        this.context.router.replace("/event_buckets/" + props.newEventBucketId + "/settings");
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this3 = this;
	
	      var styles = this.getStyles(),
	          bucket = this.props.getEventBucketById(this.props.params.eventBucketId);
	
	      return _react2.default.createElement(
	        _base2.default,
	        {
	          title: "Duplicate " + (bucket ? "\"" + bucket.name + "\"" : ""),
	          hideTitleAndFooterBorders: true,
	          useMuiDefaultStyle: true,
	          openImmediately: true,
	          actions: [_react2.default.createElement(_materialUi.FlatButton, { label: "Cancel", onTouchTap: this.close }), _react2.default.createElement(_materialUi.FlatButton, {
	            label: "Duplicate event bucket",
	            onTouchTap: this.duplicate,
	            primary: true
	          })],
	          modal: true,
	          open: true,
	          onRequestClose: this.close
	        },
	        !bucket || this.props.isWorking ? _react2.default.createElement(_workingIndicator2.default, { fullPage: true }) : _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement(
	            _infoNotice2.default,
	            { style: { fontSize: 12 } },
	            "Check out our",
	            " ",
	            _react2.default.createElement(
	              "a",
	              {
	                href: "https://help.eventive.org/events-and-tickets/duplicate-an-event-bucket",
	                target: "_blank"
	              },
	              "guide to duplicating event buckets"
	            ),
	            "."
	          ),
	          _react2.default.createElement(
	            "p",
	            null,
	            "Choose what to copy, then click \"Duplicate event bucket\"."
	          ),
	          this.state.options.map(function (_ref) {
	            var label = _ref.label;
	            var field = _ref.field;
	            var disabled = _ref.disabled;
	
	            return _react2.default.createElement(_materialUi.Checkbox, {
	              checked: disabled || _this3.state.selected[field],
	              disabled: disabled,
	              label: label,
	              style: { marginBottom: 5, width: 400 },
	              onCheck: function onCheck() {
	                var selected = _this3.state.selected;
	
	                selected[field] = !selected[field];
	                _this3.setState({ selected: selected });
	              }
	            });
	          })
	        )
	      );
	    }
	  }], [{
	    key: "getStores",
	    value: function getStores() {
	      return [_EventBucketStore2.default];
	    }
	  }, {
	    key: "getPropsFromStores",
	    value: function getPropsFromStores() {
	      return {
	        isWorking: _EventBucketStore2.default.getState().isWorking,
	        newEventBucketId: _EventBucketStore2.default.getState().newEventBucketId,
	        getEventBucketById: _EventBucketStore2.default.getEventBucketById
	      };
	    }
	  }, {
	    key: "contextTypes",
	    get: function get() {
	      return {
	        router: _react2.default.PropTypes.object
	      };
	    }
	  }]);
	
	  return EventBucketDuplicate;
	}(_react2.default.Component);
	
	exports.default = (0, _connectToStores2.default)(EventBucketDuplicate);
	module.exports = exports["default"];

/***/ }),
/* 2195 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _materialUi = __webpack_require__(576);
	
	var _reactClickToSelect = __webpack_require__(2193);
	
	var _reactClickToSelect2 = _interopRequireDefault(_reactClickToSelect);
	
	var _base = __webpack_require__(1755);
	
	var _base2 = _interopRequireDefault(_base);
	
	var _workingIndicator = __webpack_require__(1664);
	
	var _workingIndicator2 = _interopRequireDefault(_workingIndicator);
	
	var _infoNotice = __webpack_require__(1599);
	
	var _infoNotice2 = _interopRequireDefault(_infoNotice);
	
	var _linkLike = __webpack_require__(973);
	
	var _linkLike2 = _interopRequireDefault(_linkLike);
	
	var _connectToStores = __webpack_require__(1226);
	
	var _connectToStores2 = _interopRequireDefault(_connectToStores);
	
	var _EventBucketActions = __webpack_require__(1218);
	
	var _EventBucketActions2 = _interopRequireDefault(_EventBucketActions);
	
	var _EventBucketStore = __webpack_require__(1593);
	
	var _EventBucketStore2 = _interopRequireDefault(_EventBucketStore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var EventBucketEverywhere = function (_React$Component) {
	  _inherits(EventBucketEverywhere, _React$Component);
	
	  function EventBucketEverywhere(props) {
	    _classCallCheck(this, EventBucketEverywhere);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(EventBucketEverywhere).call(this, props));
	
	    _this.state = {};
	
	    _this.close = _this.close.bind(_this);
	    return _this;
	  }
	
	  _createClass(EventBucketEverywhere, [{
	    key: "getStyles",
	    value: function getStyles() {
	      return {
	        pre: {
	          wordWrap: "break-word",
	          whiteSpace: "pre-wrap",
	          padding: "10px",
	          border: "1px solid #ccc",
	          borderRadius: "5px",
	          fontFamily: "monospace",
	          marginTop: "1em",
	          display: "block",
	          minHeight: 20
	        },
	        widgetHeader: {
	          margin: "1em 0"
	        }
	      };
	    }
	  }, {
	    key: "close",
	    value: function close() {
	      this.context.router.push("/event_buckets/" + this.props.params.eventBucketId + "/settings");
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var styles = this.getStyles(),
	          bucket = this.props.getEventBucketById(this.props.params.eventBucketId);
	
	      var query = this.state.defaultPage === "schedule" ? "?viewMode=" + this.state.defaultViewMode : "";
	      var path = this.state.defaultPage;
	
	      return _react2.default.createElement(
	        _base2.default,
	        {
	          title: "Eventive Everywhere",
	          hideTitleAndFooterBorders: true,
	          useMuiDefaultStyle: true,
	          openImmediately: true,
	          actions: [_react2.default.createElement(_materialUi.FlatButton, { label: "Close", onTouchTap: this.close })],
	          modal: true,
	          open: true,
	          onRequestClose: this.close
	        },
	        !bucket ? _react2.default.createElement(_workingIndicator2.default, { fullPage: true }) : _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement(
	            _infoNotice2.default,
	            { style: { marginBottom: 15, fontSize: 12 } },
	            "Check out our",
	            " ",
	            _react2.default.createElement(
	              "a",
	              {
	                href: "https://help.eventive.org/integrations/eventive-everywhere/introduction-to-eventive-everywhere",
	                target: "_blank"
	              },
	              "introduction to Eventive Everywhere"
	            ),
	            "."
	          ),
	          "To enable Eventive Everywhere on your site, first copy and paste the following block of code immediately ",
	          _react2.default.createElement(
	            "u",
	            null,
	            "before"
	          ),
	          " the closing",
	          " ",
	          _react2.default.createElement(
	            "code",
	            null,
	            "</body>"
	          ),
	          " tag at the bottom of the page.",
	          _react2.default.createElement(
	            _reactClickToSelect2.default,
	            null,
	            _react2.default.createElement(
	              "pre",
	              { style: styles.pre },
	              "<script type=\"text/javascript\" src=\"https://js.stripe.com/v3/\"></script>\n<script type=\"text/javascript\" src=\"" + bucket.urls.root + "loader.js\"></script>"
	            )
	          ),
	          "Then include as many of the following widgets as you'd like!",
	          _react2.default.createElement(
	            "h4",
	            { style: styles.widgetHeader },
	            "Order Tickets"
	          ),
	          _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(
	              "i",
	              null,
	              "Recommended:"
	            ),
	            " Fully functional Eventive \"Order Tickets\" button. Automatically updates when logged in to show already ordered tickets, available passes, etc."
	          ),
	          _react2.default.createElement(
	            _reactClickToSelect2.default,
	            null,
	            _react2.default.createElement(
	              "pre",
	              { style: styles.pre },
	              "<div class=\"eventive-button\" data-event=\"REPLACE_WITH_EVENT_ID\"></div>"
	            )
	          ),
	          _react2.default.createElement(
	            "h4",
	            { style: styles.widgetHeader },
	            "Buy Passes"
	          ),
	          _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(
	              "i",
	              null,
	              "Recommended:"
	            ),
	            " Fully functional Eventive \"Buy Pass\" button. Automatically updates when logged in to show applicable pass discounts. ",
	            _react2.default.createElement(
	              "i",
	              null,
	              "Note:"
	            ),
	            " Use the pass bucket code (e.g.",
	            " ",
	            _react2.default.createElement(
	              "code",
	              null,
	              "vip_pass"
	            ),
	            "), ",
	            _react2.default.createElement(
	              "i",
	              null,
	              "not"
	            ),
	            " the ID."
	          ),
	          _react2.default.createElement(
	            _reactClickToSelect2.default,
	            null,
	            _react2.default.createElement(
	              "pre",
	              { style: styles.pre },
	              "<div class=\"eventive-button\" data-pass-bucket=\"REPLACE_WITH_PASS_BUCKET_CODE\" data-buy-label=\"Buy now\" data-quantity=\"1\" data-discount=\"\"></div>"
	            )
	          ),
	          _react2.default.createElement(
	            "h4",
	            { style: styles.widgetHeader },
	            "Login widget"
	          ),
	          _react2.default.createElement(
	            "div",
	            null,
	            "Indicates if the customer is currently logged in and offers the option to log in / out. Unstyled by default so it can be integrated with your design as desired."
	          ),
	          _react2.default.createElement(
	            _reactClickToSelect2.default,
	            null,
	            _react2.default.createElement(
	              "pre",
	              { style: styles.pre },
	              "<div class=\"eventive-login\"></div>"
	            )
	          ),
	          _react2.default.createElement(
	            "h4",
	            { style: styles.widgetHeader },
	            "[Advanced] Fully custom checkout dialog"
	          ),
	          _react2.default.createElement(
	            "div",
	            null,
	            "If you have your own pre-styled \"Order Tickets\" button HTML, you can wrap it in the following snippet and when customers click the button, an Eventive checkout modal will appear, right on your site.",
	            " ",
	            _react2.default.createElement(
	              "i",
	              null,
	              "Note: Does not allow customers to use passes. For pass functionality, see \"Order Tickets\" above."
	            )
	          ),
	          _react2.default.createElement(
	            _reactClickToSelect2.default,
	            null,
	            _react2.default.createElement(
	              "pre",
	              { style: styles.pre },
	              "<div class=\"eventive-custom-button\" data-event=\"REPLACE_WITH_EVENT_ID\">\n    /* Your custom HTML goes here */\n</div>"
	            )
	          )
	        )
	      );
	    }
	  }], [{
	    key: "getStores",
	    value: function getStores() {
	      return [_EventBucketStore2.default];
	    }
	  }, {
	    key: "getPropsFromStores",
	    value: function getPropsFromStores() {
	      return {
	        getEventBucketById: _EventBucketStore2.default.getEventBucketById
	      };
	    }
	  }, {
	    key: "contextTypes",
	    get: function get() {
	      return {
	        router: _react2.default.PropTypes.object
	      };
	    }
	  }]);
	
	  return EventBucketEverywhere;
	}(_react2.default.Component);
	
	exports.default = (0, _connectToStores2.default)(EventBucketEverywhere);
	module.exports = exports["default"];

/***/ }),
/* 2196 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _materialUi = __webpack_require__(576);
	
	var _reactRouter = __webpack_require__(486);
	
	var _connectToStores = __webpack_require__(1226);
	
	var _connectToStores2 = _interopRequireDefault(_connectToStores);
	
	var _EventBucketStore = __webpack_require__(1593);
	
	var _EventBucketStore2 = _interopRequireDefault(_EventBucketStore);
	
	var _EventBucketActions = __webpack_require__(1218);
	
	var _EventBucketActions2 = _interopRequireDefault(_EventBucketActions);
	
	var _linkLike = __webpack_require__(973);
	
	var _linkLike2 = _interopRequireDefault(_linkLike);
	
	var _workingIndicator = __webpack_require__(1664);
	
	var _workingIndicator2 = _interopRequireDefault(_workingIndicator);
	
	var _schedulerOverlay = __webpack_require__(2197);
	
	var _schedulerOverlay2 = _interopRequireDefault(_schedulerOverlay);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import SchedulerStore from '../stores/SchedulerStore';
	// import SchedulerActions from '../actions/SchedulerActions';
	
	var Scheduler = function (_React$Component) {
	  _inherits(Scheduler, _React$Component);
	
	  function Scheduler(props) {
	    _classCallCheck(this, Scheduler);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(Scheduler).call(this, props));
	
	    _this.state = {
	      openedSchedule: null
	    };
	    return _this;
	  }
	
	  _createClass(Scheduler, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.componentWillReceiveProps(this.props);
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(props) {}
	  }, {
	    key: "getStyles",
	    value: function getStyles() {
	      return {
	        header: {
	          textAlign: "center",
	          marginBottom: "1em"
	        },
	        body: {
	          textAlign: "center"
	        },
	        intro: {
	          color: "rgb(33,33,33)",
	          textAlign: "center"
	        },
	        childen: {
	          textAlign: "left",
	          fontSize: "12pt"
	        }
	      };
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var eventBucketId = this.props.params.eventBucketId;
	      var eventBucket = this.props.getEventBucketById(eventBucketId);
	      var styles = this.getStyles();
	
	      if (!eventBucket) {
	        return _react2.default.createElement(_workingIndicator2.default, { fullPage: true });
	      }
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        this.state.openedSchedule,
	        _react2.default.createElement(
	          "h1",
	          { style: styles.header },
	          eventBucket.name,
	          " Scheduler"
	        ),
	        _react2.default.createElement(
	          "div",
	          { style: styles.body },
	          _react2.default.createElement(
	            "div",
	            { style: styles.childen },
	            _react2.default.createElement(
	              "p",
	              { style: styles.intro },
	              "Use Eventive Scheduler to easily schedule showings."
	            )
	          )
	        )
	      );
	    }
	  }], [{
	    key: "getStores",
	    value: function getStores() {
	      return [_EventBucketStore2.default];
	    }
	  }, {
	    key: "getPropsFromStores",
	    value: function getPropsFromStores() {
	      return {
	        getEventBucketById: _EventBucketStore2.default.getEventBucketById
	      };
	    }
	  }]);
	
	  return Scheduler;
	}(_react2.default.Component);
	
	Scheduler.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	exports.default = (0, _connectToStores2.default)(Scheduler);
	module.exports = exports["default"];

/***/ }),
/* 2197 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.appendTimeZone = exports.stripTimeZone = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _materialUi = __webpack_require__(576);
	
	var _TimePicker = __webpack_require__(900);
	
	var _TimePicker2 = _interopRequireDefault(_TimePicker);
	
	var _reactSelect = __webpack_require__(953);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	var _reactDateRange = __webpack_require__(2198);
	
	var _momentTimezone = __webpack_require__(1185);
	
	var _momentTimezone2 = _interopRequireDefault(_momentTimezone);
	
	var _rrule = __webpack_require__(2259);
	
	var _base = __webpack_require__(1755);
	
	var _base2 = _interopRequireDefault(_base);
	
	var _label = __webpack_require__(1682);
	
	var _label2 = _interopRequireDefault(_label);
	
	var _immutabilityHelper = __webpack_require__(2261);
	
	var _immutabilityHelper2 = _interopRequireDefault(_immutabilityHelper);
	
	var _IconButton = __webpack_require__(580);
	
	var _IconButton2 = _interopRequireDefault(_IconButton);
	
	var _FloatingActionButton = __webpack_require__(719);
	
	var _FloatingActionButton2 = _interopRequireDefault(_FloatingActionButton);
	
	var _add = __webpack_require__(2263);
	
	var _add2 = _interopRequireDefault(_add);
	
	var _remove = __webpack_require__(2264);
	
	var _remove2 = _interopRequireDefault(_remove);
	
	var _delete = __webpack_require__(2057);
	
	var _delete2 = _interopRequireDefault(_delete);
	
	var _recurringUpdateOptions = __webpack_require__(2265);
	
	var _recurringUpdateOptions2 = _interopRequireDefault(_recurringUpdateOptions);
	
	var _datetimeField = __webpack_require__(2061);
	
	var _datetimeField2 = _interopRequireDefault(_datetimeField);
	
	var _datetimePicker = __webpack_require__(2062);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import ActionAdd from 'material-ui/svg-icons/action/alarm-add';
	
	
	// Todo: unify
	var OPTIONS = {
	  CURRENT: "single",
	  FUTURE: "future",
	  ALL: "all"
	};
	
	var styles = {
	  timePicker: { display: "inline-block", minWidth: 80 },
	  timePickerRow: {
	    display: "flex",
	    alignItems: "center",
	    justifyContent: "space-between",
	    position: "relative"
	  },
	  addIcon: {
	    position: "absolute",
	    right: 0
	  },
	  removeIcon: {
	    position: "absolute",
	    right: 0
	  }
	};
	
	var WEEKDAYS = [{ label: "F", value: 4 }, { label: "S", value: 5 }, { label: "Su", value: 6 }, { label: "M", value: 0 }, { label: "Tu", value: 1 }, { label: "W", value: 2 }, { label: "Th", value: 3 }];
	
	/*
	 * The below two functions are needed because material-ui's TimePicker only works with dates in the local timezone.
	 */
	
	// Converts a date with a timezone to one without, i.e., Jun 10, 2019 5:00 PM PST --> June 10, 2019 5:00 PM UTC
	var stripTimeZone = exports.stripTimeZone = function stripTimeZone(d) {
	  return new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate(), d.getHours(), d.getMinutes(), d.getSeconds()));
	};
	
	// Converts a date without a timezone back to a date with the current time zone -- opposite of stripTimeZone. i.e., Jun 10, 2019 5:00 PM UTC --> June 10, 2019 5:00 PM PST
	var appendTimeZone = exports.appendTimeZone = function appendTimeZone(d) {
	  return new Date(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate(), d.getUTCHours(), d.getUTCMinutes(), d.getUTCSeconds());
	};
	
	// Sets the month and date and year of *d* to that of *date*.
	var setMonthDateYear = function setMonthDateYear(d, date) {
	  if (date._isAMomentObject) {
	    date = date.toDate();
	  }
	  if (d._isAMomentObject) {
	    d = d.toDate();
	  }
	  var d_ = new Date(d.getTime());
	  d_.setDate(date.getDate());
	  d_.setMonth(date.getMonth());
	  d_.setYear(date.getFullYear());
	  return d_;
	};
	
	// Gets the difference between *endTime* and *startTime*.
	// TODO: If endTime < startTime, should we add one day to endTime (for example when an event is happening from 11 PM - 1 AM)?
	var getDifference = function getDifference(endTime, startTime) {
	  return endTime.getTime() - startTime.getTime();
	};
	
	// Convert timezone to moment.js format normalized identifier. To do this, we filter down the set
	// of timezones to only the "valid" ones for each country, then if a link exists between zones to
	// a valid one, we use that instead.
	// For example, converting US/Central -> America/Chicago
	// Ref: https://github.com/moment/moment-timezone/issues/227#issuecomment-629098169
	var _generateValidTimezones = function _generateValidTimezones() {
	  var zones = new Set();
	  var countries = _momentTimezone2.default.tz.countries();
	  var _iteratorNormalCompletion = true;
	  var _didIteratorError = false;
	  var _iteratorError = undefined;
	
	  try {
	    for (var _iterator = countries[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	      var country = _step.value;
	
	      _momentTimezone2.default.tz.zonesForCountry(country).reduce(function (set, zone) {
	        return set.add(zone);
	      }, zones);
	    }
	  } catch (err) {
	    _didIteratorError = true;
	    _iteratorError = err;
	  } finally {
	    try {
	      if (!_iteratorNormalCompletion && _iterator.return) {
	        _iterator.return();
	      }
	    } finally {
	      if (_didIteratorError) {
	        throw _iteratorError;
	      }
	    }
	  }
	
	  return Array.from(zones).sort();
	};
	var _tzToIdentifier = function _tzToIdentifier(name) {
	  return (name || "").toLowerCase().replace(/\//g, "_");
	};
	var _normalizeTimezone = function _normalizeTimezone(name) {
	  var link = _momentTimezone2.default.tz._links[_tzToIdentifier(name)];
	  if (link) {
	    var baseTz = _momentTimezone2.default.tz._zones[link];
	    if (baseTz && _generateValidTimezones().indexOf(baseTz.name) !== -1) {
	      return baseTz.name;
	    }
	  }
	  return name;
	};
	
	var SchedulerOverlay = function (_React$Component) {
	  _inherits(SchedulerOverlay, _React$Component);
	
	  function SchedulerOverlay(props) {
	    _classCallCheck(this, SchedulerOverlay);
	
	    // Rewrite timezone to an IANA standard (non-deprecated) timezone. This is because rrule is
	    // picky about matching exactly, and has a smaller subset of available options.
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(SchedulerOverlay).call(this, props));
	
	    var timezone = _normalizeTimezone(_this.props.timezone);
	    console.log("[SchedulerOverlay] Loaded timezone: " + _this.props.timezone + " => " + timezone);
	
	    if (_this.props.repeats) {
	      var startDate = (0, _momentTimezone2.default)(appendTimeZone((0, _rrule.rrulestr)(_this.props.repeats[0].rrule).options.dtstart));
	      var endDate = (0, _momentTimezone2.default)(appendTimeZone((0, _rrule.rrulestr)(_this.props.repeats[0].rrule).options.until));
	      startDate.add((0, _datetimePicker.timezoneDelta)(startDate, timezone), "minutes");
	      endDate.add((0, _datetimePicker.timezoneDelta)(endDate, timezone), "minutes");
	
	      _this.state = {
	        timezone: timezone,
	        applyRecurring: OPTIONS.ALL,
	        showApplyRecurring: true,
	        startDate: startDate,
	        endDate: endDate,
	        repeatsInvalid: new Set(),
	        repeats: _this.props.repeats.map(function (_ref) {
	          var rrule = _ref.rrule;
	          var duration = _ref.duration;
	
	          rrule = (0, _rrule.rrulestr)(rrule);
	          var startDate = (0, _momentTimezone2.default)(appendTimeZone(rrule.options.dtstart));
	          var endDate = (0, _momentTimezone2.default)(appendTimeZone(rrule.options.until));
	          startDate.add((0, _datetimePicker.timezoneDelta)(startDate, timezone), "minutes");
	          endDate.add((0, _datetimePicker.timezoneDelta)(endDate, timezone), "minutes");
	
	          return {
	            startTime: startDate.toDate(),
	            endTime: (0, _momentTimezone2.default)(startDate).add(duration, "ms").toDate(),
	            freq: _rrule.RRule.WEEKLY, //rrule.options.freq,
	            interval: 1, //rrule.options.interval,
	            byweekday: new Set(rrule.options.byweekday || []),
	            tzid: timezone
	          };
	        })
	      };
	    } else {
	      _this.state = {
	        timezone: timezone,
	        applyRecurring: OPTIONS.CURRENT,
	        showApplyRecurring: false,
	        startDate: _this.props.start_time ? _this.props.start_time.toDate() : (0, _momentTimezone2.default)().toDate(),
	        endDate: _this.props.start_time ? (0, _momentTimezone2.default)(_this.props.start_time.toDate()).add(7, "days").toDate() : (0, _momentTimezone2.default)().add(7, "days").toDate(),
	        repeatsInvalid: new Set(),
	        repeats: [{
	          startTime: _this.props.start_time ? _this.props.start_time.toDate() : null,
	          endTime: _this.props.end_time ? _this.props.end_time.toDate() : null,
	          freq: _rrule.RRule.WEEKLY,
	          interval: 1,
	          byweekday: new Set()
	        }]
	      };
	    }
	
	    _this.validateRepeat = _this.validateRepeat.bind(_this);
	    _this.validateAllRepeats = _this.validateAllRepeats.bind(_this);
	    return _this;
	  }
	
	  _createClass(SchedulerOverlay, [{
	    key: "validateRepeat",
	    value: function validateRepeat(repeat) {
	      var options = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	
	      var startTimeMoment = (0, _momentTimezone2.default)(this.state.startDate);
	      var endTimeMoment = (0, _momentTimezone2.default)(this.state.endDate);
	
	      var daysDifference = endTimeMoment.diff(startTimeMoment, 'days') + 1;
	
	      if (daysDifference >= 7) {
	        this.setState(function (state) {
	          var newInvalidRepeats = new Set(state.repeatsInvalid);
	          newInvalidRepeats.delete(options.repeatIndex);
	
	          return { repeatsInvalid: newInvalidRepeats };
	        });
	        return true;
	      }
	
	      var currentDay = startTimeMoment.day();
	      var endDay = endTimeMoment.day();
	      var availableDays = [endDay];
	
	      while (currentDay !== endDay) {
	        availableDays.push(currentDay);
	
	        if (currentDay === 6) {
	          currentDay = 0;
	        } else {
	          currentDay++;
	        }
	      }
	
	      //convert available days to an array of available days where Monday is the zero-th day.
	      //this will make it valid with WEEKDAYS "enum"
	      var convertedAvailableDays = availableDays.map(function (day) {
	        if (day === 0) {
	          return 6;
	        }
	
	        return day - 1;
	      });
	
	      var _iteratorNormalCompletion2 = true;
	      var _didIteratorError2 = false;
	      var _iteratorError2 = undefined;
	
	      try {
	        for (var _iterator2 = repeat.byweekday[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	          var weekDay = _step2.value;
	
	          if (weekDay === options.recentlyRemoved) {
	            continue;
	          }
	
	          if (!convertedAvailableDays.includes(weekDay)) {
	            this.setState(function (state) {
	              return { repeatsInvalid: new Set(state.repeatsInvalid).add(options.repeatIndex) };
	            });
	            return false;
	          }
	        }
	      } catch (err) {
	        _didIteratorError2 = true;
	        _iteratorError2 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion2 && _iterator2.return) {
	            _iterator2.return();
	          }
	        } finally {
	          if (_didIteratorError2) {
	            throw _iteratorError2;
	          }
	        }
	      }
	
	      if (options.recentlyAdded && !convertedAvailableDays.includes(options.recentlyAdded)) {
	        this.setState(function (state) {
	          return { repeatsInvalid: new Set(state.repeatsInvalid).add(options.repeatIndex) };
	        });
	        return false;
	      }
	
	      this.setState(function (state) {
	        var newInvalidRepeats = new Set(state.repeatsInvalid);
	        newInvalidRepeats.delete(options.repeatIndex);
	
	        return { repeatsInvalid: newInvalidRepeats };
	      });
	      return true;
	    }
	  }, {
	    key: "validateAllRepeats",
	    value: function validateAllRepeats() {
	      var _this2 = this;
	
	      var recentlyRemoved = arguments.length <= 0 || arguments[0] === undefined ? -1 : arguments[0];
	
	      return this.state.repeats.reduce(function (count, repeat, index) {
	        if (index === recentlyRemoved) {
	          _this2.setState(function (state) {
	            var newInvalidRepeats = new Set(state.repeatsInvalid);
	            newInvalidRepeats.delete(recentlyRemoved);
	
	            return { repeatsInvalid: newInvalidRepeats };
	          });
	          return count;
	        }
	
	        return count + (_this2.validateRepeat(repeat, { repeatIndex: index }) ? 0 : 1);
	      }, 0);
	    }
	  }, {
	    key: "save",
	    value: function save() {
	      var _this3 = this;
	
	      var invalidRepeats = this.validateAllRepeats();
	
	      if (invalidRepeats > 0) {
	        return;
	      }
	      var repeats = this.state.repeats.map(function (_ref2) {
	        var freq = _ref2.freq;
	        var interval = _ref2.interval;
	        var _ref2$startDate = _ref2.startDate;
	        var startDate = _ref2$startDate === undefined ? _this3.state.startDate : _ref2$startDate;
	        var _ref2$endDate = _ref2.endDate;
	        var endDate = _ref2$endDate === undefined ? _this3.state.endDate : _ref2$endDate;
	        var startTime = _ref2.startTime;
	        var endTime = _ref2.endTime;
	        var byweekday = _ref2.byweekday;
	        var tzid = _ref2.tzid;
	
	        var start = stripTimeZone(setMonthDateYear(startTime, startDate));
	        var end = stripTimeZone(setMonthDateYear(endTime, endDate));
	        var firstEventEnd = stripTimeZone(setMonthDateYear(endTime, startDate));
	
	        var delta = (0, _datetimePicker.timezoneDelta)(start, _this3.state.timezone);
	        var convertedStart = (0, _momentTimezone2.default)(start).add(-delta, "minutes").toDate();
	        var convertedEnd = (0, _momentTimezone2.default)(end).add(-delta, "minutes").toDate();
	
	        return {
	          rrule: new _rrule.RRule({
	            freq: freq,
	            interval: interval,
	            dtstart: convertedStart,
	            until: convertedEnd,
	            byweekday: Array.from(byweekday),
	            tzid: _this3.state.timezone // force update
	          }).toString(),
	          duration: getDifference(firstEventEnd, start)
	        };
	      });
	      this.props.onChange({ repeats: repeats, applyRecurring: this.state.applyRecurring }, this.props.onRequestClose);
	    }
	  }, {
	    key: "setRepeatItem",
	    value: function setRepeatItem(i, key, value) {
	      return this.setState({
	        repeats: (0, _immutabilityHelper2.default)(this.state.repeats, _defineProperty({}, i, _defineProperty({}, key, { $set: value })))
	      });
	    }
	  }, {
	    key: "addByWeekday",
	    value: function addByWeekday(i, value) {
	      this.validateRepeat(this.state.repeats[i], { recentlyAdded: value, repeatIndex: i });
	      return this.setState({
	        repeats: (0, _immutabilityHelper2.default)(this.state.repeats, _defineProperty({}, i, { byweekday: { $add: [value] } }))
	      });
	    }
	  }, {
	    key: "removeByWeekday",
	    value: function removeByWeekday(i, value) {
	      this.validateRepeat(this.state.repeats[i], { recentlyRemoved: value, repeatIndex: i });
	      return this.setState({
	        repeats: (0, _immutabilityHelper2.default)(this.state.repeats, _defineProperty({}, i, { byweekday: { $remove: [value] } }))
	      });
	    }
	  }, {
	    key: "addRepeat",
	    value: function addRepeat() {
	      var newRepeat = _extends({}, this.state.repeats[0]);
	      newRepeat.startTime = null;
	      newRepeat.endTime = null;
	      newRepeat.byweekday = new Set();
	      return this.setState({
	        repeats: (0, _immutabilityHelper2.default)(this.state.repeats, { $push: [newRepeat] })
	      });
	    }
	  }, {
	    key: "removeRepeat",
	    value: function removeRepeat(i) {
	      this.validateAllRepeats(i);
	
	      return this.setState({
	        repeats: (0, _immutabilityHelper2.default)(this.state.repeats, { $splice: [[i, 1]] })
	      });
	    }
	  }, {
	    key: "setAllDates",
	    value: function setAllDates(_ref3) {
	      var startDate = _ref3.startDate;
	      var endDate = _ref3.endDate;
	
	      this.setState({
	        startDate: startDate,
	        endDate: endDate
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this4 = this;
	
	      var name = this.props.name;
	
	      return _react2.default.createElement(
	        _base2.default,
	        {
	          onRequestClose: function onRequestClose(e) {
	            return _this4.props.onRequestClose();
	          },
	          useMuiDefaultStyle: true,
	          actions: [_react2.default.createElement(_materialUi.FlatButton, {
	            label: "Cancel",
	            onTouchTap: function onTouchTap(e) {
	              return _this4.props.onRequestClose();
	            }
	          }), _react2.default.createElement(_materialUi.FlatButton, {
	            primary: true,
	            label: "Save showtimes",
	            disabled: this.state.repeatsInvalid.size !== 0,
	            onTouchTap: function onTouchTap(e) {
	              return _this4.save();
	            }
	          })]
	        },
	        _react2.default.createElement(
	          "div",
	          { style: { marginBottom: 10 } },
	          "Edit the schedule for \"",
	          name,
	          "\"."
	        ),
	        _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement(_datetimeField2.default, {
	            value: this.state.startDate,
	            label: "First day of run",
	            unclearable: true,
	            hideTime: true,
	            onChange: function onChange(e, v) {
	              return _this4.setState({ startDate: v });
	            },
	            style: { display: "inline-block", marginRight: 24 }
	          }),
	          _react2.default.createElement(_datetimeField2.default, {
	            value: this.state.endDate,
	            label: "Last day of run",
	            unclearable: true,
	            hideTime: true,
	            onChange: function onChange(e, v) {
	              return _this4.setState({ endDate: v });
	            },
	            style: { display: "inline-block" }
	          })
	        ),
	        _react2.default.createElement(
	          _label2.default,
	          { style: { marginBottom: -2 } },
	          "Showtimes"
	        ),
	        this.state.repeats.map(function (repeat, i) {
	          return _react2.default.createElement(
	            "div",
	            { key: i, style: {} },
	            false && _react2.default.createElement(
	              "div",
	              null,
	              _react2.default.createElement(
	                _label2.default,
	                null,
	                "Schedule"
	              ),
	              _react2.default.createElement(
	                "div",
	                { style: { display: "flex" } },
	                _react2.default.createElement(
	                  "div",
	                  { style: { flex: 1, width: 120 } },
	                  "Every",
	                  _react2.default.createElement(_materialUi.TextField, {
	                    hintText: "",
	                    value: repeat.interval,
	                    style: {
	                      display: "inline-block",
	                      marginLeft: 20,
	                      maxWidth: 50,
	                      textAlign: "right"
	                    },
	                    onChange: function onChange(e) {
	                      return _this4.setRepeatItem(i, "interval", e.target.value);
	                    }
	                  })
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { style: { flex: 2, alignSelf: "center", maxWidth: 300 } },
	                  _react2.default.createElement(_reactSelect2.default, {
	                    value: repeat.freq,
	                    options: [{ label: "day", value: _rrule.RRule.DAILY }, { label: "week", value: _rrule.RRule.WEEKLY }, { label: "month", value: _rrule.RRule.MONTHLY }, { label: "year", value: _rrule.RRule.YEARLY }].map(function (e) {
	                      return _extends({}, e, {
	                        label: e.label + (repeat.freq > 1 ? "s" : "")
	                      });
	                    }),
	                    onChange: function onChange(option) {
	                      return option && _this4.setRepeatItem(i, "freq", option.value);
	                    }
	                  })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { style: styles.timePickerRow },
	              _react2.default.createElement(_datetimeField2.default, {
	                value: repeat.startTime,
	                hintText: "Start time",
	                unclearable: true,
	                hideDate: true,
	                timezone: _this4.state.timezone,
	                useMoment: true,
	                onChange: function onChange(e, d) {
	                  return _this4.setRepeatItem(i, "startTime", d);
	                },
	                style: styles.timePicker
	              }),
	              _react2.default.createElement(
	                "div",
	                { style: { padding: "0 20px" } },
	                "to"
	              ),
	              _react2.default.createElement(_datetimeField2.default, {
	                value: repeat.endTime,
	                hintText: "End time",
	                unclearable: true,
	                hideDate: true,
	                timezone: _this4.state.timezone,
	                useMoment: true,
	                onChange: function onChange(e, d) {
	                  return _this4.setRepeatItem(i, "endTime", d);
	                },
	                style: styles.timePicker
	              }),
	              _react2.default.createElement(
	                "div",
	                { style: { paddingLeft: 50, flex: 10 } },
	                WEEKDAYS.map(function (_ref4) {
	                  var label = _ref4.label;
	                  var value = _ref4.value;
	                  return _react2.default.createElement(_materialUi.RaisedButton, {
	                    label: label,
	                    primary: repeat.byweekday.has(value),
	                    style: { marginRight: 5 },
	                    labelStyle: { textTransform: "initial" },
	                    onClick: function onClick() {
	                      return repeat.byweekday.has(value) ? _this4.removeByWeekday(i, value) : _this4.addByWeekday(i, value);
	                    }
	                  });
	                })
	              ),
	              i === _this4.state.repeats.length - 1 ? _react2.default.createElement(
	                _IconButton2.default,
	                {
	                  style: styles.addIcon,
	                  onClick: function onClick(e) {
	                    return _this4.addRepeat();
	                  },
	                  tooltip: "Add recurrence",
	                  disabled: !repeat.startTime || !repeat.endTime
	                },
	                _react2.default.createElement(_add2.default, null)
	              ) : _react2.default.createElement(
	                _IconButton2.default,
	                {
	                  style: styles.removeIcon,
	                  onClick: function onClick(e) {
	                    return _this4.removeRepeat(i);
	                  },
	                  tooltip: "Remove recurrence"
	                },
	                _react2.default.createElement(_delete2.default, null)
	              )
	            )
	          );
	        }),
	        this.state.showApplyRecurring && _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement(
	            _label2.default,
	            null,
	            "Apply to:"
	          ),
	          _react2.default.createElement(_recurringUpdateOptions2.default, {
	            value: this.state.applyRecurring,
	            onChange: function onChange(e) {
	              return _this4.setState({ applyRecurring: e });
	            },
	            hideCurrent: true
	          })
	        ),
	        this.state.repeatsInvalid.size !== 0 && _react2.default.createElement(
	          "p",
	          null,
	          "The scheduled showtime is not available in between the first and last day of the run, please check your showtimes to ensure they occur during the scheduled run of your event."
	        )
	      );
	    }
	  }]);
	
	  return SchedulerOverlay;
	}(_react2.default.Component);
	
	exports.default = SchedulerOverlay;

/***/ }),
/* 2198 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _DateRange = __webpack_require__(2199);
	
	Object.defineProperty(exports, 'DateRange', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_DateRange).default;
	  }
	});
	
	var _Calendar = __webpack_require__(2200);
	
	Object.defineProperty(exports, 'Calendar', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Calendar).default;
	  }
	});
	
	var _DateRangePicker = __webpack_require__(2256);
	
	Object.defineProperty(exports, 'DateRangePicker', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_DateRangePicker).default;
	  }
	});
	
	var _DefinedRange = __webpack_require__(2257);
	
	Object.defineProperty(exports, 'DefinedRange', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_DefinedRange).default;
	  }
	});
	
	var _defaultRanges = __webpack_require__(2258);
	
	Object.defineProperty(exports, 'defaultInputRanges', {
	  enumerable: true,
	  get: function get() {
	    return _defaultRanges.defaultInputRanges;
	  }
	});
	Object.defineProperty(exports, 'defaultStaticRanges', {
	  enumerable: true,
	  get: function get() {
	    return _defaultRanges.defaultStaticRanges;
	  }
	});
	Object.defineProperty(exports, 'createStaticRanges', {
	  enumerable: true,
	  get: function get() {
	    return _defaultRanges.createStaticRanges;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 2199 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(956);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Calendar = __webpack_require__(2200);
	
	var _Calendar2 = _interopRequireDefault(_Calendar);
	
	var _DayCell = __webpack_require__(2201);
	
	var _utils = __webpack_require__(2237);
	
	var _min = __webpack_require__(2245);
	
	var _min2 = _interopRequireDefault(_min);
	
	var _addDays = __webpack_require__(2250);
	
	var _addDays2 = _interopRequireDefault(_addDays);
	
	var _differenceInCalendarDays = __webpack_require__(2247);
	
	var _differenceInCalendarDays2 = _interopRequireDefault(_differenceInCalendarDays);
	
	var _isBefore = __webpack_require__(2204);
	
	var _isBefore2 = _interopRequireDefault(_isBefore);
	
	var _classnames = __webpack_require__(958);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _styles = __webpack_require__(2255);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DateRange = function (_Component) {
	  _inherits(DateRange, _Component);
	
	  function DateRange(props, context) {
	    _classCallCheck(this, DateRange);
	
	    var _this = _possibleConstructorReturn(this, (DateRange.__proto__ || Object.getPrototypeOf(DateRange)).call(this, props, context));
	
	    _this.setSelection = _this.setSelection.bind(_this);
	    _this.handleRangeFocusChange = _this.handleRangeFocusChange.bind(_this);
	    _this.updatePreview = _this.updatePreview.bind(_this);
	    _this.calcNewSelection = _this.calcNewSelection.bind(_this);
	    _this.state = {
	      focusedRange: props.initialFocusedRange || [(0, _utils.findNextRangeIndex)(props.ranges), 0],
	      preview: null
	    };
	    _this.styles = (0, _utils.generateStyles)([_styles2.default, props.classNames]);
	    return _this;
	  }
	
	  _createClass(DateRange, [{
	    key: 'calcNewSelection',
	    value: function calcNewSelection(value) {
	      var isSingleValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	      var focusedRange = this.props.focusedRange || this.state.focusedRange;
	      var _props = this.props,
	          ranges = _props.ranges,
	          onChange = _props.onChange,
	          maxDate = _props.maxDate,
	          moveRangeOnFirstSelection = _props.moveRangeOnFirstSelection;
	
	      var focusedRangeIndex = focusedRange[0];
	      var selectedRange = ranges[focusedRangeIndex];
	      if (!selectedRange || !onChange) return {};
	
	      var startDate = selectedRange.startDate,
	          endDate = selectedRange.endDate;
	
	      if (!endDate) endDate = new Date(startDate);
	      var nextFocusRange = void 0;
	      if (!isSingleValue) {
	        startDate = value.startDate;
	        endDate = value.endDate;
	      } else if (focusedRange[1] === 0) {
	        // startDate selection
	        var dayOffset = (0, _differenceInCalendarDays2.default)(endDate, startDate);
	        startDate = value;
	        endDate = moveRangeOnFirstSelection ? (0, _addDays2.default)(value, dayOffset) : value;
	        if (maxDate) endDate = (0, _min2.default)([endDate, maxDate]);
	        nextFocusRange = [focusedRange[0], 1];
	      } else {
	        endDate = value;
	      }
	      // reverse dates if startDate before endDate
	      if ((0, _isBefore2.default)(endDate, startDate)) {
	        var _ref = [endDate, startDate];
	        startDate = _ref[0];
	        endDate = _ref[1];
	      }
	
	      if (!nextFocusRange) {
	        var nextFocusRangeIndex = (0, _utils.findNextRangeIndex)(this.props.ranges, focusedRange[0]);
	        nextFocusRange = [nextFocusRangeIndex, 0];
	      }
	      return {
	        range: { startDate: startDate, endDate: endDate },
	        nextFocusRange: nextFocusRange
	      };
	    }
	  }, {
	    key: 'setSelection',
	    value: function setSelection(value, isSingleValue) {
	      var _props2 = this.props,
	          onChange = _props2.onChange,
	          ranges = _props2.ranges,
	          onRangeFocusChange = _props2.onRangeFocusChange;
	
	      var focusedRange = this.props.focusedRange || this.state.focusedRange;
	      var focusedRangeIndex = focusedRange[0];
	      var selectedRange = ranges[focusedRangeIndex];
	      if (!selectedRange) return;
	      var newSelection = this.calcNewSelection(value, isSingleValue);
	      onChange(_defineProperty({}, selectedRange.key || 'range' + (focusedRangeIndex + 1), _extends({}, selectedRange, newSelection.range)));
	      this.setState({
	        focusedRange: newSelection.nextFocusRange,
	        preview: null
	      });
	      onRangeFocusChange && onRangeFocusChange(newSelection.nextFocusRange);
	    }
	  }, {
	    key: 'handleRangeFocusChange',
	    value: function handleRangeFocusChange(focusedRange) {
	      this.setState({ focusedRange: focusedRange });
	      this.props.onRangeFocusChange && this.props.onRangeFocusChange(focusedRange);
	    }
	  }, {
	    key: 'updatePreview',
	    value: function updatePreview(val) {
	      if (!val) {
	        this.setState({ preview: null });
	        return;
	      }
	      var _props3 = this.props,
	          rangeColors = _props3.rangeColors,
	          ranges = _props3.ranges;
	
	      var focusedRange = this.props.focusedRange || this.state.focusedRange;
	      var color = ranges[focusedRange[0]].color || rangeColors[focusedRange[0]] || color;
	      this.setState({ preview: _extends({}, val, { color: color }) });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement(_Calendar2.default, _extends({
	        focusedRange: this.state.focusedRange,
	        onRangeFocusChange: this.handleRangeFocusChange,
	        preview: this.state.preview,
	        onPreviewChange: function onPreviewChange(value) {
	          _this2.updatePreview(value ? _this2.calcNewSelection(value).range : null);
	        }
	      }, this.props, {
	        displayMode: 'dateRange',
	        className: (0, _classnames2.default)(this.styles.dateRangeWrapper, this.props.className),
	        onChange: this.setSelection,
	        updateRange: function updateRange(val) {
	          return _this2.setSelection(val, false);
	        },
	        ref: function ref(target) {
	          _this2.calendar = target;
	        }
	      }));
	    }
	  }]);
	
	  return DateRange;
	}(_react.Component);
	
	DateRange.defaultProps = {
	  classNames: {},
	  ranges: [],
	  moveRangeOnFirstSelection: false,
	  rangeColors: ['#3d91ff', '#3ecf8e', '#fed14c']
	};
	
	DateRange.propTypes = _extends({}, _Calendar2.default.propTypes, {
	  onChange: _propTypes2.default.func,
	  onRangeFocusChange: _propTypes2.default.func,
	  className: _propTypes2.default.string,
	  ranges: _propTypes2.default.arrayOf(_DayCell.rangeShape),
	  moveRangeOnFirstSelection: _propTypes2.default.bool
	});
	
	exports.default = DateRange;

/***/ }),
/* 2200 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(956);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _DayCell = __webpack_require__(2201);
	
	var _Month = __webpack_require__(2231);
	
	var _Month2 = _interopRequireDefault(_Month);
	
	var _utils = __webpack_require__(2237);
	
	var _classnames3 = __webpack_require__(958);
	
	var _classnames4 = _interopRequireDefault(_classnames3);
	
	var _reactList = __webpack_require__(2243);
	
	var _reactList2 = _interopRequireDefault(_reactList);
	
	var _max = __webpack_require__(2244);
	
	var _max2 = _interopRequireDefault(_max);
	
	var _min = __webpack_require__(2245);
	
	var _min2 = _interopRequireDefault(_min);
	
	var _differenceInDays = __webpack_require__(2246);
	
	var _differenceInDays2 = _interopRequireDefault(_differenceInDays);
	
	var _isSameMonth = __webpack_require__(2249);
	
	var _isSameMonth2 = _interopRequireDefault(_isSameMonth);
	
	var _addDays = __webpack_require__(2250);
	
	var _addDays2 = _interopRequireDefault(_addDays);
	
	var _endOfMonth = __webpack_require__(2238);
	
	var _endOfMonth2 = _interopRequireDefault(_endOfMonth);
	
	var _startOfMonth = __webpack_require__(2239);
	
	var _startOfMonth2 = _interopRequireDefault(_startOfMonth);
	
	var _differenceInCalendarMonths = __webpack_require__(2251);
	
	var _differenceInCalendarMonths2 = _interopRequireDefault(_differenceInCalendarMonths);
	
	var _setMonth2 = __webpack_require__(2252);
	
	var _setMonth3 = _interopRequireDefault(_setMonth2);
	
	var _setYear2 = __webpack_require__(2253);
	
	var _setYear3 = _interopRequireDefault(_setYear2);
	
	var _addYears = __webpack_require__(2254);
	
	var _addYears2 = _interopRequireDefault(_addYears);
	
	var _isSameDay = __webpack_require__(2206);
	
	var _isSameDay2 = _interopRequireDefault(_isSameDay);
	
	var _endOfWeek = __webpack_require__(2235);
	
	var _endOfWeek2 = _interopRequireDefault(_endOfWeek);
	
	var _startOfWeek = __webpack_require__(2236);
	
	var _startOfWeek2 = _interopRequireDefault(_startOfWeek);
	
	var _eachDayOfInterval = __webpack_require__(2232);
	
	var _eachDayOfInterval2 = _interopRequireDefault(_eachDayOfInterval);
	
	var _format = __webpack_require__(2208);
	
	var _format2 = _interopRequireDefault(_format);
	
	var _addMonths = __webpack_require__(2241);
	
	var _addMonths2 = _interopRequireDefault(_addMonths);
	
	var _enUS = __webpack_require__(2210);
	
	var _enUS2 = _interopRequireDefault(_enUS);
	
	var _styles = __webpack_require__(2255);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Calendar = function (_PureComponent) {
	  _inherits(Calendar, _PureComponent);
	
	  function Calendar(props, context) {
	    _classCallCheck(this, Calendar);
	
	    var _this = _possibleConstructorReturn(this, (Calendar.__proto__ || Object.getPrototypeOf(Calendar)).call(this, props, context));
	
	    _this.changeShownDate = _this.changeShownDate.bind(_this);
	    _this.focusToDate = _this.focusToDate.bind(_this);
	    _this.updateShownDate = _this.updateShownDate.bind(_this);
	    _this.handleRangeFocusChange = _this.handleRangeFocusChange.bind(_this);
	    _this.renderDateDisplay = _this.renderDateDisplay.bind(_this);
	    _this.onDragSelectionStart = _this.onDragSelectionStart.bind(_this);
	    _this.onDragSelectionEnd = _this.onDragSelectionEnd.bind(_this);
	    _this.onDragSelectionMove = _this.onDragSelectionMove.bind(_this);
	    _this.renderMonthAndYear = _this.renderMonthAndYear.bind(_this);
	    _this.updatePreview = _this.updatePreview.bind(_this);
	    _this.estimateMonthSize = _this.estimateMonthSize.bind(_this);
	    _this.handleScroll = _this.handleScroll.bind(_this);
	    _this.dateOptions = { locale: props.locale };
	    _this.styles = (0, _utils.generateStyles)([_styles2.default, props.classNames]);
	    _this.listSizeCache = {};
	    _this.state = {
	      focusedDate: (0, _utils.calcFocusDate)(null, props),
	      drag: {
	        status: false,
	        range: { startDate: null, endDate: null },
	        disablePreview: false
	      },
	      scrollArea: _this.calcScrollArea(props)
	    };
	    return _this;
	  }
	
	  _createClass(Calendar, [{
	    key: 'calcScrollArea',
	    value: function calcScrollArea(props) {
	      var direction = props.direction,
	          months = props.months,
	          scroll = props.scroll;
	
	      if (!scroll.enabled) return { enabled: false };
	
	      var longMonthHeight = scroll.longMonthHeight || scroll.monthHeight;
	      if (direction === 'vertical') {
	        return {
	          enabled: true,
	          monthHeight: scroll.monthHeight || 220,
	          longMonthHeight: longMonthHeight || 260,
	          calendarWidth: 'auto',
	          calendarHeight: (scroll.calendarHeight || longMonthHeight || 240) * months
	        };
	      }
	      return {
	        enabled: true,
	        monthWidth: scroll.monthWidth || 332,
	        calendarWidth: (scroll.calendarWidth || scroll.monthWidth || 332) * months,
	        monthHeight: longMonthHeight || 300,
	        calendarHeight: longMonthHeight || 300
	      };
	    }
	  }, {
	    key: 'focusToDate',
	    value: function focusToDate(date) {
	      var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.props;
	      var preventUnnecessary = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
	
	      if (!props.scroll.enabled) {
	        this.setState({ focusedDate: date });
	        return;
	      }
	      var targetMonthIndex = (0, _differenceInCalendarMonths2.default)(date, props.minDate, this.dateOptions);
	      var visibleMonths = this.list.getVisibleRange();
	      if (preventUnnecessary && visibleMonths.includes(targetMonthIndex)) return;
	      this.list.scrollTo(targetMonthIndex);
	      this.setState({ focusedDate: date });
	    }
	  }, {
	    key: 'updateShownDate',
	    value: function updateShownDate() {
	      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
	
	      var newProps = props.scroll.enabled ? _extends({}, props, {
	        months: this.list.getVisibleRange().length
	      }) : props;
	      var newFocus = (0, _utils.calcFocusDate)(this.state.focusedDate, newProps);
	      this.focusToDate(newFocus, newProps);
	    }
	  }, {
	    key: 'updatePreview',
	    value: function updatePreview(val) {
	      if (!val) {
	        this.setState({ preview: null });
	        return;
	      }
	      var preview = {
	        startDate: val,
	        endDate: val,
	        color: this.props.color
	      };
	      this.setState({ preview: preview });
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      if (this.props.scroll.enabled) {
	        // prevent react-list's initial render focus problem
	        setTimeout(function () {
	          return _this2.focusToDate(_this2.state.focusedDate);
	        }, 1);
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var propMapper = {
	        dateRange: 'ranges',
	        date: 'date'
	      };
	      var targetProp = propMapper[nextProps.displayMode];
	      if (this.props.locale !== nextProps.locale) {
	        this.dateOptions = { locale: nextProps.locale };
	      }
	      if (JSON.stringify(this.props.scroll) !== JSON.stringify(nextProps.scroll)) {
	        this.setState({ scrollArea: this.calcScrollArea(nextProps) });
	      }
	      if (nextProps[targetProp] !== this.props[targetProp]) {
	        this.updateShownDate(nextProps);
	      }
	    }
	  }, {
	    key: 'changeShownDate',
	    value: function changeShownDate(value) {
	      var mode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'set';
	      var focusedDate = this.state.focusedDate;
	      var _props = this.props,
	          onShownDateChange = _props.onShownDateChange,
	          minDate = _props.minDate,
	          maxDate = _props.maxDate;
	
	      var modeMapper = {
	        monthOffset: function monthOffset() {
	          return (0, _addMonths2.default)(focusedDate, value);
	        },
	        setMonth: function setMonth() {
	          return (0, _setMonth3.default)(focusedDate, value);
	        },
	        setYear: function setYear() {
	          return (0, _setYear3.default)(focusedDate, value);
	        },
	        set: function set() {
	          return value;
	        }
	      };
	      var newDate = (0, _min2.default)([(0, _max2.default)([modeMapper[mode](), minDate]), maxDate]);
	      this.focusToDate(newDate, this.props, false);
	      onShownDateChange && onShownDateChange(newDate);
	    }
	  }, {
	    key: 'handleRangeFocusChange',
	    value: function handleRangeFocusChange(rangesIndex, rangeItemIndex) {
	      this.props.onRangeFocusChange && this.props.onRangeFocusChange([rangesIndex, rangeItemIndex]);
	    }
	  }, {
	    key: 'handleScroll',
	    value: function handleScroll() {
	      var _props2 = this.props,
	          onShownDateChange = _props2.onShownDateChange,
	          minDate = _props2.minDate;
	
	      var visibleMonths = this.list.getVisibleRange();
	      // prevent scroll jump with wrong visible value
	      if (visibleMonths[0] === undefined) return;
	      var visibleMonth = (0, _addMonths2.default)(minDate, visibleMonths[0] || 0);
	      var isFocusedToDifferent = !(0, _isSameMonth2.default)(visibleMonth, this.state.focusedDate);
	      if (isFocusedToDifferent) {
	        this.setState({ focusedDate: visibleMonth });
	        onShownDateChange && onShownDateChange(visibleMonth);
	      }
	    }
	  }, {
	    key: 'renderMonthAndYear',
	    value: function renderMonthAndYear(focusedDate, changeShownDate, props) {
	      var showMonthArrow = props.showMonthArrow,
	          locale = props.locale,
	          minDate = props.minDate,
	          maxDate = props.maxDate,
	          showMonthAndYearPickers = props.showMonthAndYearPickers;
	
	      var upperYearLimit = (maxDate || Calendar.defaultProps.maxDate).getFullYear();
	      var lowerYearLimit = (minDate || Calendar.defaultProps.minDate).getFullYear();
	      var styles = this.styles;
	      return _react2.default.createElement(
	        'div',
	        { onMouseUp: function onMouseUp(e) {
	            return e.stopPropagation();
	          }, className: styles.monthAndYearWrapper },
	        showMonthArrow ? _react2.default.createElement(
	          'button',
	          {
	            type: 'button',
	            className: (0, _classnames4.default)(styles.nextPrevButton, styles.prevButton),
	            onClick: function onClick() {
	              return changeShownDate(-1, 'monthOffset');
	            } },
	          _react2.default.createElement('i', null)
	        ) : null,
	        showMonthAndYearPickers ? _react2.default.createElement(
	          'span',
	          { className: styles.monthAndYearPickers },
	          _react2.default.createElement(
	            'span',
	            { className: styles.monthPicker },
	            _react2.default.createElement(
	              'select',
	              {
	                value: focusedDate.getMonth(),
	                onChange: function onChange(e) {
	                  return changeShownDate(e.target.value, 'setMonth');
	                } },
	              locale.localize.months().map(function (month, i) {
	                return _react2.default.createElement(
	                  'option',
	                  { key: i, value: i },
	                  month
	                );
	              })
	            )
	          ),
	          _react2.default.createElement('span', { className: styles.monthAndYearDivider }),
	          _react2.default.createElement(
	            'span',
	            { className: styles.yearPicker },
	            _react2.default.createElement(
	              'select',
	              {
	                value: focusedDate.getFullYear(),
	                onChange: function onChange(e) {
	                  return changeShownDate(e.target.value, 'setYear');
	                } },
	              new Array(upperYearLimit - lowerYearLimit + 1).fill(upperYearLimit).map(function (val, i) {
	                var year = val - i;
	                return _react2.default.createElement(
	                  'option',
	                  { key: year, value: year },
	                  year
	                );
	              })
	            )
	          )
	        ) : _react2.default.createElement(
	          'span',
	          { className: styles.monthAndYearPickers },
	          locale.localize.months()[focusedDate.getMonth()],
	          ' ',
	          focusedDate.getFullYear()
	        ),
	        showMonthArrow ? _react2.default.createElement(
	          'button',
	          {
	            type: 'button',
	            className: (0, _classnames4.default)(styles.nextPrevButton, styles.nextButton),
	            onClick: function onClick() {
	              return changeShownDate(+1, 'monthOffset');
	            } },
	          _react2.default.createElement('i', null)
	        ) : null
	      );
	    }
	  }, {
	    key: 'renderWeekdays',
	    value: function renderWeekdays() {
	      var _this3 = this;
	
	      var now = new Date();
	      return _react2.default.createElement(
	        'div',
	        { className: this.styles.weekDays },
	        (0, _eachDayOfInterval2.default)({
	          start: (0, _startOfWeek2.default)(now, this.dateOptions),
	          end: (0, _endOfWeek2.default)(now, this.dateOptions)
	        }).map(function (day, i) {
	          return _react2.default.createElement(
	            'span',
	            { className: _this3.styles.weekDay, key: i },
	            (0, _format2.default)(day, 'ddd', _this3.dateOptions)
	          );
	        })
	      );
	    }
	  }, {
	    key: 'renderDateDisplay',
	    value: function renderDateDisplay() {
	      var _this4 = this;
	
	      var _props3 = this.props,
	          focusedRange = _props3.focusedRange,
	          color = _props3.color,
	          ranges = _props3.ranges,
	          rangeColors = _props3.rangeColors;
	
	      var defaultColor = rangeColors[focusedRange[0]] || color;
	      var styles = this.styles;
	      return _react2.default.createElement(
	        'div',
	        { className: styles.dateDisplayWrapper },
	        ranges.map(function (range, i) {
	          if (range.showDateDisplay === false || range.disabled && !range.showDateDisplay) return null;
	          return _react2.default.createElement(
	            'div',
	            {
	              className: styles.dateDisplay,
	              key: i,
	              style: { color: range.color || defaultColor } },
	            _react2.default.createElement(
	              'span',
	              {
	                className: (0, _classnames4.default)(styles.dateDisplayItem, _defineProperty({}, styles.dateDisplayItemActive, focusedRange[0] === i && focusedRange[1] === 0)),
	                onFocus: function onFocus() {
	                  return _this4.handleRangeFocusChange(i, 0);
	                } },
	              _react2.default.createElement('input', {
	                disabled: range.disabled,
	                readOnly: true,
	                value: _this4.formatDateDisplay(range.startDate, 'Early')
	              })
	            ),
	            _react2.default.createElement(
	              'span',
	              {
	                className: (0, _classnames4.default)(styles.dateDisplayItem, _defineProperty({}, styles.dateDisplayItemActive, focusedRange[0] === i && focusedRange[1] === 1)),
	                onFocus: function onFocus() {
	                  return _this4.handleRangeFocusChange(i, 1);
	                } },
	              _react2.default.createElement('input', {
	                disabled: range.disabled,
	                readOnly: true,
	                value: _this4.formatDateDisplay(range.endDate, 'Continuous')
	              })
	            )
	          );
	        })
	      );
	    }
	  }, {
	    key: 'onDragSelectionStart',
	    value: function onDragSelectionStart(date) {
	      var _props4 = this.props,
	          onChange = _props4.onChange,
	          dragSelectionEnabled = _props4.dragSelectionEnabled;
	
	
	      if (dragSelectionEnabled) {
	        this.setState({
	          drag: {
	            status: true,
	            range: { startDate: date, endDate: date },
	            disablePreview: true
	          }
	        });
	      } else {
	        onChange && onChange(date);
	      }
	    }
	  }, {
	    key: 'onDragSelectionEnd',
	    value: function onDragSelectionEnd(date) {
	      var _props5 = this.props,
	          updateRange = _props5.updateRange,
	          displayMode = _props5.displayMode,
	          onChange = _props5.onChange,
	          dragSelectionEnabled = _props5.dragSelectionEnabled;
	
	
	      if (!dragSelectionEnabled) return;
	
	      if (displayMode === 'date' || !this.state.drag.status) {
	        onChange && onChange(date);
	        return;
	      }
	      var newRange = {
	        startDate: this.state.drag.range.startDate,
	        endDate: date
	      };
	      if (displayMode !== 'dateRange' || (0, _isSameDay2.default)(newRange.startDate, date)) {
	        this.setState({ drag: { status: false, range: {} } }, function () {
	          return onChange && onChange(date);
	        });
	      } else {
	        this.setState({ drag: { status: false, range: {} } }, function () {
	          updateRange && updateRange(newRange);
	        });
	      }
	    }
	  }, {
	    key: 'onDragSelectionMove',
	    value: function onDragSelectionMove(date) {
	      var drag = this.state.drag;
	
	      if (!drag.status || !this.props.dragSelectionEnabled) return;
	      this.setState({
	        drag: {
	          status: drag.status,
	          range: { startDate: drag.range.startDate, endDate: date },
	          disablePreview: true
	        }
	      });
	    }
	  }, {
	    key: 'estimateMonthSize',
	    value: function estimateMonthSize(index, cache) {
	      var _props6 = this.props,
	          direction = _props6.direction,
	          minDate = _props6.minDate;
	      var scrollArea = this.state.scrollArea;
	
	      if (cache) {
	        this.listSizeCache = cache;
	        if (cache[index]) return cache[index];
	      }
	      if (direction === 'horizontal') return scrollArea.monthWidth;
	      var monthStep = (0, _addMonths2.default)(minDate, index);
	
	      var _getMonthDisplayRange = (0, _utils.getMonthDisplayRange)(monthStep, this.dateOptions),
	          start = _getMonthDisplayRange.start,
	          end = _getMonthDisplayRange.end;
	
	      var isLongMonth = (0, _differenceInDays2.default)(end, start, this.dateOptions) + 1 > 7 * 5;
	      return isLongMonth ? scrollArea.longMonthHeight : scrollArea.monthHeight;
	    }
	  }, {
	    key: 'formatDateDisplay',
	    value: function formatDateDisplay(date, defaultText) {
	      if (!date) return defaultText;
	      return (0, _format2.default)(date, this.props.dateDisplayFormat, this.dateOptions);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this5 = this;
	
	      var _props7 = this.props,
	          showDateDisplay = _props7.showDateDisplay,
	          onPreviewChange = _props7.onPreviewChange,
	          scroll = _props7.scroll,
	          direction = _props7.direction,
	          maxDate = _props7.maxDate,
	          minDate = _props7.minDate,
	          rangeColors = _props7.rangeColors,
	          color = _props7.color;
	      var _state = this.state,
	          scrollArea = _state.scrollArea,
	          focusedDate = _state.focusedDate;
	
	      var isVertical = direction === 'vertical';
	      var navigatorRenderer = this.props.navigatorRenderer || this.renderMonthAndYear;
	
	      var ranges = this.props.ranges.map(function (range, i) {
	        return _extends({}, range, {
	          color: range.color || rangeColors[i] || color
	        });
	      });
	      return _react2.default.createElement(
	        'div',
	        {
	          className: (0, _classnames4.default)(this.styles.calendarWrapper, this.props.className),
	          onMouseUp: function onMouseUp() {
	            return _this5.setState({ drag: { status: false, range: {} } });
	          },
	          onMouseLeave: function onMouseLeave() {
	            _this5.setState({ drag: { status: false, range: {} } });
	          } },
	        showDateDisplay && this.renderDateDisplay(),
	        navigatorRenderer(focusedDate, this.changeShownDate, this.props),
	        scroll.enabled ? _react2.default.createElement(
	          'div',
	          null,
	          isVertical && this.renderWeekdays(this.dateOptions),
	          _react2.default.createElement(
	            'div',
	            {
	              className: (0, _classnames4.default)(this.styles.infiniteMonths, isVertical ? this.styles.monthsVertical : this.styles.monthsHorizontal),
	              onMouseLeave: function onMouseLeave() {
	                return onPreviewChange && onPreviewChange();
	              },
	              style: {
	                width: scrollArea.calendarWidth + 11,
	                height: scrollArea.calendarHeight + 11
	              },
	              onScroll: this.handleScroll },
	            _react2.default.createElement(_reactList2.default, {
	              length: (0, _differenceInCalendarMonths2.default)((0, _endOfMonth2.default)(maxDate), (0, _addDays2.default)((0, _startOfMonth2.default)(minDate), -1), this.dateOptions),
	              treshold: 500,
	              type: 'variable',
	              ref: function ref(target) {
	                return _this5.list = target;
	              },
	              itemSizeEstimator: this.estimateMonthSize,
	              axis: isVertical ? 'y' : 'x',
	              itemRenderer: function itemRenderer(index, key) {
	                var monthStep = (0, _addMonths2.default)(minDate, index);
	                return _react2.default.createElement(_Month2.default, _extends({}, _this5.props, {
	                  onPreviewChange: _this5.props.onPreviewChange || _this5.updatePreview,
	                  preview: _this5.props.preview || _this5.state.preview,
	                  ranges: ranges,
	                  key: key,
	                  drag: _this5.state.drag,
	                  dateOptions: _this5.dateOptions,
	                  month: monthStep,
	                  onDragSelectionStart: _this5.onDragSelectionStart,
	                  onDragSelectionEnd: _this5.onDragSelectionEnd,
	                  onDragSelectionMove: _this5.onDragSelectionMove,
	                  onMouseLeave: function onMouseLeave() {
	                    return onPreviewChange && onPreviewChange();
	                  },
	                  styles: _this5.styles,
	                  style: isVertical ? { height: _this5.estimateMonthSize(index) } : { height: scrollArea.monthHeight, width: _this5.estimateMonthSize(index) },
	                  showMonthName: true,
	                  showWeekDays: !isVertical
	                }));
	              }
	            })
	          )
	        ) : _react2.default.createElement(
	          'div',
	          {
	            className: (0, _classnames4.default)(this.styles.months, isVertical ? this.styles.monthsVertical : this.styles.monthsHorizontal) },
	          new Array(this.props.months).fill(null).map(function (_, i) {
	            var monthStep = (0, _addMonths2.default)(_this5.state.focusedDate, i);
	            return _react2.default.createElement(_Month2.default, _extends({}, _this5.props, {
	              onPreviewChange: _this5.props.onPreviewChange || _this5.updatePreview,
	              preview: _this5.props.preview || _this5.state.preview,
	              ranges: ranges,
	              key: i,
	              drag: _this5.state.drag,
	              dateOptions: _this5.dateOptions,
	              month: monthStep,
	              onDragSelectionStart: _this5.onDragSelectionStart,
	              onDragSelectionEnd: _this5.onDragSelectionEnd,
	              onDragSelectionMove: _this5.onDragSelectionMove,
	              onMouseLeave: function onMouseLeave() {
	                return onPreviewChange && onPreviewChange();
	              },
	              styles: _this5.styles,
	              showWeekDays: !isVertical || i === 0,
	              showMonthName: !isVertical || i > 0
	            }));
	          })
	        )
	      );
	    }
	  }]);
	
	  return Calendar;
	}(_react.PureComponent);
	
	Calendar.defaultProps = {
	  showMonthArrow: true,
	  showMonthAndYearPickers: true,
	  classNames: {},
	  locale: _enUS2.default,
	  ranges: [],
	  focusedRange: [0, 0],
	  dateDisplayFormat: 'MMM D, YYYY',
	  monthDisplayFormat: 'MMM YYYY',
	  showDateDisplay: true,
	  showPreview: true,
	  displayMode: 'date',
	  months: 1,
	  color: '#3d91ff',
	  scroll: {
	    enabled: false
	  },
	  direction: 'vertical',
	  maxDate: (0, _addYears2.default)(new Date(), 20),
	  minDate: (0, _addYears2.default)(new Date(), -100),
	  rangeColors: ['#3d91ff', '#3ecf8e', '#fed14c'],
	  dragSelectionEnabled: true
	};
	
	Calendar.propTypes = {
	  showMonthArrow: _propTypes2.default.bool,
	  showMonthAndYearPickers: _propTypes2.default.bool,
	  minDate: _propTypes2.default.object,
	  maxDate: _propTypes2.default.object,
	  date: _propTypes2.default.object,
	  onChange: _propTypes2.default.func,
	  onPreviewChange: _propTypes2.default.func,
	  onRangeFocusChange: _propTypes2.default.func,
	  classNames: _propTypes2.default.object,
	  locale: _propTypes2.default.object,
	  shownDate: _propTypes2.default.object,
	  onShownDateChange: _propTypes2.default.func,
	  ranges: _propTypes2.default.arrayOf(_DayCell.rangeShape),
	  preview: _propTypes2.default.shape({
	    startDate: _propTypes2.default.object,
	    endDate: _propTypes2.default.object,
	    color: _propTypes2.default.string
	  }),
	  dateDisplayFormat: _propTypes2.default.string,
	  monthDisplayFormat: _propTypes2.default.string,
	  focusedRange: _propTypes2.default.arrayOf(_propTypes2.default.number),
	  initialFocusedRange: _propTypes2.default.arrayOf(_propTypes2.default.number),
	  months: _propTypes2.default.number,
	  className: _propTypes2.default.string,
	  showDateDisplay: _propTypes2.default.bool,
	  showPreview: _propTypes2.default.bool,
	  displayMode: _propTypes2.default.oneOf(['dateRange', 'date']),
	  color: _propTypes2.default.string,
	  updateRange: _propTypes2.default.func,
	  scroll: _propTypes2.default.shape({
	    enabled: _propTypes2.default.bool,
	    monthHeight: _propTypes2.default.number,
	    longMonthHeight: _propTypes2.default.number,
	    monthWidth: _propTypes2.default.number,
	    calendarWidth: _propTypes2.default.number,
	    calendarHeight: _propTypes2.default.number
	  }),
	  direction: _propTypes2.default.oneOf(['vertical', 'horizontal']),
	  navigatorRenderer: _propTypes2.default.func,
	  rangeColors: _propTypes2.default.arrayOf(_propTypes2.default.string),
	  dragSelectionEnabled: _propTypes2.default.bool
	};
	
	exports.default = Calendar;

/***/ }),
/* 2201 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.rangeShape = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(956);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames4 = __webpack_require__(958);
	
	var _classnames5 = _interopRequireDefault(_classnames4);
	
	var _endOfDay = __webpack_require__(2202);
	
	var _endOfDay2 = _interopRequireDefault(_endOfDay);
	
	var _isBefore = __webpack_require__(2204);
	
	var _isBefore2 = _interopRequireDefault(_isBefore);
	
	var _isAfter = __webpack_require__(2205);
	
	var _isAfter2 = _interopRequireDefault(_isAfter);
	
	var _isSameDay = __webpack_require__(2206);
	
	var _isSameDay2 = _interopRequireDefault(_isSameDay);
	
	var _format = __webpack_require__(2208);
	
	var _format2 = _interopRequireDefault(_format);
	
	var _startOfDay = __webpack_require__(2207);
	
	var _startOfDay2 = _interopRequireDefault(_startOfDay);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable no-fallthrough */
	
	
	var DayCell = function (_Component) {
	  _inherits(DayCell, _Component);
	
	  function DayCell(props, context) {
	    _classCallCheck(this, DayCell);
	
	    var _this = _possibleConstructorReturn(this, (DayCell.__proto__ || Object.getPrototypeOf(DayCell)).call(this, props, context));
	
	    _this.state = {
	      hover: false,
	      active: false
	    };
	    _this.getClassNames = _this.getClassNames.bind(_this);
	    _this.handleMouseEvent = _this.handleMouseEvent.bind(_this);
	    _this.handleKeyEvent = _this.handleKeyEvent.bind(_this);
	    _this.renderSelectionPlaceholders = _this.renderSelectionPlaceholders.bind(_this);
	    _this.renderPreviewPlaceholder = _this.renderPreviewPlaceholder.bind(_this);
	    return _this;
	  }
	
	  _createClass(DayCell, [{
	    key: 'handleKeyEvent',
	    value: function handleKeyEvent(event) {
	      var day = this.props.day;
	
	      switch (event.keyCode) {
	        case 13: //space
	        case 32:
	          //enter
	          if (event.type === 'keydown') {
	            this.props.onMouseDown(day);
	          } else {
	            this.props.onMouseUp(day);
	          }
	          break;
	      }
	    }
	  }, {
	    key: 'handleMouseEvent',
	    value: function handleMouseEvent(event) {
	      var _props = this.props,
	          day = _props.day,
	          disabled = _props.disabled,
	          onPreviewChange = _props.onPreviewChange;
	
	      var stateChanges = {};
	      if (disabled) {
	        onPreviewChange();
	        return;
	      }
	
	      switch (event.type) {
	        case 'mouseenter':
	          this.props.onMouseEnter(day);
	          onPreviewChange(day);
	          stateChanges.hover = true;
	          break;
	        case 'blur':
	        case 'mouseleave':
	          stateChanges.hover = false;
	          break;
	        case 'mousedown':
	          stateChanges.active = true;
	          this.props.onMouseDown(day);
	          break;
	        case 'mouseup':
	          event.stopPropagation();
	          stateChanges.active = false;
	          this.props.onMouseUp(day);
	          break;
	        case 'focus':
	          onPreviewChange(day);
	          break;
	      }
	      if (Object.keys(stateChanges).length) {
	        this.setState(stateChanges);
	      }
	    }
	  }, {
	    key: 'getClassNames',
	    value: function getClassNames() {
	      var _classnames;
	
	      var _props2 = this.props,
	          isPassive = _props2.isPassive,
	          isToday = _props2.isToday,
	          isWeekend = _props2.isWeekend,
	          isStartOfWeek = _props2.isStartOfWeek,
	          isEndOfWeek = _props2.isEndOfWeek,
	          isStartOfMonth = _props2.isStartOfMonth,
	          isEndOfMonth = _props2.isEndOfMonth,
	          disabled = _props2.disabled,
	          styles = _props2.styles;
	
	
	      return (0, _classnames5.default)(styles.day, (_classnames = {}, _defineProperty(_classnames, styles.dayPassive, isPassive), _defineProperty(_classnames, styles.dayDisabled, disabled), _defineProperty(_classnames, styles.dayToday, isToday), _defineProperty(_classnames, styles.dayWeekend, isWeekend), _defineProperty(_classnames, styles.dayStartOfWeek, isStartOfWeek), _defineProperty(_classnames, styles.dayEndOfWeek, isEndOfWeek), _defineProperty(_classnames, styles.dayStartOfMonth, isStartOfMonth), _defineProperty(_classnames, styles.dayEndOfMonth, isEndOfMonth), _defineProperty(_classnames, styles.dayHovered, this.state.hover), _defineProperty(_classnames, styles.dayActive, this.state.active), _classnames));
	    }
	  }, {
	    key: 'renderPreviewPlaceholder',
	    value: function renderPreviewPlaceholder() {
	      var _classnames2;
	
	      var _props3 = this.props,
	          preview = _props3.preview,
	          day = _props3.day,
	          styles = _props3.styles;
	
	      if (!preview) return null;
	      var startDate = preview.startDate ? (0, _endOfDay2.default)(preview.startDate) : null;
	      var endDate = preview.endDate ? (0, _startOfDay2.default)(preview.endDate) : null;
	      var isInRange = (!startDate || (0, _isAfter2.default)(day, startDate)) && (!endDate || (0, _isBefore2.default)(day, endDate));
	      var isStartEdge = !isInRange && (0, _isSameDay2.default)(day, startDate);
	      var isEndEdge = !isInRange && (0, _isSameDay2.default)(day, endDate);
	      return _react2.default.createElement('span', {
	        className: (0, _classnames5.default)((_classnames2 = {}, _defineProperty(_classnames2, styles.dayStartPreview, isStartEdge), _defineProperty(_classnames2, styles.dayInPreview, isInRange), _defineProperty(_classnames2, styles.dayEndPreview, isEndEdge), _classnames2)),
	        style: { color: preview.color }
	      });
	    }
	  }, {
	    key: 'renderSelectionPlaceholders',
	    value: function renderSelectionPlaceholders() {
	      var _this2 = this;
	
	      var _props4 = this.props,
	          styles = _props4.styles,
	          ranges = _props4.ranges,
	          day = _props4.day;
	
	      if (this.props.displayMode === 'date') {
	        var isSelected = (0, _isSameDay2.default)(this.props.day, this.props.date);
	        return isSelected ? _react2.default.createElement('span', { className: styles.selected, style: { color: this.props.color } }) : null;
	      }
	
	      var inRanges = ranges.reduce(function (result, range) {
	        var startDate = range.startDate;
	        var endDate = range.endDate;
	        if (startDate && endDate && (0, _isBefore2.default)(endDate, startDate)) {
	          var _ref = [endDate, startDate];
	          startDate = _ref[0];
	          endDate = _ref[1];
	        }
	        startDate = startDate ? (0, _endOfDay2.default)(startDate) : null;
	        endDate = endDate ? (0, _startOfDay2.default)(endDate) : null;
	        var isInRange = (!startDate || (0, _isAfter2.default)(day, startDate)) && (!endDate || (0, _isBefore2.default)(day, endDate));
	        var isStartEdge = !isInRange && (0, _isSameDay2.default)(day, startDate);
	        var isEndEdge = !isInRange && (0, _isSameDay2.default)(day, endDate);
	        if (isInRange || isStartEdge || isEndEdge) {
	          return [].concat(_toConsumableArray(result), [_extends({
	            isStartEdge: isStartEdge,
	            isEndEdge: isEndEdge,
	            isInRange: isInRange
	          }, range)]);
	        }
	        return result;
	      }, []);
	
	      return inRanges.map(function (range, i) {
	        var _classnames3;
	
	        return _react2.default.createElement('span', {
	          key: i,
	          className: (0, _classnames5.default)((_classnames3 = {}, _defineProperty(_classnames3, styles.startEdge, range.isStartEdge), _defineProperty(_classnames3, styles.endEdge, range.isEndEdge), _defineProperty(_classnames3, styles.inRange, range.isInRange), _classnames3)),
	          style: { color: range.color || _this2.props.color }
	        });
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var styles = this.props.styles;
	
	      return _react2.default.createElement(
	        'button',
	        _extends({
	          type: 'button',
	          onMouseEnter: this.handleMouseEvent,
	          onMouseLeave: this.handleMouseEvent,
	          onFocus: this.handleMouseEvent,
	          onMouseDown: this.handleMouseEvent,
	          onMouseUp: this.handleMouseEvent,
	          onBlur: this.handleMouseEvent,
	          onPauseCapture: this.handleMouseEvent,
	          onKeyDown: this.handleKeyEvent,
	          onKeyUp: this.handleKeyEvent,
	          className: this.getClassNames(styles)
	        }, this.props.disabled || this.props.isPassive ? { tabIndex: -1 } : {}, {
	          style: { color: this.props.color } }),
	        this.renderSelectionPlaceholders(),
	        this.renderPreviewPlaceholder(),
	        _react2.default.createElement(
	          'span',
	          { className: styles.dayNumber },
	          _react2.default.createElement(
	            'span',
	            null,
	            (0, _format2.default)(this.props.day, 'D')
	          )
	        )
	      );
	    }
	  }]);
	
	  return DayCell;
	}(_react.Component);
	
	DayCell.defaultProps = {};
	
	var rangeShape = exports.rangeShape = _propTypes2.default.shape({
	  startDate: _propTypes2.default.object,
	  endDate: _propTypes2.default.object,
	  color: _propTypes2.default.string,
	  key: _propTypes2.default.string,
	  autoFocus: _propTypes2.default.bool,
	  disabled: _propTypes2.default.bool,
	  showDateDisplay: _propTypes2.default.bool
	});
	
	DayCell.propTypes = {
	  day: _propTypes2.default.object.isRequired,
	  date: _propTypes2.default.object,
	  ranges: _propTypes2.default.arrayOf(rangeShape),
	  preview: _propTypes2.default.shape({
	    startDate: _propTypes2.default.object,
	    endDate: _propTypes2.default.object
	  }),
	  onPreviewChange: _propTypes2.default.func,
	  previewColor: _propTypes2.default.string,
	  disabled: _propTypes2.default.bool,
	  isPassive: _propTypes2.default.bool,
	  isToday: _propTypes2.default.bool,
	  isWeekend: _propTypes2.default.bool,
	  isStartOfWeek: _propTypes2.default.bool,
	  isEndOfWeek: _propTypes2.default.bool,
	  isStartOfMonth: _propTypes2.default.bool,
	  isEndOfMonth: _propTypes2.default.bool,
	  color: _propTypes2.default.string,
	  displayMode: _propTypes2.default.oneOf(['dateRange', 'date']),
	  styles: _propTypes2.default.object,
	  onMouseDown: _propTypes2.default.func,
	  onMouseUp: _propTypes2.default.func,
	  onMouseEnter: _propTypes2.default.func
	};
	
	exports.default = DayCell;

/***/ }),
/* 2202 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = endOfDay;
	
	var _index = __webpack_require__(2203);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name endOfDay
	 * @category Day Helpers
	 * @summary Return the end of a day for the given date.
	 *
	 * @description
	 * Return the end of a day for the given date.
	 * The result will be in the local timezone.
	 *
	 * @param {Date|String|Number} date - the original date
	 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
	 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
	 * @returns {Date} the end of a day
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
	 *
	 * @example
	 * // The end of a day for 2 September 2014 11:55:00:
	 * var result = endOfDay(new Date(2014, 8, 2, 11, 55, 0))
	 * //=> Tue Sep 02 2014 23:59:59.999
	 */
	function endOfDay(dirtyDate, dirtyOptions) {
	  if (arguments.length < 1) {
	    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
	  }
	
	  var date = (0, _index2.default)(dirtyDate, dirtyOptions);
	  date.setHours(23, 59, 59, 999);
	  return date;
	}
	module.exports = exports['default'];

/***/ }),
/* 2203 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = toDate;
	var MILLISECONDS_IN_HOUR = 3600000;
	var MILLISECONDS_IN_MINUTE = 60000;
	var DEFAULT_ADDITIONAL_DIGITS = 2;
	
	var patterns = {
	  dateTimeDelimeter: /[T ]/,
	  plainTime: /:/,
	
	  // year tokens
	  YY: /^(\d{2})$/,
	  YYY: [/^([+-]\d{2})$/, // 0 additional digits
	  /^([+-]\d{3})$/, // 1 additional digit
	  /^([+-]\d{4})$/ // 2 additional digits
	  ],
	  YYYY: /^(\d{4})/,
	  YYYYY: [/^([+-]\d{4})/, // 0 additional digits
	  /^([+-]\d{5})/, // 1 additional digit
	  /^([+-]\d{6})/ // 2 additional digits
	  ],
	
	  // date tokens
	  MM: /^-(\d{2})$/,
	  DDD: /^-?(\d{3})$/,
	  MMDD: /^-?(\d{2})-?(\d{2})$/,
	  Www: /^-?W(\d{2})$/,
	  WwwD: /^-?W(\d{2})-?(\d{1})$/,
	
	  HH: /^(\d{2}([.,]\d*)?)$/,
	  HHMM: /^(\d{2}):?(\d{2}([.,]\d*)?)$/,
	  HHMMSS: /^(\d{2}):?(\d{2}):?(\d{2}([.,]\d*)?)$/,
	
	  // timezone tokens
	  timezone: /([Z+-].*)$/,
	  timezoneZ: /^(Z)$/,
	  timezoneHH: /^([+-])(\d{2})$/,
	  timezoneHHMM: /^([+-])(\d{2}):?(\d{2})$/
	};
	
	/**
	 * @name toDate
	 * @category Common Helpers
	 * @summary Convert the given argument to an instance of Date.
	 *
	 * @description
	 * Convert the given argument to an instance of Date.
	 *
	 * If the argument is an instance of Date, the function returns its clone.
	 *
	 * If the argument is a number, it is treated as a timestamp.
	 *
	 * If an argument is a string, the function tries to parse it.
	 * Function accepts complete ISO 8601 formats as well as partial implementations.
	 * ISO 8601: http://en.wikipedia.org/wiki/ISO_8601
	 *
	 * If the argument is null, it is treated as an invalid date.
	 *
	 * If all above fails, the function passes the given argument to Date constructor.
	 *
	 * **Note**: *all* Date arguments passed to any *date-fns* function is processed by `toDate`.
	 * All *date-fns* functions will throw `RangeError` if `options.additionalDigits` is not 0, 1, 2 or undefined.
	 *
	 * @param {*} argument - the value to convert
	 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
	 * @param {0|1|2} [options.additionalDigits=2] - the additional number of digits in the extended year format
	 * @returns {Date} the parsed date in the local time zone
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
	 *
	 * @example
	 * // Convert string '2014-02-11T11:30:30' to date:
	 * var result = toDate('2014-02-11T11:30:30')
	 * //=> Tue Feb 11 2014 11:30:30
	 *
	 * @example
	 * // Convert string '+02014101' to date,
	 * // if the additional number of digits in the extended year format is 1:
	 * var result = toDate('+02014101', {additionalDigits: 1})
	 * //=> Fri Apr 11 2014 00:00:00
	 */
	function toDate(argument, dirtyOptions) {
	  if (arguments.length < 1) {
	    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
	  }
	
	  if (argument === null) {
	    return new Date(NaN);
	  }
	
	  var options = dirtyOptions || {};
	
	  var additionalDigits = options.additionalDigits === undefined ? DEFAULT_ADDITIONAL_DIGITS : Number(options.additionalDigits);
	  if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) {
	    throw new RangeError('additionalDigits must be 0, 1 or 2');
	  }
	
	  // Clone the date
	  if (argument instanceof Date) {
	    // Prevent the date to lose the milliseconds when passed to new Date() in IE10
	    return new Date(argument.getTime());
	  } else if (typeof argument !== 'string') {
	    return new Date(argument);
	  }
	
	  var dateStrings = splitDateString(argument);
	
	  var parseYearResult = parseYear(dateStrings.date, additionalDigits);
	  var year = parseYearResult.year;
	  var restDateString = parseYearResult.restDateString;
	
	  var date = parseDate(restDateString, year);
	
	  if (date) {
	    var timestamp = date.getTime();
	    var time = 0;
	    var offset;
	
	    if (dateStrings.time) {
	      time = parseTime(dateStrings.time);
	    }
	
	    if (dateStrings.timezone) {
	      offset = parseTimezone(dateStrings.timezone);
	    } else {
	      // get offset accurate to hour in timezones that change offset
	      offset = new Date(timestamp + time).getTimezoneOffset();
	      offset = new Date(timestamp + time + offset * MILLISECONDS_IN_MINUTE).getTimezoneOffset();
	    }
	
	    return new Date(timestamp + time + offset * MILLISECONDS_IN_MINUTE);
	  } else {
	    return new Date(argument);
	  }
	}
	
	function splitDateString(dateString) {
	  var dateStrings = {};
	  var array = dateString.split(patterns.dateTimeDelimeter);
	  var timeString;
	
	  if (patterns.plainTime.test(array[0])) {
	    dateStrings.date = null;
	    timeString = array[0];
	  } else {
	    dateStrings.date = array[0];
	    timeString = array[1];
	  }
	
	  if (timeString) {
	    var token = patterns.timezone.exec(timeString);
	    if (token) {
	      dateStrings.time = timeString.replace(token[1], '');
	      dateStrings.timezone = token[1];
	    } else {
	      dateStrings.time = timeString;
	    }
	  }
	
	  return dateStrings;
	}
	
	function parseYear(dateString, additionalDigits) {
	  var patternYYY = patterns.YYY[additionalDigits];
	  var patternYYYYY = patterns.YYYYY[additionalDigits];
	
	  var token;
	
	  // YYYY or ±YYYYY
	  token = patterns.YYYY.exec(dateString) || patternYYYYY.exec(dateString);
	  if (token) {
	    var yearString = token[1];
	    return {
	      year: parseInt(yearString, 10),
	      restDateString: dateString.slice(yearString.length)
	    };
	  }
	
	  // YY or ±YYY
	  token = patterns.YY.exec(dateString) || patternYYY.exec(dateString);
	  if (token) {
	    var centuryString = token[1];
	    return {
	      year: parseInt(centuryString, 10) * 100,
	      restDateString: dateString.slice(centuryString.length)
	    };
	  }
	
	  // Invalid ISO-formatted year
	  return {
	    year: null
	  };
	}
	
	function parseDate(dateString, year) {
	  // Invalid ISO-formatted year
	  if (year === null) {
	    return null;
	  }
	
	  var token;
	  var date;
	  var month;
	  var week;
	
	  // YYYY
	  if (dateString.length === 0) {
	    date = new Date(0);
	    date.setUTCFullYear(year);
	    return date;
	  }
	
	  // YYYY-MM
	  token = patterns.MM.exec(dateString);
	  if (token) {
	    date = new Date(0);
	    month = parseInt(token[1], 10) - 1;
	    date.setUTCFullYear(year, month);
	    return date;
	  }
	
	  // YYYY-DDD or YYYYDDD
	  token = patterns.DDD.exec(dateString);
	  if (token) {
	    date = new Date(0);
	    var dayOfYear = parseInt(token[1], 10);
	    date.setUTCFullYear(year, 0, dayOfYear);
	    return date;
	  }
	
	  // YYYY-MM-DD or YYYYMMDD
	  token = patterns.MMDD.exec(dateString);
	  if (token) {
	    date = new Date(0);
	    month = parseInt(token[1], 10) - 1;
	    var day = parseInt(token[2], 10);
	    date.setUTCFullYear(year, month, day);
	    return date;
	  }
	
	  // YYYY-Www or YYYYWww
	  token = patterns.Www.exec(dateString);
	  if (token) {
	    week = parseInt(token[1], 10) - 1;
	    return dayOfISOYear(year, week);
	  }
	
	  // YYYY-Www-D or YYYYWwwD
	  token = patterns.WwwD.exec(dateString);
	  if (token) {
	    week = parseInt(token[1], 10) - 1;
	    var dayOfWeek = parseInt(token[2], 10) - 1;
	    return dayOfISOYear(year, week, dayOfWeek);
	  }
	
	  // Invalid ISO-formatted date
	  return null;
	}
	
	function parseTime(timeString) {
	  var token;
	  var hours;
	  var minutes;
	
	  // hh
	  token = patterns.HH.exec(timeString);
	  if (token) {
	    hours = parseFloat(token[1].replace(',', '.'));
	    return hours % 24 * MILLISECONDS_IN_HOUR;
	  }
	
	  // hh:mm or hhmm
	  token = patterns.HHMM.exec(timeString);
	  if (token) {
	    hours = parseInt(token[1], 10);
	    minutes = parseFloat(token[2].replace(',', '.'));
	    return hours % 24 * MILLISECONDS_IN_HOUR + minutes * MILLISECONDS_IN_MINUTE;
	  }
	
	  // hh:mm:ss or hhmmss
	  token = patterns.HHMMSS.exec(timeString);
	  if (token) {
	    hours = parseInt(token[1], 10);
	    minutes = parseInt(token[2], 10);
	    var seconds = parseFloat(token[3].replace(',', '.'));
	    return hours % 24 * MILLISECONDS_IN_HOUR + minutes * MILLISECONDS_IN_MINUTE + seconds * 1000;
	  }
	
	  // Invalid ISO-formatted time
	  return null;
	}
	
	function parseTimezone(timezoneString) {
	  var token;
	  var absoluteOffset;
	
	  // Z
	  token = patterns.timezoneZ.exec(timezoneString);
	  if (token) {
	    return 0;
	  }
	
	  // ±hh
	  token = patterns.timezoneHH.exec(timezoneString);
	  if (token) {
	    absoluteOffset = parseInt(token[2], 10) * 60;
	    return token[1] === '+' ? -absoluteOffset : absoluteOffset;
	  }
	
	  // ±hh:mm or ±hhmm
	  token = patterns.timezoneHHMM.exec(timezoneString);
	  if (token) {
	    absoluteOffset = parseInt(token[2], 10) * 60 + parseInt(token[3], 10);
	    return token[1] === '+' ? -absoluteOffset : absoluteOffset;
	  }
	
	  return 0;
	}
	
	function dayOfISOYear(isoYear, week, day) {
	  week = week || 0;
	  day = day || 0;
	  var date = new Date(0);
	  date.setUTCFullYear(isoYear, 0, 4);
	  var fourthOfJanuaryDay = date.getUTCDay() || 7;
	  var diff = week * 7 + day + 1 - fourthOfJanuaryDay;
	  date.setUTCDate(date.getUTCDate() + diff);
	  return date;
	}
	module.exports = exports['default'];

/***/ }),
/* 2204 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isBefore;
	
	var _index = __webpack_require__(2203);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name isBefore
	 * @category Common Helpers
	 * @summary Is the first date before the second one?
	 *
	 * @description
	 * Is the first date before the second one?
	 *
	 * @param {Date|String|Number} date - the date that should be before the other one to return true
	 * @param {Date|String|Number} dateToCompare - the date to compare with
	 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
	 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
	 * @returns {Boolean} the first date is before the second date
	 * @throws {TypeError} 2 arguments required
	 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
	 *
	 * @example
	 * // Is 10 July 1989 before 11 February 1987?
	 * var result = isBefore(new Date(1989, 6, 10), new Date(1987, 1, 11))
	 * //=> false
	 */
	function isBefore(dirtyDate, dirtyDateToCompare, dirtyOptions) {
	  if (arguments.length < 2) {
	    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
	  }
	
	  var date = (0, _index2.default)(dirtyDate, dirtyOptions);
	  var dateToCompare = (0, _index2.default)(dirtyDateToCompare, dirtyOptions);
	  return date.getTime() < dateToCompare.getTime();
	}
	module.exports = exports['default'];

/***/ }),
/* 2205 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isAfter;
	
	var _index = __webpack_require__(2203);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name isAfter
	 * @category Common Helpers
	 * @summary Is the first date after the second one?
	 *
	 * @description
	 * Is the first date after the second one?
	 *
	 * @param {Date|String|Number} date - the date that should be after the other one to return true
	 * @param {Date|String|Number} dateToCompare - the date to compare with
	 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
	 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
	 * @returns {Boolean} the first date is after the second date
	 * @throws {TypeError} 2 arguments required
	 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
	 *
	 * @example
	 * // Is 10 July 1989 after 11 February 1987?
	 * var result = isAfter(new Date(1989, 6, 10), new Date(1987, 1, 11))
	 * //=> true
	 */
	function isAfter(dirtyDate, dirtyDateToCompare, dirtyOptions) {
	  if (arguments.length < 2) {
	    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
	  }
	
	  var date = (0, _index2.default)(dirtyDate, dirtyOptions);
	  var dateToCompare = (0, _index2.default)(dirtyDateToCompare, dirtyOptions);
	  return date.getTime() > dateToCompare.getTime();
	}
	module.exports = exports['default'];

/***/ }),
/* 2206 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isSameDay;
	
	var _index = __webpack_require__(2207);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name isSameDay
	 * @category Day Helpers
	 * @summary Are the given dates in the same day?
	 *
	 * @description
	 * Are the given dates in the same day?
	 *
	 * @param {Date|String|Number} dateLeft - the first date to check
	 * @param {Date|String|Number} dateRight - the second date to check
	 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
	 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
	 * @returns {Boolean} the dates are in the same day
	 * @throws {TypeError} 2 arguments required
	 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
	 *
	 * @example
	 * // Are 4 September 06:00:00 and 4 September 18:00:00 in the same day?
	 * var result = isSameDay(
	 *   new Date(2014, 8, 4, 6, 0),
	 *   new Date(2014, 8, 4, 18, 0)
	 * )
	 * //=> true
	 */
	function isSameDay(dirtyDateLeft, dirtyDateRight, dirtyOptions) {
	  if (arguments.length < 2) {
	    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
	  }
	
	  var dateLeftStartOfDay = (0, _index2.default)(dirtyDateLeft, dirtyOptions);
	  var dateRightStartOfDay = (0, _index2.default)(dirtyDateRight, dirtyOptions);
	
	  return dateLeftStartOfDay.getTime() === dateRightStartOfDay.getTime();
	}
	module.exports = exports['default'];

/***/ }),
/* 2207 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = startOfDay;
	
	var _index = __webpack_require__(2203);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name startOfDay
	 * @category Day Helpers
	 * @summary Return the start of a day for the given date.
	 *
	 * @description
	 * Return the start of a day for the given date.
	 * The result will be in the local timezone.
	 *
	 * @param {Date|String|Number} date - the original date
	 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
	 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
	 * @returns {Date} the start of a day
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
	 *
	 * @example
	 * // The start of a day for 2 September 2014 11:55:00:
	 * var result = startOfDay(new Date(2014, 8, 2, 11, 55, 0))
	 * //=> Tue Sep 02 2014 00:00:00
	 */
	function startOfDay(dirtyDate, dirtyOptions) {
	  if (arguments.length < 1) {
	    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
	  }
	
	  var date = (0, _index2.default)(dirtyDate, dirtyOptions);
	  date.setHours(0, 0, 0, 0);
	  return date;
	}
	module.exports = exports['default'];

/***/ }),
/* 2208 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = format;
	
	var _index = __webpack_require__(2203);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _index3 = __webpack_require__(2209);
	
	var _index4 = _interopRequireDefault(_index3);
	
	var _index5 = __webpack_require__(2210);
	
	var _index6 = _interopRequireDefault(_index5);
	
	var _index7 = __webpack_require__(2223);
	
	var _index8 = _interopRequireDefault(_index7);
	
	var _index9 = __webpack_require__(2229);
	
	var _index10 = _interopRequireDefault(_index9);
	
	var _index11 = __webpack_require__(2230);
	
	var _index12 = _interopRequireDefault(_index11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var longFormattingTokensRegExp = /(\[[^[]*])|(\\)?(LTS|LT|LLLL|LLL|LL|L|llll|lll|ll|l)/g;
	var defaultFormattingTokensRegExp = /(\[[^[]*])|(\\)?(x|ss|s|mm|m|hh|h|do|dddd|ddd|dd|d|aa|a|ZZ|Z|YYYY|YY|X|Wo|WW|W|SSS|SS|S|Qo|Q|Mo|MMMM|MMM|MM|M|HH|H|GGGG|GG|E|Do|DDDo|DDDD|DDD|DD|D|A|.)/g;
	
	/**
	 * @name format
	 * @category Common Helpers
	 * @summary Format the date.
	 *
	 * @description
	 * Return the formatted date string in the given format.
	 *
	 * Accepted tokens:
	 * | Unit                    | Token | Result examples                  |
	 * |-------------------------|-------|----------------------------------|
	 * | Month                   | M     | 1, 2, ..., 12                    |
	 * |                         | Mo    | 1st, 2nd, ..., 12th              |
	 * |                         | MM    | 01, 02, ..., 12                  |
	 * |                         | MMM   | Jan, Feb, ..., Dec               |
	 * |                         | MMMM  | January, February, ..., December |
	 * | Quarter                 | Q     | 1, 2, 3, 4                       |
	 * |                         | Qo    | 1st, 2nd, 3rd, 4th               |
	 * | Day of month            | D     | 1, 2, ..., 31                    |
	 * |                         | Do    | 1st, 2nd, ..., 31st              |
	 * |                         | DD    | 01, 02, ..., 31                  |
	 * | Day of year             | DDD   | 1, 2, ..., 366                   |
	 * |                         | DDDo  | 1st, 2nd, ..., 366th             |
	 * |                         | DDDD  | 001, 002, ..., 366               |
	 * | Day of week             | d     | 0, 1, ..., 6                     |
	 * |                         | do    | 0th, 1st, ..., 6th               |
	 * |                         | dd    | Su, Mo, ..., Sa                  |
	 * |                         | ddd   | Sun, Mon, ..., Sat               |
	 * |                         | dddd  | Sunday, Monday, ..., Saturday    |
	 * | Day of ISO week         | E     | 1, 2, ..., 7                     |
	 * | ISO week                | W     | 1, 2, ..., 53                    |
	 * |                         | Wo    | 1st, 2nd, ..., 53rd              |
	 * |                         | WW    | 01, 02, ..., 53                  |
	 * | Year                    | YY    | 00, 01, ..., 99                  |
	 * |                         | YYYY  | 1900, 1901, ..., 2099            |
	 * | ISO week-numbering year | GG    | 00, 01, ..., 99                  |
	 * |                         | GGGG  | 1900, 1901, ..., 2099            |
	 * | AM/PM                   | A     | AM, PM                           |
	 * |                         | a     | am, pm                           |
	 * |                         | aa    | a.m., p.m.                       |
	 * | Hour                    | H     | 0, 1, ... 23                     |
	 * |                         | HH    | 00, 01, ... 23                   |
	 * |                         | h     | 1, 2, ..., 12                    |
	 * |                         | hh    | 01, 02, ..., 12                  |
	 * | Minute                  | m     | 0, 1, ..., 59                    |
	 * |                         | mm    | 00, 01, ..., 59                  |
	 * | Second                  | s     | 0, 1, ..., 59                    |
	 * |                         | ss    | 00, 01, ..., 59                  |
	 * | 1/10 of second          | S     | 0, 1, ..., 9                     |
	 * | 1/100 of second         | SS    | 00, 01, ..., 99                  |
	 * | Millisecond             | SSS   | 000, 001, ..., 999               |
	 * | Timezone                | Z     | -01:00, +00:00, ... +12:00       |
	 * |                         | ZZ    | -0100, +0000, ..., +1200         |
	 * | Seconds timestamp       | X     | 512969520                        |
	 * | Milliseconds timestamp  | x     | 512969520900                     |
	 * | Long format             | LT    | 05:30 a.m.                       |
	 * |                         | LTS   | 05:30:15 a.m.                    |
	 * |                         | L     | 07/02/1995                       |
	 * |                         | l     | 7/2/1995                         |
	 * |                         | LL    | July 2 1995                      |
	 * |                         | ll    | Jul 2 1995                       |
	 * |                         | LLL   | July 2 1995 05:30 a.m.           |
	 * |                         | lll   | Jul 2 1995 05:30 a.m.            |
	 * |                         | LLLL  | Sunday, July 2 1995 05:30 a.m.   |
	 * |                         | llll  | Sun, Jul 2 1995 05:30 a.m.       |
	 *
	 * The characters wrapped in square brackets are escaped.
	 *
	 * The result may vary by locale.
	 *
	 * @param {Date|String|Number} date - the original date
	 * @param {String} format - the string of tokens
	 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
	 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
	 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
	 * @returns {String} the formatted date string
	 * @throws {TypeError} 2 arguments required
	 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
	 * @throws {RangeError} `options.locale` must contain `localize` property
	 * @throws {RangeError} `options.locale` must contain `formatLong` property
	 *
	 * @example
	 * // Represent 11 February 2014 in middle-endian format:
	 * var result = format(
	 *   new Date(2014, 1, 11),
	 *   'MM/DD/YYYY'
	 * )
	 * //=> '02/11/2014'
	 *
	 * @example
	 * // Represent 2 July 2014 in Esperanto:
	 * import { eoLocale } from 'date-fns/locale/eo'
	 * var result = format(
	 *   new Date(2014, 6, 2),
	 *   'Do [de] MMMM YYYY',
	 *   {locale: eoLocale}
	 * )
	 * //=> '2-a de julio 2014'
	 */
	function format(dirtyDate, dirtyFormatStr, dirtyOptions) {
	  if (arguments.length < 2) {
	    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
	  }
	
	  var formatStr = String(dirtyFormatStr);
	  var options = dirtyOptions || {};
	
	  var locale = options.locale || _index6.default;
	
	  if (!locale.localize) {
	    throw new RangeError('locale must contain localize property');
	  }
	
	  if (!locale.formatLong) {
	    throw new RangeError('locale must contain formatLong property');
	  }
	
	  var localeFormatters = locale.formatters || {};
	  var formattingTokensRegExp = locale.formattingTokensRegExp || defaultFormattingTokensRegExp;
	  var formatLong = locale.formatLong;
	
	  var originalDate = (0, _index2.default)(dirtyDate, options);
	
	  if (!(0, _index4.default)(originalDate, options)) {
	    return 'Invalid Date';
	  }
	
	  // Convert the date in system timezone to the same date in UTC+00:00 timezone.
	  // This ensures that when UTC functions will be implemented, locales will be compatible with them.
	  // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/376
	  var timezoneOffset = originalDate.getTimezoneOffset();
	  var utcDate = (0, _index12.default)(originalDate, -timezoneOffset, options);
	
	  var formatterOptions = (0, _index10.default)(options);
	  formatterOptions.locale = locale;
	  formatterOptions.formatters = _index8.default;
	
	  // When UTC functions will be implemented, options._originalDate will likely be a part of public API.
	  // Right now, please don't use it in locales. If you have to use an original date,
	  // please restore it from `date`, adding a timezone offset to it.
	  formatterOptions._originalDate = originalDate;
	
	  var result = formatStr.replace(longFormattingTokensRegExp, function (substring) {
	    if (substring[0] === '[') {
	      return substring;
	    }
	
	    if (substring[0] === '\\') {
	      return cleanEscapedString(substring);
	    }
	
	    return formatLong(substring);
	  }).replace(formattingTokensRegExp, function (substring) {
	    var formatter = localeFormatters[substring] || _index8.default[substring];
	
	    if (formatter) {
	      return formatter(utcDate, formatterOptions);
	    } else {
	      return cleanEscapedString(substring);
	    }
	  });
	
	  return result;
	}
	
	function cleanEscapedString(input) {
	  if (input.match(/\[[\s\S]/)) {
	    return input.replace(/^\[|]$/g, '');
	  }
	  return input.replace(/\\/g, '');
	}
	module.exports = exports['default'];

/***/ }),
/* 2209 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isValid;
	
	var _index = __webpack_require__(2203);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name isValid
	 * @category Common Helpers
	 * @summary Is the given date valid?
	 *
	 * @description
	 * Returns false if argument is Invalid Date and true otherwise.
	 * Argument is converted to Date using `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
	 * Invalid Date is a Date, whose time value is NaN.
	 *
	 * Time value of Date: http://es5.github.io/#x15.9.1.1
	 *
	 * @param {*} date - the date to check
	 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
	 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
	 * @returns {Boolean} the date is valid
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
	 *
	 * @example
	 * // For the valid date:
	 * var result = isValid(new Date(2014, 1, 31))
	 * //=> true
	 *
	 * @example
	 * // For the value, convertable into a date:
	 * var result = isValid('2014-02-31')
	 * //=> true
	 *
	 * @example
	 * // For the invalid date:
	 * var result = isValid(new Date(''))
	 * //=> false
	 */
	function isValid(dirtyDate, dirtyOptions) {
	  if (arguments.length < 1) {
	    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
	  }
	
	  var date = (0, _index2.default)(dirtyDate, dirtyOptions);
	  return !isNaN(date);
	}
	module.exports = exports['default'];

/***/ }),
/* 2210 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _index = __webpack_require__(2211);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _index3 = __webpack_require__(2212);
	
	var _index4 = _interopRequireDefault(_index3);
	
	var _index5 = __webpack_require__(2214);
	
	var _index6 = _interopRequireDefault(_index5);
	
	var _index7 = __webpack_require__(2215);
	
	var _index8 = _interopRequireDefault(_index7);
	
	var _index9 = __webpack_require__(2218);
	
	var _index10 = _interopRequireDefault(_index9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @type {Locale}
	 * @category Locales
	 * @summary English locale (United States).
	 * @language English
	 * @iso-639-2 eng
	 */
	var locale = {
	  formatDistance: _index2.default,
	  formatLong: _index4.default,
	  formatRelative: _index6.default,
	  localize: _index8.default,
	  match: _index10.default,
	  options: {
	    weekStartsOn: 0 /* Sunday */
	    , firstWeekContainsDate: 1
	  }
	};
	
	exports.default = locale;
	module.exports = exports['default'];

/***/ }),
/* 2211 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatDistance;
	var formatDistanceLocale = {
	  lessThanXSeconds: {
	    one: 'less than a second',
	    other: 'less than {{count}} seconds'
	  },
	
	  xSeconds: {
	    one: '1 second',
	    other: '{{count}} seconds'
	  },
	
	  halfAMinute: 'half a minute',
	
	  lessThanXMinutes: {
	    one: 'less than a minute',
	    other: 'less than {{count}} minutes'
	  },
	
	  xMinutes: {
	    one: '1 minute',
	    other: '{{count}} minutes'
	  },
	
	  aboutXHours: {
	    one: 'about 1 hour',
	    other: 'about {{count}} hours'
	  },
	
	  xHours: {
	    one: '1 hour',
	    other: '{{count}} hours'
	  },
	
	  xDays: {
	    one: '1 day',
	    other: '{{count}} days'
	  },
	
	  aboutXMonths: {
	    one: 'about 1 month',
	    other: 'about {{count}} months'
	  },
	
	  xMonths: {
	    one: '1 month',
	    other: '{{count}} months'
	  },
	
	  aboutXYears: {
	    one: 'about 1 year',
	    other: 'about {{count}} years'
	  },
	
	  xYears: {
	    one: '1 year',
	    other: '{{count}} years'
	  },
	
	  overXYears: {
	    one: 'over 1 year',
	    other: 'over {{count}} years'
	  },
	
	  almostXYears: {
	    one: 'almost 1 year',
	    other: 'almost {{count}} years'
	  }
	};
	
	function formatDistance(token, count, options) {
	  options = options || {};
	
	  var result;
	  if (typeof formatDistanceLocale[token] === 'string') {
	    result = formatDistanceLocale[token];
	  } else if (count === 1) {
	    result = formatDistanceLocale[token].one;
	  } else {
	    result = formatDistanceLocale[token].other.replace('{{count}}', count);
	  }
	
	  if (options.addSuffix) {
	    if (options.comparison > 0) {
	      return 'in ' + result;
	    } else {
	      return result + ' ago';
	    }
	  }
	
	  return result;
	}
	module.exports = exports['default'];

/***/ }),
/* 2212 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _index = __webpack_require__(2213);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var formatLong = (0, _index2.default)({
	  LT: 'h:mm aa',
	  LTS: 'h:mm:ss aa',
	  L: 'MM/DD/YYYY',
	  LL: 'MMMM D YYYY',
	  LLL: 'MMMM D YYYY h:mm aa',
	  LLLL: 'dddd, MMMM D YYYY h:mm aa'
	});
	
	exports.default = formatLong;
	module.exports = exports['default'];

/***/ }),
/* 2213 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = buildFormatLongFn;
	var tokensToBeShortedPattern = /MMMM|MM|DD|dddd/g;
	
	function buildShortLongFormat(format) {
	  return format.replace(tokensToBeShortedPattern, function (token) {
	    return token.slice(1);
	  });
	}
	
	/**
	 * @name buildFormatLongFn
	 * @category Locale Helpers
	 * @summary Build `formatLong` property for locale used by `format`, `formatRelative` and `parse` functions.
	 *
	 * @description
	 * Build `formatLong` property for locale used by `format`, `formatRelative` and `parse` functions.
	 * Returns a function which takes one of the following tokens as the argument:
	 * `'LTS'`, `'LT'`, `'L'`, `'LL'`, `'LLL'`, `'l'`, `'ll'`, `'lll'`, `'llll'`
	 * and returns a long format string written as `format` token strings.
	 * See [format]{@link https://date-fns.org/docs/format}
	 *
	 * `'l'`, `'ll'`, `'lll'` and `'llll'` formats are built automatically
	 * by shortening some of the tokens from corresponding unshortened formats
	 * (e.g., if `LL` is `'MMMM DD YYYY'` then `ll` will be `MMM D YYYY`)
	 *
	 * @param {Object} obj - the object with long formats written as `format` token strings
	 * @param {String} obj.LT - time format: hours and minutes
	 * @param {String} obj.LTS - time format: hours, minutes and seconds
	 * @param {String} obj.L - short date format: numeric day, month and year
	 * @param {String} [obj.l] - short date format: numeric day, month and year (shortened)
	 * @param {String} obj.LL - long date format: day, month in words, and year
	 * @param {String} [obj.ll] - long date format: day, month in words, and year (shortened)
	 * @param {String} obj.LLL - long date and time format
	 * @param {String} [obj.lll] - long date and time format (shortened)
	 * @param {String} obj.LLLL - long date, time and weekday format
	 * @param {String} [obj.llll] - long date, time and weekday format (shortened)
	 * @returns {Function} `formatLong` property of the locale
	 *
	 * @example
	 * // For `en-US` locale:
	 * locale.formatLong = buildFormatLongFn({
	 *   LT: 'h:mm aa',
	 *   LTS: 'h:mm:ss aa',
	 *   L: 'MM/DD/YYYY',
	 *   LL: 'MMMM D YYYY',
	 *   LLL: 'MMMM D YYYY h:mm aa',
	 *   LLLL: 'dddd, MMMM D YYYY h:mm aa'
	 * })
	 */
	function buildFormatLongFn(obj) {
	  var formatLongLocale = {
	    LTS: obj.LTS,
	    LT: obj.LT,
	    L: obj.L,
	    LL: obj.LL,
	    LLL: obj.LLL,
	    LLLL: obj.LLLL,
	    l: obj.l || buildShortLongFormat(obj.L),
	    ll: obj.ll || buildShortLongFormat(obj.LL),
	    lll: obj.lll || buildShortLongFormat(obj.LLL),
	    llll: obj.llll || buildShortLongFormat(obj.LLLL)
	  };
	
	  return function (token) {
	    return formatLongLocale[token];
	  };
	}
	module.exports = exports["default"];

/***/ }),
/* 2214 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatRelative;
	var formatRelativeLocale = {
	  lastWeek: '[last] dddd [at] LT',
	  yesterday: '[yesterday at] LT',
	  today: '[today at] LT',
	  tomorrow: '[tomorrow at] LT',
	  nextWeek: 'dddd [at] LT',
	  other: 'L'
	};
	
	function formatRelative(token, date, baseDate, options) {
	  return formatRelativeLocale[token];
	}
	module.exports = exports['default'];

/***/ }),
/* 2215 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _index = __webpack_require__(2216);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _index3 = __webpack_require__(2217);
	
	var _index4 = _interopRequireDefault(_index3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Note: in English, the names of days of the week and months are capitalized.
	// If you are making a new locale based on this one, check if the same is true for the language you're working on.
	// Generally, formatted dates should look like they are in the middle of a sentence,
	// e.g. in Spanish language the weekdays and months should be in the lowercase.
	var weekdayValues = {
	  narrow: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
	  short: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
	  long: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
	};
	
	var monthValues = {
	  short: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
	  long: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
	};
	
	// `timeOfDay` is used to designate which part of the day it is, when used with 12-hour clock.
	// Use the system which is used the most commonly in the locale.
	// For example, if the country doesn't use a.m./p.m., you can use `night`/`morning`/`afternoon`/`evening`:
	//
	//   var timeOfDayValues = {
	//     any: ['in the night', 'in the morning', 'in the afternoon', 'in the evening']
	//   }
	//
	// And later:
	//
	//   var localize = {
	//     // The callback takes the hours as the argument and returns the array index
	//     timeOfDay: buildLocalizeFn(timeOfDayValues, 'any', function (hours) {
	//       if (hours >= 17) {
	//         return 3
	//       } else if (hours >= 12) {
	//         return 2
	//       } else if (hours >= 4) {
	//         return 1
	//       } else {
	//         return 0
	//       }
	//     }),
	//     timesOfDay: buildLocalizeArrayFn(timeOfDayValues, 'any')
	//   }
	var timeOfDayValues = {
	  uppercase: ['AM', 'PM'],
	  lowercase: ['am', 'pm'],
	  long: ['a.m.', 'p.m.']
	};
	
	function ordinalNumber(dirtyNumber, dirtyOptions) {
	  var number = Number(dirtyNumber);
	
	  // If ordinal numbers depend on context, for example,
	  // if they are different for different grammatical genders,
	  // use `options.unit`:
	  //
	  //   var options = dirtyOptions || {}
	  //   var unit = String(options.unit)
	  //
	  // where `unit` can be 'month', 'quarter', 'week', 'isoWeek', 'dayOfYear',
	  // 'dayOfMonth' or 'dayOfWeek'
	
	  var rem100 = number % 100;
	  if (rem100 > 20 || rem100 < 10) {
	    switch (rem100 % 10) {
	      case 1:
	        return number + 'st';
	      case 2:
	        return number + 'nd';
	      case 3:
	        return number + 'rd';
	    }
	  }
	  return number + 'th';
	}
	
	var localize = {
	  ordinalNumber: ordinalNumber,
	  weekday: (0, _index2.default)(weekdayValues, 'long'),
	  weekdays: (0, _index4.default)(weekdayValues, 'long'),
	  month: (0, _index2.default)(monthValues, 'long'),
	  months: (0, _index4.default)(monthValues, 'long'),
	  timeOfDay: (0, _index2.default)(timeOfDayValues, 'long', function (hours) {
	    return hours / 12 >= 1 ? 1 : 0;
	  }),
	  timesOfDay: (0, _index4.default)(timeOfDayValues, 'long')
	};
	
	exports.default = localize;
	module.exports = exports['default'];

/***/ }),
/* 2216 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = buildLocalizeFn;
	/**
	 * @name buildLocalizeFn
	 * @category Locale Helpers
	 * @summary Build `localize.weekday`, `localize.month` and `localize.timeOfDay` properties for the locale.
	 *
	 * @description
	 * Build `localize.weekday`, `localize.month` and `localize.timeOfDay` properties for the locale
	 * used by `format` function.
	 * If no `type` is supplied to the options of the resulting function, `defaultType` will be used (see example).
	 *
	 * `localize.weekday` function takes the weekday index as argument (0 - Sunday).
	 * `localize.month` takes the month index (0 - January).
	 * `localize.timeOfDay` takes the hours. Use `indexCallback` to convert them to an array index (see example).
	 *
	 * @param {Object} values - the object with arrays of values
	 * @param {String} defaultType - the default type for the localize function
	 * @param {Function} [indexCallback] - the callback which takes the resulting function argument
	 *   and converts it into value array index
	 * @returns {Function} the resulting function
	 *
	 * @example
	 * var timeOfDayValues = {
	 *   uppercase: ['AM', 'PM'],
	 *   lowercase: ['am', 'pm'],
	 *   long: ['a.m.', 'p.m.']
	 * }
	 * locale.localize.timeOfDay = buildLocalizeFn(timeOfDayValues, 'long', function (hours) {
	 *   // 0 is a.m. array index, 1 is p.m. array index
	 *   return (hours / 12) >= 1 ? 1 : 0
	 * })
	 * locale.localize.timeOfDay(16, {type: 'uppercase'}) //=> 'PM'
	 * locale.localize.timeOfDay(5) //=> 'a.m.'
	 */
	function buildLocalizeFn(values, defaultType, indexCallback) {
	  return function (dirtyIndex, dirtyOptions) {
	    var options = dirtyOptions || {};
	    var type = options.type ? String(options.type) : defaultType;
	    var valuesArray = values[type] || values[defaultType];
	    var index = indexCallback ? indexCallback(Number(dirtyIndex)) : Number(dirtyIndex);
	    return valuesArray[index];
	  };
	}
	module.exports = exports["default"];

/***/ }),
/* 2217 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = buildLocalizeArrayFn;
	/**
	 * @name buildLocalizeArrayFn
	 * @category Locale Helpers
	 * @summary Build `localize.weekdays`, `localize.months` and `localize.timesOfDay` properties for the locale.
	 *
	 * @description
	 * Build `localize.weekdays`, `localize.months` and `localize.timesOfDay` properties for the locale.
	 * If no `type` is supplied to the options of the resulting function, `defaultType` will be used (see example).
	 *
	 * @param {Object} values - the object with arrays of values
	 * @param {String} defaultType - the default type for the localize function
	 * @returns {Function} the resulting function
	 *
	 * @example
	 * var weekdayValues = {
	 *   narrow: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
	 *   short: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
	 *   long: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
	 * }
	 * locale.localize.weekdays = buildLocalizeArrayFn(weekdayValues, 'long')
	 * locale.localize.weekdays({type: 'narrow'}) //=> ['Su', 'Mo', ...]
	 * locale.localize.weekdays() //=> ['Sunday', 'Monday', ...]
	 */
	function buildLocalizeArrayFn(values, defaultType) {
	  return function (dirtyOptions) {
	    var options = dirtyOptions || {};
	    var type = options.type ? String(options.type) : defaultType;
	    return values[type] || values[defaultType];
	  };
	}
	module.exports = exports["default"];

/***/ }),
/* 2218 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _index = __webpack_require__(2219);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _index3 = __webpack_require__(2220);
	
	var _index4 = _interopRequireDefault(_index3);
	
	var _index5 = __webpack_require__(2221);
	
	var _index6 = _interopRequireDefault(_index5);
	
	var _index7 = __webpack_require__(2222);
	
	var _index8 = _interopRequireDefault(_index7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var matchOrdinalNumbersPattern = /^(\d+)(th|st|nd|rd)?/i;
	
	var matchWeekdaysPatterns = {
	  narrow: /^(su|mo|tu|we|th|fr|sa)/i,
	  short: /^(sun|mon|tue|wed|thu|fri|sat)/i,
	  long: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
	};
	
	var parseWeekdayPatterns = {
	  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
	};
	
	var matchMonthsPatterns = {
	  short: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
	  long: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
	};
	
	var parseMonthPatterns = {
	  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
	};
	
	// `timeOfDay` is used to designate which part of the day it is, when used with 12-hour clock.
	// Use the system which is used the most commonly in the locale.
	// For example, if the country doesn't use a.m./p.m., you can use `night`/`morning`/`afternoon`/`evening`:
	//
	//   var matchTimesOfDayPatterns = {
	//     long: /^((in the)? (night|morning|afternoon|evening?))/i
	//   }
	//
	//   var parseTimeOfDayPatterns = {
	//     any: [/(night|morning)/i, /(afternoon|evening)/i]
	//   }
	var matchTimesOfDayPatterns = {
	  short: /^(am|pm)/i,
	  long: /^([ap]\.?\s?m\.?)/i
	};
	
	var parseTimeOfDayPatterns = {
	  any: [/^a/i, /^p/i]
	};
	
	var match = {
	  ordinalNumbers: (0, _index6.default)(matchOrdinalNumbersPattern),
	  ordinalNumber: _index8.default,
	  weekdays: (0, _index2.default)(matchWeekdaysPatterns, 'long'),
	  weekday: (0, _index4.default)(parseWeekdayPatterns, 'any'),
	  months: (0, _index2.default)(matchMonthsPatterns, 'long'),
	  month: (0, _index4.default)(parseMonthPatterns, 'any'),
	  timesOfDay: (0, _index2.default)(matchTimesOfDayPatterns, 'long'),
	  timeOfDay: (0, _index4.default)(parseTimeOfDayPatterns, 'any')
	};
	
	exports.default = match;
	module.exports = exports['default'];

/***/ }),
/* 2219 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = buildMatchFn;
	/**
	 * @name buildMatchFn
	 * @category Locale Helpers
	 * @summary Build `match.weekdays`, `match.months` and `match.timesOfDay` properties for the locale.
	 *
	 * @description
	 * Build `match.weekdays`, `match.months` and `match.timesOfDay` properties for the locale used by `parse` function.
	 * If no `type` is supplied to the options of the resulting function, `defaultType` will be used (see example).
	 * The result of the match function will be passed into corresponding parser function
	 * (`match.weekday`, `match.month` or `match.timeOfDay` respectively. See `buildParseFn`).
	 *
	 * @param {Object} values - the object with RegExps
	 * @param {String} defaultType - the default type for the match function
	 * @returns {Function} the resulting function
	 *
	 * @example
	 * var matchWeekdaysPatterns = {
	 *   narrow: /^(su|mo|tu|we|th|fr|sa)/i,
	 *   short: /^(sun|mon|tue|wed|thu|fri|sat)/i,
	 *   long: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
	 * }
	 * locale.match.weekdays = buildMatchFn(matchWeekdaysPatterns, 'long')
	 * locale.match.weekdays('Sunday', {type: 'narrow'}) //=> ['Su', 'Su', ...]
	 * locale.match.weekdays('Sunday') //=> ['Sunday', 'Sunday', ...]
	 */
	function buildMatchFn(patterns, defaultType) {
	  return function (dirtyString, dirtyOptions) {
	    var options = dirtyOptions || {};
	    var type = options.type ? String(options.type) : defaultType;
	    var pattern = patterns[type] || patterns[defaultType];
	    var string = String(dirtyString);
	    return string.match(pattern);
	  };
	}
	module.exports = exports["default"];

/***/ }),
/* 2220 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = buildParseFn;
	/**
	 * @name buildParseFn
	 * @category Locale Helpers
	 * @summary Build `match.weekday`, `match.month` and `match.timeOfDay` properties for the locale.
	 *
	 * @description
	 * Build `match.weekday`, `match.month` and `match.timeOfDay` properties for the locale used by `parse` function.
	 * The argument of the resulting function is the result of the corresponding match function
	 * (`match.weekdays`, `match.months` or `match.timesOfDay` respectively. See `buildMatchFn`).
	 *
	 * @param {Object} values - the object with arrays of RegExps
	 * @param {String} defaultType - the default type for the parser function
	 * @returns {Function} the resulting function
	 *
	 * @example
	 * var parseWeekdayPatterns = {
	 *   any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
	 * }
	 * locale.match.weekday = buildParseFn(matchWeekdaysPatterns, 'long')
	 * var matchResult = locale.match.weekdays('Friday')
	 * locale.match.weekday(matchResult) //=> 5
	 */
	function buildParseFn(patterns, defaultType) {
	  return function (matchResult, dirtyOptions) {
	    var options = dirtyOptions || {};
	    var type = options.type ? String(options.type) : defaultType;
	    var patternsArray = patterns[type] || patterns[defaultType];
	    var string = matchResult[1];
	
	    return patternsArray.findIndex(function (pattern) {
	      return pattern.test(string);
	    });
	  };
	}
	module.exports = exports["default"];

/***/ }),
/* 2221 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = buildMatchPatternFn;
	/**
	 * @name buildMatchPatternFn
	 * @category Locale Helpers
	 * @summary Build match function from a single RegExp.
	 *
	 * @description
	 * Build match function from a single RegExp.
	 * Usually used for building `match.ordinalNumbers` property of the locale.
	 *
	 * @param {Object} pattern - the RegExp
	 * @returns {Function} the resulting function
	 *
	 * @example
	 * locale.match.ordinalNumbers = buildMatchPatternFn(/^(\d+)(th|st|nd|rd)?/i)
	 * locale.match.ordinalNumbers('3rd') //=> ['3rd', '3', 'rd', ...]
	 */
	function buildMatchPatternFn(pattern) {
	  return function (dirtyString) {
	    var string = String(dirtyString);
	    return string.match(pattern);
	  };
	}
	module.exports = exports["default"];

/***/ }),
/* 2222 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = parseDecimal;
	/**
	 * @name parseDecimal
	 * @category Locale Helpers
	 * @summary Parses the match result into decimal number.
	 *
	 * @description
	 * Parses the match result into decimal number.
	 * Uses the string matched with the first set of parentheses of match RegExp.
	 *
	 * @param {Array} matchResult - the object returned by matching function
	 * @returns {Number} the parsed value
	 *
	 * @example
	 * locale.match = {
	 *   ordinalNumbers: (dirtyString) {
	 *     return String(dirtyString).match(/^(\d+)(th|st|nd|rd)?/i)
	 *   },
	 *   ordinalNumber: parseDecimal
	 * }
	 */
	function parseDecimal(matchResult) {
	  return parseInt(matchResult[1], 10);
	}
	module.exports = exports["default"];

/***/ }),
/* 2223 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _index = __webpack_require__(2224);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _index3 = __webpack_require__(2225);
	
	var _index4 = _interopRequireDefault(_index3);
	
	var _index5 = __webpack_require__(2228);
	
	var _index6 = _interopRequireDefault(_index5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var formatters = {
	  // Month: 1, 2, ..., 12
	  'M': function M(date) {
	    return date.getUTCMonth() + 1;
	  },
	
	  // Month: 1st, 2nd, ..., 12th
	  'Mo': function Mo(date, options) {
	    var month = date.getUTCMonth() + 1;
	    return options.locale.localize.ordinalNumber(month, { unit: 'month' });
	  },
	
	  // Month: 01, 02, ..., 12
	  'MM': function MM(date) {
	    return addLeadingZeros(date.getUTCMonth() + 1, 2);
	  },
	
	  // Month: Jan, Feb, ..., Dec
	  'MMM': function MMM(date, options) {
	    return options.locale.localize.month(date.getUTCMonth(), { type: 'short' });
	  },
	
	  // Month: January, February, ..., December
	  'MMMM': function MMMM(date, options) {
	    return options.locale.localize.month(date.getUTCMonth(), { type: 'long' });
	  },
	
	  // Quarter: 1, 2, 3, 4
	  'Q': function Q(date) {
	    return Math.ceil((date.getUTCMonth() + 1) / 3);
	  },
	
	  // Quarter: 1st, 2nd, 3rd, 4th
	  'Qo': function Qo(date, options) {
	    var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
	    return options.locale.localize.ordinalNumber(quarter, { unit: 'quarter' });
	  },
	
	  // Day of month: 1, 2, ..., 31
	  'D': function D(date) {
	    return date.getUTCDate();
	  },
	
	  // Day of month: 1st, 2nd, ..., 31st
	  'Do': function Do(date, options) {
	    return options.locale.localize.ordinalNumber(date.getUTCDate(), { unit: 'dayOfMonth' });
	  },
	
	  // Day of month: 01, 02, ..., 31
	  'DD': function DD(date) {
	    return addLeadingZeros(date.getUTCDate(), 2);
	  },
	
	  // Day of year: 1, 2, ..., 366
	  'DDD': function DDD(date) {
	    return (0, _index2.default)(date);
	  },
	
	  // Day of year: 1st, 2nd, ..., 366th
	  'DDDo': function DDDo(date, options) {
	    return options.locale.localize.ordinalNumber((0, _index2.default)(date), { unit: 'dayOfYear' });
	  },
	
	  // Day of year: 001, 002, ..., 366
	  'DDDD': function DDDD(date) {
	    return addLeadingZeros((0, _index2.default)(date), 3);
	  },
	
	  // Day of week: Su, Mo, ..., Sa
	  'dd': function dd(date, options) {
	    return options.locale.localize.weekday(date.getUTCDay(), { type: 'narrow' });
	  },
	
	  // Day of week: Sun, Mon, ..., Sat
	  'ddd': function ddd(date, options) {
	    return options.locale.localize.weekday(date.getUTCDay(), { type: 'short' });
	  },
	
	  // Day of week: Sunday, Monday, ..., Saturday
	  'dddd': function dddd(date, options) {
	    return options.locale.localize.weekday(date.getUTCDay(), { type: 'long' });
	  },
	
	  // Day of week: 0, 1, ..., 6
	  'd': function d(date) {
	    return date.getUTCDay();
	  },
	
	  // Day of week: 0th, 1st, 2nd, ..., 6th
	  'do': function _do(date, options) {
	    return options.locale.localize.ordinalNumber(date.getUTCDay(), { unit: 'dayOfWeek' });
	  },
	
	  // Day of ISO week: 1, 2, ..., 7
	  'E': function E(date) {
	    return date.getUTCDay() || 7;
	  },
	
	  // ISO week: 1, 2, ..., 53
	  'W': function W(date) {
	    return (0, _index4.default)(date);
	  },
	
	  // ISO week: 1st, 2nd, ..., 53th
	  'Wo': function Wo(date, options) {
	    return options.locale.localize.ordinalNumber((0, _index4.default)(date), { unit: 'isoWeek' });
	  },
	
	  // ISO week: 01, 02, ..., 53
	  'WW': function WW(date) {
	    return addLeadingZeros((0, _index4.default)(date), 2);
	  },
	
	  // Year: 00, 01, ..., 99
	  'YY': function YY(date) {
	    return addLeadingZeros(date.getUTCFullYear(), 4).substr(2);
	  },
	
	  // Year: 1900, 1901, ..., 2099
	  'YYYY': function YYYY(date) {
	    return addLeadingZeros(date.getUTCFullYear(), 4);
	  },
	
	  // ISO week-numbering year: 00, 01, ..., 99
	  'GG': function GG(date) {
	    return String((0, _index6.default)(date)).substr(2);
	  },
	
	  // ISO week-numbering year: 1900, 1901, ..., 2099
	  'GGGG': function GGGG(date) {
	    return (0, _index6.default)(date);
	  },
	
	  // Hour: 0, 1, ... 23
	  'H': function H(date) {
	    return date.getUTCHours();
	  },
	
	  // Hour: 00, 01, ..., 23
	  'HH': function HH(date) {
	    return addLeadingZeros(date.getUTCHours(), 2);
	  },
	
	  // Hour: 1, 2, ..., 12
	  'h': function h(date) {
	    var hours = date.getUTCHours();
	    if (hours === 0) {
	      return 12;
	    } else if (hours > 12) {
	      return hours % 12;
	    } else {
	      return hours;
	    }
	  },
	
	  // Hour: 01, 02, ..., 12
	  'hh': function hh(date) {
	    return addLeadingZeros(formatters['h'](date), 2);
	  },
	
	  // Minute: 0, 1, ..., 59
	  'm': function m(date) {
	    return date.getUTCMinutes();
	  },
	
	  // Minute: 00, 01, ..., 59
	  'mm': function mm(date) {
	    return addLeadingZeros(date.getUTCMinutes(), 2);
	  },
	
	  // Second: 0, 1, ..., 59
	  's': function s(date) {
	    return date.getUTCSeconds();
	  },
	
	  // Second: 00, 01, ..., 59
	  'ss': function ss(date) {
	    return addLeadingZeros(date.getUTCSeconds(), 2);
	  },
	
	  // 1/10 of second: 0, 1, ..., 9
	  'S': function S(date) {
	    return Math.floor(date.getUTCMilliseconds() / 100);
	  },
	
	  // 1/100 of second: 00, 01, ..., 99
	  'SS': function SS(date) {
	    return addLeadingZeros(Math.floor(date.getUTCMilliseconds() / 10), 2);
	  },
	
	  // Millisecond: 000, 001, ..., 999
	  'SSS': function SSS(date) {
	    return addLeadingZeros(date.getUTCMilliseconds(), 3);
	  },
	
	  // Timezone: -01:00, +00:00, ... +12:00
	  'Z': function Z(date, options) {
	    var originalDate = options._originalDate || date;
	    return formatTimezone(originalDate.getTimezoneOffset(), ':');
	  },
	
	  // Timezone: -0100, +0000, ... +1200
	  'ZZ': function ZZ(date, options) {
	    var originalDate = options._originalDate || date;
	    return formatTimezone(originalDate.getTimezoneOffset());
	  },
	
	  // Seconds timestamp: 512969520
	  'X': function X(date, options) {
	    var originalDate = options._originalDate || date;
	    return Math.floor(originalDate.getTime() / 1000);
	  },
	
	  // Milliseconds timestamp: 512969520900
	  'x': function x(date, options) {
	    var originalDate = options._originalDate || date;
	    return originalDate.getTime();
	  },
	
	  // AM, PM
	  'A': function A(date, options) {
	    return options.locale.localize.timeOfDay(date.getUTCHours(), { type: 'uppercase' });
	  },
	
	  // am, pm
	  'a': function a(date, options) {
	    return options.locale.localize.timeOfDay(date.getUTCHours(), { type: 'lowercase' });
	  },
	
	  // a.m., p.m.
	  'aa': function aa(date, options) {
	    return options.locale.localize.timeOfDay(date.getUTCHours(), { type: 'long' });
	  }
	};
	
	function formatTimezone(offset, delimeter) {
	  delimeter = delimeter || '';
	  var sign = offset > 0 ? '-' : '+';
	  var absOffset = Math.abs(offset);
	  var hours = Math.floor(absOffset / 60);
	  var minutes = absOffset % 60;
	  return sign + addLeadingZeros(hours, 2) + delimeter + addLeadingZeros(minutes, 2);
	}
	
	function addLeadingZeros(number, targetLength) {
	  var output = Math.abs(number).toString();
	  while (output.length < targetLength) {
	    output = '0' + output;
	  }
	  return output;
	}
	
	exports.default = formatters;
	module.exports = exports['default'];

/***/ }),
/* 2224 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getUTCDayOfYear;
	
	var _index = __webpack_require__(2203);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MILLISECONDS_IN_DAY = 86400000;
	
	// This function will be a part of public API when UTC function will be implemented.
	// See issue: https://github.com/date-fns/date-fns/issues/376
	function getUTCDayOfYear(dirtyDate, dirtyOptions) {
	  var date = (0, _index2.default)(dirtyDate, dirtyOptions);
	  var timestamp = date.getTime();
	  date.setUTCMonth(0, 1);
	  date.setUTCHours(0, 0, 0, 0);
	  var startOfYearTimestamp = date.getTime();
	  var difference = timestamp - startOfYearTimestamp;
	  return Math.floor(difference / MILLISECONDS_IN_DAY) + 1;
	}
	module.exports = exports['default'];

/***/ }),
/* 2225 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getUTCISOWeek;
	
	var _index = __webpack_require__(2203);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _index3 = __webpack_require__(2226);
	
	var _index4 = _interopRequireDefault(_index3);
	
	var _index5 = __webpack_require__(2227);
	
	var _index6 = _interopRequireDefault(_index5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MILLISECONDS_IN_WEEK = 604800000;
	
	// This function will be a part of public API when UTC function will be implemented.
	// See issue: https://github.com/date-fns/date-fns/issues/376
	function getUTCISOWeek(dirtyDate, dirtyOptions) {
	  var date = (0, _index2.default)(dirtyDate, dirtyOptions);
	  var diff = (0, _index4.default)(date, dirtyOptions).getTime() - (0, _index6.default)(date, dirtyOptions).getTime();
	
	  // Round the number of days to the nearest integer
	  // because the number of milliseconds in a week is not constant
	  // (e.g. it's different in the week of the daylight saving time clock shift)
	  return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
	}
	module.exports = exports['default'];

/***/ }),
/* 2226 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = startOfUTCISOWeek;
	
	var _index = __webpack_require__(2203);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// This function will be a part of public API when UTC function will be implemented.
	// See issue: https://github.com/date-fns/date-fns/issues/376
	function startOfUTCISOWeek(dirtyDate, dirtyOptions) {
	  var weekStartsOn = 1;
	
	  var date = (0, _index2.default)(dirtyDate, dirtyOptions);
	  var day = date.getUTCDay();
	  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
	
	  date.setUTCDate(date.getUTCDate() - diff);
	  date.setUTCHours(0, 0, 0, 0);
	  return date;
	}
	module.exports = exports['default'];

/***/ }),
/* 2227 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = startOfUTCISOWeekYear;
	
	var _index = __webpack_require__(2228);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _index3 = __webpack_require__(2226);
	
	var _index4 = _interopRequireDefault(_index3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// This function will be a part of public API when UTC function will be implemented.
	// See issue: https://github.com/date-fns/date-fns/issues/376
	function startOfUTCISOWeekYear(dirtyDate, dirtyOptions) {
	  var year = (0, _index2.default)(dirtyDate, dirtyOptions);
	  var fourthOfJanuary = new Date(0);
	  fourthOfJanuary.setUTCFullYear(year, 0, 4);
	  fourthOfJanuary.setUTCHours(0, 0, 0, 0);
	  var date = (0, _index4.default)(fourthOfJanuary, dirtyOptions);
	  return date;
	}
	module.exports = exports['default'];

/***/ }),
/* 2228 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getUTCISOWeekYear;
	
	var _index = __webpack_require__(2203);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _index3 = __webpack_require__(2226);
	
	var _index4 = _interopRequireDefault(_index3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// This function will be a part of public API when UTC function will be implemented.
	// See issue: https://github.com/date-fns/date-fns/issues/376
	function getUTCISOWeekYear(dirtyDate, dirtyOptions) {
	  var date = (0, _index2.default)(dirtyDate, dirtyOptions);
	  var year = date.getUTCFullYear();
	
	  var fourthOfJanuaryOfNextYear = new Date(0);
	  fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
	  fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
	  var startOfNextYear = (0, _index4.default)(fourthOfJanuaryOfNextYear, dirtyOptions);
	
	  var fourthOfJanuaryOfThisYear = new Date(0);
	  fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
	  fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
	  var startOfThisYear = (0, _index4.default)(fourthOfJanuaryOfThisYear, dirtyOptions);
	
	  if (date.getTime() >= startOfNextYear.getTime()) {
	    return year + 1;
	  } else if (date.getTime() >= startOfThisYear.getTime()) {
	    return year;
	  } else {
	    return year - 1;
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 2229 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = cloneObject;
	function cloneObject(dirtyObject) {
	  dirtyObject = dirtyObject || {};
	  var object = {};
	
	  for (var property in dirtyObject) {
	    if (dirtyObject.hasOwnProperty(property)) {
	      object[property] = dirtyObject[property];
	    }
	  }
	
	  return object;
	}
	module.exports = exports["default"];

/***/ }),
/* 2230 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = addUTCMinutes;
	
	var _index = __webpack_require__(2203);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// This function will be a part of public API when UTC function will be implemented.
	// See issue: https://github.com/date-fns/date-fns/issues/376
	function addUTCMinutes(dirtyDate, dirtyAmount, dirtyOptions) {
	  var date = (0, _index2.default)(dirtyDate, dirtyOptions);
	  var amount = Number(dirtyAmount);
	  date.setUTCMinutes(date.getUTCMinutes() + amount);
	  return date;
	}
	module.exports = exports['default'];

/***/ }),
/* 2231 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(956);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _DayCell = __webpack_require__(2201);
	
	var _DayCell2 = _interopRequireDefault(_DayCell);
	
	var _eachDayOfInterval = __webpack_require__(2232);
	
	var _eachDayOfInterval2 = _interopRequireDefault(_eachDayOfInterval);
	
	var _isWithinInterval = __webpack_require__(2233);
	
	var _isWithinInterval2 = _interopRequireDefault(_isWithinInterval);
	
	var _isWeekend = __webpack_require__(2234);
	
	var _isWeekend2 = _interopRequireDefault(_isWeekend);
	
	var _isAfter = __webpack_require__(2205);
	
	var _isAfter2 = _interopRequireDefault(_isAfter);
	
	var _isSameDay = __webpack_require__(2206);
	
	var _isSameDay2 = _interopRequireDefault(_isSameDay);
	
	var _isBefore = __webpack_require__(2204);
	
	var _isBefore2 = _interopRequireDefault(_isBefore);
	
	var _endOfWeek = __webpack_require__(2235);
	
	var _endOfWeek2 = _interopRequireDefault(_endOfWeek);
	
	var _startOfWeek = __webpack_require__(2236);
	
	var _startOfWeek2 = _interopRequireDefault(_startOfWeek);
	
	var _endOfDay = __webpack_require__(2202);
	
	var _endOfDay2 = _interopRequireDefault(_endOfDay);
	
	var _startOfDay = __webpack_require__(2207);
	
	var _startOfDay2 = _interopRequireDefault(_startOfDay);
	
	var _format = __webpack_require__(2208);
	
	var _format2 = _interopRequireDefault(_format);
	
	var _utils = __webpack_require__(2237);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable no-fallthrough */
	
	
	function renderWeekdays(styles, dateOptions) {
	  var now = new Date();
	  return _react2.default.createElement(
	    'div',
	    { className: styles.weekDays },
	    (0, _eachDayOfInterval2.default)({
	      start: (0, _startOfWeek2.default)(now, dateOptions),
	      end: (0, _endOfWeek2.default)(now, dateOptions)
	    }).map(function (day, i) {
	      return _react2.default.createElement(
	        'span',
	        { className: styles.weekDay, key: i },
	        (0, _format2.default)(day, 'ddd', dateOptions)
	      );
	    })
	  );
	}
	
	var Month = function (_PureComponent) {
	  _inherits(Month, _PureComponent);
	
	  function Month() {
	    _classCallCheck(this, Month);
	
	    return _possibleConstructorReturn(this, (Month.__proto__ || Object.getPrototypeOf(Month)).apply(this, arguments));
	  }
	
	  _createClass(Month, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var now = new Date();
	      var _props = this.props,
	          displayMode = _props.displayMode,
	          focusedRange = _props.focusedRange,
	          drag = _props.drag,
	          styles = _props.styles;
	
	      var minDate = this.props.minDate && (0, _startOfDay2.default)(this.props.minDate);
	      var maxDate = this.props.maxDate && (0, _endOfDay2.default)(this.props.maxDate);
	      var monthDisplay = (0, _utils.getMonthDisplayRange)(this.props.month, this.props.dateOptions);
	      var ranges = this.props.ranges;
	      if (displayMode === 'dateRange' && drag.status) {
	        var _drag$range = drag.range,
	            startDate = _drag$range.startDate,
	            endDate = _drag$range.endDate;
	
	        ranges = ranges.map(function (range, i) {
	          if (i !== focusedRange[0]) return range;
	          return _extends({}, range, {
	            startDate: startDate,
	            endDate: endDate
	          });
	        });
	      }
	      var showPreview = this.props.showPreview && !drag.disablePreview;
	      return _react2.default.createElement(
	        'div',
	        { className: styles.month, style: this.props.style },
	        this.props.showMonthName ? _react2.default.createElement(
	          'div',
	          { className: styles.monthName },
	          (0, _format2.default)(this.props.month, this.props.monthDisplayFormat, this.props.dateOptions)
	        ) : null,
	        this.props.showWeekDays && renderWeekdays(styles, this.props.dateOptions),
	        _react2.default.createElement(
	          'div',
	          { className: styles.days, onMouseLeave: this.props.onMouseLeave },
	          (0, _eachDayOfInterval2.default)({ start: monthDisplay.start, end: monthDisplay.end }).map(function (day, index) {
	            var isStartOfMonth = (0, _isSameDay2.default)(day, monthDisplay.startDateOfMonth);
	            var isEndOfMonth = (0, _isSameDay2.default)(day, monthDisplay.endDateOfMonth);
	            var isOutsideMinMax = minDate && (0, _isBefore2.default)(day, minDate) || maxDate && (0, _isAfter2.default)(day, maxDate);
	            return _react2.default.createElement(_DayCell2.default, _extends({}, _this2.props, {
	              ranges: ranges,
	              day: day,
	              preview: showPreview ? _this2.props.preview : null,
	              isWeekend: (0, _isWeekend2.default)(day, _this2.props.dateOptions),
	              isToday: (0, _isSameDay2.default)(day, now),
	              isStartOfWeek: (0, _isSameDay2.default)(day, (0, _startOfWeek2.default)(day, _this2.props.dateOptions)),
	              isEndOfWeek: (0, _isSameDay2.default)(day, (0, _endOfWeek2.default)(day, _this2.props.dateOptions)),
	              isStartOfMonth: isStartOfMonth,
	              isEndOfMonth: isEndOfMonth,
	              key: index,
	              disabled: isOutsideMinMax,
	              isPassive: !(0, _isWithinInterval2.default)(day, {
	                start: monthDisplay.startDateOfMonth,
	                end: monthDisplay.endDateOfMonth
	              }),
	              styles: styles,
	              onMouseDown: _this2.props.onDragSelectionStart,
	              onMouseUp: _this2.props.onDragSelectionEnd,
	              onMouseEnter: _this2.props.onDragSelectionMove,
	              dragRange: drag.range,
	              drag: drag.status
	            }));
	          })
	        )
	      );
	    }
	  }]);
	
	  return Month;
	}(_react.PureComponent);
	
	Month.defaultProps = {};
	
	Month.propTypes = {
	  style: _propTypes2.default.object,
	  styles: _propTypes2.default.object,
	  month: _propTypes2.default.object,
	  drag: _propTypes2.default.object,
	  dateOptions: _propTypes2.default.object,
	  preview: _propTypes2.default.shape({
	    startDate: _propTypes2.default.object,
	    endDate: _propTypes2.default.object
	  }),
	  showPreview: _propTypes2.default.bool,
	  displayMode: _propTypes2.default.oneOf(['dateRange', 'date']),
	  minDate: _propTypes2.default.object,
	  maxDate: _propTypes2.default.object,
	  ranges: _propTypes2.default.arrayOf(_DayCell.rangeShape),
	  focusedRange: _propTypes2.default.arrayOf(_propTypes2.default.number),
	  onDragSelectionStart: _propTypes2.default.func,
	  onDragSelectionEnd: _propTypes2.default.func,
	  onDragSelectionMove: _propTypes2.default.func,
	  onMouseLeave: _propTypes2.default.func,
	  monthDisplayFormat: _propTypes2.default.string,
	  showWeekDays: _propTypes2.default.bool,
	  showMonthName: _propTypes2.default.bool
	};
	
	exports.default = Month;

/***/ }),
/* 2232 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = eachDayOfInterval;
	
	var _index = __webpack_require__(2203);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name eachDayOfInterval
	 * @category Interval Helpers
	 * @summary Return the array of dates within the specified time interval.
	 *
	 * @description
	 * Return the array of dates within the specified time interval.
	 *
	 * @param {Interval} interval - the interval. See [Interval]{@link docs/types/Interval}
	 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
	 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
	 * @returns {Date[]} the array with starts of days from the day of the interval start to the day of the interval end
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
	 * @throws {RangeError} The start of an interval cannot be after its end
	 * @throws {RangeError} Date in interval cannot be `Invalid Date`
	 *
	 * @example
	 * // Each day between 6 October 2014 and 10 October 2014:
	 * var result = eachDayOfInterval({
	 *   start: new Date(2014, 9, 6),
	 *   end: new Date(2014, 9, 10)
	 * })
	 * //=> [
	 * //   Mon Oct 06 2014 00:00:00,
	 * //   Tue Oct 07 2014 00:00:00,
	 * //   Wed Oct 08 2014 00:00:00,
	 * //   Thu Oct 09 2014 00:00:00,
	 * //   Fri Oct 10 2014 00:00:00
	 * // ]
	 */
	function eachDayOfInterval(dirtyInterval, dirtyOptions) {
	  if (arguments.length < 1) {
	    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
	  }
	
	  var interval = dirtyInterval || {};
	  var startDate = (0, _index2.default)(interval.start, dirtyOptions);
	  var endDate = (0, _index2.default)(interval.end, dirtyOptions);
	
	  var endTime = endDate.getTime();
	
	  // Throw an exception if start date is after end date or if any date is `Invalid Date`
	  if (!(startDate.getTime() <= endTime)) {
	    throw new RangeError('Invalid interval');
	  }
	
	  var dates = [];
	
	  var currentDate = startDate;
	  currentDate.setHours(0, 0, 0, 0);
	
	  while (currentDate.getTime() <= endTime) {
	    dates.push((0, _index2.default)(currentDate, dirtyOptions));
	    currentDate.setDate(currentDate.getDate() + 1);
	  }
	
	  return dates;
	}
	module.exports = exports['default'];

/***/ }),
/* 2233 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isWithinInterval;
	
	var _index = __webpack_require__(2203);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name isWithinInterval
	 * @category Interval Helpers
	 * @summary Is the given date within the interval?
	 *
	 * @description
	 * Is the given date within the interval?
	 *
	 * @param {Date|String|Number} date - the date to check
	 * @param {Interval} interval - the interval to check
	 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
	 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
	 * @returns {Boolean} the date is within the interval
	 * @throws {TypeError} 2 arguments required
	 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
	 * @throws {RangeError} The start of an interval cannot be after its end
	 * @throws {RangeError} Date in interval cannot be `Invalid Date`
	 *
	 * @example
	 * // For the date within the interval:
	 * isWithinInterval(
	 *   new Date(2014, 0, 3),
	 *   {start: new Date(2014, 0, 1), end: new Date(2014, 0, 7)}
	 * )
	 * //=> true
	 *
	 * @example
	 * // For the date outside of the interval:
	 * isWithinInterval(
	 *   new Date(2014, 0, 10),
	 *   {start: new Date(2014, 0, 1), end: new Date(2014, 0, 7)}
	 * )
	 * //=> false
	 */
	function isWithinInterval(dirtyDate, dirtyInterval, dirtyOptions) {
	  if (arguments.length < 2) {
	    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
	  }
	
	  var interval = dirtyInterval || {};
	  var time = (0, _index2.default)(dirtyDate, dirtyOptions).getTime();
	  var startTime = (0, _index2.default)(interval.start, dirtyOptions).getTime();
	  var endTime = (0, _index2.default)(interval.end, dirtyOptions).getTime();
	
	  // Throw an exception if start date is after end date or if any date is `Invalid Date`
	  if (!(startTime <= endTime)) {
	    throw new RangeError('Invalid interval');
	  }
	
	  return time >= startTime && time <= endTime;
	}
	module.exports = exports['default'];

/***/ }),
/* 2234 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isWeekend;
	
	var _index = __webpack_require__(2203);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name isWeekend
	 * @category Weekday Helpers
	 * @summary Does the given date fall on a weekend?
	 *
	 * @description
	 * Does the given date fall on a weekend?
	 *
	 * @param {Date|String|Number} date - the date to check
	 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
	 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
	 * @returns {Boolean} the date falls on a weekend
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
	 *
	 * @example
	 * // Does 5 October 2014 fall on a weekend?
	 * var result = isWeekend(new Date(2014, 9, 5))
	 * //=> true
	 */
	function isWeekend(dirtyDate, dirtyOptions) {
	  if (arguments.length < 1) {
	    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
	  }
	
	  var date = (0, _index2.default)(dirtyDate, dirtyOptions);
	  var day = date.getDay();
	  return day === 0 || day === 6;
	}
	module.exports = exports['default'];

/***/ }),
/* 2235 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = endOfWeek;
	
	var _index = __webpack_require__(2203);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name endOfWeek
	 * @category Week Helpers
	 * @summary Return the end of a week for the given date.
	 *
	 * @description
	 * Return the end of a week for the given date.
	 * The result will be in the local timezone.
	 *
	 * @param {Date|String|Number} date - the original date
	 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
	 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
	 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
	 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
	 * @returns {Date} the end of a week
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
	 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
	 *
	 * @example
	 * // The end of a week for 2 September 2014 11:55:00:
	 * var result = endOfWeek(new Date(2014, 8, 2, 11, 55, 0))
	 * //=> Sat Sep 06 2014 23:59:59.999
	 *
	 * @example
	 * // If the week starts on Monday, the end of the week for 2 September 2014 11:55:00:
	 * var result = endOfWeek(new Date(2014, 8, 2, 11, 55, 0), {weekStartsOn: 1})
	 * //=> Sun Sep 07 2014 23:59:59.999
	 */
	function endOfWeek(dirtyDate, dirtyOptions) {
	  if (arguments.length < 1) {
	    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
	  }
	
	  var options = dirtyOptions || {};
	
	  var locale = options.locale;
	  var localeWeekStartsOn = locale && locale.options && locale.options.weekStartsOn;
	  var defaultWeekStartsOn = localeWeekStartsOn === undefined ? 0 : Number(localeWeekStartsOn);
	  var weekStartsOn = options.weekStartsOn === undefined ? defaultWeekStartsOn : Number(options.weekStartsOn);
	
	  // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
	  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
	    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
	  }
	
	  var date = (0, _index2.default)(dirtyDate, options);
	  var day = date.getDay();
	  var diff = (day < weekStartsOn ? -7 : 0) + 6 - (day - weekStartsOn);
	
	  date.setDate(date.getDate() + diff);
	  date.setHours(23, 59, 59, 999);
	  return date;
	}
	module.exports = exports['default'];

/***/ }),
/* 2236 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = startOfWeek;
	
	var _index = __webpack_require__(2203);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name startOfWeek
	 * @category Week Helpers
	 * @summary Return the start of a week for the given date.
	 *
	 * @description
	 * Return the start of a week for the given date.
	 * The result will be in the local timezone.
	 *
	 * @param {Date|String|Number} date - the original date
	 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
	 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
	 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
	 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
	 * @returns {Date} the start of a week
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
	 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
	 *
	 * @example
	 * // The start of a week for 2 September 2014 11:55:00:
	 * var result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0))
	 * //=> Sun Aug 31 2014 00:00:00
	 *
	 * @example
	 * // If the week starts on Monday, the start of the week for 2 September 2014 11:55:00:
	 * var result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0), {weekStartsOn: 1})
	 * //=> Mon Sep 01 2014 00:00:00
	 */
	function startOfWeek(dirtyDate, dirtyOptions) {
	  if (arguments.length < 1) {
	    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
	  }
	
	  var options = dirtyOptions || {};
	  var locale = options.locale;
	  var localeWeekStartsOn = locale && locale.options && locale.options.weekStartsOn;
	  var defaultWeekStartsOn = localeWeekStartsOn === undefined ? 0 : Number(localeWeekStartsOn);
	  var weekStartsOn = options.weekStartsOn === undefined ? defaultWeekStartsOn : Number(options.weekStartsOn);
	
	  // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
	  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
	    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
	  }
	
	  var date = (0, _index2.default)(dirtyDate, options);
	  var day = date.getDay();
	  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
	
	  date.setDate(date.getDate() - diff);
	  date.setHours(0, 0, 0, 0);
	  return date;
	}
	module.exports = exports['default'];

/***/ }),
/* 2237 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.calcFocusDate = calcFocusDate;
	exports.findNextRangeIndex = findNextRangeIndex;
	exports.getMonthDisplayRange = getMonthDisplayRange;
	exports.generateStyles = generateStyles;
	
	var _classnames = __webpack_require__(958);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _endOfWeek = __webpack_require__(2235);
	
	var _endOfWeek2 = _interopRequireDefault(_endOfWeek);
	
	var _startOfWeek = __webpack_require__(2236);
	
	var _startOfWeek2 = _interopRequireDefault(_startOfWeek);
	
	var _endOfMonth = __webpack_require__(2238);
	
	var _endOfMonth2 = _interopRequireDefault(_endOfMonth);
	
	var _startOfMonth = __webpack_require__(2239);
	
	var _startOfMonth2 = _interopRequireDefault(_startOfMonth);
	
	var _areIntervalsOverlapping = __webpack_require__(2240);
	
	var _areIntervalsOverlapping2 = _interopRequireDefault(_areIntervalsOverlapping);
	
	var _addMonths = __webpack_require__(2241);
	
	var _addMonths2 = _interopRequireDefault(_addMonths);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function calcFocusDate(currentFocusedDate, props) {
	  var shownDate = props.shownDate,
	      date = props.date,
	      months = props.months,
	      ranges = props.ranges,
	      focusedRange = props.focusedRange,
	      displayMode = props.displayMode;
	  // find primary date according the props
	
	  var targetInterval = void 0;
	  if (displayMode === 'dateRange') {
	    var range = ranges[focusedRange[0]] || {};
	    targetInterval = {
	      start: range.startDate,
	      end: range.endDate
	    };
	  } else {
	    targetInterval = {
	      start: date,
	      end: date
	    };
	  }
	  targetInterval.start = (0, _startOfMonth2.default)(targetInterval.start || new Date());
	  targetInterval.end = (0, _endOfMonth2.default)(targetInterval.end || targetInterval.start);
	  var targetDate = targetInterval.start || targetInterval.end || shownDate || new Date();
	
	  // initial focus
	  if (!currentFocusedDate) return shownDate || targetDate;
	
	  // // just return targetDate for native scrolled calendars
	  // if (props.scroll.enabled) return targetDate;
	  var currentFocusInterval = {
	    start: (0, _startOfMonth2.default)(currentFocusedDate),
	    end: (0, _endOfMonth2.default)((0, _addMonths2.default)(currentFocusedDate, months - 1))
	  };
	  if ((0, _areIntervalsOverlapping2.default)(targetInterval, currentFocusInterval)) {
	    // don't change focused if new selection in view area
	    return currentFocusedDate;
	  }
	  return targetDate;
	}
	
	function findNextRangeIndex(ranges) {
	  var currentRangeIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : -1;
	
	  var nextIndex = ranges.findIndex(function (range, i) {
	    return i > currentRangeIndex && range.autoFocus !== false && !range.disabled;
	  });
	  if (nextIndex !== -1) return nextIndex;
	  return ranges.findIndex(function (range) {
	    return range.autoFocus !== false && !range.disabled;
	  });
	}
	
	function getMonthDisplayRange(date, dateOptions) {
	  var startDateOfMonth = (0, _startOfMonth2.default)(date, dateOptions);
	  var endDateOfMonth = (0, _endOfMonth2.default)(date, dateOptions);
	  var startDateOfCalendar = (0, _startOfWeek2.default)(startDateOfMonth, dateOptions);
	  var endDateOfCalendar = (0, _endOfWeek2.default)(endDateOfMonth, dateOptions);
	  return {
	    start: startDateOfCalendar,
	    end: endDateOfCalendar,
	    startDateOfMonth: startDateOfMonth,
	    endDateOfMonth: endDateOfMonth
	  };
	}
	
	function generateStyles(sources) {
	  if (!sources.length) return {};
	  var generatedStyles = sources.filter(function (source) {
	    return Boolean(source);
	  }).reduce(function (styles, styleSource) {
	    Object.keys(styleSource).forEach(function (key) {
	      styles[key] = (0, _classnames2.default)(styles[key], styleSource[key]);
	    });
	    return styles;
	  }, {});
	  return generatedStyles;
	}

/***/ }),
/* 2238 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = endOfMonth;
	
	var _index = __webpack_require__(2203);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name endOfMonth
	 * @category Month Helpers
	 * @summary Return the end of a month for the given date.
	 *
	 * @description
	 * Return the end of a month for the given date.
	 * The result will be in the local timezone.
	 *
	 * @param {Date|String|Number} date - the original date
	 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
	 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
	 * @returns {Date} the end of a month
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
	 *
	 * @example
	 * // The end of a month for 2 September 2014 11:55:00:
	 * var result = endOfMonth(new Date(2014, 8, 2, 11, 55, 0))
	 * //=> Tue Sep 30 2014 23:59:59.999
	 */
	function endOfMonth(dirtyDate, dirtyOptions) {
	  if (arguments.length < 1) {
	    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
	  }
	
	  var date = (0, _index2.default)(dirtyDate, dirtyOptions);
	  var month = date.getMonth();
	  date.setFullYear(date.getFullYear(), month + 1, 0);
	  date.setHours(23, 59, 59, 999);
	  return date;
	}
	module.exports = exports['default'];

/***/ }),
/* 2239 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = startOfMonth;
	
	var _index = __webpack_require__(2203);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name startOfMonth
	 * @category Month Helpers
	 * @summary Return the start of a month for the given date.
	 *
	 * @description
	 * Return the start of a month for the given date.
	 * The result will be in the local timezone.
	 *
	 * @param {Date|String|Number} date - the original date
	 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
	 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
	 * @returns {Date} the start of a month
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
	 *
	 * @example
	 * // The start of a month for 2 September 2014 11:55:00:
	 * var result = startOfMonth(new Date(2014, 8, 2, 11, 55, 0))
	 * //=> Mon Sep 01 2014 00:00:00
	 */
	function startOfMonth(dirtyDate, dirtyOptions) {
	  if (arguments.length < 1) {
	    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
	  }
	
	  var date = (0, _index2.default)(dirtyDate, dirtyOptions);
	  date.setDate(1);
	  date.setHours(0, 0, 0, 0);
	  return date;
	}
	module.exports = exports['default'];

/***/ }),
/* 2240 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = areIntervalsOverlapping;
	
	var _index = __webpack_require__(2203);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name areIntervalsOverlapping
	 * @category Interval Helpers
	 * @summary Is the given time interval overlapping with another time interval?
	 *
	 * @description
	 * Is the given time interval overlapping with another time interval?
	 *
	 * @param {Interval} intervalLeft - the first interval to compare. See [Interval]{@link docs/types/Interval}
	 * @param {Interval} intervalRight - the second interval to compare. See [Interval]{@link docs/types/Interval}
	 * @param {Options} [options] - the object with options. See [Options]{@link docs/types/Options}
	 * @returns {Boolean} whether the time intervals are overlapping
	 * @throws {TypeError} 2 arguments required
	 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
	 * @throws {RangeError} The start of an interval cannot be after its end
	 * @throws {RangeError} Date in interval cannot be `Invalid Date`
	 *
	 * @example
	 * // For overlapping time intervals:
	 * areIntervalsOverlapping(
	 *   {start: new Date(2014, 0, 10), end: new Date(2014, 0, 20)},
	 *   {start: new Date(2014, 0, 17), end: new Date(2014, 0, 21)}
	 * )
	 * //=> true
	 *
	 * @example
	 * // For non-overlapping time intervals:
	 * areIntervalsOverlapping(
	 *   {start: new Date(2014, 0, 10), end: new Date(2014, 0, 20)},
	 *   {start: new Date(2014, 0, 21), end: new Date(2014, 0, 22)}
	 * )
	 * //=> false
	 */
	function areIntervalsOverlapping(dirtyIntervalLeft, dirtyIntervalRight, dirtyOptions) {
	  if (arguments.length < 2) {
	    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
	  }
	
	  var intervalLeft = dirtyIntervalLeft || {};
	  var intervalRight = dirtyIntervalRight || {};
	  var leftStartTime = (0, _index2.default)(intervalLeft.start, dirtyOptions).getTime();
	  var leftEndTime = (0, _index2.default)(intervalLeft.end, dirtyOptions).getTime();
	  var rightStartTime = (0, _index2.default)(intervalRight.start, dirtyOptions).getTime();
	  var rightEndTime = (0, _index2.default)(intervalRight.end, dirtyOptions).getTime();
	
	  // Throw an exception if start date is after end date or if any date is `Invalid Date`
	  if (!(leftStartTime <= leftEndTime && rightStartTime <= rightEndTime)) {
	    throw new RangeError('Invalid interval');
	  }
	
	  return leftStartTime < rightEndTime && rightStartTime < leftEndTime;
	}
	module.exports = exports['default'];

/***/ }),
/* 2241 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = addMonths;
	
	var _index = __webpack_require__(2203);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _index3 = __webpack_require__(2242);
	
	var _index4 = _interopRequireDefault(_index3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name addMonths
	 * @category Month Helpers
	 * @summary Add the specified number of months to the given date.
	 *
	 * @description
	 * Add the specified number of months to the given date.
	 *
	 * @param {Date|String|Number} date - the date to be changed
	 * @param {Number} amount - the amount of months to be added
	 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
	 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
	 * @returns {Date} the new date with the months added
	 * @throws {TypeError} 2 arguments required
	 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
	 *
	 * @example
	 * // Add 5 months to 1 September 2014:
	 * var result = addMonths(new Date(2014, 8, 1), 5)
	 * //=> Sun Feb 01 2015 00:00:00
	 */
	function addMonths(dirtyDate, dirtyAmount, dirtyOptions) {
	  if (arguments.length < 2) {
	    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
	  }
	
	  var date = (0, _index2.default)(dirtyDate, dirtyOptions);
	  var amount = Number(dirtyAmount);
	  var desiredMonth = date.getMonth() + amount;
	  var dateWithDesiredMonth = new Date(0);
	  dateWithDesiredMonth.setFullYear(date.getFullYear(), desiredMonth, 1);
	  dateWithDesiredMonth.setHours(0, 0, 0, 0);
	  var daysInMonth = (0, _index4.default)(dateWithDesiredMonth, dirtyOptions);
	  // Set the last day of the new month
	  // if the original date was the last day of the longer month
	  date.setMonth(desiredMonth, Math.min(daysInMonth, date.getDate()));
	  return date;
	}
	module.exports = exports['default'];

/***/ }),
/* 2242 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getDaysInMonth;
	
	var _index = __webpack_require__(2203);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name getDaysInMonth
	 * @category Month Helpers
	 * @summary Get the number of days in a month of the given date.
	 *
	 * @description
	 * Get the number of days in a month of the given date.
	 *
	 * @param {Date|String|Number} date - the given date
	 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
	 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
	 * @returns {Number} the number of days in a month
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
	 *
	 * @example
	 * // How many days are in February 2000?
	 * var result = getDaysInMonth(new Date(2000, 1))
	 * //=> 29
	 */
	function getDaysInMonth(dirtyDate, dirtyOptions) {
	  if (arguments.length < 1) {
	    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
	  }
	
	  var date = (0, _index2.default)(dirtyDate, dirtyOptions);
	  var year = date.getFullYear();
	  var monthIndex = date.getMonth();
	  var lastDayOfMonth = new Date(0);
	  lastDayOfMonth.setFullYear(year, monthIndex + 1, 0);
	  lastDayOfMonth.setHours(0, 0, 0, 0);
	  return lastDayOfMonth.getDate();
	}
	module.exports = exports['default'];

/***/ }),
/* 2243 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [module, __webpack_require__(956), __webpack_require__(300)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(module, require('prop-types'), require('react'));
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod, global.PropTypes, global.React);
	    global.ReactList = mod.exports;
	  }
	})(this, function (_module2, _propTypes, _react) {
	  'use strict';
	
	  var _module3 = _interopRequireDefault(_module2);
	
	  var _propTypes2 = _interopRequireDefault(_propTypes);
	
	  var _react2 = _interopRequireDefault(_react);
	
	  function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : {
	      default: obj
	    };
	  }
	
	  function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	      throw new TypeError("Cannot call a class as a function");
	    }
	  }
	
	  var _createClass = function () {
	    function defineProperties(target, props) {
	      for (var i = 0; i < props.length; i++) {
	        var descriptor = props[i];
	        descriptor.enumerable = descriptor.enumerable || false;
	        descriptor.configurable = true;
	        if ("value" in descriptor) descriptor.writable = true;
	        Object.defineProperty(target, descriptor.key, descriptor);
	      }
	    }
	
	    return function (Constructor, protoProps, staticProps) {
	      if (protoProps) defineProperties(Constructor.prototype, protoProps);
	      if (staticProps) defineProperties(Constructor, staticProps);
	      return Constructor;
	    };
	  }();
	
	  function _possibleConstructorReturn(self, call) {
	    if (!self) {
	      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	    }
	
	    return call && (typeof call === "object" || typeof call === "function") ? call : self;
	  }
	
	  function _inherits(subClass, superClass) {
	    if (typeof superClass !== "function" && superClass !== null) {
	      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	    }
	
	    subClass.prototype = Object.create(superClass && superClass.prototype, {
	      constructor: {
	        value: subClass,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	  }
	
	  var _class, _temp;
	
	  var CLIENT_SIZE_KEYS = { x: 'clientWidth', y: 'clientHeight' };
	  var CLIENT_START_KEYS = { x: 'clientTop', y: 'clientLeft' };
	  var INNER_SIZE_KEYS = { x: 'innerWidth', y: 'innerHeight' };
	  var OFFSET_SIZE_KEYS = { x: 'offsetWidth', y: 'offsetHeight' };
	  var OFFSET_START_KEYS = { x: 'offsetLeft', y: 'offsetTop' };
	  var OVERFLOW_KEYS = { x: 'overflowX', y: 'overflowY' };
	  var SCROLL_SIZE_KEYS = { x: 'scrollWidth', y: 'scrollHeight' };
	  var SCROLL_START_KEYS = { x: 'scrollLeft', y: 'scrollTop' };
	  var SIZE_KEYS = { x: 'width', y: 'height' };
	
	  var NOOP = function NOOP() {};
	
	  // If a browser doesn't support the `options` argument to
	  // add/removeEventListener, we need to check, otherwise we will
	  // accidentally set `capture` with a truthy value.
	  var PASSIVE = function () {
	    if (typeof window === 'undefined') return false;
	    var hasSupport = false;
	    try {
	      document.createElement('div').addEventListener('test', NOOP, {
	        get passive() {
	          hasSupport = true;
	          return false;
	        }
	      });
	    } catch (e) {}
	    return hasSupport;
	  }() ? { passive: true } : false;
	
	  var UNSTABLE_MESSAGE = 'ReactList failed to reach a stable state.';
	  var MAX_SYNC_UPDATES = 100;
	
	  var isEqualSubset = function isEqualSubset(a, b) {
	    for (var key in b) {
	      if (a[key] !== b[key]) return false;
	    }return true;
	  };
	
	  var defaultScrollParentGetter = function defaultScrollParentGetter(component) {
	    var axis = component.props.axis;
	
	    var el = component.getEl();
	    var overflowKey = OVERFLOW_KEYS[axis];
	    while (el = el.parentElement) {
	      switch (window.getComputedStyle(el)[overflowKey]) {
	        case 'auto':case 'scroll':case 'overlay':
	          return el;
	      }
	    }
	    return window;
	  };
	
	  var defaultScrollParentViewportSizeGetter = function defaultScrollParentViewportSizeGetter(component) {
	    var axis = component.props.axis;
	    var scrollParent = component.scrollParent;
	
	    return scrollParent === window ? window[INNER_SIZE_KEYS[axis]] : scrollParent[CLIENT_SIZE_KEYS[axis]];
	  };
	
	  _module3.default.exports = (_temp = _class = function (_Component) {
	    _inherits(ReactList, _Component);
	
	    function ReactList(props) {
	      _classCallCheck(this, ReactList);
	
	      var _this = _possibleConstructorReturn(this, (ReactList.__proto__ || Object.getPrototypeOf(ReactList)).call(this, props));
	
	      var initialIndex = props.initialIndex;
	
	      var itemsPerRow = 1;
	
	      var _this$constrain = _this.constrain(initialIndex, 0, itemsPerRow, props),
	          from = _this$constrain.from,
	          size = _this$constrain.size;
	
	      _this.state = { from: from, size: size, itemsPerRow: itemsPerRow };
	      _this.cache = {};
	      _this.cachedScrollPosition = null;
	      _this.prevPrevState = {};
	      _this.unstable = false;
	      _this.updateCounter = 0;
	      return _this;
	    }
	
	    _createClass(ReactList, [{
	      key: 'componentWillReceiveProps',
	      value: function componentWillReceiveProps(next) {
	        // Viewport scroll is no longer useful if axis changes
	        if (this.props.axis !== next.axis) this.clearSizeCache();
	        var _state = this.state,
	            from = _state.from,
	            size = _state.size,
	            itemsPerRow = _state.itemsPerRow;
	
	        this.maybeSetState(this.constrain(from, size, itemsPerRow, next), NOOP);
	      }
	    }, {
	      key: 'componentDidMount',
	      value: function componentDidMount() {
	        this.updateFrameAndClearCache = this.updateFrameAndClearCache.bind(this);
	        window.addEventListener('resize', this.updateFrameAndClearCache);
	        this.updateFrame(this.scrollTo.bind(this, this.props.initialIndex));
	      }
	    }, {
	      key: 'componentDidUpdate',
	      value: function componentDidUpdate() {
	        var _this2 = this;
	
	        // If the list has reached an unstable state, prevent an infinite loop.
	        if (this.unstable) return;
	
	        if (++this.updateCounter > MAX_SYNC_UPDATES) {
	          this.unstable = true;
	          return console.error(UNSTABLE_MESSAGE);
	        }
	
	        if (!this.updateCounterTimeoutId) {
	          this.updateCounterTimeoutId = setTimeout(function () {
	            _this2.updateCounter = 0;
	            delete _this2.updateCounterTimeoutId;
	          }, 0);
	        }
	
	        this.updateFrame();
	      }
	    }, {
	      key: 'maybeSetState',
	      value: function maybeSetState(b, cb) {
	        if (isEqualSubset(this.state, b)) return cb();
	
	        this.setState(b, cb);
	      }
	    }, {
	      key: 'componentWillUnmount',
	      value: function componentWillUnmount() {
	        window.removeEventListener('resize', this.updateFrameAndClearCache);
	        this.scrollParent.removeEventListener('scroll', this.updateFrameAndClearCache, PASSIVE);
	        this.scrollParent.removeEventListener('mousewheel', NOOP, PASSIVE);
	      }
	    }, {
	      key: 'getOffset',
	      value: function getOffset(el) {
	        var axis = this.props.axis;
	
	        var offset = el[CLIENT_START_KEYS[axis]] || 0;
	        var offsetKey = OFFSET_START_KEYS[axis];
	        do {
	          offset += el[offsetKey] || 0;
	        } while (el = el.offsetParent);
	        return offset;
	      }
	    }, {
	      key: 'getEl',
	      value: function getEl() {
	        return this.el || this.items;
	      }
	    }, {
	      key: 'getScrollPosition',
	      value: function getScrollPosition() {
	        // Cache scroll position as this causes a forced synchronous layout.
	        if (typeof this.cachedScrollPosition === 'number') return this.cachedScrollPosition;
	        var scrollParent = this.scrollParent;
	        var axis = this.props.axis;
	
	        var scrollKey = SCROLL_START_KEYS[axis];
	        var actual = scrollParent === window ?
	        // Firefox always returns document.body[scrollKey] as 0 and Chrome/Safari
	        // always return document.documentElement[scrollKey] as 0, so take
	        // whichever has a value.
	        document.body[scrollKey] || document.documentElement[scrollKey] : scrollParent[scrollKey];
	        var max = this.getScrollSize() - this.props.scrollParentViewportSizeGetter(this);
	        var scroll = Math.max(0, Math.min(actual, max));
	        var el = this.getEl();
	        this.cachedScrollPosition = this.getOffset(scrollParent) + scroll - this.getOffset(el);
	        return this.cachedScrollPosition;
	      }
	    }, {
	      key: 'setScroll',
	      value: function setScroll(offset) {
	        var scrollParent = this.scrollParent;
	        var axis = this.props.axis;
	
	        offset += this.getOffset(this.getEl());
	        if (scrollParent === window) return window.scrollTo(0, offset);
	
	        offset -= this.getOffset(this.scrollParent);
	        scrollParent[SCROLL_START_KEYS[axis]] = offset;
	      }
	    }, {
	      key: 'getScrollSize',
	      value: function getScrollSize() {
	        var scrollParent = this.scrollParent;
	        var _document = document,
	            body = _document.body,
	            documentElement = _document.documentElement;
	
	        var key = SCROLL_SIZE_KEYS[this.props.axis];
	        return scrollParent === window ? Math.max(body[key], documentElement[key]) : scrollParent[key];
	      }
	    }, {
	      key: 'hasDeterminateSize',
	      value: function hasDeterminateSize() {
	        var _props = this.props,
	            itemSizeGetter = _props.itemSizeGetter,
	            type = _props.type;
	
	        return type === 'uniform' || itemSizeGetter;
	      }
	    }, {
	      key: 'getStartAndEnd',
	      value: function getStartAndEnd() {
	        var threshold = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props.threshold;
	
	        var scroll = this.getScrollPosition();
	        var start = Math.max(0, scroll - threshold);
	        var end = scroll + this.props.scrollParentViewportSizeGetter(this) + threshold;
	        if (this.hasDeterminateSize()) {
	          end = Math.min(end, this.getSpaceBefore(this.props.length));
	        }
	        return { start: start, end: end };
	      }
	    }, {
	      key: 'getItemSizeAndItemsPerRow',
	      value: function getItemSizeAndItemsPerRow() {
	        var _props2 = this.props,
	            axis = _props2.axis,
	            useStaticSize = _props2.useStaticSize;
	        var _state2 = this.state,
	            itemSize = _state2.itemSize,
	            itemsPerRow = _state2.itemsPerRow;
	
	        if (useStaticSize && itemSize && itemsPerRow) {
	          return { itemSize: itemSize, itemsPerRow: itemsPerRow };
	        }
	
	        var itemEls = this.items.children;
	        if (!itemEls.length) return {};
	
	        var firstEl = itemEls[0];
	
	        // Firefox has a problem where it will return a *slightly* (less than
	        // thousandths of a pixel) different size for the same element between
	        // renders. This can cause an infinite render loop, so only change the
	        // itemSize when it is significantly different.
	        var firstElSize = firstEl[OFFSET_SIZE_KEYS[axis]];
	        var delta = Math.abs(firstElSize - itemSize);
	        if (isNaN(delta) || delta >= 1) itemSize = firstElSize;
	
	        if (!itemSize) return {};
	
	        var startKey = OFFSET_START_KEYS[axis];
	        var firstStart = firstEl[startKey];
	        itemsPerRow = 1;
	        for (var item = itemEls[itemsPerRow]; item && item[startKey] === firstStart; item = itemEls[itemsPerRow]) {
	          ++itemsPerRow;
	        }return { itemSize: itemSize, itemsPerRow: itemsPerRow };
	      }
	    }, {
	      key: 'clearSizeCache',
	      value: function clearSizeCache() {
	        this.cachedScrollPosition = null;
	      }
	    }, {
	      key: 'updateFrameAndClearCache',
	      value: function updateFrameAndClearCache(cb) {
	        this.clearSizeCache();
	        return this.updateFrame(cb);
	      }
	    }, {
	      key: 'updateFrame',
	      value: function updateFrame(cb) {
	        this.updateScrollParent();
	        if (typeof cb != 'function') cb = NOOP;
	        switch (this.props.type) {
	          case 'simple':
	            return this.updateSimpleFrame(cb);
	          case 'variable':
	            return this.updateVariableFrame(cb);
	          case 'uniform':
	            return this.updateUniformFrame(cb);
	        }
	      }
	    }, {
	      key: 'updateScrollParent',
	      value: function updateScrollParent() {
	        var prev = this.scrollParent;
	        this.scrollParent = this.props.scrollParentGetter(this);
	        if (prev === this.scrollParent) return;
	        if (prev) {
	          prev.removeEventListener('scroll', this.updateFrameAndClearCache);
	          prev.removeEventListener('mousewheel', NOOP);
	        }
	        // If we have a new parent, cached parent dimensions are no longer useful.
	        this.clearSizeCache();
	        this.scrollParent.addEventListener('scroll', this.updateFrameAndClearCache, PASSIVE);
	        // You have to attach mousewheel listener to the scrollable element.
	        // Just an empty listener. After that onscroll events will be fired synchronously.
	        this.scrollParent.addEventListener('mousewheel', NOOP, PASSIVE);
	      }
	    }, {
	      key: 'updateSimpleFrame',
	      value: function updateSimpleFrame(cb) {
	        var _getStartAndEnd = this.getStartAndEnd(),
	            end = _getStartAndEnd.end;
	
	        var itemEls = this.items.children;
	        var elEnd = 0;
	
	        if (itemEls.length) {
	          var axis = this.props.axis;
	
	          var firstItemEl = itemEls[0];
	          var lastItemEl = itemEls[itemEls.length - 1];
	          elEnd = this.getOffset(lastItemEl) + lastItemEl[OFFSET_SIZE_KEYS[axis]] - this.getOffset(firstItemEl);
	        }
	
	        if (elEnd > end) return cb();
	
	        var _props3 = this.props,
	            pageSize = _props3.pageSize,
	            length = _props3.length;
	
	        var size = Math.min(this.state.size + pageSize, length);
	        this.maybeSetState({ size: size }, cb);
	      }
	    }, {
	      key: 'updateVariableFrame',
	      value: function updateVariableFrame(cb) {
	        if (!this.props.itemSizeGetter) this.cacheSizes();
	
	        var _getStartAndEnd2 = this.getStartAndEnd(),
	            start = _getStartAndEnd2.start,
	            end = _getStartAndEnd2.end;
	
	        var _props4 = this.props,
	            length = _props4.length,
	            pageSize = _props4.pageSize;
	
	        var space = 0;
	        var from = 0;
	        var size = 0;
	        var maxFrom = length - 1;
	
	        while (from < maxFrom) {
	          var itemSize = this.getSizeOfItem(from);
	          if (itemSize == null || space + itemSize > start) break;
	          space += itemSize;
	          ++from;
	        }
	
	        var maxSize = length - from;
	
	        while (size < maxSize && space < end) {
	          var _itemSize = this.getSizeOfItem(from + size);
	          if (_itemSize == null) {
	            size = Math.min(size + pageSize, maxSize);
	            break;
	          }
	          space += _itemSize;
	          ++size;
	        }
	
	        this.maybeSetState({ from: from, size: size }, cb);
	      }
	    }, {
	      key: 'updateUniformFrame',
	      value: function updateUniformFrame(cb) {
	        var _getItemSizeAndItemsP = this.getItemSizeAndItemsPerRow(),
	            itemSize = _getItemSizeAndItemsP.itemSize,
	            itemsPerRow = _getItemSizeAndItemsP.itemsPerRow;
	
	        if (!itemSize || !itemsPerRow) return cb();
	
	        var _getStartAndEnd3 = this.getStartAndEnd(),
	            start = _getStartAndEnd3.start,
	            end = _getStartAndEnd3.end;
	
	        var _constrain = this.constrain(Math.floor(start / itemSize) * itemsPerRow, (Math.ceil((end - start) / itemSize) + 1) * itemsPerRow, itemsPerRow, this.props),
	            from = _constrain.from,
	            size = _constrain.size;
	
	        return this.maybeSetState({ itemsPerRow: itemsPerRow, from: from, itemSize: itemSize, size: size }, cb);
	      }
	    }, {
	      key: 'getSpaceBefore',
	      value: function getSpaceBefore(index) {
	        var cache = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	        if (cache[index] != null) return cache[index];
	
	        // Try the static itemSize.
	        var _state3 = this.state,
	            itemSize = _state3.itemSize,
	            itemsPerRow = _state3.itemsPerRow;
	
	        if (itemSize) {
	          return cache[index] = Math.floor(index / itemsPerRow) * itemSize;
	        }
	
	        // Find the closest space to index there is a cached value for.
	        var from = index;
	        while (from > 0 && cache[--from] == null) {}
	
	        // Finally, accumulate sizes of items from - index.
	        var space = cache[from] || 0;
	        for (var i = from; i < index; ++i) {
	          cache[i] = space;
	          var _itemSize2 = this.getSizeOfItem(i);
	          if (_itemSize2 == null) break;
	          space += _itemSize2;
	        }
	
	        return cache[index] = space;
	      }
	    }, {
	      key: 'cacheSizes',
	      value: function cacheSizes() {
	        var cache = this.cache;
	        var from = this.state.from;
	
	        var itemEls = this.items.children;
	        var sizeKey = OFFSET_SIZE_KEYS[this.props.axis];
	        for (var i = 0, l = itemEls.length; i < l; ++i) {
	          cache[from + i] = itemEls[i][sizeKey];
	        }
	      }
	    }, {
	      key: 'getSizeOfItem',
	      value: function getSizeOfItem(index) {
	        var cache = this.cache,
	            items = this.items;
	        var _props5 = this.props,
	            axis = _props5.axis,
	            itemSizeGetter = _props5.itemSizeGetter,
	            itemSizeEstimator = _props5.itemSizeEstimator,
	            type = _props5.type;
	        var _state4 = this.state,
	            from = _state4.from,
	            itemSize = _state4.itemSize,
	            size = _state4.size;
	
	
	        // Try the static itemSize.
	        if (itemSize) return itemSize;
	
	        // Try the itemSizeGetter.
	        if (itemSizeGetter) return itemSizeGetter(index);
	
	        // Try the cache.
	        if (index in cache) return cache[index];
	
	        // Try the DOM.
	        if (type === 'simple' && index >= from && index < from + size && items) {
	          var itemEl = items.children[index - from];
	          if (itemEl) return itemEl[OFFSET_SIZE_KEYS[axis]];
	        }
	
	        // Try the itemSizeEstimator.
	        if (itemSizeEstimator) return itemSizeEstimator(index, cache);
	      }
	    }, {
	      key: 'constrain',
	      value: function constrain(from, size, itemsPerRow, _ref) {
	        var length = _ref.length,
	            minSize = _ref.minSize,
	            type = _ref.type;
	
	        size = Math.max(size, minSize);
	        var mod = size % itemsPerRow;
	        if (mod) size += itemsPerRow - mod;
	        if (size > length) size = length;
	        from = type === 'simple' || !from ? 0 : Math.max(Math.min(from, length - size), 0);
	
	        if (mod = from % itemsPerRow) {
	          from -= mod;
	          size += mod;
	        }
	
	        return { from: from, size: size };
	      }
	    }, {
	      key: 'scrollTo',
	      value: function scrollTo(index) {
	        if (index != null) this.setScroll(this.getSpaceBefore(index));
	      }
	    }, {
	      key: 'scrollAround',
	      value: function scrollAround(index) {
	        var current = this.getScrollPosition();
	        var bottom = this.getSpaceBefore(index);
	        var top = bottom - this.props.scrollParentViewportSizeGetter(this) + this.getSizeOfItem(index);
	        var min = Math.min(top, bottom);
	        var max = Math.max(top, bottom);
	        if (current <= min) return this.setScroll(min);
	        if (current > max) return this.setScroll(max);
	      }
	    }, {
	      key: 'getVisibleRange',
	      value: function getVisibleRange() {
	        var _state5 = this.state,
	            from = _state5.from,
	            size = _state5.size;
	
	        var _getStartAndEnd4 = this.getStartAndEnd(0),
	            start = _getStartAndEnd4.start,
	            end = _getStartAndEnd4.end;
	
	        var cache = {};
	        var first = void 0,
	            last = void 0;
	        for (var i = from; i < from + size; ++i) {
	          var itemStart = this.getSpaceBefore(i, cache);
	          var itemEnd = itemStart + this.getSizeOfItem(i);
	          if (first == null && itemEnd > start) first = i;
	          if (first != null && itemStart < end) last = i;
	        }
	        return [first, last];
	      }
	    }, {
	      key: 'renderItems',
	      value: function renderItems() {
	        var _this3 = this;
	
	        var _props6 = this.props,
	            itemRenderer = _props6.itemRenderer,
	            itemsRenderer = _props6.itemsRenderer;
	        var _state6 = this.state,
	            from = _state6.from,
	            size = _state6.size;
	
	        var items = [];
	        for (var i = 0; i < size; ++i) {
	          items.push(itemRenderer(from + i, i));
	        }return itemsRenderer(items, function (c) {
	          return _this3.items = c;
	        });
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        var _this4 = this;
	
	        var _props7 = this.props,
	            axis = _props7.axis,
	            length = _props7.length,
	            type = _props7.type,
	            useTranslate3d = _props7.useTranslate3d;
	        var _state7 = this.state,
	            from = _state7.from,
	            itemsPerRow = _state7.itemsPerRow;
	
	
	        var items = this.renderItems();
	        if (type === 'simple') return items;
	
	        var style = { position: 'relative' };
	        var cache = {};
	        var bottom = Math.ceil(length / itemsPerRow) * itemsPerRow;
	        var size = this.getSpaceBefore(bottom, cache);
	        if (size) {
	          style[SIZE_KEYS[axis]] = size;
	          if (axis === 'x') style.overflowX = 'hidden';
	        }
	        var offset = this.getSpaceBefore(from, cache);
	        var x = axis === 'x' ? offset : 0;
	        var y = axis === 'y' ? offset : 0;
	        var transform = useTranslate3d ? 'translate3d(' + x + 'px, ' + y + 'px, 0)' : 'translate(' + x + 'px, ' + y + 'px)';
	        var listStyle = {
	          msTransform: transform,
	          WebkitTransform: transform,
	          transform: transform
	        };
	        return _react2.default.createElement(
	          'div',
	          { style: style, ref: function ref(c) {
	              return _this4.el = c;
	            } },
	          _react2.default.createElement(
	            'div',
	            { style: listStyle },
	            items
	          )
	        );
	      }
	    }]);
	
	    return ReactList;
	  }(_react.Component), _class.displayName = 'ReactList', _class.propTypes = {
	    axis: _propTypes2.default.oneOf(['x', 'y']),
	    initialIndex: _propTypes2.default.number,
	    itemRenderer: _propTypes2.default.func,
	    itemSizeEstimator: _propTypes2.default.func,
	    itemSizeGetter: _propTypes2.default.func,
	    itemsRenderer: _propTypes2.default.func,
	    length: _propTypes2.default.number,
	    minSize: _propTypes2.default.number,
	    pageSize: _propTypes2.default.number,
	    scrollParentGetter: _propTypes2.default.func,
	    scrollParentViewportSizeGetter: _propTypes2.default.func,
	    threshold: _propTypes2.default.number,
	    type: _propTypes2.default.oneOf(['simple', 'variable', 'uniform']),
	    useStaticSize: _propTypes2.default.bool,
	    useTranslate3d: _propTypes2.default.bool
	  }, _class.defaultProps = {
	    axis: 'y',
	    itemRenderer: function itemRenderer(index, key) {
	      return _react2.default.createElement(
	        'div',
	        { key: key },
	        index
	      );
	    },
	    itemsRenderer: function itemsRenderer(items, ref) {
	      return _react2.default.createElement(
	        'div',
	        { ref: ref },
	        items
	      );
	    },
	    length: 0,
	    minSize: 1,
	    pageSize: 10,
	    scrollParentGetter: defaultScrollParentGetter,
	    scrollParentViewportSizeGetter: defaultScrollParentViewportSizeGetter,
	    threshold: 100,
	    type: 'simple',
	    useStaticSize: false,
	    useTranslate3d: false
	  }, _temp);
	});


/***/ }),
/* 2244 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = max;
	
	var _index = __webpack_require__(2203);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name max
	 * @category Common Helpers
	 * @summary Return the latest of the given dates.
	 *
	 * @description
	 * Return the latest of the given dates.
	 *
	 * @param {Date[]|String[]|Number[]} datesArray - the dates to compare
	 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
	 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
	 * @returns {Date} the latest of the dates
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
	 *
	 * @example
	 * // Which of these dates is the latest?
	 * var result = max(
	 *  [
	 *    new Date(1989, 6, 10),
	 *    new Date(1987, 1, 11),
	 *    new Date(1995, 6, 2),
	 *    new Date(1990, 0, 1)
	 *  ]
	 * )
	 * //=> Sun Jul 02 1995 00:00:00
	 */
	function max(dirtyDatesArray, dirtyOptions) {
	  if (arguments.length < 1) {
	    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
	  }
	
	  var datesArray;
	  // `dirtyDatesArray` is undefined or null
	  if (dirtyDatesArray == null) {
	    datesArray = [];
	
	    // `dirtyDatesArray` is Array, Set or Map, or object with custom `forEach` method
	  } else if (typeof dirtyDatesArray.forEach === 'function') {
	    datesArray = dirtyDatesArray;
	
	    // If `dirtyDatesArray` is Array-like Object, convert to Array. Otherwise, make it empty Array
	  } else {
	    datesArray = Array.prototype.slice.call(dirtyDatesArray);
	  }
	
	  var result;
	  datesArray.forEach(function (dirtyDate) {
	    var currentDate = (0, _index2.default)(dirtyDate, dirtyOptions);
	
	    if (result === undefined || result < currentDate || isNaN(currentDate)) {
	      result = currentDate;
	    }
	  });
	
	  return result;
	}
	module.exports = exports['default'];

/***/ }),
/* 2245 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = min;
	
	var _index = __webpack_require__(2203);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name min
	 * @category Common Helpers
	 * @summary Return the earliest of the given dates.
	 *
	 * @description
	 * Return the earliest of the given dates.
	 *
	 * @param {Date[]|String[]|Number[]} datesArray - the dates to compare
	 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
	 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
	 * @returns {Date} the earliest of the dates
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
	 *
	 * @example
	 * // Which of these dates is the earliest?
	 * var result = min(
	 *  [
	 *    new Date(1989, 6, 10),
	 *    new Date(1987, 1, 11),
	 *    new Date(1995, 6, 2),
	 *    new Date(1990, 0, 1)
	 *  ]
	 * )
	 * //=> Wed Feb 11 1987 00:00:00
	 */
	function min(dirtyDatesArray, dirtyOptions) {
	  if (arguments.length < 1) {
	    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
	  }
	
	  var datesArray;
	  // `dirtyDatesArray` is undefined or null
	  if (dirtyDatesArray == null) {
	    datesArray = [];
	
	    // `dirtyDatesArray` is Array, Set or Map, or object with custom `forEach` method
	  } else if (typeof dirtyDatesArray.forEach === 'function') {
	    datesArray = dirtyDatesArray;
	
	    // If `dirtyDatesArray` is Array-like Object, convert to Array. Otherwise, make it empty Array
	  } else {
	    datesArray = Array.prototype.slice.call(dirtyDatesArray);
	  }
	
	  var result;
	  datesArray.forEach(function (dirtyDate) {
	    var currentDate = (0, _index2.default)(dirtyDate, dirtyOptions);
	
	    if (result === undefined || result > currentDate || isNaN(currentDate)) {
	      result = currentDate;
	    }
	  });
	
	  return result;
	}
	module.exports = exports['default'];

/***/ }),
/* 2246 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = differenceInDays;
	
	var _index = __webpack_require__(2203);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _index3 = __webpack_require__(2247);
	
	var _index4 = _interopRequireDefault(_index3);
	
	var _index5 = __webpack_require__(2248);
	
	var _index6 = _interopRequireDefault(_index5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name differenceInDays
	 * @category Day Helpers
	 * @summary Get the number of full days between the given dates.
	 *
	 * @description
	 * Get the number of full days between the given dates.
	 *
	 * @param {Date|String|Number} dateLeft - the later date
	 * @param {Date|String|Number} dateRight - the earlier date
	 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
	 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
	 * @returns {Number} the number of full days
	 * @throws {TypeError} 2 arguments required
	 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
	 *
	 * @example
	 * // How many full days are between
	 * // 2 July 2011 23:00:00 and 2 July 2012 00:00:00?
	 * var result = differenceInDays(
	 *   new Date(2012, 6, 2, 0, 0),
	 *   new Date(2011, 6, 2, 23, 0)
	 * )
	 * //=> 365
	 */
	function differenceInDays(dirtyDateLeft, dirtyDateRight, dirtyOptions) {
	  if (arguments.length < 2) {
	    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
	  }
	
	  var dateLeft = (0, _index2.default)(dirtyDateLeft, dirtyOptions);
	  var dateRight = (0, _index2.default)(dirtyDateRight, dirtyOptions);
	
	  var sign = (0, _index6.default)(dateLeft, dateRight, dirtyOptions);
	  var difference = Math.abs((0, _index4.default)(dateLeft, dateRight, dirtyOptions));
	  dateLeft.setDate(dateLeft.getDate() - sign * difference);
	
	  // Math.abs(diff in full days - diff in calendar days) === 1 if last calendar day is not full
	  // If so, result must be decreased by 1 in absolute value
	  var isLastDayNotFull = (0, _index6.default)(dateLeft, dateRight, dirtyOptions) === -sign;
	  return sign * (difference - isLastDayNotFull);
	}
	module.exports = exports['default'];

/***/ }),
/* 2247 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = differenceInCalendarDays;
	
	var _index = __webpack_require__(2207);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MILLISECONDS_IN_MINUTE = 60000;
	var MILLISECONDS_IN_DAY = 86400000;
	
	/**
	 * @name differenceInCalendarDays
	 * @category Day Helpers
	 * @summary Get the number of calendar days between the given dates.
	 *
	 * @description
	 * Get the number of calendar days between the given dates.
	 *
	 * @param {Date|String|Number} dateLeft - the later date
	 * @param {Date|String|Number} dateRight - the earlier date
	 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
	 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
	 * @returns {Number} the number of calendar days
	 * @throws {TypeError} 2 arguments required
	 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
	 *
	 * @example
	 * // How many calendar days are between
	 * // 2 July 2011 23:00:00 and 2 July 2012 00:00:00?
	 * var result = differenceInCalendarDays(
	 *   new Date(2012, 6, 2, 0, 0),
	 *   new Date(2011, 6, 2, 23, 0)
	 * )
	 * //=> 366
	 */
	function differenceInCalendarDays(dirtyDateLeft, dirtyDateRight, dirtyOptions) {
	  if (arguments.length < 2) {
	    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
	  }
	
	  var startOfDayLeft = (0, _index2.default)(dirtyDateLeft, dirtyOptions);
	  var startOfDayRight = (0, _index2.default)(dirtyDateRight, dirtyOptions);
	
	  var timestampLeft = startOfDayLeft.getTime() - startOfDayLeft.getTimezoneOffset() * MILLISECONDS_IN_MINUTE;
	  var timestampRight = startOfDayRight.getTime() - startOfDayRight.getTimezoneOffset() * MILLISECONDS_IN_MINUTE;
	
	  // Round the number of days to the nearest integer
	  // because the number of milliseconds in a day is not constant
	  // (e.g. it's different in the day of the daylight saving time clock shift)
	  return Math.round((timestampLeft - timestampRight) / MILLISECONDS_IN_DAY);
	}
	module.exports = exports['default'];

/***/ }),
/* 2248 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = compareAsc;
	
	var _index = __webpack_require__(2203);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name compareAsc
	 * @category Common Helpers
	 * @summary Compare the two dates and return -1, 0 or 1.
	 *
	 * @description
	 * Compare the two dates and return 1 if the first date is after the second,
	 * -1 if the first date is before the second or 0 if dates are equal.
	 *
	 * @param {Date|String|Number} dateLeft - the first date to compare
	 * @param {Date|String|Number} dateRight - the second date to compare
	 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
	 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
	 * @returns {Number} the result of the comparison
	 * @throws {TypeError} 2 arguments required
	 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
	 *
	 * @example
	 * // Compare 11 February 1987 and 10 July 1989:
	 * var result = compareAsc(
	 *   new Date(1987, 1, 11),
	 *   new Date(1989, 6, 10)
	 * )
	 * //=> -1
	 *
	 * @example
	 * // Sort the array of dates:
	 * var result = [
	 *   new Date(1995, 6, 2),
	 *   new Date(1987, 1, 11),
	 *   new Date(1989, 6, 10)
	 * ].sort(compareAsc)
	 * //=> [
	 * //   Wed Feb 11 1987 00:00:00,
	 * //   Mon Jul 10 1989 00:00:00,
	 * //   Sun Jul 02 1995 00:00:00
	 * // ]
	 */
	function compareAsc(dirtyDateLeft, dirtyDateRight, dirtyOptions) {
	  if (arguments.length < 2) {
	    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
	  }
	
	  var dateLeft = (0, _index2.default)(dirtyDateLeft, dirtyOptions);
	  var dateRight = (0, _index2.default)(dirtyDateRight, dirtyOptions);
	
	  var diff = dateLeft.getTime() - dateRight.getTime();
	
	  if (diff < 0) {
	    return -1;
	  } else if (diff > 0) {
	    return 1;
	    // Return 0 if diff is 0; return NaN if diff is NaN
	  } else {
	    return diff;
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 2249 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isSameMonth;
	
	var _index = __webpack_require__(2203);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name isSameMonth
	 * @category Month Helpers
	 * @summary Are the given dates in the same month?
	 *
	 * @description
	 * Are the given dates in the same month?
	 *
	 * @param {Date|String|Number} dateLeft - the first date to check
	 * @param {Date|String|Number} dateRight - the second date to check
	 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
	 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
	 * @returns {Boolean} the dates are in the same month
	 * @throws {TypeError} 2 arguments required
	 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
	 *
	 * @example
	 * // Are 2 September 2014 and 25 September 2014 in the same month?
	 * var result = isSameMonth(
	 *   new Date(2014, 8, 2),
	 *   new Date(2014, 8, 25)
	 * )
	 * //=> true
	 */
	function isSameMonth(dirtyDateLeft, dirtyDateRight, dirtyOptions) {
	  if (arguments.length < 2) {
	    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
	  }
	
	  var dateLeft = (0, _index2.default)(dirtyDateLeft, dirtyOptions);
	  var dateRight = (0, _index2.default)(dirtyDateRight, dirtyOptions);
	  return dateLeft.getFullYear() === dateRight.getFullYear() && dateLeft.getMonth() === dateRight.getMonth();
	}
	module.exports = exports['default'];

/***/ }),
/* 2250 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = addDays;
	
	var _index = __webpack_require__(2203);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name addDays
	 * @category Day Helpers
	 * @summary Add the specified number of days to the given date.
	 *
	 * @description
	 * Add the specified number of days to the given date.
	 *
	 * @param {Date|String|Number} date - the date to be changed
	 * @param {Number} amount - the amount of days to be added
	 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
	 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
	 * @returns {Date} the new date with the days added
	 * @throws {TypeError} 2 arguments required
	 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
	 *
	 * @example
	 * // Add 10 days to 1 September 2014:
	 * var result = addDays(new Date(2014, 8, 1), 10)
	 * //=> Thu Sep 11 2014 00:00:00
	 */
	function addDays(dirtyDate, dirtyAmount, dirtyOptions) {
	  if (arguments.length < 2) {
	    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
	  }
	
	  var date = (0, _index2.default)(dirtyDate, dirtyOptions);
	  var amount = Number(dirtyAmount);
	  date.setDate(date.getDate() + amount);
	  return date;
	}
	module.exports = exports['default'];

/***/ }),
/* 2251 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = differenceInCalendarMonths;
	
	var _index = __webpack_require__(2203);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name differenceInCalendarMonths
	 * @category Month Helpers
	 * @summary Get the number of calendar months between the given dates.
	 *
	 * @description
	 * Get the number of calendar months between the given dates.
	 *
	 * @param {Date|String|Number} dateLeft - the later date
	 * @param {Date|String|Number} dateRight - the earlier date
	 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
	 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
	 * @returns {Number} the number of calendar months
	 * @throws {TypeError} 2 arguments required
	 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
	 *
	 * @example
	 * // How many calendar months are between 31 January 2014 and 1 September 2014?
	 * var result = differenceInCalendarMonths(
	 *   new Date(2014, 8, 1),
	 *   new Date(2014, 0, 31)
	 * )
	 * //=> 8
	 */
	function differenceInCalendarMonths(dirtyDateLeft, dirtyDateRight, dirtyOptions) {
	  if (arguments.length < 2) {
	    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
	  }
	
	  var dateLeft = (0, _index2.default)(dirtyDateLeft, dirtyOptions);
	  var dateRight = (0, _index2.default)(dirtyDateRight, dirtyOptions);
	
	  var yearDiff = dateLeft.getFullYear() - dateRight.getFullYear();
	  var monthDiff = dateLeft.getMonth() - dateRight.getMonth();
	
	  return yearDiff * 12 + monthDiff;
	}
	module.exports = exports['default'];

/***/ }),
/* 2252 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = setMonth;
	
	var _index = __webpack_require__(2203);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _index3 = __webpack_require__(2242);
	
	var _index4 = _interopRequireDefault(_index3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name setMonth
	 * @category Month Helpers
	 * @summary Set the month to the given date.
	 *
	 * @description
	 * Set the month to the given date.
	 *
	 * @param {Date|String|Number} date - the date to be changed
	 * @param {Number} month - the month of the new date
	 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
	 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
	 * @returns {Date} the new date with the month setted
	 * @throws {TypeError} 2 arguments required
	 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
	 *
	 * @example
	 * // Set February to 1 September 2014:
	 * var result = setMonth(new Date(2014, 8, 1), 1)
	 * //=> Sat Feb 01 2014 00:00:00
	 */
	function setMonth(dirtyDate, dirtyMonth, dirtyOptions) {
	  if (arguments.length < 2) {
	    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
	  }
	
	  var date = (0, _index2.default)(dirtyDate, dirtyOptions);
	  var month = Number(dirtyMonth);
	  var year = date.getFullYear();
	  var day = date.getDate();
	
	  var dateWithDesiredMonth = new Date(0);
	  dateWithDesiredMonth.setFullYear(year, month, 15);
	  dateWithDesiredMonth.setHours(0, 0, 0, 0);
	  var daysInMonth = (0, _index4.default)(dateWithDesiredMonth, dirtyOptions);
	  // Set the last day of the new month
	  // if the original date was the last day of the longer month
	  date.setMonth(month, Math.min(day, daysInMonth));
	  return date;
	}
	module.exports = exports['default'];

/***/ }),
/* 2253 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = setYear;
	
	var _index = __webpack_require__(2203);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name setYear
	 * @category Year Helpers
	 * @summary Set the year to the given date.
	 *
	 * @description
	 * Set the year to the given date.
	 *
	 * @param {Date|String|Number} date - the date to be changed
	 * @param {Number} year - the year of the new date
	 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
	 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
	 * @returns {Date} the new date with the year setted
	 * @throws {TypeError} 2 arguments required
	 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
	 *
	 * @example
	 * // Set year 2013 to 1 September 2014:
	 * var result = setYear(new Date(2014, 8, 1), 2013)
	 * //=> Sun Sep 01 2013 00:00:00
	 */
	function setYear(dirtyDate, dirtyYear, dirtyOptions) {
	  if (arguments.length < 2) {
	    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
	  }
	
	  var date = (0, _index2.default)(dirtyDate, dirtyOptions);
	  var year = Number(dirtyYear);
	
	  // Check if date is Invalid Date because Date.prototype.setFullYear ignores the value of Invalid Date
	  if (isNaN(date)) {
	    return new Date(NaN);
	  }
	
	  date.setFullYear(year);
	  return date;
	}
	module.exports = exports['default'];

/***/ }),
/* 2254 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = addYears;
	
	var _index = __webpack_require__(2241);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name addYears
	 * @category Year Helpers
	 * @summary Add the specified number of years to the given date.
	 *
	 * @description
	 * Add the specified number of years to the given date.
	 *
	 * @param {Date|String|Number} date - the date to be changed
	 * @param {Number} amount - the amount of years to be added
	 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
	 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
	 * @returns {Date} the new date with the years added
	 * @throws {TypeError} 2 arguments required
	 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
	 *
	 * @example
	 * // Add 5 years to 1 September 2014:
	 * var result = addYears(new Date(2014, 8, 1), 5)
	 * //=> Sun Sep 01 2019 00:00:00
	 */
	function addYears(dirtyDate, dirtyAmount, dirtyOptions) {
	  if (arguments.length < 2) {
	    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
	  }
	
	  var amount = Number(dirtyAmount);
	  return (0, _index2.default)(dirtyDate, amount * 12, dirtyOptions);
	}
	module.exports = exports['default'];

/***/ }),
/* 2255 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  dateRangeWrapper: 'rdrDateRangeWrapper',
	  calendarWrapper: 'rdrCalendarWrapper',
	  dateDisplay: 'rdrDateDisplay',
	  dateDisplayItem: 'rdrDateDisplayItem',
	  dateDisplayItemActive: 'rdrDateDisplayItemActive',
	  monthAndYearWrapper: 'rdrMonthAndYearWrapper',
	  monthAndYearPickers: 'rdrMonthAndYearPickers',
	  nextPrevButton: 'rdrNextPrevButton',
	  month: 'rdrMonth',
	  weekDays: 'rdrWeekDays',
	  weekDay: 'rdrWeekDay',
	  days: 'rdrDays',
	  day: 'rdrDay',
	  dayNumber: 'rdrDayNumber',
	  dayPassive: 'rdrDayPassive',
	  dayToday: 'rdrDayToday',
	  dayStartOfWeek: 'rdrDayStartOfWeek',
	  dayEndOfWeek: 'rdrDayEndOfWeek',
	  daySelected: 'rdrDaySelected',
	  dayDisabled: 'rdrDayDisabled',
	  dayStartOfMonth: 'rdrDayStartOfMonth',
	  dayEndOfMonth: 'rdrDayEndOfMonth',
	  dayWeekend: 'rdrDayWeekend',
	  dayStartPreview: 'rdrDayStartPreview',
	  dayInPreview: 'rdrDayInPreview',
	  dayEndPreview: 'rdrDayEndPreview',
	  dayHovered: 'rdrDayHovered',
	  dayActive: 'rdrDayActive',
	  inRange: 'rdrInRange',
	  endEdge: 'rdrEndEdge',
	  startEdge: 'rdrStartEdge',
	  prevButton: 'rdrPprevButton',
	  nextButton: 'rdrNextButton',
	  selected: 'rdrSelected',
	  months: 'rdrMonths',
	  monthPicker: 'rdrMonthPicker',
	  yearPicker: 'rdrYearPicker',
	  dateDisplayWrapper: 'rdrDateDisplayWrapper',
	  definedRangesWrapper: 'rdrDefinedRangesWrapper',
	  staticRanges: 'rdrStaticRanges',
	  staticRange: 'rdrStaticRange',
	  inputRanges: 'rdrInputRanges',
	  inputRange: 'rdrInputRange',
	  inputRangeInput: 'rdrInputRangeInput',
	  dateRangePickerWrapper: 'rdrDateRangePickerWrapper',
	  staticRangeLabel: 'rdrStaticRangeLabel',
	  staticRangeSelected: 'rdrStaticRangeSelected',
	  monthName: 'rdrMonthName',
	  infiniteMonths: 'rdrInfiniteMonths',
	  monthsVertical: 'rdrMonthsVertical',
	  monthsHorizontal: 'rdrMonthsHorizontal'
	};

/***/ }),
/* 2256 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(956);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _DateRange = __webpack_require__(2199);
	
	var _DateRange2 = _interopRequireDefault(_DateRange);
	
	var _DefinedRange = __webpack_require__(2257);
	
	var _DefinedRange2 = _interopRequireDefault(_DefinedRange);
	
	var _utils = __webpack_require__(2237);
	
	var _classnames = __webpack_require__(958);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _styles = __webpack_require__(2255);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DateRangePicker = function (_Component) {
	  _inherits(DateRangePicker, _Component);
	
	  function DateRangePicker(props) {
	    _classCallCheck(this, DateRangePicker);
	
	    var _this = _possibleConstructorReturn(this, (DateRangePicker.__proto__ || Object.getPrototypeOf(DateRangePicker)).call(this, props));
	
	    _this.state = {
	      focusedRange: [(0, _utils.findNextRangeIndex)(props.ranges), 0]
	    };
	    _this.styles = (0, _utils.generateStyles)([_styles2.default, props.classNames]);
	    return _this;
	  }
	
	  _createClass(DateRangePicker, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var focusedRange = this.state.focusedRange;
	
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)(this.styles.dateRangePickerWrapper, this.props.className) },
	        _react2.default.createElement(_DefinedRange2.default, _extends({
	          focusedRange: focusedRange,
	          onPreviewChange: function onPreviewChange(value) {
	            return _this2.dateRange.updatePreview(value);
	          }
	        }, this.props, {
	          range: this.props.ranges[focusedRange[0]],
	          className: undefined
	        })),
	        _react2.default.createElement(_DateRange2.default, _extends({
	          onRangeFocusChange: function onRangeFocusChange(focusedRange) {
	            return _this2.setState({ focusedRange: focusedRange });
	          },
	          focusedRange: focusedRange
	        }, this.props, {
	          ref: function ref(t) {
	            return _this2.dateRange = t;
	          },
	          className: undefined
	        }))
	      );
	    }
	  }]);
	
	  return DateRangePicker;
	}(_react.Component);
	
	DateRangePicker.defaultProps = {};
	
	DateRangePicker.propTypes = _extends({}, _DateRange2.default.propTypes, _DefinedRange2.default.propTypes, {
	  className: _propTypes2.default.string
	});
	
	exports.default = DateRangePicker;

/***/ }),
/* 2257 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(956);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styles = __webpack_require__(2255);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	var _defaultRanges = __webpack_require__(2258);
	
	var _DayCell = __webpack_require__(2201);
	
	var _classnames = __webpack_require__(958);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DefinedRanges = function (_Component) {
	  _inherits(DefinedRanges, _Component);
	
	  function DefinedRanges(props) {
	    _classCallCheck(this, DefinedRanges);
	
	    var _this = _possibleConstructorReturn(this, (DefinedRanges.__proto__ || Object.getPrototypeOf(DefinedRanges)).call(this, props));
	
	    _this.state = {
	      rangeOffset: 0,
	      focusedInput: -1
	    };
	    _this.handleRangeChange = _this.handleRangeChange.bind(_this);
	    return _this;
	  }
	
	  _createClass(DefinedRanges, [{
	    key: 'handleRangeChange',
	    value: function handleRangeChange(range) {
	      var _props = this.props,
	          onChange = _props.onChange,
	          ranges = _props.ranges,
	          focusedRange = _props.focusedRange;
	
	      var selectedRange = ranges[focusedRange[0]];
	      if (!onChange || !selectedRange) return;
	      onChange(_defineProperty({}, selectedRange.key || 'range' + (focusedRange[0] + 1), _extends({}, selectedRange, range)));
	    }
	  }, {
	    key: 'getSelectedRange',
	    value: function getSelectedRange(ranges, staticRange) {
	      var focusedRangeIndex = ranges.findIndex(function (range) {
	        if (!range.startDate || !range.endDate || range.disabled) return false;
	        return staticRange.isSelected(range);
	      });
	      var selectedRange = ranges[focusedRangeIndex];
	      return { selectedRange: selectedRange, focusedRangeIndex: focusedRangeIndex };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props2 = this.props,
	          onPreviewChange = _props2.onPreviewChange,
	          ranges = _props2.ranges,
	          rangeColors = _props2.rangeColors,
	          className = _props2.className;
	
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)(_styles2.default.definedRangesWrapper, className) },
	        this.props.headerContent,
	        _react2.default.createElement(
	          'div',
	          { className: _styles2.default.staticRanges },
	          this.props.staticRanges.map(function (staticRange, i) {
	            var _getSelectedRange = _this2.getSelectedRange(ranges, staticRange),
	                selectedRange = _getSelectedRange.selectedRange,
	                focusedRangeIndex = _getSelectedRange.focusedRangeIndex;
	
	            return _react2.default.createElement(
	              'button',
	              {
	                type: 'button',
	                className: (0, _classnames2.default)(_styles2.default.staticRange, _defineProperty({}, _styles2.default.staticRangeSelected, Boolean(selectedRange))),
	                style: {
	                  color: selectedRange ? selectedRange.color || rangeColors[focusedRangeIndex] : null
	                },
	                key: i,
	                onClick: function onClick() {
	                  return _this2.handleRangeChange(staticRange.range(_this2.props));
	                },
	                onFocus: function onFocus() {
	                  return onPreviewChange && onPreviewChange(staticRange.range(_this2.props));
	                },
	                onMouseOver: function onMouseOver() {
	                  return onPreviewChange && onPreviewChange(staticRange.range(_this2.props));
	                },
	                onMouseLeave: function onMouseLeave() {
	                  _this2.props.onPreviewChange && _this2.props.onPreviewChange();
	                } },
	              _react2.default.createElement(
	                'span',
	                { tabIndex: -1, className: _styles2.default.staticRangeLabel },
	                staticRange.label
	              )
	            );
	          })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _styles2.default.inputRanges },
	          this.props.inputRanges.map(function (rangeOption, i) {
	            return _react2.default.createElement(
	              'div',
	              { className: _styles2.default.inputRange, key: i },
	              _react2.default.createElement('input', {
	                className: _styles2.default.inputRangeInput,
	                onFocus: function onFocus() {
	                  return _this2.setState({ focusedInput: i, rangeOffset: 0 });
	                },
	                onBlur: function onBlur() {
	                  return _this2.setState({ rangeOffset: 0 });
	                },
	                onChange: function onChange(e) {
	                  var value = parseInt(e.target.value, 10);
	                  value = isNaN(value) ? 0 : Math.max(Math.min(99999, value), 0);
	                  _this2.handleRangeChange(rangeOption.range(value, _this2.props));
	                },
	                min: 0,
	                max: 99999,
	                value: rangeOption.getCurrentValue ? rangeOption.getCurrentValue(ranges[_this2.props.focusedRange[0]] || {}) : '-'
	              }),
	              _react2.default.createElement(
	                'span',
	                { className: _styles2.default.inputRangeLabel },
	                rangeOption.label
	              )
	            );
	          })
	        ),
	        this.props.footerContent
	      );
	    }
	  }]);
	
	  return DefinedRanges;
	}(_react.Component);
	
	DefinedRanges.propTypes = {
	  inputRanges: _propTypes2.default.array,
	  staticRanges: _propTypes2.default.array,
	  ranges: _propTypes2.default.arrayOf(_DayCell.rangeShape),
	  focusedRange: _propTypes2.default.arrayOf(_propTypes2.default.number),
	  onPreviewChange: _propTypes2.default.func,
	  onChange: _propTypes2.default.func,
	  footerContent: _propTypes2.default.any,
	  headerContent: _propTypes2.default.any,
	  rangeColors: _propTypes2.default.arrayOf(_propTypes2.default.string),
	  className: _propTypes2.default.string
	};
	
	DefinedRanges.defaultProps = {
	  inputRanges: _defaultRanges.defaultInputRanges,
	  staticRanges: _defaultRanges.defaultStaticRanges,
	  ranges: [],
	  rangeColors: ['#3d91ff', '#3ecf8e', '#fed14c'],
	  focusedRange: [0, 0]
	};
	
	exports.default = DefinedRanges;

/***/ }),
/* 2258 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.defaultInputRanges = exports.defaultStaticRanges = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.createStaticRanges = createStaticRanges;
	
	var _differenceInCalendarDays = __webpack_require__(2247);
	
	var _differenceInCalendarDays2 = _interopRequireDefault(_differenceInCalendarDays);
	
	var _isSameDay = __webpack_require__(2206);
	
	var _isSameDay2 = _interopRequireDefault(_isSameDay);
	
	var _endOfWeek = __webpack_require__(2235);
	
	var _endOfWeek2 = _interopRequireDefault(_endOfWeek);
	
	var _startOfWeek = __webpack_require__(2236);
	
	var _startOfWeek2 = _interopRequireDefault(_startOfWeek);
	
	var _addMonths = __webpack_require__(2241);
	
	var _addMonths2 = _interopRequireDefault(_addMonths);
	
	var _endOfMonth = __webpack_require__(2238);
	
	var _endOfMonth2 = _interopRequireDefault(_endOfMonth);
	
	var _startOfMonth = __webpack_require__(2239);
	
	var _startOfMonth2 = _interopRequireDefault(_startOfMonth);
	
	var _startOfDay = __webpack_require__(2207);
	
	var _startOfDay2 = _interopRequireDefault(_startOfDay);
	
	var _endOfDay = __webpack_require__(2202);
	
	var _endOfDay2 = _interopRequireDefault(_endOfDay);
	
	var _addDays = __webpack_require__(2250);
	
	var _addDays2 = _interopRequireDefault(_addDays);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var defineds = {
	  startOfWeek: (0, _startOfWeek2.default)(new Date()),
	  endOfWeek: (0, _endOfWeek2.default)(new Date()),
	  startOfLastWeek: (0, _startOfWeek2.default)((0, _addDays2.default)(new Date(), -7)),
	  endOfLastWeek: (0, _endOfWeek2.default)((0, _addDays2.default)(new Date(), -7)),
	  startOfToday: (0, _startOfDay2.default)(new Date()),
	  endOfToday: (0, _endOfDay2.default)(new Date()),
	  startOfYesterday: (0, _startOfDay2.default)((0, _addDays2.default)(new Date(), -1)),
	  endOfYesterday: (0, _endOfDay2.default)((0, _addDays2.default)(new Date(), -1)),
	  startOfMonth: (0, _startOfMonth2.default)(new Date()),
	  endOfMonth: (0, _endOfMonth2.default)(new Date()),
	  startOfLastMonth: (0, _startOfMonth2.default)((0, _addMonths2.default)(new Date(), -1)),
	  endOfLastMonth: (0, _endOfMonth2.default)((0, _addMonths2.default)(new Date(), -1))
	};
	
	var staticRangeHandler = {
	  range: {},
	  isSelected: function isSelected(range) {
	    var definedRange = this.range();
	    return (0, _isSameDay2.default)(range.startDate, definedRange.startDate) && (0, _isSameDay2.default)(range.endDate, definedRange.endDate);
	  }
	};
	
	function createStaticRanges(ranges) {
	  return ranges.map(function (range) {
	    return _extends({}, staticRangeHandler, range);
	  });
	}
	
	var defaultStaticRanges = exports.defaultStaticRanges = createStaticRanges([{
	  label: 'Today',
	  range: function range() {
	    return {
	      startDate: defineds.startOfToday,
	      endDate: defineds.endOfToday
	    };
	  }
	}, {
	  label: 'Yesterday',
	  range: function range() {
	    return {
	      startDate: defineds.startOfYesterday,
	      endDate: defineds.endOfYesterday
	    };
	  }
	}, {
	  label: 'This Week',
	  range: function range() {
	    return {
	      startDate: defineds.startOfWeek,
	      endDate: defineds.endOfWeek
	    };
	  }
	}, {
	  label: 'Last Week',
	  range: function range() {
	    return {
	      startDate: defineds.startOfLastWeek,
	      endDate: defineds.endOfLastWeek
	    };
	  }
	}, {
	  label: 'This Month',
	  range: function range() {
	    return {
	      startDate: defineds.startOfMonth,
	      endDate: defineds.endOfMonth
	    };
	  }
	}, {
	  label: 'Last Month',
	  range: function range() {
	    return {
	      startDate: defineds.startOfLastMonth,
	      endDate: defineds.endOfLastMonth
	    };
	  }
	}]);
	
	var defaultInputRanges = exports.defaultInputRanges = [{
	  label: 'days up to today',
	  range: function range(value) {
	    return {
	      startDate: (0, _addDays2.default)(defineds.startOfToday, (Math.max(Number(value), 1) - 1) * -1),
	      endDate: defineds.endOfToday
	    };
	  },
	  getCurrentValue: function getCurrentValue(range) {
	    if (!(0, _isSameDay2.default)(range.endDate, defineds.endOfToday)) return '-';
	    if (!range.startDate) return '∞';
	    return (0, _differenceInCalendarDays2.default)(defineds.endOfToday, range.startDate) + 1;
	  }
	}, {
	  label: 'days starting today',
	  range: function range(value) {
	    var today = new Date();
	    return {
	      startDate: today,
	      endDate: (0, _addDays2.default)(today, Math.max(Number(value), 1) - 1)
	    };
	  },
	  getCurrentValue: function getCurrentValue(range) {
	    if (!(0, _isSameDay2.default)(range.startDate, defineds.startOfToday)) return '-';
	    if (!range.endDate) return '∞';
	    return (0, _differenceInCalendarDays2.default)(range.endDate, defineds.startOfToday) + 1;
	  }
	}];

/***/ }),
/* 2259 */
/***/ (function(module, exports, __webpack_require__) {

	(function webpackUniversalModuleDefinition(root, factory) {
		if(true)
			module.exports = factory(__webpack_require__(2260));
		else if(typeof define === 'function' && define.amd)
			define(["luxon"], factory);
		else if(typeof exports === 'object')
			exports["rrule"] = factory(require("luxon"));
		else
			root["rrule"] = factory(root["luxon"]);
	})(typeof self !== 'undefined' ? self : this, function(__WEBPACK_EXTERNAL_MODULE__2__) {
	return /******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	/******/
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	/******/
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId]) {
	/******/ 			return installedModules[moduleId].exports;
	/******/ 		}
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			i: moduleId,
	/******/ 			l: false,
	/******/ 			exports: {}
	/******/ 		};
	/******/
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	/******/
	/******/ 		// Flag the module as loaded
	/******/ 		module.l = true;
	/******/
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	/******/
	/******/
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	/******/
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	/******/
	/******/ 	// define getter function for harmony exports
	/******/ 	__webpack_require__.d = function(exports, name, getter) {
	/******/ 		if(!__webpack_require__.o(exports, name)) {
	/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
	/******/ 		}
	/******/ 	};
	/******/
	/******/ 	// define __esModule on exports
	/******/ 	__webpack_require__.r = function(exports) {
	/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
	/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
	/******/ 		}
	/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
	/******/ 	};
	/******/
	/******/ 	// create a fake namespace object
	/******/ 	// mode & 1: value is a module id, require it
	/******/ 	// mode & 2: merge all properties of value into the ns
	/******/ 	// mode & 4: return value when already ns object
	/******/ 	// mode & 8|1: behave like require
	/******/ 	__webpack_require__.t = function(value, mode) {
	/******/ 		if(mode & 1) value = __webpack_require__(value);
	/******/ 		if(mode & 8) return value;
	/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
	/******/ 		var ns = Object.create(null);
	/******/ 		__webpack_require__.r(ns);
	/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
	/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
	/******/ 		return ns;
	/******/ 	};
	/******/
	/******/ 	// getDefaultExport function for compatibility with non-harmony modules
	/******/ 	__webpack_require__.n = function(module) {
	/******/ 		var getter = module && module.__esModule ?
	/******/ 			function getDefault() { return module['default']; } :
	/******/ 			function getModuleExports() { return module; };
	/******/ 		__webpack_require__.d(getter, 'a', getter);
	/******/ 		return getter;
	/******/ 	};
	/******/
	/******/ 	// Object.prototype.hasOwnProperty.call
	/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
	/******/
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	/******/
	/******/
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(__webpack_require__.s = 1);
	/******/ })
	/************************************************************************/
	/******/ ([
	/* 0 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return isPresent; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return isNumber; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return isArray; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return range; });
	/* unused harmony export clone */
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return repeat; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return toArray; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return padStart; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return split; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return pymod; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return divmod; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return empty; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return notEmpty; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return includes; });
	// =============================================================================
	// Helper functions
	// =============================================================================
	var isPresent = function (value) {
	    return value !== null && value !== undefined;
	};
	var isNumber = function (value) {
	    return typeof value === 'number';
	};
	var isArray = Array.isArray;
	/**
	 * Simplified version of python's range()
	 */
	var range = function (start, end) {
	    if (end === void 0) { end = start; }
	    if (arguments.length === 1) {
	        end = start;
	        start = 0;
	    }
	    var rang = [];
	    for (var i = start; i < end; i++)
	        rang.push(i);
	    return rang;
	};
	var clone = function (array) {
	    return [].concat(array);
	};
	var repeat = function (value, times) {
	    var i = 0;
	    var array = [];
	    if (isArray(value)) {
	        for (; i < times; i++)
	            array[i] = [].concat(value);
	    }
	    else {
	        for (; i < times; i++)
	            array[i] = value;
	    }
	    return array;
	};
	var toArray = function (item) {
	    if (isArray(item)) {
	        return item;
	    }
	    return [item];
	};
	function padStart(item, targetLength, padString) {
	    if (padString === void 0) { padString = ' '; }
	    var str = String(item);
	    targetLength = targetLength >> 0;
	    if (str.length > targetLength) {
	        return String(str);
	    }
	    targetLength = targetLength - str.length;
	    if (targetLength > padString.length) {
	        padString += repeat(padString, targetLength / padString.length);
	    }
	    return padString.slice(0, targetLength) + String(str);
	}
	/**
	 * Python like split
	 */
	var split = function (str, sep, num) {
	    var splits = str.split(sep);
	    return num
	        ? splits.slice(0, num).concat([splits.slice(num).join(sep)])
	        : splits;
	};
	/**
	 * closure/goog/math/math.js:modulo
	 * Copyright 2006 The Closure Library Authors.
	 * The % operator in JavaScript returns the remainder of a / b, but differs from
	 * some other languages in that the result will have the same sign as the
	 * dividend. For example, -1 % 8 == -1, whereas in some other languages
	 * (such as Python) the result would be 7. This function emulates the more
	 * correct modulo behavior, which is useful for certain applications such as
	 * calculating an offset index in a circular list.
	 *
	 * @param {number} a The dividend.
	 * @param {number} b The divisor.
	 * @return {number} a % b where the result is between 0 and b (either 0 <= x < b
	 *     or b < x <= 0, depending on the sign of b).
	 */
	var pymod = function (a, b) {
	    var r = a % b;
	    // If r and b differ in sign, add b to wrap the result to the correct sign.
	    return r * b < 0 ? r + b : r;
	};
	/**
	 * @see: <http://docs.python.org/library/functions.html#divmod>
	 */
	var divmod = function (a, b) {
	    return { div: Math.floor(a / b), mod: pymod(a, b) };
	};
	var empty = function (obj) {
	    return !isPresent(obj) || obj.length === 0;
	};
	/**
	 * Python-like boolean
	 * @return {Boolean} value of an object/primitive, taking into account
	 * the fact that in Python an empty list's/tuple's
	 * boolean value is False, whereas in JS it's true
	 */
	var notEmpty = function (obj) {
	    return !empty(obj);
	};
	/**
	 * Return true if a value is in an array
	 */
	var includes = function (arr, val) {
	    return notEmpty(arr) && arr.indexOf(val) !== -1;
	};
	
	
	/***/ }),
	/* 1 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	
	// EXTERNAL MODULE: ./src/helpers.ts
	var helpers = __webpack_require__(0);
	
	// CONCATENATED MODULE: ./src/dateutil.ts
	
	/**
	 * General date-related utilities.
	 * Also handles several incompatibilities between JavaScript and Python
	 *
	 */
	var dateutil_dateutil;
	(function (dateutil) {
	    dateutil.MONTH_DAYS = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
	    /**
	     * Number of milliseconds of one day
	     */
	    dateutil.ONE_DAY = 1000 * 60 * 60 * 24;
	    /**
	     * @see: <http://docs.python.org/library/datetime.html#datetime.MAXYEAR>
	     */
	    dateutil.MAXYEAR = 9999;
	    /**
	     * Python uses 1-Jan-1 as the base for calculating ordinals but we don't
	     * want to confuse the JS engine with milliseconds > Number.MAX_NUMBER,
	     * therefore we use 1-Jan-1970 instead
	     */
	    dateutil.ORDINAL_BASE = new Date(Date.UTC(1970, 0, 1));
	    /**
	     * Python: MO-SU: 0 - 6
	     * JS: SU-SAT 0 - 6
	     */
	    dateutil.PY_WEEKDAYS = [6, 0, 1, 2, 3, 4, 5];
	    /**
	     * py_date.timetuple()[7]
	     */
	    dateutil.getYearDay = function (date) {
	        var dateNoTime = new Date(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate());
	        return (Math.ceil((dateNoTime.valueOf() -
	            new Date(date.getUTCFullYear(), 0, 1).valueOf()) /
	            dateutil.ONE_DAY) + 1);
	    };
	    dateutil.isLeapYear = function (year) {
	        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
	    };
	    dateutil.isDate = function (value) {
	        return value instanceof Date;
	    };
	    dateutil.isValidDate = function (value) {
	        return dateutil.isDate(value) && !isNaN(value.getTime());
	    };
	    /**
	     * @return {Number} the date's timezone offset in ms
	     */
	    dateutil.tzOffset = function (date) {
	        return date.getTimezoneOffset() * 60 * 1000;
	    };
	    /**
	     * @see: <http://www.mcfedries.com/JavaScript/DaysBetween.asp>
	     */
	    dateutil.daysBetween = function (date1, date2) {
	        // The number of milliseconds in one day
	        // Convert both dates to milliseconds
	        var date1ms = date1.getTime() - dateutil.tzOffset(date1);
	        var date2ms = date2.getTime() - dateutil.tzOffset(date2);
	        // Calculate the difference in milliseconds
	        var differencems = date1ms - date2ms;
	        // Convert back to days and return
	        return Math.round(differencems / dateutil.ONE_DAY);
	    };
	    /**
	     * @see: <http://docs.python.org/library/datetime.html#datetime.date.toordinal>
	     */
	    dateutil.toOrdinal = function (date) {
	        return dateutil.daysBetween(date, dateutil.ORDINAL_BASE);
	    };
	    /**
	     * @see - <http://docs.python.org/library/datetime.html#datetime.date.fromordinal>
	     */
	    dateutil.fromOrdinal = function (ordinal) {
	        return new Date(dateutil.ORDINAL_BASE.getTime() + ordinal * dateutil.ONE_DAY);
	    };
	    dateutil.getMonthDays = function (date) {
	        var month = date.getUTCMonth();
	        return month === 1 && dateutil.isLeapYear(date.getUTCFullYear())
	            ? 29
	            : dateutil.MONTH_DAYS[month];
	    };
	    /**
	     * @return {Number} python-like weekday
	     */
	    dateutil.getWeekday = function (date) {
	        return dateutil.PY_WEEKDAYS[date.getUTCDay()];
	    };
	    /**
	     * @see: <http://docs.python.org/library/calendar.html#calendar.monthrange>
	     */
	    dateutil.monthRange = function (year, month) {
	        var date = new Date(Date.UTC(year, month, 1));
	        return [dateutil.getWeekday(date), dateutil.getMonthDays(date)];
	    };
	    /**
	     * @see: <http://docs.python.org/library/datetime.html#datetime.datetime.combine>
	     */
	    dateutil.combine = function (date, time) {
	        time = time || date;
	        return new Date(Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(), time.getHours(), time.getMinutes(), time.getSeconds(), time.getMilliseconds()));
	    };
	    dateutil.clone = function (date) {
	        var dolly = new Date(date.getTime());
	        return dolly;
	    };
	    dateutil.cloneDates = function (dates) {
	        var clones = [];
	        for (var i = 0; i < dates.length; i++) {
	            clones.push(dateutil.clone(dates[i]));
	        }
	        return clones;
	    };
	    /**
	     * Sorts an array of Date or dateutil.Time objects
	     */
	    dateutil.sort = function (dates) {
	        dates.sort(function (a, b) {
	            return a.getTime() - b.getTime();
	        });
	    };
	    dateutil.timeToUntilString = function (time, utc) {
	        if (utc === void 0) { utc = true; }
	        var date = new Date(time);
	        return [
	            Object(helpers["h" /* padStart */])(date.getUTCFullYear().toString(), 4, '0'),
	            Object(helpers["h" /* padStart */])(date.getUTCMonth() + 1, 2, '0'),
	            Object(helpers["h" /* padStart */])(date.getUTCDate(), 2, '0'),
	            'T',
	            Object(helpers["h" /* padStart */])(date.getUTCHours(), 2, '0'),
	            Object(helpers["h" /* padStart */])(date.getUTCMinutes(), 2, '0'),
	            Object(helpers["h" /* padStart */])(date.getUTCSeconds(), 2, '0'),
	            utc ? 'Z' : ''
	        ].join('');
	    };
	    dateutil.untilStringToDate = function (until) {
	        var re = /^(\d{4})(\d{2})(\d{2})(T(\d{2})(\d{2})(\d{2})Z?)?$/;
	        var bits = re.exec(until);
	        if (!bits)
	            throw new Error("Invalid UNTIL value: " + until);
	        return new Date(Date.UTC(parseInt(bits[1], 10), parseInt(bits[2], 10) - 1, parseInt(bits[3], 10), parseInt(bits[5], 10) || 0, parseInt(bits[6], 10) || 0, parseInt(bits[7], 10) || 0));
	    };
	})(dateutil_dateutil || (dateutil_dateutil = {}));
	/* harmony default export */ var src_dateutil = (dateutil_dateutil);
	
	// CONCATENATED MODULE: ./src/iterresult.ts
	/**
	 * This class helps us to emulate python's generators, sorta.
	 */
	var IterResult = /** @class */ (function () {
	    function IterResult(method, args) {
	        this.minDate = null;
	        this.maxDate = null;
	        this._result = [];
	        this.total = 0;
	        this.method = method;
	        this.args = args;
	        if (method === 'between') {
	            this.maxDate = args.inc
	                ? args.before
	                : new Date(args.before.getTime() - 1);
	            this.minDate = args.inc ? args.after : new Date(args.after.getTime() + 1);
	        }
	        else if (method === 'before') {
	            this.maxDate = args.inc ? args.dt : new Date(args.dt.getTime() - 1);
	        }
	        else if (method === 'after') {
	            this.minDate = args.inc ? args.dt : new Date(args.dt.getTime() + 1);
	        }
	    }
	    /**
	     * Possibly adds a date into the result.
	     *
	     * @param {Date} date - the date isn't necessarly added to the result
	     *                      list (if it is too late/too early)
	     * @return {Boolean} true if it makes sense to continue the iteration
	     *                   false if we're done.
	     */
	    IterResult.prototype.accept = function (date) {
	        ++this.total;
	        var tooEarly = this.minDate && date < this.minDate;
	        var tooLate = this.maxDate && date > this.maxDate;
	        if (this.method === 'between') {
	            if (tooEarly)
	                return true;
	            if (tooLate)
	                return false;
	        }
	        else if (this.method === 'before') {
	            if (tooLate)
	                return false;
	        }
	        else if (this.method === 'after') {
	            if (tooEarly)
	                return true;
	            this.add(date);
	            return false;
	        }
	        return this.add(date);
	    };
	    /**
	     *
	     * @param {Date} date that is part of the result.
	     * @return {Boolean} whether we are interested in more values.
	     */
	    IterResult.prototype.add = function (date) {
	        this._result.push(date);
	        return true;
	    };
	    /**
	     * 'before' and 'after' return only one date, whereas 'all'
	     * and 'between' an array.
	     * @return {Date,Array?}
	     */
	    IterResult.prototype.getValue = function () {
	        var res = this._result;
	        switch (this.method) {
	            case 'all':
	            case 'between':
	                return res;
	            case 'before':
	            case 'after':
	            default:
	                return (res.length ? res[res.length - 1] : null);
	        }
	    };
	    IterResult.prototype.clone = function () {
	        return new IterResult(this.method, this.args);
	    };
	    return IterResult;
	}());
	/* harmony default export */ var iterresult = (IterResult);
	
	// CONCATENATED MODULE: ./src/callbackiterresult.ts
	var __extends = (undefined && undefined.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    }
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	
	/**
	 * IterResult subclass that calls a callback function on each add,
	 * and stops iterating when the callback returns false.
	 */
	var CallbackIterResult = /** @class */ (function (_super) {
	    __extends(CallbackIterResult, _super);
	    function CallbackIterResult(method, args, iterator) {
	        var _this = _super.call(this, method, args) || this;
	        _this.iterator = iterator;
	        return _this;
	    }
	    CallbackIterResult.prototype.add = function (date) {
	        if (this.iterator(date, this._result.length)) {
	            this._result.push(date);
	            return true;
	        }
	        return false;
	    };
	    return CallbackIterResult;
	}(iterresult));
	/* harmony default export */ var callbackiterresult = (CallbackIterResult);
	
	// CONCATENATED MODULE: ./src/types.ts
	var Frequency;
	(function (Frequency) {
	    Frequency[Frequency["YEARLY"] = 0] = "YEARLY";
	    Frequency[Frequency["MONTHLY"] = 1] = "MONTHLY";
	    Frequency[Frequency["WEEKLY"] = 2] = "WEEKLY";
	    Frequency[Frequency["DAILY"] = 3] = "DAILY";
	    Frequency[Frequency["HOURLY"] = 4] = "HOURLY";
	    Frequency[Frequency["MINUTELY"] = 5] = "MINUTELY";
	    Frequency[Frequency["SECONDLY"] = 6] = "SECONDLY";
	})(Frequency || (Frequency = {}));
	function freqIsDailyOrGreater(freq) {
	    return freq < Frequency.HOURLY;
	}
	
	// CONCATENATED MODULE: ./src/weekday.ts
	// =============================================================================
	// Weekday
	// =============================================================================
	var WDAYS = ['MO', 'TU', 'WE', 'TH', 'FR', 'SA', 'SU'];
	var Weekday = /** @class */ (function () {
	    function Weekday(weekday, n) {
	        if (n === 0)
	            throw new Error("Can't create weekday with n == 0");
	        this.weekday = weekday;
	        this.n = n;
	    }
	    // __call__ - Cannot call the object directly, do it through
	    // e.g. RRule.TH.nth(-1) instead,
	    Weekday.prototype.nth = function (n) {
	        return this.n === n ? this : new Weekday(this.weekday, n);
	    };
	    // __eq__
	    Weekday.prototype.equals = function (other) {
	        return this.weekday === other.weekday && this.n === other.n;
	    };
	    // __repr__
	    Weekday.prototype.toString = function () {
	        var s = WDAYS[this.weekday];
	        if (this.n)
	            s = (this.n > 0 ? '+' : '') + String(this.n) + s;
	        return s;
	    };
	    Weekday.prototype.getJsWeekday = function () {
	        return this.weekday === 6 ? 0 : this.weekday + 1;
	    };
	    return Weekday;
	}());
	
	
	// CONCATENATED MODULE: ./src/datetime.ts
	var datetime_extends = (undefined && undefined.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    }
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	
	
	
	var Time = /** @class */ (function () {
	    function Time(hour, minute, second, millisecond) {
	        this.hour = hour;
	        this.minute = minute;
	        this.second = second;
	        this.millisecond = millisecond || 0;
	    }
	    Time.prototype.getHours = function () {
	        return this.hour;
	    };
	    Time.prototype.getMinutes = function () {
	        return this.minute;
	    };
	    Time.prototype.getSeconds = function () {
	        return this.second;
	    };
	    Time.prototype.getMilliseconds = function () {
	        return this.millisecond;
	    };
	    Time.prototype.getTime = function () {
	        return ((this.hour * 60 * 60 + this.minute * 60 + this.second) * 1000 +
	            this.millisecond);
	    };
	    return Time;
	}());
	
	var datetime_DateTime = /** @class */ (function (_super) {
	    datetime_extends(DateTime, _super);
	    function DateTime(year, month, day, hour, minute, second, millisecond) {
	        var _this = _super.call(this, hour, minute, second, millisecond) || this;
	        _this.year = year;
	        _this.month = month;
	        _this.day = day;
	        return _this;
	    }
	    DateTime.fromDate = function (date) {
	        return new this(date.getUTCFullYear(), date.getUTCMonth() + 1, date.getUTCDate(), date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds(), date.valueOf() % 1000);
	    };
	    DateTime.prototype.getWeekday = function () {
	        return dateutil_dateutil.getWeekday(new Date(this.getTime()));
	    };
	    DateTime.prototype.getTime = function () {
	        return new Date(Date.UTC(this.year, this.month - 1, this.day, this.hour, this.minute, this.second, this.millisecond)).getTime();
	    };
	    DateTime.prototype.getDay = function () {
	        return this.day;
	    };
	    DateTime.prototype.getMonth = function () {
	        return this.month;
	    };
	    DateTime.prototype.getYear = function () {
	        return this.year;
	    };
	    DateTime.prototype.addYears = function (years) {
	        this.year += years;
	    };
	    DateTime.prototype.addMonths = function (months) {
	        this.month += months;
	        if (this.month > 12) {
	            var yearDiv = Math.floor(this.month / 12);
	            var monthMod = Object(helpers["i" /* pymod */])(this.month, 12);
	            this.month = monthMod;
	            this.year += yearDiv;
	            if (this.month === 0) {
	                this.month = 12;
	                --this.year;
	            }
	        }
	    };
	    DateTime.prototype.addWeekly = function (days, wkst) {
	        if (wkst > this.getWeekday()) {
	            this.day += -(this.getWeekday() + 1 + (6 - wkst)) + days * 7;
	        }
	        else {
	            this.day += -(this.getWeekday() - wkst) + days * 7;
	        }
	        this.fixDay();
	    };
	    DateTime.prototype.addDaily = function (days) {
	        this.day += days;
	        this.fixDay();
	    };
	    DateTime.prototype.addHours = function (hours, filtered, byhour) {
	        if (filtered) {
	            // Jump to one iteration before next day
	            this.hour += Math.floor((23 - this.hour) / hours) * hours;
	        }
	        while (true) {
	            this.hour += hours;
	            var _a = Object(helpers["a" /* divmod */])(this.hour, 24), dayDiv = _a.div, hourMod = _a.mod;
	            if (dayDiv) {
	                this.hour = hourMod;
	                this.addDaily(dayDiv);
	            }
	            if (Object(helpers["b" /* empty */])(byhour) || Object(helpers["c" /* includes */])(byhour, this.hour))
	                break;
	        }
	    };
	    DateTime.prototype.addMinutes = function (minutes, filtered, byhour, byminute) {
	        if (filtered) {
	            // Jump to one iteration before next day
	            this.minute +=
	                Math.floor((1439 - (this.hour * 60 + this.minute)) / minutes) * minutes;
	        }
	        while (true) {
	            this.minute += minutes;
	            var _a = Object(helpers["a" /* divmod */])(this.minute, 60), hourDiv = _a.div, minuteMod = _a.mod;
	            if (hourDiv) {
	                this.minute = minuteMod;
	                this.addHours(hourDiv, false, byhour);
	            }
	            if ((Object(helpers["b" /* empty */])(byhour) || Object(helpers["c" /* includes */])(byhour, this.hour)) &&
	                (Object(helpers["b" /* empty */])(byminute) || Object(helpers["c" /* includes */])(byminute, this.minute))) {
	                break;
	            }
	        }
	    };
	    DateTime.prototype.addSeconds = function (seconds, filtered, byhour, byminute, bysecond) {
	        if (filtered) {
	            // Jump to one iteration before next day
	            this.second +=
	                Math.floor((86399 - (this.hour * 3600 + this.minute * 60 + this.second)) / seconds) * seconds;
	        }
	        while (true) {
	            this.second += seconds;
	            var _a = Object(helpers["a" /* divmod */])(this.second, 60), minuteDiv = _a.div, secondMod = _a.mod;
	            if (minuteDiv) {
	                this.second = secondMod;
	                this.addMinutes(minuteDiv, false, byhour, byminute);
	            }
	            if ((Object(helpers["b" /* empty */])(byhour) || Object(helpers["c" /* includes */])(byhour, this.hour)) &&
	                (Object(helpers["b" /* empty */])(byminute) || Object(helpers["c" /* includes */])(byminute, this.minute)) &&
	                (Object(helpers["b" /* empty */])(bysecond) || Object(helpers["c" /* includes */])(bysecond, this.second))) {
	                break;
	            }
	        }
	    };
	    DateTime.prototype.fixDay = function () {
	        if (this.day <= 28) {
	            return;
	        }
	        var daysinmonth = dateutil_dateutil.monthRange(this.year, this.month - 1)[1];
	        if (this.day <= daysinmonth) {
	            return;
	        }
	        while (this.day > daysinmonth) {
	            this.day -= daysinmonth;
	            ++this.month;
	            if (this.month === 13) {
	                this.month = 1;
	                ++this.year;
	                if (this.year > dateutil_dateutil.MAXYEAR) {
	                    return;
	                }
	            }
	            daysinmonth = dateutil_dateutil.monthRange(this.year, this.month - 1)[1];
	        }
	    };
	    DateTime.prototype.add = function (options, filtered) {
	        var freq = options.freq, interval = options.interval, wkst = options.wkst, byhour = options.byhour, byminute = options.byminute, bysecond = options.bysecond;
	        switch (freq) {
	            case Frequency.YEARLY: return this.addYears(interval);
	            case Frequency.MONTHLY: return this.addMonths(interval);
	            case Frequency.WEEKLY: return this.addWeekly(interval, wkst);
	            case Frequency.DAILY: return this.addDaily(interval);
	            case Frequency.HOURLY: return this.addHours(interval, filtered, byhour);
	            case Frequency.MINUTELY: return this.addMinutes(interval, filtered, byhour, byminute);
	            case Frequency.SECONDLY: return this.addSeconds(interval, filtered, byhour, byminute, bysecond);
	        }
	    };
	    return DateTime;
	}(Time));
	
	
	// CONCATENATED MODULE: ./src/parseoptions.ts
	
	
	
	
	
	
	function initializeOptions(options) {
	    var invalid = [];
	    var keys = Object.keys(options);
	    var initializedOptions = {};
	    // Shallow copy for options and origOptions and check for invalid
	    keys.forEach(function (key) {
	        var value = options[key];
	        initializedOptions[key] = value;
	        if (!Object(helpers["c" /* includes */])(rrule_defaultKeys, key))
	            invalid.push(key);
	        if (src_dateutil.isDate(value) && !src_dateutil.isValidDate(value))
	            invalid.push(key);
	    });
	    if (invalid.length) {
	        throw new Error('Invalid options: ' + invalid.join(', '));
	    }
	    return initializedOptions;
	}
	function parseOptions(options) {
	    var opts = initializeOptions(options);
	    var keys = Object.keys(options);
	    // Merge in default options
	    rrule_defaultKeys.forEach(function (key) {
	        if (!Object(helpers["c" /* includes */])(keys, key) || !Object(helpers["f" /* isPresent */])(opts[key]))
	            opts[key] = DEFAULT_OPTIONS[key];
	    });
	    if (Object(helpers["f" /* isPresent */])(opts.byeaster))
	        opts.freq = src_rrule.YEARLY;
	    if (!(Object(helpers["f" /* isPresent */])(opts.freq) && src_rrule.FREQUENCIES[opts.freq])) {
	        throw new Error("Invalid frequency: " + opts.freq + " " + options.freq);
	    }
	    if (!opts.dtstart)
	        opts.dtstart = new Date(new Date().setMilliseconds(0));
	    if (!Object(helpers["f" /* isPresent */])(opts.wkst)) {
	        opts.wkst = src_rrule.MO.weekday;
	    }
	    else if (Object(helpers["e" /* isNumber */])(opts.wkst)) {
	        // cool, just keep it like that
	    }
	    else {
	        opts.wkst = opts.wkst.weekday;
	    }
	    if (Object(helpers["f" /* isPresent */])(opts.bysetpos)) {
	        if (Object(helpers["e" /* isNumber */])(opts.bysetpos))
	            opts.bysetpos = [opts.bysetpos];
	        for (var i = 0; i < opts.bysetpos.length; i++) {
	            var v = opts.bysetpos[i];
	            if (v === 0 || !(v >= -366 && v <= 366)) {
	                throw new Error('bysetpos must be between 1 and 366,' + ' or between -366 and -1');
	            }
	        }
	    }
	    if (!(Boolean(opts.byweekno) ||
	        Object(helpers["g" /* notEmpty */])(opts.byweekno) ||
	        Object(helpers["g" /* notEmpty */])(opts.byyearday) ||
	        Boolean(opts.bymonthday) ||
	        Object(helpers["g" /* notEmpty */])(opts.bymonthday) ||
	        Object(helpers["f" /* isPresent */])(opts.byweekday) ||
	        Object(helpers["f" /* isPresent */])(opts.byeaster))) {
	        switch (opts.freq) {
	            case src_rrule.YEARLY:
	                if (!opts.bymonth)
	                    opts.bymonth = opts.dtstart.getUTCMonth() + 1;
	                opts.bymonthday = opts.dtstart.getUTCDate();
	                break;
	            case src_rrule.MONTHLY:
	                opts.bymonthday = opts.dtstart.getUTCDate();
	                break;
	            case src_rrule.WEEKLY:
	                opts.byweekday = [src_dateutil.getWeekday(opts.dtstart)];
	                break;
	        }
	    }
	    // bymonth
	    if (Object(helpers["f" /* isPresent */])(opts.bymonth) && !Object(helpers["d" /* isArray */])(opts.bymonth)) {
	        opts.bymonth = [opts.bymonth];
	    }
	    // byyearday
	    if (Object(helpers["f" /* isPresent */])(opts.byyearday) &&
	        !Object(helpers["d" /* isArray */])(opts.byyearday) &&
	        Object(helpers["e" /* isNumber */])(opts.byyearday)) {
	        opts.byyearday = [opts.byyearday];
	    }
	    // bymonthday
	    if (!Object(helpers["f" /* isPresent */])(opts.bymonthday)) {
	        opts.bymonthday = [];
	        opts.bynmonthday = [];
	    }
	    else if (Object(helpers["d" /* isArray */])(opts.bymonthday)) {
	        var bymonthday = [];
	        var bynmonthday = [];
	        for (var i = 0; i < opts.bymonthday.length; i++) {
	            var v = opts.bymonthday[i];
	            if (v > 0) {
	                bymonthday.push(v);
	            }
	            else if (v < 0) {
	                bynmonthday.push(v);
	            }
	        }
	        opts.bymonthday = bymonthday;
	        opts.bynmonthday = bynmonthday;
	    }
	    else if (opts.bymonthday < 0) {
	        opts.bynmonthday = [opts.bymonthday];
	        opts.bymonthday = [];
	    }
	    else {
	        opts.bynmonthday = [];
	        opts.bymonthday = [opts.bymonthday];
	    }
	    // byweekno
	    if (Object(helpers["f" /* isPresent */])(opts.byweekno) && !Object(helpers["d" /* isArray */])(opts.byweekno)) {
	        opts.byweekno = [opts.byweekno];
	    }
	    // byweekday / bynweekday
	    if (!Object(helpers["f" /* isPresent */])(opts.byweekday)) {
	        opts.bynweekday = null;
	    }
	    else if (Object(helpers["e" /* isNumber */])(opts.byweekday)) {
	        opts.byweekday = [opts.byweekday];
	        opts.bynweekday = null;
	    }
	    else if (opts.byweekday instanceof Weekday) {
	        if (!opts.byweekday.n || opts.freq > src_rrule.MONTHLY) {
	            opts.byweekday = [opts.byweekday.weekday];
	            opts.bynweekday = null;
	        }
	        else {
	            opts.bynweekday = [[opts.byweekday.weekday, opts.byweekday.n]];
	            opts.byweekday = null;
	        }
	    }
	    else {
	        var byweekday = [];
	        var bynweekday = [];
	        for (var i = 0; i < opts.byweekday.length; i++) {
	            var wday = opts.byweekday[i];
	            if (Object(helpers["e" /* isNumber */])(wday)) {
	                byweekday.push(wday);
	                continue;
	            }
	            var wd = wday;
	            if (!wd.n || opts.freq > src_rrule.MONTHLY) {
	                byweekday.push(wd.weekday);
	            }
	            else {
	                bynweekday.push([wd.weekday, wd.n]);
	            }
	        }
	        opts.byweekday = Object(helpers["g" /* notEmpty */])(byweekday) ? byweekday : null;
	        opts.bynweekday = Object(helpers["g" /* notEmpty */])(bynweekday) ? bynweekday : null;
	    }
	    // byhour
	    if (!Object(helpers["f" /* isPresent */])(opts.byhour)) {
	        opts.byhour =
	            opts.freq < src_rrule.HOURLY ? [opts.dtstart.getUTCHours()] : null;
	    }
	    else if (Object(helpers["e" /* isNumber */])(opts.byhour)) {
	        opts.byhour = [opts.byhour];
	    }
	    // byminute
	    if (!Object(helpers["f" /* isPresent */])(opts.byminute)) {
	        opts.byminute =
	            opts.freq < src_rrule.MINUTELY ? [opts.dtstart.getUTCMinutes()] : null;
	    }
	    else if (Object(helpers["e" /* isNumber */])(opts.byminute)) {
	        opts.byminute = [opts.byminute];
	    }
	    // bysecond
	    if (!Object(helpers["f" /* isPresent */])(opts.bysecond)) {
	        opts.bysecond =
	            opts.freq < src_rrule.SECONDLY ? [opts.dtstart.getUTCSeconds()] : null;
	    }
	    else if (Object(helpers["e" /* isNumber */])(opts.bysecond)) {
	        opts.bysecond = [opts.bysecond];
	    }
	    return { parsedOptions: opts };
	}
	function buildTimeset(opts) {
	    var millisecondModulo = opts.dtstart.getTime() % 1000;
	    if (!freqIsDailyOrGreater(opts.freq)) {
	        return [];
	    }
	    var timeset = [];
	    opts.byhour.forEach(function (hour) {
	        opts.byminute.forEach(function (minute) {
	            opts.bysecond.forEach(function (second) {
	                timeset.push(new Time(hour, minute, second, millisecondModulo));
	            });
	        });
	    });
	    return timeset;
	}
	
	// CONCATENATED MODULE: ./src/parsestring.ts
	var __assign = (undefined && undefined.__assign) || function () {
	    __assign = Object.assign || function(t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	                t[p] = s[p];
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	
	
	
	
	function parseString(rfcString) {
	    var options = rfcString.split('\n').map(parseLine).filter(function (x) { return x !== null; });
	    return __assign({}, options[0], options[1]);
	}
	function parseDtstart(line) {
	    var options = {};
	    var dtstartWithZone = /DTSTART(?:;TZID=([^:=]+?))?(?::|=)([^;\s]+)/i.exec(line);
	    if (!dtstartWithZone) {
	        return options;
	    }
	    var _ = dtstartWithZone[0], tzid = dtstartWithZone[1], dtstart = dtstartWithZone[2];
	    if (tzid) {
	        options.tzid = tzid;
	    }
	    options.dtstart = src_dateutil.untilStringToDate(dtstart);
	    return options;
	}
	function parseLine(rfcString) {
	    rfcString = rfcString.replace(/^\s+|\s+$/, '');
	    if (!rfcString.length)
	        return null;
	    var header = /^([A-Z]+?)[:;]/.exec(rfcString.toUpperCase());
	    if (!header) {
	        return parseRrule(rfcString);
	    }
	    var _ = header[0], key = header[1];
	    switch (key.toUpperCase()) {
	        case 'RRULE':
	        case 'EXRULE':
	            return parseRrule(rfcString);
	        case 'DTSTART':
	            return parseDtstart(rfcString);
	        default:
	            throw new Error("Unsupported RFC prop " + key + " in " + rfcString);
	    }
	}
	function parseRrule(line) {
	    var strippedLine = line.replace(/^RRULE:/i, '');
	    var options = parseDtstart(strippedLine);
	    var attrs = line.replace(/^(?:RRULE|EXRULE):/i, '').split(';');
	    attrs.forEach(function (attr) {
	        var _a = attr.split('='), key = _a[0], value = _a[1];
	        switch (key.toUpperCase()) {
	            case 'FREQ':
	                options.freq = Frequency[value.toUpperCase()];
	                break;
	            case 'WKST':
	                options.wkst = Days[value.toUpperCase()];
	                break;
	            case 'COUNT':
	            case 'INTERVAL':
	            case 'BYSETPOS':
	            case 'BYMONTH':
	            case 'BYMONTHDAY':
	            case 'BYYEARDAY':
	            case 'BYWEEKNO':
	            case 'BYHOUR':
	            case 'BYMINUTE':
	            case 'BYSECOND':
	                var num = parseNumber(value);
	                var optionKey = key.toLowerCase();
	                // @ts-ignore
	                options[optionKey] = num;
	                break;
	            case 'BYWEEKDAY':
	            case 'BYDAY':
	                options.byweekday = parseWeekday(value);
	                break;
	            case 'DTSTART':
	            case 'TZID':
	                // for backwards compatibility
	                var dtstart = parseDtstart(line);
	                options.tzid = dtstart.tzid;
	                options.dtstart = dtstart.dtstart;
	                break;
	            case 'UNTIL':
	                options.until = src_dateutil.untilStringToDate(value);
	                break;
	            case 'BYEASTER':
	                options.byeaster = Number(value);
	                break;
	            default:
	                throw new Error("Unknown RRULE property '" + key + "'");
	        }
	    });
	    return options;
	}
	function parseNumber(value) {
	    if (value.indexOf(',') !== -1) {
	        var values = value.split(',');
	        return values.map(parseIndividualNumber);
	    }
	    return parseIndividualNumber(value);
	}
	function parseIndividualNumber(value) {
	    if (/^[+-]?\d+$/.test(value)) {
	        return Number(value);
	    }
	    return value;
	}
	function parseWeekday(value) {
	    var days = value.split(',');
	    return days.map(function (day) {
	        if (day.length === 2) {
	            // MO, TU, ...
	            return Days[day]; // wday instanceof Weekday
	        }
	        // -1MO, +3FR, 1SO, ...
	        var parts = day.match(/^([+-]?\d)([A-Z]{2})$/);
	        var n = Number(parts[1]);
	        var wdaypart = parts[2];
	        var wday = Days[wdaypart].weekday;
	        return new Weekday(wday, n);
	    });
	}
	
	// EXTERNAL MODULE: external "luxon"
	var external_luxon_ = __webpack_require__(2);
	
	// CONCATENATED MODULE: ./src/datewithzone.ts
	
	
	var datewithzone_DateWithZone = /** @class */ (function () {
	    function DateWithZone(date, tzid) {
	        this.date = date;
	        this.tzid = tzid;
	    }
	    Object.defineProperty(DateWithZone.prototype, "isUTC", {
	        get: function () {
	            return !this.tzid || this.tzid.toUpperCase() === 'UTC';
	        },
	        enumerable: true,
	        configurable: true
	    });
	    DateWithZone.prototype.toString = function () {
	        var datestr = src_dateutil.timeToUntilString(this.date.getTime(), this.isUTC);
	        if (!this.isUTC) {
	            return ";TZID=" + this.tzid + ":" + datestr;
	        }
	        return ":" + datestr;
	    };
	    DateWithZone.prototype.getTime = function () {
	        return this.date.getTime();
	    };
	    DateWithZone.prototype.rezonedDate = function () {
	        if (this.isUTC) {
	            return this.date;
	        }
	        try {
	            var datetime = external_luxon_["DateTime"]
	                .fromJSDate(this.date);
	            var rezoned = datetime.setZone(this.tzid, { keepLocalTime: true });
	            return rezoned.toJSDate();
	        }
	        catch (e) {
	            if (e instanceof TypeError) {
	                console.error('Using TZID without Luxon available is unsupported. Returned times are in UTC, not the requested time zone');
	            }
	            return this.date;
	        }
	    };
	    return DateWithZone;
	}());
	
	
	// CONCATENATED MODULE: ./src/optionstostring.ts
	
	
	
	
	
	function optionsToString(options) {
	    var rrule = [];
	    var dtstart = '';
	    var keys = Object.keys(options);
	    var defaultKeys = Object.keys(DEFAULT_OPTIONS);
	    for (var i = 0; i < keys.length; i++) {
	        if (keys[i] === 'tzid')
	            continue;
	        if (!Object(helpers["c" /* includes */])(defaultKeys, keys[i]))
	            continue;
	        var key = keys[i].toUpperCase();
	        var value = options[keys[i]];
	        var outValue = '';
	        if (!Object(helpers["f" /* isPresent */])(value) || (Object(helpers["d" /* isArray */])(value) && !value.length))
	            continue;
	        switch (key) {
	            case 'FREQ':
	                outValue = src_rrule.FREQUENCIES[options.freq];
	                break;
	            case 'WKST':
	                if (Object(helpers["e" /* isNumber */])(value)) {
	                    outValue = new Weekday(value).toString();
	                }
	                else {
	                    outValue = value.toString();
	                }
	                break;
	            case 'BYWEEKDAY':
	                /*
	                NOTE: BYWEEKDAY is a special case.
	                RRule() deconstructs the rule.options.byweekday array
	                into an array of Weekday arguments.
	                On the other hand, rule.origOptions is an array of Weekdays.
	                We need to handle both cases here.
	                It might be worth change RRule to keep the Weekdays.
	      
	                Also, BYWEEKDAY (used by RRule) vs. BYDAY (RFC)
	      
	                */
	                key = 'BYDAY';
	                outValue = Object(helpers["m" /* toArray */])(value).map(function (wday) {
	                    if (wday instanceof Weekday) {
	                        return wday;
	                    }
	                    if (Object(helpers["d" /* isArray */])(wday)) {
	                        return new Weekday(wday[0], wday[1]);
	                    }
	                    return new Weekday(wday);
	                }).toString();
	                break;
	            case 'DTSTART':
	                dtstart = buildDtstart(value, options.tzid);
	                break;
	            case 'UNTIL':
	                outValue = src_dateutil.timeToUntilString(value, !options.tzid);
	                break;
	            default:
	                if (Object(helpers["d" /* isArray */])(value)) {
	                    var strValues = [];
	                    for (var j = 0; j < value.length; j++) {
	                        strValues[j] = String(value[j]);
	                    }
	                    outValue = strValues.toString();
	                }
	                else {
	                    outValue = String(value);
	                }
	        }
	        if (outValue) {
	            rrule.push([key, outValue]);
	        }
	    }
	    var rules = rrule.map(function (_a) {
	        var key = _a[0], value = _a[1];
	        return key + "=" + value.toString();
	    }).join(';');
	    var ruleString = '';
	    if (rules !== '') {
	        ruleString = "RRULE:" + rules;
	    }
	    return [dtstart, ruleString].filter(function (x) { return !!x; }).join('\n');
	}
	function buildDtstart(dtstart, tzid) {
	    if (!dtstart) {
	        return '';
	    }
	    return 'DTSTART' + new datewithzone_DateWithZone(new Date(dtstart), tzid).toString();
	}
	
	// CONCATENATED MODULE: ./src/cache.ts
	
	
	
	var cache_Cache = /** @class */ (function () {
	    function Cache() {
	        this.all = false;
	        this.before = [];
	        this.after = [];
	        this.between = [];
	    }
	    /**
	     * @param {String} what - all/before/after/between
	     * @param {Array,Date} value - an array of dates, one date, or null
	     * @param {Object?} args - _iter arguments
	     */
	    Cache.prototype._cacheAdd = function (what, value, args) {
	        if (value) {
	            value =
	                value instanceof Date
	                    ? src_dateutil.clone(value)
	                    : src_dateutil.cloneDates(value);
	        }
	        if (what === 'all') {
	            this.all = value;
	        }
	        else {
	            args._value = value;
	            this[what].push(args);
	        }
	    };
	    /**
	     * @return false - not in the cache
	     *         null  - cached, but zero occurrences (before/after)
	     *         Date  - cached (before/after)
	     *         []    - cached, but zero occurrences (all/between)
	     *         [Date1, DateN] - cached (all/between)
	     */
	    Cache.prototype._cacheGet = function (what, args) {
	        var cached = false;
	        var argsKeys = args ? Object.keys(args) : [];
	        var findCacheDiff = function (item) {
	            for (var i = 0; i < argsKeys.length; i++) {
	                var key = argsKeys[i];
	                if (String(args[key]) !== String(item[key])) {
	                    return true;
	                }
	            }
	            return false;
	        };
	        var cachedObject = this[what];
	        if (what === 'all') {
	            cached = this.all;
	        }
	        else if (Object(helpers["d" /* isArray */])(cachedObject)) {
	            // Let's see whether we've already called the
	            // 'what' method with the same 'args'
	            for (var i = 0; i < cachedObject.length; i++) {
	                var item = cachedObject[i];
	                if (argsKeys.length && findCacheDiff(item))
	                    continue;
	                cached = item._value;
	                break;
	            }
	        }
	        if (!cached && this.all) {
	            // Not in the cache, but we already know all the occurrences,
	            // so we can find the correct dates from the cached ones.
	            var iterResult = new iterresult(what, args);
	            for (var i = 0; i < this.all.length; i++) {
	                if (!iterResult.accept(this.all[i]))
	                    break;
	            }
	            cached = iterResult.getValue();
	            this._cacheAdd(what, cached, args);
	        }
	        return Object(helpers["d" /* isArray */])(cached)
	            ? src_dateutil.cloneDates(cached)
	            : cached instanceof Date
	                ? src_dateutil.clone(cached)
	                : cached;
	    };
	    return Cache;
	}());
	
	
	// CONCATENATED MODULE: ./src/masks.ts
	
	// =============================================================================
	// Date masks
	// =============================================================================
	// Every mask is 7 days longer to handle cross-year weekly periods.
	var M365MASK = Object(helpers["k" /* repeat */])(1, 31).concat(Object(helpers["k" /* repeat */])(2, 28), Object(helpers["k" /* repeat */])(3, 31), Object(helpers["k" /* repeat */])(4, 30), Object(helpers["k" /* repeat */])(5, 31), Object(helpers["k" /* repeat */])(6, 30), Object(helpers["k" /* repeat */])(7, 31), Object(helpers["k" /* repeat */])(8, 31), Object(helpers["k" /* repeat */])(9, 30), Object(helpers["k" /* repeat */])(10, 31), Object(helpers["k" /* repeat */])(11, 30), Object(helpers["k" /* repeat */])(12, 31), Object(helpers["k" /* repeat */])(1, 7));
	var M366MASK = Object(helpers["k" /* repeat */])(1, 31).concat(Object(helpers["k" /* repeat */])(2, 29), Object(helpers["k" /* repeat */])(3, 31), Object(helpers["k" /* repeat */])(4, 30), Object(helpers["k" /* repeat */])(5, 31), Object(helpers["k" /* repeat */])(6, 30), Object(helpers["k" /* repeat */])(7, 31), Object(helpers["k" /* repeat */])(8, 31), Object(helpers["k" /* repeat */])(9, 30), Object(helpers["k" /* repeat */])(10, 31), Object(helpers["k" /* repeat */])(11, 30), Object(helpers["k" /* repeat */])(12, 31), Object(helpers["k" /* repeat */])(1, 7));
	var M28 = Object(helpers["j" /* range */])(1, 29);
	var M29 = Object(helpers["j" /* range */])(1, 30);
	var M30 = Object(helpers["j" /* range */])(1, 31);
	var M31 = Object(helpers["j" /* range */])(1, 32);
	var MDAY366MASK = M31.concat(M29, M31, M30, M31, M30, M31, M31, M30, M31, M30, M31, M31.slice(0, 7));
	var MDAY365MASK = M31.concat(M28, M31, M30, M31, M30, M31, M31, M30, M31, M30, M31, M31.slice(0, 7));
	var NM28 = Object(helpers["j" /* range */])(-28, 0);
	var NM29 = Object(helpers["j" /* range */])(-29, 0);
	var NM30 = Object(helpers["j" /* range */])(-30, 0);
	var NM31 = Object(helpers["j" /* range */])(-31, 0);
	var NMDAY366MASK = NM31.concat(NM29, NM31, NM30, NM31, NM30, NM31, NM31, NM30, NM31, NM30, NM31, NM31.slice(0, 7));
	var NMDAY365MASK = NM31.concat(NM28, NM31, NM30, NM31, NM30, NM31, NM31, NM30, NM31, NM30, NM31, NM31.slice(0, 7));
	var M366RANGE = [0, 31, 60, 91, 121, 152, 182, 213, 244, 274, 305, 335, 366];
	var M365RANGE = [0, 31, 59, 90, 120, 151, 181, 212, 243, 273, 304, 334, 365];
	var WDAYMASK = (function () {
	    var wdaymask = [];
	    for (var i = 0; i < 55; i++)
	        wdaymask = wdaymask.concat(Object(helpers["j" /* range */])(7));
	    return wdaymask;
	})();
	
	
	// CONCATENATED MODULE: ./src/iterinfo/yearinfo.ts
	var yearinfo_assign = (undefined && undefined.__assign) || function () {
	    yearinfo_assign = Object.assign || function(t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	                t[p] = s[p];
	        }
	        return t;
	    };
	    return yearinfo_assign.apply(this, arguments);
	};
	
	
	
	function rebuildYear(year, options) {
	    var firstyday = new Date(Date.UTC(year, 0, 1));
	    var yearlen = src_dateutil.isLeapYear(year) ? 366 : 365;
	    var nextyearlen = src_dateutil.isLeapYear(year + 1) ? 366 : 365;
	    var yearordinal = src_dateutil.toOrdinal(firstyday);
	    var yearweekday = src_dateutil.getWeekday(firstyday);
	    var result = yearinfo_assign({ yearlen: yearlen,
	        nextyearlen: nextyearlen,
	        yearordinal: yearordinal,
	        yearweekday: yearweekday }, baseYearMasks(year), { wnomask: null });
	    if (Object(helpers["b" /* empty */])(options.byweekno)) {
	        return result;
	    }
	    result.wnomask = Object(helpers["k" /* repeat */])(0, yearlen + 7);
	    var firstwkst;
	    var wyearlen;
	    var no1wkst = firstwkst = Object(helpers["i" /* pymod */])(7 - yearweekday + options.wkst, 7);
	    if (no1wkst >= 4) {
	        no1wkst = 0;
	        // Number of days in the year, plus the days we got
	        // from last year.
	        wyearlen =
	            result.yearlen + Object(helpers["i" /* pymod */])(yearweekday - options.wkst, 7);
	    }
	    else {
	        // Number of days in the year, minus the days we
	        // left in last year.
	        wyearlen = yearlen - no1wkst;
	    }
	    var div = Math.floor(wyearlen / 7);
	    var mod = Object(helpers["i" /* pymod */])(wyearlen, 7);
	    var numweeks = Math.floor(div + mod / 4);
	    for (var j = 0; j < options.byweekno.length; j++) {
	        var n = options.byweekno[j];
	        if (n < 0) {
	            n += numweeks + 1;
	        }
	        if (!(n > 0 && n <= numweeks)) {
	            continue;
	        }
	        var i = void 0;
	        if (n > 1) {
	            i = no1wkst + (n - 1) * 7;
	            if (no1wkst !== firstwkst) {
	                i -= 7 - firstwkst;
	            }
	        }
	        else {
	            i = no1wkst;
	        }
	        for (var k = 0; k < 7; k++) {
	            result.wnomask[i] = 1;
	            i++;
	            if (result.wdaymask[i] === options.wkst)
	                break;
	        }
	    }
	    if (Object(helpers["c" /* includes */])(options.byweekno, 1)) {
	        // Check week number 1 of next year as well
	        // orig-TODO : Check -numweeks for next year.
	        var i = no1wkst + numweeks * 7;
	        if (no1wkst !== firstwkst)
	            i -= 7 - firstwkst;
	        if (i < yearlen) {
	            // If week starts in next year, we
	            // don't care about it.
	            for (var j = 0; j < 7; j++) {
	                result.wnomask[i] = 1;
	                i += 1;
	                if (result.wdaymask[i] === options.wkst)
	                    break;
	            }
	        }
	    }
	    if (no1wkst) {
	        // Check last week number of last year as
	        // well. If no1wkst is 0, either the year
	        // started on week start, or week number 1
	        // got days from last year, so there are no
	        // days from last year's last week number in
	        // this year.
	        var lnumweeks = void 0;
	        if (!Object(helpers["c" /* includes */])(options.byweekno, -1)) {
	            var lyearweekday = src_dateutil.getWeekday(new Date(Date.UTC(year - 1, 0, 1)));
	            var lno1wkst = Object(helpers["i" /* pymod */])(7 - lyearweekday.valueOf() + options.wkst, 7);
	            var lyearlen = src_dateutil.isLeapYear(year - 1) ? 366 : 365;
	            var weekst = void 0;
	            if (lno1wkst >= 4) {
	                lno1wkst = 0;
	                weekst = lyearlen + Object(helpers["i" /* pymod */])(lyearweekday - options.wkst, 7);
	            }
	            else {
	                weekst = yearlen - no1wkst;
	            }
	            lnumweeks = Math.floor(52 + Object(helpers["i" /* pymod */])(weekst, 7) / 4);
	        }
	        else {
	            lnumweeks = -1;
	        }
	        if (Object(helpers["c" /* includes */])(options.byweekno, lnumweeks)) {
	            for (var i = 0; i < no1wkst; i++)
	                result.wnomask[i] = 1;
	        }
	    }
	    return result;
	}
	function baseYearMasks(year) {
	    var yearlen = src_dateutil.isLeapYear(year) ? 366 : 365;
	    var firstyday = new Date(Date.UTC(year, 0, 1));
	    var wday = src_dateutil.getWeekday(firstyday);
	    if (yearlen === 365) {
	        return {
	            mmask: M365MASK,
	            mdaymask: MDAY365MASK,
	            nmdaymask: NMDAY365MASK,
	            wdaymask: WDAYMASK.slice(wday),
	            mrange: M365RANGE
	        };
	    }
	    return {
	        mmask: M366MASK,
	        mdaymask: MDAY366MASK,
	        nmdaymask: NMDAY366MASK,
	        wdaymask: WDAYMASK.slice(wday),
	        mrange: M366RANGE
	    };
	}
	
	// CONCATENATED MODULE: ./src/iterinfo/monthinfo.ts
	
	
	function rebuildMonth(year, month, yearlen, mrange, wdaymask, options) {
	    var result = {
	        lastyear: year,
	        lastmonth: month,
	        nwdaymask: []
	    };
	    var ranges = [];
	    if (options.freq === src_rrule.YEARLY) {
	        if (Object(helpers["b" /* empty */])(options.bymonth)) {
	            ranges = [[0, yearlen]];
	        }
	        else {
	            for (var j = 0; j < options.bymonth.length; j++) {
	                month = options.bymonth[j];
	                ranges.push(mrange.slice(month - 1, month + 1));
	            }
	        }
	    }
	    else if (options.freq === src_rrule.MONTHLY) {
	        ranges = [mrange.slice(month - 1, month + 1)];
	    }
	    if (Object(helpers["b" /* empty */])(ranges)) {
	        return result;
	    }
	    // Weekly frequency won't get here, so we may not
	    // care about cross-year weekly periods.
	    result.nwdaymask = Object(helpers["k" /* repeat */])(0, yearlen);
	    for (var j = 0; j < ranges.length; j++) {
	        var rang = ranges[j];
	        var first = rang[0];
	        var last = rang[1] - 1;
	        for (var k = 0; k < options.bynweekday.length; k++) {
	            var i = void 0;
	            var _a = options.bynweekday[k], wday = _a[0], n = _a[1];
	            if (n < 0) {
	                i = last + (n + 1) * 7;
	                i -= Object(helpers["i" /* pymod */])(wdaymask[i] - wday, 7);
	            }
	            else {
	                i = first + (n - 1) * 7;
	                i += Object(helpers["i" /* pymod */])(7 - wdaymask[i] + wday, 7);
	            }
	            if (first <= i && i <= last)
	                result.nwdaymask[i] = 1;
	        }
	    }
	    return result;
	}
	
	// CONCATENATED MODULE: ./src/iterinfo/easter.ts
	function easter(y, offset) {
	    if (offset === void 0) { offset = 0; }
	    var a = y % 19;
	    var b = Math.floor(y / 100);
	    var c = y % 100;
	    var d = Math.floor(b / 4);
	    var e = b % 4;
	    var f = Math.floor((b + 8) / 25);
	    var g = Math.floor((b - f + 1) / 3);
	    var h = Math.floor(19 * a + b - d - g + 15) % 30;
	    var i = Math.floor(c / 4);
	    var k = c % 4;
	    var l = Math.floor(32 + 2 * e + 2 * i - h - k) % 7;
	    var m = Math.floor((a + 11 * h + 22 * l) / 451);
	    var month = Math.floor((h + l - 7 * m + 114) / 31);
	    var day = ((h + l - 7 * m + 114) % 31) + 1;
	    var date = Date.UTC(y, month - 1, day + offset);
	    var yearStart = Date.UTC(y, 0, 1);
	    return [Math.ceil((date - yearStart) / (1000 * 60 * 60 * 24))];
	}
	
	// CONCATENATED MODULE: ./src/iterinfo/index.ts
	
	
	
	
	
	
	
	// =============================================================================
	// Iterinfo
	// =============================================================================
	var iterinfo_Iterinfo = /** @class */ (function () {
	    function Iterinfo(options) {
	        this.options = options;
	    }
	    Iterinfo.prototype.rebuild = function (year, month) {
	        var options = this.options;
	        if (year !== this.lastyear) {
	            this.yearinfo = rebuildYear(year, options);
	        }
	        if (Object(helpers["g" /* notEmpty */])(options.bynweekday) &&
	            (month !== this.lastmonth || year !== this.lastyear)) {
	            var _a = this.yearinfo, yearlen = _a.yearlen, mrange = _a.mrange, wdaymask = _a.wdaymask;
	            this.monthinfo = rebuildMonth(year, month, yearlen, mrange, wdaymask, options);
	        }
	        if (Object(helpers["f" /* isPresent */])(options.byeaster)) {
	            this.eastermask = easter(year, options.byeaster);
	        }
	    };
	    Object.defineProperty(Iterinfo.prototype, "lastyear", {
	        get: function () {
	            return this.monthinfo ? this.monthinfo.lastyear : null;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(Iterinfo.prototype, "lastmonth", {
	        get: function () {
	            return this.monthinfo ? this.monthinfo.lastmonth : null;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(Iterinfo.prototype, "yearlen", {
	        get: function () {
	            return this.yearinfo.yearlen;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(Iterinfo.prototype, "yearordinal", {
	        get: function () {
	            return this.yearinfo.yearordinal;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(Iterinfo.prototype, "mrange", {
	        get: function () {
	            return this.yearinfo.mrange;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(Iterinfo.prototype, "wdaymask", {
	        get: function () {
	            return this.yearinfo.wdaymask;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(Iterinfo.prototype, "mmask", {
	        get: function () {
	            return this.yearinfo.mmask;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(Iterinfo.prototype, "wnomask", {
	        get: function () {
	            return this.yearinfo.wnomask;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(Iterinfo.prototype, "nwdaymask", {
	        get: function () {
	            return this.monthinfo ? this.monthinfo.nwdaymask : [];
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(Iterinfo.prototype, "nextyearlen", {
	        get: function () {
	            return this.yearinfo.nextyearlen;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(Iterinfo.prototype, "mdaymask", {
	        get: function () {
	            return this.yearinfo.mdaymask;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(Iterinfo.prototype, "nmdaymask", {
	        get: function () {
	            return this.yearinfo.nmdaymask;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Iterinfo.prototype.ydayset = function () {
	        return [Object(helpers["j" /* range */])(this.yearlen), 0, this.yearlen];
	    };
	    Iterinfo.prototype.mdayset = function (_, month, __) {
	        var start = this.mrange[month - 1];
	        var end = this.mrange[month];
	        var set = Object(helpers["k" /* repeat */])(null, this.yearlen);
	        for (var i = start; i < end; i++)
	            set[i] = i;
	        return [set, start, end];
	    };
	    Iterinfo.prototype.wdayset = function (year, month, day) {
	        // We need to handle cross-year weeks here.
	        var set = Object(helpers["k" /* repeat */])(null, this.yearlen + 7);
	        var i = src_dateutil.toOrdinal(new Date(Date.UTC(year, month - 1, day))) -
	            this.yearordinal;
	        var start = i;
	        for (var j = 0; j < 7; j++) {
	            set[i] = i;
	            ++i;
	            if (this.wdaymask[i] === this.options.wkst)
	                break;
	        }
	        return [set, start, i];
	    };
	    Iterinfo.prototype.ddayset = function (year, month, day) {
	        var set = Object(helpers["k" /* repeat */])(null, this.yearlen);
	        var i = src_dateutil.toOrdinal(new Date(Date.UTC(year, month - 1, day))) -
	            this.yearordinal;
	        set[i] = i;
	        return [set, i, i + 1];
	    };
	    Iterinfo.prototype.htimeset = function (hour, _, second, millisecond) {
	        var _this = this;
	        var set = [];
	        this.options.byminute.forEach(function (minute) {
	            set = set.concat(_this.mtimeset(hour, minute, second, millisecond));
	        });
	        src_dateutil.sort(set);
	        return set;
	    };
	    Iterinfo.prototype.mtimeset = function (hour, minute, _, millisecond) {
	        var set = this.options.bysecond.map(function (second) {
	            return new Time(hour, minute, second, millisecond);
	        });
	        src_dateutil.sort(set);
	        return set;
	    };
	    Iterinfo.prototype.stimeset = function (hour, minute, second, millisecond) {
	        return [new Time(hour, minute, second, millisecond)];
	    };
	    Iterinfo.prototype.getdayset = function (freq) {
	        switch (freq) {
	            case Frequency.YEARLY: return this.ydayset.bind(this);
	            case Frequency.MONTHLY: return this.mdayset.bind(this);
	            case Frequency.WEEKLY: return this.wdayset.bind(this);
	            case Frequency.DAILY: return this.ddayset.bind(this);
	            default: return this.ddayset.bind(this);
	        }
	    };
	    Iterinfo.prototype.gettimeset = function (freq) {
	        switch (freq) {
	            case Frequency.HOURLY: return this.htimeset.bind(this);
	            case Frequency.MINUTELY: return this.mtimeset.bind(this);
	            case Frequency.SECONDLY: return this.stimeset.bind(this);
	        }
	    };
	    return Iterinfo;
	}());
	/* harmony default export */ var iterinfo = (iterinfo_Iterinfo);
	
	// CONCATENATED MODULE: ./src/iter/poslist.ts
	
	
	function buildPoslist(bysetpos, timeset, start, end, ii, dayset) {
	    var poslist = [];
	    for (var j = 0; j < bysetpos.length; j++) {
	        var daypos = void 0;
	        var timepos = void 0;
	        var pos = bysetpos[j];
	        if (pos < 0) {
	            daypos = Math.floor(pos / timeset.length);
	            timepos = Object(helpers["i" /* pymod */])(pos, timeset.length);
	        }
	        else {
	            daypos = Math.floor((pos - 1) / timeset.length);
	            timepos = Object(helpers["i" /* pymod */])(pos - 1, timeset.length);
	        }
	        var tmp = [];
	        for (var k = start; k < end; k++) {
	            var val = dayset[k];
	            if (!Object(helpers["f" /* isPresent */])(val))
	                continue;
	            tmp.push(val);
	        }
	        var i = void 0;
	        if (daypos < 0) {
	            i = tmp.slice(daypos)[0];
	        }
	        else {
	            i = tmp[daypos];
	        }
	        var time = timeset[timepos];
	        var date = src_dateutil.fromOrdinal(ii.yearordinal + i);
	        var res = src_dateutil.combine(date, time);
	        // XXX: can this ever be in the array?
	        // - compare the actual date instead?
	        if (!Object(helpers["c" /* includes */])(poslist, res))
	            poslist.push(res);
	    }
	    src_dateutil.sort(poslist);
	    return poslist;
	}
	
	// CONCATENATED MODULE: ./src/iter/index.ts
	
	
	
	
	
	
	
	
	
	function iter(iterResult, options) {
	    var dtstart = options.dtstart, freq = options.freq, interval = options.interval, until = options.until, bysetpos = options.bysetpos;
	    var count = options.count;
	    if (count === 0 || interval === 0) {
	        return emitResult(iterResult);
	    }
	    var counterDate = datetime_DateTime.fromDate(dtstart);
	    var ii = new iterinfo(options);
	    ii.rebuild(counterDate.year, counterDate.month);
	    var timeset = makeTimeset(ii, counterDate, options);
	    while (true) {
	        var _a = ii.getdayset(freq)(counterDate.year, counterDate.month, counterDate.day), dayset = _a[0], start = _a[1], end = _a[2];
	        var filtered = removeFilteredDays(dayset, start, end, ii, options);
	        if (Object(helpers["g" /* notEmpty */])(bysetpos)) {
	            var poslist = buildPoslist(bysetpos, timeset, start, end, ii, dayset);
	            for (var j = 0; j < poslist.length; j++) {
	                var res = poslist[j];
	                if (until && res > until) {
	                    return emitResult(iterResult);
	                }
	                if (res >= dtstart) {
	                    var rezonedDate = rezoneIfNeeded(res, options);
	                    if (!iterResult.accept(rezonedDate)) {
	                        return emitResult(iterResult);
	                    }
	                    if (count) {
	                        --count;
	                        if (!count) {
	                            return emitResult(iterResult);
	                        }
	                    }
	                }
	            }
	        }
	        else {
	            for (var j = start; j < end; j++) {
	                var currentDay = dayset[j];
	                if (!Object(helpers["f" /* isPresent */])(currentDay)) {
	                    continue;
	                }
	                var date = src_dateutil.fromOrdinal(ii.yearordinal + currentDay);
	                for (var k = 0; k < timeset.length; k++) {
	                    var time = timeset[k];
	                    var res = src_dateutil.combine(date, time);
	                    if (until && res > until) {
	                        return emitResult(iterResult);
	                    }
	                    if (res >= dtstart) {
	                        var rezonedDate = rezoneIfNeeded(res, options);
	                        if (!iterResult.accept(rezonedDate)) {
	                            return emitResult(iterResult);
	                        }
	                        if (count) {
	                            --count;
	                            if (!count) {
	                                return emitResult(iterResult);
	                            }
	                        }
	                    }
	                }
	            }
	        }
	        if (options.interval === 0) {
	            return emitResult(iterResult);
	        }
	        // Handle frequency and interval
	        counterDate.add(options, filtered);
	        if (counterDate.year > src_dateutil.MAXYEAR) {
	            return emitResult(iterResult);
	        }
	        if (!freqIsDailyOrGreater(freq)) {
	            timeset = ii.gettimeset(freq)(counterDate.hour, counterDate.minute, counterDate.second, 0);
	        }
	        ii.rebuild(counterDate.year, counterDate.month);
	    }
	}
	function isFiltered(ii, currentDay, options) {
	    var bymonth = options.bymonth, byweekno = options.byweekno, byweekday = options.byweekday, byeaster = options.byeaster, bymonthday = options.bymonthday, bynmonthday = options.bynmonthday, byyearday = options.byyearday;
	    return ((Object(helpers["g" /* notEmpty */])(bymonth) && !Object(helpers["c" /* includes */])(bymonth, ii.mmask[currentDay])) ||
	        (Object(helpers["g" /* notEmpty */])(byweekno) && !ii.wnomask[currentDay]) ||
	        (Object(helpers["g" /* notEmpty */])(byweekday) && !Object(helpers["c" /* includes */])(byweekday, ii.wdaymask[currentDay])) ||
	        (Object(helpers["g" /* notEmpty */])(ii.nwdaymask) && !ii.nwdaymask[currentDay]) ||
	        (byeaster !== null && !Object(helpers["c" /* includes */])(ii.eastermask, currentDay)) ||
	        ((Object(helpers["g" /* notEmpty */])(bymonthday) || Object(helpers["g" /* notEmpty */])(bynmonthday)) &&
	            !Object(helpers["c" /* includes */])(bymonthday, ii.mdaymask[currentDay]) &&
	            !Object(helpers["c" /* includes */])(bynmonthday, ii.nmdaymask[currentDay])) ||
	        (Object(helpers["g" /* notEmpty */])(byyearday) &&
	            ((currentDay < ii.yearlen &&
	                !Object(helpers["c" /* includes */])(byyearday, currentDay + 1) &&
	                !Object(helpers["c" /* includes */])(byyearday, -ii.yearlen + currentDay)) ||
	                (currentDay >= ii.yearlen &&
	                    !Object(helpers["c" /* includes */])(byyearday, currentDay + 1 - ii.yearlen) &&
	                    !Object(helpers["c" /* includes */])(byyearday, -ii.nextyearlen + currentDay - ii.yearlen)))));
	}
	function rezoneIfNeeded(date, options) {
	    return new datewithzone_DateWithZone(date, options.tzid).rezonedDate();
	}
	function emitResult(iterResult) {
	    return iterResult.getValue();
	}
	function removeFilteredDays(dayset, start, end, ii, options) {
	    var filtered = false;
	    for (var dayCounter = start; dayCounter < end; dayCounter++) {
	        var currentDay = dayset[dayCounter];
	        filtered = isFiltered(ii, currentDay, options);
	        if (filtered)
	            dayset[currentDay] = null;
	    }
	    return filtered;
	}
	function makeTimeset(ii, counterDate, options) {
	    var freq = options.freq, byhour = options.byhour, byminute = options.byminute, bysecond = options.bysecond;
	    if (freqIsDailyOrGreater(freq)) {
	        return buildTimeset(options);
	    }
	    if ((freq >= src_rrule.HOURLY &&
	        Object(helpers["g" /* notEmpty */])(byhour) &&
	        !Object(helpers["c" /* includes */])(byhour, counterDate.hour)) ||
	        (freq >= src_rrule.MINUTELY &&
	            Object(helpers["g" /* notEmpty */])(byminute) &&
	            !Object(helpers["c" /* includes */])(byminute, counterDate.minute)) ||
	        (freq >= src_rrule.SECONDLY &&
	            Object(helpers["g" /* notEmpty */])(bysecond) &&
	            !Object(helpers["c" /* includes */])(bysecond, counterDate.second))) {
	        return [];
	    }
	    return ii.gettimeset(freq)(counterDate.hour, counterDate.minute, counterDate.second, counterDate.millisecond);
	}
	
	// CONCATENATED MODULE: ./src/rrule.ts
	
	
	
	
	
	
	
	
	
	
	var getnlp = function () {
	    // Lazy, runtime import to avoid circular refs.
	    if (!getnlp._nlp) {
	        getnlp._nlp = __webpack_require__(3);
	    }
	    return getnlp._nlp;
	};
	// =============================================================================
	// RRule
	// =============================================================================
	var Days = {
	    MO: new Weekday(0),
	    TU: new Weekday(1),
	    WE: new Weekday(2),
	    TH: new Weekday(3),
	    FR: new Weekday(4),
	    SA: new Weekday(5),
	    SU: new Weekday(6)
	};
	var DEFAULT_OPTIONS = {
	    freq: Frequency.YEARLY,
	    dtstart: null,
	    interval: 1,
	    wkst: Days.MO,
	    count: null,
	    until: null,
	    tzid: null,
	    bysetpos: null,
	    bymonth: null,
	    bymonthday: null,
	    bynmonthday: null,
	    byyearday: null,
	    byweekno: null,
	    byweekday: null,
	    bynweekday: null,
	    byhour: null,
	    byminute: null,
	    bysecond: null,
	    byeaster: null
	};
	var rrule_defaultKeys = Object.keys(DEFAULT_OPTIONS);
	/**
	 *
	 * @param {Options?} options - see <http://labix.org/python-dateutil/#head-cf004ee9a75592797e076752b2a889c10f445418>
	 *        The only required option is `freq`, one of RRule.YEARLY, RRule.MONTHLY, ...
	 * @constructor
	 */
	var rrule_RRule = /** @class */ (function () {
	    function RRule(options, noCache) {
	        if (options === void 0) { options = {}; }
	        if (noCache === void 0) { noCache = false; }
	        // RFC string
	        this._cache = noCache ? null : new cache_Cache();
	        // used by toString()
	        this.origOptions = initializeOptions(options);
	        var parsedOptions = parseOptions(options).parsedOptions;
	        this.options = parsedOptions;
	    }
	    RRule.parseText = function (text, language) {
	        return getnlp().parseText(text, language);
	    };
	    RRule.fromText = function (text, language) {
	        return getnlp().fromText(text, language);
	    };
	    RRule.fromString = function (str) {
	        return new RRule(RRule.parseString(str) || undefined);
	    };
	    RRule.prototype._iter = function (iterResult) {
	        return iter(iterResult, this.options);
	    };
	    RRule.prototype._cacheGet = function (what, args) {
	        if (!this._cache)
	            return false;
	        return this._cache._cacheGet(what, args);
	    };
	    RRule.prototype._cacheAdd = function (what, value, args) {
	        if (!this._cache)
	            return;
	        return this._cache._cacheAdd(what, value, args);
	    };
	    /**
	     * @param {Function} iterator - optional function that will be called
	     *                   on each date that is added. It can return false
	     *                   to stop the iteration.
	     * @return Array containing all recurrences.
	     */
	    RRule.prototype.all = function (iterator) {
	        if (iterator) {
	            return this._iter(new callbackiterresult('all', {}, iterator));
	        }
	        var result = this._cacheGet('all');
	        if (result === false) {
	            result = this._iter(new iterresult('all', {}));
	            this._cacheAdd('all', result);
	        }
	        return result;
	    };
	    /**
	     * Returns all the occurrences of the rrule between after and before.
	     * The inc keyword defines what happens if after and/or before are
	     * themselves occurrences. With inc == True, they will be included in the
	     * list, if they are found in the recurrence set.
	     * @return Array
	     */
	    RRule.prototype.between = function (after, before, inc, iterator) {
	        if (inc === void 0) { inc = false; }
	        if (!src_dateutil.isValidDate(after) || !src_dateutil.isValidDate(before))
	            throw new Error('Invalid date passed in to RRule.between');
	        var args = {
	            before: before,
	            after: after,
	            inc: inc
	        };
	        if (iterator) {
	            return this._iter(new callbackiterresult('between', args, iterator));
	        }
	        var result = this._cacheGet('between', args);
	        if (result === false) {
	            result = this._iter(new iterresult('between', args));
	            this._cacheAdd('between', result, args);
	        }
	        return result;
	    };
	    /**
	     * Returns the last recurrence before the given datetime instance.
	     * The inc keyword defines what happens if dt is an occurrence.
	     * With inc == True, if dt itself is an occurrence, it will be returned.
	     * @return Date or null
	     */
	    RRule.prototype.before = function (dt, inc) {
	        if (inc === void 0) { inc = false; }
	        if (!src_dateutil.isValidDate(dt))
	            throw new Error('Invalid date passed in to RRule.before');
	        var args = { dt: dt, inc: inc };
	        var result = this._cacheGet('before', args);
	        if (result === false) {
	            result = this._iter(new iterresult('before', args));
	            this._cacheAdd('before', result, args);
	        }
	        return result;
	    };
	    /**
	     * Returns the first recurrence after the given datetime instance.
	     * The inc keyword defines what happens if dt is an occurrence.
	     * With inc == True, if dt itself is an occurrence, it will be returned.
	     * @return Date or null
	     */
	    RRule.prototype.after = function (dt, inc) {
	        if (inc === void 0) { inc = false; }
	        if (!src_dateutil.isValidDate(dt))
	            throw new Error('Invalid date passed in to RRule.after');
	        var args = { dt: dt, inc: inc };
	        var result = this._cacheGet('after', args);
	        if (result === false) {
	            result = this._iter(new iterresult('after', args));
	            this._cacheAdd('after', result, args);
	        }
	        return result;
	    };
	    /**
	     * Returns the number of recurrences in this set. It will have go trough
	     * the whole recurrence, if this hasn't been done before.
	     */
	    RRule.prototype.count = function () {
	        return this.all().length;
	    };
	    /**
	     * Converts the rrule into its string representation
	     * @see <http://www.ietf.org/rfc/rfc2445.txt>
	     * @return String
	     */
	    RRule.prototype.toString = function () {
	        return optionsToString(this.origOptions);
	    };
	    /**
	     * Will convert all rules described in nlp:ToText
	     * to text.
	     */
	    RRule.prototype.toText = function (gettext, language) {
	        return getnlp().toText(this, gettext, language);
	    };
	    RRule.prototype.isFullyConvertibleToText = function () {
	        return getnlp().isFullyConvertible(this);
	    };
	    /**
	     * @return a RRule instance with the same freq and options
	     *          as this one (cache is not cloned)
	     */
	    RRule.prototype.clone = function () {
	        return new RRule(this.origOptions);
	    };
	    // RRule class 'constants'
	    RRule.FREQUENCIES = [
	        'YEARLY',
	        'MONTHLY',
	        'WEEKLY',
	        'DAILY',
	        'HOURLY',
	        'MINUTELY',
	        'SECONDLY'
	    ];
	    RRule.YEARLY = Frequency.YEARLY;
	    RRule.MONTHLY = Frequency.MONTHLY;
	    RRule.WEEKLY = Frequency.WEEKLY;
	    RRule.DAILY = Frequency.DAILY;
	    RRule.HOURLY = Frequency.HOURLY;
	    RRule.MINUTELY = Frequency.MINUTELY;
	    RRule.SECONDLY = Frequency.SECONDLY;
	    RRule.MO = Days.MO;
	    RRule.TU = Days.TU;
	    RRule.WE = Days.WE;
	    RRule.TH = Days.TH;
	    RRule.FR = Days.FR;
	    RRule.SA = Days.SA;
	    RRule.SU = Days.SU;
	    RRule.parseString = parseString;
	    RRule.optionsToString = optionsToString;
	    return RRule;
	}());
	/* harmony default export */ var src_rrule = (rrule_RRule);
	
	// CONCATENATED MODULE: ./src/iterset.ts
	
	
	
	function iterSet(iterResult, _rrule, _exrule, _rdate, _exdate, tzid) {
	    var _exdateHash = {};
	    var _accept = iterResult.accept;
	    function evalExdate(after, before) {
	        _exrule.forEach(function (rrule) {
	            rrule.between(after, before, true).forEach(function (date) {
	                _exdateHash[Number(date)] = true;
	            });
	        });
	    }
	    _exdate.forEach(function (date) {
	        var zonedDate = new datewithzone_DateWithZone(date, tzid).rezonedDate();
	        _exdateHash[Number(zonedDate)] = true;
	    });
	    iterResult.accept = function (date) {
	        var dt = Number(date);
	        if (!_exdateHash[dt]) {
	            evalExdate(new Date(dt - 1), new Date(dt + 1));
	            if (!_exdateHash[dt]) {
	                _exdateHash[dt] = true;
	                return _accept.call(this, date);
	            }
	        }
	        return true;
	    };
	    if (iterResult.method === 'between') {
	        evalExdate(iterResult.args.after, iterResult.args.before);
	        iterResult.accept = function (date) {
	            var dt = Number(date);
	            if (!_exdateHash[dt]) {
	                _exdateHash[dt] = true;
	                return _accept.call(this, date);
	            }
	            return true;
	        };
	    }
	    for (var i = 0; i < _rdate.length; i++) {
	        var zonedDate = new datewithzone_DateWithZone(_rdate[i], tzid).rezonedDate();
	        if (!iterResult.accept(new Date(zonedDate.getTime())))
	            break;
	    }
	    _rrule.forEach(function (rrule) {
	        iter(iterResult, rrule.options);
	    });
	    var res = iterResult._result;
	    src_dateutil.sort(res);
	    switch (iterResult.method) {
	        case 'all':
	        case 'between':
	            return res;
	        case 'before':
	            return ((res.length && res[res.length - 1]) || null);
	        case 'after':
	        default:
	            return ((res.length && res[0]) || null);
	    }
	}
	
	// CONCATENATED MODULE: ./src/rruleset.ts
	var rruleset_extends = (undefined && undefined.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    }
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	
	
	
	
	var rruleset_RRuleSet = /** @class */ (function (_super) {
	    rruleset_extends(RRuleSet, _super);
	    /**
	     *
	     * @param {Boolean?} noCache
	     *  The same stratagy as RRule on cache, default to false
	     * @constructor
	     */
	    function RRuleSet(noCache) {
	        if (noCache === void 0) { noCache = false; }
	        var _this = _super.call(this, {}, noCache) || this;
	        _this._rrule = [];
	        _this._rdate = [];
	        _this._exrule = [];
	        _this._exdate = [];
	        return _this;
	    }
	    RRuleSet.prototype.tzid = function (tzid) {
	        if (tzid !== undefined) {
	            this._tzid = tzid;
	        }
	        if (this._tzid !== undefined) {
	            return this._tzid;
	        }
	        for (var i = 0; i < this._rrule.length; i++) {
	            var tzid_1 = this._rrule[i].origOptions.tzid;
	            if (tzid_1) {
	                return tzid_1;
	            }
	        }
	        return undefined;
	    };
	    RRuleSet.prototype._iter = function (iterResult) {
	        return iterSet(iterResult, this._rrule, this._exrule, this._rdate, this._exdate, this.tzid());
	    };
	    /**
	     * Adds an RRule to the set
	     *
	     * @param {RRule}
	     */
	    RRuleSet.prototype.rrule = function (rrule) {
	        _addRule(rrule, this._rrule);
	    };
	    /**
	     * Adds an EXRULE to the set
	     *
	     * @param {RRule}
	     */
	    RRuleSet.prototype.exrule = function (rrule) {
	        _addRule(rrule, this._exrule);
	    };
	    /**
	     * Adds an RDate to the set
	     *
	     * @param {Date}
	     */
	    RRuleSet.prototype.rdate = function (date) {
	        _addDate(date, this._rdate);
	    };
	    /**
	     * Adds an EXDATE to the set
	     *
	     * @param {Date}
	     */
	    RRuleSet.prototype.exdate = function (date) {
	        _addDate(date, this._exdate);
	    };
	    RRuleSet.prototype.valueOf = function () {
	        var result = [];
	        this._rrule.forEach(function (rrule) {
	            result = result.concat(rrule.toString().split('\n'));
	        });
	        this._exrule.forEach(function (exrule) {
	            result = result.concat(exrule.toString().split('\n')
	                .map(function (line) { return line.replace(/^RRULE:/, 'EXRULE:'); })
	                .filter(function (line) { return !/^DTSTART/.test(line); }));
	        });
	        if (this._rdate.length) {
	            result.push(rdatesToString('RDATE', this._rdate, this.tzid()));
	        }
	        if (this._exdate.length) {
	            result.push(rdatesToString('EXDATE', this._exdate, this.tzid()));
	        }
	        return result;
	    };
	    /**
	     * to generate recurrence field such as:
	     *   DTSTART:19970902T010000Z
	     *   RRULE:FREQ=YEARLY;COUNT=2;BYDAY=TU
	     *   RRULE:FREQ=YEARLY;COUNT=1;BYDAY=TH
	     */
	    RRuleSet.prototype.toString = function () {
	        return this.valueOf().join('\n');
	    };
	    /**
	     * Create a new RRuleSet Object completely base on current instance
	     */
	    RRuleSet.prototype.clone = function () {
	        var rrs = new RRuleSet(!!this._cache);
	        this._rrule.forEach(function (rule) { return rrs.rrule(rule.clone()); });
	        this._exrule.forEach(function (rule) { return rrs.exrule(rule.clone()); });
	        this._rdate.forEach(function (date) { return rrs.rdate(new Date(date.getTime())); });
	        this._exdate.forEach(function (date) { return rrs.exdate(new Date(date.getTime())); });
	        return rrs;
	    };
	    return RRuleSet;
	}(src_rrule));
	/* harmony default export */ var rruleset = (rruleset_RRuleSet);
	function _addRule(rrule, collection) {
	    if (!(rrule instanceof src_rrule)) {
	        throw new TypeError(String(rrule) + ' is not RRule instance');
	    }
	    if (!Object(helpers["c" /* includes */])(collection.map(String), String(rrule))) {
	        collection.push(rrule);
	    }
	}
	function _addDate(date, collection) {
	    if (!(date instanceof Date)) {
	        throw new TypeError(String(date) + ' is not Date instance');
	    }
	    if (!Object(helpers["c" /* includes */])(collection.map(Number), Number(date))) {
	        collection.push(date);
	        src_dateutil.sort(collection);
	    }
	}
	function rdatesToString(param, rdates, tzid) {
	    var isUTC = !tzid || tzid.toUpperCase() === 'UTC';
	    var header = isUTC ? param + ":" : param + ";TZID=" + tzid + ":";
	    var dateString = rdates
	        .map(function (rdate) { return src_dateutil.timeToUntilString(rdate.valueOf(), isUTC); })
	        .join(',');
	    return "" + header + dateString;
	}
	
	// CONCATENATED MODULE: ./src/rrulestr.ts
	var rrulestr_assign = (undefined && undefined.__assign) || function () {
	    rrulestr_assign = Object.assign || function(t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	                t[p] = s[p];
	        }
	        return t;
	    };
	    return rrulestr_assign.apply(this, arguments);
	};
	
	
	
	
	
	/**
	 * RRuleStr
	 *  To parse a set of rrule strings
	 */
	var rrulestr_DEFAULT_OPTIONS = {
	    dtstart: null,
	    cache: false,
	    unfold: false,
	    forceset: false,
	    compatible: false,
	    tzid: null
	};
	function parseInput(s, options) {
	    var rrulevals = [];
	    var rdatevals = [];
	    var exrulevals = [];
	    var exdatevals = [];
	    var _a = parseDtstart(s), dtstart = _a.dtstart, tzid = _a.tzid;
	    var lines = splitIntoLines(s, options.unfold);
	    lines.forEach(function (line) {
	        if (!line)
	            return;
	        var _a = breakDownLine(line), name = _a.name, parms = _a.parms, value = _a.value;
	        switch (name.toUpperCase()) {
	            case 'RRULE':
	                if (parms.length) {
	                    throw new Error("unsupported RRULE parm: " + parms.join(','));
	                }
	                rrulevals.push(parseString(line));
	                break;
	            case 'RDATE':
	                var _b = /RDATE(?:;TZID=([^:=]+))?/i.exec(line), _ = _b[0], rdateTzid = _b[1];
	                if (rdateTzid && !tzid) {
	                    tzid = rdateTzid;
	                }
	                rdatevals = rdatevals.concat(parseRDate(value, parms));
	                break;
	            case 'EXRULE':
	                if (parms.length) {
	                    throw new Error("unsupported EXRULE parm: " + parms.join(','));
	                }
	                exrulevals.push(parseString(value));
	                break;
	            case 'EXDATE':
	                exdatevals = exdatevals.concat(parseRDate(value, parms));
	                break;
	            case 'DTSTART':
	                break;
	            default:
	                throw new Error('unsupported property: ' + name);
	        }
	    });
	    return {
	        dtstart: dtstart,
	        tzid: tzid,
	        rrulevals: rrulevals,
	        rdatevals: rdatevals,
	        exrulevals: exrulevals,
	        exdatevals: exdatevals
	    };
	}
	function buildRule(s, options) {
	    var _a = parseInput(s, options), rrulevals = _a.rrulevals, rdatevals = _a.rdatevals, exrulevals = _a.exrulevals, exdatevals = _a.exdatevals, dtstart = _a.dtstart, tzid = _a.tzid;
	    var noCache = options.cache === false;
	    if (options.compatible) {
	        options.forceset = true;
	        options.unfold = true;
	    }
	    if (options.forceset ||
	        rrulevals.length > 1 ||
	        rdatevals.length ||
	        exrulevals.length ||
	        exdatevals.length) {
	        var rset_1 = new rruleset(noCache);
	        rset_1.tzid(tzid || undefined);
	        rrulevals.forEach(function (val) {
	            rset_1.rrule(new src_rrule(groomRruleOptions(val, dtstart, tzid), noCache));
	        });
	        rdatevals.forEach(function (date) {
	            rset_1.rdate(date);
	        });
	        exrulevals.forEach(function (val) {
	            rset_1.exrule(new src_rrule(groomRruleOptions(val, dtstart, tzid), noCache));
	        });
	        exdatevals.forEach(function (date) {
	            rset_1.exdate(date);
	        });
	        if (options.compatible && options.dtstart)
	            rset_1.rdate(dtstart);
	        return rset_1;
	    }
	    var val = rrulevals[0];
	    return new src_rrule(groomRruleOptions(val, val.dtstart || options.dtstart || dtstart, val.tzid || options.tzid || tzid), noCache);
	}
	function rrulestr(s, options) {
	    if (options === void 0) { options = {}; }
	    return buildRule(s, rrulestr_initializeOptions(options));
	}
	function groomRruleOptions(val, dtstart, tzid) {
	    return rrulestr_assign({}, val, { dtstart: dtstart,
	        tzid: tzid });
	}
	function rrulestr_initializeOptions(options) {
	    var invalid = [];
	    var keys = Object.keys(options);
	    var defaultKeys = Object.keys(rrulestr_DEFAULT_OPTIONS);
	    keys.forEach(function (key) {
	        if (!Object(helpers["c" /* includes */])(defaultKeys, key))
	            invalid.push(key);
	    });
	    if (invalid.length) {
	        throw new Error('Invalid options: ' + invalid.join(', '));
	    }
	    var initializedOptions = rrulestr_assign({}, options);
	    // Merge in default options
	    defaultKeys.forEach(function (key) {
	        if (!Object(helpers["c" /* includes */])(keys, key))
	            initializedOptions[key] = rrulestr_DEFAULT_OPTIONS[key];
	    });
	    return initializedOptions;
	}
	function extractName(line) {
	    if (line.indexOf(':') === -1) {
	        return {
	            name: 'RRULE',
	            value: line
	        };
	    }
	    var _a = Object(helpers["l" /* split */])(line, ':', 1), name = _a[0], value = _a[1];
	    return {
	        name: name,
	        value: value
	    };
	}
	function breakDownLine(line) {
	    var _a = extractName(line), name = _a.name, value = _a.value;
	    var parms = name.split(';');
	    if (!parms)
	        throw new Error('empty property name');
	    return {
	        name: parms[0].toUpperCase(),
	        parms: parms.slice(1),
	        value: value
	    };
	}
	function splitIntoLines(s, unfold) {
	    if (unfold === void 0) { unfold = false; }
	    s = s && s.trim();
	    if (!s)
	        throw new Error('Invalid empty string');
	    // More info about 'unfold' option
	    // Go head to http://www.ietf.org/rfc/rfc2445.txt
	    if (!unfold) {
	        return s.split(/\s/);
	    }
	    var lines = s.split('\n');
	    var i = 0;
	    while (i < lines.length) {
	        // TODO
	        var line = (lines[i] = lines[i].replace(/\s+$/g, ''));
	        if (!line) {
	            lines.splice(i, 1);
	        }
	        else if (i > 0 && line[0] === ' ') {
	            lines[i - 1] += line.slice(1);
	            lines.splice(i, 1);
	        }
	        else {
	            i += 1;
	        }
	    }
	    return lines;
	}
	function validateDateParm(parms) {
	    parms.forEach(function (parm) {
	        if (!/(VALUE=DATE(-TIME)?)|(TZID=)/.test(parm)) {
	            throw new Error('unsupported RDATE/EXDATE parm: ' + parm);
	        }
	    });
	}
	function parseRDate(rdateval, parms) {
	    validateDateParm(parms);
	    return rdateval
	        .split(',')
	        .map(function (datestr) { return src_dateutil.untilStringToDate(datestr); });
	}
	
	// CONCATENATED MODULE: ./src/index.ts
	/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Frequency", function() { return Frequency; });
	/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Weekday", function() { return Weekday; });
	/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "RRule", function() { return src_rrule; });
	/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "RRuleSet", function() { return rruleset; });
	/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "rrulestr", function() { return rrulestr; });
	/*!
	 * rrule.js - Library for working with recurrence rules for calendar dates.
	 * https://github.com/jakubroztocil/rrule
	 *
	 * Copyright 2010, Jakub Roztocil and Lars Schoning
	 * Licenced under the BSD licence.
	 * https://github.com/jakubroztocil/rrule/blob/master/LICENCE
	 *
	 * Based on:
	 * python-dateutil - Extensions to the standard Python datetime module.
	 * Copyright (c) 2003-2011 - Gustavo Niemeyer <gustavo@niemeyer.net>
	 * Copyright (c) 2012 - Tomi Pieviläinen <tomi.pievilainen@iki.fi>
	 * https://github.com/jakubroztocil/rrule/blob/master/LICENCE
	 *
	 */
	
	
	
	
	
	// =============================================================================
	// Export
	// =============================================================================
	
	/* harmony default export */ var src = __webpack_exports__["default"] = (src_rrule);
	
	
	/***/ }),
	/* 2 */
	/***/ (function(module, exports) {
	
	module.exports = __WEBPACK_EXTERNAL_MODULE__2__;
	
	/***/ }),
	/* 3 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	
	// CONCATENATED MODULE: ./src/nlp/i18n.ts
	// =============================================================================
	// i18n
	// =============================================================================
	var ENGLISH = {
	    dayNames: [
	        'Sunday', 'Monday', 'Tuesday', 'Wednesday',
	        'Thursday', 'Friday', 'Saturday'
	    ],
	    monthNames: [
	        'January', 'February', 'March', 'April', 'May',
	        'June', 'July', 'August', 'September', 'October',
	        'November', 'December'
	    ],
	    tokens: {
	        'SKIP': /^[ \r\n\t]+|^\.$/,
	        'number': /^[1-9][0-9]*/,
	        'numberAsText': /^(one|two|three)/i,
	        'every': /^every/i,
	        'day(s)': /^days?/i,
	        'weekday(s)': /^weekdays?/i,
	        'week(s)': /^weeks?/i,
	        'hour(s)': /^hours?/i,
	        'minute(s)': /^minutes?/i,
	        'month(s)': /^months?/i,
	        'year(s)': /^years?/i,
	        'on': /^(on|in)/i,
	        'at': /^(at)/i,
	        'the': /^the/i,
	        'first': /^first/i,
	        'second': /^second/i,
	        'third': /^third/i,
	        'nth': /^([1-9][0-9]*)(\.|th|nd|rd|st)/i,
	        'last': /^last/i,
	        'for': /^for/i,
	        'time(s)': /^times?/i,
	        'until': /^(un)?til/i,
	        'monday': /^mo(n(day)?)?/i,
	        'tuesday': /^tu(e(s(day)?)?)?/i,
	        'wednesday': /^we(d(n(esday)?)?)?/i,
	        'thursday': /^th(u(r(sday)?)?)?/i,
	        'friday': /^fr(i(day)?)?/i,
	        'saturday': /^sa(t(urday)?)?/i,
	        'sunday': /^su(n(day)?)?/i,
	        'january': /^jan(uary)?/i,
	        'february': /^feb(ruary)?/i,
	        'march': /^mar(ch)?/i,
	        'april': /^apr(il)?/i,
	        'may': /^may/i,
	        'june': /^june?/i,
	        'july': /^july?/i,
	        'august': /^aug(ust)?/i,
	        'september': /^sep(t(ember)?)?/i,
	        'october': /^oct(ober)?/i,
	        'november': /^nov(ember)?/i,
	        'december': /^dec(ember)?/i,
	        'comma': /^(,\s*|(and|or)\s*)+/i
	    }
	};
	/* harmony default export */ var i18n = (ENGLISH);
	
	// EXTERNAL MODULE: ./src/index.ts + 22 modules
	var src = __webpack_require__(1);
	
	// EXTERNAL MODULE: ./src/helpers.ts
	var helpers = __webpack_require__(0);
	
	// CONCATENATED MODULE: ./src/nlp/totext.ts
	
	
	
	// =============================================================================
	// Helper functions
	// =============================================================================
	/**
	 * Return true if a value is in an array
	 */
	var contains = function (arr, val) {
	    return arr.indexOf(val) !== -1;
	};
	var defaultGetText = function (id) { return id.toString(); };
	/**
	 *
	 * @param {RRule} rrule
	 * Optional:
	 * @param {Function} gettext function
	 * @param {Object} language definition
	 * @constructor
	 */
	var totext_ToText = /** @class */ (function () {
	    function ToText(rrule, gettext, language) {
	        if (gettext === void 0) { gettext = defaultGetText; }
	        if (language === void 0) { language = i18n; }
	        this.text = [];
	        this.language = language || i18n;
	        this.gettext = gettext;
	        this.rrule = rrule;
	        this.options = rrule.options;
	        this.origOptions = rrule.origOptions;
	        if (this.origOptions.bymonthday) {
	            var bymonthday = [].concat(this.options.bymonthday);
	            var bynmonthday = [].concat(this.options.bynmonthday);
	            bymonthday.sort(function (a, b) { return a - b; });
	            bynmonthday.sort(function (a, b) { return b - a; });
	            // 1, 2, 3, .., -5, -4, -3, ..
	            this.bymonthday = bymonthday.concat(bynmonthday);
	            if (!this.bymonthday.length)
	                this.bymonthday = null;
	        }
	        if (Object(helpers["f" /* isPresent */])(this.origOptions.byweekday)) {
	            var byweekday = !Object(helpers["d" /* isArray */])(this.origOptions.byweekday)
	                ? [this.origOptions.byweekday]
	                : this.origOptions.byweekday;
	            var days = String(byweekday);
	            this.byweekday = {
	                allWeeks: byweekday.filter(function (weekday) {
	                    return !weekday.n;
	                }),
	                someWeeks: byweekday.filter(function (weekday) {
	                    return Boolean(weekday.n);
	                }),
	                isWeekdays: days.indexOf('MO') !== -1 &&
	                    days.indexOf('TU') !== -1 &&
	                    days.indexOf('WE') !== -1 &&
	                    days.indexOf('TH') !== -1 &&
	                    days.indexOf('FR') !== -1 &&
	                    days.indexOf('SA') === -1 &&
	                    days.indexOf('SU') === -1,
	                isEveryDay: days.indexOf('MO') !== -1 &&
	                    days.indexOf('TU') !== -1 &&
	                    days.indexOf('WE') !== -1 &&
	                    days.indexOf('TH') !== -1 &&
	                    days.indexOf('FR') !== -1 &&
	                    days.indexOf('SA') !== -1 &&
	                    days.indexOf('SU') !== -1
	            };
	            var sortWeekDays = function (a, b) {
	                return a.weekday - b.weekday;
	            };
	            this.byweekday.allWeeks.sort(sortWeekDays);
	            this.byweekday.someWeeks.sort(sortWeekDays);
	            if (!this.byweekday.allWeeks.length)
	                this.byweekday.allWeeks = null;
	            if (!this.byweekday.someWeeks.length)
	                this.byweekday.someWeeks = null;
	        }
	        else {
	            this.byweekday = null;
	        }
	    }
	    /**
	     * Test whether the rrule can be fully converted to text.
	     * @param {RRule} rrule
	     * @return {Boolean}
	     */
	    ToText.isFullyConvertible = function (rrule) {
	        var canConvert = true;
	        if (!(rrule.options.freq in ToText.IMPLEMENTED))
	            return false;
	        if (rrule.origOptions.until && rrule.origOptions.count)
	            return false;
	        for (var key in rrule.origOptions) {
	            if (contains(['dtstart', 'wkst', 'freq'], key))
	                return true;
	            if (!contains(ToText.IMPLEMENTED[rrule.options.freq], key))
	                return false;
	        }
	        return canConvert;
	    };
	    ToText.prototype.isFullyConvertible = function () {
	        return ToText.isFullyConvertible(this.rrule);
	    };
	    /**
	     * Perform the conversion. Only some of the frequencies are supported.
	     * If some of the rrule's options aren't supported, they'll
	     * be omitted from the output an "(~ approximate)" will be appended.
	     * @return {*}
	     */
	    ToText.prototype.toString = function () {
	        var gettext = this.gettext;
	        if (!(this.options.freq in ToText.IMPLEMENTED)) {
	            return gettext('RRule error: Unable to fully convert this rrule to text');
	        }
	        this.text = [gettext('every')];
	        // @ts-ignore
	        this[src["default"].FREQUENCIES[this.options.freq]]();
	        if (this.options.until) {
	            this.add(gettext('until'));
	            var until = this.options.until;
	            this.add(this.language.monthNames[until.getUTCMonth()])
	                .add(until.getUTCDate() + ',')
	                .add(until.getUTCFullYear().toString());
	        }
	        else if (this.options.count) {
	            this.add(gettext('for'))
	                .add(this.options.count.toString())
	                .add(this.plural(this.options.count) ? gettext('times') : gettext('time'));
	        }
	        if (!this.isFullyConvertible())
	            this.add(gettext('(~ approximate)'));
	        return this.text.join('');
	    };
	    ToText.prototype.HOURLY = function () {
	        var gettext = this.gettext;
	        if (this.options.interval !== 1)
	            this.add(this.options.interval.toString());
	        this.add(this.plural(this.options.interval) ? gettext('hours') : gettext('hour'));
	    };
	    ToText.prototype.MINUTELY = function () {
	        var gettext = this.gettext;
	        if (this.options.interval !== 1)
	            this.add(this.options.interval.toString());
	        this.add(this.plural(this.options.interval)
	            ? gettext('minutes')
	            : gettext('minutes'));
	    };
	    ToText.prototype.DAILY = function () {
	        var gettext = this.gettext;
	        if (this.options.interval !== 1)
	            this.add(this.options.interval.toString());
	        if (this.byweekday && this.byweekday.isWeekdays) {
	            this.add(this.plural(this.options.interval)
	                ? gettext('weekdays')
	                : gettext('weekday'));
	        }
	        else {
	            this.add(this.plural(this.options.interval) ? gettext('days') : gettext('day'));
	        }
	        if (this.origOptions.bymonth) {
	            this.add(gettext('in'));
	            this._bymonth();
	        }
	        if (this.bymonthday) {
	            this._bymonthday();
	        }
	        else if (this.byweekday) {
	            this._byweekday();
	        }
	        else if (this.origOptions.byhour) {
	            this._byhour();
	        }
	    };
	    ToText.prototype.WEEKLY = function () {
	        var gettext = this.gettext;
	        if (this.options.interval !== 1) {
	            this.add(this.options.interval.toString()).add(this.plural(this.options.interval) ? gettext('weeks') : gettext('week'));
	        }
	        if (this.byweekday && this.byweekday.isWeekdays) {
	            if (this.options.interval === 1) {
	                this.add(this.plural(this.options.interval)
	                    ? gettext('weekdays')
	                    : gettext('weekday'));
	            }
	            else {
	                this.add(gettext('on')).add(gettext('weekdays'));
	            }
	        }
	        else if (this.byweekday && this.byweekday.isEveryDay) {
	            this.add(this.plural(this.options.interval) ? gettext('days') : gettext('day'));
	        }
	        else {
	            if (this.options.interval === 1)
	                this.add(gettext('week'));
	            if (this.origOptions.bymonth) {
	                this.add(gettext('in'));
	                this._bymonth();
	            }
	            if (this.bymonthday) {
	                this._bymonthday();
	            }
	            else if (this.byweekday) {
	                this._byweekday();
	            }
	        }
	    };
	    ToText.prototype.MONTHLY = function () {
	        var gettext = this.gettext;
	        if (this.origOptions.bymonth) {
	            if (this.options.interval !== 1) {
	                this.add(this.options.interval.toString()).add(gettext('months'));
	                if (this.plural(this.options.interval))
	                    this.add(gettext('in'));
	            }
	            else {
	                // this.add(gettext('MONTH'))
	            }
	            this._bymonth();
	        }
	        else {
	            if (this.options.interval !== 1)
	                this.add(this.options.interval.toString());
	            this.add(this.plural(this.options.interval)
	                ? gettext('months')
	                : gettext('month'));
	        }
	        if (this.bymonthday) {
	            this._bymonthday();
	        }
	        else if (this.byweekday && this.byweekday.isWeekdays) {
	            this.add(gettext('on')).add(gettext('weekdays'));
	        }
	        else if (this.byweekday) {
	            this._byweekday();
	        }
	    };
	    ToText.prototype.YEARLY = function () {
	        var gettext = this.gettext;
	        if (this.origOptions.bymonth) {
	            if (this.options.interval !== 1) {
	                this.add(this.options.interval.toString());
	                this.add(gettext('years'));
	            }
	            else {
	                // this.add(gettext('YEAR'))
	            }
	            this._bymonth();
	        }
	        else {
	            if (this.options.interval !== 1)
	                this.add(this.options.interval.toString());
	            this.add(this.plural(this.options.interval) ? gettext('years') : gettext('year'));
	        }
	        if (this.bymonthday) {
	            this._bymonthday();
	        }
	        else if (this.byweekday) {
	            this._byweekday();
	        }
	        if (this.options.byyearday) {
	            this.add(gettext('on the'))
	                .add(this.list(this.options.byyearday, this.nth, gettext('and')))
	                .add(gettext('day'));
	        }
	        if (this.options.byweekno) {
	            this.add(gettext('in'))
	                .add(this.plural(this.options.byweekno.length)
	                ? gettext('weeks')
	                : gettext('week'))
	                .add(this.list(this.options.byweekno, undefined, gettext('and')));
	        }
	    };
	    ToText.prototype._bymonthday = function () {
	        var gettext = this.gettext;
	        if (this.byweekday && this.byweekday.allWeeks) {
	            this.add(gettext('on'))
	                .add(this.list(this.byweekday.allWeeks, this.weekdaytext, gettext('or')))
	                .add(gettext('the'))
	                .add(this.list(this.bymonthday, this.nth, gettext('or')));
	        }
	        else {
	            this.add(gettext('on the')).add(this.list(this.bymonthday, this.nth, gettext('and')));
	        }
	        // this.add(gettext('DAY'))
	    };
	    ToText.prototype._byweekday = function () {
	        var gettext = this.gettext;
	        if (this.byweekday.allWeeks && !this.byweekday.isWeekdays) {
	            this.add(gettext('on')).add(this.list(this.byweekday.allWeeks, this.weekdaytext));
	        }
	        if (this.byweekday.someWeeks) {
	            if (this.byweekday.allWeeks)
	                this.add(gettext('and'));
	            this.add(gettext('on the')).add(this.list(this.byweekday.someWeeks, this.weekdaytext, gettext('and')));
	        }
	    };
	    ToText.prototype._byhour = function () {
	        var gettext = this.gettext;
	        this.add(gettext('at')).add(this.list(this.origOptions.byhour, undefined, gettext('and')));
	    };
	    ToText.prototype._bymonth = function () {
	        this.add(this.list(this.options.bymonth, this.monthtext, this.gettext('and')));
	    };
	    ToText.prototype.nth = function (n) {
	        n = parseInt(n.toString(), 10);
	        var nth;
	        var npos;
	        var gettext = this.gettext;
	        if (n === -1)
	            return gettext('last');
	        npos = Math.abs(n);
	        switch (npos) {
	            case 1:
	            case 21:
	            case 31:
	                nth = npos + gettext('st');
	                break;
	            case 2:
	            case 22:
	                nth = npos + gettext('nd');
	                break;
	            case 3:
	            case 23:
	                nth = npos + gettext('rd');
	                break;
	            default:
	                nth = npos + gettext('th');
	        }
	        return n < 0 ? nth + ' ' + gettext('last') : nth;
	    };
	    ToText.prototype.monthtext = function (m) {
	        return this.language.monthNames[m - 1];
	    };
	    ToText.prototype.weekdaytext = function (wday) {
	        var weekday = Object(helpers["e" /* isNumber */])(wday) ? (wday + 1) % 7 : wday.getJsWeekday();
	        return ((wday.n ? this.nth(wday.n) + ' ' : '') + this.language.dayNames[weekday]);
	    };
	    ToText.prototype.plural = function (n) {
	        return n % 100 !== 1;
	    };
	    ToText.prototype.add = function (s) {
	        this.text.push(' ');
	        this.text.push(s);
	        return this;
	    };
	    ToText.prototype.list = function (arr, callback, finalDelim, delim) {
	        if (delim === void 0) { delim = ','; }
	        if (!Object(helpers["d" /* isArray */])(arr)) {
	            arr = [arr];
	        }
	        var delimJoin = function (array, delimiter, finalDelimiter) {
	            var list = '';
	            for (var i = 0; i < array.length; i++) {
	                if (i !== 0) {
	                    if (i === array.length - 1) {
	                        list += ' ' + finalDelimiter + ' ';
	                    }
	                    else {
	                        list += delimiter + ' ';
	                    }
	                }
	                list += array[i];
	            }
	            return list;
	        };
	        callback =
	            callback ||
	                function (o) {
	                    return o.toString();
	                };
	        var self = this;
	        var realCallback = function (arg) {
	            return callback && callback.call(self, arg);
	        };
	        if (finalDelim) {
	            return delimJoin(arr.map(realCallback), delim, finalDelim);
	        }
	        else {
	            return arr.map(realCallback).join(delim + ' ');
	        }
	    };
	    return ToText;
	}());
	/* harmony default export */ var totext = (totext_ToText);
	
	// CONCATENATED MODULE: ./src/nlp/parsetext.ts
	
	
	// =============================================================================
	// Parser
	// =============================================================================
	var Parser = /** @class */ (function () {
	    function Parser(rules) {
	        this.done = true;
	        this.rules = rules;
	    }
	    Parser.prototype.start = function (text) {
	        this.text = text;
	        this.done = false;
	        return this.nextSymbol();
	    };
	    Parser.prototype.isDone = function () {
	        return this.done && this.symbol === null;
	    };
	    Parser.prototype.nextSymbol = function () {
	        var best;
	        var bestSymbol;
	        var p = this;
	        this.symbol = null;
	        this.value = null;
	        do {
	            if (this.done)
	                return false;
	            var rule = void 0;
	            best = null;
	            for (var name_1 in this.rules) {
	                rule = this.rules[name_1];
	                var match = rule.exec(p.text);
	                if (match) {
	                    if (best === null || match[0].length > best[0].length) {
	                        best = match;
	                        bestSymbol = name_1;
	                    }
	                }
	            }
	            if (best != null) {
	                this.text = this.text.substr(best[0].length);
	                if (this.text === '')
	                    this.done = true;
	            }
	            if (best == null) {
	                this.done = true;
	                this.symbol = null;
	                this.value = null;
	                return;
	            }
	            // @ts-ignore
	        } while (bestSymbol === 'SKIP');
	        // @ts-ignore
	        this.symbol = bestSymbol;
	        this.value = best;
	        return true;
	    };
	    Parser.prototype.accept = function (name) {
	        if (this.symbol === name) {
	            if (this.value) {
	                var v = this.value;
	                this.nextSymbol();
	                return v;
	            }
	            this.nextSymbol();
	            return true;
	        }
	        return false;
	    };
	    Parser.prototype.acceptNumber = function () {
	        return this.accept('number');
	    };
	    Parser.prototype.expect = function (name) {
	        if (this.accept(name))
	            return true;
	        throw new Error('expected ' + name + ' but found ' + this.symbol);
	    };
	    return Parser;
	}());
	function parseText(text, language) {
	    if (language === void 0) { language = i18n; }
	    var options = {};
	    var ttr = new Parser(language.tokens);
	    if (!ttr.start(text))
	        return null;
	    S();
	    return options;
	    function S() {
	        // every [n]
	        ttr.expect('every');
	        var n = ttr.acceptNumber();
	        if (n)
	            options.interval = parseInt(n[0], 10);
	        if (ttr.isDone())
	            throw new Error('Unexpected end');
	        switch (ttr.symbol) {
	            case 'day(s)':
	                options.freq = src["default"].DAILY;
	                if (ttr.nextSymbol()) {
	                    AT();
	                    F();
	                }
	                break;
	            // FIXME Note: every 2 weekdays != every two weeks on weekdays.
	            // DAILY on weekdays is not a valid rule
	            case 'weekday(s)':
	                options.freq = src["default"].WEEKLY;
	                options.byweekday = [
	                    src["default"].MO,
	                    src["default"].TU,
	                    src["default"].WE,
	                    src["default"].TH,
	                    src["default"].FR
	                ];
	                ttr.nextSymbol();
	                F();
	                break;
	            case 'week(s)':
	                options.freq = src["default"].WEEKLY;
	                if (ttr.nextSymbol()) {
	                    ON();
	                    F();
	                }
	                break;
	            case 'hour(s)':
	                options.freq = src["default"].HOURLY;
	                if (ttr.nextSymbol()) {
	                    ON();
	                    F();
	                }
	                break;
	            case 'minute(s)':
	                options.freq = src["default"].MINUTELY;
	                if (ttr.nextSymbol()) {
	                    ON();
	                    F();
	                }
	                break;
	            case 'month(s)':
	                options.freq = src["default"].MONTHLY;
	                if (ttr.nextSymbol()) {
	                    ON();
	                    F();
	                }
	                break;
	            case 'year(s)':
	                options.freq = src["default"].YEARLY;
	                if (ttr.nextSymbol()) {
	                    ON();
	                    F();
	                }
	                break;
	            case 'monday':
	            case 'tuesday':
	            case 'wednesday':
	            case 'thursday':
	            case 'friday':
	            case 'saturday':
	            case 'sunday':
	                options.freq = src["default"].WEEKLY;
	                var key = ttr.symbol.substr(0, 2).toUpperCase();
	                options.byweekday = [src["default"][key]];
	                if (!ttr.nextSymbol())
	                    return;
	                // TODO check for duplicates
	                while (ttr.accept('comma')) {
	                    if (ttr.isDone())
	                        throw new Error('Unexpected end');
	                    var wkd = decodeWKD();
	                    if (!wkd) {
	                        throw new Error('Unexpected symbol ' + ttr.symbol + ', expected weekday');
	                    }
	                    // @ts-ignore
	                    options.byweekday.push(src["default"][wkd]);
	                    ttr.nextSymbol();
	                }
	                MDAYs();
	                F();
	                break;
	            case 'january':
	            case 'february':
	            case 'march':
	            case 'april':
	            case 'may':
	            case 'june':
	            case 'july':
	            case 'august':
	            case 'september':
	            case 'october':
	            case 'november':
	            case 'december':
	                options.freq = src["default"].YEARLY;
	                options.bymonth = [decodeM()];
	                if (!ttr.nextSymbol())
	                    return;
	                // TODO check for duplicates
	                while (ttr.accept('comma')) {
	                    if (ttr.isDone())
	                        throw new Error('Unexpected end');
	                    var m = decodeM();
	                    if (!m) {
	                        throw new Error('Unexpected symbol ' + ttr.symbol + ', expected month');
	                    }
	                    options.bymonth.push(m);
	                    ttr.nextSymbol();
	                }
	                ON();
	                F();
	                break;
	            default:
	                throw new Error('Unknown symbol');
	        }
	    }
	    function ON() {
	        var on = ttr.accept('on');
	        var the = ttr.accept('the');
	        if (!(on || the))
	            return;
	        do {
	            var nth = decodeNTH();
	            var wkd = decodeWKD();
	            var m = decodeM();
	            // nth <weekday> | <weekday>
	            if (nth) {
	                // ttr.nextSymbol()
	                if (wkd) {
	                    ttr.nextSymbol();
	                    if (!options.byweekday)
	                        options.byweekday = [];
	                    // @ts-ignore
	                    options.byweekday.push(src["default"][wkd].nth(nth));
	                }
	                else {
	                    if (!options.bymonthday)
	                        options.bymonthday = [];
	                    // @ts-ignore
	                    options.bymonthday.push(nth);
	                    ttr.accept('day(s)');
	                }
	                // <weekday>
	            }
	            else if (wkd) {
	                ttr.nextSymbol();
	                if (!options.byweekday)
	                    options.byweekday = [];
	                // @ts-ignore
	                options.byweekday.push(src["default"][wkd]);
	            }
	            else if (ttr.symbol === 'weekday(s)') {
	                ttr.nextSymbol();
	                if (!options.byweekday) {
	                    options.byweekday = [
	                        src["default"].MO,
	                        src["default"].TU,
	                        src["default"].WE,
	                        src["default"].TH,
	                        src["default"].FR
	                    ];
	                }
	            }
	            else if (ttr.symbol === 'week(s)') {
	                ttr.nextSymbol();
	                var n = ttr.acceptNumber();
	                if (!n) {
	                    throw new Error('Unexpected symbol ' + ttr.symbol + ', expected week number');
	                }
	                options.byweekno = [parseInt(n[0], 10)];
	                while (ttr.accept('comma')) {
	                    n = ttr.acceptNumber();
	                    if (!n) {
	                        throw new Error('Unexpected symbol ' + ttr.symbol + '; expected monthday');
	                    }
	                    options.byweekno.push(parseInt(n[0], 10));
	                }
	            }
	            else if (m) {
	                ttr.nextSymbol();
	                if (!options.bymonth)
	                    options.bymonth = [];
	                // @ts-ignore
	                options.bymonth.push(m);
	            }
	            else {
	                return;
	            }
	        } while (ttr.accept('comma') || ttr.accept('the') || ttr.accept('on'));
	    }
	    function AT() {
	        var at = ttr.accept('at');
	        if (!at)
	            return;
	        do {
	            var n = ttr.acceptNumber();
	            if (!n) {
	                throw new Error('Unexpected symbol ' + ttr.symbol + ', expected hour');
	            }
	            options.byhour = [parseInt(n[0], 10)];
	            while (ttr.accept('comma')) {
	                n = ttr.acceptNumber();
	                if (!n) {
	                    throw new Error('Unexpected symbol ' + ttr.symbol + '; expected hour');
	                }
	                options.byhour.push(parseInt(n[0], 10));
	            }
	        } while (ttr.accept('comma') || ttr.accept('at'));
	    }
	    function decodeM() {
	        switch (ttr.symbol) {
	            case 'january':
	                return 1;
	            case 'february':
	                return 2;
	            case 'march':
	                return 3;
	            case 'april':
	                return 4;
	            case 'may':
	                return 5;
	            case 'june':
	                return 6;
	            case 'july':
	                return 7;
	            case 'august':
	                return 8;
	            case 'september':
	                return 9;
	            case 'october':
	                return 10;
	            case 'november':
	                return 11;
	            case 'december':
	                return 12;
	            default:
	                return false;
	        }
	    }
	    function decodeWKD() {
	        switch (ttr.symbol) {
	            case 'monday':
	            case 'tuesday':
	            case 'wednesday':
	            case 'thursday':
	            case 'friday':
	            case 'saturday':
	            case 'sunday':
	                return ttr.symbol.substr(0, 2).toUpperCase();
	            default:
	                return false;
	        }
	    }
	    function decodeNTH() {
	        switch (ttr.symbol) {
	            case 'last':
	                ttr.nextSymbol();
	                return -1;
	            case 'first':
	                ttr.nextSymbol();
	                return 1;
	            case 'second':
	                ttr.nextSymbol();
	                return ttr.accept('last') ? -2 : 2;
	            case 'third':
	                ttr.nextSymbol();
	                return ttr.accept('last') ? -3 : 3;
	            case 'nth':
	                var v = parseInt(ttr.value[1], 10);
	                if (v < -366 || v > 366)
	                    throw new Error('Nth out of range: ' + v);
	                ttr.nextSymbol();
	                return ttr.accept('last') ? -v : v;
	            default:
	                return false;
	        }
	    }
	    function MDAYs() {
	        ttr.accept('on');
	        ttr.accept('the');
	        var nth = decodeNTH();
	        if (!nth)
	            return;
	        options.bymonthday = [nth];
	        ttr.nextSymbol();
	        while (ttr.accept('comma')) {
	            nth = decodeNTH();
	            if (!nth) {
	                throw new Error('Unexpected symbol ' + ttr.symbol + '; expected monthday');
	            }
	            options.bymonthday.push(nth);
	            ttr.nextSymbol();
	        }
	    }
	    function F() {
	        if (ttr.symbol === 'until') {
	            var date = Date.parse(ttr.text);
	            if (!date)
	                throw new Error('Cannot parse until date:' + ttr.text);
	            options.until = new Date(date);
	        }
	        else if (ttr.accept('for')) {
	            options.count = parseInt(ttr.value[0], 10);
	            ttr.expect('number');
	            // ttr.expect('times')
	        }
	    }
	}
	
	// CONCATENATED MODULE: ./src/nlp/index.ts
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fromText", function() { return fromText; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isFullyConvertible", function() { return isFullyConvertible; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "toText", function() { return toText; });
	/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "parseText", function() { return parseText; });
	
	
	
	
	/*!
	* rrule.js - Library for working with recurrence rules for calendar dates.
	* https://github.com/jakubroztocil/rrule
	*
	* Copyright 2010, Jakub Roztocil and Lars Schoning
	* Licenced under the BSD licence.
	* https://github.com/jakubroztocil/rrule/blob/master/LICENCE
	*
	*/
	/**
	 *
	 * Implementation of RRule.fromText() and RRule::toText().
	 *
	 *
	 * On the client side, this file needs to be included
	 * when those functions are used.
	 *
	 */
	// =============================================================================
	// fromText
	// =============================================================================
	/**
	 * Will be able to convert some of the below described rules from
	 * text format to a rule object.
	 *
	 *
	 * RULES
	 *
	 * Every ([n])
	 *       day(s)
	 *     | [weekday], ..., (and) [weekday]
	 *     | weekday(s)
	 *     | week(s)
	 *     | month(s)
	 *     | [month], ..., (and) [month]
	 *     | year(s)
	 *
	 *
	 * Plus 0, 1, or multiple of these:
	 *
	 * on [weekday], ..., (or) [weekday] the [monthday], [monthday], ... (or) [monthday]
	 *
	 * on [weekday], ..., (and) [weekday]
	 *
	 * on the [monthday], [monthday], ... (and) [monthday] (day of the month)
	 *
	 * on the [nth-weekday], ..., (and) [nth-weekday] (of the month/year)
	 *
	 *
	 * Plus 0 or 1 of these:
	 *
	 * for [n] time(s)
	 *
	 * until [date]
	 *
	 * Plus (.)
	 *
	 *
	 * Definitely no supported for parsing:
	 *
	 * (for year):
	 *     in week(s) [n], ..., (and) [n]
	 *
	 *     on the [yearday], ..., (and) [n] day of the year
	 *     on day [yearday], ..., (and) [n]
	 *
	 *
	 * NON-TERMINALS
	 *
	 * [n]: 1, 2 ..., one, two, three ..
	 * [month]: January, February, March, April, May, ... December
	 * [weekday]: Monday, ... Sunday
	 * [nth-weekday]: first [weekday], 2nd [weekday], ... last [weekday], ...
	 * [monthday]: first, 1., 2., 1st, 2nd, second, ... 31st, last day, 2nd last day, ..
	 * [date]:
	 *     [month] (0-31(,) ([year])),
	 *     (the) 0-31.(1-12.([year])),
	 *     (the) 0-31/(1-12/([year])),
	 *     [weekday]
	 *
	 * [year]: 0000, 0001, ... 01, 02, ..
	 *
	 * Definitely not supported for parsing:
	 *
	 * [yearday]: first, 1., 2., 1st, 2nd, second, ... 366th, last day, 2nd last day, ..
	 *
	 * @param {String} text
	 * @return {Object, Boolean} the rule, or null.
	 */
	var fromText = function (text, language) {
	    if (language === void 0) { language = i18n; }
	    return new src["default"](parseText(text, language) || undefined);
	};
	var common = [
	    'count',
	    'until',
	    'interval',
	    'byweekday',
	    'bymonthday',
	    'bymonth'
	];
	totext.IMPLEMENTED = [];
	totext.IMPLEMENTED[src["default"].HOURLY] = common;
	totext.IMPLEMENTED[src["default"].MINUTELY] = common;
	totext.IMPLEMENTED[src["default"].DAILY] = ['byhour'].concat(common);
	totext.IMPLEMENTED[src["default"].WEEKLY] = common;
	totext.IMPLEMENTED[src["default"].MONTHLY] = common;
	totext.IMPLEMENTED[src["default"].YEARLY] = ['byweekno', 'byyearday'].concat(common);
	// =============================================================================
	// Export
	// =============================================================================
	var toText = function (rrule, gettext, language) {
	    return new totext(rrule, gettext, language).toString();
	};
	var isFullyConvertible = totext.isFullyConvertible;
	
	
	
	/***/ })
	/******/ ]);
	});
	//# sourceMappingURL=rrule.js.map

/***/ }),
/* 2260 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];
	    descriptor.enumerable = descriptor.enumerable || false;
	    descriptor.configurable = true;
	    if ("value" in descriptor) descriptor.writable = true;
	    Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
	  if (staticProps) _defineProperties(Constructor, staticProps);
	  return Constructor;
	}
	
	function _inheritsLoose(subClass, superClass) {
	  subClass.prototype = Object.create(superClass.prototype);
	  subClass.prototype.constructor = subClass;
	  subClass.__proto__ = superClass;
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };
	  return _getPrototypeOf(o);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;
	    return o;
	  };
	
	  return _setPrototypeOf(o, p);
	}
	
	function isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
	  if (Reflect.construct.sham) return false;
	  if (typeof Proxy === "function") return true;
	
	  try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
	    return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _construct(Parent, args, Class) {
	  if (isNativeReflectConstruct()) {
	    _construct = Reflect.construct;
	  } else {
	    _construct = function _construct(Parent, args, Class) {
	      var a = [null];
	      a.push.apply(a, args);
	      var Constructor = Function.bind.apply(Parent, a);
	      var instance = new Constructor();
	      if (Class) _setPrototypeOf(instance, Class.prototype);
	      return instance;
	    };
	  }
	
	  return _construct.apply(null, arguments);
	}
	
	function _isNativeFunction(fn) {
	  return Function.toString.call(fn).indexOf("[native code]") !== -1;
	}
	
	function _wrapNativeSuper(Class) {
	  var _cache = typeof Map === "function" ? new Map() : undefined;
	
	  _wrapNativeSuper = function _wrapNativeSuper(Class) {
	    if (Class === null || !_isNativeFunction(Class)) return Class;
	
	    if (typeof Class !== "function") {
	      throw new TypeError("Super expression must either be null or a function");
	    }
	
	    if (typeof _cache !== "undefined") {
	      if (_cache.has(Class)) return _cache.get(Class);
	
	      _cache.set(Class, Wrapper);
	    }
	
	    function Wrapper() {
	      return _construct(Class, arguments, _getPrototypeOf(this).constructor);
	    }
	
	    Wrapper.prototype = Object.create(Class.prototype, {
	      constructor: {
	        value: Wrapper,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	    return _setPrototypeOf(Wrapper, Class);
	  };
	
	  return _wrapNativeSuper(Class);
	}
	
	// these aren't really private, but nor are they really useful to document
	
	/**
	 * @private
	 */
	var LuxonError =
	/*#__PURE__*/
	function (_Error) {
	  _inheritsLoose(LuxonError, _Error);
	
	  function LuxonError() {
	    return _Error.apply(this, arguments) || this;
	  }
	
	  return LuxonError;
	}(_wrapNativeSuper(Error));
	/**
	 * @private
	 */
	
	
	var InvalidDateTimeError =
	/*#__PURE__*/
	function (_LuxonError) {
	  _inheritsLoose(InvalidDateTimeError, _LuxonError);
	
	  function InvalidDateTimeError(reason) {
	    return _LuxonError.call(this, "Invalid DateTime: " + reason.toMessage()) || this;
	  }
	
	  return InvalidDateTimeError;
	}(LuxonError);
	/**
	 * @private
	 */
	
	var InvalidIntervalError =
	/*#__PURE__*/
	function (_LuxonError2) {
	  _inheritsLoose(InvalidIntervalError, _LuxonError2);
	
	  function InvalidIntervalError(reason) {
	    return _LuxonError2.call(this, "Invalid Interval: " + reason.toMessage()) || this;
	  }
	
	  return InvalidIntervalError;
	}(LuxonError);
	/**
	 * @private
	 */
	
	var InvalidDurationError =
	/*#__PURE__*/
	function (_LuxonError3) {
	  _inheritsLoose(InvalidDurationError, _LuxonError3);
	
	  function InvalidDurationError(reason) {
	    return _LuxonError3.call(this, "Invalid Duration: " + reason.toMessage()) || this;
	  }
	
	  return InvalidDurationError;
	}(LuxonError);
	/**
	 * @private
	 */
	
	var ConflictingSpecificationError =
	/*#__PURE__*/
	function (_LuxonError4) {
	  _inheritsLoose(ConflictingSpecificationError, _LuxonError4);
	
	  function ConflictingSpecificationError() {
	    return _LuxonError4.apply(this, arguments) || this;
	  }
	
	  return ConflictingSpecificationError;
	}(LuxonError);
	/**
	 * @private
	 */
	
	var InvalidUnitError =
	/*#__PURE__*/
	function (_LuxonError5) {
	  _inheritsLoose(InvalidUnitError, _LuxonError5);
	
	  function InvalidUnitError(unit) {
	    return _LuxonError5.call(this, "Invalid unit " + unit) || this;
	  }
	
	  return InvalidUnitError;
	}(LuxonError);
	/**
	 * @private
	 */
	
	var InvalidArgumentError =
	/*#__PURE__*/
	function (_LuxonError6) {
	  _inheritsLoose(InvalidArgumentError, _LuxonError6);
	
	  function InvalidArgumentError() {
	    return _LuxonError6.apply(this, arguments) || this;
	  }
	
	  return InvalidArgumentError;
	}(LuxonError);
	/**
	 * @private
	 */
	
	var ZoneIsAbstractError =
	/*#__PURE__*/
	function (_LuxonError7) {
	  _inheritsLoose(ZoneIsAbstractError, _LuxonError7);
	
	  function ZoneIsAbstractError() {
	    return _LuxonError7.call(this, "Zone is an abstract class") || this;
	  }
	
	  return ZoneIsAbstractError;
	}(LuxonError);
	
	/*
	  This is just a junk drawer, containing anything used across multiple classes.
	  Because Luxon is small(ish), this should stay small and we won't worry about splitting
	  it up into, say, parsingUtil.js and basicUtil.js and so on. But they are divided up by feature area.
	*/
	/**
	 * @private
	 */
	// TYPES
	
	function isUndefined(o) {
	  return typeof o === "undefined";
	}
	function isNumber(o) {
	  return typeof o === "number";
	}
	function isString(o) {
	  return typeof o === "string";
	}
	function isDate(o) {
	  return Object.prototype.toString.call(o) === "[object Date]";
	} // CAPABILITIES
	
	function hasIntl() {
	  return typeof Intl !== "undefined" && Intl.DateTimeFormat;
	}
	function hasFormatToParts() {
	  return !isUndefined(Intl.DateTimeFormat.prototype.formatToParts);
	}
	function hasRelative() {
	  return typeof Intl !== "undefined" && !!Intl.RelativeTimeFormat;
	} // OBJECTS AND ARRAYS
	
	function maybeArray(thing) {
	  return Array.isArray(thing) ? thing : [thing];
	}
	function bestBy(arr, by, compare) {
	  if (arr.length === 0) {
	    return undefined;
	  }
	
	  return arr.reduce(function (best, next) {
	    var pair = [by(next), next];
	
	    if (!best) {
	      return pair;
	    } else if (compare(best[0], pair[0]) === best[0]) {
	      return best;
	    } else {
	      return pair;
	    }
	  }, null)[1];
	}
	function pick(obj, keys) {
	  return keys.reduce(function (a, k) {
	    a[k] = obj[k];
	    return a;
	  }, {});
	} // NUMBERS AND STRINGS
	
	function numberBetween(thing, bottom, top) {
	  return isNumber(thing) && thing >= bottom && thing <= top;
	} // x % n but takes the sign of n instead of x
	
	function floorMod(x, n) {
	  return x - n * Math.floor(x / n);
	}
	function padStart(input, n) {
	  if (n === void 0) {
	    n = 2;
	  }
	
	  if (input.toString().length < n) {
	    return ("0".repeat(n) + input).slice(-n);
	  } else {
	    return input.toString();
	  }
	}
	function parseInteger(string) {
	  if (isUndefined(string) || string === null || string === "") {
	    return undefined;
	  } else {
	    return parseInt(string, 10);
	  }
	}
	function parseMillis(fraction) {
	  // Return undefined (instead of 0) in these cases, where fraction is not set
	  if (isUndefined(fraction) || fraction === null || fraction === "") {
	    return undefined;
	  } else {
	    var f = parseFloat("0." + fraction) * 1000;
	    return Math.floor(f);
	  }
	}
	function roundTo(number, digits, towardZero) {
	  if (towardZero === void 0) {
	    towardZero = false;
	  }
	
	  var factor = Math.pow(10, digits),
	      rounder = towardZero ? Math.trunc : Math.round;
	  return rounder(number * factor) / factor;
	} // DATE BASICS
	
	function isLeapYear(year) {
	  return year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0);
	}
	function daysInYear(year) {
	  return isLeapYear(year) ? 366 : 365;
	}
	function daysInMonth(year, month) {
	  var modMonth = floorMod(month - 1, 12) + 1,
	      modYear = year + (month - modMonth) / 12;
	
	  if (modMonth === 2) {
	    return isLeapYear(modYear) ? 29 : 28;
	  } else {
	    return [31, null, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31][modMonth - 1];
	  }
	} // covert a calendar object to a local timestamp (epoch, but with the offset baked in)
	
	function objToLocalTS(obj) {
	  var d = Date.UTC(obj.year, obj.month - 1, obj.day, obj.hour, obj.minute, obj.second, obj.millisecond); // for legacy reasons, years between 0 and 99 are interpreted as 19XX; revert that
	
	  if (obj.year < 100 && obj.year >= 0) {
	    d = new Date(d);
	    d.setUTCFullYear(d.getUTCFullYear() - 1900);
	  }
	
	  return +d;
	}
	function weeksInWeekYear(weekYear) {
	  var p1 = (weekYear + Math.floor(weekYear / 4) - Math.floor(weekYear / 100) + Math.floor(weekYear / 400)) % 7,
	      last = weekYear - 1,
	      p2 = (last + Math.floor(last / 4) - Math.floor(last / 100) + Math.floor(last / 400)) % 7;
	  return p1 === 4 || p2 === 3 ? 53 : 52;
	}
	function untruncateYear(year) {
	  if (year > 99) {
	    return year;
	  } else return year > 60 ? 1900 + year : 2000 + year;
	} // PARSING
	
	function parseZoneInfo(ts, offsetFormat, locale, timeZone) {
	  if (timeZone === void 0) {
	    timeZone = null;
	  }
	
	  var date = new Date(ts),
	      intlOpts = {
	    hour12: false,
	    year: "numeric",
	    month: "2-digit",
	    day: "2-digit",
	    hour: "2-digit",
	    minute: "2-digit"
	  };
	
	  if (timeZone) {
	    intlOpts.timeZone = timeZone;
	  }
	
	  var modified = Object.assign({
	    timeZoneName: offsetFormat
	  }, intlOpts),
	      intl = hasIntl();
	
	  if (intl && hasFormatToParts()) {
	    var parsed = new Intl.DateTimeFormat(locale, modified).formatToParts(date).find(function (m) {
	      return m.type.toLowerCase() === "timezonename";
	    });
	    return parsed ? parsed.value : null;
	  } else if (intl) {
	    // this probably doesn't work for all locales
	    var without = new Intl.DateTimeFormat(locale, intlOpts).format(date),
	        included = new Intl.DateTimeFormat(locale, modified).format(date),
	        diffed = included.substring(without.length),
	        trimmed = diffed.replace(/^[, \u200e]+/, "");
	    return trimmed;
	  } else {
	    return null;
	  }
	} // signedOffset('-5', '30') -> -330
	
	function signedOffset(offHourStr, offMinuteStr) {
	  var offHour = parseInt(offHourStr, 10) || 0,
	      offMin = parseInt(offMinuteStr, 10) || 0,
	      offMinSigned = offHour < 0 ? -offMin : offMin;
	  return offHour * 60 + offMinSigned;
	} // COERCION
	
	function asNumber(value) {
	  var numericValue = Number(value);
	  if (typeof value === "boolean" || value === "" || Number.isNaN(numericValue)) throw new InvalidArgumentError("Invalid unit value " + value);
	  return numericValue;
	}
	
	function normalizeObject(obj, normalizer, nonUnitKeys) {
	  var normalized = {};
	
	  for (var u in obj) {
	    if (obj.hasOwnProperty(u)) {
	      if (nonUnitKeys.indexOf(u) >= 0) continue;
	      var v = obj[u];
	      if (v === undefined || v === null) continue;
	      normalized[normalizer(u)] = asNumber(v);
	    }
	  }
	
	  return normalized;
	}
	function formatOffset(offset, format) {
	  var hours = Math.trunc(offset / 60),
	      minutes = Math.abs(offset % 60),
	      sign = hours >= 0 ? "+" : "-",
	      base = "" + sign + Math.abs(hours);
	
	  switch (format) {
	    case "short":
	      return "" + sign + padStart(Math.abs(hours), 2) + ":" + padStart(minutes, 2);
	
	    case "narrow":
	      return minutes > 0 ? base + ":" + minutes : base;
	
	    case "techie":
	      return "" + sign + padStart(Math.abs(hours), 2) + padStart(minutes, 2);
	
	    default:
	      throw new RangeError("Value format " + format + " is out of range for property format");
	  }
	}
	function timeObject(obj) {
	  return pick(obj, ["hour", "minute", "second", "millisecond"]);
	}
	var ianaRegex = /[A-Za-z_+-]{1,256}(:?\/[A-Za-z_+-]{1,256}(\/[A-Za-z_+-]{1,256})?)?/;
	
	/**
	 * @private
	 */
	var n = "numeric",
	    s = "short",
	    l = "long",
	    d2 = "2-digit";
	var DATE_SHORT = {
	  year: n,
	  month: n,
	  day: n
	};
	var DATE_MED = {
	  year: n,
	  month: s,
	  day: n
	};
	var DATE_FULL = {
	  year: n,
	  month: l,
	  day: n
	};
	var DATE_HUGE = {
	  year: n,
	  month: l,
	  day: n,
	  weekday: l
	};
	var TIME_SIMPLE = {
	  hour: n,
	  minute: d2
	};
	var TIME_WITH_SECONDS = {
	  hour: n,
	  minute: d2,
	  second: d2
	};
	var TIME_WITH_SHORT_OFFSET = {
	  hour: n,
	  minute: d2,
	  second: d2,
	  timeZoneName: s
	};
	var TIME_WITH_LONG_OFFSET = {
	  hour: n,
	  minute: d2,
	  second: d2,
	  timeZoneName: l
	};
	var TIME_24_SIMPLE = {
	  hour: n,
	  minute: d2,
	  hour12: false
	};
	/**
	 * {@link toLocaleString}; format like '09:30:23', always 24-hour.
	 */
	
	var TIME_24_WITH_SECONDS = {
	  hour: n,
	  minute: d2,
	  second: d2,
	  hour12: false
	};
	/**
	 * {@link toLocaleString}; format like '09:30:23 EDT', always 24-hour.
	 */
	
	var TIME_24_WITH_SHORT_OFFSET = {
	  hour: n,
	  minute: d2,
	  second: d2,
	  hour12: false,
	  timeZoneName: s
	};
	/**
	 * {@link toLocaleString}; format like '09:30:23 Eastern Daylight Time', always 24-hour.
	 */
	
	var TIME_24_WITH_LONG_OFFSET = {
	  hour: n,
	  minute: d2,
	  second: d2,
	  hour12: false,
	  timeZoneName: l
	};
	/**
	 * {@link toLocaleString}; format like '10/14/1983, 9:30 AM'. Only 12-hour if the locale is.
	 */
	
	var DATETIME_SHORT = {
	  year: n,
	  month: n,
	  day: n,
	  hour: n,
	  minute: d2
	};
	/**
	 * {@link toLocaleString}; format like '10/14/1983, 9:30:33 AM'. Only 12-hour if the locale is.
	 */
	
	var DATETIME_SHORT_WITH_SECONDS = {
	  year: n,
	  month: n,
	  day: n,
	  hour: n,
	  minute: d2,
	  second: d2
	};
	var DATETIME_MED = {
	  year: n,
	  month: s,
	  day: n,
	  hour: n,
	  minute: d2
	};
	var DATETIME_MED_WITH_SECONDS = {
	  year: n,
	  month: s,
	  day: n,
	  hour: n,
	  minute: d2,
	  second: d2
	};
	var DATETIME_FULL = {
	  year: n,
	  month: l,
	  day: n,
	  hour: n,
	  minute: d2,
	  timeZoneName: s
	};
	var DATETIME_FULL_WITH_SECONDS = {
	  year: n,
	  month: l,
	  day: n,
	  hour: n,
	  minute: d2,
	  second: d2,
	  timeZoneName: s
	};
	var DATETIME_HUGE = {
	  year: n,
	  month: l,
	  day: n,
	  weekday: l,
	  hour: n,
	  minute: d2,
	  timeZoneName: l
	};
	var DATETIME_HUGE_WITH_SECONDS = {
	  year: n,
	  month: l,
	  day: n,
	  weekday: l,
	  hour: n,
	  minute: d2,
	  second: d2,
	  timeZoneName: l
	};
	
	function stringify(obj) {
	  return JSON.stringify(obj, Object.keys(obj).sort());
	}
	/**
	 * @private
	 */
	
	
	var monthsLong = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
	var monthsShort = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
	var monthsNarrow = ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"];
	function months(length) {
	  switch (length) {
	    case "narrow":
	      return monthsNarrow;
	
	    case "short":
	      return monthsShort;
	
	    case "long":
	      return monthsLong;
	
	    case "numeric":
	      return ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"];
	
	    case "2-digit":
	      return ["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12"];
	
	    default:
	      return null;
	  }
	}
	var weekdaysLong = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];
	var weekdaysShort = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];
	var weekdaysNarrow = ["M", "T", "W", "T", "F", "S", "S"];
	function weekdays(length) {
	  switch (length) {
	    case "narrow":
	      return weekdaysNarrow;
	
	    case "short":
	      return weekdaysShort;
	
	    case "long":
	      return weekdaysLong;
	
	    case "numeric":
	      return ["1", "2", "3", "4", "5", "6", "7"];
	
	    default:
	      return null;
	  }
	}
	var meridiems = ["AM", "PM"];
	var erasLong = ["Before Christ", "Anno Domini"];
	var erasShort = ["BC", "AD"];
	var erasNarrow = ["B", "A"];
	function eras(length) {
	  switch (length) {
	    case "narrow":
	      return erasNarrow;
	
	    case "short":
	      return erasShort;
	
	    case "long":
	      return erasLong;
	
	    default:
	      return null;
	  }
	}
	function meridiemForDateTime(dt) {
	  return meridiems[dt.hour < 12 ? 0 : 1];
	}
	function weekdayForDateTime(dt, length) {
	  return weekdays(length)[dt.weekday - 1];
	}
	function monthForDateTime(dt, length) {
	  return months(length)[dt.month - 1];
	}
	function eraForDateTime(dt, length) {
	  return eras(length)[dt.year < 0 ? 0 : 1];
	}
	function formatRelativeTime(unit, count, numeric, narrow) {
	  if (numeric === void 0) {
	    numeric = "always";
	  }
	
	  if (narrow === void 0) {
	    narrow = false;
	  }
	
	  var units = {
	    years: ["year", "yr."],
	    quarters: ["quarer", "qtr."],
	    months: ["month", "mo."],
	    weeks: ["week", "wk."],
	    days: ["day", "day"],
	    hours: ["hour", "hr."],
	    minutes: ["minute", "min."],
	    seconds: ["second", "sec."]
	  };
	  var lastable = ["hours", "minutes", "seconds"].indexOf(unit) === -1;
	
	  if (numeric === "auto" && lastable) {
	    var isDay = unit === "days";
	
	    switch (count) {
	      case 1:
	        return isDay ? "tomorrow" : "next " + units[unit][0];
	
	      case -1:
	        return isDay ? "yesterday" : "last " + units[unit][0];
	
	      case 0:
	        return isDay ? "today" : "this " + units[unit][0];
	
	      default: // fall through
	
	    }
	  }
	
	  var isInPast = Object.is(count, -0) || count < 0,
	      fmtValue = Math.abs(count),
	      fmtUnit = narrow ? units[unit][1] : fmtValue === 1 ? units[unit][0] : unit;
	  return isInPast ? fmtValue + " " + fmtUnit + " ago" : "in " + fmtValue + " " + fmtUnit;
	}
	function formatString(knownFormat) {
	  // these all have the offsets removed because we don't have access to them
	  // without all the intl stuff this is backfilling
	  var filtered = pick(knownFormat, ["weekday", "era", "year", "month", "day", "hour", "minute", "second", "timeZoneName", "hour12"]),
	      key = stringify(filtered),
	      dateTimeHuge = "EEEE, LLLL d, yyyy, h:mm a";
	
	  switch (key) {
	    case stringify(DATE_SHORT):
	      return "M/d/yyyy";
	
	    case stringify(DATE_MED):
	      return "LLL d, yyyy";
	
	    case stringify(DATE_FULL):
	      return "LLLL d, yyyy";
	
	    case stringify(DATE_HUGE):
	      return "EEEE, LLLL d, yyyy";
	
	    case stringify(TIME_SIMPLE):
	      return "h:mm a";
	
	    case stringify(TIME_WITH_SECONDS):
	      return "h:mm:ss a";
	
	    case stringify(TIME_WITH_SHORT_OFFSET):
	      return "h:mm a";
	
	    case stringify(TIME_WITH_LONG_OFFSET):
	      return "h:mm a";
	
	    case stringify(TIME_24_SIMPLE):
	      return "HH:mm";
	
	    case stringify(TIME_24_WITH_SECONDS):
	      return "HH:mm:ss";
	
	    case stringify(TIME_24_WITH_SHORT_OFFSET):
	      return "HH:mm";
	
	    case stringify(TIME_24_WITH_LONG_OFFSET):
	      return "HH:mm";
	
	    case stringify(DATETIME_SHORT):
	      return "M/d/yyyy, h:mm a";
	
	    case stringify(DATETIME_MED):
	      return "LLL d, yyyy, h:mm a";
	
	    case stringify(DATETIME_FULL):
	      return "LLLL d, yyyy, h:mm a";
	
	    case stringify(DATETIME_HUGE):
	      return dateTimeHuge;
	
	    case stringify(DATETIME_SHORT_WITH_SECONDS):
	      return "M/d/yyyy, h:mm:ss a";
	
	    case stringify(DATETIME_MED_WITH_SECONDS):
	      return "LLL d, yyyy, h:mm:ss a";
	
	    case stringify(DATETIME_FULL_WITH_SECONDS):
	      return "LLLL d, yyyy, h:mm:ss a";
	
	    case stringify(DATETIME_HUGE_WITH_SECONDS):
	      return "EEEE, LLLL d, yyyy, h:mm:ss a";
	
	    default:
	      return dateTimeHuge;
	  }
	}
	
	/**
	 * @interface
	 */
	
	var Zone =
	/*#__PURE__*/
	function () {
	  function Zone() {}
	
	  var _proto = Zone.prototype;
	
	  /**
	   * Returns the offset's common name (such as EST) at the specified timestamp
	   * @abstract
	   * @param {number} ts - Epoch milliseconds for which to get the name
	   * @param {Object} opts - Options to affect the format
	   * @param {string} opts.format - What style of offset to return. Accepts 'long' or 'short'.
	   * @param {string} opts.locale - What locale to return the offset name in.
	   * @return {string}
	   */
	  _proto.offsetName = function offsetName(ts, opts) {
	    throw new ZoneIsAbstractError();
	  }
	  /**
	   * Returns the offset's value as a string
	   * @abstract
	   * @param {number} ts - Epoch milliseconds for which to get the offset
	   * @param {string} format - What style of offset to return.
	   *                          Accepts 'narrow', 'short', or 'techie'. Returning '+6', '+06:00', or '+0600' respectively
	   * @return {string}
	   */
	  ;
	
	  _proto.formatOffset = function formatOffset(ts, format) {
	    throw new ZoneIsAbstractError();
	  }
	  /**
	   * Return the offset in minutes for this zone at the specified timestamp.
	   * @abstract
	   * @param {number} ts - Epoch milliseconds for which to compute the offset
	   * @return {number}
	   */
	  ;
	
	  _proto.offset = function offset(ts) {
	    throw new ZoneIsAbstractError();
	  }
	  /**
	   * Return whether this Zone is equal to another zone
	   * @abstract
	   * @param {Zone} otherZone - the zone to compare
	   * @return {boolean}
	   */
	  ;
	
	  _proto.equals = function equals(otherZone) {
	    throw new ZoneIsAbstractError();
	  }
	  /**
	   * Return whether this Zone is valid.
	   * @abstract
	   * @type {boolean}
	   */
	  ;
	
	  _createClass(Zone, [{
	    key: "type",
	
	    /**
	     * The type of zone
	     * @abstract
	     * @type {string}
	     */
	    get: function get() {
	      throw new ZoneIsAbstractError();
	    }
	    /**
	     * The name of this zone.
	     * @abstract
	     * @type {string}
	     */
	
	  }, {
	    key: "name",
	    get: function get() {
	      throw new ZoneIsAbstractError();
	    }
	    /**
	     * Returns whether the offset is known to be fixed for the whole year.
	     * @abstract
	     * @type {boolean}
	     */
	
	  }, {
	    key: "universal",
	    get: function get() {
	      throw new ZoneIsAbstractError();
	    }
	  }, {
	    key: "isValid",
	    get: function get() {
	      throw new ZoneIsAbstractError();
	    }
	  }]);
	
	  return Zone;
	}();
	
	var singleton = null;
	/**
	 * Represents the local zone for this Javascript environment.
	 * @implements {Zone}
	 */
	
	var LocalZone =
	/*#__PURE__*/
	function (_Zone) {
	  _inheritsLoose(LocalZone, _Zone);
	
	  function LocalZone() {
	    return _Zone.apply(this, arguments) || this;
	  }
	
	  var _proto = LocalZone.prototype;
	
	  /** @override **/
	  _proto.offsetName = function offsetName(ts, _ref) {
	    var format = _ref.format,
	        locale = _ref.locale;
	    return parseZoneInfo(ts, format, locale);
	  }
	  /** @override **/
	  ;
	
	  _proto.formatOffset = function formatOffset$1(ts, format) {
	    return formatOffset(this.offset(ts), format);
	  }
	  /** @override **/
	  ;
	
	  _proto.offset = function offset(ts) {
	    return -new Date(ts).getTimezoneOffset();
	  }
	  /** @override **/
	  ;
	
	  _proto.equals = function equals(otherZone) {
	    return otherZone.type === "local";
	  }
	  /** @override **/
	  ;
	
	  _createClass(LocalZone, [{
	    key: "type",
	
	    /** @override **/
	    get: function get() {
	      return "local";
	    }
	    /** @override **/
	
	  }, {
	    key: "name",
	    get: function get() {
	      if (hasIntl()) {
	        return new Intl.DateTimeFormat().resolvedOptions().timeZone;
	      } else return "local";
	    }
	    /** @override **/
	
	  }, {
	    key: "universal",
	    get: function get() {
	      return false;
	    }
	  }, {
	    key: "isValid",
	    get: function get() {
	      return true;
	    }
	  }], [{
	    key: "instance",
	
	    /**
	     * Get a singleton instance of the local zone
	     * @return {LocalZone}
	     */
	    get: function get() {
	      if (singleton === null) {
	        singleton = new LocalZone();
	      }
	
	      return singleton;
	    }
	  }]);
	
	  return LocalZone;
	}(Zone);
	
	var matchingRegex = RegExp("^" + ianaRegex.source + "$");
	var dtfCache = {};
	
	function makeDTF(zone) {
	  if (!dtfCache[zone]) {
	    dtfCache[zone] = new Intl.DateTimeFormat("en-US", {
	      hour12: false,
	      timeZone: zone,
	      year: "numeric",
	      month: "2-digit",
	      day: "2-digit",
	      hour: "2-digit",
	      minute: "2-digit",
	      second: "2-digit"
	    });
	  }
	
	  return dtfCache[zone];
	}
	
	var typeToPos = {
	  year: 0,
	  month: 1,
	  day: 2,
	  hour: 3,
	  minute: 4,
	  second: 5
	};
	
	function hackyOffset(dtf, date) {
	  var formatted = dtf.format(date).replace(/\u200E/g, ""),
	      parsed = /(\d+)\/(\d+)\/(\d+),? (\d+):(\d+):(\d+)/.exec(formatted),
	      fMonth = parsed[1],
	      fDay = parsed[2],
	      fYear = parsed[3],
	      fHour = parsed[4],
	      fMinute = parsed[5],
	      fSecond = parsed[6];
	  return [fYear, fMonth, fDay, fHour, fMinute, fSecond];
	}
	
	function partsOffset(dtf, date) {
	  var formatted = dtf.formatToParts(date),
	      filled = [];
	
	  for (var i = 0; i < formatted.length; i++) {
	    var _formatted$i = formatted[i],
	        type = _formatted$i.type,
	        value = _formatted$i.value,
	        pos = typeToPos[type];
	
	    if (!isUndefined(pos)) {
	      filled[pos] = parseInt(value, 10);
	    }
	  }
	
	  return filled;
	}
	
	var ianaZoneCache = {};
	/**
	 * A zone identified by an IANA identifier, like America/New_York
	 * @implements {Zone}
	 */
	
	var IANAZone =
	/*#__PURE__*/
	function (_Zone) {
	  _inheritsLoose(IANAZone, _Zone);
	
	  /**
	   * @param {string} name - Zone name
	   * @return {IANAZone}
	   */
	  IANAZone.create = function create(name) {
	    if (!ianaZoneCache[name]) {
	      ianaZoneCache[name] = new IANAZone(name);
	    }
	
	    return ianaZoneCache[name];
	  }
	  /**
	   * Reset local caches. Should only be necessary in testing scenarios.
	   * @return {void}
	   */
	  ;
	
	  IANAZone.resetCache = function resetCache() {
	    ianaZoneCache = {};
	    dtfCache = {};
	  }
	  /**
	   * Returns whether the provided string is a valid specifier. This only checks the string's format, not that the specifier identifies a known zone; see isValidZone for that.
	   * @param {string} s - The string to check validity on
	   * @example IANAZone.isValidSpecifier("America/New_York") //=> true
	   * @example IANAZone.isValidSpecifier("Fantasia/Castle") //=> true
	   * @example IANAZone.isValidSpecifier("Sport~~blorp") //=> false
	   * @return {boolean}
	   */
	  ;
	
	  IANAZone.isValidSpecifier = function isValidSpecifier(s) {
	    return !!(s && s.match(matchingRegex));
	  }
	  /**
	   * Returns whether the provided string identifies a real zone
	   * @param {string} zone - The string to check
	   * @example IANAZone.isValidZone("America/New_York") //=> true
	   * @example IANAZone.isValidZone("Fantasia/Castle") //=> false
	   * @example IANAZone.isValidZone("Sport~~blorp") //=> false
	   * @return {boolean}
	   */
	  ;
	
	  IANAZone.isValidZone = function isValidZone(zone) {
	    try {
	      new Intl.DateTimeFormat("en-US", {
	        timeZone: zone
	      }).format();
	      return true;
	    } catch (e) {
	      return false;
	    }
	  } // Etc/GMT+8 -> -480
	
	  /** @ignore */
	  ;
	
	  IANAZone.parseGMTOffset = function parseGMTOffset(specifier) {
	    if (specifier) {
	      var match = specifier.match(/^Etc\/GMT([+-]\d{1,2})$/i);
	
	      if (match) {
	        return -60 * parseInt(match[1]);
	      }
	    }
	
	    return null;
	  };
	
	  function IANAZone(name) {
	    var _this;
	
	    _this = _Zone.call(this) || this;
	    /** @private **/
	
	    _this.zoneName = name;
	    /** @private **/
	
	    _this.valid = IANAZone.isValidZone(name);
	    return _this;
	  }
	  /** @override **/
	
	
	  var _proto = IANAZone.prototype;
	
	  /** @override **/
	  _proto.offsetName = function offsetName(ts, _ref) {
	    var format = _ref.format,
	        locale = _ref.locale;
	    return parseZoneInfo(ts, format, locale, this.name);
	  }
	  /** @override **/
	  ;
	
	  _proto.formatOffset = function formatOffset$1(ts, format) {
	    return formatOffset(this.offset(ts), format);
	  }
	  /** @override **/
	  ;
	
	  _proto.offset = function offset(ts) {
	    var date = new Date(ts),
	        dtf = makeDTF(this.name),
	        _ref2 = dtf.formatToParts ? partsOffset(dtf, date) : hackyOffset(dtf, date),
	        year = _ref2[0],
	        month = _ref2[1],
	        day = _ref2[2],
	        hour = _ref2[3],
	        minute = _ref2[4],
	        second = _ref2[5];
	
	    var asUTC = objToLocalTS({
	      year: year,
	      month: month,
	      day: day,
	      hour: hour,
	      minute: minute,
	      second: second,
	      millisecond: 0
	    });
	    var asTS = date.valueOf();
	    asTS -= asTS % 1000;
	    return (asUTC - asTS) / (60 * 1000);
	  }
	  /** @override **/
	  ;
	
	  _proto.equals = function equals(otherZone) {
	    return otherZone.type === "iana" && otherZone.name === this.name;
	  }
	  /** @override **/
	  ;
	
	  _createClass(IANAZone, [{
	    key: "type",
	    get: function get() {
	      return "iana";
	    }
	    /** @override **/
	
	  }, {
	    key: "name",
	    get: function get() {
	      return this.zoneName;
	    }
	    /** @override **/
	
	  }, {
	    key: "universal",
	    get: function get() {
	      return false;
	    }
	  }, {
	    key: "isValid",
	    get: function get() {
	      return this.valid;
	    }
	  }]);
	
	  return IANAZone;
	}(Zone);
	
	var singleton$1 = null;
	/**
	 * A zone with a fixed offset (i.e. no DST)
	 * @implements {Zone}
	 */
	
	var FixedOffsetZone =
	/*#__PURE__*/
	function (_Zone) {
	  _inheritsLoose(FixedOffsetZone, _Zone);
	
	  /**
	   * Get an instance with a specified offset
	   * @param {number} offset - The offset in minutes
	   * @return {FixedOffsetZone}
	   */
	  FixedOffsetZone.instance = function instance(offset) {
	    return offset === 0 ? FixedOffsetZone.utcInstance : new FixedOffsetZone(offset);
	  }
	  /**
	   * Get an instance of FixedOffsetZone from a UTC offset string, like "UTC+6"
	   * @param {string} s - The offset string to parse
	   * @example FixedOffsetZone.parseSpecifier("UTC+6")
	   * @example FixedOffsetZone.parseSpecifier("UTC+06")
	   * @example FixedOffsetZone.parseSpecifier("UTC-6:00")
	   * @return {FixedOffsetZone}
	   */
	  ;
	
	  FixedOffsetZone.parseSpecifier = function parseSpecifier(s) {
	    if (s) {
	      var r = s.match(/^utc(?:([+-]\d{1,2})(?::(\d{2}))?)?$/i);
	
	      if (r) {
	        return new FixedOffsetZone(signedOffset(r[1], r[2]));
	      }
	    }
	
	    return null;
	  };
	
	  _createClass(FixedOffsetZone, null, [{
	    key: "utcInstance",
	
	    /**
	     * Get a singleton instance of UTC
	     * @return {FixedOffsetZone}
	     */
	    get: function get() {
	      if (singleton$1 === null) {
	        singleton$1 = new FixedOffsetZone(0);
	      }
	
	      return singleton$1;
	    }
	  }]);
	
	  function FixedOffsetZone(offset) {
	    var _this;
	
	    _this = _Zone.call(this) || this;
	    /** @private **/
	
	    _this.fixed = offset;
	    return _this;
	  }
	  /** @override **/
	
	
	  var _proto = FixedOffsetZone.prototype;
	
	  /** @override **/
	  _proto.offsetName = function offsetName() {
	    return this.name;
	  }
	  /** @override **/
	  ;
	
	  _proto.formatOffset = function formatOffset$1(ts, format) {
	    return formatOffset(this.fixed, format);
	  }
	  /** @override **/
	  ;
	
	  /** @override **/
	  _proto.offset = function offset() {
	    return this.fixed;
	  }
	  /** @override **/
	  ;
	
	  _proto.equals = function equals(otherZone) {
	    return otherZone.type === "fixed" && otherZone.fixed === this.fixed;
	  }
	  /** @override **/
	  ;
	
	  _createClass(FixedOffsetZone, [{
	    key: "type",
	    get: function get() {
	      return "fixed";
	    }
	    /** @override **/
	
	  }, {
	    key: "name",
	    get: function get() {
	      return this.fixed === 0 ? "UTC" : "UTC" + formatOffset(this.fixed, "narrow");
	    }
	  }, {
	    key: "universal",
	    get: function get() {
	      return true;
	    }
	  }, {
	    key: "isValid",
	    get: function get() {
	      return true;
	    }
	  }]);
	
	  return FixedOffsetZone;
	}(Zone);
	
	/**
	 * A zone that failed to parse. You should never need to instantiate this.
	 * @implements {Zone}
	 */
	
	var InvalidZone =
	/*#__PURE__*/
	function (_Zone) {
	  _inheritsLoose(InvalidZone, _Zone);
	
	  function InvalidZone(zoneName) {
	    var _this;
	
	    _this = _Zone.call(this) || this;
	    /**  @private */
	
	    _this.zoneName = zoneName;
	    return _this;
	  }
	  /** @override **/
	
	
	  var _proto = InvalidZone.prototype;
	
	  /** @override **/
	  _proto.offsetName = function offsetName() {
	    return null;
	  }
	  /** @override **/
	  ;
	
	  _proto.formatOffset = function formatOffset() {
	    return "";
	  }
	  /** @override **/
	  ;
	
	  _proto.offset = function offset() {
	    return NaN;
	  }
	  /** @override **/
	  ;
	
	  _proto.equals = function equals() {
	    return false;
	  }
	  /** @override **/
	  ;
	
	  _createClass(InvalidZone, [{
	    key: "type",
	    get: function get() {
	      return "invalid";
	    }
	    /** @override **/
	
	  }, {
	    key: "name",
	    get: function get() {
	      return this.zoneName;
	    }
	    /** @override **/
	
	  }, {
	    key: "universal",
	    get: function get() {
	      return false;
	    }
	  }, {
	    key: "isValid",
	    get: function get() {
	      return false;
	    }
	  }]);
	
	  return InvalidZone;
	}(Zone);
	
	/**
	 * @private
	 */
	function normalizeZone(input, defaultZone) {
	  var offset;
	
	  if (isUndefined(input) || input === null) {
	    return defaultZone;
	  } else if (input instanceof Zone) {
	    return input;
	  } else if (isString(input)) {
	    var lowered = input.toLowerCase();
	    if (lowered === "local") return defaultZone;else if (lowered === "utc" || lowered === "gmt") return FixedOffsetZone.utcInstance;else if ((offset = IANAZone.parseGMTOffset(input)) != null) {
	      // handle Etc/GMT-4, which V8 chokes on
	      return FixedOffsetZone.instance(offset);
	    } else if (IANAZone.isValidSpecifier(lowered)) return IANAZone.create(input);else return FixedOffsetZone.parseSpecifier(lowered) || new InvalidZone(input);
	  } else if (isNumber(input)) {
	    return FixedOffsetZone.instance(input);
	  } else if (typeof input === "object" && input.offset && typeof input.offset === "number") {
	    // This is dumb, but the instanceof check above doesn't seem to really work
	    // so we're duck checking it
	    return input;
	  } else {
	    return new InvalidZone(input);
	  }
	}
	
	var now = function now() {
	  return Date.now();
	},
	    defaultZone = null,
	    // not setting this directly to LocalZone.instance bc loading order issues
	defaultLocale = null,
	    defaultNumberingSystem = null,
	    defaultOutputCalendar = null,
	    throwOnInvalid = false;
	/**
	 * Settings contains static getters and setters that control Luxon's overall behavior. Luxon is a simple library with few options, but the ones it does have live here.
	 */
	
	
	var Settings =
	/*#__PURE__*/
	function () {
	  function Settings() {}
	
	  /**
	   * Reset Luxon's global caches. Should only be necessary in testing scenarios.
	   * @return {void}
	   */
	  Settings.resetCaches = function resetCaches() {
	    Locale.resetCache();
	    IANAZone.resetCache();
	  };
	
	  _createClass(Settings, null, [{
	    key: "now",
	
	    /**
	     * Get the callback for returning the current timestamp.
	     * @type {function}
	     */
	    get: function get() {
	      return now;
	    }
	    /**
	     * Set the callback for returning the current timestamp.
	     * The function should return a number, which will be interpreted as an Epoch millisecond count
	     * @type {function}
	     * @example Settings.now = () => Date.now() + 3000 // pretend it is 3 seconds in the future
	     * @example Settings.now = () => 0 // always pretend it's Jan 1, 1970 at midnight in UTC time
	     */
	    ,
	    set: function set(n) {
	      now = n;
	    }
	    /**
	     * Get the default time zone to create DateTimes in.
	     * @type {string}
	     */
	
	  }, {
	    key: "defaultZoneName",
	    get: function get() {
	      return Settings.defaultZone.name;
	    }
	    /**
	     * Set the default time zone to create DateTimes in. Does not affect existing instances.
	     * @type {string}
	     */
	    ,
	    set: function set(z) {
	      if (!z) {
	        defaultZone = null;
	      } else {
	        defaultZone = normalizeZone(z);
	      }
	    }
	    /**
	     * Get the default time zone object to create DateTimes in. Does not affect existing instances.
	     * @type {Zone}
	     */
	
	  }, {
	    key: "defaultZone",
	    get: function get() {
	      return defaultZone || LocalZone.instance;
	    }
	    /**
	     * Get the default locale to create DateTimes with. Does not affect existing instances.
	     * @type {string}
	     */
	
	  }, {
	    key: "defaultLocale",
	    get: function get() {
	      return defaultLocale;
	    }
	    /**
	     * Set the default locale to create DateTimes with. Does not affect existing instances.
	     * @type {string}
	     */
	    ,
	    set: function set(locale) {
	      defaultLocale = locale;
	    }
	    /**
	     * Get the default numbering system to create DateTimes with. Does not affect existing instances.
	     * @type {string}
	     */
	
	  }, {
	    key: "defaultNumberingSystem",
	    get: function get() {
	      return defaultNumberingSystem;
	    }
	    /**
	     * Set the default numbering system to create DateTimes with. Does not affect existing instances.
	     * @type {string}
	     */
	    ,
	    set: function set(numberingSystem) {
	      defaultNumberingSystem = numberingSystem;
	    }
	    /**
	     * Get the default output calendar to create DateTimes with. Does not affect existing instances.
	     * @type {string}
	     */
	
	  }, {
	    key: "defaultOutputCalendar",
	    get: function get() {
	      return defaultOutputCalendar;
	    }
	    /**
	     * Set the default output calendar to create DateTimes with. Does not affect existing instances.
	     * @type {string}
	     */
	    ,
	    set: function set(outputCalendar) {
	      defaultOutputCalendar = outputCalendar;
	    }
	    /**
	     * Get whether Luxon will throw when it encounters invalid DateTimes, Durations, or Intervals
	     * @type {boolean}
	     */
	
	  }, {
	    key: "throwOnInvalid",
	    get: function get() {
	      return throwOnInvalid;
	    }
	    /**
	     * Set whether Luxon will throw when it encounters invalid DateTimes, Durations, or Intervals
	     * @type {boolean}
	     */
	    ,
	    set: function set(t) {
	      throwOnInvalid = t;
	    }
	  }]);
	
	  return Settings;
	}();
	
	function stringifyTokens(splits, tokenToString) {
	  var s = "";
	
	  for (var _iterator = splits, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
	    var _ref;
	
	    if (_isArray) {
	      if (_i >= _iterator.length) break;
	      _ref = _iterator[_i++];
	    } else {
	      _i = _iterator.next();
	      if (_i.done) break;
	      _ref = _i.value;
	    }
	
	    var token = _ref;
	
	    if (token.literal) {
	      s += token.val;
	    } else {
	      s += tokenToString(token.val);
	    }
	  }
	
	  return s;
	}
	
	var tokenToObject = {
	  D: DATE_SHORT,
	  DD: DATE_MED,
	  DDD: DATE_FULL,
	  DDDD: DATE_HUGE,
	  t: TIME_SIMPLE,
	  tt: TIME_WITH_SECONDS,
	  ttt: TIME_WITH_SHORT_OFFSET,
	  tttt: TIME_WITH_LONG_OFFSET,
	  T: TIME_24_SIMPLE,
	  TT: TIME_24_WITH_SECONDS,
	  TTT: TIME_24_WITH_SHORT_OFFSET,
	  TTTT: TIME_24_WITH_LONG_OFFSET,
	  f: DATETIME_SHORT,
	  ff: DATETIME_MED,
	  fff: DATETIME_FULL,
	  ffff: DATETIME_HUGE,
	  F: DATETIME_SHORT_WITH_SECONDS,
	  FF: DATETIME_MED_WITH_SECONDS,
	  FFF: DATETIME_FULL_WITH_SECONDS,
	  FFFF: DATETIME_HUGE_WITH_SECONDS
	};
	/**
	 * @private
	 */
	
	var Formatter =
	/*#__PURE__*/
	function () {
	  Formatter.create = function create(locale, opts) {
	    if (opts === void 0) {
	      opts = {};
	    }
	
	    return new Formatter(locale, opts);
	  };
	
	  Formatter.parseFormat = function parseFormat(fmt) {
	    var current = null,
	        currentFull = "",
	        bracketed = false;
	    var splits = [];
	
	    for (var i = 0; i < fmt.length; i++) {
	      var c = fmt.charAt(i);
	
	      if (c === "'") {
	        if (currentFull.length > 0) {
	          splits.push({
	            literal: bracketed,
	            val: currentFull
	          });
	        }
	
	        current = null;
	        currentFull = "";
	        bracketed = !bracketed;
	      } else if (bracketed) {
	        currentFull += c;
	      } else if (c === current) {
	        currentFull += c;
	      } else {
	        if (currentFull.length > 0) {
	          splits.push({
	            literal: false,
	            val: currentFull
	          });
	        }
	
	        currentFull = c;
	        current = c;
	      }
	    }
	
	    if (currentFull.length > 0) {
	      splits.push({
	        literal: bracketed,
	        val: currentFull
	      });
	    }
	
	    return splits;
	  };
	
	  function Formatter(locale, formatOpts) {
	    this.opts = formatOpts;
	    this.loc = locale;
	    this.systemLoc = null;
	  }
	
	  var _proto = Formatter.prototype;
	
	  _proto.formatWithSystemDefault = function formatWithSystemDefault(dt, opts) {
	    if (this.systemLoc === null) {
	      this.systemLoc = this.loc.redefaultToSystem();
	    }
	
	    var df = this.systemLoc.dtFormatter(dt, Object.assign({}, this.opts, opts));
	    return df.format();
	  };
	
	  _proto.formatDateTime = function formatDateTime(dt, opts) {
	    if (opts === void 0) {
	      opts = {};
	    }
	
	    var df = this.loc.dtFormatter(dt, Object.assign({}, this.opts, opts));
	    return df.format();
	  };
	
	  _proto.formatDateTimeParts = function formatDateTimeParts(dt, opts) {
	    if (opts === void 0) {
	      opts = {};
	    }
	
	    var df = this.loc.dtFormatter(dt, Object.assign({}, this.opts, opts));
	    return df.formatToParts();
	  };
	
	  _proto.resolvedOptions = function resolvedOptions(dt, opts) {
	    if (opts === void 0) {
	      opts = {};
	    }
	
	    var df = this.loc.dtFormatter(dt, Object.assign({}, this.opts, opts));
	    return df.resolvedOptions();
	  };
	
	  _proto.num = function num(n, p) {
	    if (p === void 0) {
	      p = 0;
	    }
	
	    // we get some perf out of doing this here, annoyingly
	    if (this.opts.forceSimple) {
	      return padStart(n, p);
	    }
	
	    var opts = Object.assign({}, this.opts);
	
	    if (p > 0) {
	      opts.padTo = p;
	    }
	
	    return this.loc.numberFormatter(opts).format(n);
	  };
	
	  _proto.formatDateTimeFromString = function formatDateTimeFromString(dt, fmt) {
	    var _this = this;
	
	    var knownEnglish = this.loc.listingMode() === "en";
	
	    var string = function string(opts, extract) {
	      return _this.loc.extract(dt, opts, extract);
	    },
	        formatOffset = function formatOffset(opts) {
	      if (dt.isOffsetFixed && dt.offset === 0 && opts.allowZ) {
	        return "Z";
	      }
	
	      return dt.isValid ? dt.zone.formatOffset(dt.ts, opts.format) : "";
	    },
	        meridiem = function meridiem() {
	      return knownEnglish ? meridiemForDateTime(dt) : string({
	        hour: "numeric",
	        hour12: true
	      }, "dayperiod");
	    },
	        month = function month(length, standalone) {
	      return knownEnglish ? monthForDateTime(dt, length) : string(standalone ? {
	        month: length
	      } : {
	        month: length,
	        day: "numeric"
	      }, "month");
	    },
	        weekday = function weekday(length, standalone) {
	      return knownEnglish ? weekdayForDateTime(dt, length) : string(standalone ? {
	        weekday: length
	      } : {
	        weekday: length,
	        month: "long",
	        day: "numeric"
	      }, "weekday");
	    },
	        maybeMacro = function maybeMacro(token) {
	      var macro = tokenToObject[token];
	
	      if (macro) {
	        return _this.formatWithSystemDefault(dt, macro);
	      } else {
	        return token;
	      }
	    },
	        era = function era(length) {
	      return knownEnglish ? eraForDateTime(dt, length) : string({
	        era: length
	      }, "era");
	    },
	        tokenToString = function tokenToString(token) {
	      var outputCal = _this.loc.outputCalendar; // Where possible: http://cldr.unicode.org/translation/date-time#TOC-Stand-Alone-vs.-Format-Styles
	
	      switch (token) {
	        // ms
	        case "S":
	          return _this.num(dt.millisecond);
	
	        case "u": // falls through
	
	        case "SSS":
	          return _this.num(dt.millisecond, 3);
	        // seconds
	
	        case "s":
	          return _this.num(dt.second);
	
	        case "ss":
	          return _this.num(dt.second, 2);
	        // minutes
	
	        case "m":
	          return _this.num(dt.minute);
	
	        case "mm":
	          return _this.num(dt.minute, 2);
	        // hours
	
	        case "h":
	          return _this.num(dt.hour % 12 === 0 ? 12 : dt.hour % 12);
	
	        case "hh":
	          return _this.num(dt.hour % 12 === 0 ? 12 : dt.hour % 12, 2);
	
	        case "H":
	          return _this.num(dt.hour);
	
	        case "HH":
	          return _this.num(dt.hour, 2);
	        // offset
	
	        case "Z":
	          // like +6
	          return formatOffset({
	            format: "narrow",
	            allowZ: _this.opts.allowZ
	          });
	
	        case "ZZ":
	          // like +06:00
	          return formatOffset({
	            format: "short",
	            allowZ: _this.opts.allowZ
	          });
	
	        case "ZZZ":
	          // like +0600
	          return formatOffset({
	            format: "techie",
	            allowZ: false
	          });
	
	        case "ZZZZ":
	          // like EST
	          return dt.offsetNameShort;
	
	        case "ZZZZZ":
	          // like Eastern Standard Time
	          return dt.offsetNameLong;
	        // zone
	
	        case "z":
	          // like America/New_York
	          return dt.zoneName;
	        // meridiems
	
	        case "a":
	          return meridiem();
	        // dates
	
	        case "d":
	          return outputCal ? string({
	            day: "numeric"
	          }, "day") : _this.num(dt.day);
	
	        case "dd":
	          return outputCal ? string({
	            day: "2-digit"
	          }, "day") : _this.num(dt.day, 2);
	        // weekdays - standalone
	
	        case "c":
	          // like 1
	          return _this.num(dt.weekday);
	
	        case "ccc":
	          // like 'Tues'
	          return weekday("short", true);
	
	        case "cccc":
	          // like 'Tuesday'
	          return weekday("long", true);
	
	        case "ccccc":
	          // like 'T'
	          return weekday("narrow", true);
	        // weekdays - format
	
	        case "E":
	          // like 1
	          return _this.num(dt.weekday);
	
	        case "EEE":
	          // like 'Tues'
	          return weekday("short", false);
	
	        case "EEEE":
	          // like 'Tuesday'
	          return weekday("long", false);
	
	        case "EEEEE":
	          // like 'T'
	          return weekday("narrow", false);
	        // months - standalone
	
	        case "L":
	          // like 1
	          return outputCal ? string({
	            month: "numeric",
	            day: "numeric"
	          }, "month") : _this.num(dt.month);
	
	        case "LL":
	          // like 01, doesn't seem to work
	          return outputCal ? string({
	            month: "2-digit",
	            day: "numeric"
	          }, "month") : _this.num(dt.month, 2);
	
	        case "LLL":
	          // like Jan
	          return month("short", true);
	
	        case "LLLL":
	          // like January
	          return month("long", true);
	
	        case "LLLLL":
	          // like J
	          return month("narrow", true);
	        // months - format
	
	        case "M":
	          // like 1
	          return outputCal ? string({
	            month: "numeric"
	          }, "month") : _this.num(dt.month);
	
	        case "MM":
	          // like 01
	          return outputCal ? string({
	            month: "2-digit"
	          }, "month") : _this.num(dt.month, 2);
	
	        case "MMM":
	          // like Jan
	          return month("short", false);
	
	        case "MMMM":
	          // like January
	          return month("long", false);
	
	        case "MMMMM":
	          // like J
	          return month("narrow", false);
	        // years
	
	        case "y":
	          // like 2014
	          return outputCal ? string({
	            year: "numeric"
	          }, "year") : _this.num(dt.year);
	
	        case "yy":
	          // like 14
	          return outputCal ? string({
	            year: "2-digit"
	          }, "year") : _this.num(dt.year.toString().slice(-2), 2);
	
	        case "yyyy":
	          // like 0012
	          return outputCal ? string({
	            year: "numeric"
	          }, "year") : _this.num(dt.year, 4);
	
	        case "yyyyyy":
	          // like 000012
	          return outputCal ? string({
	            year: "numeric"
	          }, "year") : _this.num(dt.year, 6);
	        // eras
	
	        case "G":
	          // like AD
	          return era("short");
	
	        case "GG":
	          // like Anno Domini
	          return era("long");
	
	        case "GGGGG":
	          return era("narrow");
	
	        case "kk":
	          return _this.num(dt.weekYear.toString().slice(-2), 2);
	
	        case "kkkk":
	          return _this.num(dt.weekYear, 4);
	
	        case "W":
	          return _this.num(dt.weekNumber);
	
	        case "WW":
	          return _this.num(dt.weekNumber, 2);
	
	        case "o":
	          return _this.num(dt.ordinal);
	
	        case "ooo":
	          return _this.num(dt.ordinal, 3);
	
	        case "q":
	          // like 1
	          return _this.num(dt.quarter);
	
	        case "qq":
	          // like 01
	          return _this.num(dt.quarter, 2);
	
	        case "X":
	          return _this.num(Math.floor(dt.ts / 1000));
	
	        case "x":
	          return _this.num(dt.ts);
	
	        default:
	          return maybeMacro(token);
	      }
	    };
	
	    return stringifyTokens(Formatter.parseFormat(fmt), tokenToString);
	  };
	
	  _proto.formatDurationFromString = function formatDurationFromString(dur, fmt) {
	    var _this2 = this;
	
	    var tokenToField = function tokenToField(token) {
	      switch (token[0]) {
	        case "S":
	          return "millisecond";
	
	        case "s":
	          return "second";
	
	        case "m":
	          return "minute";
	
	        case "h":
	          return "hour";
	
	        case "d":
	          return "day";
	
	        case "M":
	          return "month";
	
	        case "y":
	          return "year";
	
	        default:
	          return null;
	      }
	    },
	        tokenToString = function tokenToString(lildur) {
	      return function (token) {
	        var mapped = tokenToField(token);
	
	        if (mapped) {
	          return _this2.num(lildur.get(mapped), token.length);
	        } else {
	          return token;
	        }
	      };
	    },
	        tokens = Formatter.parseFormat(fmt),
	        realTokens = tokens.reduce(function (found, _ref2) {
	      var literal = _ref2.literal,
	          val = _ref2.val;
	      return literal ? found : found.concat(val);
	    }, []),
	        collapsed = dur.shiftTo.apply(dur, realTokens.map(tokenToField).filter(function (t) {
	      return t;
	    }));
	
	    return stringifyTokens(tokens, tokenToString(collapsed));
	  };
	
	  return Formatter;
	}();
	
	var intlDTCache = {};
	
	function getCachedDTF(locString, opts) {
	  if (opts === void 0) {
	    opts = {};
	  }
	
	  var key = JSON.stringify([locString, opts]);
	  var dtf = intlDTCache[key];
	
	  if (!dtf) {
	    dtf = new Intl.DateTimeFormat(locString, opts);
	    intlDTCache[key] = dtf;
	  }
	
	  return dtf;
	}
	
	var intlNumCache = {};
	
	function getCachendINF(locString, opts) {
	  if (opts === void 0) {
	    opts = {};
	  }
	
	  var key = JSON.stringify([locString, opts]);
	  var inf = intlNumCache[key];
	
	  if (!inf) {
	    inf = new Intl.NumberFormat(locString, opts);
	    intlNumCache[key] = inf;
	  }
	
	  return inf;
	}
	
	var intlRelCache = {};
	
	function getCachendRTF(locString, opts) {
	  if (opts === void 0) {
	    opts = {};
	  }
	
	  var key = JSON.stringify([locString, opts]);
	  var inf = intlRelCache[key];
	
	  if (!inf) {
	    inf = new Intl.RelativeTimeFormat(locString, opts);
	    intlRelCache[key] = inf;
	  }
	
	  return inf;
	}
	
	var sysLocaleCache = null;
	
	function systemLocale() {
	  if (sysLocaleCache) {
	    return sysLocaleCache;
	  } else if (hasIntl()) {
	    var computedSys = new Intl.DateTimeFormat().resolvedOptions().locale; // node sometimes defaults to "und". Override that because that is dumb
	
	    sysLocaleCache = computedSys === "und" ? "en-US" : computedSys;
	    return sysLocaleCache;
	  } else {
	    sysLocaleCache = "en-US";
	    return sysLocaleCache;
	  }
	}
	
	function parseLocaleString(localeStr) {
	  // I really want to avoid writing a BCP 47 parser
	  // see, e.g. https://github.com/wooorm/bcp-47
	  // Instead, we'll do this:
	  // a) if the string has no -u extensions, just leave it alone
	  // b) if it does, use Intl to resolve everything
	  // c) if Intl fails, try again without the -u
	  var uIndex = localeStr.indexOf("-u-");
	
	  if (uIndex === -1) {
	    return [localeStr];
	  } else {
	    var options;
	    var smaller = localeStr.substring(0, uIndex);
	
	    try {
	      options = getCachedDTF(localeStr).resolvedOptions();
	    } catch (e) {
	      options = getCachedDTF(smaller).resolvedOptions();
	    }
	
	    var _options = options,
	        numberingSystem = _options.numberingSystem,
	        calendar = _options.calendar; // return the smaller one so that we can append the calendar and numbering overrides to it
	
	    return [smaller, numberingSystem, calendar];
	  }
	}
	
	function intlConfigString(localeStr, numberingSystem, outputCalendar) {
	  if (hasIntl()) {
	    if (outputCalendar || numberingSystem) {
	      localeStr += "-u";
	
	      if (outputCalendar) {
	        localeStr += "-ca-" + outputCalendar;
	      }
	
	      if (numberingSystem) {
	        localeStr += "-nu-" + numberingSystem;
	      }
	
	      return localeStr;
	    } else {
	      return localeStr;
	    }
	  } else {
	    return [];
	  }
	}
	
	function mapMonths(f) {
	  var ms = [];
	
	  for (var i = 1; i <= 12; i++) {
	    var dt = DateTime.utc(2016, i, 1);
	    ms.push(f(dt));
	  }
	
	  return ms;
	}
	
	function mapWeekdays(f) {
	  var ms = [];
	
	  for (var i = 1; i <= 7; i++) {
	    var dt = DateTime.utc(2016, 11, 13 + i);
	    ms.push(f(dt));
	  }
	
	  return ms;
	}
	
	function listStuff(loc, length, defaultOK, englishFn, intlFn) {
	  var mode = loc.listingMode(defaultOK);
	
	  if (mode === "error") {
	    return null;
	  } else if (mode === "en") {
	    return englishFn(length);
	  } else {
	    return intlFn(length);
	  }
	}
	
	function supportsFastNumbers(loc) {
	  if (loc.numberingSystem && loc.numberingSystem !== "latn") {
	    return false;
	  } else {
	    return loc.numberingSystem === "latn" || !loc.locale || loc.locale.startsWith("en") || hasIntl() && Intl.DateTimeFormat(loc.intl).resolvedOptions().numberingSystem === "latn";
	  }
	}
	/**
	 * @private
	 */
	
	
	var PolyNumberFormatter =
	/*#__PURE__*/
	function () {
	  function PolyNumberFormatter(intl, forceSimple, opts) {
	    this.padTo = opts.padTo || 0;
	    this.floor = opts.floor || false;
	
	    if (!forceSimple && hasIntl()) {
	      var intlOpts = {
	        useGrouping: false
	      };
	      if (opts.padTo > 0) intlOpts.minimumIntegerDigits = opts.padTo;
	      this.inf = getCachendINF(intl, intlOpts);
	    }
	  }
	
	  var _proto = PolyNumberFormatter.prototype;
	
	  _proto.format = function format(i) {
	    if (this.inf) {
	      var fixed = this.floor ? Math.floor(i) : i;
	      return this.inf.format(fixed);
	    } else {
	      // to match the browser's numberformatter defaults
	      var _fixed = this.floor ? Math.floor(i) : roundTo(i, 3);
	
	      return padStart(_fixed, this.padTo);
	    }
	  };
	
	  return PolyNumberFormatter;
	}();
	/**
	 * @private
	 */
	
	
	var PolyDateFormatter =
	/*#__PURE__*/
	function () {
	  function PolyDateFormatter(dt, intl, opts) {
	    this.opts = opts;
	    this.hasIntl = hasIntl();
	    var z;
	
	    if (dt.zone.universal && this.hasIntl) {
	      // Chromium doesn't support fixed-offset zones like Etc/GMT+8 in its formatter,
	      // See https://bugs.chromium.org/p/chromium/issues/detail?id=364374.
	      // So we have to make do. Two cases:
	      // 1. The format options tell us to show the zone. We can't do that, so the best
	      // we can do is format the date in UTC.
	      // 2. The format options don't tell us to show the zone. Then we can adjust them
	      // the time and tell the formatter to show it to us in UTC, so that the time is right
	      // and the bad zone doesn't show up.
	      // We can clean all this up when Chrome fixes this.
	      z = "UTC";
	
	      if (opts.timeZoneName) {
	        this.dt = dt;
	      } else {
	        this.dt = dt.offset === 0 ? dt : DateTime.fromMillis(dt.ts + dt.offset * 60 * 1000);
	      }
	    } else if (dt.zone.type === "local") {
	      this.dt = dt;
	    } else {
	      this.dt = dt;
	      z = dt.zone.name;
	    }
	
	    if (this.hasIntl) {
	      var intlOpts = Object.assign({}, this.opts);
	
	      if (z) {
	        intlOpts.timeZone = z;
	      }
	
	      this.dtf = getCachedDTF(intl, intlOpts);
	    }
	  }
	
	  var _proto2 = PolyDateFormatter.prototype;
	
	  _proto2.format = function format() {
	    if (this.hasIntl) {
	      return this.dtf.format(this.dt.toJSDate());
	    } else {
	      var tokenFormat = formatString(this.opts),
	          loc = Locale.create("en-US");
	      return Formatter.create(loc).formatDateTimeFromString(this.dt, tokenFormat);
	    }
	  };
	
	  _proto2.formatToParts = function formatToParts() {
	    if (this.hasIntl && hasFormatToParts()) {
	      return this.dtf.formatToParts(this.dt.toJSDate());
	    } else {
	      // This is kind of a cop out. We actually could do this for English. However, we couldn't do it for intl strings
	      // and IMO it's too weird to have an uncanny valley like that
	      return [];
	    }
	  };
	
	  _proto2.resolvedOptions = function resolvedOptions() {
	    if (this.hasIntl) {
	      return this.dtf.resolvedOptions();
	    } else {
	      return {
	        locale: "en-US",
	        numberingSystem: "latn",
	        outputCalendar: "gregory"
	      };
	    }
	  };
	
	  return PolyDateFormatter;
	}();
	/**
	 * @private
	 */
	
	
	var PolyRelFormatter =
	/*#__PURE__*/
	function () {
	  function PolyRelFormatter(intl, isEnglish, opts) {
	    this.opts = Object.assign({
	      style: "long"
	    }, opts);
	
	    if (!isEnglish && hasRelative()) {
	      this.rtf = getCachendRTF(intl, opts);
	    }
	  }
	
	  var _proto3 = PolyRelFormatter.prototype;
	
	  _proto3.format = function format(count, unit) {
	    if (this.rtf) {
	      return this.rtf.format(count, unit);
	    } else {
	      return formatRelativeTime(unit, count, this.opts.numeric, this.opts.style !== "long");
	    }
	  };
	
	  _proto3.formatToParts = function formatToParts(count, unit) {
	    if (this.rtf) {
	      return this.rtf.formatToParts(count, unit);
	    } else {
	      return [];
	    }
	  };
	
	  return PolyRelFormatter;
	}();
	/**
	 * @private
	 */
	
	
	var Locale =
	/*#__PURE__*/
	function () {
	  Locale.fromOpts = function fromOpts(opts) {
	    return Locale.create(opts.locale, opts.numberingSystem, opts.outputCalendar, opts.defaultToEN);
	  };
	
	  Locale.create = function create(locale, numberingSystem, outputCalendar, defaultToEN) {
	    if (defaultToEN === void 0) {
	      defaultToEN = false;
	    }
	
	    var specifiedLocale = locale || Settings.defaultLocale,
	        // the system locale is useful for human readable strings but annoying for parsing/formatting known formats
	    localeR = specifiedLocale || (defaultToEN ? "en-US" : systemLocale()),
	        numberingSystemR = numberingSystem || Settings.defaultNumberingSystem,
	        outputCalendarR = outputCalendar || Settings.defaultOutputCalendar;
	    return new Locale(localeR, numberingSystemR, outputCalendarR, specifiedLocale);
	  };
	
	  Locale.resetCache = function resetCache() {
	    sysLocaleCache = null;
	    intlDTCache = {};
	    intlNumCache = {};
	  };
	
	  Locale.fromObject = function fromObject(_temp) {
	    var _ref = _temp === void 0 ? {} : _temp,
	        locale = _ref.locale,
	        numberingSystem = _ref.numberingSystem,
	        outputCalendar = _ref.outputCalendar;
	
	    return Locale.create(locale, numberingSystem, outputCalendar);
	  };
	
	  function Locale(locale, numbering, outputCalendar, specifiedLocale) {
	    var _parseLocaleString = parseLocaleString(locale),
	        parsedLocale = _parseLocaleString[0],
	        parsedNumberingSystem = _parseLocaleString[1],
	        parsedOutputCalendar = _parseLocaleString[2];
	
	    this.locale = parsedLocale;
	    this.numberingSystem = numbering || parsedNumberingSystem || null;
	    this.outputCalendar = outputCalendar || parsedOutputCalendar || null;
	    this.intl = intlConfigString(this.locale, this.numberingSystem, this.outputCalendar);
	    this.weekdaysCache = {
	      format: {},
	      standalone: {}
	    };
	    this.monthsCache = {
	      format: {},
	      standalone: {}
	    };
	    this.meridiemCache = null;
	    this.eraCache = {};
	    this.specifiedLocale = specifiedLocale;
	    this.fastNumbersCached = null;
	  }
	
	  var _proto4 = Locale.prototype;
	
	  _proto4.listingMode = function listingMode(defaultOK) {
	    if (defaultOK === void 0) {
	      defaultOK = true;
	    }
	
	    var intl = hasIntl(),
	        hasFTP = intl && hasFormatToParts(),
	        isActuallyEn = this.isEnglish(),
	        hasNoWeirdness = (this.numberingSystem === null || this.numberingSystem === "latn") && (this.outputCalendar === null || this.outputCalendar === "gregory");
	
	    if (!hasFTP && !(isActuallyEn && hasNoWeirdness) && !defaultOK) {
	      return "error";
	    } else if (!hasFTP || isActuallyEn && hasNoWeirdness) {
	      return "en";
	    } else {
	      return "intl";
	    }
	  };
	
	  _proto4.clone = function clone(alts) {
	    if (!alts || Object.getOwnPropertyNames(alts).length === 0) {
	      return this;
	    } else {
	      return Locale.create(alts.locale || this.specifiedLocale, alts.numberingSystem || this.numberingSystem, alts.outputCalendar || this.outputCalendar, alts.defaultToEN || false);
	    }
	  };
	
	  _proto4.redefaultToEN = function redefaultToEN(alts) {
	    if (alts === void 0) {
	      alts = {};
	    }
	
	    return this.clone(Object.assign({}, alts, {
	      defaultToEN: true
	    }));
	  };
	
	  _proto4.redefaultToSystem = function redefaultToSystem(alts) {
	    if (alts === void 0) {
	      alts = {};
	    }
	
	    return this.clone(Object.assign({}, alts, {
	      defaultToEN: false
	    }));
	  };
	
	  _proto4.months = function months$1(length, format, defaultOK) {
	    var _this = this;
	
	    if (format === void 0) {
	      format = false;
	    }
	
	    if (defaultOK === void 0) {
	      defaultOK = true;
	    }
	
	    return listStuff(this, length, defaultOK, months, function () {
	      var intl = format ? {
	        month: length,
	        day: "numeric"
	      } : {
	        month: length
	      },
	          formatStr = format ? "format" : "standalone";
	
	      if (!_this.monthsCache[formatStr][length]) {
	        _this.monthsCache[formatStr][length] = mapMonths(function (dt) {
	          return _this.extract(dt, intl, "month");
	        });
	      }
	
	      return _this.monthsCache[formatStr][length];
	    });
	  };
	
	  _proto4.weekdays = function weekdays$1(length, format, defaultOK) {
	    var _this2 = this;
	
	    if (format === void 0) {
	      format = false;
	    }
	
	    if (defaultOK === void 0) {
	      defaultOK = true;
	    }
	
	    return listStuff(this, length, defaultOK, weekdays, function () {
	      var intl = format ? {
	        weekday: length,
	        year: "numeric",
	        month: "long",
	        day: "numeric"
	      } : {
	        weekday: length
	      },
	          formatStr = format ? "format" : "standalone";
	
	      if (!_this2.weekdaysCache[formatStr][length]) {
	        _this2.weekdaysCache[formatStr][length] = mapWeekdays(function (dt) {
	          return _this2.extract(dt, intl, "weekday");
	        });
	      }
	
	      return _this2.weekdaysCache[formatStr][length];
	    });
	  };
	
	  _proto4.meridiems = function meridiems$1(defaultOK) {
	    var _this3 = this;
	
	    if (defaultOK === void 0) {
	      defaultOK = true;
	    }
	
	    return listStuff(this, undefined, defaultOK, function () {
	      return meridiems;
	    }, function () {
	      // In theory there could be aribitrary day periods. We're gonna assume there are exactly two
	      // for AM and PM. This is probably wrong, but it's makes parsing way easier.
	      if (!_this3.meridiemCache) {
	        var intl = {
	          hour: "numeric",
	          hour12: true
	        };
	        _this3.meridiemCache = [DateTime.utc(2016, 11, 13, 9), DateTime.utc(2016, 11, 13, 19)].map(function (dt) {
	          return _this3.extract(dt, intl, "dayperiod");
	        });
	      }
	
	      return _this3.meridiemCache;
	    });
	  };
	
	  _proto4.eras = function eras$1(length, defaultOK) {
	    var _this4 = this;
	
	    if (defaultOK === void 0) {
	      defaultOK = true;
	    }
	
	    return listStuff(this, length, defaultOK, eras, function () {
	      var intl = {
	        era: length
	      }; // This is utter bullshit. Different calendars are going to define eras totally differently. What I need is the minimum set of dates
	      // to definitely enumerate them.
	
	      if (!_this4.eraCache[length]) {
	        _this4.eraCache[length] = [DateTime.utc(-40, 1, 1), DateTime.utc(2017, 1, 1)].map(function (dt) {
	          return _this4.extract(dt, intl, "era");
	        });
	      }
	
	      return _this4.eraCache[length];
	    });
	  };
	
	  _proto4.extract = function extract(dt, intlOpts, field) {
	    var df = this.dtFormatter(dt, intlOpts),
	        results = df.formatToParts(),
	        matching = results.find(function (m) {
	      return m.type.toLowerCase() === field;
	    });
	    return matching ? matching.value : null;
	  };
	
	  _proto4.numberFormatter = function numberFormatter(opts) {
	    if (opts === void 0) {
	      opts = {};
	    }
	
	    // this forcesimple option is never used (the only caller short-circuits on it, but it seems safer to leave)
	    // (in contrast, the rest of the condition is used heavily)
	    return new PolyNumberFormatter(this.intl, opts.forceSimple || this.fastNumbers, opts);
	  };
	
	  _proto4.dtFormatter = function dtFormatter(dt, intlOpts) {
	    if (intlOpts === void 0) {
	      intlOpts = {};
	    }
	
	    return new PolyDateFormatter(dt, this.intl, intlOpts);
	  };
	
	  _proto4.relFormatter = function relFormatter(opts) {
	    if (opts === void 0) {
	      opts = {};
	    }
	
	    return new PolyRelFormatter(this.intl, this.isEnglish(), opts);
	  };
	
	  _proto4.isEnglish = function isEnglish() {
	    return this.locale === "en" || this.locale.toLowerCase() === "en-us" || hasIntl() && Intl.DateTimeFormat(this.intl).resolvedOptions().locale.startsWith("en-us");
	  };
	
	  _proto4.equals = function equals(other) {
	    return this.locale === other.locale && this.numberingSystem === other.numberingSystem && this.outputCalendar === other.outputCalendar;
	  };
	
	  _createClass(Locale, [{
	    key: "fastNumbers",
	    get: function get() {
	      if (this.fastNumbersCached == null) {
	        this.fastNumbersCached = supportsFastNumbers(this);
	      }
	
	      return this.fastNumbersCached;
	    }
	  }]);
	
	  return Locale;
	}();
	
	/*
	 * This file handles parsing for well-specified formats. Here's how it works:
	 * Two things go into parsing: a regex to match with and an extractor to take apart the groups in the match.
	 * An extractor is just a function that takes a regex match array and returns a { year: ..., month: ... } object
	 * parse() does the work of executing the regex and applying the extractor. It takes multiple regex/extractor pairs to try in sequence.
	 * Extractors can take a "cursor" representing the offset in the match to look at. This makes it easy to combine extractors.
	 * combineExtractors() does the work of combining them, keeping track of the cursor through multiple extractions.
	 * Some extractions are super dumb and simpleParse and fromStrings help DRY them.
	 */
	
	function combineRegexes() {
	  for (var _len = arguments.length, regexes = new Array(_len), _key = 0; _key < _len; _key++) {
	    regexes[_key] = arguments[_key];
	  }
	
	  var full = regexes.reduce(function (f, r) {
	    return f + r.source;
	  }, "");
	  return RegExp("^" + full + "$");
	}
	
	function combineExtractors() {
	  for (var _len2 = arguments.length, extractors = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	    extractors[_key2] = arguments[_key2];
	  }
	
	  return function (m) {
	    return extractors.reduce(function (_ref, ex) {
	      var mergedVals = _ref[0],
	          mergedZone = _ref[1],
	          cursor = _ref[2];
	
	      var _ex = ex(m, cursor),
	          val = _ex[0],
	          zone = _ex[1],
	          next = _ex[2];
	
	      return [Object.assign(mergedVals, val), mergedZone || zone, next];
	    }, [{}, null, 1]).slice(0, 2);
	  };
	}
	
	function parse(s) {
	  if (s == null) {
	    return [null, null];
	  }
	
	  for (var _len3 = arguments.length, patterns = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
	    patterns[_key3 - 1] = arguments[_key3];
	  }
	
	  for (var _i = 0, _patterns = patterns; _i < _patterns.length; _i++) {
	    var _patterns$_i = _patterns[_i],
	        regex = _patterns$_i[0],
	        extractor = _patterns$_i[1];
	    var m = regex.exec(s);
	
	    if (m) {
	      return extractor(m);
	    }
	  }
	
	  return [null, null];
	}
	
	function simpleParse() {
	  for (var _len4 = arguments.length, keys = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
	    keys[_key4] = arguments[_key4];
	  }
	
	  return function (match, cursor) {
	    var ret = {};
	    var i;
	
	    for (i = 0; i < keys.length; i++) {
	      ret[keys[i]] = parseInteger(match[cursor + i]);
	    }
	
	    return [ret, null, cursor + i];
	  };
	} // ISO and SQL parsing
	
	
	var offsetRegex = /(?:(Z)|([+-]\d\d)(?::?(\d\d))?)/,
	    isoTimeBaseRegex = /(\d\d)(?::?(\d\d)(?::?(\d\d)(?:[.,](\d{1,9}))?)?)?/,
	    isoTimeRegex = RegExp("" + isoTimeBaseRegex.source + offsetRegex.source + "?"),
	    isoTimeExtensionRegex = RegExp("(?:T" + isoTimeRegex.source + ")?"),
	    isoYmdRegex = /([+-]\d{6}|\d{4})(?:-?(\d\d)(?:-?(\d\d))?)?/,
	    isoWeekRegex = /(\d{4})-?W(\d\d)(?:-?(\d))?/,
	    isoOrdinalRegex = /(\d{4})-?(\d{3})/,
	    extractISOWeekData = simpleParse("weekYear", "weekNumber", "weekDay"),
	    extractISOOrdinalData = simpleParse("year", "ordinal"),
	    sqlYmdRegex = /(\d{4})-(\d\d)-(\d\d)/,
	    // dumbed-down version of the ISO one
	sqlTimeRegex = RegExp(isoTimeBaseRegex.source + " ?(?:" + offsetRegex.source + "|(" + ianaRegex.source + "))?"),
	    sqlTimeExtensionRegex = RegExp("(?: " + sqlTimeRegex.source + ")?");
	
	function extractISOYmd(match, cursor) {
	  var item = {
	    year: parseInteger(match[cursor]),
	    month: parseInteger(match[cursor + 1]) || 1,
	    day: parseInteger(match[cursor + 2]) || 1
	  };
	  return [item, null, cursor + 3];
	}
	
	function extractISOTime(match, cursor) {
	  var item = {
	    hour: parseInteger(match[cursor]) || 0,
	    minute: parseInteger(match[cursor + 1]) || 0,
	    second: parseInteger(match[cursor + 2]) || 0,
	    millisecond: parseMillis(match[cursor + 3])
	  };
	  return [item, null, cursor + 4];
	}
	
	function extractISOOffset(match, cursor) {
	  var local = !match[cursor] && !match[cursor + 1],
	      fullOffset = signedOffset(match[cursor + 1], match[cursor + 2]),
	      zone = local ? null : FixedOffsetZone.instance(fullOffset);
	  return [{}, zone, cursor + 3];
	}
	
	function extractIANAZone(match, cursor) {
	  var zone = match[cursor] ? IANAZone.create(match[cursor]) : null;
	  return [{}, zone, cursor + 1];
	} // ISO duration parsing
	
	
	var isoDuration = /^P(?:(?:(-?\d{1,9})Y)?(?:(-?\d{1,9})M)?(?:(-?\d{1,9})W)?(?:(-?\d{1,9})D)?(?:T(?:(-?\d{1,9})H)?(?:(-?\d{1,9})M)?(?:(-?\d{1,9})(?:[.,](-?\d{1,9}))?S)?)?)$/;
	
	function extractISODuration(match) {
	  var yearStr = match[1],
	      monthStr = match[2],
	      weekStr = match[3],
	      dayStr = match[4],
	      hourStr = match[5],
	      minuteStr = match[6],
	      secondStr = match[7],
	      millisecondsStr = match[8];
	  return [{
	    years: parseInteger(yearStr),
	    months: parseInteger(monthStr),
	    weeks: parseInteger(weekStr),
	    days: parseInteger(dayStr),
	    hours: parseInteger(hourStr),
	    minutes: parseInteger(minuteStr),
	    seconds: parseInteger(secondStr),
	    milliseconds: parseMillis(millisecondsStr)
	  }];
	} // These are a little braindead. EDT *should* tell us that we're in, say, America/New_York
	// and not just that we're in -240 *right now*. But since I don't think these are used that often
	// I'm just going to ignore that
	
	
	var obsOffsets = {
	  GMT: 0,
	  EDT: -4 * 60,
	  EST: -5 * 60,
	  CDT: -5 * 60,
	  CST: -6 * 60,
	  MDT: -6 * 60,
	  MST: -7 * 60,
	  PDT: -7 * 60,
	  PST: -8 * 60
	};
	
	function fromStrings(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
	  var result = {
	    year: yearStr.length === 2 ? untruncateYear(parseInteger(yearStr)) : parseInteger(yearStr),
	    month: monthsShort.indexOf(monthStr) + 1,
	    day: parseInteger(dayStr),
	    hour: parseInteger(hourStr),
	    minute: parseInteger(minuteStr)
	  };
	  if (secondStr) result.second = parseInteger(secondStr);
	
	  if (weekdayStr) {
	    result.weekday = weekdayStr.length > 3 ? weekdaysLong.indexOf(weekdayStr) + 1 : weekdaysShort.indexOf(weekdayStr) + 1;
	  }
	
	  return result;
	} // RFC 2822/5322
	
	
	var rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|(?:([+-]\d\d)(\d\d)))$/;
	
	function extractRFC2822(match) {
	  var weekdayStr = match[1],
	      dayStr = match[2],
	      monthStr = match[3],
	      yearStr = match[4],
	      hourStr = match[5],
	      minuteStr = match[6],
	      secondStr = match[7],
	      obsOffset = match[8],
	      milOffset = match[9],
	      offHourStr = match[10],
	      offMinuteStr = match[11],
	      result = fromStrings(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr);
	  var offset;
	
	  if (obsOffset) {
	    offset = obsOffsets[obsOffset];
	  } else if (milOffset) {
	    offset = 0;
	  } else {
	    offset = signedOffset(offHourStr, offMinuteStr);
	  }
	
	  return [result, new FixedOffsetZone(offset)];
	}
	
	function preprocessRFC2822(s) {
	  // Remove comments and folding whitespace and replace multiple-spaces with a single space
	  return s.replace(/\([^)]*\)|[\n\t]/g, " ").replace(/(\s\s+)/g, " ").trim();
	} // http date
	
	
	var rfc1123 = /^(Mon|Tue|Wed|Thu|Fri|Sat|Sun), (\d\d) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) (\d{4}) (\d\d):(\d\d):(\d\d) GMT$/,
	    rfc850 = /^(Monday|Tuesday|Wedsday|Thursday|Friday|Saturday|Sunday), (\d\d)-(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)-(\d\d) (\d\d):(\d\d):(\d\d) GMT$/,
	    ascii = /^(Mon|Tue|Wed|Thu|Fri|Sat|Sun) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) ( \d|\d\d) (\d\d):(\d\d):(\d\d) (\d{4})$/;
	
	function extractRFC1123Or850(match) {
	  var weekdayStr = match[1],
	      dayStr = match[2],
	      monthStr = match[3],
	      yearStr = match[4],
	      hourStr = match[5],
	      minuteStr = match[6],
	      secondStr = match[7],
	      result = fromStrings(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr);
	  return [result, FixedOffsetZone.utcInstance];
	}
	
	function extractASCII(match) {
	  var weekdayStr = match[1],
	      monthStr = match[2],
	      dayStr = match[3],
	      hourStr = match[4],
	      minuteStr = match[5],
	      secondStr = match[6],
	      yearStr = match[7],
	      result = fromStrings(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr);
	  return [result, FixedOffsetZone.utcInstance];
	}
	
	var isoYmdWithTimeExtensionRegex = combineRegexes(isoYmdRegex, isoTimeExtensionRegex);
	var isoWeekWithTimeExtensionRegex = combineRegexes(isoWeekRegex, isoTimeExtensionRegex);
	var isoOrdinalWithTimeExtensionRegex = combineRegexes(isoOrdinalRegex, isoTimeExtensionRegex);
	var isoTimeCombinedRegex = combineRegexes(isoTimeRegex);
	var extractISOYmdTimeAndOffset = combineExtractors(extractISOYmd, extractISOTime, extractISOOffset);
	var extractISOWeekTimeAndOffset = combineExtractors(extractISOWeekData, extractISOTime, extractISOOffset);
	var extractISOOrdinalDataAndTime = combineExtractors(extractISOOrdinalData, extractISOTime);
	var extractISOTimeAndOffset = combineExtractors(extractISOTime, extractISOOffset);
	/**
	 * @private
	 */
	
	function parseISODate(s) {
	  return parse(s, [isoYmdWithTimeExtensionRegex, extractISOYmdTimeAndOffset], [isoWeekWithTimeExtensionRegex, extractISOWeekTimeAndOffset], [isoOrdinalWithTimeExtensionRegex, extractISOOrdinalDataAndTime], [isoTimeCombinedRegex, extractISOTimeAndOffset]);
	}
	function parseRFC2822Date(s) {
	  return parse(preprocessRFC2822(s), [rfc2822, extractRFC2822]);
	}
	function parseHTTPDate(s) {
	  return parse(s, [rfc1123, extractRFC1123Or850], [rfc850, extractRFC1123Or850], [ascii, extractASCII]);
	}
	function parseISODuration(s) {
	  return parse(s, [isoDuration, extractISODuration]);
	}
	var sqlYmdWithTimeExtensionRegex = combineRegexes(sqlYmdRegex, sqlTimeExtensionRegex);
	var sqlTimeCombinedRegex = combineRegexes(sqlTimeRegex);
	var extractISOYmdTimeOffsetAndIANAZone = combineExtractors(extractISOYmd, extractISOTime, extractISOOffset, extractIANAZone);
	var extractISOTimeOffsetAndIANAZone = combineExtractors(extractISOTime, extractISOOffset, extractIANAZone);
	function parseSQL(s) {
	  return parse(s, [sqlYmdWithTimeExtensionRegex, extractISOYmdTimeOffsetAndIANAZone], [sqlTimeCombinedRegex, extractISOTimeOffsetAndIANAZone]);
	}
	
	var Invalid =
	/*#__PURE__*/
	function () {
	  function Invalid(reason, explanation) {
	    this.reason = reason;
	    this.explanation = explanation;
	  }
	
	  var _proto = Invalid.prototype;
	
	  _proto.toMessage = function toMessage() {
	    if (this.explanation) {
	      return this.reason + ": " + this.explanation;
	    } else {
	      return this.reason;
	    }
	  };
	
	  return Invalid;
	}();
	
	var INVALID = "Invalid Duration"; // unit conversion constants
	
	var lowOrderMatrix = {
	  weeks: {
	    days: 7,
	    hours: 7 * 24,
	    minutes: 7 * 24 * 60,
	    seconds: 7 * 24 * 60 * 60,
	    milliseconds: 7 * 24 * 60 * 60 * 1000
	  },
	  days: {
	    hours: 24,
	    minutes: 24 * 60,
	    seconds: 24 * 60 * 60,
	    milliseconds: 24 * 60 * 60 * 1000
	  },
	  hours: {
	    minutes: 60,
	    seconds: 60 * 60,
	    milliseconds: 60 * 60 * 1000
	  },
	  minutes: {
	    seconds: 60,
	    milliseconds: 60 * 1000
	  },
	  seconds: {
	    milliseconds: 1000
	  }
	},
	    casualMatrix = Object.assign({
	  years: {
	    months: 12,
	    weeks: 52,
	    days: 365,
	    hours: 365 * 24,
	    minutes: 365 * 24 * 60,
	    seconds: 365 * 24 * 60 * 60,
	    milliseconds: 365 * 24 * 60 * 60 * 1000
	  },
	  quarters: {
	    months: 3,
	    weeks: 13,
	    days: 91,
	    hours: 91 * 24,
	    minutes: 91 * 24 * 60,
	    milliseconds: 91 * 24 * 60 * 60 * 1000
	  },
	  months: {
	    weeks: 4,
	    days: 30,
	    hours: 30 * 24,
	    minutes: 30 * 24 * 60,
	    seconds: 30 * 24 * 60 * 60,
	    milliseconds: 30 * 24 * 60 * 60 * 1000
	  }
	}, lowOrderMatrix),
	    daysInYearAccurate = 146097.0 / 400,
	    daysInMonthAccurate = 146097.0 / 4800,
	    accurateMatrix = Object.assign({
	  years: {
	    months: 12,
	    weeks: daysInYearAccurate / 7,
	    days: daysInYearAccurate,
	    hours: daysInYearAccurate * 24,
	    minutes: daysInYearAccurate * 24 * 60,
	    seconds: daysInYearAccurate * 24 * 60 * 60,
	    milliseconds: daysInYearAccurate * 24 * 60 * 60 * 1000
	  },
	  quarters: {
	    months: 3,
	    weeks: daysInYearAccurate / 28,
	    days: daysInYearAccurate / 4,
	    hours: daysInYearAccurate * 24 / 4,
	    minutes: daysInYearAccurate * 24 * 60 / 4,
	    seconds: daysInYearAccurate * 24 * 60 * 60 / 4,
	    milliseconds: daysInYearAccurate * 24 * 60 * 60 * 1000 / 4
	  },
	  months: {
	    weeks: daysInMonthAccurate / 7,
	    days: daysInMonthAccurate,
	    hours: daysInMonthAccurate * 24,
	    minutes: daysInMonthAccurate * 24 * 60,
	    seconds: daysInMonthAccurate * 24 * 60 * 60,
	    milliseconds: daysInMonthAccurate * 24 * 60 * 60 * 1000
	  }
	}, lowOrderMatrix); // units ordered by size
	
	var orderedUnits = ["years", "quarters", "months", "weeks", "days", "hours", "minutes", "seconds", "milliseconds"];
	var reverseUnits = orderedUnits.slice(0).reverse(); // clone really means "create another instance just like this one, but with these changes"
	
	function clone(dur, alts, clear) {
	  if (clear === void 0) {
	    clear = false;
	  }
	
	  // deep merge for vals
	  var conf = {
	    values: clear ? alts.values : Object.assign({}, dur.values, alts.values || {}),
	    loc: dur.loc.clone(alts.loc),
	    conversionAccuracy: alts.conversionAccuracy || dur.conversionAccuracy
	  };
	  return new Duration(conf);
	}
	
	function antiTrunc(n) {
	  return n < 0 ? Math.floor(n) : Math.ceil(n);
	} // NB: mutates parameters
	
	
	function convert(matrix, fromMap, fromUnit, toMap, toUnit) {
	  var conv = matrix[toUnit][fromUnit],
	      raw = fromMap[fromUnit] / conv,
	      sameSign = Math.sign(raw) === Math.sign(toMap[toUnit]),
	      // ok, so this is wild, but see the matrix in the tests
	  added = !sameSign && toMap[toUnit] !== 0 && Math.abs(raw) <= 1 ? antiTrunc(raw) : Math.trunc(raw);
	  toMap[toUnit] += added;
	  fromMap[fromUnit] -= added * conv;
	} // NB: mutates parameters
	
	
	function normalizeValues(matrix, vals) {
	  reverseUnits.reduce(function (previous, current) {
	    if (!isUndefined(vals[current])) {
	      if (previous) {
	        convert(matrix, vals, previous, vals, current);
	      }
	
	      return current;
	    } else {
	      return previous;
	    }
	  }, null);
	}
	/**
	 * A Duration object represents a period of time, like "2 months" or "1 day, 1 hour". Conceptually, it's just a map of units to their quantities, accompanied by some additional configuration and methods for creating, parsing, interrogating, transforming, and formatting them. They can be used on their own or in conjunction with other Luxon types; for example, you can use {@link DateTime.plus} to add a Duration object to a DateTime, producing another DateTime.
	 *
	 * Here is a brief overview of commonly used methods and getters in Duration:
	 *
	 * * **Creation** To create a Duration, use {@link Duration.fromMillis}, {@link Duration.fromObject}, or {@link Duration.fromISO}.
	 * * **Unit values** See the {@link Duration.years}, {@link Duration.months}, {@link Duration.weeks}, {@link Duration.days}, {@link Duration.hours}, {@link Duration.minutes}, {@link Duration.seconds}, {@link Duration.milliseconds} accessors.
	 * * **Configuration** See  {@link Duration.locale} and {@link Duration.numberingSystem} accessors.
	 * * **Transformation** To create new Durations out of old ones use {@link Duration.plus}, {@link Duration.minus}, {@link Duration.normalize}, {@link Duration.set}, {@link Duration.reconfigure}, {@link Duration.shiftTo}, and {@link Duration.negate}.
	 * * **Output** To convert the Duration into other representations, see {@link Duration.as}, {@link Duration.toISO}, {@link Duration.toFormat}, and {@link Duration.toJSON}
	 *
	 * There's are more methods documented below. In addition, for more information on subtler topics like internationalization and validity, see the external documentation.
	 */
	
	
	var Duration =
	/*#__PURE__*/
	function () {
	  /**
	   * @private
	   */
	  function Duration(config) {
	    var accurate = config.conversionAccuracy === "longterm" || false;
	    /**
	     * @access private
	     */
	
	    this.values = config.values;
	    /**
	     * @access private
	     */
	
	    this.loc = config.loc || Locale.create();
	    /**
	     * @access private
	     */
	
	    this.conversionAccuracy = accurate ? "longterm" : "casual";
	    /**
	     * @access private
	     */
	
	    this.invalid = config.invalid || null;
	    /**
	     * @access private
	     */
	
	    this.matrix = accurate ? accurateMatrix : casualMatrix;
	    /**
	     * @access private
	     */
	
	    this.isLuxonDuration = true;
	  }
	  /**
	   * Create Duration from a number of milliseconds.
	   * @param {number} count of milliseconds
	   * @param {Object} opts - options for parsing
	   * @param {string} [opts.locale='en-US'] - the locale to use
	   * @param {string} opts.numberingSystem - the numbering system to use
	   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
	   * @return {Duration}
	   */
	
	
	  Duration.fromMillis = function fromMillis(count, opts) {
	    return Duration.fromObject(Object.assign({
	      milliseconds: count
	    }, opts));
	  }
	  /**
	   * Create a Duration from a Javascript object with keys like 'years' and 'hours.
	   * If this object is empty then a zero milliseconds duration is returned.
	   * @param {Object} obj - the object to create the DateTime from
	   * @param {number} obj.years
	   * @param {number} obj.quarters
	   * @param {number} obj.months
	   * @param {number} obj.weeks
	   * @param {number} obj.days
	   * @param {number} obj.hours
	   * @param {number} obj.minutes
	   * @param {number} obj.seconds
	   * @param {number} obj.milliseconds
	   * @param {string} [obj.locale='en-US'] - the locale to use
	   * @param {string} obj.numberingSystem - the numbering system to use
	   * @param {string} [obj.conversionAccuracy='casual'] - the conversion system to use
	   * @return {Duration}
	   */
	  ;
	
	  Duration.fromObject = function fromObject(obj) {
	    if (obj == null || typeof obj !== "object") {
	      throw new InvalidArgumentError("Duration.fromObject: argument expected to be an object, got " + typeof obj);
	    }
	
	    return new Duration({
	      values: normalizeObject(obj, Duration.normalizeUnit, ["locale", "numberingSystem", "conversionAccuracy", "zone" // a bit of debt; it's super inconvenient internally not to be able to blindly pass this
	      ]),
	      loc: Locale.fromObject(obj),
	      conversionAccuracy: obj.conversionAccuracy
	    });
	  }
	  /**
	   * Create a Duration from an ISO 8601 duration string.
	   * @param {string} text - text to parse
	   * @param {Object} opts - options for parsing
	   * @param {string} [opts.locale='en-US'] - the locale to use
	   * @param {string} opts.numberingSystem - the numbering system to use
	   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
	   * @see https://en.wikipedia.org/wiki/ISO_8601#Durations
	   * @example Duration.fromISO('P3Y6M1W4DT12H30M5S').toObject() //=> { years: 3, months: 6, weeks: 1, days: 4, hours: 12, minutes: 30, seconds: 5 }
	   * @example Duration.fromISO('PT23H').toObject() //=> { hours: 23 }
	   * @example Duration.fromISO('P5Y3M').toObject() //=> { years: 5, months: 3 }
	   * @return {Duration}
	   */
	  ;
	
	  Duration.fromISO = function fromISO(text, opts) {
	    var _parseISODuration = parseISODuration(text),
	        parsed = _parseISODuration[0];
	
	    if (parsed) {
	      var obj = Object.assign(parsed, opts);
	      return Duration.fromObject(obj);
	    } else {
	      return Duration.invalid("unparsable", "the input \"" + text + "\" can't be parsed as ISO 8601");
	    }
	  }
	  /**
	   * Create an invalid Duration.
	   * @param {string} reason - simple string of why this datetime is invalid. Should not contain parameters or anything else data-dependent
	   * @param {string} [explanation=null] - longer explanation, may include parameters and other useful debugging information
	   * @return {Duration}
	   */
	  ;
	
	  Duration.invalid = function invalid(reason, explanation) {
	    if (explanation === void 0) {
	      explanation = null;
	    }
	
	    if (!reason) {
	      throw new InvalidArgumentError("need to specify a reason the Duration is invalid");
	    }
	
	    var invalid = reason instanceof Invalid ? reason : new Invalid(reason, explanation);
	
	    if (Settings.throwOnInvalid) {
	      throw new InvalidDurationError(invalid);
	    } else {
	      return new Duration({
	        invalid: invalid
	      });
	    }
	  }
	  /**
	   * @private
	   */
	  ;
	
	  Duration.normalizeUnit = function normalizeUnit(unit) {
	    var normalized = {
	      year: "years",
	      years: "years",
	      quarter: "quarters",
	      quarters: "quarters",
	      month: "months",
	      months: "months",
	      week: "weeks",
	      weeks: "weeks",
	      day: "days",
	      days: "days",
	      hour: "hours",
	      hours: "hours",
	      minute: "minutes",
	      minutes: "minutes",
	      second: "seconds",
	      seconds: "seconds",
	      millisecond: "milliseconds",
	      milliseconds: "milliseconds"
	    }[unit ? unit.toLowerCase() : unit];
	    if (!normalized) throw new InvalidUnitError(unit);
	    return normalized;
	  }
	  /**
	   * Check if an object is a Duration. Works across context boundaries
	   * @param {object} o
	   * @return {boolean}
	   */
	  ;
	
	  Duration.isDuration = function isDuration(o) {
	    return o && o.isLuxonDuration || false;
	  }
	  /**
	   * Get  the locale of a Duration, such 'en-GB'
	   * @type {string}
	   */
	  ;
	
	  var _proto = Duration.prototype;
	
	  /**
	   * Returns a string representation of this Duration formatted according to the specified format string. You may use these tokens:
	   * * `S` for milliseconds
	   * * `s` for seconds
	   * * `m` for minutes
	   * * `h` for hours
	   * * `d` for days
	   * * `M` for months
	   * * `y` for years
	   * Notes:
	   * * Add padding by repeating the token, e.g. "yy" pads the years to two digits, "hhhh" pads the hours out to four digits
	   * * The duration will be converted to the set of units in the format string using {@link Duration.shiftTo} and the Durations's conversion accuracy setting.
	   * @param {string} fmt - the format string
	   * @param {Object} opts - options
	   * @param {boolean} [opts.floor=true] - floor numerical values
	   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("y d s") //=> "1 6 2"
	   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("yy dd sss") //=> "01 06 002"
	   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("M S") //=> "12 518402000"
	   * @return {string}
	   */
	  _proto.toFormat = function toFormat(fmt, opts) {
	    if (opts === void 0) {
	      opts = {};
	    }
	
	    // reverse-compat since 1.2; we always round down now, never up, and we do it by default
	    var fmtOpts = Object.assign({}, opts, {
	      floor: opts.round !== false && opts.floor !== false
	    });
	    return this.isValid ? Formatter.create(this.loc, fmtOpts).formatDurationFromString(this, fmt) : INVALID;
	  }
	  /**
	   * Returns a Javascript object with this Duration's values.
	   * @param opts - options for generating the object
	   * @param {boolean} [opts.includeConfig=false] - include configuration attributes in the output
	   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toObject() //=> { years: 1, days: 6, seconds: 2 }
	   * @return {Object}
	   */
	  ;
	
	  _proto.toObject = function toObject(opts) {
	    if (opts === void 0) {
	      opts = {};
	    }
	
	    if (!this.isValid) return {};
	    var base = Object.assign({}, this.values);
	
	    if (opts.includeConfig) {
	      base.conversionAccuracy = this.conversionAccuracy;
	      base.numberingSystem = this.loc.numberingSystem;
	      base.locale = this.loc.locale;
	    }
	
	    return base;
	  }
	  /**
	   * Returns an ISO 8601-compliant string representation of this Duration.
	   * @see https://en.wikipedia.org/wiki/ISO_8601#Durations
	   * @example Duration.fromObject({ years: 3, seconds: 45 }).toISO() //=> 'P3YT45S'
	   * @example Duration.fromObject({ months: 4, seconds: 45 }).toISO() //=> 'P4MT45S'
	   * @example Duration.fromObject({ months: 5 }).toISO() //=> 'P5M'
	   * @example Duration.fromObject({ minutes: 5 }).toISO() //=> 'PT5M'
	   * @example Duration.fromObject({ milliseconds: 6 }).toISO() //=> 'PT0.006S'
	   * @return {string}
	   */
	  ;
	
	  _proto.toISO = function toISO() {
	    // we could use the formatter, but this is an easier way to get the minimum string
	    if (!this.isValid) return null;
	    var s = "P";
	    if (this.years !== 0) s += this.years + "Y";
	    if (this.months !== 0 || this.quarters !== 0) s += this.months + this.quarters * 3 + "M";
	    if (this.weeks !== 0) s += this.weeks + "W";
	    if (this.days !== 0) s += this.days + "D";
	    if (this.hours !== 0 || this.minutes !== 0 || this.seconds !== 0 || this.milliseconds !== 0) s += "T";
	    if (this.hours !== 0) s += this.hours + "H";
	    if (this.minutes !== 0) s += this.minutes + "M";
	    if (this.seconds !== 0 || this.milliseconds !== 0) s += this.seconds + this.milliseconds / 1000 + "S";
	    if (s === "P") s += "T0S";
	    return s;
	  }
	  /**
	   * Returns an ISO 8601 representation of this Duration appropriate for use in JSON.
	   * @return {string}
	   */
	  ;
	
	  _proto.toJSON = function toJSON() {
	    return this.toISO();
	  }
	  /**
	   * Returns an ISO 8601 representation of this Duration appropriate for use in debugging.
	   * @return {string}
	   */
	  ;
	
	  _proto.toString = function toString() {
	    return this.toISO();
	  }
	  /**
	   * Returns an milliseconds value of this Duration.
	   * @return {number}
	   */
	  ;
	
	  _proto.valueOf = function valueOf() {
	    return this.as("milliseconds");
	  }
	  /**
	   * Make this Duration longer by the specified amount. Return a newly-constructed Duration.
	   * @param {Duration|Object|number} duration - The amount to add. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
	   * @return {Duration}
	   */
	  ;
	
	  _proto.plus = function plus(duration) {
	    if (!this.isValid) return this;
	    var dur = friendlyDuration(duration),
	        result = {};
	
	    for (var _i = 0, _orderedUnits = orderedUnits; _i < _orderedUnits.length; _i++) {
	      var k = _orderedUnits[_i];
	
	      if (dur.values.hasOwnProperty(k) || this.values.hasOwnProperty(k)) {
	        result[k] = dur.get(k) + this.get(k);
	      }
	    }
	
	    return clone(this, {
	      values: result
	    }, true);
	  }
	  /**
	   * Make this Duration shorter by the specified amount. Return a newly-constructed Duration.
	   * @param {Duration|Object|number} duration - The amount to subtract. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
	   * @return {Duration}
	   */
	  ;
	
	  _proto.minus = function minus(duration) {
	    if (!this.isValid) return this;
	    var dur = friendlyDuration(duration);
	    return this.plus(dur.negate());
	  }
	  /**
	   * Get the value of unit.
	   * @param {string} unit - a unit such as 'minute' or 'day'
	   * @example Duration.fromObject({years: 2, days: 3}).years //=> 2
	   * @example Duration.fromObject({years: 2, days: 3}).months //=> 0
	   * @example Duration.fromObject({years: 2, days: 3}).days //=> 3
	   * @return {number}
	   */
	  ;
	
	  _proto.get = function get(unit) {
	    return this[Duration.normalizeUnit(unit)];
	  }
	  /**
	   * "Set" the values of specified units. Return a newly-constructed Duration.
	   * @param {Object} values - a mapping of units to numbers
	   * @example dur.set({ years: 2017 })
	   * @example dur.set({ hours: 8, minutes: 30 })
	   * @return {Duration}
	   */
	  ;
	
	  _proto.set = function set(values) {
	    if (!this.isValid) return this;
	    var mixed = Object.assign(this.values, normalizeObject(values, Duration.normalizeUnit, []));
	    return clone(this, {
	      values: mixed
	    });
	  }
	  /**
	   * "Set" the locale and/or numberingSystem.  Returns a newly-constructed Duration.
	   * @example dur.reconfigure({ locale: 'en-GB' })
	   * @return {Duration}
	   */
	  ;
	
	  _proto.reconfigure = function reconfigure(_temp) {
	    var _ref = _temp === void 0 ? {} : _temp,
	        locale = _ref.locale,
	        numberingSystem = _ref.numberingSystem,
	        conversionAccuracy = _ref.conversionAccuracy;
	
	    var loc = this.loc.clone({
	      locale: locale,
	      numberingSystem: numberingSystem
	    }),
	        opts = {
	      loc: loc
	    };
	
	    if (conversionAccuracy) {
	      opts.conversionAccuracy = conversionAccuracy;
	    }
	
	    return clone(this, opts);
	  }
	  /**
	   * Return the length of the duration in the specified unit.
	   * @param {string} unit - a unit such as 'minutes' or 'days'
	   * @example Duration.fromObject({years: 1}).as('days') //=> 365
	   * @example Duration.fromObject({years: 1}).as('months') //=> 12
	   * @example Duration.fromObject({hours: 60}).as('days') //=> 2.5
	   * @return {number}
	   */
	  ;
	
	  _proto.as = function as(unit) {
	    return this.isValid ? this.shiftTo(unit).get(unit) : NaN;
	  }
	  /**
	   * Reduce this Duration to its canonical representation in its current units.
	   * @example Duration.fromObject({ years: 2, days: 5000 }).normalize().toObject() //=> { years: 15, days: 255 }
	   * @example Duration.fromObject({ hours: 12, minutes: -45 }).normalize().toObject() //=> { hours: 11, minutes: 15 }
	   * @return {Duration}
	   */
	  ;
	
	  _proto.normalize = function normalize() {
	    if (!this.isValid) return this;
	    var vals = this.toObject();
	    normalizeValues(this.matrix, vals);
	    return Duration.fromObject(vals);
	  }
	  /**
	   * Convert this Duration into its representation in a different set of units.
	   * @example Duration.fromObject({ hours: 1, seconds: 30 }).shiftTo('minutes', 'milliseconds').toObject() //=> { minutes: 60, milliseconds: 30000 }
	   * @return {Duration}
	   */
	  ;
	
	  _proto.shiftTo = function shiftTo() {
	    for (var _len = arguments.length, units = new Array(_len), _key = 0; _key < _len; _key++) {
	      units[_key] = arguments[_key];
	    }
	
	    if (!this.isValid) return this;
	
	    if (units.length === 0) {
	      return this;
	    }
	
	    units = units.map(function (u) {
	      return Duration.normalizeUnit(u);
	    });
	    var built = {},
	        accumulated = {},
	        vals = this.toObject();
	    var lastUnit;
	    normalizeValues(this.matrix, vals);
	
	    for (var _i2 = 0, _orderedUnits2 = orderedUnits; _i2 < _orderedUnits2.length; _i2++) {
	      var k = _orderedUnits2[_i2];
	
	      if (units.indexOf(k) >= 0) {
	        lastUnit = k;
	        var own = 0; // anything we haven't boiled down yet should get boiled to this unit
	
	        for (var ak in accumulated) {
	          own += this.matrix[ak][k] * accumulated[ak];
	          accumulated[ak] = 0;
	        } // plus anything that's already in this unit
	
	
	        if (isNumber(vals[k])) {
	          own += vals[k];
	        }
	
	        var i = Math.trunc(own);
	        built[k] = i;
	        accumulated[k] = own - i; // we'd like to absorb these fractions in another unit
	        // plus anything further down the chain that should be rolled up in to this
	
	        for (var down in vals) {
	          if (orderedUnits.indexOf(down) > orderedUnits.indexOf(k)) {
	            convert(this.matrix, vals, down, built, k);
	          }
	        } // otherwise, keep it in the wings to boil it later
	
	      } else if (isNumber(vals[k])) {
	        accumulated[k] = vals[k];
	      }
	    } // anything leftover becomes the decimal for the last unit
	    // lastUnit must be defined since units is not empty
	
	
	    for (var key in accumulated) {
	      if (accumulated[key] !== 0) {
	        built[lastUnit] += key === lastUnit ? accumulated[key] : accumulated[key] / this.matrix[lastUnit][key];
	      }
	    }
	
	    return clone(this, {
	      values: built
	    }, true);
	  }
	  /**
	   * Return the negative of this Duration.
	   * @example Duration.fromObject({ hours: 1, seconds: 30 }).negate().toObject() //=> { hours: -1, seconds: -30 }
	   * @return {Duration}
	   */
	  ;
	
	  _proto.negate = function negate() {
	    if (!this.isValid) return this;
	    var negated = {};
	
	    for (var _i3 = 0, _Object$keys = Object.keys(this.values); _i3 < _Object$keys.length; _i3++) {
	      var k = _Object$keys[_i3];
	      negated[k] = -this.values[k];
	    }
	
	    return clone(this, {
	      values: negated
	    }, true);
	  }
	  /**
	   * Get the years.
	   * @type {number}
	   */
	  ;
	
	  /**
	   * Equality check
	   * Two Durations are equal iff they have the same units and the same values for each unit.
	   * @param {Duration} other
	   * @return {boolean}
	   */
	  _proto.equals = function equals(other) {
	    if (!this.isValid || !other.isValid) {
	      return false;
	    }
	
	    if (!this.loc.equals(other.loc)) {
	      return false;
	    }
	
	    for (var _i4 = 0, _orderedUnits3 = orderedUnits; _i4 < _orderedUnits3.length; _i4++) {
	      var u = _orderedUnits3[_i4];
	
	      if (this.values[u] !== other.values[u]) {
	        return false;
	      }
	    }
	
	    return true;
	  };
	
	  _createClass(Duration, [{
	    key: "locale",
	    get: function get() {
	      return this.isValid ? this.loc.locale : null;
	    }
	    /**
	     * Get the numbering system of a Duration, such 'beng'. The numbering system is used when formatting the Duration
	     *
	     * @type {string}
	     */
	
	  }, {
	    key: "numberingSystem",
	    get: function get() {
	      return this.isValid ? this.loc.numberingSystem : null;
	    }
	  }, {
	    key: "years",
	    get: function get() {
	      return this.isValid ? this.values.years || 0 : NaN;
	    }
	    /**
	     * Get the quarters.
	     * @type {number}
	     */
	
	  }, {
	    key: "quarters",
	    get: function get() {
	      return this.isValid ? this.values.quarters || 0 : NaN;
	    }
	    /**
	     * Get the months.
	     * @type {number}
	     */
	
	  }, {
	    key: "months",
	    get: function get() {
	      return this.isValid ? this.values.months || 0 : NaN;
	    }
	    /**
	     * Get the weeks
	     * @type {number}
	     */
	
	  }, {
	    key: "weeks",
	    get: function get() {
	      return this.isValid ? this.values.weeks || 0 : NaN;
	    }
	    /**
	     * Get the days.
	     * @type {number}
	     */
	
	  }, {
	    key: "days",
	    get: function get() {
	      return this.isValid ? this.values.days || 0 : NaN;
	    }
	    /**
	     * Get the hours.
	     * @type {number}
	     */
	
	  }, {
	    key: "hours",
	    get: function get() {
	      return this.isValid ? this.values.hours || 0 : NaN;
	    }
	    /**
	     * Get the minutes.
	     * @type {number}
	     */
	
	  }, {
	    key: "minutes",
	    get: function get() {
	      return this.isValid ? this.values.minutes || 0 : NaN;
	    }
	    /**
	     * Get the seconds.
	     * @return {number}
	     */
	
	  }, {
	    key: "seconds",
	    get: function get() {
	      return this.isValid ? this.values.seconds || 0 : NaN;
	    }
	    /**
	     * Get the milliseconds.
	     * @return {number}
	     */
	
	  }, {
	    key: "milliseconds",
	    get: function get() {
	      return this.isValid ? this.values.milliseconds || 0 : NaN;
	    }
	    /**
	     * Returns whether the Duration is invalid. Invalid durations are returned by diff operations
	     * on invalid DateTimes or Intervals.
	     * @return {boolean}
	     */
	
	  }, {
	    key: "isValid",
	    get: function get() {
	      return this.invalid === null;
	    }
	    /**
	     * Returns an error code if this Duration became invalid, or null if the Duration is valid
	     * @return {string}
	     */
	
	  }, {
	    key: "invalidReason",
	    get: function get() {
	      return this.invalid ? this.invalid.reason : null;
	    }
	    /**
	     * Returns an explanation of why this Duration became invalid, or null if the Duration is valid
	     * @type {string}
	     */
	
	  }, {
	    key: "invalidExplanation",
	    get: function get() {
	      return this.invalid ? this.invalid.explanation : null;
	    }
	  }]);
	
	  return Duration;
	}();
	function friendlyDuration(durationish) {
	  if (isNumber(durationish)) {
	    return Duration.fromMillis(durationish);
	  } else if (Duration.isDuration(durationish)) {
	    return durationish;
	  } else if (typeof durationish === "object") {
	    return Duration.fromObject(durationish);
	  } else {
	    throw new InvalidArgumentError("Unknown duration argument " + durationish + " of type " + typeof durationish);
	  }
	}
	
	var INVALID$1 = "Invalid Interval"; // checks if the start is equal to or before the end
	
	function validateStartEnd(start, end) {
	  if (!start || !start.isValid) {
	    return new Invalid("missing or invalid start");
	  } else if (!end || !end.isValid) {
	    return new Invalid("missing or invalid end");
	  } else if (end < start) {
	    return new Invalid("end before start", "The end of an interval must be after its start, but you had start=" + start.toISO() + " and end=" + end.toISO());
	  } else {
	    return null;
	  }
	}
	/**
	 * An Interval object represents a half-open interval of time, where each endpoint is a {@link DateTime}. Conceptually, it's a container for those two endpoints, accompanied by methods for creating, parsing, interrogating, comparing, transforming, and formatting them.
	 *
	 * Here is a brief overview of the most commonly used methods and getters in Interval:
	 *
	 * * **Creation** To create an Interval, use {@link fromDateTimes}, {@link after}, {@link before}, or {@link fromISO}.
	 * * **Accessors** Use {@link start} and {@link end} to get the start and end.
	 * * **Interrogation** To analyze the Interval, use {@link count}, {@link length}, {@link hasSame}, {@link contains}, {@link isAfter}, or {@link isBefore}.
	 * * **Transformation** To create other Intervals out of this one, use {@link set}, {@link splitAt}, {@link splitBy}, {@link divideEqually}, {@link merge}, {@link xor}, {@link union}, {@link intersection}, or {@link difference}.
	 * * **Comparison** To compare this Interval to another one, use {@link equals}, {@link overlaps}, {@link abutsStart}, {@link abutsEnd}, {@link engulfs}
	 * * **Output*** To convert the Interval into other representations, see {@link toString}, {@link toISO}, {@link toFormat}, and {@link toDuration}.
	 */
	
	
	var Interval =
	/*#__PURE__*/
	function () {
	  /**
	   * @private
	   */
	  function Interval(config) {
	    /**
	     * @access private
	     */
	    this.s = config.start;
	    /**
	     * @access private
	     */
	
	    this.e = config.end;
	    /**
	     * @access private
	     */
	
	    this.invalid = config.invalid || null;
	    /**
	     * @access private
	     */
	
	    this.isLuxonInterval = true;
	  }
	  /**
	   * Create an invalid Interval.
	   * @param {string} reason - simple string of why this Interval is invalid. Should not contain parameters or anything else data-dependent
	   * @param {string} [explanation=null] - longer explanation, may include parameters and other useful debugging information
	   * @return {Interval}
	   */
	
	
	  Interval.invalid = function invalid(reason, explanation) {
	    if (explanation === void 0) {
	      explanation = null;
	    }
	
	    if (!reason) {
	      throw new InvalidArgumentError("need to specify a reason the Interval is invalid");
	    }
	
	    var invalid = reason instanceof Invalid ? reason : new Invalid(reason, explanation);
	
	    if (Settings.throwOnInvalid) {
	      throw new InvalidIntervalError(invalid);
	    } else {
	      return new Interval({
	        invalid: invalid
	      });
	    }
	  }
	  /**
	   * Create an Interval from a start DateTime and an end DateTime. Inclusive of the start but not the end.
	   * @param {DateTime|Date|Object} start
	   * @param {DateTime|Date|Object} end
	   * @return {Interval}
	   */
	  ;
	
	  Interval.fromDateTimes = function fromDateTimes(start, end) {
	    var builtStart = friendlyDateTime(start),
	        builtEnd = friendlyDateTime(end);
	    return new Interval({
	      start: builtStart,
	      end: builtEnd,
	      invalid: validateStartEnd(builtStart, builtEnd)
	    });
	  }
	  /**
	   * Create an Interval from a start DateTime and a Duration to extend to.
	   * @param {DateTime|Date|Object} start
	   * @param {Duration|Object|number} duration - the length of the Interval.
	   * @return {Interval}
	   */
	  ;
	
	  Interval.after = function after(start, duration) {
	    var dur = friendlyDuration(duration),
	        dt = friendlyDateTime(start);
	    return Interval.fromDateTimes(dt, dt.plus(dur));
	  }
	  /**
	   * Create an Interval from an end DateTime and a Duration to extend backwards to.
	   * @param {DateTime|Date|Object} end
	   * @param {Duration|Object|number} duration - the length of the Interval.
	   * @return {Interval}
	   */
	  ;
	
	  Interval.before = function before(end, duration) {
	    var dur = friendlyDuration(duration),
	        dt = friendlyDateTime(end);
	    return Interval.fromDateTimes(dt.minus(dur), dt);
	  }
	  /**
	   * Create an Interval from an ISO 8601 string.
	   * Accepts `<start>/<end>`, `<start>/<duration>`, and `<duration>/<end>` formats.
	   * @param {string} text - the ISO string to parse
	   * @param {Object} [opts] - options to pass {@link DateTime.fromISO} and optionally {@link Duration.fromISO}
	   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
	   * @return {Interval}
	   */
	  ;
	
	  Interval.fromISO = function fromISO(text, opts) {
	    var _split = (text || "").split("/", 2),
	        s = _split[0],
	        e = _split[1];
	
	    if (s && e) {
	      var start = DateTime.fromISO(s, opts),
	          end = DateTime.fromISO(e, opts);
	
	      if (start.isValid && end.isValid) {
	        return Interval.fromDateTimes(start, end);
	      }
	
	      if (start.isValid) {
	        var dur = Duration.fromISO(e, opts);
	
	        if (dur.isValid) {
	          return Interval.after(start, dur);
	        }
	      } else if (end.isValid) {
	        var _dur = Duration.fromISO(s, opts);
	
	        if (_dur.isValid) {
	          return Interval.before(end, _dur);
	        }
	      }
	    }
	
	    return Interval.invalid("unparsable", "the input \"" + text + "\" can't be parsed asISO 8601");
	  }
	  /**
	   * Check if an object is an Interval. Works across context boundaries
	   * @param {object} o
	   * @return {boolean}
	   */
	  ;
	
	  Interval.isInterval = function isInterval(o) {
	    return o && o.isLuxonInterval || false;
	  }
	  /**
	   * Returns the start of the Interval
	   * @type {DateTime}
	   */
	  ;
	
	  var _proto = Interval.prototype;
	
	  /**
	   * Returns the length of the Interval in the specified unit.
	   * @param {string} unit - the unit (such as 'hours' or 'days') to return the length in.
	   * @return {number}
	   */
	  _proto.length = function length(unit) {
	    if (unit === void 0) {
	      unit = "milliseconds";
	    }
	
	    return this.isValid ? this.toDuration.apply(this, [unit]).get(unit) : NaN;
	  }
	  /**
	   * Returns the count of minutes, hours, days, months, or years included in the Interval, even in part.
	   * Unlike {@link length} this counts sections of the calendar, not periods of time, e.g. specifying 'day'
	   * asks 'what dates are included in this interval?', not 'how many days long is this interval?'
	   * @param {string} [unit='milliseconds'] - the unit of time to count.
	   * @return {number}
	   */
	  ;
	
	  _proto.count = function count(unit) {
	    if (unit === void 0) {
	      unit = "milliseconds";
	    }
	
	    if (!this.isValid) return NaN;
	    var start = this.start.startOf(unit),
	        end = this.end.startOf(unit);
	    return Math.floor(end.diff(start, unit).get(unit)) + 1;
	  }
	  /**
	   * Returns whether this Interval's start and end are both in the same unit of time
	   * @param {string} unit - the unit of time to check sameness on
	   * @return {boolean}
	   */
	  ;
	
	  _proto.hasSame = function hasSame(unit) {
	    return this.isValid ? this.e.minus(1).hasSame(this.s, unit) : false;
	  }
	  /**
	   * Return whether this Interval has the same start and end DateTimes.
	   * @return {boolean}
	   */
	  ;
	
	  _proto.isEmpty = function isEmpty() {
	    return this.s.valueOf() === this.e.valueOf();
	  }
	  /**
	   * Return whether this Interval's start is after the specified DateTime.
	   * @param {DateTime} dateTime
	   * @return {boolean}
	   */
	  ;
	
	  _proto.isAfter = function isAfter(dateTime) {
	    if (!this.isValid) return false;
	    return this.s > dateTime;
	  }
	  /**
	   * Return whether this Interval's end is before the specified DateTime.
	   * @param {DateTime} dateTime
	   * @return {boolean}
	   */
	  ;
	
	  _proto.isBefore = function isBefore(dateTime) {
	    if (!this.isValid) return false;
	    return this.e <= dateTime;
	  }
	  /**
	   * Return whether this Interval contains the specified DateTime.
	   * @param {DateTime} dateTime
	   * @return {boolean}
	   */
	  ;
	
	  _proto.contains = function contains(dateTime) {
	    if (!this.isValid) return false;
	    return this.s <= dateTime && this.e > dateTime;
	  }
	  /**
	   * "Sets" the start and/or end dates. Returns a newly-constructed Interval.
	   * @param {Object} values - the values to set
	   * @param {DateTime} values.start - the starting DateTime
	   * @param {DateTime} values.end - the ending DateTime
	   * @return {Interval}
	   */
	  ;
	
	  _proto.set = function set(_temp) {
	    var _ref = _temp === void 0 ? {} : _temp,
	        start = _ref.start,
	        end = _ref.end;
	
	    if (!this.isValid) return this;
	    return Interval.fromDateTimes(start || this.s, end || this.e);
	  }
	  /**
	   * Split this Interval at each of the specified DateTimes
	   * @param {...[DateTime]} dateTimes - the unit of time to count.
	   * @return {[Interval]}
	   */
	  ;
	
	  _proto.splitAt = function splitAt() {
	    if (!this.isValid) return [];
	
	    for (var _len = arguments.length, dateTimes = new Array(_len), _key = 0; _key < _len; _key++) {
	      dateTimes[_key] = arguments[_key];
	    }
	
	    var sorted = dateTimes.map(friendlyDateTime).sort(),
	        results = [];
	    var s = this.s,
	        i = 0;
	
	    while (s < this.e) {
	      var added = sorted[i] || this.e,
	          next = +added > +this.e ? this.e : added;
	      results.push(Interval.fromDateTimes(s, next));
	      s = next;
	      i += 1;
	    }
	
	    return results;
	  }
	  /**
	   * Split this Interval into smaller Intervals, each of the specified length.
	   * Left over time is grouped into a smaller interval
	   * @param {Duration|Object|number} duration - The length of each resulting interval.
	   * @return {[Interval]}
	   */
	  ;
	
	  _proto.splitBy = function splitBy(duration) {
	    var dur = friendlyDuration(duration);
	
	    if (!this.isValid || !dur.isValid || dur.as("milliseconds") === 0) {
	      return [];
	    }
	
	    var s = this.s,
	        added,
	        next;
	    var results = [];
	
	    while (s < this.e) {
	      added = s.plus(dur);
	      next = +added > +this.e ? this.e : added;
	      results.push(Interval.fromDateTimes(s, next));
	      s = next;
	    }
	
	    return results;
	  }
	  /**
	   * Split this Interval into the specified number of smaller intervals.
	   * @param {number} numberOfParts - The number of Intervals to divide the Interval into.
	   * @return {[Interval]}
	   */
	  ;
	
	  _proto.divideEqually = function divideEqually(numberOfParts) {
	    if (!this.isValid) return [];
	    return this.splitBy(this.length() / numberOfParts).slice(0, numberOfParts);
	  }
	  /**
	   * Return whether this Interval overlaps with the specified Interval
	   * @param {Interval} other
	   * @return {boolean}
	   */
	  ;
	
	  _proto.overlaps = function overlaps(other) {
	    return this.e > other.s && this.s < other.e;
	  }
	  /**
	   * Return whether this Interval's end is adjacent to the specified Interval's start.
	   * @param {Interval} other
	   * @return {boolean}
	   */
	  ;
	
	  _proto.abutsStart = function abutsStart(other) {
	    if (!this.isValid) return false;
	    return +this.e === +other.s;
	  }
	  /**
	   * Return whether this Interval's start is adjacent to the specified Interval's end.
	   * @param {Interval} other
	   * @return {boolean}
	   */
	  ;
	
	  _proto.abutsEnd = function abutsEnd(other) {
	    if (!this.isValid) return false;
	    return +other.e === +this.s;
	  }
	  /**
	   * Return whether this Interval engulfs the start and end of the specified Interval.
	   * @param {Interval} other
	   * @return {boolean}
	   */
	  ;
	
	  _proto.engulfs = function engulfs(other) {
	    if (!this.isValid) return false;
	    return this.s <= other.s && this.e >= other.e;
	  }
	  /**
	   * Return whether this Interval has the same start and end as the specified Interval.
	   * @param {Interval} other
	   * @return {boolean}
	   */
	  ;
	
	  _proto.equals = function equals(other) {
	    if (!this.isValid || !other.isValid) {
	      return false;
	    }
	
	    return this.s.equals(other.s) && this.e.equals(other.e);
	  }
	  /**
	   * Return an Interval representing the intersection of this Interval and the specified Interval.
	   * Specifically, the resulting Interval has the maximum start time and the minimum end time of the two Intervals.
	   * Returns null if the intersection is empty, i.e., the intervals don't intersect.
	   * @param {Interval} other
	   * @return {Interval}
	   */
	  ;
	
	  _proto.intersection = function intersection(other) {
	    if (!this.isValid) return this;
	    var s = this.s > other.s ? this.s : other.s,
	        e = this.e < other.e ? this.e : other.e;
	
	    if (s > e) {
	      return null;
	    } else {
	      return Interval.fromDateTimes(s, e);
	    }
	  }
	  /**
	   * Return an Interval representing the union of this Interval and the specified Interval.
	   * Specifically, the resulting Interval has the minimum start time and the maximum end time of the two Intervals.
	   * @param {Interval} other
	   * @return {Interval}
	   */
	  ;
	
	  _proto.union = function union(other) {
	    if (!this.isValid) return this;
	    var s = this.s < other.s ? this.s : other.s,
	        e = this.e > other.e ? this.e : other.e;
	    return Interval.fromDateTimes(s, e);
	  }
	  /**
	   * Merge an array of Intervals into a equivalent minimal set of Intervals.
	   * Combines overlapping and adjacent Intervals.
	   * @param {[Interval]} intervals
	   * @return {[Interval]}
	   */
	  ;
	
	  Interval.merge = function merge(intervals) {
	    var _intervals$sort$reduc = intervals.sort(function (a, b) {
	      return a.s - b.s;
	    }).reduce(function (_ref2, item) {
	      var sofar = _ref2[0],
	          current = _ref2[1];
	
	      if (!current) {
	        return [sofar, item];
	      } else if (current.overlaps(item) || current.abutsStart(item)) {
	        return [sofar, current.union(item)];
	      } else {
	        return [sofar.concat([current]), item];
	      }
	    }, [[], null]),
	        found = _intervals$sort$reduc[0],
	        final = _intervals$sort$reduc[1];
	
	    if (final) {
	      found.push(final);
	    }
	
	    return found;
	  }
	  /**
	   * Return an array of Intervals representing the spans of time that only appear in one of the specified Intervals.
	   * @param {[Interval]} intervals
	   * @return {[Interval]}
	   */
	  ;
	
	  Interval.xor = function xor(intervals) {
	    var _Array$prototype;
	
	    var start = null,
	        currentCount = 0;
	
	    var results = [],
	        ends = intervals.map(function (i) {
	      return [{
	        time: i.s,
	        type: "s"
	      }, {
	        time: i.e,
	        type: "e"
	      }];
	    }),
	        flattened = (_Array$prototype = Array.prototype).concat.apply(_Array$prototype, ends),
	        arr = flattened.sort(function (a, b) {
	      return a.time - b.time;
	    });
	
	    for (var _iterator = arr, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
	      var _ref3;
	
	      if (_isArray) {
	        if (_i >= _iterator.length) break;
	        _ref3 = _iterator[_i++];
	      } else {
	        _i = _iterator.next();
	        if (_i.done) break;
	        _ref3 = _i.value;
	      }
	
	      var i = _ref3;
	      currentCount += i.type === "s" ? 1 : -1;
	
	      if (currentCount === 1) {
	        start = i.time;
	      } else {
	        if (start && +start !== +i.time) {
	          results.push(Interval.fromDateTimes(start, i.time));
	        }
	
	        start = null;
	      }
	    }
	
	    return Interval.merge(results);
	  }
	  /**
	   * Return an Interval representing the span of time in this Interval that doesn't overlap with any of the specified Intervals.
	   * @param {...Interval} intervals
	   * @return {[Interval]}
	   */
	  ;
	
	  _proto.difference = function difference() {
	    var _this = this;
	
	    for (var _len2 = arguments.length, intervals = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	      intervals[_key2] = arguments[_key2];
	    }
	
	    return Interval.xor([this].concat(intervals)).map(function (i) {
	      return _this.intersection(i);
	    }).filter(function (i) {
	      return i && !i.isEmpty();
	    });
	  }
	  /**
	   * Returns a string representation of this Interval appropriate for debugging.
	   * @return {string}
	   */
	  ;
	
	  _proto.toString = function toString() {
	    if (!this.isValid) return INVALID$1;
	    return "[" + this.s.toISO() + " \u2013 " + this.e.toISO() + ")";
	  }
	  /**
	   * Returns an ISO 8601-compliant string representation of this Interval.
	   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
	   * @param {Object} opts - The same options as {@link DateTime.toISO}
	   * @return {string}
	   */
	  ;
	
	  _proto.toISO = function toISO(opts) {
	    if (!this.isValid) return INVALID$1;
	    return this.s.toISO(opts) + "/" + this.e.toISO(opts);
	  }
	  /**
	   * Returns a string representation of this Interval formatted according to the specified format string.
	   * @param {string} dateFormat - the format string. This string formats the start and end time. See {@link DateTime.toFormat} for details.
	   * @param {Object} opts - options
	   * @param {string} [opts.separator =  ' – '] - a separator to place between the start and end representations
	   * @return {string}
	   */
	  ;
	
	  _proto.toFormat = function toFormat(dateFormat, _temp2) {
	    var _ref4 = _temp2 === void 0 ? {} : _temp2,
	        _ref4$separator = _ref4.separator,
	        separator = _ref4$separator === void 0 ? " – " : _ref4$separator;
	
	    if (!this.isValid) return INVALID$1;
	    return "" + this.s.toFormat(dateFormat) + separator + this.e.toFormat(dateFormat);
	  }
	  /**
	   * Return a Duration representing the time spanned by this interval.
	   * @param {string|string[]} [unit=['milliseconds']] - the unit or units (such as 'hours' or 'days') to include in the duration.
	   * @param {Object} opts - options that affect the creation of the Duration
	   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
	   * @example Interval.fromDateTimes(dt1, dt2).toDuration().toObject() //=> { milliseconds: 88489257 }
	   * @example Interval.fromDateTimes(dt1, dt2).toDuration('days').toObject() //=> { days: 1.0241812152777778 }
	   * @example Interval.fromDateTimes(dt1, dt2).toDuration(['hours', 'minutes']).toObject() //=> { hours: 24, minutes: 34.82095 }
	   * @example Interval.fromDateTimes(dt1, dt2).toDuration(['hours', 'minutes', 'seconds']).toObject() //=> { hours: 24, minutes: 34, seconds: 49.257 }
	   * @example Interval.fromDateTimes(dt1, dt2).toDuration('seconds').toObject() //=> { seconds: 88489.257 }
	   * @return {Duration}
	   */
	  ;
	
	  _proto.toDuration = function toDuration(unit, opts) {
	    if (!this.isValid) {
	      return Duration.invalid(this.invalidReason);
	    }
	
	    return this.e.diff(this.s, unit, opts);
	  }
	  /**
	   * Run mapFn on the interval start and end, returning a new Interval from the resulting DateTimes
	   * @param {function} mapFn
	   * @return {Interval}
	   * @example Interval.fromDateTimes(dt1, dt2).mapEndpoints(endpoint => endpoint.toUTC())
	   * @example Interval.fromDateTimes(dt1, dt2).mapEndpoints(endpoint => endpoint.plus({ hours: 2 }))
	   */
	  ;
	
	  _proto.mapEndpoints = function mapEndpoints(mapFn) {
	    return Interval.fromDateTimes(mapFn(this.s), mapFn(this.e));
	  };
	
	  _createClass(Interval, [{
	    key: "start",
	    get: function get() {
	      return this.isValid ? this.s : null;
	    }
	    /**
	     * Returns the end of the Interval
	     * @type {DateTime}
	     */
	
	  }, {
	    key: "end",
	    get: function get() {
	      return this.isValid ? this.e : null;
	    }
	    /**
	     * Returns whether this Interval's end is at least its start, i.e. that the Interval isn't 'backwards'.
	     * @type {boolean}
	     */
	
	  }, {
	    key: "isValid",
	    get: function get() {
	      return this.invalidReason === null;
	    }
	    /**
	     * Returns an error code if this Interval is invalid, or null if the Interval is valid
	     * @type {string}
	     */
	
	  }, {
	    key: "invalidReason",
	    get: function get() {
	      return this.invalid ? this.invalid.reason : null;
	    }
	    /**
	     * Returns an explanation of why this Interval became invalid, or null if the Interval is valid
	     * @type {string}
	     */
	
	  }, {
	    key: "invalidExplanation",
	    get: function get() {
	      return this.invalid ? this.invalid.explanation : null;
	    }
	  }]);
	
	  return Interval;
	}();
	
	/**
	 * The Info class contains static methods for retrieving general time and date related data. For example, it has methods for finding out if a time zone has a DST, for listing the months in any supported locale, and for discovering which of Luxon features are available in the current environment.
	 */
	
	var Info =
	/*#__PURE__*/
	function () {
	  function Info() {}
	
	  /**
	   * Return whether the specified zone contains a DST.
	   * @param {string|Zone} [zone='local'] - Zone to check. Defaults to the environment's local zone.
	   * @return {boolean}
	   */
	  Info.hasDST = function hasDST(zone) {
	    if (zone === void 0) {
	      zone = Settings.defaultZone;
	    }
	
	    var proto = DateTime.local().setZone(zone).set({
	      month: 12
	    });
	    return !zone.universal && proto.offset !== proto.set({
	      month: 6
	    }).offset;
	  }
	  /**
	   * Return whether the specified zone is a valid IANA specifier.
	   * @param {string} zone - Zone to check
	   * @return {boolean}
	   */
	  ;
	
	  Info.isValidIANAZone = function isValidIANAZone(zone) {
	    return IANAZone.isValidSpecifier(zone) && IANAZone.isValidZone(zone);
	  }
	  /**
	   * Converts the input into a {@link Zone} instance.
	   *
	   * * If `input` is already a Zone instance, it is returned unchanged.
	   * * If `input` is a string containing a valid time zone name, a Zone instance
	   *   with that name is returned.
	   * * If `input` is a string that doesn't refer to a known time zone, a Zone
	   *   instance with {@link Zone.isValid} == false is returned.
	   * * If `input is a number, a Zone instance with the specified fixed offset
	   *   in minutes is returned.
	   * * If `input` is `null` or `undefined`, the default zone is returned.
	   * @param {string|Zone|number} [input] - the value to be converted
	   * @return {Zone}
	   */
	  ;
	
	  Info.normalizeZone = function normalizeZone$1(input) {
	    return normalizeZone(input, Settings.defaultZone);
	  }
	  /**
	   * Return an array of standalone month names.
	   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
	   * @param {string} [length='long'] - the length of the month representation, such as "numeric", "2-digit", "narrow", "short", "long"
	   * @param {Object} opts - options
	   * @param {string} [opts.locale] - the locale code
	   * @param {string} [opts.numberingSystem=null] - the numbering system
	   * @param {string} [opts.outputCalendar='gregory'] - the calendar
	   * @example Info.months()[0] //=> 'January'
	   * @example Info.months('short')[0] //=> 'Jan'
	   * @example Info.months('numeric')[0] //=> '1'
	   * @example Info.months('short', { locale: 'fr-CA' } )[0] //=> 'janv.'
	   * @example Info.months('numeric', { locale: 'ar' })[0] //=> '١'
	   * @example Info.months('long', { outputCalendar: 'islamic' })[0] //=> 'Rabiʻ I'
	   * @return {[string]}
	   */
	  ;
	
	  Info.months = function months(length, _temp) {
	    if (length === void 0) {
	      length = "long";
	    }
	
	    var _ref = _temp === void 0 ? {} : _temp,
	        _ref$locale = _ref.locale,
	        locale = _ref$locale === void 0 ? null : _ref$locale,
	        _ref$numberingSystem = _ref.numberingSystem,
	        numberingSystem = _ref$numberingSystem === void 0 ? null : _ref$numberingSystem,
	        _ref$outputCalendar = _ref.outputCalendar,
	        outputCalendar = _ref$outputCalendar === void 0 ? "gregory" : _ref$outputCalendar;
	
	    return Locale.create(locale, numberingSystem, outputCalendar).months(length);
	  }
	  /**
	   * Return an array of format month names.
	   * Format months differ from standalone months in that they're meant to appear next to the day of the month. In some languages, that
	   * changes the string.
	   * See {@link months}
	   * @param {string} [length='long'] - the length of the month representation, such as "numeric", "2-digit", "narrow", "short", "long"
	   * @param {Object} opts - options
	   * @param {string} [opts.locale] - the locale code
	   * @param {string} [opts.numberingSystem=null] - the numbering system
	   * @param {string} [opts.outputCalendar='gregory'] - the calendar
	   * @return {[string]}
	   */
	  ;
	
	  Info.monthsFormat = function monthsFormat(length, _temp2) {
	    if (length === void 0) {
	      length = "long";
	    }
	
	    var _ref2 = _temp2 === void 0 ? {} : _temp2,
	        _ref2$locale = _ref2.locale,
	        locale = _ref2$locale === void 0 ? null : _ref2$locale,
	        _ref2$numberingSystem = _ref2.numberingSystem,
	        numberingSystem = _ref2$numberingSystem === void 0 ? null : _ref2$numberingSystem,
	        _ref2$outputCalendar = _ref2.outputCalendar,
	        outputCalendar = _ref2$outputCalendar === void 0 ? "gregory" : _ref2$outputCalendar;
	
	    return Locale.create(locale, numberingSystem, outputCalendar).months(length, true);
	  }
	  /**
	   * Return an array of standalone week names.
	   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
	   * @param {string} [length='long'] - the length of the month representation, such as "narrow", "short", "long".
	   * @param {Object} opts - options
	   * @param {string} [opts.locale] - the locale code
	   * @param {string} [opts.numberingSystem=null] - the numbering system
	   * @example Info.weekdays()[0] //=> 'Monday'
	   * @example Info.weekdays('short')[0] //=> 'Mon'
	   * @example Info.weekdays('short', { locale: 'fr-CA' })[0] //=> 'lun.'
	   * @example Info.weekdays('short', { locale: 'ar' })[0] //=> 'الاثنين'
	   * @return {[string]}
	   */
	  ;
	
	  Info.weekdays = function weekdays(length, _temp3) {
	    if (length === void 0) {
	      length = "long";
	    }
	
	    var _ref3 = _temp3 === void 0 ? {} : _temp3,
	        _ref3$locale = _ref3.locale,
	        locale = _ref3$locale === void 0 ? null : _ref3$locale,
	        _ref3$numberingSystem = _ref3.numberingSystem,
	        numberingSystem = _ref3$numberingSystem === void 0 ? null : _ref3$numberingSystem;
	
	    return Locale.create(locale, numberingSystem, null).weekdays(length);
	  }
	  /**
	   * Return an array of format week names.
	   * Format weekdays differ from standalone weekdays in that they're meant to appear next to more date information. In some languages, that
	   * changes the string.
	   * See {@link weekdays}
	   * @param {string} [length='long'] - the length of the month representation, such as "narrow", "short", "long".
	   * @param {Object} opts - options
	   * @param {string} [opts.locale=null] - the locale code
	   * @param {string} [opts.numberingSystem=null] - the numbering system
	   * @return {[string]}
	   */
	  ;
	
	  Info.weekdaysFormat = function weekdaysFormat(length, _temp4) {
	    if (length === void 0) {
	      length = "long";
	    }
	
	    var _ref4 = _temp4 === void 0 ? {} : _temp4,
	        _ref4$locale = _ref4.locale,
	        locale = _ref4$locale === void 0 ? null : _ref4$locale,
	        _ref4$numberingSystem = _ref4.numberingSystem,
	        numberingSystem = _ref4$numberingSystem === void 0 ? null : _ref4$numberingSystem;
	
	    return Locale.create(locale, numberingSystem, null).weekdays(length, true);
	  }
	  /**
	   * Return an array of meridiems.
	   * @param {Object} opts - options
	   * @param {string} [opts.locale] - the locale code
	   * @example Info.meridiems() //=> [ 'AM', 'PM' ]
	   * @example Info.meridiems({ locale: 'my' }) //=> [ 'နံနက်', 'ညနေ' ]
	   * @return {[string]}
	   */
	  ;
	
	  Info.meridiems = function meridiems(_temp5) {
	    var _ref5 = _temp5 === void 0 ? {} : _temp5,
	        _ref5$locale = _ref5.locale,
	        locale = _ref5$locale === void 0 ? null : _ref5$locale;
	
	    return Locale.create(locale).meridiems();
	  }
	  /**
	   * Return an array of eras, such as ['BC', 'AD']. The locale can be specified, but the calendar system is always Gregorian.
	   * @param {string} [length='short'] - the length of the era representation, such as "short" or "long".
	   * @param {Object} opts - options
	   * @param {string} [opts.locale] - the locale code
	   * @example Info.eras() //=> [ 'BC', 'AD' ]
	   * @example Info.eras('long') //=> [ 'Before Christ', 'Anno Domini' ]
	   * @example Info.eras('long', { locale: 'fr' }) //=> [ 'avant Jésus-Christ', 'après Jésus-Christ' ]
	   * @return {[string]}
	   */
	  ;
	
	  Info.eras = function eras(length, _temp6) {
	    if (length === void 0) {
	      length = "short";
	    }
	
	    var _ref6 = _temp6 === void 0 ? {} : _temp6,
	        _ref6$locale = _ref6.locale,
	        locale = _ref6$locale === void 0 ? null : _ref6$locale;
	
	    return Locale.create(locale, null, "gregory").eras(length);
	  }
	  /**
	   * Return the set of available features in this environment.
	   * Some features of Luxon are not available in all environments. For example, on older browsers, timezone support is not available. Use this function to figure out if that's the case.
	   * Keys:
	   * * `zones`: whether this environment supports IANA timezones
	   * * `intlTokens`: whether this environment supports internationalized token-based formatting/parsing
	   * * `intl`: whether this environment supports general internationalization
	   * * `relative`: whether this environment supports relative time formatting
	   * @example Info.features() //=> { intl: true, intlTokens: false, zones: true, relative: false }
	   * @return {Object}
	   */
	  ;
	
	  Info.features = function features() {
	    var intl = false,
	        intlTokens = false,
	        zones = false,
	        relative = hasRelative();
	
	    if (hasIntl()) {
	      intl = true;
	      intlTokens = hasFormatToParts();
	
	      try {
	        zones = new Intl.DateTimeFormat("en", {
	          timeZone: "America/New_York"
	        }).resolvedOptions().timeZone === "America/New_York";
	      } catch (e) {
	        zones = false;
	      }
	    }
	
	    return {
	      intl: intl,
	      intlTokens: intlTokens,
	      zones: zones,
	      relative: relative
	    };
	  };
	
	  return Info;
	}();
	
	function dayDiff(earlier, later) {
	  var utcDayStart = function utcDayStart(dt) {
	    return dt.toUTC(0, {
	      keepLocalTime: true
	    }).startOf("day").valueOf();
	  },
	      ms = utcDayStart(later) - utcDayStart(earlier);
	
	  return Math.floor(Duration.fromMillis(ms).as("days"));
	}
	
	function highOrderDiffs(cursor, later, units) {
	  var differs = [["years", function (a, b) {
	    return b.year - a.year;
	  }], ["months", function (a, b) {
	    return b.month - a.month + (b.year - a.year) * 12;
	  }], ["weeks", function (a, b) {
	    var days = dayDiff(a, b);
	    return (days - days % 7) / 7;
	  }], ["days", dayDiff]];
	  var results = {};
	  var lowestOrder, highWater;
	
	  for (var _i = 0, _differs = differs; _i < _differs.length; _i++) {
	    var _differs$_i = _differs[_i],
	        unit = _differs$_i[0],
	        differ = _differs$_i[1];
	
	    if (units.indexOf(unit) >= 0) {
	      var _cursor$plus;
	
	      lowestOrder = unit;
	      var delta = differ(cursor, later);
	      highWater = cursor.plus((_cursor$plus = {}, _cursor$plus[unit] = delta, _cursor$plus));
	
	      if (highWater > later) {
	        var _cursor$plus2;
	
	        cursor = cursor.plus((_cursor$plus2 = {}, _cursor$plus2[unit] = delta - 1, _cursor$plus2));
	        delta -= 1;
	      } else {
	        cursor = highWater;
	      }
	
	      results[unit] = delta;
	    }
	  }
	
	  return [cursor, results, highWater, lowestOrder];
	}
	
	function _diff (earlier, later, units, opts) {
	  var _highOrderDiffs = highOrderDiffs(earlier, later, units),
	      cursor = _highOrderDiffs[0],
	      results = _highOrderDiffs[1],
	      highWater = _highOrderDiffs[2],
	      lowestOrder = _highOrderDiffs[3];
	
	  var remainingMillis = later - cursor;
	  var lowerOrderUnits = units.filter(function (u) {
	    return ["hours", "minutes", "seconds", "milliseconds"].indexOf(u) >= 0;
	  });
	
	  if (lowerOrderUnits.length === 0) {
	    if (highWater < later) {
	      var _cursor$plus3;
	
	      highWater = cursor.plus((_cursor$plus3 = {}, _cursor$plus3[lowestOrder] = 1, _cursor$plus3));
	    }
	
	    if (highWater !== cursor) {
	      results[lowestOrder] = (results[lowestOrder] || 0) + remainingMillis / (highWater - cursor);
	    }
	  }
	
	  var duration = Duration.fromObject(Object.assign(results, opts));
	
	  if (lowerOrderUnits.length > 0) {
	    var _Duration$fromMillis;
	
	    return (_Duration$fromMillis = Duration.fromMillis(remainingMillis, opts)).shiftTo.apply(_Duration$fromMillis, lowerOrderUnits).plus(duration);
	  } else {
	    return duration;
	  }
	}
	
	var numberingSystems = {
	  arab: "[\u0660-\u0669]",
	  arabext: "[\u06F0-\u06F9]",
	  bali: "[\u1B50-\u1B59]",
	  beng: "[\u09E6-\u09EF]",
	  deva: "[\u0966-\u096F]",
	  fullwide: "[\uFF10-\uFF19]",
	  gujr: "[\u0AE6-\u0AEF]",
	  hanidec: "[〇|一|二|三|四|五|六|七|八|九]",
	  khmr: "[\u17E0-\u17E9]",
	  knda: "[\u0CE6-\u0CEF]",
	  laoo: "[\u0ED0-\u0ED9]",
	  limb: "[\u1946-\u194F]",
	  mlym: "[\u0D66-\u0D6F]",
	  mong: "[\u1810-\u1819]",
	  mymr: "[\u1040-\u1049]",
	  orya: "[\u0B66-\u0B6F]",
	  tamldec: "[\u0BE6-\u0BEF]",
	  telu: "[\u0C66-\u0C6F]",
	  thai: "[\u0E50-\u0E59]",
	  tibt: "[\u0F20-\u0F29]",
	  latn: "\\d"
	};
	var numberingSystemsUTF16 = {
	  arab: [1632, 1641],
	  arabext: [1776, 1785],
	  bali: [6992, 7001],
	  beng: [2534, 2543],
	  deva: [2406, 2415],
	  fullwide: [65296, 65303],
	  gujr: [2790, 2799],
	  khmr: [6112, 6121],
	  knda: [3302, 3311],
	  laoo: [3792, 3801],
	  limb: [6470, 6479],
	  mlym: [3430, 3439],
	  mong: [6160, 6169],
	  mymr: [4160, 4169],
	  orya: [2918, 2927],
	  tamldec: [3046, 3055],
	  telu: [3174, 3183],
	  thai: [3664, 3673],
	  tibt: [3872, 3881]
	}; // eslint-disable-next-line
	
	var hanidecChars = numberingSystems.hanidec.replace(/[\[|\]]/g, "").split("");
	function parseDigits(str) {
	  var value = parseInt(str, 10);
	
	  if (isNaN(value)) {
	    value = "";
	
	    for (var i = 0; i < str.length; i++) {
	      var code = str.charCodeAt(i);
	
	      if (str[i].search(numberingSystems.hanidec) !== -1) {
	        value += hanidecChars.indexOf(str[i]);
	      } else {
	        for (var key in numberingSystemsUTF16) {
	          var _numberingSystemsUTF = numberingSystemsUTF16[key],
	              min = _numberingSystemsUTF[0],
	              max = _numberingSystemsUTF[1];
	
	          if (code >= min && code <= max) {
	            value += code - min;
	          }
	        }
	      }
	    }
	
	    return parseInt(value, 10);
	  } else {
	    return value;
	  }
	}
	function digitRegex(_ref, append) {
	  var numberingSystem = _ref.numberingSystem;
	
	  if (append === void 0) {
	    append = "";
	  }
	
	  return new RegExp("" + numberingSystems[numberingSystem || "latn"] + append);
	}
	
	var MISSING_FTP = "missing Intl.DateTimeFormat.formatToParts support";
	
	function intUnit(regex, post) {
	  if (post === void 0) {
	    post = function post(i) {
	      return i;
	    };
	  }
	
	  return {
	    regex: regex,
	    deser: function deser(_ref) {
	      var s = _ref[0];
	      return post(parseDigits(s));
	    }
	  };
	}
	
	function fixListRegex(s) {
	  // make dots optional and also make them literal
	  return s.replace(/\./, "\\.?");
	}
	
	function stripInsensitivities(s) {
	  return s.replace(/\./, "").toLowerCase();
	}
	
	function oneOf(strings, startIndex) {
	  if (strings === null) {
	    return null;
	  } else {
	    return {
	      regex: RegExp(strings.map(fixListRegex).join("|")),
	      deser: function deser(_ref2) {
	        var s = _ref2[0];
	        return strings.findIndex(function (i) {
	          return stripInsensitivities(s) === stripInsensitivities(i);
	        }) + startIndex;
	      }
	    };
	  }
	}
	
	function offset(regex, groups) {
	  return {
	    regex: regex,
	    deser: function deser(_ref3) {
	      var h = _ref3[1],
	          m = _ref3[2];
	      return signedOffset(h, m);
	    },
	    groups: groups
	  };
	}
	
	function simple(regex) {
	  return {
	    regex: regex,
	    deser: function deser(_ref4) {
	      var s = _ref4[0];
	      return s;
	    }
	  };
	}
	
	function escapeToken(value) {
	  // eslint-disable-next-line no-useless-escape
	  return value.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g, "\\$&");
	}
	
	function unitForToken(token, loc) {
	  var one = digitRegex(loc),
	      two = digitRegex(loc, "{2}"),
	      three = digitRegex(loc, "{3}"),
	      four = digitRegex(loc, "{4}"),
	      six = digitRegex(loc, "{6}"),
	      oneOrTwo = digitRegex(loc, "{1,2}"),
	      oneToThree = digitRegex(loc, "{1,3}"),
	      oneToSix = digitRegex(loc, "{1,6}"),
	      oneToNine = digitRegex(loc, "{1,9}"),
	      twoToFour = digitRegex(loc, "{2,4}"),
	      fourToSix = digitRegex(loc, "{4,6}"),
	      literal = function literal(t) {
	    return {
	      regex: RegExp(escapeToken(t.val)),
	      deser: function deser(_ref5) {
	        var s = _ref5[0];
	        return s;
	      },
	      literal: true
	    };
	  },
	      unitate = function unitate(t) {
	    if (token.literal) {
	      return literal(t);
	    }
	
	    switch (t.val) {
	      // era
	      case "G":
	        return oneOf(loc.eras("short", false), 0);
	
	      case "GG":
	        return oneOf(loc.eras("long", false), 0);
	      // years
	
	      case "y":
	        return intUnit(oneToSix);
	
	      case "yy":
	        return intUnit(twoToFour, untruncateYear);
	
	      case "yyyy":
	        return intUnit(four);
	
	      case "yyyyy":
	        return intUnit(fourToSix);
	
	      case "yyyyyy":
	        return intUnit(six);
	      // months
	
	      case "M":
	        return intUnit(oneOrTwo);
	
	      case "MM":
	        return intUnit(two);
	
	      case "MMM":
	        return oneOf(loc.months("short", true, false), 1);
	
	      case "MMMM":
	        return oneOf(loc.months("long", true, false), 1);
	
	      case "L":
	        return intUnit(oneOrTwo);
	
	      case "LL":
	        return intUnit(two);
	
	      case "LLL":
	        return oneOf(loc.months("short", false, false), 1);
	
	      case "LLLL":
	        return oneOf(loc.months("long", false, false), 1);
	      // dates
	
	      case "d":
	        return intUnit(oneOrTwo);
	
	      case "dd":
	        return intUnit(two);
	      // ordinals
	
	      case "o":
	        return intUnit(oneToThree);
	
	      case "ooo":
	        return intUnit(three);
	      // time
	
	      case "HH":
	        return intUnit(two);
	
	      case "H":
	        return intUnit(oneOrTwo);
	
	      case "hh":
	        return intUnit(two);
	
	      case "h":
	        return intUnit(oneOrTwo);
	
	      case "mm":
	        return intUnit(two);
	
	      case "m":
	        return intUnit(oneOrTwo);
	
	      case "s":
	        return intUnit(oneOrTwo);
	
	      case "ss":
	        return intUnit(two);
	
	      case "S":
	        return intUnit(oneToThree);
	
	      case "SSS":
	        return intUnit(three);
	
	      case "u":
	        return simple(oneToNine);
	      // meridiem
	
	      case "a":
	        return oneOf(loc.meridiems(), 0);
	      // weekYear (k)
	
	      case "kkkk":
	        return intUnit(four);
	
	      case "kk":
	        return intUnit(twoToFour, untruncateYear);
	      // weekNumber (W)
	
	      case "W":
	        return intUnit(oneOrTwo);
	
	      case "WW":
	        return intUnit(two);
	      // weekdays
	
	      case "E":
	      case "c":
	        return intUnit(one);
	
	      case "EEE":
	        return oneOf(loc.weekdays("short", false, false), 1);
	
	      case "EEEE":
	        return oneOf(loc.weekdays("long", false, false), 1);
	
	      case "ccc":
	        return oneOf(loc.weekdays("short", true, false), 1);
	
	      case "cccc":
	        return oneOf(loc.weekdays("long", true, false), 1);
	      // offset/zone
	
	      case "Z":
	      case "ZZ":
	        return offset(new RegExp("([+-]" + oneOrTwo.source + ")(?::(" + two.source + "))?"), 2);
	
	      case "ZZZ":
	        return offset(new RegExp("([+-]" + oneOrTwo.source + ")(" + two.source + ")?"), 2);
	      // we don't support ZZZZ (PST) or ZZZZZ (Pacific Standard Time) in parsing
	      // because we don't have any way to figure out what they are
	
	      case "z":
	        return simple(/[a-z_+-/]{1,256}?/i);
	
	      default:
	        return literal(t);
	    }
	  };
	
	  var unit = unitate(token) || {
	    invalidReason: MISSING_FTP
	  };
	  unit.token = token;
	  return unit;
	}
	
	function buildRegex(units) {
	  var re = units.map(function (u) {
	    return u.regex;
	  }).reduce(function (f, r) {
	    return f + "(" + r.source + ")";
	  }, "");
	  return ["^" + re + "$", units];
	}
	
	function match(input, regex, handlers) {
	  var matches = input.match(regex);
	
	  if (matches) {
	    var all = {};
	    var matchIndex = 1;
	
	    for (var i in handlers) {
	      if (handlers.hasOwnProperty(i)) {
	        var h = handlers[i],
	            groups = h.groups ? h.groups + 1 : 1;
	
	        if (!h.literal && h.token) {
	          all[h.token.val[0]] = h.deser(matches.slice(matchIndex, matchIndex + groups));
	        }
	
	        matchIndex += groups;
	      }
	    }
	
	    return [matches, all];
	  } else {
	    return [matches, {}];
	  }
	}
	
	function dateTimeFromMatches(matches) {
	  var toField = function toField(token) {
	    switch (token) {
	      case "S":
	        return "millisecond";
	
	      case "s":
	        return "second";
	
	      case "m":
	        return "minute";
	
	      case "h":
	      case "H":
	        return "hour";
	
	      case "d":
	        return "day";
	
	      case "o":
	        return "ordinal";
	
	      case "L":
	      case "M":
	        return "month";
	
	      case "y":
	        return "year";
	
	      case "E":
	      case "c":
	        return "weekday";
	
	      case "W":
	        return "weekNumber";
	
	      case "k":
	        return "weekYear";
	
	      default:
	        return null;
	    }
	  };
	
	  var zone;
	
	  if (!isUndefined(matches.Z)) {
	    zone = new FixedOffsetZone(matches.Z);
	  } else if (!isUndefined(matches.z)) {
	    zone = IANAZone.create(matches.z);
	  } else {
	    zone = null;
	  }
	
	  if (!isUndefined(matches.h)) {
	    if (matches.h < 12 && matches.a === 1) {
	      matches.h += 12;
	    } else if (matches.h === 12 && matches.a === 0) {
	      matches.h = 0;
	    }
	  }
	
	  if (matches.G === 0 && matches.y) {
	    matches.y = -matches.y;
	  }
	
	  if (!isUndefined(matches.u)) {
	    matches.S = parseMillis(matches.u);
	  }
	
	  var vals = Object.keys(matches).reduce(function (r, k) {
	    var f = toField(k);
	
	    if (f) {
	      r[f] = matches[k];
	    }
	
	    return r;
	  }, {});
	  return [vals, zone];
	}
	/**
	 * @private
	 */
	
	
	function explainFromTokens(locale, input, format) {
	  var tokens = Formatter.parseFormat(format),
	      units = tokens.map(function (t) {
	    return unitForToken(t, locale);
	  }),
	      disqualifyingUnit = units.find(function (t) {
	    return t.invalidReason;
	  });
	
	  if (disqualifyingUnit) {
	    return {
	      input: input,
	      tokens: tokens,
	      invalidReason: disqualifyingUnit.invalidReason
	    };
	  } else {
	    var _buildRegex = buildRegex(units),
	        regexString = _buildRegex[0],
	        handlers = _buildRegex[1],
	        regex = RegExp(regexString, "i"),
	        _match = match(input, regex, handlers),
	        rawMatches = _match[0],
	        matches = _match[1],
	        _ref6 = matches ? dateTimeFromMatches(matches) : [null, null],
	        result = _ref6[0],
	        zone = _ref6[1];
	
	    return {
	      input: input,
	      tokens: tokens,
	      regex: regex,
	      rawMatches: rawMatches,
	      matches: matches,
	      result: result,
	      zone: zone
	    };
	  }
	}
	function parseFromTokens(locale, input, format) {
	  var _explainFromTokens = explainFromTokens(locale, input, format),
	      result = _explainFromTokens.result,
	      zone = _explainFromTokens.zone,
	      invalidReason = _explainFromTokens.invalidReason;
	
	  return [result, zone, invalidReason];
	}
	
	var nonLeapLadder = [0, 31, 59, 90, 120, 151, 181, 212, 243, 273, 304, 334],
	    leapLadder = [0, 31, 60, 91, 121, 152, 182, 213, 244, 274, 305, 335];
	
	function unitOutOfRange(unit, value) {
	  return new Invalid("unit out of range", "you specified " + value + " (of type " + typeof value + ") as a " + unit + ", which is invalid");
	}
	
	function dayOfWeek(year, month, day) {
	  var js = new Date(Date.UTC(year, month - 1, day)).getUTCDay();
	  return js === 0 ? 7 : js;
	}
	
	function computeOrdinal(year, month, day) {
	  return day + (isLeapYear(year) ? leapLadder : nonLeapLadder)[month - 1];
	}
	
	function uncomputeOrdinal(year, ordinal) {
	  var table = isLeapYear(year) ? leapLadder : nonLeapLadder,
	      month0 = table.findIndex(function (i) {
	    return i < ordinal;
	  }),
	      day = ordinal - table[month0];
	  return {
	    month: month0 + 1,
	    day: day
	  };
	}
	/**
	 * @private
	 */
	
	
	function gregorianToWeek(gregObj) {
	  var year = gregObj.year,
	      month = gregObj.month,
	      day = gregObj.day,
	      ordinal = computeOrdinal(year, month, day),
	      weekday = dayOfWeek(year, month, day);
	  var weekNumber = Math.floor((ordinal - weekday + 10) / 7),
	      weekYear;
	
	  if (weekNumber < 1) {
	    weekYear = year - 1;
	    weekNumber = weeksInWeekYear(weekYear);
	  } else if (weekNumber > weeksInWeekYear(year)) {
	    weekYear = year + 1;
	    weekNumber = 1;
	  } else {
	    weekYear = year;
	  }
	
	  return Object.assign({
	    weekYear: weekYear,
	    weekNumber: weekNumber,
	    weekday: weekday
	  }, timeObject(gregObj));
	}
	function weekToGregorian(weekData) {
	  var weekYear = weekData.weekYear,
	      weekNumber = weekData.weekNumber,
	      weekday = weekData.weekday,
	      weekdayOfJan4 = dayOfWeek(weekYear, 1, 4),
	      yearInDays = daysInYear(weekYear);
	  var ordinal = weekNumber * 7 + weekday - weekdayOfJan4 - 3,
	      year;
	
	  if (ordinal < 1) {
	    year = weekYear - 1;
	    ordinal += daysInYear(year);
	  } else if (ordinal > yearInDays) {
	    year = weekYear + 1;
	    ordinal -= daysInYear(weekYear);
	  } else {
	    year = weekYear;
	  }
	
	  var _uncomputeOrdinal = uncomputeOrdinal(year, ordinal),
	      month = _uncomputeOrdinal.month,
	      day = _uncomputeOrdinal.day;
	
	  return Object.assign({
	    year: year,
	    month: month,
	    day: day
	  }, timeObject(weekData));
	}
	function gregorianToOrdinal(gregData) {
	  var year = gregData.year,
	      month = gregData.month,
	      day = gregData.day,
	      ordinal = computeOrdinal(year, month, day);
	  return Object.assign({
	    year: year,
	    ordinal: ordinal
	  }, timeObject(gregData));
	}
	function ordinalToGregorian(ordinalData) {
	  var year = ordinalData.year,
	      ordinal = ordinalData.ordinal,
	      _uncomputeOrdinal2 = uncomputeOrdinal(year, ordinal),
	      month = _uncomputeOrdinal2.month,
	      day = _uncomputeOrdinal2.day;
	
	  return Object.assign({
	    year: year,
	    month: month,
	    day: day
	  }, timeObject(ordinalData));
	}
	function hasInvalidWeekData(obj) {
	  var validYear = isNumber(obj.weekYear),
	      validWeek = numberBetween(obj.weekNumber, 1, weeksInWeekYear(obj.weekYear)),
	      validWeekday = numberBetween(obj.weekday, 1, 7);
	
	  if (!validYear) {
	    return unitOutOfRange("weekYear", obj.weekYear);
	  } else if (!validWeek) {
	    return unitOutOfRange("week", obj.week);
	  } else if (!validWeekday) {
	    return unitOutOfRange("weekday", obj.weekday);
	  } else return false;
	}
	function hasInvalidOrdinalData(obj) {
	  var validYear = isNumber(obj.year),
	      validOrdinal = numberBetween(obj.ordinal, 1, daysInYear(obj.year));
	
	  if (!validYear) {
	    return unitOutOfRange("year", obj.year);
	  } else if (!validOrdinal) {
	    return unitOutOfRange("ordinal", obj.ordinal);
	  } else return false;
	}
	function hasInvalidGregorianData(obj) {
	  var validYear = isNumber(obj.year),
	      validMonth = numberBetween(obj.month, 1, 12),
	      validDay = numberBetween(obj.day, 1, daysInMonth(obj.year, obj.month));
	
	  if (!validYear) {
	    return unitOutOfRange("year", obj.year);
	  } else if (!validMonth) {
	    return unitOutOfRange("month", obj.month);
	  } else if (!validDay) {
	    return unitOutOfRange("day", obj.day);
	  } else return false;
	}
	function hasInvalidTimeData(obj) {
	  var hour = obj.hour,
	      minute = obj.minute,
	      second = obj.second,
	      millisecond = obj.millisecond;
	  var validHour = numberBetween(hour, 0, 23) || hour === 24 && minute === 0 && second === 0 && millisecond === 0,
	      validMinute = numberBetween(minute, 0, 59),
	      validSecond = numberBetween(second, 0, 59),
	      validMillisecond = numberBetween(millisecond, 0, 999);
	
	  if (!validHour) {
	    return unitOutOfRange("hour", hour);
	  } else if (!validMinute) {
	    return unitOutOfRange("minute", minute);
	  } else if (!validSecond) {
	    return unitOutOfRange("second", second);
	  } else if (!validMillisecond) {
	    return unitOutOfRange("millisecond", millisecond);
	  } else return false;
	}
	
	var INVALID$2 = "Invalid DateTime";
	
	function unsupportedZone(zone) {
	  return new Invalid("unsupported zone", "the zone \"" + zone.name + "\" is not supported");
	} // we cache week data on the DT object and this intermediates the cache
	
	
	function possiblyCachedWeekData(dt) {
	  if (dt.weekData === null) {
	    dt.weekData = gregorianToWeek(dt.c);
	  }
	
	  return dt.weekData;
	} // clone really means, "make a new object with these modifications". all "setters" really use this
	// to create a new object while only changing some of the properties
	
	
	function clone$1(inst, alts) {
	  var current = {
	    ts: inst.ts,
	    zone: inst.zone,
	    c: inst.c,
	    o: inst.o,
	    loc: inst.loc,
	    invalid: inst.invalid
	  };
	  return new DateTime(Object.assign({}, current, alts, {
	    old: current
	  }));
	} // find the right offset a given local time. The o input is our guess, which determines which
	// offset we'll pick in ambiguous cases (e.g. there are two 3 AMs b/c Fallback DST)
	
	
	function fixOffset(localTS, o, tz) {
	  // Our UTC time is just a guess because our offset is just a guess
	  var utcGuess = localTS - o * 60 * 1000; // Test whether the zone matches the offset for this ts
	
	  var o2 = tz.offset(utcGuess); // If so, offset didn't change and we're done
	
	  if (o === o2) {
	    return [utcGuess, o];
	  } // If not, change the ts by the difference in the offset
	
	
	  utcGuess -= (o2 - o) * 60 * 1000; // If that gives us the local time we want, we're done
	
	  var o3 = tz.offset(utcGuess);
	
	  if (o2 === o3) {
	    return [utcGuess, o2];
	  } // If it's different, we're in a hole time. The offset has changed, but the we don't adjust the time
	
	
	  return [localTS - Math.min(o2, o3) * 60 * 1000, Math.max(o2, o3)];
	} // convert an epoch timestamp into a calendar object with the given offset
	
	
	function tsToObj(ts, offset) {
	  ts += offset * 60 * 1000;
	  var d = new Date(ts);
	  return {
	    year: d.getUTCFullYear(),
	    month: d.getUTCMonth() + 1,
	    day: d.getUTCDate(),
	    hour: d.getUTCHours(),
	    minute: d.getUTCMinutes(),
	    second: d.getUTCSeconds(),
	    millisecond: d.getUTCMilliseconds()
	  };
	} // convert a calendar object to a epoch timestamp
	
	
	function objToTS(obj, offset, zone) {
	  return fixOffset(objToLocalTS(obj), offset, zone);
	} // create a new DT instance by adding a duration, adjusting for DSTs
	
	
	function adjustTime(inst, dur) {
	  var oPre = inst.o,
	      year = inst.c.year + dur.years,
	      month = inst.c.month + dur.months + dur.quarters * 3,
	      c = Object.assign({}, inst.c, {
	    year: year,
	    month: month,
	    day: Math.min(inst.c.day, daysInMonth(year, month)) + dur.days + dur.weeks * 7
	  }),
	      millisToAdd = Duration.fromObject({
	    hours: dur.hours,
	    minutes: dur.minutes,
	    seconds: dur.seconds,
	    milliseconds: dur.milliseconds
	  }).as("milliseconds"),
	      localTS = objToLocalTS(c);
	
	  var _fixOffset = fixOffset(localTS, oPre, inst.zone),
	      ts = _fixOffset[0],
	      o = _fixOffset[1];
	
	  if (millisToAdd !== 0) {
	    ts += millisToAdd; // that could have changed the offset by going over a DST, but we want to keep the ts the same
	
	    o = inst.zone.offset(ts);
	  }
	
	  return {
	    ts: ts,
	    o: o
	  };
	} // helper useful in turning the results of parsing into real dates
	// by handling the zone options
	
	
	function parseDataToDateTime(parsed, parsedZone, opts, format, text) {
	  var setZone = opts.setZone,
	      zone = opts.zone;
	
	  if (parsed && Object.keys(parsed).length !== 0) {
	    var interpretationZone = parsedZone || zone,
	        inst = DateTime.fromObject(Object.assign(parsed, opts, {
	      zone: interpretationZone,
	      // setZone is a valid option in the calling methods, but not in fromObject
	      setZone: undefined
	    }));
	    return setZone ? inst : inst.setZone(zone);
	  } else {
	    return DateTime.invalid(new Invalid("unparsable", "the input \"" + text + "\" can't be parsed as " + format));
	  }
	} // if you want to output a technical format (e.g. RFC 2822), this helper
	// helps handle the details
	
	
	function toTechFormat(dt, format) {
	  return dt.isValid ? Formatter.create(Locale.create("en-US"), {
	    allowZ: true,
	    forceSimple: true
	  }).formatDateTimeFromString(dt, format) : null;
	} // technical time formats (e.g. the time part of ISO 8601), take some options
	// and this commonizes their handling
	
	
	function toTechTimeFormat(dt, _ref) {
	  var _ref$suppressSeconds = _ref.suppressSeconds,
	      suppressSeconds = _ref$suppressSeconds === void 0 ? false : _ref$suppressSeconds,
	      _ref$suppressMillisec = _ref.suppressMilliseconds,
	      suppressMilliseconds = _ref$suppressMillisec === void 0 ? false : _ref$suppressMillisec,
	      includeOffset = _ref.includeOffset,
	      _ref$includeZone = _ref.includeZone,
	      includeZone = _ref$includeZone === void 0 ? false : _ref$includeZone,
	      _ref$spaceZone = _ref.spaceZone,
	      spaceZone = _ref$spaceZone === void 0 ? false : _ref$spaceZone;
	  var fmt = "HH:mm";
	
	  if (!suppressSeconds || dt.second !== 0 || dt.millisecond !== 0) {
	    fmt += ":ss";
	
	    if (!suppressMilliseconds || dt.millisecond !== 0) {
	      fmt += ".SSS";
	    }
	  }
	
	  if ((includeZone || includeOffset) && spaceZone) {
	    fmt += " ";
	  }
	
	  if (includeZone) {
	    fmt += "z";
	  } else if (includeOffset) {
	    fmt += "ZZ";
	  }
	
	  return toTechFormat(dt, fmt);
	} // defaults for unspecified units in the supported calendars
	
	
	var defaultUnitValues = {
	  month: 1,
	  day: 1,
	  hour: 0,
	  minute: 0,
	  second: 0,
	  millisecond: 0
	},
	    defaultWeekUnitValues = {
	  weekNumber: 1,
	  weekday: 1,
	  hour: 0,
	  minute: 0,
	  second: 0,
	  millisecond: 0
	},
	    defaultOrdinalUnitValues = {
	  ordinal: 1,
	  hour: 0,
	  minute: 0,
	  second: 0,
	  millisecond: 0
	}; // Units in the supported calendars, sorted by bigness
	
	var orderedUnits$1 = ["year", "month", "day", "hour", "minute", "second", "millisecond"],
	    orderedWeekUnits = ["weekYear", "weekNumber", "weekday", "hour", "minute", "second", "millisecond"],
	    orderedOrdinalUnits = ["year", "ordinal", "hour", "minute", "second", "millisecond"]; // standardize case and plurality in units
	
	function normalizeUnit(unit) {
	  var normalized = {
	    year: "year",
	    years: "year",
	    month: "month",
	    months: "month",
	    day: "day",
	    days: "day",
	    hour: "hour",
	    hours: "hour",
	    minute: "minute",
	    minutes: "minute",
	    second: "second",
	    seconds: "second",
	    millisecond: "millisecond",
	    milliseconds: "millisecond",
	    weekday: "weekday",
	    weekdays: "weekday",
	    weeknumber: "weekNumber",
	    weeksnumber: "weekNumber",
	    weeknumbers: "weekNumber",
	    weekyear: "weekYear",
	    weekyears: "weekYear",
	    ordinal: "ordinal"
	  }[unit.toLowerCase()];
	  if (!normalized) throw new InvalidUnitError(unit);
	  return normalized;
	} // this is a dumbed down version of fromObject() that runs about 60% faster
	// but doesn't do any validation, makes a bunch of assumptions about what units
	// are present, and so on.
	
	
	function quickDT(obj, zone) {
	  // assume we have the higher-order units
	  for (var _i = 0, _orderedUnits = orderedUnits$1; _i < _orderedUnits.length; _i++) {
	    var u = _orderedUnits[_i];
	
	    if (isUndefined(obj[u])) {
	      obj[u] = defaultUnitValues[u];
	    }
	  }
	
	  var invalid = hasInvalidGregorianData(obj) || hasInvalidTimeData(obj);
	
	  if (invalid) {
	    return DateTime.invalid(invalid);
	  }
	
	  var tsNow = Settings.now(),
	      offsetProvis = zone.offset(tsNow),
	      _objToTS = objToTS(obj, offsetProvis, zone),
	      ts = _objToTS[0],
	      o = _objToTS[1];
	
	  return new DateTime({
	    ts: ts,
	    zone: zone,
	    o: o
	  });
	}
	
	function diffRelative(start, end, opts) {
	  var round = isUndefined(opts.round) ? true : opts.round,
	      format = function format(c, unit) {
	    c = roundTo(c, round || opts.calendary ? 0 : 2, true);
	    var formatter = end.loc.clone(opts).relFormatter(opts);
	    return formatter.format(c, unit);
	  },
	      differ = function differ(unit) {
	    if (opts.calendary) {
	      if (!end.hasSame(start, unit)) {
	        return end.startOf(unit).diff(start.startOf(unit), unit).get(unit);
	      } else return 0;
	    } else {
	      return end.diff(start, unit).get(unit);
	    }
	  };
	
	  if (opts.unit) {
	    return format(differ(opts.unit), opts.unit);
	  }
	
	  for (var _iterator = opts.units, _isArray = Array.isArray(_iterator), _i2 = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
	    var _ref2;
	
	    if (_isArray) {
	      if (_i2 >= _iterator.length) break;
	      _ref2 = _iterator[_i2++];
	    } else {
	      _i2 = _iterator.next();
	      if (_i2.done) break;
	      _ref2 = _i2.value;
	    }
	
	    var unit = _ref2;
	    var count = differ(unit);
	
	    if (Math.abs(count) >= 1) {
	      return format(count, unit);
	    }
	  }
	
	  return format(0, opts.units[opts.units.length - 1]);
	}
	/**
	 * A DateTime is an immutable data structure representing a specific date and time and accompanying methods. It contains class and instance methods for creating, parsing, interrogating, transforming, and formatting them.
	 *
	 * A DateTime comprises of:
	 * * A timestamp. Each DateTime instance refers to a specific millisecond of the Unix epoch.
	 * * A time zone. Each instance is considered in the context of a specific zone (by default the local system's zone).
	 * * Configuration properties that effect how output strings are formatted, such as `locale`, `numberingSystem`, and `outputCalendar`.
	 *
	 * Here is a brief overview of the most commonly used functionality it provides:
	 *
	 * * **Creation**: To create a DateTime from its components, use one of its factory class methods: {@link local}, {@link utc}, and (most flexibly) {@link fromObject}. To create one from a standard string format, use {@link fromISO}, {@link fromHTTP}, and {@link fromRFC2822}. To create one from a custom string format, use {@link fromFormat}. To create one from a native JS date, use {@link fromJSDate}.
	 * * **Gregorian calendar and time**: To examine the Gregorian properties of a DateTime individually (i.e as opposed to collectively through {@link toObject}), use the {@link year}, {@link month},
	 * {@link day}, {@link hour}, {@link minute}, {@link second}, {@link millisecond} accessors.
	 * * **Week calendar**: For ISO week calendar attributes, see the {@link weekYear}, {@link weekNumber}, and {@link weekday} accessors.
	 * * **Configuration** See the {@link locale} and {@link numberingSystem} accessors.
	 * * **Transformation**: To transform the DateTime into other DateTimes, use {@link set}, {@link reconfigure}, {@link setZone}, {@link setLocale}, {@link plus}, {@link minus}, {@link endOf}, {@link startOf}, {@link toUTC}, and {@link toLocal}.
	 * * **Output**: To convert the DateTime to other representations, use the {@link toRelative}, {@link toRelativeCalendar}, {@link toJSON}, {@link toISO}, {@link toHTTP}, {@link toObject}, {@link toRFC2822}, {@link toString}, {@link toLocaleString}, {@link toFormat}, {@link toMillis} and {@link toJSDate}.
	 *
	 * There's plenty others documented below. In addition, for more information on subtler topics like internationalization, time zones, alternative calendars, validity, and so on, see the external documentation.
	 */
	
	
	var DateTime =
	/*#__PURE__*/
	function () {
	  /**
	   * @access private
	   */
	  function DateTime(config) {
	    var zone = config.zone || Settings.defaultZone,
	        invalid = config.invalid || (Number.isNaN(config.ts) ? new Invalid("invalid input") : null) || (!zone.isValid ? unsupportedZone(zone) : null);
	    /**
	     * @access private
	     */
	
	    this.ts = isUndefined(config.ts) ? Settings.now() : config.ts;
	    var c = null,
	        o = null;
	
	    if (!invalid) {
	      var unchanged = config.old && config.old.ts === this.ts && config.old.zone.equals(zone);
	      c = unchanged ? config.old.c : tsToObj(this.ts, zone.offset(this.ts));
	      o = unchanged ? config.old.o : zone.offset(this.ts);
	    }
	    /**
	     * @access private
	     */
	
	
	    this._zone = zone;
	    /**
	     * @access private
	     */
	
	    this.loc = config.loc || Locale.create();
	    /**
	     * @access private
	     */
	
	    this.invalid = invalid;
	    /**
	     * @access private
	     */
	
	    this.weekData = null;
	    /**
	     * @access private
	     */
	
	    this.c = c;
	    /**
	     * @access private
	     */
	
	    this.o = o;
	    /**
	     * @access private
	     */
	
	    this.isLuxonDateTime = true;
	  } // CONSTRUCT
	
	  /**
	   * Create a local DateTime
	   * @param {number} year - The calendar year. If omitted (as in, call `local()` with no arguments), the current time will be used
	   * @param {number} [month=1] - The month, 1-indexed
	   * @param {number} [day=1] - The day of the month
	   * @param {number} [hour=0] - The hour of the day, in 24-hour time
	   * @param {number} [minute=0] - The minute of the hour, i.e. a number between 0 and 59
	   * @param {number} [second=0] - The second of the minute, i.e. a number between 0 and 59
	   * @param {number} [millisecond=0] - The millisecond of the second, i.e. a number between 0 and 999
	   * @example DateTime.local()                            //~> now
	   * @example DateTime.local(2017)                        //~> 2017-01-01T00:00:00
	   * @example DateTime.local(2017, 3)                     //~> 2017-03-01T00:00:00
	   * @example DateTime.local(2017, 3, 12)                 //~> 2017-03-12T00:00:00
	   * @example DateTime.local(2017, 3, 12, 5)              //~> 2017-03-12T05:00:00
	   * @example DateTime.local(2017, 3, 12, 5, 45)          //~> 2017-03-12T05:45:00
	   * @example DateTime.local(2017, 3, 12, 5, 45, 10)      //~> 2017-03-12T05:45:10
	   * @example DateTime.local(2017, 3, 12, 5, 45, 10, 765) //~> 2017-03-12T05:45:10.765
	   * @return {DateTime}
	   */
	
	
	  DateTime.local = function local(year, month, day, hour, minute, second, millisecond) {
	    if (isUndefined(year)) {
	      return new DateTime({
	        ts: Settings.now()
	      });
	    } else {
	      return quickDT({
	        year: year,
	        month: month,
	        day: day,
	        hour: hour,
	        minute: minute,
	        second: second,
	        millisecond: millisecond
	      }, Settings.defaultZone);
	    }
	  }
	  /**
	   * Create a DateTime in UTC
	   * @param {number} year - The calendar year. If omitted (as in, call `utc()` with no arguments), the current time will be used
	   * @param {number} [month=1] - The month, 1-indexed
	   * @param {number} [day=1] - The day of the month
	   * @param {number} [hour=0] - The hour of the day, in 24-hour time
	   * @param {number} [minute=0] - The minute of the hour, i.e. a number between 0 and 59
	   * @param {number} [second=0] - The second of the minute, i.e. a number between 0 and 59
	   * @param {number} [millisecond=0] - The millisecond of the second, i.e. a number between 0 and 999
	   * @example DateTime.utc()                            //~> now
	   * @example DateTime.utc(2017)                        //~> 2017-01-01T00:00:00Z
	   * @example DateTime.utc(2017, 3)                     //~> 2017-03-01T00:00:00Z
	   * @example DateTime.utc(2017, 3, 12)                 //~> 2017-03-12T00:00:00Z
	   * @example DateTime.utc(2017, 3, 12, 5)              //~> 2017-03-12T05:00:00Z
	   * @example DateTime.utc(2017, 3, 12, 5, 45)          //~> 2017-03-12T05:45:00Z
	   * @example DateTime.utc(2017, 3, 12, 5, 45, 10)      //~> 2017-03-12T05:45:10Z
	   * @example DateTime.utc(2017, 3, 12, 5, 45, 10, 765) //~> 2017-03-12T05:45:10.765Z
	   * @return {DateTime}
	   */
	  ;
	
	  DateTime.utc = function utc(year, month, day, hour, minute, second, millisecond) {
	    if (isUndefined(year)) {
	      return new DateTime({
	        ts: Settings.now(),
	        zone: FixedOffsetZone.utcInstance
	      });
	    } else {
	      return quickDT({
	        year: year,
	        month: month,
	        day: day,
	        hour: hour,
	        minute: minute,
	        second: second,
	        millisecond: millisecond
	      }, FixedOffsetZone.utcInstance);
	    }
	  }
	  /**
	   * Create a DateTime from a Javascript Date object. Uses the default zone.
	   * @param {Date} date - a Javascript Date object
	   * @param {Object} options - configuration options for the DateTime
	   * @param {string|Zone} [options.zone='local'] - the zone to place the DateTime into
	   * @return {DateTime}
	   */
	  ;
	
	  DateTime.fromJSDate = function fromJSDate(date, options) {
	    if (options === void 0) {
	      options = {};
	    }
	
	    var ts = isDate(date) ? date.valueOf() : NaN;
	
	    if (Number.isNaN(ts)) {
	      return DateTime.invalid("invalid input");
	    }
	
	    var zoneToUse = normalizeZone(options.zone, Settings.defaultZone);
	
	    if (!zoneToUse.isValid) {
	      return DateTime.invalid(unsupportedZone(zoneToUse));
	    }
	
	    return new DateTime({
	      ts: ts,
	      zone: zoneToUse,
	      loc: Locale.fromObject(options)
	    });
	  }
	  /**
	   * Create a DateTime from a number of milliseconds since the epoch (i.e. since 1 January 1970 00:00:00 UTC). Uses the default zone.
	   * @param {number} milliseconds - a number of milliseconds since 1970 UTC
	   * @param {Object} options - configuration options for the DateTime
	   * @param {string|Zone} [options.zone='local'] - the zone to place the DateTime into
	   * @param {string} [options.locale] - a locale to set on the resulting DateTime instance
	   * @param {string} options.outputCalendar - the output calendar to set on the resulting DateTime instance
	   * @param {string} options.numberingSystem - the numbering system to set on the resulting DateTime instance
	   * @return {DateTime}
	   */
	  ;
	
	  DateTime.fromMillis = function fromMillis(milliseconds, options) {
	    if (options === void 0) {
	      options = {};
	    }
	
	    if (!isNumber(milliseconds)) {
	      throw new InvalidArgumentError("fromMillis requires a numerical input");
	    } else {
	      return new DateTime({
	        ts: milliseconds,
	        zone: normalizeZone(options.zone, Settings.defaultZone),
	        loc: Locale.fromObject(options)
	      });
	    }
	  }
	  /**
	   * Create a DateTime from a number of seconds since the epoch (i.e. since 1 January 1970 00:00:00 UTC). Uses the default zone.
	   * @param {number} seconds - a number of seconds since 1970 UTC
	   * @param {Object} options - configuration options for the DateTime
	   * @param {string|Zone} [options.zone='local'] - the zone to place the DateTime into
	   * @param {string} [options.locale] - a locale to set on the resulting DateTime instance
	   * @param {string} options.outputCalendar - the output calendar to set on the resulting DateTime instance
	   * @param {string} options.numberingSystem - the numbering system to set on the resulting DateTime instance
	   * @return {DateTime}
	   */
	  ;
	
	  DateTime.fromSeconds = function fromSeconds(seconds, options) {
	    if (options === void 0) {
	      options = {};
	    }
	
	    if (!isNumber(seconds)) {
	      throw new InvalidArgumentError("fromSeconds requires a numerical input");
	    } else {
	      return new DateTime({
	        ts: seconds * 1000,
	        zone: normalizeZone(options.zone, Settings.defaultZone),
	        loc: Locale.fromObject(options)
	      });
	    }
	  }
	  /**
	   * Create a DateTime from a Javascript object with keys like 'year' and 'hour' with reasonable defaults.
	   * @param {Object} obj - the object to create the DateTime from
	   * @param {number} obj.year - a year, such as 1987
	   * @param {number} obj.month - a month, 1-12
	   * @param {number} obj.day - a day of the month, 1-31, depending on the month
	   * @param {number} obj.ordinal - day of the year, 1-365 or 366
	   * @param {number} obj.weekYear - an ISO week year
	   * @param {number} obj.weekNumber - an ISO week number, between 1 and 52 or 53, depending on the year
	   * @param {number} obj.weekday - an ISO weekday, 1-7, where 1 is Monday and 7 is Sunday
	   * @param {number} obj.hour - hour of the day, 0-23
	   * @param {number} obj.minute - minute of the hour, 0-59
	   * @param {number} obj.second - second of the minute, 0-59
	   * @param {number} obj.millisecond - millisecond of the second, 0-999
	   * @param {string|Zone} [obj.zone='local'] - interpret the numbers in the context of a particular zone. Can take any value taken as the first argument to setZone()
	   * @param {string} [obj.locale='system's locale'] - a locale to set on the resulting DateTime instance
	   * @param {string} obj.outputCalendar - the output calendar to set on the resulting DateTime instance
	   * @param {string} obj.numberingSystem - the numbering system to set on the resulting DateTime instance
	   * @example DateTime.fromObject({ year: 1982, month: 5, day: 25}).toISODate() //=> '1982-05-25'
	   * @example DateTime.fromObject({ year: 1982 }).toISODate() //=> '1982-01-01'
	   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }) //~> today at 10:26:06
	   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6, zone: 'utc' }),
	   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6, zone: 'local' })
	   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6, zone: 'America/New_York' })
	   * @example DateTime.fromObject({ weekYear: 2016, weekNumber: 2, weekday: 3 }).toISODate() //=> '2016-01-13'
	   * @return {DateTime}
	   */
	  ;
	
	  DateTime.fromObject = function fromObject(obj) {
	    var zoneToUse = normalizeZone(obj.zone, Settings.defaultZone);
	
	    if (!zoneToUse.isValid) {
	      return DateTime.invalid(unsupportedZone(zoneToUse));
	    }
	
	    var tsNow = Settings.now(),
	        offsetProvis = zoneToUse.offset(tsNow),
	        normalized = normalizeObject(obj, normalizeUnit, ["zone", "locale", "outputCalendar", "numberingSystem"]),
	        containsOrdinal = !isUndefined(normalized.ordinal),
	        containsGregorYear = !isUndefined(normalized.year),
	        containsGregorMD = !isUndefined(normalized.month) || !isUndefined(normalized.day),
	        containsGregor = containsGregorYear || containsGregorMD,
	        definiteWeekDef = normalized.weekYear || normalized.weekNumber,
	        loc = Locale.fromObject(obj); // cases:
	    // just a weekday -> this week's instance of that weekday, no worries
	    // (gregorian data or ordinal) + (weekYear or weekNumber) -> error
	    // (gregorian month or day) + ordinal -> error
	    // otherwise just use weeks or ordinals or gregorian, depending on what's specified
	
	    if ((containsGregor || containsOrdinal) && definiteWeekDef) {
	      throw new ConflictingSpecificationError("Can't mix weekYear/weekNumber units with year/month/day or ordinals");
	    }
	
	    if (containsGregorMD && containsOrdinal) {
	      throw new ConflictingSpecificationError("Can't mix ordinal dates with month/day");
	    }
	
	    var useWeekData = definiteWeekDef || normalized.weekday && !containsGregor; // configure ourselves to deal with gregorian dates or week stuff
	
	    var units,
	        defaultValues,
	        objNow = tsToObj(tsNow, offsetProvis);
	
	    if (useWeekData) {
	      units = orderedWeekUnits;
	      defaultValues = defaultWeekUnitValues;
	      objNow = gregorianToWeek(objNow);
	    } else if (containsOrdinal) {
	      units = orderedOrdinalUnits;
	      defaultValues = defaultOrdinalUnitValues;
	      objNow = gregorianToOrdinal(objNow);
	    } else {
	      units = orderedUnits$1;
	      defaultValues = defaultUnitValues;
	    } // set default values for missing stuff
	
	
	    var foundFirst = false;
	
	    for (var _iterator2 = units, _isArray2 = Array.isArray(_iterator2), _i3 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;) {
	      var _ref3;
	
	      if (_isArray2) {
	        if (_i3 >= _iterator2.length) break;
	        _ref3 = _iterator2[_i3++];
	      } else {
	        _i3 = _iterator2.next();
	        if (_i3.done) break;
	        _ref3 = _i3.value;
	      }
	
	      var u = _ref3;
	      var v = normalized[u];
	
	      if (!isUndefined(v)) {
	        foundFirst = true;
	      } else if (foundFirst) {
	        normalized[u] = defaultValues[u];
	      } else {
	        normalized[u] = objNow[u];
	      }
	    } // make sure the values we have are in range
	
	
	    var higherOrderInvalid = useWeekData ? hasInvalidWeekData(normalized) : containsOrdinal ? hasInvalidOrdinalData(normalized) : hasInvalidGregorianData(normalized),
	        invalid = higherOrderInvalid || hasInvalidTimeData(normalized);
	
	    if (invalid) {
	      return DateTime.invalid(invalid);
	    } // compute the actual time
	
	
	    var gregorian = useWeekData ? weekToGregorian(normalized) : containsOrdinal ? ordinalToGregorian(normalized) : normalized,
	        _objToTS2 = objToTS(gregorian, offsetProvis, zoneToUse),
	        tsFinal = _objToTS2[0],
	        offsetFinal = _objToTS2[1],
	        inst = new DateTime({
	      ts: tsFinal,
	      zone: zoneToUse,
	      o: offsetFinal,
	      loc: loc
	    }); // gregorian data + weekday serves only to validate
	
	
	    if (normalized.weekday && containsGregor && obj.weekday !== inst.weekday) {
	      return DateTime.invalid("mismatched weekday", "you can't specify both a weekday of " + normalized.weekday + " and a date of " + inst.toISO());
	    }
	
	    return inst;
	  }
	  /**
	   * Create a DateTime from an ISO 8601 string
	   * @param {string} text - the ISO string
	   * @param {Object} opts - options to affect the creation
	   * @param {string|Zone} [opts.zone='local'] - use this zone if no offset is specified in the input string itself. Will also convert the time to this zone
	   * @param {boolean} [opts.setZone=false] - override the zone with a fixed-offset zone specified in the string itself, if it specifies one
	   * @param {string} [opts.locale='system's locale'] - a locale to set on the resulting DateTime instance
	   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
	   * @param {string} opts.numberingSystem - the numbering system to set on the resulting DateTime instance
	   * @example DateTime.fromISO('2016-05-25T09:08:34.123')
	   * @example DateTime.fromISO('2016-05-25T09:08:34.123+06:00')
	   * @example DateTime.fromISO('2016-05-25T09:08:34.123+06:00', {setZone: true})
	   * @example DateTime.fromISO('2016-05-25T09:08:34.123', {zone: 'utc'})
	   * @example DateTime.fromISO('2016-W05-4')
	   * @return {DateTime}
	   */
	  ;
	
	  DateTime.fromISO = function fromISO(text, opts) {
	    if (opts === void 0) {
	      opts = {};
	    }
	
	    var _parseISODate = parseISODate(text),
	        vals = _parseISODate[0],
	        parsedZone = _parseISODate[1];
	
	    return parseDataToDateTime(vals, parsedZone, opts, "ISO 8601", text);
	  }
	  /**
	   * Create a DateTime from an RFC 2822 string
	   * @param {string} text - the RFC 2822 string
	   * @param {Object} opts - options to affect the creation
	   * @param {string|Zone} [opts.zone='local'] - convert the time to this zone. Since the offset is always specified in the string itself, this has no effect on the interpretation of string, merely the zone the resulting DateTime is expressed in.
	   * @param {boolean} [opts.setZone=false] - override the zone with a fixed-offset zone specified in the string itself, if it specifies one
	   * @param {string} [opts.locale='system's locale'] - a locale to set on the resulting DateTime instance
	   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
	   * @param {string} opts.numberingSystem - the numbering system to set on the resulting DateTime instance
	   * @example DateTime.fromRFC2822('25 Nov 2016 13:23:12 GMT')
	   * @example DateTime.fromRFC2822('Fri, 25 Nov 2016 13:23:12 +0600')
	   * @example DateTime.fromRFC2822('25 Nov 2016 13:23 Z')
	   * @return {DateTime}
	   */
	  ;
	
	  DateTime.fromRFC2822 = function fromRFC2822(text, opts) {
	    if (opts === void 0) {
	      opts = {};
	    }
	
	    var _parseRFC2822Date = parseRFC2822Date(text),
	        vals = _parseRFC2822Date[0],
	        parsedZone = _parseRFC2822Date[1];
	
	    return parseDataToDateTime(vals, parsedZone, opts, "RFC 2822", text);
	  }
	  /**
	   * Create a DateTime from an HTTP header date
	   * @see https://www.w3.org/Protocols/rfc2616/rfc2616-sec3.html#sec3.3.1
	   * @param {string} text - the HTTP header date
	   * @param {Object} opts - options to affect the creation
	   * @param {string|Zone} [opts.zone='local'] - convert the time to this zone. Since HTTP dates are always in UTC, this has no effect on the interpretation of string, merely the zone the resulting DateTime is expressed in.
	   * @param {boolean} [opts.setZone=false] - override the zone with the fixed-offset zone specified in the string. For HTTP dates, this is always UTC, so this option is equivalent to setting the `zone` option to 'utc', but this option is included for consistency with similar methods.
	   * @param {string} [opts.locale='system's locale'] - a locale to set on the resulting DateTime instance
	   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
	   * @param {string} opts.numberingSystem - the numbering system to set on the resulting DateTime instance
	   * @example DateTime.fromHTTP('Sun, 06 Nov 1994 08:49:37 GMT')
	   * @example DateTime.fromHTTP('Sunday, 06-Nov-94 08:49:37 GMT')
	   * @example DateTime.fromHTTP('Sun Nov  6 08:49:37 1994')
	   * @return {DateTime}
	   */
	  ;
	
	  DateTime.fromHTTP = function fromHTTP(text, opts) {
	    if (opts === void 0) {
	      opts = {};
	    }
	
	    var _parseHTTPDate = parseHTTPDate(text),
	        vals = _parseHTTPDate[0],
	        parsedZone = _parseHTTPDate[1];
	
	    return parseDataToDateTime(vals, parsedZone, opts, "HTTP", opts);
	  }
	  /**
	   * Create a DateTime from an input string and format string.
	   * Defaults to en-US if no locale has been specified, regardless of the system's locale.
	   * @see https://moment.github.io/luxon/docs/manual/parsing.html#table-of-tokens
	   * @param {string} text - the string to parse
	   * @param {string} fmt - the format the string is expected to be in (see the link below for the formats)
	   * @param {Object} opts - options to affect the creation
	   * @param {string|Zone} [opts.zone='local'] - use this zone if no offset is specified in the input string itself. Will also convert the DateTime to this zone
	   * @param {boolean} [opts.setZone=false] - override the zone with a zone specified in the string itself, if it specifies one
	   * @param {string} [opts.locale='en-US'] - a locale string to use when parsing. Will also set the DateTime to this locale
	   * @param {string} opts.numberingSystem - the numbering system to use when parsing. Will also set the resulting DateTime to this numbering system
	   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
	   * @return {DateTime}
	   */
	  ;
	
	  DateTime.fromFormat = function fromFormat(text, fmt, opts) {
	    if (opts === void 0) {
	      opts = {};
	    }
	
	    if (isUndefined(text) || isUndefined(fmt)) {
	      throw new InvalidArgumentError("fromFormat requires an input string and a format");
	    }
	
	    var _opts = opts,
	        _opts$locale = _opts.locale,
	        locale = _opts$locale === void 0 ? null : _opts$locale,
	        _opts$numberingSystem = _opts.numberingSystem,
	        numberingSystem = _opts$numberingSystem === void 0 ? null : _opts$numberingSystem,
	        localeToUse = Locale.fromOpts({
	      locale: locale,
	      numberingSystem: numberingSystem,
	      defaultToEN: true
	    }),
	        _parseFromTokens = parseFromTokens(localeToUse, text, fmt),
	        vals = _parseFromTokens[0],
	        parsedZone = _parseFromTokens[1],
	        invalid = _parseFromTokens[2];
	
	    if (invalid) {
	      return DateTime.invalid(invalid);
	    } else {
	      return parseDataToDateTime(vals, parsedZone, opts, "format " + fmt, text);
	    }
	  }
	  /**
	   * @deprecated use fromFormat instead
	   */
	  ;
	
	  DateTime.fromString = function fromString(text, fmt, opts) {
	    if (opts === void 0) {
	      opts = {};
	    }
	
	    return DateTime.fromFormat(text, fmt, opts);
	  }
	  /**
	   * Create a DateTime from a SQL date, time, or datetime
	   * Defaults to en-US if no locale has been specified, regardless of the system's locale
	   * @param {string} text - the string to parse
	   * @param {Object} opts - options to affect the creation
	   * @param {string|Zone} [opts.zone='local'] - use this zone if no offset is specified in the input string itself. Will also convert the DateTime to this zone
	   * @param {boolean} [opts.setZone=false] - override the zone with a zone specified in the string itself, if it specifies one
	   * @param {string} [opts.locale='en-US'] - a locale string to use when parsing. Will also set the DateTime to this locale
	   * @param {string} opts.numberingSystem - the numbering system to use when parsing. Will also set the resulting DateTime to this numbering system
	   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
	   * @example DateTime.fromSQL('2017-05-15')
	   * @example DateTime.fromSQL('2017-05-15 09:12:34')
	   * @example DateTime.fromSQL('2017-05-15 09:12:34.342')
	   * @example DateTime.fromSQL('2017-05-15 09:12:34.342+06:00')
	   * @example DateTime.fromSQL('2017-05-15 09:12:34.342 America/Los_Angeles')
	   * @example DateTime.fromSQL('2017-05-15 09:12:34.342 America/Los_Angeles', { setZone: true })
	   * @example DateTime.fromSQL('2017-05-15 09:12:34.342', { zone: 'America/Los_Angeles' })
	   * @example DateTime.fromSQL('09:12:34.342')
	   * @return {DateTime}
	   */
	  ;
	
	  DateTime.fromSQL = function fromSQL(text, opts) {
	    if (opts === void 0) {
	      opts = {};
	    }
	
	    var _parseSQL = parseSQL(text),
	        vals = _parseSQL[0],
	        parsedZone = _parseSQL[1];
	
	    return parseDataToDateTime(vals, parsedZone, opts, "SQL", text);
	  }
	  /**
	   * Create an invalid DateTime.
	   * @param {string} reason - simple string of why this DateTime is invalid. Should not contain parameters or anything else data-dependent
	   * @param {string} [explanation=null] - longer explanation, may include parameters and other useful debugging information
	   * @return {DateTime}
	   */
	  ;
	
	  DateTime.invalid = function invalid(reason, explanation) {
	    if (explanation === void 0) {
	      explanation = null;
	    }
	
	    if (!reason) {
	      throw new InvalidArgumentError("need to specify a reason the DateTime is invalid");
	    }
	
	    var invalid = reason instanceof Invalid ? reason : new Invalid(reason, explanation);
	
	    if (Settings.throwOnInvalid) {
	      throw new InvalidDateTimeError(invalid);
	    } else {
	      return new DateTime({
	        invalid: invalid
	      });
	    }
	  }
	  /**
	   * Check if an object is a DateTime. Works across context boundaries
	   * @param {object} o
	   * @return {boolean}
	   */
	  ;
	
	  DateTime.isDateTime = function isDateTime(o) {
	    return o && o.isLuxonDateTime || false;
	  } // INFO
	
	  /**
	   * Get the value of unit.
	   * @param {string} unit - a unit such as 'minute' or 'day'
	   * @example DateTime.local(2017, 7, 4).get('month'); //=> 7
	   * @example DateTime.local(2017, 7, 4).get('day'); //=> 4
	   * @return {number}
	   */
	  ;
	
	  var _proto = DateTime.prototype;
	
	  _proto.get = function get(unit) {
	    return this[unit];
	  }
	  /**
	   * Returns whether the DateTime is valid. Invalid DateTimes occur when:
	   * * The DateTime was created from invalid calendar information, such as the 13th month or February 30
	   * * The DateTime was created by an operation on another invalid date
	   * @type {boolean}
	   */
	  ;
	
	  /**
	   * Returns the resolved Intl options for this DateTime.
	   * This is useful in understanding the behavior of formatting methods
	   * @param {Object} opts - the same options as toLocaleString
	   * @return {Object}
	   */
	  _proto.resolvedLocaleOpts = function resolvedLocaleOpts(opts) {
	    if (opts === void 0) {
	      opts = {};
	    }
	
	    var _Formatter$create$res = Formatter.create(this.loc.clone(opts), opts).resolvedOptions(this),
	        locale = _Formatter$create$res.locale,
	        numberingSystem = _Formatter$create$res.numberingSystem,
	        calendar = _Formatter$create$res.calendar;
	
	    return {
	      locale: locale,
	      numberingSystem: numberingSystem,
	      outputCalendar: calendar
	    };
	  } // TRANSFORM
	
	  /**
	   * "Set" the DateTime's zone to UTC. Returns a newly-constructed DateTime.
	   *
	   * Equivalent to {@link setZone}('utc')
	   * @param {number} [offset=0] - optionally, an offset from UTC in minutes
	   * @param {Object} [opts={}] - options to pass to `setZone()`
	   * @return {DateTime}
	   */
	  ;
	
	  _proto.toUTC = function toUTC(offset, opts) {
	    if (offset === void 0) {
	      offset = 0;
	    }
	
	    if (opts === void 0) {
	      opts = {};
	    }
	
	    return this.setZone(FixedOffsetZone.instance(offset), opts);
	  }
	  /**
	   * "Set" the DateTime's zone to the host's local zone. Returns a newly-constructed DateTime.
	   *
	   * Equivalent to `setZone('local')`
	   * @return {DateTime}
	   */
	  ;
	
	  _proto.toLocal = function toLocal() {
	    return this.setZone(Settings.defaultZone);
	  }
	  /**
	   * "Set" the DateTime's zone to specified zone. Returns a newly-constructed DateTime.
	   *
	   * By default, the setter keeps the underlying time the same (as in, the same timestamp), but the new instance will report different local times and consider DSTs when making computations, as with {@link plus}. You may wish to use {@link toLocal} and {@link toUTC} which provide simple convenience wrappers for commonly used zones.
	   * @param {string|Zone} [zone='local'] - a zone identifier. As a string, that can be any IANA zone supported by the host environment, or a fixed-offset name of the form 'UTC+3', or the strings 'local' or 'utc'. You may also supply an instance of a {@link Zone} class.
	   * @param {Object} opts - options
	   * @param {boolean} [opts.keepLocalTime=false] - If true, adjust the underlying time so that the local time stays the same, but in the target zone. You should rarely need this.
	   * @return {DateTime}
	   */
	  ;
	
	  _proto.setZone = function setZone(zone, _temp) {
	    var _ref4 = _temp === void 0 ? {} : _temp,
	        _ref4$keepLocalTime = _ref4.keepLocalTime,
	        keepLocalTime = _ref4$keepLocalTime === void 0 ? false : _ref4$keepLocalTime,
	        _ref4$keepCalendarTim = _ref4.keepCalendarTime,
	        keepCalendarTime = _ref4$keepCalendarTim === void 0 ? false : _ref4$keepCalendarTim;
	
	    zone = normalizeZone(zone, Settings.defaultZone);
	
	    if (zone.equals(this.zone)) {
	      return this;
	    } else if (!zone.isValid) {
	      return DateTime.invalid(unsupportedZone(zone));
	    } else {
	      var newTS = this.ts;
	
	      if (keepLocalTime || keepCalendarTime) {
	        var offsetGuess = this.o - zone.offset(this.ts);
	        var asObj = this.toObject();
	
	        var _objToTS3 = objToTS(asObj, offsetGuess, zone);
	
	        newTS = _objToTS3[0];
	      }
	
	      return clone$1(this, {
	        ts: newTS,
	        zone: zone
	      });
	    }
	  }
	  /**
	   * "Set" the locale, numberingSystem, or outputCalendar. Returns a newly-constructed DateTime.
	   * @param {Object} properties - the properties to set
	   * @example DateTime.local(2017, 5, 25).reconfigure({ locale: 'en-GB' })
	   * @return {DateTime}
	   */
	  ;
	
	  _proto.reconfigure = function reconfigure(_temp2) {
	    var _ref5 = _temp2 === void 0 ? {} : _temp2,
	        locale = _ref5.locale,
	        numberingSystem = _ref5.numberingSystem,
	        outputCalendar = _ref5.outputCalendar;
	
	    var loc = this.loc.clone({
	      locale: locale,
	      numberingSystem: numberingSystem,
	      outputCalendar: outputCalendar
	    });
	    return clone$1(this, {
	      loc: loc
	    });
	  }
	  /**
	   * "Set" the locale. Returns a newly-constructed DateTime.
	   * Just a convenient alias for reconfigure({ locale })
	   * @example DateTime.local(2017, 5, 25).setLocale('en-GB')
	   * @return {DateTime}
	   */
	  ;
	
	  _proto.setLocale = function setLocale(locale) {
	    return this.reconfigure({
	      locale: locale
	    });
	  }
	  /**
	   * "Set" the values of specified units. Returns a newly-constructed DateTime.
	   * You can only set units with this method; for "setting" metadata, see {@link reconfigure} and {@link setZone}.
	   * @param {Object} values - a mapping of units to numbers
	   * @example dt.set({ year: 2017 })
	   * @example dt.set({ hour: 8, minute: 30 })
	   * @example dt.set({ weekday: 5 })
	   * @example dt.set({ year: 2005, ordinal: 234 })
	   * @return {DateTime}
	   */
	  ;
	
	  _proto.set = function set(values) {
	    if (!this.isValid) return this;
	    var normalized = normalizeObject(values, normalizeUnit, []),
	        settingWeekStuff = !isUndefined(normalized.weekYear) || !isUndefined(normalized.weekNumber) || !isUndefined(normalized.weekday);
	    var mixed;
	
	    if (settingWeekStuff) {
	      mixed = weekToGregorian(Object.assign(gregorianToWeek(this.c), normalized));
	    } else if (!isUndefined(normalized.ordinal)) {
	      mixed = ordinalToGregorian(Object.assign(gregorianToOrdinal(this.c), normalized));
	    } else {
	      mixed = Object.assign(this.toObject(), normalized); // if we didn't set the day but we ended up on an overflow date,
	      // use the last day of the right month
	
	      if (isUndefined(normalized.day)) {
	        mixed.day = Math.min(daysInMonth(mixed.year, mixed.month), mixed.day);
	      }
	    }
	
	    var _objToTS4 = objToTS(mixed, this.o, this.zone),
	        ts = _objToTS4[0],
	        o = _objToTS4[1];
	
	    return clone$1(this, {
	      ts: ts,
	      o: o
	    });
	  }
	  /**
	   * Add a period of time to this DateTime and return the resulting DateTime
	   *
	   * Adding hours, minutes, seconds, or milliseconds increases the timestamp by the right number of milliseconds. Adding days, months, or years shifts the calendar, accounting for DSTs and leap years along the way. Thus, `dt.plus({ hours: 24 })` may result in a different time than `dt.plus({ days: 1 })` if there's a DST shift in between.
	   * @param {Duration|Object|number} duration - The amount to add. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
	   * @example DateTime.local().plus(123) //~> in 123 milliseconds
	   * @example DateTime.local().plus({ minutes: 15 }) //~> in 15 minutes
	   * @example DateTime.local().plus({ days: 1 }) //~> this time tomorrow
	   * @example DateTime.local().plus({ days: -1 }) //~> this time yesterday
	   * @example DateTime.local().plus({ hours: 3, minutes: 13 }) //~> in 3 hr, 13 min
	   * @example DateTime.local().plus(Duration.fromObject({ hours: 3, minutes: 13 })) //~> in 3 hr, 13 min
	   * @return {DateTime}
	   */
	  ;
	
	  _proto.plus = function plus(duration) {
	    if (!this.isValid) return this;
	    var dur = friendlyDuration(duration);
	    return clone$1(this, adjustTime(this, dur));
	  }
	  /**
	   * Subtract a period of time to this DateTime and return the resulting DateTime
	   * See {@link plus}
	   * @param {Duration|Object|number} duration - The amount to subtract. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
	   @return {DateTime}
	  */
	  ;
	
	  _proto.minus = function minus(duration) {
	    if (!this.isValid) return this;
	    var dur = friendlyDuration(duration).negate();
	    return clone$1(this, adjustTime(this, dur));
	  }
	  /**
	   * "Set" this DateTime to the beginning of a unit of time.
	   * @param {string} unit - The unit to go to the beginning of. Can be 'year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', or 'millisecond'.
	   * @example DateTime.local(2014, 3, 3).startOf('month').toISODate(); //=> '2014-03-01'
	   * @example DateTime.local(2014, 3, 3).startOf('year').toISODate(); //=> '2014-01-01'
	   * @example DateTime.local(2014, 3, 3, 5, 30).startOf('day').toISOTime(); //=> '00:00.000-05:00'
	   * @example DateTime.local(2014, 3, 3, 5, 30).startOf('hour').toISOTime(); //=> '05:00:00.000-05:00'
	   * @return {DateTime}
	   */
	  ;
	
	  _proto.startOf = function startOf(unit) {
	    if (!this.isValid) return this;
	    var o = {},
	        normalizedUnit = Duration.normalizeUnit(unit);
	
	    switch (normalizedUnit) {
	      case "years":
	        o.month = 1;
	      // falls through
	
	      case "quarters":
	      case "months":
	        o.day = 1;
	      // falls through
	
	      case "weeks":
	      case "days":
	        o.hour = 0;
	      // falls through
	
	      case "hours":
	        o.minute = 0;
	      // falls through
	
	      case "minutes":
	        o.second = 0;
	      // falls through
	
	      case "seconds":
	        o.millisecond = 0;
	        break;
	
	      case "milliseconds":
	        break;
	      // no default, invalid units throw in normalizeUnit()
	    }
	
	    if (normalizedUnit === "weeks") {
	      o.weekday = 1;
	    }
	
	    if (normalizedUnit === "quarters") {
	      var q = Math.ceil(this.month / 3);
	      o.month = (q - 1) * 3 + 1;
	    }
	
	    return this.set(o);
	  }
	  /**
	   * "Set" this DateTime to the end (i.e. the last millisecond) of a unit of time
	   * @param {string} unit - The unit to go to the end of. Can be 'year', 'month', 'day', 'hour', 'minute', 'second', or 'millisecond'.
	   * @example DateTime.local(2014, 3, 3).endOf('month').toISO(); //=> '2014-03-31T23:59:59.999-05:00'
	   * @example DateTime.local(2014, 3, 3).endOf('year').toISO(); //=> '2014-12-31T23:59:59.999-05:00'
	   * @example DateTime.local(2014, 3, 3, 5, 30).endOf('day').toISO(); //=> '2014-03-03T23:59:59.999-05:00'
	   * @example DateTime.local(2014, 3, 3, 5, 30).endOf('hour').toISO(); //=> '2014-03-03T05:59:59.999-05:00'
	   * @return {DateTime}
	   */
	  ;
	
	  _proto.endOf = function endOf(unit) {
	    var _this$plus;
	
	    return this.isValid ? this.plus((_this$plus = {}, _this$plus[unit] = 1, _this$plus)).startOf(unit).minus(1) : this;
	  } // OUTPUT
	
	  /**
	   * Returns a string representation of this DateTime formatted according to the specified format string.
	   * **You may not want this.** See {@link toLocaleString} for a more flexible formatting tool. For a table of tokens and their interpretations, see [here](https://moment.github.io/luxon/docs/manual/formatting.html#table-of-tokens).
	   * Defaults to en-US if no locale has been specified, regardless of the system's locale.
	   * @see https://moment.github.io/luxon/docs/manual/formatting.html#table-of-tokens
	   * @param {string} fmt - the format string
	   * @param {Object} opts - opts to override the configuration options
	   * @example DateTime.local().toFormat('yyyy LLL dd') //=> '2017 Apr 22'
	   * @example DateTime.local().setLocale('fr').toFormat('yyyy LLL dd') //=> '2017 avr. 22'
	   * @example DateTime.local().toFormat('yyyy LLL dd', { locale: "fr" }) //=> '2017 avr. 22'
	   * @example DateTime.local().toFormat("HH 'hours and' mm 'minutes'") //=> '20 hours and 55 minutes'
	   * @return {string}
	   */
	  ;
	
	  _proto.toFormat = function toFormat(fmt, opts) {
	    if (opts === void 0) {
	      opts = {};
	    }
	
	    return this.isValid ? Formatter.create(this.loc.redefaultToEN(opts)).formatDateTimeFromString(this, fmt) : INVALID$2;
	  }
	  /**
	   * Returns a localized string representing this date. Accepts the same options as the Intl.DateTimeFormat constructor and any presets defined by Luxon, such as `DateTime.DATE_FULL` or `DateTime.TIME_SIMPLE`.
	   * The exact behavior of this method is browser-specific, but in general it will return an appropriate representation
	   * of the DateTime in the assigned locale.
	   * Defaults to the system's locale if no locale has been specified
	   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
	   * @param opts {Object} - Intl.DateTimeFormat constructor options and configuration options
	   * @example DateTime.local().toLocaleString(); //=> 4/20/2017
	   * @example DateTime.local().setLocale('en-gb').toLocaleString(); //=> '20/04/2017'
	   * @example DateTime.local().toLocaleString({ locale: 'en-gb' }); //=> '20/04/2017'
	   * @example DateTime.local().toLocaleString(DateTime.DATE_FULL); //=> 'April 20, 2017'
	   * @example DateTime.local().toLocaleString(DateTime.TIME_SIMPLE); //=> '11:32 AM'
	   * @example DateTime.local().toLocaleString(DateTime.DATETIME_SHORT); //=> '4/20/2017, 11:32 AM'
	   * @example DateTime.local().toLocaleString({ weekday: 'long', month: 'long', day: '2-digit' }); //=> 'Thursday, April 20'
	   * @example DateTime.local().toLocaleString({ weekday: 'short', month: 'short', day: '2-digit', hour: '2-digit', minute: '2-digit' }); //=> 'Thu, Apr 20, 11:27 AM'
	   * @example DateTime.local().toLocaleString({ hour: '2-digit', minute: '2-digit', hour12: false }); //=> '11:32'
	   * @return {string}
	   */
	  ;
	
	  _proto.toLocaleString = function toLocaleString(opts) {
	    if (opts === void 0) {
	      opts = DATE_SHORT;
	    }
	
	    return this.isValid ? Formatter.create(this.loc.clone(opts), opts).formatDateTime(this) : INVALID$2;
	  }
	  /**
	   * Returns an array of format "parts", i.e. individual tokens along with metadata. This is allows callers to post-process individual sections of the formatted output.
	   * Defaults to the system's locale if no locale has been specified
	   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat/formatToParts
	   * @param opts {Object} - Intl.DateTimeFormat constructor options, same as `toLocaleString`.
	   * @example DateTime.local().toLocaleString(); //=> [
	   *                                    //=>   { type: 'day', value: '25' },
	   *                                    //=>   { type: 'literal', value: '/' },
	   *                                    //=>   { type: 'month', value: '05' },
	   *                                    //=>   { type: 'literal', value: '/' },
	   *                                    //=>   { type: 'year', value: '1982' }
	   *                                    //=> ]
	   */
	  ;
	
	  _proto.toLocaleParts = function toLocaleParts(opts) {
	    if (opts === void 0) {
	      opts = {};
	    }
	
	    return this.isValid ? Formatter.create(this.loc.clone(opts), opts).formatDateTimeParts(this) : [];
	  }
	  /**
	   * Returns an ISO 8601-compliant string representation of this DateTime
	   * @param {Object} opts - options
	   * @param {boolean} [opts.suppressMilliseconds=false] - exclude milliseconds from the format if they're 0
	   * @param {boolean} [opts.suppressSeconds=false] - exclude seconds from the format if they're 0
	   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
	   * @example DateTime.utc(1982, 5, 25).toISO() //=> '1982-05-25T00:00:00.000Z'
	   * @example DateTime.local().toISO() //=> '2017-04-22T20:47:05.335-04:00'
	   * @example DateTime.local().toISO({ includeOffset: false }) //=> '2017-04-22T20:47:05.335'
	   * @return {string}
	   */
	  ;
	
	  _proto.toISO = function toISO(opts) {
	    if (opts === void 0) {
	      opts = {};
	    }
	
	    if (!this.isValid) {
	      return null;
	    }
	
	    return this.toISODate() + "T" + this.toISOTime(opts);
	  }
	  /**
	   * Returns an ISO 8601-compliant string representation of this DateTime's date component
	   * @example DateTime.utc(1982, 5, 25).toISODate() //=> '1982-05-25'
	   * @return {string}
	   */
	  ;
	
	  _proto.toISODate = function toISODate() {
	    var format = "yyyy-MM-dd";
	
	    if (this.year > 9999) {
	      format = "+" + format;
	    }
	
	    return toTechFormat(this, format);
	  }
	  /**
	   * Returns an ISO 8601-compliant string representation of this DateTime's week date
	   * @example DateTime.utc(1982, 5, 25).toISOWeekDate() //=> '1982-W21-2'
	   * @return {string}
	   */
	  ;
	
	  _proto.toISOWeekDate = function toISOWeekDate() {
	    return toTechFormat(this, "kkkk-'W'WW-c");
	  }
	  /**
	   * Returns an ISO 8601-compliant string representation of this DateTime's time component
	   * @param {Object} opts - options
	   * @param {boolean} [opts.suppressMilliseconds=false] - exclude milliseconds from the format if they're 0
	   * @param {boolean} [opts.suppressSeconds=false] - exclude seconds from the format if they're 0
	   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
	   * @example DateTime.utc().hour(7).minute(34).toISOTime() //=> '07:34:19.361Z'
	   * @example DateTime.utc().hour(7).minute(34).toISOTime({ suppressSeconds: true }) //=> '07:34Z'
	   * @return {string}
	   */
	  ;
	
	  _proto.toISOTime = function toISOTime(_temp3) {
	    var _ref6 = _temp3 === void 0 ? {} : _temp3,
	        _ref6$suppressMillise = _ref6.suppressMilliseconds,
	        suppressMilliseconds = _ref6$suppressMillise === void 0 ? false : _ref6$suppressMillise,
	        _ref6$suppressSeconds = _ref6.suppressSeconds,
	        suppressSeconds = _ref6$suppressSeconds === void 0 ? false : _ref6$suppressSeconds,
	        _ref6$includeOffset = _ref6.includeOffset,
	        includeOffset = _ref6$includeOffset === void 0 ? true : _ref6$includeOffset;
	
	    return toTechTimeFormat(this, {
	      suppressSeconds: suppressSeconds,
	      suppressMilliseconds: suppressMilliseconds,
	      includeOffset: includeOffset
	    });
	  }
	  /**
	   * Returns an RFC 2822-compatible string representation of this DateTime, always in UTC
	   * @example DateTime.utc(2014, 7, 13).toRFC2822() //=> 'Sun, 13 Jul 2014 00:00:00 +0000'
	   * @example DateTime.local(2014, 7, 13).toRFC2822() //=> 'Sun, 13 Jul 2014 00:00:00 -0400'
	   * @return {string}
	   */
	  ;
	
	  _proto.toRFC2822 = function toRFC2822() {
	    return toTechFormat(this, "EEE, dd LLL yyyy HH:mm:ss ZZZ");
	  }
	  /**
	   * Returns a string representation of this DateTime appropriate for use in HTTP headers.
	   * Specifically, the string conforms to RFC 1123.
	   * @see https://www.w3.org/Protocols/rfc2616/rfc2616-sec3.html#sec3.3.1
	   * @example DateTime.utc(2014, 7, 13).toHTTP() //=> 'Sun, 13 Jul 2014 00:00:00 GMT'
	   * @example DateTime.utc(2014, 7, 13, 19).toHTTP() //=> 'Sun, 13 Jul 2014 19:00:00 GMT'
	   * @return {string}
	   */
	  ;
	
	  _proto.toHTTP = function toHTTP() {
	    return toTechFormat(this.toUTC(), "EEE, dd LLL yyyy HH:mm:ss 'GMT'");
	  }
	  /**
	   * Returns a string representation of this DateTime appropriate for use in SQL Date
	   * @example DateTime.utc(2014, 7, 13).toSQLDate() //=> '2014-07-13'
	   * @return {string}
	   */
	  ;
	
	  _proto.toSQLDate = function toSQLDate() {
	    return toTechFormat(this, "yyyy-MM-dd");
	  }
	  /**
	   * Returns a string representation of this DateTime appropriate for use in SQL Time
	   * @param {Object} opts - options
	   * @param {boolean} [opts.includeZone=false] - include the zone, such as 'America/New_York'. Overrides includeOffset.
	   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
	   * @example DateTime.utc().toSQL() //=> '05:15:16.345'
	   * @example DateTime.local().toSQL() //=> '05:15:16.345 -04:00'
	   * @example DateTime.local().toSQL({ includeOffset: false }) //=> '05:15:16.345'
	   * @example DateTime.local().toSQL({ includeZone: false }) //=> '05:15:16.345 America/New_York'
	   * @return {string}
	   */
	  ;
	
	  _proto.toSQLTime = function toSQLTime(_temp4) {
	    var _ref7 = _temp4 === void 0 ? {} : _temp4,
	        _ref7$includeOffset = _ref7.includeOffset,
	        includeOffset = _ref7$includeOffset === void 0 ? true : _ref7$includeOffset,
	        _ref7$includeZone = _ref7.includeZone,
	        includeZone = _ref7$includeZone === void 0 ? false : _ref7$includeZone;
	
	    return toTechTimeFormat(this, {
	      includeOffset: includeOffset,
	      includeZone: includeZone,
	      spaceZone: true
	    });
	  }
	  /**
	   * Returns a string representation of this DateTime appropriate for use in SQL DateTime
	   * @param {Object} opts - options
	   * @param {boolean} [opts.includeZone=false] - include the zone, such as 'America/New_York'. Overrides includeOffset.
	   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
	   * @example DateTime.utc(2014, 7, 13).toSQL() //=> '2014-07-13 00:00:00.000 Z'
	   * @example DateTime.local(2014, 7, 13).toSQL() //=> '2014-07-13 00:00:00.000 -04:00'
	   * @example DateTime.local(2014, 7, 13).toSQL({ includeOffset: false }) //=> '2014-07-13 00:00:00.000'
	   * @example DateTime.local(2014, 7, 13).toSQL({ includeZone: true }) //=> '2014-07-13 00:00:00.000 America/New_York'
	   * @return {string}
	   */
	  ;
	
	  _proto.toSQL = function toSQL(opts) {
	    if (opts === void 0) {
	      opts = {};
	    }
	
	    if (!this.isValid) {
	      return null;
	    }
	
	    return this.toSQLDate() + " " + this.toSQLTime(opts);
	  }
	  /**
	   * Returns a string representation of this DateTime appropriate for debugging
	   * @return {string}
	   */
	  ;
	
	  _proto.toString = function toString() {
	    return this.isValid ? this.toISO() : INVALID$2;
	  }
	  /**
	   * Returns the epoch milliseconds of this DateTime. Alias of {@link toMillis}
	   * @return {number}
	   */
	  ;
	
	  _proto.valueOf = function valueOf() {
	    return this.toMillis();
	  }
	  /**
	   * Returns the epoch milliseconds of this DateTime.
	   * @return {number}
	   */
	  ;
	
	  _proto.toMillis = function toMillis() {
	    return this.isValid ? this.ts : NaN;
	  }
	  /**
	   * Returns the epoch seconds of this DateTime.
	   * @return {number}
	   */
	  ;
	
	  _proto.toSeconds = function toSeconds() {
	    return this.isValid ? this.ts / 1000 : NaN;
	  }
	  /**
	   * Returns an ISO 8601 representation of this DateTime appropriate for use in JSON.
	   * @return {string}
	   */
	  ;
	
	  _proto.toJSON = function toJSON() {
	    return this.toISO();
	  }
	  /**
	   * Returns a BSON serializable equivalent to this DateTime.
	   * @return {Date}
	   */
	  ;
	
	  _proto.toBSON = function toBSON() {
	    return this.toJSDate();
	  }
	  /**
	   * Returns a Javascript object with this DateTime's year, month, day, and so on.
	   * @param opts - options for generating the object
	   * @param {boolean} [opts.includeConfig=false] - include configuration attributes in the output
	   * @example DateTime.local().toObject() //=> { year: 2017, month: 4, day: 22, hour: 20, minute: 49, second: 42, millisecond: 268 }
	   * @return {Object}
	   */
	  ;
	
	  _proto.toObject = function toObject(opts) {
	    if (opts === void 0) {
	      opts = {};
	    }
	
	    if (!this.isValid) return {};
	    var base = Object.assign({}, this.c);
	
	    if (opts.includeConfig) {
	      base.outputCalendar = this.outputCalendar;
	      base.numberingSystem = this.loc.numberingSystem;
	      base.locale = this.loc.locale;
	    }
	
	    return base;
	  }
	  /**
	   * Returns a Javascript Date equivalent to this DateTime.
	   * @return {Date}
	   */
	  ;
	
	  _proto.toJSDate = function toJSDate() {
	    return new Date(this.isValid ? this.ts : NaN);
	  } // COMPARE
	
	  /**
	   * Return the difference between two DateTimes as a Duration.
	   * @param {DateTime} otherDateTime - the DateTime to compare this one to
	   * @param {string|string[]} [unit=['milliseconds']] - the unit or array of units (such as 'hours' or 'days') to include in the duration.
	   * @param {Object} opts - options that affect the creation of the Duration
	   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
	   * @example
	   * var i1 = DateTime.fromISO('1982-05-25T09:45'),
	   *     i2 = DateTime.fromISO('1983-10-14T10:30');
	   * i2.diff(i1).toObject() //=> { milliseconds: 43807500000 }
	   * i2.diff(i1, 'hours').toObject() //=> { hours: 12168.75 }
	   * i2.diff(i1, ['months', 'days']).toObject() //=> { months: 16, days: 19.03125 }
	   * i2.diff(i1, ['months', 'days', 'hours']).toObject() //=> { months: 16, days: 19, hours: 0.75 }
	   * @return {Duration}
	   */
	  ;
	
	  _proto.diff = function diff(otherDateTime, unit, opts) {
	    if (unit === void 0) {
	      unit = "milliseconds";
	    }
	
	    if (opts === void 0) {
	      opts = {};
	    }
	
	    if (!this.isValid || !otherDateTime.isValid) {
	      return Duration.invalid(this.invalid || otherDateTime.invalid, "created by diffing an invalid DateTime");
	    }
	
	    var durOpts = Object.assign({
	      locale: this.locale,
	      numberingSystem: this.numberingSystem
	    }, opts);
	
	    var units = maybeArray(unit).map(Duration.normalizeUnit),
	        otherIsLater = otherDateTime.valueOf() > this.valueOf(),
	        earlier = otherIsLater ? this : otherDateTime,
	        later = otherIsLater ? otherDateTime : this,
	        diffed = _diff(earlier, later, units, durOpts);
	
	    return otherIsLater ? diffed.negate() : diffed;
	  }
	  /**
	   * Return the difference between this DateTime and right now.
	   * See {@link diff}
	   * @param {string|string[]} [unit=['milliseconds']] - the unit or units units (such as 'hours' or 'days') to include in the duration
	   * @param {Object} opts - options that affect the creation of the Duration
	   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
	   * @return {Duration}
	   */
	  ;
	
	  _proto.diffNow = function diffNow(unit, opts) {
	    if (unit === void 0) {
	      unit = "milliseconds";
	    }
	
	    if (opts === void 0) {
	      opts = {};
	    }
	
	    return this.diff(DateTime.local(), unit, opts);
	  }
	  /**
	   * Return an Interval spanning between this DateTime and another DateTime
	   * @param {DateTime} otherDateTime - the other end point of the Interval
	   * @return {Interval}
	   */
	  ;
	
	  _proto.until = function until(otherDateTime) {
	    return this.isValid ? Interval.fromDateTimes(this, otherDateTime) : this;
	  }
	  /**
	   * Return whether this DateTime is in the same unit of time as another DateTime
	   * @param {DateTime} otherDateTime - the other DateTime
	   * @param {string} unit - the unit of time to check sameness on
	   * @example DateTime.local().hasSame(otherDT, 'day'); //~> true if both the same calendar day
	   * @return {boolean}
	   */
	  ;
	
	  _proto.hasSame = function hasSame(otherDateTime, unit) {
	    if (!this.isValid) return false;
	
	    if (unit === "millisecond") {
	      return this.valueOf() === otherDateTime.valueOf();
	    } else {
	      var inputMs = otherDateTime.valueOf();
	      return this.startOf(unit) <= inputMs && inputMs <= this.endOf(unit);
	    }
	  }
	  /**
	   * Equality check
	   * Two DateTimes are equal iff they represent the same millisecond, have the same zone and location, and are both valid.
	   * To compare just the millisecond values, use `+dt1 === ~dt2`.
	   * @param {DateTime} other - the other DateTime
	   * @return {boolean}
	   */
	  ;
	
	  _proto.equals = function equals(other) {
	    return this.isValid && other.isValid && this.valueOf() === other.valueOf() && this.zone.equals(other.zone) && this.loc.equals(other.loc);
	  }
	  /**
	   * Returns a string representation of a this time relative to now, such as "in two days". Can only internationalize if your
	   * platform supports Intl.RelativeDateFormat, **which it probably doesn't yet!** (As of this writing, only Chrome supports that). Rounds down by default.
	   * @param {Object} options - options that affect the output
	   * @param {DateTime} [options.base=DateTime.local()] - the DateTime to use as the basis to which this time is compared. Defaults to now.
	   * @param {string} [options.style="long"] - the style of units, must be "long", "short", or "narrow"
	   * @param {string} options.unit - use a specific unit; if omitted, the method will pick the unit. Use one of "year", "quarter", "month", "week", "day", "hour", "minute", or "second"
	   * @param {boolean} [options.round=true] - whether to round the numbers in the output.
	   * @param {boolean} [options.padding=0] - padding in milliseconds. This allows you to round up the result if it fits inside the threshold. Don't use in combination with {round: false} because the decimal output will include the padding.
	   * @param {string} options.locale - override the locale of this DateTime
	   * @param {string} options.numberingSystem - override the numberingSystem of this DateTime. The Intl system may choose not to honor this
	   * @example DateTime.local().plus({ days: 1 }).toRelative() //=> "in 1 day"
	   * @example DateTime.local().setLocale("es").toRelative({ days: 1 }) //=> "dentro de 1 día"
	   * @example DateTime.local().plus({ days: 1 }).toRelative({ locale: "fr" }) //=> "dans 23 heures"
	   * @example DateTime.local().minus({ days: 2 }).toRelative() //=> "2 days ago"
	   * @example DateTime.local().minus({ days: 2 }).toRelative({ unit: "hours" }) //=> "48 hours ago"
	   * @example DateTime.local().minus({ hours: 36 }).toRelative({ round: false }) //=> "1.5 days ago"
	   */
	  ;
	
	  _proto.toRelative = function toRelative(options) {
	    if (options === void 0) {
	      options = {};
	    }
	
	    if (!this.isValid) return null;
	    var base = options.base || DateTime.fromObject({
	      zone: this.zone
	    }),
	        padding = options.padding ? this < base ? -options.padding : options.padding : 0;
	    return diffRelative(base, this.plus(padding), Object.assign(options, {
	      numeric: "always",
	      units: ["years", "months", "days", "hours", "minutes", "seconds"]
	    }));
	  }
	  /**
	   * Returns a string representation of this date relative to today, such as "yesterday" or "next month"
	   * platform supports Intl.RelativeDateFormat.
	   * @param {Object} options - options that affect the output
	   * @param {DateTime} [options.base=DateTime.local()] - the DateTime to use as the basis to which this time is compared. Defaults to now.
	   * @param {string} options.locale - override the locale of this DateTime
	   * @param {string} options.unit - use a specific unit; if omitted, the method will pick the unit. Use one of "year", "quarter", "month", "week", or "day"
	   * @param {string} options.numberingSystem - override the numberingSystem of this DateTime. The Intl system may choose not to honor this
	   * @example DateTime.local().plus({ days: 1 }).toRelativeCalendar() //=> "tomorrow"
	   * @example DateTime.local().setLocale("es").plus({ days: 1 }).toRelative() //=> ""mañana"
	   * @example DateTime.local().plus({ days: 1 }).toRelativeCalendar({ locale: "fr" }) //=> "demain"
	   * @example DateTime.local().minus({ days: 2 }).toRelativeCalendar() //=> "2 days ago"
	   */
	  ;
	
	  _proto.toRelativeCalendar = function toRelativeCalendar(options) {
	    if (options === void 0) {
	      options = {};
	    }
	
	    if (!this.isValid) return null;
	    return diffRelative(options.base || DateTime.fromObject({
	      zone: this.zone
	    }), this, Object.assign(options, {
	      numeric: "auto",
	      units: ["years", "months", "days"],
	      calendary: true
	    }));
	  }
	  /**
	   * Return the min of several date times
	   * @param {...DateTime} dateTimes - the DateTimes from which to choose the minimum
	   * @return {DateTime} the min DateTime, or undefined if called with no argument
	   */
	  ;
	
	  DateTime.min = function min() {
	    for (var _len = arguments.length, dateTimes = new Array(_len), _key = 0; _key < _len; _key++) {
	      dateTimes[_key] = arguments[_key];
	    }
	
	    return bestBy(dateTimes, function (i) {
	      return i.valueOf();
	    }, Math.min);
	  }
	  /**
	   * Return the max of several date times
	   * @param {...DateTime} dateTimes - the DateTimes from which to choose the maximum
	   * @return {DateTime} the max DateTime, or undefined if called with no argument
	   */
	  ;
	
	  DateTime.max = function max() {
	    for (var _len2 = arguments.length, dateTimes = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	      dateTimes[_key2] = arguments[_key2];
	    }
	
	    return bestBy(dateTimes, function (i) {
	      return i.valueOf();
	    }, Math.max);
	  } // MISC
	
	  /**
	   * Explain how a string would be parsed by fromFormat()
	   * @param {string} text - the string to parse
	   * @param {string} fmt - the format the string is expected to be in (see description)
	   * @param {Object} options - options taken by fromFormat()
	   * @return {Object}
	   */
	  ;
	
	  DateTime.fromFormatExplain = function fromFormatExplain(text, fmt, options) {
	    if (options === void 0) {
	      options = {};
	    }
	
	    var _options = options,
	        _options$locale = _options.locale,
	        locale = _options$locale === void 0 ? null : _options$locale,
	        _options$numberingSys = _options.numberingSystem,
	        numberingSystem = _options$numberingSys === void 0 ? null : _options$numberingSys,
	        localeToUse = Locale.fromOpts({
	      locale: locale,
	      numberingSystem: numberingSystem,
	      defaultToEN: true
	    });
	    return explainFromTokens(localeToUse, text, fmt);
	  }
	  /**
	   * @deprecated use fromFormatExplain instead
	   */
	  ;
	
	  DateTime.fromStringExplain = function fromStringExplain(text, fmt, options) {
	    if (options === void 0) {
	      options = {};
	    }
	
	    return DateTime.fromFormatExplain(text, fmt, options);
	  } // FORMAT PRESETS
	
	  /**
	   * {@link toLocaleString} format like 10/14/1983
	   * @type {Object}
	   */
	  ;
	
	  _createClass(DateTime, [{
	    key: "isValid",
	    get: function get() {
	      return this.invalid === null;
	    }
	    /**
	     * Returns an error code if this DateTime is invalid, or null if the DateTime is valid
	     * @type {string}
	     */
	
	  }, {
	    key: "invalidReason",
	    get: function get() {
	      return this.invalid ? this.invalid.reason : null;
	    }
	    /**
	     * Returns an explanation of why this DateTime became invalid, or null if the DateTime is valid
	     * @type {string}
	     */
	
	  }, {
	    key: "invalidExplanation",
	    get: function get() {
	      return this.invalid ? this.invalid.explanation : null;
	    }
	    /**
	     * Get the locale of a DateTime, such 'en-GB'. The locale is used when formatting the DateTime
	     *
	     * @type {string}
	     */
	
	  }, {
	    key: "locale",
	    get: function get() {
	      return this.isValid ? this.loc.locale : null;
	    }
	    /**
	     * Get the numbering system of a DateTime, such 'beng'. The numbering system is used when formatting the DateTime
	     *
	     * @type {string}
	     */
	
	  }, {
	    key: "numberingSystem",
	    get: function get() {
	      return this.isValid ? this.loc.numberingSystem : null;
	    }
	    /**
	     * Get the output calendar of a DateTime, such 'islamic'. The output calendar is used when formatting the DateTime
	     *
	     * @type {string}
	     */
	
	  }, {
	    key: "outputCalendar",
	    get: function get() {
	      return this.isValid ? this.loc.outputCalendar : null;
	    }
	    /**
	     * Get the time zone associated with this DateTime.
	     * @type {Zone}
	     */
	
	  }, {
	    key: "zone",
	    get: function get() {
	      return this._zone;
	    }
	    /**
	     * Get the name of the time zone.
	     * @type {string}
	     */
	
	  }, {
	    key: "zoneName",
	    get: function get() {
	      return this.isValid ? this.zone.name : null;
	    }
	    /**
	     * Get the year
	     * @example DateTime.local(2017, 5, 25).year //=> 2017
	     * @type {number}
	     */
	
	  }, {
	    key: "year",
	    get: function get() {
	      return this.isValid ? this.c.year : NaN;
	    }
	    /**
	     * Get the quarter
	     * @example DateTime.local(2017, 5, 25).quarter //=> 2
	     * @type {number}
	     */
	
	  }, {
	    key: "quarter",
	    get: function get() {
	      return this.isValid ? Math.ceil(this.c.month / 3) : NaN;
	    }
	    /**
	     * Get the month (1-12).
	     * @example DateTime.local(2017, 5, 25).month //=> 5
	     * @type {number}
	     */
	
	  }, {
	    key: "month",
	    get: function get() {
	      return this.isValid ? this.c.month : NaN;
	    }
	    /**
	     * Get the day of the month (1-30ish).
	     * @example DateTime.local(2017, 5, 25).day //=> 25
	     * @type {number}
	     */
	
	  }, {
	    key: "day",
	    get: function get() {
	      return this.isValid ? this.c.day : NaN;
	    }
	    /**
	     * Get the hour of the day (0-23).
	     * @example DateTime.local(2017, 5, 25, 9).hour //=> 9
	     * @type {number}
	     */
	
	  }, {
	    key: "hour",
	    get: function get() {
	      return this.isValid ? this.c.hour : NaN;
	    }
	    /**
	     * Get the minute of the hour (0-59).
	     * @example DateTime.local(2017, 5, 25, 9, 30).minute //=> 30
	     * @type {number}
	     */
	
	  }, {
	    key: "minute",
	    get: function get() {
	      return this.isValid ? this.c.minute : NaN;
	    }
	    /**
	     * Get the second of the minute (0-59).
	     * @example DateTime.local(2017, 5, 25, 9, 30, 52).second //=> 52
	     * @type {number}
	     */
	
	  }, {
	    key: "second",
	    get: function get() {
	      return this.isValid ? this.c.second : NaN;
	    }
	    /**
	     * Get the millisecond of the second (0-999).
	     * @example DateTime.local(2017, 5, 25, 9, 30, 52, 654).millisecond //=> 654
	     * @type {number}
	     */
	
	  }, {
	    key: "millisecond",
	    get: function get() {
	      return this.isValid ? this.c.millisecond : NaN;
	    }
	    /**
	     * Get the week year
	     * @see https://en.wikipedia.org/wiki/ISO_week_date
	     * @example DateTime.local(2014, 11, 31).weekYear //=> 2015
	     * @type {number}
	     */
	
	  }, {
	    key: "weekYear",
	    get: function get() {
	      return this.isValid ? possiblyCachedWeekData(this).weekYear : NaN;
	    }
	    /**
	     * Get the week number of the week year (1-52ish).
	     * @see https://en.wikipedia.org/wiki/ISO_week_date
	     * @example DateTime.local(2017, 5, 25).weekNumber //=> 21
	     * @type {number}
	     */
	
	  }, {
	    key: "weekNumber",
	    get: function get() {
	      return this.isValid ? possiblyCachedWeekData(this).weekNumber : NaN;
	    }
	    /**
	     * Get the day of the week.
	     * 1 is Monday and 7 is Sunday
	     * @see https://en.wikipedia.org/wiki/ISO_week_date
	     * @example DateTime.local(2014, 11, 31).weekday //=> 4
	     * @type {number}
	     */
	
	  }, {
	    key: "weekday",
	    get: function get() {
	      return this.isValid ? possiblyCachedWeekData(this).weekday : NaN;
	    }
	    /**
	     * Get the ordinal (i.e. the day of the year)
	     * @example DateTime.local(2017, 5, 25).ordinal //=> 145
	     * @type {number|DateTime}
	     */
	
	  }, {
	    key: "ordinal",
	    get: function get() {
	      return this.isValid ? gregorianToOrdinal(this.c).ordinal : NaN;
	    }
	    /**
	     * Get the human readable short month name, such as 'Oct'.
	     * Defaults to the system's locale if no locale has been specified
	     * @example DateTime.local(2017, 10, 30).monthShort //=> Oct
	     * @type {string}
	     */
	
	  }, {
	    key: "monthShort",
	    get: function get() {
	      return this.isValid ? Info.months("short", {
	        locale: this.locale
	      })[this.month - 1] : null;
	    }
	    /**
	     * Get the human readable long month name, such as 'October'.
	     * Defaults to the system's locale if no locale has been specified
	     * @example DateTime.local(2017, 10, 30).monthLong //=> October
	     * @type {string}
	     */
	
	  }, {
	    key: "monthLong",
	    get: function get() {
	      return this.isValid ? Info.months("long", {
	        locale: this.locale
	      })[this.month - 1] : null;
	    }
	    /**
	     * Get the human readable short weekday, such as 'Mon'.
	     * Defaults to the system's locale if no locale has been specified
	     * @example DateTime.local(2017, 10, 30).weekdayShort //=> Mon
	     * @type {string}
	     */
	
	  }, {
	    key: "weekdayShort",
	    get: function get() {
	      return this.isValid ? Info.weekdays("short", {
	        locale: this.locale
	      })[this.weekday - 1] : null;
	    }
	    /**
	     * Get the human readable long weekday, such as 'Monday'.
	     * Defaults to the system's locale if no locale has been specified
	     * @example DateTime.local(2017, 10, 30).weekdayLong //=> Monday
	     * @type {string}
	     */
	
	  }, {
	    key: "weekdayLong",
	    get: function get() {
	      return this.isValid ? Info.weekdays("long", {
	        locale: this.locale
	      })[this.weekday - 1] : null;
	    }
	    /**
	     * Get the UTC offset of this DateTime in minutes
	     * @example DateTime.local().offset //=> -240
	     * @example DateTime.utc().offset //=> 0
	     * @type {number}
	     */
	
	  }, {
	    key: "offset",
	    get: function get() {
	      return this.isValid ? this.zone.offset(this.ts) : NaN;
	    }
	    /**
	     * Get the short human name for the zone's current offset, for example "EST" or "EDT".
	     * Defaults to the system's locale if no locale has been specified
	     * @type {string}
	     */
	
	  }, {
	    key: "offsetNameShort",
	    get: function get() {
	      if (this.isValid) {
	        return this.zone.offsetName(this.ts, {
	          format: "short",
	          locale: this.locale
	        });
	      } else {
	        return null;
	      }
	    }
	    /**
	     * Get the long human name for the zone's current offset, for example "Eastern Standard Time" or "Eastern Daylight Time".
	     * Defaults to the system's locale if no locale has been specified
	     * @type {string}
	     */
	
	  }, {
	    key: "offsetNameLong",
	    get: function get() {
	      if (this.isValid) {
	        return this.zone.offsetName(this.ts, {
	          format: "long",
	          locale: this.locale
	        });
	      } else {
	        return null;
	      }
	    }
	    /**
	     * Get whether this zone's offset ever changes, as in a DST.
	     * @type {boolean}
	     */
	
	  }, {
	    key: "isOffsetFixed",
	    get: function get() {
	      return this.isValid ? this.zone.universal : null;
	    }
	    /**
	     * Get whether the DateTime is in a DST.
	     * @type {boolean}
	     */
	
	  }, {
	    key: "isInDST",
	    get: function get() {
	      if (this.isOffsetFixed) {
	        return false;
	      } else {
	        return this.offset > this.set({
	          month: 1
	        }).offset || this.offset > this.set({
	          month: 5
	        }).offset;
	      }
	    }
	    /**
	     * Returns true if this DateTime is in a leap year, false otherwise
	     * @example DateTime.local(2016).isInLeapYear //=> true
	     * @example DateTime.local(2013).isInLeapYear //=> false
	     * @type {boolean}
	     */
	
	  }, {
	    key: "isInLeapYear",
	    get: function get() {
	      return isLeapYear(this.year);
	    }
	    /**
	     * Returns the number of days in this DateTime's month
	     * @example DateTime.local(2016, 2).daysInMonth //=> 29
	     * @example DateTime.local(2016, 3).daysInMonth //=> 31
	     * @type {number}
	     */
	
	  }, {
	    key: "daysInMonth",
	    get: function get() {
	      return daysInMonth(this.year, this.month);
	    }
	    /**
	     * Returns the number of days in this DateTime's year
	     * @example DateTime.local(2016).daysInYear //=> 366
	     * @example DateTime.local(2013).daysInYear //=> 365
	     * @type {number}
	     */
	
	  }, {
	    key: "daysInYear",
	    get: function get() {
	      return this.isValid ? daysInYear(this.year) : NaN;
	    }
	    /**
	     * Returns the number of weeks in this DateTime's year
	     * @see https://en.wikipedia.org/wiki/ISO_week_date
	     * @example DateTime.local(2004).weeksInWeekYear //=> 53
	     * @example DateTime.local(2013).weeksInWeekYear //=> 52
	     * @type {number}
	     */
	
	  }, {
	    key: "weeksInWeekYear",
	    get: function get() {
	      return this.isValid ? weeksInWeekYear(this.weekYear) : NaN;
	    }
	  }], [{
	    key: "DATE_SHORT",
	    get: function get() {
	      return DATE_SHORT;
	    }
	    /**
	     * {@link toLocaleString} format like 'Oct 14, 1983'
	     * @type {Object}
	     */
	
	  }, {
	    key: "DATE_MED",
	    get: function get() {
	      return DATE_MED;
	    }
	    /**
	     * {@link toLocaleString} format like 'October 14, 1983'
	     * @type {Object}
	     */
	
	  }, {
	    key: "DATE_FULL",
	    get: function get() {
	      return DATE_FULL;
	    }
	    /**
	     * {@link toLocaleString} format like 'Tuesday, October 14, 1983'
	     * @type {Object}
	     */
	
	  }, {
	    key: "DATE_HUGE",
	    get: function get() {
	      return DATE_HUGE;
	    }
	    /**
	     * {@link toLocaleString} format like '09:30 AM'. Only 12-hour if the locale is.
	     * @type {Object}
	     */
	
	  }, {
	    key: "TIME_SIMPLE",
	    get: function get() {
	      return TIME_SIMPLE;
	    }
	    /**
	     * {@link toLocaleString} format like '09:30:23 AM'. Only 12-hour if the locale is.
	     * @type {Object}
	     */
	
	  }, {
	    key: "TIME_WITH_SECONDS",
	    get: function get() {
	      return TIME_WITH_SECONDS;
	    }
	    /**
	     * {@link toLocaleString} format like '09:30:23 AM EDT'. Only 12-hour if the locale is.
	     * @type {Object}
	     */
	
	  }, {
	    key: "TIME_WITH_SHORT_OFFSET",
	    get: function get() {
	      return TIME_WITH_SHORT_OFFSET;
	    }
	    /**
	     * {@link toLocaleString} format like '09:30:23 AM Eastern Daylight Time'. Only 12-hour if the locale is.
	     * @type {Object}
	     */
	
	  }, {
	    key: "TIME_WITH_LONG_OFFSET",
	    get: function get() {
	      return TIME_WITH_LONG_OFFSET;
	    }
	    /**
	     * {@link toLocaleString} format like '09:30', always 24-hour.
	     * @type {Object}
	     */
	
	  }, {
	    key: "TIME_24_SIMPLE",
	    get: function get() {
	      return TIME_24_SIMPLE;
	    }
	    /**
	     * {@link toLocaleString} format like '09:30:23', always 24-hour.
	     * @type {Object}
	     */
	
	  }, {
	    key: "TIME_24_WITH_SECONDS",
	    get: function get() {
	      return TIME_24_WITH_SECONDS;
	    }
	    /**
	     * {@link toLocaleString} format like '09:30:23 EDT', always 24-hour.
	     * @type {Object}
	     */
	
	  }, {
	    key: "TIME_24_WITH_SHORT_OFFSET",
	    get: function get() {
	      return TIME_24_WITH_SHORT_OFFSET;
	    }
	    /**
	     * {@link toLocaleString} format like '09:30:23 Eastern Daylight Time', always 24-hour.
	     * @type {Object}
	     */
	
	  }, {
	    key: "TIME_24_WITH_LONG_OFFSET",
	    get: function get() {
	      return TIME_24_WITH_LONG_OFFSET;
	    }
	    /**
	     * {@link toLocaleString} format like '10/14/1983, 9:30 AM'. Only 12-hour if the locale is.
	     * @type {Object}
	     */
	
	  }, {
	    key: "DATETIME_SHORT",
	    get: function get() {
	      return DATETIME_SHORT;
	    }
	    /**
	     * {@link toLocaleString} format like '10/14/1983, 9:30:33 AM'. Only 12-hour if the locale is.
	     * @type {Object}
	     */
	
	  }, {
	    key: "DATETIME_SHORT_WITH_SECONDS",
	    get: function get() {
	      return DATETIME_SHORT_WITH_SECONDS;
	    }
	    /**
	     * {@link toLocaleString} format like 'Oct 14, 1983, 9:30 AM'. Only 12-hour if the locale is.
	     * @type {Object}
	     */
	
	  }, {
	    key: "DATETIME_MED",
	    get: function get() {
	      return DATETIME_MED;
	    }
	    /**
	     * {@link toLocaleString} format like 'Oct 14, 1983, 9:30:33 AM'. Only 12-hour if the locale is.
	     * @type {Object}
	     */
	
	  }, {
	    key: "DATETIME_MED_WITH_SECONDS",
	    get: function get() {
	      return DATETIME_MED_WITH_SECONDS;
	    }
	    /**
	     * {@link toLocaleString} format like 'October 14, 1983, 9:30 AM EDT'. Only 12-hour if the locale is.
	     * @type {Object}
	     */
	
	  }, {
	    key: "DATETIME_FULL",
	    get: function get() {
	      return DATETIME_FULL;
	    }
	    /**
	     * {@link toLocaleString} format like 'October 14, 1983, 9:30:33 AM EDT'. Only 12-hour if the locale is.
	     * @type {Object}
	     */
	
	  }, {
	    key: "DATETIME_FULL_WITH_SECONDS",
	    get: function get() {
	      return DATETIME_FULL_WITH_SECONDS;
	    }
	    /**
	     * {@link toLocaleString} format like 'Friday, October 14, 1983, 9:30 AM Eastern Daylight Time'. Only 12-hour if the locale is.
	     * @type {Object}
	     */
	
	  }, {
	    key: "DATETIME_HUGE",
	    get: function get() {
	      return DATETIME_HUGE;
	    }
	    /**
	     * {@link toLocaleString} format like 'Friday, October 14, 1983, 9:30:33 AM Eastern Daylight Time'. Only 12-hour if the locale is.
	     * @type {Object}
	     */
	
	  }, {
	    key: "DATETIME_HUGE_WITH_SECONDS",
	    get: function get() {
	      return DATETIME_HUGE_WITH_SECONDS;
	    }
	  }]);
	
	  return DateTime;
	}();
	function friendlyDateTime(dateTimeish) {
	  if (DateTime.isDateTime(dateTimeish)) {
	    return dateTimeish;
	  } else if (dateTimeish && dateTimeish.valueOf && isNumber(dateTimeish.valueOf())) {
	    return DateTime.fromJSDate(dateTimeish);
	  } else if (dateTimeish && typeof dateTimeish === "object") {
	    return DateTime.fromObject(dateTimeish);
	  } else {
	    throw new InvalidArgumentError("Unknown datetime argument: " + dateTimeish + ", of type " + typeof dateTimeish);
	  }
	}
	
	exports.DateTime = DateTime;
	exports.Duration = Duration;
	exports.FixedOffsetZone = FixedOffsetZone;
	exports.IANAZone = IANAZone;
	exports.Info = Info;
	exports.Interval = Interval;
	exports.InvalidZone = InvalidZone;
	exports.LocalZone = LocalZone;
	exports.Settings = Settings;
	exports.Zone = Zone;
	//# sourceMappingURL=luxon.js.map


/***/ }),
/* 2261 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var invariant = __webpack_require__(2262);
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var splice = Array.prototype.splice;
	var toString = Object.prototype.toString;
	function type(obj) {
	    return toString.call(obj).slice(8, -1);
	}
	var assign = Object.assign || /* istanbul ignore next */ (function (target, source) {
	    getAllKeys(source).forEach(function (key) {
	        if (hasOwnProperty.call(source, key)) {
	            target[key] = source[key];
	        }
	    });
	    return target;
	});
	var getAllKeys = typeof Object.getOwnPropertySymbols === 'function'
	    ? function (obj) { return Object.keys(obj).concat(Object.getOwnPropertySymbols(obj)); }
	    /* istanbul ignore next */
	    : function (obj) { return Object.keys(obj); };
	function copy(object) {
	    return Array.isArray(object)
	        ? assign(object.constructor(object.length), object)
	        : (type(object) === 'Map')
	            ? new Map(object)
	            : (type(object) === 'Set')
	                ? new Set(object)
	                : (object && typeof object === 'object')
	                    ? assign(Object.create(Object.getPrototypeOf(object)), object)
	                    /* istanbul ignore next */
	                    : object;
	}
	var Context = /** @class */ (function () {
	    function Context() {
	        this.commands = assign({}, defaultCommands);
	        this.update = this.update.bind(this);
	        // Deprecated: update.extend, update.isEquals and update.newContext
	        this.update.extend = this.extend = this.extend.bind(this);
	        this.update.isEquals = function (x, y) { return x === y; };
	        this.update.newContext = function () { return new Context().update; };
	    }
	    Object.defineProperty(Context.prototype, "isEquals", {
	        get: function () {
	            return this.update.isEquals;
	        },
	        set: function (value) {
	            this.update.isEquals = value;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Context.prototype.extend = function (directive, fn) {
	        this.commands[directive] = fn;
	    };
	    Context.prototype.update = function (object, $spec) {
	        var _this = this;
	        var spec = (typeof $spec === 'function') ? { $apply: $spec } : $spec;
	        if (!(Array.isArray(object) && Array.isArray(spec))) {
	            invariant(!Array.isArray(spec), 'update(): You provided an invalid spec to update(). The spec may ' +
	                'not contain an array except as the value of $set, $push, $unshift, ' +
	                '$splice or any custom command allowing an array value.');
	        }
	        invariant(typeof spec === 'object' && spec !== null, 'update(): You provided an invalid spec to update(). The spec and ' +
	            'every included key path must be plain objects containing one of the ' +
	            'following commands: %s.', Object.keys(this.commands).join(', '));
	        var nextObject = object;
	        getAllKeys(spec).forEach(function (key) {
	            if (hasOwnProperty.call(_this.commands, key)) {
	                var objectWasNextObject = object === nextObject;
	                nextObject = _this.commands[key](spec[key], nextObject, spec, object);
	                if (objectWasNextObject && _this.isEquals(nextObject, object)) {
	                    nextObject = object;
	                }
	            }
	            else {
	                var nextValueForKey = type(object) === 'Map'
	                    ? _this.update(object.get(key), spec[key])
	                    : _this.update(object[key], spec[key]);
	                var nextObjectValue = type(nextObject) === 'Map'
	                    ? nextObject.get(key)
	                    : nextObject[key];
	                if (!_this.isEquals(nextValueForKey, nextObjectValue)
	                    || typeof nextValueForKey === 'undefined'
	                        && !hasOwnProperty.call(object, key)) {
	                    if (nextObject === object) {
	                        nextObject = copy(object);
	                    }
	                    if (type(nextObject) === 'Map') {
	                        nextObject.set(key, nextValueForKey);
	                    }
	                    else {
	                        nextObject[key] = nextValueForKey;
	                    }
	                }
	            }
	        });
	        return nextObject;
	    };
	    return Context;
	}());
	exports.Context = Context;
	var defaultCommands = {
	    $push: function (value, nextObject, spec) {
	        invariantPushAndUnshift(nextObject, spec, '$push');
	        return value.length ? nextObject.concat(value) : nextObject;
	    },
	    $unshift: function (value, nextObject, spec) {
	        invariantPushAndUnshift(nextObject, spec, '$unshift');
	        return value.length ? value.concat(nextObject) : nextObject;
	    },
	    $splice: function (value, nextObject, spec, originalObject) {
	        invariantSplices(nextObject, spec);
	        value.forEach(function (args) {
	            invariantSplice(args);
	            if (nextObject === originalObject && args.length) {
	                nextObject = copy(originalObject);
	            }
	            splice.apply(nextObject, args);
	        });
	        return nextObject;
	    },
	    $set: function (value, _nextObject, spec) {
	        invariantSet(spec);
	        return value;
	    },
	    $toggle: function (targets, nextObject) {
	        invariantSpecArray(targets, '$toggle');
	        var nextObjectCopy = targets.length ? copy(nextObject) : nextObject;
	        targets.forEach(function (target) {
	            nextObjectCopy[target] = !nextObject[target];
	        });
	        return nextObjectCopy;
	    },
	    $unset: function (value, nextObject, _spec, originalObject) {
	        invariantSpecArray(value, '$unset');
	        value.forEach(function (key) {
	            if (Object.hasOwnProperty.call(nextObject, key)) {
	                if (nextObject === originalObject) {
	                    nextObject = copy(originalObject);
	                }
	                delete nextObject[key];
	            }
	        });
	        return nextObject;
	    },
	    $add: function (values, nextObject, _spec, originalObject) {
	        invariantMapOrSet(nextObject, '$add');
	        invariantSpecArray(values, '$add');
	        if (type(nextObject) === 'Map') {
	            values.forEach(function (_a) {
	                var key = _a[0], value = _a[1];
	                if (nextObject === originalObject && nextObject.get(key) !== value) {
	                    nextObject = copy(originalObject);
	                }
	                nextObject.set(key, value);
	            });
	        }
	        else {
	            values.forEach(function (value) {
	                if (nextObject === originalObject && !nextObject.has(value)) {
	                    nextObject = copy(originalObject);
	                }
	                nextObject.add(value);
	            });
	        }
	        return nextObject;
	    },
	    $remove: function (value, nextObject, _spec, originalObject) {
	        invariantMapOrSet(nextObject, '$remove');
	        invariantSpecArray(value, '$remove');
	        value.forEach(function (key) {
	            if (nextObject === originalObject && nextObject.has(key)) {
	                nextObject = copy(originalObject);
	            }
	            nextObject.delete(key);
	        });
	        return nextObject;
	    },
	    $merge: function (value, nextObject, _spec, originalObject) {
	        invariantMerge(nextObject, value);
	        getAllKeys(value).forEach(function (key) {
	            if (value[key] !== nextObject[key]) {
	                if (nextObject === originalObject) {
	                    nextObject = copy(originalObject);
	                }
	                nextObject[key] = value[key];
	            }
	        });
	        return nextObject;
	    },
	    $apply: function (value, original) {
	        invariantApply(value);
	        return value(original);
	    },
	};
	var defaultContext = new Context();
	exports.isEquals = defaultContext.update.isEquals;
	exports.extend = defaultContext.extend;
	exports.default = defaultContext.update;
	// @ts-ignore
	exports.default.default = module.exports = assign(exports.default, exports);
	// invariants
	function invariantPushAndUnshift(value, spec, command) {
	    invariant(Array.isArray(value), 'update(): expected target of %s to be an array; got %s.', command, value);
	    invariantSpecArray(spec[command], command);
	}
	function invariantSpecArray(spec, command) {
	    invariant(Array.isArray(spec), 'update(): expected spec of %s to be an array; got %s. ' +
	        'Did you forget to wrap your parameter in an array?', command, spec);
	}
	function invariantSplices(value, spec) {
	    invariant(Array.isArray(value), 'Expected $splice target to be an array; got %s', value);
	    invariantSplice(spec.$splice);
	}
	function invariantSplice(value) {
	    invariant(Array.isArray(value), 'update(): expected spec of $splice to be an array of arrays; got %s. ' +
	        'Did you forget to wrap your parameters in an array?', value);
	}
	function invariantApply(fn) {
	    invariant(typeof fn === 'function', 'update(): expected spec of $apply to be a function; got %s.', fn);
	}
	function invariantSet(spec) {
	    invariant(Object.keys(spec).length === 1, 'Cannot have more than one key in an object with $set');
	}
	function invariantMerge(target, specValue) {
	    invariant(specValue && typeof specValue === 'object', 'update(): $merge expects a spec of type \'object\'; got %s', specValue);
	    invariant(target && typeof target === 'object', 'update(): $merge expects a target of type \'object\'; got %s', target);
	}
	function invariantMapOrSet(target, command) {
	    var typeOfTarget = type(target);
	    invariant(typeOfTarget === 'Map' || typeOfTarget === 'Set', 'update(): %s expects a target of type Set or Map; got %s', command, typeOfTarget);
	}


/***/ }),
/* 2262 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var invariant = function(condition, format, a, b, c, d, e, f) {
	  if (false) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  }
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error(
	        'Minified exception occurred; use the non-minified dev environment ' +
	        'for the full error message and additional helpful warnings.'
	      );
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(
	        format.replace(/%s/g, function() { return args[argIndex++]; })
	      );
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	};
	
	module.exports = invariant;


/***/ }),
/* 2263 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(608);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(615);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ContentAdd = function ContentAdd(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z' })
	  );
	};
	ContentAdd = (0, _pure2.default)(ContentAdd);
	ContentAdd.displayName = 'ContentAdd';
	ContentAdd.muiName = 'SvgIcon';
	
	exports.default = ContentAdd;

/***/ }),
/* 2264 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(608);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(615);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ContentRemove = function ContentRemove(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 13H5v-2h14v2z' })
	  );
	};
	ContentRemove = (0, _pure2.default)(ContentRemove);
	ContentRemove.displayName = 'ContentRemove';
	ContentRemove.muiName = 'SvgIcon';
	
	exports.default = ContentRemove;

/***/ }),
/* 2265 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.OPTIONS = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _materialUi = __webpack_require__(576);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var OPTIONS = exports.OPTIONS = {
	  CURRENT: "single",
	  FUTURE: "future",
	  ALL: "all"
	};
	
	var _class = function (_React$Component) {
	  _inherits(_class, _React$Component);
	
	  function _class() {
	    _classCallCheck(this, _class);
	
	    return _possibleConstructorReturn(this, Object.getPrototypeOf(_class).apply(this, arguments));
	  }
	
	  _createClass(_class, [{
	    key: "render",
	    value: function render() {
	      var _props = this.props;
	      var hideCurrent = _props.hideCurrent;
	      var value = _props.value;
	      var _onChange = _props.onChange;
	
	      return _react2.default.createElement(
	        _materialUi.RadioButtonGroup,
	        {
	          name: "option",
	          valueSelected: value,
	          onChange: function onChange(e, v) {
	            return _onChange(v);
	          }
	        },
	        _react2.default.createElement(_materialUi.RadioButton, { value: OPTIONS.ALL, label: "All events" }),
	        _react2.default.createElement(_materialUi.RadioButton, {
	          value: OPTIONS.FUTURE,
	          label: "This and all following events"
	        }),
	        _react2.default.createElement(_materialUi.RadioButton, {
	          value: OPTIONS.CURRENT,
	          label: "This event only",
	          style: { display: hideCurrent ? "none" : "block" }
	        })
	      );
	    }
	  }]);
	
	  return _class;
	}(_react2.default.Component);
	
	exports.default = _class;

/***/ }),
/* 2266 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _materialUi = __webpack_require__(576);
	
	var _reactRouter = __webpack_require__(486);
	
	var _moment = __webpack_require__(1021);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _connectToStores = __webpack_require__(1226);
	
	var _connectToStores2 = _interopRequireDefault(_connectToStores);
	
	var _EventBucketStore = __webpack_require__(1593);
	
	var _EventBucketStore2 = _interopRequireDefault(_EventBucketStore);
	
	var _EventBucketActions = __webpack_require__(1218);
	
	var _EventBucketActions2 = _interopRequireDefault(_EventBucketActions);
	
	var _PassStore = __webpack_require__(2048);
	
	var _PassStore2 = _interopRequireDefault(_PassStore);
	
	var _PassActions = __webpack_require__(2047);
	
	var _PassActions2 = _interopRequireDefault(_PassActions);
	
	var _BoxOfficeUtil = __webpack_require__(2267);
	
	var _BoxOfficeUtil2 = _interopRequireDefault(_BoxOfficeUtil);
	
	var _UserStore = __webpack_require__(974);
	
	var _UserStore2 = _interopRequireDefault(_UserStore);
	
	var _linkLike = __webpack_require__(973);
	
	var _linkLike2 = _interopRequireDefault(_linkLike);
	
	var _workingIndicator = __webpack_require__(1664);
	
	var _workingIndicator2 = _interopRequireDefault(_workingIndicator);
	
	var _injectedSelect = __webpack_require__(1874);
	
	var _injectedSelect2 = _interopRequireDefault(_injectedSelect);
	
	var _printPassesModal = __webpack_require__(2268);
	
	var _printPassesModal2 = _interopRequireDefault(_printPassesModal);
	
	var _supplementaryDataModal = __webpack_require__(2269);
	
	var _supplementaryDataModal2 = _interopRequireDefault(_supplementaryDataModal);
	
	var _inlineNoticeLabel = __webpack_require__(1222);
	
	var _inlineNoticeLabel2 = _interopRequireDefault(_inlineNoticeLabel);
	
	var _keyboardPeripheralInput = __webpack_require__(2274);
	
	var _keyboardPeripheralInput2 = _interopRequireDefault(_keyboardPeripheralInput);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CheckIn = function (_React$Component) {
	  _inherits(CheckIn, _React$Component);
	
	  function CheckIn(props) {
	    _classCallCheck(this, CheckIn);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(CheckIn).call(this, props));
	
	    _this.state = {
	      creatingOrder: null,
	      currentlyPrinting: false,
	      currentlyEditingSupplementaryData: false,
	      selectedPassId: null
	    };
	
	    _this.isNfcMode = _this.isNfcMode.bind(_this);
	    _this.onSelect = _this.onSelect.bind(_this);
	    _this.onCreate = _this.onCreate.bind(_this);
	    _this.onSubmitNewPass = _this.onSubmitNewPass.bind(_this);
	    _this.onCheckinPrintNfc = _this.onCheckinPrintNfc.bind(_this);
	    _this.onCancelCheckinPrintNfc = _this.onCancelCheckinPrintNfc.bind(_this);
	    return _this;
	  }
	
	  _createClass(CheckIn, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.componentWillReceiveProps(this.props);
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(props) {
	      var bucket = this.props.getEventBucketById(props.params.eventBucketId);
	    }
	  }, {
	    key: "getStyles",
	    value: function getStyles() {
	      return {
	        header: {
	          textAlign: "center",
	          marginBottom: "1em"
	        },
	        body: {
	          textAlign: "center"
	        },
	        intro: {
	          color: "rgb(33,33,33)",
	          textAlign: "center"
	        },
	        childen: {
	          textAlign: "left",
	          fontSize: "12pt"
	        },
	        select: {
	          maxWidth: 500,
	          margin: "0 auto"
	        },
	        passInfo: {
	          maxWidth: 500,
	          margin: "0 auto",
	          marginTop: "1em",
	          padding: "1em",
	          border: "1px solid #ccc",
	          display: "flex",
	          alignItems: "center"
	        },
	        actions: {
	          textAlign: "right"
	        },
	        stats: {
	          maxWidth: 350,
	          margin: "1em auto",
	          padding: "1em",
	          fontSize: "11pt"
	        },
	        statsHeader: {
	          fontWeight: "bold",
	          textAlign: "center",
	          marginBottom: "0.75em",
	          fontSize: "12pt"
	        }
	      };
	    }
	  }, {
	    key: "isNfcMode",
	    value: function isNfcMode() {
	      var eventBucket = this.props.getEventBucketById(this.props.params.eventBucketId);
	      return eventBucket && eventBucket.enable_nfc;
	    }
	  }, {
	    key: "onSelect",
	    value: function onSelect(selectedPassId) {
	      this.context.router.replace({
	        pathname: this.props.location.pathname,
	        state: {
	          selectedPassId: selectedPassId
	        }
	      });
	    }
	  }, {
	    key: "onCreate",
	    value: function onCreate(name) {
	      this.setState({
	        creatingOrder: {
	          name: name.value
	        }
	      });
	    }
	  }, {
	    key: "onSubmitNewPass",
	    value: function onSubmitNewPass(_ref) {
	      var _this2 = this;
	
	      var email = _ref.email;
	      var name = _ref.name;
	      var pass_bucket = _ref.pass_bucket;
	      var supplementary_data = _ref.supplementary_data;
	
	      _BoxOfficeUtil2.default.submitOrder(_UserStore2.default.getState().apiKey, {
	        type: "check_in",
	        event_bucket: this.props.params.eventBucketId,
	        email: email || "unaffiliated@eventive.org",
	        subitems: [{
	          pass_bucket: pass_bucket,
	          quantity: 1,
	          names: [name],
	          supplementary_datas: [supplementary_data]
	        }]
	      }).then(function (data) {
	        var pass = data.passes[0];
	        _PassActions2.default.fetchOne(pass.id);
	        _this2.setState({ creatingOrder: null }, function () {
	          if (_this2.isNfcMode()) {
	            _this2.onCheckinPrintNfc(pass.id);
	          } else {
	            _this2.onSelect(pass.id);
	          }
	        });
	      }).catch(function (e) {
	        window.alert("Failed to create pass: " + e.message);
	      });
	    }
	  }, {
	    key: "onCheckinPrintNfc",
	    value: function onCheckinPrintNfc(passId) {
	      _PassActions2.default.edit(passId, {
	        checked_in: true
	      });
	
	      this.context.router.replace({
	        pathname: this.props.location.pathname,
	        state: _extends({}, this.props.location.state, {
	          selectedPassId: passId,
	          currentlyCheckinPrintNfcFlow: true
	        })
	      });
	
	      this.setState({
	        currentlyPrinting: true
	      });
	    }
	  }, {
	    key: "onCancelCheckinPrintNfc",
	    value: function onCancelCheckinPrintNfc() {
	      this.context.router.replace({
	        pathname: this.props.location.pathname,
	        state: _extends({}, this.props.location.state, {
	          currentlyCheckinPrintNfcFlow: false
	        })
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this3 = this;
	
	      var eventBucketId = this.props.params.eventBucketId;
	      var _state = this.state;
	      var currentlyPrinting = _state.currentlyPrinting;
	      var currentlyEditingSupplementaryData = _state.currentlyEditingSupplementaryData;
	      var creatingOrder = _state.creatingOrder;
	
	      var eventBucket = this.props.getEventBucketById(eventBucketId);
	      var styles = this.getStyles();
	
	      var allPasses = [];
	
	      if (this.props.location.pathname.includes("pass_buckets")) {
	        allPasses = this.props.getPassesForEventBucket(eventBucketId);
	      } else if (this.props.location.pathname.includes("memberships")) {
	        allPasses = this.props.getMembershipsForEventBucket(eventBucketId);
	      } else {
	        allPasses = [].concat(_toConsumableArray(this.props.getPassesForEventBucket(eventBucketId)), _toConsumableArray(this.props.getMembershipsForEventBucket(eventBucketId)));
	      }
	
	      if (!eventBucket) {
	        return _react2.default.createElement(_workingIndicator2.default, { fullPage: true });
	      }
	
	      var stats = allPasses.reduce(function (d, p) {
	        if (!d[p.pass_bucket.id]) {
	          d[p.pass_bucket.id] = {
	            name: p.pass_bucket.name,
	            checked_in: 0,
	            total: 0
	          };
	        }
	
	        d[p.pass_bucket.id].total++;
	        if (p.checked_in_at) {
	          d[p.pass_bucket.id].checked_in++;
	        }
	
	        return d;
	      }, {});
	
	      var currentlyCheckinPrintNfcFlow = this.props.location.state && this.props.location.state.currentlyCheckinPrintNfcFlow;
	
	      var selectedPassId = this.props.location.state && this.props.location.state.selectedPassId;
	      var selectedPass = selectedPassId ? _PassStore2.default.getPassById(this.props.location.state.selectedPassId) : null;
	
	      var isMembership = this.props.location.pathname.includes("memberships");
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        creatingOrder ? _react2.default.createElement(_supplementaryDataModal2.default, {
	          isCreatingAtCheckIn: true,
	          pass: {
	            name: creatingOrder.name,
	            supplementary_data: {}
	          },
	          onSubmit: this.onSubmitNewPass,
	          requestClose: function requestClose() {
	            return _this3.setState({ creatingOrder: null });
	          },
	          eventBucketId: eventBucketId
	        }) : null,
	        currentlyPrinting ? _react2.default.createElement(_printPassesModal2.default, {
	          id: selectedPassId,
	          eventBucket: eventBucket.id,
	          requestClose: function requestClose() {
	            return setTimeout(function () {
	              _this3.setState({ currentlyPrinting: false });
	            }, 100);
	          }
	        }) : null,
	        currentlyEditingSupplementaryData ? _react2.default.createElement(_supplementaryDataModal2.default, {
	          pass: selectedPass,
	          requestClose: function requestClose() {
	            return _this3.setState({ currentlyEditingSupplementaryData: false });
	          }
	        }) : null,
	        currentlyCheckinPrintNfcFlow && !currentlyPrinting ? _react2.default.createElement(
	          _materialUi.Dialog,
	          {
	            title: "Tap NFC tag",
	            actions: [_react2.default.createElement(_materialUi.FlatButton, {
	              label: "Cancel",
	              primary: true,
	              onClick: function onClick() {
	                return _this3.onCancelCheckinPrintNfc();
	              }
	            })],
	            modal: true,
	            openImmediately: true,
	            open: true
	          },
	          "Tap the NFC tag now.",
	          _react2.default.createElement(_keyboardPeripheralInput2.default, {
	            onChange: function onChange(raw) {
	              _PassActions2.default.edit(selectedPass.id, {
	                external_barcode: raw
	              });
	              _this3.onCancelCheckinPrintNfc();
	            }
	          })
	        ) : null,
	        _react2.default.createElement(
	          "h1",
	          { style: styles.header },
	          eventBucket.name,
	          " ",
	          isMembership ? "Pick-Up" : "Check-In"
	        ),
	        _react2.default.createElement(
	          "div",
	          { style: styles.body },
	          _react2.default.createElement(
	            "div",
	            { style: styles.childen },
	            _react2.default.createElement(
	              "p",
	              { style: styles.intro },
	              isMembership ? "Confirm pick-up of memberships, print labels, & generate new memberships on the fly. " : "Check-in passholders, print labels, & generate new passes on the fly. ",
	              eventBucket.enable_nfc ? _react2.default.createElement(_inlineNoticeLabel2.default, { label: "NFC enabled" }) : null
	            ),
	            _react2.default.createElement(
	              "div",
	              null,
	              _react2.default.createElement(_injectedSelect2.default, {
	                style: styles.select,
	                placeholder: isMembership ? "Start typing member name..." : "Start typing passholder name...",
	                type: isMembership ? "membership_passes" : "passes",
	                labelFormatter: function labelFormatter(p) {
	                  return p.name + " (" + p.pass_bucket.name + ")";
	                },
	                eventBucketId: eventBucket.id,
	                focus: !currentlyCheckinPrintNfcFlow,
	                openOnClick: false,
	                openOnFocus: false,
	                onChange: this.onSelect,
	                creatable: true,
	                creatablePromptText: function creatablePromptText(n) {
	                  return "Create new free pass with name \"" + n + "\"...";
	                },
	                onCreateSelect: this.onCreate,
	                creatableShowNewOptionAtTop: false
	              })
	            ),
	            selectedPass ? _react2.default.createElement(
	              "div",
	              { style: styles.passInfo },
	              _react2.default.createElement(
	                "div",
	                { style: { flex: 1 } },
	                _react2.default.createElement(
	                  "h2",
	                  null,
	                  selectedPass.name
	                ),
	                _react2.default.createElement(
	                  "h3",
	                  null,
	                  selectedPass.pass_bucket.name
	                ),
	                _react2.default.createElement(
	                  "div",
	                  null,
	                  "Last edited ",
	                  (0, _moment2.default)(selectedPass.updated_at).format("lll")
	                ),
	                selectedPass.checked_in_at ? _react2.default.createElement(
	                  "div",
	                  null,
	                  (isMembership ? "Picked up" : "Checked in") + " " + (0, _moment2.default)(selectedPass.checked_in_at).format("lll")
	                ) : _react2.default.createElement(
	                  "div",
	                  null,
	                  _react2.default.createElement(
	                    "i",
	                    null,
	                    isMembership ? "Not yet picked up" : "Not yet checked in"
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { style: styles.actions },
	                eventBucket.enable_nfc ? _react2.default.createElement(
	                  "div",
	                  null,
	                  _react2.default.createElement(_materialUi.RaisedButton, {
	                    label: selectedPass.checked_in_at ? "Undo check-in" : "Check in, print & nfc",
	                    primary: !selectedPass.checked_in_at,
	                    onClick: function onClick() {
	                      if (selectedPass.checked_in_at) {
	                        _PassActions2.default.edit(selectedPass.id, {
	                          checked_in: false
	                        });
	                      } else {
	                        _this3.onCheckinPrintNfc(selectedPass.id);
	                      }
	                    }
	                  })
	                ) : _react2.default.createElement(
	                  "div",
	                  null,
	                  _react2.default.createElement(_materialUi.RaisedButton, {
	                    label: selectedPass.checked_in_at ? "Undo" : isMembership ? "Pick up" : "Check in",
	                    primary: !selectedPass.checked_in_at,
	                    style: { marginRight: 7 },
	                    onClick: function onClick() {
	                      return _PassActions2.default.edit(selectedPass.id, {
	                        checked_in: !selectedPass.checked_in_at
	                      });
	                    }
	                  }),
	                  _react2.default.createElement(_materialUi.RaisedButton, {
	                    label: "Print",
	                    primary: true,
	                    onClick: function onClick() {
	                      return _this3.setState({ currentlyPrinting: true });
	                    }
	                  })
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { style: { marginTop: 7 } },
	                  _react2.default.createElement(
	                    _linkLike2.default,
	                    {
	                      onTouchTap: function onTouchTap() {
	                        return _this3.context.router.push("/event_buckets/" + eventBucketId + "/passes/" + selectedPass.id);
	                      }
	                    },
	                    "View person"
	                  ),
	                  " ",
	                  "\xB7\xA0",
	                  _react2.default.createElement(
	                    _linkLike2.default,
	                    {
	                      onTouchTap: function onTouchTap() {
	                        return _this3.setState({
	                          currentlyEditingSupplementaryData: true
	                        });
	                      }
	                    },
	                    "Edit details"
	                  )
	                ),
	                selectedPass.external_barcode ? _react2.default.createElement(
	                  "div",
	                  { style: { fontSize: "0.8em" } },
	                  "NFC identifier: ",
	                  selectedPass.external_barcode
	                ) : null
	              )
	            ) : null,
	            Object.values(stats).length > 0 && _react2.default.createElement(
	              "div",
	              { style: styles.stats },
	              _react2.default.createElement(
	                "div",
	                { style: styles.statsHeader },
	                "Current ",
	                isMembership ? "pick-ups" : "check-ins",
	                ", by ",
	                isMembership ? "membership" : "pass bucket"
	              ),
	              _react2.default.createElement(
	                "table",
	                { className: "bordered striped" },
	                _react2.default.createElement(
	                  "tbody",
	                  null,
	                  Object.values(stats).sort(function (a, b) {
	                    return b.checked_in - a.checked_in || a.name.localeCompare(b.name);
	                  }).map(function (s) {
	                    return _react2.default.createElement(
	                      "tr",
	                      { key: s.name },
	                      _react2.default.createElement(
	                        "td",
	                        null,
	                        s.name
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        null,
	                        s.checked_in + " / " + s.total
	                      )
	                    );
	                  })
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }], [{
	    key: "getStores",
	    value: function getStores() {
	      return [_EventBucketStore2.default, _PassStore2.default];
	    }
	  }, {
	    key: "getPropsFromStores",
	    value: function getPropsFromStores() {
	      return {
	        getEventBucketById: _EventBucketStore2.default.getEventBucketById,
	        getPassById: _PassStore2.default.getPassById,
	        getPassesForEventBucket: _PassStore2.default.getPassesForEventBucket,
	        getMembershipsForEventBucket: _PassStore2.default.getMembershipsForEventBucket,
	        isFetching: _PassStore2.default.getState().isFetching,
	        isEditing: _PassStore2.default.getState().isEditing
	      };
	    }
	  }]);
	
	  return CheckIn;
	}(_react2.default.Component);
	
	CheckIn.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	exports.default = (0, _connectToStores2.default)(CheckIn);
	module.exports = exports["default"];

/***/ }),
/* 2267 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _merge = __webpack_require__(732);
	
	var _merge2 = _interopRequireDefault(_merge);
	
	var _api = __webpack_require__(1160);
	
	var _api2 = _interopRequireDefault(_api);
	
	var _config = __webpack_require__(1173);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _UserStore = __webpack_require__(974);
	
	var _UserStore2 = _interopRequireDefault(_UserStore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function serializeOrder(order) {
	  return {
	    type: order.type || undefined,
	    subitems: order.subitems,
	    payment_token: order.payment_token,
	    payment_intent: order.payment_intent,
	    person: order.person ? order.person.id : undefined,
	    coupon: order.coupon_id || order.coupon_code || undefined,
	    pass: order.pass ? order.pass.id : undefined,
	    event_bucket: order.event_bucket,
	    email: order.group_sale_data && order.group_sale_data.length ? undefined : order.email,
	    group_sale_data: order.group_sale_data && order.group_sale_data.length ? order.group_sale_data : undefined,
	    name: order.name,
	    mailing_address: order.mailing_address,
	    phone_number: order.phone_number,
	    additional_message: order.additional_message,
	    check_number: order.check_number,
	    payment_type: order.paymentType === "saved" ? "card" : order.paymentType,
	    mark_as_used: order.mark_as_used,
	    cart_id: order.cart_id,
	    suppress_email_confirmation: order.suppress_email_confirmation
	  };
	}
	
	exports.default = {
	  fetchStripeTerminalToken: function fetchStripeTerminalToken() {
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "POST",
	        endpoint: "_scanner/terminal_connection_token?root=true",
	        api_key: _UserStore2.default.getState().apiKey
	      }, function (err, resp) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(resp.secret);
	      });
	    });
	  },
	  prepareOrder: function prepareOrder(apiKey, orderData) {
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "POST",
	        endpoint: "orders/prepare",
	        json: Object.assign(serializeOrder(orderData), {
	          type: "box_office"
	        }),
	        api_key: _UserStore2.default.getState().apiKey
	      }, function (err, resp) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(resp);
	      });
	    });
	  },
	  submitOrder: function submitOrder(apiKey, orderData) {
	    var order = Object.assign({}, orderData);
	
	    return new Promise(function (resolve, reject) {
	      if (order.paymentType === "card") {
	        Stripe.card.createToken(order.paymentCardDetails, function (status, response) {
	          if (response.error) {
	            return reject(response.error);
	          } else {
	            delete order.paymentCardDetails;
	            order.payment_token = response.id;
	            continueSubmit();
	          }
	        });
	      } else {
	        continueSubmit();
	      }
	
	      function continueSubmit() {
	        _api2.default.request({
	          method: "POST",
	          endpoint: "box_office/new_order",
	          json: serializeOrder(order),
	          api_key: apiKey
	        }, function (err, response) {
	          if (err) {
	            return reject(err);
	          }
	          resolve(response);
	        });
	      }
	    });
	  },
	  testCoupon: function testCoupon(apiKey, order) {
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "POST",
	        endpoint: "coupons/test",
	        json: {
	          event_bucket: order.event_bucket,
	          coupon_id: order.coupon_id,
	          coupon_code: order.coupon_code,
	          person: order.person ? order.person.id : undefined,
	          order: JSON.stringify(order)
	        },
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          return resolve({
	            is_applicable: false,
	            error: err.message || err
	          });
	        }
	
	        resolve(response);
	      });
	    });
	  },
	  testPass: function testPass(apiKey, order) {
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "POST",
	        endpoint: "passes/test",
	        json: {
	          event_bucket: order.event_bucket,
	          pass: order.pass.id,
	          order: JSON.stringify(order)
	        },
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          return resolve({
	            is_applicable: false,
	            error: err.message || err
	          });
	        }
	
	        resolve(response);
	      });
	    });
	  }
	};
	module.exports = exports["default"];

/***/ }),
/* 2268 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _materialUi = __webpack_require__(576);
	
	var _quantityEditor = __webpack_require__(2191);
	
	var _quantityEditor2 = _interopRequireDefault(_quantityEditor);
	
	var _label = __webpack_require__(1682);
	
	var _label2 = _interopRequireDefault(_label);
	
	var _linkLike = __webpack_require__(973);
	
	var _linkLike2 = _interopRequireDefault(_linkLike);
	
	var _connectToStores = __webpack_require__(1226);
	
	var _connectToStores2 = _interopRequireDefault(_connectToStores);
	
	var _EventBucketStore = __webpack_require__(1593);
	
	var _EventBucketStore2 = _interopRequireDefault(_EventBucketStore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PrintPassesModal = function (_React$Component) {
	  _inherits(PrintPassesModal, _React$Component);
	
	  function PrintPassesModal(props) {
	    _classCallCheck(this, PrintPassesModal);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(PrintPassesModal).call(this, props));
	
	    _this.state = {
	      skipCount: 0,
	      labelType: "avery5360"
	    };
	
	    _this._handleRequestClose = _this._handleRequestClose.bind(_this);
	    _this._handleRequestPrint = _this._handleRequestPrint.bind(_this);
	    _this._handleEdit = _this._handleEdit.bind(_this);
	    return _this;
	  }
	
	  _createClass(PrintPassesModal, [{
	    key: "getStyles",
	    value: function getStyles() {
	      return {
	        container: {
	          margin: "15px 0"
	        },
	        inputContainer: {
	          textAlign: "left",
	          margin: "0 auto",
	          maxWidth: "90%",
	          width: 256
	        },
	        actions: {
	          marginTop: 15
	        },
	        dialogTitle: {
	          borderBottom: "none",
	          paddingBottom: 0
	        },
	        dialogBody: {
	          paddingBottom: 0
	        },
	        dialogActionsContainer: {
	          borderTop: "none"
	        }
	      };
	    }
	  }, {
	    key: "_handleRequestClose",
	    value: function _handleRequestClose() {
	      this.props.requestClose();
	    }
	  }, {
	    key: "_handleRequestPrint",
	    value: function _handleRequestPrint() {
	      var quick = arguments.length <= 0 || arguments[0] === undefined ? true : arguments[0];
	      var id = this.props.id;
	      var skipCount = this.state.skipCount;
	      var route = {
	        pathname: "/event_buckets/" + this.props.eventBucket + "/pass_label_printer",
	        query: { quick: quick ? true : undefined, pass: id, skip: skipCount }
	      };
	
	      this.context.router.push(route);
	    }
	  }, {
	    key: "_handleEdit",
	    value: function _handleEdit() {
	      this._handleRequestPrint( /* quick */false);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var styles = this.getStyles(),
	          bucket = _EventBucketStore2.default.getEventBucketById(this.props.eventBucket),
	          quantity = Array.isArray(this.props.id) ? this.props.id.length : 1;
	
	      var _props$isMembership = this.props.isMembership;
	      var isMembership = _props$isMembership === undefined ? false : _props$isMembership;
	
	
	      return _react2.default.createElement(
	        _materialUi.Dialog,
	        {
	          title: "Quick print",
	          titleStyle: styles.dialogTitle,
	          actionsContainerStyle: styles.dialogActionsContainer,
	          bodyStyle: styles.dialogBody,
	          openImmediately: true,
	          actions: [_react2.default.createElement(_materialUi.FlatButton, { label: "Cancel", onTouchTap: this._handleRequestClose }), _react2.default.createElement(_materialUi.FlatButton, {
	            label: "Print",
	            onTouchTap: this._handleRequestPrint,
	            primary: true
	          })],
	          autoScrollBodyContent: true,
	          open: true,
	          onRequestClose: this._handleRequestClose
	        },
	        _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement(
	            "p",
	            null,
	            "Ready to print ",
	            quantity,
	            " ",
	            isMembership ? "membership" + (quantity !== 1 ? "s" : "") : "pass" + (quantity !== 1 ? "es" : ""),
	            " using your saved printing configuration",
	            " ",
	            _react2.default.createElement(
	              _linkLike2.default,
	              { onTouchTap: this._handleEdit },
	              "(edit)"
	            ),
	            "."
	          ),
	          bucket && bucket.label_printer_config.label_type === "sheet" ? _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(
	              _label2.default,
	              { style: { marginBottom: -10, marginTop: 20 } },
	              "Number of labels to skip (to use a partially used sheet)"
	            ),
	            _react2.default.createElement(_quantityEditor2.default, {
	              style: { marginLeft: -15 },
	              min: 0,
	              quantity: this.state.skipCount,
	              updateQuantity: function updateQuantity(q) {
	                return _this2.setState({ skipCount: q });
	              }
	            })
	          ) : null
	        )
	      );
	    }
	  }], [{
	    key: "getStores",
	    value: function getStores() {
	      return [_EventBucketStore2.default];
	    }
	  }, {
	    key: "getPropsFromStores",
	    value: function getPropsFromStores() {
	      var state = _EventBucketStore2.default.getState();
	      return state;
	    }
	  }, {
	    key: "contextTypes",
	    get: function get() {
	      return {
	        router: _react2.default.PropTypes.object
	      };
	    }
	  }]);
	
	  return PrintPassesModal;
	}(_react2.default.Component);
	
	exports.default = (0, _connectToStores2.default)(PrintPassesModal);
	module.exports = exports["default"];

/***/ }),
/* 2269 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _materialUi = __webpack_require__(576);
	
	var _PassActions = __webpack_require__(2047);
	
	var _PassActions2 = _interopRequireDefault(_PassActions);
	
	var _PassBucketStore = __webpack_require__(1867);
	
	var _PassBucketStore2 = _interopRequireDefault(_PassBucketStore);
	
	var _base = __webpack_require__(1755);
	
	var _base2 = _interopRequireDefault(_base);
	
	var _supplementaryDataContentEditor = __webpack_require__(2270);
	
	var _supplementaryDataContentEditor2 = _interopRequireDefault(_supplementaryDataContentEditor);
	
	var _injectedSelect = __webpack_require__(1874);
	
	var _injectedSelect2 = _interopRequireDefault(_injectedSelect);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var EMAIL_KEY = "$$$email$$$$";
	
	var SupplementaryDataModal = function (_React$Component) {
	  _inherits(SupplementaryDataModal, _React$Component);
	
	  function SupplementaryDataModal(props) {
	    _classCallCheck(this, SupplementaryDataModal);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(SupplementaryDataModal).call(this, props));
	
	    _this.state = {
	      dirty: false,
	      createData: {
	        pass_bucket: null
	      },
	      updatedData: {}
	    };
	
	    _this.cancel = _this.cancel.bind(_this);
	    _this.submit = _this.submit.bind(_this);
	    _this._updateDataValue = _this._updateDataValue.bind(_this);
	    return _this;
	  }
	
	  _createClass(SupplementaryDataModal, [{
	    key: "getStyles",
	    value: function getStyles() {
	      return {
	        actions: {
	          marginTop: 15
	        },
	        dialogTitle: {
	          borderBottom: "none"
	        },
	        dialogActionsContainer: {
	          borderTop: "none"
	        },
	        create: {
	          margin: "0px auto 1.5em",
	          maxWidth: "90%",
	          width: 320
	        }
	      };
	    }
	  }, {
	    key: "cancel",
	    value: function cancel() {
	      this.props.requestClose();
	    }
	  }, {
	    key: "submit",
	    value: function submit() {
	      var name = this.state.updatedData.name;
	      delete this.state.updatedData.name;
	      var result = {
	        name: name,
	        supplementary_data: this.state.updatedData
	      };
	
	      if (this.props.isCreatingAtCheckIn) {
	        var email = this.state.updatedData[EMAIL_KEY];
	        delete this.state.updatedData[EMAIL_KEY];
	        result.email = email;
	        Object.assign(result, this.state.createData);
	      }
	
	      if (this.props.onSubmit) {
	        this.props.onSubmit(result);
	        return;
	      }
	
	      _PassActions2.default.edit(this.props.pass.id, result);
	      this.props.requestClose();
	    }
	  }, {
	    key: "_updateDataValue",
	    value: function _updateDataValue(key, value) {
	      var data = Object.assign({}, this.state.updatedData);
	      data[key] = value;
	      this.setState({ dirty: true, updatedData: data });
	    }
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.componentWillReceiveProps(this.props);
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(newProps) {
	      // if state is dirty, don't overwrite user edits with the interval update
	      if (!this.state.dirty) {
	        var data = newProps.pass.supplementary_data;
	        data.name = newProps.pass.name;
	
	        this.setState({
	          updatedData: data
	        });
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var styles = this.getStyles();
	      var _props = this.props;
	      var pass = _props.pass;
	      var isCreatingAtCheckIn = _props.isCreatingAtCheckIn;
	      var eventBucketId = _props.eventBucketId;
	
	
	      var passBucket = pass.pass_bucket || _PassBucketStore2.default.getPassBucketById(this.state.createData.pass_bucket);
	
	      var fields = ((passBucket || {}).supplementary_data || []).slice();
	      fields.splice(0, 0, {
	        key: "name",
	        required: true,
	        label: "Full name to display on " + (passBucket && passBucket.is_membership ? "membership" : "pass")
	      });
	
	      if (isCreatingAtCheckIn) {
	        fields.splice(1, 0, {
	          key: EMAIL_KEY,
	          required: false,
	          label: "Email address"
	        });
	      }
	
	      return _react2.default.createElement(
	        _base2.default,
	        {
	          title: this.state.updatedData.name || pass.name || "Unnamed Pass",
	          titleStyle: styles.dialogTitle,
	          actionsContainerStyle: styles.dialogActionsContainer,
	          useMuiDefaultStyle: true,
	          openImmediately: true,
	          actions: [_react2.default.createElement(_materialUi.FlatButton, { label: "Cancel", onTouchTap: this.cancel }), _react2.default.createElement(_materialUi.FlatButton, {
	            disabled: !this.state.dirty,
	            primary: true,
	            label: isCreatingAtCheckIn ? "Create pass" : "Submit changes",
	            onTouchTap: this.submit
	          })],
	          modal: true,
	          open: true,
	          onRequestClose: this.cancel
	        },
	        _react2.default.createElement(
	          "div",
	          null,
	          isCreatingAtCheckIn ? _react2.default.createElement(
	            "div",
	            { style: styles.create },
	            _react2.default.createElement(_injectedSelect2.default, {
	              type: "pass_buckets",
	              value: this.state.createData.pass_bucket,
	              eventBucketId: eventBucketId,
	              labelFormatter: function labelFormatter(p) {
	                return "" + p.name;
	              },
	              placeholder: "Select pass bucket",
	              focus: !this.state.dirty,
	              onChange: function onChange(v) {
	                return _this2.setState({
	                  dirty: true,
	                  createData: Object.assign(_this2.state.createData, {
	                    pass_bucket: v
	                  })
	                });
	              }
	            })
	          ) : null,
	          _react2.default.createElement(_supplementaryDataContentEditor2.default, {
	            fields: fields,
	            data: this.state.updatedData,
	            existingImages: this.props.person && this.props.person.supplementary_data_images,
	            updateDataValue: this._updateDataValue
	          })
	        )
	      );
	    }
	  }]);
	
	  return SupplementaryDataModal;
	}(_react2.default.Component);
	
	exports.default = SupplementaryDataModal;
	module.exports = exports["default"];

/***/ }),
/* 2270 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _materialUi = __webpack_require__(576);
	
	var _reactSelect = __webpack_require__(953);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	var _momentTimezone = __webpack_require__(1185);
	
	var _momentTimezone2 = _interopRequireDefault(_momentTimezone);
	
	var _reactWebcam = __webpack_require__(2271);
	
	var _reactWebcam2 = _interopRequireDefault(_reactWebcam);
	
	var _linkLike = __webpack_require__(973);
	
	var _linkLike2 = _interopRequireDefault(_linkLike);
	
	var _datepicker = __webpack_require__(2272);
	
	var _datepicker2 = _interopRequireDefault(_datepicker);
	
	var _imageDropzone = __webpack_require__(2058);
	
	var _imageDropzone2 = _interopRequireDefault(_imageDropzone);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // =====================================================
	// SYNC WITH FRONTEND/PARTIALS/SUPPLEMENTARY-DATA-EDITOR
	// =====================================================
	
	// https://github.com/grammakov/USA-cities-and-states
	var STATES = "Alabama|Alaska|Arizona|Arkansas|California|Colorado|Connecticut|Delaware|Florida|Georgia|Hawaii|Idaho|Illinois|Indiana|Iowa|Kansas|Kentucky|Louisiana|Maine|Maryland|Massachusetts|Michigan|Minnesota|Mississippi|Missouri|Montana|Nebraska|Nevada|New Hampshire|New Jersey|New Mexico|New York|North Carolina|North Dakota|Ohio|Oklahoma|Oregon|Pennsylvania|Rhode Island|South Carolina|South Dakota|Tennessee|Texas|Utah|Vermont|Virginia|Washington|West Virginia|Wisconsin|Wyoming|Puerto Rico|Virgin Islands|Washington, D.C.|US Armed Forces Pacific|American Samoa|Guam|Palau|Federated States of Micronesia|Northern Mariana Islands|Marshall Islands|US Armed Forces Europe".split("|");
	
	var SupplementaryDataEditor = function (_React$Component) {
	  _inherits(SupplementaryDataEditor, _React$Component);
	
	  function SupplementaryDataEditor(props) {
	    _classCallCheck(this, SupplementaryDataEditor);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(SupplementaryDataEditor).call(this, props));
	
	    _this.state = {
	      shownWebcamField: null,
	      webcamCapture: null,
	      webcamDevices: [],
	      selectedWebcamDevice: null
	    };
	
	    _this.dropzones = {};
	
	    _this.onChange = _this.onChange.bind(_this);
	    _this.onWebcam = _this.onWebcam.bind(_this);
	    _this.onWebcamCapture = _this.onWebcamCapture.bind(_this);
	    _this.onWebcamClose = _this.onWebcamClose.bind(_this);
	    _this.onWebcamSubmit = _this.onWebcamSubmit.bind(_this);
	    return _this;
	  }
	
	  _createClass(SupplementaryDataEditor, [{
	    key: "getStyles",
	    value: function getStyles() {
	      return {
	        container: {
	          margin: "15px 0"
	        },
	        requiredNote: {
	          position: "absolute",
	          bottom: 16 + 74,
	          fontSize: "0.8em"
	        },
	        label: {
	          marginTop: "1em",
	          fontWeight: "bold"
	        },
	        description: {
	          fontSize: "0.8em",
	          marginBottom: -10
	        },
	        inputContainer: {
	          textAlign: "left",
	          margin: "0 auto",
	          maxWidth: "90%",
	          width: 300
	        },
	        actions: {
	          marginTop: 15
	        },
	        dropzone: {
	          height: "auto",
	          fontSize: "0.75em",
	          lineHeight: "1.25",
	          padding: 10,
	          border: "1px dashed #ccc",
	          cursor: "pointer"
	        },
	        existingImage: {
	          cursor: "pointer",
	          height: 75
	        },
	        existingImageInstruction: {
	          fontSize: "0.75em",
	          marginTop: 5,
	          marginBottom: 5
	        }
	      };
	    }
	  }, {
	    key: "onChange",
	    value: function onChange(id, e, value) {
	      this.props.updateDataValue(id, typeof value !== "undefined" ? value : e.target.value);
	    }
	  }, {
	    key: "onWebcam",
	    value: function onWebcam(f) {
	      var _this2 = this;
	
	      window.navigator.mediaDevices.getUserMedia({ video: true }).then(function () {
	        return window.navigator.mediaDevices.enumerateDevices().then(function (devices) {
	          devices = devices.filter(function (d) {
	            return d.kind === "videoinput";
	          });
	
	          var savedDevice = void 0;
	          try {
	            savedDevice = "eventive-savedVideoDevice" in window.localStorage && JSON.parse(window.localStorage["eventive-savedVideoDevice"]);
	            if (savedDevice) {
	              savedDevice = savedDevice.deviceId;
	            }
	          } catch (e) {}
	
	          if ((!savedDevice || !devices.find(function (d) {
	            return d.deviceId === savedDevice;
	          })) && devices.length) {
	            savedDevice = devices[0].deviceId;
	            try {
	              window.localStorage["eventive-savedVideoDevice"] = JSON.stringify({ deviceId: savedDevice });
	            } catch (e) {}
	          }
	
	          _this2.setState({
	            webcamDevices: devices,
	            selectedWebcam: savedDevice,
	            shownWebcamField: f
	          });
	        });
	      }).catch(function (e) {
	        console.log("[SupplementaryDataContentEditor] Failed to initialize webcam, error:");
	        console.error(e);
	        try {
	          // In case there was a cache related error, just clear it all for next time
	          delete window.localStorage["eventive-savedVideoDevice"];
	        } catch (e) {}
	      });
	    }
	  }, {
	    key: "onWebcamCapture",
	    value: function onWebcamCapture() {
	      this.setState({ webcamCapture: this.webcam.getScreenshot() });
	    }
	  }, {
	    key: "onWebcamClose",
	    value: function onWebcamClose() {
	      this.setState({
	        shownWebcamField: null,
	        webcamCapture: null
	      });
	    }
	  }, {
	    key: "onWebcamSubmit",
	    value: function onWebcamSubmit() {
	      this.dropzones[this.state.shownWebcamField.key].showCropperForImage(this.state.webcamCapture);
	      this.setState({
	        shownWebcamField: null,
	        webcamCapture: null
	      });
	    }
	  }, {
	    key: "onWebcamChange",
	    value: function onWebcamChange(deviceId) {
	      var _this3 = this;
	
	      try {
	        window.localStorage["eventive-savedVideoDevice"] = JSON.stringify({
	          deviceId: deviceId
	        });
	      } catch (e) {}
	
	      var _tempWebcamField = this.state.shownWebcamField;
	      this.setState({ shownWebcamField: null }, function () {
	        _this3.setState({
	          shownWebcamField: _tempWebcamField,
	          selectedWebcam: deviceId
	        });
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this4 = this;
	
	      var styles = this.getStyles();
	
	      var requiredNoticeStyle = this.props.requiredNoticeStyle;
	
	
	      var inputs = this.props.fields.map(function (f, i) {
	        var inner = void 0,
	            value = _this4.props.data[f.key];
	
	        if (f.type === "state") {
	          f.type = "select";
	          f.options = STATES;
	          if (f.show_none_option) {
	            f.options = [f.none_option_text || "I don't live in the United States"].concat(f.options);
	          }
	        }
	
	        if (f.type === "select") {
	          inner = _react2.default.createElement(_reactSelect2.default, {
	            name: f.key,
	            style: { marginTop: 20 },
	            value: value,
	            options: f.options.map(function (o) {
	              return { value: o, label: o };
	            }),
	            multi: f.multiple,
	            onChange: function onChange(v) {
	              return _this4.onChange(f.key, null, f.multiple ? v.map(function (i) {
	                return i.value;
	              }) : v && v.value);
	            }
	          });
	        } else if (f.type === "checkbox") {
	          inner = _react2.default.createElement(_materialUi.Checkbox, {
	            name: f.key,
	            style: { marginTop: 14 },
	            checked: value,
	            onCheck: function onCheck(e) {
	              return _this4.onChange(f.key, null, !value);
	            },
	            label: f.checkbox_label
	          });
	        } else if (f.type === "date") {
	          inner = _react2.default.createElement(_datepicker2.default, {
	            name: f.key,
	            returnFormat: "YYYY-MM-DD",
	            displayFormat: "MM/DD/YYYY",
	            fullWidth: true,
	            value: value,
	            onChange: function onChange(v) {
	              return _this4.onChange(f.key, null, v);
	            }
	          });
	        } else if (f.type === "image") {
	          inner = _react2.default.createElement(
	            "div",
	            { style: { marginTop: 20 } },
	            value ? _react2.default.createElement("img", {
	              src: value.pending_upload ? value.data : typeof value === "string" && value.indexOf("data:image") === 0 ? value : value + "?h=300",
	              style: {
	                maxHeight: 150,
	                maxWidth: "100%",
	                backgroundColor: "hsla(31,15%,50%,.1)"
	              }
	            }) : null,
	            _react2.default.createElement(
	              _imageDropzone2.default,
	              {
	                crop: f.square ? { width: 1, height: 1 } : true,
	                hideCropTip: true,
	                dataUrl: true,
	                style: styles.dropzone,
	                ref: function ref(r) {
	                  _this4.dropzones[f.key] = r;
	                },
	                onDrop: function onDrop(files) {
	                  _this4.onChange(f.key, null, {
	                    data: files[0],
	                    pending_upload: true
	                  });
	                }
	              },
	              _react2.default.createElement(
	                "div",
	                null,
	                value ? _react2.default.createElement(
	                  "div",
	                  null,
	                  _react2.default.createElement(
	                    "div",
	                    null,
	                    "Image chosen. Delete to reselect."
	                  ),
	                  _react2.default.createElement(
	                    _linkLike2.default,
	                    {
	                      style: { display: "block" },
	                      onTouchTap: function onTouchTap(e) {
	                        _this4.onChange(f.key, null, null);
	                      }
	                    },
	                    "[Delete current image]"
	                  )
	                ) : _react2.default.createElement(
	                  "div",
	                  null,
	                  "Drag & drop an image here, click to select, or\xA0",
	                  _react2.default.createElement(
	                    _linkLike2.default,
	                    { onTouchTap: function onTouchTap() {
	                        return _this4.onWebcam(f);
	                      } },
	                    "capture\xA0using\xA0webcam"
	                  )
	                )
	              )
	            ),
	            !value && _this4.props.existingImages && _this4.props.existingImages.length ? _react2.default.createElement(
	              "div",
	              null,
	              _react2.default.createElement(
	                "div",
	                { style: styles.existingImageInstruction },
	                "or select one of your previously uploaded images:"
	              ),
	              _react2.default.createElement(
	                "div",
	                null,
	                _this4.props.existingImages.reverse().map(function (src) {
	                  return _react2.default.createElement("img", {
	                    src: src,
	                    style: styles.existingImage,
	                    onTouchTap: function onTouchTap(e) {
	                      _this4.dropzones[f.key].showCropperForImage(src);
	                    }
	                  });
	                })
	              )
	            ) : null
	          );
	        } else {
	          inner = _react2.default.createElement(_materialUi.TextField, {
	            name: f.key,
	            value: value,
	            fullWidth: true,
	            multiLine: f.multiline || f.type === "address",
	            onChange: _this4.onChange.bind(null, f.key)
	          });
	        }
	
	        return _react2.default.createElement(
	          "div",
	          { key: f.key, style: styles.inputContainer },
	          _react2.default.createElement(
	            "label",
	            { htmlFor: f.key },
	            _react2.default.createElement(
	              "div",
	              { style: styles.label },
	              f.label,
	              f.required && _react2.default.createElement(
	                "span",
	                { style: { color: "rgb(229, 57, 53)" } },
	                "*"
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { style: styles.description },
	              f.description
	            )
	          ),
	          inner
	        );
	      });
	
	      return _react2.default.createElement(
	        "div",
	        { style: styles.container },
	        this.state.shownWebcamField ? _react2.default.createElement(
	          _materialUi.Dialog,
	          {
	            open: true,
	            bodyStyle: { textAlign: "center", overflowY: "visible" }
	          },
	          this.state.webcamCapture ? _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement("img", { src: this.state.webcamCapture, style: { height: 350 } }),
	            _react2.default.createElement(
	              "div",
	              { style: { marginTop: 10 } },
	              _react2.default.createElement(_materialUi.RaisedButton, {
	                onClick: function onClick() {
	                  return _this4.setState({ webcamCapture: null });
	                },
	                label: "Retake"
	              }),
	              _react2.default.createElement(_materialUi.RaisedButton, {
	                primary: true,
	                style: { marginLeft: 7 },
	                onClick: this.onWebcamSubmit,
	                label: "Crop & submit..."
	              })
	            )
	          ) : _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(_reactWebcam2.default, {
	              audio: false,
	              height: 350,
	              ref: function ref(r) {
	                _this4.webcam = r;
	              },
	              screenshotFormat: "image/jpeg",
	              videoSource: this.state.selectedWebcam,
	              audioSource: true,
	              style: { transform: "scaleX(-1)" }
	            }),
	            _react2.default.createElement(
	              "div",
	              { style: { marginTop: 10 } },
	              _react2.default.createElement(_materialUi.RaisedButton, { onClick: this.onWebcamClose, label: "Cancel" }),
	              _react2.default.createElement(
	                "div",
	                {
	                  style: {
	                    display: "inline-block",
	                    width: 175,
	                    marginLeft: 7,
	                    verticalAlign: "top"
	                  }
	                },
	                _react2.default.createElement(_reactSelect2.default, {
	                  clearable: false,
	                  value: this.state.selectedWebcam,
	                  options: this.state.webcamDevices.map(function (d) {
	                    return {
	                      label: d.label || d.deviceId,
	                      value: d.deviceId
	                    };
	                  }),
	                  onChange: function onChange(e) {
	                    return _this4.onWebcamChange(e.value);
	                  },
	                  autosize: false
	                })
	              ),
	              _react2.default.createElement(_materialUi.RaisedButton, {
	                onClick: this.onWebcamCapture,
	                style: { marginLeft: 7 },
	                primary: true,
	                label: "Capture photo"
	              })
	            )
	          )
	        ) : null,
	        inputs,
	        _react2.default.createElement(
	          "div",
	          {
	            style: Object.assign({}, styles.requiredNote, requiredNoticeStyle)
	          },
	          "Required fields are marked with a",
	          " ",
	          _react2.default.createElement(
	            "span",
	            { style: { color: "rgb(229, 57, 53)" } },
	            "*"
	          ),
	          "."
	        )
	      );
	    }
	  }]);
	
	  return SupplementaryDataEditor;
	}(_react2.default.Component);
	
	exports.default = SupplementaryDataEditor;
	module.exports = exports["default"];

/***/ }),
/* 2271 */
/***/ (function(module, exports, __webpack_require__) {

	(function webpackUniversalModuleDefinition(root, factory) {
		if(true)
			module.exports = factory(__webpack_require__(956), __webpack_require__(300));
		else if(typeof define === 'function' && define.amd)
			define(["prop-types", "react"], factory);
		else if(typeof exports === 'object')
			exports["Webcam"] = factory(require("prop-types"), require("react"));
		else
			root["Webcam"] = factory(root["PropTypes"], root["React"]);
	})(this, function(__WEBPACK_EXTERNAL_MODULE_0__, __WEBPACK_EXTERNAL_MODULE_1__) {
	return /******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	/******/
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	/******/
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId]) {
	/******/ 			return installedModules[moduleId].exports;
	/******/ 		}
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			i: moduleId,
	/******/ 			l: false,
	/******/ 			exports: {}
	/******/ 		};
	/******/
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	/******/
	/******/ 		// Flag the module as loaded
	/******/ 		module.l = true;
	/******/
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	/******/
	/******/
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	/******/
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	/******/
	/******/ 	// identity function for calling harmony imports with the correct context
	/******/ 	__webpack_require__.i = function(value) { return value; };
	/******/
	/******/ 	// define getter function for harmony exports
	/******/ 	__webpack_require__.d = function(exports, name, getter) {
	/******/ 		if(!__webpack_require__.o(exports, name)) {
	/******/ 			Object.defineProperty(exports, name, {
	/******/ 				configurable: false,
	/******/ 				enumerable: true,
	/******/ 				get: getter
	/******/ 			});
	/******/ 		}
	/******/ 	};
	/******/
	/******/ 	// getDefaultExport function for compatibility with non-harmony modules
	/******/ 	__webpack_require__.n = function(module) {
	/******/ 		var getter = module && module.__esModule ?
	/******/ 			function getDefault() { return module['default']; } :
	/******/ 			function getModuleExports() { return module; };
	/******/ 		__webpack_require__.d(getter, 'a', getter);
	/******/ 		return getter;
	/******/ 	};
	/******/
	/******/ 	// Object.prototype.hasOwnProperty.call
	/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
	/******/
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	/******/
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(__webpack_require__.s = 2);
	/******/ })
	/************************************************************************/
	/******/ ([
	/* 0 */
	/***/ (function(module, exports) {
	
	module.exports = __WEBPACK_EXTERNAL_MODULE_0__;
	
	/***/ }),
	/* 1 */
	/***/ (function(module, exports) {
	
	module.exports = __WEBPACK_EXTERNAL_MODULE_1__;
	
	/***/ }),
	/* 2 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(0);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function hasGetUserMedia() {
	  return !!(navigator.mediaDevices.getUserMedia || navigator.webkitGetUserMedia || navigator.mozGetUserMedia || navigator.msGetUserMedia);
	}
	
	var Webcam = function (_Component) {
	  _inherits(Webcam, _Component);
	
	  function Webcam() {
	    _classCallCheck(this, Webcam);
	
	    var _this = _possibleConstructorReturn(this, (Webcam.__proto__ || Object.getPrototypeOf(Webcam)).call(this));
	
	    _this.state = {
	      hasUserMedia: false
	    };
	    return _this;
	  }
	
	  _createClass(Webcam, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (!hasGetUserMedia()) return;
	
	      Webcam.mountedInstances.push(this);
	
	      if (!this.state.hasUserMedia && !Webcam.userMediaRequested) {
	        this.requestUserMedia();
	      }
	    }
	  }, {
	    key: 'componentWillUpdate',
	    value: function componentWillUpdate(nextProps) {
	      if (nextProps.videoSource !== this.props.videoSource || nextProps.audioSource !== this.props.audioSource) {
	        this.requestUserMedia();
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      var index = Webcam.mountedInstances.indexOf(this);
	      Webcam.mountedInstances.splice(index, 1);
	
	      if (Webcam.mountedInstances.length === 0 && this.state.hasUserMedia) {
	        if (this.stream.stop) {
	          this.stream.stop();
	        } else {
	          if (this.stream.getVideoTracks) {
	            this.stream.getVideoTracks().map(function (track) {
	              return track.stop();
	            });
	          }
	          if (this.stream.getAudioTracks) {
	            this.stream.getAudioTracks().map(function (track) {
	              return track.stop();
	            });
	          }
	        }
	        Webcam.userMediaRequested = false;
	        window.URL.revokeObjectURL(this.state.src);
	      }
	    }
	  }, {
	    key: 'getScreenshot',
	    value: function getScreenshot() {
	      if (!this.state.hasUserMedia) return null;
	
	      var canvas = this.getCanvas();
	      return canvas && canvas.toDataURL(this.props.screenshotFormat);
	    }
	  }, {
	    key: 'getCanvas',
	    value: function getCanvas() {
	      if (!this.state.hasUserMedia || !this.video.videoHeight) return null;
	
	      if (!this.ctx) {
	        var _canvas = document.createElement('canvas');
	        var aspectRatio = this.video.videoWidth / this.video.videoHeight;
	
	        _canvas.width = this.video.clientWidth;
	        _canvas.height = this.video.clientWidth / aspectRatio;
	
	        this.canvas = _canvas;
	        this.ctx = _canvas.getContext('2d');
	      }
	
	      var ctx = this.ctx,
	          canvas = this.canvas;
	
	      ctx.drawImage(this.video, 0, 0, canvas.width, canvas.height);
	
	      return canvas;
	    }
	  }, {
	    key: 'requestUserMedia',
	    value: function requestUserMedia() {
	      var _this2 = this;
	
	      navigator.getUserMedia = navigator.mediaDevices.getUserMedia || navigator.webkitGetUserMedia || navigator.mozGetUserMedia || navigator.msGetUserMedia;
	
	      var sourceSelected = function sourceSelected(audioSource, videoSource) {
	        var constraints = {
	          video: {
	            optional: [{ sourceId: videoSource }]
	          }
	        };
	
	        if (_this2.props.audio) {
	          constraints.audio = {
	            optional: [{ sourceId: audioSource }]
	          };
	        }
	
	        navigator.mediaDevices.getUserMedia(constraints).then(function (stream) {
	          Webcam.mountedInstances.forEach(function (instance) {
	            return instance.handleUserMedia(null, stream);
	          });
	        }).catch(function (e) {
	          Webcam.mountedInstances.forEach(function (instance) {
	            return instance.handleUserMedia(e);
	          });
	        });
	      };
	
	      if (this.props.audioSource && this.props.videoSource) {
	        sourceSelected(this.props.audioSource, this.props.videoSource);
	      } else if ('mediaDevices' in navigator) {
	        navigator.mediaDevices.enumerateDevices().then(function (devices) {
	          var audioSource = null;
	          var videoSource = null;
	
	          devices.forEach(function (device) {
	            if (device.kind === 'audioinput') {
	              audioSource = device.id;
	            } else if (device.kind === 'videoinput') {
	              videoSource = device.id;
	            }
	          });
	
	          if (_this2.props.audioSource) {
	            audioSource = _this2.props.audioSource;
	          }
	          if (_this2.props.videoSource) {
	            videoSource = _this2.props.videoSource;
	          }
	
	          sourceSelected(audioSource, videoSource);
	        }).catch(function (error) {
	          console.log(error.name + ': ' + error.message); // eslint-disable-line no-console
	        });
	      } else {
	        MediaStreamTrack.getSources(function (sources) {
	          var audioSource = null;
	          var videoSource = null;
	
	          sources.forEach(function (source) {
	            if (source.kind === 'audio') {
	              audioSource = source.id;
	            } else if (source.kind === 'video') {
	              videoSource = source.id;
	            }
	          });
	
	          if (_this2.props.audioSource) {
	            audioSource = _this2.props.audioSource;
	          }
	          if (_this2.props.videoSource) {
	            videoSource = _this2.props.videoSource;
	          }
	
	          sourceSelected(audioSource, videoSource);
	        });
	      }
	
	      Webcam.userMediaRequested = true;
	    }
	  }, {
	    key: 'handleUserMedia',
	    value: function handleUserMedia(error, stream) {
	      if (error) {
	        this.setState({
	          hasUserMedia: false
	        });
	        this.props.onUserMediaError(error);
	
	        return;
	      }
	      try {
	        var src = window.URL.createObjectURL(stream);
	
	        this.stream = stream;
	        this.setState({
	          hasUserMedia: true,
	          src: src
	        });
	      } catch (err) {
	        this.stream = stream;
	        this.video.srcObject = stream;
	        this.setState({
	          hasUserMedia: true
	        });
	      }
	
	      this.props.onUserMedia();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      return _react2.default.createElement('video', {
	        autoPlay: true,
	        width: this.props.width,
	        height: this.props.height,
	        src: this.state.src,
	        muted: this.props.audio,
	        className: this.props.className,
	        playsInline: true,
	        style: this.props.style,
	        ref: function ref(_ref) {
	          _this3.video = _ref;
	        }
	      });
	    }
	  }]);
	
	  return Webcam;
	}(_react.Component);
	
	Webcam.defaultProps = {
	  audio: true,
	  className: '',
	  height: 480,
	  onUserMedia: function onUserMedia() {},
	  onUserMediaError: function onUserMediaError() {},
	  screenshotFormat: 'image/webp',
	  width: 640
	};
	Webcam.propTypes = {
	  audio: _propTypes2.default.bool,
	  onUserMedia: _propTypes2.default.func,
	  onUserMediaError: _propTypes2.default.func,
	  height: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  width: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  screenshotFormat: _propTypes2.default.oneOf(['image/webp', 'image/png', 'image/jpeg']),
	  style: _propTypes2.default.object,
	  className: _propTypes2.default.string,
	  audioSource: _propTypes2.default.string,
	  videoSource: _propTypes2.default.string
	};
	Webcam.mountedInstances = [];
	Webcam.userMediaRequested = false;
	exports.default = Webcam;
	module.exports = exports['default'];
	
	/***/ })
	/******/ ]);
	});

/***/ }),
/* 2272 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _moment = __webpack_require__(1021);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _materialUi = __webpack_require__(576);
	
	var _event = __webpack_require__(2273);
	
	var _event2 = _interopRequireDefault(_event);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // ======================================
	// SYNC WITH FRONTEND/PARTIALS/DATEPICKER
	// ======================================
	
	var CONTAINER_STYLE = {
	  position: "relative"
	};
	
	var CONTAINER_FULL_WIDTH_STYLE = {
	  width: "100%"
	};
	
	var ICON_BUTTON_STYLE = {
	  display: "inline-block",
	  position: "absolute",
	  right: -12,
	  top: 0
	};
	
	var ICON_BUTTON_WITH_LABEL_STYLE = {
	  top: null,
	  bottom: 0
	};
	
	var ICON_BUTTON_WITH_LABEL_ERROR_STYLE = {
	  top: 24,
	  bottom: null
	};
	
	var DATE_PICKER_STLYE = {
	  display: "none"
	};
	
	var DatePicker = function (_React$Component) {
	  _inherits(DatePicker, _React$Component);
	
	  function DatePicker(props) {
	    _classCallCheck(this, DatePicker);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(DatePicker).call(this, props));
	
	    _this.state = {
	      textFieldValue: "",
	      value: null,
	      datePickerOpen: false
	    };
	
	    _this._parseTextDate = _this._parseTextDate.bind(_this);
	    _this._dateToText = _this._dateToText.bind(_this);
	    _this.onChange = _this.onChange.bind(_this);
	    _this.onTextFieldBlur = _this.onTextFieldBlur.bind(_this);
	    _this.onTextFieldChange = _this.onTextFieldChange.bind(_this);
	    return _this;
	  }
	
	  _createClass(DatePicker, [{
	    key: "_parseTextDate",
	    value: function _parseTextDate(text, format) {
	      if (!text) {
	        return null;
	      }
	
	      var m = (0, _moment2.default)(text, format);
	      return m.isValid() ? m : null;
	    }
	  }, {
	    key: "_dateToText",
	    value: function _dateToText(date) {
	      if (!date) {
	        return "";
	      }
	      return (0, _moment2.default)(date).format(this.props.displayFormat);
	    }
	  }, {
	    key: "onChange",
	    value: function onChange(date) {
	      var returnFormat = this.props.returnFormat;
	      var value = (0, _moment2.default)(date);
	
	      if (!date) {
	        this.props.onChange(returnFormat ? "" : null);
	      } else {
	        this.props.onChange(returnFormat ? value.format(returnFormat) : value);
	      }
	    }
	  }, {
	    key: "onTextFieldBlur",
	    value: function onTextFieldBlur(e) {
	      this.onChange(this._parseTextDate(e.target.value, this.props.displayFormat));
	    }
	  }, {
	    key: "onTextFieldChange",
	    value: function onTextFieldChange(e) {
	      this.setState({ textFieldValue: e.target.value });
	    }
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.componentWillReceiveProps(this.props);
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(props) {
	      var value = props.value;
	      var returnFormat = props.returnFormat;
	      var dateValue = typeof value === "string" ? this._parseTextDate(value, returnFormat) : value;
	
	      this.setState({
	        textFieldValue: this._dateToText(dateValue),
	        value: dateValue
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props;
	      var name = _props.name;
	      var style = _props.style;
	      var label = _props.label;
	      var fullWidth = _props.fullWidth;
	      var errorText = _props.errorText;
	      var minDate = _props.minDate;
	      var _state = this.state;
	      var value = _state.value;
	      var textFieldValue = _state.textFieldValue;
	      var datePickerOpen = _state.datePickerOpen;
	
	
	      return _react2.default.createElement(
	        "div",
	        {
	          style: Object.assign({}, CONTAINER_STYLE, fullWidth && CONTAINER_FULL_WIDTH_STYLE, style)
	        },
	        _react2.default.createElement(_materialUi.TextField, {
	          name: name,
	          fullWidth: true,
	          value: textFieldValue,
	          onChange: this.onTextFieldChange,
	          onBlur: this.onTextFieldBlur,
	          floatingLabelText: label,
	          floatingLabelFixed: true,
	          errorText: errorText
	        }),
	        _react2.default.createElement(
	          _materialUi.IconButton,
	          {
	            style: Object.assign({}, ICON_BUTTON_STYLE, label && ICON_BUTTON_WITH_LABEL_STYLE, label && errorText && ICON_BUTTON_WITH_LABEL_ERROR_STYLE),
	            tooltip: "Show calendar",
	            onTouchTap: function onTouchTap() {
	              _this2.picker.openDialog();
	            }
	          },
	          _react2.default.createElement(_event2.default, null)
	        ),
	        _react2.default.createElement(_materialUi.DatePicker, {
	          ref: function ref(r) {
	            _this2.picker = r;
	          },
	          name: name + "_datepicker",
	          style: DATE_PICKER_STLYE,
	          value: value && new Date(value.year(), value.month(), value.date()),
	          onChange: function onChange(e, date) {
	            _this2.onChange(date);
	          },
	          autoOk: true,
	          minDate: minDate
	        })
	      );
	    }
	  }]);
	
	  return DatePicker;
	}(_react2.default.Component);
	
	DatePicker.defaultProps = {
	  displayFormat: "MM/DD/YYYY",
	  returnFormat: "YYYY-MM-DD"
	};
	exports.default = DatePicker;
	module.exports = exports["default"];

/***/ }),
/* 2273 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(608);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(615);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionEvent = function ActionEvent(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M17 12h-5v5h5v-5zM16 1v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2h-1V1h-2zm3 18H5V8h14v11z' })
	  );
	};
	ActionEvent = (0, _pure2.default)(ActionEvent);
	ActionEvent.displayName = 'ActionEvent';
	ActionEvent.muiName = 'SvgIcon';
	
	exports.default = ActionEvent;

/***/ }),
/* 2274 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var KeyboardPeripheralInput = function (_React$Component) {
	  _inherits(KeyboardPeripheralInput, _React$Component);
	
	  function KeyboardPeripheralInput(props) {
	    _classCallCheck(this, KeyboardPeripheralInput);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(KeyboardPeripheralInput).call(this, props));
	
	    _this.state = {
	      raw: ""
	    };
	
	    _this.onChange = _this.onChange.bind(_this);
	    _this.onBlur = _this.onBlur.bind(_this);
	    _this.onKeyDown = _this.onKeyDown.bind(_this);
	    return _this;
	  }
	
	  _createClass(KeyboardPeripheralInput, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      this.interval = setInterval(function () {
	        return _this2.peripheralInput.focus();
	      }, 100);
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      clearInterval(this.interval);
	    }
	  }, {
	    key: "onChange",
	    value: function onChange(e) {
	      this.setState({ raw: e.target.value });
	    }
	  }, {
	    key: "onBlur",
	    value: function onBlur() {
	      var _this3 = this;
	
	      setTimeout(function () {
	        _this3.input && _this3.input.focus();
	      }, 10);
	    }
	  }, {
	    key: "onKeyDown",
	    value: function onKeyDown(e) {
	      if (e.keyCode === 13 && this.state.raw) {
	        this.props.onChange(this.state.raw.trim());
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this4 = this;
	
	      return _react2.default.createElement(
	        "div",
	        {
	          style: {
	            width: 0,
	            overflow: "hidden"
	          }
	        },
	        _react2.default.createElement("input", {
	          id: "CreditCardEntry--input",
	          ref: function ref(_ref) {
	            return _this4.peripheralInput = _ref;
	          },
	          type: "text",
	          onChange: this.onChange,
	          onBlur: this.onBlur,
	          onKeyDown: this.onKeyDown,
	          value: this.state.raw
	        })
	      );
	    }
	  }]);
	
	  return KeyboardPeripheralInput;
	}(_react2.default.Component);
	
	exports.default = KeyboardPeripheralInput;
	module.exports = exports["default"];

/***/ }),
/* 2275 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _materialUi = __webpack_require__(576);
	
	var _reactRouter = __webpack_require__(486);
	
	var _connectToStores = __webpack_require__(1226);
	
	var _connectToStores2 = _interopRequireDefault(_connectToStores);
	
	var _EventBucketStore = __webpack_require__(1593);
	
	var _EventBucketStore2 = _interopRequireDefault(_EventBucketStore);
	
	var _EventBucketActions = __webpack_require__(1218);
	
	var _EventBucketActions2 = _interopRequireDefault(_EventBucketActions);
	
	var _BallotStore = __webpack_require__(2276);
	
	var _BallotStore2 = _interopRequireDefault(_BallotStore);
	
	var _BallotActions = __webpack_require__(2278);
	
	var _BallotActions2 = _interopRequireDefault(_BallotActions);
	
	var _UserStore = __webpack_require__(974);
	
	var _UserStore2 = _interopRequireDefault(_UserStore);
	
	var _linkLike = __webpack_require__(973);
	
	var _linkLike2 = _interopRequireDefault(_linkLike);
	
	var _workingIndicator = __webpack_require__(1664);
	
	var _workingIndicator2 = _interopRequireDefault(_workingIndicator);
	
	var _selectWells = __webpack_require__(1676);
	
	var _selectWells2 = _interopRequireDefault(_selectWells);
	
	var _ballot = __webpack_require__(2279);
	
	var _ballot2 = _interopRequireDefault(_ballot);
	
	var _print = __webpack_require__(2280);
	
	var _print2 = _interopRequireDefault(_print);
	
	var _touchApp = __webpack_require__(2281);
	
	var _touchApp2 = _interopRequireDefault(_touchApp);
	
	var _howToVote = __webpack_require__(2282);
	
	var _howToVote2 = _interopRequireDefault(_howToVote);
	
	var _whereToVote = __webpack_require__(2283);
	
	var _whereToVote2 = _interopRequireDefault(_whereToVote);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Balloting = function (_React$Component) {
	  _inherits(Balloting, _React$Component);
	
	  function Balloting(props) {
	    _classCallCheck(this, Balloting);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(Balloting).call(this, props));
	
	    _this.state = {
	      hasInjectedSettings: false,
	      settings: {}
	    };
	
	    _this.updateSetting = _this.updateSetting.bind(_this);
	    return _this;
	  }
	
	  _createClass(Balloting, [{
	    key: "updateSetting",
	    value: function updateSetting(key, value) {
	      var settings = Object.assign({}, this.state.settings);
	      settings[key] = value;
	
	      if (key === "online_ballot_custom_introduction_tags") {
	        settings.online_ballot_custom_introduction_by_tagging_modal_headers = settings.online_ballot_custom_introduction_by_tagging_modal_headers || {};
	
	        var _iteratorNormalCompletion = true;
	        var _didIteratorError = false;
	        var _iteratorError = undefined;
	
	        try {
	          for (var _iterator = value[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	            var k = _step.value;
	
	            settings.online_ballot_custom_introduction_by_tagging_modal_headers[k] = typeof settings.online_ballot_custom_introduction_by_tagging_modal_headers[k] === "undefined" ? "" : settings.online_ballot_custom_introduction_by_tagging_modal_headers[k];
	          }
	        } catch (err) {
	          _didIteratorError = true;
	          _iteratorError = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion && _iterator.return) {
	              _iterator.return();
	            }
	          } finally {
	            if (_didIteratorError) {
	              throw _iteratorError;
	            }
	          }
	        }
	      }
	
	      this.setState({ settings: settings });
	
	      // Persist
	      _EventBucketActions2.default.edit(this.props.params.eventBucketId, {
	        balloting_config: settings
	      });
	    }
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.componentWillReceiveProps(this.props);
	      _BallotActions2.default.fetchStats.defer(this.props.params.eventBucketId);
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(props) {
	      var bucket = this.props.getEventBucketById(props.params.eventBucketId),
	          canInject = bucket && bucket.balloting_config;
	
	      if (canInject && !this.state.hasInjectedSettings) {
	        this.setState({
	          hasInjectedSettings: true,
	          settings: bucket.balloting_config
	        });
	      }
	    }
	  }, {
	    key: "getStyles",
	    value: function getStyles() {
	      return {
	        header: {
	          textAlign: "center",
	          marginBottom: "1em"
	        },
	        body: {
	          textAlign: "center"
	        },
	        intro: {
	          color: "rgb(33,33,33)",
	          textAlign: "center"
	        },
	        childen: {
	          textAlign: "left",
	          fontSize: "12pt"
	        }
	      };
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var eventBucketId = this.props.params.eventBucketId;
	      var eventBucket = this.props.getEventBucketById(eventBucketId);
	      var ballotStats = this.props.getStatsForEventBucket(eventBucketId);
	      var ballotTabulations = this.props.getTabulationsForEventBucket(eventBucketId);
	      var styles = this.getStyles();
	
	      if (!eventBucket || !this.state.hasInjectedSettings) {
	        return _react2.default.createElement(_workingIndicator2.default, { fullPage: true });
	      }
	
	      var showWells = true;
	      if (_UserStore2.default.hasPermission("app_balloting") && !_UserStore2.default.hasPermission("print_balloting")) {
	        showWells = false;
	      }
	
	      var ballotingWells = [].concat(_UserStore2.default.hasPermission("manage_balloting") || _UserStore2.default.hasPermission("setup_balloting") ? [{
	        value: "setup",
	        icon: _ballot2.default,
	        label: "Set up ballots"
	      }] : []).concat(_UserStore2.default.hasPermission("manage_balloting") || _UserStore2.default.hasPermission("app_balloting") ? [{
	        value: "app",
	        icon: _touchApp2.default,
	        label: "Mobile ballots"
	      }] : []).concat(_UserStore2.default.hasPermission("manage_balloting") || _UserStore2.default.hasPermission("print_balloting") ? [{
	        value: "print",
	        icon: _print2.default,
	        label: "Print ballots"
	      }] : []).concat(_UserStore2.default.hasPermission("manage_balloting") || _UserStore2.default.hasPermission("record_balloting") ? [{
	        value: "record",
	        icon: _howToVote2.default,
	        label: "Record votes"
	      }] : []).concat(_UserStore2.default.hasPermission("manage_balloting") || _UserStore2.default.hasPermission("tabulate_balloting") ? [{
	        value: "tabulate",
	        icon: _whereToVote2.default,
	        label: "Tabulate results"
	      }] : []);
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          "h1",
	          { style: styles.header },
	          eventBucket.name,
	          " Balloting"
	        ),
	        _react2.default.createElement(
	          "div",
	          { style: styles.body },
	          showWells ? _react2.default.createElement(_selectWells2.default, {
	            style: { margin: "1em -0.5em", fontSize: "0.8vw" },
	            options: ballotingWells,
	            onChange: function onChange(v) {
	              return _this2.context.router.push("/event_buckets/" + eventBucket.id + "/balloting/" + v);
	            },
	            value: this.props.location.pathname.split("/").pop()
	          }) : null,
	          _react2.default.createElement(
	            "div",
	            { style: styles.childen },
	            this.props.children ? _react2.default.cloneElement(this.props.children, {
	              eventBucket: eventBucket,
	              settings: this.state.settings,
	              updateSetting: this.updateSetting,
	              ballotStats: ballotStats,
	              ballotTabulations: ballotTabulations,
	              getVotesForEvent: this.props.getVotesForEvent,
	              isWorking: this.props.isWorking
	            }) : _react2.default.createElement(
	              "p",
	              { style: styles.intro },
	              "Use Eventive Balloting to automatically generate and tabulate ballots for your events. Begin by selecting an option above."
	            )
	          )
	        )
	      );
	    }
	  }], [{
	    key: "getStores",
	    value: function getStores() {
	      return [_EventBucketStore2.default, _BallotStore2.default, _UserStore2.default];
	    }
	  }, {
	    key: "getPropsFromStores",
	    value: function getPropsFromStores() {
	      return {
	        getEventBucketById: _EventBucketStore2.default.getEventBucketById,
	        getStatsForEventBucket: _BallotStore2.default.getStatsForEventBucket,
	        getVotesForEvent: _BallotStore2.default.getVotesForEvent,
	        getTabulationsForEventBucket: _BallotStore2.default.getTabulationsForEventBucket,
	        isWorking: _BallotStore2.default.getState().isWorking
	      };
	    }
	  }]);
	
	  return Balloting;
	}(_react2.default.Component);
	
	Balloting.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	exports.default = (0, _connectToStores2.default)(Balloting);
	module.exports = exports["default"];

/***/ }),
/* 2276 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _alt = __webpack_require__(975);
	
	var _alt2 = _interopRequireDefault(_alt);
	
	var _keyBy = __webpack_require__(990);
	
	var _keyBy2 = _interopRequireDefault(_keyBy);
	
	var _moment = __webpack_require__(1021);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _BallotUtil = __webpack_require__(2277);
	
	var _BallotUtil2 = _interopRequireDefault(_BallotUtil);
	
	var _BallotActions = __webpack_require__(2278);
	
	var _BallotActions2 = _interopRequireDefault(_BallotActions);
	
	var _UserStore = __webpack_require__(974);
	
	var _UserStore2 = _interopRequireDefault(_UserStore);
	
	var _config = __webpack_require__(1173);
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var BallotStore = function () {
	  function BallotStore() {
	    _classCallCheck(this, BallotStore);
	
	    this.bindActions(_BallotActions2.default);
	
	    this.state = {
	      stats: {},
	      votes: {},
	      tabulations: {}
	    };
	
	    this.exportPublicMethods({
	      getStatsForEventBucket: this.getStatsForEventBucket.bind(this),
	      getVotesForEvent: this.getVotesForEvent.bind(this),
	      getTabulationsForEventBucket: this.getTabulationsForEventBucket.bind(this)
	    });
	  }
	
	  _createClass(BallotStore, [{
	    key: "getStatsForEventBucket",
	    value: function getStatsForEventBucket(b) {
	      return this.state.stats[b];
	    }
	  }, {
	    key: "getVotesForEvent",
	    value: function getVotesForEvent(e) {
	      return this.state.votes[e];
	    }
	  }, {
	    key: "getTabulationsForEventBucket",
	    value: function getTabulationsForEventBucket(b) {
	      return this.state.tabulations[b] || [];
	    }
	  }, {
	    key: "onFetchStats",
	    value: function onFetchStats(eventBucketId) {
	      var _this = this;
	
	      this.setState({ isWorking: true });
	
	      _BallotUtil2.default.fetchStats(_UserStore2.default.getState().apiKey, eventBucketId).then(function (data) {
	        var stats = Object.assign({}, _this.state.stats);
	        stats[eventBucketId] = data;
	        _this.setState({ stats: stats });
	      }).catch(function (e) {
	        return window.alert("Error fetching ballot stats: " + e.message);
	      }).finally(function () {
	        _this.setState({ isWorking: false });
	      });
	    }
	  }, {
	    key: "onFetchVotes",
	    value: function onFetchVotes(eventId) {
	      var _this2 = this;
	
	      this.setState({ isWorking: true });
	
	      _BallotUtil2.default.fetchVotes(_UserStore2.default.getState().apiKey, eventId).then(function (data) {
	        var votes = Object.assign({}, _this2.state.votes);
	        votes[eventId] = data;
	        _this2.setState({ votes: votes });
	      }).catch(function (e) {
	        return window.alert("Error fetching ballot votes: " + e.message);
	      }).finally(function () {
	        _this2.setState({ isWorking: false });
	      });
	    }
	  }, {
	    key: "onFetchTabulations",
	    value: function onFetchTabulations(eventBucketId) {
	      var _this3 = this;
	
	      this.setState({ isWorking: true });
	
	      _BallotUtil2.default.fetchTabulations(_UserStore2.default.getState().apiKey, eventBucketId).then(function (data) {
	        var tabulations = Object.assign({}, _this3.state.tabulations);
	        tabulations[eventBucketId] = data.tabulations;
	        _this3.setState({ tabulations: tabulations });
	      }).catch(function (e) {
	        return window.alert("Error fetching ballot tabulations: " + e.message);
	      }).finally(function () {
	        _this3.setState({ isWorking: false });
	      });
	    }
	  }, {
	    key: "onTabulate",
	    value: function onTabulate(eventBucketId) {
	      var _this4 = this;
	
	      this.setState({ isWorking: true });
	
	      _BallotUtil2.default.tabulate(_UserStore2.default.getState().apiKey, eventBucketId).then(function (data) {
	        var tabulations = _this4.state.tabulations;
	
	        if (!tabulations[eventBucketId]) {
	          tabulations[eventBucketId] = [];
	        }
	        tabulations[eventBucketId].push(data);
	        _this4.setState({ tabulations: tabulations });
	      }).catch(function (e) {
	        return window.alert("Error running tabulation: " + e.message);
	      }).finally(function () {
	        _this4.setState({ isWorking: false });
	      });
	    }
	  }]);
	
	  return BallotStore;
	}();
	
	exports.default = _alt2.default.createStore(BallotStore, "BallotStore");
	module.exports = exports["default"];

/***/ }),
/* 2277 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _api = __webpack_require__(1160);
	
	var _api2 = _interopRequireDefault(_api);
	
	var _config = __webpack_require__(1173);
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  fetchStats: function fetchStats(apiKey, eventBucketId) {
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "GET",
	        endpoint: "ballots/stats",
	        qs: { event_bucket: eventBucketId },
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response);
	      });
	    });
	  },
	  fetchVotes: function fetchVotes(apiKey, eventId) {
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "GET",
	        endpoint: "ballots/votes",
	        qs: { event: eventId },
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response);
	      });
	    });
	  },
	  fetchTabulations: function fetchTabulations(apiKey, eventBucketId) {
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "GET",
	        endpoint: "ballots/tabulations",
	        qs: { event_bucket: eventBucketId },
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response);
	      });
	    });
	  },
	  tabulate: function tabulate(apiKey, eventBucketId) {
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "POST",
	        endpoint: "ballots/tabulate",
	        qs: { event_bucket: eventBucketId },
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response);
	      });
	    });
	  },
	  fetchConsolidatedAudit: function fetchConsolidatedAudit(apiKey, eventBucketId) {
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "POST",
	        endpoint: "ballots/generate_consolidated_audit",
	        qs: { event_bucket: eventBucketId },
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response);
	      });
	    });
	  }
	};
	module.exports = exports["default"];

/***/ }),
/* 2278 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _alt = __webpack_require__(975);
	
	var _alt2 = _interopRequireDefault(_alt);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var BallotActions = function BallotActions() {
	  _classCallCheck(this, BallotActions);
	
	  this.generateActions("fetchStats", "fetchVotes", "fetchTabulations", "tabulate");
	};
	
	exports.default = _alt2.default.createActions(BallotActions);
	module.exports = exports["default"];

/***/ }),
/* 2279 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _materialUi = __webpack_require__(576);
	
	exports.default = function (props) {
	  return React.createElement(
	    _materialUi.SvgIcon,
	    props,
	    React.createElement(
	      "defs",
	      null,
	      React.createElement("path", { id: "a", d: "M0 0h24v24H0z" })
	    ),
	    React.createElement(
	      "clipPath",
	      null,
	      React.createElement("use", { xlinkHref: "#a", overflow: "visible" })
	    ),
	    React.createElement("path", {
	      "fill-rule": "evenodd",
	      "clip-rule": "evenodd",
	      d: "M13 9.5h5v-2h-5v2zm0 7h5v-2h-5v2zm6 4.5H5c-1.1 0-2-.9-2-2V5c0-1.1.9-2 2-2h14c1.1 0 2 .9 2 2v14c0 1.1-.9 2-2 2zM6 11h5V6H6v5zm1-4h3v3H7V7zM6 18h5v-5H6v5zm1-4h3v3H7v-3z"
	    })
	  );
	};
	
	module.exports = exports["default"];

/***/ }),
/* 2280 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(608);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(615);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionPrint = function ActionPrint(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 8H5c-1.66 0-3 1.34-3 3v6h4v4h12v-4h4v-6c0-1.66-1.34-3-3-3zm-3 11H8v-5h8v5zm3-7c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm-1-9H6v4h12V3z' })
	  );
	};
	ActionPrint = (0, _pure2.default)(ActionPrint);
	ActionPrint.displayName = 'ActionPrint';
	ActionPrint.muiName = 'SvgIcon';
	
	exports.default = ActionPrint;

/***/ }),
/* 2281 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(608);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(615);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionTouchApp = function ActionTouchApp(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M9 11.24V7.5C9 6.12 10.12 5 11.5 5S14 6.12 14 7.5v3.74c1.21-.81 2-2.18 2-3.74C16 5.01 13.99 3 11.5 3S7 5.01 7 7.5c0 1.56.79 2.93 2 3.74zm9.84 4.63l-4.54-2.26c-.17-.07-.35-.11-.54-.11H13v-6c0-.83-.67-1.5-1.5-1.5S10 6.67 10 7.5v10.74l-3.43-.72c-.08-.01-.15-.03-.24-.03-.31 0-.59.13-.79.33l-.79.8 4.94 4.94c.27.27.65.44 1.06.44h6.79c.75 0 1.33-.55 1.44-1.28l.75-5.27c.01-.07.02-.14.02-.2 0-.62-.38-1.16-.91-1.38z' })
	  );
	};
	ActionTouchApp = (0, _pure2.default)(ActionTouchApp);
	ActionTouchApp.displayName = 'ActionTouchApp';
	ActionTouchApp.muiName = 'SvgIcon';
	
	exports.default = ActionTouchApp;

/***/ }),
/* 2282 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _materialUi = __webpack_require__(576);
	
	exports.default = function (props) {
	  return React.createElement(
	    _materialUi.SvgIcon,
	    props,
	    React.createElement("path", { d: "M18 13h-.68l-2 2h1.91L19 17H5l1.78-2h2.05l-2-2H6l-3 3v4c0 1.1.89 2 1.99 2H19c1.1 0 2-.89 2-2v-4l-3-3zm-1-5.05l-4.95 4.95-3.54-3.54 4.95-4.95L17 7.95zm-4.24-5.66L6.39 8.66c-.39.39-.39 1.02 0 1.41l4.95 4.95c.39.39 1.02.39 1.41 0l6.36-6.36c.39-.39.39-1.02 0-1.41L14.16 2.3c-.38-.4-1.01-.4-1.4-.01z" })
	  );
	};
	
	module.exports = exports["default"];

/***/ }),
/* 2283 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _materialUi = __webpack_require__(576);
	
	exports.default = function (props) {
	  return React.createElement(
	    _materialUi.SvgIcon,
	    props,
	    React.createElement("path", { d: "M12 2c3.86 0 7 3.14 7 7 0 5.25-7 13-7 13S5 14.25 5 9c0-3.86 3.14-7 7-7zm-1.53 12L17 7.41 15.6 6l-5.13 5.18L8.4 9.09 7 10.5l3.47 3.5z" })
	  );
	};
	
	module.exports = exports["default"];

/***/ }),
/* 2284 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _materialUi = __webpack_require__(576);
	
	var _reactRouter = __webpack_require__(486);
	
	var _debounce = __webpack_require__(642);
	
	var _debounce2 = _interopRequireDefault(_debounce);
	
	var _connectToStores = __webpack_require__(1226);
	
	var _connectToStores2 = _interopRequireDefault(_connectToStores);
	
	var _UserStore = __webpack_require__(974);
	
	var _UserStore2 = _interopRequireDefault(_UserStore);
	
	var _TagStore = __webpack_require__(2039);
	
	var _TagStore2 = _interopRequireDefault(_TagStore);
	
	var _TagActions = __webpack_require__(2038);
	
	var _TagActions2 = _interopRequireDefault(_TagActions);
	
	var _configuratorItem = __webpack_require__(2107);
	
	var _configuratorItem2 = _interopRequireDefault(_configuratorItem);
	
	var _selectField = __webpack_require__(1683);
	
	var _selectField2 = _interopRequireDefault(_selectField);
	
	var _label = __webpack_require__(1682);
	
	var _label2 = _interopRequireDefault(_label);
	
	var _infoNotice = __webpack_require__(1599);
	
	var _infoNotice2 = _interopRequireDefault(_infoNotice);
	
	var _quillEditor = __webpack_require__(2169);
	
	var _quillEditor2 = _interopRequireDefault(_quillEditor);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BallotingSetup = function (_React$Component) {
	  _inherits(BallotingSetup, _React$Component);
	
	  function BallotingSetup(props) {
	    _classCallCheck(this, BallotingSetup);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(BallotingSetup).call(this, props));
	
	    _this.state = {
	      showFavorite: false
	    };
	    _this.updateSettingDebounced = (0, _debounce2.default)(_this.updateSettingDebounced.bind(_this), 500);
	    return _this;
	  }
	
	  _createClass(BallotingSetup, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      _TagActions2.default.fetchAllForBucket.defer(this.props.eventBucket.id);
	    }
	  }, {
	    key: "updateSettingDebounced",
	    value: function updateSettingDebounced(k, v) {
	      this.props.updateSetting(k, v);
	    }
	  }, {
	    key: "getStyles",
	    value: function getStyles() {
	      return {
	        radio: {
	          marginTop: "-0.5em",
	          marginBottom: "1em"
	        }
	      };
	    }
	  }, {
	    key: "getTagNameById",
	    value: function getTagNameById(id) {
	      var tags = this.props.getTagsForEventBucket(this.props.eventBucket.id);
	      if (tags) {
	        for (var t = 0; t < tags.length; t++) {
	          if (id === tag[t].id) {
	            return tag[t].name;
	          }
	        }
	      }
	      return "";
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var styles = this.getStyles();
	
	      var tags = this.props.getTagsForEventBucket(this.props.eventBucket.id);
	
	      var selectedTagIds = this.props.settings.online_ballot_custom_introduction_tags;
	      var selectedTags = [];
	
	      if (tags && tags.length > 0 && selectedTagIds) {
	        selectedTags = selectedTagIds.map(function (id) {
	          for (var t = 0; t < tags.length; t++) {
	            if (id === tags[t].id) {
	              return {
	                label: tags[t].name,
	                value: id
	              };
	            }
	          }
	        });
	      }
	
	      var selectedTagHeaders = this.props.settings.online_ballot_custom_introduction_by_tagging_modal_headers || {};
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          "p",
	          null,
	          "Set up ballots for ",
	          this.props.eventBucket.name,
	          " below. All changes will be saved automatically."
	        ),
	        _react2.default.createElement(
	          _infoNotice2.default,
	          { style: { marginBottom: "1.5em", fontSize: "10pt" } },
	          "Questions? Check out our",
	          " ",
	          _react2.default.createElement(
	            "a",
	            {
	              href: "https://help.eventive.org/eventive-balloting/getting-started/set-up-ballots",
	              target: "_blank"
	            },
	            "guide to setting up ballots"
	          ),
	          "."
	        ),
	        this.props.eventBucket.enable_virtual_festival ? _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement(
	            "h3",
	            null,
	            "Virtual balloting"
	          ),
	          _react2.default.createElement(
	            "p",
	            null,
	            "Enable virtual balloting on a per-screening basis via the event editor.",
	            _react2.default.createElement("br", null),
	            " Once votes have been tabulated, you can globally close voting here."
	          ),
	          _react2.default.createElement(
	            _materialUi.RadioButtonGroup,
	            {
	              style: styles.radio,
	              name: "virtual_festival_voting_enabled",
	              valueSelected: this.props.settings.virtual_festival_voting_enabled ? "true" : "false",
	              onChange: function onChange(e, v) {
	                return _this2.props.updateSetting("virtual_festival_voting_enabled", v === "true");
	              }
	            },
	            _react2.default.createElement(_materialUi.RadioButton, { value: "true", label: "Open for voting" }),
	            _react2.default.createElement(_materialUi.RadioButton, { value: "false", label: "Voting closed" })
	          )
	        ) : null,
	        true ? _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement(
	            "h3",
	            null,
	            "Online balloting for physical events"
	          ),
	          _react2.default.createElement(
	            "p",
	            { style: { marginBottom: 10 } },
	            "Allow users to vote on films from their \"My Tickets\" page on your Eventive site. When enabled, attendees will automatically be emailed and/or texted after each physical event to submit their votes."
	          ),
	          _react2.default.createElement(_materialUi.Checkbox, {
	            label: "Enable online balloting for physical events",
	            checked: this.props.settings.online_balloting_for_physical_events_enabled,
	            onCheck: function onCheck(e, v) {
	              return _this2.props.updateSetting("online_balloting_for_physical_events_enabled", v);
	            }
	          }),
	          this.props.settings.online_balloting_for_physical_events_enabled ? _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(
	              "p",
	              null,
	              "Enable online balloting on a per-film basis via the film editor.",
	              _react2.default.createElement("br", null),
	              "Once votes have been tabulated, you can globally close online voting here."
	            ),
	            _react2.default.createElement(
	              _materialUi.RadioButtonGroup,
	              {
	                style: styles.radio,
	                name: "online_balloting_voting_enabled",
	                valueSelected: this.props.settings.online_balloting_voting_enabled ? "true" : "false",
	                onChange: function onChange(e, v) {
	                  return _this2.props.updateSetting("online_balloting_voting_enabled", v === "true");
	                }
	              },
	              _react2.default.createElement(_materialUi.RadioButton, { value: "true", label: "Open for voting" }),
	              _react2.default.createElement(_materialUi.RadioButton, { value: "false", label: "Voting closed" })
	            ),
	            _react2.default.createElement(_materialUi.Checkbox, {
	              style: { paddingBottom: 0 },
	              label: "Require ticket scan in order to vote",
	              checked: this.props.settings.online_balloting_require_ticket_scan,
	              disabled: this.props.settings.online_balloting_for_physical_events_enabled === false,
	              onCheck: function onCheck(e, v) {
	                return _this2.props.updateSetting("online_balloting_require_ticket_scan", v);
	              }
	            }),
	            _react2.default.createElement(_materialUi.Checkbox, {
	              style: { paddingBottom: 0 },
	              label: "Enable custom introduction for different tags",
	              checked: this.props.settings.online_balloting_custom_introduction_by_tagging,
	              disabled: this.props.settings.online_balloting_for_physical_events_enabled === false,
	              onCheck: function onCheck(e, v) {
	                return _this2.props.updateSetting("online_balloting_custom_introduction_by_tagging", v);
	              }
	            }),
	            this.props.settings.online_balloting_custom_introduction_by_tagging ? _react2.default.createElement(
	              "div",
	              null,
	              _react2.default.createElement(
	                _label2.default,
	                null,
	                "Tag(s) with custom ballot introductions"
	              ),
	              _react2.default.createElement(_selectField2.default, {
	                value: selectedTags,
	                multi: true,
	                style: { maxWidth: 300 },
	                options: tags.map(function (t) {
	                  return {
	                    label: t.name,
	                    value: t.id
	                  };
	                }),
	                onChange: function onChange(selected) {
	                  _this2.setState({ selectedTags: selected });
	                  var selectedIds = selected.map(function (v) {
	                    return v.value;
	                  });
	                  _this2.props.updateSetting("online_ballot_custom_introduction_tags", selectedIds);
	                }
	              }),
	              selectedTags.map(function (tag) {
	                return _react2.default.createElement(
	                  "div",
	                  null,
	                  _react2.default.createElement(
	                    "p",
	                    null,
	                    _react2.default.createElement(
	                      "strong",
	                      null,
	                      "Online ballot custom introduction (",
	                      tag ? tag.label : "custom",
	                      ")"
	                    ),
	                    ": Edit custom content displayed at the top of the online ballot modal window for all events/films with this tag."
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { style: { marginTop: "1.5em", maxWidth: 600 } },
	                    _react2.default.createElement(_quillEditor2.default, {
	                      id: "quill_" + tag.id,
	                      value: selectedTagHeaders[tag.value],
	                      inlineBasicOnly: false,
	                      bounds: ".EventBucketConfigurator--container",
	                      onChange: function onChange(content) {
	                        // If the editor is empty, save just an empty string to the database,
	                        // not the <div><br></div> stub that is generated by quill
	                        var temp = document.createElement("div");
	                        temp.innerHTML = content;
	
	                        selectedTagHeaders[tag.value] = content;
	                        if (temp.innerText.trim() === "") {
	                          selectedTagHeaders[tag.value] = "";
	                        } else {
	                          selectedTagHeaders[tag.value] = content;
	                        }
	                        _this2.updateSettingDebounced("online_ballot_custom_introduction_by_tagging_modal_headers", selectedTagHeaders);
	                      }
	                    })
	                  )
	                );
	              })
	            ) : null,
	            _react2.default.createElement(
	              "p",
	              null,
	              _react2.default.createElement(
	                "strong",
	                null,
	                this.props.settings.online_balloting_custom_introduction_by_tagging ? "Online ballot introduction (default)" : "Online ballot introduction"
	              ),
	              ": Edit custom content displayed at the top of the online ballot modal window."
	            ),
	            _react2.default.createElement(
	              "div",
	              { style: { marginTop: "1.5em", maxWidth: 600 } },
	              _react2.default.createElement(_configuratorItem2.default, {
	                eventBucket: this.props.eventBucket,
	                item: { key: "online_ballot_modal_header", type: "html" },
	                config: this.props.settings,
	                onConfigChange: function onConfigChange(_, v) {
	                  return _this2.updateSettingDebounced("online_ballot_modal_header", v);
	                },
	                onConfigFocus: function onConfigFocus() {},
	                onConfigBlur: function onConfigBlur() {},
	                onForcePreview: function onForcePreview() {},
	                onEndForcePreview: function onEndForcePreview() {}
	              })
	            ),
	            _react2.default.createElement(
	              "p",
	              null,
	              _react2.default.createElement(
	                "strong",
	                null,
	                "Notification email introduction"
	              ),
	              ": Edit custom content displayed at the top of the online ballot notification email."
	            ),
	            _react2.default.createElement(
	              "div",
	              { style: { marginTop: "1.5em", maxWidth: 600 } },
	              _react2.default.createElement(_configuratorItem2.default, {
	                eventBucket: this.props.eventBucket,
	                item: {
	                  key: "online_ballot_notification_email_header",
	                  type: "html"
	                },
	                config: this.props.settings,
	                onConfigChange: function onConfigChange(_, v) {
	                  return _this2.updateSettingDebounced("online_ballot_notification_email_header", v);
	                },
	                onConfigFocus: function onConfigFocus() {},
	                onConfigBlur: function onConfigBlur() {},
	                onForcePreview: function onForcePreview() {},
	                onEndForcePreview: function onEndForcePreview() {}
	              })
	            )
	          ) : _react2.default.createElement("div", { style: { marginBottom: 20 } })
	        ) : null,
	        _react2.default.createElement(
	          "h3",
	          null,
	          "Ballot design"
	        ),
	        _react2.default.createElement(
	          "p",
	          null,
	          "Configure the design of your ballot."
	        ),
	        _react2.default.createElement(
	          _materialUi.RadioButtonGroup,
	          {
	            style: styles.radio,
	            name: "design",
	            valueSelected: this.props.settings.design,
	            onChange: function onChange(e, v) {
	              return _this2.props.updateSetting("design", v);
	            }
	          },
	          _react2.default.createElement(_materialUi.RadioButton, {
	            value: "rank",
	            label: "Rank each film (A-F, 5-1, custom, etc.)"
	          }),
	          _react2.default.createElement(_materialUi.RadioButton, {
	            value: "updown",
	            label: "Thumbs up / thumbs down for each film"
	          })
	        ),
	        this.props.settings.design === "rank" ? _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement(
	            _label2.default,
	            null,
	            "Ranking labels"
	          ),
	          _react2.default.createElement(
	            _materialUi.RadioButtonGroup,
	            {
	              name: "rank_labels",
	              valueSelected: ["5, 4, 3, 2, 1", "A, B, C, D, F"].indexOf(this.props.settings.rank_labels) !== -1 ? this.props.settings.rank_labels : "custom",
	              onChange: function onChange(e, v) {
	                if (v === "custom") {
	                  _this2.props.updateSetting("rank_labels", _this2.props.settings.rank_labels + " ");
	                  _this2.rankLabels.focus();
	                } else {
	                  _this2.props.updateSetting("rank_labels", v);
	                }
	              }
	            },
	            _react2.default.createElement(_materialUi.RadioButton, {
	              value: "A, B, C, D, F",
	              label: "Letter (A, B, C, D, F)"
	            }),
	            _react2.default.createElement(_materialUi.RadioButton, { value: "5, 4, 3, 2, 1", label: "Numeric (5-1)" }),
	            _react2.default.createElement(_materialUi.RadioButton, { value: "custom", label: "Custom" })
	          ),
	          _react2.default.createElement(_materialUi.TextField, {
	            ref: function ref(r) {
	              _this2.rankLabels = r;
	            },
	            floatingLabelText: _react2.default.createElement(
	              "div",
	              { style: { whiteSpace: "nowrap" } },
	              "Ranking labels (best \u2192 worst, comma-separated)"
	            ),
	            floatingLabelFixed: true,
	            value: this.props.settings.rank_labels,
	            onChange: function onChange(e, v) {
	              return _this2.props.updateSetting("rank_labels", v);
	            }
	          }),
	          _react2.default.createElement(
	            "div",
	            { style: { marginBottom: "1em" } },
	            _react2.default.createElement(
	              _label2.default,
	              null,
	              "Mobile/virtual-specific settings"
	            ),
	            _react2.default.createElement(_materialUi.Checkbox, {
	              label: "Use stars instead of rank labels in mobile ballots",
	              checked: this.props.settings.rank_labels_stars,
	              onCheck: function onCheck(e, v) {
	                return _this2.props.updateSetting("rank_labels_stars", v);
	              }
	            }),
	            _react2.default.createElement(_materialUi.Checkbox, {
	              label: 'For mobile/virtual ballots with >3 films, show "pick your favorite"',
	              checked: this.state.showFavorite || this.props.settings.rank_labels_favorite,
	              onCheck: function onCheck(e, v) {
	                _this2.props.updateSetting("rank_labels_favorite", v ? 1 : 0);
	                _this2.setState({ showFavorite: v });
	              }
	            })
	          )
	        ) : null,
	        _react2.default.createElement(
	          "h3",
	          null,
	          "Tabulation method"
	        ),
	        _react2.default.createElement(
	          _infoNotice2.default,
	          { style: { marginTop: "1em", fontSize: "10pt" } },
	          "Learn about our different",
	          " ",
	          _react2.default.createElement(
	            "a",
	            {
	              href: "https://help.eventive.org/eventive-balloting/introduction-to-ballot-tabulation",
	              target: "_blank"
	            },
	            "available tabulation methods"
	          ),
	          "."
	        ),
	        _react2.default.createElement(
	          "p",
	          null,
	          "Select your desired tabulation method."
	        ),
	        _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement(
	            _materialUi.RadioButtonGroup,
	            {
	              style: styles.radio,
	              name: "tabulation_method",
	              valueSelected: this.props.settings.tabulation_method,
	              onChange: function onChange(e, v) {
	                return _this2.props.updateSetting("tabulation_method", v);
	              }
	            },
	            _react2.default.createElement(_materialUi.RadioButton, {
	              value: "eventive",
	              label: _react2.default.createElement(
	                "span",
	                null,
	                "Eventive formula ",
	                _react2.default.createElement(
	                  "i",
	                  null,
	                  "(recommended)"
	                )
	              )
	            }),
	            _react2.default.createElement(_materialUi.RadioButton, { value: "imdb", label: _react2.default.createElement(
	                "span",
	                null,
	                "IMDb formula"
	              ) }),
	            _react2.default.createElement(_materialUi.RadioButton, { value: "average", label: _react2.default.createElement(
	                "span",
	                null,
	                "Simple average"
	              ) })
	          )
	        ),
	        ["imdb", "average"].indexOf(this.props.settings.tabulation_method) !== -1 ? _react2.default.createElement(_materialUi.TextField, {
	          style: { marginTop: "-1em", marginBottom: "0.5em" },
	          floatingLabelText: _react2.default.createElement(
	            "div",
	            { style: { whiteSpace: "nowrap" } },
	            "Minimum votes for consideration"
	          ),
	          floatingLabelFixed: true,
	          value: this.props.settings.minimum_votes,
	          onChange: function onChange(e, v) {
	            return _this2.props.updateSetting("minimum_votes", v);
	          }
	        }) : null,
	        _react2.default.createElement(
	          "h3",
	          null,
	          "Print ballot header"
	        ),
	        _react2.default.createElement(
	          "p",
	          null,
	          "Edit custom content displayed at the top of each printed ballot."
	        ),
	        _react2.default.createElement(
	          "div",
	          { style: { marginTop: "1.5em", maxWidth: 600 } },
	          _react2.default.createElement(_configuratorItem2.default, {
	            eventBucket: this.props.eventBucket,
	            item: { key: "ballot_header", type: "html" },
	            config: this.props.settings,
	            onConfigChange: function onConfigChange(_, v) {
	              return _this2.updateSettingDebounced("ballot_header", v);
	            },
	            onConfigFocus: function onConfigFocus() {},
	            onConfigBlur: function onConfigBlur() {},
	            onForcePreview: function onForcePreview() {},
	            onEndForcePreview: function onEndForcePreview() {}
	          })
	        ),
	        _react2.default.createElement(
	          "h3",
	          null,
	          "Balloted films"
	        ),
	        _react2.default.createElement(
	          "p",
	          null,
	          "By default:"
	        ),
	        _react2.default.createElement(
	          "ul",
	          null,
	          _react2.default.createElement(
	            "li",
	            null,
	            "A ballot will be generated for every applicable event"
	          ),
	          _react2.default.createElement(
	            "li",
	            null,
	            "Every event containing at least one",
	            " ",
	            _react2.default.createElement(
	              _reactRouter.Link,
	              { to: "event_buckets/" + this.props.eventBucket.id + "/films" },
	              "film"
	            ),
	            " ",
	            "is balloted"
	          ),
	          _react2.default.createElement(
	            "li",
	            null,
	            "Films can be excluded by setting their balloting status to \"Not in competition\" via the film editor"
	          ),
	          _react2.default.createElement(
	            "li",
	            null,
	            "Events with multiple films (e.g. shorts blocks) will generate a single ballot containing all films screening as part of the event"
	          ),
	          _react2.default.createElement(
	            "li",
	            null,
	            "Events with no balloted films (e.g. parties) will not generate ballots"
	          )
	        ),
	        _UserStore2.default.isGod() ? _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement(
	            "h3",
	            null,
	            "God settings"
	          ),
	          _react2.default.createElement(
	            _label2.default,
	            null,
	            "Virtual consolidated balloting"
	          ),
	          _react2.default.createElement(_materialUi.Checkbox, {
	            label: "Use virtual consolidated voting (single screen, all must be watched)",
	            checked: this.props.settings.virtual_festival_consolidated_voting,
	            onCheck: function onCheck(e, v) {
	              return _this2.props.updateSetting("virtual_festival_consolidated_voting", v);
	            }
	          }),
	          this.props.settings.virtual_festival_consolidated_voting ? _react2.default.createElement(_materialUi.TextField, {
	            style: { marginBottom: "0.5em" },
	            floatingLabelText: _react2.default.createElement(
	              "div",
	              { style: { whiteSpace: "nowrap" } },
	              "Number of favorites to select"
	            ),
	            floatingLabelFixed: true,
	            value: this.props.settings.rank_labels_favorite,
	            onChange: function onChange(e, v) {
	              return _this2.props.updateSetting("rank_labels_favorite", v);
	            }
	          }) : null
	        ) : null
	      );
	    }
	  }], [{
	    key: "getStores",
	    value: function getStores() {
	      return [_TagStore2.default];
	    }
	  }, {
	    key: "getPropsFromStores",
	    value: function getPropsFromStores() {
	      return {
	        getTagsForEventBucket: _TagStore2.default.getTagsForEventBucket
	      };
	    }
	  }]);
	
	  return BallotingSetup;
	}(_react2.default.Component);
	
	BallotingSetup.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	exports.default = (0, _connectToStores2.default)(BallotingSetup);
	module.exports = exports["default"];

/***/ }),
/* 2285 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _materialUi = __webpack_require__(576);
	
	var _reactRouter = __webpack_require__(486);
	
	var _config = __webpack_require__(1173);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _UserStore = __webpack_require__(974);
	
	var _UserStore2 = _interopRequireDefault(_UserStore);
	
	var _infoNotice = __webpack_require__(1599);
	
	var _infoNotice2 = _interopRequireDefault(_infoNotice);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BallotingApp = function (_React$Component) {
	  _inherits(BallotingApp, _React$Component);
	
	  function BallotingApp() {
	    _classCallCheck(this, BallotingApp);
	
	    return _possibleConstructorReturn(this, Object.getPrototypeOf(BallotingApp).apply(this, arguments));
	  }
	
	  _createClass(BallotingApp, [{
	    key: "getStyles",
	    value: function getStyles() {
	      return {
	        image: {
	          width: "100%",
	          maxWidth: 250,
	          border: "1px solid #ccc"
	        },
	        installLink: {}
	      };
	    }
	  }, {
	    key: "getBallotImgUrl",
	    value: function getBallotImgUrl() {
	      return _config2.default.endpoint + "users/self/api_keys/qr.svg?" + _UserStore2.default.makeApiKeyQueryString() + "&scope=ballot-entry";
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var styles = this.getStyles();
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          "p",
	          null,
	          "Use the Eventive Ballot app, available for iOS and Android, to collect votes at the door after screenings.",
	          _react2.default.createElement("br", null),
	          "We recommend using a tablet (especially for programs with multiple films), but a smaller device works too.",
	          _react2.default.createElement("br", null),
	          "Collect votes with as many devices as you'd like at each screening. All votes will be recorded instantly."
	        ),
	        _react2.default.createElement(
	          _infoNotice2.default,
	          { style: { marginBottom: "1.5em", fontSize: "10pt" } },
	          "Check out our",
	          " ",
	          _react2.default.createElement(
	            "a",
	            {
	              href: "https://help.eventive.org/eventive-balloting/using-app-based-voting",
	              target: "_blank"
	            },
	            "guide to using the Eventive Ballot app"
	          ),
	          "."
	        ),
	        _react2.default.createElement(
	          "p",
	          { style: { margin: "-10px 0", minHeight: 58 } },
	          _react2.default.createElement(
	            "a",
	            {
	              style: styles.installLink,
	              href: "https://itunes.apple.com/US/app/id1447062011?mt=8",
	              target: "_blank"
	            },
	            _react2.default.createElement("img", {
	              src: "/img/download-on-app-store.svg",
	              style: { width: 130, verticalAlign: "middle" }
	            })
	          ),
	          _react2.default.createElement(
	            "a",
	            {
	              style: styles.installLink,
	              href: "https://play.google.com/store/apps/details?id=org.eventive.eventiveballot",
	              target: "_blank"
	            },
	            _react2.default.createElement("img", {
	              alt: "Get it on Google Play",
	              src: "https://play.google.com/intl/en_us/badges/images/generic/en_badge_web_generic.png",
	              style: { width: 150, verticalAlign: "middle" }
	            })
	          )
	        ),
	        _react2.default.createElement(
	          "p",
	          null,
	          "After installing Eventive Ballot, scan the code below to login as",
	          " ",
	          (_UserStore2.default.getUser() || { organization: "" }).organization,
	          "."
	        ),
	        _react2.default.createElement("img", { style: styles.image, src: this.getBallotImgUrl() })
	      );
	    }
	  }]);
	
	  return BallotingApp;
	}(_react2.default.Component);
	
	BallotingApp.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	exports.default = BallotingApp;
	module.exports = exports["default"];

/***/ }),
/* 2286 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _materialUi = __webpack_require__(576);
	
	var _reactRouter = __webpack_require__(486);
	
	var _qs = __webpack_require__(1206);
	
	var _qs2 = _interopRequireDefault(_qs);
	
	var _moment = __webpack_require__(1021);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _config = __webpack_require__(1173);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _label = __webpack_require__(1682);
	
	var _label2 = _interopRequireDefault(_label);
	
	var _injectedSelect = __webpack_require__(1874);
	
	var _injectedSelect2 = _interopRequireDefault(_injectedSelect);
	
	var _infoNotice = __webpack_require__(1599);
	
	var _infoNotice2 = _interopRequireDefault(_infoNotice);
	
	var _UserStore = __webpack_require__(974);
	
	var _UserStore2 = _interopRequireDefault(_UserStore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BallotingPrint = function (_React$Component) {
	  _inherits(BallotingPrint, _React$Component);
	
	  function BallotingPrint(props) {
	    _classCallCheck(this, BallotingPrint);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(BallotingPrint).call(this, props));
	
	    _this.state = {
	      target: "all",
	      selected: []
	    };
	
	    _this.getPDFUrl = _this.getPDFUrl.bind(_this);
	    return _this;
	  }
	
	  _createClass(BallotingPrint, [{
	    key: "getStyles",
	    value: function getStyles() {
	      return {
	        radio: {
	          marginBottom: "1em"
	        },
	        actions: {
	          marginTop: "1.5em"
	        }
	      };
	    }
	  }, {
	    key: "getPDFUrl",
	    value: function getPDFUrl() {
	      var query = {
	        event_bucket: this.props.eventBucket.id,
	        events: this.state.target === "specific" ? this.state.selected : undefined
	      };
	      return _config2.default.endpoint + "ballots/ballot.pdf?" + _UserStore2.default.makeApiKeyQueryString() + "&" + _qs2.default.stringify(query);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var styles = this.getStyles();
	      var eventBucket = this.props.eventBucket;
	
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          "p",
	          null,
	          "Instead of (or in addition to) mobile ballots, you can also collect paper ballots.",
	          _react2.default.createElement("br", null),
	          "Select desired print options and then click \"Print ballots\" to generate a printable PDF."
	        ),
	        _react2.default.createElement(
	          _infoNotice2.default,
	          { style: { marginBottom: "1em", fontSize: "10pt" } },
	          "Check out our",
	          " ",
	          _react2.default.createElement(
	            "a",
	            {
	              href: "https://help.eventive.org/eventive-balloting/generating-paper-ballots",
	              target: "_blank"
	            },
	            "guide to printing ballots"
	          ),
	          "."
	        ),
	        _react2.default.createElement(
	          _label2.default,
	          null,
	          "Ballots to print"
	        ),
	        _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement(
	            _materialUi.RadioButtonGroup,
	            {
	              style: styles.radio,
	              name: "tabulation_method",
	              valueSelected: this.state.target,
	              onChange: function onChange(e, v) {
	                return _this2.setState({ target: v });
	              }
	            },
	            _react2.default.createElement(_materialUi.RadioButton, {
	              value: "all",
	              label: "All ballots for " + eventBucket.name
	            }),
	            _react2.default.createElement(_materialUi.RadioButton, { value: "specific", label: "Ballots for specific events" })
	          )
	        ),
	        this.state.target === "specific" ? _react2.default.createElement(
	          "div",
	          { style: { maxWidth: 600 } },
	          _react2.default.createElement(_injectedSelect2.default, {
	            value: this.state.selected,
	            label: "Events",
	            labelFormatter: function labelFormatter(e) {
	              return e.name + " \u2013 " + (0, _moment2.default)(e.start_time).format("lll");
	            },
	            type: "events",
	            eventBucketId: eventBucket.id,
	            multi: true,
	            onChange: function onChange(v) {
	              return _this2.setState({ selected: v });
	            }
	          })
	        ) : null,
	        _react2.default.createElement(
	          "div",
	          { style: styles.actions },
	          _react2.default.createElement(_materialUi.RaisedButton, {
	            label: "Print ballots",
	            primary: true,
	            href: this.getPDFUrl(),
	            target: "_blank"
	          })
	        )
	      );
	    }
	  }]);
	
	  return BallotingPrint;
	}(_react2.default.Component);
	
	BallotingPrint.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	exports.default = BallotingPrint;
	module.exports = exports["default"];

/***/ }),
/* 2287 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _radium = __webpack_require__(1600);
	
	var _radium2 = _interopRequireDefault(_radium);
	
	var _materialUi = __webpack_require__(576);
	
	var _reactRouter = __webpack_require__(486);
	
	var _moment = __webpack_require__(1021);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _chunk = __webpack_require__(2288);
	
	var _chunk2 = _interopRequireDefault(_chunk);
	
	var _reactable = __webpack_require__(1688);
	
	var _api = __webpack_require__(1160);
	
	var _api2 = _interopRequireDefault(_api);
	
	var _config = __webpack_require__(1173);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _UserStore = __webpack_require__(974);
	
	var _UserStore2 = _interopRequireDefault(_UserStore);
	
	var _EventStore = __webpack_require__(2032);
	
	var _EventStore2 = _interopRequireDefault(_EventStore);
	
	var _BallotActions = __webpack_require__(2278);
	
	var _BallotActions2 = _interopRequireDefault(_BallotActions);
	
	var _base = __webpack_require__(1755);
	
	var _base2 = _interopRequireDefault(_base);
	
	var _injectedSelect = __webpack_require__(1874);
	
	var _injectedSelect2 = _interopRequireDefault(_injectedSelect);
	
	var _linkLike = __webpack_require__(973);
	
	var _linkLike2 = _interopRequireDefault(_linkLike);
	
	var _infoNotice = __webpack_require__(1599);
	
	var _infoNotice2 = _interopRequireDefault(_infoNotice);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var generateGrid = function generateGrid(event) {
	  function getChunkSize(count) {
	    if (count <= 10) {
	      return 2;
	    } else if (count <= 21) {
	      return 3;
	    } else {
	      return 4;
	    }
	  }
	
	  var films = event.films;
	
	  // Blocks of 3+ - hide unballoted if same as event name
	
	  if (films.length >= 3) {
	    films = films.filter(function (f) {
	      return f.name === event.name && f.unballoted ? false : true;
	    });
	  }
	
	  if (films.length <= 2) {
	    return films.map(function (f) {
	      return [f];
	    });
	  }
	
	  var chunkSize = getChunkSize(films.length),
	      filmChunks = (0, _chunk2.default)(films, chunkSize);
	
	  // Transform the film matrix to vertical columns
	  // [[1,2],       [[1,4],
	  //  [3,4],  ==>   [2,5]
	  //  [5]]          [3]]
	  var newChunks = new Array(filmChunks.length).fill().map(function () {
	    return [];
	  });
	  films.forEach(function (f, i) {
	    newChunks[i % newChunks.length].push(f);
	  });
	
	  return newChunks;
	};
	
	var BallotingRecord = function (_React$Component) {
	  _inherits(BallotingRecord, _React$Component);
	
	  function BallotingRecord(props) {
	    _classCallCheck(this, BallotingRecord);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(BallotingRecord).call(this, props));
	
	    _this.state = {
	      event: null,
	      totalsShown: false,
	      recording: false,
	      submitting: false,
	      currentSessionCount: 0,
	      currentBallot: {},
	      currentBallotNextFilm: null,
	      currentBallotReadyToSubmit: false,
	      currentSessionIsBulk: false
	    };
	
	    _this.updateNextFilm = _this.updateNextFilm.bind(_this);
	    _this.updateVote = _this.updateVote.bind(_this);
	    _this.onKeypress = _this.onKeypress.bind(_this);
	    _this.launch = _this.launch.bind(_this);
	    _this.close = _this.close.bind(_this);
	    _this.submitBallot = _this.submitBallot.bind(_this);
	    return _this;
	  }
	
	  _createClass(BallotingRecord, [{
	    key: "getStyles",
	    value: function getStyles() {
	      return {
	        actions: {
	          marginTop: "1.5em"
	        },
	        count: {
	          fontSize: "0.6em",
	          color: "rgba(33, 33, 33, 0.6)",
	          margin: "-0.5em 0 -1em 0"
	        },
	        previewBallot: {
	          root: {
	            display: "table",
	            border: 0,
	            margin: "1em auto",
	            textAlign: "center",
	            position: "relative",
	            borderCollapse: "collapse",
	            width: "90%"
	          },
	          row: {
	            display: "table-row"
	          },
	          submitting: {
	            backgroundColor: "rgba(255,255,255,0.8)",
	            display: "block",
	            position: "absolute",
	            top: 1,
	            left: 0,
	            right: 0,
	            bottom: 0
	          },
	          entry: {
	            border: "1px solid #ccc",
	            padding: 20,
	            display: "table-cell",
	            verticalAlign: "middle"
	          },
	          name: {
	            fontWeight: "bold",
	            marginBottom: 5
	          },
	          ratingBubble: {
	            backgroundColor: "rgba(33, 33, 33, 0.6)",
	            borderRadius: "100%",
	            color: "#fff",
	            fontWeight: "bold",
	            fontSize: "17pt",
	            padding: 5,
	            width: 30,
	            height: 30,
	            lineHeight: "30px",
	            display: "inline-block",
	            marginLeft: 5,
	            cursor: "pointer",
	            transition: "0.01s ease-out",
	            ":hover": {
	              transform: "scale(1.05)"
	            }
	          },
	          ratingBubbleSelected: {
	            backgroundColor: "rgb(2, 136, 209)"
	          },
	          ratingButtonContainer: {
	            marginLeft: -5
	          }
	        },
	        submit: {
	          textAlign: "center"
	        }
	      };
	    }
	  }, {
	    key: "submitBallot",
	    value: function submitBallot() {
	      var _this2 = this;
	
	      if (this.state.submitting) {
	        return;
	      }
	
	      this.setState({ submitting: true });
	
	      _api2.default.request({
	        method: "POST",
	        endpoint: "ballots",
	        api_key: _UserStore2.default.getState().apiKey,
	        json: {
	          event: this.state.event.id,
	          ballot: this.state.currentBallot,
	          bulk: this.state.currentSessionIsBulk
	        }
	      }, function (err, d) {
	        if (err) {
	          window.alert(err.message);
	          _this2.setState({ submitting: false });
	        } else {
	          _this2.setState({
	            currentBallot: {},
	            currentBallotReadyToSubmit: false,
	            currentSessionCount: _this2.state.currentSessionCount + (d.ballots_recorded || 1),
	            submitting: false
	          }, function () {
	            if (_this2.state.currentSessionIsBulk) {
	              _this2.close();
	            }
	            _this2.updateNextFilm();
	          });
	        }
	      });
	    }
	  }, {
	    key: "updateNextFilm",
	    value: function updateNextFilm() {
	      var _state = this.state;
	      var event = _state.event;
	      var currentBallot = _state.currentBallot;
	      var films = event.films.filter(function (f) {
	        return !f.unballoted;
	      });
	
	      if (!films.length) {
	        this.setState({ currentBallotNextFilm: null });
	        return;
	      }
	
	      for (var i = 0; i < films.length; i++) {
	        if (!currentBallot[films[i].id]) {
	          this.setState({
	            currentBallotNextFilm: films[i].id,
	            currentBallotReadyToSubmit: Object.values(currentBallot).length > 0
	          });
	          return;
	        }
	      }
	
	      // leave the pointer at the previous entry
	      this.setState({ currentBallotReadyToSubmit: true });
	    }
	  }, {
	    key: "updateVote",
	    value: function updateVote(id, vote) {
	      var _this3 = this;
	
	      var _state2 = this.state;
	      var currentBallot = _state2.currentBallot;
	      var currentSessionIsBulk = _state2.currentSessionIsBulk;
	
	      if (currentSessionIsBulk) {
	        if (!currentBallot[id]) {
	          currentBallot[id] = {};
	        }
	        currentBallot[id][vote.score] = vote.count;
	      } else {
	        currentBallot[id] = vote;
	      }
	      this.setState({ currentBallot: currentBallot }, function () {
	        _this3.updateNextFilm();
	      });
	    }
	  }, {
	    key: "onKeypress",
	    value: function onKeypress(e) {
	      var labels = this.props.settings.rank_labels.split(",").map(function (l) {
	        return l.trim();
	      }),
	          vote = +e.key,
	          next = this.state.currentBallotNextFilm;
	
	      if (this.state.submitting) {
	        // fall through
	      } else if (this.state.currentBallotReadyToSubmit && e.key === "Enter") {
	        this.submitBallot();
	      } else if (next && vote > 0 && vote < labels.length + 1) {
	        // numeric = worst->best
	        if (labels.some(function (l) {
	          return +l === 1;
	        })) {
	          vote = labels.length - vote + 1;
	        }
	
	        this.updateVote(next, vote);
	      }
	    }
	  }, {
	    key: "launch",
	    value: function launch(bulk) {
	      var _this4 = this;
	
	      if (bulk) {
	        _BallotActions2.default.fetchVotes.defer(this.state.event.id);
	      }
	
	      if (this.state.recording) {
	        return;
	      } // already launched
	      this.setState({
	        currentSessionIsBulk: bulk,
	        currentSessionCount: 0,
	        currentBallot: {},
	        currentBallotReadyToSubmit: false,
	        recording: true
	      }, function () {
	        _this4.updateNextFilm();
	      });
	      if (!bulk) {
	        window.addEventListener("keyup", this.onKeypress);
	      }
	    }
	  }, {
	    key: "close",
	    value: function close() {
	      this.setState({ recording: false });
	      _BallotActions2.default.fetchStats.defer(this.props.eventBucket.id); // update
	      window.removeEventListener("keyup", this.onKeypress);
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(props) {
	      if (this.state.recording && this.state.currentSessionIsBulk && !this.state.submitting) {
	        this.setState({
	          currentBallot: props.getVotesForEvent(this.state.event.id) || {}
	        });
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this.close();
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this5 = this;
	
	      var eventBucket = this.props.eventBucket;
	      var _state3 = this.state;
	      var event = _state3.event;
	      var submitting = _state3.submitting;
	      var styles = this.getStyles();
	      var isReversed = false;
	      var labels = this.props.settings.rank_labels.split(",").map(function (l) {
	        return l.trim();
	      });
	
	      // numeric = worst->best
	      if (labels.some(function (l) {
	        return +l === 1;
	      })) {
	        isReversed = true;
	        labels.reverse();
	      }
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          _materialUi.Dialog,
	          {
	            title: "Ballot totals",
	            modal: false,
	            open: this.state.totalsShown,
	            bodyStyle: { overflowY: "scroll" },
	            actions: [_react2.default.createElement(_materialUi.FlatButton, {
	              label: "Close",
	              primary: true,
	              onClick: function onClick() {
	                return _this5.setState({ totalsShown: false });
	              }
	            })],
	            onRequestClose: function onRequestClose() {
	              return _this5.setState({ totalsShown: false });
	            }
	          },
	          this.state.totalsShown ? _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(
	              "p",
	              null,
	              "These totals include both paper & app-submitted ballots."
	            ),
	            _react2.default.createElement(_reactable.Table, {
	              className: "bordered striped responsive-table",
	              columns: [{ key: "name", label: "Event" }, { key: "date", label: "Date" }, { key: "ballots", label: "Ballots recorded" }],
	              data: _EventStore2.default.getEventsForEventBucket(eventBucket.id).map(function (e) {
	                return {
	                  name: e.name,
	                  date: (0, _moment2.default)(e.start_time).format("lll"),
	                  ballots: _this5.props.ballotStats && _this5.props.ballotStats.by_event[e.id] || "–"
	                };
	              })
	            })
	          ) : null
	        ),
	        _react2.default.createElement(
	          _base2.default,
	          {
	            useMuiDefaultStyle: true,
	            title: _react2.default.createElement(
	              "div",
	              null,
	              event && event.name + " \u2013 " + (0, _moment2.default)(event.start_time).format("lll"),
	              _react2.default.createElement(
	                "div",
	                { style: styles.count },
	                this.state.currentSessionCount,
	                " ballot",
	                this.state.currentSessionCount !== 1 ? "s" : "",
	                " recorded this session so far",
	                event && this.props.ballotStats ? _react2.default.createElement(
	                  "span",
	                  null,
	                  "\xA0|",
	                  " ",
	                  (this.props.ballotStats.by_event[event.id] || 0) + this.state.currentSessionCount,
	                  " ",
	                  "total recorded for event"
	                ) : null
	              )
	            ),
	            modal: false,
	            open: this.state.recording,
	            actions: [_react2.default.createElement(_materialUi.FlatButton, {
	              label: "Close ballot entry",
	              primary: false,
	              onClick: this.close
	            })]
	          },
	          event ? _react2.default.createElement(
	            "div",
	            null,
	            this.state.currentSessionIsBulk ? _react2.default.createElement(
	              "p",
	              null,
	              "Enter vote totals for each film on the ballot. You can adjust these values after entering. The totals here",
	              " ",
	              _react2.default.createElement(
	                "strong",
	                null,
	                "include all previously entered votes"
	              ),
	              ", so editing them may effectively overwrite previous votes."
	            ) : _react2.default.createElement(
	              "p",
	              null,
	              "Use the number keys to enter each vote (1=",
	              labels[0],
	              ", 2=",
	              labels[1],
	              ", etc.), then press the Enter/Return key to submit.",
	              _react2.default.createElement("br", null),
	              "Once a ballot has been submitted, it cannot be edited."
	            ),
	            _react2.default.createElement(
	              "div",
	              { style: styles.previewBallot.root },
	              event.films.length === 0 ? _react2.default.createElement(
	                "div",
	                { key: "none", style: styles.previewBallot.entry },
	                _react2.default.createElement(
	                  "div",
	                  { style: { fontStyle: "italic" } },
	                  "No balloted films to record"
	                )
	              ) : null,
	              generateGrid(event).map(function (row) {
	                return _react2.default.createElement(
	                  "div",
	                  { style: styles.previewBallot.row },
	                  row.map(function (f) {
	                    return _react2.default.createElement(
	                      "div",
	                      { key: f.id, style: styles.previewBallot.entry },
	                      _react2.default.createElement(
	                        "div",
	                        { style: styles.previewBallot.name },
	                        f.name
	                      ),
	                      f.unballoted ? _react2.default.createElement(
	                        "div",
	                        null,
	                        _react2.default.createElement(
	                          "i",
	                          null,
	                          "Not in competition"
	                        )
	                      ) : _react2.default.createElement(
	                        "div",
	                        null,
	                        _react2.default.createElement(
	                          "div",
	                          {
	                            style: styles.previewBallot.ratingButtonContainer
	                          },
	                          labels.map(function (l, i) {
	                            // In the case where there is only a single label, just use whatever key is
	                            // on the ballot. This is necessary for cases where the vote keys have gotten
	                            // out of sync and a single item => 5, for example SIGGRAPH 2021.
	                            // E.g. given label=["star"], ballot[film] = { 5: 27 }, grabs [5] as the possible vote.
	                            // Ref: https://eventiveteam.slack.com/archives/C01DQN0LV9C/p1628775299002200
	                            var singleBallotWorkaround = labels.length === 1 && _this5.state.currentBallot[f.id] && Object.keys(_this5.state.currentBallot[f.id]);
	
	                            var vote = singleBallotWorkaround && singleBallotWorkaround.length === 1 ? singleBallotWorkaround[0] : isReversed ? labels.length - i : i + 1;
	
	                            if (_this5.state.currentSessionIsBulk) {
	                              return _react2.default.createElement(
	                                "div",
	                                {
	                                  key: f.id + "-" + l,
	                                  style: {
	                                    display: "inline-block",
	                                    marginLeft: 5
	                                  }
	                                },
	                                _react2.default.createElement(
	                                  "strong",
	                                  null,
	                                  l,
	                                  ":"
	                                ),
	                                "\xA0",
	                                _react2.default.createElement(_materialUi.TextField, {
	                                  hintText: "0",
	                                  style: { width: 30 },
	                                  value: _this5.state.currentBallot[f.id] && _this5.state.currentBallot[f.id][vote] || "",
	                                  onChange: function onChange(e) {
	                                    return _this5.updateVote(f.id, {
	                                      score: vote,
	                                      count: +e.target.value
	                                    });
	                                  }
	                                })
	                              );
	                            }
	
	                            return _react2.default.createElement(
	                              "div",
	                              {
	                                key: f.id + "-" + l,
	                                style: Object.assign({}, styles.previewBallot.ratingBubble, _this5.state.currentBallot[f.id] === vote && styles.previewBallot.ratingBubbleSelected),
	                                onClick: function onClick() {
	                                  return _this5.updateVote(f.id, vote);
	                                }
	                              },
	                              l
	                            );
	                          })
	                        )
	                      )
	                    );
	                  })
	                );
	              }),
	              submitting && _react2.default.createElement("div", { style: styles.previewBallot.submitting })
	            ),
	            _react2.default.createElement(
	              "div",
	              { style: styles.submit },
	              _react2.default.createElement(_materialUi.RaisedButton, {
	                primary: true,
	                label: this.state.currentSessionIsBulk ? this.state.submitting ? "Updating voting totals..." : "Update vote totals" : this.state.submitting ? "Recording ballot..." : "Record ballot",
	                disabled: this.state.submitting || !this.state.currentBallotReadyToSubmit,
	                onClick: this.submitBallot
	              })
	            )
	          ) : null
	        ),
	        _react2.default.createElement(
	          "p",
	          null,
	          "Use this interface to record paper ballot votes.",
	          " ",
	          _react2.default.createElement(
	            "i",
	            null,
	            "Note: App-based votes are already recorded automatically."
	          ),
	          _react2.default.createElement("br", null),
	          "To see which events may have yet to be recorded, review the",
	          " ",
	          _react2.default.createElement(
	            _linkLike2.default,
	            { onTouchTap: function onTouchTap() {
	                return _this5.setState({ totalsShown: true });
	              } },
	            "number of ballots recorded per event"
	          ),
	          "."
	        ),
	        _react2.default.createElement(
	          _infoNotice2.default,
	          { style: { marginBottom: "1em", fontSize: "10pt" } },
	          "Check out our",
	          " ",
	          _react2.default.createElement(
	            "a",
	            {
	              href: "https://help.eventive.org/eventive-balloting/recording-paper-votes",
	              target: "_blank"
	            },
	            "guide to recording paper votes"
	          ),
	          "."
	        ),
	        _react2.default.createElement(
	          "div",
	          { style: { maxWidth: 600 } },
	          _react2.default.createElement(_injectedSelect2.default, {
	            value: event && event.id,
	            label: "Event to record",
	            labelFormatter: function labelFormatter(e) {
	              return e.name + " \u2013 " + (0, _moment2.default)(e.start_time).format("lll");
	            },
	            type: "events",
	            eventBucketId: eventBucket.id,
	            changeValueFunction: function changeValueFunction(e) {
	              return e;
	            },
	            onChange: function onChange(v) {
	              return _this5.setState({ event: v });
	            }
	          })
	        ),
	        _react2.default.createElement(
	          "div",
	          { style: styles.actions },
	          _react2.default.createElement(_materialUi.RaisedButton, {
	            primary: true,
	            disabled: !event,
	            label: "Launch ballot entry",
	            onClick: function onClick() {
	              return _this5.launch();
	            }
	          }),
	          _react2.default.createElement(_materialUi.RaisedButton, {
	            primary: true,
	            disabled: !event,
	            label: "Bulk entry",
	            style: { marginLeft: 7 },
	            onClick: function onClick() {
	              return _this5.launch(true);
	            }
	          })
	        )
	      );
	    }
	  }]);
	
	  return BallotingRecord;
	}(_react2.default.Component);
	
	BallotingRecord.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	exports.default = (0, _radium2.default)(BallotingRecord);
	module.exports = exports["default"];

/***/ }),
/* 2288 */
/***/ (function(module, exports, __webpack_require__) {

	var baseSlice = __webpack_require__(1386),
	    isIterateeCall = __webpack_require__(819),
	    toInteger = __webpack_require__(1393);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeCeil = Math.ceil,
	    nativeMax = Math.max;
	
	/**
	 * Creates an array of elements split into groups the length of `size`.
	 * If `array` can't be split evenly, the final chunk will be the remaining
	 * elements.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Array
	 * @param {Array} array The array to process.
	 * @param {number} [size=1] The length of each chunk
	 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	 * @returns {Array} Returns the new array of chunks.
	 * @example
	 *
	 * _.chunk(['a', 'b', 'c', 'd'], 2);
	 * // => [['a', 'b'], ['c', 'd']]
	 *
	 * _.chunk(['a', 'b', 'c', 'd'], 3);
	 * // => [['a', 'b', 'c'], ['d']]
	 */
	function chunk(array, size, guard) {
	  if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
	    size = 1;
	  } else {
	    size = nativeMax(toInteger(size), 0);
	  }
	  var length = array == null ? 0 : array.length;
	  if (!length || size < 1) {
	    return [];
	  }
	  var index = 0,
	      resIndex = 0,
	      result = Array(nativeCeil(length / size));
	
	  while (index < length) {
	    result[resIndex++] = baseSlice(array, index, (index += size));
	  }
	  return result;
	}
	
	module.exports = chunk;


/***/ }),
/* 2289 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _materialUi = __webpack_require__(576);
	
	var _reactRouter = __webpack_require__(486);
	
	var _moment = __webpack_require__(1021);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _reactable = __webpack_require__(1688);
	
	var _config = __webpack_require__(1173);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _util = __webpack_require__(1183);
	
	var util = _interopRequireWildcard(_util);
	
	var _statsBlockContainer = __webpack_require__(1740);
	
	var _statsBlockContainer2 = _interopRequireDefault(_statsBlockContainer);
	
	var _statsBlock = __webpack_require__(1741);
	
	var _statsBlock2 = _interopRequireDefault(_statsBlock);
	
	var _linkLike = __webpack_require__(973);
	
	var _linkLike2 = _interopRequireDefault(_linkLike);
	
	var _workingIndicator = __webpack_require__(1664);
	
	var _workingIndicator2 = _interopRequireDefault(_workingIndicator);
	
	var _injectedSelect = __webpack_require__(1874);
	
	var _injectedSelect2 = _interopRequireDefault(_injectedSelect);
	
	var _infoNotice = __webpack_require__(1599);
	
	var _infoNotice2 = _interopRequireDefault(_infoNotice);
	
	var _FilmStore = __webpack_require__(1765);
	
	var _FilmStore2 = _interopRequireDefault(_FilmStore);
	
	var _FilmActions = __webpack_require__(1764);
	
	var _FilmActions2 = _interopRequireDefault(_FilmActions);
	
	var _UserStore = __webpack_require__(974);
	
	var _UserStore2 = _interopRequireDefault(_UserStore);
	
	var _BallotActions = __webpack_require__(2278);
	
	var _BallotActions2 = _interopRequireDefault(_BallotActions);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BallotingTabulate = function (_React$Component) {
	  _inherits(BallotingTabulate, _React$Component);
	
	  function BallotingTabulate(props) {
	    _classCallCheck(this, BallotingTabulate);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(BallotingTabulate).call(this, props));
	
	    _this.state = {
	      tabulationRequested: false,
	      shownTabulation: null,
	      shownTabulationTagFilter: null
	    };
	
	    _this.run = _this.run.bind(_this);
	    return _this;
	  }
	
	  _createClass(BallotingTabulate, [{
	    key: "run",
	    value: function run() {
	      if (!window.confirm("Are you sure you would like to run the tabulation?")) {
	        return;
	      }
	
	      _BallotActions2.default.tabulate.defer(this.props.eventBucket.id);
	    }
	  }, {
	    key: "componentWillMount",
	    value: function componentWillMount() {
	      _BallotActions2.default.fetchTabulations.defer(this.props.eventBucket.id);
	      _FilmActions2.default.fetchAllForEventBucket.defer(this.props.eventBucket.id);
	    }
	  }, {
	    key: "getStyles",
	    value: function getStyles() {
	      return {
	        header: {
	          marginTop: "1em",
	          marginBottom: 0
	        }
	      };
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var styles = this.getStyles();
	      var _props = this.props;
	      var eventBucket = _props.eventBucket;
	      var ballotStats = _props.ballotStats;
	      var ballotTabulations = _props.ballotTabulations;
	      var settings = _props.settings;
	      var isWorking = _props.isWorking;
	      var _state = this.state;
	      var shownTabulation = _state.shownTabulation;
	      var shownTabulationTagFilter = _state.shownTabulationTagFilter;
	
	      var name = _UserStore2.default.getState().data.name;
	
	      if (!ballotStats) {
	        return _react2.default.createElement(_workingIndicator2.default, { fullPage: true });
	      }
	
	      var tabulationRows = shownTabulation && shownTabulation.scores.map(function (s) {
	        var film = _FilmStore2.default.getFilmById(s.film);
	
	        if (shownTabulationTagFilter && (!film || !film.tags.some(function (t) {
	          return t.id === shownTabulationTagFilter;
	        }))) {
	          return false;
	        }
	
	        if (typeof s.score !== "number") {
	          return false;
	        }
	
	        return {
	          Film: film ? film.name : "Film #" + s.film,
	          Score: s.score.toFixed(5)
	        };
	      }).filter(function (s) {
	        return !!s;
	      });
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          _materialUi.Dialog,
	          {
	            title: shownTabulation && "Tabulation on " + (0, _moment2.default)(shownTabulation.created_at).format("lll"),
	            modal: false,
	            open: !!shownTabulation,
	            bodyStyle: { overflowY: "scroll" },
	            actions: [_react2.default.createElement(_materialUi.FlatButton, {
	              onClick: function onClick() {
	                window.open(_config2.default.endpoint + "ballots/tabulations/" + shownTabulation.id + "/raw_votes.csv?" + _UserStore2.default.makeApiKeyQueryString());
	              },
	              primary: true,
	              label: "Download raw votes"
	            }), _react2.default.createElement(_materialUi.FlatButton, {
	              onClick: tabulationRows && tabulationRows.length ? function () {
	                util.clientSideDownload("tabulation-" + util.snakeCase(eventBucket.name) + "-" + util.snakeCase(shownTabulation.created_at) + ".csv", "text/csv", util.makeCsv([["Film", "Score"]].concat(tabulationRows.map(function (r) {
	                  return [r.Film, r.Score];
	                }))));
	              } : function () {},
	              primary: true,
	              label: "Download as CSV"
	            }), _react2.default.createElement(_materialUi.FlatButton, {
	              label: "Close",
	              primary: true,
	              onClick: function onClick() {
	                return _this2.setState({ shownTabulation: null });
	              }
	            })],
	            onRequestClose: function onRequestClose() {
	              return _this2.setState({ shownTabulation: null });
	            }
	          },
	          shownTabulation ? _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(
	              "p",
	              null,
	              "This tabulation was requested by",
	              " ",
	              shownTabulation.user_account.name,
	              " and follows the",
	              " ",
	              _react2.default.createElement(
	                "code",
	                null,
	                shownTabulation.balloting_config.design,
	                "/",
	                shownTabulation.balloting_config.tabulation_method
	              ),
	              " ",
	              "methodology. ",
	              shownTabulation.stats.total,
	              " ballots were evaluated to generate the following result. Higher is better."
	            ),
	            _react2.default.createElement(_injectedSelect2.default, {
	              value: shownTabulationTagFilter,
	              label: "Filter by tag",
	              placeholderText: "All films shown",
	              type: "tags",
	              eventBucketId: eventBucket.id,
	              labelFormatter: function labelFormatter(t) {
	                return t.name;
	              },
	              onChange: function onChange(v) {
	                return _this2.setState({ shownTabulationTagFilter: v });
	              },
	              style: { marginBottom: "1.5em", maxWidth: 400 }
	            }),
	            _react2.default.createElement(_reactable.Table, {
	              className: "bordered striped responsive-table",
	              data: tabulationRows
	            }),
	            tabulationRows.length === 0 ? _react2.default.createElement(
	              "div",
	              { className: "empty-table-message" },
	              "No films found."
	            ) : null
	          ) : null
	        ),
	        _react2.default.createElement(
	          "p",
	          null,
	          "When you're ready, you can tabulate results for ",
	          eventBucket.name,
	          ". To avoid bias, preliminary results are never shown. After a tabulation is run, your user account (",
	          name,
	          "), location, tabulation method & results, and the current date and time will be permanently logged."
	        ),
	        _react2.default.createElement(
	          _infoNotice2.default,
	          { style: { marginBottom: "1em", fontSize: "10pt" } },
	          "Check out our",
	          " ",
	          _react2.default.createElement(
	            "a",
	            {
	              href: "https://help.eventive.org/eventive-balloting/tabulating-results",
	              target: "_blank"
	            },
	            "guide to tabulating results"
	          ),
	          "."
	        ),
	        _react2.default.createElement(
	          _statsBlockContainer2.default,
	          null,
	          [_react2.default.createElement(_statsBlock2.default, {
	            key: "total",
	            value: ballotStats.total,
	            label: "Ballots recorded"
	          })]
	        ),
	        _react2.default.createElement(
	          "h3",
	          { style: styles.header },
	          "Previously run tabulations"
	        ),
	        ballotTabulations.length ? _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement(_reactable.Table, {
	            className: "bordered striped responsive-table",
	            style: { marginTop: "1em" },
	            data: ballotTabulations.sort(function (a, b) {
	              return b.created_at.localeCompare(a.created_at);
	            }).map(function (t) {
	              return {
	                User: t.user_account.name,
	                Date: (0, _moment2.default)(t.created_at).format("lll"),
	                Mode: t.balloting_config.design,
	                Method: t.balloting_config.tabulation_method,
	                "# ballots": t.stats.total,
	                View: _react2.default.createElement(
	                  "span",
	                  null,
	                  _react2.default.createElement(
	                    _linkLike2.default,
	                    {
	                      onTouchTap: function onTouchTap() {
	                        return _this2.setState({ shownTabulation: t });
	                      }
	                    },
	                    "View results"
	                  )
	                )
	              };
	            })
	          })
	        ) : _react2.default.createElement(
	          "p",
	          null,
	          isWorking ? _react2.default.createElement(
	            "i",
	            null,
	            "Loading previously run tabulations..."
	          ) : _react2.default.createElement(
	            "i",
	            null,
	            "No tabulations have been run, so far"
	          )
	        ),
	        _react2.default.createElement(
	          "h3",
	          { style: styles.header },
	          "Confirm & run new tabulation"
	        ),
	        _react2.default.createElement(
	          "ul",
	          null,
	          _react2.default.createElement(
	            "li",
	            null,
	            "User: ",
	            _react2.default.createElement(
	              "code",
	              null,
	              name
	            )
	          ),
	          _react2.default.createElement(
	            "li",
	            null,
	            "Date: ",
	            _react2.default.createElement(
	              "code",
	              null,
	              (0, _moment2.default)().format("lll")
	            )
	          ),
	          _react2.default.createElement(
	            "li",
	            null,
	            "Ballot mode: ",
	            _react2.default.createElement(
	              "code",
	              null,
	              settings.design
	            )
	          ),
	          _react2.default.createElement(
	            "li",
	            null,
	            "Tabulation method: ",
	            _react2.default.createElement(
	              "code",
	              null,
	              settings.tabulation_method
	            )
	          ),
	          _react2.default.createElement(
	            "li",
	            null,
	            "Number of ballots: ",
	            _react2.default.createElement(
	              "code",
	              null,
	              ballotStats.total
	            )
	          )
	        ),
	        _react2.default.createElement(_materialUi.RaisedButton, {
	          primary: true,
	          disabled: this.state.tabulationRequested && isWorking,
	          label: this.state.tabulationRequested && isWorking ? "Running new tabulation..." : "Run new tabulation...",
	          onClick: this.run
	        })
	      );
	    }
	  }]);
	
	  return BallotingTabulate;
	}(_react2.default.Component);
	
	BallotingTabulate.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	exports.default = BallotingTabulate;
	module.exports = exports["default"];

/***/ }),
/* 2290 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _materialUi = __webpack_require__(576);
	
	var _reactRouter = __webpack_require__(486);
	
	var _moment = __webpack_require__(1021);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _reactable = __webpack_require__(1688);
	
	var _config = __webpack_require__(1173);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _util = __webpack_require__(1183);
	
	var util = _interopRequireWildcard(_util);
	
	var _genericAnalyticsTable = __webpack_require__(1687);
	
	var _genericAnalyticsTable2 = _interopRequireDefault(_genericAnalyticsTable);
	
	var _workingIndicator = __webpack_require__(1664);
	
	var _workingIndicator2 = _interopRequireDefault(_workingIndicator);
	
	var _UserStore = __webpack_require__(974);
	
	var _UserStore2 = _interopRequireDefault(_UserStore);
	
	var _BallotUtil = __webpack_require__(2277);
	
	var _BallotUtil2 = _interopRequireDefault(_BallotUtil);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BallotingExtremeAudit = function (_React$Component) {
	  _inherits(BallotingExtremeAudit, _React$Component);
	
	  function BallotingExtremeAudit(props) {
	    _classCallCheck(this, BallotingExtremeAudit);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(BallotingExtremeAudit).call(this, props));
	
	    _this.state = { votes: null };
	    return _this;
	  }
	
	  _createClass(BallotingExtremeAudit, [{
	    key: "componentWillMount",
	    value: function componentWillMount() {
	      var _this2 = this;
	
	      _BallotUtil2.default.fetchConsolidatedAudit(_UserStore2.default.getState().apiKey, this.props.eventBucket.id).then(function (data) {
	        _this2.setState({ votes: data.votes });
	      }).catch(function (e) {
	        return window.alert("Error fetching ballot audit: " + e.message);
	      });
	    }
	  }, {
	    key: "getStyles",
	    value: function getStyles() {
	      return {
	        header: {
	          marginTop: "1em",
	          marginBottom: 0
	        }
	      };
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var styles = this.getStyles();
	      var votes = this.state.votes;
	
	      var name = _UserStore2.default.getState().data.name;
	
	      if (!votes) {
	        return _react2.default.createElement(_workingIndicator2.default, { fullPage: true });
	      }
	
	      var rows = votes.map(function (v) {
	        var formatted = v.votes.map(function (a) {
	          return -(a.score - 5) + ". " + a.name;
	        });
	
	        return {
	          name: v.person.name,
	          email: v.person.email,
	          voted_at: (0, _moment2.default)(v.voted_at).format("llll"),
	          votes: {
	            value: formatted.join("; "),
	            label: _react2.default.createElement(
	              "span",
	              { style: { whiteSpace: "pre" } },
	              formatted.join("\n")
	            )
	          }
	        };
	      });
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(_genericAnalyticsTable2.default, {
	          csvLabel: "voting-log",
	          eventBucket: this.props.eventBucket,
	          data: rows,
	          columns: [{ label: "Name", value: "name" }, { label: "Email", value: "email" }, { label: "Voted At", value: "voted_at" }, { label: "Votes", value: "votes" }]
	        })
	      );
	    }
	  }]);
	
	  return BallotingExtremeAudit;
	}(_react2.default.Component);
	
	BallotingExtremeAudit.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	exports.default = BallotingExtremeAudit;
	module.exports = exports["default"];

/***/ }),
/* 2291 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _materialUi = __webpack_require__(576);
	
	var _reactRouter = __webpack_require__(486);
	
	var _connectToStores = __webpack_require__(1226);
	
	var _connectToStores2 = _interopRequireDefault(_connectToStores);
	
	var _EventBucketStore = __webpack_require__(1593);
	
	var _EventBucketStore2 = _interopRequireDefault(_EventBucketStore);
	
	var _UserStore = __webpack_require__(974);
	
	var _UserStore2 = _interopRequireDefault(_UserStore);
	
	var _linkLike = __webpack_require__(973);
	
	var _linkLike2 = _interopRequireDefault(_linkLike);
	
	var _workingIndicator = __webpack_require__(1664);
	
	var _workingIndicator2 = _interopRequireDefault(_workingIndicator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Analytics = function (_React$Component) {
	  _inherits(Analytics, _React$Component);
	
	  function Analytics() {
	    _classCallCheck(this, Analytics);
	
	    return _possibleConstructorReturn(this, Object.getPrototypeOf(Analytics).apply(this, arguments));
	  }
	
	  _createClass(Analytics, [{
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var eventBucketId = this.props.params.eventBucketId;
	      var eventBucket = this.props.getEventBucketById(eventBucketId);
	
	      if (!eventBucket) {
	        return _react2.default.createElement(_workingIndicator2.default, { fullPage: true });
	      }
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          "h1",
	          null,
	          "\"",
	          eventBucket.name,
	          "\" analytics"
	        ),
	        _react2.default.createElement(
	          "p",
	          null,
	          "Use Eventive Analytics to learn more about your event bucket and attendees.",
	          _react2.default.createElement("br", null),
	          _UserStore2.default.hasPermission("view_analytics") ? _react2.default.createElement(
	            "span",
	            null,
	            "Looking for more? ",
	            _react2.default.createElement(
	              _reactRouter.Link,
	              { to: "/reports" },
	              "Global reports"
	            ),
	            " are available as well."
	          ) : null
	        ),
	        _UserStore2.default.hasPermission("view_analytics") || _UserStore2.default.hasPermission("view_attendee_analytics") ? _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement(_materialUi.RaisedButton, {
	            label: "Attendee analytics",
	            primary: true,
	            onTouchTap: function onTouchTap() {
	              return _this2.context.router.push("/event_buckets/" + eventBucketId + "/analytics/attendees");
	            }
	          })
	        ) : null,
	        _UserStore2.default.hasPermission("view_analytics") || _UserStore2.default.hasPermission("view_event_analytics") ? _react2.default.createElement(
	          "div",
	          { style: { marginTop: 10 } },
	          _react2.default.createElement(_materialUi.RaisedButton, {
	            label: "Event analytics",
	            primary: true,
	            onTouchTap: function onTouchTap() {
	              return _this2.context.router.push("/event_buckets/" + eventBucketId + "/analytics/events");
	            }
	          })
	        ) : null,
	        _UserStore2.default.hasPermission("view_analytics") || _UserStore2.default.hasPermission("view_standalone_ticket_analytics") ? _react2.default.createElement(
	          "div",
	          { style: { marginTop: 10 } },
	          _react2.default.createElement(_materialUi.RaisedButton, {
	            label: "Standalone ticket analytics",
	            primary: true,
	            onTouchTap: function onTouchTap() {
	              return _this2.context.router.push("/event_buckets/" + eventBucketId + "/analytics/event_sales");
	            }
	          })
	        ) : null,
	        _UserStore2.default.hasPermission("view_analytics") || _UserStore2.default.hasPermission("view_pass_sales_analytics") ? _react2.default.createElement(
	          "div",
	          { style: { marginTop: 10 } },
	          _react2.default.createElement(_materialUi.RaisedButton, {
	            label: "Pass sales analytics",
	            primary: true,
	            onTouchTap: function onTouchTap() {
	              return _this2.context.router.push("/event_buckets/" + eventBucketId + "/analytics/passes");
	            }
	          })
	        ) : null,
	        _UserStore2.default.hasPermission("view_analytics") || _UserStore2.default.hasPermission("view_pass_ticket_analytics") ? _react2.default.createElement(
	          "div",
	          { style: { marginTop: 10 } },
	          _react2.default.createElement(_materialUi.RaisedButton, {
	            label: "Pass ticket analytics",
	            primary: true,
	            onTouchTap: function onTouchTap() {
	              return _this2.context.router.push("/event_buckets/" + eventBucketId + "/analytics/event_passes");
	            }
	          })
	        ) : null,
	        _UserStore2.default.hasPermission("view_analytics") || _UserStore2.default.hasPermission("view_recurring_pass_analytics") ? _react2.default.createElement(
	          "div",
	          { style: { marginTop: 10 } },
	          _react2.default.createElement(_materialUi.RaisedButton, {
	            label: "Recurring pass analytics",
	            primary: true,
	            onTouchTap: function onTouchTap() {
	              return _this2.context.router.push("/event_buckets/" + eventBucketId + "/analytics/recurring_pass");
	            }
	          })
	        ) : null,
	        eventBucket.frontend_config.memberships_enabled && (_UserStore2.default.hasPermission("view_analytics") || _UserStore2.default.hasPermission("view_pass_sales_analytics")) ? _react2.default.createElement(
	          "div",
	          { style: { marginTop: 10 } },
	          _react2.default.createElement(_materialUi.RaisedButton, {
	            label: "Membership sales analytics",
	            primary: true,
	            onTouchTap: function onTouchTap() {
	              return _this2.context.router.push("/event_buckets/" + eventBucketId + "/analytics/memberships");
	            }
	          })
	        ) : null,
	        eventBucket.frontend_config.memberships_enabled && (_UserStore2.default.hasPermission("view_analytics") || _UserStore2.default.hasPermission("view_pass_ticket_analytics")) ? _react2.default.createElement(
	          "div",
	          { style: { marginTop: 10 } },
	          _react2.default.createElement(_materialUi.RaisedButton, {
	            label: "Membership ticket analytics",
	            primary: true,
	            onTouchTap: function onTouchTap() {
	              return _this2.context.router.push("/event_buckets/" + eventBucketId + "/analytics/event_memberships");
	            }
	          })
	        ) : null,
	        eventBucket.frontend_config.memberships_enabled && (_UserStore2.default.hasPermission("view_analytics") || _UserStore2.default.hasPermission("view_recurring_pass_analytics")) ? _react2.default.createElement(
	          "div",
	          { style: { marginTop: 10 } },
	          _react2.default.createElement(_materialUi.RaisedButton, {
	            label: "Membership status analytics",
	            primary: true,
	            onTouchTap: function onTouchTap() {
	              return _this2.context.router.push("/event_buckets/" + eventBucketId + "/analytics/recurring_membership");
	            }
	          })
	        ) : null,
	        _UserStore2.default.hasPermission("view_analytics") || _UserStore2.default.hasPermission("view_geo_analytics") ? _react2.default.createElement(
	          "div",
	          { style: { marginTop: 10 } },
	          _react2.default.createElement(_materialUi.RaisedButton, {
	            label: "Geo analytics",
	            primary: true,
	            onTouchTap: function onTouchTap() {
	              return _this2.context.router.push("/event_buckets/" + eventBucketId + "/analytics/geo");
	            }
	          })
	        ) : null,
	        _UserStore2.default.hasPermission("view_analytics") || _UserStore2.default.hasPermission("view_streaming_analytics") ? _react2.default.createElement(
	          "div",
	          { style: { marginTop: 10 } },
	          _react2.default.createElement(_materialUi.RaisedButton, {
	            label: "Streaming analytics",
	            primary: true,
	            onTouchTap: function onTouchTap() {
	              return _this2.context.router.push("/event_buckets/" + eventBucketId + "/analytics/streaming");
	            }
	          })
	        ) : null,
	        _UserStore2.default.hasPermission("view_analytics") || _UserStore2.default.hasPermission("view_sales_analytics") ? _react2.default.createElement(
	          "div",
	          { style: { marginTop: 10 } },
	          _react2.default.createElement(_materialUi.RaisedButton, {
	            label: "Sales analytics",
	            primary: true,
	            onTouchTap: function onTouchTap() {
	              return _this2.context.router.push("/event_buckets/" + eventBucketId + "/analytics/sales");
	            }
	          })
	        ) : null,
	        _UserStore2.default.hasPermission("view_analytics") || _UserStore2.default.hasPermission("view_discount_analytics") ? _react2.default.createElement(
	          "div",
	          { style: { marginTop: 10 } },
	          _react2.default.createElement(_materialUi.RaisedButton, { label: "Discount analytics", disabled: true })
	        ) : null,
	        _UserStore2.default.hasPermission("view_analytics") || _UserStore2.default.hasPermission("view_venue_analytics") ? _react2.default.createElement(
	          "div",
	          { style: { marginTop: 10 } },
	          _react2.default.createElement(_materialUi.RaisedButton, { label: "Venue analytics", disabled: true })
	        ) : null,
	        _UserStore2.default.hasPermission("view_analytics") ? _react2.default.createElement(
	          "p",
	          null,
	          _react2.default.createElement(
	            "i",
	            null,
	            "Additional analytics functionality available soon.",
	            " ",
	            _react2.default.createElement(
	              _linkLike2.default,
	              {
	                onTouchTap: function onTouchTap() {
	                  return Intercom("showNewMessage", "I'm looking to analyze: ");
	                }
	              },
	              "Tell us what you're looking for!"
	            )
	          )
	        ) : null
	      );
	    }
	  }], [{
	    key: "getStores",
	    value: function getStores() {
	      return [_EventBucketStore2.default, _UserStore2.default];
	    }
	  }, {
	    key: "getPropsFromStores",
	    value: function getPropsFromStores() {
	      return {
	        getEventBucketById: _EventBucketStore2.default.getEventBucketById
	      };
	    }
	  }]);
	
	  return Analytics;
	}(_react2.default.Component);
	
	Analytics.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	exports.default = (0, _connectToStores2.default)(Analytics);
	module.exports = exports["default"];

/***/ }),
/* 2292 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _moment = __webpack_require__(1021);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _materialUi = __webpack_require__(576);
	
	var _chart = __webpack_require__(1785);
	
	var _chart2 = _interopRequireDefault(_chart);
	
	var _util = __webpack_require__(1183);
	
	var util = _interopRequireWildcard(_util);
	
	var _connectToStores = __webpack_require__(1226);
	
	var _connectToStores2 = _interopRequireDefault(_connectToStores);
	
	var _EventBucketStore = __webpack_require__(1593);
	
	var _EventBucketStore2 = _interopRequireDefault(_EventBucketStore);
	
	var _AnalyticsStore = __webpack_require__(1861);
	
	var _AnalyticsStore2 = _interopRequireDefault(_AnalyticsStore);
	
	var _AnalyticsActions = __webpack_require__(1863);
	
	var _AnalyticsActions2 = _interopRequireDefault(_AnalyticsActions);
	
	var _PassBucketStore = __webpack_require__(1867);
	
	var _PassBucketStore2 = _interopRequireDefault(_PassBucketStore);
	
	var _PassBucketActions = __webpack_require__(1869);
	
	var _PassBucketActions2 = _interopRequireDefault(_PassBucketActions);
	
	var _analyticsHeader = __webpack_require__(2293);
	
	var _analyticsHeader2 = _interopRequireDefault(_analyticsHeader);
	
	var _workingIndicator = __webpack_require__(1664);
	
	var _workingIndicator2 = _interopRequireDefault(_workingIndicator);
	
	var _statsBlockContainer = __webpack_require__(1740);
	
	var _statsBlockContainer2 = _interopRequireDefault(_statsBlockContainer);
	
	var _statsBlock = __webpack_require__(1741);
	
	var _statsBlock2 = _interopRequireDefault(_statsBlock);
	
	var _passSalesAnalyticsTable = __webpack_require__(2294);
	
	var _passSalesAnalyticsTable2 = _interopRequireDefault(_passSalesAnalyticsTable);
	
	var _genericAnalyticsTable = __webpack_require__(1687);
	
	var _genericAnalyticsTable2 = _interopRequireDefault(_genericAnalyticsTable);
	
	var _analyticsFilterWidget = __webpack_require__(2295);
	
	var _analyticsFilterWidget2 = _interopRequireDefault(_analyticsFilterWidget);
	
	var _fromCacheCallout = __webpack_require__(2296);
	
	var _fromCacheCallout2 = _interopRequireDefault(_fromCacheCallout);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PassAnalytics = function (_React$Component) {
	  _inherits(PassAnalytics, _React$Component);
	
	  function PassAnalytics(props) {
	    _classCallCheck(this, PassAnalytics);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(PassAnalytics).call(this, props));
	
	    _this.state = {
	      allTime: false,
	      range: {
	        key: "selection",
	        startDate: (0, _moment2.default)().subtract(1, "month").format("YYYY-MM-DD"),
	        endDate: (0, _moment2.default)().format("YYYY-MM-DD")
	      },
	      showCharts: false,
	      filterState: "passes",
	      isMembership: null,
	      widgetReset: false
	    };
	
	    _this.onWindowClick = _this.onWindowClick.bind(_this);
	    _this.onWindowKeyDown = _this.onWindowKeyDown.bind(_this);
	    _this.handleSegmentFilterChange = _this.handleSegmentFilterChange.bind(_this);
	    _this.handleDateChange = _this.handleDateChange.bind(_this);
	    _this.setPage = _this.setPage.bind(_this);
	    return _this;
	  }
	
	  _createClass(PassAnalytics, [{
	    key: "onWindowClick",
	    value: function onWindowClick(e) {
	      if (this.state.showRangeEditor && (!this.container || !this.container.contains(e.target) && !this.rangeButton.contains(e.target))) {
	        this.setState({ showRangeEditor: false });
	      }
	    }
	  }, {
	    key: "onWindowKeyDown",
	    value: function onWindowKeyDown(e) {
	      if (this.state.showRangeEditor && e.which === 27) {
	        // esc
	        this.setState({ showRangeEditor: false });
	      }
	    }
	
	    // Set the state of the page to reflect if we are on a 
	    // pass page or a membership page.
	
	  }, {
	    key: "setPage",
	    value: function () {
	      var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
	        return regeneratorRuntime.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                if (!this.props.location.pathname.includes("memberships")) {
	                  _context.next = 6;
	                  break;
	                }
	
	                _context.next = 3;
	                return this.setState({ isMembership: true, filterState: "memberships" });
	
	              case 3:
	                this.componentWillReceiveProps(this.props, true);
	                _context.next = 9;
	                break;
	
	              case 6:
	                _context.next = 8;
	                return this.setState({ isMembership: false, filterState: "passes" });
	
	              case 8:
	                this.componentWillReceiveProps(this.props, true);
	
	              case 9:
	              case "end":
	                return _context.stop();
	            }
	          }
	        }, _callee, this);
	      }));
	
	      function setPage() {
	        return _ref.apply(this, arguments);
	      }
	
	      return setPage;
	    }()
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.setPage(); // set state to reflect pass vs. membership
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps) {
	      if (this.props.location !== prevProps.location) {
	        this.setPage(); // set state to reflect pass vs. membership
	      }
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(newProps) {
	      var force = arguments.length <= 1 || arguments[1] === undefined ? false : arguments[1];
	
	      if (force === true || newProps.params.eventBucketId !== this.props.params.eventBucketId) {
	        _AnalyticsActions2.default.fetchPassBucketsOverview.defer({
	          eventBucketId: newProps.params.eventBucketId,
	          filterState: this.state.filterState,
	          startDate: !this.state.allTime ? JSON.stringify(this.state.range.startDate) : null,
	          endDate: !this.state.allTime ? JSON.stringify(this.state.range.endDate) : null,
	          allTime: this.state.allTime
	        });
	        _AnalyticsActions2.default.fetchPassSalesAnalytics.defer({
	          eventBucketId: newProps.params.eventBucketId,
	          isMembership: this.state.isMembership,
	          filterState: this.state.filterState,
	          startDate: !this.state.allTime ? JSON.stringify(this.state.range.startDate) : null,
	          endDate: !this.state.allTime ? JSON.stringify(this.state.range.endDate) : null,
	          allTime: this.state.allTime
	        });
	        _PassBucketActions2.default.fetchAllForEventBucket.defer(newProps.params.eventBucketId);
	      }
	    }
	  }, {
	    key: "handleSegmentFilterChange",
	    value: function handleSegmentFilterChange(props) {
	      var _this2 = this;
	
	      this.setState({ filterState: props }, function () {
	        return _this2.componentWillReceiveProps(_this2.props, true);
	      });
	    }
	  }, {
	    key: "handleDateChange",
	    value: function handleDateChange(_ref2) {
	      var _this3 = this;
	
	      var range = _ref2.range;
	      var allTime = _ref2.allTime;
	
	      this.setState({ range: range, allTime: allTime }, function () {
	        return _this3.componentWillReceiveProps(_this3.props, true);
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this4 = this;
	
	      var _props = this.props;
	      var eventBucketId = _props.params.eventBucketId;
	      var getPassBucketById = _props.getPassBucketById;
	
	      var eventBucket = this.props.getEventBucketById(eventBucketId);
	      var defaultItemsPerPage = 25;
	
	      var passBuckets = this.state.filterState !== "all" ? this.state.filterState === "passes" ? this.props.getPassBucketsForEventBucket(eventBucketId) : this.props.getMembershipsForEventBucket(eventBucketId) : this.props.getPassBucketsAndMembershipsForEventBucket(eventBucketId);
	
	      var analyticsOverview = this.props.getPassBucketsOverview(eventBucketId);
	      var salesAnalytics = this.props.getPassSalesAnalytics(eventBucketId);
	
	      var isMembership = this.props.location.pathname.includes("memberships");
	
	      if (!analyticsOverview || !salesAnalytics || !passBuckets || !eventBucket) {
	        return _react2.default.createElement(_workingIndicator2.default, { fullPage: true });
	      }
	
	      var totals = analyticsOverview.totals;
	
	
	      var passTotal = Object.values(totals).reduce(function (c, i) {
	        return c + i.count;
	      }, 0);
	      var freeTotal = Object.values(totals).reduce(function (c, i) {
	        return c + i.free_count;
	      }, 0);
	      var paidTotal = passTotal - freeTotal;
	
	      var rows = (salesAnalytics.sales || []).map(function (next) {
	        var date = new Date(next.date.year, next.date.month - 1, next.date.day);
	        return [{
	          timeframe: { end: date },
	          value: next.pass_buckets.map(function (b) {
	            return {
	              pass_bucket: (getPassBucketById(b.pass_bucket) || {
	                name: isMembership ? "Deleted membership" : "Deleted pass bucket"
	              }).name,
	              result: b.count
	            };
	          })
	        }, {
	          timeframe: { end: date },
	          value: next.pass_buckets.map(function (b) {
	            return {
	              pass_bucket: (getPassBucketById(b.pass_bucket) || {
	                name: isMembership ? "Deleted membership" : "Deleted pass bucket"
	              }).name,
	              result: b.amount / 100
	            };
	          })
	        }];
	      });
	
	      var filledRows = util.fillMissingDaysNew(rows.map(function (r) {
	        return r[0];
	      }), "timeframe.end", { default: 0 });
	      filledRows = filledRows.map(function (r) {
	        r.timeframe.end = r.timeframe.end.toISOString();
	        return r;
	      });
	
	      var filledSalesRows = util.fillMissingDaysNew(rows.map(function (r) {
	        return r[1];
	      }), "timeframe.end", { default: 0 });
	      filledSalesRows = filledSalesRows.map(function (r) {
	        r.timeframe.end = r.timeframe.end.toISOString();
	        return r;
	      });
	
	      var chartOptions = {
	        point: { show: false }
	      };
	
	      var membershipsEnabledforEventBucket = this.props.getEventBucketById(eventBucketId).frontend_config.memberships_enabled;
	      var browserTimezone = _moment2.default.tz(_moment2.default.tz.guess()).format('z');
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(_analyticsHeader2.default, {
	          eventBucket: eventBucket,
	          allEventBuckets: this.props.getEventBuckets(),
	          label: isMembership ? "membership sales analytics" : "pass sales analytics",
	          subpath: "passes"
	        }),
	        _react2.default.createElement(_analyticsFilterWidget2.default
	        // re-render this component when we switch from passes to memberships
	        // and vice-versa:
	        , { key: isMembership ? "membership" : "passes",
	          showDateFilter: true,
	          onDateRangeChange: this.handleDateChange,
	          showSegmentFilter: !isMembership && membershipsEnabledforEventBucket ? true : false,
	          segmentFilterSelected: this.state.filterState,
	          onSegmentFilterChange: this.handleSegmentFilterChange,
	          segmentFilterTitle: "Filter by",
	          segmentFilterConfig: [{
	            value: "passes",
	            label: "Non-Membership Passes"
	          }, {
	            value: "all",
	            label: "All Passes"
	          }]
	        }),
	        _react2.default.createElement(_fromCacheCallout2.default, { analytics: salesAnalytics }),
	        !analyticsOverview || !salesAnalytics || !passBuckets || !eventBucket || this.props.isFetchingPassSalesAnalytics || this.props.isFetchingPassBucketsOverview ? _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement(_workingIndicator2.default, { fullPage: true })
	        ) : _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement(
	            "p",
	            null,
	            "Scroll down to view ",
	            _react2.default.createElement(
	              "a",
	              { href: "#total-sales" },
	              "total sales"
	            ),
	            ",",
	            " ",
	            _react2.default.createElement(
	              "a",
	              { href: "#free-vs-paid" },
	              "free vs paid"
	            ),
	            ",",
	            " ",
	            _react2.default.createElement(
	              "a",
	              { href: "#ticket-orders" },
	              "ticket order breakdown"
	            ),
	            ",",
	            " ",
	            _react2.default.createElement(
	              "a",
	              { href: "#passes-chart" },
	              isMembership ? "memberships" : "passes",
	              " issued by day"
	            ),
	            ", and",
	            " ",
	            _react2.default.createElement(
	              "a",
	              { href: "#sales-chart" },
	              "sales by day"
	            ),
	            "."
	          ),
	          _react2.default.createElement(
	            _statsBlockContainer2.default,
	            { style: { marginTop: -10 } },
	            _react2.default.createElement(_statsBlock2.default, {
	              value: util.formatNumber(passTotal),
	              label: "Total " + (isMembership ? "memberships" : "passes") + " issued"
	            }),
	            _react2.default.createElement(_statsBlock2.default, {
	              value: util.formatPrice(salesAnalytics.total_volume),
	              label: "Total " + (isMembership ? "membership" : "pass") + " sales volume"
	            })
	          ),
	          _react2.default.createElement("a", { className: "anchor--fixed_header_offset", id: "total-sales" }),
	          _react2.default.createElement(
	            "div",
	            { className: "analytics-element" },
	            _react2.default.createElement(
	              "h2",
	              { style: { marginTop: "1em" } },
	              "Total sales data"
	            ),
	            _react2.default.createElement(_passSalesAnalyticsTable2.default, {
	              eventBucket: eventBucket,
	              data: salesAnalytics.volumes,
	              passBuckets: this.props.passBuckets,
	              isMembership: isMembership,
	              itemsPerPage: defaultItemsPerPage
	            })
	          ),
	          _react2.default.createElement("a", { className: "anchor--fixed_header_offset", id: "free-vs-paid" }),
	          _react2.default.createElement(
	            "div",
	            { className: "analytics-element" },
	            _react2.default.createElement(
	              "h2",
	              { style: { marginTop: "1em" } },
	              "Free vs paid breakdown"
	            ),
	            _react2.default.createElement(
	              "h3",
	              null,
	              passTotal,
	              " total ",
	              isMembership ? "memberships" : "passes",
	              " issued (",
	              freeTotal,
	              " free, ",
	              paidTotal,
	              " paid)"
	            ),
	            _react2.default.createElement(_genericAnalyticsTable2.default, {
	              eventBucket: eventBucket,
	              label: isMembership ? "Membership Bucket" : "Pass bucket",
	              csvLabel: isMembership ? "membership-free-vs-paid-analytics" : "pass-free-vs-paid-analytics",
	              source: this.props.passBuckets,
	              itemsPerPage: defaultItemsPerPage,
	              columns: [{ label: isMembership ? "Free memberships issued" : "Free passes issued", value: "freeTotal" }, { label: isMembership ? "Paid memberships issued" : "Paid passes issued", value: "paidTotal" }, { label: "Total", value: "total" }],
	              defaultSort: "Total",
	              data: passBuckets.map(function (b) {
	                var total = totals[b.id] ? totals[b.id].count : 0,
	                    freeTotal = totals[b.id] ? totals[b.id].free_count : 0,
	                    paidTotal = total - freeTotal;
	
	                return {
	                  id: b.id,
	                  total: total,
	                  freeTotal: freeTotal,
	                  paidTotal: paidTotal
	                };
	              })
	            })
	          ),
	          _react2.default.createElement("a", { className: "anchor--fixed_header_offset", id: "ticket-orders" }),
	          _react2.default.createElement(
	            "div",
	            { className: "analytics-element" },
	            _react2.default.createElement(
	              "h2",
	              { style: { marginTop: "1em" } },
	              "Ticket order breakdown"
	            ),
	            _react2.default.createElement(
	              "h3",
	              null,
	              Object.values(totals).reduce(function (c, i) {
	                return c + i.uses;
	              }, 0),
	              " total tickets issued to passes"
	            ),
	            _react2.default.createElement(_genericAnalyticsTable2.default, {
	              eventBucket: eventBucket,
	              label: isMembership ? "Membership Bucket" : "Pass bucket",
	              csvLabel: isMembership ? "membership-ticket-orders-analytics" : "pass-ticket-orders-analytics",
	              source: this.props.passBuckets,
	              itemsPerPage: defaultItemsPerPage,
	              columns: [{ label: "Total tickets ordered", value: "total" }, { label: isMembership ? "Average orders per membership" : "Average orders per pass", value: "average" }],
	              defaultSort: "Total tickets ordered",
	              data: passBuckets.map(function (b) {
	                var total = totals[b.id] ? totals[b.id].uses : 0;
	                var rawAverage = totals[b.id] ? totals[b.id].uses / totals[b.id].count : 1;
	                var average = rawAverage ? rawAverage.toFixed(1) : 0;
	
	                return {
	                  id: b.id,
	                  total: total,
	                  average: average
	                };
	              })
	            })
	          ),
	          _react2.default.createElement("a", { className: "anchor--fixed_header_offset", id: "passes-chart" }),
	          _react2.default.createElement(
	            "div",
	            { className: "analytics-element" },
	            _react2.default.createElement(
	              "h2",
	              { style: { marginTop: "1em" } },
	              isMembership ? "Memberships issued, by day, " + browserTimezone : "Passes issued, by day, " + browserTimezone
	            ),
	            filledRows.length ? this.state.showCharts === eventBucketId ? _react2.default.createElement(_chart2.default, {
	              type: "area",
	              indexBy: "timeframe.end",
	              dateFormat: "%b %e",
	              height: 200,
	              chartOptions: chartOptions,
	              data: filledRows.length && { result: filledRows }
	            }) : _react2.default.createElement(_materialUi.RaisedButton, {
	              label: "Reveal charts",
	              onTouchTap: function onTouchTap() {
	                return _this4.setState({ showCharts: eventBucketId });
	              },
	              labelStyle: { color: "rgb(2, 136, 209)" }
	            }) : _react2.default.createElement(_chart2.default, {
	              height: 200,
	              placeholder: "Issuance data will be available as soon as the first " + eventBucket.name + " pass is issued!"
	            })
	          ),
	          _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement("a", { className: "anchor--fixed_header_offset", id: "sales-chart" }),
	            _react2.default.createElement(
	              "div",
	              { className: "analytics-element" },
	              _react2.default.createElement(
	                "h2",
	                { style: { marginTop: "1em" } },
	                "Sales volume, by day, ",
	                browserTimezone
	              ),
	              filledSalesRows.length ? this.state.showCharts === eventBucketId ? _react2.default.createElement(_chart2.default, {
	                type: "area",
	                indexBy: "timeframe.end",
	                dateFormat: "%b %e",
	                height: 200,
	                chartOptions: Object.assign({}, chartOptions, {
	                  axis: {
	                    y: { tick: { format: function format(p) {
	                          return util.formatPrice(p * 100);
	                        } } }
	                  }
	                }),
	                data: filledSalesRows.length && { result: filledSalesRows }
	              }) : _react2.default.createElement(_materialUi.RaisedButton, {
	                label: "Reveal charts",
	                onTouchTap: function onTouchTap() {
	                  return _this4.setState({ showCharts: eventBucketId });
	                },
	                labelStyle: { color: "rgb(2, 136, 209)" }
	              }) : _react2.default.createElement(_chart2.default, {
	                height: 200,
	                placeholder: "Sales data will be available as soon as the first " + eventBucket.name + " pass is sold!"
	              })
	            )
	          )
	        )
	      );
	    }
	  }], [{
	    key: "getStores",
	    value: function getStores() {
	      return [_EventBucketStore2.default, _PassBucketStore2.default, _AnalyticsStore2.default];
	    }
	  }, {
	    key: "getPropsFromStores",
	    value: function getPropsFromStores() {
	      return {
	        getEventBuckets: _EventBucketStore2.default.getEventBuckets,
	        getEventBucketById: _EventBucketStore2.default.getEventBucketById,
	        getPassBucketsOverview: _AnalyticsStore2.default.getPassBucketsOverview,
	        getPassSalesAnalytics: _AnalyticsStore2.default.getPassSalesAnalytics,
	        getPassBucketsForEventBucket: _PassBucketStore2.default.getPassBucketsForEventBucket,
	        getMembershipsForEventBucket: _PassBucketStore2.default.getMembershipsForEventBucket,
	        getPassBucketsAndMembershipsForEventBucket: _PassBucketStore2.default.getPassBucketsAndMembershipsForEventBucket,
	        getPassBucketById: _PassBucketStore2.default.getPassBucketById,
	        passBuckets: _PassBucketStore2.default.getState().passBuckets,
	        isFetchingPassSalesAnalytics: _AnalyticsStore2.default.getState().isFetchingPassSalesAnalytics,
	        isFetchingPassBucketsOverview: _AnalyticsStore2.default.getState().isFetchingPassBucketsOverview
	      };
	    }
	  }]);
	
	  return PassAnalytics;
	}(_react2.default.Component);
	
	PassAnalytics.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	exports.default = (0, _connectToStores2.default)(PassAnalytics);
	module.exports = exports["default"];

/***/ }),
/* 2293 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactSelect = __webpack_require__(953);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	var _backButton = __webpack_require__(1872);
	
	var _backButton2 = _interopRequireDefault(_backButton);
	
	var _tableRefreshIndicator = __webpack_require__(1686);
	
	var _tableRefreshIndicator2 = _interopRequireDefault(_tableRefreshIndicator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HEADER_STYLE = {
	  lineHeight: 1.2
	};
	
	var AnalyticsHeader = function AnalyticsHeader(_ref, _ref2) {
	  var eventBucket = _ref.eventBucket;
	  var allEventBuckets = _ref.allEventBuckets;
	  var subpath = _ref.subpath;
	  var query = _ref.query;
	  var label = _ref.label;
	  var onRefresh = _ref.onRefresh;
	  var isRefreshing = _ref.isRefreshing;
	  var hideHeader = _ref.hideHeader;
	  var router = _ref2.router;
	
	  return _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement(_backButton2.default, {
	      label: "Analytics",
	      style: { marginBottom: 10 },
	      location: "/event_buckets/" + eventBucket.id + "/analytics"
	    }),
	    onRefresh || isRefreshing ? _react2.default.createElement(_tableRefreshIndicator2.default, {
	      onRefresh: onRefresh,
	      isRefreshing: isRefreshing,
	      style: { marginRight: 260, marginTop: -2 }
	    }) : null,
	    _react2.default.createElement(
	      "div",
	      { style: { float: "right", width: 250 } },
	      _react2.default.createElement(_reactSelect2.default, {
	        options: allEventBuckets.map(function (b) {
	          return { label: b.name, value: b.id };
	        }),
	        value: eventBucket.id,
	        clearable: false,
	        onChange: function onChange(b) {
	          return router.push({
	            pathname: "/event_buckets/" + b.value + "/analytics/" + subpath,
	            query: query
	          });
	        }
	      })
	    ),
	    !hideHeader ? _react2.default.createElement(
	      "h1",
	      { style: HEADER_STYLE },
	      "\"",
	      eventBucket.name,
	      "\" ",
	      label
	    ) : null
	  );
	};
	
	AnalyticsHeader.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	
	exports.default = AnalyticsHeader;
	module.exports = exports["default"];

/***/ }),
/* 2294 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _moment = __webpack_require__(1021);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _reactRouter = __webpack_require__(486);
	
	var _reactable = __webpack_require__(1688);
	
	var _materialUi = __webpack_require__(576);
	
	var _inlineLinkIconButton = __webpack_require__(1704);
	
	var _inlineLinkIconButton2 = _interopRequireDefault(_inlineLinkIconButton);
	
	var _util = __webpack_require__(1183);
	
	var util = _interopRequireWildcard(_util);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PassSalesAnalyticsTable = function (_React$Component) {
	  _inherits(PassSalesAnalyticsTable, _React$Component);
	
	  function PassSalesAnalyticsTable(props) {
	    _classCallCheck(this, PassSalesAnalyticsTable);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(PassSalesAnalyticsTable).call(this, props));
	
	    _this._makeRow = _this._makeRow.bind(_this);
	    return _this;
	  }
	
	  _createClass(PassSalesAnalyticsTable, [{
	    key: "_makeRow",
	    value: function _makeRow(eventBucket, id, data) {
	      var _this2 = this;
	
	      var options = arguments.length <= 3 || arguments[3] === undefined ? {} : arguments[3];
	
	      var noWrapTdStyle = { whiteSpace: "nowrap" };
	      var isMembership = this.props.isMembership;
	      var routeLocation = isMembership ? "memberships" : "pass_buckets";
	
	      return _react2.default.createElement(
	        _reactable.Tr,
	        { key: id },
	        _react2.default.createElement(
	          _reactable.Td,
	          { column: "Pass bucket", value: options.pass_bucket.name },
	          _react2.default.createElement(
	            "span",
	            null,
	            options.pass_bucket.name,
	            options.pass_bucket.id && _react2.default.createElement(_inlineLinkIconButton2.default, {
	              onTouchTap: function onTouchTap() {
	                _this2.context.router.push("/event_buckets/" + eventBucket + "/" + routeLocation + "/" + options.pass_bucket.id);
	              },
	              tooltip: this.props.isMembership ? "View membership bucket" : "View pass bucket"
	            })
	          )
	        ),
	        _react2.default.createElement(
	          _reactable.Td,
	          { column: "Web", value: data.web, style: noWrapTdStyle },
	          util.formatPrice(data.web)
	        ),
	        _react2.default.createElement(
	          _reactable.Td,
	          { column: "Box office", value: data.box_office, style: noWrapTdStyle },
	          util.formatPrice(data.box_office)
	        ),
	        _react2.default.createElement(
	          _reactable.Td,
	          { column: "Renewals", value: data.autorenewal, style: noWrapTdStyle },
	          util.formatPrice(data.autorenewal)
	        ),
	        _react2.default.createElement(
	          _reactable.Td,
	          { column: "Total", value: data.total, style: noWrapTdStyle },
	          util.formatPrice(data.total)
	        )
	      );
	    }
	  }, {
	    key: "downloadCsv",
	    value: function downloadCsv(data, passBuckets) {
	      util.clientSideDownload((this.props.isMembership ? "membership-sales-analytics" : "pass-sales-analytics") + "-" + util.snakeCase(this.props.eventBucket.name) + ".csv", "text/csv", util.makeCsv([["Pass bucket", "Web", "Box office", "Renewals", "Total"]].concat(Object.keys(data).map(function (id) {
	        return [(passBuckets[id] || { name: "Deleted pass bucket" }).name, data[id].web / 100 || 0, data[id].box_office / 100 || 0, data[id].autorenewal / 100 || 0, data[id].total / 100 || 0];
	      }))));
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this3 = this;
	
	      var _props = this.props;
	      var data = _props.data;
	      var eventBucket = _props.eventBucket;
	      var passBuckets = _props.passBuckets;
	      var isMembership = _props.isMembership;
	      var itemsPerPage = _props.itemsPerPage;
	
	
	      var defaultItemsPerPage = 25;
	      var itemsPer = itemsPerPage ? itemsPerPage : defaultItemsPerPage;
	
	      var rows = Object.keys(data).map(function (id) {
	        return _this3._makeRow(eventBucket.id, id, data[id], {
	          pass_bucket: passBuckets[id] || { name: "Deleted pass bucket" }
	        });
	      });
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          _reactable.Table,
	          {
	            className: "bordered striped responsive-table",
	            sortable: ["Pass bucket", "Web", "Box office", "Renewals", "Total"],
	            itemsPerPage: itemsPer,
	            defaultSort: { column: "Total", direction: "desc" },
	            columns: [{ key: "Pass bucket", label: isMembership ? "Membership Bucket" : "Pass Bucket" }, "Web", "Box office", "Renewals", "Total"]
	          },
	          rows
	        ),
	        _react2.default.createElement(_materialUi.RaisedButton, {
	          style: { marginTop: "1em" },
	          label: "Download (.csv)",
	          onTouchTap: function onTouchTap() {
	            return _this3.downloadCsv(data, passBuckets);
	          }
	        })
	      );
	    }
	  }], [{
	    key: "contextTypes",
	    get: function get() {
	      return {
	        router: _react2.default.PropTypes.object
	      };
	    }
	  }]);
	
	  return PassSalesAnalyticsTable;
	}(_react2.default.Component);
	
	exports.default = PassSalesAnalyticsTable;
	module.exports = exports["default"];

/***/ }),
/* 2295 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDateRange = __webpack_require__(2198);
	
	var _materialUi = __webpack_require__(576);
	
	var _arrowDropDown = __webpack_require__(716);
	
	var _arrowDropDown2 = _interopRequireDefault(_arrowDropDown);
	
	var _momentTimezone = __webpack_require__(1185);
	
	var _momentTimezone2 = _interopRequireDefault(_momentTimezone);
	
	var _defaultRanges = __webpack_require__(2258);
	
	var _UserStore = __webpack_require__(974);
	
	var _UserStore2 = _interopRequireDefault(_UserStore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AnalyticsFilterWidget = function (_React$Component) {
	  _inherits(AnalyticsFilterWidget, _React$Component);
	
	  // TO-DO:
	  // Convert the Segment Filters to simple dropdowns or to a newer MaterialUI component.
	  // Then we can reuse the component rather than duplicating.
	  function AnalyticsFilterWidget(props) {
	    _classCallCheck(this, AnalyticsFilterWidget);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(AnalyticsFilterWidget).call(this, props));
	
	    _this.onDateRangeChange = function (props) {
	      _this.props.onDateRangeChange({
	        range: _this.state.range,
	        allTime: _this.state.allTime
	      });
	    };
	
	    _this.onSegmentFilterChange = function (props) {
	      _this.props.onSegmentFilterChange(_this.state.filterState);
	    };
	
	    _this.onSegmentFilter2Change = function (props) {
	      _this.props.onSegmentFilter2Change(_this.state.filter2State);
	    };
	
	    _this.onLedgerToggleChange = function (props) {
	      _this.props.onLedgerToggleChange(_this.state.useLedger);
	    };
	
	    _this.handleLedgerToggleChange = function () {
	      _this.setState({ useLedger: !_this.state.useLedger }, _this.onLedgerToggleChange);
	    };
	
	    _this.onGenericToggleChange = function (props) {
	      _this.props.onGenericToggleChange(_this.state.genericToggleOn);
	    };
	
	    _this.handleGenericToggleChange = function () {
	      _this.setState({ genericToggleOn: !_this.state.genericToggleOn }, _this.onGenericToggleChange);
	    };
	
	    _this.onDateChange = function (_ref) {
	      var selection = _ref.selection;
	
	      var allRange = {
	        key: "selection"
	      };
	      var setTimeToEndOfDay = function setTimeToEndOfDay(dateObj) {
	        var obj = _extends({}, dateObj);
	        obj.endDate.setHours(23, 59, 59, 0);
	        return obj;
	      };
	      if (selection.startDate === "all_time") {
	        _this.setState({ allTime: true, showRangeEditor: false }, _this.onDateRangeChange);
	        return;
	      } else {
	        _this.setState({
	          range: setTimeToEndOfDay(selection),
	          allTime: false
	        }, _this.onDateRangeChange);
	      }
	    };
	
	    _this.buildSegmentFilterButtonLabel = function () {
	      var segmentLabel = _this.props.showSegmentFilter && _this.props.segmentFilterConfig ? _this.props.segmentFilterConfig.filter(function (s) {
	        return s.value === _this.props.segmentFilterSelected;
	      }) : null;
	      if (!segmentLabel || segmentLabel.length < 1) {
	        console.warn("Warning: segmentFilterSelected is not valid.");
	      }
	      return segmentLabel && segmentLabel[0] && segmentLabel[0].label ? segmentLabel[0].label : "Filter";
	    };
	
	    _this.buildSegmentFilter2ButtonLabel = function () {
	      var segmentLabel = _this.props.showSegmentFilter2 && _this.props.segmentFilter2Config ? _this.props.segmentFilter2Config.filter(function (s) {
	        return s.value === _this.props.segmentFilter2Selected;
	      }) : null;
	      if (!segmentLabel || segmentLabel.length < 1) {
	        console.warn("Warning: segmentFilter2Selected is not valid.");
	      }
	      return segmentLabel && segmentLabel[0] && segmentLabel[0].label ? segmentLabel[0].label : "Filter";
	    };
	
	    _this.state = {
	      showRangeCalendar: false,
	      allTime: false,
	      range: {
	        key: "selection",
	        startDate: (0, _momentTimezone2.default)().subtract(1, "month").format("YYYY-MM-DD"),
	        endDate: (0, _momentTimezone2.default)().format("YYYY-MM-DD")
	      },
	      filterState: false,
	      filter2State: false,
	      useLedger: false,
	      genericToggleOn: false,
	      popoverOpen: false,
	      anchorEl: null,
	      popover2Open: false,
	      anchorEl2: null
	    };
	
	    _this.onDateRangeChange = _this.onDateRangeChange.bind(_this);
	    _this.onLedgerToggleChange = _this.onLedgerToggleChange.bind(_this);
	    _this.handleLedgerToggleChange = _this.handleLedgerToggleChange.bind(_this);
	    _this.handleSegmentFilter = _this.handleSegmentFilter.bind(_this);
	    _this.onClickPopover = _this.onClickPopover.bind(_this);
	    _this.onClosePopover = _this.onClosePopover.bind(_this);
	    _this.buildSegmentFilterButtonLabel = _this.buildSegmentFilterButtonLabel.bind(_this);
	    _this.handleSegmentFilter2 = _this.handleSegmentFilter2.bind(_this);
	    _this.onClickPopover2 = _this.onClickPopover2.bind(_this);
	    _this.onClosePopover2 = _this.onClosePopover2.bind(_this);
	    _this.buildSegmentFilter2ButtonLabel = _this.buildSegmentFilter2ButtonLabel.bind(_this);
	    return _this;
	  }
	
	  _createClass(AnalyticsFilterWidget, [{
	    key: "componentDidMount",
	    value: function componentDidMount(props) {
	      // Set selected radio buttons
	      if (this.state.filterState === false) {
	        this.setState({
	          filterState: this.props.segmentFilterSelected ? this.props.segmentFilterSelected : null
	        });
	      }
	      if (this.state.filter2State === false) {
	        this.setState({
	          filter2State: this.props.segmentFilter2Selected ? this.props.segmentFilter2Selected : null
	        });
	      }
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(newProps) {
	      if (newProps.segmentFilterSelected !== this.state.filterState) {
	        this.setState({ filterState: newProps.segmentFilterSelected });
	      }
	      if (newProps.segmentFilter2Selected !== this.state.filter2State) {
	        this.setState({ filter2State: newProps.segmentFilter2Selected });
	      }
	    }
	  }, {
	    key: "onClickPopover",
	    value: function onClickPopover(e) {
	      e.preventDefault();
	
	      this.setState({
	        popoverOpen: true,
	        anchorEl: e.currentTarget
	      });
	    }
	  }, {
	    key: "onClosePopover",
	    value: function onClosePopover() {
	      this.setState({ popoverOpen: false });
	    }
	  }, {
	    key: "onClickPopover2",
	    value: function onClickPopover2(e) {
	      e.preventDefault();
	
	      this.setState({
	        popover2Open: true,
	        anchorEl2: e.currentTarget
	      });
	    }
	  }, {
	    key: "onClosePopover2",
	    value: function onClosePopover2() {
	      this.setState({ popover2Open: false });
	    }
	  }, {
	    key: "handleSegmentFilter",
	    value: function handleSegmentFilter(e) {
	      this.setState({ filterState: e.target.value }, this.onSegmentFilterChange);
	    }
	  }, {
	    key: "handleSegmentFilter2",
	    value: function handleSegmentFilter2(e) {
	      this.setState({ filter2State: e.target.value }, this.onSegmentFilter2Change);
	    }
	  }, {
	    key: "getStyles",
	    value: function getStyles() {
	      return {
	        rangeContainer: {
	          marginBottom: "0",
	          paddingBottom: "0.25rem"
	        },
	        rangeButton: {
	          display: "inline-block",
	          borderRadius: 20,
	          padding: "8px 16px",
	          fontSize: "12pt",
	          color: "rgb(33,33,33)",
	          cursor: "pointer",
	          boxShadow: "0 0 5px 2px rgba(0, 0, 0, 0.1)",
	          transition: "0.1s ease-in-out",
	          ":hover": {
	            boxShadow: "0 0 5px 2px rgba(0, 0, 0, 0.2)"
	          }
	        },
	        overlay: {
	          borderTop: "1px solid #dddddd",
	          position: "absolute",
	          left: 0,
	          top: 0,
	          backgroundColor: "#fff",
	          boxShadow: "0 0 5px 2px rgb(0,0,0,0.1)",
	          zIndex: 1000
	        },
	        overlaySubmit: {
	          position: "absolute",
	          right: 10,
	          bottom: 10
	        }
	      };
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var styles = this.getStyles();
	      var browserTimezone = _momentTimezone2.default.tz(_momentTimezone2.default.tz.guess()).format('z');
	
	      var DateFilter = function DateFilter() {
	        var dateFilterTitle = _this2.props.dateFilterToggleTitle ? "" + _this2.props.dateFilterToggleTitle : "Filter by date";
	
	        return _react2.default.createElement(
	          "div",
	          { className: "filter-widget-item item-segment-filter first" },
	          _react2.default.createElement(
	            "div",
	            {
	              className: "date-filter",
	              style: styles.rangeContainer,
	              ref: function ref(r) {
	                _this2.rangeButton = r;
	              }
	            },
	            _react2.default.createElement(
	              "div",
	              { className: "filter-widget-item-title" },
	              dateFilterTitle,
	              " ",
	              _react2.default.createElement(
	                "em",
	                null,
	                "(",
	                browserTimezone,
	                ")"
	              )
	            ),
	            _react2.default.createElement(_materialUi.RaisedButton, {
	              onClick: function onClick() {
	                return _this2.setState({ showRangeCalendar: true });
	              },
	              label: _this2.state.allTime ? "All time — click to filter" : (0, _momentTimezone2.default)(_this2.state.range.startDate).format("ll") + " \u2013 " + (0, _momentTimezone2.default)(_this2.state.range.endDate).format("ll")
	            }),
	            _react2.default.createElement(
	              "div",
	              { style: { position: "absolute" } },
	              _this2.state.showRangeCalendar ? _react2.default.createElement(
	                "div",
	                {
	                  style: styles.overlay,
	                  ref: function ref(r) {
	                    _this2.container = r;
	                  }
	                },
	                _react2.default.createElement(_reactDateRange.DateRangePicker, {
	                  ranges: [_this2.state.range],
	                  showSelectionPreview: false,
	                  onChange: _this2.onDateChange,
	                  maxDate: new Date(),
	                  shownDate: new Date(_this2.state.range.endDate),
	                  onHover: null,
	                  staticRanges: [{
	                    label: "All Time",
	                    isSelected: function isSelected() {
	                      return false;
	                    },
	                    range: function range() {
	                      return {
	                        startDate: "all_time",
	                        endDate: "all_time"
	                      };
	                    }
	                  }].concat(_defaultRanges.defaultStaticRanges)
	                }),
	                _react2.default.createElement(
	                  "div",
	                  { style: styles.overlaySubmit },
	                  _react2.default.createElement(_materialUi.RaisedButton, {
	                    label: "Close",
	                    onTouchTap: function onTouchTap() {
	                      return _this2.setState({ showRangeCalendar: false });
	                    }
	                  })
	                )
	              ) : null
	            )
	          )
	        );
	      };
	
	      var SegmentFilter = function SegmentFilter() {
	        return _react2.default.createElement(
	          _materialUi.RadioButtonGroup,
	          {
	            name: "event-filter",
	            onChange: _this2.handleSegmentFilter,
	            valueSelected: _this2.state.filterState
	          },
	          _this2.props.segmentFilterConfig.map(function (item) {
	            return _react2.default.createElement(_materialUi.RadioButton, {
	              className: "filter-widget-radio",
	              style: { whiteSpace: "nowrap" },
	              key: item.value,
	              value: item.value,
	              label: item.label
	            });
	          })
	        );
	      };
	
	      var SegmentFilter2 = function SegmentFilter2() {
	        return _react2.default.createElement(
	          _materialUi.RadioButtonGroup,
	          {
	            name: "event-filter",
	            onChange: _this2.handleSegmentFilter2,
	            valueSelected: _this2.state.filter2State
	          },
	          _this2.props.segmentFilter2Config.map(function (item) {
	            return _react2.default.createElement(_materialUi.RadioButton, {
	              className: "filter-widget-radio",
	              style: { whiteSpace: "nowrap" },
	              key: item.value,
	              value: item.value,
	              label: item.label
	            });
	          })
	        );
	      };
	
	      var LedgerToggle = function LedgerToggle() {
	        var widgetClass = _this2.props.showSegmentFilter || _this2.props.showDateFilter ? "filter-widget-item item-ledger-toggle" : "filter-widget-item item-ledger-toggle first";
	        return _react2.default.createElement(
	          "div",
	          { className: widgetClass },
	          _react2.default.createElement(
	            "div",
	            { className: "filter-widget-item-title" },
	            _this2.props.ledgerToggleTitle ? _this2.props.ledgerToggleTitle : "Ledger data"
	          ),
	          _react2.default.createElement(_materialUi.Toggle, {
	            label: "Use Ledger Data",
	            "data-toggled": _this2.state.useLedger,
	            toggled: _this2.state.useLedger,
	            style: { display: "inline-block", width: 150, float: "left" },
	            onToggle: _this2.handleLedgerToggleChange,
	            name: "ledgerToggle"
	          })
	        );
	      };
	
	      var GenericToggle = function GenericToggle() {
	        var widgetClass = _this2.props.showSegmentFilter || _this2.props.showLedgerToggle && _UserStore2.default.isGod() || _this2.props.showDateFilter ? "filter-widget-item item-ledger-toggle" : "filter-widget-item item-ledger-toggle first";
	        return _react2.default.createElement(
	          "div",
	          { className: widgetClass },
	          _react2.default.createElement(
	            "div",
	            { className: "filter-widget-item-title" },
	            _this2.props.genericToggleTitle ? _this2.props.genericToggleTitle : "Data Toggle"
	          ),
	          _react2.default.createElement(_materialUi.Toggle, {
	            label: _this2.props.genericToggleLabel ? _this2.props.genericToggleLabel : null,
	            "data-toggled": _this2.state.genericToggleOn,
	            toggled: _this2.state.genericToggleOn,
	            style: { display: "inline-block", width: 150, float: "left" },
	            onToggle: _this2.handleGenericToggleChange,
	            name: "genericToggle"
	          })
	        );
	      };
	
	      return _react2.default.createElement(
	        "div",
	        { className: "filter-widget-container" },
	
	        // DATE FILTER
	        this.props.showDateFilter ? _react2.default.createElement(DateFilter, null) : null,
	
	        // SEGMENT FILTER
	        this.props.showSegmentFilter ? _react2.default.createElement(
	          "div",
	          { className: this.props.showDateFilter ? "filter-widget-item" : "filter-widget-item first" },
	          _react2.default.createElement(
	            "div",
	            { className: "segment-filter" },
	            _react2.default.createElement(
	              "div",
	              { className: "filter-widget-item-title" },
	              this.props.segmentFilterTitle ? this.props.segmentFilterTitle : "Segment by"
	            ),
	            _react2.default.createElement(_materialUi.RaisedButton, {
	              label: this.buildSegmentFilterButtonLabel(),
	              onTouchTap: this.onClickPopover,
	              icon: _react2.default.createElement(_arrowDropDown2.default, { viewBox: "5 4 10 20" }),
	              labelPosition: "before"
	            }),
	            _react2.default.createElement(
	              _materialUi.Popover,
	              {
	                open: this.state.popoverOpen,
	                anchorEl: this.state.anchorEl,
	                onRequestClose: this.onClosePopover,
	                className: "segmentedFilterPopover"
	              },
	              _react2.default.createElement(SegmentFilter, null)
	            )
	          )
	        ) : null,
	
	        // SEGMENT FILTER 2
	        this.props.showSegmentFilter2 ? _react2.default.createElement(
	          "div",
	          { className: this.props.showDateFilter || this.props.showSegmentFilter ? "filter-widget-item" : "filter-widget-item first" },
	          _react2.default.createElement(
	            "div",
	            { className: "segment-filter" },
	            _react2.default.createElement(
	              "div",
	              { className: "filter-widget-item-title" },
	              this.props.segmentFilter2Title ? this.props.segmentFilter2Title : "Segment by"
	            ),
	            _react2.default.createElement(_materialUi.RaisedButton, {
	              label: this.buildSegmentFilter2ButtonLabel(),
	              onTouchTap: this.onClickPopover2,
	              icon: _react2.default.createElement(_arrowDropDown2.default, { viewBox: "5 4 10 20" }),
	              labelPosition: "before"
	            }),
	            _react2.default.createElement(
	              _materialUi.Popover,
	              {
	                open: this.state.popover2Open,
	                anchorEl: this.state.anchorEl2,
	                onRequestClose: this.onClosePopover2,
	                className: "segmentedFilter2Popover"
	              },
	              _react2.default.createElement(SegmentFilter2, null)
	            )
	          )
	        ) : null,
	
	        // LEDGER TOGGLE
	        this.props.showLedgerToggle && _UserStore2.default.isGod() ? _react2.default.createElement(LedgerToggle, null) : null,
	
	        // GENERIC TOGGLE
	        this.props.showGenericToggle ? _react2.default.createElement(GenericToggle, null) : null,
	        _react2.default.createElement("div", { className: "clear-both" })
	      );
	    }
	  }]);
	
	  return AnalyticsFilterWidget;
	}(_react2.default.Component);
	
	exports.default = AnalyticsFilterWidget;
	module.exports = exports["default"];

/***/ }),
/* 2296 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = FromCacheCallout;
	function FromCacheCallout(_ref) {
	  var analytics = _ref.analytics;
	
	  return analytics && analytics.fromCache ? React.createElement(
	    "div",
	    {
	      style: {
	        marginBottom: 12,
	        color: "rgba(33, 33, 33, 0.5)",
	        fontStyle: "italic"
	      }
	    },
	    "Showing cached results (last updated",
	    " ",
	    analytics.precomputedAt ? new Date(analytics.precomputedAt).toLocaleString() : "unknown",
	    ")"
	  ) : null;
	}
	module.exports = exports["default"];

/***/ }),
/* 2297 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _moment = __webpack_require__(1021);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _reactEventListener = __webpack_require__(1230);
	
	var _reactEventListener2 = _interopRequireDefault(_reactEventListener);
	
	var _connectToStores = __webpack_require__(1226);
	
	var _connectToStores2 = _interopRequireDefault(_connectToStores);
	
	var _EventBucketStore = __webpack_require__(1593);
	
	var _EventBucketStore2 = _interopRequireDefault(_EventBucketStore);
	
	var _EventBucketActions = __webpack_require__(1218);
	
	var _EventBucketActions2 = _interopRequireDefault(_EventBucketActions);
	
	var _AnalyticsStore = __webpack_require__(1861);
	
	var _AnalyticsStore2 = _interopRequireDefault(_AnalyticsStore);
	
	var _AnalyticsActions = __webpack_require__(1863);
	
	var _AnalyticsActions2 = _interopRequireDefault(_AnalyticsActions);
	
	var _EventStore = __webpack_require__(2032);
	
	var _EventStore2 = _interopRequireDefault(_EventStore);
	
	var _EventActions = __webpack_require__(2031);
	
	var _EventActions2 = _interopRequireDefault(_EventActions);
	
	var _VenueStore = __webpack_require__(2036);
	
	var _VenueStore2 = _interopRequireDefault(_VenueStore);
	
	var _VenueActions = __webpack_require__(2035);
	
	var _VenueActions2 = _interopRequireDefault(_VenueActions);
	
	var _TagStore = __webpack_require__(2039);
	
	var _TagStore2 = _interopRequireDefault(_TagStore);
	
	var _TagActions = __webpack_require__(2038);
	
	var _TagActions2 = _interopRequireDefault(_TagActions);
	
	var _analyticsHeader = __webpack_require__(2293);
	
	var _analyticsHeader2 = _interopRequireDefault(_analyticsHeader);
	
	var _workingIndicator = __webpack_require__(1664);
	
	var _workingIndicator2 = _interopRequireDefault(_workingIndicator);
	
	var _statsBlockContainer = __webpack_require__(1740);
	
	var _statsBlockContainer2 = _interopRequireDefault(_statsBlockContainer);
	
	var _statsBlock = __webpack_require__(1741);
	
	var _statsBlock2 = _interopRequireDefault(_statsBlock);
	
	var _attendeeAnalyticsTable = __webpack_require__(2298);
	
	var _attendeeAnalyticsTable2 = _interopRequireDefault(_attendeeAnalyticsTable);
	
	var _fromCacheCallout = __webpack_require__(2296);
	
	var _fromCacheCallout2 = _interopRequireDefault(_fromCacheCallout);
	
	var _analyticsFilterWidget = __webpack_require__(2295);
	
	var _analyticsFilterWidget2 = _interopRequireDefault(_analyticsFilterWidget);
	
	var _util = __webpack_require__(1183);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AttendeeAnalytics = function (_React$Component) {
	  _inherits(AttendeeAnalytics, _React$Component);
	
	  function AttendeeAnalytics(props) {
	    _classCallCheck(this, AttendeeAnalytics);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(AttendeeAnalytics).call(this, props));
	
	    _this.state = {
	      showRangeEditor: false,
	      allTime: false,
	      range: {
	        key: "selection",
	        startDate: (0, _moment2.default)().subtract(1, "month").format("YYYY-MM-DD"),
	        endDate: (0, _moment2.default)().format("YYYY-MM-DD")
	      },
	      filterState: "all"
	    };
	
	    _this.onWindowClick = _this.onWindowClick.bind(_this);
	    _this.onWindowKeyDown = _this.onWindowKeyDown.bind(_this);
	    _this.handleDateChange = _this.handleDateChange.bind(_this);
	    _this.handleSegmentFilterChange = _this.handleSegmentFilterChange.bind(_this);
	    return _this;
	  }
	
	  _createClass(AttendeeAnalytics, [{
	    key: "onWindowClick",
	    value: function onWindowClick(e) {
	      if (this.state.showRangeEditor && (!this.container || !this.container.contains(e.target) && !this.rangeButton.contains(e.target))) {
	        this.setState({ showRangeEditor: false });
	      }
	    }
	  }, {
	    key: "onWindowKeyDown",
	    value: function onWindowKeyDown(e) {
	      if (this.state.showRangeEditor && e.which === 27) {
	        // esc
	        this.setState({ showRangeEditor: false });
	      }
	    }
	  }, {
	    key: "handleSegmentFilterChange",
	    value: function handleSegmentFilterChange(props) {
	      var _this2 = this;
	
	      this.setState({ filterState: props }, function () {
	        return _this2.componentWillReceiveProps(_this2.props, true);
	      });
	    }
	  }, {
	    key: "handleDateChange",
	    value: function handleDateChange(_ref) {
	      var _this3 = this;
	
	      var range = _ref.range;
	      var allTime = _ref.allTime;
	
	      this.setState({ range: range, allTime: allTime }, function () {
	        return _this3.componentWillReceiveProps(_this3.props, true);
	      });
	    }
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.componentWillReceiveProps(this.props, true);
	    }
	  }, {
	    key: "componentWillMount",
	    value: function componentWillMount() {
	      _EventBucketActions2.default.fetchOne.defer(this.props.params.eventBucketId);
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(newProps) {
	      var force = arguments.length <= 1 || arguments[1] === undefined ? false : arguments[1];
	
	      if (force === true || newProps.params.eventBucketId !== this.props.params.eventBucketId) {
	        _AnalyticsActions2.default.fetchAttendeeAnalytics.defer({
	          eventBucketId: newProps.params.eventBucketId,
	          filterState: this.state.filterState,
	          startDate: !this.state.allTime ? JSON.stringify(this.state.range.startDate) : null,
	          endDate: !this.state.allTime ? JSON.stringify(this.state.range.endDate) : null,
	          allTime: this.state.allTime
	        });
	        _EventActions2.default.fetchAllForBucket.defer(newProps.params.eventBucketId);
	        _VenueActions2.default.fetchAllForBucket.defer(newProps.params.eventBucketId);
	        _TagActions2.default.fetchAllForBucket.defer(newProps.params.eventBucketId);
	        _EventBucketActions2.default.fetchOne.defer(newProps.params.eventBucketId);
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var eventBucketId = this.props.params.eventBucketId;
	
	      if (!eventBucketId) {
	        return _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement(_workingIndicator2.default, { fullPage: true })
	        );
	      }
	      var _props = this.props;
	      var events = _props.events;
	      var tags = _props.tags;
	      var venues = _props.venues;
	      var isFetching = _props.isFetching;
	
	      var eventBucket = this.props.getEventBucketById(eventBucketId);
	      if (!eventBucket) {
	        return _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement(_workingIndicator2.default, { fullPage: true })
	        );
	      }
	      var eventBucketEvents = this.props.getEventsForEventBucket(eventBucketId);
	      var attendeeAnalytics = this.props.getAttendeeAnalytics(eventBucketId);
	      var defaultItemsPerPage = 25;
	
	      return _react2.default.createElement(
	        "div",
	        { className: "attendee-analytics" },
	        _react2.default.createElement(_reactEventListener2.default, {
	          target: "window",
	          onClick: this.onWindowClick,
	          onKeyDown: this.onWindowKeyDown
	        }),
	        _react2.default.createElement(_analyticsHeader2.default, {
	          eventBucket: eventBucket,
	          allEventBuckets: this.props.getEventBuckets(),
	          label: "attendee analytics",
	          subpath: "attendees",
	          query: this.props.location.query,
	          hideHeader: true
	        }),
	        _react2.default.createElement(
	          "h1",
	          { style: { lineHeight: 1.2 } },
	          "\"",
	          eventBucket.name,
	          "\" attendee analytics"
	        ),
	        _react2.default.createElement(_analyticsFilterWidget2.default, {
	          showDateFilter: true,
	          onDateRangeChange: this.handleDateChange,
	          showSegmentFilter: true,
	          onSegmentFilterChange: this.handleSegmentFilterChange,
	          segmentFilterTitle: "Filter by event type",
	          segmentFilterSelected: this.state.filterState,
	          segmentFilterConfig: [{
	            value: "all",
	            label: "All Events"
	          }, {
	            value: "physical",
	            label: "Physical Events"
	          }, {
	            value: "virtual",
	            label: "Virtual Events"
	          }, {
	            value: "undatedEvents",
	            label: "Undated Events"
	          }]
	        }),
	        _react2.default.createElement(_fromCacheCallout2.default, { analytics: attendeeAnalytics }),
	        !attendeeAnalytics || !eventBucket || eventBucketEvents.length === 0 && isFetching || this.props.isFetching || this.props.getIsFetchingAttendeeAnalytics() ? _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement(_workingIndicator2.default, { fullPage: true })
	        ) : _react2.default.createElement(
	          "div",
	          { style: { position: "relative" } },
	          _react2.default.createElement(
	            "div",
	            {
	              style: {
	                width: "100%",
	                display: "flex"
	              } },
	            _react2.default.createElement(
	              "p",
	              null,
	              "Scroll down to view attendance ",
	              _react2.default.createElement(
	                "a",
	                { href: "#by-event" },
	                "by event"
	              ),
	              ",",
	              " ",
	              _react2.default.createElement(
	                "a",
	                { href: "#by-venue" },
	                "by venue"
	              ),
	              ", ",
	              _react2.default.createElement(
	                "a",
	                { href: "#by-tag" },
	                "by tag"
	              ),
	              ", and",
	              " ",
	              _react2.default.createElement(
	                "a",
	                { href: "#by-date" },
	                "by date"
	              ),
	              "."
	            )
	          ),
	          _react2.default.createElement(
	            _statsBlockContainer2.default,
	            { style: { marginTop: -10 } },
	            _react2.default.createElement(_statsBlock2.default, {
	              value: (0, _util.formatNumber)(attendeeAnalytics.unique_count),
	              label: _react2.default.createElement(
	                "span",
	                null,
	                "Unique attendees",
	                " ",
	                _react2.default.createElement(
	                  "a",
	                  {
	                    href: "https://help.eventive.org/analyzing-your-data/what-are-unique-attendees",
	                    target: "_blank",
	                    style: { textDecoration: "none" }
	                  },
	                  "(?)"
	                )
	              )
	            }),
	            _react2.default.createElement(_statsBlock2.default, {
	              value: (0, _util.formatNumber)(attendeeAnalytics.unique_used_count)
	              /*subvalue={`${(attendeeAnalytics.unique_used_count / attendeeAnalytics.unique_count * 100).toFixed(2)}%)`}*/
	              , label: "Unique scanned attendees"
	            }),
	            _react2.default.createElement(_statsBlock2.default, {
	              value: (0, _util.formatNumber)(attendeeAnalytics.total_count),
	              label: "Tickets issued"
	            }),
	            _react2.default.createElement(_statsBlock2.default, {
	              value: (0, _util.formatNumber)(attendeeAnalytics.total_used_count)
	              /*subvalue={`${(attendeeAnalytics.total_used_count / attendeeAnalytics.total_count * 100).toFixed(2)}%`}*/
	              , label: "Tickets scanned"
	            })
	          ),
	          _react2.default.createElement("a", { className: "anchor--fixed_header_offset", id: "by-event" }),
	          _react2.default.createElement(
	            "div",
	            { className: "analytics-element" },
	            _react2.default.createElement(
	              "h2",
	              { style: { marginTop: "1em", marginBottom: "0.5em" } },
	              "Attendance by event(scanned / total)"
	            ),
	            _react2.default.createElement(_attendeeAnalyticsTable2.default, {
	              eventBucket: eventBucket,
	              events: events,
	              data: attendeeAnalytics.by_event,
	              itemsPerPage: defaultItemsPerPage,
	              groupBy: "event",
	              tableFilter: true
	            })
	          ),
	          _react2.default.createElement("a", { className: "anchor--fixed_header_offset", id: "by-venue" }),
	          _react2.default.createElement(
	            "div",
	            { className: "analytics-element" },
	            _react2.default.createElement(
	              "h2",
	              { style: { marginTop: "1em", marginBottom: "0.5em" } },
	              "Attendance by venue (scanned / total)"
	            ),
	            _react2.default.createElement(_attendeeAnalyticsTable2.default, {
	              eventBucket: eventBucket,
	              venues: venues,
	              events: events,
	              itemsPerPage: defaultItemsPerPage,
	              groupBy: "venue",
	              data: attendeeAnalytics.by_event
	            })
	          ),
	          _react2.default.createElement("a", { className: "anchor--fixed_header_offset", id: "by-tag" }),
	          _react2.default.createElement(
	            "div",
	            { className: "analytics-element" },
	            _react2.default.createElement(
	              "h2",
	              { style: { marginTop: "1em", marginBottom: "0.5em" } },
	              "Attendance by tag (scanned / total)"
	            ),
	            _react2.default.createElement(_attendeeAnalyticsTable2.default, {
	              eventBucket: eventBucket,
	              tags: tags,
	              events: events,
	              itemsPerPage: defaultItemsPerPage,
	              groupBy: "tag",
	              data: attendeeAnalytics.by_event
	            })
	          ),
	          _react2.default.createElement("a", { className: "anchor--fixed_header_offset", id: "by-date" }),
	          _react2.default.createElement(
	            "div",
	            { className: "analytics-element" },
	            _react2.default.createElement(
	              "h2",
	              { style: { marginTop: "1em", marginBottom: "0.5em" } },
	              "Attendance by date (scanned / total)"
	            ),
	            _react2.default.createElement(_attendeeAnalyticsTable2.default, {
	              eventBucket: eventBucket,
	              tags: tags,
	              events: events,
	              itemsPerPage: defaultItemsPerPage,
	              groupBy: "date",
	              data: attendeeAnalytics.by_event
	            })
	          )
	        )
	      );
	    }
	  }], [{
	    key: "getStores",
	    value: function getStores() {
	      return [_EventBucketStore2.default, _EventStore2.default, _AnalyticsStore2.default];
	    }
	  }, {
	    key: "getPropsFromStores",
	    value: function getPropsFromStores() {
	      var eventState = _EventStore2.default.getState();
	      var venueState = _VenueStore2.default.getState();
	      var tagState = _TagStore2.default.getState();
	
	      return {
	        getEventBuckets: _EventBucketStore2.default.getEventBuckets,
	        getEventBucketById: _EventBucketStore2.default.getEventBucketById,
	        events: eventState.events,
	        venues: venueState.venues,
	        tags: tagState.tags,
	        isFetching: eventState.isFetching || venueState.isFetching || tagState.isFetching,
	        getIsFetchingAttendeeAnalytics: _AnalyticsStore2.default.getIsFetchingAttendeeAnalytics,
	        getEventsForEventBucket: _EventStore2.default.getEventsForEventBucket,
	        getAttendeeAnalytics: _AnalyticsStore2.default.getAttendeeAnalytics
	      };
	    }
	  }]);
	
	  return AttendeeAnalytics;
	}(_react2.default.Component);
	
	AttendeeAnalytics.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	exports.default = (0, _connectToStores2.default)(AttendeeAnalytics);
	module.exports = exports["default"];

/***/ }),
/* 2298 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _momentTimezone = __webpack_require__(1185);
	
	var _momentTimezone2 = _interopRequireDefault(_momentTimezone);
	
	var _reactRouter = __webpack_require__(486);
	
	var _reactable = __webpack_require__(1688);
	
	var _materialUi = __webpack_require__(576);
	
	var _inlineLinkIconButton = __webpack_require__(1704);
	
	var _inlineLinkIconButton2 = _interopRequireDefault(_inlineLinkIconButton);
	
	var _util = __webpack_require__(1183);
	
	var util = _interopRequireWildcard(_util);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AttendeeAnalyticsTable = function (_React$Component) {
	  _inherits(AttendeeAnalyticsTable, _React$Component);
	
	  function AttendeeAnalyticsTable(props) {
	    _classCallCheck(this, AttendeeAnalyticsTable);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(AttendeeAnalyticsTable).call(this, props));
	
	    _this._makeRow = _this._makeRow.bind(_this);
	    return _this;
	  }
	
	  _createClass(AttendeeAnalyticsTable, [{
	    key: "_makeRow",
	    value: function _makeRow(eventBucket, id, data) {
	      var _this2 = this;
	
	      var options = arguments.length <= 3 || arguments[3] === undefined ? {} : arguments[3];
	
	      var noWrapTdStyle = { whiteSpace: "nowrap" };
	
	      return _react2.default.createElement(
	        _reactable.Tr,
	        { key: id },
	        options.event ? _react2.default.createElement(
	          _reactable.Td,
	          { column: "Event", value: options.event.name },
	          _react2.default.createElement(
	            "span",
	            null,
	            options.event.name,
	            options.event.id && _react2.default.createElement(_inlineLinkIconButton2.default, {
	              onTouchTap: function onTouchTap() {
	                _this2.context.router.push("/event_buckets/" + eventBucket + "/events/" + options.event.id);
	              },
	              tooltip: "View event"
	            })
	          )
	        ) : options.venue ? _react2.default.createElement(
	          _reactable.Td,
	          { column: "Venue", value: options.venue.name },
	          _react2.default.createElement(
	            "span",
	            null,
	            options.venue.name,
	            options.venue.id && _react2.default.createElement(_inlineLinkIconButton2.default, {
	              onTouchTap: function onTouchTap() {
	                _this2.context.router.push("/event_buckets/" + eventBucket + "/venues/" + options.venue.id);
	              },
	              tooltip: "View venue"
	            })
	          )
	        ) : options.tag ? _react2.default.createElement(
	          _reactable.Td,
	          { column: "Tag", value: options.tag.name },
	          _react2.default.createElement(
	            "span",
	            null,
	            options.tag.name,
	            options.tag.id && _react2.default.createElement(_inlineLinkIconButton2.default, {
	              onTouchTap: function onTouchTap() {
	                _this2.context.router.push("/event_buckets/" + eventBucket + "/tags/" + options.tag.id);
	              },
	              tooltip: "View tag"
	            })
	          )
	        ) : options.date ? _react2.default.createElement(
	          _reactable.Td,
	          { column: "Date", value: options.date },
	          _react2.default.createElement(
	            "span",
	            null,
	            (0, _momentTimezone2.default)(options.date, "YYYY-MM-DD").format("ddd, MMM D, YYYY")
	          )
	        ) : null,
	        options.eventVenue // add "Venue Name" column for the "by events" table.
	        ? _react2.default.createElement(
	          _reactable.Td,
	          { column: "Venue Name", value: options.eventVenue.name },
	          _react2.default.createElement(
	            "span",
	            null,
	            options.eventVenue.name,
	            options.eventVenue.id && _react2.default.createElement(_inlineLinkIconButton2.default, {
	              onTouchTap: function onTouchTap() {
	                _this2.context.router.push("/event_buckets/" + eventBucket + "/venues/" + options.eventVenue.id);
	              },
	              tooltip: "View venue"
	            })
	          )
	        ) : null,
	        _react2.default.createElement(
	          _reactable.Td,
	          {
	            column: "Passholder",
	            value: data.passholder_used,
	            style: noWrapTdStyle
	          },
	          data.passholder_used + " / " + data.passholder
	        ),
	        _react2.default.createElement(
	          _reactable.Td,
	          {
	            column: "Standalone",
	            value: data.standalone_used,
	            style: noWrapTdStyle
	          },
	          data.standalone_used + " / " + data.standalone
	        ),
	        _react2.default.createElement(
	          _reactable.Td,
	          {
	            column: "Box Office",
	            value: data.unaffiliated_used,
	            style: noWrapTdStyle
	          },
	          data.unaffiliated_used + " / " + data.unaffiliated
	        ),
	        _react2.default.createElement(
	          _reactable.Td,
	          { column: "Total", value: data.total_used, style: noWrapTdStyle },
	          data.total_used + " / " + data.total
	        ),
	        _react2.default.createElement(
	          _reactable.Td,
	          {
	            column: "Scan %",
	            value: data.total_used / data.total * 100,
	            style: noWrapTdStyle
	          },
	          (data.total_used / data.total * 100).toFixed(2) + "%"
	        )
	      );
	    }
	  }, {
	    key: "downloadCsv",
	    value: function downloadCsv(data, events) {
	      util.clientSideDownload("attendee-analytics-" + util.snakeCase(this.props.eventBucket.name) + ".csv", "text/csv", util.makeCsv([["Event", "Venue", "Passholder", "Passholder scanned", "Standalone", "Standalone scanned", "No Acct/Rush", "No Acct/Rush scanned", "Total", "Total used", "Scan percent"]].concat(Object.keys(data).map(function (id) {
	        return [events[id] ? events[id].name : "Deleted event", events[id] && events[id].venue && events[id].venue.name ? events[id].venue.name : null, data[id].passholder, data[id].passholder_used, data[id].standalone, data[id].standalone_used, data[id].unaffiliated, data[id].unaffiliated_used, data[id].total, data[id].total_used, (data[id].total_used / data[id].total * 100).toFixed(2) + "%"];
	      }))));
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this3 = this;
	
	      var _props = this.props;
	      var data = _props.data;
	      var eventBucket = _props.eventBucket;
	      var groupBy = _props.groupBy;
	      var events = _props.events;
	      var venues = _props.venues;
	      var tags = _props.tags;
	      var paginateTable = _props.paginateTable;
	      var itemsPerPage = _props.itemsPerPage;
	      var tableFilter = _props.tableFilter;
	      var rows = void 0;
	
	      var defaultItemsPerPage = 25;
	      var itemsPer = itemsPerPage ? itemsPerPage : defaultItemsPerPage;
	
	      if (groupBy === "venue") {
	        (function () {
	          var byVenue = {};
	          Object.keys(data).map(function (id) {
	            var event = events[id] || { venue: { id: "undefined" } };
	            if (!byVenue[event.venue.id]) {
	              byVenue[event.venue.id] = {};
	            }
	            Object.keys(data[id]).forEach(function (k) {
	              byVenue[event.venue.id][k] = (byVenue[event.venue.id][k] || 0) + data[id][k];
	            });
	          });
	          rows = Object.keys(byVenue).map(function (id) {
	            return _this3._makeRow(eventBucket.id, id, byVenue[id], {
	              venue: venues[id] || { name: "No venue" }
	            });
	          });
	        })();
	      } else if (groupBy === "tag") {
	        (function () {
	          var byTag = {};
	
	          Object.keys(data).map(function (id) {
	            var event = events[id] || { tags: [] };
	            (event.tags.length ? event.tags : [{}]).forEach(function (tag) {
	              if (!byTag[tag.id]) {
	                byTag[tag.id] = {};
	              }
	              Object.keys(data[id]).forEach(function (k) {
	                byTag[tag.id][k] = (byTag[tag.id][k] || 0) + data[id][k];
	              });
	            });
	          });
	          rows = Object.keys(byTag).map(function (id) {
	            return _this3._makeRow(eventBucket.id, id, byTag[id], {
	              tag: tags[id] || { name: "No tag" }
	            });
	          });
	        })();
	      } else if (groupBy === "date") {
	        (function () {
	          var byDate = {};
	
	          Object.keys(data).map(function (id) {
	            var event = events[id] || { start_time: new Date().toISOString() };
	            var key = (0, _momentTimezone2.default)(event.start_time).format("YYYY-MM-DD");
	            if (!byDate[key]) {
	              byDate[key] = {};
	            }
	            Object.keys(data[id]).forEach(function (k) {
	              byDate[key][k] = (byDate[key][k] || 0) + data[id][k];
	            });
	          });
	          rows = Object.keys(byDate).map(function (id) {
	            return _this3._makeRow(eventBucket.id, id, byDate[id], { date: id });
	          });
	        })();
	      } else if (groupBy === "event") {
	        rows = Object.keys(data).map(function (id) {
	          var venue = events[id] ? events[id].venue : null;
	          var eventVenue = venue && venue.name ? venue : null;
	
	          return _this3._makeRow(eventBucket.id, id, data[id], {
	            event: events[id] || { name: "Deleted event" },
	            eventVenue: eventVenue
	          });
	        });
	      } else {
	        rows = Object.keys(data).map(function (id) {
	          return _this3._makeRow(eventBucket.id, id, data[id], {
	            event: events[id] || { name: "Deleted event" }
	          });
	        });
	      }
	
	      var primaryColumn = groupBy === "venue" ? "Venue" : groupBy === "tag" ? "Tag" : groupBy === "date" ? "Date" : groupBy === "event" ? "Event" : "Event";
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          _reactable.Table,
	          {
	            className: itemsPerPage ? "bordered striped responsive-table paginateTable" : "bordered striped responsive-table",
	            sortable: groupBy === "event" ? [primaryColumn, "Venue Name", "Passholder", "Standalone", "Box Office", "Total", "Scan %"] : [primaryColumn, "Passholder", "Standalone", "Box Office", "Total", "Scan %"],
	            defaultSort: groupBy === "date" ? { column: "Date", direction: "asc" } : { column: "Total", direction: "desc" },
	            columns: groupBy === "event" ? [primaryColumn, "Venue Name", "Passholder", "Standalone", { key: "Box Office", label: "No Acct/Rush" }, "Total", "Scan %"] : [primaryColumn, "Passholder", "Standalone", { key: "Box Office", label: "No Acct/Rush" }, "Total", "Scan %"],
	            itemsPerPage: itemsPer,
	            previousPageLabel: '<<',
	            nextPageLabel: '>>',
	            filterable: tableFilter && tableFilter !== null ? [primaryColumn] : undefined,
	            filterPlaceholder: "Type to filter..."
	
	          },
	          rows
	        ),
	        rows.length === 0 ? _react2.default.createElement(
	          "div",
	          { className: "empty-table-message" },
	          "No data available."
	        ) : null,
	        groupBy === "event" ? _react2.default.createElement(_materialUi.RaisedButton, {
	          style: { marginTop: "1em" },
	          label: "Download (.csv)",
	          onTouchTap: function onTouchTap() {
	            return _this3.downloadCsv(data, events);
	          }
	        }) : null
	      );
	    }
	  }], [{
	    key: "contextTypes",
	    get: function get() {
	      return {
	        router: _react2.default.PropTypes.object
	      };
	    }
	  }]);
	
	  return AttendeeAnalyticsTable;
	}(_react2.default.Component);
	
	AttendeeAnalyticsTable.defaultProps = {
	  groupBy: "event"
	};
	
	exports.default = AttendeeAnalyticsTable;
	module.exports = exports["default"];

/***/ }),
/* 2299 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _connectToStores = __webpack_require__(1226);
	
	var _connectToStores2 = _interopRequireDefault(_connectToStores);
	
	var _EventBucketStore = __webpack_require__(1593);
	
	var _EventBucketStore2 = _interopRequireDefault(_EventBucketStore);
	
	var _EventBucketActions = __webpack_require__(1218);
	
	var _EventBucketActions2 = _interopRequireDefault(_EventBucketActions);
	
	var _AnalyticsStore = __webpack_require__(1861);
	
	var _AnalyticsStore2 = _interopRequireDefault(_AnalyticsStore);
	
	var _AnalyticsActions = __webpack_require__(1863);
	
	var _AnalyticsActions2 = _interopRequireDefault(_AnalyticsActions);
	
	var _analyticsHeader = __webpack_require__(2293);
	
	var _analyticsHeader2 = _interopRequireDefault(_analyticsHeader);
	
	var _workingIndicator = __webpack_require__(1664);
	
	var _workingIndicator2 = _interopRequireDefault(_workingIndicator);
	
	var _geoAnalyticsTable = __webpack_require__(2300);
	
	var _geoAnalyticsTable2 = _interopRequireDefault(_geoAnalyticsTable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BEGINNING_OF_GEOANALYTICS_DATE = new Date(2017, 7, 24); // Aug 24, 2017
	
	var GeoAnalytics = function (_React$Component) {
	  _inherits(GeoAnalytics, _React$Component);
	
	  function GeoAnalytics() {
	    _classCallCheck(this, GeoAnalytics);
	
	    return _possibleConstructorReturn(this, Object.getPrototypeOf(GeoAnalytics).apply(this, arguments));
	  }
	
	  _createClass(GeoAnalytics, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.componentWillReceiveProps(this.props, true);
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(newProps) {
	      var force = arguments.length <= 1 || arguments[1] === undefined ? false : arguments[1];
	
	      if (force === true || newProps.params.eventBucketId !== this.props.params.eventBucketId) {
	        _AnalyticsActions2.default.fetchGeoAnalytics.defer(newProps.params.eventBucketId);
	        _EventBucketActions2.default.fetchOne.defer(newProps.params.eventBucketId);
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var eventBucketId = this.props.params.eventBucketId;
	      var eventBucket = this.props.getEventBucketById(eventBucketId);
	      var geoAnalytics = this.props.getGeoAnalytics(eventBucketId);
	
	      if (!geoAnalytics || !eventBucket) {
	        return _react2.default.createElement(_workingIndicator2.default, { fullPage: true });
	      }
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(_analyticsHeader2.default, {
	          eventBucket: eventBucket,
	          allEventBuckets: this.props.getEventBuckets(),
	          label: "geo analytics",
	          subpath: "geo"
	        }),
	        new Date(eventBucket.created_at) < BEGINNING_OF_GEOANALYTICS_DATE ? _react2.default.createElement(
	          "p",
	          { style: { fontStyle: "italic" } },
	          "Note: Geo analytics data only includes orders placed after August 23, 2017."
	        ) : null,
	        _react2.default.createElement(
	          "div",
	          { className: "analytics-element" },
	          _react2.default.createElement(
	            "h2",
	            { style: { marginTop: "1em", marginBottom: "0.5em" } },
	            "Web orders by postal code"
	          ),
	          _react2.default.createElement(_geoAnalyticsTable2.default, {
	            eventBucket: eventBucket,
	            data: geoAnalytics.by_postal_code
	          })
	        )
	      );
	    }
	  }], [{
	    key: "getStores",
	    value: function getStores() {
	      return [_EventBucketStore2.default, _AnalyticsStore2.default];
	    }
	  }, {
	    key: "getPropsFromStores",
	    value: function getPropsFromStores() {
	      return {
	        getEventBuckets: _EventBucketStore2.default.getEventBuckets,
	        getEventBucketById: _EventBucketStore2.default.getEventBucketById,
	        getGeoAnalytics: _AnalyticsStore2.default.getGeoAnalytics
	      };
	    }
	  }]);
	
	  return GeoAnalytics;
	}(_react2.default.Component);
	
	exports.default = (0, _connectToStores2.default)(GeoAnalytics);
	module.exports = exports["default"];

/***/ }),
/* 2300 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _moment = __webpack_require__(1021);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _reactRouter = __webpack_require__(486);
	
	var _reactable = __webpack_require__(1688);
	
	var _materialUi = __webpack_require__(576);
	
	var _util = __webpack_require__(1183);
	
	var util = _interopRequireWildcard(_util);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var GeoAnalyticsTable = function (_React$Component) {
	  _inherits(GeoAnalyticsTable, _React$Component);
	
	  function GeoAnalyticsTable(props) {
	    _classCallCheck(this, GeoAnalyticsTable);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(GeoAnalyticsTable).call(this, props));
	
	    _this._makeRow = _this._makeRow.bind(_this);
	    return _this;
	  }
	
	  _createClass(GeoAnalyticsTable, [{
	    key: "_makeRow",
	    value: function _makeRow(data) {
	      var noWrapTdStyle = { whiteSpace: "nowrap" };
	
	      return _react2.default.createElement(
	        _reactable.Tr,
	        { key: data.postal },
	        _react2.default.createElement(
	          _reactable.Td,
	          { column: "Postal code", value: data.postal, style: noWrapTdStyle },
	          "" + data.postal + (data.city ? " (" + data.city + ", " + data.region + ", " + data.country_name + ")" : "")
	        ),
	        _react2.default.createElement(
	          _reactable.Td,
	          {
	            column: "Total volume",
	            value: data.total_volume,
	            style: noWrapTdStyle
	          },
	          util.formatPrice(data.total_volume)
	        ),
	        _react2.default.createElement(
	          _reactable.Td,
	          {
	            column: "Total tickets",
	            value: data.total_tickets,
	            style: noWrapTdStyle
	          },
	          util.formatNumber(data.total_tickets)
	        ),
	        _react2.default.createElement(
	          _reactable.Td,
	          {
	            column: "Total passes",
	            value: data.total_passes,
	            style: noWrapTdStyle
	          },
	          util.formatNumber(data.total_passes)
	        ),
	        _react2.default.createElement(
	          _reactable.Td,
	          {
	            column: "Total unique customers",
	            value: data.total_people,
	            style: noWrapTdStyle
	          },
	          util.formatNumber(data.total_people)
	        )
	      );
	    }
	  }, {
	    key: "downloadCsv",
	    value: function downloadCsv(data) {
	      util.clientSideDownload("geo-analytics-" + util.snakeCase(this.props.eventBucket.name) + ".csv", "text/csv", util.makeCsv([["Postal code", "City", "Region", "Country", "Total volume", "Total tickets", "Total passes", "Total unique customers"]].concat(data.map(function (d) {
	        return [d.postal, d.city, d.region, d.country_name, d.total_volume / 100, d.total_tickets, d.total_passes, d.total_people];
	      }))));
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props;
	      var data = _props.data;
	      var itemsPerPage = _props.itemsPerPage;
	      var rows = data.map(this._makeRow);
	
	      var defaultItemsPerPage = 25;
	      var itemsPer = itemsPerPage ? itemsPerPage : defaultItemsPerPage;
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          _reactable.Table,
	          {
	            className: "bordered striped responsive-table",
	            sortable: ["Postal code", "Total volume", "Total tickets", "Total passes", "Total unique customers"],
	            defaultSort: { column: "Total volume", direction: "desc" },
	            columns: ["Postal code", "Total volume", "Total tickets", "Total passes", "Total unique customers"],
	            itemsPerPage: itemsPer
	          },
	          rows
	        ),
	        rows.length === 0 ? _react2.default.createElement(
	          "div",
	          { className: "empty-table-message" },
	          "No web orders with geo data yet."
	        ) : null,
	        _react2.default.createElement(_materialUi.RaisedButton, {
	          style: { marginTop: "1em" },
	          label: "Download (.csv)",
	          onTouchTap: function onTouchTap() {
	            return _this2.downloadCsv(data);
	          }
	        })
	      );
	    }
	  }]);
	
	  return GeoAnalyticsTable;
	}(_react2.default.Component);
	
	exports.default = GeoAnalyticsTable;
	module.exports = exports["default"];

/***/ }),
/* 2301 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _radium = __webpack_require__(1600);
	
	var _radium2 = _interopRequireDefault(_radium);
	
	var _connectToStores = __webpack_require__(1226);
	
	var _connectToStores2 = _interopRequireDefault(_connectToStores);
	
	var _EventBucketStore = __webpack_require__(1593);
	
	var _EventBucketStore2 = _interopRequireDefault(_EventBucketStore);
	
	var _EventBucketActions = __webpack_require__(1218);
	
	var _EventBucketActions2 = _interopRequireDefault(_EventBucketActions);
	
	var _AnalyticsStore = __webpack_require__(1861);
	
	var _AnalyticsStore2 = _interopRequireDefault(_AnalyticsStore);
	
	var _AnalyticsActions = __webpack_require__(1863);
	
	var _AnalyticsActions2 = _interopRequireDefault(_AnalyticsActions);
	
	var _analyticsHeader = __webpack_require__(2293);
	
	var _analyticsHeader2 = _interopRequireDefault(_analyticsHeader);
	
	var _workingIndicator = __webpack_require__(1664);
	
	var _workingIndicator2 = _interopRequireDefault(_workingIndicator);
	
	var _genericAnalyticsTable = __webpack_require__(1687);
	
	var _genericAnalyticsTable2 = _interopRequireDefault(_genericAnalyticsTable);
	
	var _fromCacheCallout = __webpack_require__(2296);
	
	var _fromCacheCallout2 = _interopRequireDefault(_fromCacheCallout);
	
	var _analyticsFilterWidget = __webpack_require__(2295);
	
	var _analyticsFilterWidget2 = _interopRequireDefault(_analyticsFilterWidget);
	
	var _moment = __webpack_require__(1021);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _util = __webpack_require__(1183);
	
	var util = _interopRequireWildcard(_util);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _color = function _color(percent) {
	  return percent < 0.5 ? "#f44336" : percent < 0.75 ? "#ff9800" : percent < 0.85 ? "#8bc34a" : "#4caf50";
	};
	
	var EventTicketAnalytics = function (_React$Component) {
	  _inherits(EventTicketAnalytics, _React$Component);
	
	  function EventTicketAnalytics(props) {
	    _classCallCheck(this, EventTicketAnalytics);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(EventTicketAnalytics).call(this, props));
	
	    _this.state = {
	      groupByTicketBucket: false,
	      showRangeEditor: false,
	      allTime: false,
	      range: {
	        key: "selection",
	        startDate: (0, _moment2.default)().subtract(1, "month").format("YYYY-MM-DD"),
	        endDate: (0, _moment2.default)().format("YYYY-MM-DD")
	      },
	      segmentFilterBy: "default",
	      segmentFilter2By: "all"
	    };
	
	    _this.onWindowClick = _this.onWindowClick.bind(_this);
	    _this.onWindowKeyDown = _this.onWindowKeyDown.bind(_this);
	    _this.handleSegmentFilterChange = _this.handleSegmentFilterChange.bind(_this);
	    _this.handleSegmentFilter2Change = _this.handleSegmentFilter2Change.bind(_this);
	    _this.handleDateChange = _this.handleDateChange.bind(_this);
	    return _this;
	  }
	
	  _createClass(EventTicketAnalytics, [{
	    key: "onWindowClick",
	    value: function onWindowClick(e) {
	      if (this.state.showRangeEditor && (!this.container || !this.container.contains(e.target) && !this.rangeButton.contains(e.target))) {
	        this.setState({ showRangeEditor: false });
	      }
	    }
	  }, {
	    key: "onWindowKeyDown",
	    value: function onWindowKeyDown(e) {
	      if (this.state.showRangeEditor && e.which === 27) {
	        // esc
	        this.setState({ showRangeEditor: false });
	      }
	    }
	
	    // default / ticket_bucket
	
	  }, {
	    key: "handleSegmentFilterChange",
	    value: function handleSegmentFilterChange(props) {
	      var _this2 = this;
	
	      this.setState({
	        segmentFilterBy: props,
	        groupByTicketBucket: props === "default" ? false : true
	      }, function () {
	        return _this2.componentWillReceiveProps(_this2.props, true);
	      });
	    }
	
	    // default / ticket_bucket
	
	  }, {
	    key: "handleSegmentFilter2Change",
	    value: function handleSegmentFilter2Change(props) {
	      var _this3 = this;
	
	      this.setState({ segmentFilter2By: props }, function () {
	        return _this3.componentWillReceiveProps(_this3.props, true);
	      });
	    }
	  }, {
	    key: "handleDateChange",
	    value: function handleDateChange(_ref) {
	      var _this4 = this;
	
	      var range = _ref.range;
	      var allTime = _ref.allTime;
	
	      this.setState({ range: range, allTime: allTime }, function () {
	        return _this4.componentWillReceiveProps(_this4.props, true);
	      });
	    }
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.componentWillReceiveProps(this.props, true);
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(newProps) {
	      var force = arguments.length <= 1 || arguments[1] === undefined ? false : arguments[1];
	
	      if (force === true || newProps.params.eventBucketId !== this.props.params.eventBucketId) {
	        _AnalyticsActions2.default.fetchEventTicketAnalytics.defer({
	          eventBucketId: newProps.params.eventBucketId,
	          filter2state: this.state.segmentFilter2By,
	          startDate: !this.state.allTime ? JSON.stringify(this.state.range.startDate) : null,
	          endDate: !this.state.allTime ? JSON.stringify(this.state.range.endDate) : null,
	          allTime: this.state.allTime
	        });
	        if (newProps.params.eventBucketId !== this.props.params.eventBucketId) {
	          _EventBucketActions2.default.fetchOne.defer(newProps.params.eventBucketId);
	        }
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var eventBucketId = this.props.params.eventBucketId;
	
	      var eventBucket = this.props.getEventBucketById(eventBucketId);
	      var eventTicketAnalytics = this.props.getEventTicketAnalytics(eventBucketId);
	      var defaultItemsPerPage = 25;
	
	      if (!eventTicketAnalytics || !eventBucket) {
	        return _react2.default.createElement(_workingIndicator2.default, { fullPage: true });
	      }
	
	      var data = eventTicketAnalytics.data.sort(function (a, b) {
	        return (a.event.start_time || "").localeCompare(b.event.start_time || "");
	      });
	
	      var ticketBucketColumns = void 0;
	      if (this.state.groupByTicketBucket) {
	        (function () {
	          var bucketNames = [];
	          data.forEach(function (event) {
	            if (event.by_ticket_bucket) {
	              Object.keys(event.by_ticket_bucket).map(function (ticketBucketName) {
	                if (bucketNames.indexOf(ticketBucketName) === -1) {
	                  bucketNames.push(ticketBucketName);
	                }
	              });
	            }
	          });
	          bucketNames.sort(function (a, b) {
	            if (a === "Deleted ticket bucket") {
	              return 1;
	            } else if (b === "Deleted ticket bucket") {
	              return -1;
	            }
	            return a.localeCompare(b);
	          });
	          ticketBucketColumns = bucketNames.map(function (ticketBucketName) {
	            return {
	              label: ticketBucketName,
	              value: function value(d) {
	                if (d && d.by_ticket_bucket && d.by_ticket_bucket[ticketBucketName]) {
	                  var _d$by_ticket_bucket$t = d.by_ticket_bucket[ticketBucketName];
	                  var capacity = _d$by_ticket_bucket$t.capacity;
	                  var sold = _d$by_ticket_bucket$t.sold;
	                  var unlimited = _d$by_ticket_bucket$t.unlimited;
	
	                  return sold + " / " + (unlimited ? "∞" : capacity);
	                } else {
	                  return "–";
	                }
	              }
	            };
	          });
	        })();
	      }
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(_analyticsHeader2.default, {
	          eventBucket: eventBucket,
	          allEventBuckets: this.props.getEventBuckets(),
	          label: "event analytics",
	          subpath: "events",
	          query: this.props.location.query
	          // onRefresh={() => this.componentWillReceiveProps(this.props, true)}
	          // isRefreshing={this.props.isFetching}
	        }),
	        _react2.default.createElement(_fromCacheCallout2.default, { analytics: eventTicketAnalytics }),
	        _react2.default.createElement(_analyticsFilterWidget2.default, {
	          showDateFilter: true,
	          onDateRangeChange: this.handleDateChange,
	
	          showSegmentFilter: true,
	          onSegmentFilterChange: this.handleSegmentFilterChange,
	          segmentFilterTitle: "Group counts by",
	          segmentFilterSelected: this.state.segmentFilterBy,
	          segmentFilterConfig: [{
	            value: "default",
	            label: "Sold / paid / pass / comp"
	          }, {
	            value: "ticket_bucket",
	            label: "Ticket bucket"
	          }],
	
	          showSegmentFilter2: true,
	          onSegmentFilter2Change: this.handleSegmentFilter2Change,
	          segmentFilter2Title: "Group by",
	          segmentFilter2Selected: this.state.segmentFilter2By,
	          segmentFilter2Config: [{
	            value: "all",
	            label: "All Events"
	          }, {
	            value: "physical",
	            label: "Physical Events"
	          }, {
	            value: "virtual",
	            label: "Virtual Events"
	          }, {
	            value: "undatedEvents",
	            label: "Undated Events"
	          }]
	
	        }),
	        this.props.isFetching ? _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement(_workingIndicator2.default, { fullPage: true })
	        ) : _react2.default.createElement(
	          "div",
	          { className: "analytics-element" },
	          _react2.default.createElement(_genericAnalyticsTable2.default, {
	            eventBucket: eventBucket,
	            csvLabel: "event-analytics",
	            showPdfDownload: true,
	            pdfFilename: util.snakeCase(eventBucket.name + " analytics"),
	            pdfTitle: eventBucket.name + " analytics",
	            defaultSort: "Date",
	            defaultSortInvert: true,
	            itemsPerPage: defaultItemsPerPage,
	            columns: [{ label: "Event", value: "event" }, { label: "Venue", value: "venue", style: { whiteSpace: "nowrap" } }, { label: "Date", value: "date", style: { whiteSpace: "nowrap" } }, { label: "Capacity", value: "capacity" }].concat(this.state.groupByTicketBucket ? ticketBucketColumns : [{ label: "Sold", value: "sold" }, { label: "Paid", value: "paid" }, { label: "Pass", value: "pass" }, { label: "Comp", value: "comp" }]).concat([{ label: "Percent sold", value: "percent_sold" }]).concat(eventTicketAnalytics.data.some(function (d) {
	              return d.hidden_capacity;
	            }) ? [{ label: "Hidden capacity", value: "hidden_capacity" }] : []),
	            data: data.map(function (d) {
	              return {
	                event: {
	                  label: d.event.name,
	                  value: d.event.name,
	                  itemClass: "data-limit"
	                },
	                venue: d.event.venue ? { label: d.event.venue.name, value: d.event.venue.name, itemClass: "data-limit" } : "–",
	                date: {
	                  label: d.event.start_time ? (0, _moment2.default)(d.event.start_time).format("llll") : "–",
	                  value: "" + d.event.start_time + (d.event.venue ? d.event.venue.name : "") + d.event.name
	                },
	                capacity: d.unlimited ? "∞" : d.capacity,
	                sold: d.sold,
	                paid: {
	                  label: d.paid,
	                  value: d.paid,
	                  itemStyle: { fontStyle: "italic" }
	                },
	                pass: {
	                  label: d.pass,
	                  value: d.pass,
	                  itemStyle: { fontStyle: "italic" }
	                },
	                comp: {
	                  label: d.comp,
	                  value: d.comp,
	                  itemStyle: { fontStyle: "italic" }
	                },
	                percent_sold: {
	                  label: d.unlimited ? "–" : (d.capacity === 0 ? "∞" : (d.sold * 100 / d.capacity || 0).toFixed(2)) + "%",
	                  value: d.unlimited ? "unlimited" : d.sold / d.capacity,
	                  itemStyle: {
	                    backgroundColor: _color(d.sold / d.capacity),
	                    color: "#fff",
	                    borderBottom: "1px solid #fff"
	                  }
	                },
	                hidden_capacity: d.hidden_capacity,
	                by_ticket_bucket: d.by_ticket_bucket
	              };
	            })
	          })
	        )
	      );
	    }
	  }], [{
	    key: "getStores",
	    value: function getStores() {
	      return [_EventBucketStore2.default, _AnalyticsStore2.default];
	    }
	  }, {
	    key: "getPropsFromStores",
	    value: function getPropsFromStores() {
	      return {
	        getEventBuckets: _EventBucketStore2.default.getEventBuckets,
	        getEventBucketById: _EventBucketStore2.default.getEventBucketById,
	        getEventTicketAnalytics: _AnalyticsStore2.default.getEventTicketAnalytics,
	        isFetching: _AnalyticsStore2.default.getState().isFetching
	      };
	    }
	  }]);
	
	  return EventTicketAnalytics;
	}(_react2.default.Component);
	
	EventTicketAnalytics.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	exports.default = (0, _radium2.default)((0, _connectToStores2.default)(EventTicketAnalytics));
	module.exports = exports["default"];

/***/ }),
/* 2302 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _moment = __webpack_require__(1021);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _connectToStores = __webpack_require__(1226);
	
	var _connectToStores2 = _interopRequireDefault(_connectToStores);
	
	var _EventBucketStore = __webpack_require__(1593);
	
	var _EventBucketStore2 = _interopRequireDefault(_EventBucketStore);
	
	var _EventBucketActions = __webpack_require__(1218);
	
	var _EventBucketActions2 = _interopRequireDefault(_EventBucketActions);
	
	var _AnalyticsStore = __webpack_require__(1861);
	
	var _AnalyticsStore2 = _interopRequireDefault(_AnalyticsStore);
	
	var _AnalyticsActions = __webpack_require__(1863);
	
	var _AnalyticsActions2 = _interopRequireDefault(_AnalyticsActions);
	
	var _EventStore = __webpack_require__(2032);
	
	var _EventStore2 = _interopRequireDefault(_EventStore);
	
	var _EventActions = __webpack_require__(2031);
	
	var _EventActions2 = _interopRequireDefault(_EventActions);
	
	var _VenueStore = __webpack_require__(2036);
	
	var _VenueStore2 = _interopRequireDefault(_VenueStore);
	
	var _VenueActions = __webpack_require__(2035);
	
	var _VenueActions2 = _interopRequireDefault(_VenueActions);
	
	var _TagStore = __webpack_require__(2039);
	
	var _TagStore2 = _interopRequireDefault(_TagStore);
	
	var _TagActions = __webpack_require__(2038);
	
	var _TagActions2 = _interopRequireDefault(_TagActions);
	
	var _analyticsHeader = __webpack_require__(2293);
	
	var _analyticsHeader2 = _interopRequireDefault(_analyticsHeader);
	
	var _workingIndicator = __webpack_require__(1664);
	
	var _workingIndicator2 = _interopRequireDefault(_workingIndicator);
	
	var _statsBlock = __webpack_require__(1741);
	
	var _statsBlock2 = _interopRequireDefault(_statsBlock);
	
	var _eventSalesAnalyticsTable = __webpack_require__(2303);
	
	var _eventSalesAnalyticsTable2 = _interopRequireDefault(_eventSalesAnalyticsTable);
	
	var _analyticsFilterWidget = __webpack_require__(2295);
	
	var _analyticsFilterWidget2 = _interopRequireDefault(_analyticsFilterWidget);
	
	var _fromCacheCallout = __webpack_require__(2296);
	
	var _fromCacheCallout2 = _interopRequireDefault(_fromCacheCallout);
	
	var _util = __webpack_require__(1183);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var EventSalesAnalytics = function (_React$Component) {
	  _inherits(EventSalesAnalytics, _React$Component);
	
	  function EventSalesAnalytics(props) {
	    _classCallCheck(this, EventSalesAnalytics);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(EventSalesAnalytics).call(this, props));
	
	    _this.state = {
	      showRangeEditor: false,
	      allTime: false,
	      range: {
	        key: "selection",
	        startDate: (0, _moment2.default)().subtract(1, "month").format("YYYY-MM-DD"),
	        endDate: (0, _moment2.default)().format("YYYY-MM-DD")
	      }
	    };
	
	    _this.handleDateChange = _this.handleDateChange.bind(_this);
	    return _this;
	  }
	
	  _createClass(EventSalesAnalytics, [{
	    key: "handleDateChange",
	    value: function handleDateChange(_ref) {
	      var _this2 = this;
	
	      var range = _ref.range;
	      var allTime = _ref.allTime;
	
	      this.setState({ range: range, allTime: allTime }, function () {
	        return _this2.componentWillReceiveProps(_this2.props, true);
	      });
	    }
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.componentWillReceiveProps(this.props, true);
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      _AnalyticsActions2.default.clearFetchEventSalesAnalyticsInterval();
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(newProps) {
	      var force = arguments.length <= 1 || arguments[1] === undefined ? false : arguments[1];
	
	      if (force === true || newProps.params.eventBucketId !== this.props.params.eventBucketId) {
	        _AnalyticsActions2.default.fetchEventSalesAnalytics.defer({
	          eventBucketId: newProps.params.eventBucketId,
	          startDate: !this.state.allTime ? JSON.stringify(this.state.range.startDate) : null,
	          endDate: !this.state.allTime ? JSON.stringify(this.state.range.endDate) : null,
	          allTime: this.state.allTime
	        });
	        _EventActions2.default.fetchAllForBucket.defer(newProps.params.eventBucketId);
	        _VenueActions2.default.fetchAllForBucket.defer(newProps.params.eventBucketId);
	        _TagActions2.default.fetchAllForBucket.defer(newProps.params.eventBucketId);
	        _EventBucketActions2.default.fetchOne.defer(newProps.params.eventBucketId);
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var eventBucketId = this.props.params.eventBucketId;
	
	      var eventBucket = this.props.getEventBucketById(eventBucketId);
	      var _props = this.props;
	      var events = _props.events;
	      var tags = _props.tags;
	      var venues = _props.venues;
	      var isFetching = _props.isFetching;
	
	      var eventBucketEvents = this.props.getEventsForEventBucket(eventBucketId);
	      var eventSalesAnalytics = this.props.getEventSalesAnalytics(eventBucketId);
	      var defaultItemsPerPage = 25;
	
	      if (!eventSalesAnalytics || !eventBucket || eventBucketEvents.length === 0 && isFetching) {
	        return _react2.default.createElement(_workingIndicator2.default, { fullPage: true });
	      }
	
	      var timePeriod = this.state.allTime ? "All time" : (0, _moment2.default)(this.state.range.startDate).twix(this.state.range.endDate, { allDay: true }).format({ implicitYear: false });
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(_analyticsHeader2.default, {
	          eventBucket: eventBucket,
	          allEventBuckets: this.props.getEventBuckets(),
	          label: "standalone ticket analytics",
	          subpath: "event_sales"
	        }),
	        _react2.default.createElement(_fromCacheCallout2.default, { analytics: eventSalesAnalytics }),
	        _react2.default.createElement(_analyticsFilterWidget2.default, {
	          showDateFilter: true,
	          onDateRangeChange: this.handleDateChange
	        }),
	        _react2.default.createElement(
	          "p",
	          null,
	          "Scroll down to view standalone ticket sales",
	          " ",
	          _react2.default.createElement(
	            "a",
	            { href: "#by-event" },
	            "by event"
	          ),
	          ", ",
	          _react2.default.createElement(
	            "a",
	            { href: "#by-venue" },
	            "by venue"
	          ),
	          ", and ",
	          _react2.default.createElement(
	            "a",
	            { href: "#by-tag" },
	            "by tag"
	          ),
	          "."
	        ),
	        this.props.isFetching || !eventSalesAnalytics || !eventBucket ? _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement(_workingIndicator2.default, { fullPage: true })
	        ) : _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement(_statsBlock2.default, {
	            value: (0, _util.formatPrice)(eventSalesAnalytics.total_volume),
	            label: "Total standalone ticket sales volume"
	          }),
	          _react2.default.createElement("a", { className: "anchor--fixed_header_offset", id: "by-event" }),
	          _react2.default.createElement(
	            "div",
	            { className: "analytics-element" },
	            _react2.default.createElement(
	              "h2",
	              { style: { marginTop: "1em", marginBottom: "0.5em" } },
	              "Standalone ticket sales by event"
	            ),
	            _react2.default.createElement(_eventSalesAnalyticsTable2.default, {
	              eventBucket: eventBucket,
	              events: events,
	              data: eventSalesAnalytics.volumes,
	              itemsPerPage: defaultItemsPerPage
	            })
	          ),
	          _react2.default.createElement("a", { className: "anchor--fixed_header_offset", id: "by-venue" }),
	          _react2.default.createElement(
	            "div",
	            { className: "analytics-element" },
	            _react2.default.createElement(
	              "h2",
	              { style: { marginTop: "1em", marginBottom: "0.5em" } },
	              "Standalone ticket sales by venue"
	            ),
	            _react2.default.createElement(_eventSalesAnalyticsTable2.default, {
	              eventBucket: eventBucket,
	              venues: venues,
	              events: events,
	              groupBy: "venue",
	              data: eventSalesAnalytics.volumes,
	              itemsPerPage: defaultItemsPerPage
	            })
	          ),
	          _react2.default.createElement("a", { className: "anchor--fixed_header_offset", id: "by-tag" }),
	          _react2.default.createElement(
	            "div",
	            { className: "analytics-element" },
	            _react2.default.createElement(
	              "h2",
	              { style: { marginTop: "1em", marginBottom: "0.5em" } },
	              "Standalone ticket sales by tag"
	            ),
	            _react2.default.createElement(_eventSalesAnalyticsTable2.default, {
	              eventBucket: eventBucket,
	              tags: tags,
	              events: events,
	              groupBy: "tag",
	              data: eventSalesAnalytics.volumes,
	              itemsPerPage: defaultItemsPerPage
	            })
	          )
	        )
	      );
	    }
	  }], [{
	    key: "getStores",
	    value: function getStores() {
	      return [_EventBucketStore2.default, _EventStore2.default, _VenueStore2.default, _TagStore2.default, _AnalyticsStore2.default];
	    }
	  }, {
	    key: "getPropsFromStores",
	    value: function getPropsFromStores() {
	      var eventState = _EventStore2.default.getState();
	      var venueState = _VenueStore2.default.getState();
	      var tagState = _TagStore2.default.getState();
	
	      return {
	        getEventBuckets: _EventBucketStore2.default.getEventBuckets,
	        getEventBucketById: _EventBucketStore2.default.getEventBucketById,
	        events: eventState.events,
	        venues: venueState.venues,
	        tags: tagState.tags,
	        isFetching: eventState.isFetching || venueState.isFetching || tagState.isFetching,
	        getEventsForEventBucket: _EventStore2.default.getEventsForEventBucket,
	        getEventSalesAnalytics: _AnalyticsStore2.default.getEventSalesAnalytics
	      };
	    }
	  }]);
	
	  return EventSalesAnalytics;
	}(_react2.default.Component);
	
	EventSalesAnalytics.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	exports.default = (0, _connectToStores2.default)(EventSalesAnalytics);
	module.exports = exports["default"];

/***/ }),
/* 2303 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _moment = __webpack_require__(1021);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _reactRouter = __webpack_require__(486);
	
	var _reactable = __webpack_require__(1688);
	
	var _materialUi = __webpack_require__(576);
	
	var _inlineLinkIconButton = __webpack_require__(1704);
	
	var _inlineLinkIconButton2 = _interopRequireDefault(_inlineLinkIconButton);
	
	var _util = __webpack_require__(1183);
	
	var util = _interopRequireWildcard(_util);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var EventSalesAnalyticsTable = function (_React$Component) {
	  _inherits(EventSalesAnalyticsTable, _React$Component);
	
	  function EventSalesAnalyticsTable(props) {
	    _classCallCheck(this, EventSalesAnalyticsTable);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(EventSalesAnalyticsTable).call(this, props));
	
	    _this._makeRow = _this._makeRow.bind(_this);
	    return _this;
	  }
	
	  _createClass(EventSalesAnalyticsTable, [{
	    key: "_makeRow",
	    value: function _makeRow(eventBucket, id, data) {
	      var _this2 = this;
	
	      var options = arguments.length <= 3 || arguments[3] === undefined ? {} : arguments[3];
	
	      var noWrapTdStyle = { whiteSpace: "nowrap" };
	
	      return _react2.default.createElement(
	        _reactable.Tr,
	        { key: id },
	        options.event ? _react2.default.createElement(
	          _reactable.Td,
	          { column: "Event", value: options.event.name },
	          _react2.default.createElement(
	            "span",
	            null,
	            options.event.name,
	            options.event.id && _react2.default.createElement(_inlineLinkIconButton2.default, {
	              onTouchTap: function onTouchTap() {
	                _this2.context.router.push("/event_buckets/" + eventBucket + "/events/" + options.event.id);
	              },
	              tooltip: "View event"
	            })
	          )
	        ) : options.venue ? _react2.default.createElement(
	          _reactable.Td,
	          { column: "Venue", value: options.venue.name },
	          _react2.default.createElement(
	            "span",
	            null,
	            options.venue.name,
	            options.venue.id && _react2.default.createElement(_inlineLinkIconButton2.default, {
	              onTouchTap: function onTouchTap() {
	                _this2.context.router.push("/event_buckets/" + eventBucket + "/venues/" + options.venue.id);
	              },
	              tooltip: "View venue"
	            })
	          )
	        ) : options.tag ? _react2.default.createElement(
	          _reactable.Td,
	          { column: "Tag", value: options.tag.name },
	          _react2.default.createElement(
	            "span",
	            null,
	            options.tag.name,
	            options.tag.id && _react2.default.createElement(_inlineLinkIconButton2.default, {
	              onTouchTap: function onTouchTap() {
	                _this2.context.router.push("/event_buckets/" + eventBucket + "/tags/" + options.tag.id);
	              },
	              tooltip: "View tag"
	            })
	          )
	        ) : null,
	        _react2.default.createElement(
	          _reactable.Td,
	          { column: "Web", value: data.web, style: noWrapTdStyle },
	          util.formatPrice(data.web)
	        ),
	        _react2.default.createElement(
	          _reactable.Td,
	          { column: "Box office", value: data.box_office, style: noWrapTdStyle },
	          util.formatPrice(data.box_office)
	        ),
	        _react2.default.createElement(
	          _reactable.Td,
	          { column: "Rush line", value: data.rush_line, style: noWrapTdStyle },
	          util.formatPrice(data.rush_line)
	        ),
	        _react2.default.createElement(
	          _reactable.Td,
	          { column: "Total", value: data.total, style: noWrapTdStyle },
	          util.formatPrice(data.total)
	        )
	      );
	    }
	  }, {
	    key: "downloadCsv",
	    value: function downloadCsv(data, events) {
	      util.clientSideDownload("event-sales-analytics-" + util.snakeCase(this.props.eventBucket.name) + ".csv", "text/csv", util.makeCsv([["Event", "Venue", "Date", "Web", "Box office", "Rush line", "Total"]].concat(Object.keys(data).map(function (id) {
	        var event = events[id] || { name: "Deleted event" };
	        return [event.name, event.venue && event.venue.name, event.start_time && (0, _moment2.default)(event.start_time).format("llll"), data[id].web / 100 || 0, data[id].box_office / 100 || 0, data[id].rush_line / 100 || 0, data[id].total / 100 || 0];
	      }))));
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this3 = this;
	
	      var _props = this.props;
	      var data = _props.data;
	      var eventBucket = _props.eventBucket;
	      var groupBy = _props.groupBy;
	      var events = _props.events;
	      var venues = _props.venues;
	      var tags = _props.tags;
	      var itemsPerPage = _props.itemsPerPage;
	      var rows = void 0;
	
	      var defaultItemsPerPage = 25;
	      var itemsPer = itemsPerPage ? itemsPerPage : defaultItemsPerPage;
	
	      if (groupBy === "venue") {
	        (function () {
	          var byVenue = {};
	          Object.keys(data).map(function (id) {
	            var event = events[id] || { venue: { id: "undefined" } };
	            if (!byVenue[event.venue.id]) {
	              byVenue[event.venue.id] = {};
	            }
	            Object.keys(data[id]).forEach(function (k) {
	              byVenue[event.venue.id][k] = (byVenue[event.venue.id][k] || 0) + data[id][k];
	            });
	          });
	          rows = Object.keys(byVenue).map(function (id) {
	            return _this3._makeRow(eventBucket.id, id, byVenue[id], {
	              venue: venues[id] || { name: "No venue" }
	            });
	          });
	        })();
	      } else if (groupBy === "tag") {
	        (function () {
	          var byTag = {};
	
	          Object.keys(data).map(function (id) {
	            var event = events[id] || { tags: [] };
	            (event.tags.length ? event.tags : [{}]).forEach(function (tag) {
	              if (!byTag[tag.id]) {
	                byTag[tag.id] = {};
	              }
	              Object.keys(data[id]).forEach(function (k) {
	                byTag[tag.id][k] = (byTag[tag.id][k] || 0) + data[id][k];
	              });
	            });
	          });
	          rows = Object.keys(byTag).map(function (id) {
	            return _this3._makeRow(eventBucket.id, id, byTag[id], {
	              tag: tags[id] || { name: "No tag" }
	            });
	          });
	        })();
	      } else {
	        rows = Object.keys(data).map(function (id) {
	          return _this3._makeRow(eventBucket.id, id, data[id], {
	            event: events[id] || { name: "Deleted event" }
	          });
	        });
	      }
	
	      var primaryColumn = groupBy === "venue" ? "Venue" : groupBy === "tag" ? "Tag" : "Event";
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          _reactable.Table,
	          {
	            className: "bordered striped responsive-table",
	            sortable: [primaryColumn, "Web", "Box office", "Rush line", "Total"],
	            defaultSort: { column: "Total", direction: "desc" },
	            columns: [primaryColumn, "Web", "Box office", "Rush line", "Total"],
	            itemsPerPage: itemsPer
	          },
	          rows
	        ),
	        rows.length === 0 ? _react2.default.createElement(
	          "div",
	          { className: "empty-table-message" },
	          "No data available."
	        ) : null,
	        groupBy === "event" ? _react2.default.createElement(_materialUi.RaisedButton, {
	          style: { marginTop: "1em" },
	          label: "Download (.csv)",
	          onTouchTap: function onTouchTap() {
	            return _this3.downloadCsv(data, events);
	          }
	        }) : null
	      );
	    }
	  }], [{
	    key: "contextTypes",
	    get: function get() {
	      return {
	        router: _react2.default.PropTypes.object
	      };
	    }
	  }]);
	
	  return EventSalesAnalyticsTable;
	}(_react2.default.Component);
	
	EventSalesAnalyticsTable.defaultProps = {
	  groupBy: "event"
	};
	
	exports.default = EventSalesAnalyticsTable;
	module.exports = exports["default"];

/***/ }),
/* 2304 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _moment = __webpack_require__(1021);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _connectToStores = __webpack_require__(1226);
	
	var _connectToStores2 = _interopRequireDefault(_connectToStores);
	
	var _EventBucketStore = __webpack_require__(1593);
	
	var _EventBucketStore2 = _interopRequireDefault(_EventBucketStore);
	
	var _EventBucketActions = __webpack_require__(1218);
	
	var _EventBucketActions2 = _interopRequireDefault(_EventBucketActions);
	
	var _AnalyticsStore = __webpack_require__(1861);
	
	var _AnalyticsStore2 = _interopRequireDefault(_AnalyticsStore);
	
	var _AnalyticsActions = __webpack_require__(1863);
	
	var _AnalyticsActions2 = _interopRequireDefault(_AnalyticsActions);
	
	var _EventStore = __webpack_require__(2032);
	
	var _EventStore2 = _interopRequireDefault(_EventStore);
	
	var _EventActions = __webpack_require__(2031);
	
	var _EventActions2 = _interopRequireDefault(_EventActions);
	
	var _PassBucketStore = __webpack_require__(1867);
	
	var _PassBucketStore2 = _interopRequireDefault(_PassBucketStore);
	
	var _PassBucketActions = __webpack_require__(1869);
	
	var _PassBucketActions2 = _interopRequireDefault(_PassBucketActions);
	
	var _analyticsHeader = __webpack_require__(2293);
	
	var _analyticsHeader2 = _interopRequireDefault(_analyticsHeader);
	
	var _workingIndicator = __webpack_require__(1664);
	
	var _workingIndicator2 = _interopRequireDefault(_workingIndicator);
	
	var _statsBlockContainer = __webpack_require__(1740);
	
	var _statsBlockContainer2 = _interopRequireDefault(_statsBlockContainer);
	
	var _statsBlock = __webpack_require__(1741);
	
	var _statsBlock2 = _interopRequireDefault(_statsBlock);
	
	var _eventPassesAnalyticsTable = __webpack_require__(2305);
	
	var _eventPassesAnalyticsTable2 = _interopRequireDefault(_eventPassesAnalyticsTable);
	
	var _analyticsFilterWidget = __webpack_require__(2295);
	
	var _analyticsFilterWidget2 = _interopRequireDefault(_analyticsFilterWidget);
	
	var _fromCacheCallout = __webpack_require__(2296);
	
	var _fromCacheCallout2 = _interopRequireDefault(_fromCacheCallout);
	
	var _util = __webpack_require__(1183);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var EventPassesAnalytics = function (_React$Component) {
	  _inherits(EventPassesAnalytics, _React$Component);
	
	  function EventPassesAnalytics(props) {
	    _classCallCheck(this, EventPassesAnalytics);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(EventPassesAnalytics).call(this, props));
	
	    _this.state = {
	      showRangeEditor: false,
	      allTime: false,
	      range: {
	        key: "selection",
	        startDate: (0, _moment2.default)().subtract(1, "month").format("YYYY-MM-DD"),
	        endDate: (0, _moment2.default)().format("YYYY-MM-DD")
	      }
	    };
	
	    _this.handleDateChange = _this.handleDateChange.bind(_this);
	    _this.setPage = _this.setPage.bind(_this);
	    return _this;
	  }
	
	  _createClass(EventPassesAnalytics, [{
	    key: "setPage",
	
	
	    // Set the state of the page to reflect if we are on a 
	    // pass page or a membership page.
	    value: function () {
	      var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
	        return regeneratorRuntime.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                if (!this.props.location.pathname.includes("memberships")) {
	                  _context.next = 6;
	                  break;
	                }
	
	                _context.next = 3;
	                return this.setState({ isMembership: true, filterState: "memberships" });
	
	              case 3:
	                this.componentWillReceiveProps(this.props, true);
	                _context.next = 9;
	                break;
	
	              case 6:
	                _context.next = 8;
	                return this.setState({ isMembership: false, filterState: "passes" });
	
	              case 8:
	                this.componentWillReceiveProps(this.props, true);
	
	              case 9:
	              case "end":
	                return _context.stop();
	            }
	          }
	        }, _callee, this);
	      }));
	
	      function setPage() {
	        return _ref.apply(this, arguments);
	      }
	
	      return setPage;
	    }()
	  }, {
	    key: "handleDateChange",
	    value: function handleDateChange(_ref2) {
	      var _this2 = this;
	
	      var range = _ref2.range;
	      var allTime = _ref2.allTime;
	
	      this.setState({ range: range, allTime: allTime }, function () {
	        return _this2.componentWillReceiveProps(_this2.props, true);
	      });
	    }
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.setPage(); // set state to reflect pass vs. membership
	      this.componentWillReceiveProps(this.props, true);
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps) {
	      if (this.props.location !== prevProps.location) {
	        this.setPage(); // set state to reflect pass vs. membership
	      }
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(newProps) {
	      var force = arguments.length <= 1 || arguments[1] === undefined ? false : arguments[1];
	
	      var isMembership = this.props.location.pathname.includes("membership");
	
	      if (force === true || newProps.params.eventBucketId !== this.props.params.eventBucketId) {
	        _AnalyticsActions2.default.fetchEventPassesAnalytics.defer({
	          eventBucketId: newProps.params.eventBucketId,
	          isMembership: isMembership,
	          startDate: !this.state.allTime ? JSON.stringify(this.state.range.startDate) : null,
	          endDate: !this.state.allTime ? JSON.stringify(this.state.range.endDate) : null,
	          allTime: this.state.allTime
	        });
	        _EventActions2.default.fetchAllForBucket.defer(newProps.params.eventBucketId);
	        _PassBucketActions2.default.fetchAllForEventBucket.defer(newProps.params.eventBucketId);
	        _EventBucketActions2.default.fetchOne.defer(newProps.params.eventBucketId);
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var eventBucketId = this.props.params.eventBucketId;
	
	      if (!eventBucketId) {
	        return _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement(_workingIndicator2.default, { fullPage: true })
	        );
	      }
	      var eventBucket = this.props.getEventBucketById(eventBucketId);
	      if (!eventBucket) {
	        return _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement(_workingIndicator2.default, { fullPage: true })
	        );
	      }
	      var _props = this.props;
	      var events = _props.events;
	      var passBuckets = _props.passBuckets;
	      var isFetching = _props.isFetching;
	
	      var eventBucketEvents = this.props.getEventsForEventBucket(eventBucketId);
	      var eventPassesAnalytics = this.props.getEventPassesAnalytics(eventBucketId);
	      var isMembership = this.props.location.pathname.includes("memberships");
	      var defaultItemsPerPage = 25;
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(_analyticsHeader2.default, {
	          eventBucket: eventBucket,
	          allEventBuckets: this.props.getEventBuckets(),
	          label: (isMembership ? "membership" : "pass") + " ticket analytics",
	          subpath: "event_passes"
	        }),
	        _react2.default.createElement(_fromCacheCallout2.default, { analytics: eventPassesAnalytics }),
	        _react2.default.createElement(_analyticsFilterWidget2.default, {
	          key: !isMembership ? "membership" : "passes",
	          showDateFilter: true,
	          onDateRangeChange: this.handleDateChange
	        }),
	        _react2.default.createElement(
	          "p",
	          null,
	          "Scroll down to view tickets ordered using a ",
	          isMembership ? "membership" : "pass",
	          " for each event",
	          " ",
	          _react2.default.createElement(
	            "a",
	            { href: "#by-pass-bucket" },
	            "by ",
	            isMembership ? "membership" : "pass bucket"
	          ),
	          " and",
	          " ",
	          _react2.default.createElement(
	            "a",
	            { href: "#by-order-type" },
	            "by order type"
	          ),
	          "."
	        ),
	        !eventPassesAnalytics || !eventBucket || eventBucketEvents.length === 0 && isFetching || isFetching ? _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement(_workingIndicator2.default, { fullPage: true })
	        ) : _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement(
	            _statsBlockContainer2.default,
	            { style: { marginTop: -10 } },
	            _react2.default.createElement(_statsBlock2.default, {
	              value: (0, _util.formatNumber)(eventPassesAnalytics.total_ordered),
	              label: "Total pass tickets ordered"
	            }),
	            _react2.default.createElement(_statsBlock2.default, {
	              value: (0, _util.formatNumber)(eventPassesAnalytics.total_scanned),
	              label: "Total pass tickets scanned"
	            })
	          ),
	          _react2.default.createElement("a", { className: "anchor--fixed_header_offset", id: "by-pass-bucket" }),
	          _react2.default.createElement(
	            "div",
	            { className: "analytics-element" },
	            _react2.default.createElement(
	              "h2",
	              { style: { marginTop: "1em", marginBottom: "0.5em" } },
	              "Tickets ordered for event by ",
	              isMembership ? "membership" : "pass bucket"
	            ),
	            _react2.default.createElement(_eventPassesAnalyticsTable2.default, {
	              eventBucket: eventBucket,
	              events: events,
	              columnBy: "pass_bucket",
	              passBuckets: passBuckets,
	              data: eventPassesAnalytics.volumes,
	              isMembership: isMembership,
	              itemsPerPage: defaultItemsPerPage
	            })
	          ),
	          _react2.default.createElement("a", { className: "anchor--fixed_header_offset", id: "by-order-type" }),
	          _react2.default.createElement(
	            "div",
	            { className: "analytics-element" },
	            _react2.default.createElement(
	              "h2",
	              { style: { marginTop: "1em", marginBottom: "0.5em" } },
	              "Tickets ordered for event by order type"
	            ),
	            _react2.default.createElement(_eventPassesAnalyticsTable2.default, {
	              eventBucket: eventBucket,
	              events: events,
	              columnBy: "order_type",
	              passBuckets: passBuckets,
	              data: eventPassesAnalytics.volumes,
	              isMembership: isMembership,
	              itemsPerPage: defaultItemsPerPage
	            })
	          )
	        )
	      );
	    }
	  }], [{
	    key: "getStores",
	    value: function getStores() {
	      return [_EventBucketStore2.default, _EventStore2.default, _PassBucketStore2.default, _AnalyticsStore2.default];
	    }
	  }, {
	    key: "getPropsFromStores",
	    value: function getPropsFromStores() {
	      var eventState = _EventStore2.default.getState(),
	          passBucketState = _PassBucketStore2.default.getState();
	
	      return {
	        getEventBuckets: _EventBucketStore2.default.getEventBuckets,
	        getEventBucketById: _EventBucketStore2.default.getEventBucketById,
	        events: eventState.events,
	        passBuckets: passBucketState.passBuckets,
	        isFetching: eventState.isFetching || passBucketState.isFetching,
	        getEventsForEventBucket: _EventStore2.default.getEventsForEventBucket,
	        getEventPassesAnalytics: _AnalyticsStore2.default.getEventPassesAnalytics
	      };
	    }
	  }]);
	
	  return EventPassesAnalytics;
	}(_react2.default.Component);
	
	EventPassesAnalytics.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	exports.default = (0, _connectToStores2.default)(EventPassesAnalytics);
	module.exports = exports["default"];

/***/ }),
/* 2305 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _momentTimezone = __webpack_require__(1185);
	
	var _momentTimezone2 = _interopRequireDefault(_momentTimezone);
	
	var _reactRouter = __webpack_require__(486);
	
	var _reactable = __webpack_require__(1688);
	
	var _materialUi = __webpack_require__(576);
	
	var _inlineLinkIconButton = __webpack_require__(1704);
	
	var _inlineLinkIconButton2 = _interopRequireDefault(_inlineLinkIconButton);
	
	var _util = __webpack_require__(1183);
	
	var util = _interopRequireWildcard(_util);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var EventSalesAnalyticsTable = function (_React$Component) {
	  _inherits(EventSalesAnalyticsTable, _React$Component);
	
	  function EventSalesAnalyticsTable(props) {
	    _classCallCheck(this, EventSalesAnalyticsTable);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(EventSalesAnalyticsTable).call(this, props));
	
	    _this._makeRow = _this._makeRow.bind(_this);
	    return _this;
	  }
	
	  _createClass(EventSalesAnalyticsTable, [{
	    key: "_makeRow",
	    value: function _makeRow(eventBucket, id, data) {
	      var _this2 = this;
	
	      var options = arguments.length <= 3 || arguments[3] === undefined ? {} : arguments[3];
	
	      var noWrapTdStyle = { whiteSpace: "nowrap" };
	
	      return _react2.default.createElement(
	        _reactable.Tr,
	        { key: id },
	        _react2.default.createElement(
	          _reactable.Td,
	          { column: "Event", value: options.event.name },
	          _react2.default.createElement(
	            "span",
	            null,
	            options.event.name,
	            options.event.id && _react2.default.createElement(_inlineLinkIconButton2.default, {
	              onTouchTap: function onTouchTap() {
	                _this2.context.router.push("/event_buckets/" + eventBucket + "/events/" + options.event.id);
	              },
	              tooltip: "View event"
	            })
	          )
	        ),
	        _react2.default.createElement(
	          _reactable.Td,
	          { column: "Web", value: data.web, style: noWrapTdStyle },
	          data.web
	        ),
	        _react2.default.createElement(
	          _reactable.Td,
	          { column: "At the door", value: data.at_the_door, style: noWrapTdStyle },
	          data.at_the_door
	        ),
	        _react2.default.createElement(
	          _reactable.Td,
	          {
	            column: "Total ordered",
	            value: data.total_ordered,
	            style: noWrapTdStyle
	          },
	          data.total_ordered
	        ),
	        _react2.default.createElement(
	          _reactable.Td,
	          {
	            column: "Total scanned",
	            value: data.total_scanned,
	            style: noWrapTdStyle
	          },
	          data.total_scanned
	        ),
	        this.props.passBuckets ? Object.values(this.props.passBuckets).map(function (b) {
	          return _react2.default.createElement(
	            _reactable.Td,
	            {
	              key: b.id,
	              column: b.id,
	              value: data.by_pass_bucket[b.id],
	              style: noWrapTdStyle
	            },
	            data.by_pass_bucket[b.id] || 0
	          );
	        }) : []
	      );
	    }
	  }, {
	    key: "downloadCsv",
	    value: function downloadCsv(data, events, columnBy) {
	      var isMembership = this.props.isMembership;
	
	      var passBucketIds = Object.values(this.props.passBuckets).filter(function (passBucket) {
	        return isMembership ? passBucket.is_membership : !passBucket.is_membership;
	      }).map(function (b) {
	        return b.id;
	      });
	      var browserTimezone = _momentTimezone2.default.tz(_momentTimezone2.default.tz.guess()).format('z');
	
	      if (columnBy === 'pass_bucket') {
	        util.clientSideDownload((this.props.isMembership ? "membership-ticket-analytics-by-membership" : "pass-ticket-analytics-by-pass-bucket") + "-" + util.snakeCase(this.props.eventBucket.name) + ".csv", "text/csv", util.makeCsv([["Event", "Venue", "Date"].concat(Object.values(this.props.passBuckets).filter(function (passBucket) {
	          return isMembership ? passBucket.is_membership : !passBucket.is_membership;
	        }).map(function (b) {
	          return b.name;
	        })).concat(["Total ordered", "Total scanned"])].concat(Object.keys(data).map(function (id) {
	          var event = events[id] || { name: "Deleted event" };
	          return [event.name, event.venue && event.venue.name, event.start_time && (0, _momentTimezone2.default)(event.start_time).format("llll") + " " + browserTimezone].concat(passBucketIds.map(function (passBucketId) {
	            return data[id].by_pass_bucket[passBucketId] || 0;
	          })).concat([data[id].total_ordered, data[id].total_scanned]);
	        }))));
	      } else if (columnBy === 'order_type') {
	        util.clientSideDownload((this.props.isMembership ? "membership-ticket-analytics-by-order-type" : "pass-ticket-analytics-by-order-type") + "-" + util.snakeCase(this.props.eventBucket.name) + ".csv", "text/csv", util.makeCsv([["Event", "Venue", "Date", "Web", "At the Door", "Total Ordered", "Total Scanned"]].concat(Object.keys(data).map(function (id) {
	          var event = events[id] || { name: "Deleted event" };
	          return [event.name, event.venue && event.venue.name, event.start_time && (0, _momentTimezone2.default)(event.start_time).format("llll"), data[id].web, data[id].at_the_door, data[id].total_ordered, data[id].total_scanned];
	        }))));
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this3 = this;
	
	      var _props = this.props;
	      var data = _props.data;
	      var eventBucket = _props.eventBucket;
	      var events = _props.events;
	      var columnBy = _props.columnBy;
	      var passBuckets = _props.passBuckets;
	      var isMembership = _props.isMembership;
	      var _props$itemsPerPage = _props.itemsPerPage;
	      var itemsPerPage = _props$itemsPerPage === undefined ? false : _props$itemsPerPage;
	
	      var rows = void 0;
	      var columns = void 0;
	
	      var defaultItemsPerPage = 25;
	      var itemsPer = itemsPerPage ? itemsPerPage : defaultItemsPerPage;
	
	      rows = Object.keys(data).map(function (id) {
	        return _this3._makeRow(eventBucket.id, id, data[id], {
	          event: events[id] || { name: "Deleted event" }
	        });
	      });
	
	      if (columnBy === "order_type") {
	        columns = ["Web", "At the door"];
	      } else if (columnBy === "pass_bucket") {
	        columns = Object.values(passBuckets).filter(function (passBucket) {
	          return isMembership ? passBucket.is_membership : !passBucket.is_membership;
	        }).map(function (b) {
	          return { key: b.id, label: b.name };
	        });
	      }
	
	      var allColumns = ["Event"].concat(columns).concat(["Total ordered", "Total scanned"]);
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          _reactable.Table,
	          {
	            className: "bordered striped responsive-table",
	            sortable: allColumns.map(function (c) {
	              return c.key || c;
	            }),
	            defaultSort: { column: "Total scanned", direction: "desc" },
	            columns: allColumns,
	            itemsPerPage: itemsPer
	          },
	          rows
	        ),
	        _react2.default.createElement(_materialUi.RaisedButton, {
	          style: { marginTop: "1em" },
	          label: "Download (.csv)",
	          onTouchTap: function onTouchTap() {
	            return _this3.downloadCsv(data, events, columnBy);
	          }
	        })
	      );
	    }
	  }], [{
	    key: "contextTypes",
	    get: function get() {
	      return {
	        router: _react2.default.PropTypes.object
	      };
	    }
	  }]);
	
	  return EventSalesAnalyticsTable;
	}(_react2.default.Component);
	
	EventSalesAnalyticsTable.defaultProps = {
	  columnBy: "order_type"
	};
	
	exports.default = EventSalesAnalyticsTable;
	module.exports = exports["default"];

/***/ }),
/* 2306 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _radium = __webpack_require__(1600);
	
	var _radium2 = _interopRequireDefault(_radium);
	
	var _reactEventListener = __webpack_require__(1230);
	
	var _reactEventListener2 = _interopRequireDefault(_reactEventListener);
	
	var _reactIframeResizerSuper = __webpack_require__(2307);
	
	var _reactIframeResizerSuper2 = _interopRequireDefault(_reactIframeResizerSuper);
	
	var _materialUi = __webpack_require__(576);
	
	var _connectToStores = __webpack_require__(1226);
	
	var _connectToStores2 = _interopRequireDefault(_connectToStores);
	
	var _EventBucketStore = __webpack_require__(1593);
	
	var _EventBucketStore2 = _interopRequireDefault(_EventBucketStore);
	
	var _EventBucketActions = __webpack_require__(1218);
	
	var _EventBucketActions2 = _interopRequireDefault(_EventBucketActions);
	
	var _AnalyticsStore = __webpack_require__(1861);
	
	var _AnalyticsStore2 = _interopRequireDefault(_AnalyticsStore);
	
	var _AnalyticsActions = __webpack_require__(1863);
	
	var _AnalyticsActions2 = _interopRequireDefault(_AnalyticsActions);
	
	var _UserStore = __webpack_require__(974);
	
	var _UserStore2 = _interopRequireDefault(_UserStore);
	
	var _analyticsHeader = __webpack_require__(2293);
	
	var _analyticsHeader2 = _interopRequireDefault(_analyticsHeader);
	
	var _workingIndicator = __webpack_require__(1664);
	
	var _workingIndicator2 = _interopRequireDefault(_workingIndicator);
	
	var _genericAnalyticsTable = __webpack_require__(1687);
	
	var _genericAnalyticsTable2 = _interopRequireDefault(_genericAnalyticsTable);
	
	var _moment = __webpack_require__(1021);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _twix = __webpack_require__(2312);
	
	var _twix2 = _interopRequireDefault(_twix);
	
	var _util = __webpack_require__(1183);
	
	var util = _interopRequireWildcard(_util);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var StreamingAnalytics = function (_React$Component) {
	  _inherits(StreamingAnalytics, _React$Component);
	
	  function StreamingAnalytics(props) {
	    _classCallCheck(this, StreamingAnalytics);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(StreamingAnalytics).call(this, props));
	
	    _this.state = { isRefreshing: false, useV2: false };
	    return _this;
	  }
	
	  _createClass(StreamingAnalytics, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.componentWillReceiveProps(this.props, true);
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(newProps) {
	      var force = arguments.length <= 1 || arguments[1] === undefined ? false : arguments[1];
	
	      if (force === true || newProps.params.eventBucketId !== this.props.params.eventBucketId) {
	        _EventBucketActions2.default.fetchOne.defer(newProps.params.eventBucketId);
	      }
	    }
	  }, {
	    key: "getStyles",
	    value: function getStyles() {
	      return {};
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var styles = this.getStyles();
	      var eventBucketId = this.props.params.eventBucketId;
	      var eventBucket = this.props.getEventBucketById(eventBucketId);
	
	      if (!eventBucket) {
	        return _react2.default.createElement(_workingIndicator2.default, { fullPage: true });
	      }
	
	      var useV2 = this.state.useV2 || eventBucket.frontend_config.streaming_analytics_use_v2;
	      var path = useV2 ? "admin/analytics_v2" : "admin/analytics";
	      var destination = "" + ("https://watch.eventive.org/") + path + "?data=" + btoa(JSON.stringify(_extends({
	        event_bucket_id: eventBucketId
	      }, _UserStore2.default.getCredentials())));
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(_analyticsHeader2.default, {
	          eventBucket: eventBucket,
	          allEventBuckets: this.props.getEventBuckets(),
	          label: "streaming analytics",
	          subpath: "streaming",
	          query: this.props.location.query,
	          onRefresh: function onRefresh() {
	            _this2.setState({ isRefreshing: true }, function () {
	              setTimeout(function () {
	                return _this2.setState({ isRefreshing: false });
	              }, 100);
	            });
	          },
	          isRefreshing: this.props.isFetching
	        }),
	        _UserStore2.default.isGod() ? _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement(_materialUi.Checkbox, {
	            label: "[God only] Use V2",
	            checked: useV2,
	            onCheck: function onCheck(e, checked) {
	              return _this2.setState({ useV2: checked });
	            },
	            style: { marginBottom: 10 }
	          })
	        ) : null,
	        _react2.default.createElement(
	          "div",
	          { style: { position: "relative" } },
	          _react2.default.createElement(_reactIframeResizerSuper2.default, {
	            style: {
	              width: "1px",
	              minWidth: "100%",
	              marginTop: "1em",
	              border: "none"
	            },
	            src: this.state.isRefreshing ? "" : destination
	          })
	        )
	      );
	    }
	  }], [{
	    key: "getStores",
	    value: function getStores() {
	      return [_EventBucketStore2.default, _AnalyticsStore2.default];
	    }
	  }, {
	    key: "getPropsFromStores",
	    value: function getPropsFromStores() {
	      return {
	        getEventBuckets: _EventBucketStore2.default.getEventBuckets,
	        getEventBucketById: _EventBucketStore2.default.getEventBucketById,
	        getSalesAnalytics: _AnalyticsStore2.default.getSalesAnalytics,
	        isFetching: _AnalyticsStore2.default.getState().isFetching
	      };
	    }
	  }]);
	
	  return StreamingAnalytics;
	}(_react2.default.Component);
	
	StreamingAnalytics.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	exports.default = (0, _radium2.default)((0, _connectToStores2.default)(StreamingAnalytics));
	module.exports = exports["default"];

/***/ }),
/* 2307 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(1231);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(1257);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(1258);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(1262);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(1309);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(956);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(332);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _iframeResizer = __webpack_require__(2308);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 *
	 * inject script to facilitate iframe resizing
	 * https://github.com/davidjbradshaw/iframe-resizer
	 *
	 */
	var IframeResizer = function (_React$Component) {
	  (0, _inherits3.default)(IframeResizer, _React$Component);
	
	  function IframeResizer() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, IframeResizer);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = IframeResizer.__proto__ || (0, _getPrototypeOf2.default)(IframeResizer)).call.apply(_ref, [this].concat(args))), _this), _this.updateIframe = function (props) {
	      // has src - no injected content
	      if (props.src) return;
	      // do we have content to inject (content or children)
	      var content = props.content || props.children;
	      if (!content) return;
	      // get frame to inject into
	      var frame = _this.refs.frame;
	      if (!frame) return;
	      // verify frame document access
	      // Due to browser security, this will fail with the following error
	      //   Uncaught DOMException: Failed to read the 'contentDocument' property from 'HTMLIFrameElement':
	      //   Blocked a frame with origin "http://<hostname>" from accessing a cross-origin frame.
	      // resolve this by loading documents from the same domain name,
	      // or injecting HTML `content` vs. loading via `src`
	      var doc = frame.contentDocument;
	      if (!doc) return;
	      // replace iframe document content
	      if (typeof content === 'string') {
	        // assume this is a HTML block
	        //   we could send this in via REACT dangerously set HTML
	        //   but we are in an iframe anyway, already a red-headed step-child.
	        doc.open();
	        doc.write(content);
	        doc.close();
	      } else {
	        // assume this is a REACT component
	        doc.open();
	        doc.write('<div id="iframe-root"></div>');
	        doc.close();
	        _reactDom2.default.render(content, doc.getElementById('iframe-root'));
	      }
	    }, _this.injectIframeResizerUrl = function () {
	      if (!_this.props.iframeResizerUrl) return;
	      var frame = _this.refs.frame;
	      if (!frame) return;
	      // verify frame document access
	      // Due to browser security, this will fail with the following error
	      //   Uncaught DOMException: Failed to read the 'contentDocument' property from 'HTMLIFrameElement':
	      //   Blocked a frame with origin "http://<hostname>" from accessing a cross-origin frame.
	      // resolve this by loading documents from the same domain name,
	      // or injecting HTML `content` vs. loading via `src`
	      var doc = frame.contentDocument;
	      if (!doc) return;
	      // where can we insert into? (fail into whatever we can find)
	      var injectTarget = null;
	      ['head', 'HEAD', 'body', 'BODY', 'div', 'DIV'].forEach(function (tagName) {
	        if (injectTarget) return;
	        var found = doc.getElementsByTagName(tagName);
	        if (!(found && found.length)) return;
	        injectTarget = found[0];
	      });
	      if (!injectTarget) {
	        console.error('Unable to inject iframe resizer script');
	        return;
	      }
	      var resizerScriptElement = document.createElement('script');
	      resizerScriptElement.type = 'text/javascript';
	      resizerScriptElement.src = _this.props.iframeResizerUrl;
	      injectTarget.appendChild(resizerScriptElement);
	    }, _this.onLoad = function () {
	      _this.injectIframeResizerUrl();
	      // DISABLED because it's causing a loading loop :(
	      // if (this.props.onIframeLoaded) this.props.onIframeLoaded();
	    }, _this.resizeIframe = function (props) {
	      var frame = _this.refs.frame;
	      if (!frame) return;
	      if (props.iframeResizerEnable) {
	        (0, _iframeResizer.iframeResizer)(props.iframeResizerOptions, frame);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(IframeResizer, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      // can't update until we have a mounted iframe
	      this.updateIframe(this.props);
	      this.resizeIframe(this.props);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      // React will remove the iframe, however we need to manually
	      // call iframe-resizer to stop its listeners
	      var iframeResizer = this.refs.frame.iFrameResizer;
	      iframeResizer && iframeResizer.removeListeners();
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      // can replace content if we got new props
	      this.updateIframe(nextProps);
	      this.resizeIframe(nextProps);
	    }
	    // inject the iframe resizer "content window" script
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          src = _props.src,
	          id = _props.id,
	          frameBorder = _props.frameBorder,
	          className = _props.className,
	          style = _props.style;
	
	      return _react2.default.createElement('iframe', {
	        ref: 'frame',
	        src: src,
	        id: id,
	        frameBorder: frameBorder,
	        className: className,
	        style: style,
	        onLoad: this.onLoad
	      });
	    }
	  }]);
	  return IframeResizer;
	}(_react2.default.Component);
	
	IframeResizer.propTypes = {
	  // iframe content/document
	  // option 1. content of HTML to load in the iframe
	  content: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element]),
	  // option 2. src to a URL to load in the iframe
	  src: _propTypes2.default.string,
	  // iframe-resizer controls and helpers
	  iframeResizerEnable: _propTypes2.default.bool,
	  iframeResizerOptions: _propTypes2.default.object,
	  iframeResizerUrl: _propTypes2.default.oneOfType([_propTypes2.default.string, // URL to inject
	  _propTypes2.default.bool] // false = disable inject
	  ),
	  // misc props to pass through to iframe
	  id: _propTypes2.default.string,
	  frameBorder: _propTypes2.default.number,
	  className: _propTypes2.default.string,
	  style: _propTypes2.default.object
	  // optional extra callback when iframe is loaded
	  // onIframeLoaded: PropTypes.func,
	};
	IframeResizer.defaultProps = {
	  // resize iframe
	  iframeResizerEnable: true,
	  iframeResizerOptions: {
	    // log: true,
	    // autoResize: true,
	    // checkOrigin: false,
	    // resizeFrom: 'parent',
	    // heightCalculationMethod: 'max',
	    // initCallback: () => { console.log('ready!'); },
	    // resizedCallback: () => { console.log('resized!'); },
	  },
	  iframeResizerUrl: 'https://cdnjs.cloudflare.com/ajax/libs/iframe-resizer/3.5.8/iframeResizer.contentWindow.min.js',
	  // misc props to pass through to iframe
	  frameBorder: 0,
	  style: {
	    width: '100%',
	    minHeight: 20
	  }
	};
	
	exports.default = IframeResizer;

/***/ }),
/* 2308 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(2309)


/***/ }),
/* 2309 */
/***/ (function(module, exports, __webpack_require__) {

	var iframeResize = __webpack_require__(2310)
	
	exports.iframeResize = iframeResize
	exports.iframeResizer = iframeResize // Backwards compatability
	exports.iframeResizerContentWindow = __webpack_require__(2311)


/***/ }),
/* 2310 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*
	 * File: iframeResizer.js
	 * Desc: Force iframes to size to content.
	 * Requires: iframeResizer.contentWindow.js to be loaded into the target frame.
	 * Doc: https://github.com/davidjbradshaw/iframe-resizer
	 * Author: David J. Bradshaw - dave@bradshaw.net
	 * Contributor: Jure Mav - jure.mav@gmail.com
	 * Contributor: Reed Dadoune - reed@dadoune.com
	 */
	
	// eslint-disable-next-line sonarjs/cognitive-complexity, no-shadow-restricted-names
	;(function(undefined) {
	  if (typeof window === 'undefined') return // don't run for server side render
	
	  var count = 0,
	    logEnabled = false,
	    hiddenCheckEnabled = false,
	    msgHeader = 'message',
	    msgHeaderLen = msgHeader.length,
	    msgId = '[iFrameSizer]', // Must match iframe msg ID
	    msgIdLen = msgId.length,
	    pagePosition = null,
	    requestAnimationFrame = window.requestAnimationFrame,
	    resetRequiredMethods = {
	      max: 1,
	      scroll: 1,
	      bodyScroll: 1,
	      documentElementScroll: 1
	    },
	    settings = {},
	    timer = null,
	    defaults = {
	      autoResize: true,
	      bodyBackground: null,
	      bodyMargin: null,
	      bodyMarginV1: 8,
	      bodyPadding: null,
	      checkOrigin: true,
	      inPageLinks: false,
	      enablePublicMethods: true,
	      heightCalculationMethod: 'bodyOffset',
	      id: 'iFrameResizer',
	      interval: 32,
	      log: false,
	      maxHeight: Infinity,
	      maxWidth: Infinity,
	      minHeight: 0,
	      minWidth: 0,
	      resizeFrom: 'parent',
	      scrolling: false,
	      sizeHeight: true,
	      sizeWidth: false,
	      warningTimeout: 5000,
	      tolerance: 0,
	      widthCalculationMethod: 'scroll',
	      onClose: function() {
	        return true
	      },
	      onClosed: function() {},
	      onInit: function() {},
	      onMessage: function() {
	        warn('onMessage function not defined')
	      },
	      onResized: function() {},
	      onScroll: function() {
	        return true
	      }
	    }
	
	  function getMutationObserver() {
	    return (
	      window.MutationObserver ||
	      window.WebKitMutationObserver ||
	      window.MozMutationObserver
	    )
	  }
	
	  function addEventListener(el, evt, func) {
	    el.addEventListener(evt, func, false)
	  }
	
	  function removeEventListener(el, evt, func) {
	    el.removeEventListener(evt, func, false)
	  }
	
	  function setupRequestAnimationFrame() {
	    var vendors = ['moz', 'webkit', 'o', 'ms']
	    var x
	
	    // Remove vendor prefixing if prefixed and break early if not
	    for (x = 0; x < vendors.length && !requestAnimationFrame; x += 1) {
	      requestAnimationFrame = window[vendors[x] + 'RequestAnimationFrame']
	    }
	
	    if (!requestAnimationFrame) {
	      log('setup', 'RequestAnimationFrame not supported')
	    } else {
	      // Firefox extension content-scripts have a globalThis object that is not the same as window.
	      // Binding `requestAnimationFrame` to window allows the function to work and prevents errors
	      // being thrown when run in that context, and should be a no-op in every other context.
	      requestAnimationFrame = requestAnimationFrame.bind(window);
	    }
	  }
	
	  function getMyID(iframeId) {
	    var retStr = 'Host page: ' + iframeId
	
	    if (window.top !== window.self) {
	      if (window.parentIFrame && window.parentIFrame.getId) {
	        retStr = window.parentIFrame.getId() + ': ' + iframeId
	      } else {
	        retStr = 'Nested host page: ' + iframeId
	      }
	    }
	
	    return retStr
	  }
	
	  function formatLogHeader(iframeId) {
	    return msgId + '[' + getMyID(iframeId) + ']'
	  }
	
	  function isLogEnabled(iframeId) {
	    return settings[iframeId] ? settings[iframeId].log : logEnabled
	  }
	
	  function log(iframeId, msg) {
	    output('log', iframeId, msg, isLogEnabled(iframeId))
	  }
	
	  function info(iframeId, msg) {
	    output('info', iframeId, msg, isLogEnabled(iframeId))
	  }
	
	  function warn(iframeId, msg) {
	    output('warn', iframeId, msg, true)
	  }
	
	  function output(type, iframeId, msg, enabled) {
	    if (true === enabled && 'object' === typeof window.console) {
	      // eslint-disable-next-line no-console
	      console[type](formatLogHeader(iframeId), msg)
	    }
	  }
	
	  function iFrameListener(event) {
	    function resizeIFrame() {
	      function resize() {
	        setSize(messageData)
	        setPagePosition(iframeId)
	        on('onResized', messageData)
	      }
	
	      ensureInRange('Height')
	      ensureInRange('Width')
	
	      syncResize(resize, messageData, 'init')
	    }
	
	    function processMsg() {
	      var data = msg.substr(msgIdLen).split(':')
	      var height = data[1] ? parseInt(data[1], 10) : 0;
	      var iframe = settings[data[0]] && settings[data[0]].iframe;
	      var compStyle = getComputedStyle(iframe)
	
	      return {
	        iframe: iframe,
	        id: data[0],
	        height: height + getPaddingEnds(compStyle) + getBorderEnds(compStyle),
	        width: data[2],
	        type: data[3]
	      }
	    }
	
	    function getPaddingEnds(compStyle) {
	      if (compStyle.boxSizing !== 'border-box') {
	        return 0;
	      }
	      var top = compStyle.paddingTop ? parseInt(compStyle.paddingTop, 10) : 0
	      var bot = compStyle.paddingBottom ? parseInt(compStyle.paddingBottom, 10) : 0
	      return top + bot
	    }
	
	    function getBorderEnds(compStyle) {
	      if (compStyle.boxSizing !== 'border-box') {
	        return 0;
	      }
	      var top = compStyle.borderTopWidth ? parseInt(compStyle.borderTopWidth, 10) : 0
	      var bot = compStyle.borderBottomWidth ? parseInt(compStyle.borderBottomWidth, 10) : 0
	      return top + bot
	    }
	
	    function ensureInRange(Dimension) {
	      var max = Number(settings[iframeId]['max' + Dimension]),
	        min = Number(settings[iframeId]['min' + Dimension]),
	        dimension = Dimension.toLowerCase(),
	        size = Number(messageData[dimension])
	
	      log(iframeId, 'Checking ' + dimension + ' is in range ' + min + '-' + max)
	
	      if (size < min) {
	        size = min
	        log(iframeId, 'Set ' + dimension + ' to min value')
	      }
	
	      if (size > max) {
	        size = max
	        log(iframeId, 'Set ' + dimension + ' to max value')
	      }
	
	      messageData[dimension] = '' + size
	    }
	
	    function isMessageFromIFrame() {
	      function checkAllowedOrigin() {
	        function checkList() {
	          var i = 0,
	            retCode = false
	
	          log(
	            iframeId,
	            'Checking connection is from allowed list of origins: ' +
	              checkOrigin
	          )
	
	          for (; i < checkOrigin.length; i++) {
	            if (checkOrigin[i] === origin) {
	              retCode = true
	              break
	            }
	          }
	          return retCode
	        }
	
	        function checkSingle() {
	          var remoteHost = settings[iframeId] && settings[iframeId].remoteHost
	          log(iframeId, 'Checking connection is from: ' + remoteHost)
	          return origin === remoteHost
	        }
	
	        return checkOrigin.constructor === Array ? checkList() : checkSingle()
	      }
	
	      var origin = event.origin,
	        checkOrigin = settings[iframeId] && settings[iframeId].checkOrigin
	
	      if (checkOrigin && '' + origin !== 'null' && !checkAllowedOrigin()) {
	        throw new Error(
	          'Unexpected message received from: ' +
	            origin +
	            ' for ' +
	            messageData.iframe.id +
	            '. Message was: ' +
	            event.data +
	            '. This error can be disabled by setting the checkOrigin: false option or by providing of array of trusted domains.'
	        )
	      }
	
	      return true
	    }
	
	    function isMessageForUs() {
	      return (
	        msgId === ('' + msg).substr(0, msgIdLen) &&
	        msg.substr(msgIdLen).split(':')[0] in settings
	      ) // ''+Protects against non-string msg
	    }
	
	    function isMessageFromMetaParent() {
	      // Test if this message is from a parent above us. This is an ugly test, however, updating
	      // the message format would break backwards compatibity.
	      var retCode = messageData.type in { true: 1, false: 1, undefined: 1 }
	
	      if (retCode) {
	        log(iframeId, 'Ignoring init message from meta parent page')
	      }
	
	      return retCode
	    }
	
	    function getMsgBody(offset) {
	      return msg.substr(msg.indexOf(':') + msgHeaderLen + offset)
	    }
	
	    function forwardMsgFromIFrame(msgBody) {
	      log(
	        iframeId,
	        'onMessage passed: {iframe: ' +
	          messageData.iframe.id +
	          ', message: ' +
	          msgBody +
	          '}'
	      )
	      on('onMessage', {
	        iframe: messageData.iframe,
	        message: JSON.parse(msgBody)
	      })
	      log(iframeId, '--')
	    }
	
	    function getPageInfo() {
	      var bodyPosition = document.body.getBoundingClientRect(),
	        iFramePosition = messageData.iframe.getBoundingClientRect()
	
	      return JSON.stringify({
	        iframeHeight: iFramePosition.height,
	        iframeWidth: iFramePosition.width,
	        clientHeight: Math.max(
	          document.documentElement.clientHeight,
	          window.innerHeight || 0
	        ),
	        clientWidth: Math.max(
	          document.documentElement.clientWidth,
	          window.innerWidth || 0
	        ),
	        offsetTop: parseInt(iFramePosition.top - bodyPosition.top, 10),
	        offsetLeft: parseInt(iFramePosition.left - bodyPosition.left, 10),
	        scrollTop: window.pageYOffset,
	        scrollLeft: window.pageXOffset,
	        documentHeight: document.documentElement.clientHeight,
	        documentWidth: document.documentElement.clientWidth,
	        windowHeight: window.innerHeight,
	        windowWidth: window.innerWidth
	      })
	    }
	
	    function sendPageInfoToIframe(iframe, iframeId) {
	      function debouncedTrigger() {
	        trigger('Send Page Info', 'pageInfo:' + getPageInfo(), iframe, iframeId)
	      }
	      debounceFrameEvents(debouncedTrigger, 32, iframeId)
	    }
	
	    function startPageInfoMonitor() {
	      function setListener(type, func) {
	        function sendPageInfo() {
	          if (settings[id]) {
	            sendPageInfoToIframe(settings[id].iframe, id)
	          } else {
	            stop()
	          }
	        }
	
	        ;['scroll', 'resize'].forEach(function(evt) {
	          log(id, type + evt + ' listener for sendPageInfo')
	          func(window, evt, sendPageInfo)
	        })
	      }
	
	      function stop() {
	        setListener('Remove ', removeEventListener)
	      }
	
	      function start() {
	        setListener('Add ', addEventListener)
	      }
	
	      var id = iframeId // Create locally scoped copy of iFrame ID
	
	      start()
	
	      if (settings[id]) {
	        settings[id].stopPageInfo = stop
	      }
	    }
	
	    function stopPageInfoMonitor() {
	      if (settings[iframeId] && settings[iframeId].stopPageInfo) {
	        settings[iframeId].stopPageInfo()
	        delete settings[iframeId].stopPageInfo
	      }
	    }
	
	    function checkIFrameExists() {
	      var retBool = true
	
	      if (null === messageData.iframe) {
	        warn(iframeId, 'IFrame (' + messageData.id + ') not found')
	        retBool = false
	      }
	      return retBool
	    }
	
	    function getElementPosition(target) {
	      var iFramePosition = target.getBoundingClientRect()
	
	      getPagePosition(iframeId)
	
	      return {
	        x: Math.floor(Number(iFramePosition.left) + Number(pagePosition.x)),
	        y: Math.floor(Number(iFramePosition.top) + Number(pagePosition.y))
	      }
	    }
	
	    function scrollRequestFromChild(addOffset) {
	      /* istanbul ignore next */ // Not testable in Karma
	      function reposition() {
	        pagePosition = newPosition
	        scrollTo()
	        log(iframeId, '--')
	      }
	
	      function calcOffset() {
	        return {
	          x: Number(messageData.width) + offset.x,
	          y: Number(messageData.height) + offset.y
	        }
	      }
	
	      function scrollParent() {
	        if (window.parentIFrame) {
	          window.parentIFrame['scrollTo' + (addOffset ? 'Offset' : '')](
	            newPosition.x,
	            newPosition.y
	          )
	        } else {
	          warn(
	            iframeId,
	            'Unable to scroll to requested position, window.parentIFrame not found'
	          )
	        }
	      }
	
	      var offset = addOffset
	          ? getElementPosition(messageData.iframe)
	          : { x: 0, y: 0 },
	        newPosition = calcOffset()
	
	      log(
	        iframeId,
	        'Reposition requested from iFrame (offset x:' +
	          offset.x +
	          ' y:' +
	          offset.y +
	          ')'
	      )
	
	      if (window.top !== window.self) {
	        scrollParent()
	      } else {
	        reposition()
	      }
	    }
	
	    function scrollTo() {
	      if (false !== on('onScroll', pagePosition)) {
	        setPagePosition(iframeId)
	      } else {
	        unsetPagePosition()
	      }
	    }
	
	    function findTarget(location) {
	      function jumpToTarget() {
	        var jumpPosition = getElementPosition(target)
	
	        log(
	          iframeId,
	          'Moving to in page link (#' +
	            hash +
	            ') at x: ' +
	            jumpPosition.x +
	            ' y: ' +
	            jumpPosition.y
	        )
	        pagePosition = {
	          x: jumpPosition.x,
	          y: jumpPosition.y
	        }
	
	        scrollTo()
	        log(iframeId, '--')
	      }
	
	      function jumpToParent() {
	        if (window.parentIFrame) {
	          window.parentIFrame.moveToAnchor(hash)
	        } else {
	          log(
	            iframeId,
	            'In page link #' +
	              hash +
	              ' not found and window.parentIFrame not found'
	          )
	        }
	      }
	
	      var hash = location.split('#')[1] || '',
	        hashData = decodeURIComponent(hash),
	        target =
	          document.getElementById(hashData) ||
	          document.getElementsByName(hashData)[0]
	
	      if (target) {
	        jumpToTarget()
	      } else if (window.top !== window.self) {
	        jumpToParent()
	      } else {
	        log(iframeId, 'In page link #' + hash + ' not found')
	      }
	    }
	
	    function on(funcName, val) {
	      return chkEvent(iframeId, funcName, val)
	    }
	
	    function actionMsg() {
	      if (settings[iframeId] && settings[iframeId].firstRun) firstRun()
	
	      switch (messageData.type) {
	        case 'close':
	          closeIFrame(messageData.iframe)
	          break
	
	        case 'message':
	          forwardMsgFromIFrame(getMsgBody(6))
	          break
	
	        case 'autoResize':
	          settings[iframeId].autoResize = JSON.parse(getMsgBody(9))
	          break
	
	        case 'scrollTo':
	          scrollRequestFromChild(false)
	          break
	
	        case 'scrollToOffset':
	          scrollRequestFromChild(true)
	          break
	
	        case 'pageInfo':
	          sendPageInfoToIframe(
	            settings[iframeId] && settings[iframeId].iframe,
	            iframeId
	          )
	          startPageInfoMonitor()
	          break
	
	        case 'pageInfoStop':
	          stopPageInfoMonitor()
	          break
	
	        case 'inPageLink':
	          findTarget(getMsgBody(9))
	          break
	
	        case 'reset':
	          resetIFrame(messageData)
	          break
	
	        case 'init':
	          resizeIFrame()
	          on('onInit', messageData.iframe)
	          break
	
	        default:
	          resizeIFrame()
	      }
	    }
	
	    function hasSettings(iframeId) {
	      var retBool = true
	
	      if (!settings[iframeId]) {
	        retBool = false
	        warn(
	          messageData.type +
	            ' No settings for ' +
	            iframeId +
	            '. Message was: ' +
	            msg
	        )
	      }
	
	      return retBool
	    }
	
	    function iFrameReadyMsgReceived() {
	      // eslint-disable-next-line no-restricted-syntax, guard-for-in
	      for (var iframeId in settings) {
	        trigger(
	          'iFrame requested init',
	          createOutgoingMsg(iframeId),
	          settings[iframeId].iframe,
	          iframeId
	        )
	      }
	    }
	
	    function firstRun() {
	      if (settings[iframeId]) {
	        settings[iframeId].firstRun = false
	      }
	    }
	
	    var msg = event.data,
	      messageData = {},
	      iframeId = null
	
	    if ('[iFrameResizerChild]Ready' === msg) {
	      iFrameReadyMsgReceived()
	    } else if (isMessageForUs()) {
	      messageData = processMsg()
	      iframeId = messageData.id
	      if (settings[iframeId]) {
	        settings[iframeId].loaded = true
	      }
	
	      if (!isMessageFromMetaParent() && hasSettings(iframeId)) {
	        log(iframeId, 'Received: ' + msg)
	
	        if (checkIFrameExists() && isMessageFromIFrame()) {
	          actionMsg()
	        }
	      }
	    } else {
	      info(iframeId, 'Ignored: ' + msg)
	    }
	  }
	
	  function chkEvent(iframeId, funcName, val) {
	    var func = null,
	      retVal = null
	
	    if (settings[iframeId]) {
	      func = settings[iframeId][funcName]
	
	      if ('function' === typeof func) {
	        retVal = func(val)
	      } else {
	        throw new TypeError(
	          funcName + ' on iFrame[' + iframeId + '] is not a function'
	        )
	      }
	    }
	
	    return retVal
	  }
	
	  function removeIframeListeners(iframe) {
	    var iframeId = iframe.id
	    delete settings[iframeId]
	  }
	
	  function closeIFrame(iframe) {
	    var iframeId = iframe.id
	    if (chkEvent(iframeId, 'onClose', iframeId) === false) {
	      log(iframeId, 'Close iframe cancelled by onClose event')
	      return
	    }
	    log(iframeId, 'Removing iFrame: ' + iframeId)
	
	    try {
	      // Catch race condition error with React
	      if (iframe.parentNode) {
	        iframe.parentNode.removeChild(iframe)
	      }
	    } catch (error) {
	      warn(error)
	    }
	
	    chkEvent(iframeId, 'onClosed', iframeId)
	    log(iframeId, '--')
	    removeIframeListeners(iframe)
	  }
	
	  function getPagePosition(iframeId) {
	    if (null === pagePosition) {
	      pagePosition = {
	        x:
	          window.pageXOffset !== undefined
	            ? window.pageXOffset
	            : document.documentElement.scrollLeft,
	        y:
	          window.pageYOffset !== undefined
	            ? window.pageYOffset
	            : document.documentElement.scrollTop
	      }
	      log(
	        iframeId,
	        'Get page position: ' + pagePosition.x + ',' + pagePosition.y
	      )
	    }
	  }
	
	  function setPagePosition(iframeId) {
	    if (null !== pagePosition) {
	      window.scrollTo(pagePosition.x, pagePosition.y)
	      log(
	        iframeId,
	        'Set page position: ' + pagePosition.x + ',' + pagePosition.y
	      )
	      unsetPagePosition()
	    }
	  }
	
	  function unsetPagePosition() {
	    pagePosition = null
	  }
	
	  function resetIFrame(messageData) {
	    function reset() {
	      setSize(messageData)
	      trigger('reset', 'reset', messageData.iframe, messageData.id)
	    }
	
	    log(
	      messageData.id,
	      'Size reset requested by ' +
	        ('init' === messageData.type ? 'host page' : 'iFrame')
	    )
	    getPagePosition(messageData.id)
	    syncResize(reset, messageData, 'reset')
	  }
	
	  function setSize(messageData) {
	    function setDimension(dimension) {
	      if (!messageData.id) {
	        log('undefined', 'messageData id not set')
	        return
	      }
	      messageData.iframe.style[dimension] = messageData[dimension] + 'px'
	      log(
	        messageData.id,
	        'IFrame (' +
	          iframeId +
	          ') ' +
	          dimension +
	          ' set to ' +
	          messageData[dimension] +
	          'px'
	      )
	    }
	
	    function chkZero(dimension) {
	      // FireFox sets dimension of hidden iFrames to zero.
	      // So if we detect that set up an event to check for
	      // when iFrame becomes visible.
	
	      /* istanbul ignore next */ // Not testable in PhantomJS
	      if (!hiddenCheckEnabled && '0' === messageData[dimension]) {
	        hiddenCheckEnabled = true
	        log(iframeId, 'Hidden iFrame detected, creating visibility listener')
	        fixHiddenIFrames()
	      }
	    }
	
	    function processDimension(dimension) {
	      setDimension(dimension)
	      chkZero(dimension)
	    }
	
	    var iframeId = messageData.iframe.id
	
	    if (settings[iframeId]) {
	      if (settings[iframeId].sizeHeight) {
	        processDimension('height')
	      }
	      if (settings[iframeId].sizeWidth) {
	        processDimension('width')
	      }
	    }
	  }
	
	  function syncResize(func, messageData, doNotSync) {
	    /* istanbul ignore if */ // Not testable in PhantomJS
	    if (doNotSync !== messageData.type && requestAnimationFrame &&
	        // including check for jasmine because had trouble getting spy to work in unit test using requestAnimationFrame
	        !window.jasmine) {
	      log(messageData.id, 'Requesting animation frame')
	      requestAnimationFrame(func)
	    } else {
	      func()
	    }
	  }
	
	  function trigger(calleeMsg, msg, iframe, id, noResponseWarning) {
	    function postMessageToIFrame() {
	      var target = settings[id] && settings[id].targetOrigin
	      log(
	        id,
	        '[' +
	          calleeMsg +
	          '] Sending msg to iframe[' +
	          id +
	          '] (' +
	          msg +
	          ') targetOrigin: ' +
	          target
	      )
	      iframe.contentWindow.postMessage(msgId + msg, target)
	    }
	
	    function iFrameNotFound() {
	      warn(id, '[' + calleeMsg + '] IFrame(' + id + ') not found')
	    }
	
	    function chkAndSend() {
	      if (
	        iframe &&
	        'contentWindow' in iframe &&
	        null !== iframe.contentWindow
	      ) {
	        // Null test for PhantomJS
	        postMessageToIFrame()
	      } else {
	        iFrameNotFound()
	      }
	    }
	
	    function warnOnNoResponse() {
	      function warning() {
	        if (settings[id] && !settings[id].loaded && !errorShown) {
	          errorShown = true
	          warn(
	            id,
	            'IFrame has not responded within ' +
	              settings[id].warningTimeout / 1000 +
	              ' seconds. Check iFrameResizer.contentWindow.js has been loaded in iFrame. This message can be ignored if everything is working, or you can set the warningTimeout option to a higher value or zero to suppress this warning.'
	          )
	        }
	      }
	
	      if (
	        !!noResponseWarning &&
	        settings[id] &&
	        !!settings[id].warningTimeout
	      ) {
	        settings[id].msgTimeout = setTimeout(
	          warning,
	          settings[id].warningTimeout
	        )
	      }
	    }
	
	    var errorShown = false
	
	    id = id || iframe.id
	
	    if (settings[id]) {
	      chkAndSend()
	      warnOnNoResponse()
	    }
	  }
	
	  function createOutgoingMsg(iframeId) {
	    return (
	      iframeId +
	      ':' +
	      settings[iframeId].bodyMarginV1 +
	      ':' +
	      settings[iframeId].sizeWidth +
	      ':' +
	      settings[iframeId].log +
	      ':' +
	      settings[iframeId].interval +
	      ':' +
	      settings[iframeId].enablePublicMethods +
	      ':' +
	      settings[iframeId].autoResize +
	      ':' +
	      settings[iframeId].bodyMargin +
	      ':' +
	      settings[iframeId].heightCalculationMethod +
	      ':' +
	      settings[iframeId].bodyBackground +
	      ':' +
	      settings[iframeId].bodyPadding +
	      ':' +
	      settings[iframeId].tolerance +
	      ':' +
	      settings[iframeId].inPageLinks +
	      ':' +
	      settings[iframeId].resizeFrom +
	      ':' +
	      settings[iframeId].widthCalculationMethod
	    )
	  }
	
	  function setupIFrame(iframe, options) {
	    function setLimits() {
	      function addStyle(style) {
	        if (
	          Infinity !== settings[iframeId][style] &&
	          0 !== settings[iframeId][style]
	        ) {
	          iframe.style[style] = settings[iframeId][style] + 'px'
	          log(
	            iframeId,
	            'Set ' + style + ' = ' + settings[iframeId][style] + 'px'
	          )
	        }
	      }
	
	      function chkMinMax(dimension) {
	        if (
	          settings[iframeId]['min' + dimension] >
	          settings[iframeId]['max' + dimension]
	        ) {
	          throw new Error(
	            'Value for min' +
	              dimension +
	              ' can not be greater than max' +
	              dimension
	          )
	        }
	      }
	
	      chkMinMax('Height')
	      chkMinMax('Width')
	
	      addStyle('maxHeight')
	      addStyle('minHeight')
	      addStyle('maxWidth')
	      addStyle('minWidth')
	    }
	
	    function newId() {
	      var id = (options && options.id) || defaults.id + count++
	      if (null !== document.getElementById(id)) {
	        id += count++
	      }
	      return id
	    }
	
	    function ensureHasId(iframeId) {
	      if ('' === iframeId) {
	        // eslint-disable-next-line no-multi-assign
	        iframe.id = iframeId = newId()
	        logEnabled = (options || {}).log
	        log(
	          iframeId,
	          'Added missing iframe ID: ' + iframeId + ' (' + iframe.src + ')'
	        )
	      }
	
	      return iframeId
	    }
	
	    function setScrolling() {
	      log(
	        iframeId,
	        'IFrame scrolling ' +
	          (settings[iframeId] && settings[iframeId].scrolling
	            ? 'enabled'
	            : 'disabled') +
	          ' for ' +
	          iframeId
	      )
	      iframe.style.overflow =
	        false === (settings[iframeId] && settings[iframeId].scrolling)
	          ? 'hidden'
	          : 'auto'
	      switch (settings[iframeId] && settings[iframeId].scrolling) {
	        case 'omit':
	          break
	
	        case true:
	          iframe.scrolling = 'yes'
	          break
	
	        case false:
	          iframe.scrolling = 'no'
	          break
	
	        default:
	          iframe.scrolling = settings[iframeId]
	            ? settings[iframeId].scrolling
	            : 'no'
	      }
	    }
	
	    // The V1 iFrame script expects an int, where as in V2 expects a CSS
	    // string value such as '1px 3em', so if we have an int for V2, set V1=V2
	    // and then convert V2 to a string PX value.
	    function setupBodyMarginValues() {
	      if (
	        'number' ===
	          typeof (settings[iframeId] && settings[iframeId].bodyMargin) ||
	        '0' === (settings[iframeId] && settings[iframeId].bodyMargin)
	      ) {
	        settings[iframeId].bodyMarginV1 = settings[iframeId].bodyMargin
	        settings[iframeId].bodyMargin =
	          '' + settings[iframeId].bodyMargin + 'px'
	      }
	    }
	
	    function checkReset() {
	      // Reduce scope of firstRun to function, because IE8's JS execution
	      // context stack is borked and this value gets externally
	      // changed midway through running this function!!!
	      var firstRun = settings[iframeId] && settings[iframeId].firstRun,
	        resetRequertMethod =
	          settings[iframeId] &&
	          settings[iframeId].heightCalculationMethod in resetRequiredMethods
	
	      if (!firstRun && resetRequertMethod) {
	        resetIFrame({ iframe: iframe, height: 0, width: 0, type: 'init' })
	      }
	    }
	
	    function setupIFrameObject() {
	      if (settings[iframeId]) {
	        settings[iframeId].iframe.iFrameResizer = {
	          close: closeIFrame.bind(null, settings[iframeId].iframe),
	
	          removeListeners: removeIframeListeners.bind(
	            null,
	            settings[iframeId].iframe
	          ),
	
	          resize: trigger.bind(
	            null,
	            'Window resize',
	            'resize',
	            settings[iframeId].iframe
	          ),
	
	          moveToAnchor: function(anchor) {
	            trigger(
	              'Move to anchor',
	              'moveToAnchor:' + anchor,
	              settings[iframeId].iframe,
	              iframeId
	            )
	          },
	
	          sendMessage: function(message) {
	            message = JSON.stringify(message)
	            trigger(
	              'Send Message',
	              'message:' + message,
	              settings[iframeId].iframe,
	              iframeId
	            )
	          }
	        }
	      }
	    }
	
	    // We have to call trigger twice, as we can not be sure if all
	    // iframes have completed loading when this code runs. The
	    // event listener also catches the page changing in the iFrame.
	    function init(msg) {
	      function iFrameLoaded() {
	        trigger('iFrame.onload', msg, iframe, undefined, true)
	        checkReset()
	      }
	
	      function createDestroyObserver(MutationObserver) {
	        if (!iframe.parentNode) {
	          return
	        }
	
	        var destroyObserver = new MutationObserver(function(mutations) {
	          mutations.forEach(function(mutation) {
	            var removedNodes = Array.prototype.slice.call(mutation.removedNodes) // Transform NodeList into an Array
	            removedNodes.forEach(function(removedNode) {
	              if (removedNode === iframe) {
	                closeIFrame(iframe)
	              }
	            })
	          })
	        })
	        destroyObserver.observe(iframe.parentNode, {
	          childList: true
	        })
	      }
	
	      var MutationObserver = getMutationObserver()
	      if (MutationObserver) {
	        createDestroyObserver(MutationObserver)
	      }
	
	      addEventListener(iframe, 'load', iFrameLoaded)
	      trigger('init', msg, iframe, undefined, true)
	    }
	
	    function checkOptions(options) {
	      if ('object' !== typeof options) {
	        throw new TypeError('Options is not an object')
	      }
	    }
	
	    function copyOptions(options) {
	      // eslint-disable-next-line no-restricted-syntax
	      for (var option in defaults) {
	        if (Object.prototype.hasOwnProperty.call(defaults, option)) {
	          settings[iframeId][option] = Object.prototype.hasOwnProperty.call(
	            options,
	            option
	          )
	            ? options[option]
	            : defaults[option]
	        }
	      }
	    }
	
	    function getTargetOrigin(remoteHost) {
	      return '' === remoteHost || null !== remoteHost.match(/^(about:blank|javascript:|file:\/\/)/) ? '*' : remoteHost
	    }
	
	    function depricate(key) {
	      var splitName = key.split('Callback')
	
	      if (splitName.length === 2) {
	        var name =
	          'on' + splitName[0].charAt(0).toUpperCase() + splitName[0].slice(1)
	        this[name] = this[key]
	        delete this[key]
	        warn(
	          iframeId,
	          "Deprecated: '" +
	            key +
	            "' has been renamed '" +
	            name +
	            "'. The old method will be removed in the next major version."
	        )
	      }
	    }
	
	    function processOptions(options) {
	      options = options || {}
	      settings[iframeId] = {
	        firstRun: true,
	        iframe: iframe,
	        remoteHost:
	          iframe.src &&
	          iframe.src
	            .split('/')
	            .slice(0, 3)
	            .join('/')
	      }
	
	      checkOptions(options)
	      Object.keys(options).forEach(depricate, options)
	      copyOptions(options)
	
	      if (settings[iframeId]) {
	        settings[iframeId].targetOrigin =
	          true === settings[iframeId].checkOrigin
	            ? getTargetOrigin(settings[iframeId].remoteHost)
	            : '*'
	      }
	    }
	
	    function beenHere() {
	      return iframeId in settings && 'iFrameResizer' in iframe
	    }
	
	    var iframeId = ensureHasId(iframe.id)
	
	    if (!beenHere()) {
	      processOptions(options)
	      setScrolling()
	      setLimits()
	      setupBodyMarginValues()
	      init(createOutgoingMsg(iframeId))
	      setupIFrameObject()
	    } else {
	      warn(iframeId, 'Ignored iFrame, already setup.')
	    }
	  }
	
	  function debouce(fn, time) {
	    if (null === timer) {
	      timer = setTimeout(function() {
	        timer = null
	        fn()
	      }, time)
	    }
	  }
	
	  var frameTimer = {}
	  function debounceFrameEvents(fn, time, frameId) {
	    if (!frameTimer[frameId]) {
	      frameTimer[frameId] = setTimeout(function() {
	        frameTimer[frameId] = null
	        fn()
	      }, time)
	    }
	  }
	
	  // Not testable in PhantomJS
	  /* istanbul ignore next */
	
	  function fixHiddenIFrames() {
	    function checkIFrames() {
	      function checkIFrame(settingId) {
	        function chkDimension(dimension) {
	          return (
	            '0px' ===
	            (settings[settingId] && settings[settingId].iframe.style[dimension])
	          )
	        }
	
	        function isVisible(el) {
	          return null !== el.offsetParent
	        }
	
	        if (
	          settings[settingId] &&
	          isVisible(settings[settingId].iframe) &&
	          (chkDimension('height') || chkDimension('width'))
	        ) {
	          trigger(
	            'Visibility change',
	            'resize',
	            settings[settingId].iframe,
	            settingId
	          )
	        }
	      }
	
	      Object.keys(settings).forEach(function(key) {
	        checkIFrame(key)
	      })
	    }
	
	    function mutationObserved(mutations) {
	      log(
	        'window',
	        'Mutation observed: ' + mutations[0].target + ' ' + mutations[0].type
	      )
	      debouce(checkIFrames, 16)
	    }
	
	    function createMutationObserver() {
	      var target = document.querySelector('body'),
	        config = {
	          attributes: true,
	          attributeOldValue: false,
	          characterData: true,
	          characterDataOldValue: false,
	          childList: true,
	          subtree: true
	        },
	        observer = new MutationObserver(mutationObserved)
	
	      observer.observe(target, config)
	    }
	
	    var MutationObserver = getMutationObserver()
	    if (MutationObserver) {
	      createMutationObserver()
	    }
	  }
	
	  function resizeIFrames(event) {
	    function resize() {
	      sendTriggerMsg('Window ' + event, 'resize')
	    }
	
	    log('window', 'Trigger event: ' + event)
	    debouce(resize, 16)
	  }
	
	  // Not testable in PhantomJS
	  /* istanbul ignore next */
	  function tabVisible() {
	    function resize() {
	      sendTriggerMsg('Tab Visable', 'resize')
	    }
	
	    if ('hidden' !== document.visibilityState) {
	      log('document', 'Trigger event: Visiblity change')
	      debouce(resize, 16)
	    }
	  }
	
	  function sendTriggerMsg(eventName, event) {
	    function isIFrameResizeEnabled(iframeId) {
	      return (
	        settings[iframeId] &&
	        'parent' === settings[iframeId].resizeFrom &&
	        settings[iframeId].autoResize &&
	        !settings[iframeId].firstRun
	      )
	    }
	
	    Object.keys(settings).forEach(function(iframeId) {
	      if (isIFrameResizeEnabled(iframeId)) {
	        trigger(eventName, event, settings[iframeId].iframe, iframeId)
	      }
	    })
	  }
	
	  function setupEventListeners() {
	    addEventListener(window, 'message', iFrameListener)
	
	    addEventListener(window, 'resize', function() {
	      resizeIFrames('resize')
	    })
	
	    addEventListener(document, 'visibilitychange', tabVisible)
	
	    addEventListener(document, '-webkit-visibilitychange', tabVisible)
	  }
	
	  function factory() {
	    function init(options, element) {
	      function chkType() {
	        if (!element.tagName) {
	          throw new TypeError('Object is not a valid DOM element')
	        } else if ('IFRAME' !== element.tagName.toUpperCase()) {
	          throw new TypeError(
	            'Expected <IFRAME> tag, found <' + element.tagName + '>'
	          )
	        }
	      }
	
	      if (element) {
	        chkType()
	        setupIFrame(element, options)
	        iFrames.push(element)
	      }
	    }
	
	    function warnDeprecatedOptions(options) {
	      if (options && options.enablePublicMethods) {
	        warn(
	          'enablePublicMethods option has been removed, public methods are now always available in the iFrame'
	        )
	      }
	    }
	
	    var iFrames
	
	    setupRequestAnimationFrame()
	    setupEventListeners()
	
	    return function iFrameResizeF(options, target) {
	      iFrames = [] // Only return iFrames past in on this call
	
	      warnDeprecatedOptions(options)
	
	      switch (typeof target) {
	        case 'undefined':
	        case 'string':
	          Array.prototype.forEach.call(
	            document.querySelectorAll(target || 'iframe'),
	            init.bind(undefined, options)
	          )
	          break
	
	        case 'object':
	          init(options, target)
	          break
	
	        default:
	          throw new TypeError('Unexpected data type (' + typeof target + ')')
	      }
	
	      return iFrames
	    }
	  }
	
	  function createJQueryPublicMethod($) {
	    if (!$.fn) {
	      info('', 'Unable to bind to jQuery, it is not fully loaded.')
	    } else if (!$.fn.iFrameResize) {
	      $.fn.iFrameResize = function $iFrameResizeF(options) {
	        function init(index, element) {
	          setupIFrame(element, options)
	        }
	
	        return this.filter('iframe')
	          .each(init)
	          .end()
	      }
	    }
	  }
	
	  if (window.jQuery) {
	    createJQueryPublicMethod(window.jQuery)
	  }
	
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
	  } else if (typeof module === 'object' && typeof module.exports === 'object') {
	    // Node for browserfy
	    module.exports = factory()
	  }
	  window.iFrameResize = window.iFrameResize || factory()
	})()


/***/ }),
/* 2311 */
/***/ (function(module, exports) {

	/*
	 * File: iframeResizer.contentWindow.js
	 * Desc: Include this file in any page being loaded into an iframe
	 *       to force the iframe to resize to the content size.
	 * Requires: iframeResizer.js on host page.
	 * Doc: https://github.com/davidjbradshaw/iframe-resizer
	 * Author: David J. Bradshaw - dave@bradshaw.net
	 *
	 */
	
	// eslint-disable-next-line sonarjs/cognitive-complexity, no-shadow-restricted-names
	;(function(undefined) {
	  if (typeof window === 'undefined') return // don't run for server side render
	
	  var autoResize = true,
	    base = 10,
	    bodyBackground = '',
	    bodyMargin = 0,
	    bodyMarginStr = '',
	    bodyObserver = null,
	    bodyPadding = '',
	    calculateWidth = false,
	    doubleEventList = { resize: 1, click: 1 },
	    eventCancelTimer = 128,
	    firstRun = true,
	    height = 1,
	    heightCalcModeDefault = 'bodyOffset',
	    heightCalcMode = heightCalcModeDefault,
	    initLock = true,
	    initMsg = '',
	    inPageLinks = {},
	    interval = 32,
	    intervalTimer = null,
	    logging = false,
	    msgID = '[iFrameSizer]', // Must match host page msg ID
	    msgIdLen = msgID.length,
	    myID = '',
	    resetRequiredMethods = {
	      max: 1,
	      min: 1,
	      bodyScroll: 1,
	      documentElementScroll: 1
	    },
	    resizeFrom = 'child',
	    sendPermit = true,
	    target = window.parent,
	    targetOriginDefault = '*',
	    tolerance = 0,
	    triggerLocked = false,
	    triggerLockedTimer = null,
	    throttledTimer = 16,
	    width = 1,
	    widthCalcModeDefault = 'scroll',
	    widthCalcMode = widthCalcModeDefault,
	    win = window,
	    onMessage = function() {
	      warn('onMessage function not defined')
	    },
	    onReady = function() {},
	    onPageInfo = function() {},
	    customCalcMethods = {
	      height: function() {
	        warn('Custom height calculation function not defined')
	        return document.documentElement.offsetHeight
	      },
	      width: function() {
	        warn('Custom width calculation function not defined')
	        return document.body.scrollWidth
	      }
	    },
	    eventHandlersByName = {},
	    passiveSupported = false
	
	  function noop() {}
	
	  try {
	    var options = Object.create(
	      {},
	      {
	        passive: {
	          get: function() {
	            passiveSupported = true
	          }
	        }
	      }
	    )
	    window.addEventListener('test', noop, options)
	    window.removeEventListener('test', noop, options)
	  } catch (error) {
	    /* */
	  }
	
	  function addEventListener(el, evt, func, options) {
	    el.addEventListener(evt, func, passiveSupported ? options || {} : false)
	  }
	
	  function removeEventListener(el, evt, func) {
	    el.removeEventListener(evt, func, false)
	  }
	
	  function capitalizeFirstLetter(string) {
	    return string.charAt(0).toUpperCase() + string.slice(1)
	  }
	
	  // Based on underscore.js
	  function throttle(func) {
	    var context,
	      args,
	      result,
	      timeout = null,
	      previous = 0,
	      later = function() {
	        previous = getNow()
	        timeout = null
	        result = func.apply(context, args)
	        if (!timeout) {
	          // eslint-disable-next-line no-multi-assign
	          context = args = null
	        }
	      }
	
	    return function() {
	      var now = getNow()
	
	      if (!previous) {
	        previous = now
	      }
	
	      var remaining = throttledTimer - (now - previous)
	
	      context = this
	      args = arguments
	
	      if (remaining <= 0 || remaining > throttledTimer) {
	        if (timeout) {
	          clearTimeout(timeout)
	          timeout = null
	        }
	
	        previous = now
	        result = func.apply(context, args)
	
	        if (!timeout) {
	          // eslint-disable-next-line no-multi-assign
	          context = args = null
	        }
	      } else if (!timeout) {
	        timeout = setTimeout(later, remaining)
	      }
	
	      return result
	    }
	  }
	
	  var getNow =
	    Date.now ||
	    function() {
	      /* istanbul ignore next */ // Not testable in PhantonJS
	      return new Date().getTime()
	    }
	
	  function formatLogMsg(msg) {
	    return msgID + '[' + myID + '] ' + msg
	  }
	
	  function log(msg) {
	    if (logging && 'object' === typeof window.console) {
	      // eslint-disable-next-line no-console
	      console.log(formatLogMsg(msg))
	    }
	  }
	
	  function warn(msg) {
	    if ('object' === typeof window.console) {
	      // eslint-disable-next-line no-console
	      console.warn(formatLogMsg(msg))
	    }
	  }
	
	  function init() {
	    readDataFromParent()
	    log('Initialising iFrame (' + location.href + ')')
	    readDataFromPage()
	    setMargin()
	    setBodyStyle('background', bodyBackground)
	    setBodyStyle('padding', bodyPadding)
	    injectClearFixIntoBodyElement()
	    checkHeightMode()
	    checkWidthMode()
	    stopInfiniteResizingOfIFrame()
	    setupPublicMethods()
	    startEventListeners()
	    inPageLinks = setupInPageLinks()
	    sendSize('init', 'Init message from host page')
	    onReady()
	  }
	
	  function readDataFromParent() {
	    function strBool(str) {
	      return 'true' === str
	    }
	
	    var data = initMsg.substr(msgIdLen).split(':')
	
	    myID = data[0]
	    bodyMargin = undefined !== data[1] ? Number(data[1]) : bodyMargin // For V1 compatibility
	    calculateWidth = undefined !== data[2] ? strBool(data[2]) : calculateWidth
	    logging = undefined !== data[3] ? strBool(data[3]) : logging
	    interval = undefined !== data[4] ? Number(data[4]) : interval
	    autoResize = undefined !== data[6] ? strBool(data[6]) : autoResize
	    bodyMarginStr = data[7]
	    heightCalcMode = undefined !== data[8] ? data[8] : heightCalcMode
	    bodyBackground = data[9]
	    bodyPadding = data[10]
	    tolerance = undefined !== data[11] ? Number(data[11]) : tolerance
	    inPageLinks.enable = undefined !== data[12] ? strBool(data[12]) : false
	    resizeFrom = undefined !== data[13] ? data[13] : resizeFrom
	    widthCalcMode = undefined !== data[14] ? data[14] : widthCalcMode
	  }
	
	  function depricate(key) {
	    var splitName = key.split('Callback')
	
	    if (splitName.length === 2) {
	      var name =
	        'on' + splitName[0].charAt(0).toUpperCase() + splitName[0].slice(1)
	      this[name] = this[key]
	      delete this[key]
	      warn(
	        "Deprecated: '" +
	          key +
	          "' has been renamed '" +
	          name +
	          "'. The old method will be removed in the next major version."
	      )
	    }
	  }
	
	  function readDataFromPage() {
	    function readData() {
	      var data = window.iFrameResizer
	
	      log('Reading data from page: ' + JSON.stringify(data))
	      Object.keys(data).forEach(depricate, data)
	
	      onMessage = 'onMessage' in data ? data.onMessage : onMessage
	      onReady = 'onReady' in data ? data.onReady : onReady
	      targetOriginDefault =
	        'targetOrigin' in data ? data.targetOrigin : targetOriginDefault
	      heightCalcMode =
	        'heightCalculationMethod' in data
	          ? data.heightCalculationMethod
	          : heightCalcMode
	      widthCalcMode =
	        'widthCalculationMethod' in data
	          ? data.widthCalculationMethod
	          : widthCalcMode
	    }
	
	    function setupCustomCalcMethods(calcMode, calcFunc) {
	      if ('function' === typeof calcMode) {
	        log('Setup custom ' + calcFunc + 'CalcMethod')
	        customCalcMethods[calcFunc] = calcMode
	        calcMode = 'custom'
	      }
	
	      return calcMode
	    }
	
	    if (
	      'iFrameResizer' in window &&
	      Object === window.iFrameResizer.constructor
	    ) {
	      readData()
	      heightCalcMode = setupCustomCalcMethods(heightCalcMode, 'height')
	      widthCalcMode = setupCustomCalcMethods(widthCalcMode, 'width')
	    }
	
	    log('TargetOrigin for parent set to: ' + targetOriginDefault)
	  }
	
	  function chkCSS(attr, value) {
	    if (-1 !== value.indexOf('-')) {
	      warn('Negative CSS value ignored for ' + attr)
	      value = ''
	    }
	    return value
	  }
	
	  function setBodyStyle(attr, value) {
	    if (undefined !== value && '' !== value && 'null' !== value) {
	      document.body.style[attr] = value
	      log('Body ' + attr + ' set to "' + value + '"')
	    }
	  }
	
	  function setMargin() {
	    // If called via V1 script, convert bodyMargin from int to str
	    if (undefined === bodyMarginStr) {
	      bodyMarginStr = bodyMargin + 'px'
	    }
	
	    setBodyStyle('margin', chkCSS('margin', bodyMarginStr))
	  }
	
	  function stopInfiniteResizingOfIFrame() {
	    document.documentElement.style.height = ''
	    document.body.style.height = ''
	    log('HTML & body height set to "auto"')
	  }
	
	  function manageTriggerEvent(options) {
	    var listener = {
	      add: function(eventName) {
	        function handleEvent() {
	          sendSize(options.eventName, options.eventType)
	        }
	
	        eventHandlersByName[eventName] = handleEvent
	
	        addEventListener(window, eventName, handleEvent, { passive: true })
	      },
	      remove: function(eventName) {
	        var handleEvent = eventHandlersByName[eventName]
	        delete eventHandlersByName[eventName]
	
	        removeEventListener(window, eventName, handleEvent)
	      }
	    }
	
	    if (options.eventNames && Array.prototype.map) {
	      options.eventName = options.eventNames[0]
	      options.eventNames.map(listener[options.method])
	    } else {
	      listener[options.method](options.eventName)
	    }
	
	    log(
	      capitalizeFirstLetter(options.method) +
	        ' event listener: ' +
	        options.eventType
	    )
	  }
	
	  function manageEventListeners(method) {
	    manageTriggerEvent({
	      method: method,
	      eventType: 'Animation Start',
	      eventNames: ['animationstart', 'webkitAnimationStart']
	    })
	    manageTriggerEvent({
	      method: method,
	      eventType: 'Animation Iteration',
	      eventNames: ['animationiteration', 'webkitAnimationIteration']
	    })
	    manageTriggerEvent({
	      method: method,
	      eventType: 'Animation End',
	      eventNames: ['animationend', 'webkitAnimationEnd']
	    })
	    manageTriggerEvent({
	      method: method,
	      eventType: 'Input',
	      eventName: 'input'
	    })
	    manageTriggerEvent({
	      method: method,
	      eventType: 'Mouse Up',
	      eventName: 'mouseup'
	    })
	    manageTriggerEvent({
	      method: method,
	      eventType: 'Mouse Down',
	      eventName: 'mousedown'
	    })
	    manageTriggerEvent({
	      method: method,
	      eventType: 'Orientation Change',
	      eventName: 'orientationchange'
	    })
	    manageTriggerEvent({
	      method: method,
	      eventType: 'Print',
	      eventName: ['afterprint', 'beforeprint']
	    })
	    manageTriggerEvent({
	      method: method,
	      eventType: 'Ready State Change',
	      eventName: 'readystatechange'
	    })
	    manageTriggerEvent({
	      method: method,
	      eventType: 'Touch Start',
	      eventName: 'touchstart'
	    })
	    manageTriggerEvent({
	      method: method,
	      eventType: 'Touch End',
	      eventName: 'touchend'
	    })
	    manageTriggerEvent({
	      method: method,
	      eventType: 'Touch Cancel',
	      eventName: 'touchcancel'
	    })
	    manageTriggerEvent({
	      method: method,
	      eventType: 'Transition Start',
	      eventNames: [
	        'transitionstart',
	        'webkitTransitionStart',
	        'MSTransitionStart',
	        'oTransitionStart',
	        'otransitionstart'
	      ]
	    })
	    manageTriggerEvent({
	      method: method,
	      eventType: 'Transition Iteration',
	      eventNames: [
	        'transitioniteration',
	        'webkitTransitionIteration',
	        'MSTransitionIteration',
	        'oTransitionIteration',
	        'otransitioniteration'
	      ]
	    })
	    manageTriggerEvent({
	      method: method,
	      eventType: 'Transition End',
	      eventNames: [
	        'transitionend',
	        'webkitTransitionEnd',
	        'MSTransitionEnd',
	        'oTransitionEnd',
	        'otransitionend'
	      ]
	    })
	    if ('child' === resizeFrom) {
	      manageTriggerEvent({
	        method: method,
	        eventType: 'IFrame Resized',
	        eventName: 'resize'
	      })
	    }
	  }
	
	  function checkCalcMode(calcMode, calcModeDefault, modes, type) {
	    if (calcModeDefault !== calcMode) {
	      if (!(calcMode in modes)) {
	        warn(
	          calcMode + ' is not a valid option for ' + type + 'CalculationMethod.'
	        )
	        calcMode = calcModeDefault
	      }
	      log(type + ' calculation method set to "' + calcMode + '"')
	    }
	
	    return calcMode
	  }
	
	  function checkHeightMode() {
	    heightCalcMode = checkCalcMode(
	      heightCalcMode,
	      heightCalcModeDefault,
	      getHeight,
	      'height'
	    )
	  }
	
	  function checkWidthMode() {
	    widthCalcMode = checkCalcMode(
	      widthCalcMode,
	      widthCalcModeDefault,
	      getWidth,
	      'width'
	    )
	  }
	
	  function startEventListeners() {
	    if (true === autoResize) {
	      manageEventListeners('add')
	      setupMutationObserver()
	    } else {
	      log('Auto Resize disabled')
	    }
	  }
	
	  //   function stopMsgsToParent() {
	  //     log('Disable outgoing messages')
	  //     sendPermit = false
	  //   }
	
	  //   function removeMsgListener() {
	  //     log('Remove event listener: Message')
	  //     removeEventListener(window, 'message', receiver)
	  //   }
	
	  function disconnectMutationObserver() {
	    if (null !== bodyObserver) {
	      /* istanbul ignore next */ // Not testable in PhantonJS
	      bodyObserver.disconnect()
	    }
	  }
	
	  function stopEventListeners() {
	    manageEventListeners('remove')
	    disconnectMutationObserver()
	    clearInterval(intervalTimer)
	  }
	
	  //   function teardown() {
	  //     stopMsgsToParent()
	  //     removeMsgListener()
	  //     if (true === autoResize) stopEventListeners()
	  //   }
	
	  function injectClearFixIntoBodyElement() {
	    var clearFix = document.createElement('div')
	    clearFix.style.clear = 'both'
	    // Guard against the following having been globally redefined in CSS.
	    clearFix.style.display = 'block'
	    clearFix.style.height = '0'
	    document.body.appendChild(clearFix)
	  }
	
	  function setupInPageLinks() {
	    function getPagePosition() {
	      return {
	        x:
	          window.pageXOffset !== undefined
	            ? window.pageXOffset
	            : document.documentElement.scrollLeft,
	        y:
	          window.pageYOffset !== undefined
	            ? window.pageYOffset
	            : document.documentElement.scrollTop
	      }
	    }
	
	    function getElementPosition(el) {
	      var elPosition = el.getBoundingClientRect(),
	        pagePosition = getPagePosition()
	
	      return {
	        x: parseInt(elPosition.left, 10) + parseInt(pagePosition.x, 10),
	        y: parseInt(elPosition.top, 10) + parseInt(pagePosition.y, 10)
	      }
	    }
	
	    function findTarget(location) {
	      function jumpToTarget(target) {
	        var jumpPosition = getElementPosition(target)
	
	        log(
	          'Moving to in page link (#' +
	            hash +
	            ') at x: ' +
	            jumpPosition.x +
	            ' y: ' +
	            jumpPosition.y
	        )
	        sendMsg(jumpPosition.y, jumpPosition.x, 'scrollToOffset') // X&Y reversed at sendMsg uses height/width
	      }
	
	      var hash = location.split('#')[1] || location, // Remove # if present
	        hashData = decodeURIComponent(hash),
	        target =
	          document.getElementById(hashData) ||
	          document.getElementsByName(hashData)[0]
	
	      if (undefined !== target) {
	        jumpToTarget(target)
	      } else {
	        log(
	          'In page link (#' +
	            hash +
	            ') not found in iFrame, so sending to parent'
	        )
	        sendMsg(0, 0, 'inPageLink', '#' + hash)
	      }
	    }
	
	    function checkLocationHash() {
	      if ('' !== location.hash && '#' !== location.hash) {
	        findTarget(location.href)
	      }
	    }
	
	    function bindAnchors() {
	      function setupLink(el) {
	        function linkClicked(e) {
	          e.preventDefault()
	
	          /* jshint validthis:true */
	          findTarget(this.getAttribute('href'))
	        }
	
	        if ('#' !== el.getAttribute('href')) {
	          addEventListener(el, 'click', linkClicked)
	        }
	      }
	
	      Array.prototype.forEach.call(
	        document.querySelectorAll('a[href^="#"]'),
	        setupLink
	      )
	    }
	
	    function bindLocationHash() {
	      addEventListener(window, 'hashchange', checkLocationHash)
	    }
	
	    function initCheck() {
	      // Check if page loaded with location hash after init resize
	      setTimeout(checkLocationHash, eventCancelTimer)
	    }
	
	    function enableInPageLinks() {
	      /* istanbul ignore else */ // Not testable in phantonJS
	      if (Array.prototype.forEach && document.querySelectorAll) {
	        log('Setting up location.hash handlers')
	        bindAnchors()
	        bindLocationHash()
	        initCheck()
	      } else {
	        warn(
	          'In page linking not fully supported in this browser! (See README.md for IE8 workaround)'
	        )
	      }
	    }
	
	    if (inPageLinks.enable) {
	      enableInPageLinks()
	    } else {
	      log('In page linking not enabled')
	    }
	
	    return {
	      findTarget: findTarget
	    }
	  }
	
	  function setupPublicMethods() {
	    log('Enable public methods')
	
	    win.parentIFrame = {
	      autoResize: function autoResizeF(resize) {
	        if (true === resize && false === autoResize) {
	          autoResize = true
	          startEventListeners()
	        } else if (false === resize && true === autoResize) {
	          autoResize = false
	          stopEventListeners()
	        }
	        sendMsg(0, 0, 'autoResize', JSON.stringify(autoResize))
	        return autoResize
	      },
	
	      close: function closeF() {
	        sendMsg(0, 0, 'close')
	        // teardown()
	      },
	
	      getId: function getIdF() {
	        return myID
	      },
	
	      getPageInfo: function getPageInfoF(callback) {
	        if ('function' === typeof callback) {
	          onPageInfo = callback
	          sendMsg(0, 0, 'pageInfo')
	        } else {
	          onPageInfo = function() {}
	          sendMsg(0, 0, 'pageInfoStop')
	        }
	      },
	
	      moveToAnchor: function moveToAnchorF(hash) {
	        inPageLinks.findTarget(hash)
	      },
	
	      reset: function resetF() {
	        resetIFrame('parentIFrame.reset')
	      },
	
	      scrollTo: function scrollToF(x, y) {
	        sendMsg(y, x, 'scrollTo') // X&Y reversed at sendMsg uses height/width
	      },
	
	      scrollToOffset: function scrollToF(x, y) {
	        sendMsg(y, x, 'scrollToOffset') // X&Y reversed at sendMsg uses height/width
	      },
	
	      sendMessage: function sendMessageF(msg, targetOrigin) {
	        sendMsg(0, 0, 'message', JSON.stringify(msg), targetOrigin)
	      },
	
	      setHeightCalculationMethod: function setHeightCalculationMethodF(
	        heightCalculationMethod
	      ) {
	        heightCalcMode = heightCalculationMethod
	        checkHeightMode()
	      },
	
	      setWidthCalculationMethod: function setWidthCalculationMethodF(
	        widthCalculationMethod
	      ) {
	        widthCalcMode = widthCalculationMethod
	        checkWidthMode()
	      },
	
	      setTargetOrigin: function setTargetOriginF(targetOrigin) {
	        log('Set targetOrigin: ' + targetOrigin)
	        targetOriginDefault = targetOrigin
	      },
	
	      size: function sizeF(customHeight, customWidth) {
	        var valString =
	          '' + (customHeight || '') + (customWidth ? ',' + customWidth : '')
	        sendSize(
	          'size',
	          'parentIFrame.size(' + valString + ')',
	          customHeight,
	          customWidth
	        )
	      }
	    }
	  }
	
	  function initInterval() {
	    if (0 !== interval) {
	      log('setInterval: ' + interval + 'ms')
	      intervalTimer = setInterval(function() {
	        sendSize('interval', 'setInterval: ' + interval)
	      }, Math.abs(interval))
	    }
	  }
	
	  // Not testable in PhantomJS
	  /* istanbul ignore next */
	  function setupBodyMutationObserver() {
	    function addImageLoadListners(mutation) {
	      function addImageLoadListener(element) {
	        if (false === element.complete) {
	          log('Attach listeners to ' + element.src)
	          element.addEventListener('load', imageLoaded, false)
	          element.addEventListener('error', imageError, false)
	          elements.push(element)
	        }
	      }
	
	      if (mutation.type === 'attributes' && mutation.attributeName === 'src') {
	        addImageLoadListener(mutation.target)
	      } else if (mutation.type === 'childList') {
	        Array.prototype.forEach.call(
	          mutation.target.querySelectorAll('img'),
	          addImageLoadListener
	        )
	      }
	    }
	
	    function removeFromArray(element) {
	      elements.splice(elements.indexOf(element), 1)
	    }
	
	    function removeImageLoadListener(element) {
	      log('Remove listeners from ' + element.src)
	      element.removeEventListener('load', imageLoaded, false)
	      element.removeEventListener('error', imageError, false)
	      removeFromArray(element)
	    }
	
	    function imageEventTriggered(event, type, typeDesc) {
	      removeImageLoadListener(event.target)
	      sendSize(type, typeDesc + ': ' + event.target.src, undefined, undefined)
	    }
	
	    function imageLoaded(event) {
	      imageEventTriggered(event, 'imageLoad', 'Image loaded')
	    }
	
	    function imageError(event) {
	      imageEventTriggered(event, 'imageLoadFailed', 'Image load failed')
	    }
	
	    function mutationObserved(mutations) {
	      sendSize(
	        'mutationObserver',
	        'mutationObserver: ' + mutations[0].target + ' ' + mutations[0].type
	      )
	
	      // Deal with WebKit / Blink asyncing image loading when tags are injected into the page
	      mutations.forEach(addImageLoadListners)
	    }
	
	    function createMutationObserver() {
	      var target = document.querySelector('body'),
	        config = {
	          attributes: true,
	          attributeOldValue: false,
	          characterData: true,
	          characterDataOldValue: false,
	          childList: true,
	          subtree: true
	        }
	
	      observer = new MutationObserver(mutationObserved)
	
	      log('Create body MutationObserver')
	      observer.observe(target, config)
	
	      return observer
	    }
	
	    var elements = [],
	      MutationObserver =
	        window.MutationObserver || window.WebKitMutationObserver,
	      observer = createMutationObserver()
	
	    return {
	      disconnect: function() {
	        if ('disconnect' in observer) {
	          log('Disconnect body MutationObserver')
	          observer.disconnect()
	          elements.forEach(removeImageLoadListener)
	        }
	      }
	    }
	  }
	
	  function setupMutationObserver() {
	    var forceIntervalTimer = 0 > interval
	
	    // Not testable in PhantomJS
	    /* istanbul ignore if */ if (
	      window.MutationObserver ||
	      window.WebKitMutationObserver
	    ) {
	      if (forceIntervalTimer) {
	        initInterval()
	      } else {
	        bodyObserver = setupBodyMutationObserver()
	      }
	    } else {
	      log('MutationObserver not supported in this browser!')
	      initInterval()
	    }
	  }
	
	  // document.documentElement.offsetHeight is not reliable, so
	  // we have to jump through hoops to get a better value.
	  function getComputedStyle(prop, el) {
	    var retVal = 0
	    el = el || document.body // Not testable in phantonJS
	
	    retVal = document.defaultView.getComputedStyle(el, null)
	    retVal = null !== retVal ? retVal[prop] : 0
	
	    return parseInt(retVal, base)
	  }
	
	  function chkEventThottle(timer) {
	    if (timer > throttledTimer / 2) {
	      throttledTimer = 2 * timer
	      log('Event throttle increased to ' + throttledTimer + 'ms')
	    }
	  }
	
	  // Idea from https://github.com/guardian/iframe-messenger
	  function getMaxElement(side, elements) {
	    var elementsLength = elements.length,
	      elVal = 0,
	      maxVal = 0,
	      Side = capitalizeFirstLetter(side),
	      timer = getNow()
	
	    for (var i = 0; i < elementsLength; i++) {
	      elVal =
	        elements[i].getBoundingClientRect()[side] +
	        getComputedStyle('margin' + Side, elements[i])
	      if (elVal > maxVal) {
	        maxVal = elVal
	      }
	    }
	
	    timer = getNow() - timer
	
	    log('Parsed ' + elementsLength + ' HTML elements')
	    log('Element position calculated in ' + timer + 'ms')
	
	    chkEventThottle(timer)
	
	    return maxVal
	  }
	
	  function getAllMeasurements(dimention) {
	    return [
	      dimention.bodyOffset(),
	      dimention.bodyScroll(),
	      dimention.documentElementOffset(),
	      dimention.documentElementScroll()
	    ]
	  }
	
	  function getTaggedElements(side, tag) {
	    function noTaggedElementsFound() {
	      warn('No tagged elements (' + tag + ') found on page')
	      return document.querySelectorAll('body *')
	    }
	
	    var elements = document.querySelectorAll('[' + tag + ']')
	
	    if (0 === elements.length) noTaggedElementsFound()
	
	    return getMaxElement(side, elements)
	  }
	
	  function getAllElements() {
	    return document.querySelectorAll('body *')
	  }
	
	  var getHeight = {
	      bodyOffset: function getBodyOffsetHeight() {
	        return (
	          document.body.offsetHeight +
	          getComputedStyle('marginTop') +
	          getComputedStyle('marginBottom')
	        )
	      },
	
	      offset: function() {
	        return getHeight.bodyOffset() // Backwards compatability
	      },
	
	      bodyScroll: function getBodyScrollHeight() {
	        return document.body.scrollHeight
	      },
	
	      custom: function getCustomWidth() {
	        return customCalcMethods.height()
	      },
	
	      documentElementOffset: function getDEOffsetHeight() {
	        return document.documentElement.offsetHeight
	      },
	
	      documentElementScroll: function getDEScrollHeight() {
	        return document.documentElement.scrollHeight
	      },
	
	      max: function getMaxHeight() {
	        return Math.max.apply(null, getAllMeasurements(getHeight))
	      },
	
	      min: function getMinHeight() {
	        return Math.min.apply(null, getAllMeasurements(getHeight))
	      },
	
	      grow: function growHeight() {
	        return getHeight.max() // Run max without the forced downsizing
	      },
	
	      lowestElement: function getBestHeight() {
	        return Math.max(
	          getHeight.bodyOffset() || getHeight.documentElementOffset(),
	          getMaxElement('bottom', getAllElements())
	        )
	      },
	
	      taggedElement: function getTaggedElementsHeight() {
	        return getTaggedElements('bottom', 'data-iframe-height')
	      }
	    },
	    getWidth = {
	      bodyScroll: function getBodyScrollWidth() {
	        return document.body.scrollWidth
	      },
	
	      bodyOffset: function getBodyOffsetWidth() {
	        return document.body.offsetWidth
	      },
	
	      custom: function getCustomWidth() {
	        return customCalcMethods.width()
	      },
	
	      documentElementScroll: function getDEScrollWidth() {
	        return document.documentElement.scrollWidth
	      },
	
	      documentElementOffset: function getDEOffsetWidth() {
	        return document.documentElement.offsetWidth
	      },
	
	      scroll: function getMaxWidth() {
	        return Math.max(getWidth.bodyScroll(), getWidth.documentElementScroll())
	      },
	
	      max: function getMaxWidth() {
	        return Math.max.apply(null, getAllMeasurements(getWidth))
	      },
	
	      min: function getMinWidth() {
	        return Math.min.apply(null, getAllMeasurements(getWidth))
	      },
	
	      rightMostElement: function rightMostElement() {
	        return getMaxElement('right', getAllElements())
	      },
	
	      taggedElement: function getTaggedElementsWidth() {
	        return getTaggedElements('right', 'data-iframe-width')
	      }
	    }
	
	  function sizeIFrame(
	    triggerEvent,
	    triggerEventDesc,
	    customHeight,
	    customWidth
	  ) {
	    function resizeIFrame() {
	      height = currentHeight
	      width = currentWidth
	
	      sendMsg(height, width, triggerEvent)
	    }
	
	    function isSizeChangeDetected() {
	      function checkTolarance(a, b) {
	        var retVal = Math.abs(a - b) <= tolerance
	        return !retVal
	      }
	
	      currentHeight =
	        undefined !== customHeight ? customHeight : getHeight[heightCalcMode]()
	      currentWidth =
	        undefined !== customWidth ? customWidth : getWidth[widthCalcMode]()
	
	      return (
	        checkTolarance(height, currentHeight) ||
	        (calculateWidth && checkTolarance(width, currentWidth))
	      )
	    }
	
	    function isForceResizableEvent() {
	      return !(triggerEvent in { init: 1, interval: 1, size: 1 })
	    }
	
	    function isForceResizableCalcMode() {
	      return (
	        heightCalcMode in resetRequiredMethods ||
	        (calculateWidth && widthCalcMode in resetRequiredMethods)
	      )
	    }
	
	    function logIgnored() {
	      log('No change in size detected')
	    }
	
	    function checkDownSizing() {
	      if (isForceResizableEvent() && isForceResizableCalcMode()) {
	        resetIFrame(triggerEventDesc)
	      } else if (!(triggerEvent in { interval: 1 })) {
	        logIgnored()
	      }
	    }
	
	    var currentHeight, currentWidth
	
	    if (isSizeChangeDetected() || 'init' === triggerEvent) {
	      lockTrigger()
	      resizeIFrame()
	    } else {
	      checkDownSizing()
	    }
	  }
	
	  var sizeIFrameThrottled = throttle(sizeIFrame)
	
	  function sendSize(triggerEvent, triggerEventDesc, customHeight, customWidth) {
	    function recordTrigger() {
	      if (!(triggerEvent in { reset: 1, resetPage: 1, init: 1 })) {
	        log('Trigger event: ' + triggerEventDesc)
	      }
	    }
	
	    function isDoubleFiredEvent() {
	      return triggerLocked && triggerEvent in doubleEventList
	    }
	
	    if (!isDoubleFiredEvent()) {
	      recordTrigger()
	      if (triggerEvent === 'init') {
	        sizeIFrame(triggerEvent, triggerEventDesc, customHeight, customWidth)
	      } else {
	        sizeIFrameThrottled(
	          triggerEvent,
	          triggerEventDesc,
	          customHeight,
	          customWidth
	        )
	      }
	    } else {
	      log('Trigger event cancelled: ' + triggerEvent)
	    }
	  }
	
	  function lockTrigger() {
	    if (!triggerLocked) {
	      triggerLocked = true
	      log('Trigger event lock on')
	    }
	    clearTimeout(triggerLockedTimer)
	    triggerLockedTimer = setTimeout(function() {
	      triggerLocked = false
	      log('Trigger event lock off')
	      log('--')
	    }, eventCancelTimer)
	  }
	
	  function triggerReset(triggerEvent) {
	    height = getHeight[heightCalcMode]()
	    width = getWidth[widthCalcMode]()
	
	    sendMsg(height, width, triggerEvent)
	  }
	
	  function resetIFrame(triggerEventDesc) {
	    var hcm = heightCalcMode
	    heightCalcMode = heightCalcModeDefault
	
	    log('Reset trigger event: ' + triggerEventDesc)
	    lockTrigger()
	    triggerReset('reset')
	
	    heightCalcMode = hcm
	  }
	
	  function sendMsg(height, width, triggerEvent, msg, targetOrigin) {
	    function setTargetOrigin() {
	      if (undefined === targetOrigin) {
	        targetOrigin = targetOriginDefault
	      } else {
	        log('Message targetOrigin: ' + targetOrigin)
	      }
	    }
	
	    function sendToParent() {
	      var size = height + ':' + width,
	        message =
	          myID +
	          ':' +
	          size +
	          ':' +
	          triggerEvent +
	          (undefined !== msg ? ':' + msg : '')
	
	      log('Sending message to host page (' + message + ')')
	      target.postMessage(msgID + message, targetOrigin)
	    }
	
	    if (true === sendPermit) {
	      setTargetOrigin()
	      sendToParent()
	    }
	  }
	
	  function receiver(event) {
	    var processRequestFromParent = {
	      init: function initFromParent() {
	        initMsg = event.data
	        target = event.source
	
	        init()
	        firstRun = false
	        setTimeout(function() {
	          initLock = false
	        }, eventCancelTimer)
	      },
	
	      reset: function resetFromParent() {
	        if (!initLock) {
	          log('Page size reset by host page')
	          triggerReset('resetPage')
	        } else {
	          log('Page reset ignored by init')
	        }
	      },
	
	      resize: function resizeFromParent() {
	        sendSize('resizeParent', 'Parent window requested size check')
	      },
	
	      moveToAnchor: function moveToAnchorF() {
	        inPageLinks.findTarget(getData())
	      },
	      inPageLink: function inPageLinkF() {
	        this.moveToAnchor()
	      }, // Backward compatability
	
	      pageInfo: function pageInfoFromParent() {
	        var msgBody = getData()
	        log('PageInfoFromParent called from parent: ' + msgBody)
	        onPageInfo(JSON.parse(msgBody))
	        log(' --')
	      },
	
	      message: function messageFromParent() {
	        var msgBody = getData()
	
	        log('onMessage called from parent: ' + msgBody)
	        // eslint-disable-next-line sonarjs/no-extra-arguments
	        onMessage(JSON.parse(msgBody))
	        log(' --')
	      }
	    }
	
	    function isMessageForUs() {
	      return msgID === ('' + event.data).substr(0, msgIdLen) // ''+ Protects against non-string messages
	    }
	
	    function getMessageType() {
	      return event.data.split(']')[1].split(':')[0]
	    }
	
	    function getData() {
	      return event.data.substr(event.data.indexOf(':') + 1)
	    }
	
	    function isMiddleTier() {
	      return (
	        (!(typeof module !== 'undefined' && module.exports) &&
	          'iFrameResize' in window) ||
	        ('jQuery' in window && 'iFrameResize' in window.jQuery.prototype)
	      )
	    }
	
	    function isInitMsg() {
	      // Test if this message is from a child below us. This is an ugly test, however, updating
	      // the message format would break backwards compatibity.
	      return event.data.split(':')[2] in { true: 1, false: 1 }
	    }
	
	    function callFromParent() {
	      var messageType = getMessageType()
	
	      if (messageType in processRequestFromParent) {
	        processRequestFromParent[messageType]()
	      } else if (!isMiddleTier() && !isInitMsg()) {
	        warn('Unexpected message (' + event.data + ')')
	      }
	    }
	
	    function processMessage() {
	      if (false === firstRun) {
	        callFromParent()
	      } else if (isInitMsg()) {
	        processRequestFromParent.init()
	      } else {
	        log(
	          'Ignored message of type "' +
	            getMessageType() +
	            '". Received before initialization.'
	        )
	      }
	    }
	
	    if (isMessageForUs()) {
	      processMessage()
	    }
	  }
	
	  // Normally the parent kicks things off when it detects the iFrame has loaded.
	  // If this script is async-loaded, then tell parent page to retry init.
	  function chkLateLoaded() {
	    if ('loading' !== document.readyState) {
	      window.parent.postMessage('[iFrameResizerChild]Ready', '*')
	    }
	  }
	
	  addEventListener(window, 'message', receiver)
	  addEventListener(window, 'readystatechange', chkLateLoaded)
	  chkLateLoaded()
	
	  
	})()


/***/ }),
/* 2312 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module) {// Generated by CoffeeScript 1.10.0
	(function() {
	  var hasModule, isArray, makeTwix,
	    slice = [].slice;
	
	  hasModule = (typeof module !== "undefined" && module !== null) && (module.exports != null);
	
	  isArray = function(input) {
	    return Object.prototype.toString.call(input) === '[object Array]';
	  };
	
	  makeTwix = function(moment) {
	    var Twix;
	    if (moment == null) {
	      throw new Error("Can't find moment");
	    }
	    Twix = (function() {
	      function Twix(start, end, parseFormat, options) {
	        var ref;
	        if (options == null) {
	          options = {};
	        }
	        if (typeof parseFormat !== 'string') {
	          options = parseFormat != null ? parseFormat : {};
	          parseFormat = null;
	        }
	        if (typeof options === 'boolean') {
	          options = {
	            allDay: options
	          };
	        }
	        this._oStart = moment(start, parseFormat, options.parseStrict);
	        this._oEnd = moment(end, parseFormat, options.parseStrict);
	        this.allDay = (ref = options.allDay) != null ? ref : false;
	        this._mutated();
	      }
	
	      Twix._extend = function() {
	        var attr, first, j, len, other, others;
	        first = arguments[0], others = 2 <= arguments.length ? slice.call(arguments, 1) : [];
	        for (j = 0, len = others.length; j < len; j++) {
	          other = others[j];
	          for (attr in other) {
	            if (typeof other[attr] !== 'undefined') {
	              first[attr] = other[attr];
	            }
	          }
	        }
	        return first;
	      };
	
	      Twix.prototype.start = function() {
	        return this._start.clone();
	      };
	
	      Twix.prototype.end = function() {
	        return this._end.clone();
	      };
	
	      Twix.prototype.isSame = function(period) {
	        return this._start.isSame(this._end, period);
	      };
	
	      Twix.prototype.length = function(period) {
	        return this._displayEnd.diff(this._start, period);
	      };
	
	      Twix.prototype.count = function(period) {
	        var end, start;
	        start = this.start().startOf(period);
	        end = this.end().startOf(period);
	        return end.diff(start, period) + 1;
	      };
	
	      Twix.prototype.countInner = function(period) {
	        var end, ref, start;
	        ref = this._inner(period), start = ref[0], end = ref[1];
	        if (start >= end) {
	          return 0;
	        }
	        return end.diff(start, period);
	      };
	
	      Twix.prototype.iterate = function(intervalAmount, period, minHours) {
	        var end, hasNext, ref, start;
	        ref = this._prepIterateInputs(intervalAmount, period, minHours), intervalAmount = ref[0], period = ref[1], minHours = ref[2];
	        start = this.start().startOf(period);
	        end = this.end().startOf(period);
	        if (this.allDay) {
	          end = end.add(1, 'd');
	        }
	        hasNext = (function(_this) {
	          return function() {
	            return (!_this.allDay && start <= end && (!minHours || !start.isSame(end) || _this._end.hours() > minHours)) || (_this.allDay && start < end);
	          };
	        })(this);
	        return this._iterateHelper(period, start, hasNext, intervalAmount);
	      };
	
	      Twix.prototype.iterateInner = function(intervalAmount, period) {
	        var end, hasNext, ref, ref1, start;
	        ref = this._prepIterateInputs(intervalAmount, period), intervalAmount = ref[0], period = ref[1];
	        ref1 = this._inner(period, intervalAmount), start = ref1[0], end = ref1[1];
	        hasNext = function() {
	          return start < end;
	        };
	        return this._iterateHelper(period, start, hasNext, intervalAmount);
	      };
	
	      Twix.prototype.humanizeLength = function() {
	        if (this.allDay) {
	          if (this.isSame('d')) {
	            return 'all day';
	          } else {
	            return this._start.from(this.end().add(1, 'd'), true);
	          }
	        } else {
	          return this._start.from(this._end, true);
	        }
	      };
	
	      Twix.prototype.asDuration = function(units) {
	        var diff;
	        diff = this._end.diff(this._start);
	        return moment.duration(diff);
	      };
	
	      Twix.prototype.isPast = function() {
	        return this._lastMilli < moment();
	      };
	
	      Twix.prototype.isFuture = function() {
	        return this._start > moment();
	      };
	
	      Twix.prototype.isCurrent = function() {
	        return !this.isPast() && !this.isFuture();
	      };
	
	      Twix.prototype.contains = function(mom) {
	        if (!moment.isMoment(mom)) {
	          mom = moment(mom);
	        }
	        return this._start <= mom && this._lastMilli >= mom;
	      };
	
	      Twix.prototype.isEmpty = function() {
	        return this._start.isSame(this._displayEnd);
	      };
	
	      Twix.prototype.overlaps = function(other) {
	        return this._displayEnd.isAfter(other._start) && this._start.isBefore(other._displayEnd);
	      };
	
	      Twix.prototype.engulfs = function(other) {
	        return this._start <= other._start && this._displayEnd >= other._displayEnd;
	      };
	
	      Twix.prototype.union = function(other) {
	        var allDay, newEnd, newStart;
	        allDay = this.allDay && other.allDay;
	        newStart = this._start < other._start ? this._start : other._start;
	        newEnd = this._lastMilli > other._lastMilli ? (allDay ? this._end : this._displayEnd) : (allDay ? other._end : other._displayEnd);
	        return new Twix(newStart, newEnd, allDay);
	      };
	
	      Twix.prototype.intersection = function(other) {
	        var allDay, newEnd, newStart;
	        allDay = this.allDay && other.allDay;
	        newStart = this._start > other._start ? this._start : other._start;
	        newEnd = this._lastMilli < other._lastMilli ? (allDay ? this._end : this._displayEnd) : (allDay ? other._end : other._displayEnd);
	        return new Twix(newStart, newEnd, allDay);
	      };
	
	      Twix.prototype.xor = function() {
	        var allDay, arr, endTime, i, item, j, k, last, len, len1, o, open, other, others, ref, results, start, t;
	        others = 1 <= arguments.length ? slice.call(arguments, 0) : [];
	        open = 0;
	        start = null;
	        results = [];
	        allDay = ((function() {
	          var j, len, results1;
	          results1 = [];
	          for (j = 0, len = others.length; j < len; j++) {
	            o = others[j];
	            if (o.allDay) {
	              results1.push(o);
	            }
	          }
	          return results1;
	        })()).length === others.length;
	        arr = [];
	        ref = [this].concat(others);
	        for (i = j = 0, len = ref.length; j < len; i = ++j) {
	          item = ref[i];
	          arr.push({
	            time: item._start,
	            i: i,
	            type: 0
	          });
	          arr.push({
	            time: item._displayEnd,
	            i: i,
	            type: 1
	          });
	        }
	        arr = arr.sort(function(a, b) {
	          return a.time - b.time;
	        });
	        for (k = 0, len1 = arr.length; k < len1; k++) {
	          other = arr[k];
	          if (other.type === 1) {
	            open -= 1;
	          }
	          if (open === other.type) {
	            start = other.time;
	          }
	          if (open === (other.type + 1) % 2) {
	            if (start) {
	              last = results[results.length - 1];
	              if (last && last._end.isSame(start)) {
	                last._oEnd = other.time;
	                last._mutated();
	              } else {
	                endTime = allDay ? other.time.clone().subtract(1, 'd') : other.time;
	                t = new Twix(start, endTime, allDay);
	                if (!t.isEmpty()) {
	                  results.push(t);
	                }
	              }
	            }
	            start = null;
	          }
	          if (other.type === 0) {
	            open += 1;
	          }
	        }
	        return results;
	      };
	
	      Twix.prototype.difference = function() {
	        var j, len, others, ref, results1, t;
	        others = 1 <= arguments.length ? slice.call(arguments, 0) : [];
	        ref = this.xor.apply(this, others).map((function(_this) {
	          return function(i) {
	            return _this.intersection(i);
	          };
	        })(this));
	        results1 = [];
	        for (j = 0, len = ref.length; j < len; j++) {
	          t = ref[j];
	          if (!t.isEmpty() && t.isValid()) {
	            results1.push(t);
	          }
	        }
	        return results1;
	      };
	
	      Twix.prototype.split = function() {
	        var args, dur, end, final, i, mom, start, time, times, vals;
	        args = 1 <= arguments.length ? slice.call(arguments, 0) : [];
	        end = start = this.start();
	        if (moment.isDuration(args[0])) {
	          dur = args[0];
	        } else if ((!moment.isMoment(args[0]) && !isArray(args[0]) && typeof args[0] === 'object') || (typeof args[0] === 'number' && typeof args[1] === 'string')) {
	          dur = moment.duration(args[0], args[1]);
	        } else if (isArray(args[0])) {
	          times = args[0];
	        } else {
	          times = args;
	        }
	        if (times) {
	          times = (function() {
	            var j, len, results1;
	            results1 = [];
	            for (j = 0, len = times.length; j < len; j++) {
	              time = times[j];
	              results1.push(moment(time));
	            }
	            return results1;
	          })();
	          times = ((function() {
	            var j, len, results1;
	            results1 = [];
	            for (j = 0, len = times.length; j < len; j++) {
	              mom = times[j];
	              if (mom.isValid() && mom >= start) {
	                results1.push(mom);
	              }
	            }
	            return results1;
	          })()).sort();
	        }
	        if ((dur && dur.asMilliseconds() === 0) || (times && times.length === 0)) {
	          return [this];
	        }
	        vals = [];
	        i = 0;
	        final = this._displayEnd;
	        while (start < final && ((times == null) || times[i])) {
	          end = dur ? start.clone().add(dur) : times[i].clone();
	          end = moment.min(final, end);
	          if (!start.isSame(end)) {
	            vals.push(moment.twix(start, end));
	          }
	          start = end;
	          i += 1;
	        }
	        if (!end.isSame(this._displayEnd) && times) {
	          vals.push(moment.twix(end, this._displayEnd));
	        }
	        return vals;
	      };
	
	      Twix.prototype.divide = function(parts) {
	        return this.split(this.length() / parts, 'ms').slice(0, +(parts - 1) + 1 || 9e9);
	      };
	
	      Twix.prototype.isValid = function() {
	        return this._start.isValid() && this._end.isValid() && this._start <= this._displayEnd;
	      };
	
	      Twix.prototype.equals = function(other) {
	        return (other instanceof Twix) && this.allDay === other.allDay && this._start.valueOf() === other._start.valueOf() && this._end.valueOf() === other._end.valueOf();
	      };
	
	      Twix.prototype.toString = function() {
	        return "{start: " + (this._start.format()) + ", end: " + (this._end.format()) + ", allDay: " + (this.allDay ? 'true' : 'false') + "}";
	      };
	
	      Twix.prototype.simpleFormat = function(momentOpts, inopts) {
	        var options, s;
	        options = {
	          allDay: '(all day)',
	          template: Twix.formatTemplate
	        };
	        Twix._extend(options, inopts || {});
	        s = options.template(this._start.format(momentOpts), this._end.format(momentOpts));
	        if (this.allDay && options.allDay) {
	          s += " " + options.allDay;
	        }
	        return s;
	      };
	
	      Twix.prototype.format = function(inopts) {
	        var atomicMonthDate, common_bucket, end_bucket, fold, format, fs, global_first, goesIntoTheMorning, j, len, momentHourFormat, needDate, needsMeridiem, options, process, start_bucket, together;
	        if (this.isEmpty()) {
	          return '';
	        }
	        momentHourFormat = this._start.localeData()._longDateFormat['LT'][0];
	        options = {
	          groupMeridiems: true,
	          spaceBeforeMeridiem: true,
	          showDayOfWeek: false,
	          hideTime: false,
	          hideYear: false,
	          implicitMinutes: true,
	          implicitDate: false,
	          implicitYear: true,
	          yearFormat: 'YYYY',
	          monthFormat: 'MMM',
	          weekdayFormat: 'ddd',
	          dayFormat: 'D',
	          meridiemFormat: 'A',
	          hourFormat: momentHourFormat,
	          minuteFormat: 'mm',
	          allDay: 'all day',
	          explicitAllDay: false,
	          lastNightEndsAt: 0,
	          template: Twix.formatTemplate
	        };
	        Twix._extend(options, inopts || {});
	        fs = [];
	        needsMeridiem = options.hourFormat && options.hourFormat[0] === 'h';
	        goesIntoTheMorning = options.lastNightEndsAt > 0 && !this.allDay && this.end().startOf('d').valueOf() === this.start().add(1, 'd').startOf('d').valueOf() && this._start.hours() > 12 && this._end.hours() < options.lastNightEndsAt;
	        needDate = !options.hideDate && (!options.implicitDate || this.start().startOf('d').valueOf() !== moment().startOf('d').valueOf() || !(this.isSame('d') || goesIntoTheMorning));
	        atomicMonthDate = !(this.allDay || options.hideTime);
	        if (this.allDay && this.isSame('d') && (options.implicitDate || options.explicitAllDay)) {
	          fs.push({
	            name: 'all day simple',
	            fn: function() {
	              return options.allDay;
	            },
	            pre: ' ',
	            slot: 0
	          });
	        }
	        if (needDate && !options.hideYear && (!options.implicitYear || this._start.year() !== moment().year() || !this.isSame('y'))) {
	          fs.push({
	            name: 'year',
	            fn: function(date) {
	              return date.format(options.yearFormat);
	            },
	            pre: ', ',
	            slot: 4
	          });
	        }
	        if (atomicMonthDate && needDate) {
	          fs.push({
	            name: 'month-date',
	            fn: function(date) {
	              return date.format(options.monthFormat + " " + options.dayFormat);
	            },
	            ignoreEnd: function() {
	              return goesIntoTheMorning;
	            },
	            pre: ' ',
	            slot: 2
	          });
	        }
	        if (!atomicMonthDate && needDate) {
	          fs.push({
	            name: 'month',
	            fn: function(date) {
	              return date.format(options.monthFormat);
	            },
	            pre: ' ',
	            slot: 2
	          });
	        }
	        if (!atomicMonthDate && needDate) {
	          fs.push({
	            name: 'date',
	            fn: function(date) {
	              return date.format(options.dayFormat);
	            },
	            pre: ' ',
	            slot: 3
	          });
	        }
	        if (needDate && options.showDayOfWeek) {
	          fs.push({
	            name: 'day of week',
	            fn: function(date) {
	              return date.format(options.weekdayFormat);
	            },
	            pre: ' ',
	            slot: 1
	          });
	        }
	        if (options.groupMeridiems && needsMeridiem && !this.allDay && !options.hideTime) {
	          fs.push({
	            name: 'meridiem',
	            fn: function(t) {
	              return t.format(options.meridiemFormat);
	            },
	            slot: 6,
	            pre: options.spaceBeforeMeridiem ? ' ' : ''
	          });
	        }
	        if (!this.allDay && !options.hideTime) {
	          fs.push({
	            name: 'time',
	            fn: function(date) {
	              var str;
	              str = date.minutes() === 0 && options.implicitMinutes && needsMeridiem ? date.format(options.hourFormat) : date.format(options.hourFormat + ":" + options.minuteFormat);
	              if (!options.groupMeridiems && needsMeridiem) {
	                if (options.spaceBeforeMeridiem) {
	                  str += ' ';
	                }
	                str += date.format(options.meridiemFormat);
	              }
	              return str;
	            },
	            slot: 5,
	            pre: ', '
	          });
	        }
	        start_bucket = [];
	        end_bucket = [];
	        common_bucket = [];
	        together = true;
	        process = (function(_this) {
	          return function(format) {
	            var end_str, start_group, start_str;
	            start_str = format.fn(_this._start);
	            end_str = format.ignoreEnd && format.ignoreEnd() ? start_str : format.fn(_this._end);
	            start_group = {
	              format: format,
	              value: function() {
	                return start_str;
	              }
	            };
	            if (end_str === start_str && together) {
	              return common_bucket.push(start_group);
	            } else {
	              if (together) {
	                together = false;
	                common_bucket.push({
	                  format: {
	                    slot: format.slot,
	                    pre: ''
	                  },
	                  value: function() {
	                    return options.template(fold(start_bucket), fold(end_bucket, true).trim());
	                  }
	                });
	              }
	              start_bucket.push(start_group);
	              return end_bucket.push({
	                format: format,
	                value: function() {
	                  return end_str;
	                }
	              });
	            }
	          };
	        })(this);
	        for (j = 0, len = fs.length; j < len; j++) {
	          format = fs[j];
	          process(format);
	        }
	        global_first = true;
	        fold = function(array, skip_pre) {
	          var k, len1, local_first, ref, section, str;
	          local_first = true;
	          str = '';
	          ref = array.sort(function(a, b) {
	            return a.format.slot - b.format.slot;
	          });
	          for (k = 0, len1 = ref.length; k < len1; k++) {
	            section = ref[k];
	            if (!global_first) {
	              if (local_first && skip_pre) {
	                str += ' ';
	              } else {
	                str += section.format.pre;
	              }
	            }
	            str += section.value();
	            global_first = false;
	            local_first = false;
	          }
	          return str;
	        };
	        return fold(common_bucket);
	      };
	
	      Twix.prototype._iterateHelper = function(period, iter, hasNext, intervalAmount) {
	        return {
	          next: function() {
	            var val;
	            if (!hasNext()) {
	              return null;
	            } else {
	              val = iter.clone();
	              iter.add(intervalAmount, period);
	              return val;
	            }
	          },
	          hasNext: hasNext
	        };
	      };
	
	      Twix.prototype._prepIterateInputs = function() {
	        var inputs, intervalAmount, minHours, period, ref, ref1;
	        inputs = 1 <= arguments.length ? slice.call(arguments, 0) : [];
	        if (typeof inputs[0] === 'number') {
	          return inputs;
	        }
	        if (typeof inputs[0] === 'string') {
	          period = inputs.shift();
	          intervalAmount = (ref = inputs.pop()) != null ? ref : 1;
	          if (inputs.length) {
	            minHours = (ref1 = inputs[0]) != null ? ref1 : false;
	          }
	        }
	        if (moment.isDuration(inputs[0])) {
	          period = 'ms';
	          intervalAmount = inputs[0].as(period);
	        }
	        return [intervalAmount, period, minHours];
	      };
	
	      Twix.prototype._inner = function(period, intervalAmount) {
	        var durationCount, durationPeriod, end, modulus, start;
	        if (period == null) {
	          period = 'ms';
	        }
	        if (intervalAmount == null) {
	          intervalAmount = 1;
	        }
	        start = this.start();
	        end = this._displayEnd.clone();
	        if (start > start.clone().startOf(period)) {
	          start.startOf(period).add(intervalAmount, period);
	        }
	        if (end < end.clone().endOf(period)) {
	          end.startOf(period);
	        }
	        durationPeriod = start.twix(end).asDuration(period);
	        durationCount = durationPeriod.get(period);
	        modulus = durationCount % intervalAmount;
	        end.subtract(modulus, period);
	        return [start, end];
	      };
	
	      Twix.prototype._mutated = function() {
	        this._start = this.allDay ? this._oStart.clone().startOf('d') : this._oStart;
	        this._lastMilli = this.allDay ? this._oEnd.clone().endOf('d') : this._oEnd;
	        this._end = this.allDay ? this._oEnd.clone().startOf('d') : this._oEnd;
	        return this._displayEnd = this.allDay ? this._end.clone().add(1, 'd') : this._end;
	      };
	
	      return Twix;
	
	    })();
	    Twix._extend(moment.locale(), {
	      _twix: Twix.defaults
	    });
	    Twix.formatTemplate = function(leftSide, rightSide) {
	      return leftSide + " - " + rightSide;
	    };
	    moment.twix = function() {
	      return (function(func, args, ctor) {
	        ctor.prototype = func.prototype;
	        var child = new ctor, result = func.apply(child, args);
	        return Object(result) === result ? result : child;
	      })(Twix, arguments, function(){});
	    };
	    moment.fn.twix = function() {
	      return (function(func, args, ctor) {
	        ctor.prototype = func.prototype;
	        var child = new ctor, result = func.apply(child, args);
	        return Object(result) === result ? result : child;
	      })(Twix, [this].concat(slice.call(arguments)), function(){});
	    };
	    moment.fn.forDuration = function(duration, allDay) {
	      return new Twix(this, this.clone().add(duration), allDay);
	    };
	    if (moment.duration.fn) {
	      moment.duration.fn.afterMoment = function(startingTime, allDay) {
	        return new Twix(startingTime, moment(startingTime).clone().add(this), allDay);
	      };
	      moment.duration.fn.beforeMoment = function(startingTime, allDay) {
	        return new Twix(moment(startingTime).clone().subtract(this), startingTime, allDay);
	      };
	    }
	    moment.twixClass = Twix;
	    return Twix;
	  };
	
	  if (hasModule) {
	    return module.exports = makeTwix(__webpack_require__(1021));
	  }
	
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1021)], __WEBPACK_AMD_DEFINE_RESULT__ = function(moment) {
	      return makeTwix(moment);
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  }
	
	  if (this.moment) {
	    this.Twix = makeTwix(this.moment);
	  } else if (typeof moment !== "undefined" && moment !== null) {
	    this.Twix = makeTwix(moment);
	  }
	
	}).call(this);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(485)(module)))

/***/ }),
/* 2313 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _radium = __webpack_require__(1600);
	
	var _radium2 = _interopRequireDefault(_radium);
	
	var _reactEventListener = __webpack_require__(1230);
	
	var _reactEventListener2 = _interopRequireDefault(_reactEventListener);
	
	var _materialUi = __webpack_require__(576);
	
	var _connectToStores = __webpack_require__(1226);
	
	var _connectToStores2 = _interopRequireDefault(_connectToStores);
	
	var _EventBucketStore = __webpack_require__(1593);
	
	var _EventBucketStore2 = _interopRequireDefault(_EventBucketStore);
	
	var _EventBucketActions = __webpack_require__(1218);
	
	var _EventBucketActions2 = _interopRequireDefault(_EventBucketActions);
	
	var _AnalyticsStore = __webpack_require__(1861);
	
	var _AnalyticsStore2 = _interopRequireDefault(_AnalyticsStore);
	
	var _AnalyticsActions = __webpack_require__(1863);
	
	var _AnalyticsActions2 = _interopRequireDefault(_AnalyticsActions);
	
	var _analyticsHeader = __webpack_require__(2293);
	
	var _analyticsHeader2 = _interopRequireDefault(_analyticsHeader);
	
	var _workingIndicator = __webpack_require__(1664);
	
	var _workingIndicator2 = _interopRequireDefault(_workingIndicator);
	
	var _genericAnalyticsTable = __webpack_require__(1687);
	
	var _genericAnalyticsTable2 = _interopRequireDefault(_genericAnalyticsTable);
	
	var _analyticsFilterWidget = __webpack_require__(2295);
	
	var _analyticsFilterWidget2 = _interopRequireDefault(_analyticsFilterWidget);
	
	var _moment = __webpack_require__(1021);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _util = __webpack_require__(1183);
	
	var util = _interopRequireWildcard(_util);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SalesAnalytics = function (_React$Component) {
	  _inherits(SalesAnalytics, _React$Component);
	
	  function SalesAnalytics(props) {
	    _classCallCheck(this, SalesAnalytics);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(SalesAnalytics).call(this, props));
	
	    _this.state = {
	      showRangeEditor: false,
	      allTime: false,
	      range: {
	        key: "selection",
	        startDate: (0, _moment2.default)().subtract(1, "month").format("YYYY-MM-DD"),
	        endDate: (0, _moment2.default)().format("YYYY-MM-DD")
	      },
	      segmentTicketSalesBy: "price", // ['price', 'event', 'type']
	      useLedger: false
	    };
	
	    _this.onWindowClick = _this.onWindowClick.bind(_this);
	    _this.onWindowKeyDown = _this.onWindowKeyDown.bind(_this);
	    _this.handleSegmentFilterChange = _this.handleSegmentFilterChange.bind(_this);
	    _this.handleDateChange = _this.handleDateChange.bind(_this);
	    _this.handleLedgerToggleChange = _this.handleLedgerToggleChange.bind(_this);
	    return _this;
	  }
	
	  _createClass(SalesAnalytics, [{
	    key: "onWindowClick",
	    value: function onWindowClick(e) {
	      if (this.state.showRangeEditor && (!this.container || !this.container.contains(e.target) && !this.rangeButton.contains(e.target))) {
	        this.setState({ showRangeEditor: false });
	      }
	    }
	  }, {
	    key: "onWindowKeyDown",
	    value: function onWindowKeyDown(e) {
	      if (this.state.showRangeEditor && e.which === 27) {
	        // esc
	        this.setState({ showRangeEditor: false });
	      }
	    }
	  }, {
	    key: "handleSegmentFilterChange",
	    value: function handleSegmentFilterChange(props) {
	      var _this2 = this;
	
	      this.setState({ segmentTicketSalesBy: props }, function () {
	        return _this2.componentWillReceiveProps(_this2.props, true);
	      });
	    }
	  }, {
	    key: "handleDateChange",
	    value: function handleDateChange(_ref) {
	      var _this3 = this;
	
	      var range = _ref.range;
	      var allTime = _ref.allTime;
	
	      this.setState({ range: range, allTime: allTime }, function () {
	        return _this3.componentWillReceiveProps(_this3.props, true);
	      });
	    }
	  }, {
	    key: "handleLedgerToggleChange",
	    value: function handleLedgerToggleChange(props) {
	      var _this4 = this;
	
	      this.setState({ useLedger: props }, function () {
	        return _this4.componentWillReceiveProps(_this4.props, true);
	      });
	    }
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.componentWillReceiveProps(this.props, true);
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(newProps) {
	      var force = arguments.length <= 1 || arguments[1] === undefined ? false : arguments[1];
	
	      if (force === true || newProps.params.eventBucketId !== this.props.params.eventBucketId) {
	        _AnalyticsActions2.default.fetchSalesAnalytics.defer(Object.assign({ event_bucket: newProps.params.eventBucketId }, !this.state.allTime && {
	          created_at: {
	            $gt: (0, _moment2.default)(this.state.range.startDate).startOf("day"),
	            $lte: (0, _moment2.default)(this.state.range.endDate).endOf("day")
	          }
	        }, this.state.allTime && {
	          all_time: true
	        }, {
	          by_event: this.state.segmentTicketSalesBy === "event",
	          by_type: this.state.segmentTicketSalesBy === "type"
	        }, {
	          use_new: this.state.useLedger
	        }));
	        if (newProps.params.eventBucketId !== this.props.params.eventBucketId) {
	          _EventBucketActions2.default.fetchOne.defer(newProps.params.eventBucketId);
	        }
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this5 = this;
	
	      var eventBucketId = this.props.params.eventBucketId;
	
	      var eventBucket = this.props.getEventBucketById(eventBucketId);
	      var salesAnalytics = this.props.getSalesAnalytics(eventBucketId);
	      var defaultItemsPerPage = 25;
	
	      if (!salesAnalytics || !eventBucket) {
	        return _react2.default.createElement(_workingIndicator2.default, { fullPage: true });
	      }
	
	      var timePeriod = this.state.allTime ? "All time" : (0, _moment2.default)(this.state.range.startDate).twix(this.state.range.endDate, { allDay: true }).format({ implicitYear: false });
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(_reactEventListener2.default, {
	          target: "window",
	          onClick: this.onWindowClick,
	          onKeyDown: this.onWindowKeyDown
	        }),
	        _react2.default.createElement(_analyticsHeader2.default, {
	          eventBucket: eventBucket,
	          allEventBuckets: this.props.getEventBuckets(),
	          label: "sales analytics",
	          subpath: "sales",
	          query: this.props.location.query
	          // onRefresh={() => this.componentWillReceiveProps(this.props, true)}
	          // isRefreshing={this.props.isFetching}
	          , hideHeader: true
	        }),
	        _react2.default.createElement(
	          "div",
	          { style: { position: "relative" } },
	          _react2.default.createElement(
	            "h1",
	            { style: { lineHeight: 1.2 } },
	            "\"",
	            eventBucket.name,
	            "\" sales analytics"
	          ),
	          _react2.default.createElement(_analyticsFilterWidget2.default, {
	            showDateFilter: true,
	            onDateRangeChange: this.handleDateChange,
	            showSegmentFilter: true,
	            onSegmentFilterChange: this.handleSegmentFilterChange,
	            segmentFilterTitle: "Segment ticket sales by",
	            segmentFilterSelected: this.state.segmentTicketSalesBy,
	            segmentFilterConfig: [{
	              value: "price",
	              label: "Price level"
	            }, {
	              value: "event",
	              label: "Event"
	            }, {
	              value: "type",
	              label: "Screening type"
	            }],
	            showLedgerToggle: true,
	            onLedgerToggleChange: this.handleLedgerToggleChange
	          }),
	          Object.values(salesAnalytics.data).some(function (r) {
	            return !!r.platform_fees;
	          }) ? _react2.default.createElement(
	            "div",
	            { style: { margin: "1em 0" } },
	            _react2.default.createElement(_materialUi.Checkbox, {
	              checked: !!this.props.location.query.include_fee_breakdown,
	              label: "Include fee breakdown",
	              style: { width: 200 },
	              onCheck: function onCheck(e, checked) {
	                return _this5.context.router.push({
	                  pathname: "/event_buckets/" + eventBucketId + "/analytics/sales",
	                  query: checked ? { include_fee_breakdown: true } : null
	                });
	              }
	            }),
	            this.props.location.query.include_fee_breakdown ? _react2.default.createElement(
	              "div",
	              { style: { marginLeft: 40 } },
	              _react2.default.createElement(
	                "i",
	                null,
	                "*Fee difference = net sales variance from face value based on absorbed fees / negotiated rate."
	              )
	            ) : null
	          ) : null,
	          salesAnalytics.fromCache ? _react2.default.createElement(
	            "div",
	            {
	              style: {
	                marginBottom: 12,
	                color: "rgba(33, 33, 33, 0.5)",
	                fontStyle: "italic"
	              }
	            },
	            "Showing cached results (last updated",
	            " ",
	            salesAnalytics.precomputedAt ? new Date(salesAnalytics.precomputedAt).toLocaleString() : "unknown",
	            ")"
	          ) : null,
	          this.props.isFetching || !salesAnalytics || !eventBucket ? _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(_workingIndicator2.default, { fullPage: true })
	          ) : _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(_genericAnalyticsTable2.default, {
	              eventBucket: eventBucket,
	              csvLabel: "sales-analytics",
	              showPdfDownload: true,
	              pdfFilename: util.snakeCase(eventBucket.name + " sales analytics " + timePeriod),
	              pdfTitle: eventBucket.name + " sales analytics",
	              pdfSubtitle: "Period: " + timePeriod,
	              noSort: true,
	              itemsPerPage: defaultItemsPerPage,
	              columns: [{ label: "Category", value: "category" }, { label: "Gross sales", value: "gross" }].concat(!!this.props.location.query.include_fee_breakdown ? [{ label: "Face value", value: "face_sales" }] : []).concat([{ label: "Net sales", value: "net" }, { label: "Fees", value: "fee" }]).concat(!!this.props.location.query.include_fee_breakdown ? [{ label: "Stripe fees", value: "stripe_fees" }, { label: "Eventive fees", value: "platform_fees" },
	              //{ label: 'Fees absorbed', value: 'fees_absorbed' },
	              { label: "Fee difference*", value: "fees_difference" }] : []).concat(Object.values(salesAnalytics.data).some(function (v) {
	                return v.deferred_fee;
	              }) ? [{ label: "Deferred fees", value: "deferred_fee" }] : []).concat(this.state.useLedger ? [{ label: "Qty Sold", value: "quantity" }, { label: "Qty Active", value: "quantity_active" }] : [{ label: "Quantity", value: "quantity" }]).concat([{ label: "Credit (net)", value: "credit_net" }, { label: "Cash", value: "cash" }]).concat(Object.values(salesAnalytics.data).some(function (v) {
	                return v.check;
	              }) ? [{ label: "Check", value: "check" }] : []).concat(Object.values(salesAnalytics.data).some(function (v) {
	                return v.tax;
	              }) ? [{ label: "Tax collected", value: "tax" }] : []).concat(Object.values(salesAnalytics.data).some(function (v) {
	                return v.gst_vat;
	              }) ? [{ label: "GST/VAT (calculated)", value: "gst_vat" }] : []).concat([]),
	              data: Object.entries(salesAnalytics.data).map(function (_ref2) {
	                var _ref3 = _slicedToArray(_ref2, 2);
	
	                var label = _ref3[0];
	                var values = _ref3[1];
	
	                var inset = label[0] === "*";
	                if (inset) {
	                  label = label.substring(2);
	                }
	
	                return {
	                  rowStyle: inset ? { fontStyle: "italic" } : label === "total" ? { fontWeight: "bold" } : null,
	                  //itemStyle: inset ? { marginLeft: '1em' } : null,
	                  category: {
	                    label: _react2.default.createElement(
	                      "span",
	                      { style: inset ? { marginLeft: "1em" } : null },
	                      util.capitalize(label)
	                    ),
	                    value: util.capitalize(label)
	                  },
	                  gross: {
	                    label: util.formatPrice(values.gross, false, true),
	                    value: values.gross
	                  },
	                  net: {
	                    label: util.formatPrice(values.net, false, true),
	                    value: values.net
	                  },
	                  fee: {
	                    label: util.formatPrice(values.gross - values.net - (values.deferred_fee || 0), false, true),
	                    value: values.gross - values.net - (values.deferred_fee || 0)
	                  },
	                  face_sales: {
	                    label: util.formatPrice(values.face_sales, false, true),
	                    value: values.face_sales
	                  },
	                  deferred_fee: {
	                    label: util.formatPrice(values.deferred_fee, false, true),
	                    value: values.deferred_fee
	                  },
	                  stripe_fees: {
	                    label: util.formatPrice(values.stripe_fees, false, true),
	                    value: values.stripe_fees
	                  },
	                  platform_fees: {
	                    label: util.formatPrice(values.platform_fees, false, true),
	                    value: values.platform_fees
	                  },
	                  fees_absorbed: {
	                    label: util.formatPrice(values.fees_absorbed, false, true),
	                    value: values.fees_absorbed
	                  },
	                  fees_difference: {
	                    label: util.formatPrice(values.fees_difference, false, true),
	                    value: values.fees_difference
	                  },
	                  tax: {
	                    label: util.formatPrice(values.tax, false, true),
	                    value: values.tax
	                  },
	                  quantity: {
	                    label: util.formatNumber(values.quantity),
	                    value: values.quantity
	                  },
	                  quantity_active: {
	                    label: util.formatNumber(values.quantity_active),
	                    value: values.quantity_active
	                  },
	                  cash: {
	                    label: util.formatPrice(values.cash, false, true),
	                    value: values.cash
	                  },
	                  check: {
	                    label: util.formatPrice(values.check, false, true),
	                    value: values.check
	                  },
	                  credit_net: {
	                    label: util.formatPrice(values.credit_net, false, true),
	                    value: values.credit_net
	                  },
	                  gst_vat: {
	                    label: util.formatPrice(values.gst_vat, false, true),
	                    value: values.gst_vat
	                  }
	                };
	              })
	            })
	          )
	        )
	      );
	    }
	  }], [{
	    key: "getStores",
	    value: function getStores() {
	      return [_EventBucketStore2.default, _AnalyticsStore2.default];
	    }
	  }, {
	    key: "getPropsFromStores",
	    value: function getPropsFromStores() {
	      return {
	        getEventBuckets: _EventBucketStore2.default.getEventBuckets,
	        getEventBucketById: _EventBucketStore2.default.getEventBucketById,
	        getSalesAnalytics: _AnalyticsStore2.default.getSalesAnalytics,
	        isFetching: _AnalyticsStore2.default.getState().isFetching
	      };
	    }
	  }]);
	
	  return SalesAnalytics;
	}(_react2.default.Component);
	
	SalesAnalytics.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	exports.default = (0, _radium2.default)((0, _connectToStores2.default)(SalesAnalytics));
	module.exports = exports["default"];

/***/ }),
/* 2314 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _radium = __webpack_require__(1600);
	
	var _radium2 = _interopRequireDefault(_radium);
	
	var _reactEventListener = __webpack_require__(1230);
	
	var _reactEventListener2 = _interopRequireDefault(_reactEventListener);
	
	var _connectToStores = __webpack_require__(1226);
	
	var _connectToStores2 = _interopRequireDefault(_connectToStores);
	
	var _EventBucketStore = __webpack_require__(1593);
	
	var _EventBucketStore2 = _interopRequireDefault(_EventBucketStore);
	
	var _EventStore = __webpack_require__(2032);
	
	var _EventStore2 = _interopRequireDefault(_EventStore);
	
	var _EventActions = __webpack_require__(2031);
	
	var _EventActions2 = _interopRequireDefault(_EventActions);
	
	var _FilmActions = __webpack_require__(1764);
	
	var _FilmActions2 = _interopRequireDefault(_FilmActions);
	
	var _LedgerStore = __webpack_require__(2315);
	
	var _LedgerStore2 = _interopRequireDefault(_LedgerStore);
	
	var _FilmStore = __webpack_require__(1765);
	
	var _FilmStore2 = _interopRequireDefault(_FilmStore);
	
	var _UserStore = __webpack_require__(974);
	
	var _UserStore2 = _interopRequireDefault(_UserStore);
	
	var _workingIndicator = __webpack_require__(1664);
	
	var _workingIndicator2 = _interopRequireDefault(_workingIndicator);
	
	var _injectedSelect = __webpack_require__(1874);
	
	var _injectedSelect2 = _interopRequireDefault(_injectedSelect);
	
	var _boxOfficeReportView = __webpack_require__(2317);
	
	var _boxOfficeReportView2 = _interopRequireDefault(_boxOfficeReportView);
	
	var _summaryGridReportView = __webpack_require__(2318);
	
	var _summaryGridReportView2 = _interopRequireDefault(_summaryGridReportView);
	
	var _dataGridReportView = __webpack_require__(2319);
	
	var _dataGridReportView2 = _interopRequireDefault(_dataGridReportView);
	
	var _inlineNoticeLabel = __webpack_require__(1222);
	
	var _inlineNoticeLabel2 = _interopRequireDefault(_inlineNoticeLabel);
	
	var _venueReportView = __webpack_require__(2320);
	
	var _venueReportView2 = _interopRequireDefault(_venueReportView);
	
	var _config = __webpack_require__(1173);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _materialUi = __webpack_require__(576);
	
	var _reactSelect = __webpack_require__(953);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	__webpack_require__(2321);
	
	var _reactDateRange = __webpack_require__(2198);
	
	var _defaultRanges = __webpack_require__(2258);
	
	var _moment = __webpack_require__(1021);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _VenueStore = __webpack_require__(2036);
	
	var _VenueStore2 = _interopRequireDefault(_VenueStore);
	
	var _VenueActions = __webpack_require__(2035);
	
	var _VenueActions2 = _interopRequireDefault(_VenueActions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var boxOfficeGroups = [{ value: "CINEMA WEEKLY", label: "Cinema Week (Fr-Th)" }, { value: "STANDARD WEEKLY", label: "Standard Week (Su-Sa)" }
	// { value: "NO GROUPING", label: "No Grouping" }
	];
	
	var transactionLogGroups = [{ value: "WEEKLY", label: "Weekly > Category" }, { value: "MONTHLY", label: "Monthly > Category" }, { value: "STANDARD WEEKLY", label: "Category > Weekly" }, { value: "STANDARD MONTHLY", label: "Category > Monthly" }, { value: "NO GROUPING", label: "No Grouping" }];
	
	var LedgerAnalytics = function (_React$Component) {
	  _inherits(LedgerAnalytics, _React$Component);
	
	  function LedgerAnalytics(props) {
	    _classCallCheck(this, LedgerAnalytics);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(LedgerAnalytics).call(this, props));
	
	    _this.state = {
	      showRangeEditor: false,
	      showSettingsPanel: true,
	      allTime: false,
	      range: {
	        key: "selection",
	        startDate: (0, _moment2.default)().subtract(1, "month"),
	        endDate: (0, _moment2.default)()
	      },
	      reportType: null,
	      reportName: null,
	      grouping: "NO GROUPING",
	      groupingName: "No Grouping",
	      includeNameAndEmail: false,
	      tType: [],
	      tClass: [],
	      useAdvanced: false,
	      previousTransactions: [],
	      selectedFilms: [],
	      selectedBuckets: [],
	      selectedVenueDate: new Date(),
	      selectedVenue: null,
	      viewSelectedBucket: null,
	      viewSelectedFilms: [],
	      viewAllTime: true,
	      viewStartDate: (0, _moment2.default)().subtract(1, "month"),
	      viewEndDate: (0, _moment2.default)(),
	      viewGrouping: "NO GROUPING",
	      //Temporary Export Path state variables
	      downloadCSVOnly: false,
	      showDownloadTempModal: false,
	      processingReport: false,
	      completedExport: null
	    };
	
	    _this.onWindowClick = _this.onWindowClick.bind(_this);
	    _this.onWindowKeyDown = _this.onWindowKeyDown.bind(_this);
	    _this.handleDateChange = _this.handleDateChange.bind(_this);
	    _this.handleReportSelection = _this.handleReportSelection.bind(_this);
	    _this.disableRunReportButton = _this.disableRunReportButton.bind(_this);
	    _this._checkTemporaryExport = _this._checkTemporaryExport.bind(_this);
	    _this.cancelModal = _this.cancelModal.bind(_this);
	    _this.buildBoxOfficeConditions = _this.buildBoxOfficeConditions.bind(_this);
	    _this.buildLedgerTransactionConditions = _this.buildLedgerTransactionConditions.bind(_this);
	    return _this;
	  }
	
	  _createClass(LedgerAnalytics, [{
	    key: "onWindowClick",
	    value: function onWindowClick(e) {
	      if (this.state.showRangeEditor && (!this.container || !this.container.contains(e.target) && !this.rangeButton.contains(e.target))) {
	        this.setState({ showRangeEditor: false });
	      }
	    }
	  }, {
	    key: "onWindowKeyDown",
	    value: function onWindowKeyDown(e) {
	      if (this.state.showRangeEditor && e.which === 27) {
	        // esc
	        this.setState({ showRangeEditor: false });
	      }
	    }
	  }, {
	    key: "handleDateChange",
	    value: function handleDateChange(_ref) {
	      var selection = _ref.selection;
	
	      if (selection.startDate === "all_time") {
	        this.setState({
	          allTime: true,
	          showRangeEditor: false,
	          range: this.state.range
	        });
	        return;
	      }
	
	      this.setState({ range: selection, allTime: false });
	    }
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      //On mount, load all the films for the Box Office Report select
	      _FilmActions2.default.fetchAllForUser.defer();
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(newProps) {
	      var force = arguments.length <= 1 || arguments[1] === undefined ? null : arguments[1];
	
	      if (force === true && this.state.showEventFilter) {
	        _EventActions2.default.fetchAllForBucket(this.state.selectedBuckets);
	      }
	    }
	  }, {
	    key: "handleReportSelection",
	    value: function handleReportSelection(selectedItem) {
	      var report = selectedItem.value;
	      this.setState({
	        reportType: selectedItem.value,
	        reportName: selectedItem.label
	      });
	
	      switch (report) {
	        case "box_office_report":
	          this.setState({
	            tType: [],
	            tClass: [],
	            grouping: boxOfficeGroups[0].value,
	            groupingName: boxOfficeGroups[0].label
	          });
	          break;
	
	        case "internal_summary":
	          this.setState({
	            tType: [],
	            tClass: [{ value: "TICKET", label: "Ticket" }]
	          });
	          break;
	
	        case "ledger_transaction_report":
	          this.setState({
	            tType: [],
	            tClass: [],
	            grouping: transactionLogGroups[0].value,
	            groupingName: transactionLogGroups[0].label
	          });
	          break;
	
	        case "venue_transaction_report":
	          this.setState({
	            tType: [],
	            tClass: [],
	            grouping: "",
	            groupingName: "",
	            allTime: false
	          });
	          break;
	
	        default:
	          break;
	      }
	    }
	  }, {
	    key: "formatFilms",
	    value: function formatFilms() {
	      var allFilms = this.props.getAllUserFilms();
	      var eventBuckets = this.state.selectedBuckets;
	
	      if (eventBuckets === undefined) {
	        return [];
	      }
	
	      var films = allFilms.reduce(function (filmArray, item) {
	        if (item.name !== undefined && item.name !== "") {
	          if (eventBuckets.length === 0) {
	            filmArray.push({ value: item.id, label: item.name });
	          } else {
	            if (eventBuckets.includes(item.event_bucket)) {
	              filmArray.push({ value: item.id, label: item.name });
	            }
	          }
	        }
	        return filmArray;
	      }, []);
	
	      return films;
	    }
	  }, {
	    key: "formatVenues",
	    value: function formatVenues() {
	      var venues = this.props.getVenuesForEventBucket(this.state.selectedBuckets);
	
	      return venues.map(function (venue) {
	        return {
	          value: venue.id,
	          label: venue.name
	        };
	      });
	    }
	  }, {
	    key: "disableRunReportButton",
	    value: function disableRunReportButton() {
	      if (this.state.reportType === "ledger_transaction_report") {
	        if (this.state.selectedBuckets === undefined || this.state.selectedBuckets.length < 1) {
	          return true;
	        }
	      } else if (this.state.reportType === "box_office_report") {
	        if (this.state.selectedBuckets === undefined || this.state.selectedBuckets.length < 1 || this.state.selectedFilms === undefined || this.state.selectedFilms.length < 1) {
	          return true;
	        }
	      }
	
	      return false;
	    }
	  }, {
	    key: "cancelModal",
	    value: function cancelModal() {
	      this.setState({
	        showDownloadTempModal: false,
	        processingReport: false,
	        completedExport: null
	      });
	    }
	  }, {
	    key: "_checkTemporaryExport",
	    value: function _checkTemporaryExport(id, wait) {
	      var _this2 = this;
	
	      setTimeout(function () {
	        fetch(_config2.default.endpoint + "temporary_exports/" + id + "?" + _UserStore2.default.makeApiKeyQueryString()).then(function (r) {
	          return r.json();
	        }).then(function (e) {
	          if (e.completed_at) {
	            _this2.setState({ completedExport: e });
	          } else {
	            _this2._checkTemporaryExport(id, Math.min(4000, wait * 2)); // backoff: 500ms, 1s, 2s, 4s max wait
	          }
	        });
	      }, wait);
	    }
	  }, {
	    key: "buildBoxOfficeConditions",
	    value: function buildBoxOfficeConditions() {
	      var timezone = this.props.getEventBucketById(this.state.selectedBuckets).timezone;
	
	      var conditions = Object.assign({
	        event_bucket: [this.state.selectedBuckets]
	      });
	
	      if (!this.state.allTime) {
	        conditions.date = {
	          $gt: _moment2.default.tz(this.state.range.startDate, timezone).startOf("day"),
	          $lte: _moment2.default.tz(this.state.range.endDate, timezone).endOf("day")
	        };
	      }
	
	      //TODO: Discuss with Theo about these values in the Box Office Report
	      conditions["type"] = { $in: ["PAYMENT", "ADJUSTMENT", "REFUND"] };
	      conditions["class"] = { $in: ["TICKET", "TAX"] };
	      conditions.films = this.state.selectedFilms.map(function (item) {
	        if (item.value) {
	          return item.value;
	        } else {
	          return item;
	        }
	      });
	
	      return conditions;
	    }
	  }, {
	    key: "buildLedgerTransactionConditions",
	    value: function buildLedgerTransactionConditions() {
	      var eventBuckets = this.state.selectedBuckets;
	      if (typeof eventBuckets === "string") {
	        eventBuckets = [eventBuckets];
	      } else if (eventBuckets.length === 0) {
	        eventBuckets = this.props.getEventBuckets().map(function (item) {
	          return item.id;
	        });
	      }
	
	      var conditions = Object.assign({
	        event_bucket: eventBuckets
	      }, !this.state.allTime && {
	        date: {
	          $gt: (0, _moment2.default)(this.state.range.startDate).startOf("day"),
	          $lte: (0, _moment2.default)(this.state.range.endDate).endOf("day")
	        }
	      });
	
	      if (this.state.tType.length === 1) {
	        conditions["type"] = this.state.tType[0].value;
	      } else if (this.state.tType.length > 1) {
	        var typeValues = this.state.tType.map(function (item) {
	          return item.value;
	        });
	        conditions["type"] = { $in: typeValues };
	      }
	
	      if (this.state.tClass.length === 1) {
	        conditions["class"] = this.state.tClass[0].value;
	      } else if (this.state.tClass.length > 1) {
	        var classValues = this.state.tClass.map(function (item) {
	          return item.value;
	        });
	        conditions["class"] = { $in: classValues };
	      }
	
	      return conditions;
	    }
	  }, {
	    key: "submitTemporaryExport",
	    value: function submitTemporaryExport() {
	      var _this3 = this;
	
	      var conditions = this.state.reportType === "box_office_report" ? this.buildBoxOfficeConditions() : this.buildLedgerTransactionConditions();
	
	      var options = this.state.reportType === "box_office_report" ? {
	        timePeriod: this.state.grouping
	      } : {
	        timePeriod: this.state.grouping,
	        includeNameAndEmail: this.state.includeNameAndEmail
	      };
	
	      var url = "" + _config2.default.endpoint + (this.state.reportType === "box_office_report" ? "analytics/box_office_temp_export" : "analytics/ledger_transaction_temp_export") + "?" + _UserStore2.default.makeApiKeyQueryString() + "&conditions=" + JSON.stringify(conditions) + "&options=" + JSON.stringify(options);
	
	      fetch(url, {
	        method: 'POST'
	      }).then(function (r) {
	        return r.json();
	      }).then(function (d) {
	        if (d.error || !d.temporary_export) {
	          _this3.setState({
	            completedExport: {
	              error: d.error ? d.error.message : "An unknown error occurred"
	            }
	          });
	        } else {
	          _this3._checkTemporaryExport(d.temporary_export, 500);
	        }
	      });
	    }
	  }, {
	    key: "getStyles",
	    value: function getStyles() {
	      return {
	        rangeContainer: {
	          float: "right",
	          marginBottom: "1.25em"
	        },
	        rangeButton: {
	          display: "inline-block",
	          borderRadius: 20,
	          padding: "8px 16px",
	          fontSize: "12pt",
	          color: "rgb(33,33,33)",
	          cursor: "pointer",
	          boxShadow: "0 0 5px 2px rgba(0, 0, 0, 0.1)",
	          transition: "0.1s ease-in-out",
	          ":hover": {
	            boxShadow: "0 0 5px 2px rgba(0, 0, 0, 0.2)"
	          }
	        },
	        overlay: {
	          //position: "absolute",
	          //right: 0,
	          //top: 175,
	          //left: 280,
	          backgroundColor: "#fff",
	          boxShadow: "0 0 5px 2px rgb(0,0,0,0.1)",
	          zIndex: 99,
	          marginTop: 10
	        },
	        overlaySubmit: {
	          position: "absolute",
	          right: 10,
	          bottom: 10
	        },
	        summaryBarItem: {
	          color: "#0288d1",
	          fontWeight: "bold",
	          fontSize: "16px"
	        },
	        summaryBarItemNowrap: {
	          color: "#0288d1",
	          fontWeight: "bold",
	          fontSize: "16px",
	          whiteSpace: "nowrap"
	        },
	        summaryBarSpacer: {
	          color: "#0288d1",
	          fontWeight: "bold",
	          marginLeft: "20px",
	          marginRight: "20px"
	        },
	        innerDialog: {
	          maxWidth: 250,
	          margin: "0 auto"
	        }
	      };
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this4 = this;
	
	      var styles = this.getStyles(),
	          eventBuckets = this.props.getEventBuckets();
	      var events = null;
	
	      if (this.state.showEventFilter) {
	        var unprocessedEvents = this.props.getEventsForEventBucket(this.state.selectedBuckets);
	        events = unprocessedEvents.map(function (e) {
	          return {
	            label: e.name,
	            value: e.id,
	            id: e.id
	          };
	        });
	      }
	
	      var isBoxOfficeFormat = this.state.reportType === "box_office_report" || this.state.reportType === "internal_summary";
	      var isReportSelected = this.state.reportType != null;
	
	      if (!eventBuckets || eventBuckets.length === 0) {
	        return _react2.default.createElement(_workingIndicator2.default, { fullPage: true });
	      }
	
	      var timePeriod = this.state.allTime ? "All time" : (0, _moment2.default)(this.state.range.startDate).twix(this.state.range.endDate, { allDay: true }).format({ implicitYear: false });
	
	      var showSettings = this.state.showSettingsPanel ? {
	        display: "inline-block",
	        boxSizing: "border-box",
	        width: "100%",
	        marginTop: "10px",
	        border: "1px solid #ededed",
	        borderRadius: "1em",
	        padding: "30px"
	      } : { display: "none" };
	
	      // GOD MODE OR CPH FILM FESTIVALS ONLY RIGHT NOW
	      var includeVenueReport = _UserStore2.default.isGod() || _UserStore2.default.getUserId() === "63639dc6b1aa97002919a915";
	      var reportOptions = [{
	        value: "box_office_report",
	        label: "Box Office Report by Film"
	      },
	      // Temporarily Removing
	      //{
	      //  value: "internal_summary",
	      //  label: "Internal Weekly Summary"
	      //},
	      {
	        value: "ledger_transaction_report",
	        label: "Ledger Transaction Report"
	      }];
	      if (includeVenueReport) {
	        reportOptions.push({
	          value: "venue_transaction_report",
	          label: "CPH Venue Transaction Report"
	        });
	      }
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          _materialUi.Dialog,
	          {
	            title: "Custom Ledger Report",
	            actions: [_react2.default.createElement(_materialUi.FlatButton, {
	              label: !this.state.processingReport ? "Close" : "Cancel",
	              onTouchTap: this.cancelModal
	            })],
	            autoDetectWindowHeight: false,
	            autoScrollBodyContent: false,
	            bodyStyle: { overflowY: "visible" },
	            open: !!this.state.showDownloadTempModal
	          },
	          _react2.default.createElement(
	            "div",
	            null,
	            this.state.showDownloadTempModal ? this.state.completedExport ? this.state.completedExport.error ? _react2.default.createElement(
	              "div",
	              null,
	              _react2.default.createElement(
	                "p",
	                null,
	                "Unfortunately, we ran into an error preparing your report. Please try again, or contact us if the problem persists."
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                _react2.default.createElement(
	                  "i",
	                  null,
	                  "Error:",
	                  " ",
	                  _react2.default.createElement(
	                    "strong",
	                    null,
	                    this.state.completedExport.error
	                  )
	                )
	              )
	            ) : _react2.default.createElement(
	              "div",
	              null,
	              _react2.default.createElement(
	                "p",
	                null,
	                "Great news, your report is ready!"
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                _react2.default.createElement(
	                  "strong",
	                  null,
	                  this.state.completedExport.description
	                ),
	                _react2.default.createElement("br", null),
	                _react2.default.createElement(
	                  "a",
	                  {
	                    target: "_blank",
	                    href: this.state.completedExport.download_url
	                  },
	                  _react2.default.createElement(
	                    "strong",
	                    null,
	                    "Click here to download."
	                  )
	                )
	              )
	            ) : _react2.default.createElement(
	              "div",
	              null,
	              _react2.default.createElement(_workingIndicator2.default, { centered: true }),
	              _react2.default.createElement(
	                "p",
	                null,
	                "Your report is now being generated! This may take anywhere from a few seconds to a few minutes. Keep this page open and it will automatically update when your report is ready."
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                "Feel free to close this page. You will receive an email with a download link as soon as your report has been generated."
	              )
	            ) : null
	          )
	        ),
	        _react2.default.createElement(_reactEventListener2.default, {
	          target: "window",
	          onClick: this.onWindowClick,
	          onKeyDown: this.onWindowKeyDown
	        }),
	        _react2.default.createElement(
	          "div",
	          { style: { position: "relative" } },
	          _react2.default.createElement(
	            "h1",
	            { style: { lineHeight: 1.2 } },
	            "Custom Ledger Reporting",
	            " ",
	            _react2.default.createElement(_inlineNoticeLabel2.default, {
	              label: "Limited beta",
	              style: { marginLeft: 10, verticalAlign: "middle" }
	            })
	          ),
	          _react2.default.createElement(
	            "p",
	            { style: { fontStyle: "italic" } },
	            "You have been invited to the early-access Eventive Ledger Preview. Eventive Ledger powers the next generation of Eventive financial reporting tools and will be launching soon. Some features are not yet fully supported \u2013 as an early-access tester, please",
	            " ",
	            _react2.default.createElement(
	              "a",
	              { href: "mailto:ledgerfeedback@eventive.org" },
	              "let us know"
	            ),
	            " what reporting functionality would be most useful to you or if you run into any issues!"
	          ),
	          this.state.showSettingsPanel ? null : _react2.default.createElement(
	            "div",
	            {
	              style: {
	                width: "100%",
	                paddingTop: "10px",
	                display: "flex",
	                justifyContent: "start"
	              }
	            },
	            _react2.default.createElement(
	              "div",
	              { style: styles.summaryBarItem },
	              this.state.reportName
	            ),
	            _react2.default.createElement(
	              "div",
	              { style: styles.summaryBarSpacer },
	              "|"
	            ),
	            this.state.reportType !== "box_office_report" ? null : _react2.default.createElement(
	              "div",
	              { style: { display: "flex", flexDirection: "row" } },
	              _react2.default.createElement(
	                "div",
	                { style: styles.summaryBarItem },
	                this.state.selectedFilms.length < 1 ? "No Film Selected" : this.state.selectedFilms.length > 1 ? "Multiple Films" : this.state.selectedFilms[0].label
	              ),
	              _react2.default.createElement(
	                "div",
	                { style: styles.summaryBarSpacer },
	                "|"
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { style: styles.summaryBarItemNowrap },
	              this.state.allTime ? "All Time" : this.state.reportType ? (0, _moment2.default)(this.state.selectedVenueDate).format("MMM DD") : (0, _moment2.default)(this.state.range.startDate).format("MMM DD") + " \u2013 " + (0, _moment2.default)(this.state.range.endDate).format("MMM DD")
	            ),
	            _react2.default.createElement(
	              "div",
	              { style: styles.summaryBarSpacer },
	              "|"
	            ),
	            _react2.default.createElement(
	              "div",
	              { style: styles.summaryBarItemNowrap },
	              this.state.reportType === "venue_transaction_report" ? this.props.getVenueById(this.state.selectedVenue).name : this.state.groupingName
	            ),
	            _react2.default.createElement(
	              "div",
	              { style: styles.summaryBarSpacer },
	              " "
	            ),
	            _react2.default.createElement(
	              "div",
	              { style: { flex: 1, textAlign: "right" } },
	              _react2.default.createElement(_materialUi.RaisedButton, {
	                style: { marginTop: "-10px", minWidth: 170 },
	                onClick: function onClick(e) {
	                  _this4.setState({
	                    showSettingsPanel: !_this4.state.showSettingsPanel
	                  });
	                },
	                label: "Modify Settings"
	              })
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { id: "report_settings", style: showSettings },
	            _react2.default.createElement(
	              "div",
	              {
	                style: {
	                  width: "100%",
	                  display: "flex",
	                  flexDirection: "row",
	                  justifyContent: "space-between"
	                }
	              },
	              _react2.default.createElement("div", { style: { flex: 1 } }),
	              _react2.default.createElement(
	                "div",
	                {
	                  style: {
	                    display: "none",
	                    width: "80px",
	                    marginLeft: "30px",
	                    paddingTop: "20px",
	                    flexDirection: "column",
	                    textAlign: "right"
	                  }
	                },
	                _react2.default.createElement(
	                  "div",
	                  null,
	                  "Advanced"
	                ),
	                _react2.default.createElement(_materialUi.Toggle, {
	                  style: {
	                    display: "inline-block",
	                    width: 200,
	                    paddingLeft: 25
	                  },
	                  "data-toggled": this.state.useAdvanced,
	                  toggled: this.state.useAdvanced,
	                  onToggle: function onToggle(e, v) {
	                    return _this4.setState({ useAdvanced: !_this4.state.useAdvanced });
	                  },
	                  name: "advancedToggle"
	                })
	              )
	            ),
	            this.state.useAdvanced ? _react2.default.createElement(
	              "div",
	              { style: { height: "100px", padding: "20px" } },
	              _react2.default.createElement(
	                "div",
	                null,
	                "A different Query Editor will go here"
	              )
	            ) : _react2.default.createElement(
	              "div",
	              null,
	              _react2.default.createElement(
	                "div",
	                {
	                  style: {
	                    width: "400px",
	                    display: "flex",
	                    flexDirection: "column",
	                    justifyContent: "start"
	                  }
	                },
	                _react2.default.createElement(
	                  "div",
	                  {
	                    style: {
	                      color: "#0288d1",
	                      fontWeight: "bold",
	                      fontSize: "14px",
	                      paddingBottom: "5px"
	                    }
	                  },
	                  "Report Type"
	                ),
	                _react2.default.createElement(_reactSelect2.default, {
	                  clearable: false,
	                  value: this.state.reportType,
	                  onChange: this.handleReportSelection,
	                  options: reportOptions
	                })
	              ),
	              isReportSelected ? _react2.default.createElement(
	                "div",
	                { style: { width: "100%", paddingTop: "25px" } },
	                _react2.default.createElement(
	                  "div",
	                  {
	                    style: {
	                      color: "#0288d1",
	                      fontWeight: "bold",
	                      fontSize: "14px",
	                      paddingBottom: "5px",
	                      width: "100%"
	                    }
	                  },
	                  "Event Bucket"
	                ),
	                _react2.default.createElement(
	                  "div",
	                  {
	                    style: {
	                      width: "100%",
	                      display: "flex",
	                      flexDirection: "row",
	                      justifyContent: "start"
	                    }
	                  },
	                  _react2.default.createElement(_injectedSelect2.default, {
	                    style: { width: "400px" },
	                    placeholder: this.state.reportType === "box_office_report" || this.state.reportType === "venue_transaction_report" || this.state.showEventFilter === true ? "Select event bucket..." : "Select event bucket(s)...",
	                    clearable: false,
	                    value: (this.state.reportType === "box_office_report" || this.state.reportType === "venue_transaction_report" || this.state.showEventFilter === true) && this.state.selectedBuckets.length === 0 ? null : this.state.selectedBuckets,
	                    types: ["event_buckets"],
	                    multi: this.state.reportType === "box_office_report" || this.state.reportType === "venue_transaction_report" || this.state.showEventFilter === true ? false : true,
	                    labelFormatter: function labelFormatter(b) {
	                      return b.name;
	                    },
	                    onChange: function onChange(e) {
	                      _this4.setState({
	                        selectedBuckets: e,
	                        selectedFilms: [],
	                        selectedVenue: null
	                      }, function () {
	                        _this4.componentWillReceiveProps(_this4.props, true);
	                        if ((typeof e === "undefined" ? "undefined" : _typeof(e)) !== "object") {
	                          _VenueActions2.default.fetchAllForBucket(e);
	                        }
	                      });
	                    }
	                  })
	                )
	              ) : null,
	              this.state.reportType === "venue_transaction_report" ? _react2.default.createElement(
	                "div",
	                { style: {
	                    width: "100%",
	                    paddingTop: "25px",
	                    display: "flex",
	                    justifyContent: "space-between"
	                  } },
	                _react2.default.createElement(
	                  "div",
	                  {
	                    style: {
	                      width: "400px",
	                      display: "flex",
	                      flexDirection: "column",
	                      justifyContent: "start"
	                    }
	                  },
	                  _react2.default.createElement(
	                    "div",
	                    {
	                      style: {
	                        color: "#0288d1",
	                        fontWeight: "bold",
	                        fontSize: "14px",
	                        paddingBottom: "5px"
	                      }
	                    },
	                    "Venue"
	                  ),
	                  _react2.default.createElement(_reactSelect2.default, {
	                    clearable: false,
	                    value: this.state.selectedVenue,
	                    placeholder: "Select venue...",
	                    onChange: function onChange(item) {
	                      _this4.setState({
	                        selectedVenue: item.value
	                      });
	                    },
	                    options: this.formatVenues()
	                  })
	                )
	              ) : null,
	              this.state.reportType === "box_office_report" ? _react2.default.createElement(
	                "div",
	                {
	                  style: {
	                    width: "100%",
	                    paddingTop: "25px",
	                    display: "flex",
	                    justifyContent: "space-between"
	                  }
	                },
	                _react2.default.createElement(
	                  "div",
	                  {
	                    style: {
	                      width: "400px",
	                      display: "flex",
	                      flexDirection: "column",
	                      justifyContent: "start"
	                    }
	                  },
	                  _react2.default.createElement(
	                    "div",
	                    {
	                      style: {
	                        color: "#0288d1",
	                        fontWeight: "bold",
	                        fontSize: "14px",
	                        paddingBottom: "5px"
	                      }
	                    },
	                    "Film"
	                  ),
	                  _react2.default.createElement(_reactSelect2.default, {
	                    clearable: false,
	                    value: this.state.selectedFilms,
	                    multi: true,
	                    placeholder: "Select film(s)...",
	                    onChange: function onChange(items) {
	                      _this4.setState({
	                        selectedFilms: items
	                      });
	                    },
	                    options: this.formatFilms()
	                  })
	                )
	              ) : null,
	              this.state.reportType !== "venue_transaction_report" && isBoxOfficeFormat && isReportSelected ? _react2.default.createElement(
	                "div",
	                { style: { marginTop: "25px", width: "100%" } },
	                _react2.default.createElement(
	                  "div",
	                  {
	                    style: {
	                      color: "#0288d1",
	                      fontWeight: "bold",
	                      fontSize: "14px",
	                      paddingBottom: "5px"
	                    }
	                  },
	                  "Grouping"
	                ),
	                _react2.default.createElement(
	                  _materialUi.RadioButtonGroup,
	                  {
	                    name: "grouping",
	                    valueSelected: this.state.grouping,
	                    onChange: function onChange(e, v) {
	                      var name = boxOfficeGroups.filter(function (x) {
	                        return x.value === v;
	                      })[0].label;
	                      _this4.setState({ grouping: v, groupingName: name });
	                    }
	                  },
	                  boxOfficeGroups.map(function (item) {
	                    return _react2.default.createElement(_materialUi.RadioButton, {
	                      style: { display: "inline-block", width: 210 },
	                      value: item.value,
	                      label: item.label
	                    });
	                  })
	                )
	              ) : null,
	              this.state.reportType !== "venue_transaction_report" && !isBoxOfficeFormat && isReportSelected ? _react2.default.createElement(
	                "div",
	                { style: { marginTop: "25px", width: "100%" } },
	                _react2.default.createElement(
	                  "div",
	                  {
	                    style: {
	                      color: "#0288d1",
	                      fontWeight: "bold",
	                      fontSize: "14px",
	                      paddingBottom: "5px"
	                    }
	                  },
	                  "Grouping"
	                ),
	                _react2.default.createElement(
	                  _materialUi.RadioButtonGroup,
	                  {
	                    name: "groupingRadioGroup",
	                    valueSelected: this.state.grouping,
	                    onChange: function onChange(e, v) {
	                      var name = transactionLogGroups.filter(function (x) {
	                        return x.value === v;
	                      })[0].label;
	                      _this4.setState({ grouping: v, groupingName: name });
	                    }
	                  },
	                  transactionLogGroups.map(function (item) {
	                    return _react2.default.createElement(_materialUi.RadioButton, {
	                      style: { display: "inline-block", width: 200 },
	                      value: item.value,
	                      label: item.label
	                    });
	                  })
	                )
	              ) : null,
	              isReportSelected ? _react2.default.createElement(
	                "div",
	                null,
	                this.state.reportType !== "box_office_report" && this.state.reportType !== "venue_transaction_report" && this.state.grouping === "NO GROUPING" ? _react2.default.createElement(
	                  "div",
	                  null,
	                  _react2.default.createElement(
	                    "div",
	                    {
	                      style: {
	                        width: "100%",
	                        display: "flex",
	                        flexDirection: "row",
	                        justifyContent: "start",
	                        paddingTop: "25px"
	                      }
	                    },
	                    _react2.default.createElement(_materialUi.Checkbox, {
	                      label: "Include purchaser name and email columns",
	                      checked: this.state.includeNameAndEmail,
	                      onClick: function onClick(e) {
	                        _this4.setState({
	                          includeNameAndEmail: e.target.checked
	                        });
	                      }
	                    })
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    {
	                      style: {
	                        width: "100%",
	                        display: "flex",
	                        flexDirection: "row",
	                        justifyContent: "start",
	                        paddingTop: "10px"
	                      }
	                    },
	                    _react2.default.createElement(_materialUi.Checkbox, {
	                      label: "Filter by a single event",
	                      checked: this.state.showEventFilter,
	                      onClick: function onClick(e) {
	                        //adjust existing event bucket selection values
	                        var selectedBuckets = [];
	                        if (e.target.checked) {
	                          if (_this4.state.selectedBuckets.length > 0) {
	                            selectedBuckets = _this4.state.selectedBuckets[0];
	                          } else {
	                            selectedBuckets = null;
	                          }
	                        } else {
	                          selectedBuckets = [_this4.state.selectedBuckets];
	                          _this4.setState({
	                            selectedEvent: null
	                          });
	                        }
	                        _this4.setState({
	                          showEventFilter: e.target.checked,
	                          selectedBuckets: selectedBuckets
	                        }, function () {
	                          _this4.componentWillReceiveProps(_this4.props, true);
	                        });
	                      }
	                    })
	                  )
	                ) : null,
	                this.state.showEventFilter && this.state.grouping === "NO GROUPING" ? _react2.default.createElement(
	                  "div",
	                  { style: { width: "100%" } },
	                  _react2.default.createElement(
	                    "div",
	                    {
	                      style: {
	                        color: "#0288d1",
	                        paddingTop: "25px",
	                        fontWeight: "bold",
	                        fontSize: "14px",
	                        paddingBottom: "5px",
	                        width: "100%"
	                      }
	                    },
	                    "Filter by Event"
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    {
	                      style: {
	                        width: "100%",
	                        display: "flex",
	                        flexDirection: "row",
	                        justifyContent: "start"
	                      }
	                    },
	                    _react2.default.createElement(_reactSelect2.default, {
	                      multi: false,
	                      clearable: false,
	                      value: this.state.selectedEvent ? this.state.selectedEvent.id : null,
	                      style: { width: 450 },
	                      delimeter: ",",
	                      onChange: function onChange(item) {
	                        _this4.setState({ selectedEvent: item });
	                      },
	                      options: events
	                    })
	                  )
	                ) : null,
	                this.state.reportType !== "box_office_report" && this.state.reportType !== "venue_transaction_report" ? _react2.default.createElement(
	                  "div",
	                  { style: { width: "100%" } },
	                  _react2.default.createElement(
	                    "div",
	                    {
	                      style: {
	                        color: "#0288d1",
	                        paddingTop: "25px",
	                        fontWeight: "bold",
	                        fontSize: "14px",
	                        paddingBottom: "5px",
	                        width: "100%"
	                      }
	                    },
	                    "Filter by Transaction Type"
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    {
	                      style: {
	                        width: "100%",
	                        display: "flex",
	                        flexDirection: "row",
	                        justifyContent: "start"
	                      }
	                    },
	                    _react2.default.createElement(_reactSelect2.default, {
	                      multi: true,
	                      clearable: false,
	                      value: this.state.tType,
	                      style: { width: 250 },
	                      delimeter: ",",
	                      onChange: function onChange(item) {
	                        _this4.setState({ tType: item });
	                      },
	                      options: [{ value: "PAYMENT", label: "Payment" }, { value: "ADJUSTMENT", label: "Adjustment" }, { value: "REFUND", label: "Refund" }]
	                    })
	                  )
	                ) : null,
	                this.state.reportType !== "box_office_report" && this.state.reportType !== "venue_transaction_report" ? _react2.default.createElement(
	                  "div",
	                  null,
	                  _react2.default.createElement(
	                    "div",
	                    {
	                      style: {
	                        color: "#0288d1",
	                        paddingTop: "25px",
	                        fontWeight: "bold",
	                        fontSize: "14px",
	                        paddingBottom: "5px",
	                        width: "100%"
	                      }
	                    },
	                    "Filter by Transaction Class"
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    {
	                      style: {
	                        width: "100%",
	                        display: "flex",
	                        flexDirection: "row",
	                        justifyContent: "start"
	                      }
	                    },
	                    _react2.default.createElement(_reactSelect2.default, {
	                      multi: true,
	                      clearable: false,
	                      value: this.state.tClass,
	                      style: { width: 250 },
	                      delimeter: ",",
	                      onChange: function onChange(item) {
	                        _this4.setState({ tClass: item });
	                      },
	                      options: [{ value: "TICKET", label: "Ticket" }, { value: "INGEST", label: "Ingest" }, { value: "PASS", label: "Pass" }, { value: "ITEM", label: "Item" }, { value: "TAX", label: "Tax" }, { value: "GIFT_CARD", label: "Gift Card" }]
	                    })
	                  )
	                ) : null,
	                _react2.default.createElement(
	                  "div",
	                  { style: { marginTop: "25px" } },
	                  _react2.default.createElement(
	                    "div",
	                    null,
	                    _react2.default.createElement(
	                      "div",
	                      {
	                        style: {
	                          color: "#0288d1",
	                          fontWeight: "bold",
	                          fontSize: "14px",
	                          paddingBottom: "5px"
	                        }
	                      },
	                      this.state.reportType === "venue_transaction_report" ? "Date" : "Date Range"
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      {
	                        style: {
	                          width: "100%",
	                          display: "flex",
	                          justifyContent: "start"
	                        }
	                      },
	                      _react2.default.createElement(
	                        "div",
	                        {
	                          style: {
	                            display: "flex",
	                            flexDirection: "column",
	                            justifyContent: "start"
	                          }
	                        },
	                        _react2.default.createElement(
	                          "div",
	                          {
	                            style: styles.rangeContainer,
	                            ref: function ref(r) {
	                              _this4.rangeButton = r;
	                            }
	                          },
	                          _react2.default.createElement(_materialUi.RaisedButton, {
	                            style: { marginTop: "0px" },
	                            onClick: function onClick() {
	                              return _this4.setState({ showRangeEditor: true });
	                            },
	                            label: this.state.allTime ? "All Time – click to filter" : this.state.reportType === "venue_transaction_report" ? (0, _moment2.default)(this.state.selectedVenueDate).format("l") + " - click to filter" : (0, _moment2.default)(this.state.range.startDate).format("ll") + " \u2013 " + (0, _moment2.default)(this.state.range.endDate).format("ll")
	                          }),
	                          this.state.showRangeEditor ? _react2.default.createElement(
	                            "div",
	                            {
	                              style: styles.overlay,
	                              ref: function ref(r) {
	                                _this4.container = r;
	                              }
	                            },
	                            _react2.default.createElement(
	                              "div",
	                              { style: { position: "relative" } },
	                              this.state.reportType === "venue_transaction_report" ? _react2.default.createElement(_reactDateRange.Calendar, {
	                                date: this.state.selectedVenueDate,
	                                onChange: function onChange(date) {
	                                  _this4.setState({ selectedVenueDate: date });
	                                }
	                              }) : _react2.default.createElement(_reactDateRange.DateRangePicker, {
	                                ranges: [this.state.range],
	                                onChange: this.handleDateChange,
	                                maxDate: new Date(),
	                                staticRanges: [{
	                                  label: "All Time",
	                                  isSelected: function isSelected() {
	                                    return false;
	                                  },
	                                  range: function range() {
	                                    return {
	                                      startDate: "all_time",
	                                      endDate: "all_time"
	                                    };
	                                  }
	                                }].concat(_defaultRanges.defaultStaticRanges)
	                              }),
	                              _react2.default.createElement(
	                                "div",
	                                { style: styles.overlaySubmit },
	                                _react2.default.createElement(_materialUi.RaisedButton, {
	                                  label: "Close",
	                                  onTouchTap: function onTouchTap() {
	                                    return _this4.setState({
	                                      showRangeEditor: false
	                                    });
	                                  }
	                                })
	                              )
	                            )
	                          ) : null
	                        )
	                      )
	                    ),
	                    this.state.reportType !== "venue_transaction_report" && _react2.default.createElement(
	                      "div",
	                      null,
	                      _react2.default.createElement(_materialUi.Checkbox, {
	                        label: "Generate Downloadable CSV Only",
	                        checked: this.state.downloadCSVOnly,
	                        onClick: function onClick() {
	                          return _this4.setState(function (prev) {
	                            return { downloadCSVOnly: !prev.downloadCSVOnly };
	                          });
	                        }
	                      })
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      {
	                        style: {
	                          width: "100%",
	                          display: "flex",
	                          justifyContent: "start"
	                        }
	                      },
	                      _react2.default.createElement(
	                        "div",
	                        null,
	                        _react2.default.createElement(_materialUi.RaisedButton, {
	                          style: { marginTop: "1em" },
	                          primary: true,
	                          disabled: this.disableRunReportButton(),
	                          onClick: function onClick() {
	                            if (_this4.state.downloadCSVOnly) {
	                              _this4.setState({
	                                showDownloadTempModal: true
	                              });
	                              _this4.submitTemporaryExport();
	                              return;
	                            }
	
	                            _this4.setState({
	                              showSettingsPanel: false
	                            });
	                          },
	                          label: "Run Report"
	                        })
	                      )
	                    )
	                  )
	                )
	              ) : null
	            )
	          )
	        ),
	        this.state.showSettingsPanel ? null : _react2.default.createElement(
	          "div",
	          null,
	          this.state.grouping === "NO GROUPING" ? _react2.default.createElement(_dataGridReportView2.default, {
	            selectedBuckets: this.state.selectedBuckets,
	            selectedBucket: this.state.selectedBuckets.length > 0 ? this.state.selectedBuckets[0] : null,
	            selectedFilms: [this.state.selectedFilm],
	            allTime: this.state.allTime,
	            startTime: this.state.range.startDate,
	            endTime: this.state.range.endDate,
	            grouping: this.state.grouping,
	            reportType: this.state.reportType,
	            tType: this.state.tType,
	            tClass: this.state.tClass,
	            includeNameAndEmail: this.state.includeNameAndEmail,
	            selectedEvent: this.state.selectedEvent
	          }) : this.state.reportType === "box_office_report" ? _react2.default.createElement(_boxOfficeReportView2.default, {
	            selectedBucket: this.state.selectedBuckets,
	            selectedFilms: this.state.selectedFilms,
	            allTime: this.state.allTime,
	            startTime: this.state.range.startDate,
	            endTime: this.state.range.endDate,
	            grouping: this.state.grouping,
	            reportType: this.state.reportType,
	            tType: this.state.tType,
	            tClass: this.state.tClass
	          }) : this.state.reportType === "venue_transaction_report" ? _react2.default.createElement(_venueReportView2.default, {
	            selectedBucket: this.state.selectedBuckets,
	            selectedVenue: this.state.selectedVenue,
	            allTime: false,
	            startTime: this.state.selectedVenueDate,
	            endTime: this.state.selectedVenueDate,
	            grouping: this.state.grouping,
	            reportType: this.state.reportType,
	            tType: this.state.tType,
	            tClass: this.state.tClass
	          }) : _react2.default.createElement(_summaryGridReportView2.default, {
	            selectedBuckets: this.state.selectedBuckets,
	            allTime: this.state.allTime,
	            startTime: this.state.range.startDate,
	            endTime: this.state.range.endDate,
	            grouping: this.state.grouping,
	            reportType: this.state.reportType,
	            tType: this.state.tType,
	            tClass: this.state.tClass
	          })
	        )
	      );
	    }
	  }], [{
	    key: "getStores",
	    value: function getStores() {
	      return [_EventBucketStore2.default, _EventStore2.default, _FilmStore2.default, _LedgerStore2.default, _VenueStore2.default, _UserStore2.default];
	    }
	  }, {
	    key: "getPropsFromStores",
	    value: function getPropsFromStores() {
	      return {
	        getEventBuckets: _EventBucketStore2.default.getEventBuckets,
	        getEventBucketById: _EventBucketStore2.default.getEventBucketById,
	        getEventsForEventBucket: _EventStore2.default.getEventsForEventBucket,
	        getLedgerAnalyticsTransactions: _LedgerStore2.default.getLedgerAnalyticsTransactions,
	        getLedgerBoxOfficeTransactions: _LedgerStore2.default.getLedgerBoxOfficeTransactions,
	        isFetching: _LedgerStore2.default.getState().isFetching,
	        getAllUserFilms: _FilmStore2.default.getAllUserFilms,
	        getVenuesForEventBucket: _VenueStore2.default.getVenuesForEventBucket,
	        getVenueById: _VenueStore2.default.getVenueById,
	        apiKey: _UserStore2.default.getState().apiKey
	      };
	    }
	  }]);
	
	  return LedgerAnalytics;
	}(_react2.default.Component);
	
	LedgerAnalytics.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	exports.default = (0, _radium2.default)((0, _connectToStores2.default)(LedgerAnalytics));
	module.exports = exports["default"];

/***/ }),
/* 2315 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _alt = __webpack_require__(975);
	
	var _alt2 = _interopRequireDefault(_alt);
	
	var _keyBy = __webpack_require__(990);
	
	var _keyBy2 = _interopRequireDefault(_keyBy);
	
	var _LedgerUtil = __webpack_require__(2316);
	
	var _LedgerUtil2 = _interopRequireDefault(_LedgerUtil);
	
	var _LedgerActions = __webpack_require__(2052);
	
	var _LedgerActions2 = _interopRequireDefault(_LedgerActions);
	
	var _UserStore = __webpack_require__(974);
	
	var _UserStore2 = _interopRequireDefault(_UserStore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var LedgerStore = function () {
	  function LedgerStore() {
	    _classCallCheck(this, LedgerStore);
	
	    this.bindActions(_LedgerActions2.default);
	
	    this.state = {
	      isFetching: false,
	      transactionsForOrder: {},
	      analyticsTransactions: {},
	      boxOfficeTransactions: {},
	      venueTransactions: {},
	      boxOfficeReport: [],
	      transactionReport: [],
	      venueReport: []
	    };
	
	    this.exportPublicMethods({
	      getLedgerTransactionsForOrder: this.getLedgerTransactionsForOrder.bind(this),
	      getLedgerAnalyticsTransactions: this.getLedgerAnalyticsTransactions.bind(this),
	      getLedgerBoxOfficeTransactions: this.getLedgerBoxOfficeTransactions.bind(this),
	      getVenueTransactions: this.getLedgerVenueTransactions.bind(this),
	      getLedgerBoxOfficeReport: this.getLedgerBoxOfficeReport.bind(this),
	      getLedgerTransactionReport: this.getLedgerTransactionReport.bind(this),
	      getLedgerVenueReport: this.getLedgerVenueReport.bind(this)
	    });
	  }
	
	  _createClass(LedgerStore, [{
	    key: "getLedgerTransactionsForOrder",
	    value: function getLedgerTransactionsForOrder(id) {
	      return this.state.transactionsForOrder[id] || [];
	    }
	
	    // supports an array of event bucket ids
	
	  }, {
	    key: "getLedgerAnalyticsTransactions",
	    value: function getLedgerAnalyticsTransactions(idList) {
	      if (!idList.length || idList.length === 0) {
	        idList = Object.keys(this.state.analyticsTransactions);
	      }
	      var transactionsArray = [];
	      for (var t = 0; t < idList.length; t++) {
	        if (this.state.analyticsTransactions[idList[t]] !== undefined) {
	          transactionsArray = transactionsArray.concat(this.state.analyticsTransactions[idList[t]]);
	        }
	      }
	      return transactionsArray;
	    }
	
	    // supports an array of event bucket ids
	
	  }, {
	    key: "getLedgerBoxOfficeTransactions",
	    value: function getLedgerBoxOfficeTransactions(idList) {
	      if (!idList.length || idList.length === 0) {
	        idList = Object.keys(this.state.boxOfficeTransactions);
	      }
	      var transactionsArray = [];
	      for (var t = 0; t < idList.length; t++) {
	        if (this.state.boxOfficeTransactions[idList[t]] !== undefined) {
	          transactionsArray = transactionsArray.concat(this.state.boxOfficeTransactions[idList[t]]);
	        }
	      }
	      return transactionsArray;
	    }
	
	    // supports an array of event bucket ids
	
	  }, {
	    key: "getLedgerVenueTransactions",
	    value: function getLedgerVenueTransactions(idList) {
	      if (!idList.length || idList.length === 0) {
	        idList = Object.keys(this.state.boxOfficeTransactions);
	      }
	      var transactionsArray = [];
	      for (var t = 0; t < idList.length; t++) {
	        if (this.state.boxOfficeTransactions[idList[t]] !== undefined) {
	          transactionsArray = transactionsArray.concat(this.state.boxOfficeTransactions[idList[t]]);
	        }
	      }
	      return transactionsArray;
	    }
	  }, {
	    key: "getLedgerBoxOfficeReport",
	    value: function getLedgerBoxOfficeReport() {
	      return this.state.boxOfficeReport;
	    }
	  }, {
	    key: "getLedgerTransactionReport",
	    value: function getLedgerTransactionReport() {
	      return this.state.transactionReport;
	    }
	  }, {
	    key: "getLedgerVenueReport",
	    value: function getLedgerVenueReport() {
	      return this.state.venueReport;
	    }
	  }, {
	    key: "onFetchLedgerTransactionsForOrder",
	    value: function onFetchLedgerTransactionsForOrder(id) {
	      var _this = this;
	
	      _LedgerUtil2.default.fetchLedgerTransactions(_UserStore2.default.getState().apiKey, {
	        order: id
	      }).then(function (data) {
	        _this.setState({
	          transactionsForOrder: _extends({}, _this.state.transactionsForOrder, _defineProperty({}, id, data.transactions))
	        });
	      }).catch(_LedgerActions2.default.fetchFailed);
	    }
	  }, {
	    key: "onFetchLedgerAnalyticsTransactions",
	    value: function onFetchLedgerAnalyticsTransactions(params) {
	      var _this2 = this;
	
	      this.setState({ isFetching: true });
	      _LedgerUtil2.default.fetchLedgerAnalyticsTransactions(_UserStore2.default.getState().apiKey, params.conditions, params.options).then(function (data) {
	        _this2.setState({
	          analyticsTransactions: _extends({}, _this2.state.analyticsTransactions, _defineProperty({}, params.conditions.event_bucket, data.data))
	        });
	        _this2.setState({ isFetching: false });
	      }).catch(_LedgerActions2.default.fetchFailed);
	    }
	  }, {
	    key: "onFetchLedgerBoxOfficeTransactions",
	    value: function onFetchLedgerBoxOfficeTransactions(params) {
	      var _this3 = this;
	
	      this.setState({ isFetching: true });
	      _LedgerUtil2.default.fetchLedgerBoxOfficeTransactions(_UserStore2.default.getState().apiKey, params.conditions, params.options).then(function (data) {
	        _this3.setState({
	          boxOfficeTransactions: _extends({}, _this3.state.boxOfficeTransactions, _defineProperty({}, params.conditions.event_bucket, data.data))
	        });
	        _this3.setState({ isFetching: false });
	      }).catch(_LedgerActions2.default.fetchFailed);
	    }
	  }, {
	    key: "onFetchLedgerVenueTransactions",
	    value: function onFetchLedgerVenueTransactions(params) {
	      var _this4 = this;
	
	      this.setState({ isFetching: true });
	      _LedgerUtil2.default.fetchLedgerVenueTransactions(_UserStore2.default.getState().apiKey, params.conditions, params.options).then(function (data) {
	        _this4.setState({
	          venueTransactions: _extends({}, _this4.state.venueTransactions, _defineProperty({}, params.conditions.event_bucket, data.data))
	        });
	        _this4.setState({ isFetching: false });
	      }).catch(_LedgerActions2.default.fetchFailed);
	    }
	  }, {
	    key: "onFetchLedgerVenueReport",
	    value: function onFetchLedgerVenueReport(params) {
	      var _this5 = this;
	
	      this.setState({ isFetching: true });
	      _LedgerUtil2.default.fetchLedgerVenueReport(_UserStore2.default.getState().apiKey, params.conditions, params.options).then(function (data) {
	        _this5.setState({
	          venueReport: data.data
	        });
	        _this5.setState({ isFetching: false });
	      }).catch(_LedgerActions2.default.fetchFailed);
	    }
	  }, {
	    key: "onFetchLedgerBoxOfficeReport",
	    value: function onFetchLedgerBoxOfficeReport(params) {
	      var _this6 = this;
	
	      this.setState({ isFetching: true });
	      _LedgerUtil2.default.fetchLedgerBoxOfficeReport(_UserStore2.default.getState().apiKey, params.conditions, params.options).then(function (data) {
	        _this6.setState({
	          boxOfficeReport: data.data
	        });
	        _this6.setState({ isFetching: false });
	      }).catch(_LedgerActions2.default.fetchFailed);
	    }
	  }, {
	    key: "onFetchLedgerTransactionReport",
	    value: function onFetchLedgerTransactionReport(params) {
	      var _this7 = this;
	
	      this.setState({ isFetching: true });
	      _LedgerUtil2.default.fetchLedgerTransactionReport(_UserStore2.default.getState().apiKey, params.conditions, params.options).then(function (data) {
	        _this7.setState({
	          transactionReport: data.data
	        });
	        _this7.setState({ isFetching: false });
	      }).catch(_LedgerActions2.default.fetchFailed);
	    }
	  }, {
	    key: "onFetchFailed",
	    value: function onFetchFailed(e) {
	      alert("Fetching ledger data failed: " + e.message);
	      throw e;
	    }
	  }]);
	
	  return LedgerStore;
	}();
	
	exports.default = _alt2.default.createStore(LedgerStore, "LedgerStore");
	module.exports = exports["default"];

/***/ }),
/* 2316 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _api = __webpack_require__(1160);
	
	var _api2 = _interopRequireDefault(_api);
	
	var _config = __webpack_require__(1173);
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  fetchLedgerTransactions: function fetchLedgerTransactions(apiKey, _ref) {
	    var order = _ref.order;
	
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "GET",
	        endpoint: "ledger/transactions",
	        qs: {
	          order: order
	        },
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response);
	      });
	    });
	  },
	  fetchLedgerAnalyticsTransactions: function fetchLedgerAnalyticsTransactions(apiKey, conditions, options) {
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "POST",
	        endpoint: "analytics/transactions",
	        qs: {
	          conditions: JSON.stringify(conditions),
	          options: JSON.stringify(options)
	        },
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response);
	      });
	    });
	  },
	  fetchLedgerBoxOfficeTransactions: function fetchLedgerBoxOfficeTransactions(apiKey, conditions, options) {
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "POST",
	        endpoint: "analytics/box_office_transactions",
	        qs: {
	          conditions: JSON.stringify(conditions),
	          options: JSON.stringify(options)
	        },
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response);
	      });
	    });
	  },
	  fetchLedgerVenueTransactions: function fetchLedgerVenueTransactions(apiKey, conditions, options) {
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "POST",
	        endpoint: "analytics/venue_transactions",
	        qs: {
	          conditions: JSON.stringify(conditions),
	          options: JSON.stringify(options)
	        },
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response);
	      });
	    });
	  },
	  fetchLedgerVenueReport: function fetchLedgerVenueReport(apiKey, conditions, options) {
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "POST",
	        endpoint: "analytics/venue_report",
	        qs: {
	          conditions: JSON.stringify(conditions),
	          options: JSON.stringify(options)
	        },
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response);
	      });
	    });
	  },
	  fetchLedgerBoxOfficeReport: function fetchLedgerBoxOfficeReport(apiKey, conditions, options) {
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "POST",
	        endpoint: "analytics/box_office_report",
	        qs: {
	          conditions: JSON.stringify(conditions),
	          options: JSON.stringify(options)
	        },
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response);
	      });
	    });
	  },
	  fetchLedgerTransactionReport: function fetchLedgerTransactionReport(apiKey, conditions, options) {
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "POST",
	        endpoint: "analytics/ledger_transaction_report",
	        qs: {
	          conditions: JSON.stringify(conditions),
	          options: JSON.stringify(options)
	        },
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response);
	      });
	    });
	  }
	};
	module.exports = exports["default"];

/***/ }),
/* 2317 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _radium = __webpack_require__(1600);
	
	var _radium2 = _interopRequireDefault(_radium);
	
	var _reactEventListener = __webpack_require__(1230);
	
	var _reactEventListener2 = _interopRequireDefault(_reactEventListener);
	
	var _lodash = __webpack_require__(2033);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _materialUi = __webpack_require__(576);
	
	var _connectToStores = __webpack_require__(1226);
	
	var _connectToStores2 = _interopRequireDefault(_connectToStores);
	
	var _EventBucketStore = __webpack_require__(1593);
	
	var _EventBucketStore2 = _interopRequireDefault(_EventBucketStore);
	
	var _EventBucketActions = __webpack_require__(1218);
	
	var _EventBucketActions2 = _interopRequireDefault(_EventBucketActions);
	
	var _LedgerActions = __webpack_require__(2052);
	
	var _LedgerActions2 = _interopRequireDefault(_LedgerActions);
	
	var _LedgerStore = __webpack_require__(2315);
	
	var _LedgerStore2 = _interopRequireDefault(_LedgerStore);
	
	var _UserStore = __webpack_require__(974);
	
	var _UserStore2 = _interopRequireDefault(_UserStore);
	
	var _workingIndicator = __webpack_require__(1664);
	
	var _workingIndicator2 = _interopRequireDefault(_workingIndicator);
	
	var _label = __webpack_require__(1682);
	
	var _label2 = _interopRequireDefault(_label);
	
	var _moment = __webpack_require__(1021);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _twix = __webpack_require__(2312);
	
	var _twix2 = _interopRequireDefault(_twix);
	
	var _util = __webpack_require__(1183);
	
	var util = _interopRequireWildcard(_util);
	
	var _config = __webpack_require__(1173);
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BoxOfficeReportView = function (_React$Component) {
	  _inherits(BoxOfficeReportView, _React$Component);
	
	  function BoxOfficeReportView(props) {
	    _classCallCheck(this, BoxOfficeReportView);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(BoxOfficeReportView).call(this, props));
	
	    _this.downloadCsv = _this.downloadCsv.bind(_this);
	    _this.downloadPdf = _this.downloadPdf.bind(_this);
	    return _this;
	  }
	
	  _createClass(BoxOfficeReportView, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.componentWillReceiveProps(this.props, true);
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(newProps) {
	      var force = arguments.length <= 1 || arguments[1] === undefined ? false : arguments[1];
	
	      if (newProps.selectedBucket === null || newProps.selectedFilms.length === 0) {
	        return;
	      }
	
	      if (newProps.selectedBucket !== this.props.selectedBucket || !_lodash2.default.isEqual(newProps.selectedFilms, this.props.selectedFilms) || force === true) {
	        var conditions = this.buildConditions(newProps);
	        var options = {
	          timePeriod: newProps.grouping
	        };
	
	        _LedgerActions2.default.fetchLedgerBoxOfficeReport.defer({
	          conditions: conditions,
	          options: options
	        });
	
	        if (newProps.selectedBucket !== newProps.selectedBucket) {
	          _EventBucketActions2.default.fetchOne.defer(newProps.selectedBucket);
	        }
	      }
	    }
	  }, {
	    key: "buildConditions",
	    value: function buildConditions(newProps) {
	      var timezone = newProps.getEventBucketById(newProps.selectedBucket).timezone;
	
	      var conditions = Object.assign({
	        event_bucket: [newProps.selectedBucket]
	      });
	
	      if (!newProps.allTime) {
	        conditions.date = {
	          $gt: _moment2.default.tz(newProps.startTime, timezone).startOf("day"),
	          $lte: _moment2.default.tz(newProps.endTime, timezone).endOf("day")
	        };
	      }
	
	      //TODO: Discuss with Theo about these values in the Box Office Report
	      conditions["type"] = { $in: ["PAYMENT", "ADJUSTMENT", "REFUND"] };
	      conditions["class"] = { $in: ["TICKET", "TAX"] };
	      conditions.films = newProps.selectedFilms.map(function (item) {
	        if (item.value) {
	          return item.value;
	        } else {
	          return item;
	        }
	      });
	
	      return conditions;
	    }
	  }, {
	    key: "downloadCsv",
	    value: function downloadCsv() {
	      var conditions = this.buildConditions(this.props);
	      var options = {
	        timePeriod: this.props.grouping,
	        format: "csv"
	      };
	
	      var form = document.createElement("form");
	      form.method = "post";
	      form.action = _config2.default.endpoint + "analytics/box_office_report?" + _UserStore2.default.makeApiKeyQueryString() + "&conditions=" + JSON.stringify(conditions) + "&options=" + JSON.stringify(options);
	      form.target = "generatedCsv";
	
	      document.body.appendChild(form);
	
	      window.open("", "generatedCsv");
	      form.submit();
	    }
	  }, {
	    key: "downloadPdf",
	    value: function downloadPdf() {
	      var conditions = this.buildConditions(this.props);
	      var options = {
	        timePeriod: this.props.grouping,
	        format: "pdf"
	      };
	
	      var form = document.createElement("form");
	      form.method = "post";
	      form.action = _config2.default.endpoint + "analytics/box_office_report?" + _UserStore2.default.makeApiKeyQueryString() + "&conditions=" + JSON.stringify(conditions) + "&options=" + JSON.stringify(options);
	      form.target = "generatedPdf";
	
	      document.body.appendChild(form);
	
	      window.open("", "generatedPdf");
	      form.submit();
	    }
	  }, {
	    key: "getStyles",
	    value: function getStyles() {
	      return {
	        overlay: {
	          position: "absolute",
	          right: 0,
	          top: 0,
	          backgroundColor: "#fff",
	          boxShadow: "0 0 5px 2px rgb(0,0,0,0.1)",
	          zIndex: 1
	        },
	        overlaySubmit: {
	          position: "absolute",
	          right: 10,
	          bottom: 10
	        },
	        gridHeaderRow: {
	          color: "#fff",
	          backgroundColor: "#0288d1"
	        },
	        gridHeaderLabel: {
	          textAlign: "right",
	          padding: "4px",
	          width: "100px",
	          borderRight: "1px solid #fff"
	        },
	        gridDayTitle: {
	          fontWeight: "bold",
	          fontSize: "16px",
	          paddingTop: "20px",
	          paddingBottom: "2px",
	          paddingLeft: "2px"
	        },
	        gridTimeTitle: {
	          fontWeight: "bold",
	          fontSize: "13px",
	          paddingTop: "2px",
	          paddingLeft: "2px",
	          paddingBottom: "2px"
	        },
	        gridLabelCell: {
	          textAlign: "left",
	          padding: "2px"
	        },
	        gridDataCell: {
	          textAlign: "right",
	          padding: "2px",
	          width: "100px"
	        },
	        gridButtonRow: {
	          width: "100%",
	          display: "flex",
	          flexDirection: "row",
	          justifyContent: "start"
	        }
	      };
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var styles = this.getStyles();
	
	      var _props = this.props;
	      var selectedBucket = _props.selectedBucket;
	      var selectedFilms = _props.selectedFilms;
	      var allTime = _props.allTime;
	      var startTime = _props.startTime;
	      var endTime = _props.endTime;
	
	
	      var eventBucket = this.props.getEventBucketById(selectedBucket);
	
	      var timePeriod = allTime ? "All time" : (0, _moment2.default)(startTime).twix(endTime, { allDay: true }).format({ implicitYear: false });
	
	      var displayArray = [];
	
	      if (selectedBucket && selectedFilms && selectedFilms.length > 0) {
	        displayArray = this.props.getLedgerBoxOfficeReport();
	      }
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        !this.props.isFetching ? _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement(
	            "div",
	            {
	              style: {
	                width: "100%",
	                display: "flex",
	                flexDirection: "row",
	                justifyContent: "start",
	                paddingTop: "20px"
	              }
	            },
	            _react2.default.createElement(
	              "table",
	              null,
	              _react2.default.createElement(
	                "tbody",
	                null,
	                _react2.default.createElement(
	                  "tr",
	                  { style: styles.gridHeaderRow },
	                  _react2.default.createElement("td", null),
	                  _react2.default.createElement(
	                    "td",
	                    { style: styles.gridHeaderLabel },
	                    "SALES"
	                  ),
	                  _react2.default.createElement(
	                    "td",
	                    { style: styles.gridHeaderLabel },
	                    "REFUNDS"
	                  ),
	                  _react2.default.createElement(
	                    "td",
	                    { style: styles.gridHeaderLabel },
	                    "ADMITS"
	                  ),
	                  _react2.default.createElement(
	                    "td",
	                    { style: styles.gridHeaderLabel },
	                    "GROSS TOTAL"
	                  ),
	                  _react2.default.createElement(
	                    "td",
	                    { style: styles.gridHeaderLabel },
	                    "FEE TOTAL"
	                  ),
	                  _react2.default.createElement(
	                    "td",
	                    { style: styles.gridHeaderLabel },
	                    "TAX TOTAL"
	                  ),
	                  _react2.default.createElement(
	                    "td",
	                    { style: styles.gridHeaderLabel },
	                    "NET TOTAL"
	                  )
	                ),
	                displayArray.length > 0 ? displayArray.map(function (row) {
	                  if (row.time === undefined && row.summary === undefined) {
	                    return _react2.default.createElement(
	                      "tr",
	                      null,
	                      _react2.default.createElement(
	                        "td",
	                        { colSpan: "8", style: styles.gridDayTitle },
	                        row.description
	                      )
	                    );
	                  } else if (row.time && row.category === undefined) {
	                    return _react2.default.createElement(
	                      "tr",
	                      null,
	                      _react2.default.createElement(
	                        "td",
	                        { colSpan: "8", style: styles.gridTimeTitle },
	                        row.description
	                      )
	                    );
	                  } else {
	                    return _react2.default.createElement(
	                      "tr",
	                      {
	                        style: row.summary === undefined ? {} : row.overall ? {
	                          fontWeight: "bold",
	                          fontSize: "16px",
	                          borderBottom: "1px solid black"
	                        } : {
	                          fontWeight: "bold",
	                          fontSize: "13px",
	                          borderBottom: "1px solid black"
	                        }
	                      },
	                      _react2.default.createElement(
	                        "td",
	                        {
	                          style: row.overall ? { paddingTop: "20px", paddingLeft: "2px" } : styles.gridLabelCell
	                        },
	                        row.description
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { style: styles.gridDataCell },
	                        row.saleCount
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { style: styles.gridDataCell },
	                        row.refundCount
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { style: styles.gridDataCell },
	                        row.admitCount
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { style: styles.gridDataCell },
	                        row.grossTotal
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { style: styles.gridDataCell },
	                        row.feeTotal
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { style: styles.gridDataCell },
	                        row.taxTotal
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { style: styles.gridDataCell },
	                        row.netTotal
	                      )
	                    );
	                  }
	                }) : _react2.default.createElement(
	                  "tr",
	                  null,
	                  _react2.default.createElement(
	                    "td",
	                    { colSpan: "8" },
	                    "No records found."
	                  )
	                )
	              )
	            )
	          ),
	          displayArray.length > 0 ? _react2.default.createElement(
	            "div",
	            { style: styles.gridButtonRow },
	            _react2.default.createElement(
	              "div",
	              { style: styles.rangeContainer },
	              _react2.default.createElement(_materialUi.RaisedButton, {
	                style: { marginTop: "20px", marginRight: "25px" },
	                onClick: this.downloadCsv,
	                label: "DOWNLOAD (.CSV)"
	              })
	            ),
	            _react2.default.createElement(
	              "div",
	              { style: styles.rangeContainer },
	              _react2.default.createElement(_materialUi.RaisedButton, {
	                style: { marginTop: "20px", marginRight: "25px" },
	                onClick: this.downloadPdf,
	                label: "DOWNLOAD (.PDF)"
	              })
	            )
	          ) : null
	        ) : _react2.default.createElement(
	          "div",
	          { style: { clear: "both" } },
	          _react2.default.createElement(_workingIndicator2.default, { fullPage: true })
	        )
	      );
	    }
	  }], [{
	    key: "getStores",
	    value: function getStores() {
	      return [_EventBucketStore2.default, _LedgerStore2.default];
	    }
	  }, {
	    key: "getPropsFromStores",
	    value: function getPropsFromStores() {
	      return {
	        getEventBuckets: _EventBucketStore2.default.getEventBuckets,
	        getEventBucketById: _EventBucketStore2.default.getEventBucketById,
	        getLedgerAnalyticsTransactions: _LedgerStore2.default.getLedgerAnalyticsTransactions,
	        getLedgerBoxOfficeTransactions: _LedgerStore2.default.getLedgerBoxOfficeTransactions,
	        getLedgerBoxOfficeReport: _LedgerStore2.default.getLedgerBoxOfficeReport,
	        isFetching: _LedgerStore2.default.getState().isFetching
	      };
	    }
	  }]);
	
	  return BoxOfficeReportView;
	}(_react2.default.Component);
	
	exports.default = (0, _radium2.default)((0, _connectToStores2.default)(BoxOfficeReportView));
	module.exports = exports["default"];

/***/ }),
/* 2318 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _radium = __webpack_require__(1600);
	
	var _radium2 = _interopRequireDefault(_radium);
	
	var _reactEventListener = __webpack_require__(1230);
	
	var _reactEventListener2 = _interopRequireDefault(_reactEventListener);
	
	var _lodash = __webpack_require__(2033);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _materialUi = __webpack_require__(576);
	
	var _connectToStores = __webpack_require__(1226);
	
	var _connectToStores2 = _interopRequireDefault(_connectToStores);
	
	var _EventBucketStore = __webpack_require__(1593);
	
	var _EventBucketStore2 = _interopRequireDefault(_EventBucketStore);
	
	var _EventBucketActions = __webpack_require__(1218);
	
	var _EventBucketActions2 = _interopRequireDefault(_EventBucketActions);
	
	var _LedgerActions = __webpack_require__(2052);
	
	var _LedgerActions2 = _interopRequireDefault(_LedgerActions);
	
	var _LedgerStore = __webpack_require__(2315);
	
	var _LedgerStore2 = _interopRequireDefault(_LedgerStore);
	
	var _UserStore = __webpack_require__(974);
	
	var _UserStore2 = _interopRequireDefault(_UserStore);
	
	var _workingIndicator = __webpack_require__(1664);
	
	var _workingIndicator2 = _interopRequireDefault(_workingIndicator);
	
	var _label = __webpack_require__(1682);
	
	var _label2 = _interopRequireDefault(_label);
	
	var _moment = __webpack_require__(1021);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _twix = __webpack_require__(2312);
	
	var _twix2 = _interopRequireDefault(_twix);
	
	var _util = __webpack_require__(1183);
	
	var util = _interopRequireWildcard(_util);
	
	var _config = __webpack_require__(1173);
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SummaryGridReportView = function (_React$Component) {
	  _inherits(SummaryGridReportView, _React$Component);
	
	  function SummaryGridReportView(props) {
	    _classCallCheck(this, SummaryGridReportView);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(SummaryGridReportView).call(this, props));
	
	    _this.downloadCsv = _this.downloadCsv.bind(_this);
	    _this.downloadPdf = _this.downloadPdf.bind(_this);
	    return _this;
	  }
	
	  _createClass(SummaryGridReportView, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.componentWillReceiveProps(this.props, true);
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(newProps) {
	      var force = arguments.length <= 1 || arguments[1] === undefined ? false : arguments[1];
	
	      if (newProps.selectedBuckets === null || newProps.selectedBuckets.length === 0) {
	        return;
	      }
	
	      if (!_lodash2.default.isEqual(newProps.selectedBuckets, this.props.selectedBuckets) || force === true) {
	        var conditions = this.buildConditions(newProps);
	
	        var options = {
	          timePeriod: newProps.grouping
	        };
	
	        _LedgerActions2.default.fetchLedgerTransactionReport.defer({
	          conditions: conditions,
	          options: options
	        });
	      }
	    }
	  }, {
	    key: "buildConditions",
	    value: function buildConditions(newProps) {
	      var eventBuckets = newProps.selectedBuckets;
	      if (typeof eventBuckets === "string") {
	        eventBuckets = [eventBuckets];
	      } else if (eventBuckets.length === 0) {
	        eventBuckets = this.props.getEventBuckets().map(function (item) {
	          return item.id;
	        });
	      }
	
	      var conditions = Object.assign({
	        event_bucket: eventBuckets
	      }, !newProps.allTime && {
	        date: {
	          $gt: (0, _moment2.default)(newProps.startTime).startOf("day"),
	          $lte: (0, _moment2.default)(newProps.endTime).endOf("day")
	        }
	      });
	
	      if (newProps.tType.length === 1) {
	        conditions["type"] = newProps.tType[0].value;
	      } else if (newProps.tType.length > 1) {
	        var typeValues = newProps.tType.map(function (item) {
	          return item.value;
	        });
	        conditions["type"] = { $in: typeValues };
	      }
	
	      if (newProps.tClass.length === 1) {
	        conditions["class"] = newProps.tClass[0].value;
	      } else if (newProps.tClass.length > 1) {
	        var classValues = newProps.tClass.map(function (item) {
	          return item.value;
	        });
	        conditions["class"] = { $in: classValues };
	      }
	
	      return conditions;
	    }
	  }, {
	    key: "downloadCsv",
	    value: function downloadCsv() {
	      var conditions = this.buildConditions(this.props);
	      var options = {
	        timePeriod: this.props.grouping,
	        format: "csv"
	      };
	
	      var form = document.createElement("form");
	      form.method = "post";
	      form.action = _config2.default.endpoint + "analytics/ledger_transaction_report?" + _UserStore2.default.makeApiKeyQueryString() + "&conditions=" + JSON.stringify(conditions) + "&options=" + JSON.stringify(options);
	      form.target = "generatedCsv";
	
	      document.body.appendChild(form);
	
	      window.open("", "generatedCsv");
	      form.submit();
	    }
	  }, {
	    key: "downloadPdf",
	    value: function downloadPdf() {
	      var conditions = this.buildConditions(this.props);
	      var options = {
	        timePeriod: this.props.grouping,
	        format: "pdf"
	      };
	
	      var form = document.createElement("form");
	      form.method = "post";
	      form.action = _config2.default.endpoint + "analytics/ledger_transaction_report?" + _UserStore2.default.makeApiKeyQueryString() + "&conditions=" + JSON.stringify(conditions) + "&options=" + JSON.stringify(options);
	      form.target = "generatedPdf";
	
	      document.body.appendChild(form);
	
	      window.open("", "generatedPdf");
	      form.submit();
	    }
	  }, {
	    key: "getStyles",
	    value: function getStyles() {
	      return {
	        overlay: {
	          position: "absolute",
	          right: 0,
	          top: 0,
	          backgroundColor: "#fff",
	          boxShadow: "0 0 5px 2px rgb(0,0,0,0.1)",
	          zIndex: 1
	        },
	        overlaySubmit: {
	          position: "absolute",
	          right: 10,
	          bottom: 10
	        },
	        gridHeaderRow: {
	          color: "#fff",
	          backgroundColor: "#0288d1"
	        },
	        gridHeaderLabel: {
	          textAlign: "right",
	          padding: "4px",
	          width: "13%",
	          borderRight: "1px solid #fff"
	        },
	        gridHeaderLabelFirstColumn: {
	          textAlign: "left",
	          padding: "4px",
	          width: "46%",
	          borderRight: "1px solid #fff"
	        },
	        gridDayTitle: {
	          fontWeight: "bold",
	          fontSize: "16px",
	          paddingTop: "20px",
	          paddingBottom: "2px",
	          paddingLeft: "2px"
	        },
	        gridTimeTitle: {
	          fontWeight: "bold",
	          fontSize: "13px",
	          paddingTop: "2px",
	          paddingLeft: "2px",
	          paddingBottom: "2px"
	        },
	        gridLabelCell: {
	          textAlign: "left",
	          padding: "2px"
	        },
	        gridDataCell: {
	          textAlign: "right",
	          padding: "2px",
	          width: "100px"
	        },
	        gridDataSummaryTitle: {
	          fontWeight: "bold",
	          fontSize: "16px",
	          padding: "2px"
	        },
	        gridDataOverallSummaryTitle: {
	          fontWeight: "bold",
	          fontSize: "20px",
	          padding: "2px",
	          paddingTop: "15px"
	        },
	        gridDataSummaryCell: {
	          textAlign: "right",
	          fontWeight: "bold",
	          fontSize: "16px",
	          padding: "2px"
	        },
	        gridDataOverallSummaryCell: {
	          textAlign: "right",
	          fontWeight: "bold",
	          fontSize: "20px",
	          padding: "2px",
	          paddingTop: "15px"
	        },
	        gridButtonRow: {
	          width: "100%",
	          display: "flex",
	          flexDirection: "row",
	          justifyContent: "start"
	        }
	      };
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var styles = this.getStyles();
	
	      var _props = this.props;
	      var selectedBuckets = _props.selectedBuckets;
	      var allTime = _props.allTime;
	      var startDate = _props.startDate;
	      var endDate = _props.endDate;
	      var reportType = _props.reportType;
	      var grouping = _props.grouping;
	
	
	      if (!selectedBuckets || selectedBuckets.length === 0) {
	        return _react2.default.createElement(
	          "div",
	          null,
	          "No records found."
	        );
	      }
	
	      var timePeriod = allTime ? "All time" : (0, _moment2.default)(startDate).twix(endDate, { allDay: true }).format({ implicitYear: false });
	
	      var displayArray = [];
	
	      if (selectedBuckets && selectedBuckets.length > 0) {
	        displayArray = this.props.getLedgerTransactionReport();
	      }
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        !this.props.isFetching ? _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement(
	            "div",
	            {
	              style: {
	                width: "100%",
	                display: "flex",
	                flexDirection: "row",
	                justifyContent: "start",
	                paddingTop: "20px"
	              }
	            },
	            _react2.default.createElement(
	              "table",
	              null,
	              _react2.default.createElement(
	                "tbody",
	                null,
	                _react2.default.createElement(
	                  "tr",
	                  { style: styles.gridHeaderRow },
	                  _react2.default.createElement(
	                    "td",
	                    { style: styles.gridHeaderLabelFirstColumn },
	                    "Time Period"
	                  ),
	                  _react2.default.createElement(
	                    "td",
	                    { style: styles.gridHeaderLabel },
	                    "Gross"
	                  ),
	                  _react2.default.createElement(
	                    "td",
	                    { style: styles.gridHeaderLabel },
	                    "Fee"
	                  ),
	                  _react2.default.createElement(
	                    "td",
	                    { style: styles.gridHeaderLabel },
	                    "Tax"
	                  ),
	                  _react2.default.createElement(
	                    "td",
	                    { style: styles.gridHeaderLabel },
	                    "Net"
	                  )
	                ),
	                displayArray.length > 0 ? displayArray.map(function (row) {
	                  if (row.column1 && row.column2 === undefined && row.summary === undefined) {
	                    return _react2.default.createElement(
	                      "tr",
	                      null,
	                      _react2.default.createElement(
	                        "td",
	                        { colSpan: "5", style: styles.gridDayTitle },
	                        row.column1
	                      )
	                    );
	                  } else if (row.column1 && row.summary) {
	                    return _react2.default.createElement(
	                      "tr",
	                      null,
	                      _react2.default.createElement(
	                        "td",
	                        {
	                          style: row.overall ? styles.gridDataOverallSummaryTitle : styles.gridDataSummaryTitle
	                        },
	                        row.column1,
	                        " Total"
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        {
	                          style: row.overall ? styles.gridDataOverallSummaryCell : styles.gridDataSummaryCell
	                        },
	                        row.grossTotal
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        {
	                          style: row.overall ? styles.gridDataOverallSummaryCell : styles.gridDataSummaryCell
	                        },
	                        row.feeTotal
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        {
	                          style: row.overall ? styles.gridDataOverallSummaryCell : styles.gridDataSummaryCell
	                        },
	                        row.taxTotal
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        {
	                          style: row.overall ? styles.gridDataOverallSummaryCell : styles.gridDataSummaryCell
	                        },
	                        row.netTotal
	                      )
	                    );
	                  } else {
	                    return _react2.default.createElement(
	                      "tr",
	                      {
	                        style: row.summary === undefined ? {} : row.overall ? {
	                          fontWeight: "bold",
	                          fontSize: "16px",
	                          borderBottom: "1px solid black"
	                        } : {
	                          fontWeight: "bold",
	                          fontSize: "13px",
	                          borderBottom: "1px solid black"
	                        }
	                      },
	                      _react2.default.createElement(
	                        "td",
	                        {
	                          style: row.overall ? { paddingTop: "20px", paddingLeft: "2px" } : styles.gridLabelCell
	                        },
	                        row.column2
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { style: styles.gridDataCell },
	                        row.grossTotal
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { style: styles.gridDataCell },
	                        row.feeTotal
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { style: styles.gridDataCell },
	                        row.taxTotal
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { style: styles.gridDataCell },
	                        row.netTotal
	                      )
	                    );
	                  }
	                }) : _react2.default.createElement(
	                  "tr",
	                  null,
	                  _react2.default.createElement(
	                    "td",
	                    { colSpan: "5" },
	                    "No records found."
	                  )
	                )
	              )
	            )
	          ),
	          displayArray.length > 0 ? _react2.default.createElement(
	            "div",
	            { style: styles.gridButtonRow },
	            _react2.default.createElement(
	              "div",
	              { style: styles.rangeContainer },
	              _react2.default.createElement(_materialUi.RaisedButton, {
	                style: { marginTop: "20px", marginRight: "25px" },
	                onClick: this.downloadCsv,
	                label: "DOWNLOAD (.CSV)"
	              })
	            ),
	            _react2.default.createElement(
	              "div",
	              { style: styles.rangeContainer },
	              _react2.default.createElement(_materialUi.RaisedButton, {
	                style: { marginTop: "20px", marginRight: "25px" },
	                onClick: this.downloadPdf,
	                label: "DOWNLOAD (.PDF)"
	              })
	            )
	          ) : null
	        ) : _react2.default.createElement(
	          "div",
	          { style: { clear: "both" } },
	          _react2.default.createElement(_workingIndicator2.default, { fullPage: true })
	        )
	      );
	    }
	  }], [{
	    key: "getStores",
	    value: function getStores() {
	      return [_EventBucketStore2.default, _LedgerStore2.default];
	    }
	  }, {
	    key: "getPropsFromStores",
	    value: function getPropsFromStores() {
	      return {
	        getEventBuckets: _EventBucketStore2.default.getEventBuckets,
	        getEventBucketById: _EventBucketStore2.default.getEventBucketById,
	        getLedgerAnalyticsTransactions: _LedgerStore2.default.getLedgerAnalyticsTransactions,
	        getLedgerTransactionReport: _LedgerStore2.default.getLedgerTransactionReport,
	        isFetching: _LedgerStore2.default.getState().isFetching
	      };
	    }
	  }]);
	
	  return SummaryGridReportView;
	}(_react2.default.Component);
	
	exports.default = (0, _radium2.default)((0, _connectToStores2.default)(SummaryGridReportView));
	module.exports = exports["default"];

/***/ }),
/* 2319 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _radium = __webpack_require__(1600);
	
	var _radium2 = _interopRequireDefault(_radium);
	
	var _reactEventListener = __webpack_require__(1230);
	
	var _reactEventListener2 = _interopRequireDefault(_reactEventListener);
	
	var _lodash = __webpack_require__(2033);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _materialUi = __webpack_require__(576);
	
	var _connectToStores = __webpack_require__(1226);
	
	var _connectToStores2 = _interopRequireDefault(_connectToStores);
	
	var _EventBucketStore = __webpack_require__(1593);
	
	var _EventBucketStore2 = _interopRequireDefault(_EventBucketStore);
	
	var _EventBucketActions = __webpack_require__(1218);
	
	var _EventBucketActions2 = _interopRequireDefault(_EventBucketActions);
	
	var _LedgerActions = __webpack_require__(2052);
	
	var _LedgerActions2 = _interopRequireDefault(_LedgerActions);
	
	var _LedgerStore = __webpack_require__(2315);
	
	var _LedgerStore2 = _interopRequireDefault(_LedgerStore);
	
	var _UserStore = __webpack_require__(974);
	
	var _UserStore2 = _interopRequireDefault(_UserStore);
	
	var _workingIndicator = __webpack_require__(1664);
	
	var _workingIndicator2 = _interopRequireDefault(_workingIndicator);
	
	var _label = __webpack_require__(1682);
	
	var _label2 = _interopRequireDefault(_label);
	
	var _moment = __webpack_require__(1021);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _twix = __webpack_require__(2312);
	
	var _twix2 = _interopRequireDefault(_twix);
	
	var _util = __webpack_require__(1183);
	
	var util = _interopRequireWildcard(_util);
	
	var _config = __webpack_require__(1173);
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DataGridReportView = function (_React$Component) {
	  _inherits(DataGridReportView, _React$Component);
	
	  function DataGridReportView(props) {
	    _classCallCheck(this, DataGridReportView);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(DataGridReportView).call(this, props));
	
	    _this.downloadCsv = _this.downloadCsv.bind(_this);
	    _this.downloadPdf = _this.downloadPdf.bind(_this);
	    return _this;
	  }
	
	  _createClass(DataGridReportView, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.componentWillReceiveProps(this.props, true);
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(newProps) {
	      var force = arguments.length <= 1 || arguments[1] === undefined ? false : arguments[1];
	
	      if (newProps.selectedBuckets === null || newProps.selectedBuckets.length === 0) {
	        return;
	      }
	
	      if (!_lodash2.default.isEqual(newProps.selectedBuckets, this.props.selectedBuckets) || force === true) {
	        var conditions = this.buildConditions(newProps);
	
	        var options = {
	          timePeriod: newProps.grouping,
	          includeNameAndEmail: newProps.includeNameAndEmail
	        };
	
	        if (newProps.selectedEvent) {
	          // NOTE: Sending this in an array to allow for future possibility
	          //       of selecting multiple events
	          options.selectedEvent = [newProps.selectedEvent.id];
	        }
	
	        _LedgerActions2.default.fetchLedgerTransactionReport.defer({
	          conditions: conditions,
	          options: options
	        });
	      }
	    }
	  }, {
	    key: "buildConditions",
	    value: function buildConditions(newProps) {
	      var eventBuckets = newProps.selectedBuckets;
	      if (typeof eventBuckets === "string") {
	        eventBuckets = [eventBuckets];
	      } else if (eventBuckets.length === 0) {
	        eventBuckets = this.props.getEventBuckets().map(function (item) {
	          return item.id;
	        });
	      }
	
	      var conditions = Object.assign({
	        event_bucket: eventBuckets
	      }, !newProps.allTime && {
	        date: {
	          $gt: (0, _moment2.default)(newProps.startTime).startOf("day"),
	          $lte: (0, _moment2.default)(newProps.endTime).endOf("day")
	        }
	      });
	
	      if (newProps.tType.length === 1) {
	        conditions["type"] = newProps.tType[0].value;
	      } else if (newProps.tType.length > 1) {
	        var typeValues = newProps.tType.map(function (item) {
	          return item.value;
	        });
	        conditions["type"] = { $in: typeValues };
	      }
	
	      if (newProps.tClass.length === 1) {
	        conditions["class"] = newProps.tClass[0].value;
	      } else if (newProps.tClass.length > 1) {
	        var classValues = newProps.tClass.map(function (item) {
	          return item.value;
	        });
	        conditions["class"] = { $in: classValues };
	      }
	
	      return conditions;
	    }
	  }, {
	    key: "downloadCsv",
	    value: function downloadCsv() {
	      var conditions = this.buildConditions(this.props);
	      var options = {
	        timePeriod: this.props.grouping,
	        includeNameAndEmail: this.props.includeNameAndEmail,
	        format: "csv"
	      };
	
	      if (this.props.selectedEvent) {
	        options.selectedEvent = [this.props.selectedEvent.id];
	      }
	
	      var form = document.createElement("form");
	      form.method = "post";
	      form.action = _config2.default.endpoint + "analytics/ledger_transaction_report?" + _UserStore2.default.makeApiKeyQueryString() + "&conditions=" + JSON.stringify(conditions) + "&options=" + JSON.stringify(options);
	      form.target = "generatedCsv";
	
	      document.body.appendChild(form);
	
	      window.open("", "generatedCsv");
	      form.submit();
	    }
	  }, {
	    key: "downloadPdf",
	    value: function downloadPdf() {
	      var conditions = this.buildConditions(this.props);
	      var options = {
	        timePeriod: this.props.grouping,
	        includeNameAndEmail: this.props.includeNameAndEmail,
	        format: "pdf"
	      };
	
	      if (this.props.selectedEvent) {
	        options.selectedEvent = [this.props.selectedEvent.id];
	      }
	
	      var form = document.createElement("form");
	      form.method = "post";
	      form.action = _config2.default.endpoint + "analytics/ledger_transaction_report?" + _UserStore2.default.makeApiKeyQueryString() + "&conditions=" + JSON.stringify(conditions) + "&options=" + JSON.stringify(options);
	      form.target = "generatedPdf";
	
	      document.body.appendChild(form);
	
	      window.open("", "generatedPdf");
	      form.submit();
	    }
	  }, {
	    key: "getStyles",
	    value: function getStyles() {
	      return {
	        overlay: {
	          position: "absolute",
	          right: 0,
	          top: 0,
	          backgroundColor: "#fff",
	          boxShadow: "0 0 5px 2px rgb(0,0,0,0.1)",
	          zIndex: 1
	        },
	        overlaySubmit: {
	          position: "absolute",
	          right: 10,
	          bottom: 10
	        },
	        gridHeaderRow: {
	          color: "#fff",
	          backgroundColor: "#0288d1"
	        },
	        gridHeaderLabel: {
	          textAlign: "right",
	          padding: "4px",
	          width: "100px",
	          borderRight: "1px solid #fff"
	        },
	        gridHeaderLabelFinancial: {
	          textAlign: "right",
	          padding: "4px",
	          width: "75px",
	          borderRight: "1px solid #fff"
	        },
	        gridHeaderLabelSubcategory: {
	          textAlign: "right",
	          padding: "4px",
	          width: "75px",
	          borderRight: "1px solid #fff"
	        },
	        gridHeaderLabelFirstColumn: {
	          textAlign: "left",
	          padding: "4px",
	          minWidth: "150px",
	          borderRight: "1px solid #fff"
	        },
	        gridDayTitle: {
	          fontWeight: "bold",
	          fontSize: "16px",
	          paddingTop: "20px",
	          paddingBottom: "2px",
	          paddingLeft: "2px"
	        },
	        gridTimeTitle: {
	          fontWeight: "bold",
	          fontSize: "13px",
	          paddingTop: "2px",
	          paddingLeft: "2px",
	          paddingBottom: "2px"
	        },
	        gridLabelCell: {
	          textAlign: "left",
	          padding: "2px"
	        },
	        gridDataCell: {
	          textAlign: "right",
	          padding: "2px",
	          width: "100px"
	        },
	        gridDataCellFinancial: {
	          textAlign: "right",
	          padding: "2px",
	          width: "75px"
	        },
	        gridDataCellSubcategory: {
	          textAlign: "right",
	          padding: "2px",
	          width: "175px"
	        },
	        gridDataCellFirstColumn: {
	          textAlign: "left",
	          padding: "2px",
	          minwidth: "150px"
	        },
	        gridDataSummaryTitle: {
	          fontWeight: "bold",
	          fontSize: "16px",
	          padding: "2px"
	        },
	        gridDataOverallSummaryTitle: {
	          fontWeight: "bold",
	          fontSize: "20px",
	          padding: "2px",
	          paddingTop: "15px"
	        },
	        gridDataSummaryCell: {
	          textAlign: "right",
	          fontWeight: "bold",
	          fontSize: "16px",
	          padding: "2px"
	        },
	        gridDataOverallSummaryCell: {
	          textAlign: "right",
	          fontWeight: "bold",
	          fontSize: "20px",
	          padding: "2px",
	          paddingTop: "15px"
	        },
	        gridButtonRow: {
	          width: "100%",
	          display: "flex",
	          flexDirection: "row",
	          justifyContent: "start"
	        }
	      };
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var styles = this.getStyles();
	
	      var _props = this.props;
	      var selectedBuckets = _props.selectedBuckets;
	      var allTime = _props.allTime;
	      var startDate = _props.startDate;
	      var endDate = _props.endDate;
	      var reportType = _props.reportType;
	      var grouping = _props.grouping;
	      var includeNameAndEmail = _props.includeNameAndEmail;
	
	
	      if (!selectedBuckets || selectedBuckets.length === 0) {
	        return _react2.default.createElement(
	          "div",
	          null,
	          "No records found."
	        );
	      }
	
	      var timePeriod = allTime ? "All time" : (0, _moment2.default)(startDate).twix(endDate, { allDay: true }).format({ implicitYear: false });
	
	      var displayArray = [];
	
	      if (selectedBuckets && selectedBuckets.length > 0) {
	        displayArray = this.props.getLedgerTransactionReport();
	      }
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        !this.props.isFetching ? _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement(
	            "div",
	            {
	              style: {
	                width: "100%",
	                display: "flex",
	                flexDirection: "row",
	                justifyContent: "start",
	                paddingTop: "20px"
	              }
	            },
	            _react2.default.createElement(
	              "table",
	              null,
	              _react2.default.createElement(
	                "tbody",
	                null,
	                _react2.default.createElement(
	                  "tr",
	                  { style: styles.gridHeaderRow },
	                  _react2.default.createElement(
	                    "td",
	                    { style: styles.gridHeaderLabelFirstColumn },
	                    "Date"
	                  ),
	                  _react2.default.createElement(
	                    "td",
	                    { style: styles.gridHeaderLabelFirstColumn },
	                    "Category"
	                  ),
	                  _react2.default.createElement(
	                    "td",
	                    { style: styles.gridHeaderLabel },
	                    "Type"
	                  ),
	                  _react2.default.createElement(
	                    "td",
	                    { style: styles.gridHeaderLabel },
	                    "Class"
	                  ),
	                  _react2.default.createElement(
	                    "td",
	                    { style: styles.gridHeaderLabelSubcategory },
	                    "Subcategory"
	                  ),
	                  _react2.default.createElement(
	                    "td",
	                    { style: styles.gridHeaderLabel },
	                    "Variant"
	                  ),
	                  _react2.default.createElement(
	                    "td",
	                    { style: styles.gridHeaderLabel },
	                    "Acct Type"
	                  ),
	                  _react2.default.createElement(
	                    "td",
	                    { style: styles.gridHeaderLabelFinancial },
	                    "Gross"
	                  ),
	                  _react2.default.createElement(
	                    "td",
	                    { style: styles.gridHeaderLabelFinancial },
	                    "Fee"
	                  ),
	                  _react2.default.createElement(
	                    "td",
	                    { style: styles.gridHeaderLabelFinancial },
	                    "Net"
	                  ),
	                  includeNameAndEmail ? _react2.default.createElement(
	                    "td",
	                    { style: styles.gridHeaderLabel },
	                    "Name"
	                  ) : null,
	                  includeNameAndEmail ? _react2.default.createElement(
	                    "td",
	                    { style: styles.gridHeaderLabel },
	                    "Email"
	                  ) : null
	                ),
	                displayArray.length > 0 ? displayArray.map(function (row) {
	                  return _react2.default.createElement(
	                    "tr",
	                    null,
	                    _react2.default.createElement(
	                      "td",
	                      { style: styles.gridDataCellFirstColumn },
	                      row.date
	                    ),
	                    _react2.default.createElement(
	                      "td",
	                      { style: styles.gridDataCellFirstColumn },
	                      row.event_name
	                    ),
	                    _react2.default.createElement(
	                      "td",
	                      { style: styles.gridDataCell },
	                      row.type
	                    ),
	                    _react2.default.createElement(
	                      "td",
	                      { style: styles.gridDataCell },
	                      row.class
	                    ),
	                    _react2.default.createElement(
	                      "td",
	                      { style: styles.gridDataCellSubcategory },
	                      row.subcategory_label
	                    ),
	                    _react2.default.createElement(
	                      "td",
	                      { style: styles.gridDataCell },
	                      row.variant_label
	                    ),
	                    _react2.default.createElement(
	                      "td",
	                      { style: styles.gridDataCellFinancial },
	                      row.account_type
	                    ),
	                    _react2.default.createElement(
	                      "td",
	                      { style: styles.gridDataCellFinancial },
	                      row.gross
	                    ),
	                    _react2.default.createElement(
	                      "td",
	                      { style: styles.gridDataCellFinancial },
	                      row.fee
	                    ),
	                    _react2.default.createElement(
	                      "td",
	                      { style: styles.gridDataCellFinancial },
	                      row.net
	                    ),
	                    includeNameAndEmail ? _react2.default.createElement(
	                      "td",
	                      { style: styles.gridDataCell },
	                      row.name
	                    ) : null,
	                    includeNameAndEmail ? _react2.default.createElement(
	                      "td",
	                      { style: styles.gridDataCell },
	                      row.email
	                    ) : null
	                  );
	                }) : _react2.default.createElement(
	                  "tr",
	                  null,
	                  _react2.default.createElement(
	                    "td",
	                    { colSpan: "8" },
	                    "No records found."
	                  )
	                )
	              )
	            )
	          ),
	          displayArray.length > 0 ? _react2.default.createElement(
	            "div",
	            { style: styles.gridButtonRow },
	            _react2.default.createElement(
	              "div",
	              { style: styles.rangeContainer },
	              _react2.default.createElement(_materialUi.RaisedButton, {
	                style: { marginTop: "20px", marginRight: "25px" },
	                onClick: this.downloadCsv,
	                label: "DOWNLOAD (.CSV)"
	              })
	            ),
	            _react2.default.createElement(
	              "div",
	              { style: styles.rangeContainer },
	              _react2.default.createElement(_materialUi.RaisedButton, {
	                style: { marginTop: "20px", marginRight: "25px" },
	                onClick: this.downloadPdf,
	                label: "DOWNLOAD (.PDF)"
	              })
	            )
	          ) : null
	        ) : _react2.default.createElement(
	          "div",
	          { style: { clear: "both" } },
	          _react2.default.createElement(_workingIndicator2.default, { fullPage: true })
	        )
	      );
	    }
	  }], [{
	    key: "getStores",
	    value: function getStores() {
	      return [_EventBucketStore2.default, _LedgerStore2.default];
	    }
	  }, {
	    key: "getPropsFromStores",
	    value: function getPropsFromStores() {
	      return {
	        getEventBuckets: _EventBucketStore2.default.getEventBuckets,
	        getEventBucketById: _EventBucketStore2.default.getEventBucketById,
	        getLedgerAnalyticsTransactions: _LedgerStore2.default.getLedgerAnalyticsTransactions,
	        getLedgerTransactionReport: _LedgerStore2.default.getLedgerTransactionReport,
	        isFetching: _LedgerStore2.default.getState().isFetching
	      };
	    }
	  }]);
	
	  return DataGridReportView;
	}(_react2.default.Component);
	
	exports.default = (0, _radium2.default)((0, _connectToStores2.default)(DataGridReportView));
	module.exports = exports["default"];

/***/ }),
/* 2320 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _radium = __webpack_require__(1600);
	
	var _radium2 = _interopRequireDefault(_radium);
	
	var _reactEventListener = __webpack_require__(1230);
	
	var _reactEventListener2 = _interopRequireDefault(_reactEventListener);
	
	var _lodash = __webpack_require__(2033);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _materialUi = __webpack_require__(576);
	
	var _connectToStores = __webpack_require__(1226);
	
	var _connectToStores2 = _interopRequireDefault(_connectToStores);
	
	var _EventBucketStore = __webpack_require__(1593);
	
	var _EventBucketStore2 = _interopRequireDefault(_EventBucketStore);
	
	var _EventBucketActions = __webpack_require__(1218);
	
	var _EventBucketActions2 = _interopRequireDefault(_EventBucketActions);
	
	var _LedgerActions = __webpack_require__(2052);
	
	var _LedgerActions2 = _interopRequireDefault(_LedgerActions);
	
	var _LedgerStore = __webpack_require__(2315);
	
	var _LedgerStore2 = _interopRequireDefault(_LedgerStore);
	
	var _UserStore = __webpack_require__(974);
	
	var _UserStore2 = _interopRequireDefault(_UserStore);
	
	var _workingIndicator = __webpack_require__(1664);
	
	var _workingIndicator2 = _interopRequireDefault(_workingIndicator);
	
	var _label = __webpack_require__(1682);
	
	var _label2 = _interopRequireDefault(_label);
	
	var _momentTimezone = __webpack_require__(1185);
	
	var _momentTimezone2 = _interopRequireDefault(_momentTimezone);
	
	var _twix = __webpack_require__(2312);
	
	var _twix2 = _interopRequireDefault(_twix);
	
	var _util = __webpack_require__(1183);
	
	var util = _interopRequireWildcard(_util);
	
	var _config = __webpack_require__(1173);
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var VenueReportView = function (_React$Component) {
	  _inherits(VenueReportView, _React$Component);
	
	  function VenueReportView(props) {
	    _classCallCheck(this, VenueReportView);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(VenueReportView).call(this, props));
	
	    _this.downloadCsv = _this.downloadCsv.bind(_this);
	    _this.downloadPdf = _this.downloadPdf.bind(_this);
	    return _this;
	  }
	
	  _createClass(VenueReportView, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.componentWillReceiveProps(this.props, true);
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(newProps) {
	      var force = arguments.length <= 1 || arguments[1] === undefined ? false : arguments[1];
	
	      if (newProps.selectedBucket === null || newProps.selectedVenue === null) {
	        return;
	      }
	
	      if (newProps.selectedBucket !== this.props.selectedBucket || newProps.selectedVenue !== this.props.selectedVenue || force === true) {
	        var conditions = this.buildConditions(newProps);
	        var options = {
	          timePeriod: newProps.grouping
	        };
	
	        _LedgerActions2.default.fetchLedgerVenueReport.defer({
	          conditions: conditions,
	          options: options
	        });
	
	        if (newProps.selectedBucket !== newProps.selectedBucket) {
	          _EventBucketActions2.default.fetchOne.defer(newProps.selectedBucket);
	        }
	      }
	    }
	  }, {
	    key: "buildConditions",
	    value: function buildConditions(newProps) {
	      var timezone = newProps.getEventBucketById(newProps.selectedBucket).timezone;
	
	      var conditions = Object.assign({
	        event_bucket: [newProps.selectedBucket]
	      });
	
	      if (!newProps.allTime) {
	        conditions.date = {
	          $gt: _momentTimezone2.default.tz(newProps.startTime, timezone).startOf("day").utc(),
	          $lte: _momentTimezone2.default.tz(newProps.startTime, timezone).endOf("day").utc()
	        };
	      }
	
	      conditions["type"] = { $in: ["PAYMENT", "REFUND"] };
	      conditions["class"] = { $in: ["TICKET"] };
	      conditions.venue = newProps.selectedVenue;
	
	      return conditions;
	    }
	  }, {
	    key: "downloadCsv",
	    value: function downloadCsv() {
	      var conditions = this.buildConditions(this.props);
	      var options = {
	        timePeriod: this.props.grouping,
	        format: "csv"
	      };
	
	      var form = document.createElement("form");
	      form.method = "post";
	      form.action = _config2.default.endpoint + "analytics/venue_report?" + _UserStore2.default.makeApiKeyQueryString() + "&conditions=" + JSON.stringify(conditions) + "&options=" + JSON.stringify(options);
	      form.target = "generatedCsv";
	
	      document.body.appendChild(form);
	
	      window.open("", "generatedCsv");
	      form.submit();
	    }
	  }, {
	    key: "downloadPdf",
	    value: function downloadPdf() {
	      var conditions = this.buildConditions(this.props);
	      var options = {
	        timePeriod: this.props.grouping,
	        format: "pdf"
	      };
	
	      var form = document.createElement("form");
	      form.method = "post";
	      form.action = _config2.default.endpoint + "analytics/venue_report?" + _UserStore2.default.makeApiKeyQueryString() + "&conditions=" + JSON.stringify(conditions) + "&options=" + JSON.stringify(options);
	      form.target = "generatedPdf";
	
	      document.body.appendChild(form);
	
	      window.open("", "generatedPdf");
	      form.submit();
	    }
	  }, {
	    key: "getStyles",
	    value: function getStyles() {
	      return {
	        overlay: {
	          position: "absolute",
	          right: 0,
	          top: 0,
	          backgroundColor: "#fff",
	          boxShadow: "0 0 5px 2px rgb(0,0,0,0.1)",
	          zIndex: 1
	        },
	        overlaySubmit: {
	          position: "absolute",
	          right: 10,
	          bottom: 10
	        },
	        gridHeaderRow: {
	          color: "#fff",
	          backgroundColor: "#0288d1"
	        },
	        gridHeaderLabel: {
	          textAlign: "right",
	          padding: "4px",
	          width: "100px",
	          borderRight: "1px solid #fff"
	        },
	        gridDayTitle: {
	          fontWeight: "bold",
	          fontSize: "16px",
	          paddingTop: "20px",
	          paddingBottom: "2px",
	          paddingLeft: "2px"
	        },
	        gridTimeTitle: {
	          fontWeight: "bold",
	          fontSize: "13px",
	          paddingTop: "2px",
	          paddingLeft: "2px",
	          paddingBottom: "2px"
	        },
	        gridLabelCell: {
	          textAlign: "left",
	          padding: "2px"
	        },
	        gridDataCell: {
	          textAlign: "right",
	          padding: "2px",
	          width: "100px"
	        },
	        gridButtonRow: {
	          width: "100%",
	          display: "flex",
	          flexDirection: "row",
	          justifyContent: "start"
	        }
	      };
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var styles = this.getStyles();
	
	      var _props = this.props;
	      var selectedBucket = _props.selectedBucket;
	      var selectedVenue = _props.selectedVenue;
	      var allTime = _props.allTime;
	      var startTime = _props.startTime;
	      var endTime = _props.endTime;
	
	
	      var eventBucket = this.props.getEventBucketById(selectedBucket);
	
	      var timePeriod = allTime ? "All time" : (0, _momentTimezone2.default)(startTime).twix(endTime, { allDay: true }).format({ implicitYear: false });
	
	      var displayArray = [];
	
	      if (selectedBucket && selectedVenue) {
	        displayArray = this.props.getLedgerVenueReport();
	      }
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        !this.props.isFetching ? _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement(
	            "div",
	            {
	              style: {
	                width: "100%",
	                display: "flex",
	                flexDirection: "row",
	                justifyContent: "start",
	                paddingTop: "20px"
	              }
	            },
	            _react2.default.createElement(
	              "table",
	              null,
	              _react2.default.createElement(
	                "tbody",
	                null,
	                _react2.default.createElement(
	                  "tr",
	                  { style: styles.gridHeaderRow },
	                  _react2.default.createElement("td", null),
	                  _react2.default.createElement(
	                    "td",
	                    { style: styles.gridHeaderLabel },
	                    "TICKETS"
	                  ),
	                  _react2.default.createElement(
	                    "td",
	                    { style: styles.gridHeaderLabel },
	                    "REVENUE"
	                  )
	                ),
	                displayArray.length > 0 ? displayArray.map(function (row) {
	                  if (row.time === undefined && row.summary === undefined) {
	                    return _react2.default.createElement(
	                      "tr",
	                      null,
	                      _react2.default.createElement(
	                        "td",
	                        { colSpan: "8", style: styles.gridDayTitle },
	                        row.description
	                      )
	                    );
	                  } else if (row.time && row.category === undefined) {
	                    return _react2.default.createElement(
	                      "tr",
	                      null,
	                      _react2.default.createElement(
	                        "td",
	                        { colSpan: "8", style: styles.gridTimeTitle },
	                        row.description
	                      )
	                    );
	                  } else {
	                    return _react2.default.createElement(
	                      "tr",
	                      {
	                        style: row.summary === undefined ? {} : row.overall ? {
	                          fontWeight: "bold",
	                          fontSize: "16px",
	                          borderBottom: "1px solid black"
	                        } : {
	                          fontWeight: "bold",
	                          fontSize: "13px",
	                          borderBottom: "1px solid black"
	                        }
	                      },
	                      _react2.default.createElement(
	                        "td",
	                        {
	                          style: row.overall ? { paddingTop: "20px", paddingLeft: "2px" } : styles.gridLabelCell
	                        },
	                        row.description
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { style: styles.gridDataCell },
	                        row.saleCount
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { style: styles.gridDataCell },
	                        row.grossTotal
	                      )
	                    );
	                  }
	                }) : _react2.default.createElement(
	                  "tr",
	                  null,
	                  _react2.default.createElement(
	                    "td",
	                    { colSpan: "8" },
	                    "No records found."
	                  )
	                )
	              )
	            )
	          ),
	          displayArray.length > 0 ? _react2.default.createElement(
	            "div",
	            { style: styles.gridButtonRow },
	            _react2.default.createElement(
	              "div",
	              { style: styles.rangeContainer },
	              _react2.default.createElement(_materialUi.RaisedButton, {
	                style: { marginTop: "20px", marginRight: "25px" },
	                onClick: this.downloadCsv,
	                label: "DOWNLOAD (.CSV)"
	              })
	            )
	          ) : null
	        ) : _react2.default.createElement(
	          "div",
	          { style: { clear: "both" } },
	          _react2.default.createElement(_workingIndicator2.default, { fullPage: true })
	        )
	      );
	    }
	  }], [{
	    key: "getStores",
	    value: function getStores() {
	      return [_EventBucketStore2.default, _LedgerStore2.default];
	    }
	  }, {
	    key: "getPropsFromStores",
	    value: function getPropsFromStores() {
	      return {
	        getEventBuckets: _EventBucketStore2.default.getEventBuckets,
	        getEventBucketById: _EventBucketStore2.default.getEventBucketById,
	        getLedgerAnalyticsTransactions: _LedgerStore2.default.getLedgerAnalyticsTransactions,
	        getLedgerVenueTransactions: _LedgerStore2.default.getLedgerVenueTransactions,
	        getLedgerVenueReport: _LedgerStore2.default.getLedgerVenueReport,
	        isFetching: _LedgerStore2.default.getState().isFetching
	      };
	    }
	  }]);
	
	  return VenueReportView;
	}(_react2.default.Component);
	
	exports.default = (0, _radium2.default)((0, _connectToStores2.default)(VenueReportView));
	module.exports = exports["default"];

/***/ }),
/* 2321 */
/***/ (function(module, exports, __webpack_require__) {

	// ag-grid-enterprise v21.2.2
	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var ag_grid_community_1 = __webpack_require__(2322);
	var enterpriseMenu_1 = __webpack_require__(2507);
	var rangeController_1 = __webpack_require__(2512);
	var clipboardService_1 = __webpack_require__(2511);
	var groupStage_1 = __webpack_require__(2519);
	var aggregationStage_1 = __webpack_require__(2520);
	var enterpriseBoot_1 = __webpack_require__(2523);
	var contextMenu_1 = __webpack_require__(2549);
	var viewportRowModel_1 = __webpack_require__(2550);
	var sideBarComp_1 = __webpack_require__(2551);
	var licenseManager_1 = __webpack_require__(2530);
	var md5_1 = __webpack_require__(2531);
	var pivotStage_1 = __webpack_require__(2521);
	var pivotColDefService_1 = __webpack_require__(2522);
	var aggFuncService_1 = __webpack_require__(2513);
	var menuItemMapper_1 = __webpack_require__(2510);
	var excelCreator_1 = __webpack_require__(2555);
	var excelXmlFactory_1 = __webpack_require__(2558);
	var excelXlsxFactory_1 = __webpack_require__(2573);
	var serverSideRowModel_1 = __webpack_require__(2609);
	var horizontalResizeComp_1 = __webpack_require__(2554);
	var sideBarButtonsComp_1 = __webpack_require__(2552);
	var statusBarService_1 = __webpack_require__(2612);
	var statusBar_1 = __webpack_require__(2613);
	var nameValueComp_1 = __webpack_require__(2534);
	var primaryColsHeaderPanel_1 = __webpack_require__(2518);
	var primaryColsListPanel_1 = __webpack_require__(2515);
	var gridHeaderDropZones_1 = __webpack_require__(2614);
	var watermark_1 = __webpack_require__(2615);
	var fillHandle_1 = __webpack_require__(2616);
	var rangeHandle_1 = __webpack_require__(2618);
	var aggregationStage_2 = __webpack_require__(2520);
	exports.AggregationStage = aggregationStage_2.AggregationStage;
	var groupStage_2 = __webpack_require__(2519);
	exports.GroupStage = groupStage_2.GroupStage;
	var setFilter_1 = __webpack_require__(2524);
	exports.SetFilter = setFilter_1.SetFilter;
	var setValueModel_1 = __webpack_require__(2525);
	exports.SetValueModel = setValueModel_1.SetValueModel;
	var statusBar_2 = __webpack_require__(2613);
	exports.StatusBar = statusBar_2.StatusBar;
	var statusBarService_2 = __webpack_require__(2612);
	exports.StatusBarService = statusBarService_2.StatusBarService;
	var clipboardService_2 = __webpack_require__(2511);
	exports.ClipboardService = clipboardService_2.ClipboardService;
	var enterpriseBoot_2 = __webpack_require__(2523);
	exports.EnterpriseBoot = enterpriseBoot_2.EnterpriseBoot;
	var enterpriseMenu_2 = __webpack_require__(2507);
	exports.EnterpriseMenu = enterpriseMenu_2.EnterpriseMenu;
	var menuItemComponent_1 = __webpack_require__(2509);
	exports.MenuItemComponent = menuItemComponent_1.MenuItemComponent;
	var menuList_1 = __webpack_require__(2508);
	exports.MenuList = menuList_1.MenuList;
	var rangeController_2 = __webpack_require__(2512);
	exports.RangeController = rangeController_2.RangeController;
	var rowGroupDropZonePanel_1 = __webpack_require__(2538);
	exports.RowGroupDropZonePanel = rowGroupDropZonePanel_1.RowGroupDropZonePanel;
	var contextMenu_2 = __webpack_require__(2549);
	exports.ContextMenuFactory = contextMenu_2.ContextMenuFactory;
	var viewportRowModel_2 = __webpack_require__(2550);
	exports.ViewportRowModel = viewportRowModel_2.ViewportRowModel;
	var richSelectCellEditor_1 = __webpack_require__(2528);
	exports.RichSelectCellEditor = richSelectCellEditor_1.RichSelectCellEditor;
	var richSelectRow_1 = __webpack_require__(2529);
	exports.RichSelectRow = richSelectRow_1.RichSelectRow;
	var virtualList_1 = __webpack_require__(2527);
	exports.VirtualList = virtualList_1.VirtualList;
	var baseDropZonePanel_1 = __webpack_require__(2539);
	exports.BaseDropZonePanel = baseDropZonePanel_1.BaseDropZonePanel;
	var pivotDropZonePanel_1 = __webpack_require__(2542);
	exports.PivotDropZonePanel = pivotDropZonePanel_1.PivotDropZonePanel;
	var sideBarComp_2 = __webpack_require__(2551);
	exports.SideBarComp = sideBarComp_2.SideBarComp;
	var licenseManager_2 = __webpack_require__(2530);
	exports.LicenseManager = licenseManager_2.LicenseManager;
	var pivotStage_2 = __webpack_require__(2521);
	exports.PivotStage = pivotStage_2.PivotStage;
	var pivotColDefService_2 = __webpack_require__(2522);
	exports.PivotColDefService = pivotColDefService_2.PivotColDefService;
	var pivotModePanel_1 = __webpack_require__(2537);
	exports.PivotModePanel = pivotModePanel_1.PivotModePanel;
	var aggFuncService_2 = __webpack_require__(2513);
	exports.AggFuncService = aggFuncService_2.AggFuncService;
	var md5_2 = __webpack_require__(2531);
	exports.MD5 = md5_2.MD5;
	var setFilterListItem_1 = __webpack_require__(2526);
	exports.SetFilterListItem = setFilterListItem_1.SetFilterListItem;
	var dropZoneColumnComp_1 = __webpack_require__(2540);
	exports.DropZoneColumnComp = dropZoneColumnComp_1.DropZoneColumnComp;
	var valueDropZonePanel_1 = __webpack_require__(2541);
	exports.ValuesDropZonePanel = valueDropZonePanel_1.ValuesDropZonePanel;
	var excelCreator_2 = __webpack_require__(2555);
	exports.ExcelCreator = excelCreator_2.ExcelCreator;
	var excelXmlFactory_2 = __webpack_require__(2558);
	exports.ExcelXmlFactory = excelXmlFactory_2.ExcelXmlFactory;
	var excelXlsxFactory_2 = __webpack_require__(2573);
	exports.ExcelXlsxFactory = excelXlsxFactory_2.ExcelXlsxFactory;
	var watermark_2 = __webpack_require__(2615);
	exports.WatermarkComp = watermark_2.WatermarkComp;
	var fillHandle_2 = __webpack_require__(2616);
	exports.FillHandle = fillHandle_2.FillHandle;
	var rangeHandle_2 = __webpack_require__(2618);
	exports.RangeHandle = rangeHandle_2.RangeHandle;
	var rowModelTypes = { viewport: viewportRowModel_1.ViewportRowModel, serverSide: serverSideRowModel_1.ServerSideRowModel };
	ag_grid_community_1.Grid.setEnterpriseBeans([enterpriseMenu_1.EnterpriseMenuFactory, excelCreator_1.ExcelCreator, excelXmlFactory_1.ExcelXmlFactory, excelXlsxFactory_1.ExcelXlsxFactory,
	    rangeController_1.RangeController, clipboardService_1.ClipboardService, pivotStage_1.PivotStage, pivotColDefService_1.PivotColDefService,
	    contextMenu_1.ContextMenuFactory, groupStage_1.GroupStage, aggregationStage_1.AggregationStage, enterpriseBoot_1.EnterpriseBoot, aggFuncService_1.AggFuncService, licenseManager_1.LicenseManager, md5_1.MD5,
	    menuItemMapper_1.MenuItemMapper, statusBarService_1.StatusBarService], rowModelTypes);
	ag_grid_community_1.Grid.setEnterpriseComponents([
	    { componentName: 'AgPrimaryColsHeader', theClass: primaryColsHeaderPanel_1.PrimaryColsHeaderPanel },
	    { componentName: 'AgPrimaryColsList', theClass: primaryColsListPanel_1.PrimaryColsListPanel },
	    { componentName: 'AgHorizontalResize', theClass: horizontalResizeComp_1.HorizontalResizeComp },
	    { componentName: 'AgSideBar', theClass: sideBarComp_1.SideBarComp },
	    { componentName: 'AgStatusBar', theClass: statusBar_1.StatusBar },
	    { componentName: 'AgNameValue', theClass: nameValueComp_1.NameValueComp },
	    { componentName: 'AgGridHeaderDropZones', theClass: gridHeaderDropZones_1.GridHeaderDropZones },
	    { componentName: 'AgSideBarButtons', theClass: sideBarButtonsComp_1.SideBarButtonsComp },
	    { componentName: 'AgWatermark', theClass: watermark_1.WatermarkComp },
	    { componentName: 'AgFillHandle', theClass: fillHandle_1.FillHandle },
	    { componentName: 'AgRangeHandle', theClass: rangeHandle_1.RangeHandle }
	]);


/***/ }),
/* 2322 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var globalObj = typeof global === 'undefined' ? {} : global;
	globalObj.HTMLElement = typeof HTMLElement === 'undefined' ? {} : HTMLElement;
	globalObj.HTMLButtonElement = typeof HTMLButtonElement === 'undefined' ? {} : HTMLButtonElement;
	globalObj.HTMLSelectElement = typeof HTMLSelectElement === 'undefined' ? {} : HTMLSelectElement;
	globalObj.HTMLInputElement = typeof HTMLInputElement === 'undefined' ? {} : HTMLInputElement;
	globalObj.Node = typeof Node === 'undefined' ? {} : Node;
	globalObj.MouseEvent = typeof MouseEvent === 'undefined' ? {} : MouseEvent;
	// columnController
	var columnFactory_1 = __webpack_require__(2323);
	exports.ColumnFactory = columnFactory_1.ColumnFactory;
	var columnController_1 = __webpack_require__(2341);
	exports.ColumnController = columnController_1.ColumnController;
	var columnKeyCreator_1 = __webpack_require__(2442);
	exports.ColumnKeyCreator = columnKeyCreator_1.ColumnKeyCreator;
	var columnUtils_1 = __webpack_require__(2344);
	exports.ColumnUtils = columnUtils_1.ColumnUtils;
	var displayedGroupCreator_1 = __webpack_require__(2348);
	exports.DisplayedGroupCreator = displayedGroupCreator_1.DisplayedGroupCreator;
	var groupInstanceIdCreator_1 = __webpack_require__(2434);
	exports.GroupInstanceIdCreator = groupInstanceIdCreator_1.GroupInstanceIdCreator;
	// components
	var componentUtil_1 = __webpack_require__(2334);
	exports.ComponentUtil = componentUtil_1.ComponentUtil;
	var colDefUtil_1 = __webpack_require__(2439);
	exports.ColDefUtil = colDefUtil_1.ColDefUtil;
	var userComponentRegistry_1 = __webpack_require__(2381);
	exports.UserComponentRegistry = userComponentRegistry_1.UserComponentRegistry;
	var userComponentFactory_1 = __webpack_require__(2380);
	exports.UserComponentFactory = userComponentFactory_1.UserComponentFactory;
	var agGridNg1_1 = __webpack_require__(2444);
	exports.initialiseAgGridWithAngular1 = agGridNg1_1.initialiseAgGridWithAngular1;
	var agGridWebComponent_1 = __webpack_require__(2499);
	exports.initialiseAgGridWithWebComponents = agGridWebComponent_1.initialiseAgGridWithWebComponents;
	// context
	var beanStub_1 = __webpack_require__(2354);
	exports.BeanStub = beanStub_1.BeanStub;
	var context_1 = __webpack_require__(2333);
	exports.Context = context_1.Context;
	exports.Autowired = context_1.Autowired;
	exports.PostConstruct = context_1.PostConstruct;
	exports.PreConstruct = context_1.PreConstruct;
	exports.Optional = context_1.Optional;
	exports.Bean = context_1.Bean;
	exports.Qualifier = context_1.Qualifier;
	exports.PreDestroy = context_1.PreDestroy;
	var componentAnnotations_1 = __webpack_require__(2384);
	exports.QuerySelector = componentAnnotations_1.QuerySelector;
	exports.Listener = componentAnnotations_1.Listener;
	exports.RefSelector = componentAnnotations_1.RefSelector;
	// dragAndDrop
	var dragAndDropService_1 = __webpack_require__(2363);
	exports.DragAndDropService = dragAndDropService_1.DragAndDropService;
	exports.DragSourceType = dragAndDropService_1.DragSourceType;
	exports.HDirection = dragAndDropService_1.HDirection;
	exports.VDirection = dragAndDropService_1.VDirection;
	var dragService_1 = __webpack_require__(2364);
	exports.DragService = dragService_1.DragService;
	// entities
	var column_1 = __webpack_require__(2343);
	exports.Column = column_1.Column;
	var columnGroup_1 = __webpack_require__(2342);
	exports.ColumnGroup = columnGroup_1.ColumnGroup;
	var originalColumnGroup_1 = __webpack_require__(2345);
	exports.OriginalColumnGroup = originalColumnGroup_1.OriginalColumnGroup;
	var rowNode_1 = __webpack_require__(2356);
	exports.RowNode = rowNode_1.RowNode;
	// filter
	var filterManager_1 = __webpack_require__(2378);
	exports.FilterManager = filterManager_1.FilterManager;
	var providedFilter_1 = __webpack_require__(2388);
	exports.ProvidedFilter = providedFilter_1.ProvidedFilter;
	var simpleFilter_1 = __webpack_require__(2386);
	exports.SimpleFilter = simpleFilter_1.SimpleFilter;
	var scalerFilter_1 = __webpack_require__(2389);
	exports.ScalerFilter = scalerFilter_1.ScalerFilter;
	var numberFilter_1 = __webpack_require__(2403);
	exports.NumberFilter = numberFilter_1.NumberFilter;
	var textFilter_1 = __webpack_require__(2410);
	exports.TextFilter = textFilter_1.TextFilter;
	var dateFilter_1 = __webpack_require__(2383);
	exports.DateFilter = dateFilter_1.DateFilter;
	// gridPanel
	var gridPanel_1 = __webpack_require__(2456);
	exports.GridPanel = gridPanel_1.GridPanel;
	var scrollVisibleService_1 = __webpack_require__(2455);
	exports.ScrollVisibleService = scrollVisibleService_1.ScrollVisibleService;
	var mouseEventService_1 = __webpack_require__(2396);
	exports.MouseEventService = mouseEventService_1.MouseEventService;
	// headerRendering
	var bodyDropPivotTarget_1 = __webpack_require__(2454);
	exports.BodyDropPivotTarget = bodyDropPivotTarget_1.BodyDropPivotTarget;
	var bodyDropTarget_1 = __webpack_require__(2452);
	exports.BodyDropTarget = bodyDropTarget_1.BodyDropTarget;
	var cssClassApplier_1 = __webpack_require__(2426);
	exports.CssClassApplier = cssClassApplier_1.CssClassApplier;
	var headerContainer_1 = __webpack_require__(2447);
	exports.HeaderContainer = headerContainer_1.HeaderContainer;
	var headerRootComp_1 = __webpack_require__(2446);
	exports.HeaderRootComp = headerRootComp_1.HeaderRootComp;
	var headerRowComp_1 = __webpack_require__(2448);
	exports.HeaderRowComp = headerRowComp_1.HeaderRowComp;
	var horizontalResizeService_1 = __webpack_require__(2425);
	exports.HorizontalResizeService = horizontalResizeService_1.HorizontalResizeService;
	var moveColumnController_1 = __webpack_require__(2453);
	exports.MoveColumnController = moveColumnController_1.MoveColumnController;
	var standardMenu_1 = __webpack_require__(2464);
	exports.StandardMenuFactory = standardMenu_1.StandardMenuFactory;
	// layout
	var tabbedLayout_1 = __webpack_require__(2500);
	exports.TabbedLayout = tabbedLayout_1.TabbedLayout;
	var verticalStack_1 = __webpack_require__(2501);
	exports.VerticalStack = verticalStack_1.VerticalStack;
	// misc
	var simpleHttpRequest_1 = __webpack_require__(2502);
	exports.simpleHttpRequest = simpleHttpRequest_1.simpleHttpRequest;
	var resizeObserverService_1 = __webpack_require__(2462);
	exports.ResizeObserverService = resizeObserverService_1.ResizeObserverService;
	var largeTextCellEditor_1 = __webpack_require__(2402);
	exports.LargeTextCellEditor = largeTextCellEditor_1.LargeTextCellEditor;
	var popupEditorWrapper_1 = __webpack_require__(2366);
	exports.PopupEditorWrapper = popupEditorWrapper_1.PopupEditorWrapper;
	var popupSelectCellEditor_1 = __webpack_require__(2401);
	exports.PopupSelectCellEditor = popupSelectCellEditor_1.PopupSelectCellEditor;
	var popupTextCellEditor_1 = __webpack_require__(2400);
	exports.PopupTextCellEditor = popupTextCellEditor_1.PopupTextCellEditor;
	var selectCellEditor_1 = __webpack_require__(2399);
	exports.SelectCellEditor = selectCellEditor_1.SelectCellEditor;
	var textCellEditor_1 = __webpack_require__(2382);
	exports.TextCellEditor = textCellEditor_1.TextCellEditor;
	var animateShowChangeCellRenderer_1 = __webpack_require__(2397);
	exports.AnimateShowChangeCellRenderer = animateShowChangeCellRenderer_1.AnimateShowChangeCellRenderer;
	var animateSlideCellRenderer_1 = __webpack_require__(2377);
	exports.AnimateSlideCellRenderer = animateSlideCellRenderer_1.AnimateSlideCellRenderer;
	var groupCellRenderer_1 = __webpack_require__(2394);
	exports.GroupCellRenderer = groupCellRenderer_1.GroupCellRenderer;
	// features
	var setLeftFeature_1 = __webpack_require__(2427);
	exports.SetLeftFeature = setLeftFeature_1.SetLeftFeature;
	// rendering
	var autoWidthCalculator_1 = __webpack_require__(2349);
	exports.AutoWidthCalculator = autoWidthCalculator_1.AutoWidthCalculator;
	var cellRendererFactory_1 = __webpack_require__(2376);
	exports.CellRendererFactory = cellRendererFactory_1.CellRendererFactory;
	var checkboxSelectionComponent_1 = __webpack_require__(2355);
	exports.CheckboxSelectionComponent = checkboxSelectionComponent_1.CheckboxSelectionComponent;
	var cellComp_1 = __webpack_require__(2352);
	exports.CellComp = cellComp_1.CellComp;
	var rowComp_1 = __webpack_require__(2351);
	exports.RowComp = rowComp_1.RowComp;
	var rowRenderer_1 = __webpack_require__(2350);
	exports.RowRenderer = rowRenderer_1.RowRenderer;
	var valueFormatterService_1 = __webpack_require__(2395);
	exports.ValueFormatterService = valueFormatterService_1.ValueFormatterService;
	// rowControllers/inMemory
	var filterStage_1 = __webpack_require__(2465);
	exports.FilterStage = filterStage_1.FilterStage;
	var flattenStage_1 = __webpack_require__(2470);
	exports.FlattenStage = flattenStage_1.FlattenStage;
	var sortStage_1 = __webpack_require__(2468);
	exports.SortStage = sortStage_1.SortStage;
	// row models
	var pinnedRowModel_1 = __webpack_require__(2371);
	exports.PinnedRowModel = pinnedRowModel_1.PinnedRowModel;
	var clientSideRowModel_1 = __webpack_require__(2477);
	exports.ClientSideRowModel = clientSideRowModel_1.ClientSideRowModel;
	var changedPath_1 = __webpack_require__(2358);
	exports.ChangedPath = changedPath_1.ChangedPath;
	var clientSideNodeManager_1 = __webpack_require__(2478);
	exports.ClientSideNodeManager = clientSideNodeManager_1.ClientSideNodeManager;
	var infiniteRowModel_1 = __webpack_require__(2471);
	exports.InfiniteRowModel = infiniteRowModel_1.InfiniteRowModel;
	var rowNodeBlock_1 = __webpack_require__(2474);
	exports.RowNodeBlock = rowNodeBlock_1.RowNodeBlock;
	var rowNodeBlockLoader_1 = __webpack_require__(2476);
	exports.RowNodeBlockLoader = rowNodeBlockLoader_1.RowNodeBlockLoader;
	var paginationProxy_1 = __webpack_require__(2372);
	exports.PaginationProxy = paginationProxy_1.PaginationProxy;
	var rowNodeCache_1 = __webpack_require__(2475);
	exports.RowNodeCache = rowNodeCache_1.RowNodeCache;
	//styling
	var stylingService_1 = __webpack_require__(2416);
	exports.StylingService = stylingService_1.StylingService;
	// widgets
	var agAbstractField_1 = __webpack_require__(2430);
	exports.AgAbstractField = agAbstractField_1.AgAbstractField;
	var agCheckbox_1 = __webpack_require__(2428);
	exports.AgCheckbox = agCheckbox_1.AgCheckbox;
	var agRadioButton_1 = __webpack_require__(2479);
	exports.AgRadioButton = agRadioButton_1.AgRadioButton;
	var agToggleButton_1 = __webpack_require__(2498);
	exports.AgToggleButton = agToggleButton_1.AgToggleButton;
	var agInputTextField_1 = __webpack_require__(2488);
	exports.AgInputTextField = agInputTextField_1.AgInputTextField;
	var agInputTextArea_1 = __webpack_require__(2489);
	exports.AgInputTextArea = agInputTextArea_1.AgInputTextArea;
	var agInputNumberField_1 = __webpack_require__(2492);
	exports.AgInputNumberField = agInputNumberField_1.AgInputNumberField;
	var agInputRange_1 = __webpack_require__(2491);
	exports.AgInputRange = agInputRange_1.AgInputRange;
	var agSelect_1 = __webpack_require__(2496);
	exports.AgSelect = agSelect_1.AgSelect;
	var agSlider_1 = __webpack_require__(2490);
	exports.AgSlider = agSlider_1.AgSlider;
	var agAngleSelect_1 = __webpack_require__(2497);
	exports.AgAngleSelect = agAngleSelect_1.AgAngleSelect;
	var agColorPicker_1 = __webpack_require__(2493);
	exports.AgColorPicker = agColorPicker_1.AgColorPicker;
	var agGroupComponent_1 = __webpack_require__(2485);
	exports.AgGroupComponent = agGroupComponent_1.AgGroupComponent;
	var agDialog_1 = __webpack_require__(2486);
	exports.AgDialog = agDialog_1.AgDialog;
	var agPanel_1 = __webpack_require__(2487);
	exports.AgPanel = agPanel_1.AgPanel;
	var messageBox_1 = __webpack_require__(2503);
	exports.MessageBox = messageBox_1.MessageBox;
	var component_1 = __webpack_require__(2353);
	exports.Component = component_1.Component;
	var popupComponent_1 = __webpack_require__(2367);
	exports.PopupComponent = popupComponent_1.PopupComponent;
	var popupService_1 = __webpack_require__(2379);
	exports.PopupService = popupService_1.PopupService;
	var touchListener_1 = __webpack_require__(2392);
	exports.TouchListener = touchListener_1.TouchListener;
	// range
	var iRangeController_1 = __webpack_require__(2361);
	exports.CellRangeType = iRangeController_1.CellRangeType;
	// exporter
	var csvCreator_1 = __webpack_require__(2339);
	exports.CsvCreator = csvCreator_1.CsvCreator;
	exports.BaseCreator = csvCreator_1.BaseCreator;
	var downloader_1 = __webpack_require__(2436);
	exports.Downloader = downloader_1.Downloader;
	var xmlFactory_1 = __webpack_require__(2481);
	exports.XmlFactory = xmlFactory_1.XmlFactory;
	var gridSerializer_1 = __webpack_require__(2340);
	exports.BaseGridSerializingSession = gridSerializer_1.BaseGridSerializingSession;
	exports.GridSerializer = gridSerializer_1.GridSerializer;
	var gridSerializer_2 = __webpack_require__(2340);
	exports.RowType = gridSerializer_2.RowType;
	var zipContainer_1 = __webpack_require__(2484);
	exports.ZipContainer = zipContainer_1.ZipContainer;
	// root
	var vanillaFrameworkOverrides_1 = __webpack_require__(2480);
	exports.VanillaFrameworkOverrides = vanillaFrameworkOverrides_1.VanillaFrameworkOverrides;
	var cellNavigationService_1 = __webpack_require__(2370);
	exports.CellNavigationService = cellNavigationService_1.CellNavigationService;
	var alignedGridsService_1 = __webpack_require__(2438);
	exports.AlignedGridsService = alignedGridsService_1.AlignedGridsService;
	var constants_1 = __webpack_require__(2328);
	exports.Constants = constants_1.Constants;
	var grid_1 = __webpack_require__(2445);
	exports.Grid = grid_1.Grid;
	var gridApi_1 = __webpack_require__(2338);
	exports.GridApi = gridApi_1.GridApi;
	var eventKeys_1 = __webpack_require__(2336);
	exports.Events = eventKeys_1.Events;
	var focusedCellController_1 = __webpack_require__(2369);
	exports.FocusedCellController = focusedCellController_1.FocusedCellController;
	var functions_1 = __webpack_require__(2504);
	exports.defaultGroupComparator = functions_1.defaultGroupComparator;
	var gridOptionsWrapper_1 = __webpack_require__(2324);
	exports.GridOptionsWrapper = gridOptionsWrapper_1.GridOptionsWrapper;
	var eventService_1 = __webpack_require__(2331);
	exports.EventService = eventService_1.EventService;
	var selectableService_1 = __webpack_require__(2467);
	exports.SelectableService = selectableService_1.SelectableService;
	var gridCore_1 = __webpack_require__(2463);
	exports.GridCore = gridCore_1.GridCore;
	var logger_1 = __webpack_require__(2332);
	exports.Logger = logger_1.Logger;
	var selectionController_1 = __webpack_require__(2357);
	exports.SelectionController = selectionController_1.SelectionController;
	var sortController_1 = __webpack_require__(2391);
	exports.SortController = sortController_1.SortController;
	var templateService_1 = __webpack_require__(2374);
	exports.TemplateService = templateService_1.TemplateService;
	var utils_1 = __webpack_require__(2325);
	exports.Color = utils_1.Color;
	exports.Utils = utils_1.Utils;
	exports.NumberSequence = utils_1.NumberSequence;
	exports._ = utils_1._;
	exports.Promise = utils_1.Promise;
	var valueService_1 = __webpack_require__(2359);
	exports.ValueService = valueService_1.ValueService;
	var expressionService_1 = __webpack_require__(2347);
	exports.ExpressionService = expressionService_1.ExpressionService;
	var logger_2 = __webpack_require__(2332);
	exports.LoggerFactory = logger_2.LoggerFactory;
	var cellPosition_1 = __webpack_require__(2422);
	exports.CellPositionUtils = cellPosition_1.CellPositionUtils;
	var rowPosition_1 = __webpack_require__(2423);
	exports.RowPositionUtils = rowPosition_1.RowPositionUtils;
	var columnApi_1 = __webpack_require__(2346);
	exports.ColumnApi = columnApi_1.ColumnApi;
	var frameworkComponentWrapper_1 = __webpack_require__(2505);
	exports.BaseComponentWrapper = frameworkComponentWrapper_1.BaseComponentWrapper;
	var environment_1 = __webpack_require__(2365);
	exports.Environment = environment_1.Environment;
	var tooltipManager_1 = __webpack_require__(2420);
	exports.TooltipManager = tooltipManager_1.TooltipManager;
	// charts
	var iChartOptions_1 = __webpack_require__(2506);
	exports.ChartType = iChartOptions_1.ChartType;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 2323 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var __param = (this && this.__param) || function (paramIndex, decorator) {
	    return function (target, key) { decorator(target, key, paramIndex); }
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var gridOptionsWrapper_1 = __webpack_require__(2324);
	var logger_1 = __webpack_require__(2332);
	var columnUtils_1 = __webpack_require__(2344);
	var columnKeyCreator_1 = __webpack_require__(2442);
	var originalColumnGroup_1 = __webpack_require__(2345);
	var column_1 = __webpack_require__(2343);
	var context_1 = __webpack_require__(2333);
	var defaultColumnTypes_1 = __webpack_require__(2443);
	var utils_1 = __webpack_require__(2325);
	// takes ColDefs and ColGroupDefs and turns them into Columns and OriginalGroups
	var ColumnFactory = /** @class */ (function () {
	    function ColumnFactory() {
	    }
	    ColumnFactory.prototype.setBeans = function (loggerFactory) {
	        this.logger = loggerFactory.create('ColumnFactory');
	    };
	    ColumnFactory.prototype.createColumnTree = function (defs, primaryColumns, existingColumns) {
	        // column key creator dishes out unique column id's in a deterministic way,
	        // so if we have two grids (that could be master/slave) with same column definitions,
	        // then this ensures the two grids use identical id's.
	        var columnKeyCreator = new columnKeyCreator_1.ColumnKeyCreator();
	        if (existingColumns) {
	            var existingKeys = existingColumns.map(function (col) { return col.getId(); });
	            columnKeyCreator.addExistingKeys(existingKeys);
	        }
	        // we take a copy of the columns as we are going to be removing from them
	        var existingColsCopy = existingColumns ? existingColumns.slice() : null;
	        // create am unbalanced tree that maps the provided definitions
	        var unbalancedTree = this.recursivelyCreateColumns(defs, 0, primaryColumns, existingColsCopy, columnKeyCreator, null);
	        var treeDept = this.findMaxDept(unbalancedTree, 0);
	        this.logger.log('Number of levels for grouped columns is ' + treeDept);
	        var res = this.balanceColumnTree(unbalancedTree, 0, treeDept, columnKeyCreator);
	        var deptFirstCallback = function (child, parent) {
	            if (child instanceof originalColumnGroup_1.OriginalColumnGroup) {
	                child.setupExpandable();
	            }
	            // we set the original parents at the end, rather than when we go along, as balancing the tree
	            // adds extra levels into the tree. so we can only set parents when balancing is done.
	            child.setOriginalParent(parent);
	        };
	        this.columnUtils.depthFirstOriginalTreeSearch(null, res, deptFirstCallback);
	        return {
	            columnTree: res,
	            treeDept: treeDept
	        };
	    };
	    ColumnFactory.prototype.createForAutoGroups = function (autoGroupCols, gridBalancedTree) {
	        var _this = this;
	        var autoColBalancedTree = [];
	        autoGroupCols.forEach(function (col) {
	            var fakeTreeItem = _this.createAutoGroupTreeItem(gridBalancedTree, col);
	            autoColBalancedTree.push(fakeTreeItem);
	        });
	        return autoColBalancedTree;
	    };
	    ColumnFactory.prototype.createAutoGroupTreeItem = function (balancedColumnTree, column) {
	        var dept = this.findDepth(balancedColumnTree);
	        // at the end, this will be the top of the tree item.
	        var nextChild = column;
	        for (var i = dept - 1; i >= 0; i--) {
	            var autoGroup = new originalColumnGroup_1.OriginalColumnGroup(null, "FAKE_PATH_" + column.getId() + "}_" + i, true, i);
	            this.context.wireBean(autoGroup);
	            autoGroup.setChildren([nextChild]);
	            nextChild.setOriginalParent(autoGroup);
	            nextChild = autoGroup;
	        }
	        // at this point, the nextChild is the top most item in the tree
	        return nextChild;
	    };
	    ColumnFactory.prototype.findDepth = function (balancedColumnTree) {
	        var dept = 0;
	        var pointer = balancedColumnTree;
	        while (pointer && pointer[0] && pointer[0] instanceof originalColumnGroup_1.OriginalColumnGroup) {
	            dept++;
	            pointer = pointer[0].getChildren();
	        }
	        return dept;
	    };
	    ColumnFactory.prototype.balanceColumnTree = function (unbalancedTree, currentDept, columnDept, columnKeyCreator) {
	        var result = [];
	        // go through each child, for groups, recurse a level deeper,
	        // for columns we need to pad
	        for (var i = 0; i < unbalancedTree.length; i++) {
	            var child = unbalancedTree[i];
	            if (child instanceof originalColumnGroup_1.OriginalColumnGroup) {
	                // child is a group, all we do is go to the next level of recursion
	                var originalGroup = child;
	                var newChildren = this.balanceColumnTree(originalGroup.getChildren(), currentDept + 1, columnDept, columnKeyCreator);
	                originalGroup.setChildren(newChildren);
	                result.push(originalGroup);
	            }
	            else {
	                // child is a column - so here we add in the padded column groups if needed
	                var firstPaddedGroup = void 0;
	                var currentPaddedGroup = void 0;
	                // this for loop will NOT run any loops if no padded column groups are needed
	                for (var j = columnDept - 1; j >= currentDept; j--) {
	                    var newColId = columnKeyCreator.getUniqueKey(null, null);
	                    var colGroupDefMerged = this.createMergedColGroupDef(null);
	                    var paddedGroup = new originalColumnGroup_1.OriginalColumnGroup(colGroupDefMerged, newColId, true, currentDept);
	                    this.context.wireBean(paddedGroup);
	                    if (currentPaddedGroup) {
	                        currentPaddedGroup.setChildren([paddedGroup]);
	                    }
	                    currentPaddedGroup = paddedGroup;
	                    if (!firstPaddedGroup) {
	                        firstPaddedGroup = currentPaddedGroup;
	                    }
	                }
	                // likewise this if statement will not run if no padded groups
	                if (firstPaddedGroup) {
	                    result.push(firstPaddedGroup);
	                    var hasGroups = unbalancedTree.some(function (child) { return child instanceof originalColumnGroup_1.OriginalColumnGroup; });
	                    if (hasGroups) {
	                        currentPaddedGroup.setChildren([child]);
	                        continue;
	                    }
	                    else {
	                        currentPaddedGroup.setChildren(unbalancedTree);
	                        break;
	                    }
	                }
	                result.push(child);
	            }
	        }
	        return result;
	    };
	    ColumnFactory.prototype.findMaxDept = function (treeChildren, dept) {
	        var maxDeptThisLevel = dept;
	        for (var i = 0; i < treeChildren.length; i++) {
	            var abstractColumn = treeChildren[i];
	            if (abstractColumn instanceof originalColumnGroup_1.OriginalColumnGroup) {
	                var originalGroup = abstractColumn;
	                var newDept = this.findMaxDept(originalGroup.getChildren(), dept + 1);
	                if (maxDeptThisLevel < newDept) {
	                    maxDeptThisLevel = newDept;
	                }
	            }
	        }
	        return maxDeptThisLevel;
	    };
	    ColumnFactory.prototype.recursivelyCreateColumns = function (defs, level, primaryColumns, existingColsCopy, columnKeyCreator, parent) {
	        var _this = this;
	        var result = [];
	        if (!defs) {
	            return result;
	        }
	        defs.forEach(function (def) {
	            var newGroupOrColumn;
	            if (_this.isColumnGroup(def)) {
	                newGroupOrColumn = _this.createColumnGroup(primaryColumns, def, level, existingColsCopy, columnKeyCreator, parent);
	            }
	            else {
	                newGroupOrColumn = _this.createColumn(primaryColumns, def, existingColsCopy, columnKeyCreator, parent);
	            }
	            result.push(newGroupOrColumn);
	        });
	        return result;
	    };
	    ColumnFactory.prototype.createColumnGroup = function (primaryColumns, colGroupDef, level, existingColumns, columnKeyCreator, parent) {
	        var colGroupDefMerged = this.createMergedColGroupDef(colGroupDef);
	        var groupId = columnKeyCreator.getUniqueKey(colGroupDefMerged.groupId, null);
	        var originalGroup = new originalColumnGroup_1.OriginalColumnGroup(colGroupDefMerged, groupId, false, level);
	        this.context.wireBean(originalGroup);
	        var children = this.recursivelyCreateColumns(colGroupDefMerged.children, level + 1, primaryColumns, existingColumns, columnKeyCreator, originalGroup);
	        originalGroup.setChildren(children);
	        return originalGroup;
	    };
	    ColumnFactory.prototype.createMergedColGroupDef = function (colGroupDef) {
	        var colGroupDefMerged = {};
	        utils_1._.assign(colGroupDefMerged, this.gridOptionsWrapper.getDefaultColGroupDef());
	        utils_1._.assign(colGroupDefMerged, colGroupDef);
	        this.checkForDeprecatedItems(colGroupDefMerged);
	        return colGroupDefMerged;
	    };
	    ColumnFactory.prototype.createColumn = function (primaryColumns, colDef, existingColsCopy, columnKeyCreator, parent) {
	        var colDefMerged = this.mergeColDefs(colDef);
	        this.checkForDeprecatedItems(colDefMerged);
	        // see if column already exists
	        var column = this.findExistingColumn(colDef, existingColsCopy);
	        if (!column) {
	            // no existing column, need to create one
	            var colId = columnKeyCreator.getUniqueKey(colDefMerged.colId, colDefMerged.field);
	            column = new column_1.Column(colDefMerged, colDef, colId, primaryColumns);
	            this.context.wireBean(column);
	        }
	        else {
	            column.setColDef(colDefMerged, colDef);
	        }
	        return column;
	    };
	    ColumnFactory.prototype.findExistingColumn = function (colDef, existingColsCopy) {
	        var res = utils_1._.find(existingColsCopy, function (col) {
	            var oldColDef = col.getUserProvidedColDef();
	            if (!oldColDef) {
	                return false;
	            }
	            // first check object references
	            if (oldColDef === colDef) {
	                return true;
	            }
	            // second check id's
	            var oldColHadId = oldColDef.colId !== null && oldColDef.colId !== undefined;
	            if (oldColHadId) {
	                return oldColDef.colId === colDef.colId;
	            }
	            else {
	                return false;
	            }
	        });
	        // make sure we remove, so if user provided duplicate id, then we don't have more than
	        // one column instance for colDef with common id
	        if (res) {
	            utils_1._.removeFromArray(existingColsCopy, res);
	        }
	        return res;
	    };
	    ColumnFactory.prototype.mergeColDefs = function (colDef) {
	        // start with empty merged definition
	        var colDefMerged = {};
	        // merge properties from default column definitions
	        utils_1._.assign(colDefMerged, this.gridOptionsWrapper.getDefaultColDef());
	        // merge properties from column type properties
	        if (colDef.type) {
	            this.assignColumnTypes(colDef, colDefMerged);
	        }
	        // merge properties from column definitions
	        utils_1._.assign(colDefMerged, colDef);
	        return colDefMerged;
	    };
	    ColumnFactory.prototype.assignColumnTypes = function (colDef, colDefMerged) {
	        var typeKeys;
	        if (colDef.type instanceof Array) {
	            var invalidArray = colDef.type.some(function (a) { return typeof a !== 'string'; });
	            if (invalidArray) {
	                console.warn("ag-grid: if colDef.type is supplied an array it should be of type 'string[]'");
	            }
	            else {
	                typeKeys = colDef.type;
	            }
	        }
	        else if (typeof colDef.type === 'string') {
	            typeKeys = colDef.type.split(',');
	        }
	        else {
	            console.warn("ag-grid: colDef.type should be of type 'string' | 'string[]'");
	            return;
	        }
	        // merge user defined with default column types
	        var allColumnTypes = utils_1._.assign({}, this.gridOptionsWrapper.getColumnTypes(), defaultColumnTypes_1.DefaultColumnTypes);
	        typeKeys.forEach(function (t) {
	            var typeColDef = allColumnTypes[t.trim()];
	            if (typeColDef) {
	                utils_1._.assign(colDefMerged, typeColDef);
	            }
	            else {
	                console.warn("ag-grid: colDef.type '" + t + "' does not correspond to defined gridOptions.columnTypes");
	            }
	        });
	    };
	    ColumnFactory.prototype.checkForDeprecatedItems = function (colDef) {
	        if (colDef) {
	            var colDefNoType = colDef; // take out the type, so we can access attributes not defined in the type
	            if (colDefNoType.group !== undefined) {
	                console.warn('ag-grid: colDef.group is invalid, please check documentation on how to do grouping as it changed in version 3');
	            }
	            if (colDefNoType.headerGroup !== undefined) {
	                console.warn('ag-grid: colDef.headerGroup is invalid, please check documentation on how to do grouping as it changed in version 3');
	            }
	            if (colDefNoType.headerGroupShow !== undefined) {
	                console.warn('ag-grid: colDef.headerGroupShow is invalid, should be columnGroupShow, please check documentation on how to do grouping as it changed in version 3');
	            }
	            if (colDefNoType.suppressRowGroup !== undefined) {
	                console.warn('ag-grid: colDef.suppressRowGroup is deprecated, please use colDef.type instead');
	            }
	            if (colDefNoType.suppressAggregation !== undefined) {
	                console.warn('ag-grid: colDef.suppressAggregation is deprecated, please use colDef.type instead');
	            }
	            if (colDefNoType.suppressRowGroup || colDefNoType.suppressAggregation) {
	                console.warn('ag-grid: colDef.suppressAggregation and colDef.suppressRowGroup are deprecated, use allowRowGroup, allowPivot and allowValue instead');
	            }
	            if (colDefNoType.displayName) {
	                console.warn("ag-grid: Found displayName " + colDefNoType.displayName + ", please use headerName instead, displayName is deprecated.");
	                colDefNoType.headerName = colDefNoType.displayName;
	            }
	        }
	    };
	    // if object has children, we assume it's a group
	    ColumnFactory.prototype.isColumnGroup = function (abstractColDef) {
	        return abstractColDef.children !== undefined;
	    };
	    __decorate([
	        context_1.Autowired('gridOptionsWrapper'),
	        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
	    ], ColumnFactory.prototype, "gridOptionsWrapper", void 0);
	    __decorate([
	        context_1.Autowired('columnUtils'),
	        __metadata("design:type", columnUtils_1.ColumnUtils)
	    ], ColumnFactory.prototype, "columnUtils", void 0);
	    __decorate([
	        context_1.Autowired('context'),
	        __metadata("design:type", context_1.Context)
	    ], ColumnFactory.prototype, "context", void 0);
	    __decorate([
	        __param(0, context_1.Qualifier('loggerFactory')),
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", [logger_1.LoggerFactory]),
	        __metadata("design:returntype", void 0)
	    ], ColumnFactory.prototype, "setBeans", null);
	    ColumnFactory = __decorate([
	        context_1.Bean('columnFactory')
	    ], ColumnFactory);
	    return ColumnFactory;
	}());
	exports.ColumnFactory = ColumnFactory;


/***/ }),
/* 2324 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var __param = (this && this.__param) || function (paramIndex, decorator) {
	    return function (target, key) { decorator(target, key, paramIndex); }
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var utils_1 = __webpack_require__(2325);
	var eventService_1 = __webpack_require__(2331);
	var constants_1 = __webpack_require__(2328);
	var componentUtil_1 = __webpack_require__(2334);
	var gridApi_1 = __webpack_require__(2338);
	var context_1 = __webpack_require__(2333);
	var columnApi_1 = __webpack_require__(2346);
	var columnController_1 = __webpack_require__(2341);
	var environment_1 = __webpack_require__(2365);
	var propertyKeys_1 = __webpack_require__(2337);
	var colDefUtil_1 = __webpack_require__(2439);
	var eventKeys_1 = __webpack_require__(2336);
	var autoHeightCalculator_1 = __webpack_require__(2440);
	var sideBar_1 = __webpack_require__(2441);
	var DEFAULT_ROW_HEIGHT = 25;
	var DEFAULT_DETAIL_ROW_HEIGHT = 300;
	var DEFAULT_VIEWPORT_ROW_MODEL_PAGE_SIZE = 5;
	var DEFAULT_VIEWPORT_ROW_MODEL_BUFFER_SIZE = 5;
	var DEFAULT_KEEP_DETAIL_ROW_COUNT = 10;
	function isTrue(value) {
	    return value === true || value === 'true';
	}
	function zeroOrGreater(value, defaultValue) {
	    if (value >= 0) {
	        return value;
	    }
	    // zero gets returned if number is missing or the wrong type
	    return defaultValue;
	}
	function oneOrGreater(value, defaultValue) {
	    if (value > 0) {
	        return value;
	    }
	    // zero gets returned if number is missing or the wrong type
	    return defaultValue;
	}
	var GridOptionsWrapper = /** @class */ (function () {
	    function GridOptionsWrapper() {
	        this.propertyEventService = new eventService_1.EventService();
	        this.domDataKey = '__AG_' + Math.random().toString();
	        this.layoutElements = [];
	    }
	    GridOptionsWrapper_1 = GridOptionsWrapper;
	    GridOptionsWrapper.prototype.agWire = function (gridApi, columnApi) {
	        this.gridOptions.api = gridApi;
	        this.gridOptions.columnApi = columnApi;
	        this.checkForDeprecated();
	        this.checkForViolations();
	    };
	    GridOptionsWrapper.prototype.destroy = function () {
	        // need to remove these, as we don't own the lifecycle of the gridOptions, we need to
	        // remove the references in case the user keeps the grid options, we want the rest
	        // of the grid to be picked up by the garbage collector
	        this.gridOptions.api = null;
	        this.gridOptions.columnApi = null;
	    };
	    GridOptionsWrapper.prototype.init = function () {
	        if (!(this.gridOptions.suppressPropertyNamesCheck === true)) {
	            this.checkGridOptionsProperties();
	            this.checkColumnDefProperties();
	        }
	        var async = this.useAsyncEvents();
	        this.eventService.addGlobalListener(this.globalEventHandler.bind(this), async);
	        if (this.isGroupSelectsChildren() && this.isSuppressParentsInRowNodes()) {
	            console.warn('ag-Grid: groupSelectsChildren does not work wth suppressParentsInRowNodes, this selection method needs the part in rowNode to work');
	        }
	        if (this.isGroupSelectsChildren()) {
	            if (!this.isRowSelectionMulti()) {
	                console.warn("ag-Grid: rowSelection must be 'multiple' for groupSelectsChildren to make sense");
	            }
	            if (this.isRowModelServerSide()) {
	                console.warn('ag-Grid: group selects children is NOT support for Server Side Row Model. ' +
	                    'This is because the rows are lazy loaded, so selecting a group is not possible as' +
	                    'the grid has no way of knowing what the children are.');
	            }
	        }
	        if (this.isGroupRemoveSingleChildren() && this.isGroupHideOpenParents()) {
	            console.warn('ag-Grid: groupRemoveSingleChildren and groupHideOpenParents do not work with each other, you need to pick one. And don\'t ask us how to us these together on our support forum either you will get the same answer!');
	        }
	        this.addEventListener(GridOptionsWrapper_1.PROP_DOM_LAYOUT, this.updateLayoutClasses.bind(this));
	    };
	    GridOptionsWrapper.prototype.checkColumnDefProperties = function () {
	        var _this = this;
	        if (this.gridOptions.columnDefs == null) {
	            return;
	        }
	        this.gridOptions.columnDefs.forEach(function (colDef) {
	            var userProperties = Object.getOwnPropertyNames(colDef);
	            var validProperties = colDefUtil_1.ColDefUtil.ALL_PROPERTIES.concat(colDefUtil_1.ColDefUtil.FRAMEWORK_PROPERTIES);
	            _this.checkProperties(userProperties, validProperties, validProperties, 'colDef', 'https://www.ag-grid.com/javascript-grid-column-properties/');
	        });
	    };
	    GridOptionsWrapper.prototype.checkGridOptionsProperties = function () {
	        var userProperties = Object.getOwnPropertyNames(this.gridOptions);
	        var validProperties = propertyKeys_1.PropertyKeys.ALL_PROPERTIES.concat(propertyKeys_1.PropertyKeys.FRAMEWORK_PROPERTIES);
	        Object.keys(eventKeys_1.Events).forEach(function (it) { return validProperties.push(componentUtil_1.ComponentUtil.getCallbackForEvent(eventKeys_1.Events[it])); });
	        var validPropertiesAndExceptions = validProperties.concat('api', 'columnApi');
	        this.checkProperties(userProperties, validPropertiesAndExceptions, validProperties, 'gridOptions', 'https://www.ag-grid.com/javascript-grid-properties/');
	    };
	    GridOptionsWrapper.prototype.checkProperties = function (userProperties, validPropertiesAndExceptions, validProperties, containerName, docsUrl) {
	        var invalidProperties = utils_1._.fuzzyCheckStrings(userProperties, validPropertiesAndExceptions, validProperties);
	        var invalidPropertyKeys = Object.keys(invalidProperties);
	        invalidPropertyKeys.forEach(function (invalidPropertyKey) {
	            var fuzzySuggestions = invalidProperties[invalidPropertyKey];
	            console.warn("ag-grid: invalid " + containerName + " property '" + invalidPropertyKey + "' did you mean any of these: " + fuzzySuggestions.slice(0, 8).join(","));
	        });
	        if (invalidPropertyKeys.length > 0) {
	            console.warn("ag-grid: to see all the valid " + containerName + " properties please check: " + docsUrl);
	        }
	    };
	    // returns the dom data, or undefined if not found
	    GridOptionsWrapper.prototype.getDomData = function (element, key) {
	        var domData = element[this.domDataKey];
	        if (domData) {
	            return domData[key];
	        }
	        return;
	    };
	    GridOptionsWrapper.prototype.setDomData = function (element, key, value) {
	        var domData = element[this.domDataKey];
	        if (utils_1._.missing(domData)) {
	            domData = {};
	            element[this.domDataKey] = domData;
	        }
	        domData[key] = value;
	    };
	    GridOptionsWrapper.prototype.isEnterprise = function () {
	        return this.enterprise;
	    };
	    GridOptionsWrapper.prototype.isRowSelection = function () {
	        return this.gridOptions.rowSelection === "single" || this.gridOptions.rowSelection === "multiple";
	    };
	    GridOptionsWrapper.prototype.isRowDeselection = function () {
	        return isTrue(this.gridOptions.rowDeselection);
	    };
	    GridOptionsWrapper.prototype.isRowSelectionMulti = function () {
	        return this.gridOptions.rowSelection === 'multiple';
	    };
	    GridOptionsWrapper.prototype.isRowMultiSelectWithClick = function () {
	        return isTrue(this.gridOptions.rowMultiSelectWithClick);
	    };
	    GridOptionsWrapper.prototype.getContext = function () {
	        return this.gridOptions.context;
	    };
	    GridOptionsWrapper.prototype.isPivotMode = function () {
	        return isTrue(this.gridOptions.pivotMode);
	    };
	    GridOptionsWrapper.prototype.isPivotTotals = function () {
	        return isTrue(this.gridOptions.pivotTotals);
	    };
	    GridOptionsWrapper.prototype.getPivotColumnGroupTotals = function () {
	        return this.gridOptions.pivotColumnGroupTotals;
	    };
	    GridOptionsWrapper.prototype.getPivotRowTotals = function () {
	        return this.gridOptions.pivotRowTotals;
	    };
	    GridOptionsWrapper.prototype.isRowModelInfinite = function () {
	        return this.gridOptions.rowModelType === constants_1.Constants.ROW_MODEL_TYPE_INFINITE;
	    };
	    GridOptionsWrapper.prototype.isRowModelViewport = function () {
	        return this.gridOptions.rowModelType === constants_1.Constants.ROW_MODEL_TYPE_VIEWPORT;
	    };
	    GridOptionsWrapper.prototype.isRowModelServerSide = function () {
	        return this.gridOptions.rowModelType === constants_1.Constants.ROW_MODEL_TYPE_SERVER_SIDE;
	    };
	    GridOptionsWrapper.prototype.isRowModelDefault = function () {
	        return utils_1._.missing(this.gridOptions.rowModelType) ||
	            this.gridOptions.rowModelType === constants_1.Constants.ROW_MODEL_TYPE_CLIENT_SIDE ||
	            this.gridOptions.rowModelType === constants_1.Constants.DEPRECATED_ROW_MODEL_TYPE_NORMAL;
	    };
	    GridOptionsWrapper.prototype.isFullRowEdit = function () {
	        return this.gridOptions.editType === 'fullRow';
	    };
	    GridOptionsWrapper.prototype.isSuppressFocusAfterRefresh = function () {
	        return isTrue(this.gridOptions.suppressFocusAfterRefresh);
	    };
	    GridOptionsWrapper.prototype.isSuppressBrowserResizeObserver = function () {
	        return isTrue(this.gridOptions.suppressBrowserResizeObserver);
	    };
	    GridOptionsWrapper.prototype.isSuppressMaintainUnsortedOrder = function () {
	        return isTrue(this.gridOptions.suppressMaintainUnsortedOrder);
	    };
	    GridOptionsWrapper.prototype.isShowToolPanel = function () {
	        return isTrue(this.gridOptions.sideBar && Array.isArray(this.getSideBar().toolPanels));
	    };
	    GridOptionsWrapper.prototype.getSideBar = function () {
	        return this.gridOptions.sideBar;
	    };
	    GridOptionsWrapper.prototype.isSuppressTouch = function () {
	        return isTrue(this.gridOptions.suppressTouch);
	    };
	    GridOptionsWrapper.prototype.isSuppressRowTransform = function () {
	        return isTrue(this.gridOptions.suppressRowTransform);
	    };
	    GridOptionsWrapper.prototype.isSuppressSetColumnStateEvents = function () {
	        return isTrue(this.gridOptions.suppressSetColumnStateEvents);
	    };
	    GridOptionsWrapper.prototype.useAsyncEvents = function () {
	        return !isTrue(this.gridOptions.suppressAsyncEvents);
	    };
	    GridOptionsWrapper.prototype.isEnableCellChangeFlash = function () {
	        return isTrue(this.gridOptions.enableCellChangeFlash);
	    };
	    GridOptionsWrapper.prototype.isGroupSelectsChildren = function () {
	        var result = isTrue(this.gridOptions.groupSelectsChildren);
	        if (result && this.isTreeData()) {
	            console.warn('ag-Grid: groupSelectsChildren does not work with tree data');
	            return false;
	        }
	        return result;
	    };
	    GridOptionsWrapper.prototype.isSuppressRowHoverHighlight = function () {
	        return isTrue(this.gridOptions.suppressRowHoverHighlight);
	    };
	    GridOptionsWrapper.prototype.isGroupSelectsFiltered = function () {
	        return isTrue(this.gridOptions.groupSelectsFiltered);
	    };
	    GridOptionsWrapper.prototype.isGroupHideOpenParents = function () {
	        return isTrue(this.gridOptions.groupHideOpenParents);
	    };
	    // if we are doing hideOpenParents, then we always have groupMultiAutoColumn, otherwise hideOpenParents would not work
	    GridOptionsWrapper.prototype.isGroupMultiAutoColumn = function () {
	        return isTrue(this.gridOptions.groupMultiAutoColumn) || isTrue(this.gridOptions.groupHideOpenParents);
	    };
	    GridOptionsWrapper.prototype.isGroupRemoveSingleChildren = function () {
	        return isTrue(this.gridOptions.groupRemoveSingleChildren);
	    };
	    GridOptionsWrapper.prototype.isGroupRemoveLowestSingleChildren = function () {
	        return isTrue(this.gridOptions.groupRemoveLowestSingleChildren);
	    };
	    GridOptionsWrapper.prototype.isGroupIncludeFooter = function () {
	        return isTrue(this.gridOptions.groupIncludeFooter);
	    };
	    GridOptionsWrapper.prototype.isGroupIncludeTotalFooter = function () {
	        return isTrue(this.gridOptions.groupIncludeTotalFooter);
	    };
	    GridOptionsWrapper.prototype.isGroupSuppressBlankHeader = function () {
	        return isTrue(this.gridOptions.groupSuppressBlankHeader);
	    };
	    GridOptionsWrapper.prototype.isSuppressRowClickSelection = function () {
	        return isTrue(this.gridOptions.suppressRowClickSelection);
	    };
	    GridOptionsWrapper.prototype.isSuppressCellSelection = function () {
	        return isTrue(this.gridOptions.suppressCellSelection);
	    };
	    GridOptionsWrapper.prototype.isSuppressMultiSort = function () {
	        return isTrue(this.gridOptions.suppressMultiSort);
	    };
	    GridOptionsWrapper.prototype.isMultiSortKeyCtrl = function () {
	        return this.gridOptions.multiSortKey === 'ctrl';
	    };
	    GridOptionsWrapper.prototype.isGroupSuppressAutoColumn = function () {
	        return isTrue(this.gridOptions.groupSuppressAutoColumn);
	    };
	    GridOptionsWrapper.prototype.isSuppressDragLeaveHidesColumns = function () {
	        return isTrue(this.gridOptions.suppressDragLeaveHidesColumns);
	    };
	    GridOptionsWrapper.prototype.isSuppressScrollOnNewData = function () {
	        return isTrue(this.gridOptions.suppressScrollOnNewData);
	    };
	    GridOptionsWrapper.prototype.isRowDragManaged = function () {
	        return isTrue(this.gridOptions.rowDragManaged);
	    };
	    GridOptionsWrapper.prototype.isSuppressRowDrag = function () {
	        return isTrue(this.gridOptions.suppressRowDrag);
	    };
	    // returns either 'print', 'autoHeight' or 'normal' (normal is the default)
	    GridOptionsWrapper.prototype.getDomLayout = function () {
	        var _this = this;
	        var domLayout = this.gridOptions.domLayout;
	        if (domLayout === constants_1.Constants.DOM_LAYOUT_PRINT
	            || domLayout === constants_1.Constants.DOM_LAYOUT_AUTO_HEIGHT
	            || domLayout === constants_1.Constants.DOM_LAYOUT_NORMAL) {
	            return domLayout;
	        }
	        else if (domLayout === null || domLayout === undefined) {
	            return constants_1.Constants.DOM_LAYOUT_NORMAL;
	        }
	        else {
	            utils_1._.doOnce(function () { return console.warn("ag-Grid: " + _this.gridOptions.domLayout + " is not valid for DOM Layout, valid values are " + constants_1.Constants.DOM_LAYOUT_NORMAL + ", " + constants_1.Constants.DOM_LAYOUT_AUTO_HEIGHT + " and " + constants_1.Constants.DOM_LAYOUT_PRINT); }, 'warn about dom layout values');
	            return constants_1.Constants.DOM_LAYOUT_NORMAL;
	        }
	    };
	    GridOptionsWrapper.prototype.isSuppressHorizontalScroll = function () {
	        return isTrue(this.gridOptions.suppressHorizontalScroll);
	    };
	    GridOptionsWrapper.prototype.isSuppressMaxRenderedRowRestriction = function () {
	        return isTrue(this.gridOptions.suppressMaxRenderedRowRestriction);
	    };
	    GridOptionsWrapper.prototype.isExcludeChildrenWhenTreeDataFiltering = function () {
	        return isTrue(this.gridOptions.excludeChildrenWhenTreeDataFiltering);
	    };
	    GridOptionsWrapper.prototype.isAlwaysShowVerticalScroll = function () {
	        return isTrue(this.gridOptions.alwaysShowVerticalScroll);
	    };
	    GridOptionsWrapper.prototype.isSuppressLoadingOverlay = function () {
	        return isTrue(this.gridOptions.suppressLoadingOverlay);
	    };
	    GridOptionsWrapper.prototype.isSuppressNoRowsOverlay = function () {
	        return isTrue(this.gridOptions.suppressNoRowsOverlay);
	    };
	    GridOptionsWrapper.prototype.isSuppressFieldDotNotation = function () {
	        return isTrue(this.gridOptions.suppressFieldDotNotation);
	    };
	    GridOptionsWrapper.prototype.getPinnedTopRowData = function () {
	        return this.gridOptions.pinnedTopRowData;
	    };
	    GridOptionsWrapper.prototype.getPinnedBottomRowData = function () {
	        return this.gridOptions.pinnedBottomRowData;
	    };
	    GridOptionsWrapper.prototype.isFunctionsPassive = function () {
	        return isTrue(this.gridOptions.functionsPassive);
	    };
	    GridOptionsWrapper.prototype.isSuppressTabbing = function () {
	        return isTrue(this.gridOptions.suppressTabbing);
	    };
	    GridOptionsWrapper.prototype.isSuppressChangeDetection = function () {
	        return isTrue(this.gridOptions.suppressChangeDetection);
	    };
	    GridOptionsWrapper.prototype.isSuppressAnimationFrame = function () {
	        return isTrue(this.gridOptions.suppressAnimationFrame);
	    };
	    GridOptionsWrapper.prototype.getQuickFilterText = function () {
	        return this.gridOptions.quickFilterText;
	    };
	    GridOptionsWrapper.prototype.isCacheQuickFilter = function () {
	        return isTrue(this.gridOptions.cacheQuickFilter);
	    };
	    GridOptionsWrapper.prototype.isUnSortIcon = function () {
	        return isTrue(this.gridOptions.unSortIcon);
	    };
	    GridOptionsWrapper.prototype.isSuppressMenuHide = function () {
	        return isTrue(this.gridOptions.suppressMenuHide);
	    };
	    GridOptionsWrapper.prototype.isEnterMovesDownAfterEdit = function () {
	        return isTrue(this.gridOptions.enterMovesDownAfterEdit);
	    };
	    GridOptionsWrapper.prototype.isEnterMovesDown = function () {
	        return isTrue(this.gridOptions.enterMovesDown);
	    };
	    GridOptionsWrapper.prototype.getRowStyle = function () {
	        return this.gridOptions.rowStyle;
	    };
	    GridOptionsWrapper.prototype.getRowClass = function () {
	        return this.gridOptions.rowClass;
	    };
	    GridOptionsWrapper.prototype.getRowStyleFunc = function () {
	        return this.gridOptions.getRowStyle;
	    };
	    GridOptionsWrapper.prototype.getRowClassFunc = function () {
	        return this.gridOptions.getRowClass;
	    };
	    GridOptionsWrapper.prototype.rowClassRules = function () {
	        return this.gridOptions.rowClassRules;
	    };
	    GridOptionsWrapper.prototype.getCreateChartContainerFunc = function () {
	        return this.gridOptions.createChartContainer;
	    };
	    GridOptionsWrapper.prototype.getPopupParent = function () {
	        return this.gridOptions.popupParent;
	    };
	    GridOptionsWrapper.prototype.getBlockLoadDebounceMillis = function () {
	        return this.gridOptions.blockLoadDebounceMillis;
	    };
	    GridOptionsWrapper.prototype.getPostProcessPopupFunc = function () {
	        return this.gridOptions.postProcessPopup;
	    };
	    GridOptionsWrapper.prototype.getDoesDataFlowerFunc = function () {
	        return this.gridOptions.doesDataFlower;
	    };
	    GridOptionsWrapper.prototype.getPaginationNumberFormatterFunc = function () {
	        return this.gridOptions.paginationNumberFormatter;
	    };
	    GridOptionsWrapper.prototype.getChildCountFunc = function () {
	        return this.gridOptions.getChildCount;
	    };
	    GridOptionsWrapper.prototype.getDefaultGroupSortComparator = function () {
	        return this.gridOptions.defaultGroupSortComparator;
	    };
	    GridOptionsWrapper.prototype.getIsFullWidthCellFunc = function () {
	        return this.gridOptions.isFullWidthCell;
	    };
	    GridOptionsWrapper.prototype.getFullWidthCellRendererParams = function () {
	        return this.gridOptions.fullWidthCellRendererParams;
	    };
	    GridOptionsWrapper.prototype.isEmbedFullWidthRows = function () {
	        return isTrue(this.gridOptions.embedFullWidthRows) || isTrue(this.gridOptions.deprecatedEmbedFullWidthRows);
	    };
	    GridOptionsWrapper.prototype.getSuppressKeyboardEventFunc = function () {
	        return this.gridOptions.suppressKeyboardEvent;
	    };
	    GridOptionsWrapper.prototype.getBusinessKeyForNodeFunc = function () {
	        return this.gridOptions.getBusinessKeyForNode;
	    };
	    GridOptionsWrapper.prototype.getApi = function () {
	        return this.gridOptions.api;
	    };
	    GridOptionsWrapper.prototype.getColumnApi = function () {
	        return this.gridOptions.columnApi;
	    };
	    GridOptionsWrapper.prototype.isDeltaRowDataMode = function () {
	        return isTrue(this.gridOptions.deltaRowDataMode);
	    };
	    GridOptionsWrapper.prototype.isDeltaColumnMode = function () {
	        return isTrue(this.gridOptions.deltaColumnMode);
	    };
	    GridOptionsWrapper.prototype.isEnsureDomOrder = function () {
	        return isTrue(this.gridOptions.ensureDomOrder);
	    };
	    GridOptionsWrapper.prototype.isEnableCharts = function () {
	        if (isTrue((this.gridOptions.enableCharts))) {
	            if (!this.context.isModuleRegistered("chartsModule" /* ChartsModule */)) {
	                utils_1._.doOnce(function () {
	                    console.warn('ag-grid: Charts is enabled but the Charts Module has not been included.');
	                }, 'ChartsModuleCheck');
	                return false;
	            }
	            return true;
	        }
	        return false;
	    };
	    GridOptionsWrapper.prototype.getColResizeDefault = function () {
	        return this.gridOptions.colResizeDefault;
	    };
	    GridOptionsWrapper.prototype.isSingleClickEdit = function () {
	        return isTrue(this.gridOptions.singleClickEdit);
	    };
	    GridOptionsWrapper.prototype.isSuppressClickEdit = function () {
	        return isTrue(this.gridOptions.suppressClickEdit);
	    };
	    GridOptionsWrapper.prototype.isStopEditingWhenGridLosesFocus = function () {
	        return isTrue(this.gridOptions.stopEditingWhenGridLosesFocus);
	    };
	    GridOptionsWrapper.prototype.getGroupDefaultExpanded = function () {
	        return this.gridOptions.groupDefaultExpanded;
	    };
	    GridOptionsWrapper.prototype.getMaxConcurrentDatasourceRequests = function () {
	        return this.gridOptions.maxConcurrentDatasourceRequests;
	    };
	    GridOptionsWrapper.prototype.getMaxBlocksInCache = function () {
	        return this.gridOptions.maxBlocksInCache;
	    };
	    GridOptionsWrapper.prototype.getCacheOverflowSize = function () {
	        return this.gridOptions.cacheOverflowSize;
	    };
	    GridOptionsWrapper.prototype.getPaginationPageSize = function () {
	        return this.gridOptions.paginationPageSize;
	    };
	    GridOptionsWrapper.prototype.isPaginateChildRows = function () {
	        // if using groupSuppressRow, means we are not showing parent rows,
	        // so we always paginate on the child rows here as there are no parent rows
	        if (this.isGroupSuppressRow() || this.isGroupRemoveSingleChildren()
	            || this.isGroupRemoveLowestSingleChildren()) {
	            return true;
	        }
	        return isTrue(this.gridOptions.paginateChildRows);
	    };
	    GridOptionsWrapper.prototype.getCacheBlockSize = function () {
	        return this.gridOptions.cacheBlockSize;
	    };
	    GridOptionsWrapper.prototype.getInfiniteInitialRowCount = function () {
	        return this.gridOptions.infiniteInitialRowCount;
	    };
	    GridOptionsWrapper.prototype.isPurgeClosedRowNodes = function () {
	        return isTrue(this.gridOptions.purgeClosedRowNodes);
	    };
	    GridOptionsWrapper.prototype.isSuppressPaginationPanel = function () {
	        return isTrue(this.gridOptions.suppressPaginationPanel);
	    };
	    GridOptionsWrapper.prototype.getRowData = function () {
	        return this.gridOptions.rowData;
	    };
	    // this property is different - we never allow groupUseEntireRow if in pivot mode,
	    // as otherwise we don't see the pivot values.
	    GridOptionsWrapper.prototype.isGroupUseEntireRow = function (pivotMode) {
	        return pivotMode ? false : isTrue(this.gridOptions.groupUseEntireRow);
	    };
	    GridOptionsWrapper.prototype.isEnableRtl = function () {
	        return isTrue(this.gridOptions.enableRtl);
	    };
	    GridOptionsWrapper.prototype.getAutoGroupColumnDef = function () {
	        return this.gridOptions.autoGroupColumnDef;
	    };
	    GridOptionsWrapper.prototype.isGroupSuppressRow = function () {
	        return isTrue(this.gridOptions.groupSuppressRow);
	    };
	    GridOptionsWrapper.prototype.getRowGroupPanelShow = function () {
	        return this.gridOptions.rowGroupPanelShow;
	    };
	    GridOptionsWrapper.prototype.getPivotPanelShow = function () {
	        return this.gridOptions.pivotPanelShow;
	    };
	    GridOptionsWrapper.prototype.isAngularCompileRows = function () {
	        return isTrue(this.gridOptions.angularCompileRows);
	    };
	    GridOptionsWrapper.prototype.isAngularCompileFilters = function () {
	        return isTrue(this.gridOptions.angularCompileFilters);
	    };
	    GridOptionsWrapper.prototype.isAngularCompileHeaders = function () {
	        return isTrue(this.gridOptions.angularCompileHeaders);
	    };
	    GridOptionsWrapper.prototype.isDebug = function () {
	        return isTrue(this.gridOptions.debug);
	    };
	    GridOptionsWrapper.prototype.getColumnDefs = function () {
	        return this.gridOptions.columnDefs;
	    };
	    GridOptionsWrapper.prototype.getColumnTypes = function () {
	        return this.gridOptions.columnTypes;
	    };
	    GridOptionsWrapper.prototype.getDatasource = function () {
	        return this.gridOptions.datasource;
	    };
	    GridOptionsWrapper.prototype.getViewportDatasource = function () {
	        return this.gridOptions.viewportDatasource;
	    };
	    GridOptionsWrapper.prototype.getServerSideDatasource = function () {
	        return this.gridOptions.serverSideDatasource;
	    };
	    GridOptionsWrapper.prototype.isAccentedSort = function () {
	        return isTrue(this.gridOptions.accentedSort);
	    };
	    GridOptionsWrapper.prototype.isEnableBrowserTooltips = function () {
	        return isTrue(this.gridOptions.enableBrowserTooltips);
	    };
	    GridOptionsWrapper.prototype.isEnableCellExpressions = function () {
	        return isTrue(this.gridOptions.enableCellExpressions);
	    };
	    GridOptionsWrapper.prototype.isEnableGroupEdit = function () {
	        return isTrue(this.gridOptions.enableGroupEdit);
	    };
	    GridOptionsWrapper.prototype.isSuppressMiddleClickScrolls = function () {
	        return isTrue(this.gridOptions.suppressMiddleClickScrolls);
	    };
	    GridOptionsWrapper.prototype.isPreventDefaultOnContextMenu = function () {
	        return isTrue(this.gridOptions.preventDefaultOnContextMenu);
	    };
	    GridOptionsWrapper.prototype.isSuppressPreventDefaultOnMouseWheel = function () {
	        return isTrue(this.gridOptions.suppressPreventDefaultOnMouseWheel);
	    };
	    GridOptionsWrapper.prototype.isSuppressColumnVirtualisation = function () {
	        return isTrue(this.gridOptions.suppressColumnVirtualisation);
	    };
	    GridOptionsWrapper.prototype.isSuppressContextMenu = function () {
	        return isTrue(this.gridOptions.suppressContextMenu);
	    };
	    GridOptionsWrapper.prototype.isAllowContextMenuWithControlKey = function () {
	        return isTrue(this.gridOptions.allowContextMenuWithControlKey);
	    };
	    GridOptionsWrapper.prototype.isSuppressCopyRowsToClipboard = function () {
	        return isTrue(this.gridOptions.suppressCopyRowsToClipboard);
	    };
	    GridOptionsWrapper.prototype.isCopyHeadersToClipboard = function () {
	        return isTrue(this.gridOptions.copyHeadersToClipboard);
	    };
	    GridOptionsWrapper.prototype.isSuppressClipboardPaste = function () {
	        return isTrue(this.gridOptions.suppressClipboardPaste);
	    };
	    GridOptionsWrapper.prototype.isPagination = function () {
	        return isTrue(this.gridOptions.pagination);
	    };
	    GridOptionsWrapper.prototype.isSuppressEnterpriseResetOnNewColumns = function () {
	        return isTrue(this.gridOptions.suppressEnterpriseResetOnNewColumns);
	    };
	    GridOptionsWrapper.prototype.getProcessDataFromClipboardFunc = function () {
	        return this.gridOptions.processDataFromClipboard;
	    };
	    GridOptionsWrapper.prototype.getBatchUpdateWaitMillis = function () {
	        return utils_1._.exists(this.gridOptions.batchUpdateWaitMillis) ? this.gridOptions.batchUpdateWaitMillis : constants_1.Constants.BATCH_WAIT_MILLIS;
	    };
	    GridOptionsWrapper.prototype.isSuppressMovableColumns = function () {
	        return isTrue(this.gridOptions.suppressMovableColumns);
	    };
	    GridOptionsWrapper.prototype.isAnimateRows = function () {
	        // never allow animating if enforcing the row order
	        if (this.isEnsureDomOrder()) {
	            return false;
	        }
	        return isTrue(this.gridOptions.animateRows);
	    };
	    GridOptionsWrapper.prototype.isSuppressColumnMoveAnimation = function () {
	        return isTrue(this.gridOptions.suppressColumnMoveAnimation);
	    };
	    GridOptionsWrapper.prototype.isSuppressAggFuncInHeader = function () {
	        return isTrue(this.gridOptions.suppressAggFuncInHeader);
	    };
	    GridOptionsWrapper.prototype.isSuppressAggAtRootLevel = function () {
	        return isTrue(this.gridOptions.suppressAggAtRootLevel);
	    };
	    GridOptionsWrapper.prototype.isEnableRangeSelection = function () {
	        return this.enterprise && isTrue(this.gridOptions.enableRangeSelection);
	    };
	    GridOptionsWrapper.prototype.isEnableRangeHandle = function () {
	        return isTrue(this.gridOptions.enableRangeHandle);
	    };
	    GridOptionsWrapper.prototype.isEnableFillHandle = function () {
	        return isTrue(this.gridOptions.enableFillHandle);
	    };
	    GridOptionsWrapper.prototype.isSuppressMultiRangeSelection = function () {
	        return isTrue(this.gridOptions.suppressMultiRangeSelection);
	    };
	    GridOptionsWrapper.prototype.isPaginationAutoPageSize = function () {
	        return isTrue(this.gridOptions.paginationAutoPageSize);
	    };
	    GridOptionsWrapper.prototype.isRememberGroupStateWhenNewData = function () {
	        return isTrue(this.gridOptions.rememberGroupStateWhenNewData);
	    };
	    GridOptionsWrapper.prototype.getIcons = function () {
	        return this.gridOptions.icons;
	    };
	    GridOptionsWrapper.prototype.getAggFuncs = function () {
	        return this.gridOptions.aggFuncs;
	    };
	    GridOptionsWrapper.prototype.getSortingOrder = function () {
	        return this.gridOptions.sortingOrder;
	    };
	    GridOptionsWrapper.prototype.getAlignedGrids = function () {
	        return this.gridOptions.alignedGrids;
	    };
	    GridOptionsWrapper.prototype.isMasterDetail = function () {
	        var _this = this;
	        var usingMasterDetail = isTrue(this.gridOptions.masterDetail);
	        utils_1._.doOnce(function () {
	            if (usingMasterDetail && !_this.enterprise) {
	                console.warn('ag-grid: Master Detail is an Enterprise feature of ag-Grid.');
	            }
	        }, 'MasterDetailEnterpriseCheck');
	        return usingMasterDetail && this.enterprise;
	    };
	    GridOptionsWrapper.prototype.isKeepDetailRows = function () {
	        return isTrue(this.gridOptions.keepDetailRows);
	    };
	    GridOptionsWrapper.prototype.getKeepDetailRowsCount = function () {
	        if (this.gridOptions.keepDetailRowsCount > 0) {
	            return this.gridOptions.keepDetailRowsCount;
	        }
	        else {
	            return DEFAULT_KEEP_DETAIL_ROW_COUNT;
	        }
	    };
	    GridOptionsWrapper.prototype.getIsRowMasterFunc = function () {
	        return this.gridOptions.isRowMaster;
	    };
	    GridOptionsWrapper.prototype.getIsRowSelectableFunc = function () {
	        return this.gridOptions.isRowSelectable;
	    };
	    GridOptionsWrapper.prototype.getGroupRowRendererParams = function () {
	        return this.gridOptions.groupRowRendererParams;
	    };
	    GridOptionsWrapper.prototype.getOverlayLoadingTemplate = function () {
	        return this.gridOptions.overlayLoadingTemplate;
	    };
	    GridOptionsWrapper.prototype.getOverlayNoRowsTemplate = function () {
	        return this.gridOptions.overlayNoRowsTemplate;
	    };
	    GridOptionsWrapper.prototype.isSuppressAutoSize = function () {
	        return isTrue(this.gridOptions.suppressAutoSize);
	    };
	    GridOptionsWrapper.prototype.isEnableCellTextSelection = function () {
	        return isTrue(this.gridOptions.enableCellTextSelection);
	    };
	    GridOptionsWrapper.prototype.isSuppressParentsInRowNodes = function () {
	        return isTrue(this.gridOptions.suppressParentsInRowNodes);
	    };
	    GridOptionsWrapper.prototype.isFunctionsReadOnly = function () {
	        return isTrue(this.gridOptions.functionsReadOnly);
	    };
	    GridOptionsWrapper.prototype.isFloatingFilter = function () {
	        return this.gridOptions.floatingFilter;
	    };
	    GridOptionsWrapper.prototype.isEnableCellTextSelect = function () {
	        return isTrue(this.gridOptions.enableCellTextSelection);
	    };
	    GridOptionsWrapper.prototype.isEnableOldSetFilterModel = function () {
	        return isTrue(this.gridOptions.enableOldSetFilterModel);
	    };
	    GridOptionsWrapper.prototype.getDefaultColDef = function () {
	        return this.gridOptions.defaultColDef;
	    };
	    GridOptionsWrapper.prototype.getDefaultColGroupDef = function () {
	        return this.gridOptions.defaultColGroupDef;
	    };
	    GridOptionsWrapper.prototype.getDefaultExportParams = function () {
	        return this.gridOptions.defaultExportParams;
	    };
	    GridOptionsWrapper.prototype.isSuppressCsvExport = function () {
	        return isTrue(this.gridOptions.suppressCsvExport);
	    };
	    GridOptionsWrapper.prototype.isAllowShowChangeAfterFilter = function () {
	        return isTrue(this.gridOptions.allowShowChangeAfterFilter);
	    };
	    GridOptionsWrapper.prototype.isSuppressExcelExport = function () {
	        return isTrue(this.gridOptions.suppressExcelExport);
	    };
	    GridOptionsWrapper.prototype.isSuppressMakeColumnVisibleAfterUnGroup = function () {
	        return isTrue(this.gridOptions.suppressMakeColumnVisibleAfterUnGroup);
	    };
	    GridOptionsWrapper.prototype.getNodeChildDetailsFunc = function () {
	        return this.gridOptions.getNodeChildDetails;
	    };
	    GridOptionsWrapper.prototype.getDataPathFunc = function () {
	        return this.gridOptions.getDataPath;
	    };
	    GridOptionsWrapper.prototype.getIsServerSideGroupFunc = function () {
	        return this.gridOptions.isServerSideGroup;
	    };
	    GridOptionsWrapper.prototype.getServerSideGroupKeyFunc = function () {
	        return this.gridOptions.getServerSideGroupKey;
	    };
	    GridOptionsWrapper.prototype.getGroupRowAggNodesFunc = function () {
	        return this.gridOptions.groupRowAggNodes;
	    };
	    GridOptionsWrapper.prototype.getContextMenuItemsFunc = function () {
	        return this.gridOptions.getContextMenuItems;
	    };
	    GridOptionsWrapper.prototype.getMainMenuItemsFunc = function () {
	        return this.gridOptions.getMainMenuItems;
	    };
	    GridOptionsWrapper.prototype.getChartToolbarItemsFunc = function () {
	        return this.gridOptions.getChartToolbarItems;
	    };
	    GridOptionsWrapper.prototype.getRowNodeIdFunc = function () {
	        return this.gridOptions.getRowNodeId;
	    };
	    GridOptionsWrapper.prototype.getNavigateToNextCellFunc = function () {
	        return this.gridOptions.navigateToNextCell;
	    };
	    GridOptionsWrapper.prototype.getTabToNextCellFunc = function () {
	        return this.gridOptions.tabToNextCell;
	    };
	    GridOptionsWrapper.prototype.isTreeData = function () {
	        var _this = this;
	        var usingTreeData = isTrue(this.gridOptions.treeData);
	        utils_1._.doOnce(function () {
	            if (usingTreeData && !_this.enterprise) {
	                console.warn('ag-grid: TreeData is an Enterprise feature of ag-Grid.');
	            }
	        }, 'TreeDataEnterpriseCheck');
	        return usingTreeData;
	    };
	    GridOptionsWrapper.prototype.isValueCache = function () {
	        return isTrue(this.gridOptions.valueCache);
	    };
	    GridOptionsWrapper.prototype.isValueCacheNeverExpires = function () {
	        return isTrue(this.gridOptions.valueCacheNeverExpires);
	    };
	    GridOptionsWrapper.prototype.isDeltaSort = function () {
	        return isTrue(this.gridOptions.deltaSort);
	    };
	    GridOptionsWrapper.prototype.isAggregateOnlyChangedColumns = function () {
	        return isTrue(this.gridOptions.aggregateOnlyChangedColumns);
	    };
	    GridOptionsWrapper.prototype.getProcessSecondaryColDefFunc = function () {
	        return this.gridOptions.processSecondaryColDef;
	    };
	    GridOptionsWrapper.prototype.getProcessSecondaryColGroupDefFunc = function () {
	        return this.gridOptions.processSecondaryColGroupDef;
	    };
	    GridOptionsWrapper.prototype.getSendToClipboardFunc = function () {
	        return this.gridOptions.sendToClipboard;
	    };
	    GridOptionsWrapper.prototype.getProcessRowPostCreateFunc = function () {
	        return this.gridOptions.processRowPostCreate;
	    };
	    GridOptionsWrapper.prototype.getProcessCellForClipboardFunc = function () {
	        return this.gridOptions.processCellForClipboard;
	    };
	    GridOptionsWrapper.prototype.getProcessHeaderForClipboardFunc = function () {
	        return this.gridOptions.processHeaderForClipboard;
	    };
	    GridOptionsWrapper.prototype.getProcessCellFromClipboardFunc = function () {
	        return this.gridOptions.processCellFromClipboard;
	    };
	    GridOptionsWrapper.prototype.getViewportRowModelPageSize = function () {
	        return oneOrGreater(this.gridOptions.viewportRowModelPageSize, DEFAULT_VIEWPORT_ROW_MODEL_PAGE_SIZE);
	    };
	    GridOptionsWrapper.prototype.getViewportRowModelBufferSize = function () {
	        return zeroOrGreater(this.gridOptions.viewportRowModelBufferSize, DEFAULT_VIEWPORT_ROW_MODEL_BUFFER_SIZE);
	    };
	    // public getCellRenderers(): {[key: string]: {new(): ICellRenderer} | ICellRendererFunc} { return this.gridOptions.cellRenderers; }
	    // public getCellEditors(): {[key: string]: {new(): ICellEditor}} { return this.gridOptions.cellEditors; }
	    GridOptionsWrapper.prototype.isServerSideSortingAlwaysResets = function () {
	        return isTrue(this.gridOptions.serverSideSortingAlwaysResets);
	    };
	    GridOptionsWrapper.prototype.getPostSortFunc = function () {
	        return this.gridOptions.postSort;
	    };
	    GridOptionsWrapper.prototype.getProcessChartOptionsFunc = function () {
	        return this.gridOptions.processChartOptions;
	    };
	    GridOptionsWrapper.prototype.getClipboardDeliminator = function () {
	        return utils_1._.exists(this.gridOptions.clipboardDeliminator) ? this.gridOptions.clipboardDeliminator : '\t';
	    };
	    GridOptionsWrapper.prototype.setProperty = function (key, value) {
	        var gridOptionsNoType = this.gridOptions;
	        var previousValue = gridOptionsNoType[key];
	        if (previousValue !== value) {
	            gridOptionsNoType[key] = value;
	            var event_1 = {
	                type: key,
	                currentValue: value,
	                previousValue: previousValue
	            };
	            this.propertyEventService.dispatchEvent(event_1);
	        }
	    };
	    // this logic is repeated in lots of places. any element that had different CSS
	    // dependent on the layout needs to have the layout class added ot it.
	    GridOptionsWrapper.prototype.addLayoutElement = function (element) {
	        this.layoutElements.push(element);
	        this.updateLayoutClasses();
	    };
	    GridOptionsWrapper.prototype.updateLayoutClasses = function () {
	        var domLayout = this.getDomLayout();
	        var domLayoutAutoHeight = domLayout === constants_1.Constants.DOM_LAYOUT_AUTO_HEIGHT;
	        var domLayoutPrint = domLayout === constants_1.Constants.DOM_LAYOUT_PRINT;
	        var domLayoutNormal = domLayout === constants_1.Constants.DOM_LAYOUT_NORMAL;
	        this.layoutElements.forEach(function (e) {
	            utils_1._.addOrRemoveCssClass(e, 'ag-layout-auto-height', domLayoutAutoHeight);
	            utils_1._.addOrRemoveCssClass(e, 'ag-layout-normal', domLayoutNormal);
	            utils_1._.addOrRemoveCssClass(e, 'ag-layout-print', domLayoutPrint);
	        });
	    };
	    GridOptionsWrapper.prototype.addEventListener = function (key, listener) {
	        GridOptionsWrapper_1.checkEventDeprecation(key);
	        this.propertyEventService.addEventListener(key, listener);
	    };
	    GridOptionsWrapper.checkEventDeprecation = function (eventName) {
	        if (eventName === 'floatingRowDataChanged') {
	            console.warn('ag-Grid: floatingRowDataChanged is now called pinnedRowDataChanged');
	        }
	    };
	    GridOptionsWrapper.prototype.removeEventListener = function (key, listener) {
	        this.propertyEventService.removeEventListener(key, listener);
	    };
	    GridOptionsWrapper.prototype.getAutoSizePadding = function () {
	        return this.gridOptions.autoSizePadding && this.gridOptions.autoSizePadding > 0 ? this.gridOptions.autoSizePadding : 20;
	    };
	    // properties
	    GridOptionsWrapper.prototype.getHeaderHeight = function () {
	        if (typeof this.gridOptions.headerHeight === 'number') {
	            return this.gridOptions.headerHeight;
	        }
	        return this.specialForNewMaterial(25, 'headerHeight');
	    };
	    GridOptionsWrapper.prototype.getFloatingFiltersHeight = function () {
	        if (typeof this.gridOptions.floatingFiltersHeight === 'number') {
	            return this.gridOptions.floatingFiltersHeight;
	        }
	        return this.specialForNewMaterial(25, 'headerHeight');
	    };
	    GridOptionsWrapper.prototype.getGroupHeaderHeight = function () {
	        if (typeof this.gridOptions.groupHeaderHeight === 'number') {
	            return this.gridOptions.groupHeaderHeight;
	        }
	        return this.getHeaderHeight();
	    };
	    GridOptionsWrapper.prototype.getPivotHeaderHeight = function () {
	        if (typeof this.gridOptions.pivotHeaderHeight === 'number') {
	            return this.gridOptions.pivotHeaderHeight;
	        }
	        return this.getHeaderHeight();
	    };
	    GridOptionsWrapper.prototype.getPivotGroupHeaderHeight = function () {
	        if (typeof this.gridOptions.pivotGroupHeaderHeight === 'number') {
	            return this.gridOptions.pivotGroupHeaderHeight;
	        }
	        return this.getGroupHeaderHeight();
	    };
	    GridOptionsWrapper.prototype.isExternalFilterPresent = function () {
	        if (typeof this.gridOptions.isExternalFilterPresent === 'function') {
	            return this.gridOptions.isExternalFilterPresent();
	        }
	        return false;
	    };
	    GridOptionsWrapper.prototype.doesExternalFilterPass = function (node) {
	        if (typeof this.gridOptions.doesExternalFilterPass === 'function') {
	            return this.gridOptions.doesExternalFilterPass(node);
	        }
	        return false;
	    };
	    GridOptionsWrapper.prototype.getDocument = function () {
	        // if user is providing document, we use the users one,
	        // otherwise we use the document on the global namespace.
	        var result = null;
	        if (this.gridOptions.getDocument && utils_1._.exists(this.gridOptions.getDocument)) {
	            result = this.gridOptions.getDocument();
	        }
	        if (result && utils_1._.exists(result)) {
	            return result;
	        }
	        return document;
	    };
	    GridOptionsWrapper.prototype.getMinColWidth = function () {
	        if (this.gridOptions.minColWidth && (this.gridOptions.minColWidth > GridOptionsWrapper_1.MIN_COL_WIDTH)) {
	            return this.gridOptions.minColWidth;
	        }
	        return GridOptionsWrapper_1.MIN_COL_WIDTH;
	    };
	    GridOptionsWrapper.prototype.getMaxColWidth = function () {
	        if (this.gridOptions.maxColWidth && (this.gridOptions.maxColWidth > GridOptionsWrapper_1.MIN_COL_WIDTH)) {
	            return this.gridOptions.maxColWidth;
	        }
	        return null;
	    };
	    GridOptionsWrapper.prototype.getColWidth = function () {
	        if (typeof this.gridOptions.colWidth !== 'number' || this.gridOptions.colWidth < GridOptionsWrapper_1.MIN_COL_WIDTH) {
	            return 200;
	        }
	        return this.gridOptions.colWidth;
	    };
	    GridOptionsWrapper.prototype.getRowBuffer = function () {
	        var rowBuffer = this.gridOptions.rowBuffer;
	        if (typeof rowBuffer === 'number') {
	            if (rowBuffer < 0) {
	                utils_1._.doOnce(function () { return console.warn("ag-Grid: rowBuffer should not be negative"); }, 'warn rowBuffer negative');
	                this.gridOptions.rowBuffer = rowBuffer = 0;
	            }
	        }
	        else {
	            rowBuffer = constants_1.Constants.ROW_BUFFER_SIZE;
	        }
	        return rowBuffer;
	    };
	    GridOptionsWrapper.prototype.getRowBufferInPixels = function () {
	        var rowsToBuffer = this.getRowBuffer();
	        var defaultRowHeight = this.getRowHeightAsNumber();
	        return rowsToBuffer * defaultRowHeight;
	    };
	    // the user might be using some non-standard scrollbar, eg a scrollbar that has zero
	    // width and overlays (like the Safari scrollbar, but presented in Chrome). so we
	    // allow the user to provide the scroll width before we work it out.
	    GridOptionsWrapper.prototype.getScrollbarWidth = function () {
	        if (this.scrollWidth == null) {
	            var useGridOptions = typeof this.gridOptions.scrollbarWidth === 'number' &&
	                this.gridOptions.scrollbarWidth >= 0;
	            this.scrollWidth = useGridOptions ? this.gridOptions.scrollbarWidth : utils_1._.getScrollbarWidth();
	        }
	        return this.scrollWidth;
	    };
	    GridOptionsWrapper.prototype.checkForDeprecated = function () {
	        var _this = this;
	        // casting to generic object, so typescript compiles even though
	        // we are looking for attributes that don't exist
	        var options = this.gridOptions;
	        if (options.suppressUnSort) {
	            console.warn('ag-grid: as of v1.12.4 suppressUnSort is not used. Please use sortingOrder instead.');
	        }
	        if (options.suppressDescSort) {
	            console.warn('ag-grid: as of v1.12.4 suppressDescSort is not used. Please use sortingOrder instead.');
	        }
	        if (options.groupAggFields) {
	            console.warn('ag-grid: as of v3 groupAggFields is not used. Please add appropriate agg fields to your columns.');
	        }
	        if (options.groupHidePivotColumns) {
	            console.warn('ag-grid: as of v3 groupHidePivotColumns is not used as pivot columns are now called rowGroup columns. Please refer to the documentation');
	        }
	        if (options.groupKeys) {
	            console.warn('ag-grid: as of v3 groupKeys is not used. You need to set rowGroupIndex on the columns to group. Please refer to the documentation');
	        }
	        if (typeof options.groupDefaultExpanded === 'boolean') {
	            console.warn('ag-grid: groupDefaultExpanded can no longer be boolean. for groupDefaultExpanded=true, use groupDefaultExpanded=9999 instead, to expand all the groups');
	        }
	        if (options.onRowDeselected || options.rowDeselected) {
	            console.warn('ag-grid: since version 3.4 event rowDeselected no longer exists, please check the docs');
	        }
	        if (options.rowsAlreadyGrouped) {
	            console.warn('ag-grid: since version 3.4 rowsAlreadyGrouped no longer exists, please use getNodeChildDetails() instead');
	        }
	        if (options.groupAggFunction) {
	            console.warn('ag-grid: since version 4.3.x groupAggFunction is now called groupRowAggNodes');
	        }
	        if (options.checkboxSelection) {
	            console.warn('ag-grid: since version 8.0.x checkboxSelection is not supported as a grid option. ' +
	                'If you want this on all columns, use defaultColDef instead and set it there');
	        }
	        if (options.paginationInitialRowCount) {
	            console.warn('ag-grid: since version 9.0.x paginationInitialRowCount is now called infiniteInitialRowCount');
	        }
	        if (options.infinitePageSize) {
	            console.warn('ag-grid: since version 9.0.x infinitePageSize is now called cacheBlockSize');
	        }
	        if (options.infiniteBlockSize) {
	            console.warn('ag-grid: since version 10.0.x infiniteBlockSize is now called cacheBlockSize');
	        }
	        if (options.maxPagesInCache) {
	            console.warn('ag-grid: since version 10.0.x maxPagesInCache is now called maxBlocksInCache');
	        }
	        if (options.paginationOverflowSize) {
	            console.warn('ag-grid: since version 10.0.x paginationOverflowSize is now called cacheOverflowSize');
	        }
	        // if (options.forPrint) {
	        //     console.warn('ag-grid: since version 10.1.x, use property domLayout="forPrint" instead of forPrint=true');
	        // }
	        if (options.suppressMenuFilterPanel) {
	            console.warn("ag-grid: since version 11.0.x, use property colDef.menuTabs=['generalMenuTab','columnsMenuTab'] instead of suppressMenuFilterPanel=true");
	        }
	        if (options.suppressMenuMainPanel) {
	            console.warn("ag-grid: since version 11.0.x, use property colDef.menuTabs=['filterMenuTab','columnsMenuTab'] instead of suppressMenuMainPanel=true");
	        }
	        if (options.suppressMenuColumnPanel) {
	            console.warn("ag-grid: since version 11.0.x, use property colDef.menuTabs=['generalMenuTab','filterMenuTab'] instead of suppressMenuColumnPanel=true");
	        }
	        if (options.suppressUseColIdForGroups) {
	            console.warn("ag-grid: since version 11.0.x, this is not in use anymore. You should be able to remove it from your definition");
	        }
	        if (options.groupSuppressRow) {
	            console.warn("ag-grid: since version 18.2.x, 'groupSuppressRow' should not be used anymore. Instead remove row groups and perform custom sorting.");
	        }
	        if (options.groupColumnDef) {
	            console.warn("ag-grid: since version 11.0.x, groupColumnDef has been renamed, this property is now called autoGroupColumnDef. Please change your configuration accordingly");
	        }
	        if (options.slaveGrids) {
	            console.warn("ag-grid: since version 12.x, slaveGrids has been renamed, this property is now called alignedGrids. Please change your configuration accordingly");
	        }
	        if (options.floatingTopRowData) {
	            console.warn("ag-grid: since version 12.x, floatingTopRowData is now called pinnedTopRowData");
	        }
	        if (options.floatingBottomRowData) {
	            console.warn("ag-grid: since version 12.x, floatingBottomRowData is now called pinnedBottomRowData");
	        }
	        if (options.paginationStartPage) {
	            console.warn("ag-grid: since version 12.x, paginationStartPage is gone, please call api.paginationGoToPage(" + options.paginationStartPage + ") instead.");
	        }
	        if (options.getHeaderCellTemplate) {
	            console.warn("ag-grid: since version 15.x, getHeaderCellTemplate is gone, please check the header documentation on how to set header templates.");
	        }
	        if (options.headerCellTemplate) {
	            console.warn("ag-grid: since version 15.x, headerCellTemplate is gone, please check the header documentation on how to set header templates.");
	        }
	        if (options.headerCellRenderer) {
	            console.warn("ag-grid: since version 15.x, headerCellRenderer is gone, please check the header documentation on how to set header templates.");
	        }
	        if (options.angularCompileHeaders) {
	            console.warn("ag-grid: since version 15.x, angularCompileHeaders is gone, please see the getting started for Angular 1 docs to see how to do headers in Angular 1.x.");
	        }
	        if (options.pivotTotals) {
	            console.warn("ag-grid: since version 18.x, pivotTotals has been removed, instead if using pivotTotals, set pivotColumnGroupTotals='before'|'after'.");
	            options.pivotColumnGroupTotals = 'before';
	        }
	        if (options.rowModelType === 'inMemory') {
	            console.warn("ag-grid: since version 18.x, The In Memory Row Model has been renamed to the Client Side Row Model, set rowModelType='clientSide' instead.");
	            options.rowModelType = 'clientSide';
	        }
	        if (options.rowModelType === 'enterprise') {
	            console.warn("ag-grid: since version 18.x, The Enterprise Row Model has been renamed to the Server Side Row Model, set rowModelType='serverSide' instead.");
	            options.rowModelType = 'serverSide';
	        }
	        if (options.layoutInterval) {
	            console.warn("ag-grid: since version 18.x, layoutInterval is no longer a property. This is because the grid now uses CSS Flex for layout.");
	        }
	        if (options.gridAutoHeight) {
	            console.warn("ag-grid: since version 19.x, gridAutoHeight is gone, please use domLayout=autoHeight instead");
	            options.domLayout = 'autoHeight';
	        }
	        if (options.showToolPanel === true) {
	            console.warn("ag-grid: since version 19.x, showToolPanel is gone, please specify toolPanel components. See https://www.ag-grid.com/javascript-grid-tool-panel/");
	            options.showToolPanel = undefined;
	            options.sideBar = options.sideBar || true;
	        }
	        if (options.showToolPanel === false) {
	            console.warn("ag-grid: since version 19.x, showToolPanel is gone, please specify toolPanel components. See https://www.ag-grid.com/javascript-grid-tool-panel/");
	            options.showToolPanel = undefined;
	            options.sideBar = options.sideBar || false;
	        }
	        var oldToolPanelProperties = {
	            toolPanelSuppressRowGroups: 'suppressRowGroups',
	            toolPanelSuppressValues: 'suppressValues',
	            toolPanelSuppressPivots: 'suppressPivots',
	            toolPanelSuppressPivotMode: 'suppressPivotMode',
	            toolPanelSuppressColumnFilter: 'suppressColumnFilter',
	            toolPanelSuppressColumnSelectAll: 'suppressColumnSelectAll',
	            toolPanelSuppressSideButtons: 'suppressSideButtons',
	            toolPanelSuppressColumnExpandAll: 'suppressColumnExpandAll',
	            contractColumnSelection: 'contractColumnSelection'
	        };
	        var toolPanelColumnsCompProps = {};
	        Object.keys(oldToolPanelProperties).forEach(function (key) {
	            var translation = oldToolPanelProperties[key];
	            var value = _this.gridOptions[key];
	            if (value !== undefined) {
	                if (key === 'toolPanelSuppressSideButtons') {
	                    console.warn('ag-grid: since v19.0 toolPanelSuppressSideButtons has been completely removed. See https://www.ag-grid.com/javascript-grid-tool-panel/');
	                    return;
	                }
	                console.warn("ag-grid: since v19.0 gridOptions." + key + " is deprecated, please use gridOptions.sideBar.toolPanel[columnsIndex].componentParams." + translation);
	                toolPanelColumnsCompProps[translation] = value;
	            }
	        });
	        if (Object.keys(toolPanelColumnsCompProps).length > 0 && !utils_1._.exists(options.sideBar)) {
	            console.warn("ag-grid: since version 19.x, sideBar is mandatory if using toolPanel related properties. See https://www.ag-grid.com/javascript-grid-tool-panel/");
	            options.sideBar = true;
	        }
	        if (options.sideBar != null) {
	            options.sideBar = sideBar_1.SideBarDefParser.parse(options.sideBar);
	        }
	        var sideBarDef = this.gridOptions.sideBar;
	        if (Object.keys(toolPanelColumnsCompProps).length > 0 && sideBarDef && sideBarDef.toolPanels) {
	            var columnsDef = (sideBarDef.toolPanels.filter(function (it) { return it.id === 'columns'; }));
	            if (columnsDef.length === 1) {
	                utils_1._.mergeDeep(columnsDef[0], {
	                    componentParams: toolPanelColumnsCompProps
	                });
	            }
	        }
	        if (options.enableStatusBar) {
	            console.warn("ag-grid: since version 19.x, enableStatusBar is gone, please specify statusBar components");
	            options.statusBar = options.statusBar ||
	                {
	                    components: [{ component: 'agAggregationComponent' }]
	                };
	        }
	        if (options.alwaysShowStatusBar) {
	            console.warn("ag-grid: since version 19.x, alwaysShowStatusBar is gone. Please specify a min-height on the ag-status-bar css class, eg .ag-status-bar {min-height: 35px; }");
	        }
	        if (options.enableServerSideSorting || options.enableSorting) {
	            console.warn("ag-Grid: since v20, grid options enableSorting and enableServerSideSorting are gone. Instead set sortable=true on the column definition for the columns sorting are allowed on. To migrate from gridOption.enableSorting=true, set gridOptions.defaultColDef.sortable=true");
	            if (!options.defaultColDef) {
	                options.defaultColDef = {};
	            }
	            if (!options.defaultColDef.sortable) {
	                options.defaultColDef.sortable = true;
	            }
	        }
	        if (options.enableFilter || options.enableServerSideFilter) {
	            console.warn("ag-Grid: since v20, grid options enableFilter and enableServerSideFilter are gone. Instead set filter=true (if not already specifying a specific filter) on the column definition for the columns filtering is allowed on. To migrate from gridOptions.enableFilter=true, set gridOptions.defaultColDef.filter=true. If you are explicitly setting specific filters for each column (ie colDef.filter is already set) the you don't need to do anything.");
	            if (!options.defaultColDef) {
	                options.defaultColDef = {};
	            }
	            if (!options.defaultColDef.filter) {
	                options.defaultColDef.filter = true;
	            }
	        }
	        if (options.enableColResize) {
	            console.warn("ag-Grid: since v20, grid options enableColResize is gone. Instead set resizable=true on the column definition for the columns resizing are allowed on. To migrate from gridOption.enableColResize=true, set gridOptions.defaultColDef.resizable=true");
	            if (!options.defaultColDef) {
	                options.defaultColDef = {};
	            }
	            if (!options.defaultColDef.resizable) {
	                options.defaultColDef.resizable = true;
	            }
	        }
	        if (options.deprecatedEmbedFullWidthRows) {
	            console.warn("ag-Grid: since v21.2, deprecatedEmbedFullWidthRows has been replaced with embedFullWidthRows.");
	        }
	        if (options.suppressTabbing) {
	            console.warn("ag-Grid: since v20.1, suppressTabbing is replaced with the more powerful grid callback suppressKeyboardEvent(params) which can suppress any keyboard event including tabbing.");
	        }
	        if (options.doesDataFlower) {
	            console.warn('ag-Grid: since v21.1, doesDataFlower is deprecated. Master/Detail is the new way for showing child data for a row and was introduced over a year ago. Please migrate your code to use master/detail instead.');
	        }
	    };
	    GridOptionsWrapper.prototype.checkForViolations = function () {
	        if (this.isTreeData()) {
	            this.treeDataViolations();
	        }
	    };
	    GridOptionsWrapper.prototype.treeDataViolations = function () {
	        if (this.isRowModelDefault()) {
	            if (utils_1._.missing(this.getDataPathFunc())) {
	                console.warn('ag-Grid: property usingTreeData=true with rowModel=clientSide, but you did not ' +
	                    'provide getDataPath function, please provide getDataPath function if using tree data.');
	            }
	        }
	        if (this.isRowModelServerSide()) {
	            if (utils_1._.missing(this.getIsServerSideGroupFunc())) {
	                console.warn('ag-Grid: property usingTreeData=true with rowModel=serverSide, but you did not ' +
	                    'provide isServerSideGroup function, please provide isServerSideGroup function if using tree data.');
	            }
	            if (utils_1._.missing(this.getServerSideGroupKeyFunc())) {
	                console.warn('ag-Grid: property usingTreeData=true with rowModel=serverSide, but you did not ' +
	                    'provide getServerSideGroupKey function, please provide getServerSideGroupKey function if using tree data.');
	            }
	        }
	    };
	    GridOptionsWrapper.prototype.getLocaleTextFunc = function () {
	        if (this.gridOptions.localeTextFunc) {
	            return this.gridOptions.localeTextFunc;
	        }
	        var that = this;
	        return function (key, defaultValue) {
	            var localeText = that.gridOptions.localeText;
	            if (localeText && localeText[key]) {
	                return localeText[key];
	            }
	            return defaultValue;
	        };
	    };
	    // responsible for calling the onXXX functions on gridOptions
	    GridOptionsWrapper.prototype.globalEventHandler = function (eventName, event) {
	        var callbackMethodName = componentUtil_1.ComponentUtil.getCallbackForEvent(eventName);
	        if (typeof this.gridOptions[callbackMethodName] === 'function') {
	            this.gridOptions[callbackMethodName](event);
	        }
	    };
	    // we don't allow dynamic row height for virtual paging
	    GridOptionsWrapper.prototype.getRowHeightAsNumber = function () {
	        if (!this.gridOptions.rowHeight || utils_1._.missing(this.gridOptions.rowHeight)) {
	            return this.getDefaultRowHeight();
	        }
	        else if (this.gridOptions.rowHeight && this.isNumeric(this.gridOptions.rowHeight)) {
	            return this.gridOptions.rowHeight;
	        }
	        console.warn('ag-Grid row height must be a number if not using standard row model');
	        return this.getDefaultRowHeight();
	    };
	    GridOptionsWrapper.prototype.getRowHeightForNode = function (rowNode, allowEstimate) {
	        // check the function first, in case use set both function and
	        // number, when using virtual pagination then function can be
	        // used for pinned rows and the number for the body rows.
	        if (allowEstimate === void 0) { allowEstimate = false; }
	        if (typeof this.gridOptions.getRowHeight === 'function') {
	            if (allowEstimate) {
	                return { height: this.getDefaultRowHeight(), estimated: true };
	            }
	            var params = {
	                node: rowNode,
	                data: rowNode.data,
	                api: this.gridOptions.api,
	                context: this.gridOptions.context
	            };
	            return { height: this.gridOptions.getRowHeight(params), estimated: false };
	        }
	        else if (rowNode.detail && this.isMasterDetail()) {
	            if (this.isNumeric(this.gridOptions.detailRowHeight)) {
	                return { height: this.gridOptions.detailRowHeight, estimated: false };
	            }
	            else {
	                return { height: DEFAULT_DETAIL_ROW_HEIGHT, estimated: false };
	            }
	        }
	        var defaultRowHeight = this.getDefaultRowHeight();
	        var rowHeight = this.gridOptions.rowHeight && this.isNumeric(this.gridOptions.rowHeight) ?
	            this.gridOptions.rowHeight : defaultRowHeight;
	        var minRowHeight = Math.min(defaultRowHeight, rowHeight);
	        if (this.columnController.isAutoRowHeightActive()) {
	            if (allowEstimate) {
	                return { height: rowHeight, estimated: true };
	            }
	            var autoHeight = this.autoHeightCalculator.getPreferredHeightForRow(rowNode);
	            // never return less than the default row height - covers when auto height
	            // cells are blank.
	            return { height: Math.max(autoHeight, minRowHeight), estimated: false };
	        }
	        return { height: rowHeight, estimated: false };
	    };
	    GridOptionsWrapper.prototype.isDynamicRowHeight = function () {
	        return typeof this.gridOptions.getRowHeight === 'function';
	    };
	    GridOptionsWrapper.prototype.getVirtualItemHeight = function () {
	        return this.specialForNewMaterial(20, 'virtualItemHeight');
	    };
	    GridOptionsWrapper.prototype.isNumeric = function (value) {
	        return !isNaN(value) && typeof value === 'number';
	    };
	    // Material data table has strict guidelines about whitespace, and these values are different than the ones
	    // ag-grid uses by default. We override the default ones for the sake of making it better out of the box
	    GridOptionsWrapper.prototype.specialForNewMaterial = function (defaultValue, sassVariableName) {
	        var theme = this.environment.getTheme().theme;
	        if (theme && theme.indexOf('ag-theme') === 0) {
	            return this.environment.getSassVariable(theme, sassVariableName);
	        }
	        return defaultValue;
	    };
	    GridOptionsWrapper.prototype.getDefaultRowHeight = function () {
	        return this.specialForNewMaterial(DEFAULT_ROW_HEIGHT, 'rowHeight');
	    };
	    var GridOptionsWrapper_1;
	    GridOptionsWrapper.MIN_COL_WIDTH = 10;
	    GridOptionsWrapper.PROP_HEADER_HEIGHT = 'headerHeight';
	    GridOptionsWrapper.PROP_GROUP_REMOVE_SINGLE_CHILDREN = 'groupRemoveSingleChildren';
	    GridOptionsWrapper.PROP_GROUP_REMOVE_LOWEST_SINGLE_CHILDREN = 'groupRemoveLowestSingleChildren';
	    GridOptionsWrapper.PROP_PIVOT_HEADER_HEIGHT = 'pivotHeaderHeight';
	    GridOptionsWrapper.PROP_SUPPRESS_CLIPBOARD_PASTE = 'suppressClipboardPaste';
	    GridOptionsWrapper.PROP_GROUP_HEADER_HEIGHT = 'groupHeaderHeight';
	    GridOptionsWrapper.PROP_PIVOT_GROUP_HEADER_HEIGHT = 'pivotGroupHeaderHeight';
	    GridOptionsWrapper.PROP_FLOATING_FILTERS_HEIGHT = 'floatingFiltersHeight';
	    GridOptionsWrapper.PROP_SUPPRESS_ROW_DRAG = 'suppressRowDrag';
	    GridOptionsWrapper.PROP_POPUP_PARENT = 'popupParent';
	    GridOptionsWrapper.PROP_DOM_LAYOUT = 'domLayout';
	    __decorate([
	        context_1.Autowired('gridOptions'),
	        __metadata("design:type", Object)
	    ], GridOptionsWrapper.prototype, "gridOptions", void 0);
	    __decorate([
	        context_1.Autowired('columnController'),
	        __metadata("design:type", columnController_1.ColumnController)
	    ], GridOptionsWrapper.prototype, "columnController", void 0);
	    __decorate([
	        context_1.Autowired('eventService'),
	        __metadata("design:type", eventService_1.EventService)
	    ], GridOptionsWrapper.prototype, "eventService", void 0);
	    __decorate([
	        context_1.Autowired('enterprise'),
	        __metadata("design:type", Boolean)
	    ], GridOptionsWrapper.prototype, "enterprise", void 0);
	    __decorate([
	        context_1.Autowired('gridApi'),
	        __metadata("design:type", gridApi_1.GridApi)
	    ], GridOptionsWrapper.prototype, "gridApi", void 0);
	    __decorate([
	        context_1.Autowired('columnApi'),
	        __metadata("design:type", columnApi_1.ColumnApi)
	    ], GridOptionsWrapper.prototype, "columnApi", void 0);
	    __decorate([
	        context_1.Autowired('environment'),
	        __metadata("design:type", environment_1.Environment)
	    ], GridOptionsWrapper.prototype, "environment", void 0);
	    __decorate([
	        context_1.Autowired('autoHeightCalculator'),
	        __metadata("design:type", autoHeightCalculator_1.AutoHeightCalculator)
	    ], GridOptionsWrapper.prototype, "autoHeightCalculator", void 0);
	    __decorate([
	        context_1.Autowired('context'),
	        __metadata("design:type", context_1.Context)
	    ], GridOptionsWrapper.prototype, "context", void 0);
	    __decorate([
	        __param(0, context_1.Qualifier('gridApi')), __param(1, context_1.Qualifier('columnApi')),
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", [gridApi_1.GridApi, columnApi_1.ColumnApi]),
	        __metadata("design:returntype", void 0)
	    ], GridOptionsWrapper.prototype, "agWire", null);
	    __decorate([
	        context_1.PreDestroy,
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", []),
	        __metadata("design:returntype", void 0)
	    ], GridOptionsWrapper.prototype, "destroy", null);
	    __decorate([
	        context_1.PostConstruct,
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", []),
	        __metadata("design:returntype", void 0)
	    ], GridOptionsWrapper.prototype, "init", null);
	    GridOptionsWrapper = GridOptionsWrapper_1 = __decorate([
	        context_1.Bean('gridOptionsWrapper')
	    ], GridOptionsWrapper);
	    return GridOptionsWrapper;
	}());
	exports.GridOptionsWrapper = GridOptionsWrapper;


/***/ }),
/* 2325 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	Object.defineProperty(exports, "__esModule", { value: true });
	__export(__webpack_require__(2326));
	__export(__webpack_require__(2327));
	__export(__webpack_require__(2329));
	__export(__webpack_require__(2330));


/***/ }),
/* 2326 */
/***/ (function(module, exports) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Color = /** @class */ (function () {
	    /**
	     * Every color component should be in the [0, 1] range.
	     * Some easing functions (such as elastic easing) can overshoot the target value by some amount.
	     * So, when animating colors, if the source or target color components are already near
	     * or at the edge of the allowed [0, 1] range, it is possible for the intermediate color
	     * component value to end up outside of that range mid-animation. For this reason the constructor
	     * performs range checking/constraining.
	     * @param r Red component.
	     * @param g Green component.
	     * @param b Blue component.
	     * @param a Alpha (opacity) component.
	     */
	    function Color(r, g, b, a) {
	        if (a === void 0) { a = 1; }
	        // NaN is treated as 0.
	        this.r = Math.min(1, Math.max(0, r || 0));
	        this.g = Math.min(1, Math.max(0, g || 0));
	        this.b = Math.min(1, Math.max(0, b || 0));
	        this.a = Math.min(1, Math.max(0, a || 0));
	    }
	    /**
	     * The given string can be in one of the following formats:
	     * - #rgb
	     * - #rrggbb
	     * - rgb(r, g, b)
	     * - rgba(r, g, b, a)
	     * - CSS color name such as 'white', 'orange', 'cyan', etc.
	     * @param str
	     */
	    Color.fromString = function (str) {
	        // hexadecimal notation
	        if (str.indexOf('#') >= 0) { // there can be some leading whitespace
	            return Color.fromHexString(str);
	        }
	        // color name
	        var hex = Color.nameToHex[str];
	        if (hex) {
	            return Color.fromHexString(hex);
	        }
	        // rgb(a) notation
	        if (str.indexOf('rgb') >= 0) {
	            return Color.fromRgbaString(str);
	        }
	        throw new Error("Invalid color string: '" + str + "'");
	    };
	    // Using separate RegExp for the short hex notation because strings like `#abcd`
	    // are matched as ['#abcd', 'ab', 'c', 'd', undefined] when the `{1,2}` quantifier is used.
	    Color.fromHexString = function (str) {
	        var values = str.match(Color.hexRe);
	        if (values) {
	            var r = parseInt(values[1], 16);
	            var g = parseInt(values[2], 16);
	            var b = parseInt(values[3], 16);
	            var a = values[4] !== undefined ? parseInt(values[4], 16) : 255;
	            return new Color(r / 255, g / 255, b / 255, a / 255);
	        }
	        values = str.match(Color.shortHexRe);
	        if (values) {
	            var r = parseInt(values[1], 16);
	            var g = parseInt(values[2], 16);
	            var b = parseInt(values[3], 16);
	            var a = values[4] !== undefined ? parseInt(values[4], 16) : 15;
	            r += r * 16;
	            g += g * 16;
	            b += b * 16;
	            a += a * 16;
	            return new Color(r / 255, g / 255, b / 255, a / 255);
	        }
	        throw new Error("Malformed hexadecimal color string: '" + str + "'");
	    };
	    Color.fromRgbaString = function (str) {
	        var values = str.match(Color.rgbRe);
	        if (values) {
	            return new Color(+values[1] / 255, +values[2] / 255, +values[3] / 255);
	        }
	        values = str.match(Color.rgbaRe);
	        if (values) {
	            return new Color(+values[1] / 255, +values[2] / 255, +values[3] / 255, +values[4]);
	        }
	        throw new Error("Malformed rgb/rgba color string: '" + str + "'");
	    };
	    Color.fromArray = function (arr) {
	        if (arr.length === 4) {
	            return new Color(arr[0], arr[1], arr[2], arr[3]);
	        }
	        if (arr.length === 3) {
	            return new Color(arr[0], arr[1], arr[2]);
	        }
	        throw new Error('The given array should contain 3 or 4 color components (numbers).');
	    };
	    Color.fromHSB = function (h, s, b, alpha) {
	        if (alpha === void 0) { alpha = 1; }
	        var rgb = Color.HSBtoRGB(h, s, b);
	        return new Color(rgb[0], rgb[1], rgb[2], alpha);
	    };
	    Color.padHex = function (str) {
	        // Can't use `padStart(2, '0')` here because of IE.
	        return str.length === 1 ? '0' + str : str;
	    };
	    Color.prototype.toHexString = function () {
	        var hex = '#'
	            + Color.padHex(Math.round(this.r * 255).toString(16))
	            + Color.padHex(Math.round(this.g * 255).toString(16))
	            + Color.padHex(Math.round(this.b * 255).toString(16));
	        if (this.a < 1) {
	            hex += Color.padHex(Math.round(this.a * 255).toString(16));
	        }
	        return hex;
	    };
	    Color.prototype.toRgbaString = function (fractionDigits) {
	        if (fractionDigits === void 0) { fractionDigits = 3; }
	        var components = [
	            Math.round(this.r * 255),
	            Math.round(this.g * 255),
	            Math.round(this.b * 255)
	        ];
	        var k = Math.pow(10, fractionDigits);
	        if (this.a !== 1) {
	            components.push(Math.round(this.a * k) / k);
	            return "rgba(" + components.join(', ') + ")";
	        }
	        return "rgb(" + components.join(', ') + ")";
	    };
	    Color.prototype.toString = function () {
	        if (this.a === 1) {
	            return this.toHexString();
	        }
	        return this.toRgbaString();
	    };
	    Color.prototype.toHSB = function () {
	        return Color.RGBtoHSB(this.r, this.g, this.b);
	    };
	    /**
	     * Converts the given RGB triple to an array of HSB (HSV) components.
	     * The hue component will be `NaN` for achromatic colors.
	     */
	    Color.RGBtoHSB = function (r, g, b) {
	        var min = Math.min(r, g, b);
	        var max = Math.max(r, g, b);
	        var S = max !== 0 ? (max - min) / max : 0;
	        var H = NaN;
	        // min == max, means all components are the same
	        // and the color is a shade of gray with no hue (H is NaN)
	        if (min !== max) {
	            var delta = max - min;
	            var rc = (max - r) / delta;
	            var gc = (max - g) / delta;
	            var bc = (max - b) / delta;
	            if (r === max) {
	                H = bc - gc;
	            }
	            else if (g === max) {
	                H = 2.0 + rc - bc;
	            }
	            else {
	                H = 4.0 + gc - rc;
	            }
	            H /= 6.0;
	            if (H < 0) {
	                H = H + 1.0;
	            }
	        }
	        return [H * 360, S, max];
	    };
	    /**
	     * Converts the given HSB (HSV) triple to an array of RGB components.
	     */
	    Color.HSBtoRGB = function (H, S, B) {
	        if (isNaN(H)) {
	            H = 0;
	        }
	        H = (((H % 360) + 360) % 360) / 360; // normalize hue to [0, 360] interval, then scale to [0, 1]
	        var r = 0;
	        var g = 0;
	        var b = 0;
	        if (S === 0) {
	            r = g = b = B;
	        }
	        else {
	            var h = (H - Math.floor(H)) * 6;
	            var f = h - Math.floor(h);
	            var p = B * (1 - S);
	            var q = B * (1 - S * f);
	            var t = B * (1 - (S * (1 - f)));
	            switch (h >> 0) { // discard the floating point part of the number
	                case 0:
	                    r = B;
	                    g = t;
	                    b = p;
	                    break;
	                case 1:
	                    r = q;
	                    g = B;
	                    b = p;
	                    break;
	                case 2:
	                    r = p;
	                    g = B;
	                    b = t;
	                    break;
	                case 3:
	                    r = p;
	                    g = q;
	                    b = B;
	                    break;
	                case 4:
	                    r = t;
	                    g = p;
	                    b = B;
	                    break;
	                case 5:
	                    r = B;
	                    g = p;
	                    b = q;
	                    break;
	            }
	        }
	        return [r, g, b];
	    };
	    Color.prototype.derive = function (hueShift, saturationFactor, brightnessFactor, opacityFactor) {
	        var hsb = Color.RGBtoHSB(this.r, this.g, this.b);
	        var b = hsb[2];
	        if (b == 0 && brightnessFactor > 1.0) {
	            b = 0.05;
	        }
	        var h = (((hsb[0] + hueShift) % 360) + 360) % 360;
	        var s = Math.max(Math.min(hsb[1] * saturationFactor, 1.0), 0.0);
	        b = Math.max(Math.min(b * brightnessFactor, 1.0), 0.0);
	        var a = Math.max(Math.min(this.a * opacityFactor, 1.0), 0.0);
	        var rgba = Color.HSBtoRGB(h, s, b);
	        rgba.push(a);
	        return Color.fromArray(rgba);
	    };
	    Color.prototype.brighter = function () {
	        return this.derive(0, 1.0, 1.0 / 0.7, 1.0);
	    };
	    Color.prototype.darker = function () {
	        return this.derive(0, 1.0, 0.7, 1.0);
	    };
	    // See https://drafts.csswg.org/css-color/#hex-notation
	    Color.hexRe = /\s*#([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})?\s*$/;
	    Color.shortHexRe = /\s*#([0-9a-fA-F])([0-9a-fA-F])([0-9a-fA-F])([0-9a-fA-F])?\s*$/;
	    Color.rgbRe = /\s*rgb\((\d+),\s*(\d+),\s*(\d+)\)\s*/;
	    Color.rgbaRe = /\s*rgba\((\d+),\s*(\d+),\s*(\d+),\s*([.\d]+)\)\s*/;
	    /**
	     * CSS Color Module Level 4:
	     * https://drafts.csswg.org/css-color/#named-colors
	     */
	    Color.nameToHex = Object.freeze({
	        aliceblue: '#F0F8FF',
	        antiquewhite: '#FAEBD7',
	        aqua: '#00FFFF',
	        aquamarine: '#7FFFD4',
	        azure: '#F0FFFF',
	        beige: '#F5F5DC',
	        bisque: '#FFE4C4',
	        black: '#000000',
	        blanchedalmond: '#FFEBCD',
	        blue: '#0000FF',
	        blueviolet: '#8A2BE2',
	        brown: '#A52A2A',
	        burlywood: '#DEB887',
	        cadetblue: '#5F9EA0',
	        chartreuse: '#7FFF00',
	        chocolate: '#D2691E',
	        coral: '#FF7F50',
	        cornflowerblue: '#6495ED',
	        cornsilk: '#FFF8DC',
	        crimson: '#DC143C',
	        cyan: '#00FFFF',
	        darkblue: '#00008B',
	        darkcyan: '#008B8B',
	        darkgoldenrod: '#B8860B',
	        darkgray: '#A9A9A9',
	        darkgreen: '#006400',
	        darkgrey: '#A9A9A9',
	        darkkhaki: '#BDB76B',
	        darkmagenta: '#8B008B',
	        darkolivegreen: '#556B2F',
	        darkorange: '#FF8C00',
	        darkorchid: '#9932CC',
	        darkred: '#8B0000',
	        darksalmon: '#E9967A',
	        darkseagreen: '#8FBC8F',
	        darkslateblue: '#483D8B',
	        darkslategray: '#2F4F4F',
	        darkslategrey: '#2F4F4F',
	        darkturquoise: '#00CED1',
	        darkviolet: '#9400D3',
	        deeppink: '#FF1493',
	        deepskyblue: '#00BFFF',
	        dimgray: '#696969',
	        dimgrey: '#696969',
	        dodgerblue: '#1E90FF',
	        firebrick: '#B22222',
	        floralwhite: '#FFFAF0',
	        forestgreen: '#228B22',
	        fuchsia: '#FF00FF',
	        gainsboro: '#DCDCDC',
	        ghostwhite: '#F8F8FF',
	        gold: '#FFD700',
	        goldenrod: '#DAA520',
	        gray: '#808080',
	        green: '#008000',
	        greenyellow: '#ADFF2F',
	        grey: '#808080',
	        honeydew: '#F0FFF0',
	        hotpink: '#FF69B4',
	        indianred: '#CD5C5C',
	        indigo: '#4B0082',
	        ivory: '#FFFFF0',
	        khaki: '#F0E68C',
	        lavender: '#E6E6FA',
	        lavenderblush: '#FFF0F5',
	        lawngreen: '#7CFC00',
	        lemonchiffon: '#FFFACD',
	        lightblue: '#ADD8E6',
	        lightcoral: '#F08080',
	        lightcyan: '#E0FFFF',
	        lightgoldenrodyellow: '#FAFAD2',
	        lightgray: '#D3D3D3',
	        lightgreen: '#90EE90',
	        lightgrey: '#D3D3D3',
	        lightpink: '#FFB6C1',
	        lightsalmon: '#FFA07A',
	        lightseagreen: '#20B2AA',
	        lightskyblue: '#87CEFA',
	        lightslategray: '#778899',
	        lightslategrey: '#778899',
	        lightsteelblue: '#B0C4DE',
	        lightyellow: '#FFFFE0',
	        lime: '#00FF00',
	        limegreen: '#32CD32',
	        linen: '#FAF0E6',
	        magenta: '#FF00FF',
	        maroon: '#800000',
	        mediumaquamarine: '#66CDAA',
	        mediumblue: '#0000CD',
	        mediumorchid: '#BA55D3',
	        mediumpurple: '#9370DB',
	        mediumseagreen: '#3CB371',
	        mediumslateblue: '#7B68EE',
	        mediumspringgreen: '#00FA9A',
	        mediumturquoise: '#48D1CC',
	        mediumvioletred: '#C71585',
	        midnightblue: '#191970',
	        mintcream: '#F5FFFA',
	        mistyrose: '#FFE4E1',
	        moccasin: '#FFE4B5',
	        navajowhite: '#FFDEAD',
	        navy: '#000080',
	        oldlace: '#FDF5E6',
	        olive: '#808000',
	        olivedrab: '#6B8E23',
	        orange: '#FFA500',
	        orangered: '#FF4500',
	        orchid: '#DA70D6',
	        palegoldenrod: '#EEE8AA',
	        palegreen: '#98FB98',
	        paleturquoise: '#AFEEEE',
	        palevioletred: '#DB7093',
	        papayawhip: '#FFEFD5',
	        peachpuff: '#FFDAB9',
	        peru: '#CD853F',
	        pink: '#FFC0CB',
	        plum: '#DDA0DD',
	        powderblue: '#B0E0E6',
	        purple: '#800080',
	        rebeccapurple: '#663399',
	        red: '#FF0000',
	        rosybrown: '#BC8F8F',
	        royalblue: '#4169E1',
	        saddlebrown: '#8B4513',
	        salmon: '#FA8072',
	        sandybrown: '#F4A460',
	        seagreen: '#2E8B57',
	        seashell: '#FFF5EE',
	        sienna: '#A0522D',
	        silver: '#C0C0C0',
	        skyblue: '#87CEEB',
	        slateblue: '#6A5ACD',
	        slategray: '#708090',
	        slategrey: '#708090',
	        snow: '#FFFAFA',
	        springgreen: '#00FF7F',
	        steelblue: '#4682B4',
	        tan: '#D2B48C',
	        teal: '#008080',
	        thistle: '#D8BFD8',
	        tomato: '#FF6347',
	        turquoise: '#40E0D0',
	        violet: '#EE82EE',
	        wheat: '#F5DEB3',
	        white: '#FFFFFF',
	        whitesmoke: '#F5F5F5',
	        yellow: '#FFFF00',
	        yellowgreen: '#9ACD32'
	    });
	    return Color;
	}());
	exports.Color = Color;


/***/ }),
/* 2327 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var constants_1 = __webpack_require__(2328);
	var FUNCTION_STRIP_COMMENTS = /((\/\/.*$)|(\/\*[\s\S]*?\*\/))/mg;
	var FUNCTION_ARGUMENT_NAMES = /([^\s,]+)/g;
	var AG_GRID_STOP_PROPAGATION = '__ag_Grid_Stop_Propagation';
	/**
	 * HTML Escapes.
	 */
	var HTML_ESCAPES = {
	    '&': '&amp;',
	    '<': '&lt;',
	    '>': '&gt;',
	    '"': '&quot;',
	    "'": '&#39;'
	};
	var reUnescapedHtml = /[&<>"']/g;
	var Utils = /** @class */ (function () {
	    function Utils() {
	    }
	    /**
	     * When in IE or Edge, when you are editing a cell, then click on another cell,
	     * the other cell doesn't keep focus, so navigation keys, type to start edit etc
	     * don't work. appears that when you update the dom in IE it looses focus
	     * https://ag-grid.com/forum/showthread.php?tid=4362
	     * @param {HTMLElement} el
	     */
	    Utils.doIeFocusHack = function (el) {
	        if (exports._.isBrowserIE() || exports._.isBrowserEdge()) {
	            if (exports._.missing(document.activeElement) || document.activeElement === document.body) {
	                // console.log('missing focus');
	                el.focus();
	            }
	        }
	    };
	    /**
	     * If the key was passed before, then doesn't execute the func
	     * @param {Function} func
	     * @param {string} key
	     */
	    Utils.doOnce = function (func, key) {
	        if (this.doOnceFlags[key]) {
	            return;
	        }
	        func();
	        this.doOnceFlags[key] = true;
	    };
	    /**
	     * Checks if event was issued by a left click
	     * from https://stackoverflow.com/questions/3944122/detect-left-mouse-button-press
	     * @param {MouseEvent} mouseEvent
	     * @returns {boolean}
	     */
	    Utils.isLeftClick = function (mouseEvent) {
	        if ("buttons" in mouseEvent) {
	            return mouseEvent.buttons == 1;
	        }
	        var button = mouseEvent.which || mouseEvent.button;
	        return button == 1;
	    };
	    /**
	     * `True` if the event is close to the original event by X pixels either vertically or horizontally.
	     * we only start dragging after X pixels so this allows us to know if we should start dragging yet.
	     * @param {MouseEvent | TouchEvent} e1
	     * @param {MouseEvent | TouchEvent} e2
	     * @param {number} pixelCount
	     * @returns {boolean}
	     */
	    Utils.areEventsNear = function (e1, e2, pixelCount) {
	        // by default, we wait 4 pixels before starting the drag
	        if (pixelCount === 0) {
	            return false;
	        }
	        var diffX = Math.abs(e1.clientX - e2.clientX);
	        var diffY = Math.abs(e1.clientY - e2.clientY);
	        return Math.max(diffX, diffY) <= pixelCount;
	    };
	    Utils.jsonEquals = function (val1, val2) {
	        var val1Json = val1 ? JSON.stringify(val1) : null;
	        var val2Json = val2 ? JSON.stringify(val2) : null;
	        var res = val1Json === val2Json;
	        return res;
	    };
	    Utils.shallowCompare = function (arr1, arr2) {
	        // if both are missing, then they are the same
	        if (this.missing(arr1) && this.missing(arr2)) {
	            return true;
	        }
	        // if one is present, but other is missing, then then are different
	        if (this.missing(arr1) || this.missing(arr2)) {
	            return false;
	        }
	        if (arr1.length !== arr2.length) {
	            return false;
	        }
	        for (var i = 0; i < arr1.length; i++) {
	            if (arr1[i] !== arr2[i]) {
	                return false;
	            }
	        }
	        return true;
	    };
	    Utils.getNameOfClass = function (TheClass) {
	        var funcNameRegex = /function (.{1,})\(/;
	        var funcAsString = TheClass.toString();
	        var results = (funcNameRegex).exec(funcAsString);
	        return (results && results.length > 1) ? results[1] : "";
	    };
	    Utils.values = function (object) {
	        var result = [];
	        this.iterateObject(object, function (key, value) {
	            result.push(value);
	        });
	        return result;
	    };
	    Utils.getValueUsingField = function (data, field, fieldContainsDots) {
	        if (!field || !data) {
	            return;
	        }
	        // if no '.', then it's not a deep value
	        if (!fieldContainsDots) {
	            return data[field];
	        }
	        else {
	            // otherwise it is a deep value, so need to dig for it
	            var fields = field.split('.');
	            var currentObject = data;
	            for (var i = 0; i < fields.length; i++) {
	                currentObject = currentObject[fields[i]];
	                if (this.missing(currentObject)) {
	                    return null;
	                }
	            }
	            return currentObject;
	        }
	    };
	    Utils.getElementSize = function (el) {
	        var _a = window.getComputedStyle(el), height = _a.height, width = _a.width, paddingTop = _a.paddingTop, paddingRight = _a.paddingRight, paddingBottom = _a.paddingBottom, paddingLeft = _a.paddingLeft, marginTop = _a.marginTop, marginRight = _a.marginRight, marginBottom = _a.marginBottom, marginLeft = _a.marginLeft, boxSizing = _a.boxSizing;
	        return {
	            height: parseFloat(height),
	            width: parseFloat(width),
	            paddingTop: parseFloat(paddingTop),
	            paddingRight: parseFloat(paddingRight),
	            paddingBottom: parseFloat(paddingBottom),
	            paddingLeft: parseFloat(paddingLeft),
	            marginTop: parseFloat(marginTop),
	            marginRight: parseFloat(marginRight),
	            marginBottom: parseFloat(marginBottom),
	            marginLeft: parseFloat(marginLeft),
	            boxSizing: boxSizing
	        };
	    };
	    Utils.getInnerHeight = function (el) {
	        var size = this.getElementSize(el);
	        if (size.boxSizing === 'border-box') {
	            return size.height - size.paddingTop - size.paddingBottom;
	        }
	        return size.height;
	    };
	    Utils.getInnerWidth = function (el) {
	        var size = this.getElementSize(el);
	        if (size.boxSizing === 'border-box') {
	            return size.width - size.paddingLeft - size.paddingRight;
	        }
	        return size.width;
	    };
	    Utils.getAbsoluteHeight = function (el) {
	        var size = this.getElementSize(el);
	        var marginRight = size.marginBottom + size.marginTop;
	        return Math.ceil(el.offsetHeight + marginRight);
	    };
	    Utils.getAbsoluteWidth = function (el) {
	        var size = this.getElementSize(el);
	        var marginWidth = size.marginLeft + size.marginRight;
	        return Math.ceil(el.offsetWidth + marginWidth);
	    };
	    Utils.getScrollLeft = function (element, rtl) {
	        var scrollLeft = element.scrollLeft;
	        if (rtl) {
	            // Absolute value - for FF that reports RTL scrolls in negative numbers
	            scrollLeft = Math.abs(scrollLeft);
	            // Get Chrome to return the same value as well
	            if (this.isBrowserChrome()) {
	                scrollLeft = element.scrollWidth - element.clientWidth - scrollLeft;
	            }
	        }
	        return scrollLeft;
	    };
	    Utils.cleanNumber = function (value) {
	        if (typeof value === 'string') {
	            value = parseInt(value, 10);
	        }
	        if (typeof value === 'number') {
	            value = Math.floor(value);
	        }
	        else {
	            value = null;
	        }
	        return value;
	    };
	    Utils.setScrollLeft = function (element, value, rtl) {
	        if (rtl) {
	            // Chrome and Safari when doing RTL have the END position of the scroll as zero, not the start
	            if (this.isBrowserSafari() || this.isBrowserChrome()) {
	                value = element.scrollWidth - element.clientWidth - value;
	            }
	            // Firefox uses negative numbers when doing RTL scrolling
	            if (this.isBrowserFirefox()) {
	                value *= -1;
	            }
	        }
	        element.scrollLeft = value;
	    };
	    Utils.iterateNamedNodeMap = function (map, callback) {
	        if (!map) {
	            return;
	        }
	        for (var i = 0; i < map.length; i++) {
	            var attr = map[i];
	            callback(attr.name, attr.value);
	        }
	    };
	    Utils.iterateObject = function (object, callback) {
	        if (!object || this.missing(object)) {
	            return;
	        }
	        if (Array.isArray(object)) {
	            object.forEach(function (value, index) {
	                callback(index + '', value);
	            });
	        }
	        else {
	            var keys = Object.keys(object);
	            for (var i = 0; i < keys.length; i++) {
	                var key = keys[i];
	                var value = object[key];
	                callback(key, value);
	            }
	        }
	    };
	    Utils.cloneObject = function (object) {
	        var copy = {};
	        var keys = Object.keys(object);
	        for (var i = 0; i < keys.length; i++) {
	            var key = keys[i];
	            var value = object[key];
	            copy[key] = value;
	        }
	        return copy;
	    };
	    Utils.deepCloneObject = function (object) {
	        return JSON.parse(JSON.stringify(object));
	    };
	    Utils.map = function (array, callback) {
	        var result = [];
	        for (var i = 0; i < array.length; i++) {
	            var item = array[i];
	            var mappedItem = callback(item, i);
	            result.push(mappedItem);
	        }
	        return result;
	    };
	    Utils.mapObject = function (object, callback) {
	        var result = [];
	        Utils.iterateObject(object, function (key, value) {
	            result.push(callback(value));
	        });
	        return result;
	    };
	    Utils.forEach = function (array, callback) {
	        if (!array) {
	            return;
	        }
	        for (var i = 0; i < array.length; i++) {
	            var value = array[i];
	            callback(value, i);
	        }
	    };
	    Utils.filter = function (array, callback) {
	        var result = [];
	        array.forEach(function (item) {
	            if (callback(item)) {
	                result.push(item);
	            }
	        });
	        return result;
	    };
	    Utils.getAllKeysInObjects = function (objects) {
	        var allValues = {};
	        objects.forEach(function (obj) {
	            if (obj) {
	                Object.keys(obj).forEach(function (key) { return allValues[key] = null; });
	            }
	        });
	        return Object.keys(allValues);
	    };
	    Utils.mergeDeep = function (dest, source) {
	        if (!this.exists(source)) {
	            return;
	        }
	        this.iterateObject(source, function (key, newValue) {
	            var oldValue = dest[key];
	            if (oldValue === newValue) {
	                return;
	            }
	            if (typeof oldValue === 'object' && typeof newValue === 'object') {
	                Utils.mergeDeep(oldValue, newValue);
	            }
	            else {
	                dest[key] = newValue;
	            }
	        });
	    };
	    Utils.assign = function (object) {
	        var _this = this;
	        var sources = [];
	        for (var _i = 1; _i < arguments.length; _i++) {
	            sources[_i - 1] = arguments[_i];
	        }
	        sources.forEach(function (source) {
	            if (_this.exists(source)) {
	                _this.iterateObject(source, function (key, value) {
	                    object[key] = value;
	                });
	            }
	        });
	        return object;
	    };
	    Utils.flatten = function (arrayOfArrays) {
	        return [].concat.apply([], arrayOfArrays);
	    };
	    Utils.parseYyyyMmDdToDate = function (yyyyMmDd, separator) {
	        try {
	            if (!yyyyMmDd) {
	                return null;
	            }
	            if (yyyyMmDd.indexOf(separator) === -1) {
	                return null;
	            }
	            var fields = yyyyMmDd.split(separator);
	            if (fields.length != 3) {
	                return null;
	            }
	            return new Date(Number(fields[0]), Number(fields[1]) - 1, Number(fields[2]));
	        }
	        catch (e) {
	            return null;
	        }
	    };
	    Utils.serializeDateToYyyyMmDd = function (date, separator) {
	        if (!date) {
	            return null;
	        }
	        return date.getFullYear() + separator + Utils.pad(date.getMonth() + 1, 2) + separator + Utils.pad(date.getDate(), 2);
	    };
	    Utils.pad = function (num, totalStringSize) {
	        var asString = num + "";
	        while (asString.length < totalStringSize) {
	            asString = "0" + asString;
	        }
	        return asString;
	    };
	    Utils.pushAll = function (target, source) {
	        if (this.missing(source) || this.missing(target)) {
	            return;
	        }
	        source.forEach(function (func) { return target.push(func); });
	    };
	    Utils.createArrayOfNumbers = function (first, last) {
	        var result = [];
	        for (var i = first; i <= last; i++) {
	            result.push(i);
	        }
	        return result;
	    };
	    Utils.getFunctionParameters = function (func) {
	        var fnStr = func.toString().replace(FUNCTION_STRIP_COMMENTS, '');
	        var result = fnStr.slice(fnStr.indexOf('(') + 1, fnStr.indexOf(')')).match(FUNCTION_ARGUMENT_NAMES);
	        if (result === null) {
	            return [];
	        }
	        else {
	            return result;
	        }
	    };
	    Utils.find = function (collection, predicate, value) {
	        if (collection === null || collection === undefined) {
	            return null;
	        }
	        if (!Array.isArray(collection)) {
	            var objToArray = this.values(collection);
	            return this.find(objToArray, predicate, value);
	        }
	        var collectionAsArray = collection;
	        var firstMatchingItem = null;
	        for (var i = 0; i < collectionAsArray.length; i++) {
	            var item = collectionAsArray[i];
	            if (typeof predicate === 'string') {
	                if (item[predicate] === value) {
	                    firstMatchingItem = item;
	                    break;
	                }
	            }
	            else {
	                var callback = predicate;
	                if (callback(item)) {
	                    firstMatchingItem = item;
	                    break;
	                }
	            }
	        }
	        return firstMatchingItem;
	    };
	    Utils.toStrings = function (array) {
	        return this.map(array, function (item) {
	            if (item === undefined || item === null || !item.toString) {
	                return null;
	            }
	            else {
	                return item.toString();
	            }
	        });
	    };
	    Utils.iterateArray = function (array, callback) {
	        for (var index = 0; index < array.length; index++) {
	            var value = array[index];
	            callback(value, index);
	        }
	    };
	    Utils.findIndex = function (collection, predicate) {
	        for (var i = 0; i < collection.length; i++) {
	            if (predicate(collection[i], i, collection)) {
	                return i;
	            }
	        }
	        return -1;
	    };
	    /**
	     * Returns true if it is a DOM node
	     * taken from: http://stackoverflow.com/questions/384286/javascript-isdom-how-do-you-check-if-a-javascript-object-is-a-dom-object
	     * @param {any} o
	     * @return {boolean}
	     */
	    Utils.isNode = function (o) {
	        return (typeof Node === "function" ? o instanceof Node :
	            o && typeof o === "object" && typeof o.nodeType === "number" && typeof o.nodeName === "string");
	    };
	    //
	    /**
	     * Returns true if it is a DOM element
	     * taken from: http://stackoverflow.com/questions/384286/javascript-isdom-how-do-you-check-if-a-javascript-object-is-a-dom-object
	     * @param {any} o
	     * @returns {boolean}
	     */
	    Utils.isElement = function (o) {
	        return (typeof HTMLElement === "function" ? o instanceof HTMLElement : //DOM2
	            o && typeof o === "object" && o !== null && o.nodeType === 1 && typeof o.nodeName === "string");
	    };
	    Utils.isNodeOrElement = function (o) {
	        return this.isNode(o) || this.isElement(o);
	    };
	    /**
	     * Makes a copy of a node list into a list
	     * @param {NodeList} nodeList
	     * @returns {Node[]}
	     */
	    Utils.copyNodeList = function (nodeList) {
	        var childCount = nodeList ? nodeList.length : 0;
	        var res = [];
	        for (var i = 0; i < childCount; i++) {
	            res.push(nodeList[i]);
	        }
	        return res;
	    };
	    Utils.isEventFromPrintableCharacter = function (event) {
	        var pressedChar = String.fromCharCode(event.charCode);
	        // newline is an exception, as it counts as a printable character, but we don't
	        // want to start editing when it is pressed. without this check, if user is in chrome
	        // and editing a cell, and they press ctrl+enter, the cell stops editing, and then
	        // starts editing again with a blank value (two 'key down' events are fired). to
	        // test this, remove the line below, edit a cell in chrome and hit ctrl+enter while editing.
	        // https://ag-grid.atlassian.net/browse/AG-605
	        if (this.isKeyPressed(event, constants_1.Constants.KEY_NEW_LINE)) {
	            return false;
	        }
	        // no allowed printable chars have alt or ctrl key combinations
	        if (event.altKey || event.ctrlKey) {
	            return false;
	        }
	        if (exports._.exists(event.key)) {
	            // modern browser will implement key, so we return if key is length 1, eg if it is 'a' for the
	            // a key, or '2' for the '2' key. non-printable characters have names, eg 'Enter' or 'Backspace'.
	            var printableCharacter = event.key.length === 1;
	            // IE11 & Edge treat the numpad del key differently - with numlock on we get "Del" for key,
	            // so this addition checks if its IE11/Edge and handles that specific case the same was as all other browsers
	            var numpadDelWithNumlockOnForEdgeOrIe = Utils.isNumpadDelWithNumlockOnForEdgeOrIe(event);
	            return printableCharacter || numpadDelWithNumlockOnForEdgeOrIe;
	        }
	        else {
	            // otherwise, for older browsers, we test against a list of characters, which doesn't include
	            // accents for non-English, but don't care much, as most users are on modern browsers
	            return Utils.PRINTABLE_CHARACTERS.indexOf(pressedChar) >= 0;
	        }
	    };
	    /**
	     * Allows user to tell the grid to skip specific keyboard events
	     * @param {GridOptionsWrapper} gridOptionsWrapper
	     * @param {KeyboardEvent} keyboardEvent
	     * @param {RowNode} rowNode
	     * @param {Column} column
	     * @param {boolean} editing
	     * @returns {boolean}
	     */
	    Utils.isUserSuppressingKeyboardEvent = function (gridOptionsWrapper, keyboardEvent, rowNode, column, editing) {
	        var gridOptionsFunc = gridOptionsWrapper.getSuppressKeyboardEventFunc();
	        var colDefFunc = column.getColDef().suppressKeyboardEvent;
	        // if no callbacks provided by user, then do nothing
	        if (!gridOptionsFunc && !colDefFunc) {
	            return false;
	        }
	        var params = {
	            event: keyboardEvent,
	            editing: editing,
	            column: column,
	            api: gridOptionsWrapper.getApi(),
	            node: rowNode,
	            data: rowNode.data,
	            colDef: column.getColDef(),
	            context: gridOptionsWrapper.getContext(),
	            columnApi: gridOptionsWrapper.getColumnApi()
	        };
	        // colDef get first preference on suppressing events
	        if (colDefFunc) {
	            var colDefFuncResult = colDefFunc(params);
	            // if colDef func suppressed, then return now, no need to call gridOption func
	            if (colDefFuncResult) {
	                return true;
	            }
	        }
	        if (gridOptionsFunc) {
	            // if gridOption func, return the result
	            return gridOptionsFunc(params);
	        }
	        else {
	            // otherwise return false, don't suppress, as colDef didn't suppress and no func on gridOptions
	            return false;
	        }
	    };
	    Utils.getCellCompForEvent = function (gridOptionsWrapper, event) {
	        var sourceElement = this.getTarget(event);
	        while (sourceElement) {
	            var renderedCell = gridOptionsWrapper.getDomData(sourceElement, 'cellComp');
	            if (renderedCell) {
	                return renderedCell;
	            }
	            sourceElement = sourceElement.parentElement;
	        }
	        return null;
	    };
	    /**
	     * Adds all type of change listeners to an element, intended to be a text field
	     * @param {HTMLElement} element
	     * @param {EventListener} listener
	     */
	    Utils.addChangeListener = function (element, listener) {
	        element.addEventListener("changed", listener);
	        element.addEventListener("paste", listener);
	        element.addEventListener("input", listener);
	        // IE doesn't fire changed for special keys (eg delete, backspace), so need to
	        // listen for this further ones
	        element.addEventListener("keydown", listener);
	        element.addEventListener("keyup", listener);
	    };
	    /**
	     * If value is undefined, null or blank, returns null, otherwise returns the value
	     * @param {T} value
	     * @returns {T | null}
	     */
	    Utils.makeNull = function (value) {
	        var valueNoType = value;
	        if (value === null || value === undefined || valueNoType === "") {
	            return null;
	        }
	        return value;
	    };
	    Utils.missing = function (value) {
	        return !this.exists(value);
	    };
	    Utils.missingOrEmpty = function (value) {
	        return !value || this.missing(value) || value.length === 0;
	    };
	    Utils.missingOrEmptyObject = function (value) {
	        return this.missing(value) || Object.keys(value).length === 0;
	    };
	    Utils.exists = function (value, allowEmptyString) {
	        if (allowEmptyString === void 0) { allowEmptyString = false; }
	        return value != null && (value !== '' || allowEmptyString);
	    };
	    Utils.firstExistingValue = function () {
	        var values = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            values[_i] = arguments[_i];
	        }
	        for (var i = 0; i < values.length; i++) {
	            var value = values[i];
	            if (exports._.exists(value)) {
	                return value;
	            }
	        }
	        return null;
	    };
	    Utils.anyExists = function (values) {
	        if (values) {
	            for (var i = 0; i < values.length; i++) {
	                if (this.exists(values[i])) {
	                    return true;
	                }
	            }
	        }
	        return false;
	    };
	    Utils.existsAndNotEmpty = function (value) {
	        return value != null && this.exists(value) && value.length > 0;
	    };
	    Utils.clearElement = function (el) {
	        while (el && el.firstChild) {
	            el.removeChild(el.firstChild);
	        }
	    };
	    Utils.removeElement = function (parent, cssSelector) {
	        this.removeFromParent(parent.querySelector(cssSelector));
	    };
	    Utils.removeFromParent = function (node) {
	        if (node && node.parentNode) {
	            node.parentNode.removeChild(node);
	        }
	    };
	    Utils.isVisible = function (element) {
	        return (element.offsetParent !== null);
	    };
	    Utils.callIfPresent = function (func) {
	        if (func) {
	            func();
	        }
	    };
	    /**
	     * Loads the template and returns it as an element. makes up for no simple way in
	     * the dom api to load html directly, eg we cannot do this: document.createElement(template)
	     * @param {string} template
	     * @returns {HTMLElement}
	     */
	    Utils.loadTemplate = function (template) {
	        var tempDiv = document.createElement("div");
	        tempDiv.innerHTML = template;
	        return tempDiv.firstChild;
	    };
	    Utils.appendHtml = function (eContainer, htmlTemplate) {
	        if (eContainer.lastChild) {
	            // https://developer.mozilla.org/en-US/docs/Web/API/Element/insertAdjacentHTML
	            // we put the items at the start, so new items appear underneath old items,
	            // so when expanding/collapsing groups, the new rows don't go on top of the
	            // rows below that are moving our of the way
	            eContainer.insertAdjacentHTML('afterbegin', htmlTemplate);
	        }
	        else {
	            eContainer.innerHTML = htmlTemplate;
	        }
	    };
	    Utils.addOrRemoveCssClass = function (element, className, addOrRemove) {
	        if (addOrRemove) {
	            this.addCssClass(element, className);
	        }
	        else {
	            this.removeCssClass(element, className);
	        }
	    };
	    /**
	     * This method adds a class to an element and remove that class from all siblings.
	     * Useful for toggling state.
	     * @param {HTMLElement} element The element to receive the class
	     * @param {string} className The class to be assigned to the element
	     * @param {boolean} [inverted] This inverts the effect, adding the class to all siblings and
	     *        removing from the relevant element (useful when adding a class to hide non-selected elements).
	     */
	    Utils.radioCssClass = function (element, className, inverted) {
	        var parent = element.parentElement;
	        var sibling = parent.firstChild;
	        while (sibling) {
	            exports._.addOrRemoveCssClass(sibling, className, inverted ? (sibling !== element) : (sibling === element));
	            sibling = sibling.nextSibling;
	        }
	    };
	    Utils.addCssClass = function (element, className) {
	        var _this = this;
	        if (!className || className.length === 0) {
	            return;
	        }
	        if (className.indexOf(' ') >= 0) {
	            className.split(' ').forEach(function (value) { return _this.addCssClass(element, value); });
	            return;
	        }
	        if (element.classList) {
	            if (!element.classList.contains(className)) {
	                element.classList.add(className);
	            }
	        }
	        else {
	            if (element.className && element.className.length > 0) {
	                var cssClasses = element.className.split(' ');
	                if (cssClasses.indexOf(className) < 0) {
	                    cssClasses.push(className);
	                    element.setAttribute('class', cssClasses.join(' '));
	                }
	            }
	            else {
	                // do not use element.classList = className here, it will cause
	                // a read-only assignment error on some browsers (IE/Edge).
	                element.setAttribute('class', className);
	            }
	        }
	    };
	    Utils.removeCssClass = function (element, className) {
	        if (element.classList) {
	            if (element.classList.contains(className)) {
	                element.classList.remove(className);
	            }
	        }
	        else {
	            if (element.className && element.className.length > 0) {
	                var cssClasses = element.className.split(' ');
	                if (cssClasses.indexOf(className) >= 0) {
	                    // remove all instances of the item, not just the first, in case it's in more than once
	                    while (cssClasses.indexOf(className) >= 0) {
	                        cssClasses.splice(cssClasses.indexOf(className), 1);
	                    }
	                    element.setAttribute('class', cssClasses.join(' '));
	                }
	            }
	        }
	    };
	    Utils.containsClass = function (element, className) {
	        if (element.classList) {
	            // for modern browsers
	            return element.classList.contains(className);
	        }
	        else if (element.className) {
	            // for older browsers, check against the string of class names
	            // if only one class, can check for exact match
	            var onlyClass = element.className === className;
	            // if many classes, check for class name, we have to pad with ' ' to stop other
	            // class names that are a substring of this class
	            var contains = element.className.indexOf(' ' + className + ' ') >= 0;
	            // the padding above then breaks when it's the first or last class names
	            var startsWithClass = element.className.indexOf(className + ' ') === 0;
	            var endsWithClass = element.className.lastIndexOf(' ' + className) === (element.className.length - className.length - 1);
	            return onlyClass || contains || startsWithClass || endsWithClass;
	        }
	        else {
	            // if item is not a node
	            return false;
	        }
	    };
	    Utils.getElementAttribute = function (element, attributeName) {
	        if (element.attributes) {
	            if (element.attributes[attributeName]) {
	                var attribute = element.attributes[attributeName];
	                return attribute.value;
	            }
	            else {
	                return null;
	            }
	        }
	        else {
	            return null;
	        }
	    };
	    Utils.offsetHeight = function (element) {
	        return element && element.clientHeight ? element.clientHeight : 0;
	    };
	    Utils.offsetWidth = function (element) {
	        return element && element.clientWidth ? element.clientWidth : 0;
	    };
	    Utils.sortNumberArray = function (numberArray) {
	        numberArray.sort(function (a, b) { return a - b; });
	    };
	    Utils.removeRepeatsFromArray = function (array, object) {
	        if (!array) {
	            return;
	        }
	        for (var index = array.length - 2; index >= 0; index--) {
	            var thisOneMatches = array[index] === object;
	            var nextOneMatches = array[index + 1] === object;
	            if (thisOneMatches && nextOneMatches) {
	                array.splice(index + 1, 1);
	            }
	        }
	    };
	    Utils.removeFromArray = function (array, object) {
	        var index = array.indexOf(object);
	        if (index >= 0) {
	            array.splice(index, 1);
	        }
	    };
	    Utils.removeAllFromArray = function (array, toRemove) {
	        toRemove.forEach(function (item) {
	            var index = array.indexOf(item);
	            if (index >= 0) {
	                array.splice(index, 1);
	            }
	        });
	    };
	    Utils.insertIntoArray = function (array, object, toIndex) {
	        array.splice(toIndex, 0, object);
	    };
	    Utils.insertArrayIntoArray = function (dest, src, toIndex) {
	        if (this.missing(dest) || this.missing(src)) {
	            return;
	        }
	        // put items in backwards, otherwise inserted items end up in reverse order
	        for (var i = src.length - 1; i >= 0; i--) {
	            var item = src[i];
	            this.insertIntoArray(dest, item, toIndex);
	        }
	    };
	    Utils.moveInArray = function (array, objectsToMove, toIndex) {
	        var _this = this;
	        // first take out it items from the array
	        objectsToMove.forEach(function (obj) {
	            _this.removeFromArray(array, obj);
	        });
	        // now add the objects, in same order as provided to us, that means we start at the end
	        // as the objects will be pushed to the right as they are inserted
	        objectsToMove.slice().reverse().forEach(function (obj) {
	            _this.insertIntoArray(array, obj, toIndex);
	        });
	    };
	    Utils.defaultComparator = function (valueA, valueB, accentedCompare) {
	        if (accentedCompare === void 0) { accentedCompare = false; }
	        var valueAMissing = valueA === null || valueA === undefined;
	        var valueBMissing = valueB === null || valueB === undefined;
	        // this is for aggregations sum and avg, where the result can be a number that is wrapped.
	        // if we didn't do this, then the toString() value would be used, which would result in
	        // the strings getting used instead of the numbers.
	        if (valueA && valueA.toNumber) {
	            valueA = valueA.toNumber();
	        }
	        if (valueB && valueB.toNumber) {
	            valueB = valueB.toNumber();
	        }
	        if (valueAMissing && valueBMissing) {
	            return 0;
	        }
	        if (valueAMissing) {
	            return -1;
	        }
	        if (valueBMissing) {
	            return 1;
	        }
	        if (typeof valueA === "string") {
	            if (!accentedCompare) {
	                return doQuickCompare(valueA, valueB);
	            }
	            else {
	                try {
	                    // using local compare also allows chinese comparisons
	                    return valueA.localeCompare(valueB);
	                }
	                catch (e) {
	                    // if something wrong with localeCompare, eg not supported
	                    // by browser, then just continue with the quick one
	                    return doQuickCompare(valueA, valueB);
	                }
	            }
	        }
	        if (valueA < valueB) {
	            return -1;
	        }
	        else if (valueA > valueB) {
	            return 1;
	        }
	        else {
	            return 0;
	        }
	        function doQuickCompare(a, b) {
	            return (a > b ? 1 : (a < b ? -1 : 0));
	        }
	    };
	    Utils.last = function (arr) {
	        if (!arr || !arr.length) {
	            return undefined;
	        }
	        return arr[arr.length - 1];
	    };
	    Utils.compareArrays = function (array1, array2) {
	        if (this.missing(array1) && this.missing(array2)) {
	            return true;
	        }
	        if ((this.missing(array1) || this.missing(array2)) ||
	            (!array1 || !array2)) {
	            return false;
	        }
	        if (array1.length !== array2.length) {
	            return false;
	        }
	        for (var i = 0; i < array1.length; i++) {
	            if (array1[i] !== array2[i]) {
	                return false;
	            }
	        }
	        return true;
	    };
	    Utils.ensureDomOrder = function (eContainer, eChild, eChildBefore) {
	        // if already in right order, do nothing
	        if (eChildBefore && eChildBefore.nextSibling === eChild) {
	            return;
	        }
	        if (eChildBefore) {
	            if (eChildBefore.nextSibling) {
	                // insert between the eRowBefore and the row after it
	                eContainer.insertBefore(eChild, eChildBefore.nextSibling);
	            }
	            else {
	                // if nextSibling is missing, means other row is at end, so just append new row at the end
	                eContainer.appendChild(eChild);
	            }
	        }
	        else {
	            // otherwise put at start
	            if (eContainer.firstChild && eContainer.firstChild !== eChild) {
	                // insert it at the first location
	                eContainer.insertAdjacentElement('afterbegin', eChild);
	            }
	        }
	    };
	    Utils.insertWithDomOrder = function (eContainer, eChild, eChildBefore) {
	        if (eChildBefore) {
	            if (eChildBefore.nextSibling) {
	                // insert between the eRowBefore and the row after it
	                eContainer.insertBefore(eChild, eChildBefore.nextSibling);
	            }
	            else {
	                // if nextSibling is missing, means other row is at end, so just append new row at the end
	                eContainer.appendChild(eChild);
	            }
	        }
	        else {
	            if (eContainer.firstChild) {
	                // insert it at the first location
	                eContainer.insertBefore(eChild, eContainer.firstChild);
	            }
	            else {
	                // otherwise eContainer is empty, so just append it
	                eContainer.appendChild(eChild);
	            }
	        }
	    };
	    Utils.insertTemplateWithDomOrder = function (eContainer, htmlTemplate, eChildBefore) {
	        var res;
	        if (eChildBefore) {
	            // if previous element exists, just slot in after the previous element
	            eChildBefore.insertAdjacentHTML('afterend', htmlTemplate);
	            res = eChildBefore.nextSibling;
	        }
	        else {
	            if (eContainer.firstChild) {
	                // insert it at the first location
	                eContainer.insertAdjacentHTML('afterbegin', htmlTemplate);
	            }
	            else {
	                // otherwise eContainer is empty, so just append it
	                eContainer.innerHTML = htmlTemplate;
	            }
	            res = eContainer.firstChild;
	        }
	        return res;
	    };
	    Utils.every = function (items, callback) {
	        if (!items || items.length === 0) {
	            return true;
	        }
	        for (var i = 0; i < items.length; i++) {
	            if (!callback(items[i])) {
	                return false;
	            }
	        }
	        return true;
	    };
	    Utils.toStringOrNull = function (value) {
	        if (this.exists(value) && value.toString) {
	            return value.toString();
	        }
	        else {
	            return null;
	        }
	    };
	    Utils.formatSize = function (size) {
	        if (typeof size === "number") {
	            return size + "px";
	        }
	        else {
	            return size;
	        }
	    };
	    Utils.formatNumberTwoDecimalPlacesAndCommas = function (value) {
	        if (typeof value !== 'number') {
	            return '';
	        }
	        // took this from: http://blog.tompawlak.org/number-currency-formatting-javascript
	        return (Math.round(value * 100) / 100).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
	    };
	    /**
	     * the native method number.toLocaleString(undefined, {minimumFractionDigits: 0})
	     * puts in decimal places in IE, so we use this method instead
	     * from: http://blog.tompawlak.org/number-currency-formatting-javascript
	     * @param {number} value
	     * @returns {string}
	     */
	    Utils.formatNumberCommas = function (value) {
	        if (typeof value !== 'number') {
	            return '';
	        }
	        return value.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
	    };
	    Utils.prependDC = function (parent, documentFragment) {
	        if (this.exists(parent.firstChild)) {
	            parent.insertBefore(documentFragment, parent.firstChild);
	        }
	        else {
	            parent.appendChild(documentFragment);
	        }
	    };
	    /**
	     * If icon provided, use this (either a string, or a function callback).
	     * if not, then use the default icon from the theme
	     * @param {string} iconName
	     * @param {GridOptionsWrapper} gridOptionsWrapper
	     * @param {Column | null} [column]
	     * @returns {HTMLElement}
	     */
	    Utils.createIcon = function (iconName, gridOptionsWrapper, column) {
	        var iconContents = this.createIconNoSpan(iconName, gridOptionsWrapper, column);
	        if (iconContents.className.indexOf('ag-icon') > -1) {
	            return iconContents;
	        }
	        else {
	            var eResult = document.createElement('span');
	            eResult.appendChild(iconContents);
	            return eResult;
	        }
	    };
	    Utils.createIconNoSpan = function (iconName, gridOptionsWrapper, column, forceCreate) {
	        var userProvidedIcon = null;
	        // check col for icon first
	        var icons = column && column.getColDef().icons;
	        if (icons) {
	            userProvidedIcon = icons[iconName];
	        }
	        // if not in col, try grid options
	        if (gridOptionsWrapper && !userProvidedIcon) {
	            var optionsIcons = gridOptionsWrapper.getIcons();
	            if (optionsIcons) {
	                userProvidedIcon = optionsIcons[iconName];
	            }
	        }
	        // now if user provided, use it
	        if (userProvidedIcon) {
	            var rendererResult = void 0;
	            if (typeof userProvidedIcon === 'function') {
	                rendererResult = userProvidedIcon();
	            }
	            else if (typeof userProvidedIcon === 'string') {
	                rendererResult = userProvidedIcon;
	            }
	            else {
	                throw new Error('icon from grid options needs to be a string or a function');
	            }
	            if (typeof rendererResult === 'string') {
	                return this.loadTemplate(rendererResult);
	            }
	            else if (this.isNodeOrElement(rendererResult)) {
	                return rendererResult;
	            }
	            else {
	                throw new Error('iconRenderer should return back a string or a dom object');
	            }
	        }
	        else {
	            var span = document.createElement('span');
	            var cssClass = this.iconNameClassMap[iconName];
	            if (!cssClass) {
	                if (!forceCreate) {
	                    throw new Error(iconName + " did not find class");
	                }
	                else {
	                    cssClass = iconName;
	                }
	            }
	            span.setAttribute("class", "ag-icon ag-icon-" + cssClass);
	            span.setAttribute("unselectable", "on");
	            return span;
	        }
	    };
	    Utils.addStylesToElement = function (eElement, styles) {
	        var _this = this;
	        if (!styles) {
	            return;
	        }
	        Object.keys(styles).forEach(function (key) {
	            var keyCamelCase = _this.hyphenToCamelCase(key);
	            if (keyCamelCase) {
	                eElement.style[keyCamelCase] = styles[key];
	            }
	        });
	    };
	    Utils.isHorizontalScrollShowing = function (element) {
	        return element.clientWidth < element.scrollWidth;
	    };
	    Utils.isVerticalScrollShowing = function (element) {
	        return element.clientHeight < element.scrollHeight;
	    };
	    Utils.getMaxDivHeight = function () {
	        if (!document.body) {
	            return -1;
	        }
	        var res = 1000000;
	        // FF reports the height back but still renders blank after ~6M px
	        var testUpTo = navigator.userAgent.toLowerCase().match(/firefox/) ? 6000000 : 1000000000;
	        var div = this.loadTemplate("<div/>");
	        document.body.appendChild(div);
	        while (true) {
	            var test = res * 2;
	            div.style.height = test + 'px';
	            if (test > testUpTo || div.clientHeight !== test) {
	                break;
	            }
	            else {
	                res = test;
	            }
	        }
	        document.body.removeChild(div);
	        return res;
	    };
	    Utils.getScrollbarWidth = function () {
	        var body = document.body;
	        var div = document.createElement("div");
	        div.style.width = div.style.height = "100px";
	        div.style.opacity = "0";
	        div.style.overflow = "scroll";
	        div.style.msOverflowStyle = "scrollbar"; // needed for WinJS apps
	        div.style.position = "absolute";
	        body.appendChild(div);
	        var width = div.offsetWidth - div.clientWidth;
	        // remove divs
	        if (div.parentNode) {
	            div.parentNode.removeChild(div);
	        }
	        return width;
	    };
	    Utils.hasOverflowScrolling = function () {
	        var prefixes = ['webkit', 'moz', 'o', 'ms'];
	        var div = document.createElement('div');
	        var body = document.getElementsByTagName('body')[0];
	        var found = false;
	        var p;
	        body.appendChild(div);
	        div.setAttribute('style', prefixes.map(function (prefix) { return "-" + prefix + "-overflow-scrolling: touch"; }).concat('overflow-scrolling: touch').join(';'));
	        var computedStyle = window.getComputedStyle(div);
	        if (computedStyle.overflowScrolling === 'touch') {
	            found = true;
	        }
	        if (!found) {
	            for (var _i = 0, prefixes_1 = prefixes; _i < prefixes_1.length; _i++) {
	                p = prefixes_1[_i];
	                if (computedStyle[p + "OverflowScrolling"] === 'touch') {
	                    found = true;
	                    break;
	                }
	            }
	        }
	        if (div.parentNode) {
	            div.parentNode.removeChild(div);
	        }
	        return found;
	    };
	    Utils.isKeyPressed = function (event, keyToCheck) {
	        var pressedKey = event.which || event.keyCode;
	        return pressedKey === keyToCheck;
	    };
	    Utils.isCharacterKey = function (event) {
	        // from: https://stackoverflow.com/questions/4179708/how-to-detect-if-the-pressed-key-will-produce-a-character-inside-an-input-text
	        var which = event.which;
	        if (typeof which === 'number' && which) {
	            return !event.ctrlKey && !event.metaKey && !event.altKey && event.which !== 8 && event.which !== 16;
	        }
	        return which === undefined;
	    };
	    Utils.setDisplayed = function (element, displayed) {
	        this.addOrRemoveCssClass(element, 'ag-hidden', !displayed);
	    };
	    Utils.setVisible = function (element, visible) {
	        this.addOrRemoveCssClass(element, 'ag-invisible', !visible);
	    };
	    Utils.setElementWidth = function (element, width) {
	        if (width === 'flex') {
	            element.style.width = null;
	            element.style.minWidth = null;
	            element.style.maxWidth = null;
	            element.style.flex = '1 1 auto';
	        }
	        else {
	            this.setFixedWidth(element, width);
	        }
	    };
	    Utils.setFixedWidth = function (element, width) {
	        width = this.formatSize(width);
	        element.style.width = width;
	        element.style.maxWidth = width;
	        element.style.minWidth = width;
	    };
	    Utils.setElementHeight = function (element, height) {
	        if (height === 'flex') {
	            element.style.height = null;
	            element.style.minHeight = null;
	            element.style.maxHeight = null;
	            element.style.flex = '1 1 auto';
	        }
	        else {
	            this.setFixedHeight(element, height);
	        }
	    };
	    Utils.setFixedHeight = function (element, height) {
	        height = this.formatSize(height);
	        element.style.height = height;
	        element.style.maxHeight = height;
	        element.style.minHeight = height;
	    };
	    Utils.isBrowserIE = function () {
	        if (this.isIE === undefined) {
	            this.isIE = /*@cc_on!@*/ false || !!document.documentMode; // At least IE6
	        }
	        return this.isIE;
	    };
	    Utils.isBrowserEdge = function () {
	        if (this.isEdge === undefined) {
	            this.isEdge = !this.isBrowserIE() && !!window.StyleMedia;
	        }
	        return this.isEdge;
	    };
	    Utils.isBrowserSafari = function () {
	        if (this.isSafari === undefined) {
	            var anyWindow = window;
	            // taken from https://github.com/ag-grid/ag-grid/issues/550
	            this.isSafari = Object.prototype.toString.call(anyWindow.HTMLElement).indexOf('Constructor') > 0
	                || (function (p) {
	                    return p ? p.toString() === "[object SafariRemoteNotification]" : false;
	                })(!anyWindow.safari || anyWindow.safari.pushNotification);
	        }
	        return this.isSafari;
	    };
	    Utils.isBrowserChrome = function () {
	        if (this.isChrome === undefined) {
	            var win = window;
	            this.isChrome = (!!win.chrome && (!!win.chrome.webstore || !!win.chrome.runtime)) ||
	                (/Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor));
	        }
	        return this.isChrome;
	    };
	    Utils.isBrowserFirefox = function () {
	        if (this.isFirefox === undefined) {
	            var win = window;
	            this.isFirefox = typeof win.InstallTrigger !== 'undefined';
	        }
	        return this.isFirefox;
	    };
	    Utils.isUserAgentIPad = function () {
	        if (this.isIPad === undefined) {
	            // taken from https://davidwalsh.name/detect-ipad
	            this.isIPad = navigator.userAgent.match(/iPad|iPhone/i) != null;
	        }
	        return this.isIPad;
	    };
	    /**
	     * srcElement is only available in IE. In all other browsers it is target
	     * http://stackoverflow.com/questions/5301643/how-can-i-make-event-srcelement-work-in-firefox-and-what-does-it-mean
	     * @param {Event} event
	     * @returns {Element}
	     */
	    Utils.getTarget = function (event) {
	        var eventNoType = event;
	        return eventNoType.target || eventNoType.srcElement;
	    };
	    Utils.isElementChildOfClass = function (element, cls, maxNest) {
	        var counter = 0;
	        while (element) {
	            if (this.containsClass(element, cls)) {
	                return true;
	            }
	            element = element.parentElement;
	            if (maxNest && ++counter > maxNest) {
	                break;
	            }
	        }
	        return false;
	    };
	    Utils.isElementInEventPath = function (element, event) {
	        if (!event || !element) {
	            return false;
	        }
	        var path = exports._.getEventPath(event);
	        return path.indexOf(element) >= 0;
	    };
	    Utils.isFunction = function (val) {
	        return !!(val && val.constructor && val.call && val.apply);
	    };
	    Utils.createEventPath = function (event) {
	        var res = [];
	        var pointer = exports._.getTarget(event);
	        while (pointer) {
	            res.push(pointer);
	            pointer = pointer.parentElement;
	        }
	        return res;
	    };
	    /**
	     * firefox doesn't have event.path set, or any alternative to it, so we hack
	     * it in. this is needed as it's to late to work out the path when the item is
	     * removed from the dom. used by MouseEventService, where it works out if a click
	     * was from the current grid, or a detail grid (master / detail).
	     * @param {Event} event
	     */
	    Utils.addAgGridEventPath = function (event) {
	        event.__agGridEventPath = this.getEventPath(event);
	    };
	    /**
	     * Gets the path for an Event.
	     * https://stackoverflow.com/questions/39245488/event-path-undefined-with-firefox-and-vue-js
	     * https://developer.mozilla.org/en-US/docs/Web/API/Event
	     * @param {Event} event
	     * @returns {EventTarget[]}
	     */
	    Utils.getEventPath = function (event) {
	        var eventNoType = event;
	        if (eventNoType.deepPath) {
	            // IE supports deep path
	            return eventNoType.deepPath();
	        }
	        else if (eventNoType.path) {
	            // Chrome supports path
	            return eventNoType.path;
	        }
	        else if (eventNoType.composedPath) {
	            // Firefox supports composePath
	            return eventNoType.composedPath();
	        }
	        else if (eventNoType.__agGridEventPath) {
	            // Firefox supports composePath
	            return eventNoType.__agGridEventPath;
	        }
	        else {
	            // and finally, if none of the above worked,
	            // we create the path ourselves
	            return this.createEventPath(event);
	        }
	    };
	    Utils.forEachSnapshotFirst = function (list, callback) {
	        if (list) {
	            var arrayCopy = list.slice(0);
	            arrayCopy.forEach(callback);
	        }
	    };
	    /**
	     * Gets the document body width
	     * from: http://stackoverflow.com/questions/1038727/how-to-get-browser-width-using-javascript-code
	     * @returns {number}
	     */
	    Utils.getBodyWidth = function () {
	        if (document.body) {
	            return document.body.clientWidth;
	        }
	        if (window.innerHeight) {
	            return window.innerWidth;
	        }
	        if (document.documentElement && document.documentElement.clientWidth) {
	            return document.documentElement.clientWidth;
	        }
	        return -1;
	    };
	    /**
	     * Gets the body height
	     * from: http://stackoverflow.com/questions/1038727/how-to-get-browser-width-using-javascript-code
	     * @returns {number}
	     */
	    Utils.getBodyHeight = function () {
	        if (document.body) {
	            return document.body.clientHeight;
	        }
	        if (window.innerHeight) {
	            return window.innerHeight;
	        }
	        if (document.documentElement && document.documentElement.clientHeight) {
	            return document.documentElement.clientHeight;
	        }
	        return -1;
	    };
	    Utils.setCheckboxState = function (eCheckbox, state) {
	        if (typeof state === 'boolean') {
	            eCheckbox.checked = state;
	            eCheckbox.indeterminate = false;
	        }
	        else {
	            // isNodeSelected returns back undefined if it's a group and the children
	            // are a mix of selected and unselected
	            eCheckbox.indeterminate = true;
	        }
	    };
	    Utils.traverseNodesWithKey = function (nodes, callback) {
	        var keyParts = [];
	        recursiveSearchNodes(nodes);
	        function recursiveSearchNodes(currentNodes) {
	            currentNodes.forEach(function (node) {
	                // also checking for children for tree data
	                if (node.group || node.hasChildren()) {
	                    keyParts.push(node.key);
	                    var key = keyParts.join('|');
	                    callback(node, key);
	                    recursiveSearchNodes(node.childrenAfterGroup);
	                    keyParts.pop();
	                }
	            });
	        }
	    };
	    /**
	     * Converts a camelCase string into hyphenated string
	     * from https://gist.github.com/youssman/745578062609e8acac9f
	     * @param {string} str
	     * @return {string}
	     */
	    Utils.camelCaseToHyphen = function (str) {
	        if (str === null || str === undefined) {
	            return null;
	        }
	        return str.replace(/([A-Z])/g, function (g) { return '-' + g[0].toLowerCase(); });
	    };
	    /**
	     * Converts a hyphenated string into camelCase string
	     * from https://stackoverflow.com/questions/6660977/convert-hyphens-to-camel-case-camelcase
	     * @param {string} str
	     * @return {string}
	     */
	    Utils.hyphenToCamelCase = function (str) {
	        if (str === null || str === undefined) {
	            return null;
	        }
	        return str.replace(/-([a-z])/g, function (g) { return g[1].toUpperCase(); });
	    };
	    Utils.capitalise = function (str) {
	        return str[0].toUpperCase() + str.substr(1).toLowerCase();
	    };
	    /**
	     * Converts a CSS object into string
	     * @param {Object} stylesToUse an object eg: {color: 'black', top: '25px'}
	     * @return {string} A string like "color: black; top: 25px;" for html
	     */
	    Utils.cssStyleObjectToMarkup = function (stylesToUse) {
	        var _this = this;
	        if (!stylesToUse) {
	            return '';
	        }
	        var resParts = [];
	        this.iterateObject(stylesToUse, function (styleKey, styleValue) {
	            var styleKeyDashed = _this.camelCaseToHyphen(styleKey);
	            resParts.push(styleKeyDashed + ": " + styleValue + ";");
	        });
	        return resParts.join(' ');
	    };
	    /**
	     * Check if a value is numeric
	     * from http://stackoverflow.com/questions/9716468/is-there-any-function-like-isnumeric-in-javascript-to-validate-numbers
	     * @param {any} value
	     * @return {boolean}
	     */
	    Utils.isNumeric = function (value) {
	        if (value === '') {
	            return false;
	        }
	        return !isNaN(parseFloat(value)) && isFinite(value);
	    };
	    Utils.escape = function (toEscape) {
	        if (toEscape === null || toEscape === undefined || !toEscape.replace) {
	            return toEscape;
	        }
	        return toEscape.replace(reUnescapedHtml, function (chr) { return HTML_ESCAPES[chr]; });
	    };
	    /**
	     * Mouse wheel (and 2-finger trackpad) support on the web sucks.  It is
	     * complicated, thus this doc is long and (hopefully) detailed enough to answer
	     * your questions.
	     *
	     * If you need to react to the mouse wheel in a predictable way, this code is
	     * like your bestest friend. * hugs *
	     *
	     * As of today, there are 4 DOM event types you can listen to:
	     *
	     *   'wheel'                -- Chrome(31+), FF(17+), IE(9+)
	     *   'mousewheel'           -- Chrome, IE(6+), Opera, Safari
	     *   'MozMousePixelScroll'  -- FF(3.5 only!) (2010-2013) -- don't bother!
	     *   'DOMMouseScroll'       -- FF(0.9.7+) since 2003
	     *
	     * So what to do?  The is the best:
	     *
	     *   normalizeWheel.getEventType();
	     *
	     * In your event callback, use this code to get sane interpretation of the
	     * deltas.  This code will return an object with properties:
	     *
	     *   spinX   -- normalized spin speed (use for zoom) - x plane
	     *   spinY   -- " - y plane
	     *   pixelX  -- normalized distance (to pixels) - x plane
	     *   pixelY  -- " - y plane
	     *
	     * Wheel values are provided by the browser assuming you are using the wheel to
	     * scroll a web page by a number of lines or pixels (or pages).  Values can vary
	     * significantly on different platforms and browsers, forgetting that you can
	     * scroll at different speeds.  Some devices (like trackpads) emit more events
	     * at smaller increments with fine granularity, and some emit massive jumps with
	     * linear speed or acceleration.
	     *
	     * This code does its best to normalize the deltas for you:
	     *
	     *   - spin is trying to normalize how far the wheel was spun (or trackpad
	     *     dragged).  This is super useful for zoom support where you want to
	     *     throw away the chunky scroll steps on the PC and make those equal to
	     *     the slow and smooth tiny steps on the Mac. Key data: This code tries to
	     *     resolve a single slow step on a wheel to 1.
	     *
	     *   - pixel is normalizing the desired scroll delta in pixel units.  You'll
	     *     get the crazy differences between browsers, but at least it'll be in
	     *     pixels!
	     *
	     *   - positive value indicates scrolling DOWN/RIGHT, negative UP/LEFT.  This
	     *     should translate to positive value zooming IN, negative zooming OUT.
	     *     This matches the newer 'wheel' event.
	     *
	     * Why are there spinX, spinY (or pixels)?
	     *
	     *   - spinX is a 2-finger side drag on the trackpad, and a shift + wheel turn
	     *     with a mouse.  It results in side-scrolling in the browser by default.
	     *
	     *   - spinY is what you expect -- it's the classic axis of a mouse wheel.
	     *
	     *   - I dropped spinZ/pixelZ.  It is supported by the DOM 3 'wheel' event and
	     *     probably is by browsers in conjunction with fancy 3D controllers .. but
	     *     you know.
	     *
	     * Implementation info:
	     *
	     * Examples of 'wheel' event if you scroll slowly (down) by one step with an
	     * average mouse:
	     *
	     *   OS X + Chrome  (mouse)     -    4   pixel delta  (wheelDelta -120)
	     *   OS X + Safari  (mouse)     -  N/A   pixel delta  (wheelDelta  -12)
	     *   OS X + Firefox (mouse)     -    0.1 line  delta  (wheelDelta  N/A)
	     *   Win8 + Chrome  (mouse)     -  100   pixel delta  (wheelDelta -120)
	     *   Win8 + Firefox (mouse)     -    3   line  delta  (wheelDelta -120)
	     *
	     * On the trackpad:
	     *
	     *   OS X + Chrome  (trackpad)  -    2   pixel delta  (wheelDelta   -6)
	     *   OS X + Firefox (trackpad)  -    1   pixel delta  (wheelDelta  N/A)
	     *
	     * On other/older browsers.. it's more complicated as there can be multiple and
	     * also missing delta values.
	     *
	     * The 'wheel' event is more standard:
	     *
	     * http://www.w3.org/TR/DOM-Level-3-Events/#events-wheelevents
	     *
	     * The basics is that it includes a unit, deltaMode (pixels, lines, pages), and
	     * deltaX, deltaY and deltaZ.  Some browsers provide other values to maintain
	     * backward compatibility with older events.  Those other values help us
	     * better normalize spin speed.  Example of what the browsers provide:
	     *
	     *                          | event.wheelDelta | event.detail
	     *        ------------------+------------------+--------------
	     *          Safari v5/OS X  |       -120       |       0
	     *          Safari v5/Win7  |       -120       |       0
	     *         Chrome v17/OS X  |       -120       |       0
	     *         Chrome v17/Win7  |       -120       |       0
	     *                IE9/Win7  |       -120       |   undefined
	     *         Firefox v4/OS X  |     undefined    |       1
	     *         Firefox v4/Win7  |     undefined    |       3
	     *
	     * from: https://github.com/facebook/fixed-data-table/blob/master/src/vendor_upstream/dom/normalizeWheel.js
	     * @param {any} event
	     * @return {any}
	     */
	    Utils.normalizeWheel = function (event) {
	        var PIXEL_STEP = 10;
	        var LINE_HEIGHT = 40;
	        var PAGE_HEIGHT = 800;
	        // spinX, spinY
	        var sX = 0;
	        var sY = 0;
	        // pixelX, pixelY
	        var pX = 0;
	        var pY = 0;
	        // Legacy
	        if ('detail' in event) {
	            sY = event.detail;
	        }
	        if ('wheelDelta' in event) {
	            sY = -event.wheelDelta / 120;
	        }
	        if ('wheelDeltaY' in event) {
	            sY = -event.wheelDeltaY / 120;
	        }
	        if ('wheelDeltaX' in event) {
	            sX = -event.wheelDeltaX / 120;
	        }
	        // side scrolling on FF with DOMMouseScroll
	        if ('axis' in event && event.axis === event.HORIZONTAL_AXIS) {
	            sX = sY;
	            sY = 0;
	        }
	        pX = sX * PIXEL_STEP;
	        pY = sY * PIXEL_STEP;
	        if ('deltaY' in event) {
	            pY = event.deltaY;
	        }
	        if ('deltaX' in event) {
	            pX = event.deltaX;
	        }
	        if ((pX || pY) && event.deltaMode) {
	            if (event.deltaMode == 1) { // delta in LINE units
	                pX *= LINE_HEIGHT;
	                pY *= LINE_HEIGHT;
	            }
	            else { // delta in PAGE units
	                pX *= PAGE_HEIGHT;
	                pY *= PAGE_HEIGHT;
	            }
	        }
	        // Fall-back if spin cannot be determined
	        if (pX && !sX) {
	            sX = (pX < 1) ? -1 : 1;
	        }
	        if (pY && !sY) {
	            sY = (pY < 1) ? -1 : 1;
	        }
	        return {
	            spinX: sX,
	            spinY: sY,
	            pixelX: pX,
	            pixelY: pY
	        };
	    };
	    /**
	     * from https://stackoverflow.com/questions/24004791/can-someone-explain-the-debounce-function-in-javascript
	     * @param {Function} func The function to be debounced
	     * @param {number} wait The time in ms to debounce
	     * @param {boolean} immediate If it should run immediately or wait for the initial debounce delay
	     * @return {Function} The debounced function
	     */
	    Utils.debounce = function (func, wait, immediate) {
	        if (immediate === void 0) { immediate = false; }
	        // 'private' variable for instance
	        // The returned function will be able to reference this due to closure.
	        // Each call to the returned function will share this common timer.
	        var timeout;
	        // Calling debounce returns a new anonymous function
	        return function () {
	            var args = [];
	            for (var _i = 0; _i < arguments.length; _i++) {
	                args[_i] = arguments[_i];
	            }
	            // reference the context and args for the setTimeout function
	            var context = this;
	            // Should the function be called now? If immediate is true
	            //   and not already in a timeout then the answer is: Yes
	            var callNow = immediate && !timeout;
	            // This is the basic debounce behaviour where you can call this
	            //   function several times, but it will only execute once
	            //   [before or after imposing a delay].
	            //   Each time the returned function is called, the timer starts over.
	            window.clearTimeout(timeout);
	            // Set the new timeout
	            timeout = window.setTimeout(function () {
	                // Inside the timeout function, clear the timeout variable
	                // which will let the next execution run when in 'immediate' mode
	                timeout = null;
	                // Check if the function already ran with the immediate flag
	                if (!immediate) {
	                    // Call the original function with apply
	                    // apply lets you define the 'this' object as well as the arguments
	                    //    (both captured before setTimeout)
	                    func.apply(context, args);
	                }
	            }, wait);
	            // Immediate mode and no wait timer? Execute the function..
	            if (callNow) {
	                func.apply(context, args);
	            }
	        };
	    };
	    /**
	     * a user once raised an issue - they said that when you opened a popup (eg context menu)
	     * and then clicked on a selection checkbox, the popup wasn't closed. this is because the
	     * popup listens for clicks on the body, however ag-grid WAS stopping propagation on the
	     * checkbox clicks (so the rows didn't pick them up as row selection selection clicks).
	     * to get around this, we have a pattern to stop propagation for the purposes of ag-Grid,
	     * but we still let the event pass back to teh body.
	     * @param {Event} event
	     */
	    Utils.stopPropagationForAgGrid = function (event) {
	        event[AG_GRID_STOP_PROPAGATION] = true;
	    };
	    Utils.isStopPropagationForAgGrid = function (event) {
	        return event[AG_GRID_STOP_PROPAGATION] === true;
	    };
	    Utils.executeInAWhile = function (funcs) {
	        this.executeAfter(funcs, 400);
	    };
	    Utils.executeNextVMTurn = function (funcs) {
	        this.executeAfter(funcs, 0);
	    };
	    Utils.executeAfter = function (funcs, millis) {
	        if (funcs.length > 0) {
	            window.setTimeout(function () {
	                funcs.forEach(function (func) { return func(); });
	            }, millis);
	        }
	    };
	    Utils.referenceCompare = function (left, right) {
	        if (left == null && right == null) {
	            return true;
	        }
	        if (left == null && right) {
	            return false;
	        }
	        if (left && right == null) {
	            return false;
	        }
	        return left === right;
	    };
	    Utils.get = function (source, expression, defaultValue) {
	        if (source == null) {
	            return defaultValue;
	        }
	        if (expression.indexOf('.') > -1) {
	            var fields = expression.split('.');
	            var thisKey = fields[0];
	            var nextValue_1 = source[thisKey];
	            if (nextValue_1 != null) {
	                return Utils.get(nextValue_1, fields.slice(1, fields.length).join('.'), defaultValue);
	            }
	            return defaultValue;
	        }
	        var nextValue = source[expression];
	        return nextValue != null ? nextValue : defaultValue;
	    };
	    Utils.addSafePassiveEventListener = function (frameworkOverrides, eElement, event, listener) {
	        var isPassive = Utils.PASSIVE_EVENTS.indexOf(event) >= 0;
	        var isOutsideAngular = Utils.OUTSIDE_ANGULAR_EVENTS.indexOf(event) >= 0;
	        var options = isPassive ? { passive: true } : undefined;
	        if (isOutsideAngular) {
	            frameworkOverrides.addEventListenerOutsideAngular(eElement, event, listener, options);
	        }
	        else {
	            eElement.addEventListener(event, listener, options);
	        }
	    };
	    /**
	     * Converts a camelCase string into regular text
	     * from: https://stackoverflow.com/questions/15369566/putting-space-in-camel-case-string-using-regular-expression
	     * @param {string} camelCase
	     * @return {string}
	     */
	    Utils.camelCaseToHumanText = function (camelCase) {
	        if (!camelCase || camelCase == null) {
	            return null;
	        }
	        var rex = /([A-Z])([A-Z])([a-z])|([a-z])([A-Z])/g;
	        var words = camelCase.replace(rex, '$1$4 $2$3$5').replace('.', ' ').split(' ');
	        return words.map(function (word) { return word.substring(0, 1).toUpperCase() + ((word.length > 1) ? word.substring(1, word.length) : ''); }).join(' ');
	    };
	    /**
	     * Displays a message to the browser. this is useful in iPad, where you can't easily see the console.
	     * so the javascript code can use this to give feedback. this is NOT intended to be called in production.
	     * it is intended the ag-Grid developer calls this to troubleshoot, but then takes out the calls before
	     * checking in.
	     * @param {string} msg
	     */
	    Utils.message = function (msg) {
	        var eMessage = document.createElement('div');
	        eMessage.innerHTML = msg;
	        var eBox = document.querySelector('#__ag__message');
	        if (!eBox) {
	            var template = "<div id=\"__ag__message\" style=\"display: inline-block; position: absolute; top: 0px; left: 0px; color: white; background-color: black; z-index: 20; padding: 2px; border: 1px solid darkred; height: 200px; overflow-y: auto;\"></div>";
	            eBox = this.loadTemplate(template);
	            if (document.body) {
	                document.body.appendChild(eBox);
	            }
	        }
	        eBox.insertBefore(eMessage, eBox.children[0]);
	        // eBox.appendChild(eMessage);
	    };
	    /**
	     * Gets called by: a) ClientSideNodeManager and b) GroupStage to do sorting.
	     * when in ClientSideNodeManager we always have indexes (as this sorts the items the
	     * user provided) but when in GroupStage, the nodes can contain filler nodes that
	     * don't have order id's
	     * @param {RowNode[]} rowNodes
	     * @param {Object} rowNodeOrder
	     */
	    Utils.sortRowNodesByOrder = function (rowNodes, rowNodeOrder) {
	        if (!rowNodes) {
	            return;
	        }
	        var comparator = function (nodeA, nodeB) {
	            var positionA = rowNodeOrder[nodeA.id];
	            var positionB = rowNodeOrder[nodeB.id];
	            var aHasIndex = positionA !== undefined;
	            var bHasIndex = positionB !== undefined;
	            var bothNodesAreUserNodes = aHasIndex && bHasIndex;
	            var bothNodesAreFillerNodes = !aHasIndex && !bHasIndex;
	            if (bothNodesAreUserNodes) {
	                // when comparing two nodes the user has provided, they always
	                // have indexes
	                return positionA - positionB;
	            }
	            else if (bothNodesAreFillerNodes) {
	                // when comparing two filler nodes, we have no index to compare them
	                // against, however we want this sorting to be deterministic, so that
	                // the rows don't jump around as the user does delta updates. so we
	                // want the same sort result. so we use the __objectId - which doesn't make sense
	                // from a sorting point of view, but does give consistent behaviour between
	                // calls. otherwise groups jump around as delta updates are done.
	                // note: previously here we used nodeId, however this gave a strange order
	                // as string ordering of numbers is wrong, so using id based on creation order
	                // as least gives better looking order.
	                return nodeA.__objectId - nodeB.__objectId;
	            }
	            else if (aHasIndex) {
	                return 1;
	            }
	            return -1;
	        };
	        // const a = new Date().getTime();
	        // check if the list first needs sorting
	        var rowNodeA;
	        var rowNodeB;
	        var atLeastOneOutOfOrder = false;
	        for (var i = 0; i < rowNodes.length - 1; i++) {
	            rowNodeA = rowNodes[i];
	            rowNodeB = rowNodes[i + 1];
	            if (comparator(rowNodeA, rowNodeB) > 0) {
	                atLeastOneOutOfOrder = true;
	                break;
	            }
	        }
	        // const b = new Date().getTime();
	        if (atLeastOneOutOfOrder) {
	            rowNodes.sort(comparator);
	        }
	        // const c = new Date().getTime();
	        // console.log(`${this.count}: ${rowNodes.length} items, ${b-a}ms ${atLeastOneOutOfOrder} ${c-b}ms`);
	    };
	    Utils.fuzzyCheckStrings = function (inputValues, validValues, allSuggestions) {
	        var _this = this;
	        var fuzzyMatches = {};
	        var invalidInputs = inputValues.filter(function (inputValue) {
	            return !validValues.some(function (validValue) { return validValue === inputValue; });
	        });
	        if (invalidInputs.length > 0) {
	            invalidInputs.forEach(function (invalidInput) {
	                return fuzzyMatches[invalidInput] = _this.fuzzySuggestions(invalidInput, allSuggestions);
	            });
	        }
	        return fuzzyMatches;
	    };
	    /**
	     *
	     * @param {String} inputValue The value to be compared against a list of strings
	     * @param allSuggestions The list of strings to be compared against
	     * @param hideIrrelevant By default, fuzzy suggestions will just sort the allSuggestions list, set this to true
	     *        to filter out the irrelevant values
	     * @param weighted Set this to true, to make letters matched in the order they were typed have priority in the results.
	     */
	    Utils.fuzzySuggestions = function (inputValue, allSuggestions, hideIrrelevant, weighted) {
	        var search = weighted ? exports._.string_weighted_distances : exports._.string_distances;
	        var thisSuggestions = allSuggestions.map(function (text) { return ({
	            value: text,
	            relevance: search(inputValue.toLowerCase(), text.toLocaleLowerCase())
	        }); });
	        thisSuggestions.sort(function (a, b) {
	            return b.relevance - a.relevance;
	        });
	        if (hideIrrelevant) {
	            thisSuggestions = thisSuggestions.filter(function (suggestion) { return suggestion.relevance !== 0; });
	        }
	        return thisSuggestions.map(function (suggestion) { return suggestion.value; });
	    };
	    /**
	     * Algorithm to do fuzzy search
	     * from https://stackoverflow.com/questions/23305000/javascript-fuzzy-search-that-makes-sense
	     * @param {string} from
	     * @return {[]}
	     */
	    Utils.get_bigrams = function (from) {
	        var s = from.toLowerCase();
	        var v = new Array(s.length - 1);
	        var i;
	        var j;
	        var ref;
	        for (i = j = 0, ref = v.length; j <= ref; i = j += 1) {
	            v[i] = s.slice(i, i + 2);
	        }
	        return v;
	    };
	    Utils.string_distances = function (str1, str2) {
	        if (str1.length === 0 && str2.length === 0) {
	            return 0;
	        }
	        var pairs1 = exports._.get_bigrams(str1);
	        var pairs2 = exports._.get_bigrams(str2);
	        var union = pairs1.length + pairs2.length;
	        var hit_count = 0;
	        var j;
	        var len;
	        for (j = 0, len = pairs1.length; j < len; j++) {
	            var x = pairs1[j];
	            var k = void 0;
	            var len1 = void 0;
	            for (k = 0, len1 = pairs2.length; k < len1; k++) {
	                var y = pairs2[k];
	                if (x === y) {
	                    hit_count++;
	                }
	            }
	        }
	        return hit_count > 0 ? (2 * hit_count) / union : 0;
	    };
	    Utils.string_weighted_distances = function (str1, str2) {
	        var a = str1.replace(/\s/g, '');
	        var b = str2.replace(/\s/g, '');
	        var weight = 0;
	        var lastIndex = 0;
	        for (var i = 0; i < a.length; i++) {
	            var idx = b.indexOf(a[i]);
	            if (idx === -1) {
	                continue;
	            }
	            lastIndex = idx;
	            weight += ((b.length - lastIndex) * 100) / b.length;
	            weight *= weight;
	        }
	        return weight;
	    };
	    Utils.isNumpadDelWithNumlockOnForEdgeOrIe = function (event) {
	        if (Utils.isBrowserEdge() || Utils.isBrowserIE()) {
	            return event.key === Utils.NUMPAD_DEL_NUMLOCK_ON_KEY &&
	                event.charCode === Utils.NUMPAD_DEL_NUMLOCK_ON_CHARCODE;
	        }
	        return false;
	    };
	    /**
	     * cell renderers are used in a few places. they bind to dom slightly differently to other cell renderes as they
	     * can return back strings (instead of html elemnt) in the getGui() method. common code placed here to handle that.
	     * @param {Promise<ICellRendererComp>} cellRendererPromise
	     * @param {HTMLElement} eTarget
	     */
	    Utils.bindCellRendererToHtmlElement = function (cellRendererPromise, eTarget) {
	        cellRendererPromise.then(function (cellRenderer) {
	            var gui = cellRenderer.getGui();
	            if (gui != null) {
	                if (typeof gui == 'object') {
	                    eTarget.appendChild(gui);
	                }
	                else {
	                    eTarget.innerHTML = gui;
	                }
	            }
	        });
	    };
	    Utils.PASSIVE_EVENTS = ['touchstart', 'touchend', 'touchmove', 'touchcancel'];
	    Utils.OUTSIDE_ANGULAR_EVENTS = ['mouseover', 'mouseout', 'mouseenter', 'mouseleave'];
	    Utils.PRINTABLE_CHARACTERS = 'qwertyuiopasdfghjklzxcvbnmQWERTYUIOPASDFGHJKLZXCVBNM1234567890!"£$%^&*()_+-=[];\'#,./\\|<>?:@~{}';
	    Utils.NUMPAD_DEL_NUMLOCK_ON_KEY = 'Del';
	    Utils.NUMPAD_DEL_NUMLOCK_ON_CHARCODE = 46;
	    Utils.doOnceFlags = {};
	    Utils.compose = function () {
	        var fns = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            fns[_i] = arguments[_i];
	        }
	        return function (arg) { return fns.reduce(function (composed, f) { return f(composed); }, arg); };
	    };
	    Utils.decToHex = function (number, bytes) {
	        var hex = '';
	        for (var i = 0; i < bytes; i++) {
	            hex += String.fromCharCode(number & 0xff);
	            number >>>= 8;
	        }
	        return hex;
	    };
	    /**
	     * It encodes any string in UTF-8 format
	     * taken from https://github.com/mathiasbynens/utf8.js
	     * @param {string} s
	     * @returns {string}
	     */
	    Utils.utf8_encode = function (s) {
	        var stringFromCharCode = String.fromCharCode;
	        function ucs2decode(string) {
	            var output = [];
	            var counter = 0;
	            var length = string.length;
	            var value;
	            var extra;
	            while (counter < length) {
	                value = string.charCodeAt(counter++);
	                if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
	                    // high surrogate, and there is a next character
	                    extra = string.charCodeAt(counter++);
	                    if ((extra & 0xFC00) == 0xDC00) { // low surrogate
	                        output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
	                    }
	                    else {
	                        // unmatched surrogate; only append this code unit, in case the next
	                        // code unit is the high surrogate of a surrogate pair
	                        output.push(value);
	                        counter--;
	                    }
	                }
	                else {
	                    output.push(value);
	                }
	            }
	            return output;
	        }
	        function checkScalarValue(codePoint) {
	            if (codePoint >= 0xD800 && codePoint <= 0xDFFF) {
	                throw Error('Lone surrogate U+' + codePoint.toString(16).toUpperCase() +
	                    ' is not a scalar value');
	            }
	        }
	        function createByte(codePoint, shift) {
	            return stringFromCharCode(((codePoint >> shift) & 0x3F) | 0x80);
	        }
	        function encodeCodePoint(codePoint) {
	            if ((codePoint & 0xFFFFFF80) == 0) { // 1-byte sequence
	                return stringFromCharCode(codePoint);
	            }
	            var symbol = '';
	            if ((codePoint & 0xFFFFF800) == 0) { // 2-byte sequence
	                symbol = stringFromCharCode(((codePoint >> 6) & 0x1F) | 0xC0);
	            }
	            else if ((codePoint & 0xFFFF0000) == 0) { // 3-byte sequence
	                checkScalarValue(codePoint);
	                symbol = stringFromCharCode(((codePoint >> 12) & 0x0F) | 0xE0);
	                symbol += createByte(codePoint, 6);
	            }
	            else if ((codePoint & 0xFFE00000) == 0) { // 4-byte sequence
	                symbol = stringFromCharCode(((codePoint >> 18) & 0x07) | 0xF0);
	                symbol += createByte(codePoint, 12);
	                symbol += createByte(codePoint, 6);
	            }
	            symbol += stringFromCharCode((codePoint & 0x3F) | 0x80);
	            return symbol;
	        }
	        var codePoints = ucs2decode(s);
	        var length = codePoints.length;
	        var index = -1;
	        var codePoint;
	        var byteString = '';
	        while (++index < length) {
	            codePoint = codePoints[index];
	            byteString += encodeCodePoint(codePoint);
	        }
	        return byteString;
	    };
	    Utils.iconNameClassMap = {
	        columnGroupOpened: 'expanded',
	        columnGroupClosed: 'contracted',
	        columnSelectClosed: 'tree-closed',
	        columnSelectOpen: 'tree-open',
	        columnSelectIndeterminate: 'tree-indeterminate',
	        columnMovePin: 'pin',
	        columnMoveAdd: 'plus',
	        columnMoveHide: 'eye-slash',
	        columnMoveMove: 'arrows',
	        columnMoveLeft: 'left',
	        columnMoveRight: 'right',
	        columnMoveGroup: 'group',
	        columnMoveValue: 'aggregation',
	        columnMovePivot: 'pivot',
	        dropNotAllowed: 'not-allowed',
	        groupContracted: 'expanded',
	        groupExpanded: 'contracted',
	        chart: 'chart',
	        close: 'cross',
	        cancel: 'cancel',
	        check: 'tick',
	        checkboxChecked: 'checkbox-checked',
	        checkboxUnchecked: 'checkbox-unchecked',
	        checkboxIndeterminate: 'checkbox-indeterminate',
	        checkboxCheckedReadOnly: 'checkbox-checked-readonly',
	        checkboxUncheckedReadOnly: 'checkbox-unchecked-readonly',
	        checkboxIndeterminateReadOnly: 'checkbox-indeterminate-readonly',
	        first: 'first',
	        previous: 'previous',
	        next: 'next',
	        last: 'last',
	        linked: 'linked',
	        unlinked: 'unlinked',
	        colorPicker: 'color-picker',
	        radioButtonOn: 'radio-button-on',
	        radioButtonOff: 'radio-button-off',
	        groupLoading: 'loading',
	        data: 'data',
	        menu: 'menu',
	        filter: 'filter',
	        columns: 'columns',
	        maximize: 'maximize',
	        minimize: 'minimize',
	        menuPin: 'pin',
	        menuValue: 'aggregation',
	        menuAddRowGroup: 'group',
	        menuRemoveRowGroup: 'group',
	        clipboardCopy: 'copy',
	        clipboardCut: 'cut',
	        clipboardPaste: 'paste',
	        pivotPanel: 'pivot',
	        rowGroupPanel: 'group',
	        valuePanel: 'aggregation',
	        columnDrag: 'grip',
	        rowDrag: 'grip',
	        save: 'save',
	        smallLeft: 'small-left',
	        smallRight: 'small-right',
	        smallUp: 'small-up',
	        smallDown: 'small-down',
	        sortAscending: 'asc',
	        sortDescending: 'desc',
	        sortUnSort: 'none'
	    };
	    return Utils;
	}());
	exports.Utils = Utils;
	var NumberSequence = /** @class */ (function () {
	    function NumberSequence(initValue, step) {
	        if (initValue === void 0) { initValue = 0; }
	        if (step === void 0) { step = 1; }
	        this.nextValue = initValue;
	        this.step = step;
	    }
	    NumberSequence.prototype.next = function () {
	        var valToReturn = this.nextValue;
	        this.nextValue += this.step;
	        return valToReturn;
	    };
	    NumberSequence.prototype.peek = function () {
	        return this.nextValue;
	    };
	    NumberSequence.prototype.skip = function (count) {
	        this.nextValue += count;
	    };
	    return NumberSequence;
	}());
	exports.NumberSequence = NumberSequence;
	exports._ = Utils;


/***/ }),
/* 2328 */
/***/ (function(module, exports) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Constants = /** @class */ (function () {
	    function Constants() {
	    }
	    Constants.STEP_EVERYTHING = 0;
	    Constants.STEP_FILTER = 1;
	    Constants.STEP_SORT = 2;
	    Constants.STEP_MAP = 3;
	    Constants.STEP_AGGREGATE = 4;
	    Constants.STEP_PIVOT = 5;
	    Constants.ROW_BUFFER_SIZE = 10;
	    Constants.LAYOUT_INTERVAL = 500;
	    Constants.BATCH_WAIT_MILLIS = 50;
	    Constants.EXPORT_TYPE_DRAG_COPY = 'dragCopy';
	    Constants.EXPORT_TYPE_CLIPBOARD = 'clipboard';
	    Constants.EXPORT_TYPE_EXCEL = 'excel';
	    Constants.EXPORT_TYPE_CSV = 'csv';
	    Constants.KEY_BACKSPACE = 8;
	    Constants.KEY_TAB = 9;
	    Constants.KEY_NEW_LINE = 10;
	    Constants.KEY_ENTER = 13;
	    Constants.KEY_SHIFT = 16;
	    Constants.KEY_ESCAPE = 27;
	    Constants.KEY_SPACE = 32;
	    Constants.KEY_LEFT = 37;
	    Constants.KEY_UP = 38;
	    Constants.KEY_RIGHT = 39;
	    Constants.KEY_DOWN = 40;
	    Constants.KEY_DELETE = 46;
	    Constants.KEY_A = 65;
	    Constants.KEY_C = 67;
	    Constants.KEY_V = 86;
	    Constants.KEY_D = 68;
	    Constants.KEY_F2 = 113;
	    Constants.KEY_PAGE_UP = 33;
	    Constants.KEY_PAGE_DOWN = 34;
	    Constants.KEY_PAGE_HOME = 36;
	    Constants.KEY_PAGE_END = 35;
	    Constants.ROW_MODEL_TYPE_INFINITE = 'infinite';
	    Constants.ROW_MODEL_TYPE_VIEWPORT = 'viewport';
	    Constants.ROW_MODEL_TYPE_CLIENT_SIDE = 'clientSide';
	    Constants.ROW_MODEL_TYPE_SERVER_SIDE = 'serverSide';
	    Constants.DEPRECATED_ROW_MODEL_TYPE_NORMAL = 'normal';
	    Constants.ALWAYS = 'always';
	    Constants.ONLY_WHEN_GROUPING = 'onlyWhenGrouping';
	    Constants.PINNED_TOP = 'top';
	    Constants.PINNED_BOTTOM = 'bottom';
	    Constants.DOM_LAYOUT_NORMAL = 'normal';
	    Constants.DOM_LAYOUT_PRINT = 'print';
	    Constants.DOM_LAYOUT_AUTO_HEIGHT = 'autoHeight';
	    Constants.GROUP_AUTO_COLUMN_ID = 'ag-Grid-AutoColumn';
	    return Constants;
	}());
	exports.Constants = Constants;


/***/ }),
/* 2329 */
/***/ (function(module, exports) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var PromiseStatus;
	(function (PromiseStatus) {
	    PromiseStatus[PromiseStatus["IN_PROGRESS"] = 0] = "IN_PROGRESS";
	    PromiseStatus[PromiseStatus["RESOLVED"] = 1] = "RESOLVED";
	})(PromiseStatus = exports.PromiseStatus || (exports.PromiseStatus = {}));
	var Promise = /** @class */ (function () {
	    function Promise(callback) {
	        this.status = PromiseStatus.IN_PROGRESS;
	        this.resolution = null;
	        this.listOfWaiters = [];
	        callback(this.onDone.bind(this), this.onReject.bind(this));
	    }
	    Promise.all = function (toCombine) {
	        return new Promise(function (resolve) {
	            var combinedValues = [];
	            var remainingToResolve = toCombine.length;
	            toCombine.forEach(function (source, index) {
	                source.then(function (sourceResolved) {
	                    remainingToResolve--;
	                    combinedValues[index] = sourceResolved;
	                    if (remainingToResolve == 0) {
	                        resolve(combinedValues);
	                    }
	                });
	                combinedValues.push(null); // spl todo: review with Alberto - why?
	            });
	        });
	    };
	    Promise.resolve = function (value) {
	        return new Promise(function (resolve) { return resolve(value); });
	    };
	    Promise.external = function () {
	        var capture;
	        var promise = new Promise(function (resolve) {
	            capture = resolve;
	        });
	        return {
	            promise: promise,
	            resolve: function (value) {
	                capture(value);
	            }
	        };
	    };
	    Promise.prototype.then = function (func) {
	        if (this.status === PromiseStatus.IN_PROGRESS) {
	            this.listOfWaiters.push(func);
	        }
	        else {
	            func(this.resolution);
	        }
	    };
	    Promise.prototype.firstOneOnly = function (func) {
	        if (this.status === PromiseStatus.IN_PROGRESS) {
	            if (this.listOfWaiters.length === 0) {
	                this.listOfWaiters.push(func);
	            }
	        }
	        else {
	            func(this.resolution);
	        }
	    };
	    Promise.prototype.map = function (adapter) {
	        var _this = this;
	        return new Promise(function (resolve) {
	            _this.then(function (unmapped) {
	                resolve(adapter(unmapped));
	            });
	        });
	    };
	    Promise.prototype.resolveNow = function (ifNotResolvedValue, ifResolved) {
	        if (this.status == PromiseStatus.IN_PROGRESS) {
	            return ifNotResolvedValue;
	        }
	        return ifResolved(this.resolution);
	    };
	    Promise.prototype.onDone = function (value) {
	        this.status = PromiseStatus.RESOLVED;
	        this.resolution = value;
	        this.listOfWaiters.forEach(function (waiter) { return waiter(value); });
	    };
	    Promise.prototype.onReject = function (params) {
	        console.warn('TBI');
	    };
	    return Promise;
	}());
	exports.Promise = Promise;


/***/ }),
/* 2330 */
/***/ (function(module, exports) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * A Util Class only used when debugging for printing time to console
	 */
	var Timer = /** @class */ (function () {
	    function Timer() {
	        this.timestamp = new Date().getTime();
	    }
	    Timer.prototype.print = function (msg) {
	        var duration = (new Date().getTime()) - this.timestamp;
	        console.info(msg + " = " + duration);
	        this.timestamp = new Date().getTime();
	    };
	    return Timer;
	}());
	exports.Timer = Timer;


/***/ }),
/* 2331 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var __param = (this && this.__param) || function (paramIndex, decorator) {
	    return function (target, key) { decorator(target, key, paramIndex); }
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var logger_1 = __webpack_require__(2332);
	var context_1 = __webpack_require__(2333);
	var context_2 = __webpack_require__(2333);
	var gridOptionsWrapper_1 = __webpack_require__(2324);
	var utils_1 = __webpack_require__(2325);
	var EventService = /** @class */ (function () {
	    function EventService() {
	        this.allSyncListeners = {};
	        this.allAsyncListeners = {};
	        this.globalSyncListeners = [];
	        this.globalAsyncListeners = [];
	        this.asyncFunctionsQueue = [];
	        this.scheduled = false;
	        this.firedEvents = {};
	    }
	    EventService_1 = EventService;
	    // because this class is used both inside the context and outside the context, we do not
	    // use autowired attributes, as that would be confusing, as sometimes the attributes
	    // would be wired, and sometimes not.
	    //
	    // the global event servers used by ag-Grid is autowired by the context once, and this
	    // setBeans method gets called once.
	    //
	    // the times when this class is used outside of the context (eg RowNode has an instance of this
	    // class) then it is not a bean, and this setBeans method is not called.
	    EventService.prototype.setBeans = function (loggerFactory, gridOptionsWrapper, globalEventListener) {
	        if (globalEventListener === void 0) { globalEventListener = null; }
	        this.logger = loggerFactory.create('EventService');
	        if (globalEventListener) {
	            var async = gridOptionsWrapper.useAsyncEvents();
	            this.addGlobalListener(globalEventListener, async);
	        }
	    };
	    EventService.prototype.getListenerList = function (eventType, async) {
	        var listenerMap = async ? this.allAsyncListeners : this.allSyncListeners;
	        var listenerList = listenerMap[eventType];
	        if (!listenerList) {
	            listenerList = [];
	            listenerMap[eventType] = listenerList;
	        }
	        return listenerList;
	    };
	    EventService.prototype.addEventListener = function (eventType, listener, async) {
	        if (async === void 0) { async = false; }
	        var listenerList = this.getListenerList(eventType, async);
	        if (listenerList.indexOf(listener) < 0) {
	            listenerList.push(listener);
	        }
	    };
	    // for some events, it's important that the model gets to hear about them before the view,
	    // as the model may need to update before the view works on the info. if you register
	    // via this method, you get notified before the view parts
	    EventService.prototype.addModalPriorityEventListener = function (eventType, listener, async) {
	        if (async === void 0) { async = false; }
	        this.addEventListener(eventType + EventService_1.PRIORITY, listener, async);
	    };
	    EventService.prototype.addGlobalListener = function (listener, async) {
	        if (async === void 0) { async = false; }
	        if (async) {
	            this.globalAsyncListeners.push(listener);
	        }
	        else {
	            this.globalSyncListeners.push(listener);
	        }
	    };
	    EventService.prototype.removeEventListener = function (eventType, listener, async) {
	        if (async === void 0) { async = false; }
	        var listenerList = this.getListenerList(eventType, async);
	        utils_1._.removeFromArray(listenerList, listener);
	    };
	    EventService.prototype.removeGlobalListener = function (listener, async) {
	        if (async === void 0) { async = false; }
	        if (async) {
	            utils_1._.removeFromArray(this.globalAsyncListeners, listener);
	        }
	        else {
	            utils_1._.removeFromArray(this.globalSyncListeners, listener);
	        }
	    };
	    // why do we pass the type here? the type is in ColumnChangeEvent, so unless the
	    // type is not in other types of events???
	    EventService.prototype.dispatchEvent = function (event) {
	        // console.log(`dispatching ${eventType}: ${event}`);
	        this.dispatchToListeners(event, true);
	        this.dispatchToListeners(event, false);
	        this.firedEvents[event.type] = true;
	    };
	    EventService.prototype.dispatchEventOnce = function (event) {
	        if (!this.firedEvents[event.type]) {
	            this.dispatchEvent(event);
	        }
	    };
	    EventService.prototype.dispatchToListeners = function (event, async) {
	        var _this = this;
	        var globalListeners = async ? this.globalAsyncListeners : this.globalSyncListeners;
	        var eventType = event.type;
	        // this allows the columnController to get events before anyone else
	        var p1ListenerList = this.getListenerList(eventType + EventService_1.PRIORITY, async);
	        utils_1._.forEachSnapshotFirst(p1ListenerList, function (listener) {
	            if (async) {
	                _this.dispatchAsync(function () { return listener(event); });
	            }
	            else {
	                listener(event);
	            }
	        });
	        var listenerList = this.getListenerList(eventType, async);
	        utils_1._.forEachSnapshotFirst(listenerList, function (listener) {
	            if (async) {
	                _this.dispatchAsync(function () { return listener(event); });
	            }
	            else {
	                listener(event);
	            }
	        });
	        utils_1._.forEachSnapshotFirst(globalListeners, function (listener) {
	            if (async) {
	                _this.dispatchAsync(function () { return listener(eventType, event); });
	            }
	            else {
	                listener(eventType, event);
	            }
	        });
	    };
	    // this gets called inside the grid's thread, for each event that it
	    // wants to set async. the grid then batches the events into one setTimeout()
	    // because setTimeout() is an expensive operation. ideally we would have
	    // each event in it's own setTimeout(), but we batch for performance.
	    EventService.prototype.dispatchAsync = function (func) {
	        // add to the queue for executing later in the next VM turn
	        this.asyncFunctionsQueue.push(func);
	        // check if timeout is already scheduled. the first time the grid calls
	        // this within it's thread turn, this should be false, so it will schedule
	        // the 'flush queue' method the first time it comes here. then the flag is
	        // set to 'true' so it will know it's already scheduled for subsequent calls.
	        if (!this.scheduled) {
	            // if not scheduled, schedule one
	            window.setTimeout(this.flushAsyncQueue.bind(this), 0);
	            // mark that it is scheduled
	            this.scheduled = true;
	        }
	    };
	    // this happens in the next VM turn only, and empties the queue of events
	    EventService.prototype.flushAsyncQueue = function () {
	        this.scheduled = false;
	        // we take a copy, because the event listener could be using
	        // the grid, which would cause more events, which would be potentially
	        // added to the queue, so safe to take a copy, the new events will
	        // get executed in a later VM turn rather than risk updating the
	        // queue as we are flushing it.
	        var queueCopy = this.asyncFunctionsQueue.slice();
	        this.asyncFunctionsQueue = [];
	        // execute the queue
	        queueCopy.forEach(function (func) { return func(); });
	    };
	    var EventService_1;
	    // this is an old idea niall had, should really take it out, was to do with ordering who gets to process
	    // events first, to give model and service objects preference over the view
	    EventService.PRIORITY = '-P1';
	    __decorate([
	        __param(0, context_2.Qualifier('loggerFactory')),
	        __param(1, context_2.Qualifier('gridOptionsWrapper')),
	        __param(2, context_2.Qualifier('globalEventListener')),
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", [logger_1.LoggerFactory,
	            gridOptionsWrapper_1.GridOptionsWrapper,
	            Function]),
	        __metadata("design:returntype", void 0)
	    ], EventService.prototype, "setBeans", null);
	    EventService = EventService_1 = __decorate([
	        context_1.Bean('eventService')
	    ], EventService);
	    return EventService;
	}());
	exports.EventService = EventService;


/***/ }),
/* 2332 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var __param = (this && this.__param) || function (paramIndex, decorator) {
	    return function (target, key) { decorator(target, key, paramIndex); }
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var gridOptionsWrapper_1 = __webpack_require__(2324);
	var context_1 = __webpack_require__(2333);
	var context_2 = __webpack_require__(2333);
	var LoggerFactory = /** @class */ (function () {
	    function LoggerFactory() {
	    }
	    LoggerFactory.prototype.setBeans = function (gridOptionsWrapper) {
	        this.logging = gridOptionsWrapper.isDebug();
	    };
	    LoggerFactory.prototype.create = function (name) {
	        return new Logger(name, this.isLogging.bind(this));
	    };
	    LoggerFactory.prototype.isLogging = function () {
	        return this.logging;
	    };
	    __decorate([
	        __param(0, context_2.Qualifier('gridOptionsWrapper')),
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", [gridOptionsWrapper_1.GridOptionsWrapper]),
	        __metadata("design:returntype", void 0)
	    ], LoggerFactory.prototype, "setBeans", null);
	    LoggerFactory = __decorate([
	        context_1.Bean('loggerFactory')
	    ], LoggerFactory);
	    return LoggerFactory;
	}());
	exports.LoggerFactory = LoggerFactory;
	var Logger = /** @class */ (function () {
	    function Logger(name, isLoggingFunc) {
	        this.name = name;
	        this.isLoggingFunc = isLoggingFunc;
	    }
	    Logger.prototype.isLogging = function () {
	        return this.isLoggingFunc();
	    };
	    Logger.prototype.log = function (message) {
	        if (this.isLoggingFunc()) {
	            // tslint:disable-next-line
	            console.log('ag-Grid.' + this.name + ': ' + message);
	        }
	    };
	    return Logger;
	}());
	exports.Logger = Logger;


/***/ }),
/* 2333 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var utils_1 = __webpack_require__(2325);
	var Context = /** @class */ (function () {
	    function Context(params, logger) {
	        this.beanWrappers = {};
	        this.registeredModules = [];
	        this.componentsMappedByName = {};
	        this.destroyed = false;
	        if (!params || !params.beans) {
	            return;
	        }
	        this.contextParams = params;
	        this.registeredModules = params.registeredModules;
	        this.logger = logger;
	        this.logger.log(">> creating ag-Application Context");
	        this.setupComponents();
	        this.createBeans();
	        var beanInstances = this.getBeanInstances();
	        this.wireBeans(beanInstances);
	        this.logger.log(">> ag-Application Context ready - component is alive");
	    }
	    Context.prototype.getBeanInstances = function () {
	        return utils_1._.mapObject(this.beanWrappers, function (beanEntry) { return beanEntry.beanInstance; });
	    };
	    Context.prototype.setupComponents = function () {
	        var _this = this;
	        if (this.contextParams.components) {
	            this.contextParams.components.forEach(function (componentMeta) { return _this.addComponent(componentMeta); });
	        }
	    };
	    Context.prototype.addComponent = function (componentMeta) {
	        // get name of the class as a string
	        // let className = _.getNameOfClass(ComponentClass);
	        // insert a dash after every capital letter
	        // let classEscaped = className.replace(/([A-Z])/g, "-$1").toLowerCase();
	        var classEscaped = componentMeta.componentName.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();
	        // put all to upper case
	        var classUpperCase = classEscaped.toUpperCase();
	        // finally store
	        this.componentsMappedByName[classUpperCase] = componentMeta.theClass;
	    };
	    Context.prototype.createComponentFromElement = function (element, afterPreCreateCallback) {
	        var key = element.nodeName;
	        if (this.componentsMappedByName && this.componentsMappedByName[key]) {
	            var newComponent = new this.componentsMappedByName[key]();
	            this.wireBean(newComponent, afterPreCreateCallback);
	            return newComponent;
	        }
	        return null;
	    };
	    Context.prototype.wireBean = function (bean, afterPreCreateCallback) {
	        if (!bean) {
	            throw Error("Can't wire to bean since it is null");
	        }
	        this.wireBeans([bean], afterPreCreateCallback);
	    };
	    Context.prototype.wireBeans = function (beanInstances, afterPreCreateCallback) {
	        this.autoWireBeans(beanInstances);
	        this.methodWireBeans(beanInstances);
	        this.callLifeCycleMethods(beanInstances, 'preConstructMethods');
	        // the callback sets the attributes, so the component has access to attributes
	        // before postConstruct methods in the component are executed
	        if (utils_1._.exists(afterPreCreateCallback)) {
	            beanInstances.forEach(afterPreCreateCallback);
	        }
	        this.callLifeCycleMethods(beanInstances, 'postConstructMethods');
	    };
	    Context.prototype.createBeans = function () {
	        var _this = this;
	        // register all normal beans
	        this.contextParams.beans.forEach(this.createBeanWrapper.bind(this));
	        // register override beans, these will overwrite beans above of same name
	        if (this.contextParams.overrideBeans) {
	            this.contextParams.overrideBeans.forEach(this.createBeanWrapper.bind(this));
	        }
	        // instantiate all beans - overridden beans will be left out
	        utils_1._.iterateObject(this.beanWrappers, function (key, beanEntry) {
	            var constructorParamsMeta;
	            if (beanEntry.bean.__agBeanMetaData && beanEntry.bean.__agBeanMetaData.autowireMethods && beanEntry.bean.__agBeanMetaData.autowireMethods.agConstructor) {
	                constructorParamsMeta = beanEntry.bean.__agBeanMetaData.autowireMethods.agConstructor;
	            }
	            var constructorParams = _this.getBeansForParameters(constructorParamsMeta, beanEntry.bean.name);
	            var newInstance = applyToConstructor(beanEntry.bean, constructorParams);
	            beanEntry.beanInstance = newInstance;
	            _this.logger.log("bean " + _this.getBeanName(newInstance) + " created");
	        });
	    };
	    // tslint:disable-next-line
	    Context.prototype.createBeanWrapper = function (Bean) {
	        var metaData = Bean.__agBeanMetaData;
	        if (!metaData) {
	            var beanName = void 0;
	            if (Bean.prototype.constructor) {
	                beanName = Bean.prototype.constructor.name;
	            }
	            else {
	                beanName = "" + Bean;
	            }
	            console.error("context item " + beanName + " is not a bean");
	            return;
	        }
	        var beanEntry = {
	            bean: Bean,
	            beanInstance: null,
	            beanName: metaData.beanName
	        };
	        this.beanWrappers[metaData.beanName] = beanEntry;
	    };
	    Context.prototype.autoWireBeans = function (beanInstances) {
	        var _this = this;
	        beanInstances.forEach(function (beanInstance) {
	            _this.forEachMetaDataInHierarchy(beanInstance, function (metaData, beanName) {
	                var attributes = metaData.agClassAttributes;
	                if (!attributes) {
	                    return;
	                }
	                attributes.forEach(function (attribute) {
	                    var otherBean = _this.lookupBeanInstance(beanName, attribute.beanName, attribute.optional);
	                    beanInstance[attribute.attributeName] = otherBean;
	                });
	            });
	        });
	    };
	    Context.prototype.methodWireBeans = function (beanInstances) {
	        var _this = this;
	        beanInstances.forEach(function (beanInstance) {
	            _this.forEachMetaDataInHierarchy(beanInstance, function (metaData, beanName) {
	                utils_1._.iterateObject(metaData.autowireMethods, function (methodName, wireParams) {
	                    // skip constructor, as this is dealt with elsewhere
	                    if (methodName === "agConstructor") {
	                        return;
	                    }
	                    var initParams = _this.getBeansForParameters(wireParams, beanName);
	                    beanInstance[methodName].apply(beanInstance, initParams);
	                });
	            });
	        });
	    };
	    Context.prototype.forEachMetaDataInHierarchy = function (beanInstance, callback) {
	        var prototype = Object.getPrototypeOf(beanInstance);
	        while (prototype != null) {
	            var constructor = prototype.constructor;
	            if (constructor.hasOwnProperty('__agBeanMetaData')) {
	                var metaData = constructor.__agBeanMetaData;
	                var beanName = this.getBeanName(constructor);
	                callback(metaData, beanName);
	            }
	            prototype = Object.getPrototypeOf(prototype);
	        }
	    };
	    Context.prototype.getBeanName = function (constructor) {
	        if (constructor.__agBeanMetaData && constructor.__agBeanMetaData.beanName) {
	            return constructor.__agBeanMetaData.beanName;
	        }
	        var constructorString = constructor.toString();
	        var beanName = constructorString.substring(9, constructorString.indexOf("("));
	        return beanName;
	    };
	    Context.prototype.getBeansForParameters = function (parameters, beanName) {
	        var _this = this;
	        var beansList = [];
	        if (parameters) {
	            utils_1._.iterateObject(parameters, function (paramIndex, otherBeanName) {
	                var otherBean = _this.lookupBeanInstance(beanName, otherBeanName);
	                beansList[Number(paramIndex)] = otherBean;
	            });
	        }
	        return beansList;
	    };
	    Context.prototype.lookupBeanInstance = function (wiringBean, beanName, optional) {
	        if (optional === void 0) { optional = false; }
	        if (beanName === "context") {
	            return this;
	        }
	        else if (this.contextParams.seed && this.contextParams.seed.hasOwnProperty(beanName)) {
	            return this.contextParams.seed[beanName];
	        }
	        else {
	            var beanEntry = this.beanWrappers[beanName];
	            if (beanEntry) {
	                return beanEntry.beanInstance;
	            }
	            if (!optional) {
	                console.error("ag-Grid: unable to find bean reference " + beanName + " while initialising " + wiringBean);
	            }
	            return null;
	        }
	    };
	    Context.prototype.callLifeCycleMethods = function (beanInstances, lifeCycleMethod) {
	        var _this = this;
	        beanInstances.forEach(function (beanInstance) {
	            _this.forEachMetaDataInHierarchy(beanInstance, function (metaData) {
	                var methods = metaData[lifeCycleMethod];
	                if (!methods) {
	                    return;
	                }
	                methods.forEach(function (methodName) { return beanInstance[methodName](); });
	            });
	        });
	    };
	    Context.prototype.getBean = function (name) {
	        return this.lookupBeanInstance("getBean", name, true);
	    };
	    Context.prototype.getEnterpriseDefaultComponents = function () {
	        return this.contextParams.enterpriseDefaultComponents;
	    };
	    Context.prototype.destroy = function () {
	        // should only be able to destroy once
	        if (this.destroyed) {
	            return;
	        }
	        this.logger.log(">> Shutting down ag-Application Context");
	        var beanInstances = this.getBeanInstances();
	        this.callLifeCycleMethods(beanInstances, 'preDestroyMethods');
	        this.contextParams.seed = null;
	        this.destroyed = true;
	        this.logger.log(">> ag-Application Context shut down - component is dead");
	    };
	    Context.prototype.isModuleRegistered = function (moduleName) {
	        return this.registeredModules.indexOf(moduleName) !== -1;
	    };
	    return Context;
	}());
	exports.Context = Context;
	// taken from: http://stackoverflow.com/questions/3362471/how-can-i-call-a-javascript-constructor-using-call-or-apply
	// allows calling 'apply' on a constructor
	function applyToConstructor(constructor, argArray) {
	    var args = [null].concat(argArray);
	    var factoryFunction = constructor.bind.apply(constructor, args);
	    return new factoryFunction();
	}
	function PreConstruct(target, methodName, descriptor) {
	    var props = getOrCreateProps(target.constructor);
	    if (!props.postConstructMethods) {
	        props.preConstructMethods = [];
	    }
	    props.preConstructMethods.push(methodName);
	}
	exports.PreConstruct = PreConstruct;
	function PostConstruct(target, methodName, descriptor) {
	    var props = getOrCreateProps(target.constructor);
	    if (!props.postConstructMethods) {
	        props.postConstructMethods = [];
	    }
	    props.postConstructMethods.push(methodName);
	}
	exports.PostConstruct = PostConstruct;
	function PreDestroy(target, methodName, descriptor) {
	    var props = getOrCreateProps(target.constructor);
	    if (!props.preDestroyMethods) {
	        props.preDestroyMethods = [];
	    }
	    props.preDestroyMethods.push(methodName);
	}
	exports.PreDestroy = PreDestroy;
	function Bean(beanName) {
	    return function (classConstructor) {
	        var props = getOrCreateProps(classConstructor);
	        props.beanName = beanName;
	    };
	}
	exports.Bean = Bean;
	function Autowired(name) {
	    return function (target, propertyKey, descriptor) {
	        autowiredFunc(target, name, false, target, propertyKey, null);
	    };
	}
	exports.Autowired = Autowired;
	function Optional(name) {
	    return function (target, propertyKey, descriptor) {
	        autowiredFunc(target, name, true, target, propertyKey, null);
	    };
	}
	exports.Optional = Optional;
	function autowiredFunc(target, name, optional, classPrototype, methodOrAttributeName, index) {
	    if (name === null) {
	        console.error("ag-Grid: Autowired name should not be null");
	        return;
	    }
	    if (typeof index === "number") {
	        console.error("ag-Grid: Autowired should be on an attribute");
	        return;
	    }
	    // it's an attribute on the class
	    var props = getOrCreateProps(target.constructor);
	    if (!props.agClassAttributes) {
	        props.agClassAttributes = [];
	    }
	    props.agClassAttributes.push({
	        attributeName: methodOrAttributeName,
	        beanName: name,
	        optional: optional
	    });
	}
	function Qualifier(name) {
	    return function (classPrototype, methodOrAttributeName, index) {
	        var constructor = typeof classPrototype == "function" ? classPrototype : classPrototype.constructor;
	        var props;
	        if (typeof index === "number") {
	            // it's a parameter on a method
	            var methodName = void 0;
	            if (methodOrAttributeName) {
	                props = getOrCreateProps(constructor);
	                methodName = methodOrAttributeName;
	            }
	            else {
	                props = getOrCreateProps(constructor);
	                methodName = "agConstructor";
	            }
	            if (!props.autowireMethods) {
	                props.autowireMethods = {};
	            }
	            if (!props.autowireMethods[methodName]) {
	                props.autowireMethods[methodName] = {};
	            }
	            props.autowireMethods[methodName][index] = name;
	        }
	    };
	}
	exports.Qualifier = Qualifier;
	function getOrCreateProps(target) {
	    if (!target.hasOwnProperty("__agBeanMetaData")) {
	        target.__agBeanMetaData = {};
	    }
	    return target.__agBeanMetaData;
	}


/***/ }),
/* 2334 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var events_1 = __webpack_require__(2335);
	var propertyKeys_1 = __webpack_require__(2337);
	var gridOptionsWrapper_1 = __webpack_require__(2324);
	var utils_1 = __webpack_require__(2325);
	var ComponentUtil = /** @class */ (function () {
	    function ComponentUtil() {
	    }
	    ComponentUtil.getEventCallbacks = function () {
	        if (!ComponentUtil.EVENT_CALLBACKS) {
	            ComponentUtil.EVENT_CALLBACKS = [];
	            ComponentUtil.EVENT_CALLBACKS_NO_PREFIX = [];
	            ComponentUtil.EVENTS.forEach(function (eventName) {
	                ComponentUtil.EVENT_CALLBACKS.push(ComponentUtil.getCallbackForEvent(eventName));
	                ComponentUtil.EVENT_CALLBACKS_NO_PREFIX.push(eventName);
	            });
	        }
	        return ComponentUtil.EVENT_CALLBACKS;
	    };
	    ComponentUtil.copyAttributesToGridOptions = function (gridOptions, component, skipEventDeprecationCheck) {
	        if (skipEventDeprecationCheck === void 0) { skipEventDeprecationCheck = false; }
	        checkForDeprecated(component);
	        // create empty grid options if none were passed
	        if (typeof gridOptions !== 'object') {
	            gridOptions = {};
	        }
	        // to allow array style lookup in TypeScript, take type away from 'this' and 'gridOptions'
	        var pGridOptions = gridOptions;
	        // add in all the simple properties
	        ComponentUtil.ARRAY_PROPERTIES
	            .concat(ComponentUtil.STRING_PROPERTIES)
	            .concat(ComponentUtil.OBJECT_PROPERTIES)
	            .concat(ComponentUtil.FUNCTION_PROPERTIES)
	            .forEach(function (key) {
	            if (typeof component[key] !== 'undefined') {
	                pGridOptions[key] = component[key];
	            }
	        });
	        ComponentUtil.BOOLEAN_PROPERTIES.forEach(function (key) {
	            if (typeof component[key] !== 'undefined') {
	                pGridOptions[key] = ComponentUtil.toBoolean(component[key]);
	            }
	        });
	        ComponentUtil.NUMBER_PROPERTIES.forEach(function (key) {
	            if (typeof component[key] !== 'undefined') {
	                pGridOptions[key] = ComponentUtil.toNumber(component[key]);
	            }
	        });
	        ComponentUtil.getEventCallbacks().forEach(function (funcName) {
	            if (typeof component[funcName] !== 'undefined') {
	                pGridOptions[funcName] = component[funcName];
	            }
	        });
	        // purely for event deprecation checks (for frameworks - wouldn't apply for non-fw versions)
	        if (!skipEventDeprecationCheck) {
	            ComponentUtil.EVENT_CALLBACKS_NO_PREFIX.forEach(function (funcName) {
	                // react uses onXXX...not sure why this is diff to the other frameworks
	                var onMethodName = ComponentUtil.getCallbackForEvent(funcName);
	                if (typeof component[funcName] !== 'undefined' ||
	                    typeof component[onMethodName] !== 'undefined') {
	                    gridOptionsWrapper_1.GridOptionsWrapper.checkEventDeprecation(funcName);
	                }
	            });
	        }
	        return gridOptions;
	    };
	    ComponentUtil.getCallbackForEvent = function (eventName) {
	        if (!eventName || eventName.length < 2) {
	            return eventName;
	        }
	        else {
	            return 'on' + eventName[0].toUpperCase() + eventName.substr(1);
	        }
	    };
	    ComponentUtil.processOnChange = function (changes, gridOptions, api, columnApi) {
	        if (!changes) {
	            return;
	        }
	        checkForDeprecated(changes);
	        // to allow array style lookup in TypeScript, take type away from 'this' and 'gridOptions'
	        var pGridOptions = gridOptions;
	        // check if any change for the simple types, and if so, then just copy in the new value
	        ComponentUtil.ARRAY_PROPERTIES
	            .concat(ComponentUtil.OBJECT_PROPERTIES)
	            .concat(ComponentUtil.STRING_PROPERTIES)
	            .forEach(function (key) {
	            if (changes[key]) {
	                pGridOptions[key] = changes[key].currentValue;
	            }
	        });
	        ComponentUtil.BOOLEAN_PROPERTIES.forEach(function (key) {
	            if (changes[key]) {
	                pGridOptions[key] = ComponentUtil.toBoolean(changes[key].currentValue);
	            }
	        });
	        ComponentUtil.NUMBER_PROPERTIES.forEach(function (key) {
	            if (changes[key]) {
	                pGridOptions[key] = ComponentUtil.toNumber(changes[key].currentValue);
	            }
	        });
	        ComponentUtil.getEventCallbacks().forEach(function (funcName) {
	            if (changes[funcName]) {
	                pGridOptions[funcName] = changes[funcName].currentValue;
	            }
	        });
	        if (changes.enableCellTextSelection) {
	            api.setEnableCellTextSelection(ComponentUtil.toBoolean(changes.enableCellTextSelection.currentValue));
	        }
	        if (changes.showToolPanel) {
	            api.showToolPanel(ComponentUtil.toBoolean(changes.showToolPanel.currentValue));
	        }
	        if (changes.quickFilterText) {
	            api.setQuickFilter(changes.quickFilterText.currentValue);
	        }
	        if (changes.rowData) {
	            api.setRowData(changes.rowData.currentValue);
	        }
	        if (changes.pinnedTopRowData) {
	            api.setPinnedTopRowData(changes.pinnedTopRowData.currentValue);
	        }
	        if (changes.pinnedBottomRowData) {
	            api.setPinnedBottomRowData(changes.pinnedBottomRowData.currentValue);
	        }
	        if (changes.columnDefs) {
	            api.setColumnDefs(changes.columnDefs.currentValue, "gridOptionsChanged");
	        }
	        if (changes.datasource) {
	            api.setDatasource(changes.datasource.currentValue);
	        }
	        if (changes.headerHeight) {
	            api.setHeaderHeight(ComponentUtil.toNumber(changes.headerHeight.currentValue));
	        }
	        if (changes.paginationPageSize) {
	            api.paginationSetPageSize(ComponentUtil.toNumber(changes.paginationPageSize.currentValue));
	        }
	        if (changes.pivotMode) {
	            columnApi.setPivotMode(ComponentUtil.toBoolean(changes.pivotMode.currentValue));
	        }
	        if (changes.groupRemoveSingleChildren) {
	            api.setGroupRemoveSingleChildren(ComponentUtil.toBoolean(changes.groupRemoveSingleChildren.currentValue));
	        }
	        if (changes.suppressRowDrag) {
	            api.setSuppressRowDrag(ComponentUtil.toBoolean(changes.suppressRowDrag.currentValue));
	        }
	        if (changes.gridAutoHeight) {
	            api.setGridAutoHeight(ComponentUtil.toBoolean(changes.gridAutoHeight.currentValue));
	        }
	        if (changes.suppressClipboardPaste) {
	            api.setSuppressClipboardPaste(ComponentUtil.toBoolean(changes.suppressClipboardPaste.currentValue));
	        }
	        if (changes.sideBar) {
	            api.setSideBar(changes.sideBar.currentValue);
	        }
	        if (changes.datasource) {
	            api.setDatasource(changes.datasource.currentValue);
	        }
	        // copy changes into an event for dispatch
	        var event = {
	            type: events_1.Events.EVENT_COMPONENT_STATE_CHANGED,
	            api: gridOptions.api,
	            columnApi: gridOptions.columnApi
	        };
	        utils_1._.iterateObject(changes, function (key, value) {
	            event[key] = value;
	        });
	        api.dispatchEvent(event);
	    };
	    ComponentUtil.toBoolean = function (value) {
	        if (typeof value === 'boolean') {
	            return value;
	        }
	        else if (typeof value === 'string') {
	            // for boolean, compare to empty String to allow attributes appearing with
	            // not value to be treated as 'true'
	            return value.toUpperCase() === 'TRUE' || value == '';
	        }
	        else {
	            return false;
	        }
	    };
	    ComponentUtil.toNumber = function (value) {
	        if (typeof value === 'number') {
	            return value;
	        }
	        else if (typeof value === 'string') {
	            return Number(value);
	        }
	        else {
	            return undefined;
	        }
	    };
	    // all the events are populated in here AFTER this class (at the bottom of the file).
	    ComponentUtil.EVENTS = [];
	    ComponentUtil.STRING_PROPERTIES = propertyKeys_1.PropertyKeys.STRING_PROPERTIES;
	    ComponentUtil.OBJECT_PROPERTIES = propertyKeys_1.PropertyKeys.OBJECT_PROPERTIES;
	    ComponentUtil.ARRAY_PROPERTIES = propertyKeys_1.PropertyKeys.ARRAY_PROPERTIES;
	    ComponentUtil.NUMBER_PROPERTIES = propertyKeys_1.PropertyKeys.NUMBER_PROPERTIES;
	    ComponentUtil.BOOLEAN_PROPERTIES = propertyKeys_1.PropertyKeys.BOOLEAN_PROPERTIES;
	    ComponentUtil.FUNCTION_PROPERTIES = propertyKeys_1.PropertyKeys.FUNCTION_PROPERTIES;
	    ComponentUtil.ALL_PROPERTIES = propertyKeys_1.PropertyKeys.ALL_PROPERTIES;
	    return ComponentUtil;
	}());
	exports.ComponentUtil = ComponentUtil;
	utils_1._.iterateObject(events_1.Events, function (key, value) {
	    ComponentUtil.EVENTS.push(value);
	});
	function checkForDeprecated(changes) {
	    if (changes.rowDeselected || changes.onRowDeselected) {
	        console.warn('ag-grid: as of v3.4 rowDeselected no longer exists. Please check the docs.');
	    }
	}


/***/ }),
/* 2335 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var eventKeys_1 = __webpack_require__(2336);
	exports.Events = eventKeys_1.Events;


/***/ }),
/* 2336 */
/***/ (function(module, exports) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Events = /** @class */ (function () {
	    function Events() {
	    }
	    /** Everything has changed with the columns. Either complete new set of columns set, or user called setState()*/
	    Events.EVENT_COLUMN_EVERYTHING_CHANGED = 'columnEverythingChanged';
	    /** User has set in new columns. */
	    Events.EVENT_NEW_COLUMNS_LOADED = 'newColumnsLoaded';
	    /** The pivot mode flag was changed */
	    Events.EVENT_COLUMN_PIVOT_MODE_CHANGED = 'columnPivotModeChanged';
	    /** A row group column was added, removed or order changed. */
	    Events.EVENT_COLUMN_ROW_GROUP_CHANGED = 'columnRowGroupChanged';
	    /** expandAll / collapseAll was called from the api. */
	    Events.EVENT_EXPAND_COLLAPSE_ALL = 'expandOrCollapseAll';
	    /** A pivot column was added, removed or order changed. */
	    Events.EVENT_COLUMN_PIVOT_CHANGED = 'columnPivotChanged';
	    /** The list of grid columns has changed. */
	    Events.EVENT_GRID_COLUMNS_CHANGED = 'gridColumnsChanged';
	    /** A value column was added, removed or agg function was changed. */
	    Events.EVENT_COLUMN_VALUE_CHANGED = 'columnValueChanged';
	    /** A column was moved */
	    Events.EVENT_COLUMN_MOVED = 'columnMoved';
	    /** One or more columns was shown / hidden */
	    Events.EVENT_COLUMN_VISIBLE = 'columnVisible';
	    /** One or more columns was pinned / unpinned*/
	    Events.EVENT_COLUMN_PINNED = 'columnPinned';
	    /** A column group was opened / closed */
	    Events.EVENT_COLUMN_GROUP_OPENED = 'columnGroupOpened';
	    /** One or more columns was resized. If just one, the column in the event is set. */
	    Events.EVENT_COLUMN_RESIZED = 'columnResized';
	    /** The list of displayed columns has changed, can result from columns open / close, column move, pivot, group, etc */
	    Events.EVENT_DISPLAYED_COLUMNS_CHANGED = 'displayedColumnsChanged';
	    /** The list of virtual columns has changed, results from viewport changing */
	    Events.EVENT_VIRTUAL_COLUMNS_CHANGED = 'virtualColumnsChanged';
	    /** A row group was opened / closed */
	    Events.EVENT_ROW_GROUP_OPENED = 'rowGroupOpened';
	    /** The client has set new data into the grid */
	    Events.EVENT_ROW_DATA_CHANGED = 'rowDataChanged';
	    /** The client has updated data for the grid */
	    Events.EVENT_ROW_DATA_UPDATED = 'rowDataUpdated';
	    /** The client has set new floating data into the grid */
	    Events.EVENT_PINNED_ROW_DATA_CHANGED = 'pinnedRowDataChanged';
	    /** Range selection has changed */
	    Events.EVENT_RANGE_SELECTION_CHANGED = 'rangeSelectionChanged';
	    /** Chart Range selection has changed */
	    Events.EVENT_CHART_RANGE_SELECTION_CHANGED = 'chartRangeSelectionChanged';
	    /** Chart Options have changed */
	    Events.EVENT_CHART_OPTIONS_CHANGED = 'chartOptionsChanged';
	    /** For when the tool panel is shown / hidden */
	    Events.EVENT_TOOL_PANEL_VISIBLE_CHANGED = 'toolPanelVisibleChanged';
	    /** Model was updated - grid updates the drawn rows when this happens */
	    Events.EVENT_MODEL_UPDATED = 'modelUpdated';
	    Events.EVENT_PASTE_START = 'pasteStart';
	    Events.EVENT_PASTE_END = 'pasteEnd';
	    Events.EVENT_CELL_CLICKED = 'cellClicked';
	    Events.EVENT_CELL_DOUBLE_CLICKED = 'cellDoubleClicked';
	    Events.EVENT_CELL_MOUSE_DOWN = 'cellMouseDown';
	    Events.EVENT_CELL_CONTEXT_MENU = 'cellContextMenu';
	    Events.EVENT_CELL_VALUE_CHANGED = 'cellValueChanged';
	    Events.EVENT_ROW_VALUE_CHANGED = 'rowValueChanged';
	    Events.EVENT_CELL_FOCUSED = 'cellFocused';
	    Events.EVENT_ROW_SELECTED = 'rowSelected';
	    Events.EVENT_SELECTION_CHANGED = 'selectionChanged';
	    Events.EVENT_CELL_KEY_DOWN = 'cellKeyDown';
	    Events.EVENT_CELL_KEY_PRESS = 'cellKeyPress';
	    Events.EVENT_CELL_MOUSE_OVER = 'cellMouseOver';
	    Events.EVENT_CELL_MOUSE_OUT = 'cellMouseOut';
	    /** 2 events for filtering. The grid LISTENS for filterChanged and afterFilterChanged */
	    Events.EVENT_FILTER_CHANGED = 'filterChanged';
	    /** Filter was change but not applied. Only useful if apply buttons are used in filters. */
	    Events.EVENT_FILTER_MODIFIED = 'filterModified';
	    Events.EVENT_FILTER_OPENED = 'filterOpened';
	    Events.EVENT_SORT_CHANGED = 'sortChanged';
	    /** A row was removed from the dom, for any reason. Use to clean up resources (if any) used by the row. */
	    Events.EVENT_VIRTUAL_ROW_REMOVED = 'virtualRowRemoved';
	    Events.EVENT_ROW_CLICKED = 'rowClicked';
	    Events.EVENT_ROW_DOUBLE_CLICKED = 'rowDoubleClicked';
	    /** Gets called once after the grid has finished initialising. */
	    Events.EVENT_GRID_READY = 'gridReady';
	    /** Width of height of the main grid div has changed. Grid listens for this and does layout of grid if it's
	     * changed, so always filling the space it was given. */
	    Events.EVENT_GRID_SIZE_CHANGED = 'gridSizeChanged';
	    /** The indexes of the rows rendered has changed, eg user has scrolled to a new vertical position. */
	    Events.EVENT_VIEWPORT_CHANGED = 'viewportChanged';
	    /** Rows were rendered for the first time (ie on async data load). */
	    Events.EVENT_FIRST_DATA_RENDERED = 'firstDataRendered';
	    /** A column drag has started, either resizing a column or moving a column. */
	    Events.EVENT_DRAG_STARTED = 'dragStarted';
	    /** A column drag has stopped */
	    Events.EVENT_DRAG_STOPPED = 'dragStopped';
	    Events.EVENT_ROW_EDITING_STARTED = 'rowEditingStarted';
	    Events.EVENT_ROW_EDITING_STOPPED = 'rowEditingStopped';
	    Events.EVENT_CELL_EDITING_STARTED = 'cellEditingStarted';
	    Events.EVENT_CELL_EDITING_STOPPED = 'cellEditingStopped';
	    /** Main body of grid has scrolled, either horizontally or vertically */
	    Events.EVENT_BODY_SCROLL = 'bodyScroll';
	    Events.EVENT_ANIMATION_QUEUE_EMPTY = 'animationQueueEmpty';
	    Events.EVENT_HEIGHT_SCALE_CHANGED = 'heightScaleChanged';
	    /** The displayed page for pagination has changed. For example the data was filtered or sorted,
	     * or the user has moved to a different page. */
	    Events.EVENT_PAGINATION_CHANGED = 'paginationChanged';
	    /** Only used by React, Angular 2+, Web Components and VueJS ag-Grid components
	     * (not used if doing plain JavaScript or Angular 1.x). If the grid receives changes due
	     * to bound properties, this event fires after the grid has finished processing the change. */
	    Events.EVENT_COMPONENT_STATE_CHANGED = 'componentStateChanged';
	    /** All items from here down are used internally by the grid, not intended for external use. */
	    // not documented, either experimental, or we just don't want users using an depending on them
	    Events.EVENT_BODY_HEIGHT_CHANGED = 'bodyHeightChanged';
	    Events.EVENT_DISPLAYED_COLUMNS_WIDTH_CHANGED = 'displayedColumnsWidthChanged';
	    Events.EVENT_SCROLL_VISIBILITY_CHANGED = 'scrollVisibilityChanged';
	    Events.EVENT_COLUMN_HOVER_CHANGED = 'columnHoverChanged';
	    Events.EVENT_FLASH_CELLS = 'flashCells';
	    Events.EVENT_ROW_DRAG_ENTER = 'rowDragEnter';
	    Events.EVENT_ROW_DRAG_MOVE = 'rowDragMove';
	    Events.EVENT_ROW_DRAG_LEAVE = 'rowDragLeave';
	    Events.EVENT_ROW_DRAG_END = 'rowDragEnd';
	    // these are used for server side group and agg - only used by CS with Viewport Row Model - intention is
	    // to design these better around server side functions and then release to general public when fully working with
	    // all the row models.
	    Events.EVENT_COLUMN_ROW_GROUP_CHANGE_REQUEST = 'columnRowGroupChangeRequest';
	    Events.EVENT_COLUMN_PIVOT_CHANGE_REQUEST = 'columnPivotChangeRequest';
	    Events.EVENT_COLUMN_VALUE_CHANGE_REQUEST = 'columnValueChangeRequest';
	    Events.EVENT_COLUMN_AGG_FUNC_CHANGE_REQUEST = 'columnAggFuncChangeRequest';
	    return Events;
	}());
	exports.Events = Events;


/***/ }),
/* 2337 */
/***/ (function(module, exports) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var PropertyKeys = /** @class */ (function () {
	    function PropertyKeys() {
	    }
	    PropertyKeys.STRING_PROPERTIES = [
	        'sortingOrder', 'rowClass', 'rowSelection', 'overlayLoadingTemplate',
	        'overlayNoRowsTemplate', 'quickFilterText', 'rowModelType',
	        'editType', 'domLayout', 'clipboardDeliminator', 'rowGroupPanelShow',
	        'multiSortKey', 'pivotColumnGroupTotals', 'pivotRowTotals', 'pivotPanelShow'
	    ];
	    PropertyKeys.OBJECT_PROPERTIES = [
	        'components', 'frameworkComponents', 'rowStyle', 'context', 'autoGroupColumnDef', 'groupColumnDef', 'localeText',
	        'icons', 'datasource', 'serverSideDatasource', 'viewportDatasource', 'groupRowRendererParams', 'aggFuncs',
	        'fullWidthCellRendererParams', 'defaultColGroupDef', 'defaultColDef', 'defaultExportParams', 'columnTypes',
	        'rowClassRules', 'detailGridOptions', 'detailCellRendererParams', 'loadingCellRendererParams', 'loadingOverlayComponentParams',
	        'noRowsOverlayComponentParams', 'popupParent', 'colResizeDefault', 'reduxStore', 'statusBar', 'sideBar'
	    ];
	    PropertyKeys.ARRAY_PROPERTIES = [
	        'slaveGrids', 'alignedGrids', 'rowData',
	        'columnDefs', 'excelStyles', 'pinnedTopRowData', 'pinnedBottomRowData'
	        /** @deprecated */
	    ];
	    PropertyKeys.NUMBER_PROPERTIES = [
	        'rowHeight', 'detailRowHeight', 'rowBuffer', 'colWidth', 'headerHeight', 'groupHeaderHeight',
	        'floatingFiltersHeight', 'pivotHeaderHeight', 'pivotGroupHeaderHeight', 'groupDefaultExpanded',
	        'minColWidth', 'maxColWidth', 'viewportRowModelPageSize', 'viewportRowModelBufferSize',
	        'autoSizePadding', 'maxBlocksInCache', 'maxConcurrentDatasourceRequests',
	        'cacheOverflowSize', 'paginationPageSize', 'cacheBlockSize', 'infiniteInitialRowCount',
	        'scrollbarWidth', 'paginationStartPage', 'infiniteBlockSize', 'batchUpdateWaitMillis',
	        'blockLoadDebounceMillis', 'keepDetailRowsCount'
	    ];
	    PropertyKeys.BOOLEAN_PROPERTIES = [
	        'toolPanelSuppressRowGroups', 'toolPanelSuppressValues', 'toolPanelSuppressPivots', 'toolPanelSuppressPivotMode',
	        'toolPanelSuppressSideButtons', 'toolPanelSuppressColumnFilter', 'toolPanelSuppressColumnSelectAll',
	        'toolPanelSuppressColumnExpandAll', 'suppressMakeColumnVisibleAfterUnGroup', 'suppressRowClickSelection',
	        'suppressCellSelection', 'suppressHorizontalScroll', 'alwaysShowVerticalScroll', 'debug', 'enableBrowserTooltips', 'enableColResize',
	        'enableCellExpressions', 'enableSorting', 'enableServerSideSorting', 'enableFilter', 'enableServerSideFilter',
	        'angularCompileRows', 'angularCompileFilters', 'angularCompileHeaders', 'groupSuppressAutoColumn', 'groupSelectsChildren',
	        'groupIncludeFooter', 'groupIncludeTotalFooter', 'groupUseEntireRow', 'groupSuppressRow', 'groupSuppressBlankHeader',
	        'forPrint', 'suppressMenuHide', 'rowDeselection', 'unSortIcon', 'suppressMultiSort', 'singleClickEdit',
	        'suppressLoadingOverlay', 'suppressNoRowsOverlay', 'suppressAutoSize', 'suppressParentsInRowNodes', 'showToolPanel',
	        'suppressColumnMoveAnimation', 'suppressMovableColumns', 'suppressFieldDotNotation', 'enableRangeSelection',
	        'enableRangeHandle', 'enableFillHandle', 'deltaSort', 'suppressTouch', 'suppressAsyncEvents', 'allowContextMenuWithControlKey',
	        'suppressContextMenu', 'suppressMenuFilterPanel', 'suppressMenuMainPanel', 'suppressMenuColumnPanel', 'rememberGroupStateWhenNewData',
	        'enableCellChangeFlash', 'suppressDragLeaveHidesColumns', 'suppressMiddleClickScrolls', 'suppressPreventDefaultOnMouseWheel',
	        'suppressUseColIdForGroups', 'suppressCopyRowsToClipboard', 'copyHeadersToClipboard', 'pivotMode', 'suppressAggFuncInHeader',
	        'suppressColumnVirtualisation', 'suppressAggAtRootLevel', 'suppressFocusAfterRefresh', 'functionsPassive', 'functionsReadOnly',
	        'animateRows', 'groupSelectsFiltered', 'groupRemoveSingleChildren', 'groupRemoveLowestSingleChildren', 'enableRtl',
	        'suppressClickEdit', 'rowDragManaged', 'suppressRowDrag', 'enableGroupEdit', 'embedFullWidthRows', 'deprecatedEmbedFullWidthRows',
	        'suppressTabbing', 'suppressPaginationPanel', 'floatingFilter', 'groupHideOpenParents', 'groupMultiAutoColumn', 'pagination',
	        'stopEditingWhenGridLosesFocus', 'paginationAutoPageSize', 'suppressScrollOnNewData', 'purgeClosedRowNodes', 'cacheQuickFilter',
	        'deltaRowDataMode', 'ensureDomOrder', 'accentedSort', 'pivotTotals', 'suppressChangeDetection', 'valueCache', 'valueCacheNeverExpires',
	        'aggregateOnlyChangedColumns', 'suppressAnimationFrame', 'suppressExcelExport', 'suppressCsvExport', 'treeData', 'masterDetail',
	        'suppressMultiRangeSelection', 'enterMovesDownAfterEdit', 'enterMovesDown', 'suppressPropertyNamesCheck', 'rowMultiSelectWithClick',
	        'contractColumnSelection', 'suppressEnterpriseResetOnNewColumns', 'enableOldSetFilterModel', 'suppressRowHoverHighlight',
	        'gridAutoHeight', 'suppressRowTransform', 'suppressClipboardPaste', 'serverSideSortingAlwaysResets', 'reactNext',
	        'suppressSetColumnStateEvents', 'enableCharts', 'deltaColumnMode', 'suppressMaintainUnsortedOrder', 'enableCellTextSelection',
	        'suppressBrowserResizeObserver', 'suppressMaxRenderedRowRestriction', 'excludeChildrenWhenTreeDataFiltering',
	        'keepDetailRows', 'paginateChildRows', 'preventDefaultOnContextMenu'
	    ];
	    PropertyKeys.FUNCTION_PROPERTIES = ['localeTextFunc', 'groupRowInnerRenderer', 'groupRowInnerRendererFramework',
	        'dateComponent', 'dateComponentFramework', 'groupRowRenderer', 'groupRowRendererFramework', 'isExternalFilterPresent',
	        'getRowHeight', 'doesExternalFilterPass', 'getRowClass', 'getRowStyle', 'getRowClassRules',
	        'traverseNode', 'getContextMenuItems', 'getMainMenuItems', 'processRowPostCreate', 'processCellForClipboard',
	        'getNodeChildDetails', 'groupRowAggNodes', 'getRowNodeId', 'isFullWidthCell', 'fullWidthCellRenderer',
	        'fullWidthCellRendererFramework', 'doesDataFlower', 'processSecondaryColDef', 'processSecondaryColGroupDef',
	        'getBusinessKeyForNode', 'sendToClipboard', 'navigateToNextCell', 'tabToNextCell', 'getDetailRowData',
	        'processCellFromClipboard', 'getDocument', 'postProcessPopup', 'getChildCount', 'getDataPath', 'loadingCellRenderer',
	        'loadingCellRendererFramework', 'loadingOverlayComponent', 'loadingOverlayComponentFramework', 'noRowsOverlayComponent',
	        'noRowsOverlayComponentFramework', 'detailCellRenderer', 'detailCellRendererFramework', 'onGridReady',
	        'defaultGroupSortComparator', 'isRowMaster', 'isRowSelectable', 'postSort', 'processHeaderForClipboard',
	        'paginationNumberFormatter', 'processDataFromClipboard', 'getServerSideGroupKey', 'isServerSideGroup',
	        'suppressKeyboardEvent', 'createChartContainer', 'processChartOptions', 'getChartToolbarItems'];
	    PropertyKeys.ALL_PROPERTIES = PropertyKeys.ARRAY_PROPERTIES
	        .concat(PropertyKeys.OBJECT_PROPERTIES)
	        .concat(PropertyKeys.STRING_PROPERTIES)
	        .concat(PropertyKeys.NUMBER_PROPERTIES)
	        .concat(PropertyKeys.FUNCTION_PROPERTIES)
	        .concat(PropertyKeys.BOOLEAN_PROPERTIES);
	    // used when doing property checks - this causes noise when using frameworks which can add their own fw specific
	    // properties to colDefs, gridOptions etc
	    PropertyKeys.FRAMEWORK_PROPERTIES = ['__ob__', '__metadata__', 'mappedColumnProperties', 'hasChildColumns',
	        'toColDef', 'createColDefFromGridColumn'];
	    return PropertyKeys;
	}());
	exports.PropertyKeys = PropertyKeys;


/***/ }),
/* 2338 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var csvCreator_1 = __webpack_require__(2339);
	var rowRenderer_1 = __webpack_require__(2350);
	var filterManager_1 = __webpack_require__(2378);
	var columnController_1 = __webpack_require__(2341);
	var selectionController_1 = __webpack_require__(2357);
	var gridOptionsWrapper_1 = __webpack_require__(2324);
	var valueService_1 = __webpack_require__(2359);
	var eventService_1 = __webpack_require__(2331);
	var constants_1 = __webpack_require__(2328);
	var context_1 = __webpack_require__(2333);
	var sortController_1 = __webpack_require__(2391);
	var focusedCellController_1 = __webpack_require__(2369);
	var cellRendererFactory_1 = __webpack_require__(2376);
	var paginationProxy_1 = __webpack_require__(2372);
	var immutableService_1 = __webpack_require__(2437);
	var valueCache_1 = __webpack_require__(2360);
	var alignedGridsService_1 = __webpack_require__(2438);
	var pinnedRowModel_1 = __webpack_require__(2371);
	var animationFrameService_1 = __webpack_require__(2418);
	var utils_1 = __webpack_require__(2325);
	var GridApi = /** @class */ (function () {
	    function GridApi() {
	        this.detailGridInfoMap = {};
	    }
	    GridApi.prototype.registerGridComp = function (gridPanel) {
	        this.gridPanel = gridPanel;
	    };
	    GridApi.prototype.registerGridCore = function (gridCore) {
	        this.gridCore = gridCore;
	    };
	    GridApi.prototype.registerHeaderRootComp = function (headerRootComp) {
	        this.headerRootComp = headerRootComp;
	    };
	    GridApi.prototype.init = function () {
	        switch (this.rowModel.getType()) {
	            case constants_1.Constants.ROW_MODEL_TYPE_CLIENT_SIDE:
	                this.clientSideRowModel = this.rowModel;
	                break;
	            case constants_1.Constants.ROW_MODEL_TYPE_INFINITE:
	                this.infinitePageRowModel = this.rowModel;
	                break;
	            case constants_1.Constants.ROW_MODEL_TYPE_SERVER_SIDE:
	                this.serverSideRowModel = this.rowModel;
	                break;
	        }
	    };
	    /** Used internally by grid. Not intended to be used by the client. Interface may change between releases. */
	    GridApi.prototype.__getAlignedGridService = function () {
	        return this.alignedGridsService;
	    };
	    GridApi.prototype.addDetailGridInfo = function (id, gridInfo) {
	        this.detailGridInfoMap[id] = gridInfo;
	    };
	    GridApi.prototype.removeDetailGridInfo = function (id) {
	        this.detailGridInfoMap[id] = undefined;
	    };
	    GridApi.prototype.getDetailGridInfo = function (id) {
	        return this.detailGridInfoMap[id];
	    };
	    GridApi.prototype.forEachDetailGridInfo = function (callback) {
	        var index = 0;
	        utils_1._.iterateObject(this.detailGridInfoMap, function (id, gridInfo) {
	            // check for undefined, as old references will still be lying around
	            if (utils_1._.exists(gridInfo)) {
	                callback(gridInfo, index);
	                index++;
	            }
	        });
	    };
	    GridApi.prototype.getDataAsCsv = function (params) {
	        return this.csvCreator.getDataAsCsv(params);
	    };
	    GridApi.prototype.exportDataAsCsv = function (params) {
	        this.csvCreator.exportDataAsCsv(params);
	    };
	    GridApi.prototype.getDataAsExcel = function (params) {
	        if (!this.excelCreator) {
	            console.warn('ag-Grid: Excel export is only available in ag-Grid Enterprise');
	        }
	        return this.excelCreator.getDataAsExcelXml(params);
	    };
	    GridApi.prototype.exportDataAsExcel = function (params) {
	        if (!this.excelCreator) {
	            console.warn('ag-Grid: Excel export is only available in ag-Grid Enterprise');
	        }
	        this.excelCreator.exportDataAsExcel(params);
	    };
	    /** @deprecated */
	    GridApi.prototype.setEnterpriseDatasource = function (datasource) {
	        console.warn("ag-grid: since version 18.x, api.setEnterpriseDatasource() should be replaced with api.setServerSideDatasource()");
	        this.setServerSideDatasource(datasource);
	    };
	    GridApi.prototype.setServerSideDatasource = function (datasource) {
	        if (this.gridOptionsWrapper.isRowModelServerSide()) {
	            // should really have an IEnterpriseRowModel interface, so we are not casting to any
	            this.rowModel.setDatasource(datasource);
	        }
	        else {
	            console.warn("ag-Grid: you can only use an enterprise datasource when gridOptions.rowModelType is '" + constants_1.Constants.ROW_MODEL_TYPE_SERVER_SIDE + "'");
	        }
	    };
	    GridApi.prototype.setDatasource = function (datasource) {
	        if (this.gridOptionsWrapper.isRowModelInfinite()) {
	            this.rowModel.setDatasource(datasource);
	        }
	        else {
	            console.warn("ag-Grid: you can only use a datasource when gridOptions.rowModelType is '" + constants_1.Constants.ROW_MODEL_TYPE_INFINITE + "'");
	        }
	    };
	    GridApi.prototype.setViewportDatasource = function (viewportDatasource) {
	        if (this.gridOptionsWrapper.isRowModelViewport()) {
	            // this is bad coding, because it's using an interface that's exposed in the enterprise.
	            // really we should create an interface in the core for viewportDatasource and let
	            // the enterprise implement it, rather than casting to 'any' here
	            this.rowModel.setViewportDatasource(viewportDatasource);
	        }
	        else {
	            console.warn("ag-Grid: you can only use a viewport datasource when gridOptions.rowModelType is '" + constants_1.Constants.ROW_MODEL_TYPE_VIEWPORT + "'");
	        }
	    };
	    GridApi.prototype.setRowData = function (rowData) {
	        if (this.gridOptionsWrapper.isRowModelDefault()) {
	            if (this.gridOptionsWrapper.isDeltaRowDataMode()) {
	                var _a = this.immutableService.createTransactionForRowData(rowData), transaction = _a[0], orderIdMap = _a[1];
	                this.clientSideRowModel.updateRowData(transaction, orderIdMap);
	                // need to force updating of full width rows - note this wouldn't be necessary the full width cell comp listened
	                // to the data change event on the row node and refreshed itself.
	                this.rowRenderer.refreshFullWidthRows();
	            }
	            else {
	                this.selectionController.reset();
	                this.clientSideRowModel.setRowData(rowData);
	            }
	        }
	        else {
	            console.warn('cannot call setRowData unless using normal row model');
	        }
	    };
	    /** @deprecated */
	    GridApi.prototype.setFloatingTopRowData = function (rows) {
	        console.warn('ag-Grid: since v12, api.setFloatingTopRowData() is now api.setPinnedTopRowData()');
	        this.setPinnedTopRowData(rows);
	    };
	    /** @deprecated */
	    GridApi.prototype.setFloatingBottomRowData = function (rows) {
	        console.warn('ag-Grid: since v12, api.setFloatingBottomRowData() is now api.setPinnedBottomRowData()');
	        this.setPinnedBottomRowData(rows);
	    };
	    /** @deprecated */
	    GridApi.prototype.getFloatingTopRowCount = function () {
	        console.warn('ag-Grid: since v12, api.getFloatingTopRowCount() is now api.getPinnedTopRowCount()');
	        return this.getPinnedTopRowCount();
	    };
	    /** @deprecated */
	    GridApi.prototype.getFloatingBottomRowCount = function () {
	        console.warn('ag-Grid: since v12, api.getFloatingBottomRowCount() is now api.getPinnedBottomRowCount()');
	        return this.getPinnedBottomRowCount();
	    };
	    /** @deprecated */
	    GridApi.prototype.getFloatingTopRow = function (index) {
	        console.warn('ag-Grid: since v12, api.getFloatingTopRow() is now api.getPinnedTopRow()');
	        return this.getPinnedTopRow(index);
	    };
	    /** @deprecated */
	    GridApi.prototype.getFloatingBottomRow = function (index) {
	        console.warn('ag-Grid: since v12, api.getFloatingBottomRow() is now api.getPinnedBottomRow()');
	        return this.getPinnedBottomRow(index);
	    };
	    GridApi.prototype.setPinnedTopRowData = function (rows) {
	        this.pinnedRowModel.setPinnedTopRowData(rows);
	    };
	    GridApi.prototype.setPinnedBottomRowData = function (rows) {
	        this.pinnedRowModel.setPinnedBottomRowData(rows);
	    };
	    GridApi.prototype.getPinnedTopRowCount = function () {
	        return this.pinnedRowModel.getPinnedTopRowCount();
	    };
	    GridApi.prototype.getPinnedBottomRowCount = function () {
	        return this.pinnedRowModel.getPinnedBottomRowCount();
	    };
	    GridApi.prototype.getPinnedTopRow = function (index) {
	        return this.pinnedRowModel.getPinnedTopRow(index);
	    };
	    GridApi.prototype.getPinnedBottomRow = function (index) {
	        return this.pinnedRowModel.getPinnedBottomRow(index);
	    };
	    GridApi.prototype.setColumnDefs = function (colDefs, source) {
	        if (source === void 0) { source = "api"; }
	        this.columnController.setColumnDefs(colDefs, source);
	    };
	    GridApi.prototype.expireValueCache = function () {
	        this.valueCache.expire();
	    };
	    GridApi.prototype.getVerticalPixelRange = function () {
	        return this.gridPanel.getVScrollPosition();
	    };
	    GridApi.prototype.getHorizontalPixelRange = function () {
	        return this.gridPanel.getHScrollPosition();
	    };
	    GridApi.prototype.setAlwaysShowVerticalScroll = function (show) {
	        this.gridOptionsWrapper.setProperty('alwaysShowVerticalScroll', show);
	    };
	    GridApi.prototype.refreshToolPanel = function () {
	        this.gridCore.refreshSideBar();
	    };
	    GridApi.prototype.refreshCells = function (params) {
	        if (params === void 0) { params = {}; }
	        if (Array.isArray(params)) {
	            // the old version of refreshCells() took an array of rowNodes for the first argument
	            console.warn('since ag-Grid v11.1, refreshCells() now takes parameters, please see the documentation.');
	            return;
	        }
	        this.rowRenderer.refreshCells(params);
	    };
	    GridApi.prototype.flashCells = function (params) {
	        if (params === void 0) { params = {}; }
	        this.rowRenderer.flashCells(params);
	    };
	    GridApi.prototype.redrawRows = function (params) {
	        if (params === void 0) { params = {}; }
	        if (params && params.rowNodes) {
	            this.rowRenderer.redrawRows(params.rowNodes);
	        }
	        else {
	            this.rowRenderer.redrawAfterModelUpdate();
	        }
	    };
	    GridApi.prototype.timeFullRedraw = function (count) {
	        if (count === void 0) { count = 1; }
	        var iterationCount = 0;
	        var totalProcessing = 0;
	        var totalReflow = 0;
	        var that = this;
	        doOneIteration();
	        function doOneIteration() {
	            var start = (new Date()).getTime();
	            that.rowRenderer.redrawAfterModelUpdate();
	            var endProcessing = (new Date()).getTime();
	            window.setTimeout(function () {
	                var endReflow = (new Date()).getTime();
	                var durationProcessing = endProcessing - start;
	                var durationReflow = endReflow - endProcessing;
	                // tslint:disable-next-line
	                console.log('duration:  processing = ' + durationProcessing + 'ms, reflow = ' + durationReflow + 'ms');
	                iterationCount++;
	                totalProcessing += durationProcessing;
	                totalReflow += durationReflow;
	                if (iterationCount < count) {
	                    // wait for 1s between tests
	                    window.setTimeout(doOneIteration, 1000);
	                }
	                else {
	                    finish();
	                }
	            }, 0);
	        }
	        function finish() {
	            // tslint:disable-next-line
	            console.log('tests complete. iteration count = ' + iterationCount);
	            // tslint:disable-next-line
	            console.log('average processing = ' + (totalProcessing / iterationCount) + 'ms');
	            // tslint:disable-next-line
	            console.log('average reflow = ' + (totalReflow / iterationCount) + 'ms');
	        }
	    };
	    /** @deprecated */
	    GridApi.prototype.refreshView = function () {
	        console.warn('ag-Grid: since v11.1, refreshView() is deprecated, please call refreshCells() or redrawRows() instead');
	        this.redrawRows();
	    };
	    //** @deprecated */
	    GridApi.prototype.refreshRows = function (rowNodes) {
	        console.warn('since ag-Grid v11.1, refreshRows() is deprecated, please use refreshCells({rowNodes: rows}) or redrawRows({rowNodes: rows}) instead');
	        this.refreshCells({ rowNodes: rowNodes });
	    };
	    /** @deprecated */
	    GridApi.prototype.rowDataChanged = function (rows) {
	        console.warn('ag-Grid: rowDataChanged is deprecated, either call refreshView() to refresh everything, or call rowNode.setRowData(newData) to set value on a particular node');
	        this.redrawRows();
	    };
	    /** @deprecated */
	    GridApi.prototype.softRefreshView = function () {
	        console.error('ag-Grid: since v16, softRefreshView() is no longer supported. Please check the documentation on how to refresh.');
	    };
	    /** @deprecated */
	    GridApi.prototype.refreshGroupRows = function () {
	        console.warn('ag-Grid: since v11.1, refreshGroupRows() is no longer supported, call refreshCells() instead. ' +
	            'Because refreshCells() now does dirty checking, it will only refresh cells that have changed, so it should ' +
	            'not be necessary to only refresh the group rows.');
	        this.refreshCells();
	    };
	    GridApi.prototype.setFunctionsReadOnly = function (readOnly) {
	        this.gridOptionsWrapper.setProperty('functionsReadOnly', readOnly);
	    };
	    GridApi.prototype.refreshHeader = function () {
	        this.headerRootComp.refreshHeader();
	        this.gridPanel.setHeaderAndFloatingHeights();
	    };
	    GridApi.prototype.isAnyFilterPresent = function () {
	        return this.filterManager.isAnyFilterPresent();
	    };
	    GridApi.prototype.isAdvancedFilterPresent = function () {
	        console.warn('ag-Grid: isAdvancedFilterPresent() is deprecated, please use isColumnFilterPresent()');
	        return this.isColumnFilterPresent();
	    };
	    GridApi.prototype.isColumnFilterPresent = function () {
	        return this.filterManager.isAdvancedFilterPresent();
	    };
	    GridApi.prototype.isQuickFilterPresent = function () {
	        return this.filterManager.isQuickFilterPresent();
	    };
	    GridApi.prototype.getModel = function () {
	        return this.rowModel;
	    };
	    GridApi.prototype.setRowNodeExpanded = function (rowNode, expanded) {
	        if (rowNode) {
	            rowNode.setExpanded(expanded);
	        }
	    };
	    GridApi.prototype.onGroupExpandedOrCollapsed = function (deprecated_refreshFromIndex) {
	        if (utils_1._.missing(this.clientSideRowModel)) {
	            console.warn('ag-Grid: cannot call onGroupExpandedOrCollapsed unless using normal row model');
	        }
	        if (utils_1._.exists(deprecated_refreshFromIndex)) {
	            console.warn('ag-Grid: api.onGroupExpandedOrCollapsed - refreshFromIndex parameter is no longer used, the grid will refresh all rows');
	        }
	        // we don't really want the user calling this if only one rowNode was expanded, instead they should be
	        // calling rowNode.setExpanded(boolean) - this way we do a 'keepRenderedRows=false' so that the whole
	        // grid gets refreshed again - otherwise the row with the rowNodes that were changed won't get updated,
	        // and thus the expand icon in the group cell won't get 'opened' or 'closed'.
	        this.clientSideRowModel.refreshModel({ step: constants_1.Constants.STEP_MAP });
	    };
	    GridApi.prototype.refreshInMemoryRowModel = function (step) {
	        console.warn("ag-grid: since version 18.x, api.refreshInMemoryRowModel() should be replaced with api.refreshClientSideRowModel()");
	        this.refreshClientSideRowModel(step);
	    };
	    GridApi.prototype.refreshClientSideRowModel = function (step) {
	        if (utils_1._.missing(this.clientSideRowModel)) {
	            console.warn('cannot call refreshClientSideRowModel unless using normal row model');
	        }
	        var paramsStep = constants_1.Constants.STEP_EVERYTHING;
	        var stepsMapped = {
	            group: constants_1.Constants.STEP_EVERYTHING,
	            filter: constants_1.Constants.STEP_FILTER,
	            map: constants_1.Constants.STEP_MAP,
	            aggregate: constants_1.Constants.STEP_AGGREGATE,
	            sort: constants_1.Constants.STEP_SORT,
	            pivot: constants_1.Constants.STEP_PIVOT
	        };
	        if (utils_1._.exists(step)) {
	            paramsStep = stepsMapped[step];
	        }
	        if (utils_1._.missing(paramsStep)) {
	            console.error("ag-Grid: invalid step " + step + ", available steps are " + Object.keys(stepsMapped).join(', '));
	            return;
	        }
	        var modelParams = {
	            step: paramsStep,
	            keepRenderedRows: true,
	            animate: true,
	            keepEditingRows: true
	        };
	        this.clientSideRowModel.refreshModel(modelParams);
	    };
	    GridApi.prototype.isAnimationFrameQueueEmpty = function () {
	        return this.animationFrameService.isQueueEmpty();
	    };
	    GridApi.prototype.getRowNode = function (id) {
	        return this.rowModel.getRowNode(id);
	    };
	    GridApi.prototype.expandAll = function () {
	        if (utils_1._.missing(this.clientSideRowModel)) {
	            console.warn('ag-Grid: cannot call expandAll unless using normal row model');
	            return;
	        }
	        this.clientSideRowModel.expandOrCollapseAll(true);
	    };
	    GridApi.prototype.collapseAll = function () {
	        if (utils_1._.missing(this.clientSideRowModel)) {
	            console.warn('ag-Grid: cannot call collapseAll unless using normal row model');
	            return;
	        }
	        this.clientSideRowModel.expandOrCollapseAll(false);
	    };
	    GridApi.prototype.addVirtualRowListener = function (eventName, rowIndex, callback) {
	        if (typeof eventName !== 'string') {
	            console.warn('ag-Grid: addVirtualRowListener is deprecated, please use addRenderedRowListener.');
	        }
	        this.addRenderedRowListener(eventName, rowIndex, callback);
	    };
	    GridApi.prototype.addRenderedRowListener = function (eventName, rowIndex, callback) {
	        if (eventName === 'virtualRowSelected') {
	            console.warn("ag-Grid: event virtualRowSelected is deprecated, to register for individual row\n                selection events, add a listener directly to the row node.");
	        }
	        this.rowRenderer.addRenderedRowListener(eventName, rowIndex, callback);
	    };
	    GridApi.prototype.setQuickFilter = function (newFilter) {
	        this.filterManager.setQuickFilter(newFilter);
	    };
	    GridApi.prototype.selectIndex = function (index, tryMulti, suppressEvents) {
	        console.warn('ag-Grid: do not use api for selection, call node.setSelected(value) instead');
	        if (suppressEvents) {
	            console.warn('ag-Grid: suppressEvents is no longer supported, stop listening for the event if you no longer want it');
	        }
	        this.selectionController.selectIndex(index, tryMulti);
	    };
	    GridApi.prototype.deselectIndex = function (index, suppressEvents) {
	        if (suppressEvents === void 0) { suppressEvents = false; }
	        console.warn('ag-Grid: do not use api for selection, call node.setSelected(value) instead');
	        if (suppressEvents) {
	            console.warn('ag-Grid: suppressEvents is no longer supported, stop listening for the event if you no longer want it');
	        }
	        this.selectionController.deselectIndex(index);
	    };
	    GridApi.prototype.selectNode = function (node, tryMulti, suppressEvents) {
	        if (tryMulti === void 0) { tryMulti = false; }
	        if (suppressEvents === void 0) { suppressEvents = false; }
	        console.warn('ag-Grid: API for selection is deprecated, call node.setSelected(value) instead');
	        if (suppressEvents) {
	            console.warn('ag-Grid: suppressEvents is no longer supported, stop listening for the event if you no longer want it');
	        }
	        node.setSelectedParams({ newValue: true, clearSelection: !tryMulti });
	    };
	    GridApi.prototype.deselectNode = function (node, suppressEvents) {
	        if (suppressEvents === void 0) { suppressEvents = false; }
	        console.warn('ag-Grid: API for selection is deprecated, call node.setSelected(value) instead');
	        if (suppressEvents) {
	            console.warn('ag-Grid: suppressEvents is no longer supported, stop listening for the event if you no longer want it');
	        }
	        node.setSelectedParams({ newValue: false });
	    };
	    GridApi.prototype.selectAll = function () {
	        this.selectionController.selectAllRowNodes();
	    };
	    GridApi.prototype.deselectAll = function () {
	        this.selectionController.deselectAllRowNodes();
	    };
	    GridApi.prototype.selectAllFiltered = function () {
	        this.selectionController.selectAllRowNodes(true);
	    };
	    GridApi.prototype.deselectAllFiltered = function () {
	        this.selectionController.deselectAllRowNodes(true);
	    };
	    GridApi.prototype.recomputeAggregates = function () {
	        if (utils_1._.missing(this.clientSideRowModel)) {
	            console.warn('cannot call recomputeAggregates unless using normal row model');
	        }
	        console.warn("recomputeAggregates is deprecated, please call api.refreshClientSideRowModel('aggregate') instead");
	        this.clientSideRowModel.refreshModel({ step: constants_1.Constants.STEP_AGGREGATE });
	    };
	    GridApi.prototype.sizeColumnsToFit = function () {
	        this.gridPanel.sizeColumnsToFit();
	    };
	    GridApi.prototype.showLoadingOverlay = function () {
	        this.gridPanel.showLoadingOverlay();
	    };
	    GridApi.prototype.showNoRowsOverlay = function () {
	        this.gridPanel.showNoRowsOverlay();
	    };
	    GridApi.prototype.hideOverlay = function () {
	        this.gridPanel.hideOverlay();
	    };
	    GridApi.prototype.isNodeSelected = function (node) {
	        console.warn('ag-Grid: no need to call api.isNodeSelected(), just call node.isSelected() instead');
	        return node.isSelected();
	    };
	    GridApi.prototype.getSelectedNodesById = function () {
	        console.error('ag-Grid: since version 3.4, getSelectedNodesById no longer exists, use getSelectedNodes() instead');
	        return null;
	    };
	    GridApi.prototype.getSelectedNodes = function () {
	        return this.selectionController.getSelectedNodes();
	    };
	    GridApi.prototype.getSelectedRows = function () {
	        return this.selectionController.getSelectedRows();
	    };
	    GridApi.prototype.getBestCostNodeSelection = function () {
	        return this.selectionController.getBestCostNodeSelection();
	    };
	    GridApi.prototype.getRenderedNodes = function () {
	        return this.rowRenderer.getRenderedNodes();
	    };
	    GridApi.prototype.ensureColIndexVisible = function (index) {
	        console.warn('ag-Grid: ensureColIndexVisible(index) no longer supported, use ensureColumnVisible(colKey) instead.');
	    };
	    GridApi.prototype.ensureColumnVisible = function (key) {
	        this.gridPanel.ensureColumnVisible(key);
	    };
	    // Valid values for position are bottom, middle and top
	    GridApi.prototype.ensureIndexVisible = function (index, position) {
	        this.gridPanel.ensureIndexVisible(index, position);
	    };
	    // Valid values for position are bottom, middle and top
	    GridApi.prototype.ensureNodeVisible = function (comparator, position) {
	        this.gridCore.ensureNodeVisible(comparator, position);
	    };
	    GridApi.prototype.forEachLeafNode = function (callback) {
	        if (utils_1._.missing(this.clientSideRowModel)) {
	            console.warn('cannot call forEachNode unless using normal row model');
	        }
	        this.clientSideRowModel.forEachLeafNode(callback);
	    };
	    GridApi.prototype.forEachNode = function (callback) {
	        this.rowModel.forEachNode(callback);
	    };
	    GridApi.prototype.forEachNodeAfterFilter = function (callback) {
	        if (utils_1._.missing(this.clientSideRowModel)) {
	            console.warn('cannot call forEachNodeAfterFilter unless using normal row model');
	        }
	        this.clientSideRowModel.forEachNodeAfterFilter(callback);
	    };
	    GridApi.prototype.forEachNodeAfterFilterAndSort = function (callback) {
	        if (utils_1._.missing(this.clientSideRowModel)) {
	            console.warn('cannot call forEachNodeAfterFilterAndSort unless using normal row model');
	        }
	        this.clientSideRowModel.forEachNodeAfterFilterAndSort(callback);
	    };
	    GridApi.prototype.getFilterApiForColDef = function (colDef) {
	        console.warn('ag-grid API method getFilterApiForColDef deprecated, use getFilterApi instead');
	        return this.getFilterInstance(colDef);
	    };
	    GridApi.prototype.getFilterInstance = function (key) {
	        var column = this.columnController.getPrimaryColumn(key);
	        if (column) {
	            return this.filterManager.getFilterComponent(column, 'NO_UI').resolveNow(null, function (filterComp) { return filterComp; });
	        }
	    };
	    GridApi.prototype.getFilterApi = function (key) {
	        console.warn('ag-Grid: getFilterApi is deprecated, use getFilterInstance instead');
	        return this.getFilterInstance(key);
	    };
	    GridApi.prototype.destroyFilter = function (key) {
	        var column = this.columnController.getPrimaryColumn(key);
	        if (column) {
	            return this.filterManager.destroyFilter(column, "filterDestroyed");
	        }
	    };
	    GridApi.prototype.getStatusPanel = function (key) {
	        if (this.statusBarService) {
	            return this.statusBarService.getStatusPanel(key);
	        }
	    };
	    GridApi.prototype.getColumnDef = function (key) {
	        var column = this.columnController.getPrimaryColumn(key);
	        if (column) {
	            return column.getColDef();
	        }
	        else {
	            return null;
	        }
	    };
	    GridApi.prototype.onFilterChanged = function () {
	        this.filterManager.onFilterChanged();
	    };
	    GridApi.prototype.onSortChanged = function () {
	        this.sortController.onSortChanged();
	    };
	    GridApi.prototype.setSortModel = function (sortModel, source) {
	        if (source === void 0) { source = "api"; }
	        this.sortController.setSortModel(sortModel, source);
	    };
	    GridApi.prototype.getSortModel = function () {
	        return this.sortController.getSortModel();
	    };
	    GridApi.prototype.setFilterModel = function (model) {
	        this.filterManager.setFilterModel(model);
	    };
	    GridApi.prototype.getFilterModel = function () {
	        return this.filterManager.getFilterModel();
	    };
	    GridApi.prototype.getFocusedCell = function () {
	        return this.focusedCellController.getFocusedCell();
	    };
	    GridApi.prototype.clearFocusedCell = function () {
	        return this.focusedCellController.clearFocusedCell();
	    };
	    GridApi.prototype.setFocusedCell = function (rowIndex, colKey, floating) {
	        this.focusedCellController.setFocusedCell(rowIndex, colKey, floating, true);
	    };
	    GridApi.prototype.setSuppressRowDrag = function (value) {
	        this.gridOptionsWrapper.setProperty(gridOptionsWrapper_1.GridOptionsWrapper.PROP_SUPPRESS_ROW_DRAG, value);
	    };
	    GridApi.prototype.setHeaderHeight = function (headerHeight) {
	        this.gridOptionsWrapper.setProperty(gridOptionsWrapper_1.GridOptionsWrapper.PROP_HEADER_HEIGHT, headerHeight);
	        this.doLayout();
	    };
	    GridApi.prototype.setGridAutoHeight = function (gridAutoHeight) {
	        console.warn('api.setGridAutoHeight(boolean) is deprecated, please use api.setDomLayout() instead');
	        this.setDomLayout(gridAutoHeight ? 'autoHeight' : 'normal');
	    };
	    GridApi.prototype.setDomLayout = function (domLayout) {
	        this.gridOptionsWrapper.setProperty(gridOptionsWrapper_1.GridOptionsWrapper.PROP_DOM_LAYOUT, domLayout);
	    };
	    GridApi.prototype.setEnableCellTextSelection = function (selectable) {
	        this.gridPanel.setCellTextSelection(selectable);
	    };
	    GridApi.prototype.setGroupHeaderHeight = function (headerHeight) {
	        this.gridOptionsWrapper.setProperty(gridOptionsWrapper_1.GridOptionsWrapper.PROP_GROUP_HEADER_HEIGHT, headerHeight);
	        this.doLayout();
	    };
	    GridApi.prototype.setFloatingFiltersHeight = function (headerHeight) {
	        this.gridOptionsWrapper.setProperty(gridOptionsWrapper_1.GridOptionsWrapper.PROP_FLOATING_FILTERS_HEIGHT, headerHeight);
	        this.doLayout();
	    };
	    GridApi.prototype.setPivotGroupHeaderHeight = function (headerHeight) {
	        this.gridOptionsWrapper.setProperty(gridOptionsWrapper_1.GridOptionsWrapper.PROP_PIVOT_GROUP_HEADER_HEIGHT, headerHeight);
	        this.doLayout();
	    };
	    GridApi.prototype.setPivotHeaderHeight = function (headerHeight) {
	        this.gridOptionsWrapper.setProperty(gridOptionsWrapper_1.GridOptionsWrapper.PROP_PIVOT_HEADER_HEIGHT, headerHeight);
	        this.doLayout();
	    };
	    GridApi.prototype.isSideBarVisible = function () {
	        return this.gridCore.isSideBarVisible();
	    };
	    GridApi.prototype.setSideBarVisible = function (show) {
	        this.gridCore.setSideBarVisible(show);
	    };
	    GridApi.prototype.showToolPanel = function (show) {
	        console.warn("ag-grid: from v19 api.showToolPanel has been deprecated in favour of api.setSideBarVisible");
	        this.setSideBarVisible(show);
	    };
	    GridApi.prototype.openToolPanel = function (key) {
	        this.gridCore.openToolPanel(key);
	    };
	    GridApi.prototype.closeToolPanel = function () {
	        this.gridCore.closeToolPanel();
	    };
	    GridApi.prototype.getOpenedToolPanel = function () {
	        return this.gridCore.getOpenedToolPanel();
	    };
	    GridApi.prototype.getSideBar = function () {
	        return this.gridCore.getSideBar();
	    };
	    GridApi.prototype.setSideBar = function (def) {
	        return this.gridCore.setSideBar(def);
	    };
	    GridApi.prototype.setSuppressClipboardPaste = function (value) {
	        this.gridOptionsWrapper.setProperty(gridOptionsWrapper_1.GridOptionsWrapper.PROP_SUPPRESS_CLIPBOARD_PASTE, value);
	    };
	    GridApi.prototype.isToolPanelShowing = function () {
	        return this.gridCore.isToolPanelShowing();
	    };
	    GridApi.prototype.doLayout = function () {
	        this.gridPanel.checkViewportAndScrolls();
	    };
	    GridApi.prototype.resetRowHeights = function () {
	        if (utils_1._.exists(this.clientSideRowModel)) {
	            this.clientSideRowModel.resetRowHeights();
	        }
	    };
	    GridApi.prototype.setGroupRemoveSingleChildren = function (value) {
	        this.gridOptionsWrapper.setProperty(gridOptionsWrapper_1.GridOptionsWrapper.PROP_GROUP_REMOVE_SINGLE_CHILDREN, value);
	    };
	    GridApi.prototype.setGroupRemoveLowestSingleChildren = function (value) {
	        this.gridOptionsWrapper.setProperty(gridOptionsWrapper_1.GridOptionsWrapper.PROP_GROUP_REMOVE_LOWEST_SINGLE_CHILDREN, value);
	    };
	    GridApi.prototype.onRowHeightChanged = function () {
	        if (utils_1._.exists(this.clientSideRowModel)) {
	            this.clientSideRowModel.onRowHeightChanged();
	        }
	    };
	    GridApi.prototype.getValue = function (colKey, rowNode) {
	        var column = this.columnController.getPrimaryColumn(colKey);
	        if (utils_1._.missing(column)) {
	            column = this.columnController.getGridColumn(colKey);
	        }
	        if (utils_1._.missing(column)) {
	            return null;
	        }
	        else {
	            return this.valueService.getValue(column, rowNode);
	        }
	    };
	    GridApi.prototype.addEventListener = function (eventType, listener) {
	        var async = this.gridOptionsWrapper.useAsyncEvents();
	        this.eventService.addEventListener(eventType, listener, async);
	    };
	    GridApi.prototype.addGlobalListener = function (listener) {
	        var async = this.gridOptionsWrapper.useAsyncEvents();
	        this.eventService.addGlobalListener(listener, async);
	    };
	    GridApi.prototype.removeEventListener = function (eventType, listener) {
	        var async = this.gridOptionsWrapper.useAsyncEvents();
	        this.eventService.removeEventListener(eventType, listener, async);
	    };
	    GridApi.prototype.removeGlobalListener = function (listener) {
	        var async = this.gridOptionsWrapper.useAsyncEvents();
	        this.eventService.removeGlobalListener(listener, async);
	    };
	    GridApi.prototype.dispatchEvent = function (event) {
	        this.eventService.dispatchEvent(event);
	    };
	    GridApi.prototype.destroy = function () {
	        // destroy the UI first (as they use the services)
	        this.gridCore.destroy();
	        // destroy the services
	        this.context.destroy();
	    };
	    GridApi.prototype.resetQuickFilter = function () {
	        this.rowModel.forEachNode(function (node) { return node.quickFilterAggregateText = null; });
	    };
	    GridApi.prototype.getRangeSelections = function () {
	        console.warn("ag-Grid: in v20.1.x, api.getRangeSelections() is gone, please use getCellRanges() instead.\n        We had to change how cell selections works a small bit to allow charting to integrate. The return type of\n        getCellRanges() is a bit different, please check the ag-Grid documentation.");
	        return null;
	    };
	    GridApi.prototype.getCellRanges = function () {
	        if (this.rangeController) {
	            return this.rangeController.getCellRanges();
	        }
	        else {
	            console.warn('ag-Grid: cell range selection is only available in ag-Grid Enterprise');
	            return null;
	        }
	    };
	    GridApi.prototype.camelCaseToHumanReadable = function (camelCase) {
	        return utils_1._.camelCaseToHumanText(camelCase);
	    };
	    GridApi.prototype.addRangeSelection = function (deprecatedNoLongerUsed) {
	        console.warn('ag-Grid: As of version 21.x, range selection changed slightly to allow charting integration. Please call api.addCellRange() instead of api.addRangeSelection()');
	    };
	    GridApi.prototype.addCellRange = function (params) {
	        if (!this.rangeController) {
	            console.warn('ag-Grid: cell range selection is only available in ag-Grid Enterprise');
	        }
	        this.rangeController.addCellRange(params);
	    };
	    GridApi.prototype.clearRangeSelection = function () {
	        if (!this.rangeController) {
	            console.warn('ag-Grid: cell range selection is only available in ag-Grid Enterprise');
	        }
	        this.rangeController.removeAllCellRanges();
	    };
	    GridApi.prototype.chartRange = function (params) {
	        if (!this.context.isModuleRegistered("chartsModule" /* ChartsModule */)) {
	            utils_1._.doOnce(function () {
	                console.warn('ag-grid: Cannot chart range - the Charts Module has not been included.');
	            }, 'ChartsModuleCheck');
	            return;
	        }
	        return this.chartService.chartCellRange(params);
	    };
	    GridApi.prototype.copySelectedRowsToClipboard = function (includeHeader, columnKeys) {
	        if (!this.clipboardService) {
	            console.warn('ag-Grid: clipboard is only available in ag-Grid Enterprise');
	        }
	        this.clipboardService.copySelectedRowsToClipboard(includeHeader, columnKeys);
	    };
	    GridApi.prototype.copySelectedRangeToClipboard = function (includeHeader) {
	        if (!this.clipboardService) {
	            console.warn('ag-Grid: clipboard is only available in ag-Grid Enterprise');
	        }
	        this.clipboardService.copySelectedRangeToClipboard(includeHeader);
	    };
	    GridApi.prototype.copySelectedRangeDown = function () {
	        if (!this.clipboardService) {
	            console.warn('ag-Grid: clipboard is only available in ag-Grid Enterprise');
	        }
	        this.clipboardService.copyRangeDown();
	    };
	    GridApi.prototype.showColumnMenuAfterButtonClick = function (colKey, buttonElement) {
	        // use grid column so works with pivot mode
	        var column = this.columnController.getGridColumn(colKey);
	        this.menuFactory.showMenuAfterButtonClick(column, buttonElement);
	    };
	    GridApi.prototype.showColumnMenuAfterMouseClick = function (colKey, mouseEvent) {
	        // use grid column so works with pivot mode
	        var column = this.columnController.getGridColumn(colKey);
	        this.menuFactory.showMenuAfterMouseEvent(column, mouseEvent);
	    };
	    GridApi.prototype.hidePopupMenu = function () {
	        // hide the context menu if in enterprise
	        if (this.contextMenuFactory) {
	            this.contextMenuFactory.hideActiveMenu();
	        }
	        // and hide the column menu always
	        this.menuFactory.hideActiveMenu();
	    };
	    GridApi.prototype.setPopupParent = function (ePopupParent) {
	        this.gridOptionsWrapper.setProperty(gridOptionsWrapper_1.GridOptionsWrapper.PROP_POPUP_PARENT, ePopupParent);
	    };
	    GridApi.prototype.tabToNextCell = function () {
	        return this.rowRenderer.tabToNextCell(false);
	    };
	    GridApi.prototype.tabToPreviousCell = function () {
	        return this.rowRenderer.tabToNextCell(true);
	    };
	    GridApi.prototype.getCellRendererInstances = function (params) {
	        if (params === void 0) { params = {}; }
	        return this.rowRenderer.getCellRendererInstances(params);
	    };
	    GridApi.prototype.getCellEditorInstances = function (params) {
	        if (params === void 0) { params = {}; }
	        return this.rowRenderer.getCellEditorInstances(params);
	    };
	    GridApi.prototype.getEditingCells = function () {
	        return this.rowRenderer.getEditingCells();
	    };
	    GridApi.prototype.stopEditing = function (cancel) {
	        if (cancel === void 0) { cancel = false; }
	        this.rowRenderer.stopEditing(cancel);
	    };
	    GridApi.prototype.startEditingCell = function (params) {
	        var column = this.columnController.getGridColumn(params.colKey);
	        if (!column) {
	            console.warn("ag-Grid: no column found for " + params.colKey);
	            return;
	        }
	        var cellPosition = {
	            rowIndex: params.rowIndex,
	            rowPinned: params.rowPinned,
	            column: column
	        };
	        var notPinned = utils_1._.missing(params.rowPinned);
	        if (notPinned) {
	            this.gridPanel.ensureIndexVisible(params.rowIndex);
	        }
	        this.rowRenderer.startEditingCell(cellPosition, params.keyPress, params.charPress);
	    };
	    GridApi.prototype.addAggFunc = function (key, aggFunc) {
	        if (this.aggFuncService) {
	            this.aggFuncService.addAggFunc(key, aggFunc);
	        }
	    };
	    GridApi.prototype.addAggFuncs = function (aggFuncs) {
	        if (this.aggFuncService) {
	            this.aggFuncService.addAggFuncs(aggFuncs);
	        }
	    };
	    GridApi.prototype.clearAggFuncs = function () {
	        if (this.aggFuncService) {
	            this.aggFuncService.clear();
	        }
	    };
	    GridApi.prototype.updateRowData = function (rowDataTransaction) {
	        var res = null;
	        if (this.clientSideRowModel) {
	            res = this.clientSideRowModel.updateRowData(rowDataTransaction);
	        }
	        else if (this.infinitePageRowModel) {
	            this.infinitePageRowModel.updateRowData(rowDataTransaction);
	        }
	        else {
	            console.error('ag-Grid: updateRowData() only works with ClientSideRowModel and InfiniteRowModel.');
	        }
	        // refresh all the full width rows
	        this.rowRenderer.refreshFullWidthRows();
	        // do change detection for all present cells
	        if (!this.gridOptionsWrapper.isSuppressChangeDetection()) {
	            this.rowRenderer.refreshCells();
	        }
	        return res;
	    };
	    GridApi.prototype.batchUpdateRowData = function (rowDataTransaction, callback) {
	        if (!this.clientSideRowModel) {
	            console.error('ag-Grid: api.batchUpdateRowData() only works with ClientSideRowModel.');
	            return;
	        }
	        this.clientSideRowModel.batchUpdateRowData(rowDataTransaction, callback);
	    };
	    GridApi.prototype.insertItemsAtIndex = function (index, items, skipRefresh) {
	        if (skipRefresh === void 0) { skipRefresh = false; }
	        console.warn('ag-Grid: insertItemsAtIndex() is deprecated, use updateRowData(transaction) instead.');
	        this.updateRowData({ add: items, addIndex: index, update: null, remove: null });
	    };
	    GridApi.prototype.removeItems = function (rowNodes, skipRefresh) {
	        if (skipRefresh === void 0) { skipRefresh = false; }
	        console.warn('ag-Grid: removeItems() is deprecated, use updateRowData(transaction) instead.');
	        var dataToRemove = rowNodes.map(function (rowNode) { return rowNode.data; });
	        this.updateRowData({ add: null, addIndex: null, update: null, remove: dataToRemove });
	    };
	    GridApi.prototype.addItems = function (items, skipRefresh) {
	        if (skipRefresh === void 0) { skipRefresh = false; }
	        console.warn('ag-Grid: addItems() is deprecated, use updateRowData(transaction) instead.');
	        this.updateRowData({ add: items, addIndex: null, update: null, remove: null });
	    };
	    GridApi.prototype.refreshVirtualPageCache = function () {
	        console.warn('ag-Grid: refreshVirtualPageCache() is now called refreshInfiniteCache(), please call refreshInfiniteCache() instead');
	        this.refreshInfiniteCache();
	    };
	    GridApi.prototype.refreshInfinitePageCache = function () {
	        console.warn('ag-Grid: refreshInfinitePageCache() is now called refreshInfiniteCache(), please call refreshInfiniteCache() instead');
	        this.refreshInfiniteCache();
	    };
	    GridApi.prototype.refreshInfiniteCache = function () {
	        if (this.infinitePageRowModel) {
	            this.infinitePageRowModel.refreshCache();
	        }
	        else {
	            console.warn("ag-Grid: api.refreshInfiniteCache is only available when rowModelType='infinite'.");
	        }
	    };
	    GridApi.prototype.purgeVirtualPageCache = function () {
	        console.warn('ag-Grid: purgeVirtualPageCache() is now called purgeInfiniteCache(), please call purgeInfiniteCache() instead');
	        this.purgeInfinitePageCache();
	    };
	    GridApi.prototype.purgeInfinitePageCache = function () {
	        console.warn('ag-Grid: purgeInfinitePageCache() is now called purgeInfiniteCache(), please call purgeInfiniteCache() instead');
	        this.purgeInfiniteCache();
	    };
	    GridApi.prototype.purgeInfiniteCache = function () {
	        if (this.infinitePageRowModel) {
	            this.infinitePageRowModel.purgeCache();
	        }
	        else {
	            console.warn("ag-Grid: api.purgeInfiniteCache is only available when rowModelType='infinite'.");
	        }
	    };
	    /** @deprecated */
	    GridApi.prototype.purgeEnterpriseCache = function (route) {
	        console.warn("ag-grid: since version 18.x, api.purgeEnterpriseCache() should be replaced with api.purgeServerSideCache()");
	        this.purgeServerSideCache(route);
	    };
	    GridApi.prototype.purgeServerSideCache = function (route) {
	        if (this.serverSideRowModel) {
	            this.serverSideRowModel.purgeCache(route);
	        }
	        else {
	            console.warn("ag-Grid: api.purgeServerSideCache is only available when rowModelType='enterprise'.");
	        }
	    };
	    GridApi.prototype.getVirtualRowCount = function () {
	        console.warn('ag-Grid: getVirtualRowCount() is now called getInfiniteRowCount(), please call getInfiniteRowCount() instead');
	        return this.getInfiniteRowCount();
	    };
	    GridApi.prototype.getInfiniteRowCount = function () {
	        if (this.infinitePageRowModel) {
	            return this.infinitePageRowModel.getVirtualRowCount();
	        }
	        else {
	            console.warn("ag-Grid: api.getVirtualRowCount is only available when rowModelType='virtual'.");
	        }
	    };
	    GridApi.prototype.isMaxRowFound = function () {
	        if (this.infinitePageRowModel) {
	            return this.infinitePageRowModel.isMaxRowFound();
	        }
	        else {
	            console.warn("ag-Grid: api.isMaxRowFound is only available when rowModelType='virtual'.");
	        }
	    };
	    GridApi.prototype.setVirtualRowCount = function (rowCount, maxRowFound) {
	        console.warn('ag-Grid: setVirtualRowCount() is now called setInfiniteRowCount(), please call setInfiniteRowCount() instead');
	        this.setInfiniteRowCount(rowCount, maxRowFound);
	    };
	    GridApi.prototype.setInfiniteRowCount = function (rowCount, maxRowFound) {
	        if (this.infinitePageRowModel) {
	            this.infinitePageRowModel.setVirtualRowCount(rowCount, maxRowFound);
	        }
	        else {
	            console.warn("ag-Grid: api.setVirtualRowCount is only available when rowModelType='virtual'.");
	        }
	    };
	    GridApi.prototype.getVirtualPageState = function () {
	        console.warn('ag-Grid: getVirtualPageState() is now called getCacheBlockState(), please call getCacheBlockState() instead');
	        return this.getCacheBlockState();
	    };
	    GridApi.prototype.getInfinitePageState = function () {
	        console.warn('ag-Grid: getInfinitePageState() is now called getCacheBlockState(), please call getCacheBlockState() instead');
	        return this.getCacheBlockState();
	    };
	    GridApi.prototype.getCacheBlockState = function () {
	        if (this.infinitePageRowModel) {
	            return this.infinitePageRowModel.getBlockState();
	        }
	        else if (this.serverSideRowModel) {
	            return this.serverSideRowModel.getBlockState();
	        }
	        else {
	            console.warn("ag-Grid: api.getCacheBlockState() is only available when rowModelType='infinite' or rowModelType='serverSide'.");
	        }
	    };
	    GridApi.prototype.checkGridSize = function () {
	        this.gridPanel.setHeaderAndFloatingHeights();
	    };
	    GridApi.prototype.getFirstRenderedRow = function () {
	        console.warn('in ag-Grid v12, getFirstRenderedRow() was renamed to getFirstDisplayedRow()');
	        return this.getFirstDisplayedRow();
	    };
	    GridApi.prototype.getFirstDisplayedRow = function () {
	        return this.rowRenderer.getFirstVirtualRenderedRow();
	    };
	    GridApi.prototype.getLastRenderedRow = function () {
	        console.warn('in ag-Grid v12, getLastRenderedRow() was renamed to getLastDisplayedRow()');
	        return this.getLastDisplayedRow();
	    };
	    GridApi.prototype.getLastDisplayedRow = function () {
	        return this.rowRenderer.getLastVirtualRenderedRow();
	    };
	    GridApi.prototype.getDisplayedRowAtIndex = function (index) {
	        return this.rowModel.getRow(index);
	    };
	    GridApi.prototype.getDisplayedRowCount = function () {
	        return this.rowModel.getRowCount();
	    };
	    GridApi.prototype.paginationIsLastPageFound = function () {
	        return this.paginationProxy.isLastPageFound();
	    };
	    GridApi.prototype.paginationGetPageSize = function () {
	        return this.paginationProxy.getPageSize();
	    };
	    GridApi.prototype.paginationSetPageSize = function (size) {
	        this.gridOptionsWrapper.setProperty('paginationPageSize', size);
	    };
	    GridApi.prototype.paginationGetCurrentPage = function () {
	        return this.paginationProxy.getCurrentPage();
	    };
	    GridApi.prototype.paginationGetTotalPages = function () {
	        return this.paginationProxy.getTotalPages();
	    };
	    GridApi.prototype.paginationGetRowCount = function () {
	        return this.paginationProxy.getMasterRowCount();
	    };
	    GridApi.prototype.paginationGoToNextPage = function () {
	        this.paginationProxy.goToNextPage();
	    };
	    GridApi.prototype.paginationGoToPreviousPage = function () {
	        this.paginationProxy.goToPreviousPage();
	    };
	    GridApi.prototype.paginationGoToFirstPage = function () {
	        this.paginationProxy.goToFirstPage();
	    };
	    GridApi.prototype.paginationGoToLastPage = function () {
	        this.paginationProxy.goToLastPage();
	    };
	    GridApi.prototype.paginationGoToPage = function (page) {
	        this.paginationProxy.goToPage(page);
	    };
	    __decorate([
	        context_1.Autowired('immutableService'),
	        __metadata("design:type", immutableService_1.ImmutableService)
	    ], GridApi.prototype, "immutableService", void 0);
	    __decorate([
	        context_1.Autowired('csvCreator'),
	        __metadata("design:type", csvCreator_1.CsvCreator)
	    ], GridApi.prototype, "csvCreator", void 0);
	    __decorate([
	        context_1.Optional('excelCreator'),
	        __metadata("design:type", Object)
	    ], GridApi.prototype, "excelCreator", void 0);
	    __decorate([
	        context_1.Autowired('rowRenderer'),
	        __metadata("design:type", rowRenderer_1.RowRenderer)
	    ], GridApi.prototype, "rowRenderer", void 0);
	    __decorate([
	        context_1.Autowired('filterManager'),
	        __metadata("design:type", filterManager_1.FilterManager)
	    ], GridApi.prototype, "filterManager", void 0);
	    __decorate([
	        context_1.Autowired('columnController'),
	        __metadata("design:type", columnController_1.ColumnController)
	    ], GridApi.prototype, "columnController", void 0);
	    __decorate([
	        context_1.Autowired('selectionController'),
	        __metadata("design:type", selectionController_1.SelectionController)
	    ], GridApi.prototype, "selectionController", void 0);
	    __decorate([
	        context_1.Autowired('gridOptionsWrapper'),
	        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
	    ], GridApi.prototype, "gridOptionsWrapper", void 0);
	    __decorate([
	        context_1.Autowired('valueService'),
	        __metadata("design:type", valueService_1.ValueService)
	    ], GridApi.prototype, "valueService", void 0);
	    __decorate([
	        context_1.Autowired('alignedGridsService'),
	        __metadata("design:type", alignedGridsService_1.AlignedGridsService)
	    ], GridApi.prototype, "alignedGridsService", void 0);
	    __decorate([
	        context_1.Autowired('eventService'),
	        __metadata("design:type", eventService_1.EventService)
	    ], GridApi.prototype, "eventService", void 0);
	    __decorate([
	        context_1.Autowired('pinnedRowModel'),
	        __metadata("design:type", pinnedRowModel_1.PinnedRowModel)
	    ], GridApi.prototype, "pinnedRowModel", void 0);
	    __decorate([
	        context_1.Autowired('context'),
	        __metadata("design:type", context_1.Context)
	    ], GridApi.prototype, "context", void 0);
	    __decorate([
	        context_1.Autowired('rowModel'),
	        __metadata("design:type", Object)
	    ], GridApi.prototype, "rowModel", void 0);
	    __decorate([
	        context_1.Autowired('sortController'),
	        __metadata("design:type", sortController_1.SortController)
	    ], GridApi.prototype, "sortController", void 0);
	    __decorate([
	        context_1.Autowired('paginationProxy'),
	        __metadata("design:type", paginationProxy_1.PaginationProxy)
	    ], GridApi.prototype, "paginationProxy", void 0);
	    __decorate([
	        context_1.Autowired('focusedCellController'),
	        __metadata("design:type", focusedCellController_1.FocusedCellController)
	    ], GridApi.prototype, "focusedCellController", void 0);
	    __decorate([
	        context_1.Optional('rangeController'),
	        __metadata("design:type", Object)
	    ], GridApi.prototype, "rangeController", void 0);
	    __decorate([
	        context_1.Optional('clipboardService'),
	        __metadata("design:type", Object)
	    ], GridApi.prototype, "clipboardService", void 0);
	    __decorate([
	        context_1.Optional('aggFuncService'),
	        __metadata("design:type", Object)
	    ], GridApi.prototype, "aggFuncService", void 0);
	    __decorate([
	        context_1.Autowired('menuFactory'),
	        __metadata("design:type", Object)
	    ], GridApi.prototype, "menuFactory", void 0);
	    __decorate([
	        context_1.Optional('contextMenuFactory'),
	        __metadata("design:type", Object)
	    ], GridApi.prototype, "contextMenuFactory", void 0);
	    __decorate([
	        context_1.Autowired('cellRendererFactory'),
	        __metadata("design:type", cellRendererFactory_1.CellRendererFactory)
	    ], GridApi.prototype, "cellRendererFactory", void 0);
	    __decorate([
	        context_1.Autowired('valueCache'),
	        __metadata("design:type", valueCache_1.ValueCache)
	    ], GridApi.prototype, "valueCache", void 0);
	    __decorate([
	        context_1.Optional('sideBarComp'),
	        __metadata("design:type", Object)
	    ], GridApi.prototype, "sideBarComp", void 0);
	    __decorate([
	        context_1.Autowired('animationFrameService'),
	        __metadata("design:type", animationFrameService_1.AnimationFrameService)
	    ], GridApi.prototype, "animationFrameService", void 0);
	    __decorate([
	        context_1.Optional('statusBarService'),
	        __metadata("design:type", Object)
	    ], GridApi.prototype, "statusBarService", void 0);
	    __decorate([
	        context_1.Optional('chartService'),
	        __metadata("design:type", Object)
	    ], GridApi.prototype, "chartService", void 0);
	    __decorate([
	        context_1.PostConstruct,
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", []),
	        __metadata("design:returntype", void 0)
	    ], GridApi.prototype, "init", null);
	    GridApi = __decorate([
	        context_1.Bean('gridApi')
	    ], GridApi);
	    return GridApi;
	}());
	exports.GridApi = GridApi;


/***/ }),
/* 2339 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var context_1 = __webpack_require__(2333);
	var gridSerializer_1 = __webpack_require__(2340);
	var downloader_1 = __webpack_require__(2436);
	var columnController_1 = __webpack_require__(2341);
	var valueService_1 = __webpack_require__(2359);
	var gridOptionsWrapper_1 = __webpack_require__(2324);
	var constants_1 = __webpack_require__(2328);
	var utils_1 = __webpack_require__(2325);
	var LINE_SEPARATOR = '\r\n';
	var CsvSerializingSession = /** @class */ (function (_super) {
	    __extends(CsvSerializingSession, _super);
	    function CsvSerializingSession(config) {
	        var _this = _super.call(this, {
	            columnController: config.columnController,
	            valueService: config.valueService,
	            gridOptionsWrapper: config.gridOptionsWrapper,
	            processCellCallback: config.processCellCallback,
	            processHeaderCallback: config.processHeaderCallback
	        }) || this;
	        _this.result = '';
	        _this.lineOpened = false;
	        var suppressQuotes = config.suppressQuotes, columnSeparator = config.columnSeparator;
	        _this.suppressQuotes = suppressQuotes;
	        _this.columnSeparator = columnSeparator;
	        return _this;
	    }
	    CsvSerializingSession.prototype.prepare = function (columnsToExport) {
	    };
	    CsvSerializingSession.prototype.addCustomHeader = function (customHeader) {
	        if (!customHeader) {
	            return;
	        }
	        this.result += customHeader + LINE_SEPARATOR;
	    };
	    CsvSerializingSession.prototype.addCustomFooter = function (customFooter) {
	        if (!customFooter) {
	            return;
	        }
	        this.result += customFooter + LINE_SEPARATOR;
	    };
	    CsvSerializingSession.prototype.onNewHeaderGroupingRow = function () {
	        if (this.lineOpened) {
	            this.result += LINE_SEPARATOR;
	        }
	        return {
	            onColumn: this.onNewHeaderGroupingRowColumn.bind(this)
	        };
	    };
	    CsvSerializingSession.prototype.onNewHeaderGroupingRowColumn = function (header, index, span) {
	        if (index != 0) {
	            this.result += this.columnSeparator;
	        }
	        this.result += this.putInQuotes(header, this.suppressQuotes);
	        for (var i = 1; i <= span; i++) {
	            this.result += this.columnSeparator + this.putInQuotes("", this.suppressQuotes);
	        }
	        this.lineOpened = true;
	    };
	    CsvSerializingSession.prototype.onNewHeaderRow = function () {
	        if (this.lineOpened) {
	            this.result += LINE_SEPARATOR;
	        }
	        return {
	            onColumn: this.onNewHeaderRowColumn.bind(this)
	        };
	    };
	    CsvSerializingSession.prototype.onNewHeaderRowColumn = function (column, index, node) {
	        if (index != 0) {
	            this.result += this.columnSeparator;
	        }
	        this.result += this.putInQuotes(this.extractHeaderValue(column), this.suppressQuotes);
	        this.lineOpened = true;
	    };
	    CsvSerializingSession.prototype.onNewBodyRow = function () {
	        if (this.lineOpened) {
	            this.result += LINE_SEPARATOR;
	        }
	        return {
	            onColumn: this.onNewBodyRowColumn.bind(this)
	        };
	    };
	    CsvSerializingSession.prototype.onNewBodyRowColumn = function (column, index, node) {
	        if (index != 0) {
	            this.result += this.columnSeparator;
	        }
	        this.result += this.putInQuotes(this.extractRowCellValue(column, index, constants_1.Constants.EXPORT_TYPE_CSV, node), this.suppressQuotes);
	        this.lineOpened = true;
	    };
	    CsvSerializingSession.prototype.putInQuotes = function (value, suppressQuotes) {
	        if (suppressQuotes) {
	            return value;
	        }
	        if (value === null || value === undefined) {
	            return '""';
	        }
	        var stringValue;
	        if (typeof value === 'string') {
	            stringValue = value;
	        }
	        else if (typeof value.toString === 'function') {
	            stringValue = value.toString();
	        }
	        else {
	            console.warn('unknown value type during csv conversion');
	            stringValue = '';
	        }
	        // replace each " with "" (ie two sets of double quotes is how to do double quotes in csv)
	        var valueEscaped = stringValue.replace(/"/g, "\"\"");
	        return '"' + valueEscaped + '"';
	    };
	    CsvSerializingSession.prototype.parse = function () {
	        return this.result;
	    };
	    return CsvSerializingSession;
	}(gridSerializer_1.BaseGridSerializingSession));
	exports.CsvSerializingSession = CsvSerializingSession;
	var BaseCreator = /** @class */ (function () {
	    function BaseCreator() {
	    }
	    BaseCreator.prototype.setBeans = function (beans) {
	        this.beans = beans;
	    };
	    BaseCreator.prototype.export = function (userParams) {
	        if (this.isExportSuppressed()) {
	            console.warn("ag-grid: Export cancelled. Export is not allowed as per your configuration.");
	            return '';
	        }
	        var _a = this.getMergedParamsAndData(userParams), mergedParams = _a.mergedParams, data = _a.data;
	        var fileNamePresent = mergedParams && mergedParams.fileName && mergedParams.fileName.length !== 0;
	        var fileName = fileNamePresent ? mergedParams.fileName : this.getDefaultFileName();
	        if (fileName.indexOf(".") === -1) {
	            fileName = fileName + "." + this.getDefaultFileExtension();
	        }
	        this.beans.downloader.download(fileName, this.packageFile(data));
	        return data;
	    };
	    BaseCreator.prototype.getData = function (params) {
	        return this.getMergedParamsAndData(params).data;
	    };
	    BaseCreator.prototype.getMergedParamsAndData = function (userParams) {
	        var mergedParams = this.mergeDefaultParams(userParams);
	        var data = this.beans.gridSerializer.serialize(this.createSerializingSession(mergedParams), mergedParams);
	        return { mergedParams: mergedParams, data: data };
	    };
	    BaseCreator.prototype.mergeDefaultParams = function (userParams) {
	        var baseParams = this.beans.gridOptionsWrapper.getDefaultExportParams();
	        var params = {};
	        utils_1._.assign(params, baseParams);
	        utils_1._.assign(params, userParams);
	        return params;
	    };
	    BaseCreator.prototype.packageFile = function (data) {
	        return new Blob(["\ufeff", data], {
	            type: window.navigator.msSaveOrOpenBlob ? this.getMimeType() : 'octet/stream'
	        });
	    };
	    return BaseCreator;
	}());
	exports.BaseCreator = BaseCreator;
	var CsvCreator = /** @class */ (function (_super) {
	    __extends(CsvCreator, _super);
	    function CsvCreator() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    CsvCreator.prototype.postConstruct = function () {
	        this.setBeans({
	            downloader: this.downloader,
	            gridSerializer: this.gridSerializer,
	            gridOptionsWrapper: this.gridOptionsWrapper
	        });
	    };
	    CsvCreator.prototype.exportDataAsCsv = function (params) {
	        return this.export(params);
	    };
	    CsvCreator.prototype.getDataAsCsv = function (params) {
	        return this.getData(params);
	    };
	    CsvCreator.prototype.getMimeType = function () {
	        return 'text/csv;charset=utf-8;';
	    };
	    CsvCreator.prototype.getDefaultFileName = function () {
	        return 'export.csv';
	    };
	    CsvCreator.prototype.getDefaultFileExtension = function () {
	        return 'csv';
	    };
	    CsvCreator.prototype.createSerializingSession = function (params) {
	        var _a = this, columnController = _a.columnController, valueService = _a.valueService, gridOptionsWrapper = _a.gridOptionsWrapper;
	        var _b = params, processCellCallback = _b.processCellCallback, processHeaderCallback = _b.processHeaderCallback, suppressQuotes = _b.suppressQuotes, columnSeparator = _b.columnSeparator;
	        return new CsvSerializingSession({
	            columnController: columnController,
	            valueService: valueService,
	            gridOptionsWrapper: gridOptionsWrapper,
	            processCellCallback: processCellCallback || undefined,
	            processHeaderCallback: processHeaderCallback || undefined,
	            suppressQuotes: suppressQuotes || false,
	            columnSeparator: columnSeparator || ','
	        });
	    };
	    CsvCreator.prototype.isExportSuppressed = function () {
	        return this.gridOptionsWrapper.isSuppressCsvExport();
	    };
	    __decorate([
	        context_1.Autowired('columnController'),
	        __metadata("design:type", columnController_1.ColumnController)
	    ], CsvCreator.prototype, "columnController", void 0);
	    __decorate([
	        context_1.Autowired('valueService'),
	        __metadata("design:type", valueService_1.ValueService)
	    ], CsvCreator.prototype, "valueService", void 0);
	    __decorate([
	        context_1.Autowired('downloader'),
	        __metadata("design:type", downloader_1.Downloader)
	    ], CsvCreator.prototype, "downloader", void 0);
	    __decorate([
	        context_1.Autowired('gridSerializer'),
	        __metadata("design:type", gridSerializer_1.GridSerializer)
	    ], CsvCreator.prototype, "gridSerializer", void 0);
	    __decorate([
	        context_1.Autowired('gridOptionsWrapper'),
	        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
	    ], CsvCreator.prototype, "gridOptionsWrapper", void 0);
	    __decorate([
	        context_1.PostConstruct,
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", []),
	        __metadata("design:returntype", void 0)
	    ], CsvCreator.prototype, "postConstruct", null);
	    CsvCreator = __decorate([
	        context_1.Bean('csvCreator')
	    ], CsvCreator);
	    return CsvCreator;
	}(BaseCreator));
	exports.CsvCreator = CsvCreator;


/***/ }),
/* 2340 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var context_1 = __webpack_require__(2333);
	var columnController_1 = __webpack_require__(2341);
	var constants_1 = __webpack_require__(2328);
	var selectionController_1 = __webpack_require__(2357);
	var gridOptionsWrapper_1 = __webpack_require__(2324);
	var displayedGroupCreator_1 = __webpack_require__(2348);
	var columnFactory_1 = __webpack_require__(2323);
	var groupInstanceIdCreator_1 = __webpack_require__(2434);
	var columnGroup_1 = __webpack_require__(2342);
	var pinnedRowModel_1 = __webpack_require__(2371);
	var utils_1 = __webpack_require__(2325);
	var BaseGridSerializingSession = /** @class */ (function () {
	    function BaseGridSerializingSession(config) {
	        var columnController = config.columnController, valueService = config.valueService, gridOptionsWrapper = config.gridOptionsWrapper, processCellCallback = config.processCellCallback, processHeaderCallback = config.processHeaderCallback, cellAndHeaderEscaper = config.cellAndHeaderEscaper;
	        this.columnController = columnController;
	        this.valueService = valueService;
	        this.gridOptionsWrapper = gridOptionsWrapper;
	        this.processCellCallback = processCellCallback;
	        this.processHeaderCallback = processHeaderCallback;
	        this.cellAndHeaderEscaper = cellAndHeaderEscaper;
	    }
	    BaseGridSerializingSession.prototype.extractHeaderValue = function (column) {
	        var nameForCol = this.getHeaderName(this.processHeaderCallback, column);
	        if (nameForCol === null || nameForCol === undefined) {
	            nameForCol = '';
	        }
	        return this.cellAndHeaderEscaper ? this.cellAndHeaderEscaper(nameForCol) : nameForCol;
	    };
	    BaseGridSerializingSession.prototype.extractRowCellValue = function (column, index, type, node) {
	        var isRowGrouping = this.columnController.getRowGroupColumns().length > 0;
	        var valueForCell;
	        if (node && node.group && isRowGrouping && index === 0) {
	            valueForCell = this.createValueForGroupNode(node);
	        }
	        else {
	            valueForCell = this.valueService.getValue(column, node);
	        }
	        valueForCell = this.processCell(node, column, valueForCell, this.processCellCallback, type);
	        if (valueForCell === null || valueForCell === undefined) {
	            valueForCell = '';
	        }
	        return this.cellAndHeaderEscaper ? this.cellAndHeaderEscaper(valueForCell) : valueForCell;
	    };
	    BaseGridSerializingSession.prototype.getHeaderName = function (callback, column) {
	        if (callback) {
	            return callback({
	                column: column,
	                api: this.gridOptionsWrapper.getApi(),
	                columnApi: this.gridOptionsWrapper.getColumnApi(),
	                context: this.gridOptionsWrapper.getContext()
	            });
	        }
	        else {
	            return this.columnController.getDisplayNameForColumn(column, 'csv', true);
	        }
	    };
	    BaseGridSerializingSession.prototype.createValueForGroupNode = function (node) {
	        var keys = [node.key];
	        while (node.parent) {
	            node = node.parent;
	            keys.push(node.key);
	        }
	        return keys.reverse().join(' -> ');
	    };
	    BaseGridSerializingSession.prototype.processCell = function (rowNode, column, value, processCellCallback, type) {
	        if (processCellCallback) {
	            return processCellCallback({
	                column: column,
	                node: rowNode,
	                value: value,
	                api: this.gridOptionsWrapper.getApi(),
	                columnApi: this.gridOptionsWrapper.getColumnApi(),
	                context: this.gridOptionsWrapper.getContext(),
	                type: type
	            });
	        }
	        else {
	            return value;
	        }
	    };
	    return BaseGridSerializingSession;
	}());
	exports.BaseGridSerializingSession = BaseGridSerializingSession;
	var GridSerializer = /** @class */ (function () {
	    function GridSerializer() {
	    }
	    GridSerializer.prototype.serialize = function (gridSerializingSession, params) {
	        var dontSkipRows = function () { return false; };
	        var skipGroups = params && params.skipGroups;
	        var skipHeader = params && params.skipHeader;
	        var columnGroups = params && params.columnGroups;
	        var skipFooters = params && params.skipFooters;
	        var skipPinnedTop = params && params.skipPinnedTop;
	        var skipPinnedBottom = params && params.skipPinnedBottom;
	        var includeCustomHeader = params && params.customHeader;
	        var includeCustomFooter = params && params.customFooter;
	        var allColumns = params && params.allColumns;
	        var onlySelected = params && params.onlySelected;
	        var columnKeys = params && params.columnKeys;
	        var onlySelectedAllPages = params && params.onlySelectedAllPages;
	        var rowSkipper = (params && params.shouldRowBeSkipped) || dontSkipRows;
	        var api = this.gridOptionsWrapper.getApi();
	        var skipSingleChildrenGroup = this.gridOptionsWrapper.isGroupRemoveSingleChildren();
	        var skipLowestSingleChildrenGroup = this.gridOptionsWrapper.isGroupRemoveLowestSingleChildren();
	        var context = this.gridOptionsWrapper.getContext();
	        // when in pivot mode, we always render cols on screen, never 'all columns'
	        var isPivotMode = this.columnController.isPivotMode();
	        var rowModelNormal = this.rowModel.getType() === constants_1.Constants.ROW_MODEL_TYPE_CLIENT_SIDE;
	        var onlySelectedNonStandardModel = !rowModelNormal && onlySelected;
	        var columnsToExport = [];
	        if (utils_1._.existsAndNotEmpty(columnKeys)) {
	            columnsToExport = this.columnController.getGridColumns(columnKeys);
	        }
	        else if (allColumns && !isPivotMode) {
	            // add auto group column for tree data
	            columnsToExport = this.gridOptionsWrapper.isTreeData() ?
	                this.columnController.getGridColumns([constants_1.Constants.GROUP_AUTO_COLUMN_ID]) : [];
	            columnsToExport = columnsToExport.concat(this.columnController.getAllPrimaryColumns() || []);
	        }
	        else {
	            columnsToExport = this.columnController.getAllDisplayedColumns();
	        }
	        if (includeCustomHeader) {
	            gridSerializingSession.addCustomHeader(includeCustomHeader);
	        }
	        gridSerializingSession.prepare(columnsToExport);
	        // first pass, put in the header names of the cols
	        if (columnGroups) {
	            var groupInstanceIdCreator = new groupInstanceIdCreator_1.GroupInstanceIdCreator();
	            var displayedGroups = this.displayedGroupCreator.createDisplayedGroups(columnsToExport, this.columnController.getGridBalancedTree(), groupInstanceIdCreator, null);
	            this.recursivelyAddHeaderGroups(displayedGroups, gridSerializingSession);
	        }
	        if (!skipHeader) {
	            var gridRowIterator_1 = gridSerializingSession.onNewHeaderRow();
	            columnsToExport.forEach(function (column, index) {
	                gridRowIterator_1.onColumn(column, index, undefined);
	            });
	        }
	        this.pinnedRowModel.forEachPinnedTopRow(processRow);
	        if (isPivotMode) {
	            if (this.rowModel.forEachPivotNode) {
	                this.rowModel.forEachPivotNode(processRow);
	            }
	            else {
	                //Must be enterprise, so we can just loop through all the nodes
	                this.rowModel.forEachNode(processRow);
	            }
	        }
	        else {
	            // onlySelectedAllPages: user doing pagination and wants selected items from
	            // other pages, so cannot use the standard row model as it won't have rows from
	            // other pages.
	            // onlySelectedNonStandardModel: if user wants selected in non standard row model
	            // (eg viewport) then again rowmodel cannot be used, so need to use selected instead.
	            if (onlySelectedAllPages || onlySelectedNonStandardModel) {
	                var selectedNodes = this.selectionController.getSelectedNodes();
	                selectedNodes.forEach(function (node) {
	                    processRow(node);
	                });
	            }
	            else {
	                // here is everything else - including standard row model and selected. we don't use
	                // the selection model even when just using selected, so that the result is the order
	                // of the rows appearing on the screen.
	                if (rowModelNormal) {
	                    this.rowModel.forEachNodeAfterFilterAndSort(processRow);
	                }
	                else {
	                    this.rowModel.forEachNode(processRow);
	                }
	            }
	        }
	        this.pinnedRowModel.forEachPinnedBottomRow(processRow);
	        if (includeCustomFooter) {
	            gridSerializingSession.addCustomFooter(includeCustomFooter);
	        }
	        function processRow(node) {
	            var shouldSkipLowestGroup = skipLowestSingleChildrenGroup && node.leafGroup;
	            var shouldSkipCurrentGroup = node.allChildrenCount === 1 && (skipSingleChildrenGroup || shouldSkipLowestGroup);
	            if (node.group && (skipGroups || shouldSkipCurrentGroup)) {
	                return;
	            }
	            if (skipFooters && node.footer) {
	                return;
	            }
	            if (onlySelected && !node.isSelected()) {
	                return;
	            }
	            if (skipPinnedTop && node.rowPinned === 'top') {
	                return;
	            }
	            if (skipPinnedBottom && node.rowPinned === 'bottom') {
	                return;
	            }
	            // if we are in pivotMode, then the grid will show the root node only
	            // if it's not a leaf group
	            var nodeIsRootNode = node.level === -1;
	            if (nodeIsRootNode && !node.leafGroup) {
	                return;
	            }
	            var shouldRowBeSkipped = rowSkipper({
	                node: node,
	                api: api,
	                context: context
	            });
	            if (shouldRowBeSkipped) {
	                return;
	            }
	            var rowAccumulator = gridSerializingSession.onNewBodyRow();
	            columnsToExport.forEach(function (column, index) {
	                rowAccumulator.onColumn(column, index, node);
	            });
	        }
	        return gridSerializingSession.parse();
	    };
	    GridSerializer.prototype.recursivelyAddHeaderGroups = function (displayedGroups, gridSerializingSession) {
	        var directChildrenHeaderGroups = [];
	        displayedGroups.forEach(function (columnGroupChild) {
	            var columnGroup = columnGroupChild;
	            if (!columnGroup.getChildren) {
	                return;
	            }
	            columnGroup.getChildren().forEach(function (it) { return directChildrenHeaderGroups.push(it); });
	        });
	        if (displayedGroups.length > 0 && displayedGroups[0] instanceof columnGroup_1.ColumnGroup) {
	            this.doAddHeaderHeader(gridSerializingSession, displayedGroups);
	        }
	        if (directChildrenHeaderGroups && directChildrenHeaderGroups.length > 0) {
	            this.recursivelyAddHeaderGroups(directChildrenHeaderGroups, gridSerializingSession);
	        }
	    };
	    GridSerializer.prototype.doAddHeaderHeader = function (gridSerializingSession, displayedGroups) {
	        var _this = this;
	        var gridRowIterator = gridSerializingSession.onNewHeaderGroupingRow();
	        var columnIndex = 0;
	        displayedGroups.forEach(function (columnGroupChild) {
	            var columnGroup = columnGroupChild;
	            var columnName = _this.columnController.getDisplayNameForColumnGroup(columnGroup, 'header');
	            gridRowIterator.onColumn(columnName || '', columnIndex++, columnGroup.getLeafColumns().length - 1);
	        });
	    };
	    __decorate([
	        context_1.Autowired('displayedGroupCreator'),
	        __metadata("design:type", displayedGroupCreator_1.DisplayedGroupCreator)
	    ], GridSerializer.prototype, "displayedGroupCreator", void 0);
	    __decorate([
	        context_1.Autowired('columnController'),
	        __metadata("design:type", columnController_1.ColumnController)
	    ], GridSerializer.prototype, "columnController", void 0);
	    __decorate([
	        context_1.Autowired('rowModel'),
	        __metadata("design:type", Object)
	    ], GridSerializer.prototype, "rowModel", void 0);
	    __decorate([
	        context_1.Autowired('pinnedRowModel'),
	        __metadata("design:type", pinnedRowModel_1.PinnedRowModel)
	    ], GridSerializer.prototype, "pinnedRowModel", void 0);
	    __decorate([
	        context_1.Autowired('selectionController'),
	        __metadata("design:type", selectionController_1.SelectionController)
	    ], GridSerializer.prototype, "selectionController", void 0);
	    __decorate([
	        context_1.Autowired('columnFactory'),
	        __metadata("design:type", columnFactory_1.ColumnFactory)
	    ], GridSerializer.prototype, "columnFactory", void 0);
	    __decorate([
	        context_1.Autowired('gridOptionsWrapper'),
	        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
	    ], GridSerializer.prototype, "gridOptionsWrapper", void 0);
	    GridSerializer = __decorate([
	        context_1.Bean("gridSerializer")
	    ], GridSerializer);
	    return GridSerializer;
	}());
	exports.GridSerializer = GridSerializer;
	var RowType;
	(function (RowType) {
	    RowType[RowType["HEADER_GROUPING"] = 0] = "HEADER_GROUPING";
	    RowType[RowType["HEADER"] = 1] = "HEADER";
	    RowType[RowType["BODY"] = 2] = "BODY";
	})(RowType = exports.RowType || (exports.RowType = {}));


/***/ }),
/* 2341 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var __param = (this && this.__param) || function (paramIndex, decorator) {
	    return function (target, key) { decorator(target, key, paramIndex); }
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var columnGroup_1 = __webpack_require__(2342);
	var column_1 = __webpack_require__(2343);
	var gridOptionsWrapper_1 = __webpack_require__(2324);
	var expressionService_1 = __webpack_require__(2347);
	var columnFactory_1 = __webpack_require__(2323);
	var displayedGroupCreator_1 = __webpack_require__(2348);
	var autoWidthCalculator_1 = __webpack_require__(2349);
	var eventService_1 = __webpack_require__(2331);
	var columnUtils_1 = __webpack_require__(2344);
	var logger_1 = __webpack_require__(2332);
	var events_1 = __webpack_require__(2335);
	var originalColumnGroup_1 = __webpack_require__(2345);
	var groupInstanceIdCreator_1 = __webpack_require__(2434);
	var context_1 = __webpack_require__(2333);
	var columnAnimationService_1 = __webpack_require__(2375);
	var autoGroupColService_1 = __webpack_require__(2435);
	var valueCache_1 = __webpack_require__(2360);
	var gridApi_1 = __webpack_require__(2338);
	var columnApi_1 = __webpack_require__(2346);
	var utils_1 = __webpack_require__(2325);
	var ColumnController = /** @class */ (function () {
	    function ColumnController() {
	        // header row count, based on user provided columns
	        this.primaryHeaderRowCount = 0;
	        this.secondaryHeaderRowCount = 0;
	        this.secondaryColumnsPresent = false;
	        // header row count, either above, or based on pivoting if we are pivoting
	        this.gridHeaderRowCount = 0;
	        // these are the lists used by the rowRenderer to render nodes. almost the leaf nodes of the above
	        // displayed trees, however it also takes into account if the groups are open or not.
	        this.displayedLeftColumns = [];
	        this.displayedRightColumns = [];
	        this.displayedCenterColumns = [];
	        // all three lists above combined
	        this.allDisplayedColumns = [];
	        // same as above, except trimmed down to only columns within the viewport
	        this.allDisplayedVirtualColumns = [];
	        this.allDisplayedCenterVirtualColumns = [];
	        this.rowGroupColumns = [];
	        this.valueColumns = [];
	        this.pivotColumns = [];
	        this.ready = false;
	        this.autoGroupsNeedBuilding = false;
	        this.pivotMode = false;
	        this.bodyWidth = 0;
	        this.leftWidth = 0;
	        this.rightWidth = 0;
	        this.bodyWidthDirty = true;
	    }
	    ColumnController.prototype.init = function () {
	        var pivotMode = this.gridOptionsWrapper.isPivotMode();
	        this.suppressColumnVirtualisation = this.gridOptionsWrapper.isSuppressColumnVirtualisation();
	        if (this.isPivotSettingAllowed(pivotMode)) {
	            this.pivotMode = pivotMode;
	        }
	        this.usingTreeData = this.gridOptionsWrapper.isTreeData();
	    };
	    ColumnController.prototype.setColumnDefs = function (columnDefs, source) {
	        if (source === void 0) { source = "api"; }
	        var colsPreviouslyExisted = !!this.columnDefs;
	        this.columnDefs = columnDefs;
	        // always invalidate cache on changing columns, as the column id's for the new columns
	        // could overlap with the old id's, so the cache would return old values for new columns.
	        this.valueCache.expire();
	        // NOTE ==================
	        // we should be destroying the existing columns and groups if they exist, for example, the original column
	        // group adds a listener to the columns, it should be also removing the listeners
	        this.autoGroupsNeedBuilding = true;
	        var oldPrimaryColumns = this.primaryColumns;
	        var balancedTreeResult = this.columnFactory.createColumnTree(columnDefs, true, oldPrimaryColumns);
	        this.primaryColumnTree = balancedTreeResult.columnTree;
	        this.primaryHeaderRowCount = balancedTreeResult.treeDept + 1;
	        this.primaryColumns = this.getColumnsFromTree(this.primaryColumnTree);
	        this.extractRowGroupColumns(source, oldPrimaryColumns);
	        this.extractPivotColumns(source, oldPrimaryColumns);
	        this.createValueColumns(source, oldPrimaryColumns);
	        this.ready = true;
	        this.updateGridColumns();
	        this.updateDisplayedColumns(source);
	        this.checkDisplayedVirtualColumns();
	        if (this.gridOptionsWrapper.isDeltaColumnMode() && colsPreviouslyExisted) {
	            this.resetColumnState(true, source);
	        }
	        var eventEverythingChanged = {
	            type: events_1.Events.EVENT_COLUMN_EVERYTHING_CHANGED,
	            api: this.gridApi,
	            columnApi: this.columnApi,
	            source: source
	        };
	        this.eventService.dispatchEvent(eventEverythingChanged);
	        var newColumnsLoadedEvent = {
	            type: events_1.Events.EVENT_NEW_COLUMNS_LOADED,
	            api: this.gridApi,
	            columnApi: this.columnApi
	        };
	        this.eventService.dispatchEvent(newColumnsLoadedEvent);
	    };
	    ColumnController.prototype.isAutoRowHeightActive = function () {
	        return this.autoRowHeightColumns && this.autoRowHeightColumns.length > 0;
	    };
	    ColumnController.prototype.getAllAutoRowHeightCols = function () {
	        return this.autoRowHeightColumns;
	    };
	    ColumnController.prototype.setVirtualViewportLeftAndRight = function () {
	        if (this.gridOptionsWrapper.isEnableRtl()) {
	            this.viewportLeft = this.bodyWidth - this.scrollPosition - this.scrollWidth;
	            this.viewportRight = this.bodyWidth - this.scrollPosition;
	        }
	        else {
	            this.viewportLeft = this.scrollPosition;
	            this.viewportRight = this.scrollWidth + this.scrollPosition;
	        }
	    };
	    // used by clipboard service, to know what columns to paste into
	    ColumnController.prototype.getDisplayedColumnsStartingAt = function (column) {
	        var currentColumn = column;
	        var result = [];
	        while (currentColumn && utils_1._.exists(currentColumn)) {
	            result.push(currentColumn);
	            currentColumn = this.getDisplayedColAfter(currentColumn);
	        }
	        return result;
	    };
	    // checks what columns are currently displayed due to column virtualisation. fires an event
	    // if the list of columns has changed.
	    // + setColumnWidth(), setVirtualViewportPosition(), setColumnDefs(), sizeColumnsToFit()
	    ColumnController.prototype.checkDisplayedVirtualColumns = function () {
	        // check displayCenterColumnTree exists first, as it won't exist when grid is initialising
	        if (utils_1._.exists(this.displayedCenterColumns)) {
	            var hashBefore = this.allDisplayedVirtualColumns.map(function (column) { return column.getId(); }).join('#');
	            this.updateVirtualSets();
	            var hashAfter = this.allDisplayedVirtualColumns.map(function (column) { return column.getId(); }).join('#');
	            if (hashBefore !== hashAfter) {
	                var event_1 = {
	                    type: events_1.Events.EVENT_VIRTUAL_COLUMNS_CHANGED,
	                    api: this.gridApi,
	                    columnApi: this.columnApi
	                };
	                this.eventService.dispatchEvent(event_1);
	            }
	        }
	    };
	    ColumnController.prototype.setVirtualViewportPosition = function (scrollWidth, scrollPosition) {
	        if (scrollWidth !== this.scrollWidth || scrollPosition !== this.scrollPosition || this.bodyWidthDirty) {
	            this.scrollWidth = scrollWidth;
	            this.scrollPosition = scrollPosition;
	            // we need to call setVirtualViewportLeftAndRight() at least once after the body width changes,
	            // as the viewport can stay the same, but in RTL, if body width changes, we need to work out the
	            // virtual columns again
	            this.bodyWidthDirty = true;
	            this.setVirtualViewportLeftAndRight();
	            if (this.ready) {
	                this.checkDisplayedVirtualColumns();
	            }
	        }
	    };
	    ColumnController.prototype.isPivotMode = function () {
	        return this.pivotMode;
	    };
	    ColumnController.prototype.isPivotSettingAllowed = function (pivot) {
	        if (pivot) {
	            if (this.gridOptionsWrapper.isTreeData()) {
	                console.warn("ag-Grid: Pivot mode not available in conjunction Tree Data i.e. 'gridOptions.treeData: true'");
	                return false;
	            }
	            else {
	                return true;
	            }
	        }
	        else {
	            return true;
	        }
	    };
	    ColumnController.prototype.setPivotMode = function (pivotMode, source) {
	        if (source === void 0) { source = "api"; }
	        if (pivotMode === this.pivotMode) {
	            return;
	        }
	        if (!this.isPivotSettingAllowed(this.pivotMode)) {
	            return;
	        }
	        this.pivotMode = pivotMode;
	        // we need to update grid columns to cover the scenario where user has groupSuppressAutoColumn=true, as
	        // this means we don't use auto group column UNLESS we are in pivot mode (it's mandatory in pivot mode),
	        // so need to updateGridColumn() to check it autoGroupCol needs to be added / removed
	        this.autoGroupsNeedBuilding = true;
	        this.updateGridColumns();
	        this.updateDisplayedColumns(source);
	        var event = {
	            type: events_1.Events.EVENT_COLUMN_PIVOT_MODE_CHANGED,
	            api: this.gridApi,
	            columnApi: this.columnApi
	        };
	        this.eventService.dispatchEvent(event);
	    };
	    ColumnController.prototype.getSecondaryPivotColumn = function (pivotKeys, valueColKey) {
	        if (!this.secondaryColumnsPresent) {
	            return null;
	        }
	        var valueColumnToFind = this.getPrimaryColumn(valueColKey);
	        var foundColumn = null;
	        if (this.secondaryColumns) {
	            this.secondaryColumns.forEach(function (column) {
	                var thisPivotKeys = column.getColDef().pivotKeys;
	                var pivotValueColumn = column.getColDef().pivotValueColumn;
	                var pivotKeyMatches = utils_1._.compareArrays(thisPivotKeys, pivotKeys);
	                var pivotValueMatches = pivotValueColumn === valueColumnToFind;
	                if (pivotKeyMatches && pivotValueMatches) {
	                    foundColumn = column;
	                }
	            });
	        }
	        return foundColumn;
	    };
	    ColumnController.prototype.setBeans = function (loggerFactory) {
	        this.logger = loggerFactory.create('ColumnController');
	    };
	    ColumnController.prototype.setFirstRightAndLastLeftPinned = function (source) {
	        var lastLeft;
	        var firstRight;
	        if (this.gridOptionsWrapper.isEnableRtl()) {
	            lastLeft = this.displayedLeftColumns ? this.displayedLeftColumns[0] : null;
	            firstRight = this.displayedRightColumns ? utils_1._.last(this.displayedRightColumns) : null;
	        }
	        else {
	            lastLeft = this.displayedLeftColumns ? utils_1._.last(this.displayedLeftColumns) : null;
	            firstRight = this.displayedRightColumns ? this.displayedRightColumns[0] : null;
	        }
	        this.gridColumns.forEach(function (column) {
	            column.setLastLeftPinned(column === lastLeft, source);
	            column.setFirstRightPinned(column === firstRight, source);
	        });
	    };
	    ColumnController.prototype.autoSizeColumns = function (keys, source) {
	        // because of column virtualisation, we can only do this function on columns that are
	        // actually rendered, as non-rendered columns (outside the viewport and not rendered
	        // due to column virtualisation) are not present. this can result in all rendered columns
	        // getting narrowed, which in turn introduces more rendered columns on the RHS which
	        // did not get autosized in the original run, leaving the visible grid with columns on
	        // the LHS sized, but RHS no. so we keep looping through teh visible columns until
	        // no more cols are available (rendered) to be resized
	        var _this = this;
	        if (source === void 0) { source = "api"; }
	        // keep track of which cols we have resized in here
	        var columnsAutosized = [];
	        // initialise with anything except 0 so that while loop executes at least once
	        var changesThisTimeAround = -1;
	        while (changesThisTimeAround !== 0) {
	            changesThisTimeAround = 0;
	            this.actionOnGridColumns(keys, function (column) {
	                // if already autosized, skip it
	                if (columnsAutosized.indexOf(column) >= 0) {
	                    return false;
	                }
	                // get how wide this col should be
	                var preferredWidth = _this.autoWidthCalculator.getPreferredWidthForColumn(column);
	                // preferredWidth = -1 if this col is not on the screen
	                if (preferredWidth > 0) {
	                    var newWidth = _this.normaliseColumnWidth(column, preferredWidth);
	                    column.setActualWidth(newWidth, source);
	                    columnsAutosized.push(column);
	                    changesThisTimeAround++;
	                }
	                return true;
	            }, source);
	        }
	        if (columnsAutosized.length > 0) {
	            var event_2 = {
	                type: events_1.Events.EVENT_COLUMN_RESIZED,
	                columns: columnsAutosized,
	                column: columnsAutosized.length === 1 ? columnsAutosized[0] : null,
	                finished: true,
	                api: this.gridApi,
	                columnApi: this.columnApi,
	                source: "autosizeColumns"
	            };
	            this.eventService.dispatchEvent(event_2);
	        }
	    };
	    ColumnController.prototype.autoSizeColumn = function (key, source) {
	        if (source === void 0) { source = "api"; }
	        if (key) {
	            this.autoSizeColumns([key], source);
	        }
	    };
	    ColumnController.prototype.autoSizeAllColumns = function (source) {
	        if (source === void 0) { source = "api"; }
	        var allDisplayedColumns = this.getAllDisplayedColumns();
	        this.autoSizeColumns(allDisplayedColumns, source);
	    };
	    ColumnController.prototype.getColumnsFromTree = function (rootColumns) {
	        var result = [];
	        recursiveFindColumns(rootColumns);
	        return result;
	        function recursiveFindColumns(childColumns) {
	            for (var i = 0; i < childColumns.length; i++) {
	                var child = childColumns[i];
	                if (child instanceof column_1.Column) {
	                    result.push(child);
	                }
	                else if (child instanceof originalColumnGroup_1.OriginalColumnGroup) {
	                    recursiveFindColumns(child.getChildren());
	                }
	            }
	        }
	    };
	    ColumnController.prototype.getAllDisplayedColumnGroups = function () {
	        if (this.displayedLeftColumnTree && this.displayedRightColumnTree && this.displayedCentreColumnTree) {
	            return this.displayedLeftColumnTree
	                .concat(this.displayedCentreColumnTree)
	                .concat(this.displayedRightColumnTree);
	        }
	        else {
	            return null;
	        }
	    };
	    // + columnSelectPanel
	    ColumnController.prototype.getPrimaryColumnTree = function () {
	        return this.primaryColumnTree;
	    };
	    // + gridPanel -> for resizing the body and setting top margin
	    ColumnController.prototype.getHeaderRowCount = function () {
	        return this.gridHeaderRowCount;
	    };
	    // + headerRenderer -> setting pinned body width
	    ColumnController.prototype.getLeftDisplayedColumnGroups = function () {
	        return this.displayedLeftColumnTree;
	    };
	    // + headerRenderer -> setting pinned body width
	    ColumnController.prototype.getRightDisplayedColumnGroups = function () {
	        return this.displayedRightColumnTree;
	    };
	    // + headerRenderer -> setting pinned body width
	    ColumnController.prototype.getCenterDisplayedColumnGroups = function () {
	        return this.displayedCentreColumnTree;
	    };
	    ColumnController.prototype.getDisplayedColumnGroups = function (type) {
	        switch (type) {
	            case column_1.Column.PINNED_LEFT:
	                return this.getLeftDisplayedColumnGroups();
	            case column_1.Column.PINNED_RIGHT:
	                return this.getRightDisplayedColumnGroups();
	            default:
	                return this.getCenterDisplayedColumnGroups();
	        }
	    };
	    // gridPanel -> ensureColumnVisible
	    ColumnController.prototype.isColumnDisplayed = function (column) {
	        return this.getAllDisplayedColumns().indexOf(column) >= 0;
	    };
	    // + csvCreator
	    ColumnController.prototype.getAllDisplayedColumns = function () {
	        return this.allDisplayedColumns;
	    };
	    ColumnController.prototype.getAllDisplayedVirtualColumns = function () {
	        return this.allDisplayedVirtualColumns;
	    };
	    ColumnController.prototype.getDisplayedLeftColumnsForRow = function (rowNode) {
	        if (!this.colSpanActive) {
	            return this.displayedLeftColumns;
	        }
	        else {
	            return this.getDisplayedColumnsForRow(rowNode, this.displayedLeftColumns);
	        }
	    };
	    ColumnController.prototype.getDisplayedRightColumnsForRow = function (rowNode) {
	        if (!this.colSpanActive) {
	            return this.displayedRightColumns;
	        }
	        else {
	            return this.getDisplayedColumnsForRow(rowNode, this.displayedRightColumns);
	        }
	    };
	    ColumnController.prototype.getDisplayedColumnsForRow = function (rowNode, displayedColumns, filterCallback, emptySpaceBeforeColumn) {
	        var result = [];
	        var lastConsideredCol = null;
	        var _loop_1 = function (i) {
	            var col = displayedColumns[i];
	            var maxAllowedColSpan = displayedColumns.length - i;
	            var colSpan = Math.min(col.getColSpan(rowNode), maxAllowedColSpan);
	            var columnsToCheckFilter = [col];
	            if (colSpan > 1) {
	                var colsToRemove = colSpan - 1;
	                for (var j = 1; j <= colsToRemove; j++) {
	                    columnsToCheckFilter.push(displayedColumns[i + j]);
	                }
	                i += colsToRemove;
	            }
	            // see which cols we should take out for column virtualisation
	            var filterPasses;
	            if (filterCallback) {
	                // if user provided a callback, means some columns may not be in the viewport.
	                // the user will NOT provide a callback if we are talking about pinned areas,
	                // as pinned areas have no horizontal scroll and do not virtualise the columns.
	                // if lots of columns, that means column spanning, and we set filterPasses = true
	                // if one or more of the columns spanned pass the filter.
	                filterPasses = false;
	                columnsToCheckFilter.forEach(function (colForFilter) {
	                    if (filterCallback(colForFilter)) {
	                        filterPasses = true;
	                    }
	                });
	            }
	            else {
	                filterPasses = true;
	            }
	            if (filterPasses) {
	                if (result.length === 0 && lastConsideredCol) {
	                    var gapBeforeColumn = emptySpaceBeforeColumn ? emptySpaceBeforeColumn(col) : false;
	                    if (gapBeforeColumn) {
	                        result.push(lastConsideredCol);
	                    }
	                }
	                result.push(col);
	            }
	            lastConsideredCol = col;
	            out_i_1 = i;
	        };
	        var out_i_1;
	        for (var i = 0; i < displayedColumns.length; i++) {
	            _loop_1(i);
	            i = out_i_1;
	        }
	        return result;
	    };
	    // + rowRenderer
	    // if we are not column spanning, this just returns back the virtual centre columns,
	    // however if we are column spanning, then different rows can have different virtual
	    // columns, so we have to work out the list for each individual row.
	    ColumnController.prototype.getAllDisplayedCenterVirtualColumnsForRow = function (rowNode) {
	        var _this = this;
	        if (!this.colSpanActive) {
	            return this.allDisplayedCenterVirtualColumns;
	        }
	        var emptySpaceBeforeColumn = function (col) { return col.getLeft() > _this.viewportLeft; };
	        // if doing column virtualisation, then we filter based on the viewport.
	        var filterCallback = this.suppressColumnVirtualisation ? null : this.isColumnInViewport.bind(this);
	        return this.getDisplayedColumnsForRow(rowNode, this.displayedCenterColumns, filterCallback, emptySpaceBeforeColumn);
	    };
	    ColumnController.prototype.isColumnInViewport = function (col) {
	        var columnLeft = col.getLeft();
	        var columnRight = col.getLeft() + col.getActualWidth();
	        // adding 200 for buffer size, so some cols off viewport are rendered.
	        // this helps horizontal scrolling so user rarely sees white space (unless
	        // they scroll horizontally fast). however we are conservative, as the more
	        // buffer the slower the vertical redraw speed
	        var leftBounds = this.viewportLeft - 200;
	        var rightBounds = this.viewportRight + 200;
	        var columnToMuchLeft = columnLeft < leftBounds && columnRight < leftBounds;
	        var columnToMuchRight = columnLeft > rightBounds && columnRight > rightBounds;
	        return !columnToMuchLeft && !columnToMuchRight;
	    };
	    // used by:
	    // + angularGrid -> setting pinned body width
	    // note: this should be cached
	    ColumnController.prototype.getPinnedLeftContainerWidth = function () {
	        return this.getWidthOfColsInList(this.displayedLeftColumns);
	    };
	    // note: this should be cached
	    ColumnController.prototype.getPinnedRightContainerWidth = function () {
	        return this.getWidthOfColsInList(this.displayedRightColumns);
	    };
	    ColumnController.prototype.updatePrimaryColumnList = function (keys, masterList, actionIsAdd, columnCallback, eventType, source) {
	        var _this = this;
	        if (source === void 0) { source = "api"; }
	        if (!keys || utils_1._.missingOrEmpty(keys)) {
	            return;
	        }
	        var atLeastOne = false;
	        keys.forEach(function (key) {
	            var columnToAdd = _this.getPrimaryColumn(key);
	            if (!columnToAdd) {
	                return;
	            }
	            if (actionIsAdd) {
	                if (masterList.indexOf(columnToAdd) >= 0) {
	                    return;
	                }
	                masterList.push(columnToAdd);
	            }
	            else {
	                if (masterList.indexOf(columnToAdd) < 0) {
	                    return;
	                }
	                utils_1._.removeFromArray(masterList, columnToAdd);
	            }
	            columnCallback(columnToAdd);
	            atLeastOne = true;
	        });
	        if (!atLeastOne) {
	            return;
	        }
	        if (this.autoGroupsNeedBuilding) {
	            this.updateGridColumns();
	        }
	        this.updateDisplayedColumns(source);
	        var event = {
	            type: eventType,
	            columns: masterList,
	            column: masterList.length === 1 ? masterList[0] : null,
	            api: this.gridApi,
	            columnApi: this.columnApi,
	            source: source
	        };
	        this.eventService.dispatchEvent(event);
	    };
	    ColumnController.prototype.setRowGroupColumns = function (colKeys, source) {
	        if (source === void 0) { source = "api"; }
	        this.autoGroupsNeedBuilding = true;
	        this.setPrimaryColumnList(colKeys, this.rowGroupColumns, events_1.Events.EVENT_COLUMN_ROW_GROUP_CHANGED, this.setRowGroupActive.bind(this), source);
	    };
	    ColumnController.prototype.setRowGroupActive = function (active, column, source) {
	        if (active === column.isRowGroupActive()) {
	            return;
	        }
	        column.setRowGroupActive(active, source);
	        if (!active && !this.gridOptionsWrapper.isSuppressMakeColumnVisibleAfterUnGroup()) {
	            column.setVisible(true, source);
	        }
	    };
	    ColumnController.prototype.addRowGroupColumn = function (key, source) {
	        if (source === void 0) { source = "api"; }
	        if (key) {
	            this.addRowGroupColumns([key], source);
	        }
	    };
	    ColumnController.prototype.addRowGroupColumns = function (keys, source) {
	        if (source === void 0) { source = "api"; }
	        this.autoGroupsNeedBuilding = true;
	        this.updatePrimaryColumnList(keys, this.rowGroupColumns, true, this.setRowGroupActive.bind(this, true), events_1.Events.EVENT_COLUMN_ROW_GROUP_CHANGED, source);
	    };
	    ColumnController.prototype.removeRowGroupColumns = function (keys, source) {
	        if (source === void 0) { source = "api"; }
	        this.autoGroupsNeedBuilding = true;
	        this.updatePrimaryColumnList(keys, this.rowGroupColumns, false, this.setRowGroupActive.bind(this, false), events_1.Events.EVENT_COLUMN_ROW_GROUP_CHANGED, source);
	    };
	    ColumnController.prototype.removeRowGroupColumn = function (key, source) {
	        if (source === void 0) { source = "api"; }
	        if (key) {
	            this.removeRowGroupColumns([key], source);
	        }
	    };
	    ColumnController.prototype.addPivotColumns = function (keys, source) {
	        if (source === void 0) { source = "api"; }
	        this.updatePrimaryColumnList(keys, this.pivotColumns, true, function (column) { return column.setPivotActive(true, source); }, events_1.Events.EVENT_COLUMN_PIVOT_CHANGED, source);
	    };
	    ColumnController.prototype.setPivotColumns = function (colKeys, source) {
	        if (source === void 0) { source = "api"; }
	        this.setPrimaryColumnList(colKeys, this.pivotColumns, events_1.Events.EVENT_COLUMN_PIVOT_CHANGED, function (added, column) {
	            column.setPivotActive(added, source);
	        }, source);
	    };
	    ColumnController.prototype.addPivotColumn = function (key, source) {
	        if (source === void 0) { source = "api"; }
	        this.addPivotColumns([key], source);
	    };
	    ColumnController.prototype.removePivotColumns = function (keys, source) {
	        if (source === void 0) { source = "api"; }
	        this.updatePrimaryColumnList(keys, this.pivotColumns, false, function (column) { return column.setPivotActive(false, source); }, events_1.Events.EVENT_COLUMN_PIVOT_CHANGED, source);
	    };
	    ColumnController.prototype.removePivotColumn = function (key, source) {
	        if (source === void 0) { source = "api"; }
	        this.removePivotColumns([key], source);
	    };
	    ColumnController.prototype.setPrimaryColumnList = function (colKeys, masterList, eventName, columnCallback, source) {
	        var _this = this;
	        masterList.length = 0;
	        if (utils_1._.exists(colKeys)) {
	            colKeys.forEach(function (key) {
	                var column = _this.getPrimaryColumn(key);
	                if (column) {
	                    masterList.push(column);
	                }
	            });
	        }
	        this.primaryColumns.forEach(function (column) {
	            var added = masterList.indexOf(column) >= 0;
	            columnCallback(added, column);
	        });
	        if (this.autoGroupsNeedBuilding) {
	            this.updateGridColumns();
	        }
	        this.updateDisplayedColumns(source);
	        var event = {
	            type: eventName,
	            columns: masterList,
	            column: masterList.length === 1 ? masterList[0] : null,
	            api: this.gridApi,
	            columnApi: this.columnApi,
	            source: source
	        };
	        this.eventService.dispatchEvent(event);
	    };
	    ColumnController.prototype.setValueColumns = function (colKeys, source) {
	        if (source === void 0) { source = "api"; }
	        this.setPrimaryColumnList(colKeys, this.valueColumns, events_1.Events.EVENT_COLUMN_VALUE_CHANGED, this.setValueActive.bind(this), source);
	    };
	    ColumnController.prototype.setValueActive = function (active, column, source) {
	        if (active === column.isValueActive()) {
	            return;
	        }
	        column.setValueActive(active, source);
	        if (active && !column.getAggFunc()) {
	            var defaultAggFunc = this.aggFuncService.getDefaultAggFunc(column);
	            column.setAggFunc(defaultAggFunc);
	        }
	    };
	    ColumnController.prototype.addValueColumns = function (keys, source) {
	        if (source === void 0) { source = "api"; }
	        this.updatePrimaryColumnList(keys, this.valueColumns, true, this.setValueActive.bind(this, true), events_1.Events.EVENT_COLUMN_VALUE_CHANGED, source);
	    };
	    ColumnController.prototype.addValueColumn = function (colKey, source) {
	        if (source === void 0) { source = "api"; }
	        if (colKey) {
	            this.addValueColumns([colKey], source);
	        }
	    };
	    ColumnController.prototype.removeValueColumn = function (colKey, source) {
	        if (source === void 0) { source = "api"; }
	        this.removeValueColumns([colKey], source);
	    };
	    ColumnController.prototype.removeValueColumns = function (keys, source) {
	        if (source === void 0) { source = "api"; }
	        this.updatePrimaryColumnList(keys, this.valueColumns, false, this.setValueActive.bind(this, false), events_1.Events.EVENT_COLUMN_VALUE_CHANGED, source);
	    };
	    // returns the width we can set to this col, taking into consideration min and max widths
	    ColumnController.prototype.normaliseColumnWidth = function (column, newWidth) {
	        if (newWidth < column.getMinWidth()) {
	            newWidth = column.getMinWidth();
	        }
	        if (column.isGreaterThanMax(newWidth)) {
	            newWidth = column.getMaxWidth();
	        }
	        return newWidth;
	    };
	    ColumnController.prototype.getPrimaryOrGridColumn = function (key) {
	        var column = this.getPrimaryColumn(key);
	        if (column) {
	            return column;
	        }
	        else {
	            return this.getGridColumn(key);
	        }
	    };
	    ColumnController.prototype.setColumnWidth = function (key, // @key - the column who's size we want to change
	    newWidth, // @newWidth - width in pixels
	    shiftKey, // @takeFromAdjacent - if user has 'shift' pressed, then pixels are taken from adjacent column
	    finished, // @finished - ends up in the event, tells the user if more events are to come
	    source) {
	        if (source === void 0) { source = "api"; }
	        var col = this.getPrimaryOrGridColumn(key);
	        if (!col) {
	            return;
	        }
	        var sets = [];
	        sets.push({
	            width: newWidth,
	            ratios: [1],
	            columns: [col]
	        });
	        // if user wants to do shift resize by default, then we invert the shift operation
	        var defaultIsShift = this.gridOptionsWrapper.getColResizeDefault() === 'shift';
	        if (defaultIsShift) {
	            shiftKey = !shiftKey;
	        }
	        if (shiftKey) {
	            var otherCol = this.getDisplayedColAfter(col);
	            if (!otherCol) {
	                return;
	            }
	            var widthDiff = col.getActualWidth() - newWidth;
	            var otherColWidth = otherCol.getActualWidth() + widthDiff;
	            sets.push({
	                width: otherColWidth,
	                ratios: [1],
	                columns: [otherCol]
	            });
	        }
	        this.resizeColumnSets(sets, finished, source);
	    };
	    ColumnController.prototype.checkMinAndMaxWidthsForSet = function (columnResizeSet) {
	        var columns = columnResizeSet.columns, width = columnResizeSet.width;
	        // every col has a min width, so sum them all up and see if we have enough room
	        // for all the min widths
	        var minWidthAccumulated = 0;
	        var maxWidthAccumulated = 0;
	        var maxWidthActive = true;
	        columns.forEach(function (col) {
	            minWidthAccumulated += col.getMinWidth();
	            if (col.getMaxWidth() > 0) {
	                maxWidthAccumulated += col.getMaxWidth();
	            }
	            else {
	                // if at least one columns has no max width, it means the group of columns
	                // then has no max width, as at least one column can take as much width as possible
	                maxWidthActive = false;
	            }
	        });
	        var minWidthPasses = width >= minWidthAccumulated;
	        var maxWidthPasses = !maxWidthActive || (width <= maxWidthAccumulated);
	        return minWidthPasses && maxWidthPasses;
	    };
	    // method takes sets of columns and resizes them. either all sets will be resized, or nothing
	    // be resized. this is used for example when user tries to resize a group and holds shift key,
	    // then both the current group (grows), and the adjacent group (shrinks), will get resized,
	    // so that's two sets for this method.
	    ColumnController.prototype.resizeColumnSets = function (resizeSets, finished, source) {
	        var passMinMaxCheck = utils_1._.every(resizeSets, this.checkMinAndMaxWidthsForSet.bind(this));
	        if (!passMinMaxCheck) {
	            // even though we are not going to resize beyond min/max size, we still need to raise event when finished
	            if (finished) {
	                var columns = resizeSets && resizeSets.length > 0 ? resizeSets[0].columns : null;
	                var event_3 = {
	                    type: events_1.Events.EVENT_COLUMN_RESIZED,
	                    columns: columns,
	                    column: columns && columns.length === 1 ? columns[0] : null,
	                    finished: finished,
	                    api: this.gridApi,
	                    columnApi: this.columnApi,
	                    source: source
	                };
	                this.eventService.dispatchEvent(event_3);
	            }
	            return; // don't resize!
	        }
	        var changedCols = [];
	        var allCols = [];
	        resizeSets.forEach(function (set) {
	            var width = set.width, columns = set.columns, ratios = set.ratios;
	            // keep track of pixels used, and last column gets the remaining,
	            // to cater for rounding errors, and min width adjustments
	            var newWidths = {};
	            var finishedCols = {};
	            columns.forEach(function (col) { return allCols.push(col); });
	            // the loop below goes through each col. if a col exceeds it's min/max width,
	            // it then gets set to its min/max width and the column is removed marked as 'finished'
	            // and the calculation is done again leaving this column out. take for example columns
	            // {A, width: 50, maxWidth: 100}
	            // {B, width: 50}
	            // {C, width: 50}
	            // and then the set is set to width 600 - on the first pass the grid tries to set each column
	            // to 200. it checks A and sees 200 > 100 and so sets the width to 100. col A is then marked
	            // as 'finished' and the calculation is done again with the remaining cols B and C, which end up
	            // splitting the remaining 500 pixels.
	            var finishedColsGrew = true;
	            var loopCount = 0;
	            var _loop_2 = function () {
	                loopCount++;
	                if (loopCount > 1000) {
	                    // this should never happen, but in the future, someone might introduce a bug here,
	                    // so we stop the browser from hanging and report bug properly
	                    console.error('ag-Grid: infinite loop in resizeColumnSets');
	                    return "break";
	                }
	                finishedColsGrew = false;
	                var subsetCols = [];
	                var subsetRatios = [];
	                var subsetRatioTotal = 0;
	                var pixelsToDistribute = width;
	                columns.forEach(function (col, index) {
	                    var thisColFinished = finishedCols[col.getId()];
	                    if (thisColFinished) {
	                        pixelsToDistribute -= newWidths[col.getId()];
	                    }
	                    else {
	                        subsetCols.push(col);
	                        var ratioThisCol = ratios[index];
	                        subsetRatioTotal += ratioThisCol;
	                        subsetRatios.push(ratioThisCol);
	                    }
	                });
	                // because we are not using all of the ratios (cols can be missing),
	                // we scale the ratio. if all columns are included, then subsetRatioTotal=1,
	                // and so the ratioScale will be 1.
	                var ratioScale = 1 / subsetRatioTotal;
	                subsetCols.forEach(function (col, index) {
	                    var lastCol = index === (subsetCols.length - 1);
	                    var colNewWidth;
	                    if (lastCol) {
	                        colNewWidth = pixelsToDistribute;
	                    }
	                    else {
	                        colNewWidth = Math.round(ratios[index] * width * ratioScale);
	                        pixelsToDistribute -= colNewWidth;
	                    }
	                    if (colNewWidth < col.getMinWidth()) {
	                        colNewWidth = col.getMinWidth();
	                        finishedCols[col.getId()] = true;
	                        finishedColsGrew = true;
	                    }
	                    else if (col.getMaxWidth() > 0 && colNewWidth > col.getMaxWidth()) {
	                        colNewWidth = col.getMaxWidth();
	                        finishedCols[col.getId()] = true;
	                        finishedColsGrew = true;
	                    }
	                    newWidths[col.getId()] = colNewWidth;
	                });
	            };
	            while (finishedColsGrew) {
	                var state_1 = _loop_2();
	                if (state_1 === "break")
	                    break;
	            }
	            columns.forEach(function (col) {
	                var newWidth = newWidths[col.getId()];
	                if (col.getActualWidth() !== newWidth) {
	                    col.setActualWidth(newWidth);
	                    changedCols.push(col);
	                }
	            });
	        });
	        // if no cols changed, then no need to update more or send event.
	        var atLeastOneColChanged = changedCols.length > 0;
	        if (atLeastOneColChanged) {
	            this.setLeftValues(source);
	            this.updateBodyWidths();
	            this.checkDisplayedVirtualColumns();
	        }
	        // check for change first, to avoid unnecessary firing of events
	        // however we always fire 'finished' events. this is important
	        // when groups are resized, as if the group is changing slowly,
	        // eg 1 pixel at a time, then each change will fire change events
	        // in all the columns in the group, but only one with get the pixel.
	        if (atLeastOneColChanged || finished) {
	            var event_4 = {
	                type: events_1.Events.EVENT_COLUMN_RESIZED,
	                columns: allCols,
	                column: allCols.length === 1 ? allCols[0] : null,
	                finished: finished,
	                api: this.gridApi,
	                columnApi: this.columnApi,
	                source: source
	            };
	            this.eventService.dispatchEvent(event_4);
	        }
	    };
	    ColumnController.prototype.setColumnAggFunc = function (column, aggFunc, source) {
	        if (source === void 0) { source = "api"; }
	        if (column) {
	            column.setAggFunc(aggFunc);
	            var event_5 = {
	                type: events_1.Events.EVENT_COLUMN_VALUE_CHANGED,
	                columns: [column],
	                column: column,
	                api: this.gridApi,
	                columnApi: this.columnApi,
	                source: source
	            };
	            this.eventService.dispatchEvent(event_5);
	        }
	    };
	    ColumnController.prototype.moveRowGroupColumn = function (fromIndex, toIndex, source) {
	        if (source === void 0) { source = "api"; }
	        var column = this.rowGroupColumns[fromIndex];
	        this.rowGroupColumns.splice(fromIndex, 1);
	        this.rowGroupColumns.splice(toIndex, 0, column);
	        var event = {
	            type: events_1.Events.EVENT_COLUMN_ROW_GROUP_CHANGED,
	            columns: this.rowGroupColumns,
	            column: this.rowGroupColumns.length === 1 ? this.rowGroupColumns[0] : null,
	            api: this.gridApi,
	            columnApi: this.columnApi,
	            source: source
	        };
	        this.eventService.dispatchEvent(event);
	    };
	    ColumnController.prototype.moveColumns = function (columnsToMoveKeys, toIndex, source) {
	        if (source === void 0) { source = "api"; }
	        this.columnAnimationService.start();
	        if (toIndex > this.gridColumns.length - columnsToMoveKeys.length) {
	            console.warn('ag-Grid: tried to insert columns in invalid location, toIndex = ' + toIndex);
	            console.warn('ag-Grid: remember that you should not count the moving columns when calculating the new index');
	            return;
	        }
	        // we want to pull all the columns out first and put them into an ordered list
	        var columnsToMove = this.getGridColumns(columnsToMoveKeys);
	        var failedRules = !this.doesMovePassRules(columnsToMove, toIndex);
	        if (failedRules) {
	            return;
	        }
	        utils_1._.moveInArray(this.gridColumns, columnsToMove, toIndex);
	        this.updateDisplayedColumns(source);
	        var event = {
	            type: events_1.Events.EVENT_COLUMN_MOVED,
	            columns: columnsToMove,
	            column: columnsToMove.length === 1 ? columnsToMove[0] : null,
	            toIndex: toIndex,
	            api: this.gridApi,
	            columnApi: this.columnApi,
	            source: source
	        };
	        this.eventService.dispatchEvent(event);
	        this.columnAnimationService.finish();
	    };
	    ColumnController.prototype.doesMovePassRules = function (columnsToMove, toIndex) {
	        // make a copy of what the grid columns would look like after the move
	        var proposedColumnOrder = this.gridColumns.slice();
	        utils_1._.moveInArray(proposedColumnOrder, columnsToMove, toIndex);
	        // then check that the new proposed order of the columns passes all rules
	        if (!this.doesMovePassMarryChildren(proposedColumnOrder)) {
	            return false;
	        }
	        if (!this.doesMovePassLockedPositions(proposedColumnOrder)) {
	            return false;
	        }
	        return true;
	    };
	    ColumnController.prototype.doesMovePassLockedPositions = function (proposedColumnOrder) {
	        var foundNonLocked = false;
	        var rulePassed = true;
	        // go though the cols, see if any non-locked appear before any locked
	        proposedColumnOrder.forEach(function (col) {
	            if (col.getColDef().lockPosition) {
	                if (foundNonLocked) {
	                    rulePassed = false;
	                }
	            }
	            else {
	                foundNonLocked = true;
	            }
	        });
	        return rulePassed;
	    };
	    ColumnController.prototype.doesMovePassMarryChildren = function (allColumnsCopy) {
	        var rulePassed = true;
	        this.columnUtils.depthFirstOriginalTreeSearch(null, this.gridBalancedTree, function (child) {
	            if (!(child instanceof originalColumnGroup_1.OriginalColumnGroup)) {
	                return;
	            }
	            var columnGroup = child;
	            var marryChildren = columnGroup.getColGroupDef() && columnGroup.getColGroupDef().marryChildren;
	            if (!marryChildren) {
	                return;
	            }
	            var newIndexes = [];
	            columnGroup.getLeafColumns().forEach(function (col) {
	                var newColIndex = allColumnsCopy.indexOf(col);
	                newIndexes.push(newColIndex);
	            });
	            var maxIndex = Math.max.apply(Math, newIndexes);
	            var minIndex = Math.min.apply(Math, newIndexes);
	            // spread is how far the first column in this group is away from the last column
	            var spread = maxIndex - minIndex;
	            var maxSpread = columnGroup.getLeafColumns().length - 1;
	            // if the columns
	            if (spread > maxSpread) {
	                rulePassed = false;
	            }
	            // console.log(`maxIndex = ${maxIndex}, minIndex = ${minIndex}, spread = ${spread}, maxSpread = ${maxSpread}, fail = ${spread > (count-1)}`)
	            // console.log(allColumnsCopy.map( col => col.getColDef().field).join(','));
	        });
	        return rulePassed;
	    };
	    ColumnController.prototype.moveColumn = function (key, toIndex, source) {
	        if (source === void 0) { source = "api"; }
	        this.moveColumns([key], toIndex, source);
	    };
	    ColumnController.prototype.moveColumnByIndex = function (fromIndex, toIndex, source) {
	        if (source === void 0) { source = "api"; }
	        var column = this.gridColumns[fromIndex];
	        this.moveColumn(column, toIndex, source);
	    };
	    // used by:
	    // + angularGrid -> for setting body width
	    // + rowController -> setting main row widths (when inserting and resizing)
	    // need to cache this
	    ColumnController.prototype.getBodyContainerWidth = function () {
	        return this.bodyWidth;
	    };
	    ColumnController.prototype.getContainerWidth = function (pinned) {
	        switch (pinned) {
	            case column_1.Column.PINNED_LEFT:
	                return this.leftWidth;
	            case column_1.Column.PINNED_RIGHT:
	                return this.rightWidth;
	            default:
	                return this.bodyWidth;
	        }
	    };
	    // after setColumnWidth or updateGroupsAndDisplayedColumns
	    ColumnController.prototype.updateBodyWidths = function () {
	        var newBodyWidth = this.getWidthOfColsInList(this.displayedCenterColumns);
	        var newLeftWidth = this.getWidthOfColsInList(this.displayedLeftColumns);
	        var newRightWidth = this.getWidthOfColsInList(this.displayedRightColumns);
	        // this is used by virtual col calculation, for RTL only, as a change to body width can impact displayed
	        // columns, due to RTL inverting the y coordinates
	        this.bodyWidthDirty = this.bodyWidth !== newBodyWidth;
	        var atLeastOneChanged = this.bodyWidth !== newBodyWidth || this.leftWidth !== newLeftWidth || this.rightWidth !== newRightWidth;
	        if (atLeastOneChanged) {
	            this.bodyWidth = newBodyWidth;
	            this.leftWidth = newLeftWidth;
	            this.rightWidth = newRightWidth;
	            // when this fires, it is picked up by the gridPanel, which ends up in
	            // gridPanel calling setWidthAndScrollPosition(), which in turn calls setVirtualViewportPosition()
	            var event_6 = {
	                type: events_1.Events.EVENT_DISPLAYED_COLUMNS_WIDTH_CHANGED,
	                api: this.gridApi,
	                columnApi: this.columnApi
	            };
	            this.eventService.dispatchEvent(event_6);
	        }
	    };
	    // + rowController
	    ColumnController.prototype.getValueColumns = function () {
	        return this.valueColumns ? this.valueColumns : [];
	    };
	    // + rowController
	    ColumnController.prototype.getPivotColumns = function () {
	        return this.pivotColumns ? this.pivotColumns : [];
	    };
	    // + clientSideRowModel
	    ColumnController.prototype.isPivotActive = function () {
	        return this.pivotColumns && this.pivotColumns.length > 0 && this.pivotMode;
	    };
	    // + toolPanel
	    ColumnController.prototype.getRowGroupColumns = function () {
	        return this.rowGroupColumns ? this.rowGroupColumns : [];
	    };
	    // + rowController -> while inserting rows
	    ColumnController.prototype.getDisplayedCenterColumns = function () {
	        return this.displayedCenterColumns;
	    };
	    // + rowController -> while inserting rows
	    ColumnController.prototype.getDisplayedLeftColumns = function () {
	        return this.displayedLeftColumns;
	    };
	    ColumnController.prototype.getDisplayedRightColumns = function () {
	        return this.displayedRightColumns;
	    };
	    ColumnController.prototype.getDisplayedColumns = function (type) {
	        switch (type) {
	            case column_1.Column.PINNED_LEFT:
	                return this.getDisplayedLeftColumns();
	            case column_1.Column.PINNED_RIGHT:
	                return this.getDisplayedRightColumns();
	            default:
	                return this.getDisplayedCenterColumns();
	        }
	    };
	    // used by:
	    // + clientSideRowController -> sorting, building quick filter text
	    // + headerRenderer -> sorting (clearing icon)
	    ColumnController.prototype.getAllPrimaryColumns = function () {
	        return this.primaryColumns ? this.primaryColumns.slice() : null;
	    };
	    ColumnController.prototype.getSecondaryColumns = function () {
	        return this.secondaryColumns ? this.secondaryColumns.slice() : null;
	    };
	    ColumnController.prototype.getAllColumnsForQuickFilter = function () {
	        return this.columnsForQuickFilter;
	    };
	    // + moveColumnController
	    ColumnController.prototype.getAllGridColumns = function () {
	        return this.gridColumns;
	    };
	    ColumnController.prototype.isEmpty = function () {
	        return utils_1._.missingOrEmpty(this.gridColumns);
	    };
	    ColumnController.prototype.isRowGroupEmpty = function () {
	        return utils_1._.missingOrEmpty(this.rowGroupColumns);
	    };
	    ColumnController.prototype.setColumnVisible = function (key, visible, source) {
	        if (source === void 0) { source = "api"; }
	        this.setColumnsVisible([key], visible, source);
	    };
	    ColumnController.prototype.setColumnsVisible = function (keys, visible, source) {
	        var _this = this;
	        if (source === void 0) { source = "api"; }
	        this.columnAnimationService.start();
	        this.actionOnGridColumns(keys, function (column) {
	            if (column.isVisible() !== visible) {
	                column.setVisible(visible, source);
	                return true;
	            }
	            else {
	                return false;
	            }
	        }, source, function () {
	            var event = {
	                type: events_1.Events.EVENT_COLUMN_VISIBLE,
	                visible: visible,
	                column: null,
	                columns: null,
	                api: _this.gridApi,
	                columnApi: _this.columnApi,
	                source: source
	            };
	            return event;
	        });
	        this.columnAnimationService.finish();
	    };
	    ColumnController.prototype.setColumnPinned = function (key, pinned, source) {
	        if (source === void 0) { source = "api"; }
	        if (key) {
	            this.setColumnsPinned([key], pinned, source);
	        }
	    };
	    ColumnController.prototype.setColumnsPinned = function (keys, pinned, source) {
	        var _this = this;
	        if (source === void 0) { source = "api"; }
	        if (this.gridOptionsWrapper.getDomLayout() === 'print') {
	            console.warn("Changing the column pinning status is not allowed with domLayout='print'");
	            return;
	        }
	        this.columnAnimationService.start();
	        var actualPinned;
	        if (pinned === true || pinned === column_1.Column.PINNED_LEFT) {
	            actualPinned = column_1.Column.PINNED_LEFT;
	        }
	        else if (pinned === column_1.Column.PINNED_RIGHT) {
	            actualPinned = column_1.Column.PINNED_RIGHT;
	        }
	        else {
	            actualPinned = null;
	        }
	        this.actionOnGridColumns(keys, function (col) {
	            if (col.getPinned() !== actualPinned) {
	                col.setPinned(actualPinned);
	                return true;
	            }
	            else {
	                return false;
	            }
	        }, source, function () {
	            var event = {
	                type: events_1.Events.EVENT_COLUMN_PINNED,
	                pinned: actualPinned,
	                column: null,
	                columns: null,
	                api: _this.gridApi,
	                columnApi: _this.columnApi,
	                source: source
	            };
	            return event;
	        });
	        this.columnAnimationService.finish();
	    };
	    // does an action on a set of columns. provides common functionality for looking up the
	    // columns based on key, getting a list of effected columns, and then updated the event
	    // with either one column (if it was just one col) or a list of columns
	    // used by: autoResize, setVisible, setPinned
	    ColumnController.prototype.actionOnGridColumns = function (// the column keys this action will be on
	    keys, 
	    // the action to do - if this returns false, the column was skipped
	    // and won't be included in the event
	    action, 
	    // should return back a column event of the right type
	    source, createEvent) {
	        var _this = this;
	        if (utils_1._.missingOrEmpty(keys)) {
	            return;
	        }
	        var updatedColumns = [];
	        keys.forEach(function (key) {
	            var column = _this.getGridColumn(key);
	            if (!column) {
	                return;
	            }
	            // need to check for false with type (ie !== instead of !=)
	            // as not returning anything (undefined) would also be false
	            var resultOfAction = action(column);
	            if (resultOfAction !== false) {
	                updatedColumns.push(column);
	            }
	        });
	        if (updatedColumns.length === 0) {
	            return;
	        }
	        this.updateDisplayedColumns(source);
	        if (utils_1._.exists(createEvent) && createEvent) {
	            var event_7 = createEvent();
	            event_7.columns = updatedColumns;
	            event_7.column = updatedColumns.length === 1 ? updatedColumns[0] : null;
	            this.eventService.dispatchEvent(event_7);
	        }
	    };
	    ColumnController.prototype.getDisplayedColBefore = function (col) {
	        var allDisplayedColumns = this.getAllDisplayedColumns();
	        var oldIndex = allDisplayedColumns.indexOf(col);
	        if (oldIndex > 0) {
	            return allDisplayedColumns[oldIndex - 1];
	        }
	        else {
	            return null;
	        }
	    };
	    // used by:
	    // + rowRenderer -> for navigation
	    ColumnController.prototype.getDisplayedColAfter = function (col) {
	        var allDisplayedColumns = this.getAllDisplayedColumns();
	        var oldIndex = allDisplayedColumns.indexOf(col);
	        if (oldIndex < (allDisplayedColumns.length - 1)) {
	            return allDisplayedColumns[oldIndex + 1];
	        }
	        else {
	            return null;
	        }
	    };
	    ColumnController.prototype.getDisplayedGroupAfter = function (columnGroup) {
	        // pick one col in this group at random
	        var col = columnGroup.getDisplayedLeafColumns()[0];
	        var requiredLevel = columnGroup.getOriginalColumnGroup().getLevel();
	        while (true) {
	            // keep moving to the next col, until we get to another group
	            col = this.getDisplayedColAfter(col);
	            // if no col after, means no group after
	            if (!col) {
	                return null;
	            }
	            // get group at same level as the one we are looking for
	            var groupPointer = col.getParent();
	            while (groupPointer.getOriginalColumnGroup().getLevel() !== requiredLevel) {
	                groupPointer = groupPointer.getParent();
	            }
	            if (groupPointer !== columnGroup) {
	                return groupPointer;
	            }
	        }
	    };
	    ColumnController.prototype.isPinningLeft = function () {
	        return this.displayedLeftColumns.length > 0;
	    };
	    ColumnController.prototype.isPinningRight = function () {
	        return this.displayedRightColumns.length > 0;
	    };
	    ColumnController.prototype.getPrimaryAndSecondaryAndAutoColumns = function () {
	        var result = this.primaryColumns ? this.primaryColumns.slice(0) : [];
	        if (this.groupAutoColumns && utils_1._.exists(this.groupAutoColumns)) {
	            this.groupAutoColumns.forEach(function (col) { return result.push(col); });
	        }
	        if (this.secondaryColumnsPresent && this.secondaryColumns) {
	            this.secondaryColumns.forEach(function (column) { return result.push(column); });
	        }
	        return result;
	    };
	    ColumnController.prototype.createStateItemFromColumn = function (column) {
	        var rowGroupIndex = column.isRowGroupActive() ? this.rowGroupColumns.indexOf(column) : null;
	        var pivotIndex = column.isPivotActive() ? this.pivotColumns.indexOf(column) : null;
	        var aggFunc = column.isValueActive() ? column.getAggFunc() : null;
	        return {
	            colId: column.getColId(),
	            hide: !column.isVisible(),
	            aggFunc: aggFunc,
	            width: column.getActualWidth(),
	            pivotIndex: pivotIndex,
	            pinned: column.getPinned(),
	            rowGroupIndex: rowGroupIndex
	        };
	    };
	    ColumnController.prototype.getColumnState = function () {
	        if (utils_1._.missing(this.primaryColumns)) {
	            return [];
	        }
	        var primaryColumnState = this.primaryColumns.map(this.createStateItemFromColumn.bind(this));
	        var groupAutoColumnState = this.groupAutoColumns
	            // if groupAutoCols, then include them
	            ? this.groupAutoColumns.map(this.createStateItemFromColumn.bind(this))
	            // otherwise no
	            : [];
	        var columnStateList = groupAutoColumnState.concat(primaryColumnState);
	        if (!this.pivotMode) {
	            this.orderColumnStateList(columnStateList);
	        }
	        return columnStateList;
	    };
	    ColumnController.prototype.orderColumnStateList = function (columnStateList) {
	        var gridColumnIds = this.gridColumns.map(function (column) { return column.getColId(); });
	        columnStateList.sort(function (itemA, itemB) {
	            var posA = gridColumnIds.indexOf(itemA.colId);
	            var posB = gridColumnIds.indexOf(itemB.colId);
	            return posA - posB;
	        });
	    };
	    ColumnController.prototype.resetColumnState = function (suppressEverythingEvent, source) {
	        // NOTE = there is one bug here that no customer has noticed - if a column has colDef.lockPosition,
	        // this is ignored  below when ordering the cols. to work, we should always put lockPosition cols first.
	        // As a work around, developers should just put lockPosition columns first in their colDef list.
	        if (suppressEverythingEvent === void 0) { suppressEverythingEvent = false; }
	        if (source === void 0) { source = "api"; }
	        // we can't use 'allColumns' as the order might of messed up, so get the primary ordered list
	        var primaryColumns = this.getColumnsFromTree(this.primaryColumnTree);
	        var columnStates = [];
	        // we start at 1000, so if user has mix of rowGroup and group specified, it will work with both.
	        // eg IF user has ColA.rowGroupIndex=0, ColB.rowGroupIndex=1, ColC.rowGroup=true,
	        // THEN result will be ColA.rowGroupIndex=0, ColB.rowGroupIndex=1, ColC.rowGroup=1000
	        var letRowGroupIndex = 1000;
	        var letPivotIndex = 1000;
	        if (primaryColumns) {
	            primaryColumns.forEach(function (column) {
	                var rowGroupIndex = column.getColDef().rowGroupIndex;
	                var rowGroup = column.getColDef().rowGroup;
	                var pivotIndex = column.getColDef().pivotIndex;
	                var pivot = column.getColDef().pivot;
	                var stateItem = {
	                    colId: column.getColId(),
	                    aggFunc: column.getColDef().aggFunc,
	                    hide: column.getColDef().hide,
	                    pinned: column.getColDef().pinned,
	                    rowGroupIndex: rowGroupIndex,
	                    pivotIndex: column.getColDef().pivotIndex,
	                    width: column.getColDef().width
	                };
	                if (utils_1._.missing(rowGroupIndex) && rowGroup) {
	                    stateItem.rowGroupIndex = letRowGroupIndex++;
	                }
	                if (utils_1._.missing(pivotIndex) && pivot) {
	                    stateItem.pivotIndex = letPivotIndex++;
	                }
	                columnStates.push(stateItem);
	            });
	        }
	        this.setColumnState(columnStates, suppressEverythingEvent, source);
	    };
	    ColumnController.prototype.setColumnState = function (columnStates, suppressEverythingEvent, source) {
	        var _this = this;
	        if (suppressEverythingEvent === void 0) { suppressEverythingEvent = false; }
	        if (source === void 0) { source = "api"; }
	        if (utils_1._.missingOrEmpty(this.primaryColumns)) {
	            return false;
	        }
	        var columnStateBefore = this.getColumnState();
	        this.autoGroupsNeedBuilding = true;
	        // at the end below, this list will have all columns we got no state for
	        var columnsWithNoState = this.primaryColumns.slice();
	        this.rowGroupColumns = [];
	        this.valueColumns = [];
	        this.pivotColumns = [];
	        var success = true;
	        var rowGroupIndexes = {};
	        var pivotIndexes = {};
	        var autoGroupColumnStates = [];
	        if (columnStates) {
	            columnStates.forEach(function (state) {
	                // auto group columns are re-created so deferring syncing with ColumnState
	                if (utils_1._.exists(_this.getAutoColumn(state.colId))) {
	                    autoGroupColumnStates.push(state);
	                    return;
	                }
	                var column = _this.getPrimaryColumn(state.colId);
	                if (!column) {
	                    console.warn('ag-grid: column ' + state.colId + ' not found');
	                    success = false;
	                }
	                else {
	                    _this.syncColumnWithStateItem(column, state, rowGroupIndexes, pivotIndexes, source);
	                    utils_1._.removeFromArray(columnsWithNoState, column);
	                }
	            });
	        }
	        // anything left over, we got no data for, so add in the column as non-value, non-rowGroup and hidden
	        columnsWithNoState.forEach(this.syncColumnWithNoState.bind(this));
	        // sort the lists according to the indexes that were provided
	        this.rowGroupColumns.sort(this.sortColumnListUsingIndexes.bind(this, rowGroupIndexes));
	        this.pivotColumns.sort(this.sortColumnListUsingIndexes.bind(this, pivotIndexes));
	        this.updateGridColumns();
	        // sync newly created auto group columns with ColumnState
	        autoGroupColumnStates.forEach(function (stateItem) {
	            var autoCol = _this.getAutoColumn(stateItem.colId);
	            _this.syncColumnWithStateItem(autoCol, stateItem, rowGroupIndexes, pivotIndexes, source);
	        });
	        if (columnStates) {
	            var orderOfColIds_1 = columnStates.map(function (stateItem) { return stateItem.colId; });
	            this.gridColumns.sort(function (colA, colB) {
	                var indexA = orderOfColIds_1.indexOf(colA.getId());
	                var indexB = orderOfColIds_1.indexOf(colB.getId());
	                return indexA - indexB;
	            });
	        }
	        // this is already done in updateGridColumns, however we changed the order above (to match the order of the state
	        // columns) so we need to do it again. we could of put logic into the order above to take into account fixed
	        // columns, however if we did then we would have logic for updating fixed columns twice. reusing the logic here
	        // is less sexy for the code here, but it keeps consistency.
	        this.putFixedColumnsFirst();
	        this.updateDisplayedColumns(source);
	        if (!suppressEverythingEvent) {
	            var event_8 = {
	                type: events_1.Events.EVENT_COLUMN_EVERYTHING_CHANGED,
	                api: this.gridApi,
	                columnApi: this.columnApi,
	                source: source
	            };
	            this.eventService.dispatchEvent(event_8);
	        }
	        this.raiseColumnEvents(columnStateBefore, source);
	        return success;
	    };
	    ColumnController.prototype.raiseColumnEvents = function (columnStateBefore, source) {
	        var _this = this;
	        if (this.gridOptionsWrapper.isSuppressSetColumnStateEvents()) {
	            return;
	        }
	        var columnStateAfter = this.getColumnState();
	        // raises generic ColumnEvents where all columns are returned rather than what has changed
	        var raiseEventWithAllColumns = function (eventType, idMapper, columns) {
	            var unchanged = utils_1._.compareArrays(columnStateBefore.map(idMapper).sort(), columnStateAfter.map(idMapper).sort());
	            if (unchanged) {
	                return;
	            }
	            // returning all columns rather than what has changed!
	            var event = {
	                type: eventType,
	                columns: columns,
	                column: columns.length === 1 ? columns[0] : null,
	                api: _this.gridApi,
	                columnApi: _this.columnApi,
	                source: source
	            };
	            _this.eventService.dispatchEvent(event);
	        };
	        // determines which columns have changed according to supplied predicate
	        var getChangedColumns = function (changedPredicate) {
	            var changedColumns = [];
	            var columnStateBeforeMap = {};
	            columnStateBefore.forEach(function (col) {
	                columnStateBeforeMap[col.colId] = col;
	            });
	            _this.gridColumns.forEach(function (column) {
	                var colStateBefore = columnStateBeforeMap[column.getColId()];
	                if (!colStateBefore || changedPredicate(colStateBefore, column)) {
	                    changedColumns.push(column);
	                }
	            });
	            return changedColumns;
	        };
	        // generic ColumnEvents which return current column list
	        var valueColumnIdMapper = function (cs) { return cs.colId + '-' + cs.aggFunc; };
	        raiseEventWithAllColumns(events_1.Events.EVENT_COLUMN_VALUE_CHANGED, valueColumnIdMapper, this.valueColumns);
	        var pivotColumnIdMapper = function (cs) { return cs.colId + '-' + cs.pivotIndex; };
	        raiseEventWithAllColumns(events_1.Events.EVENT_COLUMN_PIVOT_CHANGED, pivotColumnIdMapper, this.pivotColumns);
	        var rowGroupColumnIdMapper = function (cs) { return cs.colId + '-' + cs.rowGroupIndex; };
	        raiseEventWithAllColumns(events_1.Events.EVENT_COLUMN_ROW_GROUP_CHANGED, rowGroupColumnIdMapper, this.rowGroupColumns);
	        // specific ColumnEvents which return what's changed
	        var pinnedChangePredicate = function (cs, c) { return cs.pinned !== c.getPinned(); };
	        this.raiseColumnPinnedEvent(getChangedColumns(pinnedChangePredicate), source);
	        var visibilityChangePredicate = function (cs, c) { return cs.hide === c.isVisible(); };
	        var cols = getChangedColumns(visibilityChangePredicate);
	        this.raiseColumnVisibleEvent(cols, source);
	        var resizeChangePredicate = function (cs, c) { return cs.width !== c.getActualWidth(); };
	        this.raiseColumnResizeEvent(getChangedColumns(resizeChangePredicate), source);
	        // special handling for moved column events
	        this.raiseColumnMovedEvent(columnStateBefore, source);
	    };
	    ColumnController.prototype.raiseColumnPinnedEvent = function (changedColumns, source) {
	        if (changedColumns.length > 0) {
	            var event_9 = {
	                type: events_1.Events.EVENT_COLUMN_PINNED,
	                pinned: null,
	                columns: changedColumns,
	                column: null,
	                api: this.gridApi,
	                columnApi: this.columnApi,
	                source: source
	            };
	            this.eventService.dispatchEvent(event_9);
	        }
	    };
	    ColumnController.prototype.raiseColumnVisibleEvent = function (changedColumns, source) {
	        if (changedColumns.length > 0) {
	            var event_10 = {
	                type: events_1.Events.EVENT_COLUMN_VISIBLE,
	                visible: undefined,
	                columns: changedColumns,
	                column: null,
	                api: this.gridApi,
	                columnApi: this.columnApi,
	                source: source
	            };
	            this.eventService.dispatchEvent(event_10);
	        }
	    };
	    ColumnController.prototype.raiseColumnResizeEvent = function (changedColumns, source) {
	        if (changedColumns.length > 0) {
	            var event_11 = {
	                type: events_1.Events.EVENT_COLUMN_RESIZED,
	                columns: changedColumns,
	                column: null,
	                finished: true,
	                api: this.gridApi,
	                columnApi: this.columnApi,
	                source: source
	            };
	            this.eventService.dispatchEvent(event_11);
	        }
	    };
	    ColumnController.prototype.raiseColumnMovedEvent = function (columnStateBefore, source) {
	        var movedColumns = [];
	        var columnStateAfter = this.getColumnState();
	        var _loop_3 = function (i) {
	            var before = columnStateBefore[i];
	            var after = columnStateAfter[i];
	            // don't consider column if reintroduced or hidden
	            if (!before || after.hide) {
	                return "continue";
	            }
	            if (before.colId !== after.colId) {
	                var predicate = function (column) { return column.getColId() === after.colId; };
	                var movedColumn = utils_1._.find(this_1.allDisplayedColumns, predicate);
	                movedColumns.push(movedColumn);
	            }
	        };
	        var this_1 = this;
	        for (var i = 0; i < columnStateAfter.length; i++) {
	            _loop_3(i);
	        }
	        if (movedColumns.length > 0) {
	            var event_12 = {
	                type: events_1.Events.EVENT_COLUMN_MOVED,
	                columns: movedColumns,
	                column: null,
	                toIndex: undefined,
	                api: this.gridApi,
	                columnApi: this.columnApi,
	                source: source
	            };
	            this.eventService.dispatchEvent(event_12);
	        }
	    };
	    ColumnController.prototype.sortColumnListUsingIndexes = function (indexes, colA, colB) {
	        var indexA = indexes[colA.getId()];
	        var indexB = indexes[colB.getId()];
	        return indexA - indexB;
	    };
	    ColumnController.prototype.syncColumnWithNoState = function (column, source) {
	        column.setVisible(false, source);
	        column.setAggFunc(null);
	        column.setPinned(null);
	        column.setRowGroupActive(false, source);
	        column.setPivotActive(false, source);
	        column.setValueActive(false, source);
	    };
	    ColumnController.prototype.syncColumnWithStateItem = function (column, stateItem, rowGroupIndexes, pivotIndexes, source) {
	        if (!column) {
	            return;
	        }
	        // following ensures we are left with boolean true or false, eg converts (null, undefined, 0) all to true
	        column.setVisible(!stateItem.hide, source);
	        // sets pinned to 'left' or 'right'
	        column.setPinned(stateItem.pinned);
	        // if width provided and valid, use it, otherwise stick with the old width
	        var minColWidth = this.gridOptionsWrapper.getMinColWidth();
	        if (stateItem.width && minColWidth &&
	            (stateItem.width >= minColWidth)) {
	            column.setActualWidth(stateItem.width, source);
	        }
	        if (typeof stateItem.aggFunc === 'string') {
	            column.setAggFunc(stateItem.aggFunc);
	            column.setValueActive(true, source);
	            this.valueColumns.push(column);
	        }
	        else {
	            if (utils_1._.exists(stateItem.aggFunc)) {
	                console.warn('ag-Grid: stateItem.aggFunc must be a string. if using your own aggregation ' +
	                    'functions, register the functions first before using them in get/set state. This is because it is' +
	                    'intended for the column state to be stored and retrieved as simple JSON.');
	            }
	            column.setAggFunc(null);
	            column.setValueActive(false, source);
	        }
	        if (typeof stateItem.rowGroupIndex === 'number') {
	            this.rowGroupColumns.push(column);
	            column.setRowGroupActive(true, source);
	            rowGroupIndexes[column.getId()] = stateItem.rowGroupIndex;
	        }
	        else {
	            column.setRowGroupActive(false, source);
	        }
	        if (typeof stateItem.pivotIndex === 'number') {
	            this.pivotColumns.push(column);
	            column.setPivotActive(true, source);
	            pivotIndexes[column.getId()] = stateItem.pivotIndex;
	        }
	        else {
	            column.setPivotActive(false, source);
	        }
	    };
	    ColumnController.prototype.getGridColumns = function (keys) {
	        return this.getColumns(keys, this.getGridColumn.bind(this));
	    };
	    ColumnController.prototype.getColumns = function (keys, columnLookupCallback) {
	        var foundColumns = [];
	        if (keys) {
	            keys.forEach(function (key) {
	                var column = columnLookupCallback(key);
	                if (column) {
	                    foundColumns.push(column);
	                }
	            });
	        }
	        return foundColumns;
	    };
	    // used by growGroupPanel
	    ColumnController.prototype.getColumnWithValidation = function (key) {
	        if (key == null) {
	            return null;
	        }
	        var column = this.getGridColumn(key);
	        if (!column) {
	            console.warn('ag-Grid: could not find column ' + key);
	        }
	        return column;
	    };
	    ColumnController.prototype.getPrimaryColumn = function (key) {
	        return this.getColumn(key, this.primaryColumns);
	    };
	    ColumnController.prototype.getGridColumn = function (key) {
	        return this.getColumn(key, this.gridColumns);
	    };
	    ColumnController.prototype.getColumn = function (key, columnList) {
	        if (!key) {
	            return null;
	        }
	        for (var i = 0; i < columnList.length; i++) {
	            if (this.columnsMatch(columnList[i], key)) {
	                return columnList[i];
	            }
	        }
	        return this.getAutoColumn(key);
	    };
	    ColumnController.prototype.getAutoColumn = function (key) {
	        var _this = this;
	        if (!this.groupAutoColumns || !utils_1._.exists(this.groupAutoColumns) || utils_1._.missing(this.groupAutoColumns)) {
	            return null;
	        }
	        return utils_1._.find(this.groupAutoColumns, function (groupCol) {
	            return _this.columnsMatch(groupCol, key);
	        });
	    };
	    ColumnController.prototype.columnsMatch = function (column, key) {
	        var columnMatches = column === key;
	        var colDefMatches = column.getColDef() === key;
	        var idMatches = column.getColId() == key;
	        return columnMatches || colDefMatches || idMatches;
	    };
	    ColumnController.prototype.getDisplayNameForColumn = function (column, location, includeAggFunc) {
	        if (includeAggFunc === void 0) { includeAggFunc = false; }
	        if (!column) {
	            return null;
	        }
	        var headerName = this.getHeaderName(column.getColDef(), column, null, null, location);
	        if (includeAggFunc) {
	            return this.wrapHeaderNameWithAggFunc(column, headerName);
	        }
	        else {
	            return headerName;
	        }
	    };
	    ColumnController.prototype.getDisplayNameForOriginalColumnGroup = function (columnGroup, originalColumnGroup, location) {
	        var colGroupDef = originalColumnGroup ? originalColumnGroup.getColGroupDef() : null;
	        if (colGroupDef) {
	            return this.getHeaderName(colGroupDef, null, columnGroup, originalColumnGroup, location);
	        }
	        else {
	            return null;
	        }
	    };
	    ColumnController.prototype.getDisplayNameForColumnGroup = function (columnGroup, location) {
	        return this.getDisplayNameForOriginalColumnGroup(columnGroup, columnGroup.getOriginalColumnGroup(), location);
	    };
	    // location is where the column is going to appear, ie who is calling us
	    ColumnController.prototype.getHeaderName = function (colDef, column, columnGroup, originalColumnGroup, location) {
	        var headerValueGetter = colDef.headerValueGetter;
	        if (headerValueGetter) {
	            var params = {
	                colDef: colDef,
	                column: column,
	                columnGroup: columnGroup,
	                originalColumnGroup: originalColumnGroup,
	                location: location,
	                api: this.gridOptionsWrapper.getApi(),
	                context: this.gridOptionsWrapper.getContext()
	            };
	            if (typeof headerValueGetter === 'function') {
	                // valueGetter is a function, so just call it
	                return headerValueGetter(params);
	            }
	            else if (typeof headerValueGetter === 'string') {
	                // valueGetter is an expression, so execute the expression
	                return this.expressionService.evaluate(headerValueGetter, params);
	            }
	            else {
	                console.warn('ag-grid: headerValueGetter must be a function or a string');
	                return '';
	            }
	        }
	        else if (colDef.headerName != null) {
	            return colDef.headerName;
	        }
	        else if (colDef.field) {
	            return utils_1._.camelCaseToHumanText(colDef.field);
	        }
	        else {
	            return '';
	        }
	    };
	    /*
	        private getHeaderGroupName(columnGroup: ColumnGroup): string {
	            let colGroupDef = columnGroup.getOriginalColumnGroup().getColGroupDef();
	            let headerValueGetter = colGroupDef.headerValueGetter;
	
	            if (headerValueGetter) {
	                let params = {
	                    columnGroup: columnGroup,
	                    colDef: colGroupDef,
	                    api: this.gridOptionsWrapper.getApi(),
	                    context: this.gridOptionsWrapper.getContext()
	                };
	
	                if (typeof headerValueGetter === 'function') {
	                    // valueGetter is a function, so just call it
	                    return headerValueGetter(params);
	                } else if (typeof headerValueGetter === 'string') {
	                    // valueGetter is an expression, so execute the expression
	                    return this.expressionService.evaluate(headerValueGetter, params);
	                } else {
	                    console.warn('ag-grid: headerValueGetter must be a function or a string');
	                    return '';
	                }
	            } else {
	                return colGroupDef.headerName;
	            }
	        }
	    */
	    ColumnController.prototype.wrapHeaderNameWithAggFunc = function (column, headerName) {
	        if (this.gridOptionsWrapper.isSuppressAggFuncInHeader()) {
	            return headerName;
	        }
	        // only columns with aggregation active can have aggregations
	        var pivotValueColumn = column.getColDef().pivotValueColumn;
	        var pivotActiveOnThisColumn = utils_1._.exists(pivotValueColumn);
	        var aggFunc = null;
	        var aggFuncFound;
	        // otherwise we have a measure that is active, and we are doing aggregation on it
	        if (pivotActiveOnThisColumn) {
	            aggFunc = pivotValueColumn ? pivotValueColumn.getAggFunc() : null;
	            aggFuncFound = true;
	        }
	        else {
	            var measureActive = column.isValueActive();
	            var aggregationPresent = this.pivotMode || !this.isRowGroupEmpty();
	            if (measureActive && aggregationPresent) {
	                aggFunc = column.getAggFunc();
	                aggFuncFound = true;
	            }
	            else {
	                aggFuncFound = false;
	            }
	        }
	        if (aggFuncFound) {
	            var aggFuncString = (typeof aggFunc === 'string') ? aggFunc : 'func';
	            var localeTextFunc = this.gridOptionsWrapper.getLocaleTextFunc();
	            var aggFuncStringTranslated = localeTextFunc(aggFuncString, aggFuncString);
	            return aggFuncStringTranslated + "(" + headerName + ")";
	        }
	        else {
	            return headerName;
	        }
	    };
	    // returns the group with matching colId and instanceId. If instanceId is missing,
	    // matches only on the colId.
	    ColumnController.prototype.getColumnGroup = function (colId, instanceId) {
	        if (!colId) {
	            return null;
	        }
	        if (colId instanceof columnGroup_1.ColumnGroup) {
	            return colId;
	        }
	        var allColumnGroups = this.getAllDisplayedColumnGroups();
	        var checkInstanceId = typeof instanceId === 'number';
	        var result = null;
	        this.columnUtils.depthFirstAllColumnTreeSearch(allColumnGroups, function (child) {
	            if (child instanceof columnGroup_1.ColumnGroup) {
	                var columnGroup = child;
	                var matched = void 0;
	                if (checkInstanceId) {
	                    matched = colId === columnGroup.getGroupId() && instanceId === columnGroup.getInstanceId();
	                }
	                else {
	                    matched = colId === columnGroup.getGroupId();
	                }
	                if (matched) {
	                    result = columnGroup;
	                }
	            }
	        });
	        return result;
	    };
	    ColumnController.prototype.isReady = function () {
	        return this.ready;
	    };
	    ColumnController.prototype.createValueColumns = function (source, oldPrimaryColumns) {
	        this.valueColumns = this.extractColumns(oldPrimaryColumns, this.valueColumns, function (col, flag) { return col.setValueActive(flag, source); }, 
	        // aggFunc doesn't have index variant, cos order of value cols doesn't matter, so always return null
	        function () { return null; }, 
	        // aggFunc is a string, so return it's existence
	        function (colDef) { return !!colDef.aggFunc; });
	        // all new columns added will have aggFunc missing, so set it to what is in the colDef
	        this.valueColumns.forEach(function (col) {
	            if (!col.getAggFunc()) {
	                col.setAggFunc(col.getColDef().aggFunc);
	            }
	        });
	    };
	    ColumnController.prototype.extractRowGroupColumns = function (source, oldPrimaryColumns) {
	        this.rowGroupColumns = this.extractColumns(oldPrimaryColumns, this.rowGroupColumns, function (col, flag) { return col.setRowGroupActive(flag, source); }, function (colDef) { return colDef.rowGroupIndex; }, function (colDef) { return colDef.rowGroup; });
	    };
	    ColumnController.prototype.extractColumns = function (oldPrimaryColumns, previousCols, setFlagFunc, getIndexFunc, getValueFunc) {
	        var _this = this;
	        if (!previousCols) {
	            previousCols = [];
	        }
	        // remove cols that no longer exist
	        var colPresentInPrimaryFunc = function (col) { return _this.primaryColumns.indexOf(col) >= 0; };
	        var colMissingFromPrimaryFunc = function (col) { return _this.primaryColumns.indexOf(col) < 0; };
	        var colNewFunc = function (col) { return !oldPrimaryColumns || oldPrimaryColumns.indexOf(col) < 0; };
	        var removedCols = previousCols.filter(colMissingFromPrimaryFunc);
	        var existingCols = previousCols.filter(colPresentInPrimaryFunc);
	        var newPrimaryCols = this.primaryColumns.filter(colNewFunc);
	        removedCols.forEach(function (col) { return setFlagFunc(col, false); });
	        var newCols = [];
	        // we only want to work on new columns, as old columns already got processed first time around
	        // pull out items with xxxIndex
	        newPrimaryCols.forEach(function (col) {
	            var index = getIndexFunc(col.getColDef());
	            if (typeof index === 'number') {
	                newCols.push(col);
	            }
	        });
	        // then sort them
	        newCols.sort(function (colA, colB) {
	            var indexA = getIndexFunc(colA.getColDef());
	            var indexB = getIndexFunc(colB.getColDef());
	            if (indexA === indexB) {
	                return 0;
	            }
	            else if (indexA < indexB) {
	                return -1;
	            }
	            else {
	                return 1;
	            }
	        });
	        // now just pull out items xxx (boolean value), they will be added at the end
	        // after the indexed ones, but in the order the columns appear
	        newPrimaryCols.forEach(function (col) {
	            var booleanValue = getValueFunc(col.getColDef());
	            if (booleanValue) {
	                // if user already specified xxxIndex then we skip it as this col already included
	                if (newCols.indexOf(col) >= 0) {
	                    return;
	                }
	                newCols.push(col);
	            }
	        });
	        newCols.forEach(function (col) { return setFlagFunc(col, true); });
	        var res = existingCols.concat(newCols);
	        return res;
	    };
	    ColumnController.prototype.extractPivotColumns = function (source, oldPrimaryColumns) {
	        this.pivotColumns = this.extractColumns(oldPrimaryColumns, this.pivotColumns, function (col, flag) { return col.setPivotActive(flag, source); }, function (colDef) { return colDef.pivotIndex; }, function (colDef) { return colDef.pivot; });
	    };
	    ColumnController.prototype.resetColumnGroupState = function (source) {
	        if (source === void 0) { source = "api"; }
	        var stateItems = [];
	        this.columnUtils.depthFirstOriginalTreeSearch(null, this.primaryColumnTree, function (child) {
	            if (child instanceof originalColumnGroup_1.OriginalColumnGroup) {
	                var groupState = {
	                    groupId: child.getGroupId(),
	                    open: child.getColGroupDef().openByDefault
	                };
	                stateItems.push(groupState);
	            }
	        });
	        this.setColumnGroupState(stateItems, source);
	    };
	    ColumnController.prototype.getColumnGroupState = function () {
	        var columnGroupState = [];
	        this.columnUtils.depthFirstOriginalTreeSearch(null, this.gridBalancedTree, function (node) {
	            if (node instanceof originalColumnGroup_1.OriginalColumnGroup) {
	                var originalColumnGroup = node;
	                columnGroupState.push({
	                    groupId: originalColumnGroup.getGroupId(),
	                    open: originalColumnGroup.isExpanded()
	                });
	            }
	        });
	        return columnGroupState;
	    };
	    ColumnController.prototype.setColumnGroupState = function (stateItems, source) {
	        var _this = this;
	        if (source === void 0) { source = "api"; }
	        this.columnAnimationService.start();
	        var impactedGroups = [];
	        stateItems.forEach(function (stateItem) {
	            var groupKey = stateItem.groupId;
	            var newValue = stateItem.open;
	            var originalColumnGroup = _this.getOriginalColumnGroup(groupKey);
	            if (!originalColumnGroup) {
	                return;
	            }
	            if (originalColumnGroup.isExpanded() === newValue) {
	                return;
	            }
	            _this.logger.log('columnGroupOpened(' + originalColumnGroup.getGroupId() + ',' + newValue + ')');
	            originalColumnGroup.setExpanded(newValue);
	            impactedGroups.push(originalColumnGroup);
	        });
	        this.updateGroupsAndDisplayedColumns(source);
	        this.setFirstRightAndLastLeftPinned(source);
	        impactedGroups.forEach(function (originalColumnGroup) {
	            var event = {
	                type: events_1.Events.EVENT_COLUMN_GROUP_OPENED,
	                columnGroup: originalColumnGroup,
	                api: _this.gridApi,
	                columnApi: _this.columnApi
	            };
	            _this.eventService.dispatchEvent(event);
	        });
	        this.columnAnimationService.finish();
	    };
	    // called by headerRenderer - when a header is opened or closed
	    ColumnController.prototype.setColumnGroupOpened = function (key, newValue, source) {
	        if (source === void 0) { source = "api"; }
	        var keyAsString;
	        if (key instanceof originalColumnGroup_1.OriginalColumnGroup) {
	            keyAsString = key.getId();
	        }
	        else {
	            keyAsString = key;
	        }
	        this.setColumnGroupState([{ groupId: keyAsString, open: newValue }], source);
	    };
	    ColumnController.prototype.getOriginalColumnGroup = function (key) {
	        if (key instanceof originalColumnGroup_1.OriginalColumnGroup) {
	            return key;
	        }
	        if (typeof key !== 'string') {
	            console.error('ag-Grid: group key must be a string');
	        }
	        // otherwise, search for the column group by id
	        var res = null;
	        this.columnUtils.depthFirstOriginalTreeSearch(null, this.gridBalancedTree, function (node) {
	            if (node instanceof originalColumnGroup_1.OriginalColumnGroup) {
	                var originalColumnGroup = node;
	                if (originalColumnGroup.getId() === key) {
	                    res = originalColumnGroup;
	                }
	            }
	        });
	        return res;
	    };
	    ColumnController.prototype.calculateColumnsForDisplay = function () {
	        var _this = this;
	        var columnsForDisplay;
	        if (this.pivotMode && !this.secondaryColumnsPresent) {
	            // pivot mode is on, but we are not pivoting, so we only
	            // show columns we are aggregating on
	            columnsForDisplay = utils_1._.filter(this.gridColumns, function (column) {
	                var isAutoGroupCol = _this.groupAutoColumns && _this.groupAutoColumns.indexOf(column) >= 0;
	                var isValueCol = _this.valueColumns && _this.valueColumns.indexOf(column) >= 0;
	                return isAutoGroupCol || isValueCol;
	            });
	        }
	        else {
	            // otherwise continue as normal. this can be working on the primary
	            // or secondary columns, whatever the gridColumns are set to
	            columnsForDisplay = utils_1._.filter(this.gridColumns, function (column) {
	                // keep col if a) it's auto-group or b) it's visible
	                var isAutoGroupCol = _this.groupAutoColumns && _this.groupAutoColumns.indexOf(column) >= 0;
	                return isAutoGroupCol || column.isVisible();
	            });
	        }
	        return columnsForDisplay;
	    };
	    ColumnController.prototype.checkColSpanActiveInCols = function (columns) {
	        var result = false;
	        columns.forEach(function (col) {
	            if (utils_1._.exists(col.getColDef().colSpan)) {
	                result = true;
	            }
	        });
	        return result;
	    };
	    ColumnController.prototype.calculateColumnsForGroupDisplay = function () {
	        var _this = this;
	        this.groupDisplayColumns = [];
	        var checkFunc = function (col) {
	            var colDef = col.getColDef();
	            if (colDef && utils_1._.exists(colDef.showRowGroup)) {
	                _this.groupDisplayColumns.push(col);
	            }
	        };
	        this.gridColumns.forEach(checkFunc);
	        if (this.groupAutoColumns) {
	            this.groupAutoColumns.forEach(checkFunc);
	        }
	    };
	    ColumnController.prototype.getGroupDisplayColumns = function () {
	        return this.groupDisplayColumns;
	    };
	    ColumnController.prototype.updateDisplayedColumns = function (source) {
	        var columnsForDisplay = this.calculateColumnsForDisplay();
	        this.buildDisplayedTrees(columnsForDisplay);
	        this.calculateColumnsForGroupDisplay();
	        // also called when group opened/closed
	        this.updateGroupsAndDisplayedColumns(source);
	        // also called when group opened/closed
	        this.setFirstRightAndLastLeftPinned(source);
	    };
	    ColumnController.prototype.isSecondaryColumnsPresent = function () {
	        return this.secondaryColumnsPresent;
	    };
	    ColumnController.prototype.setSecondaryColumns = function (colDefs, source) {
	        if (source === void 0) { source = "api"; }
	        var newColsPresent = colDefs && colDefs.length > 0;
	        // if not cols passed, and we had to cols anyway, then do nothing
	        if (!newColsPresent && !this.secondaryColumnsPresent) {
	            return;
	        }
	        if (newColsPresent) {
	            this.processSecondaryColumnDefinitions(colDefs);
	            var balancedTreeResult = this.columnFactory.createColumnTree(colDefs, false);
	            this.secondaryBalancedTree = balancedTreeResult.columnTree;
	            this.secondaryHeaderRowCount = balancedTreeResult.treeDept + 1;
	            this.secondaryColumns = this.getColumnsFromTree(this.secondaryBalancedTree);
	            this.secondaryColumnsPresent = true;
	        }
	        else {
	            this.secondaryBalancedTree = null;
	            this.secondaryHeaderRowCount = -1;
	            this.secondaryColumns = null;
	            this.secondaryColumnsPresent = false;
	        }
	        this.updateGridColumns();
	        this.updateDisplayedColumns(source);
	    };
	    ColumnController.prototype.processSecondaryColumnDefinitions = function (colDefs) {
	        var columnCallback = this.gridOptionsWrapper.getProcessSecondaryColDefFunc();
	        var groupCallback = this.gridOptionsWrapper.getProcessSecondaryColGroupDefFunc();
	        if (!columnCallback && !groupCallback) {
	            return undefined;
	        }
	        if (colDefs) {
	            searchForColDefs(colDefs);
	        }
	        function searchForColDefs(colDefs2) {
	            colDefs2.forEach(function (abstractColDef) {
	                var isGroup = utils_1._.exists(abstractColDef.children);
	                if (isGroup) {
	                    var colGroupDef = abstractColDef;
	                    if (groupCallback) {
	                        groupCallback(colGroupDef);
	                    }
	                    searchForColDefs(colGroupDef.children);
	                }
	                else {
	                    var colDef = abstractColDef;
	                    if (columnCallback) {
	                        columnCallback(colDef);
	                    }
	                }
	            });
	        }
	    };
	    // called from: setColumnState, setColumnDefs, setSecondaryColumns
	    ColumnController.prototype.updateGridColumns = function () {
	        if (this.gridColsArePrimary) {
	            this.lastPrimaryOrder = this.gridColumns;
	        }
	        if (this.secondaryColumns && this.secondaryBalancedTree) {
	            this.gridBalancedTree = this.secondaryBalancedTree.slice();
	            this.gridHeaderRowCount = this.secondaryHeaderRowCount;
	            this.gridColumns = this.secondaryColumns.slice();
	            this.gridColsArePrimary = false;
	        }
	        else {
	            this.gridBalancedTree = this.primaryColumnTree.slice();
	            this.gridHeaderRowCount = this.primaryHeaderRowCount;
	            this.gridColumns = this.primaryColumns.slice();
	            this.gridColsArePrimary = true;
	            // updateGridColumns gets called after user adds a row group. we want to maintain the order of the columns
	            // when this happens (eg if user moved a column) rather than revert back to the original column order.
	            // likewise if changing in/out of pivot mode, we want to maintain the order of the primary cols
	            this.orderGridColsLikeLastPrimary();
	        }
	        this.addAutoGroupToGridColumns();
	        this.autoRowHeightColumns = this.gridColumns.filter(function (col) { return col.getColDef().autoHeight; });
	        this.putFixedColumnsFirst();
	        this.setupQuickFilterColumns();
	        this.clearDisplayedColumns();
	        this.colSpanActive = this.checkColSpanActiveInCols(this.gridColumns);
	        var event = {
	            type: events_1.Events.EVENT_GRID_COLUMNS_CHANGED,
	            api: this.gridApi,
	            columnApi: this.columnApi
	        };
	        this.eventService.dispatchEvent(event);
	    };
	    ColumnController.prototype.orderGridColsLikeLastPrimary = function () {
	        var _this = this;
	        if (utils_1._.missing(this.lastPrimaryOrder)) {
	            return;
	        }
	        // only do the sort if at least one column is accounted for. columns will be not accounted for
	        // if changing from secondary to primary columns
	        var noColsFound = true;
	        this.gridColumns.forEach(function (col) {
	            if (_this.lastPrimaryOrder.indexOf(col) >= 0) {
	                noColsFound = false;
	            }
	        });
	        if (noColsFound) {
	            return;
	        }
	        // order cols in the same order as before. we need to make sure that all
	        // cols still exists, so filter out any that no longer exist.
	        var oldColsOrdered = this.lastPrimaryOrder.filter(function (col) { return _this.gridColumns.indexOf(col) >= 0; });
	        var newColsOrdered = this.gridColumns.filter(function (col) { return oldColsOrdered.indexOf(col) < 0; });
	        // add in the new columns, at the end (if no group), or at the end of the group (if a group)
	        var newGridColumns = oldColsOrdered.slice();
	        newColsOrdered.forEach(function (newCol) {
	            var parent = newCol.getOriginalParent();
	            // if no parent, means we are not grouping, so just add the column to the end
	            if (!parent) {
	                newGridColumns.push(newCol);
	                return;
	            }
	            // find the group the column belongs to. if no siblings at the current level (eg col in group on it's
	            // own) then go up one level and look for siblings there.
	            var siblings = [];
	            while (!siblings.length && parent) {
	                var leafCols = parent.getLeafColumns();
	                leafCols.forEach(function (leafCol) {
	                    var presentInNewGriColumns = newGridColumns.indexOf(leafCol) >= 0;
	                    var noYetInSiblings = siblings.indexOf(leafCol) < 0;
	                    if (presentInNewGriColumns && noYetInSiblings) {
	                        siblings.push(leafCol);
	                    }
	                });
	                parent = parent.getOriginalParent();
	            }
	            // if no siblings exist at any level, this means the col is in a group (or parent groups) on it's own
	            if (!siblings.length) {
	                newGridColumns.push(newCol);
	                return;
	            }
	            // find index of last column in the group
	            var indexes = siblings.map(function (col) { return newGridColumns.indexOf(col); });
	            var lastIndex = Math.max.apply(Math, indexes);
	            utils_1._.insertIntoArray(newGridColumns, newCol, lastIndex + 1);
	        });
	        this.gridColumns = newGridColumns;
	    };
	    ColumnController.prototype.isPrimaryColumnGroupsPresent = function () {
	        return this.primaryHeaderRowCount > 1;
	    };
	    // if we are using autoGroupCols, then they should be included for quick filter. this covers the
	    // following scenarios:
	    // a) user provides 'field' into autoGroupCol of normal grid, so now because a valid col to filter leafs on
	    // b) using tree data and user depends on autoGroupCol for first col, and we also want to filter on this
	    //    (tree data is a bit different, as parent rows can be filtered on, unlike row grouping)
	    ColumnController.prototype.setupQuickFilterColumns = function () {
	        if (this.groupAutoColumns) {
	            this.columnsForQuickFilter = this.primaryColumns.concat(this.groupAutoColumns);
	        }
	        else {
	            this.columnsForQuickFilter = this.primaryColumns;
	        }
	    };
	    ColumnController.prototype.putFixedColumnsFirst = function () {
	        var locked = this.gridColumns.filter(function (c) { return c.getColDef().lockPosition; });
	        var unlocked = this.gridColumns.filter(function (c) { return !c.getColDef().lockPosition; });
	        this.gridColumns = locked.concat(unlocked);
	    };
	    ColumnController.prototype.addAutoGroupToGridColumns = function () {
	        // add in auto-group here
	        this.createGroupAutoColumnsIfNeeded();
	        if (utils_1._.missing(this.groupAutoColumns)) {
	            return;
	        }
	        this.gridColumns = this.groupAutoColumns ? this.groupAutoColumns.concat(this.gridColumns) : this.gridColumns;
	        var autoColBalancedTree = this.columnFactory.createForAutoGroups(this.groupAutoColumns, this.gridBalancedTree);
	        this.gridBalancedTree = autoColBalancedTree.concat(this.gridBalancedTree);
	    };
	    // gets called after we copy down grid columns, to make sure any part of the gui
	    // that tries to draw, eg the header, it will get empty lists of columns rather
	    // than stale columns. for example, the header will received gridColumnsChanged
	    // event, so will try and draw, but it will draw successfully when it acts on the
	    // virtualColumnsChanged event
	    ColumnController.prototype.clearDisplayedColumns = function () {
	        this.displayedLeftColumnTree = [];
	        this.displayedRightColumnTree = [];
	        this.displayedCentreColumnTree = [];
	        this.displayedLeftHeaderRows = {};
	        this.displayedRightHeaderRows = {};
	        this.displayedCentreHeaderRows = {};
	        this.displayedLeftColumns = [];
	        this.displayedRightColumns = [];
	        this.displayedCenterColumns = [];
	        this.allDisplayedColumns = [];
	        this.allDisplayedVirtualColumns = [];
	    };
	    ColumnController.prototype.updateGroupsAndDisplayedColumns = function (source) {
	        this.updateOpenClosedVisibilityInColumnGroups();
	        this.updateDisplayedColumnsFromTrees(source);
	        this.updateVirtualSets();
	        this.updateBodyWidths();
	        // this event is picked up by the gui, headerRenderer and rowRenderer, to recalculate what columns to display
	        var event = {
	            type: events_1.Events.EVENT_DISPLAYED_COLUMNS_CHANGED,
	            api: this.gridApi,
	            columnApi: this.columnApi
	        };
	        this.eventService.dispatchEvent(event);
	    };
	    ColumnController.prototype.updateDisplayedColumnsFromTrees = function (source) {
	        this.addToDisplayedColumns(this.displayedLeftColumnTree, this.displayedLeftColumns);
	        this.addToDisplayedColumns(this.displayedCentreColumnTree, this.displayedCenterColumns);
	        this.addToDisplayedColumns(this.displayedRightColumnTree, this.displayedRightColumns);
	        this.setupAllDisplayedColumns();
	        this.setLeftValues(source);
	    };
	    ColumnController.prototype.setupAllDisplayedColumns = function () {
	        if (this.gridOptionsWrapper.isEnableRtl()) {
	            this.allDisplayedColumns = this.displayedRightColumns
	                .concat(this.displayedCenterColumns)
	                .concat(this.displayedLeftColumns);
	        }
	        else {
	            this.allDisplayedColumns = this.displayedLeftColumns
	                .concat(this.displayedCenterColumns)
	                .concat(this.displayedRightColumns);
	        }
	    };
	    // sets the left pixel position of each column
	    ColumnController.prototype.setLeftValues = function (source) {
	        this.setLeftValuesOfColumns(source);
	        this.setLeftValuesOfGroups();
	    };
	    ColumnController.prototype.setLeftValuesOfColumns = function (source) {
	        var _this = this;
	        // go through each list of displayed columns
	        var allColumns = this.primaryColumns.slice(0);
	        // let totalColumnWidth = this.getWidthOfColsInList()
	        var doingRtl = this.gridOptionsWrapper.isEnableRtl();
	        [this.displayedLeftColumns, this.displayedRightColumns, this.displayedCenterColumns].forEach(function (columns) {
	            if (doingRtl) {
	                // when doing RTL, we start at the top most pixel (ie RHS) and work backwards
	                var left_1 = _this.getWidthOfColsInList(columns);
	                columns.forEach(function (column) {
	                    left_1 -= column.getActualWidth();
	                    column.setLeft(left_1, source);
	                });
	            }
	            else {
	                // otherwise normal LTR, we start at zero
	                var left_2 = 0;
	                columns.forEach(function (column) {
	                    column.setLeft(left_2, source);
	                    left_2 += column.getActualWidth();
	                });
	            }
	            utils_1._.removeAllFromArray(allColumns, columns);
	        });
	        // items left in allColumns are columns not displayed, so remove the left position. this is
	        // important for the rows, as if a col is made visible, then taken out, then made visible again,
	        // we don't want the animation of the cell floating in from the old position, whatever that was.
	        allColumns.forEach(function (column) {
	            column.setLeft(null, source);
	        });
	    };
	    ColumnController.prototype.setLeftValuesOfGroups = function () {
	        // a groups left value is the lest left value of it's children
	        [this.displayedLeftColumnTree, this.displayedRightColumnTree, this.displayedCentreColumnTree].forEach(function (columns) {
	            columns.forEach(function (column) {
	                if (column instanceof columnGroup_1.ColumnGroup) {
	                    var columnGroup = column;
	                    columnGroup.checkLeft();
	                }
	            });
	        });
	    };
	    ColumnController.prototype.addToDisplayedColumns = function (displayedColumnTree, displayedColumns) {
	        displayedColumns.length = 0;
	        this.columnUtils.depthFirstDisplayedColumnTreeSearch(displayedColumnTree, function (child) {
	            if (child instanceof column_1.Column) {
	                displayedColumns.push(child);
	            }
	        });
	    };
	    ColumnController.prototype.updateDisplayedCenterVirtualColumns = function () {
	        if (this.suppressColumnVirtualisation) {
	            // no virtualisation, so don't filter
	            this.allDisplayedCenterVirtualColumns = this.displayedCenterColumns;
	        }
	        else {
	            // filter out what should be visible
	            this.allDisplayedCenterVirtualColumns = this.filterOutColumnsWithinViewport();
	        }
	        this.allDisplayedVirtualColumns = this.allDisplayedCenterVirtualColumns
	            .concat(this.displayedLeftColumns)
	            .concat(this.displayedRightColumns);
	        // return map of virtual col id's, for easy lookup when building the groups.
	        // the map will be colId=>true, ie col id's mapping to 'true'.
	        var result = {};
	        this.allDisplayedVirtualColumns.forEach(function (col) {
	            result[col.getId()] = true;
	        });
	        return result;
	    };
	    ColumnController.prototype.getVirtualHeaderGroupRow = function (type, dept) {
	        var result;
	        switch (type) {
	            case column_1.Column.PINNED_LEFT:
	                result = this.displayedLeftHeaderRows[dept];
	                break;
	            case column_1.Column.PINNED_RIGHT:
	                result = this.displayedRightHeaderRows[dept];
	                break;
	            default:
	                result = this.displayedCentreHeaderRows[dept];
	                break;
	        }
	        if (utils_1._.missing(result)) {
	            result = [];
	        }
	        return result;
	    };
	    ColumnController.prototype.updateDisplayedVirtualGroups = function (virtualColIds) {
	        // go through each group, see if any of it's cols are displayed, and if yes,
	        // then this group is included
	        this.displayedLeftHeaderRows = {};
	        this.displayedRightHeaderRows = {};
	        this.displayedCentreHeaderRows = {};
	        testGroup(this.displayedLeftColumnTree, this.displayedLeftHeaderRows, 0);
	        testGroup(this.displayedRightColumnTree, this.displayedRightHeaderRows, 0);
	        testGroup(this.displayedCentreColumnTree, this.displayedCentreHeaderRows, 0);
	        function testGroup(children, result, dept) {
	            var returnValue = false;
	            for (var i = 0; i < children.length; i++) {
	                // see if this item is within viewport
	                var child = children[i];
	                var addThisItem = void 0;
	                if (child instanceof column_1.Column) {
	                    // for column, test if column is included
	                    addThisItem = virtualColIds[child.getId()] === true;
	                }
	                else {
	                    // if group, base decision on children
	                    var columnGroup = child;
	                    addThisItem = testGroup(columnGroup.getDisplayedChildren(), result, dept + 1);
	                }
	                if (addThisItem) {
	                    returnValue = true;
	                    if (!result[dept]) {
	                        result[dept] = [];
	                    }
	                    result[dept].push(child);
	                }
	            }
	            return returnValue;
	        }
	    };
	    ColumnController.prototype.updateVirtualSets = function () {
	        var virtualColIds = this.updateDisplayedCenterVirtualColumns();
	        this.updateDisplayedVirtualGroups(virtualColIds);
	    };
	    ColumnController.prototype.filterOutColumnsWithinViewport = function () {
	        return utils_1._.filter(this.displayedCenterColumns, this.isColumnInViewport.bind(this));
	    };
	    // called from api
	    ColumnController.prototype.sizeColumnsToFit = function (gridWidth, source) {
	        var _this = this;
	        if (source === void 0) { source = "api"; }
	        // avoid divide by zero
	        var allDisplayedColumns = this.getAllDisplayedColumns();
	        if (gridWidth <= 0 || allDisplayedColumns.length === 0) {
	            return;
	        }
	        var colsToNotSpread = utils_1._.filter(allDisplayedColumns, function (column) {
	            return column.getColDef().suppressSizeToFit === true;
	        });
	        var colsToSpread = utils_1._.filter(allDisplayedColumns, function (column) {
	            return column.getColDef().suppressSizeToFit !== true;
	        });
	        // make a copy of the cols that are going to be resized
	        var colsToFireEventFor = colsToSpread.slice(0);
	        var finishedResizing = false;
	        while (!finishedResizing) {
	            finishedResizing = true;
	            var availablePixels = gridWidth - this.getWidthOfColsInList(colsToNotSpread);
	            if (availablePixels <= 0) {
	                // no width, set everything to minimum
	                colsToSpread.forEach(function (column) {
	                    column.setMinimum(source);
	                });
	            }
	            else {
	                var scale = availablePixels / this.getWidthOfColsInList(colsToSpread);
	                // we set the pixels for the last col based on what's left, as otherwise
	                // we could be a pixel or two short or extra because of rounding errors.
	                var pixelsForLastCol = availablePixels;
	                // backwards through loop, as we are removing items as we go
	                for (var i = colsToSpread.length - 1; i >= 0; i--) {
	                    var column = colsToSpread[i];
	                    var newWidth = Math.round(column.getActualWidth() * scale);
	                    if (newWidth < column.getMinWidth()) {
	                        column.setMinimum(source);
	                        moveToNotSpread(column);
	                        finishedResizing = false;
	                    }
	                    else if (column.isGreaterThanMax(newWidth)) {
	                        column.setActualWidth(column.getMaxWidth(), source);
	                        moveToNotSpread(column);
	                        finishedResizing = false;
	                    }
	                    else {
	                        var onLastCol = i === 0;
	                        if (onLastCol) {
	                            column.setActualWidth(pixelsForLastCol, source);
	                        }
	                        else {
	                            column.setActualWidth(newWidth, source);
	                        }
	                    }
	                    pixelsForLastCol -= newWidth;
	                }
	            }
	        }
	        this.setLeftValues(source);
	        this.updateBodyWidths();
	        colsToFireEventFor.forEach(function (column) {
	            var event = {
	                type: events_1.Events.EVENT_COLUMN_RESIZED,
	                column: column,
	                columns: [column],
	                finished: true,
	                api: _this.gridApi,
	                columnApi: _this.columnApi,
	                source: "sizeColumnsToFit"
	            };
	            _this.eventService.dispatchEvent(event);
	        });
	        function moveToNotSpread(column) {
	            utils_1._.removeFromArray(colsToSpread, column);
	            colsToNotSpread.push(column);
	        }
	    };
	    ColumnController.prototype.buildDisplayedTrees = function (visibleColumns) {
	        var leftVisibleColumns = utils_1._.filter(visibleColumns, function (column) {
	            return column.getPinned() === 'left';
	        });
	        var rightVisibleColumns = utils_1._.filter(visibleColumns, function (column) {
	            return column.getPinned() === 'right';
	        });
	        var centerVisibleColumns = utils_1._.filter(visibleColumns, function (column) {
	            return column.getPinned() !== 'left' && column.getPinned() !== 'right';
	        });
	        var groupInstanceIdCreator = new groupInstanceIdCreator_1.GroupInstanceIdCreator();
	        this.displayedLeftColumnTree = this.displayedGroupCreator.createDisplayedGroups(leftVisibleColumns, this.gridBalancedTree, groupInstanceIdCreator, column_1.Column.PINNED_LEFT, this.displayedLeftColumnTree);
	        this.displayedRightColumnTree = this.displayedGroupCreator.createDisplayedGroups(rightVisibleColumns, this.gridBalancedTree, groupInstanceIdCreator, column_1.Column.PINNED_RIGHT, this.displayedRightColumnTree);
	        this.displayedCentreColumnTree = this.displayedGroupCreator.createDisplayedGroups(centerVisibleColumns, this.gridBalancedTree, groupInstanceIdCreator, null, this.displayedCentreColumnTree);
	    };
	    ColumnController.prototype.updateOpenClosedVisibilityInColumnGroups = function () {
	        var allColumnGroups = this.getAllDisplayedColumnGroups();
	        this.columnUtils.depthFirstAllColumnTreeSearch(allColumnGroups, function (child) {
	            if (child instanceof columnGroup_1.ColumnGroup) {
	                var columnGroup = child;
	                columnGroup.calculateDisplayedColumns();
	            }
	        });
	    };
	    ColumnController.prototype.getGroupAutoColumns = function () {
	        return this.groupAutoColumns;
	    };
	    ColumnController.prototype.createGroupAutoColumnsIfNeeded = function () {
	        if (!this.autoGroupsNeedBuilding) {
	            return;
	        }
	        this.autoGroupsNeedBuilding = false;
	        var groupFullWidthRow = this.gridOptionsWrapper.isGroupUseEntireRow(this.pivotMode);
	        // we never suppress auto col for pivot mode, as there is no way for user to provide group columns
	        // in pivot mode. pivot mode has auto group column (provide by grid) and value columns (provided by
	        // pivot feature in the grid).
	        var groupSuppressAutoColumn = this.gridOptionsWrapper.isGroupSuppressAutoColumn() && !this.pivotMode;
	        var groupSuppressRow = this.gridOptionsWrapper.isGroupSuppressRow();
	        var groupingActive = this.rowGroupColumns.length > 0 || this.usingTreeData;
	        var needAutoColumns = groupingActive && !groupSuppressAutoColumn && !groupFullWidthRow && !groupSuppressRow;
	        if (needAutoColumns) {
	            var newAutoGroupCols = this.autoGroupColService.createAutoGroupColumns(this.rowGroupColumns);
	            var autoColsDifferent = !this.autoColsEqual(newAutoGroupCols, this.groupAutoColumns);
	            if (autoColsDifferent) {
	                this.groupAutoColumns = newAutoGroupCols;
	            }
	        }
	        else {
	            this.groupAutoColumns = null;
	        }
	    };
	    ColumnController.prototype.autoColsEqual = function (colsA, colsB) {
	        var bothMissing = !colsA && !colsB;
	        if (bothMissing) {
	            return true;
	        }
	        var atLeastOneListMissing = !colsA || !colsB;
	        if (atLeastOneListMissing) {
	            return false;
	        }
	        if (colsA.length !== colsB.length) {
	            return false;
	        }
	        for (var i = 0; i < colsA.length; i++) {
	            var colA = colsA[i];
	            var colB = colsB[i];
	            if (colA.getColId() !== colB.getColId()) {
	                return false;
	            }
	        }
	        return true;
	    };
	    ColumnController.prototype.getWidthOfColsInList = function (columnList) {
	        var result = 0;
	        for (var i = 0; i < columnList.length; i++) {
	            result += columnList[i].getActualWidth();
	        }
	        return result;
	    };
	    ColumnController.prototype.getGridBalancedTree = function () {
	        return this.gridBalancedTree;
	    };
	    __decorate([
	        context_1.Autowired('gridOptionsWrapper'),
	        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
	    ], ColumnController.prototype, "gridOptionsWrapper", void 0);
	    __decorate([
	        context_1.Autowired('expressionService'),
	        __metadata("design:type", expressionService_1.ExpressionService)
	    ], ColumnController.prototype, "expressionService", void 0);
	    __decorate([
	        context_1.Autowired('columnFactory'),
	        __metadata("design:type", columnFactory_1.ColumnFactory)
	    ], ColumnController.prototype, "columnFactory", void 0);
	    __decorate([
	        context_1.Autowired('displayedGroupCreator'),
	        __metadata("design:type", displayedGroupCreator_1.DisplayedGroupCreator)
	    ], ColumnController.prototype, "displayedGroupCreator", void 0);
	    __decorate([
	        context_1.Autowired('autoWidthCalculator'),
	        __metadata("design:type", autoWidthCalculator_1.AutoWidthCalculator)
	    ], ColumnController.prototype, "autoWidthCalculator", void 0);
	    __decorate([
	        context_1.Autowired('eventService'),
	        __metadata("design:type", eventService_1.EventService)
	    ], ColumnController.prototype, "eventService", void 0);
	    __decorate([
	        context_1.Autowired('columnUtils'),
	        __metadata("design:type", columnUtils_1.ColumnUtils)
	    ], ColumnController.prototype, "columnUtils", void 0);
	    __decorate([
	        context_1.Autowired('context'),
	        __metadata("design:type", context_1.Context)
	    ], ColumnController.prototype, "context", void 0);
	    __decorate([
	        context_1.Autowired('columnAnimationService'),
	        __metadata("design:type", columnAnimationService_1.ColumnAnimationService)
	    ], ColumnController.prototype, "columnAnimationService", void 0);
	    __decorate([
	        context_1.Autowired('autoGroupColService'),
	        __metadata("design:type", autoGroupColService_1.AutoGroupColService)
	    ], ColumnController.prototype, "autoGroupColService", void 0);
	    __decorate([
	        context_1.Optional('aggFuncService'),
	        __metadata("design:type", Object)
	    ], ColumnController.prototype, "aggFuncService", void 0);
	    __decorate([
	        context_1.Optional('valueCache'),
	        __metadata("design:type", valueCache_1.ValueCache)
	    ], ColumnController.prototype, "valueCache", void 0);
	    __decorate([
	        context_1.Autowired('columnApi'),
	        __metadata("design:type", columnApi_1.ColumnApi)
	    ], ColumnController.prototype, "columnApi", void 0);
	    __decorate([
	        context_1.Autowired('gridApi'),
	        __metadata("design:type", gridApi_1.GridApi)
	    ], ColumnController.prototype, "gridApi", void 0);
	    __decorate([
	        context_1.PostConstruct,
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", []),
	        __metadata("design:returntype", void 0)
	    ], ColumnController.prototype, "init", null);
	    __decorate([
	        __param(0, context_1.Qualifier('loggerFactory')),
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", [logger_1.LoggerFactory]),
	        __metadata("design:returntype", void 0)
	    ], ColumnController.prototype, "setBeans", null);
	    ColumnController = __decorate([
	        context_1.Bean('columnController')
	    ], ColumnController);
	    return ColumnController;
	}());
	exports.ColumnController = ColumnController;


/***/ }),
/* 2342 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var column_1 = __webpack_require__(2343);
	var eventService_1 = __webpack_require__(2331);
	var context_1 = __webpack_require__(2333);
	var gridOptionsWrapper_1 = __webpack_require__(2324);
	var utils_1 = __webpack_require__(2325);
	var ColumnGroup = /** @class */ (function () {
	    function ColumnGroup(originalColumnGroup, groupId, instanceId, pinned) {
	        // depends on the open/closed state of the group, only displaying columns are stored here
	        this.displayedChildren = [];
	        this.localEventService = new eventService_1.EventService();
	        this.groupId = groupId;
	        this.instanceId = instanceId;
	        this.originalColumnGroup = originalColumnGroup;
	        this.pinned = pinned;
	    }
	    // this is static, a it is used outside of this class
	    ColumnGroup.createUniqueId = function (groupId, instanceId) {
	        return groupId + '_' + instanceId;
	    };
	    // as the user is adding and removing columns, the groups are recalculated.
	    // this reset clears out all children, ready for children to be added again
	    ColumnGroup.prototype.reset = function () {
	        this.parent = null;
	        this.children = null;
	        this.displayedChildren = null;
	    };
	    ColumnGroup.prototype.getParent = function () {
	        return this.parent;
	    };
	    ColumnGroup.prototype.setParent = function (parent) {
	        this.parent = parent;
	    };
	    ColumnGroup.prototype.getUniqueId = function () {
	        return ColumnGroup.createUniqueId(this.groupId, this.instanceId);
	    };
	    ColumnGroup.prototype.isEmptyGroup = function () {
	        return this.displayedChildren.length === 0;
	    };
	    ColumnGroup.prototype.isMoving = function () {
	        var allLeafColumns = this.getOriginalColumnGroup().getLeafColumns();
	        if (!allLeafColumns || allLeafColumns.length === 0) {
	            return false;
	        }
	        var allMoving = true;
	        allLeafColumns.forEach(function (col) {
	            if (!col.isMoving()) {
	                allMoving = false;
	            }
	        });
	        return allMoving;
	    };
	    ColumnGroup.prototype.checkLeft = function () {
	        // first get all children to setLeft, as it impacts our decision below
	        this.displayedChildren.forEach(function (child) {
	            if (child instanceof ColumnGroup) {
	                child.checkLeft();
	            }
	        });
	        // set our left based on first displayed column
	        if (this.displayedChildren.length > 0) {
	            if (this.gridOptionsWrapper.isEnableRtl()) {
	                var lastChild = utils_1._.last(this.displayedChildren);
	                var lastChildLeft = lastChild.getLeft();
	                this.setLeft(lastChildLeft);
	            }
	            else {
	                var firstChildLeft = this.displayedChildren[0].getLeft();
	                this.setLeft(firstChildLeft);
	            }
	        }
	        else {
	            // this should never happen, as if we have no displayed columns, then
	            // this groups should not even exist.
	            this.setLeft(null);
	        }
	    };
	    ColumnGroup.prototype.getLeft = function () {
	        return this.left;
	    };
	    ColumnGroup.prototype.getOldLeft = function () {
	        return this.oldLeft;
	    };
	    ColumnGroup.prototype.setLeft = function (left) {
	        this.oldLeft = left;
	        if (this.left !== left) {
	            this.left = left;
	            this.localEventService.dispatchEvent(this.createAgEvent(ColumnGroup.EVENT_LEFT_CHANGED));
	        }
	    };
	    ColumnGroup.prototype.getPinned = function () {
	        return this.pinned;
	    };
	    ColumnGroup.prototype.createAgEvent = function (type) {
	        return {
	            type: type,
	        };
	    };
	    ColumnGroup.prototype.addEventListener = function (eventType, listener) {
	        this.localEventService.addEventListener(eventType, listener);
	    };
	    ColumnGroup.prototype.removeEventListener = function (eventType, listener) {
	        this.localEventService.removeEventListener(eventType, listener);
	    };
	    ColumnGroup.prototype.getGroupId = function () {
	        return this.groupId;
	    };
	    ColumnGroup.prototype.getInstanceId = function () {
	        return this.instanceId;
	    };
	    ColumnGroup.prototype.isChildInThisGroupDeepSearch = function (wantedChild) {
	        var result = false;
	        this.children.forEach(function (foundChild) {
	            if (wantedChild === foundChild) {
	                result = true;
	            }
	            if (foundChild instanceof ColumnGroup) {
	                if (foundChild.isChildInThisGroupDeepSearch(wantedChild)) {
	                    result = true;
	                }
	            }
	        });
	        return result;
	    };
	    ColumnGroup.prototype.getActualWidth = function () {
	        var groupActualWidth = 0;
	        if (this.displayedChildren) {
	            this.displayedChildren.forEach(function (child) {
	                groupActualWidth += child.getActualWidth();
	            });
	        }
	        return groupActualWidth;
	    };
	    ColumnGroup.prototype.isResizable = function () {
	        if (!this.displayedChildren) {
	            return false;
	        }
	        // if at least one child is resizable, then the group is resizable
	        var result = false;
	        this.displayedChildren.forEach(function (child) {
	            if (child.isResizable()) {
	                result = true;
	            }
	        });
	        return result;
	    };
	    ColumnGroup.prototype.getMinWidth = function () {
	        var result = 0;
	        this.displayedChildren.forEach(function (groupChild) {
	            result += groupChild.getMinWidth();
	        });
	        return result;
	    };
	    ColumnGroup.prototype.addChild = function (child) {
	        if (!this.children) {
	            this.children = [];
	        }
	        this.children.push(child);
	    };
	    ColumnGroup.prototype.getDisplayedChildren = function () {
	        return this.displayedChildren;
	    };
	    ColumnGroup.prototype.getLeafColumns = function () {
	        var result = [];
	        this.addLeafColumns(result);
	        return result;
	    };
	    ColumnGroup.prototype.getDisplayedLeafColumns = function () {
	        var result = [];
	        this.addDisplayedLeafColumns(result);
	        return result;
	    };
	    // why two methods here doing the same thing?
	    ColumnGroup.prototype.getDefinition = function () {
	        return this.originalColumnGroup.getColGroupDef();
	    };
	    ColumnGroup.prototype.getColGroupDef = function () {
	        return this.originalColumnGroup.getColGroupDef();
	    };
	    ColumnGroup.prototype.isPadding = function () {
	        return this.originalColumnGroup.isPadding();
	    };
	    ColumnGroup.prototype.isExpandable = function () {
	        return this.originalColumnGroup.isExpandable();
	    };
	    ColumnGroup.prototype.isExpanded = function () {
	        return this.originalColumnGroup.isExpanded();
	    };
	    ColumnGroup.prototype.setExpanded = function (expanded) {
	        this.originalColumnGroup.setExpanded(expanded);
	    };
	    ColumnGroup.prototype.addDisplayedLeafColumns = function (leafColumns) {
	        this.displayedChildren.forEach(function (child) {
	            if (child instanceof column_1.Column) {
	                leafColumns.push(child);
	            }
	            else if (child instanceof ColumnGroup) {
	                child.addDisplayedLeafColumns(leafColumns);
	            }
	        });
	    };
	    ColumnGroup.prototype.addLeafColumns = function (leafColumns) {
	        this.children.forEach(function (child) {
	            if (child instanceof column_1.Column) {
	                leafColumns.push(child);
	            }
	            else if (child instanceof ColumnGroup) {
	                child.addLeafColumns(leafColumns);
	            }
	        });
	    };
	    ColumnGroup.prototype.getChildren = function () {
	        return this.children;
	    };
	    ColumnGroup.prototype.getColumnGroupShow = function () {
	        return this.originalColumnGroup.getColumnGroupShow();
	    };
	    ColumnGroup.prototype.getOriginalColumnGroup = function () {
	        return this.originalColumnGroup;
	    };
	    ColumnGroup.prototype.calculateDisplayedColumns = function () {
	        var _this = this;
	        // clear out last time we calculated
	        this.displayedChildren = [];
	        var topLevelGroup = this;
	        // find the column group that is controlling expandable. this is relevant when we have padding (empty)
	        // groups, where the expandable is actually the first parent that is not a padding group.
	        if (this.isPadding()) {
	            while (topLevelGroup.getParent() && topLevelGroup.isPadding()) {
	                topLevelGroup = topLevelGroup.getParent();
	            }
	        }
	        var isExpandable = topLevelGroup.originalColumnGroup.isExpandable();
	        // it not expandable, everything is visible
	        if (!isExpandable) {
	            this.displayedChildren = this.children;
	        }
	        else {
	            // Add cols based on columnGroupShow
	            // Note - the below also adds padding groups, these are always added because they never have
	            // colDef.columnGroupShow set.
	            this.children.forEach(function (abstractColumn) {
	                var headerGroupShow = abstractColumn.getColumnGroupShow();
	                switch (headerGroupShow) {
	                    case ColumnGroup.HEADER_GROUP_SHOW_OPEN:
	                        // when set to open, only show col if group is open
	                        if (topLevelGroup.originalColumnGroup.isExpanded()) {
	                            _this.displayedChildren.push(abstractColumn);
	                        }
	                        break;
	                    case ColumnGroup.HEADER_GROUP_SHOW_CLOSED:
	                        // when set to open, only show col if group is open
	                        if (!topLevelGroup.originalColumnGroup.isExpanded()) {
	                            _this.displayedChildren.push(abstractColumn);
	                        }
	                        break;
	                    default:
	                        // default is always show the column
	                        _this.displayedChildren.push(abstractColumn);
	                        break;
	                }
	            });
	        }
	        this.localEventService.dispatchEvent(this.createAgEvent(ColumnGroup.EVENT_DISPLAYED_CHILDREN_CHANGED));
	    };
	    ColumnGroup.HEADER_GROUP_SHOW_OPEN = 'open';
	    ColumnGroup.HEADER_GROUP_SHOW_CLOSED = 'closed';
	    ColumnGroup.HEADER_GROUP_PADDING = 'padding';
	    ColumnGroup.EVENT_LEFT_CHANGED = 'leftChanged';
	    ColumnGroup.EVENT_DISPLAYED_CHILDREN_CHANGED = 'displayedChildrenChanged';
	    __decorate([
	        context_1.Autowired('gridOptionsWrapper'),
	        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
	    ], ColumnGroup.prototype, "gridOptionsWrapper", void 0);
	    return ColumnGroup;
	}());
	exports.ColumnGroup = ColumnGroup;


/***/ }),
/* 2343 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var eventService_1 = __webpack_require__(2331);
	var utils_1 = __webpack_require__(2325);
	var context_1 = __webpack_require__(2333);
	var gridOptionsWrapper_1 = __webpack_require__(2324);
	var columnUtils_1 = __webpack_require__(2344);
	var columnApi_1 = __webpack_require__(2346);
	var gridApi_1 = __webpack_require__(2338);
	// Wrapper around a user provide column definition. The grid treats the column definition as ready only.
	// This class contains all the runtime information about a column, plus some logic (the definition has no logic).
	// This class implements both interfaces ColumnGroupChild and OriginalColumnGroupChild as the class can
	// appear as a child of either the original tree or the displayed tree. However the relevant group classes
	// for each type only implements one, as each group can only appear in it's associated tree (eg OriginalColumnGroup
	// can only appear in OriginalColumn tree).
	var Column = /** @class */ (function () {
	    function Column(colDef, userProvidedColDef, colId, primary) {
	        this.moving = false;
	        this.menuVisible = false;
	        this.filterActive = false;
	        this.eventService = new eventService_1.EventService();
	        this.rowGroupActive = false;
	        this.pivotActive = false;
	        this.aggregationActive = false;
	        this.colDef = colDef;
	        this.userProvidedColDef = userProvidedColDef;
	        this.visible = !colDef.hide;
	        this.sort = colDef.sort;
	        this.sortedAt = colDef.sortedAt;
	        this.colId = colId;
	        this.primary = primary;
	    }
	    // gets called when user provides an alternative colDef, eg
	    Column.prototype.setColDef = function (colDef, userProvidedColDef) {
	        this.colDef = colDef;
	        this.userProvidedColDef = userProvidedColDef;
	    };
	    Column.prototype.getUserProvidedColDef = function () {
	        return this.userProvidedColDef;
	    };
	    Column.prototype.setParent = function (parent) {
	        this.parent = parent;
	    };
	    Column.prototype.getParent = function () {
	        return this.parent;
	    };
	    Column.prototype.setOriginalParent = function (originalParent) {
	        this.originalParent = originalParent;
	    };
	    Column.prototype.getOriginalParent = function () {
	        return this.originalParent;
	    };
	    // this is done after constructor as it uses gridOptionsWrapper
	    Column.prototype.initialise = function () {
	        this.setPinned(this.colDef.pinned);
	        var minColWidth = this.gridOptionsWrapper.getMinColWidth();
	        var maxColWidth = this.gridOptionsWrapper.getMaxColWidth();
	        if (this.colDef.minWidth) {
	            this.minWidth = this.colDef.minWidth;
	        }
	        else {
	            this.minWidth = minColWidth;
	        }
	        if (this.colDef.maxWidth) {
	            this.maxWidth = this.colDef.maxWidth;
	        }
	        else {
	            this.maxWidth = maxColWidth;
	        }
	        this.actualWidth = this.columnUtils.calculateColInitialWidth(this.colDef);
	        var suppressDotNotation = this.gridOptionsWrapper.isSuppressFieldDotNotation();
	        this.fieldContainsDots = utils_1._.exists(this.colDef.field) && this.colDef.field.indexOf('.') >= 0 && !suppressDotNotation;
	        this.tooltipFieldContainsDots = utils_1._.exists(this.colDef.tooltipField) && this.colDef.tooltipField.indexOf('.') >= 0 && !suppressDotNotation;
	        this.validate();
	    };
	    Column.prototype.isEmptyGroup = function () {
	        return false;
	    };
	    Column.prototype.isRowGroupDisplayed = function (colId) {
	        if (utils_1._.missing(this.colDef) || utils_1._.missing(this.colDef.showRowGroup)) {
	            return false;
	        }
	        var showingAllGroups = this.colDef.showRowGroup === true;
	        var showingThisGroup = this.colDef.showRowGroup === colId;
	        return showingAllGroups || showingThisGroup;
	    };
	    Column.prototype.getUniqueId = function () {
	        return this.getId();
	    };
	    Column.prototype.isPrimary = function () {
	        return this.primary;
	    };
	    Column.prototype.isFilterAllowed = function () {
	        // filter defined means it's a string, class or true.
	        // if its false, null or undefined then it's false.
	        var filterDefined = !!this.colDef.filter || !!this.colDef.filterFramework;
	        return this.primary && filterDefined;
	    };
	    Column.prototype.isFieldContainsDots = function () {
	        return this.fieldContainsDots;
	    };
	    Column.prototype.isTooltipFieldContainsDots = function () {
	        return this.tooltipFieldContainsDots;
	    };
	    Column.prototype.validate = function () {
	        var colDefAny = this.colDef;
	        if (!this.gridOptionsWrapper.isEnterprise()) {
	            var itemsNotAllowedWithoutEnterprise = ['enableRowGroup', 'rowGroup', 'rowGroupIndex', 'enablePivot', 'enableValue', 'pivot', 'pivotIndex', 'aggFunc', 'chartDataType'];
	            itemsNotAllowedWithoutEnterprise.forEach(function (item) {
	                if (utils_1._.exists(colDefAny[item])) {
	                    console.warn("ag-Grid: " + item + " is only valid in ag-Grid-Enterprise, your column definition should not have " + item);
	                }
	            });
	        }
	        if (this.gridOptionsWrapper.isTreeData()) {
	            var itemsNotAllowedWithTreeData = ['rowGroup', 'rowGroupIndex', 'pivot', 'pivotIndex'];
	            itemsNotAllowedWithTreeData.forEach(function (item) {
	                if (utils_1._.exists(colDefAny[item])) {
	                    console.warn("ag-Grid: " + item + " is not possible when doing tree data, your column definition should not have " + item);
	                }
	            });
	        }
	        if (utils_1._.exists(this.colDef.width) && typeof this.colDef.width !== 'number') {
	            console.warn('ag-Grid: colDef.width should be a number, not ' + typeof this.colDef.width);
	        }
	        if (utils_1._.get(this, 'colDef.cellRendererParams.restrictToOneGroup', null)) {
	            console.warn('ag-Grid: Since ag-grid 11.0.0 cellRendererParams.restrictToOneGroup is deprecated. You should use showRowGroup');
	        }
	        if (utils_1._.get(this, 'colDef.cellRendererParams.keyMap', null)) {
	            console.warn('ag-Grid: Since ag-grid 11.0.0 cellRendererParams.keyMap is deprecated. You should use colDef.keyCreator');
	        }
	        if (utils_1._.get(this, 'colDef.cellRendererParams.keyMap', null)) {
	            console.warn('ag-Grid: Since ag-grid 11.0.0 cellRendererParams.keyMap is deprecated. You should use colDef.keyCreator');
	        }
	        if (colDefAny.floatingCellRenderer) {
	            console.warn('ag-Grid: since v11, floatingCellRenderer is now pinnedRowCellRenderer');
	            this.colDef.pinnedRowCellRenderer = colDefAny.floatingCellRenderer;
	        }
	        if (colDefAny.floatingRendererFramework) {
	            console.warn('ag-Grid: since v11, floatingRendererFramework is now pinnedRowCellRendererFramework');
	            this.colDef.pinnedRowCellRendererFramework = colDefAny.floatingRendererFramework;
	        }
	        if (colDefAny.floatingRendererParams) {
	            console.warn('ag-Grid: since v11, floatingRendererParams is now pinnedRowCellRendererParams');
	            this.colDef.pinnedRowCellRendererParams = colDefAny.floatingRendererParams;
	        }
	        if (colDefAny.floatingValueFormatter) {
	            console.warn('ag-Grid: since v11, floatingValueFormatter is now pinnedRowValueFormatter');
	            this.colDef.pinnedRowValueFormatter = colDefAny.floatingValueFormatter;
	        }
	        if (colDefAny.cellFormatter) {
	            console.warn('ag-Grid: since v12, cellFormatter is now valueFormatter');
	            if (utils_1._.missing(this.colDef.valueFormatter)) {
	                this.colDef.valueFormatter = colDefAny.cellFormatter;
	            }
	        }
	        if (colDefAny.headerCellTemplate) {
	            console.warn('ag-Grid: since v15, headerCellTemplate is gone, use header component instead.');
	        }
	        if (colDefAny.headerCellRenderer) {
	            console.warn('ag-Grid: since v15, headerCellRenderer is gone, use header component instead.');
	        }
	        if (colDefAny.volatile) {
	            console.warn('ag-Grid: since v16, colDef.volatile is gone, please check refresh docs on how to refresh specific cells.');
	        }
	        if (colDefAny.suppressSorting) {
	            console.warn("ag-Grid: since v20, colDef.suppressSorting is gone, instead use colDef.sortable=false.", this.colDef);
	            this.colDef.sortable = false;
	        }
	        if (colDefAny.suppressFilter) {
	            console.warn("ag-Grid: since v20, colDef.suppressFilter is gone, instead use colDef.filter=false.", this.colDef);
	            this.colDef.filter = false;
	        }
	        if (colDefAny.suppressResize) {
	            console.warn("ag-Grid: since v20, colDef.suppressResize is gone, instead use colDef.resizable=false.", this.colDef);
	            this.colDef.resizable = false;
	        }
	        if (colDefAny.tooltip) {
	            console.warn("ag-Grid: since v20.1, colDef.tooltip is gone, instead use colDef.tooltipValueGetter.", this.colDef);
	            this.colDef.tooltipValueGetter = colDefAny.tooltip;
	        }
	    };
	    Column.prototype.addEventListener = function (eventType, listener) {
	        this.eventService.addEventListener(eventType, listener);
	    };
	    Column.prototype.removeEventListener = function (eventType, listener) {
	        this.eventService.removeEventListener(eventType, listener);
	    };
	    Column.prototype.createIsColumnFuncParams = function (rowNode) {
	        return {
	            node: rowNode,
	            data: rowNode.data,
	            column: this,
	            colDef: this.colDef,
	            context: this.gridOptionsWrapper.getContext(),
	            api: this.gridOptionsWrapper.getApi(),
	            columnApi: this.gridOptionsWrapper.getColumnApi()
	        };
	    };
	    Column.prototype.isSuppressNavigable = function (rowNode) {
	        // if boolean set, then just use it
	        if (typeof this.colDef.suppressNavigable === 'boolean') {
	            return this.colDef.suppressNavigable;
	        }
	        // if function, then call the function to find out
	        if (typeof this.colDef.suppressNavigable === 'function') {
	            var params = this.createIsColumnFuncParams(rowNode);
	            var userFunc = this.colDef.suppressNavigable;
	            return userFunc(params);
	        }
	        return false;
	    };
	    Column.prototype.isCellEditable = function (rowNode) {
	        // only allow editing of groups if the user has this option enabled
	        if (rowNode.group && !this.gridOptionsWrapper.isEnableGroupEdit()) {
	            return false;
	        }
	        return this.isColumnFunc(rowNode, this.colDef.editable);
	    };
	    Column.prototype.isRowDrag = function (rowNode) {
	        return this.isColumnFunc(rowNode, this.colDef.rowDrag);
	    };
	    Column.prototype.isDndSource = function (rowNode) {
	        return this.isColumnFunc(rowNode, this.colDef.dndSource);
	    };
	    Column.prototype.isCellCheckboxSelection = function (rowNode) {
	        return this.isColumnFunc(rowNode, this.colDef.checkboxSelection);
	    };
	    Column.prototype.isSuppressPaste = function (rowNode) {
	        return this.isColumnFunc(rowNode, this.colDef ? this.colDef.suppressPaste : null);
	    };
	    Column.prototype.isResizable = function () {
	        return this.colDef.resizable === true;
	    };
	    Column.prototype.isColumnFunc = function (rowNode, value) {
	        // if boolean set, then just use it
	        if (typeof value === 'boolean') {
	            return value;
	        }
	        // if function, then call the function to find out
	        if (typeof value === 'function') {
	            var params = this.createIsColumnFuncParams(rowNode);
	            var editableFunc = value;
	            return editableFunc(params);
	        }
	        return false;
	    };
	    Column.prototype.setMoving = function (moving, source) {
	        if (source === void 0) { source = "api"; }
	        this.moving = moving;
	        this.eventService.dispatchEvent(this.createColumnEvent(Column.EVENT_MOVING_CHANGED, source));
	    };
	    Column.prototype.createColumnEvent = function (type, source) {
	        return {
	            api: this.gridApi,
	            columnApi: this.columnApi,
	            type: type,
	            column: this,
	            columns: [this],
	            source: source
	        };
	    };
	    Column.prototype.isMoving = function () {
	        return this.moving;
	    };
	    Column.prototype.getSort = function () {
	        return this.sort;
	    };
	    Column.prototype.setSort = function (sort, source) {
	        if (source === void 0) { source = "api"; }
	        if (this.sort !== sort) {
	            this.sort = sort;
	            this.eventService.dispatchEvent(this.createColumnEvent(Column.EVENT_SORT_CHANGED, source));
	        }
	    };
	    Column.prototype.setMenuVisible = function (visible, source) {
	        if (source === void 0) { source = "api"; }
	        if (this.menuVisible !== visible) {
	            this.menuVisible = visible;
	            this.eventService.dispatchEvent(this.createColumnEvent(Column.EVENT_MENU_VISIBLE_CHANGED, source));
	        }
	    };
	    Column.prototype.isMenuVisible = function () {
	        return this.menuVisible;
	    };
	    Column.prototype.isSortAscending = function () {
	        return this.sort === Column.SORT_ASC;
	    };
	    Column.prototype.isSortDescending = function () {
	        return this.sort === Column.SORT_DESC;
	    };
	    Column.prototype.isSortNone = function () {
	        return utils_1._.missing(this.sort);
	    };
	    Column.prototype.isSorting = function () {
	        return utils_1._.exists(this.sort);
	    };
	    Column.prototype.getSortedAt = function () {
	        return this.sortedAt;
	    };
	    Column.prototype.setSortedAt = function (sortedAt) {
	        this.sortedAt = sortedAt;
	    };
	    Column.prototype.setAggFunc = function (aggFunc) {
	        this.aggFunc = aggFunc;
	    };
	    Column.prototype.getAggFunc = function () {
	        return this.aggFunc;
	    };
	    Column.prototype.getLeft = function () {
	        return this.left;
	    };
	    Column.prototype.getOldLeft = function () {
	        return this.oldLeft;
	    };
	    Column.prototype.getRight = function () {
	        return this.left + this.actualWidth;
	    };
	    Column.prototype.setLeft = function (left, source) {
	        if (source === void 0) { source = "api"; }
	        this.oldLeft = this.left;
	        if (this.left !== left) {
	            this.left = left;
	            this.eventService.dispatchEvent(this.createColumnEvent(Column.EVENT_LEFT_CHANGED, source));
	        }
	    };
	    Column.prototype.isFilterActive = function () {
	        return this.filterActive;
	    };
	    // additionalEventAttributes is used by provided simple floating filter, so it can add 'floatingFilter=true' to the event
	    Column.prototype.setFilterActive = function (active, source, additionalEventAttributes) {
	        if (source === void 0) { source = "api"; }
	        if (this.filterActive !== active) {
	            this.filterActive = active;
	            this.eventService.dispatchEvent(this.createColumnEvent(Column.EVENT_FILTER_ACTIVE_CHANGED, source));
	        }
	        var filterChangedEvent = this.createColumnEvent(Column.EVENT_FILTER_CHANGED, source);
	        if (additionalEventAttributes) {
	            utils_1._.mergeDeep(filterChangedEvent, additionalEventAttributes);
	        }
	        this.eventService.dispatchEvent(filterChangedEvent);
	    };
	    Column.prototype.setPinned = function (pinned) {
	        if (pinned === true || pinned === Column.PINNED_LEFT) {
	            this.pinned = Column.PINNED_LEFT;
	        }
	        else if (pinned === Column.PINNED_RIGHT) {
	            this.pinned = Column.PINNED_RIGHT;
	        }
	        else {
	            this.pinned = null;
	        }
	    };
	    Column.prototype.setFirstRightPinned = function (firstRightPinned, source) {
	        if (source === void 0) { source = "api"; }
	        if (this.firstRightPinned !== firstRightPinned) {
	            this.firstRightPinned = firstRightPinned;
	            this.eventService.dispatchEvent(this.createColumnEvent(Column.EVENT_FIRST_RIGHT_PINNED_CHANGED, source));
	        }
	    };
	    Column.prototype.setLastLeftPinned = function (lastLeftPinned, source) {
	        if (source === void 0) { source = "api"; }
	        if (this.lastLeftPinned !== lastLeftPinned) {
	            this.lastLeftPinned = lastLeftPinned;
	            this.eventService.dispatchEvent(this.createColumnEvent(Column.EVENT_LAST_LEFT_PINNED_CHANGED, source));
	        }
	    };
	    Column.prototype.isFirstRightPinned = function () {
	        return this.firstRightPinned;
	    };
	    Column.prototype.isLastLeftPinned = function () {
	        return this.lastLeftPinned;
	    };
	    Column.prototype.isPinned = function () {
	        return this.pinned === Column.PINNED_LEFT || this.pinned === Column.PINNED_RIGHT;
	    };
	    Column.prototype.isPinnedLeft = function () {
	        return this.pinned === Column.PINNED_LEFT;
	    };
	    Column.prototype.isPinnedRight = function () {
	        return this.pinned === Column.PINNED_RIGHT;
	    };
	    Column.prototype.getPinned = function () {
	        return this.pinned;
	    };
	    Column.prototype.setVisible = function (visible, source) {
	        if (source === void 0) { source = "api"; }
	        var newValue = visible === true;
	        if (this.visible !== newValue) {
	            this.visible = newValue;
	            this.eventService.dispatchEvent(this.createColumnEvent(Column.EVENT_VISIBLE_CHANGED, source));
	        }
	    };
	    Column.prototype.isVisible = function () {
	        return this.visible;
	    };
	    Column.prototype.getColDef = function () {
	        return this.colDef;
	    };
	    Column.prototype.getColumnGroupShow = function () {
	        return this.colDef.columnGroupShow;
	    };
	    Column.prototype.getColId = function () {
	        return this.colId;
	    };
	    Column.prototype.getId = function () {
	        return this.getColId();
	    };
	    Column.prototype.getDefinition = function () {
	        return this.colDef;
	    };
	    Column.prototype.getActualWidth = function () {
	        return this.actualWidth;
	    };
	    Column.prototype.createBaseColDefParams = function (rowNode) {
	        var params = {
	            node: rowNode,
	            data: rowNode.data,
	            colDef: this.colDef,
	            column: this,
	            api: this.gridOptionsWrapper.getApi(),
	            columnApi: this.gridOptionsWrapper.getColumnApi(),
	            context: this.gridOptionsWrapper.getContext()
	        };
	        return params;
	    };
	    Column.prototype.getColSpan = function (rowNode) {
	        if (utils_1._.missing(this.colDef.colSpan)) {
	            return 1;
	        }
	        var params = this.createBaseColDefParams(rowNode);
	        var colSpan = this.colDef.colSpan(params);
	        // colSpan must be number equal to or greater than 1
	        return Math.max(colSpan, 1);
	    };
	    Column.prototype.getRowSpan = function (rowNode) {
	        if (utils_1._.missing(this.colDef.rowSpan)) {
	            return 1;
	        }
	        var params = this.createBaseColDefParams(rowNode);
	        var rowSpan = this.colDef.rowSpan(params);
	        // rowSpan must be number equal to or greater than 1
	        return Math.max(rowSpan, 1);
	    };
	    Column.prototype.setActualWidth = function (actualWidth, source) {
	        if (source === void 0) { source = "api"; }
	        if (this.actualWidth !== actualWidth) {
	            this.actualWidth = actualWidth;
	            this.eventService.dispatchEvent(this.createColumnEvent(Column.EVENT_WIDTH_CHANGED, source));
	        }
	    };
	    Column.prototype.isGreaterThanMax = function (width) {
	        if (this.maxWidth) {
	            return width > this.maxWidth;
	        }
	        return false;
	    };
	    Column.prototype.getMinWidth = function () {
	        return this.minWidth;
	    };
	    Column.prototype.getMaxWidth = function () {
	        return this.maxWidth;
	    };
	    Column.prototype.setMinimum = function (source) {
	        if (source === void 0) { source = "api"; }
	        this.setActualWidth(this.minWidth, source);
	    };
	    Column.prototype.setRowGroupActive = function (rowGroup, source) {
	        if (source === void 0) { source = "api"; }
	        if (this.rowGroupActive !== rowGroup) {
	            this.rowGroupActive = rowGroup;
	            this.eventService.dispatchEvent(this.createColumnEvent(Column.EVENT_ROW_GROUP_CHANGED, source));
	        }
	    };
	    Column.prototype.isRowGroupActive = function () {
	        return this.rowGroupActive;
	    };
	    Column.prototype.setPivotActive = function (pivot, source) {
	        if (source === void 0) { source = "api"; }
	        if (this.pivotActive !== pivot) {
	            this.pivotActive = pivot;
	            this.eventService.dispatchEvent(this.createColumnEvent(Column.EVENT_PIVOT_CHANGED, source));
	        }
	    };
	    Column.prototype.isPivotActive = function () {
	        return this.pivotActive;
	    };
	    Column.prototype.isAnyFunctionActive = function () {
	        return this.isPivotActive() || this.isRowGroupActive() || this.isValueActive();
	    };
	    Column.prototype.isAnyFunctionAllowed = function () {
	        return this.isAllowPivot() || this.isAllowRowGroup() || this.isAllowValue();
	    };
	    Column.prototype.setValueActive = function (value, source) {
	        if (source === void 0) { source = "api"; }
	        if (this.aggregationActive !== value) {
	            this.aggregationActive = value;
	            this.eventService.dispatchEvent(this.createColumnEvent(Column.EVENT_VALUE_CHANGED, source));
	        }
	    };
	    Column.prototype.isValueActive = function () {
	        return this.aggregationActive;
	    };
	    Column.prototype.isAllowPivot = function () {
	        return this.colDef.enablePivot === true;
	    };
	    Column.prototype.isAllowValue = function () {
	        return this.colDef.enableValue === true;
	    };
	    Column.prototype.isAllowRowGroup = function () {
	        return this.colDef.enableRowGroup === true;
	    };
	    Column.prototype.getMenuTabs = function (defaultValues) {
	        var menuTabs = this.getColDef().menuTabs;
	        if (menuTabs == null) {
	            menuTabs = defaultValues;
	        }
	        return menuTabs;
	    };
	    // this used to be needed, as previous version of ag-grid had lockPosition as column state,
	    // so couldn't depend on colDef version.
	    Column.prototype.isLockPosition = function () {
	        console.warn('ag-Grid: since v21, col.isLockPosition() should not be used, please use col.getColDef().lockPosition instead.');
	        return this.colDef ? !!this.colDef.lockPosition : false;
	    };
	    // this used to be needed, as previous version of ag-grid had lockVisible as column state,
	    // so couldn't depend on colDef version.
	    Column.prototype.isLockVisible = function () {
	        console.warn('ag-Grid: since v21, col.isLockVisible() should not be used, please use col.getColDef().lockVisible instead.');
	        return this.colDef ? !!this.colDef.lockVisible : false;
	    };
	    // this used to be needed, as previous version of ag-grid had lockPinned as column state,
	    // so couldn't depend on colDef version.
	    Column.prototype.isLockPinned = function () {
	        console.warn('ag-Grid: since v21, col.isLockPinned() should not be used, please use col.getColDef().lockPinned instead.');
	        return this.colDef ? !!this.colDef.lockPinned : false;
	    };
	    // + renderedHeaderCell - for making header cell transparent when moving
	    Column.EVENT_MOVING_CHANGED = 'movingChanged';
	    // + renderedCell - changing left position
	    Column.EVENT_LEFT_CHANGED = 'leftChanged';
	    // + renderedCell - changing width
	    Column.EVENT_WIDTH_CHANGED = 'widthChanged';
	    // + renderedCell - for changing pinned classes
	    Column.EVENT_LAST_LEFT_PINNED_CHANGED = 'lastLeftPinnedChanged';
	    Column.EVENT_FIRST_RIGHT_PINNED_CHANGED = 'firstRightPinnedChanged';
	    // + renderedColumn - for changing visibility icon
	    Column.EVENT_VISIBLE_CHANGED = 'visibleChanged';
	    // + every time the filter changes, used in the floating filters
	    Column.EVENT_FILTER_CHANGED = 'filterChanged';
	    // + renderedHeaderCell - marks the header with filter icon
	    Column.EVENT_FILTER_ACTIVE_CHANGED = 'filterActiveChanged';
	    // + renderedHeaderCell - marks the header with sort icon
	    Column.EVENT_SORT_CHANGED = 'sortChanged';
	    Column.EVENT_MENU_VISIBLE_CHANGED = 'menuVisibleChanged';
	    // + toolpanel, for gui updates
	    Column.EVENT_ROW_GROUP_CHANGED = 'columnRowGroupChanged';
	    // + toolpanel, for gui updates
	    Column.EVENT_PIVOT_CHANGED = 'columnPivotChanged';
	    // + toolpanel, for gui updates
	    Column.EVENT_VALUE_CHANGED = 'columnValueChanged';
	    Column.PINNED_RIGHT = 'right';
	    Column.PINNED_LEFT = 'left';
	    Column.SORT_ASC = 'asc';
	    Column.SORT_DESC = 'desc';
	    __decorate([
	        context_1.Autowired('gridOptionsWrapper'),
	        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
	    ], Column.prototype, "gridOptionsWrapper", void 0);
	    __decorate([
	        context_1.Autowired('columnUtils'),
	        __metadata("design:type", columnUtils_1.ColumnUtils)
	    ], Column.prototype, "columnUtils", void 0);
	    __decorate([
	        context_1.Autowired('columnApi'),
	        __metadata("design:type", columnApi_1.ColumnApi)
	    ], Column.prototype, "columnApi", void 0);
	    __decorate([
	        context_1.Autowired('gridApi'),
	        __metadata("design:type", gridApi_1.GridApi)
	    ], Column.prototype, "gridApi", void 0);
	    __decorate([
	        context_1.PostConstruct,
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", []),
	        __metadata("design:returntype", void 0)
	    ], Column.prototype, "initialise", null);
	    return Column;
	}());
	exports.Column = Column;


/***/ }),
/* 2344 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var gridOptionsWrapper_1 = __webpack_require__(2324);
	var columnGroup_1 = __webpack_require__(2342);
	var originalColumnGroup_1 = __webpack_require__(2345);
	var context_1 = __webpack_require__(2333);
	var context_2 = __webpack_require__(2333);
	// takes in a list of columns, as specified by the column definitions, and returns column groups
	var ColumnUtils = /** @class */ (function () {
	    function ColumnUtils() {
	    }
	    ColumnUtils.prototype.calculateColInitialWidth = function (colDef) {
	        if (!colDef.width) {
	            // if no width defined in colDef, use default
	            return this.gridOptionsWrapper.getColWidth();
	        }
	        else if (colDef.width < this.gridOptionsWrapper.getMinColWidth()) {
	            // if width in col def to small, set to min width
	            return this.gridOptionsWrapper.getMinColWidth();
	        }
	        else {
	            // otherwise use the provided width
	            return colDef.width;
	        }
	    };
	    ColumnUtils.prototype.getOriginalPathForColumn = function (column, originalBalancedTree) {
	        var result = [];
	        var found = false;
	        recursePath(originalBalancedTree, 0);
	        // we should always find the path, but in case there is a bug somewhere, returning null
	        // will make it fail rather than provide a 'hard to track down' bug
	        if (found) {
	            return result;
	        }
	        else {
	            return null;
	        }
	        function recursePath(balancedColumnTree, dept) {
	            for (var i = 0; i < balancedColumnTree.length; i++) {
	                if (found) {
	                    // quit the search, so 'result' is kept with the found result
	                    return;
	                }
	                var node = balancedColumnTree[i];
	                if (node instanceof originalColumnGroup_1.OriginalColumnGroup) {
	                    var nextNode = node;
	                    recursePath(nextNode.getChildren(), dept + 1);
	                    result[dept] = node;
	                }
	                else {
	                    if (node === column) {
	                        found = true;
	                    }
	                }
	            }
	        }
	    };
	    /*    public getPathForColumn(column: Column, allDisplayedColumnGroups: ColumnGroupChild[]): ColumnGroup[] {
	            let result: ColumnGroup[] = [];
	            let found = false;
	    
	            recursePath(allDisplayedColumnGroups, 0);
	    
	            // we should always find the path, but in case there is a bug somewhere, returning null
	            // will make it fail rather than provide a 'hard to track down' bug
	            if (found) {
	                return result;
	            } else {
	                return null;
	            }
	    
	            function recursePath(balancedColumnTree: ColumnGroupChild[], dept: number): void {
	    
	                for (let i = 0; i<balancedColumnTree.length; i++) {
	                    if (found) {
	                        // quit the search, so 'result' is kept with the found result
	                        return;
	                    }
	                    let node = balancedColumnTree[i];
	                    if (node instanceof ColumnGroup) {
	                        let nextNode = <ColumnGroup> node;
	                        recursePath(nextNode.getChildren(), dept+1);
	                        result[dept] = node;
	                    } else {
	                        if (node === column) {
	                            found = true;
	                        }
	                    }
	                }
	            }
	        }*/
	    ColumnUtils.prototype.depthFirstOriginalTreeSearch = function (parent, tree, callback) {
	        var _this = this;
	        if (!tree) {
	            return;
	        }
	        tree.forEach(function (child) {
	            if (child instanceof originalColumnGroup_1.OriginalColumnGroup) {
	                _this.depthFirstOriginalTreeSearch(child, child.getChildren(), callback);
	            }
	            callback(child, parent);
	        });
	    };
	    ColumnUtils.prototype.depthFirstAllColumnTreeSearch = function (tree, callback) {
	        var _this = this;
	        if (!tree) {
	            return;
	        }
	        tree.forEach(function (child) {
	            if (child instanceof columnGroup_1.ColumnGroup) {
	                _this.depthFirstAllColumnTreeSearch(child.getChildren(), callback);
	            }
	            callback(child);
	        });
	    };
	    ColumnUtils.prototype.depthFirstDisplayedColumnTreeSearch = function (tree, callback) {
	        var _this = this;
	        if (!tree) {
	            return;
	        }
	        tree.forEach(function (child) {
	            if (child instanceof columnGroup_1.ColumnGroup) {
	                _this.depthFirstDisplayedColumnTreeSearch(child.getDisplayedChildren(), callback);
	            }
	            callback(child);
	        });
	    };
	    __decorate([
	        context_2.Autowired('gridOptionsWrapper'),
	        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
	    ], ColumnUtils.prototype, "gridOptionsWrapper", void 0);
	    ColumnUtils = __decorate([
	        context_1.Bean('columnUtils')
	    ], ColumnUtils);
	    return ColumnUtils;
	}());
	exports.ColumnUtils = ColumnUtils;


/***/ }),
/* 2345 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var columnGroup_1 = __webpack_require__(2342);
	var column_1 = __webpack_require__(2343);
	var eventService_1 = __webpack_require__(2331);
	var OriginalColumnGroup = /** @class */ (function () {
	    function OriginalColumnGroup(colGroupDef, groupId, padding, level) {
	        this.localEventService = new eventService_1.EventService();
	        this.expandable = false;
	        this.colGroupDef = colGroupDef;
	        this.groupId = groupId;
	        this.expanded = colGroupDef && !!colGroupDef.openByDefault;
	        this.padding = padding;
	        this.level = level;
	    }
	    OriginalColumnGroup.prototype.setOriginalParent = function (originalParent) {
	        this.originalParent = this.originalParent;
	    };
	    OriginalColumnGroup.prototype.getOriginalParent = function () {
	        return this.originalParent;
	    };
	    OriginalColumnGroup.prototype.getLevel = function () {
	        return this.level;
	    };
	    OriginalColumnGroup.prototype.isVisible = function () {
	        // return true if at least one child is visible
	        if (this.children) {
	            return this.children.some(function (child) { return child.isVisible(); });
	        }
	        return false;
	    };
	    OriginalColumnGroup.prototype.isPadding = function () {
	        return this.padding;
	    };
	    OriginalColumnGroup.prototype.setExpanded = function (expanded) {
	        this.expanded = expanded === undefined ? false : expanded;
	        var event = {
	            type: OriginalColumnGroup.EVENT_EXPANDED_CHANGED
	        };
	        this.localEventService.dispatchEvent(event);
	    };
	    OriginalColumnGroup.prototype.isExpandable = function () {
	        return this.expandable;
	    };
	    OriginalColumnGroup.prototype.isExpanded = function () {
	        return this.expanded;
	    };
	    OriginalColumnGroup.prototype.getGroupId = function () {
	        return this.groupId;
	    };
	    OriginalColumnGroup.prototype.getId = function () {
	        return this.getGroupId();
	    };
	    OriginalColumnGroup.prototype.setChildren = function (children) {
	        this.children = children;
	    };
	    OriginalColumnGroup.prototype.getChildren = function () {
	        return this.children;
	    };
	    OriginalColumnGroup.prototype.getColGroupDef = function () {
	        return this.colGroupDef;
	    };
	    OriginalColumnGroup.prototype.getLeafColumns = function () {
	        var result = [];
	        this.addLeafColumns(result);
	        return result;
	    };
	    OriginalColumnGroup.prototype.addLeafColumns = function (leafColumns) {
	        if (!this.children) {
	            return;
	        }
	        this.children.forEach(function (child) {
	            if (child instanceof column_1.Column) {
	                leafColumns.push(child);
	            }
	            else if (child instanceof OriginalColumnGroup) {
	                child.addLeafColumns(leafColumns);
	            }
	        });
	    };
	    OriginalColumnGroup.prototype.getColumnGroupShow = function () {
	        return this.padding ? columnGroup_1.ColumnGroup.HEADER_GROUP_PADDING : this.colGroupDef.columnGroupShow;
	    };
	    // need to check that this group has at least one col showing when both expanded and contracted.
	    // if not, then we don't allow expanding and contracting on this group
	    OriginalColumnGroup.prototype.setupExpandable = function () {
	        var _this = this;
	        this.setExpandable();
	        // note - we should be removing this event listener
	        this.getLeafColumns().forEach(function (col) { return col.addEventListener(column_1.Column.EVENT_VISIBLE_CHANGED, _this.onColumnVisibilityChanged.bind(_this)); });
	    };
	    OriginalColumnGroup.prototype.setExpandable = function () {
	        if (this.isPadding()) {
	            return;
	        }
	        // want to make sure the group doesn't disappear when it's open
	        var atLeastOneShowingWhenOpen = false;
	        // want to make sure the group doesn't disappear when it's closed
	        var atLeastOneShowingWhenClosed = false;
	        // want to make sure the group has something to show / hide
	        var atLeastOneChangeable = false;
	        var children = this.findChildren();
	        for (var i = 0, j = children.length; i < j; i++) {
	            var abstractColumn = children[i];
	            if (!abstractColumn.isVisible()) {
	                continue;
	            }
	            // if the abstractColumn is a grid generated group, there will be no colDef
	            var headerGroupShow = abstractColumn.getColumnGroupShow();
	            if (headerGroupShow === columnGroup_1.ColumnGroup.HEADER_GROUP_SHOW_OPEN) {
	                atLeastOneShowingWhenOpen = true;
	                atLeastOneChangeable = true;
	            }
	            else if (headerGroupShow === columnGroup_1.ColumnGroup.HEADER_GROUP_SHOW_CLOSED) {
	                atLeastOneShowingWhenClosed = true;
	                atLeastOneChangeable = true;
	            }
	            else {
	                atLeastOneShowingWhenOpen = true;
	                atLeastOneShowingWhenClosed = true;
	                if (headerGroupShow === columnGroup_1.ColumnGroup.HEADER_GROUP_PADDING) {
	                    var column = abstractColumn;
	                    atLeastOneChangeable = column.children.some(function (child) { return child.getColumnGroupShow() !== undefined; });
	                }
	            }
	        }
	        var expandable = atLeastOneShowingWhenOpen && atLeastOneShowingWhenClosed && atLeastOneChangeable;
	        if (this.expandable !== expandable) {
	            this.expandable = expandable;
	            var event_1 = {
	                type: OriginalColumnGroup.EVENT_EXPANDABLE_CHANGED
	            };
	            this.localEventService.dispatchEvent(event_1);
	        }
	    };
	    OriginalColumnGroup.prototype.findChildren = function () {
	        var children = this.children;
	        var firstChild = children[0];
	        if (firstChild && (!firstChild.isPadding || !firstChild.isPadding())) {
	            return children;
	        }
	        while (children.length === 1 && children[0] instanceof OriginalColumnGroup) {
	            children = children[0].children;
	        }
	        return children;
	    };
	    OriginalColumnGroup.prototype.onColumnVisibilityChanged = function () {
	        this.setExpandable();
	    };
	    OriginalColumnGroup.prototype.addEventListener = function (eventType, listener) {
	        this.localEventService.addEventListener(eventType, listener);
	    };
	    OriginalColumnGroup.prototype.removeEventListener = function (eventType, listener) {
	        this.localEventService.removeEventListener(eventType, listener);
	    };
	    OriginalColumnGroup.EVENT_EXPANDED_CHANGED = 'expandedChanged';
	    OriginalColumnGroup.EVENT_EXPANDABLE_CHANGED = 'expandableChanged';
	    return OriginalColumnGroup;
	}());
	exports.OriginalColumnGroup = OriginalColumnGroup;


/***/ }),
/* 2346 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var columnController_1 = __webpack_require__(2341);
	var context_1 = __webpack_require__(2333);
	var ColumnApi = /** @class */ (function () {
	    function ColumnApi() {
	    }
	    ColumnApi.prototype.sizeColumnsToFit = function (gridWidth) { this.columnController.sizeColumnsToFit(gridWidth, 'api'); };
	    ColumnApi.prototype.setColumnGroupOpened = function (group, newValue) { this.columnController.setColumnGroupOpened(group, newValue, 'api'); };
	    ColumnApi.prototype.getColumnGroup = function (name, instanceId) { return this.columnController.getColumnGroup(name, instanceId); };
	    ColumnApi.prototype.getOriginalColumnGroup = function (name) { return this.columnController.getOriginalColumnGroup(name); };
	    ColumnApi.prototype.getDisplayNameForColumn = function (column, location) { return this.columnController.getDisplayNameForColumn(column, location); };
	    ColumnApi.prototype.getDisplayNameForColumnGroup = function (columnGroup, location) { return this.columnController.getDisplayNameForColumnGroup(columnGroup, location); };
	    ColumnApi.prototype.getColumn = function (key) { return this.columnController.getPrimaryColumn(key); };
	    ColumnApi.prototype.setColumnState = function (columnState) { return this.columnController.setColumnState(columnState, false, 'api'); };
	    ColumnApi.prototype.getColumnState = function () { return this.columnController.getColumnState(); };
	    ColumnApi.prototype.resetColumnState = function () { this.columnController.resetColumnState(false, 'api'); };
	    ColumnApi.prototype.getColumnGroupState = function () { return this.columnController.getColumnGroupState(); };
	    ColumnApi.prototype.setColumnGroupState = function (stateItems) { this.columnController.setColumnGroupState(stateItems, 'api'); };
	    ColumnApi.prototype.resetColumnGroupState = function () { this.columnController.resetColumnGroupState('api'); };
	    ColumnApi.prototype.isPinning = function () { return this.columnController.isPinningLeft() || this.columnController.isPinningRight(); };
	    ColumnApi.prototype.isPinningLeft = function () { return this.columnController.isPinningLeft(); };
	    ColumnApi.prototype.isPinningRight = function () { return this.columnController.isPinningRight(); };
	    ColumnApi.prototype.getDisplayedColAfter = function (col) { return this.columnController.getDisplayedColAfter(col); };
	    ColumnApi.prototype.getDisplayedColBefore = function (col) { return this.columnController.getDisplayedColBefore(col); };
	    ColumnApi.prototype.setColumnVisible = function (key, visible) { this.columnController.setColumnVisible(key, visible, 'api'); };
	    ColumnApi.prototype.setColumnsVisible = function (keys, visible) { this.columnController.setColumnsVisible(keys, visible, 'api'); };
	    ColumnApi.prototype.setColumnPinned = function (key, pinned) { this.columnController.setColumnPinned(key, pinned, 'api'); };
	    ColumnApi.prototype.setColumnsPinned = function (keys, pinned) { this.columnController.setColumnsPinned(keys, pinned, 'api'); };
	    ColumnApi.prototype.getAllColumns = function () { return this.columnController.getAllPrimaryColumns(); };
	    ColumnApi.prototype.getAllGridColumns = function () { return this.columnController.getAllGridColumns(); };
	    ColumnApi.prototype.getDisplayedLeftColumns = function () { return this.columnController.getDisplayedLeftColumns(); };
	    ColumnApi.prototype.getDisplayedCenterColumns = function () { return this.columnController.getDisplayedCenterColumns(); };
	    ColumnApi.prototype.getDisplayedRightColumns = function () { return this.columnController.getDisplayedRightColumns(); };
	    ColumnApi.prototype.getAllDisplayedColumns = function () { return this.columnController.getAllDisplayedColumns(); };
	    ColumnApi.prototype.getAllDisplayedVirtualColumns = function () { return this.columnController.getAllDisplayedVirtualColumns(); };
	    ColumnApi.prototype.moveColumn = function (key, toIndex) {
	        if (typeof key === 'number') {
	            // moveColumn used to take indexes, so this is advising user who hasn't moved to new method name
	            console.warn('ag-Grid: you are using moveColumn(fromIndex, toIndex) - moveColumn takes a column key and a destination index, not two indexes, to move with indexes use moveColumnByIndex(from,to) instead');
	            this.columnController.moveColumnByIndex(key, toIndex, 'api');
	        }
	        else {
	            this.columnController.moveColumn(key, toIndex, 'api');
	        }
	    };
	    ColumnApi.prototype.moveColumnByIndex = function (fromIndex, toIndex) { this.columnController.moveColumnByIndex(fromIndex, toIndex, 'api'); };
	    ColumnApi.prototype.moveColumns = function (columnsToMoveKeys, toIndex) { this.columnController.moveColumns(columnsToMoveKeys, toIndex, 'api'); };
	    ColumnApi.prototype.moveRowGroupColumn = function (fromIndex, toIndex) { this.columnController.moveRowGroupColumn(fromIndex, toIndex); };
	    ColumnApi.prototype.setColumnAggFunc = function (column, aggFunc) { this.columnController.setColumnAggFunc(column, aggFunc); };
	    ColumnApi.prototype.setColumnWidth = function (key, newWidth, finished) {
	        if (finished === void 0) { finished = true; }
	        this.columnController.setColumnWidth(key, newWidth, false, finished);
	    };
	    ColumnApi.prototype.setPivotMode = function (pivotMode) { this.columnController.setPivotMode(pivotMode); };
	    ColumnApi.prototype.isPivotMode = function () { return this.columnController.isPivotMode(); };
	    ColumnApi.prototype.getSecondaryPivotColumn = function (pivotKeys, valueColKey) { return this.columnController.getSecondaryPivotColumn(pivotKeys, valueColKey); };
	    ColumnApi.prototype.setValueColumns = function (colKeys) { this.columnController.setValueColumns(colKeys, 'api'); };
	    ColumnApi.prototype.getValueColumns = function () { return this.columnController.getValueColumns(); };
	    ColumnApi.prototype.removeValueColumn = function (colKey) { this.columnController.removeValueColumn(colKey, 'api'); };
	    ColumnApi.prototype.removeValueColumns = function (colKeys) { this.columnController.removeValueColumns(colKeys, 'api'); };
	    ColumnApi.prototype.addValueColumn = function (colKey) { this.columnController.addValueColumn(colKey, 'api'); };
	    ColumnApi.prototype.addValueColumns = function (colKeys) { this.columnController.addValueColumns(colKeys, 'api'); };
	    ColumnApi.prototype.setRowGroupColumns = function (colKeys) { this.columnController.setRowGroupColumns(colKeys, 'api'); };
	    ColumnApi.prototype.removeRowGroupColumn = function (colKey) { this.columnController.removeRowGroupColumn(colKey, 'api'); };
	    ColumnApi.prototype.removeRowGroupColumns = function (colKeys) { this.columnController.removeRowGroupColumns(colKeys, 'api'); };
	    ColumnApi.prototype.addRowGroupColumn = function (colKey) { this.columnController.addRowGroupColumn(colKey, 'api'); };
	    ColumnApi.prototype.addRowGroupColumns = function (colKeys) { this.columnController.addRowGroupColumns(colKeys, 'api'); };
	    ColumnApi.prototype.getRowGroupColumns = function () { return this.columnController.getRowGroupColumns(); };
	    ColumnApi.prototype.setPivotColumns = function (colKeys) { this.columnController.setPivotColumns(colKeys, 'api'); };
	    ColumnApi.prototype.removePivotColumn = function (colKey) { this.columnController.removePivotColumn(colKey, 'api'); };
	    ColumnApi.prototype.removePivotColumns = function (colKeys) { this.columnController.removePivotColumns(colKeys, 'api'); };
	    ColumnApi.prototype.addPivotColumn = function (colKey) { this.columnController.addPivotColumn(colKey, 'api'); };
	    ColumnApi.prototype.addPivotColumns = function (colKeys) { this.columnController.addPivotColumns(colKeys, 'api'); };
	    ColumnApi.prototype.getPivotColumns = function () { return this.columnController.getPivotColumns(); };
	    ColumnApi.prototype.getLeftDisplayedColumnGroups = function () { return this.columnController.getLeftDisplayedColumnGroups(); };
	    ColumnApi.prototype.getCenterDisplayedColumnGroups = function () { return this.columnController.getCenterDisplayedColumnGroups(); };
	    ColumnApi.prototype.getRightDisplayedColumnGroups = function () { return this.columnController.getRightDisplayedColumnGroups(); };
	    ColumnApi.prototype.getAllDisplayedColumnGroups = function () { return this.columnController.getAllDisplayedColumnGroups(); };
	    ColumnApi.prototype.autoSizeColumn = function (key) { return this.columnController.autoSizeColumn(key, 'api'); };
	    ColumnApi.prototype.autoSizeColumns = function (keys) { return this.columnController.autoSizeColumns(keys, 'api'); };
	    ColumnApi.prototype.autoSizeAllColumns = function () { this.columnController.autoSizeAllColumns('api'); };
	    ColumnApi.prototype.setSecondaryColumns = function (colDefs) { this.columnController.setSecondaryColumns(colDefs, 'api'); };
	    ColumnApi.prototype.getSecondaryColumns = function () { return this.columnController.getSecondaryColumns(); };
	    ColumnApi.prototype.getPrimaryColumns = function () { return this.columnController.getAllPrimaryColumns(); };
	    // below goes through deprecated items, prints message to user, then calls the new version of the same method
	    ColumnApi.prototype.columnGroupOpened = function (group, newValue) {
	        console.error('ag-Grid: columnGroupOpened no longer exists, use setColumnGroupOpened');
	        this.setColumnGroupOpened(group, newValue);
	    };
	    ColumnApi.prototype.hideColumns = function (colIds, hide) {
	        console.error('ag-Grid: hideColumns is deprecated, use setColumnsVisible');
	        this.columnController.setColumnsVisible(colIds, !hide, 'api');
	    };
	    ColumnApi.prototype.hideColumn = function (colId, hide) {
	        console.error('ag-Grid: hideColumn is deprecated, use setColumnVisible');
	        this.columnController.setColumnVisible(colId, !hide, 'api');
	    };
	    ColumnApi.prototype.setState = function (columnState) {
	        console.error('ag-Grid: setState is deprecated, use setColumnState');
	        return this.setColumnState(columnState);
	    };
	    ColumnApi.prototype.getState = function () {
	        console.error('ag-Grid: getState is deprecated, use getColumnState');
	        return this.getColumnState();
	    };
	    ColumnApi.prototype.resetState = function () {
	        console.error('ag-Grid: resetState is deprecated, use resetColumnState');
	        this.resetColumnState();
	    };
	    ColumnApi.prototype.getAggregationColumns = function () {
	        console.error('ag-Grid: getAggregationColumns is deprecated, use getValueColumns');
	        return this.columnController.getValueColumns();
	    };
	    ColumnApi.prototype.removeAggregationColumn = function (colKey) {
	        console.error('ag-Grid: removeAggregationColumn is deprecated, use removeValueColumn');
	        this.columnController.removeValueColumn(colKey, 'api');
	    };
	    ColumnApi.prototype.removeAggregationColumns = function (colKeys) {
	        console.error('ag-Grid: removeAggregationColumns is deprecated, use removeValueColumns');
	        this.columnController.removeValueColumns(colKeys, 'api');
	    };
	    ColumnApi.prototype.addAggregationColumn = function (colKey) {
	        console.error('ag-Grid: addAggregationColumn is deprecated, use addValueColumn');
	        this.columnController.addValueColumn(colKey, 'api');
	    };
	    ColumnApi.prototype.addAggregationColumns = function (colKeys) {
	        console.error('ag-Grid: addAggregationColumns is deprecated, use addValueColumns');
	        this.columnController.addValueColumns(colKeys, 'api');
	    };
	    ColumnApi.prototype.setColumnAggFunction = function (column, aggFunc) {
	        console.error('ag-Grid: setColumnAggFunction is deprecated, use setColumnAggFunc');
	        this.columnController.setColumnAggFunc(column, aggFunc, 'api');
	    };
	    ColumnApi.prototype.getDisplayNameForCol = function (column) {
	        console.error('ag-Grid: getDisplayNameForCol is deprecated, use getDisplayNameForColumn');
	        return this.getDisplayNameForColumn(column, null);
	    };
	    __decorate([
	        context_1.Autowired('columnController'),
	        __metadata("design:type", columnController_1.ColumnController)
	    ], ColumnApi.prototype, "columnController", void 0);
	    ColumnApi = __decorate([
	        context_1.Bean('columnApi')
	    ], ColumnApi);
	    return ColumnApi;
	}());
	exports.ColumnApi = ColumnApi;


/***/ }),
/* 2347 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var __param = (this && this.__param) || function (paramIndex, decorator) {
	    return function (target, key) { decorator(target, key, paramIndex); }
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var logger_1 = __webpack_require__(2332);
	var context_1 = __webpack_require__(2333);
	var context_2 = __webpack_require__(2333);
	var ExpressionService = /** @class */ (function () {
	    function ExpressionService() {
	        this.expressionToFunctionCache = {};
	    }
	    ExpressionService.prototype.setBeans = function (loggerFactory) {
	        this.logger = loggerFactory.create('ExpressionService');
	    };
	    ExpressionService.prototype.evaluate = function (expressionOrFunc, params) {
	        if (typeof expressionOrFunc === 'function') {
	            // valueGetter is a function, so just call it
	            var func = expressionOrFunc;
	            return func(params);
	        }
	        else if (typeof expressionOrFunc === 'string') {
	            // valueGetter is an expression, so execute the expression
	            var expression = expressionOrFunc;
	            return this.evaluateExpression(expression, params);
	        }
	        else {
	            console.error('ag-Grid: value should be either a string or a function', expressionOrFunc);
	        }
	    };
	    ExpressionService.prototype.evaluateExpression = function (expression, params) {
	        try {
	            var javaScriptFunction = this.createExpressionFunction(expression);
	            // the params don't have all these values, rather we add every possible
	            // value a params can have, which makes whatever is in the params available.
	            var result = javaScriptFunction(params.value, params.context, params.oldValue, params.newValue, params.value, params.node, params.data, params.colDef, params.rowIndex, params.api, params.columnApi, params.getValue, params.column, params.columnGroup);
	            return result;
	        }
	        catch (e) {
	            // the expression failed, which can happen, as it's the client that
	            // provides the expression. so print a nice message
	            // tslint:disable-next-line
	            console.log('Processing of the expression failed');
	            // tslint:disable-next-line
	            console.log('Expression = ' + expression);
	            // tslint:disable-next-line
	            console.log('Exception = ' + e);
	            return null;
	        }
	    };
	    ExpressionService.prototype.createExpressionFunction = function (expression) {
	        // check cache first
	        if (this.expressionToFunctionCache[expression]) {
	            return this.expressionToFunctionCache[expression];
	        }
	        // if not found in cache, return the function
	        var functionBody = this.createFunctionBody(expression);
	        var theFunction = new Function('x, ctx, oldValue, newValue, value, node, data, colDef, rowIndex, api, columnApi, getValue, column, columnGroup', functionBody);
	        // store in cache
	        this.expressionToFunctionCache[expression] = theFunction;
	        return theFunction;
	    };
	    ExpressionService.prototype.createFunctionBody = function (expression) {
	        // if the expression has the 'return' word in it, then use as is,
	        // if not, then wrap it with return and ';' to make a function
	        if (expression.indexOf('return') >= 0) {
	            return expression;
	        }
	        else {
	            return 'return ' + expression + ';';
	        }
	    };
	    __decorate([
	        __param(0, context_2.Qualifier('loggerFactory')),
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", [logger_1.LoggerFactory]),
	        __metadata("design:returntype", void 0)
	    ], ExpressionService.prototype, "setBeans", null);
	    ExpressionService = __decorate([
	        context_1.Bean('expressionService')
	    ], ExpressionService);
	    return ExpressionService;
	}());
	exports.ExpressionService = ExpressionService;


/***/ }),
/* 2348 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var context_1 = __webpack_require__(2333);
	var columnUtils_1 = __webpack_require__(2344);
	var columnGroup_1 = __webpack_require__(2342);
	var originalColumnGroup_1 = __webpack_require__(2345);
	var context_2 = __webpack_require__(2333);
	var utils_1 = __webpack_require__(2325);
	// takes in a list of columns, as specified by the column definitions, and returns column groups
	var DisplayedGroupCreator = /** @class */ (function () {
	    function DisplayedGroupCreator() {
	    }
	    DisplayedGroupCreator.prototype.createDisplayedGroups = function (
	    // all displayed columns sorted - this is the columns the grid should show
	    sortedVisibleColumns, 
	    // the tree of columns, as provided by the users, used to know what groups columns roll up into
	    balancedColumnTree, 
	    // creates unique id's for the group
	    groupInstanceIdCreator, 
	    // whether it's left, right or center col
	    pinned, 
	    // we try to reuse old groups if we can, to allow gui to do animation
	    oldDisplayedGroups) {
	        var _this = this;
	        var result = [];
	        var previousRealPath;
	        var previousOriginalPath;
	        var oldColumnsMapped = this.mapOldGroupsById(oldDisplayedGroups);
	        // go through each column, then do a bottom up comparison to the previous column, and start
	        // to share groups if they converge at any point.
	        sortedVisibleColumns.forEach(function (currentColumn) {
	            var currentOriginalPath = _this.getOriginalPathForColumn(balancedColumnTree, currentColumn);
	            var currentRealPath = [];
	            var firstColumn = !previousOriginalPath;
	            for (var i = 0; i < currentOriginalPath.length; i++) {
	                if (firstColumn || currentOriginalPath[i] !== previousOriginalPath[i]) {
	                    // new group needed
	                    var newGroup = _this.createColumnGroup(currentOriginalPath[i], groupInstanceIdCreator, oldColumnsMapped, pinned);
	                    currentRealPath[i] = newGroup;
	                    // if top level, add to result, otherwise add to parent
	                    if (i == 0) {
	                        result.push(newGroup);
	                    }
	                    else {
	                        currentRealPath[i - 1].addChild(newGroup);
	                    }
	                }
	                else {
	                    // reuse old group
	                    currentRealPath[i] = previousRealPath[i];
	                }
	            }
	            var noColumnGroups = currentRealPath.length === 0;
	            if (noColumnGroups) {
	                // if we are not grouping, then the result of the above is an empty
	                // path (no groups), and we just add the column to the root list.
	                result.push(currentColumn);
	            }
	            else {
	                var leafGroup = utils_1._.last(currentRealPath);
	                leafGroup.addChild(currentColumn);
	            }
	            previousRealPath = currentRealPath;
	            previousOriginalPath = currentOriginalPath;
	        });
	        this.setupParentsIntoColumns(result, null);
	        return result;
	    };
	    DisplayedGroupCreator.prototype.createColumnGroup = function (originalGroup, groupInstanceIdCreator, oldColumnsMapped, pinned) {
	        var groupId = originalGroup.getGroupId();
	        var instanceId = groupInstanceIdCreator.getInstanceIdForKey(groupId);
	        var uniqueId = columnGroup_1.ColumnGroup.createUniqueId(groupId, instanceId);
	        var columnGroup = oldColumnsMapped[uniqueId];
	        // if the user is setting new colDefs, it is possible that the id's overlap, and we
	        // would have a false match from above. so we double check we are talking about the
	        // same original column group.
	        if (columnGroup && columnGroup.getOriginalColumnGroup() !== originalGroup) {
	            columnGroup = null;
	        }
	        if (utils_1._.exists(columnGroup)) {
	            // clean out the old column group here, as we will be adding children into it again
	            columnGroup.reset();
	        }
	        else {
	            columnGroup = new columnGroup_1.ColumnGroup(originalGroup, groupId, instanceId, pinned);
	            this.context.wireBean(columnGroup);
	        }
	        return columnGroup;
	    };
	    // returns back a 2d map of ColumnGroup as follows: groupId -> instanceId -> ColumnGroup
	    DisplayedGroupCreator.prototype.mapOldGroupsById = function (displayedGroups) {
	        var result = {};
	        var recursive = function (columnsOrGroups) {
	            columnsOrGroups.forEach(function (columnOrGroup) {
	                if (columnOrGroup instanceof columnGroup_1.ColumnGroup) {
	                    var columnGroup = columnOrGroup;
	                    result[columnOrGroup.getUniqueId()] = columnGroup;
	                    recursive(columnGroup.getChildren());
	                }
	            });
	        };
	        if (displayedGroups) {
	            recursive(displayedGroups);
	        }
	        return result;
	    };
	    DisplayedGroupCreator.prototype.setupParentsIntoColumns = function (columnsOrGroups, parent) {
	        var _this = this;
	        columnsOrGroups.forEach(function (columnsOrGroup) {
	            columnsOrGroup.setParent(parent);
	            if (columnsOrGroup instanceof columnGroup_1.ColumnGroup) {
	                var columnGroup = columnsOrGroup;
	                _this.setupParentsIntoColumns(columnGroup.getChildren(), columnGroup);
	            }
	        });
	    };
	    // private createFakePath(balancedColumnTree: OriginalColumnGroupChild[], column: Column): OriginalColumnGroup[] {
	    //     let fakePath: OriginalColumnGroup[] = [];
	    //     let currentChildren = balancedColumnTree;
	    //     // this while loop does search on the balanced tree, so our result is the right length
	    //     let index = 0;
	    //     while (currentChildren && currentChildren[0] && currentChildren[0] instanceof OriginalColumnGroup) {
	    //         // putting in a deterministic fake id, in case the API in the future needs to reference the col
	    //         let fakeGroup = new OriginalColumnGroup(null, 'FAKE_PATH_' + index, true);
	    //         this.context.wireBean(fakeGroup);
	    //
	    //         // fakePath.setChildren(children);
	    //
	    //         fakePath.push(fakeGroup);
	    //         currentChildren = (<OriginalColumnGroup>currentChildren[0]).getChildren();
	    //         index++;
	    //     }
	    //
	    //     fakePath.forEach( (fakePathGroup: OriginalColumnGroup, i: number) => {
	    //         let lastItemInList = i === fakePath.length-1;
	    //         let child = lastItemInList ? column : fakePath[i+1];
	    //         fakePathGroup.setChildren([child]);
	    //     });
	    //
	    //     return fakePath;
	    // }
	    DisplayedGroupCreator.prototype.getOriginalPathForColumn = function (balancedColumnTree, column) {
	        var result = [];
	        var found = false;
	        recursePath(balancedColumnTree, 0);
	        // it's possible we didn't find a path. this happens if the column is generated
	        // by the grid (auto-group), in that the definition didn't come from the client. in this case,
	        // we create a fake original path.
	        if (found) {
	            return result;
	        }
	        else {
	            console.warn('could not get path');
	            return null;
	            // return this.createFakePath(balancedColumnTree, column);
	        }
	        function recursePath(balancedColumnTree, dept) {
	            for (var i = 0; i < balancedColumnTree.length; i++) {
	                if (found) {
	                    // quit the search, so 'result' is kept with the found result
	                    return;
	                }
	                var node = balancedColumnTree[i];
	                if (node instanceof originalColumnGroup_1.OriginalColumnGroup) {
	                    var nextNode = node;
	                    recursePath(nextNode.getChildren(), dept + 1);
	                    result[dept] = node;
	                }
	                else {
	                    if (node === column) {
	                        found = true;
	                    }
	                }
	            }
	        }
	    };
	    __decorate([
	        context_1.Autowired('columnUtils'),
	        __metadata("design:type", columnUtils_1.ColumnUtils)
	    ], DisplayedGroupCreator.prototype, "columnUtils", void 0);
	    __decorate([
	        context_1.Autowired('context'),
	        __metadata("design:type", context_2.Context)
	    ], DisplayedGroupCreator.prototype, "context", void 0);
	    DisplayedGroupCreator = __decorate([
	        context_2.Bean('displayedGroupCreator')
	    ], DisplayedGroupCreator);
	    return DisplayedGroupCreator;
	}());
	exports.DisplayedGroupCreator = DisplayedGroupCreator;


/***/ }),
/* 2349 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var rowRenderer_1 = __webpack_require__(2350);
	var context_1 = __webpack_require__(2333);
	var gridOptionsWrapper_1 = __webpack_require__(2324);
	var headerWrapperComp_1 = __webpack_require__(2424);
	var AutoWidthCalculator = /** @class */ (function () {
	    function AutoWidthCalculator() {
	    }
	    AutoWidthCalculator.prototype.registerGridComp = function (gridPanel) {
	        this.gridPanel = gridPanel;
	    };
	    AutoWidthCalculator.prototype.registerHeaderRootComp = function (headerRootComp) {
	        this.headerRootComp = headerRootComp;
	    };
	    // this is the trick: we create a dummy container and clone all the cells
	    // into the dummy, then check the dummy's width. then destroy the dummy
	    // as we don't need it any more.
	    // drawback: only the cells visible on the screen are considered
	    AutoWidthCalculator.prototype.getPreferredWidthForColumn = function (column) {
	        var eHeaderCell = this.getHeaderCellForColumn(column);
	        // cell isn't visible
	        if (!eHeaderCell) {
	            return -1;
	        }
	        var eDummyContainer = document.createElement('span');
	        // position fixed, so it isn't restricted to the boundaries of the parent
	        eDummyContainer.style.position = 'fixed';
	        // we put the dummy into the body container, so it will inherit all the
	        // css styles that the real cells are inheriting
	        var eBodyContainer = this.gridPanel.getCenterContainer();
	        eBodyContainer.appendChild(eDummyContainer);
	        // get all the cells that are currently displayed (this only brings back
	        // rendered cells, rows not rendered due to row visualisation will not be here)
	        this.putRowCellsIntoDummyContainer(column, eDummyContainer);
	        // also put header cell in
	        // we only consider the lowest level cell, not the group cell. in 99% of the time, this
	        // will be enough. if we consider groups, then it gets to complicated for what it's worth,
	        // as the groups can span columns and this class only considers one column at a time.
	        this.cloneItemIntoDummy(eHeaderCell, eDummyContainer);
	        // at this point, all the clones are lined up vertically with natural widths. the dummy
	        // container will have a width wide enough just to fit the largest.
	        var dummyContainerWidth = eDummyContainer.offsetWidth;
	        // we are finished with the dummy container, so get rid of it
	        eBodyContainer.removeChild(eDummyContainer);
	        // we add padding as I found sometimes the gui still put '...' after some of the texts. so the
	        // user can configure the grid to add a few more pixels after the calculated width
	        var autoSizePadding = this.gridOptionsWrapper.getAutoSizePadding();
	        return dummyContainerWidth + autoSizePadding;
	    };
	    AutoWidthCalculator.prototype.getHeaderCellForColumn = function (column) {
	        var comp = null;
	        // find the rendered header cell
	        this.headerRootComp.forEachHeaderElement(function (headerElement) {
	            if (headerElement instanceof headerWrapperComp_1.HeaderWrapperComp) {
	                var headerWrapperComp = headerElement;
	                if (headerWrapperComp.getColumn() === column) {
	                    comp = headerWrapperComp;
	                }
	            }
	        });
	        return comp ? comp.getGui() : null;
	    };
	    AutoWidthCalculator.prototype.putRowCellsIntoDummyContainer = function (column, eDummyContainer) {
	        var _this = this;
	        var eCells = this.rowRenderer.getAllCellsForColumn(column);
	        eCells.forEach(function (eCell) { return _this.cloneItemIntoDummy(eCell, eDummyContainer); });
	    };
	    AutoWidthCalculator.prototype.cloneItemIntoDummy = function (eCell, eDummyContainer) {
	        // make a deep clone of the cell
	        var eCellClone = eCell.cloneNode(true);
	        // the original has a fixed width, we remove this to allow the natural width based on content
	        eCellClone.style.width = '';
	        // the original has position = absolute, we need to remove this so it's positioned normally
	        eCellClone.style.position = 'static';
	        eCellClone.style.left = '';
	        // we put the cell into a containing div, as otherwise the cells would just line up
	        // on the same line, standard flow layout, by putting them into divs, they are laid
	        // out one per line
	        var eCloneParent = document.createElement('div');
	        // table-row, so that each cell is on a row. i also tried display='block', but this
	        // didn't work in IE
	        eCloneParent.style.display = 'table-row';
	        // the twig on the branch, the branch on the tree, the tree in the hole,
	        // the hole in the bog, the bog in the clone, the clone in the parent,
	        // the parent in the dummy, and the dummy down in the vall-e-ooo, OOOOOOOOO! Oh row the rattling bog....
	        eCloneParent.appendChild(eCellClone);
	        eDummyContainer.appendChild(eCloneParent);
	    };
	    __decorate([
	        context_1.Autowired('rowRenderer'),
	        __metadata("design:type", rowRenderer_1.RowRenderer)
	    ], AutoWidthCalculator.prototype, "rowRenderer", void 0);
	    __decorate([
	        context_1.Autowired('gridOptionsWrapper'),
	        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
	    ], AutoWidthCalculator.prototype, "gridOptionsWrapper", void 0);
	    AutoWidthCalculator = __decorate([
	        context_1.Bean('autoWidthCalculator')
	    ], AutoWidthCalculator);
	    return AutoWidthCalculator;
	}());
	exports.AutoWidthCalculator = AutoWidthCalculator;


/***/ }),
/* 2350 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var __param = (this && this.__param) || function (paramIndex, decorator) {
	    return function (target, key) { decorator(target, key, paramIndex); }
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var gridOptionsWrapper_1 = __webpack_require__(2324);
	var eventService_1 = __webpack_require__(2331);
	var rowComp_1 = __webpack_require__(2351);
	var column_1 = __webpack_require__(2343);
	var events_1 = __webpack_require__(2335);
	var constants_1 = __webpack_require__(2328);
	var cellComp_1 = __webpack_require__(2352);
	var context_1 = __webpack_require__(2333);
	var columnApi_1 = __webpack_require__(2346);
	var columnController_1 = __webpack_require__(2341);
	var logger_1 = __webpack_require__(2332);
	var focusedCellController_1 = __webpack_require__(2369);
	var cellNavigationService_1 = __webpack_require__(2370);
	var beanStub_1 = __webpack_require__(2354);
	var paginationProxy_1 = __webpack_require__(2372);
	var gridApi_1 = __webpack_require__(2338);
	var pinnedRowModel_1 = __webpack_require__(2371);
	var beans_1 = __webpack_require__(2373);
	var animationFrameService_1 = __webpack_require__(2418);
	var maxDivHeightScaler_1 = __webpack_require__(2419);
	var utils_1 = __webpack_require__(2325);
	var rowPosition_1 = __webpack_require__(2423);
	var RowRenderer = /** @class */ (function (_super) {
	    __extends(RowRenderer, _super);
	    function RowRenderer() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.destroyFuncsForColumnListeners = [];
	        // map of row ids to row objects. keeps track of which elements
	        // are rendered for which rows in the dom.
	        _this.rowCompsByIndex = {};
	        _this.floatingTopRowComps = [];
	        _this.floatingBottomRowComps = [];
	        // we only allow one refresh at a time, otherwise the internal memory structure here
	        // will get messed up. this can happen if the user has a cellRenderer, and inside the
	        // renderer they call an API method that results in another pass of the refresh,
	        // then it will be trying to draw rows in the middle of a refresh.
	        _this.refreshInProgress = false;
	        return _this;
	    }
	    RowRenderer.prototype.registerGridCore = function (gridCore) {
	        this.gridCore = gridCore;
	    };
	    RowRenderer.prototype.getGridCore = function () {
	        return this.gridCore;
	    };
	    RowRenderer.prototype.agWire = function (loggerFactory) {
	        this.logger = loggerFactory.create("RowRenderer");
	    };
	    RowRenderer.prototype.registerGridComp = function (gridPanel) {
	        this.gridPanel = gridPanel;
	        this.rowContainers = this.gridPanel.getRowContainers();
	        this.addDestroyableEventListener(this.eventService, events_1.Events.EVENT_PAGINATION_CHANGED, this.onPageLoaded.bind(this));
	        this.addDestroyableEventListener(this.eventService, events_1.Events.EVENT_PINNED_ROW_DATA_CHANGED, this.onPinnedRowDataChanged.bind(this));
	        this.addDestroyableEventListener(this.eventService, events_1.Events.EVENT_DISPLAYED_COLUMNS_CHANGED, this.onDisplayedColumnsChanged.bind(this));
	        this.addDestroyableEventListener(this.eventService, events_1.Events.EVENT_BODY_SCROLL, this.redrawAfterScroll.bind(this));
	        this.addDestroyableEventListener(this.eventService, events_1.Events.EVENT_BODY_HEIGHT_CHANGED, this.redrawAfterScroll.bind(this));
	        this.addDestroyableEventListener(this.gridOptionsWrapper, gridOptionsWrapper_1.GridOptionsWrapper.PROP_DOM_LAYOUT, this.onDomLayoutChanged.bind(this));
	        this.registerCellEventListeners();
	        this.printLayout = this.gridOptionsWrapper.getDomLayout() === constants_1.Constants.DOM_LAYOUT_PRINT;
	        this.embedFullWidthRows = this.printLayout || this.gridOptionsWrapper.isEmbedFullWidthRows();
	        this.redrawAfterModelUpdate();
	    };
	    // in a clean design, each cell would register for each of these events. however when scrolling, all the cells
	    // registering and de-registering for events is a performance bottleneck. so we register here once and inform
	    // all active cells.
	    RowRenderer.prototype.registerCellEventListeners = function () {
	        var _this = this;
	        this.addDestroyableEventListener(this.eventService, events_1.Events.EVENT_CELL_FOCUSED, function (event) {
	            _this.forEachCellComp(function (cellComp) { return cellComp.onCellFocused(event); });
	        });
	        this.addDestroyableEventListener(this.eventService, events_1.Events.EVENT_FLASH_CELLS, function (event) {
	            _this.forEachCellComp(function (cellComp) { return cellComp.onFlashCells(event); });
	        });
	        this.addDestroyableEventListener(this.eventService, events_1.Events.EVENT_COLUMN_HOVER_CHANGED, function () {
	            _this.forEachCellComp(function (cellComp) { return cellComp.onColumnHover(); });
	        });
	        // only for printLayout - because we are rendering all the cells in the same row, regardless of pinned state,
	        // then changing the width of the containers will impact left position. eg the center cols all have their
	        // left position adjusted by the width of the left pinned column, so if the pinned left column width changes,
	        // all the center cols need to be shifted to accommodate this. when in normal layout, the pinned cols are
	        // in different containers so doesn't impact.
	        this.addDestroyableEventListener(this.eventService, events_1.Events.EVENT_DISPLAYED_COLUMNS_WIDTH_CHANGED, function () {
	            if (_this.printLayout) {
	                _this.forEachCellComp(function (cellComp) { return cellComp.onLeftChanged(); });
	            }
	        });
	        var rangeSelectionEnabled = this.gridOptionsWrapper.isEnableRangeSelection();
	        if (rangeSelectionEnabled) {
	            this.addDestroyableEventListener(this.eventService, events_1.Events.EVENT_RANGE_SELECTION_CHANGED, function () {
	                _this.forEachCellComp(function (cellComp) { return cellComp.onRangeSelectionChanged(); });
	            });
	            this.addDestroyableEventListener(this.eventService, events_1.Events.EVENT_COLUMN_MOVED, function () {
	                _this.forEachCellComp(function (cellComp) { return cellComp.updateRangeBordersIfRangeCount(); });
	            });
	            this.addDestroyableEventListener(this.eventService, events_1.Events.EVENT_COLUMN_PINNED, function () {
	                _this.forEachCellComp(function (cellComp) { return cellComp.updateRangeBordersIfRangeCount(); });
	            });
	            this.addDestroyableEventListener(this.eventService, events_1.Events.EVENT_COLUMN_VISIBLE, function () {
	                _this.forEachCellComp(function (cellComp) { return cellComp.updateRangeBordersIfRangeCount(); });
	            });
	        }
	        // add listeners to the grid columns
	        this.refreshListenersToColumnsForCellComps();
	        // if the grid columns change, then refresh the listeners again
	        this.addDestroyableEventListener(this.eventService, events_1.Events.EVENT_GRID_COLUMNS_CHANGED, this.refreshListenersToColumnsForCellComps.bind(this));
	        this.addDestroyFunc(this.removeGridColumnListeners.bind(this));
	    };
	    // executes all functions in destroyFuncsForColumnListeners and then clears the list
	    RowRenderer.prototype.removeGridColumnListeners = function () {
	        this.destroyFuncsForColumnListeners.forEach(function (func) { return func(); });
	        this.destroyFuncsForColumnListeners.length = 0;
	    };
	    // this function adds listeners onto all the grid columns, which are the column that we could have cellComps for.
	    // when the grid columns change, we add listeners again. in an ideal design, each CellComp would just register to
	    // the column it belongs to on creation, however this was a bottleneck with the number of cells, so do it here
	    // once instead.
	    RowRenderer.prototype.refreshListenersToColumnsForCellComps = function () {
	        var _this = this;
	        this.removeGridColumnListeners();
	        var cols = this.columnController.getAllGridColumns();
	        if (!cols) {
	            return;
	        }
	        cols.forEach(function (col) {
	            var forEachCellWithThisCol = function (callback) {
	                _this.forEachCellComp(function (cellComp) {
	                    if (cellComp.getColumn() === col) {
	                        callback(cellComp);
	                    }
	                });
	            };
	            var leftChangedListener = function () {
	                forEachCellWithThisCol(function (cellComp) { return cellComp.onLeftChanged(); });
	            };
	            var widthChangedListener = function () {
	                forEachCellWithThisCol(function (cellComp) { return cellComp.onWidthChanged(); });
	            };
	            var firstRightPinnedChangedListener = function () {
	                forEachCellWithThisCol(function (cellComp) { return cellComp.onFirstRightPinnedChanged(); });
	            };
	            var lastLeftPinnedChangedListener = function () {
	                forEachCellWithThisCol(function (cellComp) { return cellComp.onLastLeftPinnedChanged(); });
	            };
	            col.addEventListener(column_1.Column.EVENT_LEFT_CHANGED, leftChangedListener);
	            col.addEventListener(column_1.Column.EVENT_WIDTH_CHANGED, widthChangedListener);
	            col.addEventListener(column_1.Column.EVENT_FIRST_RIGHT_PINNED_CHANGED, firstRightPinnedChangedListener);
	            col.addEventListener(column_1.Column.EVENT_LAST_LEFT_PINNED_CHANGED, lastLeftPinnedChangedListener);
	            _this.destroyFuncsForColumnListeners.push(function () {
	                col.removeEventListener(column_1.Column.EVENT_LEFT_CHANGED, leftChangedListener);
	                col.removeEventListener(column_1.Column.EVENT_WIDTH_CHANGED, widthChangedListener);
	                col.removeEventListener(column_1.Column.EVENT_FIRST_RIGHT_PINNED_CHANGED, firstRightPinnedChangedListener);
	                col.removeEventListener(column_1.Column.EVENT_LAST_LEFT_PINNED_CHANGED, lastLeftPinnedChangedListener);
	            });
	        });
	    };
	    RowRenderer.prototype.onDomLayoutChanged = function () {
	        var printLayout = this.gridOptionsWrapper.getDomLayout() === constants_1.Constants.DOM_LAYOUT_PRINT;
	        var embedFullWidthRows = printLayout || this.gridOptionsWrapper.isEmbedFullWidthRows();
	        // if moving towards or away from print layout, means we need to destroy all rows, as rows are not laid
	        // out using absolute positioning when doing print layout
	        var destroyRows = embedFullWidthRows !== this.embedFullWidthRows || this.printLayout !== printLayout;
	        this.printLayout = printLayout;
	        this.embedFullWidthRows = embedFullWidthRows;
	        if (destroyRows) {
	            this.redrawAfterModelUpdate();
	        }
	    };
	    // for row models that have datasources, when we update the datasource, we need to force the rowRenderer
	    // to redraw all rows. otherwise the old rows from the old datasource will stay displayed.
	    RowRenderer.prototype.datasourceChanged = function () {
	        this.firstRenderedRow = 0;
	        this.lastRenderedRow = -1;
	        var rowIndexesToRemove = Object.keys(this.rowCompsByIndex);
	        this.removeRowComps(rowIndexesToRemove);
	    };
	    RowRenderer.prototype.onPageLoaded = function (refreshEvent) {
	        if (utils_1._.missing(refreshEvent)) {
	            refreshEvent = {
	                type: events_1.Events.EVENT_MODEL_UPDATED,
	                api: this.gridApi,
	                columnApi: this.columnApi,
	                animate: false,
	                keepRenderedRows: false,
	                newData: false,
	                newPage: false
	            };
	        }
	        this.onModelUpdated(refreshEvent);
	    };
	    RowRenderer.prototype.getAllCellsForColumn = function (column) {
	        var eCells = [];
	        utils_1._.iterateObject(this.rowCompsByIndex, callback);
	        utils_1._.iterateObject(this.floatingBottomRowComps, callback);
	        utils_1._.iterateObject(this.floatingTopRowComps, callback);
	        function callback(key, rowComp) {
	            var eCell = rowComp.getCellForCol(column);
	            if (eCell) {
	                eCells.push(eCell);
	            }
	        }
	        return eCells;
	    };
	    RowRenderer.prototype.refreshFloatingRowComps = function () {
	        this.refreshFloatingRows(this.floatingTopRowComps, this.pinnedRowModel.getPinnedTopRowData(), this.rowContainers.floatingTopPinnedLeft, this.rowContainers.floatingTopPinnedRight, this.rowContainers.floatingTop, this.rowContainers.floatingTopFullWidth);
	        this.refreshFloatingRows(this.floatingBottomRowComps, this.pinnedRowModel.getPinnedBottomRowData(), this.rowContainers.floatingBottomPinnedLeft, this.rowContainers.floatingBottomPinnedRight, this.rowContainers.floatingBottom, this.rowContainers.floatingBottomFullWith);
	    };
	    RowRenderer.prototype.refreshFloatingRows = function (rowComps, rowNodes, pinnedLeftContainerComp, pinnedRightContainerComp, bodyContainerComp, fullWidthContainerComp) {
	        var _this = this;
	        rowComps.forEach(function (row) {
	            row.destroy();
	        });
	        rowComps.length = 0;
	        if (rowNodes) {
	            rowNodes.forEach(function (node) {
	                var rowComp = new rowComp_1.RowComp(_this.$scope, bodyContainerComp, pinnedLeftContainerComp, pinnedRightContainerComp, fullWidthContainerComp, node, _this.beans, false, false, _this.printLayout, _this.embedFullWidthRows);
	                rowComp.init();
	                rowComps.push(rowComp);
	            });
	        }
	        this.flushContainers(rowComps);
	    };
	    RowRenderer.prototype.onPinnedRowDataChanged = function () {
	        // recycling rows in order to ensure cell editing is not cancelled
	        var params = {
	            recycleRows: true
	        };
	        this.redrawAfterModelUpdate(params);
	    };
	    RowRenderer.prototype.onModelUpdated = function (refreshEvent) {
	        var params = {
	            recycleRows: refreshEvent.keepRenderedRows,
	            animate: refreshEvent.animate,
	            newData: refreshEvent.newData,
	            newPage: refreshEvent.newPage,
	            // because this is a model updated event (not pinned rows), we
	            // can skip updating the pinned rows. this is needed so that if user
	            // is doing transaction updates, the pinned rows are not getting constantly
	            // trashed - or editing cells in pinned rows are not refreshed and put into read mode
	            onlyBody: true
	        };
	        this.redrawAfterModelUpdate(params);
	    };
	    // if the row nodes are not rendered, no index is returned
	    RowRenderer.prototype.getRenderedIndexesForRowNodes = function (rowNodes) {
	        var result = [];
	        if (utils_1._.missing(rowNodes)) {
	            return result;
	        }
	        utils_1._.iterateObject(this.rowCompsByIndex, function (index, renderedRow) {
	            var rowNode = renderedRow.getRowNode();
	            if (rowNodes.indexOf(rowNode) >= 0) {
	                result.push(index);
	            }
	        });
	        return result;
	    };
	    RowRenderer.prototype.redrawRows = function (rowNodes) {
	        if (!rowNodes || rowNodes.length == 0) {
	            return;
	        }
	        // we only need to be worried about rendered rows, as this method is
	        // called to what's rendered. if the row isn't rendered, we don't care
	        var indexesToRemove = this.getRenderedIndexesForRowNodes(rowNodes);
	        // remove the rows
	        this.removeRowComps(indexesToRemove);
	        // add draw them again
	        this.redrawAfterModelUpdate({
	            recycleRows: true
	        });
	    };
	    RowRenderer.prototype.getCellToRestoreFocusToAfterRefresh = function (params) {
	        var focusedCell = params.suppressKeepFocus ? null : this.focusedCellController.getFocusCellToUseAfterRefresh();
	        if (utils_1._.missing(focusedCell)) {
	            return null;
	        }
	        // if the dom is not actually focused on a cell, then we don't try to refocus. the problem this
	        // solves is with editing - if the user is editing, eg focus is on a text field, and not on the
	        // cell itself, then the cell can be registered as having focus, however it's the text field that
	        // has the focus and not the cell div. therefore, when the refresh is finished, the grid will focus
	        // the cell, and not the textfield. that means if the user is in a text field, and the grid refreshes,
	        // the focus is lost from the text field. we do not want this.
	        var activeElement = document.activeElement;
	        var domData = this.gridOptionsWrapper.getDomData(activeElement, cellComp_1.CellComp.DOM_DATA_KEY_CELL_COMP);
	        var elementIsNotACellDev = utils_1._.missing(domData);
	        if (elementIsNotACellDev) {
	            return null;
	        }
	        return focusedCell;
	    };
	    // gets called after changes to the model.
	    RowRenderer.prototype.redrawAfterModelUpdate = function (params) {
	        if (params === void 0) { params = {}; }
	        this.getLockOnRefresh();
	        var focusedCell = this.getCellToRestoreFocusToAfterRefresh(params);
	        this.sizeContainerToPageHeight();
	        this.scrollToTopIfNewData(params);
	        // never recycle rows when print layout, we draw each row again from scratch. this is because print layout
	        // uses normal dom layout to put cells into dom - it doesn't allow reordering rows.
	        var recycleRows = !this.printLayout && params.recycleRows;
	        var animate = params.animate && this.gridOptionsWrapper.isAnimateRows();
	        var rowsToRecycle = this.binRowComps(recycleRows);
	        this.redraw(rowsToRecycle, animate);
	        if (!params.onlyBody) {
	            this.refreshFloatingRowComps();
	        }
	        this.restoreFocusedCell(focusedCell);
	        this.releaseLockOnRefresh();
	    };
	    RowRenderer.prototype.scrollToTopIfNewData = function (params) {
	        var scrollToTop = params.newData || params.newPage;
	        var suppressScrollToTop = this.gridOptionsWrapper.isSuppressScrollOnNewData();
	        if (scrollToTop && !suppressScrollToTop) {
	            this.gridPanel.scrollToTop();
	        }
	    };
	    RowRenderer.prototype.sizeContainerToPageHeight = function () {
	        var containers = [
	            this.rowContainers.body,
	            this.rowContainers.fullWidth,
	            this.rowContainers.pinnedLeft,
	            this.rowContainers.pinnedRight
	        ];
	        if (this.printLayout) {
	            containers.forEach(function (container) { return container.setHeight(null); });
	            return;
	        }
	        var containerHeight = this.paginationProxy.getCurrentPageHeight();
	        // we need at least 1 pixel for the horizontal scroll to work. so if there are now rows,
	        // we still want the scroll to be present, otherwise there would be no way to scroll the header
	        // which might be needed us user wants to access columns
	        // on the RHS - and if that was where the filter was that cause no rows to be presented, there
	        // is no way to remove the filter.
	        if (containerHeight === 0) {
	            containerHeight = 1;
	        }
	        this.maxDivHeightScaler.setModelHeight(containerHeight);
	        var realHeight = this.maxDivHeightScaler.getUiContainerHeight();
	        containers.forEach(function (container) { return container.setHeight(realHeight); });
	    };
	    RowRenderer.prototype.getLockOnRefresh = function () {
	        if (this.refreshInProgress) {
	            throw new Error("ag-Grid: cannot get grid to draw rows when it is in the middle of drawing rows. " +
	                "Your code probably called a grid API method while the grid was in the render stage. To overcome " +
	                "this, put the API call into a timeout, eg instead of api.refreshView(), " +
	                "call setTimeout(function(){api.refreshView(),0}). To see what part of your code " +
	                "that caused the refresh check this stacktrace.");
	        }
	        this.refreshInProgress = true;
	    };
	    RowRenderer.prototype.releaseLockOnRefresh = function () {
	        this.refreshInProgress = false;
	    };
	    // sets the focus to the provided cell, if the cell is provided. this way, the user can call refresh without
	    // worry about the focus been lost. this is important when the user is using keyboard navigation to do edits
	    // and the cellEditor is calling 'refresh' to get other cells to update (as other cells might depend on the
	    // edited cell).
	    RowRenderer.prototype.restoreFocusedCell = function (cellPosition) {
	        if (cellPosition) {
	            this.focusedCellController.setFocusedCell(cellPosition.rowIndex, cellPosition.column, cellPosition.rowPinned, true);
	        }
	    };
	    RowRenderer.prototype.stopEditing = function (cancel) {
	        if (cancel === void 0) { cancel = false; }
	        this.forEachRowComp(function (key, rowComp) {
	            rowComp.stopEditing(cancel);
	        });
	    };
	    RowRenderer.prototype.forEachCellComp = function (callback) {
	        this.forEachRowComp(function (key, rowComp) { return rowComp.forEachCellComp(callback); });
	    };
	    RowRenderer.prototype.forEachRowComp = function (callback) {
	        utils_1._.iterateObject(this.rowCompsByIndex, callback);
	        utils_1._.iterateObject(this.floatingTopRowComps, callback);
	        utils_1._.iterateObject(this.floatingBottomRowComps, callback);
	    };
	    RowRenderer.prototype.addRenderedRowListener = function (eventName, rowIndex, callback) {
	        var rowComp = this.rowCompsByIndex[rowIndex];
	        if (rowComp) {
	            rowComp.addEventListener(eventName, callback);
	        }
	    };
	    RowRenderer.prototype.flashCells = function (params) {
	        if (params === void 0) { params = {}; }
	        this.forEachCellCompFiltered(params.rowNodes, params.columns, function (cellComp) { return cellComp.flashCell(); });
	    };
	    RowRenderer.prototype.refreshCells = function (params) {
	        if (params === void 0) { params = {}; }
	        var refreshCellParams = {
	            forceRefresh: params.force,
	            newData: false
	        };
	        this.forEachCellCompFiltered(params.rowNodes, params.columns, function (cellComp) { return cellComp.refreshCell(refreshCellParams); });
	    };
	    RowRenderer.prototype.getCellRendererInstances = function (params) {
	        var res = [];
	        this.forEachCellCompFiltered(params.rowNodes, params.columns, function (cellComp) {
	            var cellRenderer = cellComp.getCellRenderer();
	            if (cellRenderer) {
	                res.push(cellRenderer);
	            }
	        });
	        return res;
	    };
	    RowRenderer.prototype.getCellEditorInstances = function (params) {
	        var res = [];
	        this.forEachCellCompFiltered(params.rowNodes, params.columns, function (cellComp) {
	            var cellEditor = cellComp.getCellEditor();
	            if (cellEditor) {
	                res.push(cellEditor);
	            }
	        });
	        return res;
	    };
	    RowRenderer.prototype.getEditingCells = function () {
	        var res = [];
	        this.forEachCellComp(function (cellComp) {
	            if (cellComp.isEditing()) {
	                var cellPosition = cellComp.getCellPosition();
	                res.push(cellPosition);
	            }
	        });
	        return res;
	    };
	    // calls the callback for each cellComp that match the provided rowNodes and columns. eg if one row node
	    // and two columns provided, that identifies 4 cells, so callback gets called 4 times, once for each cell.
	    RowRenderer.prototype.forEachCellCompFiltered = function (rowNodes, columns, callback) {
	        var _this = this;
	        var rowIdsMap;
	        if (utils_1._.exists(rowNodes)) {
	            rowIdsMap = {
	                top: {},
	                bottom: {},
	                normal: {}
	            };
	            rowNodes.forEach(function (rowNode) {
	                if (rowNode.rowPinned === constants_1.Constants.PINNED_TOP) {
	                    rowIdsMap.top[rowNode.id] = true;
	                }
	                else if (rowNode.rowPinned === constants_1.Constants.PINNED_BOTTOM) {
	                    rowIdsMap.bottom[rowNode.id] = true;
	                }
	                else {
	                    rowIdsMap.normal[rowNode.id] = true;
	                }
	            });
	        }
	        var colIdsMap;
	        if (utils_1._.exists(columns)) {
	            colIdsMap = {};
	            columns.forEach(function (colKey) {
	                var column = _this.columnController.getGridColumn(colKey);
	                if (utils_1._.exists(column)) {
	                    colIdsMap[column.getId()] = true;
	                }
	            });
	        }
	        var processRow = function (rowComp) {
	            var rowNode = rowComp.getRowNode();
	            var id = rowNode.id;
	            var floating = rowNode.rowPinned;
	            // skip this row if it is missing from the provided list
	            if (utils_1._.exists(rowIdsMap)) {
	                if (floating === constants_1.Constants.PINNED_BOTTOM) {
	                    if (!rowIdsMap.bottom[id]) {
	                        return;
	                    }
	                }
	                else if (floating === constants_1.Constants.PINNED_TOP) {
	                    if (!rowIdsMap.top[id]) {
	                        return;
	                    }
	                }
	                else {
	                    if (!rowIdsMap.normal[id]) {
	                        return;
	                    }
	                }
	            }
	            rowComp.forEachCellComp(function (cellComp) {
	                var colId = cellComp.getColumn().getId();
	                var excludeColFromRefresh = colIdsMap && !colIdsMap[colId];
	                if (excludeColFromRefresh) {
	                    return;
	                }
	                callback(cellComp);
	            });
	        };
	        utils_1._.iterateObject(this.rowCompsByIndex, function (index, rowComp) {
	            processRow(rowComp);
	        });
	        if (this.floatingTopRowComps) {
	            this.floatingTopRowComps.forEach(processRow);
	        }
	        if (this.floatingBottomRowComps) {
	            this.floatingBottomRowComps.forEach(processRow);
	        }
	    };
	    RowRenderer.prototype.destroy = function () {
	        _super.prototype.destroy.call(this);
	        var rowIndexesToRemove = Object.keys(this.rowCompsByIndex);
	        this.removeRowComps(rowIndexesToRemove);
	    };
	    RowRenderer.prototype.binRowComps = function (recycleRows) {
	        var _this = this;
	        var indexesToRemove;
	        var rowsToRecycle = {};
	        if (recycleRows) {
	            indexesToRemove = [];
	            utils_1._.iterateObject(this.rowCompsByIndex, function (index, rowComp) {
	                var rowNode = rowComp.getRowNode();
	                if (utils_1._.exists(rowNode.id)) {
	                    rowsToRecycle[rowNode.id] = rowComp;
	                    delete _this.rowCompsByIndex[index];
	                }
	                else {
	                    indexesToRemove.push(index);
	                }
	            });
	        }
	        else {
	            indexesToRemove = Object.keys(this.rowCompsByIndex);
	        }
	        this.removeRowComps(indexesToRemove);
	        return rowsToRecycle;
	    };
	    // takes array of row indexes
	    RowRenderer.prototype.removeRowComps = function (rowsToRemove) {
	        var _this = this;
	        // if no fromIndex then set to -1, which will refresh everything
	        // let realFromIndex = -1;
	        rowsToRemove.forEach(function (indexToRemove) {
	            var renderedRow = _this.rowCompsByIndex[indexToRemove];
	            renderedRow.destroy();
	            delete _this.rowCompsByIndex[indexToRemove];
	        });
	    };
	    // gets called when rows don't change, but viewport does, so after:
	    // 1) height of grid body changes, ie number of displayed rows has changed
	    // 2) grid scrolled to new position
	    // 3) ensure index visible (which is a scroll)
	    RowRenderer.prototype.redrawAfterScroll = function () {
	        this.getLockOnRefresh();
	        this.redraw(null, false, true);
	        this.releaseLockOnRefresh();
	    };
	    RowRenderer.prototype.removeRowCompsNotToDraw = function (indexesToDraw) {
	        // for speedy lookup, dump into map
	        var indexesToDrawMap = {};
	        indexesToDraw.forEach(function (index) { return (indexesToDrawMap[index] = true); });
	        var existingIndexes = Object.keys(this.rowCompsByIndex);
	        var indexesNotToDraw = utils_1._.filter(existingIndexes, function (index) { return !indexesToDrawMap[index]; });
	        this.removeRowComps(indexesNotToDraw);
	    };
	    RowRenderer.prototype.calculateIndexesToDraw = function () {
	        var _this = this;
	        // all in all indexes in the viewport
	        var indexesToDraw = utils_1._.createArrayOfNumbers(this.firstRenderedRow, this.lastRenderedRow);
	        // add in indexes of rows we want to keep, because they are currently editing
	        utils_1._.iterateObject(this.rowCompsByIndex, function (indexStr, rowComp) {
	            var index = Number(indexStr);
	            if (index < _this.firstRenderedRow || index > _this.lastRenderedRow) {
	                if (_this.doNotUnVirtualiseRow(rowComp)) {
	                    indexesToDraw.push(index);
	                }
	            }
	        });
	        indexesToDraw.sort(function (a, b) { return a - b; });
	        return indexesToDraw;
	    };
	    RowRenderer.prototype.redraw = function (rowsToRecycle, animate, afterScroll) {
	        var _this = this;
	        if (animate === void 0) { animate = false; }
	        if (afterScroll === void 0) { afterScroll = false; }
	        this.maxDivHeightScaler.updateOffset();
	        this.workOutFirstAndLastRowsToRender();
	        // the row can already exist and be in the following:
	        // rowsToRecycle -> if model change, then the index may be different, however row may
	        //                         exist here from previous time (mapped by id).
	        // this.rowCompsByIndex -> if just a scroll, then this will contain what is currently in the viewport
	        // this is all the indexes we want, including those that already exist, so this method
	        // will end up going through each index and drawing only if the row doesn't already exist
	        var indexesToDraw = this.calculateIndexesToDraw();
	        this.removeRowCompsNotToDraw(indexesToDraw);
	        // never animate when doing print layout - as we want to get things ready to print as quickly as possible,
	        // otherwise we risk the printer printing a row that's half faded (half way through fading in)
	        if (this.printLayout) {
	            animate = false;
	        }
	        // add in new rows
	        var nextVmTurnFunctions = [];
	        var rowComps = [];
	        indexesToDraw.forEach(function (rowIndex) {
	            var rowComp = _this.createOrUpdateRowComp(rowIndex, rowsToRecycle, animate, afterScroll);
	            if (utils_1._.exists(rowComp)) {
	                rowComps.push(rowComp);
	                utils_1._.pushAll(nextVmTurnFunctions, rowComp.getAndClearNextVMTurnFunctions());
	            }
	        });
	        this.flushContainers(rowComps);
	        utils_1._.executeNextVMTurn(nextVmTurnFunctions);
	        var useAnimationFrame = afterScroll && !this.gridOptionsWrapper.isSuppressAnimationFrame() && !this.printLayout;
	        if (useAnimationFrame) {
	            this.beans.taskQueue.addP2Task(this.destroyRowComps.bind(this, rowsToRecycle, animate));
	        }
	        else {
	            this.destroyRowComps(rowsToRecycle, animate);
	        }
	        this.checkAngularCompile();
	        this.gridPanel.updateRowCount();
	    };
	    RowRenderer.prototype.flushContainers = function (rowComps) {
	        utils_1._.iterateObject(this.rowContainers, function (key, rowContainerComp) {
	            if (rowContainerComp) {
	                rowContainerComp.flushRowTemplates();
	            }
	        });
	        rowComps.forEach(function (rowComp) { return rowComp.afterFlush(); });
	    };
	    RowRenderer.prototype.onDisplayedColumnsChanged = function () {
	        var pinningLeft = this.columnController.isPinningLeft();
	        var pinningRight = this.columnController.isPinningRight();
	        var atLeastOneChanged = this.pinningLeft !== pinningLeft || pinningRight !== this.pinningRight;
	        if (atLeastOneChanged) {
	            this.pinningLeft = pinningLeft;
	            this.pinningRight = pinningRight;
	            if (this.embedFullWidthRows) {
	                this.redrawFullWidthEmbeddedRows();
	            }
	        }
	    };
	    // when embedding, what gets showed in each section depends on what is pinned. eg if embedding group expand / collapse,
	    // then it should go into the pinned left area if pinning left, or the center area if not pinning.
	    RowRenderer.prototype.redrawFullWidthEmbeddedRows = function () {
	        // if either of the pinned panels has shown / hidden, then need to redraw the fullWidth bits when
	        // embedded, as what appears in each section depends on whether we are pinned or not
	        var rowsToRemove = [];
	        utils_1._.iterateObject(this.rowCompsByIndex, function (id, rowComp) {
	            if (rowComp.isFullWidth()) {
	                var rowIndex = rowComp.getRowNode().rowIndex;
	                rowsToRemove.push(rowIndex.toString());
	            }
	        });
	        this.refreshFloatingRowComps();
	        this.removeRowComps(rowsToRemove);
	        this.redrawAfterScroll();
	    };
	    RowRenderer.prototype.refreshFullWidthRows = function () {
	        var rowsToRemove = [];
	        utils_1._.iterateObject(this.rowCompsByIndex, function (id, rowComp) {
	            if (rowComp.isFullWidth()) {
	                var fullWidthRowsRefreshed = rowComp.refreshFullWidth();
	                if (!fullWidthRowsRefreshed) {
	                    var rowIndex = rowComp.getRowNode().rowIndex;
	                    rowsToRemove.push(rowIndex.toString());
	                }
	            }
	        });
	        this.removeRowComps(rowsToRemove);
	        this.redrawAfterScroll();
	    };
	    RowRenderer.prototype.createOrUpdateRowComp = function (rowIndex, rowsToRecycle, animate, afterScroll) {
	        var rowNode;
	        var rowComp = this.rowCompsByIndex[rowIndex];
	        // if no row comp, see if we can get it from the previous rowComps
	        if (!rowComp) {
	            rowNode = this.paginationProxy.getRow(rowIndex);
	            if (utils_1._.exists(rowNode) && utils_1._.exists(rowsToRecycle) && rowsToRecycle[rowNode.id] && rowNode.alreadyRendered) {
	                rowComp = rowsToRecycle[rowNode.id];
	                rowsToRecycle[rowNode.id] = null;
	            }
	        }
	        var creatingNewRowComp = !rowComp;
	        if (creatingNewRowComp) {
	            // create a new one
	            if (!rowNode) {
	                rowNode = this.paginationProxy.getRow(rowIndex);
	            }
	            if (utils_1._.exists(rowNode)) {
	                rowComp = this.createRowComp(rowNode, animate, afterScroll);
	            }
	            else {
	                // this should never happen - if somehow we are trying to create
	                // a row for a rowNode that does not exist.
	                return;
	            }
	        }
	        else {
	            // ensure row comp is in right position in DOM
	            rowComp.ensureDomOrder();
	        }
	        if (rowNode) {
	            // set node as 'alreadyRendered' to ensure we only recycle rowComps that have been rendered, this ensures
	            // we don't reuse rowComps that have been removed and then re-added in the same batch transaction.
	            rowNode.alreadyRendered = true;
	        }
	        this.rowCompsByIndex[rowIndex] = rowComp;
	        return rowComp;
	    };
	    RowRenderer.prototype.destroyRowComps = function (rowCompsMap, animate) {
	        var delayedFuncs = [];
	        utils_1._.iterateObject(rowCompsMap, function (nodeId, rowComp) {
	            // if row was used, then it's null
	            if (!rowComp) {
	                return;
	            }
	            rowComp.destroy(animate);
	            utils_1._.pushAll(delayedFuncs, rowComp.getAndClearDelayedDestroyFunctions());
	        });
	        utils_1._.executeInAWhile(delayedFuncs);
	    };
	    RowRenderer.prototype.checkAngularCompile = function () {
	        var _this = this;
	        // if we are doing angular compiling, then do digest the scope here
	        if (this.gridOptionsWrapper.isAngularCompileRows()) {
	            // we do it in a timeout, in case we are already in an apply
	            window.setTimeout(function () {
	                _this.$scope.$apply();
	            }, 0);
	        }
	    };
	    RowRenderer.prototype.workOutFirstAndLastRowsToRender = function () {
	        var newFirst;
	        var newLast;
	        if (!this.paginationProxy.isRowsToRender()) {
	            newFirst = 0;
	            newLast = -1; // setting to -1 means nothing in range
	        }
	        else if (this.printLayout) {
	            newFirst = this.paginationProxy.getPageFirstRow();
	            newLast = this.paginationProxy.getPageLastRow();
	        }
	        else {
	            var paginationOffset = this.paginationProxy.getPixelOffset();
	            var maxDivHeightScaler = this.maxDivHeightScaler.getOffset();
	            var bodyVRange = this.gridPanel.getVScrollPosition();
	            var bodyTopPixel = bodyVRange.top;
	            var bodyBottomPixel = bodyVRange.bottom;
	            var bufferPixels = this.gridOptionsWrapper.getRowBufferInPixels();
	            var firstPixel = bodyTopPixel + paginationOffset + maxDivHeightScaler - bufferPixels;
	            var lastPixel = bodyBottomPixel + paginationOffset + maxDivHeightScaler + bufferPixels;
	            this.ensureAllRowsInRangeHaveHeightsCalculated(firstPixel, lastPixel);
	            var firstRowIndex = this.paginationProxy.getRowIndexAtPixel(firstPixel);
	            var lastRowIndex = this.paginationProxy.getRowIndexAtPixel(lastPixel);
	            var pageFirstRow = this.paginationProxy.getPageFirstRow();
	            var pageLastRow = this.paginationProxy.getPageLastRow();
	            // adjust, in case buffer extended actual size
	            if (firstRowIndex < pageFirstRow) {
	                firstRowIndex = pageFirstRow;
	            }
	            if (lastRowIndex > pageLastRow) {
	                lastRowIndex = pageLastRow;
	            }
	            newFirst = firstRowIndex;
	            newLast = lastRowIndex;
	        }
	        // sometimes user doesn't set CSS right and ends up with grid with no height and grid ends up
	        // trying to render all the rows, eg 10,000+ rows. this will kill the browser. so instead of
	        // killing the browser, we limit the number of rows. just in case some use case we didn't think
	        // of, we also have a property to not do this operation.
	        var rowLayoutNormal = this.gridOptionsWrapper.getDomLayout() === constants_1.Constants.DOM_LAYOUT_NORMAL;
	        var suppressRowCountRestriction = this.gridOptionsWrapper.isSuppressMaxRenderedRowRestriction();
	        var rowBufferMaxSize = Math.max(this.gridOptionsWrapper.getRowBuffer(), 500);
	        if (rowLayoutNormal && !suppressRowCountRestriction) {
	            if (newLast - newFirst > rowBufferMaxSize) {
	                newLast = newFirst + rowBufferMaxSize;
	            }
	        }
	        var firstDiffers = newFirst !== this.firstRenderedRow;
	        var lastDiffers = newLast !== this.lastRenderedRow;
	        if (firstDiffers || lastDiffers) {
	            this.firstRenderedRow = newFirst;
	            this.lastRenderedRow = newLast;
	            var event_1 = {
	                type: events_1.Events.EVENT_VIEWPORT_CHANGED,
	                firstRow: newFirst,
	                lastRow: newLast,
	                api: this.gridApi,
	                columnApi: this.columnApi
	            };
	            this.eventService.dispatchEvent(event_1);
	        }
	        if (this.paginationProxy.isRowsToRender()) {
	            var event_2 = {
	                type: events_1.Events.EVENT_FIRST_DATA_RENDERED,
	                firstRow: newFirst,
	                lastRow: newLast,
	                api: this.gridApi,
	                columnApi: this.columnApi
	            };
	            this.eventService.dispatchEventOnce(event_2);
	        }
	    };
	    RowRenderer.prototype.ensureAllRowsInRangeHaveHeightsCalculated = function (topPixel, bottomPixel) {
	        // ensureRowHeightsVisible only works with CSRM, as it's the only row model that allows lazy row height calcs.
	        // all the other row models just hard code so the method just returns back false
	        var rowHeightsChanged = this.paginationProxy.ensureRowHeightsValid(topPixel, bottomPixel, -1, -1);
	        if (rowHeightsChanged) {
	            // if row heights have changed, we need to resize the containers the rows sit it
	            this.sizeContainerToPageHeight();
	            // we also need to update heightScaler as this has dependency of row container height
	            this.maxDivHeightScaler.updateOffset();
	        }
	    };
	    RowRenderer.prototype.getFirstVirtualRenderedRow = function () {
	        return this.firstRenderedRow;
	    };
	    RowRenderer.prototype.getLastVirtualRenderedRow = function () {
	        return this.lastRenderedRow;
	    };
	    // check that none of the rows to remove are editing or focused as:
	    // a) if editing, we want to keep them, otherwise the user will loose the context of the edit,
	    //    eg user starts editing, enters some text, then scrolls down and then up, next time row rendered
	    //    the edit is reset - so we want to keep it rendered.
	    // b) if focused, we want ot keep keyboard focus, so if user ctrl+c, it goes to clipboard,
	    //    otherwise the user can range select and drag (with focus cell going out of the viewport)
	    //    and then ctrl+c, nothing will happen if cell is removed from dom.
	    // c) if detail record of master detail, as users complained that the context of detail rows
	    //    was getting lost when detail row out of view. eg user expands to show detail row,
	    //    then manipulates the detail panel (eg sorts the detail grid), then context is lost
	    //    after detail panel is scrolled out of / into view.
	    RowRenderer.prototype.doNotUnVirtualiseRow = function (rowComp) {
	        var REMOVE_ROW = false;
	        var KEEP_ROW = true;
	        var rowNode = rowComp.getRowNode();
	        var rowHasFocus = this.focusedCellController.isRowNodeFocused(rowNode);
	        var rowIsEditing = rowComp.isEditing();
	        var rowIsDetail = rowNode.detail;
	        var mightWantToKeepRow = rowHasFocus || rowIsEditing || rowIsDetail;
	        // if we deffo don't want to keep it,
	        if (!mightWantToKeepRow) {
	            return REMOVE_ROW;
	        }
	        // editing row, only remove if it is no longer rendered, eg filtered out or new data set.
	        // the reason we want to keep is if user is scrolling up and down, we don't want to loose
	        // the context of the editing in process.
	        var rowNodePresent = this.paginationProxy.isRowPresent(rowNode);
	        return rowNodePresent ? KEEP_ROW : REMOVE_ROW;
	    };
	    RowRenderer.prototype.createRowComp = function (rowNode, animate, afterScroll) {
	        var suppressAnimationFrame = this.gridOptionsWrapper.isSuppressAnimationFrame();
	        // we don't use animations frames for printing, so the user can put the grid into print mode
	        // and immediately print - otherwise the user would have to wait for the rows to draw in the background
	        // (via the animation frames) which is awkward to do from code.
	        // we only do the animation frames after scrolling, as this is where we want the smooth user experience.
	        // having animation frames for other times makes the grid look 'jumpy'.
	        var useAnimationFrameForCreate = afterScroll && !suppressAnimationFrame && !this.printLayout;
	        var rowComp = new rowComp_1.RowComp(this.$scope, this.rowContainers.body, this.rowContainers.pinnedLeft, this.rowContainers.pinnedRight, this.rowContainers.fullWidth, rowNode, this.beans, animate, useAnimationFrameForCreate, this.printLayout, this.embedFullWidthRows);
	        rowComp.init();
	        return rowComp;
	    };
	    RowRenderer.prototype.getRenderedNodes = function () {
	        var renderedRows = this.rowCompsByIndex;
	        return Object.keys(renderedRows).map(function (key) {
	            return renderedRows[key].getRowNode();
	        });
	    };
	    // we use index for rows, but column object for columns, as the next column (by index) might not
	    // be visible (header grouping) so it's not reliable, so using the column object instead.
	    RowRenderer.prototype.navigateToNextCell = function (event, key, currentCell, allowUserOverride) {
	        // we keep searching for a next cell until we find one. this is how the group rows get skipped
	        var nextCell = currentCell;
	        var finished = false;
	        while (!finished) {
	            // if the current cell is spanning across multiple columns, we need to move
	            // our current position to be the last cell on the right before finding the
	            // the next target.
	            if (this.gridOptionsWrapper.isEnableRtl()) {
	                if (key === constants_1.Constants.KEY_LEFT) {
	                    nextCell = this.getLastCellOfColSpan(nextCell);
	                }
	            }
	            else if (key === constants_1.Constants.KEY_RIGHT) {
	                nextCell = this.getLastCellOfColSpan(nextCell);
	            }
	            nextCell = this.cellNavigationService.getNextCellToFocus(key, nextCell);
	            // eg if going down, and nextCell=undefined, means we are gone past the last row
	            var hitEdgeOfGrid = utils_1._.missing(nextCell);
	            if (hitEdgeOfGrid) {
	                finished = true;
	                continue;
	            }
	            var rowNode = this.rowPositionUtils.getRowNode(nextCell);
	            // we do not allow focusing on full width rows, this includes details rows
	            if (rowNode.detail) {
	                continue;
	            }
	            // if not a group, then we have a valid row, so quit the search
	            if (!rowNode.group) {
	                finished = true;
	                continue;
	            }
	            // full width rows cannot be focused, so if it's a group and using full width rows,
	            // we need to skip over the row
	            var pivotMode = this.columnController.isPivotMode();
	            var usingFullWidthRows = this.gridOptionsWrapper.isGroupUseEntireRow(pivotMode);
	            if (!usingFullWidthRows) {
	                finished = true;
	            }
	        }
	        // allow user to override what cell to go to next. when doing normal cell navigation (with keys)
	        // we allow this, however if processing 'enter after edit' we don't allow override
	        if (allowUserOverride) {
	            var userFunc = this.gridOptionsWrapper.getNavigateToNextCellFunc();
	            if (utils_1._.exists(userFunc)) {
	                var params = {
	                    key: key,
	                    previousCellPosition: currentCell,
	                    nextCellPosition: nextCell ? nextCell : null,
	                    event: event
	                };
	                var userCell = userFunc(params);
	                if (utils_1._.exists(userCell)) {
	                    if (userCell.floating) {
	                        utils_1._.doOnce(function () { console.warn("ag-Grid: tabToNextCellFunc return type should have attributes: rowIndex, rowPinned, column. However you had 'floating', maybe you meant 'rowPinned'?"); }, 'no floating in userCell');
	                        userCell.rowPinned = userCell.floating;
	                    }
	                    nextCell = {
	                        rowPinned: userCell.rowPinned,
	                        rowIndex: userCell.rowIndex,
	                        column: userCell.column
	                    };
	                }
	                else {
	                    nextCell = null;
	                }
	            }
	        }
	        // no next cell means we have reached a grid boundary, eg left, right, top or bottom of grid
	        if (!nextCell) {
	            return;
	        }
	        // in case we have col spanning we get the cellComp and use it to
	        // get the position. This was we always focus the first cell inside
	        // the spanning.
	        this.ensureCellVisible(nextCell); // ensureCellVisible first, to make sure nextCell is rendered
	        var cellComp = this.getComponentForCell(nextCell);
	        nextCell = cellComp.getCellPosition();
	        // we call this again, as nextCell can be different to it's previous value due to Column Spanning
	        // (ie if cursor moving from right to left, and cell is spanning columns, then nextCell was the
	        // last column in the group, however now it's the first column in the group). if we didn't do
	        // ensureCellVisible again, then we could only be showing the last portion (last column) of the
	        // merged cells.
	        this.ensureCellVisible(nextCell);
	        this.focusedCellController.setFocusedCell(nextCell.rowIndex, nextCell.column, nextCell.rowPinned, true);
	        if (this.rangeController) {
	            this.rangeController.setRangeToCell(nextCell);
	        }
	    };
	    RowRenderer.prototype.getLastCellOfColSpan = function (cell) {
	        var cellComp = this.getComponentForCell(cell);
	        if (!cellComp) {
	            return cell;
	        }
	        var colSpanningList = cellComp.getColSpanningList();
	        if (colSpanningList.length === 1) {
	            return cell;
	        }
	        return {
	            rowIndex: cell.rowIndex,
	            column: utils_1._.last(colSpanningList),
	            rowPinned: cell.rowPinned
	        };
	    };
	    RowRenderer.prototype.ensureCellVisible = function (gridCell) {
	        // this scrolls the row into view
	        if (utils_1._.missing(gridCell.rowPinned)) {
	            this.gridPanel.ensureIndexVisible(gridCell.rowIndex);
	        }
	        if (!gridCell.column.isPinned()) {
	            this.gridPanel.ensureColumnVisible(gridCell.column);
	        }
	        // need to nudge the scrolls for the floating items. otherwise when we set focus on a non-visible
	        // floating cell, the scrolls get out of sync
	        this.gridPanel.horizontallyScrollHeaderCenterAndFloatingCenter();
	        // need to flush frames, to make sure the correct cells are rendered
	        this.animationFrameService.flushAllFrames();
	    };
	    RowRenderer.prototype.startEditingCell = function (gridCell, keyPress, charPress) {
	        var cell = this.getComponentForCell(gridCell);
	        if (cell) {
	            cell.startRowOrCellEdit(keyPress, charPress);
	        }
	    };
	    RowRenderer.prototype.getComponentForCell = function (cellPosition) {
	        var rowComponent;
	        switch (cellPosition.rowPinned) {
	            case constants_1.Constants.PINNED_TOP:
	                rowComponent = this.floatingTopRowComps[cellPosition.rowIndex];
	                break;
	            case constants_1.Constants.PINNED_BOTTOM:
	                rowComponent = this.floatingBottomRowComps[cellPosition.rowIndex];
	                break;
	            default:
	                rowComponent = this.rowCompsByIndex[cellPosition.rowIndex];
	                break;
	        }
	        if (!rowComponent) {
	            return null;
	        }
	        var cellComponent = rowComponent.getRenderedCellForColumn(cellPosition.column);
	        return cellComponent;
	    };
	    RowRenderer.prototype.getRowNode = function (gridRow) {
	        switch (gridRow.rowPinned) {
	            case constants_1.Constants.PINNED_TOP:
	                return this.pinnedRowModel.getPinnedTopRowData()[gridRow.rowIndex];
	            case constants_1.Constants.PINNED_BOTTOM:
	                return this.pinnedRowModel.getPinnedBottomRowData()[gridRow.rowIndex];
	            default:
	                return this.rowModel.getRow(gridRow.rowIndex);
	        }
	    };
	    RowRenderer.prototype.onTabKeyDown = function (previousRenderedCell, keyboardEvent) {
	        var backwards = keyboardEvent.shiftKey;
	        var success = this.moveToCellAfter(previousRenderedCell, backwards);
	        if (success) {
	            keyboardEvent.preventDefault();
	        }
	    };
	    RowRenderer.prototype.tabToNextCell = function (backwards) {
	        var focusedCell = this.focusedCellController.getFocusedCell();
	        // if no focus, then cannot navigate
	        if (utils_1._.missing(focusedCell)) {
	            return false;
	        }
	        var renderedCell = this.getComponentForCell(focusedCell);
	        // if cell is not rendered, means user has scrolled away from the cell
	        if (utils_1._.missing(renderedCell)) {
	            return false;
	        }
	        var result = this.moveToCellAfter(renderedCell, backwards);
	        return result;
	    };
	    RowRenderer.prototype.moveToCellAfter = function (previousRenderedCell, backwards) {
	        var editing = previousRenderedCell.isEditing();
	        var res;
	        if (editing) {
	            if (this.gridOptionsWrapper.isFullRowEdit()) {
	                res = this.moveToNextEditingRow(previousRenderedCell, backwards);
	            }
	            else {
	                res = this.moveToNextEditingCell(previousRenderedCell, backwards);
	            }
	        }
	        else {
	            res = this.moveToNextCellNotEditing(previousRenderedCell, backwards);
	        }
	        return res;
	    };
	    RowRenderer.prototype.moveToNextEditingCell = function (previousRenderedCell, backwards) {
	        var gridCell = previousRenderedCell.getCellPosition();
	        // need to do this before getting next cell to edit, in case the next cell
	        // has editable function (eg colDef.editable=func() ) and it depends on the
	        // result of this cell, so need to save updates from the first edit, in case
	        // the value is referenced in the function.
	        previousRenderedCell.stopEditing();
	        // find the next cell to start editing
	        var nextRenderedCell = this.findNextCellToFocusOn(gridCell, backwards, true);
	        var foundCell = utils_1._.exists(nextRenderedCell);
	        // only prevent default if we found a cell. so if user is on last cell and hits tab, then we default
	        // to the normal tabbing so user can exit the grid.
	        if (foundCell) {
	            nextRenderedCell.startEditingIfEnabled(null, null, true);
	            nextRenderedCell.focusCell(false);
	        }
	        return foundCell;
	    };
	    RowRenderer.prototype.moveToNextEditingRow = function (previousRenderedCell, backwards) {
	        var gridCell = previousRenderedCell.getCellPosition();
	        // find the next cell to start editing
	        var nextRenderedCell = this.findNextCellToFocusOn(gridCell, backwards, true);
	        var foundCell = utils_1._.exists(nextRenderedCell);
	        // only prevent default if we found a cell. so if user is on last cell and hits tab, then we default
	        // to the normal tabbing so user can exit the grid.
	        if (foundCell) {
	            this.moveEditToNextCellOrRow(previousRenderedCell, nextRenderedCell);
	        }
	        return foundCell;
	    };
	    RowRenderer.prototype.moveToNextCellNotEditing = function (previousRenderedCell, backwards) {
	        var gridCell = previousRenderedCell.getCellPosition();
	        // find the next cell to start editing
	        var nextRenderedCell = this.findNextCellToFocusOn(gridCell, backwards, false);
	        var foundCell = utils_1._.exists(nextRenderedCell);
	        // only prevent default if we found a cell. so if user is on last cell and hits tab, then we default
	        // to the normal tabbing so user can exit the grid.
	        if (foundCell) {
	            nextRenderedCell.focusCell(true);
	        }
	        return foundCell;
	    };
	    RowRenderer.prototype.moveEditToNextCellOrRow = function (previousRenderedCell, nextRenderedCell) {
	        var pGridCell = previousRenderedCell.getCellPosition();
	        var nGridCell = nextRenderedCell.getCellPosition();
	        var rowsMatch = pGridCell.rowIndex === nGridCell.rowIndex && pGridCell.rowPinned === nGridCell.rowPinned;
	        if (rowsMatch) {
	            // same row, so we don't start / stop editing, we just move the focus along
	            previousRenderedCell.setFocusOutOnEditor();
	            nextRenderedCell.setFocusInOnEditor();
	        }
	        else {
	            var pRow = previousRenderedCell.getRenderedRow();
	            var nRow = nextRenderedCell.getRenderedRow();
	            previousRenderedCell.setFocusOutOnEditor();
	            pRow.stopEditing();
	            nRow.startRowEditing();
	            nextRenderedCell.setFocusInOnEditor();
	        }
	        nextRenderedCell.focusCell();
	    };
	    // called by the cell, when tab is pressed while editing.
	    // @return: RenderedCell when navigation successful, otherwise null
	    RowRenderer.prototype.findNextCellToFocusOn = function (gridCell, backwards, startEditing) {
	        var nextCell = gridCell;
	        while (true) {
	            if (!backwards) {
	                nextCell = this.getLastCellOfColSpan(nextCell);
	            }
	            nextCell = this.cellNavigationService.getNextTabbedCell(nextCell, backwards);
	            // allow user to override what cell to go to next
	            var userFunc = this.gridOptionsWrapper.getTabToNextCellFunc();
	            if (utils_1._.exists(userFunc)) {
	                var params = {
	                    backwards: backwards,
	                    editing: startEditing,
	                    previousCellPosition: gridCell,
	                    nextCellPosition: nextCell ? nextCell : null
	                };
	                var userCell = userFunc(params);
	                if (utils_1._.exists(userCell)) {
	                    if (userCell.floating) {
	                        utils_1._.doOnce(function () { console.warn("ag-Grid: tabToNextCellFunc return type should have attributes: rowIndex, rowPinned, column. However you had 'floating', maybe you meant 'rowPinned'?"); }, 'no floating in userCell');
	                        userCell.rowPinned = userCell.floating;
	                    }
	                    nextCell = {
	                        rowIndex: userCell.rowIndex,
	                        column: userCell.column,
	                        rowPinned: userCell.rowPinned
	                    };
	                }
	                else {
	                    nextCell = null;
	                }
	            }
	            // if no 'next cell', means we have got to last cell of grid, so nothing to move to,
	            // so bottom right cell going forwards, or top left going backwards
	            if (!nextCell) {
	                return null;
	            }
	            // if editing, but cell not editable, skip cell. we do this before we do all of
	            // the 'ensure index visible' and 'flush all frames', otherwise if we are skipping
	            // a bunch of cells (eg 10 rows) then all the work on ensuring cell visible is useless
	            // (except for the last one) which causes grid to stall for a while.
	            if (startEditing) {
	                var rowNode = this.lookupRowNodeForCell(nextCell);
	                var cellIsEditable = nextCell.column.isCellEditable(rowNode);
	                if (!cellIsEditable) {
	                    continue;
	                }
	            }
	            // this scrolls the row into view
	            var cellIsNotFloating = utils_1._.missing(nextCell.rowPinned);
	            if (cellIsNotFloating) {
	                this.gridPanel.ensureIndexVisible(nextCell.rowIndex);
	            }
	            // pinned columns don't scroll, so no need to ensure index visible
	            if (!nextCell.column.isPinned()) {
	                this.gridPanel.ensureColumnVisible(nextCell.column);
	            }
	            // need to nudge the scrolls for the floating items. otherwise when we set focus on a non-visible
	            // floating cell, the scrolls get out of sync
	            this.gridPanel.horizontallyScrollHeaderCenterAndFloatingCenter();
	            // get the grid panel to flush all animation frames - otherwise the call below to get the cellComp
	            // could fail, if we just scrolled the grid (to make a cell visible) and the rendering hasn't finished.
	            this.animationFrameService.flushAllFrames();
	            // we have to call this after ensureColumnVisible - otherwise it could be a virtual column
	            // or row that is not currently in view, hence the renderedCell would not exist
	            var nextCellComp = this.getComponentForCell(nextCell);
	            // if next cell is fullWidth row, then no rendered cell,
	            // as fullWidth rows have no cells, so we skip it
	            if (utils_1._.missing(nextCellComp)) {
	                continue;
	            }
	            if (nextCellComp.isSuppressNavigable()) {
	                continue;
	            }
	            // by default, when we click a cell, it gets selected into a range, so to keep keyboard navigation
	            // consistent, we set into range here also.
	            if (this.rangeController) {
	                this.rangeController.setRangeToCell(nextCell);
	            }
	            // we successfully tabbed onto a grid cell, so return true
	            return nextCellComp;
	        }
	    };
	    RowRenderer.prototype.lookupRowNodeForCell = function (cell) {
	        if (cell.rowPinned === constants_1.Constants.PINNED_TOP) {
	            return this.pinnedRowModel.getPinnedTopRow(cell.rowIndex);
	        }
	        if (cell.rowPinned === constants_1.Constants.PINNED_BOTTOM) {
	            return this.pinnedRowModel.getPinnedBottomRow(cell.rowIndex);
	        }
	        return this.paginationProxy.getRow(cell.rowIndex);
	    };
	    __decorate([
	        context_1.Autowired("paginationProxy"),
	        __metadata("design:type", paginationProxy_1.PaginationProxy)
	    ], RowRenderer.prototype, "paginationProxy", void 0);
	    __decorate([
	        context_1.Autowired("columnController"),
	        __metadata("design:type", columnController_1.ColumnController)
	    ], RowRenderer.prototype, "columnController", void 0);
	    __decorate([
	        context_1.Autowired("gridOptionsWrapper"),
	        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
	    ], RowRenderer.prototype, "gridOptionsWrapper", void 0);
	    __decorate([
	        context_1.Autowired("$scope"),
	        __metadata("design:type", Object)
	    ], RowRenderer.prototype, "$scope", void 0);
	    __decorate([
	        context_1.Autowired("eventService"),
	        __metadata("design:type", eventService_1.EventService)
	    ], RowRenderer.prototype, "eventService", void 0);
	    __decorate([
	        context_1.Autowired("pinnedRowModel"),
	        __metadata("design:type", pinnedRowModel_1.PinnedRowModel)
	    ], RowRenderer.prototype, "pinnedRowModel", void 0);
	    __decorate([
	        context_1.Autowired("rowModel"),
	        __metadata("design:type", Object)
	    ], RowRenderer.prototype, "rowModel", void 0);
	    __decorate([
	        context_1.Autowired("loggerFactory"),
	        __metadata("design:type", logger_1.LoggerFactory)
	    ], RowRenderer.prototype, "loggerFactory", void 0);
	    __decorate([
	        context_1.Autowired("focusedCellController"),
	        __metadata("design:type", focusedCellController_1.FocusedCellController)
	    ], RowRenderer.prototype, "focusedCellController", void 0);
	    __decorate([
	        context_1.Autowired("cellNavigationService"),
	        __metadata("design:type", cellNavigationService_1.CellNavigationService)
	    ], RowRenderer.prototype, "cellNavigationService", void 0);
	    __decorate([
	        context_1.Autowired("columnApi"),
	        __metadata("design:type", columnApi_1.ColumnApi)
	    ], RowRenderer.prototype, "columnApi", void 0);
	    __decorate([
	        context_1.Autowired("gridApi"),
	        __metadata("design:type", gridApi_1.GridApi)
	    ], RowRenderer.prototype, "gridApi", void 0);
	    __decorate([
	        context_1.Autowired("beans"),
	        __metadata("design:type", beans_1.Beans)
	    ], RowRenderer.prototype, "beans", void 0);
	    __decorate([
	        context_1.Autowired("maxDivHeightScaler"),
	        __metadata("design:type", maxDivHeightScaler_1.MaxDivHeightScaler)
	    ], RowRenderer.prototype, "maxDivHeightScaler", void 0);
	    __decorate([
	        context_1.Autowired("animationFrameService"),
	        __metadata("design:type", animationFrameService_1.AnimationFrameService)
	    ], RowRenderer.prototype, "animationFrameService", void 0);
	    __decorate([
	        context_1.Autowired("rowPositionUtils"),
	        __metadata("design:type", rowPosition_1.RowPositionUtils)
	    ], RowRenderer.prototype, "rowPositionUtils", void 0);
	    __decorate([
	        context_1.Optional("rangeController"),
	        __metadata("design:type", Object)
	    ], RowRenderer.prototype, "rangeController", void 0);
	    __decorate([
	        __param(0, context_1.Qualifier("loggerFactory")),
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", [logger_1.LoggerFactory]),
	        __metadata("design:returntype", void 0)
	    ], RowRenderer.prototype, "agWire", null);
	    RowRenderer = __decorate([
	        context_1.Bean("rowRenderer")
	    ], RowRenderer);
	    return RowRenderer;
	}(beanStub_1.BeanStub));
	exports.RowRenderer = RowRenderer;


/***/ }),
/* 2351 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __assign = (this && this.__assign) || function () {
	    __assign = Object.assign || function(t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	                t[p] = s[p];
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var cellComp_1 = __webpack_require__(2352);
	var rowNode_1 = __webpack_require__(2356);
	var column_1 = __webpack_require__(2343);
	var events_1 = __webpack_require__(2335);
	var component_1 = __webpack_require__(2353);
	var utils_1 = __webpack_require__(2325);
	var RowComp = /** @class */ (function (_super) {
	    __extends(RowComp, _super);
	    function RowComp(parentScope, bodyContainerComp, pinnedLeftContainerComp, pinnedRightContainerComp, fullWidthContainerComp, rowNode, beans, animateIn, useAnimationFrameForCreate, printLayout, embedFullWidth) {
	        var _this = _super.call(this) || this;
	        _this.eAllRowContainers = [];
	        _this.active = true;
	        _this.rowContainerReadyCount = 0;
	        _this.refreshNeeded = false;
	        _this.columnRefreshPending = false;
	        _this.cellComps = {};
	        // for animations, there are bits we want done in the next VM turn, to all DOM to update first.
	        // instead of each row doing a setTimeout(func,0), we put the functions here and the rowRenderer
	        // executes them all in one timeout
	        _this.createSecondPassFuncs = [];
	        // these get called before the row is destroyed - they set up the DOM for the remove animation (ie they
	        // set the DOM up for the animation), then the delayedDestroyFunctions get called when the animation is
	        // complete (ie removes from the dom).
	        _this.removeFirstPassFuncs = [];
	        // for animations, these functions get called 400ms after the row is cleared, called by the rowRenderer
	        // so each row isn't setting up it's own timeout
	        _this.removeSecondPassFuncs = [];
	        _this.initialised = false;
	        _this.parentScope = parentScope;
	        _this.beans = beans;
	        _this.bodyContainerComp = bodyContainerComp;
	        _this.pinnedLeftContainerComp = pinnedLeftContainerComp;
	        _this.pinnedRightContainerComp = pinnedRightContainerComp;
	        _this.fullWidthContainerComp = fullWidthContainerComp;
	        _this.rowNode = rowNode;
	        _this.rowIsEven = _this.rowNode.rowIndex % 2 === 0;
	        _this.paginationPage = _this.beans.paginationProxy.getCurrentPage();
	        _this.useAnimationFrameForCreate = useAnimationFrameForCreate;
	        _this.printLayout = printLayout;
	        _this.embedFullWidth = embedFullWidth;
	        _this.setAnimateFlags(animateIn);
	        return _this;
	    }
	    RowComp.prototype.init = function () {
	        var _this = this;
	        this.rowFocused = this.beans.focusedCellController.isRowFocused(this.rowNode.rowIndex, this.rowNode.rowPinned);
	        this.scope = this.createChildScopeOrNull(this.rowNode.data);
	        this.setupRowContainers();
	        this.addListeners();
	        if (this.slideRowIn) {
	            this.createSecondPassFuncs.push(function () {
	                _this.onTopChanged();
	            });
	        }
	        if (this.fadeRowIn) {
	            this.createSecondPassFuncs.push(function () {
	                _this.eAllRowContainers.forEach(function (eRow) { return utils_1._.removeCssClass(eRow, 'ag-opacity-zero'); });
	            });
	        }
	    };
	    RowComp.prototype.createTemplate = function (contents, extraCssClass) {
	        if (extraCssClass === void 0) { extraCssClass = null; }
	        var templateParts = [];
	        var rowHeight = this.rowNode.rowHeight;
	        var rowClasses = this.getInitialRowClasses(extraCssClass).join(' ');
	        var rowIdSanitised = utils_1._.escape(this.rowNode.id);
	        var userRowStyles = this.preProcessStylesFromGridOptions();
	        var businessKey = this.getRowBusinessKey();
	        var businessKeySanitised = utils_1._.escape(businessKey);
	        var rowTopStyle = this.getInitialRowTopStyle();
	        var rowIdx = this.rowNode.getRowIndexString();
	        var headerRowCount = this.beans.gridPanel.headerRootComp.getHeaderRowCount();
	        templateParts.push("<div");
	        templateParts.push(" role=\"row\"");
	        templateParts.push(" row-index=\"" + rowIdx + "\" aria-rowindex=\"" + (headerRowCount + this.rowNode.rowIndex + 1) + "\"");
	        templateParts.push(rowIdSanitised ? " row-id=\"" + rowIdSanitised + "\"" : "");
	        templateParts.push(businessKey ? " row-business-key=\"" + businessKeySanitised + "\"" : "");
	        templateParts.push(" comp-id=\"" + this.getCompId() + "\"");
	        templateParts.push(" class=\"" + rowClasses + "\"");
	        templateParts.push(" style=\"height: " + rowHeight + "px; " + rowTopStyle + " " + userRowStyles + "\">");
	        // add in the template for the cells
	        templateParts.push(contents);
	        templateParts.push("</div>");
	        return templateParts.join('');
	    };
	    RowComp.prototype.getCellForCol = function (column) {
	        var cellComp = this.cellComps[column.getColId()];
	        return cellComp ? cellComp.getGui() : null;
	    };
	    RowComp.prototype.afterFlush = function () {
	        if (this.initialised) {
	            return;
	        }
	        this.initialised = true;
	        this.executeProcessRowPostCreateFunc();
	    };
	    RowComp.prototype.executeProcessRowPostCreateFunc = function () {
	        var func = this.beans.gridOptionsWrapper.getProcessRowPostCreateFunc();
	        if (!func) {
	            return;
	        }
	        var params = {
	            eRow: this.eBodyRow,
	            ePinnedLeftRow: this.ePinnedLeftRow,
	            ePinnedRightRow: this.ePinnedRightRow,
	            node: this.rowNode,
	            api: this.beans.gridOptionsWrapper.getApi(),
	            rowIndex: this.rowNode.rowIndex,
	            addRenderedRowListener: this.addEventListener.bind(this),
	            columnApi: this.beans.gridOptionsWrapper.getColumnApi(),
	            context: this.beans.gridOptionsWrapper.getContext()
	        };
	        func(params);
	    };
	    RowComp.prototype.getInitialRowTopStyle = function () {
	        // print layout uses normal flow layout for row positioning
	        if (this.printLayout) {
	            return '';
	        }
	        // if sliding in, we take the old row top. otherwise we just set the current row top.
	        var pixels = this.slideRowIn ? this.roundRowTopToBounds(this.rowNode.oldRowTop) : this.rowNode.rowTop;
	        var afterPaginationPixels = this.applyPaginationOffset(pixels);
	        var afterScalingPixels = this.beans.maxDivHeightScaler.getRealPixelPosition(afterPaginationPixels);
	        var isSuppressRowTransform = this.beans.gridOptionsWrapper.isSuppressRowTransform();
	        return isSuppressRowTransform ? "top: " + afterScalingPixels + "px; " : "transform: translateY(" + afterScalingPixels + "px);";
	    };
	    RowComp.prototype.getRowBusinessKey = function () {
	        var businessKeyForNodeFunc = this.beans.gridOptionsWrapper.getBusinessKeyForNodeFunc();
	        if (typeof businessKeyForNodeFunc !== 'function') {
	            return;
	        }
	        return businessKeyForNodeFunc(this.rowNode);
	    };
	    RowComp.prototype.areAllContainersReady = function () {
	        return this.rowContainerReadyCount === 3;
	    };
	    RowComp.prototype.lazyCreateCells = function (cols, eRow) {
	        if (!this.active) {
	            return;
	        }
	        var cellTemplatesAndComps = this.createCells(cols);
	        eRow.innerHTML = cellTemplatesAndComps.template;
	        this.callAfterRowAttachedOnCells(cellTemplatesAndComps.cellComps, eRow);
	        this.rowContainerReadyCount++;
	        if (this.areAllContainersReady() && this.refreshNeeded) {
	            this.refreshCells();
	        }
	    };
	    RowComp.prototype.createRowContainer = function (rowContainerComp, cols, callback) {
	        var _this = this;
	        var useAnimationsFrameForCreate = this.useAnimationFrameForCreate;
	        var cellTemplatesAndComps = useAnimationsFrameForCreate ? { cellComps: [], template: '' } : this.createCells(cols);
	        var rowTemplate = this.createTemplate(cellTemplatesAndComps.template);
	        // the RowRenderer is probably inserting many rows. rather than inserting each template one
	        // at a time, the grid inserts all rows together - so the callback here is called by the
	        // rowRenderer when all RowComps are created, then all the HTML is inserted in one go,
	        // and then all the callbacks are called. this is NOT done in an animation frame.
	        rowContainerComp.appendRowTemplate(rowTemplate, function () {
	            var eRow = rowContainerComp.getRowElement(_this.getCompId());
	            _this.afterRowAttached(rowContainerComp, eRow);
	            callback(eRow);
	            if (useAnimationsFrameForCreate) {
	                _this.beans.taskQueue.addP1Task(_this.lazyCreateCells.bind(_this, cols, eRow), _this.rowNode.rowIndex);
	            }
	            else {
	                _this.callAfterRowAttachedOnCells(cellTemplatesAndComps.cellComps, eRow);
	                _this.rowContainerReadyCount = 3;
	            }
	        });
	    };
	    RowComp.prototype.createChildScopeOrNull = function (data) {
	        var isAngularCompileRows = this.beans.gridOptionsWrapper.isAngularCompileRows();
	        if (!isAngularCompileRows) {
	            return null;
	        }
	        var newChildScope = this.parentScope.$new();
	        newChildScope.data = __assign({}, data);
	        newChildScope.rowNode = this.rowNode;
	        newChildScope.context = this.beans.gridOptionsWrapper.getContext();
	        this.addDestroyFunc(function () {
	            newChildScope.$destroy();
	            newChildScope.data = null;
	            newChildScope.rowNode = null;
	            newChildScope.context = null;
	        });
	        return newChildScope;
	    };
	    RowComp.prototype.setupRowContainers = function () {
	        var isFullWidthCellFunc = this.beans.gridOptionsWrapper.getIsFullWidthCellFunc();
	        var isFullWidthCell = isFullWidthCellFunc ? isFullWidthCellFunc(this.rowNode) : false;
	        var isDetailCell = this.beans.doingMasterDetail && this.rowNode.detail;
	        var pivotMode = this.beans.columnController.isPivotMode();
	        // we only use full width for groups, not footers. it wouldn't make sense to include footers if not looking
	        // for totals. if users complain about this, then we should introduce a new property 'footerUseEntireRow'
	        // so each can be set independently (as a customer complained about footers getting full width, hence
	        // introducing this logic)
	        var isGroupRow = this.rowNode.group && !this.rowNode.footer;
	        var isFullWidthGroup = isGroupRow && this.beans.gridOptionsWrapper.isGroupUseEntireRow(pivotMode);
	        if (this.rowNode.stub) {
	            this.createFullWidthRows(RowComp.LOADING_CELL_RENDERER, RowComp.LOADING_CELL_RENDERER_COMP_NAME);
	        }
	        else if (isDetailCell) {
	            this.createFullWidthRows(RowComp.DETAIL_CELL_RENDERER, RowComp.DETAIL_CELL_RENDERER_COMP_NAME);
	        }
	        else if (isFullWidthCell) {
	            this.createFullWidthRows(RowComp.FULL_WIDTH_CELL_RENDERER, null);
	        }
	        else if (isFullWidthGroup) {
	            this.createFullWidthRows(RowComp.GROUP_ROW_RENDERER, RowComp.GROUP_ROW_RENDERER_COMP_NAME);
	        }
	        else {
	            this.setupNormalRowContainers();
	        }
	    };
	    RowComp.prototype.setupNormalRowContainers = function () {
	        var _this = this;
	        var centerCols;
	        var leftCols;
	        var rightCols;
	        if (this.printLayout) {
	            centerCols = this.beans.columnController.getAllDisplayedColumns();
	            leftCols = [];
	            rightCols = [];
	        }
	        else {
	            centerCols = this.beans.columnController.getAllDisplayedCenterVirtualColumnsForRow(this.rowNode);
	            leftCols = this.beans.columnController.getDisplayedLeftColumnsForRow(this.rowNode);
	            rightCols = this.beans.columnController.getDisplayedRightColumnsForRow(this.rowNode);
	        }
	        this.createRowContainer(this.bodyContainerComp, centerCols, function (eRow) { return _this.eBodyRow = eRow; });
	        this.createRowContainer(this.pinnedRightContainerComp, rightCols, function (eRow) { return _this.ePinnedRightRow = eRow; });
	        this.createRowContainer(this.pinnedLeftContainerComp, leftCols, function (eRow) { return _this.ePinnedLeftRow = eRow; });
	    };
	    RowComp.prototype.createFullWidthRows = function (type, name) {
	        var _this = this;
	        this.fullWidthRow = true;
	        if (this.embedFullWidth) {
	            this.createFullWidthRowContainer(this.bodyContainerComp, null, null, type, name, function (eRow) {
	                _this.eFullWidthRowBody = eRow;
	            }, function (cellRenderer) {
	                _this.fullWidthRowComponentBody = cellRenderer;
	            });
	            // printLayout doesn't put components into the pinned sections
	            if (!this.printLayout) {
	                this.createFullWidthRowContainer(this.pinnedLeftContainerComp, column_1.Column.PINNED_LEFT, 'ag-cell-last-left-pinned', type, name, function (eRow) {
	                    _this.eFullWidthRowLeft = eRow;
	                }, function (cellRenderer) {
	                    _this.fullWidthRowComponentLeft = cellRenderer;
	                });
	                this.createFullWidthRowContainer(this.pinnedRightContainerComp, column_1.Column.PINNED_RIGHT, 'ag-cell-first-right-pinned', type, name, function (eRow) {
	                    _this.eFullWidthRowRight = eRow;
	                }, function (cellRenderer) {
	                    _this.fullWidthRowComponentRight = cellRenderer;
	                });
	            }
	        }
	        else {
	            // otherwise we add to the fullWidth container as normal
	            // let previousFullWidth = ensureDomOrder ? this.lastPlacedElements.eFullWidth : null;
	            this.createFullWidthRowContainer(this.fullWidthContainerComp, null, null, type, name, function (eRow) {
	                _this.eFullWidthRow = eRow;
	            }, function (cellRenderer) {
	                _this.fullWidthRowComponent = cellRenderer;
	            });
	        }
	    };
	    RowComp.prototype.setAnimateFlags = function (animateIn) {
	        if (animateIn) {
	            var oldRowTopExists = utils_1._.exists(this.rowNode.oldRowTop);
	            // if the row had a previous position, we slide it in (animate row top)
	            this.slideRowIn = oldRowTopExists;
	            // if the row had no previous position, we fade it in (animate
	            this.fadeRowIn = !oldRowTopExists;
	        }
	        else {
	            this.slideRowIn = false;
	            this.fadeRowIn = false;
	        }
	    };
	    RowComp.prototype.isEditing = function () {
	        return this.editingRow;
	    };
	    RowComp.prototype.stopRowEditing = function (cancel) {
	        this.stopEditing(cancel);
	    };
	    RowComp.prototype.isFullWidth = function () {
	        return this.fullWidthRow;
	    };
	    RowComp.prototype.refreshFullWidth = function () {
	        var _this = this;
	        // returns 'true' if refresh succeeded
	        var tryRefresh = function (eRow, eCellComp, pinned) {
	            if (!eRow || !eCellComp) {
	                // no refresh needed
	                return true;
	            }
	            if (!eCellComp.refresh) {
	                // no refresh method present, so can't refresh, hard refresh needed
	                return false;
	            }
	            var params = _this.createFullWidthParams(eRow, pinned);
	            var refreshSucceeded = eCellComp.refresh(params);
	            return refreshSucceeded;
	        };
	        var normalSuccess = tryRefresh(this.eFullWidthRow, this.fullWidthRowComponent, null);
	        var bodySuccess = tryRefresh(this.eFullWidthRowBody, this.fullWidthRowComponentBody, null);
	        var leftSuccess = tryRefresh(this.eFullWidthRowLeft, this.fullWidthRowComponentLeft, column_1.Column.PINNED_LEFT);
	        var rightSuccess = tryRefresh(this.eFullWidthRowRight, this.fullWidthRowComponentRight, column_1.Column.PINNED_RIGHT);
	        var allFullWidthRowsRefreshed = normalSuccess && bodySuccess && leftSuccess && rightSuccess;
	        return allFullWidthRowsRefreshed;
	    };
	    RowComp.prototype.addListeners = function () {
	        this.addDestroyableEventListener(this.rowNode, rowNode_1.RowNode.EVENT_HEIGHT_CHANGED, this.onRowHeightChanged.bind(this));
	        this.addDestroyableEventListener(this.rowNode, rowNode_1.RowNode.EVENT_ROW_SELECTED, this.onRowSelected.bind(this));
	        this.addDestroyableEventListener(this.rowNode, rowNode_1.RowNode.EVENT_ROW_INDEX_CHANGED, this.onRowIndexChanged.bind(this));
	        this.addDestroyableEventListener(this.rowNode, rowNode_1.RowNode.EVENT_TOP_CHANGED, this.onTopChanged.bind(this));
	        this.addDestroyableEventListener(this.rowNode, rowNode_1.RowNode.EVENT_EXPANDED_CHANGED, this.onExpandedChanged.bind(this));
	        this.addDestroyableEventListener(this.rowNode, rowNode_1.RowNode.EVENT_DATA_CHANGED, this.onRowNodeDataChanged.bind(this));
	        this.addDestroyableEventListener(this.rowNode, rowNode_1.RowNode.EVENT_CELL_CHANGED, this.onRowNodeCellChanged.bind(this));
	        this.addDestroyableEventListener(this.rowNode, rowNode_1.RowNode.EVENT_DRAGGING_CHANGED, this.onRowNodeDraggingChanged.bind(this));
	        var eventService = this.beans.eventService;
	        this.addDestroyableEventListener(eventService, events_1.Events.EVENT_HEIGHT_SCALE_CHANGED, this.onTopChanged.bind(this));
	        this.addDestroyableEventListener(eventService, events_1.Events.EVENT_DISPLAYED_COLUMNS_CHANGED, this.onDisplayedColumnsChanged.bind(this));
	        this.addDestroyableEventListener(eventService, events_1.Events.EVENT_VIRTUAL_COLUMNS_CHANGED, this.onVirtualColumnsChanged.bind(this));
	        this.addDestroyableEventListener(eventService, events_1.Events.EVENT_COLUMN_RESIZED, this.onColumnResized.bind(this));
	        this.addDestroyableEventListener(eventService, events_1.Events.EVENT_CELL_FOCUSED, this.onCellFocusChanged.bind(this));
	        this.addDestroyableEventListener(eventService, events_1.Events.EVENT_PAGINATION_CHANGED, this.onPaginationChanged.bind(this));
	        this.addDestroyableEventListener(eventService, events_1.Events.EVENT_GRID_COLUMNS_CHANGED, this.onGridColumnsChanged.bind(this));
	        this.addDestroyableEventListener(eventService, events_1.Events.EVENT_MODEL_UPDATED, this.onModelUpdated.bind(this));
	        this.addListenersForCellComps();
	    };
	    RowComp.prototype.addListenersForCellComps = function () {
	        var _this = this;
	        this.addDestroyableEventListener(this.rowNode, rowNode_1.RowNode.EVENT_ROW_INDEX_CHANGED, function () {
	            _this.forEachCellComp(function (cellComp) { return cellComp.onRowIndexChanged(); });
	        });
	        this.addDestroyableEventListener(this.rowNode, rowNode_1.RowNode.EVENT_CELL_CHANGED, function (event) {
	            _this.forEachCellComp(function (cellComp) { return cellComp.onCellChanged(event); });
	        });
	    };
	    // when grid columns change, then all cells should be cleaned out,
	    // as the new columns could have same id as the previous columns and may conflict
	    RowComp.prototype.onGridColumnsChanged = function () {
	        this.removeRenderedCells(Object.keys(this.cellComps));
	    };
	    RowComp.prototype.onRowNodeDataChanged = function (event) {
	        // if this is an update, we want to refresh, as this will allow the user to put in a transition
	        // into the cellRenderer refresh method. otherwise this might be completely new data, in which case
	        // we will want to completely replace the cells
	        this.forEachCellComp(function (cellComp) {
	            return cellComp.refreshCell({
	                suppressFlash: !event.update,
	                newData: !event.update
	            });
	        });
	        // check for selected also, as this could be after lazy loading of the row data, in which case
	        // the id might of just gotten set inside the row and the row selected state may of changed
	        // as a result. this is what happens when selected rows are loaded in virtual pagination.
	        // - niall note - since moving to the stub component, this may no longer be true, as replacing
	        // the stub component now replaces the entire row
	        this.onRowSelected();
	        // as data has changed, then the style and class needs to be recomputed
	        this.postProcessCss();
	    };
	    RowComp.prototype.onRowNodeCellChanged = function (event) {
	        // as data has changed, then the style and class needs to be recomputed
	        this.postProcessCss();
	    };
	    RowComp.prototype.postProcessCss = function () {
	        this.postProcessStylesFromGridOptions();
	        this.postProcessClassesFromGridOptions();
	        this.postProcessRowClassRules();
	        this.postProcessRowDragging();
	    };
	    RowComp.prototype.onRowNodeDraggingChanged = function () {
	        this.postProcessRowDragging();
	    };
	    RowComp.prototype.postProcessRowDragging = function () {
	        var dragging = this.rowNode.dragging;
	        this.eAllRowContainers.forEach(function (row) { return utils_1._.addOrRemoveCssClass(row, 'ag-row-dragging', dragging); });
	    };
	    RowComp.prototype.onExpandedChanged = function () {
	        var rowNode = this.rowNode;
	        this.eAllRowContainers.forEach(function (row) { return utils_1._.addOrRemoveCssClass(row, 'ag-row-group-expanded', rowNode.expanded); });
	        this.eAllRowContainers.forEach(function (row) { return utils_1._.addOrRemoveCssClass(row, 'ag-row-group-contracted', !rowNode.expanded); });
	    };
	    RowComp.prototype.onDisplayedColumnsChanged = function () {
	        if (this.fullWidthRow) {
	            return;
	        }
	        this.refreshCells();
	    };
	    RowComp.prototype.destroyFullWidthComponents = function () {
	        if (this.fullWidthRowComponent) {
	            this.beans.detailRowCompCache.addOrDestroy(this.rowNode, null, this.fullWidthRowComponent);
	            this.fullWidthRowComponent = null;
	        }
	        if (this.fullWidthRowComponentBody) {
	            this.beans.detailRowCompCache.addOrDestroy(this.rowNode, null, this.fullWidthRowComponentBody);
	            this.fullWidthRowComponent = null;
	        }
	        if (this.fullWidthRowComponentLeft) {
	            this.beans.detailRowCompCache.addOrDestroy(this.rowNode, column_1.Column.PINNED_LEFT, this.fullWidthRowComponentLeft);
	            this.fullWidthRowComponentLeft = null;
	        }
	        if (this.fullWidthRowComponentRight) {
	            this.beans.detailRowCompCache.addOrDestroy(this.rowNode, column_1.Column.PINNED_RIGHT, this.fullWidthRowComponentRight);
	            this.fullWidthRowComponent = null;
	        }
	    };
	    RowComp.prototype.getContainerForCell = function (pinnedType) {
	        switch (pinnedType) {
	            case column_1.Column.PINNED_LEFT: return this.ePinnedLeftRow;
	            case column_1.Column.PINNED_RIGHT: return this.ePinnedRightRow;
	            default: return this.eBodyRow;
	        }
	    };
	    RowComp.prototype.onVirtualColumnsChanged = function () {
	        if (this.fullWidthRow) {
	            return;
	        }
	        this.refreshCells();
	    };
	    RowComp.prototype.onColumnResized = function () {
	        if (this.fullWidthRow) {
	            return;
	        }
	        this.refreshCells();
	    };
	    RowComp.prototype.refreshCells = function () {
	        if (!this.areAllContainersReady()) {
	            this.refreshNeeded = true;
	            return;
	        }
	        var suppressAnimationFrame = this.beans.gridOptionsWrapper.isSuppressAnimationFrame();
	        var skipAnimationFrame = suppressAnimationFrame || this.printLayout;
	        if (skipAnimationFrame) {
	            this.refreshCellsInAnimationFrame();
	        }
	        else {
	            if (this.columnRefreshPending) {
	                return;
	            }
	            this.beans.taskQueue.addP1Task(this.refreshCellsInAnimationFrame.bind(this), this.rowNode.rowIndex);
	        }
	    };
	    RowComp.prototype.refreshCellsInAnimationFrame = function () {
	        if (!this.active) {
	            return;
	        }
	        this.columnRefreshPending = false;
	        var centerCols;
	        var leftCols;
	        var rightCols;
	        if (this.printLayout) {
	            centerCols = this.beans.columnController.getAllDisplayedColumns();
	            leftCols = [];
	            rightCols = [];
	        }
	        else {
	            centerCols = this.beans.columnController.getAllDisplayedCenterVirtualColumnsForRow(this.rowNode);
	            leftCols = this.beans.columnController.getDisplayedLeftColumnsForRow(this.rowNode);
	            rightCols = this.beans.columnController.getDisplayedRightColumnsForRow(this.rowNode);
	        }
	        this.insertCellsIntoContainer(this.eBodyRow, centerCols);
	        this.insertCellsIntoContainer(this.ePinnedLeftRow, leftCols);
	        this.insertCellsIntoContainer(this.ePinnedRightRow, rightCols);
	        var colIdsToRemove = Object.keys(this.cellComps);
	        centerCols.forEach(function (col) { return utils_1._.removeFromArray(colIdsToRemove, col.getId()); });
	        leftCols.forEach(function (col) { return utils_1._.removeFromArray(colIdsToRemove, col.getId()); });
	        rightCols.forEach(function (col) { return utils_1._.removeFromArray(colIdsToRemove, col.getId()); });
	        // we never remove editing cells, as this would cause the cells to loose their values while editing
	        // as the grid is scrolling horizontally.
	        var eligibleToBeRemoved = utils_1._.filter(colIdsToRemove, this.isCellEligibleToBeRemoved.bind(this));
	        // remove old cells from gui, but we don't destroy them, we might use them again
	        this.removeRenderedCells(eligibleToBeRemoved);
	    };
	    RowComp.prototype.removeRenderedCells = function (colIds) {
	        var _this = this;
	        colIds.forEach(function (key) {
	            var cellComp = _this.cellComps[key];
	            // could be old reference, ie removed cell
	            if (utils_1._.missing(cellComp)) {
	                return;
	            }
	            cellComp.detach();
	            cellComp.destroy();
	            _this.cellComps[key] = null;
	        });
	    };
	    RowComp.prototype.isCellEligibleToBeRemoved = function (indexStr) {
	        var displayedColumns = this.beans.columnController.getAllDisplayedColumns();
	        var REMOVE_CELL = true;
	        var KEEP_CELL = false;
	        var renderedCell = this.cellComps[indexStr];
	        if (!renderedCell) {
	            return REMOVE_CELL;
	        }
	        // always remove the cell if it's in the wrong pinned location
	        if (this.isCellInWrongRow(renderedCell)) {
	            return REMOVE_CELL;
	        }
	        // we want to try and keep editing and focused cells
	        var editing = renderedCell.isEditing();
	        var focused = this.beans.focusedCellController.isCellFocused(renderedCell.getCellPosition());
	        var mightWantToKeepCell = editing || focused;
	        if (mightWantToKeepCell) {
	            var column = renderedCell.getColumn();
	            var cellStillDisplayed = displayedColumns.indexOf(column) >= 0;
	            return cellStillDisplayed ? KEEP_CELL : REMOVE_CELL;
	        }
	        return REMOVE_CELL;
	    };
	    RowComp.prototype.ensureCellInCorrectContainer = function (cellComp) {
	        // for print layout, we always put cells into centre, otherwise we put in correct pinned section
	        if (this.printLayout) {
	            return;
	        }
	        var element = cellComp.getGui();
	        var column = cellComp.getColumn();
	        var pinnedType = column.getPinned();
	        var eContainer = this.getContainerForCell(pinnedType);
	        // if in wrong container, remove it
	        var eOldContainer = cellComp.getParentRow();
	        var inWrongRow = eOldContainer !== eContainer;
	        if (inWrongRow) {
	            // take out from old row
	            if (eOldContainer) {
	                eOldContainer.removeChild(element);
	            }
	            eContainer.appendChild(element);
	            cellComp.setParentRow(eContainer);
	        }
	    };
	    RowComp.prototype.isCellInWrongRow = function (cellComp) {
	        var column = cellComp.getColumn();
	        var rowWeWant = this.getContainerForCell(column.getPinned());
	        // if in wrong container, remove it
	        var oldRow = cellComp.getParentRow();
	        return oldRow !== rowWeWant;
	    };
	    RowComp.prototype.insertCellsIntoContainer = function (eRow, cols) {
	        var _this = this;
	        if (!eRow) {
	            return;
	        }
	        var cellTemplates = [];
	        var newCellComps = [];
	        cols.forEach(function (col) {
	            var colId = col.getId();
	            var existingCell = _this.cellComps[colId];
	            if (existingCell) {
	                _this.ensureCellInCorrectContainer(existingCell);
	            }
	            else {
	                _this.createNewCell(col, eRow, cellTemplates, newCellComps);
	            }
	        });
	        if (cellTemplates.length > 0) {
	            utils_1._.appendHtml(eRow, cellTemplates.join(''));
	            this.callAfterRowAttachedOnCells(newCellComps, eRow);
	        }
	    };
	    RowComp.prototype.addDomData = function (eRowContainer) {
	        var gow = this.beans.gridOptionsWrapper;
	        gow.setDomData(eRowContainer, RowComp.DOM_DATA_KEY_RENDERED_ROW, this);
	        this.addDestroyFunc(function () {
	            gow.setDomData(eRowContainer, RowComp.DOM_DATA_KEY_RENDERED_ROW, null);
	        });
	    };
	    RowComp.prototype.createNewCell = function (col, eContainer, cellTemplates, newCellComps) {
	        var newCellComp = new cellComp_1.CellComp(this.scope, this.beans, col, this.rowNode, this, false, this.printLayout);
	        var cellTemplate = newCellComp.getCreateTemplate();
	        cellTemplates.push(cellTemplate);
	        newCellComps.push(newCellComp);
	        this.cellComps[col.getId()] = newCellComp;
	        newCellComp.setParentRow(eContainer);
	    };
	    RowComp.prototype.onMouseEvent = function (eventName, mouseEvent) {
	        switch (eventName) {
	            case 'dblclick':
	                this.onRowDblClick(mouseEvent);
	                break;
	            case 'click':
	                this.onRowClick(mouseEvent);
	                break;
	        }
	    };
	    RowComp.prototype.createRowEvent = function (type, domEvent) {
	        return {
	            type: type,
	            node: this.rowNode,
	            data: this.rowNode.data,
	            rowIndex: this.rowNode.rowIndex,
	            rowPinned: this.rowNode.rowPinned,
	            context: this.beans.gridOptionsWrapper.getContext(),
	            api: this.beans.gridOptionsWrapper.getApi(),
	            columnApi: this.beans.gridOptionsWrapper.getColumnApi(),
	            event: domEvent
	        };
	    };
	    RowComp.prototype.createRowEventWithSource = function (type, domEvent) {
	        var event = this.createRowEvent(type, domEvent);
	        // when first developing this, we included the rowComp in the event.
	        // this seems very weird. so when introducing the event types, i left the 'source'
	        // out of the type, and just include the source in the two places where this event
	        // was fired (rowClicked and rowDoubleClicked). it doesn't make sense for any
	        // users to be using this, as the rowComp isn't an object we expose, so would be
	        // very surprising if a user was using it.
	        event.source = this;
	        return event;
	    };
	    RowComp.prototype.onRowDblClick = function (mouseEvent) {
	        if (utils_1._.isStopPropagationForAgGrid(mouseEvent)) {
	            return;
	        }
	        var agEvent = this.createRowEventWithSource(events_1.Events.EVENT_ROW_DOUBLE_CLICKED, mouseEvent);
	        this.beans.eventService.dispatchEvent(agEvent);
	    };
	    RowComp.prototype.onRowClick = function (mouseEvent) {
	        var stop = utils_1._.isStopPropagationForAgGrid(mouseEvent);
	        if (stop) {
	            return;
	        }
	        var agEvent = this.createRowEventWithSource(events_1.Events.EVENT_ROW_CLICKED, mouseEvent);
	        this.beans.eventService.dispatchEvent(agEvent);
	        // ctrlKey for windows, metaKey for Apple
	        var multiSelectKeyPressed = mouseEvent.ctrlKey || mouseEvent.metaKey;
	        var shiftKeyPressed = mouseEvent.shiftKey;
	        if (
	        // we do not allow selecting groups by clicking (as the click here expands the group), or if it's a detail row,
	        // so return if it's a group row
	        this.rowNode.group ||
	            // this is needed so we don't unselect other rows when we click this row, eg if this row is not selectable,
	            // and we click it, the selection should not change (ie any currently selected row should stay selected)
	            !this.rowNode.selectable ||
	            // we also don't allow selection of pinned rows
	            this.rowNode.rowPinned ||
	            // if no selection method enabled, do nothing
	            !this.beans.gridOptionsWrapper.isRowSelection() ||
	            // if click selection suppressed, do nothing
	            this.beans.gridOptionsWrapper.isSuppressRowClickSelection()) {
	            return;
	        }
	        var multiSelectOnClick = this.beans.gridOptionsWrapper.isRowMultiSelectWithClick();
	        var rowDeselectionWithCtrl = this.beans.gridOptionsWrapper.isRowDeselection();
	        if (this.rowNode.isSelected()) {
	            if (multiSelectOnClick) {
	                this.rowNode.setSelectedParams({ newValue: false });
	            }
	            else if (multiSelectKeyPressed) {
	                if (rowDeselectionWithCtrl) {
	                    this.rowNode.setSelectedParams({ newValue: false });
	                }
	            }
	            else {
	                // selected with no multi key, must make sure anything else is unselected
	                this.rowNode.setSelectedParams({ newValue: true, clearSelection: true });
	            }
	        }
	        else {
	            var clearSelection = multiSelectOnClick ? false : !multiSelectKeyPressed;
	            this.rowNode.setSelectedParams({ newValue: true, clearSelection: clearSelection, rangeSelect: shiftKeyPressed });
	        }
	    };
	    RowComp.prototype.createFullWidthRowContainer = function (rowContainerComp, pinned, extraCssClass, cellRendererType, cellRendererName, eRowCallback, cellRendererCallback) {
	        var _this = this;
	        var rowTemplate = this.createTemplate('', extraCssClass);
	        rowContainerComp.appendRowTemplate(rowTemplate, function () {
	            var eRow = rowContainerComp.getRowElement(_this.getCompId());
	            var params = _this.createFullWidthParams(eRow, pinned);
	            var callback = function (cellRenderer) {
	                if (_this.isAlive()) {
	                    var gui = cellRenderer.getGui();
	                    eRow.appendChild(gui);
	                    cellRendererCallback(cellRenderer);
	                }
	                else {
	                    if (cellRenderer.destroy) {
	                        cellRenderer.destroy();
	                    }
	                }
	            };
	            // if doing master detail, it's possible we have a cached row comp from last time detail was displayed
	            var cachedRowComp = _this.beans.detailRowCompCache.get(_this.rowNode, pinned);
	            if (cachedRowComp) {
	                callback(cachedRowComp);
	            }
	            else {
	                var res = _this.beans.userComponentFactory.newFullWidthCellRenderer(params, cellRendererType, cellRendererName);
	                if (!res) {
	                    console.error('ag-Grid: fullWidthCellRenderer not defined');
	                    return;
	                }
	                res.then(callback);
	            }
	            _this.afterRowAttached(rowContainerComp, eRow);
	            eRowCallback(eRow);
	            _this.angular1Compile(eRow);
	        });
	    };
	    RowComp.prototype.angular1Compile = function (element) {
	        if (!this.scope) {
	            return;
	        }
	        this.beans.$compile(element)(this.scope);
	    };
	    RowComp.prototype.createFullWidthParams = function (eRow, pinned) {
	        var params = {
	            fullWidth: true,
	            data: this.rowNode.data,
	            node: this.rowNode,
	            value: this.rowNode.key,
	            $scope: this.scope ? this.scope : this.parentScope,
	            $compile: this.beans.$compile,
	            rowIndex: this.rowNode.rowIndex,
	            api: this.beans.gridOptionsWrapper.getApi(),
	            columnApi: this.beans.gridOptionsWrapper.getColumnApi(),
	            context: this.beans.gridOptionsWrapper.getContext(),
	            // these need to be taken out, as part of 'afterAttached' now
	            eGridCell: eRow,
	            eParentOfValue: eRow,
	            pinned: pinned,
	            addRenderedRowListener: this.addEventListener.bind(this)
	        };
	        return params;
	    };
	    RowComp.prototype.getInitialRowClasses = function (extraCssClass) {
	        var classes = [];
	        var isTreeData = this.beans.gridOptionsWrapper.isTreeData();
	        var rowNode = this.rowNode;
	        if (utils_1._.exists(extraCssClass)) {
	            classes.push(extraCssClass);
	        }
	        classes.push('ag-row');
	        classes.push(this.rowFocused ? 'ag-row-focus' : 'ag-row-no-focus');
	        if (this.fadeRowIn) {
	            classes.push('ag-opacity-zero');
	        }
	        classes.push(this.rowIsEven ? 'ag-row-even' : 'ag-row-odd');
	        if (rowNode.isSelected()) {
	            classes.push('ag-row-selected');
	        }
	        if (rowNode.group) {
	            classes.push('ag-row-group');
	            // if a group, put the level of the group in
	            classes.push('ag-row-level-' + rowNode.level);
	            if (rowNode.footer) {
	                classes.push('ag-row-footer');
	            }
	        }
	        else {
	            // if a leaf, and a parent exists, put a level of the parent, else put level of 0 for top level item
	            classes.push('ag-row-level-' + (rowNode.parent ? (rowNode.parent.level + 1) : '0'));
	        }
	        if (rowNode.stub) {
	            classes.push('ag-row-stub');
	        }
	        if (this.fullWidthRow) {
	            classes.push('ag-full-width-row');
	        }
	        var addExpandedClass = isTreeData ?
	            // if doing tree data, we add the expanded classes if any children, as any node can be a parent
	            rowNode.allChildrenCount :
	            // if normal row grouping, we add expanded classes to groups only
	            rowNode.group && !rowNode.footer;
	        if (addExpandedClass) {
	            classes.push(rowNode.expanded ? 'ag-row-group-expanded' : 'ag-row-group-contracted');
	        }
	        if (rowNode.dragging) {
	            classes.push('ag-row-dragging');
	        }
	        utils_1._.pushAll(classes, this.processClassesFromGridOptions());
	        utils_1._.pushAll(classes, this.preProcessRowClassRules());
	        // we use absolute position unless we are doing print layout
	        classes.push(this.printLayout ? 'ag-row-position-relative' : 'ag-row-position-absolute');
	        this.firstRowOnPage = this.isFirstRowOnPage();
	        this.lastRowOnPage = this.isLastRowOnPage();
	        if (this.firstRowOnPage) {
	            classes.push('ag-row-first');
	        }
	        if (this.lastRowOnPage) {
	            classes.push('ag-row-last');
	        }
	        return classes;
	    };
	    RowComp.prototype.isFirstRowOnPage = function () {
	        return this.rowNode.rowIndex === this.beans.paginationProxy.getPageFirstRow();
	    };
	    RowComp.prototype.isLastRowOnPage = function () {
	        return this.rowNode.rowIndex === this.beans.paginationProxy.getPageLastRow();
	    };
	    RowComp.prototype.onModelUpdated = function () {
	        var newFirst = this.isFirstRowOnPage();
	        var newLast = this.isLastRowOnPage();
	        if (this.firstRowOnPage !== newFirst) {
	            this.firstRowOnPage = newFirst;
	            this.eAllRowContainers.forEach(function (row) { return utils_1._.addOrRemoveCssClass(row, 'ag-row-first', newFirst); });
	        }
	        if (this.lastRowOnPage !== newLast) {
	            this.lastRowOnPage = newLast;
	            this.eAllRowContainers.forEach(function (row) { return utils_1._.addOrRemoveCssClass(row, 'ag-row-last', newLast); });
	        }
	    };
	    RowComp.prototype.preProcessRowClassRules = function () {
	        var res = [];
	        this.processRowClassRules(function (className) {
	            res.push(className);
	        }, function (className) {
	            // not catered for, if creating, no need
	            // to remove class as it was never there
	        });
	        return res;
	    };
	    RowComp.prototype.processRowClassRules = function (onApplicableClass, onNotApplicableClass) {
	        this.beans.stylingService.processClassRules(this.beans.gridOptionsWrapper.rowClassRules(), {
	            value: undefined,
	            colDef: undefined,
	            data: this.rowNode.data,
	            node: this.rowNode,
	            rowIndex: this.rowNode.rowIndex,
	            api: this.beans.gridOptionsWrapper.getApi(),
	            columnApi: this.beans.gridOptionsWrapper.getColumnApi(),
	            $scope: this.scope,
	            context: this.beans.gridOptionsWrapper.getContext()
	        }, onApplicableClass, onNotApplicableClass);
	    };
	    RowComp.prototype.stopEditing = function (cancel) {
	        if (cancel === void 0) { cancel = false; }
	        this.forEachCellComp(function (renderedCell) {
	            renderedCell.stopEditing(cancel);
	        });
	        if (!this.editingRow) {
	            return;
	        }
	        if (!cancel) {
	            var event_1 = this.createRowEvent(events_1.Events.EVENT_ROW_VALUE_CHANGED);
	            this.beans.eventService.dispatchEvent(event_1);
	        }
	        this.setEditingRow(false);
	    };
	    RowComp.prototype.setEditingRow = function (value) {
	        this.editingRow = value;
	        this.eAllRowContainers.forEach(function (row) { return utils_1._.addOrRemoveCssClass(row, 'ag-row-editing', value); });
	        var event = value ?
	            this.createRowEvent(events_1.Events.EVENT_ROW_EDITING_STARTED)
	            : this.createRowEvent(events_1.Events.EVENT_ROW_EDITING_STOPPED);
	        this.beans.eventService.dispatchEvent(event);
	    };
	    RowComp.prototype.startRowEditing = function (keyPress, charPress, sourceRenderedCell) {
	        if (keyPress === void 0) { keyPress = null; }
	        if (charPress === void 0) { charPress = null; }
	        if (sourceRenderedCell === void 0) { sourceRenderedCell = null; }
	        // don't do it if already editing
	        if (this.editingRow) {
	            return;
	        }
	        this.forEachCellComp(function (renderedCell) {
	            var cellStartedEdit = renderedCell === sourceRenderedCell;
	            if (cellStartedEdit) {
	                renderedCell.startEditingIfEnabled(keyPress, charPress, cellStartedEdit);
	            }
	            else {
	                renderedCell.startEditingIfEnabled(null, null, cellStartedEdit);
	            }
	        });
	        this.setEditingRow(true);
	    };
	    RowComp.prototype.forEachCellComp = function (callback) {
	        utils_1._.iterateObject(this.cellComps, function (key, cellComp) {
	            if (!cellComp) {
	                return;
	            }
	            callback(cellComp);
	        });
	    };
	    RowComp.prototype.postProcessClassesFromGridOptions = function () {
	        var _this = this;
	        var cssClasses = this.processClassesFromGridOptions();
	        if (!cssClasses || !cssClasses.length) {
	            return;
	        }
	        cssClasses.forEach(function (classStr) {
	            _this.eAllRowContainers.forEach(function (row) { return utils_1._.addCssClass(row, classStr); });
	        });
	    };
	    RowComp.prototype.postProcessRowClassRules = function () {
	        var _this = this;
	        this.processRowClassRules(function (className) {
	            _this.eAllRowContainers.forEach(function (row) { return utils_1._.addCssClass(row, className); });
	        }, function (className) {
	            _this.eAllRowContainers.forEach(function (row) { return utils_1._.removeCssClass(row, className); });
	        });
	    };
	    RowComp.prototype.processClassesFromGridOptions = function () {
	        var res = [];
	        var process = function (rowCls) {
	            if (typeof rowCls === 'string') {
	                res.push(rowCls);
	            }
	            else if (Array.isArray(rowCls)) {
	                rowCls.forEach(function (e) { return res.push(e); });
	            }
	        };
	        // part 1 - rowClass
	        var rowClass = this.beans.gridOptionsWrapper.getRowClass();
	        if (rowClass) {
	            if (typeof rowClass === 'function') {
	                console.warn('ag-Grid: rowClass should not be a function, please use getRowClass instead');
	                return;
	            }
	            process(rowClass);
	        }
	        // part 2 - rowClassFunc
	        var rowClassFunc = this.beans.gridOptionsWrapper.getRowClassFunc();
	        if (rowClassFunc) {
	            var params = {
	                node: this.rowNode,
	                data: this.rowNode.data,
	                rowIndex: this.rowNode.rowIndex,
	                context: this.beans.gridOptionsWrapper.getContext(),
	                api: this.beans.gridOptionsWrapper.getApi()
	            };
	            var rowClassFuncResult = rowClassFunc(params);
	            process(rowClassFuncResult);
	        }
	        return res;
	    };
	    RowComp.prototype.preProcessStylesFromGridOptions = function () {
	        var rowStyles = this.processStylesFromGridOptions();
	        return utils_1._.cssStyleObjectToMarkup(rowStyles);
	    };
	    RowComp.prototype.postProcessStylesFromGridOptions = function () {
	        var rowStyles = this.processStylesFromGridOptions();
	        this.eAllRowContainers.forEach(function (row) { return utils_1._.addStylesToElement(row, rowStyles); });
	    };
	    RowComp.prototype.processStylesFromGridOptions = function () {
	        // part 1 - rowStyle
	        var rowStyle = this.beans.gridOptionsWrapper.getRowStyle();
	        if (rowStyle && typeof rowStyle === 'function') {
	            console.warn('ag-Grid: rowStyle should be an object of key/value styles, not be a function, use getRowStyle() instead');
	            return;
	        }
	        // part 1 - rowStyleFunc
	        var rowStyleFunc = this.beans.gridOptionsWrapper.getRowStyleFunc();
	        var rowStyleFuncResult;
	        if (rowStyleFunc) {
	            var params = {
	                data: this.rowNode.data,
	                node: this.rowNode,
	                api: this.beans.gridOptionsWrapper.getApi(),
	                context: this.beans.gridOptionsWrapper.getContext(),
	                $scope: this.scope
	            };
	            rowStyleFuncResult = rowStyleFunc(params);
	        }
	        return utils_1._.assign({}, rowStyle, rowStyleFuncResult);
	    };
	    RowComp.prototype.createCells = function (cols) {
	        var _this = this;
	        var templateParts = [];
	        var newCellComps = [];
	        cols.forEach(function (col) {
	            var newCellComp = new cellComp_1.CellComp(_this.scope, _this.beans, col, _this.rowNode, _this, false, _this.printLayout);
	            var cellTemplate = newCellComp.getCreateTemplate();
	            templateParts.push(cellTemplate);
	            newCellComps.push(newCellComp);
	            _this.cellComps[col.getId()] = newCellComp;
	        });
	        var templateAndComps = {
	            template: templateParts.join(''),
	            cellComps: newCellComps
	        };
	        return templateAndComps;
	    };
	    RowComp.prototype.onRowSelected = function () {
	        var selected = this.rowNode.isSelected();
	        this.eAllRowContainers.forEach(function (row) { return utils_1._.addOrRemoveCssClass(row, 'ag-row-selected', selected); });
	    };
	    // called:
	    // + after row created for first time
	    // + after horizontal scroll, so new cells due to column virtualisation
	    RowComp.prototype.callAfterRowAttachedOnCells = function (newCellComps, eRow) {
	        var _this = this;
	        newCellComps.forEach(function (cellComp) {
	            cellComp.setParentRow(eRow);
	            cellComp.afterAttached();
	            // if we are editing the row, then the cell needs to turn
	            // into edit mode
	            if (_this.editingRow) {
	                cellComp.startEditingIfEnabled();
	            }
	        });
	    };
	    RowComp.prototype.afterRowAttached = function (rowContainerComp, eRow) {
	        var _this = this;
	        this.addDomData(eRow);
	        this.removeSecondPassFuncs.push(function () {
	            rowContainerComp.removeRowElement(eRow);
	        });
	        this.removeFirstPassFuncs.push(function () {
	            if (utils_1._.exists(_this.rowNode.rowTop)) {
	                // the row top is updated anyway, however we set it here again
	                // to something more reasonable for the animation - ie if the
	                // row top is 10000px away, the row will flash out, so this
	                // gives it a rounded value, so row animates out more slowly
	                var rowTop = _this.roundRowTopToBounds(_this.rowNode.rowTop);
	                _this.setRowTop(rowTop);
	            }
	            else {
	                utils_1._.addCssClass(eRow, 'ag-opacity-zero');
	            }
	        });
	        this.eAllRowContainers.push(eRow);
	        // adding hover functionality adds listener to this row, so we
	        // do it lazily in an animation frame
	        if (this.useAnimationFrameForCreate) {
	            this.beans.taskQueue.addP2Task(this.addHoverFunctionality.bind(this, eRow));
	        }
	        else {
	            this.addHoverFunctionality(eRow);
	        }
	    };
	    RowComp.prototype.addHoverFunctionality = function (eRow) {
	        var _this = this;
	        // because we use animation frames to do this, it's possible the row no longer exists
	        // by the time we get to add it
	        if (!this.active) {
	            return;
	        }
	        // because mouseenter and mouseleave do not propagate, we cannot listen on the gridPanel
	        // like we do for all the other mouse events.
	        // because of the pinning, we cannot simply add / remove the class based on the eRow. we
	        // have to check all eRow's (body & pinned). so the trick is if any of the rows gets a
	        // mouse hover, it sets such in the rowNode, and then all three reflect the change as
	        // all are listening for event on the row node.
	        // step 1 - add listener, to set flag on row node
	        this.addDestroyableEventListener(eRow, 'mouseenter', function () { return _this.rowNode.onMouseEnter(); });
	        this.addDestroyableEventListener(eRow, 'mouseleave', function () { return _this.rowNode.onMouseLeave(); });
	        // step 2 - listen for changes on row node (which any eRow can trigger)
	        this.addDestroyableEventListener(this.rowNode, rowNode_1.RowNode.EVENT_MOUSE_ENTER, function () {
	            // if hover turned off, we don't add the class. we do this here so that if the application
	            // toggles this property mid way, we remove the hover form the last row, but we stop
	            // adding hovers from that point onwards.
	            if (!_this.beans.gridOptionsWrapper.isSuppressRowHoverHighlight()) {
	                utils_1._.addCssClass(eRow, 'ag-row-hover');
	            }
	        });
	        this.addDestroyableEventListener(this.rowNode, rowNode_1.RowNode.EVENT_MOUSE_LEAVE, function () {
	            utils_1._.removeCssClass(eRow, 'ag-row-hover');
	        });
	    };
	    // for animation, we don't want to animate entry or exit to a very far away pixel,
	    // otherwise the row would move so fast, it would appear to disappear. so this method
	    // moves the row closer to the viewport if it is far away, so the row slide in / out
	    // at a speed the user can see.
	    RowComp.prototype.roundRowTopToBounds = function (rowTop) {
	        var range = this.beans.gridPanel.getVScrollPosition();
	        var minPixel = this.applyPaginationOffset(range.top, true) - 100;
	        var maxPixel = this.applyPaginationOffset(range.bottom, true) + 100;
	        return Math.min(Math.max(minPixel, rowTop), maxPixel);
	    };
	    RowComp.prototype.getFrameworkOverrides = function () {
	        return this.beans.frameworkOverrides;
	    };
	    RowComp.prototype.onRowHeightChanged = function () {
	        // check for exists first - if the user is resetting the row height, then
	        // it will be null (or undefined) momentarily until the next time the flatten
	        // stage is called where the row will then update again with a new height
	        if (utils_1._.exists(this.rowNode.rowHeight)) {
	            var heightPx_1 = this.rowNode.rowHeight + "px";
	            this.eAllRowContainers.forEach(function (row) { return row.style.height = heightPx_1; });
	        }
	    };
	    RowComp.prototype.addEventListener = function (eventType, listener) {
	        if (eventType === 'renderedRowRemoved' || eventType === 'rowRemoved') {
	            eventType = events_1.Events.EVENT_VIRTUAL_ROW_REMOVED;
	            console.warn('ag-Grid: Since version 11, event renderedRowRemoved is now called ' + events_1.Events.EVENT_VIRTUAL_ROW_REMOVED);
	        }
	        _super.prototype.addEventListener.call(this, eventType, listener);
	    };
	    RowComp.prototype.removeEventListener = function (eventType, listener) {
	        if (eventType === 'renderedRowRemoved' || eventType === 'rowRemoved') {
	            eventType = events_1.Events.EVENT_VIRTUAL_ROW_REMOVED;
	            console.warn('ag-Grid: Since version 11, event renderedRowRemoved and rowRemoved is now called ' + events_1.Events.EVENT_VIRTUAL_ROW_REMOVED);
	        }
	        _super.prototype.removeEventListener.call(this, eventType, listener);
	    };
	    RowComp.prototype.destroy = function (animate) {
	        if (animate === void 0) { animate = false; }
	        _super.prototype.destroy.call(this);
	        this.active = false;
	        // why do we have this method? shouldn't everything below be added as a destroy func beside
	        // the corresponding create logic?
	        this.destroyFullWidthComponents();
	        if (animate) {
	            this.removeFirstPassFuncs.forEach(function (func) { return func(); });
	            this.removeSecondPassFuncs.push(this.destroyContainingCells.bind(this));
	        }
	        else {
	            this.destroyContainingCells();
	            // we are not animating, so execute the second stage of removal now.
	            // we call getAndClear, so that they are only called once
	            var delayedDestroyFunctions = this.getAndClearDelayedDestroyFunctions();
	            delayedDestroyFunctions.forEach(function (func) { return func(); });
	        }
	        var event = this.createRowEvent(events_1.Events.EVENT_VIRTUAL_ROW_REMOVED);
	        this.dispatchEvent(event);
	        this.beans.eventService.dispatchEvent(event);
	    };
	    RowComp.prototype.destroyContainingCells = function () {
	        this.forEachCellComp(function (renderedCell) { return renderedCell.destroy(); });
	        this.destroyFullWidthComponents();
	    };
	    // we clear so that the functions are never executed twice
	    RowComp.prototype.getAndClearDelayedDestroyFunctions = function () {
	        var result = this.removeSecondPassFuncs;
	        this.removeSecondPassFuncs = [];
	        return result;
	    };
	    RowComp.prototype.onCellFocusChanged = function () {
	        var rowFocused = this.beans.focusedCellController.isRowFocused(this.rowNode.rowIndex, this.rowNode.rowPinned);
	        if (rowFocused !== this.rowFocused) {
	            this.eAllRowContainers.forEach(function (row) { return utils_1._.addOrRemoveCssClass(row, 'ag-row-focus', rowFocused); });
	            this.eAllRowContainers.forEach(function (row) { return utils_1._.addOrRemoveCssClass(row, 'ag-row-no-focus', !rowFocused); });
	            this.rowFocused = rowFocused;
	        }
	        // if we are editing, then moving the focus out of a row will stop editing
	        if (!rowFocused && this.editingRow) {
	            this.stopEditing(false);
	        }
	    };
	    RowComp.prototype.onPaginationChanged = function () {
	        var currentPage = this.beans.paginationProxy.getCurrentPage();
	        // it is possible this row is in the new page, but the page number has changed, which means
	        // it needs to reposition itself relative to the new page
	        if (this.paginationPage !== currentPage) {
	            this.paginationPage = currentPage;
	            this.onTopChanged();
	        }
	    };
	    RowComp.prototype.onTopChanged = function () {
	        this.setRowTop(this.rowNode.rowTop);
	    };
	    // applies pagination offset, eg if on second page, and page height is 500px, then removes
	    // 500px from the top position, so a row with rowTop 600px is displayed at location 100px.
	    // reverse will take the offset away rather than add.
	    RowComp.prototype.applyPaginationOffset = function (topPx, reverse) {
	        if (reverse === void 0) { reverse = false; }
	        if (this.rowNode.isRowPinned()) {
	            return topPx;
	        }
	        var pixelOffset = this.beans.paginationProxy.getPixelOffset();
	        var multiplier = reverse ? 1 : -1;
	        return topPx + (pixelOffset * multiplier);
	    };
	    RowComp.prototype.setRowTop = function (pixels) {
	        // print layout uses normal flow layout for row positioning
	        if (this.printLayout) {
	            return;
	        }
	        // need to make sure rowTop is not null, as this can happen if the node was once
	        // visible (ie parent group was expanded) but is now not visible
	        if (utils_1._.exists(pixels)) {
	            var afterPaginationPixels = this.applyPaginationOffset(pixels);
	            var afterScalingPixels = this.beans.maxDivHeightScaler.getRealPixelPosition(afterPaginationPixels);
	            var topPx_1 = afterScalingPixels + "px";
	            if (this.beans.gridOptionsWrapper.isSuppressRowTransform()) {
	                this.eAllRowContainers.forEach(function (row) { return row.style.top = topPx_1; });
	            }
	            else {
	                this.eAllRowContainers.forEach(function (row) { return row.style.transform = "translateY(" + topPx_1 + ")"; });
	            }
	        }
	    };
	    // we clear so that the functions are never executed twice
	    RowComp.prototype.getAndClearNextVMTurnFunctions = function () {
	        var result = this.createSecondPassFuncs;
	        this.createSecondPassFuncs = [];
	        return result;
	    };
	    RowComp.prototype.getRowNode = function () {
	        return this.rowNode;
	    };
	    RowComp.prototype.getRenderedCellForColumn = function (column) {
	        var _this = this;
	        var cellComp = this.cellComps[column.getColId()];
	        if (cellComp) {
	            return cellComp;
	        }
	        var spanList = Object.keys(this.cellComps)
	            .map(function (name) { return _this.cellComps[name]; })
	            .filter(function (cmp) { return cmp && cmp.getColSpanningList().indexOf(column) !== -1; });
	        return spanList.length ? spanList[0] : undefined;
	    };
	    RowComp.prototype.onRowIndexChanged = function () {
	        this.onCellFocusChanged();
	        this.updateRowIndexes();
	    };
	    RowComp.prototype.updateRowIndexes = function () {
	        var _this = this;
	        var rowIndexStr = this.rowNode.getRowIndexString();
	        var rowIsEven = this.rowNode.rowIndex % 2 === 0;
	        var rowIsEvenChanged = this.rowIsEven !== rowIsEven;
	        var headerRowCount = this.beans.gridPanel.headerRootComp.getHeaderRowCount();
	        if (rowIsEvenChanged) {
	            this.rowIsEven = rowIsEven;
	        }
	        this.eAllRowContainers.forEach(function (eRow) {
	            eRow.setAttribute('row-index', rowIndexStr);
	            eRow.setAttribute('aria-rowindex', (headerRowCount + _this.rowNode.rowIndex + 1).toString());
	            if (!rowIsEvenChanged) {
	                return;
	            }
	            utils_1._.addOrRemoveCssClass(eRow, 'ag-row-even', rowIsEven);
	            utils_1._.addOrRemoveCssClass(eRow, 'ag-row-odd', !rowIsEven);
	        });
	    };
	    RowComp.prototype.ensureDomOrder = function () {
	        var sides = [
	            {
	                el: this.getBodyRowElement(),
	                ct: this.bodyContainerComp
	            },
	            {
	                el: this.getPinnedLeftRowElement(),
	                ct: this.pinnedLeftContainerComp
	            }, {
	                el: this.getPinnedRightRowElement(),
	                ct: this.pinnedRightContainerComp
	            }, {
	                el: this.getFullWidthRowElement(),
	                ct: this.fullWidthContainerComp
	            }
	        ];
	        sides.forEach(function (side) {
	            if (!side.el) {
	                return;
	            }
	            side.ct.ensureDomOrder(side.el);
	        });
	    };
	    // returns the pinned left container, either the normal one, or the embedded full with one if exists
	    RowComp.prototype.getPinnedLeftRowElement = function () {
	        return this.ePinnedLeftRow ? this.ePinnedLeftRow : this.eFullWidthRowLeft;
	    };
	    // returns the pinned right container, either the normal one, or the embedded full with one if exists
	    RowComp.prototype.getPinnedRightRowElement = function () {
	        return this.ePinnedRightRow ? this.ePinnedRightRow : this.eFullWidthRowRight;
	    };
	    // returns the body container, either the normal one, or the embedded full with one if exists
	    RowComp.prototype.getBodyRowElement = function () {
	        return this.eBodyRow ? this.eBodyRow : this.eFullWidthRowBody;
	    };
	    // returns the full width container
	    RowComp.prototype.getFullWidthRowElement = function () {
	        return this.eFullWidthRow;
	    };
	    RowComp.DOM_DATA_KEY_RENDERED_ROW = 'renderedRow';
	    RowComp.FULL_WIDTH_CELL_RENDERER = 'fullWidthCellRenderer';
	    RowComp.GROUP_ROW_RENDERER = 'groupRowRenderer';
	    RowComp.GROUP_ROW_RENDERER_COMP_NAME = 'agGroupRowRenderer';
	    RowComp.LOADING_CELL_RENDERER = 'loadingCellRenderer';
	    RowComp.LOADING_CELL_RENDERER_COMP_NAME = 'agLoadingCellRenderer';
	    RowComp.DETAIL_CELL_RENDERER = 'detailCellRenderer';
	    RowComp.DETAIL_CELL_RENDERER_COMP_NAME = 'agDetailCellRenderer';
	    return RowComp;
	}(component_1.Component));
	exports.RowComp = RowComp;


/***/ }),
/* 2352 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __assign = (this && this.__assign) || function () {
	    __assign = Object.assign || function(t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	                t[p] = s[p];
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var column_1 = __webpack_require__(2343);
	var constants_1 = __webpack_require__(2328);
	var events_1 = __webpack_require__(2335);
	var component_1 = __webpack_require__(2353);
	var checkboxSelectionComponent_1 = __webpack_require__(2355);
	var iRangeController_1 = __webpack_require__(2361);
	var rowDragComp_1 = __webpack_require__(2362);
	var popupEditorWrapper_1 = __webpack_require__(2366);
	var utils_1 = __webpack_require__(2325);
	var dndSourceComp_1 = __webpack_require__(2368);
	var CellComp = /** @class */ (function (_super) {
	    __extends(CellComp, _super);
	    function CellComp(scope, beans, column, rowNode, rowComp, autoHeightCell, printLayout) {
	        var _this = _super.call(this) || this;
	        _this.editingCell = false;
	        _this.suppressRefreshCell = false;
	        _this.scope = null;
	        // every time we go into edit mode, or back again, this gets incremented.
	        // it's the components way of dealing with the async nature of framework components,
	        // so if a framework component takes a while to be created, we know if the object
	        // is still relevant when creating is finished. eg we could click edit / un-edit 20
	        // times before the first React edit component comes back - we should discard
	        // the first 19.
	        _this.cellEditorVersion = 0;
	        _this.cellRendererVersion = 0;
	        _this.scope = scope;
	        _this.beans = beans;
	        _this.column = column;
	        _this.rowNode = rowNode;
	        _this.rowComp = rowComp;
	        _this.autoHeightCell = autoHeightCell;
	        _this.printLayout = printLayout;
	        _this.createGridCellVo();
	        _this.rangeSelectionEnabled = beans.gridOptionsWrapper.isEnableRangeSelection();
	        _this.cellFocused = _this.beans.focusedCellController.isCellFocused(_this.cellPosition);
	        _this.firstRightPinned = _this.column.isFirstRightPinned();
	        _this.lastLeftPinned = _this.column.isLastLeftPinned();
	        if (_this.rangeSelectionEnabled) {
	            var rangeController = _this.beans.rangeController;
	            _this.rangeCount = rangeController.getCellRangeCount(_this.cellPosition);
	            if (_this.rangeCount) {
	                _this.hasChartRange = rangeController.getCellRanges().every(function (range) { return utils_1._.exists(range.type); });
	            }
	        }
	        _this.getValueAndFormat();
	        _this.setUsingWrapper();
	        _this.chooseCellRenderer();
	        _this.setupColSpan();
	        _this.rowSpan = _this.column.getRowSpan(_this.rowNode);
	        return _this;
	    }
	    CellComp.prototype.getCreateTemplate = function () {
	        var unselectable = !this.beans.gridOptionsWrapper.isEnableCellTextSelection() ? 'unselectable="on"' : '';
	        var templateParts = [];
	        var col = this.column;
	        var width = this.getCellWidth();
	        var left = this.modifyLeftForPrintLayout(this.getCellLeft());
	        var valueToRender = this.getInitialValueToRender();
	        var valueSanitised = utils_1._.get(this.column, 'colDef.template', null) ? valueToRender : utils_1._.escape(valueToRender);
	        this.tooltip = this.getToolTip();
	        var tooltipSanitised = utils_1._.escape(this.tooltip);
	        var colIdSanitised = utils_1._.escape(col.getId());
	        var wrapperStartTemplate = '';
	        var wrapperEndTemplate = '';
	        var stylesFromColDef = this.preProcessStylesFromColDef();
	        var cssClasses = this.getInitialCssClasses();
	        var stylesForRowSpanning = this.getStylesForRowSpanning();
	        if (this.usingWrapper) {
	            wrapperStartTemplate = "<div ref=\"eCellWrapper\" class=\"ag-cell-wrapper\"><span ref=\"eCellValue\" class=\"ag-cell-value\" " + unselectable + ">";
	            wrapperEndTemplate = '</span></div>';
	        }
	        templateParts.push("<div");
	        templateParts.push(" tabindex=\"-1\"");
	        templateParts.push(" " + unselectable); // THIS IS FOR IE ONLY so text selection doesn't bubble outside of the grid
	        templateParts.push(" role=\"gridcell\"");
	        templateParts.push(" comp-id=\"" + this.getCompId() + "\" ");
	        templateParts.push(" col-id=\"" + colIdSanitised + "\"");
	        templateParts.push(" class=\"" + cssClasses.join(' ') + "\"");
	        if (this.beans.gridOptionsWrapper.isEnableBrowserTooltips() && utils_1._.exists(tooltipSanitised)) {
	            templateParts.push("title=\"" + tooltipSanitised + "\"");
	        }
	        templateParts.push(" style=\"width: " + width + "px; left: " + left + "px; " + stylesFromColDef + " " + stylesForRowSpanning + "\" >");
	        templateParts.push(wrapperStartTemplate);
	        if (utils_1._.exists(valueSanitised, true)) {
	            templateParts.push(valueSanitised);
	        }
	        templateParts.push(wrapperEndTemplate);
	        templateParts.push("</div>");
	        return templateParts.join('');
	    };
	    CellComp.prototype.getStylesForRowSpanning = function () {
	        if (this.rowSpan === 1) {
	            return '';
	        }
	        var singleRowHeight = this.beans.gridOptionsWrapper.getRowHeightAsNumber();
	        var totalRowHeight = singleRowHeight * this.rowSpan;
	        return "height: " + totalRowHeight + "px; z-index: 1;";
	    };
	    CellComp.prototype.afterAttached = function () {
	        var querySelector = "[comp-id=\"" + this.getCompId() + "\"]";
	        var eGui = this.eParentRow.querySelector(querySelector);
	        this.setGui(eGui);
	        // all of these have dependencies on the eGui, so only do them after eGui is set
	        this.addDomData();
	        this.populateTemplate();
	        this.createCellRendererInstance(true);
	        this.angular1Compile();
	        // if not doing enterprise, then range selection service would be missing
	        // so need to check before trying to use it
	        if (this.rangeSelectionEnabled) {
	            if (this.shouldHaveSelectionHandle()) {
	                this.addSelectionHandle();
	            }
	        }
	        if (utils_1._.exists(this.tooltip) && !this.beans.gridOptionsWrapper.isEnableBrowserTooltips()) {
	            this.beans.tooltipManager.registerTooltip(this);
	        }
	    };
	    CellComp.prototype.onColumnHover = function () {
	        var isHovered = this.beans.columnHoverService.isHovered(this.column);
	        utils_1._.addOrRemoveCssClass(this.getGui(), 'ag-column-hover', isHovered);
	    };
	    CellComp.prototype.onCellChanged = function (event) {
	        var eventImpactsThisCell = event.column === this.column;
	        if (eventImpactsThisCell) {
	            this.refreshCell({});
	        }
	    };
	    CellComp.prototype.getCellLeft = function () {
	        var mostLeftCol;
	        if (this.beans.gridOptionsWrapper.isEnableRtl() && this.colsSpanning) {
	            mostLeftCol = utils_1._.last(this.colsSpanning);
	        }
	        else {
	            mostLeftCol = this.column;
	        }
	        return mostLeftCol.getLeft();
	    };
	    CellComp.prototype.getCellWidth = function () {
	        if (!this.colsSpanning) {
	            return this.column.getActualWidth();
	        }
	        var result = 0;
	        this.colsSpanning.forEach(function (col) { return result += col.getActualWidth(); });
	        return result;
	    };
	    CellComp.prototype.onFlashCells = function (event) {
	        var cellId = this.beans.cellPositionUtils.createId(this.cellPosition);
	        var shouldFlash = event.cells[cellId];
	        if (shouldFlash) {
	            this.animateCell('highlight');
	        }
	    };
	    CellComp.prototype.setupColSpan = function () {
	        // if no col span is active, then we don't set it up, as it would be wasteful of CPU
	        if (utils_1._.missing(this.getComponentHolder().colSpan)) {
	            return;
	        }
	        // because we are col spanning, a reorder of the cols can change what cols we are spanning over
	        this.addDestroyableEventListener(this.beans.eventService, events_1.Events.EVENT_DISPLAYED_COLUMNS_CHANGED, this.onDisplayColumnsChanged.bind(this));
	        // because we are spanning over multiple cols, we check for width any time any cols width changes.
	        // this is expensive - really we should be explicitly checking only the cols we are spanning over
	        // instead of every col, however it would be tricky code to track the cols we are spanning over, so
	        // because hardly anyone will be using colSpan, am favouring this easier way for more maintainable code.
	        this.addDestroyableEventListener(this.beans.eventService, events_1.Events.EVENT_DISPLAYED_COLUMNS_WIDTH_CHANGED, this.onWidthChanged.bind(this));
	        this.colsSpanning = this.getColSpanningList();
	    };
	    CellComp.prototype.getColSpanningList = function () {
	        var colSpan = this.column.getColSpan(this.rowNode);
	        var colsSpanning = [];
	        // if just one col, the col span is just the column we are in
	        if (colSpan === 1) {
	            colsSpanning.push(this.column);
	        }
	        else {
	            var pointer = this.column;
	            var pinned = this.column.getPinned();
	            for (var i = 0; pointer && i < colSpan; i++) {
	                colsSpanning.push(pointer);
	                pointer = this.beans.columnController.getDisplayedColAfter(pointer);
	                if (!pointer || utils_1._.missing(pointer)) {
	                    break;
	                }
	                // we do not allow col spanning to span outside of pinned areas
	                if (pinned !== pointer.getPinned()) {
	                    break;
	                }
	            }
	        }
	        return colsSpanning;
	    };
	    CellComp.prototype.onDisplayColumnsChanged = function () {
	        var colsSpanning = this.getColSpanningList();
	        if (!utils_1._.compareArrays(this.colsSpanning, colsSpanning)) {
	            this.colsSpanning = colsSpanning;
	            this.onWidthChanged();
	            this.onLeftChanged(); // left changes when doing RTL
	        }
	    };
	    CellComp.prototype.getInitialCssClasses = function () {
	        var cssClasses = ["ag-cell", "ag-cell-not-inline-editing"];
	        // if we are putting the cell into a dummy container, to work out it's height,
	        // then we don't put the height css in, as we want cell to fit height in that case.
	        if (!this.autoHeightCell) {
	            cssClasses.push('ag-cell-with-height');
	        }
	        var doingFocusCss = !this.beans.gridOptionsWrapper.isSuppressCellSelection();
	        if (doingFocusCss && this.cellFocused) {
	            // otherwise the class depends on the focus state
	            cssClasses.push('ag-cell-focus');
	        }
	        if (this.firstRightPinned) {
	            cssClasses.push('ag-cell-first-right-pinned');
	        }
	        if (this.lastLeftPinned) {
	            cssClasses.push('ag-cell-last-left-pinned');
	        }
	        if (this.beans.columnHoverService.isHovered(this.column)) {
	            cssClasses.push('ag-column-hover');
	        }
	        utils_1._.pushAll(cssClasses, this.preProcessClassesFromColDef());
	        utils_1._.pushAll(cssClasses, this.preProcessCellClassRules());
	        utils_1._.pushAll(cssClasses, this.getInitialRangeClasses());
	        // if using the wrapper, this class goes on the wrapper instead
	        if (!this.usingWrapper) {
	            cssClasses.push('ag-cell-value');
	        }
	        return cssClasses;
	    };
	    CellComp.prototype.getInitialValueToRender = function () {
	        // if using a cellRenderer, then render the html from the cell renderer if it exists
	        if (this.usingCellRenderer) {
	            if (typeof this.cellRendererGui === 'string') {
	                return this.cellRendererGui;
	            }
	            else {
	                return '';
	            }
	        }
	        var colDef = this.getComponentHolder();
	        if (colDef.template) {
	            // template is really only used for angular 1 - as people using ng1 are used to providing templates with
	            // bindings in it. in ng2, people will hopefully want to provide components, not templates.
	            return colDef.template;
	        }
	        else if (colDef.templateUrl) {
	            // likewise for templateUrl - it's for ng1 really - when we move away from ng1, we can take these out.
	            // niall was pro angular 1 when writing template and templateUrl, if writing from scratch now, would
	            // not do these, but would follow a pattern that was friendly towards components, not templates.
	            var template = this.beans.templateService.getTemplate(colDef.templateUrl, this.refreshCell.bind(this, true));
	            if (template) {
	                return template;
	            }
	            else {
	                return '';
	            }
	        }
	        else {
	            return this.getValueToUse();
	        }
	    };
	    CellComp.prototype.getRenderedRow = function () {
	        return this.rowComp;
	    };
	    CellComp.prototype.isSuppressNavigable = function () {
	        return this.column.isSuppressNavigable(this.rowNode);
	    };
	    CellComp.prototype.getCellRenderer = function () {
	        return this.cellRenderer;
	    };
	    CellComp.prototype.getCellEditor = function () {
	        return this.cellEditor;
	    };
	    // + stop editing {forceRefresh: true, suppressFlash: true}
	    // + event cellChanged {}
	    // + cellRenderer.params.refresh() {} -> method passes 'as is' to the cellRenderer, so params could be anything
	    // + rowComp: event dataChanged {animate: update, newData: !update}
	    // + rowComp: api refreshCells() {animate: true/false}
	    // + rowRenderer: api softRefreshView() {}
	    CellComp.prototype.refreshCell = function (params) {
	        // if we are in the middle of 'stopEditing', then we don't refresh here, as refresh gets called explicitly
	        if (this.suppressRefreshCell || this.editingCell) {
	            return;
	        }
	        var colDef = this.getComponentHolder();
	        var newData = params && params.newData;
	        var suppressFlash = (params && params.suppressFlash) || colDef.suppressCellFlash;
	        var forceRefresh = params && params.forceRefresh;
	        var oldValue = this.value;
	        this.getValueAndFormat();
	        // for simple values only (not pojo's), see if the value is the same, and if it is, skip the refresh.
	        // when never allow skipping after an edit, as after editing, we need to put the GUI back to the way
	        // if was before the edit.
	        var valuesDifferent = !this.valuesAreEqual(oldValue, this.value);
	        var dataNeedsUpdating = forceRefresh || valuesDifferent;
	        if (dataNeedsUpdating) {
	            // if it's 'new data', then we don't refresh the cellRenderer, even if refresh method is available.
	            // this is because if the whole data is new (ie we are showing stock price 'BBA' now and not 'SSD')
	            // then we are not showing a movement in the stock price, rather we are showing different stock.
	            var cellRendererRefreshed = newData ? false : this.attemptCellRendererRefresh();
	            // we do the replace if not doing refresh, or if refresh was unsuccessful.
	            // the refresh can be unsuccessful if we are using a framework (eg ng2 or react) and the framework
	            // wrapper has the refresh method, but the underlying component doesn't
	            if (!cellRendererRefreshed) {
	                this.replaceContentsAfterRefresh();
	            }
	            // we don't want to flash the cells when processing a filter change, as otherwise the UI would
	            // be to busy. see comment in FilterManager with regards processingFilterChange
	            var processingFilterChange = this.beans.filterManager.isSuppressFlashingCellsBecauseFiltering();
	            var flashCell = !suppressFlash && !processingFilterChange &&
	                (this.beans.gridOptionsWrapper.isEnableCellChangeFlash() || colDef.enableCellChangeFlash);
	            if (flashCell) {
	                this.flashCell();
	            }
	            // need to check rules. note, we ignore colDef classes and styles, these are assumed to be static
	            this.postProcessStylesFromColDef();
	            this.postProcessClassesFromColDef();
	        }
	        // we can't readily determine if the data in an angularjs template has changed, so here we just update
	        // and recompile (if applicable)
	        this.updateAngular1ScopeAndCompile();
	        this.refreshToolTip();
	        // we do cellClassRules even if the value has not changed, so that users who have rules that
	        // look at other parts of the row (where the other part of the row might of changed) will work.
	        this.postProcessCellClassRules();
	    };
	    // user can also call this via API
	    CellComp.prototype.flashCell = function () {
	        this.animateCell('data-changed');
	    };
	    CellComp.prototype.animateCell = function (cssName) {
	        var fullName = 'ag-cell-' + cssName;
	        var animationFullName = 'ag-cell-' + cssName + '-animation';
	        var element = this.getGui();
	        // we want to highlight the cells, without any animation
	        utils_1._.addCssClass(element, fullName);
	        utils_1._.removeCssClass(element, animationFullName);
	        // then once that is applied, we remove the highlight with animation
	        window.setTimeout(function () {
	            utils_1._.removeCssClass(element, fullName);
	            utils_1._.addCssClass(element, animationFullName);
	            window.setTimeout(function () {
	                // and then to leave things as we got them, we remove the animation
	                utils_1._.removeCssClass(element, animationFullName);
	            }, 1000);
	        }, 500);
	    };
	    CellComp.prototype.replaceContentsAfterRefresh = function () {
	        // otherwise we rip out the cell and replace it
	        utils_1._.clearElement(this.eParentOfValue);
	        // remove old renderer component if it exists
	        if (this.cellRenderer && this.cellRenderer.destroy) {
	            this.cellRenderer.destroy();
	        }
	        this.cellRenderer = null;
	        this.cellRendererGui = null;
	        // populate
	        this.putDataIntoCellAfterRefresh();
	        this.updateAngular1ScopeAndCompile();
	    };
	    CellComp.prototype.updateAngular1ScopeAndCompile = function () {
	        if (this.beans.gridOptionsWrapper.isAngularCompileRows() && this.scope) {
	            this.scope.data = __assign({}, this.rowNode.data);
	            this.angular1Compile();
	        }
	    };
	    CellComp.prototype.angular1Compile = function () {
	        // if angular compiling, then need to also compile the cell again (angular compiling sucks, please wait...)
	        if (this.beans.gridOptionsWrapper.isAngularCompileRows()) {
	            var eGui = this.getGui();
	            // only compile the node if it hasn't already been done
	            // this prevents "orphaned" node leaks
	            if (!eGui.classList.contains('ng-scope') || eGui.childElementCount === 0) {
	                var compiledElement_1 = this.beans.$compile(eGui)(this.scope);
	                this.addDestroyFunc(function () {
	                    compiledElement_1.remove();
	                });
	            }
	        }
	    };
	    CellComp.prototype.postProcessStylesFromColDef = function () {
	        var stylesToUse = this.processStylesFromColDef();
	        if (stylesToUse) {
	            utils_1._.addStylesToElement(this.getGui(), stylesToUse);
	        }
	    };
	    CellComp.prototype.preProcessStylesFromColDef = function () {
	        var stylesToUse = this.processStylesFromColDef();
	        return utils_1._.cssStyleObjectToMarkup(stylesToUse);
	    };
	    CellComp.prototype.processStylesFromColDef = function () {
	        var colDef = this.getComponentHolder();
	        if (colDef.cellStyle) {
	            var cssToUse = void 0;
	            if (typeof colDef.cellStyle === 'function') {
	                var cellStyleParams = {
	                    value: this.value,
	                    data: this.rowNode.data,
	                    node: this.rowNode,
	                    colDef: colDef,
	                    column: this.column,
	                    $scope: this.scope,
	                    context: this.beans.gridOptionsWrapper.getContext(),
	                    api: this.beans.gridOptionsWrapper.getApi()
	                };
	                var cellStyleFunc = colDef.cellStyle;
	                cssToUse = cellStyleFunc(cellStyleParams);
	            }
	            else {
	                cssToUse = colDef.cellStyle;
	            }
	            return cssToUse;
	        }
	    };
	    CellComp.prototype.postProcessClassesFromColDef = function () {
	        var _this = this;
	        this.processClassesFromColDef(function (className) { return utils_1._.addCssClass(_this.getGui(), className); });
	    };
	    CellComp.prototype.preProcessClassesFromColDef = function () {
	        var res = [];
	        this.processClassesFromColDef(function (className) { return res.push(className); });
	        return res;
	    };
	    CellComp.prototype.processClassesFromColDef = function (onApplicableClass) {
	        var colDef = this.getComponentHolder();
	        this.beans.stylingService.processStaticCellClasses(colDef, {
	            value: this.value,
	            data: this.rowNode.data,
	            node: this.rowNode,
	            colDef: colDef,
	            rowIndex: this.rowNode.rowIndex,
	            $scope: this.scope,
	            api: this.beans.gridOptionsWrapper.getApi(),
	            columnApi: this.beans.gridOptionsWrapper.getColumnApi(),
	            context: this.beans.gridOptionsWrapper.getContext()
	        }, onApplicableClass);
	    };
	    CellComp.prototype.putDataIntoCellAfterRefresh = function () {
	        // template gets preference, then cellRenderer, then do it ourselves
	        var colDef = this.getComponentHolder();
	        if (colDef.template) {
	            // template is really only used for angular 1 - as people using ng1 are used to providing templates with
	            // bindings in it. in ng2, people will hopefully want to provide components, not templates.
	            this.eParentOfValue.innerHTML = colDef.template;
	        }
	        else if (colDef.templateUrl) {
	            // likewise for templateUrl - it's for ng1 really - when we move away from ng1, we can take these out.
	            // niall was pro angular 1 when writing template and templateUrl, if writing from scratch now, would
	            // not do these, but would follow a pattern that was friendly towards components, not templates.
	            var template = this.beans.templateService.getTemplate(colDef.templateUrl, this.refreshCell.bind(this, true));
	            if (template) {
	                this.eParentOfValue.innerHTML = template;
	            }
	        }
	        else {
	            // we can switch from using a cell renderer back to the default if a user
	            // is using cellRendererSelect
	            this.chooseCellRenderer();
	            if (this.usingCellRenderer) {
	                this.createCellRendererInstance();
	            }
	            else {
	                var valueToUse = this.getValueToUse();
	                if (valueToUse !== null && valueToUse !== undefined) {
	                    this.eParentOfValue.innerHTML = utils_1._.escape(valueToUse);
	                }
	            }
	        }
	    };
	    CellComp.prototype.attemptCellRendererRefresh = function () {
	        if (utils_1._.missing(this.cellRenderer) || !this.cellRenderer || utils_1._.missing(this.cellRenderer.refresh)) {
	            return false;
	        }
	        // if the cell renderer has a refresh method, we call this instead of doing a refresh
	        var params = this.createCellRendererParams();
	        // take any custom params off of the user
	        var finalParams = this.beans.userComponentFactory.createFinalParams(this.getComponentHolder(), this.cellRendererType, params);
	        var result = this.cellRenderer.refresh(finalParams);
	        // NOTE on undefined: previous version of the cellRenderer.refresh() interface
	        // returned nothing, if the method existed, we assumed it refreshed. so for
	        // backwards compatibility, we assume if method exists and returns nothing,
	        // that it was successful.
	        return result === true || result === undefined;
	    };
	    CellComp.prototype.refreshToolTip = function () {
	        var newTooltip = this.getToolTip();
	        if (this.tooltip === newTooltip) {
	            return;
	        }
	        var hasNewTooltip = utils_1._.exists(newTooltip);
	        var hadTooltip = utils_1._.exists(this.tooltip);
	        if (hasNewTooltip && this.tooltip === newTooltip.toString()) {
	            return;
	        }
	        this.tooltip = newTooltip;
	        if (this.beans.gridOptionsWrapper.isEnableBrowserTooltips()) {
	            if (hasNewTooltip) {
	                var tooltipSanitised = utils_1._.escape(this.tooltip);
	                this.eParentOfValue.setAttribute('title', tooltipSanitised);
	            }
	            else {
	                this.eParentOfValue.removeAttribute('title');
	            }
	        }
	        else {
	            if (hadTooltip) {
	                if (!hasNewTooltip) {
	                    this.beans.tooltipManager.unregisterTooltip(this);
	                }
	            }
	            else if (hasNewTooltip) {
	                this.beans.tooltipManager.registerTooltip(this);
	            }
	        }
	    };
	    CellComp.prototype.valuesAreEqual = function (val1, val2) {
	        // if the user provided an equals method, use that, otherwise do simple comparison
	        var colDef = this.getComponentHolder();
	        var equalsMethod = colDef ? colDef.equals : null;
	        if (equalsMethod) {
	            return equalsMethod(val1, val2);
	        }
	        return val1 === val2;
	    };
	    CellComp.prototype.getToolTip = function () {
	        var colDef = this.getComponentHolder();
	        var data = this.rowNode.data;
	        if (colDef.tooltipField && utils_1._.exists(data)) {
	            return utils_1._.getValueUsingField(data, colDef.tooltipField, this.column.isTooltipFieldContainsDots());
	        }
	        var valueGetter = colDef.tooltipValueGetter || colDef.tooltip;
	        if (valueGetter) {
	            return valueGetter({
	                api: this.beans.gridOptionsWrapper.getApi(),
	                columnApi: this.beans.gridOptionsWrapper.getColumnApi(),
	                colDef: colDef,
	                column: this.getColumn(),
	                context: this.beans.gridOptionsWrapper.getContext(),
	                value: this.value,
	                valueFormatted: this.valueFormatted,
	                rowIndex: this.cellPosition.rowIndex,
	                node: this.rowNode,
	                data: this.rowNode.data,
	                $scope: this.scope,
	            });
	        }
	        return null;
	    };
	    CellComp.prototype.getTooltipText = function (escape) {
	        if (escape === void 0) { escape = true; }
	        return escape ? utils_1._.escape(this.tooltip) : this.tooltip;
	    };
	    CellComp.prototype.processCellClassRules = function (onApplicableClass, onNotApplicableClass) {
	        var colDef = this.getComponentHolder();
	        this.beans.stylingService.processClassRules(colDef.cellClassRules, {
	            value: this.value,
	            data: this.rowNode.data,
	            node: this.rowNode,
	            colDef: colDef,
	            rowIndex: this.cellPosition.rowIndex,
	            api: this.beans.gridOptionsWrapper.getApi(),
	            columnApi: this.beans.gridOptionsWrapper.getColumnApi(),
	            $scope: this.scope,
	            context: this.beans.gridOptionsWrapper.getContext()
	        }, onApplicableClass, onNotApplicableClass);
	    };
	    CellComp.prototype.postProcessCellClassRules = function () {
	        var _this = this;
	        this.processCellClassRules(function (className) {
	            utils_1._.addCssClass(_this.getGui(), className);
	        }, function (className) {
	            utils_1._.removeCssClass(_this.getGui(), className);
	        });
	    };
	    CellComp.prototype.preProcessCellClassRules = function () {
	        var res = [];
	        this.processCellClassRules(function (className) {
	            res.push(className);
	        }, function (className) {
	            // not catered for, if creating, no need
	            // to remove class as it was never there
	        });
	        return res;
	    };
	    // a wrapper is used when we are putting a selection checkbox in the cell with the value
	    CellComp.prototype.setUsingWrapper = function () {
	        var colDef = this.getComponentHolder();
	        // never allow selection or dragging on pinned rows
	        if (this.rowNode.rowPinned) {
	            this.usingWrapper = false;
	            this.includeSelectionComponent = false;
	            this.includeRowDraggingComponent = false;
	            this.includeDndSourceComponent = false;
	            return;
	        }
	        var cbSelectionIsFunc = typeof colDef.checkboxSelection === 'function';
	        var rowDraggableIsFunc = typeof colDef.rowDrag === 'function';
	        var dndSourceIsFunc = typeof colDef.dndSource === 'function';
	        this.includeSelectionComponent = cbSelectionIsFunc || colDef.checkboxSelection === true;
	        this.includeRowDraggingComponent = rowDraggableIsFunc || colDef.rowDrag === true;
	        this.includeDndSourceComponent = dndSourceIsFunc || colDef.dndSource === true;
	        this.usingWrapper = this.includeRowDraggingComponent || this.includeSelectionComponent || this.includeDndSourceComponent;
	    };
	    CellComp.prototype.chooseCellRenderer = function () {
	        // template gets preference, then cellRenderer, then do it ourselves
	        var colDef = this.getComponentHolder();
	        // templates are for ng1, ideally we wouldn't have these, they are ng1 support
	        // inside the core which is bad
	        if (colDef.template || colDef.templateUrl) {
	            this.usingCellRenderer = false;
	            return;
	        }
	        var params = this.createCellRendererParams();
	        var cellRenderer = this.beans.userComponentFactory.lookupComponentClassDef(colDef, 'cellRenderer', params);
	        var pinnedRowCellRenderer = this.beans.userComponentFactory.lookupComponentClassDef(colDef, 'pinnedRowCellRenderer', params);
	        if (pinnedRowCellRenderer && this.rowNode.rowPinned) {
	            this.cellRendererType = CellComp.CELL_RENDERER_TYPE_PINNED;
	            this.usingCellRenderer = true;
	        }
	        else if (cellRenderer) {
	            this.cellRendererType = CellComp.CELL_RENDERER_TYPE_NORMAL;
	            this.usingCellRenderer = true;
	        }
	        else {
	            this.usingCellRenderer = false;
	        }
	    };
	    CellComp.prototype.createCellRendererInstance = function (useTaskService) {
	        var _this = this;
	        if (useTaskService === void 0) { useTaskService = false; }
	        if (!this.usingCellRenderer) {
	            return;
	        }
	        // never use task service if angularCompileRows=true, as that assume the cell renderers
	        // are finished when the row is created. also we never use it if animation frame service
	        // is turned off.
	        // and lastly we never use it if doing auto-height, as the auto-height service checks the
	        // row height directly after the cell is created, it doesn't wait around for the tasks to complete
	        var angularCompileRows = this.beans.gridOptionsWrapper.isAngularCompileRows();
	        var suppressAnimationFrame = this.beans.gridOptionsWrapper.isSuppressAnimationFrame();
	        if (angularCompileRows || suppressAnimationFrame || this.autoHeightCell) {
	            useTaskService = false;
	        }
	        var params = this.createCellRendererParams();
	        this.cellRendererVersion++;
	        var callback = this.afterCellRendererCreated.bind(this, this.cellRendererVersion);
	        var cellRendererTypeNormal = this.cellRendererType === CellComp.CELL_RENDERER_TYPE_NORMAL;
	        var task = function () {
	            // this can return null in the event that the user has switched from a renderer component to nothing, for example
	            // when using a cellRendererSelect to return a component or null depending on row data etc
	            var componentPromise;
	            if (cellRendererTypeNormal) {
	                componentPromise = _this.beans.userComponentFactory.newCellRenderer(_this.getComponentHolder(), params);
	            }
	            else {
	                componentPromise = _this.beans.userComponentFactory.newPinnedRowCellRenderer(_this.getComponentHolder(), params);
	            }
	            if (componentPromise) {
	                componentPromise.then(callback);
	            }
	        };
	        if (useTaskService) {
	            this.beans.taskQueue.addP2Task(task);
	        }
	        else {
	            task();
	        }
	    };
	    CellComp.prototype.afterCellRendererCreated = function (cellRendererVersion, cellRenderer) {
	        // see if daemon
	        if (!this.isAlive() || (cellRendererVersion !== this.cellRendererVersion)) {
	            if (cellRenderer.destroy) {
	                cellRenderer.destroy();
	            }
	            return;
	        }
	        this.cellRenderer = cellRenderer;
	        this.cellRendererGui = this.cellRenderer.getGui();
	        if (utils_1._.missing(this.cellRendererGui)) {
	            return;
	        }
	        // if async components, then it's possible the user started editing since
	        // this call was made
	        if (!this.editingCell) {
	            this.eParentOfValue.appendChild(this.cellRendererGui);
	        }
	    };
	    CellComp.prototype.createCellRendererParams = function () {
	        var _this = this;
	        var params = {
	            value: this.value,
	            valueFormatted: this.valueFormatted,
	            getValue: this.getValue.bind(this),
	            setValue: function (value) {
	                _this.beans.valueService.setValue(_this.rowNode, _this.column, value);
	            },
	            formatValue: this.formatValue.bind(this),
	            data: this.rowNode.data,
	            node: this.rowNode,
	            colDef: this.getComponentHolder(),
	            column: this.column,
	            $scope: this.scope,
	            rowIndex: this.cellPosition.rowIndex,
	            api: this.beans.gridOptionsWrapper.getApi(),
	            columnApi: this.beans.gridOptionsWrapper.getColumnApi(),
	            context: this.beans.gridOptionsWrapper.getContext(),
	            refreshCell: this.refreshCell.bind(this),
	            eGridCell: this.getGui(),
	            eParentOfValue: this.eParentOfValue,
	            // these bits are not documented anywhere, so we could drop them?
	            // it was in the olden days to allow user to register for when rendered
	            // row was removed (the row comp was removed), however now that the user
	            // can provide components for cells, the destroy method gets call when this
	            // happens so no longer need to fire event.
	            addRowCompListener: this.rowComp ? this.rowComp.addEventListener.bind(this.rowComp) : null,
	            addRenderedRowListener: function (eventType, listener) {
	                console.warn('ag-Grid: since ag-Grid .v11, params.addRenderedRowListener() is now params.addRowCompListener()');
	                if (_this.rowComp) {
	                    _this.rowComp.addEventListener(eventType, listener);
	                }
	            }
	        };
	        return params;
	    };
	    CellComp.prototype.formatValue = function (value) {
	        var valueFormatted = this.beans.valueFormatterService.formatValue(this.column, this.rowNode, this.scope, value);
	        var valueFormattedExists = valueFormatted !== null && valueFormatted !== undefined;
	        return valueFormattedExists ? valueFormatted : value;
	    };
	    CellComp.prototype.getValueToUse = function () {
	        var valueFormattedExists = this.valueFormatted !== null && this.valueFormatted !== undefined;
	        return valueFormattedExists ? this.valueFormatted : this.value;
	    };
	    CellComp.prototype.getValueAndFormat = function () {
	        this.value = this.getValue();
	        this.valueFormatted = this.beans.valueFormatterService.formatValue(this.column, this.rowNode, this.scope, this.value);
	    };
	    CellComp.prototype.getValue = function () {
	        // if we don't check this, then the grid will render leaf groups as open even if we are not
	        // allowing the user to open leaf groups. confused? remember for pivot mode we don't allow
	        // opening leaf groups, so we have to force leafGroups to be closed in case the user expanded
	        // them via the API, or user user expanded them in the UI before turning on pivot mode
	        var lockedClosedGroup = this.rowNode.leafGroup && this.beans.columnController.isPivotMode();
	        var isOpenGroup = this.rowNode.group && this.rowNode.expanded && !this.rowNode.footer && !lockedClosedGroup;
	        // are we showing group footers
	        var groupFootersEnabled = this.beans.gridOptionsWrapper.isGroupIncludeFooter();
	        // if doing footers, we normally don't show agg data at group level when group is open
	        var groupAlwaysShowAggData = this.beans.gridOptionsWrapper.isGroupSuppressBlankHeader();
	        // if doing grouping and footers, we don't want to include the agg value
	        // in the header when the group is open
	        var ignoreAggData = (isOpenGroup && groupFootersEnabled) && !groupAlwaysShowAggData;
	        return this.beans.valueService.getValue(this.column, this.rowNode, false, ignoreAggData);
	    };
	    CellComp.prototype.onMouseEvent = function (eventName, mouseEvent) {
	        if (utils_1._.isStopPropagationForAgGrid(mouseEvent)) {
	            return;
	        }
	        switch (eventName) {
	            case 'click':
	                this.onCellClicked(mouseEvent);
	                break;
	            case 'mousedown':
	                this.onMouseDown(mouseEvent);
	                break;
	            case 'dblclick':
	                this.onCellDoubleClicked(mouseEvent);
	                break;
	            case 'mouseout':
	                this.onMouseOut(mouseEvent);
	                break;
	            case 'mouseover':
	                this.onMouseOver(mouseEvent);
	                break;
	        }
	    };
	    CellComp.prototype.dispatchCellContextMenuEvent = function (event) {
	        var colDef = this.getComponentHolder();
	        var cellContextMenuEvent = this.createEvent(event, events_1.Events.EVENT_CELL_CONTEXT_MENU);
	        this.beans.eventService.dispatchEvent(cellContextMenuEvent);
	        if (colDef.onCellContextMenu) {
	            // to make the callback async, do in a timeout
	            window.setTimeout(function () { return colDef.onCellContextMenu(cellContextMenuEvent); }, 0);
	        }
	    };
	    CellComp.prototype.createEvent = function (domEvent, eventType) {
	        var event = {
	            node: this.rowNode,
	            data: this.rowNode.data,
	            value: this.value,
	            column: this.column,
	            colDef: this.getComponentHolder(),
	            context: this.beans.gridOptionsWrapper.getContext(),
	            api: this.beans.gridApi,
	            columnApi: this.beans.columnApi,
	            rowPinned: this.rowNode.rowPinned,
	            event: domEvent,
	            type: eventType,
	            rowIndex: this.rowNode.rowIndex
	        };
	        // because we are hacking in $scope for angular 1, we have to de-reference
	        if (this.scope) {
	            event.$scope = this.scope;
	        }
	        return event;
	    };
	    CellComp.prototype.onMouseOut = function (mouseEvent) {
	        var cellMouseOutEvent = this.createEvent(mouseEvent, events_1.Events.EVENT_CELL_MOUSE_OUT);
	        this.beans.eventService.dispatchEvent(cellMouseOutEvent);
	        this.beans.columnHoverService.clearMouseOver();
	    };
	    CellComp.prototype.onMouseOver = function (mouseEvent) {
	        var cellMouseOverEvent = this.createEvent(mouseEvent, events_1.Events.EVENT_CELL_MOUSE_OVER);
	        this.beans.eventService.dispatchEvent(cellMouseOverEvent);
	        this.beans.columnHoverService.setMouseOver([this.column]);
	    };
	    CellComp.prototype.onCellDoubleClicked = function (mouseEvent) {
	        var colDef = this.getComponentHolder();
	        // always dispatch event to eventService
	        var cellDoubleClickedEvent = this.createEvent(mouseEvent, events_1.Events.EVENT_CELL_DOUBLE_CLICKED);
	        this.beans.eventService.dispatchEvent(cellDoubleClickedEvent);
	        // check if colDef also wants to handle event
	        if (typeof colDef.onCellDoubleClicked === 'function') {
	            // to make the callback async, do in a timeout
	            window.setTimeout(function () { return colDef.onCellDoubleClicked(cellDoubleClickedEvent); }, 0);
	        }
	        var editOnDoubleClick = !this.beans.gridOptionsWrapper.isSingleClickEdit()
	            && !this.beans.gridOptionsWrapper.isSuppressClickEdit();
	        if (editOnDoubleClick) {
	            this.startRowOrCellEdit();
	        }
	    };
	    // called by rowRenderer when user navigates via tab key
	    CellComp.prototype.startRowOrCellEdit = function (keyPress, charPress) {
	        if (this.beans.gridOptionsWrapper.isFullRowEdit()) {
	            this.rowComp.startRowEditing(keyPress, charPress, this);
	        }
	        else {
	            this.startEditingIfEnabled(keyPress, charPress, true);
	        }
	    };
	    CellComp.prototype.isCellEditable = function () {
	        return this.column.isCellEditable(this.rowNode);
	    };
	    // either called internally if single cell editing, or called by rowRenderer if row editing
	    CellComp.prototype.startEditingIfEnabled = function (keyPress, charPress, cellStartedEdit) {
	        if (keyPress === void 0) { keyPress = null; }
	        if (charPress === void 0) { charPress = null; }
	        if (cellStartedEdit === void 0) { cellStartedEdit = false; }
	        // don't do it if not editable
	        if (!this.isCellEditable()) {
	            return;
	        }
	        // don't do it if already editing
	        if (this.editingCell) {
	            return;
	        }
	        this.editingCell = true;
	        this.cellEditorVersion++;
	        var callback = this.afterCellEditorCreated.bind(this, this.cellEditorVersion);
	        var params = this.createCellEditorParams(keyPress, charPress, cellStartedEdit);
	        this.createCellEditor(params).then(callback);
	        // if we don't do this, and editor component is async, then there will be a period
	        // when the component isn't present and keyboard navigation won't work - so example
	        // of user hitting tab quickly (more quickly than renderers getting created) won't work
	        var cellEditorAsync = utils_1._.missing(this.cellEditor);
	        if (cellEditorAsync && cellStartedEdit) {
	            this.focusCell(true);
	        }
	    };
	    CellComp.prototype.createCellEditor = function (params) {
	        var _this = this;
	        var cellEditorPromise = this.beans.userComponentFactory.newCellEditor(this.column.getColDef(), params);
	        return cellEditorPromise.map(function (cellEditor) {
	            var isPopup = cellEditor.isPopup && cellEditor.isPopup();
	            if (!isPopup) {
	                return cellEditor;
	            }
	            if (_this.beans.gridOptionsWrapper.isFullRowEdit()) {
	                console.warn('ag-Grid: popup cellEditor does not work with fullRowEdit - you cannot use them both ' +
	                    '- either turn off fullRowEdit, or stop using popup editors.');
	            }
	            // if a popup, then we wrap in a popup editor and return the popup
	            var popupEditorWrapper = new popupEditorWrapper_1.PopupEditorWrapper(cellEditor);
	            _this.beans.context.wireBean(popupEditorWrapper);
	            popupEditorWrapper.init(params);
	            return popupEditorWrapper;
	        });
	    };
	    CellComp.prototype.afterCellEditorCreated = function (cellEditorVersion, cellEditor) {
	        // if editingCell=false, means user cancelled the editor before component was ready.
	        // if versionMismatch, then user cancelled the edit, then started the edit again, and this
	        //   is the first editor which is now stale.
	        var versionMismatch = cellEditorVersion !== this.cellEditorVersion;
	        if (versionMismatch || !this.editingCell) {
	            if (cellEditor.destroy) {
	                cellEditor.destroy();
	            }
	            return;
	        }
	        if (cellEditor.isCancelBeforeStart && cellEditor.isCancelBeforeStart()) {
	            if (cellEditor.destroy) {
	                cellEditor.destroy();
	            }
	            this.editingCell = false;
	            return;
	        }
	        if (!cellEditor.getGui) {
	            console.warn("ag-Grid: cellEditor for column " + this.column.getId() + " is missing getGui() method");
	            // no getGui, for React guys, see if they attached a react component directly
	            if (cellEditor.render) {
	                console.warn("ag-Grid: we found 'render' on the component, are you trying to set a React renderer but added it as colDef.cellEditor instead of colDef.cellEditorFmk?");
	            }
	            if (cellEditor.destroy) {
	                cellEditor.destroy();
	            }
	            this.editingCell = false;
	            return;
	        }
	        this.cellEditor = cellEditor;
	        this.cellEditorInPopup = cellEditor.isPopup !== undefined && cellEditor.isPopup();
	        this.setInlineEditingClass();
	        if (this.cellEditorInPopup) {
	            this.addPopupCellEditor();
	        }
	        else {
	            this.addInCellEditor();
	        }
	        if (cellEditor.afterGuiAttached) {
	            cellEditor.afterGuiAttached();
	        }
	        var event = this.createEvent(null, events_1.Events.EVENT_CELL_EDITING_STARTED);
	        this.beans.eventService.dispatchEvent(event);
	    };
	    CellComp.prototype.addInCellEditor = function () {
	        utils_1._.clearElement(this.getGui());
	        if (this.cellEditor) {
	            this.getGui().appendChild(this.cellEditor.getGui());
	        }
	        this.angular1Compile();
	    };
	    CellComp.prototype.addPopupCellEditor = function () {
	        var _this = this;
	        var ePopupGui = this.cellEditor ? this.cellEditor.getGui() : null;
	        this.hideEditorPopup = this.beans.popupService.addAsModalPopup(ePopupGui, true, 
	        // callback for when popup disappears
	        function () {
	            _this.onPopupEditorClosed();
	        });
	        this.beans.popupService.positionPopupOverComponent({
	            column: this.column,
	            rowNode: this.rowNode,
	            type: 'popupCellEditor',
	            eventSource: this.getGui(),
	            ePopup: ePopupGui,
	            keepWithinBounds: true
	        });
	        this.angular1Compile();
	    };
	    CellComp.prototype.onPopupEditorClosed = function () {
	        // we only call stopEditing if we are editing, as
	        // it's possible the popup called 'stop editing'
	        // before this, eg if 'enter key' was pressed on
	        // the editor.
	        if (this.editingCell) {
	            // note: this only happens when use clicks outside of the grid. if use clicks on another
	            // cell, then the editing will have already stopped on this cell
	            this.stopRowOrCellEdit();
	            // we only focus cell again if this cell is still focused. it is possible
	            // it is not focused if the user cancelled the edit by clicking on another
	            // cell outside of this one
	            if (this.beans.focusedCellController.isCellFocused(this.cellPosition)) {
	                this.focusCell(true);
	            }
	        }
	    };
	    // if we are editing inline, then we don't have the padding in the cell (set in the themes)
	    // to allow the text editor full access to the entire cell
	    CellComp.prototype.setInlineEditingClass = function () {
	        // ag-cell-inline-editing - appears when user is inline editing
	        // ag-cell-not-inline-editing - appears when user is no inline editing
	        // ag-cell-popup-editing - appears when user is editing cell in popup (appears on the cell, not on the popup)
	        // note: one of {ag-cell-inline-editing, ag-cell-not-inline-editing} is always present, they toggle.
	        //       however {ag-cell-popup-editing} shows when popup, so you have both {ag-cell-popup-editing}
	        //       and {ag-cell-not-inline-editing} showing at the same time.
	        var editingInline = this.editingCell && !this.cellEditorInPopup;
	        var popupEditorShowing = this.editingCell && this.cellEditorInPopup;
	        utils_1._.addOrRemoveCssClass(this.getGui(), "ag-cell-inline-editing", editingInline);
	        utils_1._.addOrRemoveCssClass(this.getGui(), "ag-cell-not-inline-editing", !editingInline);
	        utils_1._.addOrRemoveCssClass(this.getGui(), "ag-cell-popup-editing", popupEditorShowing);
	        utils_1._.addOrRemoveCssClass(this.getGui().parentNode, "ag-row-inline-editing", editingInline);
	        utils_1._.addOrRemoveCssClass(this.getGui().parentNode, "ag-row-not-inline-editing", !editingInline);
	    };
	    CellComp.prototype.createCellEditorParams = function (keyPress, charPress, cellStartedEdit) {
	        var params = {
	            value: this.getValue(),
	            keyPress: keyPress,
	            charPress: charPress,
	            column: this.column,
	            colDef: this.column.getColDef(),
	            rowIndex: this.cellPosition.rowIndex,
	            node: this.rowNode,
	            data: this.rowNode.data,
	            api: this.beans.gridOptionsWrapper.getApi(),
	            cellStartedEdit: cellStartedEdit,
	            columnApi: this.beans.gridOptionsWrapper.getColumnApi(),
	            context: this.beans.gridOptionsWrapper.getContext(),
	            $scope: this.scope,
	            onKeyDown: this.onKeyDown.bind(this),
	            stopEditing: this.stopEditingAndFocus.bind(this),
	            eGridCell: this.getGui(),
	            parseValue: this.parseValue.bind(this),
	            formatValue: this.formatValue.bind(this)
	        };
	        return params;
	    };
	    // cell editors call this, when they want to stop for reasons other
	    // than what we pick up on. eg selecting from a dropdown ends editing.
	    CellComp.prototype.stopEditingAndFocus = function (suppressNavigateAfterEdit) {
	        if (suppressNavigateAfterEdit === void 0) { suppressNavigateAfterEdit = false; }
	        this.stopRowOrCellEdit();
	        this.focusCell(true);
	        if (!suppressNavigateAfterEdit) {
	            this.navigateAfterEdit();
	        }
	    };
	    CellComp.prototype.parseValue = function (newValue) {
	        var colDef = this.getComponentHolder();
	        var params = {
	            node: this.rowNode,
	            data: this.rowNode.data,
	            oldValue: this.value,
	            newValue: newValue,
	            colDef: colDef,
	            column: this.column,
	            api: this.beans.gridOptionsWrapper.getApi(),
	            columnApi: this.beans.gridOptionsWrapper.getColumnApi(),
	            context: this.beans.gridOptionsWrapper.getContext()
	        };
	        var valueParser = colDef.valueParser;
	        return utils_1._.exists(valueParser) ? this.beans.expressionService.evaluate(valueParser, params) : newValue;
	    };
	    CellComp.prototype.focusCell = function (forceBrowserFocus) {
	        if (forceBrowserFocus === void 0) { forceBrowserFocus = false; }
	        this.beans.focusedCellController.setFocusedCell(this.cellPosition.rowIndex, this.column, this.rowNode.rowPinned, forceBrowserFocus);
	    };
	    CellComp.prototype.setFocusInOnEditor = function () {
	        if (this.editingCell) {
	            if (this.cellEditor && this.cellEditor.focusIn) {
	                // if the editor is present, then we just focus it
	                this.cellEditor.focusIn();
	            }
	            else {
	                // if the editor is not present, it means async cell editor (eg React fibre)
	                // and we are trying to set focus before the cell editor is present, so we
	                // focus the cell instead
	                this.focusCell(true);
	            }
	        }
	    };
	    CellComp.prototype.isEditing = function () {
	        return this.editingCell;
	    };
	    CellComp.prototype.onKeyDown = function (event) {
	        var key = event.which || event.keyCode;
	        switch (key) {
	            case constants_1.Constants.KEY_ENTER:
	                this.onEnterKeyDown();
	                break;
	            case constants_1.Constants.KEY_F2:
	                this.onF2KeyDown();
	                break;
	            case constants_1.Constants.KEY_ESCAPE:
	                this.onEscapeKeyDown();
	                break;
	            case constants_1.Constants.KEY_TAB:
	                this.onTabKeyDown(event);
	                break;
	            case constants_1.Constants.KEY_BACKSPACE:
	            case constants_1.Constants.KEY_DELETE:
	                this.onBackspaceOrDeleteKeyPressed(key);
	                break;
	            case constants_1.Constants.KEY_DOWN:
	            case constants_1.Constants.KEY_UP:
	            case constants_1.Constants.KEY_RIGHT:
	            case constants_1.Constants.KEY_LEFT:
	                this.onNavigationKeyPressed(event, key);
	                break;
	        }
	    };
	    CellComp.prototype.setFocusOutOnEditor = function () {
	        if (this.editingCell && this.cellEditor && this.cellEditor.focusOut) {
	            this.cellEditor.focusOut();
	        }
	    };
	    CellComp.prototype.onNavigationKeyPressed = function (event, key) {
	        if (this.editingCell) {
	            return;
	        }
	        if (event.shiftKey && this.rangeSelectionEnabled) {
	            this.onShiftRangeSelect(key);
	        }
	        else {
	            this.beans.rowRenderer.navigateToNextCell(event, key, this.cellPosition, true);
	        }
	        // if we don't prevent default, the grid will scroll with the navigation keys
	        event.preventDefault();
	    };
	    CellComp.prototype.onShiftRangeSelect = function (key) {
	        var endCell = this.beans.rangeController.extendLatestRangeInDirection(key);
	        if (endCell) {
	            this.beans.rowRenderer.ensureCellVisible(endCell);
	        }
	    };
	    CellComp.prototype.onTabKeyDown = function (event) {
	        this.beans.rowRenderer.onTabKeyDown(this, event);
	    };
	    CellComp.prototype.onBackspaceOrDeleteKeyPressed = function (key) {
	        if (!this.editingCell) {
	            this.startRowOrCellEdit(key);
	        }
	    };
	    CellComp.prototype.onEnterKeyDown = function () {
	        if (this.editingCell || this.rowComp.isEditing()) {
	            this.stopEditingAndFocus();
	        }
	        else {
	            if (this.beans.gridOptionsWrapper.isEnterMovesDown()) {
	                this.beans.rowRenderer.navigateToNextCell(null, constants_1.Constants.KEY_DOWN, this.cellPosition, false);
	            }
	            else {
	                this.startRowOrCellEdit(constants_1.Constants.KEY_ENTER);
	            }
	        }
	    };
	    CellComp.prototype.navigateAfterEdit = function () {
	        var fullRowEdit = this.beans.gridOptionsWrapper.isFullRowEdit();
	        if (fullRowEdit) {
	            return;
	        }
	        var enterMovesDownAfterEdit = this.beans.gridOptionsWrapper.isEnterMovesDownAfterEdit();
	        if (enterMovesDownAfterEdit) {
	            this.beans.rowRenderer.navigateToNextCell(null, constants_1.Constants.KEY_DOWN, this.cellPosition, false);
	        }
	    };
	    CellComp.prototype.onF2KeyDown = function () {
	        if (!this.editingCell) {
	            this.startRowOrCellEdit(constants_1.Constants.KEY_F2);
	        }
	    };
	    CellComp.prototype.onEscapeKeyDown = function () {
	        if (this.editingCell) {
	            this.stopRowOrCellEdit(true);
	            this.focusCell(true);
	        }
	    };
	    CellComp.prototype.onKeyPress = function (event) {
	        // check this, in case focus is on a (for example) a text field inside the cell,
	        // in which cse we should not be listening for these key pressed
	        var eventTarget = utils_1._.getTarget(event);
	        var eventOnChildComponent = eventTarget !== this.getGui();
	        if (eventOnChildComponent || this.editingCell) {
	            return;
	        }
	        var pressedChar = String.fromCharCode(event.charCode);
	        if (pressedChar === ' ') {
	            this.onSpaceKeyPressed(event);
	        }
	        else {
	            if (utils_1._.isEventFromPrintableCharacter(event)) {
	                this.startRowOrCellEdit(null, pressedChar);
	                // if we don't prevent default, then the keypress also gets applied to the text field
	                // (at least when doing the default editor), but we need to allow the editor to decide
	                // what it wants to do. we only do this IF editing was started - otherwise it messes
	                // up when the use is not doing editing, but using rendering with text fields in cellRenderer
	                // (as it would block the the user from typing into text fields).
	                event.preventDefault();
	            }
	        }
	    };
	    CellComp.prototype.onSpaceKeyPressed = function (event) {
	        if (!this.editingCell && this.beans.gridOptionsWrapper.isRowSelection()) {
	            var selected = this.rowNode.isSelected();
	            this.rowNode.setSelected(!selected);
	        }
	        // prevent default as space key, by default, moves browser scroll down
	        event.preventDefault();
	    };
	    CellComp.prototype.onMouseDown = function (mouseEvent) {
	        // we only need to pass true to focusCell in when the browser is IE
	        // and we are trying to focus a cell (has ag-cell class), otherwise
	        // we pass false, as we don't want the cell to focus also get the browser
	        // focus. if we did, then the cellRenderer could have a text field in it,
	        // for example, and as the user clicks on the text field, the text field,
	        // the focus doesn't get to the text field, instead to goes to the div
	        // behind, making it impossible to select the text field.
	        var forceBrowserFocus = false;
	        var button = mouseEvent.button, ctrlKey = mouseEvent.ctrlKey, metaKey = mouseEvent.metaKey, shiftKey = mouseEvent.shiftKey, target = mouseEvent.target;
	        var _a = this.beans, eventService = _a.eventService, rangeController = _a.rangeController;
	        if (rangeController) {
	            var cellInRange = rangeController.isCellInAnyRange(this.getCellPosition());
	            if (cellInRange && button === 2) {
	                return;
	            }
	        }
	        if (utils_1._.isBrowserIE()) {
	            if (target.classList.contains('ag-cell')) {
	                forceBrowserFocus = true;
	            }
	        }
	        if (!shiftKey || (rangeController && !rangeController.getCellRanges().length)) {
	            this.focusCell(forceBrowserFocus);
	        }
	        else {
	            // if a range is being changed, we need to make sure the focused cell does not change.
	            mouseEvent.preventDefault();
	        }
	        // if we are clicking on a checkbox, we need to make sure the cell wrapping that checkbox
	        // is focused but we don't want to change the range selection, so return here.
	        if (utils_1._.isElementChildOfClass(target, 'ag-selection-checkbox', 3)) {
	            return;
	        }
	        // if it's a right click, then if the cell is already in range,
	        // don't change the range, however if the cell is not in a range,
	        // we set a new range
	        var leftMouseButtonClick = utils_1._.isLeftClick(mouseEvent);
	        if (leftMouseButtonClick && rangeController) {
	            var thisCell = this.cellPosition;
	            if (shiftKey) {
	                rangeController.extendLatestRangeToCell(thisCell);
	            }
	            else {
	                var ctrlKeyPressed = ctrlKey || metaKey;
	                rangeController.setRangeToCell(thisCell, ctrlKeyPressed);
	            }
	        }
	        var cellMouseDownEvent = this.createEvent(mouseEvent, events_1.Events.EVENT_CELL_MOUSE_DOWN);
	        eventService.dispatchEvent(cellMouseDownEvent);
	    };
	    // returns true if on iPad and this is second 'click' event in 200ms
	    CellComp.prototype.isDoubleClickOnIPad = function () {
	        if (!utils_1._.isUserAgentIPad()) {
	            return false;
	        }
	        var nowMillis = new Date().getTime();
	        var res = nowMillis - this.lastIPadMouseClickEvent < 200;
	        this.lastIPadMouseClickEvent = nowMillis;
	        return res;
	    };
	    CellComp.prototype.onCellClicked = function (mouseEvent) {
	        // iPad doesn't have double click - so we need to mimic it do enable editing for
	        // iPad.
	        if (this.isDoubleClickOnIPad()) {
	            this.onCellDoubleClicked(mouseEvent);
	            mouseEvent.preventDefault(); // if we don't do this, then iPad zooms in
	            return;
	        }
	        var cellClickedEvent = this.createEvent(mouseEvent, events_1.Events.EVENT_CELL_CLICKED);
	        this.beans.eventService.dispatchEvent(cellClickedEvent);
	        var colDef = this.getComponentHolder();
	        if (colDef.onCellClicked) {
	            // to make callback async, do in a timeout
	            window.setTimeout(function () { return colDef.onCellClicked(cellClickedEvent); }, 0);
	        }
	        var editOnSingleClick = (this.beans.gridOptionsWrapper.isSingleClickEdit() || colDef.singleClickEdit)
	            && !this.beans.gridOptionsWrapper.isSuppressClickEdit();
	        if (editOnSingleClick) {
	            this.startRowOrCellEdit();
	        }
	        utils_1._.doIeFocusHack(this.getGui());
	    };
	    CellComp.prototype.createGridCellVo = function () {
	        this.cellPosition = {
	            rowIndex: this.rowNode.rowIndex,
	            rowPinned: this.rowNode.rowPinned,
	            column: this.column
	        };
	    };
	    CellComp.prototype.getCellPosition = function () {
	        return this.cellPosition;
	    };
	    CellComp.prototype.getParentRow = function () {
	        return this.eParentRow;
	    };
	    CellComp.prototype.setParentRow = function (eParentRow) {
	        this.eParentRow = eParentRow;
	    };
	    CellComp.prototype.getColumn = function () {
	        return this.column;
	    };
	    CellComp.prototype.getComponentHolder = function () {
	        return this.column.getColDef();
	    };
	    CellComp.prototype.detach = function () {
	        this.eParentRow.removeChild(this.getGui());
	    };
	    // if the row is also getting destroyed, then we don't need to remove from dom,
	    // as the row will also get removed, so no need to take out the cells from the row
	    // if the row is going (removing is an expensive operation, so only need to remove
	    // the top part)
	    CellComp.prototype.destroy = function () {
	        _super.prototype.destroy.call(this);
	        if (this.cellEditor && this.cellEditor.destroy) {
	            this.cellEditor.destroy();
	            this.cellEditor = null;
	        }
	        if (this.cellRenderer && this.cellRenderer.destroy) {
	            this.cellRenderer.destroy();
	            this.cellRenderer = null;
	        }
	        if (this.selectionHandle) {
	            this.selectionHandle.destroy();
	        }
	    };
	    CellComp.prototype.onLeftChanged = function () {
	        var left = this.modifyLeftForPrintLayout(this.getCellLeft());
	        this.getGui().style.left = left + 'px';
	    };
	    CellComp.prototype.modifyLeftForPrintLayout = function (leftPosition) {
	        if (!this.printLayout) {
	            return leftPosition;
	        }
	        if (this.column.getPinned() === column_1.Column.PINNED_LEFT) {
	            return leftPosition;
	        }
	        if (this.column.getPinned() === column_1.Column.PINNED_RIGHT) {
	            var leftWidth_1 = this.beans.columnController.getPinnedLeftContainerWidth();
	            var bodyWidth = this.beans.columnController.getBodyContainerWidth();
	            return leftWidth_1 + bodyWidth + leftPosition;
	        }
	        // is in body
	        var leftWidth = this.beans.columnController.getPinnedLeftContainerWidth();
	        return leftWidth + leftPosition;
	    };
	    CellComp.prototype.onWidthChanged = function () {
	        var width = this.getCellWidth();
	        this.getGui().style.width = width + 'px';
	    };
	    CellComp.prototype.getRangeBorders = function () {
	        var _this = this;
	        var isRtl = this.beans.gridOptionsWrapper.isEnableRtl();
	        var top = false;
	        var right = false;
	        var bottom = false;
	        var left = false;
	        var thisCol = this.cellPosition.column;
	        var rangeController = this.beans.rangeController;
	        var leftCol;
	        var rightCol;
	        if (isRtl) {
	            leftCol = this.beans.columnController.getDisplayedColAfter(thisCol);
	            rightCol = this.beans.columnController.getDisplayedColBefore(thisCol);
	        }
	        else {
	            leftCol = this.beans.columnController.getDisplayedColBefore(thisCol);
	            rightCol = this.beans.columnController.getDisplayedColAfter(thisCol);
	        }
	        var ranges = rangeController.getCellRanges().filter(function (range) { return rangeController.isCellInSpecificRange(_this.cellPosition, range); });
	        // this means we are the first column in the grid
	        if (!leftCol) {
	            left = true;
	        }
	        // this means we are the last column in the grid
	        if (!rightCol) {
	            right = true;
	        }
	        for (var i = 0; i < ranges.length; i++) {
	            if (top && right && bottom && left) {
	                break;
	            }
	            var range = ranges[i];
	            var startRow = rangeController.getRangeStartRow(range);
	            var endRow = rangeController.getRangeEndRow(range);
	            if (!top && this.beans.rowPositionUtils.sameRow(startRow, this.cellPosition)) {
	                top = true;
	            }
	            if (!bottom && this.beans.rowPositionUtils.sameRow(endRow, this.cellPosition)) {
	                bottom = true;
	            }
	            if (!left && range.columns.indexOf(leftCol) < 0) {
	                left = true;
	            }
	            if (!right && range.columns.indexOf(rightCol) < 0) {
	                right = true;
	            }
	        }
	        return { top: top, right: right, bottom: bottom, left: left };
	    };
	    CellComp.prototype.getInitialRangeClasses = function () {
	        var res = [];
	        if (!this.rangeSelectionEnabled || !this.rangeCount) {
	            return res;
	        }
	        var beans = this.beans;
	        var rangeController = beans.rangeController;
	        res.push('ag-cell-range-selected');
	        if (this.hasChartRange) {
	            res.push('ag-cell-range-chart');
	        }
	        var count = Math.min(this.rangeCount, 4);
	        res.push("ag-cell-range-selected-" + count);
	        if (this.rangeCount === 1 && !rangeController.isMoreThanOneCell()) {
	            res.push('ag-cell-range-single-cell');
	        }
	        if (this.rangeCount > 0) {
	            var borders = this.getRangeBorders();
	            if (borders.top) {
	                res.push('ag-cell-range-top');
	            }
	            if (borders.right) {
	                res.push('ag-cell-range-right');
	            }
	            if (borders.bottom) {
	                res.push('ag-cell-range-bottom');
	            }
	            if (borders.left) {
	                res.push('ag-cell-range-left');
	            }
	        }
	        if (!!this.selectionHandle) {
	            res.push('ag-cell-range-handle');
	        }
	        return res;
	    };
	    CellComp.prototype.onRowIndexChanged = function () {
	        // when index changes, this influences items that need the index, so we update the
	        // grid cell so they are working off the new index.
	        this.createGridCellVo();
	        // when the index of the row changes, ie means the cell may have lost or gained focus
	        this.onCellFocused();
	        // check range selection
	        this.onRangeSelectionChanged();
	    };
	    CellComp.prototype.onRangeSelectionChanged = function () {
	        if (!this.beans.enterprise) {
	            return;
	        }
	        var _a = this, beans = _a.beans, cellPosition = _a.cellPosition, rangeCount = _a.rangeCount;
	        var rangeController = beans.rangeController;
	        var newRangeCount = rangeController.getCellRangeCount(cellPosition);
	        var element = this.getGui();
	        if (rangeCount !== newRangeCount) {
	            utils_1._.addOrRemoveCssClass(element, 'ag-cell-range-selected', newRangeCount !== 0);
	            utils_1._.addOrRemoveCssClass(element, 'ag-cell-range-selected-1', newRangeCount === 1);
	            utils_1._.addOrRemoveCssClass(element, 'ag-cell-range-selected-2', newRangeCount === 2);
	            utils_1._.addOrRemoveCssClass(element, 'ag-cell-range-selected-3', newRangeCount === 3);
	            utils_1._.addOrRemoveCssClass(element, 'ag-cell-range-selected-4', newRangeCount >= 4);
	            this.rangeCount = newRangeCount;
	        }
	        var hasChartRange = this.rangeCount && rangeController.getCellRanges().every(function (range) { return utils_1._.exists(range.type); });
	        if (this.hasChartRange !== hasChartRange) {
	            utils_1._.addOrRemoveCssClass(element, 'ag-cell-range-chart', hasChartRange);
	            this.hasChartRange = hasChartRange;
	        }
	        this.updateRangeBorders();
	        var isSingleCell = this.rangeCount === 1 && !rangeController.isMoreThanOneCell();
	        utils_1._.addOrRemoveCssClass(element, 'ag-cell-range-single-cell', isSingleCell);
	        this.refreshHandle();
	        utils_1._.addOrRemoveCssClass(element, 'ag-cell-range-handle', !!this.selectionHandle);
	    };
	    CellComp.prototype.shouldHaveSelectionHandle = function () {
	        var _a = this.beans, gridOptionsWrapper = _a.gridOptionsWrapper, rangeController = _a.rangeController;
	        var el = this.getGui();
	        var cellRanges = rangeController.getCellRanges();
	        var rangesLen = cellRanges.length;
	        if (!rangesLen) {
	            return false;
	        }
	        var lastRange = utils_1._.last(cellRanges);
	        var isFirstRangeCategory = cellRanges[0].type === iRangeController_1.CellRangeType.DIMENSION;
	        var handlesAllowed = (gridOptionsWrapper.isEnableFillHandle() ||
	            gridOptionsWrapper.isEnableRangeHandle() ||
	            this.hasChartRange && !isFirstRangeCategory) && rangesLen === 1;
	        if (!handlesAllowed && this.hasChartRange) {
	            var cellPosition = this.getCellPosition();
	            handlesAllowed =
	                isFirstRangeCategory &&
	                    rangesLen === 2 &&
	                    rangeController.isCellInSpecificRange(this.getCellPosition(), lastRange);
	            var isCategory = isFirstRangeCategory &&
	                rangeController.isCellInSpecificRange(cellPosition, cellRanges[0]);
	            utils_1._.addOrRemoveCssClass(el, 'ag-cell-range-chart-category', isCategory);
	        }
	        return this.rangeCount &&
	            handlesAllowed &&
	            lastRange.endRow != null &&
	            this.beans.rangeController.isContiguousRange(lastRange) &&
	            (utils_1._.containsClass(el, 'ag-cell-range-single-cell') ||
	                (utils_1._.containsClass(el, 'ag-cell-range-bottom') && utils_1._.containsClass(el, 'ag-cell-range-right')));
	    };
	    CellComp.prototype.addSelectionHandle = function () {
	        var _a = this.beans, gridOptionsWrapper = _a.gridOptionsWrapper, context = _a.context, rangeController = _a.rangeController;
	        var cellRangeType = utils_1._.last(rangeController.getCellRanges()).type;
	        var type = (gridOptionsWrapper.isEnableFillHandle() && utils_1._.missing(cellRangeType)) ? 'fill' : 'range';
	        if (this.selectionHandle && this.selectionHandle.getType() !== type) {
	            this.selectionHandle.destroy();
	            this.selectionHandle = undefined;
	        }
	        if (!this.selectionHandle) {
	            this.selectionHandle = context.createComponentFromElement(document.createElement("ag-" + type + "-handle"));
	        }
	        this.selectionHandle.refresh(this);
	    };
	    CellComp.prototype.updateRangeBordersIfRangeCount = function () {
	        // we only need to update range borders if we are in a range
	        if (this.rangeCount > 0) {
	            this.updateRangeBorders();
	            this.refreshHandle();
	        }
	    };
	    CellComp.prototype.refreshHandle = function () {
	        var shouldHaveSelectionHandle = this.shouldHaveSelectionHandle();
	        if (this.selectionHandle && !shouldHaveSelectionHandle) {
	            this.selectionHandle.destroy();
	            this.selectionHandle = null;
	        }
	        if (shouldHaveSelectionHandle) {
	            this.addSelectionHandle();
	        }
	    };
	    CellComp.prototype.updateRangeBorders = function () {
	        var rangeBorders = this.getRangeBorders();
	        var isSingleCell = this.rangeCount === 1 && !this.beans.rangeController.isMoreThanOneCell();
	        var isTop = !isSingleCell && rangeBorders.top;
	        var isRight = !isSingleCell && rangeBorders.right;
	        var isBottom = !isSingleCell && rangeBorders.bottom;
	        var isLeft = !isSingleCell && rangeBorders.left;
	        var element = this.getGui();
	        utils_1._.addOrRemoveCssClass(element, 'ag-cell-range-top', isTop);
	        utils_1._.addOrRemoveCssClass(element, 'ag-cell-range-right', isRight);
	        utils_1._.addOrRemoveCssClass(element, 'ag-cell-range-bottom', isBottom);
	        utils_1._.addOrRemoveCssClass(element, 'ag-cell-range-left', isLeft);
	    };
	    CellComp.prototype.onFirstRightPinnedChanged = function () {
	        var firstRightPinned = this.column.isFirstRightPinned();
	        if (this.firstRightPinned !== firstRightPinned) {
	            this.firstRightPinned = firstRightPinned;
	            utils_1._.addOrRemoveCssClass(this.getGui(), 'ag-cell-first-right-pinned', firstRightPinned);
	        }
	    };
	    CellComp.prototype.onLastLeftPinnedChanged = function () {
	        var lastLeftPinned = this.column.isLastLeftPinned();
	        if (this.lastLeftPinned !== lastLeftPinned) {
	            this.lastLeftPinned = lastLeftPinned;
	            utils_1._.addOrRemoveCssClass(this.getGui(), 'ag-cell-last-left-pinned', lastLeftPinned);
	        }
	    };
	    CellComp.prototype.populateTemplate = function () {
	        if (this.usingWrapper) {
	            this.eParentOfValue = this.getRefElement('eCellValue');
	            this.eCellWrapper = this.getRefElement('eCellWrapper');
	            if (this.includeRowDraggingComponent) {
	                this.addRowDragging();
	            }
	            if (this.includeDndSourceComponent) {
	                this.addDndSource();
	            }
	            if (this.includeSelectionComponent) {
	                this.addSelectionCheckbox();
	            }
	        }
	        else {
	            this.eParentOfValue = this.getGui();
	        }
	    };
	    CellComp.prototype.getFrameworkOverrides = function () {
	        return this.beans.frameworkOverrides;
	    };
	    CellComp.prototype.addRowDragging = function () {
	        var pagination = this.beans.gridOptionsWrapper.isPagination();
	        var rowDragManaged = this.beans.gridOptionsWrapper.isRowDragManaged();
	        var clientSideRowModelActive = this.beans.gridOptionsWrapper.isRowModelDefault();
	        if (rowDragManaged) {
	            // row dragging only available in default row model
	            if (!clientSideRowModelActive) {
	                utils_1._.doOnce(function () { return console.warn('ag-Grid: managed row dragging is only allowed in the Client Side Row Model'); }, 'CellComp.addRowDragging');
	                return;
	            }
	            if (pagination) {
	                utils_1._.doOnce(function () { return console.warn('ag-Grid: managed row dragging is not possible when doing pagination'); }, 'CellComp.addRowDragging');
	                return;
	            }
	        }
	        var rowDraggingComp = new rowDragComp_1.RowDragComp(this.rowNode, this.column, this.getValueToUse(), this.beans);
	        this.addFeature(this.beans.context, rowDraggingComp);
	        // put the checkbox in before the value
	        this.eCellWrapper.insertBefore(rowDraggingComp.getGui(), this.eParentOfValue);
	    };
	    CellComp.prototype.addDndSource = function () {
	        var dndSourceComp = new dndSourceComp_1.DndSourceComp(this.rowNode, this.column, this.getValueToUse(), this.beans, this.getGui());
	        this.addFeature(this.beans.context, dndSourceComp);
	        // put the checkbox in before the value
	        this.eCellWrapper.insertBefore(dndSourceComp.getGui(), this.eParentOfValue);
	    };
	    CellComp.prototype.addSelectionCheckbox = function () {
	        var cbSelectionComponent = new checkboxSelectionComponent_1.CheckboxSelectionComponent();
	        this.beans.context.wireBean(cbSelectionComponent);
	        var visibleFunc = this.getComponentHolder().checkboxSelection;
	        visibleFunc = typeof visibleFunc === 'function' ? visibleFunc : null;
	        cbSelectionComponent.init({ rowNode: this.rowNode, column: this.column, visibleFunc: visibleFunc });
	        this.addDestroyFunc(function () { return cbSelectionComponent.destroy(); });
	        // put the checkbox in before the value
	        this.eCellWrapper.insertBefore(cbSelectionComponent.getGui(), this.eParentOfValue);
	    };
	    CellComp.prototype.addDomData = function () {
	        var _this = this;
	        var element = this.getGui();
	        this.beans.gridOptionsWrapper.setDomData(element, CellComp.DOM_DATA_KEY_CELL_COMP, this);
	        this.addDestroyFunc(function () {
	            return _this.beans.gridOptionsWrapper.setDomData(element, CellComp.DOM_DATA_KEY_CELL_COMP, null);
	        });
	    };
	    CellComp.prototype.onCellFocused = function (event) {
	        var cellFocused = this.beans.focusedCellController.isCellFocused(this.cellPosition);
	        // see if we need to change the classes on this cell
	        if (cellFocused !== this.cellFocused) {
	            // if we are not doing cell selection, then the focus class does not change
	            var doingFocusCss = !this.beans.gridOptionsWrapper.isSuppressCellSelection();
	            if (doingFocusCss) {
	                utils_1._.addOrRemoveCssClass(this.getGui(), 'ag-cell-focus', cellFocused);
	            }
	            this.cellFocused = cellFocused;
	        }
	        // if this cell was just focused, see if we need to force browser focus, his can
	        // happen if focus is programmatically set.
	        if (cellFocused && event && event.forceBrowserFocus) {
	            var eGui = this.getGui();
	            eGui.focus();
	            utils_1._.doIeFocusHack(eGui);
	        }
	        // if another cell was focused, and we are editing, then stop editing
	        var fullRowEdit = this.beans.gridOptionsWrapper.isFullRowEdit();
	        if (!cellFocused && !fullRowEdit && this.editingCell) {
	            this.stopRowOrCellEdit();
	        }
	    };
	    // pass in 'true' to cancel the editing.
	    CellComp.prototype.stopRowOrCellEdit = function (cancel) {
	        if (cancel === void 0) { cancel = false; }
	        if (this.beans.gridOptionsWrapper.isFullRowEdit()) {
	            this.rowComp.stopRowEditing(cancel);
	        }
	        else {
	            this.stopEditing(cancel);
	        }
	    };
	    CellComp.prototype.stopEditing = function (cancel) {
	        if (cancel === void 0) { cancel = false; }
	        if (!this.editingCell) {
	            return;
	        }
	        // if no cell editor, this means due to async, that the cell editor never got initialised,
	        // so we just carry on regardless as if the editing was never started.
	        if (!this.cellEditor) {
	            this.editingCell = false;
	            return;
	        }
	        var newValueExists = false;
	        var newValue;
	        if (!cancel) {
	            // also have another option here to cancel after editing, so for example user could have a popup editor and
	            // it is closed by user clicking outside the editor. then the editor will close automatically (with false
	            // passed above) and we need to see if the editor wants to accept the new value.
	            var userWantsToCancel = this.cellEditor.isCancelAfterEnd && this.cellEditor.isCancelAfterEnd();
	            if (!userWantsToCancel) {
	                newValue = this.cellEditor.getValue();
	                newValueExists = true;
	            }
	        }
	        // it is important we set this after setValue() above, as otherwise the cell will flash
	        // when editing stops. the 'refresh' method checks editing, and doesn't refresh editing cells.
	        // thus it will skip the refresh on this cell until the end of this method where we call
	        // refresh directly and we suppress the flash.
	        this.editingCell = false;
	        if (this.cellEditor.destroy) {
	            this.cellEditor.destroy();
	        }
	        // important to clear this out - as parts of the code will check for
	        // this to see if an async cellEditor has yet to be created
	        this.cellEditor = null;
	        if (this.cellEditorInPopup && this.hideEditorPopup) {
	            this.hideEditorPopup();
	            this.hideEditorPopup = null;
	        }
	        else {
	            utils_1._.clearElement(this.getGui());
	            // put the cell back the way it was before editing
	            if (this.usingWrapper) {
	                // if wrapper, then put the wrapper back
	                this.getGui().appendChild(this.eCellWrapper);
	            }
	            else {
	                // if cellRenderer, then put the gui back in. if the renderer has
	                // a refresh, it will be called. however if it doesn't, then later
	                // the renderer will be destroyed and a new one will be created.
	                if (this.cellRenderer) {
	                    // we know it's a dom element (not a string) because we converted
	                    // it after the gui was attached if it was a string.
	                    var eCell = this.cellRendererGui;
	                    // can be null if cell was previously null / contained empty string,
	                    // this will result in new value not being rendered.
	                    if (eCell) {
	                        this.getGui().appendChild(eCell);
	                    }
	                }
	            }
	        }
	        this.setInlineEditingClass();
	        if (newValueExists) {
	            // we suppressRefreshCell because the call to rowNode.setDataValue() results in change detection
	            // getting triggered, which results in all cells getting refreshed. we do not want this refresh
	            // to happen on this call as we want to call it explicitly below. otherwise refresh gets called twice.
	            // if we only did this refresh (and not the one below) then the cell would flash and not be forced.
	            this.suppressRefreshCell = true;
	            this.rowNode.setDataValue(this.column, newValue);
	            this.suppressRefreshCell = false;
	        }
	        // we suppress the flash, as it is not correct to flash the cell the user has finished editing,
	        // the user doesn't need to flash as they were the one who did the edit, the flash is pointless
	        // (as the flash is meant to draw the user to a change that they didn't manually do themselves).
	        this.refreshCell({ forceRefresh: true, suppressFlash: true });
	        var event = this.createEvent(null, events_1.Events.EVENT_CELL_EDITING_STOPPED);
	        this.beans.eventService.dispatchEvent(event);
	    };
	    CellComp.DOM_DATA_KEY_CELL_COMP = 'cellComp';
	    CellComp.CELL_RENDERER_TYPE_NORMAL = 'cellRenderer';
	    CellComp.CELL_RENDERER_TYPE_PINNED = 'pinnedRowCellRenderer';
	    return CellComp;
	}(component_1.Component));
	exports.CellComp = CellComp;


/***/ }),
/* 2353 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var context_1 = __webpack_require__(2333);
	var beanStub_1 = __webpack_require__(2354);
	var utils_1 = __webpack_require__(2325);
	var compIdSequence = new utils_1.NumberSequence();
	var Component = /** @class */ (function (_super) {
	    __extends(Component, _super);
	    function Component(template) {
	        var _this = _super.call(this) || this;
	        _this.childComponents = [];
	        _this.annotatedEventListeners = [];
	        // if false, then CSS class "ag-hidden" is applied, which sets "display: none"
	        _this.displayed = true;
	        // if false, then CSS class "ag-invisible" is applied, which sets "visibility: hidden"
	        _this.visible = true;
	        // unique id for this row component. this is used for getting a reference to the HTML dom.
	        // we cannot use the RowNode id as this is not unique (due to animation, old rows can be lying
	        // around as we create a new rowComp instance for the same row node).
	        _this.compId = compIdSequence.next();
	        if (template) {
	            _this.setTemplate(template);
	        }
	        return _this;
	    }
	    Component.prototype.getCompId = function () {
	        return this.compId;
	    };
	    // for registered components only, eg creates AgCheckbox instance from ag-checkbox HTML tag
	    Component.prototype.createChildComponentsFromTags = function (parentNode) {
	        var _this = this;
	        // we MUST take a copy of the list first, as the 'swapComponentForNode' adds comments into the DOM
	        // which messes up the traversal order of the children.
	        var childNodeList = utils_1._.copyNodeList(parentNode.childNodes);
	        childNodeList.forEach(function (childNode) {
	            var childComp = _this.getContext().createComponentFromElement(childNode, function (childComp) {
	                // copy over all attributes, including css classes, so any attributes user put on the tag
	                // wll be carried across
	                _this.copyAttributesFromNode(childNode, childComp.getGui());
	            });
	            if (childComp) {
	                if (childComp.addItems && childNode.children.length) {
	                    _this.createChildComponentsFromTags(childNode);
	                    // converting from HTMLCollection to Array
	                    var items = Array.prototype.slice.call(childNode.children);
	                    childComp.addItems(items);
	                }
	                // replace the tag (eg ag-checkbox) with the proper HTMLElement (eg 'div') in the dom
	                _this.swapComponentForNode(childComp, parentNode, childNode);
	            }
	            else if (childNode.childNodes) {
	                _this.createChildComponentsFromTags(childNode);
	            }
	        });
	    };
	    Component.prototype.copyAttributesFromNode = function (source, dest) {
	        utils_1._.iterateNamedNodeMap(source.attributes, function (name, value) {
	            dest.setAttribute(name, value);
	        });
	    };
	    Component.prototype.swapComponentForNode = function (newComponent, parentNode, childNode) {
	        var eComponent = newComponent.getGui();
	        parentNode.replaceChild(eComponent, childNode);
	        parentNode.insertBefore(document.createComment(childNode.nodeName), eComponent);
	        this.childComponents.push(newComponent);
	        this.swapInComponentForQuerySelectors(newComponent, childNode);
	    };
	    Component.prototype.swapInComponentForQuerySelectors = function (newComponent, childNode) {
	        var thisProto = Object.getPrototypeOf(this);
	        var thisNoType = this;
	        while (thisProto != null) {
	            var metaData = thisProto.__agComponentMetaData;
	            var currentProtoName = (thisProto.constructor).name;
	            if (metaData && metaData[currentProtoName] && metaData[currentProtoName].querySelectors) {
	                metaData[currentProtoName].querySelectors.forEach(function (querySelector) {
	                    if (thisNoType[querySelector.attributeName] === childNode) {
	                        thisNoType[querySelector.attributeName] = newComponent;
	                    }
	                });
	            }
	            thisProto = Object.getPrototypeOf(thisProto);
	        }
	    };
	    Component.prototype.setTemplate = function (template) {
	        var eGui = utils_1._.loadTemplate(template);
	        this.setTemplateFromElement(eGui);
	    };
	    Component.prototype.setTemplateFromElement = function (element) {
	        this.eGui = element;
	        this.eGui.__agComponent = this;
	        this.addAnnotatedEventListeners();
	        this.wireQuerySelectors();
	        // context will not be available when user sets template in constructor
	        var contextIsAvailable = !!this.getContext();
	        if (contextIsAvailable) {
	            this.createChildComponentsFromTags(this.getGui());
	        }
	    };
	    Component.prototype.createChildComponentsPreConstruct = function () {
	        // ui exists if user sets template in constructor. when this happens, we have to wait for the context
	        // to be autoWired first before we can create child components.
	        var uiExists = !!this.getGui();
	        if (uiExists) {
	            this.createChildComponentsFromTags(this.getGui());
	        }
	    };
	    Component.prototype.wireQuerySelectors = function () {
	        var _this = this;
	        if (!this.eGui) {
	            return;
	        }
	        var thisProto = Object.getPrototypeOf(this);
	        var _loop_1 = function () {
	            var metaData = thisProto.__agComponentMetaData;
	            var currentProtoName = (thisProto.constructor).name;
	            if (metaData && metaData[currentProtoName] && metaData[currentProtoName].querySelectors) {
	                var thisNoType_1 = this_1;
	                metaData[currentProtoName].querySelectors.forEach(function (querySelector) {
	                    var resultOfQuery = _this.eGui.querySelector(querySelector.querySelector);
	                    if (resultOfQuery) {
	                        var backingComponent = resultOfQuery.__agComponent;
	                        if (backingComponent) {
	                            thisNoType_1[querySelector.attributeName] = backingComponent;
	                        }
	                        else {
	                            thisNoType_1[querySelector.attributeName] = resultOfQuery;
	                        }
	                    }
	                    else {
	                        // put debug msg in here if query selector fails???
	                    }
	                });
	            }
	            thisProto = Object.getPrototypeOf(thisProto);
	        };
	        var this_1 = this;
	        while (thisProto != null) {
	            _loop_1();
	        }
	    };
	    Component.prototype.addAnnotatedEventListeners = function () {
	        var _this = this;
	        this.removeAnnotatedEventListeners();
	        if (!this.eGui) {
	            return;
	        }
	        var listenerMethods = this.getAgComponentMetaData('listenerMethods');
	        if (utils_1._.missingOrEmpty(listenerMethods)) {
	            return;
	        }
	        if (!this.annotatedEventListeners) {
	            this.annotatedEventListeners = [];
	        }
	        listenerMethods.forEach(function (eventListener) {
	            var listener = _this[eventListener.methodName].bind(_this);
	            _this.eGui.addEventListener(eventListener.eventName, listener);
	            _this.annotatedEventListeners.push({ eventName: eventListener.eventName, listener: listener });
	        });
	    };
	    Component.prototype.getAgComponentMetaData = function (key) {
	        var res = [];
	        var thisProto = Object.getPrototypeOf(this);
	        while (thisProto != null) {
	            var metaData = thisProto.__agComponentMetaData;
	            var currentProtoName = (thisProto.constructor).name;
	            // IE does not support Function.prototype.name, so we need to extract
	            // the name using a RegEx
	            // from: https://matt.scharley.me/2012/03/monkey-patch-name-ie.html
	            if (currentProtoName === undefined) {
	                var funcNameRegex = /function\s([^(]{1,})\(/;
	                var results = funcNameRegex.exec(thisProto.constructor.toString());
	                if (results && results.length > 1) {
	                    currentProtoName = results[1].trim();
	                }
	            }
	            if (metaData && metaData[currentProtoName] && metaData[currentProtoName][key]) {
	                res = res.concat(metaData[currentProtoName][key]);
	            }
	            thisProto = Object.getPrototypeOf(thisProto);
	        }
	        return res;
	    };
	    Component.prototype.removeAnnotatedEventListeners = function () {
	        var _this = this;
	        if (!this.annotatedEventListeners || !this.eGui) {
	            return;
	        }
	        this.annotatedEventListeners.forEach(function (eventListener) {
	            _this.eGui.removeEventListener(eventListener.eventName, eventListener.listener);
	        });
	        this.annotatedEventListeners = [];
	    };
	    Component.prototype.getGui = function () {
	        return this.eGui;
	    };
	    Component.prototype.setParentComponent = function (component) {
	        this.parentComponent = component;
	    };
	    Component.prototype.getParentComponent = function () {
	        return this.parentComponent;
	    };
	    // this method is for older code, that wants to provide the gui element,
	    // it is not intended for this to be in ag-Stack
	    Component.prototype.setGui = function (eGui) {
	        this.eGui = eGui;
	    };
	    Component.prototype.queryForHtmlElement = function (cssSelector) {
	        return this.eGui.querySelector(cssSelector);
	    };
	    Component.prototype.queryForHtmlInputElement = function (cssSelector) {
	        return this.eGui.querySelector(cssSelector);
	    };
	    Component.prototype.appendChild = function (newChild) {
	        if (utils_1._.isNodeOrElement(newChild)) {
	            this.eGui.appendChild(newChild);
	        }
	        else {
	            var childComponent = newChild;
	            this.eGui.appendChild(childComponent.getGui());
	            this.childComponents.push(childComponent);
	        }
	    };
	    Component.prototype.addFeature = function (context, feature) {
	        context.wireBean(feature);
	        if (feature.destroy) {
	            this.addDestroyFunc(feature.destroy.bind(feature));
	        }
	    };
	    Component.prototype.isDisplayed = function () {
	        return this.displayed;
	    };
	    Component.prototype.setVisible = function (visible) {
	        if (visible !== this.visible) {
	            this.visible = visible;
	            utils_1._.setVisible(this.eGui, visible);
	        }
	    };
	    Component.prototype.setDisplayed = function (displayed) {
	        if (displayed !== this.displayed) {
	            this.displayed = displayed;
	            utils_1._.setDisplayed(this.eGui, displayed);
	            var event_1 = {
	                type: Component.EVENT_DISPLAYED_CHANGED,
	                visible: this.displayed
	            };
	            this.dispatchEvent(event_1);
	        }
	    };
	    /*    public setVisible(visible: boolean, visibilityMode?: 'display' | 'visibility'): void {
	            const isDisplay = visibilityMode !== 'visibility';
	            if (visible !== this.visible) {
	                this.visible = visible;
	    
	                // ag-hidden: display: none     -> setDisplayed();
	                // ag-invisible: visibility: hidden     => setVisible();
	    
	                _.addOrRemoveCssClass(this.eGui, isDisplay ? 'ag-hidden' : 'ag-invisible', !visible);
	                const event: VisibleChangedEvent = {
	                    type: Component.EVENT_VISIBLE_CHANGED,
	                    visible: this.visible
	                };
	                this.dispatchEvent(event);
	            }
	        }*/
	    Component.prototype.addOrRemoveCssClass = function (className, addOrRemove) {
	        utils_1._.addOrRemoveCssClass(this.eGui, className, addOrRemove);
	    };
	    Component.prototype.destroy = function () {
	        _super.prototype.destroy.call(this);
	        this.childComponents.forEach(function (childComponent) {
	            if (childComponent && childComponent.destroy) {
	                childComponent.destroy();
	            }
	        });
	        this.childComponents.length = 0;
	        this.removeAnnotatedEventListeners();
	    };
	    Component.prototype.addGuiEventListener = function (event, listener) {
	        var _this = this;
	        this.getGui().addEventListener(event, listener);
	        this.addDestroyFunc(function () { return _this.getGui().removeEventListener(event, listener); });
	    };
	    Component.prototype.addCssClass = function (className) {
	        utils_1._.addCssClass(this.getGui(), className);
	    };
	    Component.prototype.removeCssClass = function (className) {
	        utils_1._.removeCssClass(this.getGui(), className);
	    };
	    Component.prototype.getAttribute = function (key) {
	        var eGui = this.getGui();
	        return eGui ? eGui.getAttribute(key) : null;
	    };
	    Component.prototype.getRefElement = function (refName) {
	        return this.queryForHtmlElement('[ref="' + refName + '"]');
	    };
	    Component.EVENT_DISPLAYED_CHANGED = 'displayedChanged';
	    __decorate([
	        context_1.PreConstruct,
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", []),
	        __metadata("design:returntype", void 0)
	    ], Component.prototype, "createChildComponentsPreConstruct", null);
	    return Component;
	}(beanStub_1.BeanStub));
	exports.Component = Component;


/***/ }),
/* 2354 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var eventService_1 = __webpack_require__(2331);
	var gridOptionsWrapper_1 = __webpack_require__(2324);
	var context_1 = __webpack_require__(2333);
	var utils_1 = __webpack_require__(2325);
	var BeanStub = /** @class */ (function () {
	    function BeanStub() {
	        this.destroyFunctions = [];
	        this.destroyed = false;
	    }
	    // this was a test constructor niall built, when active, it prints after 5 seconds all beans/components that are
	    // not destroyed. to use, create a new grid, then api.destroy() before 5 seconds. then anything that gets printed
	    // points to a bean or component that was not properly disposed of.
	    // constructor() {
	    //     setTimeout(()=> {
	    //         if (this.isAlive()) {
	    //             let prototype: any = Object.getPrototypeOf(this);
	    //             const constructor: any = prototype.constructor;
	    //             const constructorString = constructor.toString();
	    //             const beanName = constructorString.substring(9, constructorString.indexOf("("));
	    //             console.log('is alive ' + beanName);
	    //         }
	    //     }, 5000);
	    // }
	    // CellComp and GridComp and override this because they get the FrameworkOverrides from the Beans bean
	    BeanStub.prototype.getFrameworkOverrides = function () {
	        return this.frameworkOverrides;
	    };
	    BeanStub.prototype.getContext = function () {
	        return this.context;
	    };
	    BeanStub.prototype.destroy = function () {
	        // let prototype: any = Object.getPrototypeOf(this);
	        // const constructor: any = prototype.constructor;
	        // const constructorString = constructor.toString();
	        // const beanName = constructorString.substring(9, constructorString.indexOf("("));
	        this.destroyFunctions.forEach(function (func) { return func(); });
	        this.destroyFunctions.length = 0;
	        this.destroyed = true;
	        this.dispatchEvent({ type: BeanStub.EVENT_DESTROYED });
	    };
	    BeanStub.prototype.addEventListener = function (eventType, listener) {
	        if (!this.localEventService) {
	            this.localEventService = new eventService_1.EventService();
	        }
	        this.localEventService.addEventListener(eventType, listener);
	    };
	    BeanStub.prototype.removeEventListener = function (eventType, listener) {
	        if (this.localEventService) {
	            this.localEventService.removeEventListener(eventType, listener);
	        }
	    };
	    BeanStub.prototype.dispatchEventAsync = function (event) {
	        var _this = this;
	        window.setTimeout(function () { return _this.dispatchEvent(event); }, 0);
	    };
	    BeanStub.prototype.dispatchEvent = function (event) {
	        if (this.localEventService) {
	            this.localEventService.dispatchEvent(event);
	        }
	    };
	    BeanStub.prototype.addDestroyableEventListener = function (eElement, event, listener) {
	        var _this = this;
	        if (this.destroyed) {
	            return;
	        }
	        if (eElement instanceof HTMLElement) {
	            utils_1._.addSafePassiveEventListener(this.getFrameworkOverrides(), eElement, event, listener);
	        }
	        else if (eElement instanceof Window) {
	            eElement.addEventListener(event, listener);
	        }
	        else if (eElement instanceof gridOptionsWrapper_1.GridOptionsWrapper) {
	            eElement.addEventListener(event, listener);
	        }
	        else {
	            eElement.addEventListener(event, listener);
	        }
	        var destroyFunc = function () {
	            if (eElement instanceof HTMLElement) {
	                eElement.removeEventListener(event, listener);
	            }
	            else if (eElement instanceof Window) {
	                eElement.removeEventListener(event, listener);
	            }
	            else if (eElement instanceof gridOptionsWrapper_1.GridOptionsWrapper) {
	                eElement.removeEventListener(event, listener);
	            }
	            else {
	                eElement.removeEventListener(event, listener);
	            }
	            _this.destroyFunctions = _this.destroyFunctions.filter(function (fn) { return fn !== destroyFunc; });
	        };
	        this.destroyFunctions.push(destroyFunc);
	        return destroyFunc;
	    };
	    BeanStub.prototype.isAlive = function () {
	        return !this.destroyed;
	    };
	    BeanStub.prototype.addDestroyFunc = function (func) {
	        // if we are already destroyed, we execute the func now
	        if (this.isAlive()) {
	            this.destroyFunctions.push(func);
	        }
	        else {
	            func();
	        }
	    };
	    BeanStub.EVENT_DESTROYED = 'destroyed';
	    __decorate([
	        context_1.Autowired('context'),
	        __metadata("design:type", context_1.Context)
	    ], BeanStub.prototype, "context", void 0);
	    __decorate([
	        context_1.Autowired('frameworkOverrides'),
	        __metadata("design:type", Object)
	    ], BeanStub.prototype, "frameworkOverrides", void 0);
	    __decorate([
	        context_1.PreDestroy,
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", []),
	        __metadata("design:returntype", void 0)
	    ], BeanStub.prototype, "destroy", null);
	    return BeanStub;
	}());
	exports.BeanStub = BeanStub;


/***/ }),
/* 2355 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var component_1 = __webpack_require__(2353);
	var rowNode_1 = __webpack_require__(2356);
	var context_1 = __webpack_require__(2333);
	var gridOptionsWrapper_1 = __webpack_require__(2324);
	var events_1 = __webpack_require__(2335);
	var eventService_1 = __webpack_require__(2331);
	var gridApi_1 = __webpack_require__(2338);
	var columnApi_1 = __webpack_require__(2346);
	var utils_1 = __webpack_require__(2325);
	var CheckboxSelectionComponent = /** @class */ (function (_super) {
	    __extends(CheckboxSelectionComponent, _super);
	    function CheckboxSelectionComponent() {
	        return _super.call(this, "<span class=\"ag-selection-checkbox\" unselectable=\"on\"/>") || this;
	    }
	    CheckboxSelectionComponent.prototype.createAndAddIcons = function () {
	        this.eCheckedIcon = utils_1._.createIconNoSpan('checkboxChecked', this.gridOptionsWrapper, this.column);
	        this.eUncheckedIcon = utils_1._.createIconNoSpan('checkboxUnchecked', this.gridOptionsWrapper, this.column);
	        this.eIndeterminateIcon = utils_1._.createIconNoSpan('checkboxIndeterminate', this.gridOptionsWrapper, this.column);
	        var element = this.getGui();
	        element.appendChild(this.eCheckedIcon);
	        element.appendChild(this.eUncheckedIcon);
	        element.appendChild(this.eIndeterminateIcon);
	    };
	    CheckboxSelectionComponent.prototype.onDataChanged = function () {
	        // when rows are loaded for the second time, this can impact the selection, as a row
	        // could be loaded as already selected (if user scrolls down, and then up again).
	        this.onSelectionChanged();
	    };
	    CheckboxSelectionComponent.prototype.onSelectableChanged = function () {
	        this.showOrHideSelect();
	    };
	    CheckboxSelectionComponent.prototype.onSelectionChanged = function () {
	        var state = this.rowNode.isSelected();
	        utils_1._.setDisplayed(this.eCheckedIcon, state === true);
	        utils_1._.setDisplayed(this.eUncheckedIcon, state === false);
	        utils_1._.setDisplayed(this.eIndeterminateIcon, typeof state !== 'boolean');
	    };
	    CheckboxSelectionComponent.prototype.onCheckedClicked = function () {
	        var groupSelectsFiltered = this.gridOptionsWrapper.isGroupSelectsFiltered();
	        var updatedCount = this.rowNode.setSelectedParams({ newValue: false, groupSelectsFiltered: groupSelectsFiltered });
	        return updatedCount;
	    };
	    CheckboxSelectionComponent.prototype.onUncheckedClicked = function (event) {
	        var groupSelectsFiltered = this.gridOptionsWrapper.isGroupSelectsFiltered();
	        var updatedCount = this.rowNode.setSelectedParams({ newValue: true, rangeSelect: event.shiftKey, groupSelectsFiltered: groupSelectsFiltered });
	        return updatedCount;
	    };
	    CheckboxSelectionComponent.prototype.onIndeterminateClicked = function (event) {
	        var result = this.onUncheckedClicked(event);
	        if (result === 0) {
	            this.onCheckedClicked();
	        }
	    };
	    CheckboxSelectionComponent.prototype.init = function (params) {
	        this.rowNode = params.rowNode;
	        this.column = params.column;
	        this.createAndAddIcons();
	        this.onSelectionChanged();
	        // we don't want the row clicked event to fire when selecting the checkbox, otherwise the row
	        // would possibly get selected twice
	        this.addGuiEventListener('click', function (event) { return utils_1._.stopPropagationForAgGrid(event); });
	        // likewise we don't want double click on this icon to open a group
	        this.addGuiEventListener('dblclick', function (event) { return utils_1._.stopPropagationForAgGrid(event); });
	        this.addDestroyableEventListener(this.eCheckedIcon, 'click', this.onCheckedClicked.bind(this));
	        this.addDestroyableEventListener(this.eUncheckedIcon, 'click', this.onUncheckedClicked.bind(this));
	        this.addDestroyableEventListener(this.eIndeterminateIcon, 'click', this.onIndeterminateClicked.bind(this));
	        this.addDestroyableEventListener(this.rowNode, rowNode_1.RowNode.EVENT_ROW_SELECTED, this.onSelectionChanged.bind(this));
	        this.addDestroyableEventListener(this.rowNode, rowNode_1.RowNode.EVENT_DATA_CHANGED, this.onDataChanged.bind(this));
	        this.addDestroyableEventListener(this.rowNode, rowNode_1.RowNode.EVENT_SELECTABLE_CHANGED, this.onSelectableChanged.bind(this));
	        this.isRowSelectableFunc = this.gridOptionsWrapper.getIsRowSelectableFunc();
	        var checkboxVisibleIsDynamic = this.isRowSelectableFunc || this.checkboxCallbackExists();
	        if (checkboxVisibleIsDynamic) {
	            this.addDestroyableEventListener(this.eventService, events_1.Events.EVENT_DISPLAYED_COLUMNS_CHANGED, this.showOrHideSelect.bind(this));
	            this.showOrHideSelect();
	        }
	    };
	    CheckboxSelectionComponent.prototype.showOrHideSelect = function () {
	        // if the isRowSelectable() is not provided the row node is selectable by default
	        var selectable = this.rowNode.selectable;
	        // checkboxSelection callback is deemed a legacy solution however we will still consider it's result.
	        // If selectable, then also check the colDef callback. if not selectable, this it short circuits - no need
	        // to call the colDef callback.
	        if (selectable && this.checkboxCallbackExists()) {
	            selectable = this.column.isCellCheckboxSelection(this.rowNode);
	        }
	        // show checkbox if both conditions are true
	        this.setDisplayed(selectable);
	    };
	    CheckboxSelectionComponent.prototype.checkboxCallbackExists = function () {
	        // column will be missing if groupUseEntireRow=true
	        var colDef = this.column ? this.column.getColDef() : null;
	        return colDef && typeof colDef.checkboxSelection === 'function';
	    };
	    __decorate([
	        context_1.Autowired('gridOptionsWrapper'),
	        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
	    ], CheckboxSelectionComponent.prototype, "gridOptionsWrapper", void 0);
	    __decorate([
	        context_1.Autowired('eventService'),
	        __metadata("design:type", eventService_1.EventService)
	    ], CheckboxSelectionComponent.prototype, "eventService", void 0);
	    __decorate([
	        context_1.Autowired('gridApi'),
	        __metadata("design:type", gridApi_1.GridApi)
	    ], CheckboxSelectionComponent.prototype, "gridApi", void 0);
	    __decorate([
	        context_1.Autowired('columnApi'),
	        __metadata("design:type", columnApi_1.ColumnApi)
	    ], CheckboxSelectionComponent.prototype, "columnApi", void 0);
	    return CheckboxSelectionComponent;
	}(component_1.Component));
	exports.CheckboxSelectionComponent = CheckboxSelectionComponent;


/***/ }),
/* 2356 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var eventService_1 = __webpack_require__(2331);
	var events_1 = __webpack_require__(2335);
	var gridOptionsWrapper_1 = __webpack_require__(2324);
	var selectionController_1 = __webpack_require__(2357);
	var valueService_1 = __webpack_require__(2359);
	var columnController_1 = __webpack_require__(2341);
	var columnApi_1 = __webpack_require__(2346);
	var context_1 = __webpack_require__(2333);
	var constants_1 = __webpack_require__(2328);
	var valueCache_1 = __webpack_require__(2360);
	var gridApi_1 = __webpack_require__(2338);
	var utils_1 = __webpack_require__(2325);
	var RowNode = /** @class */ (function () {
	    function RowNode() {
	        /** Children mapped by the pivot columns */
	        this.childrenMapped = {};
	        /** True by default - can be overridden via gridOptions.isRowSelectable(rowNode) */
	        this.selectable = true;
	        /** Used by sorting service - to give deterministic sort to groups. Previously we
	         * just id for this, however id is a string and had slower sorting compared to numbers. */
	        this.__objectId = RowNode.OBJECT_ID_SEQUENCE++;
	        /** True when nodes with the same id are being removed and added as part of the same batch transaction */
	        this.alreadyRendered = false;
	        this.selected = false;
	    }
	    RowNode.prototype.setData = function (data) {
	        var oldData = this.data;
	        this.data = data;
	        this.valueCache.onDataChanged();
	        this.updateDataOnDetailNode();
	        this.checkRowSelectable();
	        var event = this.createDataChangedEvent(data, oldData, false);
	        this.dispatchLocalEvent(event);
	    };
	    // when we are doing master / detail, the detail node is lazy created, but then kept around.
	    // so if we show / hide the detail, the same detail rowNode is used. so we need to keep the data
	    // in sync, otherwise expand/collapse of the detail would still show the old values.
	    RowNode.prototype.updateDataOnDetailNode = function () {
	        if (this.detailNode) {
	            this.detailNode.data = this.data;
	        }
	    };
	    RowNode.prototype.createDataChangedEvent = function (newData, oldData, update) {
	        return {
	            type: RowNode.EVENT_DATA_CHANGED,
	            node: this,
	            oldData: oldData,
	            newData: newData,
	            update: update
	        };
	    };
	    RowNode.prototype.createLocalRowEvent = function (type) {
	        return {
	            type: type,
	            node: this
	        };
	    };
	    // similar to setRowData, however it is expected that the data is the same data item. this
	    // is intended to be used with Redux type stores, where the whole data can be changed. we are
	    // guaranteed that the data is the same entity (so grid doesn't need to worry about the id of the
	    // underlying data changing, hence doesn't need to worry about selection). the grid, upon receiving
	    // dataChanged event, will refresh the cells rather than rip them all out (so user can show transitions).
	    RowNode.prototype.updateData = function (data) {
	        var oldData = this.data;
	        this.data = data;
	        this.updateDataOnDetailNode();
	        this.checkRowSelectable();
	        this.updateDataOnDetailNode();
	        var event = this.createDataChangedEvent(data, oldData, true);
	        this.dispatchLocalEvent(event);
	    };
	    RowNode.prototype.getRowIndexString = function () {
	        if (this.rowPinned === constants_1.Constants.PINNED_TOP) {
	            return 't-' + this.rowIndex;
	        }
	        else if (this.rowPinned === constants_1.Constants.PINNED_BOTTOM) {
	            return 'b-' + this.rowIndex;
	        }
	        else {
	            return this.rowIndex.toString();
	        }
	    };
	    RowNode.prototype.createDaemonNode = function () {
	        var oldNode = new RowNode();
	        this.context.wireBean(oldNode);
	        // just copy the id and data, this is enough for the node to be used
	        // in the selection controller (the selection controller is the only
	        // place where daemon nodes can live).
	        oldNode.id = this.id;
	        oldNode.data = this.data;
	        oldNode.daemon = true;
	        oldNode.selected = this.selected;
	        oldNode.level = this.level;
	        return oldNode;
	    };
	    RowNode.prototype.setDataAndId = function (data, id) {
	        var oldNode = utils_1._.exists(this.id) ? this.createDaemonNode() : null;
	        var oldData = this.data;
	        this.data = data;
	        this.updateDataOnDetailNode();
	        this.setId(id);
	        this.selectionController.syncInRowNode(this, oldNode);
	        this.checkRowSelectable();
	        var event = this.createDataChangedEvent(data, oldData, false);
	        this.dispatchLocalEvent(event);
	    };
	    RowNode.prototype.checkRowSelectable = function () {
	        var isRowSelectableFunc = this.gridOptionsWrapper.getIsRowSelectableFunc();
	        var shouldInvokeIsRowSelectable = isRowSelectableFunc && utils_1._.exists(this);
	        this.setRowSelectable(shouldInvokeIsRowSelectable ? isRowSelectableFunc(this) : true);
	    };
	    RowNode.prototype.setRowSelectable = function (newVal) {
	        if (this.selectable !== newVal) {
	            this.selectable = newVal;
	            if (this.eventService) {
	                this.eventService.dispatchEvent(this.createLocalRowEvent(RowNode.EVENT_SELECTABLE_CHANGED));
	            }
	        }
	    };
	    RowNode.prototype.setId = function (id) {
	        // see if user is providing the id's
	        var getRowNodeId = this.gridOptionsWrapper.getRowNodeIdFunc();
	        if (getRowNodeId) {
	            // if user is providing the id's, then we set the id only after the data has been set.
	            // this is important for virtual pagination and viewport, where empty rows exist.
	            if (this.data) {
	                this.id = getRowNodeId(this.data);
	            }
	            else {
	                // this can happen if user has set blank into the rowNode after the row previously
	                // having data. this happens in virtual page row model, when data is delete and
	                // the page is refreshed.
	                this.id = undefined;
	            }
	        }
	        else {
	            this.id = id;
	        }
	    };
	    RowNode.prototype.isPixelInRange = function (pixel) {
	        return pixel >= this.rowTop && pixel < (this.rowTop + this.rowHeight);
	    };
	    RowNode.prototype.clearRowTop = function () {
	        this.oldRowTop = this.rowTop;
	        this.setRowTop(null);
	    };
	    RowNode.prototype.setFirstChild = function (firstChild) {
	        if (this.firstChild === firstChild) {
	            return;
	        }
	        this.firstChild = firstChild;
	        if (this.eventService) {
	            this.eventService.dispatchEvent(this.createLocalRowEvent(RowNode.EVENT_FIRST_CHILD_CHANGED));
	        }
	    };
	    RowNode.prototype.setLastChild = function (lastChild) {
	        if (this.lastChild === lastChild) {
	            return;
	        }
	        this.lastChild = lastChild;
	        if (this.eventService) {
	            this.eventService.dispatchEvent(this.createLocalRowEvent(RowNode.EVENT_LAST_CHILD_CHANGED));
	        }
	    };
	    RowNode.prototype.setChildIndex = function (childIndex) {
	        if (this.childIndex === childIndex) {
	            return;
	        }
	        this.childIndex = childIndex;
	        if (this.eventService) {
	            this.eventService.dispatchEvent(this.createLocalRowEvent(RowNode.EVENT_CHILD_INDEX_CHANGED));
	        }
	    };
	    RowNode.prototype.setRowTop = function (rowTop) {
	        if (this.rowTop === rowTop) {
	            return;
	        }
	        this.rowTop = rowTop;
	        if (this.eventService) {
	            this.eventService.dispatchEvent(this.createLocalRowEvent(RowNode.EVENT_TOP_CHANGED));
	        }
	    };
	    RowNode.prototype.setDragging = function (dragging) {
	        if (this.dragging === dragging) {
	            return;
	        }
	        this.dragging = dragging;
	        if (this.eventService) {
	            this.eventService.dispatchEvent(this.createLocalRowEvent(RowNode.EVENT_DRAGGING_CHANGED));
	        }
	    };
	    RowNode.prototype.setAllChildrenCount = function (allChildrenCount) {
	        if (this.allChildrenCount === allChildrenCount) {
	            return;
	        }
	        this.allChildrenCount = allChildrenCount;
	        if (this.eventService) {
	            this.eventService.dispatchEvent(this.createLocalRowEvent(RowNode.EVENT_ALL_CHILDREN_COUNT_CHANGED));
	        }
	    };
	    RowNode.prototype.setRowHeight = function (rowHeight, estimated) {
	        if (estimated === void 0) { estimated = false; }
	        this.rowHeight = rowHeight;
	        this.rowHeightEstimated = estimated;
	        if (this.eventService) {
	            this.eventService.dispatchEvent(this.createLocalRowEvent(RowNode.EVENT_HEIGHT_CHANGED));
	        }
	    };
	    RowNode.prototype.setRowIndex = function (rowIndex) {
	        this.rowIndex = rowIndex;
	        if (this.eventService) {
	            this.eventService.dispatchEvent(this.createLocalRowEvent(RowNode.EVENT_ROW_INDEX_CHANGED));
	        }
	    };
	    RowNode.prototype.setUiLevel = function (uiLevel) {
	        if (this.uiLevel === uiLevel) {
	            return;
	        }
	        this.uiLevel = uiLevel;
	        if (this.eventService) {
	            this.eventService.dispatchEvent(this.createLocalRowEvent(RowNode.EVENT_UI_LEVEL_CHANGED));
	        }
	    };
	    RowNode.prototype.setExpanded = function (expanded) {
	        if (this.expanded === expanded) {
	            return;
	        }
	        this.expanded = expanded;
	        if (this.eventService) {
	            this.eventService.dispatchEvent(this.createLocalRowEvent(RowNode.EVENT_EXPANDED_CHANGED));
	        }
	        var event = this.createGlobalRowEvent(events_1.Events.EVENT_ROW_GROUP_OPENED);
	        this.mainEventService.dispatchEvent(event);
	        if (this.gridOptionsWrapper.isGroupIncludeFooter()) {
	            this.gridApi.redrawRows({ rowNodes: [this] });
	        }
	    };
	    RowNode.prototype.createGlobalRowEvent = function (type) {
	        var event = {
	            type: type,
	            node: this,
	            data: this.data,
	            rowIndex: this.rowIndex,
	            rowPinned: this.rowPinned,
	            context: this.gridOptionsWrapper.getContext(),
	            api: this.gridOptionsWrapper.getApi(),
	            columnApi: this.gridOptionsWrapper.getColumnApi()
	        };
	        return event;
	    };
	    RowNode.prototype.dispatchLocalEvent = function (event) {
	        if (this.eventService) {
	            this.eventService.dispatchEvent(event);
	        }
	    };
	    // we also allow editing the value via the editors. when it is done via
	    // the editors, no 'cell changed' event gets fired, as it's assumed that
	    // the cell knows about the change given it's in charge of the editing.
	    // this method is for the client to call, so the cell listens for the change
	    // event, and also flashes the cell when the change occurs.
	    RowNode.prototype.setDataValue = function (colKey, newValue) {
	        var column = this.columnController.getPrimaryColumn(colKey);
	        this.valueService.setValue(this, column, newValue);
	        this.dispatchCellChangedEvent(column, newValue);
	    };
	    RowNode.prototype.setGroupValue = function (colKey, newValue) {
	        var column = this.columnController.getGridColumn(colKey);
	        if (utils_1._.missing(this.groupData)) {
	            this.groupData = {};
	        }
	        this.groupData[column.getColId()] = newValue;
	        this.dispatchCellChangedEvent(column, newValue);
	    };
	    // sets the data for an aggregation
	    RowNode.prototype.setAggData = function (newAggData) {
	        var _this = this;
	        // find out all keys that could potentially change
	        var colIds = utils_1._.getAllKeysInObjects([this.aggData, newAggData]);
	        this.aggData = newAggData;
	        // if no event service, nobody has registered for events, so no need fire event
	        if (this.eventService) {
	            colIds.forEach(function (colId) {
	                var column = _this.columnController.getGridColumn(colId);
	                var value = _this.aggData ? _this.aggData[colId] : undefined;
	                _this.dispatchCellChangedEvent(column, value);
	            });
	        }
	    };
	    RowNode.prototype.hasChildren = function () {
	        // we need to return true when this.group=true, as this is used by server side row model
	        // (as children are lazy loaded and stored in a cache anyway). otherwise we return true
	        // if children exist.
	        return this.group || (this.childrenAfterGroup && this.childrenAfterGroup.length > 0);
	    };
	    RowNode.prototype.isEmptyRowGroupNode = function () {
	        return this.group && utils_1._.missingOrEmpty(this.childrenAfterGroup);
	    };
	    RowNode.prototype.dispatchCellChangedEvent = function (column, newValue) {
	        var cellChangedEvent = {
	            type: RowNode.EVENT_CELL_CHANGED,
	            node: this,
	            column: column,
	            newValue: newValue
	        };
	        this.dispatchLocalEvent(cellChangedEvent);
	    };
	    RowNode.prototype.resetQuickFilterAggregateText = function () {
	        this.quickFilterAggregateText = null;
	    };
	    RowNode.prototype.isExpandable = function () {
	        return this.hasChildren() || this.master;
	    };
	    RowNode.prototype.isSelected = function () {
	        // for footers, we just return what our sibling selected state is, as cannot select a footer
	        if (this.footer) {
	            return this.sibling.isSelected();
	        }
	        return this.selected;
	    };
	    RowNode.prototype.depthFirstSearch = function (callback) {
	        if (this.childrenAfterGroup) {
	            this.childrenAfterGroup.forEach(function (child) { return child.depthFirstSearch(callback); });
	        }
	        callback(this);
	    };
	    // + rowController.updateGroupsInSelection()
	    // + selectionController.calculatedSelectedForAllGroupNodes()
	    RowNode.prototype.calculateSelectedFromChildren = function () {
	        var atLeastOneSelected = false;
	        var atLeastOneDeSelected = false;
	        var atLeastOneMixed = false;
	        var newSelectedValue;
	        if (this.childrenAfterGroup) {
	            for (var i = 0; i < this.childrenAfterGroup.length; i++) {
	                var child = this.childrenAfterGroup[i];
	                // skip non-selectable nodes to prevent inconsistent selection values
	                if (!child.selectable) {
	                    continue;
	                }
	                var childState = child.isSelected();
	                switch (childState) {
	                    case true:
	                        atLeastOneSelected = true;
	                        break;
	                    case false:
	                        atLeastOneDeSelected = true;
	                        break;
	                    default:
	                        atLeastOneMixed = true;
	                        break;
	                }
	            }
	        }
	        if (atLeastOneMixed) {
	            newSelectedValue = undefined;
	        }
	        else if (atLeastOneSelected && !atLeastOneDeSelected) {
	            newSelectedValue = true;
	        }
	        else if (!atLeastOneSelected && atLeastOneDeSelected) {
	            newSelectedValue = false;
	        }
	        else {
	            newSelectedValue = undefined;
	        }
	        this.selectThisNode(newSelectedValue);
	    };
	    RowNode.prototype.setSelectedInitialValue = function (selected) {
	        this.selected = selected;
	    };
	    RowNode.prototype.setSelected = function (newValue, clearSelection, suppressFinishActions) {
	        if (clearSelection === void 0) { clearSelection = false; }
	        if (suppressFinishActions === void 0) { suppressFinishActions = false; }
	        this.setSelectedParams({
	            newValue: newValue,
	            clearSelection: clearSelection,
	            suppressFinishActions: suppressFinishActions,
	            rangeSelect: false
	        });
	    };
	    RowNode.prototype.isRowPinned = function () {
	        return this.rowPinned === constants_1.Constants.PINNED_TOP || this.rowPinned === constants_1.Constants.PINNED_BOTTOM;
	    };
	    // to make calling code more readable, this is the same method as setSelected except it takes names parameters
	    RowNode.prototype.setSelectedParams = function (params) {
	        var groupSelectsChildren = this.gridOptionsWrapper.isGroupSelectsChildren();
	        var newValue = params.newValue === true;
	        var clearSelection = params.clearSelection === true;
	        var suppressFinishActions = params.suppressFinishActions === true;
	        var rangeSelect = params.rangeSelect === true;
	        // groupSelectsFiltered only makes sense when group selects children
	        var groupSelectsFiltered = groupSelectsChildren && (params.groupSelectsFiltered === true);
	        if (this.id === undefined) {
	            console.warn('ag-Grid: cannot select node until id for node is known');
	            return 0;
	        }
	        if (this.rowPinned) {
	            console.warn('ag-Grid: cannot select pinned rows');
	            return 0;
	        }
	        // if we are a footer, we don't do selection, just pass the info
	        // to the sibling (the parent of the group)
	        if (this.footer) {
	            var count = this.sibling.setSelectedParams(params);
	            return count;
	        }
	        if (rangeSelect) {
	            var newRowClicked = this.selectionController.getLastSelectedNode() !== this;
	            var allowMultiSelect = this.gridOptionsWrapper.isRowSelectionMulti();
	            if (newRowClicked && allowMultiSelect) {
	                return this.doRowRangeSelection();
	            }
	        }
	        var updatedCount = 0;
	        // when groupSelectsFiltered, then this node may end up intermediate despite
	        // trying to set it to true / false. this group will be calculated further on
	        // down when we call calculatedSelectedForAllGroupNodes(). we need to skip it
	        // here, otherwise the updatedCount would include it.
	        var skipThisNode = groupSelectsFiltered && this.group;
	        if (!skipThisNode) {
	            var thisNodeWasSelected = this.selectThisNode(newValue);
	            if (thisNodeWasSelected) {
	                updatedCount++;
	            }
	        }
	        if (groupSelectsChildren && this.group) {
	            updatedCount += this.selectChildNodes(newValue, groupSelectsFiltered);
	        }
	        // clear other nodes if not doing multi select
	        if (!suppressFinishActions) {
	            var clearOtherNodes = newValue && (clearSelection || !this.gridOptionsWrapper.isRowSelectionMulti());
	            if (clearOtherNodes) {
	                updatedCount += this.selectionController.clearOtherNodes(this);
	            }
	            // only if we selected something, then update groups and fire events
	            if (updatedCount > 0) {
	                this.selectionController.updateGroupsFromChildrenSelections();
	                // this is the very end of the 'action node', so we are finished all the updates,
	                // include any parent / child changes that this method caused
	                var event_1 = {
	                    type: events_1.Events.EVENT_SELECTION_CHANGED,
	                    api: this.gridApi,
	                    columnApi: this.columnApi
	                };
	                this.mainEventService.dispatchEvent(event_1);
	            }
	            // so if user next does shift-select, we know where to start the selection from
	            if (newValue) {
	                this.selectionController.setLastSelectedNode(this);
	            }
	        }
	        return updatedCount;
	    };
	    // selects all rows between this node and the last selected node (or the top if this is the first selection).
	    // not to be mixed up with 'cell range selection' where you drag the mouse, this is row range selection, by
	    // holding down 'shift'.
	    RowNode.prototype.doRowRangeSelection = function () {
	        var updatedCount = 0;
	        var groupsSelectChildren = this.gridOptionsWrapper.isGroupSelectsChildren();
	        var lastSelectedNode = this.selectionController.getLastSelectedNode();
	        var nodesToSelect = this.rowModel.getNodesInRangeForSelection(this, lastSelectedNode);
	        nodesToSelect.forEach(function (rowNode) {
	            if (rowNode.group && groupsSelectChildren) {
	                return;
	            }
	            var nodeWasSelected = rowNode.selectThisNode(true);
	            if (nodeWasSelected) {
	                updatedCount++;
	            }
	        });
	        this.selectionController.updateGroupsFromChildrenSelections();
	        var event = {
	            type: events_1.Events.EVENT_SELECTION_CHANGED,
	            api: this.gridApi,
	            columnApi: this.columnApi
	        };
	        this.mainEventService.dispatchEvent(event);
	        return updatedCount;
	    };
	    RowNode.prototype.isParentOfNode = function (potentialParent) {
	        var parentNode = this.parent;
	        while (parentNode) {
	            if (parentNode === potentialParent) {
	                return true;
	            }
	            parentNode = parentNode.parent;
	        }
	        return false;
	    };
	    RowNode.prototype.selectThisNode = function (newValue) {
	        if (!this.selectable || this.selected === newValue) {
	            return false;
	        }
	        this.selected = newValue;
	        if (this.eventService) {
	            this.dispatchLocalEvent(this.createLocalRowEvent(RowNode.EVENT_ROW_SELECTED));
	        }
	        var event = this.createGlobalRowEvent(events_1.Events.EVENT_ROW_SELECTED);
	        this.mainEventService.dispatchEvent(event);
	        return true;
	    };
	    RowNode.prototype.selectChildNodes = function (newValue, groupSelectsFiltered) {
	        var children = groupSelectsFiltered ? this.childrenAfterFilter : this.childrenAfterGroup;
	        var updatedCount = 0;
	        if (utils_1._.missing(children)) {
	            return;
	        }
	        for (var i = 0; i < children.length; i++) {
	            updatedCount += children[i].setSelectedParams({
	                newValue: newValue,
	                clearSelection: false,
	                suppressFinishActions: true,
	                groupSelectsFiltered: groupSelectsFiltered
	            });
	        }
	        return updatedCount;
	    };
	    RowNode.prototype.addEventListener = function (eventType, listener) {
	        if (!this.eventService) {
	            this.eventService = new eventService_1.EventService();
	        }
	        this.eventService.addEventListener(eventType, listener);
	    };
	    RowNode.prototype.removeEventListener = function (eventType, listener) {
	        this.eventService.removeEventListener(eventType, listener);
	    };
	    RowNode.prototype.onMouseEnter = function () {
	        this.dispatchLocalEvent(this.createLocalRowEvent(RowNode.EVENT_MOUSE_ENTER));
	    };
	    RowNode.prototype.onMouseLeave = function () {
	        this.dispatchLocalEvent(this.createLocalRowEvent(RowNode.EVENT_MOUSE_LEAVE));
	    };
	    RowNode.prototype.getFirstChildOfFirstChild = function (rowGroupColumn) {
	        var currentRowNode = this;
	        // if we are hiding groups, then if we are the first child, of the first child,
	        // all the way up to the column we are interested in, then we show the group cell.
	        var isCandidate = true;
	        var foundFirstChildPath = false;
	        var nodeToSwapIn;
	        while (isCandidate && !foundFirstChildPath) {
	            var parentRowNode = currentRowNode.parent;
	            var firstChild = utils_1._.exists(parentRowNode) && currentRowNode.firstChild;
	            if (firstChild) {
	                if (parentRowNode.rowGroupColumn === rowGroupColumn) {
	                    foundFirstChildPath = true;
	                    nodeToSwapIn = parentRowNode;
	                }
	            }
	            else {
	                isCandidate = false;
	            }
	            currentRowNode = parentRowNode;
	        }
	        return foundFirstChildPath ? nodeToSwapIn : null;
	    };
	    RowNode.OBJECT_ID_SEQUENCE = 0;
	    RowNode.EVENT_ROW_SELECTED = 'rowSelected';
	    RowNode.EVENT_DATA_CHANGED = 'dataChanged';
	    RowNode.EVENT_CELL_CHANGED = 'cellChanged';
	    RowNode.EVENT_ALL_CHILDREN_COUNT_CHANGED = 'allChildrenCountChanged';
	    RowNode.EVENT_MOUSE_ENTER = 'mouseEnter';
	    RowNode.EVENT_MOUSE_LEAVE = 'mouseLeave';
	    RowNode.EVENT_HEIGHT_CHANGED = 'heightChanged';
	    RowNode.EVENT_TOP_CHANGED = 'topChanged';
	    RowNode.EVENT_FIRST_CHILD_CHANGED = 'firstChildChanged';
	    RowNode.EVENT_LAST_CHILD_CHANGED = 'lastChildChanged';
	    RowNode.EVENT_CHILD_INDEX_CHANGED = 'childIndexChanged';
	    RowNode.EVENT_ROW_INDEX_CHANGED = 'rowIndexChanged';
	    RowNode.EVENT_EXPANDED_CHANGED = 'expandedChanged';
	    RowNode.EVENT_SELECTABLE_CHANGED = 'selectableChanged';
	    RowNode.EVENT_UI_LEVEL_CHANGED = 'uiLevelChanged';
	    RowNode.EVENT_DRAGGING_CHANGED = 'draggingChanged';
	    __decorate([
	        context_1.Autowired('eventService'),
	        __metadata("design:type", eventService_1.EventService)
	    ], RowNode.prototype, "mainEventService", void 0);
	    __decorate([
	        context_1.Autowired('gridOptionsWrapper'),
	        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
	    ], RowNode.prototype, "gridOptionsWrapper", void 0);
	    __decorate([
	        context_1.Autowired('selectionController'),
	        __metadata("design:type", selectionController_1.SelectionController)
	    ], RowNode.prototype, "selectionController", void 0);
	    __decorate([
	        context_1.Autowired('columnController'),
	        __metadata("design:type", columnController_1.ColumnController)
	    ], RowNode.prototype, "columnController", void 0);
	    __decorate([
	        context_1.Autowired('valueService'),
	        __metadata("design:type", valueService_1.ValueService)
	    ], RowNode.prototype, "valueService", void 0);
	    __decorate([
	        context_1.Autowired('rowModel'),
	        __metadata("design:type", Object)
	    ], RowNode.prototype, "rowModel", void 0);
	    __decorate([
	        context_1.Autowired('context'),
	        __metadata("design:type", context_1.Context)
	    ], RowNode.prototype, "context", void 0);
	    __decorate([
	        context_1.Autowired('valueCache'),
	        __metadata("design:type", valueCache_1.ValueCache)
	    ], RowNode.prototype, "valueCache", void 0);
	    __decorate([
	        context_1.Autowired('columnApi'),
	        __metadata("design:type", columnApi_1.ColumnApi)
	    ], RowNode.prototype, "columnApi", void 0);
	    __decorate([
	        context_1.Autowired('gridApi'),
	        __metadata("design:type", gridApi_1.GridApi)
	    ], RowNode.prototype, "gridApi", void 0);
	    return RowNode;
	}());
	exports.RowNode = RowNode;


/***/ }),
/* 2357 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var __param = (this && this.__param) || function (paramIndex, decorator) {
	    return function (target, key) { decorator(target, key, paramIndex); }
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var context_1 = __webpack_require__(2333);
	var context_2 = __webpack_require__(2333);
	var logger_1 = __webpack_require__(2332);
	var eventService_1 = __webpack_require__(2331);
	var events_1 = __webpack_require__(2335);
	var context_3 = __webpack_require__(2333);
	var gridOptionsWrapper_1 = __webpack_require__(2324);
	var context_4 = __webpack_require__(2333);
	var constants_1 = __webpack_require__(2328);
	var columnApi_1 = __webpack_require__(2346);
	var gridApi_1 = __webpack_require__(2338);
	var utils_1 = __webpack_require__(2325);
	var changedPath_1 = __webpack_require__(2358);
	var SelectionController = /** @class */ (function () {
	    function SelectionController() {
	    }
	    SelectionController.prototype.setBeans = function (loggerFactory) {
	        this.logger = loggerFactory.create('SelectionController');
	        this.reset();
	        if (this.gridOptionsWrapper.isRowModelDefault()) {
	            this.eventService.addEventListener(events_1.Events.EVENT_ROW_DATA_CHANGED, this.reset.bind(this));
	        }
	        else {
	            this.logger.log('dont know what to do here');
	        }
	    };
	    SelectionController.prototype.init = function () {
	        this.groupSelectsChildren = this.gridOptionsWrapper.isGroupSelectsChildren();
	        this.eventService.addEventListener(events_1.Events.EVENT_ROW_SELECTED, this.onRowSelected.bind(this));
	    };
	    SelectionController.prototype.setLastSelectedNode = function (rowNode) {
	        this.lastSelectedNode = rowNode;
	    };
	    SelectionController.prototype.getLastSelectedNode = function () {
	        return this.lastSelectedNode;
	    };
	    SelectionController.prototype.getSelectedNodes = function () {
	        var selectedNodes = [];
	        utils_1._.iterateObject(this.selectedNodes, function (key, rowNode) {
	            if (rowNode) {
	                selectedNodes.push(rowNode);
	            }
	        });
	        return selectedNodes;
	    };
	    SelectionController.prototype.getSelectedRows = function () {
	        var selectedRows = [];
	        utils_1._.iterateObject(this.selectedNodes, function (key, rowNode) {
	            if (rowNode && rowNode.data) {
	                selectedRows.push(rowNode.data);
	            }
	        });
	        return selectedRows;
	    };
	    SelectionController.prototype.removeGroupsFromSelection = function () {
	        var _this = this;
	        utils_1._.iterateObject(this.selectedNodes, function (key, rowNode) {
	            if (rowNode && rowNode.group) {
	                _this.selectedNodes[rowNode.id] = undefined;
	            }
	        });
	    };
	    // should only be called if groupSelectsChildren=true
	    SelectionController.prototype.updateGroupsFromChildrenSelections = function (changedPath) {
	        // we only do this when group selection state depends on selected children
	        if (!this.gridOptionsWrapper.isGroupSelectsChildren()) {
	            return;
	        }
	        // also only do it if CSRM (code should never allow this anyway)
	        if (this.rowModel.getType() !== constants_1.Constants.ROW_MODEL_TYPE_CLIENT_SIDE) {
	            return;
	        }
	        var clientSideRowModel = this.rowModel;
	        var rootNode = clientSideRowModel.getRootNode();
	        if (!changedPath) {
	            changedPath = new changedPath_1.ChangedPath(true, rootNode);
	            changedPath.setInactive();
	        }
	        changedPath.forEachChangedNodeDepthFirst(function (rowNode) {
	            if (rowNode !== rootNode) {
	                rowNode.calculateSelectedFromChildren();
	            }
	        });
	        // clientSideRowModel.getTopLevelNodes()!.forEach((rowNode: RowNode) => {
	        //     rowNode.depthFirstSearch((node) => {
	        //         if (node.group) {
	        //         }
	        //     });
	        // });
	    };
	    SelectionController.prototype.getNodeForIdIfSelected = function (id) {
	        return this.selectedNodes[id];
	    };
	    SelectionController.prototype.clearOtherNodes = function (rowNodeToKeepSelected) {
	        var _this = this;
	        var groupsToRefresh = {};
	        var updatedCount = 0;
	        utils_1._.iterateObject(this.selectedNodes, function (key, otherRowNode) {
	            if (otherRowNode && otherRowNode.id !== rowNodeToKeepSelected.id) {
	                var rowNode = _this.selectedNodes[otherRowNode.id];
	                updatedCount += rowNode.setSelectedParams({
	                    newValue: false,
	                    clearSelection: false,
	                    suppressFinishActions: true
	                });
	                if (_this.groupSelectsChildren && otherRowNode.parent) {
	                    groupsToRefresh[otherRowNode.parent.id] = otherRowNode.parent;
	                }
	            }
	        });
	        utils_1._.iterateObject(groupsToRefresh, function (key, group) {
	            group.calculateSelectedFromChildren();
	        });
	        return updatedCount;
	    };
	    SelectionController.prototype.onRowSelected = function (event) {
	        var rowNode = event.node;
	        // we do not store the group rows when the groups select children
	        if (this.groupSelectsChildren && rowNode.group) {
	            return;
	        }
	        if (rowNode.isSelected()) {
	            this.selectedNodes[rowNode.id] = rowNode;
	        }
	        else {
	            this.selectedNodes[rowNode.id] = undefined;
	        }
	    };
	    SelectionController.prototype.syncInRowNode = function (rowNode, oldNode) {
	        this.syncInOldRowNode(rowNode, oldNode);
	        this.syncInNewRowNode(rowNode);
	    };
	    // if the id has changed for the node, then this means the rowNode
	    // is getting used for a different data item, which breaks
	    // our selectedNodes, as the node now is mapped by the old id
	    // which is inconsistent. so to keep the old node as selected,
	    // we swap in the clone (with the old id and old data). this means
	    // the oldNode is effectively a daemon we keep a reference to,
	    // so if client calls api.getSelectedNodes(), it gets the daemon
	    // in the result. when the client un-selects, the reference to the
	    // daemon is removed. the daemon, because it's an oldNode, is not
	    // used by the grid for rendering, it's a copy of what the node used
	    // to be like before the id was changed.
	    SelectionController.prototype.syncInOldRowNode = function (rowNode, oldNode) {
	        var oldNodeHasDifferentId = utils_1._.exists(oldNode) && (rowNode.id !== oldNode.id);
	        if (oldNodeHasDifferentId) {
	            var oldNodeSelected = utils_1._.exists(this.selectedNodes[oldNode.id]);
	            if (oldNodeSelected) {
	                this.selectedNodes[oldNode.id] = oldNode;
	            }
	        }
	    };
	    SelectionController.prototype.syncInNewRowNode = function (rowNode) {
	        if (utils_1._.exists(this.selectedNodes[rowNode.id])) {
	            rowNode.setSelectedInitialValue(true);
	            this.selectedNodes[rowNode.id] = rowNode;
	        }
	        else {
	            rowNode.setSelectedInitialValue(false);
	        }
	    };
	    SelectionController.prototype.reset = function () {
	        this.logger.log('reset');
	        this.selectedNodes = {};
	        this.lastSelectedNode = null;
	    };
	    // returns a list of all nodes at 'best cost' - a feature to be used
	    // with groups / trees. if a group has all it's children selected,
	    // then the group appears in the result, but not the children.
	    // Designed for use with 'children' as the group selection type,
	    // where groups don't actually appear in the selection normally.
	    SelectionController.prototype.getBestCostNodeSelection = function () {
	        if (this.rowModel.getType() !== constants_1.Constants.ROW_MODEL_TYPE_CLIENT_SIDE) {
	            console.warn('getBestCostNodeSelection is only available when using normal row model');
	        }
	        var clientSideRowModel = this.rowModel;
	        var topLevelNodes = clientSideRowModel.getTopLevelNodes();
	        if (topLevelNodes === null) {
	            console.warn('selectAll not available doing rowModel=virtual');
	            return;
	        }
	        var result = [];
	        // recursive function, to find the selected nodes
	        function traverse(nodes) {
	            for (var i = 0, l = nodes.length; i < l; i++) {
	                var node = nodes[i];
	                if (node.isSelected()) {
	                    result.push(node);
	                }
	                else {
	                    // if not selected, then if it's a group, and the group
	                    // has children, continue to search for selections
	                    if (node.group && node.children) {
	                        traverse(node.children);
	                    }
	                }
	            }
	        }
	        traverse(topLevelNodes);
	        return result;
	    };
	    SelectionController.prototype.setRowModel = function (rowModel) {
	        this.rowModel = rowModel;
	    };
	    SelectionController.prototype.isEmpty = function () {
	        var count = 0;
	        utils_1._.iterateObject(this.selectedNodes, function (nodeId, rowNode) {
	            if (rowNode) {
	                count++;
	            }
	        });
	        return count === 0;
	    };
	    SelectionController.prototype.deselectAllRowNodes = function (justFiltered) {
	        if (justFiltered === void 0) { justFiltered = false; }
	        var callback = function (rowNode) { return rowNode.selectThisNode(false); };
	        var rowModelClientSide = this.rowModel.getType() === constants_1.Constants.ROW_MODEL_TYPE_CLIENT_SIDE;
	        if (justFiltered) {
	            if (!rowModelClientSide) {
	                console.error('ag-Grid: selecting just filtered only works with In Memory Row Model');
	                return;
	            }
	            var clientSideRowModel = this.rowModel;
	            clientSideRowModel.forEachNodeAfterFilter(callback);
	        }
	        else {
	            utils_1._.iterateObject(this.selectedNodes, function (id, rowNode) {
	                // remember the reference can be to null, as we never 'delete' from the map
	                if (rowNode) {
	                    callback(rowNode);
	                }
	            });
	            // this clears down the map (whereas above only sets the items in map to 'undefined')
	            this.reset();
	        }
	        // the above does not clean up the parent rows if they are selected
	        if (rowModelClientSide && this.groupSelectsChildren) {
	            this.updateGroupsFromChildrenSelections();
	        }
	        var event = {
	            type: events_1.Events.EVENT_SELECTION_CHANGED,
	            api: this.gridApi,
	            columnApi: this.columnApi
	        };
	        this.eventService.dispatchEvent(event);
	    };
	    SelectionController.prototype.selectAllRowNodes = function (justFiltered) {
	        if (justFiltered === void 0) { justFiltered = false; }
	        if (this.rowModel.getType() !== constants_1.Constants.ROW_MODEL_TYPE_CLIENT_SIDE) {
	            throw new Error("selectAll only available with normal row model, ie not " + this.rowModel.getType());
	        }
	        var clientSideRowModel = this.rowModel;
	        var callback = function (rowNode) { return rowNode.selectThisNode(true); };
	        if (justFiltered) {
	            clientSideRowModel.forEachNodeAfterFilter(callback);
	        }
	        else {
	            clientSideRowModel.forEachNode(callback);
	        }
	        // the above does not clean up the parent rows if they are selected
	        if (this.rowModel.getType() === constants_1.Constants.ROW_MODEL_TYPE_CLIENT_SIDE && this.groupSelectsChildren) {
	            this.updateGroupsFromChildrenSelections();
	        }
	        var event = {
	            type: events_1.Events.EVENT_SELECTION_CHANGED,
	            api: this.gridApi,
	            columnApi: this.columnApi
	        };
	        this.eventService.dispatchEvent(event);
	    };
	    /**
	     * @method
	     * @deprecated
	     */
	    SelectionController.prototype.selectNode = function (rowNode, tryMulti) {
	        if (rowNode) {
	            rowNode.setSelectedParams({ newValue: true, clearSelection: !tryMulti });
	        }
	    };
	    /**
	     * @method
	     * @deprecated
	     */
	    SelectionController.prototype.deselectIndex = function (rowIndex) {
	        var node = this.rowModel.getRow(rowIndex);
	        this.deselectNode(node);
	    };
	    /**
	     * @method
	     * @deprecated
	     */
	    SelectionController.prototype.deselectNode = function (rowNode) {
	        if (rowNode) {
	            rowNode.setSelectedParams({ newValue: false, clearSelection: false });
	        }
	    };
	    /**
	     * @method
	     * @deprecated
	     */
	    SelectionController.prototype.selectIndex = function (index, tryMulti) {
	        var node = this.rowModel.getRow(index);
	        this.selectNode(node, tryMulti);
	    };
	    __decorate([
	        context_3.Autowired('eventService'),
	        __metadata("design:type", eventService_1.EventService)
	    ], SelectionController.prototype, "eventService", void 0);
	    __decorate([
	        context_3.Autowired('rowModel'),
	        __metadata("design:type", Object)
	    ], SelectionController.prototype, "rowModel", void 0);
	    __decorate([
	        context_3.Autowired('gridOptionsWrapper'),
	        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
	    ], SelectionController.prototype, "gridOptionsWrapper", void 0);
	    __decorate([
	        context_3.Autowired('columnApi'),
	        __metadata("design:type", columnApi_1.ColumnApi)
	    ], SelectionController.prototype, "columnApi", void 0);
	    __decorate([
	        context_3.Autowired('gridApi'),
	        __metadata("design:type", gridApi_1.GridApi)
	    ], SelectionController.prototype, "gridApi", void 0);
	    __decorate([
	        __param(0, context_2.Qualifier('loggerFactory')),
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", [logger_1.LoggerFactory]),
	        __metadata("design:returntype", void 0)
	    ], SelectionController.prototype, "setBeans", null);
	    __decorate([
	        context_4.PostConstruct,
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", []),
	        __metadata("design:returntype", void 0)
	    ], SelectionController.prototype, "init", null);
	    SelectionController = __decorate([
	        context_1.Bean('selectionController')
	    ], SelectionController);
	    return SelectionController;
	}());
	exports.SelectionController = SelectionController;


/***/ }),
/* 2358 */
/***/ (function(module, exports) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	// when doing transactions, or change detection, and grouping is present
	// in the data, there is no need for the ClientSideRowModel to update each
	// group after an update, ony parts that were impacted by the change.
	// this class keeps track of all groups that were impacted by a transaction.
	// the the different CSRM operations (filter, sort etc) use the forEach method
	// to visit each group that was changed.
	var ChangedPath = /** @class */ (function () {
	    function ChangedPath(keepingColumns, rootNode) {
	        // whether changed path is active of not. it is active when a) doing
	        // a transaction update or b) doing change detection. if we are doing
	        // a CSRM refresh for other reasons (after sort or filter, or user calling
	        // setRowData() without delta mode) then we are not active. we are also
	        // marked as not active if secondary columns change in pivot (as this impacts
	        // aggregations)
	        this.active = true;
	        // for each node in the change path, we also store which columns need
	        // to be re-aggregated.
	        this.nodeIdsToColumns = {};
	        // for quick lookup, all items in the change path are mapped by nodeId
	        this.mapToItems = {};
	        this.keepingColumns = keepingColumns;
	        this.pathRoot = {
	            rowNode: rootNode,
	            children: null
	        };
	        this.mapToItems[rootNode.id] = this.pathRoot;
	    }
	    // can be set inactive by:
	    // a) ClientSideRowModel, if no transactions or
	    // b) PivotService, if secondary columns changed
	    ChangedPath.prototype.setInactive = function () {
	        this.active = false;
	    };
	    ChangedPath.prototype.isActive = function () {
	        return this.active;
	    };
	    ChangedPath.prototype.depthFirstSearchChangedPath = function (pathItem, callback) {
	        if (pathItem.children) {
	            for (var i = 0; i < pathItem.children.length; i++) {
	                this.depthFirstSearchChangedPath(pathItem.children[i], callback);
	            }
	        }
	        callback(pathItem.rowNode);
	    };
	    ChangedPath.prototype.depthFirstSearchEverything = function (rowNode, callback, traverseEverything) {
	        if (rowNode.childrenAfterGroup) {
	            for (var i = 0; i < rowNode.childrenAfterGroup.length; i++) {
	                var childNode = rowNode.childrenAfterGroup[i];
	                if (childNode.childrenAfterGroup) {
	                    this.depthFirstSearchEverything(rowNode.childrenAfterGroup[i], callback, traverseEverything);
	                }
	                else if (traverseEverything) {
	                    callback(childNode);
	                }
	            }
	        }
	        callback(rowNode);
	    };
	    // traverseLeafNodes -> used when NOT doing changed path, ie traversing everything. the callback
	    // will be called for child nodes in addition to parent nodes.
	    ChangedPath.prototype.forEachChangedNodeDepthFirst = function (callback, traverseLeafNodes) {
	        if (traverseLeafNodes === void 0) { traverseLeafNodes = false; }
	        if (this.active) {
	            // if we are active, then use the change path to callback
	            // only for updated groups
	            this.depthFirstSearchChangedPath(this.pathRoot, callback);
	        }
	        else {
	            // we are not active, so callback for everything, walk the entire path
	            this.depthFirstSearchEverything(this.pathRoot.rowNode, callback, traverseLeafNodes);
	        }
	    };
	    ChangedPath.prototype.executeFromRootNode = function (callback) {
	        callback(this.pathRoot.rowNode);
	    };
	    ChangedPath.prototype.createPathItems = function (rowNode) {
	        var pointer = rowNode;
	        var newEntryCount = 0;
	        while (!this.mapToItems[pointer.id]) {
	            var newEntry = {
	                rowNode: pointer,
	                children: null
	            };
	            this.mapToItems[pointer.id] = newEntry;
	            newEntryCount++;
	            pointer = pointer.parent;
	        }
	        return newEntryCount;
	    };
	    ChangedPath.prototype.populateColumnsMap = function (rowNode, columns) {
	        var _this = this;
	        if (!this.keepingColumns || !columns) {
	            return;
	        }
	        var pointer = rowNode;
	        while (pointer) {
	            // if columns, add the columns in all the way to parent, merging
	            // in any other columns that might be there already
	            if (!this.nodeIdsToColumns[pointer.id]) {
	                this.nodeIdsToColumns[pointer.id] = {};
	            }
	            columns.forEach(function (col) { return _this.nodeIdsToColumns[pointer.id][col.getId()] = true; });
	            pointer = pointer.parent;
	        }
	    };
	    ChangedPath.prototype.linkPathItems = function (rowNode, newEntryCount) {
	        var pointer = rowNode;
	        for (var i = 0; i < newEntryCount; i++) {
	            var thisItem = this.mapToItems[pointer.id];
	            var parentItem = this.mapToItems[pointer.parent.id];
	            if (!parentItem.children) {
	                parentItem.children = [];
	            }
	            parentItem.children.push(thisItem);
	            pointer = pointer.parent;
	        }
	    };
	    // called by
	    // 1) change detection (provides cols) and
	    // 2) groupStage if doing transaction update (doesn't provide cols)
	    ChangedPath.prototype.addParentNode = function (rowNode, columns) {
	        // we cannot do  both steps below in the same loop as
	        // the second loop has a dependency on the first loop.
	        // ie the hierarchy cannot be stitched up yet because
	        // we don't have it built yet
	        // create the new PathItem objects.
	        var newEntryCount = this.createPathItems(rowNode);
	        // link in the node items
	        this.linkPathItems(rowNode, newEntryCount);
	        // update columns
	        this.populateColumnsMap(rowNode, columns);
	    };
	    ChangedPath.prototype.canSkip = function (rowNode) {
	        return this.active && !this.mapToItems[rowNode.id];
	    };
	    ChangedPath.prototype.getValueColumnsForNode = function (rowNode, valueColumns) {
	        if (!this.keepingColumns) {
	            return valueColumns;
	        }
	        var colsForThisNode = this.nodeIdsToColumns[rowNode.id];
	        var result = valueColumns.filter(function (col) { return colsForThisNode[col.getId()]; });
	        return result;
	    };
	    ChangedPath.prototype.getNotValueColumnsForNode = function (rowNode, valueColumns) {
	        if (!this.keepingColumns) {
	            return null;
	        }
	        var colsForThisNode = this.nodeIdsToColumns[rowNode.id];
	        var result = valueColumns.filter(function (col) { return !colsForThisNode[col.getId()]; });
	        return result;
	    };
	    return ChangedPath;
	}());
	exports.ChangedPath = ChangedPath;


/***/ }),
/* 2359 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var gridOptionsWrapper_1 = __webpack_require__(2324);
	var expressionService_1 = __webpack_require__(2347);
	var columnController_1 = __webpack_require__(2341);
	var context_1 = __webpack_require__(2333);
	var events_1 = __webpack_require__(2335);
	var eventService_1 = __webpack_require__(2331);
	var valueCache_1 = __webpack_require__(2360);
	var utils_1 = __webpack_require__(2325);
	var ValueService = /** @class */ (function () {
	    function ValueService() {
	        this.initialised = false;
	    }
	    ValueService.prototype.init = function () {
	        this.cellExpressions = this.gridOptionsWrapper.isEnableCellExpressions();
	        this.initialised = true;
	    };
	    ValueService.prototype.getValue = function (column, rowNode, forFilter, ignoreAggData) {
	        // console.log(`turnActive = ${this.turnActive}`);
	        if (forFilter === void 0) { forFilter = false; }
	        if (ignoreAggData === void 0) { ignoreAggData = false; }
	        // hack - the grid is getting refreshed before this bean gets initialised, race condition.
	        // really should have a way so they get initialised in the right order???
	        if (!this.initialised) {
	            this.init();
	        }
	        if (!rowNode) {
	            return;
	        }
	        // pull these out to make code below easier to read
	        var colDef = column.getColDef();
	        var field = colDef.field;
	        var colId = column.getId();
	        var data = rowNode.data;
	        var result;
	        // if there is a value getter, this gets precedence over a field
	        var groupDataExists = rowNode.groupData && rowNode.groupData[colId] !== undefined;
	        var aggDataExists = !ignoreAggData && rowNode.aggData && rowNode.aggData[colId] !== undefined;
	        if (forFilter && colDef.filterValueGetter) {
	            result = this.executeFilterValueGetter(colDef.filterValueGetter, data, column, rowNode);
	        }
	        else if (this.gridOptionsWrapper.isTreeData() && aggDataExists) {
	            result = rowNode.aggData[colId];
	        }
	        else if (this.gridOptionsWrapper.isTreeData() && colDef.valueGetter) {
	            result = this.executeValueGetter(colDef.valueGetter, data, column, rowNode);
	        }
	        else if (this.gridOptionsWrapper.isTreeData() && (field && data)) {
	            result = utils_1._.getValueUsingField(data, field, column.isFieldContainsDots());
	        }
	        else if (groupDataExists) {
	            result = rowNode.groupData[colId];
	        }
	        else if (aggDataExists) {
	            result = rowNode.aggData[colId];
	        }
	        else if (colDef.valueGetter) {
	            result = this.executeValueGetter(colDef.valueGetter, data, column, rowNode);
	        }
	        else if (field && data) {
	            result = utils_1._.getValueUsingField(data, field, column.isFieldContainsDots());
	        }
	        // the result could be an expression itself, if we are allowing cell values to be expressions
	        if (this.cellExpressions && (typeof result === 'string') && result.indexOf('=') === 0) {
	            var cellValueGetter = result.substring(1);
	            result = this.executeValueGetter(cellValueGetter, data, column, rowNode);
	        }
	        return result;
	    };
	    ValueService.prototype.setValue = function (rowNode, colKey, newValue) {
	        var column = this.columnController.getPrimaryColumn(colKey);
	        if (!rowNode || !column) {
	            return;
	        }
	        // this will only happen if user is trying to paste into a group row, which doesn't make sense
	        // the user should not be trying to paste into group rows
	        var data = rowNode.data;
	        if (utils_1._.missing(data)) {
	            rowNode.data = {};
	        }
	        // for backwards compatibility we are also retrieving the newValueHandler as well as the valueSetter
	        var _a = column.getColDef(), field = _a.field, newValueHandler = _a.newValueHandler, valueSetter = _a.valueSetter;
	        // need either a field or a newValueHandler for this to work
	        if (utils_1._.missing(field) && utils_1._.missing(newValueHandler) && utils_1._.missing(valueSetter)) {
	            // we don't tell user about newValueHandler, as that is deprecated
	            console.warn("ag-Grid: you need either field or valueSetter set on colDef for editing to work");
	            return;
	        }
	        var params = {
	            node: rowNode,
	            data: rowNode.data,
	            oldValue: this.getValue(column, rowNode),
	            newValue: newValue,
	            colDef: column.getColDef(),
	            column: column,
	            api: this.gridOptionsWrapper.getApi(),
	            columnApi: this.gridOptionsWrapper.getColumnApi(),
	            context: this.gridOptionsWrapper.getContext()
	        };
	        params.newValue = newValue;
	        var valueWasDifferent;
	        if (newValueHandler && utils_1._.exists(newValueHandler)) {
	            valueWasDifferent = newValueHandler(params);
	        }
	        else if (utils_1._.exists(valueSetter)) {
	            valueWasDifferent = this.expressionService.evaluate(valueSetter, params);
	        }
	        else {
	            valueWasDifferent = this.setValueUsingField(data, field, newValue, column.isFieldContainsDots());
	        }
	        // in case user forgot to return something (possible if they are not using TypeScript
	        // and just forgot, or using an old newValueHandler we didn't always expect a return
	        // value here), we default the return value to true, so we always refresh.
	        if (valueWasDifferent === undefined) {
	            valueWasDifferent = true;
	        }
	        // if no change to the value, then no need to do the updating, or notifying via events.
	        // otherwise the user could be tabbing around the grid, and cellValueChange would get called
	        // all the time.
	        if (!valueWasDifferent) {
	            return;
	        }
	        // reset quick filter on this row
	        rowNode.resetQuickFilterAggregateText();
	        this.valueCache.onDataChanged();
	        params.newValue = this.getValue(column, rowNode);
	        var onCellValueChanged = column.getColDef().onCellValueChanged;
	        if (typeof onCellValueChanged === 'function') {
	            // to make callback async, do in a timeout
	            setTimeout(function () { return onCellValueChanged(params); }, 0);
	        }
	        var event = {
	            type: events_1.Events.EVENT_CELL_VALUE_CHANGED,
	            event: null,
	            rowIndex: rowNode.rowIndex,
	            rowPinned: rowNode.rowPinned,
	            column: params.column,
	            api: params.api,
	            colDef: params.colDef,
	            columnApi: params.columnApi,
	            context: params.context,
	            data: rowNode.data,
	            node: rowNode,
	            oldValue: params.oldValue,
	            newValue: params.newValue,
	            value: params.newValue
	        };
	        this.eventService.dispatchEvent(event);
	    };
	    ValueService.prototype.setValueUsingField = function (data, field, newValue, isFieldContainsDots) {
	        if (!field) {
	            return false;
	        }
	        // if no '.', then it's not a deep value
	        var valuesAreSame = false;
	        if (!isFieldContainsDots) {
	            data[field] = newValue;
	        }
	        else {
	            // otherwise it is a deep value, so need to dig for it
	            var fieldPieces = field.split('.');
	            var currentObject = data;
	            while (fieldPieces.length > 0 && currentObject) {
	                var fieldPiece = fieldPieces.shift();
	                if (fieldPieces.length === 0) {
	                    currentObject[fieldPiece] = newValue;
	                }
	                else {
	                    currentObject = currentObject[fieldPiece];
	                }
	            }
	        }
	        return !valuesAreSame;
	    };
	    ValueService.prototype.executeFilterValueGetter = function (valueGetter, data, column, rowNode) {
	        var params = {
	            data: data,
	            node: rowNode,
	            column: column,
	            colDef: column.getColDef(),
	            api: this.gridOptionsWrapper.getApi(),
	            columnApi: this.gridOptionsWrapper.getColumnApi(),
	            context: this.gridOptionsWrapper.getContext(),
	            getValue: this.getValueCallback.bind(this, rowNode)
	        };
	        return this.expressionService.evaluate(valueGetter, params);
	    };
	    ValueService.prototype.executeValueGetter = function (valueGetter, data, column, rowNode) {
	        var colId = column.getId();
	        // if inside the same turn, just return back the value we got last time
	        var valueFromCache = this.valueCache.getValue(rowNode, colId);
	        if (valueFromCache !== undefined) {
	            return valueFromCache;
	        }
	        var params = {
	            data: data,
	            node: rowNode,
	            column: column,
	            colDef: column.getColDef(),
	            api: this.gridOptionsWrapper.getApi(),
	            columnApi: this.gridOptionsWrapper.getColumnApi(),
	            context: this.gridOptionsWrapper.getContext(),
	            getValue: this.getValueCallback.bind(this, rowNode)
	        };
	        var result = this.expressionService.evaluate(valueGetter, params);
	        // if a turn is active, store the value in case the grid asks for it again
	        this.valueCache.setValue(rowNode, colId, result);
	        return result;
	    };
	    ValueService.prototype.getValueCallback = function (node, field) {
	        var otherColumn = this.columnController.getPrimaryColumn(field);
	        if (otherColumn) {
	            return this.getValue(otherColumn, node);
	        }
	        return null;
	    };
	    // used by row grouping and pivot, to get key for a row. col can be a pivot col or a row grouping col
	    ValueService.prototype.getKeyForNode = function (col, rowNode) {
	        var value = this.getValue(col, rowNode);
	        var keyCreator = col.getColDef().keyCreator;
	        var result = keyCreator ? keyCreator({ value: value }) : value;
	        // if already a string, or missing, just return it
	        if (typeof result === 'string' || result == null) {
	            return result;
	        }
	        result = String(result);
	        if (result === '[object Object]') {
	            utils_1._.doOnce(function () {
	                console.warn('ag-Grid: a column you are grouping or pivoting by has objects as values. If you want to group by complex objects then either a) use a colDef.keyCreator (se ag-Grid docs) or b) to toString() on the object to return a key');
	            }, 'getKeyForNode - warn about [object,object]');
	        }
	        return result;
	    };
	    __decorate([
	        context_1.Autowired('gridOptionsWrapper'),
	        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
	    ], ValueService.prototype, "gridOptionsWrapper", void 0);
	    __decorate([
	        context_1.Autowired('expressionService'),
	        __metadata("design:type", expressionService_1.ExpressionService)
	    ], ValueService.prototype, "expressionService", void 0);
	    __decorate([
	        context_1.Autowired('columnController'),
	        __metadata("design:type", columnController_1.ColumnController)
	    ], ValueService.prototype, "columnController", void 0);
	    __decorate([
	        context_1.Autowired('eventService'),
	        __metadata("design:type", eventService_1.EventService)
	    ], ValueService.prototype, "eventService", void 0);
	    __decorate([
	        context_1.Autowired('valueCache'),
	        __metadata("design:type", valueCache_1.ValueCache)
	    ], ValueService.prototype, "valueCache", void 0);
	    __decorate([
	        context_1.PostConstruct,
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", []),
	        __metadata("design:returntype", void 0)
	    ], ValueService.prototype, "init", null);
	    ValueService = __decorate([
	        context_1.Bean('valueService')
	    ], ValueService);
	    return ValueService;
	}());
	exports.ValueService = ValueService;


/***/ }),
/* 2360 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var context_1 = __webpack_require__(2333);
	var gridOptionsWrapper_1 = __webpack_require__(2324);
	var ValueCache = /** @class */ (function () {
	    function ValueCache() {
	        this.cacheVersion = 0;
	    }
	    ValueCache.prototype.init = function () {
	        this.active = this.gridOptionsWrapper.isValueCache();
	        this.neverExpires = this.gridOptionsWrapper.isValueCacheNeverExpires();
	    };
	    ValueCache.prototype.onDataChanged = function () {
	        if (this.neverExpires) {
	            return;
	        }
	        this.expire();
	    };
	    ValueCache.prototype.expire = function () {
	        this.cacheVersion++;
	    };
	    ValueCache.prototype.setValue = function (rowNode, colId, value) {
	        if (this.active) {
	            if (rowNode.__cacheVersion !== this.cacheVersion) {
	                rowNode.__cacheVersion = this.cacheVersion;
	                rowNode.__cacheData = {};
	            }
	            rowNode.__cacheData[colId] = value;
	        }
	    };
	    ValueCache.prototype.getValue = function (rowNode, colId) {
	        var valueInCache = this.active
	            && rowNode.__cacheVersion === this.cacheVersion
	            && rowNode.__cacheData[colId] !== undefined;
	        if (valueInCache) {
	            return rowNode.__cacheData[colId];
	        }
	        else {
	            return undefined;
	        }
	    };
	    __decorate([
	        context_1.Autowired('gridOptionsWrapper'),
	        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
	    ], ValueCache.prototype, "gridOptionsWrapper", void 0);
	    __decorate([
	        context_1.PostConstruct,
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", []),
	        __metadata("design:returntype", void 0)
	    ], ValueCache.prototype, "init", null);
	    ValueCache = __decorate([
	        context_1.Bean('valueCache')
	    ], ValueCache);
	    return ValueCache;
	}());
	exports.ValueCache = ValueCache;


/***/ }),
/* 2361 */
/***/ (function(module, exports) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var CellRangeType;
	(function (CellRangeType) {
	    CellRangeType[CellRangeType["VALUE"] = 0] = "VALUE";
	    CellRangeType[CellRangeType["DIMENSION"] = 1] = "DIMENSION";
	})(CellRangeType = exports.CellRangeType || (exports.CellRangeType = {}));


/***/ }),
/* 2362 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var component_1 = __webpack_require__(2353);
	var context_1 = __webpack_require__(2333);
	var rowNode_1 = __webpack_require__(2356);
	var dragAndDropService_1 = __webpack_require__(2363);
	var eventKeys_1 = __webpack_require__(2336);
	var beanStub_1 = __webpack_require__(2354);
	var utils_1 = __webpack_require__(2325);
	var RowDragComp = /** @class */ (function (_super) {
	    __extends(RowDragComp, _super);
	    function RowDragComp(rowNode, column, cellValue, beans) {
	        var _this = _super.call(this, "<div class=\"ag-row-drag\"></div>") || this;
	        _this.rowNode = rowNode;
	        _this.column = column;
	        _this.cellValue = cellValue;
	        _this.beans = beans;
	        return _this;
	    }
	    RowDragComp.prototype.postConstruct = function () {
	        var eGui = this.getGui();
	        eGui.appendChild(utils_1._.createIconNoSpan('rowDrag', this.beans.gridOptionsWrapper, null));
	        this.addDragSource();
	        this.checkCompatibility();
	        if (this.beans.gridOptionsWrapper.isRowDragManaged()) {
	            this.addFeature(this.beans.context, new ManagedVisibilityStrategy(this, this.beans, this.rowNode, this.column));
	        }
	        else {
	            this.addFeature(this.beans.context, new NonManagedVisibilityStrategy(this, this.beans, this.rowNode, this.column));
	        }
	    };
	    // returns true if all compatibility items work out
	    RowDragComp.prototype.checkCompatibility = function () {
	        var managed = this.beans.gridOptionsWrapper.isRowDragManaged();
	        var treeData = this.beans.gridOptionsWrapper.isTreeData();
	        if (treeData && managed) {
	            utils_1._.doOnce(function () {
	                return console.warn('ag-Grid: If using row drag with tree data, you cannot have rowDragManaged=true');
	            }, 'RowDragComp.managedAndTreeData');
	        }
	    };
	    RowDragComp.prototype.addDragSource = function () {
	        var _this = this;
	        var dragItem = {
	            rowNode: this.rowNode
	        };
	        var dragSource = {
	            type: dragAndDropService_1.DragSourceType.RowDrag,
	            eElement: this.getGui(),
	            dragItemName: this.cellValue,
	            dragItemCallback: function () { return dragItem; },
	            dragStartPixels: 0
	        };
	        this.beans.dragAndDropService.addDragSource(dragSource, true);
	        this.addDestroyFunc(function () { return _this.beans.dragAndDropService.removeDragSource(dragSource); });
	    };
	    __decorate([
	        context_1.PostConstruct,
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", []),
	        __metadata("design:returntype", void 0)
	    ], RowDragComp.prototype, "postConstruct", null);
	    return RowDragComp;
	}(component_1.Component));
	exports.RowDragComp = RowDragComp;
	var VisibilityStrategy = /** @class */ (function (_super) {
	    __extends(VisibilityStrategy, _super);
	    function VisibilityStrategy(parent, rowNode, column) {
	        var _this = _super.call(this) || this;
	        _this.parent = parent;
	        _this.column = column;
	        _this.rowNode = rowNode;
	        return _this;
	    }
	    VisibilityStrategy.prototype.setDisplayedOrVisible = function (neverDisplayed) {
	        if (neverDisplayed) {
	            this.parent.setDisplayed(false);
	        }
	        else {
	            var shown = this.column.isRowDrag(this.rowNode);
	            var isShownSometimes = utils_1._.isFunction(this.column.getColDef().rowDrag);
	            // if shown sometimes, them some rows can have drag handle while other don't,
	            // so we use setVisible to keep the handles horizontally aligned (as setVisible
	            // keeps the empty space, whereas setDisplayed looses the space)
	            if (isShownSometimes) {
	                this.parent.setVisible(shown);
	            }
	            else {
	                this.parent.setDisplayed(shown);
	            }
	        }
	    };
	    return VisibilityStrategy;
	}(beanStub_1.BeanStub));
	// when non managed, the visibility depends on suppressRowDrag property only
	var NonManagedVisibilityStrategy = /** @class */ (function (_super) {
	    __extends(NonManagedVisibilityStrategy, _super);
	    function NonManagedVisibilityStrategy(parent, beans, rowNode, column) {
	        var _this = _super.call(this, parent, rowNode, column) || this;
	        _this.beans = beans;
	        return _this;
	    }
	    NonManagedVisibilityStrategy.prototype.postConstruct = function () {
	        this.addDestroyableEventListener(this.beans.gridOptionsWrapper, 'suppressRowDrag', this.onSuppressRowDrag.bind(this));
	        // in case data changes, then we need to update visibility of drag item
	        this.addDestroyableEventListener(this.rowNode, rowNode_1.RowNode.EVENT_DATA_CHANGED, this.workOutVisibility.bind(this));
	        this.addDestroyableEventListener(this.rowNode, rowNode_1.RowNode.EVENT_CELL_CHANGED, this.workOutVisibility.bind(this));
	        this.workOutVisibility();
	    };
	    NonManagedVisibilityStrategy.prototype.onSuppressRowDrag = function () {
	        this.workOutVisibility();
	    };
	    NonManagedVisibilityStrategy.prototype.workOutVisibility = function () {
	        // only show the drag if both sort and filter are not present
	        var neverDisplayed = this.beans.gridOptionsWrapper.isSuppressRowDrag();
	        this.setDisplayedOrVisible(neverDisplayed);
	    };
	    __decorate([
	        context_1.PostConstruct,
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", []),
	        __metadata("design:returntype", void 0)
	    ], NonManagedVisibilityStrategy.prototype, "postConstruct", null);
	    return NonManagedVisibilityStrategy;
	}(VisibilityStrategy));
	// when managed, the visibility depends on sort, filter and row group, as well as suppressRowDrag property
	var ManagedVisibilityStrategy = /** @class */ (function (_super) {
	    __extends(ManagedVisibilityStrategy, _super);
	    function ManagedVisibilityStrategy(parent, beans, rowNode, column) {
	        var _this = _super.call(this, parent, rowNode, column) || this;
	        _this.beans = beans;
	        return _this;
	    }
	    ManagedVisibilityStrategy.prototype.postConstruct = function () {
	        // we do not show the component if sort, filter or grouping is active
	        this.addDestroyableEventListener(this.beans.eventService, eventKeys_1.Events.EVENT_SORT_CHANGED, this.onSortChanged.bind(this));
	        this.addDestroyableEventListener(this.beans.eventService, eventKeys_1.Events.EVENT_FILTER_CHANGED, this.onFilterChanged.bind(this));
	        this.addDestroyableEventListener(this.beans.eventService, eventKeys_1.Events.EVENT_COLUMN_ROW_GROUP_CHANGED, this.onRowGroupChanged.bind(this));
	        // in case data changes, then we need to update visibility of drag item
	        this.addDestroyableEventListener(this.rowNode, rowNode_1.RowNode.EVENT_DATA_CHANGED, this.workOutVisibility.bind(this));
	        this.addDestroyableEventListener(this.rowNode, rowNode_1.RowNode.EVENT_CELL_CHANGED, this.workOutVisibility.bind(this));
	        this.addDestroyableEventListener(this.beans.gridOptionsWrapper, 'suppressRowDrag', this.onSuppressRowDrag.bind(this));
	        this.updateSortActive();
	        this.updateFilterActive();
	        this.updateRowGroupActive();
	        this.workOutVisibility();
	    };
	    ManagedVisibilityStrategy.prototype.updateRowGroupActive = function () {
	        var rowGroups = this.beans.columnController.getRowGroupColumns();
	        this.rowGroupActive = !utils_1._.missingOrEmpty(rowGroups);
	    };
	    ManagedVisibilityStrategy.prototype.onRowGroupChanged = function () {
	        this.updateRowGroupActive();
	        this.workOutVisibility();
	    };
	    ManagedVisibilityStrategy.prototype.updateSortActive = function () {
	        var sortModel = this.beans.sortController.getSortModel();
	        this.sortActive = !utils_1._.missingOrEmpty(sortModel);
	    };
	    ManagedVisibilityStrategy.prototype.onSortChanged = function () {
	        this.updateSortActive();
	        this.workOutVisibility();
	    };
	    ManagedVisibilityStrategy.prototype.updateFilterActive = function () {
	        this.filterActive = this.beans.filterManager.isAnyFilterPresent();
	    };
	    ManagedVisibilityStrategy.prototype.onFilterChanged = function () {
	        this.updateFilterActive();
	        this.workOutVisibility();
	    };
	    ManagedVisibilityStrategy.prototype.onSuppressRowDrag = function () {
	        this.workOutVisibility();
	    };
	    ManagedVisibilityStrategy.prototype.workOutVisibility = function () {
	        // only show the drag if both sort and filter are not present
	        var sortOrFilterOrGroupActive = this.sortActive || this.filterActive || this.rowGroupActive;
	        var suppressRowDrag = this.beans.gridOptionsWrapper.isSuppressRowDrag();
	        var neverDisplayed = sortOrFilterOrGroupActive || suppressRowDrag;
	        this.setDisplayedOrVisible(neverDisplayed);
	    };
	    __decorate([
	        context_1.PostConstruct,
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", []),
	        __metadata("design:returntype", void 0)
	    ], ManagedVisibilityStrategy.prototype, "postConstruct", null);
	    return ManagedVisibilityStrategy;
	}(VisibilityStrategy));


/***/ }),
/* 2363 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var __param = (this && this.__param) || function (paramIndex, decorator) {
	    return function (target, key) { decorator(target, key, paramIndex); }
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var logger_1 = __webpack_require__(2332);
	var context_1 = __webpack_require__(2333);
	var gridOptionsWrapper_1 = __webpack_require__(2324);
	var dragService_1 = __webpack_require__(2364);
	var columnController_1 = __webpack_require__(2341);
	var environment_1 = __webpack_require__(2365);
	var utils_1 = __webpack_require__(2325);
	var DragSourceType;
	(function (DragSourceType) {
	    DragSourceType[DragSourceType["ToolPanel"] = 0] = "ToolPanel";
	    DragSourceType[DragSourceType["HeaderCell"] = 1] = "HeaderCell";
	    DragSourceType[DragSourceType["RowDrag"] = 2] = "RowDrag";
	})(DragSourceType = exports.DragSourceType || (exports.DragSourceType = {}));
	var VDirection;
	(function (VDirection) {
	    VDirection[VDirection["Up"] = 0] = "Up";
	    VDirection[VDirection["Down"] = 1] = "Down";
	})(VDirection = exports.VDirection || (exports.VDirection = {}));
	var HDirection;
	(function (HDirection) {
	    HDirection[HDirection["Left"] = 0] = "Left";
	    HDirection[HDirection["Right"] = 1] = "Right";
	})(HDirection = exports.HDirection || (exports.HDirection = {}));
	var DragAndDropService = /** @class */ (function () {
	    function DragAndDropService() {
	        this.dragSourceAndParamsList = [];
	        this.dropTargets = [];
	    }
	    DragAndDropService_1 = DragAndDropService;
	    DragAndDropService.prototype.init = function () {
	        this.ePinnedIcon = utils_1._.createIcon('columnMovePin', this.gridOptionsWrapper, null);
	        this.ePlusIcon = utils_1._.createIcon('columnMoveAdd', this.gridOptionsWrapper, null);
	        this.eHiddenIcon = utils_1._.createIcon('columnMoveHide', this.gridOptionsWrapper, null);
	        this.eMoveIcon = utils_1._.createIcon('columnMoveMove', this.gridOptionsWrapper, null);
	        this.eLeftIcon = utils_1._.createIcon('columnMoveLeft', this.gridOptionsWrapper, null);
	        this.eRightIcon = utils_1._.createIcon('columnMoveRight', this.gridOptionsWrapper, null);
	        this.eGroupIcon = utils_1._.createIcon('columnMoveGroup', this.gridOptionsWrapper, null);
	        this.eAggregateIcon = utils_1._.createIcon('columnMoveValue', this.gridOptionsWrapper, null);
	        this.ePivotIcon = utils_1._.createIcon('columnMovePivot', this.gridOptionsWrapper, null);
	        this.eDropNotAllowedIcon = utils_1._.createIcon('dropNotAllowed', this.gridOptionsWrapper, null);
	    };
	    DragAndDropService.prototype.setBeans = function (loggerFactory) {
	        this.logger = loggerFactory.create('OldToolPanelDragAndDropService');
	    };
	    DragAndDropService.prototype.getStringType = function (type) {
	        switch (type) {
	            case DragSourceType.RowDrag: return 'row';
	            case DragSourceType.HeaderCell: return 'headerCell';
	            case DragSourceType.ToolPanel: return 'toolPanel';
	            default:
	                console.warn("ag-Grid: bug - unknown drag type " + type);
	                return null;
	        }
	    };
	    DragAndDropService.prototype.addDragSource = function (dragSource, allowTouch) {
	        if (allowTouch === void 0) { allowTouch = false; }
	        var params = {
	            eElement: dragSource.eElement,
	            dragStartPixels: dragSource.dragStartPixels,
	            onDragStart: this.onDragStart.bind(this, dragSource),
	            onDragStop: this.onDragStop.bind(this),
	            onDragging: this.onDragging.bind(this)
	        };
	        this.dragSourceAndParamsList.push({ params: params, dragSource: dragSource });
	        this.dragService.addDragSource(params, allowTouch);
	    };
	    DragAndDropService.prototype.removeDragSource = function (dragSource) {
	        var sourceAndParams = utils_1._.find(this.dragSourceAndParamsList, function (item) { return item.dragSource === dragSource; });
	        if (sourceAndParams) {
	            this.dragService.removeDragSource(sourceAndParams.params);
	            utils_1._.removeFromArray(this.dragSourceAndParamsList, sourceAndParams);
	        }
	    };
	    DragAndDropService.prototype.destroy = function () {
	        var _this = this;
	        this.dragSourceAndParamsList.forEach(function (sourceAndParams) {
	            _this.dragService.removeDragSource(sourceAndParams.params);
	        });
	        this.dragSourceAndParamsList.length = 0;
	    };
	    DragAndDropService.prototype.nudge = function () {
	        if (this.dragging) {
	            this.onDragging(this.eventLastTime, true);
	        }
	    };
	    DragAndDropService.prototype.onDragStart = function (dragSource, mouseEvent) {
	        this.dragging = true;
	        this.dragSource = dragSource;
	        this.eventLastTime = mouseEvent;
	        this.dragItem = this.dragSource.dragItemCallback();
	        this.lastDropTarget = this.dragSource.dragSourceDropTarget;
	        if (this.dragSource.dragStarted) {
	            this.dragSource.dragStarted();
	        }
	        this.createGhost();
	    };
	    DragAndDropService.prototype.onDragStop = function (mouseEvent) {
	        this.eventLastTime = null;
	        this.dragging = false;
	        if (this.dragSource.dragStopped) {
	            this.dragSource.dragStopped();
	        }
	        if (this.lastDropTarget && this.lastDropTarget.onDragStop) {
	            var draggingEvent = this.createDropTargetEvent(this.lastDropTarget, mouseEvent, null, null, false);
	            this.lastDropTarget.onDragStop(draggingEvent);
	        }
	        this.lastDropTarget = null;
	        this.dragItem = null;
	        this.removeGhost();
	    };
	    DragAndDropService.prototype.onDragging = function (mouseEvent, fromNudge) {
	        var hDirection = this.workOutHDirection(mouseEvent);
	        var vDirection = this.workOutVDirection(mouseEvent);
	        this.eventLastTime = mouseEvent;
	        this.positionGhost(mouseEvent);
	        // check if mouseEvent intersects with any of the drop targets
	        var dropTarget = utils_1._.find(this.dropTargets, this.isMouseOnDropTarget.bind(this, mouseEvent));
	        if (dropTarget !== this.lastDropTarget) {
	            this.leaveLastTargetIfExists(mouseEvent, hDirection, vDirection, fromNudge);
	            this.enterDragTargetIfExists(dropTarget, mouseEvent, hDirection, vDirection, fromNudge);
	            this.lastDropTarget = dropTarget;
	        }
	        else if (dropTarget) {
	            var draggingEvent = this.createDropTargetEvent(dropTarget, mouseEvent, hDirection, vDirection, fromNudge);
	            dropTarget.onDragging(draggingEvent);
	        }
	    };
	    DragAndDropService.prototype.enterDragTargetIfExists = function (dropTarget, mouseEvent, hDirection, vDirection, fromNudge) {
	        if (!dropTarget) {
	            return;
	        }
	        var dragEnterEvent = this.createDropTargetEvent(dropTarget, mouseEvent, hDirection, vDirection, fromNudge);
	        dropTarget.onDragEnter(dragEnterEvent);
	        this.setGhostIcon(dropTarget.getIconName ? dropTarget.getIconName() : null);
	    };
	    DragAndDropService.prototype.leaveLastTargetIfExists = function (mouseEvent, hDirection, vDirection, fromNudge) {
	        if (!this.lastDropTarget) {
	            return;
	        }
	        var dragLeaveEvent = this.createDropTargetEvent(this.lastDropTarget, mouseEvent, hDirection, vDirection, fromNudge);
	        this.lastDropTarget.onDragLeave(dragLeaveEvent);
	        this.setGhostIcon(null);
	    };
	    DragAndDropService.prototype.getAllContainersFromDropTarget = function (dropTarget) {
	        var containers = [dropTarget.getContainer()];
	        var secondaryContainers = dropTarget.getSecondaryContainers ? dropTarget.getSecondaryContainers() : null;
	        if (secondaryContainers) {
	            containers = containers.concat(secondaryContainers);
	        }
	        return containers;
	    };
	    // checks if the mouse is on the drop target. it checks eContainer and eSecondaryContainers
	    DragAndDropService.prototype.isMouseOnDropTarget = function (mouseEvent, dropTarget) {
	        var allContainers = this.getAllContainersFromDropTarget(dropTarget);
	        var mouseOverTarget = false;
	        allContainers.forEach(function (eContainer) {
	            if (!eContainer) {
	                return;
	            } // secondary can be missing
	            var rect = eContainer.getBoundingClientRect();
	            // if element is not visible, then width and height are zero
	            if (rect.width === 0 || rect.height === 0) {
	                return;
	            }
	            var horizontalFit = mouseEvent.clientX >= rect.left && mouseEvent.clientX <= rect.right;
	            var verticalFit = mouseEvent.clientY >= rect.top && mouseEvent.clientY <= rect.bottom;
	            //console.log(`rect.width = ${rect.width} || rect.height = ${rect.height} ## verticalFit = ${verticalFit}, horizontalFit = ${horizontalFit}, `);
	            if (horizontalFit && verticalFit) {
	                mouseOverTarget = true;
	            }
	        });
	        if (mouseOverTarget) {
	            var mouseOverTargetAndInterested = dropTarget.isInterestedIn(this.dragSource.type);
	            return mouseOverTargetAndInterested;
	        }
	        else {
	            return false;
	        }
	    };
	    DragAndDropService.prototype.addDropTarget = function (dropTarget) {
	        this.dropTargets.push(dropTarget);
	    };
	    DragAndDropService.prototype.workOutHDirection = function (event) {
	        if (this.eventLastTime.clientX > event.clientX) {
	            return HDirection.Left;
	        }
	        else if (this.eventLastTime.clientX < event.clientX) {
	            return HDirection.Right;
	        }
	        else {
	            return null;
	        }
	    };
	    DragAndDropService.prototype.workOutVDirection = function (event) {
	        if (this.eventLastTime.clientY > event.clientY) {
	            return VDirection.Up;
	        }
	        else if (this.eventLastTime.clientY < event.clientY) {
	            return VDirection.Down;
	        }
	        else {
	            return null;
	        }
	    };
	    DragAndDropService.prototype.createDropTargetEvent = function (dropTarget, event, hDirection, vDirection, fromNudge) {
	        // localise x and y to the target component
	        var rect = dropTarget.getContainer().getBoundingClientRect();
	        var x = event.clientX - rect.left;
	        var y = event.clientY - rect.top;
	        var dropTargetEvent = {
	            event: event,
	            x: x,
	            y: y,
	            vDirection: vDirection,
	            hDirection: hDirection,
	            dragSource: this.dragSource,
	            fromNudge: fromNudge,
	            dragItem: this.dragItem
	        };
	        return dropTargetEvent;
	    };
	    DragAndDropService.prototype.positionGhost = function (event) {
	        var ghostRect = this.eGhost.getBoundingClientRect();
	        var ghostHeight = ghostRect.height;
	        // for some reason, without the '-2', it still overlapped by 1 or 2 pixels, which
	        // then brought in scrollbars to the browser. no idea why, but putting in -2 here
	        // works around it which is good enough for me.
	        var browserWidth = utils_1._.getBodyWidth() - 2;
	        var browserHeight = utils_1._.getBodyHeight() - 2;
	        // put ghost vertically in middle of cursor
	        var top = event.pageY - (ghostHeight / 2);
	        // horizontally, place cursor just right of icon
	        var left = event.pageX - 30;
	        var usrDocument = this.gridOptionsWrapper.getDocument();
	        var windowScrollY = window.pageYOffset || usrDocument.documentElement.scrollTop;
	        var windowScrollX = window.pageXOffset || usrDocument.documentElement.scrollLeft;
	        // check ghost is not positioned outside of the browser
	        if (browserWidth > 0) {
	            if ((left + this.eGhost.clientWidth) > (browserWidth + windowScrollX)) {
	                left = browserWidth + windowScrollX - this.eGhost.clientWidth;
	            }
	        }
	        if (left < 0) {
	            left = 0;
	        }
	        if (browserHeight > 0) {
	            if ((top + this.eGhost.clientHeight) > (browserHeight + windowScrollY)) {
	                top = browserHeight + windowScrollY - this.eGhost.clientHeight;
	            }
	        }
	        if (top < 0) {
	            top = 0;
	        }
	        this.eGhost.style.left = left + 'px';
	        this.eGhost.style.top = top + 'px';
	    };
	    DragAndDropService.prototype.removeGhost = function () {
	        if (this.eGhost && this.eGhostParent) {
	            this.eGhostParent.removeChild(this.eGhost);
	        }
	        this.eGhost = null;
	    };
	    DragAndDropService.prototype.createGhost = function () {
	        this.eGhost = utils_1._.loadTemplate(DragAndDropService_1.GHOST_TEMPLATE);
	        var theme = this.environment.getTheme().theme;
	        if (theme) {
	            utils_1._.addCssClass(this.eGhost, theme);
	        }
	        this.eGhostIcon = this.eGhost.querySelector('.ag-dnd-ghost-icon');
	        this.setGhostIcon(null);
	        var eText = this.eGhost.querySelector('.ag-dnd-ghost-label');
	        eText.innerHTML = utils_1._.escape(this.dragSource.dragItemName);
	        this.eGhost.style.height = '25px';
	        this.eGhost.style.top = '20px';
	        this.eGhost.style.left = '20px';
	        var usrDocument = this.gridOptionsWrapper.getDocument();
	        this.eGhostParent = usrDocument.querySelector('body');
	        if (!this.eGhostParent) {
	            console.warn('ag-Grid: could not find document body, it is needed for dragging columns');
	        }
	        else {
	            this.eGhostParent.appendChild(this.eGhost);
	        }
	    };
	    DragAndDropService.prototype.setGhostIcon = function (iconName, shake) {
	        if (shake === void 0) { shake = false; }
	        utils_1._.clearElement(this.eGhostIcon);
	        var eIcon;
	        switch (iconName) {
	            case DragAndDropService_1.ICON_ADD:
	                eIcon = this.ePlusIcon;
	                break;
	            case DragAndDropService_1.ICON_PINNED:
	                eIcon = this.ePinnedIcon;
	                break;
	            case DragAndDropService_1.ICON_MOVE:
	                eIcon = this.eMoveIcon;
	                break;
	            case DragAndDropService_1.ICON_LEFT:
	                eIcon = this.eLeftIcon;
	                break;
	            case DragAndDropService_1.ICON_RIGHT:
	                eIcon = this.eRightIcon;
	                break;
	            case DragAndDropService_1.ICON_GROUP:
	                eIcon = this.eGroupIcon;
	                break;
	            case DragAndDropService_1.ICON_AGGREGATE:
	                eIcon = this.eAggregateIcon;
	                break;
	            case DragAndDropService_1.ICON_PIVOT:
	                eIcon = this.ePivotIcon;
	                break;
	            case DragAndDropService_1.ICON_NOT_ALLOWED:
	                eIcon = this.eDropNotAllowedIcon;
	                break;
	            default:
	                eIcon = this.eHiddenIcon;
	                break;
	        }
	        this.eGhostIcon.appendChild(eIcon);
	        utils_1._.addOrRemoveCssClass(this.eGhostIcon, 'ag-shake-left-to-right', shake);
	    };
	    var DragAndDropService_1;
	    DragAndDropService.ICON_PINNED = 'pinned';
	    DragAndDropService.ICON_ADD = 'add';
	    DragAndDropService.ICON_MOVE = 'move';
	    DragAndDropService.ICON_LEFT = 'left';
	    DragAndDropService.ICON_RIGHT = 'right';
	    DragAndDropService.ICON_GROUP = 'group';
	    DragAndDropService.ICON_AGGREGATE = 'aggregate';
	    DragAndDropService.ICON_PIVOT = 'pivot';
	    DragAndDropService.ICON_NOT_ALLOWED = 'notAllowed';
	    DragAndDropService.GHOST_TEMPLATE = '<div class="ag-dnd-ghost">' +
	        '  <span class="ag-dnd-ghost-icon ag-shake-left-to-right"></span>' +
	        '  <div class="ag-dnd-ghost-label">' +
	        '  </div>' +
	        '</div>';
	    __decorate([
	        context_1.Autowired('gridOptionsWrapper'),
	        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
	    ], DragAndDropService.prototype, "gridOptionsWrapper", void 0);
	    __decorate([
	        context_1.Autowired('dragService'),
	        __metadata("design:type", dragService_1.DragService)
	    ], DragAndDropService.prototype, "dragService", void 0);
	    __decorate([
	        context_1.Autowired('environment'),
	        __metadata("design:type", environment_1.Environment)
	    ], DragAndDropService.prototype, "environment", void 0);
	    __decorate([
	        context_1.Autowired('columnController'),
	        __metadata("design:type", columnController_1.ColumnController)
	    ], DragAndDropService.prototype, "columnController", void 0);
	    __decorate([
	        context_1.PostConstruct,
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", []),
	        __metadata("design:returntype", void 0)
	    ], DragAndDropService.prototype, "init", null);
	    __decorate([
	        __param(0, context_1.Qualifier('loggerFactory')),
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", [logger_1.LoggerFactory]),
	        __metadata("design:returntype", void 0)
	    ], DragAndDropService.prototype, "setBeans", null);
	    __decorate([
	        context_1.PreDestroy,
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", []),
	        __metadata("design:returntype", void 0)
	    ], DragAndDropService.prototype, "destroy", null);
	    DragAndDropService = DragAndDropService_1 = __decorate([
	        context_1.Bean('dragAndDropService')
	    ], DragAndDropService);
	    return DragAndDropService;
	}());
	exports.DragAndDropService = DragAndDropService;


/***/ }),
/* 2364 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var context_1 = __webpack_require__(2333);
	var logger_1 = __webpack_require__(2332);
	var eventService_1 = __webpack_require__(2331);
	var events_1 = __webpack_require__(2335);
	var gridOptionsWrapper_1 = __webpack_require__(2324);
	var columnApi_1 = __webpack_require__(2346);
	var gridApi_1 = __webpack_require__(2338);
	var utils_1 = __webpack_require__(2325);
	/** Adds drag listening onto an element. In ag-Grid this is used twice, first is resizing columns,
	 * second is moving the columns and column groups around (ie the 'drag' part of Drag and Drop. */
	var DragService = /** @class */ (function () {
	    function DragService() {
	        this.onMouseUpListener = this.onMouseUp.bind(this);
	        this.onMouseMoveListener = this.onMouseMove.bind(this);
	        this.onTouchEndListener = this.onTouchUp.bind(this);
	        this.onTouchMoveListener = this.onTouchMove.bind(this);
	        this.dragEndFunctions = [];
	        this.dragSources = [];
	    }
	    DragService.prototype.init = function () {
	        this.logger = this.loggerFactory.create('DragService');
	    };
	    DragService.prototype.destroy = function () {
	        this.dragSources.forEach(this.removeListener.bind(this));
	        this.dragSources.length = 0;
	    };
	    DragService.prototype.removeListener = function (dragSourceAndListener) {
	        var element = dragSourceAndListener.dragSource.eElement;
	        var mouseDownListener = dragSourceAndListener.mouseDownListener;
	        element.removeEventListener('mousedown', mouseDownListener);
	        // remove touch listener only if it exists
	        if (dragSourceAndListener.touchEnabled) {
	            var touchStartListener = dragSourceAndListener.touchStartListener;
	            element.removeEventListener('touchstart', touchStartListener, { passive: true });
	        }
	    };
	    DragService.prototype.removeDragSource = function (params) {
	        var dragSourceAndListener = utils_1._.find(this.dragSources, function (item) { return item.dragSource === params; });
	        if (!dragSourceAndListener) {
	            return;
	        }
	        this.removeListener(dragSourceAndListener);
	        utils_1._.removeFromArray(this.dragSources, dragSourceAndListener);
	    };
	    DragService.prototype.setNoSelectToBody = function (noSelect) {
	        var eDocument = this.gridOptionsWrapper.getDocument();
	        var eBody = eDocument.querySelector('body');
	        if (utils_1._.exists(eBody)) {
	            // when we drag the mouse in ag-Grid, this class gets added / removed from the body, so that
	            // the mouse isn't selecting text when dragging.
	            utils_1._.addOrRemoveCssClass(eBody, 'ag-unselectable', noSelect);
	        }
	    };
	    DragService.prototype.addDragSource = function (params, includeTouch) {
	        if (includeTouch === void 0) { includeTouch = false; }
	        var mouseListener = this.onMouseDown.bind(this, params);
	        params.eElement.addEventListener('mousedown', mouseListener);
	        var touchListener = null;
	        var suppressTouch = this.gridOptionsWrapper.isSuppressTouch();
	        if (includeTouch && !suppressTouch) {
	            touchListener = this.onTouchStart.bind(this, params);
	            params.eElement.addEventListener('touchstart', touchListener, { passive: false });
	        }
	        this.dragSources.push({
	            dragSource: params,
	            mouseDownListener: mouseListener,
	            touchStartListener: touchListener,
	            touchEnabled: includeTouch
	        });
	    };
	    // gets called whenever mouse down on any drag source
	    DragService.prototype.onTouchStart = function (params, touchEvent) {
	        var _this = this;
	        this.currentDragParams = params;
	        this.dragging = false;
	        var touch = touchEvent.touches[0];
	        this.touchLastTime = touch;
	        this.touchStart = touch;
	        touchEvent.preventDefault();
	        // we temporally add these listeners, for the duration of the drag, they
	        // are removed in touch end handling.
	        params.eElement.addEventListener('touchmove', this.onTouchMoveListener, { passive: true });
	        params.eElement.addEventListener('touchend', this.onTouchEndListener, { passive: true });
	        params.eElement.addEventListener('touchcancel', this.onTouchEndListener, { passive: true });
	        this.dragEndFunctions.push(function () {
	            params.eElement.removeEventListener('touchmove', _this.onTouchMoveListener, { passive: true });
	            params.eElement.removeEventListener('touchend', _this.onTouchEndListener, { passive: true });
	            params.eElement.removeEventListener('touchcancel', _this.onTouchEndListener, { passive: true });
	        });
	        // see if we want to start dragging straight away
	        if (params.dragStartPixels === 0) {
	            this.onCommonMove(touch, this.touchStart);
	        }
	    };
	    // gets called whenever mouse down on any drag source
	    DragService.prototype.onMouseDown = function (params, mouseEvent) {
	        var _this = this;
	        // we ignore when shift key is pressed. this is for the range selection, as when
	        // user shift-clicks a cell, this should not be interpreted as the start of a drag.
	        // if (mouseEvent.shiftKey) { return; }
	        if (params.skipMouseEvent) {
	            if (params.skipMouseEvent(mouseEvent)) {
	                return;
	            }
	        }
	        // if there are two elements with parent / child relationship, and both are draggable,
	        // when we drag the child, we should NOT drag the parent. an example of this is row moving
	        // and range selection - row moving should get preference when use drags the rowDrag component.
	        if (mouseEvent._alreadyProcessedByDragService) {
	            return;
	        }
	        mouseEvent._alreadyProcessedByDragService = true;
	        // only interested in left button clicks
	        if (mouseEvent.button !== 0) {
	            return;
	        }
	        this.currentDragParams = params;
	        this.dragging = false;
	        this.mouseStartEvent = mouseEvent;
	        var eDocument = this.gridOptionsWrapper.getDocument();
	        this.setNoSelectToBody(true);
	        // we temporally add these listeners, for the duration of the drag, they
	        // are removed in mouseup handling.
	        eDocument.addEventListener('mousemove', this.onMouseMoveListener);
	        eDocument.addEventListener('mouseup', this.onMouseUpListener);
	        this.dragEndFunctions.push(function () {
	            eDocument.removeEventListener('mousemove', _this.onMouseMoveListener);
	            eDocument.removeEventListener('mouseup', _this.onMouseUpListener);
	        });
	        //see if we want to start dragging straight away
	        if (params.dragStartPixels === 0) {
	            this.onMouseMove(mouseEvent);
	        }
	    };
	    // returns true if the event is close to the original event by X pixels either vertically or horizontally.
	    // we only start dragging after X pixels so this allows us to know if we should start dragging yet.
	    DragService.prototype.isEventNearStartEvent = function (currentEvent, startEvent) {
	        // by default, we wait 4 pixels before starting the drag
	        var dragStartPixels = this.currentDragParams.dragStartPixels;
	        var requiredPixelDiff = utils_1._.exists(dragStartPixels) ? dragStartPixels : 4;
	        return utils_1._.areEventsNear(currentEvent, startEvent, requiredPixelDiff);
	    };
	    DragService.prototype.getFirstActiveTouch = function (touchList) {
	        for (var i = 0; i < touchList.length; i++) {
	            if (touchList[i].identifier === this.touchStart.identifier) {
	                return touchList[i];
	            }
	        }
	        return null;
	    };
	    DragService.prototype.onCommonMove = function (currentEvent, startEvent) {
	        if (!this.dragging) {
	            // if mouse hasn't travelled from the start position enough, do nothing
	            if (!this.dragging && this.isEventNearStartEvent(currentEvent, startEvent)) {
	                return;
	            }
	            this.dragging = true;
	            var event_1 = {
	                type: events_1.Events.EVENT_DRAG_STARTED,
	                api: this.gridApi,
	                columnApi: this.columnApi
	            };
	            this.eventService.dispatchEvent(event_1);
	            this.currentDragParams.onDragStart(startEvent);
	        }
	        this.currentDragParams.onDragging(currentEvent);
	    };
	    DragService.prototype.onTouchMove = function (touchEvent) {
	        var touch = this.getFirstActiveTouch(touchEvent.touches);
	        if (!touch) {
	            return;
	        }
	        // this.___statusPanel.setInfoText(Math.random() + ' onTouchMove preventDefault stopPropagation');
	        // if we don't preview default, then the browser will try and do it's own touch stuff,
	        // like do 'back button' (chrome does this) or scroll the page (eg drag column could  be confused
	        // with scroll page in the app)
	        // touchEvent.preventDefault();
	        this.onCommonMove(touch, this.touchStart);
	    };
	    // only gets called after a mouse down - as this is only added after mouseDown
	    // and is removed when mouseUp happens
	    DragService.prototype.onMouseMove = function (mouseEvent) {
	        this.onCommonMove(mouseEvent, this.mouseStartEvent);
	    };
	    DragService.prototype.onTouchUp = function (touchEvent) {
	        var touch = this.getFirstActiveTouch(touchEvent.changedTouches);
	        // i haven't worked this out yet, but there is no matching touch
	        // when we get the touch up event. to get around this, we swap in
	        // the last touch. this is a hack to 'get it working' while we
	        // figure out what's going on, why we are not getting a touch in
	        // current event.
	        if (!touch) {
	            touch = this.touchLastTime;
	        }
	        // if mouse was left up before we started to move, then this is a tap.
	        // we check this before onUpCommon as onUpCommon resets the dragging
	        // let tap = !this.dragging;
	        // let tapTarget = this.currentDragParams.eElement;
	        this.onUpCommon(touch);
	        // if tap, tell user
	        // console.log(`${Math.random()} tap = ${tap}`);
	        // if (tap) {
	        //     tapTarget.click();
	        // }
	    };
	    DragService.prototype.onMouseUp = function (mouseEvent) {
	        this.onUpCommon(mouseEvent);
	    };
	    DragService.prototype.onUpCommon = function (eventOrTouch) {
	        if (this.dragging) {
	            this.dragging = false;
	            this.currentDragParams.onDragStop(eventOrTouch);
	            var event_2 = {
	                type: events_1.Events.EVENT_DRAG_STOPPED,
	                api: this.gridApi,
	                columnApi: this.columnApi
	            };
	            this.eventService.dispatchEvent(event_2);
	        }
	        this.setNoSelectToBody(false);
	        this.mouseStartEvent = null;
	        this.touchStart = null;
	        this.touchLastTime = null;
	        this.currentDragParams = null;
	        this.dragEndFunctions.forEach(function (func) { return func(); });
	        this.dragEndFunctions.length = 0;
	    };
	    __decorate([
	        context_1.Autowired('loggerFactory'),
	        __metadata("design:type", logger_1.LoggerFactory)
	    ], DragService.prototype, "loggerFactory", void 0);
	    __decorate([
	        context_1.Autowired('eventService'),
	        __metadata("design:type", eventService_1.EventService)
	    ], DragService.prototype, "eventService", void 0);
	    __decorate([
	        context_1.Autowired('gridOptionsWrapper'),
	        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
	    ], DragService.prototype, "gridOptionsWrapper", void 0);
	    __decorate([
	        context_1.Autowired('columnApi'),
	        __metadata("design:type", columnApi_1.ColumnApi)
	    ], DragService.prototype, "columnApi", void 0);
	    __decorate([
	        context_1.Autowired('gridApi'),
	        __metadata("design:type", gridApi_1.GridApi)
	    ], DragService.prototype, "gridApi", void 0);
	    __decorate([
	        context_1.PostConstruct,
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", []),
	        __metadata("design:returntype", void 0)
	    ], DragService.prototype, "init", null);
	    __decorate([
	        context_1.PreDestroy,
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", []),
	        __metadata("design:returntype", void 0)
	    ], DragService.prototype, "destroy", null);
	    DragService = __decorate([
	        context_1.Bean('dragService')
	    ], DragService);
	    return DragService;
	}());
	exports.DragService = DragService;


/***/ }),
/* 2365 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var context_1 = __webpack_require__(2333);
	var utils_1 = __webpack_require__(2325);
	var MAT_GRID_SIZE = 8;
	var FRESH_GRID_SIZE = 4;
	var BALHAM_GRID_SIZE = 4;
	var HARD_CODED_SIZES = {
	    'ag-theme-material': {
	        headerHeight: MAT_GRID_SIZE * 7,
	        virtualItemHeight: MAT_GRID_SIZE * 5,
	        rowHeight: MAT_GRID_SIZE * 6
	    },
	    'ag-theme-classic': {
	        headerHeight: 25,
	        virtualItemHeight: FRESH_GRID_SIZE * 5,
	        rowHeight: 25
	    },
	    'ag-theme-balham': {
	        headerHeight: BALHAM_GRID_SIZE * 8,
	        virtualItemHeight: BALHAM_GRID_SIZE * 7,
	        rowHeight: BALHAM_GRID_SIZE * 7
	    }
	};
	/**
	 * this object contains a list of Sass variables and an array
	 * of CSS styles required to get the correct value.
	 * eg. $virtual-item-height requires a structure, so we can get it's height.
	 * <div class="ag-theme-balham">
	 *     <div class="ag-virtual-list-container">
	 *         <div class="ag-virtual-list-item"></div>
	 *     </div>
	 */
	var SASS_PROPERTY_BUILDER = {
	    headerHeight: ['ag-header-row'],
	    virtualItemHeight: ['ag-virtual-list-container', 'ag-virtual-list-item'],
	    rowHeight: ['ag-row']
	};
	var CALCULATED_SIZES = {};
	var Environment = /** @class */ (function () {
	    function Environment() {
	    }
	    Environment.prototype.getSassVariable = function (theme, key) {
	        var useTheme = 'ag-theme-' + (theme.match('material') ? 'material' : (theme.match('balham') ? 'balham' : 'classic'));
	        var defaultValue = HARD_CODED_SIZES[useTheme][key];
	        var calculatedValue = 0;
	        if (!CALCULATED_SIZES[theme]) {
	            CALCULATED_SIZES[theme] = {};
	        }
	        if (CALCULATED_SIZES[theme][key]) {
	            return CALCULATED_SIZES[theme][key];
	        }
	        if (SASS_PROPERTY_BUILDER[key]) {
	            var classList = SASS_PROPERTY_BUILDER[key];
	            var div = document.createElement('div');
	            var el = classList.reduce(function (el, currentClass, idx) {
	                if (idx === 0) {
	                    utils_1._.addCssClass(el, theme);
	                }
	                var div = document.createElement('div');
	                utils_1._.addCssClass(div, currentClass);
	                el.appendChild(div);
	                return div;
	            }, div);
	            if (document.body) {
	                document.body.appendChild(div);
	                calculatedValue = parseInt(window.getComputedStyle(el).height, 10);
	                document.body.removeChild(div);
	            }
	        }
	        CALCULATED_SIZES[theme][key] = calculatedValue || defaultValue;
	        return CALCULATED_SIZES[theme][key];
	    };
	    Environment.prototype.isThemeDark = function () {
	        var theme = this.getTheme().theme;
	        return !!theme && theme.indexOf('dark') >= 0;
	    };
	    Environment.prototype.getTheme = function () {
	        var reg = /\bag-(fresh|dark|blue|material|bootstrap|(?:theme-([\w\-]*)))\b/;
	        var el = this.eGridDiv;
	        var themeMatch;
	        while (el) {
	            themeMatch = reg.exec(el.className);
	            if (!themeMatch) {
	                el = el.parentElement;
	            }
	            else {
	                break;
	            }
	        }
	        if (!themeMatch) {
	            return {};
	        }
	        var theme = themeMatch[0];
	        var usingOldTheme = themeMatch[2] === undefined;
	        if (usingOldTheme) {
	            var newTheme_1 = theme.replace('ag-', 'ag-theme-');
	            utils_1._.doOnce(function () { return console.warn("ag-Grid: As of v19 old theme are no longer provided. Please replace " + theme + " with " + newTheme_1 + "."); }, 'using-old-theme');
	        }
	        return { theme: theme, el: el };
	    };
	    __decorate([
	        context_1.Autowired('eGridDiv'),
	        __metadata("design:type", HTMLElement)
	    ], Environment.prototype, "eGridDiv", void 0);
	    Environment = __decorate([
	        context_1.Bean('environment')
	    ], Environment);
	    return Environment;
	}());
	exports.Environment = Environment;


/***/ }),
/* 2366 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var popupComponent_1 = __webpack_require__(2367);
	var context_1 = __webpack_require__(2333);
	var gridOptionsWrapper_1 = __webpack_require__(2324);
	var utils_1 = __webpack_require__(2325);
	var PopupEditorWrapper = /** @class */ (function (_super) {
	    __extends(PopupEditorWrapper, _super);
	    function PopupEditorWrapper(cellEditor) {
	        var _this = _super.call(this, "<div class=\"ag-popup-editor\" tabindex=\"-1\"/>") || this;
	        _this.getGuiCalledOnChild = false;
	        _this.cellEditor = cellEditor;
	        return _this;
	    }
	    PopupEditorWrapper.prototype.onKeyDown = function (event) {
	        if (!utils_1._.isUserSuppressingKeyboardEvent(this.gridOptionsWrapper, event, this.params.node, this.params.column, true)) {
	            this.params.onKeyDown(event);
	        }
	    };
	    PopupEditorWrapper.prototype.getGui = function () {
	        // we call getGui() on child here (rather than in the constructor)
	        // as we should wait for 'init' to be called on child first.
	        if (!this.getGuiCalledOnChild) {
	            this.appendChild(this.cellEditor.getGui());
	            this.getGuiCalledOnChild = true;
	        }
	        return _super.prototype.getGui.call(this);
	    };
	    PopupEditorWrapper.prototype.init = function (params) {
	        var _this = this;
	        this.params = params;
	        this.gridOptionsWrapper.setDomData(this.getGui(), PopupEditorWrapper.DOM_KEY_POPUP_EDITOR_WRAPPER, true);
	        this.addDestroyFunc(function () {
	            if (_this.cellEditor.destroy) {
	                _this.cellEditor.destroy();
	            }
	        });
	        this.addDestroyableEventListener(
	        // this needs to be 'super' and not 'this' as if we call 'this',
	        // it ends up called 'getGui()' on the child before 'init' was called,
	        // which is not good
	        _super.prototype.getGui.call(this), 'keydown', this.onKeyDown.bind(this));
	    };
	    PopupEditorWrapper.prototype.afterGuiAttached = function () {
	        if (this.cellEditor.afterGuiAttached) {
	            this.cellEditor.afterGuiAttached();
	        }
	    };
	    PopupEditorWrapper.prototype.getValue = function () {
	        return this.cellEditor.getValue();
	    };
	    PopupEditorWrapper.prototype.isCancelBeforeStart = function () {
	        if (this.cellEditor.isCancelBeforeStart) {
	            return this.cellEditor.isCancelBeforeStart();
	        }
	    };
	    PopupEditorWrapper.prototype.isCancelAfterEnd = function () {
	        if (this.cellEditor.isCancelAfterEnd) {
	            return this.cellEditor.isCancelAfterEnd();
	        }
	    };
	    PopupEditorWrapper.prototype.focusIn = function () {
	        if (this.cellEditor.focusIn) {
	            this.cellEditor.focusIn();
	        }
	    };
	    PopupEditorWrapper.prototype.focusOut = function () {
	        if (this.cellEditor.focusOut) {
	            this.cellEditor.focusOut();
	        }
	    };
	    PopupEditorWrapper.DOM_KEY_POPUP_EDITOR_WRAPPER = 'popupEditorWrapper';
	    __decorate([
	        context_1.Autowired('gridOptionsWrapper'),
	        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
	    ], PopupEditorWrapper.prototype, "gridOptionsWrapper", void 0);
	    return PopupEditorWrapper;
	}(popupComponent_1.PopupComponent));
	exports.PopupEditorWrapper = PopupEditorWrapper;


/***/ }),
/* 2367 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var component_1 = __webpack_require__(2353);
	var utils_1 = __webpack_require__(2325);
	var PopupComponent = /** @class */ (function (_super) {
	    __extends(PopupComponent, _super);
	    function PopupComponent() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    PopupComponent.prototype.isPopup = function () {
	        return true;
	    };
	    PopupComponent.prototype.setParentComponent = function (container) {
	        utils_1._.addCssClass(container.getGui(), 'ag-has-popup');
	        _super.prototype.setParentComponent.call(this, container);
	    };
	    PopupComponent.prototype.destroy = function () {
	        var parentComp = this.parentComponent;
	        var hasParent = parentComp && parentComp.isAlive();
	        if (hasParent) {
	            utils_1._.removeCssClass(parentComp.getGui(), 'ag-has-popup');
	        }
	        _super.prototype.destroy.call(this);
	    };
	    return PopupComponent;
	}(component_1.Component));
	exports.PopupComponent = PopupComponent;


/***/ }),
/* 2368 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var component_1 = __webpack_require__(2353);
	var context_1 = __webpack_require__(2333);
	var utils_1 = __webpack_require__(2325);
	var DndSourceComp = /** @class */ (function (_super) {
	    __extends(DndSourceComp, _super);
	    function DndSourceComp(rowNode, column, cellValue, beans, eCell) {
	        var _this = _super.call(this, "<div class=\"ag-row-drag\" draggable=\"true\"></div>") || this;
	        _this.rowNode = rowNode;
	        _this.column = column;
	        _this.cellValue = cellValue;
	        _this.beans = beans;
	        _this.eCell = eCell;
	        return _this;
	    }
	    DndSourceComp.prototype.postConstruct = function () {
	        var eGui = this.getGui();
	        eGui.appendChild(utils_1._.createIconNoSpan('rowDrag', this.beans.gridOptionsWrapper, null));
	        this.addDragSource();
	        this.checkVisibility();
	    };
	    DndSourceComp.prototype.addDragSource = function () {
	        this.addGuiEventListener('dragstart', this.onDragStart.bind(this));
	    };
	    DndSourceComp.prototype.onDragStart = function (dragEvent) {
	        var _this = this;
	        var providedOnRowDrag = this.column.getColDef().dndSourceOnRowDrag;
	        var isIE = utils_1._.isBrowserIE();
	        if (!isIE) {
	            dragEvent.dataTransfer.setDragImage(this.eCell, 0, 0);
	        }
	        // default behaviour is to convert data to json and set into drag component
	        var defaultOnRowDrag = function () {
	            try {
	                var jsonData = JSON.stringify(_this.rowNode.data);
	                if (isIE) {
	                    dragEvent.dataTransfer.setData('text', jsonData);
	                }
	                else {
	                    dragEvent.dataTransfer.setData('application/json', jsonData);
	                    dragEvent.dataTransfer.setData('text/plain', jsonData);
	                }
	            }
	            catch (e) {
	                // if we cannot convert the data to json, then we do not set the type
	            }
	        };
	        if (providedOnRowDrag) {
	            providedOnRowDrag({ rowNode: this.rowNode, dragEvent: dragEvent });
	        }
	        else {
	            defaultOnRowDrag();
	        }
	    };
	    DndSourceComp.prototype.checkVisibility = function () {
	        var visible = this.column.isDndSource(this.rowNode);
	        this.setDisplayed(visible);
	    };
	    __decorate([
	        context_1.PostConstruct,
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", []),
	        __metadata("design:returntype", void 0)
	    ], DndSourceComp.prototype, "postConstruct", null);
	    return DndSourceComp;
	}(component_1.Component));
	exports.DndSourceComp = DndSourceComp;


/***/ }),
/* 2369 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var context_1 = __webpack_require__(2333);
	var eventService_1 = __webpack_require__(2331);
	var events_1 = __webpack_require__(2335);
	var gridOptionsWrapper_1 = __webpack_require__(2324);
	var columnApi_1 = __webpack_require__(2346);
	var columnController_1 = __webpack_require__(2341);
	var gridApi_1 = __webpack_require__(2338);
	var cellComp_1 = __webpack_require__(2352);
	var utils_1 = __webpack_require__(2325);
	var FocusedCellController = /** @class */ (function () {
	    function FocusedCellController() {
	    }
	    FocusedCellController.prototype.init = function () {
	        this.eventService.addEventListener(events_1.Events.EVENT_COLUMN_PIVOT_MODE_CHANGED, this.clearFocusedCell.bind(this));
	        this.eventService.addEventListener(events_1.Events.EVENT_COLUMN_EVERYTHING_CHANGED, this.clearFocusedCell.bind(this));
	        this.eventService.addEventListener(events_1.Events.EVENT_COLUMN_GROUP_OPENED, this.clearFocusedCell.bind(this));
	        this.eventService.addEventListener(events_1.Events.EVENT_COLUMN_ROW_GROUP_CHANGED, this.clearFocusedCell.bind(this));
	        // we used to remove focus when moving column, am not sure why. so taking this out and see who complains.
	        // we can delete these three lines of code soon.
	        // this.eventService.addEventListener(Events.EVENT_COLUMN_MOVED, this.clearFocusedCell.bind(this));
	        // this.eventService.addEventListener(Events.EVENT_COLUMN_PINNED, this.clearFocusedCell.bind(this));
	        // this.eventService.addEventListener(Events.EVENT_COLUMN_VISIBLE, this.clearFocusedCell.bind(this));
	    };
	    FocusedCellController.prototype.clearFocusedCell = function () {
	        this.focusedCellPosition = null;
	        this.onCellFocused(false);
	    };
	    FocusedCellController.prototype.getFocusedCell = function () {
	        return this.focusedCellPosition;
	    };
	    // we check if the browser is focusing something, and if it is, and
	    // it's the cell we think is focused, then return the cell. so this
	    // methods returns the cell if a) we think it has focus and b) the
	    // browser thinks it has focus. this then returns nothing if we
	    // first focus a cell, then second click outside the grid, as then the
	    // grid cell will still be focused as far as the grid is concerned,
	    // however the browser focus will have moved somewhere else.
	    FocusedCellController.prototype.getFocusCellToUseAfterRefresh = function () {
	        if (this.gridOptionsWrapper.isSuppressFocusAfterRefresh()) {
	            return null;
	        }
	        if (!this.focusedCellPosition) {
	            return null;
	        }
	        // we check that the browser is actually focusing on the grid, if it is not, then
	        // we have nothing to worry about
	        var browserFocusedCell = this.getGridCellForDomElement(document.activeElement);
	        if (!browserFocusedCell) {
	            return null;
	        }
	        return this.focusedCellPosition;
	    };
	    FocusedCellController.prototype.getGridCellForDomElement = function (eBrowserCell) {
	        var ePointer = eBrowserCell;
	        while (ePointer) {
	            var cellComp = this.gridOptionsWrapper.getDomData(ePointer, cellComp_1.CellComp.DOM_DATA_KEY_CELL_COMP);
	            if (cellComp) {
	                return cellComp.getCellPosition();
	            }
	            ePointer = ePointer.parentNode;
	        }
	        return null;
	    };
	    FocusedCellController.prototype.setFocusedCell = function (rowIndex, colKey, floating, forceBrowserFocus) {
	        if (forceBrowserFocus === void 0) { forceBrowserFocus = false; }
	        var column = utils_1._.makeNull(this.columnController.getGridColumn(colKey));
	        this.focusedCellPosition = { rowIndex: rowIndex, rowPinned: utils_1._.makeNull(floating), column: column };
	        this.onCellFocused(forceBrowserFocus);
	    };
	    FocusedCellController.prototype.isCellFocused = function (cellPosition) {
	        if (utils_1._.missing(this.focusedCellPosition)) {
	            return false;
	        }
	        return this.focusedCellPosition.column === cellPosition.column && this.isRowFocused(cellPosition.rowIndex, cellPosition.rowPinned);
	    };
	    FocusedCellController.prototype.isRowNodeFocused = function (rowNode) {
	        return this.isRowFocused(rowNode.rowIndex, rowNode.rowPinned);
	    };
	    FocusedCellController.prototype.isAnyCellFocused = function () {
	        return !!this.focusedCellPosition;
	    };
	    FocusedCellController.prototype.isRowFocused = function (rowIndex, floating) {
	        if (utils_1._.missing(this.focusedCellPosition)) {
	            return false;
	        }
	        var floatingOrNull = utils_1._.makeNull(floating);
	        return this.focusedCellPosition.rowIndex === rowIndex && this.focusedCellPosition.rowPinned === floatingOrNull;
	    };
	    FocusedCellController.prototype.onCellFocused = function (forceBrowserFocus) {
	        var event = {
	            type: events_1.Events.EVENT_CELL_FOCUSED,
	            forceBrowserFocus: forceBrowserFocus,
	            rowIndex: null,
	            column: null,
	            floating: null,
	            api: this.gridApi,
	            columnApi: this.columnApi,
	            rowPinned: null
	        };
	        if (this.focusedCellPosition) {
	            event.rowIndex = this.focusedCellPosition.rowIndex;
	            event.column = this.focusedCellPosition.column;
	            event.rowPinned = this.focusedCellPosition.rowPinned;
	        }
	        this.eventService.dispatchEvent(event);
	    };
	    __decorate([
	        context_1.Autowired('eventService'),
	        __metadata("design:type", eventService_1.EventService)
	    ], FocusedCellController.prototype, "eventService", void 0);
	    __decorate([
	        context_1.Autowired('gridOptionsWrapper'),
	        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
	    ], FocusedCellController.prototype, "gridOptionsWrapper", void 0);
	    __decorate([
	        context_1.Autowired('columnController'),
	        __metadata("design:type", columnController_1.ColumnController)
	    ], FocusedCellController.prototype, "columnController", void 0);
	    __decorate([
	        context_1.Autowired('columnApi'),
	        __metadata("design:type", columnApi_1.ColumnApi)
	    ], FocusedCellController.prototype, "columnApi", void 0);
	    __decorate([
	        context_1.Autowired('gridApi'),
	        __metadata("design:type", gridApi_1.GridApi)
	    ], FocusedCellController.prototype, "gridApi", void 0);
	    __decorate([
	        context_1.PostConstruct,
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", []),
	        __metadata("design:returntype", void 0)
	    ], FocusedCellController.prototype, "init", null);
	    FocusedCellController = __decorate([
	        context_1.Bean('focusedCellController')
	    ], FocusedCellController);
	    return FocusedCellController;
	}());
	exports.FocusedCellController = FocusedCellController;


/***/ }),
/* 2370 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var context_1 = __webpack_require__(2333);
	var constants_1 = __webpack_require__(2328);
	var columnController_1 = __webpack_require__(2341);
	var gridOptionsWrapper_1 = __webpack_require__(2324);
	var pinnedRowModel_1 = __webpack_require__(2371);
	var utils_1 = __webpack_require__(2325);
	var CellNavigationService = /** @class */ (function () {
	    function CellNavigationService() {
	    }
	    // returns null if no cell to focus on, ie at the end of the grid
	    CellNavigationService.prototype.getNextCellToFocus = function (key, lastCellToFocus) {
	        // starting with the provided cell, we keep moving until we find a cell we can
	        // focus on.
	        var pointer = lastCellToFocus;
	        var finished = false;
	        // finished will be true when either:
	        // a) cell found that we can focus on
	        // b) run out of cells (ie the method returns null)
	        while (!finished) {
	            switch (key) {
	                case constants_1.Constants.KEY_UP:
	                    pointer = this.getCellAbove(pointer);
	                    break;
	                case constants_1.Constants.KEY_DOWN:
	                    pointer = this.getCellBelow(pointer);
	                    break;
	                case constants_1.Constants.KEY_RIGHT:
	                    if (this.gridOptionsWrapper.isEnableRtl()) {
	                        pointer = this.getCellToLeft(pointer);
	                    }
	                    else {
	                        pointer = this.getCellToRight(pointer);
	                    }
	                    break;
	                case constants_1.Constants.KEY_LEFT:
	                    if (this.gridOptionsWrapper.isEnableRtl()) {
	                        pointer = this.getCellToRight(pointer);
	                    }
	                    else {
	                        pointer = this.getCellToLeft(pointer);
	                    }
	                    break;
	                default:
	                    pointer = null;
	                    console.warn('ag-Grid: unknown key for navigation ' + key);
	                    break;
	            }
	            if (pointer) {
	                finished = this.isCellGoodToFocusOn(pointer);
	            }
	            else {
	                finished = true;
	            }
	        }
	        return pointer;
	    };
	    CellNavigationService.prototype.isCellGoodToFocusOn = function (gridCell) {
	        var column = gridCell.column;
	        var rowNode;
	        switch (gridCell.rowPinned) {
	            case constants_1.Constants.PINNED_TOP:
	                rowNode = this.pinnedRowModel.getPinnedTopRow(gridCell.rowIndex);
	                break;
	            case constants_1.Constants.PINNED_BOTTOM:
	                rowNode = this.pinnedRowModel.getPinnedBottomRow(gridCell.rowIndex);
	                break;
	            default:
	                rowNode = this.rowModel.getRow(gridCell.rowIndex);
	                break;
	        }
	        var suppressNavigable = column.isSuppressNavigable(rowNode);
	        return !suppressNavigable;
	    };
	    CellNavigationService.prototype.getCellToLeft = function (lastCell) {
	        if (!lastCell) {
	            return null;
	        }
	        var colToLeft = this.columnController.getDisplayedColBefore(lastCell.column);
	        if (!colToLeft) {
	            return null;
	        }
	        return {
	            rowIndex: lastCell.rowIndex,
	            column: colToLeft,
	            rowPinned: lastCell.rowPinned
	        };
	    };
	    CellNavigationService.prototype.getCellToRight = function (lastCell) {
	        if (!lastCell) {
	            return null;
	        }
	        var colToRight = this.columnController.getDisplayedColAfter(lastCell.column);
	        // if already on right, do nothing
	        if (!colToRight) {
	            return null;
	        }
	        return {
	            rowIndex: lastCell.rowIndex,
	            column: colToRight,
	            rowPinned: lastCell.rowPinned
	        };
	    };
	    CellNavigationService.prototype.getRowBelow = function (rowPosition) {
	        // if already on top row, do nothing
	        var index = rowPosition.rowIndex;
	        var pinned = rowPosition.rowPinned;
	        if (this.isLastRowInContainer(rowPosition)) {
	            switch (pinned) {
	                case constants_1.Constants.PINNED_BOTTOM:
	                    // never any rows after pinned bottom
	                    return null;
	                case constants_1.Constants.PINNED_TOP:
	                    // if on last row of pinned top, then next row is main body (if rows exist),
	                    // otherwise it's the pinned bottom
	                    if (this.rowModel.isRowsToRender()) {
	                        return { rowIndex: 0, rowPinned: null };
	                    }
	                    else if (this.pinnedRowModel.isRowsToRender(constants_1.Constants.PINNED_BOTTOM)) {
	                        return { rowIndex: 0, rowPinned: constants_1.Constants.PINNED_BOTTOM };
	                    }
	                    return null;
	                default:
	                    // if in the main body, then try pinned bottom, otherwise return nothing
	                    if (this.pinnedRowModel.isRowsToRender(constants_1.Constants.PINNED_BOTTOM)) {
	                        return { rowIndex: 0, rowPinned: constants_1.Constants.PINNED_BOTTOM };
	                    }
	                    return null;
	            }
	        }
	        return { rowIndex: index + 1, rowPinned: pinned };
	    };
	    CellNavigationService.prototype.getCellBelow = function (lastCell) {
	        if (!lastCell) {
	            return null;
	        }
	        var rowBelow = this.getRowBelow(lastCell);
	        if (rowBelow) {
	            return {
	                rowIndex: rowBelow.rowIndex,
	                column: lastCell.column,
	                rowPinned: rowBelow.rowPinned
	            };
	        }
	        return null;
	    };
	    CellNavigationService.prototype.isLastRowInContainer = function (rowPosition) {
	        var pinned = rowPosition.rowPinned;
	        var index = rowPosition.rowIndex;
	        if (pinned === constants_1.Constants.PINNED_TOP) {
	            var lastTopIndex = this.pinnedRowModel.getPinnedTopRowData().length - 1;
	            return lastTopIndex <= index;
	        }
	        else if (pinned === constants_1.Constants.PINNED_BOTTOM) {
	            var lastBottomIndex = this.pinnedRowModel.getPinnedBottomRowData().length - 1;
	            return lastBottomIndex <= index;
	        }
	        var lastBodyIndex = this.rowModel.getRowCount() - 1;
	        return lastBodyIndex <= index;
	    };
	    CellNavigationService.prototype.getRowAbove = function (rowPosition) {
	        // if already on top row, do nothing
	        var index = rowPosition.rowIndex;
	        var pinned = rowPosition.rowPinned;
	        // if already on top row, do nothing
	        if (index === 0) {
	            if (pinned === constants_1.Constants.PINNED_TOP) {
	                return null;
	            }
	            else if (!pinned) {
	                if (this.pinnedRowModel.isRowsToRender(constants_1.Constants.PINNED_TOP)) {
	                    return this.getLastFloatingTopRow();
	                }
	                return null;
	            }
	            else {
	                // last floating bottom
	                if (this.rowModel.isRowsToRender()) {
	                    return this.getLastBodyCell();
	                }
	                else if (this.pinnedRowModel.isRowsToRender(constants_1.Constants.PINNED_TOP)) {
	                    return this.getLastFloatingTopRow();
	                }
	                return null;
	            }
	        }
	        return { rowIndex: index - 1, rowPinned: pinned };
	    };
	    CellNavigationService.prototype.getCellAbove = function (lastCell) {
	        if (!lastCell) {
	            return null;
	        }
	        var rowAbove = this.getRowAbove({ rowIndex: lastCell.rowIndex, rowPinned: lastCell.rowPinned });
	        if (rowAbove) {
	            return {
	                rowIndex: rowAbove.rowIndex,
	                column: lastCell.column,
	                rowPinned: rowAbove.rowPinned
	            };
	        }
	        return null;
	    };
	    CellNavigationService.prototype.getLastBodyCell = function () {
	        var lastBodyRow = this.rowModel.getRowCount() - 1;
	        return { rowIndex: lastBodyRow, rowPinned: null };
	    };
	    CellNavigationService.prototype.getLastFloatingTopRow = function () {
	        var lastFloatingRow = this.pinnedRowModel.getPinnedTopRowData().length - 1;
	        return { rowIndex: lastFloatingRow, rowPinned: constants_1.Constants.PINNED_TOP };
	    };
	    CellNavigationService.prototype.getNextTabbedCell = function (gridCell, backwards) {
	        if (backwards) {
	            return this.getNextTabbedCellBackwards(gridCell);
	        }
	        return this.getNextTabbedCellForwards(gridCell);
	    };
	    CellNavigationService.prototype.getNextTabbedCellForwards = function (gridCell) {
	        var displayedColumns = this.columnController.getAllDisplayedColumns();
	        var newRowIndex = gridCell.rowIndex;
	        var newFloating = gridCell.rowPinned;
	        // move along to the next cell
	        var newColumn = this.columnController.getDisplayedColAfter(gridCell.column);
	        // check if end of the row, and if so, go forward a row
	        if (!newColumn) {
	            newColumn = displayedColumns[0];
	            var rowBelow = this.getRowBelow(gridCell);
	            if (utils_1._.missing(rowBelow)) {
	                return null;
	            }
	            newRowIndex = rowBelow ? rowBelow.rowIndex : null;
	            newFloating = rowBelow ? rowBelow.rowPinned : null;
	        }
	        return { rowIndex: newRowIndex, column: newColumn, rowPinned: newFloating };
	    };
	    CellNavigationService.prototype.getNextTabbedCellBackwards = function (gridCell) {
	        var displayedColumns = this.columnController.getAllDisplayedColumns();
	        var newRowIndex = gridCell.rowIndex;
	        var newFloating = gridCell.rowPinned;
	        // move along to the next cell
	        var newColumn = this.columnController.getDisplayedColBefore(gridCell.column);
	        // check if end of the row, and if so, go forward a row
	        if (!newColumn) {
	            newColumn = utils_1._.last(displayedColumns);
	            var rowAbove = this.getRowAbove({ rowIndex: gridCell.rowIndex, rowPinned: gridCell.rowPinned });
	            if (utils_1._.missing(rowAbove)) {
	                return null;
	            }
	            newRowIndex = rowAbove ? rowAbove.rowIndex : null;
	            newFloating = rowAbove ? rowAbove.rowPinned : null;
	        }
	        return { rowIndex: newRowIndex, column: newColumn, rowPinned: newFloating };
	    };
	    __decorate([
	        context_1.Autowired('columnController'),
	        __metadata("design:type", columnController_1.ColumnController)
	    ], CellNavigationService.prototype, "columnController", void 0);
	    __decorate([
	        context_1.Autowired('rowModel'),
	        __metadata("design:type", Object)
	    ], CellNavigationService.prototype, "rowModel", void 0);
	    __decorate([
	        context_1.Autowired('pinnedRowModel'),
	        __metadata("design:type", pinnedRowModel_1.PinnedRowModel)
	    ], CellNavigationService.prototype, "pinnedRowModel", void 0);
	    __decorate([
	        context_1.Autowired('gridOptionsWrapper'),
	        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
	    ], CellNavigationService.prototype, "gridOptionsWrapper", void 0);
	    CellNavigationService = __decorate([
	        context_1.Bean('cellNavigationService')
	    ], CellNavigationService);
	    return CellNavigationService;
	}());
	exports.CellNavigationService = CellNavigationService;


/***/ }),
/* 2371 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var gridOptionsWrapper_1 = __webpack_require__(2324);
	var rowNode_1 = __webpack_require__(2356);
	var context_1 = __webpack_require__(2333);
	var eventService_1 = __webpack_require__(2331);
	var events_1 = __webpack_require__(2335);
	var constants_1 = __webpack_require__(2328);
	var columnApi_1 = __webpack_require__(2346);
	var gridApi_1 = __webpack_require__(2338);
	var utils_1 = __webpack_require__(2325);
	var PinnedRowModel = /** @class */ (function () {
	    function PinnedRowModel() {
	    }
	    PinnedRowModel.prototype.init = function () {
	        this.setPinnedTopRowData(this.gridOptionsWrapper.getPinnedTopRowData());
	        this.setPinnedBottomRowData(this.gridOptionsWrapper.getPinnedBottomRowData());
	    };
	    PinnedRowModel.prototype.isEmpty = function (floating) {
	        var rows = floating === constants_1.Constants.PINNED_TOP ? this.pinnedTopRows : this.pinnedBottomRows;
	        return utils_1._.missingOrEmpty(rows);
	    };
	    PinnedRowModel.prototype.isRowsToRender = function (floating) {
	        return !this.isEmpty(floating);
	    };
	    PinnedRowModel.prototype.getRowAtPixel = function (pixel, floating) {
	        var rows = floating === constants_1.Constants.PINNED_TOP ? this.pinnedTopRows : this.pinnedBottomRows;
	        if (utils_1._.missingOrEmpty(rows)) {
	            return 0; // this should never happen, just in case, 0 is graceful failure
	        }
	        for (var i = 0; i < rows.length; i++) {
	            var rowNode = rows[i];
	            var rowTopPixel = rowNode.rowTop + rowNode.rowHeight - 1;
	            // only need to range check against the top pixel, as we are going through the list
	            // in order, first row to hit the pixel wins
	            if (rowTopPixel >= pixel) {
	                return i;
	            }
	        }
	        return rows.length - 1;
	    };
	    PinnedRowModel.prototype.setPinnedTopRowData = function (rowData) {
	        this.pinnedTopRows = this.createNodesFromData(rowData, true);
	        var event = {
	            type: events_1.Events.EVENT_PINNED_ROW_DATA_CHANGED,
	            api: this.gridApi,
	            columnApi: this.columnApi
	        };
	        this.eventService.dispatchEvent(event);
	    };
	    PinnedRowModel.prototype.setPinnedBottomRowData = function (rowData) {
	        this.pinnedBottomRows = this.createNodesFromData(rowData, false);
	        var event = {
	            type: events_1.Events.EVENT_PINNED_ROW_DATA_CHANGED,
	            api: this.gridApi,
	            columnApi: this.columnApi
	        };
	        this.eventService.dispatchEvent(event);
	    };
	    PinnedRowModel.prototype.createNodesFromData = function (allData, isTop) {
	        var _this = this;
	        var rowNodes = [];
	        if (allData) {
	            var nextRowTop_1 = 0;
	            allData.forEach(function (dataItem, index) {
	                var rowNode = new rowNode_1.RowNode();
	                _this.context.wireBean(rowNode);
	                rowNode.data = dataItem;
	                rowNode.id = (isTop ? 't' : 'b') + "-" + index;
	                rowNode.rowPinned = isTop ? constants_1.Constants.PINNED_TOP : constants_1.Constants.PINNED_BOTTOM;
	                rowNode.setRowTop(nextRowTop_1);
	                rowNode.setRowHeight(_this.gridOptionsWrapper.getRowHeightForNode(rowNode).height);
	                rowNode.setRowIndex(index);
	                nextRowTop_1 += rowNode.rowHeight;
	                rowNodes.push(rowNode);
	            });
	        }
	        return rowNodes;
	    };
	    PinnedRowModel.prototype.getPinnedTopRowData = function () {
	        return this.pinnedTopRows;
	    };
	    PinnedRowModel.prototype.getPinnedBottomRowData = function () {
	        return this.pinnedBottomRows;
	    };
	    PinnedRowModel.prototype.getPinnedTopTotalHeight = function () {
	        return this.getTotalHeight(this.pinnedTopRows);
	    };
	    PinnedRowModel.prototype.getPinnedTopRowCount = function () {
	        return this.pinnedTopRows ? this.pinnedTopRows.length : 0;
	    };
	    PinnedRowModel.prototype.getPinnedBottomRowCount = function () {
	        return this.pinnedBottomRows ? this.pinnedBottomRows.length : 0;
	    };
	    PinnedRowModel.prototype.getPinnedTopRow = function (index) {
	        return this.pinnedTopRows[index];
	    };
	    PinnedRowModel.prototype.getPinnedBottomRow = function (index) {
	        return this.pinnedBottomRows[index];
	    };
	    PinnedRowModel.prototype.forEachPinnedTopRow = function (callback) {
	        if (utils_1._.missingOrEmpty(this.pinnedTopRows)) {
	            return;
	        }
	        this.pinnedTopRows.forEach(callback);
	    };
	    PinnedRowModel.prototype.forEachPinnedBottomRow = function (callback) {
	        if (utils_1._.missingOrEmpty(this.pinnedBottomRows)) {
	            return;
	        }
	        this.pinnedBottomRows.forEach(callback);
	    };
	    PinnedRowModel.prototype.getPinnedBottomTotalHeight = function () {
	        return this.getTotalHeight(this.pinnedBottomRows);
	    };
	    PinnedRowModel.prototype.getTotalHeight = function (rowNodes) {
	        if (!rowNodes || rowNodes.length === 0) {
	            return 0;
	        }
	        else {
	            var lastNode = utils_1._.last(rowNodes);
	            return lastNode.rowTop + lastNode.rowHeight;
	        }
	    };
	    __decorate([
	        context_1.Autowired('gridOptionsWrapper'),
	        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
	    ], PinnedRowModel.prototype, "gridOptionsWrapper", void 0);
	    __decorate([
	        context_1.Autowired('eventService'),
	        __metadata("design:type", eventService_1.EventService)
	    ], PinnedRowModel.prototype, "eventService", void 0);
	    __decorate([
	        context_1.Autowired('context'),
	        __metadata("design:type", context_1.Context)
	    ], PinnedRowModel.prototype, "context", void 0);
	    __decorate([
	        context_1.Autowired('columnApi'),
	        __metadata("design:type", columnApi_1.ColumnApi)
	    ], PinnedRowModel.prototype, "columnApi", void 0);
	    __decorate([
	        context_1.Autowired('gridApi'),
	        __metadata("design:type", gridApi_1.GridApi)
	    ], PinnedRowModel.prototype, "gridApi", void 0);
	    __decorate([
	        context_1.PostConstruct,
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", []),
	        __metadata("design:returntype", void 0)
	    ], PinnedRowModel.prototype, "init", null);
	    PinnedRowModel = __decorate([
	        context_1.Bean('pinnedRowModel')
	    ], PinnedRowModel);
	    return PinnedRowModel;
	}());
	exports.PinnedRowModel = PinnedRowModel;


/***/ }),
/* 2372 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var beanStub_1 = __webpack_require__(2354);
	var eventService_1 = __webpack_require__(2331);
	var events_1 = __webpack_require__(2335);
	var context_1 = __webpack_require__(2333);
	var gridOptionsWrapper_1 = __webpack_require__(2324);
	var selectionController_1 = __webpack_require__(2357);
	var columnApi_1 = __webpack_require__(2346);
	var gridApi_1 = __webpack_require__(2338);
	var utils_1 = __webpack_require__(2325);
	var PaginationProxy = /** @class */ (function (_super) {
	    __extends(PaginationProxy, _super);
	    function PaginationProxy() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.currentPage = 0;
	        _this.topDisplayedRowIndex = 0;
	        _this.bottomDisplayedRowIndex = 0;
	        _this.pixelOffset = 0;
	        _this.masterRowCount = 0;
	        return _this;
	    }
	    PaginationProxy.prototype.postConstruct = function () {
	        this.active = this.gridOptionsWrapper.isPagination();
	        this.paginateChildRows = this.gridOptionsWrapper.isPaginateChildRows();
	        this.addDestroyableEventListener(this.eventService, events_1.Events.EVENT_MODEL_UPDATED, this.onModelUpdated.bind(this));
	        this.addDestroyableEventListener(this.gridOptionsWrapper, 'paginationPageSize', this.onModelUpdated.bind(this));
	        this.onModelUpdated();
	    };
	    PaginationProxy.prototype.ensureRowHeightsValid = function (startPixel, endPixel, startLimitIndex, endLimitIndex) {
	        var res = this.rowModel.ensureRowHeightsValid(startPixel, endPixel, this.getPageFirstRow(), this.getPageLastRow());
	        if (res) {
	            this.calculatePages();
	        }
	        return res;
	    };
	    PaginationProxy.prototype.onModelUpdated = function (modelUpdatedEvent) {
	        this.calculatePages();
	        var paginationChangedEvent = {
	            type: events_1.Events.EVENT_PAGINATION_CHANGED,
	            animate: modelUpdatedEvent ? modelUpdatedEvent.animate : false,
	            newData: modelUpdatedEvent ? modelUpdatedEvent.newData : false,
	            newPage: modelUpdatedEvent ? modelUpdatedEvent.newPage : false,
	            keepRenderedRows: modelUpdatedEvent ? modelUpdatedEvent.keepRenderedRows : false,
	            api: this.gridApi,
	            columnApi: this.columnApi
	        };
	        this.eventService.dispatchEvent(paginationChangedEvent);
	    };
	    PaginationProxy.prototype.goToPage = function (page) {
	        if (!this.active) {
	            return;
	        }
	        if (this.currentPage === page) {
	            return;
	        }
	        this.currentPage = page;
	        var event = {
	            type: events_1.Events.EVENT_MODEL_UPDATED,
	            animate: false,
	            keepRenderedRows: false,
	            newData: false,
	            newPage: true,
	            api: this.gridApi,
	            columnApi: this.columnApi
	        };
	        this.onModelUpdated(event);
	    };
	    PaginationProxy.prototype.getPixelOffset = function () {
	        return this.pixelOffset;
	    };
	    PaginationProxy.prototype.getRow = function (index) {
	        return this.rowModel.getRow(index);
	    };
	    PaginationProxy.prototype.getRowNode = function (id) {
	        return this.rowModel.getRowNode(id);
	    };
	    PaginationProxy.prototype.getRowIndexAtPixel = function (pixel) {
	        return this.rowModel.getRowIndexAtPixel(pixel);
	    };
	    PaginationProxy.prototype.getCurrentPageHeight = function () {
	        if (utils_1._.missing(this.topRowBounds) || utils_1._.missing(this.bottomRowBounds)) {
	            return 0;
	        }
	        return Math.max(this.bottomRowBounds.rowTop + this.bottomRowBounds.rowHeight - this.topRowBounds.rowTop, 0);
	    };
	    PaginationProxy.prototype.isRowPresent = function (rowNode) {
	        if (!this.rowModel.isRowPresent(rowNode)) {
	            return false;
	        }
	        var nodeIsInPage = rowNode.rowIndex >= this.topDisplayedRowIndex && rowNode.rowIndex <= this.bottomDisplayedRowIndex;
	        return nodeIsInPage;
	    };
	    PaginationProxy.prototype.isEmpty = function () {
	        return this.rowModel.isEmpty();
	    };
	    PaginationProxy.prototype.isRowsToRender = function () {
	        return this.rowModel.isRowsToRender();
	    };
	    PaginationProxy.prototype.getNodesInRangeForSelection = function (firstInRange, lastInRange) {
	        return this.rowModel.getNodesInRangeForSelection(firstInRange, lastInRange);
	    };
	    PaginationProxy.prototype.forEachNode = function (callback) {
	        return this.rowModel.forEachNode(callback);
	    };
	    PaginationProxy.prototype.getType = function () {
	        return this.rowModel.getType();
	    };
	    PaginationProxy.prototype.getRowBounds = function (index) {
	        var res = this.rowModel.getRowBounds(index);
	        res.rowIndex = index;
	        return res;
	    };
	    PaginationProxy.prototype.getPageFirstRow = function () {
	        return this.topRowBounds ? this.topRowBounds.rowIndex : -1;
	    };
	    PaginationProxy.prototype.getPageLastRow = function () {
	        return this.bottomRowBounds ? this.bottomRowBounds.rowIndex : -1;
	    };
	    PaginationProxy.prototype.getRowCount = function () {
	        return this.rowModel.getRowCount();
	    };
	    PaginationProxy.prototype.goToPageWithIndex = function (index) {
	        if (!this.active) {
	            return;
	        }
	        var pageNumber = Math.floor(index / this.pageSize);
	        this.goToPage(pageNumber);
	    };
	    PaginationProxy.prototype.isLastPageFound = function () {
	        return this.rowModel.isLastRowFound();
	    };
	    PaginationProxy.prototype.getCurrentPage = function () {
	        return this.currentPage;
	    };
	    PaginationProxy.prototype.goToNextPage = function () {
	        this.goToPage(this.currentPage + 1);
	    };
	    PaginationProxy.prototype.goToPreviousPage = function () {
	        this.goToPage(this.currentPage - 1);
	    };
	    PaginationProxy.prototype.goToFirstPage = function () {
	        this.goToPage(0);
	    };
	    PaginationProxy.prototype.goToLastPage = function () {
	        var rowCount = this.rowModel.getRowCount();
	        var lastPage = Math.floor(rowCount / this.pageSize);
	        this.goToPage(lastPage);
	    };
	    PaginationProxy.prototype.getPageSize = function () {
	        return this.pageSize;
	    };
	    PaginationProxy.prototype.getTotalPages = function () {
	        return this.totalPages;
	    };
	    PaginationProxy.prototype.setPageSize = function () {
	        // show put this into super class
	        this.pageSize = this.gridOptionsWrapper.getPaginationPageSize();
	        if (!(this.pageSize >= 1)) {
	            this.pageSize = 100;
	        }
	    };
	    PaginationProxy.prototype.calculatePages = function () {
	        if (this.active) {
	            this.setPageSize();
	            if (this.paginateChildRows) {
	                this.calculatePagesAllRows();
	            }
	            else {
	                this.calculatePagesMasterRowsOnly();
	            }
	        }
	        else {
	            this.calculatedPagesNotActive();
	        }
	        this.topRowBounds = this.rowModel.getRowBounds(this.topDisplayedRowIndex);
	        if (this.topRowBounds) {
	            this.topRowBounds.rowIndex = this.topDisplayedRowIndex;
	        }
	        this.bottomRowBounds = this.rowModel.getRowBounds(this.bottomDisplayedRowIndex);
	        if (this.bottomRowBounds) {
	            this.bottomRowBounds.rowIndex = this.bottomDisplayedRowIndex;
	        }
	        this.pixelOffset = utils_1._.exists(this.topRowBounds) ? this.topRowBounds.rowTop : 0;
	    };
	    PaginationProxy.prototype.setZeroRows = function () {
	        this.topDisplayedRowIndex = 0;
	        this.bottomDisplayedRowIndex = -1;
	        this.currentPage = 0;
	        this.totalPages = 0;
	    };
	    PaginationProxy.prototype.calculatePagesMasterRowsOnly = function () {
	        // const csrm = <ClientSideRowModel> this.rowModel;
	        // const rootNode = csrm.getRootNode();
	        // const masterRows = rootNode.childrenAfterSort;
	        this.masterRowCount = this.rowModel.getTopLevelRowCount();
	        if (this.masterRowCount === 0) {
	            this.setZeroRows();
	            return;
	        }
	        var masterLastRowIndex = this.masterRowCount - 1;
	        this.totalPages = Math.floor((masterLastRowIndex) / this.pageSize) + 1;
	        if (this.currentPage >= this.totalPages) {
	            this.currentPage = this.totalPages - 1;
	        }
	        if (!utils_1._.isNumeric(this.currentPage) || this.currentPage < 0) {
	            this.currentPage = 0;
	        }
	        var masterPageStartIndex = this.pageSize * this.currentPage;
	        var masterPageEndIndex = (this.pageSize * (this.currentPage + 1)) - 1;
	        if (masterPageEndIndex > masterLastRowIndex) {
	            masterPageEndIndex = masterLastRowIndex;
	        }
	        this.topDisplayedRowIndex = this.rowModel.getTopLevelRowDisplayedIndex(masterPageStartIndex);
	        // masterRows[masterPageStartIndex].rowIndex;
	        if (masterPageEndIndex === masterLastRowIndex) {
	            // if showing the last master row, then we want to show the very last row of the model
	            this.bottomDisplayedRowIndex = this.rowModel.getRowCount() - 1;
	        }
	        else {
	            var firstIndexNotToShow = this.rowModel.getTopLevelRowDisplayedIndex(masterPageEndIndex + 1);
	            //masterRows[masterPageEndIndex + 1].rowIndex;
	            // this gets the index of the last child - eg current row is open, we want to display all children,
	            // the index of the last child is one less than the index of the next parent row.
	            this.bottomDisplayedRowIndex = firstIndexNotToShow - 1;
	        }
	    };
	    PaginationProxy.prototype.getMasterRowCount = function () {
	        return this.masterRowCount;
	    };
	    PaginationProxy.prototype.calculatePagesAllRows = function () {
	        this.masterRowCount = this.rowModel.getRowCount();
	        if (this.masterRowCount === 0) {
	            this.setZeroRows();
	            return;
	        }
	        var maxRowIndex = this.masterRowCount - 1;
	        this.totalPages = Math.floor((maxRowIndex) / this.pageSize) + 1;
	        if (this.currentPage >= this.totalPages) {
	            this.currentPage = this.totalPages - 1;
	        }
	        if (!utils_1._.isNumeric(this.currentPage) || this.currentPage < 0) {
	            this.currentPage = 0;
	        }
	        this.topDisplayedRowIndex = this.pageSize * this.currentPage;
	        this.bottomDisplayedRowIndex = (this.pageSize * (this.currentPage + 1)) - 1;
	        if (this.bottomDisplayedRowIndex > maxRowIndex) {
	            this.bottomDisplayedRowIndex = maxRowIndex;
	        }
	    };
	    PaginationProxy.prototype.calculatedPagesNotActive = function () {
	        this.pageSize = this.rowModel.getRowCount();
	        this.totalPages = 1;
	        this.currentPage = 0;
	        this.topDisplayedRowIndex = 0;
	        this.bottomDisplayedRowIndex = this.rowModel.getRowCount() - 1;
	    };
	    __decorate([
	        context_1.Autowired('rowModel'),
	        __metadata("design:type", Object)
	    ], PaginationProxy.prototype, "rowModel", void 0);
	    __decorate([
	        context_1.Autowired('eventService'),
	        __metadata("design:type", eventService_1.EventService)
	    ], PaginationProxy.prototype, "eventService", void 0);
	    __decorate([
	        context_1.Autowired('gridOptionsWrapper'),
	        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
	    ], PaginationProxy.prototype, "gridOptionsWrapper", void 0);
	    __decorate([
	        context_1.Autowired('selectionController'),
	        __metadata("design:type", selectionController_1.SelectionController)
	    ], PaginationProxy.prototype, "selectionController", void 0);
	    __decorate([
	        context_1.Autowired('columnApi'),
	        __metadata("design:type", columnApi_1.ColumnApi)
	    ], PaginationProxy.prototype, "columnApi", void 0);
	    __decorate([
	        context_1.Autowired('gridApi'),
	        __metadata("design:type", gridApi_1.GridApi)
	    ], PaginationProxy.prototype, "gridApi", void 0);
	    __decorate([
	        context_1.PostConstruct,
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", []),
	        __metadata("design:returntype", void 0)
	    ], PaginationProxy.prototype, "postConstruct", null);
	    PaginationProxy = __decorate([
	        context_1.Bean('paginationProxy')
	    ], PaginationProxy);
	    return PaginationProxy;
	}(beanStub_1.BeanStub));
	exports.PaginationProxy = PaginationProxy;


/***/ }),
/* 2373 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var context_1 = __webpack_require__(2333);
	var columnApi_1 = __webpack_require__(2346);
	var columnController_1 = __webpack_require__(2341);
	var gridApi_1 = __webpack_require__(2338);
	var gridOptionsWrapper_1 = __webpack_require__(2324);
	var expressionService_1 = __webpack_require__(2347);
	var rowRenderer_1 = __webpack_require__(2350);
	var templateService_1 = __webpack_require__(2374);
	var valueService_1 = __webpack_require__(2359);
	var eventService_1 = __webpack_require__(2331);
	var columnAnimationService_1 = __webpack_require__(2375);
	var focusedCellController_1 = __webpack_require__(2369);
	var cellRendererFactory_1 = __webpack_require__(2376);
	var popupService_1 = __webpack_require__(2379);
	var valueFormatterService_1 = __webpack_require__(2395);
	var stylingService_1 = __webpack_require__(2416);
	var columnHoverService_1 = __webpack_require__(2417);
	var paginationProxy_1 = __webpack_require__(2372);
	var animationFrameService_1 = __webpack_require__(2418);
	var userComponentFactory_1 = __webpack_require__(2380);
	var dragAndDropService_1 = __webpack_require__(2363);
	var sortController_1 = __webpack_require__(2391);
	var filterManager_1 = __webpack_require__(2378);
	var maxDivHeightScaler_1 = __webpack_require__(2419);
	var tooltipManager_1 = __webpack_require__(2420);
	var detailRowCompCache_1 = __webpack_require__(2421);
	var cellPosition_1 = __webpack_require__(2422);
	var rowPosition_1 = __webpack_require__(2423);
	/** Using the IoC has a slight performance consideration, which is no problem most of the
	 * time, unless we are trashing objects - which is the case when scrolling and rowComp
	 * and cellComp. So for performance reasons, RowComp and CellComp do not get autowired
	 * with the IoC. Instead they get passed this object which is all the beans the RowComp
	 * and CellComp need. Not autowiring all the cells gives performance improvement. */
	var Beans = /** @class */ (function () {
	    function Beans() {
	    }
	    Beans.prototype.registerGridComp = function (gridPanel) {
	        this.gridPanel = gridPanel;
	    };
	    Beans.prototype.postConstruct = function () {
	        this.doingMasterDetail = this.gridOptionsWrapper.isMasterDetail();
	    };
	    __decorate([
	        context_1.Autowired('paginationProxy'),
	        __metadata("design:type", paginationProxy_1.PaginationProxy)
	    ], Beans.prototype, "paginationProxy", void 0);
	    __decorate([
	        context_1.Autowired('context'),
	        __metadata("design:type", context_1.Context)
	    ], Beans.prototype, "context", void 0);
	    __decorate([
	        context_1.Autowired('columnApi'),
	        __metadata("design:type", columnApi_1.ColumnApi)
	    ], Beans.prototype, "columnApi", void 0);
	    __decorate([
	        context_1.Autowired('gridApi'),
	        __metadata("design:type", gridApi_1.GridApi)
	    ], Beans.prototype, "gridApi", void 0);
	    __decorate([
	        context_1.Autowired('gridOptionsWrapper'),
	        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
	    ], Beans.prototype, "gridOptionsWrapper", void 0);
	    __decorate([
	        context_1.Autowired('expressionService'),
	        __metadata("design:type", expressionService_1.ExpressionService)
	    ], Beans.prototype, "expressionService", void 0);
	    __decorate([
	        context_1.Autowired('rowRenderer'),
	        __metadata("design:type", rowRenderer_1.RowRenderer)
	    ], Beans.prototype, "rowRenderer", void 0);
	    __decorate([
	        context_1.Autowired('$compile'),
	        __metadata("design:type", Object)
	    ], Beans.prototype, "$compile", void 0);
	    __decorate([
	        context_1.Autowired('templateService'),
	        __metadata("design:type", templateService_1.TemplateService)
	    ], Beans.prototype, "templateService", void 0);
	    __decorate([
	        context_1.Autowired('valueService'),
	        __metadata("design:type", valueService_1.ValueService)
	    ], Beans.prototype, "valueService", void 0);
	    __decorate([
	        context_1.Autowired('eventService'),
	        __metadata("design:type", eventService_1.EventService)
	    ], Beans.prototype, "eventService", void 0);
	    __decorate([
	        context_1.Autowired('columnController'),
	        __metadata("design:type", columnController_1.ColumnController)
	    ], Beans.prototype, "columnController", void 0);
	    __decorate([
	        context_1.Autowired('columnAnimationService'),
	        __metadata("design:type", columnAnimationService_1.ColumnAnimationService)
	    ], Beans.prototype, "columnAnimationService", void 0);
	    __decorate([
	        context_1.Optional('rangeController'),
	        __metadata("design:type", Object)
	    ], Beans.prototype, "rangeController", void 0);
	    __decorate([
	        context_1.Autowired('focusedCellController'),
	        __metadata("design:type", focusedCellController_1.FocusedCellController)
	    ], Beans.prototype, "focusedCellController", void 0);
	    __decorate([
	        context_1.Optional('contextMenuFactory'),
	        __metadata("design:type", Object)
	    ], Beans.prototype, "contextMenuFactory", void 0);
	    __decorate([
	        context_1.Autowired('cellRendererFactory'),
	        __metadata("design:type", cellRendererFactory_1.CellRendererFactory)
	    ], Beans.prototype, "cellRendererFactory", void 0);
	    __decorate([
	        context_1.Autowired('popupService'),
	        __metadata("design:type", popupService_1.PopupService)
	    ], Beans.prototype, "popupService", void 0);
	    __decorate([
	        context_1.Autowired('valueFormatterService'),
	        __metadata("design:type", valueFormatterService_1.ValueFormatterService)
	    ], Beans.prototype, "valueFormatterService", void 0);
	    __decorate([
	        context_1.Autowired('stylingService'),
	        __metadata("design:type", stylingService_1.StylingService)
	    ], Beans.prototype, "stylingService", void 0);
	    __decorate([
	        context_1.Autowired('columnHoverService'),
	        __metadata("design:type", columnHoverService_1.ColumnHoverService)
	    ], Beans.prototype, "columnHoverService", void 0);
	    __decorate([
	        context_1.Autowired('enterprise'),
	        __metadata("design:type", Boolean)
	    ], Beans.prototype, "enterprise", void 0);
	    __decorate([
	        context_1.Autowired('userComponentFactory'),
	        __metadata("design:type", userComponentFactory_1.UserComponentFactory)
	    ], Beans.prototype, "userComponentFactory", void 0);
	    __decorate([
	        context_1.Autowired('animationFrameService'),
	        __metadata("design:type", animationFrameService_1.AnimationFrameService)
	    ], Beans.prototype, "taskQueue", void 0);
	    __decorate([
	        context_1.Autowired('dragAndDropService'),
	        __metadata("design:type", dragAndDropService_1.DragAndDropService)
	    ], Beans.prototype, "dragAndDropService", void 0);
	    __decorate([
	        context_1.Autowired('sortController'),
	        __metadata("design:type", sortController_1.SortController)
	    ], Beans.prototype, "sortController", void 0);
	    __decorate([
	        context_1.Autowired('filterManager'),
	        __metadata("design:type", filterManager_1.FilterManager)
	    ], Beans.prototype, "filterManager", void 0);
	    __decorate([
	        context_1.Autowired('maxDivHeightScaler'),
	        __metadata("design:type", maxDivHeightScaler_1.MaxDivHeightScaler)
	    ], Beans.prototype, "maxDivHeightScaler", void 0);
	    __decorate([
	        context_1.Autowired('tooltipManager'),
	        __metadata("design:type", tooltipManager_1.TooltipManager)
	    ], Beans.prototype, "tooltipManager", void 0);
	    __decorate([
	        context_1.Autowired('frameworkOverrides'),
	        __metadata("design:type", Object)
	    ], Beans.prototype, "frameworkOverrides", void 0);
	    __decorate([
	        context_1.Autowired('detailRowCompCache'),
	        __metadata("design:type", detailRowCompCache_1.DetailRowCompCache)
	    ], Beans.prototype, "detailRowCompCache", void 0);
	    __decorate([
	        context_1.Autowired('cellPositionUtils'),
	        __metadata("design:type", cellPosition_1.CellPositionUtils)
	    ], Beans.prototype, "cellPositionUtils", void 0);
	    __decorate([
	        context_1.Autowired('rowPositionUtils'),
	        __metadata("design:type", rowPosition_1.RowPositionUtils)
	    ], Beans.prototype, "rowPositionUtils", void 0);
	    __decorate([
	        context_1.PostConstruct,
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", []),
	        __metadata("design:returntype", void 0)
	    ], Beans.prototype, "postConstruct", null);
	    Beans = __decorate([
	        context_1.Bean('beans')
	    ], Beans);
	    return Beans;
	}());
	exports.Beans = Beans;


/***/ }),
/* 2374 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var context_1 = __webpack_require__(2333);
	var context_2 = __webpack_require__(2333);
	var TemplateService = /** @class */ (function () {
	    function TemplateService() {
	        this.templateCache = {};
	        this.waitingCallbacks = {};
	    }
	    // returns the template if it is loaded, or null if it is not loaded
	    // but will call the callback when it is loaded
	    TemplateService.prototype.getTemplate = function (url, callback) {
	        var templateFromCache = this.templateCache[url];
	        if (templateFromCache) {
	            return templateFromCache;
	        }
	        var callbackList = this.waitingCallbacks[url];
	        var that = this;
	        if (!callbackList) {
	            // first time this was called, so need a new list for callbacks
	            callbackList = [];
	            this.waitingCallbacks[url] = callbackList;
	            // and also need to do the http request
	            var client = new XMLHttpRequest();
	            client.onload = function () {
	                that.handleHttpResult(this, url);
	            };
	            client.open("GET", url);
	            client.send();
	        }
	        // add this callback
	        if (callback) {
	            callbackList.push(callback);
	        }
	        // caller needs to wait for template to load, so return null
	        return null;
	    };
	    TemplateService.prototype.handleHttpResult = function (httpResult, url) {
	        if (httpResult.status !== 200 || httpResult.response === null) {
	            console.warn("Unable to get template error " + httpResult.status + " - " + url);
	            return;
	        }
	        // response success, so process it
	        // in IE9 the response is in - responseText
	        this.templateCache[url] = httpResult.response || httpResult.responseText;
	        // inform all listeners that this is now in the cache
	        var callbacks = this.waitingCallbacks[url];
	        for (var i = 0; i < callbacks.length; i++) {
	            var callback = callbacks[i];
	            // we could pass the callback the response, however we know the client of this code
	            // is the cell renderer, and it passes the 'cellRefresh' method in as the callback
	            // which doesn't take any parameters.
	            callback();
	        }
	        if (this.$scope) {
	            var that_1 = this;
	            window.setTimeout(function () {
	                that_1.$scope.$apply();
	            }, 0);
	        }
	    };
	    __decorate([
	        context_2.Autowired('$scope'),
	        __metadata("design:type", Object)
	    ], TemplateService.prototype, "$scope", void 0);
	    TemplateService = __decorate([
	        context_1.Bean('templateService')
	    ], TemplateService);
	    return TemplateService;
	}());
	exports.TemplateService = TemplateService;


/***/ }),
/* 2375 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var context_1 = __webpack_require__(2333);
	var gridOptionsWrapper_1 = __webpack_require__(2324);
	var ColumnAnimationService = /** @class */ (function () {
	    function ColumnAnimationService() {
	        this.executeNextFuncs = [];
	        this.executeLaterFuncs = [];
	        this.active = false;
	        this.animationThreadCount = 0;
	    }
	    ColumnAnimationService.prototype.registerGridComp = function (gridPanel) {
	        this.gridPanel = gridPanel;
	    };
	    ColumnAnimationService.prototype.isActive = function () {
	        return this.active;
	    };
	    ColumnAnimationService.prototype.start = function () {
	        if (this.active) {
	            return;
	        }
	        if (this.gridOptionsWrapper.isSuppressColumnMoveAnimation()) {
	            return;
	        }
	        // if doing RTL, we don't animate open / close as due to how the pixels are inverted,
	        // the animation moves all the row the the right rather than to the left (ie it's the static
	        // columns that actually get their coordinates updated)
	        if (this.gridOptionsWrapper.isEnableRtl()) {
	            return;
	        }
	        this.ensureAnimationCssClassPresent();
	        this.active = true;
	    };
	    ColumnAnimationService.prototype.finish = function () {
	        if (!this.active) {
	            return;
	        }
	        this.flush();
	        this.active = false;
	    };
	    ColumnAnimationService.prototype.executeNextVMTurn = function (func) {
	        if (this.active) {
	            this.executeNextFuncs.push(func);
	        }
	        else {
	            func();
	        }
	    };
	    ColumnAnimationService.prototype.executeLaterVMTurn = function (func) {
	        if (this.active) {
	            this.executeLaterFuncs.push(func);
	        }
	        else {
	            func();
	        }
	    };
	    ColumnAnimationService.prototype.ensureAnimationCssClassPresent = function () {
	        var _this = this;
	        // up the count, so we can tell if someone else has updated the count
	        // by the time the 'wait' func executes
	        this.animationThreadCount++;
	        var animationThreadCountCopy = this.animationThreadCount;
	        this.gridPanel.setColumnMovingCss(true);
	        this.executeLaterFuncs.push(function () {
	            // only remove the class if this thread was the last one to update it
	            if (_this.animationThreadCount === animationThreadCountCopy) {
	                _this.gridPanel.setColumnMovingCss(false);
	            }
	        });
	    };
	    ColumnAnimationService.prototype.flush = function () {
	        var nowFuncs = this.executeNextFuncs;
	        this.executeNextFuncs = [];
	        var waitFuncs = this.executeLaterFuncs;
	        this.executeLaterFuncs = [];
	        if (nowFuncs.length === 0 && waitFuncs.length === 0) {
	            return;
	        }
	        window.setTimeout(function () { return nowFuncs.forEach(function (func) { return func(); }); }, 0);
	        window.setTimeout(function () { return waitFuncs.forEach(function (func) { return func(); }); }, 300);
	    };
	    __decorate([
	        context_1.Autowired('gridOptionsWrapper'),
	        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
	    ], ColumnAnimationService.prototype, "gridOptionsWrapper", void 0);
	    ColumnAnimationService = __decorate([
	        context_1.Bean('columnAnimationService')
	    ], ColumnAnimationService);
	    return ColumnAnimationService;
	}());
	exports.ColumnAnimationService = ColumnAnimationService;


/***/ }),
/* 2376 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var context_1 = __webpack_require__(2333);
	var gridOptionsWrapper_1 = __webpack_require__(2324);
	var eventService_1 = __webpack_require__(2331);
	var expressionService_1 = __webpack_require__(2347);
	var animateSlideCellRenderer_1 = __webpack_require__(2377);
	var animateShowChangeCellRenderer_1 = __webpack_require__(2397);
	var groupCellRenderer_1 = __webpack_require__(2394);
	var utils_1 = __webpack_require__(2325);
	var CellRendererFactory = /** @class */ (function () {
	    function CellRendererFactory() {
	        this.cellRendererMap = {};
	    }
	    CellRendererFactory_1 = CellRendererFactory;
	    CellRendererFactory.prototype.init = function () {
	        this.cellRendererMap[CellRendererFactory_1.ANIMATE_SLIDE] = animateSlideCellRenderer_1.AnimateSlideCellRenderer;
	        this.cellRendererMap[CellRendererFactory_1.ANIMATE_SHOW_CHANGE] = animateShowChangeCellRenderer_1.AnimateShowChangeCellRenderer;
	        this.cellRendererMap[CellRendererFactory_1.GROUP] = groupCellRenderer_1.GroupCellRenderer;
	        // this.registerRenderersFromGridOptions();
	    };
	    // private registerRenderersFromGridOptions(): void {
	    //     let userProvidedCellRenderers = this.gridOptionsWrapper.getCellRenderers();
	    //     _.iterateObject(userProvidedCellRenderers, (key: string, cellRenderer: {new(): ICellRenderer} | ICellRendererFunc)=> {
	    //         this.addCellRenderer(key, cellRenderer);
	    //     });
	    // }
	    CellRendererFactory.prototype.addCellRenderer = function (key, cellRenderer) {
	        this.cellRendererMap[key] = cellRenderer;
	    };
	    CellRendererFactory.prototype.getCellRenderer = function (key) {
	        var result = this.cellRendererMap[key];
	        if (utils_1._.missing(result)) {
	            console.warn('ag-Grid: unable to find cellRenderer for key ' + key);
	            return null;
	        }
	        return result;
	    };
	    var CellRendererFactory_1;
	    CellRendererFactory.ANIMATE_SLIDE = 'animateSlide';
	    CellRendererFactory.ANIMATE_SHOW_CHANGE = 'animateShowChange';
	    CellRendererFactory.GROUP = 'group';
	    __decorate([
	        context_1.Autowired('gridOptionsWrapper'),
	        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
	    ], CellRendererFactory.prototype, "gridOptionsWrapper", void 0);
	    __decorate([
	        context_1.Autowired('expressionService'),
	        __metadata("design:type", expressionService_1.ExpressionService)
	    ], CellRendererFactory.prototype, "expressionService", void 0);
	    __decorate([
	        context_1.Autowired('eventService'),
	        __metadata("design:type", eventService_1.EventService)
	    ], CellRendererFactory.prototype, "eventService", void 0);
	    __decorate([
	        context_1.PostConstruct,
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", []),
	        __metadata("design:returntype", void 0)
	    ], CellRendererFactory.prototype, "init", null);
	    CellRendererFactory = CellRendererFactory_1 = __decorate([
	        context_1.Bean('cellRendererFactory')
	    ], CellRendererFactory);
	    return CellRendererFactory;
	}());
	exports.CellRendererFactory = CellRendererFactory;


/***/ }),
/* 2377 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var component_1 = __webpack_require__(2353);
	var utils_1 = __webpack_require__(2325);
	var context_1 = __webpack_require__(2333);
	var filterManager_1 = __webpack_require__(2378);
	var AnimateSlideCellRenderer = /** @class */ (function (_super) {
	    __extends(AnimateSlideCellRenderer, _super);
	    function AnimateSlideCellRenderer() {
	        var _this = _super.call(this, AnimateSlideCellRenderer.TEMPLATE) || this;
	        _this.refreshCount = 0;
	        _this.eCurrent = _this.queryForHtmlElement('.ag-value-slide-current');
	        return _this;
	    }
	    AnimateSlideCellRenderer.prototype.init = function (params) {
	        this.params = params;
	        this.refresh(params);
	    };
	    AnimateSlideCellRenderer.prototype.addSlideAnimation = function () {
	        var _this = this;
	        this.refreshCount++;
	        // below we keep checking this, and stop working on the animation
	        // if it no longer matches - this means another animation has started
	        // and this one is stale.
	        var refreshCountCopy = this.refreshCount;
	        // if old animation, remove it
	        if (this.ePrevious) {
	            this.getGui().removeChild(this.ePrevious);
	        }
	        this.ePrevious = utils_1._.loadTemplate('<span class="ag-value-slide-previous ag-value-slide-out"></span>');
	        this.ePrevious.innerHTML = this.eCurrent.innerHTML;
	        this.getGui().insertBefore(this.ePrevious, this.eCurrent);
	        // having timeout of 0 allows use to skip to the next css turn,
	        // so we know the previous css classes have been applied. so the
	        // complex set of setTimeout below creates the animation
	        window.setTimeout(function () {
	            if (refreshCountCopy !== _this.refreshCount) {
	                return;
	            }
	            utils_1._.addCssClass(_this.ePrevious, 'ag-value-slide-out-end');
	        }, 50);
	        window.setTimeout(function () {
	            if (refreshCountCopy !== _this.refreshCount) {
	                return;
	            }
	            _this.getGui().removeChild(_this.ePrevious);
	            _this.ePrevious = null;
	        }, 3000);
	    };
	    AnimateSlideCellRenderer.prototype.refresh = function (params) {
	        var value = params.value;
	        if (utils_1._.missing(value)) {
	            value = '';
	        }
	        if (value === this.lastValue) {
	            return;
	        }
	        // we don't show the delta if we are in the middle of a filter. see comment on FilterManager
	        // with regards processingFilterChange
	        if (this.filterManager.isSuppressFlashingCellsBecauseFiltering()) {
	            return;
	        }
	        this.addSlideAnimation();
	        this.lastValue = value;
	        if (utils_1._.exists(params.valueFormatted)) {
	            this.eCurrent.innerHTML = params.valueFormatted;
	        }
	        else if (utils_1._.exists(params.value)) {
	            this.eCurrent.innerHTML = value;
	        }
	        else {
	            utils_1._.clearElement(this.eCurrent);
	        }
	        return true;
	    };
	    AnimateSlideCellRenderer.TEMPLATE = '<span>' +
	        '<span class="ag-value-slide-current"></span>' +
	        '</span>';
	    __decorate([
	        context_1.Autowired('filterManager'),
	        __metadata("design:type", filterManager_1.FilterManager)
	    ], AnimateSlideCellRenderer.prototype, "filterManager", void 0);
	    return AnimateSlideCellRenderer;
	}(component_1.Component));
	exports.AnimateSlideCellRenderer = AnimateSlideCellRenderer;


/***/ }),
/* 2378 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var utils_1 = __webpack_require__(2325);
	var gridOptionsWrapper_1 = __webpack_require__(2324);
	var popupService_1 = __webpack_require__(2379);
	var valueService_1 = __webpack_require__(2359);
	var columnController_1 = __webpack_require__(2341);
	var columnApi_1 = __webpack_require__(2346);
	var context_1 = __webpack_require__(2333);
	var eventService_1 = __webpack_require__(2331);
	var events_1 = __webpack_require__(2335);
	var gridApi_1 = __webpack_require__(2338);
	var userComponentFactory_1 = __webpack_require__(2380);
	var FilterManager = /** @class */ (function () {
	    function FilterManager() {
	        this.allFilters = {};
	        this.quickFilter = null;
	        this.quickFilterParts = null;
	        // this is true when the grid is processing the filter change. this is used by the cell comps, so that they
	        // don't flash when data changes due to filter changes. there is no need to flash when filter changes as the
	        // user is in control, so doesn't make sense to show flashing changes. for example, go to main demo where
	        // this feature is turned off (hack code to always return false for isSuppressFlashingCellsBecauseFiltering(), put in)
	        // 100,000 rows and group by country. then do some filtering. all the cells flash, which is silly.
	        this.processingFilterChange = false;
	    }
	    FilterManager_1 = FilterManager;
	    FilterManager.prototype.registerGridCore = function (gridCore) {
	        this.gridCore = gridCore;
	    };
	    FilterManager.prototype.init = function () {
	        this.eventService.addEventListener(events_1.Events.EVENT_ROW_DATA_CHANGED, this.onNewRowsLoaded.bind(this));
	        this.eventService.addEventListener(events_1.Events.EVENT_NEW_COLUMNS_LOADED, this.onNewColumnsLoaded.bind(this));
	        this.quickFilter = this.parseQuickFilter(this.gridOptionsWrapper.getQuickFilterText());
	        this.setQuickFilterParts();
	        this.allowShowChangeAfterFilter = this.gridOptionsWrapper.isAllowShowChangeAfterFilter();
	        // check this here, in case there is a filter from the start
	        this.checkExternalFilter();
	    };
	    FilterManager.prototype.setQuickFilterParts = function () {
	        if (this.quickFilter) {
	            this.quickFilterParts = this.quickFilter.split(' ');
	        }
	        else {
	            this.quickFilterParts = null;
	        }
	    };
	    FilterManager.prototype.setFilterModel = function (model) {
	        var _this = this;
	        var allPromises = [];
	        if (model) {
	            // mark the filters as we set them, so any active filters left over we stop
	            var modelKeys_1 = Object.keys(model);
	            utils_1._.iterateObject(this.allFilters, function (colId, filterWrapper) {
	                utils_1._.removeFromArray(modelKeys_1, colId);
	                var newModel = model[colId];
	                _this.setModelOnFilterWrapper(filterWrapper.filterPromise, newModel);
	                allPromises.push(filterWrapper.filterPromise);
	            });
	            // at this point, processedFields contains data for which we don't have a filter working yet
	            utils_1._.iterateArray(modelKeys_1, function (colId) {
	                var column = _this.columnController.getPrimaryColumn(colId);
	                if (!column) {
	                    console.warn('Warning ag-grid setFilterModel - no column found for colId ' + colId);
	                    return;
	                }
	                var filterWrapper = _this.getOrCreateFilterWrapper(column, 'NO_UI');
	                _this.setModelOnFilterWrapper(filterWrapper.filterPromise, model[colId]);
	                allPromises.push(filterWrapper.filterPromise);
	            });
	        }
	        else {
	            utils_1._.iterateObject(this.allFilters, function (key, filterWrapper) {
	                _this.setModelOnFilterWrapper(filterWrapper.filterPromise, null);
	                allPromises.push(filterWrapper.filterPromise);
	            });
	        }
	        utils_1.Promise.all(allPromises).then(function (whatever) {
	            _this.onFilterChanged();
	        });
	    };
	    FilterManager.prototype.setModelOnFilterWrapper = function (filterPromise, newModel) {
	        filterPromise.then(function (filter) {
	            if (typeof filter.setModel !== 'function') {
	                console.warn('Warning ag-grid - filter missing setModel method, which is needed for setFilterModel');
	                return;
	            }
	            filter.setModel(newModel);
	        });
	    };
	    FilterManager.prototype.getFilterModel = function () {
	        var result = {};
	        utils_1._.iterateObject(this.allFilters, function (key, filterWrapper) {
	            // because user can provide filters, we provide useful error checking and messages
	            var filterPromise = filterWrapper.filterPromise;
	            var filter = filterPromise.resolveNow(null, function (filter) { return filter; });
	            if (filter == null) {
	                return null;
	            }
	            if (typeof filter.getModel !== 'function') {
	                console.warn('Warning ag-grid - filter API missing getModel method, which is needed for getFilterModel');
	                return;
	            }
	            var model = filter.getModel();
	            if (utils_1._.exists(model)) {
	                result[key] = model;
	            }
	        });
	        return result;
	    };
	    // returns true if any advanced filter (ie not quick filter) active
	    FilterManager.prototype.isAdvancedFilterPresent = function () {
	        return this.advancedFilterPresent;
	    };
	    // called by:
	    // 1) onFilterChanged()
	    // 2) onNewRowsLoaded()
	    FilterManager.prototype.setAdvancedFilterPresent = function () {
	        var atLeastOneActive = false;
	        utils_1._.iterateObject(this.allFilters, function (key, filterWrapper) {
	            if (filterWrapper.filterPromise.resolveNow(false, function (filter) { return filter.isFilterActive(); })) {
	                atLeastOneActive = true;
	            }
	        });
	        this.advancedFilterPresent = atLeastOneActive;
	    };
	    FilterManager.prototype.updateFilterFlagInColumns = function (source, additionalEventAttributes) {
	        utils_1._.iterateObject(this.allFilters, function (key, filterWrapper) {
	            var filterActive = filterWrapper.filterPromise.resolveNow(false, function (filter) { return filter.isFilterActive(); });
	            filterWrapper.column.setFilterActive(filterActive, source, additionalEventAttributes);
	        });
	    };
	    // returns true if quickFilter or advancedFilter
	    FilterManager.prototype.isAnyFilterPresent = function () {
	        return this.isQuickFilterPresent() || this.advancedFilterPresent || this.externalFilterPresent;
	    };
	    FilterManager.prototype.doesFilterPass = function (node, filterToSkip) {
	        var data = node.data;
	        var colKeys = Object.keys(this.allFilters);
	        for (var i = 0, l = colKeys.length; i < l; i++) { // critical code, don't use functional programming
	            var colId = colKeys[i];
	            var filterWrapper = this.allFilters[colId];
	            // if no filter, always pass
	            if (filterWrapper === undefined) {
	                continue;
	            }
	            var filter = filterWrapper.filterPromise.resolveNow(undefined, function (filter) { return filter; });
	            // if filter not yet there, continue
	            if (filter === undefined) {
	                continue;
	            }
	            if (filter === filterToSkip) {
	                continue;
	            }
	            // don't bother with filters that are not active
	            if (!filter.isFilterActive()) {
	                continue;
	            }
	            if (!filter.doesFilterPass) { // because users can do custom filters, give nice error message
	                console.error('Filter is missing method doesFilterPass');
	            }
	            var params = {
	                node: node,
	                data: data
	            };
	            if (!filter.doesFilterPass(params)) {
	                return false;
	            }
	        }
	        // all filters passed
	        return true;
	    };
	    FilterManager.prototype.parseQuickFilter = function (newFilter) {
	        if (utils_1._.missing(newFilter) || newFilter === "") {
	            return null;
	        }
	        if (!this.gridOptionsWrapper.isRowModelDefault()) {
	            console.warn('ag-grid: quick filtering only works with the Client-side Row Model');
	            return null;
	        }
	        return newFilter.toUpperCase();
	    };
	    // returns true if it has changed (not just same value again)
	    FilterManager.prototype.setQuickFilter = function (newFilter) {
	        var parsedFilter = this.parseQuickFilter(newFilter);
	        if (this.quickFilter !== parsedFilter) {
	            this.quickFilter = parsedFilter;
	            this.setQuickFilterParts();
	            this.onFilterChanged();
	        }
	    };
	    FilterManager.prototype.checkExternalFilter = function () {
	        this.externalFilterPresent = this.gridOptionsWrapper.isExternalFilterPresent();
	    };
	    FilterManager.prototype.onFilterChanged = function (additionalEventAttributes) {
	        this.setAdvancedFilterPresent();
	        this.updateFilterFlagInColumns("filterChanged", additionalEventAttributes);
	        this.checkExternalFilter();
	        utils_1._.iterateObject(this.allFilters, function (key, filterWrapper) {
	            filterWrapper.filterPromise.then(function (filter) {
	                if (filter.onAnyFilterChanged) {
	                    filter.onAnyFilterChanged();
	                }
	            });
	        });
	        var filterChangedEvent = {
	            type: events_1.Events.EVENT_FILTER_CHANGED,
	            api: this.gridApi,
	            columnApi: this.columnApi
	        };
	        if (additionalEventAttributes) {
	            utils_1._.mergeDeep(filterChangedEvent, additionalEventAttributes);
	        }
	        // because internal events are not async in ag-grid, when the dispatchEvent
	        // method comes back, we know all listeners have finished executing.
	        this.processingFilterChange = true;
	        this.eventService.dispatchEvent(filterChangedEvent);
	        this.processingFilterChange = false;
	    };
	    FilterManager.prototype.isSuppressFlashingCellsBecauseFiltering = function () {
	        if (this.allowShowChangeAfterFilter) {
	            // if user has elected to always flash cell changes, then return false always
	            return false;
	        }
	        else {
	            // otherwise we suppress flashing changes when filtering
	            return this.processingFilterChange;
	        }
	    };
	    FilterManager.prototype.isQuickFilterPresent = function () {
	        return this.quickFilter !== null;
	    };
	    FilterManager.prototype.doesRowPassOtherFilters = function (filterToSkip, node) {
	        return this.doesRowPassFilter(node, filterToSkip);
	    };
	    FilterManager.prototype.doesRowPassQuickFilterNoCache = function (node, filterPart) {
	        var _this = this;
	        var columns = this.columnController.getAllColumnsForQuickFilter();
	        var filterPasses = false;
	        columns.forEach(function (column) {
	            if (filterPasses) {
	                return;
	            }
	            var part = _this.getQuickFilterTextForColumn(column, node);
	            if (utils_1._.exists(part)) {
	                if (part.indexOf(filterPart) >= 0) {
	                    filterPasses = true;
	                }
	            }
	        });
	        return filterPasses;
	    };
	    FilterManager.prototype.doesRowPassQuickFilterCache = function (node, filterPart) {
	        if (!node.quickFilterAggregateText) {
	            this.aggregateRowForQuickFilter(node);
	        }
	        var filterPasses = node.quickFilterAggregateText.indexOf(filterPart) >= 0;
	        return filterPasses;
	    };
	    FilterManager.prototype.doesRowPassQuickFilter = function (node) {
	        var _this = this;
	        var filterPasses = true;
	        var usingCache = this.gridOptionsWrapper.isCacheQuickFilter();
	        this.quickFilterParts.forEach(function (filterPart) {
	            var partPasses = usingCache ?
	                _this.doesRowPassQuickFilterCache(node, filterPart) : _this.doesRowPassQuickFilterNoCache(node, filterPart);
	            // each part must pass, if any fails, then the whole filter fails
	            if (!partPasses) {
	                filterPasses = false;
	            }
	        });
	        return filterPasses;
	    };
	    FilterManager.prototype.doesRowPassFilter = function (node, filterToSkip) {
	        // the row must pass ALL of the filters, so if any of them fail,
	        // we return true. that means if a row passes the quick filter,
	        // but fails the column filter, it fails overall
	        // first up, check quick filter
	        if (this.isQuickFilterPresent()) {
	            if (!this.doesRowPassQuickFilter(node)) {
	                return false;
	            }
	        }
	        // secondly, give the client a chance to reject this row
	        if (this.externalFilterPresent) {
	            if (!this.gridOptionsWrapper.doesExternalFilterPass(node)) {
	                return false;
	            }
	        }
	        // lastly, check our internal advanced filter
	        if (this.advancedFilterPresent) {
	            if (!this.doesFilterPass(node, filterToSkip)) {
	                return false;
	            }
	        }
	        // got this far, all filters pass
	        return true;
	    };
	    FilterManager.prototype.getQuickFilterTextForColumn = function (column, rowNode) {
	        var value = this.valueService.getValue(column, rowNode, true);
	        var valueAfterCallback;
	        var colDef = column.getColDef();
	        if (column.getColDef().getQuickFilterText) {
	            var params = {
	                value: value,
	                node: rowNode,
	                data: rowNode.data,
	                column: column,
	                colDef: colDef,
	                context: this.gridOptionsWrapper.getContext()
	            };
	            valueAfterCallback = column.getColDef().getQuickFilterText(params);
	        }
	        else {
	            valueAfterCallback = value;
	        }
	        if (utils_1._.exists(valueAfterCallback)) {
	            return valueAfterCallback.toString().toUpperCase();
	        }
	        else {
	            return null;
	        }
	    };
	    FilterManager.prototype.aggregateRowForQuickFilter = function (node) {
	        var _this = this;
	        var stringParts = [];
	        var columns = this.columnController.getAllColumnsForQuickFilter();
	        columns.forEach(function (column) {
	            var part = _this.getQuickFilterTextForColumn(column, node);
	            if (utils_1._.exists(part)) {
	                stringParts.push(part);
	            }
	        });
	        node.quickFilterAggregateText = stringParts.join(FilterManager_1.QUICK_FILTER_SEPARATOR);
	    };
	    FilterManager.prototype.onNewRowsLoaded = function (source) {
	        utils_1._.iterateObject(this.allFilters, function (key, filterWrapper) {
	            filterWrapper.filterPromise.then(function (filter) {
	                if (filter.onNewRowsLoaded) {
	                    filter.onNewRowsLoaded();
	                }
	            });
	        });
	        this.updateFilterFlagInColumns(source);
	        this.setAdvancedFilterPresent();
	    };
	    FilterManager.prototype.createValueGetter = function (column) {
	        var _this = this;
	        return function (node) {
	            return _this.valueService.getValue(column, node, true);
	        };
	    };
	    FilterManager.prototype.getFilterComponent = function (column, source) {
	        var filterWrapper = this.getOrCreateFilterWrapper(column, source);
	        return filterWrapper.filterPromise;
	    };
	    FilterManager.prototype.isFilterActive = function (column) {
	        var filterWrapper = this.cachedFilter(column);
	        if (filterWrapper) {
	            return filterWrapper.filterPromise.resolveNow(false, function (filter) { return filter.isFilterActive(); });
	        }
	        else {
	            return false;
	        }
	    };
	    FilterManager.prototype.getOrCreateFilterWrapper = function (column, source) {
	        var filterWrapper = this.cachedFilter(column);
	        if (!filterWrapper) {
	            filterWrapper = this.createFilterWrapper(column, source);
	            this.allFilters[column.getColId()] = filterWrapper;
	        }
	        else {
	            if (source !== 'NO_UI') {
	                this.putIntoGui(filterWrapper, source);
	            }
	        }
	        return filterWrapper;
	    };
	    FilterManager.prototype.cachedFilter = function (column) {
	        return this.allFilters[column.getColId()];
	    };
	    FilterManager.prototype.createFilterInstance = function (column, $scope) {
	        var _this = this;
	        var defaultFilter = 'agTextColumnFilter';
	        if (this.gridOptionsWrapper.isEnterprise()) {
	            defaultFilter = 'agSetColumnFilter';
	        }
	        var sanitisedColDef = utils_1._.cloneObject(column.getColDef());
	        var filterInstance;
	        var params = this.createFilterParams(column, sanitisedColDef, $scope);
	        params.filterChangedCallback = this.onFilterChanged.bind(this);
	        params.filterModifiedCallback = function () {
	            var event = {
	                type: events_1.Events.EVENT_FILTER_MODIFIED,
	                api: _this.gridApi,
	                columnApi: _this.columnApi,
	                column: column,
	                filterInstance: filterInstance
	            };
	            _this.eventService.dispatchEvent(event);
	        };
	        // we modify params in a callback as we need the filter instance, and this isn't available
	        // when creating the params above
	        var modifyParamsCallback = function (params, filter) { return utils_1._.assign(params, {
	            doesRowPassOtherFilter: _this.doesRowPassOtherFilters.bind(_this, filter),
	        }); };
	        var res = this.userComponentFactory.newFilterComponent(sanitisedColDef, params, defaultFilter, modifyParamsCallback);
	        res.then(function (r) { return filterInstance = r; });
	        return res;
	    };
	    FilterManager.prototype.createFilterParams = function (column, colDef, $scope) {
	        if ($scope === void 0) { $scope = null; }
	        var params = {
	            api: this.gridOptionsWrapper.getApi(),
	            column: column,
	            colDef: colDef,
	            rowModel: this.rowModel,
	            filterChangedCallback: null,
	            filterModifiedCallback: null,
	            valueGetter: this.createValueGetter(column),
	            context: this.gridOptionsWrapper.getContext(),
	            doesRowPassOtherFilter: null
	        };
	        // hack in scope if using AngularJS
	        if ($scope) {
	            params.$scope = $scope;
	        }
	        return params;
	    };
	    FilterManager.prototype.createFilterWrapper = function (column, source) {
	        var filterWrapper = {
	            column: column,
	            filterPromise: null,
	            scope: null,
	            compiledElement: null,
	            guiPromise: utils_1.Promise.external()
	        };
	        filterWrapper.scope = this.gridOptionsWrapper.isAngularCompileFilters() ? this.$scope.$new() : null;
	        filterWrapper.filterPromise = this.createFilterInstance(column, filterWrapper.scope);
	        this.putIntoGui(filterWrapper, source);
	        return filterWrapper;
	    };
	    FilterManager.prototype.putIntoGui = function (filterWrapper, source) {
	        var _this = this;
	        var eFilterGui = document.createElement('div');
	        eFilterGui.className = 'ag-filter';
	        filterWrapper.filterPromise.then(function (filter) {
	            var guiFromFilter = filter.getGui();
	            if (utils_1._.missing(guiFromFilter)) {
	                console.warn("getGui method from filter returned " + guiFromFilter + ", it should be a DOM element or an HTML template string.");
	            }
	            // for backwards compatibility with Angular 1 - we
	            // used to allow providing back HTML from getGui().
	            // once we move away from supporting Angular 1
	            // directly, we can change this.
	            if (typeof guiFromFilter === 'string') {
	                guiFromFilter = utils_1._.loadTemplate(guiFromFilter);
	            }
	            eFilterGui.appendChild(guiFromFilter);
	            if (filterWrapper.scope) {
	                var compiledElement = _this.$compile(eFilterGui)(filterWrapper.scope);
	                filterWrapper.compiledElement = compiledElement;
	                window.setTimeout(function () { return filterWrapper.scope.$apply(); }, 0);
	            }
	            filterWrapper.guiPromise.resolve(eFilterGui);
	            _this.eventService.dispatchEvent({
	                type: events_1.Events.EVENT_FILTER_OPENED,
	                column: filterWrapper.column,
	                source: source,
	                eGui: eFilterGui,
	                api: _this.gridApi,
	                columnApi: _this.columnApi
	            });
	        });
	    };
	    FilterManager.prototype.onNewColumnsLoaded = function () {
	        var _this = this;
	        var atLeastOneFilterGone = false;
	        utils_1._.iterateObject(this.allFilters, function (key, filterWrapper) {
	            var oldColumn = !_this.columnController.getPrimaryColumn(filterWrapper.column);
	            if (oldColumn) {
	                atLeastOneFilterGone = true;
	                _this.disposeFilterWrapper(filterWrapper, "filterDestroyed");
	            }
	        });
	        if (atLeastOneFilterGone) {
	            this.onFilterChanged();
	        }
	    };
	    // destroys the filter, so it not longer takes part
	    FilterManager.prototype.destroyFilter = function (column, source) {
	        if (source === void 0) { source = "api"; }
	        var filterWrapper = this.allFilters[column.getColId()];
	        if (filterWrapper) {
	            this.disposeFilterWrapper(filterWrapper, source);
	            this.onFilterChanged();
	        }
	    };
	    FilterManager.prototype.disposeFilterWrapper = function (filterWrapper, source) {
	        var _this = this;
	        filterWrapper.filterPromise.then(function (filter) {
	            filter.setModel(null);
	            if (filter.destroy) {
	                filter.destroy();
	            }
	            filterWrapper.column.setFilterActive(false, source);
	            if (filterWrapper.scope) {
	                if (filterWrapper.compiledElement) {
	                    filterWrapper.compiledElement.remove();
	                }
	                filterWrapper.scope.$destroy();
	            }
	            delete _this.allFilters[filterWrapper.column.getColId()];
	        });
	    };
	    FilterManager.prototype.destroy = function () {
	        var _this = this;
	        utils_1._.iterateObject(this.allFilters, function (key, filterWrapper) {
	            _this.disposeFilterWrapper(filterWrapper, "filterDestroyed");
	        });
	    };
	    var FilterManager_1;
	    FilterManager.QUICK_FILTER_SEPARATOR = '\n';
	    __decorate([
	        context_1.Autowired('$compile'),
	        __metadata("design:type", Object)
	    ], FilterManager.prototype, "$compile", void 0);
	    __decorate([
	        context_1.Autowired('$scope'),
	        __metadata("design:type", Object)
	    ], FilterManager.prototype, "$scope", void 0);
	    __decorate([
	        context_1.Autowired('gridOptionsWrapper'),
	        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
	    ], FilterManager.prototype, "gridOptionsWrapper", void 0);
	    __decorate([
	        context_1.Autowired('popupService'),
	        __metadata("design:type", popupService_1.PopupService)
	    ], FilterManager.prototype, "popupService", void 0);
	    __decorate([
	        context_1.Autowired('valueService'),
	        __metadata("design:type", valueService_1.ValueService)
	    ], FilterManager.prototype, "valueService", void 0);
	    __decorate([
	        context_1.Autowired('columnController'),
	        __metadata("design:type", columnController_1.ColumnController)
	    ], FilterManager.prototype, "columnController", void 0);
	    __decorate([
	        context_1.Autowired('rowModel'),
	        __metadata("design:type", Object)
	    ], FilterManager.prototype, "rowModel", void 0);
	    __decorate([
	        context_1.Autowired('eventService'),
	        __metadata("design:type", eventService_1.EventService)
	    ], FilterManager.prototype, "eventService", void 0);
	    __decorate([
	        context_1.Autowired('enterprise'),
	        __metadata("design:type", Boolean)
	    ], FilterManager.prototype, "enterprise", void 0);
	    __decorate([
	        context_1.Autowired('context'),
	        __metadata("design:type", context_1.Context)
	    ], FilterManager.prototype, "context", void 0);
	    __decorate([
	        context_1.Autowired('columnApi'),
	        __metadata("design:type", columnApi_1.ColumnApi)
	    ], FilterManager.prototype, "columnApi", void 0);
	    __decorate([
	        context_1.Autowired('gridApi'),
	        __metadata("design:type", gridApi_1.GridApi)
	    ], FilterManager.prototype, "gridApi", void 0);
	    __decorate([
	        context_1.Autowired('userComponentFactory'),
	        __metadata("design:type", userComponentFactory_1.UserComponentFactory)
	    ], FilterManager.prototype, "userComponentFactory", void 0);
	    __decorate([
	        context_1.PostConstruct,
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", []),
	        __metadata("design:returntype", void 0)
	    ], FilterManager.prototype, "init", null);
	    __decorate([
	        context_1.PreDestroy,
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", []),
	        __metadata("design:returntype", void 0)
	    ], FilterManager.prototype, "destroy", null);
	    FilterManager = FilterManager_1 = __decorate([
	        context_1.Bean('filterManager')
	    ], FilterManager);
	    return FilterManager;
	}());
	exports.FilterManager = FilterManager;


/***/ }),
/* 2379 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var constants_1 = __webpack_require__(2328);
	var context_1 = __webpack_require__(2333);
	var gridOptionsWrapper_1 = __webpack_require__(2324);
	var environment_1 = __webpack_require__(2365);
	var eventService_1 = __webpack_require__(2331);
	var events_1 = __webpack_require__(2335);
	var utils_1 = __webpack_require__(2325);
	var PopupService = /** @class */ (function () {
	    function PopupService() {
	        this.popupList = [];
	    }
	    PopupService.prototype.registerGridCore = function (gridCore) {
	        this.gridCore = gridCore;
	    };
	    PopupService.prototype.getDocument = function () {
	        return this.gridOptionsWrapper.getDocument();
	    };
	    PopupService.prototype.getPopupParent = function () {
	        var ePopupParent = this.gridOptionsWrapper.getPopupParent();
	        if (ePopupParent) {
	            return ePopupParent;
	        }
	        return this.gridCore.getRootGui();
	    };
	    PopupService.prototype.positionPopupForMenu = function (params) {
	        var sourceRect = params.eventSource.getBoundingClientRect();
	        var eDocument = this.getDocument();
	        var popupParent = this.getPopupParent();
	        var parentRect;
	        if (popupParent === eDocument.body) {
	            parentRect = eDocument.documentElement.getBoundingClientRect();
	        }
	        else {
	            parentRect = popupParent.getBoundingClientRect();
	        }
	        var y = sourceRect.top - parentRect.top;
	        y = this.keepYWithinBounds(params, y);
	        var minWidth = (params.ePopup.clientWidth > 0) ? params.ePopup.clientWidth : 200;
	        params.ePopup.style.minWidth = minWidth + "px";
	        var widthOfParent = parentRect.right - parentRect.left;
	        var maxX = widthOfParent - minWidth;
	        // the x position of the popup depends on RTL or LTR. for normal cases, LTR, we put the child popup
	        // to the right, unless it doesn't fit and we then put it to the left. for RTL it's the other way around,
	        // we try place it first to the left, and then if not to the right.
	        var x;
	        if (this.gridOptionsWrapper.isEnableRtl()) {
	            // for RTL, try left first
	            x = xLeftPosition();
	            if (x < 0) {
	                x = xRightPosition();
	            }
	            if (x > maxX) {
	                x = 0;
	            }
	        }
	        else {
	            // for LTR, try right first
	            x = xRightPosition();
	            if (x > maxX) {
	                x = xLeftPosition();
	            }
	            if (x < 0) {
	                x = 0;
	            }
	        }
	        params.ePopup.style.left = x + "px";
	        params.ePopup.style.top = y + "px";
	        function xRightPosition() {
	            return sourceRect.right - parentRect.left - 2;
	        }
	        function xLeftPosition() {
	            return sourceRect.left - parentRect.left - minWidth;
	        }
	    };
	    PopupService.prototype.positionPopupUnderMouseEvent = function (params) {
	        var _a = this.calculatePointerAlign(params.mouseEvent), x = _a.x, y = _a.y;
	        var ePopup = params.ePopup, nudgeX = params.nudgeX, nudgeY = params.nudgeY;
	        this.positionPopup({
	            ePopup: ePopup,
	            x: x,
	            y: y,
	            nudgeX: nudgeX,
	            nudgeY: nudgeY,
	            keepWithinBounds: true
	        });
	        this.callPostProcessPopup(params.ePopup, null, params.mouseEvent, params.type, params.column, params.rowNode);
	    };
	    PopupService.prototype.calculatePointerAlign = function (e) {
	        var eDocument = this.getDocument();
	        var popupParent = this.getPopupParent();
	        var parentRect = popupParent.getBoundingClientRect();
	        var documentRect = eDocument.documentElement.getBoundingClientRect();
	        return {
	            x: e.clientX - (popupParent === eDocument.body ? documentRect.left : parentRect.left),
	            y: e.clientY - (popupParent === eDocument.body ? documentRect.top : parentRect.top)
	        };
	    };
	    PopupService.prototype.positionPopupUnderComponent = function (params) {
	        var sourceRect = params.eventSource.getBoundingClientRect();
	        var eDocument = this.getDocument();
	        var popupParent = this.getPopupParent();
	        var alignSide = params.alignSide || 'left';
	        var parentRect;
	        if (popupParent === eDocument.body) {
	            parentRect = eDocument.documentElement.getBoundingClientRect();
	        }
	        else {
	            parentRect = popupParent.getBoundingClientRect();
	        }
	        var x = sourceRect.left - parentRect.left;
	        if (alignSide === 'right') {
	            x -= (params.ePopup.offsetWidth - sourceRect.width);
	        }
	        this.positionPopup({
	            ePopup: params.ePopup,
	            minWidth: params.minWidth,
	            minHeight: params.minHeight,
	            nudgeX: params.nudgeX,
	            nudgeY: params.nudgeY,
	            x: x,
	            y: sourceRect.top - parentRect.top + sourceRect.height,
	            keepWithinBounds: params.keepWithinBounds
	        });
	        this.callPostProcessPopup(params.ePopup, params.eventSource, null, params.type, params.column, params.rowNode);
	    };
	    PopupService.prototype.positionPopupOverComponent = function (params) {
	        var sourceRect = params.eventSource.getBoundingClientRect();
	        var eDocument = this.getDocument();
	        var popupParent = this.getPopupParent();
	        var parentRect;
	        if (popupParent === eDocument.body) {
	            parentRect = eDocument.documentElement.getBoundingClientRect();
	        }
	        else {
	            parentRect = popupParent.getBoundingClientRect();
	        }
	        this.positionPopup({
	            ePopup: params.ePopup,
	            minWidth: params.minWidth,
	            nudgeX: params.nudgeX,
	            nudgeY: params.nudgeY,
	            x: sourceRect.left - parentRect.left,
	            y: sourceRect.top - parentRect.top,
	            keepWithinBounds: params.keepWithinBounds
	        });
	        this.callPostProcessPopup(params.ePopup, params.eventSource, null, params.type, params.column, params.rowNode);
	    };
	    PopupService.prototype.callPostProcessPopup = function (ePopup, eventSource, mouseEvent, type, column, rowNode) {
	        var callback = this.gridOptionsWrapper.getPostProcessPopupFunc();
	        if (callback) {
	            var params = {
	                column: column,
	                rowNode: rowNode,
	                ePopup: ePopup,
	                type: type,
	                eventSource: eventSource,
	                mouseEvent: mouseEvent
	            };
	            callback(params);
	        }
	    };
	    PopupService.prototype.positionPopup = function (params) {
	        var x = params.x;
	        var y = params.y;
	        if (params.nudgeX) {
	            x += params.nudgeX;
	        }
	        if (params.nudgeY) {
	            y += params.nudgeY;
	        }
	        // if popup is overflowing to the bottom, move it up
	        if (params.keepWithinBounds) {
	            x = this.keepXWithinBounds(params, x);
	            y = this.keepYWithinBounds(params, y);
	        }
	        params.ePopup.style.left = x + "px";
	        params.ePopup.style.top = y + "px";
	    };
	    PopupService.prototype.keepYWithinBounds = function (params, y) {
	        var eDocument = this.gridOptionsWrapper.getDocument();
	        var docElement = eDocument.documentElement;
	        var popupParent = this.getPopupParent();
	        var parentRect = popupParent.getBoundingClientRect();
	        var documentRect = eDocument.documentElement.getBoundingClientRect();
	        var isBody = popupParent === eDocument.body;
	        var defaultPadding = 3;
	        var minHeight = Math.min(200, parentRect.height);
	        var diff = 0;
	        if (params.minHeight && params.minHeight < minHeight) {
	            minHeight = params.minHeight;
	        }
	        else if (params.ePopup.offsetHeight > 0) {
	            minHeight = params.ePopup.clientHeight;
	            diff = utils_1._.getAbsoluteHeight(params.ePopup) - minHeight;
	        }
	        var heightOfParent = isBody ? (utils_1._.getAbsoluteHeight(docElement) + docElement.scrollTop) : parentRect.height;
	        if (isBody) {
	            heightOfParent -= Math.abs(documentRect.top - parentRect.top);
	        }
	        var maxY = heightOfParent - minHeight - diff - defaultPadding;
	        return Math.min(Math.max(y, 0), Math.abs(maxY));
	    };
	    PopupService.prototype.keepXWithinBounds = function (params, x) {
	        var eDocument = this.gridOptionsWrapper.getDocument();
	        var docElement = eDocument.documentElement;
	        var popupParent = this.getPopupParent();
	        var parentRect = popupParent.getBoundingClientRect();
	        var documentRect = eDocument.documentElement.getBoundingClientRect();
	        var isBody = popupParent === eDocument.body;
	        var defaultPadding = 3;
	        var ePopup = params.ePopup;
	        var minWidth = Math.min(200, parentRect.width);
	        var diff = 0;
	        if (params.minWidth && params.minWidth < minWidth) {
	            minWidth = params.minWidth;
	        }
	        else if (ePopup.offsetWidth > 0) {
	            minWidth = ePopup.offsetWidth;
	            ePopup.style.minWidth = minWidth + "px";
	            diff = utils_1._.getAbsoluteWidth(ePopup) - minWidth;
	        }
	        var widthOfParent = isBody ? (utils_1._.getAbsoluteWidth(docElement) + docElement.scrollLeft) : parentRect.width;
	        if (isBody) {
	            widthOfParent -= Math.abs(documentRect.left - parentRect.left);
	        }
	        var maxX = widthOfParent - minWidth - diff - defaultPadding;
	        return Math.min(Math.max(x, 0), Math.abs(maxX));
	    };
	    // adds an element to a div, but also listens to background checking for clicks,
	    // so that when the background is clicked, the child is removed again, giving
	    // a model look to popups.
	    PopupService.prototype.addAsModalPopup = function (eChild, closeOnEsc, closedCallback, click) {
	        return this.addPopup(true, eChild, closeOnEsc, closedCallback, click);
	    };
	    PopupService.prototype.addPopup = function (modal, eChild, closeOnEsc, closedCallback, click, alwaysOnTop) {
	        var _this = this;
	        var eDocument = this.gridOptionsWrapper.getDocument();
	        if (!eDocument) {
	            console.warn('ag-grid: could not find the document, document is empty');
	            return function () { };
	        }
	        var pos = utils_1._.findIndex(this.popupList, function (popup) { return popup.element === eChild; });
	        if (pos !== -1) {
	            var popup = this.popupList[pos];
	            return popup.hideFunc;
	        }
	        var ePopupParent = this.getPopupParent();
	        // for angular specifically, but shouldn't cause an issue with js or other fw's
	        // https://github.com/angular/angular/issues/8563
	        ePopupParent.appendChild(eChild);
	        eChild.style.top = '0px';
	        eChild.style.left = '0px';
	        // add env CSS class to child, in case user provided a popup parent, which means
	        // theme class may be missing
	        var eWrapper = document.createElement('div');
	        var theme = this.environment.getTheme().theme;
	        if (theme) {
	            utils_1._.addCssClass(eWrapper, theme);
	        }
	        utils_1._.addCssClass(eWrapper, 'ag-popup');
	        utils_1._.addCssClass(eChild, this.gridOptionsWrapper.isEnableRtl() ? 'ag-rtl' : 'ag-ltr');
	        eWrapper.appendChild(eChild);
	        ePopupParent.appendChild(eWrapper);
	        if (alwaysOnTop) {
	            this.setAlwaysOnTop(eWrapper, true);
	        }
	        else {
	            this.bringPopupToFront(eWrapper);
	        }
	        var popupHidden = false;
	        var hidePopupOnKeyboardEvent = function (event) {
	            var key = event.which || event.keyCode;
	            if (key === constants_1.Constants.KEY_ESCAPE && eWrapper.contains(document.activeElement)) {
	                hidePopup(null);
	            }
	        };
	        var hidePopupOnMouseEvent = function (event) {
	            hidePopup(event);
	        };
	        var hidePopupOnTouchEvent = function (event) {
	            hidePopup(null, event);
	        };
	        var hidePopup = function (mouseEvent, touchEvent) {
	            if (
	            // we don't hide popup if the event was on the child, or any
	            // children of this child
	            _this.isEventFromCurrentPopup(mouseEvent, touchEvent, eChild) ||
	                // if the event to close is actually the open event, then ignore it
	                _this.isEventSameChainAsOriginalEvent(click, mouseEvent, touchEvent) ||
	                // this method should only be called once. the client can have different
	                // paths, each one wanting to close, so this method may be called multiple times.
	                popupHidden) {
	                return;
	            }
	            popupHidden = true;
	            ePopupParent.removeChild(eWrapper);
	            eDocument.removeEventListener('keydown', hidePopupOnKeyboardEvent);
	            eDocument.removeEventListener('mousedown', hidePopupOnMouseEvent);
	            eDocument.removeEventListener('touchstart', hidePopupOnTouchEvent);
	            eDocument.removeEventListener('contextmenu', hidePopupOnMouseEvent);
	            _this.eventService.removeEventListener(events_1.Events.EVENT_DRAG_STARTED, hidePopupOnMouseEvent);
	            if (closedCallback) {
	                closedCallback();
	            }
	            _this.popupList = _this.popupList.filter(function (popup) { return popup.element !== eChild; });
	        };
	        // if we add these listeners now, then the current mouse
	        // click will be included, which we don't want
	        window.setTimeout(function () {
	            if (closeOnEsc) {
	                eDocument.addEventListener('keydown', hidePopupOnKeyboardEvent);
	            }
	            if (modal) {
	                eDocument.addEventListener('mousedown', hidePopupOnMouseEvent);
	                _this.eventService.addEventListener(events_1.Events.EVENT_DRAG_STARTED, hidePopupOnMouseEvent);
	                eDocument.addEventListener('touchstart', hidePopupOnTouchEvent);
	                eDocument.addEventListener('contextmenu', hidePopupOnMouseEvent);
	            }
	        }, 0);
	        this.popupList.push({
	            element: eChild,
	            hideFunc: hidePopup
	        });
	        return hidePopup;
	    };
	    PopupService.prototype.isEventFromCurrentPopup = function (mouseEvent, touchEvent, eChild) {
	        var event = mouseEvent ? mouseEvent : touchEvent;
	        if (!event) {
	            return false;
	        }
	        var indexOfThisChild = utils_1._.findIndex(this.popupList, function (popup) { return popup.element === eChild; });
	        if (indexOfThisChild === -1) {
	            return false;
	        }
	        for (var i = indexOfThisChild; i < this.popupList.length; i++) {
	            var popup = this.popupList[i];
	            if (utils_1._.isElementInEventPath(popup.element, event)) {
	                return true;
	            }
	        }
	        // if the user did not write their own Custom Element to be rendered as popup
	        // and this component has additional popup element, they should have the
	        // `ag-custom-component-popup` class to be detected as part of the Custom Component
	        var el = event.target;
	        while (el && el != document.body) {
	            if (el.classList.contains('ag-custom-component-popup') || el.parentElement === null) {
	                return true;
	            }
	            el = el.parentElement;
	        }
	    };
	    // in some browsers, the context menu event can be fired before the click event, which means
	    // the context menu event could open the popup, but then the click event closes it straight away.
	    PopupService.prototype.isEventSameChainAsOriginalEvent = function (originalClick, mouseEvent, touchEvent) {
	        // we check the coordinates of the event, to see if it's the same event. there is a 1 / 1000 chance that
	        // the event is a different event, however that is an edge case that is not very relevant (the user clicking
	        // twice on the same location isn't a normal path).
	        // event could be mouse event or touch event.
	        var mouseEventOrTouch = null;
	        if (mouseEvent) {
	            // mouse event can be used direction, it has coordinates
	            mouseEventOrTouch = mouseEvent;
	        }
	        else if (touchEvent) {
	            // touch event doesn't have coordinates, need it's touch object
	            mouseEventOrTouch = touchEvent.touches[0];
	        }
	        if (mouseEventOrTouch && originalClick) {
	            // for x, allow 4px margin, to cover iPads, where touch (which opens menu) is followed
	            // by browser click (when you life finger up, touch is interrupted as click in browser)
	            var screenX_1 = mouseEvent ? mouseEvent.screenX : 0;
	            var screenY_1 = mouseEvent ? mouseEvent.screenY : 0;
	            var xMatch = Math.abs(originalClick.screenX - screenX_1) < 5;
	            var yMatch = Math.abs(originalClick.screenY - screenY_1) < 5;
	            if (xMatch && yMatch) {
	                return true;
	            }
	        }
	        return false;
	    };
	    PopupService.prototype.getWrapper = function (ePopup) {
	        while (!utils_1._.containsClass(ePopup, 'ag-popup') && ePopup.parentElement) {
	            ePopup = ePopup.parentElement;
	        }
	        return utils_1._.containsClass(ePopup, 'ag-popup') ? ePopup : null;
	    };
	    PopupService.prototype.setAlwaysOnTop = function (ePopup, alwaysOnTop) {
	        var eWrapper = this.getWrapper(ePopup);
	        if (!eWrapper) {
	            return;
	        }
	        utils_1._.addOrRemoveCssClass(eWrapper, 'ag-always-on-top', !!alwaysOnTop);
	        if (alwaysOnTop) {
	            this.bringPopupToFront(eWrapper);
	        }
	    };
	    PopupService.prototype.bringPopupToFront = function (ePopup) {
	        var parent = this.getPopupParent();
	        var popupList = Array.prototype.slice.call(parent.querySelectorAll('.ag-popup'));
	        var popupLen = popupList.length;
	        var alwaysOnTopList = Array.prototype.slice.call(parent.querySelectorAll('.ag-popup.ag-always-on-top'));
	        var onTopLength = alwaysOnTopList.length;
	        var eWrapper = this.getWrapper(ePopup);
	        if (!eWrapper || popupLen <= 1 || !parent.contains(ePopup)) {
	            return;
	        }
	        var pos = popupList.indexOf(eWrapper);
	        if (onTopLength) {
	            var isPopupAlwaysOnTop = utils_1._.containsClass(eWrapper, 'ag-always-on-top');
	            if (isPopupAlwaysOnTop) {
	                if (pos !== popupLen - 1) {
	                    utils_1._.last(alwaysOnTopList).insertAdjacentElement('afterend', eWrapper);
	                }
	            }
	            else if (pos !== popupLen - onTopLength - 1) {
	                alwaysOnTopList[0].insertAdjacentElement('beforebegin', eWrapper);
	            }
	        }
	        else if (pos !== popupLen - 1) {
	            utils_1._.last(popupList).insertAdjacentElement('afterend', eWrapper);
	        }
	        var params = {
	            type: 'popupToFront',
	            api: this.gridOptionsWrapper.getApi(),
	            columnApi: this.gridOptionsWrapper.getColumnApi(),
	            eWrapper: eWrapper
	        };
	        this.eventService.dispatchEvent(params);
	    };
	    __decorate([
	        context_1.Autowired('gridOptionsWrapper'),
	        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
	    ], PopupService.prototype, "gridOptionsWrapper", void 0);
	    __decorate([
	        context_1.Autowired('environment'),
	        __metadata("design:type", environment_1.Environment)
	    ], PopupService.prototype, "environment", void 0);
	    __decorate([
	        context_1.Autowired('eventService'),
	        __metadata("design:type", eventService_1.EventService)
	    ], PopupService.prototype, "eventService", void 0);
	    PopupService = __decorate([
	        context_1.Bean('popupService')
	    ], PopupService);
	    return PopupService;
	}());
	exports.PopupService = PopupService;


/***/ }),
/* 2380 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var context_1 = __webpack_require__(2333);
	var gridOptionsWrapper_1 = __webpack_require__(2324);
	var userComponentRegistry_1 = __webpack_require__(2381);
	var agComponentUtils_1 = __webpack_require__(2414);
	var componentMetadataProvider_1 = __webpack_require__(2415);
	var utils_1 = __webpack_require__(2325);
	var ComponentSource;
	(function (ComponentSource) {
	    ComponentSource[ComponentSource["DEFAULT"] = 0] = "DEFAULT";
	    ComponentSource[ComponentSource["REGISTERED_BY_NAME"] = 1] = "REGISTERED_BY_NAME";
	    ComponentSource[ComponentSource["HARDCODED"] = 2] = "HARDCODED";
	})(ComponentSource = exports.ComponentSource || (exports.ComponentSource = {}));
	var UserComponentFactory = /** @class */ (function () {
	    function UserComponentFactory() {
	    }
	    UserComponentFactory.prototype.newDateComponent = function (params) {
	        return this.createAndInitUserComponent(this.gridOptions, params, "dateComponent", "agDateInput");
	    };
	    UserComponentFactory.prototype.newHeaderComponent = function (params) {
	        return this.createAndInitUserComponent(params.column.getColDef(), params, "headerComponent", "agColumnHeader");
	    };
	    UserComponentFactory.prototype.newHeaderGroupComponent = function (params) {
	        return this.createAndInitUserComponent(params.columnGroup.getColGroupDef(), params, "headerGroupComponent", "agColumnGroupHeader");
	    };
	    UserComponentFactory.prototype.newFullWidthGroupRowInnerCellRenderer = function (params) {
	        return this.createAndInitUserComponent(this.gridOptions, params, "groupRowInnerRenderer", null, true);
	    };
	    // this one is unusual, as it can be LoadingCellRenderer, DetailCellRenderer, FullWidthCellRenderer or GroupRowRenderer.
	    // so we have to pass the type in.
	    UserComponentFactory.prototype.newFullWidthCellRenderer = function (params, cellRendererType, cellRendererName) {
	        return this.createAndInitUserComponent(null, params, cellRendererType, cellRendererName);
	    };
	    UserComponentFactory.prototype.newCellRenderer = function (target, params) {
	        return this.createAndInitUserComponent(target, params, "cellRenderer", null, true);
	    };
	    UserComponentFactory.prototype.newPinnedRowCellRenderer = function (target, params) {
	        return this.createAndInitUserComponent(target, params, "pinnedRowCellRenderer", null, true);
	    };
	    UserComponentFactory.prototype.newCellEditor = function (colDef, params) {
	        return this.createAndInitUserComponent(colDef, params, 'cellEditor', 'agCellEditor');
	    };
	    UserComponentFactory.prototype.newInnerCellRenderer = function (target, params) {
	        return this.createAndInitUserComponent(target, params, "innerRenderer", null);
	    };
	    UserComponentFactory.prototype.newLoadingOverlayComponent = function (params) {
	        return this.createAndInitUserComponent(this.gridOptions, params, "loadingOverlayComponent", "agLoadingOverlay");
	    };
	    UserComponentFactory.prototype.newNoRowsOverlayComponent = function (params) {
	        return this.createAndInitUserComponent(this.gridOptions, params, "noRowsOverlayComponent", "agNoRowsOverlay");
	    };
	    UserComponentFactory.prototype.newTooltipComponent = function (params) {
	        var colDef = params.colDef;
	        return this.createAndInitUserComponent(colDef, params, "tooltipComponent", 'agTooltipComponent');
	    };
	    UserComponentFactory.prototype.newFilterComponent = function (colDef, params, defaultFilter, modifyParamsCallback) {
	        return this.createAndInitUserComponent(colDef, params, 'filter', defaultFilter, false, modifyParamsCallback);
	    };
	    UserComponentFactory.prototype.newFloatingFilterComponent = function (colDef, params, defaultFloatingFilter) {
	        return this.createAndInitUserComponent(colDef, params, "floatingFilterComponent", defaultFloatingFilter, true);
	    };
	    UserComponentFactory.prototype.newToolPanelComponent = function (toolPanelDef, params) {
	        return this.createAndInitUserComponent(toolPanelDef, params, 'toolPanel');
	    };
	    UserComponentFactory.prototype.newStatusPanelComponent = function (def, params) {
	        return this.createAndInitUserComponent(def, params, 'statusPanel');
	    };
	    /**
	     * This method creates a component given everything needed to guess what sort of component needs to be instantiated
	     * It takes
	     *  @param definitionObject: This is the context for which this component needs to be created, it can be gridOptions
	     *      (global) or columnDef mostly.
	     *  @param paramsFromGrid: Params to be passed to the component and passed by ag-Grid. This will get merged with any params
	     *      specified by the user in the configuration
	     *  @param propertyName: The name of the property used in ag-grid as a convention to refer to the component, it can be:
	     *      'floatingFilter', 'cellRenderer', is used to find if the user is specifying a custom component
	     *  @param defaultComponentName: The actual name of the component to instantiate, this is usually the same as propertyName, but in
	     *      some cases is not, like floatingFilter, if it is the same is not necessary to specify
	     *  @param optional: Handy method to tell if this should return a component ALWAYS. if that is the case, but there is no
	     *      component found, it throws an error, by default all components are MANDATORY
	     *  @param modifyParamsCallback: A chance to customise the params passed to the init method. It receives what the current
	     *  params are and the component that init is about to get called for
	     */
	    UserComponentFactory.prototype.createAndInitUserComponent = function (definitionObject, paramsFromGrid, propertyName, defaultComponentName, 
	    // optional items are: FloatingFilter, CellComp (for cellRenderer)
	    optional, 
	    // used by FilterManager only
	    modifyParamsCallback) {
	        if (optional === void 0) { optional = false; }
	        if (!definitionObject) {
	            definitionObject = this.gridOptions;
	        }
	        // Create the component instance
	        var componentAndParams = this.createComponentInstance(definitionObject, propertyName, paramsFromGrid, defaultComponentName, optional);
	        if (!componentAndParams) {
	            return null;
	        }
	        var componentInstance = componentAndParams.componentInstance;
	        // Wire the component and call the init method with the correct params
	        var params = this.createFinalParams(definitionObject, propertyName, paramsFromGrid, componentAndParams.paramsFromSelector);
	        this.addReactHacks(params);
	        // give caller chance to set any params that depend on the componentInstance (need here as the
	        // componentInstance was not available when createUserComponent was called)
	        var paramsAfterCallback = modifyParamsCallback ? modifyParamsCallback(params, componentInstance) : params;
	        var deferredInit = this.initComponent(componentInstance, paramsAfterCallback);
	        if (deferredInit == null) {
	            // const p = new Promise<A>(resolve => {
	            //     setTimeout( ()=> {
	            //         resolve(componentInstance);
	            //     }, 1000);
	            // });
	            // return p;
	            return utils_1.Promise.resolve(componentInstance);
	        }
	        else {
	            var asPromise = deferredInit;
	            return asPromise.map(function (notRelevant) { return componentInstance; });
	        }
	    };
	    UserComponentFactory.prototype.addReactHacks = function (params) {
	        // a temporary fix for AG-1574
	        // AG-1715 raised to do a wider ranging refactor to improve this
	        var agGridReact = this.context.getBean('agGridReact');
	        if (agGridReact) {
	            params.agGridReact = utils_1._.cloneObject(agGridReact);
	        }
	        // AG-1716 - directly related to AG-1574 and AG-1715
	        var frameworkComponentWrapper = this.context.getBean('frameworkComponentWrapper');
	        if (frameworkComponentWrapper) {
	            params.frameworkComponentWrapper = frameworkComponentWrapper;
	        }
	    };
	    /**
	     * This method creates a component given everything needed to guess what sort of component needs to be instantiated
	     * It takes
	     *  @param clazz: The class to instantiate,
	     *  @param agGridParams: Params to be passed to the component and passed by ag-Grid. This will get merged with any params
	     *      specified by the user in the configuration
	     *  @param modifyParamsCallback: A chance to customise the params passed to the init method. It receives what the current
	     *  params are and the component that init is about to get called for
	     */
	    UserComponentFactory.prototype.createUserComponentFromConcreteClass = function (clazz, agGridParams) {
	        var internalComponent = new clazz();
	        this.initComponent(internalComponent, agGridParams);
	        return internalComponent;
	    };
	    /**
	     * This method returns the underlying representation of the component to be created. ie for Javascript the
	     * underlying function where we should be calling new into. In case of the frameworks, the framework class
	     * object that represents the component to be created.
	     *
	     * This method is handy for different reasons, for example if you want to check if a component has a particular
	     * method implemented without having to create the component, just by inspecting the source component
	     *
	     * It takes
	     *  @param definitionObject: This is the context for which this component needs to be created, it can be gridOptions
	     *      (global) or columnDef mostly.
	     *  @param propertyName: The name of the property used in ag-grid as a convention to refer to the component, it can be:
	     *      'floatingFilter', 'cellRenderer', is used to find if the user is specifying a custom component
	     *  @param params: Params to be passed to the dynamic component function in case it needs to be
	     *      invoked
	     *  @param defaultComponentName: The name of the component to load if there is no component specified
	     */
	    UserComponentFactory.prototype.lookupComponentClassDef = function (definitionObject, propertyName, params, defaultComponentName) {
	        if (params === void 0) { params = null; }
	        /**
	         * There are five things that can happen when resolving a component.
	         *  a) HardcodedFwComponent: That holder[propertyName]Framework has associated a Framework native component
	         *  b) HardcodedJsComponent: That holder[propertyName] has associate a JS component
	         *  c) hardcodedJsFunction: That holder[propertyName] has associate a JS function
	         *  d) hardcodedNameComponent: That holder[propertyName] has associate a string that represents a component to load
	         *  e) That none of the three previous are specified, then we need to use the DefaultRegisteredComponent
	         */
	        var hardcodedNameComponent = null;
	        var HardcodedJsComponent = null;
	        var hardcodedJsFunction = null;
	        var HardcodedFwComponent = null;
	        var componentSelectorFunc;
	        if (definitionObject != null) {
	            var componentPropertyValue = definitionObject[propertyName];
	            // for filters only, we allow 'true' for the component, which means default filter to be used
	            var usingDefaultComponent = componentPropertyValue === true;
	            if (componentPropertyValue != null && !usingDefaultComponent) {
	                if (typeof componentPropertyValue === 'string') {
	                    hardcodedNameComponent = componentPropertyValue;
	                }
	                else if (typeof componentPropertyValue === 'boolean') {
	                    // never happens, as we test for usingDefaultComponent above,
	                    // however it's needed for the next block to compile
	                }
	                else if (this.agComponentUtils.doesImplementIComponent(componentPropertyValue)) {
	                    HardcodedJsComponent = componentPropertyValue;
	                }
	                else {
	                    hardcodedJsFunction = componentPropertyValue;
	                }
	            }
	            HardcodedFwComponent = definitionObject[propertyName + "Framework"];
	            componentSelectorFunc = definitionObject[propertyName + "Selector"];
	        }
	        /**
	         * Since we allow many types of flavors for specifying the components, let's make sure this is not an illegal
	         * combination
	         */
	        if ((HardcodedJsComponent && HardcodedFwComponent) ||
	            (hardcodedNameComponent && HardcodedFwComponent) ||
	            (hardcodedJsFunction && HardcodedFwComponent)) {
	            throw Error("ag-grid: you are trying to specify: " + propertyName + " twice as a component.");
	        }
	        if (HardcodedFwComponent && !this.frameworkComponentWrapper) {
	            throw Error("ag-grid: you are specifying a framework component but you are not using a framework version of ag-grid for : " + propertyName);
	        }
	        if (componentSelectorFunc && (hardcodedNameComponent || HardcodedJsComponent || hardcodedJsFunction || HardcodedFwComponent)) {
	            throw Error("ag-grid: you can't specify both, the selector and the component of ag-grid for : " + propertyName);
	        }
	        /**
	         * At this stage we are guaranteed to either have,
	         * DEPRECATED
	         * - A unique HardcodedFwComponent
	         * - A unique HardcodedJsComponent
	         * - A unique hardcodedJsFunction
	         * BY NAME- FAVOURED APPROACH
	         * - A unique hardcodedNameComponent
	         * - None of the previous, hence we revert to: RegisteredComponent
	         */
	        if (HardcodedFwComponent) {
	            // console.warn(`ag-grid: Since version 12.1.0 specifying a component directly is deprecated, you should register the component by name`);
	            // console.warn(`${HardcodedFwComponent}`);
	            return {
	                componentFromFramework: true,
	                component: HardcodedFwComponent,
	                source: ComponentSource.HARDCODED,
	                paramsFromSelector: null
	            };
	        }
	        if (HardcodedJsComponent) {
	            // console.warn(`ag-grid: Since version 12.1.0 specifying a component directly is deprecated, you should register the component by name`);
	            // console.warn(`${HardcodedJsComponent}`);
	            return {
	                componentFromFramework: false,
	                component: HardcodedJsComponent,
	                source: ComponentSource.HARDCODED,
	                paramsFromSelector: null
	            };
	        }
	        if (hardcodedJsFunction) {
	            // console.warn(`ag-grid: Since version 12.1.0 specifying a function directly is deprecated, you should register the component by name`);
	            // console.warn(`${hardcodedJsFunction}`);
	            return this.agComponentUtils.adaptFunction(propertyName, hardcodedJsFunction, false, ComponentSource.HARDCODED);
	        }
	        var selectorResult = componentSelectorFunc ? componentSelectorFunc(params) : null;
	        var componentNameToUse;
	        if (selectorResult && selectorResult.component) {
	            componentNameToUse = selectorResult.component;
	        }
	        else if (hardcodedNameComponent) {
	            componentNameToUse = hardcodedNameComponent;
	        }
	        else {
	            componentNameToUse = defaultComponentName;
	        }
	        if (!componentNameToUse) {
	            return null;
	        }
	        var registeredCompClassDef = this.lookupFromRegisteredComponents(propertyName, componentNameToUse);
	        return {
	            componentFromFramework: registeredCompClassDef.componentFromFramework,
	            component: registeredCompClassDef.component,
	            source: registeredCompClassDef.source,
	            paramsFromSelector: selectorResult ? selectorResult.params : null
	        };
	    };
	    UserComponentFactory.prototype.lookupFromRegisteredComponents = function (propertyName, componentNameOpt) {
	        var componentName = componentNameOpt != null ? componentNameOpt : propertyName;
	        var registeredComponent = this.userComponentRegistry.retrieve(componentName);
	        if (registeredComponent == null) {
	            return null;
	        }
	        //If it is a FW it has to be registered as a component
	        if (registeredComponent.componentFromFramework) {
	            return {
	                component: registeredComponent.component,
	                componentFromFramework: true,
	                source: ComponentSource.REGISTERED_BY_NAME,
	                paramsFromSelector: null
	            };
	        }
	        //If it is JS it may be a function or a component
	        if (this.agComponentUtils.doesImplementIComponent(registeredComponent.component)) {
	            return {
	                component: registeredComponent.component,
	                componentFromFramework: false,
	                source: (registeredComponent.source == userComponentRegistry_1.RegisteredComponentSource.REGISTERED) ? ComponentSource.REGISTERED_BY_NAME : ComponentSource.DEFAULT,
	                paramsFromSelector: null
	            };
	        }
	        // This is a function
	        return this.agComponentUtils.adaptFunction(propertyName, registeredComponent.component, registeredComponent.componentFromFramework, (registeredComponent.source == userComponentRegistry_1.RegisteredComponentSource.REGISTERED) ? ComponentSource.REGISTERED_BY_NAME : ComponentSource.DEFAULT);
	    };
	    /**
	     * Useful to check what would be the resultant params for a given object
	     *  @param definitionObject: This is the context for which this component needs to be created, it can be gridOptions
	     *      (global) or columnDef mostly.
	     *  @param propertyName: The name of the property used in ag-grid as a convention to refer to the component, it can be:
	     *      'floatingFilter', 'cellRenderer', is used to find if the user is specifying a custom component
	     *  @param paramsFromGrid: Params to be passed to the component and passed by ag-Grid. This will get merged with any params
	     *      specified by the user in the configuration
	     * @returns {any} It merges the user agGridParams with the actual params specified by the user.
	     */
	    UserComponentFactory.prototype.createFinalParams = function (definitionObject, propertyName, paramsFromGrid, paramsFromSelector) {
	        if (paramsFromSelector === void 0) { paramsFromSelector = null; }
	        var res = {};
	        utils_1._.mergeDeep(res, paramsFromGrid);
	        var userParams = definitionObject ? definitionObject[propertyName + "Params"] : null;
	        if (userParams != null) {
	            if (typeof userParams === 'function') {
	                utils_1._.mergeDeep(res, userParams(paramsFromGrid));
	            }
	            else if (typeof userParams === 'object') {
	                utils_1._.mergeDeep(res, userParams);
	            }
	        }
	        utils_1._.mergeDeep(res, paramsFromSelector);
	        return res;
	    };
	    UserComponentFactory.prototype.createComponentInstance = function (holder, propertyName, paramsForSelector, defaultComponentName, optional) {
	        var componentToUse = this.lookupComponentClassDef(holder, propertyName, paramsForSelector, defaultComponentName);
	        var missing = !componentToUse || !componentToUse.component;
	        if (missing) {
	            if (!optional) {
	                console.error("Error creating component " + propertyName + "=>" + defaultComponentName);
	            }
	            return null;
	        }
	        var componentInstance;
	        if (componentToUse.componentFromFramework) {
	            // Using framework component
	            var FrameworkComponentRaw = componentToUse.component;
	            var thisComponentConfig = this.componentMetadataProvider.retrieve(propertyName);
	            componentInstance = this.frameworkComponentWrapper.wrap(FrameworkComponentRaw, thisComponentConfig.mandatoryMethodList, thisComponentConfig.optionalMethodList, defaultComponentName);
	        }
	        else {
	            // Using plain JavaScript component
	            componentInstance = new componentToUse.component();
	        }
	        return { componentInstance: componentInstance, paramsFromSelector: componentToUse.paramsFromSelector };
	    };
	    UserComponentFactory.prototype.initComponent = function (component, finalParams) {
	        this.context.wireBean(component);
	        if (component.init == null) {
	            return;
	        }
	        else {
	            return component.init(finalParams);
	        }
	    };
	    __decorate([
	        context_1.Autowired("gridOptions"),
	        __metadata("design:type", Object)
	    ], UserComponentFactory.prototype, "gridOptions", void 0);
	    __decorate([
	        context_1.Autowired("gridOptionsWrapper"),
	        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
	    ], UserComponentFactory.prototype, "gridOptionsWrapper", void 0);
	    __decorate([
	        context_1.Autowired("context"),
	        __metadata("design:type", context_1.Context)
	    ], UserComponentFactory.prototype, "context", void 0);
	    __decorate([
	        context_1.Autowired("agComponentUtils"),
	        __metadata("design:type", agComponentUtils_1.AgComponentUtils)
	    ], UserComponentFactory.prototype, "agComponentUtils", void 0);
	    __decorate([
	        context_1.Autowired("componentMetadataProvider"),
	        __metadata("design:type", componentMetadataProvider_1.ComponentMetadataProvider)
	    ], UserComponentFactory.prototype, "componentMetadataProvider", void 0);
	    __decorate([
	        context_1.Autowired("userComponentRegistry"),
	        __metadata("design:type", userComponentRegistry_1.UserComponentRegistry)
	    ], UserComponentFactory.prototype, "userComponentRegistry", void 0);
	    __decorate([
	        context_1.Optional("frameworkComponentWrapper"),
	        __metadata("design:type", Object)
	    ], UserComponentFactory.prototype, "frameworkComponentWrapper", void 0);
	    UserComponentFactory = __decorate([
	        context_1.Bean('userComponentFactory')
	    ], UserComponentFactory);
	    return UserComponentFactory;
	}());
	exports.UserComponentFactory = UserComponentFactory;


/***/ }),
/* 2381 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var textCellEditor_1 = __webpack_require__(2382);
	var context_1 = __webpack_require__(2333);
	var dateFilter_1 = __webpack_require__(2383);
	var headerComp_1 = __webpack_require__(2390);
	var headerGroupComp_1 = __webpack_require__(2393);
	var groupCellRenderer_1 = __webpack_require__(2394);
	var animateShowChangeCellRenderer_1 = __webpack_require__(2397);
	var animateSlideCellRenderer_1 = __webpack_require__(2377);
	var loadingCellRenderer_1 = __webpack_require__(2398);
	var selectCellEditor_1 = __webpack_require__(2399);
	var popupTextCellEditor_1 = __webpack_require__(2400);
	var popupSelectCellEditor_1 = __webpack_require__(2401);
	var largeTextCellEditor_1 = __webpack_require__(2402);
	var numberFilter_1 = __webpack_require__(2403);
	var loadingOverlayComponent_1 = __webpack_require__(2404);
	var noRowsOverlayComponent_1 = __webpack_require__(2405);
	var tooltipComponent_1 = __webpack_require__(2406);
	var utils_1 = __webpack_require__(2325);
	var defaultDateComponent_1 = __webpack_require__(2407);
	var dateFloatingFilter_1 = __webpack_require__(2408);
	var textFilter_1 = __webpack_require__(2410);
	var numberFloatingFilter_1 = __webpack_require__(2411);
	var textFloatingFilter_1 = __webpack_require__(2413);
	var RegisteredComponentSource;
	(function (RegisteredComponentSource) {
	    RegisteredComponentSource[RegisteredComponentSource["DEFAULT"] = 0] = "DEFAULT";
	    RegisteredComponentSource[RegisteredComponentSource["REGISTERED"] = 1] = "REGISTERED";
	})(RegisteredComponentSource = exports.RegisteredComponentSource || (exports.RegisteredComponentSource = {}));
	var UserComponentRegistry = /** @class */ (function () {
	    function UserComponentRegistry() {
	        this.agGridDefaults = {
	            //date
	            agDateInput: defaultDateComponent_1.DefaultDateComponent,
	            //header
	            agColumnHeader: headerComp_1.HeaderComp,
	            agColumnGroupHeader: headerGroupComp_1.HeaderGroupComp,
	            //floating filters
	            agTextColumnFloatingFilter: textFloatingFilter_1.TextFloatingFilter,
	            agNumberColumnFloatingFilter: numberFloatingFilter_1.NumberFloatingFilter,
	            agDateColumnFloatingFilter: dateFloatingFilter_1.DateFloatingFilter,
	            // renderers
	            agAnimateShowChangeCellRenderer: animateShowChangeCellRenderer_1.AnimateShowChangeCellRenderer,
	            agAnimateSlideCellRenderer: animateSlideCellRenderer_1.AnimateSlideCellRenderer,
	            agGroupCellRenderer: groupCellRenderer_1.GroupCellRenderer,
	            agGroupRowRenderer: groupCellRenderer_1.GroupCellRenderer,
	            agLoadingCellRenderer: loadingCellRenderer_1.LoadingCellRenderer,
	            //editors
	            agCellEditor: textCellEditor_1.TextCellEditor,
	            agTextCellEditor: textCellEditor_1.TextCellEditor,
	            agSelectCellEditor: selectCellEditor_1.SelectCellEditor,
	            agPopupTextCellEditor: popupTextCellEditor_1.PopupTextCellEditor,
	            agPopupSelectCellEditor: popupSelectCellEditor_1.PopupSelectCellEditor,
	            agLargeTextCellEditor: largeTextCellEditor_1.LargeTextCellEditor,
	            //filter
	            agTextColumnFilter: textFilter_1.TextFilter,
	            agNumberColumnFilter: numberFilter_1.NumberFilter,
	            agDateColumnFilter: dateFilter_1.DateFilter,
	            //overlays
	            agLoadingOverlay: loadingOverlayComponent_1.LoadingOverlayComponent,
	            agNoRowsOverlay: noRowsOverlayComponent_1.NoRowsOverlayComponent,
	            // tooltips
	            agTooltipComponent: tooltipComponent_1.TooltipComponent
	        };
	        this.agDeprecatedNames = {
	            set: {
	                newComponentName: 'agSetColumnFilter',
	                propertyHolder: 'filter'
	            },
	            text: {
	                newComponentName: 'agTextColumnFilter',
	                propertyHolder: 'filter'
	            },
	            number: {
	                newComponentName: 'agNumberColumnFilter',
	                propertyHolder: 'filter'
	            },
	            date: {
	                newComponentName: 'agDateColumnFilter',
	                propertyHolder: 'filter'
	            },
	            group: {
	                newComponentName: 'agGroupCellRenderer',
	                propertyHolder: 'cellRenderer'
	            },
	            animateShowChange: {
	                newComponentName: 'agAnimateShowChangeCellRenderer',
	                propertyHolder: 'cellRenderer'
	            },
	            animateSlide: {
	                newComponentName: 'agAnimateSlideCellRenderer',
	                propertyHolder: 'cellRenderer'
	            },
	            select: {
	                newComponentName: 'agSelectCellEditor',
	                propertyHolder: 'cellEditor'
	            },
	            largeText: {
	                newComponentName: 'agLargeTextCellEditor',
	                propertyHolder: 'cellEditor'
	            },
	            popupSelect: {
	                newComponentName: 'agPopupSelectCellEditor',
	                propertyHolder: 'cellEditor'
	            },
	            popupText: {
	                newComponentName: 'agPopupTextCellEditor',
	                propertyHolder: 'cellEditor'
	            },
	            richSelect: {
	                newComponentName: 'agRichSelectCellEditor',
	                propertyHolder: 'cellEditor'
	            },
	            headerComponent: {
	                newComponentName: 'agColumnHeader',
	                propertyHolder: 'headerComponent'
	            }
	        };
	        this.jsComponents = {};
	        this.frameworkComponents = {};
	    }
	    UserComponentRegistry.prototype.init = function () {
	        var _this = this;
	        var enterpriseDefaultComponents = this.context.getEnterpriseDefaultComponents();
	        if (enterpriseDefaultComponents) {
	            utils_1._.forEach(enterpriseDefaultComponents, function (config) {
	                _this.registerDefaultComponent(config.componentName, config.theClass);
	            });
	        }
	        if (this.gridOptions.components != null) {
	            Object.keys(this.gridOptions.components).forEach(function (it) {
	                _this.registerComponent(it, _this.gridOptions.components[it]);
	            });
	        }
	        if (this.gridOptions.frameworkComponents != null) {
	            Object.keys(this.gridOptions.frameworkComponents).forEach(function (it) {
	                _this.registerFwComponent(it, _this.gridOptions.frameworkComponents[it]);
	            });
	        }
	    };
	    UserComponentRegistry.prototype.registerDefaultComponent = function (rawName, component) {
	        var name = this.translateIfDeprecated(rawName);
	        if (this.agGridDefaults[name]) {
	            console.error("Trying to overwrite a default component. You should call registerComponent");
	            return;
	        }
	        this.agGridDefaults[name] = component;
	    };
	    UserComponentRegistry.prototype.registerComponent = function (rawName, component) {
	        var name = this.translateIfDeprecated(rawName);
	        if (this.frameworkComponents[name]) {
	            console.error("Trying to register a component that you have already registered for frameworks: " + name);
	            return;
	        }
	        this.jsComponents[name] = component;
	    };
	    /**
	     * B the business interface (ie IHeader)
	     * A the agGridComponent interface (ie IHeaderComp). The final object acceptable by ag-grid
	     */
	    UserComponentRegistry.prototype.registerFwComponent = function (rawName, component) {
	        var name = this.translateIfDeprecated(rawName);
	        if (this.jsComponents[name]) {
	            console.error("Trying to register a component that you have already registered for plain javascript: " + name);
	            return;
	        }
	        this.frameworkComponents[name] = component;
	    };
	    /**
	     * B the business interface (ie IHeader)
	     * A the agGridComponent interface (ie IHeaderComp). The final object acceptable by ag-grid
	     */
	    UserComponentRegistry.prototype.retrieve = function (rawName) {
	        var name = this.translateIfDeprecated(rawName);
	        if (this.frameworkComponents[name]) {
	            return {
	                componentFromFramework: true,
	                component: this.frameworkComponents[name],
	                source: RegisteredComponentSource.REGISTERED
	            };
	        }
	        if (this.jsComponents[name]) {
	            return {
	                componentFromFramework: false,
	                component: this.jsComponents[name],
	                source: RegisteredComponentSource.REGISTERED
	            };
	        }
	        if (this.agGridDefaults[name]) {
	            return this.agGridDefaults[name] ?
	                {
	                    componentFromFramework: false,
	                    component: this.agGridDefaults[name],
	                    source: RegisteredComponentSource.DEFAULT
	                } :
	                null;
	        }
	        if (Object.keys(this.agGridDefaults).indexOf(name) < 0) {
	            console.warn("ag-Grid: Looking for component [" + name + "] but it wasn't found.");
	        }
	        return null;
	    };
	    UserComponentRegistry.prototype.translateIfDeprecated = function (raw) {
	        var deprecatedInfo = this.agDeprecatedNames[raw];
	        if (deprecatedInfo != null) {
	            utils_1._.doOnce(function () {
	                console.warn("ag-grid. Since v15.0 component names have been renamed to be namespaced. You should rename " + deprecatedInfo.propertyHolder + ":" + raw + " to " + deprecatedInfo.propertyHolder + ":" + deprecatedInfo.newComponentName);
	            }, 'DEPRECATE_COMPONENT_' + raw);
	            return deprecatedInfo.newComponentName;
	        }
	        return raw;
	    };
	    __decorate([
	        context_1.Autowired('gridOptions'),
	        __metadata("design:type", Object)
	    ], UserComponentRegistry.prototype, "gridOptions", void 0);
	    __decorate([
	        context_1.Autowired('context'),
	        __metadata("design:type", context_1.Context)
	    ], UserComponentRegistry.prototype, "context", void 0);
	    __decorate([
	        context_1.PostConstruct,
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", []),
	        __metadata("design:returntype", void 0)
	    ], UserComponentRegistry.prototype, "init", null);
	    UserComponentRegistry = __decorate([
	        context_1.Bean('userComponentRegistry')
	    ], UserComponentRegistry);
	    return UserComponentRegistry;
	}());
	exports.UserComponentRegistry = UserComponentRegistry;


/***/ }),
/* 2382 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var constants_1 = __webpack_require__(2328);
	var popupComponent_1 = __webpack_require__(2367);
	var utils_1 = __webpack_require__(2325);
	var TextCellEditor = /** @class */ (function (_super) {
	    __extends(TextCellEditor, _super);
	    function TextCellEditor() {
	        var _this = _super.call(this, TextCellEditor.TEMPLATE) || this;
	        _this.eInput = _this.getGui().querySelector('input');
	        return _this;
	    }
	    TextCellEditor.prototype.init = function (params) {
	        this.params = params;
	        var eInput = this.eInput;
	        var startValue;
	        // cellStartedEdit is only false if we are doing fullRow editing
	        if (params.cellStartedEdit) {
	            this.focusAfterAttached = true;
	            var keyPressBackspaceOrDelete = params.keyPress === constants_1.Constants.KEY_BACKSPACE
	                || params.keyPress === constants_1.Constants.KEY_DELETE;
	            if (keyPressBackspaceOrDelete) {
	                startValue = '';
	            }
	            else if (params.charPress) {
	                startValue = params.charPress;
	            }
	            else {
	                startValue = this.getStartValue(params);
	                if (params.keyPress !== constants_1.Constants.KEY_F2) {
	                    this.highlightAllOnFocus = true;
	                }
	            }
	        }
	        else {
	            this.focusAfterAttached = false;
	            startValue = this.getStartValue(params);
	        }
	        if (utils_1._.exists(startValue)) {
	            eInput.value = startValue;
	        }
	        this.addDestroyableEventListener(eInput, 'keydown', function (event) {
	            var pageUp = event.keyCode === constants_1.Constants.KEY_PAGE_UP;
	            var pageDown = event.keyCode === constants_1.Constants.KEY_PAGE_DOWN;
	            if (pageUp || pageDown) {
	                event.preventDefault();
	            }
	        });
	    };
	    TextCellEditor.prototype.afterGuiAttached = function () {
	        if (!this.focusAfterAttached) {
	            return;
	        }
	        var eInput = this.eInput;
	        eInput.focus();
	        if (this.highlightAllOnFocus) {
	            eInput.select();
	        }
	        else {
	            // when we started editing, we want the caret at the end, not the start.
	            // this comes into play in two scenarios: a) when user hits F2 and b)
	            // when user hits a printable character, then on IE (and only IE) the caret
	            // was placed after the first character, thus 'apply' would end up as 'pplea'
	            var length_1 = eInput.value ? eInput.value.length : 0;
	            if (length_1 > 0) {
	                eInput.setSelectionRange(length_1, length_1);
	            }
	        }
	    };
	    // gets called when tabbing trough cells and in full row edit mode
	    TextCellEditor.prototype.focusIn = function () {
	        var eInput = this.eInput;
	        eInput.focus();
	        eInput.select();
	    };
	    TextCellEditor.prototype.getValue = function () {
	        var eInput = this.eInput;
	        return this.params.parseValue(eInput.value);
	    };
	    TextCellEditor.prototype.getStartValue = function (params) {
	        var formatValue = params.useFormatter || params.column.getColDef().refData;
	        return formatValue ? params.formatValue(params.value) : params.value;
	    };
	    TextCellEditor.prototype.isPopup = function () {
	        return false;
	    };
	    TextCellEditor.TEMPLATE = '<div class="ag-input-wrapper" role="presentation"><input class="ag-cell-edit-input" type="text"/></div>';
	    return TextCellEditor;
	}(popupComponent_1.PopupComponent));
	exports.TextCellEditor = TextCellEditor;


/***/ }),
/* 2383 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var componentAnnotations_1 = __webpack_require__(2384);
	var context_1 = __webpack_require__(2333);
	var userComponentFactory_1 = __webpack_require__(2380);
	var utils_1 = __webpack_require__(2325);
	var dateCompWrapper_1 = __webpack_require__(2385);
	var simpleFilter_1 = __webpack_require__(2386);
	var scalerFilter_1 = __webpack_require__(2389);
	var DateFilter = /** @class */ (function (_super) {
	    __extends(DateFilter, _super);
	    function DateFilter() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    DateFilter.prototype.mapRangeFromModel = function (filterModel) {
	        // unlike the other filters, we do two things here:
	        // 1) allow for different attribute names (same as done for other filters) (eg the 'from' and 'to'
	        //    are in different locations in Date and Number filter models)
	        // 2) convert the type (cos Date filter uses Dates, however model is 'string')
	        //
	        // NOTE: The conversion of string to date also removes the timezone - ie when user picks
	        //       a date form the UI, it will have timezone info in it. This is lost when creating
	        //       the model. Then when we recreate the date again here, it's without timezone.
	        return {
	            from: utils_1._.parseYyyyMmDdToDate(filterModel.dateFrom, "-"),
	            to: utils_1._.parseYyyyMmDdToDate(filterModel.dateTo, "-")
	        };
	    };
	    DateFilter.prototype.setValueFromFloatingFilter = function (value) {
	        if (value != null) {
	            var dateFrom = utils_1._.parseYyyyMmDdToDate(value, "-");
	            this.dateCompFrom1.setDate(dateFrom);
	        }
	        else {
	            this.dateCompFrom1.setDate(null);
	        }
	        this.dateCompTo1.setDate(null);
	        this.dateCompFrom2.setDate(null);
	        this.dateCompTo2.setDate(null);
	    };
	    DateFilter.prototype.setConditionIntoUi = function (model, position) {
	        var positionOne = position === simpleFilter_1.ConditionPosition.One;
	        var dateFromString = model ? model.dateFrom : null;
	        var dateToString = model ? model.dateTo : null;
	        var dateFrom = utils_1._.parseYyyyMmDdToDate(dateFromString, "-");
	        var dateTo = utils_1._.parseYyyyMmDdToDate(dateToString, "-");
	        var compFrom = positionOne ? this.dateCompFrom1 : this.dateCompFrom2;
	        var compTo = positionOne ? this.dateCompTo1 : this.dateCompTo2;
	        compFrom.setDate(dateFrom);
	        compTo.setDate(dateTo);
	    };
	    DateFilter.prototype.resetUiToDefaults = function () {
	        _super.prototype.resetUiToDefaults.call(this);
	        this.dateCompTo1.setDate(null);
	        this.dateCompTo2.setDate(null);
	        this.dateCompFrom1.setDate(null);
	        this.dateCompFrom2.setDate(null);
	    };
	    DateFilter.prototype.comparator = function () {
	        return this.dateFilterParams.comparator ? this.dateFilterParams.comparator : this.defaultComparator.bind(this);
	    };
	    DateFilter.prototype.defaultComparator = function (filterDate, cellValue) {
	        //The default comparator assumes that the cellValue is a date
	        var cellAsDate = cellValue;
	        if (cellAsDate < filterDate) {
	            return -1;
	        }
	        if (cellAsDate > filterDate) {
	            return 1;
	        }
	        return cellValue != null ? 0 : -1;
	    };
	    DateFilter.prototype.setParams = function (params) {
	        _super.prototype.setParams.call(this, params);
	        this.dateFilterParams = params;
	        this.createDateComponents();
	    };
	    DateFilter.prototype.createDateComponents = function () {
	        var _this = this;
	        // params to pass to all four date comps
	        var dateComponentParams = {
	            onDateChanged: function () { return _this.onUiChanged(); },
	            filterParams: this.dateFilterParams
	        };
	        this.dateCompFrom1 = new dateCompWrapper_1.DateCompWrapper(this.userComponentFactory, dateComponentParams, this.ePanelFrom1);
	        this.dateCompFrom2 = new dateCompWrapper_1.DateCompWrapper(this.userComponentFactory, dateComponentParams, this.ePanelFrom2);
	        this.dateCompTo1 = new dateCompWrapper_1.DateCompWrapper(this.userComponentFactory, dateComponentParams, this.ePanelTo1);
	        this.dateCompTo2 = new dateCompWrapper_1.DateCompWrapper(this.userComponentFactory, dateComponentParams, this.ePanelTo2);
	        this.addDestroyFunc(function () {
	            _this.dateCompFrom1.destroy();
	            _this.dateCompFrom2.destroy();
	            _this.dateCompTo1.destroy();
	            _this.dateCompTo2.destroy();
	        });
	    };
	    DateFilter.prototype.getDefaultFilterOptions = function () {
	        return DateFilter.DEFAULT_FILTER_OPTIONS;
	    };
	    DateFilter.prototype.createValueTemplate = function (position) {
	        var positionOne = position === simpleFilter_1.ConditionPosition.One;
	        var pos = positionOne ? '1' : '2';
	        return "<div class=\"ag-filter-body\" ref=\"eCondition" + pos + "Body\">\n                    <div class=\"ag-filter-date-from\" ref=\"ePanelFrom" + pos + "\">\n                    </div>\n                    <div class=\"ag-filter-date-to\" ref=\"ePanelTo" + pos + "\"\">\n                    </div>\n                </div>";
	    };
	    DateFilter.prototype.isConditionUiComplete = function (position) {
	        var positionOne = position === simpleFilter_1.ConditionPosition.One;
	        var option = positionOne ? this.getCondition1Type() : this.getCondition2Type();
	        var compFrom = positionOne ? this.dateCompFrom1 : this.dateCompFrom2;
	        var compTo = positionOne ? this.dateCompTo1 : this.dateCompTo2;
	        var valueFrom = compFrom.getDate();
	        var valueTo = compTo.getDate();
	        if (option === simpleFilter_1.SimpleFilter.EMPTY) {
	            return false;
	        }
	        if (this.doesFilterHaveHiddenInput(option)) {
	            return true;
	        }
	        if (option === simpleFilter_1.SimpleFilter.IN_RANGE) {
	            return valueFrom != null && valueTo != null;
	        }
	        else {
	            return valueFrom != null;
	        }
	    };
	    DateFilter.prototype.areSimpleModelsEqual = function (aSimple, bSimple) {
	        return aSimple.dateFrom === bSimple.dateFrom
	            && aSimple.dateTo === bSimple.dateTo
	            && aSimple.type === bSimple.type;
	    };
	    // needed for creating filter model
	    DateFilter.prototype.getFilterType = function () {
	        return DateFilter.FILTER_TYPE;
	    };
	    DateFilter.prototype.createCondition = function (position) {
	        var positionOne = position === simpleFilter_1.ConditionPosition.One;
	        var type = positionOne ? this.getCondition1Type() : this.getCondition2Type();
	        var dateCompTo = positionOne ? this.dateCompTo1 : this.dateCompTo2;
	        var dateCompFrom = positionOne ? this.dateCompFrom1 : this.dateCompFrom2;
	        return {
	            dateTo: utils_1._.serializeDateToYyyyMmDd(dateCompTo.getDate(), "-"),
	            dateFrom: utils_1._.serializeDateToYyyyMmDd(dateCompFrom.getDate(), "-"),
	            type: type,
	            filterType: DateFilter.FILTER_TYPE
	        };
	    };
	    DateFilter.prototype.updateUiVisibility = function () {
	        _super.prototype.updateUiVisibility.call(this);
	        var showFrom1 = this.showValueFrom(this.getCondition1Type());
	        utils_1._.setDisplayed(this.ePanelFrom1, showFrom1);
	        var showTo1 = this.showValueTo(this.getCondition1Type());
	        utils_1._.setDisplayed(this.ePanelTo1, showTo1);
	        var showFrom2 = this.showValueFrom(this.getCondition2Type());
	        utils_1._.setDisplayed(this.ePanelFrom2, showFrom2);
	        var showTo2 = this.showValueTo(this.getCondition2Type());
	        utils_1._.setDisplayed(this.ePanelTo2, showTo2);
	    };
	    DateFilter.FILTER_TYPE = 'date';
	    DateFilter.DEFAULT_FILTER_OPTIONS = [scalerFilter_1.ScalerFilter.EQUALS, scalerFilter_1.ScalerFilter.GREATER_THAN,
	        scalerFilter_1.ScalerFilter.LESS_THAN, scalerFilter_1.ScalerFilter.NOT_EQUAL, scalerFilter_1.ScalerFilter.IN_RANGE];
	    __decorate([
	        componentAnnotations_1.RefSelector('ePanelFrom1'),
	        __metadata("design:type", HTMLElement)
	    ], DateFilter.prototype, "ePanelFrom1", void 0);
	    __decorate([
	        componentAnnotations_1.RefSelector('ePanelFrom2'),
	        __metadata("design:type", HTMLElement)
	    ], DateFilter.prototype, "ePanelFrom2", void 0);
	    __decorate([
	        componentAnnotations_1.RefSelector('ePanelTo1'),
	        __metadata("design:type", HTMLElement)
	    ], DateFilter.prototype, "ePanelTo1", void 0);
	    __decorate([
	        componentAnnotations_1.RefSelector('ePanelTo2'),
	        __metadata("design:type", HTMLElement)
	    ], DateFilter.prototype, "ePanelTo2", void 0);
	    __decorate([
	        context_1.Autowired('userComponentFactory'),
	        __metadata("design:type", userComponentFactory_1.UserComponentFactory)
	    ], DateFilter.prototype, "userComponentFactory", void 0);
	    return DateFilter;
	}(scalerFilter_1.ScalerFilter));
	exports.DateFilter = DateFilter;


/***/ }),
/* 2384 */
/***/ (function(module, exports) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	function QuerySelector(selector) {
	    return querySelectorFunc.bind(this, selector);
	}
	exports.QuerySelector = QuerySelector;
	function RefSelector(ref) {
	    return querySelectorFunc.bind(this, "[ref=" + ref + "]");
	}
	exports.RefSelector = RefSelector;
	function querySelectorFunc(selector, classPrototype, methodOrAttributeName, index) {
	    if (selector === null) {
	        console.error("ag-Grid: QuerySelector selector should not be null");
	        return;
	    }
	    if (typeof index === "number") {
	        console.error("ag-Grid: QuerySelector should be on an attribute");
	        return;
	    }
	    addToObjectProps(classPrototype, 'querySelectors', {
	        attributeName: methodOrAttributeName,
	        querySelector: selector
	    });
	}
	// think we should take this out, put property bindings on the
	function Listener(eventName) {
	    return listenerFunc.bind(this, eventName);
	}
	exports.Listener = Listener;
	function listenerFunc(eventName, target, methodName) {
	    if (eventName === null) {
	        console.error("ag-Grid: EventListener eventName should not be null");
	        return;
	    }
	    addToObjectProps(target, 'listenerMethods', {
	        methodName: methodName,
	        eventName: eventName
	    });
	}
	// think we should take this out, put property bindings on the
	function Method(eventName) {
	    return methodFunc.bind(this, eventName);
	}
	exports.Method = Method;
	function methodFunc(alias, target, methodName) {
	    if (alias === null) {
	        console.error("ag-Grid: EventListener eventName should not be null");
	        return;
	    }
	    addToObjectProps(target, 'methods', {
	        methodName: methodName,
	        alias: alias
	    });
	}
	function addToObjectProps(target, key, value) {
	    // it's an attribute on the class
	    var props = getOrCreateProps(target, target.constructor.name);
	    if (!props[key]) {
	        props[key] = [];
	    }
	    props[key].push(value);
	}
	function getOrCreateProps(target, instanceName) {
	    if (!target.__agComponentMetaData) {
	        target.__agComponentMetaData = {};
	    }
	    if (!target.__agComponentMetaData[instanceName]) {
	        target.__agComponentMetaData[instanceName] = {};
	    }
	    return target.__agComponentMetaData[instanceName];
	}


/***/ }),
/* 2385 */
/***/ (function(module, exports) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/** Provides sync access to async component. Date component can be lazy created - this class encapsulates
	 * this by keeping value locally until DateComp has loaded, then passing DateComp the value. */
	var DateCompWrapper = /** @class */ (function () {
	    function DateCompWrapper(userComponentFactory, dateComponentParams, eParent) {
	        var _this = this;
	        this.alive = true;
	        userComponentFactory.newDateComponent(dateComponentParams).then(function (dateComp) {
	            // because async, check the filter still exists after component comes back
	            if (!_this.alive) {
	                if (dateComp.destroy) {
	                    dateComp.destroy();
	                }
	                return;
	            }
	            _this.dateComp = dateComp;
	            eParent.appendChild(dateComp.getGui());
	            if (dateComp.afterGuiAttached) {
	                dateComp.afterGuiAttached();
	            }
	            if (_this.tempValue) {
	                dateComp.setDate(_this.tempValue);
	            }
	        });
	    }
	    DateCompWrapper.prototype.destroy = function () {
	        this.alive = false;
	        if (this.dateComp && this.dateComp.destroy) {
	            this.dateComp.destroy();
	        }
	    };
	    DateCompWrapper.prototype.getDate = function () {
	        if (this.dateComp) {
	            return this.dateComp.getDate();
	        }
	        else {
	            return this.tempValue;
	        }
	    };
	    DateCompWrapper.prototype.setDate = function (value) {
	        if (this.dateComp) {
	            this.dateComp.setDate(value);
	        }
	        else {
	            this.tempValue = value;
	        }
	    };
	    return DateCompWrapper;
	}());
	exports.DateCompWrapper = DateCompWrapper;


/***/ }),
/* 2386 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var componentAnnotations_1 = __webpack_require__(2384);
	var optionsFactory_1 = __webpack_require__(2387);
	var providedFilter_1 = __webpack_require__(2388);
	var utils_1 = __webpack_require__(2325);
	var ConditionPosition;
	(function (ConditionPosition) {
	    ConditionPosition[ConditionPosition["One"] = 0] = "One";
	    ConditionPosition[ConditionPosition["Two"] = 1] = "Two";
	})(ConditionPosition = exports.ConditionPosition || (exports.ConditionPosition = {}));
	var DEFAULT_TRANSLATIONS = {
	    loadingOoo: 'Loading...',
	    empty: 'Choose One',
	    equals: 'Equals',
	    notEqual: 'Not equal',
	    lessThan: 'Less than',
	    greaterThan: 'Greater than',
	    inRange: 'In range',
	    lessThanOrEqual: 'Less than or equals',
	    greaterThanOrEqual: 'Greater than or equals',
	    filterOoo: 'Filter...',
	    contains: 'Contains',
	    notContains: 'Not contains',
	    startsWith: 'Starts with',
	    endsWith: 'Ends with',
	    searchOoo: 'Search...',
	    selectAll: 'Select All',
	    applyFilter: 'Apply Filter',
	    clearFilter: 'Clear Filter',
	    andCondition: 'AND',
	    orCondition: 'OR'
	};
	/**
	 * Every filter with a dropdown where the user can specify a comparing type against the filter values
	 */
	var SimpleFilter = /** @class */ (function (_super) {
	    __extends(SimpleFilter, _super);
	    function SimpleFilter() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    // returns true if this type requires a 'from' field, eg any filter that requires at least one text value
	    SimpleFilter.prototype.showValueFrom = function (type) {
	        return !this.doesFilterHaveHiddenInput(type) && type !== SimpleFilter.EMPTY;
	    };
	    // returns true if this type requires a 'to' field, currently only 'range' returns true
	    SimpleFilter.prototype.showValueTo = function (type) {
	        return type === SimpleFilter.IN_RANGE;
	    };
	    // floating filter calls this when user applies filter from floating filter
	    SimpleFilter.prototype.onFloatingFilterChanged = function (type, value) {
	        this.setValueFromFloatingFilter(value);
	        this.setTypeFromFloatingFilter(type);
	        this.onUiChanged(true);
	    };
	    SimpleFilter.prototype.setTypeFromFloatingFilter = function (type) {
	        this.eType1.value = type;
	        this.eType2.value = null;
	        this.eJoinOperatorAnd.checked = true;
	    };
	    SimpleFilter.prototype.getModelFromUi = function () {
	        if (!this.isConditionUiComplete(ConditionPosition.One)) {
	            return null;
	        }
	        if (this.isAllowTwoConditions() && this.isConditionUiComplete(ConditionPosition.Two)) {
	            var res = {
	                filterType: this.getFilterType(),
	                operator: this.getJoinOperator(),
	                condition1: this.createCondition(ConditionPosition.One),
	                condition2: this.createCondition(ConditionPosition.Two)
	            };
	            return res;
	        }
	        else {
	            var res = this.createCondition(ConditionPosition.One);
	            return res;
	        }
	    };
	    SimpleFilter.prototype.getCondition1Type = function () {
	        return this.eType1.value;
	    };
	    SimpleFilter.prototype.getCondition2Type = function () {
	        return this.eType2.value;
	    };
	    SimpleFilter.prototype.getJoinOperator = function () {
	        return this.eJoinOperatorOr.checked ? 'OR' : 'AND';
	    };
	    SimpleFilter.prototype.areModelsEqual = function (a, b) {
	        // both are missing
	        if (!a && !b) {
	            return true;
	        }
	        // one is missing, other present
	        if ((!a && b) || (a && !b)) {
	            return false;
	        }
	        // one is combined, the other is not
	        var aIsSimple = !a.operator;
	        var bIsSimple = !b.operator;
	        var oneSimpleOneCombined = (!aIsSimple && bIsSimple) || (aIsSimple && !bIsSimple);
	        if (oneSimpleOneCombined) {
	            return false;
	        }
	        var res;
	        // otherwise both present, so compare
	        if (aIsSimple) {
	            var aSimple = a;
	            var bSimple = b;
	            res = this.areSimpleModelsEqual(aSimple, bSimple);
	        }
	        else {
	            var aCombined = a;
	            var bCombined = b;
	            res = aCombined.operator === bCombined.operator
	                && this.areSimpleModelsEqual(aCombined.condition1, bCombined.condition1)
	                && this.areSimpleModelsEqual(aCombined.condition2, bCombined.condition2);
	        }
	        return res;
	    };
	    SimpleFilter.prototype.setModelIntoUi = function (model) {
	        var isCombined = model.operator;
	        if (isCombined) {
	            var combinedModel = model;
	            var orChecked = combinedModel.operator === 'OR';
	            this.eJoinOperatorAnd.checked = !orChecked;
	            this.eJoinOperatorOr.checked = orChecked;
	            this.eType1.value = combinedModel.condition1.type;
	            this.eType2.value = combinedModel.condition2.type;
	            this.setConditionIntoUi(combinedModel.condition1, ConditionPosition.One);
	            this.setConditionIntoUi(combinedModel.condition2, ConditionPosition.Two);
	        }
	        else {
	            var simpleModel = model;
	            this.eJoinOperatorAnd.checked = true;
	            this.eJoinOperatorOr.checked = false;
	            this.eType1.value = simpleModel.type;
	            this.eType2.value = this.optionsFactory.getDefaultOption();
	            this.setConditionIntoUi(simpleModel, ConditionPosition.One);
	            this.setConditionIntoUi(null, ConditionPosition.Two);
	        }
	    };
	    SimpleFilter.prototype.doesFilterPass = function (params) {
	        var model = this.getModel();
	        var isCombined = model.operator;
	        if (isCombined) {
	            var combinedModel = model;
	            var firstResult = this.individualConditionPasses(params, combinedModel.condition1);
	            var secondResult = this.individualConditionPasses(params, combinedModel.condition2);
	            if (combinedModel.operator === 'AND') {
	                return firstResult && secondResult;
	            }
	            else {
	                return firstResult || secondResult;
	            }
	        }
	        else {
	            var simpleModel = model;
	            var result = this.individualConditionPasses(params, simpleModel);
	            return result;
	        }
	    };
	    SimpleFilter.prototype.setParams = function (params) {
	        _super.prototype.setParams.call(this, params);
	        this.simpleFilterParams = params;
	        this.optionsFactory = new optionsFactory_1.OptionsFactory();
	        this.optionsFactory.init(params, this.getDefaultFilterOptions());
	        this.allowTwoConditions = !params.suppressAndOrCondition;
	        this.putOptionsIntoDropdown();
	        this.addChangedListeners();
	    };
	    SimpleFilter.prototype.putOptionsIntoDropdown = function () {
	        var _this = this;
	        var filterOptions = this.optionsFactory.getFilterOptions();
	        filterOptions.forEach(function (option) {
	            var createOption = function () {
	                var key = (typeof option === 'string') ? option : option.displayKey;
	                var localName = _this.translate(key);
	                var eOption = document.createElement("option");
	                eOption.text = localName;
	                eOption.value = key;
	                return eOption;
	            };
	            _this.eType1.add(createOption());
	            _this.eType2.add(createOption());
	        });
	        var readOnly = filterOptions.length <= 1;
	        this.eType1.disabled = readOnly;
	        this.eType2.disabled = readOnly;
	    };
	    SimpleFilter.prototype.isAllowTwoConditions = function () {
	        return this.allowTwoConditions;
	    };
	    SimpleFilter.prototype.createBodyTemplate = function () {
	        var optionsTemplate1 = "<select class=\"ag-filter-select\" ref=\"eOptions1\"></select>";
	        var valueTemplate1 = this.createValueTemplate(ConditionPosition.One);
	        var optionsTemplate2 = "<select class=\"ag-filter-select\" ref=\"eOptions2\"></select>";
	        var valueTemplate2 = this.createValueTemplate(ConditionPosition.Two);
	        var uniqueGroupId = 'ag-simple-filter-and-or-' + this.getCompId();
	        var translate = this.gridOptionsWrapper.getLocaleTextFunc();
	        var andOrTemplate = "<div class=\"ag-filter-condition\" ref=\"eJoinOperatorPanel\">\n                    <label>\n                        <input ref=\"eJoinOperatorAnd\" type=\"radio\" class=\"and\" name=\"" + uniqueGroupId + "\" value=\"AND\")} checked=\"checked\" />\n                        " + translate('andCondition', 'AND') + "\n                    </label>\n                    <label>\n                        <input ref=\"eJoinOperatorOr\" type=\"radio\" class=\"or\" name=\"" + uniqueGroupId + "\" value=\"OR\" />\n                        " + translate('orCondition', 'OR') + "\n                    </label>\n                </div>";
	        var template = optionsTemplate1 + "\n                " + valueTemplate1 + "\n                " + andOrTemplate + "\n                " + optionsTemplate2 + "\n                " + valueTemplate2;
	        return template;
	    };
	    SimpleFilter.prototype.updateUiVisibility = function () {
	        var firstConditionComplete = this.isConditionUiComplete(ConditionPosition.One);
	        var showSecondFilter = this.allowTwoConditions && firstConditionComplete;
	        utils_1._.setDisplayed(this.eCondition2Body, showSecondFilter);
	        utils_1._.setDisplayed(this.eType2, showSecondFilter);
	        utils_1._.setDisplayed(this.eJoinOperatorPanel, showSecondFilter);
	    };
	    SimpleFilter.prototype.resetUiToDefaults = function () {
	        this.eJoinOperatorAnd.checked = true;
	        var defaultOption = this.optionsFactory.getDefaultOption();
	        this.eType1.value = defaultOption;
	        this.eType2.value = defaultOption;
	    };
	    SimpleFilter.prototype.translate = function (toTranslate) {
	        var translate = this.gridOptionsWrapper.getLocaleTextFunc();
	        var defaultTranslation = DEFAULT_TRANSLATIONS[toTranslate];
	        if (!defaultTranslation && this.optionsFactory.getCustomOption(toTranslate)) {
	            defaultTranslation = this.optionsFactory.getCustomOption(toTranslate).displayName;
	        }
	        return translate(toTranslate, defaultTranslation);
	    };
	    SimpleFilter.prototype.addChangedListeners = function () {
	        var _this = this;
	        var listener = function () { return _this.onUiChanged(); };
	        this.addDestroyableEventListener(this.eType1, "change", listener);
	        this.addDestroyableEventListener(this.eType2, "change", listener);
	        this.addDestroyableEventListener(this.eJoinOperatorOr, "change", listener);
	        this.addDestroyableEventListener(this.eJoinOperatorAnd, "change", listener);
	    };
	    SimpleFilter.prototype.doesFilterHaveHiddenInput = function (filterType) {
	        var customFilterOption = this.optionsFactory.getCustomOption(filterType);
	        return customFilterOption && customFilterOption.hideFilterInput;
	    };
	    SimpleFilter.EMPTY = 'empty';
	    SimpleFilter.EQUALS = 'equals';
	    SimpleFilter.NOT_EQUAL = 'notEqual';
	    SimpleFilter.LESS_THAN = 'lessThan';
	    SimpleFilter.LESS_THAN_OR_EQUAL = 'lessThanOrEqual';
	    SimpleFilter.GREATER_THAN = 'greaterThan';
	    SimpleFilter.GREATER_THAN_OR_EQUAL = 'greaterThanOrEqual';
	    SimpleFilter.IN_RANGE = 'inRange';
	    SimpleFilter.CONTAINS = 'contains';
	    SimpleFilter.NOT_CONTAINS = 'notContains';
	    SimpleFilter.STARTS_WITH = 'startsWith';
	    SimpleFilter.ENDS_WITH = 'endsWith';
	    __decorate([
	        componentAnnotations_1.RefSelector('eOptions1'),
	        __metadata("design:type", HTMLSelectElement)
	    ], SimpleFilter.prototype, "eType1", void 0);
	    __decorate([
	        componentAnnotations_1.RefSelector('eOptions2'),
	        __metadata("design:type", HTMLSelectElement)
	    ], SimpleFilter.prototype, "eType2", void 0);
	    __decorate([
	        componentAnnotations_1.RefSelector('eJoinOperatorAnd'),
	        __metadata("design:type", HTMLInputElement)
	    ], SimpleFilter.prototype, "eJoinOperatorAnd", void 0);
	    __decorate([
	        componentAnnotations_1.RefSelector('eJoinOperatorOr'),
	        __metadata("design:type", HTMLInputElement)
	    ], SimpleFilter.prototype, "eJoinOperatorOr", void 0);
	    __decorate([
	        componentAnnotations_1.RefSelector('eCondition2Body'),
	        __metadata("design:type", HTMLElement)
	    ], SimpleFilter.prototype, "eCondition2Body", void 0);
	    __decorate([
	        componentAnnotations_1.RefSelector('eJoinOperatorPanel'),
	        __metadata("design:type", HTMLElement)
	    ], SimpleFilter.prototype, "eJoinOperatorPanel", void 0);
	    return SimpleFilter;
	}(providedFilter_1.ProvidedFilter));
	exports.SimpleFilter = SimpleFilter;


/***/ }),
/* 2387 */
/***/ (function(module, exports) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/* Common logic for options, used by both filters and floating filters. */
	var OptionsFactory = /** @class */ (function () {
	    function OptionsFactory() {
	        this.customFilterOptions = {};
	    }
	    OptionsFactory.prototype.init = function (params, defaultOptions) {
	        this.filterOptions = params.filterOptions ? params.filterOptions : defaultOptions;
	        this.mapCustomOptions();
	        this.selectDefaultItem(params);
	    };
	    OptionsFactory.prototype.getFilterOptions = function () {
	        return this.filterOptions;
	    };
	    OptionsFactory.prototype.mapCustomOptions = function () {
	        var _this = this;
	        if (!this.filterOptions) {
	            return;
	        }
	        this.filterOptions.forEach(function (filterOption) {
	            if (typeof filterOption === 'string') {
	                return;
	            }
	            if (!filterOption.displayKey) {
	                console.warn("ag-Grid: ignoring FilterOptionDef as it doesn't contain a 'displayKey'");
	                return;
	            }
	            if (!filterOption.displayName) {
	                console.warn("ag-Grid: ignoring FilterOptionDef as it doesn't contain a 'displayName'");
	                return;
	            }
	            if (!filterOption.test) {
	                console.warn("ag-Grid: ignoring FilterOptionDef as it doesn't contain a 'test'");
	                return;
	            }
	            _this.customFilterOptions[filterOption.displayKey] = filterOption;
	        });
	    };
	    OptionsFactory.prototype.selectDefaultItem = function (params) {
	        if (params.defaultOption) {
	            this.defaultOption = params.defaultOption;
	        }
	        else if (this.filterOptions.length >= 1) {
	            var firstFilterOption = this.filterOptions[0];
	            if (typeof firstFilterOption === 'string') {
	                this.defaultOption = firstFilterOption;
	            }
	            else if (firstFilterOption.displayKey) {
	                this.defaultOption = firstFilterOption.displayKey;
	            }
	            else {
	                console.warn("ag-Grid: invalid FilterOptionDef supplied as it doesn't contain a 'displayKey'");
	            }
	        }
	        else {
	            console.warn('ag-Grid: no filter options for filter');
	        }
	    };
	    OptionsFactory.prototype.getDefaultOption = function () {
	        return this.defaultOption;
	    };
	    OptionsFactory.prototype.getCustomOption = function (name) {
	        return this.customFilterOptions[name];
	    };
	    return OptionsFactory;
	}());
	exports.OptionsFactory = OptionsFactory;


/***/ }),
/* 2388 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var component_1 = __webpack_require__(2353);
	var componentAnnotations_1 = __webpack_require__(2384);
	var context_1 = __webpack_require__(2333);
	var gridOptionsWrapper_1 = __webpack_require__(2324);
	var utils_1 = __webpack_require__(2325);
	var constants_1 = __webpack_require__(2328);
	/**
	 * Contains common logic to all provided filters (apply button, clear button, etc).
	 * All the filters that come with ag-Grid extend this class. User filters do not
	 * extend this class.
	 */
	var ProvidedFilter = /** @class */ (function (_super) {
	    __extends(ProvidedFilter, _super);
	    function ProvidedFilter() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    /** @deprecated */
	    ProvidedFilter.prototype.onFilterChanged = function () {
	        console.warn("ag-Grid: you should not call onFilterChanged() directly on the filter, please call\n        gridApi.onFilterChanged() instead. onFilterChanged is not part of the exposed filter interface (it was\n        a method that existed on an old version of the filters that was not intended for public use.");
	        this.providedFilterParams.filterChangedCallback();
	    };
	    ProvidedFilter.prototype.isFilterActive = function () {
	        // filter is active if we have a valid applied model
	        return !!this.appliedModel;
	    };
	    ProvidedFilter.prototype.postConstruct = function () {
	        var templateString = this.createTemplate();
	        this.setTemplate(templateString);
	    };
	    ProvidedFilter.prototype.init = function (params) {
	        this.setParams(params);
	        this.resetUiToDefaults();
	        this.updateUiVisibility();
	        this.setupOnBtApplyDebounce();
	    };
	    ProvidedFilter.prototype.setParams = function (params) {
	        var _this = this;
	        this.providedFilterParams = params;
	        this.clearActive = params.clearButton === true;
	        this.applyActive = ProvidedFilter.isUseApplyButton(params);
	        if (params.newRowsAction === ProvidedFilter.NEW_ROWS_ACTION_KEEP) {
	            this.newRowsActionKeep = true;
	        }
	        else if (params.newRowsAction === ProvidedFilter.NEW_ROWS_ACTION_CLEAR) {
	            this.newRowsActionKeep = false;
	        }
	        else {
	            // the default for SSRM and IRM is 'keep', for CSRM and VRM teh default is 'clear'
	            var rowModelType = this.rowModel.getType();
	            var modelsForKeep = [constants_1.Constants.ROW_MODEL_TYPE_SERVER_SIDE, constants_1.Constants.ROW_MODEL_TYPE_INFINITE];
	            this.newRowsActionKeep = modelsForKeep.indexOf(rowModelType) >= 0;
	        }
	        utils_1._.setDisplayed(this.eApplyButton, this.applyActive);
	        // we do not bind onBtApply here because onBtApply() has a parameter, and it is not the event. if we
	        // just applied, the event would get passed as the second parameter, which we do not want.
	        this.addDestroyableEventListener(this.eApplyButton, "click", function () { return _this.onBtApply(); });
	        utils_1._.setDisplayed(this.eClearButton, this.clearActive);
	        this.addDestroyableEventListener(this.eClearButton, "click", this.onBtClear.bind(this));
	        var anyButtonVisible = this.applyActive || this.clearActive;
	        utils_1._.setDisplayed(this.eButtonsPanel, anyButtonVisible);
	    };
	    // subclasses can override this to provide alternative debounce defaults
	    ProvidedFilter.prototype.getDefaultDebounceMs = function () {
	        return 0;
	    };
	    ProvidedFilter.prototype.setupOnBtApplyDebounce = function () {
	        var debounceMs = ProvidedFilter.getDebounceMs(this.providedFilterParams, this.getDefaultDebounceMs());
	        this.onBtApplyDebounce = utils_1._.debounce(this.onBtApply.bind(this), debounceMs);
	    };
	    ProvidedFilter.prototype.getModel = function () {
	        return this.appliedModel;
	    };
	    ProvidedFilter.prototype.setModel = function (model) {
	        if (model) {
	            this.setModelIntoUi(model);
	        }
	        else {
	            this.resetUiToDefaults();
	        }
	        this.updateUiVisibility();
	        // we set the model from the gui, rather than the provided model,
	        // so the model is consistent. eg handling of null/undefined will be the same,
	        // of if model is case insensitive, then casing is removed.
	        this.applyModel();
	    };
	    ProvidedFilter.prototype.onBtClear = function () {
	        this.resetUiToDefaults();
	        this.updateUiVisibility();
	        this.onUiChanged();
	    };
	    // returns true if the new model is different to the old model
	    ProvidedFilter.prototype.applyModel = function () {
	        var oldAppliedModel = this.appliedModel;
	        this.appliedModel = this.getModelFromUi();
	        // models can be same if user pasted same content into text field, or maybe just changed the case
	        // and it's a case insensitive filter
	        var newModelDifferent = !this.areModelsEqual(this.appliedModel, oldAppliedModel);
	        return newModelDifferent;
	    };
	    ProvidedFilter.prototype.onBtApply = function (afterFloatingFilter) {
	        if (afterFloatingFilter === void 0) { afterFloatingFilter = false; }
	        var newModelDifferent = this.applyModel();
	        if (newModelDifferent) {
	            // the floating filter uses 'afterFloatingFilter' info, so it doesn't refresh after filter changed if change
	            // came from floating filter
	            this.providedFilterParams.filterChangedCallback({ afterFloatingFilter: afterFloatingFilter });
	        }
	    };
	    ProvidedFilter.prototype.onNewRowsLoaded = function () {
	        if (!this.newRowsActionKeep) {
	            this.resetUiToDefaults();
	            this.appliedModel = null;
	        }
	    };
	    // called by set filter
	    ProvidedFilter.prototype.isNewRowsActionKeep = function () {
	        return this.newRowsActionKeep;
	    };
	    ProvidedFilter.prototype.onUiChanged = function (afterFloatingFilter) {
	        if (afterFloatingFilter === void 0) { afterFloatingFilter = false; }
	        this.updateUiVisibility();
	        this.providedFilterParams.filterModifiedCallback();
	        // applyNow=true for floating filter changes, we always act on these immediately
	        if (afterFloatingFilter) {
	            this.onBtApply(true);
	            // otherwise if no apply button, we apply (but debounce for time delay)
	        }
	        else if (!this.applyActive) {
	            this.onBtApplyDebounce();
	        }
	    };
	    ProvidedFilter.prototype.createTemplate = function () {
	        var body = this.createBodyTemplate();
	        var translate = this.gridOptionsWrapper.getLocaleTextFunc();
	        return "<div>\n                    <div class='ag-filter-body-wrapper' ref=\"eFilterBodyWrapper\">" + body + "</div>\n                    <div class=\"ag-filter-apply-panel\" ref=\"eButtonsPanel\">\n                        <button type=\"button\" ref=\"eClearButton\">" + translate('clearFilter', 'Clear Filter') + "</button>\n                        <button type=\"button\" ref=\"eApplyButton\">" + translate('applyFilter', 'Apply Filter') + "</button>\n                    </div>\n                </div>";
	    };
	    // static, as used by floating filter also
	    ProvidedFilter.getDebounceMs = function (params, debounceDefault) {
	        var applyActive = ProvidedFilter.isUseApplyButton(params);
	        if (applyActive) {
	            if (params.debounceMs != null) {
	                console.warn('ag-Grid: debounceMs is ignored when applyButton = true');
	            }
	            return 0;
	        }
	        return params.debounceMs != null ? params.debounceMs : debounceDefault;
	    };
	    // static, as used by floating filter also
	    ProvidedFilter.isUseApplyButton = function (params) {
	        if (params.apply && !params.applyButton) {
	            console.warn('ag-Grid: as of ag-Grid v21, filterParams.apply is now filterParams.applyButton, please change to applyButton');
	            params.applyButton = true;
	        }
	        return params.applyButton === true;
	    };
	    ProvidedFilter.NEW_ROWS_ACTION_KEEP = 'keep';
	    ProvidedFilter.NEW_ROWS_ACTION_CLEAR = 'clear';
	    __decorate([
	        componentAnnotations_1.RefSelector('eButtonsPanel'),
	        __metadata("design:type", HTMLElement)
	    ], ProvidedFilter.prototype, "eButtonsPanel", void 0);
	    __decorate([
	        componentAnnotations_1.RefSelector('eFilterBodyWrapper'),
	        __metadata("design:type", HTMLElement)
	    ], ProvidedFilter.prototype, "eFilterBodyWrapper", void 0);
	    __decorate([
	        componentAnnotations_1.RefSelector('eApplyButton'),
	        __metadata("design:type", HTMLElement)
	    ], ProvidedFilter.prototype, "eApplyButton", void 0);
	    __decorate([
	        componentAnnotations_1.RefSelector('eClearButton'),
	        __metadata("design:type", HTMLElement)
	    ], ProvidedFilter.prototype, "eClearButton", void 0);
	    __decorate([
	        context_1.Autowired('gridOptionsWrapper'),
	        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
	    ], ProvidedFilter.prototype, "gridOptionsWrapper", void 0);
	    __decorate([
	        context_1.Autowired('rowModel'),
	        __metadata("design:type", Object)
	    ], ProvidedFilter.prototype, "rowModel", void 0);
	    __decorate([
	        context_1.PostConstruct,
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", []),
	        __metadata("design:returntype", void 0)
	    ], ProvidedFilter.prototype, "postConstruct", null);
	    return ProvidedFilter;
	}(component_1.Component));
	exports.ProvidedFilter = ProvidedFilter;


/***/ }),
/* 2389 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var simpleFilter_1 = __webpack_require__(2386);
	var ScalerFilter = /** @class */ (function (_super) {
	    __extends(ScalerFilter, _super);
	    function ScalerFilter() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    ScalerFilter.prototype.setParams = function (params) {
	        _super.prototype.setParams.call(this, params);
	        this.scalarFilterParams = params;
	        this.checkDeprecatedParams();
	    };
	    ScalerFilter.prototype.checkDeprecatedParams = function () {
	        if (this.scalarFilterParams.nullComparator) {
	            console.warn('ag-Grid: Since v21.0, the property filterParams.nullComparator is deprecated. ' +
	                'Please use filterParams.includeBlanksInEquals, filterParams.includeBlanksInLessThan and ' +
	                'filterParams.includeBlanksInGreaterThan instead.');
	            this.scalarFilterParams.includeBlanksInEquals = this.scalarFilterParams.nullComparator.equals;
	            this.scalarFilterParams.includeBlanksInLessThan = this.scalarFilterParams.nullComparator.lessThan;
	            this.scalarFilterParams.includeBlanksInGreaterThan = this.scalarFilterParams.nullComparator.greaterThan;
	        }
	    };
	    ScalerFilter.prototype.nullComparator = function (selectedOption, filterValue, gridValue) {
	        if (gridValue == null) {
	            var nullValue = this.canNullsPassFilter(selectedOption);
	            if (selectedOption === ScalerFilter.EMPTY) {
	                return 0;
	            }
	            if (selectedOption === ScalerFilter.EQUALS) {
	                return nullValue ? 0 : 1;
	            }
	            if (selectedOption === ScalerFilter.GREATER_THAN) {
	                return nullValue ? 1 : -1;
	            }
	            if (selectedOption === ScalerFilter.GREATER_THAN_OR_EQUAL) {
	                return nullValue ? 1 : -1;
	            }
	            if (selectedOption === ScalerFilter.LESS_THAN_OR_EQUAL) {
	                return nullValue ? -1 : 1;
	            }
	            if (selectedOption === ScalerFilter.LESS_THAN) {
	                return nullValue ? -1 : 1;
	            }
	            if (selectedOption === ScalerFilter.NOT_EQUAL) {
	                return nullValue ? 1 : 0;
	            }
	        }
	        var actualComparator = this.comparator();
	        return actualComparator(filterValue, gridValue);
	    };
	    ScalerFilter.prototype.canNullsPassFilter = function (type) {
	        switch (type) {
	            case simpleFilter_1.SimpleFilter.GREATER_THAN:
	            case simpleFilter_1.SimpleFilter.GREATER_THAN_OR_EQUAL:
	                return this.scalarFilterParams.includeBlanksInGreaterThan;
	            case simpleFilter_1.SimpleFilter.LESS_THAN:
	            case simpleFilter_1.SimpleFilter.LESS_THAN_OR_EQUAL:
	                return this.scalarFilterParams.includeBlanksInLessThan;
	            case simpleFilter_1.SimpleFilter.EQUALS:
	                return this.scalarFilterParams.includeBlanksInEquals;
	        }
	    };
	    ScalerFilter.prototype.individualConditionPasses = function (params, filterModel) {
	        var cellValue = this.scalarFilterParams.valueGetter(params.node);
	        var range = this.mapRangeFromModel(filterModel);
	        var filterValue = range.from;
	        var filterValueTo = range.to;
	        var filterType = filterModel.type;
	        var customFilterOption = this.optionsFactory.getCustomOption(filterType);
	        if (customFilterOption) {
	            // only execute the custom filter if a value exists or a value isn't required, i.e. input is hidden
	            if (filterValue != null || customFilterOption.hideFilterInput) {
	                return customFilterOption.test(filterValue, cellValue);
	            }
	        }
	        // why this? looks like logic that should be in parent class????
	        // if (filterValue == null) {
	        //     return type === FilterConditionType.MAIN ? true : this.conditionValue === 'AND';
	        // }
	        var compareResult = this.nullComparator(filterType, filterValue, cellValue);
	        if (filterType === ScalerFilter.EQUALS) {
	            return compareResult === 0;
	        }
	        if (filterType === ScalerFilter.GREATER_THAN) {
	            return compareResult > 0;
	        }
	        if (filterType === ScalerFilter.GREATER_THAN_OR_EQUAL) {
	            return compareResult >= 0;
	        }
	        if (filterType === ScalerFilter.LESS_THAN_OR_EQUAL) {
	            return compareResult <= 0;
	        }
	        if (filterType === ScalerFilter.LESS_THAN) {
	            return compareResult < 0;
	        }
	        if (filterType === ScalerFilter.NOT_EQUAL) {
	            return compareResult != 0;
	        }
	        // From now on the type is a range and rawFilterValues must be an array!
	        var compareToResult = this.nullComparator(filterType, filterValueTo, cellValue);
	        if (filterType === ScalerFilter.IN_RANGE) {
	            if (!this.scalarFilterParams.inRangeInclusive) {
	                return compareResult > 0 && compareToResult < 0;
	            }
	            else {
	                return compareResult >= 0 && compareToResult <= 0;
	            }
	        }
	        throw new Error('Unexpected type of filter: ' + filterType);
	    };
	    ScalerFilter.DEFAULT_NULL_COMPARATOR = {
	        equals: false,
	        lessThan: false,
	        greaterThan: false
	    };
	    return ScalerFilter;
	}(simpleFilter_1.SimpleFilter));
	exports.ScalerFilter = ScalerFilter;


/***/ }),
/* 2390 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var component_1 = __webpack_require__(2353);
	var column_1 = __webpack_require__(2343);
	var context_1 = __webpack_require__(2333);
	var gridOptionsWrapper_1 = __webpack_require__(2324);
	var sortController_1 = __webpack_require__(2391);
	var touchListener_1 = __webpack_require__(2392);
	var eventService_1 = __webpack_require__(2331);
	var componentAnnotations_1 = __webpack_require__(2384);
	var events_1 = __webpack_require__(2335);
	var utils_1 = __webpack_require__(2325);
	var HeaderComp = /** @class */ (function (_super) {
	    __extends(HeaderComp, _super);
	    function HeaderComp() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.lastMovingChanged = 0;
	        return _this;
	    }
	    HeaderComp.prototype.init = function (params) {
	        var template = utils_1._.firstExistingValue(params.template, HeaderComp.TEMPLATE);
	        // take account of any newlines & whitespace before/after the actual template
	        template = template && template.trim ? template.trim() : template;
	        this.setTemplate(template);
	        this.params = params;
	        this.setupTap();
	        this.setupIcons(params.column);
	        this.setupMenu();
	        this.setupSort();
	        this.setupFilterIcon();
	        this.setupText(params.displayName);
	    };
	    HeaderComp.prototype.setupText = function (displayName) {
	        var displayNameSanitised = utils_1._.escape(displayName);
	        if (this.eText) {
	            this.eText.innerHTML = displayNameSanitised;
	        }
	    };
	    HeaderComp.prototype.setupIcons = function (column) {
	        this.addInIcon('sortAscending', this.eSortAsc, column);
	        this.addInIcon('sortDescending', this.eSortDesc, column);
	        this.addInIcon('sortUnSort', this.eSortNone, column);
	        this.addInIcon('menu', this.eMenu, column);
	        this.addInIcon('filter', this.eFilter, column);
	    };
	    HeaderComp.prototype.addInIcon = function (iconName, eParent, column) {
	        if (eParent == null) {
	            return;
	        }
	        var eIcon = utils_1._.createIconNoSpan(iconName, this.gridOptionsWrapper, column);
	        eParent.appendChild(eIcon);
	    };
	    HeaderComp.prototype.setupTap = function () {
	        var _this = this;
	        var options = this.gridOptionsWrapper;
	        if (options.isSuppressTouch()) {
	            return;
	        }
	        var touchListener = new touchListener_1.TouchListener(this.getGui(), true);
	        var suppressMenuHide = options.isSuppressMenuHide();
	        var tapMenuButton = suppressMenuHide && utils_1._.exists(this.eMenu);
	        var menuTouchListener = tapMenuButton ? new touchListener_1.TouchListener(this.eMenu, true) : touchListener;
	        if (this.params.enableMenu) {
	            var eventType = tapMenuButton ? 'EVENT_TAP' : 'EVENT_LONG_TAP';
	            var showMenuFn = function (event) {
	                options.getApi().showColumnMenuAfterMouseClick(_this.params.column, event.touchStart);
	            };
	            this.addDestroyableEventListener(menuTouchListener, touchListener_1.TouchListener[eventType], showMenuFn);
	        }
	        if (this.params.enableSorting) {
	            var tapListener = function (event) {
	                var target = event.touchStart.target;
	                // When suppressMenuHide is true, a tap on the menu icon will bubble up
	                // to the header container, in that case we should not sort
	                if (suppressMenuHide && _this.eMenu.contains(target)) {
	                    return;
	                }
	                _this.sortController.progressSort(_this.params.column, false, "uiColumnSorted");
	            };
	            this.addDestroyableEventListener(touchListener, touchListener_1.TouchListener.EVENT_TAP, tapListener);
	        }
	        // if tapMenuButton is true `touchListener` and `menuTouchListener` are different
	        // so we need to make sure to destroy both listeners here
	        this.addDestroyFunc(function () { return touchListener.destroy(); });
	        if (tapMenuButton) {
	            this.addDestroyFunc(function () { return menuTouchListener.destroy(); });
	        }
	    };
	    HeaderComp.prototype.setupMenu = function () {
	        var _this = this;
	        // if no menu provided in template, do nothing
	        if (!this.eMenu) {
	            return;
	        }
	        // we don't show the menu if on an iPad/iPhone, as the user cannot have a pointer device
	        // Note: If suppressMenuHide is set to true the menu will be displayed, and if suppressMenuHide
	        // is false (default) user will need to use longpress to display the menu.
	        var suppressMenuHide = this.gridOptionsWrapper.isSuppressMenuHide();
	        var hideShowMenu = !this.params.enableMenu || (utils_1._.isUserAgentIPad() && !suppressMenuHide);
	        if (hideShowMenu) {
	            utils_1._.removeFromParent(this.eMenu);
	            return;
	        }
	        this.addDestroyableEventListener(this.eMenu, 'click', function () { return _this.showMenu(_this.eMenu); });
	        if (!suppressMenuHide) {
	            this.eMenu.style.opacity = '0';
	            this.addGuiEventListener('mouseover', function () {
	                _this.eMenu.style.opacity = '1';
	            });
	            this.addGuiEventListener('mouseout', function () {
	                _this.eMenu.style.opacity = '0';
	            });
	        }
	        var style = this.eMenu.style;
	        style.transition = 'opacity 0.2s, border 0.2s';
	        style['-webkit-transition'] = 'opacity 0.2s, border 0.2s';
	    };
	    HeaderComp.prototype.showMenu = function (eventSource) {
	        this.menuFactory.showMenuAfterButtonClick(this.params.column, eventSource);
	    };
	    HeaderComp.prototype.removeSortIcons = function () {
	        utils_1._.removeFromParent(this.eSortAsc);
	        utils_1._.removeFromParent(this.eSortDesc);
	        utils_1._.removeFromParent(this.eSortNone);
	        utils_1._.removeFromParent(this.eSortOrder);
	    };
	    HeaderComp.prototype.setupSort = function () {
	        var _this = this;
	        var enableSorting = this.params.enableSorting;
	        if (!enableSorting) {
	            this.removeSortIcons();
	            return;
	        }
	        var sortUsingCtrl = this.gridOptionsWrapper.isMultiSortKeyCtrl();
	        // keep track of last time the moving changed flag was set
	        this.addDestroyableEventListener(this.params.column, column_1.Column.EVENT_MOVING_CHANGED, function () {
	            _this.lastMovingChanged = new Date().getTime();
	        });
	        // add the event on the header, so when clicked, we do sorting
	        if (this.eLabel) {
	            this.addDestroyableEventListener(this.eLabel, 'click', function (event) {
	                // sometimes when moving a column via dragging, this was also firing a clicked event.
	                // here is issue raised by user: https://ag-grid.zendesk.com/agent/tickets/1076
	                // this check stops sort if a) column is moving or b) column moved less than 200ms ago (so caters for race condition)
	                var moving = _this.params.column.isMoving();
	                var nowTime = new Date().getTime();
	                // typically there is <2ms if moving flag was set recently, as it would be done in same VM turn
	                var movedRecently = (nowTime - _this.lastMovingChanged) < 50;
	                var columnMoving = moving || movedRecently;
	                if (!columnMoving) {
	                    var multiSort = sortUsingCtrl ? (event.ctrlKey || event.metaKey) : event.shiftKey;
	                    _this.params.progressSort(multiSort);
	                }
	            });
	        }
	        this.addDestroyableEventListener(this.params.column, column_1.Column.EVENT_SORT_CHANGED, this.onSortChanged.bind(this));
	        this.onSortChanged();
	        this.addDestroyableEventListener(this.eventService, events_1.Events.EVENT_SORT_CHANGED, this.setMultiSortOrder.bind(this));
	        this.setMultiSortOrder();
	    };
	    HeaderComp.prototype.onSortChanged = function () {
	        utils_1._.addOrRemoveCssClass(this.getGui(), 'ag-header-cell-sorted-asc', this.params.column.isSortAscending());
	        utils_1._.addOrRemoveCssClass(this.getGui(), 'ag-header-cell-sorted-desc', this.params.column.isSortDescending());
	        utils_1._.addOrRemoveCssClass(this.getGui(), 'ag-header-cell-sorted-none', this.params.column.isSortNone());
	        if (this.eSortAsc) {
	            utils_1._.addOrRemoveCssClass(this.eSortAsc, 'ag-hidden', !this.params.column.isSortAscending());
	        }
	        if (this.eSortDesc) {
	            utils_1._.addOrRemoveCssClass(this.eSortDesc, 'ag-hidden', !this.params.column.isSortDescending());
	        }
	        if (this.eSortNone) {
	            var alwaysHideNoSort = !this.params.column.getColDef().unSortIcon && !this.gridOptionsWrapper.isUnSortIcon();
	            utils_1._.addOrRemoveCssClass(this.eSortNone, 'ag-hidden', alwaysHideNoSort || !this.params.column.isSortNone());
	        }
	    };
	    // we listen here for global sort events, NOT column sort events, as we want to do this
	    // when sorting has been set on all column (if we listened just for our col (where we
	    // set the asc / desc icons) then it's possible other cols are yet to get their sorting state.
	    HeaderComp.prototype.setMultiSortOrder = function () {
	        if (!this.eSortOrder) {
	            return;
	        }
	        var col = this.params.column;
	        var allColumnsWithSorting = this.sortController.getColumnsWithSortingOrdered();
	        var indexThisCol = allColumnsWithSorting.indexOf(col);
	        var moreThanOneColSorting = allColumnsWithSorting.length > 1;
	        var showIndex = col.isSorting() && moreThanOneColSorting;
	        utils_1._.setDisplayed(this.eSortOrder, showIndex);
	        if (indexThisCol >= 0) {
	            this.eSortOrder.innerHTML = (indexThisCol + 1).toString();
	        }
	        else {
	            utils_1._.clearElement(this.eSortOrder);
	        }
	    };
	    HeaderComp.prototype.setupFilterIcon = function () {
	        if (!this.eFilter) {
	            return;
	        }
	        this.addDestroyableEventListener(this.params.column, column_1.Column.EVENT_FILTER_CHANGED, this.onFilterChanged.bind(this));
	        this.onFilterChanged();
	    };
	    HeaderComp.prototype.onFilterChanged = function () {
	        var filterPresent = this.params.column.isFilterActive();
	        utils_1._.addOrRemoveCssClass(this.eFilter, 'ag-hidden', !filterPresent);
	    };
	    HeaderComp.TEMPLATE = '<div class="ag-cell-label-container" role="presentation">' +
	        '  <span ref="eMenu" class="ag-header-icon ag-header-cell-menu-button" aria-hidden="true"></span>' +
	        '  <div ref="eLabel" class="ag-header-cell-label" role="presentation" unselectable="on">' +
	        '    <span ref="eText" class="ag-header-cell-text" role="columnheader" unselectable="on"></span>' +
	        '    <span ref="eFilter" class="ag-header-icon ag-filter-icon" aria-hidden="true"></span>' +
	        '    <span ref="eSortOrder" class="ag-header-icon ag-sort-order" aria-hidden="true"></span>' +
	        '    <span ref="eSortAsc" class="ag-header-icon ag-sort-ascending-icon" aria-hidden="true"></span>' +
	        '    <span ref="eSortDesc" class="ag-header-icon ag-sort-descending-icon" aria-hidden="true"></span>' +
	        '    <span ref="eSortNone" class="ag-header-icon ag-sort-none-icon" aria-hidden="true"></span>' +
	        '  </div>' +
	        '</div>';
	    __decorate([
	        context_1.Autowired('gridOptionsWrapper'),
	        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
	    ], HeaderComp.prototype, "gridOptionsWrapper", void 0);
	    __decorate([
	        context_1.Autowired('sortController'),
	        __metadata("design:type", sortController_1.SortController)
	    ], HeaderComp.prototype, "sortController", void 0);
	    __decorate([
	        context_1.Autowired('menuFactory'),
	        __metadata("design:type", Object)
	    ], HeaderComp.prototype, "menuFactory", void 0);
	    __decorate([
	        context_1.Autowired('eventService'),
	        __metadata("design:type", eventService_1.EventService)
	    ], HeaderComp.prototype, "eventService", void 0);
	    __decorate([
	        componentAnnotations_1.RefSelector('eFilter'),
	        __metadata("design:type", HTMLElement)
	    ], HeaderComp.prototype, "eFilter", void 0);
	    __decorate([
	        componentAnnotations_1.RefSelector('eSortAsc'),
	        __metadata("design:type", HTMLElement)
	    ], HeaderComp.prototype, "eSortAsc", void 0);
	    __decorate([
	        componentAnnotations_1.RefSelector('eSortDesc'),
	        __metadata("design:type", HTMLElement)
	    ], HeaderComp.prototype, "eSortDesc", void 0);
	    __decorate([
	        componentAnnotations_1.RefSelector('eSortNone'),
	        __metadata("design:type", HTMLElement)
	    ], HeaderComp.prototype, "eSortNone", void 0);
	    __decorate([
	        componentAnnotations_1.RefSelector('eSortOrder'),
	        __metadata("design:type", HTMLElement)
	    ], HeaderComp.prototype, "eSortOrder", void 0);
	    __decorate([
	        componentAnnotations_1.RefSelector('eMenu'),
	        __metadata("design:type", HTMLElement)
	    ], HeaderComp.prototype, "eMenu", void 0);
	    __decorate([
	        componentAnnotations_1.RefSelector('eLabel'),
	        __metadata("design:type", HTMLElement)
	    ], HeaderComp.prototype, "eLabel", void 0);
	    __decorate([
	        componentAnnotations_1.RefSelector('eText'),
	        __metadata("design:type", HTMLElement)
	    ], HeaderComp.prototype, "eText", void 0);
	    return HeaderComp;
	}(component_1.Component));
	exports.HeaderComp = HeaderComp;


/***/ }),
/* 2391 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var column_1 = __webpack_require__(2343);
	var context_1 = __webpack_require__(2333);
	var gridOptionsWrapper_1 = __webpack_require__(2324);
	var columnApi_1 = __webpack_require__(2346);
	var columnController_1 = __webpack_require__(2341);
	var eventService_1 = __webpack_require__(2331);
	var events_1 = __webpack_require__(2335);
	var gridApi_1 = __webpack_require__(2338);
	var utils_1 = __webpack_require__(2325);
	var SortController = /** @class */ (function () {
	    function SortController() {
	    }
	    SortController_1 = SortController;
	    SortController.prototype.progressSort = function (column, multiSort, source) {
	        if (source === void 0) { source = "api"; }
	        var nextDirection = this.getNextSortDirection(column);
	        this.setSortForColumn(column, nextDirection, multiSort, source);
	    };
	    SortController.prototype.setSortForColumn = function (column, sort, multiSort, source) {
	        if (source === void 0) { source = "api"; }
	        // auto correct - if sort not legal value, then set it to 'no sort' (which is null)
	        if (sort !== column_1.Column.SORT_ASC && sort !== column_1.Column.SORT_DESC) {
	            sort = null;
	        }
	        // update sort on current col
	        column.setSort(sort, source);
	        // sortedAt used for knowing order of cols when multi-col sort
	        if (column.getSort()) {
	            var sortedAt = Number(new Date().valueOf());
	            column.setSortedAt(sortedAt);
	        }
	        else {
	            column.setSortedAt(null);
	        }
	        var doingMultiSort = multiSort && !this.gridOptionsWrapper.isSuppressMultiSort();
	        // clear sort on all columns except this one, and update the icons
	        if (!doingMultiSort) {
	            this.clearSortBarThisColumn(column, source);
	        }
	        this.dispatchSortChangedEvents();
	    };
	    // gets called by API, so if data changes, use can call this, which will end up
	    // working out the sort order again of the rows.
	    SortController.prototype.onSortChanged = function () {
	        this.dispatchSortChangedEvents();
	    };
	    SortController.prototype.dispatchSortChangedEvents = function () {
	        var event = {
	            type: events_1.Events.EVENT_SORT_CHANGED,
	            api: this.gridApi,
	            columnApi: this.columnApi
	        };
	        this.eventService.dispatchEvent(event);
	    };
	    SortController.prototype.clearSortBarThisColumn = function (columnToSkip, source) {
	        this.columnController.getPrimaryAndSecondaryAndAutoColumns().forEach(function (columnToClear) {
	            // Do not clear if either holding shift, or if column in question was clicked
	            if (!(columnToClear === columnToSkip)) {
	                // setting to 'undefined' as null means 'none' rather than cleared, otherwise issue will arise
	                // if sort order is: ['desc', null , 'asc'], as it will start at null rather than 'desc'.
	                columnToClear.setSort(undefined, source);
	            }
	        });
	    };
	    SortController.prototype.getNextSortDirection = function (column) {
	        var sortingOrder;
	        if (column.getColDef().sortingOrder) {
	            sortingOrder = column.getColDef().sortingOrder;
	        }
	        else if (this.gridOptionsWrapper.getSortingOrder()) {
	            sortingOrder = this.gridOptionsWrapper.getSortingOrder();
	        }
	        else {
	            sortingOrder = SortController_1.DEFAULT_SORTING_ORDER;
	        }
	        if (!Array.isArray(sortingOrder) || sortingOrder.length <= 0) {
	            console.warn("ag-grid: sortingOrder must be an array with at least one element, currently it's " + sortingOrder);
	            return null;
	        }
	        var currentIndex = sortingOrder.indexOf(column.getSort());
	        var notInArray = currentIndex < 0;
	        var lastItemInArray = currentIndex == sortingOrder.length - 1;
	        var result;
	        if (notInArray || lastItemInArray) {
	            result = sortingOrder[0];
	        }
	        else {
	            result = sortingOrder[currentIndex + 1];
	        }
	        // verify the sort type exists, as the user could provide the sortingOrder, need to make sure it's valid
	        if (SortController_1.DEFAULT_SORTING_ORDER.indexOf(result) < 0) {
	            console.warn('ag-grid: invalid sort type ' + result);
	            return null;
	        }
	        return result;
	    };
	    // used by the public api, for saving the sort model
	    SortController.prototype.getSortModel = function () {
	        var columnsWithSorting = this.getColumnsWithSortingOrdered();
	        return utils_1._.map(columnsWithSorting, function (column) {
	            return {
	                colId: column.getColId(),
	                sort: column.getSort()
	            };
	        });
	    };
	    SortController.prototype.setSortModel = function (sortModel, source) {
	        var _this = this;
	        if (source === void 0) { source = "api"; }
	        // first up, clear any previous sort
	        var sortModelProvided = sortModel && sortModel.length > 0;
	        var allColumnsIncludingAuto = this.columnController.getPrimaryAndSecondaryAndAutoColumns();
	        allColumnsIncludingAuto.forEach(function (column) {
	            var sortForCol = null;
	            var sortedAt = -1;
	            if (sortModelProvided && column.getColDef().sortable) {
	                for (var j = 0; j < sortModel.length; j++) {
	                    var sortModelEntry = sortModel[j];
	                    if (typeof sortModelEntry.colId === 'string'
	                        && typeof column.getColId() === 'string'
	                        && _this.compareColIds(sortModelEntry, column)) {
	                        sortForCol = sortModelEntry.sort;
	                        sortedAt = j;
	                    }
	                }
	            }
	            if (sortForCol) {
	                column.setSort(sortForCol, source);
	                column.setSortedAt(sortedAt);
	            }
	            else {
	                column.setSort(null, source);
	                column.setSortedAt(null);
	            }
	        });
	        this.dispatchSortChangedEvents();
	    };
	    SortController.prototype.compareColIds = function (sortModelEntry, column) {
	        return sortModelEntry.colId === column.getColId();
	    };
	    SortController.prototype.getColumnsWithSortingOrdered = function () {
	        // pull out all the columns that have sorting set
	        var allColumnsIncludingAuto = this.columnController.getPrimaryAndSecondaryAndAutoColumns();
	        var columnsWithSorting = utils_1._.filter(allColumnsIncludingAuto, function (column) { return !!column.getSort(); });
	        // put the columns in order of which one got sorted first
	        columnsWithSorting.sort(function (a, b) { return a.sortedAt - b.sortedAt; });
	        return columnsWithSorting;
	    };
	    // used by row controller, when doing the sorting
	    SortController.prototype.getSortForRowController = function () {
	        var columnsWithSorting = this.getColumnsWithSortingOrdered();
	        return utils_1._.map(columnsWithSorting, function (column) {
	            var ascending = column.getSort() === column_1.Column.SORT_ASC;
	            return {
	                inverter: ascending ? 1 : -1,
	                column: column
	            };
	        });
	    };
	    var SortController_1;
	    SortController.DEFAULT_SORTING_ORDER = [column_1.Column.SORT_ASC, column_1.Column.SORT_DESC, null];
	    __decorate([
	        context_1.Autowired('gridOptionsWrapper'),
	        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
	    ], SortController.prototype, "gridOptionsWrapper", void 0);
	    __decorate([
	        context_1.Autowired('columnController'),
	        __metadata("design:type", columnController_1.ColumnController)
	    ], SortController.prototype, "columnController", void 0);
	    __decorate([
	        context_1.Autowired('eventService'),
	        __metadata("design:type", eventService_1.EventService)
	    ], SortController.prototype, "eventService", void 0);
	    __decorate([
	        context_1.Autowired('columnApi'),
	        __metadata("design:type", columnApi_1.ColumnApi)
	    ], SortController.prototype, "columnApi", void 0);
	    __decorate([
	        context_1.Autowired('gridApi'),
	        __metadata("design:type", gridApi_1.GridApi)
	    ], SortController.prototype, "gridApi", void 0);
	    SortController = SortController_1 = __decorate([
	        context_1.Bean('sortController')
	    ], SortController);
	    return SortController;
	}());
	exports.SortController = SortController;


/***/ }),
/* 2392 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var eventService_1 = __webpack_require__(2331);
	var utils_1 = __webpack_require__(2325);
	var TouchListener = /** @class */ (function () {
	    function TouchListener(eElement, preventMouseClick) {
	        var _this = this;
	        if (preventMouseClick === void 0) { preventMouseClick = false; }
	        this.destroyFuncs = [];
	        this.touching = false;
	        this.eventService = new eventService_1.EventService();
	        this.eElement = eElement;
	        this.preventMouseClick = preventMouseClick;
	        var startListener = this.onTouchStart.bind(this);
	        var moveListener = this.onTouchMove.bind(this);
	        var endListener = this.onTouchEnd.bind(this);
	        this.eElement.addEventListener("touchstart", startListener, { passive: true });
	        this.eElement.addEventListener("touchmove", moveListener, { passive: true });
	        // we set passive=false, as we want to prevent default on this event
	        this.eElement.addEventListener("touchend", endListener, { passive: false });
	        this.destroyFuncs.push(function () {
	            _this.eElement.removeEventListener("touchstart", startListener, { passive: true });
	            _this.eElement.removeEventListener("touchmove", moveListener, { passive: true });
	            _this.eElement.removeEventListener("touchend", endListener, { passive: false });
	        });
	    }
	    TouchListener.prototype.getActiveTouch = function (touchList) {
	        for (var i = 0; i < touchList.length; i++) {
	            var matches = touchList[i].identifier === this.touchStart.identifier;
	            if (matches) {
	                return touchList[i];
	            }
	        }
	        return null;
	    };
	    TouchListener.prototype.addEventListener = function (eventType, listener) {
	        this.eventService.addEventListener(eventType, listener);
	    };
	    TouchListener.prototype.removeEventListener = function (eventType, listener) {
	        this.eventService.removeEventListener(eventType, listener);
	    };
	    TouchListener.prototype.onTouchStart = function (touchEvent) {
	        var _this = this;
	        // only looking at one touch point at any time
	        if (this.touching) {
	            return;
	        }
	        this.touchStart = touchEvent.touches[0];
	        this.touching = true;
	        this.moved = false;
	        var touchStartCopy = this.touchStart;
	        window.setTimeout(function () {
	            var touchesMatch = _this.touchStart === touchStartCopy;
	            if (_this.touching && touchesMatch && !_this.moved) {
	                _this.moved = true;
	                var event_1 = {
	                    type: TouchListener.EVENT_LONG_TAP,
	                    touchStart: _this.touchStart,
	                    touchEvent: touchEvent
	                };
	                _this.eventService.dispatchEvent(event_1);
	            }
	        }, 500);
	    };
	    TouchListener.prototype.onTouchMove = function (touchEvent) {
	        if (!this.touching) {
	            return;
	        }
	        var touch = this.getActiveTouch(touchEvent.touches);
	        if (!touch) {
	            return;
	        }
	        var eventIsFarAway = !utils_1._.areEventsNear(touch, this.touchStart, 4);
	        if (eventIsFarAway) {
	            this.moved = true;
	        }
	    };
	    TouchListener.prototype.onTouchEnd = function (touchEvent) {
	        if (!this.touching) {
	            return;
	        }
	        if (!this.moved) {
	            var event_2 = {
	                type: TouchListener.EVENT_TAP,
	                touchStart: this.touchStart
	            };
	            this.eventService.dispatchEvent(event_2);
	            this.checkForDoubleTap();
	        }
	        // stops the tap from also been processed as a mouse click
	        if (this.preventMouseClick) {
	            touchEvent.preventDefault();
	        }
	        this.touching = false;
	    };
	    TouchListener.prototype.checkForDoubleTap = function () {
	        var now = new Date().getTime();
	        if (this.lastTapTime && this.lastTapTime > 0) {
	            // if previous tap, see if duration is short enough to be considered double tap
	            var interval = now - this.lastTapTime;
	            if (interval > TouchListener.DOUBLE_TAP_MILLIS) {
	                // dispatch double tap event
	                var event_3 = {
	                    type: TouchListener.EVENT_DOUBLE_TAP,
	                    touchStart: this.touchStart
	                };
	                this.eventService.dispatchEvent(event_3);
	                // this stops a tripple tap ending up as two double taps
	                this.lastTapTime = null;
	            }
	            else {
	                this.lastTapTime = now;
	            }
	        }
	        else {
	            this.lastTapTime = now;
	        }
	    };
	    TouchListener.prototype.destroy = function () {
	        this.destroyFuncs.forEach(function (func) { return func(); });
	    };
	    TouchListener.EVENT_TAP = "tap";
	    TouchListener.EVENT_DOUBLE_TAP = "doubleTap";
	    TouchListener.EVENT_LONG_TAP = "longTap";
	    TouchListener.DOUBLE_TAP_MILLIS = 500;
	    return TouchListener;
	}());
	exports.TouchListener = TouchListener;


/***/ }),
/* 2393 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var component_1 = __webpack_require__(2353);
	var columnController_1 = __webpack_require__(2341);
	var gridOptionsWrapper_1 = __webpack_require__(2324);
	var context_1 = __webpack_require__(2333);
	var touchListener_1 = __webpack_require__(2392);
	var componentAnnotations_1 = __webpack_require__(2384);
	var originalColumnGroup_1 = __webpack_require__(2345);
	var utils_1 = __webpack_require__(2325);
	var HeaderGroupComp = /** @class */ (function (_super) {
	    __extends(HeaderGroupComp, _super);
	    function HeaderGroupComp() {
	        return _super.call(this, HeaderGroupComp.TEMPLATE) || this;
	    }
	    HeaderGroupComp.prototype.init = function (params) {
	        this.params = params;
	        this.setupLabel();
	        this.addGroupExpandIcon();
	        this.setupExpandIcons();
	    };
	    HeaderGroupComp.prototype.setupExpandIcons = function () {
	        var _this = this;
	        this.addInIcon("columnGroupOpened", "agOpened");
	        this.addInIcon("columnGroupClosed", "agClosed");
	        var expandAction = function (event) {
	            if (utils_1._.isStopPropagationForAgGrid(event)) {
	                return;
	            }
	            var newExpandedValue = !_this.params.columnGroup.isExpanded();
	            _this.columnController.setColumnGroupOpened(_this.params.columnGroup.getOriginalColumnGroup(), newExpandedValue, "uiColumnExpanded");
	        };
	        this.addTouchAndClickListeners(this.eCloseIcon, expandAction);
	        this.addTouchAndClickListeners(this.eOpenIcon, expandAction);
	        var stopPropagationAction = function (event) {
	            utils_1._.stopPropagationForAgGrid(event);
	        };
	        // adding stopPropagation to the double click for the icons prevents double click action happening
	        // when the icons are clicked. if the icons are double clicked, then the groups should open and
	        // then close again straight away. if we also listened to double click, then the group would open,
	        // close, then open, which is not what we want. double click should only action if the user double
	        // clicks outside of the icons.
	        this.addDestroyableEventListener(this.eCloseIcon, "dblclick", stopPropagationAction);
	        this.addDestroyableEventListener(this.eOpenIcon, "dblclick", stopPropagationAction);
	        this.addDestroyableEventListener(this.getGui(), "dblclick", expandAction);
	        this.updateIconVisibility();
	        var originalColumnGroup = this.params.columnGroup.getOriginalColumnGroup();
	        this.addDestroyableEventListener(originalColumnGroup, originalColumnGroup_1.OriginalColumnGroup.EVENT_EXPANDED_CHANGED, this.updateIconVisibility.bind(this));
	        this.addDestroyableEventListener(originalColumnGroup, originalColumnGroup_1.OriginalColumnGroup.EVENT_EXPANDABLE_CHANGED, this.updateIconVisibility.bind(this));
	    };
	    HeaderGroupComp.prototype.addTouchAndClickListeners = function (eElement, action) {
	        var touchListener = new touchListener_1.TouchListener(eElement);
	        this.addDestroyableEventListener(touchListener, touchListener_1.TouchListener.EVENT_TAP, action);
	        this.addDestroyFunc(function () { return touchListener.destroy(); });
	        this.addDestroyableEventListener(eElement, "click", action);
	    };
	    HeaderGroupComp.prototype.updateIconVisibility = function () {
	        var columnGroup = this.params.columnGroup;
	        if (columnGroup.isExpandable()) {
	            var expanded = this.params.columnGroup.isExpanded();
	            utils_1._.setDisplayed(this.eOpenIcon, !expanded);
	            utils_1._.setDisplayed(this.eCloseIcon, expanded);
	        }
	        else {
	            utils_1._.setDisplayed(this.eOpenIcon, false);
	            utils_1._.setDisplayed(this.eCloseIcon, false);
	        }
	    };
	    HeaderGroupComp.prototype.addInIcon = function (iconName, refName) {
	        var eIcon = utils_1._.createIconNoSpan(iconName, this.gridOptionsWrapper, null);
	        this.getRefElement(refName).appendChild(eIcon);
	    };
	    HeaderGroupComp.prototype.addGroupExpandIcon = function () {
	        if (!this.params.columnGroup.isExpandable()) {
	            utils_1._.setDisplayed(this.eOpenIcon, false);
	            utils_1._.setDisplayed(this.eCloseIcon, false);
	            return;
	        }
	    };
	    HeaderGroupComp.prototype.setupLabel = function () {
	        // no renderer, default text render
	        if (this.params.displayName && this.params.displayName !== "") {
	            var eInnerText = this.getRefElement("agLabel");
	            eInnerText.innerHTML = this.params.displayName;
	        }
	    };
	    HeaderGroupComp.TEMPLATE = "<div class=\"ag-header-group-cell-label\" ref=\"agContainer\" role=\"presentation\">" +
	        "<span ref=\"agLabel\" class=\"ag-header-group-text\" role=\"columnheader\"></span>" +
	        "<span ref=\"agOpened\" class=\"ag-header-icon ag-header-expand-icon ag-header-expand-icon-expanded\"></span>" +
	        "<span ref=\"agClosed\" class=\"ag-header-icon ag-header-expand-icon ag-header-expand-icon-collapsed\"></span>" +
	        "</div>";
	    __decorate([
	        context_1.Autowired("columnController"),
	        __metadata("design:type", columnController_1.ColumnController)
	    ], HeaderGroupComp.prototype, "columnController", void 0);
	    __decorate([
	        context_1.Autowired("gridOptionsWrapper"),
	        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
	    ], HeaderGroupComp.prototype, "gridOptionsWrapper", void 0);
	    __decorate([
	        componentAnnotations_1.RefSelector("agOpened"),
	        __metadata("design:type", HTMLElement)
	    ], HeaderGroupComp.prototype, "eOpenIcon", void 0);
	    __decorate([
	        componentAnnotations_1.RefSelector("agClosed"),
	        __metadata("design:type", HTMLElement)
	    ], HeaderGroupComp.prototype, "eCloseIcon", void 0);
	    return HeaderGroupComp;
	}(component_1.Component));
	exports.HeaderGroupComp = HeaderGroupComp;


/***/ }),
/* 2394 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var gridOptionsWrapper_1 = __webpack_require__(2324);
	var expressionService_1 = __webpack_require__(2347);
	var eventService_1 = __webpack_require__(2331);
	var constants_1 = __webpack_require__(2328);
	var context_1 = __webpack_require__(2333);
	var component_1 = __webpack_require__(2353);
	var rowNode_1 = __webpack_require__(2356);
	var valueFormatterService_1 = __webpack_require__(2395);
	var checkboxSelectionComponent_1 = __webpack_require__(2355);
	var columnController_1 = __webpack_require__(2341);
	var column_1 = __webpack_require__(2343);
	var componentAnnotations_1 = __webpack_require__(2384);
	var mouseEventService_1 = __webpack_require__(2396);
	var userComponentFactory_1 = __webpack_require__(2380);
	var utils_1 = __webpack_require__(2325);
	var GroupCellRenderer = /** @class */ (function (_super) {
	    __extends(GroupCellRenderer, _super);
	    function GroupCellRenderer() {
	        return _super.call(this, GroupCellRenderer.TEMPLATE) || this;
	    }
	    GroupCellRenderer.prototype.init = function (params) {
	        this.params = params;
	        if (this.gridOptionsWrapper.isGroupIncludeTotalFooter()) {
	            this.assignBlankValueToGroupFooterCell(params);
	        }
	        var embeddedRowMismatch = this.isEmbeddedRowMismatch();
	        // This allows for empty strings to appear as groups since
	        // it will only return for null or undefined.
	        var cellIsEmpty = params.value == null;
	        this.cellIsBlank = embeddedRowMismatch || cellIsEmpty;
	        if (this.cellIsBlank) {
	            return;
	        }
	        this.setupDragOpenParents();
	        this.addExpandAndContract();
	        this.addCheckboxIfNeeded();
	        this.addValueElement();
	        this.setupIndent();
	    };
	    GroupCellRenderer.prototype.assignBlankValueToGroupFooterCell = function (params) {
	        // this is not ideal, but it was the only way we could get footer working for the root node
	        if (!params.value && params.node.level == -1) {
	            params.value = '';
	        }
	    };
	    // if we are doing embedded full width rows, we only show the renderer when
	    // in the body, or if pinning in the pinned section, or if pinning and RTL,
	    // in the right section. otherwise we would have the cell repeated in each section.
	    GroupCellRenderer.prototype.isEmbeddedRowMismatch = function () {
	        if (this.params.fullWidth && this.gridOptionsWrapper.isEmbedFullWidthRows()) {
	            var pinnedLeftCell = this.params.pinned === column_1.Column.PINNED_LEFT;
	            var pinnedRightCell = this.params.pinned === column_1.Column.PINNED_RIGHT;
	            var bodyCell = !pinnedLeftCell && !pinnedRightCell;
	            if (this.gridOptionsWrapper.isEnableRtl()) {
	                if (this.columnController.isPinningLeft()) {
	                    return !pinnedRightCell;
	                }
	                else {
	                    return !bodyCell;
	                }
	            }
	            else {
	                if (this.columnController.isPinningLeft()) {
	                    return !pinnedLeftCell;
	                }
	                else {
	                    return !bodyCell;
	                }
	            }
	        }
	        else {
	            return false;
	        }
	    };
	    GroupCellRenderer.prototype.setIndent = function () {
	        if (this.gridOptionsWrapper.isGroupHideOpenParents()) {
	            return;
	        }
	        var params = this.params;
	        var rowNode = params.node;
	        var paddingCount = rowNode.uiLevel;
	        var userProvidedPaddingPixelsTheDeprecatedWay = params.padding >= 0;
	        if (userProvidedPaddingPixelsTheDeprecatedWay) {
	            this.setPaddingDeprecatedWay(paddingCount, params.padding);
	            return;
	        }
	        if (this.indentClass) {
	            this.removeCssClass(this.indentClass);
	        }
	        this.indentClass = 'ag-row-group-indent-' + paddingCount;
	        this.addCssClass(this.indentClass);
	    };
	    GroupCellRenderer.prototype.setPaddingDeprecatedWay = function (paddingCount, padding) {
	        utils_1._.doOnce(function () { return console.warn('ag-Grid: since v14.2, configuring padding for groupCellRenderer should be done with Sass variables and themes. Please see the ag-Grid documentation page for Themes, in particular the property $row-group-indent-size.'); }, 'groupCellRenderer->doDeprecatedWay');
	        var paddingPx = paddingCount * padding;
	        if (this.gridOptionsWrapper.isEnableRtl()) {
	            // if doing rtl, padding is on the right
	            this.getGui().style.paddingRight = paddingPx + 'px';
	        }
	        else {
	            // otherwise it is on the left
	            this.getGui().style.paddingLeft = paddingPx + 'px';
	        }
	    };
	    GroupCellRenderer.prototype.setupIndent = function () {
	        // only do this if an indent - as this overwrites the padding that
	        // the theme set, which will make things look 'not aligned' for the
	        // first group level.
	        var node = this.params.node;
	        var suppressPadding = this.params.suppressPadding;
	        if (!suppressPadding) {
	            this.addDestroyableEventListener(node, rowNode_1.RowNode.EVENT_UI_LEVEL_CHANGED, this.setIndent.bind(this));
	            this.setIndent();
	        }
	    };
	    GroupCellRenderer.prototype.addValueElement = function () {
	        var params = this.params;
	        var rowNode = this.displayedGroup;
	        if (rowNode.footer) {
	            this.createFooterCell();
	        }
	        else if (rowNode.hasChildren() ||
	            utils_1._.get(params.colDef, 'cellRendererParams.innerRenderer', null) ||
	            utils_1._.get(params.colDef, 'cellRendererParams.innerRendererFramework', null)) {
	            this.createGroupCell();
	            if (rowNode.hasChildren()) {
	                this.addChildCount();
	            }
	        }
	        else {
	            this.createLeafCell();
	        }
	    };
	    GroupCellRenderer.prototype.createFooterCell = function () {
	        var footerValue;
	        var footerValueGetter = this.params.footerValueGetter;
	        if (footerValueGetter) {
	            // params is same as we were given, except we set the value as the item to display
	            var paramsClone = utils_1._.cloneObject(this.params);
	            paramsClone.value = this.params.value;
	            if (typeof footerValueGetter === 'function') {
	                footerValue = footerValueGetter(paramsClone);
	            }
	            else if (typeof footerValueGetter === 'string') {
	                footerValue = this.expressionService.evaluate(footerValueGetter, paramsClone);
	            }
	            else {
	                console.warn('ag-Grid: footerValueGetter should be either a function or a string (expression)');
	            }
	        }
	        else {
	            footerValue = 'Total ' + this.params.value;
	        }
	        this.eValue.innerHTML = footerValue;
	    };
	    GroupCellRenderer.prototype.createGroupCell = function () {
	        var _this = this;
	        var params = this.params;
	        var rowGroupColumn = this.displayedGroup.rowGroupColumn;
	        // we try and use the cellRenderer of the column used for the grouping if we can
	        var columnToUse = rowGroupColumn ? rowGroupColumn : params.column;
	        var groupName = this.params.value;
	        var valueFormatted = columnToUse ?
	            this.valueFormatterService.formatValue(columnToUse, params.node, params.scope, groupName) : null;
	        params.valueFormatted = valueFormatted;
	        var rendererPromise;
	        if (params.fullWidth == true) {
	            rendererPromise = this.useFullWidth(params);
	        }
	        else {
	            rendererPromise = this.useInnerRenderer(this.params.colDef.cellRendererParams, columnToUse.getColDef(), params);
	        }
	        // retain a reference to the created renderer - we'll use this later for cleanup (in destroy)
	        if (rendererPromise) {
	            rendererPromise.then(function (value) {
	                _this.innerCellRenderer = value;
	            });
	        }
	    };
	    GroupCellRenderer.prototype.useInnerRenderer = function (groupCellRendererParams, groupedColumnDef, // the column this group row is for, eg 'Country'
	    params) {
	        // when grouping, the normal case is we use the cell renderer of the grouped column. eg if grouping by country
	        // and then rating, we will use the country cell renderer for each country group row and likewise the rating
	        // cell renderer for each rating group row.
	        //
	        // however if the user has innerCellRenderer defined, this gets preference and we don't use cell renderers
	        // of the grouped columns.
	        //
	        // so we check and use in the following order:
	        //
	        // 1) thisColDef.cellRendererParams.innerRenderer of the column showing the groups (eg auto group column)
	        // 2) groupedColDef.cellRenderer of the grouped column
	        // 3) groupedColDef.cellRendererParams.innerRenderer
	        var _this = this;
	        var cellRendererPromise = null;
	        // we check if cell renderer provided for the group cell renderer, eg colDef.cellRendererParams.innerRenderer
	        var groupInnerRendererClass = this.userComponentFactory
	            .lookupComponentClassDef(groupCellRendererParams, "innerRenderer");
	        if (groupInnerRendererClass && groupInnerRendererClass.component != null
	            && groupInnerRendererClass.source != userComponentFactory_1.ComponentSource.DEFAULT) {
	            // use the renderer defined in cellRendererParams.innerRenderer
	            cellRendererPromise = this.userComponentFactory.newInnerCellRenderer(groupCellRendererParams, params);
	        }
	        else {
	            // otherwise see if we can use the cellRenderer of the column we are grouping by
	            var groupColumnRendererClass = this.userComponentFactory
	                .lookupComponentClassDef(groupedColumnDef, "cellRenderer");
	            if (groupColumnRendererClass && groupColumnRendererClass.source != userComponentFactory_1.ComponentSource.DEFAULT) {
	                // Only if the original column is using a specific renderer, it it is a using a DEFAULT one ignore it
	                cellRendererPromise = this.userComponentFactory.newCellRenderer(groupedColumnDef, params);
	            }
	            else if (groupColumnRendererClass && groupColumnRendererClass.source == userComponentFactory_1.ComponentSource.DEFAULT
	                && (utils_1._.get(groupedColumnDef, 'cellRendererParams.innerRenderer', null))) {
	                // EDGE CASE - THIS COMES FROM A COLUMN WHICH HAS BEEN GROUPED DYNAMICALLY, THAT HAS AS RENDERER 'group'
	                // AND HAS A INNER CELL RENDERER
	                cellRendererPromise = this.userComponentFactory.newInnerCellRenderer(groupedColumnDef.cellRendererParams, params);
	            }
	            else {
	                // This forces the retrieval of the default plain cellRenderer that just renders the values.
	                cellRendererPromise = this.userComponentFactory.newCellRenderer({}, params);
	            }
	        }
	        if (cellRendererPromise != null) {
	            cellRendererPromise.then(function (rendererToUse) {
	                if (rendererToUse == null) {
	                    _this.eValue.innerText = params.valueFormatted != null ? params.valueFormatted : params.value;
	                    return;
	                }
	                utils_1._.bindCellRendererToHtmlElement(cellRendererPromise, _this.eValue);
	            });
	        }
	        else {
	            this.eValue.innerText = params.valueFormatted != null ? params.valueFormatted : params.value;
	        }
	        return cellRendererPromise;
	    };
	    GroupCellRenderer.prototype.useFullWidth = function (params) {
	        var cellRendererPromise = this.userComponentFactory.newFullWidthGroupRowInnerCellRenderer(params);
	        if (cellRendererPromise != null) {
	            utils_1._.bindCellRendererToHtmlElement(cellRendererPromise, this.eValue);
	        }
	        else {
	            this.eValue.innerText = params.valueFormatted != null ? params.valueFormatted : params.value;
	        }
	        return cellRendererPromise;
	    };
	    GroupCellRenderer.prototype.addChildCount = function () {
	        // only include the child count if it's included, eg if user doing custom aggregation,
	        // then this could be left out, or set to -1, ie no child count
	        if (this.params.suppressCount) {
	            return;
	        }
	        this.addDestroyableEventListener(this.displayedGroup, rowNode_1.RowNode.EVENT_ALL_CHILDREN_COUNT_CHANGED, this.updateChildCount.bind(this));
	        // filtering changes the child count, so need to cater for it
	        this.updateChildCount();
	    };
	    GroupCellRenderer.prototype.updateChildCount = function () {
	        var allChildrenCount = this.displayedGroup.allChildrenCount;
	        this.eChildCount.innerHTML = allChildrenCount >= 0 ? "(" + allChildrenCount + ")" : "";
	    };
	    GroupCellRenderer.prototype.createLeafCell = function () {
	        if (utils_1._.exists(this.params.value)) {
	            this.eValue.innerText = this.params.valueFormatted ? this.params.valueFormatted : this.params.value;
	        }
	    };
	    GroupCellRenderer.prototype.isUserWantsSelected = function () {
	        var paramsCheckbox = this.params.checkbox;
	        if (typeof paramsCheckbox === 'function') {
	            return paramsCheckbox(this.params);
	        }
	        else {
	            return paramsCheckbox === true;
	        }
	    };
	    GroupCellRenderer.prototype.addCheckboxIfNeeded = function () {
	        var rowNode = this.displayedGroup;
	        var checkboxNeeded = this.isUserWantsSelected()
	            // footers cannot be selected
	            && !rowNode.footer
	            // pinned rows cannot be selected
	            && !rowNode.rowPinned
	            // details cannot be selected
	            && !rowNode.detail;
	        if (checkboxNeeded) {
	            var cbSelectionComponent_1 = new checkboxSelectionComponent_1.CheckboxSelectionComponent();
	            this.getContext().wireBean(cbSelectionComponent_1);
	            cbSelectionComponent_1.init({ rowNode: rowNode, column: this.params.column });
	            this.eCheckbox.appendChild(cbSelectionComponent_1.getGui());
	            this.addDestroyFunc(function () { return cbSelectionComponent_1.destroy(); });
	        }
	        utils_1._.addOrRemoveCssClass(this.eCheckbox, 'ag-invisible', !checkboxNeeded);
	    };
	    GroupCellRenderer.prototype.addExpandAndContract = function () {
	        var params = this.params;
	        var eGroupCell = params.eGridCell;
	        var eExpandedIcon = utils_1._.createIconNoSpan('groupExpanded', this.gridOptionsWrapper, null);
	        var eContractedIcon = utils_1._.createIconNoSpan('groupContracted', this.gridOptionsWrapper, null);
	        this.eExpanded.appendChild(eExpandedIcon);
	        this.eContracted.appendChild(eContractedIcon);
	        this.addDestroyableEventListener(this.eExpanded, 'click', this.onExpandClicked.bind(this));
	        this.addDestroyableEventListener(this.eContracted, 'click', this.onExpandClicked.bind(this));
	        // expand / contract as the user hits enter
	        this.addDestroyableEventListener(eGroupCell, 'keydown', this.onKeyDown.bind(this));
	        this.addDestroyableEventListener(params.node, rowNode_1.RowNode.EVENT_EXPANDED_CHANGED, this.showExpandAndContractIcons.bind(this));
	        this.showExpandAndContractIcons();
	        // because we don't show the expand / contract when there are no children, we need to check every time
	        // the number of children change.
	        this.addDestroyableEventListener(this.displayedGroup, rowNode_1.RowNode.EVENT_ALL_CHILDREN_COUNT_CHANGED, this.onAllChildrenCountChanged.bind(this));
	        // if editing groups, then double click is to start editing
	        if (!this.gridOptionsWrapper.isEnableGroupEdit() && this.isExpandable() && !params.suppressDoubleClickExpand) {
	            this.addDestroyableEventListener(eGroupCell, 'dblclick', this.onCellDblClicked.bind(this));
	        }
	    };
	    GroupCellRenderer.prototype.onAllChildrenCountChanged = function () {
	        // maybe if no children now, we should hide the expand / contract icons
	        this.showExpandAndContractIcons();
	        // if we have no children, this impacts the indent
	        this.setIndent();
	    };
	    GroupCellRenderer.prototype.onKeyDown = function (event) {
	        var enterKeyPressed = utils_1._.isKeyPressed(event, constants_1.Constants.KEY_ENTER);
	        if (enterKeyPressed) {
	            if (this.params.suppressEnterExpand) {
	                return;
	            }
	            var cellEditable = this.params.column && this.params.column.isCellEditable(this.params.node);
	            if (cellEditable) {
	                return;
	            }
	            event.preventDefault();
	            this.onExpandOrContract();
	        }
	    };
	    GroupCellRenderer.prototype.setupDragOpenParents = function () {
	        var column = this.params.column;
	        var rowNode = this.params.node;
	        if (!this.gridOptionsWrapper.isGroupHideOpenParents()) {
	            this.draggedFromHideOpenParents = false;
	        }
	        else if (!rowNode.hasChildren()) {
	            // if we are here, and we are not a group, then we must of been dragged down,
	            // as otherwise the cell would be blank, and if cell is blank, this method is never called.
	            this.draggedFromHideOpenParents = true;
	        }
	        else {
	            var rowGroupColumn = rowNode.rowGroupColumn;
	            if (rowGroupColumn) {
	                // if the displayGroup column for this col matches the rowGroupColumn we grouped by for this node,
	                // then nothing was dragged down
	                this.draggedFromHideOpenParents = !column.isRowGroupDisplayed(rowGroupColumn.getId());
	            }
	            else {
	                // the only way we can end up here (no column, but a group) is if we are at the root node,
	                // which only happens when 'groupIncludeTotalFooter' is true. here, we are never dragging
	                this.draggedFromHideOpenParents = false;
	            }
	        }
	        if (this.draggedFromHideOpenParents) {
	            var pointer = rowNode.parent;
	            while (true) {
	                if (utils_1._.missing(pointer)) {
	                    break;
	                }
	                if (pointer.rowGroupColumn && column.isRowGroupDisplayed(pointer.rowGroupColumn.getId())) {
	                    this.displayedGroup = pointer;
	                    break;
	                }
	                pointer = pointer.parent;
	            }
	        }
	        // if we didn't find a displayed group, set it to the row node
	        if (utils_1._.missing(this.displayedGroup)) {
	            this.displayedGroup = rowNode;
	        }
	    };
	    GroupCellRenderer.prototype.onExpandClicked = function (mouseEvent) {
	        if (utils_1._.isStopPropagationForAgGrid(mouseEvent)) {
	            return;
	        }
	        // so if we expand a node, it does not also get selected.
	        utils_1._.stopPropagationForAgGrid(mouseEvent);
	        this.onExpandOrContract();
	    };
	    GroupCellRenderer.prototype.onCellDblClicked = function (mouseEvent) {
	        if (utils_1._.isStopPropagationForAgGrid(mouseEvent)) {
	            return;
	        }
	        // we want to avoid acting on double click events on the expand / contract icon,
	        // as that icons already has expand / collapse functionality on it. otherwise if
	        // the icon was double clicked, we would get 'click', 'click', 'dblclick' which
	        // is open->close->open, however double click should be open->close only.
	        var targetIsExpandIcon = utils_1._.isElementInEventPath(this.eExpanded, mouseEvent)
	            || utils_1._.isElementInEventPath(this.eContracted, mouseEvent);
	        if (!targetIsExpandIcon) {
	            this.onExpandOrContract();
	        }
	    };
	    GroupCellRenderer.prototype.onExpandOrContract = function () {
	        // must use the displayedGroup, so if data was dragged down, we expand the parent, not this row
	        var rowNode = this.displayedGroup;
	        rowNode.setExpanded(!rowNode.expanded);
	    };
	    GroupCellRenderer.prototype.isExpandable = function () {
	        var rowNode = this.params.node;
	        var reducedLeafNode = this.columnController.isPivotMode() && rowNode.leafGroup;
	        return this.draggedFromHideOpenParents ||
	            (rowNode.isExpandable() && !rowNode.footer && !reducedLeafNode);
	    };
	    GroupCellRenderer.prototype.showExpandAndContractIcons = function () {
	        var rowNode = this.params.node;
	        if (this.isExpandable()) {
	            // if expandable, show one based on expand state.
	            // if we were dragged down, means our parent is always expanded
	            var expanded = this.draggedFromHideOpenParents ? true : rowNode.expanded;
	            utils_1._.setDisplayed(this.eContracted, !expanded);
	            utils_1._.setDisplayed(this.eExpanded, expanded);
	        }
	        else {
	            // it not expandable, show neither
	            utils_1._.setDisplayed(this.eExpanded, false);
	            utils_1._.setDisplayed(this.eContracted, false);
	        }
	        var displayedGroup = this.displayedGroup;
	        // compensation padding for leaf nodes, so there is blank space instead of the expand icon
	        var pivotModeAndLeafGroup = this.columnController.isPivotMode() && displayedGroup.leafGroup;
	        var notExpandable = !displayedGroup.isExpandable();
	        var addLeafIndentClass = displayedGroup.footer || notExpandable || pivotModeAndLeafGroup;
	        this.addOrRemoveCssClass('ag-row-group', !addLeafIndentClass);
	        this.addOrRemoveCssClass('ag-row-group-leaf-indent', addLeafIndentClass);
	    };
	    GroupCellRenderer.prototype.destroy = function () {
	        _super.prototype.destroy.call(this);
	        if (this.innerCellRenderer && this.innerCellRenderer.destroy) {
	            this.innerCellRenderer.destroy();
	        }
	    };
	    GroupCellRenderer.prototype.refresh = function () {
	        return false;
	    };
	    GroupCellRenderer.TEMPLATE = '<span class="ag-cell-wrapper">' +
	        '<span class="ag-group-expanded" ref="eExpanded"></span>' +
	        '<span class="ag-group-contracted" ref="eContracted"></span>' +
	        '<span class="ag-group-checkbox ag-invisible" ref="eCheckbox"></span>' +
	        '<span class="ag-group-value" ref="eValue"></span>' +
	        '<span class="ag-group-child-count" ref="eChildCount"></span>' +
	        '</span>';
	    __decorate([
	        context_1.Autowired('gridOptionsWrapper'),
	        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
	    ], GroupCellRenderer.prototype, "gridOptionsWrapper", void 0);
	    __decorate([
	        context_1.Autowired('expressionService'),
	        __metadata("design:type", expressionService_1.ExpressionService)
	    ], GroupCellRenderer.prototype, "expressionService", void 0);
	    __decorate([
	        context_1.Autowired('eventService'),
	        __metadata("design:type", eventService_1.EventService)
	    ], GroupCellRenderer.prototype, "eventService", void 0);
	    __decorate([
	        context_1.Autowired('valueFormatterService'),
	        __metadata("design:type", valueFormatterService_1.ValueFormatterService)
	    ], GroupCellRenderer.prototype, "valueFormatterService", void 0);
	    __decorate([
	        context_1.Autowired('columnController'),
	        __metadata("design:type", columnController_1.ColumnController)
	    ], GroupCellRenderer.prototype, "columnController", void 0);
	    __decorate([
	        context_1.Autowired('mouseEventService'),
	        __metadata("design:type", mouseEventService_1.MouseEventService)
	    ], GroupCellRenderer.prototype, "mouseEventService", void 0);
	    __decorate([
	        context_1.Autowired('userComponentFactory'),
	        __metadata("design:type", userComponentFactory_1.UserComponentFactory)
	    ], GroupCellRenderer.prototype, "userComponentFactory", void 0);
	    __decorate([
	        componentAnnotations_1.RefSelector('eExpanded'),
	        __metadata("design:type", HTMLElement)
	    ], GroupCellRenderer.prototype, "eExpanded", void 0);
	    __decorate([
	        componentAnnotations_1.RefSelector('eContracted'),
	        __metadata("design:type", HTMLElement)
	    ], GroupCellRenderer.prototype, "eContracted", void 0);
	    __decorate([
	        componentAnnotations_1.RefSelector('eCheckbox'),
	        __metadata("design:type", HTMLElement)
	    ], GroupCellRenderer.prototype, "eCheckbox", void 0);
	    __decorate([
	        componentAnnotations_1.RefSelector('eValue'),
	        __metadata("design:type", HTMLElement)
	    ], GroupCellRenderer.prototype, "eValue", void 0);
	    __decorate([
	        componentAnnotations_1.RefSelector('eChildCount'),
	        __metadata("design:type", HTMLElement)
	    ], GroupCellRenderer.prototype, "eChildCount", void 0);
	    return GroupCellRenderer;
	}(component_1.Component));
	exports.GroupCellRenderer = GroupCellRenderer;


/***/ }),
/* 2395 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var context_1 = __webpack_require__(2333);
	var gridOptionsWrapper_1 = __webpack_require__(2324);
	var expressionService_1 = __webpack_require__(2347);
	var ValueFormatterService = /** @class */ (function () {
	    function ValueFormatterService() {
	    }
	    ValueFormatterService.prototype.formatValue = function (column, rowNode, $scope, value) {
	        var formatter;
	        var colDef = column.getColDef();
	        // if floating, give preference to the floating formatter
	        if (rowNode && rowNode.rowPinned) {
	            formatter = colDef.pinnedRowValueFormatter ? colDef.pinnedRowValueFormatter : colDef.valueFormatter;
	        }
	        else {
	            formatter = colDef.valueFormatter;
	        }
	        var result = null;
	        if (formatter) {
	            var params = {
	                value: value,
	                node: rowNode,
	                data: rowNode ? rowNode.data : null,
	                colDef: column.getColDef(),
	                column: column,
	                api: this.gridOptionsWrapper.getApi(),
	                columnApi: this.gridOptionsWrapper.getColumnApi(),
	                context: this.gridOptionsWrapper.getContext()
	            };
	            // originally we put the angular 1 scope here, but we don't want the scope
	            // in the params interface, as other frameworks will see the interface, and
	            // angular 1 is not cool any more. so we hack the scope in here (we cannot
	            // include it above, as it's not in the interface, so would cause a compile error).
	            // in the future, when we stop supporting angular 1, we can take this out.
	            params.$scope = $scope;
	            result = this.expressionService.evaluate(formatter, params);
	        }
	        else if (colDef.refData) {
	            return colDef.refData[value] || '';
	        }
	        // if we don't do this, then arrays get displayed as 1,2,3, but we want 1, 2, 3 (ie with spaces)
	        if ((result === null || result === undefined) && Array.isArray(value)) {
	            result = value.join(', ');
	        }
	        return result;
	    };
	    __decorate([
	        context_1.Autowired('gridOptionsWrapper'),
	        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
	    ], ValueFormatterService.prototype, "gridOptionsWrapper", void 0);
	    __decorate([
	        context_1.Autowired('expressionService'),
	        __metadata("design:type", expressionService_1.ExpressionService)
	    ], ValueFormatterService.prototype, "expressionService", void 0);
	    ValueFormatterService = __decorate([
	        context_1.Bean('valueFormatterService')
	    ], ValueFormatterService);
	    return ValueFormatterService;
	}());
	exports.ValueFormatterService = ValueFormatterService;


/***/ }),
/* 2396 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var context_1 = __webpack_require__(2333);
	var context_2 = __webpack_require__(2333);
	var gridOptionsWrapper_1 = __webpack_require__(2324);
	var utils_1 = __webpack_require__(2325);
	var MouseEventService = /** @class */ (function () {
	    function MouseEventService() {
	        this.gridInstanceId = MouseEventService_1.gridInstanceSequence.next();
	    }
	    MouseEventService_1 = MouseEventService;
	    MouseEventService.prototype.init = function () {
	        this.stampDomElementWithGridInstance();
	    };
	    // we put the instance id onto the main DOM element. this is used for events, when grids are inside grids,
	    // so the grid can work out if the even came from this grid or a grid inside this one. see the ctrl+v logic
	    // for where this is used.
	    MouseEventService.prototype.stampDomElementWithGridInstance = function () {
	        this.eGridDiv[MouseEventService_1.GRID_DOM_KEY] = this.gridInstanceId;
	    };
	    MouseEventService.prototype.getRenderedCellForEvent = function (event) {
	        return utils_1._.getCellCompForEvent(this.gridOptionsWrapper, event);
	    };
	    // walks the path of the event, and returns true if this grid is the first one that it finds. if doing
	    // master / detail grids, and a child grid is found, then it returns false. this stops things like copy/paste
	    // getting executed on many grids at the same time.
	    MouseEventService.prototype.isEventFromThisGrid = function (event) {
	        var path = utils_1._.getEventPath(event);
	        for (var i = 0; i < path.length; i++) {
	            var element = path[i];
	            var instanceId = element[MouseEventService_1.GRID_DOM_KEY];
	            if (utils_1._.exists(instanceId)) {
	                var eventFromThisGrid = instanceId === this.gridInstanceId;
	                return eventFromThisGrid;
	            }
	        }
	        return false;
	    };
	    MouseEventService.prototype.getCellPositionForEvent = function (event) {
	        var cellComp = this.getRenderedCellForEvent(event);
	        return cellComp ? cellComp.getCellPosition() : null;
	    };
	    var MouseEventService_1;
	    MouseEventService.gridInstanceSequence = new utils_1.NumberSequence();
	    MouseEventService.GRID_DOM_KEY = '__ag_grid_instance';
	    __decorate([
	        context_2.Autowired('gridOptionsWrapper'),
	        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
	    ], MouseEventService.prototype, "gridOptionsWrapper", void 0);
	    __decorate([
	        context_2.Autowired('eGridDiv'),
	        __metadata("design:type", HTMLElement)
	    ], MouseEventService.prototype, "eGridDiv", void 0);
	    __decorate([
	        context_1.PostConstruct,
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", []),
	        __metadata("design:returntype", void 0)
	    ], MouseEventService.prototype, "init", null);
	    MouseEventService = MouseEventService_1 = __decorate([
	        context_1.Bean('mouseEventService')
	    ], MouseEventService);
	    return MouseEventService;
	}());
	exports.MouseEventService = MouseEventService;


/***/ }),
/* 2397 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var component_1 = __webpack_require__(2353);
	var utils_1 = __webpack_require__(2325);
	var filterManager_1 = __webpack_require__(2378);
	var context_1 = __webpack_require__(2333);
	var ARROW_UP = '\u2191';
	var ARROW_DOWN = '\u2193';
	var AnimateShowChangeCellRenderer = /** @class */ (function (_super) {
	    __extends(AnimateShowChangeCellRenderer, _super);
	    function AnimateShowChangeCellRenderer() {
	        var _this = _super.call(this, AnimateShowChangeCellRenderer.TEMPLATE) || this;
	        _this.refreshCount = 0;
	        return _this;
	    }
	    AnimateShowChangeCellRenderer.prototype.init = function (params) {
	        // this.params = params;
	        this.eValue = this.queryForHtmlElement('.ag-value-change-value');
	        this.eDelta = this.queryForHtmlElement('.ag-value-change-delta');
	        this.refresh(params);
	    };
	    AnimateShowChangeCellRenderer.prototype.showDelta = function (params, delta) {
	        var absDelta = Math.abs(delta);
	        var valueFormatted = params.formatValue(absDelta);
	        var valueToUse = utils_1._.exists(valueFormatted) ? valueFormatted : absDelta;
	        var deltaUp = (delta >= 0);
	        if (deltaUp) {
	            this.eDelta.innerHTML = ARROW_UP + valueToUse;
	        }
	        else {
	            // because negative, use ABS to remove sign
	            this.eDelta.innerHTML = ARROW_DOWN + valueToUse;
	        }
	        // class makes it green (in ag-fresh)
	        utils_1._.addOrRemoveCssClass(this.eDelta, 'ag-value-change-delta-up', deltaUp);
	        // class makes it red (in ag-fresh)
	        utils_1._.addOrRemoveCssClass(this.eDelta, 'ag-value-change-delta-down', !deltaUp);
	    };
	    AnimateShowChangeCellRenderer.prototype.setTimerToRemoveDelta = function () {
	        var _this = this;
	        // the refreshCount makes sure that if the value updates again while
	        // the below timer is waiting, then the below timer will realise it
	        // is not the most recent and will not try to remove the delta value.
	        this.refreshCount++;
	        var refreshCountCopy = this.refreshCount;
	        window.setTimeout(function () {
	            if (refreshCountCopy === _this.refreshCount) {
	                _this.hideDeltaValue();
	            }
	        }, 2000);
	    };
	    AnimateShowChangeCellRenderer.prototype.hideDeltaValue = function () {
	        utils_1._.removeCssClass(this.eValue, 'ag-value-change-value-highlight');
	        utils_1._.clearElement(this.eDelta);
	    };
	    AnimateShowChangeCellRenderer.prototype.refresh = function (params) {
	        var value = params.value;
	        if (value === this.lastValue) {
	            return;
	        }
	        if (utils_1._.exists(params.valueFormatted)) {
	            this.eValue.innerHTML = params.valueFormatted;
	        }
	        else if (utils_1._.exists(params.value)) {
	            this.eValue.innerHTML = value;
	        }
	        else {
	            utils_1._.clearElement(this.eValue);
	        }
	        // we don't show the delta if we are in the middle of a filter. see comment on FilterManager
	        // with regards processingFilterChange
	        if (this.filterManager.isSuppressFlashingCellsBecauseFiltering()) {
	            return;
	        }
	        if (typeof value === 'number' && typeof this.lastValue === 'number') {
	            var delta = value - this.lastValue;
	            this.showDelta(params, delta);
	        }
	        // highlight the current value, but only if it's not new, otherwise it
	        // would get highlighted first time the value is shown
	        if (this.lastValue) {
	            utils_1._.addCssClass(this.eValue, 'ag-value-change-value-highlight');
	        }
	        this.setTimerToRemoveDelta();
	        this.lastValue = value;
	        return true;
	    };
	    AnimateShowChangeCellRenderer.TEMPLATE = '<span>' +
	        '<span class="ag-value-change-delta"></span>' +
	        '<span class="ag-value-change-value"></span>' +
	        '</span>';
	    __decorate([
	        context_1.Autowired('filterManager'),
	        __metadata("design:type", filterManager_1.FilterManager)
	    ], AnimateShowChangeCellRenderer.prototype, "filterManager", void 0);
	    return AnimateShowChangeCellRenderer;
	}(component_1.Component));
	exports.AnimateShowChangeCellRenderer = AnimateShowChangeCellRenderer;


/***/ }),
/* 2398 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var context_1 = __webpack_require__(2333);
	var component_1 = __webpack_require__(2353);
	var gridOptionsWrapper_1 = __webpack_require__(2324);
	var componentAnnotations_1 = __webpack_require__(2384);
	var utils_1 = __webpack_require__(2325);
	var LoadingCellRenderer = /** @class */ (function (_super) {
	    __extends(LoadingCellRenderer, _super);
	    function LoadingCellRenderer() {
	        return _super.call(this, LoadingCellRenderer.TEMPLATE) || this;
	    }
	    LoadingCellRenderer.prototype.init = function (params) {
	        var eLoadingIcon = utils_1._.createIconNoSpan('groupLoading', this.gridOptionsWrapper, null);
	        this.eLoadingIcon.appendChild(eLoadingIcon);
	        var localeTextFunc = this.gridOptionsWrapper.getLocaleTextFunc();
	        this.eLoadingText.innerText = localeTextFunc('loadingOoo', 'Loading');
	    };
	    LoadingCellRenderer.prototype.refresh = function (params) {
	        return false;
	    };
	    LoadingCellRenderer.TEMPLATE = "<div class=\"ag-stub-cell\">\n            <span class=\"ag-loading-icon\" ref=\"eLoadingIcon\"></span>\n            <span class=\"ag-loading-text\" ref=\"eLoadingText\"></span>\n        </div>";
	    __decorate([
	        context_1.Autowired('gridOptionsWrapper'),
	        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
	    ], LoadingCellRenderer.prototype, "gridOptionsWrapper", void 0);
	    __decorate([
	        componentAnnotations_1.RefSelector('eLoadingIcon'),
	        __metadata("design:type", HTMLElement)
	    ], LoadingCellRenderer.prototype, "eLoadingIcon", void 0);
	    __decorate([
	        componentAnnotations_1.RefSelector('eLoadingText'),
	        __metadata("design:type", HTMLElement)
	    ], LoadingCellRenderer.prototype, "eLoadingText", void 0);
	    return LoadingCellRenderer;
	}(component_1.Component));
	exports.LoadingCellRenderer = LoadingCellRenderer;


/***/ }),
/* 2399 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var popupComponent_1 = __webpack_require__(2367);
	var constants_1 = __webpack_require__(2328);
	var context_1 = __webpack_require__(2333);
	var gridOptionsWrapper_1 = __webpack_require__(2324);
	var valueFormatterService_1 = __webpack_require__(2395);
	var utils_1 = __webpack_require__(2325);
	var SelectCellEditor = /** @class */ (function (_super) {
	    __extends(SelectCellEditor, _super);
	    function SelectCellEditor() {
	        var _this = _super.call(this, '<div class="ag-cell-edit-input"><select class="ag-cell-edit-input"/></div>') || this;
	        _this.eSelect = _this.getGui().querySelector('select');
	        return _this;
	    }
	    SelectCellEditor.prototype.init = function (params) {
	        var _this = this;
	        this.focusAfterAttached = params.cellStartedEdit;
	        if (utils_1._.missing(params.values)) {
	            console.warn('ag-Grid: no values found for select cellEditor');
	            return;
	        }
	        params.values.forEach(function (value) {
	            var option = document.createElement('option');
	            option.value = value;
	            var valueFormatted = _this.valueFormatterService.formatValue(params.column, null, null, value);
	            var valueFormattedExits = valueFormatted !== null && valueFormatted !== undefined;
	            option.text = valueFormattedExits ? valueFormatted : value;
	            if (params.value === value) {
	                option.selected = true;
	            }
	            _this.eSelect.appendChild(option);
	        });
	        // we don't want to add this if full row editing, otherwise selecting will stop the
	        // full row editing.
	        if (!this.gridOptionsWrapper.isFullRowEdit()) {
	            this.addDestroyableEventListener(this.eSelect, 'change', function () { return params.stopEditing(); });
	        }
	        this.addDestroyableEventListener(this.eSelect, 'keydown', function (event) {
	            var isNavigationKey = event.keyCode === constants_1.Constants.KEY_UP || event.keyCode === constants_1.Constants.KEY_DOWN;
	            if (isNavigationKey) {
	                event.stopPropagation();
	            }
	        });
	        this.addDestroyableEventListener(this.eSelect, 'mousedown', function (event) {
	            event.stopPropagation();
	        });
	    };
	    SelectCellEditor.prototype.afterGuiAttached = function () {
	        if (this.focusAfterAttached) {
	            this.eSelect.focus();
	        }
	    };
	    SelectCellEditor.prototype.focusIn = function () {
	        this.eSelect.focus();
	    };
	    SelectCellEditor.prototype.getValue = function () {
	        return this.eSelect.value;
	    };
	    SelectCellEditor.prototype.isPopup = function () {
	        return false;
	    };
	    __decorate([
	        context_1.Autowired('gridOptionsWrapper'),
	        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
	    ], SelectCellEditor.prototype, "gridOptionsWrapper", void 0);
	    __decorate([
	        context_1.Autowired('valueFormatterService'),
	        __metadata("design:type", valueFormatterService_1.ValueFormatterService)
	    ], SelectCellEditor.prototype, "valueFormatterService", void 0);
	    return SelectCellEditor;
	}(popupComponent_1.PopupComponent));
	exports.SelectCellEditor = SelectCellEditor;


/***/ }),
/* 2400 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var textCellEditor_1 = __webpack_require__(2382);
	var PopupTextCellEditor = /** @class */ (function (_super) {
	    __extends(PopupTextCellEditor, _super);
	    function PopupTextCellEditor() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    PopupTextCellEditor.prototype.isPopup = function () {
	        return true;
	    };
	    return PopupTextCellEditor;
	}(textCellEditor_1.TextCellEditor));
	exports.PopupTextCellEditor = PopupTextCellEditor;


/***/ }),
/* 2401 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var selectCellEditor_1 = __webpack_require__(2399);
	var PopupSelectCellEditor = /** @class */ (function (_super) {
	    __extends(PopupSelectCellEditor, _super);
	    function PopupSelectCellEditor() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    PopupSelectCellEditor.prototype.isPopup = function () {
	        return true;
	    };
	    return PopupSelectCellEditor;
	}(selectCellEditor_1.SelectCellEditor));
	exports.PopupSelectCellEditor = PopupSelectCellEditor;


/***/ }),
/* 2402 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var popupComponent_1 = __webpack_require__(2367);
	var constants_1 = __webpack_require__(2328);
	var utils_1 = __webpack_require__(2325);
	var LargeTextCellEditor = /** @class */ (function (_super) {
	    __extends(LargeTextCellEditor, _super);
	    function LargeTextCellEditor() {
	        return _super.call(this, LargeTextCellEditor.TEMPLATE) || this;
	    }
	    LargeTextCellEditor.prototype.init = function (params) {
	        this.params = params;
	        this.focusAfterAttached = params.cellStartedEdit;
	        this.textarea = document.createElement("textarea");
	        this.textarea.maxLength = params.maxLength ? params.maxLength : "200";
	        this.textarea.cols = params.cols ? params.cols : "60";
	        this.textarea.rows = params.rows ? params.rows : "10";
	        if (utils_1._.exists(params.value)) {
	            this.textarea.value = params.value.toString();
	        }
	        this.getGui().querySelector('.ag-large-textarea').appendChild(this.textarea);
	        this.addGuiEventListener('keydown', this.onKeyDown.bind(this));
	    };
	    LargeTextCellEditor.prototype.onKeyDown = function (event) {
	        var key = event.which || event.keyCode;
	        if (key == constants_1.Constants.KEY_LEFT ||
	            key == constants_1.Constants.KEY_UP ||
	            key == constants_1.Constants.KEY_RIGHT ||
	            key == constants_1.Constants.KEY_DOWN ||
	            (event.shiftKey && key == constants_1.Constants.KEY_ENTER)) { // shift+enter allows for newlines
	            event.stopPropagation();
	        }
	    };
	    LargeTextCellEditor.prototype.afterGuiAttached = function () {
	        if (this.focusAfterAttached) {
	            this.textarea.focus();
	        }
	    };
	    LargeTextCellEditor.prototype.getValue = function () {
	        return this.params.parseValue(this.textarea.value);
	    };
	    LargeTextCellEditor.TEMPLATE = 
	    // tab index is needed so we can focus, which is needed for keyboard events
	    '<div class="ag-large-text" tabindex="0">' +
	        '<div class="ag-large-textarea"></div>' +
	        '</div>';
	    return LargeTextCellEditor;
	}(popupComponent_1.PopupComponent));
	exports.LargeTextCellEditor = LargeTextCellEditor;


/***/ }),
/* 2403 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var componentAnnotations_1 = __webpack_require__(2384);
	var utils_1 = __webpack_require__(2325);
	var simpleFilter_1 = __webpack_require__(2386);
	var scalerFilter_1 = __webpack_require__(2389);
	var NumberFilter = /** @class */ (function (_super) {
	    __extends(NumberFilter, _super);
	    function NumberFilter() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    NumberFilter.prototype.mapRangeFromModel = function (filterModel) {
	        return {
	            from: filterModel.filter,
	            to: filterModel.filterTo
	        };
	    };
	    NumberFilter.prototype.getDefaultDebounceMs = function () {
	        return 500;
	    };
	    NumberFilter.prototype.resetUiToDefaults = function () {
	        _super.prototype.resetUiToDefaults.call(this);
	        this.eValueFrom1.value = null;
	        this.eValueFrom2.value = null;
	        this.eValueTo1.value = null;
	        this.eValueTo2.value = null;
	    };
	    NumberFilter.prototype.setConditionIntoUi = function (model, position) {
	        var positionOne = position === simpleFilter_1.ConditionPosition.One;
	        var eValueFrom = positionOne ? this.eValueFrom1 : this.eValueFrom2;
	        var eValueTo = positionOne ? this.eValueTo1 : this.eValueTo2;
	        eValueFrom.value = model ? ('' + model.filter) : null;
	        eValueTo.value = model ? ('' + model.filterTo) : null;
	    };
	    NumberFilter.prototype.setValueFromFloatingFilter = function (value) {
	        this.eValueFrom1.value = value;
	        this.eValueFrom2.value = null;
	        this.eValueTo1.value = null;
	        this.eValueTo2.value = null;
	    };
	    NumberFilter.prototype.comparator = function () {
	        return function (left, right) {
	            if (left === right) {
	                return 0;
	            }
	            if (left < right) {
	                return 1;
	            }
	            if (left > right) {
	                return -1;
	            }
	        };
	    };
	    NumberFilter.prototype.setParams = function (params) {
	        _super.prototype.setParams.call(this, params);
	        this.addValueChangedListeners();
	    };
	    NumberFilter.prototype.addValueChangedListeners = function () {
	        var _this = this;
	        var listener = function () { return _this.onUiChanged(); };
	        this.addDestroyableEventListener(this.eValueFrom1, 'input', listener);
	        this.addDestroyableEventListener(this.eValueFrom2, 'input', listener);
	        this.addDestroyableEventListener(this.eValueTo1, 'input', listener);
	        this.addDestroyableEventListener(this.eValueTo2, 'input', listener);
	    };
	    NumberFilter.prototype.afterGuiAttached = function () {
	        this.eValueFrom1.focus();
	    };
	    NumberFilter.prototype.getDefaultFilterOptions = function () {
	        return NumberFilter.DEFAULT_FILTER_OPTIONS;
	    };
	    NumberFilter.prototype.createValueTemplate = function (position) {
	        var positionOne = position === simpleFilter_1.ConditionPosition.One;
	        var pos = positionOne ? '1' : '2';
	        var translate = this.translate.bind(this);
	        return "<div class=\"ag-filter-body\" ref=\"eCondition" + pos + "Body\" role=\"presentation\">\n            <div class=\"ag-input-wrapper\" role=\"presentation\">\n                <input class=\"ag-filter-filter\" ref=\"eValueFrom" + pos + "\" type=\"text\" placeholder=\"" + translate('filterOoo') + "\"/>\n            </div>\n             <div class=\"ag-input-wrapper ag-filter-number-to\" ref=\"ePanel" + pos + "\" role=\"presentation\">\n                <input class=\"ag-filter-filter\" ref=\"eValueTo" + pos + "\" type=\"text\" placeholder=\"" + translate('filterOoo') + "\"/>\n            </div>\n        </div>";
	    };
	    NumberFilter.prototype.isConditionUiComplete = function (position) {
	        var positionOne = position === simpleFilter_1.ConditionPosition.One;
	        var option = positionOne ? this.getCondition1Type() : this.getCondition2Type();
	        var eValue = positionOne ? this.eValueFrom1 : this.eValueFrom2;
	        var eValueTo = positionOne ? this.eValueTo1 : this.eValueTo2;
	        var value = this.stringToFloat(eValue.value);
	        var valueTo = this.stringToFloat(eValueTo.value);
	        if (option === simpleFilter_1.SimpleFilter.EMPTY) {
	            return false;
	        }
	        if (this.doesFilterHaveHiddenInput(option)) {
	            return true;
	        }
	        if (option === simpleFilter_1.SimpleFilter.IN_RANGE) {
	            return value != null && valueTo != null;
	        }
	        else {
	            return value != null;
	        }
	    };
	    NumberFilter.prototype.areSimpleModelsEqual = function (aSimple, bSimple) {
	        return aSimple.filter === bSimple.filter
	            && aSimple.filterTo === bSimple.filterTo
	            && aSimple.type === bSimple.type;
	    };
	    // needed for creating filter model
	    NumberFilter.prototype.getFilterType = function () {
	        return NumberFilter.FILTER_TYPE;
	    };
	    NumberFilter.prototype.stringToFloat = function (value) {
	        var filterText = utils_1._.makeNull(value);
	        if (filterText && filterText.trim() === '') {
	            filterText = null;
	        }
	        var newFilter;
	        if (filterText !== null && filterText !== undefined) {
	            newFilter = parseFloat(filterText);
	        }
	        else {
	            newFilter = null;
	        }
	        return newFilter;
	    };
	    NumberFilter.prototype.createCondition = function (position) {
	        var positionOne = position === simpleFilter_1.ConditionPosition.One;
	        var type = positionOne ? this.getCondition1Type() : this.getCondition2Type();
	        var eValue = positionOne ? this.eValueFrom1 : this.eValueFrom2;
	        var value = this.stringToFloat(eValue.value);
	        var eValueTo = positionOne ? this.eValueTo1 : this.eValueTo2;
	        var valueTo = this.stringToFloat(eValueTo.value);
	        var model = {
	            filterType: NumberFilter.FILTER_TYPE,
	            type: type
	        };
	        if (!this.doesFilterHaveHiddenInput(type)) {
	            model.filter = value;
	            model.filterTo = valueTo; // FIX - should only populate this when filter choice has 'to' option
	        }
	        return model;
	    };
	    NumberFilter.prototype.updateUiVisibility = function () {
	        _super.prototype.updateUiVisibility.call(this);
	        var showFrom1 = this.showValueFrom(this.getCondition1Type());
	        utils_1._.setDisplayed(this.eValueFrom1, showFrom1);
	        var showTo1 = this.showValueTo(this.getCondition1Type());
	        utils_1._.setDisplayed(this.eValueTo1, showTo1);
	        var showFrom2 = this.showValueFrom(this.getCondition2Type());
	        utils_1._.setDisplayed(this.eValueFrom2, showFrom2);
	        var showTo2 = this.showValueTo(this.getCondition2Type());
	        utils_1._.setDisplayed(this.eValueTo2, showTo2);
	    };
	    NumberFilter.FILTER_TYPE = 'number';
	    NumberFilter.DEFAULT_FILTER_OPTIONS = [scalerFilter_1.ScalerFilter.EQUALS, scalerFilter_1.ScalerFilter.NOT_EQUAL,
	        scalerFilter_1.ScalerFilter.LESS_THAN, scalerFilter_1.ScalerFilter.LESS_THAN_OR_EQUAL,
	        scalerFilter_1.ScalerFilter.GREATER_THAN, scalerFilter_1.ScalerFilter.GREATER_THAN_OR_EQUAL,
	        scalerFilter_1.ScalerFilter.IN_RANGE];
	    __decorate([
	        componentAnnotations_1.RefSelector('eValueFrom1'),
	        __metadata("design:type", HTMLInputElement)
	    ], NumberFilter.prototype, "eValueFrom1", void 0);
	    __decorate([
	        componentAnnotations_1.RefSelector('eValueFrom2'),
	        __metadata("design:type", HTMLInputElement)
	    ], NumberFilter.prototype, "eValueFrom2", void 0);
	    __decorate([
	        componentAnnotations_1.RefSelector('eValueTo1'),
	        __metadata("design:type", HTMLInputElement)
	    ], NumberFilter.prototype, "eValueTo1", void 0);
	    __decorate([
	        componentAnnotations_1.RefSelector('eValueTo2'),
	        __metadata("design:type", HTMLInputElement)
	    ], NumberFilter.prototype, "eValueTo2", void 0);
	    return NumberFilter;
	}(scalerFilter_1.ScalerFilter));
	exports.NumberFilter = NumberFilter;


/***/ }),
/* 2404 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var gridOptionsWrapper_1 = __webpack_require__(2324);
	var context_1 = __webpack_require__(2333);
	var component_1 = __webpack_require__(2353);
	var LoadingOverlayComponent = /** @class */ (function (_super) {
	    __extends(LoadingOverlayComponent, _super);
	    function LoadingOverlayComponent() {
	        return _super.call(this) || this;
	    }
	    LoadingOverlayComponent.prototype.init = function (params) {
	        var template = this.gridOptionsWrapper.getOverlayLoadingTemplate() ?
	            this.gridOptionsWrapper.getOverlayLoadingTemplate() : LoadingOverlayComponent.DEFAULT_LOADING_OVERLAY_TEMPLATE;
	        var localeTextFunc = this.gridOptionsWrapper.getLocaleTextFunc();
	        var localisedTemplate = template.replace('[LOADING...]', localeTextFunc('loadingOoo', 'Loading...'));
	        this.setTemplate(localisedTemplate);
	    };
	    LoadingOverlayComponent.DEFAULT_LOADING_OVERLAY_TEMPLATE = '<span class="ag-overlay-loading-center">[LOADING...]</span>';
	    __decorate([
	        context_1.Autowired('gridOptionsWrapper'),
	        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
	    ], LoadingOverlayComponent.prototype, "gridOptionsWrapper", void 0);
	    return LoadingOverlayComponent;
	}(component_1.Component));
	exports.LoadingOverlayComponent = LoadingOverlayComponent;


/***/ }),
/* 2405 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var gridOptionsWrapper_1 = __webpack_require__(2324);
	var context_1 = __webpack_require__(2333);
	var component_1 = __webpack_require__(2353);
	var NoRowsOverlayComponent = /** @class */ (function (_super) {
	    __extends(NoRowsOverlayComponent, _super);
	    function NoRowsOverlayComponent() {
	        return _super.call(this) || this;
	    }
	    NoRowsOverlayComponent.prototype.init = function (params) {
	        var template = this.gridOptionsWrapper.getOverlayNoRowsTemplate() ?
	            this.gridOptionsWrapper.getOverlayNoRowsTemplate() : NoRowsOverlayComponent.DEFAULT_NO_ROWS_TEMPLATE;
	        var localeTextFunc = this.gridOptionsWrapper.getLocaleTextFunc();
	        var localisedTemplate = template.replace('[NO_ROWS_TO_SHOW]', localeTextFunc('noRowsToShow', 'No Rows To Show'));
	        this.setTemplate(localisedTemplate);
	    };
	    NoRowsOverlayComponent.DEFAULT_NO_ROWS_TEMPLATE = '<span class="ag-overlay-no-rows-center">[NO_ROWS_TO_SHOW]</span>';
	    __decorate([
	        context_1.Autowired('gridOptionsWrapper'),
	        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
	    ], NoRowsOverlayComponent.prototype, "gridOptionsWrapper", void 0);
	    return NoRowsOverlayComponent;
	}(component_1.Component));
	exports.NoRowsOverlayComponent = NoRowsOverlayComponent;


/***/ }),
/* 2406 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var popupComponent_1 = __webpack_require__(2367);
	var TooltipComponent = /** @class */ (function (_super) {
	    __extends(TooltipComponent, _super);
	    function TooltipComponent() {
	        return _super.call(this, "<div class=\"ag-tooltip\"></div>") || this;
	    }
	    // will need to type params
	    TooltipComponent.prototype.init = function (params) {
	        var value = params.value;
	        this.getGui().innerHTML = value;
	    };
	    return TooltipComponent;
	}(popupComponent_1.PopupComponent));
	exports.TooltipComponent = TooltipComponent;


/***/ }),
/* 2407 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var component_1 = __webpack_require__(2353);
	var utils_1 = __webpack_require__(2325);
	var DefaultDateComponent = /** @class */ (function (_super) {
	    __extends(DefaultDateComponent, _super);
	    function DefaultDateComponent() {
	        return _super.call(this, "<div class=\"ag-input-wrapper\" role=\"presentation\"><input class=\"ag-filter-filter\" type=\"text\" placeholder=\"yyyy-mm-dd\"></div>") || this;
	    }
	    DefaultDateComponent.prototype.init = function (params) {
	        this.eDateInput = this.getGui().querySelector('input');
	        if (utils_1._.isBrowserChrome() || params.filterParams.browserDatePicker) {
	            if (utils_1._.isBrowserIE()) {
	                console.warn('ag-grid: browserDatePicker is specified to true, but it is not supported in IE 11, reverting to plain text date picker');
	            }
	            else {
	                this.eDateInput.type = 'date';
	            }
	        }
	        this.listener = params.onDateChanged;
	        this.addGuiEventListener('input', this.listener);
	    };
	    DefaultDateComponent.prototype.getDate = function () {
	        return utils_1._.parseYyyyMmDdToDate(this.eDateInput.value, "-");
	    };
	    DefaultDateComponent.prototype.setDate = function (date) {
	        this.eDateInput.value = utils_1._.serializeDateToYyyyMmDd(date, "-");
	    };
	    return DefaultDateComponent;
	}(component_1.Component));
	exports.DefaultDateComponent = DefaultDateComponent;


/***/ }),
/* 2408 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var dateFilter_1 = __webpack_require__(2383);
	var context_1 = __webpack_require__(2333);
	var userComponentFactory_1 = __webpack_require__(2380);
	var utils_1 = __webpack_require__(2325);
	var dateCompWrapper_1 = __webpack_require__(2385);
	var componentAnnotations_1 = __webpack_require__(2384);
	var simpleFilter_1 = __webpack_require__(2386);
	var simpleFloatingFilter_1 = __webpack_require__(2409);
	var providedFilter_1 = __webpack_require__(2388);
	var DateFloatingFilter = /** @class */ (function (_super) {
	    __extends(DateFloatingFilter, _super);
	    function DateFloatingFilter() {
	        return _super.call(this, "<div class=\"ag-input-wrapper\" role=\"presentation\">\n                <input ref=\"eReadOnlyText\" disabled=\"true\" class=\"ag-floating-filter-input\">\n                <div ref=\"eDateWrapper\" style=\"display: flex; flex: 1 1 auto; overflow: hidden;\"></div>\n            </div>") || this;
	    }
	    DateFloatingFilter.prototype.getDefaultFilterOptions = function () {
	        return dateFilter_1.DateFilter.DEFAULT_FILTER_OPTIONS;
	    };
	    DateFloatingFilter.prototype.conditionToString = function (condition) {
	        var isRange = condition.type == simpleFilter_1.SimpleFilter.IN_RANGE;
	        if (isRange) {
	            return condition.dateFrom + "-" + condition.dateTo;
	        }
	        else {
	            // cater for when the type doesn't need a value
	            if (condition.dateFrom != null) {
	                return "" + condition.dateFrom;
	            }
	            else {
	                return "" + condition.type;
	            }
	        }
	    };
	    DateFloatingFilter.prototype.init = function (params) {
	        _super.prototype.init.call(this, params);
	        this.params = params;
	        this.createDateComponent();
	    };
	    DateFloatingFilter.prototype.setEditable = function (editable) {
	        utils_1._.setDisplayed(this.eDateWrapper, editable);
	        utils_1._.setDisplayed(this.eReadOnlyText, !editable);
	    };
	    DateFloatingFilter.prototype.onParentModelChanged = function (model, event) {
	        // we don't want to update the floating filter if the floating filter caused the change.
	        // as if it caused the change, the ui is already in sycn. if we didn't do this, the UI
	        // would behave strange as it would be updating as the user is typing
	        if (this.isEventFromFloatingFilter(event)) {
	            return;
	        }
	        _super.prototype.setLastTypeFromModel.call(this, model);
	        var allowEditing = this.canWeEditAfterModelFromParentFilter(model);
	        this.setEditable(allowEditing);
	        if (allowEditing) {
	            if (model) {
	                var dateModel = model;
	                this.dateComp.setDate(utils_1._.parseYyyyMmDdToDate(dateModel.dateFrom, '-'));
	            }
	            else {
	                this.dateComp.setDate(null);
	            }
	            this.eReadOnlyText.value = '';
	        }
	        else {
	            this.eReadOnlyText.value = this.getTextFromModel(model);
	            this.dateComp.setDate(null);
	        }
	    };
	    DateFloatingFilter.prototype.onDateChanged = function () {
	        var _this = this;
	        var filterValueDate = this.dateComp.getDate();
	        var filterValueText = utils_1._.serializeDateToYyyyMmDd(filterValueDate, "-");
	        this.params.parentFilterInstance(function (filterInstance) {
	            if (filterInstance) {
	                var simpleFilter = filterInstance;
	                simpleFilter.onFloatingFilterChanged(_this.getLastType(), filterValueText);
	            }
	        });
	    };
	    DateFloatingFilter.prototype.createDateComponent = function () {
	        var _this = this;
	        var debounceMs = providedFilter_1.ProvidedFilter.getDebounceMs(this.params.filterParams, this.getDefaultDebounceMs());
	        var toDebounce = utils_1._.debounce(this.onDateChanged.bind(this), debounceMs);
	        var dateComponentParams = {
	            onDateChanged: toDebounce,
	            filterParams: this.params.column.getColDef().filterParams
	        };
	        this.dateComp = new dateCompWrapper_1.DateCompWrapper(this.userComponentFactory, dateComponentParams, this.eDateWrapper);
	        this.addDestroyFunc(function () {
	            _this.dateComp.destroy();
	        });
	    };
	    __decorate([
	        context_1.Autowired('userComponentFactory'),
	        __metadata("design:type", userComponentFactory_1.UserComponentFactory)
	    ], DateFloatingFilter.prototype, "userComponentFactory", void 0);
	    __decorate([
	        componentAnnotations_1.RefSelector('eReadOnlyText'),
	        __metadata("design:type", HTMLInputElement)
	    ], DateFloatingFilter.prototype, "eReadOnlyText", void 0);
	    __decorate([
	        componentAnnotations_1.RefSelector('eDateWrapper'),
	        __metadata("design:type", HTMLInputElement)
	    ], DateFloatingFilter.prototype, "eDateWrapper", void 0);
	    return DateFloatingFilter;
	}(simpleFloatingFilter_1.SimpleFloatingFilter));
	exports.DateFloatingFilter = DateFloatingFilter;


/***/ }),
/* 2409 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var component_1 = __webpack_require__(2353);
	var simpleFilter_1 = __webpack_require__(2386);
	var optionsFactory_1 = __webpack_require__(2387);
	var SimpleFloatingFilter = /** @class */ (function (_super) {
	    __extends(SimpleFloatingFilter, _super);
	    function SimpleFloatingFilter() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    SimpleFloatingFilter.prototype.getDefaultDebounceMs = function () {
	        return 0;
	    };
	    // used by:
	    // 1) NumberFloatingFilter & TextFloatingFilter: Always, for both when editable and read only.
	    // 2) DateFloatingFilter: Only when read only (as we show text rather than a date picker when read only)
	    SimpleFloatingFilter.prototype.getTextFromModel = function (model) {
	        if (!model) {
	            return null;
	        }
	        var isCombined = model.operator;
	        if (isCombined) {
	            var combinedModel = model;
	            var con1Str = this.conditionToString(combinedModel.condition1);
	            var con2Str = this.conditionToString(combinedModel.condition2);
	            return con1Str + " " + combinedModel.operator + " " + con2Str;
	        }
	        else {
	            var condition = model;
	            return this.conditionToString(condition);
	        }
	    };
	    SimpleFloatingFilter.prototype.isEventFromFloatingFilter = function (event) {
	        return (event && event.afterFloatingFilter);
	    };
	    SimpleFloatingFilter.prototype.getLastType = function () {
	        return this.lastType;
	    };
	    SimpleFloatingFilter.prototype.setLastTypeFromModel = function (model) {
	        // if no model provided by the parent filter, we continue to use the last type used
	        if (!model) {
	            return;
	        }
	        var isCombined = model.operator;
	        var condition;
	        if (isCombined) {
	            var combinedModel = model;
	            condition = combinedModel.condition1;
	        }
	        else {
	            condition = model;
	        }
	        this.lastType = condition.type;
	    };
	    SimpleFloatingFilter.prototype.canWeEditAfterModelFromParentFilter = function (model) {
	        if (!model) {
	            // if no model, then we can edit as long as the lastType is something we can edit, as this
	            // is the type we will provide to the parent filter if the user decides to use the floating filter.
	            return this.isTypeEditable(this.lastType);
	        }
	        // never allow editing if the filter is combined (ie has two parts)
	        var isCombined = model.operator;
	        if (isCombined) {
	            return false;
	        }
	        var simpleModel = model;
	        var typeIsEditable = this.isTypeEditable(simpleModel.type);
	        return typeIsEditable;
	    };
	    SimpleFloatingFilter.prototype.init = function (params) {
	        this.optionsFactory = new optionsFactory_1.OptionsFactory();
	        this.optionsFactory.init(params.filterParams, this.getDefaultFilterOptions());
	        this.lastType = this.optionsFactory.getDefaultOption();
	        // we are editable if:
	        // 1) there is a type (user has configured filter wrong if not type)
	        //  AND
	        // 2) the default type is not 'in range'
	        var editable = this.isTypeEditable(this.lastType);
	        this.setEditable(editable);
	    };
	    SimpleFloatingFilter.prototype.doesFilterHaveHiddenInput = function (filterType) {
	        var customFilterOption = this.optionsFactory.getCustomOption(filterType);
	        return customFilterOption && customFilterOption.hideFilterInput;
	    };
	    SimpleFloatingFilter.prototype.isTypeEditable = function (type) {
	        if (this.doesFilterHaveHiddenInput(type)) {
	            return false;
	        }
	        return type
	            && (type != simpleFilter_1.SimpleFilter.IN_RANGE)
	            && (type != simpleFilter_1.SimpleFilter.EMPTY);
	    };
	    return SimpleFloatingFilter;
	}(component_1.Component));
	exports.SimpleFloatingFilter = SimpleFloatingFilter;


/***/ }),
/* 2410 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var componentAnnotations_1 = __webpack_require__(2384);
	var utils_1 = __webpack_require__(2325);
	var simpleFilter_1 = __webpack_require__(2386);
	var TextFilter = /** @class */ (function (_super) {
	    __extends(TextFilter, _super);
	    function TextFilter() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    TextFilter.prototype.getDefaultDebounceMs = function () {
	        return 500;
	    };
	    TextFilter.prototype.getValue = function (element) {
	        var val = element.value;
	        val = utils_1._.makeNull(val);
	        if (val && val.trim() === '') {
	            val = null;
	        }
	        return val;
	    };
	    TextFilter.prototype.addValueChangedListeners = function () {
	        var _this = this;
	        var listener = function () { return _this.onUiChanged(); };
	        this.addDestroyableEventListener(this.eValue1, 'input', listener);
	        this.addDestroyableEventListener(this.eValue2, 'input', listener);
	    };
	    TextFilter.prototype.setParams = function (params) {
	        _super.prototype.setParams.call(this, params);
	        this.textFilterParams = params;
	        this.comparator = this.textFilterParams.textCustomComparator ? this.textFilterParams.textCustomComparator : TextFilter.DEFAULT_COMPARATOR;
	        this.formatter =
	            this.textFilterParams.textFormatter ? this.textFilterParams.textFormatter :
	                this.textFilterParams.caseSensitive == true ? TextFilter.DEFAULT_FORMATTER :
	                    TextFilter.DEFAULT_LOWERCASE_FORMATTER;
	        this.addValueChangedListeners();
	    };
	    TextFilter.prototype.setConditionIntoUi = function (model, position) {
	        var positionOne = position === simpleFilter_1.ConditionPosition.One;
	        var eValue = positionOne ? this.eValue1 : this.eValue2;
	        eValue.value = model ? model.filter : null;
	    };
	    TextFilter.prototype.createCondition = function (position) {
	        var positionOne = position === simpleFilter_1.ConditionPosition.One;
	        var type = positionOne ? this.getCondition1Type() : this.getCondition2Type();
	        var eValue = positionOne ? this.eValue1 : this.eValue2;
	        var value = this.getValue(eValue);
	        var model = {
	            filterType: TextFilter.FILTER_TYPE,
	            type: type
	        };
	        if (!this.doesFilterHaveHiddenInput(type)) {
	            model.filter = value;
	        }
	        return model;
	    };
	    TextFilter.prototype.getFilterType = function () {
	        return TextFilter.FILTER_TYPE;
	    };
	    TextFilter.prototype.areSimpleModelsEqual = function (aSimple, bSimple) {
	        return aSimple.filter === bSimple.filter && aSimple.type === bSimple.type;
	    };
	    TextFilter.prototype.resetUiToDefaults = function () {
	        _super.prototype.resetUiToDefaults.call(this);
	        this.eValue1.value = null;
	        this.eValue2.value = null;
	    };
	    TextFilter.prototype.setValueFromFloatingFilter = function (value) {
	        this.eValue1.value = value;
	        this.eValue2.value = null;
	    };
	    TextFilter.prototype.getDefaultFilterOptions = function () {
	        return TextFilter.DEFAULT_FILTER_OPTIONS;
	    };
	    TextFilter.prototype.createValueTemplate = function (position) {
	        var pos = position === simpleFilter_1.ConditionPosition.One ? '1' : '2';
	        var translate = this.gridOptionsWrapper.getLocaleTextFunc();
	        return "<div class=\"ag-filter-body\" ref=\"eCondition" + pos + "Body\" role=\"presentation\">\n            <div class=\"ag-input-wrapper\" ref=\"eInputWrapper" + pos + "\" role=\"presentation\">\n                <input class=\"ag-filter-filter\" ref=\"eValue" + pos + "\" type=\"text\" placeholder=\"" + translate('filterOoo', 'Filter...') + "\"/>\n            </div>\n        </div>";
	    };
	    TextFilter.prototype.updateUiVisibility = function () {
	        _super.prototype.updateUiVisibility.call(this);
	        var showValue1 = this.showValueFrom(this.getCondition1Type());
	        utils_1._.setDisplayed(this.eInputWrapper1, showValue1);
	        var showValue2 = this.showValueFrom(this.getCondition2Type());
	        utils_1._.setDisplayed(this.eInputWrapper2, showValue2);
	    };
	    TextFilter.prototype.afterGuiAttached = function () {
	        this.eValue1.focus();
	    };
	    TextFilter.prototype.isConditionUiComplete = function (position) {
	        var positionOne = position === simpleFilter_1.ConditionPosition.One;
	        var option = positionOne ? this.getCondition1Type() : this.getCondition2Type();
	        var eFilterValue = positionOne ? this.eValue1 : this.eValue2;
	        if (option === simpleFilter_1.SimpleFilter.EMPTY) {
	            return false;
	        }
	        var value = this.getValue(eFilterValue);
	        if (this.doesFilterHaveHiddenInput(option)) {
	            return true;
	        }
	        return value != null;
	    };
	    TextFilter.prototype.individualConditionPasses = function (params, filterModel) {
	        var filterText = filterModel.filter;
	        var filterOption = filterModel.type;
	        var cellValue = this.textFilterParams.valueGetter(params.node);
	        var cellValueFormatted = this.formatter(cellValue);
	        var customFilterOption = this.optionsFactory.getCustomOption(filterOption);
	        if (customFilterOption) {
	            // only execute the custom filter if a value exists or a value isn't required, i.e. input is hidden
	            if (filterText != null || customFilterOption.hideFilterInput) {
	                return customFilterOption.test(filterText, cellValueFormatted);
	            }
	        }
	        if (cellValue == null) {
	            return filterOption === simpleFilter_1.SimpleFilter.NOT_EQUAL || filterOption === simpleFilter_1.SimpleFilter.NOT_CONTAINS;
	        }
	        var filterTextFormatted = this.formatter(filterText);
	        return this.comparator(filterOption, cellValueFormatted, filterTextFormatted);
	    };
	    TextFilter.FILTER_TYPE = 'text';
	    TextFilter.DEFAULT_FILTER_OPTIONS = [simpleFilter_1.SimpleFilter.CONTAINS, simpleFilter_1.SimpleFilter.NOT_CONTAINS,
	        simpleFilter_1.SimpleFilter.EQUALS, simpleFilter_1.SimpleFilter.NOT_EQUAL,
	        simpleFilter_1.SimpleFilter.STARTS_WITH, simpleFilter_1.SimpleFilter.ENDS_WITH];
	    TextFilter.DEFAULT_FORMATTER = function (from) {
	        return from;
	    };
	    TextFilter.DEFAULT_LOWERCASE_FORMATTER = function (from) {
	        if (from == null) {
	            return null;
	        }
	        return from.toString().toLowerCase();
	    };
	    TextFilter.DEFAULT_COMPARATOR = function (filter, value, filterText) {
	        switch (filter) {
	            case TextFilter.CONTAINS:
	                return value.indexOf(filterText) >= 0;
	            case TextFilter.NOT_CONTAINS:
	                return value.indexOf(filterText) === -1;
	            case TextFilter.EQUALS:
	                return value === filterText;
	            case TextFilter.NOT_EQUAL:
	                return value != filterText;
	            case TextFilter.STARTS_WITH:
	                return value.indexOf(filterText) === 0;
	            case TextFilter.ENDS_WITH:
	                var index = value.lastIndexOf(filterText);
	                return index >= 0 && index === (value.length - filterText.length);
	            default:
	                // should never happen
	                console.warn('invalid filter type ' + filter);
	                return false;
	        }
	    };
	    __decorate([
	        componentAnnotations_1.RefSelector('eValue1'),
	        __metadata("design:type", HTMLInputElement)
	    ], TextFilter.prototype, "eValue1", void 0);
	    __decorate([
	        componentAnnotations_1.RefSelector('eValue2'),
	        __metadata("design:type", HTMLInputElement)
	    ], TextFilter.prototype, "eValue2", void 0);
	    __decorate([
	        componentAnnotations_1.RefSelector('eInputWrapper1'),
	        __metadata("design:type", HTMLElement)
	    ], TextFilter.prototype, "eInputWrapper1", void 0);
	    __decorate([
	        componentAnnotations_1.RefSelector('eInputWrapper2'),
	        __metadata("design:type", HTMLElement)
	    ], TextFilter.prototype, "eInputWrapper2", void 0);
	    return TextFilter;
	}(simpleFilter_1.SimpleFilter));
	exports.TextFilter = TextFilter;


/***/ }),
/* 2411 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var numberFilter_1 = __webpack_require__(2403);
	var simpleFilter_1 = __webpack_require__(2386);
	var textInputFloatingFilter_1 = __webpack_require__(2412);
	var NumberFloatingFilter = /** @class */ (function (_super) {
	    __extends(NumberFloatingFilter, _super);
	    function NumberFloatingFilter() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    NumberFloatingFilter.prototype.getDefaultFilterOptions = function () {
	        return numberFilter_1.NumberFilter.DEFAULT_FILTER_OPTIONS;
	    };
	    NumberFloatingFilter.prototype.conditionToString = function (condition) {
	        var isRange = condition.type == simpleFilter_1.SimpleFilter.IN_RANGE;
	        if (isRange) {
	            return condition.filter + "-" + condition.filterTo;
	        }
	        else {
	            // cater for when the type doesn't need a value
	            if (condition.filter != null) {
	                return "" + condition.filter;
	            }
	            else {
	                return "" + condition.type;
	            }
	        }
	    };
	    return NumberFloatingFilter;
	}(textInputFloatingFilter_1.TextInputFloatingFilter));
	exports.NumberFloatingFilter = NumberFloatingFilter;


/***/ }),
/* 2412 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var componentAnnotations_1 = __webpack_require__(2384);
	var utils_1 = __webpack_require__(2325);
	var constants_1 = __webpack_require__(2328);
	var providedFilter_1 = __webpack_require__(2388);
	var context_1 = __webpack_require__(2333);
	var simpleFloatingFilter_1 = __webpack_require__(2409);
	var TextInputFloatingFilter = /** @class */ (function (_super) {
	    __extends(TextInputFloatingFilter, _super);
	    function TextInputFloatingFilter() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    TextInputFloatingFilter.prototype.postConstruct = function () {
	        this.setTemplate("<div class=\"ag-input-wrapper\" role=\"presentation\">\n                <input ref=\"eFloatingFilterText\" class=\"ag-floating-filter-input\">\n            </div>");
	    };
	    TextInputFloatingFilter.prototype.getDefaultDebounceMs = function () {
	        return 500;
	    };
	    TextInputFloatingFilter.prototype.onParentModelChanged = function (model, event) {
	        // we don't want to update the floating filter if the floating filter caused the change.
	        // as if it caused the change, the ui is already in sycn. if we didn't do this, the UI
	        // would behave strange as it would be updating as the user is typing
	        if (this.isEventFromFloatingFilter(event)) {
	            return;
	        }
	        this.setLastTypeFromModel(model);
	        var modelString = this.getTextFromModel(model);
	        this.eFloatingFilterText.value = modelString;
	        var editable = this.canWeEditAfterModelFromParentFilter(model);
	        this.setEditable(editable);
	    };
	    TextInputFloatingFilter.prototype.init = function (params) {
	        _super.prototype.init.call(this, params);
	        this.params = params;
	        this.applyActive = providedFilter_1.ProvidedFilter.isUseApplyButton(this.params.filterParams);
	        var debounceMs = providedFilter_1.ProvidedFilter.getDebounceMs(this.params.filterParams, this.getDefaultDebounceMs());
	        var toDebounce = utils_1._.debounce(this.syncUpWithParentFilter.bind(this), debounceMs);
	        this.addDestroyableEventListener(this.eFloatingFilterText, 'input', toDebounce);
	        this.addDestroyableEventListener(this.eFloatingFilterText, 'keypress', toDebounce);
	        this.addDestroyableEventListener(this.eFloatingFilterText, 'keydown', toDebounce);
	        var columnDef = params.column.getDefinition();
	        if (columnDef.filterParams && columnDef.filterParams.filterOptions && columnDef.filterParams.filterOptions.length === 1 && columnDef.filterParams.filterOptions[0] === 'inRange') {
	            this.eFloatingFilterText.disabled = true;
	        }
	    };
	    TextInputFloatingFilter.prototype.syncUpWithParentFilter = function (e) {
	        var _this = this;
	        var value = this.eFloatingFilterText.value;
	        var enterKeyPressed = utils_1._.isKeyPressed(e, constants_1.Constants.KEY_ENTER);
	        if (this.applyActive && !enterKeyPressed) {
	            return;
	        }
	        this.params.parentFilterInstance(function (filterInstance) {
	            if (filterInstance) {
	                var simpleFilter = filterInstance;
	                simpleFilter.onFloatingFilterChanged(_this.getLastType(), value);
	            }
	        });
	    };
	    TextInputFloatingFilter.prototype.setEditable = function (editable) {
	        this.eFloatingFilterText.disabled = !editable;
	    };
	    __decorate([
	        componentAnnotations_1.RefSelector('eFloatingFilterText'),
	        __metadata("design:type", HTMLInputElement)
	    ], TextInputFloatingFilter.prototype, "eFloatingFilterText", void 0);
	    __decorate([
	        context_1.PostConstruct,
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", []),
	        __metadata("design:returntype", void 0)
	    ], TextInputFloatingFilter.prototype, "postConstruct", null);
	    return TextInputFloatingFilter;
	}(simpleFloatingFilter_1.SimpleFloatingFilter));
	exports.TextInputFloatingFilter = TextInputFloatingFilter;


/***/ }),
/* 2413 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var textFilter_1 = __webpack_require__(2410);
	var textInputFloatingFilter_1 = __webpack_require__(2412);
	var TextFloatingFilter = /** @class */ (function (_super) {
	    __extends(TextFloatingFilter, _super);
	    function TextFloatingFilter() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    TextFloatingFilter.prototype.conditionToString = function (condition) {
	        // it's not possible to have 'in range' for string, so no need to check for it.
	        // also cater for when the type doesn't need a value
	        if (condition.filter != null) {
	            return "" + condition.filter;
	        }
	        else {
	            return "" + condition.type;
	        }
	    };
	    TextFloatingFilter.prototype.getDefaultFilterOptions = function () {
	        return textFilter_1.TextFilter.DEFAULT_FILTER_OPTIONS;
	    };
	    return TextFloatingFilter;
	}(textInputFloatingFilter_1.TextInputFloatingFilter));
	exports.TextFloatingFilter = TextFloatingFilter;


/***/ }),
/* 2414 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var context_1 = __webpack_require__(2333);
	var componentMetadataProvider_1 = __webpack_require__(2415);
	var utils_1 = __webpack_require__(2325);
	var AgComponentUtils = /** @class */ (function () {
	    function AgComponentUtils() {
	    }
	    AgComponentUtils.prototype.adaptFunction = function (propertyName, hardcodedJsFunction, componentFromFramework, source) {
	        if (hardcodedJsFunction == null) {
	            return {
	                component: null,
	                componentFromFramework: componentFromFramework,
	                source: source,
	                paramsFromSelector: null
	            };
	        }
	        var metadata = this.componentMetadataProvider.retrieve(propertyName);
	        if (metadata && metadata.functionAdapter) {
	            return {
	                componentFromFramework: componentFromFramework,
	                component: metadata.functionAdapter(hardcodedJsFunction),
	                source: source,
	                paramsFromSelector: null
	            };
	        }
	        return null;
	    };
	    AgComponentUtils.prototype.adaptCellRendererFunction = function (callback) {
	        var Adapter = /** @class */ (function () {
	            function Adapter() {
	            }
	            Adapter.prototype.refresh = function (params) {
	                return false;
	            };
	            Adapter.prototype.getGui = function () {
	                var callbackResult = callback(this.params);
	                var type = typeof callbackResult;
	                if (type === 'string' || type === 'number' || type === 'boolean') {
	                    return utils_1._.loadTemplate('<span>' + callbackResult + '</span>');
	                }
	                else {
	                    return callbackResult;
	                }
	            };
	            Adapter.prototype.init = function (params) {
	                this.params = params;
	            };
	            return Adapter;
	        }());
	        return Adapter;
	    };
	    AgComponentUtils.prototype.doesImplementIComponent = function (candidate) {
	        if (!candidate) {
	            return false;
	        }
	        return candidate.prototype && 'getGui' in candidate.prototype;
	    };
	    __decorate([
	        context_1.Autowired("componentMetadataProvider"),
	        __metadata("design:type", componentMetadataProvider_1.ComponentMetadataProvider)
	    ], AgComponentUtils.prototype, "componentMetadataProvider", void 0);
	    AgComponentUtils = __decorate([
	        context_1.Bean("agComponentUtils")
	    ], AgComponentUtils);
	    return AgComponentUtils;
	}());
	exports.AgComponentUtils = AgComponentUtils;


/***/ }),
/* 2415 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var context_1 = __webpack_require__(2333);
	var agComponentUtils_1 = __webpack_require__(2414);
	var ComponentMetadataProvider = /** @class */ (function () {
	    function ComponentMetadataProvider() {
	    }
	    ComponentMetadataProvider.prototype.postConstruct = function () {
	        this.componentMetaData = {
	            dateComponent: {
	                mandatoryMethodList: ['getDate', 'setDate'],
	                optionalMethodList: ['afterGuiAttached']
	            },
	            detailCellRenderer: {
	                mandatoryMethodList: [],
	                optionalMethodList: ['refresh']
	            },
	            headerComponent: {
	                mandatoryMethodList: [],
	                optionalMethodList: []
	            },
	            headerGroupComponent: {
	                mandatoryMethodList: [],
	                optionalMethodList: []
	            },
	            loadingCellRenderer: {
	                mandatoryMethodList: [],
	                optionalMethodList: []
	            },
	            loadingOverlayComponent: {
	                mandatoryMethodList: [],
	                optionalMethodList: []
	            },
	            noRowsOverlayComponent: {
	                mandatoryMethodList: [],
	                optionalMethodList: []
	            },
	            floatingFilterComponent: {
	                mandatoryMethodList: ['onParentModelChanged'],
	                optionalMethodList: ['afterGuiAttached']
	            },
	            floatingFilterWrapperComponent: {
	                mandatoryMethodList: [],
	                optionalMethodList: []
	            },
	            cellRenderer: {
	                mandatoryMethodList: [],
	                optionalMethodList: ['refresh', 'afterGuiAttached'],
	                functionAdapter: this.agComponentUtils.adaptCellRendererFunction.bind(this.agComponentUtils)
	            },
	            cellEditor: {
	                mandatoryMethodList: ['getValue'],
	                optionalMethodList: ['isPopup', 'isCancelBeforeStart', 'isCancelAfterEnd', 'focusIn', 'focusOut', 'afterGuiAttached']
	            },
	            innerRenderer: {
	                mandatoryMethodList: [],
	                optionalMethodList: ['afterGuiAttached'],
	                functionAdapter: this.agComponentUtils.adaptCellRendererFunction.bind(this.agComponentUtils)
	            },
	            fullWidthCellRenderer: {
	                mandatoryMethodList: [],
	                optionalMethodList: ['refresh', 'afterGuiAttached'],
	                functionAdapter: this.agComponentUtils.adaptCellRendererFunction.bind(this.agComponentUtils)
	            },
	            pinnedRowCellRenderer: {
	                mandatoryMethodList: [],
	                optionalMethodList: ['refresh', 'afterGuiAttached'],
	                functionAdapter: this.agComponentUtils.adaptCellRendererFunction.bind(this.agComponentUtils)
	            },
	            groupRowInnerRenderer: {
	                mandatoryMethodList: [],
	                optionalMethodList: ['afterGuiAttached'],
	                functionAdapter: this.agComponentUtils.adaptCellRendererFunction.bind(this.agComponentUtils)
	            },
	            groupRowRenderer: {
	                mandatoryMethodList: [],
	                optionalMethodList: ['afterGuiAttached'],
	                functionAdapter: this.agComponentUtils.adaptCellRendererFunction.bind(this.agComponentUtils)
	            },
	            filter: {
	                mandatoryMethodList: ['isFilterActive', 'doesFilterPass', 'getModel', 'setModel'],
	                optionalMethodList: ['afterGuiAttached', 'onNewRowsLoaded', 'getModelAsString', 'onFloatingFilterChanged']
	            },
	            filterComponent: {
	                mandatoryMethodList: ['isFilterActive', 'doesFilterPass', 'getModel', 'setModel'],
	                optionalMethodList: ['afterGuiAttached', 'onNewRowsLoaded', 'getModelAsString', 'onFloatingFilterChanged']
	            },
	            statusPanel: {
	                mandatoryMethodList: [],
	                optionalMethodList: ['afterGuiAttached'],
	            },
	            toolPanel: {
	                mandatoryMethodList: [],
	                optionalMethodList: ['refresh', 'afterGuiAttached']
	            },
	            tooltipComponent: {
	                mandatoryMethodList: [],
	                optionalMethodList: []
	            }
	        };
	    };
	    ComponentMetadataProvider.prototype.retrieve = function (name) {
	        return this.componentMetaData[name];
	    };
	    __decorate([
	        context_1.Autowired("agComponentUtils"),
	        __metadata("design:type", agComponentUtils_1.AgComponentUtils)
	    ], ComponentMetadataProvider.prototype, "agComponentUtils", void 0);
	    __decorate([
	        context_1.PostConstruct,
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", []),
	        __metadata("design:returntype", void 0)
	    ], ComponentMetadataProvider.prototype, "postConstruct", null);
	    ComponentMetadataProvider = __decorate([
	        context_1.Bean("componentMetadataProvider")
	    ], ComponentMetadataProvider);
	    return ComponentMetadataProvider;
	}());
	exports.ComponentMetadataProvider = ComponentMetadataProvider;


/***/ }),
/* 2416 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var context_1 = __webpack_require__(2333);
	var expressionService_1 = __webpack_require__(2347);
	var StylingService = /** @class */ (function () {
	    function StylingService() {
	    }
	    StylingService.prototype.processAllCellClasses = function (colDef, params, onApplicableClass, onNotApplicableClass) {
	        this.processClassRules(colDef.cellClassRules, params, onApplicableClass, onNotApplicableClass);
	        this.processStaticCellClasses(colDef, params, onApplicableClass);
	    };
	    StylingService.prototype.processClassRules = function (classRules, params, onApplicableClass, onNotApplicableClass) {
	        if (typeof classRules === 'object' && classRules !== null) {
	            var classNames = Object.keys(classRules);
	            for (var i = 0; i < classNames.length; i++) {
	                var className = classNames[i];
	                var rule = classRules[className];
	                var resultOfRule = void 0;
	                if (typeof rule === 'string') {
	                    resultOfRule = this.expressionService.evaluate(rule, params);
	                }
	                else if (typeof rule === 'function') {
	                    resultOfRule = rule(params);
	                }
	                if (resultOfRule) {
	                    onApplicableClass(className);
	                }
	                else if (onNotApplicableClass) {
	                    onNotApplicableClass(className);
	                }
	            }
	        }
	    };
	    StylingService.prototype.processStaticCellClasses = function (colDef, params, onApplicableClass) {
	        var cellClass = colDef.cellClass;
	        if (cellClass) {
	            var classOrClasses = void 0;
	            if (typeof colDef.cellClass === 'function') {
	                var cellClassFunc = colDef.cellClass;
	                classOrClasses = cellClassFunc(params);
	            }
	            else {
	                classOrClasses = colDef.cellClass;
	            }
	            if (typeof classOrClasses === 'string') {
	                onApplicableClass(classOrClasses);
	            }
	            else if (Array.isArray(classOrClasses)) {
	                classOrClasses.forEach(function (cssClassItem) {
	                    onApplicableClass(cssClassItem);
	                });
	            }
	        }
	    };
	    __decorate([
	        context_1.Autowired('expressionService'),
	        __metadata("design:type", expressionService_1.ExpressionService)
	    ], StylingService.prototype, "expressionService", void 0);
	    StylingService = __decorate([
	        context_1.Bean('stylingService')
	    ], StylingService);
	    return StylingService;
	}());
	exports.StylingService = StylingService;


/***/ }),
/* 2417 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var eventService_1 = __webpack_require__(2331);
	var context_1 = __webpack_require__(2333);
	var events_1 = __webpack_require__(2335);
	var beanStub_1 = __webpack_require__(2354);
	var columnApi_1 = __webpack_require__(2346);
	var gridApi_1 = __webpack_require__(2338);
	var ColumnHoverService = /** @class */ (function (_super) {
	    __extends(ColumnHoverService, _super);
	    function ColumnHoverService() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    ColumnHoverService.prototype.setMouseOver = function (columns) {
	        this.selectedColumns = columns;
	        var event = {
	            type: events_1.Events.EVENT_COLUMN_HOVER_CHANGED,
	            api: this.gridApi,
	            columnApi: this.columnApi
	        };
	        this.eventService.dispatchEvent(event);
	    };
	    ColumnHoverService.prototype.clearMouseOver = function () {
	        this.selectedColumns = null;
	        var event = {
	            type: events_1.Events.EVENT_COLUMN_HOVER_CHANGED,
	            api: this.gridApi,
	            columnApi: this.columnApi
	        };
	        this.eventService.dispatchEvent(event);
	    };
	    ColumnHoverService.prototype.isHovered = function (column) {
	        return this.selectedColumns && this.selectedColumns.indexOf(column) >= 0;
	    };
	    __decorate([
	        context_1.Autowired('eventService'),
	        __metadata("design:type", eventService_1.EventService)
	    ], ColumnHoverService.prototype, "eventService", void 0);
	    __decorate([
	        context_1.Autowired('columnApi'),
	        __metadata("design:type", columnApi_1.ColumnApi)
	    ], ColumnHoverService.prototype, "columnApi", void 0);
	    __decorate([
	        context_1.Autowired('gridApi'),
	        __metadata("design:type", gridApi_1.GridApi)
	    ], ColumnHoverService.prototype, "gridApi", void 0);
	    ColumnHoverService = __decorate([
	        context_1.Bean('columnHoverService')
	    ], ColumnHoverService);
	    return ColumnHoverService;
	}(beanStub_1.BeanStub));
	exports.ColumnHoverService = ColumnHoverService;


/***/ }),
/* 2418 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var context_1 = __webpack_require__(2333);
	var gridOptionsWrapper_1 = __webpack_require__(2324);
	var eventKeys_1 = __webpack_require__(2336);
	var eventService_1 = __webpack_require__(2331);
	var AnimationFrameService = /** @class */ (function () {
	    function AnimationFrameService() {
	        // create tasks are to do with row creation. for them we want to execute according to row order, so we use
	        // TaskItem so we know what index the item is for.
	        this.p1Tasks = [];
	        // destroy tasks are to do with row removal. they are done after row creation as the user will need to see new
	        // rows first (as blank is scrolled into view), when we remove the old rows (no longer in view) is not as
	        // important.
	        this.p2Tasks = [];
	        this.ticking = false;
	        // we need to know direction of scroll, to build up rows in the direction of
	        // the scroll. eg if user scrolls down, we extend the rows by building down.
	        this.scrollGoingDown = true;
	        this.lastScrollTop = 0;
	    }
	    AnimationFrameService.prototype.setScrollTop = function (scrollTop) {
	        this.scrollGoingDown = scrollTop > this.lastScrollTop;
	        this.lastScrollTop = scrollTop;
	    };
	    AnimationFrameService.prototype.registerGridComp = function (gridPanel) {
	        this.gridPanel = gridPanel;
	    };
	    AnimationFrameService.prototype.init = function () {
	        this.useAnimationFrame = !this.gridOptionsWrapper.isSuppressAnimationFrame();
	    };
	    // this method is for our ag-Grid sanity only - if animation frames are turned off,
	    // then no place in the code should be looking to add any work to be done in animation
	    // frames. this stops bugs - where some code is asking for a frame to be executed
	    // when it should not.
	    AnimationFrameService.prototype.verifyAnimationFrameOn = function (methodName) {
	        if (this.useAnimationFrame === false) {
	            console.warn("ag-Grid: AnimationFrameService." + methodName + " called but animation frames are off");
	        }
	    };
	    AnimationFrameService.prototype.addP1Task = function (task, index) {
	        this.verifyAnimationFrameOn('addP1Task');
	        var taskItem = { task: task, index: index };
	        this.p1Tasks.push(taskItem);
	        this.schedule();
	    };
	    AnimationFrameService.prototype.addP2Task = function (task) {
	        this.verifyAnimationFrameOn('addP2Task');
	        this.p2Tasks.push(task);
	        this.schedule();
	    };
	    AnimationFrameService.prototype.executeFrame = function (millis) {
	        this.verifyAnimationFrameOn('executeFrame');
	        if (this.scrollGoingDown) {
	            this.p1Tasks.sort(function (a, b) { return b.index - a.index; });
	        }
	        else {
	            this.p1Tasks.sort(function (a, b) { return a.index - b.index; });
	        }
	        var frameStart = new Date().getTime();
	        var duration = (new Date().getTime()) - frameStart;
	        // 16ms is 60 fps
	        var noMaxMillis = millis <= 0;
	        while (noMaxMillis || duration < millis) {
	            var gridPanelUpdated = this.gridPanel.executeFrame();
	            if (!gridPanelUpdated) {
	                if (this.p1Tasks.length > 0) {
	                    var taskItem = this.p1Tasks.pop();
	                    taskItem.task();
	                }
	                else if (this.p2Tasks.length > 0) {
	                    var task = this.p2Tasks.pop();
	                    task();
	                }
	                else {
	                    break;
	                }
	            }
	            duration = (new Date().getTime()) - frameStart;
	        }
	        if (this.p1Tasks.length > 0 || this.p2Tasks.length > 0) {
	            this.requestFrame();
	        }
	        else {
	            this.stopTicking();
	        }
	    };
	    AnimationFrameService.prototype.stopTicking = function () {
	        this.ticking = false;
	        var event = {
	            type: eventKeys_1.Events.EVENT_ANIMATION_QUEUE_EMPTY,
	            columnApi: this.gridOptionsWrapper.getColumnApi(),
	            api: this.gridOptionsWrapper.getApi()
	        };
	        this.eventService.dispatchEvent(event);
	    };
	    AnimationFrameService.prototype.flushAllFrames = function () {
	        if (!this.useAnimationFrame) {
	            return;
	        }
	        this.executeFrame(-1);
	    };
	    AnimationFrameService.prototype.schedule = function () {
	        if (!this.useAnimationFrame) {
	            return;
	        }
	        if (!this.ticking) {
	            this.ticking = true;
	            this.requestFrame();
	        }
	    };
	    AnimationFrameService.prototype.requestFrame = function () {
	        // check for the existence of requestAnimationFrame, and if
	        // it's missing, then we polyfill it with setTimeout()
	        var callback = this.executeFrame.bind(this, 60);
	        if (window.requestAnimationFrame) {
	            window.requestAnimationFrame(callback);
	        }
	        else if (window.webkitRequestAnimationFrame) {
	            window.webkitRequestAnimationFrame(callback);
	        }
	        else {
	            window.setTimeout(callback, 0);
	        }
	    };
	    AnimationFrameService.prototype.isQueueEmpty = function () {
	        return this.ticking;
	    };
	    __decorate([
	        context_1.Autowired('gridOptionsWrapper'),
	        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
	    ], AnimationFrameService.prototype, "gridOptionsWrapper", void 0);
	    __decorate([
	        context_1.Autowired('eventService'),
	        __metadata("design:type", eventService_1.EventService)
	    ], AnimationFrameService.prototype, "eventService", void 0);
	    __decorate([
	        context_1.PostConstruct,
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", []),
	        __metadata("design:returntype", void 0)
	    ], AnimationFrameService.prototype, "init", null);
	    AnimationFrameService = __decorate([
	        context_1.Bean('animationFrameService')
	    ], AnimationFrameService);
	    return AnimationFrameService;
	}());
	exports.AnimationFrameService = AnimationFrameService;


/***/ }),
/* 2419 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var beanStub_1 = __webpack_require__(2354);
	var context_1 = __webpack_require__(2333);
	var eventService_1 = __webpack_require__(2331);
	var eventKeys_1 = __webpack_require__(2336);
	var gridOptionsWrapper_1 = __webpack_require__(2324);
	var utils_1 = __webpack_require__(2325);
	/**
	 * This class solves the 'max height' problem, where the user might want to show more data than
	 * the max div height actually allows.
	 */
	var MaxDivHeightScaler = /** @class */ (function (_super) {
	    __extends(MaxDivHeightScaler, _super);
	    function MaxDivHeightScaler() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        // the scrollY position
	        _this.scrollY = 0;
	        // how tall the body is
	        _this.uiBodyHeight = 0;
	        return _this;
	    }
	    MaxDivHeightScaler.prototype.postConstruct = function () {
	        this.addDestroyableEventListener(this.eventService, eventKeys_1.Events.EVENT_BODY_HEIGHT_CHANGED, this.updateOffset.bind(this));
	        this.scrollBarWidth = this.gridOptionsWrapper.getScrollbarWidth();
	        this.maxDivHeight = utils_1._.getMaxDivHeight();
	    };
	    MaxDivHeightScaler.prototype.registerGridComp = function (gridPanel) {
	        this.gridPanel = gridPanel;
	    };
	    MaxDivHeightScaler.prototype.isScaling = function () {
	        return this.scaling;
	    };
	    MaxDivHeightScaler.prototype.getOffset = function () {
	        return this.offset;
	    };
	    MaxDivHeightScaler.prototype.updateOffset = function () {
	        if (!this.scaling) {
	            return;
	        }
	        var newScrollY = this.gridPanel.getVScrollPosition().top;
	        var newBodyHeight = this.getUiBodyHeight();
	        var atLeastOneChanged = newScrollY !== this.scrollY || newBodyHeight !== this.uiBodyHeight;
	        if (atLeastOneChanged) {
	            this.scrollY = newScrollY;
	            this.uiBodyHeight = newBodyHeight;
	            this.calculateOffset();
	        }
	    };
	    MaxDivHeightScaler.prototype.calculateOffset = function () {
	        this.uiContainerHeight = this.maxDivHeight;
	        this.pixelsToShave = this.modelHeight - this.uiContainerHeight;
	        this.maxScrollY = this.uiContainerHeight - this.uiBodyHeight;
	        var scrollPercent = this.scrollY / this.maxScrollY;
	        this.setOffset(scrollPercent * this.pixelsToShave);
	    };
	    MaxDivHeightScaler.prototype.clearOffset = function () {
	        this.uiContainerHeight = this.modelHeight;
	        this.pixelsToShave = 0;
	        this.setOffset(0);
	    };
	    MaxDivHeightScaler.prototype.setOffset = function (newOffset) {
	        // because we are talking pixels, no point in confusing things with half numbers
	        var newOffsetFloor = typeof newOffset === 'number' ? Math.floor(newOffset) : null;
	        if (this.offset === newOffsetFloor) {
	            return;
	        }
	        this.offset = newOffsetFloor;
	        this.eventService.dispatchEvent({ type: eventKeys_1.Events.EVENT_HEIGHT_SCALE_CHANGED });
	    };
	    MaxDivHeightScaler.prototype.setModelHeight = function (modelHeight) {
	        this.modelHeight = modelHeight;
	        this.scaling = this.maxDivHeight > 0 && modelHeight > this.maxDivHeight;
	        if (this.scaling) {
	            this.calculateOffset();
	        }
	        else {
	            this.clearOffset();
	        }
	    };
	    MaxDivHeightScaler.prototype.getUiContainerHeight = function () {
	        return this.uiContainerHeight;
	    };
	    MaxDivHeightScaler.prototype.getRealPixelPosition = function (modelPixel) {
	        return modelPixel - this.offset;
	    };
	    MaxDivHeightScaler.prototype.getUiBodyHeight = function () {
	        var pos = this.gridPanel.getVScrollPosition();
	        return pos.bottom - pos.top;
	    };
	    MaxDivHeightScaler.prototype.getScrollPositionForPixel = function (rowTop) {
	        if (this.pixelsToShave <= 0) {
	            return rowTop;
	        }
	        var modelMaxScroll = this.modelHeight - this.getUiBodyHeight();
	        var scrollPercent = rowTop / modelMaxScroll;
	        var scrollPixel = this.maxScrollY * scrollPercent;
	        return scrollPixel;
	    };
	    __decorate([
	        context_1.Autowired('eventService'),
	        __metadata("design:type", eventService_1.EventService)
	    ], MaxDivHeightScaler.prototype, "eventService", void 0);
	    __decorate([
	        context_1.Autowired('gridOptionsWrapper'),
	        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
	    ], MaxDivHeightScaler.prototype, "gridOptionsWrapper", void 0);
	    __decorate([
	        context_1.PostConstruct,
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", []),
	        __metadata("design:returntype", void 0)
	    ], MaxDivHeightScaler.prototype, "postConstruct", null);
	    MaxDivHeightScaler = __decorate([
	        context_1.Bean('maxDivHeightScaler')
	    ], MaxDivHeightScaler);
	    return MaxDivHeightScaler;
	}(beanStub_1.BeanStub));
	exports.MaxDivHeightScaler = MaxDivHeightScaler;


/***/ }),
/* 2420 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var context_1 = __webpack_require__(2333);
	var popupService_1 = __webpack_require__(2379);
	var userComponentFactory_1 = __webpack_require__(2380);
	var gridOptionsWrapper_1 = __webpack_require__(2324);
	var columnApi_1 = __webpack_require__(2346);
	var gridApi_1 = __webpack_require__(2338);
	var utils_1 = __webpack_require__(2325);
	var TooltipManager = /** @class */ (function () {
	    function TooltipManager() {
	        this.DEFAULT_HIDE_TOOLTIP_TIMEOUT = 10000;
	        this.MOUSEOUT_HIDE_TOOLTIP_TIMEOUT = 1000;
	        this.MOUSEOVER_SHOW_TOOLTIP_TIMEOUT = 2000;
	        this.HIDE_SHOW_ONLY = true;
	        this.showTimeoutId = 0;
	        this.hideTimeoutId = 0;
	        // map of compId to [tooltip component, close function]
	        this.registeredComponents = {};
	    }
	    TooltipManager.prototype.registerTooltip = function (targetCmp) {
	        var _this = this;
	        var el = targetCmp.getGui();
	        var id = targetCmp.getCompId();
	        this.registeredComponents[id] = {
	            tooltipComp: undefined,
	            destroyFunc: undefined,
	            eventDestroyFuncs: [
	                targetCmp.addDestroyableEventListener(el, 'mouseover', function (e) { return _this.processMouseOver(e, targetCmp); }),
	                targetCmp.addDestroyableEventListener(el, 'mousemove', function (e) { return _this.processMouseMove(e); }),
	                targetCmp.addDestroyableEventListener(el, 'mousedown', this.hideTooltip.bind(this)),
	                targetCmp.addDestroyableEventListener(el, 'mouseout', this.processMouseOut.bind(this))
	            ]
	        };
	        targetCmp.addDestroyFunc(function () { return _this.unregisterTooltip(targetCmp); });
	    };
	    TooltipManager.prototype.unregisterTooltip = function (targetCmp) {
	        var id = targetCmp.getCompId();
	        var registeredComponent = this.registeredComponents[id];
	        // hide the tooltip if it's being displayed while unregistering the component
	        if (this.activeComponent === targetCmp) {
	            this.hideTooltip();
	        }
	        if (targetCmp.isAlive() && registeredComponent && registeredComponent.eventDestroyFuncs.length) {
	            registeredComponent.eventDestroyFuncs.forEach(function (func) { return func(); });
	        }
	        delete this.registeredComponents[id];
	    };
	    TooltipManager.prototype.processMouseOver = function (e, targetCmp) {
	        var delay = this.MOUSEOVER_SHOW_TOOLTIP_TIMEOUT;
	        if (this.activeComponent) {
	            // lastHoveredComponent will be the activeComponent when we are hovering
	            // a component with many child elements like the grid header
	            if (this.lastHoveredComponent === this.activeComponent) {
	                return;
	            }
	            delay = 200;
	        }
	        else if (this.showTimeoutId && this.lastHoveredComponent === targetCmp) {
	            return;
	        }
	        this.clearTimers(this.HIDE_SHOW_ONLY);
	        // lastHoveredComponent will be the targetCmp when a click hid the tooltip
	        // and the lastHoveredComponent has many child elements
	        if (this.lastHoveredComponent === targetCmp) {
	            return;
	        }
	        this.lastHoveredComponent = targetCmp;
	        this.lastMouseEvent = e;
	        this.showTimeoutId = window.setTimeout(this.showTooltip.bind(this), delay, e);
	    };
	    TooltipManager.prototype.processMouseOut = function (e) {
	        var activeComponent = this.activeComponent;
	        var relatedTarget = e.relatedTarget;
	        if (!activeComponent) {
	            if (this.lastHoveredComponent) {
	                var containsElement = this.lastHoveredComponent.getGui().contains(relatedTarget);
	                if (this.showTimeoutId && containsElement) {
	                    // if we are hovering within a component with multiple child elements before
	                    // the tooltip has been displayed, we should cancel this event
	                    return;
	                }
	                else if (!containsElement) {
	                    // when a click hides the tooltip we need to reset the lastHoveredComponent
	                    // otherwise the tooltip won't appear until another registered component is hovered.
	                    this.lastHoveredComponent = undefined;
	                }
	            }
	            this.clearTimers();
	            return;
	        }
	        // the mouseout was called from within the activeComponent so we do nothing
	        if (activeComponent.getGui().contains(relatedTarget)) {
	            return;
	        }
	        var registeredComponent = this.registeredComponents[activeComponent.getCompId()];
	        utils_1._.addCssClass(registeredComponent.tooltipComp.getGui(), 'ag-tooltip-hiding');
	        this.lastHoveredComponent = undefined;
	        this.clearTimers();
	        this.hideTimeoutId = window.setTimeout(this.hideTooltip.bind(this), this.MOUSEOUT_HIDE_TOOLTIP_TIMEOUT);
	    };
	    TooltipManager.prototype.processMouseMove = function (e) {
	        // there is a delay from the time we mouseOver a component and the time the
	        // tooltip is displayed, so we need to track mousemove to be able to correctly
	        // position the tooltip when showTooltip is called.
	        this.lastMouseEvent = e;
	    };
	    TooltipManager.prototype.showTooltip = function (e) {
	        var targetCmp = this.lastHoveredComponent;
	        var cellComp = targetCmp;
	        var registeredComponent = this.registeredComponents[targetCmp.getCompId()];
	        this.hideTooltip();
	        var params = {
	            api: this.gridApi,
	            columnApi: this.columnApi,
	            colDef: targetCmp.getComponentHolder(),
	            column: cellComp.getColumn && cellComp.getColumn(),
	            context: this.gridOptionsWrapper.getContext(),
	            rowIndex: cellComp.getCellPosition && cellComp.getCellPosition().rowIndex,
	            value: targetCmp.getTooltipText()
	        };
	        this.createTooltipComponent(params, registeredComponent, e);
	    };
	    TooltipManager.prototype.createTooltipComponent = function (params, cmp, e) {
	        var _this = this;
	        this.userComponentFactory.newTooltipComponent(params).then(function (tooltipComp) {
	            // if the component was unregistered while creating
	            // the tooltip (async) we should return undefined here.
	            if (!cmp) {
	                return;
	            }
	            cmp.tooltipComp = tooltipComp;
	            var eGui = tooltipComp.getGui();
	            if (!utils_1._.containsClass(eGui, 'ag-tooltip')) {
	                utils_1._.addCssClass(eGui, 'ag-tooltip-custom');
	            }
	            var closeFnc = _this.popupService.addPopup(false, eGui, false);
	            cmp.destroyFunc = function () {
	                closeFnc();
	                if (tooltipComp.destroy) {
	                    tooltipComp.destroy();
	                }
	            };
	            _this.popupService.positionPopupUnderMouseEvent({
	                type: 'tooltip',
	                mouseEvent: _this.lastMouseEvent,
	                ePopup: eGui,
	                nudgeY: 18
	            });
	            _this.activeComponent = _this.lastHoveredComponent;
	            _this.hideTimeoutId = window.setTimeout(_this.hideTooltip.bind(_this), _this.DEFAULT_HIDE_TOOLTIP_TIMEOUT);
	        });
	    };
	    TooltipManager.prototype.hideTooltip = function () {
	        var activeComponent = this.activeComponent;
	        this.clearTimers();
	        if (!activeComponent) {
	            return;
	        }
	        var id = activeComponent.getCompId();
	        var registeredComponent = this.registeredComponents[id];
	        this.activeComponent = undefined;
	        if (!registeredComponent) {
	            return;
	        }
	        if (registeredComponent.destroyFunc) {
	            registeredComponent.destroyFunc();
	        }
	        this.clearRegisteredComponent(registeredComponent);
	    };
	    TooltipManager.prototype.clearRegisteredComponent = function (registeredComponent) {
	        delete registeredComponent.destroyFunc;
	        delete registeredComponent.tooltipComp;
	    };
	    TooltipManager.prototype.clearTimers = function (showOnly) {
	        if (showOnly === void 0) { showOnly = false; }
	        if (this.hideTimeoutId && !showOnly) {
	            window.clearTimeout(this.hideTimeoutId);
	            this.hideTimeoutId = 0;
	        }
	        if (this.showTimeoutId) {
	            window.clearTimeout(this.showTimeoutId);
	            this.showTimeoutId = 0;
	        }
	    };
	    __decorate([
	        context_1.Autowired('popupService'),
	        __metadata("design:type", popupService_1.PopupService)
	    ], TooltipManager.prototype, "popupService", void 0);
	    __decorate([
	        context_1.Autowired('userComponentFactory'),
	        __metadata("design:type", userComponentFactory_1.UserComponentFactory)
	    ], TooltipManager.prototype, "userComponentFactory", void 0);
	    __decorate([
	        context_1.Autowired('columnApi'),
	        __metadata("design:type", columnApi_1.ColumnApi)
	    ], TooltipManager.prototype, "columnApi", void 0);
	    __decorate([
	        context_1.Autowired('gridApi'),
	        __metadata("design:type", gridApi_1.GridApi)
	    ], TooltipManager.prototype, "gridApi", void 0);
	    __decorate([
	        context_1.Autowired('gridOptionsWrapper'),
	        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
	    ], TooltipManager.prototype, "gridOptionsWrapper", void 0);
	    TooltipManager = __decorate([
	        context_1.Bean('tooltipManager')
	    ], TooltipManager);
	    return TooltipManager;
	}());
	exports.TooltipManager = TooltipManager;


/***/ }),
/* 2421 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var column_1 = __webpack_require__(2343);
	var context_1 = __webpack_require__(2333);
	var gridOptionsWrapper_1 = __webpack_require__(2324);
	/**
	 * For Master Detail, it is required to keep components between expanding & collapsing parents.
	 * For example a user expands row A (and shows a detail grid for this row), then when row A
	 * is closed, we want to keep the detail grid, so next time row A is expanded the detail grid
	 * is showed with it's context intact, eg if user sorted in the detail grid, that sort should
	 * still be applied after the detail grid is shown for the second time.
	 */
	var DetailRowCompCache = /** @class */ (function () {
	    function DetailRowCompCache() {
	        this.cacheItems = [];
	    }
	    DetailRowCompCache.prototype.postConstruct = function () {
	        this.active = this.gridOptionsWrapper.isKeepDetailRows();
	        this.maxCacheSize = this.gridOptionsWrapper.getKeepDetailRowsCount();
	    };
	    DetailRowCompCache.prototype.addOrDestroy = function (rowNode, pinned, comp) {
	        // only accept detail rows
	        var doNotUseCache = !this.active || !rowNode.detail;
	        if (doNotUseCache) {
	            this.destroyFullWidthRow(comp);
	            return;
	        }
	        var item = this.getCacheItem(rowNode, true);
	        // put the comp in the right location of the item.
	        // we also destroy any previous comp - this should never happen
	        // as the logic outside of this class shouldn't be adding same item to the
	        // cache twice, however we cater for it in case in future releases code
	        // outside of this class is changed and this could happen.
	        switch (pinned) {
	            case column_1.Column.PINNED_LEFT:
	                this.destroyFullWidthRow(item.left);
	                item.left = comp;
	                break;
	            case column_1.Column.PINNED_RIGHT:
	                this.destroyFullWidthRow(item.right);
	                item.right = comp;
	                break;
	            default:
	                this.destroyFullWidthRow(item.center);
	                item.center = comp;
	                break;
	        }
	        this.cacheItems.sort(function (a, b) {
	            return b.lastAccessedTime - a.lastAccessedTime;
	        });
	        this.purgeCache(this.maxCacheSize);
	    };
	    DetailRowCompCache.prototype.getCacheItem = function (rowNode, autoCreate) {
	        if (autoCreate === void 0) { autoCreate = false; }
	        var res;
	        for (var i = 0; i < this.cacheItems.length; i++) {
	            var item = this.cacheItems[i];
	            if (item.rowNode === rowNode) {
	                res = item;
	                break;
	            }
	        }
	        if (!res && autoCreate) {
	            res = {
	                rowNode: rowNode
	            };
	            this.cacheItems.push(res);
	        }
	        if (res) {
	            this.stampCacheItem(res);
	        }
	        return res;
	    };
	    DetailRowCompCache.prototype.stampCacheItem = function (item) {
	        item.lastAccessedTime = new Date().getTime();
	    };
	    DetailRowCompCache.prototype.destroyFullWidthRow = function (comp) {
	        if (comp && comp.destroy) {
	            comp.destroy();
	        }
	    };
	    DetailRowCompCache.prototype.purgeCache = function (startIndex) {
	        // delete all rows past the index of interest
	        for (var i = startIndex; i < this.cacheItems.length; i++) {
	            var item = this.cacheItems[i];
	            this.destroyFullWidthRow(item.center);
	            this.destroyFullWidthRow(item.left);
	            this.destroyFullWidthRow(item.right);
	        }
	        // change the length of the array so it no longer contains the deleted items
	        if (this.cacheItems.length > startIndex) {
	            this.cacheItems.length = startIndex;
	        }
	    };
	    DetailRowCompCache.prototype.get = function (rowNode, pinned) {
	        if (!rowNode.detail) {
	            return undefined;
	        }
	        var item = this.getCacheItem(rowNode);
	        var res;
	        if (item) {
	            switch (pinned) {
	                case column_1.Column.PINNED_LEFT:
	                    if (item.left) {
	                        res = item.left;
	                        item.left = undefined;
	                    }
	                    break;
	                case column_1.Column.PINNED_RIGHT:
	                    if (item.right) {
	                        res = item.right;
	                        item.right = undefined;
	                    }
	                    break;
	                default:
	                    if (item.center) {
	                        res = item.center;
	                        item.center = undefined;
	                    }
	                    break;
	            }
	        }
	        return res;
	    };
	    DetailRowCompCache.prototype.destroy = function () {
	        this.purgeCache(0);
	    };
	    __decorate([
	        context_1.Autowired('gridOptionsWrapper'),
	        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
	    ], DetailRowCompCache.prototype, "gridOptionsWrapper", void 0);
	    __decorate([
	        context_1.PostConstruct,
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", []),
	        __metadata("design:returntype", void 0)
	    ], DetailRowCompCache.prototype, "postConstruct", null);
	    __decorate([
	        context_1.PreDestroy,
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", []),
	        __metadata("design:returntype", void 0)
	    ], DetailRowCompCache.prototype, "destroy", null);
	    DetailRowCompCache = __decorate([
	        context_1.Bean('detailRowCompCache')
	    ], DetailRowCompCache);
	    return DetailRowCompCache;
	}());
	exports.DetailRowCompCache = DetailRowCompCache;


/***/ }),
/* 2422 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var context_1 = __webpack_require__(2333);
	var CellPositionUtils = /** @class */ (function () {
	    function CellPositionUtils() {
	    }
	    CellPositionUtils.prototype.createId = function (cellPosition) {
	        var rowIndex = cellPosition.rowIndex, rowPinned = cellPosition.rowPinned, column = cellPosition.column;
	        return rowIndex + "." + (rowPinned == null ? 'null' : rowPinned) + "." + column.getId();
	    };
	    CellPositionUtils.prototype.equals = function (cellA, cellB) {
	        var colsMatch = cellA.column === cellB.column;
	        var floatingMatch = cellA.rowPinned === cellB.rowPinned;
	        var indexMatch = cellA.rowIndex === cellB.rowIndex;
	        return colsMatch && floatingMatch && indexMatch;
	    };
	    CellPositionUtils = __decorate([
	        context_1.Bean('cellPositionUtils')
	    ], CellPositionUtils);
	    return CellPositionUtils;
	}());
	exports.CellPositionUtils = CellPositionUtils;


/***/ }),
/* 2423 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var constants_1 = __webpack_require__(2328);
	var context_1 = __webpack_require__(2333);
	var pinnedRowModel_1 = __webpack_require__(2371);
	var utils_1 = __webpack_require__(2325);
	var RowPositionUtils = /** @class */ (function () {
	    function RowPositionUtils() {
	    }
	    RowPositionUtils.prototype.getRowNode = function (gridRow) {
	        switch (gridRow.rowPinned) {
	            case constants_1.Constants.PINNED_TOP:
	                return this.pinnedRowModel.getPinnedTopRowData()[gridRow.rowIndex];
	            case constants_1.Constants.PINNED_BOTTOM:
	                return this.pinnedRowModel.getPinnedBottomRowData()[gridRow.rowIndex];
	            default:
	                return this.rowModel.getRow(gridRow.rowIndex);
	        }
	    };
	    RowPositionUtils.prototype.sameRow = function (rowA, rowB) {
	        // if both missing
	        if (!rowA && !rowB) {
	            return true;
	        }
	        // if only one missing
	        if ((rowA && !rowB) || (!rowA && rowB)) {
	            return false;
	        }
	        // otherwise compare (use == to compare rowPinned because it can be null or undefined)
	        return rowA.rowIndex === rowB.rowIndex && rowA.rowPinned == rowB.rowPinned;
	    };
	    // tests if this row selection is before the other row selection
	    RowPositionUtils.prototype.before = function (rowA, rowB) {
	        switch (rowA.rowPinned) {
	            case constants_1.Constants.PINNED_TOP:
	                // we we are floating top, and other isn't, then we are always before
	                if (rowB.rowPinned !== constants_1.Constants.PINNED_TOP) {
	                    return true;
	                }
	                break;
	            case constants_1.Constants.PINNED_BOTTOM:
	                // if we are floating bottom, and the other isn't, then we are never before
	                if (rowB.rowPinned !== constants_1.Constants.PINNED_BOTTOM) {
	                    return false;
	                }
	                break;
	            default:
	                // if we are not floating, but the other one is floating...
	                if (utils_1._.exists(rowB.rowPinned)) {
	                    return rowB.rowPinned !== constants_1.Constants.PINNED_TOP;
	                }
	                break;
	        }
	        return rowA.rowIndex < rowB.rowIndex;
	    };
	    __decorate([
	        context_1.Autowired('rowModel'),
	        __metadata("design:type", Object)
	    ], RowPositionUtils.prototype, "rowModel", void 0);
	    __decorate([
	        context_1.Autowired('pinnedRowModel'),
	        __metadata("design:type", pinnedRowModel_1.PinnedRowModel)
	    ], RowPositionUtils.prototype, "pinnedRowModel", void 0);
	    RowPositionUtils = __decorate([
	        context_1.Bean('rowPositionUtils')
	    ], RowPositionUtils);
	    return RowPositionUtils;
	}());
	exports.RowPositionUtils = RowPositionUtils;


/***/ }),
/* 2424 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var component_1 = __webpack_require__(2353);
	var context_1 = __webpack_require__(2333);
	var column_1 = __webpack_require__(2343);
	var dragAndDropService_1 = __webpack_require__(2363);
	var columnApi_1 = __webpack_require__(2346);
	var columnController_1 = __webpack_require__(2341);
	var horizontalResizeService_1 = __webpack_require__(2425);
	var gridOptionsWrapper_1 = __webpack_require__(2324);
	var cssClassApplier_1 = __webpack_require__(2426);
	var setLeftFeature_1 = __webpack_require__(2427);
	var gridApi_1 = __webpack_require__(2338);
	var sortController_1 = __webpack_require__(2391);
	var eventService_1 = __webpack_require__(2331);
	var userComponentFactory_1 = __webpack_require__(2380);
	var agCheckbox_1 = __webpack_require__(2428);
	var componentAnnotations_1 = __webpack_require__(2384);
	var selectAllFeature_1 = __webpack_require__(2432);
	var events_1 = __webpack_require__(2335);
	var columnHoverService_1 = __webpack_require__(2417);
	var beans_1 = __webpack_require__(2373);
	var hoverFeature_1 = __webpack_require__(2433);
	var touchListener_1 = __webpack_require__(2392);
	var utils_1 = __webpack_require__(2325);
	var HeaderWrapperComp = /** @class */ (function (_super) {
	    __extends(HeaderWrapperComp, _super);
	    function HeaderWrapperComp(column, dragSourceDropTarget, pinned) {
	        var _this = _super.call(this, HeaderWrapperComp.TEMPLATE) || this;
	        _this.column = column;
	        _this.dragSourceDropTarget = dragSourceDropTarget;
	        _this.pinned = pinned;
	        return _this;
	    }
	    HeaderWrapperComp.prototype.getColumn = function () {
	        return this.column;
	    };
	    HeaderWrapperComp.prototype.getComponentHolder = function () {
	        return this.column.getColDef();
	    };
	    HeaderWrapperComp.prototype.init = function () {
	        var colDef = this.getComponentHolder();
	        var displayName = this.columnController.getDisplayNameForColumn(this.column, 'header', true);
	        var enableSorting = colDef.sortable;
	        var enableMenu = this.menuFactory.isMenuEnabled(this.column) && !colDef.suppressMenu;
	        this.appendHeaderComp(displayName, enableSorting, enableMenu);
	        this.setupWidth();
	        this.setupMovingCss();
	        this.setupTooltip();
	        this.setupResize();
	        this.setupMenuClass();
	        this.setupSortableClass(enableSorting);
	        this.addColumnHoverListener();
	        this.addFeature(this.getContext(), new hoverFeature_1.HoverFeature([this.column], this.getGui()));
	        this.addDestroyableEventListener(this.column, column_1.Column.EVENT_FILTER_ACTIVE_CHANGED, this.onFilterChanged.bind(this));
	        this.onFilterChanged();
	        this.addFeature(this.getContext(), new selectAllFeature_1.SelectAllFeature(this.cbSelectAll, this.column));
	        var setLeftFeature = new setLeftFeature_1.SetLeftFeature(this.column, this.getGui(), this.beans);
	        setLeftFeature.init();
	        this.addDestroyFunc(setLeftFeature.destroy.bind(setLeftFeature));
	        this.addAttributes();
	        cssClassApplier_1.CssClassApplier.addHeaderClassesFromColDef(colDef, this.getGui(), this.gridOptionsWrapper, this.column, null);
	    };
	    HeaderWrapperComp.prototype.addColumnHoverListener = function () {
	        this.addDestroyableEventListener(this.eventService, events_1.Events.EVENT_COLUMN_HOVER_CHANGED, this.onColumnHover.bind(this));
	        this.onColumnHover();
	    };
	    HeaderWrapperComp.prototype.onColumnHover = function () {
	        var isHovered = this.columnHoverService.isHovered(this.column);
	        utils_1._.addOrRemoveCssClass(this.getGui(), 'ag-column-hover', isHovered);
	    };
	    HeaderWrapperComp.prototype.setupSortableClass = function (enableSorting) {
	        if (enableSorting) {
	            var element = this.getGui();
	            utils_1._.addCssClass(element, 'ag-header-cell-sortable');
	        }
	    };
	    HeaderWrapperComp.prototype.onFilterChanged = function () {
	        var filterPresent = this.column.isFilterActive();
	        utils_1._.addOrRemoveCssClass(this.getGui(), 'ag-header-cell-filtered', filterPresent);
	    };
	    HeaderWrapperComp.prototype.appendHeaderComp = function (displayName, enableSorting, enableMenu) {
	        var _this = this;
	        var params = {
	            column: this.column,
	            displayName: displayName,
	            enableSorting: enableSorting,
	            enableMenu: enableMenu,
	            showColumnMenu: function (source) {
	                _this.gridApi.showColumnMenuAfterButtonClick(_this.column, source);
	            },
	            progressSort: function (multiSort) {
	                _this.sortController.progressSort(_this.column, !!multiSort, "uiColumnSorted");
	            },
	            setSort: function (sort, multiSort) {
	                _this.sortController.setSortForColumn(_this.column, sort, !!multiSort, "uiColumnSorted");
	            },
	            api: this.gridApi,
	            columnApi: this.columnApi,
	            context: this.gridOptionsWrapper.getContext()
	        };
	        var callback = this.afterHeaderCompCreated.bind(this, displayName);
	        this.userComponentFactory.newHeaderComponent(params).then(callback);
	    };
	    HeaderWrapperComp.prototype.afterHeaderCompCreated = function (displayName, headerComp) {
	        this.appendChild(headerComp);
	        this.setupMove(headerComp.getGui(), displayName);
	    };
	    HeaderWrapperComp.prototype.onColumnMovingChanged = function () {
	        // this function adds or removes the moving css, based on if the col is moving.
	        // this is what makes the header go dark when it is been moved (gives impression to
	        // user that the column was picked up).
	        if (this.column.isMoving()) {
	            utils_1._.addCssClass(this.getGui(), 'ag-header-cell-moving');
	        }
	        else {
	            utils_1._.removeCssClass(this.getGui(), 'ag-header-cell-moving');
	        }
	    };
	    HeaderWrapperComp.prototype.setupMove = function (eHeaderCellLabel, displayName) {
	        var _this = this;
	        var suppressMove = this.gridOptionsWrapper.isSuppressMovableColumns()
	            || this.getComponentHolder().suppressMovable
	            || this.column.getColDef().lockPosition;
	        if (suppressMove) {
	            return;
	        }
	        if (eHeaderCellLabel) {
	            var dragSource_1 = {
	                type: dragAndDropService_1.DragSourceType.HeaderCell,
	                eElement: eHeaderCellLabel,
	                dragItemCallback: function () { return _this.createDragItem(); },
	                dragItemName: displayName,
	                dragSourceDropTarget: this.dragSourceDropTarget,
	                dragStarted: function () { return _this.column.setMoving(true, "uiColumnMoved"); },
	                dragStopped: function () { return _this.column.setMoving(false, "uiColumnMoved"); }
	            };
	            this.dragAndDropService.addDragSource(dragSource_1, true);
	            this.addDestroyFunc(function () { return _this.dragAndDropService.removeDragSource(dragSource_1); });
	        }
	    };
	    HeaderWrapperComp.prototype.createDragItem = function () {
	        var visibleState = {};
	        visibleState[this.column.getId()] = this.column.isVisible();
	        return {
	            columns: [this.column],
	            visibleState: visibleState
	        };
	    };
	    HeaderWrapperComp.prototype.setupResize = function () {
	        var _this = this;
	        var colDef = this.getComponentHolder();
	        // if no eResize in template, do nothing
	        if (!this.eResize) {
	            return;
	        }
	        if (!this.column.isResizable()) {
	            utils_1._.removeFromParent(this.eResize);
	            return;
	        }
	        var finishedWithResizeFunc = this.horizontalResizeService.addResizeBar({
	            eResizeBar: this.eResize,
	            onResizeStart: this.onResizeStart.bind(this),
	            onResizing: this.onResizing.bind(this, false),
	            onResizeEnd: this.onResizing.bind(this, true)
	        });
	        this.addDestroyFunc(finishedWithResizeFunc);
	        var weWantAutoSize = !this.gridOptionsWrapper.isSuppressAutoSize() && !colDef.suppressAutoSize;
	        if (weWantAutoSize) {
	            this.addDestroyableEventListener(this.eResize, 'dblclick', function () {
	                _this.columnController.autoSizeColumn(_this.column, "uiColumnResized");
	            });
	            var touchListener = new touchListener_1.TouchListener(this.eResize);
	            this.addDestroyableEventListener(touchListener, touchListener_1.TouchListener.EVENT_DOUBLE_TAP, function () {
	                _this.columnController.autoSizeColumn(_this.column, "uiColumnResized");
	            });
	            this.addDestroyFunc(touchListener.destroy.bind(touchListener));
	        }
	    };
	    HeaderWrapperComp.prototype.onResizing = function (finished, resizeAmount) {
	        var resizeAmountNormalised = this.normaliseResizeAmount(resizeAmount);
	        var newWidth = this.resizeStartWidth + resizeAmountNormalised;
	        this.columnController.setColumnWidth(this.column, newWidth, this.resizeWithShiftKey, finished, "uiColumnDragged");
	        if (finished) {
	            utils_1._.removeCssClass(this.getGui(), 'ag-column-resizing');
	        }
	    };
	    HeaderWrapperComp.prototype.onResizeStart = function (shiftKey) {
	        this.resizeStartWidth = this.column.getActualWidth();
	        this.resizeWithShiftKey = shiftKey;
	        utils_1._.addCssClass(this.getGui(), 'ag-column-resizing');
	    };
	    HeaderWrapperComp.prototype.getTooltipText = function () {
	        var colDef = this.getComponentHolder();
	        return colDef.headerTooltip;
	    };
	    HeaderWrapperComp.prototype.setupTooltip = function () {
	        var tooltipText = this.getTooltipText();
	        // add tooltip if exists
	        if (tooltipText == null) {
	            return;
	        }
	        if (this.gridOptionsWrapper.isEnableBrowserTooltips()) {
	            this.getGui().setAttribute('title', tooltipText);
	        }
	        else {
	            this.beans.tooltipManager.registerTooltip(this);
	        }
	    };
	    HeaderWrapperComp.prototype.setupMovingCss = function () {
	        this.addDestroyableEventListener(this.column, column_1.Column.EVENT_MOVING_CHANGED, this.onColumnMovingChanged.bind(this));
	        this.onColumnMovingChanged();
	    };
	    HeaderWrapperComp.prototype.addAttributes = function () {
	        this.getGui().setAttribute("col-id", this.column.getColId());
	    };
	    HeaderWrapperComp.prototype.setupWidth = function () {
	        this.addDestroyableEventListener(this.column, column_1.Column.EVENT_WIDTH_CHANGED, this.onColumnWidthChanged.bind(this));
	        this.onColumnWidthChanged();
	    };
	    HeaderWrapperComp.prototype.setupMenuClass = function () {
	        this.addDestroyableEventListener(this.column, column_1.Column.EVENT_MENU_VISIBLE_CHANGED, this.onMenuVisible.bind(this));
	        this.onColumnWidthChanged();
	    };
	    HeaderWrapperComp.prototype.onMenuVisible = function () {
	        this.addOrRemoveCssClass('ag-column-menu-visible', this.column.isMenuVisible());
	    };
	    HeaderWrapperComp.prototype.onColumnWidthChanged = function () {
	        this.getGui().style.width = this.column.getActualWidth() + 'px';
	    };
	    // optionally inverts the drag, depending on pinned and RTL
	    // note - this method is duplicated in RenderedHeaderGroupCell - should refactor out?
	    HeaderWrapperComp.prototype.normaliseResizeAmount = function (dragChange) {
	        var result = dragChange;
	        if (this.gridOptionsWrapper.isEnableRtl()) {
	            // for RTL, dragging left makes the col bigger, except when pinning left
	            if (this.pinned !== column_1.Column.PINNED_LEFT) {
	                result *= -1;
	            }
	        }
	        else {
	            // for LTR (ie normal), dragging left makes the col smaller, except when pinning right
	            if (this.pinned === column_1.Column.PINNED_RIGHT) {
	                result *= -1;
	            }
	        }
	        return result;
	    };
	    HeaderWrapperComp.TEMPLATE = '<div class="ag-header-cell" role="presentation" unselectable="on">' +
	        '<div ref="eResize" class="ag-header-cell-resize" role="presentation"></div>' +
	        '<ag-checkbox ref="cbSelectAll" class="ag-header-select-all" role="presentation"></ag-checkbox>' +
	        // <inner component goes here>
	        '</div>';
	    __decorate([
	        context_1.Autowired('gridOptionsWrapper'),
	        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
	    ], HeaderWrapperComp.prototype, "gridOptionsWrapper", void 0);
	    __decorate([
	        context_1.Autowired('dragAndDropService'),
	        __metadata("design:type", dragAndDropService_1.DragAndDropService)
	    ], HeaderWrapperComp.prototype, "dragAndDropService", void 0);
	    __decorate([
	        context_1.Autowired('columnController'),
	        __metadata("design:type", columnController_1.ColumnController)
	    ], HeaderWrapperComp.prototype, "columnController", void 0);
	    __decorate([
	        context_1.Autowired('horizontalResizeService'),
	        __metadata("design:type", horizontalResizeService_1.HorizontalResizeService)
	    ], HeaderWrapperComp.prototype, "horizontalResizeService", void 0);
	    __decorate([
	        context_1.Autowired('menuFactory'),
	        __metadata("design:type", Object)
	    ], HeaderWrapperComp.prototype, "menuFactory", void 0);
	    __decorate([
	        context_1.Autowired('gridApi'),
	        __metadata("design:type", gridApi_1.GridApi)
	    ], HeaderWrapperComp.prototype, "gridApi", void 0);
	    __decorate([
	        context_1.Autowired('columnApi'),
	        __metadata("design:type", columnApi_1.ColumnApi)
	    ], HeaderWrapperComp.prototype, "columnApi", void 0);
	    __decorate([
	        context_1.Autowired('sortController'),
	        __metadata("design:type", sortController_1.SortController)
	    ], HeaderWrapperComp.prototype, "sortController", void 0);
	    __decorate([
	        context_1.Autowired('eventService'),
	        __metadata("design:type", eventService_1.EventService)
	    ], HeaderWrapperComp.prototype, "eventService", void 0);
	    __decorate([
	        context_1.Autowired('userComponentFactory'),
	        __metadata("design:type", userComponentFactory_1.UserComponentFactory)
	    ], HeaderWrapperComp.prototype, "userComponentFactory", void 0);
	    __decorate([
	        context_1.Autowired('columnHoverService'),
	        __metadata("design:type", columnHoverService_1.ColumnHoverService)
	    ], HeaderWrapperComp.prototype, "columnHoverService", void 0);
	    __decorate([
	        context_1.Autowired('beans'),
	        __metadata("design:type", beans_1.Beans)
	    ], HeaderWrapperComp.prototype, "beans", void 0);
	    __decorate([
	        componentAnnotations_1.RefSelector('eResize'),
	        __metadata("design:type", HTMLElement)
	    ], HeaderWrapperComp.prototype, "eResize", void 0);
	    __decorate([
	        componentAnnotations_1.RefSelector('cbSelectAll'),
	        __metadata("design:type", agCheckbox_1.AgCheckbox)
	    ], HeaderWrapperComp.prototype, "cbSelectAll", void 0);
	    __decorate([
	        context_1.PostConstruct,
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", []),
	        __metadata("design:returntype", void 0)
	    ], HeaderWrapperComp.prototype, "init", null);
	    return HeaderWrapperComp;
	}(component_1.Component));
	exports.HeaderWrapperComp = HeaderWrapperComp;


/***/ }),
/* 2425 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var gridOptionsWrapper_1 = __webpack_require__(2324);
	var context_1 = __webpack_require__(2333);
	var dragService_1 = __webpack_require__(2364);
	var HorizontalResizeService = /** @class */ (function () {
	    function HorizontalResizeService() {
	    }
	    HorizontalResizeService.prototype.addResizeBar = function (params) {
	        var _this = this;
	        var dragSource = {
	            dragStartPixels: params.dragStartPixels || 0,
	            eElement: params.eResizeBar,
	            onDragStart: this.onDragStart.bind(this, params),
	            onDragStop: this.onDragStop.bind(this, params),
	            onDragging: this.onDragging.bind(this, params)
	        };
	        this.dragService.addDragSource(dragSource, true);
	        // we pass remove func back to the caller, so call can tell us when they
	        // are finished, and then we remove the listener from the drag source
	        var finishedWithResizeFunc = function () { return _this.dragService.removeDragSource(dragSource); };
	        return finishedWithResizeFunc;
	    };
	    HorizontalResizeService.prototype.onDragStart = function (params, mouseEvent) {
	        this.draggingStarted = true;
	        this.dragStartX = mouseEvent.clientX;
	        this.setResizeIcons();
	        var shiftKey = mouseEvent instanceof MouseEvent ? mouseEvent.shiftKey === true : false;
	        params.onResizeStart(shiftKey);
	    };
	    HorizontalResizeService.prototype.setResizeIcons = function () {
	        this.oldBodyCursor = this.eGridDiv.style.cursor;
	        this.oldMsUserSelect = this.eGridDiv.style.msUserSelect;
	        this.oldWebkitUserSelect = this.eGridDiv.style.webkitUserSelect;
	        // change the body cursor, so when drag moves out of the drag bar, the cursor is still 'resize' (or 'move'
	        this.eGridDiv.style.cursor = 'col-resize';
	        // we don't want text selection outside the grid (otherwise it looks weird as text highlights when we move)
	        this.eGridDiv.style.msUserSelect = 'none';
	        this.eGridDiv.style.webkitUserSelect = 'none';
	    };
	    HorizontalResizeService.prototype.onDragStop = function (params, mouseEvent) {
	        params.onResizeEnd(this.resizeAmount);
	        this.resetIcons();
	    };
	    HorizontalResizeService.prototype.resetIcons = function () {
	        // we don't want text selection outside the grid (otherwise it looks weird as text highlights when we move)
	        this.eGridDiv.style.cursor = this.oldBodyCursor;
	        this.eGridDiv.style.msUserSelect = this.oldMsUserSelect;
	        this.eGridDiv.style.webkitUserSelect = this.oldWebkitUserSelect;
	    };
	    HorizontalResizeService.prototype.onDragging = function (params, mouseEvent) {
	        this.resizeAmount = mouseEvent.clientX - this.dragStartX;
	        params.onResizing(this.resizeAmount);
	    };
	    __decorate([
	        context_1.Autowired('gridOptionsWrapper'),
	        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
	    ], HorizontalResizeService.prototype, "gridOptionsWrapper", void 0);
	    __decorate([
	        context_1.Autowired('dragService'),
	        __metadata("design:type", dragService_1.DragService)
	    ], HorizontalResizeService.prototype, "dragService", void 0);
	    __decorate([
	        context_1.Autowired('eGridDiv'),
	        __metadata("design:type", HTMLElement)
	    ], HorizontalResizeService.prototype, "eGridDiv", void 0);
	    HorizontalResizeService = __decorate([
	        context_1.Bean('horizontalResizeService')
	    ], HorizontalResizeService);
	    return HorizontalResizeService;
	}());
	exports.HorizontalResizeService = HorizontalResizeService;


/***/ }),
/* 2426 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var utils_1 = __webpack_require__(2325);
	var CssClassApplier = /** @class */ (function () {
	    function CssClassApplier() {
	    }
	    CssClassApplier.addHeaderClassesFromColDef = function (abstractColDef, eHeaderCell, gridOptionsWrapper, column, columnGroup) {
	        if (utils_1._.missing(abstractColDef)) {
	            return;
	        }
	        this.addColumnClassesFromCollDef(abstractColDef.headerClass, abstractColDef, eHeaderCell, gridOptionsWrapper, column, columnGroup);
	    };
	    CssClassApplier.addToolPanelClassesFromColDef = function (abstractColDef, eHeaderCell, gridOptionsWrapper, column, columnGroup) {
	        if (utils_1._.missing(abstractColDef)) {
	            return;
	        }
	        this.addColumnClassesFromCollDef(abstractColDef.toolPanelClass, abstractColDef, eHeaderCell, gridOptionsWrapper, column, columnGroup);
	    };
	    CssClassApplier.addColumnClassesFromCollDef = function (classesOrFunc, abstractColDef, eHeaderCell, gridOptionsWrapper, column, columnGroup) {
	        if (utils_1._.missing(classesOrFunc)) {
	            return;
	        }
	        var classToUse;
	        if (typeof classesOrFunc === 'function') {
	            var params = {
	                // bad naming, as colDef here can be a group or a column,
	                // however most people won't appreciate the difference,
	                // so keeping it as colDef to avoid confusion.
	                colDef: abstractColDef,
	                column: column,
	                columnGroup: columnGroup,
	                context: gridOptionsWrapper.getContext(),
	                api: gridOptionsWrapper.getApi()
	            };
	            var headerClassFunc = classesOrFunc;
	            classToUse = headerClassFunc(params);
	        }
	        else {
	            classToUse = classesOrFunc;
	        }
	        if (typeof classToUse === 'string') {
	            utils_1._.addCssClass(eHeaderCell, classToUse);
	        }
	        else if (Array.isArray(classToUse)) {
	            classToUse.forEach(function (cssClassItem) {
	                utils_1._.addCssClass(eHeaderCell, cssClassItem);
	            });
	        }
	    };
	    return CssClassApplier;
	}());
	exports.CssClassApplier = CssClassApplier;


/***/ }),
/* 2427 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var column_1 = __webpack_require__(2343);
	var beanStub_1 = __webpack_require__(2354);
	var constants_1 = __webpack_require__(2328);
	var utils_1 = __webpack_require__(2325);
	var SetLeftFeature = /** @class */ (function (_super) {
	    __extends(SetLeftFeature, _super);
	    function SetLeftFeature(columnOrGroup, eCell, beans, colsSpanning) {
	        var _this = _super.call(this) || this;
	        _this.columnOrGroup = columnOrGroup;
	        _this.eCell = eCell;
	        _this.colsSpanning = colsSpanning;
	        _this.beans = beans;
	        _this.printLayout = beans.gridOptionsWrapper.getDomLayout() === constants_1.Constants.DOM_LAYOUT_PRINT;
	        return _this;
	    }
	    SetLeftFeature.prototype.setColsSpanning = function (colsSpanning) {
	        this.colsSpanning = colsSpanning;
	        this.onLeftChanged();
	    };
	    SetLeftFeature.prototype.getColumnOrGroup = function () {
	        if (this.beans.gridOptionsWrapper.isEnableRtl() && this.colsSpanning) {
	            return utils_1._.last(this.colsSpanning);
	        }
	        else {
	            return this.columnOrGroup;
	        }
	    };
	    SetLeftFeature.prototype.init = function () {
	        this.addDestroyableEventListener(this.columnOrGroup, column_1.Column.EVENT_LEFT_CHANGED, this.onLeftChanged.bind(this));
	        this.setLeftFirstTime();
	    };
	    SetLeftFeature.prototype.setLeftFirstTime = function () {
	        var suppressMoveAnimation = this.beans.gridOptionsWrapper.isSuppressColumnMoveAnimation();
	        var oldLeftExists = utils_1._.exists(this.columnOrGroup.getOldLeft());
	        var animateColumnMove = this.beans.columnAnimationService.isActive() && oldLeftExists && !suppressMoveAnimation;
	        if (animateColumnMove) {
	            this.animateInLeft();
	        }
	        else {
	            this.onLeftChanged();
	        }
	    };
	    SetLeftFeature.prototype.animateInLeft = function () {
	        var _this = this;
	        var left = this.getColumnOrGroup().getLeft();
	        var oldLeft = this.getColumnOrGroup().getOldLeft();
	        this.setLeft(oldLeft);
	        // we must keep track of the left we want to set to, as this would otherwise lead to a race
	        // condition, if the user changed the left value many times in one VM turn, then we want to make
	        // make sure the actualLeft we set in the timeout below (in the next VM turn) is the correct left
	        // position. eg if user changes column position twice, then setLeft() below executes twice in next
	        // VM turn, but only one (the correct one) should get applied.
	        this.actualLeft = left;
	        this.beans.columnAnimationService.executeNextVMTurn(function () {
	            // test this left value is the latest one to be applied, and if not, do nothing
	            if (_this.actualLeft === left) {
	                _this.setLeft(left);
	            }
	        });
	    };
	    SetLeftFeature.prototype.onLeftChanged = function () {
	        var colOrGroup = this.getColumnOrGroup();
	        var left = colOrGroup.getLeft();
	        this.actualLeft = this.modifyLeftForPrintLayout(colOrGroup, left);
	        this.setLeft(this.actualLeft);
	    };
	    SetLeftFeature.prototype.modifyLeftForPrintLayout = function (colOrGroup, leftPosition) {
	        if (!this.printLayout) {
	            return leftPosition;
	        }
	        if (colOrGroup.getPinned() === column_1.Column.PINNED_LEFT) {
	            return leftPosition;
	        }
	        else if (colOrGroup.getPinned() === column_1.Column.PINNED_RIGHT) {
	            var leftWidth = this.beans.columnController.getPinnedLeftContainerWidth();
	            var bodyWidth = this.beans.columnController.getBodyContainerWidth();
	            return leftWidth + bodyWidth + leftPosition;
	        }
	        else {
	            // is in body
	            var leftWidth = this.beans.columnController.getPinnedLeftContainerWidth();
	            return leftWidth + leftPosition;
	        }
	    };
	    SetLeftFeature.prototype.setLeft = function (value) {
	        // if the value is null, then that means the column is no longer
	        // displayed. there is logic in the rendering to fade these columns
	        // out, so we don't try and change their left positions.
	        if (utils_1._.exists(value)) {
	            this.eCell.style.left = value + "px";
	        }
	    };
	    return SetLeftFeature;
	}(beanStub_1.BeanStub));
	exports.SetLeftFeature = SetLeftFeature;


/***/ }),
/* 2428 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var context_1 = __webpack_require__(2333);
	var gridOptionsWrapper_1 = __webpack_require__(2324);
	var agAbstractInputField_1 = __webpack_require__(2429);
	var agAbstractField_1 = __webpack_require__(2430);
	var utils_1 = __webpack_require__(2325);
	var AgCheckbox = /** @class */ (function (_super) {
	    __extends(AgCheckbox, _super);
	    function AgCheckbox() {
	        var _this = _super.call(this) || this;
	        _this.className = 'ag-checkbox';
	        _this.displayTag = 'input';
	        _this.inputType = 'checkbox';
	        _this.labelAlignment = 'right';
	        _this.iconMap = {
	            selected: 'checkboxChecked',
	            unselected: 'checkboxUnchecked',
	            indeterminate: 'checkboxIndeterminate'
	        };
	        _this.selected = false;
	        _this.readOnly = false;
	        _this.passive = false;
	        _this.setTemplate(_this.TEMPLATE.replace(/%displayField%/g, _this.displayTag));
	        return _this;
	    }
	    AgCheckbox.prototype.postConstruct = function () {
	        _super.prototype.postConstruct.call(this);
	        utils_1._.addCssClass(this.eInput, 'ag-hidden');
	        this.addIconsPlaceholder();
	        this.updateIcons();
	    };
	    AgCheckbox.prototype.addInputListeners = function () {
	        var _this = this;
	        this.addDestroyableEventListener(this.getGui(), 'click', function (e) { return _this.onClick(e); });
	        this.addDestroyableEventListener(this.eInput, 'change', function (e) { return _this.setValue(e.target.checked, true); });
	    };
	    AgCheckbox.prototype.addIconsPlaceholder = function () {
	        var iconDiv = document.createElement('div');
	        this.eWrapper.appendChild(iconDiv);
	        this.eIconEl = iconDiv;
	    };
	    AgCheckbox.prototype.onClick = function (event) {
	        // if we don't set the path, then won't work in Edge, as once the <span> is removed from the dom,
	        // it's not possible to calculate the path by following the parent's chain. in other browser (eg
	        // chrome) there is event.path for this purpose, but missing in Edge.
	        utils_1._.addAgGridEventPath(event);
	        if (!this.readOnly) {
	            this.toggle();
	        }
	    };
	    AgCheckbox.prototype.getNextValue = function () {
	        return this.selected === undefined ? true : !this.selected;
	    };
	    AgCheckbox.prototype.setPassive = function (passive) {
	        this.passive = passive;
	    };
	    AgCheckbox.prototype.setReadOnly = function (readOnly) {
	        this.readOnly = readOnly;
	        this.updateIcons();
	    };
	    AgCheckbox.prototype.isReadOnly = function () {
	        return this.readOnly;
	    };
	    AgCheckbox.prototype.isSelected = function () {
	        return this.selected;
	    };
	    AgCheckbox.prototype.toggle = function () {
	        var nextValue = this.getNextValue();
	        if (this.passive) {
	            var event_1 = {
	                type: AgCheckbox.EVENT_CHANGED,
	                selected: nextValue
	            };
	            this.dispatchEvent(event_1);
	        }
	        else {
	            this.setValue(nextValue);
	        }
	    };
	    AgCheckbox.prototype.setSelected = function (selected, silent) {
	        if (this.selected === selected) {
	            return;
	        }
	        this.selected = typeof selected === 'boolean' ? selected : undefined;
	        this.eInput.checked = this.selected;
	        this.updateIcons();
	        if (!silent) {
	            var event_2 = {
	                type: agAbstractField_1.AgAbstractField.EVENT_CHANGED,
	                selected: this.selected
	            };
	            this.dispatchEvent(event_2);
	        }
	    };
	    AgCheckbox.prototype.getIconName = function () {
	        var value = this.getValue();
	        var prop = value === undefined ? 'indeterminate' : (value ? 'selected' : 'unselected');
	        var readOnlyStr = this.isReadOnly() ? 'ReadOnly' : '';
	        return "" + this.iconMap[prop] + readOnlyStr;
	    };
	    AgCheckbox.prototype.updateIcons = function () {
	        utils_1._.clearElement(this.eIconEl);
	        this.eIconEl.appendChild(utils_1._.createIconNoSpan(this.getIconName(), this.gridOptionsWrapper, null));
	    };
	    AgCheckbox.prototype.getValue = function () {
	        return this.isSelected();
	    };
	    AgCheckbox.prototype.setValue = function (value, silent) {
	        this.setSelected(value, silent);
	        return this;
	    };
	    __decorate([
	        context_1.Autowired('gridOptionsWrapper'),
	        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
	    ], AgCheckbox.prototype, "gridOptionsWrapper", void 0);
	    return AgCheckbox;
	}(agAbstractInputField_1.AgAbstractInputField));
	exports.AgCheckbox = AgCheckbox;


/***/ }),
/* 2429 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var componentAnnotations_1 = __webpack_require__(2384);
	var agAbstractField_1 = __webpack_require__(2430);
	var utils_1 = __webpack_require__(2325);
	var AgAbstractInputField = /** @class */ (function (_super) {
	    __extends(AgAbstractInputField, _super);
	    function AgAbstractInputField() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.config = {};
	        _this.TEMPLATE = "<div class=\"ag-input-field\" role=\"presentation\">\n            <label ref=\"eLabel\"></label>\n            <div ref=\"eWrapper\" class=\"ag-wrapper ag-input-wrapper\" role=\"presentation\">\n                <%displayField% ref=\"eInput\"></%displayField%>\n            </div>\n        </div>";
	        return _this;
	    }
	    AgAbstractInputField.prototype.postConstruct = function () {
	        _super.prototype.postConstruct.call(this);
	        this.setInputType();
	        utils_1._.addCssClass(this.getGui(), this.className);
	        var _a = this.config, width = _a.width, value = _a.value;
	        if (width != null) {
	            this.setWidth(width);
	        }
	        if (value != null) {
	            this.setValue(value);
	        }
	        this.addInputListeners();
	    };
	    AgAbstractInputField.prototype.addInputListeners = function () {
	        var _this = this;
	        this.addDestroyableEventListener(this.eInput, 'input', function (e) {
	            var value = e.target.value;
	            _this.setValue(value);
	        });
	    };
	    AgAbstractInputField.prototype.setInputType = function () {
	        if (this.inputType) {
	            this.eInput.setAttribute('type', this.inputType);
	        }
	    };
	    AgAbstractInputField.prototype.getInputElement = function () {
	        return this.eInput;
	    };
	    AgAbstractInputField.prototype.setInputWidth = function (width) {
	        utils_1._.setElementWidth(this.eWrapper, width);
	        return this;
	    };
	    AgAbstractInputField.prototype.setInputName = function (name) {
	        this.getInputElement().setAttribute('name', name);
	        return this;
	    };
	    __decorate([
	        componentAnnotations_1.RefSelector('eLabel'),
	        __metadata("design:type", HTMLElement)
	    ], AgAbstractInputField.prototype, "eLabel", void 0);
	    __decorate([
	        componentAnnotations_1.RefSelector('eWrapper'),
	        __metadata("design:type", HTMLElement)
	    ], AgAbstractInputField.prototype, "eWrapper", void 0);
	    __decorate([
	        componentAnnotations_1.RefSelector('eInput'),
	        __metadata("design:type", Object)
	    ], AgAbstractInputField.prototype, "eInput", void 0);
	    return AgAbstractInputField;
	}(agAbstractField_1.AgAbstractField));
	exports.AgAbstractInputField = AgAbstractInputField;


/***/ }),
/* 2430 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var agAbstractLabel_1 = __webpack_require__(2431);
	var utils_1 = __webpack_require__(2325);
	var AgAbstractField = /** @class */ (function (_super) {
	    __extends(AgAbstractField, _super);
	    function AgAbstractField() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    AgAbstractField.prototype.onValueChange = function (callbackFn) {
	        var _this = this;
	        this.addDestroyableEventListener(this, AgAbstractField.EVENT_CHANGED, function () {
	            callbackFn(_this.getValue());
	        });
	        return this;
	    };
	    AgAbstractField.prototype.getWidth = function () {
	        return this.getGui().clientWidth;
	    };
	    AgAbstractField.prototype.setWidth = function (width) {
	        utils_1._.setFixedWidth(this.getGui(), width);
	        return this;
	    };
	    AgAbstractField.prototype.getValue = function () {
	        return this.value;
	    };
	    AgAbstractField.prototype.setValue = function (value, silent) {
	        if (this.value === value) {
	            return this;
	        }
	        this.value = value;
	        if (!silent) {
	            this.dispatchEvent({ type: AgAbstractField.EVENT_CHANGED });
	        }
	        return this;
	    };
	    AgAbstractField.EVENT_CHANGED = 'valueChange';
	    return AgAbstractField;
	}(agAbstractLabel_1.AgAbstractLabel));
	exports.AgAbstractField = AgAbstractField;


/***/ }),
/* 2431 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var component_1 = __webpack_require__(2353);
	var context_1 = __webpack_require__(2333);
	var utils_1 = __webpack_require__(2325);
	var AgAbstractLabel = /** @class */ (function (_super) {
	    __extends(AgAbstractLabel, _super);
	    function AgAbstractLabel() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.labelSeparator = '';
	        _this.labelAlignment = 'left';
	        _this.config = {};
	        _this.label = '';
	        return _this;
	    }
	    AgAbstractLabel.prototype.postConstruct = function () {
	        utils_1._.addCssClass(this.getGui(), 'ag-labeled');
	        var _a = this.config, labelSeparator = _a.labelSeparator, label = _a.label, labelWidth = _a.labelWidth, labelAlignment = _a.labelAlignment;
	        if (labelSeparator != null) {
	            this.setLabelSeparator(labelSeparator);
	        }
	        if (label != null) {
	            this.setLabel(label);
	        }
	        if (labelWidth != null) {
	            this.setLabelWidth(labelWidth);
	        }
	        this.setLabelAlignment(labelAlignment || this.labelAlignment);
	        this.refreshLabel();
	    };
	    AgAbstractLabel.prototype.refreshLabel = function () {
	        this.eLabel.innerText = this.label + this.labelSeparator;
	        utils_1._.addOrRemoveCssClass(this.eLabel, 'ag-hidden', this.label === '');
	    };
	    AgAbstractLabel.prototype.setLabelSeparator = function (labelSeparator) {
	        if (this.labelSeparator === labelSeparator) {
	            return this;
	        }
	        this.labelSeparator = labelSeparator;
	        if (this.label != null) {
	            this.refreshLabel();
	        }
	        return this;
	    };
	    AgAbstractLabel.prototype.setLabel = function (label) {
	        if (this.label === label) {
	            return this;
	        }
	        this.label = label;
	        this.refreshLabel();
	        return this;
	    };
	    AgAbstractLabel.prototype.setLabelAlignment = function (alignment) {
	        var eGui = this.getGui();
	        utils_1._.addOrRemoveCssClass(eGui, 'ag-label-align-left', alignment === 'left');
	        utils_1._.addOrRemoveCssClass(eGui, 'ag-label-align-right', alignment === 'right');
	        utils_1._.addOrRemoveCssClass(eGui, 'ag-label-align-top', alignment === 'top');
	        return this;
	    };
	    AgAbstractLabel.prototype.setLabelWidth = function (width) {
	        if (this.label == null) {
	            return this;
	        }
	        utils_1._.setElementWidth(this.eLabel, width);
	        return this;
	    };
	    __decorate([
	        context_1.PostConstruct,
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", []),
	        __metadata("design:returntype", void 0)
	    ], AgAbstractLabel.prototype, "postConstruct", null);
	    return AgAbstractLabel;
	}(component_1.Component));
	exports.AgAbstractLabel = AgAbstractLabel;


/***/ }),
/* 2432 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var agCheckbox_1 = __webpack_require__(2428);
	var beanStub_1 = __webpack_require__(2354);
	var context_1 = __webpack_require__(2333);
	var columnApi_1 = __webpack_require__(2346);
	var gridApi_1 = __webpack_require__(2338);
	var events_1 = __webpack_require__(2335);
	var eventService_1 = __webpack_require__(2331);
	var constants_1 = __webpack_require__(2328);
	var selectionController_1 = __webpack_require__(2357);
	var gridOptionsWrapper_1 = __webpack_require__(2324);
	var SelectAllFeature = /** @class */ (function (_super) {
	    __extends(SelectAllFeature, _super);
	    function SelectAllFeature(cbSelectAll, column) {
	        var _this = _super.call(this) || this;
	        _this.cbSelectAllVisible = false;
	        _this.processingEventFromCheckbox = false;
	        _this.cbSelectAll = cbSelectAll;
	        _this.column = column;
	        var colDef = column.getColDef();
	        _this.filteredOnly = colDef ? !!colDef.headerCheckboxSelectionFilteredOnly : false;
	        return _this;
	    }
	    SelectAllFeature.prototype.postConstruct = function () {
	        this.showOrHideSelectAll();
	        this.addDestroyableEventListener(this.eventService, events_1.Events.EVENT_DISPLAYED_COLUMNS_CHANGED, this.showOrHideSelectAll.bind(this));
	        this.addDestroyableEventListener(this.eventService, events_1.Events.EVENT_SELECTION_CHANGED, this.onSelectionChanged.bind(this));
	        this.addDestroyableEventListener(this.eventService, events_1.Events.EVENT_MODEL_UPDATED, this.onModelChanged.bind(this));
	        this.addDestroyableEventListener(this.cbSelectAll, agCheckbox_1.AgCheckbox.EVENT_CHANGED, this.onCbSelectAll.bind(this));
	    };
	    SelectAllFeature.prototype.showOrHideSelectAll = function () {
	        this.cbSelectAllVisible = this.isCheckboxSelection();
	        this.cbSelectAll.setDisplayed(this.cbSelectAllVisible);
	        if (this.cbSelectAllVisible) {
	            // in case user is trying this feature with the wrong model type
	            this.checkRightRowModelType();
	            // make sure checkbox is showing the right state
	            this.updateStateOfCheckbox();
	        }
	    };
	    SelectAllFeature.prototype.onModelChanged = function () {
	        if (!this.cbSelectAllVisible) {
	            return;
	        }
	        this.updateStateOfCheckbox();
	    };
	    SelectAllFeature.prototype.onSelectionChanged = function () {
	        if (!this.cbSelectAllVisible) {
	            return;
	        }
	        this.updateStateOfCheckbox();
	    };
	    SelectAllFeature.prototype.getNextCheckboxState = function (selectionCount) {
	        if (selectionCount.selected === 0 && selectionCount.notSelected === 0) {
	            // if no rows, always have it unselected
	            return false;
	        }
	        else if (selectionCount.selected > 0 && selectionCount.notSelected > 0) {
	            // if mix of selected and unselected, this is the tri-state
	            return null;
	        }
	        else if (selectionCount.selected > 0) {
	            // only selected
	            return true;
	        }
	        else {
	            // nothing selected
	            return false;
	        }
	    };
	    SelectAllFeature.prototype.updateStateOfCheckbox = function () {
	        if (this.processingEventFromCheckbox) {
	            return;
	        }
	        this.processingEventFromCheckbox = true;
	        var selectionCount = this.getSelectionCount();
	        var allSelected = this.getNextCheckboxState(selectionCount);
	        this.cbSelectAll.setValue(allSelected);
	        this.processingEventFromCheckbox = false;
	    };
	    SelectAllFeature.prototype.getSelectionCount = function () {
	        var _this = this;
	        var selectedCount = 0;
	        var notSelectedCount = 0;
	        var callback = function (node) {
	            if (_this.gridOptionsWrapper.isGroupSelectsChildren() && node.group) {
	                return;
	            }
	            if (node.isSelected()) {
	                selectedCount++;
	            }
	            else if (!node.selectable) {
	                // don't count non-selectable nodes!
	            }
	            else {
	                notSelectedCount++;
	            }
	        };
	        if (this.filteredOnly) {
	            this.gridApi.forEachNodeAfterFilter(callback);
	        }
	        else {
	            this.gridApi.forEachNode(callback);
	        }
	        return {
	            notSelected: notSelectedCount,
	            selected: selectedCount
	        };
	    };
	    SelectAllFeature.prototype.checkRightRowModelType = function () {
	        var rowModelType = this.rowModel.getType();
	        var rowModelMatches = rowModelType === constants_1.Constants.ROW_MODEL_TYPE_CLIENT_SIDE;
	        if (!rowModelMatches) {
	            console.warn("ag-Grid: selectAllCheckbox is only available if using normal row model, you are using " + rowModelType);
	        }
	    };
	    SelectAllFeature.prototype.onCbSelectAll = function () {
	        if (this.processingEventFromCheckbox) {
	            return;
	        }
	        if (!this.cbSelectAllVisible) {
	            return;
	        }
	        var value = this.cbSelectAll.getValue();
	        if (value) {
	            this.selectionController.selectAllRowNodes(this.filteredOnly);
	        }
	        else {
	            this.selectionController.deselectAllRowNodes(this.filteredOnly);
	        }
	    };
	    SelectAllFeature.prototype.isCheckboxSelection = function () {
	        var result = this.column.getColDef().headerCheckboxSelection;
	        if (typeof result === 'function') {
	            var func = result;
	            result = func({
	                column: this.column,
	                colDef: this.column.getColDef(),
	                columnApi: this.columnApi,
	                api: this.gridApi
	            });
	        }
	        if (result) {
	            if (this.gridOptionsWrapper.isRowModelServerSide()) {
	                console.warn('headerCheckboxSelection is not supported for Server Side Row Model');
	                return false;
	            }
	            if (this.gridOptionsWrapper.isRowModelInfinite()) {
	                console.warn('headerCheckboxSelection is not supported for Infinite Row Model');
	                return false;
	            }
	            if (this.gridOptionsWrapper.isRowModelViewport()) {
	                console.warn('headerCheckboxSelection is not supported for Viewport Row Model');
	                return false;
	            }
	            // otherwise the row model is compatible, so return true
	            return true;
	        }
	        else {
	            return false;
	        }
	    };
	    __decorate([
	        context_1.Autowired('gridApi'),
	        __metadata("design:type", gridApi_1.GridApi)
	    ], SelectAllFeature.prototype, "gridApi", void 0);
	    __decorate([
	        context_1.Autowired('columnApi'),
	        __metadata("design:type", columnApi_1.ColumnApi)
	    ], SelectAllFeature.prototype, "columnApi", void 0);
	    __decorate([
	        context_1.Autowired('eventService'),
	        __metadata("design:type", eventService_1.EventService)
	    ], SelectAllFeature.prototype, "eventService", void 0);
	    __decorate([
	        context_1.Autowired('rowModel'),
	        __metadata("design:type", Object)
	    ], SelectAllFeature.prototype, "rowModel", void 0);
	    __decorate([
	        context_1.Autowired('selectionController'),
	        __metadata("design:type", selectionController_1.SelectionController)
	    ], SelectAllFeature.prototype, "selectionController", void 0);
	    __decorate([
	        context_1.Autowired('gridOptionsWrapper'),
	        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
	    ], SelectAllFeature.prototype, "gridOptionsWrapper", void 0);
	    __decorate([
	        context_1.PostConstruct,
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", []),
	        __metadata("design:returntype", void 0)
	    ], SelectAllFeature.prototype, "postConstruct", null);
	    return SelectAllFeature;
	}(beanStub_1.BeanStub));
	exports.SelectAllFeature = SelectAllFeature;


/***/ }),
/* 2433 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var beanStub_1 = __webpack_require__(2354);
	var context_1 = __webpack_require__(2333);
	var columnHoverService_1 = __webpack_require__(2417);
	var HoverFeature = /** @class */ (function (_super) {
	    __extends(HoverFeature, _super);
	    function HoverFeature(columns, element) {
	        var _this = _super.call(this) || this;
	        _this.columns = columns;
	        _this.element = element;
	        return _this;
	    }
	    HoverFeature.prototype.postConstruct = function () {
	        this.addMouseHoverListeners();
	    };
	    HoverFeature.prototype.addMouseHoverListeners = function () {
	        this.addDestroyableEventListener(this.element, 'mouseout', this.onMouseOut.bind(this));
	        this.addDestroyableEventListener(this.element, 'mouseover', this.onMouseOver.bind(this));
	    };
	    HoverFeature.prototype.onMouseOut = function () {
	        this.columnHoverService.clearMouseOver();
	    };
	    HoverFeature.prototype.onMouseOver = function () {
	        this.columnHoverService.setMouseOver(this.columns);
	    };
	    __decorate([
	        context_1.Autowired('columnHoverService'),
	        __metadata("design:type", columnHoverService_1.ColumnHoverService)
	    ], HoverFeature.prototype, "columnHoverService", void 0);
	    __decorate([
	        context_1.PostConstruct,
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", []),
	        __metadata("design:returntype", void 0)
	    ], HoverFeature.prototype, "postConstruct", null);
	    return HoverFeature;
	}(beanStub_1.BeanStub));
	exports.HoverFeature = HoverFeature;


/***/ }),
/* 2434 */
/***/ (function(module, exports) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	// class returns unique instance id's for columns.
	// eg, the following calls (in this order) will result in:
	//
	// getInstanceIdForKey('country') => 0
	// getInstanceIdForKey('country') => 1
	// getInstanceIdForKey('country') => 2
	// getInstanceIdForKey('country') => 3
	// getInstanceIdForKey('age') => 0
	// getInstanceIdForKey('age') => 1
	// getInstanceIdForKey('country') => 4
	var GroupInstanceIdCreator = /** @class */ (function () {
	    function GroupInstanceIdCreator() {
	        // this map contains keys to numbers, so we remember what the last call was
	        this.existingIds = {};
	    }
	    GroupInstanceIdCreator.prototype.getInstanceIdForKey = function (key) {
	        var lastResult = this.existingIds[key];
	        var result;
	        if (typeof lastResult !== 'number') {
	            // first time this key
	            result = 0;
	        }
	        else {
	            result = lastResult + 1;
	        }
	        this.existingIds[key] = result;
	        return result;
	    };
	    return GroupInstanceIdCreator;
	}());
	exports.GroupInstanceIdCreator = GroupInstanceIdCreator;


/***/ }),
/* 2435 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var context_1 = __webpack_require__(2333);
	var column_1 = __webpack_require__(2343);
	var gridOptionsWrapper_1 = __webpack_require__(2324);
	var columnController_1 = __webpack_require__(2341);
	var columnFactory_1 = __webpack_require__(2323);
	var constants_1 = __webpack_require__(2328);
	var utils_1 = __webpack_require__(2325);
	var AutoGroupColService = /** @class */ (function () {
	    function AutoGroupColService() {
	    }
	    AutoGroupColService_1 = AutoGroupColService;
	    AutoGroupColService.prototype.createAutoGroupColumns = function (rowGroupColumns) {
	        var _this = this;
	        var groupAutoColumns = [];
	        var doingTreeData = this.gridOptionsWrapper.isTreeData();
	        var doingMultiAutoColumn = this.gridOptionsWrapper.isGroupMultiAutoColumn();
	        if (doingTreeData && doingMultiAutoColumn) {
	            console.warn('ag-Grid: you cannot mix groupMultiAutoColumn with treeData, only one column can be used to display groups when doing tree data');
	            doingMultiAutoColumn = false;
	        }
	        // if doing groupMultiAutoColumn, then we call the method multiple times, once
	        // for each column we are grouping by
	        if (doingMultiAutoColumn) {
	            rowGroupColumns.forEach(function (rowGroupCol, index) {
	                groupAutoColumns.push(_this.createOneAutoGroupColumn(rowGroupCol, index));
	            });
	        }
	        else {
	            groupAutoColumns.push(this.createOneAutoGroupColumn());
	        }
	        return groupAutoColumns;
	    };
	    // rowGroupCol and index are missing if groupMultiAutoColumn=false
	    AutoGroupColService.prototype.createOneAutoGroupColumn = function (rowGroupCol, index) {
	        // if one provided by user, use it, otherwise create one
	        var defaultAutoColDef = this.generateDefaultColDef(rowGroupCol);
	        // if doing multi, set the field
	        var colId;
	        if (rowGroupCol) {
	            colId = constants_1.Constants.GROUP_AUTO_COLUMN_ID + "-" + rowGroupCol.getId();
	        }
	        else {
	            colId = AutoGroupColService_1.GROUP_AUTO_COLUMN_BUNDLE_ID;
	        }
	        var userAutoColDef = this.gridOptionsWrapper.getAutoGroupColumnDef();
	        utils_1._.mergeDeep(defaultAutoColDef, userAutoColDef);
	        defaultAutoColDef = this.columnFactory.mergeColDefs(defaultAutoColDef);
	        defaultAutoColDef.colId = colId;
	        // For tree data the filter is always allowed
	        if (!this.gridOptionsWrapper.isTreeData()) {
	            // we would only allow filter if the user has provided field or value getter. otherwise the filter
	            // would not be able to work.
	            var noFieldOrValueGetter = utils_1._.missing(defaultAutoColDef.field) && utils_1._.missing(defaultAutoColDef.valueGetter) && utils_1._.missing(defaultAutoColDef.filterValueGetter);
	            if (noFieldOrValueGetter) {
	                defaultAutoColDef.filter = false;
	            }
	        }
	        // if showing many cols, we don't want to show more than one with a checkbox for selection
	        if (index && index > 0) {
	            defaultAutoColDef.headerCheckboxSelection = false;
	        }
	        var newCol = new column_1.Column(defaultAutoColDef, null, colId, true);
	        this.context.wireBean(newCol);
	        return newCol;
	    };
	    AutoGroupColService.prototype.generateDefaultColDef = function (rowGroupCol) {
	        var userAutoColDef = this.gridOptionsWrapper.getAutoGroupColumnDef();
	        var localeTextFunc = this.gridOptionsWrapper.getLocaleTextFunc();
	        var defaultAutoColDef = {
	            headerName: localeTextFunc('group', 'Group')
	        };
	        var userHasProvidedGroupCellRenderer = userAutoColDef && (userAutoColDef.cellRenderer || userAutoColDef.cellRendererFramework);
	        // only add the default group cell renderer if user hasn't provided one
	        if (!userHasProvidedGroupCellRenderer) {
	            defaultAutoColDef.cellRenderer = 'agGroupCellRenderer';
	        }
	        // we never allow moving the group column
	        // defaultAutoColDef.suppressMovable = true;
	        if (rowGroupCol) {
	            var rowGroupColDef = rowGroupCol.getColDef();
	            utils_1._.assign(defaultAutoColDef, {
	                // cellRendererParams.groupKey: colDefToCopy.field;
	                headerName: this.columnController.getDisplayNameForColumn(rowGroupCol, 'header'),
	                headerValueGetter: rowGroupColDef.headerValueGetter
	            });
	            if (rowGroupColDef.cellRenderer) {
	                utils_1._.assign(defaultAutoColDef, {
	                    cellRendererParams: {
	                        innerRenderer: rowGroupColDef.cellRenderer,
	                        innerRendererParams: rowGroupColDef.cellRendererParams
	                    }
	                });
	            }
	            defaultAutoColDef.showRowGroup = rowGroupCol.getColId();
	        }
	        else {
	            defaultAutoColDef.showRowGroup = true;
	        }
	        return defaultAutoColDef;
	    };
	    var AutoGroupColService_1;
	    AutoGroupColService.GROUP_AUTO_COLUMN_BUNDLE_ID = constants_1.Constants.GROUP_AUTO_COLUMN_ID;
	    __decorate([
	        context_1.Autowired('gridOptionsWrapper'),
	        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
	    ], AutoGroupColService.prototype, "gridOptionsWrapper", void 0);
	    __decorate([
	        context_1.Autowired('context'),
	        __metadata("design:type", context_1.Context)
	    ], AutoGroupColService.prototype, "context", void 0);
	    __decorate([
	        context_1.Autowired('columnController'),
	        __metadata("design:type", columnController_1.ColumnController)
	    ], AutoGroupColService.prototype, "columnController", void 0);
	    __decorate([
	        context_1.Autowired('columnFactory'),
	        __metadata("design:type", columnFactory_1.ColumnFactory)
	    ], AutoGroupColService.prototype, "columnFactory", void 0);
	    AutoGroupColService = AutoGroupColService_1 = __decorate([
	        context_1.Bean('autoGroupColService')
	    ], AutoGroupColService);
	    return AutoGroupColService;
	}());
	exports.AutoGroupColService = AutoGroupColService;


/***/ }),
/* 2436 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var context_1 = __webpack_require__(2333);
	var Downloader = /** @class */ (function () {
	    function Downloader() {
	    }
	    Downloader.prototype.download = function (fileName, content) {
	        // Internet Explorer
	        if (window.navigator.msSaveOrOpenBlob) {
	            window.navigator.msSaveOrOpenBlob(content, fileName);
	        }
	        else {
	            // Other Browsers
	            var element = document.createElement("a");
	            var url_1 = window.URL.createObjectURL(content);
	            element.setAttribute("href", url_1);
	            element.setAttribute("download", fileName);
	            element.style.display = "none";
	            document.body.appendChild(element);
	            element.dispatchEvent(new MouseEvent('click', {
	                bubbles: false,
	                cancelable: true,
	                view: window
	            }));
	            document.body.removeChild(element);
	            window.setTimeout(function () {
	                window.URL.revokeObjectURL(url_1);
	            }, 0);
	        }
	    };
	    Downloader = __decorate([
	        context_1.Bean("downloader")
	    ], Downloader);
	    return Downloader;
	}());
	exports.Downloader = Downloader;


/***/ }),
/* 2437 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var context_1 = __webpack_require__(2333);
	var constants_1 = __webpack_require__(2328);
	var gridOptionsWrapper_1 = __webpack_require__(2324);
	var utils_1 = __webpack_require__(2325);
	var ImmutableService = /** @class */ (function () {
	    function ImmutableService() {
	    }
	    ImmutableService.prototype.postConstruct = function () {
	        if (this.rowModel.getType() === constants_1.Constants.ROW_MODEL_TYPE_CLIENT_SIDE) {
	            this.clientSideRowModel = this.rowModel;
	        }
	    };
	    // converts the setRowData() command to a transaction
	    ImmutableService.prototype.createTransactionForRowData = function (data) {
	        if (utils_1._.missing(this.clientSideRowModel)) {
	            console.error('ag-Grid: ImmutableService only works with ClientSideRowModel');
	            return;
	        }
	        var getRowNodeIdFunc = this.gridOptionsWrapper.getRowNodeIdFunc();
	        if (!getRowNodeIdFunc || utils_1._.missing(getRowNodeIdFunc)) {
	            console.error('ag-Grid: ImmutableService requires getRowNodeId() callback to be implemented, your row data need IDs!');
	            return;
	        }
	        // convert the data into a transaction object by working out adds, removes and updates
	        var transaction = {
	            remove: [],
	            update: [],
	            add: []
	        };
	        var existingNodesMap = this.clientSideRowModel.getCopyOfNodesMap();
	        var suppressSortOrder = this.gridOptionsWrapper.isSuppressMaintainUnsortedOrder();
	        var orderMap = suppressSortOrder ? null : {};
	        if (utils_1._.exists(data)) {
	            // split all the new data in the following:
	            // if new, push to 'add'
	            // if update, push to 'update'
	            // if not changed, do not include in the transaction
	            data.forEach(function (dataItem, index) {
	                var id = getRowNodeIdFunc(dataItem);
	                var existingNode = existingNodesMap[id];
	                if (orderMap) {
	                    orderMap[id] = index;
	                }
	                if (existingNode) {
	                    var dataHasChanged = existingNode.data !== dataItem;
	                    if (dataHasChanged) {
	                        transaction.update.push(dataItem);
	                    }
	                    // otherwise, if data not changed, we just don't include it anywhere, as it's not a delta
	                    // remove from list, so we know the item is not to be removed
	                    existingNodesMap[id] = undefined;
	                }
	                else {
	                    transaction.add.push(dataItem);
	                }
	            });
	        }
	        // at this point, all rows that are left, should be removed
	        utils_1._.iterateObject(existingNodesMap, function (id, rowNode) {
	            if (rowNode) {
	                transaction.remove.push(rowNode.data);
	            }
	        });
	        return [transaction, orderMap];
	    };
	    __decorate([
	        context_1.Autowired('rowModel'),
	        __metadata("design:type", Object)
	    ], ImmutableService.prototype, "rowModel", void 0);
	    __decorate([
	        context_1.Autowired('gridOptionsWrapper'),
	        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
	    ], ImmutableService.prototype, "gridOptionsWrapper", void 0);
	    __decorate([
	        context_1.PostConstruct,
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", []),
	        __metadata("design:returntype", void 0)
	    ], ImmutableService.prototype, "postConstruct", null);
	    ImmutableService = __decorate([
	        context_1.Bean('immutableService')
	    ], ImmutableService);
	    return ImmutableService;
	}());
	exports.ImmutableService = ImmutableService;


/***/ }),
/* 2438 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var __param = (this && this.__param) || function (paramIndex, decorator) {
	    return function (target, key) { decorator(target, key, paramIndex); }
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var gridOptionsWrapper_1 = __webpack_require__(2324);
	var columnController_1 = __webpack_require__(2341);
	var eventService_1 = __webpack_require__(2331);
	var logger_1 = __webpack_require__(2332);
	var events_1 = __webpack_require__(2335);
	var context_1 = __webpack_require__(2333);
	var context_2 = __webpack_require__(2333);
	var context_3 = __webpack_require__(2333);
	var context_4 = __webpack_require__(2333);
	var AlignedGridsService = /** @class */ (function () {
	    function AlignedGridsService() {
	        // flag to mark if we are consuming. to avoid cyclic events (ie other grid firing back to master
	        // while processing a master event) we mark this if consuming an event, and if we are, then
	        // we don't fire back any events.
	        this.consuming = false;
	    }
	    AlignedGridsService.prototype.setBeans = function (loggerFactory) {
	        this.logger = loggerFactory.create('AlignedGridsService');
	    };
	    AlignedGridsService.prototype.registerGridComp = function (gridPanel) {
	        this.gridPanel = gridPanel;
	    };
	    AlignedGridsService.prototype.init = function () {
	        this.eventService.addEventListener(events_1.Events.EVENT_COLUMN_MOVED, this.fireColumnEvent.bind(this));
	        this.eventService.addEventListener(events_1.Events.EVENT_COLUMN_VISIBLE, this.fireColumnEvent.bind(this));
	        this.eventService.addEventListener(events_1.Events.EVENT_COLUMN_PINNED, this.fireColumnEvent.bind(this));
	        this.eventService.addEventListener(events_1.Events.EVENT_COLUMN_GROUP_OPENED, this.fireColumnEvent.bind(this));
	        this.eventService.addEventListener(events_1.Events.EVENT_COLUMN_RESIZED, this.fireColumnEvent.bind(this));
	        this.eventService.addEventListener(events_1.Events.EVENT_BODY_SCROLL, this.fireScrollEvent.bind(this));
	    };
	    // common logic across all the fire methods
	    AlignedGridsService.prototype.fireEvent = function (callback) {
	        // if we are already consuming, then we are acting on an event from a master,
	        // so we don't cause a cyclic firing of events
	        if (this.consuming) {
	            return;
	        }
	        // iterate through the aligned grids, and pass each aligned grid service to the callback
	        var otherGrids = this.gridOptionsWrapper.getAlignedGrids();
	        if (otherGrids) {
	            otherGrids.forEach(function (otherGridOptions) {
	                if (otherGridOptions.api) {
	                    var alignedGridService = otherGridOptions.api.__getAlignedGridService();
	                    callback(alignedGridService);
	                }
	            });
	        }
	    };
	    // common logic across all consume methods. very little common logic, however extracting
	    // guarantees consistency across the methods.
	    AlignedGridsService.prototype.onEvent = function (callback) {
	        this.consuming = true;
	        callback();
	        this.consuming = false;
	    };
	    AlignedGridsService.prototype.fireColumnEvent = function (event) {
	        this.fireEvent(function (alignedGridsService) {
	            alignedGridsService.onColumnEvent(event);
	        });
	    };
	    AlignedGridsService.prototype.fireScrollEvent = function (event) {
	        if (event.direction !== 'horizontal') {
	            return;
	        }
	        this.fireEvent(function (alignedGridsService) {
	            alignedGridsService.onScrollEvent(event);
	        });
	    };
	    AlignedGridsService.prototype.onScrollEvent = function (event) {
	        var _this = this;
	        this.onEvent(function () {
	            _this.gridPanel.setHorizontalScrollPosition(event.left);
	        });
	    };
	    AlignedGridsService.prototype.getMasterColumns = function (event) {
	        var result = [];
	        if (event.columns) {
	            event.columns.forEach(function (column) {
	                result.push(column);
	            });
	        }
	        else if (event.column) {
	            result.push(event.column);
	        }
	        return result;
	    };
	    AlignedGridsService.prototype.getColumnIds = function (event) {
	        var result = [];
	        if (event.columns) {
	            event.columns.forEach(function (column) {
	                result.push(column.getColId());
	            });
	        }
	        else if (event.column) {
	            result.push(event.column.getColId());
	        }
	        return result;
	    };
	    AlignedGridsService.prototype.onColumnEvent = function (event) {
	        var _this = this;
	        this.onEvent(function () {
	            switch (event.type) {
	                case events_1.Events.EVENT_COLUMN_MOVED:
	                case events_1.Events.EVENT_COLUMN_VISIBLE:
	                case events_1.Events.EVENT_COLUMN_PINNED:
	                case events_1.Events.EVENT_COLUMN_RESIZED:
	                    var colEvent = event;
	                    _this.processColumnEvent(colEvent);
	                    break;
	                case events_1.Events.EVENT_COLUMN_GROUP_OPENED:
	                    var groupOpenedEvent = event;
	                    _this.processGroupOpenedEvent(groupOpenedEvent);
	                    break;
	                case events_1.Events.EVENT_COLUMN_PIVOT_CHANGED:
	                    // we cannot support pivoting with aligned grids as the columns will be out of sync as the
	                    // grids will have columns created based on the row data of the grid.
	                    console.warn('ag-Grid: pivoting is not supported with aligned grids. ' +
	                        'You can only use one of these features at a time in a grid.');
	                    break;
	            }
	        });
	    };
	    AlignedGridsService.prototype.processGroupOpenedEvent = function (groupOpenedEvent) {
	        // likewise for column group
	        var masterColumnGroup = groupOpenedEvent.columnGroup;
	        var otherColumnGroup;
	        if (masterColumnGroup) {
	            var groupId = masterColumnGroup.getGroupId();
	            otherColumnGroup = this.columnController.getOriginalColumnGroup(groupId);
	        }
	        if (masterColumnGroup && !otherColumnGroup) {
	            return;
	        }
	        this.logger.log('onColumnEvent-> processing ' + groupOpenedEvent + ' expanded = ' + masterColumnGroup.isExpanded());
	        this.columnController.setColumnGroupOpened(otherColumnGroup, masterColumnGroup.isExpanded(), "alignedGridChanged");
	    };
	    AlignedGridsService.prototype.processColumnEvent = function (colEvent) {
	        var _this = this;
	        // the column in the event is from the master grid. need to
	        // look up the equivalent from this (other) grid
	        var masterColumn = colEvent.column;
	        var otherColumn;
	        if (masterColumn) {
	            otherColumn = this.columnController.getPrimaryColumn(masterColumn.getColId());
	        }
	        // if event was with respect to a master column, that is not present in this
	        // grid, then we ignore the event
	        if (masterColumn && !otherColumn) {
	            return;
	        }
	        // in time, all the methods below should use the column ids, it's a more generic way
	        // of handling columns, and also allows for single or multi column events
	        var columnIds = this.getColumnIds(colEvent);
	        var masterColumns = this.getMasterColumns(colEvent);
	        switch (colEvent.type) {
	            case events_1.Events.EVENT_COLUMN_MOVED:
	                var movedEvent = colEvent;
	                this.logger.log("onColumnEvent-> processing " + colEvent.type + " toIndex = " + movedEvent.toIndex);
	                this.columnController.moveColumns(columnIds, movedEvent.toIndex, "alignedGridChanged");
	                break;
	            case events_1.Events.EVENT_COLUMN_VISIBLE:
	                var visibleEvent = colEvent;
	                this.logger.log("onColumnEvent-> processing " + colEvent.type + " visible = " + visibleEvent.visible);
	                this.columnController.setColumnsVisible(columnIds, visibleEvent.visible, "alignedGridChanged");
	                break;
	            case events_1.Events.EVENT_COLUMN_PINNED:
	                var pinnedEvent = colEvent;
	                this.logger.log("onColumnEvent-> processing " + colEvent.type + " pinned = " + pinnedEvent.pinned);
	                this.columnController.setColumnsPinned(columnIds, pinnedEvent.pinned, "alignedGridChanged");
	                break;
	            case events_1.Events.EVENT_COLUMN_RESIZED:
	                var resizedEvent_1 = colEvent;
	                masterColumns.forEach(function (column) {
	                    _this.logger.log("onColumnEvent-> processing " + colEvent.type + " actualWidth = " + column.getActualWidth());
	                    _this.columnController.setColumnWidth(column.getColId(), column.getActualWidth(), false, resizedEvent_1.finished, "alignedGridChanged");
	                });
	                break;
	        }
	        var isVerticalScrollShowing = this.gridPanel.isVerticalScrollShowing();
	        var alignedGrids = this.gridOptionsWrapper.getAlignedGrids();
	        alignedGrids.forEach(function (grid) {
	            grid.api.setAlwaysShowVerticalScroll(isVerticalScrollShowing);
	        });
	    };
	    __decorate([
	        context_3.Autowired('gridOptionsWrapper'),
	        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
	    ], AlignedGridsService.prototype, "gridOptionsWrapper", void 0);
	    __decorate([
	        context_3.Autowired('columnController'),
	        __metadata("design:type", columnController_1.ColumnController)
	    ], AlignedGridsService.prototype, "columnController", void 0);
	    __decorate([
	        context_3.Autowired('eventService'),
	        __metadata("design:type", eventService_1.EventService)
	    ], AlignedGridsService.prototype, "eventService", void 0);
	    __decorate([
	        __param(0, context_2.Qualifier('loggerFactory')),
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", [logger_1.LoggerFactory]),
	        __metadata("design:returntype", void 0)
	    ], AlignedGridsService.prototype, "setBeans", null);
	    __decorate([
	        context_4.PostConstruct,
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", []),
	        __metadata("design:returntype", void 0)
	    ], AlignedGridsService.prototype, "init", null);
	    AlignedGridsService = __decorate([
	        context_1.Bean('alignedGridsService')
	    ], AlignedGridsService);
	    return AlignedGridsService;
	}());
	exports.AlignedGridsService = AlignedGridsService;


/***/ }),
/* 2439 */
/***/ (function(module, exports) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var ColDefUtil = /** @class */ (function () {
	    function ColDefUtil() {
	    }
	    ColDefUtil.STRING_PROPERTIES = [
	        'headerName',
	        'columnGroupShow',
	        'headerClass',
	        'toolPanelClass',
	        'headerValueGetter',
	        'pivotKeys',
	        'groupId',
	        'colId',
	        'sort',
	        'field',
	        'type',
	        'tooltipComponent',
	        'tooltipField',
	        'headerTooltip',
	        'cellClass',
	        'showRowGroup',
	        'template',
	        'templateUrl',
	        'filter',
	        'aggFunc',
	        'cellRenderer',
	        'cellEditor',
	        'pinned',
	        'chartDataType'
	    ];
	    ColDefUtil.OBJECT_PROPERTIES = [
	        'headerGroupComponent',
	        'headerGroupComponentFramework',
	        'headerGroupComponentParams',
	        'cellStyle',
	        'cellRendererParams',
	        'cellEditorFramework',
	        'cellEditorParams',
	        'pinnedRowCellRendererFramework',
	        'pinnedRowCellRendererParams',
	        'filterFramework',
	        'filterParams',
	        'pivotValueColumn',
	        'headerComponent',
	        'headerComponentFramework',
	        'headerComponentParams',
	        'floatingFilterComponent',
	        'floatingFilterComponentParams',
	        'floatingFilterComponentFramework',
	        'tooltipComponent',
	        'tooltipComponentParams',
	        'tooltipComponentFramework',
	        'refData'
	    ];
	    ColDefUtil.ARRAY_PROPERTIES = [
	        'children',
	        'sortingOrder',
	        'allowedAggFuncs',
	        'menuTabs',
	        'pivotTotalColumnIds',
	        'cellClassRules',
	        'icons'
	    ];
	    ColDefUtil.NUMBER_PROPERTIES = [
	        'sortedAt',
	        'width',
	        'minWidth',
	        'maxWidth',
	        'rowGroupIndex',
	        'pivotIndex'
	    ];
	    ColDefUtil.BOOLEAN_PROPERTIES = [
	        'suppressCellFlash',
	        'suppressToolPanel',
	        'openByDefault',
	        'marryChildren',
	        'hide',
	        'rowGroup',
	        'pivot',
	        'checkboxSelection',
	        'headerCheckboxSelection',
	        'headerCheckboxSelectionFilteredOnly',
	        'suppressMenu',
	        'suppressSorting',
	        'suppressMovable',
	        'suppressFilter',
	        'lockPosition',
	        'lockVisible',
	        'lockPinned',
	        'unSortIcon',
	        'suppressSizeToFit',
	        'suppressResize',
	        'suppressAutoSize',
	        'enableRowGroup',
	        'enablePivot',
	        'enableValue',
	        'editable',
	        'suppressPaste',
	        'suppressNavigable',
	        'enableCellChangeFlash',
	        'rowDrag',
	        'dndSource',
	        'autoHeight',
	        'sortable',
	        'resizable',
	        'singleClickEdit'
	    ];
	    ColDefUtil.FUNCTION_PROPERTIES = [
	        'dndSourceOnRowDrag',
	        'valueGetter',
	        'valueSetter',
	        'filterValueGetter',
	        'keyCreator',
	        'cellRenderer',
	        'cellRendererFramework',
	        'pinnedRowCellRenderer',
	        'valueFormatter',
	        'pinnedRowValueFormatter',
	        'valueParser',
	        'comparator',
	        'equals',
	        'pivotComparator',
	        'suppressKeyboardEvent',
	        'colSpan',
	        'rowSpan',
	        'getQuickFilterText',
	        'newValueHandler',
	        'onCellValueChanged',
	        'onCellClicked',
	        'onCellDoubleClicked',
	        'onCellContextMenu',
	        'tooltip',
	        'tooltipValueGetter',
	        'tooltipComponent',
	        'tooltipComponentFramework',
	        'cellRendererSelector',
	        'cellEditorSelector'
	    ];
	    ColDefUtil.ALL_PROPERTIES = ColDefUtil.ARRAY_PROPERTIES
	        .concat(ColDefUtil.OBJECT_PROPERTIES)
	        .concat(ColDefUtil.STRING_PROPERTIES)
	        .concat(ColDefUtil.NUMBER_PROPERTIES)
	        .concat(ColDefUtil.FUNCTION_PROPERTIES)
	        .concat(ColDefUtil.BOOLEAN_PROPERTIES);
	    // used when doing property checks - this causes noise when using frameworks which can add their own fw specific
	    // properties to colDefs, gridOptions etc
	    ColDefUtil.FRAMEWORK_PROPERTIES = ['__ob__', '__metadata__', 'mappedColumnProperties', 'hasChildColumns',
	        'toColDef', 'createColDefFromGridColumn'];
	    return ColDefUtil;
	}());
	exports.ColDefUtil = ColDefUtil;


/***/ }),
/* 2440 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var context_1 = __webpack_require__(2333);
	var beans_1 = __webpack_require__(2373);
	var cellComp_1 = __webpack_require__(2352);
	var columnController_1 = __webpack_require__(2341);
	var utils_1 = __webpack_require__(2325);
	var AutoHeightCalculator = /** @class */ (function () {
	    function AutoHeightCalculator() {
	    }
	    AutoHeightCalculator.prototype.registerGridComp = function (gridPanel) {
	        this.gridPanel = gridPanel;
	    };
	    AutoHeightCalculator.prototype.getPreferredHeightForRow = function (rowNode) {
	        var _this = this;
	        if (!this.eDummyContainer) {
	            this.eDummyContainer = document.createElement('div');
	            // so any styles on row also get applied in dummy, otherwise
	            // the content in dummy may differ to the real
	            utils_1._.addCssClass(this.eDummyContainer, 'ag-row ag-row-no-focus');
	        }
	        // we put the dummy into the body container, so it will inherit all the
	        // css styles that the real cells are inheriting
	        var eBodyContainer = this.gridPanel.getCenterContainer();
	        eBodyContainer.appendChild(this.eDummyContainer);
	        var cellComps = [];
	        var autoRowHeightCols = this.columnController.getAllAutoRowHeightCols();
	        var visibleAutoRowHeightCols = autoRowHeightCols.filter(function (col) { return col.isVisible(); });
	        visibleAutoRowHeightCols.forEach(function (col) {
	            var cellComp = new cellComp_1.CellComp(_this.$scope, _this.beans, col, rowNode, null, true, false);
	            cellComp.setParentRow(_this.eDummyContainer);
	            cellComps.push(cellComp);
	        });
	        var template = cellComps.map(function (cellComp) { return cellComp.getCreateTemplate(); }).join(' ');
	        this.eDummyContainer.innerHTML = template;
	        // this gets any cellComps that are using components to put the components in
	        cellComps.forEach(function (cellComp) { return cellComp.afterAttached(); });
	        // we should be able to just take the height of the row at this point, however
	        // the row isn't expanding to cover the cell heights, i don't know why, i couldn't
	        // figure it out so instead looking at the individual cells instead
	        var maxCellHeight = 0;
	        for (var i = 0; i < this.eDummyContainer.children.length; i++) {
	            var child = this.eDummyContainer.children[i];
	            if (child.offsetHeight > maxCellHeight) {
	                maxCellHeight = child.offsetHeight;
	            }
	        }
	        // we are finished with the dummy container, so get rid of it
	        eBodyContainer.removeChild(this.eDummyContainer);
	        cellComps.forEach(function (cellComp) {
	            // dunno why we need to detach first, doing it here to be consistent with code in RowComp
	            cellComp.detach();
	            cellComp.destroy();
	        });
	        // in case anything left over from last time
	        utils_1._.clearElement(this.eDummyContainer);
	        return maxCellHeight;
	    };
	    __decorate([
	        context_1.Autowired('beans'),
	        __metadata("design:type", beans_1.Beans)
	    ], AutoHeightCalculator.prototype, "beans", void 0);
	    __decorate([
	        context_1.Autowired("$scope"),
	        __metadata("design:type", Object)
	    ], AutoHeightCalculator.prototype, "$scope", void 0);
	    __decorate([
	        context_1.Autowired("columnController"),
	        __metadata("design:type", columnController_1.ColumnController)
	    ], AutoHeightCalculator.prototype, "columnController", void 0);
	    AutoHeightCalculator = __decorate([
	        context_1.Bean('autoHeightCalculator')
	    ], AutoHeightCalculator);
	    return AutoHeightCalculator;
	}());
	exports.AutoHeightCalculator = AutoHeightCalculator;


/***/ }),
/* 2441 */
/***/ (function(module, exports) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var SideBarDefParser = /** @class */ (function () {
	    function SideBarDefParser() {
	    }
	    SideBarDefParser.parse = function (toParse) {
	        if (!toParse) {
	            return null;
	        }
	        if (toParse === true) {
	            return {
	                toolPanels: [
	                    SideBarDefParser.DEFAULT_COLUMN_COMP,
	                    SideBarDefParser.DEFAULT_FILTER_COMP,
	                ],
	                defaultToolPanel: 'columns'
	            };
	        }
	        if (typeof toParse === 'string') {
	            return SideBarDefParser.parse([toParse]);
	        }
	        if (Array.isArray(toParse)) {
	            var comps_1 = [];
	            toParse.forEach(function (key) {
	                var lookupResult = SideBarDefParser.DEFAULT_BY_KEY[key];
	                if (!lookupResult) {
	                    console.warn("ag-grid: the key " + key + " is not a valid key for specifying a tool panel, valid keys are: " + Object.keys(SideBarDefParser.DEFAULT_BY_KEY).join(','));
	                    return;
	                }
	                comps_1.push(lookupResult);
	            });
	            if (comps_1.length === 0) {
	                return null;
	            }
	            return {
	                toolPanels: comps_1,
	                defaultToolPanel: comps_1[0].id
	            };
	        }
	        var result = {
	            toolPanels: SideBarDefParser.parseComponents(toParse.toolPanels),
	            defaultToolPanel: toParse.defaultToolPanel,
	            hiddenByDefault: toParse.hiddenByDefault
	        };
	        return result;
	    };
	    SideBarDefParser.parseComponents = function (from) {
	        var result = [];
	        from.forEach(function (it) {
	            var toAdd = null;
	            if (typeof it === 'string') {
	                var lookupResult = SideBarDefParser.DEFAULT_BY_KEY[it];
	                if (!lookupResult) {
	                    console.warn("ag-grid: the key " + it + " is not a valid key for specifying a tool panel, valid keys are: " + Object.keys(SideBarDefParser.DEFAULT_BY_KEY).join(','));
	                    return;
	                }
	                toAdd = lookupResult;
	            }
	            else {
	                toAdd = it;
	            }
	            result.push(toAdd);
	        });
	        return result;
	    };
	    SideBarDefParser.DEFAULT_COLUMN_COMP = {
	        id: 'columns',
	        labelDefault: 'Columns',
	        labelKey: 'columns',
	        iconKey: 'columns',
	        toolPanel: 'agColumnsToolPanel',
	    };
	    SideBarDefParser.DEFAULT_FILTER_COMP = {
	        id: 'filters',
	        labelDefault: 'Filters',
	        labelKey: 'filters',
	        iconKey: 'filter',
	        toolPanel: 'agFiltersToolPanel',
	    };
	    SideBarDefParser.DEFAULT_BY_KEY = {
	        columns: SideBarDefParser.DEFAULT_COLUMN_COMP,
	        filters: SideBarDefParser.DEFAULT_FILTER_COMP
	    };
	    return SideBarDefParser;
	}());
	exports.SideBarDefParser = SideBarDefParser;


/***/ }),
/* 2442 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	// class returns a unique id to use for the column. it checks the existing columns, and if the requested
	// id is already taken, it will start appending numbers until it gets a unique id.
	// eg, if the col field is 'name', it will try ids: {name, name_1, name_2...}
	// if no field or id provided in the col, it will try the ids of natural numbers
	var utils_1 = __webpack_require__(2325);
	var ColumnKeyCreator = /** @class */ (function () {
	    function ColumnKeyCreator() {
	        this.existingKeys = [];
	    }
	    ColumnKeyCreator.prototype.addExistingKeys = function (keys) {
	        this.existingKeys = this.existingKeys.concat(keys);
	    };
	    ColumnKeyCreator.prototype.getUniqueKey = function (colId, colField) {
	        // in case user passed in number for colId, convert to string
	        colId = utils_1._.toStringOrNull(colId);
	        var count = 0;
	        while (true) {
	            var idToTry = void 0;
	            if (colId) {
	                idToTry = colId;
	                if (count !== 0) {
	                    idToTry += '_' + count;
	                }
	            }
	            else if (colField) {
	                idToTry = colField;
	                if (count !== 0) {
	                    idToTry += '_' + count;
	                }
	            }
	            else {
	                idToTry = '' + count;
	            }
	            if (this.existingKeys.indexOf(idToTry) < 0) {
	                this.existingKeys.push(idToTry);
	                return idToTry;
	            }
	            count++;
	        }
	    };
	    return ColumnKeyCreator;
	}());
	exports.ColumnKeyCreator = ColumnKeyCreator;


/***/ }),
/* 2443 */
/***/ (function(module, exports) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.DefaultColumnTypes = {
	    numericColumn: {
	        headerClass: "ag-numeric-header",
	        cellClass: "ag-numeric-cell"
	    }
	};


/***/ }),
/* 2444 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var grid_1 = __webpack_require__(2445);
	function initialiseAgGridWithAngular1(angular) {
	    var angularModule = angular.module("agGrid", []);
	    angularModule.directive("agGrid", function () {
	        return {
	            restrict: "A",
	            controller: ['$element', '$scope', '$compile', '$attrs', AngularDirectiveController],
	            scope: true
	        };
	    });
	}
	exports.initialiseAgGridWithAngular1 = initialiseAgGridWithAngular1;
	function AngularDirectiveController($element, $scope, $compile, $attrs) {
	    var gridOptions;
	    var quickFilterOnScope;
	    var keyOfGridInScope = $attrs.agGrid;
	    quickFilterOnScope = keyOfGridInScope + '.quickFilterText';
	    gridOptions = $scope.$eval(keyOfGridInScope);
	    if (!gridOptions) {
	        console.warn("WARNING - grid options for ag-Grid not found. Please ensure the attribute ag-grid points to a valid object on the scope");
	        return;
	    }
	    var eGridDiv = $element[0];
	    var gridParams = {
	        $scope: $scope,
	        $compile: $compile,
	        quickFilterOnScope: quickFilterOnScope
	    };
	    var grid = new grid_1.Grid(eGridDiv, gridOptions, gridParams);
	    $scope.$on("$destroy", function () {
	        grid.destroy();
	        grid = null;
	    });
	}


/***/ }),
/* 2445 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var gridOptionsWrapper_1 = __webpack_require__(2324);
	var selectionController_1 = __webpack_require__(2357);
	var columnApi_1 = __webpack_require__(2346);
	var columnController_1 = __webpack_require__(2341);
	var rowRenderer_1 = __webpack_require__(2350);
	var headerRootComp_1 = __webpack_require__(2446);
	var filterManager_1 = __webpack_require__(2378);
	var valueService_1 = __webpack_require__(2359);
	var eventService_1 = __webpack_require__(2331);
	var gridPanel_1 = __webpack_require__(2456);
	var gridApi_1 = __webpack_require__(2338);
	var columnFactory_1 = __webpack_require__(2323);
	var displayedGroupCreator_1 = __webpack_require__(2348);
	var expressionService_1 = __webpack_require__(2347);
	var templateService_1 = __webpack_require__(2374);
	var popupService_1 = __webpack_require__(2379);
	var logger_1 = __webpack_require__(2332);
	var columnUtils_1 = __webpack_require__(2344);
	var autoWidthCalculator_1 = __webpack_require__(2349);
	var horizontalResizeService_1 = __webpack_require__(2425);
	var context_1 = __webpack_require__(2333);
	var csvCreator_1 = __webpack_require__(2339);
	var gridCore_1 = __webpack_require__(2463);
	var standardMenu_1 = __webpack_require__(2464);
	var dragAndDropService_1 = __webpack_require__(2363);
	var dragService_1 = __webpack_require__(2364);
	var sortController_1 = __webpack_require__(2391);
	var focusedCellController_1 = __webpack_require__(2369);
	var mouseEventService_1 = __webpack_require__(2396);
	var cellNavigationService_1 = __webpack_require__(2370);
	var filterStage_1 = __webpack_require__(2465);
	var sortStage_1 = __webpack_require__(2468);
	var flattenStage_1 = __webpack_require__(2470);
	var events_1 = __webpack_require__(2335);
	var infiniteRowModel_1 = __webpack_require__(2471);
	var clientSideRowModel_1 = __webpack_require__(2477);
	var cellRendererFactory_1 = __webpack_require__(2376);
	var valueFormatterService_1 = __webpack_require__(2395);
	var agCheckbox_1 = __webpack_require__(2428);
	var agRadioButton_1 = __webpack_require__(2479);
	var vanillaFrameworkOverrides_1 = __webpack_require__(2480);
	var scrollVisibleService_1 = __webpack_require__(2455);
	var downloader_1 = __webpack_require__(2436);
	var xmlFactory_1 = __webpack_require__(2481);
	var gridSerializer_1 = __webpack_require__(2340);
	var stylingService_1 = __webpack_require__(2416);
	var columnHoverService_1 = __webpack_require__(2417);
	var columnAnimationService_1 = __webpack_require__(2375);
	var sortService_1 = __webpack_require__(2469);
	var filterService_1 = __webpack_require__(2466);
	var autoGroupColService_1 = __webpack_require__(2435);
	var paginationProxy_1 = __webpack_require__(2372);
	var paginationAutoPageSizeService_1 = __webpack_require__(2458);
	var immutableService_1 = __webpack_require__(2437);
	var constants_1 = __webpack_require__(2328);
	var valueCache_1 = __webpack_require__(2360);
	var changeDetectionService_1 = __webpack_require__(2482);
	var alignedGridsService_1 = __webpack_require__(2438);
	var pinnedRowModel_1 = __webpack_require__(2371);
	var userComponentFactory_1 = __webpack_require__(2380);
	var userComponentRegistry_1 = __webpack_require__(2381);
	var agComponentUtils_1 = __webpack_require__(2414);
	var componentMetadataProvider_1 = __webpack_require__(2415);
	var beans_1 = __webpack_require__(2373);
	var environment_1 = __webpack_require__(2365);
	var animationFrameService_1 = __webpack_require__(2418);
	var navigationService_1 = __webpack_require__(2459);
	var maxDivHeightScaler_1 = __webpack_require__(2419);
	var selectableService_1 = __webpack_require__(2467);
	var autoHeightCalculator_1 = __webpack_require__(2440);
	var paginationComp_1 = __webpack_require__(2483);
	var resizeObserverService_1 = __webpack_require__(2462);
	var zipContainer_1 = __webpack_require__(2484);
	var tooltipManager_1 = __webpack_require__(2420);
	var overlayWrapperComponent_1 = __webpack_require__(2461);
	var agGroupComponent_1 = __webpack_require__(2485);
	var agDialog_1 = __webpack_require__(2486);
	var agPanel_1 = __webpack_require__(2487);
	var agInputTextField_1 = __webpack_require__(2488);
	var agInputTextArea_1 = __webpack_require__(2489);
	var agSlider_1 = __webpack_require__(2490);
	var utils_1 = __webpack_require__(2325);
	var agColorPicker_1 = __webpack_require__(2493);
	var agInputNumberField_1 = __webpack_require__(2492);
	var agInputRange_1 = __webpack_require__(2491);
	var agSelect_1 = __webpack_require__(2496);
	var agAngleSelect_1 = __webpack_require__(2497);
	var agToggleButton_1 = __webpack_require__(2498);
	var detailRowCompCache_1 = __webpack_require__(2421);
	var rowPosition_1 = __webpack_require__(2423);
	var cellPosition_1 = __webpack_require__(2422);
	var Grid = /** @class */ (function () {
	    function Grid(eGridDiv, gridOptions, params) {
	        if (!eGridDiv) {
	            console.error('ag-Grid: no div element provided to the grid');
	        }
	        if (!gridOptions) {
	            console.error('ag-Grid: no gridOptions provided to the grid');
	        }
	        this.gridOptions = gridOptions;
	        var rowModelClass = this.getRowModelClass(gridOptions);
	        var enterprise = !utils_1._.missingOrEmpty(Grid.enterpriseBeans);
	        var moduleBeans = this.extractModuleEntity(Grid.modulesToInclude, function (module) { return module.beans ? module.beans : []; });
	        var moduleEnterpriseBeans = this.extractModuleEntity(Grid.modulesToInclude, function (module) { return module.enterpriseBeans ? module.enterpriseBeans : []; });
	        var moduleEnterpriseComponents = this.extractModuleEntity(Grid.modulesToInclude, function (module) { return module.enterpriseComponents ? module.enterpriseComponents : []; });
	        var modulesEnterpriseDefaultComponents = this.extractModuleEntity(Grid.modulesToInclude, function (module) { return module.enterpriseDefaultComponents ? module.enterpriseDefaultComponents : []; });
	        var frameworkOverrides = params ? params.frameworkOverrides : null;
	        if (utils_1._.missing(frameworkOverrides)) {
	            frameworkOverrides = new vanillaFrameworkOverrides_1.VanillaFrameworkOverrides();
	        }
	        var overrideBeans = [];
	        if (Grid.enterpriseBeans) {
	            overrideBeans = overrideBeans.concat(Grid.enterpriseBeans)
	                .concat(moduleEnterpriseBeans);
	        }
	        if (Grid.frameworkBeans) {
	            overrideBeans = overrideBeans.concat(Grid.frameworkBeans);
	        }
	        var seed = {
	            enterprise: enterprise,
	            gridOptions: gridOptions,
	            eGridDiv: eGridDiv,
	            $scope: params ? params.$scope : null,
	            $compile: params ? params.$compile : null,
	            quickFilterOnScope: params ? params.quickFilterOnScope : null,
	            globalEventListener: params ? params.globalEventListener : null,
	            frameworkOverrides: frameworkOverrides
	        };
	        if (params && params.seedBeanInstances) {
	            utils_1._.assign(seed, params.seedBeanInstances);
	        }
	        var components = [
	            { componentName: 'AgCheckbox', theClass: agCheckbox_1.AgCheckbox },
	            { componentName: 'AgRadioButton', theClass: agRadioButton_1.AgRadioButton },
	            { componentName: 'AgToggleButton', theClass: agToggleButton_1.AgToggleButton },
	            { componentName: 'AgInputTextField', theClass: agInputTextField_1.AgInputTextField },
	            { componentName: 'AgInputTextArea', theClass: agInputTextArea_1.AgInputTextArea },
	            { componentName: 'AgInputNumberField', theClass: agInputNumberField_1.AgInputNumberField },
	            { componentName: 'AgInputRange', theClass: agInputRange_1.AgInputRange },
	            { componentName: 'AgSelect', theClass: agSelect_1.AgSelect },
	            { componentName: 'AgSlider', theClass: agSlider_1.AgSlider },
	            { componentName: 'AgAngleSelect', theClass: agAngleSelect_1.AgAngleSelect },
	            { componentName: 'AgColorPicker', theClass: agColorPicker_1.AgColorPicker },
	            { componentName: 'AgGridComp', theClass: gridPanel_1.GridPanel },
	            { componentName: 'AgHeaderRoot', theClass: headerRootComp_1.HeaderRootComp },
	            { componentName: 'AgPagination', theClass: paginationComp_1.PaginationComp },
	            { componentName: 'AgOverlayWrapper', theClass: overlayWrapperComponent_1.OverlayWrapperComponent },
	            { componentName: 'AgGroupComponent', theClass: agGroupComponent_1.AgGroupComponent },
	            { componentName: 'AgPanel', theClass: agPanel_1.AgPanel },
	            { componentName: 'AgDialog', theClass: agDialog_1.AgDialog }
	        ];
	        if (Grid.enterpriseComponents) {
	            components = components.concat(Grid.enterpriseComponents)
	                .concat(moduleEnterpriseComponents);
	        }
	        var contextParams = {
	            overrideBeans: overrideBeans,
	            seed: seed,
	            //Careful with the order of the beans here, there are dependencies between them that need to be kept
	            beans: [
	                // this should only contain SERVICES, it should NEVER contain COMPONENTS
	                rowModelClass, beans_1.Beans, rowPosition_1.RowPositionUtils, cellPosition_1.CellPositionUtils,
	                paginationAutoPageSizeService_1.PaginationAutoPageSizeService, gridApi_1.GridApi, userComponentRegistry_1.UserComponentRegistry, agComponentUtils_1.AgComponentUtils,
	                componentMetadataProvider_1.ComponentMetadataProvider, resizeObserverService_1.ResizeObserverService, userComponentRegistry_1.UserComponentRegistry, userComponentFactory_1.UserComponentFactory,
	                maxDivHeightScaler_1.MaxDivHeightScaler, autoHeightCalculator_1.AutoHeightCalculator, cellRendererFactory_1.CellRendererFactory, horizontalResizeService_1.HorizontalResizeService,
	                pinnedRowModel_1.PinnedRowModel, dragService_1.DragService, displayedGroupCreator_1.DisplayedGroupCreator, eventService_1.EventService, gridOptionsWrapper_1.GridOptionsWrapper, popupService_1.PopupService,
	                selectionController_1.SelectionController, filterManager_1.FilterManager, columnController_1.ColumnController, paginationProxy_1.PaginationProxy, rowRenderer_1.RowRenderer, expressionService_1.ExpressionService,
	                columnFactory_1.ColumnFactory, csvCreator_1.CsvCreator, downloader_1.Downloader, xmlFactory_1.XmlFactory, gridSerializer_1.GridSerializer, templateService_1.TemplateService, alignedGridsService_1.AlignedGridsService,
	                navigationService_1.NavigationService, popupService_1.PopupService, valueCache_1.ValueCache, valueService_1.ValueService, logger_1.LoggerFactory, columnUtils_1.ColumnUtils, autoWidthCalculator_1.AutoWidthCalculator,
	                standardMenu_1.StandardMenuFactory, dragAndDropService_1.DragAndDropService, columnApi_1.ColumnApi, focusedCellController_1.FocusedCellController, mouseEventService_1.MouseEventService, environment_1.Environment,
	                cellNavigationService_1.CellNavigationService, filterStage_1.FilterStage, sortStage_1.SortStage, flattenStage_1.FlattenStage, filterService_1.FilterService,
	                valueFormatterService_1.ValueFormatterService, stylingService_1.StylingService, scrollVisibleService_1.ScrollVisibleService, sortController_1.SortController,
	                columnHoverService_1.ColumnHoverService, columnAnimationService_1.ColumnAnimationService, sortService_1.SortService, selectableService_1.SelectableService, autoGroupColService_1.AutoGroupColService,
	                immutableService_1.ImmutableService, changeDetectionService_1.ChangeDetectionService, animationFrameService_1.AnimationFrameService, tooltipManager_1.TooltipManager, zipContainer_1.ZipContainer,
	                detailRowCompCache_1.DetailRowCompCache
	            ].concat(moduleBeans),
	            components: components,
	            enterpriseDefaultComponents: Grid.enterpriseDefaultComponents.concat(modulesEnterpriseDefaultComponents),
	            registeredModules: Grid.modulesToInclude.map(function (module) { return module.moduleName; }),
	            debug: !!gridOptions.debug
	        };
	        this.logger = new logger_1.Logger('ag-Grid', function () { return gridOptions.debug; });
	        var contextLogger = new logger_1.Logger('Context', function () { return contextParams.debug; });
	        this.context = new context_1.Context(contextParams, contextLogger);
	        var gridCore = new gridCore_1.GridCore();
	        this.context.wireBean(gridCore);
	        this.setColumnsAndData();
	        this.dispatchGridReadyEvent(gridOptions);
	        this.logger.log("initialised successfully, enterprise = " + enterprise);
	    }
	    Grid.setEnterpriseBeans = function (enterpriseBeans, rowModelClasses) {
	        Grid.enterpriseBeans = enterpriseBeans;
	        // the enterprise can inject additional row models. this is how it injects the viewportRowModel
	        utils_1._.iterateObject(rowModelClasses, function (key, value) { return Grid.RowModelClasses[key] = value; });
	    };
	    Grid.setEnterpriseComponents = function (components) {
	        Grid.enterpriseComponents = components;
	    };
	    Grid.setFrameworkBeans = function (frameworkBeans) {
	        Grid.frameworkBeans = frameworkBeans;
	    };
	    Grid.setEnterpriseDefaultComponents = function (enterpriseDefaultComponents) {
	        Grid.enterpriseDefaultComponents = enterpriseDefaultComponents;
	    };
	    Grid.addModule = function (modulesToInclude) {
	        var _a;
	        // de-duping would need to be done here (while ensuring order etc)
	        (_a = Grid.modulesToInclude).push.apply(_a, modulesToInclude);
	    };
	    Grid.prototype.extractModuleEntity = function (moduleEntities, extractor) {
	        return [].concat.apply([], moduleEntities.map(extractor));
	    };
	    Grid.prototype.setColumnsAndData = function () {
	        var gridOptionsWrapper = this.context.getBean('gridOptionsWrapper');
	        var columnController = this.context.getBean('columnController');
	        var rowModel = this.context.getBean('rowModel');
	        var columnDefs = gridOptionsWrapper.getColumnDefs();
	        var rowData = gridOptionsWrapper.getRowData();
	        var nothingToSet = utils_1._.missing(columnDefs) && utils_1._.missing(rowData);
	        if (nothingToSet) {
	            return;
	        }
	        if (utils_1._.exists(columnDefs)) {
	            columnController.setColumnDefs(columnDefs, "gridInitializing");
	        }
	        if (utils_1._.exists(rowData) && rowModel.getType() === constants_1.Constants.ROW_MODEL_TYPE_CLIENT_SIDE) {
	            var clientSideRowModel = rowModel;
	            clientSideRowModel.setRowData(rowData);
	        }
	    };
	    Grid.prototype.dispatchGridReadyEvent = function (gridOptions) {
	        var eventService = this.context.getBean('eventService');
	        var readyEvent = {
	            type: events_1.Events.EVENT_GRID_READY,
	            api: gridOptions.api,
	            columnApi: gridOptions.columnApi
	        };
	        eventService.dispatchEvent(readyEvent);
	    };
	    Grid.prototype.getRowModelClass = function (gridOptions) {
	        var rowModelType = gridOptions.rowModelType;
	        //TODO: temporary measure before 'enterprise' is completely removed (similar handling in gridOptionsWrapper is also required)
	        rowModelType = rowModelType === 'enterprise' ? constants_1.Constants.ROW_MODEL_TYPE_SERVER_SIDE : rowModelType;
	        if (utils_1._.exists(rowModelType)) {
	            var rowModelClass = Grid.RowModelClasses[rowModelType];
	            if (utils_1._.exists(rowModelClass)) {
	                return rowModelClass;
	            }
	            else {
	                if (rowModelType === 'normal') {
	                    console.warn("ag-Grid: normal rowModel deprecated. Should now be called client side row model instead.");
	                    return clientSideRowModel_1.ClientSideRowModel;
	                }
	                console.error('ag-Grid: could not find matching row model for rowModelType ' + rowModelType);
	                if (rowModelType === constants_1.Constants.ROW_MODEL_TYPE_VIEWPORT) {
	                    console.error('ag-Grid: rowModelType viewport is only available in ag-Grid Enterprise');
	                }
	                if (rowModelType === constants_1.Constants.ROW_MODEL_TYPE_SERVER_SIDE) {
	                    console.error('ag-Grid: rowModelType server side is only available in ag-Grid Enterprise');
	                }
	            }
	        }
	        return clientSideRowModel_1.ClientSideRowModel;
	    };
	    Grid.prototype.destroy = function () {
	        this.gridOptions.api.destroy();
	    };
	    Grid.enterpriseBeans = [];
	    Grid.enterpriseComponents = [];
	    Grid.enterpriseDefaultComponents = [];
	    Grid.modulesToInclude = [];
	    // the default is ClientSideRowModel, which is also used for pagination.
	    // the enterprise adds viewport to this list.
	    Grid.RowModelClasses = {
	        infinite: infiniteRowModel_1.InfiniteRowModel,
	        clientSide: clientSideRowModel_1.ClientSideRowModel
	    };
	    return Grid;
	}());
	exports.Grid = Grid;


/***/ }),
/* 2446 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var gridOptionsWrapper_1 = __webpack_require__(2324);
	var columnController_1 = __webpack_require__(2341);
	var column_1 = __webpack_require__(2343);
	var context_1 = __webpack_require__(2333);
	var headerContainer_1 = __webpack_require__(2447);
	var eventService_1 = __webpack_require__(2331);
	var events_1 = __webpack_require__(2335);
	var component_1 = __webpack_require__(2353);
	var componentAnnotations_1 = __webpack_require__(2384);
	var gridApi_1 = __webpack_require__(2338);
	var autoWidthCalculator_1 = __webpack_require__(2349);
	var constants_1 = __webpack_require__(2328);
	var utils_1 = __webpack_require__(2325);
	var HeaderRootComp = /** @class */ (function (_super) {
	    __extends(HeaderRootComp, _super);
	    function HeaderRootComp() {
	        return _super.call(this, HeaderRootComp.TEMPLATE) || this;
	    }
	    HeaderRootComp.prototype.registerGridComp = function (gridPanel) {
	        this.gridPanel = gridPanel;
	        this.childContainers.forEach(function (c) { return c.registerGridComp(gridPanel); });
	    };
	    HeaderRootComp.prototype.postConstruct = function () {
	        var _this = this;
	        this.printLayout = this.gridOptionsWrapper.getDomLayout() === constants_1.Constants.DOM_LAYOUT_PRINT;
	        this.gridApi.registerHeaderRootComp(this);
	        this.autoWidthCalculator.registerHeaderRootComp(this);
	        var centerContainer = new headerContainer_1.HeaderContainer(this.eHeaderContainer, this.eHeaderViewport, null);
	        var pinnedLeftContainer = new headerContainer_1.HeaderContainer(this.ePinnedLeftHeader, null, column_1.Column.PINNED_LEFT);
	        var pinnedRightContainer = new headerContainer_1.HeaderContainer(this.ePinnedRightHeader, null, column_1.Column.PINNED_RIGHT);
	        this.childContainers = [centerContainer, pinnedLeftContainer, pinnedRightContainer];
	        this.childContainers.forEach(function (container) { return _this.getContext().wireBean(container); });
	        // shotgun way to get labels to change, eg from sum(amount) to avg(amount)
	        this.addDestroyableEventListener(this.eventService, events_1.Events.EVENT_COLUMN_VALUE_CHANGED, this.refreshHeader.bind(this));
	        this.addDestroyableEventListener(this.gridOptionsWrapper, gridOptionsWrapper_1.GridOptionsWrapper.PROP_DOM_LAYOUT, this.onDomLayoutChanged.bind(this));
	        // for setting ag-pivot-on / ag-pivot-off CSS classes
	        this.addDestroyableEventListener(this.eventService, events_1.Events.EVENT_COLUMN_PIVOT_MODE_CHANGED, this.onPivotModeChanged.bind(this));
	        this.onPivotModeChanged();
	        this.addPreventHeaderScroll();
	        if (this.columnController.isReady()) {
	            this.refreshHeader();
	        }
	    };
	    HeaderRootComp.prototype.onDomLayoutChanged = function () {
	        var newValue = this.gridOptionsWrapper.getDomLayout() === constants_1.Constants.DOM_LAYOUT_PRINT;
	        if (this.printLayout !== newValue) {
	            this.printLayout = newValue;
	            this.refreshHeader();
	        }
	    };
	    HeaderRootComp.prototype.setHorizontalScroll = function (offset) {
	        this.eHeaderContainer.style.transform = "translateX(" + offset + "px)";
	    };
	    HeaderRootComp.prototype.forEachHeaderElement = function (callback) {
	        this.childContainers.forEach(function (childContainer) { return childContainer.forEachHeaderElement(callback); });
	    };
	    HeaderRootComp.prototype.destroy = function () {
	        _super.prototype.destroy.call(this);
	        this.childContainers.forEach(function (container) { return container.destroy(); });
	    };
	    HeaderRootComp.prototype.refreshHeader = function () {
	        this.childContainers.forEach(function (container) { return container.refresh(); });
	    };
	    HeaderRootComp.prototype.onPivotModeChanged = function () {
	        var pivotMode = this.columnController.isPivotMode();
	        utils_1._.addOrRemoveCssClass(this.getGui(), 'ag-pivot-on', pivotMode);
	        utils_1._.addOrRemoveCssClass(this.getGui(), 'ag-pivot-off', !pivotMode);
	    };
	    HeaderRootComp.prototype.setHeight = function (height) {
	        var px = height + "px";
	        this.getGui().style.height = px;
	        this.getGui().style.minHeight = px;
	    };
	    // if the user is in floating filter and hits tab a few times, the header can
	    // end up scrolling to show items off the screen, leaving the grid and header
	    // and the grid columns no longer in sync.
	    HeaderRootComp.prototype.addPreventHeaderScroll = function () {
	        var _this = this;
	        this.addDestroyableEventListener(this.eHeaderViewport, 'scroll', function () {
	            // if the header scrolls, the header will be out of sync. so we reset the
	            // header scroll, and then scroll the body, which will in turn set the offset
	            // on the header, giving the impression that the header scrolled as expected.
	            var scrollLeft = _this.eHeaderViewport.scrollLeft;
	            if (scrollLeft !== 0) {
	                _this.gridPanel.scrollHorizontally(scrollLeft);
	                _this.eHeaderViewport.scrollLeft = 0;
	            }
	        });
	    };
	    HeaderRootComp.prototype.setHeaderContainerWidth = function (width) {
	        this.eHeaderContainer.style.width = width + "px";
	    };
	    HeaderRootComp.prototype.setLeftVisible = function (visible) {
	        utils_1._.setDisplayed(this.ePinnedLeftHeader, visible);
	    };
	    HeaderRootComp.prototype.setRightVisible = function (visible) {
	        utils_1._.setDisplayed(this.ePinnedRightHeader, visible);
	    };
	    HeaderRootComp.prototype.getHeaderRowCount = function () {
	        if (this.childContainers.length === 0) {
	            return 0;
	        }
	        return this.childContainers[0].getRowComps().length;
	    };
	    HeaderRootComp.TEMPLATE = "<div class=\"ag-header\" role=\"presentation\">\n            <div class=\"ag-pinned-left-header\" ref=\"ePinnedLeftHeader\" role=\"presentation\"></div>\n            <div class=\"ag-header-viewport\" ref=\"eHeaderViewport\" role=\"presentation\">\n                <div class=\"ag-header-container\" ref=\"eHeaderContainer\" role=\"rowgroup\"></div>\n            </div>\n            <div class=\"ag-pinned-right-header\" ref=\"ePinnedRightHeader\" role=\"presentation\"></div>\n        </div>";
	    __decorate([
	        componentAnnotations_1.RefSelector('ePinnedLeftHeader'),
	        __metadata("design:type", HTMLElement)
	    ], HeaderRootComp.prototype, "ePinnedLeftHeader", void 0);
	    __decorate([
	        componentAnnotations_1.RefSelector('ePinnedRightHeader'),
	        __metadata("design:type", HTMLElement)
	    ], HeaderRootComp.prototype, "ePinnedRightHeader", void 0);
	    __decorate([
	        componentAnnotations_1.RefSelector('eHeaderContainer'),
	        __metadata("design:type", HTMLElement)
	    ], HeaderRootComp.prototype, "eHeaderContainer", void 0);
	    __decorate([
	        componentAnnotations_1.RefSelector('eHeaderViewport'),
	        __metadata("design:type", HTMLElement)
	    ], HeaderRootComp.prototype, "eHeaderViewport", void 0);
	    __decorate([
	        context_1.Autowired('gridOptionsWrapper'),
	        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
	    ], HeaderRootComp.prototype, "gridOptionsWrapper", void 0);
	    __decorate([
	        context_1.Autowired('columnController'),
	        __metadata("design:type", columnController_1.ColumnController)
	    ], HeaderRootComp.prototype, "columnController", void 0);
	    __decorate([
	        context_1.Autowired('eventService'),
	        __metadata("design:type", eventService_1.EventService)
	    ], HeaderRootComp.prototype, "eventService", void 0);
	    __decorate([
	        context_1.Autowired('gridApi'),
	        __metadata("design:type", gridApi_1.GridApi)
	    ], HeaderRootComp.prototype, "gridApi", void 0);
	    __decorate([
	        context_1.Autowired('autoWidthCalculator'),
	        __metadata("design:type", autoWidthCalculator_1.AutoWidthCalculator)
	    ], HeaderRootComp.prototype, "autoWidthCalculator", void 0);
	    __decorate([
	        context_1.PostConstruct,
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", []),
	        __metadata("design:returntype", void 0)
	    ], HeaderRootComp.prototype, "postConstruct", null);
	    return HeaderRootComp;
	}(component_1.Component));
	exports.HeaderRootComp = HeaderRootComp;


/***/ }),
/* 2447 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var gridOptionsWrapper_1 = __webpack_require__(2324);
	var context_1 = __webpack_require__(2333);
	var dragAndDropService_1 = __webpack_require__(2363);
	var columnController_1 = __webpack_require__(2341);
	var eventService_1 = __webpack_require__(2331);
	var events_1 = __webpack_require__(2335);
	var headerRowComp_1 = __webpack_require__(2448);
	var bodyDropTarget_1 = __webpack_require__(2452);
	var column_1 = __webpack_require__(2343);
	var scrollVisibleService_1 = __webpack_require__(2455);
	var utils_1 = __webpack_require__(2325);
	var HeaderContainer = /** @class */ (function () {
	    function HeaderContainer(eContainer, eViewport, pinned) {
	        this.headerRowComps = [];
	        this.eContainer = eContainer;
	        this.pinned = pinned;
	        this.eViewport = eViewport;
	    }
	    HeaderContainer.prototype.registerGridComp = function (gridPanel) {
	        this.setupDragAndDrop(gridPanel);
	    };
	    HeaderContainer.prototype.forEachHeaderElement = function (callback) {
	        this.headerRowComps.forEach(function (headerRowComp) { return headerRowComp.forEachHeaderElement(callback); });
	    };
	    HeaderContainer.prototype.init = function () {
	        this.scrollWidth = this.gridOptionsWrapper.getScrollbarWidth();
	        // if value changes, then if not pivoting, we at least need to change the label eg from sum() to avg(),
	        // if pivoting, then the columns have changed
	        this.eventService.addEventListener(events_1.Events.EVENT_COLUMN_VALUE_CHANGED, this.onColumnValueChanged.bind(this));
	        this.eventService.addEventListener(events_1.Events.EVENT_COLUMN_ROW_GROUP_CHANGED, this.onColumnRowGroupChanged.bind(this));
	        this.eventService.addEventListener(events_1.Events.EVENT_GRID_COLUMNS_CHANGED, this.onGridColumnsChanged.bind(this));
	        this.eventService.addEventListener(events_1.Events.EVENT_SCROLL_VISIBILITY_CHANGED, this.onScrollVisibilityChanged.bind(this));
	        this.eventService.addEventListener(events_1.Events.EVENT_COLUMN_RESIZED, this.onColumnResized.bind(this));
	        this.eventService.addEventListener(events_1.Events.EVENT_DISPLAYED_COLUMNS_CHANGED, this.onDisplayedColumnsChanged.bind(this));
	    };
	    // if row group changes, that means we may need to add aggFuncs to the column headers,
	    // if the grid goes from no aggregation (ie no grouping) to grouping
	    HeaderContainer.prototype.onColumnRowGroupChanged = function () {
	        this.onGridColumnsChanged();
	    };
	    // if the agg func of a column changes, then we may need to update the agg func in columns header
	    HeaderContainer.prototype.onColumnValueChanged = function () {
	        this.onGridColumnsChanged();
	    };
	    HeaderContainer.prototype.onColumnResized = function () {
	        this.setWidthOfPinnedContainer();
	    };
	    HeaderContainer.prototype.onDisplayedColumnsChanged = function () {
	        this.setWidthOfPinnedContainer();
	    };
	    HeaderContainer.prototype.onScrollVisibilityChanged = function () {
	        this.setWidthOfPinnedContainer();
	    };
	    HeaderContainer.prototype.setWidthOfPinnedContainer = function () {
	        var pinningLeft = this.pinned === column_1.Column.PINNED_LEFT;
	        var pinningRight = this.pinned === column_1.Column.PINNED_RIGHT;
	        var controller = this.columnController;
	        var isRtl = this.gridOptionsWrapper.isEnableRtl();
	        if (pinningLeft || pinningRight) {
	            // size to fit all columns
	            var width = controller[pinningLeft ? 'getPinnedLeftContainerWidth' : 'getPinnedRightContainerWidth']();
	            // if there is a scroll showing (and taking up space, so Windows, and not iOS)
	            // in the body, then we add extra space to keep header aligned with the body,
	            // as body width fits the cols and the scrollbar
	            var addPaddingForScrollbar = this.scrollVisibleService.isVerticalScrollShowing() && ((isRtl && pinningLeft) || (!isRtl && pinningRight));
	            if (addPaddingForScrollbar) {
	                width += this.scrollWidth;
	            }
	            utils_1._.setFixedWidth(this.eContainer, width);
	        }
	    };
	    HeaderContainer.prototype.destroy = function () {
	        this.removeHeaderRowComps();
	    };
	    HeaderContainer.prototype.getRowComps = function () {
	        return this.headerRowComps;
	    };
	    // grid cols have changed - this also means the number of rows in the header can have
	    // changed. so we remove all the old rows and insert new ones for a complete refresh
	    HeaderContainer.prototype.onGridColumnsChanged = function () {
	        this.removeAndCreateAllRowComps();
	    };
	    HeaderContainer.prototype.removeAndCreateAllRowComps = function () {
	        this.removeHeaderRowComps();
	        this.createHeaderRowComps();
	    };
	    // we expose this for gridOptions.api.refreshHeader() to call
	    HeaderContainer.prototype.refresh = function () {
	        this.removeAndCreateAllRowComps();
	    };
	    HeaderContainer.prototype.setupDragAndDrop = function (gridComp) {
	        var dropContainer = this.eViewport ? this.eViewport : this.eContainer;
	        var bodyDropTarget = new bodyDropTarget_1.BodyDropTarget(this.pinned, dropContainer);
	        this.context.wireBean(bodyDropTarget);
	        bodyDropTarget.registerGridComp(gridComp);
	    };
	    HeaderContainer.prototype.removeHeaderRowComps = function () {
	        this.headerRowComps.forEach(function (headerRowComp) {
	            headerRowComp.destroy();
	        });
	        this.headerRowComps.length = 0;
	        utils_1._.clearElement(this.eContainer);
	    };
	    HeaderContainer.prototype.createHeaderRowComps = function () {
	        // if we are displaying header groups, then we have many rows here.
	        // go through each row of the header, one by one.
	        var rowCount = this.columnController.getHeaderRowCount();
	        for (var dept = 0; dept < rowCount; dept++) {
	            var groupRow = dept !== (rowCount - 1);
	            var type = groupRow ? headerRowComp_1.HeaderRowType.COLUMN_GROUP : headerRowComp_1.HeaderRowType.COLUMN;
	            var headerRowComp = new headerRowComp_1.HeaderRowComp(dept, type, this.pinned, this.dropTarget);
	            this.context.wireBean(headerRowComp);
	            this.headerRowComps.push(headerRowComp);
	            headerRowComp.getGui().setAttribute('aria-rowindex', this.headerRowComps.length.toString());
	            this.eContainer.appendChild(headerRowComp.getGui());
	        }
	        var includeFloatingFilterRow = this.gridOptionsWrapper.isFloatingFilter() && !this.columnController.isPivotMode();
	        if (includeFloatingFilterRow) {
	            var headerRowComp = new headerRowComp_1.HeaderRowComp(rowCount, headerRowComp_1.HeaderRowType.FLOATING_FILTER, this.pinned, this.dropTarget);
	            this.context.wireBean(headerRowComp);
	            this.headerRowComps.push(headerRowComp);
	            headerRowComp.getGui().setAttribute('aria-rowindex', this.headerRowComps.length.toString());
	            this.eContainer.appendChild(headerRowComp.getGui());
	        }
	    };
	    __decorate([
	        context_1.Autowired('gridOptionsWrapper'),
	        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
	    ], HeaderContainer.prototype, "gridOptionsWrapper", void 0);
	    __decorate([
	        context_1.Autowired('context'),
	        __metadata("design:type", context_1.Context)
	    ], HeaderContainer.prototype, "context", void 0);
	    __decorate([
	        context_1.Autowired('$scope'),
	        __metadata("design:type", Object)
	    ], HeaderContainer.prototype, "$scope", void 0);
	    __decorate([
	        context_1.Autowired('dragAndDropService'),
	        __metadata("design:type", dragAndDropService_1.DragAndDropService)
	    ], HeaderContainer.prototype, "dragAndDropService", void 0);
	    __decorate([
	        context_1.Autowired('columnController'),
	        __metadata("design:type", columnController_1.ColumnController)
	    ], HeaderContainer.prototype, "columnController", void 0);
	    __decorate([
	        context_1.Autowired('eventService'),
	        __metadata("design:type", eventService_1.EventService)
	    ], HeaderContainer.prototype, "eventService", void 0);
	    __decorate([
	        context_1.Autowired('scrollVisibleService'),
	        __metadata("design:type", scrollVisibleService_1.ScrollVisibleService)
	    ], HeaderContainer.prototype, "scrollVisibleService", void 0);
	    __decorate([
	        context_1.PostConstruct,
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", []),
	        __metadata("design:returntype", void 0)
	    ], HeaderContainer.prototype, "init", null);
	    return HeaderContainer;
	}());
	exports.HeaderContainer = HeaderContainer;


/***/ }),
/* 2448 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var component_1 = __webpack_require__(2353);
	var context_1 = __webpack_require__(2333);
	var gridOptionsWrapper_1 = __webpack_require__(2324);
	var columnController_1 = __webpack_require__(2341);
	var column_1 = __webpack_require__(2343);
	var eventService_1 = __webpack_require__(2331);
	var events_1 = __webpack_require__(2335);
	var headerWrapperComp_1 = __webpack_require__(2424);
	var headerGroupWrapperComp_1 = __webpack_require__(2449);
	var filterManager_1 = __webpack_require__(2378);
	var gridApi_1 = __webpack_require__(2338);
	var constants_1 = __webpack_require__(2328);
	var utils_1 = __webpack_require__(2325);
	var floatingFilterWrapper_1 = __webpack_require__(2450);
	var HeaderRowType;
	(function (HeaderRowType) {
	    HeaderRowType[HeaderRowType["COLUMN_GROUP"] = 0] = "COLUMN_GROUP";
	    HeaderRowType[HeaderRowType["COLUMN"] = 1] = "COLUMN";
	    HeaderRowType[HeaderRowType["FLOATING_FILTER"] = 2] = "FLOATING_FILTER";
	})(HeaderRowType = exports.HeaderRowType || (exports.HeaderRowType = {}));
	var HeaderRowComp = /** @class */ (function (_super) {
	    __extends(HeaderRowComp, _super);
	    function HeaderRowComp(dept, type, pinned, dropTarget) {
	        var _this = _super.call(this, "<div class=\"ag-header-row\" role=\"row\"/>") || this;
	        _this.headerComps = {};
	        _this.dept = dept;
	        _this.type = type;
	        _this.pinned = pinned;
	        _this.dropTarget = dropTarget;
	        return _this;
	    }
	    HeaderRowComp.prototype.forEachHeaderElement = function (callback) {
	        var _this = this;
	        Object.keys(this.headerComps).forEach(function (key) {
	            callback(_this.headerComps[key]);
	        });
	    };
	    HeaderRowComp.prototype.destroy = function () {
	        var idsOfAllChildren = Object.keys(this.headerComps);
	        this.removeAndDestroyChildComponents(idsOfAllChildren);
	        _super.prototype.destroy.call(this);
	    };
	    HeaderRowComp.prototype.removeAndDestroyChildComponents = function (idsToDestroy) {
	        var _this = this;
	        idsToDestroy.forEach(function (id) {
	            var childHeaderComp = _this.headerComps[id];
	            _this.getGui().removeChild(childHeaderComp.getGui());
	            childHeaderComp.destroy();
	            delete _this.headerComps[id];
	        });
	    };
	    HeaderRowComp.prototype.onRowHeightChanged = function () {
	        var headerRowCount = this.columnController.getHeaderRowCount();
	        var sizes = [];
	        var numberOfFloating = 0;
	        var groupHeight;
	        var headerHeight;
	        if (!this.columnController.isPivotMode()) {
	            if (this.gridOptionsWrapper.isFloatingFilter()) {
	                headerRowCount++;
	            }
	            numberOfFloating = (this.gridOptionsWrapper.isFloatingFilter()) ? 1 : 0;
	            groupHeight = this.gridOptionsWrapper.getGroupHeaderHeight();
	            headerHeight = this.gridOptionsWrapper.getHeaderHeight();
	        }
	        else {
	            numberOfFloating = 0;
	            groupHeight = this.gridOptionsWrapper.getPivotGroupHeaderHeight();
	            headerHeight = this.gridOptionsWrapper.getPivotHeaderHeight();
	        }
	        var numberOfNonGroups = 1 + numberOfFloating;
	        var numberOfGroups = headerRowCount - numberOfNonGroups;
	        for (var i = 0; i < numberOfGroups; i++) {
	            sizes.push(groupHeight);
	        }
	        sizes.push(headerHeight);
	        for (var i = 0; i < numberOfFloating; i++) {
	            sizes.push(this.gridOptionsWrapper.getFloatingFiltersHeight());
	        }
	        var rowHeight = 0;
	        for (var i = 0; i < this.dept; i++) {
	            rowHeight += sizes[i];
	        }
	        this.getGui().style.top = rowHeight + 'px';
	        this.getGui().style.height = sizes[this.dept] + 'px';
	    };
	    //noinspection JSUnusedLocalSymbols
	    HeaderRowComp.prototype.init = function () {
	        this.onRowHeightChanged();
	        this.onVirtualColumnsChanged();
	        this.setWidth();
	        this.addDestroyableEventListener(this.gridOptionsWrapper, gridOptionsWrapper_1.GridOptionsWrapper.PROP_HEADER_HEIGHT, this.onRowHeightChanged.bind(this));
	        this.addDestroyableEventListener(this.gridOptionsWrapper, gridOptionsWrapper_1.GridOptionsWrapper.PROP_PIVOT_HEADER_HEIGHT, this.onRowHeightChanged.bind(this));
	        this.addDestroyableEventListener(this.gridOptionsWrapper, gridOptionsWrapper_1.GridOptionsWrapper.PROP_GROUP_HEADER_HEIGHT, this.onRowHeightChanged.bind(this));
	        this.addDestroyableEventListener(this.gridOptionsWrapper, gridOptionsWrapper_1.GridOptionsWrapper.PROP_PIVOT_GROUP_HEADER_HEIGHT, this.onRowHeightChanged.bind(this));
	        this.addDestroyableEventListener(this.gridOptionsWrapper, gridOptionsWrapper_1.GridOptionsWrapper.PROP_FLOATING_FILTERS_HEIGHT, this.onRowHeightChanged.bind(this));
	        this.addDestroyableEventListener(this.eventService, events_1.Events.EVENT_VIRTUAL_COLUMNS_CHANGED, this.onVirtualColumnsChanged.bind(this));
	        this.addDestroyableEventListener(this.eventService, events_1.Events.EVENT_DISPLAYED_COLUMNS_CHANGED, this.onDisplayedColumnsChanged.bind(this));
	        this.addDestroyableEventListener(this.eventService, events_1.Events.EVENT_COLUMN_RESIZED, this.onColumnResized.bind(this));
	        this.addDestroyableEventListener(this.eventService, events_1.Events.EVENT_GRID_COLUMNS_CHANGED, this.onGridColumnsChanged.bind(this));
	    };
	    HeaderRowComp.prototype.onColumnResized = function () {
	        this.setWidth();
	    };
	    HeaderRowComp.prototype.setWidth = function () {
	        var width = this.getWidthForRow();
	        this.getGui().style.width = width + 'px';
	    };
	    HeaderRowComp.prototype.getWidthForRow = function () {
	        var printLayout = this.gridOptionsWrapper.getDomLayout() === constants_1.Constants.DOM_LAYOUT_PRINT;
	        if (printLayout) {
	            var centerRow = utils_1._.missing(this.pinned);
	            if (centerRow) {
	                return this.columnController.getContainerWidth(column_1.Column.PINNED_RIGHT)
	                    + this.columnController.getContainerWidth(column_1.Column.PINNED_LEFT)
	                    + this.columnController.getContainerWidth(null);
	            }
	            else {
	                return 0;
	            }
	        }
	        else {
	            // if not printing, just return the width as normal
	            return this.columnController.getContainerWidth(this.pinned);
	        }
	    };
	    HeaderRowComp.prototype.onGridColumnsChanged = function () {
	        this.removeAndDestroyAllChildComponents();
	    };
	    HeaderRowComp.prototype.removeAndDestroyAllChildComponents = function () {
	        var idsOfAllChildren = Object.keys(this.headerComps);
	        this.removeAndDestroyChildComponents(idsOfAllChildren);
	    };
	    HeaderRowComp.prototype.onDisplayedColumnsChanged = function () {
	        this.onVirtualColumnsChanged();
	        this.setWidth();
	    };
	    HeaderRowComp.prototype.getItemsAtDept = function () {
	        var _this = this;
	        var printLayout = this.gridOptionsWrapper.getDomLayout() === constants_1.Constants.DOM_LAYOUT_PRINT;
	        if (printLayout) {
	            // for print layout, we add all columns into the center
	            var centerContainer = utils_1._.missing(this.pinned);
	            if (centerContainer) {
	                var result_1 = [];
	                [column_1.Column.PINNED_LEFT, null, column_1.Column.PINNED_RIGHT].forEach(function (pinned) {
	                    var items = _this.columnController.getVirtualHeaderGroupRow(pinned, _this.type == HeaderRowType.FLOATING_FILTER ?
	                        _this.dept - 1 :
	                        _this.dept);
	                    result_1 = result_1.concat(items);
	                });
	                return result_1;
	            }
	            else {
	                return [];
	            }
	        }
	        else {
	            // when in normal layout, we add the columns for that container only
	            return this.columnController.getVirtualHeaderGroupRow(this.pinned, this.type == HeaderRowType.FLOATING_FILTER ?
	                this.dept - 1 :
	                this.dept);
	        }
	    };
	    HeaderRowComp.prototype.onVirtualColumnsChanged = function () {
	        var _this = this;
	        var currentChildIds = Object.keys(this.headerComps);
	        var itemsAtDepth = this.getItemsAtDept();
	        var ensureDomOrder = this.gridOptionsWrapper.isEnsureDomOrder();
	        var eBefore;
	        itemsAtDepth.forEach(function (child) {
	            // skip groups that have no displayed children. this can happen when the group is broken,
	            // and this section happens to have nothing to display for the open / closed state.
	            // (a broken group is one that is split, ie columns in the group have a non-group column
	            // in between them)
	            if (child.isEmptyGroup()) {
	                return;
	            }
	            var idOfChild = child.getUniqueId();
	            var eParentContainer = _this.getGui();
	            // if we already have this cell rendered, do nothing
	            var colAlreadyInDom = currentChildIds.indexOf(idOfChild) >= 0;
	            var headerComp;
	            var eHeaderCompGui;
	            if (colAlreadyInDom) {
	                utils_1._.removeFromArray(currentChildIds, idOfChild);
	                headerComp = _this.headerComps[idOfChild];
	                eHeaderCompGui = headerComp.getGui();
	                if (ensureDomOrder) {
	                    utils_1._.ensureDomOrder(eParentContainer, eHeaderCompGui, eBefore);
	                }
	                eBefore = eHeaderCompGui;
	            }
	            else {
	                headerComp = _this.createHeaderComp(child);
	                _this.headerComps[idOfChild] = headerComp;
	                eHeaderCompGui = headerComp.getGui();
	                if (ensureDomOrder) {
	                    utils_1._.insertWithDomOrder(eParentContainer, eHeaderCompGui, eBefore);
	                }
	                else {
	                    eParentContainer.appendChild(eHeaderCompGui);
	                }
	                eBefore = eHeaderCompGui;
	            }
	        });
	        // at this point, anything left in currentChildIds is an element that is no longer in the viewport
	        this.removeAndDestroyChildComponents(currentChildIds);
	    };
	    HeaderRowComp.prototype.createHeaderComp = function (columnGroupChild) {
	        var result;
	        switch (this.type) {
	            case HeaderRowType.COLUMN:
	                result = new headerWrapperComp_1.HeaderWrapperComp(columnGroupChild, this.dropTarget, this.pinned);
	                break;
	            case HeaderRowType.COLUMN_GROUP:
	                result = new headerGroupWrapperComp_1.HeaderGroupWrapperComp(columnGroupChild, this.dropTarget, this.pinned);
	                break;
	            case HeaderRowType.FLOATING_FILTER:
	                result = new floatingFilterWrapper_1.FloatingFilterWrapper(columnGroupChild);
	                break;
	        }
	        this.getContext().wireBean(result);
	        return result;
	    };
	    __decorate([
	        context_1.Autowired('gridOptionsWrapper'),
	        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
	    ], HeaderRowComp.prototype, "gridOptionsWrapper", void 0);
	    __decorate([
	        context_1.Autowired('gridApi'),
	        __metadata("design:type", gridApi_1.GridApi)
	    ], HeaderRowComp.prototype, "gridApi", void 0);
	    __decorate([
	        context_1.Autowired('columnController'),
	        __metadata("design:type", columnController_1.ColumnController)
	    ], HeaderRowComp.prototype, "columnController", void 0);
	    __decorate([
	        context_1.Autowired('eventService'),
	        __metadata("design:type", eventService_1.EventService)
	    ], HeaderRowComp.prototype, "eventService", void 0);
	    __decorate([
	        context_1.Autowired('filterManager'),
	        __metadata("design:type", filterManager_1.FilterManager)
	    ], HeaderRowComp.prototype, "filterManager", void 0);
	    __decorate([
	        context_1.PostConstruct,
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", []),
	        __metadata("design:returntype", void 0)
	    ], HeaderRowComp.prototype, "init", null);
	    return HeaderRowComp;
	}(component_1.Component));
	exports.HeaderRowComp = HeaderRowComp;


/***/ }),
/* 2449 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var component_1 = __webpack_require__(2353);
	var column_1 = __webpack_require__(2343);
	var columnGroup_1 = __webpack_require__(2342);
	var columnApi_1 = __webpack_require__(2346);
	var columnController_1 = __webpack_require__(2341);
	var gridOptionsWrapper_1 = __webpack_require__(2324);
	var horizontalResizeService_1 = __webpack_require__(2425);
	var context_1 = __webpack_require__(2333);
	var cssClassApplier_1 = __webpack_require__(2426);
	var dragAndDropService_1 = __webpack_require__(2363);
	var setLeftFeature_1 = __webpack_require__(2427);
	var gridApi_1 = __webpack_require__(2338);
	var userComponentFactory_1 = __webpack_require__(2380);
	var beans_1 = __webpack_require__(2373);
	var hoverFeature_1 = __webpack_require__(2433);
	var utils_1 = __webpack_require__(2325);
	var HeaderGroupWrapperComp = /** @class */ (function (_super) {
	    __extends(HeaderGroupWrapperComp, _super);
	    function HeaderGroupWrapperComp(columnGroup, dragSourceDropTarget, pinned) {
	        var _this = _super.call(this, HeaderGroupWrapperComp.TEMPLATE) || this;
	        // the children can change, we keep destroy functions related to listening to the children here
	        _this.childColumnsDestroyFuncs = [];
	        _this.columnGroup = columnGroup;
	        _this.dragSourceDropTarget = dragSourceDropTarget;
	        _this.pinned = pinned;
	        return _this;
	    }
	    HeaderGroupWrapperComp.prototype.postConstruct = function () {
	        cssClassApplier_1.CssClassApplier.addHeaderClassesFromColDef(this.getComponentHolder(), this.getGui(), this.gridOptionsWrapper, null, this.columnGroup);
	        var displayName = this.columnController.getDisplayNameForColumnGroup(this.columnGroup, 'header');
	        this.appendHeaderGroupComp(displayName);
	        this.setupResize();
	        this.addClasses();
	        this.setupWidth();
	        this.addAttributes();
	        this.setupMovingCss();
	        this.setupTooltip();
	        this.addFeature(this.getContext(), new hoverFeature_1.HoverFeature(this.columnGroup.getOriginalColumnGroup().getLeafColumns(), this.getGui()));
	        var setLeftFeature = new setLeftFeature_1.SetLeftFeature(this.columnGroup, this.getGui(), this.beans);
	        setLeftFeature.init();
	        this.addDestroyFunc(setLeftFeature.destroy.bind(setLeftFeature));
	    };
	    HeaderGroupWrapperComp.prototype.setupMovingCss = function () {
	        var _this = this;
	        var originalColumnGroup = this.columnGroup.getOriginalColumnGroup();
	        var leafColumns = originalColumnGroup.getLeafColumns();
	        leafColumns.forEach(function (col) {
	            _this.addDestroyableEventListener(col, column_1.Column.EVENT_MOVING_CHANGED, _this.onColumnMovingChanged.bind(_this));
	        });
	        this.onColumnMovingChanged();
	    };
	    HeaderGroupWrapperComp.prototype.getColumn = function () {
	        return this.columnGroup;
	    };
	    HeaderGroupWrapperComp.prototype.getComponentHolder = function () {
	        return this.columnGroup.getColGroupDef();
	    };
	    HeaderGroupWrapperComp.prototype.getTooltipText = function () {
	        var colGroupDef = this.getComponentHolder();
	        return colGroupDef && colGroupDef.headerTooltip;
	    };
	    HeaderGroupWrapperComp.prototype.setupTooltip = function () {
	        var tooltipText = this.getTooltipText();
	        if (tooltipText == null) {
	            return;
	        }
	        if (this.gridOptionsWrapper.isEnableBrowserTooltips()) {
	            this.getGui().setAttribute('title', tooltipText);
	        }
	        else {
	            this.beans.tooltipManager.registerTooltip(this);
	        }
	    };
	    HeaderGroupWrapperComp.prototype.onColumnMovingChanged = function () {
	        // this function adds or removes the moving css, based on if the col is moving.
	        // this is what makes the header go dark when it is been moved (gives impression to
	        // user that the column was picked up).
	        utils_1._.addOrRemoveCssClass(this.getGui(), 'ag-header-cell-moving', this.columnGroup.isMoving());
	    };
	    HeaderGroupWrapperComp.prototype.addAttributes = function () {
	        this.getGui().setAttribute("col-id", this.columnGroup.getUniqueId());
	    };
	    HeaderGroupWrapperComp.prototype.appendHeaderGroupComp = function (displayName) {
	        var _this = this;
	        var params = {
	            displayName: displayName,
	            columnGroup: this.columnGroup,
	            setExpanded: function (expanded) {
	                _this.columnController.setColumnGroupOpened(_this.columnGroup.getOriginalColumnGroup(), expanded, "gridInitializing");
	            },
	            api: this.gridApi,
	            columnApi: this.columnApi,
	            context: this.gridOptionsWrapper.getContext()
	        };
	        if (!displayName) {
	            var columnGroup = this.columnGroup;
	            var leafCols = columnGroup.getLeafColumns();
	            // find the top most column group that represents the same columns. so if we are dragging a group, we also
	            // want to visually show the parent groups dragging for the same column set. for example imaging 5 levels
	            // of grouping, with each group only containing the next group, and the last group containing three columns,
	            // then when you move any group (even the lowest level group) you are in-fact moving all the groups, as all
	            // the groups represent the same column set.
	            while (columnGroup.getParent() && columnGroup.getParent().getLeafColumns().length === leafCols.length) {
	                columnGroup = columnGroup.getParent();
	            }
	            var colGroupDef = columnGroup.getColGroupDef();
	            if (colGroupDef) {
	                displayName = colGroupDef.headerName;
	            }
	            if (!displayName) {
	                displayName = leafCols ? this.columnController.getDisplayNameForColumn(leafCols[0], 'header', true) : '';
	            }
	        }
	        var callback = this.afterHeaderCompCreated.bind(this, displayName);
	        this.userComponentFactory.newHeaderGroupComponent(params).then(callback);
	    };
	    HeaderGroupWrapperComp.prototype.afterHeaderCompCreated = function (displayName, headerGroupComp) {
	        this.appendChild(headerGroupComp);
	        this.setupMove(headerGroupComp.getGui(), displayName);
	    };
	    HeaderGroupWrapperComp.prototype.addClasses = function () {
	        // having different classes below allows the style to not have a bottom border
	        // on the group header, if no group is specified
	        // columnGroup.getColGroupDef
	        if (this.columnGroup.isPadding()) {
	            this.addCssClass('ag-header-group-cell-no-group');
	        }
	        else {
	            this.addCssClass('ag-header-group-cell-with-group');
	        }
	    };
	    HeaderGroupWrapperComp.prototype.setupMove = function (eHeaderGroup, displayName) {
	        var _this = this;
	        if (!eHeaderGroup) {
	            return;
	        }
	        if (this.isSuppressMoving()) {
	            return;
	        }
	        var allLeafColumns = this.columnGroup.getOriginalColumnGroup().getLeafColumns();
	        if (eHeaderGroup) {
	            var dragSource_1 = {
	                type: dragAndDropService_1.DragSourceType.HeaderCell,
	                eElement: eHeaderGroup,
	                dragItemName: displayName,
	                // we add in the original group leaf columns, so we move both visible and non-visible items
	                dragItemCallback: this.getDragItemForGroup.bind(this),
	                dragSourceDropTarget: this.dragSourceDropTarget,
	                dragStarted: function () { return allLeafColumns.forEach(function (col) { return col.setMoving(true, "uiColumnDragged"); }); },
	                dragStopped: function () { return allLeafColumns.forEach(function (col) { return col.setMoving(false, "uiColumnDragged"); }); }
	            };
	            this.dragAndDropService.addDragSource(dragSource_1, true);
	            this.addDestroyFunc(function () { return _this.dragAndDropService.removeDragSource(dragSource_1); });
	        }
	    };
	    // when moving the columns, we want to move all the columns (contained within the DragItem) in this group in one go,
	    // and in the order they are currently in the screen.
	    HeaderGroupWrapperComp.prototype.getDragItemForGroup = function () {
	        var allColumnsOriginalOrder = this.columnGroup.getOriginalColumnGroup().getLeafColumns();
	        // capture visible state, used when re-entering grid to dictate which columns should be visible
	        var visibleState = {};
	        allColumnsOriginalOrder.forEach(function (column) { return visibleState[column.getId()] = column.isVisible(); });
	        var allColumnsCurrentOrder = [];
	        this.columnController.getAllDisplayedColumns().forEach(function (column) {
	            if (allColumnsOriginalOrder.indexOf(column) >= 0) {
	                allColumnsCurrentOrder.push(column);
	                utils_1._.removeFromArray(allColumnsOriginalOrder, column);
	            }
	        });
	        // we are left with non-visible columns, stick these in at the end
	        allColumnsOriginalOrder.forEach(function (column) { return allColumnsCurrentOrder.push(column); });
	        // create and return dragItem
	        return {
	            columns: allColumnsCurrentOrder,
	            visibleState: visibleState
	        };
	    };
	    HeaderGroupWrapperComp.prototype.isSuppressMoving = function () {
	        // if any child is fixed, then don't allow moving
	        var childSuppressesMoving = false;
	        this.columnGroup.getLeafColumns().forEach(function (column) {
	            if (column.getColDef().suppressMovable || column.getColDef().lockPosition) {
	                childSuppressesMoving = true;
	            }
	        });
	        var result = childSuppressesMoving || this.gridOptionsWrapper.isSuppressMovableColumns();
	        return result;
	    };
	    HeaderGroupWrapperComp.prototype.setupWidth = function () {
	        // we need to listen to changes in child columns, as they impact our width
	        this.addListenersToChildrenColumns();
	        // the children belonging to this group can change, so we need to add and remove listeners as they change
	        this.addDestroyableEventListener(this.columnGroup, columnGroup_1.ColumnGroup.EVENT_DISPLAYED_CHILDREN_CHANGED, this.onDisplayedChildrenChanged.bind(this));
	        this.onWidthChanged();
	        // the child listeners are not tied to this components life-cycle, as children can get added and removed
	        // to the group - hence they are on a different life-cycle. so we must make sure the existing children
	        // listeners are removed when we finally get destroyed
	        this.addDestroyFunc(this.destroyListenersOnChildrenColumns.bind(this));
	    };
	    HeaderGroupWrapperComp.prototype.onDisplayedChildrenChanged = function () {
	        this.addListenersToChildrenColumns();
	        this.onWidthChanged();
	    };
	    HeaderGroupWrapperComp.prototype.addListenersToChildrenColumns = function () {
	        var _this = this;
	        // first destroy any old listeners
	        this.destroyListenersOnChildrenColumns();
	        // now add new listeners to the new set of children
	        var widthChangedListener = this.onWidthChanged.bind(this);
	        this.columnGroup.getLeafColumns().forEach(function (column) {
	            column.addEventListener(column_1.Column.EVENT_WIDTH_CHANGED, widthChangedListener);
	            column.addEventListener(column_1.Column.EVENT_VISIBLE_CHANGED, widthChangedListener);
	            _this.childColumnsDestroyFuncs.push(function () {
	                column.removeEventListener(column_1.Column.EVENT_WIDTH_CHANGED, widthChangedListener);
	                column.removeEventListener(column_1.Column.EVENT_VISIBLE_CHANGED, widthChangedListener);
	            });
	        });
	    };
	    HeaderGroupWrapperComp.prototype.destroyListenersOnChildrenColumns = function () {
	        this.childColumnsDestroyFuncs.forEach(function (func) { return func(); });
	        this.childColumnsDestroyFuncs = [];
	    };
	    HeaderGroupWrapperComp.prototype.onWidthChanged = function () {
	        this.getGui().style.width = this.columnGroup.getActualWidth() + 'px';
	    };
	    HeaderGroupWrapperComp.prototype.setupResize = function () {
	        var _this = this;
	        this.eHeaderCellResize = this.getRefElement('agResize');
	        if (!this.columnGroup.isResizable()) {
	            utils_1._.removeFromParent(this.eHeaderCellResize);
	            return;
	        }
	        var finishedWithResizeFunc = this.horizontalResizeService.addResizeBar({
	            eResizeBar: this.eHeaderCellResize,
	            onResizeStart: this.onResizeStart.bind(this),
	            onResizing: this.onResizing.bind(this, false),
	            onResizeEnd: this.onResizing.bind(this, true)
	        });
	        this.addDestroyFunc(finishedWithResizeFunc);
	        if (!this.gridOptionsWrapper.isSuppressAutoSize()) {
	            this.eHeaderCellResize.addEventListener('dblclick', function (event) {
	                // get list of all the column keys we are responsible for
	                var keys = [];
	                _this.columnGroup.getDisplayedLeafColumns().forEach(function (column) {
	                    // not all cols in the group may be participating with auto-resize
	                    if (!column.getColDef().suppressAutoSize) {
	                        keys.push(column.getColId());
	                    }
	                });
	                if (keys.length > 0) {
	                    _this.columnController.autoSizeColumns(keys, "uiColumnResized");
	                }
	            });
	        }
	    };
	    HeaderGroupWrapperComp.prototype.onResizeStart = function (shiftKey) {
	        var _this = this;
	        var leafCols = this.columnGroup.getDisplayedLeafColumns();
	        this.resizeCols = utils_1._.filter(leafCols, function (col) { return col.isResizable(); });
	        this.resizeStartWidth = 0;
	        this.resizeCols.forEach(function (col) { return _this.resizeStartWidth += col.getActualWidth(); });
	        this.resizeRatios = [];
	        this.resizeCols.forEach(function (col) { return _this.resizeRatios.push(col.getActualWidth() / _this.resizeStartWidth); });
	        var takeFromGroup = null;
	        if (shiftKey) {
	            takeFromGroup = this.columnController.getDisplayedGroupAfter(this.columnGroup);
	        }
	        if (takeFromGroup) {
	            var takeFromLeafCols = takeFromGroup.getDisplayedLeafColumns();
	            this.resizeTakeFromCols = utils_1._.filter(takeFromLeafCols, function (col) { return col.isResizable(); });
	            this.resizeTakeFromStartWidth = 0;
	            this.resizeTakeFromCols.forEach(function (col) { return _this.resizeTakeFromStartWidth += col.getActualWidth(); });
	            this.resizeTakeFromRatios = [];
	            this.resizeTakeFromCols.forEach(function (col) { return _this.resizeTakeFromRatios.push(col.getActualWidth() / _this.resizeTakeFromStartWidth); });
	        }
	        else {
	            this.resizeTakeFromCols = null;
	            this.resizeTakeFromStartWidth = null;
	            this.resizeTakeFromRatios = null;
	        }
	        utils_1._.addCssClass(this.getGui(), 'ag-column-resizing');
	    };
	    HeaderGroupWrapperComp.prototype.onResizing = function (finished, resizeAmount) {
	        var resizeSets = [];
	        var resizeAmountNormalised = this.normaliseDragChange(resizeAmount);
	        resizeSets.push({
	            columns: this.resizeCols,
	            ratios: this.resizeRatios,
	            width: this.resizeStartWidth + resizeAmountNormalised
	        });
	        if (this.resizeTakeFromCols) {
	            resizeSets.push({
	                columns: this.resizeTakeFromCols,
	                ratios: this.resizeTakeFromRatios,
	                width: this.resizeTakeFromStartWidth - resizeAmountNormalised
	            });
	        }
	        this.columnController.resizeColumnSets(resizeSets, finished, 'uiColumnDragged');
	        if (finished) {
	            utils_1._.removeCssClass(this.getGui(), 'ag-column-resizing');
	        }
	    };
	    // optionally inverts the drag, depending on pinned and RTL
	    // note - this method is duplicated in RenderedHeaderCell - should refactor out?
	    HeaderGroupWrapperComp.prototype.normaliseDragChange = function (dragChange) {
	        var result = dragChange;
	        if (this.gridOptionsWrapper.isEnableRtl()) {
	            // for RTL, dragging left makes the col bigger, except when pinning left
	            if (this.pinned !== column_1.Column.PINNED_LEFT) {
	                result *= -1;
	            }
	        }
	        else {
	            // for LTR (ie normal), dragging left makes the col smaller, except when pinning right
	            if (this.pinned === column_1.Column.PINNED_RIGHT) {
	                result *= -1;
	            }
	        }
	        return result;
	    };
	    HeaderGroupWrapperComp.TEMPLATE = '<div class="ag-header-group-cell" role="presentation">' +
	        '<div ref="agResize" class="ag-header-cell-resize" role="presentation"></div>' +
	        '</div>';
	    __decorate([
	        context_1.Autowired('gridOptionsWrapper'),
	        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
	    ], HeaderGroupWrapperComp.prototype, "gridOptionsWrapper", void 0);
	    __decorate([
	        context_1.Autowired('columnController'),
	        __metadata("design:type", columnController_1.ColumnController)
	    ], HeaderGroupWrapperComp.prototype, "columnController", void 0);
	    __decorate([
	        context_1.Autowired('horizontalResizeService'),
	        __metadata("design:type", horizontalResizeService_1.HorizontalResizeService)
	    ], HeaderGroupWrapperComp.prototype, "horizontalResizeService", void 0);
	    __decorate([
	        context_1.Autowired('dragAndDropService'),
	        __metadata("design:type", dragAndDropService_1.DragAndDropService)
	    ], HeaderGroupWrapperComp.prototype, "dragAndDropService", void 0);
	    __decorate([
	        context_1.Autowired('userComponentFactory'),
	        __metadata("design:type", userComponentFactory_1.UserComponentFactory)
	    ], HeaderGroupWrapperComp.prototype, "userComponentFactory", void 0);
	    __decorate([
	        context_1.Autowired('gridApi'),
	        __metadata("design:type", gridApi_1.GridApi)
	    ], HeaderGroupWrapperComp.prototype, "gridApi", void 0);
	    __decorate([
	        context_1.Autowired('columnApi'),
	        __metadata("design:type", columnApi_1.ColumnApi)
	    ], HeaderGroupWrapperComp.prototype, "columnApi", void 0);
	    __decorate([
	        context_1.Autowired('beans'),
	        __metadata("design:type", beans_1.Beans)
	    ], HeaderGroupWrapperComp.prototype, "beans", void 0);
	    __decorate([
	        context_1.PostConstruct,
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", []),
	        __metadata("design:returntype", void 0)
	    ], HeaderGroupWrapperComp.prototype, "postConstruct", null);
	    return HeaderGroupWrapperComp;
	}(component_1.Component));
	exports.HeaderGroupWrapperComp = HeaderGroupWrapperComp;


/***/ }),
/* 2450 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var context_1 = __webpack_require__(2333);
	var column_1 = __webpack_require__(2343);
	var setLeftFeature_1 = __webpack_require__(2427);
	var component_1 = __webpack_require__(2353);
	var componentAnnotations_1 = __webpack_require__(2384);
	var gridOptionsWrapper_1 = __webpack_require__(2324);
	var beans_1 = __webpack_require__(2373);
	var hoverFeature_1 = __webpack_require__(2433);
	var events_1 = __webpack_require__(2335);
	var eventService_1 = __webpack_require__(2331);
	var columnHoverService_1 = __webpack_require__(2417);
	var utils_1 = __webpack_require__(2325);
	var userComponentFactory_1 = __webpack_require__(2380);
	var gridApi_1 = __webpack_require__(2338);
	var columnApi_1 = __webpack_require__(2346);
	var filterManager_1 = __webpack_require__(2378);
	var readOnlyFloatingFilter_1 = __webpack_require__(2451);
	var FloatingFilterWrapper = /** @class */ (function (_super) {
	    __extends(FloatingFilterWrapper, _super);
	    function FloatingFilterWrapper(column) {
	        var _this = _super.call(this, FloatingFilterWrapper.TEMPLATE) || this;
	        _this.column = column;
	        return _this;
	    }
	    FloatingFilterWrapper.prototype.postConstruct = function () {
	        this.setupFloatingFilter();
	        this.setupWidth();
	        this.setupLeftPositioning();
	        this.setupColumnHover();
	        this.addFeature(this.getContext(), new hoverFeature_1.HoverFeature([this.column], this.getGui()));
	        this.addDestroyableEventListener(this.eButtonShowMainFilter, 'click', this.showParentFilter.bind(this));
	    };
	    FloatingFilterWrapper.prototype.setupFloatingFilter = function () {
	        var _this = this;
	        var colDef = this.column.getColDef();
	        if (colDef.filter) {
	            this.floatingFilterCompPromise = this.getFloatingFilterInstance();
	            if (this.floatingFilterCompPromise) {
	                this.floatingFilterCompPromise.then(function (compInstance) {
	                    if (compInstance) {
	                        _this.setupWithFloatingFilter(compInstance);
	                        _this.setupSyncWithFilter();
	                    }
	                    else {
	                        _this.setupEmpty();
	                    }
	                });
	            }
	            else {
	                this.setupEmpty();
	            }
	        }
	        else {
	            this.setupEmpty();
	        }
	    };
	    FloatingFilterWrapper.prototype.setupLeftPositioning = function () {
	        var setLeftFeature = new setLeftFeature_1.SetLeftFeature(this.column, this.getGui(), this.beans);
	        setLeftFeature.init();
	        this.addDestroyFunc(setLeftFeature.destroy.bind(setLeftFeature));
	    };
	    FloatingFilterWrapper.prototype.setupSyncWithFilter = function () {
	        var _this = this;
	        var syncWithFilter = function (filterChangedEvent) {
	            var filterComponentPromise = _this.filterManager.getFilterComponent(_this.column, 'NO_UI');
	            var parentModel = filterComponentPromise.resolveNow(null, function (filter) { return filter.getModel(); });
	            _this.onParentModelChanged(parentModel, filterChangedEvent);
	        };
	        this.addDestroyableEventListener(this.column, column_1.Column.EVENT_FILTER_CHANGED, syncWithFilter);
	        if (this.filterManager.isFilterActive(this.column)) {
	            syncWithFilter(null);
	        }
	    };
	    // linked to event listener in template
	    FloatingFilterWrapper.prototype.showParentFilter = function () {
	        this.menuFactory.showMenuAfterButtonClick(this.column, this.eButtonShowMainFilter, 'filterMenuTab', ['filterMenuTab']);
	    };
	    FloatingFilterWrapper.prototype.setupColumnHover = function () {
	        this.addDestroyableEventListener(this.eventService, events_1.Events.EVENT_COLUMN_HOVER_CHANGED, this.onColumnHover.bind(this));
	        this.onColumnHover();
	    };
	    FloatingFilterWrapper.prototype.onColumnHover = function () {
	        var isHovered = this.columnHoverService.isHovered(this.column);
	        utils_1._.addOrRemoveCssClass(this.getGui(), 'ag-column-hover', isHovered);
	    };
	    FloatingFilterWrapper.prototype.setupWidth = function () {
	        this.addDestroyableEventListener(this.column, column_1.Column.EVENT_WIDTH_CHANGED, this.onColumnWidthChanged.bind(this));
	        this.onColumnWidthChanged();
	    };
	    FloatingFilterWrapper.prototype.onColumnWidthChanged = function () {
	        this.getGui().style.width = this.column.getActualWidth() + 'px';
	    };
	    FloatingFilterWrapper.prototype.setupWithFloatingFilter = function (floatingFilterComp) {
	        var disposeFunc = function () {
	            if (floatingFilterComp.destroy) {
	                floatingFilterComp.destroy();
	            }
	        };
	        if (!this.isAlive()) {
	            disposeFunc();
	            return;
	        }
	        this.addDestroyFunc(disposeFunc);
	        var floatingFilterCompUi = floatingFilterComp.getGui();
	        utils_1._.addOrRemoveCssClass(this.eFloatingFilterBody, 'ag-floating-filter-body', !this.suppressFilterButton);
	        utils_1._.addOrRemoveCssClass(this.eFloatingFilterBody, 'ag-floating-filter-full-body', this.suppressFilterButton);
	        utils_1._.setDisplayed(this.eButtonWrapper, !this.suppressFilterButton);
	        var eIcon = utils_1._.createIconNoSpan('filter', this.gridOptionsWrapper, this.column);
	        this.eButtonShowMainFilter.appendChild(eIcon);
	        this.eFloatingFilterBody.appendChild(floatingFilterCompUi);
	        if (floatingFilterComp.afterGuiAttached) {
	            floatingFilterComp.afterGuiAttached();
	        }
	    };
	    FloatingFilterWrapper.prototype.parentFilterInstance = function (callback) {
	        var promise = this.filterManager.getFilterComponent(this.column, 'NO_UI');
	        promise.then(callback);
	    };
	    FloatingFilterWrapper.prototype.getFloatingFilterInstance = function () {
	        var colDef = this.column.getColDef();
	        var defaultFloatingFilterType;
	        if (typeof colDef.filter === 'string') {
	            // will be undefined if not in the map
	            defaultFloatingFilterType = FloatingFilterWrapper.filterToFloatingFilterNames[colDef.filter];
	        }
	        else if (colDef.filter === true) {
	            defaultFloatingFilterType = this.gridOptionsWrapper.isEnterprise() ? 'agSetColumnFloatingFilter' : 'agTextColumnFloatingFilter';
	        }
	        var filterParams = this.filterManager.createFilterParams(this.column, this.column.getColDef());
	        var finalFilterParams = this.userComponentFactory.createFinalParams(colDef, 'filter', filterParams);
	        var params = {
	            api: this.gridApi,
	            column: this.column,
	            filterParams: finalFilterParams,
	            currentParentModel: this.currentParentModel.bind(this),
	            parentFilterInstance: this.parentFilterInstance.bind(this),
	            onFloatingFilterChanged: this.onFloatingFilterChanged.bind(this),
	            suppressFilterButton: false // This one might be overridden from the colDef
	        };
	        // this is unusual - we need a params value OUTSIDE the component the params are for.
	        // the params are for the floating filter component, but this property is actually for the wrapper.
	        this.suppressFilterButton = colDef.floatingFilterComponentParams ? !!colDef.floatingFilterComponentParams.suppressFilterButton : false;
	        var promise = this.userComponentFactory.newFloatingFilterComponent(colDef, params, defaultFloatingFilterType);
	        if (!promise) {
	            var filterComponent = this.getFilterComponentPrototype(colDef);
	            var getModelAsStringExists = filterComponent && filterComponent.prototype && filterComponent.prototype.getModelAsString;
	            if (getModelAsStringExists) {
	                var compInstance = this.userComponentFactory.createUserComponentFromConcreteClass(readOnlyFloatingFilter_1.ReadOnlyFloatingFilter, params);
	                promise = utils_1.Promise.resolve(compInstance);
	            }
	        }
	        return promise;
	    };
	    FloatingFilterWrapper.prototype.createDynamicParams = function () {
	        return {
	            column: this.column,
	            colDef: this.column.getColDef(),
	            api: this.gridApi,
	            columnApi: this.columnApi
	        };
	    };
	    FloatingFilterWrapper.prototype.getFilterComponentPrototype = function (colDef) {
	        var resolvedComponent = this.userComponentFactory.lookupComponentClassDef(colDef, "filter", this.createDynamicParams());
	        return resolvedComponent ? resolvedComponent.component : null;
	    };
	    FloatingFilterWrapper.prototype.setupEmpty = function () {
	        utils_1._.setDisplayed(this.eButtonWrapper, false);
	    };
	    FloatingFilterWrapper.prototype.currentParentModel = function () {
	        var filterPromise = this.filterManager.getFilterComponent(this.column, 'NO_UI');
	        return filterPromise.resolveNow(null, function (filter) { return filter.getModel(); });
	    };
	    FloatingFilterWrapper.prototype.onParentModelChanged = function (model, filterChangedEvent) {
	        if (!this.floatingFilterCompPromise) {
	            return;
	        }
	        this.floatingFilterCompPromise.then(function (floatingFilterComp) {
	            floatingFilterComp.onParentModelChanged(model, filterChangedEvent);
	        });
	    };
	    FloatingFilterWrapper.prototype.onFloatingFilterChanged = function () {
	        console.warn('ag-Grid: since version 21.x, how floating filters are implemented has changed. ' +
	            'Instead of calling params.onFloatingFilterChanged(), get a reference to the main filter via ' +
	            'params.parentFilterInstance() and then set a value on the parent filter directly.');
	    };
	    FloatingFilterWrapper.filterToFloatingFilterNames = {
	        set: 'agSetColumnFloatingFilter',
	        agSetColumnFilter: 'agSetColumnFloatingFilter',
	        number: 'agNumberColumnFloatingFilter',
	        agNumberColumnFilter: 'agNumberColumnFloatingFilter',
	        date: 'agDateColumnFloatingFilter',
	        agDateColumnFilter: 'agDateColumnFloatingFilter',
	        text: 'agTextColumnFloatingFilter',
	        agTextColumnFilter: 'agTextColumnFloatingFilter'
	    };
	    FloatingFilterWrapper.TEMPLATE = "<div class=\"ag-header-cell\" role=\"presentation\">\n            <div ref=\"eFloatingFilterBody\" role=\"columnheader\"></div>\n            <div class=\"ag-floating-filter-button\" ref=\"eButtonWrapper\" role=\"presentation\">\n                <button type=\"button\" ref=\"eButtonShowMainFilter\"></button>\n            </div>\n        </div>";
	    __decorate([
	        context_1.Autowired('columnHoverService'),
	        __metadata("design:type", columnHoverService_1.ColumnHoverService)
	    ], FloatingFilterWrapper.prototype, "columnHoverService", void 0);
	    __decorate([
	        context_1.Autowired('eventService'),
	        __metadata("design:type", eventService_1.EventService)
	    ], FloatingFilterWrapper.prototype, "eventService", void 0);
	    __decorate([
	        context_1.Autowired('beans'),
	        __metadata("design:type", beans_1.Beans)
	    ], FloatingFilterWrapper.prototype, "beans", void 0);
	    __decorate([
	        context_1.Autowired('gridOptionsWrapper'),
	        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
	    ], FloatingFilterWrapper.prototype, "gridOptionsWrapper", void 0);
	    __decorate([
	        context_1.Autowired("userComponentFactory"),
	        __metadata("design:type", userComponentFactory_1.UserComponentFactory)
	    ], FloatingFilterWrapper.prototype, "userComponentFactory", void 0);
	    __decorate([
	        context_1.Autowired("gridApi"),
	        __metadata("design:type", gridApi_1.GridApi)
	    ], FloatingFilterWrapper.prototype, "gridApi", void 0);
	    __decorate([
	        context_1.Autowired("columnApi"),
	        __metadata("design:type", columnApi_1.ColumnApi)
	    ], FloatingFilterWrapper.prototype, "columnApi", void 0);
	    __decorate([
	        context_1.Autowired("filterManager"),
	        __metadata("design:type", filterManager_1.FilterManager)
	    ], FloatingFilterWrapper.prototype, "filterManager", void 0);
	    __decorate([
	        context_1.Autowired('menuFactory'),
	        __metadata("design:type", Object)
	    ], FloatingFilterWrapper.prototype, "menuFactory", void 0);
	    __decorate([
	        componentAnnotations_1.RefSelector('eFloatingFilterBody'),
	        __metadata("design:type", HTMLElement)
	    ], FloatingFilterWrapper.prototype, "eFloatingFilterBody", void 0);
	    __decorate([
	        componentAnnotations_1.RefSelector('eButtonWrapper'),
	        __metadata("design:type", HTMLElement)
	    ], FloatingFilterWrapper.prototype, "eButtonWrapper", void 0);
	    __decorate([
	        componentAnnotations_1.RefSelector('eButtonShowMainFilter'),
	        __metadata("design:type", HTMLElement)
	    ], FloatingFilterWrapper.prototype, "eButtonShowMainFilter", void 0);
	    __decorate([
	        context_1.PostConstruct,
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", []),
	        __metadata("design:returntype", void 0)
	    ], FloatingFilterWrapper.prototype, "postConstruct", null);
	    return FloatingFilterWrapper;
	}(component_1.Component));
	exports.FloatingFilterWrapper = FloatingFilterWrapper;


/***/ }),
/* 2451 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var component_1 = __webpack_require__(2353);
	var componentAnnotations_1 = __webpack_require__(2384);
	// optional floating filter for user provided filters - instead of providing a floating filter,
	// they can provide a getModelAsString() method on the filter instead. this class just displays
	// the string returned from getModelAsString()
	var ReadOnlyFloatingFilter = /** @class */ (function (_super) {
	    __extends(ReadOnlyFloatingFilter, _super);
	    function ReadOnlyFloatingFilter() {
	        return _super.call(this, "<div class=\"ag-input-wrapper\" role=\"presentation\"><input ref=\"eFloatingFilterText\" class=\"ag-floating-filter-input\"></div>") || this;
	    }
	    ReadOnlyFloatingFilter.prototype.init = function (params) {
	        this.params = params;
	        this.eFloatingFilterText.disabled = true;
	    };
	    ReadOnlyFloatingFilter.prototype.onParentModelChanged = function (parentModel) {
	        var _this = this;
	        if (!parentModel) {
	            this.eFloatingFilterText.value = '';
	            return;
	        }
	        this.params.parentFilterInstance(function (filterInstance) {
	            // getModelAsString should be present, as we check this
	            // in floatingFilterWrapper
	            if (filterInstance.getModelAsString) {
	                var modelAsString = filterInstance.getModelAsString(parentModel);
	                _this.eFloatingFilterText.value = modelAsString;
	            }
	        });
	    };
	    __decorate([
	        componentAnnotations_1.RefSelector('eFloatingFilterText'),
	        __metadata("design:type", HTMLInputElement)
	    ], ReadOnlyFloatingFilter.prototype, "eFloatingFilterText", void 0);
	    return ReadOnlyFloatingFilter;
	}(component_1.Component));
	exports.ReadOnlyFloatingFilter = ReadOnlyFloatingFilter;


/***/ }),
/* 2452 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var dragAndDropService_1 = __webpack_require__(2363);
	var context_1 = __webpack_require__(2333);
	var moveColumnController_1 = __webpack_require__(2453);
	var column_1 = __webpack_require__(2343);
	var bodyDropPivotTarget_1 = __webpack_require__(2454);
	var columnController_1 = __webpack_require__(2341);
	var DropType;
	(function (DropType) {
	    DropType[DropType["ColumnMove"] = 0] = "ColumnMove";
	    DropType[DropType["Pivot"] = 1] = "Pivot";
	})(DropType || (DropType = {}));
	var BodyDropTarget = /** @class */ (function () {
	    function BodyDropTarget(pinned, eContainer) {
	        this.dropListeners = {};
	        this.pinned = pinned;
	        this.eContainer = eContainer;
	    }
	    BodyDropTarget.prototype.registerGridComp = function (gridPanel) {
	        this.gridPanel = gridPanel;
	        this.moveColumnController.registerGridComp(gridPanel);
	        switch (this.pinned) {
	            case column_1.Column.PINNED_LEFT:
	                this.eSecondaryContainers = this.gridPanel.getDropTargetLeftContainers();
	                break;
	            case column_1.Column.PINNED_RIGHT:
	                this.eSecondaryContainers = this.gridPanel.getDropTargetRightContainers();
	                break;
	            default:
	                this.eSecondaryContainers = this.gridPanel.getDropTargetBodyContainers();
	                break;
	        }
	    };
	    BodyDropTarget.prototype.isInterestedIn = function (type) {
	        // not interested in row drags
	        return type === dragAndDropService_1.DragSourceType.HeaderCell || type === dragAndDropService_1.DragSourceType.ToolPanel;
	    };
	    BodyDropTarget.prototype.getSecondaryContainers = function () {
	        return this.eSecondaryContainers;
	    };
	    BodyDropTarget.prototype.getContainer = function () {
	        return this.eContainer;
	    };
	    BodyDropTarget.prototype.init = function () {
	        this.moveColumnController = new moveColumnController_1.MoveColumnController(this.pinned, this.eContainer);
	        this.context.wireBean(this.moveColumnController);
	        var bodyDropPivotTarget = new bodyDropPivotTarget_1.BodyDropPivotTarget(this.pinned);
	        this.context.wireBean(bodyDropPivotTarget);
	        this.dropListeners[DropType.ColumnMove] = this.moveColumnController;
	        this.dropListeners[DropType.Pivot] = bodyDropPivotTarget;
	        this.dragAndDropService.addDropTarget(this);
	    };
	    BodyDropTarget.prototype.getIconName = function () {
	        return this.currentDropListener.getIconName();
	    };
	    // we want to use the bodyPivotTarget if the user is dragging columns in from the toolPanel
	    // and we are in pivot mode, as it has to logic to set pivot/value/group on the columns when
	    // dropped into the grid's body.
	    BodyDropTarget.prototype.getDropType = function (draggingEvent) {
	        if (this.columnController.isPivotMode()) {
	            // in pivot mode, then if moving a column (ie didn't come from toolpanel) then it's
	            // a standard column move, however if it came from teh toolpanel, then we are introducing
	            // dimensions or values to the grid
	            if (draggingEvent.dragSource.type === dragAndDropService_1.DragSourceType.ToolPanel) {
	                return DropType.Pivot;
	            }
	            else {
	                return DropType.ColumnMove;
	            }
	        }
	        else {
	            // it's a column, and not pivot mode, so always moving
	            return DropType.ColumnMove;
	        }
	    };
	    BodyDropTarget.prototype.onDragEnter = function (draggingEvent) {
	        // we pick the drop listener depending on whether we are in pivot mode are not. if we are
	        // in pivot mode, then dropping cols changes the row group, pivot, value stats. otherwise
	        // we change visibility state and position.
	        // if (this.columnController.isPivotMode()) {
	        var dropType = this.getDropType(draggingEvent);
	        this.currentDropListener = this.dropListeners[dropType];
	        this.currentDropListener.onDragEnter(draggingEvent);
	    };
	    BodyDropTarget.prototype.onDragLeave = function (params) {
	        this.currentDropListener.onDragLeave(params);
	    };
	    BodyDropTarget.prototype.onDragging = function (params) {
	        this.currentDropListener.onDragging(params);
	    };
	    BodyDropTarget.prototype.onDragStop = function (params) {
	        this.currentDropListener.onDragStop(params);
	    };
	    __decorate([
	        context_1.Autowired('context'),
	        __metadata("design:type", context_1.Context)
	    ], BodyDropTarget.prototype, "context", void 0);
	    __decorate([
	        context_1.Autowired('dragAndDropService'),
	        __metadata("design:type", dragAndDropService_1.DragAndDropService)
	    ], BodyDropTarget.prototype, "dragAndDropService", void 0);
	    __decorate([
	        context_1.Autowired('columnController'),
	        __metadata("design:type", columnController_1.ColumnController)
	    ], BodyDropTarget.prototype, "columnController", void 0);
	    __decorate([
	        context_1.PostConstruct,
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", []),
	        __metadata("design:returntype", void 0)
	    ], BodyDropTarget.prototype, "init", null);
	    return BodyDropTarget;
	}());
	exports.BodyDropTarget = BodyDropTarget;


/***/ }),
/* 2453 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var context_1 = __webpack_require__(2333);
	var logger_1 = __webpack_require__(2332);
	var columnController_1 = __webpack_require__(2341);
	var column_1 = __webpack_require__(2343);
	var utils_1 = __webpack_require__(2325);
	var dragAndDropService_1 = __webpack_require__(2363);
	var gridOptionsWrapper_1 = __webpack_require__(2324);
	var MoveColumnController = /** @class */ (function () {
	    function MoveColumnController(pinned, eContainer) {
	        this.needToMoveLeft = false;
	        this.needToMoveRight = false;
	        this.pinned = pinned;
	        this.eContainer = eContainer;
	        this.centerContainer = !utils_1._.exists(pinned);
	    }
	    MoveColumnController.prototype.registerGridComp = function (gridPanel) {
	        this.gridPanel = gridPanel;
	    };
	    MoveColumnController.prototype.init = function () {
	        this.logger = this.loggerFactory.create('MoveColumnController');
	    };
	    MoveColumnController.prototype.getIconName = function () {
	        return this.pinned ? dragAndDropService_1.DragAndDropService.ICON_PINNED : dragAndDropService_1.DragAndDropService.ICON_MOVE;
	    };
	    MoveColumnController.prototype.onDragEnter = function (draggingEvent) {
	        // we do dummy drag, so make sure column appears in the right location when first placed
	        var columns = draggingEvent.dragItem.columns;
	        var dragCameFromToolPanel = draggingEvent.dragSource.type === dragAndDropService_1.DragSourceType.ToolPanel;
	        if (dragCameFromToolPanel) {
	            // the if statement doesn't work if drag leaves grid, then enters again
	            this.setColumnsVisible(columns, true, "uiColumnDragged");
	        }
	        else {
	            // restore previous state of visible columns upon re-entering. this means if the user drags
	            // a group out, and then drags the group back in, only columns that were originally visible
	            // will be visible again. otherwise a group with three columns (but only two visible) could
	            // be dragged out, then when it's dragged in again, all three are visible. this stops that.
	            var visibleState_1 = draggingEvent.dragItem.visibleState;
	            var visibleColumns = columns.filter(function (column) { return visibleState_1[column.getId()]; });
	            this.setColumnsVisible(visibleColumns, true, "uiColumnDragged");
	        }
	        this.setColumnsPinned(columns, this.pinned, "uiColumnDragged");
	        this.onDragging(draggingEvent, true);
	    };
	    MoveColumnController.prototype.onDragLeave = function (draggingEvent) {
	        var hideColumnOnExit = !this.gridOptionsWrapper.isSuppressDragLeaveHidesColumns() && !draggingEvent.fromNudge;
	        if (hideColumnOnExit) {
	            var dragItem = draggingEvent.dragSource.dragItemCallback();
	            var columns = dragItem.columns;
	            this.setColumnsVisible(columns, false, "uiColumnDragged");
	        }
	        this.ensureIntervalCleared();
	    };
	    MoveColumnController.prototype.setColumnsVisible = function (columns, visible, source) {
	        if (source === void 0) { source = "api"; }
	        if (columns) {
	            var allowedCols = columns.filter(function (c) { return !c.getColDef().lockVisible; });
	            this.columnController.setColumnsVisible(allowedCols, visible, source);
	        }
	    };
	    MoveColumnController.prototype.setColumnsPinned = function (columns, pinned, source) {
	        if (source === void 0) { source = "api"; }
	        if (columns) {
	            var allowedCols = columns.filter(function (c) { return !c.getColDef().lockPinned; });
	            this.columnController.setColumnsPinned(allowedCols, pinned, source);
	        }
	    };
	    MoveColumnController.prototype.onDragStop = function () {
	        this.ensureIntervalCleared();
	    };
	    MoveColumnController.prototype.normaliseX = function (x) {
	        // flip the coordinate if doing RTL
	        var flipHorizontallyForRtl = this.gridOptionsWrapper.isEnableRtl();
	        if (flipHorizontallyForRtl) {
	            var clientWidth = this.eContainer.clientWidth;
	            x = clientWidth - x;
	        }
	        // adjust for scroll only if centre container (the pinned containers dont scroll)
	        var adjustForScroll = this.centerContainer;
	        if (adjustForScroll) {
	            x += this.gridPanel.getCenterViewportScrollLeft();
	        }
	        return x;
	    };
	    MoveColumnController.prototype.checkCenterForScrolling = function (xAdjustedForScroll) {
	        if (this.centerContainer) {
	            // scroll if the mouse has gone outside the grid (or just outside the scrollable part if pinning)
	            // putting in 50 buffer, so even if user gets to edge of grid, a scroll will happen
	            var firstVisiblePixel = this.gridPanel.getCenterViewportScrollLeft();
	            var lastVisiblePixel = firstVisiblePixel + this.gridPanel.getCenterWidth();
	            if (this.gridOptionsWrapper.isEnableRtl()) {
	                this.needToMoveRight = xAdjustedForScroll < (firstVisiblePixel + 50);
	                this.needToMoveLeft = xAdjustedForScroll > (lastVisiblePixel - 50);
	            }
	            else {
	                this.needToMoveLeft = xAdjustedForScroll < (firstVisiblePixel + 50);
	                this.needToMoveRight = xAdjustedForScroll > (lastVisiblePixel - 50);
	            }
	            if (this.needToMoveLeft || this.needToMoveRight) {
	                this.ensureIntervalStarted();
	            }
	            else {
	                this.ensureIntervalCleared();
	            }
	        }
	    };
	    MoveColumnController.prototype.onDragging = function (draggingEvent, fromEnter) {
	        var _this = this;
	        if (fromEnter === void 0) { fromEnter = false; }
	        this.lastDraggingEvent = draggingEvent;
	        // if moving up or down (ie not left or right) then do nothing
	        if (utils_1._.missing(draggingEvent.hDirection)) {
	            return;
	        }
	        var mouseXNormalised = this.normaliseX(draggingEvent.x);
	        // if the user is dragging into the panel, ie coming from the side panel into the main grid,
	        // we don't want to scroll the grid this time, it would appear like the table is jumping
	        // each time a column is dragged in.
	        if (!fromEnter) {
	            this.checkCenterForScrolling(mouseXNormalised);
	        }
	        var hDirectionNormalised = this.normaliseDirection(draggingEvent.hDirection);
	        var dragSourceType = draggingEvent.dragSource.type;
	        var columnsToMove = draggingEvent.dragSource.dragItemCallback().columns;
	        columnsToMove = columnsToMove.filter(function (col) {
	            if (col.getColDef().lockPinned) {
	                // if locked return true only if both col and container are same pin type.
	                // double equals (==) here on purpose so that null==undefined is true (for not pinned options)
	                return col.getPinned() == _this.pinned;
	            }
	            else {
	                // if not pin locked, then always allowed to be in this container
	                return true;
	            }
	        });
	        this.attemptMoveColumns(dragSourceType, columnsToMove, hDirectionNormalised, mouseXNormalised, fromEnter);
	    };
	    MoveColumnController.prototype.normaliseDirection = function (hDirection) {
	        if (this.gridOptionsWrapper.isEnableRtl()) {
	            switch (hDirection) {
	                case dragAndDropService_1.HDirection.Left: return dragAndDropService_1.HDirection.Right;
	                case dragAndDropService_1.HDirection.Right: return dragAndDropService_1.HDirection.Left;
	                default: console.error("ag-Grid: Unknown direction " + hDirection);
	            }
	        }
	        else {
	            return hDirection;
	        }
	    };
	    // returns the index of the first column in the list ONLY if the cols are all beside
	    // each other. if the cols are not beside each other, then returns null
	    MoveColumnController.prototype.calculateOldIndex = function (movingCols) {
	        var gridCols = this.columnController.getAllGridColumns();
	        var indexes = [];
	        movingCols.forEach(function (col) { return indexes.push(gridCols.indexOf(col)); });
	        utils_1._.sortNumberArray(indexes);
	        var firstIndex = indexes[0];
	        var lastIndex = utils_1._.last(indexes);
	        var spread = lastIndex - firstIndex;
	        var gapsExist = spread !== indexes.length - 1;
	        return gapsExist ? null : firstIndex;
	    };
	    MoveColumnController.prototype.attemptMoveColumns = function (dragSourceType, allMovingColumns, hDirection, mouseX, fromEnter) {
	        var draggingLeft = hDirection === dragAndDropService_1.HDirection.Left;
	        var draggingRight = hDirection === dragAndDropService_1.HDirection.Right;
	        var validMoves = this.calculateValidMoves(allMovingColumns, draggingRight, mouseX);
	        // if cols are not adjacent, then this returns null. when moving, we constrain the direction of the move
	        // (ie left or right) to the mouse direction. however
	        var oldIndex = this.calculateOldIndex(allMovingColumns);
	        if (validMoves.length === 0) {
	            return;
	        }
	        var firstValidMove = validMoves[0];
	        // the two check below stop an error when the user grabs a group my a middle column, then
	        // it is possible the mouse pointer is to the right of a column while been dragged left.
	        // so we need to make sure that the mouse pointer is actually left of the left most column
	        // if moving left, and right of the right most column if moving right
	        // we check 'fromEnter' below so we move the column to the new spot if the mouse is coming from
	        // outside the grid, eg if the column is moving from side panel, mouse is moving left, then we should
	        // place the column to the RHS even if the mouse is moving left and the column is already on
	        // the LHS. otherwise we stick to the rule described above.
	        var constrainDirection = oldIndex !== null && !fromEnter;
	        // don't consider 'fromEnter' when dragging header cells, otherwise group can jump to opposite direction of drag
	        if (dragSourceType == dragAndDropService_1.DragSourceType.HeaderCell) {
	            constrainDirection = oldIndex !== null;
	        }
	        if (constrainDirection) {
	            // only allow left drag if this column is moving left
	            if (draggingLeft && firstValidMove >= oldIndex) {
	                return;
	            }
	            // only allow right drag if this column is moving right
	            if (draggingRight && firstValidMove <= oldIndex) {
	                return;
	            }
	        }
	        for (var i = 0; i < validMoves.length; i++) {
	            var move = validMoves[i];
	            if (!this.columnController.doesMovePassRules(allMovingColumns, move)) {
	                continue;
	            }
	            this.columnController.moveColumns(allMovingColumns, move, "uiColumnDragged");
	            // important to return here, so once we do the first valid move, we don't try do any more
	            return;
	        }
	    };
	    MoveColumnController.prototype.calculateValidMoves = function (movingCols, draggingRight, mouseX) {
	        // this is the list of cols on the screen, so it's these we use when comparing the x mouse position
	        var allDisplayedCols = this.columnController.getDisplayedColumns(this.pinned);
	        // but this list is the list of all cols, when we move a col it's the index within this list that gets used,
	        // so the result we return has to be and index location for this list
	        var allGridCols = this.columnController.getAllGridColumns();
	        var colIsMovingFunc = function (col) { return movingCols.indexOf(col) >= 0; };
	        var colIsNotMovingFunc = function (col) { return movingCols.indexOf(col) < 0; };
	        var movingDisplayedCols = allDisplayedCols.filter(colIsMovingFunc);
	        var otherDisplayedCols = allDisplayedCols.filter(colIsNotMovingFunc);
	        var otherGridCols = allGridCols.filter(colIsNotMovingFunc);
	        // work out how many DISPLAYED columns fit before the 'x' position. this gives us the displayIndex.
	        // for example, if cols are a,b,c,d and we find a,b fit before 'x', then we want to place the moving
	        // col between b and c (so that it is under the mouse position).
	        var displayIndex = 0;
	        var availableWidth = mouseX;
	        // if we are dragging right, then the columns will be to the left of the mouse, so we also want to
	        // include the width of the moving columns
	        if (draggingRight) {
	            var widthOfMovingDisplayedCols_1 = 0;
	            movingDisplayedCols.forEach(function (col) { return widthOfMovingDisplayedCols_1 += col.getActualWidth(); });
	            availableWidth -= widthOfMovingDisplayedCols_1;
	        }
	        if (availableWidth > 0) {
	            // now count how many of the displayed columns will fit to the left
	            for (var i = 0; i < otherDisplayedCols.length; i++) {
	                var col = otherDisplayedCols[i];
	                availableWidth -= col.getActualWidth();
	                if (availableWidth < 0) {
	                    break;
	                }
	                displayIndex++;
	            }
	            // trial and error, if going right, we adjust by one, i didn't manage to quantify why, but it works
	            if (draggingRight) {
	                displayIndex++;
	            }
	        }
	        // the display index is with respect to all the showing columns, however when we move, it's with
	        // respect to all grid columns, so we need to translate from display index to grid index
	        var firstValidMove;
	        if (displayIndex > 0) {
	            var leftColumn = otherDisplayedCols[displayIndex - 1];
	            firstValidMove = otherGridCols.indexOf(leftColumn) + 1;
	        }
	        else {
	            firstValidMove = 0;
	        }
	        var validMoves = [firstValidMove];
	        // add in other valid moves due to hidden columns and married children. for example, a particular
	        // move might break a group that has married children (so move isn't valid), however there could
	        // be hidden columns (not displayed) that we could jump over to make the move valid. because
	        // they are hidden, user doesn't see any different, however it allows moves that would otherwise
	        // not work. for example imagine a group with 9 columns and all columns are hidden except the
	        // middle one (so 4 hidden to left, 4 hidden to right), then when moving 'firstValidMove' will
	        // be relative to the not-shown column, however we need to consider the move jumping over all the
	        // hidden children. if we didn't do this, then if the group just described was at the end (RHS) of the
	        // grid, there would be no way to put a column after it (as the grid would only consider beside the
	        // visible column, which would fail valid move rules).
	        if (draggingRight) {
	            // if dragging right, then we add all the additional moves to the right. so in other words
	            // if the next move is not valid, find the next move to the right that is valid.
	            var pointer = firstValidMove + 1;
	            var lastIndex = allGridCols.length - 1;
	            while (pointer <= lastIndex) {
	                validMoves.push(pointer);
	                pointer++;
	            }
	        }
	        else {
	            // if dragging left we do the reverse of dragging right, we add in all the valid moves to the
	            // left. however we also have to consider moves to the right for all hidden columns first.
	            // (this logic is hard to reason with, it was worked out with trial and error,
	            // move observation rather than science).
	            // add moves to the right
	            var pointer = firstValidMove;
	            var lastIndex = allGridCols.length - 1;
	            var displacedCol = allGridCols[pointer];
	            while (pointer <= lastIndex && this.isColumnHidden(allDisplayedCols, displacedCol)) {
	                pointer++;
	                validMoves.push(pointer);
	                displacedCol = allGridCols[pointer];
	            }
	            // add moves to the left
	            pointer = firstValidMove - 1;
	            var firstDisplayIndex = 0;
	            while (pointer >= firstDisplayIndex) {
	                validMoves.push(pointer);
	                pointer--;
	            }
	        }
	        return validMoves;
	    };
	    // isHidden takes into account visible=false and group=closed, ie it is not displayed
	    MoveColumnController.prototype.isColumnHidden = function (displayedColumns, col) {
	        return displayedColumns.indexOf(col) < 0;
	    };
	    MoveColumnController.prototype.ensureIntervalStarted = function () {
	        if (!this.movingIntervalId) {
	            this.intervalCount = 0;
	            this.failedMoveAttempts = 0;
	            this.movingIntervalId = window.setInterval(this.moveInterval.bind(this), 100);
	            if (this.needToMoveLeft) {
	                this.dragAndDropService.setGhostIcon(dragAndDropService_1.DragAndDropService.ICON_LEFT, true);
	            }
	            else {
	                this.dragAndDropService.setGhostIcon(dragAndDropService_1.DragAndDropService.ICON_RIGHT, true);
	            }
	        }
	    };
	    MoveColumnController.prototype.ensureIntervalCleared = function () {
	        if (this.moveInterval) {
	            window.clearInterval(this.movingIntervalId);
	            this.movingIntervalId = null;
	            this.dragAndDropService.setGhostIcon(dragAndDropService_1.DragAndDropService.ICON_MOVE);
	        }
	    };
	    MoveColumnController.prototype.moveInterval = function () {
	        // the amounts we move get bigger at each interval, so the speed accelerates, starting a bit slow
	        // and getting faster. this is to give smoother user experience. we max at 100px to limit the speed.
	        var pixelsToMove;
	        this.intervalCount++;
	        pixelsToMove = 10 + (this.intervalCount * 5);
	        if (pixelsToMove > 100) {
	            pixelsToMove = 100;
	        }
	        var pixelsMoved;
	        if (this.needToMoveLeft) {
	            pixelsMoved = this.gridPanel.scrollHorizontally(-pixelsToMove);
	        }
	        else if (this.needToMoveRight) {
	            pixelsMoved = this.gridPanel.scrollHorizontally(pixelsToMove);
	        }
	        if (pixelsMoved !== 0) {
	            this.onDragging(this.lastDraggingEvent);
	            this.failedMoveAttempts = 0;
	        }
	        else {
	            // we count the failed move attempts. if we fail to move 7 times, then we pin the column.
	            // this is how we achieve pining by dragging the column to the edge of the grid.
	            this.failedMoveAttempts++;
	            var columns = this.lastDraggingEvent.dragItem.columns;
	            var columnsThatCanPin = columns.filter(function (c) { return !c.getColDef().lockPinned; });
	            if (columnsThatCanPin.length > 0) {
	                this.dragAndDropService.setGhostIcon(dragAndDropService_1.DragAndDropService.ICON_PINNED);
	                if (this.failedMoveAttempts > 7) {
	                    var pinType = this.needToMoveLeft ? column_1.Column.PINNED_LEFT : column_1.Column.PINNED_RIGHT;
	                    this.setColumnsPinned(columnsThatCanPin, pinType, "uiColumnDragged");
	                    this.dragAndDropService.nudge();
	                }
	            }
	        }
	    };
	    __decorate([
	        context_1.Autowired('loggerFactory'),
	        __metadata("design:type", logger_1.LoggerFactory)
	    ], MoveColumnController.prototype, "loggerFactory", void 0);
	    __decorate([
	        context_1.Autowired('columnController'),
	        __metadata("design:type", columnController_1.ColumnController)
	    ], MoveColumnController.prototype, "columnController", void 0);
	    __decorate([
	        context_1.Autowired('dragAndDropService'),
	        __metadata("design:type", dragAndDropService_1.DragAndDropService)
	    ], MoveColumnController.prototype, "dragAndDropService", void 0);
	    __decorate([
	        context_1.Autowired('gridOptionsWrapper'),
	        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
	    ], MoveColumnController.prototype, "gridOptionsWrapper", void 0);
	    __decorate([
	        context_1.PostConstruct,
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", []),
	        __metadata("design:returntype", void 0)
	    ], MoveColumnController.prototype, "init", null);
	    return MoveColumnController;
	}());
	exports.MoveColumnController = MoveColumnController;


/***/ }),
/* 2454 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var dragAndDropService_1 = __webpack_require__(2363);
	var columnController_1 = __webpack_require__(2341);
	var context_1 = __webpack_require__(2333);
	var gridOptionsWrapper_1 = __webpack_require__(2324);
	var BodyDropPivotTarget = /** @class */ (function () {
	    function BodyDropPivotTarget(pinned) {
	        this.columnsToAggregate = [];
	        this.columnsToGroup = [];
	        this.columnsToPivot = [];
	        this.pinned = pinned;
	    }
	    /** Callback for when drag enters */
	    BodyDropPivotTarget.prototype.onDragEnter = function (draggingEvent) {
	        var _this = this;
	        this.clearColumnsList();
	        // in pivot mode, we don't accept any drops if functions are read only
	        if (this.gridOptionsWrapper.isFunctionsReadOnly()) {
	            return;
	        }
	        var dragColumns = draggingEvent.dragItem.columns;
	        dragColumns.forEach(function (column) {
	            // we don't allow adding secondary columns
	            if (!column.isPrimary()) {
	                return;
	            }
	            if (column.isAnyFunctionActive()) {
	                return;
	            }
	            if (column.isAllowValue()) {
	                _this.columnsToAggregate.push(column);
	            }
	            else if (column.isAllowRowGroup()) {
	                _this.columnsToGroup.push(column);
	            }
	            else if (column.isAllowRowGroup()) {
	                _this.columnsToPivot.push(column);
	            }
	        });
	    };
	    BodyDropPivotTarget.prototype.getIconName = function () {
	        var totalColumns = this.columnsToAggregate.length + this.columnsToGroup.length + this.columnsToPivot.length;
	        if (totalColumns > 0) {
	            return this.pinned ? dragAndDropService_1.DragAndDropService.ICON_PINNED : dragAndDropService_1.DragAndDropService.ICON_MOVE;
	        }
	        else {
	            return null;
	        }
	    };
	    /** Callback for when drag leaves */
	    BodyDropPivotTarget.prototype.onDragLeave = function (draggingEvent) {
	        // if we are taking columns out of the center, then we remove them from the report
	        this.clearColumnsList();
	    };
	    BodyDropPivotTarget.prototype.clearColumnsList = function () {
	        this.columnsToAggregate.length = 0;
	        this.columnsToGroup.length = 0;
	        this.columnsToPivot.length = 0;
	    };
	    /** Callback for when dragging */
	    BodyDropPivotTarget.prototype.onDragging = function (draggingEvent) {
	    };
	    /** Callback for when drag stops */
	    BodyDropPivotTarget.prototype.onDragStop = function (draggingEvent) {
	        if (this.columnsToAggregate.length > 0) {
	            this.columnController.addValueColumns(this.columnsToAggregate, "toolPanelDragAndDrop");
	        }
	        if (this.columnsToGroup.length > 0) {
	            this.columnController.addRowGroupColumns(this.columnsToGroup, "toolPanelDragAndDrop");
	        }
	        if (this.columnsToPivot.length > 0) {
	            this.columnController.addPivotColumns(this.columnsToPivot, "toolPanelDragAndDrop");
	        }
	    };
	    __decorate([
	        context_1.Autowired('columnController'),
	        __metadata("design:type", columnController_1.ColumnController)
	    ], BodyDropPivotTarget.prototype, "columnController", void 0);
	    __decorate([
	        context_1.Autowired('gridOptionsWrapper'),
	        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
	    ], BodyDropPivotTarget.prototype, "gridOptionsWrapper", void 0);
	    return BodyDropPivotTarget;
	}());
	exports.BodyDropPivotTarget = BodyDropPivotTarget;


/***/ }),
/* 2455 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var context_1 = __webpack_require__(2333);
	var eventService_1 = __webpack_require__(2331);
	var events_1 = __webpack_require__(2335);
	var columnController_1 = __webpack_require__(2341);
	var columnApi_1 = __webpack_require__(2346);
	var gridApi_1 = __webpack_require__(2338);
	var gridOptionsWrapper_1 = __webpack_require__(2324);
	var ScrollVisibleService = /** @class */ (function () {
	    function ScrollVisibleService() {
	    }
	    ScrollVisibleService.prototype.setScrollsVisible = function (params) {
	        var atLeastOneDifferent = this.horizontalScrollShowing !== params.horizontalScrollShowing ||
	            this.verticalScrollShowing !== params.verticalScrollShowing;
	        if (atLeastOneDifferent) {
	            this.horizontalScrollShowing = params.horizontalScrollShowing;
	            this.verticalScrollShowing = params.verticalScrollShowing;
	            var event_1 = {
	                type: events_1.Events.EVENT_SCROLL_VISIBILITY_CHANGED,
	                api: this.gridApi,
	                columnApi: this.columnApi
	            };
	            this.eventService.dispatchEvent(event_1);
	        }
	    };
	    // used by pagination service - to know page height
	    ScrollVisibleService.prototype.isHorizontalScrollShowing = function () {
	        return this.horizontalScrollShowing;
	    };
	    // used by header container
	    ScrollVisibleService.prototype.isVerticalScrollShowing = function () {
	        return this.verticalScrollShowing;
	    };
	    __decorate([
	        context_1.Autowired('eventService'),
	        __metadata("design:type", eventService_1.EventService)
	    ], ScrollVisibleService.prototype, "eventService", void 0);
	    __decorate([
	        context_1.Autowired('columnController'),
	        __metadata("design:type", columnController_1.ColumnController)
	    ], ScrollVisibleService.prototype, "columnController", void 0);
	    __decorate([
	        context_1.Autowired('columnApi'),
	        __metadata("design:type", columnApi_1.ColumnApi)
	    ], ScrollVisibleService.prototype, "columnApi", void 0);
	    __decorate([
	        context_1.Autowired('gridApi'),
	        __metadata("design:type", gridApi_1.GridApi)
	    ], ScrollVisibleService.prototype, "gridApi", void 0);
	    __decorate([
	        context_1.Autowired('gridOptionsWrapper'),
	        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
	    ], ScrollVisibleService.prototype, "gridOptionsWrapper", void 0);
	    ScrollVisibleService = __decorate([
	        context_1.Bean('scrollVisibleService')
	    ], ScrollVisibleService);
	    return ScrollVisibleService;
	}());
	exports.ScrollVisibleService = ScrollVisibleService;


/***/ }),
/* 2456 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var gridOptionsWrapper_1 = __webpack_require__(2324);
	var columnController_1 = __webpack_require__(2341);
	var columnApi_1 = __webpack_require__(2346);
	var rowRenderer_1 = __webpack_require__(2350);
	var context_1 = __webpack_require__(2333);
	var eventService_1 = __webpack_require__(2331);
	var events_1 = __webpack_require__(2335);
	var dragService_1 = __webpack_require__(2364);
	var constants_1 = __webpack_require__(2328);
	var mouseEventService_1 = __webpack_require__(2396);
	var focusedCellController_1 = __webpack_require__(2369);
	var scrollVisibleService_1 = __webpack_require__(2455);
	var rowContainerComponent_1 = __webpack_require__(2457);
	var paginationProxy_1 = __webpack_require__(2372);
	var paginationAutoPageSizeService_1 = __webpack_require__(2458);
	var popupEditorWrapper_1 = __webpack_require__(2366);
	var alignedGridsService_1 = __webpack_require__(2438);
	var pinnedRowModel_1 = __webpack_require__(2371);
	var gridApi_1 = __webpack_require__(2338);
	var animationFrameService_1 = __webpack_require__(2418);
	var rowComp_1 = __webpack_require__(2351);
	var navigationService_1 = __webpack_require__(2459);
	var valueService_1 = __webpack_require__(2359);
	var touchListener_1 = __webpack_require__(2392);
	var dragAndDropService_1 = __webpack_require__(2363);
	var rowDragFeature_1 = __webpack_require__(2460);
	var maxDivHeightScaler_1 = __webpack_require__(2419);
	var overlayWrapperComponent_1 = __webpack_require__(2461);
	var component_1 = __webpack_require__(2353);
	var autoHeightCalculator_1 = __webpack_require__(2440);
	var columnAnimationService_1 = __webpack_require__(2375);
	var autoWidthCalculator_1 = __webpack_require__(2349);
	var beans_1 = __webpack_require__(2373);
	var componentAnnotations_1 = __webpack_require__(2384);
	var headerRootComp_1 = __webpack_require__(2446);
	var resizeObserverService_1 = __webpack_require__(2462);
	var utils_1 = __webpack_require__(2325);
	// in the html below, it is important that there are no white space between some of the divs, as if there is white space,
	// it won't render correctly in safari, as safari renders white space as a gap
	var GRID_PANEL_NORMAL_TEMPLATE = "<div class=\"ag-root ag-unselectable\" role=\"grid\" unselectable=\"on\">\n        <ag-header-root ref=\"headerRoot\" unselectable=\"on\"></ag-header-root>\n        <div class=\"ag-floating-top\" ref=\"eTop\" role=\"presentation\" unselectable=\"on\">\n            <div class=\"ag-pinned-left-floating-top\" ref=\"eLeftTop\" role=\"presentation\" unselectable=\"on\"></div>\n            <div class=\"ag-floating-top-viewport\" ref=\"eTopViewport\" role=\"presentation\" unselectable=\"on\">\n                <div class=\"ag-floating-top-container\" ref=\"eTopContainer\" role=\"presentation\" unselectable=\"on\"></div>\n            </div>\n            <div class=\"ag-pinned-right-floating-top\" ref=\"eRightTop\" role=\"presentation\" unselectable=\"on\"></div>\n            <div class=\"ag-floating-top-full-width-container\" ref=\"eTopFullWidthContainer\" role=\"presentation\" unselectable=\"on\"></div>\n        </div>\n        <div class=\"ag-body-viewport\" ref=\"eBodyViewport\" role=\"presentation\" unselectable=\"on\">\n            <div class=\"ag-pinned-left-cols-container\" ref=\"eLeftContainer\" role=\"presentation\" unselectable=\"on\"></div>\n            <div class=\"ag-center-cols-clipper\" ref=\"eCenterColsClipper\" role=\"presentation\" unselectable=\"on\">\n                <div class=\"ag-center-cols-viewport\" ref=\"eCenterViewport\" role=\"presentation\" unselectable=\"on\">\n                    <div class=\"ag-center-cols-container\" ref=\"eCenterContainer\" role=\"rowgroup\" unselectable=\"on\"></div>\n                </div>\n            </div>\n            <div class=\"ag-pinned-right-cols-container\" ref=\"eRightContainer\" role=\"presentation\" unselectable=\"on\"></div>\n            <div class=\"ag-full-width-container\" ref=\"eFullWidthContainer\" role=\"presentation\" unselectable=\"on\"></div>\n        </div>\n        <div class=\"ag-floating-bottom\" ref=\"eBottom\" role=\"presentation\" unselectable=\"on\">\n            <div class=\"ag-pinned-left-floating-bottom\" ref=\"eLeftBottom\" role=\"presentation\" unselectable=\"on\"></div>\n            <div class=\"ag-floating-bottom-viewport\" ref=\"eBottomViewport\" role=\"presentation\" unselectable=\"on\">\n                <div class=\"ag-floating-bottom-container\" ref=\"eBottomContainer\" role=\"presentation\" unselectable=\"on\"></div>\n            </div>\n            <div class=\"ag-pinned-right-floating-bottom\" ref=\"eRightBottom\" role=\"presentation\" unselectable=\"on\"></div>\n            <div class=\"ag-floating-bottom-full-width-container\" ref=\"eBottomFullWidthContainer\" role=\"presentation\" unselectable=\"on\"></div>\n        </div>\n        <div class=\"ag-body-horizontal-scroll\" ref=\"eHorizontalScrollBody\" aria-hidden=\"true\">\n            <div class=\"ag-horizontal-left-spacer\" ref=\"eHorizontalLeftSpacer\"></div>\n            <div class=\"ag-body-horizontal-scroll-viewport\" ref=\"eBodyHorizontalScrollViewport\">\n                <div class=\"ag-body-horizontal-scroll-container\" ref=\"eBodyHorizontalScrollContainer\"></div>\n            </div>\n            <div class=\"ag-horizontal-right-spacer\" ref=\"eHorizontalRightSpacer\"></div>\n        </div>\n        <ag-overlay-wrapper ref=\"overlayWrapper\"></ag-overlay-wrapper>\n    </div>";
	var GridPanel = /** @class */ (function (_super) {
	    __extends(GridPanel, _super);
	    function GridPanel() {
	        var _this = _super.call(this, GRID_PANEL_NORMAL_TEMPLATE) || this;
	        _this.scrollLeft = -1;
	        _this.scrollTop = -1;
	        _this.nextScrollTop = -1;
	        _this.resetLastHorizontalScrollElementDebounce = utils_1._.debounce(_this.resetLastHorizontalScrollElement.bind(_this), 500);
	        return _this;
	    }
	    GridPanel.prototype.getVScrollPosition = function () {
	        var result = {
	            top: this.eBodyViewport.scrollTop,
	            bottom: this.eBodyViewport.scrollTop + this.eBodyViewport.offsetHeight
	        };
	        return result;
	    };
	    GridPanel.prototype.getHScrollPosition = function () {
	        var result = {
	            left: this.eCenterViewport.scrollLeft,
	            right: this.eCenterViewport.scrollLeft + this.eCenterViewport.offsetWidth
	        };
	        return result;
	    };
	    GridPanel.prototype.onRowDataChanged = function () {
	        this.showOrHideOverlay();
	    };
	    GridPanel.prototype.showOrHideOverlay = function () {
	        var isEmpty = this.paginationProxy.isEmpty();
	        var isSuppressNoRowsOverlay = this.gridOptionsWrapper.isSuppressNoRowsOverlay();
	        var method = isEmpty && !isSuppressNoRowsOverlay ? 'showNoRowsOverlay' : 'hideOverlay';
	        this[method]();
	    };
	    GridPanel.prototype.onNewColumnsLoaded = function () {
	        // hide overlay if columns and rows exist, this can happen if columns are loaded after data.
	        // this problem exists before of the race condition between the services (column controller in this case)
	        // and the view (grid panel). if the model beans were all initialised first, and then the view beans second,
	        // this race condition would not happen.
	        if (this.columnController.isReady() && !this.paginationProxy.isEmpty()) {
	            this.hideOverlay();
	        }
	    };
	    GridPanel.prototype.init = function () {
	        var _this = this;
	        this.scrollWidth = this.gridOptionsWrapper.getScrollbarWidth();
	        this.enableRtl = this.gridOptionsWrapper.isEnableRtl();
	        this.printLayout = this.gridOptionsWrapper.getDomLayout() === constants_1.Constants.DOM_LAYOUT_PRINT;
	        // these elements have different CSS when layout changes
	        this.gridOptionsWrapper.addLayoutElement(this.getGui());
	        this.gridOptionsWrapper.addLayoutElement(this.eBodyViewport);
	        this.suppressScrollOnFloatingRow();
	        this.setupRowAnimationCssClass();
	        this.buildRowContainerComponents();
	        this.addEventListeners();
	        this.addDragListeners();
	        this.addScrollListener();
	        if (this.gridOptionsWrapper.isRowModelDefault() && !this.gridOptionsWrapper.getRowData()) {
	            this.showLoadingOverlay();
	        }
	        this.setCellTextSelection(this.gridOptionsWrapper.isEnableCellTextSelect());
	        this.setPinnedContainerSize();
	        this.setHeaderAndFloatingHeights();
	        this.disableBrowserDragging();
	        this.addMouseListeners();
	        this.addKeyboardEvents();
	        this.addBodyViewportListener();
	        this.addStopEditingWhenGridLosesFocus();
	        this.mockContextMenuForIPad();
	        this.addRowDragListener();
	        if (this.$scope) {
	            this.addAngularApplyCheck();
	        }
	        this.onDisplayedColumnsWidthChanged();
	        this.gridApi.registerGridComp(this);
	        this.alignedGridsService.registerGridComp(this);
	        this.headerRootComp.registerGridComp(this);
	        this.navigationService.registerGridComp(this);
	        this.heightScaler.registerGridComp(this);
	        this.autoHeightCalculator.registerGridComp(this);
	        this.columnAnimationService.registerGridComp(this);
	        this.autoWidthCalculator.registerGridComp(this);
	        this.paginationAutoPageSizeService.registerGridComp(this);
	        this.beans.registerGridComp(this);
	        this.rowRenderer.registerGridComp(this);
	        this.animationFrameService.registerGridComp(this);
	        if (this.rangeController) {
	            this.rangeController.registerGridComp(this);
	        }
	        [this.eCenterViewport, this.eBodyViewport].forEach(function (viewport) {
	            var unsubscribeFromResize = _this.resizeObserverService.observeResize(viewport, _this.onCenterViewportResized.bind(_this));
	            _this.addDestroyFunc(function () { return unsubscribeFromResize(); });
	        });
	    };
	    GridPanel.prototype.onDomLayoutChanged = function () {
	        var newPrintLayout = this.gridOptionsWrapper.getDomLayout() === constants_1.Constants.DOM_LAYOUT_PRINT;
	        if (this.printLayout !== newPrintLayout) {
	            this.printLayout = newPrintLayout;
	            this.setWidthsOfContainers();
	            // pinned containers are always hidden for print layout
	            this.setPinnedContainerSize();
	        }
	    };
	    GridPanel.prototype.onCenterViewportResized = function () {
	        if (utils_1._.isVisible(this.eCenterViewport)) {
	            this.checkViewportAndScrolls();
	        }
	        else {
	            this.bodyHeight = 0;
	        }
	    };
	    // used by ColumnAnimationService
	    GridPanel.prototype.setColumnMovingCss = function (moving) {
	        this.addOrRemoveCssClass('ag-column-moving', moving);
	    };
	    GridPanel.prototype.setCellTextSelection = function (selectable) {
	        if (selectable === void 0) { selectable = false; }
	        [this.eTop, this.eBodyViewport, this.eBottom]
	            .forEach(function (ct) { return utils_1._.addOrRemoveCssClass(ct, 'ag-selectable', selectable); });
	    };
	    GridPanel.prototype.addRowDragListener = function () {
	        var rowDragFeature = new rowDragFeature_1.RowDragFeature(this.eBodyViewport, this);
	        this.getContext().wireBean(rowDragFeature);
	        this.dragAndDropService.addDropTarget(rowDragFeature);
	    };
	    GridPanel.prototype.addStopEditingWhenGridLosesFocus = function () {
	        var _this = this;
	        if (!this.gridOptionsWrapper.isStopEditingWhenGridLosesFocus()) {
	            return;
	        }
	        var focusOutListener = function (event) {
	            // this is the element the focus is moving to
	            var elementWithFocus = event.relatedTarget;
	            // see if the element the focus is going to is part of the grid
	            var clickInsideGrid = false;
	            var pointer = elementWithFocus;
	            while (utils_1._.exists(pointer) && !clickInsideGrid) {
	                var isPopup = !!_this.gridOptionsWrapper.getDomData(pointer, popupEditorWrapper_1.PopupEditorWrapper.DOM_KEY_POPUP_EDITOR_WRAPPER);
	                var isBody = _this.eBodyViewport === pointer || _this.eBottom === pointer || _this.eTop === pointer;
	                clickInsideGrid = isPopup || isBody;
	                pointer = pointer.parentNode;
	            }
	            if (!clickInsideGrid) {
	                _this.rowRenderer.stopEditing();
	            }
	        };
	        this.addDestroyableEventListener(this.eBodyViewport, 'focusout', focusOutListener);
	        this.addDestroyableEventListener(this.eTop, 'focusout', focusOutListener);
	        this.addDestroyableEventListener(this.eBottom, 'focusout', focusOutListener);
	    };
	    GridPanel.prototype.addAngularApplyCheck = function () {
	        var _this = this;
	        // this makes sure if we queue up requests, we only execute oe
	        var applyTriggered = false;
	        var listener = function () {
	            // only need to do one apply at a time
	            if (applyTriggered) {
	                return;
	            }
	            applyTriggered = true; // mark 'need apply' to true
	            window.setTimeout(function () {
	                applyTriggered = false;
	                _this.$scope.$apply();
	            }, 0);
	        };
	        // these are the events we need to do an apply after - these are the ones that can end up
	        // with columns added or removed
	        this.addDestroyableEventListener(this.eventService, events_1.Events.EVENT_DISPLAYED_COLUMNS_CHANGED, listener);
	        this.addDestroyableEventListener(this.eventService, events_1.Events.EVENT_VIRTUAL_COLUMNS_CHANGED, listener);
	    };
	    // if we do not do this, then the user can select a pic in the grid (eg an image in a custom cell renderer)
	    // and then that will start the browser native drag n' drop, which messes up with our own drag and drop.
	    GridPanel.prototype.disableBrowserDragging = function () {
	        this.addGuiEventListener('dragstart', function (event) {
	            if (event.target instanceof HTMLImageElement) {
	                event.preventDefault();
	                return false;
	            }
	        });
	    };
	    GridPanel.prototype.addEventListeners = function () {
	        this.addDestroyableEventListener(this.eventService, events_1.Events.EVENT_DISPLAYED_COLUMNS_CHANGED, this.onDisplayedColumnsChanged.bind(this));
	        this.addDestroyableEventListener(this.eventService, events_1.Events.EVENT_DISPLAYED_COLUMNS_WIDTH_CHANGED, this.onDisplayedColumnsWidthChanged.bind(this));
	        this.addDestroyableEventListener(this.eventService, events_1.Events.EVENT_PINNED_ROW_DATA_CHANGED, this.setHeaderAndFloatingHeights.bind(this));
	        this.addDestroyableEventListener(this.eventService, events_1.Events.EVENT_ROW_DATA_CHANGED, this.onRowDataChanged.bind(this));
	        this.addDestroyableEventListener(this.eventService, events_1.Events.EVENT_ROW_DATA_UPDATED, this.onRowDataChanged.bind(this));
	        this.addDestroyableEventListener(this.eventService, events_1.Events.EVENT_NEW_COLUMNS_LOADED, this.onNewColumnsLoaded.bind(this));
	        this.addDestroyableEventListener(this.gridOptionsWrapper, gridOptionsWrapper_1.GridOptionsWrapper.PROP_HEADER_HEIGHT, this.setHeaderAndFloatingHeights.bind(this));
	        this.addDestroyableEventListener(this.gridOptionsWrapper, gridOptionsWrapper_1.GridOptionsWrapper.PROP_PIVOT_HEADER_HEIGHT, this.setHeaderAndFloatingHeights.bind(this));
	        this.addDestroyableEventListener(this.gridOptionsWrapper, gridOptionsWrapper_1.GridOptionsWrapper.PROP_GROUP_HEADER_HEIGHT, this.setHeaderAndFloatingHeights.bind(this));
	        this.addDestroyableEventListener(this.gridOptionsWrapper, gridOptionsWrapper_1.GridOptionsWrapper.PROP_PIVOT_GROUP_HEADER_HEIGHT, this.setHeaderAndFloatingHeights.bind(this));
	        this.addDestroyableEventListener(this.gridOptionsWrapper, gridOptionsWrapper_1.GridOptionsWrapper.PROP_FLOATING_FILTERS_HEIGHT, this.setHeaderAndFloatingHeights.bind(this));
	        this.addDestroyableEventListener(this.gridOptionsWrapper, gridOptionsWrapper_1.GridOptionsWrapper.PROP_DOM_LAYOUT, this.onDomLayoutChanged.bind(this));
	    };
	    GridPanel.prototype.addDragListeners = function () {
	        var _this = this;
	        if (!this.gridOptionsWrapper.isEnableRangeSelection() || // no range selection if no property
	            utils_1._.missing(this.rangeController) // no range selection if not enterprise version
	        ) {
	            return;
	        }
	        var containers = [
	            this.eLeftContainer,
	            this.eRightContainer,
	            this.eCenterContainer,
	            this.eTop,
	            this.eBottom
	        ];
	        containers.forEach(function (container) {
	            var params = {
	                eElement: container,
	                onDragStart: _this.rangeController.onDragStart.bind(_this.rangeController),
	                onDragStop: _this.rangeController.onDragStop.bind(_this.rangeController),
	                onDragging: _this.rangeController.onDragging.bind(_this.rangeController)
	            };
	            _this.dragService.addDragSource(params);
	            _this.addDestroyFunc(function () { return _this.dragService.removeDragSource(params); });
	        });
	    };
	    GridPanel.prototype.addMouseListeners = function () {
	        var _this = this;
	        var eventNames = ['click', 'mousedown', 'dblclick', 'contextmenu', 'mouseover', 'mouseout'];
	        eventNames.forEach(function (eventName) {
	            var listener = _this.processMouseEvent.bind(_this, eventName);
	            _this.eAllCellContainers.forEach(function (container) {
	                return _this.addDestroyableEventListener(container, eventName, listener);
	            });
	        });
	    };
	    GridPanel.prototype.addKeyboardEvents = function () {
	        var _this = this;
	        var eventNames = ['keydown', 'keypress'];
	        eventNames.forEach(function (eventName) {
	            var listener = _this.processKeyboardEvent.bind(_this, eventName);
	            _this.eAllCellContainers.forEach(function (container) {
	                _this.addDestroyableEventListener(container, eventName, listener);
	            });
	        });
	    };
	    GridPanel.prototype.addBodyViewportListener = function () {
	        var _this = this;
	        // we want to listen for clicks directly on the eBodyViewport, so the user has a way of showing
	        // the context menu if no rows or columns are displayed, or user simply clicks outside of a cell
	        var listener = function (mouseEvent) {
	            var target = utils_1._.getTarget(mouseEvent);
	            if (target === _this.eBodyViewport || target === _this.eCenterViewport) {
	                // show it
	                _this.onContextMenu(mouseEvent, null, null, null, null);
	                _this.preventDefaultOnContextMenu(mouseEvent);
	            }
	        };
	        this.addDestroyableEventListener(this.eBodyViewport, 'contextmenu', listener);
	    };
	    // + rangeController - used to know when to scroll when user is dragging outside the
	    // main viewport while doing a range selection
	    GridPanel.prototype.getBodyClientRect = function () {
	        if (!this.eBodyViewport) {
	            return;
	        }
	        return this.eBodyViewport.getBoundingClientRect();
	    };
	    GridPanel.prototype.getRowForEvent = function (event) {
	        var sourceElement = utils_1._.getTarget(event);
	        while (sourceElement) {
	            var renderedRow = this.gridOptionsWrapper.getDomData(sourceElement, rowComp_1.RowComp.DOM_DATA_KEY_RENDERED_ROW);
	            if (renderedRow) {
	                return renderedRow;
	            }
	            sourceElement = sourceElement.parentElement;
	        }
	        return null;
	    };
	    GridPanel.prototype.processKeyboardEvent = function (eventName, keyboardEvent) {
	        var cellComp = utils_1._.getCellCompForEvent(this.gridOptionsWrapper, keyboardEvent);
	        if (!cellComp) {
	            return;
	        }
	        var rowNode = cellComp.getRenderedRow().getRowNode();
	        var column = cellComp.getColumn();
	        var editing = cellComp.isEditing();
	        var gridProcessingAllowed = !utils_1._.isUserSuppressingKeyboardEvent(this.gridOptionsWrapper, keyboardEvent, rowNode, column, editing);
	        if (gridProcessingAllowed) {
	            switch (eventName) {
	                case 'keydown':
	                    // first see if it's a scroll key, page up / down, home / end etc
	                    var wasScrollKey = !editing && this.navigationService.handlePageScrollingKey(keyboardEvent);
	                    // if not a scroll key, then we pass onto cell
	                    if (!wasScrollKey) {
	                        cellComp.onKeyDown(keyboardEvent);
	                    }
	                    this.doClipboardOperations(keyboardEvent, cellComp);
	                    break;
	                case 'keypress':
	                    cellComp.onKeyPress(keyboardEvent);
	                    break;
	            }
	        }
	        if (eventName === 'keydown') {
	            var cellKeyDownEvent = cellComp.createEvent(keyboardEvent, events_1.Events.EVENT_CELL_KEY_DOWN);
	            this.beans.eventService.dispatchEvent(cellKeyDownEvent);
	        }
	        if (eventName === 'keypress') {
	            var cellKeyPressEvent = cellComp.createEvent(keyboardEvent, events_1.Events.EVENT_CELL_KEY_PRESS);
	            this.beans.eventService.dispatchEvent(cellKeyPressEvent);
	        }
	    };
	    GridPanel.prototype.doClipboardOperations = function (keyboardEvent, cellComp) {
	        // check if ctrl or meta key pressed
	        if (!keyboardEvent.ctrlKey && !keyboardEvent.metaKey) {
	            return;
	        }
	        // if the cell the event came from is editing, then we do not
	        // want to do the default shortcut keys, otherwise the editor
	        // (eg a text field) would not be able to do the normal cut/copy/paste
	        if (cellComp.isEditing()) {
	            return;
	        }
	        // for copy / paste, we don't want to execute when the event
	        // was from a child grid (happens in master detail)
	        if (!this.mouseEventService.isEventFromThisGrid(keyboardEvent)) {
	            return;
	        }
	        switch (keyboardEvent.which) {
	            case constants_1.Constants.KEY_A:
	                return this.onCtrlAndA(keyboardEvent);
	            case constants_1.Constants.KEY_C:
	                return this.onCtrlAndC(keyboardEvent);
	            case constants_1.Constants.KEY_V:
	                return this.onCtrlAndV();
	            case constants_1.Constants.KEY_D:
	                return this.onCtrlAndD(keyboardEvent);
	        }
	    };
	    // gets called by rowRenderer when new data loaded, as it will want to scroll to the top
	    GridPanel.prototype.scrollToTop = function () {
	        this.eBodyViewport.scrollTop = 0;
	    };
	    GridPanel.prototype.processMouseEvent = function (eventName, mouseEvent) {
	        if (!this.mouseEventService.isEventFromThisGrid(mouseEvent) ||
	            utils_1._.isStopPropagationForAgGrid(mouseEvent)) {
	            return;
	        }
	        var rowComp = this.getRowForEvent(mouseEvent);
	        var cellComp = this.mouseEventService.getRenderedCellForEvent(mouseEvent);
	        if (eventName === "contextmenu") {
	            this.handleContextMenuMouseEvent(mouseEvent, null, rowComp, cellComp);
	        }
	        else {
	            if (cellComp) {
	                cellComp.onMouseEvent(eventName, mouseEvent);
	            }
	            if (rowComp) {
	                rowComp.onMouseEvent(eventName, mouseEvent);
	            }
	        }
	        this.preventDefaultOnContextMenu(mouseEvent);
	    };
	    GridPanel.prototype.mockContextMenuForIPad = function () {
	        var _this = this;
	        // we do NOT want this when not in iPad, otherwise we will be doing
	        if (!utils_1._.isUserAgentIPad()) {
	            return;
	        }
	        this.eAllCellContainers.forEach(function (container) {
	            var touchListener = new touchListener_1.TouchListener(container);
	            var longTapListener = function (event) {
	                var rowComp = _this.getRowForEvent(event.touchEvent);
	                var cellComp = _this.mouseEventService.getRenderedCellForEvent(event.touchEvent);
	                _this.handleContextMenuMouseEvent(null, event.touchEvent, rowComp, cellComp);
	            };
	            _this.addDestroyableEventListener(touchListener, touchListener_1.TouchListener.EVENT_LONG_TAP, longTapListener);
	            _this.addDestroyFunc(function () { return touchListener.destroy(); });
	        });
	    };
	    GridPanel.prototype.handleContextMenuMouseEvent = function (mouseEvent, touchEvent, rowComp, cellComp) {
	        var rowNode = rowComp ? rowComp.getRowNode() : null;
	        var column = cellComp ? cellComp.getColumn() : null;
	        var value = null;
	        if (column) {
	            var event_1 = mouseEvent ? mouseEvent : touchEvent;
	            cellComp.dispatchCellContextMenuEvent(event_1);
	            value = this.valueService.getValue(column, rowNode);
	        }
	        this.onContextMenu(mouseEvent, touchEvent, rowNode, column, value);
	    };
	    GridPanel.prototype.onContextMenu = function (mouseEvent, touchEvent, rowNode, column, value) {
	        // to allow us to debug in chrome, we ignore the event if ctrl is pressed.
	        // not everyone wants this, so first 'if' below allows to turn this hack off.
	        if (!this.gridOptionsWrapper.isAllowContextMenuWithControlKey()) {
	            // then do the check
	            if (mouseEvent && (mouseEvent.ctrlKey || mouseEvent.metaKey)) {
	                return;
	            }
	        }
	        if (this.contextMenuFactory && !this.gridOptionsWrapper.isSuppressContextMenu()) {
	            var eventOrTouch = mouseEvent ? mouseEvent : touchEvent.touches[0];
	            this.contextMenuFactory.showMenu(rowNode, column, value, eventOrTouch);
	            var event_2 = mouseEvent ? mouseEvent : touchEvent;
	            event_2.preventDefault();
	        }
	    };
	    GridPanel.prototype.preventDefaultOnContextMenu = function (mouseEvent) {
	        // if we don't do this, then middle click will never result in a 'click' event, as 'mousedown'
	        // will be consumed by the browser to mean 'scroll' (as you can scroll with the middle mouse
	        // button in the browser). so this property allows the user to receive middle button clicks if
	        // they want.
	        var gridOptionsWrapper = this.gridOptionsWrapper;
	        var which = mouseEvent.which;
	        if (gridOptionsWrapper.isPreventDefaultOnContextMenu() ||
	            (gridOptionsWrapper.isSuppressMiddleClickScrolls() && which === 2)) {
	            mouseEvent.preventDefault();
	        }
	    };
	    GridPanel.prototype.onCtrlAndA = function (event) {
	        var _a = this, columnController = _a.columnController, pinnedRowModel = _a.pinnedRowModel, paginationProxy = _a.paginationProxy, rangeController = _a.rangeController;
	        var PINNED_BOTTOM = constants_1.Constants.PINNED_BOTTOM, PINNED_TOP = constants_1.Constants.PINNED_TOP;
	        if (rangeController && paginationProxy.isRowsToRender()) {
	            var _b = [
	                pinnedRowModel.isEmpty(PINNED_TOP),
	                pinnedRowModel.isEmpty(PINNED_BOTTOM)
	            ], isEmptyPinnedTop = _b[0], isEmptyPinnedBottom = _b[1];
	            var floatingStart = isEmptyPinnedTop ? null : PINNED_TOP;
	            var floatingEnd = void 0;
	            var rowEnd = void 0;
	            if (isEmptyPinnedBottom) {
	                floatingEnd = null;
	                rowEnd = this.paginationProxy.getRowCount() - 1;
	            }
	            else {
	                floatingEnd = PINNED_BOTTOM;
	                rowEnd = pinnedRowModel.getPinnedBottomRowData().length - 1;
	            }
	            var allDisplayedColumns = columnController.getAllDisplayedColumns();
	            if (utils_1._.missingOrEmpty(allDisplayedColumns)) {
	                return;
	            }
	            rangeController.setCellRange({
	                rowStartIndex: 0,
	                rowStartPinned: floatingStart,
	                rowEndIndex: rowEnd,
	                rowEndPinned: floatingEnd,
	                columnStart: allDisplayedColumns[0],
	                columnEnd: utils_1._.last(allDisplayedColumns)
	            });
	        }
	        event.preventDefault();
	    };
	    GridPanel.prototype.onCtrlAndC = function (event) {
	        if (!this.clipboardService || this.gridOptionsWrapper.isEnableCellTextSelection()) {
	            return;
	        }
	        var focusedCell = this.focusedCellController.getFocusedCell();
	        this.clipboardService.copyToClipboard();
	        event.preventDefault();
	        // the copy operation results in loosing focus on the cell,
	        // because of the trickery the copy logic uses with a temporary
	        // widget. so we set it back again.
	        if (focusedCell) {
	            this.focusedCellController.setFocusedCell(focusedCell.rowIndex, focusedCell.column, focusedCell.rowPinned, true);
	        }
	    };
	    GridPanel.prototype.onCtrlAndV = function () {
	        if (!this.enterprise || this.gridOptionsWrapper.isSuppressClipboardPaste()) {
	            return;
	        }
	        this.clipboardService.pasteFromClipboard();
	    };
	    GridPanel.prototype.onCtrlAndD = function (event) {
	        if (!this.enterprise) {
	            return;
	        }
	        this.clipboardService.copyRangeDown();
	        event.preventDefault();
	    };
	    // Valid values for position are bottom, middle and top
	    // position should be {'top','middle','bottom', or undefined/null}.
	    // if undefined/null, then the grid will to the minimal amount of scrolling,
	    // eg if grid needs to scroll up, it scrolls until row is on top,
	    //    if grid needs to scroll down, it scrolls until row is on bottom,
	    //    if row is already in view, grid does not scroll
	    // fixme - how does this work in the new way
	    GridPanel.prototype.ensureIndexVisible = function (index, position) {
	        // if for print or auto height, everything is always visible
	        if (this.printLayout) {
	            return;
	        }
	        var rowCount = this.paginationProxy.getRowCount();
	        if (typeof index !== 'number' || index < 0 || index >= rowCount) {
	            console.warn('invalid row index for ensureIndexVisible: ' + index);
	            return;
	        }
	        this.paginationProxy.goToPageWithIndex(index);
	        var rowNode = this.paginationProxy.getRow(index);
	        var rowGotShiftedDuringOperation;
	        do {
	            var startingRowTop = rowNode.rowTop;
	            var startingRowHeight = rowNode.rowHeight;
	            var paginationOffset = this.paginationProxy.getPixelOffset();
	            var rowTopPixel = rowNode.rowTop - paginationOffset;
	            var rowBottomPixel = rowTopPixel + rowNode.rowHeight;
	            var scrollPosition = this.getVScrollPosition();
	            var heightOffset = this.heightScaler.getOffset();
	            var vScrollTop = scrollPosition.top + heightOffset;
	            var vScrollBottom = scrollPosition.bottom + heightOffset;
	            var viewportHeight = vScrollBottom - vScrollTop;
	            // work out the pixels for top, middle and bottom up front,
	            // make the if/else below easier to read
	            var pxTop = this.heightScaler.getScrollPositionForPixel(rowTopPixel);
	            var pxBottom = this.heightScaler.getScrollPositionForPixel(rowBottomPixel - viewportHeight);
	            // make sure if middle, the row is not outside the top of the grid
	            var pxMiddle = Math.min((pxTop + pxBottom) / 2, rowTopPixel);
	            var rowBelowViewport = vScrollTop > rowTopPixel;
	            var rowAboveViewport = vScrollBottom < rowBottomPixel;
	            var newScrollPosition = null;
	            if (position === 'top') {
	                newScrollPosition = pxTop;
	            }
	            else if (position === 'bottom') {
	                newScrollPosition = pxBottom;
	            }
	            else if (position === 'middle') {
	                newScrollPosition = pxMiddle;
	            }
	            else if (rowBelowViewport) {
	                // if row is before, scroll up with row at top
	                newScrollPosition = pxTop;
	            }
	            else if (rowAboveViewport) {
	                // if row is below, scroll down with row at bottom
	                newScrollPosition = pxBottom;
	            }
	            if (newScrollPosition !== null) {
	                this.eBodyViewport.scrollTop = newScrollPosition;
	                this.rowRenderer.redrawAfterScroll();
	            }
	            // the row can get shifted if during the rendering (during rowRenderer.redrawAfterScroll()),
	            // the height of a row changes due to lazy calculation of row heights when using
	            // colDef.autoHeight or gridOptions.getRowHeight.
	            // if row was shifted, then the position we scrolled to is incorrect.
	            rowGotShiftedDuringOperation = (startingRowTop !== rowNode.rowTop)
	                || (startingRowHeight !== rowNode.rowHeight);
	        } while (rowGotShiftedDuringOperation);
	        // so when we return back to user, the cells have rendered
	        this.animationFrameService.flushAllFrames();
	    };
	    // + moveColumnController
	    GridPanel.prototype.getCenterWidth = function () {
	        return this.eCenterViewport.clientWidth;
	    };
	    GridPanel.prototype.isVerticalScrollShowing = function () {
	        var isAlwaysShowVerticalScroll = this.gridOptionsWrapper.isAlwaysShowVerticalScroll();
	        utils_1._.addOrRemoveCssClass(this.eBodyViewport, 'ag-force-vertical-scroll', isAlwaysShowVerticalScroll);
	        return isAlwaysShowVerticalScroll || utils_1._.isVerticalScrollShowing(this.eBodyViewport);
	    };
	    GridPanel.prototype.isHorizontalScrollShowing = function () {
	        return utils_1._.isHorizontalScrollShowing(this.eCenterViewport);
	    };
	    // gets called every time the viewport size changes. we use this to check visibility of scrollbars
	    // in the grid panel, and also to check size and position of viewport for row and column virtualisation.
	    GridPanel.prototype.checkViewportAndScrolls = function () {
	        // results in updating anything that depends on scroll showing
	        this.updateScrollVisibleService();
	        // fires event if height changes, used by PaginationService, HeightScalerService, RowRenderer
	        this.checkBodyHeight();
	        // check for virtual columns for ColumnController
	        this.onHorizontalViewportChanged();
	        this.setPinnedContainerSize();
	    };
	    GridPanel.prototype.updateScrollVisibleService = function () {
	        // because of column animation (which takes 200ms), we have to do this twice.
	        // eg if user removes cols anywhere except at the RHS, then the cols on the RHS
	        // will animate to the left to fill the gap. this animation means just after
	        // the cols are removed, the remaining cols are still in the original location
	        // at the start of the animation, so pre animation the H scrollbar is still needed,
	        // but post animation it is not.
	        this.updateScrollVisibleServiceImpl();
	        setTimeout(this.updateScrollVisibleServiceImpl.bind(this), 500);
	    };
	    GridPanel.prototype.updateScrollVisibleServiceImpl = function () {
	        var params = {
	            horizontalScrollShowing: false,
	            verticalScrollShowing: false
	        };
	        params.verticalScrollShowing = this.isVerticalScrollShowing();
	        params.horizontalScrollShowing = this.isHorizontalScrollShowing();
	        this.scrollVisibleService.setScrollsVisible(params);
	        this.setHorizontalScrollVisible(params.horizontalScrollShowing);
	        this.setVerticalScrollPaddingVisible(params.verticalScrollShowing);
	    };
	    GridPanel.prototype.setHorizontalScrollVisible = function (visible) {
	        var isSuppressHorizontalScroll = this.gridOptionsWrapper.isSuppressHorizontalScroll();
	        var scrollSize = visible ? (this.gridOptionsWrapper.getScrollbarWidth() || 0) : 0;
	        var scrollContainerSize = !isSuppressHorizontalScroll ? scrollSize : 0;
	        var addIEPadding = utils_1._.isBrowserIE() && visible;
	        this.eCenterViewport.style.height = "calc(100% + " + scrollSize + "px)";
	        utils_1._.setFixedHeight(this.eHorizontalScrollBody, scrollContainerSize);
	        // we have to add an extra pixel to the scroller viewport on IE because
	        // if the container has the same size as the scrollbar, the scroll button won't work
	        utils_1._.setFixedHeight(this.eBodyHorizontalScrollViewport, scrollContainerSize + (addIEPadding ? 1 : 0));
	        utils_1._.setFixedHeight(this.eBodyHorizontalScrollContainer, scrollContainerSize);
	    };
	    GridPanel.prototype.setVerticalScrollPaddingVisible = function (show) {
	        var scroller = show ? "scroll" : "hidden";
	        this.eTop.style.overflowY = this.eBottom.style.overflowY = scroller;
	        this.setFakeHScrollSpacerWidths();
	    };
	    GridPanel.prototype.updateRowCount = function () {
	        var headerCount = this.headerRootComp.getHeaderRowCount();
	        var rowCount = this.paginationProxy.getRowCount();
	        var total = (headerCount + rowCount).toString();
	        this.getGui().setAttribute('aria-rowcount', total);
	    };
	    GridPanel.prototype.ensureColumnVisible = function (key) {
	        var column = this.columnController.getGridColumn(key);
	        if (!column) {
	            return;
	        }
	        if (column.isPinned()) {
	            console.warn('calling ensureIndexVisible on a ' + column.getPinned() + ' pinned column doesn\'t make sense for column ' + column.getColId());
	            return;
	        }
	        if (!this.columnController.isColumnDisplayed(column)) {
	            console.warn('column is not currently visible');
	            return;
	        }
	        var colLeftPixel = column.getLeft();
	        var colRightPixel = colLeftPixel + column.getActualWidth();
	        var viewportWidth = this.eCenterViewport.clientWidth;
	        var scrollPosition = this.getCenterViewportScrollLeft();
	        var bodyWidth = this.columnController.getBodyContainerWidth();
	        var viewportLeftPixel;
	        var viewportRightPixel;
	        // the logic of working out left and right viewport px is both here and in the ColumnController,
	        // need to refactor it out to one place
	        if (this.enableRtl) {
	            viewportLeftPixel = bodyWidth - scrollPosition - viewportWidth;
	            viewportRightPixel = bodyWidth - scrollPosition;
	        }
	        else {
	            viewportLeftPixel = scrollPosition;
	            viewportRightPixel = viewportWidth + scrollPosition;
	        }
	        var viewportScrolledPastCol = viewportLeftPixel > colLeftPixel;
	        var viewportScrolledBeforeCol = viewportRightPixel < colRightPixel;
	        var colToSmallForViewport = viewportWidth < column.getActualWidth();
	        var alignColToLeft = viewportScrolledPastCol || colToSmallForViewport;
	        var alignColToRight = viewportScrolledBeforeCol;
	        var newScrollPosition = this.getCenterViewportScrollLeft();
	        if (alignColToLeft || alignColToRight) {
	            if (this.enableRtl) {
	                newScrollPosition = alignColToLeft ? (bodyWidth - viewportWidth - colLeftPixel) : (bodyWidth - colRightPixel);
	            }
	            else {
	                newScrollPosition = alignColToLeft ? colLeftPixel : (colRightPixel - viewportWidth);
	            }
	            this.setCenterViewportScrollLeft(newScrollPosition);
	        }
	        else {
	            // otherwise, col is already in view, so do nothing
	        }
	        // this will happen anyway, as the move will cause a 'scroll' event on the body, however
	        // it is possible that the ensureColumnVisible method is called from within ag-Grid and
	        // the caller will need to have the columns rendered to continue, which will be before
	        // the event has been worked on (which is the case for cell navigation).
	        this.onHorizontalViewportChanged();
	        // so when we return back to user, the cells have rendered
	        this.animationFrameService.flushAllFrames();
	    };
	    GridPanel.prototype.showLoadingOverlay = function () {
	        if (!this.gridOptionsWrapper.isSuppressLoadingOverlay()) {
	            this.overlayWrapper.showLoadingOverlay();
	        }
	    };
	    GridPanel.prototype.showNoRowsOverlay = function () {
	        if (!this.gridOptionsWrapper.isSuppressNoRowsOverlay()) {
	            this.overlayWrapper.showNoRowsOverlay();
	        }
	    };
	    GridPanel.prototype.hideOverlay = function () {
	        this.overlayWrapper.hideOverlay();
	    };
	    // method will call itself if no available width. this covers if the grid
	    // isn't visible, but is just about to be visible.
	    GridPanel.prototype.sizeColumnsToFit = function (nextTimeout) {
	        var _this = this;
	        var availableWidth = this.eBodyViewport.clientWidth;
	        if (availableWidth > 0) {
	            this.columnController.sizeColumnsToFit(availableWidth, "sizeColumnsToFit");
	            return;
	        }
	        if (nextTimeout === undefined) {
	            window.setTimeout(function () {
	                _this.sizeColumnsToFit(100);
	            }, 0);
	        }
	        else if (nextTimeout === 100) {
	            window.setTimeout(function () {
	                _this.sizeColumnsToFit(500);
	            }, 100);
	        }
	        else if (nextTimeout === 500) {
	            window.setTimeout(function () {
	                _this.sizeColumnsToFit(-1);
	            }, 500);
	        }
	        else {
	            console.warn('ag-Grid: tried to call sizeColumnsToFit() but the grid is coming back with ' +
	                'zero width, maybe the grid is not visible yet on the screen?');
	        }
	    };
	    // used by autoWidthCalculator and autoHeightCalculator
	    GridPanel.prototype.getCenterContainer = function () {
	        return this.eCenterContainer;
	    };
	    GridPanel.prototype.getDropTargetBodyContainers = function () {
	        return [this.eCenterViewport, this.eTopViewport, this.eBottomViewport];
	    };
	    GridPanel.prototype.getDropTargetLeftContainers = function () {
	        return [this.eLeftContainer, this.eLeftBottom, this.eLeftTop];
	    };
	    GridPanel.prototype.getDropTargetRightContainers = function () {
	        return [this.eRightContainer, this.eRightBottom, this.eRightTop];
	    };
	    GridPanel.prototype.buildRowContainerComponents = function () {
	        var _this = this;
	        this.eAllCellContainers = [
	            this.eLeftContainer, this.eRightContainer, this.eCenterContainer,
	            this.eTop, this.eBottom, this.eFullWidthContainer
	        ];
	        this.rowContainerComponents = {
	            body: new rowContainerComponent_1.RowContainerComponent({
	                eContainer: this.eCenterContainer,
	                eWrapper: this.eCenterColsClipper,
	                eViewport: this.eBodyViewport
	            }),
	            fullWidth: new rowContainerComponent_1.RowContainerComponent({
	                eContainer: this.eFullWidthContainer
	            }),
	            pinnedLeft: new rowContainerComponent_1.RowContainerComponent({ eContainer: this.eLeftContainer }),
	            pinnedRight: new rowContainerComponent_1.RowContainerComponent({ eContainer: this.eRightContainer }),
	            floatingTop: new rowContainerComponent_1.RowContainerComponent({ eContainer: this.eTopContainer }),
	            floatingTopPinnedLeft: new rowContainerComponent_1.RowContainerComponent({ eContainer: this.eLeftTop }),
	            floatingTopPinnedRight: new rowContainerComponent_1.RowContainerComponent({ eContainer: this.eRightTop }),
	            floatingTopFullWidth: new rowContainerComponent_1.RowContainerComponent({
	                eContainer: this.eTopFullWidthContainer,
	                hideWhenNoChildren: true
	            }),
	            floatingBottom: new rowContainerComponent_1.RowContainerComponent({ eContainer: this.eBottomContainer }),
	            floatingBottomPinnedLeft: new rowContainerComponent_1.RowContainerComponent({ eContainer: this.eLeftBottom }),
	            floatingBottomPinnedRight: new rowContainerComponent_1.RowContainerComponent({ eContainer: this.eRightBottom }),
	            floatingBottomFullWith: new rowContainerComponent_1.RowContainerComponent({
	                eContainer: this.eBottomFullWidthContainer,
	                hideWhenNoChildren: true
	            }),
	        };
	        utils_1._.iterateObject(this.rowContainerComponents, function (key, container) {
	            if (container) {
	                _this.getContext().wireBean(container);
	            }
	        });
	    };
	    GridPanel.prototype.setupRowAnimationCssClass = function () {
	        var _this = this;
	        var listener = function () {
	            // we don't want to use row animation if scaling, as rows jump strangely as you scroll,
	            // when scaling and doing row animation.
	            var animateRows = _this.gridOptionsWrapper.isAnimateRows() && !_this.heightScaler.isScaling();
	            utils_1._.addOrRemoveCssClass(_this.eBodyViewport, 'ag-row-animation', animateRows);
	            utils_1._.addOrRemoveCssClass(_this.eBodyViewport, 'ag-row-no-animation', !animateRows);
	        };
	        listener();
	        this.addDestroyableEventListener(this.eventService, events_1.Events.EVENT_HEIGHT_SCALE_CHANGED, listener);
	    };
	    // when editing a pinned row, if the cell is half outside the scrollable area, the browser can
	    // scroll the column into view. we do not want this, the pinned sections should never scroll.
	    // so we listen to scrolls on these containers and reset the scroll if we find one.
	    GridPanel.prototype.suppressScrollOnFloatingRow = function () {
	        var _this = this;
	        var resetTopScroll = function () { return _this.eTopViewport.scrollLeft = 0; };
	        var resetBottomScroll = function () { return _this.eTopViewport.scrollLeft = 0; };
	        this.addDestroyableEventListener(this.eTopViewport, 'scroll', resetTopScroll);
	        this.addDestroyableEventListener(this.eBottomViewport, 'scroll', resetBottomScroll);
	    };
	    GridPanel.prototype.getRowContainers = function () {
	        return this.rowContainerComponents;
	    };
	    GridPanel.prototype.getFloatingTopBottom = function () {
	        return [this.eTop, this.eBottom];
	    };
	    GridPanel.prototype.onDisplayedColumnsChanged = function () {
	        this.setPinnedContainerSize();
	        this.setHeaderAndFloatingHeights();
	        this.onHorizontalViewportChanged();
	        this.updateScrollVisibleService();
	    };
	    GridPanel.prototype.onDisplayedColumnsWidthChanged = function () {
	        this.setWidthsOfContainers();
	        this.onHorizontalViewportChanged();
	        this.updateScrollVisibleService();
	        if (this.enableRtl) {
	            // because RTL is all backwards, a change in the width of the row
	            // can cause a change in the scroll position, without a scroll event,
	            // because the scroll position in RTL is a function that depends on
	            // the width. to be convinced of this, take out this line, enable RTL,
	            // scroll all the way to the left and then resize a column
	            this.horizontallyScrollHeaderCenterAndFloatingCenter();
	        }
	    };
	    GridPanel.prototype.setWidthsOfContainers = function () {
	        this.setCenterWidth();
	        this.setPinnedContainerSize();
	    };
	    GridPanel.prototype.setCenterWidth = function () {
	        var width = this.columnController.getBodyContainerWidth();
	        if (this.printLayout) {
	            var pinnedContainerWidths = this.columnController.getPinnedLeftContainerWidth()
	                + this.columnController.getPinnedRightContainerWidth();
	            width += pinnedContainerWidths;
	        }
	        this.headerRootComp.setHeaderContainerWidth(width);
	        var widthPx = width + "px";
	        this.eCenterContainer.style.width = widthPx;
	        this.eBottomContainer.style.width = widthPx;
	        this.eTopContainer.style.width = widthPx;
	        if (!this.printLayout) {
	            this.eBodyHorizontalScrollContainer.style.width = widthPx;
	        }
	    };
	    GridPanel.prototype.setPinnedLeftWidth = function () {
	        var _this = this;
	        var oldPinning = this.pinningLeft;
	        var widthOfCols = this.columnController.getPinnedLeftContainerWidth();
	        var newPinning = this.pinningLeft = !this.printLayout && widthOfCols > 0;
	        var containers = [this.eLeftContainer, this.eLeftTop, this.eLeftBottom];
	        if (oldPinning !== newPinning) {
	            this.headerRootComp.setLeftVisible(newPinning);
	        }
	        containers.forEach(function (e) { return utils_1._.setDisplayed(e, _this.pinningLeft); });
	        if (newPinning) {
	            containers.forEach(function (ct) { return utils_1._.setFixedWidth(ct, widthOfCols); });
	        }
	    };
	    GridPanel.prototype.setPinnedRightWidth = function () {
	        var oldPinning = this.pinningRight;
	        var widthOfCols = this.columnController.getPinnedRightContainerWidth();
	        var newPinning = this.pinningRight = !this.printLayout && widthOfCols > 0;
	        var containers = [this.eRightContainer, this.eRightTop, this.eRightBottom];
	        if (oldPinning !== newPinning) {
	            this.headerRootComp.setRightVisible(newPinning);
	        }
	        containers.forEach(function (ct) { return utils_1._.setDisplayed(ct, newPinning); });
	        if (newPinning) {
	            containers.forEach(function (ct) { return utils_1._.setFixedWidth(ct, widthOfCols); });
	        }
	    };
	    GridPanel.prototype.setPinnedContainerSize = function () {
	        this.setPinnedLeftWidth();
	        this.setPinnedRightWidth();
	        this.setFakeHScrollSpacerWidths();
	    };
	    GridPanel.prototype.setFakeHScrollSpacerWidths = function () {
	        // we pad the right based on a) if cols are pinned to the right and
	        // b) if v scroll is showing on the right (normal position of scroll)
	        var rightSpacing = this.columnController.getPinnedRightContainerWidth();
	        var scrollOnRight = !this.enableRtl && this.isVerticalScrollShowing();
	        if (scrollOnRight) {
	            rightSpacing += this.scrollWidth;
	        }
	        utils_1._.setFixedWidth(this.eHorizontalRightSpacer, rightSpacing);
	        utils_1._.addOrRemoveCssClass(this.eHorizontalRightSpacer, 'ag-scroller-corner', rightSpacing <= this.scrollWidth);
	        // we pad the left based on a) if cols are pinned to the left and
	        // b) if v scroll is showing on the left (happens in LTR layout only)
	        var leftSpacing = this.columnController.getPinnedLeftContainerWidth();
	        var scrollOnLeft = this.enableRtl && this.isVerticalScrollShowing();
	        if (scrollOnLeft) {
	            leftSpacing += this.scrollWidth;
	        }
	        utils_1._.setFixedWidth(this.eHorizontalLeftSpacer, leftSpacing);
	        utils_1._.addOrRemoveCssClass(this.eHorizontalLeftSpacer, 'ag-scroller-corner', leftSpacing <= this.scrollWidth);
	    };
	    GridPanel.prototype.checkBodyHeight = function () {
	        var bodyHeight = this.eBodyViewport.clientHeight;
	        if (this.bodyHeight !== bodyHeight) {
	            this.bodyHeight = bodyHeight;
	            var event_3 = {
	                type: events_1.Events.EVENT_BODY_HEIGHT_CHANGED,
	                api: this.gridApi,
	                columnApi: this.columnApi
	            };
	            this.eventService.dispatchEvent(event_3);
	        }
	    };
	    GridPanel.prototype.setHeaderAndFloatingHeights = function () {
	        var _a = this, columnController = _a.columnController, gridOptionsWrapper = _a.gridOptionsWrapper, pinnedRowModel = _a.pinnedRowModel, eTop = _a.eTop, eBottom = _a.eBottom;
	        var numberOfFloating = 0;
	        var headerRowCount = columnController.getHeaderRowCount();
	        var totalHeaderHeight;
	        var groupHeight;
	        var headerHeight;
	        if (!columnController.isPivotMode()) {
	            if (gridOptionsWrapper.isFloatingFilter()) {
	                headerRowCount++;
	            }
	            numberOfFloating = (gridOptionsWrapper.isFloatingFilter()) ? 1 : 0;
	            groupHeight = gridOptionsWrapper.getGroupHeaderHeight();
	            headerHeight = gridOptionsWrapper.getHeaderHeight();
	        }
	        else {
	            numberOfFloating = 0;
	            groupHeight = gridOptionsWrapper.getPivotGroupHeaderHeight();
	            headerHeight = gridOptionsWrapper.getPivotHeaderHeight();
	        }
	        var numberOfNonGroups = 1 + numberOfFloating;
	        var numberOfGroups = headerRowCount - numberOfNonGroups;
	        totalHeaderHeight = numberOfFloating * gridOptionsWrapper.getFloatingFiltersHeight();
	        totalHeaderHeight += numberOfGroups * groupHeight;
	        totalHeaderHeight += headerHeight;
	        this.headerRootComp.setHeight(totalHeaderHeight);
	        var floatingTopHeight = pinnedRowModel.getPinnedTopTotalHeight();
	        if (floatingTopHeight) {
	            // adding 1px for cell bottom border
	            floatingTopHeight += 1;
	        }
	        var floatingBottomHeight = pinnedRowModel.getPinnedBottomTotalHeight();
	        if (floatingBottomHeight) {
	            // adding 1px for cell bottom border
	            floatingBottomHeight += 1;
	        }
	        var floatingTopHeightString = floatingTopHeight + "px";
	        var floatingBottomHeightString = floatingBottomHeight + "px";
	        eTop.style.minHeight = floatingTopHeightString;
	        eTop.style.height = floatingTopHeightString;
	        eTop.style.display = floatingTopHeight ? 'inherit' : 'none';
	        eBottom.style.minHeight = floatingBottomHeightString;
	        eBottom.style.height = floatingBottomHeightString;
	        eBottom.style.display = floatingBottomHeight ? 'inherit' : 'none';
	        this.checkBodyHeight();
	    };
	    GridPanel.prototype.getBodyHeight = function () {
	        return this.bodyHeight;
	    };
	    // called by scrollHorizontally method and alignedGridsService
	    GridPanel.prototype.setHorizontalScrollPosition = function (hScrollPosition) {
	        this.eCenterViewport.scrollLeft = hScrollPosition;
	        // we need to manually do the event handling (rather than wait for the event)
	        // for the alignedGridsService, as if we don't, the aligned grid service gets
	        // notified async, and then it's 'consuming' flag doesn't get used right, and
	        // we can end up with an infinite loop
	        this.doHorizontalScroll(hScrollPosition);
	    };
	    GridPanel.prototype.setVerticalScrollPosition = function (vScrollPosition) {
	        this.eBodyViewport.scrollTop = vScrollPosition;
	    };
	    // called by the headerRootComp and moveColumnController
	    GridPanel.prototype.scrollHorizontally = function (pixels) {
	        var oldScrollPosition = this.eCenterViewport.scrollLeft;
	        this.setHorizontalScrollPosition(oldScrollPosition + pixels);
	        return this.eCenterViewport.scrollLeft - oldScrollPosition;
	    };
	    // called by rowDragFeature
	    GridPanel.prototype.scrollVertically = function (pixels) {
	        var oldScrollPosition = this.eBodyViewport.scrollTop;
	        this.setVerticalScrollPosition(oldScrollPosition + pixels);
	        return this.eBodyViewport.scrollTop - oldScrollPosition;
	    };
	    GridPanel.prototype.addScrollListener = function () {
	        this.addDestroyableEventListener(this.eCenterViewport, 'scroll', this.onCenterViewportScroll.bind(this));
	        this.addDestroyableEventListener(this.eBodyHorizontalScrollViewport, 'scroll', this.onFakeHorizontalScroll.bind(this));
	        this.addDestroyableEventListener(this.eBodyViewport, 'scroll', this.onVerticalScroll.bind(this));
	    };
	    GridPanel.prototype.onVerticalScroll = function () {
	        var scrollTop = this.eBodyViewport.scrollTop;
	        this.animationFrameService.setScrollTop(scrollTop);
	        this.nextScrollTop = scrollTop;
	        if (this.gridOptionsWrapper.isSuppressAnimationFrame()) {
	            this.redrawRowsAfterScroll();
	        }
	        else {
	            this.animationFrameService.schedule();
	        }
	    };
	    GridPanel.prototype.executeFrame = function () {
	        var frameNeeded = this.scrollTop !== this.nextScrollTop;
	        if (frameNeeded) {
	            this.scrollTop = this.nextScrollTop;
	            this.redrawRowsAfterScroll();
	        }
	        return frameNeeded;
	    };
	    GridPanel.prototype.isControllingScroll = function (eDiv) {
	        if (!this.lastHorizontalScrollElement) {
	            this.lastHorizontalScrollElement = eDiv;
	            return true;
	        }
	        return eDiv === this.lastHorizontalScrollElement;
	    };
	    GridPanel.prototype.onFakeHorizontalScroll = function () {
	        if (!this.isControllingScroll(this.eBodyHorizontalScrollViewport)) {
	            return;
	        }
	        this.onBodyHorizontalScroll(this.eBodyHorizontalScrollViewport);
	    };
	    GridPanel.prototype.onCenterViewportScroll = function () {
	        if (!this.isControllingScroll(this.eCenterViewport)) {
	            return;
	        }
	        this.onBodyHorizontalScroll(this.eCenterViewport);
	    };
	    GridPanel.prototype.onBodyHorizontalScroll = function (eSource) {
	        var _a = this.eCenterViewport, scrollWidth = _a.scrollWidth, clientWidth = _a.clientWidth;
	        // in chrome, fractions can be in the scroll left, eg 250.342234 - which messes up our 'scrollWentPastBounds'
	        // formula. so we floor it to allow the formula to work.
	        var scrollLeft = Math.floor(utils_1._.getScrollLeft(eSource, this.enableRtl));
	        // touch devices allow elastic scroll - which temporally scrolls the panel outside of the viewport
	        // (eg user uses touch to go to the left of the grid, but drags past the left, the rows will actually
	        // scroll past the left until the user releases the mouse). when this happens, we want ignore the scroll,
	        // as otherwise it was causing the rows and header to flicker.
	        var scrollWentPastBounds = scrollLeft < 0 || (scrollLeft + clientWidth > scrollWidth);
	        if (scrollWentPastBounds) {
	            return;
	        }
	        this.doHorizontalScroll(scrollLeft);
	        this.resetLastHorizontalScrollElementDebounce();
	    };
	    GridPanel.prototype.resetLastHorizontalScrollElement = function () {
	        this.lastHorizontalScrollElement = null;
	    };
	    GridPanel.prototype.doHorizontalScroll = function (scrollLeft) {
	        this.scrollLeft = scrollLeft;
	        var event = {
	            type: events_1.Events.EVENT_BODY_SCROLL,
	            api: this.gridApi,
	            columnApi: this.columnApi,
	            direction: 'horizontal',
	            left: this.scrollLeft,
	            top: this.scrollTop
	        };
	        this.eventService.dispatchEvent(event);
	        this.horizontallyScrollHeaderCenterAndFloatingCenter(scrollLeft);
	        this.onHorizontalViewportChanged();
	    };
	    GridPanel.prototype.redrawRowsAfterScroll = function () {
	        var event = {
	            type: events_1.Events.EVENT_BODY_SCROLL,
	            direction: 'vertical',
	            api: this.gridApi,
	            columnApi: this.columnApi,
	            left: this.scrollLeft,
	            top: this.scrollTop
	        };
	        this.eventService.dispatchEvent(event);
	    };
	    // this gets called whenever a change in the viewport, so we can inform column controller it has to work
	    // out the virtual columns again. gets called from following locations:
	    // + ensureColVisible, scroll, init, layoutChanged, displayedColumnsChanged, API (doLayout)
	    GridPanel.prototype.onHorizontalViewportChanged = function () {
	        var scrollWidth = this.eCenterViewport.clientWidth;
	        var scrollPosition = this.getCenterViewportScrollLeft();
	        this.columnController.setVirtualViewportPosition(scrollWidth, scrollPosition);
	    };
	    GridPanel.prototype.getCenterViewportScrollLeft = function () {
	        // we defer to a util, as how you calculated scrollLeft when doing RTL depends on the browser
	        return utils_1._.getScrollLeft(this.eCenterViewport, this.enableRtl);
	    };
	    GridPanel.prototype.setCenterViewportScrollLeft = function (value) {
	        // we defer to a util, as how you calculated scrollLeft when doing RTL depends on the browser
	        utils_1._.setScrollLeft(this.eCenterViewport, value, this.enableRtl);
	    };
	    GridPanel.prototype.horizontallyScrollHeaderCenterAndFloatingCenter = function (scrollLeft) {
	        if (scrollLeft === undefined) {
	            scrollLeft = this.getCenterViewportScrollLeft();
	        }
	        var offset = this.enableRtl ? scrollLeft : -scrollLeft;
	        var _a = this.eCenterViewport, clientWidth = _a.clientWidth, scrollWidth = _a.scrollWidth;
	        var scrollWentPastBounds = Math.abs(offset) + clientWidth > scrollWidth;
	        if (scrollWentPastBounds ||
	            (this.enableRtl && offset < 0) ||
	            (!this.enableRtl && offset > 0)) {
	            return;
	        }
	        this.headerRootComp.setHorizontalScroll(offset);
	        this.eBottomContainer.style.transform = "translateX(" + offset + "px)";
	        this.eTopContainer.style.transform = "translateX(" + offset + "px)";
	        var partner = this.lastHorizontalScrollElement === this.eCenterViewport ? this.eBodyHorizontalScrollViewport : this.eCenterViewport;
	        utils_1._.setScrollLeft(partner, scrollLeft, this.enableRtl);
	    };
	    // + rangeController
	    GridPanel.prototype.addScrollEventListener = function (listener) {
	        this.eBodyViewport.addEventListener('scroll', listener);
	    };
	    // + rangeController
	    GridPanel.prototype.removeScrollEventListener = function (listener) {
	        this.eBodyViewport.removeEventListener('scroll', listener);
	    };
	    __decorate([
	        context_1.Autowired('alignedGridsService'),
	        __metadata("design:type", alignedGridsService_1.AlignedGridsService)
	    ], GridPanel.prototype, "alignedGridsService", void 0);
	    __decorate([
	        context_1.Autowired('gridOptionsWrapper'),
	        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
	    ], GridPanel.prototype, "gridOptionsWrapper", void 0);
	    __decorate([
	        context_1.Autowired('columnController'),
	        __metadata("design:type", columnController_1.ColumnController)
	    ], GridPanel.prototype, "columnController", void 0);
	    __decorate([
	        context_1.Autowired('rowRenderer'),
	        __metadata("design:type", rowRenderer_1.RowRenderer)
	    ], GridPanel.prototype, "rowRenderer", void 0);
	    __decorate([
	        context_1.Autowired('pinnedRowModel'),
	        __metadata("design:type", pinnedRowModel_1.PinnedRowModel)
	    ], GridPanel.prototype, "pinnedRowModel", void 0);
	    __decorate([
	        context_1.Autowired('eventService'),
	        __metadata("design:type", eventService_1.EventService)
	    ], GridPanel.prototype, "eventService", void 0);
	    __decorate([
	        context_1.Autowired('animationFrameService'),
	        __metadata("design:type", animationFrameService_1.AnimationFrameService)
	    ], GridPanel.prototype, "animationFrameService", void 0);
	    __decorate([
	        context_1.Autowired('navigationService'),
	        __metadata("design:type", navigationService_1.NavigationService)
	    ], GridPanel.prototype, "navigationService", void 0);
	    __decorate([
	        context_1.Autowired('autoHeightCalculator'),
	        __metadata("design:type", autoHeightCalculator_1.AutoHeightCalculator)
	    ], GridPanel.prototype, "autoHeightCalculator", void 0);
	    __decorate([
	        context_1.Autowired('columnAnimationService'),
	        __metadata("design:type", columnAnimationService_1.ColumnAnimationService)
	    ], GridPanel.prototype, "columnAnimationService", void 0);
	    __decorate([
	        context_1.Autowired('autoWidthCalculator'),
	        __metadata("design:type", autoWidthCalculator_1.AutoWidthCalculator)
	    ], GridPanel.prototype, "autoWidthCalculator", void 0);
	    __decorate([
	        context_1.Autowired('paginationAutoPageSizeService'),
	        __metadata("design:type", paginationAutoPageSizeService_1.PaginationAutoPageSizeService)
	    ], GridPanel.prototype, "paginationAutoPageSizeService", void 0);
	    __decorate([
	        context_1.Autowired('beans'),
	        __metadata("design:type", beans_1.Beans)
	    ], GridPanel.prototype, "beans", void 0);
	    __decorate([
	        context_1.Autowired('paginationProxy'),
	        __metadata("design:type", paginationProxy_1.PaginationProxy)
	    ], GridPanel.prototype, "paginationProxy", void 0);
	    __decorate([
	        context_1.Autowired('columnApi'),
	        __metadata("design:type", columnApi_1.ColumnApi)
	    ], GridPanel.prototype, "columnApi", void 0);
	    __decorate([
	        context_1.Autowired('gridApi'),
	        __metadata("design:type", gridApi_1.GridApi)
	    ], GridPanel.prototype, "gridApi", void 0);
	    __decorate([
	        context_1.Autowired('dragService'),
	        __metadata("design:type", dragService_1.DragService)
	    ], GridPanel.prototype, "dragService", void 0);
	    __decorate([
	        context_1.Autowired('mouseEventService'),
	        __metadata("design:type", mouseEventService_1.MouseEventService)
	    ], GridPanel.prototype, "mouseEventService", void 0);
	    __decorate([
	        context_1.Autowired('focusedCellController'),
	        __metadata("design:type", focusedCellController_1.FocusedCellController)
	    ], GridPanel.prototype, "focusedCellController", void 0);
	    __decorate([
	        context_1.Autowired('$scope'),
	        __metadata("design:type", Object)
	    ], GridPanel.prototype, "$scope", void 0);
	    __decorate([
	        context_1.Autowired('scrollVisibleService'),
	        __metadata("design:type", scrollVisibleService_1.ScrollVisibleService)
	    ], GridPanel.prototype, "scrollVisibleService", void 0);
	    __decorate([
	        context_1.Autowired('valueService'),
	        __metadata("design:type", valueService_1.ValueService)
	    ], GridPanel.prototype, "valueService", void 0);
	    __decorate([
	        context_1.Autowired('dragAndDropService'),
	        __metadata("design:type", dragAndDropService_1.DragAndDropService)
	    ], GridPanel.prototype, "dragAndDropService", void 0);
	    __decorate([
	        context_1.Autowired('maxDivHeightScaler'),
	        __metadata("design:type", maxDivHeightScaler_1.MaxDivHeightScaler)
	    ], GridPanel.prototype, "heightScaler", void 0);
	    __decorate([
	        context_1.Autowired('enterprise'),
	        __metadata("design:type", Boolean)
	    ], GridPanel.prototype, "enterprise", void 0);
	    __decorate([
	        context_1.Autowired('resizeObserverService'),
	        __metadata("design:type", resizeObserverService_1.ResizeObserverService)
	    ], GridPanel.prototype, "resizeObserverService", void 0);
	    __decorate([
	        context_1.Optional('rangeController'),
	        __metadata("design:type", Object)
	    ], GridPanel.prototype, "rangeController", void 0);
	    __decorate([
	        context_1.Optional('contextMenuFactory'),
	        __metadata("design:type", Object)
	    ], GridPanel.prototype, "contextMenuFactory", void 0);
	    __decorate([
	        context_1.Optional('clipboardService'),
	        __metadata("design:type", Object)
	    ], GridPanel.prototype, "clipboardService", void 0);
	    __decorate([
	        componentAnnotations_1.RefSelector('eBodyViewport'),
	        __metadata("design:type", HTMLElement)
	    ], GridPanel.prototype, "eBodyViewport", void 0);
	    __decorate([
	        componentAnnotations_1.RefSelector('eCenterContainer'),
	        __metadata("design:type", HTMLElement)
	    ], GridPanel.prototype, "eCenterContainer", void 0);
	    __decorate([
	        componentAnnotations_1.RefSelector('eCenterViewport'),
	        __metadata("design:type", HTMLElement)
	    ], GridPanel.prototype, "eCenterViewport", void 0);
	    __decorate([
	        componentAnnotations_1.RefSelector('eLeftContainer'),
	        __metadata("design:type", HTMLElement)
	    ], GridPanel.prototype, "eLeftContainer", void 0);
	    __decorate([
	        componentAnnotations_1.RefSelector('eRightContainer'),
	        __metadata("design:type", HTMLElement)
	    ], GridPanel.prototype, "eRightContainer", void 0);
	    __decorate([
	        componentAnnotations_1.RefSelector('eCenterColsClipper'),
	        __metadata("design:type", HTMLElement)
	    ], GridPanel.prototype, "eCenterColsClipper", void 0);
	    __decorate([
	        componentAnnotations_1.RefSelector('eHorizontalScrollBody'),
	        __metadata("design:type", HTMLElement)
	    ], GridPanel.prototype, "eHorizontalScrollBody", void 0);
	    __decorate([
	        componentAnnotations_1.RefSelector('eHorizontalLeftSpacer'),
	        __metadata("design:type", HTMLElement)
	    ], GridPanel.prototype, "eHorizontalLeftSpacer", void 0);
	    __decorate([
	        componentAnnotations_1.RefSelector('eHorizontalRightSpacer'),
	        __metadata("design:type", HTMLElement)
	    ], GridPanel.prototype, "eHorizontalRightSpacer", void 0);
	    __decorate([
	        componentAnnotations_1.RefSelector('eBodyHorizontalScrollViewport'),
	        __metadata("design:type", HTMLElement)
	    ], GridPanel.prototype, "eBodyHorizontalScrollViewport", void 0);
	    __decorate([
	        componentAnnotations_1.RefSelector('eBodyHorizontalScrollContainer'),
	        __metadata("design:type", HTMLElement)
	    ], GridPanel.prototype, "eBodyHorizontalScrollContainer", void 0);
	    __decorate([
	        componentAnnotations_1.RefSelector('eFullWidthContainer'),
	        __metadata("design:type", HTMLElement)
	    ], GridPanel.prototype, "eFullWidthContainer", void 0);
	    __decorate([
	        componentAnnotations_1.RefSelector('eTop'),
	        __metadata("design:type", HTMLElement)
	    ], GridPanel.prototype, "eTop", void 0);
	    __decorate([
	        componentAnnotations_1.RefSelector('eLeftTop'),
	        __metadata("design:type", HTMLElement)
	    ], GridPanel.prototype, "eLeftTop", void 0);
	    __decorate([
	        componentAnnotations_1.RefSelector('eRightTop'),
	        __metadata("design:type", HTMLElement)
	    ], GridPanel.prototype, "eRightTop", void 0);
	    __decorate([
	        componentAnnotations_1.RefSelector('eTopContainer'),
	        __metadata("design:type", HTMLElement)
	    ], GridPanel.prototype, "eTopContainer", void 0);
	    __decorate([
	        componentAnnotations_1.RefSelector('eTopViewport'),
	        __metadata("design:type", HTMLElement)
	    ], GridPanel.prototype, "eTopViewport", void 0);
	    __decorate([
	        componentAnnotations_1.RefSelector('eTopFullWidthContainer'),
	        __metadata("design:type", HTMLElement)
	    ], GridPanel.prototype, "eTopFullWidthContainer", void 0);
	    __decorate([
	        componentAnnotations_1.RefSelector('eBottom'),
	        __metadata("design:type", HTMLElement)
	    ], GridPanel.prototype, "eBottom", void 0);
	    __decorate([
	        componentAnnotations_1.RefSelector('eLeftBottom'),
	        __metadata("design:type", HTMLElement)
	    ], GridPanel.prototype, "eLeftBottom", void 0);
	    __decorate([
	        componentAnnotations_1.RefSelector('eRightBottom'),
	        __metadata("design:type", HTMLElement)
	    ], GridPanel.prototype, "eRightBottom", void 0);
	    __decorate([
	        componentAnnotations_1.RefSelector('eBottomContainer'),
	        __metadata("design:type", HTMLElement)
	    ], GridPanel.prototype, "eBottomContainer", void 0);
	    __decorate([
	        componentAnnotations_1.RefSelector('eBottomViewport'),
	        __metadata("design:type", HTMLElement)
	    ], GridPanel.prototype, "eBottomViewport", void 0);
	    __decorate([
	        componentAnnotations_1.RefSelector('eBottomFullWidthContainer'),
	        __metadata("design:type", HTMLElement)
	    ], GridPanel.prototype, "eBottomFullWidthContainer", void 0);
	    __decorate([
	        componentAnnotations_1.RefSelector('headerRoot'),
	        __metadata("design:type", headerRootComp_1.HeaderRootComp)
	    ], GridPanel.prototype, "headerRootComp", void 0);
	    __decorate([
	        componentAnnotations_1.RefSelector('overlayWrapper'),
	        __metadata("design:type", overlayWrapperComponent_1.OverlayWrapperComponent)
	    ], GridPanel.prototype, "overlayWrapper", void 0);
	    __decorate([
	        context_1.PostConstruct,
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", []),
	        __metadata("design:returntype", void 0)
	    ], GridPanel.prototype, "init", null);
	    return GridPanel;
	}(component_1.Component));
	exports.GridPanel = GridPanel;


/***/ }),
/* 2457 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var context_1 = __webpack_require__(2333);
	var gridOptionsWrapper_1 = __webpack_require__(2324);
	var utils_1 = __webpack_require__(2325);
	/**
	 * There are many instances of this component covering each of the areas a row can be entered
	 * eg body, pinned left, fullWidth. The component differs from others in that it's given the
	 * elements, there is no template. All of the elements are part of the GridPanel.
	 */
	var RowContainerComponent = /** @class */ (function () {
	    function RowContainerComponent(params) {
	        this.childCount = 0;
	        this.rowTemplatesToAdd = [];
	        this.afterGuiAttachedCallbacks = [];
	        // this is to cater for a 'strange behaviour' where when a panel is made visible, it is firing a scroll
	        // event which we want to ignore. see gridPanel.onAnyBodyScroll()
	        this.lastMadeVisibleTime = 0;
	        this.eContainer = params.eContainer;
	        this.eViewport = params.eViewport;
	        if (params.eWrapper) {
	            this.eWrapper = params.eWrapper;
	        }
	        this.hideWhenNoChildren = params.hideWhenNoChildren;
	    }
	    RowContainerComponent.prototype.setVerticalScrollPosition = function (verticalScrollPosition) {
	        this.scrollTop = verticalScrollPosition;
	    };
	    RowContainerComponent.prototype.postConstruct = function () {
	        this.checkDomOrder();
	        this.checkVisibility();
	        this.gridOptionsWrapper.addEventListener(gridOptionsWrapper_1.GridOptionsWrapper.PROP_DOM_LAYOUT, this.checkDomOrder.bind(this));
	    };
	    RowContainerComponent.prototype.checkDomOrder = function () {
	        this.domOrder = this.gridOptionsWrapper.isEnsureDomOrder();
	    };
	    RowContainerComponent.prototype.getRowElement = function (compId) {
	        return this.eContainer.querySelector("[comp-id=\"" + compId + "\"]");
	    };
	    RowContainerComponent.prototype.setHeight = function (height) {
	        if (height == null) {
	            this.eContainer.style.height = '';
	            return;
	        }
	        this.eContainer.style.height = height + "px";
	        if (this.eWrapper) {
	            this.eWrapper.style.height = height + "px";
	        }
	    };
	    RowContainerComponent.prototype.flushRowTemplates = function () {
	        // if doing dom order, then rowTemplates will be empty,
	        // or if no rows added since last time also empty.
	        if (this.rowTemplatesToAdd.length !== 0) {
	            var htmlToAdd = this.rowTemplatesToAdd.join('');
	            utils_1._.appendHtml(this.eContainer, htmlToAdd);
	            this.rowTemplatesToAdd.length = 0;
	        }
	        // this only empty if no rows since last time, as when
	        // doing dom order, we still have callbacks to process
	        this.afterGuiAttachedCallbacks.forEach(function (func) { return func(); });
	        this.afterGuiAttachedCallbacks.length = 0;
	        this.lastPlacedElement = null;
	    };
	    RowContainerComponent.prototype.appendRowTemplate = function (rowTemplate, callback) {
	        if (this.domOrder) {
	            this.lastPlacedElement = utils_1._.insertTemplateWithDomOrder(this.eContainer, rowTemplate, this.lastPlacedElement);
	        }
	        else {
	            this.rowTemplatesToAdd.push(rowTemplate);
	        }
	        this.afterGuiAttachedCallbacks.push(callback);
	        // it is important we put items in in order, so that when we open a row group,
	        // the new rows are inserted after the opened group, but before the rows below.
	        // that way, the rows below are over the new rows (as dom renders last in dom over
	        // items previous in dom), otherwise the child rows would cover the row below and
	        // that meant the user doesn't see the rows below slide away.
	        this.childCount++;
	        this.checkVisibility();
	    };
	    RowContainerComponent.prototype.ensureDomOrder = function (eRow) {
	        if (this.domOrder) {
	            utils_1._.ensureDomOrder(this.eContainer, eRow, this.lastPlacedElement);
	            this.lastPlacedElement = eRow;
	        }
	    };
	    RowContainerComponent.prototype.removeRowElement = function (eRow) {
	        this.eContainer.removeChild(eRow);
	        this.childCount--;
	        this.checkVisibility();
	    };
	    RowContainerComponent.prototype.checkVisibility = function () {
	        if (!this.hideWhenNoChildren) {
	            return;
	        }
	        var eGui = this.eViewport ? this.eViewport : this.eContainer;
	        var visible = this.childCount > 0;
	        if (this.visible !== visible) {
	            this.visible = visible;
	            this.lastMadeVisibleTime = new Date().getTime();
	            utils_1._.setDisplayed(eGui, visible);
	            // if we are showing the viewport, then the scroll is always zero,
	            // so we need to align with the other sections (ie if this is full
	            // width container, and first time showing a full width row, we need to
	            // scroll it so full width rows are show in right place alongside the
	            // body rows). without this, there was an issue with 'loading rows' for
	            // server side row model, as loading rows are full width, and they were
	            // not getting displayed in the right location when rows were expanded.
	            if (visible && this.eViewport) {
	                this.eViewport.scrollTop = this.scrollTop;
	            }
	        }
	    };
	    RowContainerComponent.prototype.isMadeVisibleRecently = function () {
	        var now = new Date().getTime();
	        var millisSinceVisible = now - this.lastMadeVisibleTime;
	        return millisSinceVisible < 500;
	    };
	    __decorate([
	        context_1.Autowired('gridOptionsWrapper'),
	        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
	    ], RowContainerComponent.prototype, "gridOptionsWrapper", void 0);
	    __decorate([
	        context_1.PostConstruct,
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", []),
	        __metadata("design:returntype", void 0)
	    ], RowContainerComponent.prototype, "postConstruct", null);
	    return RowContainerComponent;
	}());
	exports.RowContainerComponent = RowContainerComponent;


/***/ }),
/* 2458 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var beanStub_1 = __webpack_require__(2354);
	var eventService_1 = __webpack_require__(2331);
	var events_1 = __webpack_require__(2335);
	var context_1 = __webpack_require__(2333);
	var gridOptionsWrapper_1 = __webpack_require__(2324);
	var scrollVisibleService_1 = __webpack_require__(2455);
	var PaginationAutoPageSizeService = /** @class */ (function (_super) {
	    __extends(PaginationAutoPageSizeService, _super);
	    function PaginationAutoPageSizeService() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    PaginationAutoPageSizeService.prototype.registerGridComp = function (gridPanel) {
	        this.gridPanel = gridPanel;
	        this.addDestroyableEventListener(this.eventService, events_1.Events.EVENT_BODY_HEIGHT_CHANGED, this.onBodyHeightChanged.bind(this));
	        this.addDestroyableEventListener(this.eventService, events_1.Events.EVENT_SCROLL_VISIBILITY_CHANGED, this.onScrollVisibilityChanged.bind(this));
	        this.checkPageSize();
	    };
	    PaginationAutoPageSizeService.prototype.notActive = function () {
	        return !this.gridOptionsWrapper.isPaginationAutoPageSize();
	    };
	    PaginationAutoPageSizeService.prototype.onScrollVisibilityChanged = function () {
	        this.checkPageSize();
	    };
	    PaginationAutoPageSizeService.prototype.onBodyHeightChanged = function () {
	        this.checkPageSize();
	    };
	    PaginationAutoPageSizeService.prototype.checkPageSize = function () {
	        if (this.notActive()) {
	            return;
	        }
	        var rowHeight = this.gridOptionsWrapper.getRowHeightAsNumber();
	        var bodyHeight = this.gridPanel.getBodyHeight();
	        if (bodyHeight > 0) {
	            var newPageSize = Math.floor(bodyHeight / rowHeight);
	            this.gridOptionsWrapper.setProperty('paginationPageSize', newPageSize);
	        }
	    };
	    __decorate([
	        context_1.Autowired('eventService'),
	        __metadata("design:type", eventService_1.EventService)
	    ], PaginationAutoPageSizeService.prototype, "eventService", void 0);
	    __decorate([
	        context_1.Autowired('gridOptionsWrapper'),
	        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
	    ], PaginationAutoPageSizeService.prototype, "gridOptionsWrapper", void 0);
	    __decorate([
	        context_1.Autowired('scrollVisibleService'),
	        __metadata("design:type", scrollVisibleService_1.ScrollVisibleService)
	    ], PaginationAutoPageSizeService.prototype, "scrollVisibleService", void 0);
	    PaginationAutoPageSizeService = __decorate([
	        context_1.Bean('paginationAutoPageSizeService')
	    ], PaginationAutoPageSizeService);
	    return PaginationAutoPageSizeService;
	}(beanStub_1.BeanStub));
	exports.PaginationAutoPageSizeService = PaginationAutoPageSizeService;


/***/ }),
/* 2459 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var context_1 = __webpack_require__(2333);
	var constants_1 = __webpack_require__(2328);
	var mouseEventService_1 = __webpack_require__(2396);
	var paginationProxy_1 = __webpack_require__(2372);
	var focusedCellController_1 = __webpack_require__(2369);
	var animationFrameService_1 = __webpack_require__(2418);
	var columnController_1 = __webpack_require__(2341);
	var gridOptionsWrapper_1 = __webpack_require__(2324);
	var utils_1 = __webpack_require__(2325);
	var NavigationService = /** @class */ (function () {
	    function NavigationService() {
	        this.timeLastPageEventProcessed = 0;
	    }
	    NavigationService.prototype.init = function () {
	        this.scrollWidth = this.gridOptionsWrapper.getScrollbarWidth();
	    };
	    NavigationService.prototype.registerGridComp = function (gridPanel) {
	        this.gridPanel = gridPanel;
	    };
	    NavigationService.prototype.handlePageScrollingKey = function (event) {
	        var key = event.which || event.keyCode;
	        var alt = event.altKey;
	        var ctrl = event.ctrlKey;
	        var currentCell = this.mouseEventService.getCellPositionForEvent(event);
	        if (!currentCell) {
	            return false;
	        }
	        var processed = false;
	        switch (key) {
	            case constants_1.Constants.KEY_PAGE_HOME:
	            case constants_1.Constants.KEY_PAGE_END:
	                // handle home and end when ctrl & alt are NOT pressed
	                if (!ctrl && !alt) {
	                    this.onHomeOrEndKey(key);
	                    processed = true;
	                }
	                break;
	            case constants_1.Constants.KEY_LEFT:
	            case constants_1.Constants.KEY_RIGHT:
	                // handle left and right when ctrl is pressed only
	                if (ctrl && !alt) {
	                    this.onCtrlLeftOrRight(key, currentCell);
	                    processed = true;
	                }
	                break;
	            case constants_1.Constants.KEY_UP:
	            case constants_1.Constants.KEY_DOWN:
	                // handle up and down when ctrl is pressed only
	                if (ctrl && !alt) {
	                    this.onCtrlUpOrDown(key, currentCell);
	                    processed = true;
	                }
	                break;
	            case constants_1.Constants.KEY_PAGE_DOWN:
	                // handle page up and page down when ctrl & alt are NOT pressed
	                if (!ctrl && !alt) {
	                    this.onPageDown(currentCell);
	                    processed = true;
	                }
	                break;
	            case constants_1.Constants.KEY_PAGE_UP:
	                // handle page up and page down when ctrl & alt are NOT pressed
	                if (!ctrl && !alt) {
	                    this.onPageUp(currentCell);
	                    processed = true;
	                }
	                break;
	        }
	        if (processed) {
	            event.preventDefault();
	        }
	        return processed;
	    };
	    // the page up/down keys caused a problem, in that if the user
	    // held the page up/down key down, lots of events got generated,
	    // which clogged up the event queue (as they take time to process)
	    // which in turn froze the grid. Logic below makes sure we wait 100ms
	    // between processing the page up/down events, so when user has finger
	    // held down on key, we ignore page up/down events until 100ms has passed,
	    // which effectively empties the queue of page up/down events.
	    NavigationService.prototype.isTimeSinceLastPageEventToRecent = function () {
	        var now = new Date().getTime();
	        var diff = now - this.timeLastPageEventProcessed;
	        return (diff < 100);
	    };
	    NavigationService.prototype.setTimeLastPageEventProcessed = function () {
	        this.timeLastPageEventProcessed = new Date().getTime();
	    };
	    NavigationService.prototype.onPageDown = function (gridCell) {
	        if (this.isTimeSinceLastPageEventToRecent()) {
	            return;
	        }
	        var scrollPosition = this.gridPanel.getVScrollPosition();
	        var pixelsInOnePage = scrollPosition.bottom - scrollPosition.top;
	        if (this.gridPanel.isHorizontalScrollShowing()) {
	            pixelsInOnePage -= this.scrollWidth;
	        }
	        var pagingPixelOffset = this.paginationProxy.getPixelOffset();
	        var currentPageBottomPixel = scrollPosition.top + pixelsInOnePage;
	        var currentPageBottomRow = this.paginationProxy.getRowIndexAtPixel(currentPageBottomPixel + pagingPixelOffset);
	        var scrollIndex = currentPageBottomRow;
	        var currentCellPixel = this.paginationProxy.getRow(gridCell.rowIndex).rowTop;
	        var nextCellPixel = currentCellPixel + pixelsInOnePage - pagingPixelOffset;
	        var focusIndex = this.paginationProxy.getRowIndexAtPixel(nextCellPixel + pagingPixelOffset);
	        var pageLastRow = this.paginationProxy.getPageLastRow();
	        if (focusIndex > pageLastRow) {
	            focusIndex = pageLastRow;
	        }
	        if (scrollIndex > pageLastRow) {
	            scrollIndex = pageLastRow;
	        }
	        this.navigateTo(scrollIndex, 'top', null, focusIndex, gridCell.column);
	        this.setTimeLastPageEventProcessed();
	    };
	    NavigationService.prototype.onPageUp = function (gridCell) {
	        if (this.isTimeSinceLastPageEventToRecent()) {
	            return;
	        }
	        var scrollPosition = this.gridPanel.getVScrollPosition();
	        var pixelsInOnePage = scrollPosition.bottom - scrollPosition.top;
	        if (this.gridPanel.isHorizontalScrollShowing()) {
	            pixelsInOnePage -= this.scrollWidth;
	        }
	        var pagingPixelOffset = this.paginationProxy.getPixelOffset();
	        var currentPageTopPixel = scrollPosition.top;
	        var currentPageTopRow = this.paginationProxy.getRowIndexAtPixel(currentPageTopPixel + pagingPixelOffset);
	        var scrollIndex = currentPageTopRow;
	        var currentRowNode = this.paginationProxy.getRow(gridCell.rowIndex);
	        var nextCellPixel = currentRowNode.rowTop + currentRowNode.rowHeight - pixelsInOnePage - pagingPixelOffset;
	        var focusIndex = this.paginationProxy.getRowIndexAtPixel(nextCellPixel + pagingPixelOffset);
	        var firstRow = this.paginationProxy.getPageFirstRow();
	        if (focusIndex < firstRow) {
	            focusIndex = firstRow;
	        }
	        if (scrollIndex < firstRow) {
	            scrollIndex = firstRow;
	        }
	        this.navigateTo(scrollIndex, 'bottom', null, focusIndex, gridCell.column);
	        this.setTimeLastPageEventProcessed();
	    };
	    // common logic to navigate. takes parameters:
	    // scrollIndex - what row to vertically scroll to
	    // scrollType - what position to put scroll index ie top/bottom
	    // scrollColumn - what column to horizontally scroll to
	    // focusIndex / focusColumn - for page up / down, we want to scroll to one row/column, but focus another
	    NavigationService.prototype.navigateTo = function (scrollIndex, scrollType, scrollColumn, focusIndex, focusColumn) {
	        if (utils_1._.exists(scrollColumn)) {
	            this.gridPanel.ensureColumnVisible(scrollColumn);
	        }
	        if (utils_1._.exists(scrollIndex)) {
	            this.gridPanel.ensureIndexVisible(scrollIndex, scrollType);
	        }
	        // make sure the cell is rendered, needed if we are to focus
	        this.animationFrameService.flushAllFrames();
	        // if we don't do this, the range will be left on the last cell, which will leave the last focused cell
	        // highlighted.
	        this.focusedCellController.setFocusedCell(focusIndex, focusColumn, null, true);
	        if (this.rangeController) {
	            var cellPosition = { rowIndex: focusIndex, rowPinned: null, column: focusColumn };
	            this.rangeController.setRangeToCell(cellPosition);
	        }
	    };
	    // ctrl + up/down will bring focus to same column, first/last row. no horizontal scrolling.
	    NavigationService.prototype.onCtrlUpOrDown = function (key, gridCell) {
	        var upKey = key === constants_1.Constants.KEY_UP;
	        var rowIndexToScrollTo = upKey ? 0 : this.paginationProxy.getPageLastRow();
	        this.navigateTo(rowIndexToScrollTo, null, gridCell.column, rowIndexToScrollTo, gridCell.column);
	    };
	    // ctrl + left/right will bring focus to same row, first/last cell. no vertical scrolling.
	    NavigationService.prototype.onCtrlLeftOrRight = function (key, gridCell) {
	        var leftKey = key === constants_1.Constants.KEY_LEFT;
	        var allColumns = this.columnController.getAllDisplayedColumns();
	        var columnToSelect = leftKey ? allColumns[0] : utils_1._.last(allColumns);
	        this.navigateTo(gridCell.rowIndex, null, columnToSelect, gridCell.rowIndex, columnToSelect);
	    };
	    // home brings focus to top left cell, end brings focus to bottom right, grid scrolled to bring
	    // same cell into view (which means either scroll all the way up, or all the way down).
	    NavigationService.prototype.onHomeOrEndKey = function (key) {
	        var homeKey = key === constants_1.Constants.KEY_PAGE_HOME;
	        var allColumns = this.columnController.getAllDisplayedColumns();
	        var columnToSelect = homeKey ? allColumns[0] : utils_1._.last(allColumns);
	        var rowIndexToScrollTo = homeKey ? 0 : this.paginationProxy.getPageLastRow();
	        this.navigateTo(rowIndexToScrollTo, null, columnToSelect, rowIndexToScrollTo, columnToSelect);
	    };
	    __decorate([
	        context_1.Autowired('mouseEventService'),
	        __metadata("design:type", mouseEventService_1.MouseEventService)
	    ], NavigationService.prototype, "mouseEventService", void 0);
	    __decorate([
	        context_1.Autowired('paginationProxy'),
	        __metadata("design:type", paginationProxy_1.PaginationProxy)
	    ], NavigationService.prototype, "paginationProxy", void 0);
	    __decorate([
	        context_1.Autowired('focusedCellController'),
	        __metadata("design:type", focusedCellController_1.FocusedCellController)
	    ], NavigationService.prototype, "focusedCellController", void 0);
	    __decorate([
	        context_1.Autowired('animationFrameService'),
	        __metadata("design:type", animationFrameService_1.AnimationFrameService)
	    ], NavigationService.prototype, "animationFrameService", void 0);
	    __decorate([
	        context_1.Optional('rangeController'),
	        __metadata("design:type", Object)
	    ], NavigationService.prototype, "rangeController", void 0);
	    __decorate([
	        context_1.Autowired('columnController'),
	        __metadata("design:type", columnController_1.ColumnController)
	    ], NavigationService.prototype, "columnController", void 0);
	    __decorate([
	        context_1.Autowired('gridOptionsWrapper'),
	        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
	    ], NavigationService.prototype, "gridOptionsWrapper", void 0);
	    __decorate([
	        context_1.PostConstruct,
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", []),
	        __metadata("design:returntype", void 0)
	    ], NavigationService.prototype, "init", null);
	    NavigationService = __decorate([
	        context_1.Bean('navigationService')
	    ], NavigationService);
	    return NavigationService;
	}());
	exports.NavigationService = NavigationService;


/***/ }),
/* 2460 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var dragAndDropService_1 = __webpack_require__(2363);
	var context_1 = __webpack_require__(2333);
	var focusedCellController_1 = __webpack_require__(2369);
	var gridOptionsWrapper_1 = __webpack_require__(2324);
	var eventService_1 = __webpack_require__(2331);
	var eventKeys_1 = __webpack_require__(2336);
	var constants_1 = __webpack_require__(2328);
	var RowDragFeature = /** @class */ (function () {
	    function RowDragFeature(eContainer, gridPanel) {
	        this.eContainer = eContainer;
	        this.gridPanel = gridPanel;
	    }
	    RowDragFeature.prototype.postConstruct = function () {
	        if (this.gridOptionsWrapper.isRowModelDefault()) {
	            this.clientSideRowModel = this.rowModel;
	        }
	    };
	    RowDragFeature.prototype.getContainer = function () {
	        return this.eContainer;
	    };
	    RowDragFeature.prototype.isInterestedIn = function (type) {
	        return type === dragAndDropService_1.DragSourceType.RowDrag;
	    };
	    RowDragFeature.prototype.getIconName = function () {
	        return dragAndDropService_1.DragAndDropService.ICON_MOVE;
	    };
	    RowDragFeature.prototype.onDragEnter = function (draggingEvent) {
	        // when entering, we fire the enter event, then in onEnterOrDragging,
	        // we also fire the move event. so we get both events when entering.
	        this.dispatchEvent(eventKeys_1.Events.EVENT_ROW_DRAG_ENTER, draggingEvent);
	        this.dragAndDropService.setGhostIcon(dragAndDropService_1.DragAndDropService.ICON_MOVE);
	        draggingEvent.dragItem.rowNode.setDragging(true);
	        this.onEnterOrDragging(draggingEvent);
	    };
	    RowDragFeature.prototype.onDragging = function (draggingEvent) {
	        this.onEnterOrDragging(draggingEvent);
	    };
	    RowDragFeature.prototype.onEnterOrDragging = function (draggingEvent) {
	        // this event is fired for enter and move
	        this.dispatchEvent(eventKeys_1.Events.EVENT_ROW_DRAG_MOVE, draggingEvent);
	        this.lastDraggingEvent = draggingEvent;
	        var pixel = this.normaliseForScroll(draggingEvent.y);
	        var managedDrag = this.gridOptionsWrapper.isRowDragManaged();
	        if (managedDrag) {
	            this.doManagedDrag(draggingEvent, pixel);
	        }
	        this.checkCenterForScrolling(pixel);
	    };
	    RowDragFeature.prototype.doManagedDrag = function (draggingEvent, pixel) {
	        var rowNode = draggingEvent.dragItem.rowNode;
	        var rowWasMoved = this.clientSideRowModel.ensureRowAtPixel(rowNode, pixel);
	        if (rowWasMoved) {
	            this.focusedCellController.clearFocusedCell();
	            if (this.rangeController) {
	                this.rangeController.removeAllCellRanges();
	            }
	        }
	    };
	    RowDragFeature.prototype.normaliseForScroll = function (pixel) {
	        var gridPanelHasScrolls = this.gridOptionsWrapper.getDomLayout() === constants_1.Constants.DOM_LAYOUT_NORMAL;
	        if (gridPanelHasScrolls) {
	            var pixelRange = this.gridPanel.getVScrollPosition();
	            return pixel + pixelRange.top;
	        }
	        else {
	            return pixel;
	        }
	    };
	    RowDragFeature.prototype.checkCenterForScrolling = function (pixel) {
	        // scroll if the mouse is within 50px of the grid edge
	        var pixelRange = this.gridPanel.getVScrollPosition();
	        // console.log(`pixelRange = (${pixelRange.top}, ${pixelRange.bottom})`);
	        this.needToMoveUp = pixel < (pixelRange.top + 50);
	        this.needToMoveDown = pixel > (pixelRange.bottom - 50);
	        // console.log(`needToMoveUp = ${this.needToMoveUp} = pixel < (pixelRange.top + 50) = ${pixel} < (${pixelRange.top} + 50)`);
	        // console.log(`needToMoveDown = ${this.needToMoveDown} = pixel < (pixelRange.top + 50) = ${pixel} < (${pixelRange.top} + 50)`);
	        if (this.needToMoveUp || this.needToMoveDown) {
	            this.ensureIntervalStarted();
	        }
	        else {
	            this.ensureIntervalCleared();
	        }
	    };
	    RowDragFeature.prototype.ensureIntervalStarted = function () {
	        if (!this.movingIntervalId) {
	            this.intervalCount = 0;
	            this.movingIntervalId = window.setInterval(this.moveInterval.bind(this), 100);
	        }
	    };
	    RowDragFeature.prototype.ensureIntervalCleared = function () {
	        if (this.moveInterval) {
	            window.clearInterval(this.movingIntervalId);
	            this.movingIntervalId = null;
	        }
	    };
	    RowDragFeature.prototype.moveInterval = function () {
	        // the amounts we move get bigger at each interval, so the speed accelerates, starting a bit slow
	        // and getting faster. this is to give smoother user experience. we max at 100px to limit the speed.
	        var pixelsToMove;
	        this.intervalCount++;
	        pixelsToMove = 10 + (this.intervalCount * 5);
	        if (pixelsToMove > 100) {
	            pixelsToMove = 100;
	        }
	        var pixelsMoved;
	        if (this.needToMoveDown) {
	            pixelsMoved = this.gridPanel.scrollVertically(pixelsToMove);
	        }
	        else if (this.needToMoveUp) {
	            pixelsMoved = this.gridPanel.scrollVertically(-pixelsToMove);
	        }
	        if (pixelsMoved !== 0) {
	            this.onDragging(this.lastDraggingEvent);
	        }
	    };
	    // i tried using generics here with this:
	    //     public createEvent<T extends RowDragEvent>(type: string, clazz: {new(): T; }, draggingEvent: DraggingEvent) {
	    // but it didn't work - i think it's because it only works with classes, and not interfaces, (the events are interfaces)
	    RowDragFeature.prototype.dispatchEvent = function (type, draggingEvent) {
	        var yNormalised = this.normaliseForScroll(draggingEvent.y);
	        var overIndex = -1;
	        var overNode = null;
	        var mouseIsPastLastRow = yNormalised > this.rowModel.getCurrentPageHeight();
	        if (!mouseIsPastLastRow) {
	            overIndex = this.rowModel.getRowIndexAtPixel(yNormalised);
	            overNode = this.rowModel.getRow(overIndex);
	        }
	        var vDirectionString;
	        switch (draggingEvent.vDirection) {
	            case dragAndDropService_1.VDirection.Down:
	                vDirectionString = 'down';
	                break;
	            case dragAndDropService_1.VDirection.Up:
	                vDirectionString = 'up';
	                break;
	            default:
	                vDirectionString = null;
	                break;
	        }
	        var event = {
	            type: type,
	            api: this.gridOptionsWrapper.getApi(),
	            columnApi: this.gridOptionsWrapper.getColumnApi(),
	            event: draggingEvent.event,
	            node: draggingEvent.dragItem.rowNode,
	            overIndex: overIndex,
	            overNode: overNode,
	            y: yNormalised,
	            vDirection: vDirectionString
	        };
	        this.eventService.dispatchEvent(event);
	    };
	    RowDragFeature.prototype.onDragLeave = function (draggingEvent) {
	        this.dispatchEvent(eventKeys_1.Events.EVENT_ROW_DRAG_LEAVE, draggingEvent);
	        this.stopDragging(draggingEvent);
	    };
	    RowDragFeature.prototype.onDragStop = function (draggingEvent) {
	        this.dispatchEvent(eventKeys_1.Events.EVENT_ROW_DRAG_END, draggingEvent);
	        this.stopDragging(draggingEvent);
	    };
	    RowDragFeature.prototype.stopDragging = function (draggingEvent) {
	        this.ensureIntervalCleared();
	        draggingEvent.dragItem.rowNode.setDragging(false);
	    };
	    __decorate([
	        context_1.Autowired('dragAndDropService'),
	        __metadata("design:type", dragAndDropService_1.DragAndDropService)
	    ], RowDragFeature.prototype, "dragAndDropService", void 0);
	    __decorate([
	        context_1.Autowired('rowModel'),
	        __metadata("design:type", Object)
	    ], RowDragFeature.prototype, "rowModel", void 0);
	    __decorate([
	        context_1.Autowired('focusedCellController'),
	        __metadata("design:type", focusedCellController_1.FocusedCellController)
	    ], RowDragFeature.prototype, "focusedCellController", void 0);
	    __decorate([
	        context_1.Autowired('gridOptionsWrapper'),
	        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
	    ], RowDragFeature.prototype, "gridOptionsWrapper", void 0);
	    __decorate([
	        context_1.Optional('rangeController'),
	        __metadata("design:type", Object)
	    ], RowDragFeature.prototype, "rangeController", void 0);
	    __decorate([
	        context_1.Autowired('eventService'),
	        __metadata("design:type", eventService_1.EventService)
	    ], RowDragFeature.prototype, "eventService", void 0);
	    __decorate([
	        context_1.PostConstruct,
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", []),
	        __metadata("design:returntype", void 0)
	    ], RowDragFeature.prototype, "postConstruct", null);
	    return RowDragFeature;
	}());
	exports.RowDragFeature = RowDragFeature;


/***/ }),
/* 2461 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var gridOptionsWrapper_1 = __webpack_require__(2324);
	var context_1 = __webpack_require__(2333);
	var component_1 = __webpack_require__(2353);
	var userComponentFactory_1 = __webpack_require__(2380);
	var componentAnnotations_1 = __webpack_require__(2384);
	var utils_1 = __webpack_require__(2325);
	var LoadingType;
	(function (LoadingType) {
	    LoadingType[LoadingType["Loading"] = 0] = "Loading";
	    LoadingType[LoadingType["NoRows"] = 1] = "NoRows";
	})(LoadingType || (LoadingType = {}));
	var OverlayWrapperComponent = /** @class */ (function (_super) {
	    __extends(OverlayWrapperComponent, _super);
	    function OverlayWrapperComponent() {
	        return _super.call(this, OverlayWrapperComponent.TEMPLATE) || this;
	    }
	    OverlayWrapperComponent.prototype.postConstruct = function () {
	        this.gridOptionsWrapper.addLayoutElement(this.eOverlayWrapper);
	        this.setDisplayed(false);
	    };
	    OverlayWrapperComponent.prototype.setWrapperTypeClass = function (loadingType) {
	        utils_1._.addOrRemoveCssClass(this.eOverlayWrapper, 'ag-overlay-loading-wrapper', loadingType === LoadingType.Loading);
	        utils_1._.addOrRemoveCssClass(this.eOverlayWrapper, 'ag-overlay-no-rows-wrapper', loadingType === LoadingType.NoRows);
	    };
	    OverlayWrapperComponent.prototype.showLoadingOverlay = function () {
	        var _this = this;
	        this.setWrapperTypeClass(LoadingType.Loading);
	        this.destroyActiveOverlay();
	        var params = { api: this.gridOptionsWrapper.getApi() };
	        this.userComponentFactory.newLoadingOverlayComponent(params).then(function (comp) {
	            _this.eOverlayWrapper.appendChild(comp.getGui());
	            _this.activeOverlay = comp;
	        });
	        this.setDisplayed(true);
	    };
	    OverlayWrapperComponent.prototype.showNoRowsOverlay = function () {
	        var _this = this;
	        this.setWrapperTypeClass(LoadingType.NoRows);
	        this.destroyActiveOverlay();
	        var params = { api: this.gridOptionsWrapper.getApi() };
	        this.userComponentFactory.newNoRowsOverlayComponent(params).then(function (comp) {
	            _this.eOverlayWrapper.appendChild(comp.getGui());
	            _this.activeOverlay = comp;
	        });
	        this.setDisplayed(true);
	    };
	    OverlayWrapperComponent.prototype.destroyActiveOverlay = function () {
	        if (!this.activeOverlay) {
	            return;
	        }
	        if (this.activeOverlay.destroy) {
	            this.activeOverlay.destroy();
	        }
	        this.activeOverlay = undefined;
	        utils_1._.clearElement(this.eOverlayWrapper);
	    };
	    OverlayWrapperComponent.prototype.hideOverlay = function () {
	        this.destroyActiveOverlay();
	        this.setDisplayed(false);
	    };
	    OverlayWrapperComponent.prototype.destroy = function () {
	        _super.prototype.destroy.call(this);
	        this.destroyActiveOverlay();
	    };
	    // wrapping in outer div, and wrapper, is needed to center the loading icon
	    // The idea for centering came from here: http://www.vanseodesign.com/css/vertical-centering/
	    OverlayWrapperComponent.TEMPLATE = "<div class=\"ag-overlay\" aria-hidden=\"true\">\n            <div class=\"ag-overlay-panel\">\n                <div class=\"ag-overlay-wrapper\" ref=\"eOverlayWrapper\"></div>\n            </div>\n        </div>";
	    __decorate([
	        context_1.Autowired('gridOptionsWrapper'),
	        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
	    ], OverlayWrapperComponent.prototype, "gridOptionsWrapper", void 0);
	    __decorate([
	        context_1.Autowired('userComponentFactory'),
	        __metadata("design:type", userComponentFactory_1.UserComponentFactory)
	    ], OverlayWrapperComponent.prototype, "userComponentFactory", void 0);
	    __decorate([
	        componentAnnotations_1.RefSelector('eOverlayWrapper'),
	        __metadata("design:type", HTMLElement)
	    ], OverlayWrapperComponent.prototype, "eOverlayWrapper", void 0);
	    __decorate([
	        context_1.PostConstruct,
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", []),
	        __metadata("design:returntype", void 0)
	    ], OverlayWrapperComponent.prototype, "postConstruct", null);
	    return OverlayWrapperComponent;
	}(component_1.Component));
	exports.OverlayWrapperComponent = OverlayWrapperComponent;


/***/ }),
/* 2462 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var context_1 = __webpack_require__(2333);
	var gridOptionsWrapper_1 = __webpack_require__(2324);
	var utils_1 = __webpack_require__(2325);
	var ResizeObserverService = /** @class */ (function () {
	    function ResizeObserverService() {
	    }
	    ResizeObserverService.prototype.observeResize = function (element, callback, debounceDelay) {
	        if (debounceDelay === void 0) { debounceDelay = 50; }
	        // put in variable, so available to usePolyfill() function below
	        var frameworkFactory = this.frameworkOverrides;
	        // this gets fired too often and might cause some relayout issues
	        // so we add a debounce to the callback here to avoid the flashing effect.
	        var debouncedCallback = utils_1._.debounce(callback, debounceDelay);
	        var useBrowserResizeObserver = function () {
	            var resizeObserver = new window.ResizeObserver(debouncedCallback);
	            resizeObserver.observe(element);
	            return function () { return resizeObserver.disconnect(); };
	        };
	        var usePolyfill = function () {
	            // initialise to the current width and height, so first call will have no changes
	            var widthLastTime = utils_1._.offsetWidth(element);
	            var heightLastTime = utils_1._.offsetHeight(element);
	            // when finished, this gets turned to false.
	            var running = true;
	            var periodicallyCheckWidthAndHeight = function () {
	                if (running) {
	                    var newWidth = utils_1._.offsetWidth(element);
	                    var newHeight = utils_1._.offsetHeight(element);
	                    var changed = newWidth !== widthLastTime || newHeight !== heightLastTime;
	                    if (changed) {
	                        widthLastTime = newWidth;
	                        heightLastTime = newHeight;
	                        callback();
	                    }
	                    frameworkFactory.setTimeout(periodicallyCheckWidthAndHeight, debounceDelay);
	                }
	            };
	            periodicallyCheckWidthAndHeight();
	            // the callback function we return sets running to false
	            return function () { return running = false; };
	        };
	        var suppressResize = this.gridOptionsWrapper.isSuppressBrowserResizeObserver();
	        var resizeObserverExists = !!window.ResizeObserver;
	        if (resizeObserverExists && !suppressResize) {
	            return useBrowserResizeObserver();
	        }
	        else {
	            return usePolyfill();
	        }
	    };
	    __decorate([
	        context_1.Autowired('gridOptionsWrapper'),
	        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
	    ], ResizeObserverService.prototype, "gridOptionsWrapper", void 0);
	    __decorate([
	        context_1.Autowired('frameworkOverrides'),
	        __metadata("design:type", Object)
	    ], ResizeObserverService.prototype, "frameworkOverrides", void 0);
	    ResizeObserverService = __decorate([
	        context_1.Bean('resizeObserverService')
	    ], ResizeObserverService);
	    return ResizeObserverService;
	}());
	exports.ResizeObserverService = ResizeObserverService;


/***/ }),
/* 2463 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var gridOptionsWrapper_1 = __webpack_require__(2324);
	var columnApi_1 = __webpack_require__(2346);
	var columnController_1 = __webpack_require__(2341);
	var rowRenderer_1 = __webpack_require__(2350);
	var filterManager_1 = __webpack_require__(2378);
	var eventService_1 = __webpack_require__(2331);
	var gridPanel_1 = __webpack_require__(2456);
	var logger_1 = __webpack_require__(2332);
	var popupService_1 = __webpack_require__(2379);
	var context_1 = __webpack_require__(2333);
	var focusedCellController_1 = __webpack_require__(2369);
	var component_1 = __webpack_require__(2353);
	var gridApi_1 = __webpack_require__(2338);
	var componentAnnotations_1 = __webpack_require__(2384);
	var events_1 = __webpack_require__(2335);
	var resizeObserverService_1 = __webpack_require__(2462);
	var sideBar_1 = __webpack_require__(2441);
	var utils_1 = __webpack_require__(2325);
	var GridCore = /** @class */ (function (_super) {
	    __extends(GridCore, _super);
	    function GridCore() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    GridCore.prototype.init = function () {
	        var _this = this;
	        this.logger = this.loggerFactory.create('GridCore');
	        var template = this.enterprise ? GridCore.TEMPLATE_ENTERPRISE : GridCore.TEMPLATE_NORMAL;
	        this.setTemplate(template);
	        // register with services that need grid core
	        [
	            this.gridApi,
	            this.filterManager,
	            this.rowRenderer,
	            this.popupService
	        ].forEach(function (service) { return service.registerGridCore(_this); });
	        if (this.enterprise) {
	            this.clipboardService.registerGridCore(this);
	        }
	        this.gridOptionsWrapper.addLayoutElement(this.getGui());
	        // see what the grid options are for default of toolbar
	        this.setSideBarVisible(this.gridOptionsWrapper.isShowToolPanel());
	        this.eGridDiv.appendChild(this.getGui());
	        this.addDestroyFunc(function () {
	            _this.eGridDiv.removeChild(_this.getGui());
	        });
	        // if using angular, watch for quickFilter changes
	        if (this.$scope) {
	            var quickFilterUnregisterFn = this.$scope.$watch(this.quickFilterOnScope, function (newFilter) { return _this.filterManager.setQuickFilter(newFilter); });
	            this.addDestroyFunc(quickFilterUnregisterFn);
	        }
	        // important to set rtl before doLayout, as setting the RTL class impacts the scroll position,
	        // which doLayout indirectly depends on
	        this.addRtlSupport();
	        this.logger.log('ready');
	        this.gridOptionsWrapper.addLayoutElement(this.eRootWrapperBody);
	        var gridPanelEl = this.gridPanel.getGui();
	        this.addDestroyableEventListener(gridPanelEl, 'focusin', function () {
	            utils_1._.addCssClass(gridPanelEl, 'ag-has-focus');
	        });
	        this.addDestroyableEventListener(gridPanelEl, 'focusout', function (e) {
	            if (!gridPanelEl.contains(e.relatedTarget)) {
	                utils_1._.removeCssClass(gridPanelEl, 'ag-has-focus');
	            }
	        });
	        var unsubscribeFromResize = this.resizeObserverService.observeResize(this.eGridDiv, this.onGridSizeChanged.bind(this));
	        this.addDestroyFunc(function () { return unsubscribeFromResize(); });
	    };
	    GridCore.prototype.onGridSizeChanged = function () {
	        var event = {
	            type: events_1.Events.EVENT_GRID_SIZE_CHANGED,
	            api: this.gridApi,
	            columnApi: this.columnApi,
	            clientWidth: this.eGridDiv.clientWidth,
	            clientHeight: this.eGridDiv.clientHeight
	        };
	        this.eventService.dispatchEvent(event);
	    };
	    GridCore.prototype.addRtlSupport = function () {
	        var cssClass = this.gridOptionsWrapper.isEnableRtl() ? 'ag-rtl' : 'ag-ltr';
	        utils_1._.addCssClass(this.getGui(), cssClass);
	    };
	    GridCore.prototype.getRootGui = function () {
	        return this.getGui();
	    };
	    GridCore.prototype.isSideBarVisible = function () {
	        if (!this.sideBarComp) {
	            return false;
	        }
	        return this.sideBarComp.isDisplayed();
	    };
	    GridCore.prototype.setSideBarVisible = function (show) {
	        if (!this.sideBarComp) {
	            if (show) {
	                console.warn('ag-Grid: toolPanel is only available in ag-Grid Enterprise');
	            }
	            return;
	        }
	        this.sideBarComp.setDisplayed(show);
	    };
	    GridCore.prototype.closeToolPanel = function () {
	        if (!this.sideBarComp) {
	            console.warn('ag-Grid: toolPanel is only available in ag-Grid Enterprise');
	            return;
	        }
	        this.sideBarComp.close();
	    };
	    GridCore.prototype.getSideBar = function () {
	        return this.gridOptions.sideBar;
	    };
	    GridCore.prototype.refreshSideBar = function () {
	        if (this.sideBarComp) {
	            this.sideBarComp.refresh();
	        }
	    };
	    GridCore.prototype.setSideBar = function (def) {
	        this.eRootWrapperBody.removeChild(this.sideBarComp.getGui());
	        this.gridOptions.sideBar = sideBar_1.SideBarDefParser.parse(def);
	        this.sideBarComp.reset();
	        this.eRootWrapperBody.appendChild(this.sideBarComp.getGui());
	    };
	    GridCore.prototype.getOpenedToolPanel = function () {
	        if (!this.sideBarComp) {
	            return null;
	        }
	        return this.sideBarComp.openedItem();
	    };
	    GridCore.prototype.openToolPanel = function (key) {
	        if (!this.sideBarComp) {
	            console.warn('ag-Grid: toolPanel is only available in ag-Grid Enterprise');
	            return;
	        }
	        this.sideBarComp.openToolPanel(key);
	    };
	    GridCore.prototype.isToolPanelShowing = function () {
	        return this.sideBarComp.isToolPanelShowing();
	    };
	    GridCore.prototype.destroy = function () {
	        _super.prototype.destroy.call(this);
	        this.logger.log('Grid DOM removed');
	    };
	    // Valid values for position are bottom, middle and top
	    GridCore.prototype.ensureNodeVisible = function (comparator, position) {
	        if (position === void 0) { position = 'top'; }
	        if (this.doingVirtualPaging) {
	            throw new Error('Cannot use ensureNodeVisible when doing virtual paging, as we cannot check rows that are not in memory');
	        }
	        // look for the node index we want to display
	        var rowCount = this.rowModel.getRowCount();
	        var comparatorIsAFunction = typeof comparator === 'function';
	        var indexToSelect = -1;
	        // go through all the nodes, find the one we want to show
	        for (var i = 0; i < rowCount; i++) {
	            var node = this.rowModel.getRow(i);
	            if (comparatorIsAFunction) {
	                if (comparator(node)) {
	                    indexToSelect = i;
	                    break;
	                }
	            }
	            else {
	                // check object equality against node and data
	                if (comparator === node || comparator === node.data) {
	                    indexToSelect = i;
	                    break;
	                }
	            }
	        }
	        if (indexToSelect >= 0) {
	            this.gridPanel.ensureIndexVisible(indexToSelect, position);
	        }
	    };
	    GridCore.TEMPLATE_NORMAL = "<div class=\"ag-root-wrapper\">\n            <div class=\"ag-root-wrapper-body\" ref=\"rootWrapperBody\">\n                <ag-grid-comp ref=\"gridPanel\"></ag-grid-comp>\n            </div>\n            <ag-pagination></ag-pagination>\n        </div>";
	    GridCore.TEMPLATE_ENTERPRISE = "<div class=\"ag-root-wrapper\">\n            <ag-grid-header-drop-zones></ag-grid-header-drop-zones>\n            <div ref=\"rootWrapperBody\" class=\"ag-root-wrapper-body\">\n                <ag-grid-comp ref=\"gridPanel\"></ag-grid-comp>\n                <ag-side-bar ref=\"sideBar\"></ag-side-bar>\n            </div>\n            <ag-status-bar ref=\"statusBar\"></ag-status-bar>\n            <ag-pagination></ag-pagination>\n            <ag-watermark></ag-watermark>\n        </div>";
	    __decorate([
	        context_1.Autowired('enterprise'),
	        __metadata("design:type", Boolean)
	    ], GridCore.prototype, "enterprise", void 0);
	    __decorate([
	        context_1.Autowired('gridOptions'),
	        __metadata("design:type", Object)
	    ], GridCore.prototype, "gridOptions", void 0);
	    __decorate([
	        context_1.Autowired('gridOptionsWrapper'),
	        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
	    ], GridCore.prototype, "gridOptionsWrapper", void 0);
	    __decorate([
	        context_1.Autowired('rowModel'),
	        __metadata("design:type", Object)
	    ], GridCore.prototype, "rowModel", void 0);
	    __decorate([
	        context_1.Autowired('resizeObserverService'),
	        __metadata("design:type", resizeObserverService_1.ResizeObserverService)
	    ], GridCore.prototype, "resizeObserverService", void 0);
	    __decorate([
	        context_1.Autowired('columnController'),
	        __metadata("design:type", columnController_1.ColumnController)
	    ], GridCore.prototype, "columnController", void 0);
	    __decorate([
	        context_1.Autowired('rowRenderer'),
	        __metadata("design:type", rowRenderer_1.RowRenderer)
	    ], GridCore.prototype, "rowRenderer", void 0);
	    __decorate([
	        context_1.Autowired('filterManager'),
	        __metadata("design:type", filterManager_1.FilterManager)
	    ], GridCore.prototype, "filterManager", void 0);
	    __decorate([
	        context_1.Autowired('eventService'),
	        __metadata("design:type", eventService_1.EventService)
	    ], GridCore.prototype, "eventService", void 0);
	    __decorate([
	        context_1.Autowired('eGridDiv'),
	        __metadata("design:type", HTMLElement)
	    ], GridCore.prototype, "eGridDiv", void 0);
	    __decorate([
	        context_1.Autowired('$scope'),
	        __metadata("design:type", Object)
	    ], GridCore.prototype, "$scope", void 0);
	    __decorate([
	        context_1.Autowired('quickFilterOnScope'),
	        __metadata("design:type", String)
	    ], GridCore.prototype, "quickFilterOnScope", void 0);
	    __decorate([
	        context_1.Autowired('popupService'),
	        __metadata("design:type", popupService_1.PopupService)
	    ], GridCore.prototype, "popupService", void 0);
	    __decorate([
	        context_1.Autowired('focusedCellController'),
	        __metadata("design:type", focusedCellController_1.FocusedCellController)
	    ], GridCore.prototype, "focusedCellController", void 0);
	    __decorate([
	        context_1.Autowired('loggerFactory'),
	        __metadata("design:type", logger_1.LoggerFactory)
	    ], GridCore.prototype, "loggerFactory", void 0);
	    __decorate([
	        context_1.Autowired('columnApi'),
	        __metadata("design:type", columnApi_1.ColumnApi)
	    ], GridCore.prototype, "columnApi", void 0);
	    __decorate([
	        context_1.Autowired('gridApi'),
	        __metadata("design:type", gridApi_1.GridApi)
	    ], GridCore.prototype, "gridApi", void 0);
	    __decorate([
	        context_1.Optional('clipboardService'),
	        __metadata("design:type", Object)
	    ], GridCore.prototype, "clipboardService", void 0);
	    __decorate([
	        componentAnnotations_1.RefSelector('gridPanel'),
	        __metadata("design:type", gridPanel_1.GridPanel)
	    ], GridCore.prototype, "gridPanel", void 0);
	    __decorate([
	        componentAnnotations_1.RefSelector('sideBar'),
	        __metadata("design:type", Object)
	    ], GridCore.prototype, "sideBarComp", void 0);
	    __decorate([
	        componentAnnotations_1.RefSelector('rootWrapperBody'),
	        __metadata("design:type", HTMLElement)
	    ], GridCore.prototype, "eRootWrapperBody", void 0);
	    __decorate([
	        context_1.PostConstruct,
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", []),
	        __metadata("design:returntype", void 0)
	    ], GridCore.prototype, "init", null);
	    return GridCore;
	}(component_1.Component));
	exports.GridCore = GridCore;


/***/ }),
/* 2464 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var context_1 = __webpack_require__(2333);
	var filterManager_1 = __webpack_require__(2378);
	var popupService_1 = __webpack_require__(2379);
	var gridOptionsWrapper_1 = __webpack_require__(2324);
	var eventService_1 = __webpack_require__(2331);
	var utils_1 = __webpack_require__(2325);
	var StandardMenuFactory = /** @class */ (function () {
	    function StandardMenuFactory() {
	    }
	    StandardMenuFactory.prototype.hideActiveMenu = function () {
	        if (this.hidePopup) {
	            this.hidePopup();
	        }
	    };
	    StandardMenuFactory.prototype.showMenuAfterMouseEvent = function (column, mouseEvent) {
	        var _this = this;
	        this.showPopup(column, function (eMenu) {
	            _this.popupService.positionPopupUnderMouseEvent({
	                column: column,
	                type: 'columnMenu',
	                mouseEvent: mouseEvent,
	                ePopup: eMenu
	            });
	        });
	    };
	    StandardMenuFactory.prototype.showMenuAfterButtonClick = function (column, eventSource) {
	        var _this = this;
	        this.showPopup(column, function (eMenu) {
	            _this.popupService.positionPopupUnderComponent({
	                type: 'columnMenu', eventSource: eventSource,
	                ePopup: eMenu, keepWithinBounds: true, column: column
	            });
	        });
	    };
	    StandardMenuFactory.prototype.showPopup = function (column, positionCallback) {
	        var _this = this;
	        var filterWrapper = this.filterManager.getOrCreateFilterWrapper(column, 'COLUMN_MENU');
	        var eMenu = document.createElement('div');
	        utils_1._.addCssClass(eMenu, 'ag-menu');
	        filterWrapper.guiPromise.promise.then(function (gui) {
	            eMenu.appendChild(gui);
	        });
	        var hidePopup;
	        var bodyScrollListener = function (event) {
	            // if h scroll, popup is no longer over the column
	            if (event.direction === 'horizontal') {
	                hidePopup();
	            }
	        };
	        this.eventService.addEventListener('bodyScroll', bodyScrollListener);
	        var closedCallback = function () {
	            _this.eventService.removeEventListener('bodyScroll', bodyScrollListener);
	            column.setMenuVisible(false, "contextMenu");
	        };
	        // need to show filter before positioning, as only after filter
	        // is visible can we find out what the width of it is
	        hidePopup = this.popupService.addAsModalPopup(eMenu, true, closedCallback);
	        positionCallback(eMenu);
	        filterWrapper.filterPromise.then(function (filter) {
	            if (filter.afterGuiAttached) {
	                var params = {
	                    hidePopup: hidePopup
	                };
	                filter.afterGuiAttached(params);
	            }
	        });
	        this.hidePopup = hidePopup;
	        column.setMenuVisible(true, "contextMenu");
	    };
	    StandardMenuFactory.prototype.isMenuEnabled = function (column) {
	        // for standard, we show menu if filter is enabled, and he menu is not suppressed
	        return column.isFilterAllowed();
	    };
	    __decorate([
	        context_1.Autowired('eventService'),
	        __metadata("design:type", eventService_1.EventService)
	    ], StandardMenuFactory.prototype, "eventService", void 0);
	    __decorate([
	        context_1.Autowired('filterManager'),
	        __metadata("design:type", filterManager_1.FilterManager)
	    ], StandardMenuFactory.prototype, "filterManager", void 0);
	    __decorate([
	        context_1.Autowired('popupService'),
	        __metadata("design:type", popupService_1.PopupService)
	    ], StandardMenuFactory.prototype, "popupService", void 0);
	    __decorate([
	        context_1.Autowired('gridOptionsWrapper'),
	        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
	    ], StandardMenuFactory.prototype, "gridOptionsWrapper", void 0);
	    StandardMenuFactory = __decorate([
	        context_1.Bean('menuFactory')
	    ], StandardMenuFactory);
	    return StandardMenuFactory;
	}());
	exports.StandardMenuFactory = StandardMenuFactory;


/***/ }),
/* 2465 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var context_1 = __webpack_require__(2333);
	var gridOptionsWrapper_1 = __webpack_require__(2324);
	var filterService_1 = __webpack_require__(2466);
	var selectableService_1 = __webpack_require__(2467);
	var FilterStage = /** @class */ (function () {
	    function FilterStage() {
	    }
	    FilterStage.prototype.execute = function (params) {
	        var rowNode = params.rowNode, changedPath = params.changedPath;
	        this.filterService.filter(changedPath);
	        this.selectableService.updateSelectableAfterFiltering(rowNode);
	    };
	    __decorate([
	        context_1.Autowired('gridOptionsWrapper'),
	        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
	    ], FilterStage.prototype, "gridOptionsWrapper", void 0);
	    __decorate([
	        context_1.Autowired('selectableService'),
	        __metadata("design:type", selectableService_1.SelectableService)
	    ], FilterStage.prototype, "selectableService", void 0);
	    __decorate([
	        context_1.Autowired('filterService'),
	        __metadata("design:type", filterService_1.FilterService)
	    ], FilterStage.prototype, "filterService", void 0);
	    FilterStage = __decorate([
	        context_1.Bean('filterStage')
	    ], FilterStage);
	    return FilterStage;
	}());
	exports.FilterStage = FilterStage;


/***/ }),
/* 2466 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var context_1 = __webpack_require__(2333);
	var filterManager_1 = __webpack_require__(2378);
	var gridOptionsWrapper_1 = __webpack_require__(2324);
	var FilterService = /** @class */ (function () {
	    function FilterService() {
	    }
	    FilterService.prototype.postConstruct = function () {
	        this.doingTreeData = this.gridOptionsWrapper.isTreeData();
	    };
	    FilterService.prototype.filter = function (changedPath) {
	        var filterActive = this.filterManager.isAnyFilterPresent();
	        this.filterNodes(filterActive, changedPath);
	    };
	    FilterService.prototype.filterNodes = function (filterActive, changedPath) {
	        var _this = this;
	        var filterCallback = function (rowNode, includeChildNodes) {
	            // recursively get all children that are groups to also filter
	            if (rowNode.hasChildren()) {
	                // result of filter for this node. when filtering tree data, includeChildNodes = true when parent passes
	                if (filterActive && !includeChildNodes) {
	                    rowNode.childrenAfterFilter = rowNode.childrenAfterGroup.filter(function (childNode) {
	                        // a group is included in the result if it has any children of it's own.
	                        // by this stage, the child groups are already filtered
	                        var passBecauseChildren = childNode.childrenAfterFilter && childNode.childrenAfterFilter.length > 0;
	                        // both leaf level nodes and tree data nodes have data. these get added if
	                        // the data passes the filter
	                        var passBecauseDataPasses = childNode.data && _this.filterManager.doesRowPassFilter(childNode);
	                        // note - tree data nodes pass either if a) they pass themselves or b) any children of that node pass
	                        return passBecauseChildren || passBecauseDataPasses;
	                    });
	                }
	                else {
	                    // if not filtering, the result is the original list
	                    rowNode.childrenAfterFilter = rowNode.childrenAfterGroup;
	                }
	                _this.setAllChildrenCount(rowNode);
	            }
	            else {
	                rowNode.childrenAfterFilter = rowNode.childrenAfterGroup;
	                rowNode.setAllChildrenCount(null);
	            }
	        };
	        if (this.doingTreeDataFiltering()) {
	            var treeDataDepthFirstFilter_1 = function (rowNode, alreadyFoundInParent) {
	                // tree data filter traverses the hierarchy depth first and includes child nodes if parent passes
	                // filter, and parent nodes will be include if any children exist.
	                if (rowNode.childrenAfterGroup) {
	                    for (var i = 0; i < rowNode.childrenAfterGroup.length; i++) {
	                        var childNode = rowNode.childrenAfterGroup[i];
	                        // first check if current node passes filter before invoking child nodes
	                        var foundInParent = alreadyFoundInParent || _this.filterManager.doesRowPassFilter(childNode);
	                        if (childNode.childrenAfterGroup) {
	                            treeDataDepthFirstFilter_1(rowNode.childrenAfterGroup[i], foundInParent);
	                        }
	                        else {
	                            filterCallback(childNode, foundInParent);
	                        }
	                    }
	                }
	                filterCallback(rowNode, alreadyFoundInParent);
	            };
	            var treeDataFilterCallback = function (rowNode) { return treeDataDepthFirstFilter_1(rowNode, false); };
	            changedPath.executeFromRootNode(treeDataFilterCallback);
	        }
	        else {
	            var defaultFilterCallback = function (rowNode) { return filterCallback(rowNode, false); };
	            changedPath.forEachChangedNodeDepthFirst(defaultFilterCallback, true);
	        }
	    };
	    FilterService.prototype.setAllChildrenCountTreeData = function (rowNode) {
	        // for tree data, we include all children, groups and leafs
	        var allChildrenCount = 0;
	        rowNode.childrenAfterFilter.forEach(function (child) {
	            // include child itself
	            allChildrenCount++;
	            // include children of children
	            allChildrenCount += child.allChildrenCount;
	        });
	        rowNode.setAllChildrenCount(allChildrenCount);
	    };
	    FilterService.prototype.setAllChildrenCountGridGrouping = function (rowNode) {
	        // for grid data, we only count the leafs
	        var allChildrenCount = 0;
	        rowNode.childrenAfterFilter.forEach(function (child) {
	            if (child.group) {
	                allChildrenCount += child.allChildrenCount;
	            }
	            else {
	                allChildrenCount++;
	            }
	        });
	        rowNode.setAllChildrenCount(allChildrenCount);
	    };
	    FilterService.prototype.setAllChildrenCount = function (rowNode) {
	        if (this.doingTreeData) {
	            this.setAllChildrenCountTreeData(rowNode);
	        }
	        else {
	            this.setAllChildrenCountGridGrouping(rowNode);
	        }
	    };
	    FilterService.prototype.doingTreeDataFiltering = function () {
	        return this.gridOptionsWrapper.isTreeData() && !this.gridOptionsWrapper.isExcludeChildrenWhenTreeDataFiltering();
	    };
	    __decorate([
	        context_1.Autowired('filterManager'),
	        __metadata("design:type", filterManager_1.FilterManager)
	    ], FilterService.prototype, "filterManager", void 0);
	    __decorate([
	        context_1.Autowired('gridOptionsWrapper'),
	        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
	    ], FilterService.prototype, "gridOptionsWrapper", void 0);
	    __decorate([
	        context_1.PostConstruct,
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", []),
	        __metadata("design:returntype", void 0)
	    ], FilterService.prototype, "postConstruct", null);
	    FilterService = __decorate([
	        context_1.Bean("filterService")
	    ], FilterService);
	    return FilterService;
	}());
	exports.FilterService = FilterService;


/***/ }),
/* 2467 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var context_1 = __webpack_require__(2333);
	var gridOptionsWrapper_1 = __webpack_require__(2324);
	var utils_1 = __webpack_require__(2325);
	var SelectableService = /** @class */ (function () {
	    function SelectableService() {
	    }
	    SelectableService.prototype.init = function () {
	        this.groupSelectsChildren = this.gridOptionsWrapper.isGroupSelectsChildren();
	        this.isRowSelectableFunc = this.gridOptionsWrapper.getIsRowSelectableFunc();
	    };
	    SelectableService.prototype.updateSelectableAfterGrouping = function (rowNode) {
	        if (this.isRowSelectableFunc) {
	            var nextChildrenFunc = function (rowNode) { return rowNode.childrenAfterGroup; };
	            this.recurseDown(rowNode.childrenAfterGroup, nextChildrenFunc);
	        }
	    };
	    SelectableService.prototype.updateSelectableAfterFiltering = function (rowNode) {
	        if (this.isRowSelectableFunc) {
	            var nextChildrenFunc = function (rowNode) { return rowNode.childrenAfterFilter; };
	            this.recurseDown(rowNode.childrenAfterGroup, nextChildrenFunc);
	        }
	    };
	    SelectableService.prototype.recurseDown = function (children, nextChildrenFunc) {
	        var _this = this;
	        children.forEach(function (child) {
	            if (!child.group) {
	                return;
	            } // only interested in groups
	            if (child.hasChildren()) {
	                _this.recurseDown(nextChildrenFunc(child), nextChildrenFunc);
	            }
	            var rowSelectable;
	            if (_this.groupSelectsChildren) {
	                // have this group selectable if at least one direct child is selectable
	                var firstSelectable = utils_1._.find(nextChildrenFunc(child), 'selectable', true);
	                rowSelectable = utils_1._.exists(firstSelectable);
	            }
	            else {
	                // directly retrieve selectable value from user callback
	                rowSelectable = _this.isRowSelectableFunc ? _this.isRowSelectableFunc(child) : false;
	            }
	            child.setRowSelectable(rowSelectable);
	        });
	    };
	    __decorate([
	        context_1.Autowired('gridOptionsWrapper'),
	        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
	    ], SelectableService.prototype, "gridOptionsWrapper", void 0);
	    __decorate([
	        context_1.PostConstruct,
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", []),
	        __metadata("design:returntype", void 0)
	    ], SelectableService.prototype, "init", null);
	    SelectableService = __decorate([
	        context_1.Bean('selectableService')
	    ], SelectableService);
	    return SelectableService;
	}());
	exports.SelectableService = SelectableService;


/***/ }),
/* 2468 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var context_1 = __webpack_require__(2333);
	var gridOptionsWrapper_1 = __webpack_require__(2324);
	var sortService_1 = __webpack_require__(2469);
	var sortController_1 = __webpack_require__(2391);
	var columnController_1 = __webpack_require__(2341);
	var utils_1 = __webpack_require__(2325);
	var SortStage = /** @class */ (function () {
	    function SortStage() {
	    }
	    SortStage.prototype.execute = function (params) {
	        var sortOptions = this.sortController.getSortForRowController();
	        var sortActive = utils_1._.exists(sortOptions) && sortOptions.length > 0;
	        var deltaSort = sortActive
	            && utils_1._.exists(params.rowNodeTransactions)
	            // in time we can remove this check, so that delta sort is always
	            // on if transactions are present. it's off for now so that we can
	            // selectively turn it on and test it with some select users before
	            // rolling out to everyone.
	            && this.gridOptionsWrapper.isDeltaSort();
	        // we only need dirty nodes if doing delta sort
	        var dirtyLeafNodes = deltaSort ? this.calculateDirtyNodes(params.rowNodeTransactions) : null;
	        var valueColumns = this.columnController.getValueColumns();
	        var noAggregations = utils_1._.missingOrEmpty(valueColumns);
	        this.sortService.sort(sortOptions, sortActive, deltaSort, dirtyLeafNodes, params.changedPath, noAggregations);
	    };
	    SortStage.prototype.calculateDirtyNodes = function (rowNodeTransactions) {
	        var dirtyNodes = {};
	        var addNodesFunc = function (rowNodes) {
	            if (rowNodes) {
	                rowNodes.forEach(function (rowNode) { return dirtyNodes[rowNode.id] = true; });
	            }
	        };
	        // all leaf level nodes in the transaction were impacted
	        rowNodeTransactions.forEach(function (tran) {
	            addNodesFunc(tran.add);
	            addNodesFunc(tran.update);
	            addNodesFunc(tran.remove);
	        });
	        return dirtyNodes;
	    };
	    __decorate([
	        context_1.Autowired('gridOptionsWrapper'),
	        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
	    ], SortStage.prototype, "gridOptionsWrapper", void 0);
	    __decorate([
	        context_1.Autowired('sortService'),
	        __metadata("design:type", sortService_1.SortService)
	    ], SortStage.prototype, "sortService", void 0);
	    __decorate([
	        context_1.Autowired('sortController'),
	        __metadata("design:type", sortController_1.SortController)
	    ], SortStage.prototype, "sortController", void 0);
	    __decorate([
	        context_1.Autowired('columnController'),
	        __metadata("design:type", columnController_1.ColumnController)
	    ], SortStage.prototype, "columnController", void 0);
	    SortStage = __decorate([
	        context_1.Bean('sortStage')
	    ], SortStage);
	    return SortStage;
	}());
	exports.SortStage = SortStage;


/***/ }),
/* 2469 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var context_1 = __webpack_require__(2333);
	var sortController_1 = __webpack_require__(2391);
	var valueService_1 = __webpack_require__(2359);
	var gridOptionsWrapper_1 = __webpack_require__(2324);
	var columnController_1 = __webpack_require__(2341);
	var utils_1 = __webpack_require__(2325);
	var SortService = /** @class */ (function () {
	    function SortService() {
	    }
	    SortService.prototype.init = function () {
	        this.postSortFunc = this.gridOptionsWrapper.getPostSortFunc();
	    };
	    SortService.prototype.sort = function (sortOptions, sortActive, deltaSort, dirtyLeafNodes, changedPath, noAggregations) {
	        var _this = this;
	        var callback = function (rowNode) {
	            // we clear out the 'pull down open parents' first, as the values mix up the sorting
	            _this.pullDownGroupDataForHideOpenParents(rowNode.childrenAfterFilter, true);
	            // Javascript sort is non deterministic when all the array items are equals, ie Comparator always returns 0,
	            // so to ensure the array keeps its order, add an additional sorting condition manually, in this case we
	            // are going to inspect the original array position. This is what sortedRowNodes is for.
	            if (sortActive) {
	                var sortedRowNodes = deltaSort ?
	                    _this.doDeltaSort(rowNode, sortOptions, dirtyLeafNodes, changedPath, noAggregations)
	                    : _this.doFullSort(rowNode, sortOptions);
	                rowNode.childrenAfterSort = sortedRowNodes.map(function (sorted) { return sorted.rowNode; });
	            }
	            else {
	                rowNode.childrenAfterSort = rowNode.childrenAfterFilter.slice(0);
	            }
	            _this.updateChildIndexes(rowNode);
	            if (_this.postSortFunc) {
	                _this.postSortFunc(rowNode.childrenAfterSort);
	            }
	        };
	        changedPath.forEachChangedNodeDepthFirst(callback);
	        this.updateGroupDataForHiddenOpenParents(changedPath);
	    };
	    SortService.prototype.doFullSort = function (rowNode, sortOptions) {
	        var sortedRowNodes = rowNode.childrenAfterFilter
	            .map(this.mapNodeToSortedNode.bind(this));
	        sortedRowNodes.sort(this.compareRowNodes.bind(this, sortOptions));
	        return sortedRowNodes;
	    };
	    SortService.prototype.mapNodeToSortedNode = function (rowNode, pos) {
	        return { currentPos: pos, rowNode: rowNode };
	    };
	    SortService.prototype.doDeltaSort = function (rowNode, sortOptions, dirtyLeafNodes, changedPath, noAggregations) {
	        // clean nodes will be a list of all row nodes that remain in the set
	        // and ordered. we start with the old sorted set and take out any nodes
	        // that were removed or changed (but not added, added doesn't make sense,
	        // if a node was added, there is no way it could be here from last time).
	        var cleanNodes = rowNode.childrenAfterSort
	            .filter(function (rowNode) {
	            // take out all nodes that were changed as part of the current transaction.
	            // a changed node could a) be in a different sort position or b) may
	            // no longer be in this set as the changed node may not pass filtering,
	            // or be in a different group.
	            var passesDirtyNodesCheck = !dirtyLeafNodes[rowNode.id];
	            // also remove group nodes in the changed path, as they can have different aggregate
	            // values which could impact the sort order.
	            // note: changed path is not active if a) no value columns or b) no transactions. it is never
	            // (b) in deltaSort as we only do deltaSort for transactions. for (a) if no value columns, then
	            // there is no value in the group that could of changed (ie no aggregate values)
	            var passesChangedPathCheck = noAggregations || changedPath.canSkip(rowNode);
	            return passesDirtyNodesCheck && passesChangedPathCheck;
	        })
	            .map(this.mapNodeToSortedNode.bind(this));
	        // for fast access below, we map them
	        var cleanNodesMapped = {};
	        cleanNodes.forEach(function (sortedRowNode) { return cleanNodesMapped[sortedRowNode.rowNode.id] = sortedRowNode.rowNode; });
	        // these are all nodes that need to be placed
	        var changedNodes = rowNode.childrenAfterFilter
	            // ignore nodes in the clean list
	            .filter(function (rowNode) { return !cleanNodesMapped[rowNode.id]; })
	            .map(this.mapNodeToSortedNode.bind(this));
	        // sort changed nodes. note that we don't need to sort cleanNodes as they are
	        // already sorted from last time.
	        changedNodes.sort(this.compareRowNodes.bind(this, sortOptions));
	        if (changedNodes.length === 0) {
	            return cleanNodes;
	        }
	        else if (cleanNodes.length === 0) {
	            return changedNodes;
	        }
	        else {
	            return this.mergeSortedArrays(sortOptions, cleanNodes, changedNodes);
	        }
	    };
	    // Merge two sorted arrays into each other
	    SortService.prototype.mergeSortedArrays = function (sortOptions, arr1, arr2) {
	        var res = [];
	        var i = 0;
	        var j = 0;
	        // Traverse both array, adding them in order
	        while (i < arr1.length && j < arr2.length) {
	            // Check if current element of first
	            // array is smaller than current element
	            // of second array. If yes, store first
	            // array element and increment first array
	            // index. Otherwise do same with second array
	            var compareResult = this.compareRowNodes(sortOptions, arr1[i], arr2[j]);
	            if (compareResult < 0) {
	                res.push(arr1[i++]);
	            }
	            else {
	                res.push(arr2[j++]);
	            }
	        }
	        // add remaining from arr1
	        while (i < arr1.length) {
	            res.push(arr1[i++]);
	        }
	        // add remaining from arr2
	        while (j < arr2.length) {
	            res.push(arr2[j++]);
	        }
	        return res;
	    };
	    SortService.prototype.compareRowNodes = function (sortOptions, sortedNodeA, sortedNodeB) {
	        var nodeA = sortedNodeA.rowNode;
	        var nodeB = sortedNodeB.rowNode;
	        // Iterate columns, return the first that doesn't match
	        for (var i = 0, len = sortOptions.length; i < len; i++) {
	            var sortOption = sortOptions[i];
	            // let compared = compare(nodeA, nodeB, sortOption.column, sortOption.inverter === -1);
	            var isInverted = sortOption.inverter === -1;
	            var valueA = this.getValue(nodeA, sortOption.column);
	            var valueB = this.getValue(nodeB, sortOption.column);
	            var comparatorResult = void 0;
	            if (sortOption.column.getColDef().comparator) {
	                //if comparator provided, use it
	                comparatorResult = sortOption.column.getColDef().comparator(valueA, valueB, nodeA, nodeB, isInverted);
	            }
	            else {
	                //otherwise do our own comparison
	                comparatorResult = utils_1._.defaultComparator(valueA, valueB, this.gridOptionsWrapper.isAccentedSort());
	            }
	            if (comparatorResult !== 0) {
	                return comparatorResult * sortOption.inverter;
	            }
	        }
	        // All matched, we make is so that the original sort order is kept:
	        return sortedNodeA.currentPos - sortedNodeB.currentPos;
	    };
	    SortService.prototype.getValue = function (nodeA, column) {
	        return this.valueService.getValue(column, nodeA);
	    };
	    SortService.prototype.updateChildIndexes = function (rowNode) {
	        if (utils_1._.missing(rowNode.childrenAfterSort)) {
	            return;
	        }
	        var listToSort = rowNode.childrenAfterSort;
	        for (var i = 0; i < listToSort.length; i++) {
	            var child = listToSort[i];
	            var firstChild = i === 0;
	            var lastChild = i === rowNode.childrenAfterSort.length - 1;
	            child.setFirstChild(firstChild);
	            child.setLastChild(lastChild);
	            child.setChildIndex(i);
	        }
	    };
	    SortService.prototype.updateGroupDataForHiddenOpenParents = function (changedPath) {
	        var _this = this;
	        if (!this.gridOptionsWrapper.isGroupHideOpenParents()) {
	            return;
	        }
	        // recurse breadth first over group nodes after sort to 'pull down' group data to child groups
	        var callback = function (rowNode) {
	            _this.pullDownGroupDataForHideOpenParents(rowNode.childrenAfterSort, false);
	            rowNode.childrenAfterSort.forEach(function (child) {
	                if (child.hasChildren()) {
	                    callback(child);
	                }
	            });
	        };
	        changedPath.executeFromRootNode(function (rowNode) { return callback(rowNode); });
	    };
	    SortService.prototype.pullDownGroupDataForHideOpenParents = function (rowNodes, clearOperation) {
	        var _this = this;
	        if (utils_1._.missing(rowNodes)) {
	            return;
	        }
	        if (!this.gridOptionsWrapper.isGroupHideOpenParents()) {
	            return;
	        }
	        rowNodes.forEach(function (childRowNode) {
	            var groupDisplayCols = _this.columnController.getGroupDisplayColumns();
	            groupDisplayCols.forEach(function (groupDisplayCol) {
	                var showRowGroup = groupDisplayCol.getColDef().showRowGroup;
	                if (typeof showRowGroup !== 'string') {
	                    console.error('ag-Grid: groupHideOpenParents only works when specifying specific columns for colDef.showRowGroup');
	                    return;
	                }
	                var displayingGroupKey = showRowGroup;
	                var rowGroupColumn = _this.columnController.getPrimaryColumn(displayingGroupKey);
	                var thisRowNodeMatches = rowGroupColumn === childRowNode.rowGroupColumn;
	                if (thisRowNodeMatches) {
	                    return;
	                }
	                if (clearOperation) {
	                    // if doing a clear operation, we clear down the value for every possible group column
	                    childRowNode.setGroupValue(groupDisplayCol.getId(), null);
	                }
	                else {
	                    // if doing a set operation, we set only where the pull down is to occur
	                    var parentToStealFrom = childRowNode.getFirstChildOfFirstChild(rowGroupColumn);
	                    if (parentToStealFrom) {
	                        childRowNode.setGroupValue(groupDisplayCol.getId(), parentToStealFrom.key);
	                    }
	                }
	            });
	        });
	    };
	    __decorate([
	        context_1.Autowired('sortController'),
	        __metadata("design:type", sortController_1.SortController)
	    ], SortService.prototype, "sortController", void 0);
	    __decorate([
	        context_1.Autowired('columnController'),
	        __metadata("design:type", columnController_1.ColumnController)
	    ], SortService.prototype, "columnController", void 0);
	    __decorate([
	        context_1.Autowired('valueService'),
	        __metadata("design:type", valueService_1.ValueService)
	    ], SortService.prototype, "valueService", void 0);
	    __decorate([
	        context_1.Autowired('gridOptionsWrapper'),
	        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
	    ], SortService.prototype, "gridOptionsWrapper", void 0);
	    __decorate([
	        context_1.PostConstruct,
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", []),
	        __metadata("design:returntype", void 0)
	    ], SortService.prototype, "init", null);
	    SortService = __decorate([
	        context_1.Bean('sortService')
	    ], SortService);
	    return SortService;
	}());
	exports.SortService = SortService;


/***/ }),
/* 2470 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var context_1 = __webpack_require__(2333);
	var rowNode_1 = __webpack_require__(2356);
	var gridOptionsWrapper_1 = __webpack_require__(2324);
	var selectionController_1 = __webpack_require__(2357);
	var eventService_1 = __webpack_require__(2331);
	var columnController_1 = __webpack_require__(2341);
	var utils_1 = __webpack_require__(2325);
	var FlattenStage = /** @class */ (function () {
	    function FlattenStage() {
	    }
	    FlattenStage.prototype.execute = function (params) {
	        var rootNode = params.rowNode;
	        // even if not doing grouping, we do the mapping, as the client might
	        // of passed in data that already has a grouping in it somewhere
	        var result = [];
	        // putting value into a wrapper so it's passed by reference
	        var nextRowTop = { value: 0 };
	        var skipLeafNodes = this.columnController.isPivotMode();
	        // if we are reducing, and not grouping, then we want to show the root node, as that
	        // is where the pivot values are
	        var showRootNode = skipLeafNodes && rootNode.leafGroup;
	        var topList = showRootNode ? [rootNode] : rootNode.childrenAfterSort;
	        this.recursivelyAddToRowsToDisplay(topList, result, nextRowTop, skipLeafNodes, 0);
	        // don't show total footer when showRootNode is true (i.e. in pivot mode and no groups)
	        var includeGroupTotalFooter = !showRootNode && this.gridOptionsWrapper.isGroupIncludeTotalFooter();
	        if (includeGroupTotalFooter) {
	            this.ensureFooterNodeExists(rootNode);
	            this.addRowNodeToRowsToDisplay(rootNode.sibling, result, nextRowTop, 0);
	        }
	        return result;
	    };
	    FlattenStage.prototype.recursivelyAddToRowsToDisplay = function (rowsToFlatten, result, nextRowTop, skipLeafNodes, uiLevel) {
	        if (utils_1._.missingOrEmpty(rowsToFlatten)) {
	            return;
	        }
	        var groupSuppressRow = this.gridOptionsWrapper.isGroupSuppressRow();
	        var hideOpenParents = this.gridOptionsWrapper.isGroupHideOpenParents();
	        // these two are mutually exclusive, so if first set, we don't set the second
	        var groupRemoveSingleChildren = this.gridOptionsWrapper.isGroupRemoveSingleChildren();
	        var groupRemoveLowestSingleChildren = !groupRemoveSingleChildren && this.gridOptionsWrapper.isGroupRemoveLowestSingleChildren();
	        for (var i = 0; i < rowsToFlatten.length; i++) {
	            var rowNode = rowsToFlatten[i];
	            // check all these cases, for working out if this row should be included in the final mapped list
	            var isParent = rowNode.hasChildren();
	            var isGroupSuppressedNode = groupSuppressRow && isParent;
	            var isSkippedLeafNode = skipLeafNodes && !isParent;
	            var isRemovedSingleChildrenGroup = groupRemoveSingleChildren && isParent && rowNode.childrenAfterGroup.length === 1;
	            var isRemovedLowestSingleChildrenGroup = groupRemoveLowestSingleChildren && isParent && rowNode.leafGroup && rowNode.childrenAfterGroup.length === 1;
	            // hide open parents means when group is open, we don't show it. we also need to make sure the
	            // group is expandable in the first place (as leaf groups are not expandable if pivot mode is on).
	            // the UI will never allow expanding leaf  groups, however the user might via the API (or menu option 'expand all')
	            var neverAllowToExpand = skipLeafNodes && rowNode.leafGroup;
	            var isHiddenOpenParent = hideOpenParents && rowNode.expanded && (!neverAllowToExpand);
	            var thisRowShouldBeRendered = !isSkippedLeafNode && !isGroupSuppressedNode && !isHiddenOpenParent && !isRemovedSingleChildrenGroup && !isRemovedLowestSingleChildrenGroup;
	            if (thisRowShouldBeRendered) {
	                this.addRowNodeToRowsToDisplay(rowNode, result, nextRowTop, uiLevel);
	            }
	            // if we are pivoting, we never map below the leaf group
	            if (skipLeafNodes && rowNode.leafGroup) {
	                continue;
	            }
	            if (isParent) {
	                var excludedParent = isRemovedSingleChildrenGroup || isRemovedLowestSingleChildrenGroup;
	                // we traverse the group if it is expended, however we always traverse if the parent node
	                // was removed (as the group will never be opened if it is not displayed, we show the children instead)
	                if (rowNode.expanded || excludedParent) {
	                    // if the parent was excluded, then ui level is that of the parent
	                    var uiLevelForChildren = excludedParent ? uiLevel : uiLevel + 1;
	                    this.recursivelyAddToRowsToDisplay(rowNode.childrenAfterSort, result, nextRowTop, skipLeafNodes, uiLevelForChildren);
	                    // put a footer in if user is looking for it
	                    if (this.gridOptionsWrapper.isGroupIncludeFooter()) {
	                        this.ensureFooterNodeExists(rowNode);
	                        this.addRowNodeToRowsToDisplay(rowNode.sibling, result, nextRowTop, uiLevel);
	                    }
	                }
	            }
	            else if (rowNode.master && rowNode.expanded) {
	                var detailNode = this.createDetailNode(rowNode);
	                this.addRowNodeToRowsToDisplay(detailNode, result, nextRowTop, uiLevel);
	            }
	        }
	    };
	    // duplicated method, it's also in floatingRowModel
	    FlattenStage.prototype.addRowNodeToRowsToDisplay = function (rowNode, result, nextRowTop, uiLevel) {
	        result.push(rowNode);
	        var isGroupMultiAutoColumn = this.gridOptionsWrapper.isGroupMultiAutoColumn();
	        rowNode.setUiLevel(isGroupMultiAutoColumn ? 0 : uiLevel);
	    };
	    FlattenStage.prototype.ensureFooterNodeExists = function (groupNode) {
	        // only create footer node once, otherwise we have daemons and
	        // the animate screws up with the daemons hanging around
	        if (utils_1._.exists(groupNode.sibling)) {
	            return;
	        }
	        var footerNode = new rowNode_1.RowNode();
	        this.context.wireBean(footerNode);
	        Object.keys(groupNode).forEach(function (key) {
	            footerNode[key] = groupNode[key];
	        });
	        footerNode.footer = true;
	        footerNode.rowTop = null;
	        footerNode.oldRowTop = null;
	        if (utils_1._.exists(footerNode.id)) {
	            footerNode.id = 'rowGroupFooter_' + footerNode.id;
	        }
	        // get both header and footer to reference each other as siblings. this is never undone,
	        // only overwritten. so if a group is expanded, then contracted, it will have a ghost
	        // sibling - but that's fine, as we can ignore this if the header is contracted.
	        footerNode.sibling = groupNode;
	        groupNode.sibling = footerNode;
	    };
	    FlattenStage.prototype.createDetailNode = function (masterNode) {
	        if (utils_1._.exists(masterNode.detailNode)) {
	            return masterNode.detailNode;
	        }
	        else {
	            var detailNode = new rowNode_1.RowNode();
	            this.context.wireBean(detailNode);
	            detailNode.detail = true;
	            detailNode.selectable = false;
	            // flower was renamed to 'detail', but keeping for backwards compatibility
	            detailNode.flower = detailNode.detail;
	            detailNode.parent = masterNode;
	            if (utils_1._.exists(masterNode.id)) {
	                detailNode.id = 'detail_' + masterNode.id;
	            }
	            detailNode.data = masterNode.data;
	            detailNode.level = masterNode.level + 1;
	            masterNode.detailNode = detailNode;
	            masterNode.childFlower = masterNode.detailNode; // for backwards compatibility
	            return detailNode;
	        }
	    };
	    __decorate([
	        context_1.Autowired('gridOptionsWrapper'),
	        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
	    ], FlattenStage.prototype, "gridOptionsWrapper", void 0);
	    __decorate([
	        context_1.Autowired('selectionController'),
	        __metadata("design:type", selectionController_1.SelectionController)
	    ], FlattenStage.prototype, "selectionController", void 0);
	    __decorate([
	        context_1.Autowired('eventService'),
	        __metadata("design:type", eventService_1.EventService)
	    ], FlattenStage.prototype, "eventService", void 0);
	    __decorate([
	        context_1.Autowired('context'),
	        __metadata("design:type", context_1.Context)
	    ], FlattenStage.prototype, "context", void 0);
	    __decorate([
	        context_1.Autowired('columnController'),
	        __metadata("design:type", columnController_1.ColumnController)
	    ], FlattenStage.prototype, "columnController", void 0);
	    FlattenStage = __decorate([
	        context_1.Bean('flattenStage')
	    ], FlattenStage);
	    return FlattenStage;
	}());
	exports.FlattenStage = FlattenStage;


/***/ }),
/* 2471 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var gridOptionsWrapper_1 = __webpack_require__(2324);
	var context_1 = __webpack_require__(2333);
	var eventService_1 = __webpack_require__(2331);
	var selectionController_1 = __webpack_require__(2357);
	var events_1 = __webpack_require__(2335);
	var sortController_1 = __webpack_require__(2391);
	var filterManager_1 = __webpack_require__(2378);
	var constants_1 = __webpack_require__(2328);
	var infiniteCache_1 = __webpack_require__(2472);
	var beanStub_1 = __webpack_require__(2354);
	var rowNodeCache_1 = __webpack_require__(2475);
	var rowNodeBlockLoader_1 = __webpack_require__(2476);
	var gridApi_1 = __webpack_require__(2338);
	var columnApi_1 = __webpack_require__(2346);
	var utils_1 = __webpack_require__(2325);
	var rowRenderer_1 = __webpack_require__(2350);
	var InfiniteRowModel = /** @class */ (function (_super) {
	    __extends(InfiniteRowModel, _super);
	    function InfiniteRowModel() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    InfiniteRowModel.prototype.getRowBounds = function (index) {
	        return {
	            rowHeight: this.rowHeight,
	            rowTop: this.rowHeight * index
	        };
	    };
	    // we don't implement as lazy row heights is not supported in this row model
	    InfiniteRowModel.prototype.ensureRowHeightsValid = function (startPixel, endPixel, startLimitIndex, endLimitIndex) { return false; };
	    InfiniteRowModel.prototype.init = function () {
	        var _this = this;
	        if (!this.gridOptionsWrapper.isRowModelInfinite()) {
	            return;
	        }
	        this.rowHeight = this.gridOptionsWrapper.getRowHeightAsNumber();
	        this.addEventListeners();
	        this.setDatasource(this.gridOptionsWrapper.getDatasource());
	        this.addDestroyFunc(function () { return _this.destroyCache(); });
	    };
	    InfiniteRowModel.prototype.destroyDatasource = function () {
	        if (this.datasource) {
	            if (this.datasource.destroy) {
	                this.datasource.destroy();
	            }
	            this.rowRenderer.datasourceChanged();
	            this.datasource = null;
	        }
	    };
	    InfiniteRowModel.prototype.isLastRowFound = function () {
	        return this.infiniteCache ? this.infiniteCache.isMaxRowFound() : false;
	    };
	    InfiniteRowModel.prototype.addEventListeners = function () {
	        this.addDestroyableEventListener(this.eventService, events_1.Events.EVENT_FILTER_CHANGED, this.onFilterChanged.bind(this));
	        this.addDestroyableEventListener(this.eventService, events_1.Events.EVENT_SORT_CHANGED, this.onSortChanged.bind(this));
	        this.addDestroyableEventListener(this.eventService, events_1.Events.EVENT_COLUMN_EVERYTHING_CHANGED, this.onColumnEverything.bind(this));
	    };
	    InfiniteRowModel.prototype.onFilterChanged = function () {
	        this.reset();
	    };
	    InfiniteRowModel.prototype.onSortChanged = function () {
	        this.reset();
	    };
	    InfiniteRowModel.prototype.onColumnEverything = function () {
	        var resetRequired;
	        // if cache params, we require reset only if sort model has changed. we don't need to check
	        // for filter model, as the filter manager will fire an event when columns change that result
	        // in the filter changing.
	        if (this.cacheParams) {
	            resetRequired = this.isSortModelDifferent();
	        }
	        else {
	            // if no cacheParams, means first time creating the cache, so always create one
	            resetRequired = true;
	        }
	        if (resetRequired) {
	            this.reset();
	        }
	    };
	    InfiniteRowModel.prototype.isSortModelDifferent = function () {
	        return !utils_1._.jsonEquals(this.cacheParams.sortModel, this.sortController.getSortModel());
	    };
	    InfiniteRowModel.prototype.getType = function () {
	        return constants_1.Constants.ROW_MODEL_TYPE_INFINITE;
	    };
	    InfiniteRowModel.prototype.setDatasource = function (datasource) {
	        this.destroyDatasource();
	        this.datasource = datasource;
	        // only reset if we have a valid datasource to working with
	        if (datasource) {
	            this.checkForDeprecated();
	            this.reset();
	        }
	    };
	    InfiniteRowModel.prototype.checkForDeprecated = function () {
	        var ds = this.datasource;
	        // the number of concurrent loads we are allowed to the server
	        if (utils_1._.exists(ds.maxConcurrentRequests)) {
	            console.error('ag-Grid: since version 5.1.x, maxConcurrentRequests is replaced with grid property maxConcurrentDatasourceRequests');
	        }
	        if (utils_1._.exists(ds.maxPagesInCache)) {
	            console.error('ag-Grid: since version 5.1.x, maxPagesInCache is replaced with grid property maxPagesInPaginationCache');
	        }
	        if (utils_1._.exists(ds.overflowSize)) {
	            console.error('ag-Grid: since version 5.1.x, overflowSize is replaced with grid property paginationOverflowSize');
	        }
	        if (utils_1._.exists(ds.blockSize)) {
	            console.error('ag-Grid: since version 5.1.x, pageSize/blockSize is replaced with grid property infinitePageSize');
	        }
	    };
	    InfiniteRowModel.prototype.isEmpty = function () {
	        return utils_1._.missing(this.infiniteCache);
	    };
	    InfiniteRowModel.prototype.isRowsToRender = function () {
	        return utils_1._.exists(this.infiniteCache);
	    };
	    InfiniteRowModel.prototype.getNodesInRangeForSelection = function (firstInRange, lastInRange) {
	        return this.infiniteCache ? this.infiniteCache.getRowNodesInRange(firstInRange, lastInRange) : [];
	    };
	    InfiniteRowModel.prototype.reset = function () {
	        // important to return here, as the user could be setting filter or sort before
	        // data-source is set
	        if (utils_1._.missing(this.datasource)) {
	            return;
	        }
	        // if user is providing id's, then this means we can keep the selection between datasource hits,
	        // as the rows will keep their unique id's even if, for example, server side sorting or filtering
	        // is done.
	        var userGeneratingIds = utils_1._.exists(this.gridOptionsWrapper.getRowNodeIdFunc());
	        if (!userGeneratingIds) {
	            this.selectionController.reset();
	        }
	        this.resetCache();
	        var event = this.createModelUpdatedEvent();
	        this.eventService.dispatchEvent(event);
	    };
	    InfiniteRowModel.prototype.createModelUpdatedEvent = function () {
	        return {
	            type: events_1.Events.EVENT_MODEL_UPDATED,
	            api: this.gridApi,
	            columnApi: this.columnApi,
	            // not sure if these should all be false - noticed if after implementing,
	            // maybe they should be true?
	            newPage: false,
	            newData: false,
	            keepRenderedRows: false,
	            animate: false
	        };
	    };
	    InfiniteRowModel.prototype.resetCache = function () {
	        // if not first time creating a cache, need to destroy the old one
	        this.destroyCache();
	        var maxConcurrentRequests = this.gridOptionsWrapper.getMaxConcurrentDatasourceRequests();
	        var blockLoadDebounceMillis = this.gridOptionsWrapper.getBlockLoadDebounceMillis();
	        // there is a bi-directional dependency between the loader and the cache,
	        // so we create loader here, and then pass dependencies in setDependencies() method later
	        this.rowNodeBlockLoader = new rowNodeBlockLoader_1.RowNodeBlockLoader(maxConcurrentRequests, blockLoadDebounceMillis);
	        this.getContext().wireBean(this.rowNodeBlockLoader);
	        this.cacheParams = {
	            // the user provided datasource
	            datasource: this.datasource,
	            // sort and filter model
	            filterModel: this.filterManager.getFilterModel(),
	            sortModel: this.sortController.getSortModel(),
	            rowNodeBlockLoader: this.rowNodeBlockLoader,
	            // properties - this way we take a snapshot of them, so if user changes any, they will be
	            // used next time we create a new cache, which is generally after a filter or sort change,
	            // or a new datasource is set
	            maxConcurrentRequests: maxConcurrentRequests,
	            overflowSize: this.gridOptionsWrapper.getCacheOverflowSize(),
	            initialRowCount: this.gridOptionsWrapper.getInfiniteInitialRowCount(),
	            maxBlocksInCache: this.gridOptionsWrapper.getMaxBlocksInCache(),
	            blockSize: this.gridOptionsWrapper.getCacheBlockSize(),
	            rowHeight: this.gridOptionsWrapper.getRowHeightAsNumber(),
	            // the cache could create this, however it is also used by the pages, so handy to create it
	            // here as the settings are also passed to the pages
	            lastAccessedSequence: new utils_1.NumberSequence()
	        };
	        // set defaults
	        if (!this.cacheParams.maxConcurrentRequests || !(this.cacheParams.maxConcurrentRequests >= 1)) {
	            this.cacheParams.maxConcurrentRequests = 2;
	        }
	        // page size needs to be 1 or greater. having it at 1 would be silly, as you would be hitting the
	        // server for one page at a time. so the default if not specified is 100.
	        if (!this.cacheParams.blockSize || !(this.cacheParams.blockSize >= 1)) {
	            this.cacheParams.blockSize = 100;
	        }
	        // if user doesn't give initial rows to display, we assume zero
	        if (!(this.cacheParams.initialRowCount >= 1)) {
	            this.cacheParams.initialRowCount = 0;
	        }
	        // if user doesn't provide overflow, we use default overflow of 1, so user can scroll past
	        // the current page and request first row of next page
	        if (!(this.cacheParams.overflowSize >= 1)) {
	            this.cacheParams.overflowSize = 1;
	        }
	        this.infiniteCache = new infiniteCache_1.InfiniteCache(this.cacheParams);
	        this.getContext().wireBean(this.infiniteCache);
	        this.infiniteCache.addEventListener(rowNodeCache_1.RowNodeCache.EVENT_CACHE_UPDATED, this.onCacheUpdated.bind(this));
	    };
	    InfiniteRowModel.prototype.destroyCache = function () {
	        if (this.infiniteCache) {
	            this.infiniteCache.destroy();
	            this.infiniteCache = null;
	        }
	        if (this.rowNodeBlockLoader) {
	            this.rowNodeBlockLoader.destroy();
	            this.rowNodeBlockLoader = null;
	        }
	    };
	    InfiniteRowModel.prototype.onCacheUpdated = function () {
	        var event = this.createModelUpdatedEvent();
	        this.eventService.dispatchEvent(event);
	    };
	    InfiniteRowModel.prototype.getRow = function (rowIndex) {
	        return this.infiniteCache ? this.infiniteCache.getRow(rowIndex) : null;
	    };
	    InfiniteRowModel.prototype.getRowNode = function (id) {
	        var result = null;
	        this.forEachNode(function (rowNode) {
	            if (rowNode.id === id) {
	                result = rowNode;
	            }
	        });
	        return result;
	    };
	    InfiniteRowModel.prototype.forEachNode = function (callback) {
	        if (this.infiniteCache) {
	            this.infiniteCache.forEachNodeDeep(callback, new utils_1.NumberSequence());
	        }
	    };
	    InfiniteRowModel.prototype.getCurrentPageHeight = function () {
	        return this.getRowCount() * this.rowHeight;
	    };
	    InfiniteRowModel.prototype.getTopLevelRowCount = function () {
	        return this.getRowCount();
	    };
	    InfiniteRowModel.prototype.getTopLevelRowDisplayedIndex = function (topLevelIndex) {
	        return topLevelIndex;
	    };
	    InfiniteRowModel.prototype.getRowIndexAtPixel = function (pixel) {
	        if (this.rowHeight !== 0) { // avoid divide by zero error
	            var rowIndexForPixel = Math.floor(pixel / this.rowHeight);
	            var lastRowIndex = this.getRowCount() - 1;
	            if (rowIndexForPixel > lastRowIndex) {
	                return lastRowIndex;
	            }
	            else {
	                return rowIndexForPixel;
	            }
	        }
	        else {
	            return 0;
	        }
	    };
	    InfiniteRowModel.prototype.getRowCount = function () {
	        return this.infiniteCache ? this.infiniteCache.getVirtualRowCount() : 0;
	    };
	    InfiniteRowModel.prototype.updateRowData = function (transaction) {
	        if (utils_1._.exists(transaction.remove) || utils_1._.exists(transaction.update)) {
	            console.warn('ag-Grid: updateRowData for InfiniteRowModel does not support remove or update, only add');
	            return;
	        }
	        if (utils_1._.missing(transaction.addIndex)) {
	            console.warn('ag-Grid: updateRowData for InfiniteRowModel requires add and addIndex to be set');
	            return;
	        }
	        if (this.infiniteCache) {
	            this.infiniteCache.insertItemsAtIndex(transaction.addIndex, transaction.add);
	        }
	    };
	    InfiniteRowModel.prototype.isRowPresent = function (rowNode) {
	        return false;
	    };
	    InfiniteRowModel.prototype.refreshCache = function () {
	        if (this.infiniteCache) {
	            this.infiniteCache.refreshCache();
	        }
	    };
	    InfiniteRowModel.prototype.purgeCache = function () {
	        if (this.infiniteCache) {
	            this.infiniteCache.purgeCache();
	        }
	    };
	    InfiniteRowModel.prototype.getVirtualRowCount = function () {
	        if (this.infiniteCache) {
	            return this.infiniteCache.getVirtualRowCount();
	        }
	        else {
	            return null;
	        }
	    };
	    InfiniteRowModel.prototype.isMaxRowFound = function () {
	        if (this.infiniteCache) {
	            return this.infiniteCache.isMaxRowFound();
	        }
	    };
	    InfiniteRowModel.prototype.setVirtualRowCount = function (rowCount, maxRowFound) {
	        if (this.infiniteCache) {
	            this.infiniteCache.setVirtualRowCount(rowCount, maxRowFound);
	        }
	    };
	    InfiniteRowModel.prototype.getBlockState = function () {
	        if (this.rowNodeBlockLoader) {
	            return this.rowNodeBlockLoader.getBlockState();
	        }
	        else {
	            return null;
	        }
	    };
	    __decorate([
	        context_1.Autowired('gridOptionsWrapper'),
	        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
	    ], InfiniteRowModel.prototype, "gridOptionsWrapper", void 0);
	    __decorate([
	        context_1.Autowired('filterManager'),
	        __metadata("design:type", filterManager_1.FilterManager)
	    ], InfiniteRowModel.prototype, "filterManager", void 0);
	    __decorate([
	        context_1.Autowired('sortController'),
	        __metadata("design:type", sortController_1.SortController)
	    ], InfiniteRowModel.prototype, "sortController", void 0);
	    __decorate([
	        context_1.Autowired('selectionController'),
	        __metadata("design:type", selectionController_1.SelectionController)
	    ], InfiniteRowModel.prototype, "selectionController", void 0);
	    __decorate([
	        context_1.Autowired('eventService'),
	        __metadata("design:type", eventService_1.EventService)
	    ], InfiniteRowModel.prototype, "eventService", void 0);
	    __decorate([
	        context_1.Autowired('gridApi'),
	        __metadata("design:type", gridApi_1.GridApi)
	    ], InfiniteRowModel.prototype, "gridApi", void 0);
	    __decorate([
	        context_1.Autowired('columnApi'),
	        __metadata("design:type", columnApi_1.ColumnApi)
	    ], InfiniteRowModel.prototype, "columnApi", void 0);
	    __decorate([
	        context_1.Autowired('rowRenderer'),
	        __metadata("design:type", rowRenderer_1.RowRenderer)
	    ], InfiniteRowModel.prototype, "rowRenderer", void 0);
	    __decorate([
	        context_1.PostConstruct,
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", []),
	        __metadata("design:returntype", void 0)
	    ], InfiniteRowModel.prototype, "init", null);
	    __decorate([
	        context_1.PreDestroy,
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", []),
	        __metadata("design:returntype", void 0)
	    ], InfiniteRowModel.prototype, "destroyDatasource", null);
	    InfiniteRowModel = __decorate([
	        context_1.Bean('rowModel')
	    ], InfiniteRowModel);
	    return InfiniteRowModel;
	}(beanStub_1.BeanStub));
	exports.InfiniteRowModel = InfiniteRowModel;


/***/ }),
/* 2472 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var __param = (this && this.__param) || function (paramIndex, decorator) {
	    return function (target, key) { decorator(target, key, paramIndex); }
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var context_1 = __webpack_require__(2333);
	var eventService_1 = __webpack_require__(2331);
	var events_1 = __webpack_require__(2335);
	var logger_1 = __webpack_require__(2332);
	var infiniteBlock_1 = __webpack_require__(2473);
	var rowNodeCache_1 = __webpack_require__(2475);
	var gridApi_1 = __webpack_require__(2338);
	var columnApi_1 = __webpack_require__(2346);
	var InfiniteCache = /** @class */ (function (_super) {
	    __extends(InfiniteCache, _super);
	    function InfiniteCache(params) {
	        return _super.call(this, params) || this;
	    }
	    InfiniteCache.prototype.setBeans = function (loggerFactory) {
	        this.logger = loggerFactory.create('InfiniteCache');
	    };
	    InfiniteCache.prototype.init = function () {
	        _super.prototype.init.call(this);
	        // start load of data, as the virtualRowCount will remain at 0 otherwise,
	        // so we need this to kick things off, otherwise grid would never call getRow()
	        this.getRow(0);
	    };
	    InfiniteCache.prototype.moveItemsDown = function (block, moveFromIndex, moveCount) {
	        var startRow = block.getStartRow();
	        var endRow = block.getEndRow();
	        var indexOfLastRowToMove = moveFromIndex + moveCount;
	        // all rows need to be moved down below the insertion index
	        for (var currentRowIndex = endRow - 1; currentRowIndex >= startRow; currentRowIndex--) {
	            // don't move rows at or before the insertion index
	            if (currentRowIndex < indexOfLastRowToMove) {
	                continue;
	            }
	            var indexOfNodeWeWant = currentRowIndex - moveCount;
	            var nodeForThisIndex = this.getRow(indexOfNodeWeWant, true);
	            if (nodeForThisIndex) {
	                block.setRowNode(currentRowIndex, nodeForThisIndex);
	            }
	            else {
	                block.setBlankRowNode(currentRowIndex);
	                block.setDirty();
	            }
	        }
	    };
	    InfiniteCache.prototype.insertItems = function (block, indexToInsert, items) {
	        var pageStartRow = block.getStartRow();
	        var pageEndRow = block.getEndRow();
	        var newRowNodes = [];
	        // next stage is insert the rows into this page, if applicable
	        for (var index = 0; index < items.length; index++) {
	            var rowIndex = indexToInsert + index;
	            var currentRowInThisPage = rowIndex >= pageStartRow && rowIndex < pageEndRow;
	            if (currentRowInThisPage) {
	                var dataItem = items[index];
	                var newRowNode = block.setNewData(rowIndex, dataItem);
	                newRowNodes.push(newRowNode);
	            }
	        }
	        return newRowNodes;
	    };
	    InfiniteCache.prototype.insertItemsAtIndex = function (indexToInsert, items) {
	        // get all page id's as NUMBERS (not strings, as we need to sort as numbers) and in descending order
	        var _this = this;
	        var newNodes = [];
	        this.forEachBlockInReverseOrder(function (block) {
	            var pageEndRow = block.getEndRow();
	            // if the insertion is after this page, then this page is not impacted
	            if (pageEndRow <= indexToInsert) {
	                return;
	            }
	            _this.moveItemsDown(block, indexToInsert, items.length);
	            var newNodesThisPage = _this.insertItems(block, indexToInsert, items);
	            newNodesThisPage.forEach(function (rowNode) { return newNodes.push(rowNode); });
	        });
	        if (this.isMaxRowFound()) {
	            this.hack_setVirtualRowCount(this.getVirtualRowCount() + items.length);
	        }
	        this.onCacheUpdated();
	        var event = {
	            type: events_1.Events.EVENT_ROW_DATA_UPDATED,
	            api: this.gridApi,
	            columnApi: this.columnApi
	        };
	        this.eventService.dispatchEvent(event);
	    };
	    // the rowRenderer will not pass dontCreatePage, meaning when rendering the grid,
	    // it will want new pages in the cache as it asks for rows. only when we are inserting /
	    // removing rows via the api is dontCreatePage set, where we move rows between the pages.
	    InfiniteCache.prototype.getRow = function (rowIndex, dontCreatePage) {
	        if (dontCreatePage === void 0) { dontCreatePage = false; }
	        var blockId = Math.floor(rowIndex / this.cacheParams.blockSize);
	        var block = this.getBlock(blockId);
	        if (!block) {
	            if (dontCreatePage) {
	                return null;
	            }
	            else {
	                block = this.createBlock(blockId);
	            }
	        }
	        return block.getRow(rowIndex);
	    };
	    InfiniteCache.prototype.createBlock = function (blockNumber) {
	        var newBlock = new infiniteBlock_1.InfiniteBlock(blockNumber, this.cacheParams);
	        this.getContext().wireBean(newBlock);
	        this.postCreateBlock(newBlock);
	        return newBlock;
	    };
	    // we have this on infinite row model only, not server side row model,
	    // because for server side, it would leave the children in inconsistent
	    // state - eg if a node had children, but after the refresh it had data
	    // for a different row, then the children would be with the wrong row node.
	    InfiniteCache.prototype.refreshCache = function () {
	        this.forEachBlockInOrder(function (block) { return block.setDirty(); });
	        this.checkBlockToLoad();
	    };
	    __decorate([
	        context_1.Autowired('eventService'),
	        __metadata("design:type", eventService_1.EventService)
	    ], InfiniteCache.prototype, "eventService", void 0);
	    __decorate([
	        context_1.Autowired('columnApi'),
	        __metadata("design:type", columnApi_1.ColumnApi)
	    ], InfiniteCache.prototype, "columnApi", void 0);
	    __decorate([
	        context_1.Autowired('gridApi'),
	        __metadata("design:type", gridApi_1.GridApi)
	    ], InfiniteCache.prototype, "gridApi", void 0);
	    __decorate([
	        __param(0, context_1.Qualifier('loggerFactory')),
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", [logger_1.LoggerFactory]),
	        __metadata("design:returntype", void 0)
	    ], InfiniteCache.prototype, "setBeans", null);
	    __decorate([
	        context_1.PostConstruct,
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", []),
	        __metadata("design:returntype", void 0)
	    ], InfiniteCache.prototype, "init", null);
	    return InfiniteCache;
	}(rowNodeCache_1.RowNodeCache));
	exports.InfiniteCache = InfiniteCache;


/***/ }),
/* 2473 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var gridOptionsWrapper_1 = __webpack_require__(2324);
	var context_1 = __webpack_require__(2333);
	var rowNodeBlock_1 = __webpack_require__(2474);
	var rowRenderer_1 = __webpack_require__(2350);
	var utils_1 = __webpack_require__(2325);
	var InfiniteBlock = /** @class */ (function (_super) {
	    __extends(InfiniteBlock, _super);
	    function InfiniteBlock(pageNumber, params) {
	        var _this = _super.call(this, pageNumber, params) || this;
	        _this.cacheParams = params;
	        return _this;
	    }
	    InfiniteBlock.prototype.createBlankRowNode = function (rowIndex) {
	        var rowNode = _super.prototype.createBlankRowNode.call(this, rowIndex);
	        rowNode.uiLevel = 0;
	        this.setIndexAndTopOnRowNode(rowNode, rowIndex);
	        return rowNode;
	    };
	    InfiniteBlock.prototype.setDataAndId = function (rowNode, data, index) {
	        if (utils_1._.exists(data)) {
	            // this means if the user is not providing id's we just use the
	            // index for the row. this will allow selection to work (that is based
	            // on index) as long user is not inserting or deleting rows,
	            // or wanting to keep selection between server side sorting or filtering
	            rowNode.setDataAndId(data, index.toString());
	        }
	        else {
	            rowNode.setDataAndId(undefined, undefined);
	        }
	    };
	    InfiniteBlock.prototype.setRowNode = function (rowIndex, rowNode) {
	        _super.prototype.setRowNode.call(this, rowIndex, rowNode);
	        this.setIndexAndTopOnRowNode(rowNode, rowIndex);
	    };
	    InfiniteBlock.prototype.init = function () {
	        _super.prototype.init.call(this, {
	            context: this.getContext(),
	            rowRenderer: this.rowRenderer
	        });
	    };
	    InfiniteBlock.prototype.getNodeIdPrefix = function () {
	        return null;
	    };
	    InfiniteBlock.prototype.getRow = function (displayIndex) {
	        return this.getRowUsingLocalIndex(displayIndex);
	    };
	    InfiniteBlock.prototype.setIndexAndTopOnRowNode = function (rowNode, rowIndex) {
	        rowNode.setRowIndex(rowIndex);
	        rowNode.rowTop = this.cacheParams.rowHeight * rowIndex;
	    };
	    InfiniteBlock.prototype.loadFromDatasource = function () {
	        var _this = this;
	        // PROBLEM . . . . when the user sets sort via colDef.sort, then this code
	        // is executing before the sort is set up, so server is not getting the sort
	        // model. need to change with regards order - so the server side request is
	        // AFTER thus it gets the right sort model.
	        var params = {
	            startRow: this.getStartRow(),
	            endRow: this.getEndRow(),
	            successCallback: this.pageLoaded.bind(this, this.getVersion()),
	            failCallback: this.pageLoadFailed.bind(this),
	            sortModel: this.cacheParams.sortModel,
	            filterModel: this.cacheParams.filterModel,
	            context: this.gridOptionsWrapper.getContext()
	        };
	        if (utils_1._.missing(this.cacheParams.datasource.getRows)) {
	            console.warn("ag-Grid: datasource is missing getRows method");
	            return;
	        }
	        // check if old version of datasource used
	        var getRowsParams = utils_1._.getFunctionParameters(this.cacheParams.datasource.getRows);
	        if (getRowsParams.length > 1) {
	            console.warn('ag-grid: It looks like your paging datasource is of the old type, taking more than one parameter.');
	            console.warn('ag-grid: From ag-grid 1.9.0, now the getRows takes one parameter. See the documentation for details.');
	        }
	        // put in timeout, to force result to be async
	        window.setTimeout(function () {
	            _this.cacheParams.datasource.getRows(params);
	        }, 0);
	    };
	    __decorate([
	        context_1.Autowired('gridOptionsWrapper'),
	        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
	    ], InfiniteBlock.prototype, "gridOptionsWrapper", void 0);
	    __decorate([
	        context_1.Autowired('rowRenderer'),
	        __metadata("design:type", rowRenderer_1.RowRenderer)
	    ], InfiniteBlock.prototype, "rowRenderer", void 0);
	    __decorate([
	        context_1.PostConstruct,
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", []),
	        __metadata("design:returntype", void 0)
	    ], InfiniteBlock.prototype, "init", null);
	    return InfiniteBlock;
	}(rowNodeBlock_1.RowNodeBlock));
	exports.InfiniteBlock = InfiniteBlock;


/***/ }),
/* 2474 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var utils_1 = __webpack_require__(2325);
	var rowNode_1 = __webpack_require__(2356);
	var beanStub_1 = __webpack_require__(2354);
	var RowNodeBlock = /** @class */ (function (_super) {
	    __extends(RowNodeBlock, _super);
	    function RowNodeBlock(blockNumber, rowNodeCacheParams) {
	        var _this = _super.call(this) || this;
	        _this.version = 0;
	        _this.state = RowNodeBlock.STATE_DIRTY;
	        _this.rowNodeCacheParams = rowNodeCacheParams;
	        _this.blockNumber = blockNumber;
	        // we don't need to calculate these now, as the inputs don't change,
	        // however it makes the code easier to read if we work them out up front
	        _this.startRow = blockNumber * rowNodeCacheParams.blockSize;
	        _this.endRow = _this.startRow + rowNodeCacheParams.blockSize;
	        return _this;
	    }
	    RowNodeBlock.prototype.isAnyNodeOpen = function (rowCount) {
	        var result = false;
	        this.forEachNodeCallback(function (rowNode) {
	            if (rowNode.expanded) {
	                result = true;
	            }
	        }, rowCount);
	        return result;
	    };
	    RowNodeBlock.prototype.forEachNodeCallback = function (callback, rowCount) {
	        for (var rowIndex = this.startRow; rowIndex < this.endRow; rowIndex++) {
	            // we check against rowCount as this page may be the last one, and if it is, then
	            // the last rows are not part of the set
	            if (rowIndex < rowCount) {
	                var rowNode = this.getRowUsingLocalIndex(rowIndex);
	                callback(rowNode, rowIndex);
	            }
	        }
	    };
	    RowNodeBlock.prototype.forEachNode = function (callback, sequence, rowCount, deep) {
	        this.forEachNodeCallback(function (rowNode) {
	            callback(rowNode, sequence.next());
	            // this will only every happen for server side row model, as infinite
	            // row model doesn't have groups
	            if (deep && rowNode.childrenCache) {
	                rowNode.childrenCache.forEachNodeDeep(callback, sequence);
	            }
	        }, rowCount);
	    };
	    RowNodeBlock.prototype.forEachNodeDeep = function (callback, sequence, rowCount) {
	        this.forEachNode(callback, sequence, rowCount, true);
	    };
	    RowNodeBlock.prototype.forEachNodeShallow = function (callback, sequence, rowCount) {
	        this.forEachNode(callback, sequence, rowCount, false);
	    };
	    RowNodeBlock.prototype.getVersion = function () {
	        return this.version;
	    };
	    RowNodeBlock.prototype.getLastAccessed = function () {
	        return this.lastAccessed;
	    };
	    RowNodeBlock.prototype.getRowUsingLocalIndex = function (rowIndex, dontTouchLastAccessed) {
	        if (dontTouchLastAccessed === void 0) { dontTouchLastAccessed = false; }
	        if (!dontTouchLastAccessed) {
	            this.lastAccessed = this.rowNodeCacheParams.lastAccessedSequence.next();
	        }
	        var localIndex = rowIndex - this.startRow;
	        return this.rowNodes[localIndex];
	    };
	    RowNodeBlock.prototype.init = function (beans) {
	        this.beans = beans;
	        this.createRowNodes();
	    };
	    RowNodeBlock.prototype.getStartRow = function () {
	        return this.startRow;
	    };
	    RowNodeBlock.prototype.getEndRow = function () {
	        return this.endRow;
	    };
	    RowNodeBlock.prototype.getBlockNumber = function () {
	        return this.blockNumber;
	    };
	    RowNodeBlock.prototype.setDirty = function () {
	        // in case any current loads in progress, this will have their results ignored
	        this.version++;
	        this.state = RowNodeBlock.STATE_DIRTY;
	    };
	    RowNodeBlock.prototype.setDirtyAndPurge = function () {
	        this.setDirty();
	        this.rowNodes.forEach(function (rowNode) {
	            rowNode.setData(null);
	        });
	    };
	    RowNodeBlock.prototype.getState = function () {
	        return this.state;
	    };
	    RowNodeBlock.prototype.setRowNode = function (rowIndex, rowNode) {
	        var localIndex = rowIndex - this.startRow;
	        this.rowNodes[localIndex] = rowNode;
	    };
	    RowNodeBlock.prototype.setBlankRowNode = function (rowIndex) {
	        var localIndex = rowIndex - this.startRow;
	        var newRowNode = this.createBlankRowNode(rowIndex);
	        this.rowNodes[localIndex] = newRowNode;
	        return newRowNode;
	    };
	    RowNodeBlock.prototype.setNewData = function (rowIndex, dataItem) {
	        var newRowNode = this.setBlankRowNode(rowIndex);
	        this.setDataAndId(newRowNode, dataItem, this.startRow + rowIndex);
	        return newRowNode;
	    };
	    RowNodeBlock.prototype.createBlankRowNode = function (rowIndex) {
	        var rowNode = new rowNode_1.RowNode();
	        this.beans.context.wireBean(rowNode);
	        rowNode.setRowHeight(this.rowNodeCacheParams.rowHeight);
	        return rowNode;
	    };
	    // creates empty row nodes, data is missing as not loaded yet
	    RowNodeBlock.prototype.createRowNodes = function () {
	        this.rowNodes = [];
	        for (var i = 0; i < this.rowNodeCacheParams.blockSize; i++) {
	            var rowIndex = this.startRow + i;
	            var rowNode = this.createBlankRowNode(rowIndex);
	            this.rowNodes.push(rowNode);
	        }
	    };
	    RowNodeBlock.prototype.load = function () {
	        this.state = RowNodeBlock.STATE_LOADING;
	        this.loadFromDatasource();
	    };
	    RowNodeBlock.prototype.pageLoadFailed = function () {
	        this.state = RowNodeBlock.STATE_FAILED;
	        var event = {
	            type: RowNodeBlock.EVENT_LOAD_COMPLETE,
	            success: false,
	            page: this,
	            lastRow: null
	        };
	        this.dispatchEvent(event);
	    };
	    RowNodeBlock.prototype.populateWithRowData = function (rows) {
	        var _this = this;
	        var rowNodesToRefresh = [];
	        this.rowNodes.forEach(function (rowNode, index) {
	            var data = rows[index];
	            if (rowNode.stub) {
	                rowNodesToRefresh.push(rowNode);
	            }
	            _this.setDataAndId(rowNode, data, _this.startRow + index);
	        });
	        if (rowNodesToRefresh.length > 0) {
	            this.beans.rowRenderer.redrawRows(rowNodesToRefresh);
	        }
	    };
	    RowNodeBlock.prototype.destroy = function () {
	        _super.prototype.destroy.call(this);
	        this.rowNodes.forEach(function (rowNode) {
	            if (rowNode.childrenCache) {
	                rowNode.childrenCache.destroy();
	                rowNode.childrenCache = null;
	            }
	            // this is needed, so row render knows to fade out the row, otherwise it
	            // sees row top is present, and thinks the row should be shown. maybe
	            // rowNode should have a flag on whether it is visible???
	            rowNode.clearRowTop();
	        });
	    };
	    RowNodeBlock.prototype.pageLoaded = function (version, rows, lastRow) {
	        // we need to check the version, in case there was an old request
	        // from the server that was sent before we refreshed the cache,
	        // if the load was done as a result of a cache refresh
	        if (version === this.version) {
	            this.state = RowNodeBlock.STATE_LOADED;
	            this.populateWithRowData(rows);
	        }
	        lastRow = utils_1._.cleanNumber(lastRow);
	        // check here if lastRow should be set
	        var event = {
	            type: RowNodeBlock.EVENT_LOAD_COMPLETE,
	            success: true,
	            page: this,
	            lastRow: lastRow
	        };
	        this.dispatchEvent(event);
	    };
	    RowNodeBlock.EVENT_LOAD_COMPLETE = 'loadComplete';
	    RowNodeBlock.STATE_DIRTY = 'dirty';
	    RowNodeBlock.STATE_LOADING = 'loading';
	    RowNodeBlock.STATE_LOADED = 'loaded';
	    RowNodeBlock.STATE_FAILED = 'failed';
	    return RowNodeBlock;
	}(beanStub_1.BeanStub));
	exports.RowNodeBlock = RowNodeBlock;


/***/ }),
/* 2475 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var beanStub_1 = __webpack_require__(2354);
	var rowNodeBlock_1 = __webpack_require__(2474);
	var utils_1 = __webpack_require__(2325);
	var RowNodeCache = /** @class */ (function (_super) {
	    __extends(RowNodeCache, _super);
	    function RowNodeCache(cacheParams) {
	        var _this = _super.call(this) || this;
	        _this.maxRowFound = false;
	        _this.blocks = {};
	        _this.blockCount = 0;
	        _this.virtualRowCount = cacheParams.initialRowCount;
	        _this.cacheParams = cacheParams;
	        return _this;
	    }
	    RowNodeCache.prototype.destroy = function () {
	        var _this = this;
	        _super.prototype.destroy.call(this);
	        this.forEachBlockInOrder(function (block) { return _this.destroyBlock(block); });
	    };
	    RowNodeCache.prototype.init = function () {
	        var _this = this;
	        this.active = true;
	        this.addDestroyFunc(function () { return _this.active = false; });
	    };
	    RowNodeCache.prototype.isActive = function () {
	        return this.active;
	    };
	    RowNodeCache.prototype.getVirtualRowCount = function () {
	        return this.virtualRowCount;
	    };
	    RowNodeCache.prototype.hack_setVirtualRowCount = function (virtualRowCount) {
	        this.virtualRowCount = virtualRowCount;
	    };
	    RowNodeCache.prototype.isMaxRowFound = function () {
	        return this.maxRowFound;
	    };
	    // listener on EVENT_LOAD_COMPLETE
	    RowNodeCache.prototype.onPageLoaded = function (event) {
	        this.cacheParams.rowNodeBlockLoader.loadComplete();
	        this.checkBlockToLoad();
	        // if we are not active, then we ignore all events, otherwise we could end up getting the
	        // grid to refresh even though we are no longer the active cache
	        if (!this.isActive()) {
	            return;
	        }
	        this.logger.log("onPageLoaded: page = " + event.page.getBlockNumber() + ", lastRow = " + event.lastRow);
	        if (event.success) {
	            this.checkVirtualRowCount(event.page, event.lastRow);
	        }
	    };
	    RowNodeCache.prototype.purgeBlocksIfNeeded = function (blockToExclude) {
	        var _this = this;
	        // put all candidate blocks into a list for sorting
	        var blocksForPurging = [];
	        this.forEachBlockInOrder(function (block) {
	            // we exclude checking for the page just created, as this has yet to be accessed and hence
	            // the lastAccessed stamp will not be updated for the first time yet
	            if (block === blockToExclude) {
	                return;
	            }
	            blocksForPurging.push(block);
	        });
	        // note: need to verify that this sorts items in the right order
	        blocksForPurging.sort(function (a, b) { return b.getLastAccessed() - a.getLastAccessed(); });
	        // we remove (maxBlocksInCache - 1) as we already excluded the 'just created' page.
	        // in other words, after the splice operation below, we have taken out the blocks
	        // we want to keep, which means we are left with blocks that we can potentially purge
	        var maxBlocksProvided = this.cacheParams.maxBlocksInCache > 0;
	        var blocksToKeep = maxBlocksProvided ? this.cacheParams.maxBlocksInCache - 1 : null;
	        var emptyBlocksToKeep = RowNodeCache.MAX_EMPTY_BLOCKS_TO_KEEP - 1;
	        blocksForPurging.forEach(function (block, index) {
	            var purgeBecauseBlockEmpty = block.getState() === rowNodeBlock_1.RowNodeBlock.STATE_DIRTY && index >= emptyBlocksToKeep;
	            var purgeBecauseCacheFull = maxBlocksProvided ? index >= blocksToKeep : false;
	            if (purgeBecauseBlockEmpty || purgeBecauseCacheFull) {
	                // we never purge blocks if they are open, as purging them would mess up with
	                // our indexes, it would be very messy to restore the purged block to it's
	                // previous state if it had open children (and what if open children of open
	                // children, jeeeesus, just thinking about it freaks me out) so best is have a
	                // rule, if block is open, we never purge.
	                if (block.isAnyNodeOpen(_this.virtualRowCount)) {
	                    return;
	                }
	                // at this point, block is not needed, and no open nodes, so burn baby burn
	                _this.removeBlockFromCache(block);
	            }
	        });
	    };
	    RowNodeCache.prototype.postCreateBlock = function (newBlock) {
	        newBlock.addEventListener(rowNodeBlock_1.RowNodeBlock.EVENT_LOAD_COMPLETE, this.onPageLoaded.bind(this));
	        this.setBlock(newBlock.getBlockNumber(), newBlock);
	        this.purgeBlocksIfNeeded(newBlock);
	        this.checkBlockToLoad();
	    };
	    RowNodeCache.prototype.removeBlockFromCache = function (blockToRemove) {
	        if (!blockToRemove) {
	            return;
	        }
	        this.destroyBlock(blockToRemove);
	        // we do not want to remove the 'loaded' event listener, as the
	        // concurrent loads count needs to be updated when the load is complete
	        // if the purged page is in loading state
	    };
	    // gets called after: 1) block loaded 2) block created 3) cache refresh
	    RowNodeCache.prototype.checkBlockToLoad = function () {
	        this.cacheParams.rowNodeBlockLoader.checkBlockToLoad();
	    };
	    RowNodeCache.prototype.checkVirtualRowCount = function (block, lastRow) {
	        // if client provided a last row, we always use it, as it could change between server calls
	        // if user deleted data and then called refresh on the grid.
	        if (typeof lastRow === 'number' && lastRow >= 0) {
	            this.virtualRowCount = lastRow;
	            this.maxRowFound = true;
	            this.onCacheUpdated();
	        }
	        else if (!this.maxRowFound) {
	            // otherwise, see if we need to add some virtual rows
	            var lastRowIndex = (block.getBlockNumber() + 1) * this.cacheParams.blockSize;
	            var lastRowIndexPlusOverflow = lastRowIndex + this.cacheParams.overflowSize;
	            if (this.virtualRowCount < lastRowIndexPlusOverflow) {
	                this.virtualRowCount = lastRowIndexPlusOverflow;
	                this.onCacheUpdated();
	            }
	            else if (this.cacheParams.dynamicRowHeight) {
	                // the only other time is if dynamic row height, as loading rows
	                // will change the height of the block, given the height of the rows
	                // is only known after the row is loaded.
	                this.onCacheUpdated();
	            }
	        }
	    };
	    RowNodeCache.prototype.setVirtualRowCount = function (rowCount, maxRowFound) {
	        this.virtualRowCount = rowCount;
	        // if undefined is passed, we do not set this value, if one of {true,false}
	        // is passed, we do set the value.
	        if (utils_1._.exists(maxRowFound)) {
	            this.maxRowFound = maxRowFound;
	        }
	        // if we are still searching, then the row count must not end at the end
	        // of a particular page, otherwise the searching will not pop into the
	        // next page
	        if (!this.maxRowFound) {
	            if (this.virtualRowCount % this.cacheParams.blockSize === 0) {
	                this.virtualRowCount++;
	            }
	        }
	        this.onCacheUpdated();
	    };
	    RowNodeCache.prototype.forEachNodeDeep = function (callback, sequence) {
	        var _this = this;
	        if (sequence === void 0) { sequence = new utils_1.NumberSequence(); }
	        this.forEachBlockInOrder(function (block) {
	            block.forEachNodeDeep(callback, sequence, _this.virtualRowCount);
	        });
	    };
	    RowNodeCache.prototype.forEachBlockInOrder = function (callback) {
	        var ids = this.getBlockIdsSorted();
	        this.forEachBlockId(ids, callback);
	    };
	    RowNodeCache.prototype.forEachBlockInReverseOrder = function (callback) {
	        var ids = this.getBlockIdsSorted().reverse();
	        this.forEachBlockId(ids, callback);
	    };
	    RowNodeCache.prototype.forEachBlockId = function (ids, callback) {
	        var _this = this;
	        ids.forEach(function (id) {
	            var block = _this.blocks[id];
	            callback(block, id);
	        });
	    };
	    RowNodeCache.prototype.getBlockIdsSorted = function () {
	        // get all page id's as NUMBERS (not strings, as we need to sort as numbers) and in descending order
	        var numberComparator = function (a, b) { return a - b; }; // default comparator for array is string comparison
	        var blockIds = Object.keys(this.blocks).map(function (idStr) { return parseInt(idStr, 10); }).sort(numberComparator);
	        return blockIds;
	    };
	    RowNodeCache.prototype.getBlock = function (blockId) {
	        return this.blocks[blockId];
	    };
	    RowNodeCache.prototype.setBlock = function (id, block) {
	        this.blocks[id] = block;
	        this.blockCount++;
	        this.cacheParams.rowNodeBlockLoader.addBlock(block);
	    };
	    RowNodeCache.prototype.destroyBlock = function (block) {
	        delete this.blocks[block.getBlockNumber()];
	        block.destroy();
	        this.blockCount--;
	        this.cacheParams.rowNodeBlockLoader.removeBlock(block);
	    };
	    // gets called 1) row count changed 2) cache purged 3) items inserted
	    RowNodeCache.prototype.onCacheUpdated = function () {
	        if (this.isActive()) {
	            // this results in both row models (infinite and server side) firing ModelUpdated,
	            // however server side row model also updates the row indexes first
	            var event_1 = {
	                type: RowNodeCache.EVENT_CACHE_UPDATED
	            };
	            this.dispatchEvent(event_1);
	        }
	    };
	    RowNodeCache.prototype.purgeCache = function () {
	        var _this = this;
	        this.forEachBlockInOrder(function (block) { return _this.removeBlockFromCache(block); });
	        // re-initialise cache - this ensures a cache with no rows can reload when purged!
	        this.virtualRowCount = this.cacheParams.initialRowCount;
	        this.maxRowFound = false;
	        this.onCacheUpdated();
	    };
	    RowNodeCache.prototype.getRowNodesInRange = function (firstInRange, lastInRange) {
	        var _this = this;
	        var result = [];
	        var lastBlockId = -1;
	        var inActiveRange = false;
	        var numberSequence = new utils_1.NumberSequence();
	        // if only one node passed, we start the selection at the top
	        if (utils_1._.missing(firstInRange)) {
	            inActiveRange = true;
	        }
	        var foundGapInSelection = false;
	        this.forEachBlockInOrder(function (block, id) {
	            if (foundGapInSelection) {
	                return;
	            }
	            if (inActiveRange && (lastBlockId + 1 !== id)) {
	                foundGapInSelection = true;
	                return;
	            }
	            lastBlockId = id;
	            block.forEachNodeShallow(function (rowNode) {
	                var hitFirstOrLast = rowNode === firstInRange || rowNode === lastInRange;
	                if (inActiveRange || hitFirstOrLast) {
	                    result.push(rowNode);
	                }
	                if (hitFirstOrLast) {
	                    inActiveRange = !inActiveRange;
	                }
	            }, numberSequence, _this.virtualRowCount);
	        });
	        // inActiveRange will be still true if we never hit the second rowNode
	        var invalidRange = foundGapInSelection || inActiveRange;
	        return invalidRange ? [] : result;
	    };
	    RowNodeCache.EVENT_CACHE_UPDATED = 'cacheUpdated';
	    // this property says how many empty blocks should be in a cache, eg if scrolls down fast and creates 10
	    // blocks all for loading, the grid will only load the last 2 - it will assume the blocks the user quickly
	    // scrolled over are not needed to be loaded.
	    RowNodeCache.MAX_EMPTY_BLOCKS_TO_KEEP = 2;
	    return RowNodeCache;
	}(beanStub_1.BeanStub));
	exports.RowNodeCache = RowNodeCache;


/***/ }),
/* 2476 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var __param = (this && this.__param) || function (paramIndex, decorator) {
	    return function (target, key) { decorator(target, key, paramIndex); }
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var rowNodeBlock_1 = __webpack_require__(2474);
	var logger_1 = __webpack_require__(2332);
	var context_1 = __webpack_require__(2333);
	var utils_1 = __webpack_require__(2325);
	var RowNodeBlockLoader = /** @class */ (function () {
	    function RowNodeBlockLoader(maxConcurrentRequests, blockLoadDebounceMillis) {
	        this.activeBlockLoadsCount = 0;
	        this.blocks = [];
	        this.active = true;
	        this.maxConcurrentRequests = maxConcurrentRequests;
	        if (blockLoadDebounceMillis && blockLoadDebounceMillis > 0) {
	            this.checkBlockToLoadDebounce = utils_1._.debounce(this.performCheckBlocksToLoad.bind(this), blockLoadDebounceMillis);
	        }
	    }
	    RowNodeBlockLoader.prototype.setBeans = function (loggerFactory) {
	        this.logger = loggerFactory.create('RowNodeBlockLoader');
	    };
	    RowNodeBlockLoader.prototype.addBlock = function (block) {
	        this.blocks.push(block);
	    };
	    RowNodeBlockLoader.prototype.removeBlock = function (block) {
	        utils_1._.removeFromArray(this.blocks, block);
	    };
	    RowNodeBlockLoader.prototype.destroy = function () {
	        this.active = false;
	    };
	    RowNodeBlockLoader.prototype.loadComplete = function () {
	        this.activeBlockLoadsCount--;
	    };
	    RowNodeBlockLoader.prototype.checkBlockToLoad = function () {
	        if (this.checkBlockToLoadDebounce) {
	            this.checkBlockToLoadDebounce();
	        }
	        else {
	            this.performCheckBlocksToLoad();
	        }
	    };
	    RowNodeBlockLoader.prototype.performCheckBlocksToLoad = function () {
	        if (!this.active) {
	            return;
	        }
	        this.printCacheStatus();
	        if (this.activeBlockLoadsCount >= this.maxConcurrentRequests) {
	            this.logger.log("checkBlockToLoad: max loads exceeded");
	            return;
	        }
	        var blockToLoad = null;
	        this.blocks.forEach(function (block) {
	            if (block.getState() === rowNodeBlock_1.RowNodeBlock.STATE_DIRTY) {
	                blockToLoad = block;
	            }
	        });
	        if (blockToLoad) {
	            blockToLoad.load();
	            this.activeBlockLoadsCount++;
	            this.logger.log("checkBlockToLoad: loading page " + blockToLoad.getBlockNumber());
	            this.printCacheStatus();
	        }
	        else {
	            this.logger.log("checkBlockToLoad: no pages to load");
	        }
	    };
	    RowNodeBlockLoader.prototype.getBlockState = function () {
	        var result = {};
	        this.blocks.forEach(function (block) {
	            var nodeIdPrefix = block.getNodeIdPrefix();
	            var stateItem = {
	                blockNumber: block.getBlockNumber(),
	                startRow: block.getStartRow(),
	                endRow: block.getEndRow(),
	                pageStatus: block.getState()
	            };
	            if (utils_1._.exists(nodeIdPrefix)) {
	                result[nodeIdPrefix + block.getBlockNumber()] = stateItem;
	            }
	            else {
	                result[block.getBlockNumber()] = stateItem;
	            }
	        });
	        return result;
	    };
	    RowNodeBlockLoader.prototype.printCacheStatus = function () {
	        if (this.logger.isLogging()) {
	            this.logger.log("printCacheStatus: activePageLoadsCount = " + this.activeBlockLoadsCount + ","
	                + (" blocks = " + JSON.stringify(this.getBlockState())));
	        }
	    };
	    RowNodeBlockLoader.prototype.isLoading = function () {
	        return this.activeBlockLoadsCount > 0;
	    };
	    __decorate([
	        __param(0, context_1.Qualifier('loggerFactory')),
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", [logger_1.LoggerFactory]),
	        __metadata("design:returntype", void 0)
	    ], RowNodeBlockLoader.prototype, "setBeans", null);
	    return RowNodeBlockLoader;
	}());
	exports.RowNodeBlockLoader = RowNodeBlockLoader;


/***/ }),
/* 2477 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var constants_1 = __webpack_require__(2328);
	var gridOptionsWrapper_1 = __webpack_require__(2324);
	var columnApi_1 = __webpack_require__(2346);
	var columnController_1 = __webpack_require__(2341);
	var filterManager_1 = __webpack_require__(2378);
	var rowNode_1 = __webpack_require__(2356);
	var eventService_1 = __webpack_require__(2331);
	var events_1 = __webpack_require__(2335);
	var context_1 = __webpack_require__(2333);
	var selectionController_1 = __webpack_require__(2357);
	var clientSideNodeManager_1 = __webpack_require__(2478);
	var changedPath_1 = __webpack_require__(2358);
	var valueService_1 = __webpack_require__(2359);
	var valueCache_1 = __webpack_require__(2360);
	var gridApi_1 = __webpack_require__(2338);
	var utils_1 = __webpack_require__(2325);
	var RecursionType;
	(function (RecursionType) {
	    RecursionType[RecursionType["Normal"] = 0] = "Normal";
	    RecursionType[RecursionType["AfterFilter"] = 1] = "AfterFilter";
	    RecursionType[RecursionType["AfterFilterAndSort"] = 2] = "AfterFilterAndSort";
	    RecursionType[RecursionType["PivotNodes"] = 3] = "PivotNodes";
	})(RecursionType || (RecursionType = {}));
	var ClientSideRowModel = /** @class */ (function () {
	    function ClientSideRowModel() {
	    }
	    ClientSideRowModel.prototype.init = function () {
	        var refreshEverythingFunc = this.refreshModel.bind(this, { step: constants_1.Constants.STEP_EVERYTHING });
	        var refreshEverythingAfterColsChangedFunc = this.refreshModel.bind(this, { step: constants_1.Constants.STEP_EVERYTHING, afterColumnsChanged: true });
	        this.eventService.addModalPriorityEventListener(events_1.Events.EVENT_COLUMN_EVERYTHING_CHANGED, refreshEverythingAfterColsChangedFunc);
	        this.eventService.addModalPriorityEventListener(events_1.Events.EVENT_COLUMN_ROW_GROUP_CHANGED, refreshEverythingFunc);
	        this.eventService.addModalPriorityEventListener(events_1.Events.EVENT_COLUMN_VALUE_CHANGED, this.onValueChanged.bind(this));
	        this.eventService.addModalPriorityEventListener(events_1.Events.EVENT_COLUMN_PIVOT_CHANGED, this.refreshModel.bind(this, { step: constants_1.Constants.STEP_PIVOT }));
	        this.eventService.addModalPriorityEventListener(events_1.Events.EVENT_ROW_GROUP_OPENED, this.onRowGroupOpened.bind(this));
	        this.eventService.addModalPriorityEventListener(events_1.Events.EVENT_FILTER_CHANGED, this.onFilterChanged.bind(this));
	        this.eventService.addModalPriorityEventListener(events_1.Events.EVENT_SORT_CHANGED, this.onSortChanged.bind(this));
	        this.eventService.addModalPriorityEventListener(events_1.Events.EVENT_COLUMN_PIVOT_MODE_CHANGED, refreshEverythingFunc);
	        var refreshMapFunc = this.refreshModel.bind(this, {
	            step: constants_1.Constants.STEP_MAP,
	            keepRenderedRows: true,
	            animate: true
	        });
	        this.gridOptionsWrapper.addEventListener(gridOptionsWrapper_1.GridOptionsWrapper.PROP_GROUP_REMOVE_SINGLE_CHILDREN, refreshMapFunc);
	        this.gridOptionsWrapper.addEventListener(gridOptionsWrapper_1.GridOptionsWrapper.PROP_GROUP_REMOVE_LOWEST_SINGLE_CHILDREN, refreshMapFunc);
	        this.rootNode = new rowNode_1.RowNode();
	        this.nodeManager = new clientSideNodeManager_1.ClientSideNodeManager(this.rootNode, this.gridOptionsWrapper, this.context, this.eventService, this.columnController, this.gridApi, this.columnApi, this.selectionController);
	        this.context.wireBean(this.rootNode);
	    };
	    ClientSideRowModel.prototype.ensureRowHeightsValid = function (startPixel, endPixel, startLimitIndex, endLimitIndex) {
	        var atLeastOneChange;
	        var res = false;
	        // we do this multiple times as changing the row heights can also change the first and last rows,
	        // so the first pass can make lots of rows smaller, which means the second pass we end up changing
	        // more rows.
	        do {
	            atLeastOneChange = false;
	            var rowAtStartPixel = this.getRowIndexAtPixel(startPixel);
	            var rowAtEndPixel = this.getRowIndexAtPixel(endPixel);
	            // keep check to current page if doing pagination
	            var firstRow = Math.max(rowAtStartPixel, startLimitIndex);
	            var lastRow = Math.min(rowAtEndPixel, endLimitIndex);
	            for (var rowIndex = firstRow; rowIndex <= lastRow; rowIndex++) {
	                var rowNode = this.getRow(rowIndex);
	                if (rowNode.rowHeightEstimated) {
	                    var rowHeight = this.gridOptionsWrapper.getRowHeightForNode(rowNode);
	                    rowNode.setRowHeight(rowHeight.height);
	                    atLeastOneChange = true;
	                    res = true;
	                }
	            }
	            if (atLeastOneChange) {
	                this.setRowTops();
	            }
	        } while (atLeastOneChange);
	        return res;
	    };
	    ClientSideRowModel.prototype.setRowTops = function () {
	        var nextRowTop = 0;
	        for (var i = 0; i < this.rowsToDisplay.length; i++) {
	            // we don't estimate if doing fullHeight or autoHeight, as all rows get rendered all the time
	            // with these two layouts.
	            var allowEstimate = this.gridOptionsWrapper.getDomLayout() === constants_1.Constants.DOM_LAYOUT_NORMAL;
	            var rowNode = this.rowsToDisplay[i];
	            if (utils_1._.missing(rowNode.rowHeight)) {
	                var rowHeight = this.gridOptionsWrapper.getRowHeightForNode(rowNode, allowEstimate);
	                rowNode.setRowHeight(rowHeight.height, rowHeight.estimated);
	            }
	            rowNode.setRowTop(nextRowTop);
	            rowNode.setRowIndex(i);
	            nextRowTop += rowNode.rowHeight;
	        }
	    };
	    ClientSideRowModel.prototype.resetRowTops = function (rowNode, changedPath) {
	        rowNode.clearRowTop();
	        if (rowNode.hasChildren()) {
	            if (rowNode.childrenAfterGroup) {
	                // if a changedPath is active, it means we are here because of a transaction update or
	                // a change detection. neither of these impacts the open/closed state of groups. so if
	                // a group is not open this time, it was not open last time. so we know all closed groups
	                // already have their top positions cleared. so there is no need to traverse all the way
	                // when changedPath is active and the rowNode is not expanded.
	                var skipChildren = changedPath.isActive() && !rowNode.expanded;
	                if (!skipChildren) {
	                    for (var i = 0; i < rowNode.childrenAfterGroup.length; i++) {
	                        this.resetRowTops(rowNode.childrenAfterGroup[i], changedPath);
	                    }
	                }
	            }
	            if (rowNode.sibling) {
	                rowNode.sibling.clearRowTop();
	            }
	        }
	        if (rowNode.detailNode) {
	            rowNode.detailNode.clearRowTop();
	        }
	    };
	    // returns false if row was moved, otherwise true
	    ClientSideRowModel.prototype.ensureRowAtPixel = function (rowNode, pixel) {
	        var indexAtPixelNow = this.getRowIndexAtPixel(pixel);
	        var rowNodeAtPixelNow = this.getRow(indexAtPixelNow);
	        if (rowNodeAtPixelNow === rowNode) {
	            return false;
	        }
	        utils_1._.removeFromArray(this.rootNode.allLeafChildren, rowNode);
	        utils_1._.insertIntoArray(this.rootNode.allLeafChildren, rowNode, indexAtPixelNow);
	        this.refreshModel({
	            step: constants_1.Constants.STEP_EVERYTHING,
	            keepRenderedRows: true,
	            animate: true,
	            keepEditingRows: true
	        });
	        return true;
	    };
	    ClientSideRowModel.prototype.isLastRowFound = function () {
	        return true;
	    };
	    ClientSideRowModel.prototype.getRowCount = function () {
	        if (this.rowsToDisplay) {
	            return this.rowsToDisplay.length;
	        }
	        else {
	            return 0;
	        }
	    };
	    ClientSideRowModel.prototype.getTopLevelRowCount = function () {
	        var showingRootNode = this.rowsToDisplay && this.rowsToDisplay[0] === this.rootNode;
	        if (showingRootNode) {
	            return 1;
	        }
	        else {
	            return this.rootNode.childrenAfterFilter ? this.rootNode.childrenAfterFilter.length : 0;
	        }
	    };
	    ClientSideRowModel.prototype.getTopLevelRowDisplayedIndex = function (topLevelIndex) {
	        var showingRootNode = this.rowsToDisplay && this.rowsToDisplay[0] === this.rootNode;
	        if (showingRootNode) {
	            return topLevelIndex;
	        }
	        else {
	            var rowNode = this.rootNode.childrenAfterSort[topLevelIndex];
	            if (this.gridOptionsWrapper.isGroupHideOpenParents()) {
	                // if hideOpenParents, and this row open, then this row is now displayed at this index, first child is
	                while (rowNode.expanded && rowNode.childrenAfterSort && rowNode.childrenAfterSort.length > 0) {
	                    rowNode = rowNode.childrenAfterSort[0];
	                }
	            }
	            return rowNode.rowIndex;
	        }
	    };
	    ClientSideRowModel.prototype.getRowBounds = function (index) {
	        if (utils_1._.missing(this.rowsToDisplay)) {
	            return null;
	        }
	        var rowNode = this.rowsToDisplay[index];
	        if (rowNode) {
	            return {
	                rowTop: rowNode.rowTop,
	                rowHeight: rowNode.rowHeight
	            };
	        }
	        else {
	            return null;
	        }
	    };
	    ClientSideRowModel.prototype.onRowGroupOpened = function () {
	        var animate = this.gridOptionsWrapper.isAnimateRows();
	        this.refreshModel({ step: constants_1.Constants.STEP_MAP, keepRenderedRows: true, animate: animate });
	    };
	    ClientSideRowModel.prototype.onFilterChanged = function () {
	        var animate = this.gridOptionsWrapper.isAnimateRows();
	        this.refreshModel({ step: constants_1.Constants.STEP_FILTER, keepRenderedRows: true, animate: animate });
	    };
	    ClientSideRowModel.prototype.onSortChanged = function () {
	        var animate = this.gridOptionsWrapper.isAnimateRows();
	        this.refreshModel({ step: constants_1.Constants.STEP_SORT, keepRenderedRows: true, animate: animate, keepEditingRows: true });
	    };
	    ClientSideRowModel.prototype.getType = function () {
	        return constants_1.Constants.ROW_MODEL_TYPE_CLIENT_SIDE;
	    };
	    ClientSideRowModel.prototype.onValueChanged = function () {
	        if (this.columnController.isPivotActive()) {
	            this.refreshModel({ step: constants_1.Constants.STEP_PIVOT });
	        }
	        else {
	            this.refreshModel({ step: constants_1.Constants.STEP_AGGREGATE });
	        }
	    };
	    ClientSideRowModel.prototype.createChangePath = function (rowNodeTransactions) {
	        // for updates, if the row is updated at all, then we re-calc all the values
	        // in that row. we could compare each value to each old value, however if we
	        // did this, we would be calling the valueService twice, once on the old value
	        // and once on the new value. so it's less valueGetter calls if we just assume
	        // each column is different. that way the changedPath is used so that only
	        // the impacted parent rows are recalculated, parents who's children have
	        // not changed are not impacted.
	        var noTransactions = utils_1._.missingOrEmpty(rowNodeTransactions);
	        var changedPath = new changedPath_1.ChangedPath(false, this.rootNode);
	        if (noTransactions || this.gridOptionsWrapper.isTreeData()) {
	            changedPath.setInactive();
	        }
	        return changedPath;
	    };
	    ClientSideRowModel.prototype.refreshModel = function (params) {
	        // this goes through the pipeline of stages. what's in my head is similar
	        // to the diagram on this page:
	        // http://commons.apache.org/sandbox/commons-pipeline/pipeline_basics.html
	        // however we want to keep the results of each stage, hence we manually call
	        // each step rather than have them chain each other.
	        var _this = this;
	        // fallthrough in below switch is on purpose,
	        // eg if STEP_FILTER, then all steps below this
	        // step get done
	        // let start: number;
	        // console.log('======= start =======');
	        var changedPath = this.createChangePath(params.rowNodeTransactions);
	        switch (params.step) {
	            case constants_1.Constants.STEP_EVERYTHING:
	                // start = new Date().getTime();
	                this.doRowGrouping(params.groupState, params.rowNodeTransactions, params.rowNodeOrder, changedPath, params.afterColumnsChanged);
	            // console.log('rowGrouping = ' + (new Date().getTime() - start));
	            case constants_1.Constants.STEP_FILTER:
	                // start = new Date().getTime();
	                this.doFilter(changedPath);
	            // console.log('filter = ' + (new Date().getTime() - start));
	            case constants_1.Constants.STEP_PIVOT:
	                this.doPivot(changedPath);
	            case constants_1.Constants.STEP_AGGREGATE: // depends on agg fields
	                // start = new Date().getTime();
	                this.doAggregate(changedPath);
	            // console.log('aggregation = ' + (new Date().getTime() - start));
	            case constants_1.Constants.STEP_SORT:
	                // start = new Date().getTime();
	                this.doSort(params.rowNodeTransactions, changedPath);
	            // console.log('sort = ' + (new Date().getTime() - start));
	            case constants_1.Constants.STEP_MAP:
	                // start = new Date().getTime();
	                this.doRowsToDisplay();
	            // console.log('rowsToDisplay = ' + (new Date().getTime() - start));
	        }
	        // set all row tops to null, then set row tops on all visible rows. if we don't
	        // do this, then the algorithm below only sets row tops, old row tops from old rows
	        // will still lie around
	        this.resetRowTops(this.rootNode, changedPath);
	        this.setRowTops();
	        var event = {
	            type: events_1.Events.EVENT_MODEL_UPDATED,
	            api: this.gridApi,
	            columnApi: this.columnApi,
	            animate: params.animate,
	            keepRenderedRows: params.keepRenderedRows,
	            newData: params.newData,
	            newPage: false
	        };
	        this.eventService.dispatchEvent(event);
	        if (this.$scope) {
	            window.setTimeout(function () {
	                _this.$scope.$apply();
	            }, 0);
	        }
	    };
	    ClientSideRowModel.prototype.isEmpty = function () {
	        var rowsMissing;
	        var doingLegacyTreeData = utils_1._.exists(this.gridOptionsWrapper.getNodeChildDetailsFunc());
	        if (doingLegacyTreeData) {
	            rowsMissing = utils_1._.missing(this.rootNode.childrenAfterGroup) || this.rootNode.childrenAfterGroup.length === 0;
	        }
	        else {
	            rowsMissing = utils_1._.missing(this.rootNode.allLeafChildren) || this.rootNode.allLeafChildren.length === 0;
	        }
	        var empty = utils_1._.missing(this.rootNode) || rowsMissing || !this.columnController.isReady();
	        return empty;
	    };
	    ClientSideRowModel.prototype.isRowsToRender = function () {
	        return utils_1._.exists(this.rowsToDisplay) && this.rowsToDisplay.length > 0;
	    };
	    ClientSideRowModel.prototype.getNodesInRangeForSelection = function (firstInRange, lastInRange) {
	        // if lastSelectedNode is missing, we start at the first row
	        var firstRowHit = !lastInRange;
	        var lastRowHit = false;
	        var lastRow;
	        var result = [];
	        var groupsSelectChildren = this.gridOptionsWrapper.isGroupSelectsChildren();
	        this.forEachNodeAfterFilterAndSort(function (rowNode) {
	            var lookingForLastRow = firstRowHit && !lastRowHit;
	            // check if we need to flip the select switch
	            if (!firstRowHit) {
	                if (rowNode === lastInRange || rowNode === firstInRange) {
	                    firstRowHit = true;
	                }
	            }
	            var skipThisGroupNode = rowNode.group && groupsSelectChildren;
	            if (!skipThisGroupNode) {
	                var inRange = firstRowHit && !lastRowHit;
	                var childOfLastRow = rowNode.isParentOfNode(lastRow);
	                if (inRange || childOfLastRow) {
	                    result.push(rowNode);
	                }
	            }
	            if (lookingForLastRow) {
	                if (rowNode === lastInRange || rowNode === firstInRange) {
	                    lastRowHit = true;
	                    if (rowNode === lastInRange) {
	                        lastRow = lastInRange;
	                    }
	                    else {
	                        lastRow = firstInRange;
	                    }
	                }
	            }
	        });
	        return result;
	    };
	    ClientSideRowModel.prototype.setDatasource = function (datasource) {
	        console.error('ag-Grid: should never call setDatasource on clientSideRowController');
	    };
	    ClientSideRowModel.prototype.getTopLevelNodes = function () {
	        return this.rootNode ? this.rootNode.childrenAfterGroup : null;
	    };
	    ClientSideRowModel.prototype.getRootNode = function () {
	        return this.rootNode;
	    };
	    ClientSideRowModel.prototype.getRow = function (index) {
	        return this.rowsToDisplay[index];
	    };
	    ClientSideRowModel.prototype.isRowPresent = function (rowNode) {
	        return this.rowsToDisplay.indexOf(rowNode) >= 0;
	    };
	    ClientSideRowModel.prototype.getRowIndexAtPixel = function (pixelToMatch) {
	        if (this.isEmpty()) {
	            return -1;
	        }
	        // do binary search of tree
	        // http://oli.me.uk/2013/06/08/searching-javascript-arrays-with-a-binary-search/
	        var bottomPointer = 0;
	        var topPointer = this.rowsToDisplay.length - 1;
	        // quick check, if the pixel is out of bounds, then return last row
	        if (pixelToMatch <= 0) {
	            // if pixel is less than or equal zero, it's always the first row
	            return 0;
	        }
	        var lastNode = utils_1._.last(this.rowsToDisplay);
	        if (lastNode.rowTop <= pixelToMatch) {
	            return this.rowsToDisplay.length - 1;
	        }
	        while (true) {
	            var midPointer = Math.floor((bottomPointer + topPointer) / 2);
	            var currentRowNode = this.rowsToDisplay[midPointer];
	            if (this.isRowInPixel(currentRowNode, pixelToMatch)) {
	                return midPointer;
	            }
	            else if (currentRowNode.rowTop < pixelToMatch) {
	                bottomPointer = midPointer + 1;
	            }
	            else if (currentRowNode.rowTop > pixelToMatch) {
	                topPointer = midPointer - 1;
	            }
	        }
	    };
	    ClientSideRowModel.prototype.isRowInPixel = function (rowNode, pixelToMatch) {
	        var topPixel = rowNode.rowTop;
	        var bottomPixel = rowNode.rowTop + rowNode.rowHeight;
	        var pixelInRow = topPixel <= pixelToMatch && bottomPixel > pixelToMatch;
	        return pixelInRow;
	    };
	    ClientSideRowModel.prototype.getCurrentPageHeight = function () {
	        if (this.rowsToDisplay && this.rowsToDisplay.length > 0) {
	            var lastRow = utils_1._.last(this.rowsToDisplay);
	            var lastPixel = lastRow.rowTop + lastRow.rowHeight;
	            return lastPixel;
	        }
	        else {
	            return 0;
	        }
	    };
	    ClientSideRowModel.prototype.forEachLeafNode = function (callback) {
	        if (this.rootNode.allLeafChildren) {
	            this.rootNode.allLeafChildren.forEach(function (rowNode, index) { return callback(rowNode, index); });
	        }
	    };
	    ClientSideRowModel.prototype.forEachNode = function (callback) {
	        this.recursivelyWalkNodesAndCallback(this.rootNode.childrenAfterGroup, callback, RecursionType.Normal, 0);
	    };
	    ClientSideRowModel.prototype.forEachNodeAfterFilter = function (callback) {
	        this.recursivelyWalkNodesAndCallback(this.rootNode.childrenAfterFilter, callback, RecursionType.AfterFilter, 0);
	    };
	    ClientSideRowModel.prototype.forEachNodeAfterFilterAndSort = function (callback) {
	        this.recursivelyWalkNodesAndCallback(this.rootNode.childrenAfterSort, callback, RecursionType.AfterFilterAndSort, 0);
	    };
	    ClientSideRowModel.prototype.forEachPivotNode = function (callback) {
	        this.recursivelyWalkNodesAndCallback([this.rootNode], callback, RecursionType.PivotNodes, 0);
	    };
	    // iterates through each item in memory, and calls the callback function
	    // nodes - the rowNodes to traverse
	    // callback - the user provided callback
	    // recursion type - need this to know what child nodes to recurse, eg if looking at all nodes, or filtered notes etc
	    // index - works similar to the index in forEach in javascript's array function
	    ClientSideRowModel.prototype.recursivelyWalkNodesAndCallback = function (nodes, callback, recursionType, index) {
	        if (nodes) {
	            for (var i = 0; i < nodes.length; i++) {
	                var node = nodes[i];
	                callback(node, index++);
	                // go to the next level if it is a group
	                if (node.hasChildren()) {
	                    // depending on the recursion type, we pick a difference set of children
	                    var nodeChildren = null;
	                    switch (recursionType) {
	                        case RecursionType.Normal:
	                            nodeChildren = node.childrenAfterGroup;
	                            break;
	                        case RecursionType.AfterFilter:
	                            nodeChildren = node.childrenAfterFilter;
	                            break;
	                        case RecursionType.AfterFilterAndSort:
	                            nodeChildren = node.childrenAfterSort;
	                            break;
	                        case RecursionType.PivotNodes:
	                            // for pivot, we don't go below leafGroup levels
	                            nodeChildren = !node.leafGroup ? node.childrenAfterSort : null;
	                            break;
	                    }
	                    if (nodeChildren) {
	                        index = this.recursivelyWalkNodesAndCallback(nodeChildren, callback, recursionType, index);
	                    }
	                }
	            }
	        }
	        return index;
	    };
	    // it's possible to recompute the aggregate without doing the other parts
	    // + gridApi.recomputeAggregates()
	    ClientSideRowModel.prototype.doAggregate = function (changedPath) {
	        if (this.aggregationStage) {
	            this.aggregationStage.execute({ rowNode: this.rootNode, changedPath: changedPath });
	        }
	    };
	    // + gridApi.expandAll()
	    // + gridApi.collapseAll()
	    ClientSideRowModel.prototype.expandOrCollapseAll = function (expand) {
	        var usingTreeData = this.gridOptionsWrapper.isTreeData();
	        if (this.rootNode) {
	            recursiveExpandOrCollapse(this.rootNode.childrenAfterGroup);
	        }
	        function recursiveExpandOrCollapse(rowNodes) {
	            if (!rowNodes) {
	                return;
	            }
	            rowNodes.forEach(function (rowNode) {
	                var shouldExpandOrCollapse = usingTreeData ? utils_1._.exists(rowNode.childrenAfterGroup) : rowNode.group;
	                if (shouldExpandOrCollapse) {
	                    rowNode.expanded = expand;
	                    recursiveExpandOrCollapse(rowNode.childrenAfterGroup);
	                }
	            });
	        }
	        this.refreshModel({ step: constants_1.Constants.STEP_MAP });
	        var eventSource = expand ? 'expandAll' : 'collapseAll';
	        var event = {
	            api: this.gridApi,
	            columnApi: this.columnApi,
	            type: events_1.Events.EVENT_EXPAND_COLLAPSE_ALL,
	            source: eventSource
	        };
	        this.eventService.dispatchEvent(event);
	    };
	    ClientSideRowModel.prototype.doSort = function (rowNodeTransactions, changedPath) {
	        this.sortStage.execute({
	            rowNode: this.rootNode,
	            rowNodeTransactions: rowNodeTransactions,
	            changedPath: changedPath
	        });
	    };
	    ClientSideRowModel.prototype.doRowGrouping = function (groupState, rowNodeTransactions, rowNodeOrder, changedPath, afterColumnsChanged) {
	        var _this = this;
	        // grouping is enterprise only, so if service missing, skip the step
	        var doingLegacyTreeData = utils_1._.exists(this.gridOptionsWrapper.getNodeChildDetailsFunc());
	        if (doingLegacyTreeData) {
	            return;
	        }
	        if (this.groupStage) {
	            if (rowNodeTransactions && utils_1._.exists(rowNodeTransactions)) {
	                rowNodeTransactions.forEach(function (tran) {
	                    _this.groupStage.execute({
	                        rowNode: _this.rootNode,
	                        rowNodeTransaction: tran,
	                        rowNodeOrder: rowNodeOrder,
	                        changedPath: changedPath
	                    });
	                });
	            }
	            else {
	                // groups are about to get disposed, so need to deselect any that are selected
	                this.selectionController.removeGroupsFromSelection();
	                this.groupStage.execute({
	                    rowNode: this.rootNode,
	                    changedPath: changedPath,
	                    afterColumnsChanged: afterColumnsChanged
	                });
	                // set open/closed state on groups
	                this.restoreGroupState(groupState);
	            }
	            if (this.gridOptionsWrapper.isGroupSelectsChildren()) {
	                this.selectionController.updateGroupsFromChildrenSelections(changedPath);
	            }
	        }
	        else {
	            this.rootNode.childrenAfterGroup = this.rootNode.allLeafChildren;
	        }
	    };
	    ClientSideRowModel.prototype.restoreGroupState = function (groupState) {
	        if (!groupState) {
	            return;
	        }
	        utils_1._.traverseNodesWithKey(this.rootNode.childrenAfterGroup, function (node, key) {
	            // if the group was open last time, then open it this time. however
	            // if was not open last time, then don't touch the group, so the 'groupDefaultExpanded'
	            // setting will take effect.
	            if (typeof groupState[key] === 'boolean') {
	                node.expanded = groupState[key];
	            }
	        });
	    };
	    ClientSideRowModel.prototype.doFilter = function (changedPath) {
	        this.filterStage.execute({ rowNode: this.rootNode, changedPath: changedPath });
	    };
	    ClientSideRowModel.prototype.doPivot = function (changedPath) {
	        if (this.pivotStage) {
	            this.pivotStage.execute({ rowNode: this.rootNode, changedPath: changedPath });
	        }
	    };
	    ClientSideRowModel.prototype.getGroupState = function () {
	        if (!this.rootNode.childrenAfterGroup || !this.gridOptionsWrapper.isRememberGroupStateWhenNewData()) {
	            return null;
	        }
	        var result = {};
	        utils_1._.traverseNodesWithKey(this.rootNode.childrenAfterGroup, function (node, key) { return result[key] = node.expanded; });
	        return result;
	    };
	    ClientSideRowModel.prototype.getCopyOfNodesMap = function () {
	        return this.nodeManager.getCopyOfNodesMap();
	    };
	    ClientSideRowModel.prototype.getRowNode = function (id) {
	        return this.nodeManager.getRowNode(id);
	    };
	    // rows: the rows to put into the model
	    ClientSideRowModel.prototype.setRowData = function (rowData) {
	        // no need to invalidate cache, as the cache is stored on the rowNode,
	        // so new rowNodes means the cache is wiped anyway.
	        // remember group state, so we can expand groups that should be expanded
	        var groupState = this.getGroupState();
	        this.nodeManager.setRowData(rowData);
	        // this event kicks off:
	        // - clears selection
	        // - updates filters
	        // - shows 'no rows' overlay if needed
	        var rowDataChangedEvent = {
	            type: events_1.Events.EVENT_ROW_DATA_CHANGED,
	            api: this.gridApi,
	            columnApi: this.columnApi
	        };
	        this.eventService.dispatchEvent(rowDataChangedEvent);
	        this.refreshModel({
	            step: constants_1.Constants.STEP_EVERYTHING,
	            groupState: groupState,
	            newData: true
	        });
	    };
	    ClientSideRowModel.prototype.batchUpdateRowData = function (rowDataTransaction, callback) {
	        var _this = this;
	        if (!this.rowDataTransactionBatch) {
	            this.rowDataTransactionBatch = [];
	            var waitMillis = this.gridOptionsWrapper.getBatchUpdateWaitMillis();
	            window.setTimeout(function () {
	                _this.executeBatchUpdateRowData();
	                _this.rowDataTransactionBatch = null;
	            }, waitMillis);
	        }
	        this.rowDataTransactionBatch.push({ rowDataTransaction: rowDataTransaction, callback: callback });
	    };
	    ClientSideRowModel.prototype.executeBatchUpdateRowData = function () {
	        var _this = this;
	        this.valueCache.onDataChanged();
	        var callbackFuncsBound = [];
	        var rowNodeTrans = [];
	        if (this.rowDataTransactionBatch) {
	            this.rowDataTransactionBatch.forEach(function (tranItem) {
	                var rowNodeTran = _this.nodeManager.updateRowData(tranItem.rowDataTransaction, null);
	                rowNodeTrans.push(rowNodeTran);
	                if (tranItem.callback) {
	                    callbackFuncsBound.push(tranItem.callback.bind(null, rowNodeTran));
	                }
	            });
	        }
	        this.commonUpdateRowData(rowNodeTrans);
	        // do callbacks in next VM turn so it's async
	        if (callbackFuncsBound.length > 0) {
	            window.setTimeout(function () {
	                callbackFuncsBound.forEach(function (func) { return func(); });
	            }, 0);
	        }
	    };
	    ClientSideRowModel.prototype.updateRowData = function (rowDataTran, rowNodeOrder) {
	        this.valueCache.onDataChanged();
	        var rowNodeTran = this.nodeManager.updateRowData(rowDataTran, rowNodeOrder);
	        this.commonUpdateRowData([rowNodeTran], rowNodeOrder);
	        return rowNodeTran;
	    };
	    // common to updateRowData and batchUpdateRowData
	    ClientSideRowModel.prototype.commonUpdateRowData = function (rowNodeTrans, rowNodeOrder) {
	        this.refreshModel({
	            step: constants_1.Constants.STEP_EVERYTHING,
	            rowNodeTransactions: rowNodeTrans,
	            rowNodeOrder: rowNodeOrder,
	            keepRenderedRows: true,
	            animate: true,
	            keepEditingRows: true
	        });
	        var event = {
	            type: events_1.Events.EVENT_ROW_DATA_UPDATED,
	            api: this.gridApi,
	            columnApi: this.columnApi
	        };
	        this.eventService.dispatchEvent(event);
	    };
	    ClientSideRowModel.prototype.doRowsToDisplay = function () {
	        this.rowsToDisplay = this.flattenStage.execute({ rowNode: this.rootNode });
	    };
	    ClientSideRowModel.prototype.onRowHeightChanged = function () {
	        this.refreshModel({ step: constants_1.Constants.STEP_MAP, keepRenderedRows: true, keepEditingRows: true });
	    };
	    ClientSideRowModel.prototype.resetRowHeights = function () {
	        this.forEachNode(function (rowNode) { return rowNode.setRowHeight(null); });
	        this.onRowHeightChanged();
	    };
	    __decorate([
	        context_1.Autowired('gridOptionsWrapper'),
	        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
	    ], ClientSideRowModel.prototype, "gridOptionsWrapper", void 0);
	    __decorate([
	        context_1.Autowired('columnController'),
	        __metadata("design:type", columnController_1.ColumnController)
	    ], ClientSideRowModel.prototype, "columnController", void 0);
	    __decorate([
	        context_1.Autowired('filterManager'),
	        __metadata("design:type", filterManager_1.FilterManager)
	    ], ClientSideRowModel.prototype, "filterManager", void 0);
	    __decorate([
	        context_1.Autowired('$scope'),
	        __metadata("design:type", Object)
	    ], ClientSideRowModel.prototype, "$scope", void 0);
	    __decorate([
	        context_1.Autowired('selectionController'),
	        __metadata("design:type", selectionController_1.SelectionController)
	    ], ClientSideRowModel.prototype, "selectionController", void 0);
	    __decorate([
	        context_1.Autowired('eventService'),
	        __metadata("design:type", eventService_1.EventService)
	    ], ClientSideRowModel.prototype, "eventService", void 0);
	    __decorate([
	        context_1.Autowired('context'),
	        __metadata("design:type", context_1.Context)
	    ], ClientSideRowModel.prototype, "context", void 0);
	    __decorate([
	        context_1.Autowired('valueService'),
	        __metadata("design:type", valueService_1.ValueService)
	    ], ClientSideRowModel.prototype, "valueService", void 0);
	    __decorate([
	        context_1.Autowired('valueCache'),
	        __metadata("design:type", valueCache_1.ValueCache)
	    ], ClientSideRowModel.prototype, "valueCache", void 0);
	    __decorate([
	        context_1.Autowired('columnApi'),
	        __metadata("design:type", columnApi_1.ColumnApi)
	    ], ClientSideRowModel.prototype, "columnApi", void 0);
	    __decorate([
	        context_1.Autowired('gridApi'),
	        __metadata("design:type", gridApi_1.GridApi)
	    ], ClientSideRowModel.prototype, "gridApi", void 0);
	    __decorate([
	        context_1.Autowired('filterStage'),
	        __metadata("design:type", Object)
	    ], ClientSideRowModel.prototype, "filterStage", void 0);
	    __decorate([
	        context_1.Autowired('sortStage'),
	        __metadata("design:type", Object)
	    ], ClientSideRowModel.prototype, "sortStage", void 0);
	    __decorate([
	        context_1.Autowired('flattenStage'),
	        __metadata("design:type", Object)
	    ], ClientSideRowModel.prototype, "flattenStage", void 0);
	    __decorate([
	        context_1.Optional('groupStage'),
	        __metadata("design:type", Object)
	    ], ClientSideRowModel.prototype, "groupStage", void 0);
	    __decorate([
	        context_1.Optional('aggregationStage'),
	        __metadata("design:type", Object)
	    ], ClientSideRowModel.prototype, "aggregationStage", void 0);
	    __decorate([
	        context_1.Optional('pivotStage'),
	        __metadata("design:type", Object)
	    ], ClientSideRowModel.prototype, "pivotStage", void 0);
	    __decorate([
	        context_1.PostConstruct,
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", []),
	        __metadata("design:returntype", void 0)
	    ], ClientSideRowModel.prototype, "init", null);
	    ClientSideRowModel = __decorate([
	        context_1.Bean('rowModel')
	    ], ClientSideRowModel);
	    return ClientSideRowModel;
	}());
	exports.ClientSideRowModel = ClientSideRowModel;


/***/ }),
/* 2478 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var rowNode_1 = __webpack_require__(2356);
	var events_1 = __webpack_require__(2335);
	var utils_1 = __webpack_require__(2325);
	var ClientSideNodeManager = /** @class */ (function () {
	    function ClientSideNodeManager(rootNode, gridOptionsWrapper, context, eventService, columnController, gridApi, columnApi, selectionController) {
	        this.nextId = 0;
	        // when user is provide the id's, we also keep a map of ids to row nodes for convenience
	        this.allNodesMap = {};
	        this.rootNode = rootNode;
	        this.gridOptionsWrapper = gridOptionsWrapper;
	        this.context = context;
	        this.eventService = eventService;
	        this.columnController = columnController;
	        this.gridApi = gridApi;
	        this.columnApi = columnApi;
	        this.selectionController = selectionController;
	        this.rootNode.group = true;
	        this.rootNode.level = -1;
	        this.rootNode.id = ClientSideNodeManager.ROOT_NODE_ID;
	        this.rootNode.allLeafChildren = [];
	        this.rootNode.childrenAfterGroup = [];
	        this.rootNode.childrenAfterSort = [];
	        this.rootNode.childrenAfterFilter = [];
	        // if we make this class a bean, then can annotate postConstruct
	        this.postConstruct();
	    }
	    // @PostConstruct - this is not a bean, so postConstruct called by constructor
	    ClientSideNodeManager.prototype.postConstruct = function () {
	        // func below doesn't have 'this' pointer, so need to pull out these bits
	        this.getNodeChildDetails = this.gridOptionsWrapper.getNodeChildDetailsFunc();
	        this.suppressParentsInRowNodes = this.gridOptionsWrapper.isSuppressParentsInRowNodes();
	        this.doesDataFlower = this.gridOptionsWrapper.getDoesDataFlowerFunc();
	        this.isRowMasterFunc = this.gridOptionsWrapper.getIsRowMasterFunc();
	        this.doingLegacyTreeData = utils_1._.exists(this.getNodeChildDetails);
	        this.doingMasterDetail = this.gridOptionsWrapper.isMasterDetail();
	        if (this.getNodeChildDetails) {
	            console.warn("ag-Grid: the callback nodeChildDetailsFunc() is now deprecated. The new way of doing\n                                    tree data in ag-Grid was introduced in v14 (released November 2017). In the next\n                                    major release of ag-Grid we will be dropping support for the old version of\n                                    tree data. If you are reading this message, please go to the docs to see how\n                                    to implement Tree Data without using nodeChildDetailsFunc().");
	        }
	    };
	    ClientSideNodeManager.prototype.getCopyOfNodesMap = function () {
	        var result = utils_1._.cloneObject(this.allNodesMap);
	        return result;
	    };
	    ClientSideNodeManager.prototype.getRowNode = function (id) {
	        return this.allNodesMap[id];
	    };
	    ClientSideNodeManager.prototype.setRowData = function (rowData) {
	        this.rootNode.childrenAfterFilter = null;
	        this.rootNode.childrenAfterGroup = null;
	        this.rootNode.childrenAfterSort = null;
	        this.rootNode.childrenMapped = null;
	        this.nextId = 0;
	        this.allNodesMap = {};
	        if (!rowData) {
	            this.rootNode.allLeafChildren = [];
	            this.rootNode.childrenAfterGroup = [];
	            return;
	        }
	        // kick off recursion
	        // we add rootNode as the parent, however if using ag-grid-enterprise, the grouping stage
	        // sets the parent node on each row (even if we are not grouping). so setting parent node
	        // here is for benefit of ag-grid-community users
	        var result = this.recursiveFunction(rowData, this.rootNode, ClientSideNodeManager.TOP_LEVEL);
	        if (this.doingLegacyTreeData) {
	            this.rootNode.childrenAfterGroup = result;
	            this.setLeafChildren(this.rootNode);
	        }
	        else {
	            this.rootNode.allLeafChildren = result;
	        }
	    };
	    ClientSideNodeManager.prototype.updateRowData = function (rowDataTran, rowNodeOrder) {
	        if (this.isLegacyTreeData()) {
	            return null;
	        }
	        var add = rowDataTran.add, addIndex = rowDataTran.addIndex, remove = rowDataTran.remove, update = rowDataTran.update;
	        var rowNodeTransaction = {
	            remove: [],
	            update: [],
	            add: []
	        };
	        this.executeAdd(rowDataTran, rowNodeTransaction);
	        this.executeRemove(rowDataTran, rowNodeTransaction);
	        this.executeUpdate(rowDataTran, rowNodeTransaction);
	        if (rowNodeOrder) {
	            utils_1._.sortRowNodesByOrder(this.rootNode.allLeafChildren, rowNodeOrder);
	        }
	        return rowNodeTransaction;
	    };
	    ClientSideNodeManager.prototype.executeAdd = function (rowDataTran, rowNodeTransaction) {
	        var _this = this;
	        var add = rowDataTran.add, addIndex = rowDataTran.addIndex;
	        if (!add) {
	            return;
	        }
	        var useIndex = typeof addIndex === 'number' && addIndex >= 0;
	        if (useIndex) {
	            // items get inserted in reverse order for index insertion
	            add.reverse().forEach(function (item) {
	                var newRowNode = _this.addRowNode(item, addIndex);
	                rowNodeTransaction.add.push(newRowNode);
	            });
	        }
	        else {
	            add.forEach(function (item) {
	                var newRowNode = _this.addRowNode(item);
	                rowNodeTransaction.add.push(newRowNode);
	            });
	        }
	    };
	    ClientSideNodeManager.prototype.executeRemove = function (rowDataTran, rowNodeTransaction) {
	        var _this = this;
	        var remove = rowDataTran.remove;
	        if (!remove) {
	            return;
	        }
	        var rowIdsRemoved = {};
	        var anyNodesSelected = false;
	        remove.forEach(function (item) {
	            var rowNode = _this.lookupRowNode(item);
	            if (!rowNode) {
	                return;
	            }
	            if (rowNode.isSelected()) {
	                anyNodesSelected = true;
	            }
	            // do delete - setting 'tailingNodeInSequence = true' to ensure EVENT_SELECTION_CHANGED is not raised for
	            // each row node updated, instead it is raised once by the calling code if any selected nodes exist.
	            rowNode.setSelected(false, false, true);
	            // so row renderer knows to fade row out (and not reposition it)
	            rowNode.clearRowTop();
	            // NOTE: were we could remove from allLeaveChildren, however _.removeFromArray() is expensive, especially
	            // if called multiple times (eg deleting lots of rows) and if allLeafChildren is a large list
	            rowIdsRemoved[rowNode.id] = true;
	            // _.removeFromArray(this.rootNode.allLeafChildren, rowNode);
	            delete _this.allNodesMap[rowNode.id];
	            rowNodeTransaction.remove.push(rowNode);
	        });
	        this.rootNode.allLeafChildren = this.rootNode.allLeafChildren.filter(function (rowNode) { return !rowIdsRemoved[rowNode.id]; });
	        if (anyNodesSelected) {
	            this.selectionController.updateGroupsFromChildrenSelections();
	            var event_1 = {
	                type: events_1.Events.EVENT_SELECTION_CHANGED,
	                api: this.gridApi,
	                columnApi: this.columnApi
	            };
	            this.eventService.dispatchEvent(event_1);
	        }
	    };
	    ClientSideNodeManager.prototype.executeUpdate = function (rowDataTran, rowNodeTransaction) {
	        var _this = this;
	        var update = rowDataTran.update;
	        if (!update) {
	            return;
	        }
	        update.forEach(function (item) {
	            var rowNode = _this.lookupRowNode(item);
	            if (!rowNode) {
	                return;
	            }
	            rowNode.updateData(item);
	            rowNodeTransaction.update.push(rowNode);
	        });
	    };
	    ClientSideNodeManager.prototype.addRowNode = function (data, index) {
	        var newNode = this.createNode(data, this.rootNode, ClientSideNodeManager.TOP_LEVEL);
	        if (utils_1._.exists(index)) {
	            utils_1._.insertIntoArray(this.rootNode.allLeafChildren, newNode, index);
	        }
	        else {
	            this.rootNode.allLeafChildren.push(newNode);
	        }
	        return newNode;
	    };
	    ClientSideNodeManager.prototype.lookupRowNode = function (data) {
	        var rowNodeIdFunc = this.gridOptionsWrapper.getRowNodeIdFunc();
	        var rowNode;
	        if (utils_1._.exists(rowNodeIdFunc)) {
	            // find rowNode using id
	            var id = rowNodeIdFunc(data);
	            rowNode = this.allNodesMap[id];
	            if (!rowNode) {
	                console.error("ag-Grid: could not find row id=" + id + ", data item was not found for this id");
	                return null;
	            }
	        }
	        else {
	            // find rowNode using object references
	            rowNode = utils_1._.find(this.rootNode.allLeafChildren, function (rowNode) { return rowNode.data === data; });
	            if (!rowNode) {
	                console.error("ag-Grid: could not find data item as object was not found", data);
	                return null;
	            }
	        }
	        return rowNode;
	    };
	    ClientSideNodeManager.prototype.recursiveFunction = function (rowData, parent, level) {
	        var _this = this;
	        // make sure the rowData is an array and not a string of json - this was a commonly reported problem on the forum
	        if (typeof rowData === 'string') {
	            console.warn('ag-Grid: rowData must be an array, however you passed in a string. If you are loading JSON, make sure you convert the JSON string to JavaScript objects first');
	            return;
	        }
	        var rowNodes = [];
	        rowData.forEach(function (dataItem) {
	            var node = _this.createNode(dataItem, parent, level);
	            rowNodes.push(node);
	        });
	        return rowNodes;
	    };
	    ClientSideNodeManager.prototype.createNode = function (dataItem, parent, level) {
	        var node = new rowNode_1.RowNode();
	        this.context.wireBean(node);
	        var doingTreeData = this.gridOptionsWrapper.isTreeData();
	        var doingLegacyTreeData = !doingTreeData && utils_1._.exists(this.getNodeChildDetails);
	        var nodeChildDetails = doingLegacyTreeData ? this.getNodeChildDetails(dataItem) : null;
	        if (nodeChildDetails && nodeChildDetails.group) {
	            node.group = true;
	            node.childrenAfterGroup = this.recursiveFunction(nodeChildDetails.children, node, level + 1);
	            node.expanded = nodeChildDetails.expanded === true;
	            node.field = nodeChildDetails.field;
	            node.key = nodeChildDetails.key;
	            /** @deprecated is now 'master' */
	            node.canFlower = node.master;
	            // pull out all the leaf children and add to our node
	            this.setLeafChildren(node);
	        }
	        else {
	            node.group = false;
	            if (doingTreeData) {
	                node.master = false;
	                node.expanded = false;
	            }
	            else {
	                // this is the default, for when doing grid data
	                if (this.doesDataFlower) {
	                    node.master = this.doesDataFlower(dataItem);
	                }
	                else if (this.doingMasterDetail) {
	                    // if we are doing master detail, then the
	                    // default is that everything can flower.
	                    if (this.isRowMasterFunc) {
	                        node.master = this.isRowMasterFunc(dataItem);
	                    }
	                    else {
	                        node.master = true;
	                    }
	                }
	                else {
	                    node.master = false;
	                }
	                var rowGroupColumns = this.columnController.getRowGroupColumns();
	                var numRowGroupColumns = rowGroupColumns ? rowGroupColumns.length : 0;
	                // need to take row group into account when determining level
	                var masterRowLevel = level + numRowGroupColumns;
	                node.expanded = node.master ? this.isExpanded(masterRowLevel) : false;
	            }
	        }
	        // support for backwards compatibility, canFlow is now called 'master'
	        node.canFlower = node.master;
	        if (parent && !this.suppressParentsInRowNodes) {
	            node.parent = parent;
	        }
	        node.level = level;
	        node.setDataAndId(dataItem, this.nextId.toString());
	        if (this.allNodesMap[node.id]) {
	            console.warn("ag-grid: duplicate node id '" + node.id + "' detected from getRowNodeId callback, this could cause issues in your grid.");
	        }
	        this.allNodesMap[node.id] = node;
	        this.nextId++;
	        return node;
	    };
	    ClientSideNodeManager.prototype.isExpanded = function (level) {
	        var expandByDefault = this.gridOptionsWrapper.getGroupDefaultExpanded();
	        if (expandByDefault === -1) {
	            return true;
	        }
	        else {
	            return level < expandByDefault;
	        }
	    };
	    // this is only used for doing legacy tree data
	    ClientSideNodeManager.prototype.setLeafChildren = function (node) {
	        node.allLeafChildren = [];
	        if (node.childrenAfterGroup) {
	            node.childrenAfterGroup.forEach(function (childAfterGroup) {
	                if (childAfterGroup.group) {
	                    if (childAfterGroup.allLeafChildren) {
	                        childAfterGroup.allLeafChildren.forEach(function (leafChild) { return node.allLeafChildren.push(leafChild); });
	                    }
	                }
	                else {
	                    node.allLeafChildren.push(childAfterGroup);
	                }
	            });
	        }
	    };
	    ClientSideNodeManager.prototype.isLegacyTreeData = function () {
	        var rowsAlreadyGrouped = utils_1._.exists(this.gridOptionsWrapper.getNodeChildDetailsFunc());
	        if (rowsAlreadyGrouped) {
	            console.warn('ag-Grid: adding and removing rows is not supported when using nodeChildDetailsFunc, ie it is not ' +
	                'supported for legacy tree data. Please see the docs on the new preferred way of providing tree data that works with delta updates.');
	            return true;
	        }
	        else {
	            return false;
	        }
	    };
	    ClientSideNodeManager.TOP_LEVEL = 0;
	    ClientSideNodeManager.ROOT_NODE_ID = 'ROOT_NODE_ID';
	    return ClientSideNodeManager;
	}());
	exports.ClientSideNodeManager = ClientSideNodeManager;


/***/ }),
/* 2479 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var agCheckbox_1 = __webpack_require__(2428);
	var AgRadioButton = /** @class */ (function (_super) {
	    __extends(AgRadioButton, _super);
	    function AgRadioButton() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.className = 'ag-radio-button';
	        _this.inputType = 'radio';
	        _this.iconMap = {
	            selected: 'radioButtonOn',
	            unselected: 'radioButtonOff'
	        };
	        return _this;
	    }
	    AgRadioButton.prototype.toggle = function () {
	        var nextValue = this.getNextValue();
	        this.setValue(nextValue);
	    };
	    AgRadioButton.prototype.getIconName = function () {
	        var value = this.getValue();
	        var prop = value ? 'selected' : 'unselected';
	        var readOnlyStr = this.isReadOnly() ? 'ReadOnly' : '';
	        return "" + this.iconMap[prop] + readOnlyStr;
	    };
	    return AgRadioButton;
	}(agCheckbox_1.AgCheckbox));
	exports.AgRadioButton = AgRadioButton;


/***/ }),
/* 2480 */
/***/ (function(module, exports) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/** The base frameworks, eg React & Angular 2, override this bean with implementations specific to their requirement. */
	var VanillaFrameworkOverrides = /** @class */ (function () {
	    function VanillaFrameworkOverrides() {
	    }
	    // for Vanilla JS, we use simple timeout
	    VanillaFrameworkOverrides.prototype.setTimeout = function (action, timeout) {
	        window.setTimeout(action, timeout);
	    };
	    // for Vanilla JS, we just add the event to the element
	    VanillaFrameworkOverrides.prototype.addEventListenerOutsideAngular = function (element, type, listener, useCapture) {
	        element.addEventListener(type, listener, useCapture);
	    };
	    return VanillaFrameworkOverrides;
	}());
	exports.VanillaFrameworkOverrides = VanillaFrameworkOverrides;


/***/ }),
/* 2481 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var context_1 = __webpack_require__(2333);
	var LINE_SEPARATOR = '\r\n';
	var XmlFactory = /** @class */ (function () {
	    function XmlFactory() {
	    }
	    XmlFactory.prototype.createHeader = function (headerElement) {
	        if (headerElement === void 0) { headerElement = {}; }
	        var headerStart = '<?';
	        var headerEnd = '?>';
	        var keys = ['version'];
	        if (!headerElement.version) {
	            headerElement.version = "1.0";
	        }
	        if (headerElement.encoding) {
	            keys.push('encoding');
	        }
	        if (headerElement.standalone) {
	            keys.push('standalone');
	        }
	        var att = keys.map(function (key) { return key + "=\"" + headerElement[key] + "\""; }).join(' ');
	        return headerStart + "xml " + att + " " + headerEnd;
	    };
	    XmlFactory.prototype.createXml = function (xmlElement, booleanTransformer) {
	        var _this = this;
	        var props = '';
	        if (xmlElement.properties) {
	            if (xmlElement.properties.prefixedAttributes) {
	                xmlElement.properties.prefixedAttributes.forEach(function (prefixedSet) {
	                    Object.keys(prefixedSet.map).forEach(function (key) {
	                        props += _this.returnAttributeIfPopulated(prefixedSet.prefix + key, prefixedSet.map[key], booleanTransformer);
	                    });
	                });
	            }
	            if (xmlElement.properties.rawMap) {
	                Object.keys(xmlElement.properties.rawMap).forEach(function (key) {
	                    props += _this.returnAttributeIfPopulated(key, xmlElement.properties.rawMap[key], booleanTransformer);
	                });
	            }
	        }
	        var result = '<' + xmlElement.name + props;
	        if (!xmlElement.children && xmlElement.textNode == null) {
	            return result + '/>' + LINE_SEPARATOR;
	        }
	        if (xmlElement.textNode != null) {
	            return result + '>' + xmlElement.textNode + '</' + xmlElement.name + '>' + LINE_SEPARATOR;
	        }
	        result += '>' + LINE_SEPARATOR;
	        if (xmlElement.children) {
	            xmlElement.children.forEach(function (it) {
	                result += _this.createXml(it, booleanTransformer);
	            });
	        }
	        return result + '</' + xmlElement.name + '>' + LINE_SEPARATOR;
	    };
	    XmlFactory.prototype.returnAttributeIfPopulated = function (key, value, booleanTransformer) {
	        if (!value && value !== '' && value !== 0) {
	            return '';
	        }
	        var xmlValue = value;
	        if ((typeof (value) === 'boolean')) {
	            if (booleanTransformer) {
	                xmlValue = booleanTransformer(value);
	            }
	        }
	        return " " + key + "=\"" + xmlValue + "\"";
	    };
	    XmlFactory = __decorate([
	        context_1.Bean('xmlFactory')
	    ], XmlFactory);
	    return XmlFactory;
	}());
	exports.XmlFactory = XmlFactory;


/***/ }),
/* 2482 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var context_1 = __webpack_require__(2333);
	var gridOptionsWrapper_1 = __webpack_require__(2324);
	var changedPath_1 = __webpack_require__(2358);
	var rowRenderer_1 = __webpack_require__(2350);
	var eventService_1 = __webpack_require__(2331);
	var constants_1 = __webpack_require__(2328);
	var beanStub_1 = __webpack_require__(2354);
	var events_1 = __webpack_require__(2335);
	var ChangeDetectionService = /** @class */ (function (_super) {
	    __extends(ChangeDetectionService, _super);
	    function ChangeDetectionService() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    ChangeDetectionService.prototype.init = function () {
	        if (this.rowModel.getType() === constants_1.Constants.ROW_MODEL_TYPE_CLIENT_SIDE) {
	            this.clientSideRowModel = this.rowModel;
	        }
	        this.addDestroyableEventListener(this.eventService, events_1.Events.EVENT_CELL_VALUE_CHANGED, this.onCellValueChanged.bind(this));
	    };
	    ChangeDetectionService.prototype.onCellValueChanged = function (event) {
	        this.doChangeDetection(event.node, event.column);
	    };
	    ChangeDetectionService.prototype.doChangeDetection = function (rowNode, column) {
	        if (this.gridOptionsWrapper.isSuppressChangeDetection()) {
	            return;
	        }
	        // clipboard service manages it's own change detection, so no need to do it here.
	        // the clipboard manages it own, as otherwise this would happen once for every cell
	        // that got updated as part of a paste operation. so eg if 100 cells in a paste operation,
	        // this doChangeDetection would get called 100 times (once for each cell), instead clipboard
	        // service executes the logic we have here once (in essence batching up all cell changes
	        // into one change detection).
	        if (this.clipboardService && this.clipboardService.isPasteOperationActive()) {
	            return;
	        }
	        // step 1 of change detection is to update the aggregated values
	        if (this.clientSideRowModel && !rowNode.isRowPinned()) {
	            var onlyChangedColumns = this.gridOptionsWrapper.isAggregateOnlyChangedColumns();
	            var changedPath = new changedPath_1.ChangedPath(onlyChangedColumns, this.clientSideRowModel.getRootNode());
	            changedPath.addParentNode(rowNode.parent, [column]);
	            this.clientSideRowModel.doAggregate(changedPath);
	        }
	        // step 2 of change detection is to refresh the cells
	        this.rowRenderer.refreshCells();
	    };
	    __decorate([
	        context_1.Autowired('gridOptionsWrapper'),
	        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
	    ], ChangeDetectionService.prototype, "gridOptionsWrapper", void 0);
	    __decorate([
	        context_1.Autowired('rowModel'),
	        __metadata("design:type", Object)
	    ], ChangeDetectionService.prototype, "rowModel", void 0);
	    __decorate([
	        context_1.Autowired('rowRenderer'),
	        __metadata("design:type", rowRenderer_1.RowRenderer)
	    ], ChangeDetectionService.prototype, "rowRenderer", void 0);
	    __decorate([
	        context_1.Autowired('eventService'),
	        __metadata("design:type", eventService_1.EventService)
	    ], ChangeDetectionService.prototype, "eventService", void 0);
	    __decorate([
	        context_1.Optional('clipboardService'),
	        __metadata("design:type", Object)
	    ], ChangeDetectionService.prototype, "clipboardService", void 0);
	    __decorate([
	        context_1.PostConstruct,
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", []),
	        __metadata("design:returntype", void 0)
	    ], ChangeDetectionService.prototype, "init", null);
	    ChangeDetectionService = __decorate([
	        context_1.Bean('changeDetectionService')
	    ], ChangeDetectionService);
	    return ChangeDetectionService;
	}(beanStub_1.BeanStub));
	exports.ChangeDetectionService = ChangeDetectionService;


/***/ }),
/* 2483 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var component_1 = __webpack_require__(2353);
	var context_1 = __webpack_require__(2333);
	var gridOptionsWrapper_1 = __webpack_require__(2324);
	var componentAnnotations_1 = __webpack_require__(2384);
	var eventService_1 = __webpack_require__(2331);
	var events_1 = __webpack_require__(2335);
	var rowRenderer_1 = __webpack_require__(2350);
	var paginationProxy_1 = __webpack_require__(2372);
	var utils_1 = __webpack_require__(2325);
	var constants_1 = __webpack_require__(2328);
	var PaginationComp = /** @class */ (function (_super) {
	    __extends(PaginationComp, _super);
	    function PaginationComp() {
	        return _super.call(this) || this;
	    }
	    PaginationComp.prototype.postConstruct = function () {
	        var isRtl = this.gridOptionsWrapper.isEnableRtl();
	        this.setTemplate(this.getTemplate());
	        this.btFirst.insertAdjacentElement('afterbegin', utils_1._.createIconNoSpan(isRtl ? 'last' : 'first', this.gridOptionsWrapper));
	        this.btPrevious.insertAdjacentElement('afterbegin', utils_1._.createIconNoSpan(isRtl ? 'next' : 'previous', this.gridOptionsWrapper));
	        this.btNext.insertAdjacentElement('afterbegin', utils_1._.createIconNoSpan(isRtl ? 'previous' : 'next', this.gridOptionsWrapper));
	        this.btLast.insertAdjacentElement('afterbegin', utils_1._.createIconNoSpan(isRtl ? 'first' : 'last', this.gridOptionsWrapper));
	        if (this.rowModel.getType() === constants_1.Constants.ROW_MODEL_TYPE_SERVER_SIDE) {
	            this.serverSideRowModel = this.rowModel;
	        }
	        var isPaging = this.gridOptionsWrapper.isPagination();
	        var paginationPanelEnabled = isPaging && !this.gridOptionsWrapper.isSuppressPaginationPanel();
	        if (!paginationPanelEnabled) {
	            this.setDisplayed(false);
	            return;
	        }
	        this.addDestroyableEventListener(this.eventService, events_1.Events.EVENT_PAGINATION_CHANGED, this.onPaginationChanged.bind(this));
	        this.addDestroyableEventListener(this.btFirst, 'click', this.onBtFirst.bind(this));
	        this.addDestroyableEventListener(this.btLast, 'click', this.onBtLast.bind(this));
	        this.addDestroyableEventListener(this.btNext, 'click', this.onBtNext.bind(this));
	        this.addDestroyableEventListener(this.btPrevious, 'click', this.onBtPrevious.bind(this));
	        this.onPaginationChanged();
	    };
	    PaginationComp.prototype.onPaginationChanged = function () {
	        this.enableOrDisableButtons();
	        this.updateRowLabels();
	        this.setCurrentPageLabel();
	        this.setTotalLabels();
	    };
	    PaginationComp.prototype.setCurrentPageLabel = function () {
	        var pagesExist = this.paginationProxy.getTotalPages() > 0;
	        var currentPage = this.paginationProxy.getCurrentPage();
	        var toDisplay = pagesExist ? currentPage + 1 : 0;
	        this.lbCurrent.innerHTML = this.formatNumber(toDisplay);
	    };
	    PaginationComp.prototype.formatNumber = function (value) {
	        var userFunc = this.gridOptionsWrapper.getPaginationNumberFormatterFunc();
	        if (userFunc) {
	            return userFunc({ value: value });
	        }
	        else {
	            return utils_1._.formatNumberCommas(value);
	        }
	    };
	    PaginationComp.prototype.getTemplate = function () {
	        var localeTextFunc = this.gridOptionsWrapper.getLocaleTextFunc();
	        var strPage = localeTextFunc('page', 'Page');
	        var strTo = localeTextFunc('to', 'to');
	        var strOf = localeTextFunc('of', 'of');
	        var strFirst = localeTextFunc('first', 'First');
	        var strPrevious = localeTextFunc('previous', 'Previous');
	        var strNext = localeTextFunc('next', 'Next');
	        var strLast = localeTextFunc('last', 'Last');
	        return "<div class=\"ag-paging-panel ag-unselectable\">\n                <span ref=\"eSummaryPanel\" class=\"ag-paging-row-summary-panel\">\n                    <span ref=\"lbFirstRowOnPage\"></span> " + strTo + " <span ref=\"lbLastRowOnPage\"></span> " + strOf + " <span ref=\"lbRecordCount\"></span>\n                </span>\n                <span class=\"ag-paging-page-summary-panel\">\n                    <div ref=\"btFirst\" class=\"ag-paging-button\">\n                        <button type=\"button\">" + strFirst + "</button>\n                    </div>\n                    <div ref=\"btPrevious\" class=\"ag-paging-button\">\n                        <button type=\"button\">" + strPrevious + "</button>\n                    </div>\n                    " + strPage + " <span ref=\"lbCurrent\"></span> " + strOf + " <span ref=\"lbTotal\"></span>\n                    <div ref=\"btNext\" class=\"ag-paging-button\">\n                        <button type=\"button\">" + strNext + "</button>\n                    </div>\n                    <div ref=\"btLast\" class=\"ag-paging-button\">\n                        <button type=\"button\">" + strLast + "</button>\n                    </div>\n                </span>\n            </div>";
	    };
	    PaginationComp.prototype.onBtNext = function () {
	        this.paginationProxy.goToNextPage();
	    };
	    PaginationComp.prototype.onBtPrevious = function () {
	        this.paginationProxy.goToPreviousPage();
	    };
	    PaginationComp.prototype.onBtFirst = function () {
	        this.paginationProxy.goToFirstPage();
	    };
	    PaginationComp.prototype.onBtLast = function () {
	        this.paginationProxy.goToLastPage();
	    };
	    PaginationComp.prototype.enableOrDisableButtons = function () {
	        var currentPage = this.paginationProxy.getCurrentPage();
	        var maxRowFound = this.paginationProxy.isLastPageFound();
	        var totalPages = this.paginationProxy.getTotalPages();
	        var disablePreviousAndFirst = currentPage === 0;
	        utils_1._.addOrRemoveCssClass(this.btPrevious, 'ag-disabled', disablePreviousAndFirst);
	        utils_1._.addOrRemoveCssClass(this.btFirst, 'ag-disabled', disablePreviousAndFirst);
	        var zeroPagesToDisplay = this.isZeroPagesToDisplay();
	        var onLastPage = maxRowFound && currentPage === (totalPages - 1);
	        var disableNext = onLastPage || zeroPagesToDisplay;
	        utils_1._.addOrRemoveCssClass(this.btNext, 'ag-disabled', disableNext);
	        var disableLast = !maxRowFound || zeroPagesToDisplay || currentPage === (totalPages - 1);
	        utils_1._.addOrRemoveCssClass(this.btLast, 'ag-disabled', disableLast);
	    };
	    PaginationComp.prototype.updateRowLabels = function () {
	        var currentPage = this.paginationProxy.getCurrentPage();
	        var pageSize = this.paginationProxy.getPageSize();
	        var maxRowFound = this.paginationProxy.isLastPageFound();
	        var rowCount = this.paginationProxy.isLastPageFound() ?
	            this.paginationProxy.getMasterRowCount() : null;
	        var startRow;
	        var endRow;
	        if (this.isZeroPagesToDisplay()) {
	            startRow = 0;
	            endRow = 0;
	        }
	        else {
	            startRow = (pageSize * currentPage) + 1;
	            endRow = startRow + pageSize - 1;
	            if (maxRowFound && endRow > rowCount) {
	                endRow = rowCount;
	            }
	        }
	        this.lbFirstRowOnPage.innerHTML = this.formatNumber(startRow);
	        if (this.serverSideRowModel && this.serverSideRowModel.isLoading()) {
	            this.lbLastRowOnPage.innerHTML = '?';
	        }
	        else {
	            this.lbLastRowOnPage.innerHTML = this.formatNumber(endRow);
	        }
	    };
	    PaginationComp.prototype.isZeroPagesToDisplay = function () {
	        var maxRowFound = this.paginationProxy.isLastPageFound();
	        var totalPages = this.paginationProxy.getTotalPages();
	        return maxRowFound && totalPages === 0;
	    };
	    PaginationComp.prototype.setTotalLabels = function () {
	        var lastPageFound = this.paginationProxy.isLastPageFound();
	        var totalPages = this.paginationProxy.getTotalPages();
	        var rowCount = this.paginationProxy.isLastPageFound() ?
	            this.paginationProxy.getMasterRowCount() : null;
	        if (lastPageFound) {
	            this.lbTotal.innerHTML = this.formatNumber(totalPages);
	            this.lbRecordCount.innerHTML = this.formatNumber(rowCount);
	        }
	        else {
	            var moreText = this.gridOptionsWrapper.getLocaleTextFunc()('more', 'more');
	            this.lbTotal.innerHTML = moreText;
	            this.lbRecordCount.innerHTML = moreText;
	        }
	    };
	    __decorate([
	        context_1.Autowired('gridOptionsWrapper'),
	        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
	    ], PaginationComp.prototype, "gridOptionsWrapper", void 0);
	    __decorate([
	        context_1.Autowired('eventService'),
	        __metadata("design:type", eventService_1.EventService)
	    ], PaginationComp.prototype, "eventService", void 0);
	    __decorate([
	        context_1.Autowired('paginationProxy'),
	        __metadata("design:type", paginationProxy_1.PaginationProxy)
	    ], PaginationComp.prototype, "paginationProxy", void 0);
	    __decorate([
	        context_1.Autowired('rowRenderer'),
	        __metadata("design:type", rowRenderer_1.RowRenderer)
	    ], PaginationComp.prototype, "rowRenderer", void 0);
	    __decorate([
	        context_1.Autowired('rowModel'),
	        __metadata("design:type", Object)
	    ], PaginationComp.prototype, "rowModel", void 0);
	    __decorate([
	        componentAnnotations_1.RefSelector('btFirst'),
	        __metadata("design:type", HTMLElement)
	    ], PaginationComp.prototype, "btFirst", void 0);
	    __decorate([
	        componentAnnotations_1.RefSelector('btPrevious'),
	        __metadata("design:type", HTMLElement)
	    ], PaginationComp.prototype, "btPrevious", void 0);
	    __decorate([
	        componentAnnotations_1.RefSelector('btNext'),
	        __metadata("design:type", HTMLElement)
	    ], PaginationComp.prototype, "btNext", void 0);
	    __decorate([
	        componentAnnotations_1.RefSelector('btLast'),
	        __metadata("design:type", HTMLElement)
	    ], PaginationComp.prototype, "btLast", void 0);
	    __decorate([
	        componentAnnotations_1.RefSelector('lbRecordCount'),
	        __metadata("design:type", Object)
	    ], PaginationComp.prototype, "lbRecordCount", void 0);
	    __decorate([
	        componentAnnotations_1.RefSelector('lbFirstRowOnPage'),
	        __metadata("design:type", Object)
	    ], PaginationComp.prototype, "lbFirstRowOnPage", void 0);
	    __decorate([
	        componentAnnotations_1.RefSelector('lbLastRowOnPage'),
	        __metadata("design:type", Object)
	    ], PaginationComp.prototype, "lbLastRowOnPage", void 0);
	    __decorate([
	        componentAnnotations_1.RefSelector('eSummaryPanel'),
	        __metadata("design:type", Object)
	    ], PaginationComp.prototype, "eSummaryPanel", void 0);
	    __decorate([
	        componentAnnotations_1.RefSelector('lbCurrent'),
	        __metadata("design:type", Object)
	    ], PaginationComp.prototype, "lbCurrent", void 0);
	    __decorate([
	        componentAnnotations_1.RefSelector('lbTotal'),
	        __metadata("design:type", Object)
	    ], PaginationComp.prototype, "lbTotal", void 0);
	    __decorate([
	        context_1.PostConstruct,
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", []),
	        __metadata("design:returntype", void 0)
	    ], PaginationComp.prototype, "postConstruct", null);
	    return PaginationComp;
	}(component_1.Component));
	exports.PaginationComp = PaginationComp;


/***/ }),
/* 2484 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var context_1 = __webpack_require__(2333);
	var utils_1 = __webpack_require__(2325);
	// table for crc calculation
	// from: https://referencesource.microsoft.com/#System/sys/System/IO/compression/Crc32Helper.cs,3b31978c7d7f7246,references
	var crcTable = [
	    0, 1996959894, -301047508, -1727442502, 124634137, 1886057615, -379345611, -1637575261, 249268274,
	    2044508324, -522852066, -1747789432, 162941995, 2125561021, -407360249, -1866523247, 498536548,
	    1789927666, -205950648, -2067906082, 450548861, 1843258603, -187386543, -2083289657, 325883990,
	    1684777152, -43845254, -1973040660, 335633487, 1661365465, -99664541, -1928851979, 997073096,
	    1281953886, -715111964, -1570279054, 1006888145, 1258607687, -770865667, -1526024853, 901097722,
	    1119000684, -608450090, -1396901568, 853044451, 1172266101, -589951537, -1412350631, 651767980,
	    1373503546, -925412992, -1076862698, 565507253, 1454621731, -809855591, -1195530993, 671266974,
	    1594198024, -972236366, -1324619484, 795835527, 1483230225, -1050600021, -1234817731, 1994146192,
	    31158534, -1731059524, -271249366, 1907459465, 112637215, -1614814043, -390540237, 2013776290,
	    251722036, -1777751922, -519137256, 2137656763, 141376813, -1855689577, -429695999, 1802195444,
	    476864866, -2056965928, -228458418, 1812370925, 453092731, -2113342271, -183516073, 1706088902,
	    314042704, -1950435094, -54949764, 1658658271, 366619977, -1932296973, -69972891, 1303535960,
	    984961486, -1547960204, -725929758, 1256170817, 1037604311, -1529756563, -740887301, 1131014506,
	    879679996, -1385723834, -631195440, 1141124467, 855842277, -1442165665, -586318647, 1342533948,
	    654459306, -1106571248, -921952122, 1466479909, 544179635, -1184443383, -832445281, 1591671054,
	    702138776, -1328506846, -942167884, 1504918807, 783551873, -1212326853, -1061524307, -306674912,
	    -1698712650, 62317068, 1957810842, -355121351, -1647151185, 81470997, 1943803523, -480048366,
	    -1805370492, 225274430, 2053790376, -468791541, -1828061283, 167816743, 2097651377, -267414716,
	    -2029476910, 503444072, 1762050814, -144550051, -2140837941, 426522225, 1852507879, -19653770,
	    -1982649376, 282753626, 1742555852, -105259153, -1900089351, 397917763, 1622183637, -690576408,
	    -1580100738, 953729732, 1340076626, -776247311, -1497606297, 1068828381, 1219638859, -670225446,
	    -1358292148, 906185462, 1090812512, -547295293, -1469587627, 829329135, 1181335161, -882789492,
	    -1134132454, 628085408, 1382605366, -871598187, -1156888829, 570562233, 1426400815, -977650754,
	    -1296233688, 733239954, 1555261956, -1026031705, -1244606671, 752459403, 1541320221, -1687895376,
	    -328994266, 1969922972, 40735498, -1677130071, -351390145, 1913087877, 83908371, -1782625662,
	    -491226604, 2075208622, 213261112, -1831694693, -438977011, 2094854071, 198958881, -2032938284,
	    -237706686, 1759359992, 534414190, -2118248755, -155638181, 1873836001, 414664567, -2012718362,
	    -15766928, 1711684554, 285281116, -1889165569, -127750551, 1634467795, 376229701, -1609899400,
	    -686959890, 1308918612, 956543938, -1486412191, -799009033, 1231636301, 1047427035, -1362007478,
	    -640263460, 1088359270, 936918000, -1447252397, -558129467, 1202900863, 817233897, -1111625188,
	    -893730166, 1404277552, 615818150, -1160759803, -841546093, 1423857449, 601450431, -1285129682,
	    -1000256840, 1567103746, 711928724, -1274298825, -1022587231, 1510334235, 755167117
	];
	var ZipContainer = /** @class */ (function () {
	    function ZipContainer() {
	        var _this = this;
	        this.folders = [];
	        this.files = [];
	        this.addFolder = function (path) {
	            _this.folders.push({
	                path: path,
	                created: new Date()
	            });
	        };
	    }
	    ZipContainer.prototype.addFolders = function (paths) {
	        paths.forEach(this.addFolder);
	    };
	    ZipContainer.prototype.addFile = function (path, content) {
	        this.files.push({
	            path: path,
	            created: new Date(),
	            content: content
	        });
	    };
	    ZipContainer.prototype.clearStream = function () {
	        this.folders = [];
	        this.files = [];
	    };
	    ZipContainer.prototype.getContent = function (mimeType) {
	        if (mimeType === void 0) { mimeType = 'application/zip'; }
	        var textOutput = this.buildFileStream();
	        var uInt8Output = this.buildUint8Array(textOutput);
	        this.clearStream();
	        return new Blob([uInt8Output], { type: mimeType });
	    };
	    ZipContainer.prototype.buildFileStream = function (fData) {
	        if (fData === void 0) { fData = ''; }
	        var totalFiles = this.folders.concat(this.files);
	        var len = totalFiles.length;
	        var foData = '';
	        var lL = 0;
	        var cL = 0;
	        for (var _i = 0, totalFiles_1 = totalFiles; _i < totalFiles_1.length; _i++) {
	            var currentFile = totalFiles_1[_i];
	            var _a = this.getHeader(currentFile, lL), fileHeader = _a.fileHeader, folderHeader = _a.folderHeader, content = _a.content;
	            lL += fileHeader.length + content.length;
	            cL += folderHeader.length;
	            fData += fileHeader + content;
	            foData += folderHeader;
	        }
	        var foEnd = this.buildFolderEnd(len, cL, lL);
	        return fData + foData + foEnd;
	    };
	    ZipContainer.prototype.getHeader = function (currentFile, offset) {
	        var content = currentFile.content, path = currentFile.path, created = currentFile.created;
	        var utf8_encode = utils_1._.utf8_encode, decToHex = utils_1._.decToHex;
	        var utfPath = utf8_encode(path);
	        var isUTF8 = utfPath !== path;
	        var time = this.convertTime(created);
	        var dt = this.convertDate(created);
	        var extraFields = '';
	        if (isUTF8) {
	            var uExtraFieldPath = decToHex(1, 1) + decToHex(this.getFromCrc32Table(utfPath), 4) + utfPath;
	            extraFields = "\x75\x70" + decToHex(uExtraFieldPath.length, 2) + uExtraFieldPath;
	        }
	        var header = '\x0A\x00' +
	            (isUTF8 ? '\x00\x08' : '\x00\x00') +
	            '\x00\x00' +
	            decToHex(time, 2) + // last modified time
	            decToHex(dt, 2) + // last modified date
	            decToHex(content ? this.getFromCrc32Table(content) : 0, 4) +
	            decToHex(content ? content.length : 0, 4) + // compressed size
	            decToHex(content ? content.length : 0, 4) + // uncompressed size
	            decToHex(utfPath.length, 2) + // file name length
	            decToHex(extraFields.length, 2); // extra field length
	        var fileHeader = 'PK\x03\x04' + header + utfPath + extraFields;
	        var folderHeader = 'PK\x01\x02' + // central header
	            '\x14\x00' +
	            header + // file header
	            '\x00\x00' +
	            '\x00\x00' +
	            '\x00\x00' +
	            (content ? '\x00\x00\x00\x00' : '\x10\x00\x00\x00') + // external file attributes
	            decToHex(offset, 4) + // relative offset of local header
	            utfPath + // file name
	            extraFields; // extra field
	        return { fileHeader: fileHeader, folderHeader: folderHeader, content: content || '' };
	    };
	    ZipContainer.prototype.buildFolderEnd = function (tLen, cLen, lLen) {
	        var decToHex = utils_1._.decToHex;
	        return 'PK\x05\x06' + // central folder end
	            '\x00\x00' +
	            '\x00\x00' +
	            decToHex(tLen, 2) + // total number of entries in the central folder
	            decToHex(tLen, 2) + // total number of entries in the central folder
	            decToHex(cLen, 4) + // size of the central folder
	            decToHex(lLen, 4) + // central folder start offset
	            '\x00\x00';
	    };
	    ZipContainer.prototype.buildUint8Array = function (content) {
	        var uint8 = new Uint8Array(content.length);
	        for (var i = 0; i < uint8.length; i++) {
	            uint8[i] = content.charCodeAt(i);
	        }
	        return uint8;
	    };
	    ZipContainer.prototype.getFromCrc32Table = function (content, crc) {
	        if (crc === void 0) { crc = 0; }
	        if (!content.length) {
	            return 0;
	        }
	        crc ^= (-1);
	        var j = 0;
	        var k = 0;
	        var l = 0;
	        for (var i = 0; i < content.length; i++) {
	            j = content.charCodeAt(i);
	            k = (crc ^ j) & 0xFF;
	            l = crcTable[k];
	            crc = (crc >>> 8) ^ l;
	        }
	        return crc ^ (-1);
	    };
	    ZipContainer.prototype.convertTime = function (date) {
	        var time = date.getHours();
	        time <<= 6;
	        time = time | date.getMinutes();
	        time <<= 5;
	        time = time | date.getSeconds() / 2;
	        return time;
	    };
	    ZipContainer.prototype.convertDate = function (date) {
	        var dt = date.getFullYear() - 1980;
	        dt <<= 4;
	        dt = dt | (date.getMonth() + 1);
	        dt <<= 5;
	        dt = dt | date.getDate();
	        return dt;
	    };
	    ZipContainer = __decorate([
	        context_1.Bean('zipContainer')
	    ], ZipContainer);
	    return ZipContainer;
	}());
	exports.ZipContainer = ZipContainer;


/***/ }),
/* 2485 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var component_1 = __webpack_require__(2353);
	var componentAnnotations_1 = __webpack_require__(2384);
	var context_1 = __webpack_require__(2333);
	var gridOptionsWrapper_1 = __webpack_require__(2324);
	var agCheckbox_1 = __webpack_require__(2428);
	var utils_1 = __webpack_require__(2325);
	var AgGroupComponent = /** @class */ (function (_super) {
	    __extends(AgGroupComponent, _super);
	    function AgGroupComponent(params) {
	        var _this = _super.call(this, AgGroupComponent.TEMPLATE) || this;
	        _this.suppressEnabledCheckbox = true;
	        _this.suppressOpenCloseIcons = false;
	        if (!params) {
	            params = {};
	        }
	        var title = params.title, enabled = params.enabled, items = params.items, suppressEnabledCheckbox = params.suppressEnabledCheckbox, suppressOpenCloseIcons = params.suppressOpenCloseIcons;
	        _this.title = title;
	        _this.enabled = enabled != null ? enabled : true;
	        _this.items = items || [];
	        if (suppressEnabledCheckbox != null) {
	            _this.suppressEnabledCheckbox = suppressEnabledCheckbox;
	        }
	        if (suppressOpenCloseIcons != null) {
	            _this.suppressOpenCloseIcons = suppressOpenCloseIcons;
	        }
	        return _this;
	    }
	    AgGroupComponent.prototype.postConstruct = function () {
	        if (this.items.length) {
	            var initialItems = this.items;
	            this.items = [];
	            this.addItems(initialItems);
	        }
	        var localeTextFunc = this.gridOptionsWrapper.getLocaleTextFunc();
	        this.cbGroupEnabled.setLabel(localeTextFunc('enabled', 'Enabled'));
	        if (this.title) {
	            this.setTitle(this.title);
	        }
	        if (this.enabled) {
	            this.setEnabled(this.enabled);
	        }
	        this.hideEnabledCheckbox(this.suppressEnabledCheckbox);
	        this.hideOpenCloseIcons(this.suppressOpenCloseIcons);
	        this.setupExpandContract();
	    };
	    AgGroupComponent.prototype.setupExpandContract = function () {
	        var _this = this;
	        this.eGroupClosedIcon.appendChild(utils_1._.createIcon('columnSelectClosed', this.gridOptionsWrapper, null));
	        this.eGroupOpenedIcon.appendChild(utils_1._.createIcon('columnSelectOpen', this.gridOptionsWrapper, null));
	        this.setOpenClosedIcons();
	        this.addDestroyableEventListener(this.groupTitle, 'click', function () { return _this.toggleGroupExpand(); });
	    };
	    AgGroupComponent.prototype.setOpenClosedIcons = function () {
	        var folderOpen = this.expanded;
	        utils_1._.setDisplayed(this.eGroupClosedIcon, !folderOpen);
	        utils_1._.setDisplayed(this.eGroupOpenedIcon, folderOpen);
	    };
	    AgGroupComponent.prototype.isExpanded = function () {
	        return this.expanded;
	    };
	    AgGroupComponent.prototype.toggleGroupExpand = function (expanded) {
	        var eGui = this.getGui();
	        if (this.suppressOpenCloseIcons) {
	            this.expanded = true;
	            utils_1._.removeCssClass(eGui, 'ag-collapsed');
	            return this;
	        }
	        expanded = expanded != null ? expanded : !this.expanded;
	        if (this.expanded === expanded) {
	            return this;
	        }
	        this.expanded = expanded;
	        this.setOpenClosedIcons();
	        utils_1._.addOrRemoveCssClass(eGui, 'ag-collapsed', !expanded);
	        if (this.expanded) {
	            var event_1 = {
	                type: 'expanded',
	            };
	            this.dispatchEvent(event_1);
	        }
	        return this;
	    };
	    AgGroupComponent.prototype.addItems = function (items) {
	        var _this = this;
	        items.forEach(function (item) { return _this.addItem(item); });
	    };
	    AgGroupComponent.prototype.addItem = function (item) {
	        var container = this.groupContainer;
	        var el = item instanceof component_1.Component ? item.getGui() : item;
	        utils_1._.addCssClass(el, 'ag-group-item');
	        container.appendChild(el);
	        this.items.push(el);
	    };
	    AgGroupComponent.prototype.setTitle = function (title) {
	        this.lbGroupTitle.innerText = title;
	        return this;
	    };
	    AgGroupComponent.prototype.setEnabled = function (enabled, skipToggle) {
	        this.enabled = enabled;
	        utils_1._.addOrRemoveCssClass(this.getGui(), 'ag-disabled', !enabled);
	        this.toggleGroupExpand(enabled);
	        if (!skipToggle) {
	            this.cbGroupEnabled.setValue(enabled);
	        }
	        return this;
	    };
	    AgGroupComponent.prototype.isEnabled = function () {
	        return this.enabled;
	    };
	    AgGroupComponent.prototype.onEnableChange = function (callbackFn) {
	        var _this = this;
	        this.cbGroupEnabled.onValueChange(function (newSelection) {
	            _this.setEnabled(newSelection, true);
	            callbackFn(newSelection);
	        });
	        return this;
	    };
	    AgGroupComponent.prototype.hideEnabledCheckbox = function (hide) {
	        utils_1._.addOrRemoveCssClass(this.eToolbar, 'ag-hidden', hide);
	        return this;
	    };
	    AgGroupComponent.prototype.hideOpenCloseIcons = function (hide) {
	        this.suppressOpenCloseIcons = hide;
	        utils_1._.addOrRemoveCssClass(this.getGui(), 'ag-collapsible', !hide);
	        if (hide) {
	            this.toggleGroupExpand(true);
	        }
	        return this;
	    };
	    AgGroupComponent.TEMPLATE = "<div class=\"ag-group-component\">\n            <div class=\"ag-group-component-title-bar\" ref=\"groupTitle\">\n                 <span class=\"ag-column-group-icons\">\n                    <span class=\"ag-column-group-closed-icon\" ref=\"eGroupOpenedIcon\"></span>\n                    <span class=\"ag-column-group-opened-icon\" ref=\"eGroupClosedIcon\"></span>\n                </span>\n                <span ref=\"lbGroupTitle\" class=\"ag-group-component-title\"></span>\n            </div>\n            <div ref=\"eToolbar\" class=\"ag-group-component-toolbar\">\n                <ag-checkbox ref=\"cbGroupEnabled\"></ag-checkbox>\n            </div>\n            <div ref=\"eContainer\" class=\"ag-group-component-container\"></div>\n        </div>";
	    __decorate([
	        context_1.Autowired('gridOptionsWrapper'),
	        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
	    ], AgGroupComponent.prototype, "gridOptionsWrapper", void 0);
	    __decorate([
	        componentAnnotations_1.RefSelector('groupTitle'),
	        __metadata("design:type", HTMLElement)
	    ], AgGroupComponent.prototype, "groupTitle", void 0);
	    __decorate([
	        componentAnnotations_1.RefSelector('eGroupOpenedIcon'),
	        __metadata("design:type", HTMLElement)
	    ], AgGroupComponent.prototype, "eGroupOpenedIcon", void 0);
	    __decorate([
	        componentAnnotations_1.RefSelector('eGroupClosedIcon'),
	        __metadata("design:type", HTMLElement)
	    ], AgGroupComponent.prototype, "eGroupClosedIcon", void 0);
	    __decorate([
	        componentAnnotations_1.RefSelector('eToolbar'),
	        __metadata("design:type", HTMLElement)
	    ], AgGroupComponent.prototype, "eToolbar", void 0);
	    __decorate([
	        componentAnnotations_1.RefSelector('cbGroupEnabled'),
	        __metadata("design:type", agCheckbox_1.AgCheckbox)
	    ], AgGroupComponent.prototype, "cbGroupEnabled", void 0);
	    __decorate([
	        componentAnnotations_1.RefSelector("lbGroupTitle"),
	        __metadata("design:type", HTMLElement)
	    ], AgGroupComponent.prototype, "lbGroupTitle", void 0);
	    __decorate([
	        componentAnnotations_1.RefSelector("eContainer"),
	        __metadata("design:type", HTMLElement)
	    ], AgGroupComponent.prototype, "groupContainer", void 0);
	    __decorate([
	        context_1.PostConstruct,
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", []),
	        __metadata("design:returntype", void 0)
	    ], AgGroupComponent.prototype, "postConstruct", null);
	    return AgGroupComponent;
	}(component_1.Component));
	exports.AgGroupComponent = AgGroupComponent;


/***/ }),
/* 2486 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var dragService_1 = __webpack_require__(2364);
	var context_1 = __webpack_require__(2333);
	var agPanel_1 = __webpack_require__(2487);
	var component_1 = __webpack_require__(2353);
	var utils_1 = __webpack_require__(2325);
	var AgDialog = /** @class */ (function (_super) {
	    __extends(AgDialog, _super);
	    function AgDialog(config) {
	        var _this = _super.call(this, config) || this;
	        _this.RESIZE_TEMPLATE = "\n        <div class=\"ag-resizer-wrapper\">\n            <div ref=\"eTopLeftResizer\" class=\"ag-resizer ag-resizer-topLeft\"></div>\n            <div ref=\"eTopResizer\" class=\"ag-resizer ag-resizer-top\"></div>\n            <div ref=\"eTopRightResizer\" class=\"ag-resizer ag-resizer-topRight\"></div>\n            <div ref=\"eRightResizer\" class=\"ag-resizer ag-resizer-right\"></div>\n            <div ref=\"eBottomRightResizer\" class=\"ag-resizer ag-resizer-bottomRight\"></div>\n            <div ref=\"eBottomResizer\" class=\"ag-resizer ag-resizer-bottom\"></div>\n            <div ref=\"eBottomLeftResizer\" class=\"ag-resizer ag-resizer-bottomLeft\"></div>\n            <div ref=\"eLeftResizer\" class=\"ag-resizer ag-resizer-left\"></div>\n        </div>\n    ";
	        _this.MAXIMIZE_BTN_TEMPLATE = "<div class=\"ag-dialog-button\"></span>";
	        _this.resizable = {};
	        _this.isResizable = false;
	        _this.movable = false;
	        _this.isMoving = false;
	        _this.isMaximizable = false;
	        _this.isMaximized = false;
	        _this.maximizeListeners = [];
	        _this.resizeListenerDestroy = null;
	        _this.isResizing = false;
	        _this.lastPosition = {
	            x: 0,
	            y: 0,
	            width: 0,
	            height: 0
	        };
	        return _this;
	    }
	    AgDialog.prototype.postConstruct = function () {
	        var _this = this;
	        var eGui = this.getGui();
	        var _a = this.config, movable = _a.movable, resizable = _a.resizable, maximizable = _a.maximizable;
	        utils_1._.addCssClass(eGui, 'ag-dialog');
	        this.moveElement = this.eTitleBar;
	        _super.prototype.postConstruct.call(this);
	        this.addDestroyableEventListener(eGui, 'focusin', function (e) {
	            if (eGui.contains(e.relatedTarget)) {
	                return;
	            }
	            _this.popupService.bringPopupToFront(eGui);
	        });
	        if (movable) {
	            this.setMovable(movable);
	        }
	        if (maximizable) {
	            this.setMaximizable(maximizable);
	        }
	        this.addResizers();
	        if (resizable) {
	            this.setResizable(resizable);
	        }
	    };
	    AgDialog.prototype.renderComponent = function () {
	        var eGui = this.getGui();
	        var _a = this.config, alwaysOnTop = _a.alwaysOnTop, modal = _a.modal;
	        this.close = this.popupService.addPopup(modal, eGui, true, this.destroy.bind(this), undefined, alwaysOnTop);
	        eGui.focus();
	    };
	    AgDialog.prototype.addResizers = function () {
	        var eGui = this.getGui();
	        if (!eGui) {
	            return;
	        }
	        var parser = new DOMParser();
	        var resizers = parser.parseFromString(this.RESIZE_TEMPLATE, 'text/html').body;
	        eGui.appendChild(resizers.firstChild);
	        this.createMap();
	    };
	    AgDialog.prototype.createMap = function () {
	        var eGui = this.getGui();
	        this.resizerMap = {
	            topLeft: { element: eGui.querySelector('[ref=eTopLeftResizer]') },
	            top: { element: eGui.querySelector('[ref=eTopResizer]') },
	            topRight: { element: eGui.querySelector('[ref=eTopRightResizer]') },
	            right: { element: eGui.querySelector('[ref=eRightResizer]') },
	            bottomRight: { element: eGui.querySelector('[ref=eBottomRightResizer]') },
	            bottom: { element: eGui.querySelector('[ref=eBottomResizer]') },
	            bottomLeft: { element: eGui.querySelector('[ref=eBottomLeftResizer]') },
	            left: { element: eGui.querySelector('[ref=eLeftResizer]') }
	        };
	    };
	    AgDialog.prototype.getResizerElement = function (side) {
	        return this.resizerMap[side].element;
	    };
	    AgDialog.prototype.onResizeStart = function (e) {
	        this.isResizing = true;
	        this.updateDragStartPosition(e.clientX, e.clientY);
	    };
	    AgDialog.prototype.onResize = function (e, side) {
	        if (!this.isResizing) {
	            return;
	        }
	        var isLeft = !!side.match(/left/i);
	        var isRight = !!side.match(/right/i);
	        var isTop = !!side.match(/top/i);
	        var isBottom = !!side.match(/bottom/i);
	        var isHorizontal = isLeft || isRight;
	        var isVertical = isTop || isBottom;
	        var _a = this.calculateMouseMovement({ e: e, isLeft: isLeft, isTop: isTop }), movementX = _a.movementX, movementY = _a.movementY;
	        var offsetLeft = 0;
	        var offsetTop = 0;
	        if (isHorizontal && movementX) {
	            var direction = isLeft ? -1 : 1;
	            var oldWidth = this.getWidth();
	            var newWidth = oldWidth + (movementX * direction);
	            var skipWidth = false;
	            if (isLeft) {
	                offsetLeft = oldWidth - newWidth;
	                if (this.position.x + offsetLeft <= 0 || newWidth <= this.minWidth) {
	                    skipWidth = true;
	                    offsetLeft = 0;
	                }
	            }
	            if (!skipWidth) {
	                this.setWidth(newWidth);
	            }
	        }
	        if (isVertical && movementY) {
	            var direction = isTop ? -1 : 1;
	            var oldHeight = this.getHeight();
	            var newHeight = oldHeight + (movementY * direction);
	            var skipHeight = false;
	            if (isTop) {
	                offsetTop = oldHeight - newHeight;
	                if (this.position.y + offsetTop <= 0 || newHeight <= this.minHeight) {
	                    skipHeight = true;
	                    offsetTop = 0;
	                }
	            }
	            if (!skipHeight) {
	                this.setHeight(newHeight);
	            }
	        }
	        this.updateDragStartPosition(e.clientX, e.clientY);
	        if (offsetLeft || offsetTop) {
	            this.offsetElement(this.position.x + offsetLeft, this.position.y + offsetTop);
	        }
	    };
	    AgDialog.prototype.onResizeEnd = function () {
	        this.isResizing = false;
	        var params = {
	            type: 'resize',
	            api: this.gridOptionsWrapper.getApi(),
	            columnApi: this.gridOptionsWrapper.getColumnApi()
	        };
	        if (this.localEventService) {
	            this.localEventService.dispatchEvent(params);
	        }
	    };
	    AgDialog.prototype.onMoveStart = function (e) {
	        this.isMoving = true;
	        this.updateDragStartPosition(e.clientX, e.clientY);
	    };
	    AgDialog.prototype.onMove = function (e) {
	        if (!this.isMoving) {
	            return;
	        }
	        var _a = this.position, x = _a.x, y = _a.y;
	        var _b = this.calculateMouseMovement({
	            e: e,
	            isTop: true,
	            anywhereWithin: true,
	            topBuffer: this.getHeight() - this.getBodyHeight()
	        }), movementX = _b.movementX, movementY = _b.movementY;
	        this.offsetElement(x + movementX, y + movementY);
	        this.updateDragStartPosition(e.clientX, e.clientY);
	    };
	    AgDialog.prototype.onMoveEnd = function () {
	        this.isMoving = false;
	    };
	    AgDialog.prototype.toggleMaximize = function () {
	        if (this.isMaximized) {
	            var _a = this.lastPosition, x = _a.x, y = _a.y, width = _a.width, height = _a.height;
	            this.setWidth(width);
	            this.setHeight(height);
	            this.offsetElement(x, y);
	        }
	        else {
	            this.lastPosition.width = this.getWidth();
	            this.lastPosition.height = this.getHeight();
	            this.lastPosition.x = this.position.x;
	            this.lastPosition.y = this.position.y;
	            this.offsetElement(0, 0);
	            this.setHeight('100%');
	            this.setWidth('100%');
	        }
	        this.isMaximized = !this.isMaximized;
	        this.refreshMaximizeIcon();
	    };
	    AgDialog.prototype.refreshMaximizeIcon = function () {
	        utils_1._.addOrRemoveCssClass(this.maximizeIcon, 'ag-hidden', this.isMaximized);
	        utils_1._.addOrRemoveCssClass(this.minimizeIcon, 'ag-hidden', !this.isMaximized);
	    };
	    AgDialog.prototype.clearMaximizebleListeners = function () {
	        if (this.maximizeListeners.length) {
	            this.maximizeListeners.forEach(function (destroyListener) { return destroyListener(); });
	            this.maximizeListeners.length = 0;
	        }
	        if (this.resizeListenerDestroy) {
	            this.resizeListenerDestroy();
	            this.resizeListenerDestroy = null;
	        }
	    };
	    AgDialog.prototype.destroy = function () {
	        _super.prototype.destroy.call(this);
	        this.setResizable(false);
	        this.setMovable(false);
	        if (this.maximizeButtonComp) {
	            this.maximizeButtonComp.destroy();
	            this.maximizeButtonComp = undefined;
	        }
	        this.clearMaximizebleListeners();
	    };
	    AgDialog.prototype.setResizable = function (resizable) {
	        var _this = this;
	        var isResizable = false;
	        if (typeof resizable === 'boolean') {
	            resizable = {
	                topLeft: resizable,
	                top: resizable,
	                topRight: resizable,
	                right: resizable,
	                bottomRight: resizable,
	                bottom: resizable,
	                bottomLeft: resizable,
	                left: resizable
	            };
	        }
	        Object.keys(resizable).forEach(function (side) {
	            var r = resizable;
	            var s = side;
	            var val = !!r[s];
	            var el = _this.getResizerElement(s);
	            var params = _this.resizerMap[s].dragSource || {
	                eElement: el,
	                onDragStart: _this.onResizeStart.bind(_this),
	                onDragging: function (e) { return _this.onResize(e, s); },
	                onDragStop: _this.onResizeEnd.bind(_this),
	            };
	            if (!!_this.resizable[s] !== val || (!_this.isAlive() && !val)) {
	                if (val) {
	                    _this.dragService.addDragSource(params);
	                    el.style.pointerEvents = 'all';
	                    isResizable = true;
	                }
	                else {
	                    _this.dragService.removeDragSource(params);
	                    el.style.pointerEvents = 'none';
	                }
	                _this.resizerMap[s].dragSource = val ? params : undefined;
	            }
	        });
	        this.isResizable = isResizable;
	    };
	    AgDialog.prototype.setMovable = function (movable) {
	        if (movable !== this.movable) {
	            this.movable = movable;
	            var params = this.moveElementDragListener || {
	                eElement: this.moveElement,
	                onDragStart: this.onMoveStart.bind(this),
	                onDragging: this.onMove.bind(this),
	                onDragStop: this.onMoveEnd.bind(this)
	            };
	            if (movable) {
	                this.dragService.addDragSource(params);
	                this.moveElementDragListener = params;
	            }
	            else {
	                this.dragService.removeDragSource(params);
	                this.moveElementDragListener = undefined;
	            }
	        }
	    };
	    AgDialog.prototype.setMaximizable = function (maximizable) {
	        var _this = this;
	        if (maximizable === false) {
	            this.clearMaximizebleListeners();
	            if (this.maximizeButtonComp) {
	                this.maximizeButtonComp.destroy();
	                this.maximizeButtonComp = this.maximizeIcon = this.minimizeIcon = undefined;
	            }
	            return;
	        }
	        var eTitleBar = this.eTitleBar;
	        if (!eTitleBar || maximizable === this.isMaximizable) {
	            return;
	        }
	        var maximizeButtonComp = this.maximizeButtonComp = new component_1.Component(this.MAXIMIZE_BTN_TEMPLATE);
	        this.getContext().wireBean(maximizeButtonComp);
	        var eGui = maximizeButtonComp.getGui();
	        eGui.appendChild(this.maximizeIcon = utils_1._.createIconNoSpan('maximize', this.gridOptionsWrapper));
	        eGui.appendChild(this.minimizeIcon = utils_1._.createIconNoSpan('minimize', this.gridOptionsWrapper));
	        utils_1._.addCssClass(this.minimizeIcon, 'ag-hidden');
	        maximizeButtonComp.addDestroyableEventListener(eGui, 'click', this.toggleMaximize.bind(this));
	        this.addTitleBarButton(maximizeButtonComp, 0);
	        this.maximizeListeners.push(this.addDestroyableEventListener(eTitleBar, 'dblclick', this.toggleMaximize.bind(this)));
	        this.resizeListenerDestroy = this.addDestroyableEventListener(this, 'resize', function () {
	            _this.isMaximized = false;
	            _this.refreshMaximizeIcon();
	        });
	    };
	    __decorate([
	        context_1.Autowired('dragService'),
	        __metadata("design:type", dragService_1.DragService)
	    ], AgDialog.prototype, "dragService", void 0);
	    return AgDialog;
	}(agPanel_1.AgPanel));
	exports.AgDialog = AgDialog;


/***/ }),
/* 2487 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var componentAnnotations_1 = __webpack_require__(2384);
	var context_1 = __webpack_require__(2333);
	var component_1 = __webpack_require__(2353);
	var popupService_1 = __webpack_require__(2379);
	var gridOptionsWrapper_1 = __webpack_require__(2324);
	var utils_1 = __webpack_require__(2325);
	var AgPanel = /** @class */ (function (_super) {
	    __extends(AgPanel, _super);
	    function AgPanel(config) {
	        var _this = _super.call(this, AgPanel.TEMPLATE) || this;
	        _this.closable = true;
	        _this.positioned = false;
	        _this.dragStartPosition = {
	            x: 0,
	            y: 0
	        };
	        _this.position = {
	            x: 0,
	            y: 0
	        };
	        _this.size = {
	            width: undefined,
	            height: undefined
	        };
	        _this.config = config;
	        return _this;
	    }
	    AgPanel.prototype.postConstruct = function () {
	        var _this = this;
	        var _a = this.config, component = _a.component, closable = _a.closable, hideTitleBar = _a.hideTitleBar, title = _a.title, minWidth = _a.minWidth, width = _a.width, minHeight = _a.minHeight, height = _a.height, centered = _a.centered, x = _a.x, y = _a.y;
	        var eGui = this.getGui();
	        if (component) {
	            this.setBodyComponent(component);
	        }
	        if (!hideTitleBar) {
	            if (title) {
	                this.setTitle(title);
	            }
	            this.setClosable(closable != null ? closable : this.closable);
	        }
	        else {
	            utils_1._.addCssClass(this.eTitleBar, 'ag-hidden');
	        }
	        this.addDestroyableEventListener(this.eTitleBar, 'mousedown', function (e) {
	            if (eGui.contains(e.relatedTarget) ||
	                eGui.contains(document.activeElement) ||
	                _this.eTitleBarButtons.contains(e.target)) {
	                e.preventDefault();
	                return;
	            }
	            var focusEl = _this.eContentWrapper.querySelector('button, [href], input, select, textarea, [tabindex]');
	            if (focusEl) {
	                focusEl.focus();
	            }
	        });
	        if (this.positioned) {
	            return;
	        }
	        this.minHeight = minHeight != null ? minHeight : 250;
	        this.minWidth = minWidth != null ? minWidth : 250;
	        this.popupParent = this.popupService.getPopupParent();
	        if (width) {
	            this.setWidth(width);
	        }
	        if (height) {
	            this.setHeight(height);
	        }
	        if (this.renderComponent) {
	            this.renderComponent();
	        }
	        if (!width || !height) {
	            this.refreshSize();
	        }
	        if (centered) {
	            this.center();
	        }
	        else if (x || y) {
	            this.offsetElement(x, y);
	        }
	        this.positioned = true;
	        this.eContentWrapper.style.height = '0';
	    };
	    AgPanel.prototype.renderComponent = function () {
	        var _this = this;
	        var eGui = this.getGui();
	        eGui.focus();
	        this.close = function () {
	            eGui.parentElement.removeChild(eGui);
	            _this.destroy();
	        };
	    };
	    AgPanel.prototype.updateDragStartPosition = function (x, y) {
	        this.dragStartPosition = { x: x, y: y };
	    };
	    AgPanel.prototype.calculateMouseMovement = function (params) {
	        var parentRect = this.popupParent.getBoundingClientRect();
	        var e = params.e, isLeft = params.isLeft, isTop = params.isTop, anywhereWithin = params.anywhereWithin, topBuffer = params.topBuffer;
	        var movementX = e.clientX - this.dragStartPosition.x;
	        var movementY = e.clientY - this.dragStartPosition.y;
	        var width = this.getWidth();
	        var height = this.getHeight();
	        // skip if cursor is outside of popupParent horizontally
	        var skipX = (parentRect.left >= e.clientX && this.position.x <= 0 ||
	            parentRect.right <= e.clientX && parentRect.right <= this.position.x + parentRect.left + width);
	        if (!skipX) {
	            if (isLeft) {
	                skipX = (
	                // skip if we are moving to the left and the cursor
	                // is positioned to the right of the left side anchor
	                (movementX < 0 && e.clientX > this.position.x + parentRect.left) ||
	                    // skip if we are moving to the right and the cursor
	                    // is positioned to the left of the dialog
	                    (movementX > 0 && e.clientX < this.position.x + parentRect.left));
	            }
	            else {
	                if (anywhereWithin) {
	                    // if anywhereWithin is true, we allow to move
	                    // as long as the cursor is within the dialog
	                    skipX = ((movementX < 0 && e.clientX > this.position.x + parentRect.left + width) ||
	                        (movementX > 0 && e.clientX < this.position.x + parentRect.left));
	                }
	                else {
	                    skipX = (
	                    // if the movement is bound to the right side of the dialog
	                    // we skip if we are moving to the left and the cursor
	                    // is to the right of the dialog
	                    (movementX < 0 && e.clientX > this.position.x + parentRect.left + width) ||
	                        // or skip if we are moving to the right and the cursor
	                        // is to the left of the right side anchor
	                        (movementX > 0 && e.clientX < this.position.x + parentRect.left + width));
	                }
	            }
	        }
	        movementX = skipX ? 0 : movementX;
	        var skipY = (
	        // skip if cursor is outside of popupParent vertically
	        parentRect.top >= e.clientY && this.position.y <= 0 ||
	            parentRect.bottom <= e.clientY && parentRect.bottom <= this.position.y + parentRect.top + height ||
	            isTop && (
	            // skip if we are moving to towards top and the cursor is
	            // below the top anchor + topBuffer
	            // note: topBuffer is used when moving the dialog using the title bar
	            (movementY < 0 && e.clientY > this.position.y + parentRect.top + (topBuffer || 0)) ||
	                // skip if we are moving to the bottom and the cursor is
	                // above the top anchor
	                (movementY > 0 && e.clientY < this.position.y + parentRect.top)) ||
	            // we are anchored to the bottom of the dialog
	            !isTop && (
	            // skip if we are moving towards the top and the cursor
	            // is below the bottom anchor
	            (movementY < 0 && e.clientY > this.position.y + parentRect.top + height) ||
	                // skip if we are moving towards the bottom and the cursor
	                // is above the bottom anchor
	                (movementY > 0 && e.clientY < this.position.y + parentRect.top + height)));
	        movementY = skipY ? 0 : movementY;
	        return { movementX: movementX, movementY: movementY };
	    };
	    AgPanel.prototype.refreshSize = function () {
	        var _a = this.size, width = _a.width, height = _a.height;
	        if (!width) {
	            this.setWidth(this.getGui().offsetWidth);
	        }
	        if (!height) {
	            this.setHeight(this.getGui().offsetHeight);
	        }
	    };
	    AgPanel.prototype.offsetElement = function (x, y) {
	        if (x === void 0) { x = 0; }
	        if (y === void 0) { y = 0; }
	        var ePopup = this.getGui();
	        this.popupService.positionPopup({
	            ePopup: ePopup,
	            x: x,
	            y: y,
	            minWidth: this.minWidth,
	            minHeight: this.minHeight,
	            keepWithinBounds: true
	        });
	        this.position.x = parseInt(ePopup.style.left, 10);
	        this.position.y = parseInt(ePopup.style.top, 10);
	    };
	    AgPanel.prototype.getHeight = function () {
	        return this.size.height;
	    };
	    AgPanel.prototype.setHeight = function (height) {
	        var eGui = this.getGui();
	        var isPercent = false;
	        if (typeof height === 'string' && height.indexOf('%') !== -1) {
	            utils_1._.setFixedHeight(eGui, height);
	            height = utils_1._.getAbsoluteHeight(eGui);
	            isPercent = true;
	        }
	        else {
	            height = Math.max(this.minHeight, height);
	            var offsetParent = eGui.offsetParent;
	            if (offsetParent && offsetParent.clientHeight && (height + this.position.y > offsetParent.clientHeight)) {
	                height = offsetParent.clientHeight - this.position.y;
	            }
	        }
	        if (this.size.height === height) {
	            return;
	        }
	        this.size.height = height;
	        if (!isPercent) {
	            utils_1._.setFixedHeight(eGui, height);
	        }
	        else {
	            eGui.style.maxHeight = 'unset';
	            eGui.style.minHeight = 'unset';
	        }
	    };
	    AgPanel.prototype.getWidth = function () {
	        return this.size.width;
	    };
	    AgPanel.prototype.setWidth = function (width) {
	        var eGui = this.getGui();
	        var isPercent = false;
	        if (typeof width === 'string' && width.indexOf('%') !== -1) {
	            utils_1._.setFixedWidth(eGui, width);
	            width = utils_1._.getAbsoluteWidth(eGui);
	            isPercent = true;
	        }
	        else {
	            width = Math.max(this.minWidth, width);
	            var offsetParent = eGui.offsetParent;
	            if (offsetParent && offsetParent.clientWidth && (width + this.position.x > offsetParent.clientWidth)) {
	                width = offsetParent.clientWidth - this.position.x;
	            }
	        }
	        if (this.size.width === width) {
	            return;
	        }
	        this.size.width = width;
	        if (!isPercent) {
	            utils_1._.setFixedWidth(eGui, width);
	        }
	        else {
	            eGui.style.maxWidth = 'unset';
	            eGui.style.minWidth = 'unset';
	        }
	    };
	    AgPanel.prototype.center = function () {
	        var eGui = this.getGui();
	        var x = (eGui.offsetParent.clientWidth / 2) - (this.getWidth() / 2);
	        var y = (eGui.offsetParent.clientHeight / 2) - (this.getHeight() / 2);
	        this.offsetElement(x, y);
	    };
	    AgPanel.prototype.setClosable = function (closable) {
	        if (closable !== this.closable) {
	            this.closable = closable;
	        }
	        if (closable) {
	            var closeButtonComp = this.closeButtonComp = new component_1.Component(AgPanel.CLOSE_BTN_TEMPLATE);
	            this.getContext().wireBean(closeButtonComp);
	            var eGui = closeButtonComp.getGui();
	            eGui.appendChild(utils_1._.createIconNoSpan('close', this.gridOptionsWrapper));
	            this.addTitleBarButton(closeButtonComp);
	            closeButtonComp.addDestroyableEventListener(eGui, 'click', this.onBtClose.bind(this));
	        }
	        else if (this.closeButtonComp) {
	            var eGui = this.closeButtonComp.getGui();
	            eGui.parentElement.removeChild(eGui);
	            this.closeButtonComp.destroy();
	            this.closeButtonComp = undefined;
	        }
	    };
	    AgPanel.prototype.setBodyComponent = function (bodyComponent) {
	        bodyComponent.setParentComponent(this);
	        this.eContentWrapper.appendChild(bodyComponent.getGui());
	    };
	    AgPanel.prototype.addTitleBarButton = function (button, position) {
	        var eTitleBarButtons = this.eTitleBarButtons;
	        var buttons = eTitleBarButtons.children;
	        var len = buttons.length;
	        if (position == null) {
	            position = len;
	        }
	        position = Math.max(0, Math.min(position, len));
	        var eGui = button.getGui();
	        utils_1._.addCssClass(eGui, 'ag-button');
	        if (position === 0) {
	            eTitleBarButtons.insertAdjacentElement('afterbegin', eGui);
	        }
	        else if (position === len) {
	            eTitleBarButtons.insertAdjacentElement('beforeend', eGui);
	        }
	        else {
	            buttons[position - 1].insertAdjacentElement('afterend', eGui);
	        }
	        button.setParentComponent(this);
	    };
	    AgPanel.prototype.getBodyHeight = function () {
	        return utils_1._.getInnerHeight(this.eContentWrapper);
	    };
	    AgPanel.prototype.getBodyWidth = function () {
	        return utils_1._.getInnerWidth(this.eContentWrapper);
	    };
	    AgPanel.prototype.setTitle = function (title) {
	        this.eTitle.innerText = title;
	    };
	    // called when user hits the 'x' in the top right
	    AgPanel.prototype.onBtClose = function () {
	        this.close();
	    };
	    AgPanel.prototype.destroy = function () {
	        _super.prototype.destroy.call(this);
	        if (this.closeButtonComp) {
	            this.closeButtonComp.destroy();
	            this.closeButtonComp = undefined;
	        }
	        var eGui = this.getGui();
	        if (eGui && eGui.offsetParent) {
	            this.close();
	        }
	    };
	    AgPanel.TEMPLATE = "<div class=\"ag-panel\" tabindex=\"-1\">\n            <div ref=\"eTitleBar\" class=\"ag-title-bar ag-unselectable\">\n                <span ref=\"eTitle\" class=\"ag-title-bar-title\"></span>\n                <div ref=\"eTitleBarButtons\" class=\"ag-title-bar-buttons\"></div>\n            </div>\n            <div ref=\"eContentWrapper\" class=\"ag-panel-content-wrapper\"></div>\n        </div>";
	    AgPanel.CLOSE_BTN_TEMPLATE = "<div class=\"ag-button\"></div>";
	    __decorate([
	        context_1.Autowired('popupService'),
	        __metadata("design:type", popupService_1.PopupService)
	    ], AgPanel.prototype, "popupService", void 0);
	    __decorate([
	        context_1.Autowired('gridOptionsWrapper'),
	        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
	    ], AgPanel.prototype, "gridOptionsWrapper", void 0);
	    __decorate([
	        componentAnnotations_1.RefSelector('eContentWrapper'),
	        __metadata("design:type", HTMLElement)
	    ], AgPanel.prototype, "eContentWrapper", void 0);
	    __decorate([
	        componentAnnotations_1.RefSelector('eTitleBar'),
	        __metadata("design:type", HTMLElement)
	    ], AgPanel.prototype, "eTitleBar", void 0);
	    __decorate([
	        componentAnnotations_1.RefSelector('eTitleBarButtons'),
	        __metadata("design:type", HTMLElement)
	    ], AgPanel.prototype, "eTitleBarButtons", void 0);
	    __decorate([
	        componentAnnotations_1.RefSelector('eTitle'),
	        __metadata("design:type", HTMLElement)
	    ], AgPanel.prototype, "eTitle", void 0);
	    __decorate([
	        context_1.PostConstruct,
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", []),
	        __metadata("design:returntype", void 0)
	    ], AgPanel.prototype, "postConstruct", null);
	    return AgPanel;
	}(component_1.Component));
	exports.AgPanel = AgPanel;


/***/ }),
/* 2488 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var agAbstractInputField_1 = __webpack_require__(2429);
	var AgInputTextField = /** @class */ (function (_super) {
	    __extends(AgInputTextField, _super);
	    function AgInputTextField(config) {
	        var _this = _super.call(this) || this;
	        _this.className = 'ag-text-field';
	        _this.displayTag = 'input';
	        _this.inputType = 'text';
	        _this.setTemplate(_this.TEMPLATE.replace(/%displayField%/g, _this.displayTag));
	        if (config) {
	            _this.config = config;
	        }
	        return _this;
	    }
	    AgInputTextField.prototype.setValue = function (value, silent) {
	        var ret = _super.prototype.setValue.call(this, value, silent);
	        if (this.eInput.value !== value) {
	            this.eInput.value = value;
	        }
	        return ret;
	    };
	    return AgInputTextField;
	}(agAbstractInputField_1.AgAbstractInputField));
	exports.AgInputTextField = AgInputTextField;


/***/ }),
/* 2489 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var agAbstractInputField_1 = __webpack_require__(2429);
	var AgInputTextArea = /** @class */ (function (_super) {
	    __extends(AgInputTextArea, _super);
	    function AgInputTextArea(config) {
	        var _this = _super.call(this) || this;
	        _this.className = 'ag-text-area';
	        _this.displayTag = 'textarea';
	        _this.inputType = '';
	        _this.setTemplate(_this.TEMPLATE.replace(/%displayField%/g, _this.displayTag));
	        if (config) {
	            _this.config = config;
	        }
	        return _this;
	    }
	    AgInputTextArea.prototype.setValue = function (value, silent) {
	        var ret = _super.prototype.setValue.call(this, value, silent);
	        this.eInput.value = value;
	        return ret;
	    };
	    return AgInputTextArea;
	}(agAbstractInputField_1.AgAbstractInputField));
	exports.AgInputTextArea = AgInputTextArea;


/***/ }),
/* 2490 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var componentAnnotations_1 = __webpack_require__(2384);
	var agInputRange_1 = __webpack_require__(2491);
	var agAbstractLabel_1 = __webpack_require__(2431);
	var agInputNumberField_1 = __webpack_require__(2492);
	var agAbstractField_1 = __webpack_require__(2430);
	var AgSlider = /** @class */ (function (_super) {
	    __extends(AgSlider, _super);
	    function AgSlider() {
	        var _this = _super.call(this, AgSlider.TEMPLATE) || this;
	        _this.labelAlignment = 'top';
	        return _this;
	    }
	    AgSlider.prototype.postConstruct = function () {
	        _super.prototype.postConstruct.call(this);
	        this.setMinValue(0);
	    };
	    AgSlider.prototype.onValueChange = function (callbackFn) {
	        var _this = this;
	        var eventChanged = agAbstractField_1.AgAbstractField.EVENT_CHANGED;
	        this.addDestroyableEventListener(this.eText, eventChanged, function () {
	            var textValue = parseFloat(_this.eText.getValue());
	            _this.eSlider.setValue(textValue.toString(), true);
	            callbackFn(textValue || 0);
	        });
	        this.addDestroyableEventListener(this.eSlider, eventChanged, function () {
	            var sliderValue = _this.eSlider.getValue();
	            _this.eText.setValue(sliderValue, true);
	            callbackFn(parseFloat(sliderValue));
	        });
	        return this;
	    };
	    AgSlider.prototype.setSliderWidth = function (width) {
	        this.eSlider.setWidth(width);
	        return this;
	    };
	    AgSlider.prototype.setTextFieldWidth = function (width) {
	        this.eText.setWidth(width);
	        return this;
	    };
	    AgSlider.prototype.setMinValue = function (minValue) {
	        this.eSlider.setMinValue(minValue);
	        this.eText.setMin(minValue);
	        return this;
	    };
	    AgSlider.prototype.setMaxValue = function (maxValue) {
	        this.eSlider.setMaxValue(maxValue);
	        this.eText.setMax(maxValue);
	        return this;
	    };
	    AgSlider.prototype.getValue = function () {
	        return this.eText.getValue();
	    };
	    AgSlider.prototype.setValue = function (value) {
	        if (this.getValue() === value) {
	            return this;
	        }
	        this.eText.setValue(value, true);
	        this.eSlider.setValue(value, true);
	        this.dispatchEvent({ type: agAbstractField_1.AgAbstractField.EVENT_CHANGED });
	        return this;
	    };
	    AgSlider.prototype.setStep = function (step) {
	        this.eSlider.setStep(step);
	        this.eText.setStep(step);
	        return this;
	    };
	    AgSlider.TEMPLATE = "<div class=\"ag-slider\">\n            <label ref=\"eLabel\"></label>\n            <div class=\"ag-wrapper\">\n                <ag-input-range ref=\"eSlider\"></ag-input-range>\n                <ag-input-number-field ref=\"eText\"></ag-input-number-field>\n            </div>\n        </div>";
	    __decorate([
	        componentAnnotations_1.RefSelector('eLabel'),
	        __metadata("design:type", HTMLElement)
	    ], AgSlider.prototype, "eLabel", void 0);
	    __decorate([
	        componentAnnotations_1.RefSelector('eSlider'),
	        __metadata("design:type", agInputRange_1.AgInputRange)
	    ], AgSlider.prototype, "eSlider", void 0);
	    __decorate([
	        componentAnnotations_1.RefSelector('eText'),
	        __metadata("design:type", agInputNumberField_1.AgInputNumberField)
	    ], AgSlider.prototype, "eText", void 0);
	    return AgSlider;
	}(agAbstractLabel_1.AgAbstractLabel));
	exports.AgSlider = AgSlider;


/***/ }),
/* 2491 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var agAbstractInputField_1 = __webpack_require__(2429);
	var utils_1 = __webpack_require__(2325);
	var AgInputRange = /** @class */ (function (_super) {
	    __extends(AgInputRange, _super);
	    function AgInputRange(config) {
	        var _this = _super.call(this) || this;
	        _this.className = 'ag-range-field';
	        _this.displayTag = 'input';
	        _this.inputType = 'range';
	        _this.setTemplate(_this.TEMPLATE.replace(/%displayField%/g, _this.displayTag));
	        if (config) {
	            _this.config = config;
	        }
	        return _this;
	    }
	    AgInputRange.prototype.postConstruct = function () {
	        _super.prototype.postConstruct.call(this);
	        var _a = this.config, min = _a.min, max = _a.max, step = _a.step;
	        if (min != null) {
	            this.setMinValue(min);
	        }
	        if (max != null) {
	            this.setMaxValue(max);
	        }
	        this.setStep(step || 1);
	    };
	    AgInputRange.prototype.addInputListeners = function () {
	        var _this = this;
	        var isIE = utils_1._.isBrowserIE();
	        var eventName = isIE ? 'change' : 'input';
	        this.addDestroyableEventListener(this.eInput, eventName, function (e) {
	            var value = e.target.value;
	            _this.setValue(value);
	        });
	    };
	    AgInputRange.prototype.setMinValue = function (value) {
	        this.min = value;
	        this.eInput.setAttribute('min', value.toString());
	        return this;
	    };
	    AgInputRange.prototype.setMaxValue = function (value) {
	        this.max = value;
	        this.eInput.setAttribute('max', value.toString());
	        return this;
	    };
	    AgInputRange.prototype.setStep = function (value) {
	        this.step = value;
	        this.eInput.setAttribute('step', value.toString());
	        return this;
	    };
	    AgInputRange.prototype.setValue = function (value, silent) {
	        if (this.min != null) {
	            value = Math.max(parseFloat(value), this.min).toString();
	        }
	        if (this.max != null) {
	            value = Math.min(parseFloat(value), this.max).toString();
	        }
	        var ret = _super.prototype.setValue.call(this, value, silent);
	        this.eInput.value = value;
	        return ret;
	    };
	    return AgInputRange;
	}(agAbstractInputField_1.AgAbstractInputField));
	exports.AgInputRange = AgInputRange;


/***/ }),
/* 2492 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var agInputTextField_1 = __webpack_require__(2488);
	var AgInputNumberField = /** @class */ (function (_super) {
	    __extends(AgInputNumberField, _super);
	    function AgInputNumberField() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.className = 'ag-number-field';
	        _this.inputType = 'number';
	        return _this;
	    }
	    AgInputNumberField.prototype.postConstruct = function () {
	        var _this = this;
	        _super.prototype.postConstruct.call(this);
	        this.addDestroyableEventListener(this.eInput, 'blur', function () {
	            var value = _this.normalizeValue(_this.eInput.value);
	            if (_this.value !== value) {
	                _this.setValue(value);
	            }
	        });
	    };
	    AgInputNumberField.prototype.normalizeValue = function (value) {
	        if (value === '') {
	            return '';
	        }
	        if (this.precision) {
	            value = this.adjustPrecision(value);
	        }
	        var val = parseFloat(value);
	        if (this.min != null && val < this.min) {
	            value = this.min.toString();
	        }
	        else if (this.max != null && val > this.max) {
	            value = this.max.toString();
	        }
	        return value;
	    };
	    AgInputNumberField.prototype.adjustPrecision = function (value) {
	        if (this.precision) {
	            var floatString = parseFloat(value).toFixed(this.precision);
	            value = parseFloat(floatString).toString();
	        }
	        return value;
	    };
	    AgInputNumberField.prototype.setMin = function (min) {
	        if (this.min === min) {
	            return this;
	        }
	        this.min = min;
	        if (this.min != null) {
	            this.eInput.setAttribute('min', min.toString());
	        }
	        else {
	            this.eInput.removeAttribute('min');
	        }
	        return this;
	    };
	    AgInputNumberField.prototype.setMax = function (max) {
	        if (this.max === max) {
	            return this;
	        }
	        this.max = max;
	        if (this.max != null) {
	            this.eInput.setAttribute('max', max.toString());
	        }
	        else {
	            this.eInput.removeAttribute('max');
	        }
	        return this;
	    };
	    AgInputNumberField.prototype.setPrecision = function (precision) {
	        this.precision = precision;
	        return this;
	    };
	    AgInputNumberField.prototype.setStep = function (step) {
	        if (this.step === step) {
	            return this;
	        }
	        this.step = step;
	        if (step != null) {
	            this.eInput.setAttribute('step', step.toString());
	        }
	        else {
	            this.eInput.removeAttribute('step');
	        }
	        return this;
	    };
	    AgInputNumberField.prototype.setValue = function (value, silent) {
	        value = this.adjustPrecision(value);
	        var normalizedValue = this.normalizeValue(value);
	        if (value != normalizedValue) {
	            return this;
	        }
	        return _super.prototype.setValue.call(this, value, silent);
	    };
	    return AgInputNumberField;
	}(agInputTextField_1.AgInputTextField));
	exports.AgInputNumberField = AgInputNumberField;


/***/ }),
/* 2493 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var agColorPanel_1 = __webpack_require__(2494);
	var agDialog_1 = __webpack_require__(2486);
	var agPickerField_1 = __webpack_require__(2495);
	var agAbstractField_1 = __webpack_require__(2430);
	var utils_1 = __webpack_require__(2325);
	var AgColorPicker = /** @class */ (function (_super) {
	    __extends(AgColorPicker, _super);
	    function AgColorPicker(config) {
	        var _this = _super.call(this) || this;
	        _this.displayTag = 'div';
	        _this.className = 'ag-color-picker';
	        _this.pickerIcon = 'colorPicker';
	        _this.setTemplate(_this.TEMPLATE.replace(/%displayField%/g, _this.displayTag));
	        if (config && config.color) {
	            _this.value = config.color;
	        }
	        return _this;
	    }
	    AgColorPicker.prototype.postConstruct = function () {
	        var _this = this;
	        _super.prototype.postConstruct.call(this);
	        utils_1._.addCssClass(this.getGui(), this.className);
	        this.addDestroyableEventListener(this.eDisplayField, 'click', function () { return _this.showPicker(); });
	        if (this.value) {
	            this.setValue(this.value);
	        }
	    };
	    AgColorPicker.prototype.showPicker = function () {
	        var _this = this;
	        if (this.displayedPicker) {
	            this.displayedPicker = false;
	            return;
	        }
	        var eGuiRect = this.getGui().getBoundingClientRect();
	        var colorDialog = new agDialog_1.AgDialog({
	            closable: false,
	            modal: true,
	            hideTitleBar: true,
	            minWidth: 190,
	            width: 190,
	            height: 250,
	            x: eGuiRect.right - 190,
	            y: eGuiRect.top - 250
	        });
	        this.getContext().wireBean(colorDialog);
	        utils_1._.addCssClass(colorDialog.getGui(), 'ag-color-dialog');
	        var colorPanel = new agColorPanel_1.AgColorPanel({
	            picker: this
	        });
	        this.getContext().wireBean(colorPanel);
	        colorPanel.addDestroyFunc(function () {
	            if (colorDialog.isAlive()) {
	                colorDialog.destroy();
	            }
	        });
	        colorDialog.setParentComponent(this);
	        colorDialog.setBodyComponent(colorPanel);
	        colorPanel.setValue(this.getValue());
	        colorDialog.addDestroyFunc(function () {
	            var wasDestroying = _this.isDestroyingPicker;
	            _this.displayedPicker = false;
	            // here we check if the picker was already being
	            // destroyed to avoid a stackoverflow
	            if (!wasDestroying) {
	                _this.isDestroyingPicker = true;
	                if (colorPanel.isAlive()) {
	                    colorPanel.destroy();
	                }
	            }
	            else {
	                _this.isDestroyingPicker = false;
	            }
	        });
	    };
	    AgColorPicker.prototype.setValue = function (color) {
	        if (this.value === color) {
	            return this;
	        }
	        this.value = color;
	        this.eDisplayField.style.backgroundColor = color;
	        this.dispatchEvent({ type: agAbstractField_1.AgAbstractField.EVENT_CHANGED });
	        return this;
	    };
	    AgColorPicker.prototype.getValue = function () {
	        return this.value;
	    };
	    return AgColorPicker;
	}(agPickerField_1.AgPickerField));
	exports.AgColorPicker = AgColorPicker;


/***/ }),
/* 2494 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var component_1 = __webpack_require__(2353);
	var utils_1 = __webpack_require__(2325);
	var componentAnnotations_1 = __webpack_require__(2384);
	var context_1 = __webpack_require__(2333);
	var AgColorPanel = /** @class */ (function (_super) {
	    __extends(AgColorPanel, _super);
	    function AgColorPanel(config) {
	        var _this = _super.call(this, AgColorPanel.TEMPLATE) || this;
	        _this.H = 1; // in the [0, 1] range
	        _this.S = 1; // in the [0, 1] range
	        _this.B = 1; // in the [0, 1] range
	        _this.A = 1; // in the [0, 1] range
	        _this.isSpectrumDragging = false;
	        _this.isSpectrumHueDragging = false;
	        _this.isSpectrumAlphaDragging = false;
	        _this.colorChanged = false;
	        _this.picker = config.picker;
	        return _this;
	    }
	    AgColorPanel.prototype.postConstruct = function () {
	        var eGui = this.getGui();
	        this.initRecentColors();
	        this.addDestroyableEventListener(this.spectrumVal, 'mousedown', this.onSpectrumDraggerDown.bind(this));
	        this.addDestroyableEventListener(eGui, 'mousemove', this.onSpectrumDraggerMove.bind(this));
	        this.addDestroyableEventListener(this.spectrumHue, 'mousedown', this.onSpectrumHueDown.bind(this));
	        this.addDestroyableEventListener(eGui, 'mousemove', this.onSpectrumHueMove.bind(this));
	        this.addDestroyableEventListener(this.spectrumAlpha, 'mousedown', this.onSpectrumAlphaDown.bind(this));
	        this.addDestroyableEventListener(eGui, 'mousemove', this.onSpectrumAlphaMove.bind(this));
	        // Listening to `mouseup` on the document on purpose. The user might release the mouse button
	        // outside the UI control. When the mouse returns back to the control's area, the dragging
	        // of the thumb is not expected and seen as a bug.
	        this.addDestroyableEventListener(document, 'mouseup', this.onMouseUp.bind(this));
	        this.addDestroyableEventListener(this.recentColors, 'click', this.onRecentColorClick.bind(this));
	    };
	    AgColorPanel.prototype.refreshSpectrumRect = function () {
	        return this.spectrumValRect = this.spectrumVal.getBoundingClientRect();
	    };
	    AgColorPanel.prototype.refreshHueRect = function () {
	        return this.spectrumHueRect = this.spectrumHue.getBoundingClientRect();
	    };
	    AgColorPanel.prototype.refreshAlphaRect = function () {
	        return this.spectrumAlphaRect = this.spectrumAlpha.getBoundingClientRect();
	    };
	    AgColorPanel.prototype.onSpectrumDraggerDown = function (e) {
	        this.refreshSpectrumRect();
	        this.isSpectrumDragging = true;
	        this.moveDragger(e);
	    };
	    AgColorPanel.prototype.onSpectrumDraggerMove = function (e) {
	        if (this.isSpectrumDragging) {
	            this.moveDragger(e);
	        }
	    };
	    AgColorPanel.prototype.onSpectrumHueDown = function (e) {
	        this.refreshHueRect();
	        this.isSpectrumHueDragging = true;
	        this.moveHueSlider(e);
	    };
	    AgColorPanel.prototype.onSpectrumHueMove = function (e) {
	        if (this.isSpectrumHueDragging) {
	            this.moveHueSlider(e);
	        }
	    };
	    AgColorPanel.prototype.onSpectrumAlphaDown = function (e) {
	        this.refreshAlphaRect();
	        this.isSpectrumAlphaDragging = true;
	        this.moveAlphaSlider(e);
	    };
	    AgColorPanel.prototype.onSpectrumAlphaMove = function (e) {
	        if (this.isSpectrumAlphaDragging) {
	            this.moveAlphaSlider(e);
	        }
	    };
	    AgColorPanel.prototype.onMouseUp = function () {
	        this.isSpectrumDragging = false;
	        this.isSpectrumHueDragging = false;
	        this.isSpectrumAlphaDragging = false;
	    };
	    AgColorPanel.prototype.moveDragger = function (e) {
	        var valRect = this.spectrumValRect;
	        if (valRect) {
	            var x = e.clientX - valRect.left;
	            var y = e.clientY - valRect.top;
	            x = Math.max(x, 0);
	            x = Math.min(x, valRect.width);
	            y = Math.max(y, 0);
	            y = Math.min(y, valRect.height);
	            this.setSpectrumValue(x / valRect.width, 1 - y / valRect.height);
	        }
	    };
	    AgColorPanel.prototype.moveHueSlider = function (e) {
	        var hueRect = this.spectrumHueRect;
	        if (hueRect) {
	            var slider = this.spectrumHueSlider;
	            var sliderRect = slider.getBoundingClientRect();
	            var x = e.clientX - hueRect.left;
	            x = Math.max(x, 0);
	            x = Math.min(x, hueRect.width);
	            this.H = 1 - x / hueRect.width;
	            slider.style.left = (x + sliderRect.width / 2) + 'px';
	            this.update();
	        }
	    };
	    AgColorPanel.prototype.moveAlphaSlider = function (e) {
	        var alphaRect = this.spectrumAlphaRect;
	        if (alphaRect) {
	            var slider = this.spectrumAlphaSlider;
	            var sliderRect = slider.getBoundingClientRect();
	            var x = e.clientX - alphaRect.left;
	            x = Math.max(x, 0);
	            x = Math.min(x, alphaRect.width);
	            this.A = x / alphaRect.width;
	            slider.style.left = (x + sliderRect.width / 2) + 'px';
	            this.update();
	        }
	    };
	    AgColorPanel.prototype.update = function () {
	        var color = utils_1.Color.fromHSB(this.H * 360, this.S, this.B, this.A);
	        var spectrumColor = utils_1.Color.fromHSB(this.H * 360, 1, 1);
	        var rgbaColor = color.toRgbaString();
	        // the recent color list needs to know color has actually changed
	        var colorPicker = this.picker;
	        var existingColor = utils_1.Color.fromString(colorPicker.getValue());
	        if (existingColor.toRgbaString() !== rgbaColor) {
	            this.colorChanged = true;
	        }
	        colorPicker.setValue(rgbaColor);
	        this.spectrumColor.style.backgroundColor = spectrumColor.toRgbaString();
	        this.spectrumDragger.style.backgroundColor = rgbaColor;
	    };
	    /**
	     * @param saturation In the [0, 1] interval.
	     * @param brightness In the [0, 1] interval.
	     */
	    AgColorPanel.prototype.setSpectrumValue = function (saturation, brightness) {
	        var valRect = this.spectrumValRect || this.refreshSpectrumRect();
	        if (valRect) {
	            var dragger = this.spectrumDragger;
	            var draggerRect = dragger.getBoundingClientRect();
	            saturation = Math.max(0, saturation);
	            saturation = Math.min(1, saturation);
	            brightness = Math.max(0, brightness);
	            brightness = Math.min(1, brightness);
	            this.S = saturation;
	            this.B = brightness;
	            dragger.style.left = (saturation * valRect.width - draggerRect.width / 2) + 'px';
	            dragger.style.top = ((1 - brightness) * valRect.height - draggerRect.height / 2) + 'px';
	            this.update();
	        }
	    };
	    AgColorPanel.prototype.initRecentColors = function () {
	        var recentColors = AgColorPanel.recentColors;
	        var innerHtml = recentColors.map(function (color, index) {
	            return "<div class=\"ag-recent-color\" id=" + index + " style=\"background-color: " + color + "; width: 15px; height: 15px;\" recent-color=\"" + color + "\"></div>";
	        });
	        this.recentColors.innerHTML = innerHtml.join('');
	    };
	    AgColorPanel.prototype.setValue = function (val) {
	        var color = utils_1.Color.fromString(val);
	        var _a = color.toHSB(), h = _a[0], s = _a[1], b = _a[2];
	        this.H = (isNaN(h) ? 0 : h) / 360;
	        this.A = color.a;
	        var spectrumHueRect = this.spectrumHueRect || this.refreshHueRect();
	        var spectrumAlphaRect = this.spectrumAlphaRect || this.refreshAlphaRect();
	        this.spectrumHueSlider.style.left = ((this.H - 1) * -spectrumHueRect.width) + "px";
	        this.spectrumAlphaSlider.style.left = (this.A * spectrumAlphaRect.width) + "px";
	        this.setSpectrumValue(s, b);
	    };
	    AgColorPanel.prototype.onRecentColorClick = function (e) {
	        var target = e.target;
	        if (!utils_1._.exists(target.id)) {
	            return;
	        }
	        var id = parseInt(target.id, 10);
	        this.setValue(AgColorPanel.recentColors[id]);
	        this.destroy();
	    };
	    AgColorPanel.prototype.addRecentColor = function () {
	        var color = utils_1.Color.fromHSB(this.H * 360, this.S, this.B, this.A);
	        var rgbaColor = color.toRgbaString();
	        var recentColors = AgColorPanel.recentColors;
	        if (!this.colorChanged || recentColors[0] === rgbaColor) {
	            return;
	        }
	        // remove duplicate color
	        recentColors = recentColors.filter(function (color) { return color != rgbaColor; });
	        // add color to head
	        recentColors = [rgbaColor].concat(recentColors);
	        // ensure we don't exceed max number of recent colors
	        if (recentColors.length > AgColorPanel.maxRecentColors) {
	            recentColors = recentColors.slice(0, AgColorPanel.maxRecentColors);
	        }
	        AgColorPanel.recentColors = recentColors;
	    };
	    AgColorPanel.prototype.destroy = function () {
	        _super.prototype.destroy.call(this);
	        this.addRecentColor();
	    };
	    AgColorPanel.maxRecentColors = 8;
	    AgColorPanel.recentColors = [];
	    AgColorPanel.TEMPLATE = "<div class=\"ag-color-panel\">\n            <div ref=\"spectrumColor\" class=\"ag-spectrum-color\">\n                <div class=\"ag-spectrum-sat ag-fill\">\n                    <div ref=\"spectrumVal\" class=\"ag-spectrum-val ag-fill\">\n                        <div ref=\"spectrumDragger\" class=\"ag-spectrum-dragger\"></div>\n                    </div>\n                </div>\n            </div>\n            <div class=\"ag-spectrum-tools\">\n                <div ref=\"spectrumHue\" class=\"ag-spectrum-hue ag-hue-alpha\">\n                    <div class=\"ag-spectrum-hue-background\"></div>\n                    <div ref=\"spectrumHueSlider\" class=\"ag-spectrum-slider\"></div>\n                </div>\n                <div ref=\"spectrumAlpha\" class=\"ag-spectrum-alpha ag-hue-alpha\">\n                    <div class=\"ag-spectrum-alpha-background\"></div>\n                    <div ref=\"spectrumAlphaSlider\" class=\"ag-spectrum-slider\"></div>\n                </div>\n                <div ref=\"recentColors\" class=\"ag-recent-colors\"></div>\n            </div>\n        </div>";
	    __decorate([
	        componentAnnotations_1.RefSelector('spectrumColor'),
	        __metadata("design:type", HTMLElement)
	    ], AgColorPanel.prototype, "spectrumColor", void 0);
	    __decorate([
	        componentAnnotations_1.RefSelector('spectrumVal'),
	        __metadata("design:type", HTMLElement)
	    ], AgColorPanel.prototype, "spectrumVal", void 0);
	    __decorate([
	        componentAnnotations_1.RefSelector('spectrumDragger'),
	        __metadata("design:type", HTMLElement)
	    ], AgColorPanel.prototype, "spectrumDragger", void 0);
	    __decorate([
	        componentAnnotations_1.RefSelector('spectrumHue'),
	        __metadata("design:type", HTMLElement)
	    ], AgColorPanel.prototype, "spectrumHue", void 0);
	    __decorate([
	        componentAnnotations_1.RefSelector('spectrumHueSlider'),
	        __metadata("design:type", HTMLElement)
	    ], AgColorPanel.prototype, "spectrumHueSlider", void 0);
	    __decorate([
	        componentAnnotations_1.RefSelector('spectrumAlpha'),
	        __metadata("design:type", HTMLElement)
	    ], AgColorPanel.prototype, "spectrumAlpha", void 0);
	    __decorate([
	        componentAnnotations_1.RefSelector('spectrumAlphaSlider'),
	        __metadata("design:type", HTMLElement)
	    ], AgColorPanel.prototype, "spectrumAlphaSlider", void 0);
	    __decorate([
	        componentAnnotations_1.RefSelector('recentColors'),
	        __metadata("design:type", HTMLElement)
	    ], AgColorPanel.prototype, "recentColors", void 0);
	    __decorate([
	        context_1.PostConstruct,
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", []),
	        __metadata("design:returntype", void 0)
	    ], AgColorPanel.prototype, "postConstruct", null);
	    return AgColorPanel;
	}(component_1.Component));
	exports.AgColorPanel = AgColorPanel;


/***/ }),
/* 2495 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var componentAnnotations_1 = __webpack_require__(2384);
	var context_1 = __webpack_require__(2333);
	var gridOptionsWrapper_1 = __webpack_require__(2324);
	var agAbstractField_1 = __webpack_require__(2430);
	var utils_1 = __webpack_require__(2325);
	var AgPickerField = /** @class */ (function (_super) {
	    __extends(AgPickerField, _super);
	    function AgPickerField() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.TEMPLATE = "<div class=\"ag-picker-field\">\n            <label ref=\"eLabel\"></label>\n            <div ref=\"eWrapper\" class=\"ag-wrapper\">\n                <%displayField% ref=\"eDisplayField\"></%displayField%>\n                <button ref=\"eButton\" class=\"ag-picker-button\"> </button>\n            </div>\n        </div>";
	        _this.displayedPicker = false;
	        _this.isDestroyingPicker = false;
	        return _this;
	    }
	    AgPickerField.prototype.postConstruct = function () {
	        var _this = this;
	        _super.prototype.postConstruct.call(this);
	        this.addDestroyableEventListener(this.eButton, 'click', function () {
	            _this.showPicker();
	        });
	        if (this.pickerIcon) {
	            this.eButton.appendChild(utils_1._.createIconNoSpan(this.pickerIcon, this.gridOptionsWrapper, null));
	        }
	    };
	    AgPickerField.prototype.setInputWidth = function (width) {
	        utils_1._.setElementWidth(this.eWrapper, width);
	        return this;
	    };
	    __decorate([
	        context_1.Autowired('gridOptionsWrapper'),
	        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
	    ], AgPickerField.prototype, "gridOptionsWrapper", void 0);
	    __decorate([
	        componentAnnotations_1.RefSelector('eLabel'),
	        __metadata("design:type", HTMLElement)
	    ], AgPickerField.prototype, "eLabel", void 0);
	    __decorate([
	        componentAnnotations_1.RefSelector('eWrapper'),
	        __metadata("design:type", HTMLElement)
	    ], AgPickerField.prototype, "eWrapper", void 0);
	    __decorate([
	        componentAnnotations_1.RefSelector('eDisplayField'),
	        __metadata("design:type", Object)
	    ], AgPickerField.prototype, "eDisplayField", void 0);
	    __decorate([
	        componentAnnotations_1.RefSelector('eButton'),
	        __metadata("design:type", HTMLButtonElement)
	    ], AgPickerField.prototype, "eButton", void 0);
	    return AgPickerField;
	}(agAbstractField_1.AgAbstractField));
	exports.AgPickerField = AgPickerField;


/***/ }),
/* 2496 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var agAbstractInputField_1 = __webpack_require__(2429);
	var AgSelect = /** @class */ (function (_super) {
	    __extends(AgSelect, _super);
	    function AgSelect() {
	        var _this = _super.call(this) || this;
	        _this.className = 'ag-select';
	        _this.displayTag = 'select';
	        _this.inputType = '';
	        _this.setTemplate(_this.TEMPLATE.replace(/%displayField%/g, _this.displayTag));
	        return _this;
	    }
	    AgSelect.prototype.addOptions = function (options) {
	        var _this = this;
	        options.forEach(function (option) { return _this.addOption(option); });
	        return this;
	    };
	    AgSelect.prototype.addOption = function (option) {
	        var optionEl = document.createElement('option');
	        optionEl.value = option.value;
	        optionEl.text = option.text || option.value;
	        this.eInput.appendChild(optionEl);
	        return this;
	    };
	    AgSelect.prototype.setValue = function (value, silent) {
	        var ret = _super.prototype.setValue.call(this, value, silent);
	        this.eInput.value = value;
	        return ret;
	    };
	    return AgSelect;
	}(agAbstractInputField_1.AgAbstractInputField));
	exports.AgSelect = AgSelect;


/***/ }),
/* 2497 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var agAbstractLabel_1 = __webpack_require__(2431);
	var componentAnnotations_1 = __webpack_require__(2384);
	var context_1 = __webpack_require__(2333);
	var dragService_1 = __webpack_require__(2364);
	var agInputNumberField_1 = __webpack_require__(2492);
	var agAbstractField_1 = __webpack_require__(2430);
	var utils_1 = __webpack_require__(2325);
	var AgAngleSelect = /** @class */ (function (_super) {
	    __extends(AgAngleSelect, _super);
	    function AgAngleSelect() {
	        var _this = _super.call(this, AgAngleSelect.TEMPLATE) || this;
	        _this.radius = 0;
	        _this.offsetX = 0;
	        _this.offsetY = 0;
	        return _this;
	    }
	    AgAngleSelect.prototype.postConstruct = function () {
	        var _this = this;
	        _super.prototype.postConstruct.call(this);
	        this.dragListener = {
	            eElement: this.eParentCircle,
	            dragStartPixels: 0,
	            onDragStart: function (e) {
	                _this.parentCircleRect = _this.eParentCircle.getBoundingClientRect();
	            },
	            onDragging: function (e) { return _this.calculateAngleDrag(e); },
	            onDragStop: function () { }
	        };
	        this.dragService.addDragSource(this.dragListener);
	        this.eAngleValue
	            .setLabel('')
	            .setLabelWidth(5)
	            .setInputWidth(45)
	            .setMin(0)
	            .setMax(360)
	            .setValue("" + this.degrees)
	            .onValueChange(function (value) {
	            if (value == null || value === '') {
	                value = '0';
	            }
	            value = _this.eAngleValue.normalizeValue(value);
	            var floatValue = parseFloat(value);
	            if (floatValue > 180) {
	                floatValue = floatValue - 360;
	            }
	            _this.setValue(floatValue);
	        });
	        this.updateNumberInput();
	        if (utils_1._.exists(this.getValue())) {
	            this.eAngleValue.setValue(this.normalizeNegativeValue(this.getValue()).toString());
	        }
	        this.addDestroyableEventListener(this, agAbstractField_1.AgAbstractField.EVENT_CHANGED, function () {
	            if (_this.eAngleValue.getInputElement().contains(document.activeElement)) {
	                return;
	            }
	            _this.updateNumberInput();
	        });
	    };
	    AgAngleSelect.prototype.updateNumberInput = function () {
	        var normalizedValue = this.normalizeNegativeValue(this.getValue());
	        this.eAngleValue.setValue(normalizedValue.toString());
	    };
	    AgAngleSelect.prototype.positionChildCircle = function (radians) {
	        var rect = this.parentCircleRect || { width: 24, height: 24 };
	        var eChildCircle = this.eChildCircle;
	        var centerX = rect.width / 2;
	        var centerY = rect.height / 2;
	        eChildCircle.style.left = centerX + Math.cos(radians) * 8 + "px";
	        eChildCircle.style.top = centerY + Math.sin(radians) * 8 + "px";
	    };
	    AgAngleSelect.prototype.calculatePolar = function () {
	        var x = this.offsetX;
	        var y = this.offsetY;
	        var radians = Math.atan2(y, x);
	        this.degrees = this.toDegrees(radians);
	        this.radius = Math.sqrt((x * x) + (y * y));
	        this.positionChildCircle(radians);
	    };
	    AgAngleSelect.prototype.calculateCartesian = function () {
	        var radians = this.toRadians(this.getValue());
	        var radius = this.getRadius();
	        this
	            .setOffsetX(Math.cos(radians) * radius)
	            .setOffsetY(Math.sin(radians) * radius);
	    };
	    AgAngleSelect.prototype.setOffsetX = function (offset) {
	        if (this.offsetX !== offset) {
	            this.offsetX = offset;
	            this.calculatePolar();
	        }
	        return this;
	    };
	    AgAngleSelect.prototype.setOffsetY = function (offset) {
	        if (this.offsetY !== offset) {
	            this.offsetY = offset;
	            this.calculatePolar();
	        }
	        return this;
	    };
	    AgAngleSelect.prototype.calculateAngleDrag = function (e) {
	        var rect = this.parentCircleRect;
	        var centerX = rect.width / 2;
	        var centerY = rect.height / 2;
	        var x = e.clientX - rect.left;
	        var y = e.clientY - rect.top;
	        var dx = x - centerX;
	        var dy = y - centerY;
	        var radians = Math.atan2(dy, dx);
	        this.setValue(radians, true);
	    };
	    AgAngleSelect.prototype.toDegrees = function (radians) {
	        return radians / Math.PI * 180;
	    };
	    AgAngleSelect.prototype.toRadians = function (degrees) {
	        return degrees / 180 * Math.PI;
	    };
	    AgAngleSelect.prototype.normalizeNegativeValue = function (degrees) {
	        return degrees < 0 ? 360 + degrees : degrees;
	    };
	    AgAngleSelect.prototype.normalizeAngle180 = function (radians) {
	        radians %= Math.PI * 2;
	        if (radians < -Math.PI) {
	            radians += Math.PI * 2;
	        }
	        else if (radians >= Math.PI) {
	            radians -= Math.PI * 2;
	        }
	        return radians;
	    };
	    AgAngleSelect.prototype.getRadius = function () {
	        return this.radius;
	    };
	    AgAngleSelect.prototype.setRadius = function (r) {
	        if (this.radius === r) {
	            return this;
	        }
	        this.radius = r;
	        this.calculateCartesian();
	        return this;
	    };
	    AgAngleSelect.prototype.onValueChange = function (callbackFn) {
	        var _this = this;
	        this.addDestroyableEventListener(this, agAbstractField_1.AgAbstractField.EVENT_CHANGED, function () {
	            callbackFn(_this.degrees);
	        });
	        return this;
	    };
	    AgAngleSelect.prototype.getValue = function (radians) {
	        return radians ? this.toRadians(this.degrees) : this.degrees;
	    };
	    AgAngleSelect.prototype.setValue = function (degrees, radians) {
	        var radiansValue;
	        if (!radians) {
	            radiansValue = this.normalizeAngle180(this.toRadians(degrees));
	        }
	        else {
	            radiansValue = degrees;
	        }
	        degrees = this.toDegrees(radiansValue);
	        if (this.degrees !== degrees) {
	            this.degrees = Math.floor(degrees);
	            this.calculateCartesian();
	            this.positionChildCircle(radiansValue);
	            this.dispatchEvent({ type: agAbstractField_1.AgAbstractField.EVENT_CHANGED });
	        }
	        return this;
	    };
	    AgAngleSelect.prototype.setWidth = function (width) {
	        utils_1._.setFixedWidth(this.getGui(), width);
	        return this;
	    };
	    AgAngleSelect.prototype.destroy = function () {
	        _super.prototype.destroy.call(this);
	        this.dragService.removeDragSource(this.dragListener);
	    };
	    AgAngleSelect.TEMPLATE = "<div class=\"ag-angle-select\">\n            <label ref=\"eLabel\"></label>\n            <div class=\"ag-wrapper\">\n                <div ref=\"eAngleSelectField\" class=\"ag-angle-select-field\">\n                    <div ref=\"eParentCircle\" class=\"ag-parent-circle\">\n                        <div ref=\"eChildCircle\" class=\"ag-child-circle\"></div>\n                    </div>\n                </div>\n                <ag-input-number-field ref=\"eAngleValue\"></ag-input-number-field>\n            </div>\n        </div>";
	    __decorate([
	        componentAnnotations_1.RefSelector('eLabel'),
	        __metadata("design:type", HTMLElement)
	    ], AgAngleSelect.prototype, "eLabel", void 0);
	    __decorate([
	        componentAnnotations_1.RefSelector('eParentCircle'),
	        __metadata("design:type", HTMLElement)
	    ], AgAngleSelect.prototype, "eParentCircle", void 0);
	    __decorate([
	        componentAnnotations_1.RefSelector('eChildCircle'),
	        __metadata("design:type", HTMLElement)
	    ], AgAngleSelect.prototype, "eChildCircle", void 0);
	    __decorate([
	        componentAnnotations_1.RefSelector('eAngleValue'),
	        __metadata("design:type", agInputNumberField_1.AgInputNumberField)
	    ], AgAngleSelect.prototype, "eAngleValue", void 0);
	    __decorate([
	        context_1.Autowired("dragService"),
	        __metadata("design:type", dragService_1.DragService)
	    ], AgAngleSelect.prototype, "dragService", void 0);
	    return AgAngleSelect;
	}(agAbstractLabel_1.AgAbstractLabel));
	exports.AgAngleSelect = AgAngleSelect;


/***/ }),
/* 2498 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var agRadioButton_1 = __webpack_require__(2479);
	var utils_1 = __webpack_require__(2325);
	var AgToggleButton = /** @class */ (function (_super) {
	    __extends(AgToggleButton, _super);
	    function AgToggleButton() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.className = 'ag-toggle-button';
	        return _this;
	    }
	    AgToggleButton.prototype.postConstruct = function () {
	        _super.prototype.postConstruct.call(this);
	        utils_1._.addCssClass(this.eIconEl, 'ag-icon');
	    };
	    AgToggleButton.prototype.updateIcons = function () {
	        var value = this.getValue();
	        utils_1._.addOrRemoveCssClass(this.eIconEl, 'ag-icon-toggle-on', value);
	        utils_1._.addOrRemoveCssClass(this.eIconEl, 'ag-icon-toggle-off', !value);
	    };
	    AgToggleButton.prototype.setValue = function (value, silent) {
	        _super.prototype.setValue.call(this, value, silent);
	        utils_1._.addOrRemoveCssClass(this.getGui(), 'ag-selected', this.getValue());
	        return this;
	    };
	    return AgToggleButton;
	}(agRadioButton_1.AgRadioButton));
	exports.AgToggleButton = AgToggleButton;


/***/ }),
/* 2499 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var componentUtil_1 = __webpack_require__(2334);
	var grid_1 = __webpack_require__(2445);
	var registered = false;
	function initialiseAgGridWithWebComponents() {
	    console.warn('ag-grid: initialiseAgGridWithWebComponents is deprecated. Please use the ag-grid-webcomponent dependency instead. ');
	    // only register to WebComponents once
	    if (registered) {
	        return;
	    }
	    registered = true;
	    if (typeof document === 'undefined' || !document.registerElement) {
	        console.error('ag-Grid: unable to find document.registerElement() function, unable to initialise ag-Grid as a Web Component');
	    }
	    // i don't think this type of extension is possible in TypeScript, so back to
	    // plain Javascript to create this object
	    var AgileGridProto = Object.create(HTMLElement.prototype);
	    // wrap each property with a get and set method, so we can track when changes are done
	    componentUtil_1.ComponentUtil.ALL_PROPERTIES.forEach(function (key) {
	        Object.defineProperty(AgileGridProto, key, {
	            set: function (v) {
	                this.__agGridSetProperty(key, v);
	            },
	            get: function () {
	                return this.__agGridGetProperty(key);
	            },
	            enumerable: true,
	            configurable: true
	        });
	    });
	    var agGridProtoNoType = AgileGridProto;
	    agGridProtoNoType.__agGridSetProperty = function (key, value) {
	        if (!this.__attributes) {
	            this.__attributes = {};
	        }
	        this.__attributes[key] = value;
	        // keeping this consistent with the ng2 onChange, so I can reuse the handling code
	        var changeObject = {};
	        changeObject[key] = { currentValue: value };
	        this.onChange(changeObject);
	    };
	    agGridProtoNoType.onChange = function (changes) {
	        if (this._initialised) {
	            componentUtil_1.ComponentUtil.processOnChange(changes, this._gridOptions, this.api, this.columnApi);
	        }
	    };
	    agGridProtoNoType.__agGridGetProperty = function (key) {
	        if (!this.__attributes) {
	            this.__attributes = {};
	        }
	        return this.__attributes[key];
	    };
	    agGridProtoNoType.setGridOptions = function (options) {
	        var globalEventListener = this.globalEventListener.bind(this);
	        this._gridOptions = componentUtil_1.ComponentUtil.copyAttributesToGridOptions(options, this);
	        var gridParams = {
	            globalEventListener: globalEventListener
	        };
	        this._agGrid = new grid_1.Grid(this, this._gridOptions, gridParams);
	        this.api = options.api;
	        this.columnApi = options.columnApi;
	        this._initialised = true;
	    };
	    // copies all the attributes into this object
	    agGridProtoNoType.createdCallback = function () {
	        for (var i = 0; i < this.attributes.length; i++) {
	            var attribute = this.attributes[i];
	            this.setPropertyFromAttribute(attribute);
	        }
	    };
	    agGridProtoNoType.setPropertyFromAttribute = function (attribute) {
	        var name = toCamelCase(attribute.nodeName);
	        var value = attribute.nodeValue;
	        if (componentUtil_1.ComponentUtil.ALL_PROPERTIES.indexOf(name) >= 0) {
	            this[name] = value;
	        }
	    };
	    agGridProtoNoType.attachedCallback = function (params) { };
	    agGridProtoNoType.detachedCallback = function (params) { };
	    agGridProtoNoType.attributeChangedCallback = function (attributeName) {
	        var attribute = this.attributes[attributeName];
	        this.setPropertyFromAttribute(attribute);
	    };
	    agGridProtoNoType.globalEventListener = function (eventType, event) {
	        var eventLowerCase = eventType.toLowerCase();
	        var browserEvent = new Event(eventLowerCase);
	        var browserEventNoType = browserEvent;
	        browserEventNoType.agGridDetails = event;
	        this.dispatchEvent(browserEvent);
	        var callbackMethod = 'on' + eventLowerCase;
	        if (typeof this[callbackMethod] === 'function') {
	            this[callbackMethod](browserEvent);
	        }
	    };
	    // finally, register
	    document.registerElement('ag-grid', { prototype: AgileGridProto });
	}
	exports.initialiseAgGridWithWebComponents = initialiseAgGridWithWebComponents;
	function toCamelCase(myString) {
	    if (typeof myString === 'string') {
	        var result = myString.replace(/-([a-z])/g, function (g) {
	            return g[1].toUpperCase();
	        });
	        return result;
	    }
	    else {
	        return myString;
	    }
	}


/***/ }),
/* 2500 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var utils_1 = __webpack_require__(2325);
	var TabbedLayout = /** @class */ (function () {
	    function TabbedLayout(params) {
	        var _this = this;
	        this.items = [];
	        this.params = params;
	        this.eGui = document.createElement('div');
	        this.eGui.innerHTML = TabbedLayout.TEMPLATE;
	        this.eHeader = this.eGui.querySelector('[ref="tabHeader"]');
	        this.eBody = this.eGui.querySelector('[ref="tabBody"]');
	        utils_1._.addCssClass(this.eGui, params.cssClass);
	        if (params.items) {
	            params.items.forEach(function (item) { return _this.addItem(item); });
	        }
	    }
	    TabbedLayout.prototype.setAfterAttachedParams = function (params) {
	        this.afterAttachedParams = params;
	    };
	    TabbedLayout.prototype.getMinDimensions = function () {
	        var eDummyContainer = this.eGui.cloneNode(true);
	        var eDummyBody = eDummyContainer.querySelector('[ref="tabBody"]');
	        // position fixed, so it isn't restricted to the boundaries of the parent
	        eDummyContainer.style.position = 'fixed';
	        // we put the dummy into the body container, so it will inherit all the
	        // css styles that the real cells are inheriting
	        this.eGui.appendChild(eDummyContainer);
	        var minWidth = 0;
	        var minHeight = 0;
	        this.items.forEach(function (itemWrapper) {
	            utils_1._.clearElement(eDummyBody);
	            var eClone = itemWrapper.tabbedItem.bodyPromise.resolveNow(null, function (body) { return body.cloneNode(true); });
	            if (eClone == null) {
	                return;
	            }
	            eDummyBody.appendChild(eClone);
	            if (minWidth < eDummyContainer.offsetWidth) {
	                minWidth = eDummyContainer.offsetWidth;
	            }
	            if (minHeight < eDummyContainer.offsetHeight) {
	                minHeight = eDummyContainer.offsetHeight;
	            }
	        });
	        // finally check the parent tabs are no wider, as if they
	        // are, then these are the min width and not the child tabs
	        // if (minWidth<this.eGui.offsetWidth) {
	        //     minWidth = this.eGui.offsetWidth;
	        // }
	        this.eGui.removeChild(eDummyContainer);
	        return { height: minHeight, width: minWidth };
	    };
	    TabbedLayout.prototype.showFirstItem = function () {
	        if (this.items.length > 0) {
	            this.showItemWrapper(this.items[0]);
	        }
	    };
	    TabbedLayout.prototype.addItem = function (item) {
	        var eHeaderButton = document.createElement('span');
	        eHeaderButton.appendChild(item.title);
	        utils_1._.addCssClass(eHeaderButton, 'ag-tab');
	        this.eHeader.appendChild(eHeaderButton);
	        var wrapper = {
	            tabbedItem: item,
	            eHeaderButton: eHeaderButton
	        };
	        this.items.push(wrapper);
	        eHeaderButton.addEventListener('click', this.showItemWrapper.bind(this, wrapper));
	    };
	    TabbedLayout.prototype.showItem = function (tabbedItem) {
	        var itemWrapper = utils_1._.find(this.items, function (wrapper) {
	            return wrapper.tabbedItem === tabbedItem;
	        });
	        if (itemWrapper) {
	            this.showItemWrapper(itemWrapper);
	        }
	    };
	    TabbedLayout.prototype.showItemWrapper = function (wrapper) {
	        var _this = this;
	        if (this.params.onItemClicked) {
	            this.params.onItemClicked({ item: wrapper.tabbedItem });
	        }
	        if (this.activeItem === wrapper) {
	            utils_1._.callIfPresent(this.params.onActiveItemClicked);
	            return;
	        }
	        utils_1._.clearElement(this.eBody);
	        wrapper.tabbedItem.bodyPromise.then(function (body) {
	            _this.eBody.appendChild(body);
	        });
	        if (this.activeItem) {
	            utils_1._.removeCssClass(this.activeItem.eHeaderButton, 'ag-tab-selected');
	        }
	        utils_1._.addCssClass(wrapper.eHeaderButton, 'ag-tab-selected');
	        this.activeItem = wrapper;
	        if (wrapper.tabbedItem.afterAttachedCallback) {
	            wrapper.tabbedItem.afterAttachedCallback(this.afterAttachedParams);
	        }
	    };
	    TabbedLayout.prototype.getGui = function () {
	        return this.eGui;
	    };
	    TabbedLayout.TEMPLATE = '<div>' +
	        '<div ref="tabHeader" class="ag-tab-header"></div>' +
	        '<div ref="tabBody" class="ag-tab-body"></div>' +
	        '</div>';
	    return TabbedLayout;
	}());
	exports.TabbedLayout = TabbedLayout;


/***/ }),
/* 2501 */
/***/ (function(module, exports) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var VerticalStack = /** @class */ (function () {
	    function VerticalStack() {
	        this.isLayoutPanel = true;
	        this.childPanels = [];
	        this.eGui = document.createElement('div');
	        this.eGui.style.height = '100%';
	    }
	    VerticalStack.prototype.addPanel = function (panel, height) {
	        var component;
	        if (panel.isLayoutPanel) {
	            this.childPanels.push(panel);
	            component = panel.getGui();
	        }
	        else {
	            component = panel;
	        }
	        if (height) {
	            component.style.height = height;
	        }
	        this.eGui.appendChild(component);
	    };
	    VerticalStack.prototype.getGui = function () {
	        return this.eGui;
	    };
	    VerticalStack.prototype.doLayout = function () {
	        for (var i = 0; i < this.childPanels.length; i++) {
	            this.childPanels[i].doLayout();
	        }
	    };
	    return VerticalStack;
	}());
	exports.VerticalStack = VerticalStack;


/***/ }),
/* 2502 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var utils_1 = __webpack_require__(2325);
	function simpleHttpRequest(params) {
	    return new utils_1.Promise(function (resolve) {
	        var httpRequest = new XMLHttpRequest();
	        httpRequest.open('GET', params.url);
	        httpRequest.send();
	        httpRequest.onreadystatechange = function () {
	            if (httpRequest.readyState == 4 && httpRequest.status == 200) {
	                var httpResponse = JSON.parse(httpRequest.responseText);
	                resolve(httpResponse);
	            }
	        };
	    });
	}
	exports.simpleHttpRequest = simpleHttpRequest;


/***/ }),
/* 2503 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var agDialog_1 = __webpack_require__(2486);
	var context_1 = __webpack_require__(2333);
	var component_1 = __webpack_require__(2353);
	var componentAnnotations_1 = __webpack_require__(2384);
	var MessageBox = /** @class */ (function (_super) {
	    __extends(MessageBox, _super);
	    function MessageBox(config) {
	        var _this = _super.call(this, config) || this;
	        _this.message = config.message;
	        return _this;
	    }
	    MessageBox.prototype.postConstruct = function () {
	        var _this = this;
	        var messageBodyComp = new MessageBody();
	        this.addFeature(this.getContext(), messageBodyComp);
	        messageBodyComp.setMessage(this.message);
	        this.setBodyComponent(messageBodyComp);
	        _super.prototype.postConstruct.call(this);
	        this.addDestroyableEventListener(messageBodyComp, 'onBtOk', function () { return _this.close(); });
	    };
	    return MessageBox;
	}(agDialog_1.AgDialog));
	exports.MessageBox = MessageBox;
	var MessageBody = /** @class */ (function (_super) {
	    __extends(MessageBody, _super);
	    function MessageBody() {
	        return _super.call(this, MessageBody.TEMPLATE) || this;
	    }
	    MessageBody.prototype.setMessage = function (message) {
	        this.eCenter.innerText = message;
	    };
	    MessageBody.prototype.postConstruct = function () {
	        this.addDestroyableEventListener(this.eOk, 'click', this.onBtOk.bind(this));
	    };
	    MessageBody.prototype.onBtOk = function () {
	        this.dispatchEvent({ type: 'onBtOk' });
	    };
	    MessageBody.TEMPLATE = "<div class=\"ag-message-box\">\n            <div ref=\"eCenter\" class=\"ag-message-box-content\"></div>\n            <div ref=\"eButtons\" class=\"ag-message-box-button-bar\">\n                <button ref=\"eOk\">OK</button>\n            </div>\n        </div>";
	    __decorate([
	        componentAnnotations_1.RefSelector('eCenter'),
	        __metadata("design:type", HTMLElement)
	    ], MessageBody.prototype, "eCenter", void 0);
	    __decorate([
	        componentAnnotations_1.RefSelector('eOk'),
	        __metadata("design:type", HTMLElement)
	    ], MessageBody.prototype, "eOk", void 0);
	    __decorate([
	        context_1.PostConstruct,
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", []),
	        __metadata("design:returntype", void 0)
	    ], MessageBody.prototype, "postConstruct", null);
	    return MessageBody;
	}(component_1.Component));


/***/ }),
/* 2504 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var utils_1 = __webpack_require__(2325);
	function defaultGroupComparator(valueA, valueB, nodeA, nodeB, accentedCompare) {
	    if (accentedCompare === void 0) { accentedCompare = false; }
	    console.warn('ag-Grid: Since ag-grid 11.0.0 defaultGroupComparator is not necessary. You can remove this from your colDef');
	    var nodeAIsGroup = utils_1._.exists(nodeA) && nodeA.group;
	    var nodeBIsGroup = utils_1._.exists(nodeB) && nodeB.group;
	    var bothAreGroups = nodeAIsGroup && nodeBIsGroup;
	    var bothAreNormal = !nodeAIsGroup && !nodeBIsGroup;
	    if (bothAreGroups) {
	        return utils_1._.defaultComparator(nodeA.key, nodeB.key, accentedCompare);
	    }
	    else if (bothAreNormal) {
	        return utils_1._.defaultComparator(valueA, valueB, accentedCompare);
	    }
	    else if (nodeAIsGroup) {
	        return 1;
	    }
	    else {
	        return -1;
	    }
	}
	exports.defaultGroupComparator = defaultGroupComparator;


/***/ }),
/* 2505 */
/***/ (function(module, exports) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var BaseComponentWrapper = /** @class */ (function () {
	    function BaseComponentWrapper() {
	    }
	    BaseComponentWrapper.prototype.wrap = function (OriginalConstructor, mandatoryMethodList, optionalMethodList, componentName) {
	        var _this = this;
	        if (optionalMethodList === void 0) { optionalMethodList = []; }
	        var wrapper = this.createWrapper(OriginalConstructor, componentName);
	        mandatoryMethodList.forEach((function (methodName) {
	            _this.createMethod(wrapper, methodName, true);
	        }));
	        optionalMethodList.forEach((function (methodName) {
	            _this.createMethod(wrapper, methodName, false);
	        }));
	        return wrapper;
	    };
	    BaseComponentWrapper.prototype.createMethod = function (wrapper, methodName, mandatory) {
	        wrapper.addMethod(methodName, this.createMethodProxy(wrapper, methodName, mandatory));
	    };
	    BaseComponentWrapper.prototype.createMethodProxy = function (wrapper, methodName, mandatory) {
	        return function () {
	            if (wrapper.hasMethod(methodName)) {
	                return wrapper.callMethod(methodName, arguments);
	            }
	            if (mandatory) {
	                console.warn('ag-Grid: Framework component is missing the method ' + methodName + '()');
	            }
	            return null;
	        };
	    };
	    return BaseComponentWrapper;
	}());
	exports.BaseComponentWrapper = BaseComponentWrapper;


/***/ }),
/* 2506 */
/***/ (function(module, exports) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var ChartType;
	(function (ChartType) {
	    ChartType["GroupedColumn"] = "groupedColumn";
	    ChartType["StackedColumn"] = "stackedColumn";
	    ChartType["NormalizedColumn"] = "normalizedColumn";
	    ChartType["GroupedBar"] = "groupedBar";
	    ChartType["StackedBar"] = "stackedBar";
	    ChartType["NormalizedBar"] = "normalizedBar";
	    ChartType["Line"] = "line";
	    ChartType["Scatter"] = "scatter";
	    ChartType["Bubble"] = "bubble";
	    ChartType["Pie"] = "pie";
	    ChartType["Doughnut"] = "doughnut";
	    ChartType["Area"] = "area";
	    ChartType["StackedArea"] = "stackedArea";
	    ChartType["NormalizedArea"] = "normalizedArea";
	})(ChartType = exports.ChartType || (exports.ChartType = {}));


/***/ }),
/* 2507 */
/***/ (function(module, exports, __webpack_require__) {

	// ag-grid-enterprise v21.2.2
	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var ag_grid_community_1 = __webpack_require__(2322);
	var menuList_1 = __webpack_require__(2508);
	var menuItemComponent_1 = __webpack_require__(2509);
	var menuItemMapper_1 = __webpack_require__(2510);
	var primaryColsPanel_1 = __webpack_require__(2514);
	var EnterpriseMenuFactory = /** @class */ (function () {
	    function EnterpriseMenuFactory() {
	    }
	    EnterpriseMenuFactory.prototype.hideActiveMenu = function () {
	        if (this.activeMenu) {
	            this.activeMenu.destroy();
	        }
	    };
	    EnterpriseMenuFactory.prototype.showMenuAfterMouseEvent = function (column, mouseEvent, defaultTab) {
	        var _this = this;
	        this.showMenu(column, function (menu) {
	            _this.popupService.positionPopupUnderMouseEvent({
	                column: column,
	                type: 'columnMenu',
	                mouseEvent: mouseEvent,
	                ePopup: menu.getGui()
	            });
	            if (defaultTab) {
	                menu.showTab(defaultTab);
	            }
	        }, defaultTab);
	    };
	    EnterpriseMenuFactory.prototype.showMenuAfterButtonClick = function (column, eventSource, defaultTab, restrictToTabs) {
	        var _this = this;
	        var multiplier = -1;
	        var alignSide = 'left';
	        if (this.gridOptionsWrapper.isEnableRtl()) {
	            multiplier = 1;
	            alignSide = 'right';
	        }
	        this.showMenu(column, function (menu) {
	            var minDims = menu.getMinDimensions();
	            _this.popupService.positionPopupUnderComponent({
	                column: column,
	                type: 'columnMenu',
	                eventSource: eventSource,
	                ePopup: menu.getGui(),
	                nudgeX: 9 * multiplier,
	                nudgeY: -23,
	                minWidth: minDims.width,
	                minHeight: minDims.height,
	                alignSide: alignSide,
	                keepWithinBounds: true
	            });
	            if (defaultTab) {
	                menu.showTab(defaultTab);
	            }
	        }, defaultTab, restrictToTabs);
	    };
	    EnterpriseMenuFactory.prototype.showMenu = function (column, positionCallback, defaultTab, restrictToTabs) {
	        var _this = this;
	        var menu = new EnterpriseMenu(column, this.lastSelectedTab, restrictToTabs);
	        this.context.wireBean(menu);
	        var eMenuGui = menu.getGui();
	        // need to show filter before positioning, as only after filter
	        // is visible can we find out what the width of it is
	        var hidePopup = this.popupService.addAsModalPopup(eMenuGui, true, function () {
	            menu.destroy();
	            column.setMenuVisible(false, "contextMenu");
	        });
	        menu.afterGuiAttached({
	            hidePopup: hidePopup
	        });
	        positionCallback(menu);
	        if (!defaultTab) {
	            menu.showTabBasedOnPreviousSelection();
	        }
	        menu.addEventListener(EnterpriseMenu.EVENT_TAB_SELECTED, function (event) {
	            _this.lastSelectedTab = event.key;
	        });
	        column.setMenuVisible(true, "contextMenu");
	        this.activeMenu = menu;
	        menu.addEventListener(ag_grid_community_1.BeanStub.EVENT_DESTROYED, function () {
	            if (_this.activeMenu === menu) {
	                _this.activeMenu = null;
	            }
	        });
	    };
	    EnterpriseMenuFactory.prototype.isMenuEnabled = function (column) {
	        return column.getMenuTabs(EnterpriseMenu.TABS_DEFAULT).length > 0;
	    };
	    __decorate([
	        ag_grid_community_1.Autowired('context'),
	        __metadata("design:type", ag_grid_community_1.Context)
	    ], EnterpriseMenuFactory.prototype, "context", void 0);
	    __decorate([
	        ag_grid_community_1.Autowired('popupService'),
	        __metadata("design:type", ag_grid_community_1.PopupService)
	    ], EnterpriseMenuFactory.prototype, "popupService", void 0);
	    __decorate([
	        ag_grid_community_1.Autowired('gridOptionsWrapper'),
	        __metadata("design:type", ag_grid_community_1.GridOptionsWrapper)
	    ], EnterpriseMenuFactory.prototype, "gridOptionsWrapper", void 0);
	    EnterpriseMenuFactory = __decorate([
	        ag_grid_community_1.Bean('menuFactory')
	    ], EnterpriseMenuFactory);
	    return EnterpriseMenuFactory;
	}());
	exports.EnterpriseMenuFactory = EnterpriseMenuFactory;
	var EnterpriseMenu = /** @class */ (function (_super) {
	    __extends(EnterpriseMenu, _super);
	    function EnterpriseMenu(column, initialSelection, restrictTo) {
	        var _this = _super.call(this) || this;
	        _this.tabFactories = {};
	        _this.includeChecks = {};
	        _this.column = column;
	        _this.initialSelection = initialSelection;
	        _this.tabFactories[EnterpriseMenu.TAB_GENERAL] = _this.createMainPanel.bind(_this);
	        _this.tabFactories[EnterpriseMenu.TAB_FILTER] = _this.createFilterPanel.bind(_this);
	        _this.tabFactories[EnterpriseMenu.TAB_COLUMNS] = _this.createColumnsPanel.bind(_this);
	        _this.includeChecks[EnterpriseMenu.TAB_GENERAL] = function () { return true; };
	        _this.includeChecks[EnterpriseMenu.TAB_FILTER] = function () { return column.isFilterAllowed(); };
	        _this.includeChecks[EnterpriseMenu.TAB_COLUMNS] = function () { return true; };
	        _this.restrictTo = restrictTo;
	        return _this;
	    }
	    EnterpriseMenu.prototype.getMinDimensions = function () {
	        return this.tabbedLayout.getMinDimensions();
	    };
	    EnterpriseMenu.prototype.init = function () {
	        var _this = this;
	        var tabs = this.getTabsToCreate()
	            .map(function (menuTabName) { return _this.createTab(menuTabName); });
	        this.tabbedLayout = new ag_grid_community_1.TabbedLayout({
	            items: tabs,
	            cssClass: 'ag-menu',
	            onActiveItemClicked: this.onHidePopup.bind(this),
	            onItemClicked: this.onTabItemClicked.bind(this)
	        });
	    };
	    EnterpriseMenu.prototype.getTabsToCreate = function () {
	        var _this = this;
	        if (this.restrictTo) {
	            return this.restrictTo;
	        }
	        return this.column.getMenuTabs(EnterpriseMenu.TABS_DEFAULT)
	            .filter(function (tabName) { return _this.isValidMenuTabItem(tabName); })
	            .filter(function (tabName) { return _this.isNotSuppressed(tabName); });
	    };
	    EnterpriseMenu.prototype.isValidMenuTabItem = function (menuTabName) {
	        var isValid = true;
	        var itemsToConsider = EnterpriseMenu.TABS_DEFAULT;
	        if (this.restrictTo != null) {
	            isValid = this.restrictTo.indexOf(menuTabName) > -1;
	            itemsToConsider = this.restrictTo;
	        }
	        isValid = isValid && EnterpriseMenu.TABS_DEFAULT.indexOf(menuTabName) > -1;
	        if (!isValid) {
	            console.warn("Trying to render an invalid menu item '" + menuTabName + "'. Check that your 'menuTabs' contains one of [" + itemsToConsider + "]");
	        }
	        return isValid;
	    };
	    EnterpriseMenu.prototype.isNotSuppressed = function (menuTabName) {
	        return this.includeChecks[menuTabName]();
	    };
	    EnterpriseMenu.prototype.createTab = function (name) {
	        return this.tabFactories[name]();
	    };
	    EnterpriseMenu.prototype.showTabBasedOnPreviousSelection = function () {
	        // show the tab the user was on last time they had a menu open
	        this.showTab(this.initialSelection);
	    };
	    EnterpriseMenu.prototype.showTab = function (toShow) {
	        if (this.tabItemColumns && toShow === EnterpriseMenu.TAB_COLUMNS) {
	            this.tabbedLayout.showItem(this.tabItemColumns);
	        }
	        else if (this.tabItemFilter && toShow === EnterpriseMenu.TAB_FILTER) {
	            this.tabbedLayout.showItem(this.tabItemFilter);
	        }
	        else if (this.tabItemGeneral && toShow === EnterpriseMenu.TAB_GENERAL) {
	            this.tabbedLayout.showItem(this.tabItemGeneral);
	        }
	        else {
	            this.tabbedLayout.showFirstItem();
	        }
	    };
	    EnterpriseMenu.prototype.onTabItemClicked = function (event) {
	        var key = null;
	        switch (event.item) {
	            case this.tabItemColumns:
	                key = EnterpriseMenu.TAB_COLUMNS;
	                break;
	            case this.tabItemFilter:
	                key = EnterpriseMenu.TAB_FILTER;
	                break;
	            case this.tabItemGeneral:
	                key = EnterpriseMenu.TAB_GENERAL;
	                break;
	        }
	        if (key) {
	            var ev = {
	                type: EnterpriseMenu.EVENT_TAB_SELECTED,
	                key: key
	            };
	            this.dispatchEvent(ev);
	        }
	    };
	    EnterpriseMenu.prototype.destroy = function () {
	        if (this.columnSelectPanel) {
	            this.columnSelectPanel.destroy();
	        }
	        if (this.mainMenuList) {
	            this.mainMenuList.destroy();
	        }
	        _super.prototype.destroy.call(this);
	    };
	    EnterpriseMenu.prototype.getMenuItems = function () {
	        var defaultMenuOptions = this.getDefaultMenuOptions();
	        var result;
	        var userFunc = this.gridOptionsWrapper.getMainMenuItemsFunc();
	        if (userFunc) {
	            var userOptions = userFunc({
	                column: this.column,
	                api: this.gridOptionsWrapper.getApi(),
	                columnApi: this.gridOptionsWrapper.getColumnApi(),
	                context: this.gridOptionsWrapper.getContext(),
	                defaultItems: defaultMenuOptions
	            });
	            result = userOptions;
	        }
	        else {
	            result = defaultMenuOptions;
	        }
	        // GUI looks weird when two separators are side by side. this can happen accidentally
	        // if we remove items from the menu then two separators can edit up adjacent.
	        ag_grid_community_1._.removeRepeatsFromArray(result, EnterpriseMenu.MENU_ITEM_SEPARATOR);
	        return result;
	    };
	    EnterpriseMenu.prototype.getDefaultMenuOptions = function () {
	        var result = [];
	        var allowPinning = !this.column.getColDef().lockPinned;
	        var rowGroupCount = this.columnController.getRowGroupColumns().length;
	        var doingGrouping = rowGroupCount > 0;
	        var groupedByThisColumn = this.columnController.getRowGroupColumns().indexOf(this.column) >= 0;
	        var allowValue = this.column.isAllowValue();
	        var allowRowGroup = this.column.isAllowRowGroup();
	        var isPrimary = this.column.isPrimary();
	        var pivotModeOn = this.columnController.isPivotMode();
	        var isInMemoryRowModel = this.rowModel.getType() === ag_grid_community_1.Constants.ROW_MODEL_TYPE_CLIENT_SIDE;
	        var usingTreeData = this.gridOptionsWrapper.isTreeData();
	        var allowValueAgg = 
	        // if primary, then only allow aggValue if grouping and it's a value columns
	        (isPrimary && doingGrouping && allowValue)
	            // secondary columns can always have aggValue, as it means it's a pivot value column
	            || !isPrimary;
	        if (allowPinning) {
	            result.push('pinSubMenu');
	        }
	        if (allowValueAgg) {
	            result.push('valueAggSubMenu');
	        }
	        if (allowPinning || allowValueAgg) {
	            result.push(EnterpriseMenu.MENU_ITEM_SEPARATOR);
	        }
	        result.push('autoSizeThis');
	        result.push('autoSizeAll');
	        result.push(EnterpriseMenu.MENU_ITEM_SEPARATOR);
	        if (allowRowGroup && this.column.isPrimary()) {
	            if (groupedByThisColumn) {
	                result.push('rowUnGroup');
	            }
	            else {
	                result.push('rowGroup');
	            }
	        }
	        result.push(EnterpriseMenu.MENU_ITEM_SEPARATOR);
	        result.push('resetColumns');
	        // only add grouping expand/collapse if grouping in the InMemoryRowModel
	        // if pivoting, we only have expandable groups if grouping by 2 or more columns
	        // as the lowest level group is not expandable while pivoting.
	        // if not pivoting, then any active row group can be expanded.
	        var allowExpandAndContract = false;
	        if (isInMemoryRowModel) {
	            if (usingTreeData) {
	                allowExpandAndContract = true;
	            }
	            else {
	                allowExpandAndContract = pivotModeOn ? rowGroupCount > 1 : rowGroupCount > 0;
	            }
	        }
	        if (allowExpandAndContract) {
	            result.push('expandAll');
	            result.push('contractAll');
	        }
	        return result;
	    };
	    EnterpriseMenu.prototype.createMainPanel = function () {
	        this.mainMenuList = new menuList_1.MenuList();
	        this.getContext().wireBean(this.mainMenuList);
	        var menuItems = this.getMenuItems();
	        var menuItemsMapped = this.menuItemMapper.mapWithStockItems(menuItems, this.column);
	        this.mainMenuList.addMenuItems(menuItemsMapped);
	        this.mainMenuList.addEventListener(menuItemComponent_1.MenuItemComponent.EVENT_ITEM_SELECTED, this.onHidePopup.bind(this));
	        this.tabItemGeneral = {
	            title: ag_grid_community_1._.createIconNoSpan('menu', this.gridOptionsWrapper, this.column),
	            bodyPromise: ag_grid_community_1.Promise.resolve(this.mainMenuList.getGui()),
	            name: EnterpriseMenu.TAB_GENERAL
	        };
	        return this.tabItemGeneral;
	    };
	    EnterpriseMenu.prototype.onHidePopup = function () {
	        this.hidePopupFunc();
	    };
	    EnterpriseMenu.prototype.createFilterPanel = function () {
	        var filterWrapper = this.filterManager.getOrCreateFilterWrapper(this.column, 'COLUMN_MENU');
	        var afterFilterAttachedCallback = null;
	        // slightly odd block this - this promise will always have been resolved by the time it gets here, so won't be
	        // async (_unless_ in react or similar, but if so why not encountered before now?).
	        // I'd suggest a future improvement would be to remove/replace this promise as this block just wont work if it is
	        // async and is confusing if you don't have this context
	        filterWrapper.filterPromise.then(function (filter) {
	            if (filter.afterGuiAttached) {
	                afterFilterAttachedCallback = filter.afterGuiAttached.bind(filter);
	            }
	        });
	        this.tabItemFilter = {
	            title: ag_grid_community_1._.createIconNoSpan('filter', this.gridOptionsWrapper, this.column),
	            bodyPromise: filterWrapper.guiPromise.promise,
	            afterAttachedCallback: afterFilterAttachedCallback,
	            name: EnterpriseMenu.TAB_FILTER
	        };
	        return this.tabItemFilter;
	    };
	    EnterpriseMenu.prototype.createColumnsPanel = function () {
	        var eWrapperDiv = document.createElement('div');
	        ag_grid_community_1._.addCssClass(eWrapperDiv, 'ag-menu-column-select-wrapper');
	        this.columnSelectPanel = new primaryColsPanel_1.PrimaryColsPanel(false, {
	            suppressValues: false,
	            suppressPivots: false,
	            suppressRowGroups: false,
	            suppressPivotMode: false,
	            contractColumnSelection: false,
	            suppressColumnExpandAll: false,
	            suppressColumnFilter: false,
	            suppressColumnSelectAll: false,
	            suppressSideButtons: false,
	            api: this.gridApi
	        });
	        this.getContext().wireBean(this.columnSelectPanel);
	        eWrapperDiv.appendChild(this.columnSelectPanel.getGui());
	        this.tabItemColumns = {
	            title: ag_grid_community_1._.createIconNoSpan('columns', this.gridOptionsWrapper, this.column),
	            bodyPromise: ag_grid_community_1.Promise.resolve(eWrapperDiv),
	            name: EnterpriseMenu.TAB_COLUMNS
	        };
	        return this.tabItemColumns;
	    };
	    EnterpriseMenu.prototype.afterGuiAttached = function (params) {
	        var _this = this;
	        this.tabbedLayout.setAfterAttachedParams({ hidePopup: params.hidePopup });
	        this.hidePopupFunc = params.hidePopup;
	        var initialScroll = this.gridApi.getHorizontalPixelRange().left;
	        // if the body scrolls, we want to hide the menu, as the menu will not appear in the right location anymore
	        var onBodyScroll = function (event) {
	            // if h scroll, popup is no longer over the column
	            if (event.direction === 'horizontal') {
	                var newScroll = _this.gridApi.getHorizontalPixelRange().left;
	                if (Math.abs(newScroll - initialScroll) > _this.gridOptionsWrapper.getScrollbarWidth()) {
	                    params.hidePopup();
	                }
	            }
	        };
	        this.addDestroyFunc(params.hidePopup);
	        this.addDestroyableEventListener(this.eventService, 'bodyScroll', onBodyScroll);
	    };
	    EnterpriseMenu.prototype.getGui = function () {
	        return this.tabbedLayout.getGui();
	    };
	    EnterpriseMenu.EVENT_TAB_SELECTED = 'tabSelected';
	    EnterpriseMenu.TAB_FILTER = 'filterMenuTab';
	    EnterpriseMenu.TAB_GENERAL = 'generalMenuTab';
	    EnterpriseMenu.TAB_COLUMNS = 'columnsMenuTab';
	    EnterpriseMenu.TABS_DEFAULT = [EnterpriseMenu.TAB_GENERAL, EnterpriseMenu.TAB_FILTER, EnterpriseMenu.TAB_COLUMNS];
	    EnterpriseMenu.MENU_ITEM_SEPARATOR = 'separator';
	    __decorate([
	        ag_grid_community_1.Autowired('columnController'),
	        __metadata("design:type", ag_grid_community_1.ColumnController)
	    ], EnterpriseMenu.prototype, "columnController", void 0);
	    __decorate([
	        ag_grid_community_1.Autowired('filterManager'),
	        __metadata("design:type", ag_grid_community_1.FilterManager)
	    ], EnterpriseMenu.prototype, "filterManager", void 0);
	    __decorate([
	        ag_grid_community_1.Autowired('gridApi'),
	        __metadata("design:type", ag_grid_community_1.GridApi)
	    ], EnterpriseMenu.prototype, "gridApi", void 0);
	    __decorate([
	        ag_grid_community_1.Autowired('gridOptionsWrapper'),
	        __metadata("design:type", ag_grid_community_1.GridOptionsWrapper)
	    ], EnterpriseMenu.prototype, "gridOptionsWrapper", void 0);
	    __decorate([
	        ag_grid_community_1.Autowired('eventService'),
	        __metadata("design:type", ag_grid_community_1.EventService)
	    ], EnterpriseMenu.prototype, "eventService", void 0);
	    __decorate([
	        ag_grid_community_1.Autowired('menuItemMapper'),
	        __metadata("design:type", menuItemMapper_1.MenuItemMapper)
	    ], EnterpriseMenu.prototype, "menuItemMapper", void 0);
	    __decorate([
	        ag_grid_community_1.Autowired('rowModel'),
	        __metadata("design:type", Object)
	    ], EnterpriseMenu.prototype, "rowModel", void 0);
	    __decorate([
	        ag_grid_community_1.PostConstruct,
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", []),
	        __metadata("design:returntype", void 0)
	    ], EnterpriseMenu.prototype, "init", null);
	    return EnterpriseMenu;
	}(ag_grid_community_1.BeanStub));
	exports.EnterpriseMenu = EnterpriseMenu;


/***/ }),
/* 2508 */
/***/ (function(module, exports, __webpack_require__) {

	// ag-grid-enterprise v21.2.2
	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var ag_grid_community_1 = __webpack_require__(2322);
	var menuItemComponent_1 = __webpack_require__(2509);
	var MenuList = /** @class */ (function (_super) {
	    __extends(MenuList, _super);
	    function MenuList() {
	        var _this = _super.call(this, MenuList.TEMPLATE) || this;
	        _this.timerCount = 0;
	        _this.removeChildFuncs = [];
	        return _this;
	    }
	    MenuList.prototype.clearActiveItem = function () {
	        this.removeActiveItem();
	        this.removeChildPopup();
	    };
	    MenuList.prototype.addMenuItems = function (menuItems) {
	        var _this = this;
	        if (!menuItems || ag_grid_community_1._.missing(menuItems)) {
	            return;
	        }
	        menuItems.forEach(function (menuItemOrString) {
	            if (menuItemOrString === 'separator') {
	                _this.addSeparator();
	            }
	            else if (typeof menuItemOrString === 'string') {
	                console.warn("ag-Grid: unrecognised menu item " + menuItemOrString);
	            }
	            else {
	                var menuItem = menuItemOrString;
	                _this.addItem(menuItem);
	            }
	        });
	    };
	    MenuList.prototype.addItem = function (menuItemDef) {
	        var _this = this;
	        var cMenuItem = new menuItemComponent_1.MenuItemComponent(menuItemDef);
	        this.getContext().wireBean(cMenuItem);
	        this.getGui().appendChild(cMenuItem.getGui());
	        this.addDestroyFunc(function () { return cMenuItem.destroy(); });
	        cMenuItem.addEventListener(menuItemComponent_1.MenuItemComponent.EVENT_ITEM_SELECTED, function (event) {
	            if (menuItemDef.subMenu && !menuItemDef.action) {
	                _this.showChildMenu(menuItemDef, cMenuItem, event.mouseEvent);
	            }
	            else {
	                _this.dispatchEvent(event);
	            }
	        });
	        cMenuItem.addGuiEventListener('mouseenter', this.mouseEnterItem.bind(this, menuItemDef, cMenuItem));
	        cMenuItem.addGuiEventListener('mouseleave', function () { return _this.timerCount++; });
	    };
	    MenuList.prototype.mouseEnterItem = function (menuItemParams, menuItem) {
	        if (menuItemParams.disabled) {
	            return;
	        }
	        if (this.activeMenuItemParams !== menuItemParams) {
	            this.removeChildPopup();
	        }
	        this.removeActiveItem();
	        this.activeMenuItemParams = menuItemParams;
	        this.activeMenuItem = menuItem;
	        ag_grid_community_1._.addCssClass(this.activeMenuItem.getGui(), 'ag-menu-option-active');
	        if (menuItemParams.subMenu) {
	            this.addHoverForChildPopup(menuItemParams, menuItem);
	        }
	    };
	    MenuList.prototype.removeActiveItem = function () {
	        if (this.activeMenuItem) {
	            ag_grid_community_1._.removeCssClass(this.activeMenuItem.getGui(), 'ag-menu-option-active');
	            this.activeMenuItem = null;
	            this.activeMenuItemParams = null;
	        }
	    };
	    MenuList.prototype.addHoverForChildPopup = function (menuItemDef, menuItemComp) {
	        var _this = this;
	        var timerCountCopy = this.timerCount;
	        window.setTimeout(function () {
	            var shouldShow = timerCountCopy === _this.timerCount;
	            var showingThisMenu = _this.subMenuParentDef === menuItemDef;
	            if (shouldShow && !showingThisMenu) {
	                _this.showChildMenu(menuItemDef, menuItemComp, null);
	            }
	        }, 300);
	    };
	    MenuList.prototype.addSeparator = function () {
	        this.getGui().appendChild(ag_grid_community_1._.loadTemplate(MenuList.SEPARATOR_TEMPLATE));
	    };
	    MenuList.prototype.showChildMenu = function (menuItemDef, menuItemComp, mouseEvent) {
	        var _this = this;
	        this.removeChildPopup();
	        var childMenu = new MenuList();
	        this.getContext().wireBean(childMenu);
	        childMenu.addMenuItems(menuItemDef.subMenu);
	        var ePopup = ag_grid_community_1._.loadTemplate('<div class="ag-menu"></div>');
	        ePopup.appendChild(childMenu.getGui());
	        var hidePopupFunc = this.popupService.addAsModalPopup(ePopup, true, undefined, mouseEvent);
	        this.popupService.positionPopupForMenu({
	            eventSource: menuItemComp.getGui(),
	            ePopup: ePopup
	        });
	        this.subMenuParentDef = menuItemDef;
	        var selectedListener = function (event) {
	            _this.dispatchEvent(event);
	        };
	        childMenu.addEventListener(menuItemComponent_1.MenuItemComponent.EVENT_ITEM_SELECTED, selectedListener);
	        this.removeChildFuncs.push(function () {
	            childMenu.clearActiveItem();
	            childMenu.destroy();
	            _this.subMenuParentDef = null;
	            childMenu.removeEventListener(menuItemComponent_1.MenuItemComponent.EVENT_ITEM_SELECTED, selectedListener);
	            hidePopupFunc();
	        });
	    };
	    MenuList.prototype.removeChildPopup = function () {
	        this.removeChildFuncs.forEach(function (func) { return func(); });
	        this.removeChildFuncs = [];
	    };
	    MenuList.prototype.destroy = function () {
	        this.removeChildPopup();
	        _super.prototype.destroy.call(this);
	    };
	    // private instance = Math.random();
	    MenuList.TEMPLATE = '<div class="ag-menu-list"></div>';
	    MenuList.SEPARATOR_TEMPLATE = "<div class=\"ag-menu-separator\">\n            <span class=\"ag-menu-separator-cell\"></span>\n            <span class=\"ag-menu-separator-cell\"></span>\n            <span class=\"ag-menu-separator-cell\"></span>\n            <span class=\"ag-menu-separator-cell\"></span>\n        </div>";
	    __decorate([
	        ag_grid_community_1.Autowired('popupService'),
	        __metadata("design:type", ag_grid_community_1.PopupService)
	    ], MenuList.prototype, "popupService", void 0);
	    return MenuList;
	}(ag_grid_community_1.Component));
	exports.MenuList = MenuList;


/***/ }),
/* 2509 */
/***/ (function(module, exports, __webpack_require__) {

	// ag-grid-enterprise v21.2.2
	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var ag_grid_community_1 = __webpack_require__(2322);
	var MenuItemComponent = /** @class */ (function (_super) {
	    __extends(MenuItemComponent, _super);
	    function MenuItemComponent(params) {
	        var _this = _super.call(this, MenuItemComponent.TEMPLATE) || this;
	        _this.params = params;
	        return _this;
	    }
	    MenuItemComponent.prototype.init = function () {
	        var _this = this;
	        if (this.params.checked) {
	            this.eIcon.appendChild(ag_grid_community_1._.createIconNoSpan('check', this.gridOptionsWrapper));
	        }
	        else if (this.params.icon) {
	            if (ag_grid_community_1._.isNodeOrElement(this.params.icon)) {
	                this.eIcon.appendChild(this.params.icon);
	            }
	            else if (typeof this.params.icon === 'string') {
	                this.eIcon.innerHTML = this.params.icon;
	            }
	            else {
	                console.warn('ag-Grid: menu item icon must be DOM node or string');
	            }
	        }
	        else {
	            // if i didn't put space here, the alignment was messed up, probably
	            // fixable with CSS but i was spending to much time trying to figure
	            // it out.
	            this.eIcon.innerHTML = '&nbsp;';
	        }
	        if (this.params.tooltip) {
	            this.tooltip = this.params.tooltip;
	            if (this.gridOptionsWrapper.isEnableBrowserTooltips()) {
	                this.getGui().setAttribute('title', this.tooltip);
	            }
	            else {
	                this.tooltipManager.registerTooltip(this);
	            }
	        }
	        if (this.params.shortcut) {
	            this.eShortcut.innerHTML = this.params.shortcut;
	        }
	        if (this.params.subMenu) {
	            if (this.gridOptionsWrapper.isEnableRtl()) {
	                // for RTL, we show arrow going left
	                this.ePopupPointer.appendChild(ag_grid_community_1._.createIconNoSpan('smallLeft', this.gridOptionsWrapper));
	            }
	            else {
	                // for normal, we show arrow going right
	                this.ePopupPointer.appendChild(ag_grid_community_1._.createIconNoSpan('smallRight', this.gridOptionsWrapper));
	            }
	        }
	        else {
	            this.ePopupPointer.innerHTML = '&nbsp;';
	        }
	        this.eName.innerHTML = this.params.name;
	        if (this.params.disabled) {
	            ag_grid_community_1._.addCssClass(this.getGui(), 'ag-menu-option-disabled');
	        }
	        else {
	            this.addGuiEventListener('click', this.onOptionSelected.bind(this));
	        }
	        if (this.params.cssClasses) {
	            this.params.cssClasses.forEach(function (it) { return ag_grid_community_1._.addCssClass(_this.getGui(), it); });
	        }
	    };
	    MenuItemComponent.prototype.getTooltipText = function () {
	        return this.tooltip;
	    };
	    MenuItemComponent.prototype.getComponentHolder = function () {
	        return undefined;
	    };
	    MenuItemComponent.prototype.onOptionSelected = function (mouseEvent) {
	        var event = {
	            type: MenuItemComponent.EVENT_ITEM_SELECTED,
	            action: this.params.action,
	            checked: this.params.checked,
	            cssClasses: this.params.cssClasses,
	            disabled: this.params.disabled,
	            icon: this.params.icon,
	            name: this.params.name,
	            shortcut: this.params.shortcut,
	            subMenu: this.params.subMenu,
	            tooltip: this.params.tooltip,
	            mouseEvent: mouseEvent
	        };
	        this.dispatchEvent(event);
	        if (this.params.action) {
	            this.params.action();
	        }
	    };
	    MenuItemComponent.prototype.destroy = function () {
	        // console.log('MenuItemComponent->destroy() ' + this.instance);
	        _super.prototype.destroy.call(this);
	    };
	    // private instance = Math.random();
	    MenuItemComponent.TEMPLATE = "<div class=\"ag-menu-option\">\n            <span ref=\"eIcon\" class=\"ag-menu-option-icon\"></span>\n            <span ref=\"eName\" class=\"ag-menu-option-text\"></span>\n            <span ref=\"eShortcut\" class=\"ag-menu-option-shortcut\"></span>\n            <span ref=\"ePopupPointer\" class=\"ag-menu-option-popup-pointer\"></span>\n        </div>";
	    MenuItemComponent.EVENT_ITEM_SELECTED = 'itemSelected';
	    __decorate([
	        ag_grid_community_1.Autowired('gridOptionsWrapper'),
	        __metadata("design:type", ag_grid_community_1.GridOptionsWrapper)
	    ], MenuItemComponent.prototype, "gridOptionsWrapper", void 0);
	    __decorate([
	        ag_grid_community_1.Autowired('tooltipManager'),
	        __metadata("design:type", ag_grid_community_1.TooltipManager)
	    ], MenuItemComponent.prototype, "tooltipManager", void 0);
	    __decorate([
	        ag_grid_community_1.RefSelector('eIcon'),
	        __metadata("design:type", HTMLElement)
	    ], MenuItemComponent.prototype, "eIcon", void 0);
	    __decorate([
	        ag_grid_community_1.RefSelector('eName'),
	        __metadata("design:type", HTMLElement)
	    ], MenuItemComponent.prototype, "eName", void 0);
	    __decorate([
	        ag_grid_community_1.RefSelector('eShortcut'),
	        __metadata("design:type", HTMLElement)
	    ], MenuItemComponent.prototype, "eShortcut", void 0);
	    __decorate([
	        ag_grid_community_1.RefSelector('ePopupPointer'),
	        __metadata("design:type", HTMLElement)
	    ], MenuItemComponent.prototype, "ePopupPointer", void 0);
	    __decorate([
	        ag_grid_community_1.PostConstruct,
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", []),
	        __metadata("design:returntype", void 0)
	    ], MenuItemComponent.prototype, "init", null);
	    return MenuItemComponent;
	}(ag_grid_community_1.Component));
	exports.MenuItemComponent = MenuItemComponent;


/***/ }),
/* 2510 */
/***/ (function(module, exports, __webpack_require__) {

	// ag-grid-enterprise v21.2.2
	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var ag_grid_community_1 = __webpack_require__(2322);
	var clipboardService_1 = __webpack_require__(2511);
	var aggFuncService_1 = __webpack_require__(2513);
	var MenuItemMapper = /** @class */ (function () {
	    function MenuItemMapper() {
	    }
	    MenuItemMapper.prototype.mapWithStockItems = function (originalList, column) {
	        var _this = this;
	        if (!originalList) {
	            return [];
	        }
	        var resultList = [];
	        originalList.forEach(function (menuItemOrString) {
	            var result;
	            if (typeof menuItemOrString === 'string') {
	                result = _this.getStockMenuItem(menuItemOrString, column);
	            }
	            else {
	                result = menuItemOrString;
	            }
	            if (result.subMenu) {
	                var resultDef = result;
	                resultDef.subMenu = _this.mapWithStockItems(resultDef.subMenu, column);
	            }
	            if (result != null) {
	                resultList.push(result);
	            }
	        });
	        return resultList;
	    };
	    MenuItemMapper.prototype.getStockMenuItem = function (key, column) {
	        var _this = this;
	        var localeTextFunc = this.gridOptionsWrapper.getLocaleTextFunc();
	        switch (key) {
	            case 'pinSubMenu':
	                return {
	                    name: localeTextFunc('pinColumn', 'Pin Column'),
	                    icon: ag_grid_community_1._.createIconNoSpan('menuPin', this.gridOptionsWrapper, null),
	                    subMenu: ['pinLeft', 'pinRight', 'clearPinned']
	                };
	            case 'pinLeft':
	                return {
	                    name: localeTextFunc('pinLeft', 'Pin Left'),
	                    action: function () { return _this.columnController.setColumnPinned(column, ag_grid_community_1.Column.PINNED_LEFT, "contextMenu"); },
	                    checked: column.isPinnedLeft()
	                };
	            case 'pinRight':
	                return {
	                    name: localeTextFunc('pinRight', 'Pin Right'),
	                    action: function () { return _this.columnController.setColumnPinned(column, ag_grid_community_1.Column.PINNED_RIGHT, "contextMenu"); },
	                    checked: column.isPinnedRight()
	                };
	            case 'clearPinned':
	                return {
	                    name: localeTextFunc('noPin', 'No Pin'),
	                    action: function () { return _this.columnController.setColumnPinned(column, null, "contextMenu"); },
	                    checked: !column.isPinned()
	                };
	            case 'valueAggSubMenu':
	                return {
	                    name: localeTextFunc('valueAggregation', 'Value Aggregation'),
	                    icon: ag_grid_community_1._.createIconNoSpan('menuValue', this.gridOptionsWrapper, null),
	                    subMenu: this.createAggregationSubMenu(column)
	                };
	            case 'autoSizeThis':
	                return {
	                    name: localeTextFunc('autosizeThiscolumn', 'Autosize This Column'),
	                    action: function () { return _this.columnController.autoSizeColumn(column, "contextMenu"); }
	                };
	            case 'autoSizeAll':
	                return {
	                    name: localeTextFunc('autosizeAllColumns', 'Autosize All Columns'),
	                    action: function () { return _this.columnController.autoSizeAllColumns("contextMenu"); }
	                };
	            case 'rowGroup':
	                return {
	                    name: localeTextFunc('groupBy', 'Group by') + ' ' + ag_grid_community_1._.escape(this.columnController.getDisplayNameForColumn(column, 'header')),
	                    action: function () { return _this.columnController.addRowGroupColumn(column, "contextMenu"); },
	                    icon: ag_grid_community_1._.createIconNoSpan('menuAddRowGroup', this.gridOptionsWrapper, null)
	                };
	            case 'rowUnGroup':
	                return {
	                    name: localeTextFunc('ungroupBy', 'Un-Group by') + ' ' + ag_grid_community_1._.escape(this.columnController.getDisplayNameForColumn(column, 'header')),
	                    action: function () { return _this.columnController.removeRowGroupColumn(column, "contextMenu"); },
	                    icon: ag_grid_community_1._.createIconNoSpan('menuRemoveRowGroup', this.gridOptionsWrapper, null)
	                };
	            case 'resetColumns':
	                return {
	                    name: localeTextFunc('resetColumns', 'Reset Columns'),
	                    action: function () { return _this.columnController.resetColumnState(false, "contextMenu"); }
	                };
	            case 'expandAll':
	                return {
	                    name: localeTextFunc('expandAll', 'Expand All'),
	                    action: function () { return _this.gridApi.expandAll(); }
	                };
	            case 'contractAll':
	                return {
	                    name: localeTextFunc('collapseAll', 'Collapse All'),
	                    action: function () { return _this.gridApi.collapseAll(); }
	                };
	            case 'copy':
	                return {
	                    name: localeTextFunc('copy', 'Copy'),
	                    shortcut: localeTextFunc('ctrlC', 'Ctrl+C'),
	                    icon: ag_grid_community_1._.createIconNoSpan('clipboardCopy', this.gridOptionsWrapper, null),
	                    action: function () { return _this.clipboardService.copyToClipboard(false); }
	                };
	            case 'copyWithHeaders':
	                return {
	                    name: localeTextFunc('copyWithHeaders', 'Copy with Headers'),
	                    // shortcut: localeTextFunc('ctrlC','Ctrl+C'),
	                    icon: ag_grid_community_1._.createIconNoSpan('clipboardCopy', this.gridOptionsWrapper, null),
	                    action: function () { return _this.clipboardService.copyToClipboard(true); }
	                };
	            case 'paste':
	                return {
	                    name: localeTextFunc('paste', 'Paste'),
	                    shortcut: localeTextFunc('ctrlV', 'Ctrl+V'),
	                    disabled: true,
	                    icon: ag_grid_community_1._.createIconNoSpan('clipboardPaste', this.gridOptionsWrapper, null),
	                    action: function () { return _this.clipboardService.pasteFromClipboard(); }
	                };
	            case 'export':
	                var exportSubMenuItems = [];
	                if (!this.gridOptionsWrapper.isSuppressCsvExport()) {
	                    exportSubMenuItems.push('csvExport');
	                }
	                if (!this.gridOptionsWrapper.isSuppressExcelExport()) {
	                    exportSubMenuItems.push('excelExport');
	                    exportSubMenuItems.push('excelXmlExport');
	                }
	                return {
	                    name: localeTextFunc('export', 'Export'),
	                    subMenu: exportSubMenuItems,
	                    icon: ag_grid_community_1._.createIconNoSpan('save', this.gridOptionsWrapper, null),
	                };
	            case 'csvExport':
	                return {
	                    name: localeTextFunc('csvExport', 'CSV Export'),
	                    action: function () { return _this.gridApi.exportDataAsCsv({}); }
	                };
	            case 'excelExport':
	                return {
	                    name: localeTextFunc('excelExport', 'Excel Export (.xlsx)&lrm;'),
	                    action: function () { return _this.gridApi.exportDataAsExcel({
	                        exportMode: 'xlsx'
	                    }); }
	                };
	            case 'excelXmlExport':
	                return {
	                    name: localeTextFunc('excelXmlExport', 'Excel Export (.xml)&lrm;'),
	                    action: function () { return _this.gridApi.exportDataAsExcel({
	                        exportMode: 'xml'
	                    }); }
	                };
	            case 'separator':
	                return 'separator';
	            default:
	                var chartMenuItem = this.getChartItems(key);
	                if (chartMenuItem) {
	                    return chartMenuItem;
	                }
	                else {
	                    console.warn("ag-Grid: unknown menu item type " + key);
	                    return null;
	                }
	        }
	    };
	    MenuItemMapper.prototype.getChartItems = function (key) {
	        var _this = this;
	        var localeTextFunc = this.gridOptionsWrapper.getLocaleTextFunc();
	        var pivotChartMenuItem = function (localeKey, defaultText, chartType) {
	            return {
	                name: localeTextFunc(localeKey, defaultText),
	                action: function () { return _this.chartService.pivotChart(chartType); }
	            };
	        };
	        var rangeChartMenuItem = function (localeKey, defaultText, chartType) {
	            return {
	                name: localeTextFunc(localeKey, defaultText),
	                action: function () { return _this.chartService.chartCurrentRange(chartType); }
	            };
	        };
	        switch (key) {
	            // case 'pivotChartAndPivotMode':
	            //     return {
	            //         name: localeTextFunc('pivotChartAndPivotMode', 'Pivot Chart & Pivot Mode&lrm;'),
	            //         action: () => this.chartService.pivotChart(ChartType.GroupedColumn),
	            //         icon: _.createIconNoSpan('chart', this.gridOptionsWrapper, null)
	            //     };
	            case 'pivotChart':
	                return {
	                    name: localeTextFunc('pivotChart', 'Pivot Chart'),
	                    subMenu: [
	                        'pivotColumnChart',
	                        'pivotBarChart',
	                        'pivotPieChart',
	                        'pivotLineChart',
	                        'pivotXYChart',
	                        'pivotAreaChart'
	                    ],
	                    icon: ag_grid_community_1._.createIconNoSpan('chart', this.gridOptionsWrapper, null),
	                };
	            case 'chartRange':
	                return {
	                    name: localeTextFunc('chartRange', 'Chart Range'),
	                    subMenu: [
	                        'rangeColumnChart',
	                        'rangeBarChart',
	                        'rangePieChart',
	                        'rangeLineChart',
	                        'rangeXYChart',
	                        'rangeAreaChart'
	                    ],
	                    icon: ag_grid_community_1._.createIconNoSpan('chart', this.gridOptionsWrapper, null),
	                };
	            case 'pivotColumnChart':
	                return {
	                    name: localeTextFunc('columnChart', 'Column'),
	                    subMenu: ['pivotGroupedColumn', 'pivotStackedColumn', 'pivotNormalizedColumn']
	                };
	            case 'pivotGroupedColumn':
	                return pivotChartMenuItem('groupedColumn', 'Grouped&lrm;', ag_grid_community_1.ChartType.GroupedColumn);
	            case 'pivotStackedColumn':
	                return pivotChartMenuItem('stackedColumn', 'Stacked&lrm;', ag_grid_community_1.ChartType.StackedColumn);
	            case 'pivotNormalizedColumn':
	                return pivotChartMenuItem('normalizedColumn', '100% Stacked&lrm;', ag_grid_community_1.ChartType.NormalizedColumn);
	            case 'rangeColumnChart':
	                return {
	                    name: localeTextFunc('columnChart', 'Column'),
	                    subMenu: ['rangeGroupedColumn', 'rangeStackedColumn', 'rangeNormalizedColumn']
	                };
	            case 'rangeGroupedColumn':
	                return rangeChartMenuItem('groupedColumn', 'Grouped&lrm;', ag_grid_community_1.ChartType.GroupedColumn);
	            case 'rangeStackedColumn':
	                return rangeChartMenuItem('stackedColumn', 'Stacked&lrm;', ag_grid_community_1.ChartType.StackedColumn);
	            case 'rangeNormalizedColumn':
	                return rangeChartMenuItem('normalizedColumn', '100% Stacked&lrm;', ag_grid_community_1.ChartType.NormalizedColumn);
	            case 'pivotBarChart':
	                return {
	                    name: localeTextFunc('barChart', 'Bar'),
	                    subMenu: ['pivotGroupedBar', 'pivotStackedBar', 'pivotNormalizedBar']
	                };
	            case 'pivotGroupedBar':
	                return pivotChartMenuItem('groupedBar', 'Grouped&lrm;', ag_grid_community_1.ChartType.GroupedBar);
	            case 'pivotStackedBar':
	                return pivotChartMenuItem('stackedBar', 'Stacked&lrm;', ag_grid_community_1.ChartType.StackedBar);
	            case 'pivotNormalizedBar':
	                return pivotChartMenuItem('normalizedBar', '100% Stacked&lrm;', ag_grid_community_1.ChartType.NormalizedBar);
	            case 'rangeBarChart':
	                return {
	                    name: localeTextFunc('barChart', 'Bar'),
	                    subMenu: ['rangeGroupedBar', 'rangeStackedBar', 'rangeNormalizedBar']
	                };
	            case 'rangeGroupedBar':
	                return rangeChartMenuItem('groupedBar', 'Grouped&lrm;', ag_grid_community_1.ChartType.GroupedBar);
	            case 'rangeStackedBar':
	                return rangeChartMenuItem('stackedBar', 'Stacked&lrm;', ag_grid_community_1.ChartType.StackedBar);
	            case 'rangeNormalizedBar':
	                return rangeChartMenuItem('normalizedBar', '100% Stacked&lrm;', ag_grid_community_1.ChartType.NormalizedBar);
	            case 'pivotPieChart':
	                return {
	                    name: localeTextFunc('pieChart', 'Pie'),
	                    subMenu: ['pivotPie', 'pivotDoughnut']
	                };
	            case 'pivotPie':
	                return pivotChartMenuItem('pie', 'Pie&lrm;', ag_grid_community_1.ChartType.Pie);
	            case 'pivotDoughnut':
	                return pivotChartMenuItem('doughnut', 'Doughnut&lrm;', ag_grid_community_1.ChartType.Doughnut);
	            case 'rangePieChart':
	                return {
	                    name: localeTextFunc('pieChart', 'Pie'),
	                    subMenu: ['rangePie', 'rangeDoughnut']
	                };
	            case 'rangePie':
	                return rangeChartMenuItem('pie', 'Pie&lrm;', ag_grid_community_1.ChartType.Pie);
	            case 'rangeDoughnut':
	                return rangeChartMenuItem('doughnut', 'Doughnut&lrm;', ag_grid_community_1.ChartType.Doughnut);
	            case 'pivotLineChart':
	                return pivotChartMenuItem('line', 'Line&lrm;', ag_grid_community_1.ChartType.Line);
	            case 'rangeLineChart':
	                return rangeChartMenuItem('line', 'Line&lrm;', ag_grid_community_1.ChartType.Line);
	            case 'pivotXYChart':
	                return {
	                    name: localeTextFunc('xyChart', 'X Y (Scatter)'),
	                    subMenu: ['pivotScatter', 'pivotBubble']
	                };
	            case 'pivotScatter':
	                return pivotChartMenuItem('scatter', 'Scatter&lrm;', ag_grid_community_1.ChartType.Scatter);
	            case 'pivotBubble':
	                return pivotChartMenuItem('bubble', 'Bubble&lrm;', ag_grid_community_1.ChartType.Bubble);
	            case 'rangeXYChart':
	                return {
	                    name: localeTextFunc('xyChart', 'X Y (Scatter)'),
	                    subMenu: ['rangeScatter', 'rangeBubble']
	                };
	            case 'rangeScatter':
	                return rangeChartMenuItem('scatter', 'Scatter&lrm;', ag_grid_community_1.ChartType.Scatter);
	            case 'rangeBubble':
	                return rangeChartMenuItem('bubble', 'Bubble&lrm;', ag_grid_community_1.ChartType.Bubble);
	            case 'pivotAreaChart':
	                return {
	                    name: localeTextFunc('areaChart', 'Area'),
	                    subMenu: ['pivotArea', 'pivotStackedArea', 'pivotNormalizedArea']
	                };
	            case 'pivotArea':
	                return pivotChartMenuItem('area', 'Area&lrm;', ag_grid_community_1.ChartType.Area);
	            case 'pivotStackedArea':
	                return pivotChartMenuItem('stackedArea', 'Stacked&lrm;', ag_grid_community_1.ChartType.StackedArea);
	            case 'pivotNormalizedArea':
	                return pivotChartMenuItem('normalizedArea', '100% Stacked&lrm;', ag_grid_community_1.ChartType.NormalizedArea);
	            case 'rangeAreaChart':
	                return {
	                    name: localeTextFunc('areaChart', 'Area'),
	                    subMenu: ['rangeArea', 'rangeStackedArea', 'rangeNormalizedArea']
	                };
	            case 'rangeArea':
	                return rangeChartMenuItem('area', 'Area&lrm;', ag_grid_community_1.ChartType.Area);
	            case 'rangeStackedArea':
	                return rangeChartMenuItem('stackedArea', 'Stacked&lrm;', ag_grid_community_1.ChartType.StackedArea);
	            case 'rangeNormalizedArea':
	                return rangeChartMenuItem('normalizedArea', '100% Stacked&lrm;', ag_grid_community_1.ChartType.NormalizedArea);
	            default:
	                return null;
	        }
	    };
	    MenuItemMapper.prototype.createAggregationSubMenu = function (column) {
	        var _this = this;
	        var localeTextFunc = this.gridOptionsWrapper.getLocaleTextFunc();
	        var columnIsAlreadyAggValue = column.isValueActive();
	        var funcNames = this.aggFuncService.getFuncNames(column);
	        var columnToUse;
	        if (column.isPrimary()) {
	            columnToUse = column;
	        }
	        else {
	            var pivotValueColumn = column.getColDef().pivotValueColumn;
	            columnToUse = ag_grid_community_1._.exists(pivotValueColumn) ? pivotValueColumn : undefined;
	        }
	        var result = [];
	        funcNames.forEach(function (funcName) {
	            result.push({
	                name: localeTextFunc(funcName, funcName),
	                action: function () {
	                    _this.columnController.setColumnAggFunc(columnToUse, funcName, "contextMenu");
	                    _this.columnController.addValueColumn(columnToUse, "contextMenu");
	                },
	                checked: columnIsAlreadyAggValue && columnToUse.getAggFunc() === funcName
	            });
	        });
	        return result;
	    };
	    __decorate([
	        ag_grid_community_1.Autowired('gridOptionsWrapper'),
	        __metadata("design:type", ag_grid_community_1.GridOptionsWrapper)
	    ], MenuItemMapper.prototype, "gridOptionsWrapper", void 0);
	    __decorate([
	        ag_grid_community_1.Autowired('columnController'),
	        __metadata("design:type", ag_grid_community_1.ColumnController)
	    ], MenuItemMapper.prototype, "columnController", void 0);
	    __decorate([
	        ag_grid_community_1.Autowired('gridApi'),
	        __metadata("design:type", ag_grid_community_1.GridApi)
	    ], MenuItemMapper.prototype, "gridApi", void 0);
	    __decorate([
	        ag_grid_community_1.Autowired('clipboardService'),
	        __metadata("design:type", clipboardService_1.ClipboardService)
	    ], MenuItemMapper.prototype, "clipboardService", void 0);
	    __decorate([
	        ag_grid_community_1.Autowired('aggFuncService'),
	        __metadata("design:type", aggFuncService_1.AggFuncService)
	    ], MenuItemMapper.prototype, "aggFuncService", void 0);
	    __decorate([
	        ag_grid_community_1.Optional('chartService'),
	        __metadata("design:type", Object)
	    ], MenuItemMapper.prototype, "chartService", void 0);
	    MenuItemMapper = __decorate([
	        ag_grid_community_1.Bean('menuItemMapper')
	    ], MenuItemMapper);
	    return MenuItemMapper;
	}());
	exports.MenuItemMapper = MenuItemMapper;


/***/ }),
/* 2511 */
/***/ (function(module, exports, __webpack_require__) {

	// ag-grid-enterprise v21.2.2
	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var ag_grid_community_1 = __webpack_require__(2322);
	var rangeController_1 = __webpack_require__(2512);
	var ClipboardService = /** @class */ (function () {
	    function ClipboardService() {
	        this.pasteOperationActive = false;
	    }
	    ClipboardService.prototype.isPasteOperationActive = function () {
	        return this.pasteOperationActive;
	    };
	    ClipboardService.prototype.registerGridCore = function (gridCore) {
	        this.gridCore = gridCore;
	    };
	    ClipboardService.prototype.init = function () {
	        this.logger = this.loggerFactory.create('ClipboardService');
	        if (this.rowModel.getType() === ag_grid_community_1.Constants.ROW_MODEL_TYPE_CLIENT_SIDE) {
	            this.clientSideRowModel = this.rowModel;
	        }
	    };
	    ClipboardService.prototype.pasteFromClipboard = function () {
	        var _this = this;
	        this.logger.log('pasteFromClipboard');
	        this.executeOnTempElement(function (textArea) {
	            textArea.focus();
	        }, function (element) {
	            var data = element.value;
	            if (ag_grid_community_1._.missingOrEmpty(data)) {
	                return;
	            }
	            var parsedData = _this.dataToArray(data);
	            var userFunc = _this.gridOptionsWrapper.getProcessDataFromClipboardFunc();
	            if (userFunc) {
	                parsedData = userFunc({ data: parsedData });
	            }
	            if (ag_grid_community_1._.missingOrEmpty(parsedData)) {
	                return;
	            }
	            _this.eventService.dispatchEvent({
	                type: ag_grid_community_1.Events.EVENT_PASTE_START,
	                api: _this.gridOptionsWrapper.getApi(),
	                columnApi: _this.gridOptionsWrapper.getColumnApi(),
	                source: 'clipboard'
	            });
	            var singleCellInClipboard = parsedData.length == 1 && parsedData[0].length == 1;
	            var rangeActive = _this.rangeController.isMoreThanOneCell();
	            rangeActive && !singleCellInClipboard ?
	                _this.pasteIntoActiveRange(parsedData) : _this.pasteStartingFromFocusedCell(parsedData);
	            _this.eventService.dispatchEvent({
	                type: ag_grid_community_1.Events.EVENT_PASTE_END,
	                api: _this.gridOptionsWrapper.getApi(),
	                columnApi: _this.gridOptionsWrapper.getColumnApi(),
	                source: 'clipboard'
	            });
	        });
	    };
	    ClipboardService.prototype.pasteIntoActiveRange = function (clipboardData) {
	        var _this = this;
	        var cellsToFlash = {};
	        var updatedRowNodes = [];
	        var updatedColumnIds = [];
	        var focusedCell = this.focusedCellController.getFocusedCell();
	        // true if clipboard data can be evenly pasted into range, otherwise false
	        var abortRepeatingPasteIntoRows = this.rangeSize() % clipboardData.length != 0;
	        var indexOffset = 0, dataRowIndex = 0;
	        var rowCallback = function (currentRow, rowNode, columns, index, isLastRow) {
	            var atEndOfClipboardData = index - indexOffset >= clipboardData.length;
	            if (atEndOfClipboardData) {
	                if (abortRepeatingPasteIntoRows) {
	                    return;
	                }
	                // increment offset and reset data index to repeat paste of data
	                indexOffset += dataRowIndex;
	                dataRowIndex = 0;
	            }
	            var currentRowData = clipboardData[index - indexOffset];
	            // otherwise we are not the first row, so copy
	            updatedRowNodes.push(rowNode);
	            columns.forEach(function (column, idx) {
	                if (!column.isCellEditable(rowNode)) {
	                    return;
	                }
	                // repeat data for columns we don't have data for - happens when to range is bigger than copied data range
	                if (idx >= currentRowData.length) {
	                    idx = idx % currentRowData.length;
	                }
	                var firstRowValue = currentRowData[idx];
	                var processCellFromClipboardFunc = _this.gridOptionsWrapper.getProcessCellFromClipboardFunc();
	                firstRowValue = _this.userProcessCell(rowNode, column, firstRowValue, processCellFromClipboardFunc, ag_grid_community_1.Constants.EXPORT_TYPE_DRAG_COPY);
	                _this.valueService.setValue(rowNode, column, firstRowValue);
	                var cellPosition = {
	                    rowIndex: currentRow.rowIndex,
	                    rowPinned: currentRow.rowPinned,
	                    column: column
	                };
	                var cellId = _this.cellPositionUtils.createId(cellPosition);
	                cellsToFlash[cellId] = true;
	            });
	            dataRowIndex++;
	        };
	        this.iterateActiveRanges(false, rowCallback);
	        this.rowRenderer.refreshCells({ rowNodes: updatedRowNodes, columns: updatedColumnIds });
	        this.dispatchFlashCells(cellsToFlash);
	        if (focusedCell) {
	            this.focusedCellController.setFocusedCell(focusedCell.rowIndex, focusedCell.column, focusedCell.rowPinned, true);
	        }
	        this.fireRowChanged(updatedRowNodes);
	    };
	    ClipboardService.prototype.pasteStartingFromFocusedCell = function (parsedData) {
	        var focusedCell = this.focusedCellController.getFocusedCell();
	        if (!focusedCell) {
	            return;
	        }
	        // some parts of the grid logic shouldn't execute when paste operation
	        // in progress, so we flag when paste is in progress. used by changeDetectionService
	        // (as we don't want the grid refreshing for every cell, due to CellValueChanged event)
	        //
	        // NOTE - it is only pasteStartingFromFocusedCell where we want the ChangeDetectionService
	        // to stand down, as it is only this method which does clientSideRowModel.doAggregate()
	        // (the pasteIntoActiveRange or copyRangeDown do NOT do this). in the future this class needs
	        // to be refactored, so that all these methods do the same (hopefully with common logic)
	        // and then this flag is turned on / off at a higher level. i am not doing the refactor now
	        // as this is a critical code fix going into a patch release.
	        this.pasteOperationActive = true;
	        // remove last row if empty, excel puts empty last row in
	        var lastLine = ag_grid_community_1._.last(parsedData);
	        if (lastLine && lastLine.length === 1 && lastLine[0] === '') {
	            ag_grid_community_1._.removeFromArray(parsedData, lastLine);
	        }
	        var currentRow = { rowIndex: focusedCell.rowIndex, rowPinned: focusedCell.rowPinned };
	        var cellsToFlash = {};
	        var updatedRowNodes = [];
	        var updatedColumnIds = [];
	        var columnsToPasteInto = this.columnController.getDisplayedColumnsStartingAt(focusedCell.column);
	        var onlyOneValueToPaste = parsedData.length === 1 && parsedData[0].length === 1;
	        var changedPath;
	        if (this.clientSideRowModel) {
	            var onlyChangedColumns = this.gridOptionsWrapper.isAggregateOnlyChangedColumns();
	            changedPath = new ag_grid_community_1.ChangedPath(onlyChangedColumns, this.clientSideRowModel.getRootNode());
	        }
	        if (onlyOneValueToPaste) {
	            this.pasteSingleValue(parsedData, updatedRowNodes, cellsToFlash, updatedColumnIds, changedPath);
	        }
	        else {
	            this.pasteMultipleValues(parsedData, currentRow, updatedRowNodes, columnsToPasteInto, cellsToFlash, updatedColumnIds, ag_grid_community_1.Constants.EXPORT_TYPE_CLIPBOARD, changedPath);
	        }
	        if (changedPath) {
	            this.clientSideRowModel.doAggregate(changedPath);
	        }
	        this.rowRenderer.refreshCells({ rowNodes: updatedRowNodes, columns: updatedColumnIds });
	        this.dispatchFlashCells(cellsToFlash);
	        this.focusedCellController.setFocusedCell(focusedCell.rowIndex, focusedCell.column, focusedCell.rowPinned, true);
	        this.fireRowChanged(updatedRowNodes);
	        // unset the paste active operation
	        this.pasteOperationActive = false;
	    };
	    ClipboardService.prototype.copyRangeDown = function () {
	        var _this = this;
	        if (this.rangeController.isEmpty()) {
	            return;
	        }
	        this.eventService.dispatchEvent({
	            type: ag_grid_community_1.Events.EVENT_PASTE_START,
	            api: this.gridOptionsWrapper.getApi(),
	            columnApi: this.gridOptionsWrapper.getColumnApi(),
	            source: 'rangeDown'
	        });
	        var cellsToFlash = {};
	        var firstRowValues = [];
	        var updatedRowNodes = [];
	        var updatedColumnIds = [];
	        var rowCallback = function (currentRow, rowNode, columns, index, isLastRow) {
	            // take reference of first row, this is the one we will be using to copy from
	            if (!firstRowValues.length) {
	                // two reasons for looping through columns
	                columns.forEach(function (column) {
	                    // reason 1 - to get the initial values to copy down
	                    var value = _this.valueService.getValue(column, rowNode);
	                    var processCellForClipboardFunc = _this.gridOptionsWrapper.getProcessCellForClipboardFunc();
	                    value = _this.userProcessCell(rowNode, column, value, processCellForClipboardFunc, ag_grid_community_1.Constants.EXPORT_TYPE_DRAG_COPY);
	                    firstRowValues.push(value);
	                    // reason 2 - to record the columnId for refreshing
	                    updatedColumnIds.push(column.getId());
	                });
	            }
	            else {
	                // otherwise we are not the first row, so copy
	                updatedRowNodes.push(rowNode);
	                columns.forEach(function (column, index) {
	                    if (!column.isCellEditable(rowNode)) {
	                        return;
	                    }
	                    var firstRowValue = firstRowValues[index];
	                    var processCellFromClipboardFunc = _this.gridOptionsWrapper.getProcessCellFromClipboardFunc();
	                    firstRowValue = _this.userProcessCell(rowNode, column, firstRowValue, processCellFromClipboardFunc, ag_grid_community_1.Constants.EXPORT_TYPE_DRAG_COPY);
	                    _this.valueService.setValue(rowNode, column, firstRowValue);
	                    var cellPosition = {
	                        rowIndex: currentRow.rowIndex,
	                        rowPinned: currentRow.rowPinned,
	                        column: column
	                    };
	                    var cellId = _this.cellPositionUtils.createId(cellPosition);
	                    cellsToFlash[cellId] = true;
	                });
	            }
	        };
	        this.iterateActiveRanges(true, rowCallback);
	        // this is very heavy, should possibly just refresh the specific cells?
	        this.rowRenderer.refreshCells({ rowNodes: updatedRowNodes, columns: updatedColumnIds });
	        this.dispatchFlashCells(cellsToFlash);
	        this.fireRowChanged(updatedRowNodes);
	        this.eventService.dispatchEvent({
	            type: ag_grid_community_1.Events.EVENT_PASTE_END,
	            api: this.gridOptionsWrapper.getApi(),
	            columnApi: this.gridOptionsWrapper.getColumnApi(),
	            source: 'rangeDown'
	        });
	    };
	    ClipboardService.prototype.fireRowChanged = function (rowNodes) {
	        var _this = this;
	        if (!this.gridOptionsWrapper.isFullRowEdit()) {
	            return;
	        }
	        rowNodes.forEach(function (rowNode) {
	            var event = {
	                type: ag_grid_community_1.Events.EVENT_ROW_VALUE_CHANGED,
	                node: rowNode,
	                data: rowNode.data,
	                rowIndex: rowNode.rowIndex,
	                rowPinned: rowNode.rowPinned,
	                context: _this.gridOptionsWrapper.getContext(),
	                api: _this.gridOptionsWrapper.getApi(),
	                columnApi: _this.gridOptionsWrapper.getColumnApi()
	            };
	            _this.eventService.dispatchEvent(event);
	        });
	    };
	    ClipboardService.prototype.pasteMultipleValues = function (clipboardGridData, currentRow, updatedRowNodes, columnsToPasteInto, cellsToFlash, updatedColumnIds, type, changedPath) {
	        var _this = this;
	        clipboardGridData.forEach(function (clipboardRowData) {
	            // if we have come to end of rows in grid, then skip
	            if (!currentRow) {
	                return;
	            }
	            var rowNode = _this.rowPositionUtils.getRowNode(currentRow);
	            if (rowNode) {
	                updatedRowNodes.push(rowNode);
	                clipboardRowData.forEach(function (value, index) {
	                    var column = columnsToPasteInto[index];
	                    _this.updateCellValue(rowNode, column, value, currentRow, cellsToFlash, updatedColumnIds, type, changedPath);
	                });
	                // move to next row down for next set of values
	                currentRow = _this.cellNavigationService.getRowBelow({ rowPinned: currentRow.rowPinned, rowIndex: currentRow.rowIndex });
	            }
	        });
	        return currentRow;
	    };
	    ClipboardService.prototype.pasteSingleValue = function (parsedData, updatedRowNodes, cellsToFlash, updatedColumnIds, changedPath) {
	        var _this = this;
	        var value = parsedData[0][0];
	        var rowCallback = function (currentRow, rowNode, columns) {
	            updatedRowNodes.push(rowNode);
	            columns.forEach(function (column) {
	                _this.updateCellValue(rowNode, column, value, currentRow, cellsToFlash, updatedColumnIds, ag_grid_community_1.Constants.EXPORT_TYPE_CLIPBOARD, changedPath);
	            });
	        };
	        this.iterateActiveRanges(false, rowCallback);
	    };
	    ClipboardService.prototype.updateCellValue = function (rowNode, column, value, currentRow, cellsToFlash, updatedColumnIds, type, changedPath) {
	        if (!rowNode || !currentRow) {
	            return;
	        }
	        if (!column.isCellEditable(rowNode)) {
	            return;
	        }
	        if (column.isSuppressPaste(rowNode)) {
	            return;
	        }
	        var processedValue = this.userProcessCell(rowNode, column, value, this.gridOptionsWrapper.getProcessCellFromClipboardFunc(), type);
	        this.valueService.setValue(rowNode, column, processedValue);
	        var cellPosition = {
	            rowIndex: currentRow.rowIndex,
	            rowPinned: currentRow.rowPinned,
	            column: column
	        };
	        var cellId = this.cellPositionUtils.createId(cellPosition);
	        cellsToFlash[cellId] = true;
	        if (updatedColumnIds.indexOf(column.getId()) < 0) {
	            updatedColumnIds.push(column.getId());
	        }
	        if (changedPath && !rowNode.isRowPinned()) {
	            changedPath.addParentNode(rowNode.parent, [column]);
	        }
	    };
	    ClipboardService.prototype.copyToClipboard = function (includeHeaders) {
	        this.logger.log("copyToClipboard: includeHeaders = " + includeHeaders);
	        // don't override 'includeHeaders' if it has been explicitly set to 'false'
	        if (typeof includeHeaders === 'undefined') {
	            includeHeaders = this.gridOptionsWrapper.isCopyHeadersToClipboard();
	        }
	        var selectedRowsToCopy = !this.selectionController.isEmpty()
	            && !this.gridOptionsWrapper.isSuppressCopyRowsToClipboard();
	        // default is copy range if exists, otherwise rows
	        if (this.rangeController.isMoreThanOneCell()) {
	            this.copySelectedRangeToClipboard(includeHeaders);
	        }
	        else if (selectedRowsToCopy) {
	            // otherwise copy selected rows if they exist
	            this.copySelectedRowsToClipboard(includeHeaders);
	        }
	        else if (this.focusedCellController.isAnyCellFocused()) {
	            // if there is a focused cell, copy this
	            this.copyFocusedCellToClipboard(includeHeaders);
	        }
	        else {
	            // lastly if no focused cell, try range again. this can happen
	            // if use has cellSelection turned off (so no focused cell)
	            // but has a cell clicked, so there exists a cell range
	            // of exactly one cell (hence the first 'if' above didn't
	            // get executed).
	            this.copySelectedRangeToClipboard(includeHeaders);
	        }
	    };
	    ClipboardService.prototype.iterateActiveRanges = function (onlyFirst, rowCallback, columnCallback) {
	        var _this = this;
	        if (this.rangeController.isEmpty()) {
	            return;
	        }
	        var cellRanges = this.rangeController.getCellRanges();
	        if (onlyFirst) {
	            var range = cellRanges[0];
	            this.iterateActiveRange(range, rowCallback, columnCallback, true);
	        }
	        else {
	            cellRanges.forEach(function (range, idx) { return _this.iterateActiveRange(range, rowCallback, columnCallback, idx === cellRanges.length - 1); });
	        }
	    };
	    ClipboardService.prototype.iterateActiveRange = function (range, rowCallback, columnCallback, isLastRange) {
	        var currentRow = this.rangeController.getRangeStartRow(range);
	        var lastRow = this.rangeController.getRangeEndRow(range);
	        if (columnCallback && ag_grid_community_1._.exists(columnCallback) && range.columns) {
	            columnCallback(range.columns);
	        }
	        var rangeIndex = 0;
	        var isLastRow = false;
	        // the currentRow could be missing if the user sets the active range manually, and sets a range
	        // that is outside of the grid (eg. sets range rows 0 to 100, but grid has only 20 rows).
	        while (!isLastRow && !ag_grid_community_1._.missing(currentRow) && currentRow) {
	            var rowNode = this.rowPositionUtils.getRowNode(currentRow);
	            isLastRow = currentRow.rowIndex === lastRow.rowIndex && currentRow.rowIndex === lastRow.rowIndex;
	            rowCallback(currentRow, rowNode, range.columns, rangeIndex++, isLastRow && isLastRange);
	            currentRow = this.cellNavigationService.getRowBelow(currentRow);
	        }
	    };
	    ClipboardService.prototype.copySelectedRangeToClipboard = function (includeHeaders) {
	        var _this = this;
	        if (includeHeaders === void 0) { includeHeaders = false; }
	        if (this.rangeController.isEmpty()) {
	            return;
	        }
	        var deliminator = this.gridOptionsWrapper.getClipboardDeliminator();
	        var data = '';
	        var cellsToFlash = {};
	        // adds columns to the data
	        var columnCallback = function (columns) {
	            if (!includeHeaders) {
	                return;
	            }
	            columns.forEach(function (column, index) {
	                var value = _this.columnController.getDisplayNameForColumn(column, 'clipboard', true);
	                var processedValue = _this.userProcessHeader(column, value, _this.gridOptionsWrapper.getProcessHeaderForClipboardFunc());
	                if (index != 0) {
	                    data += deliminator;
	                }
	                if (ag_grid_community_1._.exists(processedValue)) {
	                    data += processedValue;
	                }
	            });
	            data += '\r\n';
	        };
	        // adds cell values to the data
	        var rowCallback = function (currentRow, rowNode, columns, index, isLastRow) {
	            columns.forEach(function (column, index) {
	                var value = _this.valueService.getValue(column, rowNode);
	                var processedValue = _this.userProcessCell(rowNode, column, value, _this.gridOptionsWrapper.getProcessCellForClipboardFunc(), ag_grid_community_1.Constants.EXPORT_TYPE_CLIPBOARD);
	                if (index != 0) {
	                    data += deliminator;
	                }
	                if (ag_grid_community_1._.exists(processedValue)) {
	                    data += processedValue;
	                }
	                var cellPosition = {
	                    rowIndex: currentRow.rowIndex,
	                    rowPinned: currentRow.rowPinned,
	                    column: column
	                };
	                var cellId = _this.cellPositionUtils.createId(cellPosition);
	                cellsToFlash[cellId] = true;
	            });
	            if (!isLastRow) {
	                data += '\r\n';
	            }
	        };
	        this.iterateActiveRanges(false, rowCallback, columnCallback);
	        this.copyDataToClipboard(data);
	        this.dispatchFlashCells(cellsToFlash);
	    };
	    ClipboardService.prototype.copyFocusedCellToClipboard = function (includeHeaders) {
	        var _a;
	        if (includeHeaders === void 0) { includeHeaders = false; }
	        var focusedCell = this.focusedCellController.getFocusedCell();
	        if (ag_grid_community_1._.missing(focusedCell)) {
	            return;
	        }
	        var cellId = this.cellPositionUtils.createId(focusedCell);
	        var currentRow = { rowPinned: focusedCell.rowPinned, rowIndex: focusedCell.rowIndex };
	        var rowNode = this.rowPositionUtils.getRowNode(currentRow);
	        var column = focusedCell.column;
	        var value = this.valueService.getValue(column, rowNode);
	        var processedValue = this.userProcessCell(rowNode, column, value, this.gridOptionsWrapper.getProcessCellForClipboardFunc(), ag_grid_community_1.Constants.EXPORT_TYPE_CLIPBOARD);
	        if (ag_grid_community_1._.missing(processedValue)) {
	            // copy the new line character to clipboard instead of an empty string, as the 'execCommand' will ignore it.
	            // this behaviour is consistent with how Excel works!
	            processedValue = '\t';
	        }
	        var data = '';
	        if (includeHeaders) {
	            var headerValue = this.columnController.getDisplayNameForColumn(column, 'clipboard', true);
	            data = this.userProcessHeader(column, headerValue, this.gridOptionsWrapper.getProcessHeaderForClipboardFunc());
	            data += '\r\n';
	        }
	        data += processedValue.toString();
	        this.copyDataToClipboard(data);
	        this.dispatchFlashCells((_a = {}, _a[cellId] = true, _a));
	    };
	    ClipboardService.prototype.dispatchFlashCells = function (cellsToFlash) {
	        var _this = this;
	        window.setTimeout(function () {
	            var event = {
	                type: ag_grid_community_1.Events.EVENT_FLASH_CELLS,
	                cells: cellsToFlash,
	                api: _this.gridApi,
	                columnApi: _this.columnApi
	            };
	            _this.eventService.dispatchEvent(event);
	        }, 0);
	    };
	    ClipboardService.prototype.userProcessCell = function (rowNode, column, value, func, type) {
	        if (func) {
	            var params = {
	                column: column,
	                node: rowNode,
	                value: value,
	                api: this.gridOptionsWrapper.getApi(),
	                columnApi: this.gridOptionsWrapper.getColumnApi(),
	                context: this.gridOptionsWrapper.getContext(),
	                type: type
	            };
	            return func(params);
	        }
	        else {
	            return value;
	        }
	    };
	    ClipboardService.prototype.userProcessHeader = function (column, value, func) {
	        if (func) {
	            var params = {
	                column: column,
	                api: this.gridOptionsWrapper.getApi(),
	                columnApi: this.gridOptionsWrapper.getColumnApi(),
	                context: this.gridOptionsWrapper.getContext()
	            };
	            return func(params);
	        }
	        else {
	            return value;
	        }
	    };
	    ClipboardService.prototype.copySelectedRowsToClipboard = function (includeHeaders, columnKeys) {
	        if (includeHeaders === void 0) { includeHeaders = false; }
	        var skipHeader = !includeHeaders;
	        var deliminator = this.gridOptionsWrapper.getClipboardDeliminator();
	        var params = {
	            columnKeys: columnKeys,
	            skipHeader: skipHeader,
	            skipFooters: true,
	            suppressQuotes: true,
	            columnSeparator: deliminator,
	            onlySelected: true,
	            processCellCallback: this.gridOptionsWrapper.getProcessCellForClipboardFunc(),
	            processHeaderCallback: this.gridOptionsWrapper.getProcessHeaderForClipboardFunc()
	        };
	        var data = this.csvCreator.getDataAsCsv(params);
	        this.copyDataToClipboard(data);
	    };
	    ClipboardService.prototype.copyDataToClipboard = function (data) {
	        var userProvidedFunc = this.gridOptionsWrapper.getSendToClipboardFunc();
	        if (userProvidedFunc && ag_grid_community_1._.exists(userProvidedFunc)) {
	            var params = { data: data };
	            userProvidedFunc(params);
	        }
	        else {
	            this.executeOnTempElement(function (element) {
	                element.value = data;
	                element.select();
	                element.focus();
	                var result = document.execCommand('copy');
	                if (!result) {
	                    console.warn('ag-grid: Browser did not allow document.execCommand(\'copy\'). Ensure ' +
	                        'api.copySelectedRowsToClipboard() is invoked via a user event, i.e. button click, otherwise ' +
	                        'the browser will prevent it for security reasons.');
	                }
	            });
	        }
	    };
	    ClipboardService.prototype.executeOnTempElement = function (callbackNow, callbackAfter) {
	        var eTempInput = document.createElement('textarea');
	        eTempInput.style.width = '1px';
	        eTempInput.style.height = '1px';
	        eTempInput.style.top = '0px';
	        eTempInput.style.left = '0px';
	        eTempInput.style.position = 'absolute';
	        eTempInput.style.opacity = '0.0';
	        var guiRoot = this.gridCore.getRootGui();
	        guiRoot.appendChild(eTempInput);
	        try {
	            callbackNow(eTempInput);
	        }
	        catch (err) {
	            console.warn('ag-grid: Browser does not support document.execCommand(\'copy\') for clipboard operations');
	        }
	        //It needs 100 otherwise OS X seemed to not always be able to paste... Go figure...
	        if (callbackAfter) {
	            window.setTimeout(function () {
	                callbackAfter(eTempInput);
	                guiRoot.removeChild(eTempInput);
	            }, 100);
	        }
	        else {
	            guiRoot.removeChild(eTempInput);
	        }
	    };
	    // From http://stackoverflow.com/questions/1293147/javascript-code-to-parse-csv-data
	    // This will parse a delimited string into an array of arrays.
	    // Note: this code fixes an issue with the example posted on stack overflow where it doesn't correctly handle
	    // empty values in the first cell.
	    ClipboardService.prototype.dataToArray = function (strData) {
	        var delimiter = this.gridOptionsWrapper.getClipboardDeliminator();
	        // Create a regular expression to parse the CSV values.
	        var objPattern = new RegExp((
	        // Delimiters.
	        '(\\' + delimiter + '|\\r?\\n|\\r|^)' +
	            // Quoted fields.
	            '(?:"([^\"]*(?:""[^\"]*)*)"|' +
	            // Standard fields.
	            '([^\\' + delimiter + '\\r\\n]*))'), "gi");
	        // Create an array to hold our data. Give the array
	        // a default empty first row.
	        var arrData = [[]];
	        // Create an array to hold our individual pattern matching groups.
	        var arrMatches;
	        // Required for handling edge case on first row copy
	        var atFirstRow = true;
	        // Keep looping over the regular expression matches
	        // until we can no longer find a match.
	        while (arrMatches = objPattern.exec(strData)) {
	            // Get the delimiter that was found.
	            var strMatchedDelimiter = arrMatches[1];
	            // Handles case when first row is an empty cell, insert an empty string before delimiter
	            if ((atFirstRow && strMatchedDelimiter) || !arrMatches.index && arrMatches[0].charAt(0) === delimiter) {
	                arrData[0].push('');
	            }
	            // Check to see if the given delimiter has a length
	            // (is not the start of string) and if it matches
	            // field delimiter. If id does not, then we know
	            // that this delimiter is a row delimiter.
	            if (strMatchedDelimiter.length && strMatchedDelimiter !== delimiter) {
	                // Since we have reached a new row of data,
	                // add an empty row to our data array.
	                arrData.push([]);
	            }
	            var strMatchedValue = void 0;
	            // Now that we have our delimiter out of the way,
	            // let's check to see which kind of value we
	            // captured (quoted or unquoted).
	            if (arrMatches[2]) {
	                // We found a quoted value. When we capture
	                // this value, unescaped any double quotes.
	                strMatchedValue = arrMatches[2].replace(new RegExp('""', 'g'), '"');
	            }
	            else {
	                // We found a non-quoted value.
	                strMatchedValue = arrMatches[3];
	            }
	            // Now that we have our value string, let's add
	            // it to the data array.
	            var lastItem = ag_grid_community_1._.last(arrData);
	            if (lastItem) {
	                lastItem.push(strMatchedValue);
	            }
	            atFirstRow = false;
	        }
	        // Return the parsed data.
	        return arrData;
	    };
	    ClipboardService.prototype.rangeSize = function () {
	        var ranges = this.rangeController.getCellRanges();
	        var startRangeIndex;
	        var endRangeIndex;
	        if (ranges.length > 0) {
	            startRangeIndex = 0;
	            endRangeIndex = 0;
	        }
	        else {
	            startRangeIndex = this.rangeController.getRangeStartRow(ranges[0]).rowIndex;
	            endRangeIndex = this.rangeController.getRangeEndRow(ranges[0]).rowIndex;
	        }
	        return startRangeIndex - endRangeIndex + 1;
	    };
	    __decorate([
	        ag_grid_community_1.Autowired('csvCreator'),
	        __metadata("design:type", ag_grid_community_1.CsvCreator)
	    ], ClipboardService.prototype, "csvCreator", void 0);
	    __decorate([
	        ag_grid_community_1.Autowired('loggerFactory'),
	        __metadata("design:type", ag_grid_community_1.LoggerFactory)
	    ], ClipboardService.prototype, "loggerFactory", void 0);
	    __decorate([
	        ag_grid_community_1.Autowired('selectionController'),
	        __metadata("design:type", ag_grid_community_1.SelectionController)
	    ], ClipboardService.prototype, "selectionController", void 0);
	    __decorate([
	        ag_grid_community_1.Autowired('rangeController'),
	        __metadata("design:type", rangeController_1.RangeController)
	    ], ClipboardService.prototype, "rangeController", void 0);
	    __decorate([
	        ag_grid_community_1.Autowired('rowModel'),
	        __metadata("design:type", Object)
	    ], ClipboardService.prototype, "rowModel", void 0);
	    __decorate([
	        ag_grid_community_1.Autowired('valueService'),
	        __metadata("design:type", ag_grid_community_1.ValueService)
	    ], ClipboardService.prototype, "valueService", void 0);
	    __decorate([
	        ag_grid_community_1.Autowired('focusedCellController'),
	        __metadata("design:type", ag_grid_community_1.FocusedCellController)
	    ], ClipboardService.prototype, "focusedCellController", void 0);
	    __decorate([
	        ag_grid_community_1.Autowired('rowRenderer'),
	        __metadata("design:type", ag_grid_community_1.RowRenderer)
	    ], ClipboardService.prototype, "rowRenderer", void 0);
	    __decorate([
	        ag_grid_community_1.Autowired('columnController'),
	        __metadata("design:type", ag_grid_community_1.ColumnController)
	    ], ClipboardService.prototype, "columnController", void 0);
	    __decorate([
	        ag_grid_community_1.Autowired('eventService'),
	        __metadata("design:type", ag_grid_community_1.EventService)
	    ], ClipboardService.prototype, "eventService", void 0);
	    __decorate([
	        ag_grid_community_1.Autowired('cellNavigationService'),
	        __metadata("design:type", ag_grid_community_1.CellNavigationService)
	    ], ClipboardService.prototype, "cellNavigationService", void 0);
	    __decorate([
	        ag_grid_community_1.Autowired('gridOptionsWrapper'),
	        __metadata("design:type", ag_grid_community_1.GridOptionsWrapper)
	    ], ClipboardService.prototype, "gridOptionsWrapper", void 0);
	    __decorate([
	        ag_grid_community_1.Autowired('columnApi'),
	        __metadata("design:type", ag_grid_community_1.ColumnApi)
	    ], ClipboardService.prototype, "columnApi", void 0);
	    __decorate([
	        ag_grid_community_1.Autowired('gridApi'),
	        __metadata("design:type", ag_grid_community_1.GridApi)
	    ], ClipboardService.prototype, "gridApi", void 0);
	    __decorate([
	        ag_grid_community_1.Autowired('cellPositionUtils'),
	        __metadata("design:type", ag_grid_community_1.CellPositionUtils)
	    ], ClipboardService.prototype, "cellPositionUtils", void 0);
	    __decorate([
	        ag_grid_community_1.Autowired('rowPositionUtils'),
	        __metadata("design:type", ag_grid_community_1.RowPositionUtils)
	    ], ClipboardService.prototype, "rowPositionUtils", void 0);
	    __decorate([
	        ag_grid_community_1.PostConstruct,
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", []),
	        __metadata("design:returntype", void 0)
	    ], ClipboardService.prototype, "init", null);
	    ClipboardService = __decorate([
	        ag_grid_community_1.Bean('clipboardService')
	    ], ClipboardService);
	    return ClipboardService;
	}());
	exports.ClipboardService = ClipboardService;


/***/ }),
/* 2512 */
/***/ (function(module, exports, __webpack_require__) {

	// ag-grid-enterprise v21.2.2
	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var ag_grid_community_1 = __webpack_require__(2322);
	var RangeController = /** @class */ (function () {
	    function RangeController() {
	        this.cellRanges = [];
	        this.bodyScrollListener = this.onBodyScroll.bind(this);
	        this.dragging = false;
	    }
	    RangeController.prototype.registerGridComp = function (gridPanel) {
	        this.gridPanel = gridPanel;
	        this.autoScrollService = new AutoScrollService(this.gridPanel, this.gridOptionsWrapper);
	    };
	    RangeController.prototype.init = function () {
	        this.logger = this.loggerFactory.create('RangeController');
	        this.eventService.addEventListener(ag_grid_community_1.Events.EVENT_COLUMN_EVERYTHING_CHANGED, this.removeAllCellRanges.bind(this));
	        this.eventService.addEventListener(ag_grid_community_1.Events.EVENT_COLUMN_PIVOT_MODE_CHANGED, this.removeAllCellRanges.bind(this));
	        this.eventService.addEventListener(ag_grid_community_1.Events.EVENT_COLUMN_ROW_GROUP_CHANGED, this.removeAllCellRanges.bind(this));
	        this.eventService.addEventListener(ag_grid_community_1.Events.EVENT_COLUMN_GROUP_OPENED, this.refreshLastRangeStart.bind(this));
	        this.eventService.addEventListener(ag_grid_community_1.Events.EVENT_COLUMN_MOVED, this.refreshLastRangeStart.bind(this));
	        this.eventService.addEventListener(ag_grid_community_1.Events.EVENT_COLUMN_PINNED, this.refreshLastRangeStart.bind(this));
	        this.eventService.addEventListener(ag_grid_community_1.Events.EVENT_COLUMN_VISIBLE, this.onColumnVisibleChange.bind(this));
	    };
	    RangeController.prototype.onColumnVisibleChange = function () {
	        var _this = this;
	        // first move start column in last cell range (i.e. series chart range)
	        this.refreshLastRangeStart();
	        // then check if the column visibility has changed in any cell range
	        this.cellRanges.forEach(function (cellRange) {
	            var beforeCols = cellRange.columns;
	            // remove hidden cols from cell range
	            cellRange.columns = cellRange.columns.filter(function (col) { return col.isVisible(); });
	            var colsInRangeChanged = !ag_grid_community_1._.compareArrays(beforeCols, cellRange.columns);
	            if (colsInRangeChanged) {
	                // notify users and other parts of grid (i.e. status panel) that range has changed
	                _this.onRangeChanged({ started: false, finished: true });
	                // notify chart of cell range change
	                var event_1 = {
	                    id: cellRange.id,
	                    type: ag_grid_community_1.Events.EVENT_CHART_RANGE_SELECTION_CHANGED
	                };
	                _this.eventService.dispatchEvent(event_1);
	            }
	        });
	    };
	    RangeController.prototype.refreshLastRangeStart = function () {
	        var lastRange = ag_grid_community_1._.last(this.cellRanges);
	        if (!lastRange) {
	            return;
	        }
	        this.refreshRangeStart(lastRange);
	    };
	    RangeController.prototype.isContiguousRange = function (cellRange) {
	        var rangeColumns = cellRange.columns;
	        if (!rangeColumns.length) {
	            return false;
	        }
	        var allColumns = this.columnController.getAllDisplayedColumns();
	        var allPositions = [];
	        rangeColumns.forEach(function (col) { return allPositions.push(allColumns.indexOf(col)); });
	        allPositions.sort(function (a, b) { return a - b; });
	        return ag_grid_community_1._.last(allPositions) - allPositions[0] + 1 === rangeColumns.length;
	    };
	    RangeController.prototype.getRangeStartRow = function (cellRange) {
	        if (cellRange.startRow && cellRange.endRow) {
	            var startRowIsFirst = this.rowPositionUtils.before(cellRange.startRow, cellRange.endRow);
	            return startRowIsFirst ? cellRange.startRow : cellRange.endRow;
	        }
	        var pinned = (this.pinnedRowModel.getPinnedTopRowCount() > 0) ? ag_grid_community_1.Constants.PINNED_TOP : undefined;
	        return { rowIndex: 0, rowPinned: pinned };
	    };
	    RangeController.prototype.getRangeEndRow = function (cellRange) {
	        if (cellRange.startRow && cellRange.endRow) {
	            var startRowIsFirst = this.rowPositionUtils.before(cellRange.startRow, cellRange.endRow);
	            return startRowIsFirst ? cellRange.endRow : cellRange.startRow;
	        }
	        var pinnedBottomRowCount = this.pinnedRowModel.getPinnedBottomRowCount();
	        var pinnedBottom = pinnedBottomRowCount > 0;
	        if (pinnedBottom) {
	            return {
	                rowIndex: pinnedBottomRowCount - 1,
	                rowPinned: ag_grid_community_1.Constants.PINNED_BOTTOM
	            };
	        }
	        return {
	            rowIndex: this.rowModel.getRowCount() - 1,
	            rowPinned: undefined
	        };
	    };
	    RangeController.prototype.setRangeToCell = function (cell, appendRange) {
	        if (appendRange === void 0) { appendRange = false; }
	        if (!this.gridOptionsWrapper.isEnableRangeSelection()) {
	            return;
	        }
	        var columns = this.calculateColumnsBetween(cell.column, cell.column);
	        if (!columns) {
	            return;
	        }
	        var suppressMultiRangeSelections = this.gridOptionsWrapper.isSuppressMultiRangeSelection();
	        // if not appending, then clear previous range selections
	        if (suppressMultiRangeSelections || !appendRange || ag_grid_community_1._.missing(this.cellRanges)) {
	            this.removeAllCellRanges(true);
	        }
	        var rowForCell = {
	            rowIndex: cell.rowIndex,
	            rowPinned: cell.rowPinned
	        };
	        // if there is already a range for this cell, then we reuse the same range, otherwise the user
	        // can ctrl & click a cell many times and hit ctrl+c, which would result in the cell getting copied
	        // many times to the clipboard.
	        var existingRange;
	        for (var i = 0; i < this.cellRanges.length; i++) {
	            var range = this.cellRanges[i];
	            var matches = 
	            // check cols are same
	            (range.columns && range.columns.length === 1 && range.columns[0] === cell.column) &&
	                // check rows are same
	                this.rowPositionUtils.sameRow(rowForCell, range.startRow) &&
	                this.rowPositionUtils.sameRow(rowForCell, range.endRow);
	            if (matches) {
	                existingRange = range;
	                break;
	            }
	        }
	        if (existingRange) {
	            // we need it at the end of the list, as the dragStart picks the last created
	            // range as the start point for the drag
	            var atEndOfList = ag_grid_community_1._.last(this.cellRanges) === existingRange;
	            if (!atEndOfList) {
	                ag_grid_community_1._.removeFromArray(this.cellRanges, existingRange);
	                this.cellRanges.push(existingRange);
	            }
	        }
	        else {
	            var newRange = {
	                startRow: rowForCell,
	                endRow: rowForCell,
	                columns: columns,
	                startColumn: cell.column
	            };
	            this.cellRanges.push(newRange);
	        }
	        this.newestRangeStartCell = cell;
	        this.onDragStop();
	        this.onRangeChanged({ started: false, finished: true });
	    };
	    RangeController.prototype.extendLatestRangeToCell = function (cellPosition) {
	        if (this.isEmpty() || !this.newestRangeStartCell) {
	            return;
	        }
	        var cellRange = ag_grid_community_1._.last(this.cellRanges);
	        this.updateRangeEnd({
	            cellRange: cellRange,
	            cellPosition: cellPosition
	        });
	    };
	    RangeController.prototype.updateRangeEnd = function (params) {
	        var cellRange = params.cellRange, cellPosition = params.cellPosition;
	        var beforeCols = cellRange.columns.slice();
	        var beforeEndRow = ag_grid_community_1._.cloneObject(cellRange.endRow);
	        var endColumn = cellPosition.column;
	        var colsToAdd = this.calculateColumnsBetween(cellRange.startColumn, endColumn);
	        if (!colsToAdd) {
	            return;
	        }
	        cellRange.columns = colsToAdd;
	        cellRange.endRow = { rowIndex: cellPosition.rowIndex, rowPinned: cellPosition.rowPinned };
	        this.onRangeChanged({ started: false, finished: true });
	        var colsChanged = !ag_grid_community_1._.compareArrays(beforeCols, cellRange.columns);
	        var endRowChanged = JSON.stringify(beforeEndRow) !== JSON.stringify(cellRange.endRow);
	        if (colsChanged || endRowChanged) {
	            // Note that we are raising a new event as the Chart shouldn't be notified when other ranges are changed
	            // or when the chart setCellRanges when the chart gains focus!
	            var event_2 = {
	                id: cellRange.id,
	                type: ag_grid_community_1.Events.EVENT_CHART_RANGE_SELECTION_CHANGED
	            };
	            this.eventService.dispatchEvent(event_2);
	        }
	    };
	    RangeController.prototype.refreshRangeStart = function (cellRange) {
	        var startColumn = cellRange.startColumn, columns = cellRange.columns;
	        var moveColInCellRange = function (colToMove, moveToFront) {
	            var otherCols = cellRange.columns.filter(function (col) { return col !== colToMove; });
	            if (colToMove) {
	                cellRange.startColumn = colToMove;
	                cellRange.columns = moveToFront ? [colToMove].concat(otherCols) : otherCols.concat([colToMove]);
	            }
	            else {
	                cellRange.columns = otherCols;
	            }
	        };
	        var _a = this.getRangeEdgeColumns(cellRange), left = _a.left, right = _a.right;
	        var shouldMoveLeftCol = startColumn === columns[0] && startColumn !== left;
	        if (shouldMoveLeftCol) {
	            moveColInCellRange(left, true);
	            return;
	        }
	        var shouldMoveRightCol = startColumn === ag_grid_community_1._.last(columns) && startColumn === right;
	        if (shouldMoveRightCol) {
	            moveColInCellRange(right, false);
	            return;
	        }
	    };
	    RangeController.prototype.getRangeEdgeColumns = function (cellRange) {
	        var allColumns = this.columnController.getAllDisplayedColumns();
	        var allIndices = [];
	        for (var _i = 0, _a = cellRange.columns; _i < _a.length; _i++) {
	            var column = _a[_i];
	            var idx = allColumns.indexOf(column);
	            if (idx > -1) {
	                allIndices.push(idx);
	            }
	        }
	        allIndices.sort(function (a, b) { return a - b; });
	        return {
	            left: allColumns[allIndices[0]],
	            right: allColumns[ag_grid_community_1._.last(allIndices)]
	        };
	    };
	    // returns true if successful, false if not successful
	    RangeController.prototype.extendLatestRangeInDirection = function (key) {
	        if (this.isEmpty() || !this.newestRangeStartCell) {
	            return;
	        }
	        var lastRange = ag_grid_community_1._.last(this.cellRanges);
	        var startCell = this.newestRangeStartCell;
	        var firstCol = lastRange.columns[0];
	        var lastCol = ag_grid_community_1._.last(lastRange.columns);
	        // find the cell that is at the furthest away corner from the starting cell
	        var endCellIndex = lastRange.endRow.rowIndex;
	        var endCellFloating = lastRange.endRow.rowPinned;
	        var endCellColumn = startCell.column === firstCol ? lastCol : firstCol;
	        var endCell = { column: endCellColumn, rowIndex: endCellIndex, rowPinned: endCellFloating };
	        var newEndCell = this.cellNavigationService.getNextCellToFocus(key, endCell);
	        // if user is at end of grid, so no cell to extend to, we return false
	        if (!newEndCell) {
	            return;
	        }
	        this.setCellRange({
	            rowStartIndex: startCell.rowIndex,
	            rowStartPinned: startCell.rowPinned,
	            rowEndIndex: newEndCell.rowIndex,
	            rowEndPinned: newEndCell.rowPinned,
	            columnStart: startCell.column,
	            columnEnd: newEndCell.column
	        });
	        return newEndCell;
	    };
	    RangeController.prototype.setCellRange = function (params) {
	        if (!this.gridOptionsWrapper.isEnableRangeSelection()) {
	            return;
	        }
	        this.removeAllCellRanges(true);
	        this.addCellRange(params);
	    };
	    RangeController.prototype.setCellRanges = function (cellRanges) {
	        var _this = this;
	        this.removeAllCellRanges(true);
	        cellRanges.forEach(function (newRange) {
	            if (newRange.columns && newRange.startRow) {
	                _this.newestRangeStartCell = {
	                    rowIndex: newRange.startRow.rowIndex,
	                    rowPinned: newRange.startRow.rowPinned,
	                    column: newRange.columns[0]
	                };
	            }
	            _this.cellRanges.push(newRange);
	        });
	        this.onRangeChanged({ started: false, finished: true });
	    };
	    RangeController.prototype.createCellRangeFromCellRangeParams = function (params) {
	        var _this = this;
	        var columns;
	        if (params.columns) {
	            columns = [];
	            params.columns.forEach(function (key) {
	                var col = _this.columnController.getColumnWithValidation(key);
	                if (col) {
	                    columns.push(col);
	                }
	            });
	        }
	        else {
	            var columnStart = this.columnController.getColumnWithValidation(params.columnStart);
	            var columnEnd = this.columnController.getColumnWithValidation(params.columnEnd);
	            if (!columnStart || !columnEnd) {
	                return;
	            }
	            columns = this.calculateColumnsBetween(columnStart, columnEnd);
	        }
	        if (!columns) {
	            return;
	        }
	        var startRow = undefined;
	        if (params.rowStartIndex != null) {
	            startRow = {
	                rowIndex: params.rowStartIndex,
	                rowPinned: params.rowStartPinned
	            };
	        }
	        var endRow = undefined;
	        if (params.rowEndIndex != null) {
	            endRow = {
	                rowIndex: params.rowEndIndex,
	                rowPinned: params.rowEndPinned
	            };
	        }
	        var newRange = {
	            startRow: startRow,
	            endRow: endRow,
	            columns: columns,
	            startColumn: columns[0]
	        };
	        return newRange;
	    };
	    RangeController.prototype.addCellRange = function (params) {
	        if (!this.gridOptionsWrapper.isEnableRangeSelection()) {
	            return;
	        }
	        var newRange = this.createCellRangeFromCellRangeParams(params);
	        if (newRange) {
	            this.cellRanges.push(newRange);
	            this.onRangeChanged({ started: false, finished: true });
	        }
	    };
	    RangeController.prototype.getCellRanges = function () {
	        return this.cellRanges;
	    };
	    RangeController.prototype.isEmpty = function () {
	        return this.cellRanges.length === 0;
	    };
	    RangeController.prototype.isMoreThanOneCell = function () {
	        if (this.cellRanges.length === 0) {
	            // no ranges, so not more than one cell
	            return false;
	        }
	        else if (this.cellRanges.length > 1) {
	            // many ranges, so more than one cell
	            return true;
	        }
	        // only one range, return true if range has more than one
	        var range = this.cellRanges[0];
	        var startRow = this.getRangeStartRow(range);
	        var endRow = this.getRangeEndRow(range);
	        var moreThanOneCell = startRow.rowPinned !== endRow.rowPinned ||
	            startRow.rowIndex !== endRow.rowIndex ||
	            range.columns.length !== 1;
	        return moreThanOneCell;
	    };
	    RangeController.prototype.removeAllCellRanges = function (silent) {
	        if (this.isEmpty()) {
	            return;
	        }
	        this.onDragStop();
	        this.cellRanges.length = 0;
	        if (!silent) {
	            this.onRangeChanged({ started: false, finished: true });
	        }
	    };
	    // as the user is dragging outside of the panel, the div starts to scroll, which in turn
	    // means we are selection more (or less) cells, but the mouse isn't moving, so we recalculate
	    // the selection my mimicking a new mouse event
	    RangeController.prototype.onBodyScroll = function () {
	        this.onDragging(this.lastMouseEvent);
	    };
	    RangeController.prototype.isCellInAnyRange = function (cell) {
	        return this.getCellRangeCount(cell) > 0;
	    };
	    RangeController.prototype.isCellInSpecificRange = function (cell, range) {
	        var columnInRange = range.columns !== null && range.columns.indexOf(cell.column) >= 0;
	        var rowInRange = this.isRowInRange(cell.rowIndex, cell.rowPinned, range);
	        return columnInRange && rowInRange;
	    };
	    // returns the number of ranges this cell is in
	    RangeController.prototype.getCellRangeCount = function (cell) {
	        var _this = this;
	        if (this.isEmpty()) {
	            return 0;
	        }
	        var matchingCount = 0;
	        this.cellRanges.forEach(function (cellRange) {
	            if (_this.isCellInSpecificRange(cell, cellRange)) {
	                matchingCount++;
	            }
	        });
	        return matchingCount;
	    };
	    RangeController.prototype.isRowInRange = function (rowIndex, floating, cellRange) {
	        var firstRow = this.getRangeStartRow(cellRange);
	        var lastRow = this.getRangeEndRow(cellRange);
	        var thisRow = { rowIndex: rowIndex, rowPinned: floating };
	        // compare rowPinned with == instead of === because it can be `null` or `undefined`
	        var equalsFirstRow = thisRow.rowIndex === firstRow.rowIndex && thisRow.rowPinned == firstRow.rowPinned;
	        var equalsLastRow = thisRow.rowIndex === lastRow.rowIndex && thisRow.rowPinned == lastRow.rowPinned;
	        if (equalsFirstRow || equalsLastRow) {
	            return true;
	        }
	        var afterFirstRow = !this.rowPositionUtils.before(thisRow, firstRow);
	        var beforeLastRow = this.rowPositionUtils.before(thisRow, lastRow);
	        return afterFirstRow && beforeLastRow;
	    };
	    RangeController.prototype.getDraggingRange = function () {
	        return this.draggingRange;
	    };
	    RangeController.prototype.onDragStart = function (mouseEvent) {
	        if (!this.gridOptionsWrapper.isEnableRangeSelection()) {
	            return;
	        }
	        var ctrlKey = mouseEvent.ctrlKey, metaKey = mouseEvent.metaKey, shiftKey = mouseEvent.shiftKey;
	        // ctrlKey for windows, metaKey for Apple
	        var multiKeyPressed = ctrlKey || metaKey;
	        var allowMulti = !this.gridOptionsWrapper.isSuppressMultiRangeSelection();
	        var multiSelectKeyPressed = allowMulti ? multiKeyPressed : false;
	        var mouseCell = this.mouseEventService.getCellPositionForEvent(mouseEvent);
	        if (ag_grid_community_1._.missing(mouseCell)) {
	            // if drag wasn't on cell, then do nothing, including do not set dragging=true,
	            // (which them means onDragging and onDragStop do nothing)
	            return;
	        }
	        if (!multiSelectKeyPressed && (!shiftKey || ag_grid_community_1._.exists(ag_grid_community_1._.last(this.cellRanges).type))) {
	            this.removeAllCellRanges(true);
	        }
	        this.dragging = true;
	        this.draggingCell = mouseCell;
	        this.lastMouseEvent = mouseEvent;
	        if (!shiftKey) {
	            this.newestRangeStartCell = mouseCell;
	        }
	        // if we didn't clear the ranges, then dragging means the user clicked, and when the
	        // user clicks it means a range of one cell was created. we need to extend this range
	        // rather than creating another range. otherwise we end up with two distinct ranges
	        // from a drag operation (one from click, and one from drag).
	        if (this.cellRanges.length > 0) {
	            this.draggingRange = ag_grid_community_1._.last(this.cellRanges);
	        }
	        else {
	            var mouseRowPosition = {
	                rowIndex: mouseCell.rowIndex,
	                rowPinned: mouseCell.rowPinned
	            };
	            this.draggingRange = {
	                startRow: mouseRowPosition,
	                endRow: mouseRowPosition,
	                columns: [mouseCell.column],
	                startColumn: this.newestRangeStartCell.column
	            };
	            this.cellRanges.push(this.draggingRange);
	        }
	        this.gridPanel.addScrollEventListener(this.bodyScrollListener);
	        this.onRangeChanged({ started: true, finished: false });
	    };
	    RangeController.prototype.onDragging = function (mouseEvent) {
	        if (!this.dragging || !mouseEvent) {
	            return;
	        }
	        this.lastMouseEvent = mouseEvent;
	        var cellPosition = this.mouseEventService.getCellPositionForEvent(mouseEvent);
	        var mouseAndStartInPinnedTop = cellPosition && cellPosition.rowPinned === 'top' && this.newestRangeStartCell.rowPinned === 'top';
	        var mouseAndStartInPinnedBottom = cellPosition && cellPosition.rowPinned === 'bottom' && this.newestRangeStartCell.rowPinned === 'bottom';
	        var skipVerticalScroll = mouseAndStartInPinnedTop || mouseAndStartInPinnedBottom;
	        this.autoScrollService.check(mouseEvent, skipVerticalScroll);
	        if (!cellPosition ||
	            !this.draggingCell ||
	            this.cellPositionUtils.equals(this.draggingCell, cellPosition)) {
	            return;
	        }
	        var columns = this.calculateColumnsBetween(this.newestRangeStartCell.column, cellPosition.column);
	        if (!columns) {
	            return;
	        }
	        this.draggingCell = cellPosition;
	        this.draggingRange.endRow = {
	            rowIndex: cellPosition.rowIndex,
	            rowPinned: cellPosition.rowPinned
	        };
	        this.draggingRange.columns = columns;
	        this.onRangeChanged({ started: false, finished: false });
	    };
	    RangeController.prototype.onDragStop = function () {
	        if (!this.dragging) {
	            return;
	        }
	        this.autoScrollService.ensureCleared();
	        this.gridPanel.removeScrollEventListener(this.bodyScrollListener);
	        this.lastMouseEvent = null;
	        this.dragging = false;
	        this.draggingRange = undefined;
	        this.draggingCell = undefined;
	        this.onRangeChanged({ started: false, finished: true });
	    };
	    RangeController.prototype.onRangeChanged = function (params) {
	        var started = params.started, finished = params.finished;
	        this.dispatchChangedEvent(started, finished);
	    };
	    RangeController.prototype.dispatchChangedEvent = function (started, finished) {
	        var event = {
	            type: ag_grid_community_1.Events.EVENT_RANGE_SELECTION_CHANGED,
	            api: this.gridApi,
	            columnApi: this.columnApi,
	            started: started,
	            finished: finished
	        };
	        this.eventService.dispatchEvent(event);
	    };
	    RangeController.prototype.calculateColumnsBetween = function (columnFrom, columnTo) {
	        var allColumns = this.columnController.getAllDisplayedColumns();
	        var isSameColumn = columnFrom === columnTo;
	        var fromIndex = allColumns.indexOf(columnFrom);
	        var toIndex = isSameColumn ? fromIndex : allColumns.indexOf(columnTo);
	        if (fromIndex < 0) {
	            console.warn('ag-Grid: column ' + columnFrom.getId() + ' is not visible');
	            return undefined;
	        }
	        if (toIndex < 0) {
	            console.warn('ag-Grid: column ' + columnTo.getId() + ' is not visible');
	            return undefined;
	        }
	        if (isSameColumn) {
	            return [columnFrom];
	        }
	        var firstIndex = Math.min(fromIndex, toIndex);
	        var lastIndex = firstIndex === fromIndex ? toIndex : fromIndex;
	        var columns = [];
	        for (var i = firstIndex; i <= lastIndex; i++) {
	            columns.push(allColumns[i]);
	        }
	        return columns;
	    };
	    __decorate([
	        ag_grid_community_1.Autowired('loggerFactory'),
	        __metadata("design:type", ag_grid_community_1.LoggerFactory)
	    ], RangeController.prototype, "loggerFactory", void 0);
	    __decorate([
	        ag_grid_community_1.Autowired('rowModel'),
	        __metadata("design:type", Object)
	    ], RangeController.prototype, "rowModel", void 0);
	    __decorate([
	        ag_grid_community_1.Autowired('eventService'),
	        __metadata("design:type", ag_grid_community_1.EventService)
	    ], RangeController.prototype, "eventService", void 0);
	    __decorate([
	        ag_grid_community_1.Autowired('columnController'),
	        __metadata("design:type", ag_grid_community_1.ColumnController)
	    ], RangeController.prototype, "columnController", void 0);
	    __decorate([
	        ag_grid_community_1.Autowired('mouseEventService'),
	        __metadata("design:type", ag_grid_community_1.MouseEventService)
	    ], RangeController.prototype, "mouseEventService", void 0);
	    __decorate([
	        ag_grid_community_1.Autowired('gridOptionsWrapper'),
	        __metadata("design:type", ag_grid_community_1.GridOptionsWrapper)
	    ], RangeController.prototype, "gridOptionsWrapper", void 0);
	    __decorate([
	        ag_grid_community_1.Autowired('columnApi'),
	        __metadata("design:type", ag_grid_community_1.ColumnApi)
	    ], RangeController.prototype, "columnApi", void 0);
	    __decorate([
	        ag_grid_community_1.Autowired('gridApi'),
	        __metadata("design:type", ag_grid_community_1.GridApi)
	    ], RangeController.prototype, "gridApi", void 0);
	    __decorate([
	        ag_grid_community_1.Autowired('cellNavigationService'),
	        __metadata("design:type", ag_grid_community_1.CellNavigationService)
	    ], RangeController.prototype, "cellNavigationService", void 0);
	    __decorate([
	        ag_grid_community_1.Autowired("pinnedRowModel"),
	        __metadata("design:type", ag_grid_community_1.PinnedRowModel)
	    ], RangeController.prototype, "pinnedRowModel", void 0);
	    __decorate([
	        ag_grid_community_1.Autowired('rowPositionUtils'),
	        __metadata("design:type", ag_grid_community_1.RowPositionUtils)
	    ], RangeController.prototype, "rowPositionUtils", void 0);
	    __decorate([
	        ag_grid_community_1.Autowired('cellPositionUtils'),
	        __metadata("design:type", ag_grid_community_1.CellPositionUtils)
	    ], RangeController.prototype, "cellPositionUtils", void 0);
	    __decorate([
	        ag_grid_community_1.PostConstruct,
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", []),
	        __metadata("design:returntype", void 0)
	    ], RangeController.prototype, "init", null);
	    RangeController = __decorate([
	        ag_grid_community_1.Bean('rangeController')
	    ], RangeController);
	    return RangeController;
	}());
	exports.RangeController = RangeController;
	var AutoScrollService = /** @class */ (function () {
	    function AutoScrollService(gridPanel, gridOptionsWrapper) {
	        this.tickingInterval = null;
	        this.gridPanel = gridPanel;
	        this.gridOptionsWrapper = gridOptionsWrapper;
	    }
	    AutoScrollService.prototype.check = function (mouseEvent, skipVerticalScroll) {
	        if (skipVerticalScroll === void 0) { skipVerticalScroll = false; }
	        var rect = this.gridPanel.getBodyClientRect();
	        skipVerticalScroll = skipVerticalScroll || this.gridOptionsWrapper.getDomLayout() !== ag_grid_community_1.Constants.DOM_LAYOUT_NORMAL;
	        // we don't do ticking if grid is auto height unless we have a horizontal scroller
	        if (skipVerticalScroll && !this.gridPanel.isHorizontalScrollShowing()) {
	            return;
	        }
	        this.tickLeft = mouseEvent.clientX < (rect.left + 20);
	        this.tickRight = mouseEvent.clientX > (rect.right - 20);
	        this.tickUp = mouseEvent.clientY < (rect.top + 20) && !skipVerticalScroll;
	        this.tickDown = mouseEvent.clientY > (rect.bottom - 20) && !skipVerticalScroll;
	        if (this.tickLeft || this.tickRight || this.tickUp || this.tickDown) {
	            this.ensureTickingStarted();
	        }
	        else {
	            this.ensureCleared();
	        }
	    };
	    AutoScrollService.prototype.ensureTickingStarted = function () {
	        if (this.tickingInterval === null) {
	            this.tickingInterval = window.setInterval(this.doTick.bind(this), 100);
	            this.tickCount = 0;
	        }
	    };
	    AutoScrollService.prototype.doTick = function () {
	        this.tickCount++;
	        var vScrollPosition = this.gridPanel.getVScrollPosition();
	        var hScrollPosition = this.gridPanel.getHScrollPosition();
	        var tickAmount;
	        tickAmount = this.tickCount > 20 ? 200 : (this.tickCount > 10 ? 80 : 40);
	        if (this.tickUp) {
	            this.gridPanel.setVerticalScrollPosition(vScrollPosition.top - tickAmount);
	        }
	        if (this.tickDown) {
	            this.gridPanel.setVerticalScrollPosition(vScrollPosition.top + tickAmount);
	        }
	        if (this.tickLeft) {
	            this.gridPanel.setHorizontalScrollPosition(hScrollPosition.left - tickAmount);
	        }
	        if (this.tickRight) {
	            this.gridPanel.setHorizontalScrollPosition(hScrollPosition.left + tickAmount);
	        }
	    };
	    AutoScrollService.prototype.ensureCleared = function () {
	        if (this.tickingInterval) {
	            window.clearInterval(this.tickingInterval);
	            this.tickingInterval = null;
	        }
	    };
	    return AutoScrollService;
	}());


/***/ }),
/* 2513 */
/***/ (function(module, exports, __webpack_require__) {

	// ag-grid-enterprise v21.2.2
	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var ag_grid_community_1 = __webpack_require__(2322);
	var AggFuncService = /** @class */ (function () {
	    function AggFuncService() {
	        this.aggFuncsMap = {};
	        this.initialised = false;
	    }
	    AggFuncService_1 = AggFuncService;
	    AggFuncService.prototype.init = function () {
	        if (this.initialised) {
	            return;
	        }
	        this.initialised = true;
	        this.initialiseWithDefaultAggregations();
	        this.addAggFuncs(this.gridOptionsWrapper.getAggFuncs());
	    };
	    AggFuncService.prototype.initialiseWithDefaultAggregations = function () {
	        this.aggFuncsMap[AggFuncService_1.AGG_SUM] = aggSum;
	        this.aggFuncsMap[AggFuncService_1.AGG_FIRST] = aggFirst;
	        this.aggFuncsMap[AggFuncService_1.AGG_LAST] = aggLast;
	        this.aggFuncsMap[AggFuncService_1.AGG_MIN] = aggMin;
	        this.aggFuncsMap[AggFuncService_1.AGG_MAX] = aggMax;
	        this.aggFuncsMap[AggFuncService_1.AGG_COUNT] = aggCount;
	        this.aggFuncsMap[AggFuncService_1.AGG_AVG] = aggAvg;
	    };
	    AggFuncService.prototype.getDefaultAggFunc = function (column) {
	        var allKeys = this.getFuncNames(column);
	        // use 'sum' if it's a) allowed for the column and b) still registered
	        // (ie not removed by user)
	        var sumInKeysList = allKeys.indexOf(AggFuncService_1.AGG_SUM) >= 0;
	        var sumInFuncs = ag_grid_community_1._.exists(this.aggFuncsMap[AggFuncService_1.AGG_SUM]);
	        var useSum = sumInKeysList && sumInFuncs;
	        if (useSum) {
	            return AggFuncService_1.AGG_SUM;
	        }
	        else {
	            if (ag_grid_community_1._.existsAndNotEmpty(allKeys)) {
	                return allKeys[0];
	            }
	            else {
	                return null;
	            }
	        }
	    };
	    AggFuncService.prototype.addAggFuncs = function (aggFuncs) {
	        ag_grid_community_1._.iterateObject(aggFuncs, this.addAggFunc.bind(this));
	    };
	    AggFuncService.prototype.addAggFunc = function (key, aggFunc) {
	        this.init();
	        this.aggFuncsMap[key] = aggFunc;
	    };
	    AggFuncService.prototype.getAggFunc = function (name) {
	        this.init();
	        return this.aggFuncsMap[name];
	    };
	    AggFuncService.prototype.getFuncNames = function (column) {
	        var userAllowedFuncs = column.getColDef().allowedAggFuncs;
	        if (ag_grid_community_1._.exists(userAllowedFuncs) && userAllowedFuncs) {
	            return userAllowedFuncs;
	        }
	        else {
	            return Object.keys(this.aggFuncsMap).sort();
	        }
	    };
	    AggFuncService.prototype.clear = function () {
	        this.aggFuncsMap = {};
	    };
	    var AggFuncService_1;
	    AggFuncService.AGG_SUM = 'sum';
	    AggFuncService.AGG_FIRST = 'first';
	    AggFuncService.AGG_LAST = 'last';
	    AggFuncService.AGG_MIN = 'min';
	    AggFuncService.AGG_MAX = 'max';
	    AggFuncService.AGG_COUNT = 'count';
	    AggFuncService.AGG_AVG = 'avg';
	    __decorate([
	        ag_grid_community_1.Autowired('gridOptionsWrapper'),
	        __metadata("design:type", ag_grid_community_1.GridOptionsWrapper)
	    ], AggFuncService.prototype, "gridOptionsWrapper", void 0);
	    __decorate([
	        ag_grid_community_1.PostConstruct,
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", []),
	        __metadata("design:returntype", void 0)
	    ], AggFuncService.prototype, "init", null);
	    AggFuncService = AggFuncService_1 = __decorate([
	        ag_grid_community_1.Bean('aggFuncService')
	    ], AggFuncService);
	    return AggFuncService;
	}());
	exports.AggFuncService = AggFuncService;
	function aggSum(input) {
	    var result = null;
	    var length = input.length;
	    for (var i = 0; i < length; i++) {
	        if (typeof input[i] === 'number') {
	            if (result === null) {
	                result = input[i];
	            }
	            else {
	                result += input[i];
	            }
	        }
	    }
	    return result;
	}
	function aggFirst(input) {
	    if (input.length >= 0) {
	        return input[0];
	    }
	    else {
	        return null;
	    }
	}
	function aggLast(input) {
	    if (input.length >= 0) {
	        return ag_grid_community_1._.last(input);
	    }
	    else {
	        return null;
	    }
	}
	function aggMin(input) {
	    var result = null;
	    var length = input.length;
	    for (var i = 0; i < length; i++) {
	        if (typeof input[i] === 'number') {
	            if (result === null) {
	                result = input[i];
	            }
	            else if (result > input[i]) {
	                result = input[i];
	            }
	        }
	    }
	    return result;
	}
	function aggMax(input) {
	    var result = null;
	    var length = input.length;
	    for (var i = 0; i < length; i++) {
	        if (typeof input[i] === 'number') {
	            if (result === null) {
	                result = input[i];
	            }
	            else if (result < input[i]) {
	                result = input[i];
	            }
	        }
	    }
	    return result;
	}
	function aggCount(input) {
	    var result = {
	        value: 0,
	        toString: function () {
	            return this.value.toString();
	        },
	        // used for sorting
	        toNumber: function () {
	            return this.value;
	        }
	    };
	    var length = input.length;
	    for (var i = 0; i < length; i++) {
	        var isGroupAgg = ag_grid_community_1._.exists(input[i]) && typeof input[i].value === 'number';
	        if (isGroupAgg) {
	            result.value += input[i].value;
	        }
	        else {
	            result.value++;
	        }
	    }
	    return result;
	}
	// the average function is tricky as the multiple levels require weighted averages
	// for the non-leaf node aggregations.
	function aggAvg(input) {
	    // the average will be the sum / count
	    var sum = 0;
	    var count = 0;
	    var length = input.length;
	    for (var i = 0; i < length; i++) {
	        var currentItem = input[i];
	        var itemIsGroupResult = ag_grid_community_1._.exists(currentItem) && typeof currentItem.value === 'number' && typeof currentItem.count === 'number';
	        // skip values that are not numbers (ie skip empty values)
	        if (typeof currentItem === 'number') {
	            sum += currentItem;
	            count++;
	            // check if it's a group (ie value is a wrapper object)
	        }
	        else if (itemIsGroupResult) {
	            // we are aggregating groups, so we take the
	            // aggregated values to calculated a weighted average
	            sum += currentItem.value * currentItem.count;
	            count += currentItem.count;
	        }
	    }
	    // avoid divide by zero error
	    var value = null;
	    if (count !== 0) {
	        value = sum / count;
	    }
	    // the result will be an object. when this cell is rendered, only the avg is shown.
	    // however when this cell is part of another aggregation, the count is also needed
	    // to create a weighted average for the next level.
	    var result = {
	        count: count,
	        value: value,
	        // the grid by default uses toString to render values for an object, so this
	        // is a trick to get the default cellRenderer to display the avg value
	        toString: function () {
	            if (typeof this.value === 'number') {
	                return this.value.toString();
	            }
	            else {
	                return '';
	            }
	        },
	        // used for sorting
	        toNumber: function () {
	            return this.value;
	        }
	    };
	    return result;
	}


/***/ }),
/* 2514 */
/***/ (function(module, exports, __webpack_require__) {

	// ag-grid-enterprise v21.2.2
	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var main_1 = __webpack_require__(2322);
	var primaryColsListPanel_1 = __webpack_require__(2515);
	var primaryColsHeaderPanel_1 = __webpack_require__(2518);
	var PrimaryColsPanel = /** @class */ (function (_super) {
	    __extends(PrimaryColsPanel, _super);
	    // we allow dragging in the toolPanel, but not when this component appears in the column menu
	    function PrimaryColsPanel(allowDragging, params) {
	        var _this = _super.call(this, PrimaryColsPanel.TEMPLATE) || this;
	        _this.allowDragging = allowDragging;
	        _this.params = params;
	        return _this;
	    }
	    PrimaryColsPanel.prototype.init = function () {
	        this.primaryColsHeaderPanel.init(this.params);
	        this.primaryColsListPanel.init(this.params, this.allowDragging);
	        var hideFilter = this.params.suppressColumnFilter;
	        var hideSelect = this.params.suppressColumnSelectAll;
	        var hideExpand = this.params.suppressColumnExpandAll;
	        if (hideExpand && hideFilter && hideSelect) {
	            this.primaryColsHeaderPanel.setDisplayed(false);
	        }
	        this.addDestroyableEventListener(this.primaryColsHeaderPanel, 'expandAll', this.onExpandAll.bind(this));
	        this.addDestroyableEventListener(this.primaryColsHeaderPanel, 'collapseAll', this.onCollapseAll.bind(this));
	        this.addDestroyableEventListener(this.primaryColsHeaderPanel, 'selectAll', this.onSelectAll.bind(this));
	        this.addDestroyableEventListener(this.primaryColsHeaderPanel, 'unselectAll', this.onUnselectAll.bind(this));
	        this.addDestroyableEventListener(this.primaryColsHeaderPanel, 'filterChanged', this.onFilterChanged.bind(this));
	        this.addDestroyableEventListener(this.primaryColsListPanel, 'groupExpanded', this.onGroupExpanded.bind(this));
	    };
	    PrimaryColsPanel.prototype.onFilterChanged = function (event) {
	        this.primaryColsListPanel.setFilterText(event.filterText);
	    };
	    PrimaryColsPanel.prototype.onSelectAll = function () {
	        this.primaryColsListPanel.doSetSelectedAll(true);
	    };
	    PrimaryColsPanel.prototype.onUnselectAll = function () {
	        this.primaryColsListPanel.doSetSelectedAll(false);
	    };
	    PrimaryColsPanel.prototype.onExpandAll = function () {
	        this.primaryColsListPanel.doSetExpandedAll(true);
	    };
	    PrimaryColsPanel.prototype.onCollapseAll = function () {
	        this.primaryColsListPanel.doSetExpandedAll(false);
	    };
	    PrimaryColsPanel.prototype.onGroupExpanded = function (event) {
	        this.primaryColsHeaderPanel.setExpandState(event.state);
	    };
	    PrimaryColsPanel.TEMPLATE = "<div class=\"ag-column-select-panel\">\n            <ag-primary-cols-header ref=\"primaryColsHeaderPanel\"></ag-primary-cols-header>\n            <ag-primary-cols-list ref=\"primaryColsListPanel\"></ag-primary-cols-list>\n        </div>";
	    __decorate([
	        main_1.Autowired('gridOptionsWrapper'),
	        __metadata("design:type", main_1.GridOptionsWrapper)
	    ], PrimaryColsPanel.prototype, "gridOptionsWrapper", void 0);
	    __decorate([
	        main_1.RefSelector('primaryColsHeaderPanel'),
	        __metadata("design:type", primaryColsHeaderPanel_1.PrimaryColsHeaderPanel)
	    ], PrimaryColsPanel.prototype, "primaryColsHeaderPanel", void 0);
	    __decorate([
	        main_1.RefSelector('primaryColsListPanel'),
	        __metadata("design:type", primaryColsListPanel_1.PrimaryColsListPanel)
	    ], PrimaryColsPanel.prototype, "primaryColsListPanel", void 0);
	    __decorate([
	        main_1.PostConstruct,
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", []),
	        __metadata("design:returntype", void 0)
	    ], PrimaryColsPanel.prototype, "init", null);
	    return PrimaryColsPanel;
	}(main_1.Component));
	exports.PrimaryColsPanel = PrimaryColsPanel;


/***/ }),
/* 2515 */
/***/ (function(module, exports, __webpack_require__) {

	// ag-grid-enterprise v21.2.2
	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var main_1 = __webpack_require__(2322);
	var toolPanelColumnGroupComp_1 = __webpack_require__(2516);
	var toolPanelColumnComp_1 = __webpack_require__(2517);
	var primaryColsHeaderPanel_1 = __webpack_require__(2518);
	var ag_grid_community_1 = __webpack_require__(2322);
	var PrimaryColsListPanel = /** @class */ (function (_super) {
	    __extends(PrimaryColsListPanel, _super);
	    function PrimaryColsListPanel() {
	        return _super.call(this, PrimaryColsListPanel.TEMPLATE) || this;
	    }
	    PrimaryColsListPanel.prototype.init = function (params, allowDragging) {
	        this.params = params;
	        this.allowDragging = allowDragging;
	        this.addDestroyableEventListener(this.globalEventService, main_1.Events.EVENT_COLUMN_EVERYTHING_CHANGED, this.onColumnsChanged.bind(this));
	        this.expandGroupsByDefault = !this.params.contractColumnSelection;
	        if (this.columnController.isReady()) {
	            this.onColumnsChanged();
	        }
	    };
	    PrimaryColsListPanel.prototype.onColumnsChanged = function () {
	        this.destroyColumnComps();
	        this.columnTree = this.columnController.getPrimaryColumnTree();
	        var groupsExist = this.columnController.isPrimaryColumnGroupsPresent();
	        this.recursivelyAddComps(this.columnTree, 0, groupsExist);
	        this.updateVisibilityOfRows();
	    };
	    PrimaryColsListPanel.prototype.destroyColumnComps = function () {
	        main_1._.clearElement(this.getGui());
	        if (this.columnComps) {
	            main_1._.iterateObject(this.columnComps, function (key, renderedItem) { return renderedItem.destroy(); });
	        }
	        this.columnComps = {};
	    };
	    PrimaryColsListPanel.prototype.recursivelyAddGroupComps = function (columnGroup, dept, groupsExist) {
	        // only render group if user provided the definition
	        var newDept;
	        if (columnGroup.getColGroupDef() && columnGroup.getColGroupDef().suppressToolPanel) {
	            return;
	        }
	        if (!columnGroup.isPadding()) {
	            var renderedGroup = new toolPanelColumnGroupComp_1.ToolPanelColumnGroupComp(columnGroup, dept, this.onGroupExpanded.bind(this), this.allowDragging, this.expandGroupsByDefault);
	            this.getContext().wireBean(renderedGroup);
	            this.getGui().appendChild(renderedGroup.getGui());
	            // we want to indent on the gui for the children
	            newDept = dept + 1;
	            this.columnComps[columnGroup.getId()] = renderedGroup;
	        }
	        else {
	            // no children, so no indent
	            newDept = dept;
	        }
	        this.recursivelyAddComps(columnGroup.getChildren(), newDept, groupsExist);
	    };
	    PrimaryColsListPanel.prototype.onGroupExpanded = function () {
	        this.updateVisibilityOfRows();
	        this.fireExpandedEvent();
	    };
	    PrimaryColsListPanel.prototype.fireExpandedEvent = function () {
	        var _this = this;
	        var expandedCount = 0;
	        var notExpandedCount = 0;
	        var recursiveFunc = function (items) {
	            items.forEach(function (item) {
	                // only interested in groups
	                if (item instanceof main_1.OriginalColumnGroup) {
	                    var comp = _this.columnComps[item.getId()];
	                    if (comp) {
	                        if (comp.isExpanded()) {
	                            expandedCount++;
	                        }
	                        else {
	                            notExpandedCount++;
	                        }
	                    }
	                    var columnGroup = item;
	                    var groupChildren = columnGroup.getChildren();
	                    recursiveFunc(groupChildren);
	                }
	            });
	        };
	        recursiveFunc(this.columnTree);
	        var state;
	        if (expandedCount > 0 && notExpandedCount > 0) {
	            state = primaryColsHeaderPanel_1.SELECTED_STATE.INDETERMINATE;
	        }
	        else if (notExpandedCount > 0) {
	            state = primaryColsHeaderPanel_1.SELECTED_STATE.UNCHECKED;
	        }
	        else {
	            state = primaryColsHeaderPanel_1.SELECTED_STATE.CHECKED;
	        }
	        this.dispatchEvent({ type: 'groupExpanded', state: state });
	    };
	    PrimaryColsListPanel.prototype.recursivelyAddColumnComps = function (column, dept, groupsExist) {
	        if (column.getColDef() && column.getColDef().suppressToolPanel) {
	            return;
	        }
	        var columnComp = new toolPanelColumnComp_1.ToolPanelColumnComp(column, dept, this.allowDragging, groupsExist);
	        this.getContext().wireBean(columnComp);
	        this.getGui().appendChild(columnComp.getGui());
	        this.columnComps[column.getId()] = columnComp;
	    };
	    PrimaryColsListPanel.prototype.recursivelyAddComps = function (tree, dept, groupsExist) {
	        var _this = this;
	        tree.forEach(function (child) {
	            if (child instanceof main_1.OriginalColumnGroup) {
	                _this.recursivelyAddGroupComps(child, dept, groupsExist);
	            }
	            else {
	                _this.recursivelyAddColumnComps(child, dept, groupsExist);
	            }
	        });
	    };
	    PrimaryColsListPanel.prototype.destroy = function () {
	        _super.prototype.destroy.call(this);
	        this.destroyColumnComps();
	    };
	    PrimaryColsListPanel.prototype.doSetExpandedAll = function (value) {
	        main_1._.iterateObject(this.columnComps, function (key, renderedItem) {
	            if (renderedItem.isExpandable()) {
	                renderedItem.setExpanded(value);
	            }
	        });
	    };
	    PrimaryColsListPanel.prototype.setFilterText = function (filterText) {
	        this.filterText = main_1._.exists(filterText) ? filterText.toLowerCase() : null;
	        this.updateVisibilityOfRows();
	    };
	    PrimaryColsListPanel.prototype.updateVisibilityOfRows = function () {
	        // we have to create the filter results first as that requires dept first search, then setting
	        // the visibility requires breadth first search. this is because a group passes filter if CHILDREN
	        // pass filter, a column passes group open/closed visibility if a PARENT is open. so we need to do
	        // two recursions. we pass the result of the first recursion to the second.
	        var filterResults = main_1._.exists(this.filterText) ? this.createFilterResults() : null;
	        this.recursivelySetVisibility(this.columnTree, true, filterResults);
	    };
	    PrimaryColsListPanel.prototype.createFilterResults = function () {
	        var _this = this;
	        var filterResults = {};
	        // we recurse dept first - as the item should show if any of the children are showing
	        var recursivelyCheckFilter = function (items) {
	            var atLeastOneThisLevelPassed = false;
	            items.forEach(function (item) {
	                var atLeastOneChildPassed = false;
	                if (item instanceof main_1.OriginalColumnGroup) {
	                    var columnGroup = item;
	                    var groupChildren = columnGroup.getChildren();
	                    atLeastOneChildPassed = recursivelyCheckFilter(groupChildren);
	                }
	                var filterPasses;
	                if (atLeastOneChildPassed) {
	                    filterPasses = true;
	                }
	                else {
	                    var comp = _this.columnComps[item.getId()];
	                    if (comp && _this.filterText) {
	                        var displayName = comp.getDisplayName();
	                        filterPasses = displayName !== null ? displayName.toLowerCase().indexOf(_this.filterText) >= 0 : true;
	                    }
	                    else {
	                        // if this is a dummy column group, we should return false here
	                        filterPasses = item instanceof main_1.OriginalColumnGroup && item.getOriginalParent() ? true : false;
	                    }
	                }
	                filterResults[item.getId()] = filterPasses;
	                if (filterPasses) {
	                    atLeastOneThisLevelPassed = true;
	                }
	            });
	            return atLeastOneThisLevelPassed;
	        };
	        recursivelyCheckFilter(this.columnTree);
	        return filterResults;
	    };
	    PrimaryColsListPanel.prototype.recursivelySetVisibility = function (columnTree, parentGroupsOpen, filterResults) {
	        var _this = this;
	        columnTree.forEach(function (child) {
	            var comp = _this.columnComps[child.getId()];
	            if (comp) {
	                var passesFilter = filterResults ? filterResults[child.getId()] : true;
	                comp.setDisplayed(parentGroupsOpen && passesFilter);
	            }
	            if (child instanceof main_1.OriginalColumnGroup) {
	                var columnGroup = child;
	                var childrenOpen = void 0;
	                if (comp) {
	                    var expanded = comp.isExpanded();
	                    childrenOpen = parentGroupsOpen ? expanded : false;
	                }
	                else {
	                    childrenOpen = parentGroupsOpen;
	                }
	                var children = columnGroup.getChildren();
	                _this.recursivelySetVisibility(children, childrenOpen, filterResults);
	            }
	        });
	    };
	    PrimaryColsListPanel.prototype.doSetSelectedAll = function (checked) {
	        if (this.columnApi.isPivotMode()) {
	            // if pivot mode is on, then selecting columns has special meaning (eg group, aggregate, pivot etc),
	            // so there is no bulk operation we can do.
	            main_1._.iterateObject(this.columnComps, function (key, column) {
	                column.onSelectAllChanged(checked);
	            });
	        }
	        else {
	            // however if pivot mode is off, then it's all about column visibility so we can do a bulk
	            // operation directly with the column controller. we could column.onSelectAllChanged(checked)
	            // as above, however this would work on each column independently and take longer.
	            var primaryCols = this.columnApi.getPrimaryColumns();
	            this.columnApi.setColumnsVisible(primaryCols, checked);
	        }
	    };
	    PrimaryColsListPanel.TEMPLATE = "<div class=\"ag-primary-cols-list-panel\"></div>";
	    __decorate([
	        main_1.Autowired('gridOptionsWrapper'),
	        __metadata("design:type", main_1.GridOptionsWrapper)
	    ], PrimaryColsListPanel.prototype, "gridOptionsWrapper", void 0);
	    __decorate([
	        main_1.Autowired('columnController'),
	        __metadata("design:type", main_1.ColumnController)
	    ], PrimaryColsListPanel.prototype, "columnController", void 0);
	    __decorate([
	        main_1.Autowired('eventService'),
	        __metadata("design:type", main_1.EventService)
	    ], PrimaryColsListPanel.prototype, "globalEventService", void 0);
	    __decorate([
	        main_1.Autowired('columnApi'),
	        __metadata("design:type", ag_grid_community_1.ColumnApi)
	    ], PrimaryColsListPanel.prototype, "columnApi", void 0);
	    return PrimaryColsListPanel;
	}(main_1.Component));
	exports.PrimaryColsListPanel = PrimaryColsListPanel;


/***/ }),
/* 2516 */
/***/ (function(module, exports, __webpack_require__) {

	// ag-grid-enterprise v21.2.2
	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var main_1 = __webpack_require__(2322);
	var ToolPanelColumnGroupComp = /** @class */ (function (_super) {
	    __extends(ToolPanelColumnGroupComp, _super);
	    function ToolPanelColumnGroupComp(columnGroup, columnDept, expandedCallback, allowDragging, expandByDefault) {
	        var _this = _super.call(this) || this;
	        _this.processingColumnStateChange = false;
	        _this.columnGroup = columnGroup;
	        _this.columnDept = columnDept;
	        _this.expandedCallback = expandedCallback;
	        _this.allowDragging = allowDragging;
	        _this.expanded = expandByDefault;
	        return _this;
	    }
	    ToolPanelColumnGroupComp.prototype.init = function () {
	        this.setTemplate(ToolPanelColumnGroupComp.TEMPLATE);
	        this.eDragHandle = main_1._.createIconNoSpan('columnDrag', this.gridOptionsWrapper);
	        main_1._.addCssClass(this.eDragHandle, 'ag-column-drag');
	        this.cbSelect.getGui().insertAdjacentElement('afterend', this.eDragHandle);
	        // this.displayName = this.columnGroup.getColGroupDef() ? this.columnGroup.getColGroupDef().headerName : null;
	        this.displayName = this.columnController.getDisplayNameForOriginalColumnGroup(null, this.columnGroup, 'toolPanel');
	        if (main_1._.missing(this.displayName)) {
	            this.displayName = '>>';
	        }
	        this.eLabel.innerHTML = this.displayName ? this.displayName : '';
	        this.setupExpandContract();
	        this.addCssClass('ag-toolpanel-indent-' + this.columnDept);
	        this.addDestroyableEventListener(this.eventService, main_1.Events.EVENT_COLUMN_PIVOT_MODE_CHANGED, this.onColumnStateChanged.bind(this));
	        this.addDestroyableEventListener(this.eLabel, 'click', this.onLabelClicked.bind(this));
	        this.addDestroyableEventListener(this.cbSelect, main_1.AgCheckbox.EVENT_CHANGED, this.onCheckboxChanged.bind(this));
	        this.setOpenClosedIcons();
	        this.setupDragging();
	        this.onColumnStateChanged();
	        this.addVisibilityListenersToAllChildren();
	        main_1.CssClassApplier.addToolPanelClassesFromColDef(this.columnGroup.getColGroupDef(), this.getGui(), this.gridOptionsWrapper, null, this.columnGroup);
	    };
	    ToolPanelColumnGroupComp.prototype.addVisibilityListenersToAllChildren = function () {
	        var _this = this;
	        this.columnGroup.getLeafColumns().forEach(function (column) {
	            _this.addDestroyableEventListener(column, main_1.Column.EVENT_VISIBLE_CHANGED, _this.onColumnStateChanged.bind(_this));
	            _this.addDestroyableEventListener(column, main_1.Column.EVENT_VALUE_CHANGED, _this.onColumnStateChanged.bind(_this));
	            _this.addDestroyableEventListener(column, main_1.Column.EVENT_PIVOT_CHANGED, _this.onColumnStateChanged.bind(_this));
	            _this.addDestroyableEventListener(column, main_1.Column.EVENT_ROW_GROUP_CHANGED, _this.onColumnStateChanged.bind(_this));
	        });
	    };
	    ToolPanelColumnGroupComp.prototype.setupDragging = function () {
	        var _this = this;
	        if (!this.allowDragging) {
	            main_1._.setDisplayed(this.eDragHandle, false);
	            return;
	        }
	        var dragSource = {
	            type: main_1.DragSourceType.ToolPanel,
	            eElement: this.eDragHandle,
	            dragItemName: this.displayName,
	            dragItemCallback: function () { return _this.createDragItem(); }
	        };
	        this.dragAndDropService.addDragSource(dragSource, true);
	        this.addDestroyFunc(function () { return _this.dragAndDropService.removeDragSource(dragSource); });
	    };
	    ToolPanelColumnGroupComp.prototype.createDragItem = function () {
	        var visibleState = {};
	        this.columnGroup.getLeafColumns().forEach(function (col) {
	            visibleState[col.getId()] = col.isVisible();
	        });
	        return {
	            columns: this.columnGroup.getLeafColumns(),
	            visibleState: visibleState
	        };
	    };
	    ToolPanelColumnGroupComp.prototype.setupExpandContract = function () {
	        this.eGroupClosedIcon.appendChild(main_1._.createIcon('columnSelectClosed', this.gridOptionsWrapper, null));
	        this.eGroupOpenedIcon.appendChild(main_1._.createIcon('columnSelectOpen', this.gridOptionsWrapper, null));
	        this.addDestroyableEventListener(this.eGroupClosedIcon, 'click', this.onExpandOrContractClicked.bind(this));
	        this.addDestroyableEventListener(this.eGroupOpenedIcon, 'click', this.onExpandOrContractClicked.bind(this));
	        var touchListener = new main_1.TouchListener(this.eColumnGroupIcons, true);
	        this.addDestroyableEventListener(touchListener, main_1.TouchListener.EVENT_TAP, this.onExpandOrContractClicked.bind(this));
	        this.addDestroyFunc(touchListener.destroy.bind(touchListener));
	    };
	    ToolPanelColumnGroupComp.prototype.onLabelClicked = function () {
	        var nextState = !this.cbSelect.getValue();
	        this.onChangeCommon(nextState);
	    };
	    ToolPanelColumnGroupComp.prototype.onCheckboxChanged = function (event) {
	        this.onChangeCommon(event.selected);
	    };
	    ToolPanelColumnGroupComp.prototype.onChangeCommon = function (nextState) {
	        if (this.processingColumnStateChange) {
	            return;
	        }
	        var childColumns = this.columnGroup.getLeafColumns();
	        if (this.columnController.isPivotMode()) {
	            if (nextState) {
	                this.actionCheckedReduce(childColumns);
	            }
	            else {
	                this.actionUnCheckedReduce(childColumns);
	            }
	        }
	        else {
	            var isAllowedColumn = function (c) { return !c.getColDef().lockVisible && !c.getColDef().suppressToolPanel; };
	            var allowedColumns = childColumns.filter(isAllowedColumn);
	            this.columnController.setColumnsVisible(allowedColumns, nextState, "toolPanelUi");
	        }
	        if (this.selectionCallback) {
	            this.selectionCallback(this.isSelected());
	        }
	    };
	    ToolPanelColumnGroupComp.prototype.actionUnCheckedReduce = function (columns) {
	        var columnsToUnPivot = [];
	        var columnsToUnValue = [];
	        var columnsToUnGroup = [];
	        columns.forEach(function (column) {
	            if (column.isPivotActive()) {
	                columnsToUnPivot.push(column);
	            }
	            if (column.isRowGroupActive()) {
	                columnsToUnGroup.push(column);
	            }
	            if (column.isValueActive()) {
	                columnsToUnValue.push(column);
	            }
	        });
	        if (columnsToUnPivot.length > 0) {
	            this.columnController.removePivotColumns(columnsToUnPivot, "toolPanelUi");
	        }
	        if (columnsToUnGroup.length > 0) {
	            this.columnController.removeRowGroupColumns(columnsToUnGroup, "toolPanelUi");
	        }
	        if (columnsToUnValue.length > 0) {
	            this.columnController.removeValueColumns(columnsToUnValue, "toolPanelUi");
	        }
	    };
	    ToolPanelColumnGroupComp.prototype.actionCheckedReduce = function (columns) {
	        var columnsToAggregate = [];
	        var columnsToGroup = [];
	        var columnsToPivot = [];
	        columns.forEach(function (column) {
	            // don't change any column that's already got a function active
	            if (column.isAnyFunctionActive()) {
	                return;
	            }
	            if (column.isAllowValue()) {
	                columnsToAggregate.push(column);
	            }
	            else if (column.isAllowRowGroup()) {
	                columnsToGroup.push(column);
	            }
	            else if (column.isAllowRowGroup()) {
	                columnsToPivot.push(column);
	            }
	        });
	        if (columnsToAggregate.length > 0) {
	            this.columnController.addValueColumns(columnsToAggregate, "toolPanelUi");
	        }
	        if (columnsToGroup.length > 0) {
	            this.columnController.addRowGroupColumns(columnsToGroup, "toolPanelUi");
	        }
	        if (columnsToPivot.length > 0) {
	            this.columnController.addPivotColumns(columnsToPivot, "toolPanelUi");
	        }
	    };
	    ToolPanelColumnGroupComp.prototype.onColumnStateChanged = function () {
	        var selectedValue = this.workOutSelectedValue();
	        var readOnlyValue = this.workOutReadOnlyValue();
	        this.processingColumnStateChange = true;
	        this.cbSelect.setValue(selectedValue);
	        if (this.selectionCallback) {
	            this.selectionCallback(this.isSelected());
	        }
	        this.cbSelect.setReadOnly(readOnlyValue);
	        this.processingColumnStateChange = false;
	    };
	    ToolPanelColumnGroupComp.prototype.workOutReadOnlyValue = function () {
	        var pivotMode = this.columnController.isPivotMode();
	        var colsThatCanAction = 0;
	        this.columnGroup.getLeafColumns().forEach(function (col) {
	            if (pivotMode) {
	                if (col.isAnyFunctionAllowed()) {
	                    colsThatCanAction++;
	                }
	            }
	            else {
	                if (!col.getColDef().lockVisible) {
	                    colsThatCanAction++;
	                }
	            }
	        });
	        return colsThatCanAction === 0;
	    };
	    ToolPanelColumnGroupComp.prototype.workOutSelectedValue = function () {
	        var pivotMode = this.columnController.isPivotMode();
	        var leafColumns = this.columnGroup.getLeafColumns();
	        var len = leafColumns.length;
	        var count = { visible: 0, hidden: 0 };
	        var ignoredChildCount = { visible: 0, hidden: 0 };
	        for (var i = 0; i < len; i++) {
	            var column = leafColumns[i];
	            // ignore lock visible columns and columns set to 'suppressToolPanel'
	            var ignore = column.getColDef().lockVisible || column.getColDef().suppressToolPanel;
	            var type = this.isColumnVisible(column, pivotMode) ? 'visible' : 'hidden';
	            count[type]++;
	            if (!ignore) {
	                continue;
	            }
	            ignoredChildCount[type]++;
	        }
	        // if all columns are ignored we use the regular count, if not
	        // we only consider the columns that were not ignored
	        if (ignoredChildCount.visible + ignoredChildCount.hidden !== len) {
	            count.visible -= ignoredChildCount.visible;
	            count.hidden -= ignoredChildCount.hidden;
	        }
	        var selectedValue;
	        if (count.visible > 0 && count.hidden > 0) {
	            selectedValue = null;
	        }
	        else if (count.visible > 0) {
	            selectedValue = true;
	        }
	        else {
	            selectedValue = false;
	        }
	        return selectedValue == null ? undefined : selectedValue;
	    };
	    ToolPanelColumnGroupComp.prototype.isColumnVisible = function (column, pivotMode) {
	        if (pivotMode) {
	            var pivoted = column.isPivotActive();
	            var grouped = column.isRowGroupActive();
	            var aggregated = column.isValueActive();
	            return pivoted || grouped || aggregated;
	        }
	        else {
	            return column.isVisible();
	        }
	    };
	    ToolPanelColumnGroupComp.prototype.onExpandOrContractClicked = function () {
	        this.expanded = !this.expanded;
	        this.setOpenClosedIcons();
	        this.expandedCallback();
	    };
	    ToolPanelColumnGroupComp.prototype.setOpenClosedIcons = function () {
	        var folderOpen = this.expanded;
	        main_1._.setDisplayed(this.eGroupClosedIcon, !folderOpen);
	        main_1._.setDisplayed(this.eGroupOpenedIcon, folderOpen);
	    };
	    ToolPanelColumnGroupComp.prototype.isExpanded = function () {
	        return this.expanded;
	    };
	    ToolPanelColumnGroupComp.prototype.getDisplayName = function () {
	        return this.displayName;
	    };
	    ToolPanelColumnGroupComp.prototype.onSelectAllChanged = function (value) {
	        if ((value && !this.cbSelect.getValue()) ||
	            (!value && this.cbSelect.getValue())) {
	            if (!this.cbSelect.isReadOnly()) {
	                this.cbSelect.toggle();
	            }
	        }
	    };
	    ToolPanelColumnGroupComp.prototype.isSelected = function () {
	        return this.cbSelect.getValue();
	    };
	    ToolPanelColumnGroupComp.prototype.isSelectable = function () {
	        return !this.cbSelect.isReadOnly();
	    };
	    ToolPanelColumnGroupComp.prototype.isExpandable = function () {
	        return true;
	    };
	    ToolPanelColumnGroupComp.prototype.setExpanded = function (value) {
	        if (this.expanded !== value) {
	            this.onExpandOrContractClicked();
	        }
	    };
	    ToolPanelColumnGroupComp.TEMPLATE = "<div class=\"ag-column-tool-panel-column-group\">\n            <span class=\"ag-column-group-icons\" ref=\"eColumnGroupIcons\" >\n                <span class=\"ag-column-group-closed-icon\" ref=\"eGroupOpenedIcon\"></span>\n                <span class=\"ag-column-group-opened-icon\" ref=\"eGroupClosedIcon\"></span>\n            </span>\n            <ag-checkbox ref=\"cbSelect\" class=\"ag-column-select-checkbox\"></ag-checkbox>\n            <span class=\"ag-column-tool-panel-column-label\" ref=\"eLabel\"></span>\n        </div>";
	    __decorate([
	        main_1.Autowired('gridOptionsWrapper'),
	        __metadata("design:type", main_1.GridOptionsWrapper)
	    ], ToolPanelColumnGroupComp.prototype, "gridOptionsWrapper", void 0);
	    __decorate([
	        main_1.Autowired('columnController'),
	        __metadata("design:type", main_1.ColumnController)
	    ], ToolPanelColumnGroupComp.prototype, "columnController", void 0);
	    __decorate([
	        main_1.Autowired('dragAndDropService'),
	        __metadata("design:type", main_1.DragAndDropService)
	    ], ToolPanelColumnGroupComp.prototype, "dragAndDropService", void 0);
	    __decorate([
	        main_1.Autowired('eventService'),
	        __metadata("design:type", main_1.EventService)
	    ], ToolPanelColumnGroupComp.prototype, "eventService", void 0);
	    __decorate([
	        main_1.RefSelector('cbSelect'),
	        __metadata("design:type", main_1.AgCheckbox)
	    ], ToolPanelColumnGroupComp.prototype, "cbSelect", void 0);
	    __decorate([
	        main_1.RefSelector('eLabel'),
	        __metadata("design:type", HTMLElement)
	    ], ToolPanelColumnGroupComp.prototype, "eLabel", void 0);
	    __decorate([
	        main_1.RefSelector('eGroupOpenedIcon'),
	        __metadata("design:type", HTMLElement)
	    ], ToolPanelColumnGroupComp.prototype, "eGroupOpenedIcon", void 0);
	    __decorate([
	        main_1.RefSelector('eGroupClosedIcon'),
	        __metadata("design:type", HTMLElement)
	    ], ToolPanelColumnGroupComp.prototype, "eGroupClosedIcon", void 0);
	    __decorate([
	        main_1.RefSelector('eColumnGroupIcons'),
	        __metadata("design:type", HTMLElement)
	    ], ToolPanelColumnGroupComp.prototype, "eColumnGroupIcons", void 0);
	    __decorate([
	        main_1.PostConstruct,
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", []),
	        __metadata("design:returntype", void 0)
	    ], ToolPanelColumnGroupComp.prototype, "init", null);
	    return ToolPanelColumnGroupComp;
	}(main_1.Component));
	exports.ToolPanelColumnGroupComp = ToolPanelColumnGroupComp;


/***/ }),
/* 2517 */
/***/ (function(module, exports, __webpack_require__) {

	// ag-grid-enterprise v21.2.2
	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var main_1 = __webpack_require__(2322);
	var ToolPanelColumnComp = /** @class */ (function (_super) {
	    __extends(ToolPanelColumnComp, _super);
	    function ToolPanelColumnComp(column, columnDept, allowDragging, groupsExist) {
	        var _this = _super.call(this) || this;
	        _this.processingColumnStateChange = false;
	        _this.column = column;
	        _this.columnDept = columnDept;
	        _this.allowDragging = allowDragging;
	        _this.groupsExist = groupsExist;
	        return _this;
	    }
	    ToolPanelColumnComp.prototype.init = function () {
	        this.setTemplate(ToolPanelColumnComp.TEMPLATE);
	        this.eDragHandle = main_1._.createIconNoSpan('columnDrag', this.gridOptionsWrapper);
	        main_1._.addCssClass(this.eDragHandle, 'ag-column-drag');
	        this.cbSelect.getGui().insertAdjacentElement('afterend', this.eDragHandle);
	        this.displayName = this.columnController.getDisplayNameForColumn(this.column, 'toolPanel');
	        var displayNameSanitised = main_1._.escape(this.displayName);
	        this.eLabel.innerHTML = displayNameSanitised;
	        // if grouping, we add an extra level of indent, to cater for expand/contract icons we need to indent for
	        var indent = this.columnDept;
	        if (this.groupsExist) {
	            this.addCssClass('ag-toolpanel-add-group-indent');
	        }
	        this.addCssClass("ag-toolpanel-indent-" + indent);
	        this.setupDragging();
	        this.addDestroyableEventListener(this.eventService, main_1.Events.EVENT_COLUMN_PIVOT_MODE_CHANGED, this.onColumnStateChanged.bind(this));
	        this.addDestroyableEventListener(this.column, main_1.Column.EVENT_VALUE_CHANGED, this.onColumnStateChanged.bind(this));
	        this.addDestroyableEventListener(this.column, main_1.Column.EVENT_PIVOT_CHANGED, this.onColumnStateChanged.bind(this));
	        this.addDestroyableEventListener(this.column, main_1.Column.EVENT_ROW_GROUP_CHANGED, this.onColumnStateChanged.bind(this));
	        this.addDestroyableEventListener(this.column, main_1.Column.EVENT_VISIBLE_CHANGED, this.onColumnStateChanged.bind(this));
	        this.addDestroyableEventListener(this.gridOptionsWrapper, 'functionsReadOnly', this.onColumnStateChanged.bind(this));
	        this.addDestroyableEventListener(this.cbSelect, main_1.AgCheckbox.EVENT_CHANGED, this.onCheckboxChanged.bind(this));
	        this.addDestroyableEventListener(this.eLabel, 'click', this.onLabelClicked.bind(this));
	        this.onColumnStateChanged();
	        main_1.CssClassApplier.addToolPanelClassesFromColDef(this.column.getColDef(), this.getGui(), this.gridOptionsWrapper, this.column, null);
	    };
	    ToolPanelColumnComp.prototype.onLabelClicked = function () {
	        if (this.gridOptionsWrapper.isFunctionsReadOnly()) {
	            return;
	        }
	        var nextState = !this.cbSelect.getValue();
	        this.onChangeCommon(nextState);
	    };
	    ToolPanelColumnComp.prototype.onCheckboxChanged = function (event) {
	        this.onChangeCommon(event.selected);
	    };
	    ToolPanelColumnComp.prototype.onChangeCommon = function (nextState) {
	        // ignore lock visible columns
	        if (this.column.getColDef().lockVisible) {
	            return;
	        }
	        // only want to action if the user clicked the checkbox, not is we are setting the checkbox because
	        // of a change in the model
	        if (this.processingColumnStateChange) {
	            return;
	        }
	        // action in a timeout, as the action takes some time, we want to update the icons first
	        // so the user gets nice feedback when they click. otherwise there would be a lag and the
	        // user would think the checkboxes were clunky
	        if (this.columnController.isPivotMode()) {
	            if (nextState) {
	                this.actionCheckedPivotMode();
	            }
	            else {
	                this.actionUnCheckedPivotMode();
	            }
	        }
	        else {
	            this.columnController.setColumnVisible(this.column, nextState, "columnMenu");
	        }
	        if (this.selectionCallback) {
	            this.selectionCallback(this.isSelected());
	        }
	    };
	    ToolPanelColumnComp.prototype.actionUnCheckedPivotMode = function () {
	        var functionPassive = this.gridOptionsWrapper.isFunctionsPassive();
	        var column = this.column;
	        var columnController = this.columnController;
	        // remove pivot if column is pivoted
	        if (column.isPivotActive()) {
	            if (functionPassive) {
	                var copyOfPivotColumns = this.columnController.getPivotColumns().slice();
	                copyOfPivotColumns.push(column);
	                var event_1 = {
	                    type: main_1.Events.EVENT_COLUMN_PIVOT_CHANGE_REQUEST,
	                    columns: copyOfPivotColumns,
	                    api: this.gridApi,
	                    columnApi: this.columnApi
	                };
	                this.eventService.dispatchEvent(event_1);
	            }
	            else {
	                columnController.removePivotColumn(column, "columnMenu");
	            }
	        }
	        // remove value if column is value
	        if (column.isValueActive()) {
	            if (functionPassive) {
	                var copyOfValueColumns = this.columnController.getValueColumns().slice();
	                copyOfValueColumns.push(column);
	                var event_2 = {
	                    type: main_1.Events.EVENT_COLUMN_VALUE_CHANGE_REQUEST,
	                    columns: copyOfValueColumns,
	                    api: this.gridApi,
	                    columnApi: this.columnApi
	                };
	                this.eventService.dispatchEvent(event_2);
	            }
	            else {
	                columnController.removeValueColumn(column, "columnMenu");
	            }
	        }
	        // remove group if column is grouped
	        if (column.isRowGroupActive()) {
	            if (functionPassive) {
	                var copyOfRowGroupColumns = this.columnController.getRowGroupColumns().slice();
	                copyOfRowGroupColumns.push(column);
	                var event_3 = {
	                    type: main_1.Events.EVENT_COLUMN_ROW_GROUP_CHANGE_REQUEST,
	                    columns: copyOfRowGroupColumns,
	                    api: this.gridApi,
	                    columnApi: this.columnApi
	                };
	                this.eventService.dispatchEvent(event_3);
	            }
	            else {
	                columnController.removeRowGroupColumn(column, "columnMenu");
	            }
	        }
	    };
	    ToolPanelColumnComp.prototype.actionCheckedPivotMode = function () {
	        var column = this.column;
	        // function already active, so do nothing
	        if (column.isValueActive() || column.isPivotActive() || column.isRowGroupActive()) {
	            return;
	        }
	        var functionPassive = this.gridOptionsWrapper.isFunctionsPassive();
	        if (column.isAllowValue()) {
	            if (functionPassive) {
	                var copyOfValueColumns = this.columnController.getValueColumns().slice();
	                main_1._.removeFromArray(copyOfValueColumns, column);
	                var event_4 = {
	                    type: main_1.Events.EVENT_COLUMN_VALUE_CHANGE_REQUEST,
	                    api: this.gridApi,
	                    columnApi: this.columnApi,
	                    columns: copyOfValueColumns
	                };
	                this.eventService.dispatchEvent(event_4);
	            }
	            else {
	                this.columnController.addValueColumn(column, "columnMenu");
	            }
	        }
	        else if (column.isAllowRowGroup()) {
	            if (functionPassive) {
	                var copyOfRowGroupColumns = this.columnController.getRowGroupColumns().slice();
	                main_1._.removeFromArray(copyOfRowGroupColumns, column);
	                var event_5 = {
	                    type: main_1.Events.EVENT_COLUMN_ROW_GROUP_CHANGE_REQUEST,
	                    api: this.gridApi,
	                    columnApi: this.columnApi,
	                    columns: copyOfRowGroupColumns
	                };
	                this.eventService.dispatchEvent(event_5);
	            }
	            else {
	                this.columnController.addRowGroupColumn(column, "columnMenu");
	            }
	        }
	        else if (column.isAllowPivot()) {
	            if (functionPassive) {
	                var copyOfPivotColumns = this.columnController.getPivotColumns().slice();
	                main_1._.removeFromArray(copyOfPivotColumns, column);
	                var event_6 = {
	                    type: main_1.Events.EVENT_COLUMN_PIVOT_CHANGE_REQUEST,
	                    api: this.gridApi,
	                    columnApi: this.columnApi,
	                    columns: copyOfPivotColumns
	                };
	                this.eventService.dispatchEvent(event_6);
	            }
	            else {
	                this.columnController.addPivotColumn(column, "columnMenu");
	            }
	        }
	    };
	    ToolPanelColumnComp.prototype.setupDragging = function () {
	        var _this = this;
	        if (!this.allowDragging) {
	            main_1._.setDisplayed(this.eDragHandle, false);
	            return;
	        }
	        var dragSource = {
	            type: main_1.DragSourceType.ToolPanel,
	            eElement: this.eDragHandle,
	            dragItemName: this.displayName,
	            dragItemCallback: function () { return _this.createDragItem(); }
	        };
	        this.dragAndDropService.addDragSource(dragSource, true);
	        this.addDestroyFunc(function () { return _this.dragAndDropService.removeDragSource(dragSource); });
	    };
	    ToolPanelColumnComp.prototype.createDragItem = function () {
	        var visibleState = {};
	        visibleState[this.column.getId()] = this.column.isVisible();
	        return {
	            columns: [this.column],
	            visibleState: visibleState
	        };
	    };
	    ToolPanelColumnComp.prototype.onColumnStateChanged = function () {
	        this.processingColumnStateChange = true;
	        var isPivotMode = this.columnController.isPivotMode();
	        if (isPivotMode) {
	            // if reducing, checkbox means column is one of pivot, value or group
	            var anyFunctionActive = this.column.isAnyFunctionActive();
	            this.cbSelect.setValue(anyFunctionActive);
	            if (this.selectionCallback) {
	                this.selectionCallback(this.isSelected());
	            }
	        }
	        else {
	            // if not reducing, the checkbox tells us if column is visible or not
	            this.cbSelect.setValue(this.column.isVisible());
	            if (this.selectionCallback) {
	                this.selectionCallback(this.isSelected());
	            }
	        }
	        var checkboxReadOnly;
	        if (isPivotMode) {
	            // when in pivot mode, the item should be read only if:
	            //  a) gui is not allowed make any changes
	            var functionsReadOnly = this.gridOptionsWrapper.isFunctionsReadOnly();
	            //  b) column is not allow any functions on it
	            var noFunctionsAllowed = !this.column.isAnyFunctionAllowed();
	            checkboxReadOnly = functionsReadOnly || noFunctionsAllowed;
	        }
	        else {
	            // when in normal mode, the checkbox is read only if visibility is locked
	            checkboxReadOnly = !!this.column.getColDef().lockVisible;
	        }
	        this.cbSelect.setReadOnly(checkboxReadOnly);
	        var checkboxPassive = isPivotMode && this.gridOptionsWrapper.isFunctionsPassive();
	        this.cbSelect.setPassive(checkboxPassive);
	        this.processingColumnStateChange = false;
	    };
	    ToolPanelColumnComp.prototype.getDisplayName = function () {
	        return this.displayName;
	    };
	    ToolPanelColumnComp.prototype.onSelectAllChanged = function (value) {
	        if (value !== this.cbSelect.getValue()) {
	            if (!this.cbSelect.isReadOnly()) {
	                this.cbSelect.toggle();
	            }
	        }
	    };
	    ToolPanelColumnComp.prototype.isSelected = function () {
	        return this.cbSelect.getValue();
	    };
	    ToolPanelColumnComp.prototype.isSelectable = function () {
	        return !this.cbSelect.isReadOnly();
	    };
	    ToolPanelColumnComp.prototype.isExpandable = function () {
	        return false;
	    };
	    ToolPanelColumnComp.prototype.setExpanded = function (value) {
	        console.warn('ag-grid: can not expand a column item that does not represent a column group header');
	    };
	    ToolPanelColumnComp.TEMPLATE = "<div class=\"ag-column-tool-panel-column\">\n            <ag-checkbox ref=\"cbSelect\" class=\"ag-column-select-checkbox\"></ag-checkbox>\n            <span class=\"ag-column-tool-panel-column-label\" ref=\"eLabel\"></span>\n        </div>";
	    __decorate([
	        main_1.Autowired('gridOptionsWrapper'),
	        __metadata("design:type", main_1.GridOptionsWrapper)
	    ], ToolPanelColumnComp.prototype, "gridOptionsWrapper", void 0);
	    __decorate([
	        main_1.Autowired('columnController'),
	        __metadata("design:type", main_1.ColumnController)
	    ], ToolPanelColumnComp.prototype, "columnController", void 0);
	    __decorate([
	        main_1.Autowired('eventService'),
	        __metadata("design:type", main_1.EventService)
	    ], ToolPanelColumnComp.prototype, "eventService", void 0);
	    __decorate([
	        main_1.Autowired('dragAndDropService'),
	        __metadata("design:type", main_1.DragAndDropService)
	    ], ToolPanelColumnComp.prototype, "dragAndDropService", void 0);
	    __decorate([
	        main_1.Autowired('columnApi'),
	        __metadata("design:type", main_1.ColumnApi)
	    ], ToolPanelColumnComp.prototype, "columnApi", void 0);
	    __decorate([
	        main_1.Autowired('gridApi'),
	        __metadata("design:type", main_1.GridApi)
	    ], ToolPanelColumnComp.prototype, "gridApi", void 0);
	    __decorate([
	        main_1.RefSelector('eLabel'),
	        __metadata("design:type", HTMLElement)
	    ], ToolPanelColumnComp.prototype, "eLabel", void 0);
	    __decorate([
	        main_1.RefSelector('cbSelect'),
	        __metadata("design:type", main_1.AgCheckbox)
	    ], ToolPanelColumnComp.prototype, "cbSelect", void 0);
	    __decorate([
	        main_1.PostConstruct,
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", []),
	        __metadata("design:returntype", void 0)
	    ], ToolPanelColumnComp.prototype, "init", null);
	    return ToolPanelColumnComp;
	}(main_1.Component));
	exports.ToolPanelColumnComp = ToolPanelColumnComp;


/***/ }),
/* 2518 */
/***/ (function(module, exports, __webpack_require__) {

	// ag-grid-enterprise v21.2.2
	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var main_1 = __webpack_require__(2322);
	var SELECTED_STATE;
	(function (SELECTED_STATE) {
	    SELECTED_STATE[SELECTED_STATE["CHECKED"] = 0] = "CHECKED";
	    SELECTED_STATE[SELECTED_STATE["UNCHECKED"] = 1] = "UNCHECKED";
	    SELECTED_STATE[SELECTED_STATE["INDETERMINATE"] = 2] = "INDETERMINATE";
	})(SELECTED_STATE = exports.SELECTED_STATE || (exports.SELECTED_STATE = {}));
	var PrimaryColsHeaderPanel = /** @class */ (function (_super) {
	    __extends(PrimaryColsHeaderPanel, _super);
	    function PrimaryColsHeaderPanel() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.expandState = SELECTED_STATE.CHECKED;
	        _this.selectState = SELECTED_STATE.CHECKED;
	        return _this;
	    }
	    PrimaryColsHeaderPanel.prototype.preConstruct = function () {
	        var translate = this.gridOptionsWrapper.getLocaleTextFunc();
	        this.setTemplate("<div class=\"ag-primary-cols-header-panel\" role=\"presentation\">\n            <div ref=\"eExpand\"></div>\n            <div ref=\"eSelect\"></div>\n            <div class=\"ag-input-wrapper ag-primary-cols-filter-wrapper\" ref=\"eFilterWrapper\" role=\"presentation\">\n                <input class=\"ag-primary-cols-filter\" ref=\"eFilterTextField\" type=\"text\" placeholder=\"" + translate('filterOoo', 'Filter...') + "\">        \n            </div>\n        </div>");
	    };
	    PrimaryColsHeaderPanel.prototype.postConstruct = function () {
	        this.addEventListeners();
	        this.createExpandIcons();
	        this.createCheckIcons();
	        this.setExpandState(SELECTED_STATE.CHECKED);
	        this.addDestroyableEventListener(this.eExpand, 'click', this.onExpandClicked.bind(this));
	        this.addDestroyableEventListener(this.eSelect, 'click', this.onSelectClicked.bind(this));
	        this.addDestroyableEventListener(this.eFilterTextField, 'input', this.onFilterTextChanged.bind(this));
	    };
	    PrimaryColsHeaderPanel.prototype.init = function (params) {
	        this.params = params;
	        if (this.columnController.isReady()) {
	            this.setColumnsCheckedState();
	            this.showOrHideOptions();
	        }
	    };
	    PrimaryColsHeaderPanel.prototype.createExpandIcons = function () {
	        this.eExpand.appendChild(this.eExpandChecked = main_1._.createIconNoSpan('columnSelectOpen', this.gridOptionsWrapper));
	        this.eExpand.appendChild(this.eExpandUnchecked = main_1._.createIconNoSpan('columnSelectClosed', this.gridOptionsWrapper));
	        this.eExpand.appendChild(this.eExpandIndeterminate = main_1._.createIconNoSpan('columnSelectIndeterminate', this.gridOptionsWrapper));
	    };
	    PrimaryColsHeaderPanel.prototype.createCheckIcons = function () {
	        this.eSelect.appendChild(this.eSelectChecked = main_1._.createIconNoSpan('checkboxChecked', this.gridOptionsWrapper));
	        this.eSelect.appendChild(this.eSelectUnchecked = main_1._.createIconNoSpan('checkboxUnchecked', this.gridOptionsWrapper));
	        this.eSelect.appendChild(this.eSelectIndeterminate = main_1._.createIconNoSpan('checkboxIndeterminate', this.gridOptionsWrapper));
	    };
	    // we only show expand / collapse if we are showing columns
	    PrimaryColsHeaderPanel.prototype.showOrHideOptions = function () {
	        var showFilter = !this.params.suppressColumnFilter;
	        var showSelect = !this.params.suppressColumnSelectAll;
	        var showExpand = !this.params.suppressColumnExpandAll;
	        var groupsPresent = this.columnController.isPrimaryColumnGroupsPresent();
	        main_1._.setDisplayed(this.eFilterWrapper, showFilter);
	        main_1._.setDisplayed(this.eSelect, showSelect);
	        main_1._.setDisplayed(this.eExpand, showExpand && groupsPresent);
	    };
	    PrimaryColsHeaderPanel.prototype.addEventListeners = function () {
	        var _this = this;
	        var eventsImpactingCheckedState = [
	            main_1.Events.EVENT_COLUMN_EVERYTHING_CHANGED,
	            main_1.Events.EVENT_COLUMN_PIVOT_CHANGED,
	            main_1.Events.EVENT_COLUMN_PIVOT_MODE_CHANGED,
	            main_1.Events.EVENT_COLUMN_ROW_GROUP_CHANGED,
	            main_1.Events.EVENT_COLUMN_VALUE_CHANGED,
	            main_1.Events.EVENT_COLUMN_VISIBLE,
	            main_1.Events.EVENT_NEW_COLUMNS_LOADED
	        ];
	        eventsImpactingCheckedState.forEach(function (event) {
	            _this.addDestroyableEventListener(_this.eventService, event, _this.setColumnsCheckedState.bind(_this));
	        });
	        this.addDestroyableEventListener(this.eventService, main_1.Events.EVENT_NEW_COLUMNS_LOADED, this.showOrHideOptions.bind(this));
	    };
	    PrimaryColsHeaderPanel.prototype.onFilterTextChanged = function () {
	        var _this = this;
	        if (!this.onFilterTextChangedDebounced) {
	            this.onFilterTextChangedDebounced = main_1._.debounce(function () {
	                var filterText = _this.eFilterTextField.value;
	                _this.dispatchEvent({ type: 'filterChanged', filterText: filterText });
	            }, 400);
	        }
	        this.onFilterTextChangedDebounced();
	    };
	    PrimaryColsHeaderPanel.prototype.onSelectClicked = function () {
	        // here we just fire the event. the following happens is the flow of events:
	        // 1. event here fired.
	        // 2. toolpanel updates the columns.
	        // 3. column controller fires events of column updated
	        // 4. update in this panel is updated based on events fired by column controller
	        if (this.selectState === SELECTED_STATE.CHECKED) {
	            this.dispatchEvent({ type: 'unselectAll' });
	        }
	        else {
	            this.dispatchEvent({ type: 'selectAll' });
	        }
	    };
	    PrimaryColsHeaderPanel.prototype.onExpandClicked = function () {
	        if (this.expandState === SELECTED_STATE.CHECKED) {
	            this.dispatchEvent({ type: 'collapseAll' });
	        }
	        else {
	            this.dispatchEvent({ type: 'expandAll' });
	        }
	    };
	    PrimaryColsHeaderPanel.prototype.setExpandState = function (state) {
	        this.expandState = state;
	        main_1._.setDisplayed(this.eExpandChecked, this.expandState === SELECTED_STATE.CHECKED);
	        main_1._.setDisplayed(this.eExpandUnchecked, this.expandState === SELECTED_STATE.UNCHECKED);
	        main_1._.setDisplayed(this.eExpandIndeterminate, this.expandState === SELECTED_STATE.INDETERMINATE);
	    };
	    PrimaryColsHeaderPanel.prototype.setColumnsCheckedState = function () {
	        var allPrimaryColumns = this.columnController.getAllPrimaryColumns();
	        var columns = [];
	        if (allPrimaryColumns !== null) {
	            columns = allPrimaryColumns.filter(function (col) { return !col.getColDef().lockVisible; });
	        }
	        var pivotMode = this.columnController.isPivotMode();
	        var checkedCount = 0;
	        var uncheckedCount = 0;
	        columns.forEach(function (col) {
	            // ignore lock visible columns
	            if (col.getColDef().lockVisible) {
	                return;
	            }
	            // not not count columns not in tool panel
	            var colDef = col.getColDef();
	            if (colDef && colDef.suppressToolPanel) {
	                return;
	            }
	            var checked;
	            if (pivotMode) {
	                var noPivotModeOptionsAllowed = !col.isAllowPivot() && !col.isAllowRowGroup() && !col.isAllowValue();
	                if (noPivotModeOptionsAllowed) {
	                    return;
	                }
	                checked = col.isValueActive() || col.isPivotActive() || col.isRowGroupActive();
	            }
	            else {
	                checked = col.isVisible();
	            }
	            if (checked) {
	                checkedCount++;
	            }
	            else {
	                uncheckedCount++;
	            }
	        });
	        if (checkedCount > 0 && uncheckedCount > 0) {
	            this.selectState = SELECTED_STATE.INDETERMINATE;
	        }
	        else if (uncheckedCount > 0) {
	            this.selectState = SELECTED_STATE.UNCHECKED;
	        }
	        else {
	            this.selectState = SELECTED_STATE.CHECKED;
	        }
	        main_1._.setDisplayed(this.eSelectChecked, this.selectState === SELECTED_STATE.CHECKED);
	        main_1._.setDisplayed(this.eSelectUnchecked, this.selectState === SELECTED_STATE.UNCHECKED);
	        main_1._.setDisplayed(this.eSelectIndeterminate, this.selectState === SELECTED_STATE.INDETERMINATE);
	    };
	    __decorate([
	        main_1.Autowired('gridOptionsWrapper'),
	        __metadata("design:type", main_1.GridOptionsWrapper)
	    ], PrimaryColsHeaderPanel.prototype, "gridOptionsWrapper", void 0);
	    __decorate([
	        main_1.Autowired('columnController'),
	        __metadata("design:type", main_1.ColumnController)
	    ], PrimaryColsHeaderPanel.prototype, "columnController", void 0);
	    __decorate([
	        main_1.Autowired('eventService'),
	        __metadata("design:type", main_1.EventService)
	    ], PrimaryColsHeaderPanel.prototype, "eventService", void 0);
	    __decorate([
	        main_1.RefSelector('eFilterTextField'),
	        __metadata("design:type", HTMLInputElement)
	    ], PrimaryColsHeaderPanel.prototype, "eFilterTextField", void 0);
	    __decorate([
	        main_1.RefSelector('eExpand'),
	        __metadata("design:type", HTMLElement)
	    ], PrimaryColsHeaderPanel.prototype, "eExpand", void 0);
	    __decorate([
	        main_1.RefSelector('eSelect'),
	        __metadata("design:type", HTMLElement)
	    ], PrimaryColsHeaderPanel.prototype, "eSelect", void 0);
	    __decorate([
	        main_1.RefSelector('eFilterWrapper'),
	        __metadata("design:type", HTMLElement)
	    ], PrimaryColsHeaderPanel.prototype, "eFilterWrapper", void 0);
	    __decorate([
	        main_1.PreConstruct,
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", []),
	        __metadata("design:returntype", void 0)
	    ], PrimaryColsHeaderPanel.prototype, "preConstruct", null);
	    __decorate([
	        main_1.PostConstruct,
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", []),
	        __metadata("design:returntype", void 0)
	    ], PrimaryColsHeaderPanel.prototype, "postConstruct", null);
	    return PrimaryColsHeaderPanel;
	}(main_1.Component));
	exports.PrimaryColsHeaderPanel = PrimaryColsHeaderPanel;


/***/ }),
/* 2519 */
/***/ (function(module, exports, __webpack_require__) {

	// ag-grid-enterprise v21.2.2
	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var ag_grid_community_1 = __webpack_require__(2322);
	var GroupStage = /** @class */ (function () {
	    function GroupStage() {
	        // we use a sequence variable so that each time we do a grouping, we don't
	        // reuse the ids - otherwise the rowRenderer will confuse rowNodes between redraws
	        // when it tries to animate between rows. we set to -1 as others row id 0 will be shared
	        // with the other rows.
	        this.groupIdSequence = new ag_grid_community_1.NumberSequence(1);
	    }
	    GroupStage.prototype.postConstruct = function () {
	        this.usingTreeData = this.gridOptionsWrapper.isTreeData();
	        if (this.usingTreeData) {
	            this.getDataPath = this.gridOptionsWrapper.getDataPathFunc();
	        }
	    };
	    GroupStage.prototype.execute = function (params) {
	        var details = this.createGroupingDetails(params);
	        if (details.transaction) {
	            this.handleTransaction(details);
	        }
	        else {
	            var afterColsChanged = params.afterColumnsChanged === true;
	            this.shotgunResetEverything(details, afterColsChanged);
	        }
	        this.sortGroupsWithComparator(details.rootNode);
	        this.selectableService.updateSelectableAfterGrouping(details.rootNode);
	    };
	    GroupStage.prototype.createGroupingDetails = function (params) {
	        var rowNode = params.rowNode, changedPath = params.changedPath, rowNodeTransaction = params.rowNodeTransaction, rowNodeOrder = params.rowNodeOrder;
	        var groupedCols = this.usingTreeData ? null : this.columnController.getRowGroupColumns();
	        var isGrouping = this.usingTreeData || (groupedCols && groupedCols.length > 0);
	        var usingTransaction = isGrouping && ag_grid_community_1._.exists(rowNodeTransaction);
	        var details = {
	            // someone complained that the parent attribute was causing some change detection
	            // to break is some angular add-on - which i never used. taking the parent out breaks
	            // a cyclic dependency, hence this flag got introduced.
	            includeParents: !this.gridOptionsWrapper.isSuppressParentsInRowNodes(),
	            expandByDefault: this.gridOptionsWrapper.isGroupSuppressRow() ?
	                -1 : this.gridOptionsWrapper.getGroupDefaultExpanded(),
	            groupedCols: groupedCols,
	            rootNode: rowNode,
	            pivotMode: this.columnController.isPivotMode(),
	            groupedColCount: this.usingTreeData || !groupedCols ? 0 : groupedCols.length,
	            rowNodeOrder: rowNodeOrder,
	            // important not to do transaction if we are not grouping, as otherwise the 'insert index' is ignored.
	            // ie, if not grouping, then we just want to shotgun so the rootNode.allLeafChildren gets copied
	            // to rootNode.childrenAfterGroup and maintaining order (as delta transaction misses the order).
	            transaction: usingTransaction ? rowNodeTransaction : null,
	            // if no transaction, then it's shotgun, changed path would be 'not active' at this point anyway
	            changedPath: changedPath
	        };
	        return details;
	    };
	    GroupStage.prototype.handleTransaction = function (details) {
	        var tran = details.transaction;
	        if (tran.add) {
	            this.insertNodes(tran.add, details);
	        }
	        if (tran.update) {
	            this.moveNodesInWrongPath(tran.update, details);
	        }
	        if (tran.remove) {
	            this.removeNodes(tran.remove, details);
	        }
	        if (details.rowNodeOrder) {
	            this.sortChildren(details);
	        }
	    };
	    // this is used when doing delta updates, eg Redux, keeps nodes in right order
	    GroupStage.prototype.sortChildren = function (details) {
	        details.changedPath.forEachChangedNodeDepthFirst(function (rowNode) {
	            ag_grid_community_1._.sortRowNodesByOrder(rowNode.childrenAfterGroup, details.rowNodeOrder);
	        });
	    };
	    GroupStage.prototype.sortGroupsWithComparator = function (rootNode) {
	        // we don't do group sorting for tree data
	        if (this.usingTreeData) {
	            return;
	        }
	        var comparator = this.gridOptionsWrapper.getDefaultGroupSortComparator();
	        if (ag_grid_community_1._.exists(comparator)) {
	            recursiveSort(rootNode);
	        }
	        function recursiveSort(rowNode) {
	            var doSort = ag_grid_community_1._.exists(rowNode.childrenAfterGroup) &&
	                // we only want to sort groups, so we do not sort leafs (a leaf group has leafs as children)
	                !rowNode.leafGroup;
	            if (doSort) {
	                rowNode.childrenAfterGroup.sort(comparator);
	                rowNode.childrenAfterGroup.forEach(function (childNode) { return recursiveSort(childNode); });
	            }
	        }
	    };
	    GroupStage.prototype.getExistingPathForNode = function (node, details) {
	        var res = [];
	        // when doing tree data, the node is part of the path,
	        // but when doing grid grouping, the node is not part of the path so we start with the parent.
	        var pointer = this.usingTreeData ? node : node.parent;
	        while (pointer && pointer !== details.rootNode) {
	            res.push({
	                key: pointer.key,
	                rowGroupColumn: pointer.rowGroupColumn,
	                field: pointer.field
	            });
	            pointer = pointer.parent;
	        }
	        res.reverse();
	        return res;
	    };
	    GroupStage.prototype.moveNodesInWrongPath = function (childNodes, details) {
	        var _this = this;
	        childNodes.forEach(function (childNode) {
	            // we add node, even if parent has not changed, as the data could have
	            // changed, hence aggregations will be wrong
	            if (details.changedPath.isActive()) {
	                details.changedPath.addParentNode(childNode.parent);
	            }
	            var infoToKeyMapper = function (item) { return item.key; };
	            var oldPath = _this.getExistingPathForNode(childNode, details).map(infoToKeyMapper);
	            var newPath = _this.getGroupInfo(childNode, details).map(infoToKeyMapper);
	            var nodeInCorrectPath = ag_grid_community_1._.compareArrays(oldPath, newPath);
	            if (!nodeInCorrectPath) {
	                _this.moveNode(childNode, details);
	            }
	        });
	    };
	    GroupStage.prototype.moveNode = function (childNode, details) {
	        this.removeNodesInStages([childNode], details);
	        this.insertOneNode(childNode, details);
	        // hack - if we didn't do this, then renaming a tree item (ie changing rowNode.key) wouldn't get
	        // refreshed into the gui.
	        // this is needed to kick off the event that rowComp listens to for refresh. this in turn
	        // then will get each cell in the row to refresh - which is what we need as we don't know which
	        // columns will be displaying the rowNode.key info.
	        childNode.setData(childNode.data);
	        // we add both old and new parents to changed path, as both will need to be refreshed.
	        // we already added the old parent (in calling method), so just add the new parent here
	        if (details.changedPath.isActive()) {
	            var newParent = childNode.parent;
	            details.changedPath.addParentNode(newParent);
	        }
	    };
	    GroupStage.prototype.removeNodes = function (leafRowNodes, details) {
	        this.removeNodesInStages(leafRowNodes, details);
	        if (details.changedPath.isActive()) {
	            leafRowNodes.forEach(function (rowNode) { return details.changedPath.addParentNode(rowNode.parent); });
	        }
	    };
	    GroupStage.prototype.removeNodesInStages = function (leafRowNodes, details) {
	        this.removeNodesFromParents(leafRowNodes, details);
	        this.postRemoveCreateFillerNodes(leafRowNodes, details);
	        this.postRemoveRemoveEmptyGroups(leafRowNodes, details);
	    };
	    GroupStage.prototype.forEachParentGroup = function (details, child, callback) {
	        var pointer = child.parent;
	        while (pointer && pointer !== details.rootNode) {
	            callback(pointer);
	            pointer = pointer.parent;
	        }
	    };
	    GroupStage.prototype.removeNodesFromParents = function (nodesToRemove, details) {
	        var _this = this;
	        var batchRemover = new BatchRemover();
	        nodesToRemove.forEach(function (nodeToRemove) {
	            _this.removeFromParent(nodeToRemove, batchRemover);
	            // remove from allLeafChildren. we clear down all parents EXCEPT the Root Node, as
	            // the ClientSideNodeManager is responsible for the Root Node.
	            _this.forEachParentGroup(details, nodeToRemove, function (parentNode) {
	                batchRemover.removeFromAllLeafChildren(parentNode, nodeToRemove);
	            });
	        });
	        batchRemover.flush();
	    };
	    GroupStage.prototype.postRemoveCreateFillerNodes = function (nodesToRemove, details) {
	        var _this = this;
	        nodesToRemove.forEach(function (nodeToRemove) {
	            // if not group, and children are present, need to move children to a group.
	            // otherwise if no children, we can just remove without replacing.
	            var replaceWithGroup = nodeToRemove.hasChildren();
	            if (replaceWithGroup) {
	                var oldPath = _this.getExistingPathForNode(nodeToRemove, details);
	                // because we just removed the userGroup, this will always return new support group
	                var newGroupNode_1 = _this.findParentForNode(nodeToRemove, oldPath, details);
	                // these properties are the ones that will be incorrect in the newly created group,
	                // so copy them from the old childNode
	                newGroupNode_1.expanded = nodeToRemove.expanded;
	                newGroupNode_1.allLeafChildren = nodeToRemove.allLeafChildren;
	                newGroupNode_1.childrenAfterGroup = nodeToRemove.childrenAfterGroup;
	                newGroupNode_1.childrenMapped = nodeToRemove.childrenMapped;
	                newGroupNode_1.childrenAfterGroup.forEach(function (rowNode) { return rowNode.parent = newGroupNode_1; });
	            }
	        });
	    };
	    GroupStage.prototype.postRemoveRemoveEmptyGroups = function (nodesToRemove, details) {
	        var _this = this;
	        // we do this multiple times, as when we remove groups, that means the parent of just removed
	        // group can then be empty. to get around this, if we remove, then we check everything again for
	        // newly emptied groups. the max number of times this will execute is the depth of the group tree.
	        var checkAgain = true;
	        var groupShouldBeRemoved = function (rowNode) {
	            // because of the while loop below, it's possible we already moved the node,
	            // so double check before trying to remove again.
	            var mapKey = _this.getChildrenMappedKey(rowNode.key, rowNode.rowGroupColumn);
	            var parentRowNode = rowNode.parent;
	            var groupAlreadyRemoved = (parentRowNode && parentRowNode.childrenMapped) ?
	                !parentRowNode.childrenMapped[mapKey] : true;
	            if (groupAlreadyRemoved) {
	                // if not linked, then group was already removed
	                return false;
	            }
	            else {
	                // if still not removed, then we remove if this group is empty
	                return rowNode.isEmptyRowGroupNode();
	            }
	        };
	        var _loop_1 = function () {
	            checkAgain = false;
	            var batchRemover = new BatchRemover();
	            nodesToRemove.forEach(function (nodeToRemove) {
	                // remove empty groups
	                _this.forEachParentGroup(details, nodeToRemove, function (rowNode) {
	                    if (groupShouldBeRemoved(rowNode)) {
	                        checkAgain = true;
	                        _this.removeFromParent(rowNode, batchRemover);
	                        // we remove selection on filler nodes here, as the selection would not be removed
	                        // from the RowNodeManager, as filler nodes don't exist on the RowNodeManager
	                        rowNode.setSelected(false);
	                    }
	                });
	            });
	            batchRemover.flush();
	        };
	        while (checkAgain) {
	            _loop_1();
	        }
	    };
	    // removes the node from the parent by:
	    // a) removing from childrenAfterGroup (using batchRemover if present, otherwise immediately)
	    // b) removing from childrenMapped (immediately)
	    // c) setRowTop(null) - as the rowRenderer uses this to know the RowNode is no longer needed
	    GroupStage.prototype.removeFromParent = function (child, batchRemover) {
	        if (child.parent) {
	            if (batchRemover) {
	                batchRemover.removeFromChildrenAfterGroup(child.parent, child);
	            }
	            else {
	                ag_grid_community_1._.removeFromArray(child.parent.childrenAfterGroup, child);
	            }
	        }
	        var mapKey = this.getChildrenMappedKey(child.key, child.rowGroupColumn);
	        if (child.parent && child.parent.childrenMapped) {
	            child.parent.childrenMapped[mapKey] = undefined;
	        }
	        // this is important for transition, see rowComp removeFirstPassFuncs. when doing animation and
	        // remove, if rowTop is still present, the rowComp thinks it's just moved position.
	        child.setRowTop(null);
	    };
	    GroupStage.prototype.addToParent = function (child, parent) {
	        var mapKey = this.getChildrenMappedKey(child.key, child.rowGroupColumn);
	        if (parent) {
	            if (parent.childrenMapped) {
	                parent.childrenMapped[mapKey] = child;
	            }
	            parent.childrenAfterGroup.push(child);
	        }
	    };
	    GroupStage.prototype.areGroupColsEqual = function (d1, d2) {
	        if (d1 == null || d2 == null) {
	            return false;
	        }
	        if (d1.pivotMode !== d2.pivotMode) {
	            return false;
	        }
	        if (!ag_grid_community_1._.compareArrays(d1.groupedCols, d2.groupedCols)) {
	            return false;
	        }
	        return true;
	    };
	    GroupStage.prototype.shotgunResetEverything = function (details, afterColumnsChanged) {
	        var skipStage = afterColumnsChanged ?
	            this.usingTreeData || this.areGroupColsEqual(details, this.oldGroupingDetails)
	            : false;
	        this.oldGroupingDetails = details;
	        if (skipStage) {
	            return;
	        }
	        // because we are not creating the root node each time, we have the logic
	        // here to change leafGroup once.
	        // we set .leafGroup to false for tree data, as .leafGroup is only used when pivoting, and pivoting
	        // isn't allowed with treeData, so the grid never actually use .leafGroup when doing treeData.
	        details.rootNode.leafGroup = this.usingTreeData ? false : details.groupedCols.length === 0;
	        // we are doing everything from scratch, so reset childrenAfterGroup and childrenMapped from the rootNode
	        details.rootNode.childrenAfterGroup = [];
	        details.rootNode.childrenMapped = {};
	        this.insertNodes(details.rootNode.allLeafChildren, details);
	    };
	    GroupStage.prototype.insertNodes = function (newRowNodes, details) {
	        var _this = this;
	        newRowNodes.forEach(function (rowNode) {
	            _this.insertOneNode(rowNode, details);
	            if (details.changedPath.isActive()) {
	                details.changedPath.addParentNode(rowNode.parent);
	            }
	        });
	    };
	    GroupStage.prototype.insertOneNode = function (childNode, details) {
	        var path = this.getGroupInfo(childNode, details);
	        var parentGroup = this.findParentForNode(childNode, path, details);
	        if (!parentGroup.group) {
	            console.warn("ag-Grid: duplicate group keys for row data, keys should be unique", [parentGroup.data, childNode.data]);
	        }
	        if (this.usingTreeData) {
	            this.swapGroupWithUserNode(parentGroup, childNode);
	        }
	        else {
	            childNode.parent = parentGroup;
	            childNode.level = path.length;
	            parentGroup.childrenAfterGroup.push(childNode);
	        }
	    };
	    GroupStage.prototype.findParentForNode = function (childNode, path, details) {
	        var _this = this;
	        var nextNode = details.rootNode;
	        path.forEach(function (groupInfo, level) {
	            nextNode = _this.getOrCreateNextNode(nextNode, groupInfo, level, details);
	            // node gets added to all group nodes.
	            // note: we do not add to rootNode here, as the rootNode is the master list of rowNodes
	            nextNode.allLeafChildren.push(childNode);
	        });
	        return nextNode;
	    };
	    GroupStage.prototype.swapGroupWithUserNode = function (fillerGroup, userGroup) {
	        userGroup.parent = fillerGroup.parent;
	        userGroup.key = fillerGroup.key;
	        userGroup.field = fillerGroup.field;
	        userGroup.groupData = fillerGroup.groupData;
	        userGroup.level = fillerGroup.level;
	        userGroup.expanded = fillerGroup.expanded;
	        // we set .leafGroup to false for tree data, as .leafGroup is only used when pivoting, and pivoting
	        // isn't allowed with treeData, so the grid never actually use .leafGroup when doing treeData.
	        userGroup.leafGroup = fillerGroup.leafGroup;
	        // always null for userGroups, as row grouping is not allowed when doing tree data
	        userGroup.rowGroupIndex = fillerGroup.rowGroupIndex;
	        userGroup.allLeafChildren = fillerGroup.allLeafChildren;
	        userGroup.childrenAfterGroup = fillerGroup.childrenAfterGroup;
	        userGroup.childrenMapped = fillerGroup.childrenMapped;
	        this.removeFromParent(fillerGroup);
	        userGroup.childrenAfterGroup.forEach(function (rowNode) { return rowNode.parent = userGroup; });
	        this.addToParent(userGroup, fillerGroup.parent);
	    };
	    GroupStage.prototype.getOrCreateNextNode = function (parentGroup, groupInfo, level, details) {
	        var mapKey = this.getChildrenMappedKey(groupInfo.key, groupInfo.rowGroupColumn);
	        var nextNode = parentGroup.childrenMapped ? parentGroup.childrenMapped[mapKey] : undefined;
	        if (!nextNode) {
	            nextNode = this.createGroup(groupInfo, parentGroup, level, details);
	            // attach the new group to the parent
	            this.addToParent(nextNode, parentGroup);
	        }
	        return nextNode;
	    };
	    GroupStage.prototype.createGroup = function (groupInfo, parent, level, details) {
	        var _this = this;
	        var groupNode = new ag_grid_community_1.RowNode();
	        this.context.wireBean(groupNode);
	        groupNode.group = true;
	        groupNode.field = groupInfo.field;
	        groupNode.rowGroupColumn = groupInfo.rowGroupColumn;
	        groupNode.groupData = {};
	        var groupDisplayCols = this.columnController.getGroupDisplayColumns();
	        groupDisplayCols.forEach(function (col) {
	            // newGroup.rowGroupColumn=null when working off GroupInfo, and we always display the group in the group column
	            // if rowGroupColumn is present, then it's grid row grouping and we only include if configuration says so
	            var displayGroupForCol = _this.usingTreeData || (groupNode.rowGroupColumn ? col.isRowGroupDisplayed(groupNode.rowGroupColumn.getId()) : false);
	            if (displayGroupForCol) {
	                groupNode.groupData[col.getColId()] = groupInfo.key;
	            }
	        });
	        // we use negative number for the ids of the groups, this makes sure we don't clash with the
	        // id's of the leaf nodes.
	        groupNode.id = (this.groupIdSequence.next() * -1).toString();
	        groupNode.key = groupInfo.key;
	        groupNode.level = level;
	        groupNode.leafGroup = this.usingTreeData ? false : level === (details.groupedColCount - 1);
	        // if doing pivoting, then the leaf group is never expanded,
	        // as we do not show leaf rows
	        if (details.pivotMode && groupNode.leafGroup) {
	            groupNode.expanded = false;
	        }
	        else {
	            groupNode.expanded = this.isExpanded(details.expandByDefault, level);
	        }
	        groupNode.allLeafChildren = [];
	        // why is this done here? we are not updating the children could as we go,
	        // i suspect this is updated in the filter stage
	        groupNode.setAllChildrenCount(0);
	        groupNode.rowGroupIndex = this.usingTreeData ? null : level;
	        groupNode.childrenAfterGroup = [];
	        groupNode.childrenMapped = {};
	        groupNode.parent = details.includeParents ? parent : null;
	        return groupNode;
	    };
	    GroupStage.prototype.getChildrenMappedKey = function (key, rowGroupColumn) {
	        if (rowGroupColumn) {
	            // grouping by columns
	            return rowGroupColumn.getId() + '-' + key;
	        }
	        else {
	            // tree data - we don't have rowGroupColumns
	            return key;
	        }
	    };
	    GroupStage.prototype.isExpanded = function (expandByDefault, level) {
	        if (expandByDefault === -1) {
	            return true;
	        }
	        else {
	            return level < expandByDefault;
	        }
	    };
	    GroupStage.prototype.getGroupInfo = function (rowNode, details) {
	        if (this.usingTreeData) {
	            return this.getGroupInfoFromCallback(rowNode);
	        }
	        else {
	            return this.getGroupInfoFromGroupColumns(rowNode, details);
	        }
	    };
	    GroupStage.prototype.getGroupInfoFromCallback = function (rowNode) {
	        var keys = this.getDataPath ? this.getDataPath(rowNode.data) : null;
	        if (keys === null || keys === undefined || keys.length === 0) {
	            ag_grid_community_1._.doOnce(function () { return console.warn("getDataPath() should not return an empty path for data", rowNode.data); }, 'groupStage.getGroupInfoFromCallback');
	        }
	        var groupInfoMapper = function (key) { return ({ key: key, field: null, rowGroupColumn: null }); };
	        return keys ? keys.map(groupInfoMapper) : [];
	    };
	    GroupStage.prototype.getGroupInfoFromGroupColumns = function (rowNode, details) {
	        var _this = this;
	        var res = [];
	        details.groupedCols.forEach(function (groupCol) {
	            var key = _this.valueService.getKeyForNode(groupCol, rowNode);
	            var keyExists = key !== null && key !== undefined;
	            // unbalanced tree and pivot mode don't work together - not because of the grid, it doesn't make
	            // mathematical sense as you are building up a cube. so if pivot mode, we put in a blank key where missing.
	            // this keeps the tree balanced and hence can be represented as a group.
	            if (details.pivotMode && !keyExists) {
	                key = ' ';
	                keyExists = true;
	            }
	            if (keyExists) {
	                var item = {
	                    key: key,
	                    field: groupCol.getColDef().field,
	                    rowGroupColumn: groupCol
	                };
	                res.push(item);
	            }
	        });
	        return res;
	    };
	    __decorate([
	        ag_grid_community_1.Autowired('selectionController'),
	        __metadata("design:type", ag_grid_community_1.SelectionController)
	    ], GroupStage.prototype, "selectionController", void 0);
	    __decorate([
	        ag_grid_community_1.Autowired('gridOptionsWrapper'),
	        __metadata("design:type", ag_grid_community_1.GridOptionsWrapper)
	    ], GroupStage.prototype, "gridOptionsWrapper", void 0);
	    __decorate([
	        ag_grid_community_1.Autowired('columnController'),
	        __metadata("design:type", ag_grid_community_1.ColumnController)
	    ], GroupStage.prototype, "columnController", void 0);
	    __decorate([
	        ag_grid_community_1.Autowired('selectableService'),
	        __metadata("design:type", ag_grid_community_1.SelectableService)
	    ], GroupStage.prototype, "selectableService", void 0);
	    __decorate([
	        ag_grid_community_1.Autowired('valueService'),
	        __metadata("design:type", ag_grid_community_1.ValueService)
	    ], GroupStage.prototype, "valueService", void 0);
	    __decorate([
	        ag_grid_community_1.Autowired('eventService'),
	        __metadata("design:type", ag_grid_community_1.EventService)
	    ], GroupStage.prototype, "eventService", void 0);
	    __decorate([
	        ag_grid_community_1.Autowired('context'),
	        __metadata("design:type", ag_grid_community_1.Context)
	    ], GroupStage.prototype, "context", void 0);
	    __decorate([
	        ag_grid_community_1.PostConstruct,
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", []),
	        __metadata("design:returntype", void 0)
	    ], GroupStage.prototype, "postConstruct", null);
	    GroupStage = __decorate([
	        ag_grid_community_1.Bean('groupStage')
	    ], GroupStage);
	    return GroupStage;
	}());
	exports.GroupStage = GroupStage;
	// doing _.removeFromArray() multiple times on a large list can be a bottleneck.
	// when doing large deletes (eg removing 1,000 rows) then we would be calling _.removeFromArray()
	// a thousands of times, in particular RootNode.allGroupChildren could be a large list, and
	// 1,000 removes is time consuming as each one requires traversing the full list.
	// to get around this, we do all the removes in a batch. this class manages the batch.
	//
	// This problem was brought to light by a client (AG-2879), with dataset of 20,000
	// in 10,000 groups (2 items per group), then deleting all rows with transaction,
	// it took about 20 seconds to delete. with the BathRemoved, the reduced to less than 1 second.
	var BatchRemover = /** @class */ (function () {
	    function BatchRemover() {
	        this.allSets = {};
	        this.allParents = [];
	    }
	    BatchRemover.prototype.removeFromChildrenAfterGroup = function (parent, child) {
	        var set = this.getSet(parent);
	        set.removeFromChildrenAfterGroup[child.id] = true;
	    };
	    BatchRemover.prototype.removeFromAllLeafChildren = function (parent, child) {
	        var set = this.getSet(parent);
	        set.removeFromAllLeafChildren[child.id] = true;
	    };
	    BatchRemover.prototype.getSet = function (parent) {
	        if (!this.allSets[parent.id]) {
	            this.allSets[parent.id] = {
	                removeFromAllLeafChildren: {},
	                removeFromChildrenAfterGroup: {}
	            };
	            this.allParents.push(parent);
	        }
	        return this.allSets[parent.id];
	    };
	    BatchRemover.prototype.flush = function () {
	        var _this = this;
	        this.allParents.forEach(function (parent) {
	            var nodeDetails = _this.allSets[parent.id];
	            parent.childrenAfterGroup = parent.childrenAfterGroup.filter(function (child) {
	                var res = !nodeDetails.removeFromChildrenAfterGroup[child.id];
	                return res;
	            });
	            parent.allLeafChildren = parent.allLeafChildren.filter(function (child) { return !nodeDetails.removeFromAllLeafChildren[child.id]; });
	        });
	        this.allSets = {};
	        this.allParents.length = 0;
	    };
	    return BatchRemover;
	}());


/***/ }),
/* 2520 */
/***/ (function(module, exports, __webpack_require__) {

	// ag-grid-enterprise v21.2.2
	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var ag_grid_community_1 = __webpack_require__(2322);
	var pivotStage_1 = __webpack_require__(2521);
	var aggFuncService_1 = __webpack_require__(2513);
	var AggregationStage = /** @class */ (function () {
	    function AggregationStage() {
	    }
	    // it's possible to recompute the aggregate without doing the other parts
	    // + gridApi.recomputeAggregates()
	    AggregationStage.prototype.execute = function (params) {
	        // we don't do aggregation if doing legacy tree good
	        var doingLegacyTreeData = ag_grid_community_1._.exists(this.gridOptionsWrapper.getNodeChildDetailsFunc());
	        if (doingLegacyTreeData) {
	            return null;
	        }
	        // if changed path is active, it means we came from a) change detection or b) transaction update.
	        // for both of these, if no value columns are present, it means there is nothing to aggregate now
	        // and there is no cleanup to be done (as value columns don't change between transactions or change
	        // detections). if no value columns and no changed path, means we have to go through all nodes in
	        // case we need to clean up agg data from before.
	        var noValueColumns = ag_grid_community_1._.missingOrEmpty(this.columnController.getValueColumns());
	        var noUserAgg = !this.gridOptionsWrapper.getGroupRowAggNodesFunc();
	        var changedPathActive = params.changedPath && params.changedPath.isActive();
	        if (noValueColumns && noUserAgg && changedPathActive) {
	            return;
	        }
	        var aggDetails = this.createAggDetails(params);
	        this.recursivelyCreateAggData(aggDetails);
	    };
	    AggregationStage.prototype.createAggDetails = function (params) {
	        var pivotActive = this.columnController.isPivotActive();
	        var measureColumns = this.columnController.getValueColumns();
	        var pivotColumns = pivotActive ? this.columnController.getPivotColumns() : [];
	        var aggDetails = {
	            changedPath: params.changedPath,
	            valueColumns: measureColumns,
	            pivotColumns: pivotColumns
	        };
	        return aggDetails;
	    };
	    AggregationStage.prototype.recursivelyCreateAggData = function (aggDetails) {
	        var _this = this;
	        var callback = function (rowNode) {
	            var hasNoChildren = !rowNode.hasChildren();
	            if (hasNoChildren) {
	                // this check is needed for TreeData, in case the node is no longer a child,
	                // but it was a child previously.
	                if (rowNode.aggData) {
	                    rowNode.setAggData(null);
	                }
	                // never agg data for leaf nodes
	                return;
	            }
	            //Optionally prevent the aggregation at the root Node
	            //https://ag-grid.atlassian.net/browse/AG-388
	            var isRootNode = rowNode.level === -1;
	            if (isRootNode) {
	                var notPivoting = !_this.columnController.isPivotMode();
	                var suppressAggAtRootLevel = _this.gridOptionsWrapper.isSuppressAggAtRootLevel();
	                if (suppressAggAtRootLevel && notPivoting) {
	                    return;
	                }
	            }
	            _this.aggregateRowNode(rowNode, aggDetails);
	        };
	        aggDetails.changedPath.forEachChangedNodeDepthFirst(callback, true);
	    };
	    AggregationStage.prototype.aggregateRowNode = function (rowNode, aggDetails) {
	        var measureColumnsMissing = aggDetails.valueColumns.length === 0;
	        var pivotColumnsMissing = aggDetails.pivotColumns.length === 0;
	        var userFunc = this.gridOptionsWrapper.getGroupRowAggNodesFunc();
	        var aggResult;
	        if (userFunc) {
	            aggResult = userFunc(rowNode.childrenAfterFilter);
	        }
	        else if (measureColumnsMissing) {
	            aggResult = null;
	        }
	        else if (pivotColumnsMissing) {
	            aggResult = this.aggregateRowNodeUsingValuesOnly(rowNode, aggDetails);
	        }
	        else {
	            aggResult = this.aggregateRowNodeUsingValuesAndPivot(rowNode);
	        }
	        rowNode.setAggData(aggResult);
	        // if we are grouping, then it's possible there is a sibling footer
	        // to the group, so update the data here also if there is one
	        if (rowNode.sibling) {
	            rowNode.sibling.setAggData(aggResult);
	        }
	    };
	    AggregationStage.prototype.aggregateRowNodeUsingValuesAndPivot = function (rowNode) {
	        var _this = this;
	        var result = {};
	        var pivotColumnDefs = this.pivotStage.getPivotColumnDefs();
	        // Step 1: process value columns
	        pivotColumnDefs
	            .filter(function (v) { return !ag_grid_community_1._.exists(v.pivotTotalColumnIds); }) // only process pivot value columns
	            .forEach(function (valueColDef) {
	            var keys = valueColDef.pivotKeys || [];
	            var values;
	            var valueColumn = valueColDef.pivotValueColumn;
	            var colId = valueColDef.colId;
	            if (rowNode.leafGroup) {
	                // lowest level group, get the values from the mapped set
	                values = _this.getValuesFromMappedSet(rowNode.childrenMapped, keys, valueColumn);
	            }
	            else {
	                // value columns and pivot columns, non-leaf group
	                values = _this.getValuesPivotNonLeaf(rowNode, colId);
	            }
	            result[colId] = _this.aggregateValues(values, valueColumn.getAggFunc());
	        });
	        // Step 2: process total columns
	        pivotColumnDefs
	            .filter(function (v) { return ag_grid_community_1._.exists(v.pivotTotalColumnIds); }) // only process pivot total columns
	            .forEach(function (totalColDef) {
	            var aggResults = [];
	            var pivotValueColumn = totalColDef.pivotValueColumn, pivotTotalColumnIds = totalColDef.pivotTotalColumnIds, colId = totalColDef.colId;
	            //retrieve results for colIds associated with this pivot total column
	            if (!pivotTotalColumnIds || !pivotTotalColumnIds.length) {
	                return;
	            }
	            pivotTotalColumnIds.forEach(function (colId) {
	                aggResults.push(result[colId]);
	            });
	            result[colId] = _this.aggregateValues(aggResults, pivotValueColumn.getAggFunc());
	        });
	        return result;
	    };
	    AggregationStage.prototype.aggregateRowNodeUsingValuesOnly = function (rowNode, aggDetails) {
	        var _this = this;
	        var result = {};
	        var changedValueColumns = aggDetails.changedPath.isActive() ?
	            aggDetails.changedPath.getValueColumnsForNode(rowNode, aggDetails.valueColumns)
	            : aggDetails.valueColumns;
	        var notChangedValueColumns = aggDetails.changedPath.isActive() ?
	            aggDetails.changedPath.getNotValueColumnsForNode(rowNode, aggDetails.valueColumns)
	            : null;
	        var values2d = this.getValuesNormal(rowNode, changedValueColumns);
	        var oldValues = rowNode.aggData;
	        changedValueColumns.forEach(function (valueColumn, index) {
	            result[valueColumn.getId()] = _this.aggregateValues(values2d[index], valueColumn.getAggFunc());
	        });
	        if (notChangedValueColumns && oldValues) {
	            notChangedValueColumns.forEach(function (valueColumn) {
	                result[valueColumn.getId()] = oldValues[valueColumn.getId()];
	            });
	        }
	        return result;
	    };
	    AggregationStage.prototype.getValuesPivotNonLeaf = function (rowNode, colId) {
	        var values = [];
	        rowNode.childrenAfterFilter.forEach(function (node) {
	            var value = node.aggData[colId];
	            values.push(value);
	        });
	        return values;
	    };
	    AggregationStage.prototype.getValuesFromMappedSet = function (mappedSet, keys, valueColumn) {
	        var _this = this;
	        var mapPointer = mappedSet;
	        keys.forEach(function (key) { return (mapPointer = mapPointer ? mapPointer[key] : null); });
	        if (!mapPointer) {
	            return [];
	        }
	        var values = [];
	        mapPointer.forEach(function (rowNode) {
	            var value = _this.valueService.getValue(valueColumn, rowNode);
	            values.push(value);
	        });
	        return values;
	    };
	    AggregationStage.prototype.getValuesNormal = function (rowNode, valueColumns) {
	        // create 2d array, of all values for all valueColumns
	        var values = [];
	        valueColumns.forEach(function () { return values.push([]); });
	        var valueColumnCount = valueColumns.length;
	        var rowCount = rowNode.childrenAfterFilter.length;
	        for (var i = 0; i < rowCount; i++) {
	            var childNode = rowNode.childrenAfterFilter[i];
	            for (var j = 0; j < valueColumnCount; j++) {
	                var valueColumn = valueColumns[j];
	                // if the row is a group, then it will only have an agg result value,
	                // which means valueGetter is never used.
	                var value = this.valueService.getValue(valueColumn, childNode);
	                values[j].push(value);
	            }
	        }
	        return values;
	    };
	    AggregationStage.prototype.aggregateValues = function (values, aggFuncOrString) {
	        var aggFunction;
	        if (typeof aggFuncOrString === 'string') {
	            aggFunction = this.aggFuncService.getAggFunc(aggFuncOrString);
	        }
	        else {
	            aggFunction = aggFuncOrString;
	        }
	        if (typeof aggFunction !== 'function') {
	            console.error("ag-Grid: unrecognised aggregation function " + aggFuncOrString);
	            return null;
	        }
	        return aggFunction(values);
	    };
	    __decorate([
	        ag_grid_community_1.Autowired('gridOptionsWrapper'),
	        __metadata("design:type", ag_grid_community_1.GridOptionsWrapper)
	    ], AggregationStage.prototype, "gridOptionsWrapper", void 0);
	    __decorate([
	        ag_grid_community_1.Autowired('columnController'),
	        __metadata("design:type", ag_grid_community_1.ColumnController)
	    ], AggregationStage.prototype, "columnController", void 0);
	    __decorate([
	        ag_grid_community_1.Autowired('valueService'),
	        __metadata("design:type", ag_grid_community_1.ValueService)
	    ], AggregationStage.prototype, "valueService", void 0);
	    __decorate([
	        ag_grid_community_1.Autowired('pivotStage'),
	        __metadata("design:type", pivotStage_1.PivotStage)
	    ], AggregationStage.prototype, "pivotStage", void 0);
	    __decorate([
	        ag_grid_community_1.Autowired('aggFuncService'),
	        __metadata("design:type", aggFuncService_1.AggFuncService)
	    ], AggregationStage.prototype, "aggFuncService", void 0);
	    AggregationStage = __decorate([
	        ag_grid_community_1.Bean('aggregationStage')
	    ], AggregationStage);
	    return AggregationStage;
	}());
	exports.AggregationStage = AggregationStage;


/***/ }),
/* 2521 */
/***/ (function(module, exports, __webpack_require__) {

	// ag-grid-enterprise v21.2.2
	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var ag_grid_community_1 = __webpack_require__(2322);
	var pivotColDefService_1 = __webpack_require__(2522);
	var PivotStage = /** @class */ (function () {
	    function PivotStage() {
	        this.uniqueValues = {};
	    }
	    PivotStage.prototype.execute = function (params) {
	        var rootNode = params.rowNode;
	        var changedPath = params.changedPath;
	        if (this.columnController.isPivotActive()) {
	            this.executePivotOn(rootNode, changedPath);
	        }
	        else {
	            this.executePivotOff(changedPath);
	        }
	    };
	    PivotStage.prototype.executePivotOff = function (changedPath) {
	        this.aggregationColumnsHashLastTime = null;
	        this.uniqueValues = {};
	        if (this.columnController.isSecondaryColumnsPresent()) {
	            this.columnController.setSecondaryColumns(null, "rowModelUpdated");
	            if (changedPath) {
	                changedPath.setInactive();
	            }
	        }
	    };
	    PivotStage.prototype.executePivotOn = function (rootNode, changedPath) {
	        var uniqueValues = this.bucketUpRowNodes(rootNode);
	        var uniqueValuesChanged = this.setUniqueValues(uniqueValues);
	        var aggregationColumns = this.columnController.getValueColumns();
	        var aggregationColumnsHash = aggregationColumns.map(function (column) { return column.getId(); }).join('#');
	        var aggregationFuncsHash = aggregationColumns.map(function (column) { return column.getAggFunc().toString(); }).join('#');
	        var aggregationColumnsChanged = this.aggregationColumnsHashLastTime !== aggregationColumnsHash;
	        var aggregationFuncsChanged = this.aggregationFuncsHashLastTime !== aggregationFuncsHash;
	        this.aggregationColumnsHashLastTime = aggregationColumnsHash;
	        this.aggregationFuncsHashLastTime = aggregationFuncsHash;
	        if (uniqueValuesChanged || aggregationColumnsChanged || aggregationFuncsChanged) {
	            var result = this.pivotColDefService.createPivotColumnDefs(this.uniqueValues);
	            this.pivotColumnGroupDefs = result.pivotColumnGroupDefs;
	            this.pivotColumnDefs = result.pivotColumnDefs;
	            this.columnController.setSecondaryColumns(this.pivotColumnGroupDefs, "rowModelUpdated");
	            // because the secondary columns have changed, then the aggregation needs to visit the whole
	            // tree again, so we make the changedPath not active, to force aggregation to visit all paths.
	            if (changedPath) {
	                changedPath.setInactive();
	            }
	        }
	    };
	    PivotStage.prototype.setUniqueValues = function (newValues) {
	        var json1 = JSON.stringify(newValues);
	        var json2 = JSON.stringify(this.uniqueValues);
	        var uniqueValuesChanged = json1 !== json2;
	        // we only continue the below if the unique values are different, as otherwise
	        // the result will be the same as the last time we did it
	        if (uniqueValuesChanged) {
	            this.uniqueValues = newValues;
	            return true;
	        }
	        else {
	            return false;
	        }
	    };
	    // returns true if values were different
	    PivotStage.prototype.bucketUpRowNodes = function (rootNode) {
	        var _this = this;
	        // accessed from inside inner function
	        var uniqueValues = {};
	        // finds all leaf groups and calls mapRowNode with it
	        var recursivelySearchForLeafNodes = function (rowNode) {
	            if (rowNode.leafGroup) {
	                _this.bucketRowNode(rowNode, uniqueValues);
	            }
	            else {
	                rowNode.childrenAfterFilter.forEach(function (child) {
	                    recursivelySearchForLeafNodes(child);
	                });
	            }
	        };
	        recursivelySearchForLeafNodes(rootNode);
	        return uniqueValues;
	    };
	    PivotStage.prototype.bucketRowNode = function (rowNode, uniqueValues) {
	        var pivotColumns = this.columnController.getPivotColumns();
	        if (pivotColumns.length === 0) {
	            rowNode.childrenMapped = null;
	            return;
	        }
	        rowNode.childrenMapped = this.bucketChildren(rowNode.childrenAfterFilter, pivotColumns, 0, uniqueValues);
	    };
	    PivotStage.prototype.bucketChildren = function (children, pivotColumns, pivotIndex, uniqueValues) {
	        var _this = this;
	        var mappedChildren = {};
	        var pivotColumn = pivotColumns[pivotIndex];
	        // map the children out based on the pivot column
	        children.forEach(function (child) {
	            var key = _this.valueService.getKeyForNode(pivotColumn, child);
	            if (ag_grid_community_1._.missing(key)) {
	                key = '';
	            }
	            if (!uniqueValues[key]) {
	                uniqueValues[key] = {};
	            }
	            if (!mappedChildren[key]) {
	                mappedChildren[key] = [];
	            }
	            mappedChildren[key].push(child);
	        });
	        // if it's the last pivot column, return as is, otherwise go one level further in the map
	        if (pivotIndex === pivotColumns.length - 1) {
	            return mappedChildren;
	        }
	        else {
	            var result_1 = {};
	            ag_grid_community_1._.iterateObject(mappedChildren, function (key, value) {
	                result_1[key] = _this.bucketChildren(value, pivotColumns, pivotIndex + 1, uniqueValues[key]);
	            });
	            return result_1;
	        }
	    };
	    PivotStage.prototype.getPivotColumnDefs = function () {
	        return this.pivotColumnDefs;
	    };
	    __decorate([
	        ag_grid_community_1.Autowired('rowModel'),
	        __metadata("design:type", Object)
	    ], PivotStage.prototype, "rowModel", void 0);
	    __decorate([
	        ag_grid_community_1.Autowired('valueService'),
	        __metadata("design:type", ag_grid_community_1.ValueService)
	    ], PivotStage.prototype, "valueService", void 0);
	    __decorate([
	        ag_grid_community_1.Autowired('columnController'),
	        __metadata("design:type", ag_grid_community_1.ColumnController)
	    ], PivotStage.prototype, "columnController", void 0);
	    __decorate([
	        ag_grid_community_1.Autowired('eventService'),
	        __metadata("design:type", ag_grid_community_1.EventService)
	    ], PivotStage.prototype, "eventService", void 0);
	    __decorate([
	        ag_grid_community_1.Autowired('pivotColDefService'),
	        __metadata("design:type", pivotColDefService_1.PivotColDefService)
	    ], PivotStage.prototype, "pivotColDefService", void 0);
	    PivotStage = __decorate([
	        ag_grid_community_1.Bean('pivotStage')
	    ], PivotStage);
	    return PivotStage;
	}());
	exports.PivotStage = PivotStage;


/***/ }),
/* 2522 */
/***/ (function(module, exports, __webpack_require__) {

	// ag-grid-enterprise v21.2.2
	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var ag_grid_community_1 = __webpack_require__(2322);
	var PivotColDefService = /** @class */ (function () {
	    function PivotColDefService() {
	    }
	    PivotColDefService.prototype.createPivotColumnDefs = function (uniqueValues) {
	        // this is passed to the columnController, to configure the columns and groups we show
	        var pivotColumnGroupDefs = [];
	        // this is used by the aggregation stage, to do the aggregation based on the pivot columns
	        var pivotColumnDefs = [];
	        var pivotColumns = this.columnController.getPivotColumns();
	        var valueColumns = this.columnController.getValueColumns();
	        var levelsDeep = pivotColumns.length;
	        var columnIdSequence = new ag_grid_community_1.NumberSequence();
	        this.recursivelyAddGroup(pivotColumnGroupDefs, pivotColumnDefs, 1, uniqueValues, [], columnIdSequence, levelsDeep, pivotColumns);
	        this.addRowGroupTotals(pivotColumnGroupDefs, pivotColumnDefs, valueColumns, pivotColumns, columnIdSequence);
	        this.addPivotTotalsToGroups(pivotColumnGroupDefs, pivotColumnDefs, columnIdSequence);
	        // we clone, so the colDefs in pivotColumnsGroupDefs and pivotColumnDefs are not shared. this is so that
	        // any changes the user makes (via processSecondaryColumnDefinitions) don't impact the internal aggregations,
	        // as these use the col defs also
	        var pivotColumnDefsClone = pivotColumnDefs.map(function (colDef) { return ag_grid_community_1._.cloneObject(colDef); });
	        return {
	            pivotColumnGroupDefs: pivotColumnGroupDefs,
	            pivotColumnDefs: pivotColumnDefsClone
	        };
	    };
	    // parentChildren - the list of colDefs we are adding to
	    // @index - how far the column is from the top (also same as pivotKeys.length)
	    // @uniqueValues - the values for which we should create a col for
	    // @pivotKeys - the keys for the pivot, eg if pivoting on {Language,Country} then could be {English,Ireland}
	    PivotColDefService.prototype.recursivelyAddGroup = function (parentChildren, pivotColumnDefs, index, uniqueValues, pivotKeys, columnIdSequence, levelsDeep, primaryPivotColumns) {
	        var _this = this;
	        ag_grid_community_1._.iterateObject(uniqueValues, function (key, value) {
	            var newPivotKeys = pivotKeys.slice(0);
	            newPivotKeys.push(key);
	            var createGroup = index !== levelsDeep;
	            if (createGroup) {
	                var groupDef = {
	                    children: [],
	                    headerName: key,
	                    pivotKeys: newPivotKeys,
	                    columnGroupShow: 'open',
	                    groupId: 'pivot' + columnIdSequence.next()
	                };
	                parentChildren.push(groupDef);
	                _this.recursivelyAddGroup(groupDef.children, pivotColumnDefs, index + 1, value, newPivotKeys, columnIdSequence, levelsDeep, primaryPivotColumns);
	            }
	            else {
	                var measureColumns = _this.columnController.getValueColumns();
	                var valueGroup_1 = {
	                    children: [],
	                    headerName: key,
	                    pivotKeys: newPivotKeys,
	                    columnGroupShow: 'open',
	                    groupId: 'pivot' + columnIdSequence.next()
	                };
	                // if no value columns selected, then we insert one blank column, so the user at least sees columns
	                // rendered. otherwise the grid would render with no columns (just empty groups) which would give the
	                // impression that the grid is broken
	                if (measureColumns.length === 0) {
	                    // this is the blank column, for when no value columns enabled.
	                    var colDef_1 = _this.createColDef(null, '-', newPivotKeys, columnIdSequence);
	                    valueGroup_1.children.push(colDef_1);
	                    pivotColumnDefs.push(colDef_1);
	                }
	                else {
	                    measureColumns.forEach(function (measureColumn) {
	                        var columnName = _this.columnController.getDisplayNameForColumn(measureColumn, 'header');
	                        var colDef = _this.createColDef(measureColumn, columnName, newPivotKeys, columnIdSequence);
	                        colDef.columnGroupShow = 'open';
	                        valueGroup_1.children.push(colDef);
	                        pivotColumnDefs.push(colDef);
	                    });
	                }
	                parentChildren.push(valueGroup_1);
	            }
	        });
	        // sort by either user provided comparator, or our own one
	        var colDef = primaryPivotColumns[index - 1].getColDef();
	        var userComparator = colDef.pivotComparator;
	        var comparator = this.headerNameComparator.bind(this, userComparator);
	        parentChildren.sort(comparator);
	    };
	    PivotColDefService.prototype.addPivotTotalsToGroups = function (pivotColumnGroupDefs, pivotColumnDefs, columnIdSequence) {
	        var _this = this;
	        if (!this.gridOptionsWrapper.getPivotColumnGroupTotals()) {
	            return;
	        }
	        var insertAfter = this.gridOptionsWrapper.getPivotColumnGroupTotals() === 'after';
	        var valueCols = this.columnController.getValueColumns();
	        var aggFuncs = valueCols.map(function (valueCol) { return valueCol.getAggFunc(); });
	        // don't add pivot totals if there is less than 1 aggFunc or they are not all the same
	        if (!aggFuncs || aggFuncs.length < 1 || !this.sameAggFuncs(aggFuncs)) {
	            // console.warn('ag-Grid: aborting adding pivot total columns - value columns require same aggFunc');
	            return;
	        }
	        // arbitrarily select a value column to use as a template for pivot columns
	        var valueColumn = valueCols[0];
	        pivotColumnGroupDefs.forEach(function (groupDef) {
	            _this.recursivelyAddPivotTotal(groupDef, pivotColumnDefs, columnIdSequence, valueColumn, insertAfter);
	        });
	    };
	    PivotColDefService.prototype.recursivelyAddPivotTotal = function (groupDef, pivotColumnDefs, columnIdSequence, valueColumn, insertAfter) {
	        var _this = this;
	        var group = groupDef;
	        if (!group.children) {
	            var def = groupDef;
	            return def.colId ? [def.colId] : null;
	        }
	        var colIds = [];
	        // need to recurse children first to obtain colIds used in the aggregation stage
	        group.children
	            .forEach(function (grp) {
	            var childColIds = _this.recursivelyAddPivotTotal(grp, pivotColumnDefs, columnIdSequence, valueColumn, insertAfter);
	            if (childColIds) {
	                colIds = colIds.concat(childColIds);
	            }
	        });
	        // only add total colDef if there is more than 1 child node
	        if (group.children.length > 1) {
	            //create total colDef using an arbitrary value column as a template
	            var totalColDef = this.createColDef(valueColumn, 'Total', groupDef.pivotKeys, columnIdSequence);
	            totalColDef.pivotTotalColumnIds = colIds;
	            totalColDef.aggFunc = valueColumn.getAggFunc();
	            // add total colDef to group and pivot colDefs array
	            var children = groupDef.children;
	            insertAfter ? children.push(totalColDef) : children.unshift(totalColDef);
	            pivotColumnDefs.push(totalColDef);
	        }
	        return colIds;
	    };
	    PivotColDefService.prototype.addRowGroupTotals = function (pivotColumnGroupDefs, pivotColumnDefs, valueColumns, pivotColumns, columnIdSequence) {
	        var _this = this;
	        if (!this.gridOptionsWrapper.getPivotRowTotals()) {
	            return;
	        }
	        var insertAfter = this.gridOptionsWrapper.getPivotRowTotals() === 'after';
	        // order of row group totals depends on position
	        var valueCols = insertAfter ? valueColumns.slice() : valueColumns.slice().reverse();
	        var _loop_1 = function (i) {
	            var valueCol = valueCols[i];
	            var colIds = [];
	            pivotColumnGroupDefs.forEach(function (groupDef) {
	                colIds = colIds.concat(_this.extractColIdsForValueColumn(groupDef, valueCol));
	            });
	            var levelsDeep = pivotColumns.length;
	            this_1.createRowGroupTotal(pivotColumnGroupDefs, pivotColumnDefs, 1, [], columnIdSequence, levelsDeep, pivotColumns, valueCol, colIds, insertAfter);
	        };
	        var this_1 = this;
	        for (var i = 0; i < valueCols.length; i++) {
	            _loop_1(i);
	        }
	    };
	    PivotColDefService.prototype.extractColIdsForValueColumn = function (groupDef, valueColumn) {
	        var _this = this;
	        var group = groupDef;
	        if (!group.children) {
	            var colDef = group;
	            return colDef.pivotValueColumn === valueColumn && colDef.colId ? [colDef.colId] : [];
	        }
	        var colIds = [];
	        group.children
	            .forEach(function (grp) {
	            _this.extractColIdsForValueColumn(grp, valueColumn);
	            var childColIds = _this.extractColIdsForValueColumn(grp, valueColumn);
	            colIds = colIds.concat(childColIds);
	        });
	        return colIds;
	    };
	    PivotColDefService.prototype.createRowGroupTotal = function (parentChildren, pivotColumnDefs, index, pivotKeys, columnIdSequence, levelsDeep, primaryPivotColumns, valueColumn, colIds, insertAfter) {
	        var newPivotKeys = pivotKeys.slice(0);
	        var createGroup = index !== levelsDeep;
	        if (createGroup) {
	            var groupDef = {
	                children: [],
	                pivotKeys: newPivotKeys,
	                groupId: 'pivot' + columnIdSequence.next()
	            };
	            insertAfter ? parentChildren.push(groupDef) : parentChildren.unshift(groupDef);
	            this.createRowGroupTotal(groupDef.children, pivotColumnDefs, index + 1, newPivotKeys, columnIdSequence, levelsDeep, primaryPivotColumns, valueColumn, colIds, insertAfter);
	        }
	        else {
	            var measureColumns = this.columnController.getValueColumns();
	            var valueGroup = {
	                children: [],
	                pivotKeys: newPivotKeys,
	                groupId: 'pivot' + columnIdSequence.next()
	            };
	            if (measureColumns.length === 0) {
	                var colDef = this.createColDef(null, '-', newPivotKeys, columnIdSequence);
	                valueGroup.children.push(colDef);
	                pivotColumnDefs.push(colDef);
	            }
	            else {
	                var columnName = this.columnController.getDisplayNameForColumn(valueColumn, 'header');
	                var colDef = this.createColDef(valueColumn, columnName, newPivotKeys, columnIdSequence);
	                colDef.pivotTotalColumnIds = colIds;
	                valueGroup.children.push(colDef);
	                pivotColumnDefs.push(colDef);
	            }
	            insertAfter ? parentChildren.push(valueGroup) : parentChildren.unshift(valueGroup);
	        }
	    };
	    PivotColDefService.prototype.createColDef = function (valueColumn, headerName, pivotKeys, columnIdSequence) {
	        var colDef = {};
	        if (valueColumn) {
	            var colDefToCopy = valueColumn.getColDef();
	            ag_grid_community_1._.assign(colDef, colDefToCopy);
	            // even if original column was hidden, we always show the pivot value column, otherwise it would be
	            // very confusing for people thinking the pivot is broken
	            colDef.hide = false;
	        }
	        colDef.headerName = headerName;
	        colDef.colId = 'pivot_' + columnIdSequence.next();
	        // pivot columns repeat over field, so it makes sense to use the unique id instead. For example if you want to
	        // assign values to pinned bottom rows using setPinnedBottomRowData the value service will use this colId.
	        colDef.field = colDef.colId;
	        colDef.pivotKeys = pivotKeys;
	        colDef.pivotValueColumn = valueColumn;
	        colDef.filter = false;
	        return colDef;
	    };
	    PivotColDefService.prototype.sameAggFuncs = function (aggFuncs) {
	        if (aggFuncs.length == 1) {
	            return true;
	        }
	        //check if all aggFunc's match
	        for (var i = 1; i < aggFuncs.length; i++) {
	            if (aggFuncs[i] !== aggFuncs[0]) {
	                return false;
	            }
	        }
	        return true;
	    };
	    PivotColDefService.prototype.headerNameComparator = function (userComparator, a, b) {
	        if (userComparator) {
	            return userComparator(a.headerName, b.headerName);
	        }
	        else {
	            if (a.headerName && !b.headerName) {
	                return 1;
	            }
	            else if (!a.headerName && b.headerName) {
	                return -1;
	            }
	            // slightly naff here - just to satify typescript
	            // really should be &&, but if so ts complains
	            // the above if/else checks would deal with either being falsy, so at this stage if either are falsy, both are
	            // ..still naff though
	            if (!a.headerName || !b.headerName) {
	                return 0;
	            }
	            if (a.headerName < b.headerName) {
	                return -1;
	            }
	            else if (a.headerName > b.headerName) {
	                return 1;
	            }
	            else {
	                return 0;
	            }
	        }
	    };
	    __decorate([
	        ag_grid_community_1.Autowired('columnController'),
	        __metadata("design:type", ag_grid_community_1.ColumnController)
	    ], PivotColDefService.prototype, "columnController", void 0);
	    __decorate([
	        ag_grid_community_1.Autowired('gridOptionsWrapper'),
	        __metadata("design:type", ag_grid_community_1.GridOptionsWrapper)
	    ], PivotColDefService.prototype, "gridOptionsWrapper", void 0);
	    PivotColDefService = __decorate([
	        ag_grid_community_1.Bean('pivotColDefService')
	    ], PivotColDefService);
	    return PivotColDefService;
	}());
	exports.PivotColDefService = PivotColDefService;


/***/ }),
/* 2523 */
/***/ (function(module, exports, __webpack_require__) {

	// ag-grid-enterprise v21.2.2
	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var ag_grid_community_1 = __webpack_require__(2322);
	var setFilter_1 = __webpack_require__(2524);
	var richSelectCellEditor_1 = __webpack_require__(2528);
	var licenseManager_1 = __webpack_require__(2530);
	var detailCellRenderer_1 = __webpack_require__(2532);
	var totalRowsComp_1 = __webpack_require__(2533);
	var totalAndFilteredRowsComp_1 = __webpack_require__(2535);
	var columnToolPanel_1 = __webpack_require__(2536);
	var aggregationComp_1 = __webpack_require__(2543);
	var selectedRowsComp_1 = __webpack_require__(2544);
	var filteredRowsComp_1 = __webpack_require__(2545);
	var filtersToolPanel_1 = __webpack_require__(2546);
	var setFloatingFilter_1 = __webpack_require__(2548);
	var EnterpriseBoot = /** @class */ (function () {
	    function EnterpriseBoot() {
	    }
	    EnterpriseBoot.prototype.init = function () {
	        this.userComponentRegistry.registerDefaultComponent('agRichSelect', richSelectCellEditor_1.RichSelectCellEditor);
	        this.userComponentRegistry.registerDefaultComponent('agRichSelectCellEditor', richSelectCellEditor_1.RichSelectCellEditor);
	        this.userComponentRegistry.registerDefaultComponent('agSetColumnFilter', setFilter_1.SetFilter);
	        this.userComponentRegistry.registerDefaultComponent('agSetColumnFloatingFilter', setFloatingFilter_1.SetFloatingFilterComp);
	        this.userComponentRegistry.registerDefaultComponent('agDetailCellRenderer', detailCellRenderer_1.DetailCellRenderer);
	        this.userComponentRegistry.registerDefaultComponent('agAggregationComponent', aggregationComp_1.AggregationComp);
	        this.userComponentRegistry.registerDefaultComponent('agColumnsToolPanel', columnToolPanel_1.ColumnToolPanel);
	        this.userComponentRegistry.registerDefaultComponent('agFiltersToolPanel', filtersToolPanel_1.FiltersToolPanel);
	        this.userComponentRegistry.registerDefaultComponent('agSelectedRowCountComponent', selectedRowsComp_1.SelectedRowsComp);
	        this.userComponentRegistry.registerDefaultComponent('agTotalRowCountComponent', totalRowsComp_1.TotalRowsComp);
	        this.userComponentRegistry.registerDefaultComponent('agFilteredRowCountComponent', filteredRowsComp_1.FilteredRowsComp);
	        this.userComponentRegistry.registerDefaultComponent('agTotalAndFilteredRowCountComponent', totalAndFilteredRowsComp_1.TotalAndFilteredRowsComp);
	    };
	    __decorate([
	        ag_grid_community_1.Autowired('filterManager'),
	        __metadata("design:type", ag_grid_community_1.FilterManager)
	    ], EnterpriseBoot.prototype, "filterManager", void 0);
	    __decorate([
	        ag_grid_community_1.Autowired('licenseManager'),
	        __metadata("design:type", licenseManager_1.LicenseManager)
	    ], EnterpriseBoot.prototype, "licenseManager", void 0);
	    __decorate([
	        ag_grid_community_1.Autowired('userComponentRegistry'),
	        __metadata("design:type", ag_grid_community_1.UserComponentRegistry)
	    ], EnterpriseBoot.prototype, "userComponentRegistry", void 0);
	    __decorate([
	        ag_grid_community_1.PostConstruct,
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", []),
	        __metadata("design:returntype", void 0)
	    ], EnterpriseBoot.prototype, "init", null);
	    EnterpriseBoot = __decorate([
	        ag_grid_community_1.Bean('enterpriseBoot')
	    ], EnterpriseBoot);
	    return EnterpriseBoot;
	}());
	exports.EnterpriseBoot = EnterpriseBoot;


/***/ }),
/* 2524 */
/***/ (function(module, exports, __webpack_require__) {

	// ag-grid-enterprise v21.2.2
	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var ag_grid_community_1 = __webpack_require__(2322);
	var setValueModel_1 = __webpack_require__(2525);
	var setFilterListItem_1 = __webpack_require__(2526);
	var virtualList_1 = __webpack_require__(2527);
	var CheckboxState;
	(function (CheckboxState) {
	    CheckboxState[CheckboxState["CHECKED"] = 0] = "CHECKED";
	    CheckboxState[CheckboxState["UNCHECKED"] = 1] = "UNCHECKED";
	    CheckboxState[CheckboxState["INTERMEDIATE"] = 2] = "INTERMEDIATE";
	})(CheckboxState || (CheckboxState = {}));
	var SetFilter = /** @class */ (function (_super) {
	    __extends(SetFilter, _super);
	    function SetFilter() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    // unlike the simple filter's, nothing in the set filter UI shows/hides.
	    // maybe this method belongs in abstractSimpleFilter???
	    SetFilter.prototype.updateUiVisibility = function () { };
	    SetFilter.prototype.createBodyTemplate = function () {
	        var translate = this.gridOptionsWrapper.getLocaleTextFunc();
	        return "<div ref=\"ag-filter-loading\" class=\"loading-filter ag-hidden\">" + translate('loadingOoo', 'Loading...') + "</div>\n                <div>\n                    <div class=\"ag-filter-header-container\" role=\"presentation\">\n                        <div class=\"ag-input-wrapper\" id=\"ag-mini-filter\" role=\"presentation\">\n                            <input ref=\"eMiniFilter\" class=\"ag-filter-filter\" type=\"text\" placeholder=\"" + translate('searchOoo', 'Search...') + "\"/>\n                        </div>\n                        <label ref=\"eSelectAllContainer\" class=\"ag-set-filter-item\">\n                            <div ref=\"eSelectAll\" class=\"ag-filter-checkbox\"></div><span class=\"ag-filter-value\">(" + translate('selectAll', 'Select All') + ")</span>\n                        </label>\n                    </div>\n                    <div ref=\"eSetFilterList\" class=\"ag-set-filter-list\" role=\"presentation\"></div>\n                </div>";
	    };
	    SetFilter.prototype.resetUiToDefaults = function () {
	        this.setMiniFilter(null);
	        this.valueModel.setModel(null, true);
	        this.selectEverything();
	    };
	    SetFilter.prototype.setModelIntoUi = function (model) {
	        this.resetUiToDefaults();
	        if (model) {
	            // also supporting old filter model for backwards compatibility
	            var newValues = (model instanceof Array) ? model : model.values;
	            this.valueModel.setModel(newValues);
	            this.updateSelectAll();
	            this.virtualList.refresh();
	        }
	    };
	    SetFilter.prototype.getModelFromUi = function () {
	        var values = this.valueModel.getModel();
	        if (!values) {
	            return null;
	        }
	        if (this.gridOptionsWrapper.isEnableOldSetFilterModel()) {
	            // this is a hack, it breaks casting rules, to apply with old model
	            return values;
	        }
	        else {
	            return {
	                values: values,
	                filterType: 'set'
	            };
	        }
	    };
	    SetFilter.prototype.areModelsEqual = function (a, b) {
	        return false;
	    };
	    SetFilter.prototype.setParams = function (params) {
	        _super.prototype.setParams.call(this, params);
	        this.setFilterParams = params;
	        this.eCheckedIcon = ag_grid_community_1._.createIconNoSpan('checkboxChecked', this.gridOptionsWrapper, this.setFilterParams.column);
	        this.eUncheckedIcon = ag_grid_community_1._.createIconNoSpan('checkboxUnchecked', this.gridOptionsWrapper, this.setFilterParams.column);
	        this.eIndeterminateCheckedIcon = ag_grid_community_1._.createIconNoSpan('checkboxIndeterminate', this.gridOptionsWrapper, this.setFilterParams.column);
	        this.initialiseFilterBodyUi();
	        var doSyncLikeExcel = params.syncValuesLikeExcel
	            // sync like excel only withs with CSRM
	            && this.rowModel.getType() === ag_grid_community_1.Constants.ROW_MODEL_TYPE_CLIENT_SIDE
	            // sync only needed if user not providing values
	            && !params.values;
	        if (doSyncLikeExcel) {
	            this.setupSyncValuesLikeExcel();
	        }
	    };
	    SetFilter.prototype.resetFilterValuesAndReapplyModel = function () {
	        var modelBeforeUpdate = this.getModel();
	        this.resetFilterValues();
	        if (modelBeforeUpdate) {
	            this.setModel(modelBeforeUpdate);
	        }
	    };
	    SetFilter.prototype.setupSyncValuesLikeExcel = function () {
	        var _this = this;
	        var col = this.setFilterParams.column;
	        var rowDataUpdatedListener = function () {
	            _this.resetFilterValuesAndReapplyModel();
	        };
	        var cellValueChangedListener = function (event) {
	            // only interested in changes to do with this column
	            if (event.column !== col) {
	                return;
	            }
	            _this.resetFilterValuesAndReapplyModel();
	        };
	        this.addDestroyableEventListener(this.eventService, ag_grid_community_1.Events.EVENT_ROW_DATA_UPDATED, rowDataUpdatedListener);
	        this.addDestroyableEventListener(this.eventService, ag_grid_community_1.Events.EVENT_CELL_VALUE_CHANGED, cellValueChangedListener);
	    };
	    SetFilter.prototype.updateCheckboxIcon = function () {
	        ag_grid_community_1._.clearElement(this.eSelectAll);
	        var icon;
	        switch (this.selectAllState) {
	            case CheckboxState.INTERMEDIATE:
	                icon = this.eIndeterminateCheckedIcon;
	                break;
	            case CheckboxState.CHECKED:
	                icon = this.eCheckedIcon;
	                break;
	            case CheckboxState.UNCHECKED:
	                icon = this.eUncheckedIcon;
	                break;
	            default: // default happens when initialising for first time
	                icon = this.eCheckedIcon;
	                break;
	        }
	        this.eSelectAll.appendChild(icon);
	    };
	    SetFilter.prototype.setLoading = function (loading) {
	        ag_grid_community_1._.setDisplayed(this.eFilterLoading, loading);
	    };
	    SetFilter.prototype.initialiseFilterBodyUi = function () {
	        var _this = this;
	        this.virtualList = new virtualList_1.VirtualList();
	        this.getContext().wireBean(this.virtualList);
	        var eSetFilterList = this.getRefElement('eSetFilterList');
	        if (eSetFilterList) {
	            eSetFilterList.appendChild(this.virtualList.getGui());
	        }
	        if (ag_grid_community_1._.exists(this.setFilterParams.cellHeight)) {
	            this.virtualList.setRowHeight(this.setFilterParams.cellHeight);
	        }
	        this.virtualList.setComponentCreator(this.createSetListItem.bind(this));
	        this.valueModel = new setValueModel_1.SetValueModel(this.setFilterParams.colDef, this.setFilterParams.rowModel, this.setFilterParams.valueGetter, this.setFilterParams.doesRowPassOtherFilter, this.setFilterParams.suppressSorting, function (values, toSelect) { return _this.setFilterValues(values, toSelect ? false : true, toSelect ? true : false, toSelect); }, this.setLoading.bind(this), this.valueFormatterService, this.setFilterParams.column);
	        this.virtualList.setModel(new ModelWrapper(this.valueModel));
	        ag_grid_community_1._.setDisplayed(this.getGui().querySelector('#ag-mini-filter'), !this.setFilterParams.suppressMiniFilter);
	        this.eMiniFilter.value = this.valueModel.getMiniFilter();
	        this.addDestroyableEventListener(this.eMiniFilter, 'input', this.onMiniFilterInput.bind(this));
	        this.addDestroyableEventListener(this.eMiniFilter, 'keypress', this.onMiniFilterKeyPress.bind(this));
	        this.updateCheckboxIcon();
	        this.addDestroyableEventListener(this.eSelectAllContainer, 'click', this.onSelectAll.bind(this));
	        this.updateSelectAll();
	        if (this.setFilterParams.suppressSelectAll) {
	            ag_grid_community_1._.setDisplayed(this.eSelectAllContainer, false);
	        }
	        this.virtualList.refresh();
	    };
	    SetFilter.prototype.createSetListItem = function (value) {
	        var _this = this;
	        var listItem = new setFilterListItem_1.SetFilterListItem(value, this.setFilterParams.column);
	        this.getContext().wireBean(listItem);
	        listItem.setSelected(this.valueModel.isValueSelected(value));
	        listItem.addEventListener(setFilterListItem_1.SetFilterListItem.EVENT_SELECTED, function () {
	            _this.onItemSelected(value, listItem.isSelected());
	        });
	        return listItem;
	    };
	    // we need to have the gui attached before we can draw the virtual rows, as the
	    // virtual row logic needs info about the gui state
	    SetFilter.prototype.afterGuiAttached = function (params) {
	        this.virtualList.refresh();
	        this.eMiniFilter.focus();
	    };
	    SetFilter.prototype.applyModel = function () {
	        var _this = this;
	        var res = _super.prototype.applyModel.call(this);
	        // keep the appliedModelValuesMapped in sync with the applied model
	        var appliedModel = this.getModel();
	        if (appliedModel) {
	            this.appliedModelValuesMapped = {};
	            appliedModel.values.forEach(function (value) { return _this.appliedModelValuesMapped[value] = true; });
	        }
	        else {
	            this.appliedModelValuesMapped = undefined;
	        }
	        return res;
	    };
	    SetFilter.prototype.doesFilterPass = function (params) {
	        // should never happen, if filter model not set, then this method should never be called
	        if (!this.appliedModelValuesMapped) {
	            return true;
	        }
	        var value = this.setFilterParams.valueGetter(params.node);
	        if (this.setFilterParams.colDef.keyCreator) {
	            value = this.setFilterParams.colDef.keyCreator({ value: value });
	        }
	        value = ag_grid_community_1._.makeNull(value);
	        if (Array.isArray(value)) {
	            for (var i = 0; i < value.length; i++) {
	                var valueExistsInMap = !!this.appliedModelValuesMapped[value[i]];
	                if (valueExistsInMap) {
	                    return true;
	                }
	            }
	            return false;
	        }
	        else {
	            var valueExistsInMap = !!this.appliedModelValuesMapped[value];
	            return valueExistsInMap;
	        }
	    };
	    SetFilter.prototype.onNewRowsLoaded = function () {
	        var valuesType = this.valueModel.getValuesType();
	        var valuesTypeProvided = valuesType === setValueModel_1.SetFilterModelValuesType.PROVIDED_CB
	            || valuesType === setValueModel_1.SetFilterModelValuesType.PROVIDED_LIST;
	        // if the user is providing values, and we are keeping the previous selection, then
	        // loading new rows into the grid should have no impact.
	        var newRowsActionKeep = this.isNewRowsActionKeep();
	        if (newRowsActionKeep && valuesTypeProvided) {
	            return;
	        }
	        var everythingSelected = !this.getModel();
	        // default is reset
	        this.valueModel.refreshAfterNewRowsLoaded(newRowsActionKeep, everythingSelected);
	        this.updateSelectAll();
	        this.virtualList.refresh();
	        this.applyModel();
	    };
	    //noinspection JSUnusedGlobalSymbols
	    /**
	     * Public method provided so the user can change the value of the filter once
	     * the filter has been already started
	     * @param options The options to use.
	     * @param selectAll If by default all the values should be selected.
	     * @param notify If we should let know the model that the values of the filter have changed
	     * @param toSelect The subset of options to subselect
	     */
	    SetFilter.prototype.setFilterValues = function (options, selectAll, notify, toSelect) {
	        var _this = this;
	        if (selectAll === void 0) { selectAll = false; }
	        if (notify === void 0) { notify = true; }
	        this.valueModel.onFilterValuesReady(function () {
	            var keepSelection = _this.setFilterParams && _this.setFilterParams.newRowsAction === 'keep';
	            _this.valueModel.setValuesType(setValueModel_1.SetFilterModelValuesType.PROVIDED_LIST);
	            _this.valueModel.refreshValues(options, keepSelection, selectAll);
	            _this.updateSelectAll();
	            var actualToSelect = toSelect ? toSelect : options;
	            actualToSelect.forEach(function (option) { return _this.valueModel.selectValue(option); });
	            _this.virtualList.refresh();
	            if (notify) {
	                // this.onUiChangedListener(true);
	                _this.onUiChanged();
	            }
	        });
	    };
	    //noinspection JSUnusedGlobalSymbols
	    /**
	     * Public method provided so the user can reset the values of the filter once that it has started
	     * @param options The options to use.
	     */
	    SetFilter.prototype.resetFilterValues = function () {
	        this.valueModel.setValuesType(setValueModel_1.SetFilterModelValuesType.NOT_PROVIDED);
	        this.onNewRowsLoaded();
	    };
	    SetFilter.prototype.onAnyFilterChanged = function () {
	        this.valueModel.refreshAfterAnyFilterChanged();
	        this.virtualList.refresh();
	    };
	    SetFilter.prototype.updateSelectAll = function () {
	        if (this.valueModel.isEverythingSelected()) {
	            this.selectAllState = CheckboxState.CHECKED;
	        }
	        else if (this.valueModel.isNothingSelected()) {
	            this.selectAllState = CheckboxState.UNCHECKED;
	        }
	        else {
	            this.selectAllState = CheckboxState.INTERMEDIATE;
	        }
	        this.updateCheckboxIcon();
	    };
	    SetFilter.prototype.onMiniFilterKeyPress = function (e) {
	        if (ag_grid_community_1._.isKeyPressed(e, ag_grid_community_1.Constants.KEY_ENTER)) {
	            this.onEnterKeyOnMiniFilter();
	        }
	    };
	    SetFilter.prototype.onEnterKeyOnMiniFilter = function () {
	        this.valueModel.selectAllFromMiniFilter();
	        this.virtualList.refresh();
	        this.updateSelectAll();
	        this.onUiChanged();
	    };
	    SetFilter.prototype.onMiniFilterInput = function () {
	        var miniFilterChanged = this.valueModel.setMiniFilter(this.eMiniFilter.value);
	        if (miniFilterChanged) {
	            this.virtualList.refresh();
	        }
	        this.updateSelectAll();
	    };
	    SetFilter.prototype.onSelectAll = function (event) {
	        event.preventDefault();
	        ag_grid_community_1._.addAgGridEventPath(event);
	        if (this.selectAllState === CheckboxState.CHECKED) {
	            this.selectAllState = CheckboxState.UNCHECKED;
	        }
	        else {
	            this.selectAllState = CheckboxState.CHECKED;
	        }
	        this.doSelectAll();
	    };
	    SetFilter.prototype.doSelectAll = function () {
	        var checked = this.selectAllState === CheckboxState.CHECKED;
	        if (checked) {
	            this.valueModel.selectAllUsingMiniFilter();
	        }
	        else {
	            this.valueModel.selectNothingUsingMiniFilter();
	        }
	        this.virtualList.refresh();
	        this.onUiChanged();
	        this.updateSelectAll();
	    };
	    SetFilter.prototype.onItemSelected = function (value, selected) {
	        if (selected) {
	            this.valueModel.selectValue(value);
	        }
	        else {
	            this.valueModel.unselectValue(value);
	        }
	        this.updateSelectAll();
	        this.onUiChanged();
	    };
	    SetFilter.prototype.setMiniFilter = function (newMiniFilter) {
	        this.valueModel.setMiniFilter(newMiniFilter);
	        this.eMiniFilter.value = this.valueModel.getMiniFilter();
	    };
	    SetFilter.prototype.getMiniFilter = function () {
	        return this.valueModel.getMiniFilter();
	    };
	    SetFilter.prototype.selectEverything = function () {
	        this.valueModel.selectAllUsingMiniFilter();
	        this.updateSelectAll();
	        this.virtualList.refresh();
	    };
	    SetFilter.prototype.selectNothing = function () {
	        this.valueModel.selectNothingUsingMiniFilter();
	        this.updateSelectAll();
	        this.virtualList.refresh();
	    };
	    SetFilter.prototype.unselectValue = function (value) {
	        this.valueModel.unselectValue(value);
	        this.updateSelectAll();
	        this.virtualList.refresh();
	    };
	    SetFilter.prototype.selectValue = function (value) {
	        this.valueModel.selectValue(value);
	        this.updateSelectAll();
	        this.virtualList.refresh();
	    };
	    SetFilter.prototype.isValueSelected = function (value) {
	        return this.valueModel.isValueSelected(value);
	    };
	    SetFilter.prototype.isEverythingSelected = function () {
	        return this.valueModel.isEverythingSelected();
	    };
	    SetFilter.prototype.isNothingSelected = function () {
	        return this.valueModel.isNothingSelected();
	    };
	    SetFilter.prototype.getUniqueValueCount = function () {
	        return this.valueModel.getUniqueValueCount();
	    };
	    SetFilter.prototype.getUniqueValue = function (index) {
	        return this.valueModel.getUniqueValue(index);
	    };
	    __decorate([
	        ag_grid_community_1.RefSelector('eSelectAll'),
	        __metadata("design:type", HTMLInputElement)
	    ], SetFilter.prototype, "eSelectAll", void 0);
	    __decorate([
	        ag_grid_community_1.RefSelector('eSelectAllContainer'),
	        __metadata("design:type", HTMLElement)
	    ], SetFilter.prototype, "eSelectAllContainer", void 0);
	    __decorate([
	        ag_grid_community_1.RefSelector('eMiniFilter'),
	        __metadata("design:type", HTMLInputElement)
	    ], SetFilter.prototype, "eMiniFilter", void 0);
	    __decorate([
	        ag_grid_community_1.RefSelector('ag-filter-loading'),
	        __metadata("design:type", HTMLInputElement)
	    ], SetFilter.prototype, "eFilterLoading", void 0);
	    __decorate([
	        ag_grid_community_1.Autowired('valueFormatterService'),
	        __metadata("design:type", ag_grid_community_1.ValueFormatterService)
	    ], SetFilter.prototype, "valueFormatterService", void 0);
	    __decorate([
	        ag_grid_community_1.Autowired('eventService'),
	        __metadata("design:type", ag_grid_community_1.EventService)
	    ], SetFilter.prototype, "eventService", void 0);
	    return SetFilter;
	}(ag_grid_community_1.ProvidedFilter));
	exports.SetFilter = SetFilter;
	var ModelWrapper = /** @class */ (function () {
	    function ModelWrapper(model) {
	        this.model = model;
	    }
	    ModelWrapper.prototype.getRowCount = function () {
	        return this.model.getDisplayedValueCount();
	    };
	    ModelWrapper.prototype.getRow = function (index) {
	        return this.model.getDisplayedValue(index);
	    };
	    return ModelWrapper;
	}());


/***/ }),
/* 2525 */
/***/ (function(module, exports, __webpack_require__) {

	// ag-grid-enterprise v21.2.2
	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var ag_grid_community_1 = __webpack_require__(2322);
	// we cannot have 'null' as a key in a JavaScript map,
	// it needs to be a string. so we use this string for
	// storing null values.
	var NULL_VALUE = '___NULL___';
	var SetFilterModelValuesType;
	(function (SetFilterModelValuesType) {
	    SetFilterModelValuesType[SetFilterModelValuesType["PROVIDED_LIST"] = 0] = "PROVIDED_LIST";
	    SetFilterModelValuesType[SetFilterModelValuesType["PROVIDED_CB"] = 1] = "PROVIDED_CB";
	    SetFilterModelValuesType[SetFilterModelValuesType["NOT_PROVIDED"] = 2] = "NOT_PROVIDED";
	})(SetFilterModelValuesType = exports.SetFilterModelValuesType || (exports.SetFilterModelValuesType = {}));
	var SetValueModel = /** @class */ (function () {
	    function SetValueModel(colDef, rowModel, valueGetter, doesRowPassOtherFilters, suppressSorting, modelUpdatedFunc, isLoadingFunc, valueFormatterService, column) {
	        this.suppressSorting = suppressSorting;
	        this.colDef = colDef;
	        this.valueGetter = valueGetter;
	        this.doesRowPassOtherFilters = doesRowPassOtherFilters;
	        this.modelUpdatedFunc = modelUpdatedFunc;
	        this.isLoadingFunc = isLoadingFunc;
	        this.valueFormatterService = valueFormatterService;
	        this.column = column;
	        if (rowModel.getType() === ag_grid_community_1.Constants.ROW_MODEL_TYPE_CLIENT_SIDE) {
	            this.clientSideRowModel = rowModel;
	        }
	        this.filterParams = this.colDef.filterParams ? this.colDef.filterParams : {};
	        if (ag_grid_community_1._.exists(this.filterParams) && ag_grid_community_1._.exists(this.filterParams.values)) {
	            this.valuesType = Array.isArray(this.filterParams.values) ?
	                SetFilterModelValuesType.PROVIDED_LIST :
	                SetFilterModelValuesType.PROVIDED_CB;
	            this.showingAvailableOnly = this.filterParams.suppressRemoveEntries !== true;
	        }
	        else {
	            this.valuesType = SetFilterModelValuesType.NOT_PROVIDED;
	            this.showingAvailableOnly = true;
	        }
	        this.createAllUniqueValues();
	        this.createAvailableUniqueValues();
	        // by default, no filter, so we display everything
	        this.displayedValues = this.availableUniqueValues;
	        this.miniFilter = null;
	        // we use a map rather than an array for the selected values as the lookup
	        // for a map is much faster than the lookup for an array, especially when
	        // the length of the array is thousands of records long
	        this.selectedValuesMap = {};
	        this.selectAllUsingMiniFilter();
	        this.formatter = this.filterParams.textFormatter ? this.filterParams.textFormatter : ag_grid_community_1.TextFilter.DEFAULT_FORMATTER;
	    }
	    // if keepSelection not set will always select all filters
	    // if keepSelection set will keep current state of selected filters
	    //    unless selectAll chosen in which case will select all
	    SetValueModel.prototype.refreshAfterNewRowsLoaded = function (keepSelection, everythingSelected) {
	        this.createAllUniqueValues();
	        this.refreshSelection(keepSelection, everythingSelected);
	    };
	    // if keepSelection not set will always select all filters
	    // if keepSelection set will keep current state of selected filters
	    //    unless selectAll chosen in which case will select all
	    SetValueModel.prototype.refreshValues = function (valuesToUse, keepSelection, isSelectAll) {
	        this.setValues(valuesToUse);
	        this.refreshSelection(keepSelection, isSelectAll);
	    };
	    SetValueModel.prototype.refreshSelection = function (keepSelection, isSelectAll) {
	        this.createAvailableUniqueValues();
	        var oldModel = Object.keys(this.selectedValuesMap);
	        this.selectedValuesMap = {};
	        this.processMiniFilter();
	        if (keepSelection) {
	            this.setModel(oldModel, isSelectAll);
	        }
	        else {
	            this.selectAllUsingMiniFilter();
	        }
	    };
	    SetValueModel.prototype.refreshAfterAnyFilterChanged = function () {
	        if (this.showingAvailableOnly) {
	            this.createAvailableUniqueValues();
	            this.processMiniFilter();
	        }
	    };
	    SetValueModel.prototype.createAllUniqueValues = function () {
	        if (this.areValuesSync()) {
	            var valuesToUse = this.extractSyncValuesToUse();
	            this.setValues(valuesToUse);
	            this.filterValuesPromise = ag_grid_community_1.Promise.resolve([]);
	        }
	        else {
	            this.filterValuesExternalPromise = ag_grid_community_1.Promise.external();
	            this.filterValuesPromise = this.filterValuesExternalPromise.promise;
	            this.isLoadingFunc(true);
	            this.setValues([]);
	            var callback_1 = this.filterParams.values;
	            var params_1 = {
	                success: this.onAsyncValuesLoaded.bind(this),
	                colDef: this.colDef
	            };
	            window.setTimeout(function () { return callback_1(params_1); }, 0);
	        }
	    };
	    SetValueModel.prototype.onAsyncValuesLoaded = function (values) {
	        this.modelUpdatedFunc(values);
	        this.isLoadingFunc(false);
	        this.filterValuesExternalPromise.resolve(values);
	    };
	    SetValueModel.prototype.areValuesSync = function () {
	        return this.valuesType == SetFilterModelValuesType.PROVIDED_LIST || this.valuesType == SetFilterModelValuesType.NOT_PROVIDED;
	    };
	    SetValueModel.prototype.setValuesType = function (value) {
	        this.valuesType = value;
	    };
	    SetValueModel.prototype.getValuesType = function () {
	        return this.valuesType;
	    };
	    SetValueModel.prototype.setValues = function (valuesToUse) {
	        this.allUniqueValues = valuesToUse;
	        if (!this.suppressSorting) {
	            this.sortValues(this.allUniqueValues);
	        }
	    };
	    SetValueModel.prototype.extractSyncValuesToUse = function () {
	        var valuesToUse;
	        if (this.valuesType == SetFilterModelValuesType.PROVIDED_LIST) {
	            if (Array.isArray(this.filterParams.values)) {
	                valuesToUse = ag_grid_community_1._.toStrings(this.filterParams.values);
	            }
	            else {
	                // In this case the values are async but have already been resolved, so we can reuse them
	                valuesToUse = this.allUniqueValues;
	            }
	        }
	        else if (this.valuesType == SetFilterModelValuesType.PROVIDED_CB) {
	            throw Error("ag-grid: Error extracting values to use. We should not extract the values synchronously when using a callback for the filterParams.values");
	        }
	        else {
	            var uniqueValuesAsAnyObjects = this.getUniqueValues(false);
	            valuesToUse = ag_grid_community_1._.toStrings(uniqueValuesAsAnyObjects);
	        }
	        return valuesToUse;
	    };
	    SetValueModel.prototype.createAvailableUniqueValues = function () {
	        var dontCheckAvailableValues = !this.showingAvailableOnly || this.valuesType == SetFilterModelValuesType.PROVIDED_LIST || this.valuesType == SetFilterModelValuesType.PROVIDED_CB;
	        if (dontCheckAvailableValues) {
	            this.availableUniqueValues = this.allUniqueValues;
	            return;
	        }
	        var uniqueValuesAsAnyObjects = this.getUniqueValues(true);
	        this.availableUniqueValues = ag_grid_community_1._.toStrings(uniqueValuesAsAnyObjects);
	        this.sortValues(this.availableUniqueValues);
	    };
	    SetValueModel.prototype.sortValues = function (values) {
	        if (this.filterParams && this.filterParams.comparator) {
	            values.sort(this.filterParams.comparator);
	        }
	        else if (this.colDef.comparator) {
	            values.sort(this.colDef.comparator);
	        }
	        else {
	            values.sort(ag_grid_community_1._.defaultComparator);
	        }
	    };
	    SetValueModel.prototype.getUniqueValues = function (filterOutNotAvailable) {
	        var _this = this;
	        var uniqueCheck = {};
	        var result = [];
	        if (!this.clientSideRowModel) {
	            console.error('ag-Grid: Set Filter cannot initialise because you are using a row model that does not contain all rows in the browser. Either use a different filter type, or configure Set Filter such that you provide it with values');
	            return [];
	        }
	        this.clientSideRowModel.forEachLeafNode(function (node) {
	            // only pull values from rows that have data. this means we skip filler group nodes.
	            if (!node.data) {
	                return;
	            }
	            var value = _this.valueGetter(node);
	            if (_this.colDef.keyCreator) {
	                value = _this.colDef.keyCreator({ value: value });
	            }
	            if (value === "" || value === undefined) {
	                value = null;
	            }
	            if (filterOutNotAvailable) {
	                if (!_this.doesRowPassOtherFilters(node)) {
	                    return;
	                }
	            }
	            if (value != null && Array.isArray(value)) {
	                for (var j = 0; j < value.length; j++) {
	                    addUniqueValueIfMissing(value[j]);
	                }
	            }
	            else {
	                addUniqueValueIfMissing(value);
	            }
	        });
	        function addUniqueValueIfMissing(value) {
	            if (!uniqueCheck.hasOwnProperty(value)) {
	                result.push(value);
	                uniqueCheck[value] = 1;
	            }
	        }
	        return result;
	    };
	    //sets mini filter. returns true if it changed from last value, otherwise false
	    SetValueModel.prototype.setMiniFilter = function (newMiniFilter) {
	        newMiniFilter = ag_grid_community_1._.makeNull(newMiniFilter);
	        if (this.miniFilter === newMiniFilter) {
	            //do nothing if filter has not changed
	            return false;
	        }
	        this.miniFilter = newMiniFilter;
	        this.processMiniFilter();
	        return true;
	    };
	    SetValueModel.prototype.getMiniFilter = function () {
	        return this.miniFilter;
	    };
	    SetValueModel.prototype.processMiniFilter = function () {
	        // if no filter, just use the unique values
	        if (this.miniFilter === null) {
	            this.displayedValues = this.availableUniqueValues;
	            return;
	        }
	        // if filter present, we filter down the list
	        this.displayedValues = [];
	        var miniFilter = this.formatter(this.miniFilter);
	        // make upper case to have search case insensitive
	        var miniFilterUpperCase = miniFilter.toUpperCase();
	        //This function encapsulates the logic to check if a string matches the mini filter
	        var matchesFn = function (valueToCheck) {
	            if (valueToCheck == null) {
	                return false;
	            }
	            // allow for case insensitive searches, make both filter and value uppercase
	            var valueUpperCase = valueToCheck.toUpperCase();
	            return valueUpperCase.indexOf(miniFilterUpperCase) >= 0;
	        };
	        for (var i = 0, l = this.availableUniqueValues.length; i < l; i++) {
	            var value = this.availableUniqueValues[i];
	            if (value) {
	                var displayedValue = this.formatter(value.toString());
	                var formattedValue = this.valueFormatterService.formatValue(this.column, null, null, displayedValue);
	                if (matchesFn(displayedValue) || matchesFn(formattedValue)) {
	                    this.displayedValues.push(value);
	                }
	            }
	        }
	    };
	    SetValueModel.prototype.getDisplayedValueCount = function () {
	        return this.displayedValues.length;
	    };
	    SetValueModel.prototype.getDisplayedValue = function (index) {
	        return this.displayedValues[index];
	    };
	    SetValueModel.prototype.selectAllUsingMiniFilter = function () {
	        if (!this.filterParams.selectAllOnMiniFilter || !this.miniFilter) {
	            this.selectOn(this.allUniqueValues);
	        }
	        else {
	            this.selectOn(this.displayedValues);
	        }
	    };
	    SetValueModel.prototype.selectOn = function (toSelectOn) {
	        var count = toSelectOn.length;
	        for (var i = 0; i < count; i++) {
	            var key = toSelectOn[i];
	            var safeKey = this.valueToKey(key);
	            this.selectedValuesMap[safeKey] = null;
	        }
	        this.selectedValuesCount = Object.keys(this.selectedValuesMap).length;
	    };
	    SetValueModel.prototype.valueToKey = function (key) {
	        if (key === null) {
	            return NULL_VALUE;
	        }
	        else {
	            return key;
	        }
	    };
	    SetValueModel.prototype.keyToValue = function (value) {
	        if (value === NULL_VALUE) {
	            return null;
	        }
	        else {
	            return value;
	        }
	    };
	    SetValueModel.prototype.isFilterActive = function () {
	        return this.allUniqueValues.length !== this.selectedValuesCount;
	    };
	    SetValueModel.prototype.selectNothingUsingMiniFilter = function () {
	        var _this = this;
	        if (!this.filterParams.selectAllOnMiniFilter || !this.miniFilter) {
	            this.selectNothing();
	        }
	        else {
	            this.displayedValues.forEach(function (it) { return _this.unselectValue(it); });
	        }
	    };
	    SetValueModel.prototype.selectNothing = function () {
	        this.selectedValuesMap = {};
	        this.selectedValuesCount = 0;
	    };
	    SetValueModel.prototype.getUniqueValueCount = function () {
	        return this.allUniqueValues.length;
	    };
	    SetValueModel.prototype.getUniqueValue = function (index) {
	        return this.allUniqueValues[index];
	    };
	    SetValueModel.prototype.unselectValue = function (value) {
	        var safeKey = this.valueToKey(value);
	        if (this.selectedValuesMap[safeKey] !== undefined) {
	            delete this.selectedValuesMap[safeKey];
	            this.selectedValuesCount--;
	        }
	    };
	    SetValueModel.prototype.selectAllFromMiniFilter = function () {
	        this.selectNothing();
	        this.selectAllUsingMiniFilter();
	    };
	    SetValueModel.prototype.selectValue = function (value) {
	        var safeKey = this.valueToKey(value);
	        if (this.selectedValuesMap[safeKey] === undefined) {
	            this.selectedValuesMap[safeKey] = null;
	            this.selectedValuesCount++;
	        }
	    };
	    SetValueModel.prototype.isValueSelected = function (value) {
	        var safeKey = this.valueToKey(value);
	        return this.selectedValuesMap[safeKey] !== undefined;
	    };
	    SetValueModel.prototype.isEverythingSelected = function () {
	        var _this = this;
	        if (!this.filterParams.selectAllOnMiniFilter || !this.miniFilter) {
	            return this.allUniqueValues.length === this.selectedValuesCount;
	        }
	        else {
	            return this.displayedValues.filter(function (it) { return _this.isValueSelected(it); }).length === this.displayedValues.length;
	        }
	    };
	    SetValueModel.prototype.isNothingSelected = function () {
	        var _this = this;
	        if (!this.filterParams.selectAllOnMiniFilter || !this.miniFilter) {
	            return this.selectedValuesCount === 0;
	        }
	        else {
	            return this.displayedValues.filter(function (it) { return _this.isValueSelected(it); }).length === 0;
	        }
	    };
	    SetValueModel.prototype.getModel = function () {
	        var _this = this;
	        if (!this.isFilterActive()) {
	            return null;
	        }
	        var selectedValues = [];
	        ag_grid_community_1._.iterateObject(this.selectedValuesMap, function (key) {
	            var value = _this.keyToValue(key);
	            selectedValues.push(value);
	        });
	        return selectedValues;
	    };
	    SetValueModel.prototype.setModel = function (model, isSelectAll) {
	        var _this = this;
	        if (isSelectAll === void 0) { isSelectAll = false; }
	        if (this.areValuesSync()) {
	            this.setSyncModel(model, isSelectAll);
	        }
	        else {
	            this.filterValuesExternalPromise.promise.then(function (values) {
	                _this.setSyncModel(model, isSelectAll);
	                _this.modelUpdatedFunc(values, model);
	            });
	        }
	    };
	    SetValueModel.prototype.setSyncModel = function (model, isSelectAll) {
	        if (isSelectAll === void 0) { isSelectAll = false; }
	        if (model && !isSelectAll) {
	            this.selectNothingUsingMiniFilter();
	            for (var i = 0; i < model.length; i++) {
	                var rawValue = model[i];
	                var value = this.keyToValue(rawValue);
	                if (this.allUniqueValues.indexOf(value) >= 0) {
	                    this.selectValue(value);
	                }
	            }
	        }
	        else {
	            this.selectAllUsingMiniFilter();
	        }
	    };
	    SetValueModel.prototype.onFilterValuesReady = function (callback) {
	        //This guarantees that if the user is racing to set values async into the set filter, only the first instance
	        //will be used
	        // ie Values are async and the user manually wants to override them before the retrieval of values is triggered
	        // (set filter values in the following example)
	        // http://plnkr.co/edit/eFka7ynvPj68tL3VJFWf?p=preview
	        this.filterValuesPromise.firstOneOnly(callback);
	    };
	    return SetValueModel;
	}());
	exports.SetValueModel = SetValueModel;


/***/ }),
/* 2526 */
/***/ (function(module, exports, __webpack_require__) {

	// ag-grid-enterprise v21.2.2
	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var ag_grid_community_1 = __webpack_require__(2322);
	var SetFilterListItem = /** @class */ (function (_super) {
	    __extends(SetFilterListItem, _super);
	    function SetFilterListItem(value, column) {
	        var _this = _super.call(this, SetFilterListItem.TEMPLATE) || this;
	        _this.selected = true;
	        _this.value = value;
	        _this.column = column;
	        return _this;
	    }
	    SetFilterListItem.prototype.useCellRenderer = function (target, eTarget, params) {
	        var cellRendererPromise = this.userComponentFactory.newCellRenderer(target.filterParams, params);
	        if (cellRendererPromise != null) {
	            ag_grid_community_1._.bindCellRendererToHtmlElement(cellRendererPromise, eTarget);
	        }
	        else {
	            if (params.valueFormatted == null && params.value == null) {
	                var localeTextFunc = this.gridOptionsWrapper.getLocaleTextFunc();
	                eTarget.innerText = '(' + localeTextFunc('blanks', 'Blanks') + ')';
	            }
	            else {
	                eTarget.innerText = params.valueFormatted != null ? params.valueFormatted : params.value;
	            }
	        }
	        return cellRendererPromise;
	    };
	    SetFilterListItem.prototype.init = function () {
	        var _this = this;
	        this.eCheckedIcon = ag_grid_community_1._.createIconNoSpan('checkboxChecked', this.gridOptionsWrapper, this.column);
	        this.eUncheckedIcon = ag_grid_community_1._.createIconNoSpan('checkboxUnchecked', this.gridOptionsWrapper, this.column);
	        this.eCheckbox = this.queryForHtmlElement(".ag-filter-checkbox");
	        this.eClickableArea = this.getGui();
	        this.updateCheckboxIcon();
	        this.render();
	        var listener = function (mouseEvent) {
	            mouseEvent.preventDefault();
	            ag_grid_community_1._.addAgGridEventPath(mouseEvent);
	            _this.selected = !_this.selected;
	            _this.updateCheckboxIcon();
	            var event = {
	                type: SetFilterListItem.EVENT_SELECTED
	            };
	            return _this.dispatchEvent(event);
	        };
	        this.addDestroyableEventListener(this.eClickableArea, 'click', listener);
	    };
	    SetFilterListItem.prototype.isSelected = function () {
	        return this.selected;
	    };
	    SetFilterListItem.prototype.setSelected = function (selected) {
	        this.selected = selected;
	        this.updateCheckboxIcon();
	    };
	    SetFilterListItem.prototype.updateCheckboxIcon = function () {
	        ag_grid_community_1._.clearElement(this.eCheckbox);
	        if (this.isSelected()) {
	            this.eCheckbox.appendChild(this.eCheckedIcon);
	        }
	        else {
	            this.eCheckbox.appendChild(this.eUncheckedIcon);
	        }
	    };
	    SetFilterListItem.prototype.render = function () {
	        var _this = this;
	        var valueElement = this.queryForHtmlElement(".ag-filter-value");
	        var valueFormatted = this.valueFormatterService.formatValue(this.column, null, null, this.value);
	        var colDef = this.column.getColDef();
	        var params = {
	            value: this.value,
	            valueFormatted: valueFormatted,
	            api: this.gridOptionsWrapper.getApi()
	        };
	        var componentPromise = this.useCellRenderer(colDef, valueElement, params);
	        if (!componentPromise) {
	            return;
	        }
	        componentPromise.then(function (component) {
	            if (component && component.destroy) {
	                _this.addDestroyFunc(component.destroy.bind(component));
	            }
	        });
	    };
	    SetFilterListItem.EVENT_SELECTED = 'selected';
	    SetFilterListItem.TEMPLATE = "<label class=\"ag-set-filter-item\">\n            <div class=\"ag-filter-checkbox\"></div>\n            <span class=\"ag-filter-value\"></span>\n        </label>";
	    __decorate([
	        ag_grid_community_1.Autowired('gridOptionsWrapper'),
	        __metadata("design:type", ag_grid_community_1.GridOptionsWrapper)
	    ], SetFilterListItem.prototype, "gridOptionsWrapper", void 0);
	    __decorate([
	        ag_grid_community_1.Autowired('valueFormatterService'),
	        __metadata("design:type", ag_grid_community_1.ValueFormatterService)
	    ], SetFilterListItem.prototype, "valueFormatterService", void 0);
	    __decorate([
	        ag_grid_community_1.Autowired('userComponentFactory'),
	        __metadata("design:type", ag_grid_community_1.UserComponentFactory)
	    ], SetFilterListItem.prototype, "userComponentFactory", void 0);
	    __decorate([
	        ag_grid_community_1.PostConstruct,
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", []),
	        __metadata("design:returntype", void 0)
	    ], SetFilterListItem.prototype, "init", null);
	    return SetFilterListItem;
	}(ag_grid_community_1.Component));
	exports.SetFilterListItem = SetFilterListItem;


/***/ }),
/* 2527 */
/***/ (function(module, exports, __webpack_require__) {

	// ag-grid-enterprise v21.2.2
	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var ag_grid_community_1 = __webpack_require__(2322);
	var VirtualList = /** @class */ (function (_super) {
	    __extends(VirtualList, _super);
	    function VirtualList() {
	        var _this = _super.call(this, undefined) || this;
	        _this.rowsInBodyContainer = {};
	        _this.rowHeight = 20;
	        return _this;
	    }
	    VirtualList.prototype.init = function () {
	        this.setTemplate(VirtualList.TEMPLATE);
	        this.eListContainer = this.queryForHtmlElement(".ag-virtual-list-container");
	        this.addScrollListener();
	        var item = document.createElement('div');
	        ag_grid_community_1._.addCssClass(item, 'ag-virtual-list-item');
	        this.rowHeight = this.getItemHeight();
	    };
	    VirtualList.prototype.getItemHeight = function () {
	        return this.gridOptionsWrapper.getVirtualItemHeight();
	    };
	    VirtualList.prototype.ensureIndexVisible = function (index) {
	        var lastRow = this.model.getRowCount();
	        if (typeof index !== 'number' || index < 0 || index >= lastRow) {
	            console.warn('invalid row index for ensureIndexVisible: ' + index);
	            return;
	        }
	        // let nodeAtIndex = this.rowModel.getRow(index);
	        var rowTopPixel = index * this.rowHeight;
	        var rowBottomPixel = rowTopPixel + this.rowHeight;
	        var viewportTopPixel = this.getGui().scrollTop;
	        var viewportHeight = this.getGui().offsetHeight;
	        var viewportBottomPixel = viewportTopPixel + viewportHeight;
	        var viewportScrolledPastRow = viewportTopPixel > rowTopPixel;
	        var viewportScrolledBeforeRow = viewportBottomPixel < rowBottomPixel;
	        if (viewportScrolledPastRow) {
	            // if row is before, scroll up with row at top
	            this.getGui().scrollTop = rowTopPixel;
	        }
	        else if (viewportScrolledBeforeRow) {
	            // if row is below, scroll down with row at bottom
	            var newScrollPosition = rowBottomPixel - viewportHeight;
	            this.getGui().scrollTop = newScrollPosition;
	        }
	    };
	    VirtualList.prototype.setComponentCreator = function (componentCreator) {
	        this.componentCreator = componentCreator;
	    };
	    VirtualList.prototype.getRowHeight = function () {
	        return this.rowHeight;
	    };
	    VirtualList.prototype.getScrollTop = function () {
	        return this.getGui().scrollTop;
	    };
	    VirtualList.prototype.setRowHeight = function (rowHeight) {
	        this.rowHeight = rowHeight;
	        this.refresh();
	    };
	    VirtualList.prototype.refresh = function () {
	        if (ag_grid_community_1._.missing(this.model)) {
	            return;
	        }
	        this.eListContainer.style.height = (this.model.getRowCount() * this.rowHeight) + "px";
	        this.clearVirtualRows();
	        this.drawVirtualRows();
	    };
	    VirtualList.prototype.clearVirtualRows = function () {
	        var rowsToRemove = Object.keys(this.rowsInBodyContainer);
	        this.removeVirtualRows(rowsToRemove);
	    };
	    VirtualList.prototype.drawVirtualRows = function () {
	        var topPixel = this.getGui().scrollTop;
	        var bottomPixel = topPixel + this.getGui().offsetHeight;
	        var firstRow = Math.floor(topPixel / this.rowHeight);
	        var lastRow = Math.floor(bottomPixel / this.rowHeight);
	        this.ensureRowsRendered(firstRow, lastRow);
	    };
	    VirtualList.prototype.ensureRowsRendered = function (start, finish) {
	        // at the end, this array will contain the items we need to remove
	        var rowsToRemove = Object.keys(this.rowsInBodyContainer);
	        // add in new rows
	        for (var rowIndex = start; rowIndex <= finish; rowIndex++) {
	            // see if item already there, and if yes, take it out of the 'to remove' array
	            if (rowsToRemove.indexOf(rowIndex.toString()) >= 0) {
	                rowsToRemove.splice(rowsToRemove.indexOf(rowIndex.toString()), 1);
	                continue;
	            }
	            // check this row actually exists (in case overflow buffer window exceeds real data)
	            if (this.model.getRowCount() > rowIndex) {
	                var value = this.model.getRow(rowIndex);
	                this.insertRow(value, rowIndex);
	            }
	        }
	        // at this point, everything in our 'rowsToRemove' . . .
	        this.removeVirtualRows(rowsToRemove);
	    };
	    // takes array of row id's
	    VirtualList.prototype.removeVirtualRows = function (rowsToRemove) {
	        var _this = this;
	        rowsToRemove.forEach(function (index) {
	            var component = _this.rowsInBodyContainer[index];
	            _this.eListContainer.removeChild(component.eDiv);
	            if (component.rowComponent.destroy) {
	                component.rowComponent.destroy();
	            }
	            delete _this.rowsInBodyContainer[index];
	        });
	    };
	    VirtualList.prototype.insertRow = function (value, rowIndex) {
	        var eDiv = document.createElement('div');
	        ag_grid_community_1._.addCssClass(eDiv, 'ag-virtual-list-item');
	        eDiv.style.top = (this.rowHeight * rowIndex) + "px";
	        var rowComponent = this.componentCreator(value);
	        eDiv.appendChild(rowComponent.getGui());
	        this.eListContainer.appendChild(eDiv);
	        this.rowsInBodyContainer[rowIndex] = {
	            rowComponent: rowComponent,
	            eDiv: eDiv
	        };
	    };
	    VirtualList.prototype.addScrollListener = function () {
	        var _this = this;
	        this.addGuiEventListener('scroll', function () {
	            _this.drawVirtualRows();
	        });
	    };
	    VirtualList.prototype.setModel = function (model) {
	        this.model = model;
	    };
	    VirtualList.TEMPLATE = "<div class=\"ag-virtual-list-viewport\">\n            <div class=\"ag-virtual-list-container\"></div>\n        </div>";
	    __decorate([
	        ag_grid_community_1.Autowired('environment'),
	        __metadata("design:type", ag_grid_community_1.Environment)
	    ], VirtualList.prototype, "environment", void 0);
	    __decorate([
	        ag_grid_community_1.Autowired('gridOptionsWrapper'),
	        __metadata("design:type", ag_grid_community_1.GridOptionsWrapper)
	    ], VirtualList.prototype, "gridOptionsWrapper", void 0);
	    __decorate([
	        ag_grid_community_1.PostConstruct,
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", []),
	        __metadata("design:returntype", void 0)
	    ], VirtualList.prototype, "init", null);
	    return VirtualList;
	}(ag_grid_community_1.Component));
	exports.VirtualList = VirtualList;


/***/ }),
/* 2528 */
/***/ (function(module, exports, __webpack_require__) {

	// ag-grid-enterprise v21.2.2
	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var ag_grid_community_1 = __webpack_require__(2322);
	var richSelectRow_1 = __webpack_require__(2529);
	var virtualList_1 = __webpack_require__(2527);
	var RichSelectCellEditor = /** @class */ (function (_super) {
	    __extends(RichSelectCellEditor, _super);
	    function RichSelectCellEditor() {
	        var _this = _super.call(this, RichSelectCellEditor.TEMPLATE) || this;
	        _this.selectionConfirmed = false;
	        _this.searchString = '';
	        return _this;
	    }
	    RichSelectCellEditor.prototype.init = function (params) {
	        this.params = params;
	        this.selectedValue = params.value;
	        this.originalSelectedValue = params.value;
	        this.focusAfterAttached = params.cellStartedEdit;
	        this.eValue.appendChild(ag_grid_community_1._.createIconNoSpan('smallDown', this.gridOptionsWrapper));
	        this.virtualList = new virtualList_1.VirtualList();
	        this.getContext().wireBean(this.virtualList);
	        this.virtualList.setComponentCreator(this.createRowComponent.bind(this));
	        this.eList.appendChild(this.virtualList.getGui());
	        if (ag_grid_community_1._.exists(this.params.cellHeight)) {
	            this.virtualList.setRowHeight(this.params.cellHeight);
	        }
	        this.renderSelectedValue();
	        if (ag_grid_community_1._.missing(params.values)) {
	            console.warn('ag-Grid: richSelectCellEditor requires values for it to work');
	            return;
	        }
	        var values = params.values;
	        this.virtualList.setModel({
	            getRowCount: function () { return values.length; },
	            getRow: function (index) { return values[index]; }
	        });
	        this.addGuiEventListener('keydown', this.onKeyDown.bind(this));
	        var virtualListGui = this.virtualList.getGui();
	        this.addDestroyableEventListener(virtualListGui, 'click', this.onClick.bind(this));
	        this.addDestroyableEventListener(virtualListGui, 'mousemove', this.onMouseMove.bind(this));
	        this.clearSearchString = ag_grid_community_1._.debounce(this.clearSearchString, 300);
	        if (ag_grid_community_1._.exists(params.charPress)) {
	            this.searchText(params.charPress);
	        }
	    };
	    RichSelectCellEditor.prototype.onKeyDown = function (event) {
	        var key = event.which || event.keyCode;
	        switch (key) {
	            case ag_grid_community_1.Constants.KEY_ENTER:
	                this.onEnterKeyDown();
	                break;
	            case ag_grid_community_1.Constants.KEY_DOWN:
	            case ag_grid_community_1.Constants.KEY_UP:
	                this.onNavigationKeyPressed(event, key);
	                break;
	            default:
	                this.searchText(event);
	        }
	    };
	    RichSelectCellEditor.prototype.onEnterKeyDown = function () {
	        this.selectionConfirmed = true;
	        this.params.stopEditing();
	    };
	    RichSelectCellEditor.prototype.onNavigationKeyPressed = function (event, key) {
	        // if we don't stop propagation, then the grids navigation kicks in
	        event.stopPropagation();
	        var oldIndex = this.params.values.indexOf(this.selectedValue);
	        var newIndex = key === ag_grid_community_1.Constants.KEY_UP ? oldIndex - 1 : oldIndex + 1;
	        if (newIndex >= 0 && newIndex < this.params.values.length) {
	            var valueToSelect = this.params.values[newIndex];
	            this.setSelectedValue(valueToSelect);
	        }
	    };
	    RichSelectCellEditor.prototype.searchText = function (key) {
	        if (typeof key !== 'string') {
	            if (!ag_grid_community_1._.isCharacterKey(key)) {
	                return;
	            }
	            key = key.key;
	        }
	        this.searchString += key;
	        this.runSearch();
	        this.clearSearchString();
	    };
	    RichSelectCellEditor.prototype.runSearch = function () {
	        var suggestions = ag_grid_community_1._.fuzzySuggestions(this.searchString, this.params.values, true, true);
	        if (!suggestions.length) {
	            return;
	        }
	        this.setSelectedValue(suggestions[0]);
	    };
	    RichSelectCellEditor.prototype.clearSearchString = function () {
	        this.searchString = '';
	    };
	    RichSelectCellEditor.prototype.renderSelectedValue = function () {
	        var _this = this;
	        var valueFormatted = this.params.formatValue(this.selectedValue);
	        var eValue = this.eValue;
	        var params = {
	            value: this.selectedValue,
	            valueFormatted: valueFormatted,
	            api: this.gridOptionsWrapper.getApi()
	        };
	        var promise = this.userComponentFactory.newCellRenderer(this.params, params);
	        if (promise != null) {
	            ag_grid_community_1._.bindCellRendererToHtmlElement(promise, eValue);
	        }
	        else {
	            eValue.innerText = params.valueFormatted != null ? params.valueFormatted : params.value;
	        }
	        if (promise) {
	            promise.then(function (renderer) {
	                if (renderer && renderer.destroy) {
	                    _this.addDestroyFunc(function () { return renderer.destroy(); });
	                }
	            });
	        }
	        else {
	            if (ag_grid_community_1._.exists(this.selectedValue)) {
	                eValue.innerHTML = valueFormatted;
	            }
	            else {
	                ag_grid_community_1._.clearElement(eValue);
	            }
	        }
	    };
	    RichSelectCellEditor.prototype.setSelectedValue = function (value) {
	        if (this.selectedValue === value) {
	            return;
	        }
	        var index = this.params.values.indexOf(value);
	        if (index >= 0) {
	            this.selectedValue = value;
	            this.virtualList.ensureIndexVisible(index);
	            this.virtualList.refresh();
	        }
	    };
	    RichSelectCellEditor.prototype.createRowComponent = function (value) {
	        var valueFormatted = this.params.formatValue(value);
	        var row = new richSelectRow_1.RichSelectRow(this.params);
	        this.getContext().wireBean(row);
	        row.setState(value, valueFormatted, value === this.selectedValue);
	        return row;
	    };
	    RichSelectCellEditor.prototype.onMouseMove = function (mouseEvent) {
	        var rect = this.virtualList.getGui().getBoundingClientRect();
	        var scrollTop = this.virtualList.getScrollTop();
	        var mouseY = mouseEvent.clientY - rect.top + scrollTop;
	        var row = Math.floor(mouseY / this.virtualList.getRowHeight());
	        var value = this.params.values[row];
	        // not using utils.exist() as want empty string test to pass
	        if (value !== undefined) {
	            this.setSelectedValue(value);
	        }
	    };
	    RichSelectCellEditor.prototype.onClick = function () {
	        this.selectionConfirmed = true;
	        this.params.stopEditing();
	    };
	    // we need to have the gui attached before we can draw the virtual rows, as the
	    // virtual row logic needs info about the gui state
	    RichSelectCellEditor.prototype.afterGuiAttached = function () {
	        var selectedIndex = this.params.values.indexOf(this.selectedValue);
	        // we have to call this here to get the list to have the right height, ie
	        // otherwise it would not have scrolls yet and ensureIndexVisible would do nothing
	        this.virtualList.refresh();
	        if (selectedIndex >= 0) {
	            this.virtualList.ensureIndexVisible(selectedIndex);
	        }
	        // we call refresh again, as the list could of moved, and we need to render the new rows
	        this.virtualList.refresh();
	        if (this.focusAfterAttached) {
	            this.getGui().focus();
	        }
	    };
	    RichSelectCellEditor.prototype.getValue = function () {
	        // NOTE: we don't use valueParser for Set Filter. The user should provide values that are to be
	        // set into the data. valueParser only really makese sense when the user is typing in text (not picking
	        // form a set).
	        return this.selectionConfirmed ? this.selectedValue : this.originalSelectedValue;
	    };
	    // tab index is needed so we can focus, which is needed for keyboard events
	    RichSelectCellEditor.TEMPLATE = "<div class=\"ag-rich-select\" tabindex=\"0\">\n            <div ref=\"eValue\" class=\"ag-rich-select-value\"></div>\n            <div ref=\"eList\" class=\"ag-rich-select-list\"></div>\n        </div>";
	    __decorate([
	        ag_grid_community_1.Autowired('userComponentFactory'),
	        __metadata("design:type", ag_grid_community_1.UserComponentFactory)
	    ], RichSelectCellEditor.prototype, "userComponentFactory", void 0);
	    __decorate([
	        ag_grid_community_1.Autowired('gridOptionsWrapper'),
	        __metadata("design:type", ag_grid_community_1.GridOptionsWrapper)
	    ], RichSelectCellEditor.prototype, "gridOptionsWrapper", void 0);
	    __decorate([
	        ag_grid_community_1.RefSelector('eValue'),
	        __metadata("design:type", HTMLElement)
	    ], RichSelectCellEditor.prototype, "eValue", void 0);
	    __decorate([
	        ag_grid_community_1.RefSelector('eList'),
	        __metadata("design:type", HTMLElement)
	    ], RichSelectCellEditor.prototype, "eList", void 0);
	    return RichSelectCellEditor;
	}(ag_grid_community_1.PopupComponent));
	exports.RichSelectCellEditor = RichSelectCellEditor;


/***/ }),
/* 2529 */
/***/ (function(module, exports, __webpack_require__) {

	// ag-grid-enterprise v21.2.2
	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var ag_grid_community_1 = __webpack_require__(2322);
	var RichSelectRow = /** @class */ (function (_super) {
	    __extends(RichSelectRow, _super);
	    function RichSelectRow(params) {
	        var _this = _super.call(this, '<div class="ag-rich-select-row"></div>') || this;
	        _this.params = params;
	        return _this;
	    }
	    RichSelectRow.prototype.setState = function (value, valueFormatted, selected) {
	        var rendererSuccessful = this.populateWithRenderer(value, valueFormatted);
	        if (!rendererSuccessful) {
	            this.populateWithoutRenderer(value, valueFormatted);
	        }
	        ag_grid_community_1._.addOrRemoveCssClass(this.getGui(), 'ag-rich-select-row-selected', selected);
	    };
	    RichSelectRow.prototype.populateWithoutRenderer = function (value, valueFormatted) {
	        var valueFormattedExits = valueFormatted !== null && valueFormatted !== undefined;
	        var valueToRender = valueFormattedExits ? valueFormatted : value;
	        if (ag_grid_community_1._.exists(valueToRender) && valueToRender !== '') {
	            // not using innerHTML to prevent injection of HTML
	            // https://developer.mozilla.org/en-US/docs/Web/API/Element/innerHTML#Security_considerations
	            this.getGui().textContent = valueToRender.toString();
	        }
	        else {
	            // putting in blank, so if missing, at least the user can click on it
	            this.getGui().innerHTML = '&nbsp;';
	        }
	    };
	    RichSelectRow.prototype.populateWithRenderer = function (value, valueFormatted) {
	        var _this = this;
	        // bad coder here - we are not populating all values of the cellRendererParams
	        var params = {
	            value: value,
	            valueFormatted: valueFormatted,
	            api: this.gridOptionsWrapper.getApi()
	        };
	        var cellRendererPromise = this.userComponentFactory.newCellRenderer(this.params, params);
	        if (cellRendererPromise != null) {
	            ag_grid_community_1._.bindCellRendererToHtmlElement(cellRendererPromise, this.getGui());
	        }
	        else {
	            this.getGui().innerText = params.valueFormatted != null ? params.valueFormatted : params.value;
	        }
	        if (cellRendererPromise) {
	            cellRendererPromise.then(function (childComponent) {
	                if (childComponent && childComponent.destroy) {
	                    _this.addDestroyFunc(childComponent.destroy.bind(childComponent));
	                }
	            });
	            return true;
	        }
	        return false;
	    };
	    __decorate([
	        ag_grid_community_1.Autowired('userComponentFactory'),
	        __metadata("design:type", ag_grid_community_1.UserComponentFactory)
	    ], RichSelectRow.prototype, "userComponentFactory", void 0);
	    __decorate([
	        ag_grid_community_1.Autowired('gridOptionsWrapper'),
	        __metadata("design:type", ag_grid_community_1.GridOptionsWrapper)
	    ], RichSelectRow.prototype, "gridOptionsWrapper", void 0);
	    return RichSelectRow;
	}(ag_grid_community_1.Component));
	exports.RichSelectRow = RichSelectRow;


/***/ }),
/* 2530 */
/***/ (function(module, exports, __webpack_require__) {

	// ag-grid-enterprise v21.2.2
	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var ag_grid_community_1 = __webpack_require__(2322);
	var md5_1 = __webpack_require__(2531);
	var LicenseManager = /** @class */ (function () {
	    function LicenseManager() {
	        this.watermarkMessage = undefined;
	    }
	    LicenseManager_1 = LicenseManager;
	    LicenseManager.prototype.validateLicense = function () {
	        if (ag_grid_community_1._.missingOrEmpty(LicenseManager_1.licenseKey)) {
	            this.outputMissingLicenseKey();
	        }
	        else if (!ag_grid_community_1._.missingOrEmpty(LicenseManager_1.licenseKey) && LicenseManager_1.licenseKey.length > 32) {
	            var _a = LicenseManager_1.extractLicenseComponents(LicenseManager_1.licenseKey), md5 = _a.md5, license = _a.license, version = _a.version, isTrial = _a.isTrial;
	            if (md5 === this.md5.md5(license)) {
	                if (ag_grid_community_1._.exists(version) && version) {
	                    this.validateLicenseKeyForVersion(version, !!isTrial, license);
	                }
	                else {
	                    this.validateLegacyKey(license);
	                }
	            }
	            else {
	                this.outputInvalidLicenseKey();
	            }
	        }
	    };
	    LicenseManager.extractExpiry = function (license) {
	        var restrictionHashed = license.substring(license.lastIndexOf('_') + 1, license.length);
	        return new Date(parseInt(LicenseManager_1.decode(restrictionHashed), 10));
	    };
	    LicenseManager.extractLicenseComponents = function (licenseKey) {
	        var hashStart = licenseKey.length - 32;
	        var md5 = licenseKey.substring(hashStart);
	        var license = licenseKey.substring(0, hashStart);
	        var _a = LicenseManager_1.extractBracketedInformation(licenseKey), version = _a[0], isTrial = _a[1];
	        return { md5: md5, license: license, version: version, isTrial: isTrial };
	    };
	    LicenseManager.prototype.getLicenseDetails = function (licenseKey) {
	        var _a = LicenseManager_1.extractLicenseComponents(licenseKey), md5 = _a.md5, license = _a.license, version = _a.version, isTrial = _a.isTrial;
	        var valid = (md5 === this.md5.md5(license));
	        var expiry = null;
	        if (valid) {
	            expiry = LicenseManager_1.extractExpiry(license);
	            valid = !isNaN(expiry.getTime());
	        }
	        return {
	            licenseKey: licenseKey,
	            valid: valid,
	            expiry: valid ? LicenseManager_1.formatDate(expiry) : null,
	            version: version ? version : 'legacy',
	            isTrial: isTrial
	        };
	    };
	    LicenseManager.prototype.isDisplayWatermark = function () {
	        return !ag_grid_community_1._.missingOrEmpty(this.watermarkMessage);
	    };
	    LicenseManager.prototype.getWatermarkMessage = function () {
	        return this.watermarkMessage;
	    };
	    LicenseManager.formatDate = function (date) {
	        var monthNames = [
	            'January', 'February', 'March',
	            'April', 'May', 'June', 'July',
	            'August', 'September', 'October',
	            'November', 'December'
	        ];
	        var day = date.getDate();
	        var monthIndex = date.getMonth();
	        var year = date.getFullYear();
	        return day + ' ' + monthNames[monthIndex] + ' ' + year;
	    };
	    LicenseManager.getGridReleaseDate = function () {
	        return new Date(parseInt(LicenseManager_1.decode(LicenseManager_1.RELEASE_INFORMATION), 10));
	    };
	    LicenseManager.decode = function (input) {
	        var keystr = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
	        var t = '';
	        var n, r, i;
	        var s, o, u, a;
	        var f = 0;
	        var e = input.replace(/[^A-Za-z0-9+/=]/g, '');
	        while (f < e.length) {
	            s = keystr.indexOf(e.charAt(f++));
	            o = keystr.indexOf(e.charAt(f++));
	            u = keystr.indexOf(e.charAt(f++));
	            a = keystr.indexOf(e.charAt(f++));
	            n = s << 2 | o >> 4;
	            r = (o & 15) << 4 | u >> 2;
	            i = (u & 3) << 6 | a;
	            t = t + String.fromCharCode(n);
	            if (u != 64) {
	                t = t + String.fromCharCode(r);
	            }
	            if (a != 64) {
	                t = t + String.fromCharCode(i);
	            }
	        }
	        t = LicenseManager_1.utf8_decode(t);
	        return t;
	    };
	    LicenseManager.utf8_decode = function (input) {
	        input = input.replace(/rn/g, 'n');
	        var t = '';
	        for (var n = 0; n < input.length; n++) {
	            var r = input.charCodeAt(n);
	            if (r < 128) {
	                t += String.fromCharCode(r);
	            }
	            else if (r > 127 && r < 2048) {
	                t += String.fromCharCode(r >> 6 | 192);
	                t += String.fromCharCode(r & 63 | 128);
	            }
	            else {
	                t += String.fromCharCode(r >> 12 | 224);
	                t += String.fromCharCode(r >> 6 & 63 | 128);
	                t += String.fromCharCode(r & 63 | 128);
	            }
	        }
	        return t;
	    };
	    LicenseManager.setLicenseKey = function (licenseKey) {
	        LicenseManager_1.licenseKey = licenseKey;
	    };
	    LicenseManager.extractBracketedInformation = function (licenseKey) {
	        var matches = licenseKey.split('[')
	            .filter(function (v) {
	            return v.indexOf(']') > -1;
	        })
	            .map(function (value) {
	            return value.split(']')[0];
	        });
	        if (!matches || matches.length === 0) {
	            return [null, null];
	        }
	        var isTrial = matches.filter(function (match) { return match === 'TRIAL'; }).length === 1;
	        var version = matches.filter(function (match) { return match.indexOf("v") === 0; }).map(function (match) { return match.replace(/^v/, ""); })[0];
	        return [version, isTrial];
	    };
	    LicenseManager.prototype.validateLicenseKeyForVersion = function (version, isTrial, license) {
	        switch (version) {
	            case "2":
	                if (isTrial) {
	                    this.validateForTrial(license);
	                }
	                else {
	                    this.validateLegacyKey(license);
	                }
	                break;
	        }
	    };
	    LicenseManager.prototype.validateLegacyKey = function (license) {
	        var gridReleaseDate = LicenseManager_1.getGridReleaseDate();
	        var expiry = LicenseManager_1.extractExpiry(license);
	        var valid = false;
	        var current = false;
	        if (!isNaN(expiry.getTime())) {
	            valid = true;
	            current = (gridReleaseDate < expiry);
	        }
	        if (!valid) {
	            this.outputInvalidLicenseKey();
	        }
	        else if (!current) {
	            var formattedExpiryDate = LicenseManager_1.formatDate(expiry);
	            var formattedReleaseDate = LicenseManager_1.formatDate(gridReleaseDate);
	            this.outputIncompatibleVersion(formattedExpiryDate, formattedReleaseDate);
	        }
	    };
	    LicenseManager.prototype.validateForTrial = function (license) {
	        var expiry = LicenseManager_1.extractExpiry(license);
	        var now = new Date();
	        var valid = false;
	        var current = false;
	        if (!isNaN(expiry.getTime())) {
	            valid = true;
	            current = (expiry > now);
	        }
	        if (!valid) {
	            this.outputInvalidLicenseKey();
	        }
	        else if (!current) {
	            var formattedExpiryDate = LicenseManager_1.formatDate(expiry);
	            this.outputExpiredTrialKey(formattedExpiryDate);
	        }
	    };
	    LicenseManager.prototype.outputInvalidLicenseKey = function () {
	        console.error('*****************************************************************************************************************');
	        console.error('***************************************** ag-Grid Enterprise License ********************************************');
	        console.error('********************************************* Invalid License ***************************************************');
	        console.error('* Your license for ag-Grid Enterprise is not valid - please contact info@ag-grid.com to obtain a valid license. *');
	        console.error('*****************************************************************************************************************');
	        console.error('*****************************************************************************************************************');
	        this.watermarkMessage = "Invalid License";
	    };
	    LicenseManager.prototype.outputExpiredTrialKey = function (formattedExpiryDate) {
	        console.error('****************************************************************************************************************');
	        console.error('***************************************** ag-Grid Enterprise License *******************************************');
	        console.error('*****************************************   Trial Period Expired.    *******************************************');
	        console.error("* Your license for ag-Grid Enterprise expired on " + formattedExpiryDate + ".                                                *");
	        console.error('* Please email info@ag-grid.com to purchase a license.                                                         *');
	        console.error('****************************************************************************************************************');
	        console.error('****************************************************************************************************************');
	        this.watermarkMessage = "Trial Period Expired";
	    };
	    LicenseManager.prototype.outputMissingLicenseKey = function () {
	        console.error('****************************************************************************************************************');
	        console.error('***************************************** ag-Grid Enterprise License *******************************************');
	        console.error('****************************************** License Key Not Found ***********************************************');
	        console.error('* All ag-Grid Enterprise features are unlocked.                                                                *');
	        console.error('* This is an evaluation only version, it is not licensed for development projects intended for production.     *');
	        console.error('* If you want to hide the watermark, please email info@ag-grid.com for a trial license.                        *');
	        console.error('****************************************************************************************************************');
	        console.error('****************************************************************************************************************');
	        this.watermarkMessage = "For Trial Use Only";
	    };
	    LicenseManager.prototype.outputIncompatibleVersion = function (formattedExpiryDate, formattedReleaseDate) {
	        console.error('****************************************************************************************************************************');
	        console.error('********************************************* ag-Grid Enterprise License ***************************************************');
	        console.error('*************************** License not compatible with installed version of ag-Grid Enterprise. ***************************');
	        console.error("* Your license for ag-Grid Enterprise expired on " + formattedExpiryDate + " but the version installed was released on " + formattedReleaseDate + ". *");
	        console.error('* Please contact info@ag-grid.com to renew your subscription to new versions.                                              *');
	        console.error('****************************************************************************************************************************');
	        console.error('****************************************************************************************************************************');
	        this.watermarkMessage = "Incompatible License Version";
	    };
	    var LicenseManager_1;
	    LicenseManager.RELEASE_INFORMATION = 'MTU2OTUwNzQ0NTUxNw==';
	    __decorate([
	        ag_grid_community_1.Autowired('md5'),
	        __metadata("design:type", md5_1.MD5)
	    ], LicenseManager.prototype, "md5", void 0);
	    __decorate([
	        ag_grid_community_1.PreConstruct,
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", []),
	        __metadata("design:returntype", void 0)
	    ], LicenseManager.prototype, "validateLicense", null);
	    LicenseManager = LicenseManager_1 = __decorate([
	        ag_grid_community_1.Bean('licenseManager')
	    ], LicenseManager);
	    return LicenseManager;
	}());
	exports.LicenseManager = LicenseManager;


/***/ }),
/* 2531 */
/***/ (function(module, exports, __webpack_require__) {

	// ag-grid-enterprise v21.2.2
	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var ag_grid_community_1 = __webpack_require__(2322);
	var MD5 = /** @class */ (function () {
	    function MD5() {
	        this.ieCompatibility = false;
	    }
	    MD5.prototype.init = function () {
	        this.ieCompatibility = (this.md5('hello') != '5d41402abc4b2a76b9719d911017c592');
	    };
	    MD5.prototype.md5cycle = function (x, k) {
	        var a = x[0], b = x[1], c = x[2], d = x[3];
	        a = this.ff(a, b, c, d, k[0], 7, -680876936);
	        d = this.ff(d, a, b, c, k[1], 12, -389564586);
	        c = this.ff(c, d, a, b, k[2], 17, 606105819);
	        b = this.ff(b, c, d, a, k[3], 22, -1044525330);
	        a = this.ff(a, b, c, d, k[4], 7, -176418897);
	        d = this.ff(d, a, b, c, k[5], 12, 1200080426);
	        c = this.ff(c, d, a, b, k[6], 17, -1473231341);
	        b = this.ff(b, c, d, a, k[7], 22, -45705983);
	        a = this.ff(a, b, c, d, k[8], 7, 1770035416);
	        d = this.ff(d, a, b, c, k[9], 12, -1958414417);
	        c = this.ff(c, d, a, b, k[10], 17, -42063);
	        b = this.ff(b, c, d, a, k[11], 22, -1990404162);
	        a = this.ff(a, b, c, d, k[12], 7, 1804603682);
	        d = this.ff(d, a, b, c, k[13], 12, -40341101);
	        c = this.ff(c, d, a, b, k[14], 17, -1502002290);
	        b = this.ff(b, c, d, a, k[15], 22, 1236535329);
	        a = this.gg(a, b, c, d, k[1], 5, -165796510);
	        d = this.gg(d, a, b, c, k[6], 9, -1069501632);
	        c = this.gg(c, d, a, b, k[11], 14, 643717713);
	        b = this.gg(b, c, d, a, k[0], 20, -373897302);
	        a = this.gg(a, b, c, d, k[5], 5, -701558691);
	        d = this.gg(d, a, b, c, k[10], 9, 38016083);
	        c = this.gg(c, d, a, b, k[15], 14, -660478335);
	        b = this.gg(b, c, d, a, k[4], 20, -405537848);
	        a = this.gg(a, b, c, d, k[9], 5, 568446438);
	        d = this.gg(d, a, b, c, k[14], 9, -1019803690);
	        c = this.gg(c, d, a, b, k[3], 14, -187363961);
	        b = this.gg(b, c, d, a, k[8], 20, 1163531501);
	        a = this.gg(a, b, c, d, k[13], 5, -1444681467);
	        d = this.gg(d, a, b, c, k[2], 9, -51403784);
	        c = this.gg(c, d, a, b, k[7], 14, 1735328473);
	        b = this.gg(b, c, d, a, k[12], 20, -1926607734);
	        a = this.hh(a, b, c, d, k[5], 4, -378558);
	        d = this.hh(d, a, b, c, k[8], 11, -2022574463);
	        c = this.hh(c, d, a, b, k[11], 16, 1839030562);
	        b = this.hh(b, c, d, a, k[14], 23, -35309556);
	        a = this.hh(a, b, c, d, k[1], 4, -1530992060);
	        d = this.hh(d, a, b, c, k[4], 11, 1272893353);
	        c = this.hh(c, d, a, b, k[7], 16, -155497632);
	        b = this.hh(b, c, d, a, k[10], 23, -1094730640);
	        a = this.hh(a, b, c, d, k[13], 4, 681279174);
	        d = this.hh(d, a, b, c, k[0], 11, -358537222);
	        c = this.hh(c, d, a, b, k[3], 16, -722521979);
	        b = this.hh(b, c, d, a, k[6], 23, 76029189);
	        a = this.hh(a, b, c, d, k[9], 4, -640364487);
	        d = this.hh(d, a, b, c, k[12], 11, -421815835);
	        c = this.hh(c, d, a, b, k[15], 16, 530742520);
	        b = this.hh(b, c, d, a, k[2], 23, -995338651);
	        a = this.ii(a, b, c, d, k[0], 6, -198630844);
	        d = this.ii(d, a, b, c, k[7], 10, 1126891415);
	        c = this.ii(c, d, a, b, k[14], 15, -1416354905);
	        b = this.ii(b, c, d, a, k[5], 21, -57434055);
	        a = this.ii(a, b, c, d, k[12], 6, 1700485571);
	        d = this.ii(d, a, b, c, k[3], 10, -1894986606);
	        c = this.ii(c, d, a, b, k[10], 15, -1051523);
	        b = this.ii(b, c, d, a, k[1], 21, -2054922799);
	        a = this.ii(a, b, c, d, k[8], 6, 1873313359);
	        d = this.ii(d, a, b, c, k[15], 10, -30611744);
	        c = this.ii(c, d, a, b, k[6], 15, -1560198380);
	        b = this.ii(b, c, d, a, k[13], 21, 1309151649);
	        a = this.ii(a, b, c, d, k[4], 6, -145523070);
	        d = this.ii(d, a, b, c, k[11], 10, -1120210379);
	        c = this.ii(c, d, a, b, k[2], 15, 718787259);
	        b = this.ii(b, c, d, a, k[9], 21, -343485551);
	        x[0] = this.add32(a, x[0]);
	        x[1] = this.add32(b, x[1]);
	        x[2] = this.add32(c, x[2]);
	        x[3] = this.add32(d, x[3]);
	    };
	    MD5.prototype.cmn = function (q, a, b, x, s, t) {
	        a = this.add32(this.add32(a, q), this.add32(x, t));
	        return this.add32((a << s) | (a >>> (32 - s)), b);
	    };
	    MD5.prototype.ff = function (a, b, c, d, x, s, t) {
	        return this.cmn((b & c) | ((~b) & d), a, b, x, s, t);
	    };
	    MD5.prototype.gg = function (a, b, c, d, x, s, t) {
	        return this.cmn((b & d) | (c & (~d)), a, b, x, s, t);
	    };
	    MD5.prototype.hh = function (a, b, c, d, x, s, t) {
	        return this.cmn(b ^ c ^ d, a, b, x, s, t);
	    };
	    MD5.prototype.ii = function (a, b, c, d, x, s, t) {
	        return this.cmn(c ^ (b | (~d)), a, b, x, s, t);
	    };
	    MD5.prototype.md51 = function (s) {
	        var n = s.length;
	        var state = [1732584193, -271733879, -1732584194, 271733878];
	        var i;
	        for (i = 64; i <= s.length; i += 64) {
	            this.md5cycle(state, this.md5blk(s.substring(i - 64, i)));
	        }
	        s = s.substring(i - 64);
	        var tail = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
	        for (i = 0; i < s.length; i++) {
	            tail[i >> 2] |= s.charCodeAt(i) << ((i % 4) << 3);
	        }
	        tail[i >> 2] |= 0x80 << ((i % 4) << 3);
	        if (i > 55) {
	            this.md5cycle(state, tail);
	            for (i = 0; i < 16; i++) {
	                tail[i] = 0;
	            }
	        }
	        tail[14] = n * 8;
	        this.md5cycle(state, tail);
	        return state;
	    };
	    /* there needs to be support for Unicode here, * unless we pretend that we can redefine the MD-5
	     * algorithm for multi-byte characters (perhaps by adding every four 16-bit characters and
	     * shortening the sum to 32 bits). Otherwise I suthis.ggest performing MD-5 as if every character
	     * was two bytes--e.g., 0040 0025 = @%--but then how will an ordinary MD-5 sum be matched?
	     * There is no way to standardize text to something like UTF-8 before transformation; speed cost is
	     * utterly prohibitive. The JavaScript standard itself needs to look at this: it should start
	     * providing access to strings as preformed UTF-8 8-bit unsigned value arrays.
	     */
	    MD5.prototype.md5blk = function (s) {
	        var md5blks = [];
	        /* Andy King said do it this way. */
	        for (var i = 0; i < 64; i += 4) {
	            md5blks[i >> 2] = s.charCodeAt(i)
	                + (s.charCodeAt(i + 1) << 8)
	                + (s.charCodeAt(i + 2) << 16)
	                + (s.charCodeAt(i + 3) << 24);
	        }
	        return md5blks;
	    };
	    MD5.prototype.rhex = function (n) {
	        var hex_chr = '0123456789abcdef'.split('');
	        var s = '', j = 0;
	        for (; j < 4; j++) {
	            s += hex_chr[(n >> (j * 8 + 4)) & 0x0F]
	                + hex_chr[(n >> (j * 8)) & 0x0F];
	        }
	        return s;
	    };
	    MD5.prototype.hex = function (x) {
	        for (var i = 0; i < x.length; i++) {
	            x[i] = this.rhex(x[i]);
	        }
	        return x.join('');
	    };
	    MD5.prototype.md5 = function (s) {
	        return this.hex(this.md51(s));
	    };
	    MD5.prototype.add32 = function (a, b) {
	        return this.ieCompatibility ? this.add32Compat(a, b) : this.add32Std(a, b);
	    };
	    /* this function is much faster, so if possible we use it. Some IEs are the only ones I know of that
	     need the idiotic second function, generated by an if clause.  */
	    MD5.prototype.add32Std = function (a, b) {
	        return (a + b) & 0xFFFFFFFF;
	    };
	    MD5.prototype.add32Compat = function (x, y) {
	        var lsw = (x & 0xFFFF) + (y & 0xFFFF), msw = (x >> 16) + (y >> 16) + (lsw >> 16);
	        return (msw << 16) | (lsw & 0xFFFF);
	    };
	    __decorate([
	        ag_grid_community_1.PostConstruct,
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", []),
	        __metadata("design:returntype", void 0)
	    ], MD5.prototype, "init", null);
	    MD5 = __decorate([
	        ag_grid_community_1.Bean('md5')
	    ], MD5);
	    return MD5;
	}());
	exports.MD5 = MD5;


/***/ }),
/* 2532 */
/***/ (function(module, exports, __webpack_require__) {

	// ag-grid-enterprise v21.2.2
	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var ag_grid_community_1 = __webpack_require__(2322);
	var DetailCellRenderer = /** @class */ (function (_super) {
	    __extends(DetailCellRenderer, _super);
	    function DetailCellRenderer() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.needRefresh = false;
	        return _this;
	    }
	    DetailCellRenderer.prototype.refresh = function () {
	        // if we return true, it means we pretend to the grid
	        // that we have refreshed, so refresh will never happen.
	        if (this.suppressRefresh) {
	            return true;
	        }
	        // otherwise we only refresh if the data has changed in the node
	        // since the last time. this happens when user updates data using transaction.
	        var res = !this.needRefresh;
	        this.needRefresh = false;
	        return res;
	    };
	    DetailCellRenderer.prototype.init = function (params) {
	        var _this = this;
	        this.rowId = params.node.id;
	        this.masterGridApi = params.api;
	        this.suppressRefresh = params.suppressRefresh;
	        this.selectAndSetTemplate(params);
	        if (ag_grid_community_1._.exists(this.eDetailGrid)) {
	            this.addThemeToDetailGrid();
	            this.createDetailsGrid(params);
	            this.registerDetailWithMaster(params.node);
	            this.loadRowData(params);
	            window.setTimeout(function () {
	                // ensure detail grid api still exists (grid may be destroyed when async call tries to set data)
	                if (_this.detailGridOptions.api) {
	                    _this.detailGridOptions.api.doLayout();
	                }
	            }, 0);
	        }
	        else {
	            console.warn('ag-Grid: reference to eDetailGrid was missing from the details template. ' +
	                'Please add ref="eDetailGrid" to the template.');
	        }
	        this.addDestroyableEventListener(params.node.parent, ag_grid_community_1.RowNode.EVENT_DATA_CHANGED, function () {
	            _this.needRefresh = true;
	        });
	    };
	    DetailCellRenderer.prototype.addThemeToDetailGrid = function () {
	        // this is needed by environment service of the child grid, the class needs to be on
	        // the grid div itself - the browser's CSS on the other hand just inherits from the parent grid theme.
	        var theme = this.environment.getTheme().theme;
	        if (theme) {
	            ag_grid_community_1._.addCssClass(this.eDetailGrid, theme);
	        }
	    };
	    DetailCellRenderer.prototype.registerDetailWithMaster = function (rowNode) {
	        var _this = this;
	        var gridInfo = {
	            id: this.rowId,
	            api: this.detailGridOptions.api,
	            columnApi: this.detailGridOptions.columnApi
	        };
	        // register with api
	        this.masterGridApi.addDetailGridInfo(this.rowId, gridInfo);
	        // register with node
	        rowNode.detailGridInfo = gridInfo;
	        this.addDestroyFunc(function () {
	            _this.masterGridApi.removeDetailGridInfo(_this.rowId); // unregister from api
	            rowNode.detailGridInfo = null; // unregister from node
	        });
	    };
	    DetailCellRenderer.prototype.selectAndSetTemplate = function (params) {
	        var paramsAny = params;
	        if (ag_grid_community_1._.missing(paramsAny.template)) {
	            // use default template
	            this.setTemplate(DetailCellRenderer.TEMPLATE);
	        }
	        else {
	            // use user provided template
	            if (typeof paramsAny.template === 'string') {
	                this.setTemplate(paramsAny.template);
	            }
	            else if (typeof paramsAny.template === 'function') {
	                var templateFunc = paramsAny.template;
	                var template = templateFunc(params);
	                this.setTemplate(template);
	            }
	            else {
	                console.warn('ag-Grid: detailCellRendererParams.template should be function or string');
	                this.setTemplate(DetailCellRenderer.TEMPLATE);
	            }
	        }
	    };
	    DetailCellRenderer.prototype.createDetailsGrid = function (params) {
	        // we clone the detail grid options, as otherwise it would be shared
	        // across many instances, and that would be a problem because we set
	        // api and columnApi into gridOptions
	        var _this = this;
	        var gridOptions = params.detailGridOptions;
	        if (ag_grid_community_1._.missing(gridOptions)) {
	            console.warn('ag-Grid: could not find detail grid options for master detail, ' +
	                'please set gridOptions.detailCellRendererParams.detailGridOptions');
	        }
	        // IMPORTANT - gridOptions must be cloned
	        this.detailGridOptions = ag_grid_community_1._.cloneObject(gridOptions);
	        // tslint:disable-next-line
	        new ag_grid_community_1.Grid(this.eDetailGrid, this.detailGridOptions, {
	            $scope: params.$scope,
	            $compile: params.$compile,
	            seedBeanInstances: {
	                // a temporary fix for AG-1574
	                // AG-1715 raised to do a wider ranging refactor to improve this
	                agGridReact: params.agGridReact,
	                // AG-1716 - directly related to AG-1574 and AG-1715
	                frameworkComponentWrapper: params.frameworkComponentWrapper
	            }
	        });
	        this.addDestroyFunc(function () {
	            if (_this.detailGridOptions.api) {
	                _this.detailGridOptions.api.destroy();
	            }
	        });
	    };
	    DetailCellRenderer.prototype.loadRowData = function (params) {
	        var userFunc = params.getDetailRowData;
	        if (!userFunc) {
	            console.warn('ag-Grid: could not find getDetailRowData for master / detail, ' +
	                'please set gridOptions.detailCellRendererParams.getDetailRowData');
	            return;
	        }
	        var funcParams = {
	            node: params.node,
	            data: params.data,
	            successCallback: this.setRowData.bind(this)
	        };
	        userFunc(funcParams);
	    };
	    DetailCellRenderer.prototype.setRowData = function (rowData) {
	        // ensure detail grid api still exists (grid may be destroyed when async call tries to set data)
	        if (this.detailGridOptions.api) {
	            this.detailGridOptions.api.setRowData(rowData);
	        }
	    };
	    DetailCellRenderer.TEMPLATE = "<div class=\"ag-details-row\">\n            <div ref=\"eDetailGrid\" class=\"ag-details-grid\"/>\n        </div>";
	    __decorate([
	        ag_grid_community_1.RefSelector('eDetailGrid'),
	        __metadata("design:type", HTMLElement)
	    ], DetailCellRenderer.prototype, "eDetailGrid", void 0);
	    __decorate([
	        ag_grid_community_1.Autowired('gridOptionsWrapper'),
	        __metadata("design:type", ag_grid_community_1.GridOptionsWrapper)
	    ], DetailCellRenderer.prototype, "gridOptionsWrapper", void 0);
	    __decorate([
	        ag_grid_community_1.Autowired('environment'),
	        __metadata("design:type", ag_grid_community_1.Environment)
	    ], DetailCellRenderer.prototype, "environment", void 0);
	    return DetailCellRenderer;
	}(ag_grid_community_1.Component));
	exports.DetailCellRenderer = DetailCellRenderer;


/***/ }),
/* 2533 */
/***/ (function(module, exports, __webpack_require__) {

	// ag-grid-enterprise v21.2.2
	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var ag_grid_community_1 = __webpack_require__(2322);
	var nameValueComp_1 = __webpack_require__(2534);
	var TotalRowsComp = /** @class */ (function (_super) {
	    __extends(TotalRowsComp, _super);
	    function TotalRowsComp() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    TotalRowsComp.prototype.postConstruct = function () {
	        this.setLabel('totalRows', 'Total Rows');
	        // this component is only really useful with client side row model
	        if (this.gridApi.getModel().getType() !== 'clientSide') {
	            console.warn("ag-Grid: agTotalRowCountComponent should only be used with the client side row model.");
	            return;
	        }
	        this.addCssClass('ag-status-panel');
	        this.addCssClass('ag-status-panel-total-row-count');
	        this.setDisplayed(true);
	        var listener = this.onDataChanged.bind(this);
	        this.eventService.addEventListener(ag_grid_community_1.Events.EVENT_MODEL_UPDATED, listener);
	    };
	    TotalRowsComp.prototype.onDataChanged = function () {
	        this.setValue(this.getRowCountValue());
	    };
	    TotalRowsComp.prototype.getRowCountValue = function () {
	        var totalRowCount = 0;
	        this.gridApi.forEachLeafNode(function (node) { return totalRowCount += 1; });
	        return "" + totalRowCount;
	    };
	    TotalRowsComp.prototype.init = function () {
	    };
	    __decorate([
	        ag_grid_community_1.Autowired('eventService'),
	        __metadata("design:type", ag_grid_community_1.EventService)
	    ], TotalRowsComp.prototype, "eventService", void 0);
	    __decorate([
	        ag_grid_community_1.Autowired('gridApi'),
	        __metadata("design:type", ag_grid_community_1.GridApi)
	    ], TotalRowsComp.prototype, "gridApi", void 0);
	    __decorate([
	        ag_grid_community_1.PostConstruct,
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", []),
	        __metadata("design:returntype", void 0)
	    ], TotalRowsComp.prototype, "postConstruct", null);
	    return TotalRowsComp;
	}(nameValueComp_1.NameValueComp));
	exports.TotalRowsComp = TotalRowsComp;


/***/ }),
/* 2534 */
/***/ (function(module, exports, __webpack_require__) {

	// ag-grid-enterprise v21.2.2
	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var ag_grid_community_1 = __webpack_require__(2322);
	var NameValueComp = /** @class */ (function (_super) {
	    __extends(NameValueComp, _super);
	    function NameValueComp() {
	        return _super.call(this, NameValueComp.TEMPLATE) || this;
	    }
	    NameValueComp.prototype.setLabel = function (key, defaultValue) {
	        // we want to hide until the first value comes in
	        this.setDisplayed(false);
	        var localeTextFunc = this.gridOptionsWrapper.getLocaleTextFunc();
	        this.eLabel.innerHTML = localeTextFunc(key, defaultValue);
	    };
	    NameValueComp.prototype.setValue = function (value) {
	        this.eValue.innerHTML = value;
	    };
	    NameValueComp.TEMPLATE = "<div class=\"ag-name-value\">  \n            <span ref=\"eLabel\"></span>:&nbsp;\n            <span ref=\"eValue\" class=\"ag-name-value-value\"></span>\n        </div>";
	    __decorate([
	        ag_grid_community_1.Autowired('gridOptionsWrapper'),
	        __metadata("design:type", ag_grid_community_1.GridOptionsWrapper)
	    ], NameValueComp.prototype, "gridOptionsWrapper", void 0);
	    __decorate([
	        ag_grid_community_1.RefSelector('eLabel'),
	        __metadata("design:type", HTMLElement)
	    ], NameValueComp.prototype, "eLabel", void 0);
	    __decorate([
	        ag_grid_community_1.RefSelector('eValue'),
	        __metadata("design:type", HTMLElement)
	    ], NameValueComp.prototype, "eValue", void 0);
	    return NameValueComp;
	}(ag_grid_community_1.Component));
	exports.NameValueComp = NameValueComp;


/***/ }),
/* 2535 */
/***/ (function(module, exports, __webpack_require__) {

	// ag-grid-enterprise v21.2.2
	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var ag_grid_community_1 = __webpack_require__(2322);
	var nameValueComp_1 = __webpack_require__(2534);
	var TotalAndFilteredRowsComp = /** @class */ (function (_super) {
	    __extends(TotalAndFilteredRowsComp, _super);
	    function TotalAndFilteredRowsComp() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    TotalAndFilteredRowsComp.prototype.postConstruct = function () {
	        // this component is only really useful with client side row model
	        if (this.gridApi.getModel().getType() !== 'clientSide') {
	            console.warn("ag-Grid: agTotalAndFilteredRowCountComponent should only be used with the client side row model.");
	            return;
	        }
	        this.setLabel('totalAndFilteredRows', 'Rows');
	        this.addCssClass('ag-status-panel');
	        this.addCssClass('ag-status-panel-total-and-filtered-row-count');
	        this.setDisplayed(true);
	        this.addDestroyableEventListener(this.eventService, ag_grid_community_1.Events.EVENT_MODEL_UPDATED, this.onDataChanged.bind(this));
	    };
	    TotalAndFilteredRowsComp.prototype.onDataChanged = function () {
	        var rowCount = this.getFilteredRowCountValue();
	        var totalRowCount = this.getTotalRowCount();
	        if (rowCount === totalRowCount) {
	            this.setValue(rowCount);
	        }
	        else {
	            var localeTextFunc = this.gridOptionsWrapper.getLocaleTextFunc();
	            this.setValue(rowCount + " " + localeTextFunc('of', 'of') + " " + totalRowCount);
	        }
	    };
	    TotalAndFilteredRowsComp.prototype.getFilteredRowCountValue = function () {
	        var filteredRowCount = 0;
	        this.gridApi.forEachNodeAfterFilter(function (node) {
	            if (!node.group) {
	                filteredRowCount++;
	            }
	        });
	        return filteredRowCount;
	    };
	    TotalAndFilteredRowsComp.prototype.getTotalRowCount = function () {
	        var totalRowCount = 0;
	        this.gridApi.forEachNode(function (node) {
	            if (!node.group) {
	                totalRowCount++;
	            }
	        });
	        return totalRowCount;
	    };
	    TotalAndFilteredRowsComp.prototype.init = function () { };
	    __decorate([
	        ag_grid_community_1.Autowired('gridApi'),
	        __metadata("design:type", ag_grid_community_1.GridApi)
	    ], TotalAndFilteredRowsComp.prototype, "gridApi", void 0);
	    __decorate([
	        ag_grid_community_1.Autowired('eventService'),
	        __metadata("design:type", ag_grid_community_1.EventService)
	    ], TotalAndFilteredRowsComp.prototype, "eventService", void 0);
	    __decorate([
	        ag_grid_community_1.PostConstruct,
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", []),
	        __metadata("design:returntype", void 0)
	    ], TotalAndFilteredRowsComp.prototype, "postConstruct", null);
	    return TotalAndFilteredRowsComp;
	}(nameValueComp_1.NameValueComp));
	exports.TotalAndFilteredRowsComp = TotalAndFilteredRowsComp;


/***/ }),
/* 2536 */
/***/ (function(module, exports, __webpack_require__) {

	// ag-grid-enterprise v21.2.2
	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var main_1 = __webpack_require__(2322);
	var pivotModePanel_1 = __webpack_require__(2537);
	var rowGroupDropZonePanel_1 = __webpack_require__(2538);
	var valueDropZonePanel_1 = __webpack_require__(2541);
	var pivotDropZonePanel_1 = __webpack_require__(2542);
	var primaryColsPanel_1 = __webpack_require__(2514);
	var ColumnToolPanel = /** @class */ (function (_super) {
	    __extends(ColumnToolPanel, _super);
	    function ColumnToolPanel() {
	        var _this = _super.call(this, ColumnToolPanel.TEMPLATE) || this;
	        _this.initialised = false;
	        _this.childDestroyFuncs = [];
	        return _this;
	    }
	    // lazy initialise the panel
	    ColumnToolPanel.prototype.setVisible = function (visible) {
	        _super.prototype.setDisplayed.call(this, visible);
	        if (visible && !this.initialised) {
	            this.init(this.params);
	        }
	    };
	    ColumnToolPanel.prototype.init = function (params) {
	        var defaultParams = {
	            suppressSideButtons: false,
	            suppressColumnSelectAll: false,
	            suppressColumnFilter: false,
	            suppressColumnExpandAll: false,
	            contractColumnSelection: false,
	            suppressPivotMode: false,
	            suppressRowGroups: false,
	            suppressValues: false,
	            suppressPivots: false,
	            api: this.gridApi
	        };
	        main_1._.mergeDeep(defaultParams, params);
	        this.params = defaultParams;
	        if (!this.params.suppressPivotMode) {
	            this.addComponent(new pivotModePanel_1.PivotModePanel());
	        }
	        this.addComponent(new primaryColsPanel_1.PrimaryColsPanel(true, this.params));
	        if (!this.params.suppressRowGroups) {
	            this.addComponent(new rowGroupDropZonePanel_1.RowGroupDropZonePanel(false));
	        }
	        if (!this.params.suppressValues) {
	            this.addComponent(new valueDropZonePanel_1.ValuesDropZonePanel(false));
	        }
	        if (!this.params.suppressPivots) {
	            this.addComponent(new pivotDropZonePanel_1.PivotDropZonePanel(false));
	        }
	        this.initialised = true;
	    };
	    ColumnToolPanel.prototype.addComponent = function (component) {
	        this.getContext().wireBean(component);
	        this.getGui().appendChild(component.getGui());
	        this.childDestroyFuncs.push(component.destroy.bind(component));
	    };
	    ColumnToolPanel.prototype.destroyChildren = function () {
	        this.childDestroyFuncs.forEach(function (func) { return func(); });
	        this.childDestroyFuncs.length = 0;
	        main_1._.clearElement(this.getGui());
	    };
	    ColumnToolPanel.prototype.refresh = function () {
	        this.destroyChildren();
	        this.init(this.params);
	    };
	    ColumnToolPanel.prototype.destroy = function () {
	        this.destroyChildren();
	        _super.prototype.destroy.call(this);
	    };
	    ColumnToolPanel.TEMPLATE = "<div class=\"ag-column-panel\"></div>";
	    __decorate([
	        main_1.Autowired("gridOptionsWrapper"),
	        __metadata("design:type", main_1.GridOptionsWrapper)
	    ], ColumnToolPanel.prototype, "gridOptionsWrapper", void 0);
	    __decorate([
	        main_1.Autowired("gridApi"),
	        __metadata("design:type", main_1.GridApi)
	    ], ColumnToolPanel.prototype, "gridApi", void 0);
	    __decorate([
	        main_1.Autowired("eventService"),
	        __metadata("design:type", main_1.EventService)
	    ], ColumnToolPanel.prototype, "eventService", void 0);
	    return ColumnToolPanel;
	}(main_1.Component));
	exports.ColumnToolPanel = ColumnToolPanel;


/***/ }),
/* 2537 */
/***/ (function(module, exports, __webpack_require__) {

	// ag-grid-enterprise v21.2.2
	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var main_1 = __webpack_require__(2322);
	var PivotModePanel = /** @class */ (function (_super) {
	    __extends(PivotModePanel, _super);
	    function PivotModePanel() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    PivotModePanel.prototype.createTemplate = function () {
	        return "<div class=\"ag-pivot-mode-panel\">\n                <ag-checkbox ref=\"cbPivotMode\" class=\"ag-pivot-mode-select\"></ag-checkbox>\n            </div>";
	    };
	    PivotModePanel.prototype.init = function () {
	        this.setTemplate(this.createTemplate());
	        this.cbPivotMode.setValue(this.columnController.isPivotMode());
	        var localeTextFunc = this.gridOptionsWrapper.getLocaleTextFunc();
	        this.cbPivotMode.setLabel(localeTextFunc('pivotMode', 'Pivot Mode'));
	        this.addDestroyableEventListener(this.cbPivotMode, main_1.AgCheckbox.EVENT_CHANGED, this.onBtPivotMode.bind(this));
	        this.addDestroyableEventListener(this.eventService, main_1.Events.EVENT_COLUMN_EVERYTHING_CHANGED, this.onPivotModeChanged.bind(this));
	        this.addDestroyableEventListener(this.eventService, main_1.Events.EVENT_COLUMN_PIVOT_MODE_CHANGED, this.onPivotModeChanged.bind(this));
	    };
	    PivotModePanel.prototype.onBtPivotMode = function () {
	        var newValue = this.cbPivotMode.getValue();
	        if (newValue !== this.columnController.isPivotMode()) {
	            this.columnController.setPivotMode(newValue, "toolPanelUi");
	            var api = this.gridOptionsWrapper.getApi();
	            if (api) {
	                api.refreshHeader();
	            }
	        }
	    };
	    PivotModePanel.prototype.onPivotModeChanged = function () {
	        var pivotModeActive = this.columnController.isPivotMode();
	        this.cbPivotMode.setValue(pivotModeActive);
	    };
	    __decorate([
	        main_1.Autowired('columnController'),
	        __metadata("design:type", main_1.ColumnController)
	    ], PivotModePanel.prototype, "columnController", void 0);
	    __decorate([
	        main_1.Autowired('eventService'),
	        __metadata("design:type", main_1.EventService)
	    ], PivotModePanel.prototype, "eventService", void 0);
	    __decorate([
	        main_1.Autowired('gridOptionsWrapper'),
	        __metadata("design:type", main_1.GridOptionsWrapper)
	    ], PivotModePanel.prototype, "gridOptionsWrapper", void 0);
	    __decorate([
	        main_1.RefSelector('cbPivotMode'),
	        __metadata("design:type", main_1.AgCheckbox)
	    ], PivotModePanel.prototype, "cbPivotMode", void 0);
	    __decorate([
	        main_1.PreConstruct,
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", []),
	        __metadata("design:returntype", void 0)
	    ], PivotModePanel.prototype, "init", null);
	    return PivotModePanel;
	}(main_1.Component));
	exports.PivotModePanel = PivotModePanel;


/***/ }),
/* 2538 */
/***/ (function(module, exports, __webpack_require__) {

	// ag-grid-enterprise v21.2.2
	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var main_1 = __webpack_require__(2322);
	var baseDropZonePanel_1 = __webpack_require__(2539);
	var RowGroupDropZonePanel = /** @class */ (function (_super) {
	    __extends(RowGroupDropZonePanel, _super);
	    function RowGroupDropZonePanel(horizontal) {
	        return _super.call(this, horizontal, false, 'row-group') || this;
	    }
	    RowGroupDropZonePanel.prototype.passBeansUp = function () {
	        _super.prototype.setBeans.call(this, {
	            gridOptionsWrapper: this.gridOptionsWrapper,
	            eventService: this.eventService,
	            context: this.getContext(),
	            loggerFactory: this.loggerFactory,
	            dragAndDropService: this.dragAndDropService
	        });
	        var localeTextFunc = this.gridOptionsWrapper.getLocaleTextFunc();
	        var emptyMessage = localeTextFunc('rowGroupColumnsEmptyMessage', 'Drag here to set row groups');
	        var title = localeTextFunc('groups', 'Row Groups');
	        _super.prototype.init.call(this, {
	            dragAndDropIcon: main_1.DragAndDropService.ICON_GROUP,
	            icon: main_1._.createIconNoSpan('rowGroupPanel', this.gridOptionsWrapper, null),
	            emptyMessage: emptyMessage,
	            title: title
	        });
	        this.addDestroyableEventListener(this.eventService, main_1.Events.EVENT_COLUMN_ROW_GROUP_CHANGED, this.refreshGui.bind(this));
	    };
	    RowGroupDropZonePanel.prototype.isColumnDroppable = function (column) {
	        if (this.gridOptionsWrapper.isFunctionsReadOnly()) {
	            return false;
	        }
	        // we never allow grouping of secondary columns
	        if (!column.isPrimary()) {
	            return false;
	        }
	        var columnGroupable = column.isAllowRowGroup();
	        var columnNotAlreadyGrouped = !column.isRowGroupActive();
	        return columnGroupable && columnNotAlreadyGrouped;
	    };
	    RowGroupDropZonePanel.prototype.updateColumns = function (columns) {
	        if (this.gridOptionsWrapper.isFunctionsPassive()) {
	            var event_1 = {
	                type: main_1.Events.EVENT_COLUMN_ROW_GROUP_CHANGE_REQUEST,
	                columns: columns,
	                api: this.gridApi,
	                columnApi: this.columnApi
	            };
	            this.eventService.dispatchEvent(event_1);
	        }
	        else {
	            this.columnController.setRowGroupColumns(columns, "toolPanelUi");
	        }
	    };
	    RowGroupDropZonePanel.prototype.getIconName = function () {
	        return this.isPotentialDndColumns() ? main_1.DragAndDropService.ICON_GROUP : main_1.DragAndDropService.ICON_NOT_ALLOWED;
	    };
	    RowGroupDropZonePanel.prototype.getExistingColumns = function () {
	        return this.columnController.getRowGroupColumns();
	    };
	    __decorate([
	        main_1.Autowired('columnController'),
	        __metadata("design:type", main_1.ColumnController)
	    ], RowGroupDropZonePanel.prototype, "columnController", void 0);
	    __decorate([
	        main_1.Autowired('eventService'),
	        __metadata("design:type", main_1.EventService)
	    ], RowGroupDropZonePanel.prototype, "eventService", void 0);
	    __decorate([
	        main_1.Autowired('gridOptionsWrapper'),
	        __metadata("design:type", main_1.GridOptionsWrapper)
	    ], RowGroupDropZonePanel.prototype, "gridOptionsWrapper", void 0);
	    __decorate([
	        main_1.Autowired('loggerFactory'),
	        __metadata("design:type", main_1.LoggerFactory)
	    ], RowGroupDropZonePanel.prototype, "loggerFactory", void 0);
	    __decorate([
	        main_1.Autowired('dragAndDropService'),
	        __metadata("design:type", main_1.DragAndDropService)
	    ], RowGroupDropZonePanel.prototype, "dragAndDropService", void 0);
	    __decorate([
	        main_1.Autowired('columnApi'),
	        __metadata("design:type", main_1.ColumnApi)
	    ], RowGroupDropZonePanel.prototype, "columnApi", void 0);
	    __decorate([
	        main_1.Autowired('gridApi'),
	        __metadata("design:type", main_1.GridApi)
	    ], RowGroupDropZonePanel.prototype, "gridApi", void 0);
	    __decorate([
	        main_1.PostConstruct,
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", []),
	        __metadata("design:returntype", void 0)
	    ], RowGroupDropZonePanel.prototype, "passBeansUp", null);
	    return RowGroupDropZonePanel;
	}(baseDropZonePanel_1.BaseDropZonePanel));
	exports.RowGroupDropZonePanel = RowGroupDropZonePanel;


/***/ }),
/* 2539 */
/***/ (function(module, exports, __webpack_require__) {

	// ag-grid-enterprise v21.2.2
	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var main_1 = __webpack_require__(2322);
	var dropZoneColumnComp_1 = __webpack_require__(2540);
	var BaseDropZonePanel = /** @class */ (function (_super) {
	    __extends(BaseDropZonePanel, _super);
	    function BaseDropZonePanel(horizontal, valueColumn, name) {
	        var _this = _super.call(this, "<div class=\"ag-column-drop ag-unselectable ag-column-drop-" + (horizontal ? 'horizontal' : 'vertical') + " ag-column-drop-" + name + "\"></div>") || this;
	        _this.state = BaseDropZonePanel.STATE_NOT_DRAGGING;
	        _this.guiDestroyFunctions = [];
	        _this.childColumnComponents = [];
	        _this.horizontal = horizontal;
	        _this.valueColumn = valueColumn;
	        _this.eColumnDropList = main_1._.loadTemplate('<div class="ag-column-drop-list"></div>');
	        return _this;
	    }
	    BaseDropZonePanel.prototype.isHorizontal = function () {
	        return this.horizontal;
	    };
	    BaseDropZonePanel.prototype.setBeans = function (beans) {
	        this.beans = beans;
	    };
	    BaseDropZonePanel.prototype.destroy = function () {
	        this.destroyGui();
	        _super.prototype.destroy.call(this);
	    };
	    BaseDropZonePanel.prototype.destroyGui = function () {
	        this.guiDestroyFunctions.forEach(function (func) { return func(); });
	        this.guiDestroyFunctions.length = 0;
	        this.childColumnComponents.length = 0;
	        main_1._.clearElement(this.getGui());
	        main_1._.clearElement(this.eColumnDropList);
	    };
	    BaseDropZonePanel.prototype.init = function (params) {
	        this.params = params;
	        this.logger = this.beans.loggerFactory.create('AbstractColumnDropPanel');
	        this.beans.eventService.addEventListener(main_1.Events.EVENT_COLUMN_EVERYTHING_CHANGED, this.refreshGui.bind(this));
	        this.addDestroyableEventListener(this.beans.gridOptionsWrapper, 'functionsReadOnly', this.refreshGui.bind(this));
	        this.setupDropTarget();
	        // we don't know if this bean will be initialised before columnController.
	        // if columnController first, then below will work
	        // if columnController second, then below will put blank in, and then above event gets first when columnController is set up
	        this.refreshGui();
	    };
	    BaseDropZonePanel.prototype.setupDropTarget = function () {
	        this.dropTarget = {
	            getContainer: this.getGui.bind(this),
	            getIconName: this.getIconName.bind(this),
	            onDragging: this.onDragging.bind(this),
	            onDragEnter: this.onDragEnter.bind(this),
	            onDragLeave: this.onDragLeave.bind(this),
	            onDragStop: this.onDragStop.bind(this),
	            isInterestedIn: this.isInterestedIn.bind(this)
	        };
	        this.beans.dragAndDropService.addDropTarget(this.dropTarget);
	    };
	    BaseDropZonePanel.prototype.isInterestedIn = function (type) {
	        // not interested in row drags
	        return type === main_1.DragSourceType.HeaderCell || type === main_1.DragSourceType.ToolPanel;
	    };
	    BaseDropZonePanel.prototype.checkInsertIndex = function (draggingEvent) {
	        var newIndex;
	        if (this.horizontal) {
	            newIndex = this.getNewHorizontalInsertIndex(draggingEvent);
	        }
	        else {
	            newIndex = this.getNewVerticalInsertIndex(draggingEvent);
	        }
	        // <0 happens when drag is no a direction we are interested in, eg drag is up/down but in horizontal panel
	        if (newIndex < 0) {
	            return false;
	        }
	        var changed = newIndex !== this.insertIndex;
	        if (changed) {
	            this.insertIndex = newIndex;
	        }
	        return changed;
	    };
	    BaseDropZonePanel.prototype.getNewHorizontalInsertIndex = function (draggingEvent) {
	        if (main_1._.missing(draggingEvent.hDirection)) {
	            return -1;
	        }
	        var newIndex = 0;
	        var mouseEvent = draggingEvent.event;
	        var enableRtl = this.beans.gridOptionsWrapper.isEnableRtl();
	        var goingLeft = draggingEvent.hDirection === main_1.HDirection.Left;
	        var mouseX = mouseEvent.clientX;
	        this.childColumnComponents.forEach(function (childColumn) {
	            var rect = childColumn.getGui().getBoundingClientRect();
	            var rectX = goingLeft ? rect.right : rect.left;
	            var horizontalFit = enableRtl ? (mouseX <= rectX) : (mouseX >= rectX);
	            if (horizontalFit) {
	                newIndex++;
	            }
	        });
	        return newIndex;
	    };
	    BaseDropZonePanel.prototype.getNewVerticalInsertIndex = function (draggingEvent) {
	        if (main_1._.missing(draggingEvent.vDirection)) {
	            return -1;
	        }
	        var newIndex = 0;
	        var mouseEvent = draggingEvent.event;
	        this.childColumnComponents.forEach(function (childColumn) {
	            var rect = childColumn.getGui().getBoundingClientRect();
	            if (draggingEvent.vDirection === main_1.VDirection.Down) {
	                var verticalFit = mouseEvent.clientY >= rect.top;
	                if (verticalFit) {
	                    newIndex++;
	                }
	            }
	            else {
	                var verticalFit = mouseEvent.clientY >= rect.bottom;
	                if (verticalFit) {
	                    newIndex++;
	                }
	            }
	        });
	        return newIndex;
	    };
	    BaseDropZonePanel.prototype.checkDragStartedBySelf = function (draggingEvent) {
	        if (this.state !== BaseDropZonePanel.STATE_NOT_DRAGGING) {
	            return;
	        }
	        this.state = BaseDropZonePanel.STATE_REARRANGE_COLUMNS;
	        this.potentialDndColumns = draggingEvent.dragSource.dragItemCallback().columns || [];
	        this.refreshGui();
	        this.checkInsertIndex(draggingEvent);
	        this.refreshGui();
	    };
	    BaseDropZonePanel.prototype.onDragging = function (draggingEvent) {
	        this.checkDragStartedBySelf(draggingEvent);
	        var positionChanged = this.checkInsertIndex(draggingEvent);
	        if (positionChanged) {
	            this.refreshGui();
	        }
	    };
	    BaseDropZonePanel.prototype.onDragEnter = function (draggingEvent) {
	        // this will contain all columns that are potential drops
	        var dragColumns = draggingEvent.dragSource.dragItemCallback().columns || [];
	        this.state = BaseDropZonePanel.STATE_NEW_COLUMNS_IN;
	        // take out columns that are not groupable
	        var goodDragColumns = main_1._.filter(dragColumns, this.isColumnDroppable.bind(this));
	        var weHaveColumnsToDrag = goodDragColumns.length > 0;
	        if (weHaveColumnsToDrag) {
	            this.potentialDndColumns = goodDragColumns;
	            this.checkInsertIndex(draggingEvent);
	            this.refreshGui();
	        }
	    };
	    BaseDropZonePanel.prototype.isPotentialDndColumns = function () {
	        return main_1._.existsAndNotEmpty(this.potentialDndColumns);
	    };
	    BaseDropZonePanel.prototype.onDragLeave = function (draggingEvent) {
	        // if the dragging started from us, we remove the group, however if it started
	        // someplace else, then we don't, as it was only 'asking'
	        if (this.state === BaseDropZonePanel.STATE_REARRANGE_COLUMNS) {
	            var columns = draggingEvent.dragSource.dragItemCallback().columns || [];
	            this.removeColumns(columns);
	        }
	        if (this.isPotentialDndColumns()) {
	            this.potentialDndColumns = [];
	            this.refreshGui();
	        }
	        this.state = BaseDropZonePanel.STATE_NOT_DRAGGING;
	    };
	    BaseDropZonePanel.prototype.onDragStop = function () {
	        if (this.isPotentialDndColumns()) {
	            var success = void 0;
	            if (this.state === BaseDropZonePanel.STATE_NEW_COLUMNS_IN) {
	                this.addColumns(this.potentialDndColumns);
	                success = true;
	            }
	            else {
	                success = this.rearrangeColumns(this.potentialDndColumns);
	            }
	            this.potentialDndColumns = [];
	            // if the function is passive, then we don't refresh, as we assume the client application
	            // is going to call setRowGroups / setPivots / setValues at a later point which will then
	            // cause a refresh. this gives a nice gui where the ghost stays until the app has caught
	            // up with the changes.
	            if (this.beans.gridOptionsWrapper.isFunctionsPassive()) {
	                // when functions are passive, we don't refresh,
	                // unless there was no change in the order, then we
	                // do need to refresh to reset the columns
	                if (!success) {
	                    this.refreshGui();
	                }
	            }
	            else {
	                this.refreshGui();
	            }
	        }
	        this.state = BaseDropZonePanel.STATE_NOT_DRAGGING;
	    };
	    BaseDropZonePanel.prototype.removeColumns = function (columnsToRemove) {
	        var newColumnList = this.getExistingColumns().slice();
	        columnsToRemove.forEach(function (column) { return main_1._.removeFromArray(newColumnList, column); });
	        this.updateColumns(newColumnList);
	    };
	    BaseDropZonePanel.prototype.addColumns = function (columnsToAdd) {
	        var newColumnList = this.getExistingColumns().slice();
	        main_1._.insertArrayIntoArray(newColumnList, columnsToAdd, this.insertIndex);
	        this.updateColumns(newColumnList);
	    };
	    BaseDropZonePanel.prototype.rearrangeColumns = function (columnsToAdd) {
	        var newColumnList = this.getNonGhostColumns().slice();
	        main_1._.insertArrayIntoArray(newColumnList, columnsToAdd, this.insertIndex);
	        var noChangeDetected = main_1._.shallowCompare(newColumnList, this.getExistingColumns());
	        if (noChangeDetected) {
	            return false;
	        }
	        else {
	            this.updateColumns(newColumnList);
	            return true;
	        }
	    };
	    BaseDropZonePanel.prototype.refreshGui = function () {
	        // we reset the scroll position after the refresh.
	        // if we don't do this, then the list will always scroll to the top
	        // each time we refresh it. this is because part of the refresh empties
	        // out the list which sets scroll to zero. so the user could be just
	        // reordering the list - we want to prevent the resetting of the scroll.
	        // this is relevant for vertical display only (as horizontal has no scroll)
	        var scrollTop = this.eColumnDropList.scrollTop;
	        this.destroyGui();
	        this.addIconAndTitleToGui();
	        this.addEmptyMessageToGui();
	        this.addColumnsToGui();
	        if (!this.isHorizontal()) {
	            this.eColumnDropList.scrollTop = scrollTop;
	        }
	    };
	    BaseDropZonePanel.prototype.getNonGhostColumns = function () {
	        var _this = this;
	        var existingColumns = this.getExistingColumns();
	        var nonGhostColumns;
	        if (this.isPotentialDndColumns()) {
	            nonGhostColumns = main_1._.filter(existingColumns, function (column) { return _this.potentialDndColumns.indexOf(column) < 0; });
	        }
	        else {
	            nonGhostColumns = existingColumns;
	        }
	        return nonGhostColumns;
	    };
	    BaseDropZonePanel.prototype.addColumnsToGui = function () {
	        var _this = this;
	        var nonGhostColumns = this.getNonGhostColumns();
	        var itemsToAddToGui = [];
	        var addingGhosts = this.isPotentialDndColumns();
	        nonGhostColumns.forEach(function (column, index) {
	            if (addingGhosts && index >= _this.insertIndex) {
	                return;
	            }
	            var columnComponent = _this.createColumnComponent(column, false);
	            itemsToAddToGui.push(columnComponent);
	        });
	        if (this.isPotentialDndColumns()) {
	            this.potentialDndColumns.forEach(function (column) {
	                var columnComponent = _this.createColumnComponent(column, true);
	                itemsToAddToGui.push(columnComponent);
	            });
	            nonGhostColumns.forEach(function (column, index) {
	                if (index < _this.insertIndex) {
	                    return;
	                }
	                var columnComponent = _this.createColumnComponent(column, false);
	                itemsToAddToGui.push(columnComponent);
	            });
	        }
	        this.getGui().appendChild(this.eColumnDropList);
	        itemsToAddToGui.forEach(function (columnComponent, index) {
	            var needSeparator = index !== 0;
	            if (needSeparator) {
	                _this.addArrow(_this.eColumnDropList);
	            }
	            _this.eColumnDropList.appendChild(columnComponent.getGui());
	        });
	    };
	    BaseDropZonePanel.prototype.createColumnComponent = function (column, ghost) {
	        var columnComponent = new dropZoneColumnComp_1.DropZoneColumnComp(column, this.dropTarget, ghost, this.valueColumn);
	        columnComponent.addEventListener(dropZoneColumnComp_1.DropZoneColumnComp.EVENT_COLUMN_REMOVE, this.removeColumns.bind(this, [column]));
	        this.beans.context.wireBean(columnComponent);
	        this.guiDestroyFunctions.push(function () { return columnComponent.destroy(); });
	        if (!ghost) {
	            this.childColumnComponents.push(columnComponent);
	        }
	        return columnComponent;
	    };
	    BaseDropZonePanel.prototype.addIconAndTitleToGui = function () {
	        var iconFaded = this.horizontal && this.isExistingColumnsEmpty();
	        var eGroupIcon = this.params.icon;
	        var eContainer = document.createElement('div');
	        main_1._.addCssClass(eGroupIcon, 'ag-column-drop-icon');
	        main_1._.addOrRemoveCssClass(eGroupIcon, 'ag-faded', iconFaded);
	        eContainer.appendChild(eGroupIcon);
	        if (!this.horizontal) {
	            var eTitle = document.createElement('span');
	            eTitle.innerHTML = this.params.title;
	            main_1._.addCssClass(eTitle, 'ag-column-drop-title');
	            main_1._.addOrRemoveCssClass(eTitle, 'ag-faded', iconFaded);
	            eContainer.appendChild(eTitle);
	        }
	        this.getGui().appendChild(eContainer);
	    };
	    BaseDropZonePanel.prototype.isExistingColumnsEmpty = function () {
	        return this.getExistingColumns().length === 0;
	    };
	    BaseDropZonePanel.prototype.addEmptyMessageToGui = function () {
	        var showEmptyMessage = this.isExistingColumnsEmpty() && !this.isPotentialDndColumns();
	        if (!showEmptyMessage) {
	            return;
	        }
	        var eMessage = document.createElement('span');
	        eMessage.innerHTML = this.params.emptyMessage;
	        main_1._.addCssClass(eMessage, 'ag-column-drop-empty-message');
	        this.getGui().appendChild(eMessage);
	    };
	    BaseDropZonePanel.prototype.addArrow = function (eParent) {
	        // only add the arrows if the layout is horizontal
	        if (this.horizontal) {
	            // for RTL it's a left arrow, otherwise it's a right arrow
	            var enableRtl = this.beans.gridOptionsWrapper.isEnableRtl();
	            eParent.appendChild(main_1._.createIconNoSpan(enableRtl ? 'smallLeft' : 'smallRight', this.beans.gridOptionsWrapper));
	        }
	    };
	    BaseDropZonePanel.STATE_NOT_DRAGGING = 'notDragging';
	    BaseDropZonePanel.STATE_NEW_COLUMNS_IN = 'newColumnsIn';
	    BaseDropZonePanel.STATE_REARRANGE_COLUMNS = 'rearrangeColumns';
	    BaseDropZonePanel.CHAR_LEFT_ARROW = '&#8592;';
	    BaseDropZonePanel.CHAR_RIGHT_ARROW = '&#8594;';
	    return BaseDropZonePanel;
	}(main_1.Component));
	exports.BaseDropZonePanel = BaseDropZonePanel;


/***/ }),
/* 2540 */
/***/ (function(module, exports, __webpack_require__) {

	// ag-grid-enterprise v21.2.2
	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var ag_grid_community_1 = __webpack_require__(2322);
	var aggFuncService_1 = __webpack_require__(2513);
	var virtualList_1 = __webpack_require__(2527);
	var DropZoneColumnComp = /** @class */ (function (_super) {
	    __extends(DropZoneColumnComp, _super);
	    function DropZoneColumnComp(column, dragSourceDropTarget, ghost, valueColumn) {
	        var _this = _super.call(this) || this;
	        _this.popupShowing = false;
	        _this.valueColumn = valueColumn;
	        _this.column = column;
	        _this.dragSourceDropTarget = dragSourceDropTarget;
	        _this.ghost = ghost;
	        return _this;
	    }
	    DropZoneColumnComp.prototype.init = function () {
	        this.setTemplate(DropZoneColumnComp.TEMPLATE);
	        this.eDragHandle.appendChild(ag_grid_community_1._.createIconNoSpan('columnDrag', this.gridOptionsWrapper));
	        this.btRemove.appendChild(ag_grid_community_1._.createIconNoSpan('cancel', this.gridOptionsWrapper));
	        this.displayName = this.columnController.getDisplayNameForColumn(this.column, 'columnDrop');
	        this.setupComponents();
	        if (!this.ghost && !this.gridOptionsWrapper.isFunctionsReadOnly()) {
	            this.addDragSource();
	        }
	    };
	    DropZoneColumnComp.prototype.addDragSource = function () {
	        var _this = this;
	        var dragSource = {
	            type: ag_grid_community_1.DragSourceType.ToolPanel,
	            eElement: this.eDragHandle,
	            dragItemCallback: function () { return _this.createDragItem(); },
	            dragItemName: this.displayName,
	            dragSourceDropTarget: this.dragSourceDropTarget
	        };
	        this.dragAndDropService.addDragSource(dragSource, true);
	        this.addDestroyFunc(function () { return _this.dragAndDropService.removeDragSource(dragSource); });
	    };
	    DropZoneColumnComp.prototype.createDragItem = function () {
	        var visibleState = {};
	        visibleState[this.column.getId()] = this.column.isVisible();
	        return {
	            columns: [this.column],
	            visibleState: visibleState
	        };
	    };
	    DropZoneColumnComp.prototype.setupComponents = function () {
	        this.setTextValue();
	        this.setupRemove();
	        if (this.ghost) {
	            ag_grid_community_1._.addCssClass(this.getGui(), 'ag-column-drop-cell-ghost');
	        }
	        if (this.valueColumn && !this.gridOptionsWrapper.isFunctionsReadOnly()) {
	            this.addGuiEventListener('click', this.onShowAggFuncSelection.bind(this));
	        }
	    };
	    DropZoneColumnComp.prototype.setupRemove = function () {
	        var _this = this;
	        ag_grid_community_1._.setDisplayed(this.btRemove, !this.gridOptionsWrapper.isFunctionsReadOnly());
	        this.addDestroyableEventListener(this.btRemove, 'click', function (mouseEvent) {
	            var agEvent = { type: DropZoneColumnComp.EVENT_COLUMN_REMOVE };
	            _this.dispatchEvent(agEvent);
	            mouseEvent.stopPropagation();
	        });
	        var touchListener = new ag_grid_community_1.TouchListener(this.btRemove);
	        this.addDestroyableEventListener(touchListener, ag_grid_community_1.TouchListener.EVENT_TAP, function (event) {
	            var agEvent = { type: DropZoneColumnComp.EVENT_COLUMN_REMOVE };
	            _this.dispatchEvent(agEvent);
	        });
	        this.addDestroyFunc(touchListener.destroy.bind(touchListener));
	    };
	    DropZoneColumnComp.prototype.setTextValue = function () {
	        var displayValue;
	        if (this.valueColumn) {
	            var aggFunc = this.column.getAggFunc();
	            // if aggFunc is a string, we can use it, but if it's a function, then we swap with 'func'
	            var aggFuncString = (typeof aggFunc === 'string') ? aggFunc : 'agg';
	            var localeTextFunc = this.gridOptionsWrapper.getLocaleTextFunc();
	            var aggFuncStringTranslated = localeTextFunc(aggFuncString, aggFuncString);
	            displayValue = aggFuncStringTranslated + "(" + this.displayName + ")";
	        }
	        else {
	            displayValue = this.displayName;
	        }
	        var displayValueSanitised = ag_grid_community_1._.escape(displayValue);
	        this.eText.innerHTML = displayValueSanitised;
	    };
	    DropZoneColumnComp.prototype.onShowAggFuncSelection = function () {
	        var _this = this;
	        if (this.popupShowing) {
	            return;
	        }
	        this.popupShowing = true;
	        var virtualList = new virtualList_1.VirtualList();
	        var rows = this.aggFuncService.getFuncNames(this.column);
	        virtualList.setModel({
	            getRow: function (index) { return rows[index]; },
	            getRowCount: function () { return rows.length; }
	        });
	        this.getContext().wireBean(virtualList);
	        var ePopup = ag_grid_community_1._.loadTemplate('<div class="ag-select-agg-func-popup"></div>');
	        ePopup.style.top = '0px';
	        ePopup.style.left = '0px';
	        ePopup.appendChild(virtualList.getGui());
	        // ePopup.style.height = this.gridOptionsWrapper.getAggFuncPopupHeight() + 'px';
	        ePopup.style.width = this.getGui().clientWidth + 'px';
	        var popupHiddenFunc = function () {
	            virtualList.destroy();
	            _this.popupShowing = false;
	        };
	        var hidePopup = this.popupService.addAsModalPopup(ePopup, true, popupHiddenFunc);
	        virtualList.setComponentCreator(this.createAggSelect.bind(this, hidePopup));
	        this.popupService.positionPopupUnderComponent({
	            type: 'aggFuncSelect',
	            eventSource: this.getGui(),
	            ePopup: ePopup,
	            keepWithinBounds: true,
	            column: this.column
	        });
	        virtualList.refresh();
	    };
	    DropZoneColumnComp.prototype.createAggSelect = function (hidePopup, value) {
	        var _this = this;
	        var itemSelected = function () {
	            hidePopup();
	            if (_this.gridOptionsWrapper.isFunctionsPassive()) {
	                var event_1 = {
	                    type: ag_grid_community_1.Events.EVENT_COLUMN_AGG_FUNC_CHANGE_REQUEST,
	                    columns: [_this.column],
	                    aggFunc: value,
	                    api: _this.gridApi,
	                    columnApi: _this.columnApi
	                };
	                _this.eventService.dispatchEvent(event_1);
	            }
	            else {
	                _this.columnController.setColumnAggFunc(_this.column, value, "toolPanelDragAndDrop");
	            }
	        };
	        var localeTextFunc = this.gridOptionsWrapper.getLocaleTextFunc();
	        var aggFuncString = value.toString();
	        var aggFuncStringTranslated = localeTextFunc(aggFuncString, aggFuncString);
	        var comp = new AggItemComp(itemSelected, aggFuncStringTranslated);
	        return comp;
	    };
	    DropZoneColumnComp.EVENT_COLUMN_REMOVE = 'columnRemove';
	    DropZoneColumnComp.TEMPLATE = "<span class=\"ag-column-drop-cell\">\n          <span ref=\"eDragHandle\" class=\"ag-column-drag\"></span>\n          <span ref=\"eText\" class=\"ag-column-drop-cell-text\"></span>\n          <span ref=\"btRemove\" class=\"ag-column-drop-cell-button\"></span>\n        </span>";
	    __decorate([
	        ag_grid_community_1.Autowired('dragAndDropService'),
	        __metadata("design:type", ag_grid_community_1.DragAndDropService)
	    ], DropZoneColumnComp.prototype, "dragAndDropService", void 0);
	    __decorate([
	        ag_grid_community_1.Autowired('columnController'),
	        __metadata("design:type", ag_grid_community_1.ColumnController)
	    ], DropZoneColumnComp.prototype, "columnController", void 0);
	    __decorate([
	        ag_grid_community_1.Autowired('popupService'),
	        __metadata("design:type", ag_grid_community_1.PopupService)
	    ], DropZoneColumnComp.prototype, "popupService", void 0);
	    __decorate([
	        ag_grid_community_1.Autowired('aggFuncService'),
	        __metadata("design:type", aggFuncService_1.AggFuncService)
	    ], DropZoneColumnComp.prototype, "aggFuncService", void 0);
	    __decorate([
	        ag_grid_community_1.Autowired('gridOptionsWrapper'),
	        __metadata("design:type", ag_grid_community_1.GridOptionsWrapper)
	    ], DropZoneColumnComp.prototype, "gridOptionsWrapper", void 0);
	    __decorate([
	        ag_grid_community_1.Autowired('eventService'),
	        __metadata("design:type", ag_grid_community_1.EventService)
	    ], DropZoneColumnComp.prototype, "eventService", void 0);
	    __decorate([
	        ag_grid_community_1.Autowired('columnApi'),
	        __metadata("design:type", ag_grid_community_1.ColumnApi)
	    ], DropZoneColumnComp.prototype, "columnApi", void 0);
	    __decorate([
	        ag_grid_community_1.Autowired('gridApi'),
	        __metadata("design:type", ag_grid_community_1.GridApi)
	    ], DropZoneColumnComp.prototype, "gridApi", void 0);
	    __decorate([
	        ag_grid_community_1.RefSelector('eText'),
	        __metadata("design:type", HTMLElement)
	    ], DropZoneColumnComp.prototype, "eText", void 0);
	    __decorate([
	        ag_grid_community_1.RefSelector('eDragHandle'),
	        __metadata("design:type", HTMLElement)
	    ], DropZoneColumnComp.prototype, "eDragHandle", void 0);
	    __decorate([
	        ag_grid_community_1.RefSelector('btRemove'),
	        __metadata("design:type", HTMLElement)
	    ], DropZoneColumnComp.prototype, "btRemove", void 0);
	    __decorate([
	        ag_grid_community_1.PostConstruct,
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", []),
	        __metadata("design:returntype", void 0)
	    ], DropZoneColumnComp.prototype, "init", null);
	    return DropZoneColumnComp;
	}(ag_grid_community_1.Component));
	exports.DropZoneColumnComp = DropZoneColumnComp;
	var AggItemComp = /** @class */ (function (_super) {
	    __extends(AggItemComp, _super);
	    function AggItemComp(itemSelected, value) {
	        var _this = _super.call(this, '<div class="ag-select-agg-func-item"/>') || this;
	        _this.getGui().innerText = value;
	        _this.value = value;
	        _this.addGuiEventListener('click', itemSelected);
	        return _this;
	    }
	    return AggItemComp;
	}(ag_grid_community_1.Component));


/***/ }),
/* 2541 */
/***/ (function(module, exports, __webpack_require__) {

	// ag-grid-enterprise v21.2.2
	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var main_1 = __webpack_require__(2322);
	var baseDropZonePanel_1 = __webpack_require__(2539);
	var ValuesDropZonePanel = /** @class */ (function (_super) {
	    __extends(ValuesDropZonePanel, _super);
	    function ValuesDropZonePanel(horizontal) {
	        return _super.call(this, horizontal, true, 'values') || this;
	    }
	    ValuesDropZonePanel.prototype.passBeansUp = function () {
	        _super.prototype.setBeans.call(this, {
	            gridOptionsWrapper: this.gridOptionsWrapper,
	            eventService: this.eventService,
	            context: this.getContext(),
	            loggerFactory: this.loggerFactory,
	            dragAndDropService: this.dragAndDropService
	        });
	        var localeTextFunc = this.gridOptionsWrapper.getLocaleTextFunc();
	        var emptyMessage = localeTextFunc('valueColumnsEmptyMessage', 'Drag here to aggregate');
	        var title = localeTextFunc('values', 'Values');
	        _super.prototype.init.call(this, {
	            dragAndDropIcon: main_1.DragAndDropService.ICON_AGGREGATE,
	            icon: main_1._.createIconNoSpan('valuePanel', this.gridOptionsWrapper, null),
	            emptyMessage: emptyMessage,
	            title: title
	        });
	        this.addDestroyableEventListener(this.eventService, main_1.Events.EVENT_COLUMN_VALUE_CHANGED, this.refreshGui.bind(this));
	    };
	    ValuesDropZonePanel.prototype.getIconName = function () {
	        return this.isPotentialDndColumns() ? main_1.DragAndDropService.ICON_AGGREGATE : main_1.DragAndDropService.ICON_NOT_ALLOWED;
	    };
	    ValuesDropZonePanel.prototype.isColumnDroppable = function (column) {
	        if (this.gridOptionsWrapper.isFunctionsReadOnly()) {
	            return false;
	        }
	        // we never allow grouping of secondary columns
	        if (!column.isPrimary()) {
	            return false;
	        }
	        var columnValue = column.isAllowValue();
	        var columnNotValue = !column.isValueActive();
	        return columnValue && columnNotValue;
	    };
	    ValuesDropZonePanel.prototype.updateColumns = function (columns) {
	        if (this.gridOptionsWrapper.isFunctionsPassive()) {
	            var event_1 = {
	                type: main_1.Events.EVENT_COLUMN_VALUE_CHANGE_REQUEST,
	                columns: columns,
	                api: this.gridApi,
	                columnApi: this.columnApi
	            };
	            this.eventService.dispatchEvent(event_1);
	        }
	        else {
	            this.columnController.setValueColumns(columns, "toolPanelUi");
	        }
	    };
	    ValuesDropZonePanel.prototype.getExistingColumns = function () {
	        return this.columnController.getValueColumns();
	    };
	    __decorate([
	        main_1.Autowired('columnController'),
	        __metadata("design:type", main_1.ColumnController)
	    ], ValuesDropZonePanel.prototype, "columnController", void 0);
	    __decorate([
	        main_1.Autowired('eventService'),
	        __metadata("design:type", main_1.EventService)
	    ], ValuesDropZonePanel.prototype, "eventService", void 0);
	    __decorate([
	        main_1.Autowired('gridOptionsWrapper'),
	        __metadata("design:type", main_1.GridOptionsWrapper)
	    ], ValuesDropZonePanel.prototype, "gridOptionsWrapper", void 0);
	    __decorate([
	        main_1.Autowired('loggerFactory'),
	        __metadata("design:type", main_1.LoggerFactory)
	    ], ValuesDropZonePanel.prototype, "loggerFactory", void 0);
	    __decorate([
	        main_1.Autowired('dragAndDropService'),
	        __metadata("design:type", main_1.DragAndDropService)
	    ], ValuesDropZonePanel.prototype, "dragAndDropService", void 0);
	    __decorate([
	        main_1.Autowired('columnApi'),
	        __metadata("design:type", main_1.ColumnApi)
	    ], ValuesDropZonePanel.prototype, "columnApi", void 0);
	    __decorate([
	        main_1.Autowired('gridApi'),
	        __metadata("design:type", main_1.GridApi)
	    ], ValuesDropZonePanel.prototype, "gridApi", void 0);
	    __decorate([
	        main_1.PostConstruct,
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", []),
	        __metadata("design:returntype", void 0)
	    ], ValuesDropZonePanel.prototype, "passBeansUp", null);
	    return ValuesDropZonePanel;
	}(baseDropZonePanel_1.BaseDropZonePanel));
	exports.ValuesDropZonePanel = ValuesDropZonePanel;


/***/ }),
/* 2542 */
/***/ (function(module, exports, __webpack_require__) {

	// ag-grid-enterprise v21.2.2
	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var main_1 = __webpack_require__(2322);
	var baseDropZonePanel_1 = __webpack_require__(2539);
	var PivotDropZonePanel = /** @class */ (function (_super) {
	    __extends(PivotDropZonePanel, _super);
	    function PivotDropZonePanel(horizontal) {
	        return _super.call(this, horizontal, false, 'pivot') || this;
	    }
	    PivotDropZonePanel.prototype.passBeansUp = function () {
	        _super.prototype.setBeans.call(this, {
	            gridOptionsWrapper: this.gridOptionsWrapper,
	            eventService: this.eventService,
	            context: this.getContext(),
	            loggerFactory: this.loggerFactory,
	            dragAndDropService: this.dragAndDropService
	        });
	        var localeTextFunc = this.gridOptionsWrapper.getLocaleTextFunc();
	        var emptyMessage = localeTextFunc('pivotColumnsEmptyMessage', 'Drag here to set column labels');
	        var title = localeTextFunc('pivots', 'Column Labels');
	        _super.prototype.init.call(this, {
	            dragAndDropIcon: main_1.DragAndDropService.ICON_GROUP,
	            icon: main_1._.createIconNoSpan('pivotPanel', this.gridOptionsWrapper, null),
	            emptyMessage: emptyMessage,
	            title: title
	        });
	        this.addDestroyableEventListener(this.eventService, main_1.Events.EVENT_COLUMN_EVERYTHING_CHANGED, this.refresh.bind(this));
	        this.addDestroyableEventListener(this.eventService, main_1.Events.EVENT_COLUMN_PIVOT_CHANGED, this.refresh.bind(this));
	        this.addDestroyableEventListener(this.eventService, main_1.Events.EVENT_COLUMN_PIVOT_MODE_CHANGED, this.checkVisibility.bind(this));
	        this.refresh();
	    };
	    PivotDropZonePanel.prototype.refresh = function () {
	        this.checkVisibility();
	        this.refreshGui();
	    };
	    PivotDropZonePanel.prototype.checkVisibility = function () {
	        var pivotMode = this.columnController.isPivotMode();
	        if (this.isHorizontal()) {
	            // what we do for horizontal (ie the pivot panel at the top) depends
	            // on the user property as well as pivotMode.
	            switch (this.gridOptionsWrapper.getPivotPanelShow()) {
	                case 'always':
	                    this.setDisplayed(pivotMode);
	                    break;
	                case 'onlyWhenPivoting':
	                    var pivotActive = this.columnController.isPivotActive();
	                    this.setDisplayed(pivotMode && pivotActive);
	                    break;
	                default:
	                    // never show it
	                    this.setDisplayed(false);
	                    break;
	            }
	        }
	        else {
	            // in toolPanel, the pivot panel is always shown when pivot mode is on
	            this.setDisplayed(pivotMode);
	        }
	    };
	    PivotDropZonePanel.prototype.isColumnDroppable = function (column) {
	        if (this.gridOptionsWrapper.isFunctionsReadOnly()) {
	            return false;
	        }
	        // we never allow grouping of secondary columns
	        if (!column.isPrimary()) {
	            return false;
	        }
	        var allowPivot = column.isAllowPivot();
	        var columnNotAlreadyPivoted = !column.isPivotActive();
	        return allowPivot && columnNotAlreadyPivoted;
	    };
	    PivotDropZonePanel.prototype.updateColumns = function (columns) {
	        if (this.gridOptionsWrapper.isFunctionsPassive()) {
	            var event_1 = {
	                type: main_1.Events.EVENT_COLUMN_PIVOT_CHANGE_REQUEST,
	                columns: columns,
	                api: this.gridApi,
	                columnApi: this.columnApi
	            };
	            this.eventService.dispatchEvent(event_1);
	        }
	        else {
	            this.columnController.setPivotColumns(columns, "toolPanelUi");
	        }
	    };
	    PivotDropZonePanel.prototype.getIconName = function () {
	        return this.isPotentialDndColumns() ? main_1.DragAndDropService.ICON_PIVOT : main_1.DragAndDropService.ICON_NOT_ALLOWED;
	    };
	    PivotDropZonePanel.prototype.getExistingColumns = function () {
	        return this.columnController.getPivotColumns();
	    };
	    __decorate([
	        main_1.Autowired('columnController'),
	        __metadata("design:type", main_1.ColumnController)
	    ], PivotDropZonePanel.prototype, "columnController", void 0);
	    __decorate([
	        main_1.Autowired('eventService'),
	        __metadata("design:type", main_1.EventService)
	    ], PivotDropZonePanel.prototype, "eventService", void 0);
	    __decorate([
	        main_1.Autowired('gridOptionsWrapper'),
	        __metadata("design:type", main_1.GridOptionsWrapper)
	    ], PivotDropZonePanel.prototype, "gridOptionsWrapper", void 0);
	    __decorate([
	        main_1.Autowired('loggerFactory'),
	        __metadata("design:type", main_1.LoggerFactory)
	    ], PivotDropZonePanel.prototype, "loggerFactory", void 0);
	    __decorate([
	        main_1.Autowired('dragAndDropService'),
	        __metadata("design:type", main_1.DragAndDropService)
	    ], PivotDropZonePanel.prototype, "dragAndDropService", void 0);
	    __decorate([
	        main_1.Autowired('columnApi'),
	        __metadata("design:type", main_1.ColumnApi)
	    ], PivotDropZonePanel.prototype, "columnApi", void 0);
	    __decorate([
	        main_1.Autowired('gridApi'),
	        __metadata("design:type", main_1.GridApi)
	    ], PivotDropZonePanel.prototype, "gridApi", void 0);
	    __decorate([
	        main_1.PostConstruct,
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", []),
	        __metadata("design:returntype", void 0)
	    ], PivotDropZonePanel.prototype, "passBeansUp", null);
	    return PivotDropZonePanel;
	}(baseDropZonePanel_1.BaseDropZonePanel));
	exports.PivotDropZonePanel = PivotDropZonePanel;


/***/ }),
/* 2543 */
/***/ (function(module, exports, __webpack_require__) {

	// ag-grid-enterprise v21.2.2
	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var ag_grid_community_1 = __webpack_require__(2322);
	var rangeController_1 = __webpack_require__(2512);
	var nameValueComp_1 = __webpack_require__(2534);
	var AggregationComp = /** @class */ (function (_super) {
	    __extends(AggregationComp, _super);
	    function AggregationComp() {
	        return _super.call(this, AggregationComp.TEMPLATE) || this;
	    }
	    AggregationComp.prototype.postConstruct = function () {
	        if (!this.isValidRowModel()) {
	            console.warn("ag-Grid: agAggregationComponent should only be used with the client and server side row model.");
	            return;
	        }
	        this.avgAggregationComp.setLabel('average', 'Average');
	        this.countAggregationComp.setLabel('count', 'Count');
	        this.minAggregationComp.setLabel('min', 'Min');
	        this.maxAggregationComp.setLabel('max', 'Max');
	        this.sumAggregationComp.setLabel('sum', 'Sum');
	        this.addDestroyableEventListener(this.eventService, ag_grid_community_1.Events.EVENT_RANGE_SELECTION_CHANGED, this.onRangeSelectionChanged.bind(this));
	        this.addDestroyableEventListener(this.eventService, ag_grid_community_1.Events.EVENT_MODEL_UPDATED, this.onRangeSelectionChanged.bind(this));
	    };
	    AggregationComp.prototype.isValidRowModel = function () {
	        // this component is only really useful with client or server side rowmodels
	        var rowModelType = this.gridApi.getModel().getType();
	        return rowModelType === 'clientSide' || rowModelType === 'serverSide';
	    };
	    AggregationComp.prototype.init = function () {
	    };
	    AggregationComp.prototype.setAggregationComponentValue = function (aggFuncName, value, visible) {
	        var statusBarValueComponent = this.getAggregationValueComponent(aggFuncName);
	        if (ag_grid_community_1._.exists(statusBarValueComponent) && statusBarValueComponent) {
	            statusBarValueComponent.setValue(ag_grid_community_1._.formatNumberTwoDecimalPlacesAndCommas(value));
	            statusBarValueComponent.setDisplayed(visible);
	        }
	    };
	    AggregationComp.prototype.getAggregationValueComponent = function (aggFuncName) {
	        // converts user supplied agg name to our reference - eg: sum => sumAggregationComp
	        var refComponentName = aggFuncName + "AggregationComp";
	        // if the user has specified the agAggregationPanelComp but no aggFuncs we show the all
	        // if the user has specified the agAggregationPanelComp and aggFuncs, then we only show the aggFuncs listed
	        var statusBarValueComponent = null;
	        var aggregationPanelConfig = ag_grid_community_1._.exists(this.gridOptions.statusBar) && this.gridOptions.statusBar ? ag_grid_community_1._.find(this.gridOptions.statusBar.statusPanels, function (panel) { return panel.statusPanel === 'agAggregationComponent'; }) : null;
	        if (ag_grid_community_1._.exists(aggregationPanelConfig) && aggregationPanelConfig) {
	            // a little defensive here - if no statusPanelParams show it, if componentParams we also expect aggFuncs
	            if (!ag_grid_community_1._.exists(aggregationPanelConfig.statusPanelParams) ||
	                (ag_grid_community_1._.exists(aggregationPanelConfig.statusPanelParams) &&
	                    ag_grid_community_1._.exists(aggregationPanelConfig.statusPanelParams.aggFuncs) &&
	                    ag_grid_community_1._.exists(ag_grid_community_1._.find(aggregationPanelConfig.statusPanelParams.aggFuncs, function (func) { return func === aggFuncName; })))) {
	                statusBarValueComponent = this[refComponentName];
	            }
	        }
	        else {
	            // components not specified - assume we can show this component
	            statusBarValueComponent = this[refComponentName];
	        }
	        // either we can't find it (which would indicate a typo or similar user side), or the user has deliberately
	        // not listed the component in aggFuncs
	        return statusBarValueComponent;
	    };
	    AggregationComp.prototype.onRangeSelectionChanged = function () {
	        var _this = this;
	        var cellRanges = this.rangeController.getCellRanges();
	        var sum = 0;
	        var count = 0;
	        var numberCount = 0;
	        var min = null;
	        var max = 0;
	        var cellsSoFar = {};
	        if (cellRanges && !ag_grid_community_1._.missingOrEmpty(cellRanges)) {
	            cellRanges.forEach(function (cellRange) {
	                var currentRow = _this.rangeController.getRangeStartRow(cellRange);
	                var lastRow = _this.rangeController.getRangeEndRow(cellRange);
	                while (true) {
	                    var finishedAllRows = ag_grid_community_1._.missing(currentRow) || !currentRow || _this.rowPositionUtils.before(lastRow, currentRow);
	                    if (finishedAllRows || !currentRow || !cellRange.columns) {
	                        break;
	                    }
	                    cellRange.columns.forEach(function (col) {
	                        if (currentRow === null) {
	                            return;
	                        }
	                        // we only want to include each cell once, in case a cell is in multiple ranges
	                        var cellId = _this.cellPositionUtils.createId({
	                            rowPinned: currentRow.rowPinned,
	                            column: col,
	                            rowIndex: currentRow.rowIndex
	                        });
	                        if (cellsSoFar[cellId]) {
	                            return;
	                        }
	                        cellsSoFar[cellId] = true;
	                        var rowNode = _this.rowRenderer.getRowNode(currentRow);
	                        if (ag_grid_community_1._.missing(rowNode)) {
	                            return;
	                        }
	                        var value = _this.valueService.getValue(col, rowNode);
	                        // if empty cell, skip it, doesn't impact count or anything
	                        if (ag_grid_community_1._.missing(value) || value === '') {
	                            return;
	                        }
	                        // see if value is wrapped, can happen when doing count() or avg() functions
	                        if (value.value) {
	                            value = value.value;
	                        }
	                        if (typeof value === 'string') {
	                            value = Number(value);
	                        }
	                        if (typeof value === 'number' && !isNaN(value)) {
	                            sum += value;
	                            if (max === null || value > max) {
	                                max = value;
	                            }
	                            if (min === null || value < min) {
	                                min = value;
	                            }
	                            numberCount++;
	                        }
	                        count++;
	                    });
	                    currentRow = _this.cellNavigationService.getRowBelow(currentRow);
	                }
	            });
	        }
	        var gotResult = count > 1;
	        var gotNumberResult = numberCount > 1;
	        // we show count even if no numbers
	        this.setAggregationComponentValue('count', count, gotResult);
	        // show if numbers found
	        this.setAggregationComponentValue('sum', sum, gotNumberResult);
	        this.setAggregationComponentValue('min', min, gotNumberResult);
	        this.setAggregationComponentValue('max', max, gotNumberResult);
	        this.setAggregationComponentValue('avg', (sum / numberCount), gotNumberResult);
	    };
	    AggregationComp.TEMPLATE = "<div class=\"ag-status-panel ag-status-panel-aggregations\">\n                <ag-name-value ref=\"avgAggregationComp\"></ag-name-value>\n                <ag-name-value ref=\"countAggregationComp\"></ag-name-value>\n                <ag-name-value ref=\"minAggregationComp\"></ag-name-value>\n                <ag-name-value ref=\"maxAggregationComp\"></ag-name-value>\n                <ag-name-value ref=\"sumAggregationComp\"></ag-name-value>\n            </div>";
	    __decorate([
	        ag_grid_community_1.Autowired('eventService'),
	        __metadata("design:type", ag_grid_community_1.EventService)
	    ], AggregationComp.prototype, "eventService", void 0);
	    __decorate([
	        ag_grid_community_1.Autowired('rangeController'),
	        __metadata("design:type", rangeController_1.RangeController)
	    ], AggregationComp.prototype, "rangeController", void 0);
	    __decorate([
	        ag_grid_community_1.Autowired('valueService'),
	        __metadata("design:type", ag_grid_community_1.ValueService)
	    ], AggregationComp.prototype, "valueService", void 0);
	    __decorate([
	        ag_grid_community_1.Autowired('cellNavigationService'),
	        __metadata("design:type", ag_grid_community_1.CellNavigationService)
	    ], AggregationComp.prototype, "cellNavigationService", void 0);
	    __decorate([
	        ag_grid_community_1.Autowired('rowRenderer'),
	        __metadata("design:type", ag_grid_community_1.RowRenderer)
	    ], AggregationComp.prototype, "rowRenderer", void 0);
	    __decorate([
	        ag_grid_community_1.Autowired('gridOptionsWrapper'),
	        __metadata("design:type", ag_grid_community_1.GridOptionsWrapper)
	    ], AggregationComp.prototype, "gridOptionsWrapper", void 0);
	    __decorate([
	        ag_grid_community_1.Autowired('gridOptions'),
	        __metadata("design:type", Object)
	    ], AggregationComp.prototype, "gridOptions", void 0);
	    __decorate([
	        ag_grid_community_1.Autowired('gridApi'),
	        __metadata("design:type", ag_grid_community_1.GridApi)
	    ], AggregationComp.prototype, "gridApi", void 0);
	    __decorate([
	        ag_grid_community_1.Autowired('cellPositionUtils'),
	        __metadata("design:type", ag_grid_community_1.CellPositionUtils)
	    ], AggregationComp.prototype, "cellPositionUtils", void 0);
	    __decorate([
	        ag_grid_community_1.Autowired('rowPositionUtils'),
	        __metadata("design:type", ag_grid_community_1.RowPositionUtils)
	    ], AggregationComp.prototype, "rowPositionUtils", void 0);
	    __decorate([
	        ag_grid_community_1.RefSelector('sumAggregationComp'),
	        __metadata("design:type", nameValueComp_1.NameValueComp)
	    ], AggregationComp.prototype, "sumAggregationComp", void 0);
	    __decorate([
	        ag_grid_community_1.RefSelector('countAggregationComp'),
	        __metadata("design:type", nameValueComp_1.NameValueComp)
	    ], AggregationComp.prototype, "countAggregationComp", void 0);
	    __decorate([
	        ag_grid_community_1.RefSelector('minAggregationComp'),
	        __metadata("design:type", nameValueComp_1.NameValueComp)
	    ], AggregationComp.prototype, "minAggregationComp", void 0);
	    __decorate([
	        ag_grid_community_1.RefSelector('maxAggregationComp'),
	        __metadata("design:type", nameValueComp_1.NameValueComp)
	    ], AggregationComp.prototype, "maxAggregationComp", void 0);
	    __decorate([
	        ag_grid_community_1.RefSelector('avgAggregationComp'),
	        __metadata("design:type", nameValueComp_1.NameValueComp)
	    ], AggregationComp.prototype, "avgAggregationComp", void 0);
	    __decorate([
	        ag_grid_community_1.PostConstruct,
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", []),
	        __metadata("design:returntype", void 0)
	    ], AggregationComp.prototype, "postConstruct", null);
	    return AggregationComp;
	}(ag_grid_community_1.Component));
	exports.AggregationComp = AggregationComp;


/***/ }),
/* 2544 */
/***/ (function(module, exports, __webpack_require__) {

	// ag-grid-enterprise v21.2.2
	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var ag_grid_community_1 = __webpack_require__(2322);
	var nameValueComp_1 = __webpack_require__(2534);
	var SelectedRowsComp = /** @class */ (function (_super) {
	    __extends(SelectedRowsComp, _super);
	    function SelectedRowsComp() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    SelectedRowsComp.prototype.postConstruct = function () {
	        if (!this.isValidRowModel()) {
	            console.warn("ag-Grid: agSelectedRowCountComponent should only be used with the client and server side row model.");
	            return;
	        }
	        this.setLabel('selectedRows', 'Selected');
	        this.addCssClass('ag-status-panel');
	        this.addCssClass('ag-status-panel-selected-row-count');
	        var selectedRowCount = this.gridApi.getSelectedRows().length;
	        this.setValue(selectedRowCount);
	        this.setDisplayed(selectedRowCount > 0);
	        var eventListener = this.onRowSelectionChanged.bind(this);
	        this.eventService.addEventListener(ag_grid_community_1.Events.EVENT_MODEL_UPDATED, eventListener);
	        this.eventService.addEventListener(ag_grid_community_1.Events.EVENT_SELECTION_CHANGED, eventListener);
	    };
	    SelectedRowsComp.prototype.isValidRowModel = function () {
	        // this component is only really useful with client or server side rowmodels
	        var rowModelType = this.gridApi.getModel().getType();
	        return rowModelType === 'clientSide' || rowModelType === 'serverSide';
	    };
	    SelectedRowsComp.prototype.onRowSelectionChanged = function () {
	        var selectedRowCount = this.gridApi.getSelectedRows().length;
	        this.setValue(selectedRowCount);
	        this.setDisplayed(selectedRowCount > 0);
	    };
	    SelectedRowsComp.prototype.init = function () {
	    };
	    __decorate([
	        ag_grid_community_1.Autowired('eventService'),
	        __metadata("design:type", ag_grid_community_1.EventService)
	    ], SelectedRowsComp.prototype, "eventService", void 0);
	    __decorate([
	        ag_grid_community_1.Autowired('gridApi'),
	        __metadata("design:type", ag_grid_community_1.GridApi)
	    ], SelectedRowsComp.prototype, "gridApi", void 0);
	    __decorate([
	        ag_grid_community_1.PostConstruct,
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", []),
	        __metadata("design:returntype", void 0)
	    ], SelectedRowsComp.prototype, "postConstruct", null);
	    return SelectedRowsComp;
	}(nameValueComp_1.NameValueComp));
	exports.SelectedRowsComp = SelectedRowsComp;


/***/ }),
/* 2545 */
/***/ (function(module, exports, __webpack_require__) {

	// ag-grid-enterprise v21.2.2
	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var ag_grid_community_1 = __webpack_require__(2322);
	var nameValueComp_1 = __webpack_require__(2534);
	var FilteredRowsComp = /** @class */ (function (_super) {
	    __extends(FilteredRowsComp, _super);
	    function FilteredRowsComp() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    FilteredRowsComp.prototype.postConstruct = function () {
	        this.setLabel('filteredRows', 'Filtered');
	        // this component is only really useful with client side row model
	        if (this.gridApi.getModel().getType() !== 'clientSide') {
	            console.warn("ag-Grid: agFilteredRowCountComponent should only be used with the client side row model.");
	            return;
	        }
	        this.addCssClass('ag-status-panel');
	        this.addCssClass('ag-status-panel-filtered-row-count');
	        this.setDisplayed(true);
	        var listener = this.onDataChanged.bind(this);
	        this.eventService.addEventListener(ag_grid_community_1.Events.EVENT_MODEL_UPDATED, listener);
	    };
	    FilteredRowsComp.prototype.onDataChanged = function () {
	        var totalRowCountValue = this.getTotalRowCountValue();
	        var filteredRowCountValue = this.getFilteredRowCountValue();
	        this.setValue(filteredRowCountValue);
	        this.setDisplayed(totalRowCountValue !== filteredRowCountValue);
	    };
	    FilteredRowsComp.prototype.getTotalRowCountValue = function () {
	        var totalRowCount = 0;
	        this.gridApi.forEachNode(function (node) { return totalRowCount += 1; });
	        return totalRowCount;
	    };
	    FilteredRowsComp.prototype.getFilteredRowCountValue = function () {
	        var filteredRowCount = 0;
	        this.gridApi.forEachNodeAfterFilter(function (node) {
	            if (!node.group) {
	                filteredRowCount += 1;
	            }
	        });
	        return filteredRowCount;
	    };
	    FilteredRowsComp.prototype.init = function () { };
	    __decorate([
	        ag_grid_community_1.Autowired('eventService'),
	        __metadata("design:type", ag_grid_community_1.EventService)
	    ], FilteredRowsComp.prototype, "eventService", void 0);
	    __decorate([
	        ag_grid_community_1.Autowired('gridApi'),
	        __metadata("design:type", ag_grid_community_1.GridApi)
	    ], FilteredRowsComp.prototype, "gridApi", void 0);
	    __decorate([
	        ag_grid_community_1.PostConstruct,
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", []),
	        __metadata("design:returntype", void 0)
	    ], FilteredRowsComp.prototype, "postConstruct", null);
	    return FilteredRowsComp;
	}(nameValueComp_1.NameValueComp));
	exports.FilteredRowsComp = FilteredRowsComp;


/***/ }),
/* 2546 */
/***/ (function(module, exports, __webpack_require__) {

	// ag-grid-enterprise v21.2.2
	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var ag_grid_community_1 = __webpack_require__(2322);
	var toolPanelFilterComp_1 = __webpack_require__(2547);
	var FiltersToolPanel = /** @class */ (function (_super) {
	    __extends(FiltersToolPanel, _super);
	    function FiltersToolPanel() {
	        var _this = _super.call(this, FiltersToolPanel.TEMPLATE) || this;
	        _this.initialised = false;
	        return _this;
	    }
	    FiltersToolPanel.prototype.init = function () {
	        var _this = this;
	        this.initialised = true;
	        this.eventService.addEventListener('newColumnsLoaded', function () { return _this.onColumnsChanged(); });
	        if (this.columnController.isReady()) {
	            this.onColumnsChanged();
	        }
	    };
	    FiltersToolPanel.prototype.onColumnsChanged = function () {
	        var _this = this;
	        var eGui = this.getGui();
	        ag_grid_community_1._.clearElement(eGui);
	        var primaryCols = this.columnController.getAllPrimaryColumns();
	        if (!primaryCols) {
	            return;
	        }
	        var primaryColsWithFilter = primaryCols.filter(function (col) { return col.isFilterAllowed(); });
	        primaryColsWithFilter.forEach(function (col) { return _this.addColumnComps(col); });
	    };
	    // we don't support refreshing, but must implement because it's on the tool panel interface
	    FiltersToolPanel.prototype.refresh = function () {
	    };
	    // lazy initialise the panel
	    FiltersToolPanel.prototype.setVisible = function (visible) {
	        _super.prototype.setDisplayed.call(this, visible);
	        if (visible && !this.initialised) {
	            this.init();
	        }
	    };
	    FiltersToolPanel.prototype.addColumnComps = function (column) {
	        var toolPanelFilterComp = new toolPanelFilterComp_1.ToolPanelFilterComp();
	        this.getContext().wireBean(toolPanelFilterComp);
	        toolPanelFilterComp.setColumn(column);
	        this.appendChild(toolPanelFilterComp);
	    };
	    FiltersToolPanel.TEMPLATE = "<div class=\"ag-filter-panel\" ref=\"ePanelContainer\" />";
	    __decorate([
	        ag_grid_community_1.Autowired("eventService"),
	        __metadata("design:type", ag_grid_community_1.EventService)
	    ], FiltersToolPanel.prototype, "eventService", void 0);
	    __decorate([
	        ag_grid_community_1.Autowired('columnController'),
	        __metadata("design:type", ag_grid_community_1.ColumnController)
	    ], FiltersToolPanel.prototype, "columnController", void 0);
	    return FiltersToolPanel;
	}(ag_grid_community_1.Component));
	exports.FiltersToolPanel = FiltersToolPanel;


/***/ }),
/* 2547 */
/***/ (function(module, exports, __webpack_require__) {

	// ag-grid-enterprise v21.2.2
	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var ag_grid_community_1 = __webpack_require__(2322);
	var ToolPanelFilterComp = /** @class */ (function (_super) {
	    __extends(ToolPanelFilterComp, _super);
	    function ToolPanelFilterComp() {
	        var _this = _super.call(this, ToolPanelFilterComp.TEMPLATE) || this;
	        _this.expanded = false;
	        return _this;
	    }
	    ToolPanelFilterComp.prototype.postConstruct = function () {
	        this.eExpandChecked = ag_grid_community_1._.createIconNoSpan('columnSelectOpen', this.gridOptionsWrapper);
	        this.eExpandUnchecked = ag_grid_community_1._.createIconNoSpan('columnSelectClosed', this.gridOptionsWrapper);
	        this.eExpand.appendChild(this.eExpandChecked);
	        this.eExpand.appendChild(this.eExpandUnchecked);
	    };
	    ToolPanelFilterComp.prototype.setColumn = function (column) {
	        this.column = column;
	        var displayName = this.columnController.getDisplayNameForColumn(this.column, 'header', false);
	        this.eFilterName.innerText = displayName;
	        this.addDestroyableEventListener(this.eFilterToolPanelHeader, 'click', this.doExpandOrCollapse.bind(this));
	        this.addDestroyableEventListener(this.eventService, ag_grid_community_1.Events.EVENT_FILTER_OPENED, this.onFilterOpened.bind(this));
	        this.addInIcon('filter', this.eFilterIcon, this.column);
	        ag_grid_community_1._.addOrRemoveCssClass(this.eFilterIcon, 'ag-hidden', !this.isFilterActive());
	        ag_grid_community_1._.addCssClass(this.eExpandChecked, 'ag-hidden');
	        this.addDestroyableEventListener(this.column, ag_grid_community_1.Column.EVENT_FILTER_CHANGED, this.onFilterChanged.bind(this));
	    };
	    ToolPanelFilterComp.prototype.addInIcon = function (iconName, eParent, column) {
	        if (eParent == null) {
	            return;
	        }
	        var eIcon = ag_grid_community_1._.createIconNoSpan(iconName, this.gridOptionsWrapper, column);
	        eIcon.innerHTML = '&nbsp';
	        eParent.appendChild(eIcon);
	    };
	    ToolPanelFilterComp.prototype.isFilterActive = function () {
	        return this.filterManager.isFilterActive(this.column);
	    };
	    ToolPanelFilterComp.prototype.onFilterChanged = function () {
	        ag_grid_community_1._.addOrRemoveCssClass(this.eFilterIcon, 'ag-hidden', !this.isFilterActive());
	    };
	    ToolPanelFilterComp.prototype.doExpandOrCollapse = function () {
	        this.expanded ? this.doCollapse() : this.doExpand();
	    };
	    ToolPanelFilterComp.prototype.doExpand = function () {
	        var _this = this;
	        this.expanded = true;
	        var container = ag_grid_community_1._.loadTemplate("<div class=\"ag-filter-air\" />");
	        this.filterManager.getOrCreateFilterWrapper(this.column, 'TOOLBAR').filterPromise.then(function (filter) {
	            container.appendChild(filter.getGui());
	            _this.agFilterToolPanelBody.appendChild(container);
	            if (filter.afterGuiAttached) {
	                filter.afterGuiAttached({});
	            }
	        });
	        ag_grid_community_1._.setDisplayed(this.eExpandChecked, true);
	        ag_grid_community_1._.setDisplayed(this.eExpandUnchecked, false);
	    };
	    ToolPanelFilterComp.prototype.doCollapse = function () {
	        this.expanded = false;
	        this.agFilterToolPanelBody.removeChild(this.agFilterToolPanelBody.children[0]);
	        ag_grid_community_1._.setDisplayed(this.eExpandChecked, false);
	        ag_grid_community_1._.setDisplayed(this.eExpandUnchecked, true);
	    };
	    ToolPanelFilterComp.prototype.onFilterOpened = function (event) {
	        if (event.source !== 'COLUMN_MENU') {
	            return;
	        }
	        if (event.column !== this.column) {
	            return;
	        }
	        if (!this.expanded) {
	            return;
	        }
	        this.doCollapse();
	    };
	    ToolPanelFilterComp.TEMPLATE = "<div class=\"ag-filter-toolpanel-instance\" >\n            <div class=\"ag-filter-toolpanel-header ag-header-cell-label\" ref=\"eFilterToolPanelHeader\">\n                <div ref=\"eExpand\"></div>\n                <span ref=\"eFilterName\" class=\"ag-header-cell-text\"></span>\n                <span ref=\"eFilterIcon\" class=\"ag-header-icon ag-filter-icon\" aria-hidden=\"true\"></span>\n            </div>\n            <div class=\"ag-filter-toolpanel-body ag-filter\" ref=\"agFilterToolPanelBody\"/>\n        </div>";
	    __decorate([
	        ag_grid_community_1.Autowired('gridApi'),
	        __metadata("design:type", ag_grid_community_1.GridApi)
	    ], ToolPanelFilterComp.prototype, "gridApi", void 0);
	    __decorate([
	        ag_grid_community_1.Autowired('filterManager'),
	        __metadata("design:type", ag_grid_community_1.FilterManager)
	    ], ToolPanelFilterComp.prototype, "filterManager", void 0);
	    __decorate([
	        ag_grid_community_1.Autowired('eventService'),
	        __metadata("design:type", ag_grid_community_1.EventService)
	    ], ToolPanelFilterComp.prototype, "eventService", void 0);
	    __decorate([
	        ag_grid_community_1.Autowired('gridOptionsWrapper'),
	        __metadata("design:type", ag_grid_community_1.GridOptionsWrapper)
	    ], ToolPanelFilterComp.prototype, "gridOptionsWrapper", void 0);
	    __decorate([
	        ag_grid_community_1.Autowired('columnController'),
	        __metadata("design:type", ag_grid_community_1.ColumnController)
	    ], ToolPanelFilterComp.prototype, "columnController", void 0);
	    __decorate([
	        ag_grid_community_1.RefSelector('eFilterToolPanelHeader'),
	        __metadata("design:type", HTMLElement)
	    ], ToolPanelFilterComp.prototype, "eFilterToolPanelHeader", void 0);
	    __decorate([
	        ag_grid_community_1.RefSelector('eFilterName'),
	        __metadata("design:type", HTMLElement)
	    ], ToolPanelFilterComp.prototype, "eFilterName", void 0);
	    __decorate([
	        ag_grid_community_1.RefSelector('agFilterToolPanelBody'),
	        __metadata("design:type", HTMLElement)
	    ], ToolPanelFilterComp.prototype, "agFilterToolPanelBody", void 0);
	    __decorate([
	        ag_grid_community_1.RefSelector('eFilterIcon'),
	        __metadata("design:type", HTMLElement)
	    ], ToolPanelFilterComp.prototype, "eFilterIcon", void 0);
	    __decorate([
	        ag_grid_community_1.RefSelector('eExpand'),
	        __metadata("design:type", HTMLElement)
	    ], ToolPanelFilterComp.prototype, "eExpand", void 0);
	    __decorate([
	        ag_grid_community_1.PostConstruct,
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", []),
	        __metadata("design:returntype", void 0)
	    ], ToolPanelFilterComp.prototype, "postConstruct", null);
	    return ToolPanelFilterComp;
	}(ag_grid_community_1.Component));
	exports.ToolPanelFilterComp = ToolPanelFilterComp;


/***/ }),
/* 2548 */
/***/ (function(module, exports, __webpack_require__) {

	// ag-grid-enterprise v21.2.2
	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var ag_grid_community_1 = __webpack_require__(2322);
	var SetFloatingFilterComp = /** @class */ (function (_super) {
	    __extends(SetFloatingFilterComp, _super);
	    function SetFloatingFilterComp() {
	        return _super.call(this, "<div class=\"ag-input-wrapper\" role=\"presentation\"><input ref=\"eFloatingFilterText\" class=\"ag-floating-filter-input\"></div>") || this;
	    }
	    SetFloatingFilterComp.prototype.init = function (params) {
	        this.eFloatingFilterText.disabled = true;
	        this.column = params.column;
	    };
	    SetFloatingFilterComp.prototype.onParentModelChanged = function (parentModel) {
	        if (!parentModel) {
	            this.eFloatingFilterText.value = '';
	            return;
	        }
	        // also supporting old filter model for backwards compatibility
	        var values = (parentModel instanceof Array) ? parentModel : parentModel.values;
	        if (!values || values.length === 0) {
	            this.eFloatingFilterText.value = '';
	            return;
	        }
	        // format all the values, if a formatter is provided
	        for (var i = 0; i < values.length; i++) {
	            var valueUnformatted = values[i];
	            var valueFormatted = this.valueFormatterService.formatValue(this.column, null, null, valueUnformatted);
	            if (valueFormatted != null) {
	                values[i] = valueFormatted;
	            }
	        }
	        var arrayToDisplay = values.length > 10 ? values.slice(0, 10).concat('...') : values;
	        var valuesString = "(" + values.length + ") " + arrayToDisplay.join(",");
	        this.eFloatingFilterText.value = valuesString;
	    };
	    __decorate([
	        ag_grid_community_1.RefSelector('eFloatingFilterText'),
	        __metadata("design:type", HTMLInputElement)
	    ], SetFloatingFilterComp.prototype, "eFloatingFilterText", void 0);
	    __decorate([
	        ag_grid_community_1.Autowired('valueFormatterService'),
	        __metadata("design:type", ag_grid_community_1.ValueFormatterService)
	    ], SetFloatingFilterComp.prototype, "valueFormatterService", void 0);
	    return SetFloatingFilterComp;
	}(ag_grid_community_1.Component));
	exports.SetFloatingFilterComp = SetFloatingFilterComp;


/***/ }),
/* 2549 */
/***/ (function(module, exports, __webpack_require__) {

	// ag-grid-enterprise v21.2.2
	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var ag_grid_community_1 = __webpack_require__(2322);
	var menuItemComponent_1 = __webpack_require__(2509);
	var menuList_1 = __webpack_require__(2508);
	var menuItemMapper_1 = __webpack_require__(2510);
	var rangeController_1 = __webpack_require__(2512);
	var ContextMenuFactory = /** @class */ (function () {
	    function ContextMenuFactory() {
	    }
	    ContextMenuFactory.prototype.init = function () {
	    };
	    ContextMenuFactory.prototype.hideActiveMenu = function () {
	        if (!this.activeMenu) {
	            return;
	        }
	        this.activeMenu.destroy();
	    };
	    ContextMenuFactory.prototype.getMenuItems = function (node, column, value) {
	        var defaultMenuOptions = [];
	        if (ag_grid_community_1._.exists(node)) {
	            if (column) {
	                // only makes sense if column exists, could have originated from a row
	                defaultMenuOptions.push('copy', 'copyWithHeaders', 'paste', 'separator');
	            }
	        }
	        else {
	            // if user clicks outside of a cell (eg below the rows, or not rows present)
	            // nothing to show, perhaps tool panels???
	        }
	        if (this.gridOptionsWrapper.isEnableCharts() && this.context.isModuleRegistered("chartsModule" /* ChartsModule */)) {
	            if (this.columnController.isPivotMode()) {
	                defaultMenuOptions.push('pivotChart');
	            }
	            // else {
	            //     defaultMenuOptions.push('pivotChartAndPivotMode');
	            // }
	            if (!this.rangeController.isEmpty()) {
	                defaultMenuOptions.push('chartRange');
	            }
	        }
	        if (ag_grid_community_1._.exists(node)) {
	            // if user clicks a cell
	            var suppressExcel = this.gridOptionsWrapper.isSuppressExcelExport();
	            var suppressCsv = this.gridOptionsWrapper.isSuppressCsvExport();
	            var onIPad = ag_grid_community_1._.isUserAgentIPad();
	            var anyExport = !onIPad && (!suppressExcel || !suppressCsv);
	            if (anyExport) {
	                defaultMenuOptions.push('export');
	            }
	        }
	        if (this.gridOptionsWrapper.getContextMenuItemsFunc()) {
	            var userFunc = this.gridOptionsWrapper.getContextMenuItemsFunc();
	            var params = {
	                node: node,
	                column: column,
	                value: value,
	                defaultItems: defaultMenuOptions.length ? defaultMenuOptions : undefined,
	                api: this.gridOptionsWrapper.getApi(),
	                columnApi: this.gridOptionsWrapper.getColumnApi(),
	                context: this.gridOptionsWrapper.getContext()
	            };
	            return userFunc ? userFunc(params) : undefined;
	        }
	        return defaultMenuOptions;
	    };
	    ContextMenuFactory.prototype.showMenu = function (node, column, value, mouseEvent) {
	        var _this = this;
	        var menuItems = this.getMenuItems(node, column, value);
	        if (menuItems === undefined || ag_grid_community_1._.missingOrEmpty(menuItems)) {
	            return;
	        }
	        var menu = new ContextMenu(menuItems);
	        this.context.wireBean(menu);
	        var eMenuGui = menu.getGui();
	        // need to show filter before positioning, as only after filter
	        // is visible can we find out what the width of it is
	        var hidePopup = this.popupService.addAsModalPopup(eMenuGui, true, function () { return menu.destroy(); }, mouseEvent);
	        this.popupService.positionPopupUnderMouseEvent({
	            column: column,
	            rowNode: node,
	            type: 'contextMenu',
	            mouseEvent: mouseEvent,
	            ePopup: eMenuGui
	        });
	        menu.afterGuiAttached({
	            hidePopup: hidePopup
	        });
	        this.activeMenu = menu;
	        menu.addEventListener(ag_grid_community_1.BeanStub.EVENT_DESTROYED, function () {
	            if (_this.activeMenu === menu) {
	                _this.activeMenu = null;
	            }
	        });
	    };
	    __decorate([
	        ag_grid_community_1.Autowired('context'),
	        __metadata("design:type", ag_grid_community_1.Context)
	    ], ContextMenuFactory.prototype, "context", void 0);
	    __decorate([
	        ag_grid_community_1.Autowired('popupService'),
	        __metadata("design:type", ag_grid_community_1.PopupService)
	    ], ContextMenuFactory.prototype, "popupService", void 0);
	    __decorate([
	        ag_grid_community_1.Autowired('gridOptionsWrapper'),
	        __metadata("design:type", ag_grid_community_1.GridOptionsWrapper)
	    ], ContextMenuFactory.prototype, "gridOptionsWrapper", void 0);
	    __decorate([
	        ag_grid_community_1.Autowired('rowModel'),
	        __metadata("design:type", Object)
	    ], ContextMenuFactory.prototype, "rowModel", void 0);
	    __decorate([
	        ag_grid_community_1.Autowired('rangeController'),
	        __metadata("design:type", rangeController_1.RangeController)
	    ], ContextMenuFactory.prototype, "rangeController", void 0);
	    __decorate([
	        ag_grid_community_1.Autowired('columnController'),
	        __metadata("design:type", ag_grid_community_1.ColumnController)
	    ], ContextMenuFactory.prototype, "columnController", void 0);
	    __decorate([
	        ag_grid_community_1.PostConstruct,
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", []),
	        __metadata("design:returntype", void 0)
	    ], ContextMenuFactory.prototype, "init", null);
	    ContextMenuFactory = __decorate([
	        ag_grid_community_1.Bean('contextMenuFactory')
	    ], ContextMenuFactory);
	    return ContextMenuFactory;
	}());
	exports.ContextMenuFactory = ContextMenuFactory;
	var ContextMenu = /** @class */ (function (_super) {
	    __extends(ContextMenu, _super);
	    function ContextMenu(menuItems) {
	        var _this = _super.call(this, '<div class="ag-menu"></div>') || this;
	        _this.menuItems = menuItems;
	        return _this;
	    }
	    ContextMenu.prototype.addMenuItems = function () {
	        var menuList = new menuList_1.MenuList();
	        this.getContext().wireBean(menuList);
	        var menuItemsMapped = this.menuItemMapper.mapWithStockItems(this.menuItems, null);
	        menuList.addMenuItems(menuItemsMapped);
	        this.appendChild(menuList);
	        menuList.addEventListener(menuItemComponent_1.MenuItemComponent.EVENT_ITEM_SELECTED, this.destroy.bind(this));
	    };
	    ContextMenu.prototype.afterGuiAttached = function (params) {
	        if (params.hidePopup) {
	            this.addDestroyFunc(params.hidePopup);
	        }
	        // if the body scrolls, we want to hide the menu, as the menu will not appear in the right location anymore
	        this.addDestroyableEventListener(this.eventService, 'bodyScroll', this.destroy.bind(this));
	    };
	    __decorate([
	        ag_grid_community_1.Autowired('eventService'),
	        __metadata("design:type", ag_grid_community_1.EventService)
	    ], ContextMenu.prototype, "eventService", void 0);
	    __decorate([
	        ag_grid_community_1.Autowired('menuItemMapper'),
	        __metadata("design:type", menuItemMapper_1.MenuItemMapper)
	    ], ContextMenu.prototype, "menuItemMapper", void 0);
	    __decorate([
	        ag_grid_community_1.PostConstruct,
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", []),
	        __metadata("design:returntype", void 0)
	    ], ContextMenu.prototype, "addMenuItems", null);
	    return ContextMenu;
	}(ag_grid_community_1.Component));


/***/ }),
/* 2550 */
/***/ (function(module, exports, __webpack_require__) {

	// ag-grid-enterprise v21.2.2
	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var ag_grid_community_1 = __webpack_require__(2322);
	var ViewportRowModel = /** @class */ (function () {
	    function ViewportRowModel() {
	        // rowRenderer tells us these
	        this.firstRow = -1;
	        this.lastRow = -1;
	        // datasource tells us this
	        this.rowCount = -1;
	        this.rowNodesByIndex = {};
	    }
	    // we don't implement as lazy row heights is not supported in this row model
	    ViewportRowModel.prototype.ensureRowHeightsValid = function (startPixel, endPixel, startLimitIndex, endLimitIndex) { return false; };
	    ViewportRowModel.prototype.init = function () {
	        this.rowHeight = this.gridOptionsWrapper.getRowHeightAsNumber();
	        this.eventService.addEventListener(ag_grid_community_1.Events.EVENT_VIEWPORT_CHANGED, this.onViewportChanged.bind(this));
	        var viewportEnabled = this.gridOptionsWrapper.isRowModelViewport();
	        if (viewportEnabled && this.gridOptionsWrapper.getViewportDatasource()) {
	            this.setViewportDatasource(this.gridOptionsWrapper.getViewportDatasource());
	        }
	    };
	    ViewportRowModel.prototype.isLastRowFound = function () {
	        return true;
	    };
	    ViewportRowModel.prototype.destroyDatasource = function () {
	        if (this.viewportDatasource) {
	            if (this.viewportDatasource.destroy) {
	                this.viewportDatasource.destroy();
	            }
	            this.rowRenderer.datasourceChanged();
	            this.firstRow = -1;
	            this.lastRow = -1;
	        }
	    };
	    ViewportRowModel.prototype.calculateFirstRow = function (firstRenderedRow) {
	        var bufferSize = this.gridOptionsWrapper.getViewportRowModelBufferSize();
	        var pageSize = this.gridOptionsWrapper.getViewportRowModelPageSize();
	        var afterBuffer = firstRenderedRow - bufferSize;
	        if (afterBuffer < 0) {
	            return 0;
	        }
	        else {
	            return Math.floor(afterBuffer / pageSize) * pageSize;
	        }
	    };
	    ViewportRowModel.prototype.calculateLastRow = function (lastRenderedRow) {
	        if (lastRenderedRow === -1) {
	            return lastRenderedRow;
	        }
	        var bufferSize = this.gridOptionsWrapper.getViewportRowModelBufferSize();
	        var pageSize = this.gridOptionsWrapper.getViewportRowModelPageSize();
	        var afterBuffer = lastRenderedRow + bufferSize;
	        var result = Math.ceil(afterBuffer / pageSize) * pageSize;
	        var lastRowIndex = this.rowCount - 1;
	        return Math.min(result, lastRowIndex);
	    };
	    ViewportRowModel.prototype.onViewportChanged = function (event) {
	        var newFirst = this.calculateFirstRow(event.firstRow);
	        var newLast = this.calculateLastRow(event.lastRow);
	        if (this.firstRow !== newFirst || this.lastRow !== newLast) {
	            this.firstRow = newFirst;
	            this.lastRow = newLast;
	            this.purgeRowsNotInViewport();
	            if (this.viewportDatasource) {
	                this.viewportDatasource.setViewportRange(this.firstRow, this.lastRow);
	            }
	        }
	    };
	    ViewportRowModel.prototype.purgeRowsNotInViewport = function () {
	        var _this = this;
	        Object.keys(this.rowNodesByIndex).forEach(function (indexStr) {
	            var index = parseInt(indexStr, 10);
	            if (index < _this.firstRow || index > _this.lastRow) {
	                delete _this.rowNodesByIndex[index];
	            }
	        });
	    };
	    ViewportRowModel.prototype.setViewportDatasource = function (viewportDatasource) {
	        this.destroyDatasource();
	        this.viewportDatasource = viewportDatasource;
	        this.rowCount = 0;
	        if (!viewportDatasource.init) {
	            console.warn('ag-Grid: viewport is missing init method.');
	        }
	        else {
	            viewportDatasource.init({
	                setRowCount: this.setRowCount.bind(this),
	                setRowData: this.setRowData.bind(this),
	                getRow: this.getRow.bind(this)
	            });
	        }
	    };
	    ViewportRowModel.prototype.getType = function () {
	        return ag_grid_community_1.Constants.ROW_MODEL_TYPE_VIEWPORT;
	    };
	    ViewportRowModel.prototype.getRow = function (rowIndex) {
	        if (!this.rowNodesByIndex[rowIndex]) {
	            this.rowNodesByIndex[rowIndex] = this.createBlankRowNode(rowIndex);
	        }
	        return this.rowNodesByIndex[rowIndex];
	    };
	    ViewportRowModel.prototype.getRowNode = function (id) {
	        var result = null;
	        this.forEachNode(function (rowNode) {
	            if (rowNode.id === id) {
	                result = rowNode;
	            }
	        });
	        return result;
	    };
	    ViewportRowModel.prototype.getRowCount = function () {
	        return this.rowCount;
	    };
	    ViewportRowModel.prototype.getRowIndexAtPixel = function (pixel) {
	        if (this.rowHeight !== 0) { // avoid divide by zero error
	            return Math.floor(pixel / this.rowHeight);
	        }
	        else {
	            return 0;
	        }
	    };
	    ViewportRowModel.prototype.getRowBounds = function (index) {
	        return {
	            rowHeight: this.rowHeight,
	            rowTop: this.rowHeight * index
	        };
	    };
	    ViewportRowModel.prototype.getTopLevelRowCount = function () {
	        return this.getRowCount();
	    };
	    ViewportRowModel.prototype.getTopLevelRowDisplayedIndex = function (topLevelIndex) {
	        return topLevelIndex;
	    };
	    ViewportRowModel.prototype.getCurrentPageHeight = function () {
	        return this.rowCount * this.rowHeight;
	    };
	    ViewportRowModel.prototype.isEmpty = function () {
	        return this.rowCount > 0;
	    };
	    ViewportRowModel.prototype.isRowsToRender = function () {
	        return this.rowCount > 0;
	    };
	    ViewportRowModel.prototype.getNodesInRangeForSelection = function (firstInRange, lastInRange) {
	        var firstIndex = ag_grid_community_1._.missing(firstInRange) ? 0 : firstInRange.rowIndex;
	        var lastIndex = lastInRange.rowIndex;
	        var firstNodeOutOfRange = firstIndex < this.firstRow || firstIndex > this.lastRow;
	        var lastNodeOutOfRange = lastIndex < this.firstRow || lastIndex > this.lastRow;
	        if (firstNodeOutOfRange || lastNodeOutOfRange) {
	            return [];
	        }
	        var result = [];
	        var startIndex = firstIndex <= lastIndex ? firstIndex : lastIndex;
	        var endIndex = firstIndex <= lastIndex ? lastIndex : firstIndex;
	        for (var i = startIndex; i <= endIndex; i++) {
	            result.push(this.rowNodesByIndex[i]);
	        }
	        return result;
	    };
	    ViewportRowModel.prototype.forEachNode = function (callback) {
	        var _this = this;
	        var callbackCount = 0;
	        Object.keys(this.rowNodesByIndex).forEach(function (indexStr) {
	            var index = parseInt(indexStr, 10);
	            var rowNode = _this.rowNodesByIndex[index];
	            callback(rowNode, callbackCount);
	            callbackCount++;
	        });
	    };
	    ViewportRowModel.prototype.setRowData = function (rowData) {
	        var _this = this;
	        ag_grid_community_1._.iterateObject(rowData, function (indexStr, dataItem) {
	            var index = parseInt(indexStr, 10);
	            // we should never keep rows that we didn't specifically ask for, this
	            // guarantees the contract we have with the server.
	            if (index >= _this.firstRow && index <= _this.lastRow) {
	                var rowNode = _this.rowNodesByIndex[index];
	                // the abnormal case is we requested a row even though the grid didn't need it
	                // as a result of the paging and buffer (ie the row is off screen), in which
	                // case we need to create a new node now
	                if (ag_grid_community_1._.missing(rowNode)) {
	                    rowNode = _this.createBlankRowNode(index);
	                    _this.rowNodesByIndex[index] = rowNode;
	                }
	                // now we deffo have a row node, so set in the details
	                // if the grid already asked for this row (the normal case), then we would
	                // of put a placeholder node in place.
	                rowNode.setDataAndId(dataItem, index.toString());
	            }
	        });
	    };
	    ViewportRowModel.prototype.createBlankRowNode = function (rowIndex) {
	        var rowNode = new ag_grid_community_1.RowNode();
	        this.context.wireBean(rowNode);
	        rowNode.setRowHeight(this.rowHeight);
	        rowNode.setRowTop(this.rowHeight * rowIndex);
	        rowNode.setRowIndex(rowIndex);
	        return rowNode;
	    };
	    ViewportRowModel.prototype.setRowCount = function (rowCount) {
	        if (rowCount !== this.rowCount) {
	            this.rowCount = rowCount;
	            var event_1 = {
	                type: ag_grid_community_1.Events.EVENT_MODEL_UPDATED,
	                api: this.gridApi,
	                columnApi: this.columnApi,
	                newData: false,
	                newPage: false,
	                keepRenderedRows: false,
	                animate: false
	            };
	            this.eventService.dispatchEvent(event_1);
	        }
	    };
	    ViewportRowModel.prototype.isRowPresent = function (rowNode) {
	        return false;
	    };
	    __decorate([
	        ag_grid_community_1.Autowired('gridOptionsWrapper'),
	        __metadata("design:type", ag_grid_community_1.GridOptionsWrapper)
	    ], ViewportRowModel.prototype, "gridOptionsWrapper", void 0);
	    __decorate([
	        ag_grid_community_1.Autowired('eventService'),
	        __metadata("design:type", ag_grid_community_1.EventService)
	    ], ViewportRowModel.prototype, "eventService", void 0);
	    __decorate([
	        ag_grid_community_1.Autowired('selectionController'),
	        __metadata("design:type", ag_grid_community_1.SelectionController)
	    ], ViewportRowModel.prototype, "selectionController", void 0);
	    __decorate([
	        ag_grid_community_1.Autowired('context'),
	        __metadata("design:type", ag_grid_community_1.Context)
	    ], ViewportRowModel.prototype, "context", void 0);
	    __decorate([
	        ag_grid_community_1.Autowired('gridApi'),
	        __metadata("design:type", ag_grid_community_1.GridApi)
	    ], ViewportRowModel.prototype, "gridApi", void 0);
	    __decorate([
	        ag_grid_community_1.Autowired('columnApi'),
	        __metadata("design:type", ag_grid_community_1.ColumnApi)
	    ], ViewportRowModel.prototype, "columnApi", void 0);
	    __decorate([
	        ag_grid_community_1.Autowired('rowRenderer'),
	        __metadata("design:type", ag_grid_community_1.RowRenderer)
	    ], ViewportRowModel.prototype, "rowRenderer", void 0);
	    __decorate([
	        ag_grid_community_1.PostConstruct,
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", []),
	        __metadata("design:returntype", void 0)
	    ], ViewportRowModel.prototype, "init", null);
	    __decorate([
	        ag_grid_community_1.PreDestroy,
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", []),
	        __metadata("design:returntype", void 0)
	    ], ViewportRowModel.prototype, "destroyDatasource", null);
	    ViewportRowModel = __decorate([
	        ag_grid_community_1.Bean('rowModel')
	    ], ViewportRowModel);
	    return ViewportRowModel;
	}());
	exports.ViewportRowModel = ViewportRowModel;


/***/ }),
/* 2551 */
/***/ (function(module, exports, __webpack_require__) {

	// ag-grid-enterprise v21.2.2
	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var ag_grid_community_1 = __webpack_require__(2322);
	var sideBarButtonsComp_1 = __webpack_require__(2552);
	var toolPanelWrapper_1 = __webpack_require__(2553);
	var SideBarComp = /** @class */ (function (_super) {
	    __extends(SideBarComp, _super);
	    function SideBarComp() {
	        var _this = _super.call(this, SideBarComp.TEMPLATE) || this;
	        _this.toolPanelWrappers = [];
	        return _this;
	    }
	    SideBarComp.prototype.postConstruct = function () {
	        this.sideBarButtonsComp.addEventListener(sideBarButtonsComp_1.SideBarButtonsComp.EVENT_SIDE_BAR_BUTTON_CLICKED, this.onToolPanelButtonClicked.bind(this));
	        this.setSideBarDef();
	    };
	    SideBarComp.prototype.onToolPanelButtonClicked = function (event) {
	        var id = event.toolPanelId;
	        var openedItem = this.openedItem();
	        // if item was already open, we close it
	        if (openedItem === id) {
	            this.openToolPanel(undefined); // passing undefined closes
	        }
	        else {
	            this.openToolPanel(id);
	        }
	    };
	    SideBarComp.prototype.clearDownUi = function () {
	        this.sideBarButtonsComp.clearButtons();
	        this.destroyToolPanelWrappers();
	    };
	    SideBarComp.prototype.setSideBarDef = function () {
	        var _this = this;
	        var sideBar = this.gridOptionsWrapper.getSideBar();
	        var sideBarExists = !!sideBar && !!sideBar.toolPanels;
	        if (sideBarExists) {
	            var toolPanelDefs = sideBar.toolPanels;
	            this.sideBarButtonsComp.setToolPanelDefs(toolPanelDefs);
	            this.setupToolPanels(toolPanelDefs);
	            if (!sideBar.hiddenByDefault) {
	                this.openToolPanel(sideBar.defaultToolPanel);
	            }
	        }
	        var sideBarVisible = sideBarExists && !sideBar.hiddenByDefault;
	        setTimeout(function () { return _this.setDisplayed(sideBarVisible); }, 0);
	    };
	    SideBarComp.prototype.setupToolPanels = function (defs) {
	        var _this = this;
	        defs.forEach(function (def) {
	            if (def.id == null) {
	                console.warn("ag-grid: please review all your toolPanel components, it seems like at least one of them doesn't have an id");
	                return;
	            }
	            var wrapper = new toolPanelWrapper_1.ToolPanelWrapper();
	            _this.getContext().wireBean(wrapper);
	            wrapper.setToolPanelDef(def);
	            wrapper.setDisplayed(false);
	            _this.getGui().appendChild(wrapper.getGui());
	            _this.toolPanelWrappers.push(wrapper);
	        });
	    };
	    SideBarComp.prototype.refresh = function () {
	        this.toolPanelWrappers.forEach(function (wrapper) { return wrapper.refresh(); });
	    };
	    SideBarComp.prototype.openToolPanel = function (key) {
	        var currentlyOpenedKey = this.openedItem();
	        if (currentlyOpenedKey === key) {
	            return;
	        }
	        this.toolPanelWrappers.forEach(function (wrapper) {
	            var show = key === wrapper.getToolPanelId();
	            wrapper.setDisplayed(show);
	        });
	        var newlyOpenedKey = this.openedItem();
	        var openToolPanelChanged = currentlyOpenedKey !== newlyOpenedKey;
	        if (openToolPanelChanged) {
	            this.sideBarButtonsComp.setActiveButton(key);
	            this.raiseToolPanelVisibleEvent(key);
	        }
	    };
	    SideBarComp.prototype.raiseToolPanelVisibleEvent = function (key) {
	        var event = {
	            type: ag_grid_community_1.Events.EVENT_TOOL_PANEL_VISIBLE_CHANGED,
	            source: key,
	            api: this.gridOptionsWrapper.getApi(),
	            columnApi: this.gridOptionsWrapper.getColumnApi()
	        };
	        this.eventService.dispatchEvent(event);
	    };
	    SideBarComp.prototype.close = function () {
	        this.openToolPanel(undefined);
	    };
	    SideBarComp.prototype.isToolPanelShowing = function () {
	        return !!this.openedItem();
	    };
	    SideBarComp.prototype.openedItem = function () {
	        var activeToolPanel = null;
	        this.toolPanelWrappers.forEach(function (wrapper) {
	            if (wrapper.isDisplayed()) {
	                activeToolPanel = wrapper.getToolPanelId();
	            }
	        });
	        return activeToolPanel;
	    };
	    // get called after user sets new sideBarDef via the API
	    SideBarComp.prototype.reset = function () {
	        this.clearDownUi();
	        this.setSideBarDef();
	    };
	    SideBarComp.prototype.destroyToolPanelWrappers = function () {
	        this.toolPanelWrappers.forEach(function (wrapper) {
	            ag_grid_community_1._.removeFromParent(wrapper.getGui());
	            wrapper.destroy();
	        });
	        this.toolPanelWrappers.length = 0;
	    };
	    SideBarComp.prototype.destroy = function () {
	        this.destroyToolPanelWrappers();
	        _super.prototype.destroy.call(this);
	    };
	    SideBarComp.TEMPLATE = "<div class=\"ag-side-bar ag-unselectable\">\n              <ag-side-bar-buttons ref=\"sideBarButtons\">\n          </div>";
	    __decorate([
	        ag_grid_community_1.Autowired("eventService"),
	        __metadata("design:type", ag_grid_community_1.EventService)
	    ], SideBarComp.prototype, "eventService", void 0);
	    __decorate([
	        ag_grid_community_1.Autowired("gridOptionsWrapper"),
	        __metadata("design:type", ag_grid_community_1.GridOptionsWrapper)
	    ], SideBarComp.prototype, "gridOptionsWrapper", void 0);
	    __decorate([
	        ag_grid_community_1.RefSelector('sideBarButtons'),
	        __metadata("design:type", sideBarButtonsComp_1.SideBarButtonsComp)
	    ], SideBarComp.prototype, "sideBarButtonsComp", void 0);
	    __decorate([
	        ag_grid_community_1.PostConstruct,
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", []),
	        __metadata("design:returntype", void 0)
	    ], SideBarComp.prototype, "postConstruct", null);
	    return SideBarComp;
	}(ag_grid_community_1.Component));
	exports.SideBarComp = SideBarComp;


/***/ }),
/* 2552 */
/***/ (function(module, exports, __webpack_require__) {

	// ag-grid-enterprise v21.2.2
	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var ag_grid_community_1 = __webpack_require__(2322);
	var SideBarButtonsComp = /** @class */ (function (_super) {
	    __extends(SideBarButtonsComp, _super);
	    function SideBarButtonsComp() {
	        var _this = _super.call(this, SideBarButtonsComp.TEMPLATE) || this;
	        _this.buttonComps = [];
	        return _this;
	    }
	    SideBarButtonsComp.prototype.setToolPanelDefs = function (toolPanelDefs) {
	        toolPanelDefs.forEach(this.addButtonComp.bind(this));
	    };
	    SideBarButtonsComp.prototype.setActiveButton = function (id) {
	        this.buttonComps.forEach(function (comp) {
	            comp.setSelected(id === comp.getToolPanelId());
	        });
	    };
	    SideBarButtonsComp.prototype.addButtonComp = function (def) {
	        var _this = this;
	        var buttonComp = new SideBarButtonComp(def);
	        this.getContext().wireBean(buttonComp);
	        this.buttonComps.push(buttonComp);
	        this.getGui().appendChild(buttonComp.getGui());
	        buttonComp.addEventListener(SideBarButtonComp.EVENT_TOGGLE_BUTTON_CLICKED, function () {
	            _this.dispatchEvent({
	                type: SideBarButtonsComp.EVENT_SIDE_BAR_BUTTON_CLICKED,
	                toolPanelId: def.id
	            });
	        });
	    };
	    SideBarButtonsComp.prototype.clearButtons = function () {
	        if (this.buttonComps) {
	            this.buttonComps.forEach(function (comp) { return comp.destroy(); });
	        }
	        ag_grid_community_1._.clearElement(this.getGui());
	        this.buttonComps.length = 0;
	    };
	    SideBarButtonsComp.prototype.destroy = function () {
	        this.clearButtons();
	        _super.prototype.destroy.call(this);
	    };
	    SideBarButtonsComp.EVENT_SIDE_BAR_BUTTON_CLICKED = 'sideBarButtonClicked';
	    SideBarButtonsComp.TEMPLATE = "<div class=\"ag-side-buttons\"></div>";
	    __decorate([
	        ag_grid_community_1.Autowired("gridOptionsWrapper"),
	        __metadata("design:type", ag_grid_community_1.GridOptionsWrapper)
	    ], SideBarButtonsComp.prototype, "gridOptionsWrapper", void 0);
	    return SideBarButtonsComp;
	}(ag_grid_community_1.Component));
	exports.SideBarButtonsComp = SideBarButtonsComp;
	var SideBarButtonComp = /** @class */ (function (_super) {
	    __extends(SideBarButtonComp, _super);
	    function SideBarButtonComp(toolPanelDef) {
	        var _this = _super.call(this) || this;
	        _this.toolPanelDef = toolPanelDef;
	        return _this;
	    }
	    SideBarButtonComp.prototype.getToolPanelId = function () {
	        return this.toolPanelDef.id;
	    };
	    SideBarButtonComp.prototype.postConstruct = function () {
	        var template = this.createTemplate();
	        this.setTemplate(template);
	        var toggleButton = this.eToggleButton;
	        var iconDiv = toggleButton.querySelector('div');
	        iconDiv.insertAdjacentElement('afterbegin', ag_grid_community_1._.createIconNoSpan(this.toolPanelDef.iconKey, this.gridOptionsWrapper));
	        this.addDestroyableEventListener(this.eToggleButton, 'click', this.onButtonPressed.bind(this));
	    };
	    SideBarButtonComp.prototype.createTemplate = function () {
	        var translate = this.gridOptionsWrapper.getLocaleTextFunc();
	        var def = this.toolPanelDef;
	        var label = translate(def.labelKey, def.labelDefault);
	        var res = "<div class=\"ag-side-button\">\n                <button type=\"button\" ref=\"eToggleButton\">\n                    <div></div>\n                    <span>" + label + "</span>\n                </button>\n            </div>";
	        return res;
	    };
	    SideBarButtonComp.prototype.onButtonPressed = function () {
	        this.dispatchEvent({ type: SideBarButtonComp.EVENT_TOGGLE_BUTTON_CLICKED });
	    };
	    SideBarButtonComp.prototype.setSelected = function (selected) {
	        this.addOrRemoveCssClass('ag-selected', selected);
	    };
	    SideBarButtonComp.EVENT_TOGGLE_BUTTON_CLICKED = 'toggleButtonClicked';
	    __decorate([
	        ag_grid_community_1.Autowired("gridOptionsWrapper"),
	        __metadata("design:type", ag_grid_community_1.GridOptionsWrapper)
	    ], SideBarButtonComp.prototype, "gridOptionsWrapper", void 0);
	    __decorate([
	        ag_grid_community_1.RefSelector('eToggleButton'),
	        __metadata("design:type", HTMLButtonElement)
	    ], SideBarButtonComp.prototype, "eToggleButton", void 0);
	    __decorate([
	        ag_grid_community_1.PostConstruct,
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", []),
	        __metadata("design:returntype", void 0)
	    ], SideBarButtonComp.prototype, "postConstruct", null);
	    return SideBarButtonComp;
	}(ag_grid_community_1.Component));


/***/ }),
/* 2553 */
/***/ (function(module, exports, __webpack_require__) {

	// ag-grid-enterprise v21.2.2
	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var ag_grid_community_1 = __webpack_require__(2322);
	var horizontalResizeComp_1 = __webpack_require__(2554);
	var ToolPanelWrapper = /** @class */ (function (_super) {
	    __extends(ToolPanelWrapper, _super);
	    function ToolPanelWrapper() {
	        return _super.call(this, ToolPanelWrapper.TEMPLATE) || this;
	    }
	    ToolPanelWrapper.prototype.getToolPanelId = function () {
	        return this.toolPanelId;
	    };
	    ToolPanelWrapper.prototype.setToolPanelDef = function (toolPanelDef) {
	        this.toolPanelId = toolPanelDef.id;
	        var params = {
	            api: this.gridOptionsWrapper.getApi()
	        };
	        var componentPromise = this.userComponentFactory.newToolPanelComponent(toolPanelDef, params);
	        if (componentPromise == null) {
	            console.warn("ag-grid: error processing tool panel component " + toolPanelDef.id + ". You need to specify either 'toolPanel' or 'toolPanelFramework'");
	            return;
	        }
	        componentPromise.then(this.setToolPanelComponent.bind(this));
	    };
	    ToolPanelWrapper.prototype.setupResize = function () {
	        var resizeBar = new horizontalResizeComp_1.HorizontalResizeComp();
	        this.getContext().wireBean(resizeBar);
	        resizeBar.setElementToResize(this.getGui());
	        this.appendChild(resizeBar);
	    };
	    ToolPanelWrapper.prototype.setToolPanelComponent = function (compInstance) {
	        this.toolPanelCompInstance = compInstance;
	        this.appendChild(compInstance);
	    };
	    ToolPanelWrapper.prototype.refresh = function () {
	        this.toolPanelCompInstance.refresh();
	    };
	    ToolPanelWrapper.TEMPLATE = "<div class=\"ag-tool-panel-wrapper\"/>";
	    __decorate([
	        ag_grid_community_1.Autowired("userComponentFactory"),
	        __metadata("design:type", ag_grid_community_1.UserComponentFactory)
	    ], ToolPanelWrapper.prototype, "userComponentFactory", void 0);
	    __decorate([
	        ag_grid_community_1.Autowired("gridOptionsWrapper"),
	        __metadata("design:type", ag_grid_community_1.GridOptionsWrapper)
	    ], ToolPanelWrapper.prototype, "gridOptionsWrapper", void 0);
	    __decorate([
	        ag_grid_community_1.PostConstruct,
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", []),
	        __metadata("design:returntype", void 0)
	    ], ToolPanelWrapper.prototype, "setupResize", null);
	    return ToolPanelWrapper;
	}(ag_grid_community_1.Component));
	exports.ToolPanelWrapper = ToolPanelWrapper;


/***/ }),
/* 2554 */
/***/ (function(module, exports, __webpack_require__) {

	// ag-grid-enterprise v21.2.2
	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var ag_grid_community_1 = __webpack_require__(2322);
	var HorizontalResizeComp = /** @class */ (function (_super) {
	    __extends(HorizontalResizeComp, _super);
	    function HorizontalResizeComp() {
	        return _super.call(this, "<div class=\"ag-tool-panel-horizontal-resize\"></div>") || this;
	    }
	    HorizontalResizeComp.prototype.setElementToResize = function (elementToResize) {
	        this.elementToResize = elementToResize;
	    };
	    HorizontalResizeComp.prototype.postConstruct = function () {
	        var finishedWithResizeFunc = this.horizontalResizeService.addResizeBar({
	            eResizeBar: this.getGui(),
	            dragStartPixels: 1,
	            onResizeStart: this.onResizeStart.bind(this),
	            onResizing: this.onResizing.bind(this),
	            onResizeEnd: this.onResizing.bind(this)
	        });
	        this.addDestroyFunc(finishedWithResizeFunc);
	    };
	    HorizontalResizeComp.prototype.onResizeStart = function () {
	        this.startingWidth = this.elementToResize.offsetWidth;
	    };
	    HorizontalResizeComp.prototype.onResizing = function (delta) {
	        var direction = this.gridOptionsWrapper.isEnableRtl() ? -1 : 1;
	        var newWidth = Math.max(100, Math.floor(this.startingWidth - (delta * direction)));
	        this.elementToResize.style.width = newWidth + "px";
	    };
	    __decorate([
	        ag_grid_community_1.Autowired('horizontalResizeService'),
	        __metadata("design:type", ag_grid_community_1.HorizontalResizeService)
	    ], HorizontalResizeComp.prototype, "horizontalResizeService", void 0);
	    __decorate([
	        ag_grid_community_1.Autowired('gridOptionsWrapper'),
	        __metadata("design:type", ag_grid_community_1.GridOptionsWrapper)
	    ], HorizontalResizeComp.prototype, "gridOptionsWrapper", void 0);
	    __decorate([
	        ag_grid_community_1.Autowired('eventService'),
	        __metadata("design:type", ag_grid_community_1.EventService)
	    ], HorizontalResizeComp.prototype, "eventService", void 0);
	    __decorate([
	        ag_grid_community_1.PostConstruct,
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", []),
	        __metadata("design:returntype", void 0)
	    ], HorizontalResizeComp.prototype, "postConstruct", null);
	    return HorizontalResizeComp;
	}(ag_grid_community_1.Component));
	exports.HorizontalResizeComp = HorizontalResizeComp;


/***/ }),
/* 2555 */
/***/ (function(module, exports, __webpack_require__) {

	// ag-grid-enterprise v21.2.2
	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var ag_grid_community_1 = __webpack_require__(2322);
	var excelXmlSerializingSession_1 = __webpack_require__(2556);
	var excelXlsxSerializingSession_1 = __webpack_require__(2557);
	var excelXmlFactory_1 = __webpack_require__(2558);
	var excelXlsxFactory_1 = __webpack_require__(2573);
	var ExcelCreator = /** @class */ (function (_super) {
	    __extends(ExcelCreator, _super);
	    function ExcelCreator() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    ExcelCreator.prototype.postConstruct = function () {
	        this.setBeans({
	            downloader: this.downloader,
	            gridSerializer: this.gridSerializer,
	            gridOptionsWrapper: this.gridOptionsWrapper
	        });
	    };
	    ExcelCreator.prototype.exportDataAsExcel = function (params) {
	        if (params && params.exportMode) {
	            this.setExportMode(params.exportMode);
	        }
	        return this.export(params);
	    };
	    ExcelCreator.prototype.getDataAsExcelXml = function (params) {
	        if (params && params.exportMode) {
	            delete params.exportMode;
	        }
	        this.setExportMode('xml');
	        return this.getData(params || {});
	    };
	    ExcelCreator.prototype.getMimeType = function () {
	        return this.getExportMode() === 'xml' ? 'application/vnd.ms-excel' : 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
	    };
	    ExcelCreator.prototype.getDefaultFileName = function () {
	        return "export." + this.getExportMode();
	    };
	    ExcelCreator.prototype.getDefaultFileExtension = function () {
	        return this.getExportMode();
	    };
	    ExcelCreator.prototype.createSerializingSession = function (params) {
	        var _a = this, columnController = _a.columnController, valueService = _a.valueService, gridOptionsWrapper = _a.gridOptionsWrapper;
	        var processCellCallback = params.processCellCallback, processHeaderCallback = params.processHeaderCallback, suppressTextAsCDATA = params.suppressTextAsCDATA, rowHeight = params.rowHeight, headerRowHeight = params.headerRowHeight;
	        var isXlsx = this.getExportMode() === 'xlsx';
	        var excelFactory = isXlsx ? this.xlsxFactory : this.excelXmlFactory;
	        var sheetName = 'ag-grid';
	        if (ag_grid_community_1._.exists(params.sheetName)) {
	            sheetName = ag_grid_community_1._.utf8_encode(params.sheetName.toString().substr(0, 31));
	        }
	        var config = {
	            columnController: columnController,
	            valueService: valueService,
	            gridOptionsWrapper: gridOptionsWrapper,
	            processCellCallback: processCellCallback,
	            processHeaderCallback: processHeaderCallback,
	            rowHeight: rowHeight,
	            headerRowHeight: headerRowHeight || rowHeight,
	            sheetName: sheetName,
	            excelFactory: excelFactory,
	            baseExcelStyles: this.gridOptions.excelStyles || undefined,
	            styleLinker: this.styleLinker.bind(this),
	            suppressTextAsCDATA: suppressTextAsCDATA || false
	        };
	        return new (isXlsx ? excelXlsxSerializingSession_1.ExcelXlsxSerializingSession : excelXmlSerializingSession_1.ExcelXmlSerializingSession)(config);
	    };
	    ExcelCreator.prototype.styleLinker = function (rowType, rowIndex, colIndex, value, column, node) {
	        if ((rowType === ag_grid_community_1.RowType.HEADER) || (rowType === ag_grid_community_1.RowType.HEADER_GROUPING)) {
	            return ["header"];
	        }
	        var styles = this.gridOptions.excelStyles;
	        if (!styles || !styles.length) {
	            return null;
	        }
	        var styleIds = styles.map(function (it) {
	            return it.id;
	        });
	        var applicableStyles = [];
	        this.stylingService.processAllCellClasses(column.getColDef(), {
	            value: value,
	            data: node.data,
	            node: node,
	            colDef: column.getColDef(),
	            rowIndex: rowIndex,
	            api: this.gridOptionsWrapper.getApi(),
	            context: this.gridOptionsWrapper.getContext()
	        }, function (className) {
	            if (styleIds.indexOf(className) > -1) {
	                applicableStyles.push(className);
	            }
	        });
	        return applicableStyles.sort(function (left, right) {
	            return (styleIds.indexOf(left) < styleIds.indexOf(right)) ? -1 : 1;
	        });
	    };
	    ExcelCreator.prototype.isExportSuppressed = function () {
	        return this.gridOptionsWrapper.isSuppressExcelExport();
	    };
	    ExcelCreator.prototype.setExportMode = function (exportMode) {
	        this.exportMode = exportMode;
	    };
	    ExcelCreator.prototype.getExportMode = function () {
	        return this.exportMode || 'xlsx';
	    };
	    ExcelCreator.prototype.packageFile = function (data) {
	        if (this.getExportMode() === 'xml') {
	            return _super.prototype.packageFile.call(this, data);
	        }
	        var _a = this, zipContainer = _a.zipContainer, xlsxFactory = _a.xlsxFactory;
	        zipContainer.addFolders([
	            'xl/worksheets/',
	            'xl/',
	            'xl/theme/',
	            'xl/_rels/',
	            'docProps/',
	            '_rels/'
	        ]);
	        zipContainer.addFile('xl/worksheets/sheet1.xml', data);
	        zipContainer.addFile('xl/workbook.xml', xlsxFactory.createWorkbook());
	        zipContainer.addFile('xl/styles.xml', xlsxFactory.createStylesheet());
	        zipContainer.addFile('xl/sharedStrings.xml', xlsxFactory.createSharedStrings());
	        zipContainer.addFile('xl/theme/theme1.xml', xlsxFactory.createTheme());
	        zipContainer.addFile('xl/_rels/workbook.xml.rels', xlsxFactory.createWorkbookRels());
	        zipContainer.addFile('docProps/core.xml', xlsxFactory.createCore());
	        zipContainer.addFile('[Content_Types].xml', xlsxFactory.createContentTypes());
	        zipContainer.addFile('_rels/.rels', xlsxFactory.createRels());
	        return zipContainer.getContent('application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
	    };
	    __decorate([
	        ag_grid_community_1.Autowired('excelXmlFactory'),
	        __metadata("design:type", excelXmlFactory_1.ExcelXmlFactory)
	    ], ExcelCreator.prototype, "excelXmlFactory", void 0);
	    __decorate([
	        ag_grid_community_1.Autowired('excelXlsxFactory'),
	        __metadata("design:type", excelXlsxFactory_1.ExcelXlsxFactory)
	    ], ExcelCreator.prototype, "xlsxFactory", void 0);
	    __decorate([
	        ag_grid_community_1.Autowired('columnController'),
	        __metadata("design:type", ag_grid_community_1.ColumnController)
	    ], ExcelCreator.prototype, "columnController", void 0);
	    __decorate([
	        ag_grid_community_1.Autowired('valueService'),
	        __metadata("design:type", ag_grid_community_1.ValueService)
	    ], ExcelCreator.prototype, "valueService", void 0);
	    __decorate([
	        ag_grid_community_1.Autowired('gridOptions'),
	        __metadata("design:type", Object)
	    ], ExcelCreator.prototype, "gridOptions", void 0);
	    __decorate([
	        ag_grid_community_1.Autowired('stylingService'),
	        __metadata("design:type", ag_grid_community_1.StylingService)
	    ], ExcelCreator.prototype, "stylingService", void 0);
	    __decorate([
	        ag_grid_community_1.Autowired('downloader'),
	        __metadata("design:type", ag_grid_community_1.Downloader)
	    ], ExcelCreator.prototype, "downloader", void 0);
	    __decorate([
	        ag_grid_community_1.Autowired('gridSerializer'),
	        __metadata("design:type", ag_grid_community_1.GridSerializer)
	    ], ExcelCreator.prototype, "gridSerializer", void 0);
	    __decorate([
	        ag_grid_community_1.Autowired('gridOptionsWrapper'),
	        __metadata("design:type", ag_grid_community_1.GridOptionsWrapper)
	    ], ExcelCreator.prototype, "gridOptionsWrapper", void 0);
	    __decorate([
	        ag_grid_community_1.Autowired('zipContainer'),
	        __metadata("design:type", ag_grid_community_1.ZipContainer)
	    ], ExcelCreator.prototype, "zipContainer", void 0);
	    __decorate([
	        ag_grid_community_1.PostConstruct,
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", []),
	        __metadata("design:returntype", void 0)
	    ], ExcelCreator.prototype, "postConstruct", null);
	    ExcelCreator = __decorate([
	        ag_grid_community_1.Bean('excelCreator')
	    ], ExcelCreator);
	    return ExcelCreator;
	}(ag_grid_community_1.BaseCreator));
	exports.ExcelCreator = ExcelCreator;


/***/ }),
/* 2556 */
/***/ (function(module, exports, __webpack_require__) {

	// ag-grid-enterprise v21.2.2
	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var ag_grid_community_1 = __webpack_require__(2322);
	var ExcelXmlSerializingSession = /** @class */ (function (_super) {
	    __extends(ExcelXmlSerializingSession, _super);
	    function ExcelXmlSerializingSession(config) {
	        var _this = _super.call(this, {
	            columnController: config.columnController,
	            valueService: config.valueService,
	            gridOptionsWrapper: config.gridOptionsWrapper,
	            processCellCallback: config.processCellCallback,
	            processHeaderCallback: config.processHeaderCallback,
	            cellAndHeaderEscaper: function (raw) { return raw; }
	        }) || this;
	        _this.mixedStyles = {};
	        _this.mixedStyleCounter = 0;
	        _this.rows = [];
	        var sheetName = config.sheetName, excelFactory = config.excelFactory, baseExcelStyles = config.baseExcelStyles, styleLinker = config.styleLinker, suppressTextAsCDATA = config.suppressTextAsCDATA, rowHeight = config.rowHeight, headerRowHeight = config.headerRowHeight;
	        _this.sheetName = sheetName;
	        _this.excelFactory = excelFactory;
	        _this.baseExcelStyles = baseExcelStyles || [];
	        _this.styleLinker = styleLinker;
	        _this.suppressTextAsCDATA = suppressTextAsCDATA;
	        _this.stylesByIds = {};
	        _this.rowHeight = rowHeight;
	        _this.headerRowHeight = headerRowHeight;
	        _this.baseExcelStyles.forEach(function (it) {
	            _this.stylesByIds[it.id] = it;
	        });
	        _this.excelStyles = _this.baseExcelStyles.slice();
	        return _this;
	    }
	    ExcelXmlSerializingSession.prototype.addCustomHeader = function (customHeader) {
	        this.customHeader = customHeader;
	    };
	    ExcelXmlSerializingSession.prototype.addCustomFooter = function (customFooter) {
	        this.customFooter = customFooter;
	    };
	    ExcelXmlSerializingSession.prototype.prepare = function (columnsToExport) {
	        this.cols = ag_grid_community_1._.map(columnsToExport, function (it) {
	            // tslint:disable-next-line
	            it.getColDef().cellStyle;
	            return {
	                width: it.getActualWidth()
	            };
	        });
	    };
	    ExcelXmlSerializingSession.prototype.onNewHeaderGroupingRow = function () {
	        var currentCells = [];
	        var that = this;
	        this.rows.push({
	            cells: currentCells,
	            height: this.headerRowHeight
	        });
	        return {
	            onColumn: function (header, index, span) {
	                var styleIds = that.styleLinker(ag_grid_community_1.RowType.HEADER_GROUPING, 1, index, "grouping-" + header, undefined, undefined);
	                currentCells.push(that.createMergedCell((styleIds && styleIds.length > 0) ? styleIds[0] : undefined, "String", header, span));
	            }
	        };
	    };
	    ExcelXmlSerializingSession.prototype.onNewHeaderRow = function () {
	        return this.onNewRow(this.onNewHeaderColumn, this.headerRowHeight);
	    };
	    ExcelXmlSerializingSession.prototype.onNewBodyRow = function () {
	        return this.onNewRow(this.onNewBodyColumn, this.rowHeight);
	    };
	    ExcelXmlSerializingSession.prototype.onNewRow = function (onNewColumnAccumulator, height) {
	        var currentCells = [];
	        this.rows.push({
	            cells: currentCells,
	            height: height
	        });
	        return {
	            onColumn: onNewColumnAccumulator.bind(this, this.rows.length, currentCells)()
	        };
	    };
	    ExcelXmlSerializingSession.prototype.onNewHeaderColumn = function (rowIndex, currentCells) {
	        var _this = this;
	        var that = this;
	        return function (column, index, node) {
	            var nameForCol = _this.extractHeaderValue(column);
	            var styleIds = that.styleLinker(ag_grid_community_1.RowType.HEADER, rowIndex, index, nameForCol, column, undefined);
	            currentCells.push(_this.createCell((styleIds && styleIds.length > 0) ? styleIds[0] : undefined, 'String', nameForCol));
	        };
	    };
	    ExcelXmlSerializingSession.prototype.parse = function () {
	        function join(header, body, footer) {
	            var all = [];
	            if (header) {
	                header.forEach(function (rowArray) { return all.push({ cells: rowArray }); });
	            }
	            body.forEach(function (it) { return all.push(it); });
	            if (footer) {
	                footer.forEach(function (rowArray) { return all.push({ cells: rowArray }); });
	            }
	            return all;
	        }
	        var data = [{
	                name: this.sheetName,
	                table: {
	                    columns: this.cols,
	                    rows: join(this.customHeader, this.rows, this.customFooter)
	                }
	            }];
	        return this.excelFactory.createExcel(this.excelStyles, data, []);
	    };
	    ExcelXmlSerializingSession.prototype.onNewBodyColumn = function (rowIndex, currentCells) {
	        var _this = this;
	        var that = this;
	        return function (column, index, node) {
	            var valueForCell = _this.extractRowCellValue(column, index, ag_grid_community_1.Constants.EXPORT_TYPE_EXCEL, node);
	            var styleIds = that.styleLinker(ag_grid_community_1.RowType.BODY, rowIndex, index, valueForCell, column, node);
	            var excelStyleId;
	            if (styleIds && styleIds.length == 1) {
	                excelStyleId = styleIds[0];
	            }
	            else if (styleIds && styleIds.length > 1) {
	                var key = styleIds.join("-");
	                if (!_this.mixedStyles[key]) {
	                    _this.addNewMixedStyle(styleIds);
	                }
	                excelStyleId = _this.mixedStyles[key].excelID;
	            }
	            var type = ag_grid_community_1._.isNumeric(valueForCell) ? 'Number' : 'String';
	            currentCells.push(that.createCell(excelStyleId, type, valueForCell));
	        };
	    };
	    ExcelXmlSerializingSession.prototype.addNewMixedStyle = function (styleIds) {
	        var _this = this;
	        this.mixedStyleCounter += 1;
	        var excelId = 'mixedStyle' + this.mixedStyleCounter;
	        var resultantStyle = {};
	        styleIds.forEach(function (styleId) {
	            _this.excelStyles.forEach(function (excelStyle) {
	                if (excelStyle.id === styleId) {
	                    ag_grid_community_1._.mergeDeep(resultantStyle, ag_grid_community_1._.deepCloneObject(excelStyle));
	                }
	            });
	        });
	        resultantStyle.id = excelId;
	        resultantStyle.name = excelId;
	        var key = styleIds.join("-");
	        this.mixedStyles[key] = {
	            excelID: excelId,
	            key: key,
	            result: resultantStyle
	        };
	        this.excelStyles.push(resultantStyle);
	        this.stylesByIds[excelId] = resultantStyle;
	    };
	    ExcelXmlSerializingSession.prototype.styleExists = function (styleId) {
	        if (styleId == null) {
	            return false;
	        }
	        return this.stylesByIds[styleId];
	    };
	    ExcelXmlSerializingSession.prototype.createCell = function (styleId, type, value) {
	        var _this = this;
	        var actualStyle = styleId && this.stylesByIds[styleId];
	        var styleExists = actualStyle !== undefined;
	        function getType() {
	            if (styleExists &&
	                actualStyle.dataType) {
	                switch (actualStyle.dataType) {
	                    case 'string':
	                        return 'String';
	                    case 'number':
	                        return 'Number';
	                    case 'dateTime':
	                        return 'DateTime';
	                    case 'error':
	                        return 'Error';
	                    case 'boolean':
	                        return 'Boolean';
	                    default:
	                        console.warn("ag-grid: Unrecognized data type for excel export [" + actualStyle.id + ".dataType=" + actualStyle.dataType + "]");
	                }
	            }
	            return type;
	        }
	        var typeTransformed = getType();
	        var massageText = function (val) { return _this.suppressTextAsCDATA ? ag_grid_community_1._.escape(val) : "<![CDATA[" + val + "]]>"; };
	        var convertBoolean = function (val) {
	            if (!val || val === '0' || val === 'false') {
	                return '0';
	            }
	            return '1';
	        };
	        return {
	            styleId: styleExists ? styleId : undefined,
	            data: {
	                type: typeTransformed,
	                value: typeTransformed === 'String' ? massageText(value) :
	                    typeTransformed === 'Number' ? Number(value).valueOf() + '' :
	                        typeTransformed === 'Boolean' ? convertBoolean(value) :
	                            value
	            }
	        };
	    };
	    ExcelXmlSerializingSession.prototype.createMergedCell = function (styleId, type, value, numOfCells) {
	        return {
	            styleId: this.styleExists(styleId) ? styleId : undefined,
	            data: {
	                type: type,
	                value: value
	            },
	            mergeAcross: numOfCells
	        };
	    };
	    return ExcelXmlSerializingSession;
	}(ag_grid_community_1.BaseGridSerializingSession));
	exports.ExcelXmlSerializingSession = ExcelXmlSerializingSession;


/***/ }),
/* 2557 */
/***/ (function(module, exports, __webpack_require__) {

	// ag-grid-enterprise v21.2.2
	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var ag_grid_community_1 = __webpack_require__(2322);
	var excelXmlSerializingSession_1 = __webpack_require__(2556);
	var ExcelXlsxSerializingSession = /** @class */ (function (_super) {
	    __extends(ExcelXlsxSerializingSession, _super);
	    function ExcelXlsxSerializingSession() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.stringList = [];
	        _this.stringMap = {};
	        return _this;
	    }
	    ExcelXlsxSerializingSession.prototype.onNewHeaderGroupingRow = function () {
	        var currentCells = [];
	        var that = this;
	        this.rows.push({
	            cells: currentCells,
	            height: this.headerRowHeight
	        });
	        return {
	            onColumn: function (header, index, span) {
	                var styleIds = that.styleLinker(ag_grid_community_1.RowType.HEADER_GROUPING, 1, index, "grouping-" + header, undefined, undefined);
	                currentCells.push(that.createMergedCell((styleIds && styleIds.length > 0) ? styleIds[0] : undefined, 's', header, span));
	            }
	        };
	    };
	    ExcelXlsxSerializingSession.prototype.onNewHeaderColumn = function (rowIndex, currentCells) {
	        var _this = this;
	        var that = this;
	        return function (column, index, node) {
	            var nameForCol = _this.extractHeaderValue(column);
	            var styleIds = that.styleLinker(ag_grid_community_1.RowType.HEADER, rowIndex, index, nameForCol, column, undefined);
	            currentCells.push(_this.createCell((styleIds && styleIds.length > 0) ? styleIds[0] : undefined, 's', nameForCol));
	        };
	    };
	    ExcelXlsxSerializingSession.prototype.parse = function () {
	        function join(header, body, footer) {
	            var all = [];
	            if (header) {
	                header.forEach(function (rowArray) { return all.push({ cells: rowArray }); });
	            }
	            body.forEach(function (it) { return all.push(it); });
	            if (footer) {
	                footer.forEach(function (rowArray) { return all.push({ cells: rowArray }); });
	            }
	            return all;
	        }
	        var data = [{
	                name: this.sheetName,
	                table: {
	                    columns: this.cols,
	                    rows: join(this.customHeader, this.rows, this.customFooter)
	                }
	            }];
	        return this.excelFactory.createExcel(this.excelStyles, data, this.stringList);
	    };
	    ExcelXlsxSerializingSession.prototype.onNewBodyColumn = function (rowIndex, currentCells) {
	        var _this = this;
	        var that = this;
	        return function (column, index, node) {
	            var valueForCell = _this.extractRowCellValue(column, index, ag_grid_community_1.Constants.EXPORT_TYPE_EXCEL, node);
	            var styleIds = that.styleLinker(ag_grid_community_1.RowType.BODY, rowIndex, index, valueForCell, column, node);
	            var excelStyleId;
	            if (styleIds && styleIds.length == 1) {
	                excelStyleId = styleIds[0];
	            }
	            else if (styleIds && styleIds.length > 1) {
	                var key = styleIds.join("-");
	                if (!_this.mixedStyles[key]) {
	                    _this.addNewMixedStyle(styleIds);
	                }
	                excelStyleId = _this.mixedStyles[key].excelID;
	            }
	            var type = ag_grid_community_1._.isNumeric(valueForCell) ? 'n' : 's';
	            currentCells.push(that.createCell(excelStyleId, type, valueForCell));
	        };
	    };
	    ExcelXlsxSerializingSession.prototype.getStringPosition = function (val) {
	        var pos = this.stringMap[val];
	        if (pos === undefined) {
	            pos = this.stringMap[val] = this.stringList.length;
	            this.stringList.push(val);
	        }
	        return pos;
	    };
	    ExcelXlsxSerializingSession.prototype.createCell = function (styleId, type, value) {
	        var actualStyle = styleId && this.stylesByIds[styleId];
	        var styleExists = actualStyle !== undefined;
	        function getType() {
	            if (styleExists &&
	                actualStyle.dataType) {
	                switch (actualStyle.dataType) {
	                    case 'string':
	                        return 's';
	                    case 'number':
	                        return 'n';
	                    case 'dateTime':
	                        return 'd';
	                    case 'error':
	                        return 'e';
	                    case 'boolean':
	                        return 'b';
	                    default:
	                        console.warn("ag-grid: Unrecognized data type for excel export [" + actualStyle.id + ".dataType=" + actualStyle.dataType + "]");
	                }
	            }
	            return type;
	        }
	        var typeTransformed = getType();
	        return {
	            styleId: styleExists ? styleId : undefined,
	            data: {
	                type: typeTransformed,
	                value: typeTransformed === 's'
	                    ? this.getStringPosition(value == null ? '' : value).toString()
	                    : typeTransformed === 'n'
	                        ? Number(value).toString()
	                        : value
	            }
	        };
	    };
	    ExcelXlsxSerializingSession.prototype.createMergedCell = function (styleId, type, value, numOfCells) {
	        return {
	            styleId: this.styleExists(styleId) ? styleId : undefined,
	            data: {
	                type: type,
	                value: type === 's' ? this.getStringPosition(value == null ? '' : value).toString() : value
	            },
	            mergeAcross: numOfCells
	        };
	    };
	    return ExcelXlsxSerializingSession;
	}(excelXmlSerializingSession_1.ExcelXmlSerializingSession));
	exports.ExcelXlsxSerializingSession = ExcelXlsxSerializingSession;


/***/ }),
/* 2558 */
/***/ (function(module, exports, __webpack_require__) {

	// ag-grid-enterprise v21.2.2
	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var ag_grid_community_1 = __webpack_require__(2322);
	var ag_grid_community_2 = __webpack_require__(2322);
	var workbook_1 = __webpack_require__(2559);
	var excelWorkbook_1 = __webpack_require__(2560);
	var worksheet_1 = __webpack_require__(2561);
	var documentProperties_1 = __webpack_require__(2565);
	var alignment_1 = __webpack_require__(2566);
	var borders_1 = __webpack_require__(2567);
	var font_1 = __webpack_require__(2568);
	var interior_1 = __webpack_require__(2569);
	var protection_1 = __webpack_require__(2570);
	var numberFormat_1 = __webpack_require__(2571);
	var style_1 = __webpack_require__(2572);
	/**
	 * See https://msdn.microsoft.com/en-us/library/aa140066(v=office.10).aspx
	 */
	var ExcelXmlFactory = /** @class */ (function () {
	    function ExcelXmlFactory() {
	    }
	    ExcelXmlFactory.prototype.createExcel = function (styles, worksheets, sharedStrings) {
	        var header = this.excelXmlHeader();
	        var docProps = documentProperties_1.default.getTemplate();
	        var eWorkbook = excelWorkbook_1.default.getTemplate();
	        var wb = this.workbook(docProps, eWorkbook, styles, worksheets);
	        return "" + header + this.xmlFactory.createXml(wb, function (boolean) { return boolean ? '1' : '0'; });
	    };
	    ExcelXmlFactory.prototype.workbook = function (docProperties, eWorkbook, styles, worksheets) {
	        var children = [
	            docProperties,
	            eWorkbook,
	            this.stylesXmlElement(styles)
	        ].concat(ag_grid_community_1._.map(worksheets, function (it) { return worksheet_1.default.getTemplate(it); }));
	        return ag_grid_community_1._.assign({}, workbook_1.default.getTemplate(), { children: children });
	    };
	    ExcelXmlFactory.prototype.excelXmlHeader = function () {
	        return "<?xml version=\"1.0\" ?>\n        <?mso-application progid=\"Excel.Sheet\" ?>\n        ";
	    };
	    ExcelXmlFactory.prototype.stylesXmlElement = function (styles) {
	        var _this = this;
	        return {
	            name: 'Styles',
	            children: styles ? ag_grid_community_1._.map(styles, function (it) {
	                return _this.styleXmlElement(it);
	            }) : []
	        };
	    };
	    ExcelXmlFactory.prototype.styleXmlElement = function (styleProperties) {
	        var children = ag_grid_community_1._.compose(this.addProperty('alignment', styleProperties), this.addProperty('borders', styleProperties), this.addProperty('font', styleProperties), this.addProperty('interior', styleProperties), this.addProperty('protection', styleProperties), this.addProperty('numberFormat', styleProperties))([]);
	        return ag_grid_community_1._.assign({}, style_1.default.getTemplate(styleProperties), { children: children });
	    };
	    ExcelXmlFactory.prototype.addProperty = function (property, styleProperties) {
	        return function (children) {
	            if (!styleProperties[property]) {
	                return children;
	            }
	            var options = {
	                alignment: alignment_1.default,
	                borders: borders_1.default,
	                font: font_1.default,
	                interior: interior_1.default,
	                numberFormat: numberFormat_1.default,
	                protection: protection_1.default
	            };
	            return children.concat(options[property].getTemplate(styleProperties));
	        };
	    };
	    __decorate([
	        ag_grid_community_2.Autowired('xmlFactory'),
	        __metadata("design:type", ag_grid_community_1.XmlFactory)
	    ], ExcelXmlFactory.prototype, "xmlFactory", void 0);
	    ExcelXmlFactory = __decorate([
	        ag_grid_community_2.Bean('excelXmlFactory')
	    ], ExcelXmlFactory);
	    return ExcelXmlFactory;
	}());
	exports.ExcelXmlFactory = ExcelXmlFactory;


/***/ }),
/* 2559 */
/***/ (function(module, exports) {

	// ag-grid-enterprise v21.2.2
	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var workbook = {
	    getTemplate: function () {
	        return {
	            name: "Workbook",
	            properties: {
	                prefixedAttributes: [{
	                        prefix: "xmlns:",
	                        map: {
	                            o: "urn:schemas-microsoft-com:office:office",
	                            x: "urn:schemas-microsoft-com:office:excel",
	                            ss: "urn:schemas-microsoft-com:office:spreadsheet",
	                            html: "http://www.w3.org/TR/REC-html40"
	                        },
	                    }],
	                rawMap: {
	                    xmlns: "urn:schemas-microsoft-com:office:spreadsheet"
	                }
	            }
	        };
	    }
	};
	exports.default = workbook;


/***/ }),
/* 2560 */
/***/ (function(module, exports) {

	// ag-grid-enterprise v21.2.2
	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var excelWorkbook = {
	    getTemplate: function () {
	        return {
	            name: "ExcelWorkbook",
	            properties: {
	                rawMap: {
	                    xmlns: "urn:schemas-microsoft-com:office:excel"
	                }
	            },
	            children: [{
	                    name: "WindowHeight",
	                    textNode: "8130"
	                }, {
	                    name: "WindowWidth",
	                    textNode: "15135"
	                }, {
	                    name: "WindowHeight",
	                    textNode: "8130"
	                }, {
	                    name: "WindowTopX",
	                    textNode: "120"
	                }, {
	                    name: "WindowTopY",
	                    textNode: "45"
	                }, {
	                    name: "ProtectStructure",
	                    textNode: "False"
	                }, {
	                    name: "ProtectWindow",
	                    textNode: "False"
	                }]
	        };
	    }
	};
	exports.default = excelWorkbook;


/***/ }),
/* 2561 */
/***/ (function(module, exports, __webpack_require__) {

	// ag-grid-enterprise v21.2.2
	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var ag_grid_community_1 = __webpack_require__(2322);
	var column_1 = __webpack_require__(2562);
	var row_1 = __webpack_require__(2563);
	var worksheet = {
	    getTemplate: function (ws) {
	        var table = ws.table, name = ws.name;
	        var columns = table.columns, rows = table.rows;
	        var c = ag_grid_community_1._.map(columns, function (it) { return column_1.default.getTemplate(it); });
	        var r = ag_grid_community_1._.map(rows, function (it) { return row_1.default.getTemplate(it); });
	        return {
	            name: "Worksheet",
	            children: [{
	                    name: "Table",
	                    children: c.concat(r)
	                }],
	            properties: {
	                prefixedAttributes: [{
	                        prefix: "ss:",
	                        map: {
	                            Name: name
	                        }
	                    }]
	            }
	        };
	    }
	};
	exports.default = worksheet;


/***/ }),
/* 2562 */
/***/ (function(module, exports) {

	// ag-grid-enterprise v21.2.2
	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var column = {
	    getTemplate: function (c) {
	        var width = c.width;
	        return {
	            name: "Column",
	            properties: {
	                prefixedAttributes: [{
	                        prefix: "ss:",
	                        map: {
	                            Width: width
	                        }
	                    }]
	            }
	        };
	    }
	};
	exports.default = column;


/***/ }),
/* 2563 */
/***/ (function(module, exports, __webpack_require__) {

	// ag-grid-enterprise v21.2.2
	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var ag_grid_community_1 = __webpack_require__(2322);
	var cell_1 = __webpack_require__(2564);
	var row = {
	    getTemplate: function (r) {
	        var cells = r.cells;
	        return {
	            name: "Row",
	            children: ag_grid_community_1._.map(cells, function (it) {
	                return cell_1.default.getTemplate(it);
	            })
	        };
	    }
	};
	exports.default = row;


/***/ }),
/* 2564 */
/***/ (function(module, exports) {

	// ag-grid-enterprise v21.2.2
	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var cell = {
	    getTemplate: function (c) {
	        var mergeAcross = c.mergeAcross, styleId = c.styleId, data = c.data;
	        var properties = {};
	        if (mergeAcross) {
	            properties.MergeAcross = mergeAcross;
	        }
	        if (styleId) {
	            properties.StyleID = styleId;
	        }
	        return {
	            name: "Cell",
	            properties: {
	                prefixedAttributes: [{
	                        prefix: "ss:",
	                        map: properties
	                    }]
	            },
	            children: [{
	                    name: "Data",
	                    properties: {
	                        prefixedAttributes: [{
	                                prefix: "ss:",
	                                map: {
	                                    Type: data.type
	                                }
	                            }]
	                    },
	                    textNode: data.value
	                }]
	        };
	    }
	};
	exports.default = cell;


/***/ }),
/* 2565 */
/***/ (function(module, exports) {

	// ag-grid-enterprise v21.2.2
	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var documentProperties = {
	    getTemplate: function () {
	        return {
	            name: "DocumentProperties",
	            properties: {
	                rawMap: {
	                    xmlns: "urn:schemas-microsoft-com:office:office"
	                }
	            },
	            children: [{
	                    name: "Version",
	                    textNode: "12.00"
	                }]
	        };
	    }
	};
	exports.default = documentProperties;


/***/ }),
/* 2566 */
/***/ (function(module, exports) {

	// ag-grid-enterprise v21.2.2
	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var alignment = {
	    getTemplate: function (styleProperties) {
	        var _a = styleProperties.alignment, vertical = _a.vertical, horizontal = _a.horizontal, indent = _a.indent, readingOrder = _a.readingOrder, rotate = _a.rotate, shrinkToFit = _a.shrinkToFit, verticalText = _a.verticalText, wrapText = _a.wrapText;
	        return {
	            name: 'Alignment',
	            properties: {
	                prefixedAttributes: [{
	                        prefix: "ss:",
	                        map: {
	                            Vertical: vertical,
	                            Horizontal: horizontal,
	                            Indent: indent,
	                            ReadingOrder: readingOrder,
	                            Rotate: rotate,
	                            ShrinkToFit: shrinkToFit,
	                            VerticalText: verticalText,
	                            WrapText: wrapText
	                        }
	                    }]
	            }
	        };
	    }
	};
	exports.default = alignment;


/***/ }),
/* 2567 */
/***/ (function(module, exports) {

	// ag-grid-enterprise v21.2.2
	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var borders = {
	    getTemplate: function (styleProperties) {
	        var _a = styleProperties.borders, borderBottom = _a.borderBottom, borderLeft = _a.borderLeft, borderRight = _a.borderRight, borderTop = _a.borderTop;
	        return {
	            name: 'Borders',
	            children: [borderBottom, borderLeft, borderRight, borderTop].map(function (it, index) {
	                var current = index == 0 ? "Bottom" : index == 1 ? "Left" : index == 2 ? "Right" : "Top";
	                return {
	                    name: 'Border',
	                    properties: {
	                        prefixedAttributes: [{
	                                prefix: 'ss:',
	                                map: {
	                                    Position: current,
	                                    LineStyle: it.lineStyle,
	                                    Weight: it.weight,
	                                    Color: it.color
	                                }
	                            }]
	                    }
	                };
	            })
	        };
	    }
	};
	exports.default = borders;


/***/ }),
/* 2568 */
/***/ (function(module, exports) {

	// ag-grid-enterprise v21.2.2
	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var font = {
	    getTemplate: function (styleProperties) {
	        var _a = styleProperties.font, bold = _a.bold, fontName = _a.fontName, italic = _a.italic, color = _a.color, outline = _a.outline, shadow = _a.shadow, size = _a.size, strikeThrough = _a.strikeThrough, underline = _a.underline, verticalAlign = _a.verticalAlign, charSet = _a.charSet, family = _a.family;
	        return {
	            name: "Font",
	            properties: {
	                prefixedAttributes: [{
	                        prefix: "ss:",
	                        map: {
	                            Bold: bold,
	                            FontName: fontName,
	                            Italic: italic,
	                            Color: color,
	                            Outline: outline,
	                            Shadow: shadow,
	                            Size: size,
	                            StrikeThrough: strikeThrough,
	                            Underline: underline,
	                            VerticalAlign: verticalAlign
	                        }
	                    }, {
	                        prefix: "x:",
	                        map: {
	                            CharSet: charSet,
	                            Family: family
	                        }
	                    }]
	            }
	        };
	    }
	};
	exports.default = font;


/***/ }),
/* 2569 */
/***/ (function(module, exports) {

	// ag-grid-enterprise v21.2.2
	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var interior = {
	    getTemplate: function (styleProperties) {
	        var _a = styleProperties.interior, color = _a.color, pattern = _a.pattern, patternColor = _a.patternColor;
	        return {
	            name: "Interior",
	            properties: {
	                prefixedAttributes: [{
	                        prefix: "ss:",
	                        map: {
	                            Color: color,
	                            Pattern: pattern,
	                            PatternColor: patternColor
	                        }
	                    }]
	            }
	        };
	    }
	};
	exports.default = interior;


/***/ }),
/* 2570 */
/***/ (function(module, exports) {

	// ag-grid-enterprise v21.2.2
	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var protection = {
	    getTemplate: function (styleProperties) {
	        return {
	            name: "Protection",
	            properties: {
	                prefixedAttributes: [{
	                        prefix: "ss:",
	                        map: {
	                            Protected: styleProperties.protection.protected,
	                            HideFormula: styleProperties.protection.hideFormula
	                        }
	                    }]
	            }
	        };
	    }
	};
	exports.default = protection;


/***/ }),
/* 2571 */
/***/ (function(module, exports) {

	// ag-grid-enterprise v21.2.2
	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var numberFormat = {
	    getTemplate: function (styleProperties) {
	        var format = styleProperties.numberFormat.format;
	        return {
	            name: "NumberFormat",
	            properties: {
	                prefixedAttributes: [{
	                        prefix: "ss:",
	                        map: {
	                            Format: format
	                        }
	                    }]
	            }
	        };
	    }
	};
	exports.default = numberFormat;


/***/ }),
/* 2572 */
/***/ (function(module, exports) {

	// ag-grid-enterprise v21.2.2
	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var style = {
	    getTemplate: function (styleProperties) {
	        var id = styleProperties.id, name = styleProperties.name;
	        return {
	            name: 'Style',
	            properties: {
	                prefixedAttributes: [{
	                        prefix: "ss:",
	                        map: {
	                            ID: id,
	                            Name: name ? name : id
	                        }
	                    }]
	            }
	        };
	    }
	};
	exports.default = style;


/***/ }),
/* 2573 */
/***/ (function(module, exports, __webpack_require__) {

	// ag-grid-enterprise v21.2.2
	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var ag_grid_community_1 = __webpack_require__(2322);
	var core_1 = __webpack_require__(2574);
	var contentTypes_1 = __webpack_require__(2575);
	var office_1 = __webpack_require__(2577);
	var sharedStrings_1 = __webpack_require__(2582);
	var stylesheet_1 = __webpack_require__(2583);
	var workbook_1 = __webpack_require__(2599);
	var worksheet_1 = __webpack_require__(2602);
	var relationships_1 = __webpack_require__(2607);
	/**
	 * See https://www.ecma-international.org/news/TC45_current_work/OpenXML%20White%20Paper.pdf
	 */
	var ExcelXlsxFactory = /** @class */ (function () {
	    function ExcelXlsxFactory() {
	        this.sharedStrings = [];
	    }
	    ExcelXlsxFactory.prototype.createSharedStrings = function () {
	        return this.createXmlPart(sharedStrings_1.default.getTemplate(this.sharedStrings));
	    };
	    ExcelXlsxFactory.prototype.createXmlPart = function (body) {
	        var header = this.xmlFactory.createHeader({
	            encoding: 'UTF-8',
	            standalone: 'yes'
	        });
	        var xmlBody = this.xmlFactory.createXml(body);
	        return "" + header + xmlBody;
	    };
	    ExcelXlsxFactory.prototype.createExcel = function (styles, worksheets, sharedStrings) {
	        if (sharedStrings === void 0) { sharedStrings = []; }
	        this.sharedStrings = sharedStrings;
	        this.sheetNames = worksheets.map(function (worksheet) { return worksheet.name; });
	        stylesheet_1.registerStyles(styles);
	        return this.createWorksheet(worksheets);
	    };
	    ExcelXlsxFactory.prototype.createCore = function () {
	        return this.createXmlPart(core_1.default.getTemplate());
	    };
	    ExcelXlsxFactory.prototype.createContentTypes = function () {
	        return this.createXmlPart(contentTypes_1.default.getTemplate());
	    };
	    ExcelXlsxFactory.prototype.createRels = function () {
	        var rs = relationships_1.default.getTemplate([{
	                Id: 'rId1',
	                Type: 'http://schemas.openxmlformats.org/officeDocument/2006/relationships/officeDocument',
	                Target: 'xl/workbook.xml'
	            }, {
	                Id: 'rId2',
	                Type: 'http://schemas.openxmlformats.org/package/2006/relationships/metadata/core-properties',
	                Target: 'docProps/core.xml'
	            }]);
	        return this.createXmlPart(rs);
	    };
	    ExcelXlsxFactory.prototype.createStylesheet = function () {
	        return this.createXmlPart(stylesheet_1.default.getTemplate());
	    };
	    ExcelXlsxFactory.prototype.createTheme = function () {
	        return this.createXmlPart(office_1.default.getTemplate());
	    };
	    ExcelXlsxFactory.prototype.createWorkbook = function () {
	        return this.createXmlPart(workbook_1.default.getTemplate(this.sheetNames));
	    };
	    ExcelXlsxFactory.prototype.createWorkbookRels = function () {
	        var rs = relationships_1.default.getTemplate([{
	                Id: 'rId1',
	                Type: 'http://schemas.openxmlformats.org/officeDocument/2006/relationships/worksheet',
	                Target: 'worksheets/sheet1.xml'
	            }, {
	                Id: 'rId2',
	                Type: 'http://schemas.openxmlformats.org/officeDocument/2006/relationships/theme',
	                Target: 'theme/theme1.xml'
	            }, {
	                Id: 'rId3',
	                Type: 'http://schemas.openxmlformats.org/officeDocument/2006/relationships/styles',
	                Target: 'styles.xml'
	            }, {
	                Id: 'rId4',
	                Type: 'http://schemas.openxmlformats.org/officeDocument/2006/relationships/sharedStrings',
	                Target: 'sharedStrings.xml'
	            }]);
	        return this.createXmlPart(rs);
	    };
	    ExcelXlsxFactory.prototype.createWorksheet = function (worksheets) {
	        return this.createXmlPart(worksheet_1.default.getTemplate(worksheets[0]));
	    };
	    __decorate([
	        ag_grid_community_1.Autowired('xmlFactory'),
	        __metadata("design:type", ag_grid_community_1.XmlFactory)
	    ], ExcelXlsxFactory.prototype, "xmlFactory", void 0);
	    ExcelXlsxFactory = __decorate([
	        ag_grid_community_1.Bean('excelXlsxFactory')
	    ], ExcelXlsxFactory);
	    return ExcelXlsxFactory;
	}());
	exports.ExcelXlsxFactory = ExcelXlsxFactory;


/***/ }),
/* 2574 */
/***/ (function(module, exports) {

	// ag-grid-enterprise v21.2.2
	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var coreFactory = {
	    getTemplate: function () {
	        var dt = new Date(), jsonDate = dt.toJSON();
	        return {
	            name: 'cp:coreProperties',
	            properties: {
	                prefixedAttributes: [{
	                        prefix: "xmlns:",
	                        map: {
	                            cp: "http://schemas.openxmlformats.org/package/2006/metadata/core-properties",
	                            dc: 'http://purl.org/dc/elements/1.1/',
	                            dcterms: 'http://purl.org/dc/terms/',
	                            dcmitype: 'http://purl.org/dc/dcmitype/',
	                            xsi: 'http://www.w3.org/2001/XMLSchema-instance'
	                        }
	                    }]
	            },
	            children: [{
	                    name: 'dc:creator',
	                    textNode: 'ag-Grid'
	                }, {
	                    name: 'dc:title',
	                    textNode: 'Workbook'
	                }, {
	                    name: 'dcterms:created',
	                    properties: {
	                        rawMap: {
	                            'xsi:type': 'dcterms:W3CDTF'
	                        }
	                    },
	                    textNode: jsonDate
	                }, {
	                    name: 'dcterms:modified',
	                    properties: {
	                        rawMap: {
	                            'xsi:type': 'dcterms:W3CDTF'
	                        }
	                    },
	                    textNode: jsonDate
	                }]
	        };
	    }
	};
	exports.default = coreFactory;


/***/ }),
/* 2575 */
/***/ (function(module, exports, __webpack_require__) {

	// ag-grid-enterprise v21.2.2
	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var ag_grid_community_1 = __webpack_require__(2322);
	var contentType_1 = __webpack_require__(2576);
	var contentTypesFactory = {
	    getTemplate: function () {
	        var children = ag_grid_community_1._.map([{
	                name: 'Default',
	                Extension: 'rels',
	                ContentType: 'application/vnd.openxmlformats-package.relationships+xml'
	            }, {
	                name: 'Default',
	                ContentType: 'application/xml',
	                Extension: 'xml'
	            }, {
	                name: 'Override',
	                ContentType: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet.main+xml',
	                PartName: "/xl/workbook.xml"
	            }, {
	                name: 'Override',
	                ContentType: 'application/vnd.openxmlformats-officedocument.spreadsheetml.worksheet+xml',
	                PartName: '/xl/worksheets/sheet1.xml'
	            }, {
	                name: 'Override',
	                ContentType: 'application/vnd.openxmlformats-officedocument.theme+xml',
	                PartName: '/xl/theme/theme1.xml'
	            }, {
	                name: 'Override',
	                ContentType: 'application/vnd.openxmlformats-officedocument.spreadsheetml.styles+xml',
	                PartName: '/xl/styles.xml'
	            }, {
	                name: 'Override',
	                ContentType: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sharedStrings+xml',
	                PartName: '/xl/sharedStrings.xml'
	            }, {
	                name: 'Override',
	                ContentType: 'application/vnd.openxmlformats-package.core-properties+xml',
	                PartName: '/docProps/core.xml'
	            }], contentType_1.default.getTemplate);
	        return {
	            name: "Types",
	            properties: {
	                rawMap: {
	                    xmlns: "http://schemas.openxmlformats.org/package/2006/content-types"
	                }
	            },
	            children: children
	        };
	    }
	};
	exports.default = contentTypesFactory;


/***/ }),
/* 2576 */
/***/ (function(module, exports) {

	// ag-grid-enterprise v21.2.2
	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var contentTypeFactory = {
	    getTemplate: function (config) {
	        var name = config.name, ContentType = config.ContentType, Extension = config.Extension, PartName = config.PartName;
	        return {
	            name: name,
	            properties: {
	                rawMap: {
	                    Extension: Extension,
	                    PartName: PartName,
	                    ContentType: ContentType
	                }
	            }
	        };
	    }
	};
	exports.default = contentTypeFactory;


/***/ }),
/* 2577 */
/***/ (function(module, exports, __webpack_require__) {

	// ag-grid-enterprise v21.2.2
	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var themeElements_1 = __webpack_require__(2578);
	var officeTheme = {
	    getTemplate: function () {
	        return {
	            name: "a:theme",
	            properties: {
	                prefixedAttributes: [{
	                        prefix: "xmlns:",
	                        map: {
	                            a: "http://schemas.openxmlformats.org/drawingml/2006/main"
	                        },
	                    }],
	                rawMap: {
	                    name: "Office Theme"
	                }
	            },
	            children: [
	                themeElements_1.default.getTemplate(),
	                {
	                    name: 'a:objectDefaults'
	                },
	                {
	                    name: 'a:extraClrSchemeLst'
	                }
	            ]
	        };
	    }
	};
	exports.default = officeTheme;


/***/ }),
/* 2578 */
/***/ (function(module, exports, __webpack_require__) {

	// ag-grid-enterprise v21.2.2
	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var colorScheme_1 = __webpack_require__(2579);
	var fontScheme_1 = __webpack_require__(2580);
	var formatScheme_1 = __webpack_require__(2581);
	var themeElements = {
	    getTemplate: function () {
	        return {
	            name: "a:themeElements",
	            children: [
	                colorScheme_1.default.getTemplate(),
	                fontScheme_1.default.getTemplate(),
	                formatScheme_1.default.getTemplate()
	            ]
	        };
	    }
	};
	exports.default = themeElements;


/***/ }),
/* 2579 */
/***/ (function(module, exports) {

	// ag-grid-enterprise v21.2.2
	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var getColorChildren = function (props) {
	    var type = props[0], innerType = props[1], val = props[2], lastClr = props[3];
	    return {
	        name: "a:" + type,
	        children: [{
	                name: "a:" + innerType,
	                properties: {
	                    rawMap: {
	                        val: val,
	                        lastClr: lastClr
	                    }
	                }
	            }]
	    };
	};
	var colorScheme = {
	    getTemplate: function () {
	        return {
	            name: "a:clrScheme",
	            properties: {
	                rawMap: {
	                    name: "Office"
	                }
	            },
	            children: [
	                getColorChildren(['dk1', 'sysClr', 'windowText', '000000']),
	                getColorChildren(['lt1', 'sysClr', 'window', 'FFFFFF']),
	                getColorChildren(['dk2', 'srgbClr', '44546A']),
	                getColorChildren(['lt2', 'srgbClr', 'E7E6E6']),
	                getColorChildren(['accent1', 'srgbClr', '4472C4']),
	                getColorChildren(['accent2', 'srgbClr', 'ED7D31']),
	                getColorChildren(['accent3', 'srgbClr', 'A5A5A5']),
	                getColorChildren(['accent4', 'srgbClr', 'FFC000']),
	                getColorChildren(['accent5', 'srgbClr', '5B9BD5']),
	                getColorChildren(['accent6', 'srgbClr', '70AD47']),
	                getColorChildren(['hlink', 'srgbClr', '0563C1']),
	                getColorChildren(['folHlink', 'srgbClr', '954F72'])
	            ]
	        };
	    }
	};
	exports.default = colorScheme;


/***/ }),
/* 2580 */
/***/ (function(module, exports, __webpack_require__) {

	// ag-grid-enterprise v21.2.2
	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var ag_grid_community_1 = __webpack_require__(2322);
	var getFont = function (props) {
	    var type = props[0], typeface = props[1], script = props[2], panose = props[3];
	    return {
	        name: "a:" + type,
	        properties: {
	            rawMap: {
	                script: script,
	                typeface: typeface,
	                panose: panose
	            }
	        }
	    };
	};
	var fontScheme = {
	    getTemplate: function () {
	        var utf8_encode = ag_grid_community_1._.utf8_encode;
	        return {
	            name: "a:fontScheme",
	            properties: {
	                rawMap: {
	                    name: "Office"
	                }
	            },
	            children: [{
	                    name: 'a:majorFont',
	                    children: [
	                        getFont(['latin', 'Calibri Light', undefined, '020F0302020204030204']),
	                        getFont(['ea', '']),
	                        getFont(['cs', '']),
	                        getFont(['font', utf8_encode('游ゴシック Light'), 'Jpan']),
	                        getFont(['font', utf8_encode('맑은 고딕'), 'Hang']),
	                        getFont(['font', utf8_encode('等线 Light'), 'Hans']),
	                        getFont(['font', utf8_encode('新細明體'), 'Hant']),
	                        getFont(['font', 'Times New Roman', 'Arab']),
	                        getFont(['font', 'Times New Roman', 'Hebr']),
	                        getFont(['font', 'Tahoma', 'Thai']),
	                        getFont(['font', 'Nyala', 'Ethi']),
	                        getFont(['font', 'Vrinda', 'Beng']),
	                        getFont(['font', 'Shruti', 'Gujr']),
	                        getFont(['font', 'MoolBoran', 'Khmr']),
	                        getFont(['font', 'Tunga', 'Knda']),
	                        getFont(['font', 'Raavi', 'Guru']),
	                        getFont(['font', 'Euphemia', 'Cans']),
	                        getFont(['font', 'Plantagenet Cherokee', 'Cher']),
	                        getFont(['font', 'Microsoft Yi Baiti', 'Yiii']),
	                        getFont(['font', 'Microsoft Himalaya', 'Tibt']),
	                        getFont(['font', 'MV Boli', 'Thaa']),
	                        getFont(['font', 'Mangal', 'Deva']),
	                        getFont(['font', 'Gautami', 'Telu']),
	                        getFont(['font', 'Latha', 'Taml']),
	                        getFont(['font', 'Estrangelo Edessa', 'Syrc']),
	                        getFont(['font', 'Kalinga', 'Orya']),
	                        getFont(['font', 'Kartika', 'Mlym']),
	                        getFont(['font', 'DokChampa', 'Laoo']),
	                        getFont(['font', 'Iskoola Pota', 'Sinh']),
	                        getFont(['font', 'Mongolian Baiti', 'Mong']),
	                        getFont(['font', 'Times New Roman', 'Viet']),
	                        getFont(['font', 'Microsoft Uighur', 'Uigh']),
	                        getFont(['font', 'Sylfaen', 'Geor']),
	                        getFont(['font', 'Arial', 'Armn']),
	                        getFont(['font', 'Leelawadee UI', 'Bugi']),
	                        getFont(['font', 'Microsoft JhengHei', 'Bopo']),
	                        getFont(['font', 'Javanese Text', 'Java']),
	                        getFont(['font', 'Segoe UI', 'Lisu']),
	                        getFont(['font', 'Myanmar Text', 'Mymr']),
	                        getFont(['font', 'Ebrima', 'Nkoo']),
	                        getFont(['font', 'Nirmala UI', 'Olck']),
	                        getFont(['font', 'Ebrima', 'Osma']),
	                        getFont(['font', 'Phagspa', 'Phag']),
	                        getFont(['font', 'Estrangelo Edessa', 'Syrn']),
	                        getFont(['font', 'Estrangelo Edessa', 'Syrj']),
	                        getFont(['font', 'Estrangelo Edessa', 'Syre']),
	                        getFont(['font', 'Nirmala UI', 'Sora']),
	                        getFont(['font', 'Microsoft Tai Le', 'Tale']),
	                        getFont(['font', 'Microsoft New Tai Lue', 'Talu']),
	                        getFont(['font', 'Ebrima', 'Tfng'])
	                    ]
	                }, {
	                    name: 'a:minorFont',
	                    children: [
	                        getFont(['latin', 'Calibri', undefined, '020F0502020204030204']),
	                        getFont(['ea', '']),
	                        getFont(['cs', '']),
	                        getFont(['font', utf8_encode('游ゴシック'), 'Jpan']),
	                        getFont(['font', utf8_encode('맑은 고딕'), 'Hang']),
	                        getFont(['font', utf8_encode('等线'), 'Hans']),
	                        getFont(['font', utf8_encode('新細明體'), 'Hant']),
	                        getFont(['font', 'Arial', 'Arab']),
	                        getFont(['font', 'Arial', 'Hebr']),
	                        getFont(['font', 'Tahoma', 'Thai']),
	                        getFont(['font', 'Nyala', 'Ethi']),
	                        getFont(['font', 'Vrinda', 'Beng']),
	                        getFont(['font', 'Shruti', 'Gujr']),
	                        getFont(['font', 'DaunPenh', 'Khmr']),
	                        getFont(['font', 'Tunga', 'Knda']),
	                        getFont(['font', 'Raavi', 'Guru']),
	                        getFont(['font', 'Euphemia', 'Cans']),
	                        getFont(['font', 'Plantagenet Cherokee', 'Cher']),
	                        getFont(['font', 'Microsoft Yi Baiti', 'Yiii']),
	                        getFont(['font', 'Microsoft Himalaya', 'Tibt']),
	                        getFont(['font', 'MV Boli', 'Thaa']),
	                        getFont(['font', 'Mangal', 'Deva']),
	                        getFont(['font', 'Gautami', 'Telu']),
	                        getFont(['font', 'Latha', 'Taml']),
	                        getFont(['font', 'Estrangelo Edessa', 'Syrc']),
	                        getFont(['font', 'Kalinga', 'Orya']),
	                        getFont(['font', 'Kartika', 'Mlym']),
	                        getFont(['font', 'DokChampa', 'Laoo']),
	                        getFont(['font', 'Iskoola Pota', 'Sinh']),
	                        getFont(['font', 'Mongolian Baiti', 'Mong']),
	                        getFont(['font', 'Arial', 'Viet']),
	                        getFont(['font', 'Microsoft Uighur', 'Uigh']),
	                        getFont(['font', 'Sylfaen', 'Geor']),
	                        getFont(['font', 'Arial', 'Armn']),
	                        getFont(['font', 'Leelawadee UI', 'Bugi']),
	                        getFont(['font', 'Microsoft JhengHei', 'Bopo']),
	                        getFont(['font', 'Javanese Text', 'Java']),
	                        getFont(['font', 'Segoe UI', 'Lisu']),
	                        getFont(['font', 'Myanmar Text', 'Mymr']),
	                        getFont(['font', 'Ebrima', 'Nkoo']),
	                        getFont(['font', 'Nirmala UI', 'Olck']),
	                        getFont(['font', 'Ebrima', 'Osma']),
	                        getFont(['font', 'Phagspa', 'Phag']),
	                        getFont(['font', 'Estrangelo Edessa', 'Syrn']),
	                        getFont(['font', 'Estrangelo Edessa', 'Syrj']),
	                        getFont(['font', 'Estrangelo Edessa', 'Syre']),
	                        getFont(['font', 'Nirmala UI', 'Sora']),
	                        getFont(['font', 'Microsoft Tai Le', 'Tale']),
	                        getFont(['font', 'Microsoft New Tai Lue', 'Talu']),
	                        getFont(['font', 'Ebrima', 'Tfng'])
	                    ]
	                }]
	        };
	    }
	};
	exports.default = fontScheme;


/***/ }),
/* 2581 */
/***/ (function(module, exports, __webpack_require__) {

	// ag-grid-enterprise v21.2.2
	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var ag_grid_community_1 = __webpack_require__(2322);
	var getPropertyVal = function (name, val, children) { return ({
	    name: "a:" + name,
	    properties: {
	        rawMap: {
	            val: val
	        }
	    },
	    children: children
	}); };
	var getGs = function (props) {
	    var pos = props[0], schemeColor = props[1], satMod = props[2], lumMod = props[3], tint = props[4], shade = props[5];
	    var children = [];
	    children.push(getPropertyVal('satMod', satMod));
	    if (lumMod) {
	        children.push(getPropertyVal('lumMod', lumMod));
	    }
	    if (tint) {
	        children.push(getPropertyVal('tint', tint));
	    }
	    if (shade) {
	        children.push(getPropertyVal('shade', shade));
	    }
	    return {
	        name: 'a:gs',
	        properties: {
	            rawMap: {
	                pos: pos
	            }
	        },
	        children: [{
	                name: 'a:schemeClr',
	                properties: {
	                    rawMap: {
	                        val: schemeColor
	                    }
	                },
	                children: children
	            }]
	    };
	};
	var getSolidFill = function (val, children) { return ({
	    name: 'a:solidFill',
	    children: [getPropertyVal('schemeClr', val, children)]
	}); };
	var getGradFill = function (props) {
	    var rotWithShape = props[0], gs1 = props[1], gs2 = props[2], gs3 = props[3], lin = props[4];
	    var ang = lin[0], scaled = lin[1];
	    return {
	        name: 'a:gradFill',
	        properties: {
	            rawMap: {
	                rotWithShape: rotWithShape
	            }
	        },
	        children: [{
	                name: 'a:gsLst',
	                children: [
	                    getGs(gs1),
	                    getGs(gs2),
	                    getGs(gs3)
	                ]
	            }, {
	                name: 'a:lin',
	                properties: {
	                    rawMap: {
	                        ang: ang,
	                        scaled: scaled
	                    }
	                }
	            }]
	    };
	};
	var getLine = function (props) {
	    var w = props[0], cap = props[1], cmpd = props[2], algn = props[3];
	    return {
	        name: 'a:ln',
	        properties: {
	            rawMap: { w: w, cap: cap, cmpd: cmpd, algn: algn }
	        },
	        children: [
	            getSolidFill('phClr'),
	            getPropertyVal('prstDash', 'solid'),
	            {
	                name: 'a:miter',
	                properties: {
	                    rawMap: {
	                        lim: '800000'
	                    }
	                }
	            }
	        ]
	    };
	};
	var getEffectStyle = function (shadow) {
	    var children = [];
	    if (shadow) {
	        var blurRad = shadow[0], dist = shadow[1], dir = shadow[2], algn = shadow[3], rotWithShape = shadow[4];
	        children.push({
	            name: 'a:outerShdw',
	            properties: {
	                rawMap: { blurRad: blurRad, dist: dist, dir: dir, algn: algn, rotWithShape: rotWithShape }
	            },
	            children: [
	                getPropertyVal('srgbClr', '000000', [getPropertyVal('alpha', '63000')])
	            ]
	        });
	    }
	    return {
	        name: 'a:effectStyle',
	        children: [ag_grid_community_1._.assign({}, {
	                name: 'a:effectLst'
	            }, children.length ? { children: children } : {})]
	    };
	};
	var getFillStyleList = function () { return ({
	    name: 'a:fillStyleLst',
	    children: [
	        getSolidFill('phClr'),
	        getGradFill([
	            '1',
	            ['0', 'phClr', '105000', '110000', '67000'],
	            ['50000', 'phClr', '103000', '105000', '73000'],
	            ['100000', 'phClr', '109000', '105000', '81000'],
	            ['5400000', '0']
	        ]),
	        getGradFill([
	            '1',
	            ['0', 'phClr', '103000', '102000', '94000'],
	            ['50000', 'phClr', '110000', '100000', undefined, '100000'],
	            ['100000', 'phClr', '120000', '99000', undefined, '78000'],
	            ['5400000', '0']
	        ])
	    ]
	}); };
	var getLineStyleList = function () { return ({
	    name: 'a:lnStyleLst',
	    children: [
	        getLine(['6350', 'flat', 'sng', 'ctr']),
	        getLine(['12700', 'flat', 'sng', 'ctr']),
	        getLine(['19050', 'flat', 'sng', 'ctr'])
	    ]
	}); };
	var getEffectStyleList = function () { return ({
	    name: 'a:effectStyleLst',
	    children: [
	        getEffectStyle(),
	        getEffectStyle(),
	        getEffectStyle(['57150', '19050', '5400000', 'ctr', '0'])
	    ]
	}); };
	var getBgFillStyleList = function () { return ({
	    name: 'a:bgFillStyleLst',
	    children: [
	        getSolidFill('phClr'),
	        getSolidFill('phClr', [
	            getPropertyVal('tint', '95000'),
	            getPropertyVal('satMod', '170000'),
	        ]),
	        getGradFill([
	            '1',
	            ['0', 'phClr', '150000', '102000', '93000', '98000'],
	            ['50000', 'phClr', '130000', '103000', '98000', '90000'],
	            ['100000', 'phClr', '120000', undefined, undefined, '63000'],
	            ['5400000', '0']
	        ])
	    ]
	}); };
	var formatScheme = {
	    getTemplate: function () {
	        return {
	            name: "a:fmtScheme",
	            properties: {
	                rawMap: {
	                    name: "Office"
	                }
	            },
	            children: [
	                getFillStyleList(),
	                getLineStyleList(),
	                getEffectStyleList(),
	                getBgFillStyleList()
	            ]
	        };
	    }
	};
	exports.default = formatScheme;


/***/ }),
/* 2582 */
/***/ (function(module, exports, __webpack_require__) {

	// ag-grid-enterprise v21.2.2
	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var ag_grid_community_1 = __webpack_require__(2322);
	var buildSharedString = function (textNode) { return ({
	    name: 'si',
	    children: [{
	            name: 't',
	            textNode: ag_grid_community_1._.utf8_encode(ag_grid_community_1._.escape(textNode.toString()))
	        }]
	}); };
	var sharedStrings = {
	    getTemplate: function (strings) {
	        return {
	            name: "sst",
	            properties: {
	                rawMap: {
	                    xmlns: 'http://schemas.openxmlformats.org/spreadsheetml/2006/main',
	                    count: strings.length,
	                    uniqueCount: strings.length
	                }
	            },
	            children: ag_grid_community_1._.map(strings, buildSharedString)
	        };
	    }
	};
	exports.default = sharedStrings;


/***/ }),
/* 2583 */
/***/ (function(module, exports, __webpack_require__) {

	// ag-grid-enterprise v21.2.2
	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var ag_grid_community_1 = __webpack_require__(2322);
	var numberFormats_1 = __webpack_require__(2584);
	var fonts_1 = __webpack_require__(2586);
	var fills_1 = __webpack_require__(2588);
	var borders_1 = __webpack_require__(2590);
	var cellStyleXfs_1 = __webpack_require__(2592);
	var cellXfs_1 = __webpack_require__(2596);
	var cellStyles_1 = __webpack_require__(2597);
	var numberFormat_1 = __webpack_require__(2585);
	var font_1 = __webpack_require__(2587);
	var border_1 = __webpack_require__(2591);
	var stylesMap;
	var registeredNumberFmts;
	var registeredFonts;
	var registeredFills;
	var registeredBorders;
	var registeredCellStyleXfs;
	var registeredCellXfs;
	var registeredCellStyles;
	var resetStylesheetValues = function () {
	    stylesMap = { base: 0 };
	    registeredNumberFmts = [];
	    registeredFonts = [{ name: 'Calibri', size: 14, colorTheme: '1', family: 2, scheme: 'minor' }];
	    registeredFills = [{ patternType: 'none', }, { patternType: 'gray125' }];
	    registeredBorders = [{ left: undefined, right: undefined, top: undefined, bottom: undefined, diagonal: undefined }];
	    registeredCellStyleXfs = [{ borderId: 0, fillId: 0, fontId: 0, numFmtId: 0 }];
	    registeredCellXfs = [{ borderId: 0, fillId: 0, fontId: 0, numFmtId: 0, xfId: 0 }];
	    registeredCellStyles = [{ builtinId: 0, name: 'normal', xfId: 0 }];
	};
	var convertLegacyPattern = function (name) {
	    var colorMap = {
	        None: 'none',
	        Solid: 'solid',
	        Gray50: 'mediumGray',
	        Gray75: 'darkGray',
	        Gray25: 'lightGray',
	        HorzStripe: 'darkHorizontal',
	        VertStripe: 'darkVertical',
	        ReverseDiagStripe: 'darkDown',
	        DiagStripe: 'darkUp',
	        DiagCross: 'darkGrid',
	        ThickDiagCross: 'darkTrellis',
	        ThinHorzStripe: 'lightHorizontal',
	        ThinVertStripe: 'lightVertical',
	        ThinReverseDiagStripe: 'lightDown',
	        ThinDiagStripe: 'lightUp',
	        ThinHorzCross: 'lightGrid',
	        ThinDiagCross: 'lightTrellis',
	        Gray125: 'gray125',
	        Gray0625: 'gray0625'
	    };
	    if (!name) {
	        return 'none';
	    }
	    return colorMap[name] || name;
	};
	exports.convertLegacyColor = function (color) {
	    if (color == undefined) {
	        return color;
	    }
	    if (color.charAt(0) === '#') {
	        color = color.substr(1);
	    }
	    return color.length === 6 ? '00' + color : color;
	};
	var registerFill = function (fill) {
	    var convertedPattern = convertLegacyPattern(fill.pattern);
	    var convertedFillColor = exports.convertLegacyColor(fill.color);
	    var convertedPatternColor = exports.convertLegacyColor(fill.patternColor);
	    var pos = ag_grid_community_1._.findIndex(registeredFills, function (currentFill) {
	        var patternType = currentFill.patternType, fgRgb = currentFill.fgRgb, bgRgb = currentFill.bgRgb;
	        if (patternType != convertedPattern ||
	            fgRgb != convertedFillColor ||
	            bgRgb != convertedPatternColor) {
	            return false;
	        }
	        return true;
	    });
	    if (pos === -1) {
	        pos = registeredFills.length;
	        registeredFills.push({ patternType: convertedPattern, fgRgb: convertedFillColor, bgRgb: convertedPatternColor });
	    }
	    return pos;
	};
	var registerNumberFmt = function (format) {
	    format = ag_grid_community_1._.utf8_encode(format);
	    if (numberFormat_1.numberFormatMap[format]) {
	        return numberFormat_1.numberFormatMap[format];
	    }
	    var pos = ag_grid_community_1._.findIndex(registeredNumberFmts, function (currentFormat) { return currentFormat.formatCode === format; });
	    if (pos === -1) {
	        pos = registeredNumberFmts.length + 164;
	        registeredNumberFmts.push({ formatCode: format, numFmtId: pos });
	    }
	    else {
	        pos = registeredNumberFmts[pos].numFmtId;
	    }
	    return pos;
	};
	var registerBorders = function (borders) {
	    var borderBottom = borders.borderBottom, borderTop = borders.borderTop, borderLeft = borders.borderLeft, borderRight = borders.borderRight;
	    var bottomStyle, topStyle, leftStyle, rightStyle;
	    var bottomColor, topColor, leftColor, rightColor;
	    if (borderLeft) {
	        leftStyle = border_1.convertLegacyBorder(borderLeft.lineStyle, borderLeft.weight);
	        leftColor = exports.convertLegacyColor(borderLeft.color);
	    }
	    if (borderRight) {
	        rightStyle = border_1.convertLegacyBorder(borderRight.lineStyle, borderRight.weight);
	        rightColor = exports.convertLegacyColor(borderRight.color);
	    }
	    if (borderBottom) {
	        bottomStyle = border_1.convertLegacyBorder(borderBottom.lineStyle, borderBottom.weight);
	        bottomColor = exports.convertLegacyColor(borderBottom.color);
	    }
	    if (borderTop) {
	        topStyle = border_1.convertLegacyBorder(borderTop.lineStyle, borderTop.weight);
	        topColor = exports.convertLegacyColor(borderTop.color);
	    }
	    var pos = ag_grid_community_1._.findIndex(registeredBorders, function (currentBorder) {
	        var left = currentBorder.left, right = currentBorder.right, top = currentBorder.top, bottom = currentBorder.bottom;
	        if (!left && (leftStyle || leftColor)) {
	            return false;
	        }
	        if (!right && (rightStyle || rightColor)) {
	            return false;
	        }
	        if (!top && (topStyle || topColor)) {
	            return false;
	        }
	        if (!bottom && (bottomStyle || bottomColor)) {
	            return false;
	        }
	        var _a = left || {}, clS = _a.style, clC = _a.color;
	        var _b = right || {}, crS = _b.style, crC = _b.color;
	        var _c = top || {}, ctS = _c.style, ctC = _c.color;
	        var _d = bottom || {}, cbS = _d.style, cbC = _d.color;
	        if (clS != leftStyle || clC != leftColor) {
	            return false;
	        }
	        if (crS != rightStyle || crC != rightColor) {
	            return false;
	        }
	        if (ctS != topStyle || ctC != topColor) {
	            return false;
	        }
	        if (cbS != bottomStyle || cbC != bottomColor) {
	            return false;
	        }
	        return true;
	    });
	    if (pos === -1) {
	        pos = registeredBorders.length;
	        registeredBorders.push({
	            left: {
	                style: leftStyle, color: leftColor
	            },
	            right: {
	                style: rightStyle, color: rightColor
	            },
	            top: {
	                style: topStyle, color: topColor
	            },
	            bottom: {
	                style: bottomStyle, color: bottomColor
	            },
	            diagonal: {
	                style: undefined,
	                color: undefined
	            }
	        });
	    }
	    return pos;
	};
	var registerFont = function (font) {
	    var name = font.fontName, color = font.color, size = font.size, bold = font.bold, italic = font.italic, outline = font.outline, shadow = font.shadow, strikeThrough = font.strikeThrough, underline = font.underline, family = font.family;
	    var utf8Name = name ? ag_grid_community_1._.utf8_encode(name) : name;
	    var convertedColor = exports.convertLegacyColor(color);
	    var familyId = font_1.getFamilyId(family);
	    var pos = ag_grid_community_1._.findIndex(registeredFonts, function (currentFont) {
	        if (currentFont.name != utf8Name ||
	            currentFont.color != convertedColor ||
	            currentFont.size != size ||
	            currentFont.bold != bold ||
	            currentFont.italic != italic ||
	            currentFont.outline != outline ||
	            currentFont.shadow != shadow ||
	            currentFont.strike != strikeThrough ||
	            currentFont.underline != underline ||
	            currentFont.family != familyId) {
	            return false;
	        }
	        return true;
	    });
	    if (pos === -1) {
	        pos = registeredFonts.length;
	        registeredFonts.push({
	            name: utf8Name,
	            color: convertedColor,
	            size: size,
	            bold: bold,
	            italic: italic,
	            outline: outline,
	            shadow: shadow,
	            strike: strikeThrough,
	            underline: underline,
	            family: familyId
	        });
	    }
	    return pos;
	};
	var registerStyle = function (config) {
	    var id = config.id, alignment = config.alignment, borders = config.borders, font = config.font, interior = config.interior, numberFormat = config.numberFormat, protection = config.protection;
	    var currentFill = 0;
	    var currentBorder = 0;
	    var currentFont = 0;
	    var currentNumberFmt = 0;
	    if (!id || stylesMap[id] != undefined) {
	        return;
	    }
	    if (interior) {
	        currentFill = registerFill(interior);
	    }
	    if (borders) {
	        currentBorder = registerBorders(borders);
	    }
	    if (font) {
	        currentFont = registerFont(font);
	    }
	    if (numberFormat) {
	        currentNumberFmt = registerNumberFmt(numberFormat.format);
	    }
	    stylesMap[id] = registeredCellXfs.length;
	    registeredCellXfs.push({
	        alignment: alignment,
	        borderId: currentBorder || 0,
	        fillId: currentFill || 0,
	        fontId: currentFont || 0,
	        numFmtId: currentNumberFmt || 0,
	        protection: protection,
	        xfId: 0
	    });
	};
	var stylesheetFactory = {
	    getTemplate: function () {
	        var numberFormats = numberFormats_1.default.getTemplate(registeredNumberFmts);
	        var fonts = fonts_1.default.getTemplate(registeredFonts);
	        var fills = fills_1.default.getTemplate(registeredFills);
	        var borders = borders_1.default.getTemplate(registeredBorders);
	        var cellStylesXfs = cellStyleXfs_1.default.getTemplate(registeredCellStyleXfs);
	        var cellXfs = cellXfs_1.default.getTemplate(registeredCellXfs);
	        var cellStyles = cellStyles_1.default.getTemplate(registeredCellStyles);
	        resetStylesheetValues();
	        return {
	            name: 'styleSheet',
	            properties: {
	                rawMap: {
	                    xmlns: 'http://schemas.openxmlformats.org/spreadsheetml/2006/main'
	                }
	            },
	            children: [
	                numberFormats,
	                fonts,
	                fills,
	                borders,
	                cellStylesXfs,
	                cellXfs,
	                cellStyles,
	                {
	                    name: 'tableStyles',
	                    properties: {
	                        rawMap: {
	                            count: 0,
	                            defaultPivotStyle: 'PivotStyleLight16',
	                            defaultTableStyle: 'TableStyleMedium2'
	                        }
	                    }
	                }
	            ]
	        };
	    }
	};
	exports.getStyleId = function (name) {
	    return stylesMap[name] || 0;
	};
	exports.registerStyles = function (styles) {
	    resetStylesheetValues();
	    styles.forEach(registerStyle);
	};
	exports.default = stylesheetFactory;


/***/ }),
/* 2584 */
/***/ (function(module, exports, __webpack_require__) {

	// ag-grid-enterprise v21.2.2
	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var ag_grid_community_1 = __webpack_require__(2322);
	var numberFormat_1 = __webpack_require__(2585);
	var numberFormatsFactory = {
	    getTemplate: function (numberFormats) {
	        return {
	            name: "numFmts",
	            properties: {
	                rawMap: {
	                    count: numberFormats.length
	                }
	            },
	            children: ag_grid_community_1._.map(numberFormats, numberFormat_1.default.getTemplate)
	        };
	    }
	};
	exports.default = numberFormatsFactory;


/***/ }),
/* 2585 */
/***/ (function(module, exports) {

	// ag-grid-enterprise v21.2.2
	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var numberFormatFactory = {
	    getTemplate: function (numberFormat) {
	        var formatCode = numberFormat.formatCode, numFmtId = numberFormat.numFmtId;
	        return {
	            name: "numFmt",
	            properties: {
	                rawMap: {
	                    formatCode: formatCode,
	                    numFmtId: numFmtId
	                }
	            }
	        };
	    }
	};
	exports.default = numberFormatFactory;
	exports.numberFormatMap = {
	    '0': 1,
	    '0.00': 2,
	    '#,##0': 3,
	    '#,##0.00': 4,
	    '0%': 9,
	    '0.00%': 10,
	    '0.00E+00': 11,
	    '# ?/?': 12,
	    '# ??/??': 13,
	    'mm-dd-yy': 14,
	    'd-mmm-yy': 15,
	    'd-mmm': 16,
	    'mmm-yy': 17,
	    'h:mm AM/PM': 18,
	    'h:mm:ss AM/PM': 19,
	    'h:mm': 20,
	    'h:mm:ss': 21,
	    'm/d/yy h:mm': 22,
	    '#,##0 ;(#,##0)': 37,
	    '#,##0 ;[Red](#,##0)': 38,
	    '#,##0.00;(#,##0.00)': 39,
	    '#,##0.00;[Red](#,##0.00)': 40,
	    'mm:ss': 45,
	    '[h]:mm:ss': 46,
	    'mmss.0': 47,
	    '##0.0E+0': 48,
	    '@': 49
	};


/***/ }),
/* 2586 */
/***/ (function(module, exports, __webpack_require__) {

	// ag-grid-enterprise v21.2.2
	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var ag_grid_community_1 = __webpack_require__(2322);
	var font_1 = __webpack_require__(2587);
	var fontsFactory = {
	    getTemplate: function (fonts) {
	        return {
	            name: "fonts",
	            properties: {
	                rawMap: {
	                    count: fonts.length
	                }
	            },
	            children: ag_grid_community_1._.map(fonts, font_1.default.getTemplate)
	        };
	    }
	};
	exports.default = fontsFactory;


/***/ }),
/* 2587 */
/***/ (function(module, exports) {

	// ag-grid-enterprise v21.2.2
	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var fontFactory = {
	    getTemplate: function (font) {
	        var _a = font.size, size = _a === void 0 ? 14 : _a, colorTheme = font.colorTheme, _b = font.color, color = _b === void 0 ? '00000000' : _b, _c = font.name, name = _c === void 0 ? 'Calibri' : _c, family = font.family, scheme = font.scheme, italic = font.italic, bold = font.bold, strike = font.strike, outline = font.outline, shadow = font.shadow, underline = font.underline;
	        var children = [
	            { name: 'sz', properties: { rawMap: { val: size } } },
	            { name: 'color', properties: { rawMap: { theme: colorTheme, rgb: color } } },
	            { name: 'name', properties: { rawMap: { val: name } } }
	        ];
	        if (family) {
	            children.push({ name: 'family', properties: { rawMap: { val: family } } });
	        }
	        if (scheme) {
	            children.push({ name: 'scheme', properties: { rawMap: { val: scheme } } });
	        }
	        if (italic) {
	            children.push({ name: 'i' });
	        }
	        if (bold) {
	            children.push({ name: 'b' });
	        }
	        if (strike) {
	            children.push({ name: 'strike' });
	        }
	        if (outline) {
	            children.push({ name: 'outline' });
	        }
	        if (shadow) {
	            children.push({ name: 'shadow' });
	        }
	        if (underline) {
	            var lUnder = underline.toLocaleLowerCase();
	            children.push({ name: 'u', properties: { rawMap: { val: lUnder === 'double' ? 'double' : 'single' } } });
	        }
	        return {
	            name: "font",
	            children: children
	        };
	    }
	};
	exports.default = fontFactory;
	exports.getFamilyId = function (name) {
	    var families = ['Automatic', 'Roman', 'Swiss', 'Modern', 'Script', 'Decorative'];
	    var pos = families.indexOf(name || 'Automatic');
	    return Math.max(pos, 0);
	};


/***/ }),
/* 2588 */
/***/ (function(module, exports, __webpack_require__) {

	// ag-grid-enterprise v21.2.2
	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var ag_grid_community_1 = __webpack_require__(2322);
	var fill_1 = __webpack_require__(2589);
	var fillsFactory = {
	    getTemplate: function (fills) {
	        return {
	            name: "fills",
	            properties: {
	                rawMap: {
	                    count: fills.length
	                }
	            },
	            children: ag_grid_community_1._.map(fills, fill_1.default.getTemplate)
	        };
	    }
	};
	exports.default = fillsFactory;


/***/ }),
/* 2589 */
/***/ (function(module, exports) {

	// ag-grid-enterprise v21.2.2
	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var fillFactory = {
	    getTemplate: function (fill) {
	        var patternType = fill.patternType, fgTheme = fill.fgTheme, fgTint = fill.fgTint, fgRgb = fill.fgRgb, bgRgb = fill.bgRgb, bgIndexed = fill.bgIndexed;
	        var pf = {
	            name: 'patternFill',
	            properties: {
	                rawMap: {
	                    patternType: patternType
	                }
	            }
	        };
	        if (fgTheme || fgTint || fgRgb) {
	            pf.children = [{
	                    name: 'fgColor',
	                    properties: {
	                        rawMap: {
	                            theme: fgTheme,
	                            tint: fgTint,
	                            rgb: fgRgb
	                        }
	                    }
	                }];
	        }
	        if (bgIndexed) {
	            if (!pf.children) {
	                pf.children = [];
	            }
	            pf.children.push({
	                name: 'bgColor',
	                properties: {
	                    rawMap: {
	                        indexed: bgIndexed,
	                        rgb: bgRgb
	                    }
	                }
	            });
	        }
	        return {
	            name: "fill",
	            children: [pf]
	        };
	    }
	};
	exports.default = fillFactory;


/***/ }),
/* 2590 */
/***/ (function(module, exports, __webpack_require__) {

	// ag-grid-enterprise v21.2.2
	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var ag_grid_community_1 = __webpack_require__(2322);
	var border_1 = __webpack_require__(2591);
	var bordersFactory = {
	    getTemplate: function (borders) {
	        return {
	            name: "borders",
	            properties: {
	                rawMap: {
	                    count: borders.length
	                }
	            },
	            children: ag_grid_community_1._.map(borders, border_1.default.getTemplate)
	        };
	    }
	};
	exports.default = bordersFactory;


/***/ }),
/* 2591 */
/***/ (function(module, exports, __webpack_require__) {

	// ag-grid-enterprise v21.2.2
	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var stylesheet_1 = __webpack_require__(2583);
	var getBorderColor = function (color) {
	    return {
	        name: 'color',
	        properties: {
	            rawMap: {
	                rgb: stylesheet_1.convertLegacyColor(color || '#000000')
	            }
	        }
	    };
	};
	var borderFactory = {
	    getTemplate: function (border) {
	        var left = border.left, right = border.right, top = border.top, bottom = border.bottom, diagonal = border.diagonal;
	        var leftChildren = left ? [getBorderColor(left.color)] : undefined;
	        var rightChildren = right ? [getBorderColor(right.color)] : undefined;
	        var topChildren = top ? [getBorderColor(top.color)] : undefined;
	        var bottomChildren = bottom ? [getBorderColor(bottom.color)] : undefined;
	        var diagonalChildren = diagonal ? [getBorderColor(diagonal.color)] : undefined;
	        return {
	            name: 'border',
	            children: [{
	                    name: 'left',
	                    properties: { rawMap: { style: left && left.style } },
	                    children: leftChildren
	                }, {
	                    name: 'right',
	                    properties: { rawMap: { style: right && right.style } },
	                    children: rightChildren
	                }, {
	                    name: 'top',
	                    properties: { rawMap: { style: top && top.style } },
	                    children: topChildren
	                }, {
	                    name: 'bottom',
	                    properties: { rawMap: { style: bottom && bottom.style } },
	                    children: bottomChildren
	                }, {
	                    name: 'diagonal',
	                    properties: { rawMap: { style: diagonal && diagonal.style } },
	                    children: diagonalChildren
	                }]
	        };
	    }
	};
	exports.default = borderFactory;
	var getWeightName = function (value) {
	    if (value === 1) {
	        return 'thin';
	    }
	    if (value === 2) {
	        return 'medium';
	    }
	    if (value === 3) {
	        return 'thick';
	    }
	    return 'hair';
	};
	var mappedNames = {
	    None: 'None',
	    Dot: 'Dotted',
	    Dash: 'Dashed',
	    Double: 'Double',
	    DashDot: 'DashDot',
	    DashDotDot: 'DashDotDot',
	    SlantDashDot: 'SlantDashDot'
	};
	var mediumBorders = ['Dashed', 'DashDot', 'DashDotDot'];
	exports.convertLegacyBorder = function (type, weight) {
	    // Legacy Types are: None, Continuous, Dash, Dot, DashDot, DashDotDot, SlantDashDot, and Double
	    // Weight represents: 0—Hairline, 1—Thin , 2—Medium, 3—Thick
	    // New types: none, thin, medium, dashed, dotted, thick, double, hair, mediumDashed, dashDot, mediumDashDot,
	    // dashDotDot, mediumDashDotDot, slantDashDot
	    var namedWeight = getWeightName(weight);
	    var mappedName = mappedNames[type];
	    if (!type) {
	        return 'thin';
	    }
	    if (type === 'Continuous') {
	        return namedWeight;
	    }
	    if (namedWeight === 'medium' && mediumBorders.indexOf(mappedName) > 0) {
	        return "medium" + mappedName;
	    }
	    return mappedName.charAt(0).toLowerCase() + mappedName.substr(1);
	};


/***/ }),
/* 2592 */
/***/ (function(module, exports, __webpack_require__) {

	// ag-grid-enterprise v21.2.2
	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var ag_grid_community_1 = __webpack_require__(2322);
	var xf_1 = __webpack_require__(2593);
	var cellStylesXfsFactory = {
	    getTemplate: function (xf) {
	        return {
	            name: "cellStyleXfs",
	            properties: {
	                rawMap: {
	                    count: xf.length
	                }
	            },
	            children: ag_grid_community_1._.map(xf, xf_1.default.getTemplate)
	        };
	    }
	};
	exports.default = cellStylesXfsFactory;


/***/ }),
/* 2593 */
/***/ (function(module, exports, __webpack_require__) {

	// ag-grid-enterprise v21.2.2
	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var alignment_1 = __webpack_require__(2594);
	var protection_1 = __webpack_require__(2595);
	var xfFactory = {
	    getTemplate: function (xf) {
	        var alignment = xf.alignment, borderId = xf.borderId, fillId = xf.fillId, fontId = xf.fontId, numFmtId = xf.numFmtId, protection = xf.protection, xfId = xf.xfId;
	        var children = [];
	        if (alignment) {
	            children.push(alignment_1.default.getTemplate(alignment));
	        }
	        if (protection) {
	            children.push(protection_1.default.getTemplate(protection));
	        }
	        return {
	            name: "xf",
	            properties: {
	                rawMap: {
	                    applyAlignment: alignment ? 1 : undefined,
	                    applyProtection: protection ? 1 : undefined,
	                    applyBorder: borderId ? 1 : undefined,
	                    borderId: borderId,
	                    fillId: fillId,
	                    applyFont: fontId ? 1 : undefined,
	                    fontId: fontId,
	                    applyNumberFormat: numFmtId ? 1 : undefined,
	                    numFmtId: numFmtId,
	                    xfId: xfId
	                }
	            },
	            children: children.length ? children : undefined
	        };
	    }
	};
	exports.default = xfFactory;


/***/ }),
/* 2594 */
/***/ (function(module, exports) {

	// ag-grid-enterprise v21.2.2
	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var convertLegacyHorizontalAlignment = function (alignment) {
	    var map = {
	        Automatic: 'general',
	        Left: 'left',
	        Center: 'center',
	        Right: 'right',
	        Fill: 'fill',
	        Justify: 'justify',
	        CenterAcrossSelection: 'centerContinuous',
	        Distributed: 'distributed',
	        JustifyDistributed: 'justify'
	    };
	    return map[alignment] || 'general';
	};
	var convertLegacyVerticalAlignment = function (alignment) {
	    var map = {
	        Automatic: undefined,
	        Top: 'top',
	        Bottom: 'bottom',
	        Center: 'center',
	        Justify: 'justify',
	        Distributed: 'distributed',
	        JustifyDistributed: 'justify'
	    };
	    return map[alignment] || undefined;
	};
	var getReadingOrderId = function (readingOrder) {
	    var order = ['Context', 'LeftToRight', 'RightToLeft'];
	    var pos = order.indexOf(readingOrder);
	    return Math.max(pos, 0);
	};
	var alignmentFactory = {
	    getTemplate: function (alignment) {
	        var horizontal = alignment.horizontal, indent = alignment.indent, readingOrder = alignment.readingOrder, rotate = alignment.rotate, shrinkToFit = alignment.shrinkToFit, vertical = alignment.vertical, wrapText = alignment.wrapText;
	        return {
	            name: 'alignment',
	            properties: {
	                rawMap: {
	                    horizontal: horizontal && convertLegacyHorizontalAlignment(horizontal),
	                    indent: indent,
	                    readingOrder: readingOrder && getReadingOrderId(readingOrder),
	                    textRotation: rotate,
	                    shrinkToFit: shrinkToFit,
	                    vertical: vertical && convertLegacyVerticalAlignment(vertical),
	                    wrapText: wrapText
	                }
	            }
	        };
	    }
	};
	exports.default = alignmentFactory;


/***/ }),
/* 2595 */
/***/ (function(module, exports) {

	// ag-grid-enterprise v21.2.2
	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var protectionFactory = {
	    getTemplate: function (protection) {
	        var locked = protection.protected === false ? 0 : 1;
	        var hidden = protection.hideFormula === true ? 1 : 0;
	        return {
	            name: 'protection',
	            properties: {
	                rawMap: {
	                    hidden: hidden,
	                    locked: locked
	                }
	            }
	        };
	    }
	};
	exports.default = protectionFactory;


/***/ }),
/* 2596 */
/***/ (function(module, exports, __webpack_require__) {

	// ag-grid-enterprise v21.2.2
	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var ag_grid_community_1 = __webpack_require__(2322);
	var xf_1 = __webpack_require__(2593);
	var cellXfsFactory = {
	    getTemplate: function (xf) {
	        return {
	            name: "cellXfs",
	            properties: {
	                rawMap: {
	                    count: xf.length
	                }
	            },
	            children: ag_grid_community_1._.map(xf, xf_1.default.getTemplate)
	        };
	    }
	};
	exports.default = cellXfsFactory;


/***/ }),
/* 2597 */
/***/ (function(module, exports, __webpack_require__) {

	// ag-grid-enterprise v21.2.2
	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var ag_grid_community_1 = __webpack_require__(2322);
	var cellStyle_1 = __webpack_require__(2598);
	var cellStylesFactory = {
	    getTemplate: function (cellStyles) {
	        return {
	            name: "cellStyles",
	            properties: {
	                rawMap: {
	                    count: cellStyles.length
	                }
	            },
	            children: ag_grid_community_1._.map(cellStyles, cellStyle_1.default.getTemplate)
	        };
	    }
	};
	exports.default = cellStylesFactory;


/***/ }),
/* 2598 */
/***/ (function(module, exports) {

	// ag-grid-enterprise v21.2.2
	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var borderFactory = {
	    getTemplate: function (cellStyle) {
	        var builtinId = cellStyle.builtinId, name = cellStyle.name, xfId = cellStyle.xfId;
	        return {
	            name: "cellStyle",
	            properties: {
	                rawMap: {
	                    builtinId: builtinId,
	                    name: name,
	                    xfId: xfId
	                }
	            }
	        };
	    }
	};
	exports.default = borderFactory;


/***/ }),
/* 2599 */
/***/ (function(module, exports, __webpack_require__) {

	// ag-grid-enterprise v21.2.2
	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var sheets_1 = __webpack_require__(2600);
	var workbookFactory = {
	    getTemplate: function (names) {
	        return {
	            name: "workbook",
	            properties: {
	                prefixedAttributes: [{
	                        prefix: "xmlns:",
	                        map: {
	                            r: "http://schemas.openxmlformats.org/officeDocument/2006/relationships"
	                        },
	                    }],
	                rawMap: {
	                    xmlns: "http://schemas.openxmlformats.org/spreadsheetml/2006/main"
	                }
	            },
	            children: [sheets_1.default.getTemplate(names)]
	        };
	    }
	};
	exports.default = workbookFactory;


/***/ }),
/* 2600 */
/***/ (function(module, exports, __webpack_require__) {

	// ag-grid-enterprise v21.2.2
	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var ag_grid_community_1 = __webpack_require__(2322);
	var sheet_1 = __webpack_require__(2601);
	var sheetsFactory = {
	    getTemplate: function (names) {
	        return {
	            name: "sheets",
	            children: ag_grid_community_1._.map(names, sheet_1.default.getTemplate)
	        };
	    }
	};
	exports.default = sheetsFactory;


/***/ }),
/* 2601 */
/***/ (function(module, exports) {

	// ag-grid-enterprise v21.2.2
	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var sheetFactory = {
	    getTemplate: function (name, idx) {
	        var sheetId = (idx + 1).toString();
	        return {
	            name: "sheet",
	            properties: {
	                rawMap: {
	                    "name": name,
	                    "sheetId": sheetId,
	                    "r:id": "rId" + sheetId
	                }
	            }
	        };
	    }
	};
	exports.default = sheetFactory;


/***/ }),
/* 2602 */
/***/ (function(module, exports, __webpack_require__) {

	// ag-grid-enterprise v21.2.2
	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var ag_grid_community_1 = __webpack_require__(2322);
	var column_1 = __webpack_require__(2603);
	var row_1 = __webpack_require__(2604);
	var mergeCell_1 = __webpack_require__(2606);
	var updateColMinMax = function (col, min, range, prevCol) {
	    if (!col.min) {
	        col.min = min;
	        col.max = min + range;
	        return;
	    }
	    var currentMin = min;
	    if (prevCol) {
	        currentMin = Math.max(currentMin, prevCol.min);
	    }
	    col.min = Math.max(col.min, currentMin);
	    col.max = Math.max(col.max, currentMin + range);
	};
	var getMergedCells = function (rows, cols) {
	    var mergedCells = [];
	    rows.forEach(function (currentRow, rowIdx) {
	        var cells = currentRow.cells;
	        var merges = 0;
	        currentRow.index = rowIdx + 1;
	        var lastCol;
	        cells.forEach(function (currentCell, cellIdx) {
	            var min = cellIdx + merges + 1;
	            var start = exports.getExcelColumnName(min);
	            var outputRow = rowIdx + 1;
	            if (currentCell.mergeAcross) {
	                merges += currentCell.mergeAcross;
	                var end = exports.getExcelColumnName(cellIdx + merges + 1);
	                mergedCells.push("" + start + outputRow + ":" + end + outputRow);
	            }
	            if (!cols[min - 1]) {
	                cols[min - 1] = {};
	            }
	            updateColMinMax(cols[min - 1], min, merges, lastCol);
	            lastCol = cols[min - 1];
	            currentCell.ref = "" + start + outputRow;
	        });
	    });
	    return mergedCells;
	};
	exports.getExcelColumnName = function (colIdx) {
	    var startCode = 65;
	    var tableWidth = 26;
	    var fromCharCode = String.fromCharCode;
	    var pos = Math.floor(colIdx / tableWidth);
	    var tableIdx = colIdx % tableWidth;
	    if (!pos || colIdx === tableWidth) {
	        return fromCharCode(startCode + colIdx - 1);
	    }
	    if (!tableIdx) {
	        return exports.getExcelColumnName(pos - 1) + 'Z';
	    }
	    if (pos < tableWidth) {
	        return fromCharCode(startCode + pos - 1) + fromCharCode(startCode + tableIdx - 1);
	    }
	    return exports.getExcelColumnName(pos) + fromCharCode(startCode + tableIdx - 1);
	};
	var worksheetFactory = {
	    getTemplate: function (config) {
	        var table = config.table;
	        var rows = table.rows, columns = table.columns;
	        var mergedCells = (columns && columns.length) ? getMergedCells(rows, columns) : [];
	        var children = [];
	        if (columns.length) {
	            children.push({
	                name: 'cols',
	                children: ag_grid_community_1._.map(columns, column_1.default.getTemplate)
	            });
	        }
	        if (rows.length) {
	            children.push({
	                name: 'sheetData',
	                children: ag_grid_community_1._.map(rows, row_1.default.getTemplate)
	            });
	        }
	        if (mergedCells.length) {
	            children.push({
	                name: 'mergeCells',
	                properties: {
	                    rawMap: {
	                        count: mergedCells.length
	                    }
	                },
	                children: ag_grid_community_1._.map(mergedCells, mergeCell_1.default.getTemplate)
	            });
	        }
	        return {
	            name: "worksheet",
	            properties: {
	                prefixedAttributes: [{
	                        prefix: "xmlns:",
	                        map: {
	                            r: "http://schemas.openxmlformats.org/officeDocument/2006/relationships"
	                        }
	                    }],
	                rawMap: {
	                    xmlns: "http://schemas.openxmlformats.org/spreadsheetml/2006/main"
	                }
	            },
	            children: children
	        };
	    }
	};
	exports.default = worksheetFactory;


/***/ }),
/* 2603 */
/***/ (function(module, exports) {

	// ag-grid-enterprise v21.2.2
	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var getExcelCellWidth = function (width) { return Math.max(Math.ceil((width - 12) / 7 + 1), 10); };
	var columnFactory = {
	    getTemplate: function (config) {
	        var min = config.min, max = config.max, s = config.s, _a = config.width, width = _a === void 0 ? 10 : _a, hidden = config.hidden, bestFit = config.bestFit;
	        var excelWidth = getExcelCellWidth(width);
	        return {
	            name: 'col',
	            properties: {
	                rawMap: {
	                    min: min,
	                    max: max,
	                    width: excelWidth,
	                    style: s,
	                    hidden: hidden ? '1' : '0',
	                    bestFit: bestFit ? '1' : '0',
	                    customWidth: excelWidth != 10 ? '1' : '0'
	                }
	            }
	        };
	    }
	};
	exports.default = columnFactory;


/***/ }),
/* 2604 */
/***/ (function(module, exports, __webpack_require__) {

	// ag-grid-enterprise v21.2.2
	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var ag_grid_community_1 = __webpack_require__(2322);
	var worksheet_1 = __webpack_require__(2602);
	var cell_1 = __webpack_require__(2605);
	var addEmptyCells = function (cells, rowIdx) {
	    var mergeMap = [];
	    var posCounter = 0;
	    for (var i = 0; i < cells.length; i++) {
	        var cell = cells[i];
	        if (cell.mergeAcross) {
	            mergeMap.push({
	                pos: i,
	                excelPos: posCounter
	            });
	            posCounter += cells[i].mergeAcross;
	        }
	        posCounter++;
	    }
	    if (mergeMap.length) {
	        for (var i = mergeMap.length - 1; i >= 0; i--) {
	            var mergedCells = [];
	            var cell = cells[mergeMap[i].pos];
	            for (var j = 1; j <= cell.mergeAcross; j++) {
	                mergedCells.push({
	                    ref: "" + worksheet_1.getExcelColumnName(mergeMap[i].excelPos + 1 + j) + (rowIdx + 1),
	                    styleId: cell.styleId,
	                    data: { type: 'empty', value: null }
	                });
	            }
	            if (mergedCells.length) {
	                cells.splice.apply(cells, [mergeMap[i].pos + 1, 0].concat(mergedCells));
	            }
	        }
	    }
	};
	var rowFactory = {
	    getTemplate: function (config, idx) {
	        var index = config.index, collapsed = config.collapsed, hidden = config.hidden, height = config.height, s = config.s, _a = config.cells, cells = _a === void 0 ? [] : _a;
	        addEmptyCells(cells, idx);
	        var children = ag_grid_community_1._.map(cells, cell_1.default.getTemplate);
	        return {
	            name: "row",
	            properties: {
	                rawMap: {
	                    r: index,
	                    collapsed: collapsed,
	                    hidden: hidden ? '1' : '0',
	                    ht: height,
	                    customHeight: height != null ? '1' : '0',
	                    s: s,
	                    customFormat: s != null ? '1' : '0'
	                }
	            },
	            children: children
	        };
	    }
	};
	exports.default = rowFactory;


/***/ }),
/* 2605 */
/***/ (function(module, exports, __webpack_require__) {

	// ag-grid-enterprise v21.2.2
	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var ag_grid_community_1 = __webpack_require__(2322);
	var stylesheet_1 = __webpack_require__(2583);
	var convertLegacyType = function (type) {
	    var t = type.charAt(0).toLowerCase();
	    return t === 's' ? 'inlineStr' : t;
	};
	var cellFactory = {
	    getTemplate: function (config) {
	        var ref = config.ref, data = config.data, styleId = config.styleId;
	        var type = data.type, value = data.value;
	        var convertedType = type;
	        if (type.charAt(0) === type.charAt(0).toUpperCase()) {
	            convertedType = convertLegacyType(type);
	        }
	        var obj = {
	            name: 'c',
	            properties: {
	                rawMap: {
	                    r: ref,
	                    t: convertedType === 'empty' ? undefined : convertedType,
	                    s: styleId ? stylesheet_1.getStyleId(styleId) : undefined
	                }
	            }
	        };
	        var children;
	        if (convertedType === 'inlineStr') {
	            children = [{
	                    name: 'is',
	                    children: [{
	                            name: 't',
	                            textNode: ag_grid_community_1._.escape(ag_grid_community_1._.utf8_encode(value))
	                        }]
	                }];
	        }
	        else {
	            children = [{
	                    name: 'v',
	                    textNode: value
	                }];
	        }
	        return ag_grid_community_1._.assign({}, obj, { children: children });
	    }
	};
	exports.default = cellFactory;


/***/ }),
/* 2606 */
/***/ (function(module, exports) {

	// ag-grid-enterprise v21.2.2
	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var mergeCell = {
	    getTemplate: function (ref) {
	        return {
	            name: 'mergeCell',
	            properties: {
	                rawMap: {
	                    ref: ref
	                }
	            }
	        };
	    }
	};
	exports.default = mergeCell;


/***/ }),
/* 2607 */
/***/ (function(module, exports, __webpack_require__) {

	// ag-grid-enterprise v21.2.2
	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var ag_grid_community_1 = __webpack_require__(2322);
	var relationship_1 = __webpack_require__(2608);
	var relationshipsFactory = {
	    getTemplate: function (c) {
	        var children = ag_grid_community_1._.map(c, relationship_1.default.getTemplate);
	        return {
	            name: "Relationships",
	            properties: {
	                rawMap: {
	                    xmlns: "http://schemas.openxmlformats.org/package/2006/relationships"
	                }
	            },
	            children: children
	        };
	    }
	};
	exports.default = relationshipsFactory;


/***/ }),
/* 2608 */
/***/ (function(module, exports) {

	// ag-grid-enterprise v21.2.2
	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var relationshipFactory = {
	    getTemplate: function (config) {
	        var Id = config.Id, Type = config.Type, Target = config.Target;
	        return {
	            name: "Relationship",
	            properties: {
	                rawMap: {
	                    Id: Id,
	                    Type: Type,
	                    Target: Target
	                }
	            }
	        };
	    }
	};
	exports.default = relationshipFactory;


/***/ }),
/* 2609 */
/***/ (function(module, exports, __webpack_require__) {

	// ag-grid-enterprise v21.2.2
	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var __param = (this && this.__param) || function (paramIndex, decorator) {
	    return function (target, key) { decorator(target, key, paramIndex); }
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var ag_grid_community_1 = __webpack_require__(2322);
	var serverSideCache_1 = __webpack_require__(2610);
	var serverSideBlock_1 = __webpack_require__(2611);
	var ServerSideRowModel = /** @class */ (function (_super) {
	    __extends(ServerSideRowModel, _super);
	    function ServerSideRowModel() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    // we don't implement as lazy row heights is not supported in this row model
	    ServerSideRowModel.prototype.ensureRowHeightsValid = function (startPixel, endPixel, startLimitIndex, endLimitIndex) { return false; };
	    ServerSideRowModel.prototype.postConstruct = function () {
	        this.rowHeight = this.gridOptionsWrapper.getRowHeightAsNumber();
	        this.addEventListeners();
	        var datasource = this.gridOptionsWrapper.getServerSideDatasource();
	        if (ag_grid_community_1._.exists(datasource)) {
	            this.setDatasource(datasource);
	        }
	    };
	    ServerSideRowModel.prototype.destroyDatasource = function () {
	        if (this.datasource) {
	            if (this.datasource.destroy) {
	                this.datasource.destroy();
	            }
	            this.rowRenderer.datasourceChanged();
	            this.datasource = undefined;
	        }
	    };
	    ServerSideRowModel.prototype.setBeans = function (loggerFactory) {
	        this.logger = loggerFactory.create('ServerSideRowModel');
	    };
	    ServerSideRowModel.prototype.addEventListeners = function () {
	        this.addDestroyableEventListener(this.eventService, ag_grid_community_1.Events.EVENT_COLUMN_ROW_GROUP_CHANGED, this.onColumnRowGroupChanged.bind(this));
	        this.addDestroyableEventListener(this.eventService, ag_grid_community_1.Events.EVENT_ROW_GROUP_OPENED, this.onRowGroupOpened.bind(this));
	        this.addDestroyableEventListener(this.eventService, ag_grid_community_1.Events.EVENT_COLUMN_PIVOT_MODE_CHANGED, this.onPivotModeChanged.bind(this));
	        this.addDestroyableEventListener(this.eventService, ag_grid_community_1.Events.EVENT_COLUMN_EVERYTHING_CHANGED, this.onColumnEverything.bind(this));
	        this.addDestroyableEventListener(this.eventService, ag_grid_community_1.Events.EVENT_COLUMN_VALUE_CHANGED, this.onValueChanged.bind(this));
	        this.addDestroyableEventListener(this.eventService, ag_grid_community_1.Events.EVENT_COLUMN_PIVOT_CHANGED, this.onColumnPivotChanged.bind(this));
	        this.addDestroyableEventListener(this.eventService, ag_grid_community_1.Events.EVENT_FILTER_CHANGED, this.onFilterChanged.bind(this));
	        this.addDestroyableEventListener(this.eventService, ag_grid_community_1.Events.EVENT_SORT_CHANGED, this.onSortChanged.bind(this));
	    };
	    ServerSideRowModel.prototype.setDatasource = function (datasource) {
	        this.destroyDatasource();
	        this.datasource = datasource;
	        this.reset();
	    };
	    ServerSideRowModel.prototype.isLastRowFound = function () {
	        if (this.cacheExists()) {
	            return this.rootNode.childrenCache.isMaxRowFound();
	        }
	        else {
	            return false;
	        }
	    };
	    ServerSideRowModel.prototype.onColumnEverything = function () {
	        // this is a hack for one customer only, so they can suppress the resetting of the columns.
	        // The problem the customer had was they were api.setColumnDefs() after the data source came
	        // back with data. So this stops the reload from the grid after the data comes back.
	        // Once we have "AG-1591 Allow delta changes to columns" fixed, then this hack can be taken out.
	        if (this.gridOptionsWrapper.isSuppressEnterpriseResetOnNewColumns()) {
	            return;
	        }
	        // every other customer can continue as normal and have it working!!!
	        // check if anything pertaining to fetching data has changed, and if it has, reset, but if
	        // it has not, don't reset
	        var resetRequired;
	        if (!this.cacheParams) {
	            resetRequired = true;
	        }
	        else {
	            var rowGroupColumnVos = this.toValueObjects(this.columnController.getRowGroupColumns());
	            var valueColumnVos = this.toValueObjects(this.columnController.getValueColumns());
	            var pivotColumnVos = this.toValueObjects(this.columnController.getPivotColumns());
	            var sortModelDifferent = !ag_grid_community_1._.jsonEquals(this.cacheParams.sortModel, this.sortController.getSortModel());
	            var rowGroupDifferent = !ag_grid_community_1._.jsonEquals(this.cacheParams.rowGroupCols, rowGroupColumnVos);
	            var pivotDifferent = !ag_grid_community_1._.jsonEquals(this.cacheParams.pivotCols, pivotColumnVos);
	            var valuesDifferent = !ag_grid_community_1._.jsonEquals(this.cacheParams.valueCols, valueColumnVos);
	            resetRequired = sortModelDifferent || rowGroupDifferent || pivotDifferent || valuesDifferent;
	        }
	        if (resetRequired) {
	            this.reset();
	        }
	    };
	    ServerSideRowModel.prototype.onFilterChanged = function () {
	        this.reset();
	    };
	    // returns back all the cols that were effected by the sorting. eg if we were sorting by col A,
	    // and now we are sorting by col B, the list of impacted cols should be A and B. so if a cache
	    // is impacted by sorting on A or B then it needs to be refreshed. this includes where the cache
	    // was previously sorted by A and then the A sort now needs to be cleared.
	    ServerSideRowModel.prototype.findChangedColumnsInSort = function (newSortModel, oldSortModel) {
	        var allColsInBothSorts = [];
	        [newSortModel, oldSortModel].forEach(function (sortModel) {
	            if (sortModel) {
	                var ids = sortModel.map(function (sm) { return sm.colId; });
	                allColsInBothSorts = allColsInBothSorts.concat(ids);
	            }
	        });
	        var differentSorts = function (oldSortItem, newSortItem) {
	            var oldSort = oldSortItem ? oldSortItem.sort : null;
	            var newSort = newSortItem ? newSortItem.sort : null;
	            return oldSort !== newSort;
	        };
	        var differentIndexes = function (oldSortItem, newSortItem) {
	            var oldIndex = oldSortModel.indexOf(oldSortItem);
	            var newIndex = newSortModel.indexOf(newSortItem);
	            return oldIndex !== newIndex;
	        };
	        return allColsInBothSorts.filter(function (colId) {
	            var oldSortItem = ag_grid_community_1._.find(oldSortModel, function (sm) { return sm.colId === colId; });
	            var newSortItem = ag_grid_community_1._.find(newSortModel, function (sm) { return sm.colId === colId; });
	            return differentSorts(oldSortItem, newSortItem) || differentIndexes(oldSortItem, newSortItem);
	        });
	    };
	    ServerSideRowModel.prototype.onSortChanged = function () {
	        if (!this.cacheExists()) {
	            return;
	        }
	        var newSortModel = this.extractSortModel();
	        var oldSortModel = this.cacheParams.sortModel;
	        var changedColumnsInSort = this.findChangedColumnsInSort(newSortModel, oldSortModel);
	        this.cacheParams.sortModel = newSortModel;
	        var rowGroupColIds = this.columnController.getRowGroupColumns().map(function (col) { return col.getId(); });
	        var serverSideCache = this.rootNode.childrenCache;
	        var sortingWithValueCol = this.isSortingWithValueColumn(changedColumnsInSort);
	        var sortingWithSecondaryCol = this.isSortingWithSecondaryColumn(changedColumnsInSort);
	        var sortAlwaysResets = this.gridOptionsWrapper.isServerSideSortingAlwaysResets();
	        if (sortAlwaysResets || sortingWithValueCol || sortingWithSecondaryCol) {
	            this.reset();
	        }
	        else {
	            serverSideCache.refreshCacheAfterSort(changedColumnsInSort, rowGroupColIds);
	        }
	    };
	    ServerSideRowModel.prototype.onValueChanged = function () {
	        this.reset();
	    };
	    ServerSideRowModel.prototype.onColumnRowGroupChanged = function () {
	        this.reset();
	    };
	    ServerSideRowModel.prototype.onColumnPivotChanged = function () {
	        this.reset();
	    };
	    ServerSideRowModel.prototype.onPivotModeChanged = function () {
	        this.reset();
	    };
	    ServerSideRowModel.prototype.onRowGroupOpened = function (event) {
	        var _this = this;
	        var rowNode = event.node;
	        if (rowNode.expanded) {
	            if (rowNode.master) {
	                this.createDetailNode(rowNode);
	            }
	            else if (ag_grid_community_1._.missing(rowNode.childrenCache)) {
	                this.createNodeCache(rowNode);
	            }
	        }
	        else {
	            if (this.gridOptionsWrapper.isPurgeClosedRowNodes() && ag_grid_community_1._.exists(rowNode.childrenCache)) {
	                rowNode.childrenCache.destroy();
	                rowNode.childrenCache = null;
	            }
	        }
	        var shouldAnimate = function () {
	            var rowAnimationEnabled = _this.gridOptionsWrapper.isAnimateRows();
	            if (rowNode.master) {
	                return rowAnimationEnabled && rowNode.expanded;
	            }
	            return rowAnimationEnabled;
	        };
	        this.updateRowIndexesAndBounds();
	        var modelUpdatedEvent = {
	            type: ag_grid_community_1.Events.EVENT_MODEL_UPDATED,
	            api: this.gridOptionsWrapper.getApi(),
	            columnApi: this.gridOptionsWrapper.getColumnApi(),
	            newPage: false,
	            newData: false,
	            animate: shouldAnimate(),
	            keepRenderedRows: true
	        };
	        this.eventService.dispatchEvent(modelUpdatedEvent);
	    };
	    ServerSideRowModel.prototype.reset = function () {
	        this.rootNode = new ag_grid_community_1.RowNode();
	        this.rootNode.group = true;
	        this.rootNode.level = -1;
	        this.getContext().wireBean(this.rootNode);
	        if (this.datasource) {
	            this.createNewRowNodeBlockLoader();
	            this.cacheParams = this.createCacheParams();
	            this.createNodeCache(this.rootNode);
	            this.updateRowIndexesAndBounds();
	        }
	        // this event: 1) clears selection 2) updates filters 3) shows/hides 'no rows' overlay
	        var rowDataChangedEvent = {
	            type: ag_grid_community_1.Events.EVENT_ROW_DATA_CHANGED,
	            api: this.gridApi,
	            columnApi: this.columnApi
	        };
	        this.eventService.dispatchEvent(rowDataChangedEvent);
	        // this gets the row to render rows (or remove the previously rendered rows, as it's blank to start).
	        // important to NOT pass in an event with keepRenderedRows or animate, as we want the renderer
	        // to treat the rows as new rows, as it's all new data
	        var modelUpdatedEvent = {
	            type: ag_grid_community_1.Events.EVENT_MODEL_UPDATED,
	            api: this.gridApi,
	            columnApi: this.columnApi,
	            animate: false,
	            keepRenderedRows: false,
	            newData: false,
	            newPage: false
	        };
	        this.eventService.dispatchEvent(modelUpdatedEvent);
	    };
	    ServerSideRowModel.prototype.createNewRowNodeBlockLoader = function () {
	        this.destroyRowNodeBlockLoader();
	        var maxConcurrentRequests = this.gridOptionsWrapper.getMaxConcurrentDatasourceRequests();
	        var blockLoadDebounceMillis = this.gridOptionsWrapper.getBlockLoadDebounceMillis();
	        this.rowNodeBlockLoader = new ag_grid_community_1.RowNodeBlockLoader(maxConcurrentRequests, blockLoadDebounceMillis);
	        this.getContext().wireBean(this.rowNodeBlockLoader);
	    };
	    ServerSideRowModel.prototype.destroyRowNodeBlockLoader = function () {
	        if (this.rowNodeBlockLoader) {
	            this.rowNodeBlockLoader.destroy();
	            this.rowNodeBlockLoader = undefined;
	        }
	    };
	    ServerSideRowModel.prototype.toValueObjects = function (columns) {
	        var _this = this;
	        return columns.map(function (col) { return ({
	            id: col.getId(),
	            aggFunc: col.getAggFunc(),
	            displayName: _this.columnController.getDisplayNameForColumn(col, 'model'),
	            field: col.getColDef().field
	        }); });
	    };
	    ServerSideRowModel.prototype.createCacheParams = function () {
	        var rowGroupColumnVos = this.toValueObjects(this.columnController.getRowGroupColumns());
	        var valueColumnVos = this.toValueObjects(this.columnController.getValueColumns());
	        var pivotColumnVos = this.toValueObjects(this.columnController.getPivotColumns());
	        var dynamicRowHeight = this.gridOptionsWrapper.isDynamicRowHeight();
	        var maxBlocksInCache = this.gridOptionsWrapper.getMaxBlocksInCache();
	        if (dynamicRowHeight && maxBlocksInCache >= 0) {
	            console.warn('ag-Grid: Server Side Row Model does not support Dynamic Row Height and Cache Purging. ' +
	                'Either a) remove getRowHeight() callback or b) remove maxBlocksInCache property. Purging has been disabled.');
	            maxBlocksInCache = undefined;
	        }
	        if (maxBlocksInCache >= 0 && this.columnController.isAutoRowHeightActive()) {
	            console.warn('ag-Grid: Server Side Row Model does not support Auto Row Height and Cache Purging. ' +
	                'Either a) remove colDef.autoHeight or b) remove maxBlocksInCache property. Purging has been disabled.');
	            maxBlocksInCache = undefined;
	        }
	        var params = {
	            // the columns the user has grouped and aggregated by
	            valueCols: valueColumnVos,
	            rowGroupCols: rowGroupColumnVos,
	            pivotCols: pivotColumnVos,
	            pivotMode: this.columnController.isPivotMode(),
	            // sort and filter model
	            filterModel: this.filterManager.getFilterModel(),
	            sortModel: this.extractSortModel(),
	            rowNodeBlockLoader: this.rowNodeBlockLoader,
	            datasource: this.datasource,
	            lastAccessedSequence: new ag_grid_community_1.NumberSequence(),
	            overflowSize: 1,
	            initialRowCount: 1,
	            maxConcurrentRequests: this.gridOptionsWrapper.getMaxConcurrentDatasourceRequests() || 0,
	            maxBlocksInCache: maxBlocksInCache,
	            blockSize: this.gridOptionsWrapper.getCacheBlockSize(),
	            rowHeight: this.rowHeight,
	            dynamicRowHeight: dynamicRowHeight
	        };
	        // set defaults
	        if (!(params.maxConcurrentRequests >= 1)) {
	            params.maxConcurrentRequests = 2;
	        }
	        // page size needs to be 1 or greater. having it at 1 would be silly, as you would be hitting the
	        // server for one page at a time. so the default if not specified is 100.
	        if (!(params.blockSize >= 1)) {
	            params.blockSize = serverSideBlock_1.ServerSideBlock.DefaultBlockSize;
	        }
	        // if user doesn't give initial rows to display, we assume zero
	        if (!(params.initialRowCount >= 1)) {
	            params.initialRowCount = 0;
	        }
	        // if user doesn't provide overflow, we use default overflow of 1, so user can scroll past
	        // the current page and request first row of next page
	        if (!(params.overflowSize >= 1)) {
	            params.overflowSize = 1;
	        }
	        return params;
	    };
	    ServerSideRowModel.prototype.createNodeCache = function (rowNode) {
	        var cache = new serverSideCache_1.ServerSideCache(this.cacheParams, rowNode);
	        this.getContext().wireBean(cache);
	        cache.addEventListener(ag_grid_community_1.RowNodeCache.EVENT_CACHE_UPDATED, this.onCacheUpdated.bind(this));
	        rowNode.childrenCache = cache;
	    };
	    ServerSideRowModel.prototype.onCacheUpdated = function () {
	        this.updateRowIndexesAndBounds();
	        var modelUpdatedEvent = {
	            type: ag_grid_community_1.Events.EVENT_MODEL_UPDATED,
	            api: this.gridApi,
	            columnApi: this.columnApi,
	            animate: this.gridOptionsWrapper.isAnimateRows(),
	            keepRenderedRows: true,
	            newPage: false,
	            newData: false
	        };
	        this.eventService.dispatchEvent(modelUpdatedEvent);
	    };
	    ServerSideRowModel.prototype.updateRowIndexesAndBounds = function () {
	        if (this.cacheExists()) {
	            // NOTE: should not be casting here, the RowModel should use IServerSideRowModel interface?
	            var serverSideCache = this.rootNode.childrenCache;
	            this.resetRowTops(serverSideCache);
	            this.setDisplayIndexes(serverSideCache);
	        }
	    };
	    ServerSideRowModel.prototype.setDisplayIndexes = function (cache) {
	        var numberSequence = new ag_grid_community_1.NumberSequence();
	        var nextRowTop = { value: 0 };
	        cache.setDisplayIndexes(numberSequence, nextRowTop);
	    };
	    // resetting row tops is needed for animation, as part of the operation is saving the old location,
	    // which is needed for rows that are transitioning in
	    ServerSideRowModel.prototype.resetRowTops = function (cache) {
	        var numberSequence = new ag_grid_community_1.NumberSequence();
	        cache.forEachNodeDeep(function (rowNode) { return rowNode.clearRowTop(); }, numberSequence);
	    };
	    ServerSideRowModel.prototype.getRow = function (index) {
	        if (this.cacheExists()) {
	            return this.rootNode.childrenCache.getRow(index);
	        }
	        return null;
	    };
	    ServerSideRowModel.prototype.getRowCount = function () {
	        if (!this.cacheExists()) {
	            return 1;
	        }
	        var serverSideCache = this.rootNode.childrenCache;
	        var res = serverSideCache.getDisplayIndexEnd();
	        return res;
	    };
	    ServerSideRowModel.prototype.getTopLevelRowCount = function () {
	        if (!this.cacheExists()) {
	            return 1;
	        }
	        var serverSideCache = this.rootNode.childrenCache;
	        return serverSideCache.getVirtualRowCount();
	    };
	    ServerSideRowModel.prototype.getTopLevelRowDisplayedIndex = function (topLevelIndex) {
	        if (!this.cacheExists()) {
	            return topLevelIndex;
	        }
	        var serverSideCache = this.rootNode.childrenCache;
	        return serverSideCache.getTopLevelRowDisplayedIndex(topLevelIndex);
	    };
	    ServerSideRowModel.prototype.getRowBounds = function (index) {
	        if (!this.cacheExists()) {
	            return {
	                rowTop: 0,
	                rowHeight: this.rowHeight
	            };
	        }
	        var serverSideCache = this.rootNode.childrenCache;
	        return serverSideCache.getRowBounds(index);
	    };
	    ServerSideRowModel.prototype.getRowIndexAtPixel = function (pixel) {
	        if (pixel === 0) {
	            return 0;
	        }
	        if (!this.cacheExists()) {
	            return 0;
	        }
	        var serverSideCache = this.rootNode.childrenCache;
	        return serverSideCache.getRowIndexAtPixel(pixel);
	    };
	    ServerSideRowModel.prototype.getCurrentPageHeight = function () {
	        return this.rowHeight * this.getRowCount();
	    };
	    ServerSideRowModel.prototype.isEmpty = function () {
	        return false;
	    };
	    ServerSideRowModel.prototype.isRowsToRender = function () {
	        return this.cacheExists() && this.getRowCount() > 0;
	    };
	    ServerSideRowModel.prototype.getType = function () {
	        return ag_grid_community_1.Constants.ROW_MODEL_TYPE_SERVER_SIDE;
	    };
	    ServerSideRowModel.prototype.forEachNode = function (callback) {
	        if (this.cacheExists()) {
	            this.rootNode.childrenCache.forEachNodeDeep(callback);
	        }
	    };
	    ServerSideRowModel.prototype.executeOnCache = function (route, callback) {
	        if (this.cacheExists()) {
	            var topLevelCache = this.rootNode.childrenCache;
	            var cacheToPurge = topLevelCache.getChildCache(route);
	            if (cacheToPurge) {
	                callback(cacheToPurge);
	            }
	        }
	    };
	    ServerSideRowModel.prototype.purgeCache = function (route) {
	        if (route === void 0) { route = []; }
	        this.executeOnCache(route, function (cache) { return cache.purgeCache(); });
	    };
	    ServerSideRowModel.prototype.getNodesInRangeForSelection = function (firstInRange, lastInRange) {
	        if (ag_grid_community_1._.exists(firstInRange) && firstInRange.parent !== lastInRange.parent) {
	            return [];
	        }
	        return lastInRange.parent.childrenCache.getRowNodesInRange(firstInRange, lastInRange);
	    };
	    ServerSideRowModel.prototype.getRowNode = function (id) {
	        var result = null;
	        this.forEachNode(function (rowNode) {
	            if (rowNode.id === id) {
	                result = rowNode;
	            }
	            if (rowNode.detailNode && rowNode.detailNode.id === id) {
	                result = rowNode.detailNode;
	            }
	        });
	        return result;
	    };
	    ServerSideRowModel.prototype.getBlockState = function () {
	        if (this.rowNodeBlockLoader) {
	            return this.rowNodeBlockLoader.getBlockState();
	        }
	        else {
	            return null;
	        }
	    };
	    // always returns true - this is used by the
	    ServerSideRowModel.prototype.isRowPresent = function (rowNode) {
	        var foundRowNode = this.getRowNode(rowNode.id);
	        return !!foundRowNode;
	    };
	    ServerSideRowModel.prototype.extractSortModel = function () {
	        var sortModel = this.sortController.getSortModel();
	        // when using tree data we just return the sort model with the 'ag-Grid-AutoColumn' as is, i.e not broken out
	        // into it's constitute group columns as they are not defined up front and can vary per node.
	        if (this.gridOptionsWrapper.isTreeData()) {
	            return sortModel;
	        }
	        var rowGroupCols = this.toValueObjects(this.columnController.getRowGroupColumns());
	        // find index of auto group column in sort model
	        var autoGroupIndex = -1;
	        for (var i = 0; i < sortModel.length; ++i) {
	            if (sortModel[i].colId === ag_grid_community_1.Constants.GROUP_AUTO_COLUMN_ID) {
	                autoGroupIndex = i;
	                break;
	            }
	        }
	        // replace auto column with individual group columns
	        if (autoGroupIndex > -1) {
	            var individualGroupCols = rowGroupCols.map(function (group) {
	                return {
	                    colId: group.field,
	                    sort: sortModel[autoGroupIndex].sort
	                };
	            });
	            // remove auto group column
	            sortModel.splice(autoGroupIndex, 1);
	            var _loop_1 = function (i) {
	                var individualGroupCol = individualGroupCols[i];
	                // don't add individual group column if non group column already exists as it gets precedence
	                var sameNonGroupColumnExists = sortModel.some(function (sm) { return sm.colId === individualGroupCol.colId; });
	                if (sameNonGroupColumnExists) {
	                    return "continue";
	                }
	                sortModel.splice(autoGroupIndex++, 0, individualGroupCol);
	            };
	            // insert individual group columns
	            for (var i = 0; i < individualGroupCols.length; i++) {
	                _loop_1(i);
	            }
	        }
	        // strip out multi-column prefix on colId's
	        if (this.gridOptionsWrapper.isGroupMultiAutoColumn()) {
	            var multiColumnPrefix = ag_grid_community_1.Constants.GROUP_AUTO_COLUMN_ID + "-";
	            for (var i = 0; i < sortModel.length; ++i) {
	                if (sortModel[i].colId.indexOf(multiColumnPrefix) > -1) {
	                    sortModel[i].colId = sortModel[i].colId.substr(multiColumnPrefix.length);
	                }
	            }
	        }
	        return sortModel;
	    };
	    ServerSideRowModel.prototype.isSortingWithValueColumn = function (changedColumnsInSort) {
	        var valueColIds = this.columnController.getValueColumns().map(function (col) { return col.getColId(); });
	        for (var i = 0; i < changedColumnsInSort.length; i++) {
	            if (valueColIds.indexOf(changedColumnsInSort[i]) > -1) {
	                return true;
	            }
	        }
	        return false;
	    };
	    ServerSideRowModel.prototype.isSortingWithSecondaryColumn = function (changedColumnsInSort) {
	        if (!this.columnController.getSecondaryColumns()) {
	            return false;
	        }
	        var secondaryColIds = this.columnController.getSecondaryColumns().map(function (col) { return col.getColId(); });
	        for (var i = 0; i < changedColumnsInSort.length; i++) {
	            if (secondaryColIds.indexOf(changedColumnsInSort[i]) > -1) {
	                return true;
	            }
	        }
	        return false;
	    };
	    ServerSideRowModel.prototype.cacheExists = function () {
	        return ag_grid_community_1._.exists(this.rootNode) && ag_grid_community_1._.exists(this.rootNode.childrenCache);
	    };
	    ServerSideRowModel.prototype.createDetailNode = function (masterNode) {
	        if (ag_grid_community_1._.exists(masterNode.detailNode)) {
	            return masterNode.detailNode;
	        }
	        else {
	            var detailNode = new ag_grid_community_1.RowNode();
	            this.getContext().wireBean(detailNode);
	            detailNode.detail = true;
	            detailNode.selectable = false;
	            detailNode.parent = masterNode;
	            if (ag_grid_community_1._.exists(masterNode.id)) {
	                detailNode.id = 'detail_' + masterNode.id;
	            }
	            detailNode.data = masterNode.data;
	            detailNode.level = masterNode.level + 1;
	            var defaultDetailRowHeight = 200;
	            var rowHeight = this.gridOptionsWrapper.getRowHeightForNode(detailNode).height;
	            detailNode.rowHeight = rowHeight ? rowHeight : defaultDetailRowHeight;
	            masterNode.detailNode = detailNode;
	            return detailNode;
	        }
	    };
	    ServerSideRowModel.prototype.isLoading = function () {
	        return this.rowNodeBlockLoader ? this.rowNodeBlockLoader.isLoading() : false;
	    };
	    __decorate([
	        ag_grid_community_1.Autowired('gridOptionsWrapper'),
	        __metadata("design:type", ag_grid_community_1.GridOptionsWrapper)
	    ], ServerSideRowModel.prototype, "gridOptionsWrapper", void 0);
	    __decorate([
	        ag_grid_community_1.Autowired('eventService'),
	        __metadata("design:type", ag_grid_community_1.EventService)
	    ], ServerSideRowModel.prototype, "eventService", void 0);
	    __decorate([
	        ag_grid_community_1.Autowired('columnController'),
	        __metadata("design:type", ag_grid_community_1.ColumnController)
	    ], ServerSideRowModel.prototype, "columnController", void 0);
	    __decorate([
	        ag_grid_community_1.Autowired('filterManager'),
	        __metadata("design:type", ag_grid_community_1.FilterManager)
	    ], ServerSideRowModel.prototype, "filterManager", void 0);
	    __decorate([
	        ag_grid_community_1.Autowired('sortController'),
	        __metadata("design:type", ag_grid_community_1.SortController)
	    ], ServerSideRowModel.prototype, "sortController", void 0);
	    __decorate([
	        ag_grid_community_1.Autowired('gridApi'),
	        __metadata("design:type", ag_grid_community_1.GridApi)
	    ], ServerSideRowModel.prototype, "gridApi", void 0);
	    __decorate([
	        ag_grid_community_1.Autowired('columnApi'),
	        __metadata("design:type", ag_grid_community_1.ColumnApi)
	    ], ServerSideRowModel.prototype, "columnApi", void 0);
	    __decorate([
	        ag_grid_community_1.Autowired('rowRenderer'),
	        __metadata("design:type", ag_grid_community_1.RowRenderer)
	    ], ServerSideRowModel.prototype, "rowRenderer", void 0);
	    __decorate([
	        ag_grid_community_1.PostConstruct,
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", []),
	        __metadata("design:returntype", void 0)
	    ], ServerSideRowModel.prototype, "postConstruct", null);
	    __decorate([
	        ag_grid_community_1.PreDestroy,
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", []),
	        __metadata("design:returntype", void 0)
	    ], ServerSideRowModel.prototype, "destroyDatasource", null);
	    __decorate([
	        __param(0, ag_grid_community_1.Qualifier('loggerFactory')),
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", [ag_grid_community_1.LoggerFactory]),
	        __metadata("design:returntype", void 0)
	    ], ServerSideRowModel.prototype, "setBeans", null);
	    ServerSideRowModel = __decorate([
	        ag_grid_community_1.Bean('rowModel')
	    ], ServerSideRowModel);
	    return ServerSideRowModel;
	}(ag_grid_community_1.BeanStub));
	exports.ServerSideRowModel = ServerSideRowModel;


/***/ }),
/* 2610 */
/***/ (function(module, exports, __webpack_require__) {

	// ag-grid-enterprise v21.2.2
	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var __param = (this && this.__param) || function (paramIndex, decorator) {
	    return function (target, key) { decorator(target, key, paramIndex); }
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var ag_grid_community_1 = __webpack_require__(2322);
	var serverSideBlock_1 = __webpack_require__(2611);
	var ServerSideCache = /** @class */ (function (_super) {
	    __extends(ServerSideCache, _super);
	    function ServerSideCache(cacheParams, parentRowNode) {
	        var _this = _super.call(this, cacheParams) || this;
	        // this will always be zero for the top level cache only,
	        // all the other ones change as the groups open and close
	        _this.displayIndexStart = 0;
	        _this.displayIndexEnd = 0; // not sure if setting this one to zero is necessary
	        _this.cacheTop = 0;
	        _this.blockHeights = {};
	        _this.parentRowNode = parentRowNode;
	        return _this;
	    }
	    ServerSideCache.prototype.setBeans = function (loggerFactory) {
	        this.logger = loggerFactory.create('ServerSideCache');
	    };
	    ServerSideCache.prototype.init = function () {
	        _super.prototype.init.call(this);
	    };
	    ServerSideCache.prototype.getRowBounds = function (index) {
	        var _this = this;
	        this.logger.log("getRowBounds(" + index + ")");
	        // we return null if row not found
	        // note - cast to "any" due to https://github.com/Microsoft/TypeScript/issues/11498
	        // should be RowBounds
	        var result;
	        var blockFound = false;
	        // note - cast to "any" due to https://github.com/Microsoft/TypeScript/issues/11498
	        // should be ServerSideBlock
	        var lastBlock = null;
	        this.forEachBlockInOrder(function (block) {
	            if (blockFound) {
	                return;
	            }
	            if (block.isDisplayIndexInBlock(index)) {
	                result = block.getRowBounds(index, _this.getVirtualRowCount());
	                blockFound = true;
	            }
	            else if (block.isBlockBefore(index)) {
	                lastBlock = block;
	            }
	        });
	        if (!blockFound) {
	            var nextRowTop = void 0;
	            var nextRowIndex = void 0;
	            if (lastBlock !== null) {
	                nextRowTop = lastBlock.getBlockTop() + lastBlock.getBlockHeight();
	                nextRowIndex = lastBlock.getDisplayIndexEnd();
	            }
	            else {
	                nextRowTop = this.cacheTop;
	                nextRowIndex = this.displayIndexStart;
	            }
	            var rowsBetween = index - nextRowIndex;
	            result = {
	                rowHeight: this.cacheParams.rowHeight,
	                rowTop: nextRowTop + rowsBetween * this.cacheParams.rowHeight
	            };
	        }
	        // NOTE: what about purged blocks
	        this.logger.log("getRowBounds(" + index + "), result = " + result);
	        return result;
	    };
	    ServerSideCache.prototype.destroyBlock = function (block) {
	        _super.prototype.destroyBlock.call(this, block);
	    };
	    ServerSideCache.prototype.getRowIndexAtPixel = function (pixel) {
	        var _this = this;
	        this.logger.log("getRowIndexAtPixel(" + pixel + ")");
	        // we return null if row not found
	        // note - cast to "any" due to https://github.com/Microsoft/TypeScript/issues/11498
	        // should be number
	        var result;
	        var blockFound = false;
	        // note - cast to "any" due to https://github.com/Microsoft/TypeScript/issues/11498
	        // should be ServerSideBlock
	        var lastBlock;
	        this.forEachBlockInOrder(function (block) {
	            if (blockFound) {
	                return;
	            }
	            if (block.isPixelInRange(pixel)) {
	                result = block.getRowIndexAtPixel(pixel, _this.getVirtualRowCount());
	                blockFound = true;
	            }
	            else if (block.getBlockTop() < pixel) {
	                lastBlock = block;
	            }
	        });
	        if (!blockFound) {
	            var nextRowTop = void 0;
	            var nextRowIndex = void 0;
	            if (lastBlock) {
	                nextRowTop = lastBlock.getBlockTop() + lastBlock.getBlockHeight();
	                nextRowIndex = lastBlock.getDisplayIndexEnd();
	            }
	            else {
	                nextRowTop = this.cacheTop;
	                nextRowIndex = this.displayIndexStart;
	            }
	            var pixelsBetween = pixel - nextRowTop;
	            var rowsBetween = (pixelsBetween / this.cacheParams.rowHeight) | 0;
	            result = nextRowIndex + rowsBetween;
	        }
	        var lastAllowedIndex = this.getDisplayIndexEnd() - 1;
	        if (result > lastAllowedIndex) {
	            result = lastAllowedIndex;
	        }
	        //NOTE: purged
	        this.logger.log("getRowIndexAtPixel(" + pixel + ") result = " + result);
	        return result;
	    };
	    ServerSideCache.prototype.clearRowTops = function () {
	        var _this = this;
	        this.forEachBlockInOrder(function (block) { return block.clearRowTops(_this.getVirtualRowCount()); });
	    };
	    ServerSideCache.prototype.setDisplayIndexes = function (displayIndexSeq, nextRowTop) {
	        var _this = this;
	        this.displayIndexStart = displayIndexSeq.peek();
	        this.cacheTop = nextRowTop.value;
	        var lastBlockId = -1;
	        var blockSize = this.getBlockSize();
	        this.forEachBlockInOrder(function (currentBlock, blockId) {
	            // if we skipped blocks, then we need to skip the row indexes. we assume that all missing
	            // blocks are made up of closed RowNodes only (if they were groups), as we never expire from
	            // the cache if any row nodes are open.
	            var blocksSkippedCount = blockId - lastBlockId - 1;
	            var rowsSkippedCount = blocksSkippedCount * blockSize;
	            if (rowsSkippedCount > 0) {
	                displayIndexSeq.skip(rowsSkippedCount);
	            }
	            for (var i = 1; i <= blocksSkippedCount; i++) {
	                var blockToAddId = blockId - i;
	                if (ag_grid_community_1._.exists(_this.blockHeights[blockToAddId])) {
	                    nextRowTop.value += _this.blockHeights[blockToAddId];
	                }
	                else {
	                    nextRowTop.value += blockSize * _this.cacheParams.rowHeight;
	                }
	            }
	            lastBlockId = blockId;
	            currentBlock.setDisplayIndexes(displayIndexSeq, _this.getVirtualRowCount(), nextRowTop);
	            _this.blockHeights[blockId] = currentBlock.getBlockHeight();
	        });
	        // if any blocks missing at the end, need to increase the row index for them also
	        // eg if block size = 10, we have total rows of 25 (indexes 0 .. 24), but first 2 blocks loaded (because
	        // last row was ejected from cache), then:
	        // lastVisitedRow = 19, virtualRowCount = 25, rows not accounted for = 5 (24 - 19)
	        var lastVisitedRow = ((lastBlockId + 1) * blockSize) - 1;
	        var rowCount = this.getVirtualRowCount();
	        var rowsNotAccountedFor = rowCount - lastVisitedRow - 1;
	        if (rowsNotAccountedFor > 0) {
	            displayIndexSeq.skip(rowsNotAccountedFor);
	            nextRowTop.value += rowsNotAccountedFor * this.cacheParams.rowHeight;
	        }
	        this.displayIndexEnd = displayIndexSeq.peek();
	        this.cacheHeight = nextRowTop.value - this.cacheTop;
	    };
	    // gets called in a) init() above and b) by the grid
	    ServerSideCache.prototype.getRow = function (displayRowIndex, dontCreateBlock) {
	        if (dontCreateBlock === void 0) { dontCreateBlock = false; }
	        // this can happen if asking for a row that doesn't exist in the model,
	        // eg if a cell range is selected, and the user filters so rows no longer
	        // exist
	        if (!this.isDisplayIndexInCache(displayRowIndex)) {
	            return null;
	        }
	        // if we have the block, then this is the block
	        var block = null;
	        // this is the last block that we have BEFORE the right block
	        // note - cast to "any" due to https://github.com/Microsoft/TypeScript/issues/11498
	        // should be ServerSideBlock
	        var beforeBlock = null;
	        this.forEachBlockInOrder(function (currentBlock) {
	            if (currentBlock.isDisplayIndexInBlock(displayRowIndex)) {
	                block = currentBlock;
	            }
	            else if (currentBlock.isBlockBefore(displayRowIndex)) {
	                // this will get assigned many times, but the last time will
	                // be the closest block to the required block that is BEFORE
	                beforeBlock = currentBlock;
	            }
	        });
	        // when we are moving rows around, we don't want to trigger loads
	        if (ag_grid_community_1._.missing(block) && dontCreateBlock) {
	            return null;
	        }
	        var blockSize = this.getBlockSize();
	        // if block not found, we need to load it
	        if (ag_grid_community_1._.missing(block)) {
	            var blockNumber = void 0;
	            var displayIndexStart_1;
	            var nextRowTop = void 0;
	            // because missing blocks are always fully closed, we can work out
	            // the start index of the block we want by hopping from the closest block,
	            // as we know the row count in closed blocks is equal to the page size
	            if (beforeBlock) {
	                blockNumber = beforeBlock.getBlockNumber() + 1;
	                displayIndexStart_1 = beforeBlock.getDisplayIndexEnd();
	                nextRowTop = beforeBlock.getBlockHeight() + beforeBlock.getBlockTop();
	                var isInRange = function () {
	                    return displayRowIndex >= displayIndexStart_1 && displayRowIndex < (displayIndexStart_1 + blockSize);
	                };
	                while (!isInRange()) {
	                    displayIndexStart_1 += blockSize;
	                    var cachedBlockHeight = this.blockHeights[blockNumber];
	                    if (ag_grid_community_1._.exists(cachedBlockHeight)) {
	                        nextRowTop += cachedBlockHeight;
	                    }
	                    else {
	                        nextRowTop += this.cacheParams.rowHeight * blockSize;
	                    }
	                    blockNumber++;
	                }
	            }
	            else {
	                var localIndex = displayRowIndex - this.displayIndexStart;
	                blockNumber = Math.floor(localIndex / blockSize);
	                displayIndexStart_1 = this.displayIndexStart + (blockNumber * blockSize);
	                nextRowTop = this.cacheTop + (blockNumber * blockSize * this.cacheParams.rowHeight);
	            }
	            block = this.createBlock(blockNumber, displayIndexStart_1, { value: nextRowTop });
	            this.logger.log("block missing, rowIndex = " + displayRowIndex + ", creating #" + blockNumber + ", displayIndexStart = " + displayIndexStart_1);
	        }
	        return block ? block.getRow(displayRowIndex) : null;
	    };
	    ServerSideCache.prototype.getBlockSize = function () {
	        return this.cacheParams.blockSize ? this.cacheParams.blockSize : serverSideBlock_1.ServerSideBlock.DefaultBlockSize;
	    };
	    ServerSideCache.prototype.getTopLevelRowDisplayedIndex = function (topLevelIndex) {
	        var blockSize = this.getBlockSize();
	        var blockId = Math.floor(topLevelIndex / blockSize);
	        var block = this.getBlock(blockId);
	        if (block) {
	            // if we found a block, means row is in memory, so we can report the row index directly
	            var rowNode = block.getRowUsingLocalIndex(topLevelIndex, true);
	            return rowNode.rowIndex;
	        }
	        else {
	            // otherwise we need to calculate it from the previous block
	            var blockBefore_1;
	            this.forEachBlockInOrder(function (currentBlock, currentId) {
	                if (blockId > currentId) {
	                    // this will get assigned many times, but the last time will
	                    // be the closest block to the required block that is BEFORE
	                    blockBefore_1 = currentBlock;
	                }
	            });
	            if (blockBefore_1) {
	                // note: the local index is the same as the top level index, two terms for same thing
	                //
	                // get index of the last row before this row
	                // eg if blocksize = 100, then:
	                //   last row of first block is 99 (100 * 1) -1;
	                //   last row of second block is 199 (100 * 2) -1;
	                var lastRowTopLevelIndex = (blockSize * (blockBefore_1.getBlockNumber() + 1)) - 1;
	                // this is the last loaded rownode in the cache that is before the row we are interested in.
	                // we are guaranteed no rows are open. so the difference between the topTopIndex will be the
	                // same as the difference between the displayed index
	                var indexDiff = topLevelIndex - lastRowTopLevelIndex;
	                var lastRowNode = blockBefore_1.getRowUsingLocalIndex(lastRowTopLevelIndex, true);
	                return lastRowNode.rowIndex + indexDiff;
	            }
	            else {
	                return topLevelIndex;
	            }
	        }
	    };
	    ServerSideCache.prototype.createBlock = function (blockNumber, displayIndex, nextRowTop) {
	        var newBlock = new serverSideBlock_1.ServerSideBlock(blockNumber, this.parentRowNode, this.cacheParams, this);
	        this.getContext().wireBean(newBlock);
	        var displayIndexSequence = new ag_grid_community_1.NumberSequence(displayIndex);
	        newBlock.setDisplayIndexes(displayIndexSequence, this.getVirtualRowCount(), nextRowTop);
	        this.postCreateBlock(newBlock);
	        return newBlock;
	    };
	    ServerSideCache.prototype.getDisplayIndexEnd = function () {
	        return this.displayIndexEnd;
	    };
	    ServerSideCache.prototype.isDisplayIndexInCache = function (displayIndex) {
	        if (this.getVirtualRowCount() === 0) {
	            return false;
	        }
	        return displayIndex >= this.displayIndexStart && displayIndex < this.displayIndexEnd;
	    };
	    ServerSideCache.prototype.getChildCache = function (keys) {
	        var _this = this;
	        if (ag_grid_community_1._.missingOrEmpty(keys)) {
	            return this;
	        }
	        var nextKey = keys[0];
	        var nextServerSideCache = null;
	        this.forEachBlockInOrder(function (block) {
	            // callback: (rowNode: RowNode, index: number) => void, sequence: NumberSequence, rowCount: number
	            block.forEachNodeShallow(function (rowNode) {
	                if (rowNode.key === nextKey) {
	                    nextServerSideCache = rowNode.childrenCache;
	                }
	            }, new ag_grid_community_1.NumberSequence(), _this.getVirtualRowCount());
	        });
	        if (nextServerSideCache) {
	            var keyListForNextLevel = keys.slice(1, keys.length);
	            return nextServerSideCache ? nextServerSideCache.getChildCache(keyListForNextLevel) : null;
	        }
	        else {
	            return null;
	        }
	    };
	    ServerSideCache.prototype.isPixelInRange = function (pixel) {
	        if (this.getVirtualRowCount() === 0) {
	            return false;
	        }
	        return pixel >= this.cacheTop && pixel < (this.cacheTop + this.cacheHeight);
	    };
	    ServerSideCache.prototype.refreshCacheAfterSort = function (changedColumnsInSort, rowGroupColIds) {
	        var _this = this;
	        var level = this.parentRowNode.level + 1;
	        var grouping = level < this.cacheParams.rowGroupCols.length;
	        var shouldPurgeCache;
	        if (grouping) {
	            var groupColVo = this.cacheParams.rowGroupCols[level];
	            var groupField = groupColVo.field;
	            var rowGroupBlock = rowGroupColIds.indexOf(groupField) > -1;
	            var sortingByGroup = changedColumnsInSort.indexOf(groupField) > -1;
	            shouldPurgeCache = rowGroupBlock && sortingByGroup;
	        }
	        else {
	            shouldPurgeCache = true;
	        }
	        if (shouldPurgeCache) {
	            this.purgeCache();
	        }
	        else {
	            this.forEachBlockInOrder(function (block) {
	                if (block.isGroupLevel()) {
	                    var callback = function (rowNode) {
	                        var nextCache = rowNode.childrenCache;
	                        if (nextCache) {
	                            nextCache.refreshCacheAfterSort(changedColumnsInSort, rowGroupColIds);
	                        }
	                    };
	                    block.forEachNodeShallow(callback, new ag_grid_community_1.NumberSequence(), _this.getVirtualRowCount());
	                }
	            });
	        }
	    };
	    __decorate([
	        ag_grid_community_1.Autowired('eventService'),
	        __metadata("design:type", ag_grid_community_1.EventService)
	    ], ServerSideCache.prototype, "eventService", void 0);
	    __decorate([
	        ag_grid_community_1.Autowired('gridOptionsWrapper'),
	        __metadata("design:type", ag_grid_community_1.GridOptionsWrapper)
	    ], ServerSideCache.prototype, "gridOptionsWrapper", void 0);
	    __decorate([
	        __param(0, ag_grid_community_1.Qualifier('loggerFactory')),
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", [ag_grid_community_1.LoggerFactory]),
	        __metadata("design:returntype", void 0)
	    ], ServerSideCache.prototype, "setBeans", null);
	    __decorate([
	        ag_grid_community_1.PostConstruct,
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", []),
	        __metadata("design:returntype", void 0)
	    ], ServerSideCache.prototype, "init", null);
	    return ServerSideCache;
	}(ag_grid_community_1.RowNodeCache));
	exports.ServerSideCache = ServerSideCache;


/***/ }),
/* 2611 */
/***/ (function(module, exports, __webpack_require__) {

	// ag-grid-enterprise v21.2.2
	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var __param = (this && this.__param) || function (paramIndex, decorator) {
	    return function (target, key) { decorator(target, key, paramIndex); }
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var ag_grid_community_1 = __webpack_require__(2322);
	var ServerSideBlock = /** @class */ (function (_super) {
	    __extends(ServerSideBlock, _super);
	    function ServerSideBlock(pageNumber, parentRowNode, params, parentCache) {
	        var _this = _super.call(this, pageNumber, params) || this;
	        _this.params = params;
	        _this.parentRowNode = parentRowNode;
	        _this.parentCache = parentCache;
	        _this.level = parentRowNode.level + 1;
	        _this.groupLevel = params.rowGroupCols ? _this.level < params.rowGroupCols.length : undefined;
	        _this.leafGroup = params.rowGroupCols ? _this.level === params.rowGroupCols.length - 1 : false;
	        return _this;
	    }
	    ServerSideBlock.prototype.init = function () {
	        this.usingTreeData = this.gridOptionsWrapper.isTreeData();
	        this.usingMasterDetail = this.gridOptionsWrapper.isMasterDetail();
	        if (!this.usingTreeData && this.groupLevel) {
	            var groupColVo = this.params.rowGroupCols[this.level];
	            this.groupField = groupColVo.field;
	            this.rowGroupColumn = this.columnController.getRowGroupColumns()[this.level];
	        }
	        this.createNodeIdPrefix();
	        _super.prototype.init.call(this, {
	            context: this.getContext(),
	            rowRenderer: this.rowRenderer
	        });
	    };
	    ServerSideBlock.prototype.setBeans = function (loggerFactory) {
	        this.logger = loggerFactory.create('ServerSideBlock');
	    };
	    ServerSideBlock.prototype.createNodeIdPrefix = function () {
	        var parts = [];
	        var rowNode = this.parentRowNode;
	        // pull keys from all parent nodes, but do not include the root node
	        while (rowNode && rowNode.level >= 0) {
	            parts.push(rowNode.key);
	            rowNode = rowNode.parent;
	        }
	        if (parts.length > 0) {
	            this.nodeIdPrefix = parts.reverse().join('-') + '-';
	        }
	    };
	    ServerSideBlock.prototype.createIdForIndex = function (index) {
	        if (ag_grid_community_1._.exists(this.nodeIdPrefix)) {
	            return this.nodeIdPrefix + index.toString();
	        }
	        else {
	            return index.toString();
	        }
	    };
	    ServerSideBlock.prototype.getNodeIdPrefix = function () {
	        return this.nodeIdPrefix;
	    };
	    ServerSideBlock.prototype.getRow = function (displayRowIndex) {
	        var bottomPointer = this.getStartRow();
	        // the end row depends on whether all this block is used or not. if the virtual row count
	        // is before the end, then not all the row is used
	        var virtualRowCount = this.parentCache.getVirtualRowCount();
	        var endRow = this.getEndRow();
	        var actualEnd = (virtualRowCount < endRow) ? virtualRowCount : endRow;
	        var topPointer = actualEnd - 1;
	        if (ag_grid_community_1._.missing(topPointer) || ag_grid_community_1._.missing(bottomPointer)) {
	            console.warn("ag-grid: error: topPointer = " + topPointer + ", bottomPointer = " + bottomPointer);
	            return null;
	        }
	        while (true) {
	            var midPointer = Math.floor((bottomPointer + topPointer) / 2);
	            var currentRowNode = _super.prototype.getRowUsingLocalIndex.call(this, midPointer);
	            // first check current row for index
	            if (currentRowNode.rowIndex === displayRowIndex) {
	                return currentRowNode;
	            }
	            // then check if current row contains a detail row with the index
	            var expandedMasterRow = currentRowNode.master && currentRowNode.expanded;
	            if (expandedMasterRow && currentRowNode.detailNode.rowIndex === displayRowIndex) {
	                return currentRowNode.detailNode;
	            }
	            // then check if child cache contains index
	            var childrenCache = currentRowNode.childrenCache;
	            if (currentRowNode.expanded && childrenCache && childrenCache.isDisplayIndexInCache(displayRowIndex)) {
	                return childrenCache.getRow(displayRowIndex);
	            }
	            // otherwise adjust pointers to continue searching for index
	            if (currentRowNode.rowIndex < displayRowIndex) {
	                bottomPointer = midPointer + 1;
	            }
	            else if (currentRowNode.rowIndex > displayRowIndex) {
	                topPointer = midPointer - 1;
	            }
	            else {
	                console.warn("ag-Grid: error: unable to locate rowIndex = " + displayRowIndex + " in cache");
	                return null;
	            }
	        }
	    };
	    ServerSideBlock.prototype.setDataAndId = function (rowNode, data, index) {
	        var _this = this;
	        rowNode.stub = false;
	        if (ag_grid_community_1._.exists(data)) {
	            // if the user is not providing id's, then we build an id based on the index.
	            // for infinite scrolling, the index is used on it's own. for Server Side Row Model,
	            // we combine the index with the level and group key, so that the id is
	            // unique across the set.
	            //
	            // unique id is needed for selection (so selection can be maintained when
	            // doing server side sorting / filtering) - if user is not providing id's
	            // (and we use the indexes) then selection will not work between sorting &
	            // filtering.
	            //
	            // id's are also used by the row renderer for updating the dom as it identifies
	            // rowNodes by id
	            var idToUse = this.createIdForIndex(index);
	            rowNode.setDataAndId(data, idToUse);
	            rowNode.setRowHeight(this.gridOptionsWrapper.getRowHeightForNode(rowNode).height);
	            if (this.usingTreeData) {
	                var getServerSideGroupKey = this.gridOptionsWrapper.getServerSideGroupKeyFunc();
	                if (ag_grid_community_1._.exists(getServerSideGroupKey) && getServerSideGroupKey) {
	                    rowNode.key = getServerSideGroupKey(rowNode.data);
	                }
	                var isServerSideGroup = this.gridOptionsWrapper.getIsServerSideGroupFunc();
	                if (ag_grid_community_1._.exists(isServerSideGroup) && isServerSideGroup) {
	                    rowNode.group = isServerSideGroup(rowNode.data);
	                }
	            }
	            else if (rowNode.group) {
	                rowNode.key = this.valueService.getValue(this.rowGroupColumn, rowNode);
	                if (rowNode.key === null || rowNode.key === undefined) {
	                    ag_grid_community_1._.doOnce(function () {
	                        console.warn("null and undefined values are not allowed for server side row model keys");
	                        if (_this.rowGroupColumn) {
	                            console.warn("column = " + _this.rowGroupColumn.getId());
	                        }
	                        console.warn("data is ", rowNode.data);
	                    }, 'ServerSideBlock-CannotHaveNullOrUndefinedForKey');
	                }
	            }
	            else if (this.usingMasterDetail) {
	                var isRowMasterFunc = this.gridOptionsWrapper.getIsRowMasterFunc();
	                if (ag_grid_community_1._.exists(isRowMasterFunc) && isRowMasterFunc) {
	                    rowNode.master = isRowMasterFunc(rowNode.data);
	                }
	                else {
	                    rowNode.master = true;
	                }
	            }
	        }
	        else {
	            rowNode.setDataAndId(undefined, undefined);
	            rowNode.key = null;
	        }
	        if (this.usingTreeData || this.groupLevel) {
	            this.setGroupDataIntoRowNode(rowNode);
	            this.setChildCountIntoRowNode(rowNode);
	        }
	    };
	    ServerSideBlock.prototype.setChildCountIntoRowNode = function (rowNode) {
	        var getChildCount = this.gridOptionsWrapper.getChildCountFunc();
	        if (getChildCount) {
	            rowNode.allChildrenCount = getChildCount(rowNode.data);
	        }
	    };
	    ServerSideBlock.prototype.setGroupDataIntoRowNode = function (rowNode) {
	        var _this = this;
	        var groupDisplayCols = this.columnController.getGroupDisplayColumns();
	        var usingTreeData = this.gridOptionsWrapper.isTreeData();
	        groupDisplayCols.forEach(function (col) {
	            if (usingTreeData) {
	                if (ag_grid_community_1._.missing(rowNode.groupData)) {
	                    rowNode.groupData = {};
	                }
	                rowNode.groupData[col.getColId()] = rowNode.key;
	            }
	            else if (col.isRowGroupDisplayed(_this.rowGroupColumn.getId())) {
	                var groupValue = _this.valueService.getValue(_this.rowGroupColumn, rowNode);
	                if (ag_grid_community_1._.missing(rowNode.groupData)) {
	                    rowNode.groupData = {};
	                }
	                rowNode.groupData[col.getColId()] = groupValue;
	            }
	        });
	    };
	    ServerSideBlock.prototype.loadFromDatasource = function () {
	        var _this = this;
	        var params = this.createLoadParams();
	        window.setTimeout(function () {
	            if (_this.params.datasource) {
	                _this.params.datasource.getRows(params);
	            }
	        }, 0);
	    };
	    ServerSideBlock.prototype.createBlankRowNode = function (rowIndex) {
	        var rowNode = _super.prototype.createBlankRowNode.call(this, rowIndex);
	        rowNode.group = this.groupLevel;
	        rowNode.leafGroup = this.leafGroup;
	        rowNode.level = this.level;
	        rowNode.uiLevel = this.level;
	        rowNode.parent = this.parentRowNode;
	        // stub gets set to true here, and then false when this rowNode gets it's data
	        rowNode.stub = true;
	        if (rowNode.group) {
	            rowNode.expanded = false;
	            rowNode.field = this.groupField;
	            rowNode.rowGroupColumn = this.rowGroupColumn;
	        }
	        return rowNode;
	    };
	    ServerSideBlock.prototype.createGroupKeys = function (groupNode) {
	        var keys = [];
	        var pointer = groupNode;
	        while (pointer && pointer.level >= 0) {
	            keys.push(pointer.key);
	            pointer = pointer.parent;
	        }
	        keys.reverse();
	        return keys;
	    };
	    ServerSideBlock.prototype.isPixelInRange = function (pixel) {
	        return pixel >= this.blockTop && pixel < (this.blockTop + this.blockHeight);
	    };
	    ServerSideBlock.prototype.getRowBounds = function (index, virtualRowCount) {
	        var start = this.getStartRow();
	        var end = this.getEndRow();
	        var extractRowBounds = function (rowNode) {
	            return {
	                rowHeight: rowNode.rowHeight,
	                rowTop: rowNode.rowTop
	            };
	        };
	        for (var i = start; i <= end; i++) {
	            // the blocks can have extra rows in them, if they are the last block
	            // in the cache and the virtual row count doesn't divide evenly by the
	            if (i >= virtualRowCount) {
	                continue;
	            }
	            var rowNode = this.getRowUsingLocalIndex(i);
	            if (rowNode) {
	                if (rowNode.rowIndex === index) {
	                    return extractRowBounds(rowNode);
	                }
	                if (rowNode.group && rowNode.expanded && ag_grid_community_1._.exists(rowNode.childrenCache)) {
	                    var serverSideCache = rowNode.childrenCache;
	                    if (serverSideCache.isDisplayIndexInCache(index)) {
	                        return serverSideCache.getRowBounds(index);
	                    }
	                }
	                else if (rowNode.master && rowNode.expanded && ag_grid_community_1._.exists(rowNode.detailNode)) {
	                    if (rowNode.detailNode.rowIndex === index) {
	                        return extractRowBounds(rowNode.detailNode);
	                    }
	                }
	            }
	        }
	        console.error(" ag-Grid: looking for invalid row index in Server Side Row Model, index=" + index);
	        return null;
	    };
	    ServerSideBlock.prototype.getRowIndexAtPixel = function (pixel, virtualRowCount) {
	        var start = this.getStartRow();
	        var end = this.getEndRow();
	        for (var i = start; i <= end; i++) {
	            // the blocks can have extra rows in them, if they are the last block
	            // in the cache and the virtual row count doesn't divide evenly by the
	            if (i >= virtualRowCount) {
	                continue;
	            }
	            var rowNode = this.getRowUsingLocalIndex(i);
	            if (rowNode) {
	                // first check if pixel is in range of current row
	                if (rowNode.isPixelInRange(pixel)) {
	                    return rowNode.rowIndex;
	                }
	                // then check if current row contains a detail row with pixel in range
	                var expandedMasterRow = rowNode.master && rowNode.expanded;
	                if (expandedMasterRow && rowNode.detailNode.isPixelInRange(pixel)) {
	                    return rowNode.detailNode.rowIndex;
	                }
	                // then check if it's a group row with a child cache with pixel in range
	                if (rowNode.group && rowNode.expanded && ag_grid_community_1._.exists(rowNode.childrenCache)) {
	                    var serverSideCache = rowNode.childrenCache;
	                    if (serverSideCache.isPixelInRange(pixel)) {
	                        return serverSideCache.getRowIndexAtPixel(pixel);
	                    }
	                }
	            }
	        }
	        console.warn("ag-Grid: invalid pixel range for server side block " + pixel);
	        return 0;
	    };
	    ServerSideBlock.prototype.clearRowTops = function (virtualRowCount) {
	        this.forEachRowNode(virtualRowCount, function (rowNode) {
	            rowNode.clearRowTop();
	            var hasChildCache = rowNode.group && ag_grid_community_1._.exists(rowNode.childrenCache);
	            if (hasChildCache) {
	                var serverSideCache = rowNode.childrenCache;
	                serverSideCache.clearRowTops();
	            }
	        });
	    };
	    ServerSideBlock.prototype.setDisplayIndexes = function (displayIndexSeq, virtualRowCount, nextRowTop) {
	        this.displayIndexStart = displayIndexSeq.peek();
	        this.blockTop = nextRowTop.value;
	        this.forEachRowNode(virtualRowCount, function (rowNode) {
	            rowNode.setRowIndex(displayIndexSeq.next());
	            rowNode.setRowTop(nextRowTop.value);
	            nextRowTop.value += rowNode.rowHeight;
	            var hasDetailRow = rowNode.master && rowNode.expanded;
	            if (hasDetailRow) {
	                rowNode.detailNode.setRowIndex(displayIndexSeq.next());
	                rowNode.detailNode.setRowTop(nextRowTop.value);
	                nextRowTop.value += rowNode.detailNode.rowHeight;
	            }
	            var hasChildCache = rowNode.group && ag_grid_community_1._.exists(rowNode.childrenCache);
	            if (hasChildCache) {
	                var serverSideCache = rowNode.childrenCache;
	                if (rowNode.expanded) {
	                    serverSideCache.setDisplayIndexes(displayIndexSeq, nextRowTop);
	                }
	                else {
	                    // we need to clear the row tops, as the row renderer depends on
	                    // this to know if the row should be faded out
	                    serverSideCache.clearRowTops();
	                }
	            }
	        });
	        this.displayIndexEnd = displayIndexSeq.peek();
	        this.blockHeight = nextRowTop.value - this.blockTop;
	    };
	    ServerSideBlock.prototype.forEachRowNode = function (virtualRowCount, callback) {
	        var start = this.getStartRow();
	        var end = this.getEndRow();
	        for (var i = start; i <= end; i++) {
	            // the blocks can have extra rows in them, if they are the last block
	            // in the cache and the virtual row count doesn't divide evenly by the
	            if (i >= virtualRowCount) {
	                continue;
	            }
	            var rowNode = this.getRowUsingLocalIndex(i);
	            if (rowNode) {
	                callback(rowNode);
	            }
	        }
	    };
	    ServerSideBlock.prototype.createLoadParams = function () {
	        var groupKeys = this.createGroupKeys(this.parentRowNode);
	        var request = {
	            startRow: this.getStartRow(),
	            endRow: this.getEndRow(),
	            rowGroupCols: this.params.rowGroupCols,
	            valueCols: this.params.valueCols,
	            pivotCols: this.params.pivotCols,
	            pivotMode: this.params.pivotMode,
	            groupKeys: groupKeys,
	            filterModel: this.params.filterModel,
	            sortModel: this.params.sortModel
	        };
	        var params = {
	            successCallback: this.pageLoaded.bind(this, this.getVersion()),
	            failCallback: this.pageLoadFailed.bind(this),
	            request: request,
	            parentNode: this.parentRowNode
	        };
	        return params;
	    };
	    ServerSideBlock.prototype.isDisplayIndexInBlock = function (displayIndex) {
	        return displayIndex >= this.displayIndexStart && displayIndex < this.displayIndexEnd;
	    };
	    ServerSideBlock.prototype.isBlockBefore = function (displayIndex) {
	        return displayIndex >= this.displayIndexEnd;
	    };
	    ServerSideBlock.prototype.getDisplayIndexStart = function () {
	        return this.displayIndexStart;
	    };
	    ServerSideBlock.prototype.getDisplayIndexEnd = function () {
	        return this.displayIndexEnd;
	    };
	    ServerSideBlock.prototype.getBlockHeight = function () {
	        return this.blockHeight;
	    };
	    ServerSideBlock.prototype.getBlockTop = function () {
	        return this.blockTop;
	    };
	    ServerSideBlock.prototype.isGroupLevel = function () {
	        return this.groupLevel;
	    };
	    ServerSideBlock.prototype.getGroupField = function () {
	        return this.groupField;
	    };
	    ServerSideBlock.DefaultBlockSize = 100;
	    __decorate([
	        ag_grid_community_1.Autowired('rowRenderer'),
	        __metadata("design:type", ag_grid_community_1.RowRenderer)
	    ], ServerSideBlock.prototype, "rowRenderer", void 0);
	    __decorate([
	        ag_grid_community_1.Autowired('columnController'),
	        __metadata("design:type", ag_grid_community_1.ColumnController)
	    ], ServerSideBlock.prototype, "columnController", void 0);
	    __decorate([
	        ag_grid_community_1.Autowired('valueService'),
	        __metadata("design:type", ag_grid_community_1.ValueService)
	    ], ServerSideBlock.prototype, "valueService", void 0);
	    __decorate([
	        ag_grid_community_1.Autowired('gridOptionsWrapper'),
	        __metadata("design:type", ag_grid_community_1.GridOptionsWrapper)
	    ], ServerSideBlock.prototype, "gridOptionsWrapper", void 0);
	    __decorate([
	        ag_grid_community_1.PostConstruct,
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", []),
	        __metadata("design:returntype", void 0)
	    ], ServerSideBlock.prototype, "init", null);
	    __decorate([
	        __param(0, ag_grid_community_1.Qualifier('loggerFactory')),
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", [ag_grid_community_1.LoggerFactory]),
	        __metadata("design:returntype", void 0)
	    ], ServerSideBlock.prototype, "setBeans", null);
	    return ServerSideBlock;
	}(ag_grid_community_1.RowNodeBlock));
	exports.ServerSideBlock = ServerSideBlock;


/***/ }),
/* 2612 */
/***/ (function(module, exports, __webpack_require__) {

	// ag-grid-enterprise v21.2.2
	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var ag_grid_community_1 = __webpack_require__(2322);
	var StatusBarService = /** @class */ (function () {
	    // tslint:disable-next-line
	    function StatusBarService() {
	        this.allComponents = {};
	    }
	    StatusBarService.prototype.registerStatusPanel = function (key, component) {
	        this.allComponents[key] = component;
	    };
	    StatusBarService.prototype.getStatusPanel = function (key) {
	        return this.allComponents[key];
	    };
	    StatusBarService = __decorate([
	        ag_grid_community_1.Bean('statusBarService'),
	        __metadata("design:paramtypes", [])
	    ], StatusBarService);
	    return StatusBarService;
	}());
	exports.StatusBarService = StatusBarService;


/***/ }),
/* 2613 */
/***/ (function(module, exports, __webpack_require__) {

	// ag-grid-enterprise v21.2.2
	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var ag_grid_community_1 = __webpack_require__(2322);
	var statusBarService_1 = __webpack_require__(2612);
	var StatusBar = /** @class */ (function (_super) {
	    __extends(StatusBar, _super);
	    function StatusBar() {
	        return _super.call(this, StatusBar.TEMPLATE) || this;
	    }
	    StatusBar.prototype.postConstruct = function () {
	        if (this.gridOptions.statusBar && this.gridOptions.statusBar.statusPanels) {
	            var leftStatusPanelComponents = this.gridOptions.statusBar.statusPanels
	                .filter(function (componentConfig) { return componentConfig.align === 'left'; });
	            this.createAndRenderComponents(leftStatusPanelComponents, this.eStatusBarLeft);
	            var centerStatusPanelComponents = this.gridOptions.statusBar.statusPanels
	                .filter(function (componentConfig) { return componentConfig.align === 'center'; });
	            this.createAndRenderComponents(centerStatusPanelComponents, this.eStatusBarCenter);
	            var rightStatusPanelComponents = this.gridOptions.statusBar.statusPanels
	                .filter(function (componentConfig) { return (!componentConfig.align || componentConfig.align === 'right'); });
	            this.createAndRenderComponents(rightStatusPanelComponents, this.eStatusBarRight);
	        }
	    };
	    StatusBar.prototype.createAndRenderComponents = function (statusBarComponents, ePanelComponent) {
	        var _this = this;
	        var componentDetails = [];
	        ag_grid_community_1._.forEach(statusBarComponents, function (componentConfig) {
	            var params = {
	                api: _this.gridOptionsWrapper.getApi(),
	                columnApi: _this.gridOptionsWrapper.getColumnApi(),
	                context: _this.gridOptionsWrapper.getContext()
	            };
	            var promise = _this.userComponentFactory.newStatusPanelComponent(componentConfig, params);
	            componentDetails.push({
	                // default to the component name if no key supplied
	                key: componentConfig.key || componentConfig.statusPanel,
	                promise: promise
	            });
	        });
	        ag_grid_community_1.Promise.all(componentDetails.map(function (details) { return details.promise; }))
	            .then(function () {
	            ag_grid_community_1._.forEach(componentDetails, function (componentDetail) {
	                componentDetail.promise.then(function (component) {
	                    var destroyFunc = function () {
	                        if (component.destroy) {
	                            component.destroy();
	                        }
	                    };
	                    if (_this.isAlive()) {
	                        _this.statusBarService.registerStatusPanel(componentDetail.key, component);
	                        ePanelComponent.appendChild(component.getGui());
	                        _this.addDestroyFunc(destroyFunc);
	                    }
	                    else {
	                        destroyFunc();
	                    }
	                });
	            });
	        });
	    };
	    StatusBar.TEMPLATE = "<div class=\"ag-status-bar\">\n        <div ref=\"eStatusBarLeft\" class=\"ag-status-bar-left\"></div>\n        <div ref=\"eStatusBarCenter\" class=\"ag-status-bar-center\"></div>\n        <div ref=\"eStatusBarRight\" class=\"ag-status-bar-right\"></div>\n    </div>";
	    __decorate([
	        ag_grid_community_1.Autowired('gridOptionsWrapper'),
	        __metadata("design:type", ag_grid_community_1.GridOptionsWrapper)
	    ], StatusBar.prototype, "gridOptionsWrapper", void 0);
	    __decorate([
	        ag_grid_community_1.Autowired('gridOptions'),
	        __metadata("design:type", Object)
	    ], StatusBar.prototype, "gridOptions", void 0);
	    __decorate([
	        ag_grid_community_1.Autowired('userComponentFactory'),
	        __metadata("design:type", ag_grid_community_1.UserComponentFactory)
	    ], StatusBar.prototype, "userComponentFactory", void 0);
	    __decorate([
	        ag_grid_community_1.Autowired('statusBarService'),
	        __metadata("design:type", statusBarService_1.StatusBarService)
	    ], StatusBar.prototype, "statusBarService", void 0);
	    __decorate([
	        ag_grid_community_1.RefSelector('eStatusBarLeft'),
	        __metadata("design:type", HTMLElement)
	    ], StatusBar.prototype, "eStatusBarLeft", void 0);
	    __decorate([
	        ag_grid_community_1.RefSelector('eStatusBarCenter'),
	        __metadata("design:type", HTMLElement)
	    ], StatusBar.prototype, "eStatusBarCenter", void 0);
	    __decorate([
	        ag_grid_community_1.RefSelector('eStatusBarRight'),
	        __metadata("design:type", HTMLElement)
	    ], StatusBar.prototype, "eStatusBarRight", void 0);
	    __decorate([
	        ag_grid_community_1.PostConstruct,
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", []),
	        __metadata("design:returntype", void 0)
	    ], StatusBar.prototype, "postConstruct", null);
	    return StatusBar;
	}(ag_grid_community_1.Component));
	exports.StatusBar = StatusBar;


/***/ }),
/* 2614 */
/***/ (function(module, exports, __webpack_require__) {

	// ag-grid-enterprise v21.2.2
	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var main_1 = __webpack_require__(2322);
	var rowGroupDropZonePanel_1 = __webpack_require__(2538);
	var pivotDropZonePanel_1 = __webpack_require__(2542);
	var GridHeaderDropZones = /** @class */ (function (_super) {
	    __extends(GridHeaderDropZones, _super);
	    function GridHeaderDropZones() {
	        return _super.call(this) || this;
	    }
	    GridHeaderDropZones.prototype.postConstruct = function () {
	        this.setGui(this.createNorthPanel());
	        this.eventService.addEventListener(main_1.Events.EVENT_COLUMN_ROW_GROUP_CHANGED, this.onRowGroupChanged.bind(this));
	        this.eventService.addEventListener(main_1.Events.EVENT_COLUMN_EVERYTHING_CHANGED, this.onRowGroupChanged.bind(this));
	        this.onRowGroupChanged();
	    };
	    GridHeaderDropZones.prototype.createNorthPanel = function () {
	        var _this = this;
	        var topPanelGui = document.createElement('div');
	        var dropPanelVisibleListener = this.onDropPanelVisible.bind(this);
	        this.rowGroupComp = new rowGroupDropZonePanel_1.RowGroupDropZonePanel(true);
	        this.getContext().wireBean(this.rowGroupComp);
	        this.addDestroyFunc(function () { return _this.rowGroupComp.destroy(); });
	        this.pivotComp = new pivotDropZonePanel_1.PivotDropZonePanel(true);
	        this.getContext().wireBean(this.pivotComp);
	        this.addDestroyFunc(function () { return _this.pivotComp.destroy(); });
	        topPanelGui.appendChild(this.rowGroupComp.getGui());
	        topPanelGui.appendChild(this.pivotComp.getGui());
	        this.rowGroupComp.addEventListener(main_1.Component.EVENT_DISPLAYED_CHANGED, dropPanelVisibleListener);
	        this.pivotComp.addEventListener(main_1.Component.EVENT_DISPLAYED_CHANGED, dropPanelVisibleListener);
	        this.addDestroyFunc(function () {
	            _this.rowGroupComp.removeEventListener(main_1.Component.EVENT_DISPLAYED_CHANGED, dropPanelVisibleListener);
	            _this.pivotComp.removeEventListener(main_1.Component.EVENT_DISPLAYED_CHANGED, dropPanelVisibleListener);
	        });
	        this.onDropPanelVisible();
	        return topPanelGui;
	    };
	    GridHeaderDropZones.prototype.onDropPanelVisible = function () {
	        var bothDisplayed = this.rowGroupComp.isDisplayed() && this.pivotComp.isDisplayed();
	        this.rowGroupComp.addOrRemoveCssClass('ag-width-half', bothDisplayed);
	        this.pivotComp.addOrRemoveCssClass('ag-width-half', bothDisplayed);
	    };
	    GridHeaderDropZones.prototype.onRowGroupChanged = function () {
	        if (!this.rowGroupComp) {
	            return;
	        }
	        var rowGroupPanelShow = this.gridOptionsWrapper.getRowGroupPanelShow();
	        if (rowGroupPanelShow === main_1.Constants.ALWAYS) {
	            this.rowGroupComp.setDisplayed(true);
	        }
	        else if (rowGroupPanelShow === main_1.Constants.ONLY_WHEN_GROUPING) {
	            var grouping = !this.columnController.isRowGroupEmpty();
	            this.rowGroupComp.setDisplayed(grouping);
	        }
	        else {
	            this.rowGroupComp.setDisplayed(false);
	        }
	    };
	    __decorate([
	        main_1.Autowired('gridOptionsWrapper'),
	        __metadata("design:type", main_1.GridOptionsWrapper)
	    ], GridHeaderDropZones.prototype, "gridOptionsWrapper", void 0);
	    __decorate([
	        main_1.Autowired('columnController'),
	        __metadata("design:type", main_1.ColumnController)
	    ], GridHeaderDropZones.prototype, "columnController", void 0);
	    __decorate([
	        main_1.Autowired('eventService'),
	        __metadata("design:type", main_1.EventService)
	    ], GridHeaderDropZones.prototype, "eventService", void 0);
	    __decorate([
	        main_1.PostConstruct,
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", []),
	        __metadata("design:returntype", void 0)
	    ], GridHeaderDropZones.prototype, "postConstruct", null);
	    return GridHeaderDropZones;
	}(main_1.Component));
	exports.GridHeaderDropZones = GridHeaderDropZones;


/***/ }),
/* 2615 */
/***/ (function(module, exports, __webpack_require__) {

	// ag-grid-enterprise v21.2.2
	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var ag_grid_community_1 = __webpack_require__(2322);
	var licenseManager_1 = __webpack_require__(2530);
	var WatermarkComp = /** @class */ (function (_super) {
	    __extends(WatermarkComp, _super);
	    function WatermarkComp() {
	        return _super.call(this, "<div class=\"ag-watermark\">\n                    <div ref=\"eLicenseTextRef\" class=\"ag-watermark-text\"></div>\n               </div>") || this;
	    }
	    WatermarkComp.prototype.postContruct = function () {
	        var _this = this;
	        var show = this.shouldDisplayWatermark();
	        ag_grid_community_1._.addOrRemoveCssClass(this.getGui(), 'ag-hidden', !show);
	        if (show) {
	            this.eLicenseTextRef.innerText = this.licenseManager.getWatermarkMessage();
	            window.setTimeout(function () {
	                _this.addCssClass('ag-opacity-zero');
	            }, 0);
	            window.setTimeout(function () {
	                _this.addCssClass('ag-hidden');
	            }, 5000);
	        }
	    };
	    WatermarkComp.prototype.shouldDisplayWatermark = function () {
	        var isDisplayWatermark = this.licenseManager.isDisplayWatermark();
	        var isWhiteListURL = location.hostname.match('^127\.0\.0\.1|localhost|www\.ag-grid\.com$') != null;
	        var isForceWatermark = location.search.indexOf('forceWatermark') !== -1;
	        return isForceWatermark || (isDisplayWatermark && !isWhiteListURL);
	    };
	    __decorate([
	        ag_grid_community_1.Autowired('licenseManager'),
	        __metadata("design:type", licenseManager_1.LicenseManager)
	    ], WatermarkComp.prototype, "licenseManager", void 0);
	    __decorate([
	        ag_grid_community_1.RefSelector('eLicenseTextRef'),
	        __metadata("design:type", HTMLElement)
	    ], WatermarkComp.prototype, "eLicenseTextRef", void 0);
	    __decorate([
	        ag_grid_community_1.PostConstruct,
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", []),
	        __metadata("design:returntype", void 0)
	    ], WatermarkComp.prototype, "postContruct", null);
	    return WatermarkComp;
	}(ag_grid_community_1.Component));
	exports.WatermarkComp = WatermarkComp;


/***/ }),
/* 2616 */
/***/ (function(module, exports, __webpack_require__) {

	// ag-grid-enterprise v21.2.2
	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __assign = (this && this.__assign) || function () {
	    __assign = Object.assign || function(t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	                t[p] = s[p];
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var ag_grid_community_1 = __webpack_require__(2322);
	var abstractSelectionHandle_1 = __webpack_require__(2617);
	var FillHandle = /** @class */ (function (_super) {
	    __extends(FillHandle, _super);
	    function FillHandle() {
	        var _this = _super.call(this, FillHandle.TEMPLATE) || this;
	        _this.markedCellComps = [];
	        _this.cellValues = [];
	        _this.isUp = false;
	        _this.isLeft = false;
	        _this.isReduce = false;
	        _this.type = 'fill';
	        return _this;
	    }
	    FillHandle.prototype.onDrag = function (e) {
	        if (!this.initialXY) {
	            var _a = this.getGui().getBoundingClientRect(), x_1 = _a.x, y_1 = _a.y;
	            this.initialXY = { x: x_1, y: y_1 };
	        }
	        var _b = this.initialXY, x = _b.x, y = _b.y;
	        var diffX = Math.abs(x - e.clientX);
	        var diffY = Math.abs(y - e.clientY);
	        var direction = diffX > diffY ? 'x' : 'y';
	        if (direction !== this.dragAxis) {
	            this.dragAxis = direction;
	        }
	        if (!this.initialPosition) {
	            var cellComp = this.getCellComp();
	            if (!cellComp) {
	                return;
	            }
	            this.initialPosition = cellComp.getCellPosition();
	        }
	        var lastCellHovered = this.getLastCellHovered();
	        if (lastCellHovered && lastCellHovered !== this.lastCellMarked) {
	            this.lastCellMarked = lastCellHovered;
	            this.markPathFrom(this.initialPosition, lastCellHovered);
	        }
	    };
	    FillHandle.prototype.onDragEnd = function (e) {
	        if (!this.markedCellComps.length) {
	            return;
	        }
	        var isX = this.dragAxis === 'x';
	        var initialRange = this.getCellRange();
	        var colLen = initialRange.columns.length;
	        var rangeStartRow = this.getRangeStartRow();
	        var rangeEndRow = this.getRangeEndRow();
	        var finalRange;
	        if (!this.isUp && !this.isLeft) {
	            finalRange = this.rangeController.createCellRangeFromCellRangeParams({
	                rowStartIndex: rangeStartRow.rowIndex,
	                rowStartPinned: rangeStartRow.rowPinned,
	                columnStart: initialRange.columns[0],
	                rowEndIndex: isX ? rangeEndRow.rowIndex : this.lastCellMarked.rowIndex,
	                rowEndPinned: isX ? rangeEndRow.rowPinned : this.lastCellMarked.rowPinned,
	                columnEnd: isX ? this.lastCellMarked.column : initialRange.columns[colLen - 1]
	            });
	        }
	        else {
	            var startRow = isX ? rangeStartRow : this.lastCellMarked;
	            finalRange = this.rangeController.createCellRangeFromCellRangeParams({
	                rowStartIndex: startRow.rowIndex,
	                rowStartPinned: startRow.rowPinned,
	                columnStart: isX ? this.lastCellMarked.column : initialRange.columns[0],
	                rowEndIndex: rangeEndRow.rowIndex,
	                rowEndPinned: rangeEndRow.rowPinned,
	                columnEnd: initialRange.columns[colLen - 1]
	            });
	        }
	        if (finalRange) {
	            this.handleValueChanged(initialRange, finalRange, e.altKey);
	            this.rangeController.setCellRanges([finalRange]);
	        }
	    };
	    FillHandle.prototype.handleValueChanged = function (initialRange, finalRange, altKey) {
	        var _this = this;
	        var initialRangeEndRow = this.rangeController.getRangeEndRow(initialRange);
	        var initialRangeStartRow = this.rangeController.getRangeStartRow(initialRange);
	        var finalRangeEndRow = this.rangeController.getRangeEndRow(finalRange);
	        var finalRangeStartRow = this.rangeController.getRangeStartRow(finalRange);
	        var isVertical = this.dragAxis === 'y';
	        // if the range is being reduced in size, all we need to do is
	        // clear the cells that are no longer part of the range
	        if (this.isReduce) {
	            var columns = isVertical
	                ? initialRange.columns
	                : initialRange.columns.filter(function (col) { return finalRange.columns.indexOf(col) < 0; });
	            var startRow = isVertical ? this.cellNavigationService.getRowBelow(finalRangeEndRow) : finalRangeStartRow;
	            if (startRow) {
	                this.clearCellsInRange(startRow, initialRangeEndRow, columns);
	            }
	            return;
	        }
	        var withinInitialRange = true;
	        var values = [];
	        var resetValues = function () {
	            values.length = 0;
	        };
	        var iterateAcrossCells = function (column, columns) {
	            var currentRow = _this.isUp ? initialRangeEndRow : initialRangeStartRow;
	            var finished = false;
	            if (isVertical) {
	                withinInitialRange = true;
	                resetValues();
	            }
	            var _loop_1 = function () {
	                var rowNode = _this.rowPositionUtils.getRowNode(currentRow);
	                if (!rowNode) {
	                    return "break";
	                }
	                if (isVertical && column) {
	                    fillValues(values, column, rowNode, function () {
	                        return !_this.rowPositionUtils.sameRow(currentRow, _this.isUp ? initialRangeStartRow : initialRangeEndRow);
	                    });
	                }
	                else if (columns) {
	                    withinInitialRange = true;
	                    resetValues();
	                    ag_grid_community_1._.forEach(columns, (function (col) { return fillValues(values, col, rowNode, function () {
	                        return _this.isLeft ? col !== initialRange.columns[0] : col !== ag_grid_community_1._.last(initialRange.columns);
	                    }); }));
	                }
	                finished = _this.rowPositionUtils.sameRow(currentRow, _this.isUp ? finalRangeStartRow : finalRangeEndRow);
	                currentRow = _this.isUp
	                    ? _this.cellNavigationService.getRowAbove(currentRow)
	                    : _this.cellNavigationService.getRowBelow(currentRow);
	            };
	            while (!finished && currentRow) {
	                var state_1 = _loop_1();
	                if (state_1 === "break")
	                    break;
	            }
	        };
	        var fillValues = function (values, col, rowNode, updateInitialSet) {
	            var currentValue;
	            if (withinInitialRange) {
	                currentValue = _this.valueService.getValue(col, rowNode);
	                withinInitialRange = updateInitialSet();
	            }
	            else {
	                currentValue = _this.processValues(values, altKey);
	                _this.valueService.setValue(rowNode, col, currentValue);
	            }
	            values.push(currentValue);
	        };
	        if (isVertical) {
	            initialRange.columns.forEach(function (col) {
	                iterateAcrossCells(col);
	            });
	        }
	        else {
	            var columns = this.isLeft ? finalRange.columns.slice().reverse() : finalRange.columns;
	            iterateAcrossCells(undefined, columns);
	        }
	    };
	    FillHandle.prototype.clearCellsInRange = function (startRow, endRow, columns) {
	        var _this = this;
	        var currentRow = startRow;
	        var finished = false;
	        var _loop_2 = function () {
	            var rowNode = this_1.rowPositionUtils.getRowNode(currentRow);
	            // should never happen, defensive programming
	            if (!rowNode) {
	                return "break";
	            }
	            columns.forEach(function (col) {
	                _this.valueService.setValue(rowNode, col, null);
	            });
	            finished = this_1.rowPositionUtils.sameRow(currentRow, endRow);
	            currentRow = this_1.cellNavigationService.getRowBelow(currentRow);
	        };
	        var this_1 = this;
	        while (!finished && currentRow) {
	            var state_2 = _loop_2();
	            if (state_2 === "break")
	                break;
	        }
	    };
	    FillHandle.prototype.processValues = function (values, altKey) {
	        return 10;
	    };
	    FillHandle.prototype.clearValues = function () {
	        this.clearMarkedPath();
	        this.clearCellValues();
	        this.lastCellMarked = undefined;
	        _super.prototype.clearValues.call(this);
	    };
	    FillHandle.prototype.clearMarkedPath = function () {
	        this.markedCellComps.forEach(function (cellComp) {
	            var eGui = cellComp.getGui();
	            ag_grid_community_1._.removeCssClass(eGui, 'ag-selection-fill-top');
	            ag_grid_community_1._.removeCssClass(eGui, 'ag-selection-fill-right');
	            ag_grid_community_1._.removeCssClass(eGui, 'ag-selection-fill-bottom');
	            ag_grid_community_1._.removeCssClass(eGui, 'ag-selection-fill-left');
	        });
	        this.markedCellComps.length = 0;
	        this.isUp = false;
	        this.isLeft = false;
	        this.isReduce = false;
	    };
	    FillHandle.prototype.clearCellValues = function () {
	        this.cellValues.length = 0;
	    };
	    FillHandle.prototype.markPathFrom = function (initialPosition, currentPosition) {
	        this.clearMarkedPath();
	        this.clearCellValues();
	        if (this.dragAxis === 'y') {
	            if (this.rowPositionUtils.sameRow(currentPosition, initialPosition)) {
	                return;
	            }
	            var isBefore = this.rowPositionUtils.before(currentPosition, initialPosition);
	            var rangeStartRow = this.getRangeStartRow();
	            var rangeEndRow = this.getRangeEndRow();
	            if (isBefore && ((currentPosition.rowPinned == rangeStartRow.rowPinned &&
	                currentPosition.rowIndex >= rangeStartRow.rowIndex) ||
	                (rangeStartRow.rowPinned != rangeEndRow.rowPinned &&
	                    currentPosition.rowPinned == rangeEndRow.rowPinned &&
	                    currentPosition.rowIndex <= rangeEndRow.rowIndex))) {
	                this.reduceVertical(initialPosition, currentPosition);
	                this.isReduce = true;
	            }
	            else {
	                this.extendVertical(initialPosition, currentPosition, isBefore);
	                this.isReduce = false;
	            }
	        }
	        else {
	            var initialColumn = initialPosition.column;
	            var currentColumn = currentPosition.column;
	            if (initialColumn === currentColumn) {
	                return;
	            }
	            var displayedColumns = this.columnController.getAllDisplayedColumns();
	            var initialIndex = displayedColumns.indexOf(initialColumn);
	            var currentIndex = displayedColumns.indexOf(currentColumn);
	            if (currentIndex <= initialIndex && currentIndex >= displayedColumns.indexOf(this.getCellRange().columns[0])) {
	                this.reduceHorizontal(initialPosition, currentPosition);
	                this.isReduce = true;
	            }
	            else {
	                this.extendHorizontal(initialPosition, currentPosition, currentIndex < initialIndex);
	                this.isReduce = false;
	            }
	        }
	    };
	    FillHandle.prototype.extendVertical = function (initialPosition, endPosition, isMovingUp) {
	        var _a = this, rowRenderer = _a.rowRenderer, rangeController = _a.rangeController;
	        var row = initialPosition;
	        do {
	            var cellRange = this.getCellRange();
	            var colLen = cellRange.columns.length;
	            for (var i = 0; i < colLen; i++) {
	                var column = cellRange.columns[i];
	                var rowPos = { rowIndex: row.rowIndex, rowPinned: row.rowPinned };
	                var cellPos = __assign({}, rowPos, { column: column });
	                var cellInRange = rangeController.isCellInSpecificRange(cellPos, cellRange);
	                var isInitialRow = this.rowPositionUtils.sameRow(row, initialPosition);
	                if (isMovingUp) {
	                    this.isUp = true;
	                }
	                if (!isInitialRow) {
	                    var cellComp = rowRenderer.getComponentForCell(cellPos);
	                    if (cellComp) {
	                        this.markedCellComps.push(cellComp);
	                        var eGui = cellComp.getGui();
	                        if (!cellInRange) {
	                            ag_grid_community_1._.addOrRemoveCssClass(eGui, 'ag-selection-fill-left', i === 0);
	                            ag_grid_community_1._.addOrRemoveCssClass(eGui, 'ag-selection-fill-right', i === colLen - 1);
	                        }
	                        ag_grid_community_1._.addOrRemoveCssClass(eGui, isMovingUp ? 'ag-selection-fill-top' : 'ag-selection-fill-bottom', this.rowPositionUtils.sameRow(row, endPosition));
	                    }
	                }
	            }
	            if (this.rowPositionUtils.sameRow(row, endPosition)) {
	                break;
	            }
	        } while (row = isMovingUp ?
	            this.cellNavigationService.getRowAbove(row) :
	            this.cellNavigationService.getRowBelow(row));
	    };
	    FillHandle.prototype.reduceVertical = function (initialPosition, endPosition) {
	        var row = initialPosition;
	        do {
	            var cellRange = this.getCellRange();
	            var colLen = cellRange.columns.length;
	            var isLastRow = this.rowPositionUtils.sameRow(row, endPosition);
	            for (var i = 0; i < colLen; i++) {
	                var rowPos = { rowIndex: row.rowIndex, rowPinned: row.rowPinned };
	                var celPos = __assign({}, rowPos, { column: cellRange.columns[i] });
	                var cellComp = this.rowRenderer.getComponentForCell(celPos);
	                if (cellComp) {
	                    this.markedCellComps.push(cellComp);
	                    var eGui = cellComp.getGui();
	                    ag_grid_community_1._.addOrRemoveCssClass(eGui, 'ag-selection-fill-bottom', this.rowPositionUtils.sameRow(row, endPosition));
	                }
	            }
	            if (isLastRow) {
	                break;
	            }
	        } while (row = this.cellNavigationService.getRowAbove(row));
	    };
	    FillHandle.prototype.extendHorizontal = function (initialPosition, endPosition, isMovingLeft) {
	        var _this = this;
	        var allCols = this.columnController.getAllDisplayedColumns();
	        var startCol = allCols.indexOf(isMovingLeft ? endPosition.column : initialPosition.column);
	        var endCol = allCols.indexOf(isMovingLeft ? this.getCellRange().columns[0] : endPosition.column);
	        var offset = isMovingLeft ? 0 : 1;
	        var colsToMark = allCols.slice(startCol + offset, endCol + offset);
	        var rangeStartRow = this.getRangeStartRow();
	        var rangeEndRow = this.getRangeEndRow();
	        colsToMark.forEach(function (column) {
	            var row = rangeStartRow;
	            var isLastRow = false;
	            do {
	                isLastRow = _this.rowPositionUtils.sameRow(row, rangeEndRow);
	                var cellComp = _this.rowRenderer.getComponentForCell({
	                    rowIndex: row.rowIndex,
	                    rowPinned: row.rowPinned,
	                    column: column
	                });
	                if (cellComp) {
	                    _this.markedCellComps.push(cellComp);
	                    var eGui = cellComp.getGui();
	                    ag_grid_community_1._.addOrRemoveCssClass(eGui, 'ag-selection-fill-top', _this.rowPositionUtils.sameRow(row, rangeStartRow));
	                    ag_grid_community_1._.addOrRemoveCssClass(eGui, 'ag-selection-fill-bottom', _this.rowPositionUtils.sameRow(row, rangeEndRow));
	                    if (isMovingLeft) {
	                        _this.isLeft = true;
	                        ag_grid_community_1._.addOrRemoveCssClass(eGui, 'ag-selection-fill-left', column === colsToMark[0]);
	                    }
	                    else {
	                        ag_grid_community_1._.addOrRemoveCssClass(eGui, 'ag-selection-fill-right', column === ag_grid_community_1._.last(colsToMark));
	                    }
	                }
	                row = _this.cellNavigationService.getRowBelow(row);
	            } while (!isLastRow);
	        });
	    };
	    FillHandle.prototype.reduceHorizontal = function (initialPosition, endPosition) {
	        var _this = this;
	        var allCols = this.columnController.getAllDisplayedColumns();
	        var startCol = allCols.indexOf(endPosition.column);
	        var endCol = allCols.indexOf(initialPosition.column);
	        var colsToMark = allCols.slice(startCol, endCol);
	        var rangeStartRow = this.getRangeStartRow();
	        var rangeEndRow = this.getRangeEndRow();
	        colsToMark.forEach(function (column) {
	            var row = rangeStartRow;
	            var isLastRow = false;
	            do {
	                isLastRow = _this.rowPositionUtils.sameRow(row, rangeEndRow);
	                var cellComp = _this.rowRenderer.getComponentForCell({
	                    rowIndex: row.rowIndex,
	                    rowPinned: row.rowPinned,
	                    column: column
	                });
	                if (cellComp) {
	                    _this.markedCellComps.push(cellComp);
	                    var eGui = cellComp.getGui();
	                    ag_grid_community_1._.addOrRemoveCssClass(eGui, 'ag-selection-fill-right', column === colsToMark[0]);
	                }
	                row = _this.cellNavigationService.getRowBelow(row);
	            } while (!isLastRow);
	        });
	    };
	    FillHandle.prototype.refresh = function (cellComp) {
	        var cellRange = this.rangeController.getCellRanges()[0];
	        var isColumnRange = !cellRange.startRow || !cellRange.endRow;
	        if (isColumnRange) {
	            this.destroy();
	            return;
	        }
	        _super.prototype.refresh.call(this, cellComp);
	    };
	    FillHandle.TEMPLATE = '<div class="ag-fill-handle"></div>';
	    __decorate([
	        ag_grid_community_1.Autowired('valueService'),
	        __metadata("design:type", ag_grid_community_1.ValueService)
	    ], FillHandle.prototype, "valueService", void 0);
	    return FillHandle;
	}(abstractSelectionHandle_1.AbstractSelectionHandle));
	exports.FillHandle = FillHandle;


/***/ }),
/* 2617 */
/***/ (function(module, exports, __webpack_require__) {

	// ag-grid-enterprise v21.2.2
	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var ag_grid_community_1 = __webpack_require__(2322);
	var rangeController_1 = __webpack_require__(2512);
	var AbstractSelectionHandle = /** @class */ (function (_super) {
	    __extends(AbstractSelectionHandle, _super);
	    function AbstractSelectionHandle() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.changedCell = false;
	        _this.dragging = false;
	        _this.shouldDestroyOnEndDragging = false;
	        return _this;
	    }
	    AbstractSelectionHandle.prototype.init = function () {
	        var _this = this;
	        this.dragService.addDragSource({
	            dragStartPixels: 0,
	            eElement: this.getGui(),
	            onDragStart: this.onDragStart.bind(this),
	            onDragging: function (e) {
	                _this.dragging = true;
	                _this.rangeController.autoScrollService.check(e);
	                if (_this.changedCell) {
	                    _this.onDrag(e);
	                }
	            },
	            onDragStop: function (e) {
	                _this.dragging = false;
	                _this.onDragEnd(e);
	                _this.clearValues();
	                _this.rangeController.autoScrollService.ensureCleared();
	                ag_grid_community_1._.removeCssClass(document.body, "ag-dragging-" + _this.type + "-handle");
	                if (_this.shouldDestroyOnEndDragging) {
	                    _this.destroy();
	                }
	            }
	        });
	        this.addDestroyableEventListener(this.getGui(), 'mousedown', this.preventRangeExtension.bind(this));
	    };
	    AbstractSelectionHandle.prototype.isDragging = function () {
	        return this.dragging;
	    };
	    AbstractSelectionHandle.prototype.getCellComp = function () {
	        return this.cellComp;
	    };
	    AbstractSelectionHandle.prototype.setCellComp = function (cellComp) {
	        this.cellComp = cellComp;
	    };
	    AbstractSelectionHandle.prototype.getCellRange = function () {
	        return this.cellRange;
	    };
	    AbstractSelectionHandle.prototype.setCellRange = function (range) {
	        this.cellRange = range;
	    };
	    AbstractSelectionHandle.prototype.getRangeStartRow = function () {
	        return this.rangeStartRow;
	    };
	    AbstractSelectionHandle.prototype.setRangeStartRow = function (row) {
	        this.rangeStartRow = row;
	    };
	    AbstractSelectionHandle.prototype.getRangeEndRow = function () {
	        return this.rangeEndRow;
	    };
	    AbstractSelectionHandle.prototype.setRangeEndRow = function (row) {
	        this.rangeEndRow = row;
	    };
	    AbstractSelectionHandle.prototype.getLastCellHovered = function () {
	        return this.lastCellHovered;
	    };
	    AbstractSelectionHandle.prototype.preventRangeExtension = function (e) {
	        e.preventDefault();
	        e.stopPropagation();
	    };
	    AbstractSelectionHandle.prototype.onDragStart = function (e) {
	        this.cellHoverListener = this.addDestroyableEventListener(this.rowRenderer.getGridCore().getRootGui(), 'mousemove', this.updateLastCellPositionHovered.bind(this));
	        ag_grid_community_1._.addCssClass(document.body, "ag-dragging-" + this.type + "-handle");
	    };
	    AbstractSelectionHandle.prototype.updateLastCellPositionHovered = function (e) {
	        var cell = this.mouseEventService.getCellPositionForEvent(e);
	        if (cell === this.lastCellHovered) {
	            this.changedCell = false;
	            return;
	        }
	        this.lastCellHovered = cell;
	        this.changedCell = true;
	    };
	    AbstractSelectionHandle.prototype.getType = function () {
	        return this.type;
	    };
	    AbstractSelectionHandle.prototype.refresh = function (cellComp) {
	        var _this = this;
	        var oldCellComp = this.getCellComp();
	        var eGui = this.getGui();
	        var cellRange = ag_grid_community_1._.last(this.rangeController.getCellRanges());
	        var start = cellRange.startRow;
	        var end = cellRange.endRow;
	        if (start && end) {
	            var isBefore = this.rowPositionUtils.before(end, start);
	            if (isBefore) {
	                this.setRangeStartRow(end);
	                this.setRangeEndRow(start);
	            }
	            else {
	                this.setRangeStartRow(start);
	                this.setRangeEndRow(end);
	            }
	        }
	        if (oldCellComp !== cellComp) {
	            this.setCellComp(cellComp);
	            window.setTimeout(function () {
	                if (_this.isAlive()) {
	                    cellComp.appendChild(eGui);
	                }
	            }, 1);
	        }
	        this.setCellRange(cellRange);
	    };
	    AbstractSelectionHandle.prototype.clearValues = function () {
	        this.lastCellHovered = undefined;
	        this.removeListeners();
	    };
	    AbstractSelectionHandle.prototype.removeListeners = function () {
	        if (this.cellHoverListener) {
	            this.cellHoverListener();
	            this.cellHoverListener = undefined;
	        }
	    };
	    AbstractSelectionHandle.prototype.destroy = function () {
	        if (!this.shouldDestroyOnEndDragging && this.isDragging()) {
	            ag_grid_community_1._.setDisplayed(this.getGui(), false);
	            this.shouldDestroyOnEndDragging = true;
	            return;
	        }
	        this.shouldDestroyOnEndDragging = false;
	        _super.prototype.destroy.call(this);
	        this.removeListeners();
	        var eGui = this.getGui();
	        if (eGui.parentElement) {
	            eGui.parentElement.removeChild(eGui);
	        }
	    };
	    __decorate([
	        ag_grid_community_1.Autowired("rowRenderer"),
	        __metadata("design:type", ag_grid_community_1.RowRenderer)
	    ], AbstractSelectionHandle.prototype, "rowRenderer", void 0);
	    __decorate([
	        ag_grid_community_1.Autowired("dragService"),
	        __metadata("design:type", ag_grid_community_1.DragService)
	    ], AbstractSelectionHandle.prototype, "dragService", void 0);
	    __decorate([
	        ag_grid_community_1.Autowired("rangeController"),
	        __metadata("design:type", rangeController_1.RangeController)
	    ], AbstractSelectionHandle.prototype, "rangeController", void 0);
	    __decorate([
	        ag_grid_community_1.Autowired("mouseEventService"),
	        __metadata("design:type", ag_grid_community_1.MouseEventService)
	    ], AbstractSelectionHandle.prototype, "mouseEventService", void 0);
	    __decorate([
	        ag_grid_community_1.Autowired("columnController"),
	        __metadata("design:type", ag_grid_community_1.ColumnController)
	    ], AbstractSelectionHandle.prototype, "columnController", void 0);
	    __decorate([
	        ag_grid_community_1.Autowired("cellNavigationService"),
	        __metadata("design:type", ag_grid_community_1.CellNavigationService)
	    ], AbstractSelectionHandle.prototype, "cellNavigationService", void 0);
	    __decorate([
	        ag_grid_community_1.Autowired('rowPositionUtils'),
	        __metadata("design:type", ag_grid_community_1.RowPositionUtils)
	    ], AbstractSelectionHandle.prototype, "rowPositionUtils", void 0);
	    __decorate([
	        ag_grid_community_1.PostConstruct,
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", []),
	        __metadata("design:returntype", void 0)
	    ], AbstractSelectionHandle.prototype, "init", null);
	    return AbstractSelectionHandle;
	}(ag_grid_community_1.Component));
	exports.AbstractSelectionHandle = AbstractSelectionHandle;


/***/ }),
/* 2618 */
/***/ (function(module, exports, __webpack_require__) {

	// ag-grid-enterprise v21.2.2
	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __assign = (this && this.__assign) || function () {
	    __assign = Object.assign || function(t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	                t[p] = s[p];
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var ag_grid_community_1 = __webpack_require__(2322);
	var abstractSelectionHandle_1 = __webpack_require__(2617);
	var RangeHandle = /** @class */ (function (_super) {
	    __extends(RangeHandle, _super);
	    function RangeHandle() {
	        var _this = _super.call(this, RangeHandle.TEMPLATE) || this;
	        _this.type = 'range';
	        _this.rangeFixed = false;
	        return _this;
	    }
	    RangeHandle.prototype.onDrag = function (e) {
	        var lastCellHovered = this.getLastCellHovered();
	        if (!lastCellHovered) {
	            return;
	        }
	        var cellRanges = this.rangeController.getCellRanges();
	        var lastRange = ag_grid_community_1._.last(cellRanges);
	        if (!this.rangeFixed) {
	            this.fixRangeStartEnd(lastRange);
	            this.rangeFixed = true;
	        }
	        var newEndRow = {
	            rowIndex: lastCellHovered.rowIndex,
	            rowPinned: lastCellHovered.rowPinned,
	        };
	        var rowChanged = !this.rowPositionUtils.sameRow(newEndRow, this.rangeController.getRangeEndRow(lastRange));
	        if (cellRanges.length === 2 && rowChanged) {
	            this.rangeController.updateRangeEnd({
	                cellRange: cellRanges[0],
	                cellPosition: __assign({}, newEndRow, { column: cellRanges[0].columns[0] })
	            });
	        }
	        this.endPosition = __assign({}, newEndRow, { column: lastCellHovered.column });
	        this.rangeController.extendLatestRangeToCell(this.endPosition);
	    };
	    RangeHandle.prototype.onDragEnd = function (e) {
	        var cellRange = ag_grid_community_1._.last(this.rangeController.getCellRanges());
	        this.fixRangeStartEnd(cellRange);
	        this.rangeFixed = false;
	    };
	    RangeHandle.prototype.fixRangeStartEnd = function (cellRange) {
	        var startRow = this.rangeController.getRangeStartRow(cellRange);
	        var endRow = this.rangeController.getRangeEndRow(cellRange);
	        var column = cellRange.columns[0];
	        cellRange.startRow = startRow;
	        cellRange.endRow = endRow;
	        cellRange.startColumn = column;
	    };
	    RangeHandle.TEMPLATE = '<div class="ag-range-handle"></div>';
	    return RangeHandle;
	}(abstractSelectionHandle_1.AbstractSelectionHandle));
	exports.RangeHandle = RangeHandle;


/***/ }),
/* 2619 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _momentTimezone = __webpack_require__(1185);
	
	var _momentTimezone2 = _interopRequireDefault(_momentTimezone);
	
	var _connectToStores = __webpack_require__(1226);
	
	var _connectToStores2 = _interopRequireDefault(_connectToStores);
	
	var _EventBucketStore = __webpack_require__(1593);
	
	var _EventBucketStore2 = _interopRequireDefault(_EventBucketStore);
	
	var _EventBucketActions = __webpack_require__(1218);
	
	var _EventBucketActions2 = _interopRequireDefault(_EventBucketActions);
	
	var _AnalyticsStore = __webpack_require__(1861);
	
	var _AnalyticsStore2 = _interopRequireDefault(_AnalyticsStore);
	
	var _AnalyticsActions = __webpack_require__(1863);
	
	var _AnalyticsActions2 = _interopRequireDefault(_AnalyticsActions);
	
	var _analyticsHeader = __webpack_require__(2293);
	
	var _analyticsHeader2 = _interopRequireDefault(_analyticsHeader);
	
	var _workingIndicator = __webpack_require__(1664);
	
	var _workingIndicator2 = _interopRequireDefault(_workingIndicator);
	
	var _recurringPassAnalyticsTable = __webpack_require__(2620);
	
	var _recurringPassAnalyticsTable2 = _interopRequireDefault(_recurringPassAnalyticsTable);
	
	var _analyticsFilterWidget = __webpack_require__(2295);
	
	var _analyticsFilterWidget2 = _interopRequireDefault(_analyticsFilterWidget);
	
	var _statsBlockContainer = __webpack_require__(1740);
	
	var _statsBlockContainer2 = _interopRequireDefault(_statsBlockContainer);
	
	var _statsBlock = __webpack_require__(1741);
	
	var _statsBlock2 = _interopRequireDefault(_statsBlock);
	
	var _cloneDeep = __webpack_require__(1189);
	
	var _cloneDeep2 = _interopRequireDefault(_cloneDeep);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RecurringPassAnalytics = function (_React$Component) {
	  _inherits(RecurringPassAnalytics, _React$Component);
	
	  function RecurringPassAnalytics(props) {
	    _classCallCheck(this, RecurringPassAnalytics);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(RecurringPassAnalytics).call(this, props));
	
	    _this.state = {
	      allTime: false,
	      range: {
	        key: "selection",
	        startDate: (0, _momentTimezone2.default)().subtract(1, "month"),
	        endDate: (0, _momentTimezone2.default)()
	      },
	      isMembership: null,
	      filterState: "90 days" // default 90 days
	    };
	
	    _this.onWindowClick = _this.onWindowClick.bind(_this);
	    _this.onWindowKeyDown = _this.onWindowKeyDown.bind(_this);
	    _this.handleSegmentFilterChange = _this.handleSegmentFilterChange.bind(_this);
	    _this.setPage = _this.setPage.bind(_this);
	    _this.onMembershipPage = _this.onMembershipPage.bind(_this);
	    return _this;
	  }
	
	  _createClass(RecurringPassAnalytics, [{
	    key: "onWindowClick",
	    value: function onWindowClick(e) {
	      if (this.state.showRangeEditor && (!this.container || !this.container.contains(e.target) && !this.rangeButton.contains(e.target))) {
	        this.setState({ showRangeEditor: false });
	      }
	    }
	  }, {
	    key: "onWindowKeyDown",
	    value: function onWindowKeyDown(e) {
	      if (this.state.showRangeEditor && e.which === 27) {
	        // esc
	        this.setState({ showRangeEditor: false });
	      }
	    }
	  }, {
	    key: "onMembershipPage",
	    value: function onMembershipPage() {
	      return this.props.location.pathname.includes("membership");
	      // return this.props.route.name;
	    }
	
	    // Set the state of the page to reflect if we are on a 
	    // pass page or a membership page.
	
	  }, {
	    key: "setPage",
	    value: function () {
	      var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
	        return regeneratorRuntime.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                // reset date range filter when changing between pass and membership
	                this.setState({ filterState: "90 days" });
	
	                if (!this.onMembershipPage()) {
	                  _context.next = 7;
	                  break;
	                }
	
	                _context.next = 4;
	                return this.setState({ isMembership: true });
	
	              case 4:
	                this.componentWillReceiveProps(this.props, "all");
	                _context.next = 10;
	                break;
	
	              case 7:
	                _context.next = 9;
	                return this.setState({ isMembership: false });
	
	              case 9:
	                this.componentWillReceiveProps(this.props, "all");
	
	              case 10:
	              case "end":
	                return _context.stop();
	            }
	          }
	        }, _callee, this);
	      }));
	
	      function setPage() {
	        return _ref.apply(this, arguments);
	      }
	
	      return setPage;
	    }()
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.setPage(); // set state to reflect pass vs. membership
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps) {
	      if (this.props.location !== prevProps.location) {
	        this.setPage(); // set state to reflect pass vs. membership
	      }
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(newProps) {
	      var force = arguments.length <= 1 || arguments[1] === undefined ? null : arguments[1];
	
	      if (force === "all" || newProps.params.eventBucketId !== this.props.params.eventBucketId) {
	        var eventBucketId = newProps.params.eventBucketId;
	
	        // Break string into number and units of time
	        var rangeArray = this.state.filterState.split(" ");
	        var rangeAmount = Number(rangeArray[0]);
	        var rangePeriod = rangeArray[1];
	
	        _AnalyticsActions2.default.fetchRecurringPassAnalytics.defer({ // future
	          eventBucketId: eventBucketId,
	          isMembership: this.state.isMembership,
	          startDate: JSON.stringify((0, _momentTimezone2.default)()),
	          endDate: JSON.stringify((0, _momentTimezone2.default)().add(rangeAmount, rangePeriod)),
	          allTime: this.state.allTime
	        });
	        _AnalyticsActions2.default.fetchExpiredPassAnalytics.defer({ // past
	          eventBucketId: eventBucketId,
	          isMembership: this.state.isMembership,
	          startDate: JSON.stringify((0, _momentTimezone2.default)().subtract(rangeAmount, rangePeriod)),
	          endDate: JSON.stringify((0, _momentTimezone2.default)()),
	          allTime: this.state.allTime
	        });
	        _AnalyticsActions2.default.fetchNewSubscriptionAnalytics.defer({ // past
	          eventBucketId: eventBucketId,
	          isMembership: this.state.isMembership,
	          startDate: JSON.stringify((0, _momentTimezone2.default)().subtract(rangeAmount, rangePeriod)),
	          endDate: JSON.stringify((0, _momentTimezone2.default)()),
	          allTime: this.state.allTime
	        });
	        _AnalyticsActions2.default.fetchRecurringPassOverview.defer({ // past
	          eventBucketId: eventBucketId,
	          isMembership: this.state.isMembership,
	          startDate: JSON.stringify((0, _momentTimezone2.default)().subtract(rangeAmount, rangePeriod)),
	          endDate: JSON.stringify((0, _momentTimezone2.default)()),
	          allTime: this.state.allTime
	        });
	
	        _EventBucketActions2.default.fetchOne.defer(newProps.params.eventBucketId);
	      }
	    }
	  }, {
	    key: "handleSegmentFilterChange",
	    value: function () {
	      var _ref2 = _asyncToGenerator(regeneratorRuntime.mark(function _callee2(props) {
	        var _this2 = this;
	
	        return regeneratorRuntime.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                this.setState({ filterState: props }, function () {
	                  return _this2.componentWillReceiveProps(_this2.props, "all");
	                });
	
	              case 1:
	              case "end":
	                return _context2.stop();
	            }
	          }
	        }, _callee2, this);
	      }));
	
	      function handleSegmentFilterChange(_x2) {
	        return _ref2.apply(this, arguments);
	      }
	
	      return handleSegmentFilterChange;
	    }()
	  }, {
	    key: "render",
	    value: function render() {
	      var eventBucketId = this.props.params.eventBucketId;
	
	      var eventBucket = this.props.getEventBucketById(eventBucketId);
	
	      var recurringPassAnalytics = this.props.getRecurringPassAnalytics(eventBucketId);
	      var expiredPassAnalytics = this.props.getExpiredPassAnalytics(eventBucketId);
	      var newSubscriptionAnalytics = this.props.getNewSubscriptionAnalytics(eventBucketId);
	      var recurringPassOverview = this.props.getRecurringPassOverview(eventBucketId);
	
	      var isMembership = this.props.location.pathname.includes("membership");
	      var defaultItemsPerPage = 25;
	
	      // Break string into number and units of time
	      var rangeArray = this.state.filterState.split(" ");
	      var rangeAmount = Number(rangeArray[0]);
	      var rangePeriod = rangeArray[1];
	
	      if (!(recurringPassAnalytics && expiredPassAnalytics && newSubscriptionAnalytics && recurringPassOverview) || !eventBucket) {
	        return _react2.default.createElement(_workingIndicator2.default, { fullPage: true });
	      }
	
	      // Flatten data
	      var processedRenewalData = [];
	      for (var y = 0; y < recurringPassAnalytics.data.length; y++) {
	        var thisPassSub = recurringPassAnalytics.data[y];
	        for (var z = 0; z < thisPassSub.passes.length; z++) {
	          var singlePassSub = (0, _cloneDeep2.default)(thisPassSub);
	          singlePassSub.pass = thisPassSub.passes[z];
	          processedRenewalData.push(singlePassSub);
	        }
	      }
	
	      var processedExpiredData = [];
	      for (var _y = 0; _y < expiredPassAnalytics.data.length; _y++) {
	        var _thisPassSub = expiredPassAnalytics.data[_y];
	        for (var _z = 0; _z < _thisPassSub.passes.length; _z++) {
	          var _singlePassSub = (0, _cloneDeep2.default)(_thisPassSub);
	          _singlePassSub.pass = _thisPassSub.passes[_z];
	          processedExpiredData.push(_singlePassSub);
	        }
	      }
	
	      var processedNewSubscriptionData = [];
	      for (var _y2 = 0; _y2 < newSubscriptionAnalytics.data.length; _y2++) {
	        var _thisPassSub2 = newSubscriptionAnalytics.data[_y2];
	        for (var _z2 = 0; _z2 < _thisPassSub2.passes.length; _z2++) {
	          var _singlePassSub2 = (0, _cloneDeep2.default)(_thisPassSub2);
	          _singlePassSub2.pass = _thisPassSub2.passes[_z2];
	          processedNewSubscriptionData.push(_singlePassSub2);
	        }
	      }
	
	      // Stat Blocks
	      var statsActive = recurringPassOverview.data.activePasses ? recurringPassOverview.data.activePasses : 0;
	      var statsNew = processedNewSubscriptionData.length;
	      var statsRenewals = processedRenewalData.filter(function (r) {
	        if ((0, _momentTimezone2.default)(r.renewal_date) >= (0, _momentTimezone2.default)() && (0, _momentTimezone2.default)(r.renewal_date) <= (0, _momentTimezone2.default)().add(rangeAmount, rangePeriod) && r.should_autorenew === true) {
	          return true;
	        }
	      }).length;
	
	      var statsExpiring = processedRenewalData.filter(function (r) {
	        if ((0, _momentTimezone2.default)(r.renewal_date) >= (0, _momentTimezone2.default)() && (0, _momentTimezone2.default)(r.renewal_date) <= (0, _momentTimezone2.default)().add(rangeAmount, rangePeriod) && r.should_autorenew === false) {
	          return true;
	        }
	      }).length;
	      var statsFailedRenewals = recurringPassOverview.data.failedRenewals ? recurringPassOverview.data.failedRenewals : 0;
	
	      var browserTimezone = _momentTimezone2.default.tz(_momentTimezone2.default.tz.guess()).format('z');
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(_analyticsHeader2.default, {
	          eventBucket: eventBucket,
	          allEventBuckets: this.props.getEventBuckets(),
	          label: isMembership ? "membership status analytics" : "recurring pass analytics",
	          subpath: "recurring_pass"
	        }),
	        _react2.default.createElement(_analyticsFilterWidget2.default, {
	          key: isMembership ? "membership" : "passes",
	          showSegmentFilter: true,
	          onSegmentFilterChange: this.handleSegmentFilterChange,
	          segmentFilterTitle: "Choose date range (" + browserTimezone + ")",
	          segmentFilterSelected: this.state.filterState,
	          segmentFilterConfig: [{
	            value: "14 days",
	            label: "14 Days"
	          }, {
	            value: "30 days",
	            label: "30 Days"
	          }, {
	            value: "60 days",
	            label: "60 Days"
	          }, {
	            value: "90 days",
	            label: "90 Days"
	          }, {
	            value: "1 year",
	            label: "1 year"
	          }, {
	            value: "2 years",
	            label: "2 years"
	          }, {
	            value: "3 years",
	            label: "3 years"
	          }]
	        }),
	        this.props.getIsFetchingRenewalAnalytics() || this.props.getIsFetchingExpiredPassAnalytics() || this.props.getIsFetchingNewSubscriptionAnalytics() || this.props.getIsFetchingRecurringPassOverview() ? _react2.default.createElement(
	          "div",
	          { style: { width: 100, height: 100, marginTop: 20 } },
	          _react2.default.createElement(_workingIndicator2.default, { fullPage: true })
	        ) : _react2.default.createElement(
	          "div",
	          { className: "analytics-element" },
	          _react2.default.createElement(
	            "div",
	            { className: "statbox-label" },
	            "in the past ",
	            this.state.filterState
	          ),
	          _react2.default.createElement(
	            _statsBlockContainer2.default,
	            null,
	            _react2.default.createElement(_statsBlock2.default, {
	              value: statsActive,
	              label: "Active " + (isMembership ? "Members" : "Passholders") + " as of today"
	            }),
	            _react2.default.createElement(_statsBlock2.default, {
	              value: statsNew,
	              label: "New " + (isMembership ? "Members" : "Passholders") + " in the past " + this.state.filterState
	            }),
	            _react2.default.createElement(_statsBlock2.default, {
	              value: statsRenewals,
	              label: (isMembership ? "membership" : "pass") + " Renewals in the next " + this.state.filterState
	            }),
	            _react2.default.createElement(_statsBlock2.default, {
	              value: statsExpiring,
	              label: (isMembership ? "membership" : "pass") + " Expiring in the next " + this.state.filterState
	            }),
	            _react2.default.createElement(_statsBlock2.default, {
	              value: statsFailedRenewals,
	              label: "Failed " + (isMembership ? "membership" : "pass") + " Renewals in the past " + this.state.filterState
	            })
	          )
	        ),
	        this.props.getIsFetchingRenewalAnalytics() ? _react2.default.createElement(
	          "div",
	          { style: { width: 100, height: 100, marginTop: 20 } },
	          _react2.default.createElement(_workingIndicator2.default, { fullPage: true })
	        ) : _react2.default.createElement(
	          "div",
	          { className: "analytics-element" },
	          _react2.default.createElement(
	            "h2",
	            null,
	            "Recurring ",
	            isMembership ? "memberships" : "passes",
	            " renewing or expiring in the next ",
	            this.state.filterState
	          ),
	          _react2.default.createElement(_recurringPassAnalyticsTable2.default, {
	            reportName: "Renewing or Expiring " + (isMembership ? "Memberships" : "Passes"),
	            eventBucket: eventBucket,
	            data: processedRenewalData,
	            includeAutorenew: true,
	            includeCardOnFile: true,
	            includeExpiredDate: false,
	            includeRenewalDate: true,
	            isMembership: isMembership,
	            itemsPerPage: defaultItemsPerPage
	          })
	        ),
	        this.props.getIsFetchingExpiredPassAnalytics() ? _react2.default.createElement(
	          "div",
	          { style: { width: 100, height: 100, marginTop: 20 } },
	          _react2.default.createElement(_workingIndicator2.default, null)
	        ) : _react2.default.createElement(
	          "div",
	          { className: "analytics-element" },
	          _react2.default.createElement(
	            "h2",
	            null,
	            "Expired ",
	            isMembership ? "memberships" : "passes",
	            " in the past ",
	            this.state.filterState
	          ),
	          _react2.default.createElement(_recurringPassAnalyticsTable2.default, {
	            reportName: "Expired " + (isMembership ? "Memberships" : "Passes"),
	            eventBucket: eventBucket,
	            data: processedExpiredData,
	            includeAutorenew: false,
	            includeCardOnFile: false,
	            includeExpiredDate: true,
	            includeRenewalDate: false,
	            isMembership: isMembership,
	            itemsPerPage: defaultItemsPerPage
	          })
	        ),
	        this.props.getIsFetchingNewSubscriptionAnalytics() ? _react2.default.createElement(
	          "div",
	          { style: { width: 100, height: 100, marginTop: 20 } },
	          _react2.default.createElement(_workingIndicator2.default, null)
	        ) : _react2.default.createElement(
	          "div",
	          { className: "analytics-element" },
	          _react2.default.createElement(
	            "h2",
	            null,
	            "New subscriptions in the past ",
	            this.state.filterState
	          ),
	          _react2.default.createElement(_recurringPassAnalyticsTable2.default, {
	            reportName: "New Subscriptions",
	            eventBucket: eventBucket,
	            data: processedNewSubscriptionData,
	            includeAutorenew: true,
	            includeCardOnFile: true,
	            includeExpiredDate: false,
	            includeRenewalDate: true,
	            isMembership: isMembership,
	            itemsPerPage: defaultItemsPerPage
	          })
	        )
	      );
	    }
	  }], [{
	    key: "getStores",
	    value: function getStores() {
	      return [_EventBucketStore2.default, _AnalyticsStore2.default];
	    }
	  }, {
	    key: "getPropsFromStores",
	    value: function getPropsFromStores() {
	      return {
	        getEventBuckets: _EventBucketStore2.default.getEventBuckets,
	        getEventBucketById: _EventBucketStore2.default.getEventBucketById,
	
	        getPassSalesAnalytics: _AnalyticsStore2.default.getPassSalesAnalytics,
	
	        // Note: getRecurringPassAnalytics collects recurring passes that are 
	        // renewing or expiring.
	        getRecurringPassAnalytics: _AnalyticsStore2.default.getRecurringPassAnalytics,
	        getExpiredPassAnalytics: _AnalyticsStore2.default.getExpiredPassAnalytics,
	        getNewSubscriptionAnalytics: _AnalyticsStore2.default.getNewSubscriptionAnalytics,
	
	        // Statbox info for Active Members and Failed Renewals
	        getRecurringPassOverview: _AnalyticsStore2.default.getRecurringPassOverview,
	
	        getIsFetchingRenewalAnalytics: _AnalyticsStore2.default.getIsFetchingRenewalAnalytics,
	        getIsFetchingExpiredPassAnalytics: _AnalyticsStore2.default.getIsFetchingExpiredPassAnalytics,
	        getIsFetchingNewSubscriptionAnalytics: _AnalyticsStore2.default.getIsFetchingNewSubscriptionAnalytics,
	        getIsFetchingRecurringPassOverview: _AnalyticsStore2.default.getIsFetchingRecurringPassOverview
	      };
	    }
	  }]);
	
	  return RecurringPassAnalytics;
	}(_react2.default.Component);
	
	RecurringPassAnalytics.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	exports.default = (0, _connectToStores2.default)(RecurringPassAnalytics);
	module.exports = exports["default"];

/***/ }),
/* 2620 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _moment = __webpack_require__(1021);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _reactRouter = __webpack_require__(486);
	
	var _reactable = __webpack_require__(1688);
	
	var _materialUi = __webpack_require__(576);
	
	var _inlineLinkIconButton = __webpack_require__(1704);
	
	var _inlineLinkIconButton2 = _interopRequireDefault(_inlineLinkIconButton);
	
	var _util = __webpack_require__(1183);
	
	var util = _interopRequireWildcard(_util);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RecurringPassAnalyticsTable = function (_React$Component) {
	  _inherits(RecurringPassAnalyticsTable, _React$Component);
	
	  function RecurringPassAnalyticsTable(props) {
	    _classCallCheck(this, RecurringPassAnalyticsTable);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(RecurringPassAnalyticsTable).call(this, props));
	
	    _this._makeRow = _this._makeRow.bind(_this);
	    return _this;
	  }
	
	  _createClass(RecurringPassAnalyticsTable, [{
	    key: "_makeRow",
	    value: function _makeRow(data) {
	      var _this2 = this;
	
	      var noWrapTdStyle = { whiteSpace: "nowrap" };
	      var autoRenew = data.should_autorenew ? "Y" : "N";
	      var renewalDate = (0, _moment2.default)(data.renewal_date).format("MM/DD/YYYY");
	      var expiredDate = (0, _moment2.default)(data.expired_date).format("MM/DD/YYYY");
	      var _props$isMembership = this.props.isMembership;
	      var isMembership = _props$isMembership === undefined ? false : _props$isMembership;
	
	
	      return _react2.default.createElement(
	        _reactable.Tr,
	        { key: data._id },
	        _react2.default.createElement(
	          _reactable.Td // 311 td.exports error
	          ,
	          { column: "Name", value: data.person.name, style: { width: 150 } },
	          _react2.default.createElement(
	            "div",
	            null,
	            data.pass.name,
	            _react2.default.createElement(_inlineLinkIconButton2.default, {
	              onTouchTap: function onTouchTap() {
	                _this2.context.router.push("/event_buckets/" + _this2.props.eventBucket.id + "/people/" + data.person._id + "?highlight_pass=" + data.pass._id);
	              },
	              tooltip: isMembership ? "View membership" : "View pass"
	            })
	          )
	        ),
	        _react2.default.createElement(
	          _reactable.Td,
	          { column: "Email", value: data.person.email, style: noWrapTdStyle },
	          data.person.email
	        ),
	        _react2.default.createElement(
	          _reactable.Td,
	          {
	            data: null,
	            column: "Phone Number",
	            value: data.person.phone_number,
	            style: noWrapTdStyle
	          },
	          data.person.phone_number ? data.person.phone_number : "n/a"
	        ),
	        _react2.default.createElement(
	          _reactable.Td,
	          { column: "Mailing Address", value: data.person.mailing_address },
	          data.person.mailing_address ? data.person.mailing_address : "n/a"
	        ),
	        _react2.default.createElement(
	          _reactable.Td,
	          {
	            column: "Pass Bucket",
	            value: (data.pass_bucket || { name: "Deleted " + (isMembership ? "Membership" : "Pass Bucket") }).name
	          },
	          (data.pass_bucket || { name: "Deleted " + (isMembership ? "Membership" : "Pass Bucket") }).name
	        ),
	        this.props.includeCardOnFile ? _react2.default.createElement(
	          _reactable.Td,
	          {
	            column: "Card On File", value: data.person.payment_method_summary },
	          data.person.payment_method_summary ? data.person.payment_method_summary : "n/a"
	        ) : null,
	        this.props.includeRenewalDate ? _react2.default.createElement(
	          _reactable.Td,
	          { column: "Renewal Date", value: new Date(renewalDate) },
	          renewalDate
	        ) : null,
	        this.props.includeAutorenew ? _react2.default.createElement(
	          _reactable.Td,
	          {
	            column: "Autorenew",
	            value: autoRenew,
	            style: autoRenew === "Y" ? {
	              backgroundColor: "rgb(76, 175, 80)",
	              color: "white",
	              borderBottom: "1px solid white"
	            } : {
	              backgroundColor: "rgb(244, 67, 54)",
	              color: "white",
	              borderBottom: "1px solid white"
	            }
	          },
	          autoRenew
	        ) : null,
	        this.props.includeExpiredDate ? _react2.default.createElement(
	          _reactable.Td,
	          { column: "Expired Date", value: new Date(expiredDate) },
	          expiredDate
	        ) : null
	      );
	    }
	  }, {
	    key: "downloadCsv",
	    value: function downloadCsv(data, reportName) {
	      util.clientSideDownload((this.props.isMembership ? "membership_status_analytics" : "recurring_pass_analytics") + "-" + util.snakeCase(reportName) + "-" + util.snakeCase(this.props.eventBucket.name) + ".csv", "text/csv", util.makeCsv([["Name", "Email", "Phone Number", "Mailing Address", "Pass Bucket", "Card On File", "Renewal Date", "Autorenew"]].concat(data.map(function (d) {
	        return [d.person.name, d.person.email, d.person.phone_number, d.person.mailing_address, (d.pass_bucket || { name: "Deleted Pass Bucket" }).name, d.person.payment_method_summary, d.renewal_date, d.should_autorenew ? "Y" : "N"];
	      }))));
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this3 = this;
	
	      var _props = this.props;
	      var data = _props.data;
	      var includeCardOnFile = _props.includeCardOnFile;
	      var includeRenewalDate = _props.includeRenewalDate;
	      var includeAutorenew = _props.includeAutorenew;
	      var includeExpiredDate = _props.includeExpiredDate;
	      var itemsPerPage = _props.itemsPerPage;
	      var _props$isMembership2 = _props.isMembership;
	      var isMembership = _props$isMembership2 === undefined ? false : _props$isMembership2;
	      var rows = data.map(this._makeRow);
	
	      var defaultItemsPerPage = 25;
	      var itemsPer = itemsPerPage ? itemsPerPage : defaultItemsPerPage;
	
	      var columns = ["Name", "Email", "Phone Number", "Mailing Address", { label: isMembership ? "Membership" : "Pass Bucket", key: "Pass Bucket" }];
	
	      if (includeCardOnFile) {
	        columns.push("Card On File");
	      }
	      if (includeRenewalDate) {
	        columns.push("Renewal Date");
	      }
	      if (includeAutorenew) {
	        columns.push("Autorenew");
	      }
	      if (includeExpiredDate) {
	        columns.push("Expired Date");
	      }
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          _reactable.Table,
	          {
	            className: "bordered striped responsive-table",
	            sortable: ["Name", "Email", "Renewal Date", "Autorenew"],
	            defaultSort: includeExpiredDate ? { column: "Expired Date", direction: "desc" } : { column: "Renewal Date", direction: "asc" },
	            columns: columns,
	            itemsPerPage: itemsPer,
	            previousPageLabel: '<<',
	            nextPageLabel: '>>'
	          },
	          rows
	        ),
	        rows.length === 0 ? _react2.default.createElement(
	          "div",
	          { className: "empty-table-message" },
	          "No data available."
	        ) : null,
	        _react2.default.createElement(_materialUi.RaisedButton, {
	          style: { marginTop: "1em" },
	          label: "Download (.csv)",
	          onTouchTap: function onTouchTap() {
	            return _this3.downloadCsv(data, _this3.props.reportName);
	          }
	        })
	      );
	    }
	  }], [{
	    key: "contextTypes",
	    get: function get() {
	      return {
	        router: _react2.default.PropTypes.object
	      };
	    }
	  }]);
	
	  return RecurringPassAnalyticsTable;
	}(_react2.default.Component);
	
	exports.default = RecurringPassAnalyticsTable;
	module.exports = exports["default"];

/***/ }),
/* 2621 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactSelect = __webpack_require__(953);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	var _radium = __webpack_require__(1600);
	
	var _radium2 = _interopRequireDefault(_radium);
	
	var _reactEventListener = __webpack_require__(1230);
	
	var _reactEventListener2 = _interopRequireDefault(_reactEventListener);
	
	var _materialUi = __webpack_require__(576);
	
	var _connectToStores = __webpack_require__(1226);
	
	var _connectToStores2 = _interopRequireDefault(_connectToStores);
	
	var _EventBucketStore = __webpack_require__(1593);
	
	var _EventBucketStore2 = _interopRequireDefault(_EventBucketStore);
	
	var _EventBucketActions = __webpack_require__(1218);
	
	var _EventBucketActions2 = _interopRequireDefault(_EventBucketActions);
	
	var _LedgerActions = __webpack_require__(2052);
	
	var _LedgerActions2 = _interopRequireDefault(_LedgerActions);
	
	var _FilmActions = __webpack_require__(1764);
	
	var _FilmActions2 = _interopRequireDefault(_FilmActions);
	
	var _LedgerStore = __webpack_require__(2315);
	
	var _LedgerStore2 = _interopRequireDefault(_LedgerStore);
	
	var _UserStore = __webpack_require__(974);
	
	var _UserStore2 = _interopRequireDefault(_UserStore);
	
	var _FilmStore = __webpack_require__(1765);
	
	var _FilmStore2 = _interopRequireDefault(_FilmStore);
	
	var _reportsHeader = __webpack_require__(2622);
	
	var _reportsHeader2 = _interopRequireDefault(_reportsHeader);
	
	var _workingIndicator = __webpack_require__(1664);
	
	var _workingIndicator2 = _interopRequireDefault(_workingIndicator);
	
	var _label = __webpack_require__(1682);
	
	var _label2 = _interopRequireDefault(_label);
	
	var _boxOfficeReportView = __webpack_require__(2317);
	
	var _boxOfficeReportView2 = _interopRequireDefault(_boxOfficeReportView);
	
	var _reactDateRange = __webpack_require__(2198);
	
	var _defaultRanges = __webpack_require__(2258);
	
	var _moment = __webpack_require__(1021);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _twix = __webpack_require__(2312);
	
	var _twix2 = _interopRequireDefault(_twix);
	
	var _util = __webpack_require__(1183);
	
	var util = _interopRequireWildcard(_util);
	
	var _config = __webpack_require__(1173);
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LedgerBoxOfficeReport = function (_React$Component) {
	  _inherits(LedgerBoxOfficeReport, _React$Component);
	
	  function LedgerBoxOfficeReport(props) {
	    _classCallCheck(this, LedgerBoxOfficeReport);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(LedgerBoxOfficeReport).call(this, props));
	
	    _this.state = {
	      showRangeEditor: false,
	      allTime: true,
	      range: {
	        key: "selection",
	        startDate: (0, _moment2.default)().subtract(1, "month"),
	        endDate: (0, _moment2.default)()
	      },
	      selectedFilm: null,
	      selectedBucket: null
	    };
	
	    _this.onWindowClick = _this.onWindowClick.bind(_this);
	    _this.onWindowKeyDown = _this.onWindowKeyDown.bind(_this);
	    _this.handleDateChange = _this.handleDateChange.bind(_this);
	    _this.formatFilms = _this.formatFilms.bind(_this);
	    _this.downloadCsv = _this.downloadCsv.bind(_this);
	    _this.downloadPdf = _this.downloadPdf.bind(_this);
	    return _this;
	  }
	
	  _createClass(LedgerBoxOfficeReport, [{
	    key: "onWindowClick",
	    value: function onWindowClick(e) {
	      if (this.state.showRangeEditor && (!this.container || !this.container.contains(e.target) && !this.rangeButton.contains(e.target))) {
	        this.setState({ showRangeEditor: false });
	      }
	    }
	  }, {
	    key: "onWindowKeyDown",
	    value: function onWindowKeyDown(e) {
	      if (this.state.showRangeEditor && e.which === 27) {
	        // esc
	        this.setState({ showRangeEditor: false });
	      }
	    }
	  }, {
	    key: "handleDateChange",
	    value: function handleDateChange(_ref) {
	      var _this2 = this;
	
	      var selection = _ref.selection;
	
	      if (selection.startDate === "all_time") {
	        this.setState({ allTime: true, showRangeEditor: false, range: this.state.range }, function () {
	          _this2.componentWillReceiveProps(_this2.props, true);
	        });
	        return;
	      }
	
	      console.log(selection);
	
	      this.setState({ range: selection, allTime: false }, function () {
	        _this2.componentWillReceiveProps(_this2.props, true);
	      });
	    }
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      _EventBucketActions2.default.fetchAll.defer();
	      _FilmActions2.default.fetchAllForUser.defer();
	      this.componentWillReceiveProps(this.props, true);
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(newProps) {
	      var force = arguments.length <= 1 || arguments[1] === undefined ? false : arguments[1];
	
	      if (force === true) {
	        if (newProps.params.eventBucketId !== this.props.params.eventBucketId) {
	          _EventBucketActions2.default.fetchOne.defer(newProps.params.eventBucketId);
	        }
	      }
	    }
	  }, {
	    key: "formatFilms",
	    value: function formatFilms() {
	      var allFilms = this.props.getAllUserFilms();
	      var films = allFilms.reduce(function (filmArray, item) {
	        if (item.name !== "" && item.name !== undefined) {
	          if (this.state.selectedBucket === item.event_bucket) {
	            filmArray.push({ value: item.id, label: item.name });
	          }
	        }
	        return filmArray;
	      }.bind(this), []);
	
	      return films;
	    }
	  }, {
	    key: "downloadCsv",
	    value: function downloadCsv() {
	      var conditions = this.buildConditions();
	      var options = {
	        timePeriod: this.state.grouping,
	        format: "csv"
	      };
	
	      var form = document.createElement("form");
	      form.method = "post";
	      form.action = _config2.default.endpoint + "analytics/box_office_report?" + _UserStore2.default.makeApiKeyQueryString() + "&conditions=" + JSON.stringify(conditions) + "&options=" + JSON.stringify(options);
	      form.target = "generatedCsv";
	
	      document.body.appendChild(form);
	
	      window.open("", "generatedCsv");
	      form.submit();
	    }
	  }, {
	    key: "downloadPdf",
	    value: function downloadPdf() {
	      var conditions = this.buildConditions();
	      var options = {
	        timePeriod: this.state.grouping,
	        format: "pdf"
	      };
	
	      var form = document.createElement("form");
	      form.method = "post";
	      form.action = _config2.default.endpoint + "analytics/box_office_report?" + _UserStore2.default.makeApiKeyQueryString() + "&conditions=" + JSON.stringify(conditions) + "&options=" + JSON.stringify(options);
	      form.target = "generatedPdf";
	
	      document.body.appendChild(form);
	
	      window.open("", "generatedPdf");
	      form.submit();
	    }
	  }, {
	    key: "getStyles",
	    value: function getStyles() {
	      return {
	        rangeContainer: {
	          float: "right",
	          marginBottom: "1.25em"
	        },
	        rangeButton: {
	          display: "inline-block",
	          borderRadius: 20,
	          padding: "8px 16px",
	          fontSize: "12pt",
	          color: "rgb(33,33,33)",
	          cursor: "pointer",
	          boxShadow: "0 0 5px 2px rgba(0, 0, 0, 0.1)",
	          transition: "0.1s ease-in-out",
	          ":hover": {
	            boxShadow: "0 0 5px 2px rgba(0, 0, 0, 0.2)"
	          }
	        },
	        overlay: {
	          position: "absolute",
	          right: 0,
	          top: 0,
	          backgroundColor: "#fff",
	          boxShadow: "0 0 5px 2px rgb(0,0,0,0.1)",
	          zIndex: 1
	        },
	        overlaySubmit: {
	          position: "absolute",
	          right: 10,
	          bottom: 10
	        },
	        gridHeaderRow: {
	          color: "#fff",
	          backgroundColor: "#0288d1"
	        },
	        gridHeaderLabel: {
	          textAlign: "right",
	          padding: "4px",
	          width: "100px",
	          borderRight: "1px solid #fff"
	        },
	        gridDayTitle: {
	          fontWeight: "bold",
	          fontSize: "16px",
	          paddingTop: "20px",
	          paddingBottom: "2px",
	          paddingLeft: "2px"
	        },
	        gridTimeTitle: {
	          fontWeight: "bold",
	          fontSize: "13px",
	          paddingTop: "2px",
	          paddingLeft: "2px",
	          paddingBottom: "2px"
	        },
	        gridLabelCell: {
	          textAlign: "left",
	          padding: "2px"
	        },
	        gridDataCell: {
	          textAlign: "right",
	          padding: "2px",
	          width: "100px"
	        },
	        gridButtonRow: {
	          width: "100%",
	          display: "flex",
	          flexDirection: "row",
	          justifyContent: "start"
	        }
	      };
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this3 = this;
	
	      var styles = this.getStyles(),
	          eventBucketId = this.state.selectedBucket,
	          selectedFilms = this.state.selectedFilms || [],
	          eventBucket = this.props.getEventBucketById(eventBucketId),
	          films = this.props.getAllUserFilms();
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(_reactEventListener2.default, {
	          target: "window",
	          onClick: this.onWindowClick,
	          onKeyDown: this.onWindowKeyDown
	        }),
	        _react2.default.createElement(_reportsHeader2.default, {
	          eventBucket: eventBucket,
	          allEventBuckets: this.props.getEventBuckets(),
	          label: "reports",
	          subpath: "sales",
	          query: this.props.location.query,
	          onRefresh: function onRefresh() {
	            return _this3.componentWillReceiveProps(_this3.props, true);
	          },
	          isRefreshing: this.props.isFetching,
	          hideHeader: true,
	          handleChange: function handleChange(b) {
	            return _this3.setState({ selectedBucket: b.value, selectedFilms: [] });
	          }
	        }),
	        _react2.default.createElement(
	          "div",
	          { style: { position: "relative" } },
	          _react2.default.createElement(
	            "div",
	            {
	              style: styles.rangeContainer,
	              ref: function ref(r) {
	                _this3.rangeButton = r;
	              }
	            },
	            _react2.default.createElement(_materialUi.RaisedButton, {
	              onClick: function onClick() {
	                return _this3.setState({ showRangeEditor: true });
	              },
	              label: this.state.allTime ? "All time sales – click to filter" : _moment2.default.tz(this.state.range.startDate, eventBucket.timezone).format("ll") + " \u2013 " + _moment2.default.tz(this.state.range.endDate, eventBucket.timezone).format("ll")
	            })
	          ),
	          _react2.default.createElement(
	            "h1",
	            { style: { lineHeight: 1.2 } },
	            selectedFilms.length > 0 ? selectedFilms.length === 1 ? selectedFilms[0].label + " - " : "Multiple Films " : "Generate ",
	            "Box Office Report"
	          ),
	          _react2.default.createElement(
	            "div",
	            { style: { float: "left", width: 400 } },
	            _react2.default.createElement(_reactSelect2.default, {
	              options: this.formatFilms().map(function (b) {
	                return {
	                  label: b.label,
	                  value: b.value
	                };
	              }),
	              value: selectedFilms,
	              clearable: false,
	              multi: true,
	              onChange: function onChange(e) {
	                _this3.setState({ selectedFilms: e }, function () {
	                  _this3.componentWillReceiveProps(_this3.props, true);
	                });
	              }
	            })
	          ),
	          this.state.showRangeEditor ? _react2.default.createElement(
	            "div",
	            {
	              style: styles.overlay,
	              ref: function ref(r) {
	                _this3.container = r;
	              }
	            },
	            _react2.default.createElement(_reactDateRange.DateRangePicker, {
	              ranges: [this.state.range],
	              onChange: this.handleDateChange,
	              maxDate: new Date(),
	              staticRanges: [{
	                label: "All Time",
	                isSelected: function isSelected() {
	                  return false;
	                },
	                range: function range() {
	                  return {
	                    startDate: "all_time",
	                    endDate: "all_time"
	                  };
	                }
	              }].concat(_defaultRanges.defaultStaticRanges)
	            }),
	            _react2.default.createElement(
	              "div",
	              { style: styles.overlaySubmit },
	              _react2.default.createElement(_materialUi.RaisedButton, {
	                label: "Close",
	                onTouchTap: function onTouchTap() {
	                  return _this3.setState({ showRangeEditor: false });
	                }
	              })
	            )
	          ) : null,
	          !this.props.isFetching ? _react2.default.createElement(_boxOfficeReportView2.default, {
	            selectedBucket: eventBucketId,
	            selectedFilms: selectedFilms,
	            allTime: this.state.allTime,
	            startTime: this.state.range.startDate,
	            endTime: this.state.range.endDate,
	            grouping: this.state.grouping
	          }) : _react2.default.createElement(
	            "div",
	            { style: { clear: "both" } },
	            _react2.default.createElement(_workingIndicator2.default, { fullPage: true })
	          )
	        )
	      );
	    }
	  }], [{
	    key: "getStores",
	    value: function getStores() {
	      return [_EventBucketStore2.default, _FilmStore2.default, _LedgerStore2.default];
	    }
	  }, {
	    key: "getPropsFromStores",
	    value: function getPropsFromStores() {
	      return {
	        getEventBuckets: _EventBucketStore2.default.getEventBuckets,
	        getEventBucketById: _EventBucketStore2.default.getEventBucketById,
	        getLedgerAnalyticsTransactions: _LedgerStore2.default.getLedgerAnalyticsTransactions,
	        getLedgerBoxOfficeTransactions: _LedgerStore2.default.getLedgerBoxOfficeTransactions,
	        getLedgerBoxOfficeReport: _LedgerStore2.default.getLedgerBoxOfficeReport,
	        isFetching: _LedgerStore2.default.getState().isFetching,
	        getAllUserFilms: _FilmStore2.default.getAllUserFilms
	      };
	    }
	  }]);
	
	  return LedgerBoxOfficeReport;
	}(_react2.default.Component);
	
	LedgerBoxOfficeReport.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	exports.default = (0, _radium2.default)((0, _connectToStores2.default)(LedgerBoxOfficeReport));
	module.exports = exports["default"];

/***/ }),
/* 2622 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactSelect = __webpack_require__(953);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	var _backButton = __webpack_require__(1872);
	
	var _backButton2 = _interopRequireDefault(_backButton);
	
	var _tableRefreshIndicator = __webpack_require__(1686);
	
	var _tableRefreshIndicator2 = _interopRequireDefault(_tableRefreshIndicator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HEADER_STYLE = {
	  lineHeight: 1.2
	};
	
	var ReportsHeader = function ReportsHeader(_ref, _ref2) {
	  var eventBucket = _ref.eventBucket;
	  var allEventBuckets = _ref.allEventBuckets;
	  var onRefresh = _ref.onRefresh;
	  var isRefreshing = _ref.isRefreshing;
	  var handleChange = _ref.handleChange;
	  var router = _ref2.router;
	
	  return _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement(_backButton2.default, {
	      label: "Reports",
	      style: { marginBottom: 10 },
	      location: "/reports"
	    }),
	    onRefresh || isRefreshing ? _react2.default.createElement(_tableRefreshIndicator2.default, {
	      onRefresh: onRefresh,
	      isRefreshing: isRefreshing,
	      style: { marginRight: 260, marginTop: -2 }
	    }) : null,
	    _react2.default.createElement(
	      "div",
	      { style: { float: "right", width: 250 } },
	      _react2.default.createElement(_reactSelect2.default, {
	        options: allEventBuckets.map(function (b) {
	          return { label: b.name, value: b.id };
	        }),
	        value: eventBucket ? eventBucket.id : null,
	        clearable: false,
	        onChange: handleChange
	      })
	    )
	  );
	};
	
	ReportsHeader.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	
	exports.default = ReportsHeader;
	module.exports = exports["default"];

/***/ }),
/* 2623 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _momentTimezone = __webpack_require__(1185);
	
	var _momentTimezone2 = _interopRequireDefault(_momentTimezone);
	
	var _connectToStores = __webpack_require__(1226);
	
	var _connectToStores2 = _interopRequireDefault(_connectToStores);
	
	var _BoxOfficeActions = __webpack_require__(2624);
	
	var _BoxOfficeActions2 = _interopRequireDefault(_BoxOfficeActions);
	
	var _BoxOfficeStore = __webpack_require__(2625);
	
	var _BoxOfficeStore2 = _interopRequireDefault(_BoxOfficeStore);
	
	var _EventBucketStore = __webpack_require__(1593);
	
	var _EventBucketStore2 = _interopRequireDefault(_EventBucketStore);
	
	var _EventStore = __webpack_require__(2032);
	
	var _EventStore2 = _interopRequireDefault(_EventStore);
	
	var _PassBucketStore = __webpack_require__(1867);
	
	var _PassBucketStore2 = _interopRequireDefault(_PassBucketStore);
	
	var _ItemBucketStore = __webpack_require__(2045);
	
	var _ItemBucketStore2 = _interopRequireDefault(_ItemBucketStore);
	
	var _UserStore = __webpack_require__(974);
	
	var _UserStore2 = _interopRequireDefault(_UserStore);
	
	var _ShiftStore = __webpack_require__(2626);
	
	var _ShiftStore2 = _interopRequireDefault(_ShiftStore);
	
	var _PassBucketActions = __webpack_require__(1869);
	
	var _PassBucketActions2 = _interopRequireDefault(_PassBucketActions);
	
	var _ItemBucketActions = __webpack_require__(2044);
	
	var _ItemBucketActions2 = _interopRequireDefault(_ItemBucketActions);
	
	var _EventActions = __webpack_require__(2031);
	
	var _EventActions2 = _interopRequireDefault(_EventActions);
	
	var _util = __webpack_require__(1183);
	
	var util = _interopRequireWildcard(_util);
	
	var _config = __webpack_require__(1173);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _workingIndicator = __webpack_require__(1664);
	
	var _workingIndicator2 = _interopRequireDefault(_workingIndicator);
	
	var _linkLike = __webpack_require__(973);
	
	var _linkLike2 = _interopRequireDefault(_linkLike);
	
	var _seatPicker = __webpack_require__(2628);
	
	var _seatPicker2 = _interopRequireDefault(_seatPicker);
	
	var _boxOfficeLastOrder = __webpack_require__(2631);
	
	var _boxOfficeLastOrder2 = _interopRequireDefault(_boxOfficeLastOrder);
	
	var _boxOfficeSubitemTable = __webpack_require__(2632);
	
	var _boxOfficeSubitemTable2 = _interopRequireDefault(_boxOfficeSubitemTable);
	
	var _boxOfficePassSetup = __webpack_require__(2640);
	
	var _boxOfficePassSetup2 = _interopRequireDefault(_boxOfficePassSetup);
	
	var _boxOfficePayment = __webpack_require__(2641);
	
	var _boxOfficePayment2 = _interopRequireDefault(_boxOfficePayment);
	
	var _boxOfficeConfirm = __webpack_require__(2659);
	
	var _boxOfficeConfirm2 = _interopRequireDefault(_boxOfficeConfirm);
	
	var _boxOfficeTerminal = __webpack_require__(2661);
	
	var _boxOfficeTerminal2 = _interopRequireDefault(_boxOfficeTerminal);
	
	var _boxOfficeShiftTracking = __webpack_require__(2663);
	
	var _boxOfficeShiftTracking2 = _interopRequireDefault(_boxOfficeShiftTracking);
	
	var _boxOfficeDisplayModeControl = __webpack_require__(2664);
	
	var _boxOfficeDisplayModeControl2 = _interopRequireDefault(_boxOfficeDisplayModeControl);
	
	var _boxOfficeGiftDetailsSetup = __webpack_require__(2665);
	
	var _boxOfficeGiftDetailsSetup2 = _interopRequireDefault(_boxOfficeGiftDetailsSetup);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BOX_OFFICE_TICKETS_PDF_WINDOW = "EventiveBoxOfficeTicketsPDF";
	var BOX_OFFICE_PASSES_PDF_WINDOW = "EventiveBoxOfficePassesPDF";
	
	var BoxOffice = function (_React$Component) {
	  _inherits(BoxOffice, _React$Component);
	
	  function BoxOffice(props) {
	    _classCallCheck(this, BoxOffice);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(BoxOffice).call(this, props));
	
	    _this.state = {
	      refetchIntervalId: null,
	      processedData: {
	        subitems: [],
	        total: 0,
	        originalTotal: 0
	      },
	      lastOpenedOrder: null,
	      openedSeatPickerEvent: null,
	      hasReset: false
	    };
	
	    _this._makeSubitemData = _this._makeSubitemData.bind(_this);
	    _this.openSeatPicker = _this.openSeatPicker.bind(_this);
	    _this.closeSeatPicker = _this.closeSeatPicker.bind(_this);
	    _this.onSeatPickerSubmit = _this.onSeatPickerSubmit.bind(_this);
	    return _this;
	  }
	
	  _createClass(BoxOffice, [{
	    key: "componentWillMount",
	    value: function componentWillMount() {
	      var _this2 = this;
	
	      setTimeout(function () {
	        _BoxOfficeActions2.default.reset({
	          event_bucket: _this2.props.params.eventBucketId,
	          customerType: "standard"
	        });
	        _this2.setState({ hasReset: true });
	      }, 0);
	    }
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var _this3 = this;
	
	      // refetch pass buckets every 15 seconds to keep availability up-to-date
	      var intervalId = setInterval(function () {
	        _PassBucketActions2.default.fetchAllForEventBucket.defer(_this3.props.params.eventBucketId);
	        _ItemBucketActions2.default.fetchAllForEventBucket.defer(_this3.props.params.eventBucketId);
	        var eventBucket = _EventBucketStore2.default.getEventBucketById(_this3.props.params.eventBucketId);
	      }, 15000);
	
	      this.setState(function (prevState) {
	        return _extends({}, prevState, {
	          refetchIntervalId: intervalId
	        });
	      });
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      clearInterval(this.state.refetchIntervalId);
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(newProps) {
	      var _this4 = this;
	
	      var eventBucket = _EventBucketStore2.default.getEventBucketById(newProps.params.eventBucketId);
	      if (this.props.params.eventBucketId !== newProps.params.eventBucketId) {
	        var excludeOlderEvents = false;
	        if (eventBucket.frontend_config.box_office_performance) {
	          excludeOlderEvents = eventBucket.frontend_config.box_office_performance.exclude_older_events ? true : false;
	        }
	        _EventActions2.default.fetchAllForBucket.defer(newProps.params.eventBucketId, false, excludeOlderEvents);
	      }
	
	      var subitemData = [];
	      (newProps.orderData.subitems || []).forEach(function (s, i) {
	        subitemData.push(_this4._makeSubitemData(s, i, {
	          orderData: newProps.orderData,
	          eventBucket: eventBucket,
	          subitemData: subitemData
	        }));
	      });
	
	      var originalTotal = subitemData.reduce(function (t, i) {
	        return t + (i.originalTotal || i.total);
	      }, 0),
	          total = subitemData.reduce(function (t, i) {
	        return t + i.total;
	      }, 0);
	
	      if (newProps.orderData.coupon && newProps.orderData.coupon.gift_card && newProps.orderData.coupon.gift_card_balance) {
	        originalTotal = originalTotal || total;
	        total = Math.max(total - newProps.orderData.coupon.gift_card_balance, 0);
	      }
	
	      var processedData = {
	        subitems: subitemData,
	        mailingAddressRequired: subitemData.some(function (d) {
	          return d.item && d.item.event && d.item.event.require_mailing_address;
	        }) || subitemData.some(function (d) {
	          return d.item && d.item.code === "donation";
	        }) && _EventBucketStore2.default.getEventBucketById(newProps.params.eventBucketId).frontend_config.donate_require_mailing_address,
	        phoneNumberRequired: subitemData.some(function (d) {
	          return d.item && d.item.event && d.item.event.require_phone_number;
	        }) || subitemData.some(function (d) {
	          return d.item && d.item.code === "donation";
	        }) && _EventBucketStore2.default.getEventBucketById(newProps.params.eventBucketId).frontend_config.donate_require_phone_number,
	        originalTotal: originalTotal,
	        total: total
	      };
	
	      if (newProps.orderData.group_sale_data) {
	        var groupSize = newProps.orderData.group_sale_data.length;
	        if (groupSize) {
	          processedData.originalTotal *= groupSize;
	          processedData.total *= groupSize;
	          processedData.groupSalesSize = groupSize;
	        }
	      }
	
	      this.setState({
	        processedData: processedData
	      });
	
	      // Open window for success
	      if (this.props.orderInProgress && newProps.lastOrder && this.state.lastOpenedOrder !== newProps.lastOrder.id && _EventBucketStore2.default.getEventBucketById(newProps.params.eventBucketId).box_office_auto_open) {
	        var win = void 0;
	
	        this.setState({ lastOpenedOrder: newProps.lastOrder.id });
	
	        if (newProps.lastOrder.tickets.some(function (t) {
	          return !t.event.is_virtual;
	        })) {
	          win = window.open(_config2.default.endpoint + newProps.lastOrder.order_tickets_pdf_path + "?via_box_office=true", BOX_OFFICE_TICKETS_PDF_WINDOW + Date.now());
	        } else if (newProps.lastOrder.passes.length) {
	          win = window.open(_config2.default.endpoint + ("passes/labels.pdf?" + _UserStore2.default.makeApiKeyQueryString() + "&conditions=" + JSON.stringify({ _id: { $in: newProps.lastOrder.passes.map(function (p) {
	                return p.id;
	              }) } })), BOX_OFFICE_PASSES_PDF_WINDOW + Date.now());
	        }
	
	        if (win && win.focus) {
	          win.focus();
	        }
	      }
	    }
	  }, {
	    key: "_makeSubitemData",
	    value: function _makeSubitemData(subitem, i, _ref) {
	      var _this5 = this;
	
	      var orderData = _ref.orderData;
	      var eventBucket = _ref.eventBucket;
	      var subitemData = _ref.subitemData;
	
	      var item = void 0,
	          variant = void 0,
	          name = void 0,
	          tooltip = void 0,
	          descriptor = void 0,
	          subname = void 0,
	          price = void 0,
	          originalPrice = void 0,
	          variablePrice = void 0,
	          quantity = void 0,
	          tax = void 0,
	          fee = void 0,
	          total = void 0,
	          originalTotal = void 0,
	          seatQuantityEditor = void 0;
	      var _props = this.props;
	      var getTicketBucketWithEventById = _props.getTicketBucketWithEventById;
	      var getPassBucketById = _props.getPassBucketById;
	      var getItemBucketById = _props.getItemBucketById;
	
	
	      if (subitem.ticket_bucket) {
	        item = getTicketBucketWithEventById(subitem.ticket_bucket);
	        name = "" + item.event.name;
	        descriptor = item.event.start_time ? "" + _momentTimezone2.default.tz(item.event.start_time, item.event.timezone).format("ddd MMM Do h:mm A") : "Undated event";
	        if (subitem.variant) {
	          variant = item.variants.find(function (v) {
	            return v.id === subitem.variant;
	          });
	          subname = item.name + " \u2013 " + variant.name;
	          price = variant.price;
	        } else {
	          subname = item.name;
	        }
	        if (subitem.seats && subitem.seats.length) {
	          subname += " (" + subitem.seats.join(", ") + ")";
	        }
	      } else if (subitem.pass_bucket) {
	        item = getPassBucketById(subitem.pass_bucket);
	        name = "" + item.name;
	      } else if (subitem.memberships) {
	        item = getPassBucketById(subitem.memberships);
	        name = "" + item.name;
	      } else if (subitem.item_bucket) {
	        item = getItemBucketById(subitem.item_bucket);
	        variant = item.variants.find(function (v) {
	          return v.id === subitem.variant;
	        });
	        name = variant.name ? item.name + " \u2013 " + variant.name : "" + item.name;
	        price = variant.price;
	        variablePrice = variant.variable_price;
	      } else if (subitem.gift_card) {
	        item = subitem;
	        name = "" + item.name;
	        price = item.price;
	        variablePrice = item.variable_price;
	      } else if (subitem.service_fee && subitem.auto) {
	        (function () {
	          var threshold = _config2.default.fee.service_fee_threshold.default;
	          item = { service_fee: true };
	          name = "Box office service fee";
	          tooltip = "Charged on each item over " + util.formatPrice(threshold);
	          subitem.price = eventBucket.box_office_service_fee;
	          subitem.quantity = subitemData.reduce(function (q, i, index) {
	            if (i.service_fee || i.item.code === "service_fee" || i.item.code === "donation") {
	              return q;
	            }
	
	            var numEligible = Array.isArray(i.price) ? i.price.filter(function (p) {
	              return p[0] >= threshold;
	            }).reduce(function (q, d) {
	              return q + d[1];
	            }, 0) : i.price >= threshold ? orderData.subitems[index].quantity : 0;
	
	            return q + numEligible;
	          }, 0);
	        })();
	      }
	
	      price = typeof subitem.price !== "undefined" ? subitem.price : typeof price !== "undefined" ? price : typeof item.sale_price !== "undefined" && item.sale_price > 0 // nonzero only since 0 = unset
	      ? item.sale_price : typeof item.price !== "undefined" ? item.price : 0;
	      quantity = subitem.quantity;
	
	      if (item.event && item.event.venue && item.event.venue.use_reserved_seating) {
	        if (orderData.customerType === "groupSales") {
	          quantity = 1;
	          seatQuantityEditor = _react2.default.createElement(
	            "div",
	            null,
	            "1",
	            _react2.default.createElement(
	              "div",
	              { style: { fontSize: "0.8em", lineHeight: 1 } },
	              "Choose seat in group sale"
	            )
	          );
	        } else {
	          subitem.seats = subitem.seats || [];
	          quantity = subitem.seats.length;
	          seatQuantityEditor = _react2.default.createElement(
	            "div",
	            null,
	            subitem.seats.length,
	            _react2.default.createElement(
	              "div",
	              { style: { fontSize: "0.8em", lineHeight: 1 } },
	              _react2.default.createElement(
	                _linkLike2.default,
	                { onTouchTap: function onTouchTap() {
	                    return _this5.openSeatPicker(item.event);
	                  } },
	                "Choose seats"
	              )
	            )
	          );
	        }
	      }
	
	      // Apply pass
	      if (orderData.pass_data && orderData.pass_data.subitems[i] && orderData.pass_data.subitems[i].price !== price) {
	        originalPrice = price;
	
	        if (orderData.pass_data.subitems[i].quantity_available && subitem.quantity > orderData.pass_data.subitems[i].quantity_available) {
	          price = [[orderData.pass_data.subitems[i].price, orderData.pass_data.subitems[i].quantity_available], [price, subitem.quantity - orderData.pass_data.subitems[i].quantity_available]];
	        } else {
	          price = orderData.pass_data.subitems[i].price;
	        }
	
	        originalTotal = originalPrice * quantity;
	      }
	
	      if (orderData.coupon && orderData.coupon.subitems && orderData.coupon.subitems[i] && orderData.coupon.subitems[i].is_applicable || item && item.volume_price_enabled && !Array.isArray(price) || item && item.sale_price || eventBucket && eventBucket.tax_at_box_office || eventBucket && eventBucket.fee_at_box_office) {
	        if (Array.isArray(price)) {
	          var _price$reduce = price.reduce(function (d, p) {
	            var _util$applyCoupon = util.applyCoupon(_extends({}, subitem, { quantity: p[1] }), p[0], item, orderData.coupon && orderData.coupon.subitems[i].price, eventBucket);
	
	            var tax_ = _util$applyCoupon.tax;
	            var total_ = _util$applyCoupon.total;
	
	            return { tax: d.tax + tax_, total: d.total + total_ };
	          }, { tax: 0, fee: 0, total: 0 });
	
	          tax = _price$reduce.tax;
	          fee = _price$reduce.fee;
	          total = _price$reduce.total;
	        } else {
	          var _util$applyCoupon2 = util.applyCoupon(subitem, price, item, orderData.coupon && orderData.coupon.subitems && orderData.coupon.subitems[i] && orderData.coupon.subitems[i].price, eventBucket);
	
	          originalPrice = _util$applyCoupon2.originalPrice;
	          price = _util$applyCoupon2.price;
	          tax = _util$applyCoupon2.tax;
	          fee = _util$applyCoupon2.fee;
	          total = _util$applyCoupon2.total;
	
	          originalTotal = originalPrice * quantity;
	        }
	      } else {
	        total = Array.isArray(price) ? price.reduce(function (total, p) {
	          return total + p[0] * p[1];
	        }, 0) : price * subitem.quantity;
	      }
	
	      return {
	        item: item,
	        name: name,
	        descriptor: descriptor,
	        tooltip: tooltip,
	        subname: subname,
	        price: price,
	        originalPrice: originalPrice,
	        quantity: seatQuantityEditor || quantity,
	        fixedQuantity: !!seatQuantityEditor || subitem.service_fee,
	        noDelete: subitem.service_fee && subitem.auto,
	        hidden: subitem.service_fee && total === 0,
	        variablePrice: variablePrice,
	        tax: tax,
	        fee: fee,
	        total: total,
	        originalTotal: originalTotal
	      };
	    }
	  }, {
	    key: "openSeatPicker",
	    value: function openSeatPicker(event) {
	      this.setState({
	        openedSeatPickerEvent: event
	      });
	    }
	  }, {
	    key: "closeSeatPicker",
	    value: function closeSeatPicker() {
	      this.setState({ openedSeatPickerEvent: null });
	    }
	  }, {
	    key: "onSeatPickerSubmit",
	    value: function onSeatPickerSubmit(pickedSubitems) {
	      var updatedSubitems = this.props.orderData.subitems.slice();
	
	      // Remove all previous subitems for this event since we'll be resetting them all
	      // with the latest new data from the seat picker.
	      var affectedTicketBuckets = this.state.openedSeatPickerEvent.ticket_buckets.map(function (b) {
	        return b.id;
	      });
	      updatedSubitems = updatedSubitems.filter(function (s) {
	        return affectedTicketBuckets.indexOf(s.ticket_bucket) === -1;
	      });
	
	      updatedSubitems = updatedSubitems.concat(pickedSubitems);
	
	      _BoxOfficeActions2.default.updateCurrentOrder({
	        subitems: updatedSubitems
	      });
	      this.setState({
	        openedSeatPickerEvent: null
	      });
	    }
	  }, {
	    key: "getStyles",
	    value: function getStyles() {
	      return {
	        header: {
	          textAlign: "left",
	          marginBottom: "0.5em",
	          marginTop: "0.3em"
	        },
	        headerWithShiftTracking: {},
	        subheaderStyle: {
	          marginTop: "2em",
	          color: "#0288d1",
	          borderBottom: "1px solid",
	          paddingBottom: 5,
	          width: 150
	        },
	        topOptions: {
	          float: "right",
	          marginTop: -5
	        }
	      };
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var styles = this.getStyles();
	
	      var _props2 = this.props;
	      var orderData = _props2.orderData;
	      var orderInProgress = _props2.orderInProgress;
	      var orderErrorMessage = _props2.orderErrorMessage;
	      var lastOrder = _props2.lastOrder;
	      var location = _props2.location;
	      var terminal = _props2.terminal;
	      var terminalConnectionStatus = _props2.terminalConnectionStatus;
	      var terminalPaymentStatus = _props2.terminalPaymentStatus;
	      var externalNeedsConfirm = _props2.externalNeedsConfirm;
	      var displayMode = _props2.displayMode;
	      var posConfig = _props2.posConfig;
	      var _state = this.state;
	      var processedData = _state.processedData;
	      var hasReset = _state.hasReset;
	      var bucket = _EventBucketStore2.default.getEventBucketById(this.props.params.eventBucketId);
	
	      if (!bucket || !orderData || !orderData.subitems || !hasReset) {
	        return _react2.default.createElement(_workingIndicator2.default, { fullPage: true });
	      }
	
	      return _react2.default.createElement(
	        "div",
	        { style: displayMode === "pos" ? { minWidth: 900 } : null },
	        this.state.openedSeatPickerEvent ? _react2.default.createElement(_seatPicker2.default, {
	          order: orderData,
	          event: this.state.openedSeatPickerEvent,
	          onRequestClose: this.closeSeatPicker,
	          onSubmit: this.onSeatPickerSubmit
	        }) : null,
	        _react2.default.createElement(
	          "div",
	          { style: styles.topOptions },
	          _react2.default.createElement(_boxOfficeTerminal2.default, {
	            initializeTerminal: _BoxOfficeActions2.default.initializeTerminal,
	            terminal: terminal,
	            terminalConnectionStatus: terminalConnectionStatus,
	            terminalPaymentStatus: terminalPaymentStatus,
	            processedData: processedData,
	            orderInProgress: orderInProgress
	          }),
	          _react2.default.createElement(_boxOfficeDisplayModeControl2.default, null),
	          bucket.box_office_shift_tracking ? _react2.default.createElement(_boxOfficeShiftTracking2.default, null) : null
	        ),
	        _react2.default.createElement(
	          "h1",
	          {
	            style: Object.assign({}, styles.header, bucket.box_office_shift_tracking && styles.headerWithShiftTracking)
	          },
	          bucket.name,
	          " Box Office"
	        ),
	        _react2.default.createElement(_boxOfficeLastOrder2.default, {
	          lastOrder: lastOrder,
	          repeatLastOrder: function repeatLastOrder() {
	            var newOrder = _extends({}, lastOrder._raw_order);
	            newOrder.subitems = newOrder.subitems.map(function (s) {
	              var seats = s.seats;
	
	              var rest = _objectWithoutProperties(s, ["seats"]);
	
	              return rest;
	            });
	            _BoxOfficeActions2.default.updateCurrentOrder(newOrder);
	          }
	        }),
	        _react2.default.createElement(_boxOfficeSubitemTable2.default, {
	          displayMode: displayMode,
	          posConfig: (posConfig || {})[bucket.id] || {},
	          orderData: orderData,
	          processedData: processedData,
	          updateCurrentOrder: _BoxOfficeActions2.default.updateCurrentOrder,
	          updatePosConfig: function updatePosConfig(config) {
	            return _BoxOfficeActions2.default.updatePosConfig(_defineProperty({}, bucket.id, config));
	          }
	        }),
	        _react2.default.createElement(_boxOfficeGiftDetailsSetup2.default, {
	          orderData: orderData,
	          updateCurrentOrder: _BoxOfficeActions2.default.updateCurrentOrder,
	          headerStyle: styles.subheaderStyle
	        }),
	        _react2.default.createElement(_boxOfficePassSetup2.default, {
	          orderData: orderData,
	          updateCurrentOrder: _BoxOfficeActions2.default.updateCurrentOrder,
	          headerStyle: styles.subheaderStyle,
	          membershipsEnabled: bucket.frontend_config.memberships_enabled
	        }),
	        _react2.default.createElement(_boxOfficePayment2.default, {
	          orderData: orderData,
	          updateCurrentOrder: _BoxOfficeActions2.default.updateCurrentOrder,
	          processedData: processedData,
	          location: location,
	          eventBucket: bucket,
	          headerStyle: styles.subheaderStyle,
	          terminalConnectionStatus: terminalConnectionStatus
	        }),
	        _react2.default.createElement(_boxOfficeConfirm2.default, {
	          orderData: orderData,
	          updateCurrentOrder: _BoxOfficeActions2.default.updateCurrentOrder,
	          submitOrder: _BoxOfficeActions2.default.submitOrder,
	          processedData: processedData,
	          orderInProgress: orderInProgress,
	          orderErrorMessage: orderErrorMessage,
	          eventBucket: bucket,
	          headerStyle: styles.subheaderStyle,
	          externalNeedsConfirm: externalNeedsConfirm,
	          cancelExternal: _BoxOfficeActions2.default.cancelExternal,
	          showEmailSuppressionCheckbox: _UserStore2.default.isGod() || bucket.frontend_config.sundance_login || bucket.frontend_config.box_office_email_suppression_option_enabled
	        })
	      );
	    }
	  }], [{
	    key: "getStores",
	    value: function getStores() {
	      return [_BoxOfficeStore2.default, _EventBucketStore2.default, _EventStore2.default, _PassBucketStore2.default, _ItemBucketStore2.default];
	    }
	  }, {
	    key: "getPropsFromStores",
	    value: function getPropsFromStores() {
	      var state = _BoxOfficeStore2.default.getState();
	      state.getPassBucketById = _PassBucketStore2.default.getPassBucketById;
	      state.getTicketBucketWithEventById = _EventStore2.default.getTicketBucketWithEventById;
	      state.getItemBucketById = _ItemBucketStore2.default.getItemBucketById;
	      return state;
	    }
	  }]);
	
	  return BoxOffice;
	}(_react2.default.Component);
	
	exports.default = (0, _connectToStores2.default)(BoxOffice);
	module.exports = exports["default"];

/***/ }),
/* 2624 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _alt = __webpack_require__(975);
	
	var _alt2 = _interopRequireDefault(_alt);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var BoxOfficeActions = function BoxOfficeActions() {
	  _classCallCheck(this, BoxOfficeActions);
	
	  this.generateActions("reset", "updateCurrentOrder", "submitOrder", "initializeTerminal", "terminalUnexpectedDisconnect", "terminalConnectionStatusChange", "terminalPaymentStatusChange", "cancelExternal", "setDisplayMode", "updatePosConfig");
	};
	
	exports.default = _alt2.default.createActions(BoxOfficeActions);
	module.exports = exports["default"];

/***/ }),
/* 2625 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _alt = __webpack_require__(975);
	
	var _alt2 = _interopRequireDefault(_alt);
	
	var _keyBy = __webpack_require__(990);
	
	var _keyBy2 = _interopRequireDefault(_keyBy);
	
	var _extend = __webpack_require__(1212);
	
	var _extend2 = _interopRequireDefault(_extend);
	
	var _BoxOfficeUtil = __webpack_require__(2267);
	
	var _BoxOfficeUtil2 = _interopRequireDefault(_BoxOfficeUtil);
	
	var _BoxOfficeActions = __webpack_require__(2624);
	
	var _BoxOfficeActions2 = _interopRequireDefault(_BoxOfficeActions);
	
	var _EventBucketActions = __webpack_require__(1218);
	
	var _EventBucketActions2 = _interopRequireDefault(_EventBucketActions);
	
	var _GlobalNotificationActions = __webpack_require__(1182);
	
	var _GlobalNotificationActions2 = _interopRequireDefault(_GlobalNotificationActions);
	
	var _UserStore = __webpack_require__(974);
	
	var _UserStore2 = _interopRequireDefault(_UserStore);
	
	var _EventBucketStore = __webpack_require__(1593);
	
	var _EventBucketStore2 = _interopRequireDefault(_EventBucketStore);
	
	var _util = __webpack_require__(1183);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var SHOULD_PERSIST = !!window.localStorage;
	var LS_KEY = "eventive-boxOfficeState";
	var cachedBoxOfficeState = SHOULD_PERSIST && window.localStorage[LS_KEY] && JSON.parse(window.localStorage[LS_KEY]) || {};
	
	var BoxOfficeStore = function () {
	  function BoxOfficeStore() {
	    _classCallCheck(this, BoxOfficeStore);
	
	    this.bindActions(_BoxOfficeActions2.default);
	    this.state = {
	      orderData: {},
	      orderInProgress: false,
	      orderSuccess: false,
	      orderErrorMessage: null,
	      lastOrder: null,
	
	      terminal: null,
	      terminalConnectionStatus: "not_connected",
	      terminalPaymentStatus: "not_ready",
	
	      displayMode: cachedBoxOfficeState.displayMode || "basic", // 'basic' | 'pos'
	      posConfig: cachedBoxOfficeState.posConfig || {},
	
	      externalNeedsConfirm: false
	    };
	  }
	
	  _createClass(BoxOfficeStore, [{
	    key: "onInitializeTerminal",
	    value: function onInitializeTerminal() {
	      if (this.state.terminal || !window.StripeTerminal) {
	        return;
	      }
	
	      var terminal = window.StripeTerminal.create({
	        onFetchConnectionToken: _BoxOfficeUtil2.default.fetchStripeTerminalToken,
	        onUnexpectedReaderDisconnect: function onUnexpectedReaderDisconnect() {
	          return _BoxOfficeActions2.default.terminalUnexpectedDisconnect();
	        },
	        onConnectionStatusChange: function onConnectionStatusChange(_ref) {
	          var status = _ref.status;
	          return _BoxOfficeActions2.default.terminalConnectionStatusChange(status);
	        },
	        onPaymentStatusChange: function onPaymentStatusChange(_ref2) {
	          var status = _ref2.status;
	          return _BoxOfficeActions2.default.terminalPaymentStatusChange(status);
	        }
	      });
	      this.setState({ terminal: terminal });
	    }
	  }, {
	    key: "onTerminalUnexpectedDisconnect",
	    value: function onTerminalUnexpectedDisconnect() {
	      window.alert("Eventive Terminal unexpectedly disconnected.");
	    }
	  }, {
	    key: "onTerminalConnectionStatusChange",
	    value: function onTerminalConnectionStatusChange(terminalConnectionStatus) {
	      this.setState({ terminalConnectionStatus: terminalConnectionStatus });
	    }
	  }, {
	    key: "onTerminalPaymentStatusChange",
	    value: function onTerminalPaymentStatusChange(terminalPaymentStatus) {
	      this.setState({ terminalPaymentStatus: terminalPaymentStatus });
	    }
	  }, {
	    key: "onReset",
	    value: function onReset(data) {
	      this.setState({
	        orderData: Object.assign({
	          subitems: [],
	          customerType: "standard"
	        }, data),
	        orderInProgress: false,
	        orderSuccess: false,
	        orderErrorMessage: null
	      });
	    }
	  }, {
	    key: "onCancelExternal",
	    value: function onCancelExternal() {
	      this.setState({
	        externalNeedsConfirm: false,
	        orderInProgress: false,
	        orderErrorMessage: "External payment was canceled."
	      });
	    }
	  }, {
	    key: "onUpdateCurrentOrder",
	    value: function onUpdateCurrentOrder(data) {
	      var _this = this;
	
	      var haveItemsChanged = data.subitems && data.subitems.length !== (this.state.orderData.subitems || []).length || data.subitems && data.subitems.some(function (s, i) {
	        return _this.state.orderData.subitems[i].quantity !== s.quantity;
	      });
	
	      var shouldRecheckCoupon = data.coupon_id && !this.state.orderData.coupon_id || data.coupon_code && !this.state.orderData.coupon_code || (this.state.orderData.coupon_id || this.state.orderData.coupon_code) && haveItemsChanged,
	          shouldRecheckPass = data.pass && !this.state.orderData.pass || this.state.orderData.pass && haveItemsChanged;
	
	      if (shouldRecheckCoupon) {
	        data.checking_coupon = true;
	      }
	
	      if (shouldRecheckPass) {
	        data.checking_pass = true;
	      }
	
	      // Inject service fee at end if necessary
	      var autoServiceFee = _EventBucketStore2.default.getEventBucketById(this.state.orderData.event_bucket).box_office_service_fee;
	      if (data.subitems && autoServiceFee) {
	        data.subitems = data.subitems.filter(function (i) {
	          return !(i.service_fee && i.auto);
	        });
	        data.subitems.push({ service_fee: true, auto: true });
	      }
	
	      this.setState({
	        orderData: Object.assign({}, this.state.orderData, data)
	      });
	
	      if (shouldRecheckCoupon) {
	        _BoxOfficeUtil2.default.testCoupon(_UserStore2.default.getState().apiKey, this.state.orderData).then(function (result) {
	          _BoxOfficeActions2.default.updateCurrentOrder({
	            coupon: result,
	            checking_coupon: false
	          });
	        });
	      }
	
	      if (shouldRecheckPass) {
	        _BoxOfficeUtil2.default.testPass(_UserStore2.default.getState().apiKey, this.state.orderData).then(function (result) {
	          _BoxOfficeActions2.default.updateCurrentOrder({
	            pass_data: result,
	            checking_pass: false
	          });
	        });
	      }
	    }
	  }, {
	    key: "onSubmitOrder",
	    value: function () {
	      var _ref3 = _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
	        var _this2 = this;
	
	        var orderData, _ref4, order, secret, cart_id, no_payment_required, result, paymentResult;
	
	        return regeneratorRuntime.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                this.setState({
	                  orderInProgress: true,
	                  orderErrorMessage: null,
	                  lastOrder: null
	                });
	
	                orderData = this.state.orderData;
	
	
	                if (orderData.person) {
	                  orderData.subitems.forEach(function (item) {
	                    if (item.gift_card) {
	                      item.senderName = orderData.person.details.name;
	                      item.senderEmail = orderData.person.details.email;
	                    }
	                  });
	                } else {
	                  orderData.subitems.forEach(function (item) {
	                    if (item.gift_card) {
	                      item.senderName = orderData.name;
	                      item.senderEmail = orderData.email;
	                    }
	                  });
	                }
	
	                // Require external POS to be confirmed
	
	                if (!(orderData.paymentType === "external" && !externalNeedsConfirm)) {
	                  _context.next = 8;
	                  break;
	                }
	
	                this.setState({ externalNeedsConfirm: true });
	                return _context.abrupt("return");
	
	              case 8:
	                this.setState({ externalNeedsConfirm: false });
	
	              case 9:
	                if (!(orderData.paymentType === "terminal")) {
	                  _context.next = 39;
	                  break;
	                }
	
	                _context.prev = 10;
	                _context.next = 13;
	                return _BoxOfficeUtil2.default.prepareOrder(_UserStore2.default.getState().apiKey, orderData);
	
	              case 13:
	                _ref4 = _context.sent;
	                order = _ref4.order;
	                secret = _ref4.secret;
	                cart_id = _ref4.cart_id;
	                no_payment_required = _ref4.no_payment_required;
	
	                if (no_payment_required) {
	                  _context.next = 33;
	                  break;
	                }
	
	                _context.next = 21;
	                return this.state.terminal.collectPaymentMethod(secret);
	
	              case 21:
	                result = _context.sent;
	
	                console.log("Terminal: Payment Method collected, with result:", JSON.stringify(result));
	
	                if (!result.error) {
	                  _context.next = 25;
	                  break;
	                }
	
	                throw new Error(result.error.message);
	
	              case 25:
	                _context.next = 27;
	                return this.state.terminal.processPayment(result.paymentIntent);
	
	              case 27:
	                paymentResult = _context.sent;
	
	                console.log("Terminal: Payment processed, with result:", JSON.stringify(paymentResult));
	
	                if (!paymentResult.error) {
	                  _context.next = 31;
	                  break;
	                }
	
	                throw new Error(paymentResult.error.message);
	
	              case 31:
	                orderData.payment_intent = paymentResult.paymentIntent.id;
	                orderData.cart_id = cart_id;
	
	              case 33:
	                _context.next = 39;
	                break;
	
	              case 35:
	                _context.prev = 35;
	                _context.t0 = _context["catch"](10);
	
	                this.setState({
	                  orderInProgress: false,
	                  orderErrorMessage: _context.t0.message
	                });
	                return _context.abrupt("return");
	
	              case 39:
	
	                _BoxOfficeUtil2.default.submitOrder(_UserStore2.default.getState().apiKey, orderData).then(function (data) {
	                  if (data.orders) {
	                    data = data.orders[0];
	                  }
	
	                  _this2.setState({
	                    lastOrder: data
	                  });
	
	                  var autoPopulate = _EventBucketStore2.default.getEventBucketById(data.event_bucket.id).box_office_auto_populate;
	                  _BoxOfficeActions2.default.reset({
	                    event_bucket: data.event_bucket.id,
	                    subitems: autoPopulate && orderData.subitems.length === 1 && orderData.subitems[0].ticket_bucket ? [{
	                      ticket_bucket: orderData.subitems[0].ticket_bucket,
	                      quantity: 1
	                    }] : []
	                  });
	
	                  window.scrollTo(0, 0); // scroll back to top to restart
	                }).catch(function (e) {
	                  _this2.setState({
	                    orderInProgress: false,
	                    orderErrorMessage: e.message
	                  });
	                });
	
	              case 40:
	              case "end":
	                return _context.stop();
	            }
	          }
	        }, _callee, this, [[10, 35]]);
	      }));
	
	      function onSubmitOrder() {
	        return _ref3.apply(this, arguments);
	      }
	
	      return onSubmitOrder;
	    }()
	  }, {
	    key: "onSetDisplayMode",
	    value: function onSetDisplayMode(displayMode) {
	      this.setState({ displayMode: displayMode });
	    }
	  }, {
	    key: "onUpdatePosConfig",
	    value: function onUpdatePosConfig(config) {
	      this.setState({ posConfig: _extends({}, this.state.posConfig, config) });
	    }
	  }]);
	
	  return BoxOfficeStore;
	}();
	
	var store = _alt2.default.createStore(BoxOfficeStore, "BoxOfficeStore");
	
	if (SHOULD_PERSIST) {
	  store.listen(function (state) {
	    window.localStorage[LS_KEY] = JSON.stringify({
	      displayMode: state.displayMode,
	      posConfig: state.posConfig
	    });
	  });
	}
	
	exports.default = store;
	module.exports = exports["default"];

/***/ }),
/* 2626 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _alt = __webpack_require__(975);
	
	var _alt2 = _interopRequireDefault(_alt);
	
	var _keyBy = __webpack_require__(990);
	
	var _keyBy2 = _interopRequireDefault(_keyBy);
	
	var _moment = __webpack_require__(1021);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _ShiftUtil = __webpack_require__(2627);
	
	var _ShiftUtil2 = _interopRequireDefault(_ShiftUtil);
	
	var _ShiftActions = __webpack_require__(1221);
	
	var _ShiftActions2 = _interopRequireDefault(_ShiftActions);
	
	var _UserStore = __webpack_require__(974);
	
	var _UserStore2 = _interopRequireDefault(_UserStore);
	
	var _config = __webpack_require__(1173);
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ShiftStore = function () {
	  function ShiftStore() {
	    _classCallCheck(this, ShiftStore);
	
	    this.bindActions(_ShiftActions2.default);
	
	    this.state = {
	      isWorking: true,
	      hasFetchedForFirstTime: false,
	      currentShift: null
	    };
	  }
	
	  _createClass(ShiftStore, [{
	    key: "onReset",
	    value: function onReset() {
	      this.setState({
	        isWorking: true,
	        hasFetchedForFirstTime: false,
	        currentShift: null
	      });
	    }
	  }, {
	    key: "onFetchCurrentShift",
	    value: function onFetchCurrentShift() {
	      var _this = this;
	
	      this.setState({ isWorking: true });
	
	      _ShiftUtil2.default.fetchCurrentShift(_UserStore2.default.getState().apiKey).then(function (data) {
	        _this.setState({ currentShift: data });
	      }).catch(function () {
	        /* Fall through - no current shift */
	      }).finally(function () {
	        _this.setState({ isWorking: false, hasFetchedForFirstTime: true });
	      });
	    }
	  }, {
	    key: "onCreateShift",
	    value: function onCreateShift(data) {
	      var _this2 = this;
	
	      this.setState({ isWorking: true });
	
	      _ShiftUtil2.default.createShift(_UserStore2.default.getState().apiKey, data).then(function (shift) {
	        _this2.setState({ currentShift: shift });
	      }).catch(function (e) {
	        alert("Failed to start new shift: " + e.message);
	      }).finally(function () {
	        _this2.setState({ isWorking: false });
	      });
	    }
	  }, {
	    key: "onCloseShift",
	    value: function onCloseShift(data) {
	      var _this3 = this;
	
	      this.setState({ isWorking: true });
	
	      var shiftId = this.state.currentShift.id;
	
	      _ShiftUtil2.default.closeShift(_UserStore2.default.getState().apiKey, data).then(function () {
	        window.open(_config2.default.endpoint + "shifts/" + shiftId + "/receipt.pdf?" + _UserStore2.default.makeApiKeyQueryString() + "&tz=" + _moment2.default.tz.guess()); // open cash out receipt
	        _this3.setState({ currentShift: null });
	      }).catch(function (e) {
	        alert("Failed to close shift: " + e.message);
	      }).finally(function () {
	        _this3.setState({ isWorking: false });
	      });
	    }
	  }]);
	
	  return ShiftStore;
	}();
	
	exports.default = _alt2.default.createStore(ShiftStore, "ShiftStore");
	module.exports = exports["default"];

/***/ }),
/* 2627 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _api = __webpack_require__(1160);
	
	var _api2 = _interopRequireDefault(_api);
	
	var _config = __webpack_require__(1173);
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  fetchCurrentShift: function fetchCurrentShift(apiKey) {
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "GET",
	        endpoint: "shifts/me",
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response);
	      });
	    });
	  },
	  createShift: function createShift(apiKey, data) {
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "POST",
	        endpoint: "shifts",
	        json: data,
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response);
	      });
	    });
	  },
	  closeShift: function closeShift(apiKey, data) {
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "POST",
	        endpoint: "shifts/me/close",
	        json: data,
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response);
	      });
	    });
	  }
	};
	module.exports = exports["default"];

/***/ }),
/* 2628 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _base = __webpack_require__(1755);
	
	var _base2 = _interopRequireDefault(_base);
	
	var _seatPicker = __webpack_require__(2629);
	
	var _seatPicker2 = _interopRequireDefault(_seatPicker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	  var onRequestClose = _ref.onRequestClose;
	  var event = _ref.event;
	  var order = _ref.order;
	  var onSubmit = _ref.onSubmit;
	
	  return React.createElement(
	    _base2.default,
	    { onRequestClose: onRequestClose },
	    React.createElement(
	      "div",
	      { style: { textAlign: "center" } },
	      React.createElement(_seatPicker2.default, {
	        event: event,
	        order: order,
	        onCancel: onRequestClose,
	        updateCurrentOrder: function updateCurrentOrder(_ref2) {
	          var subitems = _ref2.subitems;
	
	          onSubmit(subitems);
	        }
	      })
	    )
	  );
	};
	
	module.exports = exports["default"];

/***/ }),
/* 2629 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styles = __webpack_require__(917);
	
	var _materialUi = __webpack_require__(576);
	
	var _util = __webpack_require__(1183);
	
	var _seatList = __webpack_require__(2630);
	
	var _seatList2 = _interopRequireDefault(_seatList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // SYNC WITH FRONTEND ORDER-SEAT-PICKER
	
	// CHANGED IMPORT PATH FROM SYNC
	
	
	var SEATS_IO_SCRIPT_URL = "https://cdn.seatsio.net/chart.js";
	
	var OrderSeatPicker = function (_React$Component) {
	  _inherits(OrderSeatPicker, _React$Component);
	
	  function OrderSeatPicker(props) {
	    _classCallCheck(this, OrderSeatPicker);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(OrderSeatPicker).call(this, props));
	
	    _this.state = {
	      showBestAvailableSelector: false,
	      editorInstance: null,
	      selectedSeats: [],
	      badSeats: []
	    };
	
	    _this._makePricing = _this._makePricing.bind(_this);
	    _this.createInstance = _this.createInstance.bind(_this);
	    _this.destroyInstance = _this.destroyInstance.bind(_this);
	    _this.submit = _this.submit.bind(_this);
	    return _this;
	  }
	
	  _createClass(OrderSeatPicker, [{
	    key: "_makePricing",
	    value: function _makePricing() {
	      var event = this.props.event;
	      var venue = event.venue;
	
	
	      var pricing = {};
	
	      event.ticket_buckets.forEach(function (b) {
	        if (b.reserved_seating_category) {
	          if (!pricing[b.reserved_seating_category]) {
	            pricing[b.reserved_seating_category] = [];
	          }
	          pricing[b.reserved_seating_category].push({
	            ticketType: b.name,
	            price: b.price,
	            ticket_bucket: b.id
	          });
	
	          if (b.variants) {
	            b.variants.forEach(function (v) {
	              pricing[b.reserved_seating_category].push({
	                ticketType: b.name + " \u2013 " + v.name,
	                price: v.price,
	                ticket_bucket: b.id,
	                variant: v.id
	              });
	            });
	          }
	        }
	      });
	
	      return Object.keys(pricing).map(function (key) {
	        // Only 1 ticket type for this section
	        if (pricing[key].length === 1) {
	          return {
	            category: key,
	            price: pricing[key][0].price,
	            ticket_bucket: pricing[key][0].ticket_bucket
	          };
	        }
	
	        return {
	          category: key,
	          ticketTypes: pricing[key]
	        };
	      });
	    }
	  }, {
	    key: "createInstance",
	    value: function createInstance() {
	      var _this2 = this;
	
	      var _props = this.props;
	      var event = _props.event;
	      var order = _props.order;
	      var venue = event.venue;
	
	
	      if (!window.seatsio || !venue || this.state.editorInstance) {
	        return;
	      }
	
	      var instance = new window.seatsio.SeatingChart({
	        divId: "seatioInject",
	        publicKey: ("de0b391e-8c72-47c5-92d5-ced3b9b4c612"),
	        event: event.id,
	        pricing: this._makePricing(),
	        priceFormatter: function priceFormatter(p) {
	          return (0, _util.formatPrice)(p, /* short */true);
	        },
	        priceLevelsTooltipMessage: "Select ticket type:",
	        reserveOnSelect: false, // this causes too many problems...
	        multiSelectEnabled: true,
	        maxSelectedObjects: this.props.quantityAvailable,
	        baseColor: "#0288d1",
	        selectionValidators: [{ type: "noOrphanSeats", enabled: false }],
	        messages: {
	          maxSelectionReached: "This seat is not available"
	        },
	        onObjectSelected: function onObjectSelected(object, ticketType) {
	          var selectedSeats = _this2.state.selectedSeats;
	
	
	          selectedSeats.push({
	            ticket_bucket: event.ticket_buckets.find(function (b) {
	              return b.reserved_seating_category === object.category.key.toString() && (!ticketType || b.id === ticketType.ticket_bucket);
	            }),
	            seat: object.label,
	            seatmap_object: object,
	            variant: ticketType ? ticketType.variant : undefined
	          });
	
	          _this2.setState({ selectedSeats: selectedSeats }, function () {
	            if (_this2.seatList) {
	              _this2.seatList.scrollIntoView();
	            }
	          });
	        },
	        onObjectDeselected: function onObjectDeselected(object, ticketType) {
	          var selectedSeats = _this2.state.selectedSeats;
	
	          selectedSeats.splice(_this2.state.selectedSeats.findIndex(function (s) {
	            return s.seat === object.label;
	          }), 1);
	          _this2.setState({ selectedSeats: selectedSeats });
	        },
	        onSelectedObjectBooked: function onSelectedObjectBooked(object, ticketType) {
	          _this2.setState({
	            badSeats: _this2.state.badSeats.concat(object.label)
	          });
	        },
	        onScrolledOutOfBoundsVertically: function onScrolledOutOfBoundsVertically(amount) {
	          // This is hacky - basically trasmit the scroll of the seatmap --> overlay,
	          // to help for scrolling on mobile.
	          var roots = document.querySelectorAll("div > [data-reactroot]");
	          roots[roots.length - 1].scrollTop += amount;
	        },
	        objectIcon: function objectIcon(object) {
	          if (object.selected) {
	            return "check";
	          }
	          return null;
	        },
	        onChartRendered: function onChartRendered() {
	          // Re-select seats if specified in the order
	          var currentSeats = order.subitems.reduce(function (all, s) {
	            return all.concat(s.seats.map(function (id) {
	              // Determine the proper variant selected - note this is a bit hacky, since we have to pass in
	              // a string key for the variant, so there's some backwardsness to generate the right key.
	              var ticketBucket = event.ticket_buckets.find(function (b) {
	                return b.id === s.ticket_bucket;
	              });
	              var ticketType = ticketBucket.variants.length ? s.variant ? ticketBucket.name + " \u2013 " + ticketBucket.variants.find(function (v) {
	                return v.id === s.variant;
	              }).name : "" + ticketBucket.name : undefined;
	              return {
	                id: id,
	                ticketType: ticketType
	              };
	            }) || []);
	          }, []);
	          if (currentSeats.length) {
	            instance.selectObjects(currentSeats);
	          }
	        }
	      });
	
	      this.setState({
	        editorInstance: instance
	      });
	
	      instance.render();
	    }
	  }, {
	    key: "destroyInstance",
	    value: function destroyInstance() {
	      document.getElementById("seatioInject").innerHTML = "";
	      window.seatsio.removeFromArray(this.state.editorInstance, window.seatsio.charts);
	    }
	  }, {
	    key: "submit",
	    value: function submit() {
	      var ticketBuckets = this.state.selectedSeats.reduce(function (byBucket, seat) {
	        var key = seat.ticket_bucket.id + "-" + (seat.variant || "");
	        if (byBucket[key]) {
	          byBucket[key].push(seat.seat);
	        } else {
	          byBucket[key] = [seat.seat];
	        }
	        return byBucket;
	      }, {});
	
	      this.props.updateCurrentOrder({
	        seats_confirmed: true,
	        subitems: Object.entries(ticketBuckets).map(function (_ref) {
	          var _ref2 = _slicedToArray(_ref, 2);
	
	          var identifier = _ref2[0];
	          var seats = _ref2[1];
	
	          var _identifier$split = identifier.split("-");
	
	          var _identifier$split2 = _slicedToArray(_identifier$split, 2);
	
	          var id = _identifier$split2[0];
	          var variant = _identifier$split2[1];
	
	          return {
	            ticket_bucket: id,
	            variant: variant,
	            quantity: seats.length,
	            seats: seats
	          };
	        })
	      });
	    }
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      if (!document.querySelector("script[src=\"" + SEATS_IO_SCRIPT_URL + "\"]")) {
	        var script = document.createElement("script");
	        script.type = "text/javascript";
	        script.src = SEATS_IO_SCRIPT_URL;
	        script.onload = this.createInstance;
	        document.body.appendChild(script);
	      }
	      this.createInstance();
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      if (this.state.editorInstance) {
	        this.destroyInstance();
	      }
	    }
	  }, {
	    key: "getStyles",
	    value: function getStyles() {
	      return {
	        error: {
	          color: "#fff",
	          backgroundColor: _styles.colors.red600,
	          padding: 10
	        },
	        inner: {
	          width: "100%",
	          height: 400,
	          position: "relative",
	          marginBottom: 16
	        },
	        innerBestAvailableShown: {
	          display: "none"
	        },
	        actions: {
	          marginTop: 20
	        }
	      };
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this3 = this;
	
	      var styles = this.getStyles(),
	          currentBadTickets = this.state.selectedSeats.filter(function (s) {
	        return _this3.state.badSeats.indexOf(s.seat) !== -1;
	      });
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        currentBadTickets.length ? _react2.default.createElement(
	          "div",
	          { style: styles.error },
	          _react2.default.createElement(
	            "div",
	            null,
	            "Another customer has reserved the following seat",
	            currentBadTickets.length !== 1 ? "s" : "",
	            ":",
	            " ",
	            _react2.default.createElement(
	              "strong",
	              null,
	              currentBadTickets.map(function (t) {
	                return t.seat;
	              }).join(",")
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            null,
	            "Please remove ",
	            currentBadTickets.length !== 1 ? "them" : "it",
	            " ",
	            "from your purchase before continuing."
	          )
	        ) : null,
	        this.state.showBestAvailableSelector ? _react2.default.createElement(
	          "div",
	          null,
	          "What are you looking for?"
	        ) : null,
	        _react2.default.createElement("div", {
	          id: "seatioInject",
	          style: Object.assign({}, styles.inner, this.state.showBestAvailableSelector && styles.innerBestAvailableShown)
	        }),
	        _react2.default.createElement(_seatList2.default, {
	          containerRef: function containerRef(r) {
	            _this3.seatList = r;
	          },
	          seats: this.state.selectedSeats,
	          event: this.props.event,
	          onRemoveSeat: function onRemoveSeat(id) {
	            return _this3.state.editorInstance.deselectObjects([id]);
	          }
	        }),
	        _react2.default.createElement(
	          "div",
	          { style: styles.actions },
	          _react2.default.createElement(_materialUi.FlatButton, {
	            label: "Cancel",
	            onClick: function onClick() {
	              _this3.props.onCancel();
	            },
	            style: { float: "left" }
	          }),
	          _react2.default.createElement(_materialUi.RaisedButton, {
	            label: "Continue (" + this.state.selectedSeats.length + " seat" + (this.state.selectedSeats.length === 1 ? "" : "s") + ")",
	            primary: true,
	            disabled: this.state.selectedSeats.length === 0 || currentBadTickets.length > 0,
	            onClick: this.submit,
	            style: { float: "right" }
	          })
	        )
	      );
	    }
	  }]);
	
	  return OrderSeatPicker;
	}(_react2.default.Component);
	
	exports.default = OrderSeatPicker;
	module.exports = exports["default"];

/***/ }),
/* 2630 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _util = __webpack_require__(1183);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// SYNC WITH FRONTEND ORDER-SEAT-LIST
	
	var styles = {
	  container: {
	    display: "flex",
	    flexWrap: "wrap",
	    margin: "0 -5px -5px",
	    justifyContent: "center"
	  },
	  seat: {
	    border: "1px solid #ccc",
	    padding: 10,
	    margin: 5,
	    position: "relative",
	    flex: 1,
	    width: "100%",
	    boxSizing: "border-box"
	  },
	  largeSeat: {
	    flex: 1,
	    minWidth: "calc(25% - 10px)",
	    maxWidth: "calc(25% - 10px)"
	  },
	  delete: {
	    fontWeight: "bold",
	    position: "absolute",
	    top: 0,
	    right: 5,
	    cursor: "pointer",
	    fontSize: "1.5em"
	  },
	  label: {
	    fontSize: "1.5em",
	    fontWeight: "bold"
	  },
	  ticket_bucket: {},
	  price: {
	    color: "#9e9e9e",
	    marginLeft: 3
	  }
	};
	
	function _sortSeats(a, b) {
	  // sort by section/parent/own (i.e. Choir - A - 2)
	  var sectionDelta = (a.seatmap_object.labels.section || "").localeCompare(b.seatmap_object.labels.section || "");
	  if (sectionDelta !== 0) {
	    return sectionDelta;
	  }
	  var parentDelta = (a.seatmap_object.labels.parent || "").localeCompare(b.seatmap_object.labels.parent || "");
	  if (parentDelta !== 0) {
	    return parentDelta;
	  }
	  var ownDelta = a.seatmap_object.labels.own - b.seatmap_object.labels.own;
	  return ownDelta;
	}
	
	var OrderSeatList = function OrderSeatList(_ref, _ref2) {
	  var seats = _ref.seats;
	  var event = _ref.event;
	  var onRemoveSeat = _ref.onRemoveSeat;
	  var containerRef = _ref.containerRef;
	  var isLarge = _ref2.isLarge;
	
	  return _react2.default.createElement(
	    "div",
	    { style: styles.container, ref: containerRef },
	    seats.sort(_sortSeats).map(function (seat) {
	      var variant = seat.variant ? seat.ticket_bucket.variants.find(function (v) {
	        return v.id === seat.variant;
	      }) : null;
	      return _react2.default.createElement(
	        "div",
	        {
	          key: "" + (seat.seatmap_object.uuid || seat.seat) + seat.seatmap_object.numSelected,
	          style: Object.assign({}, styles.seat, isLarge && styles.largeSeat, {
	            borderLeft: "5px solid " + seat.seatmap_object.category.color
	          })
	        },
	        onRemoveSeat ? _react2.default.createElement(
	          "div",
	          {
	            style: styles.delete,
	            onClick: function onClick() {
	              return onRemoveSeat(seat.seat);
	            }
	          },
	          "\xD7"
	        ) : null,
	        _react2.default.createElement(
	          "div",
	          { style: styles.label },
	          seat.seat
	        ),
	        _react2.default.createElement(
	          "div",
	          { style: styles.ticket_bucket },
	          seat.ticket_bucket.name,
	          " ",
	          variant ? "\u2013 " + variant.name + " " : "",
	          _react2.default.createElement(
	            "span",
	            { style: styles.price },
	            "(",
	            (0, _util.formatPrice)(variant ? variant.price : seat.ticket_bucket.price,
	            /*short*/true),
	            ")"
	          )
	        )
	      );
	    })
	  );
	};
	
	OrderSeatList.contextTypes = {
	  isLarge: _react2.default.PropTypes.bool
	};
	
	exports.default = OrderSeatList;
	module.exports = exports["default"];

/***/ }),
/* 2631 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _moment = __webpack_require__(1021);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _reactRouter = __webpack_require__(486);
	
	var _materialUi = __webpack_require__(576);
	
	var _checkCircle = __webpack_require__(877);
	
	var _checkCircle2 = _interopRequireDefault(_checkCircle);
	
	var _colors = __webpack_require__(821);
	
	var _config = __webpack_require__(1173);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _util = __webpack_require__(1183);
	
	var _linkLike = __webpack_require__(973);
	
	var _linkLike2 = _interopRequireDefault(_linkLike);
	
	var _UserStore = __webpack_require__(974);
	
	var _UserStore2 = _interopRequireDefault(_UserStore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CONTAINER_STYLE = {
	  border: "1px solid #0288d1",
	  padding: 10,
	  marginBottom: 10,
	  textAlign: "center"
	};
	
	var BoxOfficeLastOrder = function (_React$Component) {
	  _inherits(BoxOfficeLastOrder, _React$Component);
	
	  function BoxOfficeLastOrder(props) {
	    _classCallCheck(this, BoxOfficeLastOrder);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(BoxOfficeLastOrder).call(this, props));
	
	    _this.state = {
	      showPopover: false
	    };
	
	    _this._closePopover = _this._closePopover.bind(_this);
	    return _this;
	  }
	
	  _createClass(BoxOfficeLastOrder, [{
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(newProps) {
	      var _this2 = this;
	
	      if (newProps.lastOrder && newProps.lastOrder !== this.props.lastOrder) {
	        clearTimeout(this.timeout);
	        this.setState({ showPopover: true }, function () {
	          _this2.timeout = setTimeout(_this2._closePopover, 3500);
	        });
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      clearTimeout(this.timeout);
	    }
	  }, {
	    key: "_closePopover",
	    value: function _closePopover() {
	      this.setState({ showPopover: false });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _props = this.props;
	      var lastOrder = _props.lastOrder;
	      var repeatLastOrder = _props.repeatLastOrder;
	      var showPopover = this.state.showPopover;
	
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          _materialUi.Dialog,
	          {
	            open: showPopover && !!lastOrder,
	            onRequestClose: this._closePopover
	          },
	          lastOrder ? _react2.default.createElement(
	            "div",
	            { style: { cursor: "pointer" }, onClick: this._closePopover },
	            _react2.default.createElement(_checkCircle2.default, {
	              color: _colors.green500,
	              style: {
	                display: "block",
	                width: 75,
	                height: 75,
	                margin: "0 auto 0.5em"
	              }
	            }),
	            _react2.default.createElement(
	              "div",
	              {
	                style: {
	                  fontSize: "1.25em",
	                  textAlign: "center",
	                  lineHeight: 1.5
	                }
	              },
	              "Order placed successfully.",
	              _react2.default.createElement("br", null),
	              (0, _util.formatPrice)(lastOrder.purchase_price),
	              " \u2022",
	              " ",
	              (0, _moment2.default)(lastOrder.created_at).format("LLLL")
	            )
	          ) : null
	        ),
	        lastOrder ? _react2.default.createElement(
	          "div",
	          { style: CONTAINER_STYLE },
	          _react2.default.createElement(
	            "span",
	            null,
	            "Last order:",
	            " ",
	            _react2.default.createElement(
	              "strong",
	              null,
	              (0, _util.formatPrice)(lastOrder.purchase_price)
	            ),
	            " \u2022",
	            " ",
	            (0, _moment2.default)(lastOrder.created_at).format("LLLL"),
	            lastOrder.tickets.length ? _react2.default.createElement(
	              "span",
	              null,
	              " ",
	              "\u2022",
	              " ",
	              _react2.default.createElement(
	                "a",
	                {
	                  href: _config2.default.endpoint + lastOrder.order_tickets_pdf_path + "?via_box_office=true",
	                  target: "_blank"
	                },
	                "Open tickets PDF"
	              )
	            ) : null,
	            lastOrder.passes.length ? _react2.default.createElement(
	              "span",
	              null,
	              " ",
	              "\u2022",
	              " ",
	              _react2.default.createElement(
	                "a",
	                {
	                  href: _config2.default.endpoint + ("passes/labels.pdf?" + _UserStore2.default.makeApiKeyQueryString() + "&conditions=" + JSON.stringify({ _id: { $in: lastOrder.passes.map(function (p) {
	                        return p.id;
	                      }) } })),
	                  target: "_blank"
	                },
	                "Open pass labels PDF"
	              )
	            ) : null,
	            _react2.default.createElement(
	              "span",
	              null,
	              " ",
	              "\u2022",
	              " ",
	              _react2.default.createElement(
	                "a",
	                {
	                  href: _config2.default.endpoint + ("orders/" + lastOrder.id + "/receipt.pdf"),
	                  target: "_blank"
	                },
	                "Open receipt PDF"
	              )
	            ),
	            _react2.default.createElement(
	              "span",
	              null,
	              " ",
	              "\u2022\xA0",
	              _react2.default.createElement(
	                _reactRouter.Link,
	                {
	                  to: "/event_buckets/" + lastOrder.event_bucket.id + "/orders/" + lastOrder.id
	                },
	                "View order"
	              )
	            ),
	            _react2.default.createElement(
	              "span",
	              null,
	              " ",
	              "\u2022\xA0",
	              _react2.default.createElement(
	                _linkLike2.default,
	                { onTouchTap: repeatLastOrder },
	                "Repeat order"
	              )
	            )
	          )
	        ) : null
	      );
	    }
	  }]);
	
	  return BoxOfficeLastOrder;
	}(_react2.default.Component);
	
	exports.default = BoxOfficeLastOrder;
	module.exports = exports["default"];

/***/ }),
/* 2632 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _materialUi = __webpack_require__(576);
	
	var _Table = __webpack_require__(892);
	
	var _util = __webpack_require__(1183);
	
	var util = _interopRequireWildcard(_util);
	
	var _infoTooltip = __webpack_require__(2633);
	
	var _infoTooltip2 = _interopRequireDefault(_infoTooltip);
	
	var _quantityEditor = __webpack_require__(2191);
	
	var _quantityEditor2 = _interopRequireDefault(_quantityEditor);
	
	var _currencyField = __webpack_require__(1747);
	
	var _currencyField2 = _interopRequireDefault(_currencyField);
	
	var _linkLike = __webpack_require__(973);
	
	var _linkLike2 = _interopRequireDefault(_linkLike);
	
	var _boxOfficeSubitemTableAddItemColumn = __webpack_require__(2634);
	
	var _boxOfficeSubitemTableAddItemColumn2 = _interopRequireDefault(_boxOfficeSubitemTableAddItemColumn);
	
	var _boxOfficeSubitemTablePosPicker = __webpack_require__(2635);
	
	var _boxOfficeSubitemTablePosPicker2 = _interopRequireDefault(_boxOfficeSubitemTablePosPicker);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BoxOfficeSubitemTable = function (_React$Component) {
	  _inherits(BoxOfficeSubitemTable, _React$Component);
	
	  function BoxOfficeSubitemTable(props) {
	    _classCallCheck(this, BoxOfficeSubitemTable);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(BoxOfficeSubitemTable).call(this, props));
	
	    _this.updateQuantity = _this.updateQuantity.bind(_this);
	    _this.updatePrice = _this.updatePrice.bind(_this);
	    _this.clearSubitems = _this.clearSubitems.bind(_this);
	    _this.removeSubitem = _this.removeSubitem.bind(_this);
	
	    _this._makeSubitemContent = _this._makeSubitemContent.bind(_this);
	    return _this;
	  }
	
	  _createClass(BoxOfficeSubitemTable, [{
	    key: "updateQuantity",
	    value: function updateQuantity(i, quantity) {
	      var subitems = this.props.orderData.subitems.map(function (a) {
	        return _extends({}, a);
	      });
	      subitems[i].quantity = quantity;
	      this.props.updateCurrentOrder({
	        subitems: subitems
	      });
	    }
	  }, {
	    key: "updatePrice",
	    value: function updatePrice(i, price) {
	      var subitems = this.props.orderData.subitems.map(function (a) {
	        return _extends({}, a);
	      });
	      subitems[i].price = price;
	      this.props.updateCurrentOrder({
	        subitems: subitems
	      });
	    }
	  }, {
	    key: "clearSubitems",
	    value: function clearSubitems() {
	      this.props.updateCurrentOrder({
	        subitems: []
	      });
	    }
	  }, {
	    key: "removeSubitem",
	    value: function removeSubitem(i) {
	      var subitems = this.props.orderData.subitems.map(function (a) {
	        return _extends({}, a);
	      });
	      subitems.splice(i, 1);
	      this.props.updateCurrentOrder({
	        subitems: subitems
	      });
	    }
	  }, {
	    key: "removeCoupon",
	    value: function removeCoupon() {
	      this.props.updateCurrentOrder({
	        coupon_id: null,
	        coupon_code: null,
	        checking_coupon: false,
	        coupon: null
	      });
	    }
	  }, {
	    key: "_makeSubitemContent",
	    value: function _makeSubitemContent(_ref, i, _ref2) {
	      var name = _ref.name;
	      var descriptor = _ref.descriptor;
	      var tooltip = _ref.tooltip;
	      var subname = _ref.subname;
	      var price = _ref.price;
	      var originalPrice = _ref.originalPrice;
	      var variablePrice = _ref.variablePrice;
	      var quantity = _ref.quantity;
	      var fixedQuantity = _ref.fixedQuantity;
	      var noDelete = _ref.noDelete;
	      var tax = _ref.tax;
	      var fee = _ref.fee;
	      var total = _ref.total;
	      var originalTotal = _ref.originalTotal;
	
	      var _this2 = this;
	
	      var isPosMode = _ref2.isPosMode;
	
	      var priceEl = variablePrice ? _react2.default.createElement(_currencyField2.default, {
	        placeholder: "$0.00",
	        value: price,
	        onChange: function onChange(e) {
	          return _this2.updatePrice(i, e.target.value);
	        }
	      }) : originalPrice ? _react2.default.createElement(
	        "span",
	        null,
	        util.formatPrice(price),
	        " ",
	        _react2.default.createElement(
	          "s",
	          null,
	          util.formatPrice(originalPrice)
	        )
	      ) : util.formatPrice(price);
	
	      return {
	        name: _react2.default.createElement(
	          "div",
	          null,
	          subname || descriptor ? _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(
	              "div",
	              { style: { lineHeight: 1, marginBottom: "0.3em" } },
	              name
	            ),
	            _react2.default.createElement(
	              "div",
	              {
	                style: {
	                  fontSize: "0.8em",
	                  lineHeight: 1,
	                  marginBottom: "0.1em"
	                }
	              },
	              descriptor
	            ),
	            _react2.default.createElement(
	              "div",
	              { style: { fontSize: "0.8em", lineHeight: 1 } },
	              subname
	            )
	          ) : name,
	          " ",
	          tooltip ? _react2.default.createElement(_infoTooltip2.default, { text: tooltip }) : null,
	          isPosMode && !variablePrice ? _react2.default.createElement(
	            "div",
	            { style: { lineHeight: 1, marginTop: 3 } },
	            "@ ",
	            priceEl,
	            fee ? _react2.default.createElement(
	              "span",
	              null,
	              " ",
	              "+",
	              " ",
	              util.formatPrice(fee / (typeof quantity === "number" ? quantity : 1)),
	              " ",
	              "fee"
	            ) : null,
	            tax ? _react2.default.createElement(
	              "span",
	              null,
	              " ",
	              "+",
	              " ",
	              util.formatPrice(tax / (typeof quantity === "number" ? quantity : 1)),
	              " ",
	              "tax"
	            ) : null
	          ) : null
	        ),
	        price: priceEl,
	        quantity: isPosMode && variablePrice ? priceEl : variablePrice ? 1 : fixedQuantity ? quantity : _react2.default.createElement(_quantityEditor2.default, {
	          style: { marginLeft: -16 },
	          quantity: quantity,
	          updateQuantity: this.updateQuantity.bind(this, i),
	          min: isPosMode ? 0 : 1
	        }),
	        tax: util.formatPrice(tax),
	        fee: util.formatPrice(fee),
	        total: originalTotal ? _react2.default.createElement(
	          "span",
	          null,
	          util.formatPrice(total),
	          " ",
	          _react2.default.createElement(
	            "s",
	            null,
	            util.formatPrice(originalTotal)
	          )
	        ) : util.formatPrice(total),
	        noDelete: noDelete
	      };
	    }
	  }, {
	    key: "getStyles",
	    value: function getStyles() {
	      return {
	        delete: {
	          width: 5,
	          textAlign: "center",
	          fontSize: "1.3em",
	          overflow: "visible"
	        },
	        wrapCell: {
	          whiteSpace: "normal",
	          overflow: "visible"
	        }
	      };
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this3 = this;
	
	      var _props = this.props;
	      var orderData = _props.orderData;
	      var processedData = _props.processedData;
	      var displayMode = _props.displayMode;
	
	
	      var isPosMode = displayMode === "pos";
	
	      if (!orderData.event_bucket) {
	        return null;
	      }
	
	      var styles = this.getStyles();
	
	      var subitemData = processedData.subitems,
	          subitemContent = subitemData.filter(function (i) {
	        return !i.hidden;
	      }).map(function (item, i) {
	        return _this3._makeSubitemContent(item, i, { isPosMode: isPosMode });
	      });
	
	      var originalTotal = processedData.originalTotal;
	      var total = processedData.total;
	
	
	      var hasTax = processedData.subitems.some(function (subitem) {
	        return subitem.tax;
	      });
	      var hasFee = processedData.subitems.some(function (subitem) {
	        return subitem.fee;
	      });
	
	      var couponRow = void 0;
	      if (orderData.checking_coupon) {
	        couponRow = _react2.default.createElement(
	          _Table.TableRow,
	          null,
	          isPosMode ? null : _react2.default.createElement(_Table.TableRowColumn, { style: { width: 5 } }),
	          _react2.default.createElement(
	            _Table.TableRowColumn,
	            { colSpan: isPosMode ? "2" : hasFee ? "4" : "3" },
	            _react2.default.createElement(
	              "i",
	              null,
	              "Applying coupon..."
	            )
	          ),
	          _react2.default.createElement(
	            _Table.TableRowColumn,
	            null,
	            _react2.default.createElement(
	              "strong",
	              null,
	              originalTotal && originalTotal !== total ? _react2.default.createElement(
	                "span",
	                null,
	                util.formatPrice(total),
	                " ",
	                _react2.default.createElement(
	                  "s",
	                  null,
	                  util.formatPrice(originalTotal)
	                )
	              ) : null
	            )
	          )
	        );
	      } else if (orderData.coupon) {
	        couponRow = _react2.default.createElement(
	          _Table.TableRow,
	          null,
	          isPosMode ? null : _react2.default.createElement(
	            _Table.TableRowColumn,
	            { style: styles.delete },
	            _react2.default.createElement(
	              "span",
	              {
	                style: { cursor: "pointer" },
	                onClick: function onClick() {
	                  return _this3.removeCoupon();
	                }
	              },
	              "\xD7"
	            )
	          ),
	          _react2.default.createElement(
	            _Table.TableRowColumn,
	            {
	              style: styles.wrapCell,
	              colSpan: isPosMode ? "2" : hasFee ? "4" : "3"
	            },
	            orderData.coupon.is_applicable ? _react2.default.createElement(
	              "span",
	              null,
	              "Discount applied: ",
	              _react2.default.createElement(
	                "strong",
	                null,
	                orderData.coupon.name
	              ),
	              " (",
	              _react2.default.createElement(
	                _linkLike2.default,
	                { onTouchTap: function onTouchTap() {
	                    return _this3.removeCoupon();
	                  } },
	                "Remove"
	              ),
	              ")"
	            ) : _react2.default.createElement(
	              "span",
	              null,
	              _react2.default.createElement(
	                "strong",
	                null,
	                orderData.coupon.error || orderData.subitems.length > 0 ? "Discount not applicable" : "Discount ready to be applied",
	                ":"
	              ),
	              " ",
	              orderData.coupon.error || (orderData.subitems.length === 0 ? "No items in cart, yet. Why not add some?" : "Unknown error"),
	              " ",
	              "(",
	              _react2.default.createElement(
	                _linkLike2.default,
	                { onTouchTap: function onTouchTap() {
	                    return _this3.removeCoupon();
	                  } },
	                "Remove"
	              ),
	              ")"
	            )
	          ),
	          _react2.default.createElement(
	            _Table.TableRowColumn,
	            null,
	            _react2.default.createElement(
	              "strong",
	              null,
	              originalTotal && originalTotal !== total ? _react2.default.createElement(
	                "span",
	                null,
	                util.formatPrice(total),
	                " ",
	                _react2.default.createElement(
	                  "s",
	                  null,
	                  util.formatPrice(originalTotal)
	                )
	              ) : null
	            )
	          )
	        );
	      }
	
	      var passRow = void 0;
	      if (orderData.checking_pass) {
	        passRow = _react2.default.createElement(
	          _Table.TableRow,
	          null,
	          isPosMode ? null : _react2.default.createElement(_Table.TableRowColumn, { style: { width: 5 } }),
	          _react2.default.createElement(
	            _Table.TableRowColumn,
	            { colSpan: isPosMode ? "2" : "3" },
	            _react2.default.createElement(
	              "i",
	              null,
	              "Applying pass..."
	            )
	          ),
	          _react2.default.createElement(
	            _Table.TableRowColumn,
	            null,
	            _react2.default.createElement(
	              "strong",
	              null,
	              originalTotal && originalTotal !== total ? _react2.default.createElement(
	                "span",
	                null,
	                util.formatPrice(total),
	                " ",
	                _react2.default.createElement(
	                  "s",
	                  null,
	                  util.formatPrice(originalTotal)
	                )
	              ) : null
	            )
	          )
	        );
	      } else if (orderData.pass) {
	        passRow = _react2.default.createElement(
	          _Table.TableRow,
	          null,
	          isPosMode ? null : _react2.default.createElement(_Table.TableRowColumn, { style: { width: 5 } }),
	          _react2.default.createElement(
	            _Table.TableRowColumn,
	            {
	              style: styles.wrapCell,
	              colSpan: isPosMode ? "2" : "3"
	            },
	            _react2.default.createElement(
	              "div",
	              null,
	              _react2.default.createElement(
	                "div",
	                null,
	                _react2.default.createElement(
	                  "span",
	                  null,
	                  "Pass applied: ",
	                  _react2.default.createElement(
	                    "strong",
	                    null,
	                    orderData.pass.name
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                null,
	                [].concat(_toConsumableArray(new Set(orderData.pass_data.subitems.reduce(function (a, i, index) {
	                  return a.concat(i && i.errors ? i.errors.map(function (e) {
	                    return subitemData[index] ? e.replace(/this event/, subitemData[index].name) : e;
	                  }) : []);
	                }, [])))).join("; ")
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _Table.TableRowColumn,
	            null,
	            _react2.default.createElement(
	              "strong",
	              null,
	              originalTotal && originalTotal !== total ? _react2.default.createElement(
	                "span",
	                null,
	                util.formatPrice(total),
	                " ",
	                _react2.default.createElement(
	                  "s",
	                  null,
	                  util.formatPrice(originalTotal)
	                )
	              ) : null
	            )
	          )
	        );
	      }
	
	      var table = _react2.default.createElement(
	        _Table.Table,
	        {
	          selectable: false,
	          wrapperStyle: { overflow: "visible" },
	          style: { overflow: "visible" },
	          bodyStyle: { overflow: "visible" }
	        },
	        _react2.default.createElement(
	          _Table.TableHeader,
	          {
	            displaySelectAll: false,
	            adjustForCheckbox: false,
	            style: { backgroundColor: "#0288d1" }
	          },
	          _react2.default.createElement(
	            _Table.TableRow,
	            { style: { height: 24 }, displayRowCheckbox: false },
	            !isPosMode ? _react2.default.createElement(
	              _Table.TableHeaderColumn,
	              {
	                style: Object.assign({}, styles.delete, { height: 24 })
	              },
	              _react2.default.createElement(
	                "span",
	                {
	                  style: { cursor: "pointer" },
	                  onClick: function onClick() {
	                    return _this3.clearSubitems();
	                  }
	                },
	                "\xD7"
	              )
	            ) : null,
	            _react2.default.createElement(
	              _Table.TableHeaderColumn,
	              { style: { height: 24 } },
	              "Item"
	            ),
	            _react2.default.createElement(
	              _Table.TableHeaderColumn,
	              { style: { height: 24 } },
	              "Quantity"
	            ),
	            !isPosMode ? _react2.default.createElement(
	              _Table.TableHeaderColumn,
	              { style: { height: 24 } },
	              "Price/ea."
	            ) : null,
	            hasTax && !isPosMode ? _react2.default.createElement(
	              _Table.TableHeaderColumn,
	              { style: { height: 24 } },
	              "Tax"
	            ) : null,
	            hasFee && !isPosMode ? _react2.default.createElement(
	              _Table.TableHeaderColumn,
	              { style: { height: 24 } },
	              "Fee"
	            ) : null,
	            _react2.default.createElement(
	              _Table.TableHeaderColumn,
	              { style: { height: 24 } },
	              "Total"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _Table.TableBody,
	          { displayRowCheckbox: false, style: { overflow: "visible" } },
	          subitemContent.map(function (content, i) {
	            return _react2.default.createElement(
	              _Table.TableRow,
	              null,
	              !isPosMode ? _react2.default.createElement(
	                _Table.TableRowColumn,
	                { style: styles.delete },
	                !content.noDelete && _react2.default.createElement(
	                  "span",
	                  {
	                    style: { cursor: "pointer" },
	                    onClick: function onClick() {
	                      return _this3.removeSubitem(i);
	                    }
	                  },
	                  "\xD7"
	                )
	              ) : null,
	              _react2.default.createElement(
	                _Table.TableRowColumn,
	                { style: styles.wrapCell },
	                content.name
	              ),
	              _react2.default.createElement(
	                _Table.TableRowColumn,
	                null,
	                content.quantity
	              ),
	              !isPosMode ? _react2.default.createElement(
	                _Table.TableRowColumn,
	                { style: styles.wrapCell },
	                content.price
	              ) : null,
	              hasTax && !isPosMode ? _react2.default.createElement(
	                _Table.TableRowColumn,
	                { style: styles.wrapCell },
	                content.tax
	              ) : null,
	              hasFee && !isPosMode ? _react2.default.createElement(
	                _Table.TableRowColumn,
	                { style: styles.wrapCell },
	                content.fee
	              ) : null,
	              _react2.default.createElement(
	                _Table.TableRowColumn,
	                { style: styles.wrapCell },
	                _react2.default.createElement(
	                  "div",
	                  {
	                    style: {
	                      display: "flex",
	                      justifyContent: "space-between",
	                      alignItems: "center"
	                    }
	                  },
	                  _react2.default.createElement(
	                    "div",
	                    null,
	                    content.total
	                  ),
	                  isPosMode && !content.noDelete ? _react2.default.createElement(
	                    "div",
	                    {
	                      style: {
	                        cursor: "pointer",
	                        fontSize: 30
	                      },
	                      onClick: function onClick() {
	                        return _this3.removeSubitem(i);
	                      }
	                    },
	                    "\xD7"
	                  ) : null
	                )
	              )
	            );
	          }),
	          subitemContent.length === 0 ?
	          // Filler row to keep the widths correct (to account for 5px wide "x" column)
	          // This ensures $0.00 total is in line with "Total header"
	          _react2.default.createElement(
	            _Table.TableRow,
	            { style: { border: 0, height: 0, padding: 0 } },
	            !isPosMode ? _react2.default.createElement(_Table.TableRowColumn, {
	              style: {
	                width: 5,
	                height: 0,
	                paddingTop: 0,
	                paddingBottom: 0
	              }
	            }) : null,
	            _react2.default.createElement(_Table.TableRowColumn, {
	              style: { height: 0, paddingTop: 0, paddingBottom: 0 },
	              colSpan: isPosMode ? "3" : "4"
	            })
	          ) : null,
	          subitemContent.length === 0 && isPosMode ?
	          // In POS mode, show a placeholder since it's so tall
	          _react2.default.createElement(
	            _Table.TableRow,
	            null,
	            _react2.default.createElement(
	              _Table.TableRowColumn,
	              {
	                style: { textAlign: "center", fontStyle: "italic" },
	                colSpan: "3"
	              },
	              "Nothing in the cart yet \u2013 why not add something?"
	            )
	          ) : null,
	          passRow,
	          couponRow,
	          _react2.default.createElement(
	            _Table.TableRow,
	            { style: { overflow: "visible" } },
	            isPosMode ? _react2.default.createElement(
	              _Table.TableRowColumn,
	              { colSpan: "1" },
	              subitemContent.length ? _react2.default.createElement(_materialUi.FlatButton, {
	                label: "Reset",
	                secondary: true,
	                labelStyle: { padding: "0px 10px" },
	                style: { marginLeft: -10, marginRight: -10 },
	                onClick: function onClick() {
	                  return _this3.clearSubitems();
	                }
	              }) : null
	            ) : _react2.default.createElement(_boxOfficeSubitemTableAddItemColumn2.default, {
	              colSpan: hasTax || hasFee ? "5" : "4",
	              orderData: orderData,
	              updateCurrentOrder: this.props.updateCurrentOrder
	            }),
	            _react2.default.createElement(
	              _Table.TableRowColumn,
	              {
	                style: {
	                  fontWeight: "bold",
	                  fontSize: "2em",
	                  overflow: "visible",
	                  textAlign: isPosMode ? "right" : undefined
	                },
	                colSpan: isPosMode ? "2" : undefined
	              },
	              processedData.groupSalesSize ? _react2.default.createElement(
	                "div",
	                {
	                  style: {
	                    fontSize: "0.5em",
	                    fontWeight: "normal",
	                    marginBottom: "0.25em",
	                    marginTop: "-0.2em"
	                  }
	                },
	                processedData.groupSalesSize,
	                " x",
	                " ",
	                util.formatPrice(processedData.total / processedData.groupSalesSize),
	                " ",
	                "="
	              ) : null,
	              util.formatPrice(total)
	            )
	          )
	        )
	      );
	
	      if (!isPosMode) {
	        return table;
	      }
	
	      return _react2.default.createElement(
	        "div",
	        { style: { display: "flex", alignItems: "stretch", marginTop: 20 } },
	        _react2.default.createElement(
	          "div",
	          {
	            style: {
	              display: "flex",
	              width: "70%",
	              maxWidth: "70%"
	            }
	          },
	          _react2.default.createElement(_boxOfficeSubitemTablePosPicker2.default, {
	            orderData: orderData,
	            updateCurrentOrder: this.props.updateCurrentOrder,
	            posConfig: this.props.posConfig,
	            updatePosConfig: this.props.updatePosConfig
	          })
	        ),
	        _react2.default.createElement(
	          "div",
	          {
	            style: {
	              flex: 1,
	              minWidth: 400
	            }
	          },
	          _react2.default.createElement(
	            "div",
	            {
	              className: "sticky top-24",
	              style: {
	                border: "1px solid #0288d1",
	                borderRadius: 5,
	                overflow: "hidden"
	              }
	            },
	            table
	          )
	        )
	      );
	    }
	  }]);
	
	  return BoxOfficeSubitemTable;
	}(_react2.default.Component);
	
	exports.default = BoxOfficeSubitemTable;
	module.exports = exports["default"];

/***/ }),
/* 2633 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _radium = __webpack_require__(1600);
	
	var _radium2 = _interopRequireDefault(_radium);
	
	var _info = __webpack_require__(1661);
	
	var _info2 = _interopRequireDefault(_info);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ROOT_STYLE = {
	  position: "relative",
	  display: "inline-block",
	  ":hover": {}
	};
	
	var ICON_STYLE = {
	  verticalAlign: -4,
	  color: "rgba(0,0,0,0.4)",
	  height: 16,
	  width: 16,
	  minWidth: 16,
	  marginRight: 4
	};
	
	var TOOLTIP_STYLE = {
	  position: "absolute",
	  fontSize: 10,
	  lineHeight: "22px",
	  padding: "0px 8px",
	  zIndex: 1200,
	  color: "rgb(255, 255, 255)",
	  backgroundColor: "rgb(97, 97, 97)",
	  overflow: "hidden",
	  top: 20,
	  left: 20,
	  opacity: 0,
	  borderRadius: 2,
	  transition: "top 0.1s ease, opacity 0.1s ease",
	  whiteSpace: "nowrap",
	  pointerEvents: "none"
	};
	
	var SHOWN_STYLE = {
	  opacity: 0.9,
	  top: 0,
	  pointerEvents: "auto"
	};
	
	var InfoTooltip = function (_React$Component) {
	  _inherits(InfoTooltip, _React$Component);
	
	  function InfoTooltip() {
	    _classCallCheck(this, InfoTooltip);
	
	    return _possibleConstructorReturn(this, Object.getPrototypeOf(InfoTooltip).apply(this, arguments));
	  }
	
	  _createClass(InfoTooltip, [{
	    key: "render",
	    value: function render() {
	      var text = this.props.text;
	
	
	      return _react2.default.createElement(
	        "div",
	        { key: "root", style: ROOT_STYLE },
	        _react2.default.createElement(_info2.default, { style: ICON_STYLE }),
	        _react2.default.createElement(
	          "div",
	          {
	            style: [TOOLTIP_STYLE, _radium2.default.getState(this.state, "root", ":hover") && SHOWN_STYLE]
	          },
	          text
	        )
	      );
	    }
	  }]);
	
	  return InfoTooltip;
	}(_react2.default.Component);
	
	exports.default = (0, _radium2.default)(InfoTooltip);
	module.exports = exports["default"];

/***/ }),
/* 2634 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _materialUi = __webpack_require__(576);
	
	var _Table = __webpack_require__(892);
	
	var _momentTimezone = __webpack_require__(1185);
	
	var _momentTimezone2 = _interopRequireDefault(_momentTimezone);
	
	var _injectedSelect = __webpack_require__(1874);
	
	var _injectedSelect2 = _interopRequireDefault(_injectedSelect);
	
	var _ItemBucketStore = __webpack_require__(2045);
	
	var _ItemBucketStore2 = _interopRequireDefault(_ItemBucketStore);
	
	var _EventStore = __webpack_require__(2032);
	
	var _EventStore2 = _interopRequireDefault(_EventStore);
	
	var _EventBucketStore = __webpack_require__(1593);
	
	var _EventBucketStore2 = _interopRequireDefault(_EventBucketStore);
	
	var _UserStore = __webpack_require__(974);
	
	var _UserStore2 = _interopRequireDefault(_UserStore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BoxOfficeSubitemTableAddItemColumn = function (_React$Component) {
	  _inherits(BoxOfficeSubitemTableAddItemColumn, _React$Component);
	
	  function BoxOfficeSubitemTableAddItemColumn(props) {
	    _classCallCheck(this, BoxOfficeSubitemTableAddItemColumn);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(BoxOfficeSubitemTableAddItemColumn).call(this, props));
	
	    _this.state = {
	      mode: null, // [null, 'ticket_bucket', 'pass_bucket', 'item_bucket']
	      intermediateId: null
	    };
	
	    _this.submit = _this.submit.bind(_this);
	    _this.intermediateSubmit = _this.intermediateSubmit.bind(_this);
	    return _this;
	  }
	
	  _createClass(BoxOfficeSubitemTableAddItemColumn, [{
	    key: "submit",
	    value: function submit(id) {
	      var _newSubitem;
	
	      if (this.state.mode === "coupon") {
	        this.props.updateCurrentOrder((typeof id === "undefined" ? "undefined" : _typeof(id)) === "object" && id.code ? {
	          coupon_code: id.code
	        } : {
	          coupon_id: id
	        });
	        this.setState({ mode: null });
	        return;
	      }
	
	      // For item bucket / ticket bucket with variant
	      var variantId = void 0;
	      if (this.state.intermediateId && (this.state.mode === "item_bucket" || this.state.mode === "ticket_bucket")) {
	        variantId = id;
	        id = this.state.intermediateId;
	      }
	
	      var subitems = this.props.orderData.subitems.slice();
	
	      var newSubitem = (_newSubitem = {}, _defineProperty(_newSubitem, this.state.mode, id), _defineProperty(_newSubitem, "quantity", 1), _newSubitem);
	
	      if (variantId) {
	        newSubitem.variant = variantId;
	      }
	
	      subitems.push(newSubitem);
	
	      this.props.updateCurrentOrder({
	        subitems: subitems
	      });
	
	      // Reset for next item
	      this.setState({ mode: null, intermediateId: null });
	    }
	  }, {
	    key: "submitGiftCard",
	    value: function submitGiftCard() {
	      this.props.updateCurrentOrder({
	        subitems: this.props.orderData.subitems.concat([{
	          name: "Gift Card",
	          gift_card: true,
	          variable_price: true,
	          price: 0,
	          giftScheduledSend: new Date(),
	          quantity: 1
	        }])
	      });
	
	      this.setState({ mode: null, intermediateId: null });
	    }
	  }, {
	    key: "intermediateSubmit",
	    value: function intermediateSubmit(id) {
	      var _this2 = this;
	
	      if (this.state.mode === "item_bucket") {
	        this.setState({
	          intermediateId: id
	        }, function () {
	          if (id === "gift_card") {
	            _this2.submitGiftCard();
	
	            return;
	          }
	          var itemBucket = _ItemBucketStore2.default.getItemBucketById(id);
	          if (itemBucket.variants.length === 1) {
	            _this2.submit(itemBucket.variants[0].id);
	          }
	        });
	      } else if (this.state.mode === "ticket_bucket") {
	        var ticketBucket = _EventStore2.default.getTicketBucketWithEventById(id);
	        if (ticketBucket.variants.length === 0 || ticketBucket.event.venue && ticketBucket.event.venue.use_reserved_seating // variants will be chosen in seat picker
	        ) {
	            this.submit(id);
	          } else {
	          this.setState({
	            intermediateId: id
	          }, function () {
	            // Note: we don't autosubmit for variants, because there are ALWAYS
	            // at least two options, the original bucket + at least one variant.
	            // if (ticketBucket.variants.length === 1) {
	            //   this.submit(ticketBucket.variants[0].id);
	            // }
	          });
	        }
	      }
	    }
	  }, {
	    key: "_getTicketCount",
	    value: function _getTicketCount(bucket) {
	      return bucket.unlimited ? "unlimited" : Math.max(bucket.quantity_remaining, 0);
	    }
	  }, {
	    key: "_canUseTicket",
	    value: function _canUseTicket(bucket) {
	      if (!bucket.lock_admin_only || _UserStore2.default.hasRole("admin")) return true;
	
	      var requiredRoles = bucket.lock_admin_only_role && bucket.lock_admin_only_role.split(",") || [];
	
	      return _UserStore2.default.hasRole(requiredRoles);
	    }
	  }, {
	    key: "getStyles",
	    value: function getStyles() {
	      return {
	        column: {
	          overflow: "visible"
	        },
	        select: {
	          display: "none",
	          width: 500,
	          maxWidth: "80%",
	          verticalAlign: "middle"
	        },
	        resetButton: {
	          marginLeft: 7,
	          verticalAlign: "middle"
	        },
	        addButton: {
	          marginRight: 7,
	          border: "1px solid",
	          lineHeight: "33px"
	        },
	        addButtonLast: {
	          marginRight: 0
	        },
	        intermediateLabel: {
	          display: "inline-block",
	          flex: 1,
	          marginRight: 15
	        }
	      };
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this3 = this;
	
	      var styles = this.getStyles(),
	          now = new Date();
	
	      // Box office level accounts must enter the exact discount code - no dropdown
	      var requireDiscountCodeEntry = _UserStore2.default.hasRole("box_office");
	
	      var eventBucket = _EventBucketStore2.default.getEventBucketById(this.props.orderData.event_bucket);
	      var excludeOlderEvents = false;
	      if (eventBucket.frontend_config.box_office_performance) {
	        excludeOlderEvents = eventBucket.frontend_config.box_office_performance.exclude_older_events ? true : false;
	      }
	
	      return _react2.default.createElement(
	        _Table.TableRowColumn,
	        { colSpan: this.props.colSpan, style: styles.column },
	        _react2.default.createElement(_injectedSelect2.default, {
	          autoFocus: this.state.mode === "ticket_bucket",
	          autosize: false,
	          style: Object.assign({}, styles.select, this.state.mode === "ticket_bucket" && !this.state.intermediateId && { display: "inline-block" }),
	          placeholder: "Select ticket bucket",
	          type: "ticket_buckets",
	          excludeOlder: excludeOlderEvents,
	          labelToFilterString: function labelToFilterString(t) {
	            return t.event.name + " - " + t.name;
	          },
	          labelFormatter: function labelFormatter(t) {
	            var count = _this3._getTicketCount(t);
	            return _react2.default.createElement(
	              "div",
	              null,
	              _react2.default.createElement(
	                "div",
	                null,
	                t.event.is_virtual && t.event.end_time && Date.now() > new Date(t.event.end_time) ? "[ENDED] " : count === 0 ? "[SOLD OUT] " : "",
	                _react2.default.createElement(
	                  "span",
	                  { style: { fontWeight: "bold" } },
	                  t.event.name,
	                  " \u2013 ",
	                  t.name
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                null,
	                t.event.is_virtual ? "Virtual Screening" : t.event.venue && t.event.venue.name ? t.event.venue.name : "No Venue",
	                " ",
	                t.event.start_time ? "\u2013 " + _momentTimezone2.default.tz(t.event.start_time, t.event.timezone).format("ddd, lll") + " " : "",
	                "\u2013 ",
	                count,
	                " tickets remaining"
	              )
	            );
	          },
	          isDisabledFunction: function isDisabledFunction(t) {
	            return _this3._getTicketCount(t) === 0 || !_this3._canUseTicket(t);
	          },
	          eventBucketId: this.props.orderData.event_bucket,
	          sortFunction: function sortFunction(a, b) {
	            if (a.rawValue.event.id === b.rawValue.event.id) {
	              var aIndex = a.rawValue.event.ticket_buckets.findIndex(function (bucket) {
	                return bucket.id === a.rawValue.id;
	              }),
	                  bIndex = b.rawValue.event.ticket_buckets.findIndex(function (bucket) {
	                return bucket.id === b.rawValue.id;
	              });
	              return aIndex - bIndex;
	            }
	
	            // 20 min buffer
	            var aDate = (0, _momentTimezone2.default)(a.rawValue.event.start_time).add(20, "minutes"),
	                bDate = (0, _momentTimezone2.default)(b.rawValue.event.start_time).add(20, "minutes");
	
	            if (aDate > now && now > bDate) {
	              return -1;
	            } else if (bDate > now && now > aDate) {
	              return 1;
	            }
	
	            return aDate - bDate;
	          },
	          onChange: this.intermediateSubmit
	        }),
	        this.state.mode === "ticket_bucket" && this.state.intermediateId ? _react2.default.createElement(
	          "div",
	          {
	            style: Object.assign({}, styles.select, _defineProperty({
	              display: "flex"
	            }, "display", "inline-block"))
	          },
	          _react2.default.createElement(
	            "div",
	            { style: styles.intermediateLabel },
	            _EventStore2.default.getTicketBucketWithEventById(this.state.intermediateId).event.name
	          ),
	          _react2.default.createElement(_injectedSelect2.default, {
	            autoFocus: true,
	            autosize: false,
	            style: Object.assign({ verticalAlign: "middle", display: "inline-block" }, {}),
	            placeholder: "Select variant",
	            type: "ticket_bucket.variants",
	            labelFormatter: function labelFormatter(p) {
	              return "" + p.name;
	            },
	            eventBucketId: this.props.orderData.event_bucket,
	            ticketBucketId: this.state.intermediateId,
	            focus: this.state.mode === "ticket_bucket" && this.state.intermediateId && true,
	            injectOptions: [{
	              label: _EventStore2.default.getTicketBucketWithEventById(this.state.intermediateId).name,
	              value: null
	            }],
	            onChange: this.submit
	          })
	        ) : null,
	        _react2.default.createElement(_injectedSelect2.default, {
	          autoFocus: this.state.mode === "pass_bucket",
	          autosize: false,
	          style: Object.assign({}, styles.select, this.state.mode === "pass_bucket" && { display: "inline-block" }),
	          placeholder: "Select pass bucket",
	          type: "pass_buckets",
	          filterBy: function filterBy(p) {
	            return p.visible_in_box_office;
	          },
	          labelToFilterString: function labelToFilterString(p) {
	            return "" + p.name;
	          },
	          labelFormatter: function labelFormatter(p) {
	            return _react2.default.createElement(
	              "div",
	              null,
	              _react2.default.createElement(
	                "div",
	                null,
	                _react2.default.createElement(
	                  "span",
	                  { style: { fontWeight: "bold" } },
	                  p.name
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                null,
	                p.unlimited ? "Unlimited passes remaining" : p.quantity - p.quantity_sold !== 1 ? p.quantity - p.quantity_sold + " passes remaining" : "1 pass remaining"
	              )
	            );
	          },
	          isDisabledFunction: function isDisabledFunction(p) {
	            return p.unlimited ? false : p.quantity - p.quantity_sold <= 0;
	          },
	          sortDisabledToEnd: true,
	          eventBucketId: this.props.orderData.event_bucket,
	          sortFunction: function sortFunction(a, b) {
	            return a.rawValue.name.localeCompare(b.rawValue.name);
	          },
	          onChange: this.submit
	        }),
	        _react2.default.createElement(_injectedSelect2.default, {
	          autoFocus: this.state.mode === "memberships",
	          autosize: false,
	          style: Object.assign({}, styles.select, this.state.mode === "memberships" && { display: "inline-block" }),
	          placeholder: "Select membership",
	          type: "memberships",
	          filterBy: function filterBy(p) {
	            return p.visible_in_box_office;
	          },
	          labelToFilterString: function labelToFilterString(p) {
	            return "" + p.name;
	          },
	          labelFormatter: function labelFormatter(p) {
	            return _react2.default.createElement(
	              "div",
	              null,
	              _react2.default.createElement(
	                "div",
	                null,
	                _react2.default.createElement(
	                  "span",
	                  { style: { fontWeight: "bold" } },
	                  p.name
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                null,
	                p.unlimited ? "Unlimited memberships remaining" : p.quantity - p.quantity_sold !== 1 ? p.quantity - p.quantity_sold + " memberships remaining" : "1 membership remaining"
	              )
	            );
	          },
	          isDisabledFunction: function isDisabledFunction(p) {
	            return p.unlimited ? false : p.quantity - p.quantity_sold <= 0;
	          },
	          sortDisabledToEnd: true,
	          eventBucketId: this.props.orderData.event_bucket,
	          sortFunction: function sortFunction(a, b) {
	            return a.rawValue.name.localeCompare(b.rawValue.name);
	          },
	          onChange: this.submit
	        }),
	        _react2.default.createElement(_injectedSelect2.default, {
	          autoFocus: this.state.mode === "item_bucket",
	          autosize: false,
	          style: Object.assign({}, styles.select, this.state.mode === "item_bucket" && !this.state.intermediateId && { display: "inline-block" }),
	          placeholder: "Select item bucket",
	          type: "item_buckets",
	          labelFormatter: function labelFormatter(p, disabled) {
	            return "" + (disabled ? "[SOLD OUT] " : "") + p.name;
	          },
	          eventBucketId: this.props.orderData.event_bucket,
	          isDisabledFunction: function isDisabledFunction(b) {
	            return b.variants.every(function (v) {
	              return _this3._getTicketCount(v) === 0;
	            });
	          },
	          sortDisabledToEnd: true,
	          sortFunction: function sortFunction(a, b) {
	            return a.label.localeCompare(b.label);
	          },
	          onChange: this.intermediateSubmit,
	          injectOptions: eventBucket.frontend_config.gift_cards_enabled && this.props.orderData.customerType === "standard" ? [{ label: "Gift Card", value: "gift_card" }] : []
	        }),
	        this.state.mode === "item_bucket" && this.state.intermediateId ? _react2.default.createElement(
	          "div",
	          {
	            style: Object.assign({}, styles.select, _defineProperty({
	              display: "flex"
	            }, "display", "inline-block"))
	          },
	          _react2.default.createElement(
	            "div",
	            { style: styles.intermediateLabel },
	            this.state.intermediateId === "gift_card" ? "Gift Card" : _ItemBucketStore2.default.getItemBucketById(this.state.intermediateId).name
	          ),
	          _react2.default.createElement(_injectedSelect2.default, {
	            autoFocus: true,
	            autosize: false,
	            style: Object.assign({ verticalAlign: "middle", display: "inline-block" }, {}),
	            placeholder: "Select variant",
	            type: "item_bucket.variants",
	            labelFormatter: function labelFormatter(p, disabled) {
	              return "" + (disabled ? "[SOLD OUT] " : "") + p.name;
	            },
	            eventBucketId: this.props.orderData.event_bucket,
	            itemBucketId: this.state.intermediateId,
	            sortFunction: function sortFunction(a, b) {
	              return a.label.localeCompare(b.label);
	            },
	            focus: this.state.mode === "item_bucket" && this.state.intermediateId && true,
	            isDisabledFunction: function isDisabledFunction(v) {
	              return _this3._getTicketCount(v) === 0;
	            },
	            sortDisabledToEnd: true,
	            onChange: this.submit
	          })
	        ) : null,
	        _react2.default.createElement(_injectedSelect2.default, {
	          autoFocus: this.state.mode === "coupon",
	          autosize: false,
	          style: Object.assign({}, styles.select, this.state.mode === "coupon" && { display: "inline-block" }),
	          placeholder: requireDiscountCodeEntry ? "Type discount code (case-sensitive)" : "Select discount, " + (eventBucket.frontend_config.gift_cards_enabled ? "type discount code, or type gift card code" : "or type discount code"),
	          type: requireDiscountCodeEntry ? null : "coupons",
	          labelFormatter: function labelFormatter(p) {
	            return p.multicode ? p.name + " - type code to apply discount" : "" + p.name;
	          },
	          isDisabledFunction: function isDisabledFunction(p) {
	            if (p.multicode) {
	              return true;
	            } else {
	              return false;
	            }
	          },
	          eventBucketId: this.props.orderData.event_bucket,
	          sortFunction: function sortFunction(a, b) {
	            return a.label.localeCompare(b.label);
	          },
	          onChange: this.submit,
	          creatable: true,
	          creatablePromptText: function creatablePromptText(s) {
	            return "Use discount code \"" + s + "\"";
	          },
	          onCreateSelect: function onCreateSelect(o) {
	            return _this3.submit({ code: o.value });
	          }
	        }),
	        this.state.mode ? _react2.default.createElement(_materialUi.FlatButton, {
	          label: "Back",
	          onClick: function onClick() {
	            return _this3.setState({ mode: null, intermediateId: null });
	          },
	          style: styles.resetButton
	        }) : _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement(_materialUi.FlatButton, {
	            label: "+ Ticket",
	            primary: true,
	            onClick: function onClick() {
	              return _this3.setState({ mode: "ticket_bucket" });
	            },
	            style: styles.addButton
	          }),
	          _react2.default.createElement(_materialUi.FlatButton, {
	            label: "+ Pass",
	            primary: true,
	            onClick: function onClick() {
	              return _this3.setState({ mode: "pass_bucket" });
	            },
	            style: styles.addButton
	          }),
	          eventBucket.frontend_config.memberships_enabled && _react2.default.createElement(_materialUi.FlatButton, {
	            label: "+ Membership",
	            primary: true,
	            onClick: function onClick() {
	              return _this3.setState({ mode: "memberships" });
	            },
	            style: styles.addButton
	          }),
	          _react2.default.createElement(_materialUi.FlatButton, {
	            label: "+ Item",
	            primary: true,
	            onClick: function onClick() {
	              return _this3.setState({ mode: "item_bucket" });
	            },
	            style: styles.addButton
	          }),
	          !this.props.orderData.coupon ? _react2.default.createElement(_materialUi.FlatButton, {
	            label: eventBucket.frontend_config.gift_cards_enabled ? "+ Discount / GC" : "+ Discount",
	            primary: true,
	            onClick: function onClick() {
	              return _this3.setState({ mode: "coupon" });
	            },
	            style: Object.assign({}, styles.addButton, styles.addButtonLast)
	          }) : null
	        )
	      );
	    }
	  }]);
	
	  return BoxOfficeSubitemTableAddItemColumn;
	}(_react2.default.Component);
	
	exports.default = BoxOfficeSubitemTableAddItemColumn;
	module.exports = exports["default"];

/***/ }),
/* 2635 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(958);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _materialUi = __webpack_require__(576);
	
	var _Popover = __webpack_require__(860);
	
	var _reactSelect = __webpack_require__(953);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	var _momentTimezone = __webpack_require__(1185);
	
	var _momentTimezone2 = _interopRequireDefault(_momentTimezone);
	
	var _colorHash = __webpack_require__(2636);
	
	var _colorHash2 = _interopRequireDefault(_colorHash);
	
	var _groupBy = __webpack_require__(2637);
	
	var _groupBy2 = _interopRequireDefault(_groupBy);
	
	var _util = __webpack_require__(1183);
	
	var util = _interopRequireWildcard(_util);
	
	var _injectedSelect = __webpack_require__(1874);
	
	var _injectedSelect2 = _interopRequireDefault(_injectedSelect);
	
	var _workingIndicator = __webpack_require__(1664);
	
	var _workingIndicator2 = _interopRequireDefault(_workingIndicator);
	
	var _connectToStores = __webpack_require__(1226);
	
	var _connectToStores2 = _interopRequireDefault(_connectToStores);
	
	var _EventActions = __webpack_require__(2031);
	
	var _EventActions2 = _interopRequireDefault(_EventActions);
	
	var _ItemBucketActions = __webpack_require__(2044);
	
	var _ItemBucketActions2 = _interopRequireDefault(_ItemBucketActions);
	
	var _ItemBucketStore = __webpack_require__(2045);
	
	var _ItemBucketStore2 = _interopRequireDefault(_ItemBucketStore);
	
	var _EventStore = __webpack_require__(2032);
	
	var _EventStore2 = _interopRequireDefault(_EventStore);
	
	var _EventBucketStore = __webpack_require__(1593);
	
	var _EventBucketStore2 = _interopRequireDefault(_EventBucketStore);
	
	var _UserStore = __webpack_require__(974);
	
	var _UserStore2 = _interopRequireDefault(_UserStore);
	
	var _boxOfficePosFilter = __webpack_require__(2638);
	
	var _boxOfficePosFilter2 = _interopRequireDefault(_boxOfficePosFilter);
	
	var _boxOfficeSundancePosFilter = __webpack_require__(2639);
	
	var _boxOfficeSundancePosFilter2 = _interopRequireDefault(_boxOfficeSundancePosFilter);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var colorHasher = new _colorHash2.default({ lightness: 0.6 });
	
	var BoxOfficeSubitemTablePosPicker = function (_React$Component) {
	  _inherits(BoxOfficeSubitemTablePosPicker, _React$Component);
	
	  function BoxOfficeSubitemTablePosPicker(props) {
	    _classCallCheck(this, BoxOfficeSubitemTablePosPicker);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(BoxOfficeSubitemTablePosPicker).call(this, props));
	
	    _this.state = {
	      mode: null, // [null, 'pass_bucket', 'coupon']
	      intermediateId: null,
	
	      todayOnly: false,
	      eventSort: "upcoming", // upcoming | alphabetical
	      lastSelectedSection: null,
	
	      currentEventIds: [],
	      refetchIntervalId: null,
	
	      filterText: "",
	
	      activeSalesItemOverlay: null
	    };
	
	    _this.submit = _this.submit.bind(_this);
	    _this.intermediateSubmit = _this.intermediateSubmit.bind(_this);
	
	    _this.selectShowing = _this.selectShowing.bind(_this);
	
	    _this.generateEventOptions = _this.generateEventOptions.bind(_this);
	    _this.generateItemBucketOptions = _this.generateItemBucketOptions.bind(_this);
	    return _this;
	  }
	
	  _createClass(BoxOfficeSubitemTablePosPicker, [{
	    key: "_canUseTicket",
	    value: function _canUseTicket(bucket) {
	      if (!bucket.lock_admin_only || _UserStore2.default.hasRole("admin")) return true;
	
	      var requiredRoles = bucket.lock_admin_only_role && bucket.lock_admin_only_role.split(",") || [];
	
	      return _UserStore2.default.hasRole(requiredRoles);
	    }
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      var eventBucket = _EventBucketStore2.default.getEventBucketById(this.props.orderData.event_bucket);
	      var excludeOlderEvents = false;
	      if (eventBucket.frontend_config.box_office_performance) {
	        excludeOlderEvents = eventBucket.frontend_config.box_office_performance.exclude_older_events ? true : false;
	      }
	      _EventActions2.default.fetchAllForBucket.defer(this.props.orderData.event_bucket, false, excludeOlderEvents);
	      _ItemBucketActions2.default.fetchAllForEventBucket.defer(this.props.orderData.event_bucket);
	
	      if (!document.getElementById("tailwindloader")) {
	        var script = document.createElement("script");
	        script.id = "tailwindloader";
	        script.src = "https://cdn.tailwindcss.com";
	        script.onload = function () {
	          tailwind.config = {
	            theme: {
	              extend: {
	                colors: {
	                  eventiveblue: "#0288d1"
	                }
	              }
	            },
	            corePlugins: {
	              preflight: false
	            }
	          };
	          _this2.setState({ hasMounted: true });
	        };
	        document.body.appendChild(script);
	      } else {
	        setTimeout(function () {
	          _this2.setState({ hasMounted: true });
	        }, 100);
	      }
	
	      // refetch availability every 5 seconds
	      var intervalId = setInterval(function () {
	        _EventActions2.default.fetchAvailability.defer({
	          eventBucketId: _this2.props.orderData.event_bucket,
	          eventIds: _this2.state.currentEventIds
	        });
	      }, 5000);
	
	      this.setState(function (prevState) {
	        return _extends({}, prevState, {
	          refetchIntervalId: intervalId
	        });
	      });
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      if (this.state.refetchIntervalId) {
	        clearInterval(this.state.refetchIntervalId);
	      }
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(newProps) {
	      var orderData = newProps.orderData;
	      var updateCurrentOrder = newProps.updateCurrentOrder;
	
	
	      var subitems = orderData.subitems.slice(0);
	      var originalLength = subitems.length;
	
	      // Remove empty quantity subitems
	      subitems = subitems.filter(function (s) {
	        return s.quantity > 0 || s.auto;
	      });
	
	      if (subitems.length !== originalLength) {
	        setTimeout(function () {
	          return updateCurrentOrder({
	            subitems: subitems
	          });
	        }, 0);
	      }
	    }
	  }, {
	    key: "submit",
	    value: function submit(id) {
	      // id = string => legacy submit path
	      // id = object => already a fully formed subitem
	      if (this.state.mode === "coupon") {
	        this.props.updateCurrentOrder((typeof id === "undefined" ? "undefined" : _typeof(id)) === "object" && id.code ? {
	          coupon_code: id.code
	        } : {
	          coupon_id: id
	        });
	        this.setState({ mode: null });
	        return;
	      }
	
	      var newSubitem = void 0;
	      if (typeof id === "string") {
	        var _newSubitem;
	
	        // For item bucket / ticket bucket with variant
	        var variantId = void 0;
	        if (this.state.intermediateId && (this.state.mode === "item_bucket" || this.state.mode === "ticket_bucket")) {
	          variantId = id;
	          id = this.state.intermediateId;
	        }
	
	        newSubitem = (_newSubitem = {}, _defineProperty(_newSubitem, this.state.mode, id), _defineProperty(_newSubitem, "quantity", 1), _newSubitem);
	
	        if (variantId) {
	          newSubitem.variant = variantId;
	        }
	      } else {
	        newSubitem = id;
	      }
	
	      var subitems = this.props.orderData.subitems.slice();
	
	      var match = subitems.find(function (candidate) {
	        return Object.keys(newSubitem).concat(Object.keys(candidate)).every(function (k) {
	          return k === "quantity" || newSubitem[k] === candidate[k];
	        });
	      });
	      if (match && !match.gift_card) {
	        match.quantity += newSubitem.quantity;
	      } else {
	        subitems.push(newSubitem);
	      }
	
	      this.props.updateCurrentOrder({
	        subitems: subitems
	      });
	
	      // Reset for next item
	      this.setState({ mode: null, intermediateId: null });
	    }
	  }, {
	    key: "intermediateSubmit",
	    value: function intermediateSubmit(id) {
	      var _this3 = this;
	
	      if (this.state.mode === "item_bucket") {
	        this.setState({
	          intermediateId: id
	        }, function () {
	          var itemBucket = _ItemBucketStore2.default.getItemBucketById(id);
	          if (itemBucket.variants.length === 1) {
	            _this3.submit(itemBucket.variants[0].id);
	          }
	        });
	      } else if (this.state.mode === "ticket_bucket") {
	        var ticketBucket = _EventStore2.default.getTicketBucketWithEventById(id);
	        if (ticketBucket.variants.length === 0 || ticketBucket.event.venue && ticketBucket.event.venue.use_reserved_seating // variants will be chosen in seat picker
	        ) {
	            this.submit(id);
	          } else {
	          this.setState({
	            intermediateId: id
	          }, function () {
	            // Note: we don't autosubmit for variants, because there are ALWAYS
	            // at least two options, the original bucket + at least one variant.
	            // if (ticketBucket.variants.length === 1) {
	            //   this.submit(ticketBucket.variants[0].id);
	            // }
	          });
	        }
	      }
	    }
	  }, {
	    key: "_getAvailabilityForTicketBucket",
	    value: function _getAvailabilityForTicketBucket(bucket) {
	      var availability = this.props.ticketBucketAvailability[bucket.id];
	
	      var quantity_remaining = bucket.quantity_remaining;
	      var unlimited = bucket.unlimited;
	      var quantity = bucket.quantity;
	
	      if (availability) {
	        quantity_remaining = availability.u ? Number.MAX_SAFE_INTEGER : availability.r;
	        unlimited = availability.u === undefined ? bucket.unlimited : availability.u;
	        quantity = availability.a === undefined ? bucket.quantity : availability.a;
	      }
	
	      return {
	        quantity_remaining: quantity_remaining,
	        unlimited: unlimited,
	        quantity: quantity
	      };
	    }
	  }, {
	    key: "_makeQuantityStats",
	    value: function _makeQuantityStats(event) {
	      return event.ticket_buckets.reduce(function (data, bucket) {
	        if (bucket.unlimited) {
	          data.unlimited = true;
	          data.quantity_remaining = Number.MAX_SAFE_INTEGER;
	        } else {
	          if (!bucket.exclude_capacity) {
	            data.quantity_remaining += bucket.quantity_remaining;
	            data.quantity += bucket.quantity;
	          }
	        }
	
	        return data;
	      }, {
	        unlimited: false,
	        quantity_remaining: 0,
	        quantity: 0
	      });
	    }
	  }, {
	    key: "generateEventOptions",
	    value: function generateEventOptions() {
	      var _this4 = this;
	
	      var eventBucket = _EventBucketStore2.default.getEventBucketById(this.props.orderData.event_bucket);
	
	      var rawEvents = this.props.getEventsForEventBucket(this.props.orderData.event_bucket).filter(function (e) {
	        return !e.is_dated || new Date(e.end_time) > new Date();
	      }).filter(function (e) {
	        if (e.name === "Unnamed Virtual Screening" || e.name === "Unnamed Event") {
	          return false;
	        }
	        return true;
	      }).filter(function (e) {
	        if (_this4.props.posConfig.selectedVenueId) {
	          if (!(e.venue && e.venue.id === _this4.props.posConfig.selectedVenueId)) {
	            return false;
	          }
	        }
	        if (_this4.props.posConfig.todayOnly) {
	          if (!(e.is_dated && (0, _momentTimezone2.default)().tz(e.timezone).isSame((0, _momentTimezone2.default)(e.start_time).tz(e.timezone), "day"))) {
	            return false;
	          }
	        }
	
	        var isSundance = eventBucket.frontend_config.sundance_login;
	
	        var tagFilterBoolean = isSundance ? _this4.props.posConfig.selectedTagIds && _this4.props.posConfig.selectedTagIds.length : _this4.props.posConfig.filterByTag && _this4.props.posConfig.selectedTagIds && _this4.props.posConfig.selectedTagIds.length;
	
	        if (tagFilterBoolean) {
	          if (!e.tags || !e.tags.length) {
	            return false;
	          }
	          if (!e.tags.some(function (t) {
	            return _this4.props.posConfig.selectedTagIds.includes(t.id);
	          })) {
	            return false;
	          }
	        }
	
	        if (_this4.state.filterText) {
	          if (e.name.toLowerCase().indexOf(_this4.state.filterText.toLowerCase()) === -1) {
	            return false;
	          }
	        }
	
	        return true;
	      }).sort(function (a, b) {
	        if (a.is_virtual && !b.is_virtual) {
	          return 1;
	        } else if (!a.is_virtual && b.is_virtual) {
	          return -1;
	        } else if (!a.is_dated && !b.is_dated) {
	          return 0;
	        } else if (!a.is_dated) {
	          return 1;
	        } else if (!b.is_dated) {
	          return -1;
	        }
	        return a.start_time.localeCompare(b.start_time);
	      });
	
	      this.state.currentEventIds = rawEvents.map(function (e) {
	        return e.id;
	      });
	
	      if (!rawEvents.length) {
	        return [];
	      }
	
	      var timezone = rawEvents[0] && rawEvents[0].timezone;
	      var today = (0, _momentTimezone2.default)().tz(timezone);
	
	      var groupedEvents = Object.values((0, _groupBy2.default)(rawEvents, function (e) {
	        return e.films.length ? e.films.map(function (f) {
	          return f.id;
	        }).sort().join("_") : e.id;
	      })).map(function (events) {
	        var baseEvent = events[0];
	        var name = baseEvent.name;
	        // events.length === 1
	        //   ? baseEvent.name
	        //   : baseEvent.films.length
	        //   ? baseEvent.films.map(f => f.name).join(" & ")
	        //   : baseEvent.name;
	
	        var sections = Object.entries((0, _groupBy2.default)(events, function (e) {
	          if (e.is_virtual) {
	            return "virtual";
	          } else if (!e.is_dated) {
	            return "undated";
	          }
	          return (0, _momentTimezone2.default)(e.start_time).tz(timezone).format("YYYY-MM-DD");
	        })).map(function (_ref) {
	          var _ref2 = _slicedToArray(_ref, 2);
	
	          var key = _ref2[0];
	          var events = _ref2[1];
	
	          var dated_events = events.filter(function (e) {
	            return e.is_dated;
	          });
	          var isToday = _momentTimezone2.default.tz(key, timezone).isSame(today, "day");
	          return _extends({
	            key: key
	          }, dated_events.length ? {
	            start_time: dated_events[0].start_time,
	            end_time: dated_events[dated_events.length - 1].end_time
	          } : null, {
	            label: key === "undated" ? "Undated events" : key === "virtual" ? "Virtual screenings" : "" + _momentTimezone2.default.tz(key, timezone).format("ddd, MMM Do") + (isToday ? " – TODAY" : ""),
	            showings: events.map(function (event) {
	              var sale_options = [];
	              var public_quantity = 0;
	              var public_remaining = 0;
	
	              event.ticket_buckets.filter(function (b) {
	                return _this4.props.posConfig.publicTicketsOnly ? b.public : true;
	              }).forEach(function (b) {
	                var _getAvailabilityForTi = _this4._getAvailabilityForTicketBucket(b);
	
	                var quantity_remaining = _getAvailabilityForTi.quantity_remaining;
	                var unlimited = _getAvailabilityForTi.unlimited;
	                var quantity = _getAvailabilityForTi.quantity;
	
	
	                b.unlimited = unlimited;
	                b.quantity_remaining = quantity_remaining;
	                b.quantity = quantity;
	
	                if (_this4.props.posConfig.publicTicketsOnly) {
	                  public_quantity += b.quantity;
	                  public_remaining += b.quantity_remaining;
	                }
	
	                sale_options.push({
	                  key: b.id,
	                  subitem: {
	                    ticket_bucket: b.id
	                  },
	                  primary_label: b.name,
	                  secondary_label: b.variants.length ? "Default" : undefined,
	                  price: b.price,
	                  canUse: _this4._canUseTicket(b),
	                  unlimited: unlimited,
	                  quantity: quantity,
	                  quantity_remaining: quantity_remaining
	                });
	
	                b.variants.forEach(function (v) {
	                  sale_options.push({
	                    key: b.id + "-" + v.id,
	                    subitem: {
	                      ticket_bucket: b.id,
	                      variant: v.id
	                    },
	                    primary_label: b.name,
	                    secondary_label: v.name,
	                    price: v.price,
	                    canUse: _this4._canUseTicket(b),
	                    is_variant: true,
	                    unlimited: unlimited,
	                    quantity: quantity,
	                    quantity_remaining: quantity_remaining
	                  });
	                });
	              });
	
	              var _makeQuantityStats2 = _this4._makeQuantityStats(event);
	
	              var quantity = _makeQuantityStats2.quantity;
	              var quantity_remaining = _makeQuantityStats2.quantity_remaining;
	              var unlimited = _makeQuantityStats2.unlimited;
	
	
	              return {
	                key: event.id,
	                label: event.is_virtual ? "Virtual" : event.is_dated ? (0, _momentTimezone2.default)(event.start_time).tz(timezone).format("h:mm A") : "Undated",
	                quantity_remaining: _this4.props.posConfig.publicTicketsOnly ? public_remaining : quantity_remaining,
	                quantity: _this4.props.posConfig.publicTicketsOnly ? public_quantity : quantity,
	                unlimited: unlimited,
	                venue_label: event.venue && event.venue.name || (event.is_virtual ? "Virtual" : "No venue"),
	                sale_options: sale_options,
	                event: event
	              };
	            })
	          });
	        });
	
	        var start = Math.min.apply(Math, _toConsumableArray(sections.map(function (s) {
	          return new Date(s.start_time);
	        }))),
	            end = Math.max.apply(Math, _toConsumableArray(sections.map(function (s) {
	          return new Date(s.end_time);
	        }))),
	            startLabel = start && (0, _momentTimezone2.default)(start).tz(timezone).format("MMM D"),
	            endLabel = end && (0, _momentTimezone2.default)(end).tz(timezone).format("MMM D");
	
	        var screening_window_label = [startLabel && endLabel ? startLabel === endLabel ? startLabel : startLabel + " \u2013 " + endLabel : null, sections.some(function (s) {
	          return s.key === "undated";
	        }) && "Undated", sections.some(function (s) {
	          return s.key === "virtual";
	        }) && (sections.length > 1 ? "Hybrid" : "Virtual")].filter(function (x) {
	          return !!x;
	        }).join(" · ");
	
	        var cover_image = undefined;
	        var eventWithCover = events.find(function (e) {
	          return e.images.cover;
	        });
	        if (eventWithCover) {
	          cover_image = eventWithCover.images.cover;
	        } else {
	          var filmWithCover = baseEvent.films.find(function (f) {
	            return f.still_image || f.cover_image;
	          });
	          if (filmWithCover) {
	            cover_image = filmWithCover.still_image || filmWithCover.cover_image;
	          }
	        }
	
	        return {
	          key: baseEvent.id,
	          name: name,
	          cover_image: cover_image,
	          screening_window_label: screening_window_label,
	          sections: sections
	        };
	      });
	
	      if (this.state.eventSort === "alphabetical") {
	        return groupedEvents.sort(function (a, b) {
	          return a.name.localeCompare(b.name);
	        });
	      }
	
	      return groupedEvents;
	    }
	  }, {
	    key: "generateItemBucketOptions",
	    value: function generateItemBucketOptions() {
	      var eventBucket = _EventBucketStore2.default.getEventBucketById(this.props.orderData.event_bucket);
	
	      var rawBuckets = this.props.getItemBucketsForEventBucket(this.props.orderData.event_bucket).filter(function (b) {
	        if (b.name === "Unnamed Item Bucket") {
	          return false;
	        }
	        return true;
	      }).sort(function (a, b) {
	        return a.name.localeCompare(b.name);
	      });
	
	      if (eventBucket.frontend_config.gift_cards_enabled && this.props.orderData.customerType === "standard") {
	        rawBuckets.unshift({
	          id: "gift_card",
	          name: "Gift Card",
	          code: "gift_card",
	          variants: [{
	            id: "gift_card",
	            active: true,
	            variable_price: true,
	            quantity_remaining: Number.MAX_SAFE_INTEGER
	          }]
	        });
	      }
	
	      var determineDefaultName = function determineDefaultName(code) {
	        switch (code) {
	          case "gift_card":
	            return "Gift Card";
	          case "donation":
	            return "Donation";
	          default:
	            return "Default";
	        }
	      };
	
	      var processed = rawBuckets.map(function (b) {
	        return {
	          key: b.id,
	          name: b.name,
	          sections: [{
	            key: "default",
	            label: "Default",
	            showings: b.variants.map(function (v) {
	              var _subitem;
	
	              return {
	                key: v.id,
	                label: v.name || determineDefaultName(b.code),
	                quantity_remaining: v.quantity_remaining,
	                quantity: v.quantity,
	                sale_options: [{
	                  subitem: (_subitem = {}, _defineProperty(_subitem, b.code === "gift_card" ? "gift_card" : "item_bucket", b.id), _defineProperty(_subitem, "variant", v.id), _subitem),
	                  primary_label: b.name,
	                  secondary_label: v.name,
	                  price: v.price
	                }]
	              };
	            })
	          }]
	        };
	      });
	
	      return processed;
	    }
	  }, {
	    key: "selectShowing",
	    value: function selectShowing(showing) {
	      this.setState({ focusedShowing: null });
	
	      var sale_options = showing.sale_options;
	
	
	      if (sale_options.length === 0) {
	        window.alert("You do not have permission to sell tickets to this event.");
	        return;
	      }
	
	      if (sale_options.length === 1) {
	        this.submit(sale_options[0].subitem.gift_card ? _extends({}, sale_options[0].subitem, {
	          quantity: 1,
	          name: "Gift Card",
	          variable_price: true,
	          price: 0
	        }) : _extends({}, sale_options[0].subitem, { quantity: 1 }));
	        return;
	      }
	
	      this.setState({ activeSalesItemOverlay: showing });
	    }
	  }, {
	    key: "getStyles",
	    value: function getStyles() {
	      return {
	        container: {
	          paddingRight: 20,
	          flex: 1,
	          display: "flex",
	          flexDirection: "column"
	        },
	        select: {
	          display: "none",
	          width: "calc(100% - 100px)",
	          maxWidth: 300,
	          verticalAlign: "middle"
	        },
	        resetButton: {
	          marginLeft: 7,
	          verticalAlign: "middle"
	        },
	        addButton: {
	          marginRight: 7,
	          border: "1px solid",
	          lineHeight: "33px"
	        },
	        addButtonLast: {
	          marginRight: 0
	        },
	
	        venueSelectorContainer: {
	          display: "flex",
	          backgroundColor: "rgba(0,0,0,0.1)",
	          padding: "10px 20px",
	          borderRadius: 5,
	          flexDirection: "column"
	        },
	        sectionHeader: {
	          fontWeight: "bold",
	          fontSize: 16,
	          marginTop: 20,
	          marginBottom: 5
	        }
	      };
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this5 = this;
	
	      var styles = this.getStyles(),
	          now = new Date();
	
	      var eventBucket = _EventBucketStore2.default.getEventBucketById(this.props.orderData.event_bucket);
	
	      // Box office level accounts must enter the exact discount code - no dropdown
	      var requireDiscountCodeEntry = _UserStore2.default.hasRole("box_office");
	      var isSundance = eventBucket.frontend_config.sundance_login;
	
	      var events = this.generateEventOptions();
	      var itemBuckets = this.generateItemBucketOptions();
	
	      var activeSalesItemOverlay = this.state.activeSalesItemOverlay;
	
	
	      var FilterComponent = isSundance ? _boxOfficeSundancePosFilter2.default : _boxOfficePosFilter2.default;
	
	      // only show the loader if the component hasn't finished mounting
	      // or if data is being fetched AND there are no events or item buckets
	      if (!this.state.hasMounted || this.props.isFetching && events.length === 0 && itemBuckets.length === 0) {
	        return _react2.default.createElement(
	          "div",
	          { style: { marginTop: 20, width: "100%", textAlign: "center" } },
	          _react2.default.createElement(_workingIndicator2.default, { centered: true }),
	          _react2.default.createElement(
	            "div",
	            { style: { marginTop: 10 } },
	            "Preparing the Box Office..."
	          )
	        );
	      }
	
	      return _react2.default.createElement(
	        "div",
	        { style: styles.container },
	        _react2.default.createElement(FilterComponent, {
	          orderData: this.props.orderData,
	          posConfig: this.props.posConfig,
	          updatePosConfig: this.props.updatePosConfig,
	          filterText: this.state.filterText,
	          isSundance: isSundance,
	          updateFilterText: function updateFilterText(text) {
	            return _this5.setState({ filterText: text });
	          }
	        }),
	        _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement(
	            _materialUi.Popover,
	            {
	              open: !!activeSalesItemOverlay,
	              anchorEl: document.getElementById("salesItemOverlayAnchor_" + (activeSalesItemOverlay && activeSalesItemOverlay.key)),
	              anchorOrigin: { horizontal: "left", vertical: "bottom" },
	              targetOrigin: { horizontal: "left", vertical: "top" },
	              onRequestClose: function onRequestClose() {
	                return _this5.setState({ activeSalesItemOverlay: null });
	              },
	              animation: _Popover.PopoverAnimationVertical
	            },
	            _react2.default.createElement(
	              _materialUi.Menu,
	              { desktop: true, maxHeight: 300 },
	              activeSalesItemOverlay && activeSalesItemOverlay.sale_options.map(function (option) {
	                return _react2.default.createElement(_materialUi.MenuItem, {
	                  key: option.key,
	                  onClick: function onClick() {
	                    if (option.quantity_remaining > 0 && option.canUse) {
	                      _this5.submit(_extends({}, option.subitem, { quantity: 1 }));
	                    }
	                  },
	                  disabled: option.quantity_remaining <= 0 || !option.canUse,
	                  primaryText: _react2.default.createElement(
	                    "div",
	                    { className: "flex" },
	                    _react2.default.createElement(
	                      "span",
	                      { className: "flex-1" },
	                      option.primary_label,
	                      option.secondary_label ? " \u2013\u2060 " + option.secondary_label : null,
	                      typeof option.quantity_remaining !== "undefined" && !option.is_variant ? _react2.default.createElement(
	                        "div",
	                        {
	                          style: {
	                            marginTop: "-0.35rem",
	                            marginBottom: "0.5rem",
	                            color: "rgba(0,0,0,0.4)",
	                            fontSize: "0.65rem",
	                            lineHeight: "0.65rem"
	                          }
	                        },
	                        option.unlimited ? "∞ remaining" : _react2.default.createElement(
	                          "span",
	                          null,
	                          option.quantity_remaining,
	                          " /",
	                          " ",
	                          option.unlimited ? "∞" : option.quantity,
	                          " ",
	                          "remaining"
	                        )
	                      ) : null
	                    ),
	                    _react2.default.createElement(
	                      "span",
	                      { className: "ml-2" },
	                      util.formatPrice(option.price)
	                    )
	                  )
	                });
	              })
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { style: styles.sectionHeader, className: "flex" },
	            _react2.default.createElement(
	              "span",
	              { className: "flex-1" },
	              "Events"
	            ),
	            _react2.default.createElement(
	              "span",
	              { className: "text-sm font-normal rounded border border-gray-200" },
	              _react2.default.createElement(
	                "span",
	                {
	                  className: (0, _classnames2.default)("cursor-pointer rounded-l px-2 py-0.5", this.state.eventSort === "upcoming" ? "bg-eventiveblue text-white" : "bg-gray-300 text-gray-700"),
	                  onClick: function onClick() {
	                    return _this5.setState({ eventSort: "upcoming" });
	                  }
	                },
	                "Next Up"
	              ),
	              _react2.default.createElement(
	                "span",
	                {
	                  className: (0, _classnames2.default)("cursor-pointer rounded-r px-2 py-0.5", this.state.eventSort === "alphabetical" ? "bg-eventiveblue text-white" : "bg-gray-300 text-gray-700"),
	                  onClick: function onClick() {
	                    return _this5.setState({ eventSort: "alphabetical" });
	                  }
	                },
	                "A-Z"
	              )
	            )
	          ),
	          events.length ? _react2.default.createElement(
	            "div",
	            {
	              style: {
	                maxHeight: events.length > 10 ? "50vh" : undefined,
	                overflowY: events.length > 10 ? "auto" : undefined,
	                marginLeft: -5,
	                marginRight: -5
	              },
	              onWheel: function onWheel(e) {
	                // prevent scrolling the page unless we're at the top or bottom
	                if (e.target.scrollTop > 0 && e.target.scrollTop < e.target.scrollHeight - e.target.offsetHeight) {
	                  e.stopPropagation();
	                }
	              }
	            },
	            _react2.default.createElement(
	              "div",
	              { className: "grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4" },
	              events.map(function (e, i) {
	                return _react2.default.createElement(EventItem, {
	                  key: e.key,
	                  event: e,
	                  isLastRow: events.length > 10 && i > events.length - 4,
	                  todayOnly: _this5.props.posConfig.todayOnly,
	                  initialSection: _this5.state.lastSelectedSection,
	                  onChangeSection: function onChangeSection(key) {
	                    _this5.setState({ lastSelectedSection: key });
	                  },
	                  onSelectShowing: _this5.selectShowing
	                });
	              })
	            )
	          ) : _react2.default.createElement(
	            "div",
	            { style: { fontStyle: "italic" } },
	            this.state.filterText ? "No events matched your search" : "No events available for sale"
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement(
	            "div",
	            { style: styles.sectionHeader },
	            "Items"
	          ),
	          itemBuckets.length ? _react2.default.createElement(
	            "div",
	            {
	              className: "grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4",
	              style: { marginLeft: -5, marginRight: -5 /*maxHeight: 400*/ }
	            },
	            itemBuckets.map(function (data) {
	              return _react2.default.createElement(EventItem, {
	                key: data.key,
	                event: data,
	                todayOnly: true,
	                isItem: true,
	                onSelectShowing: _this5.selectShowing
	              });
	            })
	          ) : _react2.default.createElement(
	            "div",
	            { style: { fontStyle: "italic" } },
	            "No items available for sale"
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement(
	            "div",
	            { style: styles.sectionHeader },
	            "Other"
	          ),
	          _react2.default.createElement(_injectedSelect2.default, {
	            autoFocus: this.state.mode === "pass_bucket",
	            autosize: false,
	            style: Object.assign({}, styles.select, this.state.mode === "pass_bucket" && { display: "inline-block" }),
	            placeholder: "Select pass bucket",
	            type: "pass_buckets",
	            filterBy: function filterBy(p) {
	              return p.visible_in_box_office;
	            },
	            labelToFilterString: function labelToFilterString(p) {
	              return "" + p.name;
	            },
	            labelFormatter: function labelFormatter(p) {
	              return _react2.default.createElement(
	                "div",
	                null,
	                _react2.default.createElement(
	                  "div",
	                  null,
	                  _react2.default.createElement(
	                    "span",
	                    { style: { fontWeight: "bold" } },
	                    p.name
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  null,
	                  p.unlimited ? "Unlimited passes remaining" : p.quantity - p.quantity_sold !== 1 ? p.quantity - p.quantity_sold + " passes remaining" : "1 pass remaining"
	                )
	              );
	            },
	            isDisabledFunction: function isDisabledFunction(p) {
	              return p.unlimited ? false : p.quantity - p.quantity_sold <= 0;
	            },
	            sortDisabledToEnd: true,
	            eventBucketId: this.props.orderData.event_bucket,
	            sortFunction: function sortFunction(a, b) {
	              return a.rawValue.name.localeCompare(b.rawValue.name);
	            },
	            onChange: this.submit
	          }),
	          _react2.default.createElement(_injectedSelect2.default, {
	            autoFocus: this.state.mode === "memberships",
	            autosize: false,
	            style: Object.assign({}, styles.select, this.state.mode === "memberships" && { display: "inline-block" }),
	            placeholder: "Select membership",
	            type: "memberships",
	            filterBy: function filterBy(p) {
	              return p.visible_in_box_office;
	            },
	            labelToFilterString: function labelToFilterString(p) {
	              return "" + p.name;
	            },
	            labelFormatter: function labelFormatter(p) {
	              return _react2.default.createElement(
	                "div",
	                null,
	                _react2.default.createElement(
	                  "div",
	                  null,
	                  _react2.default.createElement(
	                    "span",
	                    { style: { fontWeight: "bold" } },
	                    p.name
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  null,
	                  p.unlimited ? "Unlimited memberships remaining" : p.quantity - p.quantity_sold !== 1 ? p.quantity - p.quantity_sold + " memberships remaining" : "1 membership remaining"
	                )
	              );
	            },
	            isDisabledFunction: function isDisabledFunction(p) {
	              return p.unlimited ? false : p.quantity - p.quantity_sold <= 0;
	            },
	            sortDisabledToEnd: true,
	            eventBucketId: this.props.orderData.event_bucket,
	            sortFunction: function sortFunction(a, b) {
	              return a.rawValue.name.localeCompare(b.rawValue.name);
	            },
	            onChange: this.submit
	          }),
	          _react2.default.createElement(_injectedSelect2.default, {
	            autoFocus: this.state.mode === "coupon",
	            autosize: false,
	            style: Object.assign({}, styles.select, this.state.mode === "coupon" && { display: "inline-block" }),
	            placeholder: requireDiscountCodeEntry ? "Type discount code (case-sensitive)" : "Select discount, or type discount code",
	            type: requireDiscountCodeEntry ? null : "coupons",
	            labelFormatter: function labelFormatter(p) {
	              return "" + p.name;
	            },
	            eventBucketId: this.props.orderData.event_bucket,
	            sortFunction: function sortFunction(a, b) {
	              return a.label.localeCompare(b.label);
	            },
	            onChange: this.submit,
	            creatable: true,
	            creatablePromptText: function creatablePromptText(s) {
	              return "Use discount code \"" + s + "\"";
	            },
	            onCreateSelect: function onCreateSelect(o) {
	              return _this5.submit({ code: o.value });
	            }
	          }),
	          this.state.mode ? _react2.default.createElement(_materialUi.FlatButton, {
	            label: "Back",
	            onClick: function onClick() {
	              return _this5.setState({ mode: null, intermediateId: null });
	            },
	            style: styles.resetButton
	          }) : _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(_materialUi.FlatButton, {
	              label: "+ Pass",
	              primary: true,
	              onClick: function onClick() {
	                return _this5.setState({ mode: "pass_bucket" });
	              },
	              style: styles.addButton
	            }),
	            eventBucket.frontend_config.memberships_enabled && _react2.default.createElement(_materialUi.FlatButton, {
	              label: "+ Membership",
	              primary: true,
	              onClick: function onClick() {
	                return _this5.setState({ mode: "memberships" });
	              },
	              style: styles.addButton
	            }),
	            !this.props.orderData.coupon ? _react2.default.createElement(_materialUi.FlatButton, {
	              label: eventBucket.frontend_config.gift_cards_enabled ? "+ Discount / GC" : "+ Discount",
	              primary: true,
	              onClick: function onClick() {
	                return _this5.setState({ mode: "coupon" });
	              },
	              style: Object.assign({}, styles.addButton, styles.addButtonLast)
	            }) : null
	          )
	        )
	      );
	    }
	  }], [{
	    key: "getStores",
	    value: function getStores() {
	      return [_EventStore2.default, _EventBucketStore2.default, _ItemBucketStore2.default];
	    }
	  }, {
	    key: "getPropsFromStores",
	    value: function getPropsFromStores() {
	      return {
	        getEventsForEventBucket: _EventStore2.default.getEventsForEventBucket,
	        getItemBucketsForEventBucket: _ItemBucketStore2.default.getItemBucketsForEventBucket,
	        isFetching: _EventStore2.default.getState().isFetching || _ItemBucketStore2.default.getState().isFetching,
	        ticketBucketAvailability: _EventStore2.default.getState().availability
	      };
	    }
	  }]);
	
	  return BoxOfficeSubitemTablePosPicker;
	}(_react2.default.Component);
	
	var EventItem = function (_React$Component2) {
	  _inherits(EventItem, _React$Component2);
	
	  function EventItem(props) {
	    _classCallCheck(this, EventItem);
	
	    var _this6 = _possibleConstructorReturn(this, Object.getPrototypeOf(EventItem).call(this, props));
	
	    _this6.state = {
	      selectedSection: null,
	      focusedShowing: null
	    };
	    return _this6;
	  }
	
	  _createClass(EventItem, [{
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(props) {
	      if (props.initialSection && this.props.event.sections.find(function (s) {
	        return s.key === props.initialSection;
	      })) {
	        this.setState({ selectedSection: props.initialSection });
	      }
	    }
	  }, {
	    key: "_formatQuantity",
	    value: function _formatQuantity(q) {
	      return q >= Number.MAX_SAFE_INTEGER ? "∞" : Math.max(q, 0);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this7 = this;
	
	      var _props = this.props;
	      var event = _props.event;
	      var todayOnly = _props.todayOnly;
	      var isItem = _props.isItem;
	      var isLastRow = _props.isLastRow;
	      var name = event.name;
	      var cover_image = event.cover_image;
	      var screening_window_label = event.screening_window_label;
	      var sections = event.sections;
	
	
	      var selectedSection = this.state.selectedSection ? sections.find(function (s) {
	        return s.key === _this7.state.selectedSection;
	      }) || sections[0] : sections[0];
	
	      var focusedShowing = selectedSection.showings.find(function (s) {
	        return s.key === _this7.state.focusedShowing;
	      });
	
	      return _react2.default.createElement(
	        _materialUi.Paper,
	        {
	          className: "hover:z-10",
	          style: {
	            padding: 10,
	            margin: 5,
	            borderRadius: 6,
	            position: "relative",
	            backgroundImage: "linear-gradient(rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.4)), " + (cover_image ? "url(" + cover_image + ")" : "linear-gradient(" + colorHasher.hex(event.key) + "," + colorHasher.hex(event.key) + ")"),
	            backgroundSize: "cover",
	            minHeight: 100
	          }
	        },
	        _react2.default.createElement(
	          "div",
	          {
	            style: {
	              fontSize: 20,
	              fontWeight: "bold",
	              color: "#fff"
	            },
	            className: "max-h-10 overflow-hidden hover:max-h-auto"
	          },
	          name
	        ),
	        _react2.default.createElement(
	          "div",
	          null,
	          !todayOnly ? _react2.default.createElement(
	            "div",
	            { style: { marginBottom: 2, color: "rgba(255,255,255,0.8)" } },
	            screening_window_label
	          ) : null,
	          !todayOnly ? _react2.default.createElement(_reactSelect2.default, {
	            style: {
	              width: "100%"
	            },
	            className: "Select--short Select--dark",
	            clearable: false,
	            searchable: false,
	            value: selectedSection.key,
	            options: sections.map(function (s) {
	              return {
	                value: s.key,
	                label: s.label
	              };
	            }),
	            onChange: function onChange(data) {
	              _this7.setState({ selectedSection: data.value });
	              _this7.props.onChangeSection(data.value);
	            }
	          }) : null
	        ),
	        _react2.default.createElement(
	          "div",
	          {
	            style: Object.assign({ marginTop: 5, marginLeft: -2, marginRight: -2 }
	            //isItem && { maxHeight: 70, overflowY: "auto" }
	            )
	          },
	          selectedSection.showings.map(function (showing) {
	            return _react2.default.createElement(
	              "div",
	              {
	                key: showing.key,
	                id: "salesItemOverlayAnchor_" + showing.key,
	                className: (0, _classnames2.default)("rounded", showing.quantity_remaining === 0 ? "cursor-not-allowed" : "hover:bg-black hover:bg-opacity-50"),
	                style: { display: "inline-block", margin: 2, maxWidth: "100%" },
	                onMouseEnter: function onMouseEnter() {
	                  return _this7.setState({ focusedShowing: showing.key });
	                },
	                onMouseLeave: function onMouseLeave() {
	                  return _this7.setState({ focusedShowing: null });
	                }
	              },
	              _react2.default.createElement(_materialUi.FlatButton, {
	                label: showing.label,
	                style: {
	                  height: 24,
	                  lineHeight: "22px",
	                  border: "1px solid #ccc",
	                  color: "#fff",
	                  backgroundColor: "transparent",
	                  pointerEvents: showing.quantity_remaining === 0 ? "none" : undefined,
	                  opacity: showing.quantity_remaining === 0 ? 0.5 : undefined,
	                  maxWidth: "100%"
	                },
	                labelStyle: {
	                  padding: "0px 5px",
	                  fontVariantNumeric: "tabular-nums",
	                  overflow: "hidden",
	                  whiteSpace: "nowrap",
	                  textOverflow: "ellipsis",
	                  maxWidth: "100%",
	                  display: "inline-block",
	                  textDecoration: showing.quantity_remaining === 0 || showing.sale_options.length === 0 ? "line-through" : undefined
	                },
	                disabled: showing.quantity_remaining === 0,
	                onClick: function onClick() {
	                  return _this7.props.onSelectShowing(showing);
	                }
	              })
	            );
	          })
	        ),
	        _react2.default.createElement(
	          "div",
	          {
	            id: "eventOverlayAnchor_" + event.key,
	            style: { position: "relative" }
	          },
	          focusedShowing ?
	          // <Popover
	          //   open={true}
	          //   anchorEl={document.getElementById(
	          //     `eventOverlayAnchor_${event.key}`
	          //   )}
	          //   // anchorOrigin={{ horizontal: "left", vertical: "bottom" }}
	          //   // targetOrigin={{ horizontal: "left", vertical: "top" }}
	          //   animated={false}
	          //   autoCloseWhenOffScreen={false}
	          //   canAutoPosition={false}
	          //   anchorOrigin={{ horizontal: "left", vertical: "top" }}
	          //   style={{ marginTop: 5 }}
	          // >
	          _react2.default.createElement(
	            "div",
	            {
	              style: {
	                position: "absolute",
	                top: isLastRow ? undefined : 5,
	                bottom: isLastRow ? 65 : undefined,
	                background: "rgba(255,255,255,0.95)",
	                color: "#000",
	                borderRadius: 5,
	                padding: "5px 8px",
	                lineHeight: 1.25,
	                zIndex: 999
	              },
	              className: "shadow"
	            },
	            isItem ? _react2.default.createElement(
	              "div",
	              { style: { fontWeight: "bold" } },
	              focusedShowing.label,
	              " @",
	              " ",
	              util.formatPrice(focusedShowing.sale_options[0].price)
	            ) : _react2.default.createElement(
	              "div",
	              { style: { fontWeight: "bold" } },
	              focusedShowing.event && focusedShowing.event.name || name,
	              " ",
	              "@ ",
	              focusedShowing.label
	            ),
	            _react2.default.createElement(
	              "div",
	              null,
	              this._formatQuantity(focusedShowing.quantity_remaining),
	              "/",
	              this._formatQuantity(focusedShowing.quantity || focusedShowing.quantity_remaining),
	              " ",
	              "remaining"
	            ),
	            focusedShowing.sale_options && focusedShowing.sale_options.length === 1 ? _react2.default.createElement(
	              "div",
	              null,
	              focusedShowing.sale_options[0].primary_label
	            ) : null,
	            _react2.default.createElement(
	              "div",
	              null,
	              focusedShowing.venue_label
	            )
	          ) : // </Popover>
	          null
	        )
	      );
	    }
	  }]);
	
	  return EventItem;
	}(_react2.default.Component);
	
	exports.default = (0, _connectToStores2.default)(BoxOfficeSubitemTablePosPicker);
	module.exports = exports["default"];

/***/ }),
/* 2636 */
/***/ (function(module, exports) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        if (typeof b !== "function" && b !== null)
	            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, privateMap, value) {
	    if (!privateMap.has(receiver)) {
	        throw new TypeError("attempted to set private field on non-instance");
	    }
	    privateMap.set(receiver, value);
	    return value;
	};
	var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, privateMap) {
	    if (!privateMap.has(receiver)) {
	        throw new TypeError("attempted to get private field on non-instance");
	    }
	    return privateMap.get(receiver);
	};
	var _block, _blocks, _bytes, _finalized, _first, _h0, _h1, _h2, _h3, _h4, _h5, _h6, _h7, _hashed, _hBytes, _is224, _lastByteIndex, _start, _inner, _is224_1, _oKeyPad, _sharedMemory;
	exports.__esModule = true;
	exports["default"] = void 0;
	var BKDRHash = function (str) {
	    var seed = 131;
	    var seed2 = 137;
	    var hash = 0;
	    str += 'x';
	    var MAX_SAFE_INTEGER = Math.floor(9007199254740991 / seed2);
	    for (var i = 0; i < str.length; i++) {
	        if (hash > MAX_SAFE_INTEGER) {
	            hash = Math.floor(hash / seed2);
	        }
	        hash = hash * seed + str.charCodeAt(i);
	    }
	    return hash;
	};
	var HEX_CHARS = "0123456789abcdef".split("");
	var EXTRA = [
	    -2147483648,
	    8388608,
	    32768,
	    128
	];
	var SHIFT = [
	    24,
	    16,
	    8,
	    0
	];
	var K = [
	    1116352408,
	    1899447441,
	    3049323471,
	    3921009573,
	    961987163,
	    1508970993,
	    2453635748,
	    2870763221,
	    3624381080,
	    310598401,
	    607225278,
	    1426881987,
	    1925078388,
	    2162078206,
	    2614888103,
	    3248222580,
	    3835390401,
	    4022224774,
	    264347078,
	    604807628,
	    770255983,
	    1249150122,
	    1555081692,
	    1996064986,
	    2554220882,
	    2821834349,
	    2952996808,
	    3210313671,
	    3336571891,
	    3584528711,
	    113926993,
	    338241895,
	    666307205,
	    773529912,
	    1294757372,
	    1396182291,
	    1695183700,
	    1986661051,
	    2177026350,
	    2456956037,
	    2730485921,
	    2820302411,
	    3259730800,
	    3345764771,
	    3516065817,
	    3600352804,
	    4094571909,
	    275423344,
	    430227734,
	    506948616,
	    659060556,
	    883997877,
	    958139571,
	    1322822218,
	    1537002063,
	    1747873779,
	    1955562222,
	    2024104815,
	    2227730452,
	    2361852424,
	    2428436474,
	    2756734187,
	    3204031479,
	    3329325298,
	];
	var blocks = [];
	var Sha256 = /** @class */ (function () {
	    function Sha256(is2241, sharedMemory1) {
	        if (is2241 === void 0) { is2241 = false; }
	        if (sharedMemory1 === void 0) { sharedMemory1 = false; }
	        _block.set(this, void 0);
	        _blocks.set(this, void 0);
	        _bytes.set(this, void 0);
	        _finalized.set(this, void 0);
	        _first.set(this, void 0);
	        _h0.set(this, void 0);
	        _h1.set(this, void 0);
	        _h2.set(this, void 0);
	        _h3.set(this, void 0);
	        _h4.set(this, void 0);
	        _h5.set(this, void 0);
	        _h6.set(this, void 0);
	        _h7.set(this, void 0);
	        _hashed.set(this, void 0);
	        _hBytes.set(this, void 0);
	        _is224.set(this, void 0);
	        _lastByteIndex.set(this, 0);
	        _start.set(this, void 0);
	        this.init(is2241, sharedMemory1);
	    }
	    Sha256.prototype.init = function (is224, sharedMemory) {
	        if (sharedMemory) {
	            blocks[0] = blocks[16] = blocks[1] = blocks[2] = blocks[3] = blocks[4] = blocks[5] = blocks[6] = blocks[7] = blocks[8] = blocks[9] = blocks[10] = blocks[11] = blocks[12] = blocks[13] = blocks[14] = blocks[15] = 0;
	            __classPrivateFieldSet(this, _blocks, blocks);
	        }
	        else {
	            __classPrivateFieldSet(this, _blocks, [
	                0,
	                0,
	                0,
	                0,
	                0,
	                0,
	                0,
	                0,
	                0,
	                0,
	                0,
	                0,
	                0,
	                0,
	                0,
	                0,
	                0
	            ]);
	        }
	        if (is224) {
	            __classPrivateFieldSet(this, _h0, 3238371032);
	            __classPrivateFieldSet(this, _h1, 914150663);
	            __classPrivateFieldSet(this, _h2, 812702999);
	            __classPrivateFieldSet(this, _h3, 4144912697);
	            __classPrivateFieldSet(this, _h4, 4290775857);
	            __classPrivateFieldSet(this, _h5, 1750603025);
	            __classPrivateFieldSet(this, _h6, 1694076839);
	            __classPrivateFieldSet(this, _h7, 3204075428);
	        }
	        else {
	            __classPrivateFieldSet(this, _h0, 1779033703);
	            __classPrivateFieldSet(this, _h1, 3144134277);
	            __classPrivateFieldSet(this, _h2, 1013904242);
	            __classPrivateFieldSet(this, _h3, 2773480762);
	            __classPrivateFieldSet(this, _h4, 1359893119);
	            __classPrivateFieldSet(this, _h5, 2600822924);
	            __classPrivateFieldSet(this, _h6, 528734635);
	            __classPrivateFieldSet(this, _h7, 1541459225);
	        }
	        __classPrivateFieldSet(this, _block, __classPrivateFieldSet(this, _start, __classPrivateFieldSet(this, _bytes, __classPrivateFieldSet(this, _hBytes, 0))));
	        __classPrivateFieldSet(this, _finalized, __classPrivateFieldSet(this, _hashed, false));
	        __classPrivateFieldSet(this, _first, true);
	        __classPrivateFieldSet(this, _is224, is224);
	    };
	    Sha256.prototype.update = function (message) {
	        if (__classPrivateFieldGet(this, _finalized)) {
	            return this;
	        }
	        var msg;
	        if (message instanceof ArrayBuffer) {
	            msg = new Uint8Array(message);
	        }
	        else {
	            msg = message;
	        }
	        var index = 0;
	        var length = msg.length;
	        var blocks1 = __classPrivateFieldGet(this, _blocks);
	        while (index < length) {
	            var i = void 0;
	            if (__classPrivateFieldGet(this, _hashed)) {
	                __classPrivateFieldSet(this, _hashed, false);
	                blocks1[0] = __classPrivateFieldGet(this, _block);
	                blocks1[16] = blocks1[1] = blocks1[2] = blocks1[3] = blocks1[4] = blocks1[5] = blocks1[6] = blocks1[7] = blocks1[8] = blocks1[9] = blocks1[10] = blocks1[11] = blocks1[12] = blocks1[13] = blocks1[14] = blocks1[15] = 0;
	            }
	            if (typeof msg !== "string") {
	                for (i = __classPrivateFieldGet(this, _start); index < length && i < 64; ++index) {
	                    blocks1[i >> 2] |= msg[index] << SHIFT[(i++) & 3];
	                }
	            }
	            else {
	                for (i = __classPrivateFieldGet(this, _start); index < length && i < 64; ++index) {
	                    var code = msg.charCodeAt(index);
	                    if (code < 128) {
	                        blocks1[i >> 2] |= code << SHIFT[(i++) & 3];
	                    }
	                    else if (code < 2048) {
	                        blocks1[i >> 2] |= (192 | code >> 6) << SHIFT[(i++) & 3];
	                        blocks1[i >> 2] |= (128 | code & 63) << SHIFT[(i++) & 3];
	                    }
	                    else if (code < 55296 || code >= 57344) {
	                        blocks1[i >> 2] |= (224 | code >> 12) << SHIFT[(i++) & 3];
	                        blocks1[i >> 2] |= (128 | code >> 6 & 63) << SHIFT[(i++) & 3];
	                        blocks1[i >> 2] |= (128 | code & 63) << SHIFT[(i++) & 3];
	                    }
	                    else {
	                        code = 65536 + ((code & 1023) << 10 | msg.charCodeAt(++index) & 1023);
	                        blocks1[i >> 2] |= (240 | code >> 18) << SHIFT[(i++) & 3];
	                        blocks1[i >> 2] |= (128 | code >> 12 & 63) << SHIFT[(i++) & 3];
	                        blocks1[i >> 2] |= (128 | code >> 6 & 63) << SHIFT[(i++) & 3];
	                        blocks1[i >> 2] |= (128 | code & 63) << SHIFT[(i++) & 3];
	                    }
	                }
	            }
	            __classPrivateFieldSet(this, _lastByteIndex, i);
	            __classPrivateFieldSet(this, _bytes, __classPrivateFieldGet(this, _bytes) + (i - __classPrivateFieldGet(this, _start)));
	            if (i >= 64) {
	                __classPrivateFieldSet(this, _block, blocks1[16]);
	                __classPrivateFieldSet(this, _start, i - 64);
	                this.hash();
	                __classPrivateFieldSet(this, _hashed, true);
	            }
	            else {
	                __classPrivateFieldSet(this, _start, i);
	            }
	        }
	        if (__classPrivateFieldGet(this, _bytes) > 4294967295) {
	            __classPrivateFieldSet(this, _hBytes, __classPrivateFieldGet(this, _hBytes) + (__classPrivateFieldGet(this, _bytes) / 4294967296 << 0));
	            __classPrivateFieldSet(this, _bytes, __classPrivateFieldGet(this, _bytes) % 4294967296);
	        }
	        return this;
	    };
	    Sha256.prototype.finalize = function () {
	        if (__classPrivateFieldGet(this, _finalized)) {
	            return;
	        }
	        __classPrivateFieldSet(this, _finalized, true);
	        var blocks1 = __classPrivateFieldGet(this, _blocks);
	        var i = __classPrivateFieldGet(this, _lastByteIndex);
	        blocks1[16] = __classPrivateFieldGet(this, _block);
	        blocks1[i >> 2] |= EXTRA[i & 3];
	        __classPrivateFieldSet(this, _block, blocks1[16]);
	        if (i >= 56) {
	            if (!__classPrivateFieldGet(this, _hashed)) {
	                this.hash();
	            }
	            blocks1[0] = __classPrivateFieldGet(this, _block);
	            blocks1[16] = blocks1[1] = blocks1[2] = blocks1[3] = blocks1[4] = blocks1[5] = blocks1[6] = blocks1[7] = blocks1[8] = blocks1[9] = blocks1[10] = blocks1[11] = blocks1[12] = blocks1[13] = blocks1[14] = blocks1[15] = 0;
	        }
	        blocks1[14] = __classPrivateFieldGet(this, _hBytes) << 3 | __classPrivateFieldGet(this, _bytes) >>> 29;
	        blocks1[15] = __classPrivateFieldGet(this, _bytes) << 3;
	        this.hash();
	    };
	    Sha256.prototype.hash = function () {
	        var a = __classPrivateFieldGet(this, _h0);
	        var b = __classPrivateFieldGet(this, _h1);
	        var c = __classPrivateFieldGet(this, _h2);
	        var d = __classPrivateFieldGet(this, _h3);
	        var e = __classPrivateFieldGet(this, _h4);
	        var f = __classPrivateFieldGet(this, _h5);
	        var g = __classPrivateFieldGet(this, _h6);
	        var h = __classPrivateFieldGet(this, _h7);
	        var blocks1 = __classPrivateFieldGet(this, _blocks);
	        var s0;
	        var s1;
	        var maj;
	        var t1;
	        var t2;
	        var ch;
	        var ab;
	        var da;
	        var cd;
	        var bc;
	        for (var j = 16; j < 64; ++j) {
	            t1 = blocks1[j - 15];
	            s0 = (t1 >>> 7 | t1 << 25) ^ (t1 >>> 18 | t1 << 14) ^ t1 >>> 3;
	            t1 = blocks1[j - 2];
	            s1 = (t1 >>> 17 | t1 << 15) ^ (t1 >>> 19 | t1 << 13) ^ t1 >>> 10;
	            blocks1[j] = blocks1[j - 16] + s0 + blocks1[j - 7] + s1 << 0;
	        }
	        bc = b & c;
	        for (var j1 = 0; j1 < 64; j1 += 4) {
	            if (__classPrivateFieldGet(this, _first)) {
	                if (__classPrivateFieldGet(this, _is224)) {
	                    ab = 300032;
	                    t1 = blocks1[0] - 1413257819;
	                    h = t1 - 150054599 << 0;
	                    d = t1 + 24177077 << 0;
	                }
	                else {
	                    ab = 704751109;
	                    t1 = blocks1[0] - 210244248;
	                    h = t1 - 1521486534 << 0;
	                    d = t1 + 143694565 << 0;
	                }
	                __classPrivateFieldSet(this, _first, false);
	            }
	            else {
	                s0 = (a >>> 2 | a << 30) ^ (a >>> 13 | a << 19) ^ (a >>> 22 | a << 10);
	                s1 = (e >>> 6 | e << 26) ^ (e >>> 11 | e << 21) ^ (e >>> 25 | e << 7);
	                ab = a & b;
	                maj = ab ^ a & c ^ bc;
	                ch = e & f ^ ~e & g;
	                t1 = h + s1 + ch + K[j1] + blocks1[j1];
	                t2 = s0 + maj;
	                h = d + t1 << 0;
	                d = t1 + t2 << 0;
	            }
	            s0 = (d >>> 2 | d << 30) ^ (d >>> 13 | d << 19) ^ (d >>> 22 | d << 10);
	            s1 = (h >>> 6 | h << 26) ^ (h >>> 11 | h << 21) ^ (h >>> 25 | h << 7);
	            da = d & a;
	            maj = da ^ d & b ^ ab;
	            ch = h & e ^ ~h & f;
	            t1 = g + s1 + ch + K[j1 + 1] + blocks1[j1 + 1];
	            t2 = s0 + maj;
	            g = c + t1 << 0;
	            c = t1 + t2 << 0;
	            s0 = (c >>> 2 | c << 30) ^ (c >>> 13 | c << 19) ^ (c >>> 22 | c << 10);
	            s1 = (g >>> 6 | g << 26) ^ (g >>> 11 | g << 21) ^ (g >>> 25 | g << 7);
	            cd = c & d;
	            maj = cd ^ c & a ^ da;
	            ch = g & h ^ ~g & e;
	            t1 = f + s1 + ch + K[j1 + 2] + blocks1[j1 + 2];
	            t2 = s0 + maj;
	            f = b + t1 << 0;
	            b = t1 + t2 << 0;
	            s0 = (b >>> 2 | b << 30) ^ (b >>> 13 | b << 19) ^ (b >>> 22 | b << 10);
	            s1 = (f >>> 6 | f << 26) ^ (f >>> 11 | f << 21) ^ (f >>> 25 | f << 7);
	            bc = b & c;
	            maj = bc ^ b & d ^ cd;
	            ch = f & g ^ ~f & h;
	            t1 = e + s1 + ch + K[j1 + 3] + blocks1[j1 + 3];
	            t2 = s0 + maj;
	            e = a + t1 << 0;
	            a = t1 + t2 << 0;
	        }
	        __classPrivateFieldSet(this, _h0, __classPrivateFieldGet(this, _h0) + a << 0);
	        __classPrivateFieldSet(this, _h1, __classPrivateFieldGet(this, _h1) + b << 0);
	        __classPrivateFieldSet(this, _h2, __classPrivateFieldGet(this, _h2) + c << 0);
	        __classPrivateFieldSet(this, _h3, __classPrivateFieldGet(this, _h3) + d << 0);
	        __classPrivateFieldSet(this, _h4, __classPrivateFieldGet(this, _h4) + e << 0);
	        __classPrivateFieldSet(this, _h5, __classPrivateFieldGet(this, _h5) + f << 0);
	        __classPrivateFieldSet(this, _h6, __classPrivateFieldGet(this, _h6) + g << 0);
	        __classPrivateFieldSet(this, _h7, __classPrivateFieldGet(this, _h7) + h << 0);
	    };
	    Sha256.prototype.hex = function () {
	        this.finalize();
	        var h0 = __classPrivateFieldGet(this, _h0);
	        var h1 = __classPrivateFieldGet(this, _h1);
	        var h2 = __classPrivateFieldGet(this, _h2);
	        var h3 = __classPrivateFieldGet(this, _h3);
	        var h4 = __classPrivateFieldGet(this, _h4);
	        var h5 = __classPrivateFieldGet(this, _h5);
	        var h6 = __classPrivateFieldGet(this, _h6);
	        var h7 = __classPrivateFieldGet(this, _h7);
	        var hex = HEX_CHARS[h0 >> 28 & 15] + HEX_CHARS[h0 >> 24 & 15] + HEX_CHARS[h0 >> 20 & 15] + HEX_CHARS[h0 >> 16 & 15] + HEX_CHARS[h0 >> 12 & 15] + HEX_CHARS[h0 >> 8 & 15] + HEX_CHARS[h0 >> 4 & 15] + HEX_CHARS[h0 & 15] + HEX_CHARS[h1 >> 28 & 15] + HEX_CHARS[h1 >> 24 & 15] + HEX_CHARS[h1 >> 20 & 15] + HEX_CHARS[h1 >> 16 & 15] + HEX_CHARS[h1 >> 12 & 15] + HEX_CHARS[h1 >> 8 & 15] + HEX_CHARS[h1 >> 4 & 15] + HEX_CHARS[h1 & 15] + HEX_CHARS[h2 >> 28 & 15] + HEX_CHARS[h2 >> 24 & 15] + HEX_CHARS[h2 >> 20 & 15] + HEX_CHARS[h2 >> 16 & 15] + HEX_CHARS[h2 >> 12 & 15] + HEX_CHARS[h2 >> 8 & 15] + HEX_CHARS[h2 >> 4 & 15] + HEX_CHARS[h2 & 15] + HEX_CHARS[h3 >> 28 & 15] + HEX_CHARS[h3 >> 24 & 15] + HEX_CHARS[h3 >> 20 & 15] + HEX_CHARS[h3 >> 16 & 15] + HEX_CHARS[h3 >> 12 & 15] + HEX_CHARS[h3 >> 8 & 15] + HEX_CHARS[h3 >> 4 & 15] + HEX_CHARS[h3 & 15] + HEX_CHARS[h4 >> 28 & 15] + HEX_CHARS[h4 >> 24 & 15] + HEX_CHARS[h4 >> 20 & 15] + HEX_CHARS[h4 >> 16 & 15] + HEX_CHARS[h4 >> 12 & 15] + HEX_CHARS[h4 >> 8 & 15] + HEX_CHARS[h4 >> 4 & 15] + HEX_CHARS[h4 & 15] + HEX_CHARS[h5 >> 28 & 15] + HEX_CHARS[h5 >> 24 & 15] + HEX_CHARS[h5 >> 20 & 15] + HEX_CHARS[h5 >> 16 & 15] + HEX_CHARS[h5 >> 12 & 15] + HEX_CHARS[h5 >> 8 & 15] + HEX_CHARS[h5 >> 4 & 15] + HEX_CHARS[h5 & 15] + HEX_CHARS[h6 >> 28 & 15] + HEX_CHARS[h6 >> 24 & 15] + HEX_CHARS[h6 >> 20 & 15] + HEX_CHARS[h6 >> 16 & 15] + HEX_CHARS[h6 >> 12 & 15] + HEX_CHARS[h6 >> 8 & 15] + HEX_CHARS[h6 >> 4 & 15] + HEX_CHARS[h6 & 15];
	        if (!__classPrivateFieldGet(this, _is224)) {
	            hex += HEX_CHARS[h7 >> 28 & 15] + HEX_CHARS[h7 >> 24 & 15] + HEX_CHARS[h7 >> 20 & 15] + HEX_CHARS[h7 >> 16 & 15] + HEX_CHARS[h7 >> 12 & 15] + HEX_CHARS[h7 >> 8 & 15] + HEX_CHARS[h7 >> 4 & 15] + HEX_CHARS[h7 & 15];
	        }
	        return hex;
	    };
	    Sha256.prototype.toString = function () {
	        return this.hex();
	    };
	    Sha256.prototype.digest = function () {
	        this.finalize();
	        var h0 = __classPrivateFieldGet(this, _h0);
	        var h1 = __classPrivateFieldGet(this, _h1);
	        var h2 = __classPrivateFieldGet(this, _h2);
	        var h3 = __classPrivateFieldGet(this, _h3);
	        var h4 = __classPrivateFieldGet(this, _h4);
	        var h5 = __classPrivateFieldGet(this, _h5);
	        var h6 = __classPrivateFieldGet(this, _h6);
	        var h7 = __classPrivateFieldGet(this, _h7);
	        var arr = [
	            h0 >> 24 & 255,
	            h0 >> 16 & 255,
	            h0 >> 8 & 255,
	            h0 & 255,
	            h1 >> 24 & 255,
	            h1 >> 16 & 255,
	            h1 >> 8 & 255,
	            h1 & 255,
	            h2 >> 24 & 255,
	            h2 >> 16 & 255,
	            h2 >> 8 & 255,
	            h2 & 255,
	            h3 >> 24 & 255,
	            h3 >> 16 & 255,
	            h3 >> 8 & 255,
	            h3 & 255,
	            h4 >> 24 & 255,
	            h4 >> 16 & 255,
	            h4 >> 8 & 255,
	            h4 & 255,
	            h5 >> 24 & 255,
	            h5 >> 16 & 255,
	            h5 >> 8 & 255,
	            h5 & 255,
	            h6 >> 24 & 255,
	            h6 >> 16 & 255,
	            h6 >> 8 & 255,
	            h6 & 255,
	        ];
	        if (!__classPrivateFieldGet(this, _is224)) {
	            arr.push(h7 >> 24 & 255, h7 >> 16 & 255, h7 >> 8 & 255, h7 & 255);
	        }
	        return arr;
	    };
	    Sha256.prototype.array = function () {
	        return this.digest();
	    };
	    Sha256.prototype.arrayBuffer = function () {
	        this.finalize();
	        var buffer = new ArrayBuffer(__classPrivateFieldGet(this, _is224) ? 28 : 32);
	        var dataView = new DataView(buffer);
	        dataView.setUint32(0, __classPrivateFieldGet(this, _h0));
	        dataView.setUint32(4, __classPrivateFieldGet(this, _h1));
	        dataView.setUint32(8, __classPrivateFieldGet(this, _h2));
	        dataView.setUint32(12, __classPrivateFieldGet(this, _h3));
	        dataView.setUint32(16, __classPrivateFieldGet(this, _h4));
	        dataView.setUint32(20, __classPrivateFieldGet(this, _h5));
	        dataView.setUint32(24, __classPrivateFieldGet(this, _h6));
	        if (!__classPrivateFieldGet(this, _is224)) {
	            dataView.setUint32(28, __classPrivateFieldGet(this, _h7));
	        }
	        return buffer;
	    };
	    return Sha256;
	}());
	_block = new WeakMap(), _blocks = new WeakMap(), _bytes = new WeakMap(), _finalized = new WeakMap(), _first = new WeakMap(), _h0 = new WeakMap(), _h1 = new WeakMap(), _h2 = new WeakMap(), _h3 = new WeakMap(), _h4 = new WeakMap(), _h5 = new WeakMap(), _h6 = new WeakMap(), _h7 = new WeakMap(), _hashed = new WeakMap(), _hBytes = new WeakMap(), _is224 = new WeakMap(), _lastByteIndex = new WeakMap(), _start = new WeakMap();
	var HmacSha256 = /** @class */ (function (_super) {
	    __extends(HmacSha256, _super);
	    function HmacSha256(secretKey, is2242, sharedMemory2) {
	        if (is2242 === void 0) { is2242 = false; }
	        if (sharedMemory2 === void 0) { sharedMemory2 = false; }
	        var _this = _super.call(this, is2242, sharedMemory2) || this;
	        _inner.set(_this, void 0);
	        _is224_1.set(_this, void 0);
	        _oKeyPad.set(_this, void 0);
	        _sharedMemory.set(_this, void 0);
	        var key;
	        if (typeof secretKey === "string") {
	            var bytes = [];
	            var length_1 = secretKey.length;
	            var index = 0;
	            for (var i = 0; i < length_1; ++i) {
	                var code = secretKey.charCodeAt(i);
	                if (code < 128) {
	                    bytes[index++] = code;
	                }
	                else if (code < 2048) {
	                    bytes[index++] = 192 | code >> 6;
	                    bytes[index++] = 128 | code & 63;
	                }
	                else if (code < 55296 || code >= 57344) {
	                    bytes[index++] = 224 | code >> 12;
	                    bytes[index++] = 128 | code >> 6 & 63;
	                    bytes[index++] = 128 | code & 63;
	                }
	                else {
	                    code = 65536 + ((code & 1023) << 10 | secretKey.charCodeAt(++i) & 1023);
	                    bytes[index++] = 240 | code >> 18;
	                    bytes[index++] = 128 | code >> 12 & 63;
	                    bytes[index++] = 128 | code >> 6 & 63;
	                    bytes[index++] = 128 | code & 63;
	                }
	            }
	            key = bytes;
	        }
	        else {
	            if (secretKey instanceof ArrayBuffer) {
	                key = new Uint8Array(secretKey);
	            }
	            else {
	                key = secretKey;
	            }
	        }
	        if (key.length > 64) {
	            key = new Sha256(is2242, true).update(key).array();
	        }
	        var oKeyPad = [];
	        var iKeyPad = [];
	        for (var i = 0; i < 64; ++i) {
	            var b = key[i] || 0;
	            oKeyPad[i] = 92 ^ b;
	            iKeyPad[i] = 54 ^ b;
	        }
	        _this.update(iKeyPad);
	        __classPrivateFieldSet(_this, _oKeyPad, oKeyPad);
	        __classPrivateFieldSet(_this, _inner, true);
	        __classPrivateFieldSet(_this, _is224_1, is2242);
	        __classPrivateFieldSet(_this, _sharedMemory, sharedMemory2);
	        return _this;
	    }
	    HmacSha256.prototype.finalize = function () {
	        _super.prototype.finalize.call(this);
	        if (__classPrivateFieldGet(this, _inner)) {
	            __classPrivateFieldSet(this, _inner, false);
	            var innerHash = this.array();
	            _super.prototype.init.call(this, __classPrivateFieldGet(this, _is224_1), __classPrivateFieldGet(this, _sharedMemory));
	            this.update(__classPrivateFieldGet(this, _oKeyPad));
	            this.update(innerHash);
	            _super.prototype.finalize.call(this);
	        }
	    };
	    return HmacSha256;
	}(Sha256));
	_inner = new WeakMap(), _is224_1 = new WeakMap(), _oKeyPad = new WeakMap(), _sharedMemory = new WeakMap();
	function Sha256ToInt(s) {
	    var sha256 = new Sha256();
	    sha256.update(s);
	    return parseInt(sha256.hex().substring(0, 8), 16);
	}
	var RGB2HEX = function (RGBArray) {
	    var hex = '#';
	    RGBArray.forEach(function (value) {
	        if (value < 16) {
	            hex += 0;
	        }
	        hex += value.toString(16);
	    });
	    return hex;
	};
	var HSL2RGB = function (H, S, L) {
	    H /= 360;
	    var q = L < 0.5 ? L * (1 + S) : L + S - L * S;
	    var p = 2 * L - q;
	    return [
	        H + 1 / 3,
	        H,
	        H - 1 / 3
	    ].map(function (color) {
	        if (color < 0) {
	            color++;
	        }
	        if (color > 1) {
	            color--;
	        }
	        if (color < 1 / 6) {
	            color = p + (q - p) * 6 * color;
	        }
	        else if (color < 0.5) {
	            color = q;
	        }
	        else if (color < 2 / 3) {
	            color = p + (q - p) * 6 * (2 / 3 - color);
	        }
	        else {
	            color = p;
	        }
	        return Math.round(color * 255);
	    });
	};
	var ColorHash = /** @class */ (function () {
	    function ColorHash(options) {
	        if (options === void 0) { options = {}; }
	        var _a = [
	            options.lightness,
	            options.saturation
	        ].map(function (param) {
	            param = param !== undefined ? param : [
	                0.35,
	                0.5,
	                0.65
	            ];
	            return Array.isArray(param) ? param.concat() : [
	                param
	            ];
	        }), L = _a[0], S = _a[1];
	        this.L = L;
	        this.S = S;
	        if (typeof options.hue === 'number') {
	            options.hue = {
	                min: options.hue,
	                max: options.hue
	            };
	        }
	        if (typeof options.hue === 'object' && !Array.isArray(options.hue)) {
	            options.hue = [
	                options.hue
	            ];
	        }
	        if (typeof options.hue === 'undefined') {
	            options.hue = [];
	        }
	        this.hueRanges = options.hue.map(function (range) {
	            return {
	                min: typeof range.min === 'undefined' ? 0 : range.min,
	                max: typeof range.max === 'undefined' ? 360 : range.max
	            };
	        });
	        this.hash = Sha256ToInt;
	        if (typeof options.hash === 'function') {
	            this.hash = options.hash;
	        }
	        if (options.hash === 'bkdr') {
	            this.hash = BKDRHash;
	        }
	    }
	    ColorHash.prototype.hsl = function (str) {
	        var H, S1, L1;
	        var hash = this.hash(str);
	        var hueResolution = 727;
	        if (this.hueRanges.length) {
	            var range = this.hueRanges[hash % this.hueRanges.length];
	            H = hash / this.hueRanges.length % hueResolution * (range.max - range.min) / hueResolution + range.min;
	        }
	        else {
	            H = hash % 359;
	        }
	        hash = Math.ceil(hash / 360);
	        S1 = this.S[hash % this.S.length];
	        hash = Math.ceil(hash / this.S.length);
	        L1 = this.L[hash % this.L.length];
	        return [
	            H,
	            S1,
	            L1
	        ];
	    };
	    ColorHash.prototype.rgb = function (str) {
	        var hsl = this.hsl(str);
	        return HSL2RGB.apply(this, hsl);
	    };
	    ColorHash.prototype.hex = function (str) {
	        var rgb = this.rgb(str);
	        return RGB2HEX(rgb);
	    };
	    return ColorHash;
	}());
	exports["default"] = ColorHash;


/***/ }),
/* 2637 */
/***/ (function(module, exports, __webpack_require__) {

	var baseAssignValue = __webpack_require__(772),
	    createAggregator = __webpack_require__(991);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Creates an object composed of keys generated from the results of running
	 * each element of `collection` thru `iteratee`. The order of grouped values
	 * is determined by the order they occur in `collection`. The corresponding
	 * value of each key is an array of elements responsible for generating the
	 * key. The iteratee is invoked with one argument: (value).
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	 * @returns {Object} Returns the composed aggregate object.
	 * @example
	 *
	 * _.groupBy([6.1, 4.2, 6.3], Math.floor);
	 * // => { '4': [4.2], '6': [6.1, 6.3] }
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.groupBy(['one', 'two', 'three'], 'length');
	 * // => { '3': ['one', 'two'], '5': ['three'] }
	 */
	var groupBy = createAggregator(function(result, value, key) {
	  if (hasOwnProperty.call(result, key)) {
	    result[key].push(value);
	  } else {
	    baseAssignValue(result, key, [value]);
	  }
	});
	
	module.exports = groupBy;


/***/ }),
/* 2638 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _injectedSelect = __webpack_require__(1874);
	
	var _injectedSelect2 = _interopRequireDefault(_injectedSelect);
	
	var _materialUi = __webpack_require__(576);
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BoxOfficePosFilter = function (_React$Component) {
	  _inherits(BoxOfficePosFilter, _React$Component);
	
	  function BoxOfficePosFilter() {
	    _classCallCheck(this, BoxOfficePosFilter);
	
	    return _possibleConstructorReturn(this, Object.getPrototypeOf(BoxOfficePosFilter).apply(this, arguments));
	  }
	
	  _createClass(BoxOfficePosFilter, [{
	    key: "getStyles",
	    value: function getStyles() {
	      return {
	        filterContainer: {
	          display: "flex"
	        },
	        venueSelectorContainer: {
	          display: "flex",
	          backgroundColor: "rgba(0,0,0,0.1)",
	          padding: "10px 20px",
	          borderRadius: 5
	        }
	      };
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var styles = this.getStyles();
	
	      return _react2.default.createElement(
	        "div",
	        { style: styles.venueSelectorContainer },
	        _react2.default.createElement(
	          "span",
	          { style: { marginRight: 10 } },
	          _react2.default.createElement(
	            "span",
	            {
	              className: "Select-control flex items-center",
	              style: { width: 175, boxSizing: "border-box" }
	            },
	            _react2.default.createElement(
	              "svg",
	              {
	                xmlns: "http://www.w3.org/2000/svg",
	                viewBox: "0 0 20 20",
	                fill: "currentColor",
	                className: "flex-shrink-0 w-4 h-4 ml-2 mr-1 -my-2"
	              },
	              _react2.default.createElement("path", {
	                fillRule: "evenodd",
	                d: "M9 3.5a5.5 5.5 0 100 11 5.5 5.5 0 000-11zM2 9a7 7 0 1112.452 4.391l3.328 3.329a.75.75 0 11-1.06 1.06l-3.329-3.328A7 7 0 012 9z",
	                clipRule: "evenodd"
	              })
	            ),
	            _react2.default.createElement("input", {
	              className: "BoxOffice--PosMode--SearchInput flex-1 min-w-0",
	              type: "text",
	              value: this.props.filterText,
	              onChange: function onChange(e) {
	                return _this2.props.updateFilterText(e.target.value);
	              },
	              placeholder: "Search events",
	              style: {
	                border: "none",
	                outline: "none"
	              }
	            }),
	            this.props.filterText ? _react2.default.createElement(
	              "span",
	              {
	                className: "Select-clear-zone flex-shrink-0",
	                onClick: function onClick() {
	                  _this2.props.updateFilterText("");
	                }
	              },
	              _react2.default.createElement(
	                "span",
	                { className: "Select-clear" },
	                "\xD7"
	              )
	            ) : null
	          )
	        ),
	        _react2.default.createElement(
	          "span",
	          { style: { flex: 1 } },
	          _react2.default.createElement(_injectedSelect2.default, {
	            autosize: false,
	            value: this.props.posConfig.selectedVenueId,
	            style: { maxWidth: 175 },
	            placeholder: "All venues",
	            type: "venues",
	            labelFormatter: function labelFormatter(v) {
	              return "" + v.name;
	            },
	            eventBucketId: this.props.orderData.event_bucket,
	            sortFunction: function sortFunction(a, b) {
	              return a.label.localeCompare(b.label);
	            },
	            onChange: function onChange(selectedVenueId) {
	              _this2.props.updatePosConfig(_extends({}, _this2.props.posConfig, {
	                selectedVenueId: selectedVenueId
	              }));
	            }
	          })
	        ),
	        _react2.default.createElement(
	          "span",
	          null,
	          _react2.default.createElement(_materialUi.Checkbox, {
	            label: "Today only",
	            style: { width: 95, marginLeft: 20 },
	            iconStyle: { marginRight: 4 },
	            labelStyle: { width: "100%" },
	            checked: this.props.posConfig.todayOnly,
	            onCheck: function onCheck(e) {
	              _this2.props.updatePosConfig(_extends({}, _this2.props.posConfig, {
	                todayOnly: e.target.checked
	              }));
	            }
	          })
	        ),
	        _react2.default.createElement(
	          "span",
	          null,
	          _react2.default.createElement(_materialUi.Checkbox, {
	            label: "Filter by tag" + (this.props.posConfig.filterByTag ? "s:" : ""),
	            style: {
	              width: this.props.posConfig.filterByTag ? 120 : 102,
	              marginLeft: 20
	            },
	            iconStyle: { marginRight: 4 },
	            labelStyle: { width: "100%" },
	            checked: this.props.posConfig.filterByTag,
	            onCheck: function onCheck(e) {
	              _this2.props.updatePosConfig(_extends({}, _this2.props.posConfig, {
	                filterByTag: e.target.checked
	              }));
	            }
	          })
	        ),
	        this.props.posConfig.filterByTag ? _react2.default.createElement(_injectedSelect2.default, {
	          autosize: false,
	          multi: true,
	          value: this.props.posConfig.selectedTagIds || [],
	          style: {
	            width: 200
	          },
	          placeholder: "All tags",
	          type: "tags",
	          labelFormatter: function labelFormatter(v) {
	            return "" + v.name;
	          },
	          eventBucketId: this.props.orderData.event_bucket,
	          sortFunction: function sortFunction(a, b) {
	            return a.label.localeCompare(b.label);
	          },
	          onChange: function onChange(selectedTagIds) {
	            _this2.props.updatePosConfig(_extends({}, _this2.props.posConfig, {
	              selectedTagIds: selectedTagIds
	            }));
	          }
	        }) : null
	      );
	    }
	  }]);
	
	  return BoxOfficePosFilter;
	}(_react2.default.Component);
	
	exports.default = BoxOfficePosFilter;
	module.exports = exports["default"];

/***/ }),
/* 2639 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _injectedSelect = __webpack_require__(1874);
	
	var _injectedSelect2 = _interopRequireDefault(_injectedSelect);
	
	var _materialUi = __webpack_require__(576);
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BoxOfficeSundancePosFilter = function (_React$Component) {
	  _inherits(BoxOfficeSundancePosFilter, _React$Component);
	
	  function BoxOfficeSundancePosFilter() {
	    _classCallCheck(this, BoxOfficeSundancePosFilter);
	
	    return _possibleConstructorReturn(this, Object.getPrototypeOf(BoxOfficeSundancePosFilter).apply(this, arguments));
	  }
	
	  _createClass(BoxOfficeSundancePosFilter, [{
	    key: "getStyles",
	    value: function getStyles() {
	      return {
	        filterContainer: {
	          display: "flex"
	        },
	        venueSelectorContainer: {
	          display: "flex",
	          backgroundColor: "rgba(0,0,0,0.1)",
	          padding: "10px 20px",
	          borderRadius: 5,
	          flexDirection: "column"
	        }
	      };
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var styles = this.getStyles();
	
	      return _react2.default.createElement(
	        "div",
	        { style: styles.venueSelectorContainer },
	        _react2.default.createElement(
	          "div",
	          { style: styles.filterContainer },
	          _react2.default.createElement(
	            "div",
	            { style: { marginRight: 10 } },
	            _react2.default.createElement(
	              "div",
	              {
	                className: "Select-control flex items-center",
	                style: { width: 200, boxSizing: "border-box" }
	              },
	              _react2.default.createElement(
	                "svg",
	                {
	                  xmlns: "http://www.w3.org/2000/svg",
	                  viewBox: "0 0 20 20",
	                  fill: "currentColor",
	                  className: "flex-shrink-0 w-4 h-4 ml-2 mr-1 -my-2"
	                },
	                _react2.default.createElement("path", {
	                  fillRule: "evenodd",
	                  d: "M9 3.5a5.5 5.5 0 100 11 5.5 5.5 0 000-11zM2 9a7 7 0 1112.452 4.391l3.328 3.329a.75.75 0 11-1.06 1.06l-3.329-3.328A7 7 0 012 9z",
	                  clipRule: "evenodd"
	                })
	              ),
	              _react2.default.createElement("input", {
	                className: "BoxOffice--PosMode--SearchInput flex-1 min-w-0",
	                type: "text",
	                value: this.props.filterText,
	                onChange: function onChange(e) {
	                  return _this2.props.updateFilterText(e.target.value);
	                },
	                placeholder: "Search events",
	                style: {
	                  border: "none",
	                  outline: "none"
	                }
	              }),
	              this.props.filterText ? _react2.default.createElement(
	                "span",
	                {
	                  className: "Select-clear-zone flex-shrink-0",
	                  onClick: function onClick() {
	                    _this2.props.updateFilterText("");
	                  }
	                },
	                _react2.default.createElement(
	                  "span",
	                  { className: "Select-clear" },
	                  "\xD7"
	                )
	              ) : null
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { style: { marginRight: 10 } },
	            _react2.default.createElement(_injectedSelect2.default, {
	              autosize: false,
	              value: this.props.posConfig.selectedVenueId,
	              style: { width: 200 },
	              placeholder: "All venues",
	              type: "venues",
	              labelFormatter: function labelFormatter(v) {
	                return "" + v.name;
	              },
	              eventBucketId: this.props.orderData.event_bucket,
	              sortFunction: function sortFunction(a, b) {
	                return a.label.localeCompare(b.label);
	              },
	              onChange: function onChange(selectedVenueId) {
	                _this2.props.updatePosConfig(_extends({}, _this2.props.posConfig, {
	                  selectedVenueId: selectedVenueId
	                }));
	              }
	            })
	          ),
	          _react2.default.createElement(
	            "div",
	            { style: { flex: 1 } },
	            _react2.default.createElement(_injectedSelect2.default, {
	              autosize: false,
	              multi: true,
	              value: this.props.posConfig.selectedTagIds || [],
	              style: {
	                width: 200
	              },
	              placeholder: "All tags",
	              type: "tags",
	              labelFormatter: function labelFormatter(v) {
	                return "" + v.name;
	              },
	              eventBucketId: this.props.orderData.event_bucket,
	              sortFunction: function sortFunction(a, b) {
	                return a.label.localeCompare(b.label);
	              },
	              onChange: function onChange(selectedTagIds) {
	                _this2.props.updatePosConfig(_extends({}, _this2.props.posConfig, {
	                  selectedTagIds: selectedTagIds
	                }));
	              }
	            })
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { style: _extends({ marginTop: 5, alignItems: "center", height: 36 }, styles.filterContainer) },
	          this.props.isSundance && _react2.default.createElement(_materialUi.Checkbox, {
	            label: "Public Tickets Only",
	            style: { width: 150 },
	            iconStyle: { marginRight: 4 },
	            labelStyle: { width: "100%" },
	            checked: this.props.posConfig.publicTicketsOnly,
	            onCheck: function onCheck(e) {
	              _this2.props.updatePosConfig(_extends({}, _this2.props.posConfig, {
	                publicTicketsOnly: e.target.checked
	              }));
	            }
	          }),
	          _react2.default.createElement(_materialUi.Checkbox, {
	            label: "Today only",
	            style: { width: 125, marginLeft: this.props.isSundance ? 20 : 0 },
	            iconStyle: { marginRight: 4 },
	            labelStyle: { width: "100%" },
	            checked: this.props.posConfig.todayOnly,
	            onCheck: function onCheck(e) {
	              _this2.props.updatePosConfig(_extends({}, _this2.props.posConfig, {
	                todayOnly: e.target.checked
	              }));
	            }
	          })
	        )
	      );
	    }
	  }]);
	
	  return BoxOfficeSundancePosFilter;
	}(_react2.default.Component);
	
	exports.default = BoxOfficeSundancePosFilter;
	module.exports = exports["default"];

/***/ }),
/* 2640 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _get = __webpack_require__(1004);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _materialUi = __webpack_require__(576);
	
	var _supplementaryDataModal = __webpack_require__(2269);
	
	var _supplementaryDataModal2 = _interopRequireDefault(_supplementaryDataModal);
	
	var _connectToStores = __webpack_require__(1226);
	
	var _connectToStores2 = _interopRequireDefault(_connectToStores);
	
	var _PassBucketStore = __webpack_require__(1867);
	
	var _PassBucketStore2 = _interopRequireDefault(_PassBucketStore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BoxOfficePassSetup = function (_React$Component) {
	  _inherits(BoxOfficePassSetup, _React$Component);
	
	  function BoxOfficePassSetup(props) {
	    _classCallCheck(this, BoxOfficePassSetup);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(BoxOfficePassSetup).call(this, props));
	
	    _this.state = {
	      editing: null
	    };
	
	    _this.edit = _this.edit.bind(_this);
	    _this.closeEditor = _this.closeEditor.bind(_this);
	    _this.updatePass = _this.updatePass.bind(_this);
	    return _this;
	  }
	
	  _createClass(BoxOfficePassSetup, [{
	    key: "edit",
	    value: function edit(subitemIndex, passIndex) {
	      this.setState({
	        editing: {
	          subitem: subitemIndex,
	          pass: passIndex
	        }
	      });
	    }
	  }, {
	    key: "closeEditor",
	    value: function closeEditor() {
	      this.setState({
	        editing: null
	      });
	    }
	  }, {
	    key: "updatePass",
	    value: function updatePass(subitemIndex, passIndex, content) {
	      var subitems = this.props.orderData.subitems.slice();
	
	      // Fill array with null values if necessary
	      if (!subitems[subitemIndex].names) {
	        subitems[subitemIndex].names = [];
	      }
	      if (!subitems[subitemIndex].supplementary_datas) {
	        subitems[subitemIndex].supplementary_datas = [];
	      }
	      while (subitems[subitemIndex].names.length <= passIndex) {
	        subitems[subitemIndex].names.push(undefined);
	      }
	      while (subitems[subitemIndex].supplementary_datas.length <= passIndex) {
	        subitems[subitemIndex].supplementary_datas.push(undefined);
	      }
	
	      subitems[subitemIndex].names[passIndex] = content.name;
	      subitems[subitemIndex].supplementary_datas[passIndex] = content.supplementary_data;
	
	      this.props.updateCurrentOrder({
	        subitems: subitems
	      });
	    }
	  }, {
	    key: "getStyles",
	    value: function getStyles() {
	      return {
	        editPassButton: {
	          border: "1px solid",
	          lineHeight: "33px",
	          marginRight: 7
	        }
	      };
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var styles = this.getStyles();
	      var _props = this.props;
	      var orderData = _props.orderData;
	      var headerStyle = _props.headerStyle;
	      var membershipsEnabled = _props.membershipsEnabled;
	      var passBucketIndices = orderData.subitems ? orderData.subitems.map(function (s, i) {
	        return s.pass_bucket || s.memberships ? i : null;
	      }).filter(function (s) {
	        return s !== null;
	      }) : [];
	
	      if (!passBucketIndices.length) {
	        return null;
	      }
	
	      if (orderData.customerType === "groupSales") {
	        return null;
	      }
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        this.state.editing ? _react2.default.createElement(_supplementaryDataModal2.default, {
	          pass: {
	            name: (0, _get2.default)(orderData, "subitems[" + this.state.editing.subitem + "].names[" + this.state.editing.pass + "]"),
	            supplementary_data: (0, _get2.default)(orderData, "subitems[" + this.state.editing.subitem + "].supplementary_datas[" + this.state.editing.pass + "]", {}),
	            pass_bucket: this.props.getPassBucketById((0, _get2.default)(orderData, "subitems[" + this.state.editing.subitem + "].pass_bucket") || (0, _get2.default)(orderData, "subitems[" + this.state.editing.subitem + "].memberships"))
	          },
	          onSubmit: function onSubmit(content) {
	            _this2.updatePass(_this2.state.editing.subitem, _this2.state.editing.pass, content);
	            _this2.closeEditor();
	          },
	          requestClose: function requestClose() {
	            return _this2.closeEditor();
	          }
	        }) : null,
	        _react2.default.createElement(
	          "div",
	          { style: headerStyle },
	          membershipsEnabled ? "Pass/Membership setup" : "Pass setup"
	        ),
	        _react2.default.createElement(
	          "p",
	          null,
	          "Select each new pass",
	          membershipsEnabled ? " or membership" : "",
	          " to edit the name & data associated with it."
	        ),
	        passBucketIndices.map(function (subitemIndex) {
	          var subitem = orderData.subitems[subitemIndex],
	              passBucket = subitem.memberships ? _this2.props.getPassBucketById(subitem.memberships) || { name: "Membership" } : _this2.props.getPassBucketById(subitem.pass_bucket) || { name: "Pass" };
	
	          return _react2.default.createElement(
	            "div",
	            { style: { marginTop: 7 } },
	            Array(subitem.quantity).fill().map(function (_, passIndex) {
	              return _react2.default.createElement(_materialUi.FlatButton, {
	                label: (0, _get2.default)(subitem, "names[" + passIndex + "]", passBucket.name + " #" + (passIndex + 1)),
	                onClick: function onClick() {
	                  return _this2.edit(subitemIndex, passIndex);
	                },
	                style: styles.editPassButton
	              });
	            })
	          );
	        })
	      );
	    }
	  }], [{
	    key: "getStores",
	    value: function getStores() {
	      return [_PassBucketStore2.default];
	    }
	  }, {
	    key: "getPropsFromStores",
	    value: function getPropsFromStores() {
	      return {
	        getPassBucketById: _PassBucketStore2.default.getPassBucketById
	      };
	    }
	  }]);
	
	  return BoxOfficePassSetup;
	}(_react2.default.Component);
	
	exports.default = (0, _connectToStores2.default)(BoxOfficePassSetup);
	module.exports = exports["default"];

/***/ }),
/* 2641 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _AutoComplete = __webpack_require__(619);
	
	var _AutoComplete2 = _interopRequireDefault(_AutoComplete);
	
	var _materialUi = __webpack_require__(576);
	
	var _label = __webpack_require__(1682);
	
	var _label2 = _interopRequireDefault(_label);
	
	var _creditCardEntry = __webpack_require__(1713);
	
	var _creditCardEntry2 = _interopRequireDefault(_creditCardEntry);
	
	var _boxOfficeGroupSalesEntry = __webpack_require__(2642);
	
	var _boxOfficeGroupSalesEntry2 = _interopRequireDefault(_boxOfficeGroupSalesEntry);
	
	var _connectToStores = __webpack_require__(1226);
	
	var _connectToStores2 = _interopRequireDefault(_connectToStores);
	
	var _PersonStore = __webpack_require__(2656);
	
	var _PersonStore2 = _interopRequireDefault(_PersonStore);
	
	var _PersonActions = __webpack_require__(2658);
	
	var _PersonActions2 = _interopRequireDefault(_PersonActions);
	
	var _PassStore = __webpack_require__(2048);
	
	var _PassStore2 = _interopRequireDefault(_PassStore);
	
	var _PassActions = __webpack_require__(2047);
	
	var _PassActions2 = _interopRequireDefault(_PassActions);
	
	var _UserStore = __webpack_require__(974);
	
	var _UserStore2 = _interopRequireDefault(_UserStore);
	
	var _util = __webpack_require__(1183);
	
	var _debounce = __webpack_require__(642);
	
	var _debounce2 = _interopRequireDefault(_debounce);
	
	var _api = __webpack_require__(1160);
	
	var _api2 = _interopRequireDefault(_api);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BoxOfficePayment = function (_React$Component) {
	  _inherits(BoxOfficePayment, _React$Component);
	
	  function BoxOfficePayment(props) {
	    _classCallCheck(this, BoxOfficePayment);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(BoxOfficePayment).call(this, props));
	
	    _this.state = {
	      autocompletePeople: [],
	      autoCompletePeopleUseServer: false,
	      autocompletePasses: [],
	      autoCompletePassesUseServer: false,
	      loadedPersonFromQuery: false,
	      loadedPassFromQuery: false
	    };
	
	    _this.onNewEmailQueryDebounced = (0, _debounce2.default)(_this.onNewEmailQuery.bind(_this), 500);
	    _this.onChangeEmail = _this.onChangeEmail.bind(_this);
	    _this.onChangeName = _this.onChangeName.bind(_this);
	    _this.onNewPassQueryDebounced = (0, _debounce2.default)(_this.onNewPassQuery.bind(_this), 500);
	    _this.onChangePassholder = _this.onChangePassholder.bind(_this);
	    _this.calculateMissingRequiredFields = _this.calculateMissingRequiredFields.bind(_this);
	    return _this;
	  }
	
	  _createClass(BoxOfficePayment, [{
	    key: "onNewEmailQuery",
	    value: function onNewEmailQuery(raw, processedData) {
	      var query = raw.text ? raw.text : raw;
	      if (query.length < 2) {
	        return;
	      }
	      _PersonActions2.default.fetchAutocomplete.defer(query);
	      this.props.updateCurrentOrder({
	        email: query
	      });
	    }
	  }, {
	    key: "onChangeEmail",
	    value: function onChangeEmail(raw, processedData) {
	      var missingRequiredFields = this.calculateMissingRequiredFields();
	
	      if (raw && raw.value) {
	        this.props.updateCurrentOrder({
	          missingRequiredFields: missingRequiredFields,
	          email: "",
	          person: raw.value // person object
	        });
	        this.props.updateCurrentOrder({
	          missingRequiredFields: missingRequiredFields,
	          paymentType: raw.value.details.payment_method_summary ? "saved" : null
	        });
	      } else {
	        this.props.updateCurrentOrder({
	          missingRequiredFields: missingRequiredFields,
	          person: null,
	          email: raw || ""
	        });
	        if (this.state.paymentType === "saved") {
	          this.props.updateCurrentOrder({ paymentType: "card" });
	        }
	      }
	    }
	  }, {
	    key: "onChangeName",
	    value: function onChangeName(raw) {
	      this.props.updateCurrentOrder({
	        name: raw
	      });
	      if (this.refs.cardEntry) {
	        this.refs.cardEntry.set({ name: raw });
	      }
	    }
	  }, {
	    key: "onNewPassQuery",
	    value: function onNewPassQuery(raw) {
	      var query = raw.text ? raw.text : raw;
	      if (query.length < 2) {
	        return;
	      }
	      _PassActions2.default.fetchAutocomplete.defer(query, this.props.eventBucket.id);
	    }
	  }, {
	    key: "onChangePassholder",
	    value: function onChangePassholder(raw) {
	      var missingRequiredFields = this.calculateMissingRequiredFields();
	
	      if (raw && raw.value) {
	        var person = _PersonStore2.default.getPersonById(raw.value.person.id);
	        this.props.updateCurrentOrder({
	          missingRequiredFields: missingRequiredFields,
	          pass: raw.value, // pass object
	          person: person
	        });
	        this.props.updateCurrentOrder({
	          missingRequiredFields: missingRequiredFields,
	          customerType: "passholder",
	          paymentType: person && person.details.payment_method_summary ? "saved" : null
	        });
	      } else {
	        this.props.updateCurrentOrder({
	          missingRequiredFields: missingRequiredFields,
	          person: null,
	          pass: null,
	          pass_data: null
	        });
	        if (this.state.paymentType === "saved") {
	          this.props.updateCurrentOrder({
	            missingRequiredFields: missingRequiredFields,
	            paymentType: "card"
	          });
	        }
	      }
	    }
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      // NOTE: These fetchAll calls are currently still needed for loadedPersonFromQuery and
	      //       loadedPassFromQuery URLS, but are no longer slowing down user interaction in the autocomplete dropdowns
	      _PersonActions2.default.fetchAll.defer();
	      _PassActions2.default.fetchAllForEventBucketIncludingGlobal.defer(this.props.eventBucket.id);
	      this.refs.cardEntry && this.refs.cardEntry.reset(); // reset
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(newProps) {
	      var _this2 = this;
	
	      // NOTE: These fetchAll calls are currently still needed for loadedPersonFromQuery and
	      //       loadedPassFromQuery URLS, but are no longer slowing down user interaction in the autocomplete dropdowns
	      var people = newProps.getPeople(),
	          passes = newProps.getPassesForEventBucketIncludingGlobal(newProps.eventBucket.id);
	
	      // obtain server side data if autocomplete people feature is turned on
	      var autocompletePeopleData = void 0;
	      if (newProps.eventBucket.frontend_config.box_office_performance && newProps.eventBucket.frontend_config.box_office_performance.autocomplete_people_server_side) {
	        autocompletePeopleData = newProps.getPeopleAutocomplete();
	      }
	
	      // obtain server side data if autocomplete passes feature is turned on
	      var autocompletePassesData = void 0;
	      if (newProps.eventBucket.frontend_config.box_office_performance && newProps.eventBucket.frontend_config.box_office_performance.autocomplete_passes_server_side) {
	        autocompletePassesData = newProps.getPassesAutocomplete();
	      }
	
	      this.setState({
	        autocompletePeople: autocompletePeopleData ? autocompletePeopleData : newProps.getPeople().map(function (p) {
	          return {
	            value: p,
	            text: "" + p.details.email + (p.details.name ? " (" + p.details.name + ")" : "")
	          };
	        }),
	        autocompletePeopleUseServer: autocompletePeopleData ? true : false,
	        autocompletePasses: autocompletePassesData ? autocompletePassesData : newProps.getPassesForEventBucketIncludingGlobal(newProps.eventBucket.id).map(function (p) {
	          return {
	            value: p,
	            text: p.name + " (" + p.pass_bucket.name + ")"
	          };
	        }),
	        autocompletePassesUseServer: autocompletePassesData ? true : false
	      });
	
	      if (!this.state.loadedPersonFromQuery && !this.state.loadedPassFromQuery && newProps.location && newProps.location.query) {
	        if (newProps.location.query.person) {
	          (function () {
	            var person = people.find(function (p) {
	              return p.id === newProps.location.query.person;
	            });
	            if (person) {
	              setTimeout(function () {
	                _this2.onChangeEmail({
	                  value: person
	                });
	              }, 0);
	              _this2.setState({ loadedPersonFromQuery: true });
	            }
	          })();
	        }
	        if (newProps.location.query.pass && people.length) {
	          (function () {
	            var pass = passes.find(function (p) {
	              return p.id === newProps.location.query.pass;
	            });
	            if (pass) {
	              setTimeout(function () {
	                _this2.onChangePassholder({
	                  value: pass
	                });
	              }, 0);
	              _this2.setState({ loadedPassFromQuery: true });
	            }
	          })();
	        }
	
	        if (newProps.terminalConnectionStatus === "connected" && !newProps.orderData.paymentType) {
	          setTimeout(function () {
	            return _this2.props.updateCurrentOrder({ paymentType: "terminal" });
	          }, 0);
	        }
	      }
	    }
	  }, {
	    key: "calculateMissingRequiredFields",
	    value: function calculateMissingRequiredFields() {
	      var _props = this.props;
	      var processedData = _props.processedData;
	      var orderData = _props.orderData;
	
	
	      if (processedData.mailingAddressRequired) {
	        if (!orderData.mailing_address || orderData.mailing_address.trim() === "") {
	          return true;
	        }
	
	        if (orderData.customerType === "standard" || orderData.customerType === "passholder") {
	          // make sure there is a person or an email
	          if (!orderData.person && (!orderData.email || orderData.email.trim() === "")) {
	            return true;
	          }
	        } else if (orderData.customerType === "groupSales") {
	          // make sure there is group data
	          if (!orderData.group_sale_data || orderData.group_sale_data.length < 1) return true;
	        }
	      }
	
	      if (processedData.phoneNumberRequired && (!orderData.phone_number || orderData.phone_number.trim() === "")) {
	        return true;
	      }
	
	      return false;
	    }
	  }, {
	    key: "getStyles",
	    value: function getStyles() {
	      return {
	        passId: {
	          fontSize: "0.8em",
	          marginTop: -5,
	          color: "#ccc"
	        }
	      };
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this3 = this;
	
	      var styles = this.getStyles();
	
	      var _props2 = this.props;
	      var orderData = _props2.orderData;
	      var processedData = _props2.processedData;
	      var headerStyle = _props2.headerStyle;
	      var terminalConnectionStatus = _props2.terminalConnectionStatus;
	      var eventBucket = _props2.eventBucket;
	
	
	      var isMembership = eventBucket.frontend_config.memberships_enabled;
	
	      var terminalAvailable = terminalConnectionStatus === "connected";
	      var user = _UserStore2.default.getUser();
	      var showExternalPos = user && user.global_config && user.global_config.external_pos_enabled;
	
	      // populate orderData mailing address and phone number with existing data
	      // if that information is available
	      if (orderData.mailing_address === undefined) {
	        if (orderData.person && orderData.person.details.mailing_address) {
	          orderData.mailing_address = orderData.person.details.mailing_address;
	        }
	      }
	      if (orderData.phone_number === undefined) {
	        if (orderData.person && orderData.person.details.phone_number) {
	          orderData.phone_number = orderData.person.details.phone_number;
	        }
	      }
	
	      orderData.missingRequiredFields = this.calculateMissingRequiredFields();
	
	      var orderHasGiftCard = orderData.subitems.some(function (item) {
	        return item.gift_card;
	      });
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          "div",
	          { style: headerStyle },
	          "Payment"
	        ),
	        _react2.default.createElement(
	          _label2.default,
	          null,
	          "Order type"
	        ),
	        _react2.default.createElement(
	          _materialUi.RadioButtonGroup,
	          {
	            name: "customer-type",
	            valueSelected: orderData.customerType,
	            onChange: function onChange(e, customerType) {
	              return _this3.props.updateCurrentOrder({
	                customerType: customerType,
	                pass: null,
	                person: null,
	                pass_data: null,
	                group_sale_data: null
	              });
	            }
	          },
	          _react2.default.createElement(_materialUi.RadioButton, { value: "standard", label: "Box office order" }),
	          _react2.default.createElement(_materialUi.RadioButton, {
	            value: "passholder",
	            label: isMembership ? "Passholder/Membership reservation" : "Passholder reservation",
	            disabled: orderHasGiftCard
	          }),
	          _react2.default.createElement(_materialUi.RadioButton, {
	            value: "groupSales",
	            label: "Group sales",
	            disabled: orderHasGiftCard
	          })
	        ),
	        orderData.customerType === "standard" ? _react2.default.createElement(
	          "form",
	          { autoComplete: "off" },
	          _react2.default.createElement(_AutoComplete2.default, {
	            floatingLabelText: "Customer email address",
	            id: "customerName1",
	            name: "customerName1",
	            floatingLabelFixed: true,
	            hintText: orderData.subitems.some(function (i) {
	              return !!i.pass_bucket;
	            }) ? "Required for new passholder account" : "Email to receive receipt",
	            dataSource: this.state.autocompletePeople || [],
	            searchText: orderData.email || orderData.person && orderData.person.details.email || "",
	            filter: function filter(searchText, key) {
	              return searchText && key.toLowerCase().indexOf(searchText.toLowerCase()) !== -1;
	            },
	            open: true,
	            maxSearchResults: 10,
	            menuProps: { desktop: true, autoWidth: true, width: "auto" },
	            manuStyle: { width: 500 },
	            style: { width: 500, marginRight: 12 },
	            textFieldStyle: { width: 500 },
	            fullWidth: true,
	            onNewRequest: this.onChangeEmail,
	            onUpdateInput: this.state.autocompletePeopleUseServer ? this.onNewEmailQueryDebounced : this.onChangeEmail
	          }),
	          _react2.default.createElement(_materialUi.TextField, {
	            floatingLabelText: "Customer name",
	            id: "customerName2",
	            name: "customerName2",
	            floatingLabelFixed: true,
	            value: orderData.person && orderData.person.details.name || orderData.name || "",
	            disabled: !!orderData.person,
	            onChange: function onChange(e) {
	              return _this3.onChangeName(e.target.value);
	            },
	            style: {
	              display: orderData.email || orderData.person && orderData.person.details.email ? "block" : "none",
	              width: 300
	            }
	          })
	        ) : orderData.customerType === "passholder" ? _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement(_AutoComplete2.default, {
	            floatingLabelText: "Pass name",
	            id: "passholderName",
	            name: "passholderName",
	            floatingLabelFixed: true,
	            hintText: "Start typing name to select...",
	            dataSource: this.state.autocompletePasses || [],
	            searchText: orderData.pass && orderData.pass.name || "",
	            filter: function filter(searchText, key) {
	              return searchText && key.toLowerCase().indexOf(searchText.toLowerCase()) !== -1;
	            },
	            maxSearchResults: 10,
	            menuProps: { desktop: true, autoWidth: true, width: "auto" },
	            style: { width: 500, marginRight: 12 },
	            textFieldStyle: { width: 500 },
	            fullWidth: true,
	            onNewRequest: this.onChangePassholder,
	            onUpdateInput: this.state.autocompletePassesUseServer ? this.onNewPassQueryDebounced : this.onChangePassholder
	          }),
	          orderData.pass && orderData.pass.name ? _react2.default.createElement(
	            "div",
	            { style: styles.passId },
	            "ID #",
	            orderData.pass.id,
	            " | ",
	            orderData.pass.pass_bucket.name
	          ) : null
	        ) : orderData.customerType === "groupSales" ? _react2.default.createElement(_boxOfficeGroupSalesEntry2.default, {
	          orderData: orderData,
	          updateCurrentOrder: this.props.updateCurrentOrder,
	          processedData: processedData
	        }) : null,
	        processedData.mailingAddressRequired ? _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement(_materialUi.TextField, {
	            floatingLabelText: _react2.default.createElement(
	              "span",
	              { style: { whiteSpace: "nowrap" } },
	              "Mailing address ",
	              _react2.default.createElement(
	                "small",
	                null,
	                "(required for 1 or more items)"
	              )
	            ),
	            floatingLabelFixed: true,
	            hintText: _react2.default.createElement(
	              "div",
	              { style: { textAlign: "left" } },
	              "123 Main Street",
	              _react2.default.createElement("br", null),
	              "New York, NY 10001"
	            ),
	            value: typeof orderData.mailing_address !== "undefined" ? orderData.mailing_address : orderData.person && orderData.person.details.mailing_address || "",
	            onChange: function onChange(e) {
	              orderData.mailing_address = e.target.value;
	              _this3.props.updateCurrentOrder({
	                missingRequiredFields: _this3.calculateMissingRequiredFields(),
	                mailing_address: e.target.value
	              });
	            },
	            style: { display: "block", width: 300 },
	            multiLine: true,
	            rows: 2,
	            rowsMax: 2
	          })
	        ) : null,
	        processedData.phoneNumberRequired ? _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement(_materialUi.TextField, {
	            floatingLabelText: _react2.default.createElement(
	              "span",
	              { style: { whiteSpace: "nowrap" } },
	              "Phone number ",
	              _react2.default.createElement(
	                "small",
	                null,
	                "(required for 1 or more items)"
	              )
	            ),
	            floatingLabelFixed: true,
	            hintText: _react2.default.createElement(
	              "div",
	              { style: { textAlign: "left" } },
	              "555-123-4567"
	            ),
	            value: typeof orderData.phone_number !== "undefined" ? orderData.phone_number : orderData.person && orderData.person.details.phone_number || "",
	            onChange: function onChange(e) {
	              orderData.phone_number = e.target.value;
	              _this3.props.updateCurrentOrder({
	                missingRequiredFields: _this3.calculateMissingRequiredFields(),
	                phone_number: e.target.value
	              });
	            },
	            style: { display: "block", width: 300 },
	            multiLine: false,
	            rows: 1,
	            rowsMax: 1
	          })
	        ) : null,
	        orderData.email || orderData.person || orderData.customerType === "groupSales" ? _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement(_materialUi.TextField, {
	            floatingLabelText: _react2.default.createElement(
	              "div",
	              { style: { whiteSpace: "nowrap" } },
	              "Additional message (prepended to confirmation email)"
	            ),
	            floatingLabelFixed: true,
	            hintText: "No message",
	            value: orderData.additional_message,
	            onChange: function onChange(e) {
	              return _this3.props.updateCurrentOrder({
	                additional_message: e.target.value
	              });
	            },
	            style: { display: "block", width: 300 },
	            multiLine: true
	          })
	        ) : null,
	        _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement(
	            _label2.default,
	            null,
	            "Payment method"
	          ),
	          processedData.total === 0 ? _react2.default.createElement(
	            "div",
	            null,
	            "None necessary \u2013 ",
	            (0, _util.formatPrice)(0, true),
	            " order."
	          ) : _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(
	              _materialUi.RadioButtonGroup,
	              {
	                name: "payment-type",
	                valueSelected: orderData.paymentType,
	                onChange: function onChange(e, paymentType) {
	                  return _this3.props.updateCurrentOrder({ paymentType: paymentType });
	                }
	              },
	              (terminalAvailable ? [_react2.default.createElement(_materialUi.RadioButton, {
	                value: "terminal",
	                label: "Eventive Terminal"
	              })] : []).concat(orderData.person && orderData.person.details.payment_method_summary ? [_react2.default.createElement(_materialUi.RadioButton, {
	                value: "saved",
	                label: "Saved credit card (" + orderData.person.details.payment_method_summary + ")"
	              })] : []).concat([_react2.default.createElement(_materialUi.RadioButton, {
	                value: "card",
	                label: terminalAvailable ? "Manual card" : "Card"
	              }), _react2.default.createElement(_materialUi.RadioButton, { value: "cash", label: "Cash" }), _react2.default.createElement(_materialUi.RadioButton, { value: "check", label: "Check" })]).concat(showExternalPos ? [_react2.default.createElement(_materialUi.RadioButton, { value: "external", label: "External POS" })] : [])
	            ),
	            orderData.paymentType === "card" ? _react2.default.createElement(
	              "div",
	              { style: { maxWidth: 620 } },
	              _react2.default.createElement(_creditCardEntry2.default, {
	                ref: "cardEntry",
	                onChange: function onChange(details) {
	                  _this3.props.updateCurrentOrder({
	                    paymentCardDetails: details
	                  });
	                }
	              })
	            ) : null
	          )
	        )
	      );
	    }
	  }], [{
	    key: "getStores",
	    value: function getStores() {
	      return [_PersonStore2.default, _PassStore2.default, _UserStore2.default];
	    }
	  }, {
	    key: "getPropsFromStores",
	    value: function getPropsFromStores() {
	      return {
	        getPeople: _PersonStore2.default.getPeople,
	        getPeopleAutocomplete: _PersonStore2.default.getPeopleAutocomplete,
	        getPassesForEventBucketIncludingGlobal: _PassStore2.default.getPassesForEventBucketIncludingGlobal,
	        getPassesAutocomplete: _PassStore2.default.getPassesAutocomplete
	      };
	    }
	  }]);
	
	  return BoxOfficePayment;
	}(_react2.default.Component);
	
	exports.default = (0, _connectToStores2.default)(BoxOfficePayment);
	module.exports = exports["default"];

/***/ }),
/* 2642 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _materialUi = __webpack_require__(576);
	
	var _Table = __webpack_require__(892);
	
	var _reactDatasheet = __webpack_require__(2643);
	
	var _reactDatasheet2 = _interopRequireDefault(_reactDatasheet);
	
	__webpack_require__(2654);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BoxOfficeGroupSalesEntry = function (_React$Component) {
	  _inherits(BoxOfficeGroupSalesEntry, _React$Component);
	
	  function BoxOfficeGroupSalesEntry(props) {
	    _classCallCheck(this, BoxOfficeGroupSalesEntry);
	
	    return _possibleConstructorReturn(this, Object.getPrototypeOf(BoxOfficeGroupSalesEntry).call(this, props));
	  }
	
	  _createClass(BoxOfficeGroupSalesEntry, [{
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props;
	      var orderData = _props.orderData;
	      var processedData = _props.processedData;
	
	
	      var reservedSeatingSubitems = processedData.subitems.filter(function (_ref) {
	        var item = _ref.item;
	
	        return item && item.event && item.event.venue && item.event.venue.use_reserved_seating;
	      });
	      var columns = [{ name: "Email address" }, { name: "Name (optional)" }].concat(reservedSeatingSubitems.map(function (_ref2) {
	        var item = _ref2.item;
	
	        return {
	          name: item.event.name + " seat"
	        };
	      }));
	
	      var grid = (orderData.group_sale_data || []).concat({}).map(function (entry) {
	        return [{
	          __type: "email",
	          value: entry.email || ""
	        }, {
	          __type: "name",
	          value: entry.name || ""
	        }].concat(reservedSeatingSubitems.map(function (_ref3) {
	          var item = _ref3.item;
	
	          return { __type: "seat", value: (entry.seats || {})[item.id] || "" };
	        }));
	      });
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          "div",
	          { style: { maxWidth: 500, margin: "1em 0 0.5em" } },
	          _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(
	              "strong",
	              null,
	              "Group sales"
	            ),
	            " allows you to repeat the same order multiple times. The above order will be repeated once for each individual entered below. The entered payment method will be used for each order."
	          ),
	          _react2.default.createElement(
	            "div",
	            { style: { marginTop: 5 } },
	            _react2.default.createElement(
	              "i",
	              null,
	              "Tip: Copy and paste from a spreadsheet for large orders!"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { style: { maxWidth: 500, marginBottom: "0.75em" } },
	          _react2.default.createElement(_reactDatasheet2.default, {
	            data: grid,
	            dataRenderer: function dataRenderer(cell) {
	              return cell.value;
	            },
	            valueRenderer: function valueRenderer(cell) {
	              return cell.__type && !cell.value ? _react2.default.createElement(
	                "span",
	                { style: { opacity: 0.2 } },
	                cell.__type === "email" ? "customer@example.com" : cell.__type === "name" ? "Jane Doe" : "A-1"
	              ) : cell.value;
	            },
	            sheetRenderer: function sheetRenderer(props) {
	              return _react2.default.createElement(
	                "table",
	                { className: props.className },
	                _react2.default.createElement(
	                  "thead",
	                  null,
	                  _react2.default.createElement(
	                    "tr",
	                    null,
	                    columns.map(function (col) {
	                      return _react2.default.createElement(
	                        "th",
	                        null,
	                        col.name
	                      );
	                    })
	                  )
	                ),
	                _react2.default.createElement(
	                  "tbody",
	                  null,
	                  props.children
	                )
	              );
	            },
	            onCellsChanged: function onCellsChanged(changes, additions) {
	              var newGrid = grid.map(function (row) {
	                return [].concat(_toConsumableArray(row));
	              });
	              changes.concat(additions || []).forEach(function (_ref4) {
	                var cell = _ref4.cell;
	                var row = _ref4.row;
	                var col = _ref4.col;
	                var value = _ref4.value;
	
	                while (!newGrid[row]) {
	                  newGrid.push([]);
	                }
	                while (!newGrid[row][col]) {
	                  newGrid[row].push({});
	                }
	                newGrid[row][col] = _extends({}, newGrid[row][col], { value: value });
	              });
	              _this2.props.updateCurrentOrder({
	                group_sale_data: newGrid.filter(function (r) {
	                  return r.some(function (x) {
	                    return !!x.value;
	                  });
	                }).map(function (row) {
	                  var data = {
	                    email: row[0].value,
	                    name: row[1].value,
	                    seats: {}
	                  };
	                  reservedSeatingSubitems.forEach(function (_ref5, i) {
	                    var item = _ref5.item;
	
	                    data.seats[item.id] = row[2 + i].value;
	                  });
	                  return data;
	                })
	              });
	            }
	          })
	        ),
	        _react2.default.createElement(
	          "style",
	          null,
	          "\n          .data-grid-container .data-grid .cell.selected {\n            box-shadow: none !important;\n          }\n          .data-grid-container .data-grid .cell.updated {\n            background: none !important;\n          }\n          .data-grid-container {\n            line-height: 1;\n            font-family: Arial !important;\n          }\n          .data-grid-container .data-grid .cell {\n            padding: 5px;\n          }\n          .data-grid-container input.data-editor {\n            outline: 0px !important;\n            border: 0px !important;\n            width: calc(100% - 2px) !important;\n            font-size: 13px !important;\n            height: 15px !important;\n            margin-bottom: -2px !important;\n          }\n          .data-grid-container th {\n            padding: 10px 2px 5px !important;\n          }\n        "
	        )
	      );
	    }
	  }]);
	
	  return BoxOfficeGroupSalesEntry;
	}(_react2.default.Component);
	
	exports.default = BoxOfficeGroupSalesEntry;
	module.exports = exports["default"];

/***/ }),
/* 2643 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.renderData = exports.renderValue = exports.ValueViewer = exports.DataEditor = exports.Cell = exports.Row = exports.Sheet = undefined;
	
	var _DataSheet = __webpack_require__(2644);
	
	var _DataSheet2 = _interopRequireDefault(_DataSheet);
	
	var _Sheet = __webpack_require__(2645);
	
	var _Sheet2 = _interopRequireDefault(_Sheet);
	
	var _Row = __webpack_require__(2646);
	
	var _Row2 = _interopRequireDefault(_Row);
	
	var _Cell = __webpack_require__(2648);
	
	var _Cell2 = _interopRequireDefault(_Cell);
	
	var _DataEditor = __webpack_require__(2651);
	
	var _DataEditor2 = _interopRequireDefault(_DataEditor);
	
	var _ValueViewer = __webpack_require__(2652);
	
	var _ValueViewer2 = _interopRequireDefault(_ValueViewer);
	
	var _renderHelpers = __webpack_require__(2653);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _DataSheet2.default;
	exports.Sheet = _Sheet2.default;
	exports.Row = _Row2.default;
	exports.Cell = _Cell2.default;
	exports.DataEditor = _DataEditor2.default;
	exports.ValueViewer = _ValueViewer2.default;
	exports.renderValue = _renderHelpers.renderValue;
	exports.renderData = _renderHelpers.renderData;

/***/ }),
/* 2644 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(956);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Sheet = __webpack_require__(2645);
	
	var _Sheet2 = _interopRequireDefault(_Sheet);
	
	var _Row = __webpack_require__(2646);
	
	var _Row2 = _interopRequireDefault(_Row);
	
	var _Cell = __webpack_require__(2648);
	
	var _Cell2 = _interopRequireDefault(_Cell);
	
	var _DataCell = __webpack_require__(2649);
	
	var _DataCell2 = _interopRequireDefault(_DataCell);
	
	var _DataEditor = __webpack_require__(2651);
	
	var _DataEditor2 = _interopRequireDefault(_DataEditor);
	
	var _ValueViewer = __webpack_require__(2652);
	
	var _ValueViewer2 = _interopRequireDefault(_ValueViewer);
	
	var _keys = __webpack_require__(2650);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var isEmpty = function isEmpty(obj) {
	  return Object.keys(obj).length === 0;
	};
	
	var range = function range(start, end) {
	  var array = [];
	  var inc = end - start > 0;
	  for (var i = start; inc ? i <= end : i >= end; inc ? i++ : i--) {
	    inc ? array.push(i) : array.unshift(i);
	  }
	  return array;
	};
	
	var defaultParsePaste = function defaultParsePaste(str) {
	  return str.split(/\r\n|\n|\r/).map(function (row) {
	    return row.split('\t');
	  });
	};
	
	var DataSheet = function (_PureComponent) {
	  _inherits(DataSheet, _PureComponent);
	
	  function DataSheet(props) {
	    _classCallCheck(this, DataSheet);
	
	    var _this = _possibleConstructorReturn(this, (DataSheet.__proto__ || Object.getPrototypeOf(DataSheet)).call(this, props));
	
	    _this.onMouseDown = _this.onMouseDown.bind(_this);
	    _this.onMouseUp = _this.onMouseUp.bind(_this);
	    _this.onMouseOver = _this.onMouseOver.bind(_this);
	    _this.onDoubleClick = _this.onDoubleClick.bind(_this);
	    _this.onContextMenu = _this.onContextMenu.bind(_this);
	    _this.handleNavigate = _this.handleNavigate.bind(_this);
	    _this.handleKey = _this.handleKey.bind(_this).bind(_this);
	    _this.handleCut = _this.handleCut.bind(_this);
	    _this.handleCopy = _this.handleCopy.bind(_this);
	    _this.handlePaste = _this.handlePaste.bind(_this);
	    _this.pageClick = _this.pageClick.bind(_this);
	    _this.onChange = _this.onChange.bind(_this);
	    _this.onRevert = _this.onRevert.bind(_this);
	    _this.isSelected = _this.isSelected.bind(_this);
	    _this.isEditing = _this.isEditing.bind(_this);
	    _this.isClearing = _this.isClearing.bind(_this);
	    _this.handleComponentKey = _this.handleComponentKey.bind(_this);
	
	    _this.handleKeyboardCellMovement = _this.handleKeyboardCellMovement.bind(_this);
	
	    _this.defaultState = {
	      start: {},
	      end: {},
	      selecting: false,
	      forceEdit: false,
	      editing: {},
	      clear: {}
	    };
	    _this.state = _this.defaultState;
	
	    _this.removeAllListeners = _this.removeAllListeners.bind(_this);
	    return _this;
	  }
	
	  _createClass(DataSheet, [{
	    key: 'removeAllListeners',
	    value: function removeAllListeners() {
	      document.removeEventListener('mousedown', this.pageClick);
	      document.removeEventListener('mouseup', this.onMouseUp);
	      document.removeEventListener('cut', this.handleCut);
	      document.removeEventListener('copy', this.handleCopy);
	      document.removeEventListener('paste', this.handlePaste);
	      document.removeEventListener('keydown', this.handlePaste);
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      // Add listener scoped to the DataSheet that catches otherwise unhandled
	      // keyboard events when displaying components
	      this.dgDom && this.dgDom.addEventListener('keydown', this.handleComponentKey);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.dgDom && this.dgDom.removeEventListener('keydown', this.handleComponentKey);
	      this.removeAllListeners();
	    }
	  }, {
	    key: 'isSelectionControlled',
	    value: function isSelectionControlled() {
	      return 'selected' in this.props;
	    }
	  }, {
	    key: 'getState',
	    value: function getState() {
	      var state = this.state;
	      if (this.isSelectionControlled()) {
	        var _ref = this.props.selected || {},
	            start = _ref.start,
	            end = _ref.end;
	
	        start = start || this.defaultState.start;
	        end = end || this.defaultState.end;
	        state = _extends({}, state, { start: start, end: end });
	      }
	      return state;
	    }
	  }, {
	    key: '_setState',
	    value: function _setState(state) {
	      if (this.isSelectionControlled() && ('start' in state || 'end' in state)) {
	        var start = state.start,
	            end = state.end,
	            rest = _objectWithoutProperties(state, ['start', 'end']);
	
	        var _props = this.props,
	            selected = _props.selected,
	            onSelect = _props.onSelect;
	
	        selected = selected || {};
	        if (!start) {
	          start = 'start' in selected ? selected.start : this.defaultState.start;
	        }
	        if (!end) {
	          end = 'end' in selected ? selected.end : this.defaultState.end;
	        }
	        onSelect && onSelect({ start: start, end: end });
	        this.setState(rest);
	      } else {
	        this.setState(state);
	      }
	    }
	  }, {
	    key: 'pageClick',
	    value: function pageClick(e) {
	      var element = this.dgDom;
	      if (!element.contains(e.target)) {
	        this.setState(this.defaultState);
	        this.removeAllListeners();
	      }
	    }
	  }, {
	    key: 'handleCut',
	    value: function handleCut(e) {
	      if (isEmpty(this.state.editing)) {
	        e.preventDefault();
	        this.handleCopy(e);
	
	        var _getState = this.getState(),
	            start = _getState.start,
	            end = _getState.end;
	
	        this.clearSelectedCells(start, end);
	      }
	    }
	  }, {
	    key: 'handleCopy',
	    value: function handleCopy(e) {
	      if (isEmpty(this.state.editing)) {
	        e.preventDefault();
	        var _props2 = this.props,
	            dataRenderer = _props2.dataRenderer,
	            valueRenderer = _props2.valueRenderer,
	            data = _props2.data;
	
	        var _getState2 = this.getState(),
	            start = _getState2.start,
	            end = _getState2.end;
	
	        var text = range(start.i, end.i).map(function (i) {
	          return range(start.j, end.j).map(function (j) {
	            var cell = data[i][j];
	            var value = dataRenderer ? dataRenderer(cell, i, j) : null;
	            if (value === '' || value === null || typeof value === 'undefined') {
	              return valueRenderer(cell, i, j);
	            }
	            return value;
	          }).join('\t');
	        }).join('\n');
	        e.clipboardData.setData('text/plain', text);
	      }
	    }
	  }, {
	    key: 'handlePaste',
	    value: function handlePaste(e) {
	      if (isEmpty(this.state.editing)) {
	        var _getState3 = this.getState(),
	            start = _getState3.start,
	            end = _getState3.end;
	
	        start = { i: Math.min(start.i, end.i), j: Math.min(start.j, end.j) };
	        end = { i: Math.max(start.i, end.i), j: Math.max(start.j, end.j) };
	
	        var parse = this.props.parsePaste || defaultParsePaste;
	        var changes = [];
	        var pasteData = [];
	        if (window.clipboardData && window.clipboardData.getData) {
	          // IE
	          pasteData = parse(window.clipboardData.getData('Text'));
	        } else if (e.clipboardData && e.clipboardData.getData) {
	          pasteData = parse(e.clipboardData.getData('text/plain'));
	        }
	
	        // in order of preference
	        var _props3 = this.props,
	            data = _props3.data,
	            onCellsChanged = _props3.onCellsChanged,
	            onPaste = _props3.onPaste,
	            onChange = _props3.onChange;
	
	        if (onCellsChanged) {
	          var additions = [];
	          pasteData.forEach(function (row, i) {
	            row.forEach(function (value, j) {
	              end = { i: start.i + i, j: start.j + j };
	              var cell = data[end.i] && data[end.i][end.j];
	              if (!cell) {
	                additions.push({ row: end.i, col: end.j, value: value });
	              } else if (!cell.readOnly) {
	                changes.push({ cell: cell, row: end.i, col: end.j, value: value });
	              }
	            });
	          });
	          if (additions.length) {
	            onCellsChanged(changes, additions);
	          } else {
	            onCellsChanged(changes);
	          }
	        } else if (onPaste) {
	          pasteData.forEach(function (row, i) {
	            var rowData = [];
	            row.forEach(function (pastedData, j) {
	              end = { i: start.i + i, j: start.j + j };
	              var cell = data[end.i] && data[end.i][end.j];
	              rowData.push({ cell: cell, data: pastedData });
	            });
	            changes.push(rowData);
	          });
	          onPaste(changes);
	        } else if (onChange) {
	          pasteData.forEach(function (row, i) {
	            row.forEach(function (value, j) {
	              end = { i: start.i + i, j: start.j + j };
	              var cell = data[end.i] && data[end.i][end.j];
	              if (cell && !cell.readOnly) {
	                onChange(cell, end.i, end.j, value);
	              }
	            });
	          });
	        }
	        this._setState({ end: end });
	      }
	    }
	  }, {
	    key: 'handleKeyboardCellMovement',
	    value: function handleKeyboardCellMovement(e) {
	      var commit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	      var _getState4 = this.getState(),
	          start = _getState4.start,
	          editing = _getState4.editing;
	
	      var data = this.props.data;
	
	      var isEditing = editing && !isEmpty(editing);
	      var currentCell = data[start.i] && data[start.i][start.j];
	
	      if (isEditing && !commit) {
	        return false;
	      }
	      var hasComponent = currentCell && currentCell.component;
	
	      var keyCode = e.which || e.keyCode;
	
	      if (hasComponent && isEditing) {
	        e.preventDefault();
	        return;
	      }
	
	      if (keyCode === _keys.TAB_KEY) {
	        this.handleNavigate(e, { i: 0, j: e.shiftKey ? -1 : 1 }, true);
	      } else if (keyCode === _keys.RIGHT_KEY) {
	        this.handleNavigate(e, { i: 0, j: 1 });
	      } else if (keyCode === _keys.LEFT_KEY) {
	        this.handleNavigate(e, { i: 0, j: -1 });
	      } else if (keyCode === _keys.UP_KEY) {
	        this.handleNavigate(e, { i: -1, j: 0 });
	      } else if (keyCode === _keys.DOWN_KEY) {
	        this.handleNavigate(e, { i: 1, j: 0 });
	      } else if (commit && keyCode === _keys.ENTER_KEY) {
	        this.handleNavigate(e, { i: e.shiftKey ? -1 : 1, j: 0 });
	      }
	    }
	  }, {
	    key: 'handleKey',
	    value: function handleKey(e) {
	      if (e.isPropagationStopped && e.isPropagationStopped()) {
	        return;
	      }
	      var keyCode = e.which || e.keyCode;
	
	      var _getState5 = this.getState(),
	          start = _getState5.start,
	          end = _getState5.end,
	          editing = _getState5.editing;
	
	      var isEditing = editing && !isEmpty(editing);
	      var noCellsSelected = !start || isEmpty(start);
	      var ctrlKeyPressed = e.ctrlKey || e.metaKey;
	      var deleteKeysPressed = keyCode === _keys.DELETE_KEY || keyCode === _keys.BACKSPACE_KEY;
	      var enterKeyPressed = keyCode === _keys.ENTER_KEY;
	      var numbersPressed = keyCode >= 48 && keyCode <= 57;
	      var lettersPressed = keyCode >= 65 && keyCode <= 90;
	      var latin1Supplement = keyCode >= 160 && keyCode <= 255;
	      var numPadKeysPressed = keyCode >= 96 && keyCode <= 105;
	      var currentCell = !noCellsSelected && this.props.data[start.i][start.j];
	      var equationKeysPressed = [187, /* equal */
	      189, /* substract */
	      190, /* period */
	      107, /* add */
	      109, /* decimal point */
	      110].indexOf(keyCode) > -1;
	
	      if (noCellsSelected || ctrlKeyPressed) {
	        return true;
	      }
	
	      if (!isEditing) {
	        this.handleKeyboardCellMovement(e);
	        if (deleteKeysPressed) {
	          e.preventDefault();
	          this.clearSelectedCells(start, end);
	        } else if (currentCell && !currentCell.readOnly) {
	          if (enterKeyPressed) {
	            this._setState({ editing: start, clear: {}, forceEdit: true });
	            e.preventDefault();
	          } else if (numbersPressed || numPadKeysPressed || lettersPressed || latin1Supplement || equationKeysPressed) {
	            // empty out cell if user starts typing without pressing enter
	            this._setState({ editing: start, clear: start, forceEdit: false });
	          }
	        }
	      }
	    }
	  }, {
	    key: 'getSelectedCells',
	    value: function getSelectedCells(data, start, end) {
	      var selected = [];
	      range(start.i, end.i).map(function (row) {
	        range(start.j, end.j).map(function (col) {
	          if (data[row] && data[row][col]) {
	            selected.push({ cell: data[row][col], row: row, col: col });
	          }
	        });
	      });
	      return selected;
	    }
	  }, {
	    key: 'clearSelectedCells',
	    value: function clearSelectedCells(start, end) {
	      var _this2 = this;
	
	      var _props4 = this.props,
	          data = _props4.data,
	          onCellsChanged = _props4.onCellsChanged,
	          onChange = _props4.onChange;
	
	      var cells = this.getSelectedCells(data, start, end).filter(function (cell) {
	        return !cell.cell.readOnly;
	      }).map(function (cell) {
	        return _extends({}, cell, { value: '' });
	      });
	      if (onCellsChanged) {
	        onCellsChanged(cells);
	        this.onRevert();
	      } else if (onChange) {
	        // ugly solution brought to you by https://reactjs.org/docs/react-component.html#setstate
	        // setState in a loop is unreliable
	        setTimeout(function () {
	          cells.forEach(function (_ref2) {
	            var cell = _ref2.cell,
	                row = _ref2.row,
	                col = _ref2.col,
	                value = _ref2.value;
	
	            onChange(cell, row, col, value);
	          });
	          _this2.onRevert();
	        }, 0);
	      }
	    }
	  }, {
	    key: 'handleNavigate',
	    value: function handleNavigate(e, offsets, jumpRow) {
	      var _this3 = this;
	
	      if (offsets && (offsets.i || offsets.j)) {
	        var _getState6 = this.getState(),
	            start = _getState6.start,
	            end = _getState6.end;
	
	        var data = this.props.data;
	
	        var oldStartLocation = { i: start.i, j: start.j };
	        var newEndLocation = { i: end.i + offsets.i, j: end.j + offsets.j };
	
	        var newLocation = { i: start.i + offsets.i, j: start.j + offsets.j };
	
	        var updateLocation = function updateLocation() {
	          if (data[newLocation.i] && typeof data[newLocation.i][newLocation.j] !== 'undefined') {
	            _this3._setState({
	              start: e.shiftKey && !jumpRow ? oldStartLocation : newLocation,
	              end: e.shiftKey && !jumpRow ? newEndLocation : newLocation,
	              editing: {}
	            });
	            e.preventDefault();
	            return true;
	          }
	          return false;
	        };
	        if (!updateLocation() && jumpRow) {
	          if (offsets.j < 0) {
	            newLocation = { i: start.i - 1, j: data[0].length - 1 };
	          } else {
	            newLocation = { i: start.i + 1, j: 0 };
	          }
	          updateLocation();
	        }
	      }
	    }
	  }, {
	    key: 'handleComponentKey',
	    value: function handleComponentKey(e) {
	      var _this4 = this;
	
	      // handles keyboard events when editing components
	      var keyCode = e.which || e.keyCode;
	      if (![_keys.ENTER_KEY, _keys.ESCAPE_KEY, _keys.TAB_KEY].includes(keyCode)) {
	        return;
	      }
	      var editing = this.state.editing;
	      var data = this.props.data;
	
	      var isEditing = !isEmpty(editing);
	      if (isEditing) {
	        var currentCell = data[editing.i][editing.j];
	        var offset = e.shiftKey ? -1 : 1;
	        if (currentCell && currentCell.component && !currentCell.forceComponent) {
	          e.preventDefault();
	          var func = this.onRevert; // ESCAPE_KEY
	          if (keyCode === _keys.ENTER_KEY) {
	            func = function func() {
	              return _this4.handleNavigate(e, { i: offset, j: 0 });
	            };
	          } else if (keyCode === _keys.TAB_KEY) {
	            func = function func() {
	              return _this4.handleNavigate(e, { i: 0, j: offset }, true);
	            };
	          }
	          // setTimeout makes sure that component is done handling the event before we take over
	          setTimeout(function () {
	            func();_this4.dgDom && _this4.dgDom.focus();
	          }, 1);
	        }
	      }
	    }
	  }, {
	    key: 'onContextMenu',
	    value: function onContextMenu(evt, i, j) {
	      var cell = this.props.data[i][j];
	      if (this.props.onContextMenu) {
	        this.props.onContextMenu(evt, cell, i, j);
	      }
	    }
	  }, {
	    key: 'onDoubleClick',
	    value: function onDoubleClick(i, j) {
	      var cell = this.props.data[i][j];
	      if (!cell.readOnly) {
	        this._setState({ editing: { i: i, j: j }, forceEdit: true, clear: {} });
	      }
	    }
	  }, {
	    key: 'onMouseDown',
	    value: function onMouseDown(i, j, e) {
	      var _this5 = this;
	
	      var editing = isEmpty(this.state.editing) || this.state.editing.i !== i || this.state.editing.j !== j ? {} : this.state.editing;
	
	      this._setState({
	        selecting: true,
	        start: e.shiftKey ? this.state.start : { i: i, j: j },
	        end: { i: i, j: j },
	        editing: editing,
	        forceEdit: false
	      });
	
	      var ua = window.navigator.userAgent;
	      var isIE = /MSIE|Trident/.test(ua);
	      // Listen for Ctrl + V in case of IE
	      if (isIE) {
	        document.addEventListener('keydown', function (e) {
	          if ((e.keyCode === 86 || e.which === 86) && e.ctrlKey) {
	            _this5.handlePaste(e);
	          }
	        });
	      }
	
	      // Keep listening to mouse if user releases the mouse (dragging outside)
	      document.addEventListener('mouseup', this.onMouseUp);
	      // Listen for any outside mouse clicks
	      document.addEventListener('mousedown', this.pageClick);
	
	      // Cut, copy and paste event handlers
	      document.addEventListener('cut', this.handleCut);
	      document.addEventListener('copy', this.handleCopy);
	      document.addEventListener('paste', this.handlePaste);
	    }
	  }, {
	    key: 'onMouseOver',
	    value: function onMouseOver(i, j) {
	      if (this.state.selecting && isEmpty(this.state.editing)) {
	        this._setState({ end: { i: i, j: j } });
	      }
	    }
	  }, {
	    key: 'onMouseUp',
	    value: function onMouseUp() {
	      this._setState({ selecting: false });
	      document.removeEventListener('mouseup', this.onMouseUp);
	    }
	  }, {
	    key: 'onChange',
	    value: function onChange(row, col, value) {
	      var _props5 = this.props,
	          onChange = _props5.onChange,
	          onCellsChanged = _props5.onCellsChanged,
	          data = _props5.data;
	
	      if (onCellsChanged) {
	        onCellsChanged([{ cell: data[row][col], row: row, col: col, value: value }]);
	      } else if (onChange) {
	        onChange(data[row][col], row, col, value);
	      }
	      this.onRevert();
	    }
	  }, {
	    key: 'onRevert',
	    value: function onRevert() {
	      this._setState({ editing: {} });
	      this.dgDom && this.dgDom.focus();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps, prevState) {
	      var _state = this.state,
	          start = _state.start,
	          end = _state.end;
	
	      var prevEnd = prevState.end;
	      if (!isEmpty(end) && !(end.i === prevEnd.i && end.j === prevEnd.j) && !this.isSelectionControlled()) {
	        this.props.onSelect && this.props.onSelect({ start: start, end: end });
	      }
	    }
	  }, {
	    key: 'isSelected',
	    value: function isSelected(i, j) {
	      var _getState7 = this.getState(),
	          start = _getState7.start,
	          end = _getState7.end;
	
	      var posX = j >= start.j && j <= end.j;
	      var negX = j <= start.j && j >= end.j;
	      var posY = i >= start.i && i <= end.i;
	      var negY = i <= start.i && i >= end.i;
	
	      return posX && posY || negX && posY || negX && negY || posX && negY;
	    }
	  }, {
	    key: 'isEditing',
	    value: function isEditing(i, j) {
	      return this.state.editing.i === i && this.state.editing.j === j;
	    }
	  }, {
	    key: 'isClearing',
	    value: function isClearing(i, j) {
	      return this.state.clear.i === i && this.state.clear.j === j;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this6 = this;
	
	      var _props6 = this.props,
	          SheetRenderer = _props6.sheetRenderer,
	          RowRenderer = _props6.rowRenderer,
	          cellRenderer = _props6.cellRenderer,
	          dataRenderer = _props6.dataRenderer,
	          valueRenderer = _props6.valueRenderer,
	          dataEditor = _props6.dataEditor,
	          valueViewer = _props6.valueViewer,
	          attributesRenderer = _props6.attributesRenderer,
	          className = _props6.className,
	          overflow = _props6.overflow,
	          data = _props6.data,
	          keyFn = _props6.keyFn;
	      var forceEdit = this.state.forceEdit;
	
	
	      return _react2.default.createElement(
	        'span',
	        { ref: function ref(r) {
	            _this6.dgDom = r;
	          }, tabIndex: '0', className: 'data-grid-container', onKeyDown: this.handleKey },
	        _react2.default.createElement(
	          SheetRenderer,
	          { data: data, className: ['data-grid', className, overflow].filter(function (a) {
	              return a;
	            }).join(' ') },
	          data.map(function (row, i) {
	            return _react2.default.createElement(
	              RowRenderer,
	              { key: keyFn ? keyFn(i) : i, row: i, cells: row },
	              row.map(function (cell, j) {
	                return _react2.default.createElement(_DataCell2.default, {
	                  key: cell.key ? cell.key : i + '-' + j,
	                  row: i,
	                  col: j,
	                  cell: cell,
	                  forceEdit: forceEdit,
	                  onMouseDown: _this6.onMouseDown,
	                  onMouseOver: _this6.onMouseOver,
	                  onDoubleClick: _this6.onDoubleClick,
	                  onContextMenu: _this6.onContextMenu,
	                  onChange: _this6.onChange,
	                  onRevert: _this6.onRevert,
	                  onNavigate: _this6.handleKeyboardCellMovement,
	                  onKey: _this6.handleKey,
	                  selected: _this6.isSelected(i, j),
	                  editing: _this6.isEditing(i, j),
	                  clearing: _this6.isClearing(i, j),
	                  attributesRenderer: attributesRenderer,
	                  cellRenderer: cellRenderer,
	                  valueRenderer: valueRenderer,
	                  dataRenderer: dataRenderer,
	                  valueViewer: valueViewer,
	                  dataEditor: dataEditor
	                });
	              })
	            );
	          })
	        )
	      );
	    }
	  }]);
	
	  return DataSheet;
	}(_react.PureComponent);
	
	exports.default = DataSheet;
	
	
	DataSheet.propTypes = {
	  data: _propTypes2.default.array.isRequired,
	  className: _propTypes2.default.string,
	  overflow: _propTypes2.default.oneOf(['wrap', 'nowrap', 'clip']),
	  onChange: _propTypes2.default.func,
	  onCellsChanged: _propTypes2.default.func,
	  onContextMenu: _propTypes2.default.func,
	  onSelect: _propTypes2.default.func,
	  selected: _propTypes2.default.shape({
	    start: _propTypes2.default.shape({
	      i: _propTypes2.default.number,
	      j: _propTypes2.default.number
	    }),
	    end: _propTypes2.default.shape({
	      i: _propTypes2.default.number,
	      j: _propTypes2.default.number
	    })
	  }),
	  valueRenderer: _propTypes2.default.func.isRequired,
	  dataRenderer: _propTypes2.default.func,
	  sheetRenderer: _propTypes2.default.func.isRequired,
	  rowRenderer: _propTypes2.default.func.isRequired,
	  cellRenderer: _propTypes2.default.func.isRequired,
	  valueViewer: _propTypes2.default.func,
	  dataEditor: _propTypes2.default.func,
	  parsePaste: _propTypes2.default.func,
	  attributesRenderer: _propTypes2.default.func,
	  keyFn: _propTypes2.default.func
	};
	
	DataSheet.defaultProps = {
	  sheetRenderer: _Sheet2.default,
	  rowRenderer: _Row2.default,
	  cellRenderer: _Cell2.default,
	  valueViewer: _ValueViewer2.default,
	  dataEditor: _DataEditor2.default
	};

/***/ }),
/* 2645 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(956);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Sheet = function (_PureComponent) {
	  _inherits(Sheet, _PureComponent);
	
	  function Sheet() {
	    _classCallCheck(this, Sheet);
	
	    return _possibleConstructorReturn(this, (Sheet.__proto__ || Object.getPrototypeOf(Sheet)).apply(this, arguments));
	  }
	
	  _createClass(Sheet, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'table',
	        { className: this.props.className },
	        _react2.default.createElement(
	          'tbody',
	          null,
	          this.props.children
	        )
	      );
	    }
	  }]);
	
	  return Sheet;
	}(_react.PureComponent);
	
	Sheet.propTypes = {
	  className: _propTypes2.default.string,
	  data: _propTypes2.default.array.isRequired
	};
	
	exports.default = Sheet;

/***/ }),
/* 2646 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(956);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _CellShape = __webpack_require__(2647);
	
	var _CellShape2 = _interopRequireDefault(_CellShape);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Row = function (_PureComponent) {
	  _inherits(Row, _PureComponent);
	
	  function Row() {
	    _classCallCheck(this, Row);
	
	    return _possibleConstructorReturn(this, (Row.__proto__ || Object.getPrototypeOf(Row)).apply(this, arguments));
	  }
	
	  _createClass(Row, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'tr',
	        null,
	        this.props.children
	      );
	    }
	  }]);
	
	  return Row;
	}(_react.PureComponent);
	
	Row.propTypes = {
	  row: _propTypes2.default.number.isRequired,
	  cells: _propTypes2.default.arrayOf(_propTypes2.default.shape(_CellShape2.default)).isRequired
	};
	
	exports.default = Row;

/***/ }),
/* 2647 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _propTypes = __webpack_require__(956);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*
	readOnly    Bool    false   Cell will never go in edit mode
	key String  undefined   By default, each cell is given the key of col number and row number. This would override that key
	className   String  undefined   Additional class names for cells.
	component   ReactElement    undefined   Insert a react element or JSX to this field. This will render on edit mode
	forceComponent  bool    false   Renders what's in component at all times, even when not in edit mode
	disableEvents   bool    false   Makes cell unselectable and read only
	colSpan number  1   The colSpan of the cell's td element
	rowSpan number  1   The rowSpan of the cell's td element
	width   number or String    undefined   Sets the cell's td width using a style attribute. Number is interpreted as pixels, strings are used as-is. Note: This will only work if the table does not have a set width.
	overflow    'wrap'|'nowrap'| 'clip' undefined   How to render overflow text. Overrides grid-level overflow option.
	editor func  undefined A component used to render the cell's value when being edited
	viewer func  undefined A component used to render the cell's value when not being edited
	*/
	var CellShape = {
	  readOnly: _propTypes2.default.bool,
	  key: _propTypes2.default.string,
	  className: _propTypes2.default.string,
	  component: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.func]),
	  forceComponent: _propTypes2.default.bool,
	  disableEvents: _propTypes2.default.bool,
	  colSpan: _propTypes2.default.number,
	  rowSpan: _propTypes2.default.number,
	  width: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  overflow: _propTypes2.default.oneOf(['wrap', 'nowrap', 'clip']),
	  dataEditor: _propTypes2.default.func,
	  valueViewer: _propTypes2.default.func
	};
	
	exports.default = CellShape;

/***/ }),
/* 2648 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(956);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _CellShape = __webpack_require__(2647);
	
	var _CellShape2 = _interopRequireDefault(_CellShape);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Cell = function (_PureComponent) {
	  _inherits(Cell, _PureComponent);
	
	  function Cell() {
	    _classCallCheck(this, Cell);
	
	    return _possibleConstructorReturn(this, (Cell.__proto__ || Object.getPrototypeOf(Cell)).apply(this, arguments));
	  }
	
	  _createClass(Cell, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          cell = _props.cell,
	          row = _props.row,
	          col = _props.col,
	          attributesRenderer = _props.attributesRenderer,
	          className = _props.className,
	          style = _props.style,
	          onMouseDown = _props.onMouseDown,
	          onMouseOver = _props.onMouseOver,
	          onDoubleClick = _props.onDoubleClick,
	          onContextMenu = _props.onContextMenu;
	      var colSpan = cell.colSpan,
	          rowSpan = cell.rowSpan;
	
	      var attributes = attributesRenderer ? attributesRenderer(cell, row, col) : {};
	
	      return _react2.default.createElement(
	        'td',
	        _extends({
	          className: className,
	          onMouseDown: onMouseDown,
	          onMouseOver: onMouseOver,
	          onDoubleClick: onDoubleClick,
	          onTouchEnd: onDoubleClick,
	          onContextMenu: onContextMenu,
	          colSpan: colSpan,
	          rowSpan: rowSpan,
	          style: style
	        }, attributes),
	        this.props.children
	      );
	    }
	  }]);
	
	  return Cell;
	}(_react.PureComponent);
	
	exports.default = Cell;
	
	
	Cell.propTypes = {
	  row: _propTypes2.default.number.isRequired,
	  col: _propTypes2.default.number.isRequired,
	  cell: _propTypes2.default.shape(_CellShape2.default).isRequired,
	  selected: _propTypes2.default.bool,
	  editing: _propTypes2.default.bool,
	  updated: _propTypes2.default.bool,
	  attributesRenderer: _propTypes2.default.func,
	  onMouseDown: _propTypes2.default.func.isRequired,
	  onMouseOver: _propTypes2.default.func.isRequired,
	  onDoubleClick: _propTypes2.default.func.isRequired,
	  onContextMenu: _propTypes2.default.func.isRequired,
	  className: _propTypes2.default.string,
	  style: _propTypes2.default.object
	};
	
	Cell.defaultProps = {
	  selected: false,
	  editing: false,
	  updated: false,
	  attributesRenderer: function attributesRenderer() {}
	};

/***/ }),
/* 2649 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(956);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _keys = __webpack_require__(2650);
	
	var _Cell = __webpack_require__(2648);
	
	var _Cell2 = _interopRequireDefault(_Cell);
	
	var _CellShape = __webpack_require__(2647);
	
	var _CellShape2 = _interopRequireDefault(_CellShape);
	
	var _DataEditor = __webpack_require__(2651);
	
	var _DataEditor2 = _interopRequireDefault(_DataEditor);
	
	var _ValueViewer = __webpack_require__(2652);
	
	var _ValueViewer2 = _interopRequireDefault(_ValueViewer);
	
	var _renderHelpers = __webpack_require__(2653);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function initialData(_ref) {
	  var cell = _ref.cell,
	      row = _ref.row,
	      col = _ref.col,
	      valueRenderer = _ref.valueRenderer,
	      dataRenderer = _ref.dataRenderer;
	
	  return (0, _renderHelpers.renderData)(cell, row, col, valueRenderer, dataRenderer);
	}
	
	function initialValue(_ref2) {
	  var cell = _ref2.cell,
	      row = _ref2.row,
	      col = _ref2.col,
	      valueRenderer = _ref2.valueRenderer;
	
	  return (0, _renderHelpers.renderValue)(cell, row, col, valueRenderer);
	}
	
	function widthStyle(cell) {
	  var width = typeof cell.width === 'number' ? cell.width + 'px' : cell.width;
	  return width ? { width: width } : null;
	}
	
	var DataCell = function (_PureComponent) {
	  _inherits(DataCell, _PureComponent);
	
	  function DataCell(props) {
	    _classCallCheck(this, DataCell);
	
	    var _this = _possibleConstructorReturn(this, (DataCell.__proto__ || Object.getPrototypeOf(DataCell)).call(this, props));
	
	    _this.handleChange = _this.handleChange.bind(_this);
	    _this.handleCommit = _this.handleCommit.bind(_this);
	    _this.handleRevert = _this.handleRevert.bind(_this);
	
	    _this.handleKey = _this.handleKey.bind(_this);
	    _this.handleMouseDown = _this.handleMouseDown.bind(_this);
	    _this.handleMouseOver = _this.handleMouseOver.bind(_this);
	    _this.handleContextMenu = _this.handleContextMenu.bind(_this);
	    _this.handleDoubleClick = _this.handleDoubleClick.bind(_this);
	
	    _this.state = { updated: false, reverting: false, value: '', committing: false };
	    return _this;
	  }
	
	  _createClass(DataCell, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _this2 = this;
	
	      if (initialValue(nextProps) !== initialValue(this.props)) {
	        this.setState({ updated: true });
	        this.timeout = setTimeout(function () {
	          return _this2.setState({ updated: false });
	        }, 700);
	      }
	      if (nextProps.editing === true && this.props.editing === false) {
	        var value = nextProps.clearing ? '' : initialData(nextProps);
	        this.setState({ value: value, reverting: false });
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      if (prevProps.editing === true && this.props.editing === false && !this.state.reverting && !this.state.committing && this.state.value !== initialData(this.props)) {
	        this.props.onChange(this.props.row, this.props.col, this.state.value);
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      clearTimeout(this.timeout);
	    }
	  }, {
	    key: 'handleChange',
	    value: function handleChange(value) {
	      this.setState({ value: value, committing: false });
	    }
	  }, {
	    key: 'handleCommit',
	    value: function handleCommit(value, e) {
	      var _props = this.props,
	          onChange = _props.onChange,
	          onNavigate = _props.onNavigate;
	
	      if (value !== initialData(this.props)) {
	        this.setState({ value: value, committing: true });
	        onChange(this.props.row, this.props.col, value);
	      } else {
	        this.handleRevert();
	      }
	      if (e) {
	        e.preventDefault();
	        onNavigate(e, true);
	      }
	    }
	  }, {
	    key: 'handleRevert',
	    value: function handleRevert() {
	      this.setState({ reverting: true });
	      this.props.onRevert();
	    }
	  }, {
	    key: 'handleMouseDown',
	    value: function handleMouseDown(e) {
	      var _props2 = this.props,
	          row = _props2.row,
	          col = _props2.col,
	          onMouseDown = _props2.onMouseDown,
	          cell = _props2.cell;
	
	      if (!cell.disableEvents) {
	        onMouseDown(row, col, e);
	      }
	    }
	  }, {
	    key: 'handleMouseOver',
	    value: function handleMouseOver(e) {
	      var _props3 = this.props,
	          row = _props3.row,
	          col = _props3.col,
	          onMouseOver = _props3.onMouseOver,
	          cell = _props3.cell;
	
	      if (!cell.disableEvents) {
	        onMouseOver(row, col);
	      }
	    }
	  }, {
	    key: 'handleDoubleClick',
	    value: function handleDoubleClick(e) {
	      var _props4 = this.props,
	          row = _props4.row,
	          col = _props4.col,
	          onDoubleClick = _props4.onDoubleClick,
	          cell = _props4.cell;
	
	      if (!cell.disableEvents) {
	        onDoubleClick(row, col);
	      }
	    }
	  }, {
	    key: 'handleContextMenu',
	    value: function handleContextMenu(e) {
	      var _props5 = this.props,
	          row = _props5.row,
	          col = _props5.col,
	          onContextMenu = _props5.onContextMenu,
	          cell = _props5.cell;
	
	      if (!cell.disableEvents) {
	        onContextMenu(e, row, col);
	      }
	    }
	  }, {
	    key: 'handleKey',
	    value: function handleKey(e) {
	      var keyCode = e.which || e.keyCode;
	      if (keyCode === _keys.ESCAPE_KEY) {
	        return this.handleRevert();
	      }
	      var _props6 = this.props,
	          component = _props6.cell.component,
	          forceEdit = _props6.forceEdit;
	
	      var eatKeys = forceEdit || !!component;
	      var commit = keyCode === _keys.ENTER_KEY || keyCode === _keys.TAB_KEY || !eatKeys && [_keys.LEFT_KEY, _keys.RIGHT_KEY, _keys.UP_KEY, _keys.DOWN_KEY].includes(keyCode);
	
	      if (commit) {
	        this.handleCommit(this.state.value, e);
	      }
	    }
	  }, {
	    key: 'renderComponent',
	    value: function renderComponent(editing, cell) {
	      var component = cell.component,
	          readOnly = cell.readOnly,
	          forceComponent = cell.forceComponent;
	
	      if (editing && !readOnly || forceComponent) {
	        return component;
	      }
	    }
	  }, {
	    key: 'renderEditor',
	    value: function renderEditor(editing, cell, row, col, dataEditor) {
	      if (editing) {
	        var Editor = cell.dataEditor || dataEditor || _DataEditor2.default;
	        return _react2.default.createElement(Editor, {
	          cell: cell,
	          row: row,
	          col: col,
	          value: this.state.value,
	          onChange: this.handleChange,
	          onCommit: this.handleCommit,
	          onRevert: this.handleRevert,
	          onKeyDown: this.handleKey
	        });
	      }
	    }
	  }, {
	    key: 'renderViewer',
	    value: function renderViewer(cell, row, col, valueRenderer, valueViewer) {
	      var Viewer = cell.valueViewer || valueViewer || _ValueViewer2.default;
	      var value = (0, _renderHelpers.renderValue)(cell, row, col, valueRenderer);
	      return _react2.default.createElement(Viewer, { cell: cell, row: row, col: col, value: value });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props7 = this.props,
	          row = _props7.row,
	          col = _props7.col,
	          cell = _props7.cell,
	          CellRenderer = _props7.cellRenderer,
	          valueRenderer = _props7.valueRenderer,
	          dataEditor = _props7.dataEditor,
	          valueViewer = _props7.valueViewer,
	          attributesRenderer = _props7.attributesRenderer,
	          selected = _props7.selected,
	          editing = _props7.editing,
	          onKeyUp = _props7.onKeyUp;
	      var updated = this.state.updated;
	
	
	      var content = this.renderComponent(editing, cell) || this.renderEditor(editing, cell, row, col, dataEditor) || this.renderViewer(cell, row, col, valueRenderer, valueViewer);
	
	      var className = [cell.className, 'cell', cell.overflow, selected && 'selected', editing && 'editing', cell.readOnly && 'read-only', updated && 'updated'].filter(function (a) {
	        return a;
	      }).join(' ');
	
	      return _react2.default.createElement(
	        CellRenderer,
	        {
	          row: row,
	          col: col,
	          cell: cell,
	          selected: selected,
	          editing: editing,
	          updated: updated,
	          attributesRenderer: attributesRenderer,
	          className: className,
	          style: widthStyle(cell),
	          onMouseDown: this.handleMouseDown,
	          onMouseOver: this.handleMouseOver,
	          onDoubleClick: this.handleDoubleClick,
	          onContextMenu: this.handleContextMenu,
	          onKeyUp: onKeyUp
	        },
	        content
	      );
	    }
	  }]);
	
	  return DataCell;
	}(_react.PureComponent);
	
	exports.default = DataCell;
	
	
	DataCell.propTypes = {
	  row: _propTypes2.default.number.isRequired,
	  col: _propTypes2.default.number.isRequired,
	  cell: _propTypes2.default.shape(_CellShape2.default).isRequired,
	  forceEdit: _propTypes2.default.bool,
	  selected: _propTypes2.default.bool,
	  editing: _propTypes2.default.bool,
	  clearing: _propTypes2.default.bool,
	  cellRenderer: _propTypes2.default.func,
	  valueRenderer: _propTypes2.default.func.isRequired,
	  dataRenderer: _propTypes2.default.func,
	  valueViewer: _propTypes2.default.func,
	  dataEditor: _propTypes2.default.func,
	  attributesRenderer: _propTypes2.default.func,
	  onNavigate: _propTypes2.default.func.isRequired,
	  onMouseDown: _propTypes2.default.func.isRequired,
	  onMouseOver: _propTypes2.default.func.isRequired,
	  onDoubleClick: _propTypes2.default.func.isRequired,
	  onContextMenu: _propTypes2.default.func.isRequired,
	  onChange: _propTypes2.default.func.isRequired,
	  onRevert: _propTypes2.default.func.isRequired
	};
	
	DataCell.defaultProps = {
	  forceEdit: false,
	  selected: false,
	  editing: false,
	  clearing: false,
	  cellRenderer: _Cell2.default
	};

/***/ }),
/* 2650 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var TAB_KEY = exports.TAB_KEY = 9;
	var ENTER_KEY = exports.ENTER_KEY = 13;
	var ESCAPE_KEY = exports.ESCAPE_KEY = 27;
	var LEFT_KEY = exports.LEFT_KEY = 37;
	var UP_KEY = exports.UP_KEY = 38;
	var RIGHT_KEY = exports.RIGHT_KEY = 39;
	var DOWN_KEY = exports.DOWN_KEY = 40;
	var DELETE_KEY = exports.DELETE_KEY = 46;
	var BACKSPACE_KEY = exports.BACKSPACE_KEY = 8;

/***/ }),
/* 2651 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(956);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _CellShape = __webpack_require__(2647);
	
	var _CellShape2 = _interopRequireDefault(_CellShape);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DataEditor = function (_PureComponent) {
	  _inherits(DataEditor, _PureComponent);
	
	  function DataEditor(props) {
	    _classCallCheck(this, DataEditor);
	
	    var _this = _possibleConstructorReturn(this, (DataEditor.__proto__ || Object.getPrototypeOf(DataEditor)).call(this, props));
	
	    _this.handleChange = _this.handleChange.bind(_this);
	    return _this;
	  }
	
	  _createClass(DataEditor, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this._input.focus();
	    }
	  }, {
	    key: 'handleChange',
	    value: function handleChange(e) {
	      this.props.onChange(e.target.value);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          value = _props.value,
	          onKeyDown = _props.onKeyDown;
	
	      return _react2.default.createElement('input', {
	        ref: function ref(input) {
	          _this2._input = input;
	        },
	        className: 'data-editor',
	        value: value,
	        onChange: this.handleChange,
	        onKeyDown: onKeyDown
	      });
	    }
	  }]);
	
	  return DataEditor;
	}(_react.PureComponent);
	
	exports.default = DataEditor;
	
	
	DataEditor.propTypes = {
	  value: _propTypes2.default.node.isRequired,
	  row: _propTypes2.default.number.isRequired,
	  col: _propTypes2.default.number.isRequired,
	  cell: _propTypes2.default.shape(_CellShape2.default),
	  onChange: _propTypes2.default.func.isRequired,
	  onCommit: _propTypes2.default.func.isRequired,
	  onRevert: _propTypes2.default.func.isRequired,
	  onKeyDown: _propTypes2.default.func.isRequired
	};

/***/ }),
/* 2652 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(956);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _CellShape = __webpack_require__(2647);
	
	var _CellShape2 = _interopRequireDefault(_CellShape);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ValueViewer = function (_PureComponent) {
	  _inherits(ValueViewer, _PureComponent);
	
	  function ValueViewer() {
	    _classCallCheck(this, ValueViewer);
	
	    return _possibleConstructorReturn(this, (ValueViewer.__proto__ || Object.getPrototypeOf(ValueViewer)).apply(this, arguments));
	  }
	
	  _createClass(ValueViewer, [{
	    key: 'render',
	    value: function render() {
	      var value = this.props.value;
	
	      return _react2.default.createElement(
	        'span',
	        { className: 'value-viewer' },
	        value
	      );
	    }
	  }]);
	
	  return ValueViewer;
	}(_react.PureComponent);
	
	exports.default = ValueViewer;
	
	
	ValueViewer.propTypes = {
	  row: _propTypes2.default.number.isRequired,
	  col: _propTypes2.default.number.isRequired,
	  cell: _propTypes2.default.shape(_CellShape2.default),
	  value: _propTypes2.default.node.isRequired
	};

/***/ }),
/* 2653 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.renderValue = renderValue;
	exports.renderData = renderData;
	function renderValue(cell, row, col, valueRenderer) {
	  var value = valueRenderer(cell, row, col);
	  return value === null || typeof value === 'undefined' ? '' : value;
	}
	
	function renderData(cell, row, col, valueRenderer, dataRenderer) {
	  var value = dataRenderer ? dataRenderer(cell, row, col) : null;
	  return value === null || typeof value === 'undefined' ? renderValue(cell, row, col, valueRenderer) : value;
	}

/***/ }),
/* 2654 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(2655);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(1718)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../css-loader/index.js!./react-datasheet.css", function() {
				var newContent = require("!!./../../css-loader/index.js!./react-datasheet.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2655 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1717)();
	// imports
	
	
	// module
	exports.push([module.id, "span.data-grid-container,span.data-grid-container:focus{outline:none}.data-grid-container .data-grid{table-layout:fixed;border-collapse:collapse}.data-grid-container .data-grid .cell.updated{background-color:rgba(0,145,253,.16);transition:background-color 0ms ease}.data-grid-container .data-grid .cell{height:17px;user-select:none;-moz-user-select:none;-webkit-user-select:none;-ms-user-select:none;cursor:cell;background-color:unset;transition:background-color .5s ease;vertical-align:middle;text-align:right;border:1px solid #ddd;padding:0}.data-grid-container .data-grid .cell.selected{border:1px double #2185d0;transition:none;box-shadow:inset 0 -100px 0 rgba(33,133,208,.15)}.data-grid-container .data-grid .cell.read-only{background:#f5f5f5;color:#999;text-align:center}.data-grid-container .data-grid .cell>.text{padding:2px 5px;text-overflow:ellipsis;overflow:hidden}.data-grid-container .data-grid .cell>input{outline:none!important;border:2px solid #2185d0;text-align:right;width:calc(100% - 6px);height:11px;background:none;display:block}.data-grid-container .data-grid .cell{vertical-align:bottom}.data-grid-container .data-grid .cell,.data-grid-container .data-grid .cell.wrap,.data-grid-container .data-grid.clip .cell.wrap,.data-grid-container .data-grid.nowrap .cell.wrap,.data-grid-container .data-grid.wrap .cell,.data-grid-container .data-grid.wrap .cell.wrap{white-space:normal}.data-grid-container .data-grid .cell.nowrap,.data-grid-container .data-grid.clip .cell.nowrap,.data-grid-container .data-grid.nowrap .cell,.data-grid-container .data-grid.nowrap .cell.nowrap,.data-grid-container .data-grid.wrap .cell.nowrap{white-space:nowrap;overflow-x:visible}.data-grid-container .data-grid .cell.clip,.data-grid-container .data-grid.clip .cell,.data-grid-container .data-grid.clip .cell.clip,.data-grid-container .data-grid.nowrap .cell.clip,.data-grid-container .data-grid.wrap .cell.clip{white-space:nowrap;overflow-x:hidden}.data-grid-container .data-grid .cell .data-editor,.data-grid-container .data-grid .cell .value-viewer{display:block}", ""]);
	
	// exports


/***/ }),
/* 2656 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _alt = __webpack_require__(975);
	
	var _alt2 = _interopRequireDefault(_alt);
	
	var _keyBy = __webpack_require__(990);
	
	var _keyBy2 = _interopRequireDefault(_keyBy);
	
	var _extend = __webpack_require__(1212);
	
	var _extend2 = _interopRequireDefault(_extend);
	
	var _values = __webpack_require__(1214);
	
	var _values2 = _interopRequireDefault(_values);
	
	var _PersonUtil = __webpack_require__(2657);
	
	var _PersonUtil2 = _interopRequireDefault(_PersonUtil);
	
	var _PersonActions = __webpack_require__(2658);
	
	var _PersonActions2 = _interopRequireDefault(_PersonActions);
	
	var _GlobalNotificationActions = __webpack_require__(1182);
	
	var _GlobalNotificationActions2 = _interopRequireDefault(_GlobalNotificationActions);
	
	var _UserStore = __webpack_require__(974);
	
	var _UserStore2 = _interopRequireDefault(_UserStore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var PersonStore = function () {
	  function PersonStore() {
	    _classCallCheck(this, PersonStore);
	
	    this.bindActions(_PersonActions2.default);
	
	    this.state = {
	      people: {},
	      peopleAutocomplete: [],
	      isFetching: false,
	      isSaving: false,
	      isSendingPasswordReset: false
	    };
	
	    this.exportPublicMethods({
	      getPersonById: this.getPersonById.bind(this),
	      getPeople: this.getPeople.bind(this),
	      getPeopleAutocomplete: this.getPeopleAutocomplete.bind(this)
	    });
	  }
	
	  _createClass(PersonStore, [{
	    key: "getPersonById",
	    value: function getPersonById(id) {
	      return this.state.people[id];
	    }
	  }, {
	    key: "getPeople",
	    value: function getPeople() {
	      return (0, _values2.default)(this.state.people);
	    }
	  }, {
	    key: "getPeopleAutocomplete",
	    value: function getPeopleAutocomplete() {
	      return this.state.peopleAutocomplete;
	    }
	  }, {
	    key: "onFetchAll",
	    value: function onFetchAll(options) {
	      var _this = this;
	
	      this.setState({ isFetching: true });
	      _PersonUtil2.default.fetchAll(_UserStore2.default.getState().apiKey, options).then(function (data) {
	        _PersonActions2.default.updatePeople((0, _keyBy2.default)(data, "id"));
	        _this.setState({ isFetching: false });
	      }).catch(_PersonActions2.default.fetchFailed);
	    }
	  }, {
	    key: "onFetchOne",
	    value: function onFetchOne(id) {
	      _PersonUtil2.default.fetchOne(_UserStore2.default.getState().apiKey, id).then(function (data) {
	        _PersonActions2.default.updatePerson(id, data);
	      }).catch(_PersonActions2.default.fetchFailed);
	    }
	  }, {
	    key: "onFetchAutocomplete",
	    value: function onFetchAutocomplete(query) {
	      var _this2 = this;
	
	      this.setState({ isFetching: true });
	      _PersonUtil2.default.fetchAutocomplete(_UserStore2.default.getState().apiKey, query).then(function (data) {
	        _PersonActions2.default.updateAutocomplete(data);
	        _this2.setState({ isFetching: true });
	      }).catch(_PersonActions2.default.fetchFailed);
	    }
	  }, {
	    key: "onUpdatePerson",
	    value: function onUpdatePerson(d) {
	      this.state.people[d.id] = d.data;
	      this.setState(this.state);
	    }
	  }, {
	    key: "onUpdatePeople",
	    value: function onUpdatePeople(data) {
	      if (!data) {
	        this.state.people = {};
	      } else {
	        this.state.people = data;
	      }
	      this.setState(this.state);
	    }
	  }, {
	    key: "onUpdateAutocomplete",
	    value: function onUpdateAutocomplete(data) {
	      if (!data) {
	        this.state.peopleAutocomplete = [];
	      } else {
	        this.state.peopleAutocomplete = data.data.people;
	      }
	      this.setState(this.state);
	    }
	  }, {
	    key: "onEdit",
	    value: function onEdit(newData) {
	      var _this3 = this;
	
	      _GlobalNotificationActions2.default.notify.defer("Updating person...");
	      this.setState({ isSaving: true });
	      _PersonUtil2.default.edit(_UserStore2.default.getState().apiKey, newData.id, newData.values).then(function (data) {
	        _this3.setState({ isSaving: false });
	        _PersonActions2.default.updatePerson(newData.id, data);
	        _GlobalNotificationActions2.default.notify.defer("Person updated successfully.");
	      }).catch(_PersonActions2.default.editFailed);
	    }
	  }, {
	    key: "onCreate",
	    value: function onCreate(newData) {
	      var _this4 = this;
	
	      this.setState({ isSaving: true });
	      _PersonUtil2.default.create(_UserStore2.default.getState().apiKey, newData.values).then(function (data) {
	        _this4.setState({ isSaving: false });
	        _PersonActions2.default.updatePerson(data.id, data);
	        _GlobalNotificationActions2.default.notify.defer("Person created successfully.");
	      }).catch(_PersonActions2.default.editFailed);
	    }
	  }, {
	    key: "onForgotPassword",
	    value: function onForgotPassword(_ref) {
	      var _this5 = this;
	
	      var id = _ref.id;
	      var event_bucket = _ref.event_bucket;
	
	      this.setState({ isSendingPasswordReset: true });
	      _GlobalNotificationActions2.default.notify.defer("Sending password reset email...");
	      _PersonUtil2.default.forgotPassword(_UserStore2.default.getState().apiKey, id, event_bucket).then(function (data) {
	        _this5.setState({ isSendingPasswordReset: false });
	        _GlobalNotificationActions2.default.notify.defer("Password reset instructions sent successfully to \"" + data.email + "\".");
	      }).catch(function (e) {
	        _GlobalNotificationActions2.default.notify.defer("Error sending password reset instructions: " + e.message);
	      });
	    }
	  }, {
	    key: "onFetchFailed",
	    value: function onFetchFailed(e) {
	      alert("Fetching person failed: " + e.message);
	      throw e;
	    }
	  }, {
	    key: "onEditFailed",
	    value: function onEditFailed(e) {
	      alert("Editing person failed: " + e.message);
	      throw e;
	    }
	  }]);
	
	  return PersonStore;
	}();
	
	exports.default = _alt2.default.createStore(PersonStore, "PersonStore");
	module.exports = exports["default"];

/***/ }),
/* 2657 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _merge = __webpack_require__(732);
	
	var _merge2 = _interopRequireDefault(_merge);
	
	var _api = __webpack_require__(1160);
	
	var _api2 = _interopRequireDefault(_api);
	
	var _config = __webpack_require__(1173);
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  fetchAll: function fetchAll(apiKey, options) {
	    if (options && options.conditions) {
	      options.conditions = JSON.stringify(options.conditions);
	    }
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "GET",
	        endpoint: "people",
	        allow_cache: true,
	        qs: options,
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response.people);
	      });
	    });
	  },
	  fetchOne: function fetchOne(apiKey, id) {
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "GET",
	        endpoint: "people/" + id,
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response);
	      });
	    });
	  },
	  fetchAutocomplete: function fetchAutocomplete(apiKey, query) {
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "GET",
	        endpoint: "people/autocomplete?query=" + query,
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response);
	      });
	    });
	  },
	  edit: function edit(apiKey, id, values) {
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "POST",
	        endpoint: "people/" + id,
	        json: values,
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response);
	      });
	    });
	  },
	  create: function create(apiKey, values) {
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "POST",
	        endpoint: "people/admin_create",
	        json: values,
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response);
	      });
	    });
	  },
	  forgotPassword: function forgotPassword(apiKey, id, event_bucket) {
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "POST",
	        endpoint: "people/" + id + "/forgot_password",
	        json: {
	          event_bucket: event_bucket
	        },
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response);
	      });
	    });
	  }
	};
	module.exports = exports["default"];

/***/ }),
/* 2658 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _alt = __webpack_require__(975);
	
	var _alt2 = _interopRequireDefault(_alt);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var PersonActions = function () {
	  function PersonActions() {
	    _classCallCheck(this, PersonActions);
	
	    this.generateActions("updatePeople", "fetchOne", "fetchAll", "fetchAutocomplete", "fetchFailed", "editFailed", "forgotPassword");
	  }
	
	  _createClass(PersonActions, [{
	    key: "updatePerson",
	    value: function updatePerson(id, data) {
	      return { id: id, data: data };
	    }
	  }, {
	    key: "updateAutocomplete",
	    value: function updateAutocomplete(data) {
	      return { data: data };
	    }
	  }, {
	    key: "edit",
	    value: function edit(id, values) {
	      return { id: id, values: values };
	    }
	  }, {
	    key: "create",
	    value: function create(values) {
	      return { values: values };
	    }
	  }]);
	
	  return PersonActions;
	}();
	
	exports.default = _alt2.default.createActions(PersonActions);
	module.exports = exports["default"];

/***/ }),
/* 2659 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _materialUi = __webpack_require__(576);
	
	var _util = __webpack_require__(1183);
	
	var _cashChangeWidget = __webpack_require__(2660);
	
	var _cashChangeWidget2 = _interopRequireDefault(_cashChangeWidget);
	
	var _base = __webpack_require__(1755);
	
	var _base2 = _interopRequireDefault(_base);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BoxOfficePayment = function (_React$Component) {
	  _inherits(BoxOfficePayment, _React$Component);
	
	  function BoxOfficePayment(props) {
	    _classCallCheck(this, BoxOfficePayment);
	
	    return _possibleConstructorReturn(this, Object.getPrototypeOf(BoxOfficePayment).call(this, props));
	  }
	
	  _createClass(BoxOfficePayment, [{
	    key: "getStyles",
	    value: function getStyles() {
	      return {
	        text: {
	          margin: "1em 0"
	        },
	        externalIntro: {
	          marginTop: "2em"
	        },
	        externalTotal: {
	          margin: "0.5em 0 1.5em",
	          fontSize: 30,
	          fontWeight: "bold"
	        },
	        externalButton: {
	          marginBottom: "1em"
	        }
	      };
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var styles = this.getStyles();
	
	      var _props = this.props;
	      var orderData = _props.orderData;
	      var processedData = _props.processedData;
	      var headerStyle = _props.headerStyle;
	      var orderInProgress = _props.orderInProgress;
	      var orderErrorMessage = _props.orderErrorMessage;
	      var eventBucket = _props.eventBucket;
	      var externalNeedsConfirm = _props.externalNeedsConfirm;
	
	
	      var ready = orderData.missingRequiredFields === false && orderData.subitems.filter(function (i) {
	        return !i.service_fee;
	      }).length && (orderData.customerType === "groupSales" || !orderData.subitems.some(function (i) {
	        return i.seats && i.seats.length === 0;
	      })) && (processedData.total === 0 || orderData.paymentType === "terminal" || orderData.paymentType === "cash" || orderData.paymentType === "external" || orderData.paymentType === "check" || orderData.person && orderData.paymentType === "saved" || orderData.paymentType === "card" && orderData.paymentCardDetails && orderData.paymentCardDetails.number && orderData.paymentCardDetails.exp_year);
	
	      var ticketQuantity = orderData.subitems.filter(function (i) {
	        return i.ticket_bucket;
	      }).reduce(function (c, i) {
	        return i.quantity + c;
	      }, 0);
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          _base2.default,
	          {
	            open: externalNeedsConfirm,
	            onRequestClose: this.props.cancelExternal,
	            useMuiDefaultStyle: true,
	            dialogContentStyle: { maxWidth: 400, textAlign: "center" },
	            showCloseButton: true
	          },
	          _react2.default.createElement(
	            "div",
	            { style: styles.externalIntro },
	            "Collect external payment."
	          ),
	          _react2.default.createElement(
	            "div",
	            { style: styles.externalTotal },
	            (0, _util.formatPrice)(processedData.total)
	          ),
	          _react2.default.createElement(_materialUi.RaisedButton, {
	            primary: true,
	            label: "Mark as paid",
	            style: styles.externalButton,
	            onClick: this.props.submitOrder
	          })
	        ),
	        _react2.default.createElement(
	          "div",
	          { style: headerStyle },
	          "Confirm order"
	        ),
	        _react2.default.createElement(
	          "div",
	          { style: styles.text },
	          processedData.total === 0 ? _react2.default.createElement(
	            "div",
	            null,
	            "The order total is ",
	            (0, _util.formatPrice)(0, true),
	            ", so the customer will not be charged."
	          ) : orderData.paymentType === "check" ? _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(
	              "div",
	              null,
	              "Collect a check in the amount of",
	              " ",
	              (0, _util.formatPrice)(processedData.total),
	              " from the customer, then click \"Place order\"."
	            ),
	            _react2.default.createElement(_materialUi.TextField, {
	              floatingLabelText: "Check number",
	              floatingLabelFixed: true,
	              hintText: "123456",
	              value: orderData.check_number,
	              onChange: function onChange(e) {
	                return _this2.props.updateCurrentOrder({
	                  check_number: e.target.value
	                });
	              },
	              style: {
	                display: "block",
	                width: 300,
	                marginTop: -6,
	                marginBottom: 6
	              }
	            })
	          ) : orderData.paymentType === "external" ? _react2.default.createElement(
	            "div",
	            null,
	            "When you click \"Place order\", the customer will be prompted to pay",
	            " ",
	            (0, _util.formatPrice)(processedData.total),
	            ".",
	            _react2.default.createElement("br", null),
	            " Follow the instructions on your external POS to complete the order."
	          ) : orderData.paymentType === "terminal" ? _react2.default.createElement(
	            "div",
	            null,
	            "When you click \"Place order\", the customer will be prompted to pay",
	            " ",
	            (0, _util.formatPrice)(processedData.total),
	            ".",
	            _react2.default.createElement("br", null),
	            " Follow the instructions on Eventive Terminal to complete the order."
	          ) : orderData.paymentType === "cash" ? _react2.default.createElement(
	            "div",
	            { style: { marginBottom: "1em" } },
	            _react2.default.createElement(_cashChangeWidget2.default, { total: processedData.total })
	          ) : _react2.default.createElement(
	            "div",
	            null,
	            "When you click \"Place order\",",
	            " ",
	            orderData.paymentType === "saved" && orderData.person ? "the customer's saved " + orderData.person.details.payment_method_summary + " " : "the customer's card " + (orderData.paymentCardDetails && orderData.paymentCardDetails.number ? "ending in " + orderData.paymentCardDetails.number.slice(-4) : "") + " ",
	            "will be charged ",
	            (0, _util.formatPrice)(processedData.total),
	            "."
	          ),
	          orderData.person || orderData.group_sale_data && orderData.group_sale_data.length ? _react2.default.createElement(
	            "div",
	            null,
	            "A receipt will",
	            orderData.suppress_email_confirmation ? " NOT " : " ",
	            "be emailed to \"",
	            orderData.group_sale_data ? orderData.group_sale_data.map(function (s) {
	              return s.email;
	            }).join('", "') : orderData.person && orderData.person.details.email,
	            "\"."
	          ) : null
	        ),
	        orderErrorMessage ? _react2.default.createElement(
	          "div",
	          {
	            style: Object.assign({}, styles.text, {
	              color: "red",
	              maxWidth: 500
	            })
	          },
	          orderErrorMessage
	        ) : null,
	        ticketQuantity && eventBucket.box_office_show_mark_scanned ? _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement(_materialUi.Checkbox, {
	            style: { margin: "0 0 1em" },
	            label: "Mark " + (ticketQuantity !== 1 ? "all" : "the") + " " + ticketQuantity + " ticket" + (ticketQuantity !== 1 ? "s" : "") + " in " + (orderData.group_sale_data ? "each" : "") + " order as scanned",
	            checked: orderData.mark_as_used,
	            onCheck: function onCheck() {
	              return _this2.props.updateCurrentOrder({
	                mark_as_used: !orderData.mark_as_used
	              });
	            }
	          })
	        ) : null,
	        this.props.showEmailSuppressionCheckbox ? _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement(_materialUi.Checkbox, {
	            style: { margin: "0 0 1em" },
	            label: "Do not send confirmation email to customer",
	            checked: orderData.suppress_email_confirmation,
	            onCheck: function onCheck() {
	              return _this2.props.updateCurrentOrder({
	                suppress_email_confirmation: !orderData.suppress_email_confirmation
	              });
	            }
	          })
	        ) : null,
	        _react2.default.createElement(_materialUi.RaisedButton, {
	          primary: true,
	          disabled: !ready || orderInProgress,
	          label: orderInProgress ? "Placing order..." : "Place order (" + (0, _util.formatPrice)(processedData.total) + ")",
	          onClick: this.props.submitOrder
	        })
	      );
	    }
	  }]);
	
	  return BoxOfficePayment;
	}(_react2.default.Component);
	
	exports.default = BoxOfficePayment;
	module.exports = exports["default"];

/***/ }),
/* 2660 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _materialUi = __webpack_require__(576);
	
	var _uniq = __webpack_require__(2188);
	
	var _uniq2 = _interopRequireDefault(_uniq);
	
	var _util = __webpack_require__(1183);
	
	var _currencyField = __webpack_require__(1747);
	
	var _currencyField2 = _interopRequireDefault(_currencyField);
	
	var _label = __webpack_require__(1682);
	
	var _label2 = _interopRequireDefault(_label);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BUTTON_STYLE = {
	  borderWidth: "1px",
	  borderStyle: "solid",
	  borderColor: "rgb(33, 33, 33)",
	  marginRight: 7
	};
	
	var SELECTED_STYLE = {
	  backgroundColor: "rgb(2, 136, 209)",
	  color: "#fff",
	  borderColor: "rgb(2, 136, 209)"
	};
	
	var CashChangeWidget = function (_React$Component) {
	  _inherits(CashChangeWidget, _React$Component);
	
	  function CashChangeWidget(props) {
	    _classCallCheck(this, CashChangeWidget);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(CashChangeWidget).call(this, props));
	
	    _this.state = {
	      tendered: 0,
	      hasEdited: false
	    };
	    return _this;
	  }
	
	  _createClass(CashChangeWidget, [{
	    key: "_makeRecommendedCashAmounts",
	    value: function _makeRecommendedCashAmounts(total) {
	      var fractional = total / 100,
	          units = [1, 5, 10, 20, 50, 100];
	
	      return (0, _uniq2.default)([fractional].concat(units.map(function (u) {
	        return u > fractional ? u : Math.ceil(fractional / u) * u;
	      }))).map(function (fractional) {
	        return fractional && fractional * 100;
	      }).filter(function (u) {
	        return !!u;
	      }).sort(function (a, b) {
	        return a - b;
	      }).slice(0, 3);
	    }
	  }, {
	    key: "componentWillMount",
	    value: function componentWillMount() {
	      this.componentWillReceiveProps(this.props);
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(props) {
	      if (props.total !== this.props.total || !this.state.hasEdited) {
	        this.setState({ tendered: props.total });
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var total = this.props.total;
	      var tendered = this.state.tendered;
	
	
	      var suggestedTenders = this._makeRecommendedCashAmounts(this.props.total),
	          isCustomTender = suggestedTenders.indexOf(tendered) === -1;
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          "div",
	          null,
	          "Collect ",
	          (0, _util.formatPrice)(total),
	          " in cash from the customer, then click \"Place order\"."
	        ),
	        _react2.default.createElement(
	          _label2.default,
	          { style: { marginBottom: 0 } },
	          "Cash tendered"
	        ),
	        _react2.default.createElement(
	          "div",
	          null,
	          suggestedTenders.map(function (amount) {
	            return _react2.default.createElement(_materialUi.FlatButton, {
	              style: Object.assign({}, BUTTON_STYLE, tendered === amount && SELECTED_STYLE),
	              labelStyle: { verticalAlign: 0 },
	              label: (0, _util.formatPrice)(amount, true),
	              onClick: function onClick() {
	                return _this2.setState({ hasEdited: true, tendered: amount });
	              }
	            });
	          }),
	          _react2.default.createElement(_currencyField2.default, {
	            placeholder: "$0.00",
	            style: { width: 75 },
	            inputStyle: { color: "rgb(2, 136, 209)" },
	            value: isCustomTender ? this.state.tendered : 0,
	            onChange: function onChange(e) {
	              return _this2.setState({
	                hasEdited: true,
	                tendered: e.target.value === 0 ? total : e.target.value
	              });
	            }
	          })
	        ),
	        tendered ? _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement(
	            _label2.default,
	            { style: { marginTop: 5, marginBottom: 0 } },
	            "Change due"
	          ),
	          _react2.default.createElement(
	            "div",
	            { style: { fontSize: "11pt" } },
	            tendered < total ? _react2.default.createElement(
	              "span",
	              { style: { color: "red" } },
	              "Insufficient payment \u2013 ",
	              (0, _util.formatPrice)(total - tendered),
	              " ",
	              "still owed."
	            ) : _react2.default.createElement(
	              "span",
	              null,
	              (0, _util.formatPrice)(tendered - total)
	            )
	          )
	        ) : null
	      );
	    }
	  }]);
	
	  return CashChangeWidget;
	}(_react2.default.Component);
	
	exports.default = CashChangeWidget;
	module.exports = exports["default"];

/***/ }),
/* 2661 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _materialUi = __webpack_require__(576);
	
	var _moment = __webpack_require__(1021);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _UserStore = __webpack_require__(974);
	
	var _UserStore2 = _interopRequireDefault(_UserStore);
	
	var _BoxOfficeActions = __webpack_require__(2624);
	
	var _BoxOfficeActions2 = _interopRequireDefault(_BoxOfficeActions);
	
	var _numberSegmentedInput = __webpack_require__(2662);
	
	var _numberSegmentedInput2 = _interopRequireDefault(_numberSegmentedInput);
	
	var _linkLike = __webpack_require__(973);
	
	var _linkLike2 = _interopRequireDefault(_linkLike);
	
	var _base = __webpack_require__(1755);
	
	var _base2 = _interopRequireDefault(_base);
	
	var _inlineNoticeLabel = __webpack_require__(1222);
	
	var _inlineNoticeLabel2 = _interopRequireDefault(_inlineNoticeLabel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var IS_SIMULATED = window.location.search.indexOf("TERMINAL_SIMULATED=1") !== -1;
	
	var READER_SAVED_KEY = "eventive--savedTerminalReader";
	var CONNECT_TIMEOUT = 10000;
	
	var BASE_STYLE = {
	  display: "inline-block",
	  padding: "5px 10px",
	  borderRadius: 5,
	  background: "#fff",
	  boxShadow: "0px 0px 7px 1px rgba(0,0,0,0.2)"
	};
	
	var Terminal = function (_React$Component) {
	  _inherits(Terminal, _React$Component);
	
	  function Terminal(props) {
	    _classCallCheck(this, Terminal);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(Terminal).call(this, props));
	
	    _this.state = {
	      pairingCode: "",
	      modalOpen: false,
	      pairingTerminal: false,
	      pairingError: "",
	      lastDisplayData: null,
	      pairedReader: null
	    };
	
	    _this.openModal = _this.openModal.bind(_this);
	    _this.closeModal = _this.closeModal.bind(_this);
	    _this.pairTerminal = _this.pairTerminal.bind(_this);
	    _this.disconnectTerminal = _this.disconnectTerminal.bind(_this);
	    return _this;
	  }
	
	  _createClass(Terminal, [{
	    key: "componentWillMount",
	    value: function componentWillMount() {
	      var _this2 = this;
	
	      setTimeout(function () {
	        _this2.props.initializeTerminal();
	        var savedReaderId = window.localStorage.getItem(READER_SAVED_KEY);
	        if (savedReaderId && _this2.props.terminalConnectionStatus === "not_connected") {
	          _this2.setState({ pairingCode: savedReaderId }, function () {
	            _this2.pairTerminal();
	          });
	        }
	      }, 0);
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(props) {
	      var _this3 = this;
	
	      var processedData = props.processedData;
	      var terminal = props.terminal;
	      var terminalConnectionStatus = props.terminalConnectionStatus;
	      var orderInProgress = props.orderInProgress;
	
	      if (processedData && processedData.subitems && terminal && terminalConnectionStatus === "connected" && !orderInProgress) {
	        (function () {
	          var displayData = {
	            type: "cart",
	            cart: {
	              line_items: processedData.subitems.filter(function (i) {
	                return i.quantity;
	              }).map(function (item) {
	                return {
	                  description: item.name,
	                  amount: item.price,
	                  quantity: Number.isInteger(item.quantity) ? item.quantity : 1
	                };
	              }),
	              total: processedData.total,
	              currency: (_UserStore2.default.getUser() || { currency: "usd" }).currency
	            }
	          };
	
	          _this3.setState(function (prevState) {
	            // only set the display if the data has changed
	            if (JSON.stringify(displayData) !== JSON.stringify(prevState.lastDisplayData)) {
	              if (displayData.cart.line_items.length < 1) {
	                terminal.clearReaderDisplay();
	              } else {
	                terminal.setReaderDisplay(displayData);
	              }
	            }
	
	            return _extends({}, prevState, {
	              lastDisplayData: displayData
	            });
	          });
	        })();
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      clearTimeout(this.timeout);
	      if (this.props.terminalConnectionStatus === "connected") {
	        this.props.terminal.clearReaderDisplay();
	      }
	    }
	  }, {
	    key: "openModal",
	    value: function openModal() {
	      this.setState({ modalOpen: true });
	    }
	  }, {
	    key: "closeModal",
	    value: function closeModal() {
	      this.setState({
	        modalOpen: false,
	        forceOpen: false,
	        pairingTerminal: false,
	        pairingCode: ""
	      });
	    }
	  }, {
	    key: "pairTerminal",
	    value: function () {
	      var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
	        var _this4 = this;
	
	        var config, discoverResult, reader, connectResult;
	        return regeneratorRuntime.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                this.setState({ pairingTerminal: true, pairingError: "" });
	
	                config = { simulated: IS_SIMULATED };
	                _context.next = 4;
	                return this.props.terminal.discoverReaders(config);
	
	              case 4:
	                discoverResult = _context.sent;
	
	                if (!discoverResult.error) {
	                  _context.next = 9;
	                  break;
	                }
	
	                this.setState({
	                  pairingTerminal: false,
	                  pairingCode: "",
	                  pairingError: discoverResult.error
	                });
	                _context.next = 29;
	                break;
	
	              case 9:
	                if (!(discoverResult.discoveredReaders.length === 0)) {
	                  _context.next = 13;
	                  break;
	                }
	
	                this.setState({
	                  pairingTerminal: false,
	                  pairingCode: "",
	                  pairingError: "No readers found. Make sure the reader is connected to the internet and try again."
	                });
	                _context.next = 29;
	                break;
	
	              case 13:
	                reader = discoverResult.discoveredReaders.find(function (r) {
	                  return IS_SIMULATED || r.serial_number.replace(/\d{9}(?!\d)/g, "") === _this4.state.pairingCode || (r.device_type === "bbpos_wisepos_e" || r.device_type === "stripe_s700_devkit" || r.device_type === "stripe_s700") && r.serial_number.indexOf(_this4.state.pairingCode) !== -1;
	                });
	
	                if (reader) {
	                  _context.next = 19;
	                  break;
	                }
	
	                console.log("[Eventive Terminal] Invalid code, readers found:", discoverResult.discoveredReaders);
	                this.setState({
	                  pairingTerminal: false,
	                  pairingCode: "",
	                  pairingError: "Invalid pairing code or reader not found. Make sure the reader is connected to the internet, check the code, and try again."
	                });
	                _context.next = 29;
	                break;
	
	              case 19:
	                if (!(reader.status === "offline")) {
	                  _context.next = 23;
	                  break;
	                }
	
	                this.setState({
	                  pairingTerminal: false,
	                  pairingCode: "",
	                  pairingError: "Reader offline. Make sure the reader is connected to the internet and try again."
	                });
	                _context.next = 29;
	                break;
	
	              case 23:
	                this.timeout = setTimeout(function () {
	                  _this4.setState({
	                    pairingTerminal: false,
	                    pairingCode: "",
	                    pairingError: "Unable to connect to reader."
	                  });
	                  _BoxOfficeActions2.default.terminalConnectionStatusChange("not_connected");
	                }, CONNECT_TIMEOUT);
	                _context.next = 26;
	                return this.props.terminal.connectReader(reader);
	
	              case 26:
	                connectResult = _context.sent;
	
	                clearTimeout(this.timeout);
	                if (connectResult.error) {
	                  _BoxOfficeActions2.default.terminalConnectionStatusChange("not_connected");
	                  this.setState({
	                    pairingTerminal: false,
	                    pairingCode: "",
	                    pairingError: connectResult.error
	                  });
	                } else {
	                  try {
	                    window.localStorage.setItem(READER_SAVED_KEY, this.state.pairingCode);
	                  } catch (e) {
	                    /* fall through */
	                  }
	                  console.log("[Eventive Terminal] Connected to reader:", connectResult.reader);
	                  this.setState({
	                    pairingTerminal: false,
	                    pairedReader: connectResult.reader,
	                    pairingCode: "",
	                    pairingError: ""
	                  }, function () {
	                    _this4.closeModal();
	                  });
	                }
	
	              case 29:
	              case "end":
	                return _context.stop();
	            }
	          }
	        }, _callee, this);
	      }));
	
	      function pairTerminal() {
	        return _ref.apply(this, arguments);
	      }
	
	      return pairTerminal;
	    }()
	  }, {
	    key: "disconnectTerminal",
	    value: function disconnectTerminal() {
	      this.props.terminal.disconnectReader();
	      try {
	        window.localStorage.removeItem(READER_SAVED_KEY);
	      } catch (e) {
	        /* fall through */
	      }
	      this.closeModal();
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this5 = this;
	
	      var _props = this.props;
	      var terminalConnectionStatus = _props.terminalConnectionStatus;
	      var terminalPaymentStatus = _props.terminalPaymentStatus;
	      var terminal = _props.terminal;
	      var _state = this.state;
	      var forceOpen = _state.forceOpen;
	      var pairingTerminal = _state.pairingTerminal;
	      var pairingCode = _state.pairingCode;
	      var pairingError = _state.pairingError;
	      var pairedReader = _state.pairedReader;
	
	
	      var isConnected = terminalConnectionStatus === "connected";
	      var isConnecting = terminalConnectionStatus === "connecting";
	
	      var terminalInProgress = terminalPaymentStatus === "processing" || terminalPaymentStatus === "waiting_for_input";
	
	      return _react2.default.createElement(
	        "div",
	        { style: Object.assign({}, BASE_STYLE) },
	        _react2.default.createElement(
	          _base2.default,
	          {
	            open: this.state.modalOpen || terminalInProgress,
	            onRequestClose: !forceOpen && this.closeModal,
	            useMuiDefaultStyle: true,
	            dialogContentStyle: { maxWidth: 400 },
	            actions: terminalInProgress ? [] : [_react2.default.createElement(_materialUi.FlatButton, {
	              label: "Cancel",
	              onTouchTap: forceOpen ? this.context.router.goBack : this.closeModal
	            }), _react2.default.createElement(_materialUi.FlatButton, {
	              primary: true,
	              disabled: pairingTerminal,
	              label: pairingTerminal || isConnecting ? "Connecting..." : isConnected ? "Disconnect Terminal" : "Connect Terminal",
	              onTouchTap: isConnected ? this.disconnectTerminal : this.pairTerminal
	            })]
	          },
	          _react2.default.createElement(
	            "h3",
	            { style: { textAlign: "center" } },
	            "Eventive Terminal",
	            " ",
	            _react2.default.createElement(_inlineNoticeLabel2.default, {
	              label: "Beta",
	              style: { verticalAlign: 3, marginLeft: 3 }
	            })
	          ),
	          terminalInProgress ? _react2.default.createElement(
	            "div",
	            { style: { textAlign: "center" } },
	            _react2.default.createElement(
	              "p",
	              null,
	              terminalPaymentStatus === "waiting_for_input" ? "Waiting for customer..." : "Processing payment..."
	            )
	          ) : isConnected ? _react2.default.createElement(
	            "div",
	            { style: { textAlign: "center" } },
	            _react2.default.createElement(
	              "p",
	              null,
	              "Currently connected to Eventive Terminal."
	            )
	          ) : isConnecting ? _react2.default.createElement(
	            "div",
	            { style: { textAlign: "center" } },
	            _react2.default.createElement(
	              "p",
	              null,
	              "Connecting to reader..."
	            )
	          ) : _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(
	              "p",
	              null,
	              "Use the dedicated countertop Eventive Terminal for fast & secure EMV, contactless, and swipe payments.",
	              " ",
	              _react2.default.createElement(
	                _linkLike2.default,
	                {
	                  onTouchTap: function onTouchTap() {
	                    return Intercom("showNewMessage", "I'm interested in Eventive Terminal rental / purchase options!");
	                  }
	                },
	                "Available for rent or purchase."
	              )
	            ),
	            _react2.default.createElement(
	              "p",
	              null,
	              "Have an Eventive Terminal? Connect it to the internet, then enter its pairing code."
	            ),
	            _react2.default.createElement(
	              "div",
	              { style: { marginTop: 36, textAlign: "center" } },
	              _react2.default.createElement(_numberSegmentedInput2.default, {
	                digits: 9,
	                chunkSize: 3,
	                value: pairingCode,
	                onChange: function onChange(pairingCode) {
	                  return _this5.setState({ pairingCode: pairingCode, pairingError: "" });
	                },
	                onFinish: this.pairTerminal,
	                disabled: isConnecting,
	                autoFocus: true
	              })
	            ),
	            pairingError ? _react2.default.createElement(
	              "div",
	              {
	                style: { marginTop: 24, textAlign: "center", color: "red" }
	              },
	              pairingError.message || pairingError
	            ) : null
	          )
	        ),
	        isConnecting ? _react2.default.createElement(
	          "span",
	          { style: { color: "rgb(33,33,33)" } },
	          "Terminal connecting..."
	        ) : isConnected ? _react2.default.createElement(
	          "span",
	          null,
	          _react2.default.createElement(
	            "strong",
	            null,
	            "Terminal connected"
	          ),
	          " \xB7",
	          " ",
	          _react2.default.createElement(
	            _linkLike2.default,
	            { onTouchTap: this.openModal },
	            "Manage"
	          )
	        ) : _react2.default.createElement(
	          "span",
	          null,
	          _react2.default.createElement(
	            _linkLike2.default,
	            { onTouchTap: this.openModal },
	            "Connect Eventive Terminal"
	          )
	        )
	      );
	    }
	  }]);
	
	  return Terminal;
	}(_react2.default.Component);
	
	Terminal.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	exports.default = Terminal;
	module.exports = exports["default"];

/***/ }),
/* 2662 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CONTAINER_STYLE = {
	  position: "relative",
	  display: "inline-block",
	  marginRight: -10
	};
	
	var fontSize = 20;
	var width = 24;
	var height = 48;
	var padding = 6;
	var separatorWidth = 20;
	
	var INPUT_STYLE = function INPUT_STYLE(_ref) {
	  var selectedIndex = _ref.selectedIndex;
	  var hideInput = _ref.hideInput;
	  var chunkSize = _ref.chunkSize;
	  return {
	    position: "absolute",
	    border: 0,
	    padding: 0,
	    fontSize: fontSize,
	    textAlign: "center",
	    backgroundColor: "transparent",
	    outline: "none",
	    width: width,
	    lineHeight: height + "px",
	    top: 0,
	    bottom: 0,
	    left: selectedIndex * (width + padding) + (chunkSize ? Math.floor(selectedIndex / chunkSize) * separatorWidth : 0) + "px",
	    opacity: hideInput ? 0 : 1
	  };
	};
	
	var FIELD_STYLE = {
	  width: width,
	  marginRight: padding,
	  height: height,
	  lineHeight: height + "px",
	  verticalAlign: "top",
	  fontSize: fontSize,
	  border: 0,
	  boxShadow: "0 0 2px #ccc",
	  textAlign: "center",
	  display: "inline-block",
	  color: "#000"
	};
	
	var SEPARATOR_STYLE = {
	  display: "inline-block",
	  width: separatorWidth - padding,
	  marginRight: padding,
	  lineHeight: height + "px",
	  fontSize: fontSize
	};
	
	var FOCUSED_FIELD_STYLE = {
	  boxShadow: "0 0 2px #0288d1"
	};
	
	var FINISHED_FIELD_STYLE = {
	  color: "#ccc"
	};
	
	var NumberSegmentedInput = function (_React$Component) {
	  _inherits(NumberSegmentedInput, _React$Component);
	
	  function NumberSegmentedInput(props) {
	    _classCallCheck(this, NumberSegmentedInput);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(NumberSegmentedInput).call(this, props));
	
	    _this.state = {
	      focused: false,
	      hasFinished: false
	    };
	
	    _this.onChange = _this.onChange.bind(_this);
	    return _this;
	  }
	
	  _createClass(NumberSegmentedInput, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      if (this.props.autoFocus && this.input) {
	        this.input.focus();
	      }
	      this.componentWillReceiveProps(this.props);
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(_ref2) {
	      var _this2 = this;
	
	      var value = _ref2.value;
	      var digits = _ref2.digits;
	      var onFinish = _ref2.onFinish;
	
	      if (!this.state.hasFinished && onFinish && value.length === digits) {
	        this.setState({ hasFinished: true }, function () {
	          return _this2.props.onFinish();
	        });
	      } else if (value.length < digits && this.state.hasFinished) {
	        this.setState({ hasFinished: false });
	      }
	    }
	  }, {
	    key: "onChange",
	    value: function onChange(v) {
	      v = v.replace(/[^0-9]*/g, "");
	      this.props.onChange(v);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this3 = this;
	
	      var _state = this.state;
	      var focused = _state.focused;
	      var hasFinished = _state.hasFinished;
	      var _props = this.props;
	      var digits = _props.digits;
	      var chunkSize = _props.chunkSize;
	      var value = _props.value;
	      var onFinish = _props.onFinish;
	
	
	      var selectedIndex = Math.min(value.length, digits),
	          hideInput = selectedIndex === digits;
	
	      return _react2.default.createElement(
	        "div",
	        { style: CONTAINER_STYLE, onClick: function onClick() {
	            return _this3.input.focus();
	          } },
	        _react2.default.createElement("input", {
	          style: INPUT_STYLE({ selectedIndex: selectedIndex, hideInput: hideInput, chunkSize: chunkSize }),
	          type: "text",
	          ref: function ref(r) {
	            _this3.input = r;
	          },
	          value: "",
	          onChange: function onChange(e) {
	            return !hasFinished && value.length < digits && _this3.onChange(value + e.target.value.toUpperCase());
	          },
	          onKeyUp: function onKeyUp(e) {
	            return !hasFinished && e.key === "Backspace" && _this3.onChange(value.substring(0, value.length - 1));
	          },
	          onFocus: function onFocus() {
	            return _this3.setState({ focused: true });
	          },
	          onBlur: function onBlur() {
	            return _this3.setState({ focused: false });
	          }
	        }),
	        new Array(digits).fill(0).map(function (c, i) {
	          return _react2.default.createElement(
	            "span",
	            null,
	            _react2.default.createElement(
	              "div",
	              {
	                key: i,
	                style: Object.assign({}, FIELD_STYLE, focused && selectedIndex === i && FOCUSED_FIELD_STYLE, hasFinished && FINISHED_FIELD_STYLE)
	              },
	              value[i]
	            ),
	            i + 1 < digits && (i + 1) % chunkSize === 0 ? _react2.default.createElement(
	              "span",
	              { style: SEPARATOR_STYLE },
	              "-"
	            ) : null
	          );
	        })
	      );
	    }
	  }]);
	
	  return NumberSegmentedInput;
	}(_react2.default.Component);
	
	exports.default = NumberSegmentedInput;
	module.exports = exports["default"];

/***/ }),
/* 2663 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _materialUi = __webpack_require__(576);
	
	var _moment = __webpack_require__(1021);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _connectToStores = __webpack_require__(1226);
	
	var _connectToStores2 = _interopRequireDefault(_connectToStores);
	
	var _ShiftActions2 = __webpack_require__(1221);
	
	var _ShiftActions3 = _interopRequireDefault(_ShiftActions2);
	
	var _ShiftStore = __webpack_require__(2626);
	
	var _ShiftStore2 = _interopRequireDefault(_ShiftStore);
	
	var _currencyField = __webpack_require__(1747);
	
	var _currencyField2 = _interopRequireDefault(_currencyField);
	
	var _linkLike = __webpack_require__(973);
	
	var _linkLike2 = _interopRequireDefault(_linkLike);
	
	var _base = __webpack_require__(1755);
	
	var _base2 = _interopRequireDefault(_base);
	
	var _util = __webpack_require__(1183);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BASE_STYLE = {
	  marginLeft: 10,
	  display: "inline-block",
	  padding: "5px 10px",
	  borderRadius: 5,
	  background: "#fff",
	  boxShadow: "0px 0px 7px 1px rgba(0,0,0,0.2)"
	};
	
	var NO_SHIFT_STYLE = {
	  backgroundColor: "red",
	  color: "#fff"
	};
	
	var ShiftTracking = function (_React$Component) {
	  _inherits(ShiftTracking, _React$Component);
	
	  function ShiftTracking(props) {
	    _classCallCheck(this, ShiftTracking);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(ShiftTracking).call(this, props));
	
	    _this.state = {
	      modalOpen: false,
	      forceOpen: false,
	      enteredCash: 0,
	      enteredNote: ""
	    };
	
	    _this.openModal = _this.openModal.bind(_this);
	    _this.closeModal = _this.closeModal.bind(_this);
	    _this.shiftAction = _this.shiftAction.bind(_this);
	    return _this;
	  }
	
	  _createClass(ShiftTracking, [{
	    key: "componentWillMount",
	    value: function componentWillMount() {
	      _ShiftActions3.default.fetchCurrentShift.defer();
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(props) {
	      var _this2 = this;
	
	      if (!props.isWorking && !props.currentShift && !this.state.modalOpen) {
	        this.setState({ forceOpen: true }, function () {
	          _this2.openModal();
	        });
	      }
	    }
	  }, {
	    key: "openModal",
	    value: function openModal() {
	      if (this.props.currentShift) {
	        _ShiftActions3.default.fetchCurrentShift();
	      }
	      this.setState({ modalOpen: true });
	    }
	  }, {
	    key: "closeModal",
	    value: function closeModal() {
	      this.setState({ modalOpen: false, forceOpen: false });
	    }
	  }, {
	    key: "shiftAction",
	    value: function shiftAction() {
	      var _ShiftActions,
	          _this3 = this;
	
	      var currentShift = this.props.currentShift;
	
	      _ShiftActions3.default[currentShift ? "closeShift" : "createShift"]((_ShiftActions = {}, _defineProperty(_ShiftActions, (currentShift ? "closing" : "starting") + "_cash", this.state.enteredCash), _defineProperty(_ShiftActions, (currentShift ? "closing" : "starting") + "_note", this.state.enteredNote), _ShiftActions));
	      this.setState({ modalOpen: false, forceOpen: false }, function () {
	        _this3.setState({ enteredNote: "", enteredCash: 0 });
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this4 = this;
	
	      var _props = this.props;
	      var isWorking = _props.isWorking;
	      var hasFetchedForFirstTime = _props.hasFetchedForFirstTime;
	      var currentShift = _props.currentShift;
	      var forceOpen = this.state.forceOpen;
	
	
	      return _react2.default.createElement(
	        "div",
	        {
	          style: Object.assign({}, BASE_STYLE, hasFetchedForFirstTime && !currentShift && NO_SHIFT_STYLE)
	        },
	        _react2.default.createElement(
	          _base2.default,
	          {
	            open: this.state.modalOpen,
	            onRequestClose: !forceOpen && this.closeModal,
	            useMuiDefaultStyle: true,
	            dialogContentStyle: { maxWidth: 300 },
	            actions: [_react2.default.createElement(_materialUi.FlatButton, {
	              label: "Cancel",
	              onTouchTap: forceOpen ? this.context.router.goBack : this.closeModal
	            }), _react2.default.createElement(_materialUi.FlatButton, {
	              primary: true,
	              label: currentShift ? "Close current shift" : "Open new shift",
	              onTouchTap: this.shiftAction
	            })]
	          },
	          currentShift ? _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(
	              "div",
	              { style: { marginBottom: 10 } },
	              "Shift #",
	              currentShift.short_id,
	              " opened",
	              " ",
	              (0, _moment2.default)(currentShift.started_at).format("lll"),
	              currentShift.starting_cash || currentShift.starting_note ? " with" : "",
	              currentShift.starting_cash ? " " + (0, _util.formatPrice)(currentShift.starting_cash) + " starting cash" + (currentShift.starting_note ? " and" : "") : "",
	              currentShift.starting_note ? " the note \"" + currentShift.starting_note + "\"" : "",
	              "."
	            ),
	            isWorking ? _react2.default.createElement(
	              "div",
	              null,
	              "Loading expected closing cash..."
	            ) : _react2.default.createElement(
	              "div",
	              null,
	              "Expected closing cash:",
	              " ",
	              (0, _util.formatPrice)(currentShift.expected_cash)
	            )
	          ) : _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(
	              "h3",
	              { style: { textAlign: "center" } },
	              "New shift"
	            ),
	            _react2.default.createElement(
	              "div",
	              null,
	              "You must open a new shift in order to launch box office sales."
	            )
	          ),
	          _react2.default.createElement(_currencyField2.default, {
	            autoFocus: true,
	            value: this.state.enteredCash,
	            floatingLabelText: (currentShift ? "Actual closing" : "Starting") + " cash",
	            floatingLabelFixed: true,
	            placeholder: "$0.00",
	            onChange: function onChange(e) {
	              return _this4.setState({ enteredCash: e.target.value });
	            }
	          }),
	          _react2.default.createElement(_materialUi.TextField, {
	            value: this.state.enteredNote,
	            floatingLabelText: (currentShift ? "Closing" : "Shift") + " note",
	            floatingLabelFixed: true,
	            placeholder: "n/a",
	            onChange: function onChange(e) {
	              return _this4.setState({ enteredNote: e.target.value });
	            }
	          })
	        ),
	        !hasFetchedForFirstTime && !currentShift ? _react2.default.createElement(
	          "span",
	          { style: { color: "rgb(33,33,33)" } },
	          "Loading shift..."
	        ) : currentShift ? _react2.default.createElement(
	          "span",
	          null,
	          _react2.default.createElement(
	            "strong",
	            null,
	            "Shift #",
	            currentShift.short_id,
	            " opened",
	            " ",
	            (0, _moment2.default)(currentShift.started_at).format("LT")
	          ),
	          " ",
	          "\xB7",
	          " ",
	          _react2.default.createElement(
	            _linkLike2.default,
	            { onTouchTap: this.openModal },
	            "Close shift"
	          )
	        ) : _react2.default.createElement(
	          "span",
	          null,
	          _react2.default.createElement(
	            "strong",
	            null,
	            "No current shift"
	          ),
	          " \xB7",
	          " ",
	          _react2.default.createElement(
	            _linkLike2.default,
	            { style: { color: "#fff" }, onTouchTap: this.openModal },
	            "Open new shift"
	          )
	        )
	      );
	    }
	  }], [{
	    key: "getStores",
	    value: function getStores() {
	      return [_ShiftStore2.default];
	    }
	  }, {
	    key: "getPropsFromStores",
	    value: function getPropsFromStores() {
	      var state = _ShiftStore2.default.getState();
	      return state;
	    }
	  }]);
	
	  return ShiftTracking;
	}(_react2.default.Component);
	
	ShiftTracking.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	exports.default = (0, _connectToStores2.default)(ShiftTracking);
	module.exports = exports["default"];

/***/ }),
/* 2664 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _materialUi = __webpack_require__(576);
	
	var _moment = __webpack_require__(1021);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _connectToStores = __webpack_require__(1226);
	
	var _connectToStores2 = _interopRequireDefault(_connectToStores);
	
	var _BoxOfficeActions = __webpack_require__(2624);
	
	var _BoxOfficeActions2 = _interopRequireDefault(_BoxOfficeActions);
	
	var _BoxOfficeStore = __webpack_require__(2625);
	
	var _BoxOfficeStore2 = _interopRequireDefault(_BoxOfficeStore);
	
	var _currencyField = __webpack_require__(1747);
	
	var _currencyField2 = _interopRequireDefault(_currencyField);
	
	var _linkLike = __webpack_require__(973);
	
	var _linkLike2 = _interopRequireDefault(_linkLike);
	
	var _base = __webpack_require__(1755);
	
	var _base2 = _interopRequireDefault(_base);
	
	var _inlineNoticeLabel = __webpack_require__(1222);
	
	var _inlineNoticeLabel2 = _interopRequireDefault(_inlineNoticeLabel);
	
	var _util = __webpack_require__(1183);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BASE_STYLE = {
	  marginLeft: 10,
	  display: "inline-block",
	  padding: "5px 10px",
	  borderRadius: 5,
	  background: "#fff",
	  boxShadow: "0px 0px 7px 1px rgba(0,0,0,0.2)"
	};
	
	var DisplayModeControl = function (_React$Component) {
	  _inherits(DisplayModeControl, _React$Component);
	
	  function DisplayModeControl(props) {
	    _classCallCheck(this, DisplayModeControl);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(DisplayModeControl).call(this, props));
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(DisplayModeControl, [{
	    key: "componentWillMount",
	    value: function componentWillMount() {}
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(props) {}
	  }, {
	    key: "render",
	    value: function render() {
	      var displayMode = this.props.displayMode;
	
	
	      return _react2.default.createElement(
	        "div",
	        { style: Object.assign({}, BASE_STYLE) },
	        _react2.default.createElement(
	          "span",
	          null,
	          _react2.default.createElement(
	            "strong",
	            null,
	            displayMode === "pos" ? "POS" : "Web",
	            " mode"
	          ),
	          displayMode === "pos" ? _react2.default.createElement(_inlineNoticeLabel2.default, { label: "BETA", style: { marginLeft: 4 } }) : null,
	          " ",
	          "\xB7",
	          " ",
	          _react2.default.createElement(
	            _linkLike2.default,
	            {
	              onTouchTap: function onTouchTap() {
	                _BoxOfficeActions2.default.setDisplayMode(displayMode === "pos" ? "basic" : "pos");
	              }
	            },
	            "Switch to ",
	            displayMode === "pos" ? "web" : "POS"
	          )
	        )
	      );
	    }
	  }], [{
	    key: "getStores",
	    value: function getStores() {
	      return [_BoxOfficeStore2.default];
	    }
	  }, {
	    key: "getPropsFromStores",
	    value: function getPropsFromStores() {
	      var state = _BoxOfficeStore2.default.getState();
	      return state;
	    }
	  }]);
	
	  return DisplayModeControl;
	}(_react2.default.Component);
	
	DisplayModeControl.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	exports.default = (0, _connectToStores2.default)(DisplayModeControl);
	module.exports = exports["default"];

/***/ }),
/* 2665 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _FlatButton = __webpack_require__(694);
	
	var _FlatButton2 = _interopRequireDefault(_FlatButton);
	
	var _giftDetailsOverlay = __webpack_require__(2666);
	
	var _giftDetailsOverlay2 = _interopRequireDefault(_giftDetailsOverlay);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BoxOfficeGiftDetailsSetup = function (_React$Component) {
	  _inherits(BoxOfficeGiftDetailsSetup, _React$Component);
	
	  function BoxOfficeGiftDetailsSetup(props) {
	    _classCallCheck(this, BoxOfficeGiftDetailsSetup);
	
	    // Initialize state or bind methods here
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(BoxOfficeGiftDetailsSetup).call(this, props));
	
	    _this.state = {
	      editing: null
	    };
	
	    _this.closeEditor = _this.closeEditor.bind(_this);
	    return _this;
	  }
	
	  _createClass(BoxOfficeGiftDetailsSetup, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      // Fetch data or perform other setup tasks here
	    }
	  }, {
	    key: "closeEditor",
	    value: function closeEditor() {
	      this.setState({ editing: null });
	    }
	  }, {
	    key: "updateGiftCard",
	    value: function updateGiftCard(index, updatedData) {
	      var subitems = this.props.orderData.subitems;
	      subitems[index].recipientName = updatedData.recipientName;
	      subitems[index].recipientEmail = updatedData.recipientEmail;
	      subitems[index].giftMessage = updatedData.giftMessage;
	      subitems[index].giftScheduledSend = updatedData.giftScheduledSend;
	      this.props.updateCurrentOrder({ subitems: subitems });
	    }
	  }, {
	    key: "getStyles",
	    value: function getStyles() {
	      return {
	        editGiftCardButton: {
	          border: "1px solid",
	          lineHeight: "33px",
	          marginRight: 7
	        }
	      };
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props;
	      var orderData = _props.orderData;
	      var headerStyle = _props.headerStyle;
	      var editing = this.state.editing;
	
	      var styles = this.getStyles();
	
	      var giftCardIndices = orderData.subitems ? orderData.subitems.map(function (item, index) {
	        return item.gift_card ? index : null;
	      }).filter(function (item) {
	        return item !== null;
	      }) : [];
	
	      if (!giftCardIndices.length) {
	        return null;
	      }
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        editing ? _react2.default.createElement(_giftDetailsOverlay2.default, {
	          orderData: this.props.orderData,
	          giftCardIndex: editing.index,
	          giftCardDetails: editing.item,
	          requestClose: this.closeEditor,
	          onSubmit: function onSubmit(index, data) {
	            _this2.updateGiftCard(index, data);
	            _this2.closeEditor();
	          }
	        }) : null,
	        _react2.default.createElement(
	          "div",
	          { style: headerStyle },
	          "Gift Card Details"
	        ),
	        _react2.default.createElement(
	          "p",
	          null,
	          "Select each new gift card to edit gift card details"
	        ),
	        giftCardIndices.map(function (index) {
	          return _react2.default.createElement(_FlatButton2.default, {
	            key: index,
	            label: "Gift Card " + (index + 1) + " Details",
	            style: styles.editGiftCardButton,
	            onClick: function onClick() {
	              return _this2.setState({
	                editing: { index: index, item: orderData.subitems[index] }
	              });
	            }
	          });
	        })
	      );
	    }
	  }]);
	
	  return BoxOfficeGiftDetailsSetup;
	}(_react2.default.Component);
	
	exports.default = BoxOfficeGiftDetailsSetup;
	module.exports = exports["default"];

/***/ }),
/* 2666 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _base = __webpack_require__(1755);
	
	var _base2 = _interopRequireDefault(_base);
	
	var _materialUi = __webpack_require__(576);
	
	var _datepicker = __webpack_require__(2272);
	
	var _datepicker2 = _interopRequireDefault(_datepicker);
	
	var _moment = __webpack_require__(1021);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var GiftDetailsOverlay = function (_React$Component) {
	  _inherits(GiftDetailsOverlay, _React$Component);
	
	  function GiftDetailsOverlay(props) {
	    _classCallCheck(this, GiftDetailsOverlay);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(GiftDetailsOverlay).call(this, props));
	
	    _this.state = {
	      dirty: false,
	      updatedData: {},
	      showScheduledSendInput: false
	    };
	
	    _this.cancel = _this.cancel.bind(_this);
	    _this.submit = _this.submit.bind(_this);
	    _this._onUpdateData = _this._onUpdateData.bind(_this);
	    _this._onUpdateScheduleDate = _this._onUpdateScheduleDate.bind(_this);
	    _this._toggleScheduledSendInput = _this._toggleScheduledSendInput.bind(_this);
	    return _this;
	  }
	
	  _createClass(GiftDetailsOverlay, [{
	    key: "componentWillMount",
	    value: function componentWillMount() {
	      var giftCard = this.props.orderData.subitems[this.props.giftCardIndex];
	
	      var today = (0, _moment2.default)();
	      var giftScheduledSend = (0, _moment2.default)(giftCard.giftScheduledSend);
	
	      var isGiftScheduledSendToday = today.isSame(giftScheduledSend, "day");
	
	      this.setState({
	        updatedData: {
	          recipientName: giftCard.recipientName,
	          recipientEmail: giftCard.recipientEmail,
	          giftMessage: giftCard.giftMessage,
	          giftScheduledSend: isGiftScheduledSendToday ? undefined : giftScheduledSend.format("YYYY-MM-DD")
	        },
	        showScheduledSendInput: !isGiftScheduledSendToday
	      });
	    }
	  }, {
	    key: "cancel",
	    value: function cancel() {
	      this.props.requestClose();
	    }
	  }, {
	    key: "submit",
	    value: function submit() {
	      this.props.onSubmit(this.props.giftCardIndex, this.state.updatedData);
	    }
	  }, {
	    key: "_onUpdateData",
	    value: function _onUpdateData(event) {
	      this.setState({
	        dirty: true,
	        updatedData: _extends({}, this.state.updatedData, _defineProperty({}, event.target.name, event.target.value))
	      });
	    }
	  }, {
	    key: "_onUpdateScheduleDate",
	    value: function _onUpdateScheduleDate(date) {
	      this._onUpdateData({ target: { name: "giftScheduledSend", value: date } });
	    }
	  }, {
	    key: "_toggleScheduledSendInput",
	    value: function _toggleScheduledSendInput() {
	      this.setState({
	        showScheduledSendInput: !this.state.showScheduledSendInput
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement(
	        _base2.default,
	        {
	          title: "Gift Card " + (this.props.giftCardIndex + 1) + " Details",
	          useMuiDefaultStyle: true,
	          openImmediately: true,
	          actions: [_react2.default.createElement(_materialUi.FlatButton, { label: "Cancel", onTouchTap: this.cancel }), _react2.default.createElement(_materialUi.FlatButton, {
	            disabled: !this.state.dirty,
	            primary: true,
	            label: "Submit",
	            onTouchTap: this.submit
	          })],
	          open: true,
	          modal: true,
	          onRequestClose: this.cancel
	        },
	        _react2.default.createElement(
	          "div",
	          {
	            style: {
	              display: "flex",
	              flexDirection: "column"
	            }
	          },
	          _react2.default.createElement(_materialUi.TextField, {
	            floatingLabelText: "Recipient Name",
	            value: this.state.updatedData.recipientName,
	            name: "recipientName",
	            onChange: this._onUpdateData
	          }),
	          _react2.default.createElement(_materialUi.TextField, {
	            floatingLabelText: "Recipient Email",
	            value: this.state.updatedData.recipientEmail,
	            name: "recipientEmail",
	            onChange: this._onUpdateData
	          }),
	          _react2.default.createElement(_materialUi.TextField, {
	            floatingLabelText: "Gift Message",
	            value: this.state.updatedData.giftMessage,
	            name: "giftMessage",
	            onChange: this._onUpdateData
	          }),
	          _react2.default.createElement(_materialUi.Checkbox, {
	            label: "Schedule Gift Card Notification to Different Date",
	            checked: this.state.showScheduledSendInput,
	            onCheck: this._toggleScheduledSendInput,
	            style: { marginTop: 36 }
	          }),
	          this.state.showScheduledSendInput && _react2.default.createElement(_datepicker2.default, {
	            label: "Scheduled Send Date",
	            value: this.state.updatedData.giftScheduledSend,
	            minDate: new Date(),
	            onChange: this._onUpdateScheduleDate,
	            name: "giftScheduledSend"
	          })
	        )
	      );
	    }
	  }]);
	
	  return GiftDetailsOverlay;
	}(_react2.default.Component);
	
	exports.default = GiftDetailsOverlay;
	module.exports = exports["default"];

/***/ }),
/* 2667 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _values = __webpack_require__(1214);
	
	var _values2 = _interopRequireDefault(_values);
	
	var _pickBy = __webpack_require__(1163);
	
	var _pickBy2 = _interopRequireDefault(_pickBy);
	
	var _moment = __webpack_require__(1021);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _materialUi = __webpack_require__(576);
	
	var _reactable = __webpack_require__(1688);
	
	var _filmTable = __webpack_require__(1763);
	
	var _filmTable2 = _interopRequireDefault(_filmTable);
	
	var _cloneFilmWidget = __webpack_require__(2668);
	
	var _cloneFilmWidget2 = _interopRequireDefault(_cloneFilmWidget);
	
	var _connectToStores = __webpack_require__(1226);
	
	var _connectToStores2 = _interopRequireDefault(_connectToStores);
	
	var _FilmActions = __webpack_require__(1764);
	
	var _FilmActions2 = _interopRequireDefault(_FilmActions);
	
	var _FilmStore = __webpack_require__(1765);
	
	var _FilmStore2 = _interopRequireDefault(_FilmStore);
	
	var _FilmUtil = __webpack_require__(1766);
	
	var _FilmUtil2 = _interopRequireDefault(_FilmUtil);
	
	var _EventActions = __webpack_require__(2031);
	
	var _EventActions2 = _interopRequireDefault(_EventActions);
	
	var _EventStore = __webpack_require__(2032);
	
	var _EventStore2 = _interopRequireDefault(_EventStore);
	
	var _TagActions = __webpack_require__(2038);
	
	var _TagActions2 = _interopRequireDefault(_TagActions);
	
	var _config = __webpack_require__(1173);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _UserStore = __webpack_require__(974);
	
	var _UserStore2 = _interopRequireDefault(_UserStore);
	
	var _workingIndicator = __webpack_require__(1664);
	
	var _workingIndicator2 = _interopRequireDefault(_workingIndicator);
	
	var _importFilmsButton = __webpack_require__(2669);
	
	var _importFilmsButton2 = _interopRequireDefault(_importFilmsButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Films = function (_React$Component) {
	  _inherits(Films, _React$Component);
	
	  function Films(props) {
	    _classCallCheck(this, Films);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(Films).call(this, props));
	
	    _this.state = {
	      showCloneFilmWidget: false,
	
	      activeFilms: [],
	      inactiveFilms: []
	    };
	
	    _this.onBulkImportFromFile = _this.onBulkImportFromFile.bind(_this);
	    _this.onShowCloneWidget = _this.onShowCloneWidget.bind(_this);
	    _this.onCloseCloneWidget = _this.onCloseCloneWidget.bind(_this);
	    _this.onCloneFilms = _this.onCloneFilms.bind(_this);
	    return _this;
	  }
	
	  _createClass(Films, [{
	    key: "getStyles",
	    value: function getStyles() {
	      return {};
	    }
	  }, {
	    key: "downloadCsv",
	    value: function downloadCsv() {
	      window.open(_config2.default.endpoint + "event_buckets/" + this.props.params.eventBucketId + "/films.csv?" + _UserStore2.default.makeApiKeyQueryString(), "_blank");
	    }
	  }, {
	    key: "prepareFilms",
	    value: function prepareFilms(props) {
	      var films = props.films;
	      var events = props.events;
	
	      if (!films || !events) {
	        return;
	      }
	
	      // Separate active films from inactive films based on inclusion in active events
	      var activeFilms = [],
	          inactiveFilms = [];
	
	      // Mark active events
	      var now = (0, _moment2.default)();
	      var activeEvents = events.map(function (currentEvent) {
	        var endTime = (0, _moment2.default)(currentEvent.end_time);
	        if (endTime.isAfter(now) || !currentEvent.is_dated || currentEvent.end_time === undefined) {
	          return true;
	        }
	        return false;
	      });
	
	      // Iterate the films
	      for (var f = 0; f < films.length; f++) {
	        var currentFilm = films[f];
	        var filmIsActive = false;
	        var filmIsScheduled = false;
	
	        // Iterate all events (active and inactive)
	        for (var e = 0; e < events.length; e++) {
	          var currentEvent = events[e];
	          var activeEvent = activeEvents[e]; // boolean
	
	          // Iterate all films in this event.  If the film is in any
	          // event, it is scheduled.  It it is in a futureEvent, it is active
	          for (var ef = 0; ef < currentEvent.films.length; ef++) {
	            var filmInEvent = currentEvent.films[ef];
	            if (currentFilm.id === filmInEvent.id) {
	              filmIsScheduled = true;
	              if (activeEvent) {
	                filmIsActive = true;
	              }
	              break;
	            }
	          }
	
	          // if the film is active in this event, we can break, no need
	          // to keep iterating for this film. If it is scheduled but not
	          // active, we need to keep checking to make sure it is not
	          // active in another event
	          if (filmIsActive) {
	            break;
	          }
	        }
	
	        // separate into active/inactive arrays
	        if (filmIsActive || !filmIsScheduled) {
	          activeFilms.push(currentFilm);
	        } else {
	          inactiveFilms.push(currentFilm);
	        }
	      }
	
	      this.setState({
	        activeFilms: activeFilms,
	        inactiveFilms: inactiveFilms
	      });
	    }
	  }, {
	    key: "componentWillMount",
	    value: function componentWillMount() {
	      _EventActions2.default.fetchAllForBucket(this.props.params.eventBucketId, false);
	      _FilmActions2.default.fetchAllForEventBucket(this.props.params.eventBucketId);
	      _FilmActions2.default.fetchAllForUser();
	    }
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.prepareFilms(this.props);
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(newProps) {
	      var _normalize = function _normalize(arr) {
	        return arr.map(function (f) {
	          return f.id;
	        }).sort().join(",");
	      };
	
	      if (_normalize(newProps.films) !== _normalize(this.props.films) || _normalize(newProps.events) !== _normalize(this.props.events)) {
	        this.prepareFilms(newProps);
	      }
	    }
	  }, {
	    key: "onBulkImportFromFile",
	    value: function onBulkImportFromFile() {
	      this.context.router.push("/event_buckets/" + this.props.params.eventBucketId + "/bulk_import_films");
	    }
	  }, {
	    key: "onShowCloneWidget",
	    value: function onShowCloneWidget() {
	      this.setState({ showCloneFilmWidget: true });
	    }
	  }, {
	    key: "onCloseCloneWidget",
	    value: function onCloseCloneWidget() {
	      this.setState({ showCloneFilmWidget: false });
	    }
	  }, {
	    key: "onCloneFilms",
	    value: function onCloneFilms(cloneList) {
	      var _this2 = this;
	
	      var clone = function () {
	        var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
	          var filmList, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _loop, _iterator, _step;
	
	          return regeneratorRuntime.wrap(function _callee$(_context2) {
	            while (1) {
	              switch (_context2.prev = _context2.next) {
	                case 0:
	                  filmList = _this2.props.getAllUserFilms();
	                  _iteratorNormalCompletion = true;
	                  _didIteratorError = false;
	                  _iteratorError = undefined;
	                  _context2.prev = 4;
	                  _loop = regeneratorRuntime.mark(function _loop() {
	                    var e, thisFilm, newFilm, createdFilm;
	                    return regeneratorRuntime.wrap(function _loop$(_context) {
	                      while (1) {
	                        switch (_context.prev = _context.next) {
	                          case 0:
	                            e = _step.value;
	
	                            // Clone one-by-one to prevent clone_tags accidentally making multiple copies
	                            thisFilm = filmList.find(function (f) {
	                              return f.id === e;
	                            });
	
	                            if (!thisFilm) {
	                              _context.next = 8;
	                              break;
	                            }
	
	                            newFilm = {
	                              type: thisFilm.type,
	                              name: thisFilm.name,
	                              short_description: thisFilm.short_description,
	                              description: thisFilm.description,
	                              trailer_url: thisFilm.trailer_url,
	                              still_image_external: thisFilm.still_image,
	                              cover_image_external: thisFilm.cover_image,
	                              poster_image_external: thisFilm.poster_image,
	                              clone_tags: true,
	                              tags: thisFilm.tags,
	                              details: thisFilm.details,
	                              credits: thisFilm.credits,
	                              visibility: thisFilm.visibility,
	                              unballoted: thisFilm.unballoted,
	                              virtual_content: thisFilm.virtual_content ? thisFilm.virtual_content.id : null,
	                              event_bucket: _this2.props.params.eventBucketId
	                            };
	                            _context.next = 6;
	                            return _FilmUtil2.default.create(_UserStore2.default.getState().apiKey, newFilm);
	
	                          case 6:
	                            createdFilm = _context.sent;
	
	                            _FilmActions2.default.updateFilm(createdFilm.id, createdFilm);
	
	                          case 8:
	                          case "end":
	                            return _context.stop();
	                        }
	                      }
	                    }, _loop, _this2);
	                  });
	                  _iterator = cloneList[Symbol.iterator]();
	
	                case 7:
	                  if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
	                    _context2.next = 12;
	                    break;
	                  }
	
	                  return _context2.delegateYield(_loop(), "t0", 9);
	
	                case 9:
	                  _iteratorNormalCompletion = true;
	                  _context2.next = 7;
	                  break;
	
	                case 12:
	                  _context2.next = 18;
	                  break;
	
	                case 14:
	                  _context2.prev = 14;
	                  _context2.t1 = _context2["catch"](4);
	                  _didIteratorError = true;
	                  _iteratorError = _context2.t1;
	
	                case 18:
	                  _context2.prev = 18;
	                  _context2.prev = 19;
	
	                  if (!_iteratorNormalCompletion && _iterator.return) {
	                    _iterator.return();
	                  }
	
	                case 21:
	                  _context2.prev = 21;
	
	                  if (!_didIteratorError) {
	                    _context2.next = 24;
	                    break;
	                  }
	
	                  throw _iteratorError;
	
	                case 24:
	                  return _context2.finish(21);
	
	                case 25:
	                  return _context2.finish(18);
	
	                case 26:
	                  _TagActions2.default.fetchAllForBucket(_this2.props.params.eventBucketId);
	                  _FilmActions2.default.fetchAllForEventBucket(_this2.props.params.eventBucketId);
	                  _this2.setState({ showCloneFilmWidget: false });
	
	                case 29:
	                case "end":
	                  return _context2.stop();
	              }
	            }
	          }, _callee, _this2, [[4, 14, 18, 26], [19,, 21, 25]]);
	        }));
	
	        return function clone() {
	          return _ref.apply(this, arguments);
	        };
	      }();
	      clone();
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this3 = this;
	
	      var styles = this.getStyles();
	      var bucket = this.props.params.eventBucketId;
	      var _props = this.props;
	      var films = _props.films;
	      var events = _props.events;
	      var allFilms = this.props.getAllUserFilms();
	
	      if (events.length === 0 && _EventStore2.default.getState().isFetching) {
	        return _react2.default.createElement(_workingIndicator2.default, { fullPage: true });
	      }
	      if (films.length === 0 && _FilmStore2.default.getState().isFetching) {
	        return _react2.default.createElement(_workingIndicator2.default, { fullPage: true });
	      }
	
	      var _state = this.state;
	      var activeFilms = _state.activeFilms;
	      var inactiveFilms = _state.inactiveFilms;
	
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          "h1",
	          { className: "page-title" },
	          "Films"
	        ),
	        _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement(_filmTable2.default, {
	            eventBucket: bucket,
	            films: activeFilms,
	            createButton: _react2.default.createElement(
	              "span",
	              null,
	              _UserStore2.default.hasPermission("edit_film") ? _react2.default.createElement(_materialUi.RaisedButton, {
	                label: "Create new film",
	                primary: true,
	                onTouchTap: function onTouchTap() {
	                  return _this3.context.router.push("/event_buckets/" + _this3.props.params.eventBucketId + "/films/new");
	                }
	              }) : null,
	              _UserStore2.default.hasPermission("bulk_import_films") ? _react2.default.createElement(_importFilmsButton2.default, {
	                style: { marginLeft: 7, verticalAlign: "top" },
	                label: "Import films...",
	                eventBucketId: bucket,
	                onBulkImportClick: this.onBulkImportFromFile,
	                onCloneFilmsClick: this.onShowCloneWidget
	              }) : null,
	              _react2.default.createElement(_materialUi.RaisedButton, {
	                style: {
	                  marginLeft: _UserStore2.default.hasPermission("view_film_list") ? 7 : 0
	                },
	                onTouchTap: function onTouchTap() {
	                  return _this3.downloadCsv();
	                },
	                label: "Download all (.csv)"
	              })
	            )
	          }),
	          this.state.showCloneFilmWidget ? _react2.default.createElement(_cloneFilmWidget2.default, {
	            films: allFilms,
	            currentBucket: bucket,
	            onClose: this.onCloseCloneWidget,
	            onCloneFilms: this.onCloneFilms
	          }) : null
	        ),
	        inactiveFilms.length ? _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement(
	            "h2",
	            { style: { textAlign: "center", marginTop: "1.5em" } },
	            "Inactive films"
	          ),
	          _react2.default.createElement(_filmTable2.default, { eventBucket: bucket, films: inactiveFilms })
	        ) : null
	      );
	    }
	  }], [{
	    key: "getStores",
	    value: function getStores() {
	      return [_FilmStore2.default, _EventStore2.default];
	    }
	  }, {
	    key: "getPropsFromStores",
	    value: function getPropsFromStores(props) {
	      var bucket = props.params.eventBucketId,
	          bucketFilms = _FilmStore2.default.getFilmsForEventBucket(bucket),
	          bucketEvents = _EventStore2.default.getEventsForEventBucket(bucket);
	
	      var films = (0, _values2.default)((0, _pickBy2.default)(bucketFilms, function (e) {
	        return e.event_bucket === bucket && e.type !== "livestream";
	      }));
	
	      return {
	        films: films,
	        events: bucketEvents,
	        getAllUserFilms: _FilmStore2.default.getAllUserFilms
	      };
	    }
	  }, {
	    key: "contextTypes",
	    get: function get() {
	      return {
	        router: _react2.default.PropTypes.object
	      };
	    }
	  }]);
	
	  return Films;
	}(_react2.default.Component);
	
	exports.default = (0, _connectToStores2.default)(Films);
	module.exports = exports["default"];

/***/ }),
/* 2668 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _values = __webpack_require__(1214);
	
	var _values2 = _interopRequireDefault(_values);
	
	var _pickBy = __webpack_require__(1163);
	
	var _pickBy2 = _interopRequireDefault(_pickBy);
	
	var _materialUi = __webpack_require__(576);
	
	var _label = __webpack_require__(1682);
	
	var _label2 = _interopRequireDefault(_label);
	
	var _reactSelect = __webpack_require__(953);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	var _base = __webpack_require__(1755);
	
	var _base2 = _interopRequireDefault(_base);
	
	var _connectToStores = __webpack_require__(1226);
	
	var _connectToStores2 = _interopRequireDefault(_connectToStores);
	
	var _EventBucketActions = __webpack_require__(1218);
	
	var _EventBucketActions2 = _interopRequireDefault(_EventBucketActions);
	
	var _EventBucketStore = __webpack_require__(1593);
	
	var _EventBucketStore2 = _interopRequireDefault(_EventBucketStore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CloneFilmWidget = function (_React$Component) {
	  _inherits(CloneFilmWidget, _React$Component);
	
	  function CloneFilmWidget(props) {
	    _classCallCheck(this, CloneFilmWidget);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(CloneFilmWidget).call(this, props));
	
	    _this.state = {
	      selectedBucket: null,
	      selectAll: false,
	      cloneList: [],
	      isCloning: false
	    };
	
	    _this.handleSelectAll = _this.handleSelectAll.bind(_this);
	    return _this;
	  }
	
	  _createClass(CloneFilmWidget, [{
	    key: "handleSelectAll",
	    value: function handleSelectAll() {
	      var _this2 = this;
	
	      var currentList = [];
	      var films = (0, _values2.default)((0, _pickBy2.default)(this.props.films, function (e) {
	        return e.event_bucket === _this2.state.selectedBucket.value && e.type !== "livestream" && e.name && e.name !== "";
	      }));
	
	      films.sort(function (a, b) {
	        var nameA = a.name.toUpperCase();
	        var nameB = b.name.toUpperCase();
	        return nameA < nameB ? -1 : nameA > nameB ? 1 : 0;
	      });
	
	      if (this.state.selectAll) {
	        films.map(function (f) {
	          currentList.push({ value: f.id, label: f.name });
	        });
	      }
	
	      this.setState({ cloneList: currentList });
	    }
	  }, {
	    key: "getStyles",
	    value: function getStyles() {
	      return {
	        cloneFilmWidget: {
	          backgroundColor: "f2f2f2",
	          border: "1px solid black",
	          padding: 20,
	          marginTop: 25,
	          height: "100%"
	        },
	        fieldLabel: {
	          color: "#737373",
	          fontWeight: "bold",
	          marginBottom: 2
	        }
	      };
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this3 = this;
	
	      var styles = this.getStyles(),
	          bucket = this.state.selectedBucket ? this.state.selectedBucket.value : null,
	          bucketOptions = this.props.getEventBuckets().map(function (item) {
	        return { value: item.id, label: item.name };
	      });
	
	      //remove current event bucket from options list
	      bucketOptions = bucketOptions.reduce(function (bucketList, bucket) {
	        if (bucket.value !== _this3.props.currentBucket) {
	          bucketList.push(bucket);
	        }
	        return bucketList;
	      }, []);
	
	      var films = (0, _values2.default)((0, _pickBy2.default)(this.props.films, function (e) {
	        return e.event_bucket === bucket && e.type !== "livestream" && e.name && e.name !== "";
	      }));
	
	      var selectOptions = films.map(function (item) {
	        return { value: item.id, label: item.name };
	      });
	
	      selectOptions.sort(function (a, b) {
	        var nameA = a.label.toUpperCase();
	        var nameB = b.label.toUpperCase();
	        return nameA < nameB ? -1 : nameA > nameB ? 1 : 0;
	      });
	
	      return _react2.default.createElement(
	        _base2.default,
	        {
	          title: "Clone films from event bucket",
	          hideTitleAndFooterBorders: true,
	          useMuiDefaultStyle: true,
	          openImmediately: true,
	          actions: [_react2.default.createElement(_materialUi.FlatButton, { label: "Cancel", onClick: this.props.onClose }), _react2.default.createElement(_materialUi.FlatButton, {
	            onClick: function onClick(e) {
	              var cloneListIds = _this3.state.cloneList.map(function (item) {
	                return item.value;
	              });
	              _this3.setState({ isCloning: true });
	              _this3.props.onCloneFilms(cloneListIds);
	            },
	            label: this.state.isCloning ? "Cloning films..." : "Clone films",
	            disabled: this.state.isCloning || this.state.selectedBucket === null,
	            primary: true
	          })],
	          modal: true,
	          open: true,
	          onRequestClose: this.props.onClose
	        },
	        _react2.default.createElement(
	          _label2.default,
	          null,
	          "Event bucket"
	        ),
	        _react2.default.createElement(
	          "div",
	          { style: { maxWidth: "400px" } },
	          _react2.default.createElement(_reactSelect2.default, {
	            clearable: false,
	            autosize: false,
	            multi: false,
	            placeholder: "No event bucket selected",
	            value: this.state.selectedBucket ? this.state.selectedBucket.value : null,
	            options: bucketOptions,
	            onChange: function onChange(bucket) {
	              _this3.setState({ selectedBucket: bucket, cloneList: [] });
	            }
	          })
	        ),
	        this.state.selectedBucket ? _react2.default.createElement(
	          "div",
	          { style: { clear: "both", paddingTop: 10 } },
	          _react2.default.createElement(
	            _label2.default,
	            null,
	            "Choose films to clone"
	          ),
	          _react2.default.createElement(_reactSelect2.default, {
	            ref: function ref(r) {
	              _this3.select = r;
	            },
	            multi: true,
	            closeOnSelect: false,
	            options: selectOptions,
	            value: this.state.cloneList,
	            onChange: function onChange(value) {
	              _this3.setState({ cloneList: value });
	
	              // Keep menu open
	              setTimeout(function () {
	                if (_this3.select) {
	                  _this3.select.setState({ isOpen: true });
	                }
	              }, 20);
	            }
	          }),
	          _react2.default.createElement(_materialUi.Checkbox, {
	            label: "Select all films from this event bucket",
	            value: this.state.selectAll,
	            onCheck: function onCheck(e) {
	              _this3.setState({ selectAll: e.target.checked }, _this3.handleSelectAll);
	            },
	            style: {
	              width: "300px",
	              paddingTop: 10,
	              fontSize: "12px"
	            }
	          })
	        ) : null
	      );
	    }
	  }], [{
	    key: "getStores",
	    value: function getStores() {
	      return [_EventBucketStore2.default];
	    }
	  }, {
	    key: "getPropsFromStores",
	    value: function getPropsFromStores() {
	      return {
	        getEventBuckets: _EventBucketStore2.default.getEventBuckets
	      };
	    }
	  }]);
	
	  return CloneFilmWidget;
	}(_react2.default.Component);
	
	exports.default = (0, _connectToStores2.default)(CloneFilmWidget);
	module.exports = exports["default"];

/***/ }),
/* 2669 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _materialUi = __webpack_require__(576);
	
	var _qs = __webpack_require__(1206);
	
	var _qs2 = _interopRequireDefault(_qs);
	
	var _UserStore = __webpack_require__(974);
	
	var _UserStore2 = _interopRequireDefault(_UserStore);
	
	var _config = __webpack_require__(1173);
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ImportFilmsButton = function (_React$Component) {
	  _inherits(ImportFilmsButton, _React$Component);
	
	  function ImportFilmsButton(props) {
	    _classCallCheck(this, ImportFilmsButton);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(ImportFilmsButton).call(this, props));
	
	    _this.state = {
	      open: false,
	      anchorEl: null
	    };
	
	    _this._onClick = _this._onClick.bind(_this);
	    _this._onClose = _this._onClose.bind(_this);
	    return _this;
	  }
	
	  _createClass(ImportFilmsButton, [{
	    key: "_onClick",
	    value: function _onClick(e) {
	      e.preventDefault();
	
	      this.setState({
	        open: true,
	        anchorEl: e.currentTarget
	      });
	    }
	  }, {
	    key: "_onClose",
	    value: function _onClose() {
	      this.setState({ open: false });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props;
	      var style = _props.style;
	      var label = _props.label;
	
	
	      return _react2.default.createElement(
	        "div",
	        { style: Object.assign({ display: "inline-block" }, style) },
	        _react2.default.createElement(_materialUi.RaisedButton, { label: label, onTouchTap: this._onClick }),
	        _react2.default.createElement(
	          _materialUi.Popover,
	          {
	            open: this.state.open,
	            anchorEl: this.state.anchorEl,
	            onRequestClose: this._onClose
	          },
	          _react2.default.createElement(
	            _materialUi.Menu,
	            { desktop: true },
	            _react2.default.createElement(_materialUi.MenuItem, {
	              primaryText: "Bulk import using a spreadsheet",
	              onTouchTap: function onTouchTap() {
	                _this2.props.onBulkImportClick();
	              }
	            }),
	            _react2.default.createElement(_materialUi.MenuItem, {
	              primaryText: "Clone from another event bucket",
	              onTouchTap: function onTouchTap() {
	                _this2._onClose();
	                _this2.props.onCloneFilmsClick();
	              }
	            }),
	            (this.props.additionalOptions || []).map(function (option) {
	              return _react2.default.createElement(_materialUi.MenuItem, {
	                key: option.label,
	                primaryText: option.label,
	                href: option.href,
	                target: "_blank"
	              });
	            })
	          )
	        )
	      );
	    }
	  }]);
	
	  return ImportFilmsButton;
	}(_react2.default.Component);
	
	exports.default = ImportFilmsButton;
	module.exports = exports["default"];

/***/ }),
/* 2670 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(486);
	
	var _materialUi = __webpack_require__(576);
	
	var _util = __webpack_require__(1183);
	
	var _superagent = __webpack_require__(1168);
	
	var _superagent2 = _interopRequireDefault(_superagent);
	
	var _debounce = __webpack_require__(642);
	
	var _debounce2 = _interopRequireDefault(_debounce);
	
	var _backButton = __webpack_require__(1872);
	
	var _backButton2 = _interopRequireDefault(_backButton);
	
	var _workingIndicator = __webpack_require__(1664);
	
	var _workingIndicator2 = _interopRequireDefault(_workingIndicator);
	
	var _droppableImage = __webpack_require__(2671);
	
	var _droppableImage2 = _interopRequireDefault(_droppableImage);
	
	var _subfieldsField = __webpack_require__(2673);
	
	var _subfieldsField2 = _interopRequireDefault(_subfieldsField);
	
	var _injectedSelect = __webpack_require__(1874);
	
	var _injectedSelect2 = _interopRequireDefault(_injectedSelect);
	
	var _infoNotice = __webpack_require__(1599);
	
	var _infoNotice2 = _interopRequireDefault(_infoNotice);
	
	var _label = __webpack_require__(1682);
	
	var _label2 = _interopRequireDefault(_label);
	
	var _linkLike = __webpack_require__(973);
	
	var _linkLike2 = _interopRequireDefault(_linkLike);
	
	var _filmTable = __webpack_require__(1763);
	
	var _connectToStores = __webpack_require__(1226);
	
	var _connectToStores2 = _interopRequireDefault(_connectToStores);
	
	var _FilmActions = __webpack_require__(1764);
	
	var _FilmActions2 = _interopRequireDefault(_FilmActions);
	
	var _FilmStore = __webpack_require__(1765);
	
	var _FilmStore2 = _interopRequireDefault(_FilmStore);
	
	var _EventBucketStore = __webpack_require__(1593);
	
	var _EventBucketStore2 = _interopRequireDefault(_EventBucketStore);
	
	var _UserStore = __webpack_require__(974);
	
	var _UserStore2 = _interopRequireDefault(_UserStore);
	
	var _basicHtmlField = __webpack_require__(2674);
	
	var _basicHtmlField2 = _interopRequireDefault(_basicHtmlField);
	
	var _eventivalBanner = __webpack_require__(2675);
	
	var _eventivalBanner2 = _interopRequireDefault(_eventivalBanner);
	
	var _inviteContentCreator = __webpack_require__(2676);
	
	var _inviteContentCreator2 = _interopRequireDefault(_inviteContentCreator);
	
	var _addExternalVirtualContent = __webpack_require__(2677);
	
	var _addExternalVirtualContent2 = _interopRequireDefault(_addExternalVirtualContent);
	
	var _virtualContentPreview = __webpack_require__(1781);
	
	var _virtualContentPreview2 = _interopRequireDefault(_virtualContentPreview);
	
	var _inlineNoticeLabel = __webpack_require__(1222);
	
	var _inlineNoticeLabel2 = _interopRequireDefault(_inlineNoticeLabel);
	
	var _AutoComplete = __webpack_require__(619);
	
	var _AutoComplete2 = _interopRequireDefault(_AutoComplete);
	
	var _MenuItem = __webpack_require__(637);
	
	var _MenuItem2 = _interopRequireDefault(_MenuItem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// SYNC WITH FRONTEND/COMPONENTS/FILM
	var DETAILS = {
	  year: "Year",
	  runtime: "Runtime (min)",
	  language: "Language",
	  country: "Country",
	  premiere: "Premiere",
	  rating: "Rating",
	  genre: "Genre",
	  subtitle_language: "Subtitle Language",
	  content_warning: "Content Warning",
	  sponsor: "Sponsor",
	  awards: "Awards",
	  note: "Note",
	  facebook: "Facebook URL",
	  twitter: "Twitter URL",
	  instagram: "Instagram URL"
	};
	
	var CREDITS = {
	  director: "Director",
	  screenwriter: "Screenwriter",
	  producer: "Producer",
	  executive_producer: "Executive Producer",
	  co_producer: "Co-Producer",
	  filmmaker: "Filmmaker",
	  cast: "Cast",
	  cinematographer: "Cinematographer",
	  editor: "Editor",
	  animator: "Animator",
	  production_design: "Production Design",
	  composer: "Composer",
	  sound_design: "Sound Design",
	  music: "Music"
	};
	// END SYNC
	
	var THEMOVIEDB_BASE_URL = "https://api.themoviedb.org/3";
	
	var FilmEditor = function (_React$Component) {
	  _inherits(FilmEditor, _React$Component);
	
	  function FilmEditor(props) {
	    _classCallCheck(this, FilmEditor);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(FilmEditor).call(this, props));
	
	    _this.state = {
	      hasFocusedTitle: false,
	      isFetchingFilm: false,
	      isInvitingContentCreator: false,
	      inviteMode: "classic", // 'classic' | 'title'
	      isAddingExternalVirtualContent: false,
	      dirty: false,
	      film: {},
	      showAutocomplete: false,
	      searchText: "",
	      autocompleteFilms: [],
	      imageUrl: "https://image.tmdb.org/t/p/",
	      imageSize: "original"
	      //isFilmPreviewer:
	      //  UserStore.hasPermission("view_film") &&
	      //  !UserStore.hasPermission("edit_film")
	    };
	
	    _this.save = _this.save.bind(_this);
	    _this.delete = _this.delete.bind(_this);
	    _this.onChangeValue = _this.onChangeValue.bind(_this);
	    _this._makeLiveLink = _this._makeLiveLink.bind(_this);
	    _this.onSearchTextChange = (0, _debounce2.default)(_this.onSearchTextChange.bind(_this), 250);
	    _this.onFilmTitleSelect = (0, _debounce2.default)(_this.onFilmTitleSelect.bind(_this), 250);
	    return _this;
	  }
	
	  _createClass(FilmEditor, [{
	    key: "componentWillMount",
	    value: function componentWillMount() {
	      var configRequest = _superagent2.default["get"](THEMOVIEDB_BASE_URL + "/configuration?api_key=" + ("97a58966ffe8b89188f56a463c9ddaff"));
	
	      configRequest.end(function (err, response) {
	        if (err) {
	          console.log(err.message);
	        } else {
	          this.setState({
	            imageUrl: response.body.images.secure_base_url,
	            imageSize: response.body.images.poster_sizes[0]
	          });
	        }
	      }.bind(this));
	
	      configRequest.send();
	    }
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      this.context.router.setRouteLeaveHook(this.props.route, function () {
	        if (_this2.state.dirty) {
	          return "Are you sure you wish to leave the film editor? Your changes will not be saved.";
	        }
	      });
	
	      _FilmActions2.default.fetchOne(this.props.params.filmId);
	      this.setState({ isFetchingFilm: true }, function () {
	        _this2.componentWillReceiveProps(_this2.props);
	      });
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(newProps) {
	      var _this3 = this;
	
	      var film = newProps.getFilmById(newProps.params.filmId);
	
	      if (!this.state.isFetchingFilm && !film) {
	        _FilmActions2.default.fetchOne(newProps.params.filmId);
	        this.setState({ isFetchingFilm: true });
	      } else if (film) {
	        this.setState({ isFetchingFilm: false, film: film });
	        if (!this.state.hasFocusedTitle) {
	          this.setState({ hasFocusedTitle: true });
	          if (!film.name) {
	            setTimeout(function () {
	              return _this3.title && _this3.title.focus();
	            }, 100);
	          }
	        }
	      }
	
	      if (film && (!this.state.values || this.state.film.id !== newProps.params.filmId || this.state.isSaving && film.updated_at !== this.state.lastUpdatedAt)) {
	        this.setState({
	          dirty: false,
	          isSaving: false,
	          values: film ? {
	            name: film.name,
	            details: film.details,
	            credits: film.credits,
	            expanded_credits: film.expanded_credits && film.expanded_credits.length && film.expanded_credits.length > 0 ? film.expanded_credits : null,
	            tags: film.tags.map(function (t) {
	              return t.id;
	            }),
	            trailer_url: film.trailer_url,
	            description: film.description,
	            short_description: film.short_description,
	            visibility: film.visibility,
	            unballoted: film.unballoted,
	            comscore_include: film.comscore_include,
	            virtual_content_disclaimer: film.virtual_content_disclaimer
	          } : {}
	        });
	      }
	    }
	  }, {
	    key: "save",
	    value: function save() {
	      var values = Object.assign({}, this.state.values);
	      this.setState({
	        isSaving: true,
	        lastUpdatedAt: this.state.film.updated_at
	      });
	      _FilmActions2.default.edit.defer(this.props.params.filmId, values);
	      window.scrollTo(0, 0);
	    }
	  }, {
	    key: "delete",
	    value: function _delete() {
	      var bucket = this.state.film.event_bucket;
	      if (window.confirm("Are you sure you would like to delete this film?")) {
	        _FilmActions2.default.delete(this.props.params.filmId);
	        this.context.router.push("/event_buckets/" + (bucket.id ? bucket.id : bucket) + "/films");
	      }
	    }
	  }, {
	    key: "onChangeValue",
	    value: function onChangeValue(id, value) {
	      this.state.dirty = true;
	      this.state.values[id] = value;
	      this.setState(this.state);
	    }
	  }, {
	    key: "onSearchTextChange",
	    value: function onSearchTextChange(searchText) {
	      var f = this.state.film;
	      this.setState({
	        searchText: searchText
	      });
	
	      if (!searchText || searchText.length < 3) {
	        return;
	      }
	
	      var req = _superagent2.default["get"](THEMOVIEDB_BASE_URL + "/search/movie?api_key=" + ("97a58966ffe8b89188f56a463c9ddaff") + "&query=" + searchText);
	
	      req.end(function (err, response) {
	        var _this4 = this;
	
	        if (err) {
	          console.log(err.message);
	        } else {
	          var films = response.body.results.map(function (f) {
	            f.detailedTitle = _react2.default.createElement(_MenuItem2.default, {
	              className: "tmdb-wrapper",
	              primaryText: _react2.default.createElement(
	                "div",
	                { style: { display: "flex", alignItems: "center" } },
	                _react2.default.createElement("img", {
	                  src: "" + _this4.state.imageUrl + _this4.state.imageSize + f.poster_path,
	                  width: "14",
	                  height: "19"
	                }),
	                _react2.default.createElement(
	                  "div",
	                  { style: { flex: 1, marginLeft: 8 } },
	                  f.title,
	                  " (",
	                  f.release_date ? f.release_date.substring(0, 4) : "Unknown",
	                  ")"
	                )
	              )
	            });
	
	            return f;
	          });
	          this.setState({
	            autocompleteFilms: films,
	            searchText: ""
	          });
	        }
	      }.bind(this));
	
	      req.send();
	    }
	  }, {
	    key: "onFilmTitleSelect",
	    value: function () {
	      var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(film) {
	        var f, req1, req2, poster, cover;
	        return regeneratorRuntime.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                if (!(typeof film === "string")) {
	                  _context.next = 3;
	                  break;
	                }
	
	                this.onChangeValue("name", film);
	                return _context.abrupt("return");
	
	              case 3:
	
	                this.onChangeValue("name", film.title);
	                f = this.state.film;
	                req1 = _superagent2.default["get"](THEMOVIEDB_BASE_URL + "/movie/" + film.id + "?api_key=" + ("97a58966ffe8b89188f56a463c9ddaff"));
	
	
	                req1.end(function (err, response) {
	                  var _this5 = this;
	
	                  if (err) {
	                    console.log(err.message);
	                  } else {
	                    (function () {
	                      var details = _this5.state.values.details;
	
	                      _this5.onChangeValue("description", response.body.overview);
	
	                      details.year = response.body.release_date ? response.body.release_date.substring(0, 4) : null;
	                      details.runtime = response.body.runtime;
	                      details.language = null;
	                      if (response.body.spoken_languages.length > 0) {
	                        response.body.spoken_languages.map(function (lang) {
	                          if (!details.language) {
	                            details.language = lang.english_name;
	                          } else {
	                            details.language = details.language + ", " + lang.english_name;
	                          }
	                        });
	                      }
	
	                      _this5.onChangeValue("details", details);
	                      _this5.onChangeValue("imdb_id", response.body.imdb_id);
	                    })();
	                  }
	                }.bind(this));
	
	                req1.send();
	
	                req2 = _superagent2.default["get"](THEMOVIEDB_BASE_URL + "/movie/" + film.id + "/credits?api_key=" + ("97a58966ffe8b89188f56a463c9ddaff"));
	
	
	                req2.end(function (err, response) {
	                  var _this6 = this;
	
	                  if (err) {
	                    console.log(err.message);
	                  } else {
	                    (function () {
	                      var credits = _this6.state.values.credits;
	
	                      var addCredit = function addCredit(currentCredit, newCredit) {
	                        if (!currentCredit) {
	                          return newCredit;
	                        } else {
	                          return currentCredit + ", " + newCredit;
	                        }
	                      };
	
	                      // Process Crew
	                      var roles = Object.keys(CREDITS);
	                      roles.map(function (r) {
	                        credits[r] = null;
	                      });
	
	                      var creditMap = {
	                        director: "director",
	                        "executive producer": "executive_producer",
	                        producer: "producer",
	                        "co-producer": "co_producer",
	                        "director of photography": "cinematographer",
	                        cinematographer: "cinematographer",
	                        editor: "editor",
	                        "production design": "production_design",
	                        "music supervisor": "music",
	                        "original music composer": "composer",
	                        "sound designer": "sound_design",
	                        animation: "animator",
	                        screenplay: "screenwriter",
	                        writer: "screenwriter"
	                      };
	
	                      for (var cr = 0; cr < response.body.crew.length; cr++) {
	                        var crew = response.body.crew[cr];
	                        var destinationField = creditMap[crew.job.toLowerCase()];
	                        if (destinationField) {
	                          credits[destinationField] = addCredit(credits[destinationField], crew.name);
	                        }
	                      }
	
	                      // Process Cast
	                      if (response.body.cast && response.body.cast.length > 0) {
	                        var castLength = 3;
	                        if (response.body.cast.length < 3) {
	                          castLength = response.body.cast.length;
	                        }
	                        for (var cl = 0; cl < castLength; cl++) {
	                          credits.cast = addCredit(credits.cast, response.body.cast[cl].name);
	                        }
	                      }
	
	                      // Update Credits state object
	                      _this6.onChangeValue("credits", credits);
	                    })();
	                  }
	                }.bind(this));
	
	                req2.send();
	
	                if (!film.poster_path) {
	                  _context.next = 17;
	                  break;
	                }
	
	                _context.next = 14;
	                return this.getBase64ImageFromUrl(this.state.imageUrl + "original" + film.poster_path);
	
	              case 14:
	                poster = _context.sent;
	
	                f.poster_image = poster.file;
	                this.onChangeValue("poster_image", poster.file);
	
	              case 17:
	                if (!film.backdrop_path) {
	                  _context.next = 25;
	                  break;
	                }
	
	                _context.next = 20;
	                return this.getBase64ImageFromUrl(this.state.imageUrl + "original" + film.backdrop_path);
	
	              case 20:
	                cover = _context.sent;
	
	                f.cover_image = cover.file;
	                this.onChangeValue("cover_image", cover.file);
	                f.still_image = cover.file;
	                this.onChangeValue("still_image", cover.file);
	
	              case 25:
	
	                this.setState({
	                  film: f
	                });
	
	              case 26:
	              case "end":
	                return _context.stop();
	            }
	          }
	        }, _callee, this);
	      }));
	
	      function onFilmTitleSelect(_x) {
	        return _ref.apply(this, arguments);
	      }
	
	      return onFilmTitleSelect;
	    }()
	  }, {
	    key: "onDropImage",
	    value: function onDropImage(id, file) {
	      _FilmActions2.default.editImage.defer(this.props.params.filmId, id, file);
	    }
	  }, {
	    key: "onRemoveImage",
	    value: function onRemoveImage(id) {
	      _FilmActions2.default.editImage.defer(this.props.params.filmId, id, null);
	    }
	  }, {
	    key: "_makeLiveLink",
	    value: function _makeLiveLink() {
	      var bucket = _EventBucketStore2.default.getEventBucketById(this.props.params.eventBucketId);
	      if (bucket) {
	        var slug = bucket.frontend_config.urls_use_slugs ? (0, _util.dashify)(this.state.values ? this.state.values.name : this.state.film.name) + "-" : "";
	        return _EventBucketStore2.default.getEventBucketById(this.props.params.eventBucketId).urls.film_guide + "/" + slug + this.props.params.filmId;
	      } else {
	        return null;
	      }
	    }
	  }, {
	    key: "_deliverDirectly",
	    value: function _deliverDirectly() {
	      this.context.router.push("/accept_creator_invite?token=" + encodeURIComponent("self-" + this.props.params.filmId));
	    }
	  }, {
	    key: "getStyles",
	    value: function getStyles() {
	      return {
	        leftSidebar: {
	          width: 269,
	          boxSizing: "border-box",
	          float: "left"
	        },
	        leftBody: {
	          padding: "1em",
	          borderRadius: 5,
	          backgroundColor: "#ececec",
	          marginBottom: "1em"
	        },
	        leftHeader: {
	          textAlign: "center"
	        },
	        leftHeaderTitle: {
	          marginBottom: 0
	        },
	        leftHeaderSubtitle: {
	          fontWeight: "normal",
	          fontSize: "1em",
	          marginTop: 0
	        },
	        posterImage: {
	          width: 140,
	          borderRadius: 5,
	          display: "inline-block"
	        },
	        coverImage: {
	          minHeight: 140,
	          marginTop: "1em",
	          borderRadius: 5
	        },
	        main: {
	          marginLeft: 291,
	          boxSizing: "border-box"
	        }
	      };
	    }
	  }, {
	    key: "getBase64ImageFromUrl",
	    value: function () {
	      var _ref2 = _asyncToGenerator(regeneratorRuntime.mark(function _callee2(imageUrl) {
	        var _this7 = this;
	
	        var res, blob;
	        return regeneratorRuntime.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                _context2.next = 2;
	                return fetch(imageUrl);
	
	              case 2:
	                res = _context2.sent;
	                _context2.next = 5;
	                return res.blob();
	
	              case 5:
	                blob = _context2.sent;
	                return _context2.abrupt("return", new Promise(function (resolve, reject) {
	                  var reader = new FileReader();
	                  reader.addEventListener("load", function () {
	                    resolve({
	                      file: reader.result,
	                      uploadBlob: blob
	                    });
	                  }, false);
	
	                  reader.onerror = function () {
	                    return reject(_this7);
	                  };
	                  reader.readAsDataURL(blob);
	                }));
	
	              case 7:
	              case "end":
	                return _context2.stop();
	            }
	          }
	        }, _callee2, this);
	      }));
	
	      function getBase64ImageFromUrl(_x2) {
	        return _ref2.apply(this, arguments);
	      }
	
	      return getBase64ImageFromUrl;
	    }()
	  }, {
	    key: "render",
	    value: function render() {
	      var _this8 = this;
	
	      var styles = this.getStyles(),
	          bucket = _EventBucketStore2.default.getEventBucketById(this.props.params.eventBucketId),
	          hasTitleRequest = this.state.film.title_requested_media && this.state.film.title_requested_media.length;
	
	      if (!this.state.film || !this.state.values || this.state.isSaving || !bucket) {
	        return _react2.default.createElement(_workingIndicator2.default, { fullPage: true });
	      }
	
	      var saveButton = _react2.default.createElement(_materialUi.RaisedButton, {
	        label: this.state.dirty ? "Save changes" : "No changes to save",
	        primary: true,
	        disabled: !this.state.dirty,
	        onTouchTap: this.save
	      });
	
	      var detailString = (0, _util.makeFilmDetailString)(this.state.values.details);
	
	      var stillEditor = _react2.default.createElement(_droppableImage2.default, {
	        style: Object.assign({}, styles.coverImage, this.state.film.still_image && { minHeight: "auto" }),
	        label: bucket.frontend_config.film_guide_stills_mode ? "Still image for film guide and virtual screening" : "Still image for virtual screening",
	        subsublabel: !this.state.film.still_image && "Recommended size: 1920 x 1080 px",
	        isUploading: this.props.uploadingImageField === "still_image",
	        value: this.state.film.still_image,
	        crop: { width: 1920, height: 1080 },
	        onDrop: function onDrop(f) {
	          return _this8.onDropImage("still_image", f);
	        },
	        onDelete: function onDelete() {
	          return _this8.onRemoveImage("still_image");
	        }
	      });
	
	      var isReadOnly = _UserStore2.default.hasPermission("view_film") && !_UserStore2.default.hasPermission("edit_film");
	
	      var user = _UserStore2.default.getUser();
	      var hasComscore = user && user.connections && user.connections.comscore ? true : false;
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        this.state.isPreviewingVirtualContent ? _react2.default.createElement(_virtualContentPreview2.default, {
	          filmId: this.state.film.id,
	          onRequestClose: function onRequestClose() {
	            return _this8.setState({ isPreviewingVirtualContent: false });
	          }
	        }) : null,
	        this.state.isInvitingContentCreator ? _react2.default.createElement(_inviteContentCreator2.default, {
	          eventBucket: bucket,
	          film: this.state.film,
	          inviteMode: this.state.inviteMode,
	          onInvite: function onInvite(email, _ref3) {
	            var title_requested_media = _ref3.title_requested_media;
	
	            _FilmActions2.default.inviteContentCreator(_this8.state.film.id, email, _this8.state.inviteMode === "title" ? {
	              title_requested_media: title_requested_media
	            } : undefined);
	            _this8.setState({ isInvitingContentCreator: false });
	          },
	          onRequestClose: function onRequestClose() {
	            return _this8.setState({ isInvitingContentCreator: false });
	          }
	        }) : null,
	        this.state.isAddingExternalVirtualContent ? _react2.default.createElement(_addExternalVirtualContent2.default, {
	          eventBucket: bucket,
	          film: this.state.film,
	          onCreate: function onCreate(virtualContent) {
	            _this8.setState({
	              values: _extends({}, _this8.state.values, {
	                virtual_content: virtualContent.id
	              })
	            }, function () {
	              _this8.save();
	              _this8.setState({ isAddingExternalVirtualContent: false });
	            });
	          },
	          onRequestClose: function onRequestClose() {
	            return _this8.setState({ isAddingExternalVirtualContent: false });
	          }
	        }) : null,
	        _react2.default.createElement(
	          "div",
	          { style: styles.leftSidebar },
	          _react2.default.createElement(
	            "div",
	            { style: styles.leftBody },
	            _react2.default.createElement(
	              "div",
	              { style: styles.leftHeader },
	              !bucket.frontend_config.film_guide_stills_mode ? isReadOnly ? _react2.default.createElement(
	                "div",
	                {
	                  style: Object.assign({}, styles.posterImage, this.state.film.poster_image && { minHeight: "auto" })
	                },
	                this.state.film.poster_image ? _react2.default.createElement("img", {
	                  src: this.state.film.poster_image,
	                  style: { width: "100%", borderRadius: 5 }
	                }) : _react2.default.createElement(
	                  "div",
	                  {
	                    style: {
	                      width: 140,
	                      height: 200,
	                      backgroundColor: "#adadad",
	                      borderRadius: 5,
	                      textAlign: "center",
	                      paddingTop: 90,
	                      boxSizing: "border-box"
	                    }
	                  },
	                  "No Poster Image"
	                )
	              ) : _react2.default.createElement(_droppableImage2.default, {
	                style: Object.assign({}, styles.posterImage, !this.state.film.poster_image && { minHeight: 200 }),
	                label: "Poster image",
	                isUploading: this.props.uploadingImageField === "poster_image",
	                value: this.state.film.poster_image,
	                onDrop: function onDrop(f) {
	                  return _this8.onDropImage("poster_image", f);
	                },
	                onDelete: function onDelete() {
	                  return _this8.onRemoveImage("poster_image");
	                }
	              }) : null,
	              _react2.default.createElement(
	                "h2",
	                { style: styles.leftHeaderTitle },
	                this.state.values.name || "Untitled Film"
	              ),
	              _react2.default.createElement(
	                "h3",
	                { style: styles.leftHeaderSubtitle },
	                detailString
	              )
	            ),
	            !bucket.frontend_config.film_guide_stills_mode ? isReadOnly ? _react2.default.createElement(
	              "div",
	              {
	                style: Object.assign({}, styles.coverImage, this.state.film.cover_image && { minHeight: "auto" })
	              },
	              this.state.film.cover_image ? _react2.default.createElement("img", {
	                src: this.state.film.cover_image,
	                style: { width: "100%", borderRadius: 5 }
	              }) : _react2.default.createElement(
	                "div",
	                {
	                  style: {
	                    width: 243,
	                    height: 146,
	                    backgroundColor: "#adadad",
	                    borderRadius: 5,
	                    textAlign: "center",
	                    paddingTop: 65,
	                    marginBottom: 15,
	                    boxSizing: "border-box"
	                  }
	                },
	                "No Cover Image"
	              )
	            ) : _react2.default.createElement(_droppableImage2.default, {
	              style: [styles.coverImage, this.state.film.cover_image && { minHeight: "auto" }],
	              label: "Cover image",
	              isUploading: this.props.uploadingImageField === "cover_image",
	              value: this.state.film.cover_image,
	              crop: { width: 960, height: 380 },
	              subsublabel: !this.state.film.cover_image && "Recommended size: 960 x 380 px",
	              onDrop: function onDrop(f) {
	                return _this8.onDropImage("cover_image", f);
	              },
	              onDelete: function onDelete() {
	                return _this8.onRemoveImage("cover_image");
	              }
	            }) : null,
	            bucket.enable_virtual_festival || bucket.frontend_config.film_guide_stills_mode ? isReadOnly ? this.state.film.still_image ? _react2.default.createElement(
	              "div",
	              {
	                style: Object.assign({}, styles.stillImage, this.state.film.still_image && { minHeight: "auto" })
	              },
	              _react2.default.createElement("img", {
	                src: this.state.film.still_image,
	                style: { width: "100%", borderRadius: 5 }
	              })
	            ) : _react2.default.createElement(
	              "div",
	              {
	                style: {
	                  width: 243,
	                  height: 146,
	                  backgroundColor: "#adadad",
	                  borderRadius: 5,
	                  textAlign: "center",
	                  paddingTop: 65,
	                  marginBottom: 0,
	                  boxSizing: "border-box"
	                }
	              },
	              "No Still Image"
	            ) : stillEditor : null
	          ),
	          bucket.enable_title_delivery ? _react2.default.createElement(
	            "div",
	            { style: styles.leftBody },
	            _react2.default.createElement(
	              _label2.default,
	              { style: { marginTop: 0 } },
	              "Eventive Print Traffic",
	              _react2.default.createElement(_inlineNoticeLabel2.default, {
	                label: "Limited Beta",
	                style: {
	                  marginLeft: 6,
	                  fontWeight: "bold"
	                }
	              })
	            ),
	            this.state.film.title ? _react2.default.createElement(
	              "div",
	              null,
	              _react2.default.createElement(_filmTable.TitleDeliveryStatus, { film: this.state.film }),
	              this.state.film.title_delivery.status_description ? _react2.default.createElement(
	                "div",
	                { style: { fontStyle: "italic" } },
	                this.state.film.title_delivery.status_description
	              ) : null,
	              _react2.default.createElement(
	                "div",
	                null,
	                "Delivery identifier:",
	                " ",
	                _react2.default.createElement(
	                  "span",
	                  { style: { fontFamily: "monospace, sans-serif" } },
	                  this.state.film.title_delivery.delivery_identifier
	                )
	              ),
	              this.state.film.title_delivery.submitting_user_account ? _react2.default.createElement(
	                "div",
	                null,
	                "Submitter:",
	                " ",
	                this.state.film.title_delivery.submitting_user_account.name,
	                " ",
	                "(",
	                _react2.default.createElement(
	                  "a",
	                  {
	                    href: "mailto:" + this.state.film.title_delivery.submitting_user_account.email,
	                    style: { wordBreak: "break-all" }
	                  },
	                  this.state.film.title_delivery.submitting_user_account.email
	                ),
	                ")"
	              ) : null,
	              this.state.film.title_delivery.print_delivery_type ? _react2.default.createElement(
	                "div",
	                null,
	                "Print delivery:",
	                " ",
	                _react2.default.createElement(
	                  "span",
	                  { style: { fontFamily: "monospace, sans-serif" } },
	                  this.state.film.title_delivery.print_delivery_type
	                )
	              ) : null,
	              this.state.film.title_delivery.virtual_delivery_type ? _react2.default.createElement(
	                "div",
	                null,
	                "Virtual delivery:",
	                " ",
	                _react2.default.createElement(
	                  "span",
	                  { style: { fontFamily: "monospace, sans-serif" } },
	                  this.state.film.title_delivery.virtual_delivery_type
	                )
	              ) : null,
	              _react2.default.createElement(
	                "div",
	                null,
	                _react2.default.createElement(
	                  _linkLike2.default,
	                  { onTouchTap: function onTouchTap() {
	                      return _this8._deliverDirectly();
	                    } },
	                  "Deliver directly"
	                ),
	                " ",
	                "\xB7",
	                " ",
	                _react2.default.createElement(
	                  _linkLike2.default,
	                  {
	                    onTouchTap: function onTouchTap() {
	                      _this8.setState({
	                        isInvitingContentCreator: true,
	                        inviteMode: "title"
	                      });
	                    }
	                  },
	                  "Send new invite"
	                )
	              )
	            ) : _react2.default.createElement(
	              "div",
	              null,
	              _react2.default.createElement(
	                "div",
	                { style: { fontWeight: "bold" } },
	                hasTitleRequest ? _react2.default.createElement(
	                  "div",
	                  null,
	                  "Title request sent:",
	                  " ",
	                  this.state.film.title_requested_media.sort().join(", ")
	                ) : "No title connected"
	              ),
	              hasTitleRequest && this.state.film._content_creator_invites && this.state.film._content_creator_invites.length ? _react2.default.createElement(
	                "div",
	                null,
	                "Invite sent to",
	                " ",
	                this.state.film._content_creator_invites.map(function (i) {
	                  return i.email;
	                }).join(", ")
	              ) : null,
	              _react2.default.createElement(
	                "div",
	                null,
	                _react2.default.createElement(_materialUi.RaisedButton, {
	                  label: "Send delivery invite",
	                  primary: true,
	                  onTouchTap: function onTouchTap() {
	                    return _this8.setState({
	                      isInvitingContentCreator: true,
	                      inviteMode: "title"
	                    });
	                  },
	                  style: { margin: "5px 0" }
	                })
	              ),
	              _react2.default.createElement(
	                "div",
	                null,
	                _react2.default.createElement(
	                  _linkLike2.default,
	                  { onTouchTap: function onTouchTap() {
	                      return _this8._deliverDirectly();
	                    } },
	                  "Deliver directly"
	                )
	              )
	            )
	          ) : null,
	          bucket.enable_virtual_festival ? this.state.isFilmPreviewer ? null : _react2.default.createElement(
	            "div",
	            { style: styles.leftBody },
	            _react2.default.createElement(
	              _label2.default,
	              { style: { marginTop: 0 } },
	              "Virtual content"
	            ),
	            this.state.film.virtual_content ? _react2.default.createElement(
	              "div",
	              null,
	              this.state.film.virtual_content.type === "external" ? _react2.default.createElement(
	                "div",
	                null,
	                _react2.default.createElement(
	                  "strong",
	                  null,
	                  "External content"
	                ),
	                ":",
	                " ",
	                _react2.default.createElement(
	                  "a",
	                  {
	                    href: this.state.film.virtual_content.egress_url,
	                    target: "_blank",
	                    style: { wordBreak: "break-all", color: "#000" }
	                  },
	                  this.state.film.virtual_content.egress_url
	                )
	              ) : this.state.film.virtual_content.type === "vod" ? _react2.default.createElement(
	                "div",
	                null,
	                _react2.default.createElement(
	                  "strong",
	                  null,
	                  "VOD content"
	                ),
	                ":",
	                " ",
	                _react2.default.createElement(
	                  "span",
	                  { style: { wordBreak: "break-all" } },
	                  this.state.film.virtual_content.label
	                ),
	                " ",
	                this.state.film.virtual_content.platform === "cinesend" || this.state.film.virtual_content.platform === "eventive" ? _react2.default.createElement(
	                  "div",
	                  {
	                    style: {
	                      fontWeight: "bold",
	                      color: "rgb(229, 57, 53)"
	                    }
	                  },
	                  "No longer supported \u2013 re-upload required",
	                  " ",
	                  _react2.default.createElement(
	                    "a",
	                    {
	                      href: "https://help.eventive.org/en/articles/5292118-legacy-asset-pathway-deprecation-information-may-2021",
	                      target: "_blank"
	                    },
	                    "(?)"
	                  )
	                ) : _react2.default.createElement(
	                  "span",
	                  null,
	                  "(",
	                  this.state.film.virtual_content.status,
	                  this.state.film.virtual_content.platform && _UserStore2.default.isGod() ? " - " + this.state.film.virtual_content.platform : "",
	                  ")"
	                )
	              ) : _react2.default.createElement(
	                "div",
	                null,
	                "Unexpected virtual content encountered! Please contact Eventive Support."
	              ),
	              this.state.film.virtual_content.caption_tracks && this.state.film.virtual_content.caption_tracks.length ? _react2.default.createElement(
	                "div",
	                { style: { margin: "4px 0" } },
	                _react2.default.createElement(
	                  "svg",
	                  {
	                    viewBox: "0 0 24 24",
	                    fill: "currentColor",
	                    style: {
	                      width: 24,
	                      height: 24,
	                      verticalAlign: -3,
	                      margin: "-4px 0 -4px -2px"
	                    }
	                  },
	                  _react2.default.createElement("path", { d: "M0 0h24v24H0z", fill: "none" }),
	                  _react2.default.createElement("path", { d: "M19 4H5c-1.11 0-2 .9-2 2v12c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm-8 7H9.5v-.5h-2v3h2V13H11v1c0 .55-.45 1-1 1H7c-.55 0-1-.45-1-1v-4c0-.55.45-1 1-1h3c.55 0 1 .45 1 1v1zm7 0h-1.5v-.5h-2v3h2V13H18v1c0 .55-.45 1-1 1h-3c-.55 0-1-.45-1-1v-4c0-.55.45-1 1-1h3c.55 0 1 .45 1 1v1z" })
	                ),
	                " ",
	                "Closed captions available"
	              ) : null,
	              isReadOnly ? null : _react2.default.createElement(
	                _linkLike2.default,
	                {
	                  onTouchTap: function onTouchTap() {
	                    if (_this8.state.film.virtual_content.type === "external" || window.confirm("Are you sure? You will need to re-request permission from the filmmaker to re-upload.")) {
	                      _this8.setState({
	                        values: _extends({}, _this8.state.values, {
	                          virtual_content: null
	                        })
	                      }, function () {
	                        return _this8.save();
	                      });
	                    }
	                  }
	                },
	                "Remove"
	              ),
	              isReadOnly ? null : _react2.default.createElement(
	                "span",
	                null,
	                " \xB7 "
	              ),
	              _react2.default.createElement(
	                _linkLike2.default,
	                {
	                  onTouchTap: function onTouchTap() {
	                    _this8.setState({ isPreviewingVirtualContent: true });
	                  }
	                },
	                "Preview"
	              ),
	              " ",
	              this.state.film.virtual_content.type === "vod" ? isReadOnly ? null : _react2.default.createElement(
	                "span",
	                null,
	                "\xB7",
	                " ",
	                _react2.default.createElement(
	                  _reactRouter.Link,
	                  {
	                    to: "/creator_hub/virtual_content/" + this.state.film.virtual_content.id
	                  },
	                  "Manage"
	                )
	              ) : null
	            ) : _react2.default.createElement(
	              "div",
	              null,
	              _react2.default.createElement(
	                "div",
	                { style: { fontWeight: "bold" } },
	                "No virtual content uploaded",
	                hasTitleRequest && this.state.film.title_requested_media.includes("virtual") ? ", awaiting delivery from Eventive Print Traffic" : ""
	              ),
	              isReadOnly ? null : hasTitleRequest ? _react2.default.createElement(
	                "span",
	                null,
	                _react2.default.createElement(
	                  _linkLike2.default,
	                  {
	                    onTouchTap: function onTouchTap() {
	                      return _this8.setState({
	                        isInvitingContentCreator: true,
	                        inviteMode: "classic"
	                      });
	                    }
	                  },
	                  "Send virtual content upload invite"
	                ),
	                " ",
	                "\xB7"
	              ) : _react2.default.createElement(
	                "div",
	                null,
	                this.state.film._content_creator_invites && this.state.film._content_creator_invites.length ? _react2.default.createElement(
	                  "div",
	                  null,
	                  "Invite sent to",
	                  " ",
	                  this.state.film._content_creator_invites.map(function (i) {
	                    return i.email;
	                  }).join(", ")
	                ) : null,
	                _react2.default.createElement(
	                  "div",
	                  null,
	                  _react2.default.createElement(_materialUi.RaisedButton, {
	                    label: "Send upload invite",
	                    primary: true,
	                    onTouchTap: function onTouchTap() {
	                      return _this8.setState({
	                        isInvitingContentCreator: true,
	                        inviteMode: "classic"
	                      });
	                    },
	                    style: { margin: "5px 0" }
	                  })
	                )
	              ),
	              isReadOnly ? null : _react2.default.createElement(
	                "div",
	                null,
	                hasTitleRequest ? null : "or ",
	                _react2.default.createElement(
	                  _reactRouter.Link,
	                  { to: "/creator_hub/films/" + this.state.film.id },
	                  hasTitleRequest ? "U" : "u",
	                  "pload directly"
	                ),
	                " ",
	                "\xB7",
	                " ",
	                _react2.default.createElement(
	                  _linkLike2.default,
	                  {
	                    onTouchTap: function onTouchTap() {
	                      return _this8.setState({
	                        isAddingExternalVirtualContent: true
	                      });
	                    }
	                  },
	                  "Use external link"
	                )
	              )
	            )
	          ) : null,
	          _react2.default.createElement(
	            "div",
	            { style: styles.leftBody },
	            _react2.default.createElement(_materialUi.TextField, {
	              value: this.state.values.trailer_url || "",
	              floatingLabelText: "Trailer URL",
	              floatingLabelFixed: true,
	              style: { marginTop: -12, marginBottom: -6, width: "100%" },
	              placeholder: "YouTube or Vimeo link",
	              onChange: function onChange(e) {
	                return _this8.onChangeValue("trailer_url", e.target.value);
	              },
	              disabled: isReadOnly
	            })
	          ),
	          _UserStore2.default.hasPermission("manage_films") || _UserStore2.default.hasPermission("edit_film") ? _react2.default.createElement(
	            "div",
	            { style: styles.leftBody },
	            _react2.default.createElement(
	              "div",
	              null,
	              _react2.default.createElement(
	                _label2.default,
	                { style: { marginTop: 0 } },
	                "Visibility"
	              ),
	              _react2.default.createElement(
	                _materialUi.RadioButtonGroup,
	                {
	                  name: "visibility",
	                  valueSelected: this.state.values.visibility,
	                  onChange: function onChange(e, v) {
	                    return _this8.onChangeValue("visibility", v);
	                  }
	                },
	                _react2.default.createElement(_materialUi.RadioButton, { value: "visible", label: "Visible everywhere" }),
	                _react2.default.createElement(_materialUi.RadioButton, { value: "hidden", label: "Hidden from Film Guide" }),
	                _react2.default.createElement(_materialUi.RadioButton, {
	                  value: "hidden_everywhere",
	                  label: "Hidden everywhere"
	                })
	              ),
	              bucket && bucket.enable_virtual_festival ? _react2.default.createElement(
	                "div",
	                {
	                  style: {
	                    marginTop: "0.75em",
	                    fontStyle: "italic",
	                    fontSize: "0.9em",
	                    lineHeight: "1.3",
	                    opacity: 0.7
	                  }
	                },
	                _react2.default.createElement(
	                  "strong",
	                  null,
	                  "Eventive Virtual note:"
	                ),
	                " If set to \"Hidden everywhere\" and added to a virtual screening, the film will not be shown in the sidebar but will still play within the program."
	              ) : null
	            ),
	            bucket && bucket.enable_virtual_festival ? _react2.default.createElement(
	              "div",
	              null,
	              _react2.default.createElement(
	                _label2.default,
	                null,
	                "Age-restricted content"
	              ),
	              _react2.default.createElement(_materialUi.Checkbox, {
	                labelStyle: { lineHeight: "18px" },
	                label: "Viewers must attest to being 18+ to view virtual content",
	                checked: this.state.values.virtual_content_disclaimer ? true : false,
	                onCheck: function onCheck(e, checked) {
	                  _this8.onChangeValue("virtual_content_disclaimer", checked ? "disclaimer" : null);
	                }
	              })
	            ) : null,
	            bucket && bucket.enable_balloting ? _react2.default.createElement(
	              "div",
	              null,
	              _react2.default.createElement(
	                _label2.default,
	                null,
	                "Balloting status"
	              ),
	              _react2.default.createElement(
	                _materialUi.RadioButtonGroup,
	                {
	                  name: "unballoted",
	                  valueSelected: this.state.values.unballoted ? "unballoted" : "balloted",
	                  onChange: function onChange(e, v) {
	                    return _this8.onChangeValue("unballoted", v === "unballoted" ? true : false);
	                  }
	                },
	                _react2.default.createElement(_materialUi.RadioButton, { value: "balloted", label: "Balloted" }),
	                _react2.default.createElement(_materialUi.RadioButton, {
	                  value: "unballoted",
	                  label: "Not in competition"
	                })
	              )
	            ) : null
	          ) : null,
	          _react2.default.createElement(
	            "div",
	            { style: { marginTop: 15, display: "flex", alignItems: "center" } },
	            _react2.default.createElement("img", {
	              src: "/img/tmdb.svg",
	              style: { width: 30, height: 22, marginRight: 10 }
	            }),
	            _react2.default.createElement(
	              "div",
	              { style: { fontSize: 10, lineHeight: "10px" } },
	              "This product uses the",
	              " ",
	              _react2.default.createElement(
	                "a",
	                { href: "https://www.themoviedb.org/", target: "_blank" },
	                "TMDb"
	              ),
	              " ",
	              "API but is not endorsed or certified by TMDb."
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { style: styles.main },
	          _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(_backButton2.default, {
	              label: "Films",
	              onTouchTap: function onTouchTap() {
	                return _this8.props.location.state && _this8.props.location.state.fromListing ? _this8.context.router.goBack() : _this8.context.router.push("/event_buckets/" + _this8.props.params.eventBucketId + "/films");
	              },
	              style: { marginRight: 7 }
	            }),
	            saveButton,
	            _react2.default.createElement(_materialUi.RaisedButton, {
	              style: { marginLeft: 7, verticalAlign: "top" },
	              disabled: this.state.dirty,
	              label: "View live",
	              target: "_blank",
	              href: this._makeLiveLink()
	            })
	          ),
	          this.state.film.eventival_id && _react2.default.createElement(_eventivalBanner2.default, {
	            type: "film",
	            style: { marginTop: 20, marginBottom: -10 }
	          }),
	          _react2.default.createElement(
	            _infoNotice2.default,
	            { style: { marginTop: 20 } },
	            "Check out our",
	            " ",
	            _react2.default.createElement(
	              "a",
	              {
	                href: "http://help.eventive.org/films/create-films",
	                target: "_blank"
	              },
	              "guide to creating films"
	            ),
	            "."
	          ),
	          bucket.frontend_config.disable_tmdb_integration ? _react2.default.createElement(_materialUi.TextField, {
	            floatingLabelText: "Film title",
	            floatingLabelFixed: true,
	            style: { width: "100%" },
	            value: this.state.values.name,
	            onChange: function onChange(e) {
	              return _this8.onChangeValue("name", e.target.value);
	            },
	            disabled: isReadOnly
	          }) : _react2.default.createElement(_AutoComplete2.default, {
	            floatingLabelText: "Film title",
	            floatingLabelFixed: true,
	            searchText: this.state.values.name,
	            dataSource: this.state.autocompleteFilms || [],
	            dataSourceConfig: { text: "title", value: "detailedTitle" },
	            filter: function filter(searchText, key) {
	              return searchText && key.toLowerCase().indexOf(searchText.toLowerCase()) !== -1;
	            },
	            maxSearchResults: 8,
	            menuProps: { desktop: true, autoWidth: true, width: "auto" },
	            style: {
	              width: "100%"
	            },
	            fullWidth: true,
	            onNewRequest: this.onFilmTitleSelect,
	            onUpdateInput: this.onSearchTextChange,
	            onBlur: function onBlur(e) {
	              if (_this8.state.searchText !== "") {
	                _this8.onFilmTitleSelect(_this8.state.searchText);
	              } else {
	                _this8.onChangeValue("name", e.target.value);
	              }
	            },
	            disabled: isReadOnly
	          }),
	          isReadOnly ? _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(
	              _label2.default,
	              { style: { color: "#a4a4a4" } },
	              "Film description"
	            ),
	            _react2.default.createElement("div", {
	              style: { color: "#868686", fontSize: "16px" },
	              dangerouslySetInnerHTML: {
	                __html: this.state.values.description
	              }
	            })
	          ) : _react2.default.createElement(_basicHtmlField2.default, {
	            label: "Film description",
	            value: this.state.values.description,
	            formats: ["image", "align"],
	            onChange: function onChange(v) {
	              return _this8.onChangeValue("description", v);
	            },
	            withImages: true
	          }),
	          _react2.default.createElement(_materialUi.TextField, {
	            floatingLabelText: "Short description (logline)",
	            floatingLabelFixed: true,
	            style: { width: "100%" },
	            placeholder: "Start typing to add \u2013 shown in Film Guide, Virtual Catalog, and Eventive Discovery Portal",
	            value: this.state.values.short_description,
	            onChange: function onChange(e) {
	              return _this8.onChangeValue("short_description", e.target.value);
	            },
	            disabled: isReadOnly
	          }),
	          _react2.default.createElement(_injectedSelect2.default, {
	            label: "Tags",
	            value: this.state.values.tags,
	            types: ["tags"],
	            multi: true,
	            noResultsText: _react2.default.createElement(
	              "span",
	              null,
	              "No tags found. Use the",
	              " ",
	              _react2.default.createElement(
	                _reactRouter.Link,
	                {
	                  to: "event_buckets/" + this.props.params.eventBucketId + "/tags"
	                },
	                "Tags"
	              ),
	              " ",
	              "section to create new tags."
	            ),
	            labelFormatter: function labelFormatter(t) {
	              return t.name;
	            },
	            eventBucketId: this.props.params.eventBucketId,
	            style: { width: "100%" },
	            onChange: function onChange(selected) {
	              return _this8.onChangeValue("tags", selected);
	            },
	            disabled: isReadOnly
	          }),
	          hasComscore ? _react2.default.createElement(
	            "div",
	            { style: { marginTop: "15px" } },
	            _react2.default.createElement(
	              _label2.default,
	              null,
	              "COMSCORE Box Office Essentials"
	            ),
	            _react2.default.createElement(
	              "div",
	              { style: { padding: "1px", paddingBottom: 5 } },
	              _react2.default.createElement(_materialUi.Checkbox, {
	                style: { marginBottom: "0.5em", maxWidth: 500 },
	                label: "Include film in COMSCORE nightly gross revenue upload",
	                checked: this.state.values.comscore_include,
	                onCheck: function onCheck(e, checked) {
	                  _this8.onChangeValue("comscore_include", checked);
	                }
	              })
	            )
	          ) : null,
	          _react2.default.createElement(
	            "div",
	            { style: { marginTop: "1em" } },
	            _react2.default.createElement(_subfieldsField2.default, {
	              style: { display: "inline-block", marginRight: "1em" },
	              label: "Details",
	              options: DETAILS,
	              value: this.state.values.details,
	              onChange: function onChange(v) {
	                return _this8.onChangeValue("details", v);
	              },
	              disabled: isReadOnly
	            }),
	            _react2.default.createElement(_subfieldsField2.default, {
	              style: { display: "inline-block", marginRight: "-1.5em" },
	              label: "Credits",
	              options: CREDITS,
	              value: this.state.values.credits,
	              onChange: function onChange(v) {
	                return _this8.onChangeValue("credits", v);
	              },
	              disabled: isReadOnly
	            })
	          ),
	          this.state.values.expanded_credits ? _react2.default.createElement(
	            "div",
	            { style: { marginTop: "1em", width: "100%" } },
	            _react2.default.createElement(_subfieldsField2.default, {
	              style: { display: "inline-block", marginRight: "1em", width: "100%" },
	              label: "Expanded Credits",
	              options: this.state.values.expanded_credits.map(function (ec) {
	                return ec.label;
	              }),
	              value: this.state.values.expanded_credits.map(function (ec) {
	                return ec.value;
	              }),
	              disabled: true,
	              wider: true
	            })
	          ) : null,
	          isReadOnly ? null : _react2.default.createElement(
	            "div",
	            { style: { marginTop: "1em" } },
	            saveButton,
	            _react2.default.createElement(_materialUi.RaisedButton, {
	              label: "Delete film",
	              onTouchTap: this.delete,
	              style: { marginLeft: 7 }
	            })
	          )
	        )
	      );
	    }
	  }], [{
	    key: "getStores",
	    value: function getStores() {
	      return [_EventBucketStore2.default, _FilmStore2.default];
	    }
	  }, {
	    key: "getPropsFromStores",
	    value: function getPropsFromStores() {
	      return {
	        getFilmById: _FilmStore2.default.getFilmById,
	        uploadingImageField: _FilmStore2.default.getState().uploadingImageField
	      };
	    }
	  }, {
	    key: "contextTypes",
	    get: function get() {
	      return {
	        router: _react2.default.PropTypes.object
	      };
	    }
	  }]);
	
	  return FilmEditor;
	}(_react2.default.Component);
	
	exports.default = (0, _connectToStores2.default)(FilmEditor);
	module.exports = exports["default"];

/***/ }),
/* 2671 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _radium = __webpack_require__(1600);
	
	var _radium2 = _interopRequireDefault(_radium);
	
	var _addAPhoto = __webpack_require__(2672);
	
	var _addAPhoto2 = _interopRequireDefault(_addAPhoto);
	
	var _workingIndicator = __webpack_require__(1664);
	
	var _workingIndicator2 = _interopRequireDefault(_workingIndicator);
	
	var _imageDropzone = __webpack_require__(2058);
	
	var _imageDropzone2 = _interopRequireDefault(_imageDropzone);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var STYLES = {
	  outer: {
	    boxShadow: "inset 1px 1px 60px 0 rgba(0,0,0,.45)",
	    textAlign: "center",
	    position: "relative",
	    overflow: "hidden"
	  },
	  image: {
	    width: "100%",
	    display: "block"
	  },
	  instructions: {
	    position: "absolute",
	    top: 0,
	    left: 0,
	    height: "100%",
	    width: "100%",
	    display: "flex",
	    flexDirection: "column",
	    justifyContent: "center",
	    opacity: 0.4,
	    cursor: "pointer",
	    transition: "0.25s all ease-in-out",
	    ":hover": {
	      opacity: 1
	    }
	  },
	  instructionsWithValue: {
	    opacity: 0
	  },
	  icon: {
	    display: "block",
	    width: 30,
	    height: 30,
	    margin: "0 auto 0.25em"
	  },
	  label: {
	    fontWeight: "bold",
	    fontSize: "1.2em"
	  },
	  sublabel: {
	    marginTop: "0.25em",
	    lineHeight: 1.1
	  },
	  subsublabel: {
	    marginTop: "0.25em",
	    fontSize: "0.9em"
	  },
	  deleteImage: {
	    position: "absolute",
	    top: 0,
	    right: 0,
	    padding: "0 6px 4px",
	    lineHeight: 1,
	    fontSize: "1.5em",
	    backgroundColor: "red",
	    cursor: "pointer",
	    borderRadius: "0 0 0 5px",
	    ":hover": {
	      backgroundColor: "#8B0000"
	    }
	  }
	};
	
	var DroppableImage = function DroppableImage(_ref) {
	  var label = _ref.label;
	  var subsublabel = _ref.subsublabel;
	  var value = _ref.value;
	  var isUploading = _ref.isUploading;
	  var invertLabelColor = _ref.invertLabelColor;
	  var style = _ref.style;
	  var _onDrop = _ref.onDrop;
	  var onDelete = _ref.onDelete;
	
	  var rest = _objectWithoutProperties(_ref, ["label", "subsublabel", "value", "isUploading", "invertLabelColor", "style", "onDrop", "onDelete"]);
	
	  if (value) {
	    invertLabelColor = true;
	  }
	
	  return React.createElement(
	    _imageDropzone2.default,
	    _extends({
	      style: [STYLES.outer, style],
	      crop: true,
	      hideCropTip: true,
	      onDrop: function onDrop(_ref2) {
	        var _ref3 = _slicedToArray(_ref2, 1);
	
	        var file = _ref3[0];
	        return _onDrop(file);
	      }
	    }, rest),
	    value && React.createElement("img", { src: value, style: STYLES.image }),
	    React.createElement(
	      "div",
	      {
	        style: [STYLES.instructions, value && STYLES.instructionsWithValue, invertLabelColor && { color: "#fff" }, invertLabelColor && !value && { opacity: 0.7 }, isUploading && { opacity: 1 }]
	      },
	      React.createElement(
	        "div",
	        { key: "upload" },
	        isUploading ? React.createElement(
	          "div",
	          null,
	          React.createElement(_workingIndicator2.default, { color: invertLabelColor ? "#fff" : "#ccc" }),
	          React.createElement(
	            "div",
	            {
	              style: {
	                marginTop: "0.5em",
	                color: invertLabelColor ? "#fff" : "#ccc"
	              }
	            },
	            "Uploading..."
	          )
	        ) : React.createElement(
	          "div",
	          null,
	          React.createElement(_addAPhoto2.default, {
	            style: Object.assign({}, STYLES.icon, invertLabelColor && { color: "#fff" })
	          }),
	          React.createElement(
	            "div",
	            { style: STYLES.label },
	            label
	          ),
	          React.createElement(
	            "div",
	            { style: STYLES.sublabel },
	            "Drag and drop,",
	            React.createElement("br", null),
	            "or click to upload."
	          ),
	          React.createElement(
	            "div",
	            { style: STYLES.subsublabel },
	            subsublabel
	          )
	        )
	      ),
	      onDelete && value ? React.createElement(
	        "div",
	        {
	          key: "delete",
	          style: STYLES.deleteImage,
	          onClick: function onClick(e) {
	            e.preventDefault();
	            e.stopPropagation();
	            onDelete();
	          }
	        },
	        "\xD7"
	      ) : null
	    )
	  );
	};
	
	exports.default = (0, _radium2.default)(DroppableImage);
	module.exports = exports["default"];

/***/ }),
/* 2672 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(608);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(615);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageAddAPhoto = function ImageAddAPhoto(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M3 4V1h2v3h3v2H5v3H3V6H0V4h3zm3 6V7h3V4h7l1.83 2H21c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H5c-1.1 0-2-.9-2-2V10h3zm7 9c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm-3.2-5c0 1.77 1.43 3.2 3.2 3.2s3.2-1.43 3.2-3.2-1.43-3.2-3.2-3.2-3.2 1.43-3.2 3.2z' })
	  );
	};
	ImageAddAPhoto = (0, _pure2.default)(ImageAddAPhoto);
	ImageAddAPhoto.displayName = 'ImageAddAPhoto';
	ImageAddAPhoto.muiName = 'SvgIcon';
	
	exports.default = ImageAddAPhoto;

/***/ }),
/* 2673 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _materialUi = __webpack_require__(576);
	
	var _reactSelect = __webpack_require__(953);
	
	var _label = __webpack_require__(1682);
	
	var _label2 = _interopRequireDefault(_label);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var STYLES = {
	  table: {
	    width: "auto"
	  },
	  sublabel: {
	    padding: 0,
	    paddingRight: 10
	  },
	  subtextfield: {
	    marginTop: -12,
	    marginBottom: -12
	  }
	};
	
	var COUNTRIES = ["United States", "Afghanistan", "Åland Islands", "Albania", "Algeria", "American Samoa", "Andorra", "Angola", "Anguilla", "Antarctica", "Antigua and Barbuda", "Argentina", "Armenia", "Aruba", "Australia", "Austria", "Azerbaijan", "Bahamas", "Bahrain", "Bangladesh", "Barbados", "Belarus", "Belgium", "Belize", "Benin", "Bermuda", "Bhutan", "Bolivia, Plurinational State of", "Bonaire, Sint Eustatius and Saba", "Bosnia and Herzegovina", "Botswana", "Bouvet Island", "Brazil", "British Indian Ocean Territory", "Brunei Darussalam", "Bulgaria", "Burkina Faso", "Burundi", "Cambodia", "Cameroon", "Canada", "Cape Verde", "Cayman Islands", "Central African Republic", "Chad", "Chile", "China", "Christmas Island", "Cocos (Keeling) Islands", "Colombia", "Comoros", "Congo", "Congo, the Democratic Republic of the", "Cook Islands", "Costa Rica", "Côte d'Ivoire", "Croatia", "Cuba", "Curaçao", "Cyprus", "Czech Republic", "Denmark", "Djibouti", "Dominica", "Dominican Republic", "Ecuador", "Egypt", "El Salvador", "Equatorial Guinea", "Eritrea", "Estonia", "Ethiopia", "Falkland Islands (Malvinas)", "Faroe Islands", "Fiji", "Finland", "France", "French Guiana", "French Polynesia", "French Southern Territories", "Gabon", "Gambia", "Georgia", "Germany", "Ghana", "Gibraltar", "Greece", "Greenland", "Grenada", "Guadeloupe", "Guam", "Guatemala", "Guernsey", "Guinea", "Guinea-Bissau", "Guyana", "Haiti", "Heard Island and McDonald Islands", "Holy See (Vatican City State)", "Honduras", "Hong Kong", "Hungary", "Iceland", "India", "Indonesia", "Iran, Islamic Republic of", "Iraq", "Ireland", "Isle of Man", "Israel", "Italy", "Jamaica", "Japan", "Jersey", "Jordan", "Kazakhstan", "Kenya", "Kiribati", "Korea, Democratic People's Republic of", "Korea, Republic of", "Kosovo", "Kuwait", "Kyrgyzstan", "Lao People's Democratic Republic", "Latvia", "Lebanon", "Lesotho", "Liberia", "Libya", "Liechtenstein", "Lithuania", "Luxembourg", "Macao", "Macedonia, the former Yugoslav Republic of", "Madagascar", "Malawi", "Malaysia", "Maldives", "Mali", "Malta", "Marshall Islands", "Martinique", "Mauritania", "Mauritius", "Mayotte", "Mexico", "Micronesia, Federated States of", "Moldova, Republic of", "Monaco", "Mongolia", "Montenegro", "Montserrat", "Morocco", "Mozambique", "Myanmar", "Namibia", "Nauru", "Nepal", "Netherlands", "New Caledonia", "New Zealand", "Nicaragua", "Niger", "Nigeria", "Niue", "Norfolk Island", "Northern Mariana Islands", "Norway", "Oman", "Pakistan", "Palau", "Palestine, State of", "Panama", "Papua New Guinea", "Paraguay", "Peru", "Philippines", "Pitcairn", "Poland", "Portugal", "Puerto Rico", "Qatar", "Réunion", "Romania", "Russian Federation", "Rwanda", "Saint Barthélemy", "Saint Helena, Ascension and Tristan da Cunha", "Saint Kitts and Nevis", "Saint Lucia", "Saint Martin (French part)", "Saint Pierre and Miquelon", "Saint Vincent and the Grenadines", "Samoa", "San Marino", "Sao Tome and Principe", "Saudi Arabia", "Senegal", "Serbia", "Seychelles", "Sierra Leone", "Singapore", "Sint Maarten (Dutch part)", "Slovakia", "Slovenia", "Solomon Islands", "Somalia", "South Africa", "South Georgia and the South Sandwich Islands", "South Sudan", "Spain", "Sri Lanka", "Sudan", "Suriname", "Svalbard and Jan Mayen", "Swaziland", "Sweden", "Switzerland", "Syrian Arab Republic", "Taiwan", "Tajikistan", "Tanzania, United Republic of", "Thailand", "Timor-Leste", "Togo", "Tokelau", "Tonga", "Trinidad and Tobago", "Tunisia", "Turkey", "Turkmenistan", "Turks and Caicos Islands", "Tuvalu", "Uganda", "Ukraine", "United Arab Emirates", "United Kingdom", "United States Minor Outlying Islands", "Uruguay", "Uzbekistan", "Vanuatu", "Venezuela, Bolivarian Republic of", "Viet Nam", "Virgin Islands, British", "Virgin Islands, U.S.", "Wallis and Futuna", "Western Sahara", "Yemen", "Zambia", "Zimbabwe"];
	var LANGUAGES = ["English", "Afrikaans", "Albanian", "American Sign Language", "Amharic", "Arabic", "Armenian", "Azerbaijani", "Basque", "Belarusian", "Bengali", "Bulgarian", "Catalan", "Cebuano", "Central Khmer", "Chinese", "Croatian", "Czech", "Danish", "Dutch", "Eastern Canadian Inuktitut", "Estonian", "Faroese", "Fijian", "Filiipino", "Finnish", "French", "Galician", "Ganda", "Georgian", "German", "Gujarati", "Hebrew", "Hindi", "Hungarian", "Icelandic", "Indonesian", "Inuktitut", "Irish", "Italian", "Japanese", "Kannada", "Kashmiri", "Korean", "Kurdish", "Latin", "Latvian", "Lithuanian", "Macedonian", "Malay", "Malayalam", "Maltese", "Maori", "Marathi", "Marshallese", "Modern Greek (1453-)", "Mongolian", "Nepali", "Norwegian", "Oromo", "Other", "Panjabi", "Papiamento", "Persian", "Polish", "Portuguese", "Quechua", "Romanian", "Russian", "Samoan", "Serbian", "Slovak", "Slovenian", "Soga", "Somali", "Spanish", "Swahili", "Swedish", "Swiss German", "Tagalog", "Tamil", "Tatar", "Telugu", "Thai", "Tibetan", "Tigrinya", "Tonga (Tonga Islands)", "Turkish", "Ukrainian", "Urdu", "Uzbek", "Vietnamese", "Welsh", "Western Canadian Inuktitut", "Xhosa", "Yiddish"];
	
	var SubfieldsField = function (_React$Component) {
	  _inherits(SubfieldsField, _React$Component);
	
	  function SubfieldsField(props) {
	    _classCallCheck(this, SubfieldsField);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(SubfieldsField).call(this, props));
	
	    _this._makeSelect = _this._makeSelect.bind(_this);
	    return _this;
	  }
	
	  _createClass(SubfieldsField, [{
	    key: "_makeSelect",
	    value: function _makeSelect(key, options, placeholder) {
	      var _this2 = this;
	
	      var value = this.props.value;
	      var selected = value[key] && value[key].length ? value[key].split(",").map(function (x) {
	        return x.trim();
	      }) : [];
	
	      return _react2.default.createElement(_reactSelect.Creatable, {
	        key: value[key] || key,
	        style: { width: 175 },
	        placeholder: placeholder,
	        options: options.map(function (t) {
	          return { label: t, value: t };
	        }).concat(selected.map(function (k) {
	          return options.indexOf(k) === -1 ? { label: k, value: k } : null;
	        }).filter(function (x) {
	          return !!x;
	        })),
	        value: selected,
	        multi: true,
	        promptTextCreator: function promptTextCreator(s) {
	          return "Create \"" + s + "\"";
	        },
	        onChange: function onChange(v) {
	          value[key] = v.map(function (x) {
	            return x.value;
	          }).join(", ");
	          _this2.props.onChange(value);
	        },
	        disabled: this.props.disabled
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this3 = this;
	
	      var _props = this.props;
	      var style = _props.style;
	      var label = _props.label;
	      var options = _props.options;
	      var value = _props.value;
	
	
	      return _react2.default.createElement(
	        "div",
	        { style: style },
	        _react2.default.createElement(
	          _label2.default,
	          null,
	          label
	        ),
	        _react2.default.createElement(
	          "table",
	          { style: this.props.wider ? { width: "100%" } : STYLES.table },
	          _react2.default.createElement(
	            "tbody",
	            null,
	            Object.keys(options).map(function (key) {
	              return _react2.default.createElement(
	                "tr",
	                { key: key },
	                _react2.default.createElement(
	                  "td",
	                  { style: Object.assign(STYLES.sublabel, { width: _this3.props.wider ? "30%" : null }) },
	                  options[key].label || options[key]
	                ),
	                _react2.default.createElement(
	                  "td",
	                  null,
	                  key === "language" || key === "subtitle_language" ? _this3._makeSelect(key, LANGUAGES, "Select language...") : key === "country" ? _this3._makeSelect(key, COUNTRIES, "Select country...") : _react2.default.createElement(_materialUi.TextField, {
	                    style: Object.assign({}, STYLES.subtextfield, {
	                      width: _this3.props.wider ? "70%" : 175
	                    }),
	                    value: value[key],
	                    name: "subfields_field_" + key,
	                    placeholder: options[key].placeholder,
	                    onChange: function onChange(e) {
	                      value[key] = e.target.value;
	                      _this3.props.onChange(value);
	                    },
	                    disabled: _this3.props.disabled
	                  })
	                )
	              );
	            })
	          )
	        )
	      );
	    }
	  }]);
	
	  return SubfieldsField;
	}(_react2.default.Component);
	
	exports.default = SubfieldsField;
	module.exports = exports["default"];

/***/ }),
/* 2674 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _label = __webpack_require__(1682);
	
	var _label2 = _interopRequireDefault(_label);
	
	var _quillEditor = __webpack_require__(2169);
	
	var _quillEditor2 = _interopRequireDefault(_quillEditor);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	exports.default = function (_ref) {
	  var label = _ref.label;
	  var value = _ref.value;
	  var naked = _ref.naked;
	  var style = _ref.style;
	  var onChange = _ref.onChange;
	
	  var rest = _objectWithoutProperties(_ref, ["label", "value", "naked", "style", "onChange"]);
	
	  return React.createElement(
	    "div",
	    { className: naked ? "naked-quill-editor" : "", style: style },
	    label && React.createElement(
	      _label2.default,
	      null,
	      label
	    ),
	    React.createElement(_quillEditor2.default, _extends({ value: value, onChange: onChange, basic: true }, rest))
	  );
	};
	
	module.exports = exports["default"];

/***/ }),
/* 2675 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _BANNER_STYLE;
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _error = __webpack_require__(948);
	
	var _error2 = _interopRequireDefault(_error);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var BANNER_STYLE = (_BANNER_STYLE = {
	  padding: 10,
	  borderRadius: 10
	}, _defineProperty(_BANNER_STYLE, "padding", "5px 9px"), _defineProperty(_BANNER_STYLE, "border", "1px solid #ffeb3b"), _defineProperty(_BANNER_STYLE, "backgroundColor", "#fff8bd"), _defineProperty(_BANNER_STYLE, "display", "flex"), _defineProperty(_BANNER_STYLE, "alignItems", "center"), _BANNER_STYLE);
	
	var ICON_STYLE = {
	  height: 20,
	  verticalAlign: "-5px",
	  width: 20,
	  minWidth: 20,
	  marginRight: 5,
	  color: "#f9a825"
	};
	
	exports.default = function (_ref) {
	  var type = _ref.type;
	  var style = _ref.style;
	
	  return _react2.default.createElement(
	    "div",
	    { style: Object.assign({}, BANNER_STYLE, style) },
	    _react2.default.createElement(_error2.default, { style: ICON_STYLE }),
	    _react2.default.createElement(
	      "div",
	      null,
	      _react2.default.createElement(
	        "strong",
	        null,
	        "This ",
	        type,
	        " is synchronized from Eventival."
	      ),
	      " Any changes made in Eventival will update the ",
	      type,
	      "."
	    )
	  );
	};
	
	module.exports = exports["default"];

/***/ }),
/* 2676 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _materialUi = __webpack_require__(576);
	
	var _base = __webpack_require__(1755);
	
	var _base2 = _interopRequireDefault(_base);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var styles = {
	  note: {
	    marginTop: "1em",
	    fontSize: "0.8em"
	  }
	};
	
	var InviteContentCreatorOverlay = function (_React$Component) {
	  _inherits(InviteContentCreatorOverlay, _React$Component);
	
	  function InviteContentCreatorOverlay(props) {
	    _classCallCheck(this, InviteContentCreatorOverlay);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(InviteContentCreatorOverlay).call(this, props));
	
	    _this.state = {
	      recipient: "",
	      title_requested_media: []
	    };
	
	    _this.invite = _this.invite.bind(_this);
	    return _this;
	  }
	
	  _createClass(InviteContentCreatorOverlay, [{
	    key: "invite",
	    value: function invite() {
	      this.props.onInvite(this.state.recipient, {
	        title_requested_media: this.state.title_requested_media
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props;
	      var onRequestClose = _props.onRequestClose;
	      var eventBucket = _props.eventBucket;
	      var film = _props.film;
	      var inviteMode = _props.inviteMode;
	
	
	      return _react2.default.createElement(
	        _base2.default,
	        {
	          onRequestClose: onRequestClose,
	          useMuiDefaultStyle: true,
	          actions: [_react2.default.createElement(_materialUi.FlatButton, { label: "Cancel", onTouchTap: onRequestClose }), _react2.default.createElement(_materialUi.FlatButton, {
	            primary: true,
	            label: "Send invite",
	            disabled: !this.state.recipient || inviteMode === "title" && this.state.title_requested_media.length === 0,
	            onTouchTap: this.invite
	          })]
	        },
	        inviteMode === "title" ? _react2.default.createElement(
	          "div",
	          null,
	          "Welcome to the Eventive Print Traffic beta for \"",
	          film.name,
	          "\". Please provide the content creator's email address and the desired assets."
	        ) : _react2.default.createElement(
	          "div",
	          null,
	          "Please enter a recipient for the upload invite to \"",
	          film.name,
	          "\"."
	        ),
	        _react2.default.createElement(_materialUi.TextField, {
	          floatingLabelText: "Content creator email address",
	          floatingLabelFixed: true,
	          value: this.state.recipient,
	          type: "email",
	          onChange: function onChange(e) {
	            return _this2.setState({ recipient: e.target.value });
	          },
	          autoFocus: true
	        }),
	        inviteMode === "title" ? _react2.default.createElement(
	          "div",
	          { style: { marginTop: 10 } },
	          _react2.default.createElement(
	            "div",
	            { style: { marginBottom: 10 } },
	            "What is requested for this title?"
	          ),
	          _react2.default.createElement(_materialUi.Checkbox, {
	            label: "Virtual content",
	            checked: this.state.title_requested_media.includes("virtual"),
	            onCheck: function onCheck(e, checked) {
	              return _this2.setState({
	                title_requested_media: _this2.state.title_requested_media.filter(function (m) {
	                  return m !== "virtual";
	                }).concat(checked ? ["virtual"] : [])
	              });
	            }
	          }),
	          _react2.default.createElement(_materialUi.Checkbox, {
	            label: eventBucket.title_delivery_config.accepted_print_formats.includes("digital_file") ? "Digital file (non-DCP)" : "Print (DCP)",
	            checked: this.state.title_requested_media.includes("print"),
	            onCheck: function onCheck(e, checked) {
	              return _this2.setState({
	                title_requested_media: _this2.state.title_requested_media.filter(function (m) {
	                  return m !== "print";
	                }).concat(checked ? ["print"] : [])
	              });
	            }
	          }),
	          _react2.default.createElement(_materialUi.Checkbox, { label: "Title metadata (coming soon)", disabled: true })
	        ) : null,
	        _react2.default.createElement(
	          "div",
	          { style: styles.note },
	          "The content creator will receive an email invitation to",
	          " ",
	          inviteMode === "title" ? "deliver their assets" : "upload their content",
	          " ",
	          "and grant permissions to \"",
	          eventBucket.name,
	          "\"."
	        )
	      );
	    }
	  }]);
	
	  return InviteContentCreatorOverlay;
	}(_react2.default.Component);
	
	exports.default = InviteContentCreatorOverlay;
	module.exports = exports["default"];

/***/ }),
/* 2677 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _materialUi = __webpack_require__(576);
	
	var _connectToStores = __webpack_require__(1226);
	
	var _connectToStores2 = _interopRequireDefault(_connectToStores);
	
	var _VirtualContentStore = __webpack_require__(1768);
	
	var _VirtualContentStore2 = _interopRequireDefault(_VirtualContentStore);
	
	var _VirtualContentActions = __webpack_require__(1767);
	
	var _VirtualContentActions2 = _interopRequireDefault(_VirtualContentActions);
	
	var _base = __webpack_require__(1755);
	
	var _base2 = _interopRequireDefault(_base);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AddExternalVirtualContentOverlay = function (_React$Component) {
	  _inherits(AddExternalVirtualContentOverlay, _React$Component);
	
	  function AddExternalVirtualContentOverlay(props) {
	    _classCallCheck(this, AddExternalVirtualContentOverlay);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(AddExternalVirtualContentOverlay).call(this, props));
	
	    _this.state = {
	      url: "",
	      permission: false
	    };
	
	    _this.submit = _this.submit.bind(_this);
	    return _this;
	  }
	
	  _createClass(AddExternalVirtualContentOverlay, [{
	    key: "submit",
	    value: function submit() {
	      this.setState({ submitting: true });
	      _VirtualContentActions2.default.create({
	        type: "external",
	        egress_url: this.state.url
	      });
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(newProps) {
	      if (this.props.isCreating && newProps.newVirtualContentId) {
	        this.props.onCreate(_VirtualContentStore2.default.getVirtualContentById(newProps.newVirtualContentId));
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props;
	      var onRequestClose = _props.onRequestClose;
	      var eventBucket = _props.eventBucket;
	      var film = _props.film;
	      var isCreating = _props.isCreating;
	
	
	      return _react2.default.createElement(
	        _base2.default,
	        {
	          onRequestClose: onRequestClose,
	          useMuiDefaultStyle: true,
	          actions: [_react2.default.createElement(_materialUi.FlatButton, { label: "Cancel", onTouchTap: onRequestClose }), _react2.default.createElement(_materialUi.FlatButton, {
	            primary: true,
	            disabled: isCreating || this.state.submitting || !this.state.permission,
	            label: isCreating || this.state.submitting ? "Adding external virtual content..." : "Add external virtual content",
	            onTouchTap: this.submit
	          })]
	        },
	        _react2.default.createElement(
	          "div",
	          null,
	          "Please enter a complete external URL where the ",
	          film.name,
	          " content can be accessed."
	        ),
	        _react2.default.createElement(
	          "div",
	          { style: { marginTop: "1em" } },
	          _react2.default.createElement(
	            "strong",
	            null,
	            "DANGER: External content linked through this pop-up has NO content protection and may be downloaded by viewers. Only virtual content uploaded directly via Eventive Media is secured with MPAA-approved DRM protection.",
	            " ",
	            _react2.default.createElement(
	              "span",
	              { style: { fontStyle: "italic" } },
	              "Proceed with caution."
	            )
	          )
	        ),
	        _react2.default.createElement(_materialUi.TextField, {
	          floatingLabelText: "External virtual content URL",
	          floatingLabelFixed: true,
	          value: this.state.url,
	          style: { width: 400 },
	          placeholder: "https://example.com/my-video",
	          type: "url",
	          onChange: function onChange(e) {
	            return _this2.setState({ url: e.target.value });
	          },
	          autoFocus: true
	        }),
	        _react2.default.createElement(_materialUi.Checkbox, {
	          style: { marginTop: "1em" },
	          value: this.state.permission,
	          onCheck: function onCheck(e, checked) {
	            return _this2.setState({ permission: checked });
	          },
	          label: "I have permission from the content owner to distribute this content with no security in place. I understand that by choosing not to use Eventive Media, my content is not protected."
	        })
	      );
	    }
	  }], [{
	    key: "getStores",
	    value: function getStores() {
	      return [_VirtualContentStore2.default];
	    }
	  }, {
	    key: "getPropsFromStores",
	    value: function getPropsFromStores() {
	      return _VirtualContentStore2.default.getState();
	    }
	  }]);
	
	  return AddExternalVirtualContentOverlay;
	}(_react2.default.Component);
	
	exports.default = (0, _connectToStores2.default)(AddExternalVirtualContentOverlay);
	module.exports = exports["default"];

/***/ }),
/* 2678 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _connectToStores = __webpack_require__(1226);
	
	var _connectToStores2 = _interopRequireDefault(_connectToStores);
	
	var _FilmActions = __webpack_require__(1764);
	
	var _FilmActions2 = _interopRequireDefault(_FilmActions);
	
	var _FilmStore = __webpack_require__(1765);
	
	var _FilmStore2 = _interopRequireDefault(_FilmStore);
	
	var _workingIndicator = __webpack_require__(1664);
	
	var _workingIndicator2 = _interopRequireDefault(_workingIndicator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var NewFilm = function (_React$Component) {
	  _inherits(NewFilm, _React$Component);
	
	  function NewFilm(props) {
	    _classCallCheck(this, NewFilm);
	
	    return _possibleConstructorReturn(this, Object.getPrototypeOf(NewFilm).call(this, props));
	  }
	
	  _createClass(NewFilm, [{
	    key: "componentWillMount",
	    value: function componentWillMount() {
	      _FilmActions2.default.create({
	        name: "",
	        event_bucket: this.props.params.eventBucketId
	      });
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(props) {
	      if (props.newFilmId) {
	        this.context.router.replace("/event_buckets/" + props.params.eventBucketId + "/films/" + props.newFilmId + "/edit");
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement(_workingIndicator2.default, { fullPage: true });
	    }
	  }], [{
	    key: "getStores",
	    value: function getStores() {
	      return [_FilmStore2.default];
	    }
	  }, {
	    key: "getPropsFromStores",
	    value: function getPropsFromStores() {
	      return {
	        newFilmId: _FilmStore2.default.getState().newFilmId
	      };
	    }
	  }, {
	    key: "contextTypes",
	    get: function get() {
	      return {
	        router: _react2.default.PropTypes.object
	      };
	    }
	  }]);
	
	  return NewFilm;
	}(_react2.default.Component);
	
	exports.default = (0, _connectToStores2.default)(NewFilm);
	module.exports = exports["default"];

/***/ }),
/* 2679 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _values = __webpack_require__(1214);
	
	var _values2 = _interopRequireDefault(_values);
	
	var _pickBy = __webpack_require__(1163);
	
	var _pickBy2 = _interopRequireDefault(_pickBy);
	
	var _materialUi = __webpack_require__(576);
	
	var _reactable = __webpack_require__(1688);
	
	var _eventTable = __webpack_require__(2680);
	
	var _eventTable2 = _interopRequireDefault(_eventTable);
	
	var _connectToStores = __webpack_require__(1226);
	
	var _connectToStores2 = _interopRequireDefault(_connectToStores);
	
	var _EventActions = __webpack_require__(2031);
	
	var _EventActions2 = _interopRequireDefault(_EventActions);
	
	var _EventStore = __webpack_require__(2032);
	
	var _EventStore2 = _interopRequireDefault(_EventStore);
	
	var _config = __webpack_require__(1173);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _UserStore = __webpack_require__(974);
	
	var _UserStore2 = _interopRequireDefault(_UserStore);
	
	var _workingIndicator = __webpack_require__(1664);
	
	var _workingIndicator2 = _interopRequireDefault(_workingIndicator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Events = function (_React$Component) {
	  _inherits(Events, _React$Component);
	
	  function Events(props) {
	    _classCallCheck(this, Events);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(Events).call(this, props));
	
	    _this.state = {
	      showScanCounts: false
	    };
	
	    _this._onShowScanCountsCheck = _this._onShowScanCountsCheck.bind(_this);
	    _this._onRefresh = _this._onRefresh.bind(_this);
	    return _this;
	  }
	
	  _createClass(Events, [{
	    key: "getStyles",
	    value: function getStyles() {
	      return {};
	    }
	  }, {
	    key: "_onShowScanCountsCheck",
	    value: function _onShowScanCountsCheck(checked) {
	      this.setState({
	        showScanCounts: checked
	      });
	
	      if (checked) {
	        _EventActions2.default.fetchAllForBucket(this.props.params.eventBucketId,
	        /* includeScanCounts */true);
	      }
	    }
	  }, {
	    key: "_onRefresh",
	    value: function _onRefresh() {
	      _EventActions2.default.fetchAllForBucket(this.props.params.eventBucketId, this.state.showScanCounts);
	    }
	  }, {
	    key: "downloadCsv",
	    value: function downloadCsv() {
	      window.open(_config2.default.endpoint + "event_buckets/" + this.props.params.eventBucketId + "/events.csv?" + _UserStore2.default.makeApiKeyQueryString() + "&conditions={\"is_virtual\":true}", "_blank");
	    }
	  }, {
	    key: "componentWillMount",
	    value: function componentWillMount() {
	      _EventActions2.default.fetchAllForBucket(this.props.params.eventBucketId);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var styles = this.getStyles(),
	          bucket = this.props.params.eventBucketId,
	          events = (0, _values2.default)((0, _pickBy2.default)(this.props.events, function (e) {
	        return e.event_bucket === bucket && e.is_virtual;
	      }));
	
	      if (events.length === 0 && _EventStore2.default.getState().isFetching) {
	        return _react2.default.createElement(_workingIndicator2.default, { fullPage: true });
	      }
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(_eventTable2.default, {
	          virtual: true,
	          eventBucket: bucket,
	          events: events,
	          onShowScanCountsCheck: this._onShowScanCountsCheck,
	          onRefresh: this._onRefresh,
	          isRefreshing: this.props.isFetching,
	          createButton: _UserStore2.default.hasPermission("manage_virtual_festival") ? _react2.default.createElement(
	            "span",
	            null,
	            _react2.default.createElement(_materialUi.RaisedButton, {
	              label: "Create new virtual screening",
	              primary: true,
	              onTouchTap: function onTouchTap() {
	                return _this2.context.router.push("/event_buckets/" + _this2.props.params.eventBucketId + "/events/new?virtual=true");
	              }
	            }),
	            _react2.default.createElement(_materialUi.RaisedButton, {
	              style: { marginLeft: 7 },
	              onTouchTap: function onTouchTap() {
	                return _this2.downloadCsv();
	              },
	              label: "Download all (.csv)"
	            })
	          ) : null
	        })
	      );
	    }
	  }], [{
	    key: "getStores",
	    value: function getStores() {
	      return [_EventStore2.default];
	    }
	  }, {
	    key: "getPropsFromStores",
	    value: function getPropsFromStores() {
	      return _EventStore2.default.getState();
	    }
	  }, {
	    key: "contextTypes",
	    get: function get() {
	      return {
	        router: _react2.default.PropTypes.object
	      };
	    }
	  }]);
	
	  return Events;
	}(_react2.default.Component);
	
	exports.default = (0, _connectToStores2.default)(Events);
	module.exports = exports["default"];

/***/ }),
/* 2680 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _values = __webpack_require__(1214);
	
	var _values2 = _interopRequireDefault(_values);
	
	var _pickBy = __webpack_require__(1163);
	
	var _pickBy2 = _interopRequireDefault(_pickBy);
	
	var _moment = __webpack_require__(1021);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _twix = __webpack_require__(2312);
	
	var _twix2 = _interopRequireDefault(_twix);
	
	var _reactRouter = __webpack_require__(486);
	
	var _materialUi = __webpack_require__(576);
	
	var _reactable = __webpack_require__(1688);
	
	var _UserStore = __webpack_require__(974);
	
	var _UserStore2 = _interopRequireDefault(_UserStore);
	
	var _util = __webpack_require__(1183);
	
	var _tableRefreshIndicator = __webpack_require__(1686);
	
	var _tableRefreshIndicator2 = _interopRequireDefault(_tableRefreshIndicator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var EventTable = function (_React$Component) {
	  _inherits(EventTable, _React$Component);
	
	  function EventTable(props) {
	    _classCallCheck(this, EventTable);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(EventTable).call(this, props));
	
	    _this.state = {
	      showScanCounts: false,
	      showNonTicketed: true
	    };
	
	    _this._onShowScanCountsCheck = _this._onShowScanCountsCheck.bind(_this);
	    _this._onShowNonTicketedCheck = _this._onShowNonTicketedCheck.bind(_this);
	    _this._refresh = _this._refresh.bind(_this);
	    _this._makeRowForEvent = _this._makeRowForEvent.bind(_this);
	    return _this;
	  }
	
	  _createClass(EventTable, [{
	    key: "_onShowScanCountsCheck",
	    value: function _onShowScanCountsCheck(e) {
	      var show = !this.state.showScanCounts;
	      this.setState({
	        showScanCounts: show
	      });
	      this.props.onShowScanCountsCheck(show);
	    }
	  }, {
	    key: "_onShowNonTicketedCheck",
	    value: function _onShowNonTicketedCheck(e) {
	      this.setState({
	        showNonTicketed: !this.state.showNonTicketed
	      });
	    }
	  }, {
	    key: "_refresh",
	    value: function _refresh() {
	      this.props.onRefresh();
	    }
	  }, {
	    key: "getStyles",
	    value: function getStyles() {
	      return {};
	    }
	  }, {
	    key: "_makeRowForEvent",
	    value: function _makeRowForEvent(event, isPast) {
	      var soldTickets = event.quantity_sold,
	          percentSold = soldTickets / event.quantity * 100 || 0,
	          percentScanned = event.quantity_scanned / soldTickets * 100 || 0;
	
	      return _react2.default.createElement(
	        _reactable.Tr,
	        { key: event.id },
	        _react2.default.createElement(
	          _reactable.Td,
	          { column: "Name" },
	          event.name
	        ),
	        _react2.default.createElement(
	          _reactable.Td,
	          { column: "Venue", value: event.venue && event.venue.name },
	          event.venue && event.venue.name ? event.venue.name : ""
	        ),
	        _react2.default.createElement(
	          _reactable.Td,
	          { column: "Date", value: event.start_time || "-" },
	          (0, _util.makeEventDateRangeLabel)(event)
	        ),
	        _react2.default.createElement(
	          _reactable.Td,
	          { column: "Tickets Sold", value: soldTickets },
	          event.unlimited ? soldTickets + "/\u221E" : soldTickets + "/" + event.quantity
	        ),
	        _react2.default.createElement(
	          _reactable.Td,
	          { column: "% Sold", value: event.unlimited ? -1 : percentSold },
	          event.unlimited ? "n/a" : percentSold.toFixed(1) + "%"
	        ),
	        this.state.showScanCounts ? _react2.default.createElement(
	          _reactable.Td,
	          { column: "Tickets Scanned", value: event.quantity_scanned },
	          event.quantity_scanned + "/" + soldTickets
	        ) : null,
	        this.state.showScanCounts ? _react2.default.createElement(
	          _reactable.Td,
	          { column: "% Scanned", value: soldTickets ? percentScanned : -1 },
	          soldTickets ? percentScanned.toFixed(1) + "%" : "n/a"
	        ) : null,
	        _react2.default.createElement(
	          _reactable.Td,
	          { column: "Actions" },
	          _react2.default.createElement(
	            "div",
	            null,
	            _UserStore2.default.hasRole("film_preview") && isPast ? null : _UserStore2.default.hasPermission("view_virtual_event") || _UserStore2.default.hasPermission("view_physical_event") ? _react2.default.createElement(
	              _reactRouter.Link,
	              {
	                to: {
	                  pathname: "/event_buckets/" + event.event_bucket + "/" + (this.props.virtual ? "virtual_festival/" : "") + "events/" + event.id,
	                  state: { fromListing: true }
	                }
	              },
	              "View"
	            ) : null,
	            "\xA0",
	            _UserStore2.default.hasPermission("edit_virtual_event") || _UserStore2.default.hasPermission("edit_physical_event") ? _react2.default.createElement(
	              _reactRouter.Link,
	              {
	                to: {
	                  pathname: "/event_buckets/" + event.event_bucket + "/" + (this.props.virtual ? "virtual_festival/" : "") + "events/" + event.id + "/edit",
	                  state: { fromListing: true }
	                }
	              },
	              "Edit"
	            ) : null
	          )
	        )
	      );
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var styles = this.getStyles();
	      var showNonTicketed = this.state.showNonTicketed;
	      var events = (0, _values2.default)((0, _pickBy2.default)(this.props.events, function (e) {
	        if (!showNonTicketed && e.ticket_buckets.length === 0) {
	          return false;
	        }
	        if (e.name === "Unnamed Event" && !e.ticket_buckets.length) {
	          // Filter out created but never edited "accident" events
	          return false;
	        }
	        return true;
	      }));
	
	      var upcomingEvents = events.filter(function (e) {
	        return !e.is_dated || !e.start_time || !e.end_time || e.end_time === e.start_time || new Date(e.end_time) > Date.now();
	      }),
	          pastEvents = events.filter(function (e) {
	        return upcomingEvents.indexOf(e) === -1;
	      });
	
	      var tableProps = {
	        className: "bordered striped responsive-table",
	        sortable: ["Date", "Name", "Venue", "Tickets Sold", "% Sold", "Tickets Scanned", "% Scanned"],
	        defaultSort: this.props.virtual ? { column: "Name", direction: "asc" } : { column: "Date", direction: "asc" },
	        columns: ["Name"].concat(this.props.virtual ? [{ key: "Date", label: "Availability" }] : ["Venue", "Date"]).concat(["Tickets Sold", "% Sold"]).concat(this.state.showScanCounts ? ["Tickets Scanned", "% Scanned"] : []),
	        filterable: ["Name"]
	      };
	
	      var tablePropsPast = Object.assign({}, tableProps);
	      if (_UserStore2.default.hasPermission("view_virtual_event") || _UserStore2.default.hasPermission("edit_virtual_event") || _UserStore2.default.hasPermission("view_physical_event") || _UserStore2.default.hasPermission("edit_physical_event")) {
	        tableProps.columns = tableProps.columns.concat(["Actions"]);
	      }
	
	      if (_UserStore2.default.hasPermission("edit_virtual_event") || _UserStore2.default.hasPermission("view_physical_event") || _UserStore2.default.hasPermission("edit_physical_event") || _UserStore2.default.hasPermission("view_virtual_event") && !_UserStore2.default.hasRole("film_preview")) {
	        tablePropsPast.columns = tablePropsPast.columns.concat(["Actions"]);
	      }
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          "style",
	          null,
	          "\n          .reactable-filterer input {\n            width: 250px;\n          }\n        "
	        ),
	        _react2.default.createElement(
	          "div",
	          { style: styles.config },
	          _react2.default.createElement(
	            "div",
	            { style: { float: "left", width: 300 } },
	            _react2.default.createElement(_materialUi.Checkbox, {
	              checked: this.state.showScanCounts,
	              label: "Show ticket scan counts",
	              onCheck: function onCheck(e) {
	                return _this2._onShowScanCountsCheck(e, !e.target.checked);
	              }
	            }),
	            _react2.default.createElement(_materialUi.Checkbox, {
	              checked: this.state.showNonTicketed,
	              label: "Show non-ticketed " + (this.props.virtual ? "screenings" : "events"),
	              onCheck: function onCheck(e) {
	                return _this2._onShowNonTicketedCheck(e, !e.target.checked);
	              }
	            })
	          ),
	          _react2.default.createElement(_tableRefreshIndicator2.default, {
	            isRefreshing: this.props.isRefreshing,
	            onRefresh: this._refresh
	          })
	        ),
	        upcomingEvents.length ? _react2.default.createElement(
	          _reactable.Table,
	          _extends({}, tableProps, {
	            filterPlaceholder: "Type to filter upcoming " + (this.props.virtual ? "screenings" : "events") + "..."
	          }),
	          upcomingEvents.map(function (ue) {
	            return _this2._makeRowForEvent(ue, false);
	          })
	        ) : null,
	        this.props.createButton && upcomingEvents.length ? _react2.default.createElement(
	          "div",
	          { style: { marginTop: "1em" } },
	          this.props.createButton
	        ) : null,
	        !upcomingEvents.length || pastEvents.length ? _react2.default.createElement(
	          "div",
	          null,
	          upcomingEvents.length ? _react2.default.createElement(
	            "h2",
	            {
	              style: Object.assign({ textAlign: "center", marginTop: "1.5em" }, this.props.headerStyle)
	            },
	            "Past events"
	          ) : null,
	          _react2.default.createElement(
	            _reactable.Table,
	            _extends({}, tablePropsPast, {
	              filterPlaceholder: "Type to filter " + (this.props.virtual ? "past screenings" : "events") + "..."
	            }),
	            pastEvents.map(function (pe) {
	              return _this2._makeRowForEvent(pe, true);
	            })
	          )
	        ) : null,
	        pastEvents.length === 0 && upcomingEvents.length === 0 ? _react2.default.createElement(
	          "div",
	          { className: "empty-table-message" },
	          "No ",
	          this.props.virtual ? "virtual screenings" : "events",
	          " yet.",
	          " ",
	          _react2.default.createElement(
	            _reactRouter.Link,
	            {
	              to: "/event_buckets/" + this.props.eventBucket + "/events/new" + (this.props.virtual ? "?virtual=true" : "")
	            },
	            "Create a new ",
	            this.props.virtual ? "virtual screening" : "event",
	            "."
	          )
	        ) : null,
	        this.props.createButton && !upcomingEvents.length ? _react2.default.createElement(
	          "div",
	          { style: { marginTop: "1em" } },
	          this.props.createButton
	        ) : null
	      );
	    }
	  }]);
	
	  return EventTable;
	}(_react2.default.Component);
	
	exports.default = EventTable;
	module.exports = exports["default"];

/***/ }),
/* 2681 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _values = __webpack_require__(1214);
	
	var _values2 = _interopRequireDefault(_values);
	
	var _pickBy = __webpack_require__(1163);
	
	var _pickBy2 = _interopRequireDefault(_pickBy);
	
	var _reactRouter = __webpack_require__(486);
	
	var _materialUi = __webpack_require__(576);
	
	var _reactable = __webpack_require__(1688);
	
	var _filmTable = __webpack_require__(1763);
	
	var _filmTable2 = _interopRequireDefault(_filmTable);
	
	var _connectToStores = __webpack_require__(1226);
	
	var _connectToStores2 = _interopRequireDefault(_connectToStores);
	
	var _FilmActions = __webpack_require__(1764);
	
	var _FilmActions2 = _interopRequireDefault(_FilmActions);
	
	var _FilmStore = __webpack_require__(1765);
	
	var _FilmStore2 = _interopRequireDefault(_FilmStore);
	
	var _config = __webpack_require__(1173);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _UserStore = __webpack_require__(974);
	
	var _UserStore2 = _interopRequireDefault(_UserStore);
	
	var _workingIndicator = __webpack_require__(1664);
	
	var _workingIndicator2 = _interopRequireDefault(_workingIndicator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Films = function (_React$Component) {
	  _inherits(Films, _React$Component);
	
	  function Films(props) {
	    _classCallCheck(this, Films);
	
	    return _possibleConstructorReturn(this, Object.getPrototypeOf(Films).call(this, props));
	  }
	
	  _createClass(Films, [{
	    key: "getStyles",
	    value: function getStyles() {
	      return {};
	    }
	  }, {
	    key: "componentWillMount",
	    value: function componentWillMount() {
	      _FilmActions2.default.fetchAllForCreator();
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var styles = this.getStyles(),
	          films = (0, _values2.default)((0, _pickBy2.default)(this.props.films, function (f) {
	        return f.event_bucket === _this2.props.params.eventBucketId && f.type === "livestream";
	      }));
	
	      if (films.length === 0 && _FilmStore2.default.getState().isFetching) {
	        return _react2.default.createElement(_workingIndicator2.default, { fullPage: true });
	      }
	
	      var upcomingFilms = films.filter(function (f) {
	        return f.virtual_content && ["livestream_not_created", "livestream_creating", "livestream_created"].indexOf(f.virtual_content.status) !== -1 && (!f.end_time || new Date() < new Date(f.end_time));
	      });
	      var completedFilms = films.filter(function (f) {
	        return upcomingFilms.indexOf(f) === -1 && f.virtual_content;
	      });
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          "p",
	          { style: { fontSize: "11pt" } },
	          "Welcome to the Livestreaming Hub. After creating a screening that contains a livestream in your",
	          " ",
	          _react2.default.createElement(
	            _reactRouter.Link,
	            {
	              to: "/event_buckets/" + this.props.params.eventBucketId + "/virtual_festival"
	            },
	            "Virtual screenings"
	          ),
	          ", you can manage that stream here."
	        ),
	        _react2.default.createElement(_filmTable2.default, {
	          films: upcomingFilms,
	          eventBucket: this.props.params.eventBucketId,
	          livestreamView: true
	        }),
	        completedFilms.length ? _react2.default.createElement(
	          "div",
	          { style: { marginTop: "2em" } },
	          _react2.default.createElement(
	            "h2",
	            null,
	            "Past livestreams"
	          ),
	          _react2.default.createElement(_filmTable2.default, {
	            films: completedFilms,
	            eventBucket: this.props.params.eventBucketId,
	            livestreamView: true
	          })
	        ) : null
	      );
	    }
	  }], [{
	    key: "getStores",
	    value: function getStores() {
	      return [_UserStore2.default, _FilmStore2.default];
	    }
	  }, {
	    key: "getPropsFromStores",
	    value: function getPropsFromStores() {
	      return _FilmStore2.default.getState();
	    }
	  }, {
	    key: "contextTypes",
	    get: function get() {
	      return {
	        router: _react2.default.PropTypes.object
	      };
	    }
	  }]);
	
	  return Films;
	}(_react2.default.Component);
	
	exports.default = (0, _connectToStores2.default)(Films);
	module.exports = exports["default"];

/***/ }),
/* 2682 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _filmTable = __webpack_require__(1763);
	
	var _connectToStores = __webpack_require__(1226);
	
	var _connectToStores2 = _interopRequireDefault(_connectToStores);
	
	var _FilmActions = __webpack_require__(1764);
	
	var _FilmActions2 = _interopRequireDefault(_FilmActions);
	
	var _FilmStore = __webpack_require__(1765);
	
	var _FilmStore2 = _interopRequireDefault(_FilmStore);
	
	var _VirtualContentActions = __webpack_require__(1767);
	
	var _VirtualContentActions2 = _interopRequireDefault(_VirtualContentActions);
	
	var _UserStore = __webpack_require__(974);
	
	var _UserStore2 = _interopRequireDefault(_UserStore);
	
	var _EventBucketStore = __webpack_require__(1593);
	
	var _EventBucketStore2 = _interopRequireDefault(_EventBucketStore);
	
	var _VirtualContentStore = __webpack_require__(1768);
	
	var _VirtualContentStore2 = _interopRequireDefault(_VirtualContentStore);
	
	var _VirtualContentUtil = __webpack_require__(1769);
	
	var _VirtualContentUtil2 = _interopRequireDefault(_VirtualContentUtil);
	
	var _juration = __webpack_require__(1772);
	
	var _juration2 = _interopRequireDefault(_juration);
	
	var _inlineNoticeLabel = __webpack_require__(1222);
	
	var _inlineNoticeLabel2 = _interopRequireDefault(_inlineNoticeLabel);
	
	var _workingIndicator = __webpack_require__(1664);
	
	var _workingIndicator2 = _interopRequireDefault(_workingIndicator);
	
	var _moment = __webpack_require__(1021);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _materialUi = __webpack_require__(576);
	
	var _chatWidget = __webpack_require__(2683);
	
	var _chatWidget2 = _interopRequireDefault(_chatWidget);
	
	var _label = __webpack_require__(1682);
	
	var _label2 = _interopRequireDefault(_label);
	
	var _liveEventDiagnostics = __webpack_require__(2684);
	
	var _liveEventDiagnostics2 = _interopRequireDefault(_liveEventDiagnostics);
	
	var _chatReviewQueue = __webpack_require__(2685);
	
	var _chatReviewQueue2 = _interopRequireDefault(_chatReviewQueue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var THREESIXTY_VR_ENABLED = true;
	
	var Film = function (_React$Component) {
	  _inherits(Film, _React$Component);
	
	  function Film(props) {
	    _classCallCheck(this, Film);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(Film).call(this, props));
	
	    _this.state = {
	      isEditing: false,
	      isExporting: false,
	      pinging: false,
	      checkCountdown: null
	    };
	    return _this;
	  }
	
	  _createClass(Film, [{
	    key: "getStyles",
	    value: function getStyles() {
	      return {
	        flexContainer: {
	          display: "flex",
	          gap: "20px" // Adds spacing between columns
	        },
	        leftPane: {
	          maxWidth: 700,
	          flex: 1
	        },
	        rightPane: {
	          maxWidth: 700,
	          flex: 1
	        }
	      };
	    }
	  }, {
	    key: "pingUntilStatuses",
	    value: function pingUntilStatuses(statuses) {
	      var _this2 = this;
	
	      var ping = function ping() {
	        var film = _FilmStore2.default.getFilmById(_this2.props.params.filmId);
	        if (film && film.virtual_content && statuses.indexOf(film.virtual_content.status) > -1) {
	          // Done
	          _this2.setState({ pinging: false, isEditing: false });
	        } else {
	          _FilmActions2.default.fetchOne(_this2.props.params.filmId);
	          _this2.pingTimeout = setTimeout(function () {
	            return ping();
	          }, 4000);
	        }
	      };
	      this.pingTimeout = setTimeout(function () {
	        return ping();
	      }, 4000);
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      if (this.pingTimeout) {
	        clearTimeout(this.pingTimeout);
	      }
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate() {
	      var _this3 = this;
	
	      var film = _FilmStore2.default.getFilmById(this.props.params.filmId);
	      if (!this.state.pinging && film && film.virtual_content) {
	        if (film.virtual_content.status === "livestream_creating" || film.virtual_content.status === "livestream_previewing_creating") {
	          this.setState({ pinging: true }, function () {
	            _this3.pingUntilStatuses(["livestream_create_failure", "livestream_created"]);
	          });
	        } else if (film.virtual_content.status === "livestream_creating_preview") {
	          this.setState({ pinging: true }, function () {
	            _this3.pingUntilStatuses(["livestream_create_failure", "livestream_previewing"]);
	          });
	        } else if (film && film.virtual_content && film.virtual_content.status === "livestream_stopping") {
	          this.setState({ pinging: true }, function () {
	            _this3.pingUntilStatuses(["livestream_stop_failure", "livestream_publish_failure", "livestream_stopped"]);
	          });
	        }
	      }
	    }
	  }, {
	    key: "startStreaming",
	    value: function startStreaming(id, toPreview) {
	      var _this4 = this;
	
	      this.setState({ pinging: true, isEditing: true }, function () {
	        _VirtualContentActions2.default.startStreaming(id);
	        _this4.pingUntilStatuses(["livestream_create_failure", "livestream_created"].concat(toPreview ? ["livestream_previewing"] : []));
	      });
	    }
	  }, {
	    key: "stopStreaming",
	    value: function stopStreaming(id) {
	      var _this5 = this;
	
	      this.setState({ pinging: true, isEditing: true }, function () {
	        _VirtualContentActions2.default.stopStreaming(id);
	        _this5.pingUntilStatuses(["livestream_stop_failure", "livestream_publish_failure", "livestream_stopped"]);
	      });
	    }
	  }, {
	    key: "generateManifest",
	    value: function generateManifest(id) {
	      _VirtualContentActions2.default.generateManifest(id);
	    }
	  }, {
	    key: "export",
	    value: function _export(id) {
	      var _this6 = this;
	
	      this.setState({ isExporting: true });
	      _VirtualContentUtil2.default.export(_UserStore2.default.getState().apiKey, id).then(function (res) {
	        _this6.setState({ isExporting: false });
	        if (res.export_url) {
	          _this6.setState({ showExportUrlModal: res.export_url });
	        } else if (res.export_status === "export_in_progress") {
	          _this6.checkInProgressExport(id);
	        }
	        _FilmActions2.default.fetchOne(_this6.props.params.filmId);
	      }).catch(function (e) {
	        _this6.setState({ isExporting: false });
	        window.alert("Failed to export: " + e.message);
	      });
	    }
	  }, {
	    key: "checkInProgressExport",
	    value: function checkInProgressExport(id, continuing) {
	      var _this7 = this;
	
	      var checkCountdown = this.state.checkCountdown;
	
	      if (continuing && checkCountdown === 1) {
	        this.export(id);
	      } else {
	        this.setState({ checkCountdown: continuing ? checkCountdown - 1 : 10 });
	        setTimeout(function () {
	          return _this7.checkInProgressExport(id, true);
	        }, 1000);
	      }
	    }
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      _FilmActions2.default.fetchOne(this.props.params.filmId);
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(props) {
	      if (!props.isEditing && this.props.isEditing) {
	        _FilmActions2.default.fetchOne(this.props.params.filmId);
	      }
	      var film = _FilmStore2.default.getFilmById(this.props.params.filmId);
	      if (film && film.virtual_content && film.virtual_content.export_status === "export_in_progress" && this.state.checkCountdown === null) {
	        this.checkInProgressExport(film.virtual_content.id);
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this8 = this;
	
	      var styles = this.getStyles();
	      var film = _FilmStore2.default.getFilmById(this.props.params.filmId);
	      var eventBucket = this.props.getEventBucketById(this.props.params.eventBucketId);
	
	      if (!film || !eventBucket) {
	        return _react2.default.createElement(_workingIndicator2.default, { fullPage: true });
	      }
	
	      var intro = _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          "h1",
	          null,
	          "Livestreaming for ",
	          film.name
	        ),
	        _react2.default.createElement(
	          "p",
	          { style: { fontSize: "11pt" } },
	          "Scheduled start: ",
	          (0, _moment2.default)(film.start_time).format("LLL"),
	          _react2.default.createElement("br", null),
	          "Scheduled end: ",
	          (0, _moment2.default)(film.end_time).format("LLL"),
	          _UserStore2.default.isGod() ? _react2.default.createElement(
	            "span",
	            null,
	            _react2.default.createElement("br", null),
	            "Virtual content ID: ",
	            film.virtual_content.id,
	            " ",
	            film.virtual_content.ev_next_encoding_id && _react2.default.createElement(
	              "span",
	              null,
	              _react2.default.createElement(
	                "a",
	                {
	                  href: "https://dashboard.bitmovin.com/live/encodings/" + film.virtual_content.ev_next_encoding_id,
	                  target: "_blank"
	                },
	                "View in Bitmovin"
	              ),
	              " "
	            ),
	            _react2.default.createElement(_inlineNoticeLabel2.default, {
	              label: "God",
	              style: {
	                verticalAlign: 3,
	                marginLeft: 4,
	                fontWeight: "bold"
	              }
	            })
	          ) : null
	        ),
	        _UserStore2.default.isGod() && film.virtual_content.type === "livestream" && ["ready", "livestream_publish_failure", "livestream_stopped"].includes(film.virtual_content.status) && _react2.default.createElement(_materialUi.RaisedButton, {
	          label: _react2.default.createElement(
	            "span",
	            null,
	            "Re-generate manifest",
	            " ",
	            _react2.default.createElement(_inlineNoticeLabel2.default, { style: { marginLeft: 5 }, label: "God" })
	          ),
	          disabled: this.state.isEditing,
	          style: { marginBottom: "2em" },
	          onTouchTap: function onTouchTap() {
	            return _this8.generateManifest(film.virtual_content.id);
	          }
	        })
	      );
	
	      if (!film.virtual_content || film.livestream_mode !== "eventive") {
	        var noticeStyle = {
	          border: "2px dashed #ccc",
	          borderRadius: 5,
	          padding: "1em",
	          fontSize: "13pt",
	          display: "inline-block",
	          maxWidth: 450
	        };
	        return _react2.default.createElement(
	          "div",
	          null,
	          intro,
	          film.livestream_mode === "embedded" ? _react2.default.createElement(
	            "div",
	            { style: noticeStyle },
	            "This is an ",
	            _react2.default.createElement(
	              "i",
	              null,
	              "embedded livestream"
	            ),
	            ". This means that the content will automatically play from the embedded source, but no Eventive content protection or security will be applied. You can configure the source via the ",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "Virtual screening editor"
	            ),
	            "."
	          ) : film.livestream_mode === "external" ? _react2.default.createElement(
	            "div",
	            { style: noticeStyle },
	            "This is an ",
	            _react2.default.createElement(
	              "i",
	              null,
	              "external instructions livestream"
	            ),
	            ". This means that no player will be accessible directly on the Eventive site. You can configure the instructions that are displayed via the",
	            " ",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "Virtual screening editor"
	            ),
	            "."
	          ) : _react2.default.createElement(
	            "div",
	            { style: noticeStyle },
	            "Livestreaming has not been enabled for this event."
	          )
	        );
	      }
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        this.state.showExportUrlModal ? _react2.default.createElement(
	          _materialUi.Dialog,
	          {
	            title: "Your download is ready",
	            actions: [_react2.default.createElement(_materialUi.FlatButton, {
	              label: "Close",
	              onTouchTap: function onTouchTap() {
	                return _this8.setState({ showExportUrlModal: false });
	              }
	            })],
	            modal: true,
	            open: true,
	            onRequestClose: function onRequestClose() {
	              return _this8.setState({ showExportUrlModal: false });
	            }
	          },
	          _react2.default.createElement(
	            "div",
	            null,
	            "Your media has been prepared. In order to ensure your browser downloads the file and doesn't attempt to play it,",
	            " ",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "right-click the button below and select \"Save link as...\"."
	            )
	          ),
	          _react2.default.createElement(_materialUi.RaisedButton, {
	            style: { marginTop: "1em" },
	            download: "eventive-livestream-export-" + film.virtual_content.id + ".mp4",
	            primary: true,
	            href: this.state.showExportUrlModal,
	            target: "_blank",
	            label: "Download media (right-click)",
	            onClick: function onClick(e) {
	              e.preventDefault();
	              window.alert('Please right-click the button and select "Save link as..." to ensure your browser does not attempt to play the media in a new tab.');
	            }
	          }),
	          _react2.default.createElement(
	            "div",
	            { style: { marginTop: "1em" } },
	            "Having issues with the export? Please get in touch using the chat widget in the lower righthand corner of your screen."
	          )
	        ) : null,
	        intro,
	        _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement(
	            _materialUi.Paper,
	            {
	              style: {
	                // border: "2px dashed #ccc",
	                borderRadius: 15,
	                padding: "0 1em",
	                fontSize: "13pt",
	                display: "inline-block",
	                minWidth: 400
	              }
	            },
	            film.virtual_content.livestream_preview_egress_url && ["livestream_previewing", "livestream_created"].includes(film.virtual_content.status) ? _react2.default.createElement(
	              "div",
	              {
	                style: {
	                  float: "right",
	                  width: 500,
	                  height: 280,
	                  paddingTop: "1em",
	                  paddingLeft: "2em",
	                  paddingBottom: "1em"
	                }
	              },
	              _react2.default.createElement("iframe", {
	                style: {
	                  width: "100%",
	                  height: "100%"
	                },
	                frameBorder: "0",
	                scrolling: "no",
	                allow: "autoplay; encrypted-media; fullscreen",
	                src: ("https://watch.eventive.org/") + "admin/livepreview?url=" + encodeURIComponent(film.virtual_content.livestream_preview_egress_url)
	              })
	            ) : null,
	            _react2.default.createElement(
	              "p",
	              null,
	              _react2.default.createElement(
	                "strong",
	                null,
	                "Status:"
	              ),
	              " ",
	              _react2.default.createElement(_filmTable.Status, { virtual_content: film.virtual_content })
	            ),
	            film.virtual_content.type === "broadcast" ? _react2.default.createElement(
	              "p",
	              null,
	              "This is a VOD real-time broadcast. It will start and end automatically."
	            ) : ["livestream_created", "livestream_previewing", "livestream_previewing_creating", "livestream_stopping", "livestream_stop_failure"].indexOf(film.virtual_content.status) > -1 && _react2.default.createElement(
	              "p",
	              { style: { wordBreak: "break-word" } },
	              _react2.default.createElement(
	                "strong",
	                null,
	                "RTMP url:"
	              ),
	              " ",
	              film.virtual_content.livestream_ingest_urls && film.virtual_content.livestream_ingest_urls.length ? film.virtual_content.livestream_ingest_urls.slice(0, 1).map(function (e) {
	                return _react2.default.createElement(
	                  "div",
	                  null,
	                  e
	                );
	              }) : "none",
	              _react2.default.createElement("br", null),
	              _react2.default.createElement(
	                "strong",
	                null,
	                "Stream key:"
	              ),
	              " ",
	              film.virtual_content.livestream_stream_key || "default"
	            ),
	            film.virtual_content.status === "livestream_previewing" ? _react2.default.createElement(
	              "p",
	              null,
	              _react2.default.createElement(
	                "strong",
	                null,
	                "You're live in the Preview Window and billing is active. When you're ready to stream to your audience, click below to go live!"
	              ),
	              _react2.default.createElement(
	                "div",
	                { style: { marginTop: "0.5em", fontSize: "0.75em" } },
	                "After clicking, it may take up to 30 seconds to go live."
	              ),
	              _react2.default.createElement(
	                "div",
	                { style: { marginTop: "1em" } },
	                _react2.default.createElement(_materialUi.RaisedButton, {
	                  label: "Go live to audience",
	                  primary: true,
	                  disabled: this.state.isEditing,
	                  onTouchTap: function onTouchTap() {
	                    return _this8.startStreaming(film.virtual_content.id);
	                  }
	                }),
	                _react2.default.createElement(_materialUi.RaisedButton, {
	                  style: { marginLeft: 7 },
	                  label: "Abort stream permanently",
	                  primary: false,
	                  disabled: this.state.isEditing,
	                  onTouchTap: function onTouchTap() {
	                    if (window.confirm("Are you sure? You can never start this livestream again.")) {
	                      _this8.stopStreaming(film.virtual_content.id);
	                    }
	                  }
	                })
	              )
	            ) : film.virtual_content.status === "livestream_created" ? _react2.default.createElement(
	              "p",
	              null,
	              _react2.default.createElement(
	                "strong",
	                null,
	                "You're live now and streaming to your audience! When your event has concluded, click below to stop streaming."
	              )
	            ) : null,
	            film.virtual_content.type !== "broadcast" && ["livestream_not_created", "livestream_create_failure"].indexOf(film.virtual_content.status) > -1 && _react2.default.createElement(
	              "div",
	              null,
	              _react2.default.createElement(
	                "div",
	                {
	                  style: {
	                    fontSize: "10pt",
	                    margin: "-0.5em 0 1em 0",
	                    maxWidth: 500
	                  }
	                },
	                _react2.default.createElement(
	                  "div",
	                  null,
	                  _react2.default.createElement(
	                    _label2.default,
	                    null,
	                    "Livestream mode"
	                  ),
	                  _react2.default.createElement(
	                    _materialUi.RadioButtonGroup,
	                    {
	                      name: "drm",
	                      valueSelected: film.virtual_content.ams_drm_enabled ? "drm" : "none",
	                      onChange: function onChange(e, v) {
	                        return _VirtualContentActions2.default.edit(film.virtual_content.id, {
	                          ams_drm_enabled: v === "drm",
	                          livestream_premium_enabled: v === "drm",
	                          asset_pathway: undefined
	                        });
	                      }
	                    },
	                    _react2.default.createElement(_materialUi.RadioButton, {
	                      value: "none",
	                      label: _react2.default.createElement(
	                        "div",
	                        null,
	                        _react2.default.createElement(
	                          "div",
	                          null,
	                          "Basic"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          {
	                            style: { lineHeight: 1.2, fontSize: "0.9em" }
	                          },
	                          "Up to 720p resolution; basic security, single bitrate, additional fee for organizer export, no TV app playback (free)"
	                        )
	                      )
	                    }),
	                    _react2.default.createElement(_materialUi.RadioButton, {
	                      style: { marginTop: 5 },
	                      value: "drm",
	                      label: _react2.default.createElement(
	                        "div",
	                        null,
	                        _react2.default.createElement(
	                          "div",
	                          null,
	                          "Premium",
	                          " ",
	                          _react2.default.createElement(_inlineNoticeLabel2.default, {
	                            label: "Recommended",
	                            style: {
	                              verticalAlign: 1,
	                              marginLeft: 2,
	                              fontWeight: "bold"
	                            }
	                          })
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          {
	                            style: { lineHeight: 1.2, fontSize: "0.9em" }
	                          },
	                          "Up to 1080p resolution;",
	                          " ",
	                          film.virtual_content.source_video_layout === "360_single" ? "" : "multi-platform MPAA-approved DRM security, ",
	                          "adaptive bitrate quality re-encoding, free organizer HD export, TV app support, and free automatic captions (US$10/hr + US$0.99/unlock)"
	                        )
	                      )
	                    })
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  null,
	                  _react2.default.createElement(
	                    _label2.default,
	                    null,
	                    "Livestream accessibility"
	                  ),
	                  _react2.default.createElement(_materialUi.Checkbox
	                  // disabled={window.location.search.indexOf("beta=1") === -1}
	                  , { label: _react2.default.createElement(
	                      "div",
	                      null,
	                      "Real-time automatic captions (",
	                      film.virtual_content.livestream_premium_enabled ? _react2.default.createElement(
	                        "span",
	                        null,
	                        _react2.default.createElement(
	                          "span",
	                          {
	                            style: { textDecoration: "line-through" }
	                          },
	                          "US$0.03/min"
	                        ),
	                        " ",
	                        _react2.default.createElement(
	                          "span",
	                          { style: { fontWeight: "bold" } },
	                          "free with Premium"
	                        )
	                      ) : "US$0.03/min",
	                      ")",
	                      " "
	                    ),
	                    checked: film.virtual_content.livestream_transcription_enabled,
	                    onCheck: function onCheck(e, checked) {
	                      _VirtualContentActions2.default.edit(film.virtual_content.id, {
	                        livestream_transcription_enabled: checked
	                      });
	                    }
	                  })
	                ),
	                THREESIXTY_VR_ENABLED ? _react2.default.createElement(
	                  "div",
	                  null,
	                  _react2.default.createElement(
	                    _label2.default,
	                    null,
	                    "Advanced options"
	                  ),
	                  _react2.default.createElement(_materialUi.Checkbox, {
	                    label: _react2.default.createElement(
	                      "div",
	                      null,
	                      "360\xB0/VR livestream playback mode"
	                    ),
	                    checked: film.virtual_content.source_video_layout === "360_single",
	                    onCheck: function onCheck(e, checked) {
	                      _VirtualContentActions2.default.edit(film.virtual_content.id, {
	                        source_video_layout: checked ? "360_single" : null
	                      });
	                    }
	                  })
	                ) : null,
	                _react2.default.createElement(
	                  "div",
	                  { style: { marginBottom: 15 } },
	                  _react2.default.createElement(
	                    _label2.default,
	                    null,
	                    "Livestream preview window"
	                  ),
	                  _react2.default.createElement(
	                    _materialUi.RadioButtonGroup,
	                    {
	                      name: "preview",
	                      valueSelected: film.virtual_content.livestream_preview_first !== false ? "preview" : "none",
	                      onChange: function onChange(e, v) {
	                        return _VirtualContentActions2.default.edit(film.virtual_content.id, {
	                          livestream_preview_first: v === "preview"
	                        });
	                      }
	                    },
	                    _react2.default.createElement(_materialUi.RadioButton, {
	                      value: "preview",
	                      label: _react2.default.createElement(
	                        "div",
	                        null,
	                        "Start with preview window for up to 1 hour before going live",
	                        _react2.default.createElement(
	                          "div",
	                          {
	                            style: { lineHeight: 1.2, fontSize: "0.9em" }
	                          },
	                          "Connect your inputs, preview your stream, and check video/audio levels. Then click to begin streaming to your audience within the next 60 minutes."
	                        )
	                      )
	                    }),
	                    _react2.default.createElement(_materialUi.RadioButton, {
	                      style: { marginTop: 5 },
	                      value: "none",
	                      label: "Immediately stream to audience once inputs are connected"
	                    })
	                  )
	                )
	              ),
	              _react2.default.createElement(_materialUi.RaisedButton, {
	                label: film.virtual_content.livestream_preview_first !== false ? "Start streaming to preview window" : "Start streaming",
	                primary: true,
	                disabled: this.state.isEditing,
	                onTouchTap: function onTouchTap() {
	                  return _this8.startStreaming(film.virtual_content.id, film.virtual_content.livestream_preview_first);
	                }
	              }),
	              _react2.default.createElement(
	                "div",
	                {
	                  style: {
	                    marginTop: "1.25em",
	                    fontSize: "11pt",
	                    maxWidth: 500
	                  }
	                },
	                _react2.default.createElement(
	                  "strong",
	                  null,
	                  "Before you click \"start streaming\" above, remember..."
	                ),
	                _react2.default.createElement(
	                  "ul",
	                  { style: { marginTop: "0.5em", paddingLeft: "2em" } },
	                  _react2.default.createElement(
	                    "li",
	                    { style: { marginBottom: "0.25em" } },
	                    _react2.default.createElement(
	                      "strong",
	                      null,
	                      "You can only start a livestream once, even when you're using the preview window!"
	                    ),
	                    " ",
	                    "If you're testing, do it in a test screening instead. You can never restart a stream."
	                  ),
	                  _react2.default.createElement(
	                    "li",
	                    { style: { marginBottom: "0.25em" } },
	                    "It may take up to 5 minutes for your dedicated livestream to fully initialize after clicking the button, so click a few minutes early!"
	                  ),
	                  _react2.default.createElement(
	                    "li",
	                    null,
	                    "Please stream responsibly.",
	                    " ",
	                    _react2.default.createElement(
	                      "strong",
	                      null,
	                      "YOU are responsible for clicking \u201CStop streaming\u201D when your livestream is complete."
	                    ),
	                    " ",
	                    "Abuse of the livestreaming platform, including long-running unattended or abandoned streams, will result in loss of streaming privileges."
	                  )
	                )
	              )
	            ),
	            ["livestream_creating"].indexOf(film.virtual_content.status) > -1 && _react2.default.createElement(
	              "p",
	              null,
	              _react2.default.createElement(_materialUi.RaisedButton, {
	                label: "Starting...",
	                primary: true,
	                disabled: true
	              })
	            ),
	            ["livestream_created", "livestream_stop_failure"].indexOf(film.virtual_content.status) > -1 && _react2.default.createElement(
	              "p",
	              null,
	              _react2.default.createElement(_materialUi.RaisedButton, {
	                label: "Stop streaming",
	                primary: true,
	                disabled: this.state.isEditing,
	                onTouchTap: function onTouchTap() {
	                  return _this8.stopStreaming(film.virtual_content.id);
	                }
	              })
	            ),
	            ["livestream_stopping"].indexOf(film.virtual_content.status) > -1 && _react2.default.createElement(
	              "p",
	              null,
	              _react2.default.createElement(_materialUi.RaisedButton, {
	                label: "Stopping...",
	                primary: true,
	                disabled: true
	              })
	            ),
	            ["livestream_stopped"].indexOf(film.virtual_content.status) > -1 && _react2.default.createElement(
	              "div",
	              null,
	              _react2.default.createElement(
	                "p",
	                null,
	                "Livestream mode:",
	                " ",
	                film.virtual_content.type === "broadcast" ? "Premium Broadcast" : film.virtual_content.livestream_premium_enabled ? "Premium" : "Basic",
	                film.virtual_content.livestream_transcription_enabled ? " (w/ Live Transcription)" : "",
	                _react2.default.createElement("br", null),
	                "Actual start:",
	                " ",
	                film.virtual_content.livestream_started_at ? (0, _moment2.default)(film.virtual_content.livestream_started_at).format("LLL") : "Unknown",
	                _react2.default.createElement("br", null),
	                "Actual end:",
	                " ",
	                film.virtual_content.livestream_stopped_at ? (0, _moment2.default)(film.virtual_content.livestream_stopped_at).format("LLL") : "Unknown",
	                _react2.default.createElement("br", null),
	                "Actual duration:",
	                " ",
	                film.virtual_content.duration ? _juration2.default.stringify(film.virtual_content.duration / 1000) : "Unknown"
	              ),
	              film.virtual_content.type === "broadcast" ? _react2.default.createElement(
	                "div",
	                null,
	                _react2.default.createElement(
	                  "p",
	                  null,
	                  "The real-time broadcast has concluded successfully."
	                )
	              ) : _react2.default.createElement(
	                "div",
	                null,
	                film.virtual_content.livestream_premium_enabled ? _react2.default.createElement(
	                  "p",
	                  null,
	                  "Your Premium Livestream includes a full HD downloadable export if you wish to use this asset in a non-Eventive-hosted setting."
	                ) : _react2.default.createElement(
	                  "p",
	                  null,
	                  "For Basic livestreams, an HD downloadable export can be generated for US$20 (free with Premium)."
	                ),
	                _react2.default.createElement(
	                  "p",
	                  null,
	                  film.virtual_content.export_status === "export_not_requested" ? _react2.default.createElement(_materialUi.RaisedButton, {
	                    label: this.state.isExporting ? "Requesting HD export..." : "Request HD export" + (film.virtual_content.livestream_premium_enabled ? "" : " ($20)"),
	                    primary: true,
	                    disabled: this.state.isExporting,
	                    onTouchTap: function onTouchTap() {
	                      return _this8.export(film.virtual_content.id);
	                    }
	                  }) : film.virtual_content.export_status === "export_in_progress" ? _react2.default.createElement(
	                    "i",
	                    null,
	                    "Your export is in progress now. Check back soon to download.",
	                    " ",
	                    this.state.isExporting ? "Checking now..." : this.state.checkCountdown !== null ? "Checking again in " + this.state.checkCountdown + "..." : ""
	                  ) : film.virtual_content.export_status === "export_ready" ? _react2.default.createElement(_materialUi.RaisedButton, {
	                    label: this.state.isExporting ? "Downloading completed HD export..." : "Download completed HD export",
	                    primary: true,
	                    disabled: this.state.isExporting,
	                    onTouchTap: function onTouchTap() {
	                      return _this8.export(film.virtual_content.id);
	                    }
	                  }) : film.virtual_content.export_status === "export_failure" ? "An error occurred while generating your export automatically. Please contact us using the support chat in the lower righthand corner so we can prepare your export manually." : "Loading..."
	                ),
	                _react2.default.createElement(
	                  "p",
	                  { style: { fontSize: "0.8em" } },
	                  "Export may take up to an hour to render. Once generated you can download your export an unlimited number of times from this page at no additional charge.",
	                  " ",
	                  !film.virtual_content.livestream_premium_enabled && "A single fee of US$20 will\n                  appear on your next monthly invoice."
	                )
	              )
	            ),
	            this.state.pinging && _react2.default.createElement(
	              "div",
	              { style: { display: "flex", justifyContent: "center" } },
	              _react2.default.createElement(_workingIndicator2.default, {
	                overlay: false,
	                style: { marginBottom: "20px" }
	              })
	            ),
	            this.props.isEditing || this.props.isFetching ? _react2.default.createElement(_workingIndicator2.default, { overlay: true }) : null
	          )
	        ),
	        _react2.default.createElement(
	          "h2",
	          { style: { marginTop: "2em" } },
	          "Live chat management"
	        ),
	        _react2.default.createElement(
	          "div",
	          { style: { maxWidth: 400, fontSize: "11pt", margin: "1em 0" } },
	          _react2.default.createElement(_materialUi.Checkbox, {
	            label: "Show live chat",
	            checked: film.virtual_content.live_chat_visible,
	            onCheck: function onCheck(e, checked) {
	              _VirtualContentActions2.default.edit(film.virtual_content.id, {
	                live_chat_visible: checked
	              });
	            }
	          }),
	          _react2.default.createElement(_materialUi.Checkbox, {
	            disabled: film.virtual_content.live_chat_visible === false,
	            label: "Show number of people currently viewing",
	            checked: film.virtual_content.live_chat_visible && film.virtual_content.live_chat_show_viewer_count,
	            onCheck: function onCheck(e, checked) {
	              _VirtualContentActions2.default.edit(film.virtual_content.id, {
	                live_chat_show_viewer_count: checked
	              });
	            }
	          }),
	          _react2.default.createElement(_materialUi.Checkbox, {
	            disabled: film.virtual_content.live_chat_visible === false,
	            label: "Allow viewers to send messages",
	            checked: film.virtual_content.live_chat_visible && film.virtual_content.live_chat_participation_enabled,
	            onCheck: function onCheck(e, checked) {
	              _VirtualContentActions2.default.edit(film.virtual_content.id, {
	                live_chat_participation_enabled: checked
	              });
	            }
	          })
	        ),
	        _react2.default.createElement(
	          "p",
	          { style: { fontSize: "11pt" } },
	          "Your livestream includes a live chat. You can participate in the chat as ",
	          (_UserStore2.default.getUser() || {}).organization,
	          " below. You can delete messages, ban users, and more by hovering over a message and clicking on the three dots in the upper righthand corner of the message."
	        ),
	        _react2.default.createElement(
	          "div",
	          { style: styles.flexContainer },
	          _react2.default.createElement(
	            "div",
	            { style: styles.leftPane },
	            _react2.default.createElement(_chatWidget2.default, {
	              film: film,
	              user: _UserStore2.default.getUser(),
	              token: film.livechat_token
	            })
	          ),
	          _react2.default.createElement(
	            "div",
	            { style: styles.rightPane },
	            _react2.default.createElement(_chatReviewQueue2.default, { film: film })
	          )
	        ),
	        _UserStore2.default.isGod() ? _react2.default.createElement(
	          _materialUi.Paper,
	          {
	            style: { marginTop: "2em", borderRadius: "15px", padding: "10px" }
	          },
	          _react2.default.createElement(
	            "h2",
	            { style: { paddingTop: "10px" } },
	            "Live stream diagnostics",
	            " ",
	            _react2.default.createElement(_inlineNoticeLabel2.default, {
	              label: "God Beta",
	              style: {
	                verticalAlign: 3,
	                marginLeft: 4,
	                fontWeight: "bold"
	              }
	            })
	          ),
	          _react2.default.createElement(
	            "p",
	            { style: { fontSize: "11pt" } },
	            "Review live events as received from the media encoder. Newest events will appear at the top automatically\u2013no need to refresh the page."
	          ),
	          _react2.default.createElement(_liveEventDiagnostics2.default, { virtualContentId: film.virtual_content.id })
	        ) : null
	      );
	    }
	  }], [{
	    key: "getStores",
	    value: function getStores() {
	      return [_UserStore2.default, _EventBucketStore2.default, _FilmStore2.default, _VirtualContentStore2.default];
	    }
	  }, {
	    key: "getPropsFromStores",
	    value: function getPropsFromStores() {
	      return _extends({}, _FilmStore2.default.getState(), {
	        getEventBucketById: _EventBucketStore2.default.getEventBucketById,
	        isEditing: _VirtualContentStore2.default.getState().isEditing
	      });
	    }
	  }, {
	    key: "contextTypes",
	    get: function get() {
	      return {
	        router: _react2.default.PropTypes.object
	      };
	    }
	  }]);
	
	  return Film;
	}(_react2.default.Component);
	
	exports.default = (0, _connectToStores2.default)(Film);
	module.exports = exports["default"];

/***/ }),
/* 2683 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _materialUi = __webpack_require__(576);
	
	var _connectToStores = __webpack_require__(1226);
	
	var _connectToStores2 = _interopRequireDefault(_connectToStores);
	
	var _get = __webpack_require__(1004);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _EventBucketStore = __webpack_require__(1593);
	
	var _EventBucketStore2 = _interopRequireDefault(_EventBucketStore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ChatWidget = function (_React$Component) {
	  _inherits(ChatWidget, _React$Component);
	
	  function ChatWidget(props) {
	    _classCallCheck(this, ChatWidget);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(ChatWidget).call(this, props));
	
	    _this.state = {
	      setupData: null
	    };
	    return _this;
	  }
	
	  _createClass(ChatWidget, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.componentWillReceiveProps(this.props);
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(props) {
	      var film = props.film;
	      var getEventBucketById = props.getEventBucketById;
	
	      var eventBucket = getEventBucketById(film.event_bucket);
	      var avatar = (0, _get2.default)(eventBucket, "frontend_config.virtual_festival_chat_avatar");
	
	      if (!this.state.setupData && props.film && props.user && props.token && eventBucket) {
	        var name = (0, _get2.default)(eventBucket, "frontend_config.virtual_festival_chat_name") || props.user.organization;
	
	        this.setState({
	          setupData: {
	            user: {
	              id: props.user.id,
	              name: name,
	              image: avatar || "https://ui-avatars.com/api/?background=random&name=" + name + "&bold=true"
	            },
	            token: props.token,
	            channel_id: props.film.virtual_content && props.film.virtual_content.id || props.film.id,
	            channel_data: {
	              image: props.film.image,
	              name: props.film.name.replace(/[^\u0020-\u007e\u00a0-\u00ff]/g, "")
	            }
	          }
	        });
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var chatAdminLink = ("https://watch.eventive.org/") + "admin/chat?data=" + btoa(JSON.stringify(this.state.setupData));
	
	      return this.state.setupData ? _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          _materialUi.Paper,
	          {
	            style: {
	              borderRadius: "15px"
	            }
	          },
	          _react2.default.createElement(
	            "div",
	            { style: { padding: "10px", paddingTop: "20px", display: "flex" } },
	            _react2.default.createElement(
	              "h2",
	              { style: { flex: 1 } },
	              "Messages"
	            ),
	            _react2.default.createElement(_materialUi.FlatButton, {
	              style: { marginLeft: "auto" },
	              label: "Open in new tab",
	              href: chatAdminLink,
	              target: "_blank",
	              primary: true
	            })
	          ),
	          _react2.default.createElement("iframe", {
	            src: chatAdminLink,
	            style: {
	              width: "100%",
	              height: 500,
	              border: "none",
	              borderRadius: "15px"
	            }
	          })
	        )
	      ) : null;
	    }
	  }], [{
	    key: "getStores",
	    value: function getStores() {
	      return [_EventBucketStore2.default];
	    }
	  }, {
	    key: "getPropsFromStores",
	    value: function getPropsFromStores() {
	      return {
	        getEventBucketById: _EventBucketStore2.default.getEventBucketById
	      };
	    }
	  }]);
	
	  return ChatWidget;
	}(_react2.default.Component);
	
	exports.default = (0, _connectToStores2.default)(ChatWidget);
	module.exports = exports["default"];

/***/ }),
/* 2684 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIframeResizerSuper = __webpack_require__(2307);
	
	var _reactIframeResizerSuper2 = _interopRequireDefault(_reactIframeResizerSuper);
	
	var _UserStore = __webpack_require__(974);
	
	var _UserStore2 = _interopRequireDefault(_UserStore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LiveEventDiagnostics = function (_React$Component) {
	  _inherits(LiveEventDiagnostics, _React$Component);
	
	  function LiveEventDiagnostics(props) {
	    _classCallCheck(this, LiveEventDiagnostics);
	
	    return _possibleConstructorReturn(this, Object.getPrototypeOf(LiveEventDiagnostics).call(this, props));
	  }
	
	  _createClass(LiveEventDiagnostics, [{
	    key: "render",
	    value: function render() {
	      var destination = ("https://watch.eventive.org/") + "admin/analytics?data=" + btoa(JSON.stringify(_extends({
	        type: "live_event_log",
	        virtual_content_id: this.props.virtualContentId
	      }, _UserStore2.default.getCredentials())));
	
	      return _react2.default.createElement(
	        "div",
	        { style: { position: "relative" } },
	        _react2.default.createElement(_reactIframeResizerSuper2.default, {
	          style: {
	            width: "1px",
	            minWidth: "100%",
	            border: "none"
	          },
	          src: destination
	        })
	      );
	    }
	  }]);
	
	  return LiveEventDiagnostics;
	}(_react2.default.Component);
	
	exports.default = LiveEventDiagnostics;
	module.exports = exports["default"];

/***/ }),
/* 2685 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _materialUi = __webpack_require__(576);
	
	var _moreVert = __webpack_require__(2686);
	
	var _moreVert2 = _interopRequireDefault(_moreVert);
	
	var _connectToStores = __webpack_require__(1226);
	
	var _connectToStores2 = _interopRequireDefault(_connectToStores);
	
	var _moment = __webpack_require__(1021);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _VirtualContentStore = __webpack_require__(1768);
	
	var _VirtualContentStore2 = _interopRequireDefault(_VirtualContentStore);
	
	var _VirtualContentActions = __webpack_require__(1767);
	
	var _VirtualContentActions2 = _interopRequireDefault(_VirtualContentActions);
	
	var _colors = __webpack_require__(821);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var formatTime = function formatTime(time) {
	  return (0, _moment2.default)(time / 1000 / 1000).format("LLL");
	};
	
	var QueueList = function (_React$Component) {
	  _inherits(QueueList, _React$Component);
	
	  function QueueList(props) {
	    _classCallCheck(this, QueueList);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(QueueList).call(this, props));
	
	    _this.state = {
	      openModal: false,
	      selectedItem: null
	    };
	    _this.handleOpenModal = _this.handleOpenModal.bind(_this);
	    _this.handleCloseModal = _this.handleCloseModal.bind(_this);
	    return _this;
	  }
	
	  _createClass(QueueList, [{
	    key: "handleOpenModal",
	    value: function handleOpenModal(item) {
	      this.setState({ openModal: true, selectedItem: item });
	    }
	  }, {
	    key: "handleCloseModal",
	    value: function handleCloseModal() {
	      this.setState({ openModal: false, selectedItem: null });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props;
	      var queue = _props.queue;
	      var submitAction = _props.submitAction;
	      var bannedMembers = _props.bannedMembers;
	      var _state = this.state;
	      var openModal = _state.openModal;
	      var selectedItem = _state.selectedItem;
	
	
	      var iconButtonElement = _react2.default.createElement(
	        _materialUi.IconButton,
	        {
	          touch: true,
	          tooltip: "Actions",
	          tooltipPosition: "bottom-left",
	          id: "icon-menu-button",
	          onClick: function onClick(e) {
	            return e.stopPropagation();
	          }
	        },
	        _react2.default.createElement(_moreVert2.default, { color: _colors.grey400 })
	      );
	
	      var rightIconButton = function rightIconButton(item, isBanned) {
	        return _react2.default.createElement(
	          _materialUi.IconMenu,
	          { iconButtonElement: iconButtonElement, id: "icon-menu" },
	          !item.reviewed_at && _react2.default.createElement(
	            _materialUi.MenuItem,
	            { onClick: function onClick() {
	                return submitAction("mark_reviewed", item.id);
	              } },
	            "Mark Reviewed"
	          ),
	          !isBanned && _react2.default.createElement(
	            _materialUi.MenuItem,
	            {
	              onClick: function onClick() {
	                return submitAction("ban", item.id, {
	                  ban: {
	                    reason: "spam",
	                    channel_ban_only: true
	                  }
	                });
	              }
	            },
	            "Channel Ban User"
	          ),
	          isBanned && _react2.default.createElement(
	            _materialUi.MenuItem,
	            {
	              onClick: function onClick() {
	                return submitAction("unban", item.id, {
	                  unban: {
	                    channel_cid: item.message.cid
	                  }
	                });
	              }
	            },
	            "Unban User"
	          ),
	          item.message.type !== "deleted" && _react2.default.createElement(
	            _materialUi.MenuItem,
	            {
	              onClick: function onClick() {
	                return submitAction("delete_message", item.id, {
	                  delete_message: { hard_delete: false }
	                });
	              }
	            },
	            "Delete Message"
	          ),
	          item.message.type === "deleted" && _react2.default.createElement(
	            _materialUi.MenuItem,
	            {
	              onClick: function onClick() {
	                return submitAction("restore", item.id, { restore: {} });
	              }
	            },
	            "Restore Message"
	          )
	        );
	      };
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          _materialUi.List,
	          { style: { height: 436, overflowY: "scroll" } },
	          queue.map(function (item) {
	            var isBanned = !!bannedMembers.find(function (m) {
	              return m.user_id === item.entity_creator_id;
	            });
	
	            return _react2.default.createElement(_materialUi.ListItem, {
	              key: item.id,
	              leftAvatar: _react2.default.createElement(_materialUi.Avatar, { src: item.message.user.image }),
	              rightIconButton: rightIconButton(item, isBanned),
	              primaryText: _react2.default.createElement(
	                "div",
	                {
	                  style: {
	                    textDecoration: isBanned ? "line-through" : "none"
	                  }
	                },
	                item.message.user.name
	              ),
	              secondaryText: _react2.default.createElement(
	                "p",
	                null,
	                formatTime(item.message && item.message.created_at || item.created_at),
	                _react2.default.createElement("br", null),
	                item.moderation_payload.texts && item.moderation_payload.texts.map(function (t, i) {
	                  return _react2.default.createElement(
	                    "span",
	                    {
	                      key: i,
	                      style: {
	                        color: _colors.darkBlack,
	                        textDecoration: item.message.type === "deleted" ? "line-through" : "none"
	                      }
	                    },
	                    t
	                  );
	                }),
	                item.moderation_payload.images && item.moderation_payload.images.map(function (image, i) {
	                  return _react2.default.createElement("img", { key: i, src: image, style: { height: "100px" } });
	                })
	              ),
	              secondaryTextLines: 2,
	              onClick: function onClick() {
	                return _this2.handleOpenModal(item);
	              }
	            });
	          }),
	          queue.length === 0 && _react2.default.createElement(
	            _materialUi.Subheader,
	            null,
	            "No items in queue"
	          )
	        ),
	        _react2.default.createElement(
	          _materialUi.Dialog,
	          {
	            title: "Flagged Message",
	            actions: [_react2.default.createElement(_materialUi.FlatButton, {
	              label: "Close",
	              primary: true,
	              onClick: this.handleCloseModal
	            })],
	            modal: false,
	            open: openModal,
	            onRequestClose: this.handleCloseModal,
	            autoScrollBodyContent: true
	          },
	          selectedItem && _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(
	              "p",
	              null,
	              _react2.default.createElement(
	                "b",
	                null,
	                "User:"
	              ),
	              " ",
	              selectedItem.message.user.name
	            ),
	            _react2.default.createElement(
	              "p",
	              null,
	              _react2.default.createElement(
	                "b",
	                null,
	                "Flagged:"
	              ),
	              " ",
	              formatTime(selectedItem.created_at)
	            ),
	            _react2.default.createElement(
	              "p",
	              null,
	              _react2.default.createElement(
	                "b",
	                null,
	                "Sent:"
	              ),
	              " ",
	              formatTime(selectedItem.message && selectedItem.message.created_at || selectedItem.created_at)
	            ),
	            selectedItem.moderation_payload.texts && selectedItem.moderation_payload.texts.length > 0 && _react2.default.createElement(
	              "p",
	              null,
	              _react2.default.createElement(
	                "b",
	                null,
	                "Message:"
	              ),
	              " "
	            ),
	            selectedItem.moderation_payload.texts && selectedItem.moderation_payload.texts.map(function (t, i) {
	              return _react2.default.createElement(
	                "p",
	                { key: i },
	                t
	              );
	            }),
	            selectedItem.moderation_payload.images && selectedItem.moderation_payload.images.length > 0 && _react2.default.createElement(
	              "p",
	              null,
	              _react2.default.createElement(
	                "b",
	                null,
	                "Images:"
	              ),
	              " "
	            ),
	            selectedItem.moderation_payload.images && selectedItem.moderation_payload.images.map(function (image, i) {
	              return _react2.default.createElement(
	                "a",
	                {
	                  key: i,
	                  href: image,
	                  target: "_blank",
	                  rel: "noopener noreferrer"
	                },
	                _react2.default.createElement("img", {
	                  src: image,
	                  style: {
	                    "max-width": "300px",
	                    width: "100%"
	                  }
	                })
	              );
	            })
	          )
	        )
	      );
	    }
	  }]);
	
	  return QueueList;
	}(_react2.default.Component);
	
	var ChatReviewQueue = function (_React$Component2) {
	  _inherits(ChatReviewQueue, _React$Component2);
	
	  function ChatReviewQueue(props) {
	    _classCallCheck(this, ChatReviewQueue);
	
	    var _this3 = _possibleConstructorReturn(this, Object.getPrototypeOf(ChatReviewQueue).call(this, props));
	
	    _this3.state = {};
	
	    _this3.submitAction = _this3.submitAction.bind(_this3);
	    return _this3;
	  }
	
	  _createClass(ChatReviewQueue, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.componentWillReceiveProps(this.props);
	    }
	  }, {
	    key: "fetchChatReviewQueue",
	    value: function fetchChatReviewQueue(film) {
	      setTimeout(function () {
	        _VirtualContentActions2.default.fetchChatReviewQueue({
	          virtualContentId: film.virtual_content.id,
	          options: {
	            filters: {},
	            sort: {
	              created_at: -1
	            },
	            options: {}
	          }
	        });
	      }, 0);
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(props) {
	      var _this4 = this;
	
	      var film = props.film;
	
	
	      if (film && !this.fetchChatReviewQueueInterval) {
	        this.fetchChatReviewQueue(film);
	        this.fetchChatReviewQueueInterval = setInterval(function () {
	          _this4.fetchChatReviewQueue(film);
	        }, 5000);
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      if (this.fetchChatReviewQueueInterval) {
	        clearInterval(this.fetchChatReviewQueueInterval);
	      }
	    }
	  }, {
	    key: "submitAction",
	    value: function submitAction(actionType, itemId, options) {
	      var _this5 = this;
	
	      _VirtualContentActions2.default.submitChatReviewAction({
	        virtualContentId: this.props.film.virtual_content.id,
	        options: {
	          actionType: actionType,
	          itemId: itemId,
	          options: options
	        }
	      });
	
	      // wait a moment to refetch the queue
	      setTimeout(function () {
	        _this5.fetchChatReviewQueue(_this5.props.film);
	      }, 200);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      if (!this.props.film) return _react2.default.createElement("div", null);
	
	      var queue = this.props.reviewQueues[this.props.film.virtual_content.id];
	
	      if (!queue) return _react2.default.createElement("div", null);
	
	      var uniqueItems = [];
	      var itemMap = new Map();
	
	      queue.items.forEach(function (item) {
	        var flaggerUserId = item.flags[0] && item.flags[0].user_id;
	        var key = "mid:" + item.message.id + ",fuid:" + flaggerUserId;
	        if (!itemMap.has(key)) {
	          itemMap.set(key, true);
	          uniqueItems.push(item);
	        }
	      });
	
	      uniqueItems = uniqueItems.filter(function (i) {
	        return i.message.user.role !== "admin";
	      });
	
	      var queueInbox = uniqueItems.filter(function (i) {
	        return !i.reviewed_at;
	      });
	      var queueReviewed = uniqueItems.filter(function (i) {
	        return i.reviewed_at;
	      });
	
	      return _react2.default.createElement(
	        _materialUi.Paper,
	        {
	          style: {
	            width: "100%",
	            borderRadius: "15px"
	          }
	        },
	        _react2.default.createElement(
	          "h2",
	          { style: { padding: "10px", paddingTop: "20px" } },
	          "Moderation"
	        ),
	        _react2.default.createElement(
	          _materialUi.Tabs,
	          null,
	          _react2.default.createElement(
	            _materialUi.Tab,
	            { label: "Inbox" },
	            _react2.default.createElement(QueueList, {
	              queue: queueInbox,
	              submitAction: this.submitAction,
	              bannedMembers: queue.bannedMembers
	            })
	          ),
	          _react2.default.createElement(
	            _materialUi.Tab,
	            { label: "Reviewed" },
	            _react2.default.createElement(QueueList, {
	              queue: queueReviewed,
	              submitAction: this.submitAction,
	              bannedMembers: queue.bannedMembers
	            })
	          )
	        )
	      );
	    }
	  }], [{
	    key: "getStores",
	    value: function getStores() {
	      return [_VirtualContentStore2.default];
	    }
	  }, {
	    key: "getPropsFromStores",
	    value: function getPropsFromStores() {
	      return {
	        reviewQueues: _VirtualContentStore2.default.getState().reviewQueues
	      };
	    }
	  }]);
	
	  return ChatReviewQueue;
	}(_react2.default.Component);
	
	exports.default = (0, _connectToStores2.default)(ChatReviewQueue);
	module.exports = exports["default"];

/***/ }),
/* 2686 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(608);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(615);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NavigationMoreVert = function NavigationMoreVert(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z' })
	  );
	};
	NavigationMoreVert = (0, _pure2.default)(NavigationMoreVert);
	NavigationMoreVert.displayName = 'NavigationMoreVert';
	NavigationMoreVert.muiName = 'SvgIcon';
	
	exports.default = NavigationMoreVert;

/***/ }),
/* 2687 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDropzone = __webpack_require__(1780);
	
	var _reactDropzone2 = _interopRequireDefault(_reactDropzone);
	
	var _materialUi = __webpack_require__(576);
	
	var _reactable = __webpack_require__(1688);
	
	var _moment = __webpack_require__(1021);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _twix = __webpack_require__(2312);
	
	var _twix2 = _interopRequireDefault(_twix);
	
	var _striptags = __webpack_require__(1592);
	
	var _striptags2 = _interopRequireDefault(_striptags);
	
	var _connectToStores = __webpack_require__(1226);
	
	var _connectToStores2 = _interopRequireDefault(_connectToStores);
	
	var _BulkImportActions = __webpack_require__(2688);
	
	var _BulkImportActions2 = _interopRequireDefault(_BulkImportActions);
	
	var _BulkImportStore = __webpack_require__(2689);
	
	var _BulkImportStore2 = _interopRequireDefault(_BulkImportStore);
	
	var _infoNotice = __webpack_require__(1599);
	
	var _infoNotice2 = _interopRequireDefault(_infoNotice);
	
	var _checkCircle = __webpack_require__(877);
	
	var _checkCircle2 = _interopRequireDefault(_checkCircle);
	
	var _error = __webpack_require__(948);
	
	var _error2 = _interopRequireDefault(_error);
	
	var _config = __webpack_require__(1173);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _injectedSelect = __webpack_require__(1874);
	
	var _injectedSelect2 = _interopRequireDefault(_injectedSelect);
	
	var _label = __webpack_require__(1682);
	
	var _label2 = _interopRequireDefault(_label);
	
	var _quillEditor = __webpack_require__(2169);
	
	var _quillEditor2 = _interopRequireDefault(_quillEditor);
	
	var _linkLike = __webpack_require__(973);
	
	var _linkLike2 = _interopRequireDefault(_linkLike);
	
	var _util = __webpack_require__(1183);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TABLE_COLUMNS = [{ key: "name", label: "Title" }, { key: "description", label: "Description" }, { key: "short_description", label: "Short" }, { key: "tag_names", label: "Tags" }, { key: "details", label: "Details" }, { key: "credits", label: "Credits" }, { key: "visibility", label: "Visibility" }, { key: "images", label: "Images" }];
	
	var BulkImportFilms = function (_React$Component) {
	  _inherits(BulkImportFilms, _React$Component);
	
	  function BulkImportFilms(props) {
	    _classCallCheck(this, BulkImportFilms);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(BulkImportFilms).call(this, props));
	
	    _this.state = {
	      csvFile: null,
	      userReadyToImport: false
	    };
	
	    _this.reset = _this.reset.bind(_this);
	    _this.onDrop = _this.onDrop.bind(_this);
	    _this.import = _this.import.bind(_this);
	    return _this;
	  }
	
	  _createClass(BulkImportFilms, [{
	    key: "getStyles",
	    value: function getStyles() {
	      var _dropzone;
	
	      return {
	        progressContainer: {
	          margin: "0 auto",
	          textAlign: "center",
	          padding: 10
	        },
	        icon: {
	          width: 80,
	          height: "auto",
	          color: "rgb(2, 136, 209)"
	        },
	        message: {
	          marginTop: 10
	        },
	        dropzone: (_dropzone = {
	          padding: 20,
	          lineHeight: "1.25"
	        }, _defineProperty(_dropzone, "padding", 10), _defineProperty(_dropzone, "border", "1px dashed #ccc"), _defineProperty(_dropzone, "cursor", "pointer"), _dropzone),
	        actions: {
	          marginTop: 10
	        },
	        previewExtraMessage: {
	          padding: 20,
	          border: "1px dashed #ccc"
	        }
	      };
	    }
	  }, {
	    key: "componentWillMount",
	    value: function componentWillMount() {
	      this.reset();
	    }
	  }, {
	    key: "reset",
	    value: function reset() {
	      this.setState({
	        csvFile: null,
	        userReadyToImport: false
	      });
	      _BulkImportActions2.default.reset.defer();
	    }
	  }, {
	    key: "onDrop",
	    value: function onDrop(files) {
	      if (!files.length) {
	        return;
	      }
	      this.setState({
	        csvFile: files[0]
	      });
	    }
	  }, {
	    key: "import",
	    value: function _import() {
	      _BulkImportActions2.default.importFilms({
	        eventBucket: this.props.params.eventBucketId,
	        csvFile: this.state.csvFile,
	        preview: !this.state.userReadyToImport
	      });
	      window.scrollTo(0, 0);
	    }
	  }, {
	    key: "_makeCsvLink",
	    value: function _makeCsvLink() {
	      return _config2.default.endpoint + "bulk_import/example/films";
	    }
	  }, {
	    key: "_makeTable",
	    value: function _makeTable(films) {
	      return _react2.default.createElement(_reactable.Table, {
	        className: "bordered striped responsive-table",
	        columns: TABLE_COLUMNS,
	        data: films.map(function (f) {
	          return Object.assign({}, f, {
	            short_description: f.short_description && _react2.default.createElement(
	              "span",
	              { title: f.short_description },
	              f.short_description.substring(0, 10).trim() + "..."
	            ),
	            description: f.description && _react2.default.createElement(
	              "span",
	              { title: (0, _striptags2.default)(f.description) },
	              (0, _striptags2.default)(f.description).substring(0, 10).trim() + "..."
	            ),
	            tag_names: f.tags.map(function (t) {
	              return t.name;
	            }).join(", "),
	            details: Object.entries(f.details || {}).map(function (_ref) {
	              var _ref2 = _slicedToArray(_ref, 2);
	
	              var k = _ref2[0];
	              var v = _ref2[1];
	              return (0, _util.capitalize)(k) + ": " + v;
	            }).join("; "),
	            credits: Object.entries(f.credits || {}).map(function (_ref3) {
	              var _ref4 = _slicedToArray(_ref3, 2);
	
	              var k = _ref4[0];
	              var v = _ref4[1];
	              return (0, _util.capitalize)(k) + ": " + v;
	            }).join("; "),
	            visibility: (0, _util.capitalize)(f.visibility),
	            images: _react2.default.createElement(
	              "span",
	              null,
	              f.poster_image ? _react2.default.createElement(
	                "span",
	                null,
	                "Poster:",
	                " ",
	                _react2.default.createElement("img", {
	                  src: f.poster_image.poster.url,
	                  style: { height: 40 }
	                })
	              ) : null,
	              " ",
	              f.cover_image ? _react2.default.createElement(
	                "span",
	                null,
	                "Cover:",
	                " ",
	                _react2.default.createElement("img", { src: f.cover_image.cover.url, style: { height: 40 } })
	              ) : null
	            )
	          });
	        })
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props;
	      var isImporting = _props.isImporting;
	      var importCompleted = _props.importCompleted;
	      var importSuccessful = _props.importSuccessful;
	      var importMessage = _props.importMessage;
	      var previewData = _props.previewData;
	      var styles = this.getStyles();
	
	      if (isImporting || importCompleted && !previewData) {
	        return _react2.default.createElement(
	          "div",
	          { style: styles.progressContainer },
	          isImporting ? _react2.default.createElement(_materialUi.CircularProgress, { size: 1.5, mode: "indeterminate" }) : importSuccessful ? _react2.default.createElement(_checkCircle2.default, { style: styles.icon }) : _react2.default.createElement(_error2.default, { style: styles.icon }),
	          _react2.default.createElement(
	            "div",
	            { style: styles.message },
	            isImporting ? _react2.default.createElement(
	              "div",
	              null,
	              this.state.userReadyToImport ? "Importing" : "Previewing",
	              " ",
	              "films...",
	              _react2.default.createElement("br", null),
	              "This may take a little while."
	            ) : importMessage,
	            !isImporting ? _react2.default.createElement(
	              "div",
	              null,
	              importSuccessful && _react2.default.createElement(
	                "span",
	                null,
	                _react2.default.createElement(
	                  _linkLike2.default,
	                  {
	                    onTouchTap: function onTouchTap() {
	                      return _this2.context.router.push("/event_buckets/" + _this2.props.params.eventBucketId + "/films");
	                    }
	                  },
	                  "view film list"
	                ),
	                " ",
	                "|",
	                " "
	              ),
	              _react2.default.createElement(
	                _linkLike2.default,
	                { onTouchTap: this.reset },
	                "restart"
	              )
	            ) : null
	          )
	        );
	      }
	
	      if (previewData && this.state.csvFile) {
	        return _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement(
	            "p",
	            null,
	            "We detected ",
	            previewData.films.length,
	            " film",
	            previewData.films.length !== 1 ? "s" : "",
	            " in your uploaded data. Have a look:"
	          ),
	          this._makeTable(previewData.films),
	          previewData.tags.length ? _react2.default.createElement(
	            "p",
	            null,
	            "We also detected ",
	            previewData.tags.length,
	            " new tag",
	            previewData.tags.length !== 1 ? "s" : "",
	            " in your data, so",
	            " ",
	            previewData.tags.length !== 1 ? "they" : "it",
	            " will automatically be created when importing.",
	            _react2.default.createElement("br", null),
	            _react2.default.createElement(
	              "i",
	              null,
	              "You can edit tag colors, names, and more after importing (in the Tags section)."
	            ),
	            _react2.default.createElement(
	              "ul",
	              null,
	              previewData.tags.map(function (t) {
	                return _react2.default.createElement(
	                  "li",
	                  { key: t.name },
	                  t.name
	                );
	              })
	            )
	          ) : null,
	          _react2.default.createElement(
	            "p",
	            null,
	            "If everything looks all right, confirm & start the import. Otherwise,",
	            " ",
	            _react2.default.createElement(
	              _linkLike2.default,
	              { onTouchTap: this.reset },
	              "edit settings"
	            ),
	            "."
	          ),
	          _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(_materialUi.Checkbox, {
	              label: "Yes, I'm ready to import " + previewData.films.length + " film" + (previewData.films.length !== 1 ? "s" : "") + ".",
	              checked: this.state.userReadyToImport,
	              onCheck: function onCheck() {
	                return _this2.setState({
	                  userReadyToImport: !_this2.state.userReadyToImport
	                });
	              }
	            })
	          ),
	          _react2.default.createElement(
	            "div",
	            { style: styles.actions },
	            _react2.default.createElement(_materialUi.RaisedButton, {
	              label: "Start import",
	              primary: true,
	              disabled: !this.state.userReadyToImport,
	              onTouchTap: this.import
	            })
	          )
	        );
	      }
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          "h1",
	          null,
	          "Bulk import films"
	        ),
	        _react2.default.createElement(
	          _infoNotice2.default,
	          { style: { marginTop: 20 } },
	          "Check out our",
	          " ",
	          _react2.default.createElement(
	            "a",
	            {
	              href: "https://help.eventive.org/films/bulk-import-films",
	              target: "_blank"
	            },
	            "guide to importing films"
	          ),
	          "."
	        ),
	        _react2.default.createElement(
	          "p",
	          null,
	          "Use this wizard to create films in bulk. Just download the Excel template, fill in your data, and upload.",
	          _react2.default.createElement("br", null),
	          _react2.default.createElement(
	            "i",
	            null,
	            "Detailed explanations of what to include in each column are included in our",
	            " ",
	            _react2.default.createElement(
	              "a",
	              {
	                href: "https://help.eventive.org/films/bulk-import-films",
	                target: "_blank"
	              },
	              "guide to importing films"
	            ),
	            "."
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement(
	            _label2.default,
	            null,
	            "Add spreadsheet (",
	            _react2.default.createElement(
	              "a",
	              { target: "_blank", href: this._makeCsvLink() },
	              "download template"
	            ),
	            ")"
	          ),
	          _react2.default.createElement(
	            _reactDropzone2.default,
	            {
	              style: styles.dropzone,
	              multiple: false,
	              onDrop: this.onDrop
	            },
	            function (_ref5) {
	              var isDragActive = _ref5.isDragActive;
	              var isDragReject = _ref5.isDragReject;
	              var acceptedFiles = _ref5.acceptedFiles;
	              var rejectedFiles = _ref5.rejectedFiles;
	
	              return isDragActive ? "Release to select." : acceptedFiles.length ? _react2.default.createElement(
	                "span",
	                null,
	                "One spreadsheet ",
	                _react2.default.createElement(
	                  "i",
	                  null,
	                  "(",
	                  acceptedFiles[0].name,
	                  ")"
	                ),
	                " ready to import."
	              ) : "Drop spreadsheet here, or click to select.";
	            }
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { style: styles.actions },
	          _react2.default.createElement(_materialUi.RaisedButton, {
	            label: "Preview import...",
	            primary: true,
	            disabled: !this.state.csvFile,
	            onTouchTap: this.import
	          })
	        )
	      );
	    }
	  }], [{
	    key: "getStores",
	    value: function getStores() {
	      return [_BulkImportStore2.default];
	    }
	  }, {
	    key: "getPropsFromStores",
	    value: function getPropsFromStores() {
	      return _BulkImportStore2.default.getState();
	    }
	  }, {
	    key: "contextTypes",
	    get: function get() {
	      return {
	        router: _react2.default.PropTypes.object
	      };
	    }
	  }]);
	
	  return BulkImportFilms;
	}(_react2.default.Component);
	
	exports.default = (0, _connectToStores2.default)(BulkImportFilms);
	module.exports = exports["default"];

/***/ }),
/* 2688 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _alt = __webpack_require__(975);
	
	var _alt2 = _interopRequireDefault(_alt);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var BulkImportActions = function BulkImportActions() {
	  _classCallCheck(this, BulkImportActions);
	
	  this.generateActions("importPasses", "reset", "importEvents", "importFilms", "importPeople");
	};
	
	exports.default = _alt2.default.createActions(BulkImportActions);
	module.exports = exports["default"];

/***/ }),
/* 2689 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _alt = __webpack_require__(975);
	
	var _alt2 = _interopRequireDefault(_alt);
	
	var _BulkImportUtil = __webpack_require__(2690);
	
	var _BulkImportUtil2 = _interopRequireDefault(_BulkImportUtil);
	
	var _BulkImportActions = __webpack_require__(2688);
	
	var _BulkImportActions2 = _interopRequireDefault(_BulkImportActions);
	
	var _UserStore = __webpack_require__(974);
	
	var _UserStore2 = _interopRequireDefault(_UserStore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var BulkImportStore = function () {
	  function BulkImportStore() {
	    _classCallCheck(this, BulkImportStore);
	
	    this.bindActions(_BulkImportActions2.default);
	    this.state = {
	      isImporting: false,
	      importCompleted: false,
	      importSuccessful: false,
	      importMessage: "",
	      importOrder: null,
	      previewData: null
	    };
	  }
	
	  _createClass(BulkImportStore, [{
	    key: "onReset",
	    value: function onReset() {
	      this.setState({
	        isImporting: false,
	        importCompleted: false,
	        importSuccessful: false,
	        importMessage: "",
	        importOrder: null,
	        previewData: null
	      });
	    }
	  }, {
	    key: "onImportPasses",
	    value: function onImportPasses(_ref) {
	      var _this = this;
	
	      var eventBucket = _ref.eventBucket;
	      var passBucket = _ref.passBucket;
	      var extraMessage = _ref.extraMessage;
	      var preview = _ref.preview;
	      var csvFile = _ref.csvFile;
	      var noEmail = _ref.noEmail;
	      var isMembership = _ref.isMembership;
	
	      this.setState({
	        isImporting: true
	      });
	
	      _BulkImportUtil2.default.importPasses(_UserStore2.default.getState().apiKey, eventBucket, passBucket, extraMessage, csvFile, noEmail, preview, isMembership).then(function (result) {
	        var bulkImportName = isMembership ? "bulk-import-memberships" : "bulk-import-passes";
	        if (!preview) {
	          window.Intercom("trackEvent", bulkImportName);
	        }
	
	        _this.setState({
	          isImporting: false,
	          importCompleted: true,
	          importSuccessful: result.success,
	          previewData: preview ? result.preview_data : null,
	          importMessage: result.message,
	          importOrder: !preview ? result.order : null
	        });
	      }).catch(function (e) {
	        _this.setState({
	          isImporting: false,
	          importCompleted: true,
	          importSuccessful: false,
	          previewData: null,
	          importMessage: e.message
	        });
	      });
	    }
	  }, {
	    key: "onImportEvents",
	    value: function onImportEvents(_ref2) {
	      var _this2 = this;
	
	      var eventBucket = _ref2.eventBucket;
	      var preview = _ref2.preview;
	      var csvFile = _ref2.csvFile;
	      var virtual = _ref2.virtual;
	
	      this.setState({
	        isImporting: true
	      });
	
	      _BulkImportUtil2.default.importEvents(_UserStore2.default.getState().apiKey, eventBucket, csvFile, preview, virtual).then(function (result) {
	        if (!preview) {
	          window.Intercom("trackEvent", "bulk-import-events");
	        }
	
	        _this2.setState({
	          isImporting: false,
	          importCompleted: true,
	          importSuccessful: true,
	          previewData: preview ? result.preview_data : null,
	          importMessage: result.message
	        });
	      }).catch(function (e) {
	        _this2.setState({
	          isImporting: false,
	          importCompleted: true,
	          importSuccessful: false,
	          previewData: null,
	          importMessage: e.message
	        });
	      });
	    }
	  }, {
	    key: "onImportFilms",
	    value: function onImportFilms(_ref3) {
	      var _this3 = this;
	
	      var eventBucket = _ref3.eventBucket;
	      var preview = _ref3.preview;
	      var csvFile = _ref3.csvFile;
	
	      this.setState({
	        isImporting: true
	      });
	
	      _BulkImportUtil2.default.importFilms(_UserStore2.default.getState().apiKey, eventBucket, csvFile, preview).then(function (result) {
	        if (!preview) {
	          window.Intercom("trackEvent", "bulk-import-films");
	        }
	
	        _this3.setState({
	          isImporting: false,
	          importCompleted: true,
	          importSuccessful: true,
	          previewData: preview ? result.preview_data : null,
	          importMessage: result.message
	        });
	      }).catch(function (e) {
	        console.error(e);
	        _this3.setState({
	          isImporting: false,
	          importCompleted: true,
	          importSuccessful: false,
	          previewData: null,
	          importMessage: e.message
	        });
	      });
	    }
	  }, {
	    key: "onImportPeople",
	    value: function onImportPeople(_ref4) {
	      var _this4 = this;
	
	      var eventBucket = _ref4.eventBucket;
	      var subjectLine = _ref4.subjectLine;
	      var introMessage = _ref4.introMessage;
	      var extraMessage = _ref4.extraMessage;
	      var preview = _ref4.preview;
	      var skipExisting = _ref4.skipExisting;
	      var csvFile = _ref4.csvFile;
	
	      this.setState({
	        isImporting: true
	      });
	
	      _BulkImportUtil2.default.importPeople(_UserStore2.default.getState().apiKey, eventBucket, subjectLine, introMessage, extraMessage, csvFile, preview, skipExisting).then(function (result) {
	        if (!preview) {
	          window.Intercom("trackEvent", "bulk-import-people");
	        }
	
	        _this4.setState({
	          isImporting: false,
	          importCompleted: true,
	          importSuccessful: result.success,
	          previewData: preview ? result.preview_data : null,
	          importMessage: result.message
	        });
	      }).catch(function (e) {
	        _this4.setState({
	          isImporting: false,
	          importCompleted: true,
	          importSuccessful: false,
	          previewData: null,
	          importMessage: e.message
	        });
	      });
	    }
	  }]);
	
	  return BulkImportStore;
	}();
	
	exports.default = _alt2.default.createStore(BulkImportStore, "BulkImportStore");
	module.exports = exports["default"];

/***/ }),
/* 2690 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _merge = __webpack_require__(732);
	
	var _merge2 = _interopRequireDefault(_merge);
	
	var _api = __webpack_require__(1160);
	
	var _api2 = _interopRequireDefault(_api);
	
	var _config = __webpack_require__(1173);
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  importPasses: function importPasses(apiKey, eventBucket, passBucket, extraMessage, csvFile, noEmail, preview, isMembership) {
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "POST",
	        endpoint: "bulk_import/passes",
	        json: {
	          event_bucket: eventBucket,
	          pass_bucket: passBucket,
	          extra_message: extraMessage,
	          no_email: noEmail,
	          preview: preview,
	          is_membership: isMembership
	        },
	        fileField: "csv",
	        file: csvFile,
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response);
	      });
	
	      // Still send a message if the import times out.
	      if (!preview) {
	        setTimeout(function () {
	          resolve({
	            success: true,
	            message: "Your import has been processed, and emails are being sent. Check the Orders list in the next minute or two to see imported " + (isMembership ? "memberships" : "passes") + "."
	          });
	        }, 15 * 1000);
	      }
	    });
	  },
	  fetchPassErrorsCsv: function fetchPassErrorsCsv(apiKey, errors, passBucketId) {
	    return new Promise(function (resolve, reject) {
	      return _api2.default.request({
	        method: "POST",
	        endpoint: "bulk_import/passes/errors",
	        json: {
	          errorData: errors,
	          passBucket: passBucketId
	        },
	        api_key: apiKey,
	        getText: true
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response);
	      });
	    });
	  },
	  importEvents: function importEvents(apiKey, eventBucket, csvFile, preview, virtual) {
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "POST",
	        endpoint: "bulk_import/events",
	        json: {
	          event_bucket: eventBucket,
	          preview: preview,
	          virtual: virtual
	        },
	        fileField: "csv",
	        file: csvFile,
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response);
	      });
	    });
	  },
	  importFilms: function importFilms(apiKey, eventBucket, csvFile, preview) {
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "POST",
	        endpoint: "bulk_import/films",
	        json: {
	          event_bucket: eventBucket,
	          preview: preview
	        },
	        fileField: "csv",
	        file: csvFile,
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response);
	      });
	    });
	  },
	  importPeople: function importPeople(apiKey, eventBucket, subjectLine, introMessage, extraMessage, csvFile, preview, skipExisting) {
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "POST",
	        endpoint: "bulk_import/people",
	        json: {
	          event_bucket: eventBucket,
	          subject_line: subjectLine,
	          intro_message: introMessage,
	          extra_message: extraMessage,
	          skip_existing: skipExisting,
	          preview: preview
	        },
	        fileField: "csv",
	        file: csvFile,
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response);
	      });
	    });
	  }
	};
	module.exports = exports["default"];

/***/ }),
/* 2691 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _values = __webpack_require__(1214);
	
	var _values2 = _interopRequireDefault(_values);
	
	var _pickBy = __webpack_require__(1163);
	
	var _pickBy2 = _interopRequireDefault(_pickBy);
	
	var _materialUi = __webpack_require__(576);
	
	var _reactable = __webpack_require__(1688);
	
	var _eventTable = __webpack_require__(2680);
	
	var _eventTable2 = _interopRequireDefault(_eventTable);
	
	var _connectToStores = __webpack_require__(1226);
	
	var _connectToStores2 = _interopRequireDefault(_connectToStores);
	
	var _EventActions = __webpack_require__(2031);
	
	var _EventActions2 = _interopRequireDefault(_EventActions);
	
	var _EventStore = __webpack_require__(2032);
	
	var _EventStore2 = _interopRequireDefault(_EventStore);
	
	var _config = __webpack_require__(1173);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _UserStore = __webpack_require__(974);
	
	var _UserStore2 = _interopRequireDefault(_UserStore);
	
	var _workingIndicator = __webpack_require__(1664);
	
	var _workingIndicator2 = _interopRequireDefault(_workingIndicator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Events = function (_React$Component) {
	  _inherits(Events, _React$Component);
	
	  function Events(props) {
	    _classCallCheck(this, Events);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(Events).call(this, props));
	
	    _this.state = {
	      showScanCounts: false,
	      isReadOnly: _UserStore2.default.hasPermission("view_event") && !_UserStore2.default.hasPermission("edit_event")
	    };
	
	    _this._onShowScanCountsCheck = _this._onShowScanCountsCheck.bind(_this);
	    _this._onRefresh = _this._onRefresh.bind(_this);
	    return _this;
	  }
	
	  _createClass(Events, [{
	    key: "getStyles",
	    value: function getStyles() {
	      return {};
	    }
	  }, {
	    key: "_onShowScanCountsCheck",
	    value: function _onShowScanCountsCheck(checked) {
	      this.setState({
	        showScanCounts: checked
	      });
	
	      if (checked) {
	        _EventActions2.default.fetchAllForBucket(this.props.params.eventBucketId,
	        /* includeScanCounts */true);
	      }
	    }
	  }, {
	    key: "_onRefresh",
	    value: function _onRefresh() {
	      _EventActions2.default.fetchAllForBucket(this.props.params.eventBucketId, this.state.showScanCounts);
	    }
	  }, {
	    key: "downloadCsv",
	    value: function downloadCsv() {
	      window.open(_config2.default.endpoint + "event_buckets/" + this.props.params.eventBucketId + "/events.csv?" + _UserStore2.default.makeApiKeyQueryString(), "_blank");
	    }
	  }, {
	    key: "componentWillMount",
	    value: function componentWillMount() {
	      _EventActions2.default.fetchAllForBucket(this.props.params.eventBucketId);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var styles = this.getStyles(),
	          bucket = this.props.params.eventBucketId,
	          events = (0, _values2.default)((0, _pickBy2.default)(this.props.events, function (e) {
	        return e.event_bucket === bucket && !e.is_virtual;
	      }));
	
	      if (events.length === 0 && _EventStore2.default.getState().isFetching) {
	        return _react2.default.createElement(_workingIndicator2.default, { fullPage: true });
	      }
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          "h1",
	          { "class": "page-title" },
	          "Physical Events"
	        ),
	        _react2.default.createElement(_eventTable2.default, {
	          eventBucket: bucket,
	          events: events,
	          onShowScanCountsCheck: this._onShowScanCountsCheck,
	          onRefresh: this._onRefresh,
	          isRefreshing: this.props.isFetching,
	          createButton: _react2.default.createElement(
	            "span",
	            null,
	            _UserStore2.default.hasPermission("edit_physical_event") ? _react2.default.createElement(_materialUi.RaisedButton, {
	              label: "Create new event",
	              primary: true,
	              onTouchTap: function onTouchTap() {
	                return _this2.context.router.push("/event_buckets/" + _this2.props.params.eventBucketId + "/events/new");
	              }
	            }) : null,
	            _UserStore2.default.hasPermission("bulk_import") ? _react2.default.createElement(_materialUi.RaisedButton, {
	              style: { marginLeft: 7 },
	              onTouchTap: function onTouchTap() {
	                return _this2.context.router.push("/event_buckets/" + _this2.props.params.eventBucketId + "/bulk_import_events");
	              },
	              label: "Bulk import"
	            }) : null,
	            _react2.default.createElement(_materialUi.RaisedButton, {
	              style: {
	                marginLeft: _UserStore2.default.hasPermission("edit_physical_event") ? 7 : 0
	              },
	              onTouchTap: function onTouchTap() {
	                return _this2.downloadCsv();
	              },
	              label: "Download all (.csv)"
	            })
	          )
	        })
	      );
	    }
	  }], [{
	    key: "getStores",
	    value: function getStores() {
	      return [_EventStore2.default];
	    }
	  }, {
	    key: "getPropsFromStores",
	    value: function getPropsFromStores() {
	      return _EventStore2.default.getState();
	    }
	  }, {
	    key: "contextTypes",
	    get: function get() {
	      return {
	        router: _react2.default.PropTypes.object
	      };
	    }
	  }]);
	
	  return Events;
	}(_react2.default.Component);
	
	exports.default = (0, _connectToStores2.default)(Events);
	module.exports = exports["default"];

/***/ }),
/* 2692 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _moment = __webpack_require__(1021);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _twix = __webpack_require__(2312);
	
	var _twix2 = _interopRequireDefault(_twix);
	
	var _reactRouter = __webpack_require__(486);
	
	var _copyToClipboard = __webpack_require__(971);
	
	var _copyToClipboard2 = _interopRequireDefault(_copyToClipboard);
	
	var _config = __webpack_require__(1173);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _util = __webpack_require__(1183);
	
	var util = _interopRequireWildcard(_util);
	
	var _materialUi = __webpack_require__(576);
	
	var _eventTicketSalesChart = __webpack_require__(2693);
	
	var _eventTicketSalesChart2 = _interopRequireDefault(_eventTicketSalesChart);
	
	var _ticketTable = __webpack_require__(2694);
	
	var _ticketTable2 = _interopRequireDefault(_ticketTable);
	
	var _eventAnalyticsWidget = __webpack_require__(2705);
	
	var _eventAnalyticsWidget2 = _interopRequireDefault(_eventAnalyticsWidget);
	
	var _workingIndicator = __webpack_require__(1664);
	
	var _workingIndicator2 = _interopRequireDefault(_workingIndicator);
	
	var _backButton = __webpack_require__(1872);
	
	var _backButton2 = _interopRequireDefault(_backButton);
	
	var _viewLiveVirtualButton = __webpack_require__(1865);
	
	var _viewLiveVirtualButton2 = _interopRequireDefault(_viewLiveVirtualButton);
	
	var _connectToStores = __webpack_require__(1226);
	
	var _connectToStores2 = _interopRequireDefault(_connectToStores);
	
	var _EventActions = __webpack_require__(2031);
	
	var _EventActions2 = _interopRequireDefault(_EventActions);
	
	var _EventStore = __webpack_require__(2032);
	
	var _EventStore2 = _interopRequireDefault(_EventStore);
	
	var _EventBucketStore = __webpack_require__(1593);
	
	var _EventBucketStore2 = _interopRequireDefault(_EventBucketStore);
	
	var _TicketActions = __webpack_require__(2697);
	
	var _TicketActions2 = _interopRequireDefault(_TicketActions);
	
	var _TicketStore = __webpack_require__(2706);
	
	var _TicketStore2 = _interopRequireDefault(_TicketStore);
	
	var _UserStore = __webpack_require__(974);
	
	var _UserStore2 = _interopRequireDefault(_UserStore);
	
	var _GlobalNotificationActions = __webpack_require__(1182);
	
	var _GlobalNotificationActions2 = _interopRequireDefault(_GlobalNotificationActions);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Event = function (_React$Component) {
	  _inherits(Event, _React$Component);
	
	  function Event(props) {
	    _classCallCheck(this, Event);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(Event).call(this, props));
	
	    _this.state = {
	      tab: "insights",
	      isFetchingEvent: false,
	      fetchedEvent: null
	    };
	
	    _this.onChangeTab = _this.onChangeTab.bind(_this);
	
	    _this._makeInsights = _this._makeInsights.bind(_this);
	    _this._makeTickets = _this._makeTickets.bind(_this);
	    _this._makeExports = _this._makeExports.bind(_this);
	
	    _this._isRevshareView = _this._isRevshareView.bind(_this);
	    return _this;
	  }
	
	  _createClass(Event, [{
	    key: "_isRevshareView",
	    value: function _isRevshareView() {
	      return this.props.location.pathname.indexOf("/revenue_sharing") === 0;
	    }
	  }, {
	    key: "onChangeTab",
	    value: function onChangeTab(tab) {
	      if (typeof tab !== "string") {
	        return;
	      } // propagation's a bitch
	      this.context.router.push((this._isRevshareView() ? "/revenue_sharing" : "/event_buckets/" + this.props.params.eventBucketId + "/events") + "/" + this.props.params.eventId + (tab === "insights" ? "" : "/" + tab));
	    }
	  }, {
	    key: "copyPublicLink",
	    value: function copyPublicLink(eventLink) {
	      (0, _copyToClipboard2.default)(eventLink);
	      _GlobalNotificationActions2.default.notify.defer("Public link copied successfully!");
	    }
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.componentWillReceiveProps(this.props);
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(newProps) {
	      var event = newProps.getEventById(newProps.params.eventId);
	
	      if (!this.state.isFetchingEvent && this.state.fetchedEvent !== newProps.params.eventId) {
	        _EventActions2.default.fetchOne(newProps.params.eventId);
	        _TicketActions2.default.fetchAllForEvent(newProps.params.eventId);
	        this.setState({ isFetchingEvent: true });
	      } else if (event) {
	        this.setState({ isFetchingEvent: false, fetchedEvent: event.id });
	      }
	
	      // Set tab; default to "insights"
	      this.setState({ tab: newProps.params.tab || "insights" });
	    }
	  }, {
	    key: "getStyles",
	    value: function getStyles() {
	      return {
	        header: {
	          main: {
	            position: "relative",
	            backgroundColor: "rgba(0,0,0,0.5)"
	          },
	          buttonContainer: {
	            marginBottom: 5,
	            float: "right"
	          },
	          button: {
	            verticalAlign: "top",
	            marginLeft: "1em"
	          },
	          text: {
	            padding: "10px 10px",
	            boxSizing: "border-box",
	            width: "100%"
	          },
	          textContent: {
	            color: "#fff",
	            margin: 0
	          }
	        },
	        container: {
	          marginTop: 10
	        },
	        exportButton: {
	          float: "left",
	          clear: "both",
	          marginBottom: 10
	        },
	        contentText: {
	          fontSize: "12pt",
	          color: "rgb(33,33,33)"
	        }
	      };
	    }
	  }, {
	    key: "_makeInsights",
	    value: function _makeInsights() {
	      var styles = this.getStyles();
	
	      return _react2.default.createElement(
	        "div",
	        { style: styles.container },
	        _react2.default.createElement(_eventAnalyticsWidget2.default, { eventId: this.props.params.eventId })
	      );
	    }
	  }, {
	    key: "_makeTickets",
	    value: function _makeTickets() {
	      var styles = this.getStyles(),
	          event = this.props.getEventById(this.props.params.eventId),
	          tickets = this.props.getTicketsForEvent(this.props.params.eventId),
	          eventBucket = _EventBucketStore2.default.getEventBucketById(this.props.params.eventBucketId);
	
	      return _react2.default.createElement(
	        "div",
	        { style: styles.container },
	        _react2.default.createElement(_eventTicketSalesChart2.default, {
	          style: { margin: "1em 0 1.5em" },
	          event: event.id
	        }),
	        _react2.default.createElement(_ticketTable2.default, {
	          tickets: tickets,
	          event: event.id,
	          eventDetails: event,
	          isSundance: eventBucket && eventBucket.frontend_config ? eventBucket.frontend_config.sundance_login : false,
	          isFetching: this.props.isFetchingTickets,
	          showStats: true,
	          showPerson: true,
	          location: this.props.location,
	          isRevshareView: this._isRevshareView()
	        })
	      );
	    }
	  }, {
	    key: "_makeExports",
	    value: function _makeExports(eventDetails) {
	      var styles = this.getStyles(),
	          apiKey = this.props.apiKey,
	          event = this.props.params.eventId;
	
	      return _react2.default.createElement(
	        "div",
	        { style: styles.container },
	        _react2.default.createElement(
	          "p",
	          { style: styles.contentText },
	          "Generate exports related to \"",
	          eventDetails.name,
	          "\"."
	        ),
	        _react2.default.createElement(_materialUi.RaisedButton, {
	          style: styles.exportButton,
	          href: _config2.default.endpoint + "events/" + event + "/attendees.pdf?api_key=" + apiKey,
	          target: "_blank",
	          label: "Download attendees list (PDF)"
	        }),
	        _react2.default.createElement(_materialUi.RaisedButton, {
	          style: styles.exportButton,
	          href: _config2.default.endpoint + "events/" + event + "/attendees.csv?api_key=" + apiKey,
	          target: "_blank",
	          label: "Download attendees list (CSV)"
	        }),
	        !this._isRevshareView() ? _react2.default.createElement(_materialUi.RaisedButton, {
	          style: styles.exportButton,
	          href: _config2.default.endpoint + "tickets.pdf?event=" + event + "&include_bulk_info=true&api_key=" + apiKey,
	          target: "_blank",
	          label: "Download all tickets (PDF)"
	        }) : null,
	        _react2.default.createElement(_materialUi.RaisedButton, {
	          style: styles.exportButton,
	          href: _config2.default.endpoint + "events/" + event + "/attendees.csv?scanned_only=true&api_key=" + apiKey,
	          target: "_blank",
	          label: "Download scanned attendees (CSV)"
	        }),
	        _react2.default.createElement(
	          "h2",
	          {
	            style: Object.assign({}, styles.exportButton, {
	              margin: "20px 0 15px"
	            })
	          },
	          "Financial exports"
	        ),
	        _react2.default.createElement(_materialUi.RaisedButton, {
	          style: styles.exportButton,
	          onClick: function onClick() {
	            var form = document.createElement("form");
	            form.method = "post";
	            form.action = _config2.default.endpoint + "analytics/ledger_transaction_report?conditions=" + encodeURIComponent(JSON.stringify({ event_bucket: [eventDetails.event_bucket] })) + "&options=" + encodeURIComponent(JSON.stringify({
	              format: "csv",
	              timePeriod: "NO GROUPING",
	              includeNameAndEmail: true,
	              selectedEvent: [event]
	            })) + "&" + _UserStore2.default.makeApiKeyQueryString();
	            document.body.appendChild(form);
	            form.submit();
	          },
	          label: "Download all ledger transactions (CSV)"
	        })
	      );
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var styles = this.getStyles(),
	          event = this.props.getEventById(this.props.params.eventId),
	          tickets = this.props.getTicketsForEvent(this.props.params.eventId),
	          isRevshareView = this._isRevshareView();
	
	      if (!event) {
	        return _react2.default.createElement(_workingIndicator2.default, { fullPage: true });
	      }
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          "div",
	          { style: { marginBottom: 10 } },
	          _react2.default.createElement(_backButton2.default, {
	            label: isRevshareView ? "revenue sharing" : event.is_virtual ? "virtual screenings" : "events",
	            onTouchTap: function onTouchTap() {
	              return isRevshareView ? _this2.context.router.push("/revenue_sharing") : _this2.props.location.state && _this2.props.location.state.fromListing ? _this2.context.router.goBack() : _this2.context.router.push("/event_buckets/" + _this2.props.params.eventBucketId + (event.is_virtual ? "/virtual_festival" : "/events"));
	            }
	          })
	        ),
	        _react2.default.createElement(
	          "div",
	          { style: styles.header.main },
	          _react2.default.createElement(
	            "div",
	            { style: styles.header.text },
	            _react2.default.createElement(
	              "div",
	              { style: styles.header.buttonContainer },
	              _react2.default.createElement(_materialUi.RaisedButton, {
	                style: styles.header.button,
	                label: "Copy public link",
	                onTouchTap: function onTouchTap() {
	                  return _this2.copyPublicLink(event.public_url);
	                }
	              }),
	              event.is_virtual && !isRevshareView ? _react2.default.createElement(_viewLiveVirtualButton2.default, {
	                style: styles.header.button,
	                label: "View live",
	                href: event.public_url
	              }) : _react2.default.createElement(_materialUi.RaisedButton, {
	                style: styles.header.button,
	                label: "View live",
	                href: event.public_url,
	                target: "_blank"
	              }),
	              !isRevshareView && (_UserStore2.default.hasPermission("edit_virtual_event") && event.is_virtual || _UserStore2.default.hasPermission("edit_physical_event") && !event.is_virtual) ? _react2.default.createElement(_materialUi.RaisedButton, {
	                style: styles.header.button,
	                label: "Edit",
	                onTouchTap: function onTouchTap() {
	                  return _this2.context.router.push("/event_buckets/" + _this2.props.params.eventBucketId + "/events/" + _this2.props.params.eventId + "/edit");
	                },
	                primary: true
	              }) : null
	            ),
	            _react2.default.createElement(
	              "h2",
	              { style: styles.header.textContent },
	              event.name
	            ),
	            !event.is_virtual && _react2.default.createElement(
	              "h3",
	              { style: styles.header.textContent },
	              event.venue.id ? _react2.default.createElement(
	                _reactRouter.Link,
	                {
	                  style: styles.header.textContent,
	                  to: "/event_buckets/" + this.props.params.eventBucketId + "/venues/" + event.venue.id
	                },
	                event.venue.name
	              ) : "No venue set"
	            ),
	            _react2.default.createElement(
	              "h3",
	              { style: styles.header.textContent },
	              (0, _util.makeEventDateRangeLabel)(event)
	            )
	          )
	        ),
	        (_UserStore2.default.hasPermission("view_virtual_event") || _UserStore2.default.hasPermission("edit_virtual_event")) && !_UserStore2.default.hasRole("film_preview") && event.is_virtual || (_UserStore2.default.hasPermission("view_physical_event") || _UserStore2.default.hasPermission("edit_physical_event")) && !event.is_virtual ? _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement(
	            _materialUi.Tabs,
	            {
	              value: this.state.tab,
	              onChange: this.onChangeTab,
	              style: { clear: "both" }
	            },
	            _react2.default.createElement(
	              _materialUi.Tab,
	              { label: "Insights", value: "insights" },
	              this.state.tab === "insights" && this._makeInsights()
	            ),
	            _react2.default.createElement(
	              _materialUi.Tab,
	              { label: "Tickets", value: "tickets" },
	              this.state.tab === "tickets" && this._makeTickets()
	            ),
	            _react2.default.createElement(
	              _materialUi.Tab,
	              { label: "Exports", value: "exports" },
	              this.state.tab === "exports" && this._makeExports(event)
	            )
	          )
	        ) : null
	      );
	    }
	  }], [{
	    key: "getStores",
	    value: function getStores() {
	      return [_EventStore2.default, _EventBucketStore2.default, _TicketStore2.default, _UserStore2.default];
	    }
	  }, {
	    key: "getPropsFromStores",
	    value: function getPropsFromStores() {
	      return {
	        getEventById: _EventStore2.default.getEventById,
	        getTicketsForEvent: _TicketStore2.default.getTicketsForEvent,
	        apiKey: _UserStore2.default.getState().apiKey,
	        isFetchingTickets: _TicketStore2.default.getState().isFetching,
	        getEventBucketById: _EventBucketStore2.default.getEventBucketById
	      };
	    }
	  }, {
	    key: "contextTypes",
	    get: function get() {
	      return {
	        router: _react2.default.PropTypes.object
	      };
	    }
	  }]);
	
	  return Event;
	}(_react2.default.Component);
	
	exports.default = (0, _connectToStores2.default)(Event);
	module.exports = exports["default"];

/***/ }),
/* 2693 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _util = __webpack_require__(1183);
	
	var util = _interopRequireWildcard(_util);
	
	var _chart = __webpack_require__(1785);
	
	var _chart2 = _interopRequireDefault(_chart);
	
	var _connectToStores = __webpack_require__(1226);
	
	var _connectToStores2 = _interopRequireDefault(_connectToStores);
	
	var _AnalyticsStore = __webpack_require__(1861);
	
	var _AnalyticsStore2 = _interopRequireDefault(_AnalyticsStore);
	
	var _AnalyticsActions = __webpack_require__(1863);
	
	var _AnalyticsActions2 = _interopRequireDefault(_AnalyticsActions);
	
	var _EventStore = __webpack_require__(2032);
	
	var _EventStore2 = _interopRequireDefault(_EventStore);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var EventTicketSalesChart = function (_React$Component) {
	  _inherits(EventTicketSalesChart, _React$Component);
	
	  function EventTicketSalesChart() {
	    _classCallCheck(this, EventTicketSalesChart);
	
	    return _possibleConstructorReturn(this, Object.getPrototypeOf(EventTicketSalesChart).apply(this, arguments));
	  }
	
	  _createClass(EventTicketSalesChart, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      _AnalyticsActions2.default.fetchEventTicketSales.defer(this.props.event);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var sales = this.props.getEventTicketSalesById(this.props.event);
	
	      if (sales && sales.length === 0) {
	        return _react2.default.createElement(_chart2.default, {
	          height: 200,
	          placeholder: "Sales data will be available as soon as the first " + _EventStore2.default.getEventById(this.props.event).name + " ticket is sold!"
	        });
	      }
	
	      var rows = (sales || []).map(function (next) {
	        var date = new Date(next.date.year, next.date.month - 1, next.date.day);
	        return {
	          timeframe: { end: date },
	          value: [{ label: "Tickets sold", result: next.count }]
	        };
	      });
	
	      var filledRows = util.fillMissingDaysNew(rows, "timeframe.end", {
	        default: 0
	      });
	      filledRows = filledRows.map(function (r) {
	        r.timeframe.end = r.timeframe.end.toISOString();
	        return r;
	      });
	
	      // Only render 180 days worth of sales max, to avoid freezing up browser
	      var totalRows = filledRows.length;
	      if (totalRows > 180) {
	        filledRows = filledRows.slice(filledRows.length - 180);
	      }
	
	      var chartOptions = {
	        point: { show: false }
	      };
	
	      var dataTable = filledRows;
	
	      return _react2.default.createElement(
	        "div",
	        { style: this.props.style },
	        _react2.default.createElement(_chart2.default, {
	          title: "Ticket sales",
	          type: "area",
	          indexBy: "timeframe.end",
	          dateFormat: "%b %e",
	          height: 200,
	          chartOptions: chartOptions,
	          data: dataTable.length && { result: dataTable }
	        })
	      );
	    }
	  }], [{
	    key: "getStores",
	    value: function getStores() {
	      return [_AnalyticsStore2.default];
	    }
	  }, {
	    key: "getPropsFromStores",
	    value: function getPropsFromStores() {
	      return {
	        getEventTicketSalesById: _AnalyticsStore2.default.getEventTicketSalesById
	      };
	    }
	  }]);
	
	  return EventTicketSalesChart;
	}(_react2.default.Component);
	
	exports.default = (0, _connectToStores2.default)(EventTicketSalesChart);
	module.exports = exports["default"];

/***/ }),
/* 2694 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _moment = __webpack_require__(1021);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _reactable = __webpack_require__(1688);
	
	var _materialUi = __webpack_require__(576);
	
	var _ticketsAtAGlance = __webpack_require__(2695);
	
	var _ticketsAtAGlance2 = _interopRequireDefault(_ticketsAtAGlance);
	
	var _statsBlockContainer = __webpack_require__(1740);
	
	var _statsBlockContainer2 = _interopRequireDefault(_statsBlockContainer);
	
	var _statsBlock = __webpack_require__(1741);
	
	var _statsBlock2 = _interopRequireDefault(_statsBlock);
	
	var _tableRefreshIndicator = __webpack_require__(1686);
	
	var _tableRefreshIndicator2 = _interopRequireDefault(_tableRefreshIndicator);
	
	var _inlineLinkIconButton = __webpack_require__(1704);
	
	var _inlineLinkIconButton2 = _interopRequireDefault(_inlineLinkIconButton);
	
	var _downloadTicketsPdfButton = __webpack_require__(2696);
	
	var _downloadTicketsPdfButton2 = _interopRequireDefault(_downloadTicketsPdfButton);
	
	var _godTicketsExtension = __webpack_require__(2698);
	
	var _godTicketsExtension2 = _interopRequireDefault(_godTicketsExtension);
	
	var _transferOverlay = __webpack_require__(2699);
	
	var _transferOverlay2 = _interopRequireDefault(_transferOverlay);
	
	var _exchangeOverlay = __webpack_require__(2700);
	
	var _exchangeOverlay2 = _interopRequireDefault(_exchangeOverlay);
	
	var _bulkDeleteOverlay = __webpack_require__(2701);
	
	var _bulkDeleteOverlay2 = _interopRequireDefault(_bulkDeleteOverlay);
	
	var _changeSeatsOverlay = __webpack_require__(2702);
	
	var _changeSeatsOverlay2 = _interopRequireDefault(_changeSeatsOverlay);
	
	var _refund = __webpack_require__(2703);
	
	var _refund2 = _interopRequireDefault(_refund);
	
	var _loading = __webpack_require__(2704);
	
	var _loading2 = _interopRequireDefault(_loading);
	
	var _UserStore = __webpack_require__(974);
	
	var _UserStore2 = _interopRequireDefault(_UserStore);
	
	var _TicketActions = __webpack_require__(2697);
	
	var _TicketActions2 = _interopRequireDefault(_TicketActions);
	
	var _OrderActions = __webpack_require__(1220);
	
	var _OrderActions2 = _interopRequireDefault(_OrderActions);
	
	var _LedgerActions = __webpack_require__(2052);
	
	var _LedgerActions2 = _interopRequireDefault(_LedgerActions);
	
	var _GlobalNotificationActions = __webpack_require__(1182);
	
	var _GlobalNotificationActions2 = _interopRequireDefault(_GlobalNotificationActions);
	
	var _OrderUtil = __webpack_require__(2051);
	
	var _OrderUtil2 = _interopRequireDefault(_OrderUtil);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PAGE_SIZE = 20;
	
	var DELETED_ROW_STYLE = { textDecoration: "line-through", color: "#ccc" };
	var HIGHLIGHTED_ROW_STYLE = {
	  backgroundColor: "#fff176",
	  boxShadow: "1px 1px 10px rgba(0,0,0,0.2)"
	};
	
	var TicketTable = function (_React$Component) {
	  _inherits(TicketTable, _React$Component);
	
	  function TicketTable(props) {
	    _classCallCheck(this, TicketTable);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(TicketTable).call(this, props));
	
	    _this.state = {
	      deletedTickets: {},
	      selectedTickets: {},
	      highlightedRow: null,
	      currentPage: 0,
	      showExtensionsModal: false,
	      currentlyTransferring: null,
	      refundOptions: null,
	      ticketsToExchange: null,
	      ticketsToDelete: null,
	      ticketsToRefund: null,
	      ticketsToChangeSeats: null
	    };
	
	    _this._makeRowForTicket = _this._makeRowForTicket.bind(_this);
	    _this._refresh = _this._refresh.bind(_this);
	    _this._onCheckAll = _this._onCheckAll.bind(_this);
	    _this._onCheck = _this._onCheck.bind(_this);
	    _this._onExtensionFormClose = _this._onExtensionFormClose.bind(_this);
	    _this._onExtensionSubmit = _this._onExtensionSubmit.bind(_this);
	
	    _this._closeTransferModal = _this._closeTransferModal.bind(_this);
	    _this._submitTransfer = _this._submitTransfer.bind(_this);
	    _this._submitTransfer = _this._submitTransfer.bind(_this);
	
	    _this._showExchangeModal = _this._showExchangeModal.bind(_this);
	    _this._closeExchangeModal = _this._closeExchangeModal.bind(_this);
	    _this._onExchangeTickets = _this._onExchangeTickets.bind(_this);
	
	    _this._showDeleteModal = _this._showDeleteModal.bind(_this);
	    _this._closeDeleteModal = _this._closeDeleteModal.bind(_this);
	    _this._onDeleteTickets = _this._onDeleteTickets.bind(_this);
	
	    _this._showRefundModal = _this._showRefundModal.bind(_this);
	    _this._closeRefundModal = _this._closeRefundModal.bind(_this);
	    _this._onRefundTickets = _this._onRefundTickets.bind(_this);
	    _this._closeRefundStatusModal = _this._closeRefundStatusModal.bind(_this);
	
	    _this._showBulkScanModal = _this._showBulkScanModal.bind(_this);
	
	    _this._showChangeSeatsModal = _this._showChangeSeatsModal.bind(_this);
	    _this._closeChangeSeatsModal = _this._closeChangeSeatsModal.bind(_this);
	    _this._onChangeSeats = _this._onChangeSeats.bind(_this);
	    return _this;
	  }
	
	  _createClass(TicketTable, [{
	    key: "_viewHistory",
	    value: function _viewHistory(ticket, e) {
	      e.preventDefault();
	      e.stopPropagation();
	      this.context.router.push("/event_buckets/" + (this.props.eventBucket || ticket.event.event_bucket) + "/tickets/" + ticket.id + "/history");
	    }
	  }, {
	    key: "_delete",
	    value: function _delete(ticket, e) {
	      e.preventDefault();
	      e.stopPropagation();
	
	      if (window.confirm("Are you sure you want to delete this ticket to \"" + ticket.event.name + "\"? There is no going back.")) {
	        _TicketActions2.default.delete(ticket.id);
	        this.state.deletedTickets[ticket.id] = true;
	        this.setState(this.state);
	      }
	    }
	  }, {
	    key: "_markAsUsed",
	    value: function _markAsUsed(ticket, e) {
	      e.preventDefault();
	      e.stopPropagation();
	
	      if (window.confirm("Are you sure you want to mark this ticket to \"" + ticket.event.name + "\" as scanned? It will no longer be scannable.")) {
	        _TicketActions2.default.markAsUsed(ticket.id);
	      }
	    }
	  }, {
	    key: "_refresh",
	    value: function _refresh(e) {
	      e.preventDefault();
	      e.stopPropagation();
	
	      _TicketActions2.default.fetchAllForEvent(this.props.event);
	    }
	  }, {
	    key: "_onCheckAll",
	    value: function _onCheckAll() {
	      if (Object.keys(this.state.selectedTickets).length === this.props.tickets.length) {
	        this.setState({ selectedTickets: {} });
	      } else {
	        this.setState({
	          selectedTickets: this.props.tickets.reduce(function (d, t) {
	            d[t.id] = true;
	            return d;
	          }, {})
	        });
	      }
	    }
	  }, {
	    key: "_onCheck",
	    value: function _onCheck(ticket) {
	      if (!this.state.selectedTickets[ticket.id]) {
	        this.state.selectedTickets[ticket.id] = true;
	      } else {
	        delete this.state.selectedTickets[ticket.id];
	      }
	      this.setState({ selectedTickets: this.state.selectedTickets });
	    }
	  }, {
	    key: "_transfer",
	    value: function _transfer(id, e) {
	      e.preventDefault();
	      e.stopPropagation();
	      this.setState({ currentlyTransferring: id });
	    }
	  }, {
	    key: "_submitTransfer",
	    value: function _submitTransfer(recipient) {
	      _TicketActions2.default.transfer([this.state.currentlyTransferring], recipient);
	      this._closeTransferModal();
	    }
	  }, {
	    key: "_cancelTransfer",
	    value: function _cancelTransfer(id, e) {
	      e.preventDefault();
	      e.stopPropagation();
	      if (window.confirm("Are you sure you wish to cancel this ticket transfer? The original transfer link will no longer work.")) {
	        _TicketActions2.default.cancelTransfer(id);
	      }
	    }
	  }, {
	    key: "_resendTransfer",
	    value: function _resendTransfer(id, e) {
	      e.preventDefault();
	      e.stopPropagation();
	      _TicketActions2.default.resendTransfer(id);
	    }
	  }, {
	    key: "_closeTransferModal",
	    value: function _closeTransferModal() {
	      this.setState({ currentlyTransferring: null });
	    }
	  }, {
	    key: "_makeRowForTicket",
	    value: function _makeRowForTicket(ticket, showTransferHistory) {
	      var _this2 = this;
	
	      var isDeleted = this.state.deletedTickets[ticket.id],
	          isSelected = this.state.selectedTickets && this.state.selectedTickets[ticket.id],
	          shouldHighlight = this.state.highlightedId === ticket.id;
	
	      var noWrapTdStyle = this.props.person ? {} : { whiteSpace: "nowrap" },
	          onCheck = this._onCheck.bind(this, ticket);
	
	      return _react2.default.createElement(
	        _reactable.Tr,
	        {
	          style: Object.assign({}, isDeleted && DELETED_ROW_STYLE, shouldHighlight && HIGHLIGHTED_ROW_STYLE),
	          key: ticket.id
	        },
	        _react2.default.createElement(
	          _reactable.Td,
	          { column: " ", value: ticket.id },
	          _react2.default.createElement(
	            "div",
	            { onClick: onCheck },
	            _react2.default.createElement(_materialUi.Checkbox, { label: " ", checked: isSelected })
	          )
	        ),
	        _react2.default.createElement(
	          _reactable.Td,
	          { column: "Id" },
	          ticket.id
	        ),
	        _react2.default.createElement(
	          _reactable.Td,
	          {
	            column: "Person",
	            value: (ticket.person ? ticket.person.name || ticket.person.email : "Unknown Person") + " " + (ticket.pending_transfer ? ticket.pending_transfer.to_email : ""),
	            style: noWrapTdStyle
	          },
	          _react2.default.createElement(
	            "span",
	            null,
	            ticket.person ? _react2.default.createElement(
	              "span",
	              null,
	              ticket.person.name || ticket.person.email,
	              !this.props.isRevshareView ? _react2.default.createElement(_inlineLinkIconButton2.default, {
	                onTouchTap: function onTouchTap() {
	                  _this2.context.router.push("/event_buckets/" + (_this2.props.eventBucket || ticket.event.event_bucket) + "/people/" + ticket.person.id);
	                },
	                tooltip: "View person"
	              }) : null
	            ) : "Unknown Person",
	            ticket.pending_transfer ? _react2.default.createElement(
	              "span",
	              { style: { whiteSpace: "break-spaces" } },
	              "\u2192 ",
	              ticket.pending_transfer.to_email
	            ) : null
	          )
	        ),
	        _react2.default.createElement(
	          _reactable.Td,
	          {
	            column: "Pass Used",
	            value: ticket.pass ? ticket.pass.name : "n/a",
	            style: noWrapTdStyle
	          },
	          ticket.pass ? _react2.default.createElement(
	            "div",
	            null,
	            ticket.pass.name,
	            !this.props.isRevshareView ? _react2.default.createElement(_inlineLinkIconButton2.default, {
	              onTouchTap: function onTouchTap() {
	                _this2.context.router.push("/event_buckets/" + (_this2.props.eventBucket || ticket.event.event_bucket) + "/people/" + (_this2.props.person || ticket.person.id) + "?highlight_pass=" + ticket.pass.id);
	              },
	              tooltip: "View pass"
	            }) : null
	          ) : "n/a"
	        ),
	        _react2.default.createElement(
	          _reactable.Td,
	          { column: "Event", value: ticket.event.name },
	          _react2.default.createElement(
	            "div",
	            null,
	            ticket.event.name,
	            _react2.default.createElement(_inlineLinkIconButton2.default, {
	              onTouchTap: function onTouchTap() {
	                _this2.context.router.push("/event_buckets/" + (_this2.props.eventBucket || ticket.event.event_bucket) + "/events/" + ticket.event.id);
	              },
	              tooltip: "View event"
	            })
	          )
	        ),
	        _react2.default.createElement(
	          _reactable.Td,
	          { column: "Ticket Bucket", style: noWrapTdStyle },
	          "" + ticket.ticket_bucket.name + (ticket.variant ? " \u2013 " + ticket.variant.name : "")
	        ),
	        _react2.default.createElement(
	          _reactable.Td,
	          { column: "Seat", style: noWrapTdStyle },
	          ticket.seat
	        ),
	        _react2.default.createElement(
	          _reactable.Td,
	          {
	            column: "Unlock Status",
	            value: ticket.expires_at && (0, _moment2.default)(ticket.expires_at) < Date.now() ? "expires-" + ticket.expires_at : "unlock-" + ticket.unlocked_until
	          },
	          ticket.expires_at ? _react2.default.createElement(
	            "span",
	            null,
	            (0, _moment2.default)(ticket.expires_at) < Date.now() ? "Viewing complete; expired" : "Started watching; expires",
	            " ",
	            _react2.default.createElement(
	              "span",
	              { style: { whiteSpace: "nowrap" } },
	              (0, _moment2.default)(ticket.expires_at).format("lll")
	            )
	          ) : _react2.default.createElement(
	            "span",
	            null,
	            ticket.event.is_virtual ? (0, _moment2.default)(ticket.unlocked_until) < Date.now() ? "Never watched; unlock window closed" : "Not yet watched; unlocked until" : "Physical ticket",
	            " ",
	            _react2.default.createElement(
	              "span",
	              { style: { whiteSpace: "nowrap" } },
	              ticket.event.is_virtual ? (0, _moment2.default)(ticket.unlocked_until).format("lll") : ""
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _reactable.Td,
	          {
	            column: "Event Date",
	            value: ticket.event.start_time,
	            style: noWrapTdStyle
	          },
	          (0, _moment2.default)(ticket.event.start_time).format("lll")
	        ),
	        _react2.default.createElement(
	          _reactable.Td,
	          { column: "Order Date", value: ticket.created_at, style: noWrapTdStyle },
	          _react2.default.createElement(
	            "div",
	            null,
	            (0, _moment2.default)(ticket.created_at).format("lll"),
	            !this.props.isRevshareView ? _react2.default.createElement(_inlineLinkIconButton2.default, {
	              onTouchTap: function onTouchTap() {
	                _this2.context.router.push("/event_buckets/" + (_this2.props.eventBucket || ticket.event.event_bucket) + "/orders/" + (_this2.props.order || ticket.order));
	              },
	              tooltip: "View order"
	            }) : null
	          )
	        ),
	        _react2.default.createElement(
	          _reactable.Td,
	          { column: "Scan Date", value: ticket.used_at, style: noWrapTdStyle },
	          ticket.used_at ? (0, _moment2.default)(ticket.used_at).format("lll") : "Not scanned"
	        ),
	        _UserStore2.default.hasPermission("manage_orders") ? _react2.default.createElement(
	          _reactable.Td,
	          { column: "Actions", style: noWrapTdStyle },
	          _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement("div", {
	              ref: function ref(r) {
	                if (shouldHighlight) {
	                  _this2.highlightedRow = r;
	                }
	              }
	            }),
	            ticket.pending_transfer && _UserStore2.default.hasPermission("manage_orders") ? _react2.default.createElement(
	              "div",
	              null,
	              _react2.default.createElement(
	                "i",
	                {
	                  title: "Pending transfer to " + ticket.pending_transfer.to_email
	                },
	                "Pending transfer\xA0",
	                _react2.default.createElement(
	                  "small",
	                  null,
	                  "[",
	                  _react2.default.createElement(
	                    "a",
	                    {
	                      style: isDeleted && { color: "#ccc" },
	                      href: "#",
	                      onClick: this._cancelTransfer.bind(this, ticket.pending_transfer.id)
	                    },
	                    "Cancel"
	                  ),
	                  " ",
	                  "|",
	                  " ",
	                  _react2.default.createElement(
	                    "a",
	                    {
	                      style: isDeleted && { color: "#ccc" },
	                      href: "#",
	                      onClick: this._resendTransfer.bind(this, ticket.pending_transfer.id)
	                    },
	                    "Resend"
	                  ),
	                  "]"
	                )
	              )
	            ) : _UserStore2.default.hasPermission("manage_orders") ? _react2.default.createElement(
	              "span",
	              null,
	              _react2.default.createElement(
	                "a",
	                {
	                  style: isDeleted && { color: "#ccc" },
	                  href: "#",
	                  onClick: this._transfer.bind(this, ticket.id)
	                },
	                "Transfer"
	              ),
	              "\xA0"
	            ) : null,
	            _UserStore2.default.hasPermission("manage_orders") ? _react2.default.createElement(
	              "span",
	              null,
	              _react2.default.createElement(
	                "a",
	                {
	                  style: isDeleted && { color: "#ccc" },
	                  href: "#",
	                  onClick: function onClick() {
	                    return _this2._showExchangeModal(ticket.id);
	                  }
	                },
	                "Exchange"
	              )
	            ) : null,
	            !ticket.used_at && _UserStore2.default.hasPermission("manage_orders") && _react2.default.createElement(
	              "span",
	              null,
	              "\xA0",
	              _react2.default.createElement(
	                "a",
	                {
	                  href: "#",
	                  style: isDeleted && { color: "#ccc" },
	                  onClick: this._markAsUsed.bind(this, ticket)
	                },
	                "Mark as scanned"
	              )
	            ),
	            !isDeleted && _UserStore2.default.hasPermission("manage_orders") && _react2.default.createElement(
	              "span",
	              null,
	              "\xA0",
	              _react2.default.createElement(
	                "a",
	                { href: "#", onClick: this._delete.bind(this, ticket) },
	                "Delete"
	              )
	            ),
	            _UserStore2.default.isGod() || showTransferHistory ? _react2.default.createElement(
	              "span",
	              null,
	              "\xA0",
	              _react2.default.createElement(
	                "a",
	                { href: "#", onClick: this._viewHistory.bind(this, ticket) },
	                "View History"
	              )
	            ) : null
	          )
	        ) : null
	      );
	    }
	  }, {
	    key: "_onExtensionSubmit",
	    value: function _onExtensionSubmit(form) {
	      _TicketActions2.default.changeTicketsUnlock(_extends({}, form, {
	        ticketIds: Object.keys(this.state.selectedTickets)
	      }));
	    }
	  }, {
	    key: "_onExtensionFormClose",
	    value: function _onExtensionFormClose() {
	      this.setState({ showExtensionsModal: false });
	    }
	  }, {
	    key: "_showExchangeModal",
	    value: function _showExchangeModal(ticketId) {
	      var _this3 = this;
	
	      this.setState({ bulkActionsPopoverOpen: false });
	      var ticketsToExchange = ticketId ? [ticketId] : Object.keys(this.state.selectedTickets);
	      this.setState({
	        ticketsToExchange: ticketsToExchange.map(function (id) {
	          return _this3.props.tickets.find(function (t) {
	            return t.id === id;
	          });
	        })
	      });
	    }
	  }, {
	    key: "_closeExchangeModal",
	    value: function _closeExchangeModal() {
	      this.setState({ ticketsToExchange: null });
	    }
	  }, {
	    key: "_onExchangeTickets",
	    value: function _onExchangeTickets(ticketBucketId, updatedSeats) {
	      _TicketActions2.default.exchangeTickets({
	        ticketBucketId: ticketBucketId,
	        ticketIds: this.state.ticketsToExchange.map(function (t) {
	          return t.id;
	        }),
	        updatedSeats: updatedSeats
	      });
	      this._closeExchangeModal();
	    }
	  }, {
	    key: "_showDeleteModal",
	    value: function _showDeleteModal(ticketId) {
	      var _this4 = this;
	
	      this.setState({ bulkActionsPopoverOpen: false });
	      var ticketsToDelete = ticketId ? [ticketId] : Object.keys(this.state.selectedTickets);
	
	      this.setState({
	        ticketsToDelete: ticketsToDelete.map(function (id) {
	          return _this4.props.tickets.find(function (t) {
	            return t.id === id;
	          });
	        })
	      });
	    }
	  }, {
	    key: "_closeDeleteModal",
	    value: function _closeDeleteModal() {
	      this.setState({ ticketsToDelete: null });
	    }
	  }, {
	    key: "_onDeleteTickets",
	    value: function _onDeleteTickets() {
	      var ticketIds = this.state.ticketsToDelete.map(function (t) {
	        return t.id;
	      });
	      _TicketActions2.default.deleteTickets({
	        ticket_ids: ticketIds
	      });
	
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = ticketIds[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var ticketId = _step.value;
	
	          this.state.deletedTickets[ticketId] = true;
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	
	      this._closeDeleteModal();
	      this.setState({
	        selectedTickets: {}
	      });
	    }
	  }, {
	    key: "_showRefundModal",
	    value: function () {
	      var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee2() {
	        var _this5 = this;
	
	        var ticketIdsToRefund, ticketsToRefund, ordersToRefund, apiKey, refundOptions, mergedRefundOptions, filteredRefundOpts;
	        return regeneratorRuntime.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                this.setState({ bulkActionsPopoverOpen: false });
	                ticketIdsToRefund = Object.keys(this.state.selectedTickets);
	                ticketsToRefund = ticketIdsToRefund.map(function (id) {
	                  return _this5.props.tickets.find(function (t) {
	                    return t.id === id;
	                  });
	                });
	
	                // deduplicate the orders list
	
	                ordersToRefund = Array.from(new Set(ticketsToRefund.map(function (t) {
	                  return t.order || _this5.props.order;
	                })));
	                apiKey = _UserStore2.default.getState().apiKey;
	
	                // get the refund options for all of the orders
	
	                _context2.next = 7;
	                return Promise.all(ordersToRefund.map(function () {
	                  var _ref2 = _asyncToGenerator(regeneratorRuntime.mark(function _callee(orderId) {
	                    return regeneratorRuntime.wrap(function _callee$(_context) {
	                      while (1) {
	                        switch (_context.prev = _context.next) {
	                          case 0:
	                            _context.prev = 0;
	                            _context.next = 3;
	                            return _OrderUtil2.default.generateRefundOptions(apiKey, orderId);
	
	                          case 3:
	                            return _context.abrupt("return", _context.sent);
	
	                          case 6:
	                            _context.prev = 6;
	                            _context.t0 = _context["catch"](0);
	                            return _context.abrupt("return", { error: _context.t0 });
	
	                          case 9:
	                          case "end":
	                            return _context.stop();
	                        }
	                      }
	                    }, _callee, _this5, [[0, 6]]);
	                  }));
	
	                  return function (_x) {
	                    return _ref2.apply(this, arguments);
	                  };
	                }()));
	
	              case 7:
	                refundOptions = _context2.sent;
	
	
	                // merge the options into one array
	                mergedRefundOptions = refundOptions.reduce(function (result, obj) {
	                  return result.concat(obj.options);
	                }, []);
	
	                // filter out only the relevant refund options to the tickets selected
	
	                filteredRefundOpts = mergedRefundOptions.filter(function (option) {
	                  if (!option || option.item.ref_type !== "Ticket") return false;
	
	                  return ticketIdsToRefund.includes(option.item.ref_id);
	                });
	
	
	                this.setState({
	                  ticketsToRefund: ticketsToRefund,
	                  refundOptions: filteredRefundOpts
	                });
	
	              case 11:
	              case "end":
	                return _context2.stop();
	            }
	          }
	        }, _callee2, this);
	      }));
	
	      function _showRefundModal() {
	        return _ref.apply(this, arguments);
	      }
	
	      return _showRefundModal;
	    }()
	  }, {
	    key: "_onRefundTickets",
	    value: function () {
	      var _ref3 = _asyncToGenerator(regeneratorRuntime.mark(function _callee3(options) {
	        var _this6 = this;
	
	        var optionsByOrder, _loop, key, progress, orderId, data, option, ticketId;
	
	        return regeneratorRuntime.wrap(function _callee3$(_context3) {
	          while (1) {
	            switch (_context3.prev = _context3.next) {
	              case 0:
	                optionsByOrder = {};
	
	                _loop = function _loop(key) {
	                  var keySplit = key.split("-");
	                  var item = options.refunds[key];
	                  var id = keySplit[1];
	
	                  var ticket = _this6.props.tickets.find(function (t) {
	                    return t.id === id;
	                  });
	                  var order = ticket.order || _this6.props.order;
	
	                  if (!optionsByOrder[order]) {
	                    optionsByOrder[order] = {};
	                  }
	
	                  optionsByOrder[order][key] = item;
	                };
	
	                for (key in options.refunds) {
	                  _loop(key);
	                }
	
	                this.setState({
	                  ticketsToRefund: null,
	                  refundOptions: null,
	                  bulkRefunding: true,
	                  bulkRefundingOrderCount: Object.keys(optionsByOrder).length,
	                  bulkRefundingProgress: 0
	                });
	
	                progress = 0;
	                _context3.t0 = regeneratorRuntime.keys(optionsByOrder);
	
	              case 6:
	                if ((_context3.t1 = _context3.t0()).done) {
	                  _context3.next = 32;
	                  break;
	                }
	
	                orderId = _context3.t1.value;
	                _context3.prev = 8;
	
	                progress += 1;
	
	                this.setState({
	                  bulkRefundingProgress: progress
	                });
	
	                _context3.next = 13;
	                return _OrderUtil2.default.refund(_UserStore2.default.getState().apiKey, orderId, {
	                  refunds: optionsByOrder[orderId]
	                });
	
	              case 13:
	                data = _context3.sent;
	                _context3.t2 = regeneratorRuntime.keys(optionsByOrder[orderId]);
	
	              case 15:
	                if ((_context3.t3 = _context3.t2()).done) {
	                  _context3.next = 23;
	                  break;
	                }
	
	                option = _context3.t3.value;
	
	                if (option.startsWith("TICKET")) {
	                  _context3.next = 19;
	                  break;
	                }
	
	                return _context3.abrupt("continue", 15);
	
	              case 19:
	                ticketId = option.replace("TICKET-", "");
	
	                this.state.deletedTickets[ticketId] = true;
	                _context3.next = 15;
	                break;
	
	              case 23:
	
	                _OrderActions2.default.updateOrder(data);
	                _LedgerActions2.default.fetchLedgerTransactionsForOrder.defer(orderId); // force ledger update
	                _context3.next = 30;
	                break;
	
	              case 27:
	                _context3.prev = 27;
	                _context3.t4 = _context3["catch"](8);
	
	                console.error("refund on order " + orderId + " failed");
	
	              case 30:
	                _context3.next = 6;
	                break;
	
	              case 32:
	
	                this.setState({
	                  bulkRefundingComplete: true
	                });
	
	              case 33:
	              case "end":
	                return _context3.stop();
	            }
	          }
	        }, _callee3, this, [[8, 27]]);
	      }));
	
	      function _onRefundTickets(_x2) {
	        return _ref3.apply(this, arguments);
	      }
	
	      return _onRefundTickets;
	    }()
	  }, {
	    key: "_closeRefundModal",
	    value: function _closeRefundModal() {
	      this.setState({
	        ticketsToRefund: null,
	        refundOptions: null
	      });
	    }
	  }, {
	    key: "_closeRefundStatusModal",
	    value: function _closeRefundStatusModal() {
	      this.setState({
	        ticketsToRefund: null,
	        refundOptions: null,
	        bulkRefunding: false,
	        bulkRefundingOrderCount: 0,
	        bulkRefundingProgress: 0
	      });
	    }
	  }, {
	    key: "_showBulkScanModal",
	    value: function () {
	      var _ref4 = _asyncToGenerator(regeneratorRuntime.mark(function _callee4() {
	        var ticketsToScan, plural, ticketNames;
	        return regeneratorRuntime.wrap(function _callee4$(_context4) {
	          while (1) {
	            switch (_context4.prev = _context4.next) {
	              case 0:
	                this.setState({ bulkActionsPopoverOpen: false });
	                ticketsToScan = this.ticketsEligibleForScanning(this.state.selectedTickets);
	                plural = ticketsToScan.length !== 1;
	                ticketNames = Array.from(new Set(ticketsToScan.map(function (t) {
	                  return "\"" + t.event.name + "\"";
	                }))).join(", ");
	
	
	                if (window.confirm("Are you sure you want to mark the selected " + ticketsToScan.length + " ticket" + (plural ? "s" : "") + " to " + ticketNames + " as scanned? " + (plural ? "They" : "It") + " will no longer be scannable.")) {
	                  ticketsToScan.forEach(function (t) {
	                    _TicketActions2.default.markAsUsed(t.id);
	                  });
	                }
	
	              case 5:
	              case "end":
	                return _context4.stop();
	            }
	          }
	        }, _callee4, this);
	      }));
	
	      function _showBulkScanModal() {
	        return _ref4.apply(this, arguments);
	      }
	
	      return _showBulkScanModal;
	    }()
	  }, {
	    key: "_showChangeSeatsModal",
	    value: function _showChangeSeatsModal(ticketId) {
	      var _this7 = this;
	
	      this.setState({ bulkActionsPopoverOpen: false });
	      var ticketIds = ticketId ? [ticketId] : Object.keys(this.state.selectedTickets);
	
	      this.setState({
	        ticketsToChangeSeats: ticketIds.map(function (id) {
	          return _this7.props.tickets.find(function (t) {
	            return t.id === id;
	          });
	        })
	      });
	    }
	  }, {
	    key: "_closeChangeSeatsModal",
	    value: function _closeChangeSeatsModal() {
	      this.setState({ ticketsToChangeSeats: null });
	    }
	  }, {
	    key: "_onChangeSeats",
	    value: function _onChangeSeats(seatChangePayload) {
	      _TicketActions2.default.changeSeats(seatChangePayload);
	      this._closeChangeSeatsModal();
	    }
	  }, {
	    key: "ticketsIndexToArray",
	    value: function ticketsIndexToArray(ticketsIndex) {
	      var _this8 = this;
	
	      return Object.keys(ticketsIndex).map(function (id) {
	        return _this8.props.tickets.find(function (t) {
	          return t.id === id;
	        });
	      });
	    }
	  }, {
	    key: "ticketsEligibleForScanning",
	    value: function ticketsEligibleForScanning(ticketsIndex) {
	      var tickets = this.ticketsIndexToArray(ticketsIndex);
	
	      var ticketsEligible = tickets.filter(function (t) {
	        return !t.used_at;
	      });
	
	      return ticketsEligible;
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(props) {
	      if (props.location && props.location.query.ticket && this.table && this.table.data.length) {
	        var rowLocation = this.table.data.findIndex(function (p) {
	          return p.data["Id"].value === props.location.query.ticket;
	        }),
	            neededPage = Math.floor(rowLocation / PAGE_SIZE);
	
	        this.setState({
	          highlightedId: props.location.query.ticket,
	          currentPage: neededPage
	        });
	      }
	      if (!props.isFetching) {
	        this.setState({ showExtensionsModal: false });
	      }
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate() {
	      var _this9 = this;
	
	      if (this.highlightedRow && this.state.highlightedRow !== this.highlightedRow) {
	        this.setState({
	          highlightedRow: this.highlightedRow
	        }, function () {
	          setTimeout(function () {
	            if (_this9.highlightedRow && _this9.highlightedRow.scrollIntoViewIfNeeded) {
	              // chrome only
	              _this9.highlightedRow.scrollIntoViewIfNeeded();
	            } else if (_this9.highlightedRow) {
	              _this9.highlightedRow.scrollIntoView();
	            }
	          }, 0);
	        });
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this10 = this;
	
	      var isSundance = this.props.isSundance;
	      var showTransferHistory = this.props.showTransferHistory;
	      //let rows = this.props.tickets.map(this._makeRowForTicket),
	      var rows = this.props.tickets.map(function (e) {
	        return this._makeRowForTicket(e, isSundance || showTransferHistory);
	      }.bind(this)),
	          ticketCount = this.props.tickets.length,
	          scannedCount = this.props.tickets.filter(function (t) {
	        return t.used_at;
	      }).length,
	          passTicketCount = this.props.tickets.filter(function (t) {
	        return t.pass;
	      }).length,
	          passTicketScannedCount = this.props.tickets.filter(function (t) {
	        return t.pass && t.used_at;
	      }).length,
	          anyPassesUsed = this.props.tickets.some(function (t) {
	        return !!t.pass;
	      }),
	          anySeatsUsed = this.props.tickets.some(function (t) {
	        return !!t.seat;
	      }),
	          anyUnlocks = this.props.tickets.some(function (t) {
	        return !!t.unlocked_until;
	      }),
	          selectedTicketCount = Object.keys(this.state.selectedTickets).length,
	          allTicketsSelected = [0, rows.length].indexOf(selectedTicketCount) !== -1,
	          pendingTransferCount = this.props.tickets.filter(function (t) {
	        return t.pending_transfer;
	      }).length;
	      var _state = this.state;
	      var ticketsToExchange = _state.ticketsToExchange;
	      var ticketsToChangeSeats = _state.ticketsToChangeSeats;
	      var ticketsToDelete = _state.ticketsToDelete;
	      var ticketsToRefund = _state.ticketsToRefund;
	      var refundOptions = _state.refundOptions;
	      var _props = this.props;
	      var tickets = _props.tickets;
	      var eventBucket = _props.eventBucket;
	
	
	      var selectedTicketsEligibleForScanning = this.ticketsEligibleForScanning(this.state.selectedTickets);
	
	      var ticketPluralized = "ticket" + (selectedTicketCount === 1 ? "" : "s");
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        this.props.showStats ? _react2.default.createElement(
	          _statsBlockContainer2.default,
	          null,
	          _react2.default.createElement(_ticketsAtAGlance2.default, { event: this.props.eventDetails }),
	          _react2.default.createElement(_statsBlock2.default, {
	            value: scannedCount,
	            subvalue: ticketCount || "0",
	            label: "Tickets scanned"
	          }),
	          anyPassesUsed ? _react2.default.createElement(_statsBlock2.default, {
	            value: passTicketScannedCount,
	            subvalue: passTicketCount || "0",
	            label: "Passholder tickets scanned"
	          }) : null
	        ) : null,
	        _react2.default.createElement(
	          "div",
	          {
	            style: this.props.order || this.props.person ? { float: "right", marginBottom: -36, marginRight: "-1em" } : { position: "absolute", right: 40, marginTop: 18 }
	          },
	          rows.length && selectedTicketCount > 0 ? _react2.default.createElement(
	            "div",
	            { style: { display: "inline-block" } },
	            _react2.default.createElement(_materialUi.RaisedButton, {
	              label: "Bulk Actions (" + selectedTicketCount + ")",
	              style: { marginRight: "1em" },
	              onTouchTap: function onTouchTap(e) {
	                e.preventDefault();
	                _this10.setState({
	                  bulkActionsPopoverOpen: true,
	                  bulkActionsPopoverAnchorEl: e.currentTarget
	                });
	              }
	            }),
	            _react2.default.createElement(
	              _materialUi.Popover,
	              {
	                open: this.state.bulkActionsPopoverOpen,
	                anchorEl: this.state.bulkActionsPopoverAnchorEl,
	                onRequestClose: function onRequestClose() {
	                  return _this10.setState({ bulkActionsPopoverOpen: false });
	                }
	              },
	              _react2.default.createElement(
	                _materialUi.Menu,
	                { desktop: true },
	                _UserStore2.default.isGod() ? _react2.default.createElement(_materialUi.MenuItem, {
	                  disabled: selectedTicketCount === 0,
	                  primaryText: "Extend " + selectedTicketCount + " ticket" + (selectedTicketCount === 1 ? "" : "s"),
	                  onTouchTap: function onTouchTap() {
	                    return _this10.setState({
	                      showExtensionsModal: true,
	                      bulkActionsPopoverOpen: false
	                    });
	                  }
	                }) : null,
	                _react2.default.createElement(_materialUi.MenuItem, {
	                  disabled: selectedTicketCount === 0,
	                  primaryText: "Refund " + selectedTicketCount + " " + ticketPluralized,
	                  onTouchTap: function onTouchTap() {
	                    return _this10._showRefundModal();
	                  },
	                  style: { marginRight: "1em" }
	                }),
	                _react2.default.createElement(_materialUi.MenuItem, {
	                  disabled: selectedTicketsEligibleForScanning.length === 0,
	                  primaryText: "Mark " + selectedTicketsEligibleForScanning.length + " ticket" + (selectedTicketsEligibleForScanning.length !== 1 ? "s" : "") + " as scanned",
	                  onTouchTap: function onTouchTap() {
	                    return _this10._showBulkScanModal();
	                  },
	                  style: { marginRight: "1em" }
	                }),
	                _react2.default.createElement(_materialUi.MenuItem, {
	                  disabled: selectedTicketCount === 0,
	                  primaryText: "Delete " + selectedTicketCount + " ticket" + (selectedTicketCount === 1 ? "" : "s"),
	                  onTouchTap: function onTouchTap() {
	                    return _this10._showDeleteModal();
	                  },
	                  style: { marginRight: "1em" }
	                }),
	                this.props.tickets.some(function (t) {
	                  return t.seat;
	                }) ? _react2.default.createElement(_materialUi.MenuItem, {
	                  disabled: selectedTicketCount === 0,
	                  primaryText: "Change " + selectedTicketCount + " seat" + (selectedTicketCount === 1 ? "" : "s"),
	                  onTouchTap: function onTouchTap() {
	                    return _this10._showChangeSeatsModal();
	                  },
	                  style: { marginRight: "1em" }
	                }) : null,
	                this.props.order || this.props.person ? _react2.default.createElement(_materialUi.MenuItem, {
	                  disabled: selectedTicketCount === 0,
	                  primaryText: "Exchange " + selectedTicketCount + " ticket" + (selectedTicketCount === 1 ? "" : "s"),
	                  onTouchTap: function onTouchTap() {
	                    return _this10._showExchangeModal();
	                  },
	                  style: { marginRight: "1em" }
	                }) : null,
	                pendingTransferCount > 0 && !this.props.isRevshareView ? _react2.default.createElement(_materialUi.MenuItem, {
	                  primaryText: "Resend transfer" + (pendingTransferCount === 1 ? "" : "s"),
	                  onTouchTap: function onTouchTap() {
	                    if (window.confirm("This will immediately resend the ticket transfer email to all " + pendingTransferCount + " customer" + (pendingTransferCount === 1 ? "" : "s") + " who have not yet accepted their transfer.\n\nPlease use this option with care, as repeated use could lead to your emails being marked as SPAM.\n\nAre you sure you would like to continue?")) {
	                      _TicketActions2.default.resendTransfer(_this10.props.tickets.filter(function (t) {
	                        return t.pending_transfer;
	                      }).map(function (t) {
	                        return t.pending_transfer.id;
	                      }));
	                    }
	                  },
	                  style: { marginRight: "1em" }
	                }) : null
	              )
	            )
	          ) : null,
	          (this.props.order || this.props.person) && rows.length ? _react2.default.createElement(_downloadTicketsPdfButton2.default, _extends({}, this.props, {
	            tickets: Object.keys(this.state.selectedTickets),
	            label: "Download " + (allTicketsSelected ? "all " + (selectedTicketCount || rows.length) : selectedTicketCount) + " ticket" + (selectedTicketCount === 1 || rows.length === 1 ? "" : "s"),
	            style: { marginRight: "1em" }
	          })) : null
	        ),
	        this.props.event ? _react2.default.createElement(_tableRefreshIndicator2.default, {
	          isRefreshing: this.props.isFetching,
	          onRefresh: this._refresh,
	          style: { marginTop: 15 }
	        }) : null,
	        _react2.default.createElement(
	          _reactable.Table,
	          {
	            ref: function ref(r) {
	              _this10.table = r;
	            },
	            className: "bordered striped responsive-table",
	            sortable: [{ column: "Order Date", sortFunction: _reactable.Sort.Date }, { column: "Scan Date", sortFunction: _reactable.Sort.Date }, { column: "Unlock Status", sortFunction: _reactable.Sort.CaseInsensitive }, { column: "Event Date", sortFunction: _reactable.Sort.Date }, { column: "Event", sortFunction: _reactable.Sort.CaseInsensitive }, "Ticket Bucket", { column: "Pass Used", sortFunction: _reactable.Sort.CaseInsensitive }, { column: "Person", sortFunction: _reactable.Sort.CaseInsensitive }],
	            defaultSort: { column: "Event Date", direction: "asc" },
	            columns: (rows.length ? [{
	              key: " ",
	              label: _react2.default.createElement(_materialUi.Checkbox, {
	                iconStyle: { fill: "#fff" },
	                checked: selectedTicketCount === rows.length,
	                onCheck: this._onCheckAll
	              })
	            }] : []).concat(this.props.showEvent ? ["Event"] : []).concat(this.props.showPerson || pendingTransferCount ? ["Person"] : []).concat(anyPassesUsed ? ["Pass Used"] : []).concat(["Ticket Bucket"]).concat(anySeatsUsed ? ["Seat"] : []).concat(this.props.showEvent ? ["Event Date"] : []).concat(["Order Date", "Scan Date"]).concat(anyUnlocks ? ["Unlock Status"] : []).concat(_UserStore2.default.hasPermission("manage_orders") && !this.props.isRevshareView ? ["Actions"] : []),
	            filterable: ["Person", "Event", "Pass Used", "Name", "Ticket Bucket"],
	            filterPlaceholder: "Type to filter...",
	            itemsPerPage: ticketCount > PAGE_SIZE ? PAGE_SIZE : undefined,
	            currentPage: this.state.currentPage,
	            onPageChange: function onPageChange(p) {
	              return _this10.setState({ currentPage: p });
	            }
	          },
	          rows
	        ),
	        rows.length === 0 && !this.props.hideNoTicketsMessage ? _react2.default.createElement(
	          "div",
	          { className: "empty-table-message" },
	          "No tickets yet."
	        ) : null,
	        _UserStore2.default.isGod() && selectedTicketCount ? _react2.default.createElement(
	          "div",
	          {
	            style: {
	              marginTop: 5,
	              color: "rgba(0,0,0,0.6)",
	              fontSize: "0.8em"
	            }
	          },
	          "[God Only] Selected tickets:",
	          " ",
	          Object.keys(this.state.selectedTickets).join(", ")
	        ) : null,
	        _react2.default.createElement(_godTicketsExtension2.default, {
	          open: this.state.showExtensionsModal,
	          submitting: this.props.isFetching,
	          ticketsLength: selectedTicketCount,
	          onClose: this._onExtensionFormClose,
	          submit: this._onExtensionSubmit
	        }),
	        !!ticketsToExchange ? _react2.default.createElement(_exchangeOverlay2.default, {
	          submitting: this.props.isFetching,
	          tickets: ticketsToExchange,
	          eventBucketId: eventBucket || (tickets[0] ? tickets[0].event.event_bucket : ""),
	          onClose: this._closeExchangeModal,
	          onExchange: this._onExchangeTickets
	        }) : null,
	        this.state.bulkRefunding ? _react2.default.createElement(_loading2.default, {
	          onRequestClose: this._closeRefundStatusModal,
	          message: this.state.bulkRefundingComplete ? "Refunds complete!" : "Refunding " + this.state.bulkRefundingProgress + "/" + this.state.bulkRefundingOrderCount + " orders",
	          complete: this.state.bulkRefundingComplete
	        }) : null,
	        !!ticketsToRefund ? _react2.default.createElement(_refund2.default, {
	          options: refundOptions,
	          onRefund: this._onRefundTickets,
	          refundErrorMessage: this.state.refundErrorMessage,
	          onRequestClose: this._closeRefundModal
	        }) : null,
	        !!ticketsToDelete ? _react2.default.createElement(_bulkDeleteOverlay2.default, {
	          submitting: this.props.isFetching,
	          items: ticketsToDelete,
	          itemName: "ticket" + (ticketsToDelete.length !== 1 ? "s" : ""),
	          eventBucketId: eventBucket || (tickets[0] ? tickets[0].event.event_bucket : ""),
	          onClose: this._closeDeleteModal,
	          onDelete: this._onDeleteTickets
	        }) : null,
	        !!ticketsToChangeSeats ? _react2.default.createElement(_changeSeatsOverlay2.default, {
	          submitting: this.props.isFetching,
	          tickets: ticketsToChangeSeats,
	          onClose: this._closeChangeSeatsModal,
	          onChangeSeats: this._onChangeSeats
	        }) : null,
	        this.state.currentlyTransferring ? _react2.default.createElement(_transferOverlay2.default, {
	          onRequestClose: this._closeTransferModal,
	          onTransfer: this._submitTransfer,
	          type: "ticket"
	        }) : null
	      );
	    }
	  }], [{
	    key: "contextTypes",
	    get: function get() {
	      return {
	        router: _react2.default.PropTypes.object
	      };
	    }
	  }]);
	
	  return TicketTable;
	}(_react2.default.Component);
	
	exports.default = TicketTable;
	module.exports = exports["default"];

/***/ }),
/* 2695 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _statsBlock = __webpack_require__(1741);
	
	var _statsBlock2 = _interopRequireDefault(_statsBlock);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TicketsAtAGlance = function (_React$Component) {
	  _inherits(TicketsAtAGlance, _React$Component);
	
	  function TicketsAtAGlance() {
	    _classCallCheck(this, TicketsAtAGlance);
	
	    return _possibleConstructorReturn(this, Object.getPrototypeOf(TicketsAtAGlance).apply(this, arguments));
	  }
	
	  _createClass(TicketsAtAGlance, [{
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement(_statsBlock2.default, {
	        value: this.props.event.quantity_sold,
	        subvalue: this.props.event.unlimited ? "∞" : this.props.event.quantity,
	        label: "Tickets issued"
	      });
	    }
	  }]);
	
	  return TicketsAtAGlance;
	}(_react2.default.Component);
	
	exports.default = TicketsAtAGlance;
	module.exports = exports["default"];

/***/ }),
/* 2696 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _materialUi = __webpack_require__(576);
	
	var _Popover = __webpack_require__(860);
	
	var _qs = __webpack_require__(1206);
	
	var _qs2 = _interopRequireDefault(_qs);
	
	var _TicketActions = __webpack_require__(2697);
	
	var _TicketActions2 = _interopRequireDefault(_TicketActions);
	
	var _config = __webpack_require__(1173);
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DownloadTicketsPdfButton = function (_React$Component) {
	  _inherits(DownloadTicketsPdfButton, _React$Component);
	
	  function DownloadTicketsPdfButton(props) {
	    _classCallCheck(this, DownloadTicketsPdfButton);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(DownloadTicketsPdfButton).call(this, props));
	
	    _this.state = {
	      open: false,
	      anchorEl: null
	    };
	
	    _this._onClick = _this._onClick.bind(_this);
	    _this._onClose = _this._onClose.bind(_this);
	    _this.download = _this.download.bind(_this);
	    return _this;
	  }
	
	  _createClass(DownloadTicketsPdfButton, [{
	    key: "_onClick",
	    value: function _onClick(e) {
	      e.preventDefault();
	
	      this.setState({
	        open: true,
	        anchorEl: e.currentTarget
	      });
	    }
	  }, {
	    key: "_onClose",
	    value: function _onClose() {
	      this.setState({ open: false });
	    }
	  }, {
	    key: "download",
	    value: function download(forTicketPrinter) {
	      _TicketActions2.default.downloadPdf({
	        _id: this.props.tickets && this.props.tickets.length ? { $in: this.props.tickets } : undefined,
	        person: this.props.order ? undefined : this.props.person,
	        order: this.props.order,
	        event_bucket: this.props.eventBucket,
	        for_ticket_printer: forTicketPrinter ? true : undefined
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props;
	      var style = _props.style;
	      var label = _props.label;
	
	
	      return _react2.default.createElement(
	        "div",
	        { style: Object.assign({ display: "inline-block" }, style) },
	        _react2.default.createElement(_materialUi.RaisedButton, { label: label, onTouchTap: this._onClick }),
	        _react2.default.createElement(
	          _materialUi.Popover,
	          {
	            open: this.state.open,
	            anchorEl: this.state.anchorEl,
	            onRequestClose: this._onClose,
	            animation: _Popover.PopoverAnimationVertical
	          },
	          _react2.default.createElement(
	            _materialUi.Menu,
	            { desktop: true },
	            _react2.default.createElement(_materialUi.MenuItem, {
	              primaryText: "Download full page tickets",
	              onTouchTap: function onTouchTap() {
	                return _this2.download(false);
	              }
	            }),
	            _react2.default.createElement(_materialUi.MenuItem, {
	              primaryText: "Download ticket-stock tickets",
	              onTouchTap: function onTouchTap() {
	                return _this2.download(true);
	              }
	            })
	          )
	        )
	      );
	    }
	  }]);
	
	  return DownloadTicketsPdfButton;
	}(_react2.default.Component);
	
	exports.default = DownloadTicketsPdfButton;
	module.exports = exports["default"];

/***/ }),
/* 2697 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _alt = __webpack_require__(975);
	
	var _alt2 = _interopRequireDefault(_alt);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var TicketActions = function () {
	  function TicketActions() {
	    _classCallCheck(this, TicketActions);
	
	    this.generateActions("updateTickets", "fetchAllForPerson", "fetchAllForEvent", "fetchOne", "fetchFailed", "delete", "deleteTickets", "markAsUsed", "downloadPdf", "changeTicketsUnlock", "cancelTransfer", "resendTransfer", "editFailed", "exchangeTickets", "changeSeats");
	  }
	
	  _createClass(TicketActions, [{
	    key: "fetchTicketTransferHistory",
	    value: function fetchTicketTransferHistory(ticketId, eventBucketId) {
	      return { ticketId: ticketId, eventBucketId: eventBucketId };
	    }
	  }, {
	    key: "updateTicket",
	    value: function updateTicket(id, ticket) {
	      return { id: id, ticket: ticket };
	    }
	  }, {
	    key: "transfer",
	    value: function transfer(ids, recipient) {
	      return { ids: ids, recipient: recipient };
	    }
	  }]);
	
	  return TicketActions;
	}();
	
	exports.default = _alt2.default.createActions(TicketActions);
	module.exports = exports["default"];

/***/ }),
/* 2698 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _moment = __webpack_require__(1021);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _materialUi = __webpack_require__(576);
	
	var _set = __webpack_require__(1188);
	
	var _set2 = _interopRequireDefault(_set);
	
	var _juration = __webpack_require__(1772);
	
	var _juration2 = _interopRequireDefault(_juration);
	
	var _base = __webpack_require__(1755);
	
	var _base2 = _interopRequireDefault(_base);
	
	var _durationField = __webpack_require__(2054);
	
	var _durationField2 = _interopRequireDefault(_durationField);
	
	var _datetimeField = __webpack_require__(2061);
	
	var _datetimeField2 = _interopRequireDefault(_datetimeField);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var GodTicketsExtension = function (_React$Component) {
	  _inherits(GodTicketsExtension, _React$Component);
	
	  function GodTicketsExtension(props) {
	    _classCallCheck(this, GodTicketsExtension);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(GodTicketsExtension).call(this, props));
	
	    _this.onChange = function (id, value) {
	      _this.setState(_defineProperty({}, id, value));
	    };
	
	    _this.submitExtension = function () {
	      _this.props.submit(_this.state);
	    };
	
	    _this.state = {
	      type: "unlock",
	      mode: "fromNow",
	      length: _juration2.default.parse("7 days") * 1000,
	      date: (0, _moment2.default)().add(7, "days")
	    };
	    return _this;
	  }
	
	  _createClass(GodTicketsExtension, [{
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var _state = this.state;
	      var type = _state.type;
	      var mode = _state.mode;
	      var length = _state.length;
	      var date = _state.date;
	      var _props = this.props;
	      var ticketsLength = _props.ticketsLength;
	      var open = _props.open;
	      var submitting = _props.submitting;
	      var onClose = _props.onClose;
	
	
	      return _react2.default.createElement(
	        _base2.default,
	        {
	          open: open,
	          onRequestClose: onClose,
	          hideTitleAndFooterBorders: true,
	          showCloseButton: true,
	          actions: [_react2.default.createElement(_materialUi.FlatButton, { label: "Cancel", onTouchTap: onClose }), _react2.default.createElement(_materialUi.FlatButton, {
	            primary: true,
	            disabled: submitting,
	            label: submitting ? "Submitting extension..." : "Submit extension",
	            onTouchTap: this.submitExtension
	          })]
	        },
	        _react2.default.createElement(
	          "h2",
	          null,
	          "Extend ",
	          ticketsLength,
	          " ticket",
	          ticketsLength !== 1 ? "s" : ""
	        ),
	        _react2.default.createElement(
	          "div",
	          { style: { marginTop: 20 } },
	          _react2.default.createElement(
	            "h3",
	            null,
	            "Extension type"
	          ),
	          _react2.default.createElement(
	            _materialUi.RadioButtonGroup,
	            {
	              name: "extensionType",
	              valueSelected: type,
	              onChange: function onChange(e, v) {
	                return _this2.onChange("type", v);
	              }
	            },
	            _react2.default.createElement(_materialUi.RadioButton, { value: "unlock", label: "Unlock window" }),
	            _react2.default.createElement(_materialUi.RadioButton, { value: "watch", label: "Watch window" })
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { style: { marginTop: 20 } },
	          _react2.default.createElement(
	            "h3",
	            null,
	            "Extension mode"
	          ),
	          _react2.default.createElement(
	            _materialUi.RadioButtonGroup,
	            {
	              name: "extensionMode",
	              valueSelected: mode,
	              onChange: function onChange(e, v) {
	                return _this2.onChange("mode", v);
	              }
	            },
	            _react2.default.createElement(_materialUi.RadioButton, { value: "fromNow", label: "Add time from now" }),
	            _react2.default.createElement(_materialUi.RadioButton, {
	              value: "fromCurrent",
	              label: "Add time from current " + (type === "unlock" ? "unlock" : "watch expiry") + " time"
	            }),
	            _react2.default.createElement(_materialUi.RadioButton, {
	              value: "fromUsedAt",
	              label: "Add time from when scanned/\"Watch now\" clicked"
	            }),
	            _react2.default.createElement(_materialUi.RadioButton, { value: "absolute", label: "Set absolute date" })
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { style: { marginTop: 20 } },
	          _react2.default.createElement(
	            "h3",
	            { style: { marginBottom: -10 } },
	            "Extension ",
	            mode === "absolute" ? "date" : "length"
	          ),
	          mode === "absolute" ? _react2.default.createElement(_datetimeField2.default, {
	            value: date,
	            useMoment: true,
	            unclearable: true,
	            onChange: function onChange(e, v) {
	              return _this2.onChange("date", v);
	            },
	            style: { display: "inline-block" }
	          }) : _react2.default.createElement(_durationField2.default, {
	            value: length,
	            floatingLabelFixed: false,
	            onChange: function onChange(e) {
	              return _this2.onChange("length", e.target.value);
	            }
	          })
	        )
	      );
	    }
	  }]);
	
	  return GodTicketsExtension;
	}(_react2.default.Component);
	
	exports.default = GodTicketsExtension;
	module.exports = exports["default"];

/***/ }),
/* 2699 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _materialUi = __webpack_require__(576);
	
	var _base = __webpack_require__(1755);
	
	var _base2 = _interopRequireDefault(_base);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var styles = {
	  note: {
	    marginTop: "1em",
	    fontSize: "0.8em"
	  }
	};
	
	var TransferOverlay = function (_React$Component) {
	  _inherits(TransferOverlay, _React$Component);
	
	  function TransferOverlay(props) {
	    _classCallCheck(this, TransferOverlay);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(TransferOverlay).call(this, props));
	
	    _this.state = {
	      recipient: ""
	    };
	
	    _this.transfer = _this.transfer.bind(_this);
	    return _this;
	  }
	
	  _createClass(TransferOverlay, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.componentWillReceiveProps(this.props);
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(props) {}
	  }, {
	    key: "transfer",
	    value: function transfer() {
	      this.props.onTransfer(this.state.recipient);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props;
	      var onRequestClose = _props.onRequestClose;
	      var bulkCount = _props.bulkCount;
	      var typeName = _props.typeName;
	      var type = _props.type;
	
	
	      var itemName = typeName || type;
	
	      return _react2.default.createElement(
	        _base2.default,
	        {
	          onRequestClose: onRequestClose,
	          useMuiDefaultStyle: true,
	          actions: [_react2.default.createElement(_materialUi.FlatButton, { label: "Cancel", onTouchTap: onRequestClose }), _react2.default.createElement(_materialUi.FlatButton, {
	            primary: true,
	            label: "Transfer " + (bulkCount ? bulkCount + " " + itemName : ""),
	            onTouchTap: this.transfer,
	            disabled: !this.state.recipient
	          })]
	        },
	        _react2.default.createElement(
	          "div",
	          null,
	          "Please enter a recipient for the ",
	          itemName,
	          " transfer."
	        ),
	        _react2.default.createElement(_materialUi.TextField, {
	          floatingLabelText: "Recipient email address",
	          floatingLabelFixed: true,
	          value: this.state.recipient,
	          onChange: function onChange(e) {
	            return _this2.setState({ recipient: e.target.value });
	          }
	        }),
	        _react2.default.createElement(
	          "div",
	          { style: styles.note },
	          "Note: The transfer will remain pending until the recipient accepts the transfer by clicking the link that they will receive via email."
	        )
	      );
	    }
	  }]);
	
	  return TransferOverlay;
	}(_react2.default.Component);
	
	exports.default = TransferOverlay;
	module.exports = exports["default"];

/***/ }),
/* 2700 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _materialUi = __webpack_require__(576);
	
	var _base = __webpack_require__(1755);
	
	var _base2 = _interopRequireDefault(_base);
	
	var _injectedSelect = __webpack_require__(1874);
	
	var _injectedSelect2 = _interopRequireDefault(_injectedSelect);
	
	var _util = __webpack_require__(1183);
	
	var _UserStore = __webpack_require__(974);
	
	var _UserStore2 = _interopRequireDefault(_UserStore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var styles = {
	  container: {
	    marginTop: "1em"
	  },
	  selectContainer: {
	    marginTop: "1em"
	  }
	};
	
	var ExchangeOverlay = function (_React$Component) {
	  _inherits(ExchangeOverlay, _React$Component);
	
	  function ExchangeOverlay(props) {
	    _classCallCheck(this, ExchangeOverlay);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(ExchangeOverlay).call(this, props));
	
	    _this.state = {
	      ticketBucket: null,
	      seatSelectionEventId: null,
	      newSeats: {}
	    };
	
	    _this.exchange = _this.exchange.bind(_this);
	    return _this;
	  }
	
	  _createClass(ExchangeOverlay, [{
	    key: "_getTicketCount",
	    value: function _getTicketCount(bucket) {
	      return bucket.unlimited ? "unlimited" : Math.max(bucket.quantity_remaining, 0);
	    }
	  }, {
	    key: "_canUseTicket",
	    value: function _canUseTicket(bucket) {
	      if (!bucket.lock_admin_only || _UserStore2.default.hasRole("admin")) return true;
	
	      var requiredRoles = bucket.lock_admin_only_role && bucket.lock_admin_only_role.split(",") || [];
	
	      return _UserStore2.default.hasRole(requiredRoles);
	    }
	  }, {
	    key: "exchange",
	    value: function exchange() {
	      this.props.onExchange(this.state.ticketBucket, this.state.newSeats);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _React$createElement,
	          _this2 = this;
	
	      var _props = this.props;
	      var submitting = _props.submitting;
	      var tickets = _props.tickets;
	      var eventBucketId = _props.eventBucketId;
	      var onClose = _props.onClose;
	      var ticketBucket = this.state.ticketBucket;
	
	      var ticketsLength = tickets.length;
	
	      return _react2.default.createElement(
	        _base2.default,
	        {
	          onRequestClose: onClose,
	          hideTitleAndFooterBorders: true,
	          showCloseButton: true,
	          useMuiDefaultStyle: true,
	          disableBackgroundDismiss: true,
	          actions: [_react2.default.createElement(_materialUi.FlatButton, { label: "Cancel", onClick: onClose }), _react2.default.createElement(_materialUi.FlatButton, (_React$createElement = {
	            primary: true,
	            label: "Exchange",
	            disabled: submitting || !ticketBucket || this.state.seatSelectionEventId && Object.values(this.state.newSeats).filter(function (s) {
	              return !!s;
	            }).length !== ticketsLength
	          }, _defineProperty(_React$createElement, "label", submitting ? "Exchanging..." : "Exchange"), _defineProperty(_React$createElement, "onClick", this.exchange), _React$createElement))]
	        },
	        _react2.default.createElement(
	          "h2",
	          null,
	          "Exchange ",
	          ticketsLength,
	          " ticket",
	          ticketsLength !== 1 ? "s" : ""
	        ),
	        _react2.default.createElement(
	          "div",
	          { style: styles.container },
	          "Select a new ticket bucket to exchange the ticket",
	          ticketsLength !== 1 ? "s" : "",
	          ". The customer will not be charged. A confirmation email will be sent to the customer."
	        ),
	        _react2.default.createElement(
	          "div",
	          { style: styles.selectContainer },
	          _react2.default.createElement(_injectedSelect2.default, {
	            value: this.state.ticketBucket,
	            type: "ticket_buckets",
	            eventBucketId: eventBucketId,
	            placeholder: "Select ticket bucket",
	            labelFormatter: function labelFormatter(b) {
	              var count = _this2._getTicketCount(b);
	
	              return _react2.default.createElement(
	                "div",
	                null,
	                _react2.default.createElement(
	                  "div",
	                  null,
	                  count === 0 ? "[SOLD OUT] " : "",
	                  _react2.default.createElement(
	                    "strong",
	                    null,
	                    b.event.name,
	                    " \u2013 ",
	                    b.name
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  null,
	                  (0, _util.makeEventDateRangeLabel)(b.event)
	                ),
	                _react2.default.createElement(
	                  "div",
	                  null,
	                  b.event.venue ? b.event.venue.name : null
	                )
	              );
	            },
	            labelToFilterString: function labelToFilterString(b) {
	              return b.event.name + " - " + b.name;
	            },
	            changeValueFunction: function changeValueFunction(o) {
	              return o;
	            },
	            onChange: function onChange(selected) {
	              _this2.setState({ ticketBucket: selected ? selected.id : null });
	
	              var needsSeatSelection = !!(selected && selected.event.venue && selected.event.venue.use_reserved_seating);
	              if (needsSeatSelection) {
	                _this2.setState({ seatSelectionEventId: selected.event.id }, function () {
	                  _this2.chart = new seatsio.SeatingChart({
	                    divId: "seatingChart",
	                    workspaceKey: ("de0b391e-8c72-47c5-92d5-ced3b9b4c612"),
	                    event: selected.event.id,
	                    onObjectSelected: function onObjectSelected(object) {
	                      var updated = _extends({}, _this2.state.newSeats);
	
	                      // If one of the seats is deselected, set it first
	                      var _iteratorNormalCompletion = true;
	                      var _didIteratorError = false;
	                      var _iteratorError = undefined;
	
	                      try {
	                        for (var _iterator = tickets[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                          var ticket = _step.value;
	
	                          if (!updated[ticket.id]) {
	                            updated[ticket.id] = object.label;
	                            _this2.setState({ newSeats: updated });
	                            return;
	                          }
	                        }
	
	                        // Otherwise, just replace the first object
	                      } catch (err) {
	                        _didIteratorError = true;
	                        _iteratorError = err;
	                      } finally {
	                        try {
	                          if (!_iteratorNormalCompletion && _iterator.return) {
	                            _iterator.return();
	                          }
	                        } finally {
	                          if (_didIteratorError) {
	                            throw _iteratorError;
	                          }
	                        }
	                      }
	
	                      var previous = updated[tickets[0].id];
	                      updated[tickets[0].id] = object.label;
	                      _this2.chart.deselectObjects([previous]);
	                      _this2.setState({ newSeats: updated });
	                    },
	                    onObjectDeselected: function onObjectDeselected(object) {
	                      var updated = _extends({}, _this2.state.newSeats);
	                      Object.keys(updated).forEach(function (id) {
	                        if (updated[id] === object.label) {
	                          delete updated[id];
	                        }
	                      });
	                      _this2.setState({ newSeats: updated });
	                    }
	                  }).render();
	                });
	              } else {
	                _this2.setState({ seatSelectionEventId: null });
	              }
	            },
	            isDisabledFunction: function isDisabledFunction(bucket) {
	              return _this2._getTicketCount(bucket) === 0 || !_this2._canUseTicket(bucket);
	            }
	          })
	        ),
	        this.state.seatSelectionEventId ? _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement(
	            "div",
	            { style: styles.selectContainer },
	            _react2.default.createElement("div", { id: "seatingChart", style: { height: 400 } })
	          ),
	          _react2.default.createElement(
	            "div",
	            { style: styles.selectContainer },
	            "When you click Exchange, the following exchanges will be applied and the customer will receive updated tickets via email:"
	          ),
	          _react2.default.createElement(
	            "div",
	            { style: { textAlign: "center", marginTop: "1em" } },
	            tickets.map(function (t, i) {
	              return _react2.default.createElement(
	                "div",
	                {
	                  style: {
	                    marginTop: "0.25em",
	                    fontWeight: "bold",
	                    fontSize: "1.25em"
	                  }
	                },
	                "Ticket #",
	                i + 1,
	                " (",
	                t.seat || "No seat",
	                ") \u2192",
	                " ",
	                _this2.state.newSeats[t.id] || "Not yet selected"
	              );
	            })
	          )
	        ) : null
	      );
	    }
	  }]);
	
	  return ExchangeOverlay;
	}(_react2.default.Component);
	
	exports.default = ExchangeOverlay;
	module.exports = exports["default"];

/***/ }),
/* 2701 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _materialUi = __webpack_require__(576);
	
	var _base = __webpack_require__(1755);
	
	var _base2 = _interopRequireDefault(_base);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var styles = {
	  container: {
	    marginTop: "1em"
	  },
	  selectContainer: {
	    marginTop: "1em"
	  }
	};
	
	var BulkDeleteOverlay = function (_React$Component) {
	  _inherits(BulkDeleteOverlay, _React$Component);
	
	  function BulkDeleteOverlay(props) {
	    _classCallCheck(this, BulkDeleteOverlay);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(BulkDeleteOverlay).call(this, props));
	
	    _this.state = {
	      deleteConfirmation: null
	    };
	
	    _this.delete = _this.delete.bind(_this);
	    return _this;
	  }
	
	  _createClass(BulkDeleteOverlay, [{
	    key: "delete",
	    value: function _delete() {
	      this.props.onDelete();
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props;
	      var submitting = _props.submitting;
	      var items = _props.items;
	      var onClose = _props.onClose;
	      var itemName = _props.itemName;
	
	      var itemsLength = items.length;
	
	      return _react2.default.createElement(
	        _base2.default,
	        {
	          onRequestClose: onClose,
	          hideTitleAndFooterBorders: true,
	          showCloseButton: true,
	          useMuiDefaultStyle: true,
	          disableBackgroundDismiss: true,
	          actions: [_react2.default.createElement(_materialUi.FlatButton, { label: "Cancel", onClick: onClose }), _react2.default.createElement(_materialUi.FlatButton, {
	            primary: true,
	            disabled: submitting || this.state.deleteConfirmation !== itemsLength.toString(),
	            label: submitting ? "Deleting..." : "Delete",
	            onClick: this.delete
	          })]
	        },
	        _react2.default.createElement(
	          "h2",
	          null,
	          "Delete ",
	          itemsLength,
	          " ",
	          itemName
	        ),
	        _react2.default.createElement(
	          "div",
	          { style: styles.container },
	          _react2.default.createElement(
	            "p",
	            null,
	            "Are you sure you want to delete ",
	            itemsLength,
	            " ",
	            itemName,
	            "?"
	          ),
	          _react2.default.createElement(
	            "p",
	            null,
	            "This action cannot be undone."
	          ),
	          _react2.default.createElement(
	            "p",
	            null,
	            "Type `",
	            itemsLength,
	            "` below to confirm that you are deleting",
	            " ",
	            itemsLength,
	            " ",
	            itemName,
	            "."
	          ),
	          _react2.default.createElement(_materialUi.TextField, {
	            value: this.state.deleteConfirmation,
	            floatingLabelText: "Confirmation",
	            floatingLabelFixed: true,
	            onChange: function onChange(e) {
	              return _this2.setState({ deleteConfirmation: e.target.value });
	            }
	          })
	        )
	      );
	    }
	  }]);
	
	  return BulkDeleteOverlay;
	}(_react2.default.Component);
	
	exports.default = BulkDeleteOverlay;
	module.exports = exports["default"];

/***/ }),
/* 2702 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _materialUi = __webpack_require__(576);
	
	var _base = __webpack_require__(1755);
	
	var _base2 = _interopRequireDefault(_base);
	
	var _injectedSelect = __webpack_require__(1874);
	
	var _injectedSelect2 = _interopRequireDefault(_injectedSelect);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var styles = {
	  container: {
	    marginTop: "1em"
	  },
	  selectContainer: {
	    marginTop: "1em"
	  }
	};
	
	var ChangeSeatsOverlay = function (_React$Component) {
	  _inherits(ChangeSeatsOverlay, _React$Component);
	
	  function ChangeSeatsOverlay(props) {
	    _classCallCheck(this, ChangeSeatsOverlay);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(ChangeSeatsOverlay).call(this, props));
	
	    _this.state = {
	      newSeats: {}
	    };
	
	    _this.changeSeats = _this.changeSeats.bind(_this);
	    return _this;
	  }
	
	  _createClass(ChangeSeatsOverlay, [{
	    key: "changeSeats",
	    value: function changeSeats() {
	      this.props.onChangeSeats(this.state.newSeats);
	    }
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      var tickets = this.props.tickets;
	
	
	      var event = tickets[0].event.id;
	
	      this.chart = new seatsio.SeatingChart({
	        divId: "seatingChart",
	        workspaceKey: ("de0b391e-8c72-47c5-92d5-ced3b9b4c612"),
	        event: event,
	        selectableObjects: tickets.map(function (t) {
	          return t.seat;
	        }).filter(function (x) {
	          return !!x;
	        }),
	        onObjectSelected: function onObjectSelected(object) {
	          var updated = _extends({}, _this2.state.newSeats);
	
	          // If one of the seats is deselected, set it first
	          var _iteratorNormalCompletion = true;
	          var _didIteratorError = false;
	          var _iteratorError = undefined;
	
	          try {
	            for (var _iterator = tickets[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	              var ticket = _step.value;
	
	              if (!updated[ticket.id]) {
	                updated[ticket.id] = object.label;
	                _this2.setState({ newSeats: updated });
	                return;
	              }
	            }
	
	            // Otherwise, just replace the first object
	          } catch (err) {
	            _didIteratorError = true;
	            _iteratorError = err;
	          } finally {
	            try {
	              if (!_iteratorNormalCompletion && _iterator.return) {
	                _iterator.return();
	              }
	            } finally {
	              if (_didIteratorError) {
	                throw _iteratorError;
	              }
	            }
	          }
	
	          var previous = updated[tickets[0].id];
	          updated[tickets[0].id] = object.label;
	          _this2.chart.deselectObjects([previous]);
	          _this2.setState({ newSeats: updated });
	        },
	        onObjectDeselected: function onObjectDeselected(object) {
	          var updated = _extends({}, _this2.state.newSeats);
	          Object.keys(updated).forEach(function (id) {
	            if (updated[id] === object.label) {
	              delete updated[id];
	            }
	          });
	          _this2.setState({ newSeats: updated });
	        }
	      }).render();
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this3 = this;
	
	      var _props = this.props;
	      var submitting = _props.submitting;
	      var tickets = _props.tickets;
	      var onClose = _props.onClose;
	      var newSeats = this.state.newSeats;
	
	
	      var isReady = Object.keys(newSeats).length === tickets.length;
	
	      return _react2.default.createElement(
	        _base2.default,
	        {
	          onRequestClose: onClose,
	          hideTitleAndFooterBorders: true,
	          showCloseButton: true,
	          useMuiDefaultStyle: true,
	          actions: [_react2.default.createElement(_materialUi.FlatButton, { label: "Cancel", onClick: onClose }), _react2.default.createElement(_materialUi.FlatButton, {
	            primary: true,
	            disabled: submitting || !isReady,
	            label: submitting ? "Changing seats..." : "Change seats",
	            onClick: this.changeSeats
	          })]
	        },
	        _react2.default.createElement(
	          "h2",
	          null,
	          "Change ",
	          tickets.length,
	          " seat",
	          tickets.length !== 1 ? "s" : ""
	        ),
	        _react2.default.createElement(
	          "div",
	          { style: styles.container },
	          "Select the new seat",
	          tickets.length !== 1 ? "s" : "",
	          " below. The customer will not be charged. A confirmation email will be sent to the customer."
	        ),
	        _react2.default.createElement(
	          "div",
	          { style: styles.selectContainer },
	          _react2.default.createElement("div", { id: "seatingChart", style: { height: 400 } })
	        ),
	        _react2.default.createElement(
	          "div",
	          { style: styles.selectContainer },
	          "When you click Change Seats, the following seating changes will be applied and the customer will receive updated tickets via email:"
	        ),
	        _react2.default.createElement(
	          "div",
	          { style: { textAlign: "center", marginTop: "1em" } },
	          tickets.map(function (t) {
	            return _react2.default.createElement(
	              "div",
	              {
	                style: {
	                  marginTop: "0.25em",
	                  fontWeight: "bold",
	                  fontSize: "1.25em"
	                }
	              },
	              t.seat || "No seat",
	              " \u2192",
	              " ",
	              _this3.state.newSeats[t.id] || "Not yet selected"
	            );
	          })
	        )
	      );
	    }
	  }]);
	
	  return ChangeSeatsOverlay;
	}(_react2.default.Component);
	
	exports.default = ChangeSeatsOverlay;
	module.exports = exports["default"];

/***/ }),
/* 2703 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _materialUi = __webpack_require__(576);
	
	var _base = __webpack_require__(1755);
	
	var _base2 = _interopRequireDefault(_base);
	
	var _currencyField = __webpack_require__(1747);
	
	var _currencyField2 = _interopRequireDefault(_currencyField);
	
	var _workingIndicator = __webpack_require__(1664);
	
	var _workingIndicator2 = _interopRequireDefault(_workingIndicator);
	
	var _util = __webpack_require__(1183);
	
	var _reactable = __webpack_require__(1688);
	
	var _UserStore = __webpack_require__(974);
	
	var _UserStore2 = _interopRequireDefault(_UserStore);
	
	var _OrderUtil = __webpack_require__(2051);
	
	var _OrderUtil2 = _interopRequireDefault(_OrderUtil);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var styles = {
	  note: {
	    marginTop: "1em",
	    fontSize: "0.8em"
	  }
	};
	
	var RefundOverlay = function (_React$Component) {
	  _inherits(RefundOverlay, _React$Component);
	
	  function RefundOverlay(props) {
	    _classCallCheck(this, RefundOverlay);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(RefundOverlay).call(this, props));
	
	    _this.state = {
	      amount: null,
	      options: null,
	      refunds: {}
	    };
	
	    _this.refund = _this.refund.bind(_this);
	    return _this;
	  }
	
	  _createClass(RefundOverlay, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      this.componentWillReceiveProps(this.props);
	
	      // if options was provided
	      if (!this.props.options && this.props.order && this.props.order.in_ledger) {
	        _OrderUtil2.default.generateRefundOptions(_UserStore2.default.getState().apiKey, this.props.order.id).then(function (res) {
	          _this2.setState({ options: res.options });
	        }).catch(function (e) {
	          window.alert("Failed to generate refund options: " + e.message);
	        });
	      }
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(props) {
	      this.setState({
	        amount: props.order && props.order.purchase_price,
	        options: props.options
	      });
	    }
	  }, {
	    key: "refund",
	    value: function refund() {
	      this.props.onRefund(this.props.order && this.props.order.in_ledger || this.props.options ? { refunds: this.state.refunds } : this.state.amount);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this3 = this;
	
	      var _props = this.props;
	      var onRequestClose = _props.onRequestClose;
	      var order = _props.order;
	      var options = _props.options;
	
	
	      var ledgerMode = order && order.in_ledger || !order && !!options;
	
	      return _react2.default.createElement(
	        _base2.default,
	        {
	          onRequestClose: onRequestClose,
	          useMuiDefaultStyle: true,
	          actions: [_react2.default.createElement(_materialUi.FlatButton, { label: "Cancel", onTouchTap: onRequestClose }), _react2.default.createElement(_materialUi.FlatButton, {
	            primary: true,
	            label: "Refund" + (ledgerMode ? " " + (0, _util.formatPrice)(Object.values(this.state.refunds).reduce(function (t, r) {
	              return t + r.amount;
	            }, 0), { currency: order && order.currency }) : ""),
	            onTouchTap: this.refund
	          })]
	        },
	        this.props.refundErrorMessage ? _react2.default.createElement(
	          "div",
	          {
	            style: { color: "red", marginBottom: "1em", fontWeight: "bold" }
	          },
	          "Failed to refund: ",
	          this.props.refundErrorMessage
	        ) : null,
	        _react2.default.createElement(
	          "div",
	          null,
	          order ? _react2.default.createElement(
	            "div",
	            null,
	            "Refund up to ",
	            _react2.default.createElement(
	              "strong",
	              null,
	              (0, _util.formatPrice)(order.purchase_price)
	            ),
	            "."
	          ) : null,
	          "Refunds are irreversible. A confirmation email will be sent to the customer."
	        ),
	        ledgerMode ? _react2.default.createElement(
	          "div",
	          { style: { marginTop: "1em" } },
	          _react2.default.createElement(
	            "div",
	            { style: { marginBottom: "1em" } },
	            "Check the box in the lefthand column next to each item you would like to refund. Specify partial refunds and choose whether or not to delete the associated item using the righthand column. When you're ready to perform the refund, click \"Refund\" in the lower righthand corner."
	          ),
	          this.state.options ? _react2.default.createElement(_reactable.Table, {
	            className: "bordered striped responsive-table",
	            columns: [{
	              label: _react2.default.createElement(_materialUi.Checkbox, {
	                iconStyle: { fill: "#fff" },
	                checked: this.state.options.every(function (o) {
	                  return _this3.state.refunds[o.refund_key] && _this3.state.refunds[o.refund_key].amount === o.refundable_amount;
	                }),
	                onCheck: function onCheck(e, v) {
	                  return _this3.setState({
	                    refunds: _this3.state.options.reduce(function (d, o) {
	                      d[o.refund_key] = {
	                        amount: v ? o.refundable_amount : 0,
	                        delete: v && !o.item_deleted ? true : false
	                      };
	                      return d;
	                    }, {})
	                  });
	                }
	              }),
	              key: "select"
	            }, "Item", "Refundable", "Refund"],
	            data: this.state.options.map(function (o) {
	              var refund = _this3.state.refunds[o.refund_key] || {
	                amount: 0,
	                delete: false
	              };
	
	              return {
	                select: _react2.default.createElement(
	                  "span",
	                  null,
	                  _react2.default.createElement(_materialUi.Checkbox, {
	                    checked: refund.amount > 0,
	                    disabled: o.refundable_amount === 0,
	                    onCheck: function onCheck(e, v) {
	                      return _this3.setState({
	                        refunds: _extends({}, _this3.state.refunds, _defineProperty({}, o.refund_key, _extends({}, refund, {
	                          amount: v ? o.refundable_amount : 0,
	                          delete: !!v && !o.item_deleted
	                        })))
	                      });
	                    }
	                  })
	                ),
	                Item: o.class + ": " + [o.category && o.category.ref_label, o.subcategory && o.subcategory.ref_label, o.variant && o.variant.ref_label, o.item && o.item.ref_label].filter(function (x) {
	                  return !!x;
	                }).join(" - ") + " (" + (0, _util.formatPrice)(o.amount, {
	                  currency: o.currency
	                }) + ")",
	                Refundable: (0, _util.formatPrice)(o.refundable_amount, {
	                  currency: o.currency
	                }),
	                Refund: _react2.default.createElement(
	                  "div",
	                  { style: { display: "flex", alignItems: "center" } },
	                  _react2.default.createElement(_currencyField2.default, {
	                    placeholder: "$0.00",
	                    style: {
	                      width: 80,
	                      minWidth: 80,
	                      marginRight: "1em"
	                    },
	                    value: refund.amount,
	                    onChange: function onChange(e) {
	                      return _this3.setState({
	                        refunds: _extends({}, _this3.state.refunds, _defineProperty({}, o.refund_key, _extends({}, refund, {
	                          amount: e.target.value
	                        })))
	                      });
	                    }
	                  }),
	                  o.class === "GIFT_CARD" ? null : o.item_deleted ? _react2.default.createElement(
	                    "span",
	                    {
	                      style: {
	                        fontSize: "0.8em",
	                        color: "rgba(0,0,0,0.7)",
	                        fontStyle: "italic",
	                        lineHeight: "1.1em"
	                      }
	                    },
	                    o.class === "TAX" ? "Not deletable" : "Already deleted"
	                  ) : _react2.default.createElement(_materialUi.Checkbox, {
	                    label: "Delete",
	                    style: { display: "inline-block" },
	                    checked: refund.delete,
	                    labelStyle: {
	                      fontSize: "0.8em",
	                      color: "rgba(0,0,0,0.7)",
	                      marginLeft: -10
	                    },
	                    onCheck: function onCheck(e, v) {
	                      return _this3.setState({
	                        refunds: _extends({}, _this3.state.refunds, _defineProperty({}, o.refund_key, _extends({}, refund, {
	                          delete: v
	                        })))
	                      });
	                    }
	                  })
	                )
	              };
	            })
	          }) : _react2.default.createElement(_workingIndicator2.default, { centered: true })
	        ) : _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement(_currencyField2.default, {
	            floatingLabelText: "Refund amount",
	            floatingLabelFixed: true,
	            value: this.state.amount,
	            onChange: function onChange(e) {
	              return _this3.setState({ amount: e.target.value });
	            }
	          }),
	          _react2.default.createElement(
	            "div",
	            { style: styles.note },
	            "Note: ",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "Refunds DO NOT delete purchased items."
	            ),
	            " ",
	            "After issuing a refund, you must delete items using \"Delete\" links in the table on the order page."
	          )
	        )
	      );
	    }
	  }]);
	
	  return RefundOverlay;
	}(_react2.default.Component);
	
	exports.default = RefundOverlay;
	module.exports = exports["default"];

/***/ }),
/* 2704 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _base = __webpack_require__(1755);
	
	var _base2 = _interopRequireDefault(_base);
	
	var _materialUi = __webpack_require__(576);
	
	var _checkCircle = __webpack_require__(877);
	
	var _checkCircle2 = _interopRequireDefault(_checkCircle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = {
	  icon: {
	    width: 80,
	    height: "auto",
	    color: "rgb(2, 136, 209)"
	  }
	};
	
	exports.default = function (_ref) {
	  var onRequestClose = _ref.onRequestClose;
	  var message = _ref.message;
	  var complete = _ref.complete;
	
	  return React.createElement(
	    _base2.default,
	    {
	      onRequestClose: onRequestClose,
	      actions: complete ? [React.createElement(_materialUi.FlatButton, {
	        primary: true,
	        label: "Close",
	        onTouchTap: onRequestClose
	      })] : []
	    },
	    React.createElement(
	      "div",
	      { style: { textAlign: "center" } },
	      complete ? React.createElement(_checkCircle2.default, { style: styles.icon }) : React.createElement(_materialUi.CircularProgress, {
	        style: {
	          marginBottom: 50
	        },
	        mode: "indeterminate"
	      }),
	      React.createElement(
	        "div",
	        null,
	        message
	      )
	    )
	  );
	};
	
	module.exports = exports["default"];

/***/ }),
/* 2705 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactSelect = __webpack_require__(953);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	var _reactRouter = __webpack_require__(486);
	
	var _materialUi = __webpack_require__(576);
	
	var _moment = __webpack_require__(1021);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _connectToStores = __webpack_require__(1226);
	
	var _connectToStores2 = _interopRequireDefault(_connectToStores);
	
	var _EventBucketStore = __webpack_require__(1593);
	
	var _EventBucketStore2 = _interopRequireDefault(_EventBucketStore);
	
	var _EventBucketActions = __webpack_require__(1218);
	
	var _EventBucketActions2 = _interopRequireDefault(_EventBucketActions);
	
	var _AnalyticsStore = __webpack_require__(1861);
	
	var _AnalyticsStore2 = _interopRequireDefault(_AnalyticsStore);
	
	var _AnalyticsActions = __webpack_require__(1863);
	
	var _AnalyticsActions2 = _interopRequireDefault(_AnalyticsActions);
	
	var _EventStore = __webpack_require__(2032);
	
	var _EventStore2 = _interopRequireDefault(_EventStore);
	
	var _EventActions = __webpack_require__(2031);
	
	var _EventActions2 = _interopRequireDefault(_EventActions);
	
	var _eventTicketSalesChart = __webpack_require__(2693);
	
	var _eventTicketSalesChart2 = _interopRequireDefault(_eventTicketSalesChart);
	
	var _ticketsAtAGlance = __webpack_require__(2695);
	
	var _ticketsAtAGlance2 = _interopRequireDefault(_ticketsAtAGlance);
	
	var _workingIndicator = __webpack_require__(1664);
	
	var _workingIndicator2 = _interopRequireDefault(_workingIndicator);
	
	var _inlineNoticeLabel = __webpack_require__(1222);
	
	var _inlineNoticeLabel2 = _interopRequireDefault(_inlineNoticeLabel);
	
	var _genericAnalyticsTable = __webpack_require__(1687);
	
	var _genericAnalyticsTable2 = _interopRequireDefault(_genericAnalyticsTable);
	
	var _statsBlockContainer = __webpack_require__(1740);
	
	var _statsBlockContainer2 = _interopRequireDefault(_statsBlockContainer);
	
	var _statsBlock = __webpack_require__(1741);
	
	var _statsBlock2 = _interopRequireDefault(_statsBlock);
	
	var _util = __webpack_require__(1183);
	
	var util = _interopRequireWildcard(_util);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var EventAnalytics = function (_React$Component) {
	  _inherits(EventAnalytics, _React$Component);
	
	  function EventAnalytics(props) {
	    _classCallCheck(this, EventAnalytics);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(EventAnalytics).call(this, props));
	
	    _this.state = {
	      showSalesChannels: false
	    };
	    return _this;
	  }
	
	  _createClass(EventAnalytics, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.componentWillReceiveProps(this.props, true);
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(newProps) {
	      var force = arguments.length <= 1 || arguments[1] === undefined ? false : arguments[1];
	
	      if (force === true || newProps.eventId !== this.props.eventId) {
	        _AnalyticsActions2.default.fetchEventSalesDetailAnalytics.defer(newProps.eventId);
	        _EventActions2.default.fetchOne.defer(newProps.eventId);
	      }
	    }
	  }, {
	    key: "getTicketData",
	    value: function getTicketData(event) {
	      return {
	        unlimited: event.unlimited,
	        quantity_sold: event.quantity_sold,
	        quantity_remaining: event.quantity_remaining,
	        quantity: event.quantity
	      };
	    }
	  }, {
	    key: "getStyles",
	    value: function getStyles() {
	      return {
	        summary: {
	          position: "relative",
	          border: "1px solid #0288d1",
	          padding: "1em",
	          margin: "1em 0",
	          fontSize: "15pt",
	          lineHeight: 1.4,
	          color: "rgb(33,33,33)"
	        },
	        emphasis: {
	          color: "#0288d1"
	        },
	        insightsBadge: {
	          float: "right",
	          fontSize: "10pt"
	        },
	        salesChannels: {
	          display: "inline-block",
	          marginTop: "1em"
	        }
	      };
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props;
	      var isFetching = _props.isFetching;
	      var eventId = _props.eventId;
	      var showSalesChannels = this.state.showSalesChannels;
	      var event = this.props.getEventById(eventId);
	      var eventSalesDetailAnalytics = this.props.getEventSalesDetailAnalytics(eventId);
	      var styles = this.getStyles();
	
	      if (!eventSalesDetailAnalytics || !event) {
	        return _react2.default.createElement(_workingIndicator2.default, { fullPage: true });
	      }
	
	      var start = (0, _moment2.default)(event.start_time),
	          ticketData = this.getTicketData(event),
	          inFuture = start > (0, _moment2.default)();
	
	      var entries = (event.ticket_buckets.length > 1 ? [{ id: "default" }] : []).concat([].concat.apply([], event.ticket_buckets.map(function (b) {
	        return [b].concat(b.variants.length ? [{ id: b.id + "-default_variant", variant: true }] : []).concat(b.variants.map(function (b) {
	          b.variant = true;
	          return b;
	        }));
	      })));
	
	      if (showSalesChannels) {
	        entries = entries.map(function (e) {
	          return e.id === "default" || e.variants && e.variants.length ? [e] : [e, {
	            type: "channel",
	            id: e.id + "--channel--web",
	            name: "Web",
	            fromVariant: e.variant
	          }, {
	            type: "channel",
	            id: e.id + "--channel--box_rush",
	            name: "Box office",
	            fromVariant: e.variant
	          }, {
	            type: "channel",
	            id: e.id + "--channel--rush_line",
	            name: "Rush line",
	            fromVariant: e.variant
	          }];
	        }).reduce(function (a, b) {
	          return a.concat(b);
	        }, []);
	      }
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          _statsBlockContainer2.default,
	          {
	            style1: { maxWidth: 120 },
	            style2: { maxWidth: 120 },
	            style3: { maxWidth: 120 }
	          },
	          _react2.default.createElement(_ticketsAtAGlance2.default, { event: event }),
	          _react2.default.createElement(_statsBlock2.default, {
	            value: util.formatNumber(eventSalesDetailAnalytics.total.pass_uses),
	            label: "Passholder tickets"
	          }),
	          _react2.default.createElement(_statsBlock2.default, {
	            value: util.formatNumber(eventSalesDetailAnalytics.total.comps),
	            label: _react2.default.createElement(
	              "div",
	              null,
	              _react2.default.createElement(
	                "div",
	                null,
	                "Comp"
	              ),
	              _react2.default.createElement(
	                "div",
	                null,
	                "tickets"
	              )
	            )
	          }),
	          _react2.default.createElement(_statsBlock2.default, {
	            value: util.formatNumber((eventSalesDetailAnalytics.total.quantity || 0) - eventSalesDetailAnalytics.total.pass_uses - eventSalesDetailAnalytics.total.comps),
	            label: "Standalone tickets"
	          }),
	          _react2.default.createElement(_statsBlock2.default, {
	            value: util.formatPrice(eventSalesDetailAnalytics.total.net),
	            label: "Net standalone ticket sales"
	          })
	        ),
	        _react2.default.createElement(
	          "div",
	          { style: styles.summary },
	          _react2.default.createElement(
	            "div",
	            { style: styles.insightsBadge },
	            _react2.default.createElement(
	              "i",
	              null,
	              "event insights"
	            ),
	            " ",
	            _react2.default.createElement(_inlineNoticeLabel2.default, { label: "beta", style: { verticalAlign: 2 } })
	          ),
	          event.is_virtual ? _react2.default.createElement(
	            "div",
	            null,
	            "The virtual screening",
	            " ",
	            _react2.default.createElement(
	              "strong",
	              { style: styles.emphasis },
	              event.name
	            ),
	            ":"
	          ) : event.is_dated ? _react2.default.createElement(
	            "div",
	            null,
	            "The event ",
	            _react2.default.createElement(
	              "strong",
	              { style: styles.emphasis },
	              event.name
	            ),
	            " ",
	            inFuture ? "will begin" : "occurred",
	            " ",
	            start.fromNow(),
	            "."
	          ) : _react2.default.createElement(
	            "div",
	            null,
	            "The event ",
	            _react2.default.createElement(
	              "strong",
	              { style: styles.emphasis },
	              event.name
	            ),
	            ":"
	          ),
	          _react2.default.createElement(
	            "ul",
	            {
	              style: {
	                marginTop: 0,
	                marginBottom: 0,
	                marginLeft: "-1em",
	                listStyle: "square inside url('data:image/gif;base64,R0lGODlhBQAKAIABAAAAAP///yH5BAEAAAEALAAAAAAFAAoAAAIIjI+ZwKwPUQEAOw==')"
	              }
	            },
	            !event.is_virtual && event.is_dated ? _react2.default.createElement(
	              "li",
	              null,
	              start.format("lll"),
	              " ",
	              event.venue && event.venue.name ? "@ " + event.venue.name : ""
	            ) : null,
	            _react2.default.createElement(
	              "li",
	              null,
	              ticketData.unlimited ? "An unlimited number of tickets " + (inFuture ? "are" : "were") + " available; " + ticketData.quantity_sold + " tickets " + (inFuture ? "have been" : "were") + " issued." : _react2.default.createElement(
	                "span",
	                null,
	                (ticketData.quantity_sold / ticketData.quantity * 100 || 0).toFixed(1),
	                "% capacity sold;",
	                " ",
	                inFuture ? ticketData.quantity_remaining + "/" + ticketData.quantity + " tickets remain available." : ticketData.quantity_sold + "/" + ticketData.quantity + " tickets were issued."
	              )
	            ),
	            _react2.default.createElement(
	              "li",
	              null,
	              "Of tickets issued,",
	              " ",
	              (eventSalesDetailAnalytics.total.pass_uses / eventSalesDetailAnalytics.total.quantity * 100 || 0).toFixed(1),
	              "% allocated to passholders,",
	              " ",
	              (eventSalesDetailAnalytics.total.comps / eventSalesDetailAnalytics.total.quantity * 100 || 0).toFixed(1),
	              "% comp,",
	              " ",
	              (100 - (eventSalesDetailAnalytics.total.pass_uses + eventSalesDetailAnalytics.total.comps) / eventSalesDetailAnalytics.total.quantity * 100 || 0).toFixed(1),
	              "% standalone."
	            )
	          )
	        ),
	        _react2.default.createElement(_genericAnalyticsTable2.default, {
	          eventBucket: event.event_bucket,
	          label: "Ticket bucket",
	          noLink: true,
	          csvLabel: util.snakeCase(event.name) + "-sales-breakdown",
	          source: event.ticket_buckets.reduce(function (v, b) {
	            v[b.id] = b;
	            if (b.variants && b.variants.length) {
	              v[b.id + "-default_variant"] = {
	                name: "Default",
	                nameLabel: _react2.default.createElement(
	                  "i",
	                  { style: { marginLeft: "1em" } },
	                  "Default"
	                ),
	                rowStyle: { fontStyle: "italic" }
	              };
	              b.variants.map(function (variant) {
	                v[variant.id] = variant;
	                v[variant.id].nameLabel = _react2.default.createElement(
	                  "i",
	                  { style: { marginLeft: "1em" } },
	                  variant.name
	                );
	                v[variant.id].rowStyle = { fontStyle: "italic" };
	              });
	            }
	            return v;
	          }, {
	            default: {
	              name: "TOTAL",
	              nameLabel: _react2.default.createElement(
	                "strong",
	                null,
	                "TOTAL"
	              ),
	              rowStyle: { fontWeight: "bold" }
	            }
	          }),
	          columns: [{ label: "Quantity", value: "quantity" }, { label: "Pass", value: "pass_uses" }, { label: "Comps", value: "comps" }, { label: "Standalone", value: "standalone" }, { label: "Gross", value: "gross" }, { label: "Net", value: "net" }, { label: "Fees", value: "fee" }].concat(eventSalesDetailAnalytics.total.deferred_fee ? [{
	            label: "Deferred fees",
	            value: "deferred_fee"
	          }] : []).concat([{ label: "Tax collected", value: "tax" }, { label: "Cash", value: "cash" }, { label: "Check", value: "check" }, { label: "Credit (net)", value: "credit_net" }]),
	          data: entries.map(function (b) {
	            var id = b.id;
	            var type = b.type;
	            var name = b.name;
	            var fromVariant = b.fromVariant;
	            var data = id === "default" ? eventSalesDetailAnalytics.total : eventSalesDetailAnalytics.by_ticket_bucket[id];
	
	            if (!data) {
	              data = new Proxy({}, {
	                get: function get() {
	                  return 0;
	                }
	              });
	            }
	
	            var _source = void 0;
	            if (type === "channel") {
	              _source = {
	                name: name,
	                nameLabel: _react2.default.createElement(
	                  "i",
	                  { style: { marginLeft: (fromVariant ? 2 : 1) + "em" } },
	                  name
	                ),
	                rowStyle: { fontStyle: "italic" }
	              };
	            }
	
	            return {
	              id: id,
	              _source: _source,
	              pass_uses: data.pass_uses,
	              comps: data.comps,
	              standalone: data.quantity - data.pass_uses - data.comps,
	              gross: { label: util.formatPrice(data.gross), value: data.gross },
	              net: { label: util.formatPrice(data.net), value: data.net },
	              fee: {
	                label: util.formatPrice(data.gross - data.net - (data.deferred_fee || 0)),
	                value: data.gross - data.net - (data.deferred_fee || 0)
	              },
	              deferred_fee: {
	                label: util.formatPrice(data.deferred_fee),
	                value: data.deferred_fee
	              },
	              tax: { label: util.formatPrice(data.tax), value: data.tax },
	              quantity: {
	                label: util.formatNumber(data.quantity),
	                value: data.quantity
	              },
	              cash: { label: util.formatPrice(data.cash), value: data.cash },
	              check: { label: util.formatPrice(data.check), value: data.check },
	              credit_net: {
	                label: util.formatPrice(data.credit_net),
	                value: data.credit_net
	              }
	            };
	          })
	        }),
	        _react2.default.createElement(_materialUi.Checkbox, {
	          style: styles.salesChannels,
	          label: "Show sales channels",
	          checked: showSalesChannels,
	          onCheck: function onCheck() {
	            return _this2.setState({ showSalesChannels: !showSalesChannels });
	          }
	        })
	      );
	    }
	  }], [{
	    key: "getStores",
	    value: function getStores() {
	      return [_EventBucketStore2.default, _EventStore2.default, _AnalyticsStore2.default];
	    }
	  }, {
	    key: "getPropsFromStores",
	    value: function getPropsFromStores() {
	      var eventState = _EventStore2.default.getState();
	
	      return {
	        isFetching: eventState.isFetching,
	        getEventById: _EventStore2.default.getEventById,
	        getEventSalesDetailAnalytics: _AnalyticsStore2.default.getEventSalesDetailAnalytics
	      };
	    }
	  }]);
	
	  return EventAnalytics;
	}(_react2.default.Component);
	
	EventAnalytics.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	exports.default = (0, _connectToStores2.default)(EventAnalytics);
	module.exports = exports["default"];

/***/ }),
/* 2706 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _alt = __webpack_require__(975);
	
	var _alt2 = _interopRequireDefault(_alt);
	
	var _keyBy = __webpack_require__(990);
	
	var _keyBy2 = _interopRequireDefault(_keyBy);
	
	var _extend = __webpack_require__(1212);
	
	var _extend2 = _interopRequireDefault(_extend);
	
	var _values = __webpack_require__(1214);
	
	var _values2 = _interopRequireDefault(_values);
	
	var _TicketUtil = __webpack_require__(2707);
	
	var _TicketUtil2 = _interopRequireDefault(_TicketUtil);
	
	var _TicketActions = __webpack_require__(2697);
	
	var _TicketActions2 = _interopRequireDefault(_TicketActions);
	
	var _UserStore = __webpack_require__(974);
	
	var _UserStore2 = _interopRequireDefault(_UserStore);
	
	var _OrderStore = __webpack_require__(2050);
	
	var _OrderStore2 = _interopRequireDefault(_OrderStore);
	
	var _OrderActions = __webpack_require__(1220);
	
	var _OrderActions2 = _interopRequireDefault(_OrderActions);
	
	var _LedgerActions = __webpack_require__(2052);
	
	var _LedgerActions2 = _interopRequireDefault(_LedgerActions);
	
	var _GlobalNotificationActions = __webpack_require__(1182);
	
	var _GlobalNotificationActions2 = _interopRequireDefault(_GlobalNotificationActions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var TicketStore = function () {
	  function TicketStore() {
	    _classCallCheck(this, TicketStore);
	
	    this.bindActions(_TicketActions2.default);
	
	    this.state = {
	      tickets: {},
	      ticketTransferHistory: [],
	      ticketTransferHistorySingleTicket: {},
	      isFetching: false
	    };
	
	    this.exportPublicMethods({
	      getTicketById: this.getTicketById.bind(this),
	      getTicketsForPerson: this.getTicketsForPerson.bind(this),
	      getTicketsForEvent: this.getTicketsForEvent.bind(this),
	      getTicketTransferHistory: this.getTicketTransferHistory.bind(this),
	      getTicketTransferHistorySingleTicket: this.getTicketTransferHistorySingleTicket.bind(this)
	    });
	  }
	
	  _createClass(TicketStore, [{
	    key: "getTicketById",
	    value: function getTicketById(id) {
	      return this.state.tickets[id];
	    }
	  }, {
	    key: "getTicketsForPerson",
	    value: function getTicketsForPerson(id, eventBucket) {
	      return (0, _values2.default)(this.state.tickets).filter(function (t) {
	        if (eventBucket && t.event_bucket !== eventBucket) {
	          return false;
	        }
	        return t.person && t.person.id === id;
	      });
	    }
	  }, {
	    key: "getTicketsForEvent",
	    value: function getTicketsForEvent(id) {
	      return (0, _values2.default)(this.state.tickets).filter(function (t) {
	        return t.event.id === id;
	      });
	    }
	  }, {
	    key: "getTicketTransferHistory",
	    value: function getTicketTransferHistory() {
	      return this.state.ticketTransferHistory;
	    }
	  }, {
	    key: "getTicketTransferHistorySingleTicket",
	    value: function getTicketTransferHistorySingleTicket() {
	      return this.state.ticketTransferHistorySingleTicket;
	    }
	  }, {
	    key: "onFetchAllForEvent",
	    value: function onFetchAllForEvent(eventId) {
	      var _this = this;
	
	      this.setState({ isFetching: true });
	      _TicketUtil2.default.fetchAllForEvent(_UserStore2.default.getState().apiKey, eventId).then(function (data) {
	        _this.setState({ isFetching: false });
	        _TicketActions2.default.updateTickets((0, _keyBy2.default)(data, "id"));
	      }).catch(_TicketActions2.default.fetchFailed);
	    }
	  }, {
	    key: "onFetchAllForPerson",
	    value: function onFetchAllForPerson(personId) {
	      var _this2 = this;
	
	      this.setState({ isFetching: true });
	      _TicketUtil2.default.fetchAllForPerson(_UserStore2.default.getState().apiKey, personId).then(function (data) {
	        _this2.setState({ isFetching: false });
	        _TicketActions2.default.updateTickets((0, _keyBy2.default)(data, "id"));
	      }).catch(_TicketActions2.default.fetchFailed);
	    }
	  }, {
	    key: "onFetchOne",
	    value: function onFetchOne(id) {
	      var _this3 = this;
	
	      this.setState({ isFetching: true });
	      _TicketUtil2.default.fetchOne(_UserStore2.default.getState().apiKey, id).then(function (data) {
	        _this3.setState({ isFetching: false });
	        _TicketActions2.default.updateTicket(id, data);
	      }).catch(_TicketActions2.default.fetchFailed);
	    }
	  }, {
	    key: "onFetchTicketTransferHistory",
	    value: function onFetchTicketTransferHistory(ids) {
	      var _this4 = this;
	
	      this.setState({ isFetching: true });
	      _TicketUtil2.default.fetchTicketTransferHistory(_UserStore2.default.getState().apiKey, ids.ticketId, ids.eventBucketId).then(function (data) {
	        _this4.setState({ ticketTransferHistory: data.history, ticketTransferHistorySingleTicket: data.ticket, isFetching: false });
	      }).catch(_TicketActions2.default.fetchFailed);
	    }
	  }, {
	    key: "onDelete",
	    value: function onDelete(id) {
	      var _this5 = this;
	
	      _TicketUtil2.default.delete(_UserStore2.default.getState().apiKey, _UserStore2.default.getCredentials().api_key, id).then(function (data) {
	        delete _this5.state.tickets[id];
	        _this5.setState(_this5.state);
	      });
	    }
	  }, {
	    key: "onMarkAsUsed",
	    value: function onMarkAsUsed(id) {
	      var _this6 = this;
	
	      _TicketUtil2.default.markAsUsed(_UserStore2.default.getState().apiKey, id).then(function (data) {
	        _this6.state.tickets[id] = data;
	        _this6.setState(_this6.state);
	      });
	    }
	  }, {
	    key: "onUpdateTicket",
	    value: function onUpdateTicket(data) {
	      this.state.tickets[data.id] = data.ticket;
	      this.setState(this.state);
	    }
	  }, {
	    key: "onUpdateTickets",
	    value: function onUpdateTickets(tickets) {
	      (0, _extend2.default)(this.state.tickets, tickets);
	      this.setState(this.state);
	    }
	  }, {
	    key: "onFetchFailed",
	    value: function onFetchFailed(e) {
	      this.setState({ isFetching: false });
	      alert("Fetching ticket failed: " + e.message);
	      throw e;
	    }
	  }, {
	    key: "onDownloadPdf",
	    value: function onDownloadPdf(options) {
	      _TicketUtil2.default.downloadPdf(_UserStore2.default.getState().apiKey, options);
	    }
	  }, {
	    key: "onChangeTicketsUnlock",
	    value: function onChangeTicketsUnlock(form) {
	      var _this7 = this;
	
	      this.setState({ isFetching: true });
	      _TicketUtil2.default.changeTicketsUnlock(_UserStore2.default.getState().apiKey, form).then(function (data) {
	        var tickets = _extends({}, _this7.state.tickets);
	        data.tickets.forEach(function (_ref) {
	          var id = _ref.id;
	          var unlocked_until = _ref.unlocked_until;
	          var expires_at = _ref.expires_at;
	
	          if (tickets[id]) {
	            tickets[id].unlocked_until = unlocked_until;
	            tickets[id].expires_at = expires_at;
	          }
	        });
	
	        // Dispatch order update if order has been fetched previously
	        // (to propagate updated tickets if viewing orders page).
	        var orderId = data.tickets.length && data.tickets[0].order;
	        var order = _OrderStore2.default.getState().orders[orderId];
	        if (order) {
	          _OrderActions2.default.fetchOne(orderId);
	        }
	
	        _this7.setState({ isFetching: false, tickets: tickets });
	      }).catch(_TicketActions2.default.fetchFailed);
	    }
	  }, {
	    key: "onTransfer",
	    value: function onTransfer(_ref2) {
	      var _this8 = this;
	
	      var ids = _ref2.ids;
	      var recipient = _ref2.recipient;
	
	      _TicketUtil2.default.transfer(_UserStore2.default.getState().apiKey, ids, recipient).then(function (data) {
	        data.tickets.forEach(function (ticket) {
	          _TicketActions2.default.updateTicket(ticket.id, _extends({}, _this8.state.tickets[ticket.id], {
	            pending_transfer: ticket.pending_transfer
	          }));
	          // Dispatch order update if order has been fetched previously
	          // (to propagate updated ticket if viewing orders page).
	          var order = _OrderStore2.default.getState().orders[ticket.order];
	          if (order) {
	            _OrderActions2.default.fetchOne(ticket.order);
	          }
	        });
	      }).catch(_TicketActions2.default.editFailed);
	    }
	  }, {
	    key: "onCancelTransfer",
	    value: function onCancelTransfer(id) {
	      var _this9 = this;
	
	      _TicketUtil2.default.cancelTransfer(_UserStore2.default.getState().apiKey, id).then(function (data) {
	        data.tickets.forEach(function (ticket) {
	          _TicketActions2.default.updateTicket(ticket.id, _extends({}, _this9.state.tickets[ticket.id], {
	            pending_transfer: undefined
	          }));
	          // Dispatch order update if order has been fetched previously
	          // (to propagate updated ticket if viewing orders page).
	          var order = _OrderStore2.default.getState().orders[ticket.order];
	          if (order) {
	            _OrderActions2.default.fetchOne(ticket.order);
	          }
	        });
	      }).catch(_TicketActions2.default.editFailed);
	    }
	  }, {
	    key: "onResendTransfer",
	    value: function onResendTransfer(id) {
	      _GlobalNotificationActions2.default.notify.defer("Resending ticket transfer email...");
	
	      _TicketUtil2.default.resendTransfer(_UserStore2.default.getState().apiKey, id).then(function (data) {
	        _GlobalNotificationActions2.default.notify.defer("Ticket transfer email resent successfully.");
	      }).catch(_TicketActions2.default.editFailed);
	    }
	  }, {
	    key: "onEditFailed",
	    value: function onEditFailed(e) {
	      alert("Edit failed: " + e.message);
	    }
	  }, {
	    key: "onDeleteTickets",
	    value: function onDeleteTickets(form) {
	      var _this10 = this;
	
	      this.setState({ isFetching: true });
	
	      var tickets = _extends({}, this.state.tickets);
	      _TicketUtil2.default.deleteBulk(_UserStore2.default.getState().apiKey, form).then(function (data) {
	        _this10.setState({ isFetching: false, tickets: tickets });
	      }).catch(_TicketActions2.default.fetchFailed);
	    }
	  }, {
	    key: "onExchangeTickets",
	    value: function onExchangeTickets(form) {
	      var _this11 = this;
	
	      this.setState({ isFetching: true });
	      _TicketUtil2.default.exchangeTickets(_UserStore2.default.getState().apiKey, form).then(function (data) {
	        var tickets = _extends({}, _this11.state.tickets);
	        data.tickets.forEach(function (_ref3) {
	          var id = _ref3.id;
	          var ticket_bucket = _ref3.ticket_bucket;
	          var event = _ref3.event;
	          var event_bucket = _ref3.event_bucket;
	          var unlocked_until = _ref3.unlocked_until;
	          var expires_at = _ref3.expires_at;
	          var seat = _ref3.seat;
	
	          if (tickets[id]) {
	            tickets[id].ticket_bucket = ticket_bucket;
	            tickets[id].event = event;
	            tickets[id].event_bucket = event_bucket;
	            tickets[id].unlocked_until = unlocked_until;
	            tickets[id].expires_at = expires_at;
	            tickets[id].seat = seat;
	          }
	        });
	
	        var orderId = data.tickets.length && data.tickets[0].order;
	        var order = _OrderStore2.default.getState().orders[orderId];
	        if (order) {
	          _OrderActions2.default.fetchOne(orderId);
	          _LedgerActions2.default.fetchLedgerTransactionsForOrder.defer(orderId); // force ledger update
	        }
	
	        _this11.setState({ isFetching: false, tickets: tickets });
	      }).catch(_TicketActions2.default.fetchFailed);
	    }
	  }, {
	    key: "onChangeSeats",
	    value: function onChangeSeats(tickets) {
	      var _this12 = this;
	
	      this.setState({ isFetching: true });
	      _TicketUtil2.default.changeSeats(_UserStore2.default.getState().apiKey, tickets).then(function (data) {
	        var tickets = _extends({}, _this12.state.tickets);
	        data.tickets.forEach(function (_ref4) {
	          var id = _ref4.id;
	          var seat = _ref4.seat;
	
	          if (tickets[id]) {
	            tickets[id].seat = seat;
	          }
	        });
	
	        var orderId = data.tickets.length && data.tickets[0].order;
	        var order = _OrderStore2.default.getState().orders[orderId];
	        if (order) {
	          _OrderActions2.default.fetchOne(orderId);
	        }
	
	        _this12.setState({ tickets: tickets, isFetching: false });
	      }).catch(_TicketActions2.default.fetchFailed);
	    }
	  }]);
	
	  return TicketStore;
	}();
	
	exports.default = _alt2.default.createStore(TicketStore, "TicketStore");
	module.exports = exports["default"];

/***/ }),
/* 2707 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _merge = __webpack_require__(732);
	
	var _merge2 = _interopRequireDefault(_merge);
	
	var _api = __webpack_require__(1160);
	
	var _api2 = _interopRequireDefault(_api);
	
	var _config = __webpack_require__(1173);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _qs = __webpack_require__(1206);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  fetchAllForEvent: function fetchAllForEvent(apiKey, event) {
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "GET",
	        endpoint: "events/" + event + "/tickets",
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response.tickets);
	      });
	    });
	  },
	  fetchAllForPerson: function fetchAllForPerson(apiKey, person) {
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "GET",
	        endpoint: "people/" + person + "/tickets",
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response.tickets);
	      });
	    });
	  },
	  fetchOne: function fetchOne(apiKey, ticket) {
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "GET",
	        endpoint: "tickets/" + ticket,
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response);
	      });
	    });
	  },
	  fetchTicketTransferHistory: function fetchTicketTransferHistory(apiKey, ticketId, eventBucketId) {
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "GET",
	        endpoint: "tickets/" + ticketId + "/history?event_bucket=" + eventBucketId,
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response);
	      });
	    });
	  },
	  delete: function _delete(apiKey, accountToken, ticket) {
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "DELETE",
	        endpoint: "tickets/" + ticket,
	        api_key: apiKey,
	        qs: {
	          token: accountToken
	        }
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response);
	      });
	    });
	  },
	  deleteBulk: function deleteBulk(apiKey, data) {
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "DELETE",
	        endpoint: "tickets/delete",
	        json: data,
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response);
	      });
	    });
	  },
	  markAsUsed: function markAsUsed(apiKey, ticket) {
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "POST",
	        endpoint: "tickets/" + ticket + "/mark_as_used",
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response);
	      });
	    });
	  },
	  downloadPdf: function downloadPdf(apiKey, options) {
	    options.api_key = apiKey;
	    var query = (0, _qs.stringify)(options);
	    window.open(_config2.default.endpoint + "tickets.pdf?" + query);
	  },
	  changeTicketsUnlock: function changeTicketsUnlock(apiKey, data) {
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "POST",
	        endpoint: "tickets/change_unlocks",
	        json: data,
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response);
	      });
	    });
	  },
	  transfer: function transfer(apiKey, tickets, recipient) {
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "POST",
	        endpoint: "tickets/transfer",
	        json: { recipient: recipient, tickets: tickets },
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response);
	      });
	    });
	  },
	  cancelTransfer: function cancelTransfer(apiKey, transfer) {
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "POST",
	        endpoint: "tickets/cancel_transfer",
	        json: { transfer: transfer },
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response);
	      });
	    });
	  },
	  resendTransfer: function resendTransfer(apiKey, transfer) {
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "POST",
	        endpoint: "tickets/resend_transfer",
	        json: { transfer: transfer },
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response);
	      });
	    });
	  },
	  exchangeTickets: function exchangeTickets(apiKey, data) {
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "POST",
	        endpoint: "tickets/exchange",
	        json: data,
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response);
	      });
	    });
	  },
	  changeSeats: function changeSeats(apiKey, tickets) {
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "POST",
	        endpoint: "tickets/change_seats",
	        json: { tickets: tickets },
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response);
	      });
	    });
	  }
	};
	module.exports = exports["default"];

/***/ }),
/* 2708 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";Object.defineProperty(exports,"__esModule",{value:true});var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(300);var _react2=_interopRequireDefault(_react);var _find=__webpack_require__(1400);var _find2=_interopRequireDefault(_find);var _get=__webpack_require__(1004);var _get2=_interopRequireDefault(_get);var _set=__webpack_require__(1188);var _set2=_interopRequireDefault(_set);var _assign=__webpack_require__(920);var _assign2=_interopRequireDefault(_assign);var _momentTimezone=__webpack_require__(1185);var _momentTimezone2=_interopRequireDefault(_momentTimezone);var _reactStickynode=__webpack_require__(2709);var _reactStickynode2=_interopRequireDefault(_reactStickynode);var _rrule=__webpack_require__(2259);var _chronoNode=__webpack_require__(2063);var _chronoNode2=_interopRequireDefault(_chronoNode);var _materialUi=__webpack_require__(576);var _reactRouter=__webpack_require__(486);var _immutabilityHelper=__webpack_require__(2261);var _immutabilityHelper2=_interopRequireDefault(_immutabilityHelper);var _reactCodemirror=__webpack_require__(1751);var _reactCodemirror2=_interopRequireDefault(_reactCodemirror);__webpack_require__(2166);var _htmlEditor=__webpack_require__(2724);var _htmlEditor2=_interopRequireDefault(_htmlEditor);var _imageDropzone=__webpack_require__(2058);var _imageDropzone2=_interopRequireDefault(_imageDropzone);var _ticketBucketsEditor=__webpack_require__(2725);var _ticketBucketsEditor2=_interopRequireDefault(_ticketBucketsEditor);var _injectedSelect=__webpack_require__(1874);var _injectedSelect2=_interopRequireDefault(_injectedSelect);var _infoNotice=__webpack_require__(1599);var _infoNotice2=_interopRequireDefault(_infoNotice);var _label=__webpack_require__(1682);var _label2=_interopRequireDefault(_label);var _workingIndicator=__webpack_require__(1664);var _workingIndicator2=_interopRequireDefault(_workingIndicator);var _backButton=__webpack_require__(1872);var _backButton2=_interopRequireDefault(_backButton);var _linkLike=__webpack_require__(973);var _linkLike2=_interopRequireDefault(_linkLike);var _schedulerOverlay=__webpack_require__(2197);var _schedulerOverlay2=_interopRequireDefault(_schedulerOverlay);var _datetimeField=__webpack_require__(2061);var _datetimeField2=_interopRequireDefault(_datetimeField);var _datetimePicker=__webpack_require__(2062);var _filmTable=__webpack_require__(1763);var _selectWells=__webpack_require__(1676);var _selectWells2=_interopRequireDefault(_selectWells);var _durationField=__webpack_require__(2054);var _durationField2=_interopRequireDefault(_durationField);var _basicHtmlField=__webpack_require__(2674);var _basicHtmlField2=_interopRequireDefault(_basicHtmlField);var _viewLiveVirtualButton=__webpack_require__(1865);var _viewLiveVirtualButton2=_interopRequireDefault(_viewLiveVirtualButton);var _localMovies=__webpack_require__(2727);var _localMovies2=_interopRequireDefault(_localMovies);var _event=__webpack_require__(2273);var _event2=_interopRequireDefault(_event);var _dateRange=__webpack_require__(2728);var _dateRange2=_interopRequireDefault(_dateRange);var _delete2=__webpack_require__(2057);var _delete3=_interopRequireDefault(_delete2);var _contentCopy=__webpack_require__(1225);var _contentCopy2=_interopRequireDefault(_contentCopy);var _connectToStores=__webpack_require__(1226);var _connectToStores2=_interopRequireDefault(_connectToStores);var _EventActions=__webpack_require__(2031);var _EventActions2=_interopRequireDefault(_EventActions);var _EventStore=__webpack_require__(2032);var _EventStore2=_interopRequireDefault(_EventStore);var _VenueStore=__webpack_require__(2036);var _VenueStore2=_interopRequireDefault(_VenueStore);var _FilmStore=__webpack_require__(1765);var _FilmStore2=_interopRequireDefault(_FilmStore);var _UserStore=__webpack_require__(974);var _UserStore2=_interopRequireDefault(_UserStore);var _EventBucketStore=__webpack_require__(1593);var _EventBucketStore2=_interopRequireDefault(_EventBucketStore);var _util=__webpack_require__(1183);var _eventivalBanner=__webpack_require__(2675);var _eventivalBanner2=_interopRequireDefault(_eventivalBanner);var _displayAdEditor=__webpack_require__(2729);var _displayAdEditor2=_interopRequireDefault(_displayAdEditor);var _revenueSharingEditor=__webpack_require__(2731);var _revenueSharingEditor2=_interopRequireDefault(_revenueSharingEditor);var _recurringUpdateModal=__webpack_require__(2732);var _recurringUpdateModal2=_interopRequireDefault(_recurringUpdateModal);var _passRulesEditorNonatomic=__webpack_require__(2733);var _passRulesEditorNonatomic2=_interopRequireDefault(_passRulesEditorNonatomic);var _virtualContentEditor=__webpack_require__(2055);var _virtualContentEditor2=_interopRequireDefault(_virtualContentEditor);var _inlineNoticeLabel=__webpack_require__(1222);var _inlineNoticeLabel2=_interopRequireDefault(_inlineNoticeLabel);var _VirtualContentStore=__webpack_require__(1768);var _VirtualContentStore2=_interopRequireDefault(_VirtualContentStore);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var capitalize=function capitalize(e){return e&&e.length&&e.charAt(0).toUpperCase()+e.slice(1);};var Event=function(_React$Component){_inherits(Event,_React$Component);function Event(props){_classCallCheck(this,Event);var _this=_possibleConstructorReturn(this,Object.getPrototypeOf(Event).call(this,props));_this.state={mode:"",// film / undated / default
	event:{},dirty:false,isSaving:false,lastUpdatedAt:false,isUploadingImage:false,oldImage:null,hasReservedSeating:true,hasVenueChanged:false,oldVenue:null,htmlRawMode:false,values:{},showExternalTicketsUrl:false,showScheduler:false,showRecurringUpdateModal:false,showRecurringDeleteModal:false,showTermsEditor:false};_this.onChange=_this.onChange.bind(_this);_this.onChangeValue=_this.onChangeValue.bind(_this);_this.onTagsChange=_this.onTagsChange.bind(_this);_this.onDrop=_this.onDrop.bind(_this);_this.onExternalTicketsUrlCheck=_this.onExternalTicketsUrlCheck.bind(_this);_this.onTicketsButtonLabelCheck=_this.onTicketsButtonLabelCheck.bind(_this);_this.save=_this.save.bind(_this);_this.deleteConfirm=_this.deleteConfirm.bind(_this);_this.duplicate=_this.duplicate.bind(_this);return _this;}_createClass(Event,[{key:"getStyles",value:function getStyles(){return{actions:{background:"white",display:"flex",alignItems:"center"},title:{display:"inline-block",marginLeft:20,flexGrow:1},subtitle:{fontSize:"0.5em",fontWeight:"normal",marginTop:5,lineHeight:1.3},label:{color:"rgba(33, 33, 33, 0.498039)",fontSize:12,marginTop:10,marginBottom:5},editor:{marginTop:40},editorHeader:{borderBottom:"1px solid #e6e6e6",paddingBottom:5,marginBottom:15},dropzone:{width:200,padding:20,border:"1px dashed #ccc",cursor:"pointer"},progress:{marginBottom:50},h3:{margin:"15px 0 10px"}};}},{key:"onChange",value:function onChange(id,e,checked){this.onChangeValue(id,typeof checked!=="undefined"?!(0,_get2.default)(this.state.values,id):e.target.value);}},{key:"onChangeValue",value:function onChangeValue(id,value,cb){var _this2=this;// If editing the start time, apply the same delta transformation to the end time.
	var transformDelta=function transformDelta(start_time_name,end_time_name){if(id===start_time_name&&value){var oldStart=(0,_get2.default)(_this2.state.values,start_time_name);var oldEndTime=(0,_get2.default)(_this2.state.values,end_time_name);(0,_set2.default)(_this2.state.values,end_time_name,oldEndTime?oldEndTime.add(value.diff(oldStart)):(0,_momentTimezone2.default)(value).add(2,"hours"));}};transformDelta("start_time","end_time");transformDelta("_livestream_film.start_time","_livestream_film.end_time");// Copy over values to _livestream_film.
	if(this.state.mode==="live"){if(id==="name"){(0,_set2.default)(this.state.values,"_livestream_film.name",value);}if(id==="short_description"){(0,_set2.default)(this.state.values,"_livestream_film.short_description",value);}}(0,_set2.default)(this.state.values,id,value);this.setState({dirty:true,values:this.state.values},cb);}},{key:"onChangeValueAsync",value:function onChangeValueAsync(id,value){var _this3=this;return new Promise(function(resolve,reject){_this3.onChangeValue(id,value,function(){return resolve();});});}},{key:"onArrayItemShiftPosition",value:function onArrayItemShiftPosition(id,index,direction){var arr=[].concat(_toConsumableArray(this.state.values[id]));arr.splice(index+direction,0,arr.splice(index,1)[0]);this.setState({dirty:true,values:(0,_immutabilityHelper2.default)(this.state.values,_defineProperty({},id,{$set:arr}))});}},{key:"onArrayItemAdd",value:function onArrayItemAdd(id,value){this.setState({dirty:true,values:(0,_immutabilityHelper2.default)(this.state.values,_defineProperty({},id,{$push:[value]}))});}},{key:"onArrayItemEdit",value:function onArrayItemEdit(id,index,value){this.setState({dirty:true,values:(0,_immutabilityHelper2.default)(this.state.values,_defineProperty({},id,_defineProperty({},index,{$set:value})))});}},{key:"onArrayItemDelete",value:function onArrayItemDelete(id,index){this.setState({dirty:true,values:(0,_immutabilityHelper2.default)(this.state.values,_defineProperty({},id,{$splice:[[index,1]]}))});}// requires an array of additions and an array of delete indexes
	},{key:"onArrayItemAddAndDelete",value:function onArrayItemAddAndDelete(id,additions,delIndexes){//sort indexes descending
	delIndexes.sort(function(a,b){return b-a;});//process indexes (after descending sort to ensure index structure remains intact)
	var newData=this.state.values;for(var x=0;x<delIndexes.length;x++){newData=(0,_immutabilityHelper2.default)(newData,_defineProperty({},id,{$splice:[[delIndexes[x],1]]}));}//add additions all at once as an array
	var addData=(0,_immutabilityHelper2.default)(newData,_defineProperty({},id,{$push:additions}));this.setState({dirty:true,values:addData});}},{key:"onTagsChange",value:function onTagsChange(tags){this.onChangeValue("tags",tags);}},{key:"onModeChange",value:function(){var _ref=_asyncToGenerator(regeneratorRuntime.mark(function _callee(mode){return regeneratorRuntime.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:if(!this.state.event.is_virtual){_context.next=20;break;}if(!(mode==="live")){_context.next=8;break;}_context.next=4;return this.onChangeValueAsync("films",[]);case 4:_context.next=6;return this.onChangeValueAsync("name",this.state.values.name);case 6:_context.next=8;return this.onChangeValueAsync("short_description",this.state.values.short_description);case 8:if(!(mode==="film")){_context.next=13;break;}_context.next=11;return this.onChangeValueAsync("_livestream_film",{});case 11:_context.next=16;break;case 13:if(!(mode==="live"||mode==="combo")){_context.next=16;break;}_context.next=16;return this.onChangeValueAsync("_livestream_film.livestream_mode","eventive");case 16:if(!(mode==="vod")){_context.next=19;break;}_context.next=19;return this.onChangeValueAsync("_livestream_film",false);case 19:return _context.abrupt("return");case 20:_context.next=22;return this.onChangeValueAsync("is_dated",mode!=="undated");case 22:if(!(mode!=="film")){_context.next=25;break;}_context.next=25;return this.onChangeValueAsync("films",[]);case 25:case"end":return _context.stop();}}},_callee,this);}));function onModeChange(_x){return _ref.apply(this,arguments);}return onModeChange;}()},{key:"onRRuleChange",value:function(){var _ref2=_asyncToGenerator(regeneratorRuntime.mark(function _callee2(_ref3,cb){var repeats=_ref3.repeats;var applyRecurring=_ref3.applyRecurring;var values;return regeneratorRuntime.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:values=_extends({},this.state.values,{recurring_event:{repeats:repeats}});values.start_time=values.start_time&&values.start_time.toISOString();values.end_time=values.end_time&&values.end_time.toISOString();if(!applyRecurring){_context2.next=9;break;}this.setState({isSaving:true,lastUpdatedAt:this.state.event.updated_at});_context2.next=7;return _EventActions2.default.edit.defer(this.props.params.eventId,values,applyRecurring);case 7:_context2.next=10;break;case 9:throw"Error: applyRecurring is not defined.";case 10:window.scrollTo(0,0);cb();case 12:case"end":return _context2.stop();}}},_callee2,this);}));function onRRuleChange(_x2,_x3){return _ref2.apply(this,arguments);}return onRRuleChange;}()},{key:"onDrop",value:function onDrop(id,file){this.onChangeValue(id,undefined);_EventActions2.default.editImage.defer(this.props.params.eventId,id,file);}},{key:"onExternalTicketsUrlCheck",value:function onExternalTicketsUrlCheck(e){var _this4=this;this.setState({showExternalTicketsUrl:!this.state.showExternalTicketsUrl},function(){_this4.onChangeValue("external_tickets_url","");});}},{key:"onTicketsButtonLabelCheck",value:function onTicketsButtonLabelCheck(e){var _this5=this;this.setState({showTicketsButtonLabel:!this.state.showTicketsButtonLabel},function(){_this5.onChangeValue("tickets_button_label","");});}},{key:"_updateFilms",value:function _updateFilms(filmIds){var _this6=this;var originalIds=this.state.values.films,hasLivestream=false;if(this.state.values._livestream_film&&this.state.values._livestream_film.id){hasLivestream=true;filmIds.push(this.state.values._livestream_film.id);}this.onChangeValue("films",filmIds,function(){var originalDetails=originalIds.map(function(id){return _FilmStore2.default.getFilmById(id);});var details=filmIds.map(function(id){return _FilmStore2.default.getFilmById(id);});_this6.setState({filmDetails:details},function(){if(!hasLivestream&&details.length<=2&&(_this6.state.values.name.indexOf("Unnamed")===0||_this6.state.values.name===originalDetails.map(function(d){return d.name;}).join(" & "))){_this6.onChangeValue("name",details.map(function(d){return d.name;}).join(" & "));}});});}},{key:"save",value:function save(){var _ref4=arguments.length<=0||arguments[0]===undefined?{}:arguments[0];var applyRecurring=_ref4.applyRecurring;var values=(0,_assign2.default)({},this.state.values);values.start_time=values.start_time&&values.start_time.toISOString();values.end_time=values.end_time&&values.end_time.toISOString();if(values._livestream_film){values._livestream_film.start_time=values._livestream_film.start_time&&values._livestream_film.start_time.toISOString();values._livestream_film.end_time=values._livestream_film.start_time&&values._livestream_film.end_time.toISOString();}if(this.state.event.recurring_event&&!applyRecurring){this.setState({showRecurringUpdateModal:true});return;}this.setState({isSaving:true,lastUpdatedAt:this.state.event.updated_at,showRecurringUpdateModal:false});if(applyRecurring){_EventActions2.default.edit.defer(this.props.params.eventId,values,applyRecurring);}else{_EventActions2.default.edit.defer(this.props.params.eventId,values);}}},{key:"deleteConfirm",value:function deleteConfirm(){if(this.state.event.recurring_event){this.setState({showRecurringDeleteModal:true});}else if(window.confirm("Are you sure you want to DELETE \""+this.state.event.name+"\"? The screening will be PERMANENTLY DESTROYED and cannot be recovered.")){this.delete();}}},{key:"delete",value:function _delete(){var _this7=this;var _ref5=arguments.length<=0||arguments[0]===undefined?{}:arguments[0];var applyRecurring=_ref5.applyRecurring;var isVirtual=this.state.event.is_virtual;var bucket=this.state.event.event_bucket;this.setState({dirty:false},function(){_EventActions2.default.delete(_this7.props.params.eventId,applyRecurring);_this7.context.router.push("/event_buckets/"+bucket+(isVirtual?"/virtual_festival":"/events"));});}},{key:"duplicate",value:function duplicate(){if(window.confirm("Are you sure you want to duplicate \""+this.state.event.name+"\"? All ticket buckets will be duplicated as well.")){_EventActions2.default.duplicate(this.props.params.eventId);this.context.router.push("/event_buckets/"+this.props.params.eventBucketId+"/events/new?duplicate=true"+(this.state.event.is_virtual?"&virtual=true":""));}}},{key:"componentDidMount",value:function componentDidMount(){var _this8=this;this.context.router.setRouteLeaveHook(this.props.route,function(){if(_this8.state.dirty){return"Are you sure you wish to leave the event editor? Your changes will not be saved.";}});this.componentWillReceiveProps(this.props);}},{key:"componentWillReceiveProps",value:function componentWillReceiveProps(newProps){var event=newProps.getEventById(newProps.params.eventId);if(!this.state.isFetchingEvent&&(!event||!event.public_url)){_EventActions2.default.fetchOne.defer(newProps.params.eventId);this.setState({isFetchingEvent:true});}else if(event&&event.public_url){this.setState({isFetchingEvent:false,event:event});}// Short circuit if event not ready yet
	if(!event||!event.public_url){return;}var liveFilm=event&&(0,_find2.default)(event.films,function(f){return f.type==="livestream";});if(event&&!this.state.mode){if(event.is_virtual){var hasVod=event.films.some(function(f){return!f.virtual_content||f.virtual_content.type!=="livestream";});var hasLive=!!liveFilm;this.setState({mode:hasVod&&hasLive?"combo":hasVod?"vod":hasLive?"live":null});}else if(event.films.length||this.state.values.films&&this.state.values.films.length){this.setState({mode:"film"});}else if(!event.is_dated){this.setState({mode:"undated"});}else if(event.name&&event.name!=="Unnamed Event"||event.description||event.short_description){this.setState({mode:"default"});}}if(Object.keys(this.state.values).length===0||this.state.event.id!==newProps.params.eventId||this.state.isSaving&&event.updated_at!==this.state.lastUpdatedAt){this.setState({oldVenue:event.venue.id,hasReservedSeating:event.venue.use_reserved_seating,hasVenueChanged:false});this.setState({event:event,dirty:false,isSaving:false,showExternalTicketsUrl:event&&!!event.external_tickets_url,showTicketsButtonLabel:event&&!!event.tickets_button_label,showGeographicRestrictions:event?event.geographic_restrictions.length?"geographic_restrictions":event.geographic_exclusions.length?"geographic_exclusions":null:undefined,values:event?{name:event.name||"",films:event.films?event.films.map(function(f){return f.id;}):[],description:event.description||"",short_description:event.short_description||"",venue:event.venue.id,is_dated:event.is_dated,start_time:event.start_time?_momentTimezone2.default.tz(event.start_time,event.timezone):_momentTimezone2.default.tz(Date.now(),event.timezone).startOf("day").add(10,"days").add(19,"hours"),end_time:event.end_time?_momentTimezone2.default.tz(event.end_time,event.timezone):_momentTimezone2.default.tz(Date.now(),event.timezone).startOf("day").add(10,"days").add(21,"hours"),hide_tickets_button:event.hide_tickets_button,tickets_button_label:event.tickets_button_label,external_tickets_url:event.external_tickets_url,trailer_url:event.trailer_url,display_ad_url:event.display_ad_url,visibility:event.visibility,custom_email_text:event.custom_email_text,passholder_ticket_required:event.passholder_ticket_required,standalone_ticket_sales_enabled:event.standalone_ticket_sales_enabled,standalone_ticket_sales_unlocked:event.standalone_ticket_sales_unlocked,sales_disabled_unless_coupon:event.sales_disabled_unless_coupon,cutoff_event_watch_at_availability_end:event.cutoff_event_watch_at_availability_end,comscore_include:event.comscore_include,require_mailing_address:event.require_mailing_address,require_phone_number:event.require_phone_number,credits_disabled:event.credits_disabled,aarp_member_required:event.aarp_member_required,geographic_restrictions:event.geographic_restrictions||[],geographic_exclusions:event.geographic_exclusions||[],show_in_coming_soon:event.show_in_coming_soon,allow_preorder:event.allow_preorder,show_quantity_countdown:event.show_quantity_countdown,virtual_balloting_enabled:event.virtual_balloting_enabled,virtual_balloting_inline_during_playback:event.virtual_balloting_inline_during_playback,tags:event.tags.map(function(t){return t.id;}),custom_id:event.custom_id,ticket_buckets:event.ticket_buckets||[],use_default_event_bucket_preroll:event.use_default_event_bucket_preroll===undefined?true:event.use_default_event_bucket_preroll,virtual_content_preroll:event.virtual_content_preroll,virtual_content_preroll_visible:event.virtual_content_preroll_visible===undefined?true:event.virtual_content_preroll_visible,use_default_event_bucket_postroll:event.use_default_event_bucket_postroll===undefined?true:event.use_default_event_bucket_postroll,virtual_content_postroll:event.virtual_content_postroll,virtual_content_postroll_visible:event.virtual_content_postroll_visible===undefined?true:event.virtual_content_postroll_visible,virtual_show_donate_prompt:event.virtual_show_donate_prompt,virtual_intervals:event.virtual_intervals,virtual_donate_message:event.virtual_donate_message,virtual_realtime_broadcast_film:event.virtual_realtime_broadcast_film,virtual_realtime_broadcast_become_vod_afterwards:event.virtual_realtime_broadcast_become_vod_afterwards,rules:event.rules||[],_livestream_film:liveFilm?{id:liveFilm.id,name:liveFilm.name,short_description:liveFilm.short_description,description:liveFilm.description,start_time:liveFilm.start_time?_momentTimezone2.default.tz(liveFilm.start_time,event.timezone):undefined,end_time:liveFilm.end_time?_momentTimezone2.default.tz(liveFilm.end_time,event.timezone):undefined,livestream_mode:liveFilm.livestream_mode,livestream_embed_code:liveFilm.livestream_embed_code,livestream_external_instructions:liveFilm.livestream_external_instructions}:undefined,terms_at_checkout:event.terms_at_checkout,revenue_share:event.revenue_share}:{}});}}},{key:"renderExternalTicketsUrl",value:function renderExternalTicketsUrl(){var _this9=this;return _react2.default.createElement("div",null,_react2.default.createElement(_materialUi.Checkbox,{label:"Sell tickets on external site",checked:this.state.showExternalTicketsUrl,onCheck:this.onExternalTicketsUrlCheck}),this.state.showExternalTicketsUrl?_react2.default.createElement(_materialUi.TextField,{value:this.state.values.external_tickets_url||"",floatingLabelText:"External tickets url",floatingLabelFixed:true,placeholder:"https://ticketwebsite.com/123456",style:{marginTop:"-0.75em",marginLeft:"2.5em"},onChange:function onChange(e){return _this9.onChangeValue("external_tickets_url",e.target.value);}}):null);}},{key:"render",value:function render(){var _this10=this;var styles=this.getStyles();var _state=this.state;var isSaving=_state.isSaving;var htmlRawMode=_state.htmlRawMode;var isFetchingEvent=_state.isFetchingEvent;var event=_state.event;var showTermsEditor=!!this.state.values.terms_at_checkout||this.state.showTermsEditor;var isVirtualExpired=event&&event.is_virtual&&!_UserStore2.default.isGod()&&(_UserStore2.default.getUser()||{}).virtual_festival_plan_status==="expired";if(isFetchingEvent&&(!event||!event.public_url)){return _react2.default.createElement(_workingIndicator2.default,{fullPage:true});}var eventBucket=_EventBucketStore2.default.getEventBucketById(this.props.params.eventBucketId)||{};var user=_UserStore2.default.getUser();var hasComscore=user&&user.connections&&user.connections.comscore&&!this.state.event.is_virtual&&(this.state.event.venue&&this.state.event.venue.comscore_include||this.state.hasVenueChanged&&this.state.isVenueComscoreEnabled);return _react2.default.createElement("div",{style:{marginTop:-20}},_react2.default.createElement(_reactStickynode2.default,{top:"#eventive-app-bar",innerZ:50},_react2.default.createElement("div",{style:styles.actions,id:"eventive-event-editor-bar"},_react2.default.createElement(_backButton2.default,{label:this.props.location.state&&this.props.location.state.fromListing?event.is_virtual?"virtual screenings":"events":event.is_virtual?"screening":"event",style:{marginRight:7,flexShrink:0,marginTop:-1},onTouchTap:function onTouchTap(){return _this10.props.location.state&&_this10.props.location.state.fromListing?_this10.context.router.goBack():_this10.context.router.push("/event_buckets/"+_this10.props.params.eventBucketId+(event.is_virtual?"/virtual_festival":"")+"/events/"+_this10.props.params.eventId);}}),_react2.default.createElement("h1",{style:styles.title},this.state.values.name,_react2.default.createElement("div",{style:styles.subtitle},(0,_util.makeEventDateRangeLabel)(_extends({},this.state.event,this.state.values)))),isVirtualExpired?_react2.default.createElement("div",{style:{flexShrink:0}},_react2.default.createElement(_materialUi.RaisedButton,{label:"Cannot save since Eventive Virtual expired \u2013 contact us",disabled:true})):_react2.default.createElement("div",{style:{flexShrink:0}},_react2.default.createElement(_materialUi.IconButton,{tooltip:!this.state.dirty&&(event.is_virtual?"Duplicate screening":"Duplicate event"),onTouchTap:this.duplicate,disabled:this.state.dirty},_react2.default.createElement(_contentCopy2.default,null)),_react2.default.createElement(_materialUi.IconButton,{tooltip:event.is_virtual?"Delete screening":"Delete event",onTouchTap:this.deleteConfirm,style:{marginLeft:-12},iconStyle:{color:'#ee2200'}},_react2.default.createElement(_delete3.default,null)),!this.state.dirty?event.is_virtual?_react2.default.createElement(_viewLiveVirtualButton2.default,{style:{marginRight:12,marginLeft:6,verticalAlign:8},label:"View live",href:this.state.event.public_url}):_react2.default.createElement(_materialUi.RaisedButton,{style:{marginRight:12,marginLeft:6,verticalAlign:10},label:"View live",href:event.public_url,target:"_blank"}):null,_react2.default.createElement(_materialUi.RaisedButton,{label:isSaving?"Saving...":this.state.dirty?"Save changes":"No changes to save",primary:true,disabled:!this.state.dirty||isSaving,onTouchTap:this.save,style:{marginLeft:6,verticalAlign:8}})))),isSaving&&_react2.default.createElement(_workingIndicator2.default,{fullPage:true,overlay:true}),this.state.showScheduler?_react2.default.createElement(_schedulerOverlay2.default,{timezone:this.state.event.timezone,repeats:this.state.event.recurring_event&&this.state.event.recurring_event.repeats,start_time:this.state.values.start_time,end_time:this.state.values.end_time,name:this.state.values.name,onChange:function onChange(e,cb){return _this10.onRRuleChange(e,cb);},onRequestClose:function onRequestClose(){return _this10.setState({showScheduler:false});}}):null,this.state.showRecurringUpdateModal?_react2.default.createElement(_recurringUpdateModal2.default,{title:"Edit recurring event",buttonTitle:"Save",onSave:function onSave(applyRecurring){return _this10.save({applyRecurring:applyRecurring});},onRequestClose:function onRequestClose(){return _this10.setState({showRecurringUpdateModal:false});}}):null,this.state.showRecurringDeleteModal?_react2.default.createElement(_recurringUpdateModal2.default,{title:"Delete recurring event",buttonTitle:"Submit",onSave:function onSave(applyRecurring){return _this10.delete({applyRecurring:applyRecurring});},onRequestClose:function onRequestClose(){return _this10.setState({showRecurringDeleteModal:false});}}):null,_react2.default.createElement("div",{style:{marginTop:-20}},this.state.event.eventival_id&&_react2.default.createElement(_eventivalBanner2.default,{type:"event",style:{marginTop:20,marginBottom:-10}}),_react2.default.createElement(_infoNotice2.default,{style:{marginTop:20}},"Check out our"," ",event.is_virtual?_react2.default.createElement("a",{href:"http://help.eventive.org/en/articles/3987519-create-virtual-screenings",target:"_blank"},"guide to creating virtual screenings"):_react2.default.createElement("a",{href:"http://help.eventive.org/events-and-tickets/create-events",target:"_blank"},"guide to creating events"),".")),!event.is_virtual?_react2.default.createElement("div",{style:{marginTop:"1em"}},_react2.default.createElement(_label2.default,null,"Event type"),_react2.default.createElement(_selectWells2.default,{style:{maxWidth:"calc(517px + 1em)"},options:[{value:"film",icon:_localMovies2.default,label:"Film showing"},{value:"default",icon:_event2.default,label:"Other event"},{value:"undated",icon:_dateRange2.default,label:"Undated event"}],onChange:function onChange(v){return _this10.setState({mode:v},function(){return _this10.onModeChange(v);});},value:this.state.mode})):_react2.default.createElement("div",{style:{margin:"1em 0"}},_react2.default.createElement(_label2.default,null,"Virtual screening type"),_react2.default.createElement(_selectWells2.default,{style:{maxWidth:"calc(750px + 1em)"},options:[{value:"vod",icon:_localMovies2.default,label:"Video on Demand"},{value:"live",icon:_event2.default,label:"Livestream"},{value:"combo",icon:_dateRange2.default,label:"VOD + Live"}],onChange:function onChange(v){var ok=v!=="vod"||["live","combo"].indexOf(_this10.state.mode)===-1||window.confirm("Are you sure you would like to remove the livestream from this screening? You CANNOT re-attach it.");if(ok){_this10.setState({mode:v},function(){return _this10.onModeChange(v);});}},value:this.state.mode})),event.is_virtual&&(this.state.mode==="vod"||this.state.mode==="combo")||this.state.mode==="film"?_react2.default.createElement("div",{style:{marginTop:"2em"}},_react2.default.createElement(_injectedSelect2.default,{label:"Film(s)",placeholder:"Select one or more films...",value:this.state.values.films,type:"films",multi:true,noResultsText:event.is_virtual?_react2.default.createElement("span",null,"No films with virtual content found. Use the"," ",_react2.default.createElement(_reactRouter.Link,{to:"event_buckets/"+this.props.params.eventBucketId+"/films"},"Films")," ","section to create new films, and ensure content creators have uploaded virtual content."):_react2.default.createElement("span",null,"No films found. Use the"," ",_react2.default.createElement(_reactRouter.Link,{to:"event_buckets/"+this.props.params.eventBucketId+"/films"},"Films")," ","section to create new films."),labelToFilterString:function labelToFilterString(f){return f.name;},labelFormatter:event.is_virtual?function(f){return _react2.default.createElement("span",null,f.name," ",_react2.default.createElement("span",{style:{fontSize:"0.9em"}}," ","\xB7 ",_react2.default.createElement(_filmTable.Status,{film:f,detailed:true,inWidget:true})));}:function(f){return f.name;},filterBy:event.is_virtual?function(f){return f.type!=="livestream"&&(!f.virtual_content||f.virtual_content.type!=="livestream");}:undefined,eventBucketId:this.props.params.eventBucketId,style:{maxWidth:517},closeOnSelect:true,onChange:function onChange(selected){_this10._updateFilms(selected);}})):null,event.is_virtual&&this.state.mode||this.state.mode==="film"&&this.state.values.films.length||this.state.mode==="undated"||this.state.mode==="default"?_react2.default.createElement("div",null,_react2.default.createElement("div",null,_react2.default.createElement(_materialUi.TextField,{value:(0,_get2.default)(this.state,"values.name",""),floatingLabelText:event.is_virtual?"Virtual listing title":"Event name",floatingLabelFixed:true,style:{width:"100%",maxWidth:517},onChange:function onChange(e){return _this10.onChangeValue("name",e.target.value);}})),(_EventBucketStore2.default.getEventBucketById(this.props.params.eventBucketId)||{}).enable_custom_event_ids?_react2.default.createElement("div",null,_react2.default.createElement(_materialUi.TextField,{value:(0,_get2.default)(this.state,"values.custom_id",""),floatingLabelText:"Custom event ID",floatingLabelFixed:true,style:{width:"100%",maxWidth:517},onChange:function onChange(e){return _this10.onChangeValue("custom_id",e.target.value);}})):null,event.is_virtual&&["live","combo"].indexOf(this.state.mode)!==-1?_react2.default.createElement("div",{style:{marginTop:"1em",marginBottom:"1em",border:"2px dashed #ccc",borderRadius:"1em",maxWidth:550,padding:20}},_react2.default.createElement("h2",null,"Livestream setup"),_react2.default.createElement("div",{style:{marginTop:"1em"}},"This screening includes a livestream. Nice! Configure your livestream here. Once saved and configured, you can start a livestream from the"," ",_react2.default.createElement(_reactRouter.Link,{to:"/event_buckets/"+this.props.params.eventBucketId+"/virtual_festival/live"},"livestreaming hub"),"."),this.state.mode==="combo"?_react2.default.createElement("div",{style:{marginBottom:"1em"}},_react2.default.createElement(_materialUi.TextField,{value:(0,_get2.default)(this.state,"values._livestream_film.name",""),floatingLabelText:"Livestream title",floatingLabelFixed:true,style:{width:"100%",maxWidth:517},onChange:function onChange(e){return _this10.onChangeValue("_livestream_film.name",e.target.value);}}),_react2.default.createElement(_materialUi.TextField,{value:(0,_get2.default)(this.state,"values._livestream_film.short_description",""),floatingLabelText:"Livestream short/sidebar description",floatingLabelFixed:true,multiLine:true,style:{display:"block",width:"100%",maxWidth:517},onChange:function onChange(e){return _this10.onChangeValue("_livestream_film.short_description",e.target.value);}}),_react2.default.createElement(_label2.default,null,"Livestream description"),_react2.default.createElement(_htmlEditor2.default,{value:(0,_get2.default)(this.state,"values._livestream_film.description",""),onChange:function onChange(content){return _this10.onChangeValue("_livestream_film.description",content);}})):null,_react2.default.createElement("div",{style:{}},_react2.default.createElement(_datetimeField2.default,{value:(0,_get2.default)(this.state,"values._livestream_film.start_time",""),label:"Livestream start time",useMoment:true,unclearable:true,timezone:this.state.event.timezone,onChange:function onChange(e,v){return _this10.onChangeValue("_livestream_film.start_time",v);},style:{display:"inline-block",marginRight:24}}),_react2.default.createElement(_datetimeField2.default,{value:(0,_get2.default)(this.state,"values._livestream_film.end_time",""),label:"Livestream end time",useMoment:true,unclearable:true,timezone:this.state.event.timezone,onChange:function onChange(e,v){return _this10.onChangeValue("_livestream_film.end_time",v);},style:{display:"inline-block"}})),_react2.default.createElement("div",null,_react2.default.createElement(_label2.default,null,"Livestream mode"),_react2.default.createElement(_materialUi.RadioButtonGroup,{name:"livestream_mode",valueSelected:(0,_get2.default)(this.state,"values._livestream_film.livestream_mode",""),onChange:function onChange(e,v){return _this10.onChangeValue("_livestream_film.livestream_mode",v);},style:{display:"flex",justifyContent:"space-evenly"}},_react2.default.createElement(_materialUi.RadioButton,{value:"eventive",label:"Eventive native secure livestream with live chat",labelStyle:{lineHeight:"20px"},style:{display:"block"}}),_react2.default.createElement(_materialUi.RadioButton,{value:"embedded",label:"Embedded player (e.g. YouTube; no live chat)",labelStyle:{lineHeight:"20px"},style:{display:"block"}}),_react2.default.createElement(_materialUi.RadioButton,{value:"external",label:"External instructions (no player or chat)",labelStyle:{lineHeight:"20px"},style:{display:"block"}}))),(0,_get2.default)(this.state,"values._livestream_film.livestream_mode","")==="embedded"&&_react2.default.createElement("div",null,_react2.default.createElement(_label2.default,null,"Raw embed code (must be valid HTML)"),_react2.default.createElement(_reactCodemirror2.default,{ref:function ref(r){return r&&r.getCodeMirror().setSize(null,100);},style:{border:"1px solid #ccc"},value:(0,_get2.default)(this.state,"values._livestream_film.livestream_embed_code",""),onChange:function onChange(content){return _this10.onChangeValue("_livestream_film.livestream_embed_code",content);},options:{lineWrapping:true,lineNumbers:true,mode:{name:"htmlmixed"}}})),(0,_get2.default)(this.state,"values._livestream_film.livestream_mode","")==="external"&&_react2.default.createElement("div",null,_react2.default.createElement(_label2.default,null,"External access instructions"),_react2.default.createElement(_htmlEditor2.default,{value:(0,_get2.default)(this.state,"values._livestream_film.livestream_external_instructions",""),onChange:function onChange(content){return _this10.onChangeValue("_livestream_film.livestream_external_instructions",content);}}))):null,event.is_virtual?_react2.default.createElement("div",null,_react2.default.createElement(_label2.default,null,"Availability window"),_react2.default.createElement(_materialUi.RadioButtonGroup,{name:"is_dated",valueSelected:(typeof this.state.values.is_dated!=="undefined"?this.state.values.is_dated:"").toString(),onChange:function(){var _ref6=_asyncToGenerator(regeneratorRuntime.mark(function _callee3(e,v){return regeneratorRuntime.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:_context3.next=2;return _this10.onChangeValueAsync("is_dated",v==="true");case 2:if(!(v==="false")){_context3.next=5;break;}_context3.next=5;return _this10.onChangeValueAsync("virtual_realtime_broadcast_film",false);case 5:case"end":return _context3.stop();}}},_callee3,_this10);}));return function(_x6,_x7){return _ref6.apply(this,arguments);};}()},_react2.default.createElement(_materialUi.RadioButton,{value:"false",label:"No date restrictions on availability"}),_react2.default.createElement(_materialUi.RadioButton,{value:"true",label:"Restrict availability by date"}))):null,(event.is_virtual?this.state.values.is_dated:this.state.mode!=="undated")?_react2.default.createElement("div",{style:event.is_virtual?{marginLeft:"3em"}:{}},_react2.default.createElement(_datetimeField2.default,{value:this.state.values.start_time,label:this.state.values.virtual_realtime_broadcast_film?"Live broadcast begins":event.is_virtual?"Availability opens":"Start time",useMoment:true,unclearable:true,timezone:this.state.event.timezone,onChange:function onChange(e,v){return _this10.onChangeValue("start_time",v);},style:{display:"inline-block",marginRight:24}}),_react2.default.createElement(_datetimeField2.default,{value:this.state.values.end_time,label:this.state.values.virtual_realtime_broadcast_film?this.state.values.virtual_realtime_broadcast_become_vod_afterwards?"On-demand access closes":"Live broadcast ends":event.is_virtual?"Availability closes":"End time",useMoment:true,unclearable:true,timezone:this.state.event.timezone,onChange:function onChange(e,v){return _this10.onChangeValue("end_time",v);},style:{display:"inline-block"}})):null,this.state.mode!=="undated"&&!event.is_virtual?!this.state.event.recurring_event?_react2.default.createElement("div",{style:{marginTop:0}},_react2.default.createElement(_linkLike2.default,{onTouchTap:function onTouchTap(){return _this10.setState({showScheduler:true});}},"Schedule event recurrence")):_react2.default.createElement("div",null,_react2.default.createElement(_label2.default,null,"Recurrence"),this.state.event.recurring_event&&this.state.event.recurring_event.repeats&&this.state.event.recurring_event.repeats.map(function(_ref7){var rrule=_ref7.rrule;var duration=_ref7.duration;var r=(0,_rrule.rrulestr)(rrule);var first=r.all(function(_,i){return i===0;});var d=first.length?first[0]:new Date();var m=(0,_momentTimezone2.default)((0,_schedulerOverlay.appendTimeZone)(d)).tz(_this10.state.event.timezone);return _react2.default.createElement("div",null,m.format("LT [– beginning] dddd, LL,")," ",r.toText());}),_react2.default.createElement("div",null,_react2.default.createElement(_linkLike2.default,{onTouchTap:function onTouchTap(){return _this10.setState({showScheduler:true});}},"Edit schedule"))):null,event.is_virtual&&this.state.values.is_dated?_react2.default.createElement("div",{style:{marginLeft:"2.75em",marginTop:"0.25em",marginBottom:"1em",maxWidth:700}},_react2.default.createElement(_materialUi.Checkbox,{label:"Allow customers to pre-order this screening & receive an email reminder when it goes live",checked:(0,_get2.default)(this.state,"values.allow_preorder",false),onCheck:function onCheck(e){return _this10.onChangeValue("allow_preorder",!_this10.state.values.allow_preorder);}}),_react2.default.createElement(_materialUi.Checkbox,{label:"Show in \"Coming Soon\" section in Catalog before screening becomes available",checked:(0,_get2.default)(this.state,"values.show_in_coming_soon",false),onCheck:function onCheck(e){return _this10.onChangeValue("show_in_coming_soon",!_this10.state.values.show_in_coming_soon);}}),_react2.default.createElement(_materialUi.Checkbox,{label:"Play VOD content as a single real-time broadcast",checked:(0,_get2.default)(this.state,"values.virtual_realtime_broadcast_film",false),onCheck:function onCheck(e){return _this10.onChangeValue("virtual_realtime_broadcast_film",_this10.state.values.virtual_realtime_broadcast_film?false:true);}}),this.state.values.virtual_realtime_broadcast_film?_react2.default.createElement("div",{style:{marginLeft:"3em",marginTop:"0.5em",maxWidth:550,border:"2px dashed #ccc",padding:"10px 14px",borderRadius:"0.25em"}},_react2.default.createElement("div",{style:{fontWeight:"bold",marginBottom:"0.2em"}},"Eventive Real-Time Broadcasting"),_react2.default.createElement("div",{style:{marginBottom:"0.2em"}},"When you enable Real-Time Broadcasting, the program will begin to play automatically at"," ",_react2.default.createElement("span",null,(0,_momentTimezone2.default)(this.state.values.start_time).format("lll"))," ","and play all pre-roll, all films, and finally all post-roll elements, in that order. Viewers will not be able to rewind or fast-forward. If viewers join late, they will miss the beginning of the program. When the last item has finished, the program will"," ",this.state.values.virtual_realtime_broadcast_become_vod_afterwards?"become available for on-demand viewing until the availability window closes.":"end and no longer be accessible to anyone."),_react2.default.createElement("div",{style:{marginBottom:"0.2em"}},"By default, a live chat will be available. You can moderate, or disable it entirely, via the Livestreaming hub."),_react2.default.createElement("div",{style:{marginBottom:"0.2em"}},"Only media uploaded through the Eventive VOD secure pathway is supported for DRM-protected real-time broadcasting."," ",_react2.default.createElement("strong",null,"Review the program order below to confirm what will be played.")),function(){var goodAssets=event.virtual_content_preroll.map(function(k){return _VirtualContentStore2.default.getVirtualContentById(k);}).filter(function(p){return p&&p.ams_drm_enabled;}).map(function(p){return p.label;}).concat(event.films.filter(function(f){return f.virtual_content&&f.virtual_content.ams_drm_enabled&&f.virtual_content.status==="ready";}).map(function(f){return f.name;})).concat(event.virtual_content_postroll.map(function(k){return _VirtualContentStore2.default.getVirtualContentById(k);}).filter(function(p){return p&&p.ams_drm_enabled;}).map(function(p){return p.label;})).join(", ");var badAssets=event.virtual_content_preroll.map(function(k){return _VirtualContentStore2.default.getVirtualContentById(k);}).filter(function(p){return p&&!p.ams_drm_enabled;}).map(function(p){return p.label;}).concat(event.films.filter(function(f){return!(f.virtual_content&&f.virtual_content.ams_drm_enabled&&f.virtual_content.status==="ready")&&f.type!=="livestream";}).map(function(f){return f.name;})).concat(event.virtual_content_postroll.map(function(k){return _VirtualContentStore2.default.getVirtualContentById(k);}).filter(function(p){return p&&!p.ams_drm_enabled;}).map(function(p){return p.label;})).join(", ");return _react2.default.createElement("div",{style:{marginBottom:"0.2em"}},"Program order:"," ",_react2.default.createElement("strong",null,goodAssets," ",badAssets?_react2.default.createElement("div",{style:{color:"red"}},"*** DANGER: THE FOLLOWING ASSETS ARE NOT POWERED BY EVENTIVE VOD AND WILL NOT BE INCLUDED IN THE BROADCAST: ",badAssets):null));}(),_react2.default.createElement("div",{style:{marginBottom:"0em"}},"Status:"," ",event.virtual_realtime_broadcast_film?_react2.default.createElement("strong",null,"Scheduled & going live"," ",(0,_momentTimezone2.default)(event.start_time).format("lll")):_react2.default.createElement("span",null,_react2.default.createElement("strong",null,"Not scheduled")," (save to update)")),_react2.default.createElement("div",{style:{marginTop:"0.5em",marginBottom:"0.5em"}},_react2.default.createElement(_materialUi.Checkbox,{label:_react2.default.createElement("span",null,"After live broadcast concludes, make program available for on-demand viewing until availability window closes"),labelStyle:{lineHeight:"20px"},checked:(0,_get2.default)(this.state,"values.virtual_realtime_broadcast_become_vod_afterwards",false),onCheck:function onCheck(e){return _this10.onChangeValue("virtual_realtime_broadcast_become_vod_afterwards",!_this10.state.values.virtual_realtime_broadcast_become_vod_afterwards);}}))):null):null,event.is_virtual?_react2.default.createElement("div",null,_react2.default.createElement(_label2.default,null,"Geographic availability"),_react2.default.createElement(_materialUi.RadioButtonGroup,{name:"geo_availability",valueSelected:this.state.showGeographicRestrictions||"null",onChange:function onChange(e,v){if(v==="null")v=null;_this10.setState({showGeographicRestrictions:v},function(){if(v!=="geographic_restrictions"){_this10.onChangeValue("geographic_restrictions",[]);}if(v!=="geographic_exclusions"){_this10.onChangeValue("geographic_exclusions",[]);}});}},_react2.default.createElement(_materialUi.RadioButton,{value:"null",label:"No geographic restrictions"}),_react2.default.createElement(_materialUi.RadioButton,{value:"geographic_restrictions",label:"Only allow certain geographic regions"}),_react2.default.createElement(_materialUi.RadioButton,{value:"geographic_exclusions",label:"Allow all except certain geographic regions"}))):null,this.state.showGeographicRestrictions?_react2.default.createElement("div",{style:{marginTop:"0.25em",marginLeft:"3em"}},_react2.default.createElement("div",{style:{fontWeight:"bold",marginBottom:"0.5em"}},this.state.showGeographicRestrictions==="geographic_restrictions"?"Only users located in the following regions will be allowed to\n                  unlock the content:":"All users EXCEPT those located in the following regions will be allowed to\n                  unlock the content:"),_react2.default.createElement(_injectedSelect2.default,{value:this.state.values[this.state.showGeographicRestrictions],types:["countries","continents","regions"],placeholderText:this.state.showGeographicRestrictions==="geographic_restrictions"?"No authorized continents, countries, or provinces":"No blocked continents, countries, or provinces",multi:true,noResultsText:_react2.default.createElement("span",null,"No regions found. Try entering a continent, country, or province, or"," ",_react2.default.createElement(_linkLike2.default,{onTouchTap:function onTouchTap(){return Intercom("showNewMessage","I'm looking to restrict by: ");}},"get in touch with us"),"."),labelFormatter:function labelFormatter(v){return v.name;},style:{width:400},onChange:function onChange(selected){return _this10.onChangeValue(_this10.state.showGeographicRestrictions,selected);},eventBucketId:this.props.params.eventBucketId})):null,_react2.default.createElement(_label2.default,null,"Description"),this.state.mode==="combo"||this.state.mode==="vod"||this.state.mode==="film"?_react2.default.createElement(_materialUi.Checkbox,{style:{marginBottom:"0.5em",maxWidth:500},label:"Add additional description in addition to film description",checked:this.state.showDescription||this.state.values.description||this.state.values.short_description,onCheck:function onCheck(e,checked){return _this10.setState({showDescription:checked},function(){_this10.onChangeValue("description","",function(){return _this10.onChangeValue("short_description","");});});}}):null,this.state.mode!=="film"&&!event.is_virtual||this.state.mode==="live"||this.state.showDescription||this.state.values.description||this.state.values.short_description?_react2.default.createElement("div",null,typeof(0,_get2.default)(this.state,"values.description")==="string"?_react2.default.createElement(_htmlEditor2.default,{onChange:function onChange(content){return _this10.onChangeValue("description",content);},value:(0,_get2.default)(this.state,"values.description","")}):null,_react2.default.createElement(_materialUi.TextField,{value:(0,_get2.default)(this.state,"values.short_description",""),floatingLabelText:"Short description",floatingLabelFixed:true,multiLine:true,style:{display:"block",width:"100%",maxWidth:517},onChange:function onChange(e){return _this10.onChangeValue("short_description",e.target.value);}}),this.state.mode!=="live"?_react2.default.createElement("div",{style:{fontSize:"0.8em",marginTop:-5,color:"rgb(158, 158, 158)"}},"Not required. Used in schedule extended view as well as for social media sharing."):null):null,!event.is_virtual&&_react2.default.createElement("div",null,_react2.default.createElement(_label2.default,null,"Venue"),_react2.default.createElement(_injectedSelect2.default,{value:this.state.values.venue,type:"venues",noResultsText:_react2.default.createElement("span",null,"No venues found. Use the"," ",_react2.default.createElement(_reactRouter.Link,{to:"event_buckets/"+this.props.params.eventBucketId+"/venues"},"Venues")," ","section to create new venues."),labelFormatter:function labelFormatter(v){return v.name;},eventBucketId:this.props.params.eventBucketId,style:{width:300},onChange:function onChange(selected){// NOTE: For Comscore, if the venue is not comscore enabled,
	// we are going to hide the COMSCORE selection option. Only
	// venues that are enabled are included in the nightly upload.
	_this10.setState({hasVenueChanged:selected!==_this10.state.oldVenue,isVenueComscoreEnabled:_VenueStore2.default.isVenueComscoreEnabled(selected)});_this10.onChangeValue("venue",selected);}})),!event.is_virtual&&this.state.hasReservedSeating&&this.state.hasVenueChanged?_react2.default.createElement("div",{style:{color:"#f00",fontSize:11,fontWeight:"bold"}},"WARNING: If you change the venue after tickets have been sold for this event, some customers may lose the reserved seats they have chosen."):null,_react2.default.createElement("div",{style:event.is_virtual?{marginBottom:"1em"}:{}},_react2.default.createElement(_label2.default,null,event.is_virtual?"Display sections":"Tags"),this.state.mode==="film"?_react2.default.createElement(_materialUi.Checkbox,{style:{marginBottom:"0.5em"},label:"Add additional tags in addition to film tags",checked:this.state.showTags||this.state.values.tags.length,onCheck:function onCheck(e,checked){return _this10.setState({showTags:checked},function(){_this10.onChangeValue("tags",[]);});}}):null,event.is_virtual||this.state.mode!=="film"||this.state.showTags||this.state.values.tags.length?_react2.default.createElement(_injectedSelect2.default,{value:(0,_get2.default)(this.state.values,"tags",[]),types:["tags"],multi:true,noResultsText:_react2.default.createElement("span",null,"No tags found. Use the"," ",_react2.default.createElement(_reactRouter.Link,{to:"event_buckets/"+this.props.params.eventBucketId+"/tags"},"Tags")," ","section to create new tags."),labelFormatter:function labelFormatter(t){return t.name;},eventBucketId:this.props.params.eventBucketId,style:{width:500},onChange:function onChange(selected){return _this10.onChangeValue("tags",selected);}}):null),!event.is_virtual||this.state.event&&this.state.event.images&&this.state.event.images.cover?_react2.default.createElement("div",null,_react2.default.createElement(_label2.default,null,"Cover image"),(event.is_virtual?this.state.mode==="vod"||this.state.mode==="combo":this.state.mode==="film")?_react2.default.createElement(_materialUi.Checkbox,{style:{marginBottom:"0.5em"},label:"Show a custom cover image instead of default film cover image",checked:this.state.showCoverImage||this.state.event&&this.state.event.images&&this.state.event.images.cover,onCheck:function onCheck(e,checked){return _this10.setState({showCoverImage:checked},function(){_this10.state.event.images.cover=null;_this10.setState(_this10.state,function(){if(!_this10.state.showCoverImage){_this10.onChangeValue("image",null);}});});}}):null,this.state.showCoverImage||this.state.mode!=="film"||this.state.event&&this.state.event.images&&this.state.event.images.cover?_react2.default.createElement("div",null,this.props.uploadingImageField==="image"?_react2.default.createElement("div",null,_react2.default.createElement(_materialUi.CircularProgress,{style:styles.progress,mode:"indeterminate"})):null,_react2.default.createElement("div",{style:{display:this.props.uploadingImageField==="image"?"none":"block"}},this.state.event&&this.state.event.images&&this.state.event.images.cover?_react2.default.createElement("img",{src:this.state.event.images.cover,width:242}):null,_react2.default.createElement(_imageDropzone2.default,{style:styles.dropzone,onDrop:function onDrop(_ref8){var _ref9=_slicedToArray(_ref8,1);var f=_ref9[0];return _this10.onDrop("image",f);},crop:{width:960,height:380}},_react2.default.createElement("div",null,"To add a new cover image, drop a file here, or click to select.")))):null):null,event.is_virtual?_react2.default.createElement("div",null,_react2.default.createElement(_label2.default,null,"Still image"),_react2.default.createElement(_materialUi.Checkbox,{style:{marginBottom:"0.5em"},label:"Show a custom still image on the screening page"+(this.state.mode!=="live"?" instead of default film image":""),checked:this.state.showStillImage||this.state.event&&this.state.event.images&&this.state.event.images.still,onCheck:function onCheck(e,checked){return _this10.setState({showStillImage:checked},function(){_this10.state.event.images.still=null;_this10.setState(_this10.state,function(){if(!_this10.state.showStillImage){_this10.onChangeValue("still_image",null);}});});}}),this.state.showStillImage||this.state.event&&this.state.event.images&&this.state.event.images.still?_react2.default.createElement("div",null,this.props.uploadingImageField==="still_image"?_react2.default.createElement("div",null,_react2.default.createElement(_materialUi.CircularProgress,{style:styles.progress,mode:"indeterminate"})):null,_react2.default.createElement("div",{style:{display:this.props.uploadingImageField==="still_image"?"none":"block"}},this.state.event&&this.state.event.images&&this.state.event.images.still?_react2.default.createElement("img",{src:this.state.event.images.still,width:242}):null,_react2.default.createElement(_imageDropzone2.default,{style:styles.dropzone,onDrop:function onDrop(_ref10){var _ref11=_slicedToArray(_ref10,1);var f=_ref11[0];return _this10.onDrop("still_image",f);},crop:{width:1920,height:1080},hideCropTip:true},_react2.default.createElement("div",null,"To add a new still image, drop a file here, or click to select."," ",_react2.default.createElement("div",{style:{marginTop:"0.5em",fontSize:"0.9em",lineHeight:1.3}},"Recommended: 1920 x 1080px; will be cropped to 16:9 aspect ratio."))))):null):null,event.is_virtual?_react2.default.createElement("div",null,_react2.default.createElement(_label2.default,null,"Display ads"),_react2.default.createElement(_materialUi.Checkbox,{style:{marginBottom:"0.5em"},label:"Show custom display ad(s) on the screening page",checked:this.state.event&&this.state.event.display_ads&&this.state.event.display_ads.length>0,onCheck:function onCheck(e,checked){var newAdState=[];if(checked){newAdState=[{url:null,image:null}];}_this10.state.event.display_ads=newAdState;_this10.setState(_this10.state,function(){_this10.onChangeValue("display_ads",newAdState);});}}),this.state.event&&this.state.event.display_ads&&this.state.event.display_ads.length>0?_react2.default.createElement(_displayAdEditor2.default,{ads:this.state.event.display_ads,onUpdate:function onUpdate(adState){_this10.onChangeValue("display_ads",adState);}}):null):null,(event.is_virtual?this.state.mode!=="vod"&&this.state.mode!=="combo":this.state.mode!=="film")?_react2.default.createElement("div",{style:event.is_virtual?{marginTop:"-0.5em"}:{}},_react2.default.createElement(_materialUi.TextField,{style:{width:300},value:this.state.values.trailer_url||"",floatingLabelText:"Trailer URL",floatingLabelFixed:true,placeholder:"YouTube, Vimeo, Facebook Video link",onChange:function onChange(e){return _this10.onChangeValue("trailer_url",e.target.value);}})):null,_react2.default.createElement("div",null,_react2.default.createElement(_label2.default,null,"Visibility"),_react2.default.createElement(_materialUi.RadioButtonGroup,{name:"visibility",valueSelected:this.state.values.visibility,onChange:function onChange(e,v){return _this10.onChangeValue("visibility",v);}},[_react2.default.createElement(_materialUi.RadioButton,{value:"visible",label:"Visible (if schedule is enabled)"}),_react2.default.createElement(_materialUi.RadioButton,{value:"hidden",label:"Hidden from public"}),!event.is_virtual&&_react2.default.createElement(_materialUi.RadioButton,{value:"tba",label:"Show as \"To Be Announced\""})].filter(function(x){return!!x;}))),_react2.default.createElement(_label2.default,null,"Custom confirmation email message"),_react2.default.createElement(_materialUi.Checkbox,{style:{marginBottom:"0.5em"},label:"Add custom message to confirmation email",checked:this.state.showCustomEmailText||this.state.values.custom_email_text,onCheck:function onCheck(e,checked){return _this10.setState({showCustomEmailText:checked},function(){_this10.onChangeValue("custom_email_text","");});}}),this.state.showCustomEmailText||this.state.values.custom_email_text?_react2.default.createElement("div",null,_react2.default.createElement(_htmlEditor2.default,{onChange:function onChange(content){_this10.onChangeValue("custom_email_text",content);},value:(0,_get2.default)(this.state,"values.custom_email_text","")})):null,_react2.default.createElement("div",null,_react2.default.createElement(_label2.default,null,"Passholder tickets"),_react2.default.createElement(_materialUi.Checkbox,{label:"Use default event bucket setting",checked:this.state.values.passholder_ticket_required==="default",onCheck:function onCheck(e,checked){return _this10.onChangeValue("passholder_ticket_required",checked?"default":"");}}),this.state.values.passholder_ticket_required!=="default"?_react2.default.createElement(_materialUi.RadioButtonGroup,{name:"passholder_ticket_required",valueSelected:(typeof this.state.values.passholder_ticket_required!=="undefined"?this.state.values.passholder_ticket_required:"").toString(),onChange:function onChange(e,v){return _this10.onChangeValue("passholder_ticket_required",v);}},_react2.default.createElement(_materialUi.RadioButton,{value:"true",label:'Require passholder ticket reservation in advance ("RSVP")',disabled:this.state.values.passholder_ticket_required==="default"}),_react2.default.createElement(_materialUi.RadioButton,{value:"false",label:"Do not require advance reservation; allow passholder walk-ups",disabled:this.state.values.passholder_ticket_required==="default"})):null),_react2.default.createElement("div",null,_react2.default.createElement(_label2.default,null,"Standalone tickets"),_react2.default.createElement(_materialUi.Checkbox,{label:"Use default event bucket setting",checked:this.state.values.standalone_ticket_sales_enabled==="default",onCheck:function onCheck(e,checked){return _this10.onChangeValue("standalone_ticket_sales_enabled",checked?"default":"");}}),this.state.values.standalone_ticket_sales_enabled!=="default"?_react2.default.createElement(_materialUi.RadioButtonGroup,{name:"standalone_ticket_sales_enabled",valueSelected:(typeof this.state.values.standalone_ticket_sales_enabled!=="undefined"?this.state.values.standalone_ticket_sales_enabled:"").toString(),onChange:function onChange(e,v){return _this10.onChangeValue("standalone_ticket_sales_enabled",v);}},_react2.default.createElement(_materialUi.RadioButton,{value:"true",label:"Allow standalone ticket sales",disabled:this.state.values.standalone_ticket_sales_enabled==="default"}),_react2.default.createElement(_materialUi.RadioButton,{value:"false",label:"Disable standalone tickets sales (only allow passholders)",disabled:this.state.values.standalone_ticket_sales_enabled==="default"})):null,(_EventBucketStore2.default.getEventBucketById(this.props.params.eventBucketId)||{}).standalone_ticket_sales_locked?_react2.default.createElement("div",null,_react2.default.createElement("div",{style:{marginTop:10,marginBottom:5,maxWidth:525}},"Currently, standalone ticket sales are locked with a password for this event's event bucket. You can override this lock (for this event only) below."),_react2.default.createElement(_materialUi.Checkbox,{label:"Unlock standalone ticket sales (no password required)",checked:this.state.values.standalone_ticket_sales_unlocked||false,onCheck:this.onChange.bind(this,"standalone_ticket_sales_unlocked")})):null),hasComscore?_react2.default.createElement("div",null,_react2.default.createElement(_label2.default,null,"COMSCORE Box Office Essentials"),_react2.default.createElement(_materialUi.Checkbox,{style:{marginBottom:"0.5em",maxWidth:500},label:"Include event in COMSCORE nightly gross revenue upload",checked:this.state.values.comscore_include,onCheck:function onCheck(e,checked){_this10.onChangeValue("comscore_include",checked);}})):null,event.is_virtual?_react2.default.createElement("div",null,_react2.default.createElement(_label2.default,null,"Pre-roll virtual content"),_react2.default.createElement(_materialUi.Checkbox,{label:"Use default event bucket setting",checked:this.state.values.use_default_event_bucket_preroll,onCheck:function onCheck(e,checked){return _this10.onChangeValue("use_default_event_bucket_preroll",checked);}}),!this.state.values.use_default_event_bucket_preroll?_react2.default.createElement("div",null,_react2.default.createElement(_materialUi.RadioButtonGroup,{name:"virtual_content_preroll_visible",valueSelected:(typeof this.state.values.virtual_content_preroll_visible!=="undefined"?this.state.values.virtual_content_preroll_visible:"").toString(),onChange:function onChange(e,v){return _this10.onChangeValue("virtual_content_preroll_visible",v==="true");}},_react2.default.createElement(_materialUi.RadioButton,{value:"true",label:"Custom pre-roll for this screening"}),_react2.default.createElement(_materialUi.RadioButton,{value:"false",label:"Disable all pre-roll on this screening"})),this.state.values.virtual_content_preroll_visible?_react2.default.createElement("div",{style:{width:"100%",overflowX:"auto",margin:"1em 0"}},_react2.default.createElement(_virtualContentEditor2.default,{style:{width:"min-content",margin:"0 -10px"},useBeta:(0,_get2.default)(eventBucket,"virtual_festival_config.use_beta_vod_flow"),value:this.state.values.virtual_content_preroll,onChange:function onChange(v){return _this10.onChangeValue("virtual_content_preroll",v);}})):null):null):null,event.is_virtual?_react2.default.createElement("div",null,_react2.default.createElement(_label2.default,null,"Post-roll virtual content"),_react2.default.createElement(_materialUi.Checkbox,{label:"Use default event bucket setting",checked:this.state.values.use_default_event_bucket_postroll,onCheck:function onCheck(e,checked){return _this10.onChangeValue("use_default_event_bucket_postroll",checked);}}),!this.state.values.use_default_event_bucket_postroll?_react2.default.createElement("div",null,_react2.default.createElement(_materialUi.RadioButtonGroup,{name:"virtual_content_postroll_visible",valueSelected:(typeof this.state.values.virtual_content_postroll_visible!=="undefined"?this.state.values.virtual_content_postroll_visible:"").toString(),onChange:function onChange(e,v){return _this10.onChangeValue("virtual_content_postroll_visible",v==="true");}},_react2.default.createElement(_materialUi.RadioButton,{value:"true",label:"Custom post-roll for this screening"}),_react2.default.createElement(_materialUi.RadioButton,{value:"false",label:"Disable all post-roll on this screening"})),this.state.values.virtual_content_postroll_visible?_react2.default.createElement("div",{style:{width:"100%",overflowX:"auto",margin:"1em 0"}},_react2.default.createElement(_virtualContentEditor2.default,{style:{width:"min-content",margin:"0 -10px"},useBeta:(0,_get2.default)(eventBucket,"virtual_festival_config.use_beta_vod_flow"),value:this.state.values.virtual_content_postroll,onChange:function onChange(v){return _this10.onChangeValue("virtual_content_postroll",v);}})):null):null):null,event.is_virtual?_react2.default.createElement("div",null,_react2.default.createElement(_label2.default,null,"Donations at checkout"),_react2.default.createElement(_materialUi.Checkbox,{label:"Use default event bucket setting",checked:this.state.values.virtual_show_donate_prompt==="default",onCheck:function onCheck(e,checked){return _this10.onChangeValue("virtual_show_donate_prompt",checked?"default":true);}}),this.state.values.virtual_show_donate_prompt!=="default"?_react2.default.createElement(_materialUi.RadioButtonGroup,{name:"virtual_show_donate_prompt",valueSelected:(typeof this.state.values.virtual_show_donate_prompt!=="undefined"?this.state.values.virtual_show_donate_prompt:"").toString(),onChange:function onChange(e,v){return _this10.onChangeValue("virtual_show_donate_prompt",v==="true");}},_react2.default.createElement(_materialUi.RadioButton,{value:"true",label:"Request donations at checkout",disabled:this.state.values.virtual_show_donate_prompt==="default"}),_react2.default.createElement(_materialUi.RadioButton,{value:"false",label:"Do not request donations at checkout",disabled:this.state.values.virtual_show_donate_prompt==="default"})):null,this.state.values.virtual_show_donate_prompt===true?_react2.default.createElement(_materialUi.TextField,{style:{width:400},multiLine:true,value:this.state.values.virtual_donate_message||(_EventBucketStore2.default.getEventBucketById(this.props.params.eventBucketId)||{frontend_config:{}}).frontend_config.virtual_festival_donate_message,floatingLabelText:"Custom donation prompt message",floatingLabelFixed:true,onChange:function onChange(e){return _this10.onChangeValue("virtual_donate_message",e.target.value);}}):null):null,event.is_virtual&&_react2.default.createElement("div",null,_react2.default.createElement(_label2.default,null,"Unlock/watch interval"),_react2.default.createElement(_materialUi.Checkbox,{label:"Use default event bucket setting",checked:!this.state.values.virtual_intervals,onCheck:function onCheck(e,checked){return _this10.onChangeValue("virtual_intervals",checked?null:{unlock_interval:(0,_get2.default)(eventBucket,"virtual_festival_config.unlock_interval"),watch_interval:(0,_get2.default)(eventBucket,"virtual_festival_config.watch_interval")});}}),!!this.state.values.virtual_intervals&&_react2.default.createElement("div",null,_react2.default.createElement(_durationField2.default,{value:(0,_get2.default)(this.state,"values.virtual_intervals.unlock_interval",""),floatingLabelText:"Unlock window",floatingLabelFixed:true,onChange:function onChange(e){return _this10.onChangeValue("virtual_intervals.unlock_interval",e.target.value);}}),_react2.default.createElement(_durationField2.default,{style:{marginLeft:"1em"},value:(0,_get2.default)(this.state,"values.virtual_intervals.watch_interval",""),floatingLabelText:"Watch window",floatingLabelFixed:true,onChange:function onChange(e){return _this10.onChangeValue("virtual_intervals.watch_interval",e.target.value);}}))),event.is_virtual&&eventBucket&&eventBucket.frontend_config&&eventBucket.frontend_config.use_aarp_registration_flow&&_react2.default.createElement("div",null,_react2.default.createElement(_label2.default,null,"AARP Membership Requirement"),_react2.default.createElement(_materialUi.Checkbox,{label:"Require AARP Membership to access screening",checked:this.state.values.aarp_member_required,onCheck:function onCheck(e,checked){return _this10.onChangeValue("aarp_member_required",!_this10.state.values.aarp_member_required);}})),event.is_virtual?_react2.default.createElement("div",{style:{maxWidth:600}},_react2.default.createElement(_label2.default,null,"Miscellaneous"),(_EventBucketStore2.default.getEventBucketById(this.props.params.eventBucketId)||{}).credits_enabled?_react2.default.createElement("div",{style:{maxWidth:400}},_react2.default.createElement(_materialUi.Checkbox,{label:"Don't allow credits to be used",checked:(0,_get2.default)(this.state,"values.credits_disabled",false),onCheck:function onCheck(e){return _this10.onChangeValue("credits_disabled",!_this10.state.values.credits_disabled);}})):null,_react2.default.createElement(_materialUi.Checkbox,{label:"Show an \"unlocks remaining\" quantity countdown on the screening page",checked:(0,_get2.default)(this.state,"values.show_quantity_countdown",false),onCheck:function onCheck(e){return _this10.onChangeValue("show_quantity_countdown",!_this10.state.values.show_quantity_countdown);}}),_react2.default.createElement(_materialUi.Checkbox,{label:"Enable virtual balloting for this screening",checked:(0,_get2.default)(this.state,"values.virtual_balloting_enabled",false),onCheck:function onCheck(e){return _this10.onChangeValue("virtual_balloting_enabled",!_this10.state.values.virtual_balloting_enabled);}}),window.location.search.indexOf("beta=1")!==-1&&this.state.values.virtual_balloting_enabled?_react2.default.createElement(_materialUi.Checkbox,{label:"[BETA] Show balloting inline below player",checked:(0,_get2.default)(this.state,"values.virtual_balloting_inline_during_playback",false),onCheck:function onCheck(e){return _this10.onChangeValue("virtual_balloting_inline_during_playback",!_this10.state.values.virtual_balloting_inline_during_playback);}}):null,_react2.default.createElement("div",null,_react2.default.createElement(_materialUi.Checkbox,{label:'Use custom text for "Unlock" button',checked:this.state.showTicketsButtonLabel,onCheck:this.onTicketsButtonLabelCheck}),this.state.showTicketsButtonLabel?_react2.default.createElement(_materialUi.TextField,{value:this.state.values.tickets_button_label||"",floatingLabelText:"\"Unlock now\" button label",floatingLabelFixed:true,placeholder:"Unlock now",style:{marginTop:"-0.75em",marginLeft:"2.5em"},onChange:function onChange(e){return _this10.onChangeValue("tickets_button_label",e.target.value);}}):null),this.renderExternalTicketsUrl(),_react2.default.createElement(_materialUi.Checkbox,{label:"Sales locked: Require customers to first enter a valid discount code in order to unlock",checked:(0,_get2.default)(this.state,"values.sales_disabled_unless_coupon",false),onCheck:function onCheck(e){return _this10.onChangeValue("sales_disabled_unless_coupon",!_this10.state.values.sales_disabled_unless_coupon);}}),_UserStore2.default.isGod()&&event.is_virtual?_react2.default.createElement(_materialUi.Checkbox,{label:"[GOD ONLY] Cut off watch window immediately at availability window end for this event",checked:(0,_get2.default)(this.state,"values.cutoff_event_watch_at_availability_end",false),onCheck:function onCheck(e){return _this10.onChangeValue("cutoff_event_watch_at_availability_end",!_this10.state.values.cutoff_event_watch_at_availability_end);}}):null):null,!event.is_virtual?_react2.default.createElement("div",{style:{maxWidth:400}},_react2.default.createElement(_label2.default,null,"Miscellaneous"),_react2.default.createElement(_materialUi.Checkbox,{label:'Hide "Order Tickets" button',checked:this.state.values.hide_tickets_button||false,onCheck:this.onChange.bind(this,"hide_tickets_button")}),!this.state.values.hide_tickets_button?_react2.default.createElement("div",null,_react2.default.createElement(_materialUi.Checkbox,{label:'Custom label for "Order Tickets" button',checked:this.state.showTicketsButtonLabel,onCheck:this.onTicketsButtonLabelCheck}),this.state.showTicketsButtonLabel?_react2.default.createElement(_materialUi.TextField,{value:this.state.values.tickets_button_label||"",floatingLabelText:"\"Order Tickets\" button label",floatingLabelFixed:true,placeholder:"Order Tickets",style:{marginTop:"-0.75em",marginLeft:"2.5em"},onChange:function onChange(e){return _this10.onChangeValue("tickets_button_label",e.target.value);}}):null):null,_react2.default.createElement(_materialUi.Checkbox,{label:"Require customer mailing address",checked:(0,_get2.default)(this.state,"values.require_mailing_address",false),onCheck:function onCheck(e){return _this10.onChangeValue("require_mailing_address",!_this10.state.values.require_mailing_address);}}),_react2.default.createElement(_materialUi.Checkbox,{label:"Require customer phone number",checked:(0,_get2.default)(this.state,"values.require_phone_number",false),onCheck:function onCheck(e){return _this10.onChangeValue("require_phone_number",!_this10.state.values.require_phone_number);}}),_react2.default.createElement(_materialUi.Checkbox,{label:"Sales locked: Require customers to first enter a valid discount code in order to buy tickets",checked:(0,_get2.default)(this.state,"values.sales_disabled_unless_coupon",false),onCheck:function onCheck(e){return _this10.onChangeValue("sales_disabled_unless_coupon",!_this10.state.values.sales_disabled_unless_coupon);}}),(_EventBucketStore2.default.getEventBucketById(this.props.params.eventBucketId)||{}).credits_enabled?_react2.default.createElement(_materialUi.Checkbox,{label:"Don't allow credits to be used",checked:(0,_get2.default)(this.state,"values.credits_disabled",false),onCheck:function onCheck(e){return _this10.onChangeValue("credits_disabled",!_this10.state.values.credits_disabled);}}):null,this.renderExternalTicketsUrl(),_react2.default.createElement(_materialUi.Checkbox,{label:"Require agreement to a waiver/terms of use before placing order",checked:showTermsEditor,onCheck:function onCheck(e,checked){_this10.setState({showTermsEditor:checked},function(){if(!_this10.state.showTermsEditor){_this10.onChangeValue("terms_at_checkout","");}});}}),showTermsEditor?_react2.default.createElement(_basicHtmlField2.default,{label:"Waiver message to display",value:(0,_get2.default)(this.state,"values.terms_at_checkout",""),onChange:function onChange(v){return _this10.onChangeValue("terms_at_checkout",v);}}):null):null,this.state.showExternalTicketsUrl?_react2.default.createElement("div",{style:styles.editor},_react2.default.createElement("h2",{style:styles.editorHeader},"Ticket buckets"),_react2.default.createElement("p",null,"You cannot add ticket buckets when an external tickets url is set. To edit ticket buckets, disable \"Sell tickets on external site\" above.")):_react2.default.createElement("div",{style:styles.editor},_react2.default.createElement("h2",{style:styles.editorHeader},"Ticket buckets"),_react2.default.createElement(_ticketBucketsEditor2.default,{onShiftPosition:function onShiftPosition(index,direction){return _this10.onArrayItemShiftPosition("ticket_buckets",index,direction);},onAdd:function onAdd(e){return _this10.onArrayItemAdd("ticket_buckets",e);},onAddAndDelete:function onAddAndDelete(e){_this10.onArrayItemAddAndDelete("ticket_buckets",e.additions,e.delIndexes);},onEdit:function onEdit(index,value){return _this10.onArrayItemEdit("ticket_buckets",index,value);},onDelete:function onDelete(index){_this10.onArrayItemDelete("ticket_buckets",index);},event:this.props.params.eventId,eventDetails:event,ticketBuckets:this.state.values.ticket_buckets.map(function(b){return _extends({},b,{event_bucket:_this10.state.event.event_bucket});}),venueDetails:_VenueStore2.default.getVenueById(this.state.values.venue)})),this.state.showExternalTicketsUrl?_react2.default.createElement("div",{style:styles.editor},_react2.default.createElement("h2",{style:styles.editorHeader},"Pass rules override"),_react2.default.createElement("p",null,"You cannot add pass rule overides when an external tickets url is set. To edit pass rules, disable \"Sell tickets on external site\" above.")):_react2.default.createElement("div",{style:styles.editor},_react2.default.createElement("h2",{style:styles.editorHeader},"Pass rules override"),_react2.default.createElement(_passRulesEditorNonatomic2.default,{mode:"event",parentId:this.props.params.eventId,parent:this.state.event,eventBucketId:this.props.params.eventBucketId,eventBucket:this.state.event.event_bucket,onAdd:function onAdd(e){return _this10.onArrayItemAdd("rules",e);},onChange:function onChange(index,value){return _this10.onArrayItemEdit("rules",index,value);},onDelete:function onDelete(index){return _this10.onArrayItemDelete("rules",index);},getEventBucketById:_EventBucketStore2.default.getEventBucketById,passRules:this.state.values.rules})),_react2.default.createElement("div",{style:styles.editor},_react2.default.createElement("h2",{style:styles.editorHeader},"Revenue sharing"),_react2.default.createElement(_revenueSharingEditor2.default,{event:this.state.event,revenueShare:this.state.values.revenue_share,onChange:function onChange(revenueShare){_this10.onChangeValue("revenue_share",revenueShare);}}))):null);}}],[{key:"getStores",value:function getStores(){return[_EventStore2.default,_EventBucketStore2.default,_VirtualContentStore2.default];}},{key:"getPropsFromStores",value:function getPropsFromStores(){return{getEventById:_EventStore2.default.getEventById,uploadingImageField:_EventStore2.default.getState().uploadingImageField};}},{key:"contextTypes",get:function get(){return{router:_react2.default.PropTypes.object};}}]);return Event;}(_react2.default.Component);exports.default=(0,_connectToStores2.default)(Event);module.exports=exports["default"];

/***/ }),
/* 2709 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(2710);


/***/ }),
/* 2710 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	/* global window, document */
	
	'use strict';
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(956);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _subscribeUiEvent = __webpack_require__(2711);
	
	var _classnames = __webpack_require__(958);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _shallowequal = __webpack_require__(2723);
	
	var _shallowequal2 = _interopRequireDefault(_shallowequal);
	
	// constants
	var STATUS_ORIGINAL = 0; // The default status, locating at the original position.
	var STATUS_RELEASED = 1; // The released status, locating at somewhere on document but not default one.
	var STATUS_FIXED = 2; // The sticky status, locating fixed to the top or the bottom of screen.
	
	var TRANSFORM_PROP = 'transform';
	
	// global variable for all instances
	var doc;
	var docBody;
	var docEl;
	var canEnableTransforms = true; // Use transform by default, so no Sticky on lower-end browser when no Modernizr
	var M;
	var scrollDelta = 0;
	var win;
	var winHeight = -1;
	
	var Sticky = (function (_Component) {
	    _inherits(Sticky, _Component);
	
	    function Sticky(props, context) {
	        _classCallCheck(this, Sticky);
	
	        _get(Object.getPrototypeOf(Sticky.prototype), 'constructor', this).call(this, props, context);
	        this.handleResize = this.handleResize.bind(this);
	        this.handleScroll = this.handleScroll.bind(this);
	        this.handleScrollStart = this.handleScrollStart.bind(this);
	        this.delta = 0;
	        this.stickyTop = 0;
	        this.stickyBottom = 0;
	        this.frozen = false;
	        this.skipNextScrollEvent = false;
	        this.scrollTop = -1;
	
	        this.bottomBoundaryTarget;
	        this.topTarget;
	        this.subscribers;
	
	        this.state = {
	            top: 0, // A top offset from viewport top where Sticky sticks to when scrolling up
	            bottom: 0, // A bottom offset from viewport top where Sticky sticks to when scrolling down
	            width: 0, // Sticky width
	            height: 0, // Sticky height
	            x: 0, // The original x of Sticky
	            y: 0, // The original y of Sticky
	            topBoundary: 0, // The top boundary on document
	            bottomBoundary: Infinity, // The bottom boundary on document
	            status: STATUS_ORIGINAL, // The Sticky status
	            pos: 0, // Real y-axis offset for rendering position-fixed and position-relative
	            activated: false // once browser info is available after mounted, it becomes true to avoid checksum error
	        };
	    }
	
	    _createClass(Sticky, [{
	        key: 'getTargetHeight',
	        value: function getTargetHeight(target) {
	            return target && target.offsetHeight || 0;
	        }
	    }, {
	        key: 'getTopPosition',
	        value: function getTopPosition(top) {
	            // TODO, topTarget is for current layout, may remove
	            // a top argument can be provided to override reading from the props
	            top = top || this.props.top || this.props.topTarget || 0;
	            if (typeof top === 'string') {
	                if (!this.topTarget) {
	                    this.topTarget = doc.querySelector(top);
	                }
	                top = this.getTargetHeight(this.topTarget);
	            }
	            return top;
	        }
	    }, {
	        key: 'getTargetBottom',
	        value: function getTargetBottom(target) {
	            if (!target) {
	                return -1;
	            }
	            var rect = target.getBoundingClientRect();
	            return this.scrollTop + rect.bottom;
	        }
	    }, {
	        key: 'getBottomBoundary',
	        value: function getBottomBoundary(bottomBoundary) {
	            // a bottomBoundary can be provided to avoid reading from the props
	            var boundary = bottomBoundary || this.props.bottomBoundary;
	
	            // TODO, bottomBoundary was an object, depricate it later.
	            if (typeof boundary === 'object') {
	                boundary = boundary.value || boundary.target || 0;
	            }
	
	            if (typeof boundary === 'string') {
	                if (!this.bottomBoundaryTarget) {
	                    this.bottomBoundaryTarget = doc.querySelector(boundary);
	                }
	                boundary = this.getTargetBottom(this.bottomBoundaryTarget);
	            }
	            return boundary && boundary > 0 ? boundary : Infinity;
	        }
	    }, {
	        key: 'reset',
	        value: function reset() {
	            this.setState({
	                status: STATUS_ORIGINAL,
	                pos: 0
	            });
	        }
	    }, {
	        key: 'release',
	        value: function release(pos) {
	            this.setState({
	                status: STATUS_RELEASED,
	                pos: pos - this.state.y
	            });
	        }
	    }, {
	        key: 'fix',
	        value: function fix(pos) {
	            this.setState({
	                status: STATUS_FIXED,
	                pos: pos
	            });
	        }
	
	        /**
	         * Update the initial position, width, and height. It should update whenever children change.
	         * @param {Object} options optional top and bottomBoundary new values
	         */
	    }, {
	        key: 'updateInitialDimension',
	        value: function updateInitialDimension(options) {
	            options = options || {};
	
	            var outerRect = this.outerElement.getBoundingClientRect();
	            var innerRect = this.innerElement.getBoundingClientRect();
	
	            var width = outerRect.width || outerRect.right - outerRect.left;
	            var height = innerRect.height || innerRect.bottom - innerRect.top;;
	            var outerY = outerRect.top + this.scrollTop;
	
	            this.setState({
	                top: this.getTopPosition(options.top),
	                bottom: Math.min(this.state.top + height, winHeight),
	                width: width,
	                height: height,
	                x: outerRect.left,
	                y: outerY,
	                bottomBoundary: this.getBottomBoundary(options.bottomBoundary),
	                topBoundary: outerY
	            });
	        }
	    }, {
	        key: 'handleResize',
	        value: function handleResize(e, ae) {
	            if (this.props.shouldFreeze()) {
	                return;
	            }
	
	            winHeight = ae.resize.height;
	            this.updateInitialDimension();
	            this.update();
	        }
	    }, {
	        key: 'handleScrollStart',
	        value: function handleScrollStart(e, ae) {
	            this.frozen = this.props.shouldFreeze();
	
	            if (this.frozen) {
	                return;
	            }
	
	            if (this.scrollTop === ae.scroll.top) {
	                // Scroll position hasn't changed,
	                // do nothing
	                this.skipNextScrollEvent = true;
	            } else {
	                this.scrollTop = ae.scroll.top;
	                this.updateInitialDimension();
	            }
	        }
	    }, {
	        key: 'handleScroll',
	        value: function handleScroll(e, ae) {
	            // Scroll doesn't need to be handled
	            if (this.skipNextScrollEvent) {
	                this.skipNextScrollEvent = false;
	                return;
	            }
	
	            scrollDelta = ae.scroll.delta;
	            this.scrollTop = ae.scroll.top;
	            this.update();
	        }
	
	        /**
	         * Update Sticky position.
	         */
	    }, {
	        key: 'update',
	        value: function update() {
	            var disabled = !this.props.enabled || this.state.bottomBoundary - this.state.topBoundary <= this.state.height || this.state.width === 0 && this.state.height === 0;
	
	            if (disabled) {
	                if (this.state.status !== STATUS_ORIGINAL) {
	                    this.reset();
	                }
	                return;
	            }
	
	            var delta = scrollDelta;
	            // "top" and "bottom" are the positions that this.state.top and this.state.bottom project
	            // on document from viewport.
	            var top = this.scrollTop + this.state.top;
	            var bottom = this.scrollTop + this.state.bottom;
	
	            // There are 2 principles to make sure Sticky won't get wrong so much:
	            // 1. Reset Sticky to the original postion when "top" <= topBoundary
	            // 2. Release Sticky to the bottom boundary when "bottom" >= bottomBoundary
	            if (top <= this.state.topBoundary) {
	                // #1
	                this.reset();
	            } else if (bottom >= this.state.bottomBoundary) {
	                // #2
	                this.stickyBottom = this.state.bottomBoundary;
	                this.stickyTop = this.stickyBottom - this.state.height;
	                this.release(this.stickyTop);
	            } else {
	                if (this.state.height > winHeight - this.state.top) {
	                    // In this case, Sticky is higher then viewport minus top offset
	                    switch (this.state.status) {
	                        case STATUS_ORIGINAL:
	                            this.release(this.state.y);
	                            this.stickyTop = this.state.y;
	                            this.stickyBottom = this.stickyTop + this.state.height;
	                        // Commentting out "break" is on purpose, because there is a chance to transit to FIXED
	                        // from ORIGINAL when calling window.scrollTo().
	                        // break;
	                        case STATUS_RELEASED:
	                            // If "top" and "bottom" are inbetween stickyTop and stickyBottom, then Sticky is in
	                            // RELEASE status. Otherwise, it changes to FIXED status, and its bottom sticks to
	                            // viewport bottom when scrolling down, or its top sticks to viewport top when scrolling up.
	                            this.stickyBottom = this.stickyTop + this.state.height;
	                            if (delta > 0 && bottom > this.stickyBottom) {
	                                this.fix(this.state.bottom - this.state.height);
	                            } else if (delta < 0 && top < this.stickyTop) {
	                                this.fix(this.state.top);
	                            }
	                            break;
	                        case STATUS_FIXED:
	                            var toRelease = true;
	                            var pos = this.state.pos;
	                            var height = this.state.height;
	                            // In regular cases, when Sticky is in FIXED status,
	                            // 1. it's top will stick to the screen top,
	                            // 2. it's bottom will stick to the screen bottom,
	                            // 3. if not the cases above, then it's height gets changed
	                            if (delta > 0 && pos === this.state.top) {
	                                // case 1, and scrolling down
	                                this.stickyTop = top - delta;
	                                this.stickyBottom = this.stickyTop + height;
	                            } else if (delta < 0 && pos === this.state.bottom - height) {
	                                // case 2, and scrolling up
	                                this.stickyBottom = bottom - delta;
	                                this.stickyTop = this.stickyBottom - height;
	                            } else if (pos !== this.state.bottom - height && pos !== this.state.top) {
	                                // case 3
	                                // This case only happens when Sticky's bottom sticks to the screen bottom and
	                                // its height gets changed. Sticky should be in RELEASE status and update its
	                                // sticky bottom by calculating how much height it changed.
	                                var deltaHeight = pos + height - this.state.bottom;
	                                this.stickyBottom = bottom - delta + deltaHeight;
	                                this.stickyTop = this.stickyBottom - height;
	                            } else {
	                                toRelease = false;
	                            }
	
	                            if (toRelease) {
	                                this.release(this.stickyTop);
	                            }
	                            break;
	                    }
	                } else {
	                    // In this case, Sticky is shorter then viewport minus top offset
	                    // and will always fix to the top offset of viewport
	                    this.fix(this.state.top);
	                }
	            }
	            this.delta = delta;
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            this.updateInitialDimension(nextProps);
	            this.update();
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate(prevProps, prevState) {
	            var _this = this;
	
	            if (prevState.status !== this.state.status && this.props.onStateChange) {
	                this.props.onStateChange({ status: this.state.status });
	            }
	            // if the props for enabling are toggled, then trigger the update or reset depending on the current props
	            if (prevProps.enabled !== this.props.enabled) {
	                if (this.props.enabled) {
	                    this.setState({ activated: true }, function () {
	                        _this.updateInitialDimension();
	                        _this.update();
	                    });
	                } else {
	                    this.setState({ activated: false }, function () {
	                        _this.reset();
	                    });
	                }
	            }
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            var subscribers = this.subscribers || [];
	            for (var i = subscribers.length - 1; i >= 0; i--) {
	                this.subscribers[i].unsubscribe();
	            }
	        }
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            // Only initialize the globals if this is the first
	            // time this component type has been mounted
	            if (!win) {
	                win = window;
	                doc = document;
	                docEl = doc.documentElement;
	                docBody = doc.body;
	                winHeight = win.innerHeight || docEl.clientHeight;
	                M = window.Modernizr;
	                // No Sticky on lower-end browser when no Modernizr
	                if (M && M.prefixed) {
	                    canEnableTransforms = M.csstransforms3d;
	                    TRANSFORM_PROP = M.prefixed('transform');
	                }
	            }
	
	            // when mount, the scrollTop is not necessary on the top
	            this.scrollTop = docBody.scrollTop + docEl.scrollTop;
	
	            if (this.props.enabled) {
	                this.setState({ activated: true });
	                this.updateInitialDimension();
	                this.update();
	            }
	            // bind the listeners regardless if initially enabled - allows the component to toggle sticky functionality
	            this.subscribers = [(0, _subscribeUiEvent.subscribe)('scrollStart', this.handleScrollStart.bind(this), { useRAF: true }), (0, _subscribeUiEvent.subscribe)('scroll', this.handleScroll.bind(this), { useRAF: true, enableScrollInfo: true }), (0, _subscribeUiEvent.subscribe)('resize', this.handleResize.bind(this), { enableResizeInfo: true })];
	        }
	    }, {
	        key: 'translate',
	        value: function translate(style, pos) {
	            var enableTransforms = canEnableTransforms && this.props.enableTransforms;
	            if (enableTransforms && this.state.activated) {
	                style[TRANSFORM_PROP] = 'translate3d(0,' + Math.round(pos) + 'px,0)';
	            } else {
	                style.top = pos + 'px';
	            }
	        }
	    }, {
	        key: 'shouldComponentUpdate',
	        value: function shouldComponentUpdate(nextProps, nextState) {
	            return !this.props.shouldFreeze() && !((0, _shallowequal2['default'])(this.props, nextProps) && (0, _shallowequal2['default'])(this.state, nextState));
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _classNames,
	                _this2 = this;
	
	            // TODO, "overflow: auto" prevents collapse, need a good way to get children height
	            var innerStyle = {
	                position: this.state.status === STATUS_FIXED ? 'fixed' : 'relative',
	                top: this.state.status === STATUS_FIXED ? '0px' : '',
	                zIndex: this.props.innerZ
	            };
	            var outerStyle = {};
	
	            // always use translate3d to enhance the performance
	            this.translate(innerStyle, this.state.pos);
	            if (this.state.status !== STATUS_ORIGINAL) {
	                innerStyle.width = this.state.width + 'px';
	                outerStyle.height = this.state.height + 'px';
	            }
	
	            var outerClasses = (0, _classnames2['default'])('sticky-outer-wrapper', this.props.className, (_classNames = {}, _defineProperty(_classNames, this.props.activeClass, this.state.status === STATUS_FIXED), _defineProperty(_classNames, this.props.releasedClass, this.state.status === STATUS_RELEASED), _classNames));
	
	            var children = this.props.children;
	
	            return _react2['default'].createElement(
	                'div',
	                { ref: function (outer) {
	                        _this2.outerElement = outer;
	                    }, className: outerClasses, style: outerStyle },
	                _react2['default'].createElement(
	                    'div',
	                    { ref: function (inner) {
	                            _this2.innerElement = inner;
	                        }, className: 'sticky-inner-wrapper', style: innerStyle },
	                    typeof children === 'function' ? children({ status: this.state.status }) : children
	                )
	            );
	        }
	    }]);
	
	    return Sticky;
	})(_react.Component);
	
	Sticky.displayName = 'Sticky';
	
	Sticky.defaultProps = {
	    shouldFreeze: function shouldFreeze() {
	        return false;
	    },
	    enabled: true,
	    top: 0,
	    bottomBoundary: 0,
	    enableTransforms: true,
	    activeClass: 'active',
	    releasedClass: 'released',
	    onStateChange: null
	};
	
	/**
	 * @param {Bool} enabled A switch to enable or disable Sticky.
	 * @param {String/Number} top A top offset px for Sticky. Could be a selector representing a node
	 *        whose height should serve as the top offset.
	 * @param {String/Number} bottomBoundary A bottom boundary px on document where Sticky will stop.
	 *        Could be a selector representing a node whose bottom should serve as the bottom boudary.
	 */
	Sticky.propTypes = {
	    enabled: _propTypes2['default'].bool,
	    top: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].number]),
	    bottomBoundary: _propTypes2['default'].oneOfType([_propTypes2['default'].object, // TODO, may remove
	    _propTypes2['default'].string, _propTypes2['default'].number]),
	    enableTransforms: _propTypes2['default'].bool,
	    activeClass: _propTypes2['default'].string,
	    releasedClass: _propTypes2['default'].string,
	    onStateChange: _propTypes2['default'].func,
	    shouldFreeze: _propTypes2['default'].func,
	    innerZ: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].number])
	};
	
	Sticky.STATUS_ORIGINAL = STATUS_ORIGINAL;
	Sticky.STATUS_RELEASED = STATUS_RELEASED;
	Sticky.STATUS_FIXED = STATUS_FIXED;
	
	module.exports = Sticky;


/***/ }),
/* 2711 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	
	var listenLib = __webpack_require__(2712);
	var subscribeLib = __webpack_require__(2716);
	var unsubscribeLib = __webpack_require__(2722);
	
	var IS_CLIENT = typeof window !== 'undefined';
	
	function warn() {
	  if (false) {
	    console.warn('Warning: the function is client-side only, does not work on server side'); // eslint-disable-line
	  }
	}
	
	module.exports = {
	  listen: IS_CLIENT ? listenLib : warn,
	  subscribe: IS_CLIENT ? subscribeLib : warn,
	  unsubscribe: IS_CLIENT ? unsubscribeLib : warn
	};


/***/ }),
/* 2712 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(920);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _globalVars = __webpack_require__(2713);
	
	var _globalVars2 = _interopRequireDefault(_globalVars);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	
	var supportPassiveEvent = _globalVars2.default.supportPassiveEvent;
	
	
	var defaultEventOption = {
	  capture: false,
	  passive: false
	};
	
	/**
	 * Cross-browser addEventListener.
	 * @method listen
	 * @param {Object} target - The target to add event listener.
	 * @param {String} eventType - The event type.
	 * @param {Function} handler - The event handler.
	 * @param {Object} handler - The options object that specifies
	 * characteristics about the event listener.
	 * @return {Object} The object to be able to remove the handler.
	 */
	function listen(target, eventType, handler, options) {
	  var add = 'addEventListener';
	  var _remove = 'removeEventListener';
	  var type = eventType;
	
	  var eventOptions = supportPassiveEvent ? (0, _assign2.default)({}, defaultEventOption, options) : false;
	
	  if (!target.addEventListener && target.attachEvent) {
	    add = 'attachEvent';
	    _remove = 'detachEvent';
	    type = 'on' + eventType;
	  }
	  target[add](type, handler, eventOptions);
	
	  return {
	    remove: function remove() {
	      target[_remove](eventType, handler);
	    }
	  };
	}
	
	exports.default = listen;
	module.exports = exports['default'];


/***/ }),
/* 2713 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _eventemitter = __webpack_require__(2714);
	
	var _eventemitter2 = _interopRequireDefault(_eventemitter);
	
	var _supportPassiveEvent = __webpack_require__(2715);
	
	var _supportPassiveEvent2 = _interopRequireDefault(_supportPassiveEvent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	
	exports.default = {
	  connections: {},
	  EE: new _eventemitter2.default(),
	  enableResizeInfo: false,
	  enableScrollInfo: false,
	  listeners: {},
	  removers: [],
	  supportPassiveEvent: _supportPassiveEvent2.default
	};
	module.exports = exports['default'];


/***/ }),
/* 2714 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var has = Object.prototype.hasOwnProperty
	  , prefix = '~';
	
	/**
	 * Constructor to create a storage for our `EE` objects.
	 * An `Events` instance is a plain object whose properties are event names.
	 *
	 * @constructor
	 * @private
	 */
	function Events() {}
	
	//
	// We try to not inherit from `Object.prototype`. In some engines creating an
	// instance in this way is faster than calling `Object.create(null)` directly.
	// If `Object.create(null)` is not supported we prefix the event names with a
	// character to make sure that the built-in object properties are not
	// overridden or used as an attack vector.
	//
	if (Object.create) {
	  Events.prototype = Object.create(null);
	
	  //
	  // This hack is needed because the `__proto__` property is still inherited in
	  // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
	  //
	  if (!new Events().__proto__) prefix = false;
	}
	
	/**
	 * Representation of a single event listener.
	 *
	 * @param {Function} fn The listener function.
	 * @param {*} context The context to invoke the listener with.
	 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
	 * @constructor
	 * @private
	 */
	function EE(fn, context, once) {
	  this.fn = fn;
	  this.context = context;
	  this.once = once || false;
	}
	
	/**
	 * Add a listener for a given event.
	 *
	 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
	 * @param {(String|Symbol)} event The event name.
	 * @param {Function} fn The listener function.
	 * @param {*} context The context to invoke the listener with.
	 * @param {Boolean} once Specify if the listener is a one-time listener.
	 * @returns {EventEmitter}
	 * @private
	 */
	function addListener(emitter, event, fn, context, once) {
	  if (typeof fn !== 'function') {
	    throw new TypeError('The listener must be a function');
	  }
	
	  var listener = new EE(fn, context || emitter, once)
	    , evt = prefix ? prefix + event : event;
	
	  if (!emitter._events[evt]) emitter._events[evt] = listener, emitter._eventsCount++;
	  else if (!emitter._events[evt].fn) emitter._events[evt].push(listener);
	  else emitter._events[evt] = [emitter._events[evt], listener];
	
	  return emitter;
	}
	
	/**
	 * Clear event by name.
	 *
	 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
	 * @param {(String|Symbol)} evt The Event name.
	 * @private
	 */
	function clearEvent(emitter, evt) {
	  if (--emitter._eventsCount === 0) emitter._events = new Events();
	  else delete emitter._events[evt];
	}
	
	/**
	 * Minimal `EventEmitter` interface that is molded against the Node.js
	 * `EventEmitter` interface.
	 *
	 * @constructor
	 * @public
	 */
	function EventEmitter() {
	  this._events = new Events();
	  this._eventsCount = 0;
	}
	
	/**
	 * Return an array listing the events for which the emitter has registered
	 * listeners.
	 *
	 * @returns {Array}
	 * @public
	 */
	EventEmitter.prototype.eventNames = function eventNames() {
	  var names = []
	    , events
	    , name;
	
	  if (this._eventsCount === 0) return names;
	
	  for (name in (events = this._events)) {
	    if (has.call(events, name)) names.push(prefix ? name.slice(1) : name);
	  }
	
	  if (Object.getOwnPropertySymbols) {
	    return names.concat(Object.getOwnPropertySymbols(events));
	  }
	
	  return names;
	};
	
	/**
	 * Return the listeners registered for a given event.
	 *
	 * @param {(String|Symbol)} event The event name.
	 * @returns {Array} The registered listeners.
	 * @public
	 */
	EventEmitter.prototype.listeners = function listeners(event) {
	  var evt = prefix ? prefix + event : event
	    , handlers = this._events[evt];
	
	  if (!handlers) return [];
	  if (handlers.fn) return [handlers.fn];
	
	  for (var i = 0, l = handlers.length, ee = new Array(l); i < l; i++) {
	    ee[i] = handlers[i].fn;
	  }
	
	  return ee;
	};
	
	/**
	 * Return the number of listeners listening to a given event.
	 *
	 * @param {(String|Symbol)} event The event name.
	 * @returns {Number} The number of listeners.
	 * @public
	 */
	EventEmitter.prototype.listenerCount = function listenerCount(event) {
	  var evt = prefix ? prefix + event : event
	    , listeners = this._events[evt];
	
	  if (!listeners) return 0;
	  if (listeners.fn) return 1;
	  return listeners.length;
	};
	
	/**
	 * Calls each of the listeners registered for a given event.
	 *
	 * @param {(String|Symbol)} event The event name.
	 * @returns {Boolean} `true` if the event had listeners, else `false`.
	 * @public
	 */
	EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
	  var evt = prefix ? prefix + event : event;
	
	  if (!this._events[evt]) return false;
	
	  var listeners = this._events[evt]
	    , len = arguments.length
	    , args
	    , i;
	
	  if (listeners.fn) {
	    if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);
	
	    switch (len) {
	      case 1: return listeners.fn.call(listeners.context), true;
	      case 2: return listeners.fn.call(listeners.context, a1), true;
	      case 3: return listeners.fn.call(listeners.context, a1, a2), true;
	      case 4: return listeners.fn.call(listeners.context, a1, a2, a3), true;
	      case 5: return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
	      case 6: return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
	    }
	
	    for (i = 1, args = new Array(len -1); i < len; i++) {
	      args[i - 1] = arguments[i];
	    }
	
	    listeners.fn.apply(listeners.context, args);
	  } else {
	    var length = listeners.length
	      , j;
	
	    for (i = 0; i < length; i++) {
	      if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);
	
	      switch (len) {
	        case 1: listeners[i].fn.call(listeners[i].context); break;
	        case 2: listeners[i].fn.call(listeners[i].context, a1); break;
	        case 3: listeners[i].fn.call(listeners[i].context, a1, a2); break;
	        case 4: listeners[i].fn.call(listeners[i].context, a1, a2, a3); break;
	        default:
	          if (!args) for (j = 1, args = new Array(len -1); j < len; j++) {
	            args[j - 1] = arguments[j];
	          }
	
	          listeners[i].fn.apply(listeners[i].context, args);
	      }
	    }
	  }
	
	  return true;
	};
	
	/**
	 * Add a listener for a given event.
	 *
	 * @param {(String|Symbol)} event The event name.
	 * @param {Function} fn The listener function.
	 * @param {*} [context=this] The context to invoke the listener with.
	 * @returns {EventEmitter} `this`.
	 * @public
	 */
	EventEmitter.prototype.on = function on(event, fn, context) {
	  return addListener(this, event, fn, context, false);
	};
	
	/**
	 * Add a one-time listener for a given event.
	 *
	 * @param {(String|Symbol)} event The event name.
	 * @param {Function} fn The listener function.
	 * @param {*} [context=this] The context to invoke the listener with.
	 * @returns {EventEmitter} `this`.
	 * @public
	 */
	EventEmitter.prototype.once = function once(event, fn, context) {
	  return addListener(this, event, fn, context, true);
	};
	
	/**
	 * Remove the listeners of a given event.
	 *
	 * @param {(String|Symbol)} event The event name.
	 * @param {Function} fn Only remove the listeners that match this function.
	 * @param {*} context Only remove the listeners that have this context.
	 * @param {Boolean} once Only remove one-time listeners.
	 * @returns {EventEmitter} `this`.
	 * @public
	 */
	EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
	  var evt = prefix ? prefix + event : event;
	
	  if (!this._events[evt]) return this;
	  if (!fn) {
	    clearEvent(this, evt);
	    return this;
	  }
	
	  var listeners = this._events[evt];
	
	  if (listeners.fn) {
	    if (
	      listeners.fn === fn &&
	      (!once || listeners.once) &&
	      (!context || listeners.context === context)
	    ) {
	      clearEvent(this, evt);
	    }
	  } else {
	    for (var i = 0, events = [], length = listeners.length; i < length; i++) {
	      if (
	        listeners[i].fn !== fn ||
	        (once && !listeners[i].once) ||
	        (context && listeners[i].context !== context)
	      ) {
	        events.push(listeners[i]);
	      }
	    }
	
	    //
	    // Reset the array, or remove it completely if we have no more listeners.
	    //
	    if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
	    else clearEvent(this, evt);
	  }
	
	  return this;
	};
	
	/**
	 * Remove all listeners, or those of the specified event.
	 *
	 * @param {(String|Symbol)} [event] The event name.
	 * @returns {EventEmitter} `this`.
	 * @public
	 */
	EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
	  var evt;
	
	  if (event) {
	    evt = prefix ? prefix + event : event;
	    if (this._events[evt]) clearEvent(this, evt);
	  } else {
	    this._events = new Events();
	    this._eventsCount = 0;
	  }
	
	  return this;
	};
	
	//
	// Alias methods names because people roll like that.
	//
	EventEmitter.prototype.off = EventEmitter.prototype.removeListener;
	EventEmitter.prototype.addListener = EventEmitter.prototype.on;
	
	//
	// Expose the prefix.
	//
	EventEmitter.prefixed = prefix;
	
	//
	// Allow `EventEmitter` to be imported as module namespace.
	//
	EventEmitter.EventEmitter = EventEmitter;
	
	//
	// Expose the module.
	//
	if (true) {
	  module.exports = EventEmitter;
	}


/***/ }),
/* 2715 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/* global window */
	
	var passiveSupported = false; // eslint-disable-line import/no-mutable-exports
	
	if (typeof window !== 'undefined') {
	  try {
	    var options = Object.defineProperty({}, 'passive', {
	      get: function get() {
	        passiveSupported = true;
	      }
	    });
	
	    window.addEventListener('test', null, options);
	  } catch (err) {} // eslint-disable-line no-empty
	}
	
	exports.default = passiveSupported;
	module.exports = exports['default'];


/***/ }),
/* 2716 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _globalVars = __webpack_require__(2713);
	
	var _globalVars2 = _interopRequireDefault(_globalVars);
	
	var _leIE = __webpack_require__(2717);
	
	var _leIE2 = _interopRequireDefault(_leIE);
	
	var _mainEventConnectors = __webpack_require__(2718);
	
	var _mainEventConnectors2 = _interopRequireDefault(_mainEventConnectors);
	
	var _constants = __webpack_require__(2721);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Subscribe to UI events.
	 * @method subscribe
	 * @param {String} type - The type of event.
	 * @param {Function} cb - The callback function.
	 * @param {Object} options.context - The caller.
	 * @param {Number} options.throttleRate - The amount of time for throttling.
	 * @param {Boolean} options.useRAF - Use rAF for throttling if true.
	 * @param {Object} options.eventOptions - Option to pass to event listener
	 * @return {Object} The object with unsubscribe function.
	 */
	// less then or equal to IE8
	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	
	function subscribe(type, cb) {
	  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	  var useRAF = options.useRAF || false;
	  var throttleRate = parseInt(options.throttleRate, 10);
	  var eventOptions = options.eventOptions;
	
	  if (isNaN(throttleRate)) {
	    throttleRate = _constants.DEFAULT_THROTTLE_RATE;
	  }
	
	  if (useRAF) {
	    throttleRate = 'raf';
	  }
	
	  // turn off throttle if the browser is IE8 or less, because window.event will be reset
	  // when using any delayed function, i.g., setTimeout, or rAF.
	  if (_leIE2.default) {
	    throttleRate = 0;
	  }
	
	  // once those variables enabled, then never disabled.
	  _globalVars2.default.enableScrollInfo = _globalVars2.default.enableScrollInfo || options.enableScrollInfo || false;
	  _globalVars2.default.enableResizeInfo = _globalVars2.default.enableResizeInfo || options.enableResizeInfo || false;
	  _globalVars2.default.enableTouchInfo = _globalVars2.default.enableTouchInfo || options.enableTouchInfo || false;
	
	  return _mainEventConnectors2.default[type](throttleRate, cb, options, eventOptions);
	}
	
	// constants
	exports.default = subscribe;
	module.exports = exports['default'];


/***/ }),
/* 2717 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	/* global navigator, parseFloat */
	
	// less then or equal to IE8
	var leIE8 = false; // eslint-disable-line import/no-mutable-exports
	
	if (typeof navigator !== 'undefined') {
	  var matches = navigator.userAgent.match(/MSIE (\d+\.\d+)/);
	  if (matches) {
	    leIE8 = parseFloat(matches[1], 10) < 9;
	  }
	}
	
	exports.default = leIE8;
	module.exports = exports['default'];


/***/ }),
/* 2718 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _clone = __webpack_require__(2108);
	
	var _clone2 = _interopRequireDefault(_clone);
	
	var _throttle = __webpack_require__(641);
	
	var _throttle2 = _interopRequireDefault(_throttle);
	
	var _noop = __webpack_require__(1441);
	
	var _noop2 = _interopRequireDefault(_noop);
	
	var _AugmentedEvent = __webpack_require__(2719);
	
	var _AugmentedEvent2 = _interopRequireDefault(_AugmentedEvent);
	
	var _globalVars = __webpack_require__(2713);
	
	var _globalVars2 = _interopRequireDefault(_globalVars);
	
	var _leIE = __webpack_require__(2717);
	
	var _leIE2 = _interopRequireDefault(_leIE);
	
	var _listen = __webpack_require__(2712);
	
	var _listen2 = _interopRequireDefault(_listen);
	
	var _rAFThrottle = __webpack_require__(2720);
	
	var _rAFThrottle2 = _interopRequireDefault(_rAFThrottle);
	
	var _constants = __webpack_require__(2721);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var connections = _globalVars2.default.connections,
	    EE = _globalVars2.default.EE,
	    listeners = _globalVars2.default.listeners,
	    removers = _globalVars2.default.removers;
	
	// global variables
	
	
	// constants
	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	/* global window, document, setTimeout */
	
	var doc = void 0;
	var win = void 0;
	var body = void 0;
	var hashId = 0;
	
	if (typeof window !== 'undefined') {
	  win = window;
	  doc = win.document || document;
	  body = doc.body;
	}
	
	function getHash(domNode) {
	  return domNode.id || 'target-id-' + hashId++; // eslint-disable-line
	}
	
	/**
	 * Connect a throttled event to a throttled main event, and return an event remover.
	 * The number of connections to a throttled main event will be kept. If all throttled events
	 * are removed, then remove throttled main event.
	 * @method connectThrottle
	 * @param {String} throttledEvent - A throttled event
	 * @param {Function} cb - Callback function
	 * @param {Object} ctx - The "this"
	 * @param {String} throttledMainEvent - A throttled main event
	 * @return {Object} An event remover
	 */
	function connectThrottle(throttledEvent, cb, ctx, throttledMainEvent) {
	  EE.on(throttledEvent, cb || _noop2.default, ctx);
	  throttledMainEvent = throttledMainEvent || throttledEvent;
	  connections[throttledMainEvent] = (connections[throttledMainEvent] || 0) + 1;
	  return {
	    _type: throttledEvent,
	    _cb: cb,
	    _ctx: ctx,
	    unsubscribe: function unsubscribe() {
	      if (!this._type) {
	        return;
	      }
	
	      EE.removeListener(throttledEvent, cb, ctx);
	      connections[throttledMainEvent]--;
	      if (connections[throttledMainEvent] === 0) {
	        listeners[throttledMainEvent].remove();
	        listeners[throttledMainEvent] = undefined;
	      }
	
	      this._type = undefined;
	      this._cb = undefined;
	      this._ctx = undefined;
	
	      // remove the remover from removers array
	      for (var i = removers.length - 1; i >= 0; i--) {
	        var remover = removers[i];
	        if (remover === this) {
	          removers.splice(i, 1);
	          break;
	        }
	      }
	    }
	  };
	}
	
	/**
	 * Connect to event, event start and event end.
	 * @method connectContinuousEvent
	 * @param {Object} target - The target of a main event, window or document.
	 * @param {String} mainEvent - A browser event, like scroll or resize.
	 * @param {String} event - A subscribe event.
	 * @param {Object} eventOptions - An options pass to event listener
	 */
	function connectContinuousEvent(target, mainEvent, event) {
	  return function throttleEvent(throttleRate, cb, options, eventOptions) {
	    var context = options.context;
	    var domTarget = options.target;
	    var domId = domTarget && getHash(domTarget);
	    var targetPart = domId ? ':' + domId : '';
	
	    var throttledStartEvent = mainEvent + 'Start:' + throttleRate + targetPart;
	    var throttledEndEvent = mainEvent + 'End:' + throttleRate + targetPart;
	    var throttledMainEvent = mainEvent + ':' + throttleRate + targetPart;
	    var throttledEvent = event + ':' + throttleRate + targetPart;
	
	    var remover = connectThrottle(throttledEvent, cb, context, throttledMainEvent);
	    removers.push(remover);
	
	    if (listeners[throttledMainEvent]) {
	      return remover;
	    }
	
	    var ae = {
	      start: new _AugmentedEvent2.default({ mainType: mainEvent, subType: 'start' }), // start
	      main: new _AugmentedEvent2.default({ mainType: mainEvent }), // main
	      end: new _AugmentedEvent2.default({ mainType: mainEvent, subType: 'end' })
	    };
	
	    // No throttle for throttleRate = 0
	    // end
	    if (throttleRate === 'raf') {
	      throttleRate = 16; // Set as a number for setTimeout later.
	      handler = (0, _rAFThrottle2.default)(handler);
	    } else if (throttleRate > 0) {
	      handler = (0, _throttle2.default)(handler, throttleRate);
	    }
	
	    var timer = void 0;
	    function endCallback(e) {
	      ae.end.update(e);
	      EE.emit(throttledEndEvent, e, ae.end);
	      timer = null;
	    }
	    function handler(e) {
	      if (!timer) {
	        ae.start.update(e);
	        EE.emit(throttledStartEvent, e, ae.start);
	      }
	      clearTimeout(timer);
	
	      ae.main.update(e);
	      EE.emit(throttledMainEvent, e, ae.main);
	      if (!_leIE2.default) {
	        timer = setTimeout(endCallback.bind(null, e), throttleRate + _constants.EVENT_END_DELAY);
	      } else {
	        // For browser less then and equal to IE8, event object need to be cloned for setTimeout.
	        timer = setTimeout(function () {
	          endCallback((0, _clone2.default)(e));
	        }, throttleRate + _constants.EVENT_END_DELAY);
	      }
	    }
	
	    listeners[throttledMainEvent] = (0, _listen2.default)(domTarget || target, mainEvent, handler, eventOptions);
	    return remover;
	  };
	}
	
	function connectDiscreteEvent(target, event) {
	  return function throttleEvent(throttleRate, cb, options, eventOptions) {
	    var context = options.context;
	    var domTarget = options.target;
	    var domId = domTarget && getHash(domTarget);
	
	    // no throttling for discrete event
	    var throttledEvent = event + ':0' + (domId ? ':' + domId : '');
	
	    var remover = connectThrottle(throttledEvent, cb, context);
	    removers.push(remover);
	
	    if (listeners[throttledEvent]) {
	      return remover;
	    }
	
	    var ae = new _AugmentedEvent2.default({ mainType: event });
	
	    function handler(e) {
	      ae.update(e);
	      EE.emit(throttledEvent, e, ae);
	    }
	
	    listeners[throttledEvent] = (0, _listen2.default)(domTarget || target, event, handler, eventOptions);
	    return remover;
	  };
	}
	
	exports.default = {
	  scrollStart: connectContinuousEvent(win, 'scroll', 'scrollStart'),
	  scrollEnd: connectContinuousEvent(win, 'scroll', 'scrollEnd'),
	  scroll: connectContinuousEvent(win, 'scroll', 'scroll'),
	  resizeStart: connectContinuousEvent(win, 'resize', 'resizeStart'),
	  resizeEnd: connectContinuousEvent(win, 'resize', 'resizeEnd'),
	  resize: connectContinuousEvent(win, 'resize', 'resize'),
	  visibilitychange: connectDiscreteEvent(doc, 'visibilitychange'),
	  touchmoveStart: connectContinuousEvent(body, 'touchmove', 'touchmoveStart'),
	  touchmoveEnd: connectContinuousEvent(body, 'touchmove', 'touchmoveEnd'),
	  touchmove: connectContinuousEvent(body, 'touchmove', 'touchmove'),
	  touchstart: connectDiscreteEvent(body, 'touchstart'),
	  touchend: connectDiscreteEvent(body, 'touchend')
	};
	module.exports = exports['default'];


/***/ }),
/* 2719 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Copyright 2015, Yahoo! Inc.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      */
	/* global window, document */
	
	var _globalVars = __webpack_require__(2713);
	
	var _globalVars2 = _interopRequireDefault(_globalVars);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var resize = { // eslint-disable-line prefer-const
	  width: 0,
	  height: 0
	};
	var scroll = { // eslint-disable-line prefer-const
	  delta: 0,
	  top: 0
	};
	var touch = { // eslint-disable-line prefer-const
	  axisIntention: '',
	  startX: 0,
	  startY: 0,
	  deltaX: 0,
	  deltaY: 0
	};
	
	var INTENTION_THRESHOLD = 5;
	
	var getXY = function getXY(pos) {
	  var t = { x: 0, y: 0 }; // eslint-disable-line prefer-const
	  var docBody = document.body;
	  var docEl = document.documentElement;
	
	  if (pos.pageX || pos.pageY) {
	    t.x = pos.pageX;
	    t.y = pos.pageY;
	  } else {
	    t.x = pos.clientX + docBody.scrollLeft + docEl.scrollLeft;
	    t.y = pos.clientY + docBody.scrollTop + docEl.scrollTop;
	  }
	
	  return t;
	};
	
	/**
	 * ArgmentedEvent will hold some global information, such like window scroll postion,
	 * so that those information is only calculated once.
	 * @param {Object} option - The option for SyntheticEvent
	 */
	
	var AugmentedEvent = function () {
	  function AugmentedEvent() {
	    var option = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    _classCallCheck(this, AugmentedEvent);
	
	    var mainType = (option.mainType || '').toLowerCase();
	    var subType = (option.subType || '').toLowerCase();
	
	    this.mainType = mainType;
	    this.subType = subType;
	    this.type = mainType + subType.charAt(0).toUpperCase() + subType.slice(1) || '';
	    this.scroll = scroll;
	    this.resize = resize;
	    this.touch = touch;
	  }
	
	  _createClass(AugmentedEvent, [{
	    key: 'update',
	    value: function update(e) {
	      var mainType = this.mainType,
	          subType = this.subType;
	
	      var docEl = document.documentElement;
	
	      if (_globalVars2.default.enableScrollInfo && (mainType === 'scroll' || mainType === 'touchmove')) {
	        var top = docEl.scrollTop + document.body.scrollTop;
	        // Prevent delta from being 0
	        if (top !== this.scroll.top) {
	          this.scroll.delta = top - this.scroll.top;
	          this.scroll.top = top;
	        }
	      }
	      if (_globalVars2.default.enableResizeInfo && mainType === 'resize') {
	        this.resize.width = window.innerWidth || docEl.clientWidth;
	        this.resize.height = window.innerHeight || docEl.clientHeight;
	      }
	      if (_globalVars2.default.enableTouchInfo && e.touches && (mainType === 'touchstart' || mainType === 'touchmove' || mainType === 'touchend')) {
	        var pos = void 0;
	        var absX = void 0;
	        var absY = void 0;
	        if (mainType === 'touchstart' || subType === 'start') {
	          pos = getXY(e.touches[0]);
	          this.touch.axisIntention = '';
	          this.touch.startX = pos.x;
	          this.touch.startY = pos.y;
	          this.touch.deltaX = 0;
	          this.touch.deltaY = 0;
	        } else if (mainType === 'touchmove') {
	          pos = getXY(e.touches[0]);
	          this.touch.deltaX = pos.x - this.touch.startX;
	          this.touch.deltaY = pos.y - this.touch.startY;
	          if (this.touch.axisIntention === '') {
	            absX = Math.abs(this.touch.deltaX);
	            absY = Math.abs(this.touch.deltaY);
	            if (absX > INTENTION_THRESHOLD && absX >= absY) {
	              this.touch.axisIntention = 'x';
	            } else if (absY > INTENTION_THRESHOLD && absY > absX) {
	              this.touch.axisIntention = 'y';
	            }
	          }
	        }
	      }
	    }
	  }]);
	
	  return AugmentedEvent;
	}();
	
	exports.default = AugmentedEvent;
	module.exports = exports['default'];


/***/ }),
/* 2720 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _raf = __webpack_require__(2006);
	
	var _raf2 = _interopRequireDefault(_raf);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getTime = Date.now ||
	/* istanbul ignore next */function () {
	  return new Date().getTime();
	}; /**
	    * Copyright 2015, Yahoo! Inc.
	    * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	    */
	
	function rAFThrottle(func) {
	  var throttle = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 15;
	
	  var context = void 0;
	  var args = void 0;
	  var last = 0;
	  var requestId = 0;
	
	  var later = function later() {
	    var now = getTime();
	    var remaining = throttle - (now - last);
	
	    if (remaining <= 0) {
	      last = now;
	      requestId = 0;
	      func.apply(context, args);
	    } else {
	      requestId = (0, _raf2.default)(later);
	    }
	  };
	
	  return function throttledFunc() {
	    context = this;
	    args = arguments; // eslint-disable-line prefer-rest-params
	
	    if (!requestId) {
	      requestId = (0, _raf2.default)(later);
	    }
	  };
	}
	
	exports.default = rAFThrottle;
	module.exports = exports['default'];


/***/ }),
/* 2721 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	
	var EVENT_END_DELAY = exports.EVENT_END_DELAY = 100;
	var DEFAULT_THROTTLE_RATE = exports.DEFAULT_THROTTLE_RATE = 50;


/***/ }),
/* 2722 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _globalVars = __webpack_require__(2713);
	
	var _globalVars2 = _interopRequireDefault(_globalVars);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var removers = _globalVars2.default.removers;
	
	/**
	 * Unsubscribe to UI events.
	 * @method unsubscribe
	 * @param {String} type - The type of event.
	 * @param {Function} cb - The callback function.
	 */
	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	
	function unsubscribe(type, cb) {
	  var remover = void 0;
	  for (var i = removers.length - 1; i >= 0; i -= 1) {
	    remover = removers[i];
	    if (remover._cb === cb && remover._type.indexOf(type) >= 0) {
	      remover.unsubscribe();
	      removers.splice(i, 1);
	    }
	  }
	}
	
	exports.default = unsubscribe;
	module.exports = exports['default'];


/***/ }),
/* 2723 */
/***/ (function(module, exports) {

	//
	
	module.exports = function shallowEqual(objA, objB, compare, compareContext) {
	  var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
	
	  if (ret !== void 0) {
	    return !!ret;
	  }
	
	  if (objA === objB) {
	    return true;
	  }
	
	  if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
	
	  // Test for A's keys different from B.
	  for (var idx = 0; idx < keysA.length; idx++) {
	    var key = keysA[idx];
	
	    if (!bHasOwnProperty(key)) {
	      return false;
	    }
	
	    var valueA = objA[key];
	    var valueB = objB[key];
	
	    ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
	
	    if (ret === false || (ret === void 0 && valueA !== valueB)) {
	      return false;
	    }
	  }
	
	  return true;
	};


/***/ }),
/* 2724 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _quillEditor = __webpack_require__(2169);
	
	var _quillEditor2 = _interopRequireDefault(_quillEditor);
	
	var _reactCodemirror = __webpack_require__(1751);
	
	var _reactCodemirror2 = _interopRequireDefault(_reactCodemirror);
	
	__webpack_require__(2166);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var HtmlEditor = function (_React$Component) {
	  _inherits(HtmlEditor, _React$Component);
	
	  function HtmlEditor(props) {
	    _classCallCheck(this, HtmlEditor);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(HtmlEditor).call(this, props));
	
	    _this.state = {
	      rawMode: false
	    };
	    return _this;
	  }
	
	  _createClass(HtmlEditor, [{
	    key: "getStyles",
	    value: function getStyles() {
	      return {
	        quillEditor: {
	          minHeight: 150
	        },
	        quillEditorTip: {
	          color: "rgb(158, 158, 158)"
	        },
	        switcherWrapper: {
	          marginTop: -18,
	          textAlign: "right"
	        },
	        editorSwitcher: {
	          color: "rgba(33, 33, 33, 0.498039)",
	          textDecoration: "underline",
	          fontSize: 12,
	          cursor: "pointer"
	        }
	      };
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var rawMode = this.state.rawMode;
	      var _props = this.props;
	      var value = _props.value;
	      var onChange = _props.onChange;
	      var styles = this.getStyles();
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          "div",
	          { style: styles.switcherWrapper },
	          _react2.default.createElement(
	            "span",
	            {
	              style: styles.editorSwitcher,
	              onTouchTap: function onTouchTap() {
	                return _this2.setState({ rawMode: !rawMode });
	              }
	            },
	            "Switch to ",
	            rawMode ? "visual" : "raw",
	            " editor"
	          )
	        ),
	        rawMode ? _react2.default.createElement(_reactCodemirror2.default, {
	          style: { border: "1px solid #ccc" },
	          value: value,
	          onChange: onChange,
	          options: {
	            lineWrapping: true,
	            lineNumbers: true,
	            mode: { name: "htmlmixed" }
	          }
	        }) : _react2.default.createElement(_quillEditor2.default, {
	          style: styles.quillEditor,
	          tipStyle: styles.quillEditorTip,
	          value: value,
	          onChange: onChange
	        })
	      );
	    }
	  }]);
	
	  return HtmlEditor;
	}(_react2.default.Component);
	
	exports.default = HtmlEditor;
	module.exports = exports["default"];

/***/ }),
/* 2725 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _materialUi = __webpack_require__(576);
	
	var _lodash = __webpack_require__(2033);
	
	var _ticketBucketEditor = __webpack_require__(2726);
	
	var _ticketBucketEditor2 = _interopRequireDefault(_ticketBucketEditor);
	
	var _infoNotice = __webpack_require__(1599);
	
	var _infoNotice2 = _interopRequireDefault(_infoNotice);
	
	var _injectedSelect = __webpack_require__(1874);
	
	var _injectedSelect2 = _interopRequireDefault(_injectedSelect);
	
	var _close = __webpack_require__(1756);
	
	var _close2 = _interopRequireDefault(_close);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TicketBucketsEditor = function (_React$Component) {
	  _inherits(TicketBucketsEditor, _React$Component);
	
	  function TicketBucketsEditor(props) {
	    _classCallCheck(this, TicketBucketsEditor);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(TicketBucketsEditor).call(this, props));
	
	    _this.state = {
	      showCloneBucketSelector: false,
	      selectedCloneEventId: null,
	      clonedTicketBuckets: []
	    };
	    return _this;
	  }
	
	  _createClass(TicketBucketsEditor, [{
	    key: "onAdd",
	    value: function onAdd(isFirst) {
	      this.props.onAdd({
	        event: this.props.event,
	        name: isFirst && (this.props.venueDetails ? !this.props.venueDetails.use_reserved_seating : true) ? this.props.eventDetails && this.props.eventDetails.is_virtual ? "Virtual Admission" : "General Admission" : "",
	        quantity: isFirst && this.props.venueDetails ? this.props.venueDetails.default_capacity : "",
	        price: "",
	        variants: [],
	        applicable_pass_buckets: [],
	        public: true
	      });
	    }
	  }, {
	    key: "onCloneFromAnotherEventClick",
	    value: function onCloneFromAnotherEventClick() {
	      var updatedState = {
	        showCloneBucketSelector: !this.state.showCloneBucketSelector
	      };
	      // when cancel is clicked
	      if (this.state.showCloneBucketSelector === true) {
	        //remove items from any unsaved cloned selection
	        var delIndexes = [];
	        for (var tb = this.state.clonedTicketBuckets.length - 1; tb >= 0; tb--) {
	          var thisBucket = this.state.clonedTicketBuckets[tb];
	          for (var x = this.props.ticketBuckets.length - 1; x >= 0; x--) {
	            if (this.props.ticketBuckets[x].cloneId === thisBucket.cloneId) {
	              delIndexes.push(x);
	            }
	          }
	        }
	        //delete all cloned items at one time, no additions
	        if (delIndexes.length) {
	          this.props.onAddAndDelete({
	            additions: [],
	            delIndexes: delIndexes
	          });
	        }
	        updatedState.selectedCloneEventId = null;
	        updatedState.clonedTicketBuckets = [];
	      }
	      this.setState(updatedState);
	    }
	  }, {
	    key: "onCloneFromAnotherEventSelection",
	    value: function onCloneFromAnotherEventSelection(e) {
	      //identify items from any previous unsaved cloned selection
	      var delIndexes = [];
	      for (var tb = this.state.clonedTicketBuckets.length - 1; tb >= 0; tb--) {
	        var thisBucket = this.state.clonedTicketBuckets[tb];
	        for (var x = this.props.ticketBuckets.length - 1; x >= 0; x--) {
	          if (this.props.ticketBuckets[x].cloneId === thisBucket.cloneId) {
	            delIndexes.push(x);
	            break;
	          }
	        }
	      }
	
	      //clone e.ticket_buckets and clear out the ids for buckets and variants
	      var clonedTicketBuckets = e.ticket_buckets.map(function (item) {
	        var newItem = (0, _lodash.cloneDeep)(item);
	        newItem.cloneId = newItem.id;
	        newItem.id = null;
	        //clear variant ids if they exist
	        if (newItem.variants && newItem.variants.length > 0) {
	          for (var v = 0; v < newItem.variants.length; v++) {
	            newItem.variants[v].id = null;
	          }
	        }
	        return newItem;
	      });
	
	      //add new cloned items and delete unsaved cloned selections
	      this.props.onAddAndDelete({
	        additions: clonedTicketBuckets,
	        delIndexes: delIndexes
	      });
	
	      //update state
	      this.setState({
	        selectedCloneEventId: e.id,
	        clonedTicketBuckets: clonedTicketBuckets
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        this.props.venueDetails && this.props.venueDetails.use_reserved_seating ? _react2.default.createElement("img", {
	          src: this.props.venueDetails.seatmap_preview_image,
	          style: { float: "right", maxWidth: 200, maxHeight: 130 }
	        }) : null,
	        this.props.eventDetails && this.props.eventDetails.ticket_buckets && !this.props.eventDetails.ticket_buckets.length ? _react2.default.createElement(
	          "div",
	          { style: { float: "right" } },
	          _react2.default.createElement(
	            "div",
	            {
	              style: {
	                height: 45,
	                paddingLeft: 15,
	                float: "right"
	              }
	            },
	            _react2.default.createElement(_materialUi.RaisedButton, {
	              key: this.state.showCloneBucketSelector ? "open" : "closed",
	              label: this.state.showCloneBucketSelector ? "" : "Clone from Another Event",
	              icon: this.state.showCloneBucketSelector ? _react2.default.createElement(_close2.default, {
	                style: {
	                  paddingLeft: 10,
	                  paddingRight: 10,
	                  paddingTop: 8,
	                  verticalAlign: 0,
	                  width: 20,
	                  height: 20
	                }
	              }) : null,
	              onTouchTap: function onTouchTap(e) {
	                return _this2.onCloneFromAnotherEventClick(e);
	              }
	            })
	          ),
	          this.state.showCloneBucketSelector ? _react2.default.createElement(
	            "div",
	            {
	              style: {
	                height: 45,
	                minWidth: 300,
	                paddingLeft: 15,
	                float: "right"
	              }
	            },
	            _react2.default.createElement(_injectedSelect2.default, {
	              value: this.state.selectedCloneEventId,
	              types: ["events"],
	              placeholderText: "Select an event to clone from...",
	              eventBucketId: this.props.eventDetails.event_bucket,
	              changeValueFunction: function changeValueFunction(e) {
	                return e;
	              },
	              closeOnSelect: true,
	              clearable: false,
	              searchable: true,
	              filterBy: function filterBy(o) {
	                return o.ticket_buckets.length > 0 ? true : false;
	              },
	              labelFormatter: function labelFormatter(f) {
	                return f.name + " (" + f.ticket_buckets.length + ")";
	              },
	              onChange: function onChange(e) {
	                _this2.onCloneFromAnotherEventSelection(e);
	              }
	            })
	          ) : null
	        ) : null,
	        _react2.default.createElement(
	          "p",
	          null,
	          "Add ticket buckets to the event. If no ticket buckets are added, the event will be listed as",
	          " ",
	          this.props.eventDetails && this.props.eventDetails.is_virtual ? '"not currently available"' : 'a "non-ticketed event"',
	          ".",
	          _react2.default.createElement(
	            _infoNotice2.default,
	            { style: { marginTop: 5 } },
	            "Check out our",
	            " ",
	            _react2.default.createElement(
	              "a",
	              {
	                href: "http://help.eventive.org/events-and-tickets/create-ticket-buckets",
	                target: "_blank"
	              },
	              "guide to creating ticket buckets"
	            ),
	            "."
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { style: { clear: "both" } },
	          this.props.ticketBuckets.map(function (bucket, i) {
	            return _react2.default.createElement(_ticketBucketEditor2.default, {
	              key: bucket.id || i,
	              bucket: bucket,
	              eventDetails: _this2.props.eventDetails,
	              index: i,
	              onEdit: function onEdit(e) {
	                return _this2.props.onEdit(i, e);
	              },
	              venueDetails: _this2.props.venueDetails,
	              shiftPosition: function shiftPosition(e) {
	                return _this2.props.onShiftPosition(i, e);
	              },
	              "delete": function _delete(e) {
	                return _this2.props.onDelete(i);
	              },
	              canShiftUp: i > 0,
	              canShiftDown: i < _this2.props.ticketBuckets.length - 1,
	              hasMultipleTicketBuckets: _this2.props.ticketBuckets.length > 1,
	              ticketBuckets: _this2.props.ticketBuckets
	            });
	          }),
	          _react2.default.createElement(_materialUi.RaisedButton, {
	            label: "Add new ticket bucket",
	            onClick: function onClick(e) {
	              return _this2.onAdd(_this2.props.ticketBuckets.length === 0);
	            }
	          })
	        )
	      );
	    }
	  }]);
	
	  return TicketBucketsEditor;
	}(_react2.default.Component);
	
	exports.default = TicketBucketsEditor;
	module.exports = exports["default"];

/***/ }),
/* 2726 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _momentTimezone = __webpack_require__(1185);
	
	var _momentTimezone2 = _interopRequireDefault(_momentTimezone);
	
	var _get = __webpack_require__(1004);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _materialUi = __webpack_require__(576);
	
	var _reactRouter = __webpack_require__(486);
	
	var _styles = __webpack_require__(917);
	
	var _UserStore = __webpack_require__(974);
	
	var _UserStore2 = _interopRequireDefault(_UserStore);
	
	var _util = __webpack_require__(1183);
	
	var _immutabilityHelper = __webpack_require__(2261);
	
	var _immutabilityHelper2 = _interopRequireDefault(_immutabilityHelper);
	
	var _label = __webpack_require__(1682);
	
	var _label2 = _interopRequireDefault(_label);
	
	var _selectField = __webpack_require__(1683);
	
	var _selectField2 = _interopRequireDefault(_selectField);
	
	var _reactSelect = __webpack_require__(953);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	var _currencyField = __webpack_require__(1747);
	
	var _currencyField2 = _interopRequireDefault(_currencyField);
	
	var _quantityEditor = __webpack_require__(2191);
	
	var _quantityEditor2 = _interopRequireDefault(_quantityEditor);
	
	var _EventBucketStore = __webpack_require__(1593);
	
	var _EventBucketStore2 = _interopRequireDefault(_EventBucketStore);
	
	var _injectedSelect = __webpack_require__(1874);
	
	var _injectedSelect2 = _interopRequireDefault(_injectedSelect);
	
	var _datetimeField = __webpack_require__(2061);
	
	var _datetimeField2 = _interopRequireDefault(_datetimeField);
	
	var _config = __webpack_require__(1173);
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TicketBucketEditor = function (_React$Component) {
	  _inherits(TicketBucketEditor, _React$Component);
	
	  function TicketBucketEditor(props) {
	    _classCallCheck(this, TicketBucketEditor);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(TicketBucketEditor).call(this, props));
	
	    var bucket = _this.props.bucket;
	
	    _this.state = {
	      dirty: false,
	      showRushLinePriceEditor: false,
	      showApplicablePassBucketsEditor: bucket && bucket.applicable_pass_buckets.length,
	      showMaxQuantityEditor: false,
	      showCompanionEditor: false
	    };
	
	    _this.onChange = _this.onChange.bind(_this);
	    _this.onChangeValue = _this.onChangeValue.bind(_this);
	    _this.save = _this.save.bind(_this);
	    _this.delete = _this.delete.bind(_this);
	    return _this;
	  }
	
	  _createClass(TicketBucketEditor, [{
	    key: "getStyles",
	    value: function getStyles() {
	      return {
	        stats: {
	          marginBottom: 10,
	          fontSize: "1.2em",
	          fontStyle: "italic"
	        },
	        editor: {
	          position: "relative",
	          border: "1px solid #ccc",
	          padding: 20,
	          margin: "20px 0"
	        },
	        outer: {
	          marginTop: 10
	        },
	        inner: {
	          width: "50%",
	          maxWidth: 370,
	          display: "inline-block",
	          verticalAlign: "top"
	        },
	        actions: {
	          marginTop: 20
	        }
	      };
	    }
	  }, {
	    key: "onChange",
	    value: function onChange(id, e) {
	      this.onChangeValue(id, e.target.value);
	    }
	  }, {
	    key: "onChangeValue",
	    value: function onChangeValue(id, value) {
	      var bucket = (0, _immutabilityHelper2.default)(this.props.bucket, (typeof id === "undefined" ? "undefined" : _typeof(id)) === "object" ? id : _defineProperty({}, id, { $set: value }));
	      this.props.onEdit(bucket);
	    }
	  }, {
	    key: "save",
	    value: function save() {
	      // this.props.onEdit(this.props.index, this.props.bucket);
	      // this.setState({ isSaving: true });
	    }
	  }, {
	    key: "delete",
	    value: function _delete() {
	      if (window.confirm("Are you sure? This will also delete all tickets in this bucket, which will make them unusable.")) {
	        this.props.delete();
	      }
	    }
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.componentWillReceiveProps(this.props);
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(newProps) {
	      var bucket = newProps.bucket;
	
	      // Don't overwrite unless we're actively saving
	      if (this.state.bucket && this.state.dirty && !this.state.isSaving) {
	        return;
	      }
	
	      this.setState({ bucket: bucket, dirty: false });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var styles = this.getStyles();
	
	      var showCurrencyEditor = ["629e694dd48797006a9d2cdc", // banff
	      "6238cc51b3e10b005cbe04b2", // banff demo
	      "5ec53f5d15980b0071513706", // adff
	      "626910803d077e0030526b0c", // film & campaign ltd
	      "62fa9168ef65d80029436fce", // endowhat
	      "5ef11dd7c0de2d00a17fee9b", // coup 53 uk
	      "5f5aa260ada3ad00450caa7e", // education without borders
	      "5c47cc414a8fe0001d4bb705", // together filmes
	      "687504d248f9660a2ba7da6d", // tragic awakening film
	      "687a9cbd11060ebee7c7ee2b" // narrative entertainmment (NGN)
	      ].includes((_UserStore2.default.getUser() || {}).id) || _UserStore2.default.isGod();
	      var userCurrency = (_UserStore2.default.getUser() || { currency: "usd" }).currency;
	      var hasMultiCurrency = this.props.bucket.variants.some(function (v) {
	        return v.currency && v.currency !== userCurrency;
	      });
	
	      var contingentTicketBucketsEnabled = ["632796a787711400538e66da", // sundance
	      "5dae0d7c41443700308287c5" // sundance sandbox
	      ].includes((_UserStore2.default.getUser() || {}).id) || _UserStore2.default.isGod();
	
	      var roleList = _UserStore2.default.getState().roles || [];
	      var roles = [];
	      for (var roleId in roleList) {
	        if (roleId === "admin") continue;
	
	        roles.push({
	          value: roleId,
	          label: roleList[roleId].label
	        });
	      }
	
	      return _react2.default.createElement(
	        "div",
	        { style: styles.editor },
	        _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement(
	            "div",
	            {
	              style: {
	                position: "absolute",
	                right: 10,
	                top: 10,
	                lineHeight: "1.1em",
	                fontSize: "0.75em",
	                textAlign: "right",
	                color: "rgba(0,0,0,0.5)"
	              }
	            },
	            "ID: ",
	            (0, _get2.default)(this.props, "bucket.id", "Not yet assigned"),
	            (0, _get2.default)(this.props, "bucket.id") ? _react2.default.createElement(
	              "div",
	              null,
	              _react2.default.createElement(
	                "strong",
	                { style: { fontVariant: "tabular-nums" } },
	                (0, _get2.default)(this.props, "bucket.quantity_sold", 0)
	              ),
	              " ",
	              "sold /",
	              " ",
	              _react2.default.createElement(
	                "strong",
	                { style: { fontVariant: "tabular-nums" } },
	                (0, _get2.default)(this.props, "bucket.quantity_remaining") >= Number.MAX_SAFE_INTEGER ? "∞" : Math.max((0, _get2.default)(this.props, "bucket.quantity_remaining", 0), 0)
	              ),
	              " ",
	              "remaining"
	            ) : null
	          ),
	          hasMultiCurrency ? _react2.default.createElement(
	            "div",
	            {
	              style: {
	                marginTop: 15,
	                marginBottom: 5,
	                border: "1px solid " + _styles.colors.blue900,
	                padding: "4px 10px",
	                color: _styles.colors.blue900,
	                backgroundColor: _styles.colors.blue50,
	                borderRadius: 10
	              }
	            },
	            _react2.default.createElement(
	              "strong",
	              null,
	              "Multi-currency ticket bucket"
	            ),
	            ": This ticket bucket is priced in multiple currencies. Users will be recommended prices in their local currency, if available. They can also select another currency. Payments will be instantly converted to your default currency (",
	            userCurrency.toUpperCase(),
	            ") at the time of sale using Stripe's current mid-market exchange rate."
	          ) : null,
	          _react2.default.createElement(_materialUi.TextField, {
	            value: (0, _get2.default)(this.props, "bucket.name", ""),
	            floatingLabelText: "Name",
	            floatingLabelFixed: true,
	            onChange: function onChange(e) {
	              return _this2.onChangeValue("name", e.target.value);
	            }
	          }),
	          _react2.default.createElement(_currencyField2.default, {
	            value: (0, _get2.default)(this.state, "bucket.price", ""),
	            floatingLabelText: this.props.bucket.variable_price ? "Default price" : "Price",
	            floatingLabelFixed: true,
	            placeholder: "$0.00",
	            onChange: function onChange(e) {
	              return _this2.onChangeValue("price", e.target.value);
	            },
	            style: { marginLeft: 7, width: 150 }
	          }),
	          this.props.venueDetails && this.props.venueDetails.use_reserved_seating ? _react2.default.createElement(_selectField2.default, {
	            value: this.props.bucket.reserved_seating_category,
	            options: this.props.venueDetails.seatmap_categories.map(function (c) {
	              return {
	                category: c,
	                value: c.key,
	                label: _react2.default.createElement(
	                  "span",
	                  null,
	                  _react2.default.createElement("span", {
	                    style: {
	                      display: "inline-block",
	                      height: "1em",
	                      width: "1em",
	                      verticalAlign: -2,
	                      backgroundColor: c.color
	                    }
	                  }),
	                  " ",
	                  c.label
	                )
	              };
	            }),
	            clearable: false,
	            label: "Seatmap category",
	            placeholder: "Select category",
	            style: {
	              display: "inline-block",
	              verticalAlign: 27,
	              marginLeft: 15,
	              width: 200
	            },
	            labelStyle: { marginBottom: 0 },
	            onChange: function onChange(s) {
	              if (s && s.value) {
	                _this2.onChangeValue({
	                  reserved_seating_category: { $set: s.value },
	                  name: !_this2.state.dirty || !_this2.props.bucket.name ? { $set: s.category.label } : undefined
	                });
	              }
	            }
	          }) : _react2.default.createElement(_materialUi.TextField, {
	            value: (0, _get2.default)(this.state, "bucket.quantity", ""),
	            floatingLabelText: "Quantity",
	            floatingLabelFixed: true,
	            placeholder: "Unlimited",
	            onChange: function onChange(e) {
	              if (e.target.value) {
	                _this2.onChangeValue({
	                  unlimited: { $set: false },
	                  quantity: { $set: parseInt(e.target.value, 10) }
	                });
	              } else {
	                _this2.onChangeValue({
	                  unlimited: { $set: true },
	                  quantity: { $set: "" }
	                });
	              }
	            },
	            style: { marginLeft: 7, width: 70 }
	          })
	        ),
	        _react2.default.createElement(
	          "div",
	          { style: styles.outer },
	          _react2.default.createElement(
	            "div",
	            { style: styles.inner },
	            _react2.default.createElement(
	              "div",
	              null,
	              _react2.default.createElement(_materialUi.Checkbox, {
	                label: "Public for online customer orders",
	                checked: this.props.bucket.public,
	                onCheck: function onCheck(e) {
	                  return _this2.onChangeValue("public", !_this2.props.bucket.public);
	                }
	              })
	            ),
	            this.props.hasMultipleTicketBuckets || this.props.bucket.applicable_pass_buckets && this.props.bucket.applicable_pass_buckets.length ? _react2.default.createElement(
	              "div",
	              null,
	              _react2.default.createElement(_materialUi.Checkbox, {
	                label: "Restrict ordering to certain pass buckets only",
	                checked: this.state.showApplicablePassBucketsEditor,
	                onCheck: function onCheck(e) {
	                  return _this2.setState({
	                    showApplicablePassBucketsEditor: !_this2.state.showApplicablePassBucketsEditor
	                  }, function () {
	                    _this2.onChangeValue("applicable_pass_buckets", []);
	                  });
	                }
	              }),
	              this.state.showApplicablePassBucketsEditor ? _react2.default.createElement(_injectedSelect2.default, {
	                style: { margin: "-0.5em 3em 1em" },
	                value: this.props.bucket.applicable_pass_buckets,
	                types: ["all_pass_buckets"],
	                multi: true,
	                label: "Allowed pass buckets",
	                labelFormatter: function labelFormatter(b) {
	                  return "" + b.name + (b.event_bucket !== _this2.props.bucket.event_bucket && _EventBucketStore2.default.getEventBucketById(b.event_bucket) ? " (" + _EventBucketStore2.default.getEventBucketById(b.event_bucket).name + ")" : "");
	                },
	                eventBucketId: this.props.bucket.event_bucket,
	                onChange: function onChange(selected) {
	                  return _this2.onChangeValue("applicable_pass_buckets", selected);
	                },
	                filterBy: function (o) {
	                  // if pass bucket is in this event bucket, it is allowed
	                  if (o.event_bucket === this.props.bucket.event_bucket) {
	                    return true;
	                  }
	                  // if pass bucket is not in this event bucket but
	                  // applies globally, it is allowed
	                  for (var y = 0; y < o.rules.length; y++) {
	                    //"global_target.event_bucket.id": eventBucket
	                    if (o.rules[y].global_target === "*") {
	                      return true;
	                    } else if (o.rules[y].global_target && o.rules[y].global_target.event_bucket) {
	                      var idRule = o.rules[y].global_target.event_bucket.id;
	                      if (idRule === this.props.bucket.event_bucket) {
	                        return true;
	                      } else if (Array.isArray(idRule) && idRule.indexOf(this.props.bucket.event_bucket) !== -1) {
	                        return true;
	                      }
	                    }
	                  }
	                  return false;
	                }.bind(this)
	              }) : null
	            ) : null,
	            !contingentTicketBucketsEnabled ? null : this.props.bucket.contingent_has_rolled_over ? _react2.default.createElement(
	              "div",
	              null,
	              _react2.default.createElement(_materialUi.Checkbox, {
	                label: "Capacity rollover completed: " + (this.props.bucket.contingent_rollover_status_message || "unknown status") + " (" + (0, _momentTimezone2.default)(this.props.bucket.contingent_rollover_date).tz(this.props.eventDetails.timezone).format("lll z") + ")",
	                checked: true,
	                disabled: true
	              })
	            ) : this.props.hasMultipleTicketBuckets ? _react2.default.createElement(
	              "div",
	              null,
	              _react2.default.createElement(_materialUi.Checkbox, {
	                label: _react2.default.createElement(
	                  "span",
	                  null,
	                  _react2.default.createElement(
	                    "i",
	                    null,
	                    "Advanced"
	                  ),
	                  ": \"Roll over\" unused capacity to another ticket bucket at a certain date & time"
	                ),
	                checked: this.props.bucket.contingent,
	                onCheck: function onCheck(e) {
	                  return _this2.onChangeValue("contingent", !_this2.props.bucket.contingent);
	                }
	              }),
	              this.props.bucket.contingent ? _react2.default.createElement(
	                "div",
	                { style: { margin: "-0.5em 3em 0.5em" } },
	                _react2.default.createElement(
	                  "div",
	                  null,
	                  _react2.default.createElement(_selectField2.default, {
	                    value: this.props.bucket.contingent_rollover_ticket_bucket,
	                    options: this.props.ticketBuckets.filter(function (b) {
	                      return b.id !== _this2.props.bucket.id;
	                    }).map(function (b) {
	                      return {
	                        value: b.id,
	                        label: b.name
	                      };
	                    }),
	                    clearable: false,
	                    label: "Target ticket bucket",
	                    placeholder: "Ticket bucket",
	                    style: {
	                      display: "inline-block",
	                      width: 200
	                    },
	                    onChange: function onChange(s) {
	                      if (s && s.value) {
	                        _this2.onChangeValue("contingent_rollover_ticket_bucket", s.value);
	                      }
	                    }
	                  }),
	                  _react2.default.createElement(_datetimeField2.default, {
	                    value: this.props.bucket.contingent_rollover_date,
	                    label: "Rollover date",
	                    unclearable: true,
	                    timezone: this.props.eventDetails.timezone,
	                    onChange: function onChange(e, v) {
	                      return _this2.onChangeValue("contingent_rollover_date", v);
	                    },
	                    style: { display: "inline-block" }
	                  })
	                )
	              ) : null
	            ) : null,
	            !this.props.bucket.public ? _react2.default.createElement(
	              "div",
	              null,
	              _react2.default.createElement(_materialUi.Checkbox, {
	                label: "Exclude quantity from total event capacity",
	                checked: this.props.bucket.exclude_capacity,
	                onCheck: function onCheck(e) {
	                  return _this2.onChangeValue("exclude_capacity", !_this2.props.bucket.exclude_capacity);
	                }
	              })
	            ) : null,
	            this.props.bucket.exclude_capacity ? _react2.default.createElement(
	              "div",
	              null,
	              _react2.default.createElement(_materialUi.Checkbox, {
	                label: "Lock sales to administrators and selected roles",
	                checked: this.props.bucket.lock_admin_only,
	                onCheck: function onCheck(e) {
	                  return _this2.onChangeValue("lock_admin_only", !_this2.props.bucket.lock_admin_only);
	                }
	              })
	            ) : null,
	            this.props.bucket.lock_admin_only ? _react2.default.createElement(
	              "div",
	              null,
	              _react2.default.createElement(_reactSelect2.default, {
	                clearable: true,
	                multi: true,
	                value: this.props.bucket.lock_admin_only_role,
	                placeholder: "Role allowed to view",
	                options: roles,
	                simpleValue: true,
	                onChange: function onChange(v) {
	                  _this2.onChangeValue("lock_admin_only_role", v);
	                }
	              })
	            ) : null,
	            _react2.default.createElement(
	              "div",
	              null,
	              _react2.default.createElement(_materialUi.Checkbox, {
	                label: "Restrict maximum quantity of tickets per customer",
	                checked: this.props.bucket.max_quantity_per_person || this.state.showMaxQuantityEditor,
	                onCheck: function onCheck(e, checked) {
	                  _this2.setState({ showMaxQuantityEditor: checked }, function () {
	                    _this2.onChangeValue("max_quantity_per_person", checked ? 4 : null);
	                  });
	                }
	              }),
	              this.state.showMaxQuantityEditor || this.props.bucket.max_quantity_per_person ? _react2.default.createElement(
	                "div",
	                { style: { margin: "-0.5em 3em 0.5em" } },
	                _react2.default.createElement(
	                  _label2.default,
	                  null,
	                  "Max quantity per customer"
	                ),
	                _react2.default.createElement(_quantityEditor2.default, {
	                  style: { marginTop: -14, marginLeft: -17 },
	                  quantity: this.props.bucket.max_quantity_per_person,
	                  updateQuantity: function updateQuantity(q) {
	                    return _this2.setState({ showMaxQuantityEditor: true }, function () {
	                      return _this2.onChangeValue("max_quantity_per_person", q);
	                    });
	                  }
	                })
	              ) : null
	            ),
	            this.props.eventDetails ? _react2.default.createElement(
	              "div",
	              null,
	              _react2.default.createElement(_materialUi.Checkbox, {
	                style: { display: "inline-block" },
	                label: this.props.eventDetails.is_virtual ? "Enable pay-what-you-can virtual unlocks" : "Enable pay-what-you-can ticket purchases",
	                checked: this.props.bucket.variable_price,
	                onCheck: function onCheck(e, checked) {
	                  _this2.onChangeValue("variable_price", !_this2.props.bucket.variable_price);
	                }
	              }),
	              this.props.bucket.variable_price ? _react2.default.createElement(
	                "div",
	                { style: { margin: "-1em 3em 0.5em" } },
	                _react2.default.createElement(_currencyField2.default, {
	                  value: this.props.bucket.variable_price_minimum,
	                  floatingLabelText: this.props.eventDetails.is_virtual ? "Minimum price per unlock" : "Minimum price per ticket",
	                  floatingLabelFixed: true,
	                  placeholder: "$0.00",
	                  onChange: function onChange(e) {
	                    return _this2.onChangeValue("variable_price_minimum", e.target.value);
	                  },
	                  onBlur: function onBlur(e) {
	                    // If the new minimum is greater than the default bucket price,
	                    // bump up the bucket price to the new minimum price.
	                    var min = e.target.value;
	                    if ((0, _get2.default)(_this2.state, "bucket.price", 0) < min) {
	                      _this2.onChangeValue("price", min);
	                    }
	                  },
	                  style: { width: 300 }
	                })
	              ) : null
	            ) : null
	          ),
	          _react2.default.createElement(
	            "div",
	            { style: styles.inner },
	            _react2.default.createElement(
	              "div",
	              null,
	              _react2.default.createElement(_materialUi.Checkbox, {
	                label: "Sell additional variants of this ticket bucket",
	                checked: this.props.bucket.variants.length > 0,
	                onCheck: function onCheck(e, checked) {
	                  return _this2.onChangeValue("variants", checked ? [{}] : []);
	                }
	              })
	            ),
	            this.props.bucket.variants.length > 0 ? _react2.default.createElement(
	              "div",
	              { style: { margin: "-1.5em 0 1.5em" } },
	              _react2.default.createElement(
	                "ul",
	                { style: { listStyle: "none" } },
	                this.props.bucket.variants.map(function (v, i) {
	                  var currency = v.currency;
	                  return _react2.default.createElement(
	                    "li",
	                    {
	                      style: { marginBottom: "-0.5em", whiteSpace: "nowrap" }
	                    },
	                    _react2.default.createElement(_materialUi.TextField, {
	                      name: "variantName-" + i,
	                      placeholder: "Variant name",
	                      value: v.name,
	                      style: { maxWidth: "50%" },
	                      onChange: function onChange(e) {
	                        _this2.props.bucket.variants[i].name = e.target.value;
	                        _this2.onChangeValue("variants", _this2.props.bucket.variants);
	                      }
	                    }),
	                    _react2.default.createElement(_currencyField2.default, {
	                      name: "variantPrice-" + i,
	                      placeholder: "$0.00",
	                      value: v.price,
	                      currency: currency,
	                      onChange: function onChange(e) {
	                        _this2.props.bucket.variants[i].price = e.target.value;
	                        _this2.onChangeValue("variants", _this2.props.bucket.variants);
	                      },
	                      style: { marginLeft: 7, width: 150, maxWidth: "25%" }
	                    }),
	                    _this2.props.eventDetails.is_virtual && showCurrencyEditor ? _react2.default.createElement(
	                      "div",
	                      {
	                        style: {
	                          width: 70,
	                          display: "inline-block",
	                          verticalAlign: -12,
	                          marginLeft: 7,
	                          maxWidth: "20%"
	                        }
	                      },
	                      _react2.default.createElement(_reactSelect2.default, {
	                        clearable: false,
	                        value: v.currency || (_UserStore2.default.getUser() || { currency: "usd" }).currency,
	                        options: _config2.default.fee.supported_currencies.map(function (k) {
	                          return {
	                            label: k.toUpperCase(),
	                            value: k
	                          };
	                        }),
	                        onChange: function onChange(v) {
	                          var isUserCurrency = v.value === (_UserStore2.default.getUser() || { currency: "usd" }).currency;
	
	                          _this2.props.bucket.variants[i].currency = isUserCurrency ? undefined : v.value;
	                          _this2.onChangeValue("variants", _this2.props.bucket.variants);
	                        }
	                      })
	                    ) : null,
	                    _react2.default.createElement(_materialUi.FlatButton, {
	                      style: { marginLeft: 7, minWidth: 30 },
	                      label: "\xD7",
	                      onTouchTap: function onTouchTap() {
	                        if (window.confirm("Are you sure you want to delete this variant? This will also delete all tickets of this variant type.")) {
	                          var variants = [].concat(_toConsumableArray(_this2.props.bucket.variants));
	                          variants.splice(i, 1);
	                          _this2.onChangeValue("variants", variants);
	                        }
	                      }
	                    })
	                  );
	                }),
	                _react2.default.createElement(
	                  "li",
	                  { style: { marginTop: "1em" } },
	                  _react2.default.createElement(_materialUi.RaisedButton, {
	                    label: "Add another variant",
	                    onTouchTap: function onTouchTap() {
	                      return _this2.onChangeValue("variants", _this2.props.bucket.variants.concat({}));
	                    }
	                  })
	                )
	              )
	            ) : null,
	            !this.props.eventDetails.is_virtual ? _react2.default.createElement(
	              "div",
	              null,
	              _react2.default.createElement(_materialUi.Checkbox, {
	                label: _react2.default.createElement(
	                  "span",
	                  null,
	                  "Custom rush line ticket price (current:",
	                  " ",
	                  _react2.default.createElement(
	                    "strong",
	                    null,
	                    (0, _util.formatPrice)(this.props.bucket.rush_line_price || (_EventBucketStore2.default.getEventBucketById(this.state.bucket && this.state.bucket.event_bucket) || {}).rush_line_default_price || this.props.bucket.price)
	                  ),
	                  ")"
	                ),
	                checked: this.props.bucket.rush_line_price || this.state.showRushLinePriceEditor,
	                onCheck: function onCheck(e, checked) {
	                  _this2.setState({ showRushLinePriceEditor: checked }, function () {
	                    !checked && _this2.onChangeValue("rush_line_price", null);
	                  });
	                }
	              }),
	              this.state.showRushLinePriceEditor || this.props.bucket.rush_line_price ? _react2.default.createElement(_currencyField2.default, {
	                floatingLabelText: "Rush line ticket price",
	                floatingLabelFixed: true,
	                placeholder: "$0.00",
	                style: { margin: "-0.5em 2.5em 0.5em" },
	                value: this.props.bucket.rush_line_price,
	                onChange: function onChange(e) {
	                  return _this2.setState({ showRushLinePriceEditor: true }, function () {
	                    return _this2.onChangeValue("rush_line_price", e.target.value);
	                  });
	                }
	              }) : null
	            ) : null,
	            _react2.default.createElement(
	              "div",
	              null,
	              _react2.default.createElement(_materialUi.Checkbox, {
	                style: { display: "inline-block" },
	                label: "Auto-issue companion ticket to another event",
	                checked: this.props.bucket.autoissue_companion_ticket && this.props.bucket.autoissue_companion_ticket.length || this.state.showCompanionEditor,
	                onCheck: function onCheck(e) {
	                  return _this2.setState({ showCompanionEditor: !_this2.state.showCompanionEditor }, function () {
	                    _this2.onChangeValue("autoissue_companion_ticket", []);
	                  });
	                }
	              }),
	              this.state.showCompanionEditor || this.props.bucket.autoissue_companion_ticket && this.props.bucket.autoissue_companion_ticket.length ? _react2.default.createElement(_injectedSelect2.default, {
	                multi: true,
	                style: { margin: "-0.5em 3em 1em" },
	                value: this.props.bucket.autoissue_companion_ticket,
	                types: ["ticket_buckets"],
	                label: "Companion ticket bucket",
	                labelFormatter: function labelFormatter(b) {
	                  return b.event.name + " \u2013 " + b.name;
	                },
	                eventBucketId: this.props.bucket.event_bucket,
	                onChange: function onChange(selected) {
	                  return _this2.onChangeValue("autoissue_companion_ticket", selected);
	                }
	              }) : null
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { style: styles.actions },
	          _react2.default.createElement(_materialUi.RaisedButton, {
	            label: "Remove",
	            onClick: this.delete,
	            style: { marginLeft: 7 }
	          }),
	          _react2.default.createElement(_materialUi.RaisedButton, {
	            label: "\u25B2",
	            style: { minWidth: 30, marginLeft: 7 },
	            disabled: !this.props.canShiftUp,
	            onTouchTap: function onTouchTap() {
	              return _this2.props.shiftPosition(-1);
	            }
	          }),
	          _react2.default.createElement(_materialUi.RaisedButton, {
	            label: "\u25BC",
	            style: { minWidth: 30, marginLeft: 7 },
	            disabled: !this.props.canShiftDown,
	            onTouchTap: function onTouchTap() {
	              return _this2.props.shiftPosition(1);
	            }
	          })
	        )
	      );
	    }
	  }]);
	
	  return TicketBucketEditor;
	}(_react2.default.Component);
	
	exports.default = TicketBucketEditor;
	module.exports = exports["default"];

/***/ }),
/* 2727 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(608);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(615);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MapsLocalMovies = function MapsLocalMovies(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M18 3v2h-2V3H8v2H6V3H4v18h2v-2h2v2h8v-2h2v2h2V3h-2zM8 17H6v-2h2v2zm0-4H6v-2h2v2zm0-4H6V7h2v2zm10 8h-2v-2h2v2zm0-4h-2v-2h2v2zm0-4h-2V7h2v2z' })
	  );
	};
	MapsLocalMovies = (0, _pure2.default)(MapsLocalMovies);
	MapsLocalMovies.displayName = 'MapsLocalMovies';
	MapsLocalMovies.muiName = 'SvgIcon';
	
	exports.default = MapsLocalMovies;

/***/ }),
/* 2728 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(608);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(615);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionDateRange = function ActionDateRange(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M9 11H7v2h2v-2zm4 0h-2v2h2v-2zm4 0h-2v2h2v-2zm2-7h-1V2h-2v2H8V2H6v2H5c-1.11 0-1.99.9-1.99 2L3 20c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 16H5V9h14v11z' })
	  );
	};
	ActionDateRange = (0, _pure2.default)(ActionDateRange);
	ActionDateRange.displayName = 'ActionDateRange';
	ActionDateRange.muiName = 'SvgIcon';
	
	exports.default = ActionDateRange;

/***/ }),
/* 2729 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _materialUi = __webpack_require__(576);
	
	var _displayAdPanel = __webpack_require__(2730);
	
	var _displayAdPanel2 = _interopRequireDefault(_displayAdPanel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _class = function (_React$Component) {
	  _inherits(_class, _React$Component);
	
	  function _class(props) {
	    _classCallCheck(this, _class);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(_class).call(this, props));
	
	    _this.state = {
	      ads: _this.props.ads
	    };
	
	    _this.onAddItem = _this.onAddItem.bind(_this);
	    _this.onUpdateItem = _this.onUpdateItem.bind(_this);
	    _this.onDeleteItem = _this.onDeleteItem.bind(_this);
	    _this.onItemShiftPosition = _this.onItemShiftPosition.bind(_this);
	    return _this;
	  }
	
	  _createClass(_class, [{
	    key: "onAddItem",
	    value: function onAddItem() {
	      var addArray = this.state.ads.slice(0);
	      addArray.push({
	        url: null,
	        image: null
	      });
	      this.setState({ ads: addArray });
	      this.props.onUpdate(addArray);
	    }
	  }, {
	    key: "onUpdateItem",
	    value: function onUpdateItem(index, field, value) {
	      var updateArray = this.state.ads.slice(0);
	      updateArray[index][field] = value;
	      this.setState({ ads: updateArray });
	      this.props.onUpdate(updateArray);
	    }
	  }, {
	    key: "onDeleteItem",
	    value: function onDeleteItem(index) {
	      var deleteArray = this.state.ads.slice(0);
	      deleteArray.splice(index, 1);
	      this.setState({ ads: deleteArray });
	      this.props.onUpdate(deleteArray);
	    }
	  }, {
	    key: "onItemShiftPosition",
	    value: function onItemShiftPosition(idx, direction) {
	      var positionArray = this.state.ads.slice(0);
	      positionArray.splice(idx + direction, 0, positionArray.splice(idx, 1)[0]);
	      this.setState({ ads: positionArray });
	      this.props.onUpdate(positionArray);
	    }
	  }, {
	    key: "getStyles",
	    value: function getStyles() {
	      return {
	        displayadpanel: {
	          display: "flex",
	          flexDirection: "column",
	          justify: "start",
	          flexWrap: "wrap",
	          marginTop: 15
	        },
	        addbutton: {
	          marginBottom: 10
	        }
	      };
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var styles = this.getStyles();
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          "div",
	          { style: styles.displayadpanel },
	          this.state.ads.map(function (item, index) {
	            return _react2.default.createElement(_displayAdPanel2.default, {
	              key: index,
	              keyval: index,
	              url: item.url,
	              image: item.image,
	              onUpdate: _this2.onUpdateItem,
	              onDelete: _this2.onDeleteItem,
	              canShiftUp: index > 0,
	              canShiftDown: index < _this2.state.ads.length - 1,
	              onShiftPosition: function onShiftPosition(idx, direction) {
	                _this2.onItemShiftPosition(idx, direction);
	              }
	            });
	          })
	        ),
	        _react2.default.createElement(_materialUi.RaisedButton, {
	          style: styles.addbutton,
	          label: "Add another display ad",
	          onTouchTap: this.onAddItem
	        })
	      );
	    }
	  }]);
	
	  return _class;
	}(_react2.default.Component);
	
	exports.default = _class;
	module.exports = exports["default"];

/***/ }),
/* 2730 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _materialUi = __webpack_require__(576);
	
	var _delete = __webpack_require__(2057);
	
	var _delete2 = _interopRequireDefault(_delete);
	
	var _orderablePanel = __webpack_require__(2056);
	
	var _orderablePanel2 = _interopRequireDefault(_orderablePanel);
	
	var _imageDropzone = __webpack_require__(2058);
	
	var _imageDropzone2 = _interopRequireDefault(_imageDropzone);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _class = function (_React$Component) {
	  _inherits(_class, _React$Component);
	
	  function _class(props) {
	    _classCallCheck(this, _class);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(_class).call(this, props));
	
	    _this.state = {
	      url: _this.props.url,
	      image: _this.props.image,
	      uploadingImageField: null
	    };
	
	    _this.onUrlChange = _this.onUrlChange.bind(_this);
	    _this.onImageDrop = _this.onImageDrop.bind(_this);
	    return _this;
	  }
	
	  _createClass(_class, [{
	    key: "onUrlChange",
	    value: function onUrlChange(e) {
	      this.setState({ url: e.target.value });
	      this.props.onUpdate(this.props.keyval, "url", e.target.value);
	    }
	  }, {
	    key: "onImageDrop",
	    value: function onImageDrop(e) {
	      var file = e[0],
	          reader = new FileReader();
	
	      reader.onloadend = function () {
	        // Since it contains the Data URI, we should remove the prefix and keep only Base64 string
	        var b64 = reader.result.replace(/^data:.+;base64,/, "");
	        file.base64 = b64;
	        this.setState({ image: file });
	        this.props.onUpdate(this.props.keyval, "image", file);
	      }.bind(this);
	
	      reader.readAsDataURL(file);
	    }
	  }, {
	    key: "getStyles",
	    value: function getStyles() {
	      return {
	        displayadeditor: {
	          marginRight: 30,
	          marginBottom: 15,
	          padding: 20,
	          border: "1px solid #ccc",
	          display: "flex",
	          flexDirection: "column",
	          justifyContent: "space-between",
	          maxWidth: 370
	        },
	        dropzone: {
	          width: 200,
	          padding: 20,
	          border: "1px dashed #ccc",
	          cursor: "pointer"
	        },
	        progress: {
	          marginBottom: 50
	        }
	      };
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var styles = this.getStyles();
	      return _react2.default.createElement(
	        _orderablePanel2.default,
	        {
	          keyval: this.props.keyval,
	          onDelete: this.props.onDelete,
	          onShiftPosition: this.props.onShiftPosition,
	          canShiftUp: this.props.canShiftUp,
	          canShiftDown: this.props.canShiftDown
	        },
	        this.state.uploadingImageField === "display_ad_image" ? _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement(_materialUi.CircularProgress, { style: styles.progress, mode: "indeterminate" })
	        ) : null,
	        _react2.default.createElement(
	          "div",
	          {
	            style: {
	              display: this.state.uploadingImageField === "display_ad_image" ? "none" : "block"
	            }
	          },
	          this.props.image ? _react2.default.createElement("img", {
	            src: this.props.image.preview || this.props.image,
	            width: 242
	          }) : _react2.default.createElement(
	            _imageDropzone2.default,
	            {
	              style: styles.dropzone,
	              onDrop: function onDrop(e) {
	                return _this2.onImageDrop(e);
	              }
	            },
	            _react2.default.createElement(
	              "div",
	              null,
	              "To add a new display ad, drop a file here, or click to select.",
	              " ",
	              _react2.default.createElement(
	                "div",
	                {
	                  style: {
	                    marginTop: "0.5em",
	                    fontSize: "0.9em",
	                    lineHeight: 1.3
	                  }
	                },
	                "Recommended: at least 600px wide; wide or square aspect ratio."
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(_materialUi.TextField, {
	              style: { width: 350 },
	              value: this.props.url || "",
	              floatingLabelText: "Display ad link",
	              floatingLabelFixed: true,
	              placeholder: "Optional external URL (include \"https://\")",
	              onChange: function onChange(e) {
	                return _this2.onUrlChange(e);
	              }
	            })
	          )
	        )
	      );
	    }
	  }]);
	
	  return _class;
	}(_react2.default.Component);
	
	exports.default = _class;
	module.exports = exports["default"];

/***/ }),
/* 2731 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _materialUi = __webpack_require__(576);
	
	var _styles = __webpack_require__(917);
	
	var _copyToClipboard = __webpack_require__(971);
	
	var _copyToClipboard2 = _interopRequireDefault(_copyToClipboard);
	
	var _reactRouter = __webpack_require__(486);
	
	var _infoNotice = __webpack_require__(1599);
	
	var _infoNotice2 = _interopRequireDefault(_infoNotice);
	
	var _percentField = __webpack_require__(1873);
	
	var _percentField2 = _interopRequireDefault(_percentField);
	
	var _label = __webpack_require__(1682);
	
	var _label2 = _interopRequireDefault(_label);
	
	var _delete = __webpack_require__(2057);
	
	var _delete2 = _interopRequireDefault(_delete);
	
	var _contentCopy = __webpack_require__(1225);
	
	var _contentCopy2 = _interopRequireDefault(_contentCopy);
	
	var _UserStore = __webpack_require__(974);
	
	var _UserStore2 = _interopRequireDefault(_UserStore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RevenuSharingEditor = function (_React$Component) {
	  _inherits(RevenuSharingEditor, _React$Component);
	
	  function RevenuSharingEditor(props) {
	    _classCallCheck(this, RevenuSharingEditor);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(RevenuSharingEditor).call(this, props));
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(RevenuSharingEditor, [{
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var revenueShare = this.props.revenueShare;
	
	
	      var enabled = !!revenueShare;
	      var allReady = revenueShare && revenueShare.recipients.every(function (r) {
	        return !!r.user;
	      });
	
	      var primaryPercent = revenueShare ? 1 - revenueShare.recipients.reduce(function (t, r) {
	        return t + (r.percent || 0);
	      }, 0) : 0;
	      var primaryDonationPercent = revenueShare ? 1 - revenueShare.recipients.reduce(function (t, r) {
	        return t + (r.donation_percent || 0);
	      }, 0) : 0;
	
	      var hasNotEnabledRevenueSharing = !(_UserStore2.default.getUser() || {}).revenue_sharing_available;
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          "p",
	          null,
	          "Use Eventive Revenue Sharing to automatically share the proceeds from this screening with one or more additional parties.",
	          _react2.default.createElement("br", null),
	          _react2.default.createElement(
	            "strong",
	            null,
	            "Ensure your settings are correct, as modifications will NOT apply retroactively."
	          ),
	          _react2.default.createElement(
	            _infoNotice2.default,
	            { style: { marginTop: 5 } },
	            "Check out our",
	            " ",
	            _react2.default.createElement(
	              "a",
	              {
	                href: "https://help.eventive.org/en/articles/5043252-eventive-revenue-sharing",
	                target: "_blank"
	              },
	              "guide to Eventive Revenue Sharing"
	            ),
	            "."
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(_materialUi.Checkbox, {
	              label: "Enable Revenue Sharing for this screening",
	              style: { display: "inline-block", width: 350 },
	              checked: !hasNotEnabledRevenueSharing && enabled,
	              disabled: hasNotEnabledRevenueSharing,
	              onCheck: function onCheck() {
	                if (enabled && !window.confirm("Are you sure? All revenue sharing will be disabled for this screening and will require a new invitation to reconfigure.")) {
	                  return;
	                }
	
	                _this2.props.onChange(enabled ? null : { recipients: [{}] });
	              }
	            })
	          ),
	          hasNotEnabledRevenueSharing ? _react2.default.createElement(
	            "div",
	            { style: { marginTop: 5 } },
	            "You must first",
	            " ",
	            _react2.default.createElement(
	              _reactRouter.Link,
	              { to: "/revenue_sharing" },
	              "connect Eventive Revenue Sharing"
	            ),
	            " ",
	            "in order to use this feature."
	          ) : revenueShare ? _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(
	              "div",
	              null,
	              _react2.default.createElement(_materialUi.Checkbox, {
	                label: "Allow recipients to view event attendees, sales, and analytics",
	                style: { display: "inline-block", width: 500 },
	                checked: revenueShare.allow_recipients_to_view_event_data,
	                onCheck: function onCheck() {
	                  _this2.props.onChange(_extends({}, revenueShare, {
	                    allow_recipients_to_view_event_data: !revenueShare.allow_recipients_to_view_event_data
	                  }));
	                }
	              })
	            ),
	            !allReady ? _react2.default.createElement(
	              "div",
	              {
	                style: {
	                  marginTop: 10,
	                  marginBottom: 5,
	                  display: "inline-block",
	                  border: "1px solid " + _styles.colors.yellow900,
	                  padding: "4px 10px",
	                  color: _styles.colors.yellow900,
	                  backgroundColor: _styles.colors.yellow50,
	                  borderRadius: 10,
	                  maxWidth: 650
	                }
	              },
	              _react2.default.createElement(
	                "strong",
	                null,
	                "Heads up!"
	              ),
	              " Until every recipient has accepted their revenue sharing invitation, tickets to this event will not be available for sale. Invitations are sent from \"noreply@eventive.org\"."
	            ) : null,
	            _react2.default.createElement(
	              "div",
	              null,
	              _react2.default.createElement(_materialUi.TextField, {
	                floatingLabelText: "Primary revenue recipient (you)",
	                floatingLabelFixed: true,
	                value: "" + _UserStore2.default.getUser().organization,
	                disabled: true
	              }),
	              _react2.default.createElement(_percentField2.default, {
	                style: { marginLeft: 20, width: 150 },
	                floatingLabelText: "Net sales percent",
	                floatingLabelFixed: true,
	                disabled: true,
	                value: primaryPercent
	              }),
	              _react2.default.createElement(_percentField2.default, {
	                style: { marginLeft: 20, width: 150 },
	                floatingLabelText: "Donations percent",
	                floatingLabelFixed: true,
	                disabled: true,
	                value: primaryDonationPercent
	              })
	            ),
	            revenueShare.recipients.map(function (recipient, i) {
	              var acceptedUser = recipient.user;
	              var inviteSent = !!recipient.invite_token;
	
	              return _react2.default.createElement(
	                "div",
	                { key: i },
	                _react2.default.createElement(
	                  "div",
	                  null,
	                  _react2.default.createElement(
	                    "span",
	                    { style: { position: "relative" } },
	                    _react2.default.createElement(_materialUi.TextField, {
	                      floatingLabelText: acceptedUser ? "Revenue share recipient" : inviteSent ? _react2.default.createElement(
	                        "span",
	                        null,
	                        "Invited recipient",
	                        " ",
	                        _react2.default.createElement(
	                          "span",
	                          {
	                            style: {
	                              backgroundColor: _styles.colors.yellow100,
	                              padding: "2px 5px",
	                              borderRadius: 5,
	                              fontWeight: "bold",
	                              color: _styles.colors.yellow900,
	                              fontSize: 14,
	                              verticalAlign: 0
	                            }
	                          },
	                          "Not yet accepted"
	                        )
	                      ) : "Recipient email address to invite",
	                      floatingLabelFixed: true,
	                      value: acceptedUser ? acceptedUser.organization : recipient.invite_email,
	                      disabled: acceptedUser || inviteSent,
	                      onChange: function onChange(e) {
	                        revenueShare.recipients[i].invite_email = e.target.value;
	                        _this2.props.onChange(revenueShare);
	                      },
	                      autoFocus: true
	                    })
	                  ),
	                  _react2.default.createElement(_percentField2.default, {
	                    style: { marginLeft: 20, width: 150 },
	                    floatingLabelText: "Net sales percent",
	                    floatingLabelFixed: true,
	                    placeholder: "0%",
	                    value: recipient.percent,
	                    onChange: function onChange(e) {
	                      revenueShare.recipients[i].percent = e.target.value;
	                      _this2.props.onChange(revenueShare);
	                    }
	                  }),
	                  _react2.default.createElement(_percentField2.default, {
	                    style: { marginLeft: 20, width: 150 },
	                    floatingLabelText: "Donations percent",
	                    floatingLabelFixed: true,
	                    placeholder: "0%",
	                    value: recipient.donation_percent,
	                    onChange: function onChange(e) {
	                      revenueShare.recipients[i].donation_percent = e.target.value;
	                      _this2.props.onChange(revenueShare);
	                    }
	                  }),
	                  revenueShare.recipients.length > 1 ? _react2.default.createElement(
	                    _materialUi.IconButton,
	                    {
	                      tooltip: "Remove",
	                      style: { marginLeft: 10 },
	                      onClick: function onClick() {
	                        if ((recipient.invite_token || recipient.user) && !window.confirm("Are you sure you would like to remove \"" + (recipient.user ? recipient.user.organization : recipient.invite_email) + "\"? The recipient will receive an email notification and will no longer receive revenue sharing from this event.")) {
	                          return;
	                        }
	
	                        revenueShare.recipients.splice(i, 1);
	                        _this2.props.onChange(revenueShare);
	                      }
	                    },
	                    _react2.default.createElement(_delete2.default, null)
	                  ) : null,
	                  recipient.invite_token ? _react2.default.createElement(
	                    _materialUi.IconButton,
	                    {
	                      tooltip: "Copy invite link",
	                      style: { marginLeft: 10 },
	                      onClick: function onClick() {
	                        (0, _copyToClipboard2.default)(window.location.protocol + "//" + window.location.host + "/accept_revenue_sharing_invite?token=" + recipient.invite_token);
	                      }
	                    },
	                    _react2.default.createElement(_contentCopy2.default, null)
	                  ) : null,
	                  !recipient.invite_token && !recipient.user ? _react2.default.createElement(
	                    "div",
	                    {
	                      style: {
	                        display: "inline-block",
	                        marginLeft: revenueShare.recipients.length > 1 ? 10 : 20,
	                        width: 140,
	                        fontSize: "0.8em",
	                        lineHeight: "0.9em",
	                        color: "rgba(33, 33, 33, 0.5)",
	                        fontStyle: "italic"
	                      }
	                    },
	                    "Invite will be sent after you click \"Save changes\" above."
	                  ) : null
	                )
	              );
	            }),
	            _react2.default.createElement(
	              "div",
	              { style: { marginTop: 20 } },
	              _react2.default.createElement(_materialUi.RaisedButton, {
	                label: "Add another recipient",
	                onTouchTap: function onTouchTap() {
	                  revenueShare.recipients.push({});
	                  _this2.props.onChange(revenueShare);
	                }
	              })
	            )
	          ) : null
	        )
	      );
	    }
	  }]);
	
	  return RevenuSharingEditor;
	}(_react2.default.Component);
	
	exports.default = RevenuSharingEditor;
	module.exports = exports["default"];

/***/ }),
/* 2732 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _materialUi = __webpack_require__(576);
	
	var _recurringUpdateOptions = __webpack_require__(2265);
	
	var _recurringUpdateOptions2 = _interopRequireDefault(_recurringUpdateOptions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _class = function (_React$Component) {
	  _inherits(_class, _React$Component);
	
	  function _class(props) {
	    _classCallCheck(this, _class);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(_class).call(this, props));
	
	    _this.state = {
	      option: _recurringUpdateOptions.OPTIONS.CURRENT
	    };
	    return _this;
	  }
	
	  _createClass(_class, [{
	    key: "getStyles",
	    value: function getStyles() {
	      return {
	        actions: {
	          marginTop: 15
	        },
	        dialogTitle: {
	          borderBottom: "none"
	        },
	        dialogActionsContainer: {
	          borderTop: "none"
	        }
	      };
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var styles = this.getStyles();
	      return _react2.default.createElement(
	        _materialUi.Dialog,
	        {
	          title: this.props.title,
	          titleStyle: styles.dialogTitle,
	          actionsContainerStyle: styles.dialogActionsContainer,
	          openImmediately: true,
	          actions: [_react2.default.createElement(_materialUi.FlatButton, { label: "Cancel", onTouchTap: this.props.onRequestClose }), _react2.default.createElement(_materialUi.FlatButton, {
	            primary: true,
	            label: this.props.buttonTitle,
	            onTouchTap: function onTouchTap(e) {
	              return _this2.props.onSave(_this2.state.option);
	            }
	          })],
	          modal: true,
	          open: true,
	          autoDetectWindowHeight: false,
	          autoScrollBodyContent: false,
	          bodyStyle: { overflowY: "visible" },
	          onRequestClose: this.props.onRequestClose
	        },
	        _react2.default.createElement(_recurringUpdateOptions2.default, {
	          value: this.state.option,
	          onChange: function onChange(v) {
	            return _this2.setState({ option: v });
	          }
	        })
	      );
	    }
	  }]);
	
	  return _class;
	}(_react2.default.Component);
	
	exports.default = _class;
	module.exports = exports["default"];

/***/ }),
/* 2733 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _materialUi = __webpack_require__(576);
	
	var _infoNotice = __webpack_require__(1599);
	
	var _infoNotice2 = _interopRequireDefault(_infoNotice);
	
	var _passRuleEditor = __webpack_require__(2734);
	
	var _passRuleEditor2 = _interopRequireDefault(_passRuleEditor);
	
	var _connectToStores = __webpack_require__(1226);
	
	var _connectToStores2 = _interopRequireDefault(_connectToStores);
	
	var _UserStore = __webpack_require__(974);
	
	var _UserStore2 = _interopRequireDefault(_UserStore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PassRulesEditorNonAtomic = function (_React$Component) {
	  _inherits(PassRulesEditorNonAtomic, _React$Component);
	
	  function PassRulesEditorNonAtomic(props) {
	    _classCallCheck(this, PassRulesEditorNonAtomic);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(PassRulesEditorNonAtomic).call(this, props));
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(PassRulesEditorNonAtomic, [{
	    key: "onAdd",
	    value: function onAdd(isFirst) {
	      this.props.onAdd({
	        type: "ticket",
	        target: {},
	        result: {},
	        restrictions: {}
	      });
	    }
	  }, {
	    key: "save",
	    value: function save(i, value) {
	      if (value === null) {
	        // Delete
	        this.props.onDelete(i);
	      } else {
	        this.props.onChange(i, value);
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var isPassBucket = this.props.mode === "pass_bucket";
	      var isMembership = this.props.isMembership;
	      var rules = this.props.passRules;
	
	      var items = rules.map(function (r, i) {
	        return _react2.default.createElement(_passRuleEditor2.default, {
	          key: _this2.props.orderKey + "-" + i,
	          index: i,
	          rule: r,
	          mode: _this2.props.mode,
	          parentId: _this2.props.parentId,
	          parent: _this2.props.parent,
	          eventBucketId: _this2.props.eventBucketId,
	          getEventBucketById: _this2.props.getEventBucketById,
	          getEventBuckets: _this2.props.getEventBuckets,
	          onChange: !isPassBucket ? function (e) {
	            return _this2.save(i, e);
	          } : null,
	          save: function save(e) {
	            return _this2.save(i, e);
	          },
	          canShiftUp: i > 0,
	          canShiftDown: i < rules.length - 1,
	          hasMultipleTicketBuckets: rules.length > 1,
	          shiftPosition: function shiftPosition(e) {
	            _this2.props.onShiftPosition(i, e);
	          },
	          isMembership: isMembership
	        });
	      });
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        this.props.showHeader ? _react2.default.createElement(
	          "h2",
	          null,
	          "$",
	          isMembership ? "membership" : "pass",
	          " rules"
	        ) : null,
	        _UserStore2.default.hasPermission("edit_pass_bucket") ? _react2.default.createElement(
	          "p",
	          null,
	          "Use these options to set custom discount rules for particular",
	          " ",
	          this.props.mode === "pass_bucket" ? "events" : "pass types",
	          ".",
	          this.props.mode !== "pass_bucket" ? _react2.default.createElement(
	            "div",
	            { style: { fontWeight: "bold" } },
	            "If any rules are added here, all rules configured via pass bucket settings will be ignored for this event."
	          ) : null,
	          _react2.default.createElement(
	            _infoNotice2.default,
	            { style: { marginTop: 5 } },
	            "Check out our",
	            " ",
	            _react2.default.createElement(
	              "a",
	              {
	                href: "http://help.eventive.org/passes/create-pass-rules",
	                target: "_blank"
	              },
	              "guide to creating ",
	              isMembership ? "membership" : "pass",
	              " rules"
	            ),
	            "."
	          )
	        ) : _react2.default.createElement(
	          "p",
	          null,
	          "Custom discount rules"
	        ),
	        items,
	        _UserStore2.default.hasPermission("edit_pass_bucket") ? _react2.default.createElement(_materialUi.RaisedButton, {
	          label: "Add new rule",
	          onTouchTap: this.onAdd.bind(this, rules.length === 0)
	        }) : null
	      );
	    }
	  }], [{
	    key: "getStores",
	    value: function getStores() {
	      return [_UserStore2.default];
	    }
	  }, {
	    key: "getPropsFromStores",
	    value: function getPropsFromStores() {
	      return {};
	    }
	  }]);
	
	  return PassRulesEditorNonAtomic;
	}(_react2.default.Component);
	
	exports.default = (0, _connectToStores2.default)(PassRulesEditorNonAtomic);
	module.exports = exports["default"];

/***/ }),
/* 2734 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _get = __webpack_require__(1004);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _set = __webpack_require__(1188);
	
	var _set2 = _interopRequireDefault(_set);
	
	var _isEqual = __webpack_require__(924);
	
	var _isEqual2 = _interopRequireDefault(_isEqual);
	
	var _materialUi = __webpack_require__(576);
	
	var _reactRouter = __webpack_require__(486);
	
	var _reactSelect = __webpack_require__(953);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	var _juration = __webpack_require__(1772);
	
	var _juration2 = _interopRequireDefault(_juration);
	
	var _currencyField = __webpack_require__(1747);
	
	var _currencyField2 = _interopRequireDefault(_currencyField);
	
	var _injectedSelect = __webpack_require__(1874);
	
	var _injectedSelect2 = _interopRequireDefault(_injectedSelect);
	
	var _datetimeField = __webpack_require__(2061);
	
	var _datetimeField2 = _interopRequireDefault(_datetimeField);
	
	var _durationField = __webpack_require__(2054);
	
	var _durationField2 = _interopRequireDefault(_durationField);
	
	var _connectToStores = __webpack_require__(1226);
	
	var _connectToStores2 = _interopRequireDefault(_connectToStores);
	
	var _UserStore = __webpack_require__(974);
	
	var _UserStore2 = _interopRequireDefault(_UserStore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PassRuleEditor = function (_React$Component) {
	  _inherits(PassRuleEditor, _React$Component);
	
	  function PassRuleEditor(props) {
	    _classCallCheck(this, PassRuleEditor);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(PassRuleEditor).call(this, props));
	
	    _this.state = {
	      dirty: false,
	      isSaving: false,
	      showTimeRestrictionsEditor: false,
	      showUseTimeRestrictionsEditor: false,
	      showAdvanceEditor: false,
	      ticketBucketsPhysicalVirtualState: "",
	      values: {},
	      isEditMode: false
	    };
	
	    _this.onChange = _this.onChange.bind(_this);
	    _this.onChangeValue = _this.onChangeValue.bind(_this);
	    _this.onShowTimeRestrictionsCheck = _this.onShowTimeRestrictionsCheck.bind(_this);
	    _this.onShowUseTimeRestrictionsCheck = _this.onShowUseTimeRestrictionsCheck.bind(_this);
	    _this.save = _this.save.bind(_this);
	    _this.delete = _this.delete.bind(_this);
	    _this.toggleEditMode = _this.toggleEditMode.bind(_this);
	    return _this;
	  }
	
	  _createClass(PassRuleEditor, [{
	    key: "getStyles",
	    value: function getStyles() {
	      return {
	        rule: {
	          border: "1px solid #ccc",
	          padding: 20,
	          margin: "20px 0"
	        },
	        actions: {
	          marginTop: 20
	        },
	        firstHeader: {
	          margin: "0 0 10px"
	        },
	        header: {
	          margin: "20px 0 10px"
	        }
	      };
	    }
	  }, {
	    key: "onChange",
	    value: function onChange(id, e, checked) {
	      this.onChangeValue(id, typeof checked !== "undefined" ? !(0, _get2.default)(this.state.values, id) : e.target.value);
	    }
	  }, {
	    key: "onChangeValue",
	    value: function onChangeValue(id, value) {
	      var values = Object.assign({}, this.state.values);
	      (0, _set2.default)(values, id, value);
	      this.setState({
	        dirty: true,
	        values: values
	      });
	      if (this.props.onChange) {
	        this.props.onChange(values);
	      }
	    }
	  }, {
	    key: "onShowTimeRestrictionsCheck",
	    value: function onShowTimeRestrictionsCheck(e, checked) {
	      this.setState({ showTimeRestrictionsEditor: checked });
	      if (!checked) {
	        this.onChangeValue("restrictions.time.start_after", null);
	        this.onChangeValue("restrictions.time.end_before", null);
	        this.onChangeValue("restrictions.time.begin_within", null);
	      }
	    }
	  }, {
	    key: "onShowUseTimeRestrictionsCheck",
	    value: function onShowUseTimeRestrictionsCheck(e, checked) {
	      this.setState({ showUseTimeRestrictionsEditor: checked });
	      if (!checked) {
	        this.onChangeValue("restrictions.use_time.use_after", null);
	        this.onChangeValue("restrictions.use_time.use_before", null);
	      }
	    }
	  }, {
	    key: "save",
	    value: function save() {
	      this.setState({ isSaving: true, isEditMode: false });
	      this.props.save(this.state.values);
	    }
	  }, {
	    key: "delete",
	    value: function _delete() {
	      if (window.confirm("Are you sure?")) {
	        this.props.save(null);
	      }
	    }
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.componentWillReceiveProps(this.props);
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(newProps) {
	      var rule = newProps.rule;
	
	      if (!this.state.dirty || this.state.isSaving) {
	        this.setState({
	          rule: rule,
	          dirty: false,
	          isSaving: false,
	          ticketBucketsPhysicalVirtualState: this.state.ticketBucketsPhysicalVirtualState || ((0, _get2.default)(rule, "target.ticket_bucket") === "*" ? "*" : (0, _get2.default)(rule, "target.event.type")) || "*",
	          values: rule ? {
	            name: rule.name || "",
	            type: rule.type || "ticket",
	            target: rule.target,
	            global_target: rule.global_target,
	            result: rule.result,
	            restrictions: rule.restrictions
	          } : {}
	        });
	      }
	    }
	  }, {
	    key: "toggleEditMode",
	    value: function toggleEditMode() {
	      this.setState(function (prev) {
	        return { isEditMode: !prev.isEditMode };
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props;
	      var mode = _props.mode;
	      var index = _props.index;
	      var _state$values = this.state.values;
	      var type = _state$values.type;
	      var name = _state$values.name;
	
	      var isMembership = this.props.isMembership;
	      var passOrMembership = isMembership ? 'membership' : 'pass';
	      var passesOrMemberships = isMembership ? 'memberships' : 'passes';
	
	      var applyToAllTicketBuckets = (0, _get2.default)(this.state.values, "target.ticket_bucket") === "*";
	      var applyToAllPassBuckets = (0, _get2.default)(this.state.values, "target.pass_bucket") === "*";
	      var applyToAllItemBuckets = (0, _get2.default)(this.state.values, "target.item_bucket") === "*";
	      var styles = this.getStyles();
	
	      var eventBucketIds = (0, _get2.default)(this.state.values, "global_target.event_bucket.id", [this.props.eventBucketId]);
	      if ((0, _get2.default)(this.state.values, "global_target") === "*") {
	        eventBucketIds = this.props.getEventBuckets().map(function (b) {
	          return b.id;
	        });
	      }
	
	      var creditsEnabled = (this.props.getEventBucketById(this.props.eventBucketId) || {}).credits_enabled;
	
	      if (!this.state.isEditMode) {
	        var credits = (0, _get2.default)(this.state.values, "result.credits", 0);
	        var percentOff = (0, _get2.default)(this.state.values, "result.price.percent_off", 0);
	        var dollarsOff = ((0, _get2.default)(this.state.values, "result.price.cents_off", 0) / 100).toFixed(2);
	
	        // const restrictions = [];
	        var useRestrictions = [];
	        var otherRestrictions = [];
	
	        var totalUses = (0, _get2.default)(this.state.values, "restrictions.uses.total");
	        var disallowConcurrent = (0, _get2.default)(this.state.values, "restrictions.uses.disallow_concurrent", false);
	        var maxPerFilm = (0, _get2.default)(this.state.values, "restrictions.uses.max_per_film");
	        var maxPerEvent = (0, _get2.default)(this.state.values, "restrictions.uses.max_per_event");
	        var maxAdvanceReservations = (0, _get2.default)(this.state.values, "restrictions.uses.max_advance_reservations");
	        var isGlobal = (0, _get2.default)(this.state.values, "global_target", false);
	        var globalTargets = (0, _get2.default)(this.state.values, "global_target.event_bucket.id", []);
	
	        if (totalUses) {
	          if (type === "pass") {
	            useRestrictions.push("Total of " + totalUses + " target " + passesOrMemberships + " per " + passOrMembership);
	          } else if (type === "item") {
	            useRestrictions.push("Total of " + totalUses + " items per " + passOrMembership);
	          } else {
	            useRestrictions.push("Total of " + totalUses + " tickets per " + passOrMembership);
	          }
	        }
	
	        if (disallowConcurrent) {
	          useRestrictions.push("Disallow concurrent uses (i.e. multiple events at the same time)");
	        }
	
	        if ((0, _get2.default)(this.state.values, "restrictions.uses.disallow_same", false)) {
	          useRestrictions.push("Only allow one ticket per event per " + passOrMembership);
	        }
	
	        if (maxPerFilm === 1) {
	          useRestrictions.push("Only allow one ticket per film per " + passOrMembership + " (across physical and virtual events)");
	        }
	
	        if (maxPerEvent) {
	          useRestrictions.push(maxPerEvent + " tickets per event per " + passOrMembership);
	        }
	
	        if ((0, _get2.default)(this.state.values, "restrictions.rush_line_only", false)) {
	          otherRestrictions.push("Only allow Rush Line ticket orders (no advance reservation)");
	        }
	
	        if ((0, _get2.default)(this.state.values, "restrictions.box_office_only", false)) {
	          otherRestrictions.push("Only allow Box Office ticket orders (no online reservation)");
	        }
	
	        // Date/time restrictions
	        var startAfter = (0, _get2.default)(this.state.values, "restrictions.time.start_after");
	        var endBefore = (0, _get2.default)(this.state.values, "restrictions.time.end_before");
	        var beginWithin = (0, _get2.default)(this.state.values, "restrictions.time.begin_within");
	
	        if (startAfter) {
	          otherRestrictions.push("Event must start after " + new Date(startAfter).toLocaleString());
	        }
	
	        if (endBefore) {
	          otherRestrictions.push("Event must end before " + new Date(endBefore).toLocaleString());
	        }
	
	        if (beginWithin) {
	          var timeStr = _juration2.default.stringify(beginWithin / 1000);
	          otherRestrictions.push("Event must begin within " + timeStr);
	        }
	
	        // Use time restrictions
	        var useAfter = (0, _get2.default)(this.state.values, "restrictions.use_time.use_after");
	        var useBefore = (0, _get2.default)(this.state.values, "restrictions.use_time.use_before");
	
	        if (useAfter) {
	          otherRestrictions.push("Can only be used after " + new Date(useAfter).toLocaleString());
	        }
	
	        if (useBefore) {
	          otherRestrictions.push("Can only be used before " + new Date(useBefore).toLocaleString());
	        }
	
	        if (maxAdvanceReservations) {
	          otherRestrictions.push("Restrict the number of advance reservations to " + maxAdvanceReservations);
	        }
	
	        if ((0, _get2.default)(this.state.values, "restrictions.bypass_geographic_restrictions", false)) {
	          otherRestrictions.push("Bypasses geographic restrictions when unlocking virtual screenings");
	        }
	
	        return _react2.default.createElement(
	          "div",
	          { style: styles.rule },
	          _react2.default.createElement(
	            "h2",
	            null,
	            name || (isMembership ? 'Membership' : 'Pass') + " Rule " + (index + 1)
	          ),
	          _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(
	              "h3",
	              null,
	              "Type"
	            ),
	            _react2.default.createElement(
	              "p",
	              null,
	              type === "item" ? "Item orders (i.e. for buying items)" : type === "ticket" ? "Ticket orders (i.e. for buying tickets)" : type === "pass" ? "Pass orders (i.e. for buying new " + passesOrMemberships + ")" : type === "credit" ? "Auto-issue credits on " + passOrMembership + " purchase" : "N/A"
	            )
	          ),
	          type !== "credit" ? _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(
	              "h3",
	              null,
	              "Target"
	            ),
	            type === "ticket" ? _react2.default.createElement(
	              "div",
	              null,
	              applyToAllTicketBuckets || (0, _get2.default)(this.state.values, "target.event.type") ? _react2.default.createElement(
	                "p",
	                null,
	                "Apply to all",
	                " ",
	                (0, _get2.default)(this.state.values, "target.event.type") === "physical" ? "physical" : (0, _get2.default)(this.state.values, "target.event.type") === "virtual" ? "virtual" : "physical & virtual",
	                " ",
	                "ticket buckets",
	                (0, _get2.default)(this.state.values, "target.exclude_ticket_bucket.id", []).length > 0 && " (excluding " + (0, _get2.default)(this.state.values, "target.exclude_ticket_bucket.id", []).length + " ticket bucket" + ((0, _get2.default)(this.state.values, "target.exclude_ticket_bucket.id", []).length > 1 ? "s" : "") + ")",
	                (0, _get2.default)(this.state.values, "target.exclude_tag.id", []).length > 0 && " (excluding " + (0, _get2.default)(this.state.values, "target.exclude_tag.id", []).length + " tag" + ((0, _get2.default)(this.state.values, "target.exclude_tag.id", []).length > 1 ? "s" : "") + ")"
	              ) : _react2.default.createElement(
	                "ul",
	                {
	                  style: { listStyle: "none", paddingLeft: 0, margin: 0 }
	                },
	                (0, _get2.default)(this.state.values, "target.ticket_bucket.id", []).length > 0 && _react2.default.createElement(
	                  "li",
	                  null,
	                  (0, _get2.default)(this.state.values, "target.ticket_bucket.id", []).length,
	                  " ",
	                  "ticket bucket",
	                  (0, _get2.default)(this.state.values, "target.ticket_bucket.id", []).length > 1 ? "s" : ""
	                ),
	                (0, _get2.default)(this.state.values, "target.venue.id", []).length > 0 && _react2.default.createElement(
	                  "li",
	                  null,
	                  (0, _get2.default)(this.state.values, "target.venue.id", []).length,
	                  " ",
	                  "venue",
	                  (0, _get2.default)(this.state.values, "target.venue.id", []).length > 1 ? "s" : ""
	                ),
	                (0, _get2.default)(this.state.values, "target.tag.id", []).length > 0 && _react2.default.createElement(
	                  "li",
	                  null,
	                  (0, _get2.default)(this.state.values, "target.tag.id", []).length,
	                  " ",
	                  "tag",
	                  (0, _get2.default)(this.state.values, "target.tag.id", []).length > 1 ? "s" : ""
	                )
	              )
	            ) : type === "item" ? _react2.default.createElement(
	              "p",
	              null,
	              applyToAllItemBuckets ? "Apply to all item buckets" : (0, _get2.default)(this.state.values, "target.item_bucket.id", []).length + " item bucket" + ((0, _get2.default)(this.state.values, "target.item_bucket.id", []).length > 1 ? "s" : "")
	            ) : _react2.default.createElement(
	              "p",
	              null,
	              applyToAllPassBuckets ? "Apply to all " + passOrMembership + " buckets" : (0, _get2.default)(this.state.values, "target.pass_bucket.id", []).length + " pass bucket" + ((0, _get2.default)(this.state.values, "target.pass_bucket.id", []).length > 1 ? "s" : "")
	            )
	          ) : null,
	          _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(
	              "h3",
	              null,
	              "Result"
	            ),
	            type === "credit" ? _react2.default.createElement(
	              "p",
	              null,
	              "Issue ",
	              credits,
	              " credits"
	            ) : _react2.default.createElement(
	              "ul",
	              {
	                style: {
	                  listStyle: "none",
	                  paddingLeft: 0
	                }
	              },
	              percentOff && percentOff > 0 ? _react2.default.createElement(
	                "li",
	                null,
	                percentOff,
	                "% off"
	              ) : null,
	              dollarsOff && dollarsOff > 0 ? _react2.default.createElement(
	                "li",
	                null,
	                "$",
	                dollarsOff,
	                " off"
	              ) : null
	            )
	          ),
	          useRestrictions.length > 0 ? _react2.default.createElement(
	            "div",
	            { style: { marginTop: 16 } },
	            _react2.default.createElement(
	              "h3",
	              {
	                style: {
	                  margin: "0 0 8px",
	                  fontSize: "14px",
	                  fontWeight: "bold"
	                }
	              },
	              "Use restrictions"
	            ),
	            _react2.default.createElement(
	              "ul",
	              { style: { paddingLeft: 20, margin: 0 } },
	              useRestrictions.map(function (restriction, index) {
	                return _react2.default.createElement(
	                  "li",
	                  { key: index, style: { fontSize: "13px", marginBottom: 4 } },
	                  restriction
	                );
	              })
	            )
	          ) : null,
	          otherRestrictions.length > 0 ? _react2.default.createElement(
	            "div",
	            { style: { marginTop: 16 } },
	            _react2.default.createElement(
	              "h3",
	              {
	                style: {
	                  margin: "0 0 8px",
	                  fontSize: "14px",
	                  fontWeight: "bold"
	                }
	              },
	              "Other restrictions"
	            ),
	            _react2.default.createElement(
	              "ul",
	              { style: { paddingLeft: 20, margin: 0 } },
	              otherRestrictions.map(function (restriction, index) {
	                return _react2.default.createElement(
	                  "li",
	                  { key: index, style: { fontSize: "13px", marginBottom: 4 } },
	                  restriction
	                );
	              })
	            )
	          ) : null,
	          isGlobal && _react2.default.createElement(
	            "div",
	            { style: { marginTop: 16 } },
	            _react2.default.createElement(
	              "h3",
	              null,
	              "Global rule"
	            ),
	            _react2.default.createElement(
	              "p",
	              null,
	              isGlobal === "*" ? "Applies to all event buckets" : "Applies to " + globalTargets.length + " event bucket" + (globalTargets.length > 1 ? "s" : "")
	            )
	          ),
	          _react2.default.createElement(_materialUi.RaisedButton, {
	            label: "Edit",
	            onClick: this.toggleEditMode,
	            style: { marginTop: 16 }
	          }),
	          mode === "pass_bucket" && _UserStore2.default.hasPermission("edit_pass_bucket") && [_react2.default.createElement(_materialUi.RaisedButton, {
	            label: "\u25B2",
	            key: "shiftUp-view",
	            style: { minWidth: 30, marginLeft: 7 },
	            disabled: !this.props.canShiftUp,
	            onTouchTap: function onTouchTap() {
	              return _this2.props.shiftPosition(-1);
	            }
	          }), _react2.default.createElement(_materialUi.RaisedButton, {
	            label: "\u25BC",
	            key: "shiftDown-view",
	            style: { minWidth: 30, marginLeft: 7 },
	            disabled: !this.props.canShiftDown,
	            onTouchTap: function onTouchTap() {
	              return _this2.props.shiftPosition(1);
	            }
	          })]
	        );
	      }
	
	      return _react2.default.createElement(
	        "div",
	        { style: styles.rule },
	        _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement(_materialUi.TextField, {
	            value: (0, _get2.default)(this.state.values, "name", ""),
	            floatingLabelText: "Rule name (optional)",
	            floatingLabelFixed: true,
	            onChange: function onChange(e) {
	              return _this2.onChangeValue("name", e.target.value);
	            },
	            style: { width: "100%", marginBottom: 20 },
	            disabled: !_UserStore2.default.hasPermission("edit_pass_bucket")
	          }),
	          mode === "pass_bucket" ? _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(
	              "h3",
	              { style: styles.firstHeader },
	              "Type"
	            ),
	            _react2.default.createElement(
	              _materialUi.RadioButtonGroup,
	              {
	                name: "mailing_type",
	                valueSelected: this.state.values.type,
	                onChange: function onChange(e, v) {
	                  if (v === "ticket") {
	                    _this2.onChangeValue("target.pass_bucket", undefined);
	                  }
	                  _this2.onChangeValue("type", v);
	                }
	              },
	              [_react2.default.createElement(_materialUi.RadioButton, {
	                value: "ticket",
	                label: "Ticket orders (i.e. for buying tickets)",
	                disabled: !_UserStore2.default.hasPermission("edit_pass_bucket")
	              }), _react2.default.createElement(_materialUi.RadioButton, {
	                value: "item",
	                label: "Item orders (i.e. for buying items)",
	                disabled: !_UserStore2.default.hasPermission("edit_pass_bucket")
	              }), _react2.default.createElement(_materialUi.RadioButton, {
	                value: "pass",
	                label: "Pass orders (i.e. for buying new " + (isMembership ? "memberships" : "passes") + ")",
	                disabled: !_UserStore2.default.hasPermission("edit_pass_bucket")
	              }), creditsEnabled ? _react2.default.createElement(_materialUi.RadioButton, {
	                value: "credit",
	                label: "Auto-issue credits on " + (isMembership ? "membership" : "pass") + " purchase",
	                disabled: !_UserStore2.default.hasPermission("edit_pass_bucket")
	              }) : null].filter(function (b) {
	                return !!b;
	              })
	            )
	          ) : null,
	          type === "credit" ? _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(
	              "h3",
	              {
	                style: Object.assign({}, mode === "pass_bucket" ? styles.header : styles.firstHeader, { marginBottom: -10 })
	              },
	              "Result"
	            ),
	            _react2.default.createElement(_materialUi.TextField, {
	              value: (0, _get2.default)(this.state.values, "result.credits", ""),
	              floatingLabelText: "# of credits to auto-issue",
	              floatingLabelFixed: true,
	              hintText: "0",
	              onChange: function onChange(e) {
	                return _this2.onChangeValue("result.credits", e.target.value);
	              },
	              style: { width: 200 }
	            })
	          ) : _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(
	              "h3",
	              {
	                style: mode === "pass_bucket" ? styles.header : styles.firstHeader
	              },
	              "Target"
	            ),
	            mode === "pass_bucket" && type === "ticket" ? _react2.default.createElement(
	              "div",
	              null,
	              _react2.default.createElement(_materialUi.Checkbox, {
	                checked: applyToAllTicketBuckets || (0, _get2.default)(this.state.values, "target.event.type"),
	                inputStyle: { width: 100 },
	                label: _react2.default.createElement(
	                  "span",
	                  null,
	                  "Apply to all",
	                  " ",
	                  _react2.default.createElement(
	                    "span",
	                    {
	                      style: {
	                        display: "inline-block",
	                        width: 150,
	                        margin: "-20px 10px",
	                        verticalAlign: 7
	                      }
	                    },
	                    _react2.default.createElement(_reactSelect2.default, {
	                      clearable: false,
	                      disabled: !(applyToAllTicketBuckets || (0, _get2.default)(this.state.values, "target.event.type")),
	                      value: this.state.ticketBucketsPhysicalVirtualState,
	                      options: [{ label: "Physical & Virtual", value: "*" }, { label: "Physical", value: "physical" }, { label: "Virtual", value: "virtual" }],
	                      onChange: function onChange(e) {
	                        _this2.setState({
	                          ticketBucketsPhysicalVirtualState: e.value
	                        });
	                        if (applyToAllTicketBuckets || (0, _get2.default)(_this2.state.values, "target.event.type")) {
	                          if (e.value === "*") {
	                            _this2.onChangeValue("target.event", undefined);
	                            _this2.onChangeValue("target.ticket_bucket", "*");
	                          } else {
	                            _this2.onChangeValue("target.ticket_bucket", undefined);
	                            _this2.onChangeValue("target.event.type", e.value);
	                          }
	                        }
	                      }
	                    })
	                  ),
	                  "ticket buckets"
	                ),
	                onCheck: function onCheck(e) {
	                  var checked = !(applyToAllTicketBuckets || (0, _get2.default)(_this2.state.values, "target.event.type"));
	
	                  if (checked) {
	                    if (_this2.state.ticketBucketsPhysicalVirtualState === "*") {
	                      _this2.onChangeValue("target.event", undefined);
	                      _this2.onChangeValue("target.ticket_bucket", "*");
	                    } else {
	                      _this2.onChangeValue("target.ticket_bucket", undefined);
	                      _this2.onChangeValue("target.event", {
	                        type: _this2.state.ticketBucketsPhysicalVirtualState
	                      });
	                    }
	                  } else {
	                    _this2.onChangeValue("target.ticket_bucket", undefined);
	                    _this2.onChangeValue("target.event", undefined);
	                  }
	                },
	                disabled: !_UserStore2.default.hasPermission("edit_pass_bucket")
	              }),
	              !applyToAllTicketBuckets && !(0, _get2.default)(this.state.values, "target.event.type") ? _react2.default.createElement(
	                "div",
	                null,
	                _react2.default.createElement(_injectedSelect2.default, {
	                  key: "ticket_buckets_apply",
	                  style: { marginBottom: 10 },
	                  value: (0, _get2.default)(this.state.values, "target.ticket_bucket.id", []),
	                  types: ["ticket_buckets"],
	                  multi: true,
	                  label: "Ticket buckets",
	                  labelFormatter: function labelFormatter(b) {
	                    return b.event.name + " \u2013 " + b.name + ((0, _get2.default)(_this2.state.values, "global_target") ? " (" + (_this2.props.getEventBucketById(b.event.event_bucket) && _this2.props.getEventBucketById(b.event.event_bucket).name) + ")" : "");
	                  },
	                  eventBucketId: eventBucketIds,
	                  onChange: function onChange(selected) {
	                    return _this2.onChangeValue("target.ticket_bucket.id", selected);
	                  },
	                  disabled: !_UserStore2.default.hasPermission("edit_pass_bucket")
	                }),
	                _react2.default.createElement(_injectedSelect2.default, {
	                  key: "venues_apply",
	                  value: (0, _get2.default)(this.state.values, "target.venue.id", []),
	                  types: ["venues"],
	                  multi: true,
	                  label: "Venues",
	                  labelFormatter: function labelFormatter(v) {
	                    return v.name + ((0, _get2.default)(_this2.state.values, "global_target") ? " (" + (_this2.props.getEventBucketById(v.event_bucket) && _this2.props.getEventBucketById(v.event_bucket).name) + ")" : "");
	                  },
	                  eventBucketId: eventBucketIds,
	                  onChange: function onChange(selected) {
	                    return _this2.onChangeValue("target.venue.id", selected);
	                  },
	                  disabled: !_UserStore2.default.hasPermission("edit_pass_bucket")
	                }),
	                _react2.default.createElement(_injectedSelect2.default, {
	                  key: "tags_apply",
	                  value: (0, _get2.default)(this.state.values, "target.tag.id", []),
	                  types: ["tags"],
	                  multi: true,
	                  label: "Tags",
	                  labelFormatter: function labelFormatter(t) {
	                    return t.name + ((0, _get2.default)(_this2.state.values, "global_target") ? " (" + (_this2.props.getEventBucketById(t.event_bucket) && _this2.props.getEventBucketById(t.event_bucket).name) + ")" : "");
	                  },
	                  eventBucketId: eventBucketIds,
	                  onChange: function onChange(selected) {
	                    return _this2.onChangeValue("target.tag.id", selected);
	                  },
	                  disabled: !_UserStore2.default.hasPermission("edit_pass_bucket")
	                })
	              ) : _react2.default.createElement(
	                "div",
	                null,
	                _react2.default.createElement(_injectedSelect2.default, {
	                  key: "ticket_buckets_exclude",
	                  value: (0, _get2.default)(this.state.values, "target.exclude_ticket_bucket.id", []),
	                  types: ["ticket_buckets"],
	                  multi: true,
	                  label: "Ticket buckets to exclude",
	                  placeholder: "None excluded",
	                  labelFormatter: function labelFormatter(b) {
	                    return b.event.name + " \u2013 " + b.name + ((0, _get2.default)(_this2.state.values, "global_target") ? " (" + (_this2.props.getEventBucketById(b.event.event_bucket) && _this2.props.getEventBucketById(b.event.event_bucket).name) + ")" : "");
	                  },
	                  eventBucketId: eventBucketIds,
	                  onChange: function onChange(selected) {
	                    return _this2.onChangeValue("target.exclude_ticket_bucket.id", selected);
	                  },
	                  disabled: !_UserStore2.default.hasPermission("edit_pass_bucket")
	                }),
	                _react2.default.createElement(_injectedSelect2.default, {
	                  key: "tags_exclude",
	                  value: (0, _get2.default)(this.state.values, "target.exclude_tag.id", []),
	                  types: ["tags"],
	                  multi: true,
	                  label: "Tags to exclude",
	                  labelFormatter: function labelFormatter(t) {
	                    return t.name + ((0, _get2.default)(_this2.state.values, "global_target") ? " (" + (_this2.props.getEventBucketById(t.event_bucket) && _this2.props.getEventBucketById(t.event_bucket).name) + ")" : "");
	                  },
	                  eventBucketId: eventBucketIds,
	                  onChange: function onChange(selected) {
	                    return _this2.onChangeValue("target.exclude_tag.id", selected);
	                  },
	                  disabled: !_UserStore2.default.hasPermission("edit_pass_bucket")
	                })
	              )
	            ) : mode === "pass_bucket" && type === "item" ? _react2.default.createElement(
	              "div",
	              null,
	              _react2.default.createElement(_materialUi.Checkbox, {
	                checked: applyToAllItemBuckets,
	                label: "Apply to all item buckets",
	                onCheck: function onCheck(e, checked) {
	                  return _this2.onChangeValue("target.item_bucket", checked ? "*" : {});
	                },
	                disabled: !_UserStore2.default.hasPermission("edit_pass_bucket")
	              }),
	              !applyToAllItemBuckets ? _react2.default.createElement(_injectedSelect2.default, {
	                key: "item_bucket_apply",
	                value: (0, _get2.default)(this.state.values, "target.item_bucket.id", []),
	                types: ["item_buckets"],
	                multi: true,
	                label: "Item buckets",
	                labelFormatter: function labelFormatter(b) {
	                  return b.name;
	                },
	                eventBucketId: eventBucketIds,
	                onChange: function onChange(selected) {
	                  return _this2.onChangeValue("target.item_bucket.id", selected);
	                },
	                disabled: !_UserStore2.default.hasPermission("edit_pass_bucket")
	              }) : null
	            ) : _react2.default.createElement(
	              "div",
	              null,
	              _react2.default.createElement(_materialUi.Checkbox, {
	                checked: applyToAllPassBuckets,
	                label: "Apply to all " + (isMembership ? "memberships" : "pass buckets"),
	                onCheck: function onCheck(e, checked) {
	                  return _this2.onChangeValue("target.pass_bucket", checked ? "*" : {});
	                },
	                disabled: !_UserStore2.default.hasPermission("edit_pass_bucket")
	              }),
	              !applyToAllPassBuckets ? _react2.default.createElement(_injectedSelect2.default, {
	                key: "pass_bucket_apply",
	                value: (0, _get2.default)(this.state.values, "target.pass_bucket.id", []),
	                types: ["pass_buckets"],
	                multi: true,
	                label: (isMembership ? 'Membership' : 'Pass') + " buckets",
	                labelFormatter: function labelFormatter(b) {
	                  return b.name;
	                },
	                eventBucketId: eventBucketIds,
	                onChange: function onChange(selected) {
	                  return _this2.onChangeValue("target.pass_bucket.id", selected);
	                },
	                disabled: !_UserStore2.default.hasPermission("edit_pass_bucket")
	              }) : null
	            ),
	            _react2.default.createElement(
	              "h3",
	              {
	                style: Object.assign({}, styles.header, { marginBottom: -10 })
	              },
	              "Result"
	            ),
	            _react2.default.createElement(_materialUi.TextField, {
	              value: (0, _get2.default)(this.state.values, "result.price.percent_off", ""),
	              floatingLabelText: "Percent off (0 - 100)",
	              onChange: function onChange(e) {
	                return _this2.onChangeValue("result.price.percent_off", e.target.value);
	              },
	              floatingLabelFixed: true,
	              hintText: "0",
	              type: "number",
	              style: { width: 200 },
	              disabled: !_UserStore2.default.hasPermission("edit_pass_bucket")
	            }),
	            _react2.default.createElement(_currencyField2.default, {
	              value: (0, _get2.default)(this.state.values, "result.price.cents_off", ""),
	              floatingLabelText: "Dollars off",
	              floatingLabelFixed: true,
	              hintText: "$0.00",
	              onChange: function onChange(e) {
	                return _this2.onChangeValue("result.price.cents_off", e.target.value);
	              },
	              style: { marginLeft: 7, width: 200 },
	              disabled: !_UserStore2.default.hasPermission("edit_pass_bucket")
	            }),
	            _react2.default.createElement(
	              "h3",
	              { style: styles.header },
	              "Use restrictions"
	            ),
	            type === "pass" ? _react2.default.createElement(
	              "div",
	              { style: { marginTop: -20 } },
	              _react2.default.createElement(_materialUi.TextField, {
	                value: (0, _get2.default)(this.state.values, "restrictions.uses.total", ""),
	                floatingLabelText: "Number of target " + passesOrMemberships + " per " + passOrMembership,
	                floatingLabelFixed: true,
	                hintText: "Unlimited",
	                onChange: function onChange(e) {
	                  return _this2.onChangeValue("restrictions.uses.total", e.target.value);
	                },
	                type: "number",
	                style: { width: 275 }
	              })
	            ) : type === "item" ? _react2.default.createElement(
	              "div",
	              { style: { marginTop: -20 } },
	              _react2.default.createElement(_materialUi.TextField, {
	                value: (0, _get2.default)(this.state.values, "restrictions.uses.total", ""),
	                floatingLabelText: "Number of target items per " + passOrMembership,
	                floatingLabelFixed: true,
	                hintText: "Unlimited",
	                onChange: function onChange(e) {
	                  return _this2.onChangeValue("restrictions.uses.total", e.target.value);
	                },
	                type: "number",
	                style: { width: 275 }
	              })
	            ) : _react2.default.createElement(
	              "div",
	              null,
	              _react2.default.createElement(_materialUi.Checkbox, {
	                checked: (0, _get2.default)(this.state.values, "restrictions.uses.disallow_concurrent", false),
	                label: "Disallow concurrent uses (i.e. multiple events at the same time)",
	                onCheck: this.onChange.bind(null, "restrictions.uses.disallow_concurrent"),
	                disabled: !_UserStore2.default.hasPermission("edit_pass_bucket")
	              }),
	              _react2.default.createElement(_materialUi.Checkbox, {
	                checked: (0, _get2.default)(this.state.values, "restrictions.uses.disallow_same", false),
	                label: "Only allow one ticket per event per " + (isMembership ? "membership" : "pass"),
	                onCheck: this.onChange.bind(null, "restrictions.uses.disallow_same"),
	                disabled: !_UserStore2.default.hasPermission("edit_pass_bucket")
	              }),
	              mode === "pass_bucket" ? _react2.default.createElement(_materialUi.Checkbox, {
	                checked: (0, _get2.default)(this.state.values, "restrictions.uses.max_per_film") === 1,
	                label: "Only allow one ticket per film per " + (isMembership ? "membership" : "pass") + " (across physical and virtual events)",
	                onCheck: function onCheck() {
	                  return _this2.onChangeValue("restrictions.uses.max_per_film", _this2.state.values.restrictions.uses.max_per_film === 1 ? undefined : 1);
	                },
	                disabled: !_UserStore2.default.hasPermission("edit_pass_bucket")
	              }) : null,
	              mode === "pass_bucket" ? _react2.default.createElement(_materialUi.TextField, {
	                value: (0, _get2.default)(this.state.values, "restrictions.uses.total", ""),
	                floatingLabelText: "Total number of tickets per " + (isMembership ? "membership" : "pass"),
	                floatingLabelFixed: true,
	                hintText: "Unlimited",
	                onChange: function onChange(e) {
	                  return _this2.onChangeValue("restrictions.uses.total", e.target.value);
	                },
	                type: "number",
	                style: { width: 250 },
	                disabled: !_UserStore2.default.hasPermission("edit_pass_bucket")
	              }) : null,
	              !(0, _get2.default)(this.state.values, "restrictions.uses.disallow_same", false) ? _react2.default.createElement(_materialUi.TextField, {
	                value: (0, _get2.default)(this.state.values, "restrictions.uses.max_per_event", ""),
	                floatingLabelText: "Number of tickets per event per " + (isMembership ? "membership" : "pass"),
	                floatingLabelFixed: true,
	                hintText: "Unlimited",
	                onChange: function onChange(e) {
	                  return _this2.onChangeValue("restrictions.uses.max_per_event", e.target.value);
	                },
	                type: "number",
	                style: { width: 300, marginLeft: 10 }
	              }) : null
	            ),
	            mode === "pass_bucket" ? function () {
	              var showTimeRestrictions = _this2.state.showTimeRestrictionsEditor || !!(0, _get2.default)(_this2.state.values, "restrictions.time.start_after") || !!(0, _get2.default)(_this2.state.values, "restrictions.time.end_before") || !!(0, _get2.default)(_this2.state.values, "restrictions.time.begin_within");
	
	              var showUseTimeRestrictions = _this2.state.showUseTimeRestrictionsEditor || !!(0, _get2.default)(_this2.state.values, "restrictions.use_time.use_after") || !!(0, _get2.default)(_this2.state.values, "restrictions.use_time.use_before");
	
	              var showAdvanceEditor = !!(_this2.state.showAdvanceEditor || (0, _get2.default)(_this2.state.values, "restrictions.uses.max_advance_reservations"));
	
	              return _react2.default.createElement(
	                "div",
	                null,
	                type !== "pass" ? _react2.default.createElement(
	                  "div",
	                  null,
	                  _react2.default.createElement(
	                    "h3",
	                    { style: styles.header },
	                    "Other restrictions"
	                  ),
	                  type !== "item" ? _react2.default.createElement(
	                    "div",
	                    null,
	                    _react2.default.createElement(_materialUi.Checkbox, {
	                      checked: (0, _get2.default)(_this2.state.values, "restrictions.rush_line_only", false),
	                      label: "Only allow Rush Line ticket orders (no advance reservation)",
	                      onCheck: _this2.onChange.bind(null, "restrictions.rush_line_only"),
	                      disabled: !_UserStore2.default.hasPermission("edit_pass_bucket")
	                    }),
	                    _react2.default.createElement(_materialUi.Checkbox, {
	                      checked: (0, _get2.default)(_this2.state.values, "restrictions.box_office_only", false),
	                      label: "Only allow Box Office ticket orders (no online reservation)",
	                      onCheck: _this2.onChange.bind(null, "restrictions.box_office_only"),
	                      disabled: !_UserStore2.default.hasPermission("edit_pass_bucket")
	                    })
	                  ) : null,
	                  type !== "item" ? _react2.default.createElement(
	                    "div",
	                    null,
	                    _react2.default.createElement(_materialUi.Checkbox, {
	                      checked: showTimeRestrictions,
	                      label: "Restrict based on the date / time of the event",
	                      onCheck: _this2.onShowTimeRestrictionsCheck,
	                      disabled: !_UserStore2.default.hasPermission("edit_pass_bucket")
	                    }),
	                    showTimeRestrictions ? _react2.default.createElement(
	                      "div",
	                      { style: { marginBottom: "1em" } },
	                      _react2.default.createElement(_datetimeField2.default, {
	                        style: {
	                          display: "inline-block",
	                          marginRight: 24
	                        },
	                        label: "Event must start after",
	                        placeholder: "Any time",
	                        value: (0, _get2.default)(_this2.state.values, "restrictions.time.start_after"),
	                        onChange: function onChange(_, date) {
	                          return _this2.onChangeValue("restrictions.time.start_after", date);
	                        }
	                      }),
	                      _react2.default.createElement(_datetimeField2.default, {
	                        style: { display: "inline-block" },
	                        label: "Event must end before",
	                        placeholder: "Any time",
	                        value: (0, _get2.default)(_this2.state.values, "restrictions.time.end_before"),
	                        onChange: function onChange(_, date) {
	                          return _this2.onChangeValue("restrictions.time.end_before", date);
	                        }
	                      }),
	                      _react2.default.createElement(_durationField2.default, {
	                        value: (0, _get2.default)(_this2.state.values, "restrictions.time.begin_within", 0),
	                        floatingLabelText: "Event must begin within",
	                        floatingLabelFixed: true,
	                        style: {
	                          marginLeft: 24,
	                          verticalAlign: -2
	                        },
	                        onChange: function onChange(e) {
	                          return _this2.onChangeValue("restrictions.time.begin_within", e.target.value);
	                        },
	                        placeholder: "No restriction"
	                      })
	                    ) : null
	                  ) : null,
	                  _react2.default.createElement(_materialUi.Checkbox, {
	                    checked: showUseTimeRestrictions,
	                    label: "Restrict based on the current time (when the " + (isMembership ? "membership" : "pass") + " is used to place an order)",
	                    onCheck: _this2.onShowUseTimeRestrictionsCheck,
	                    disabled: !_UserStore2.default.hasPermission("edit_pass_bucket")
	                  }),
	                  showUseTimeRestrictions ? _react2.default.createElement(
	                    "div",
	                    { style: { marginBottom: "1em" } },
	                    _react2.default.createElement(_datetimeField2.default, {
	                      style: {
	                        display: "inline-block",
	                        marginRight: 24
	                      },
	                      label: "Current time must be after",
	                      placeholder: "Any time",
	                      value: (0, _get2.default)(_this2.state.values, "restrictions.use_time.use_after"),
	                      onChange: function onChange(_, date) {
	                        return _this2.onChangeValue("restrictions.use_time.use_after", date);
	                      }
	                    }),
	                    _react2.default.createElement(_datetimeField2.default, {
	                      style: { display: "inline-block" },
	                      label: "Current time must be before",
	                      placeholder: "Any time",
	                      value: (0, _get2.default)(_this2.state.values, "restrictions.use_time.use_before"),
	                      onChange: function onChange(_, date) {
	                        return _this2.onChangeValue("restrictions.use_time.use_before", date);
	                      }
	                    })
	                  ) : null,
	                  type !== "item" ? _react2.default.createElement(_materialUi.Checkbox, {
	                    checked: showAdvanceEditor,
	                    label: "Restrict the number of advance reservations (i.e. number of tickets for which event end time has not passed)",
	                    onCheck: function onCheck() {
	                      if (showAdvanceEditor) {
	                        _this2.setState({ showAdvanceEditor: false }, function () {
	                          _this2.onChangeValue("restrictions.uses.max_advance_reservations", undefined);
	                        });
	                      } else {
	                        _this2.setState({ showAdvanceEditor: true });
	                      }
	                    },
	                    disabled: !_UserStore2.default.hasPermission("edit_pass_bucket")
	                  }) : null,
	                  showAdvanceEditor ? _react2.default.createElement(_materialUi.TextField, {
	                    value: (0, _get2.default)(_this2.state.values, "restrictions.uses.max_advance_reservations", ""),
	                    floatingLabelText: "Total number of advance reservations",
	                    floatingLabelFixed: true,
	                    hintText: "0",
	                    onChange: function onChange(e) {
	                      return _this2.onChangeValue("restrictions.uses.max_advance_reservations", e.target.value);
	                    },
	                    type: "number",
	                    style: { width: 300, marginBottom: "1em" }
	                  }) : null
	                ) : null
	              );
	            }() : null
	          ),
	          (mode === "pass_bucket" || this.props.parent && this.props.parent.is_virtual) && type !== "item" ? _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(
	              "h3",
	              { style: styles.header },
	              "Virtual screening restrictions ",
	              type
	            ),
	            _react2.default.createElement(_materialUi.Checkbox, {
	              checked: (0, _get2.default)(this.state.values, "restrictions.bypass_geographic_restrictions", false),
	              style: { marginBottom: mode === "pass_bucket" ? 0 : 25 },
	              label: _react2.default.createElement(
	                "div",
	                { style: { maxWidth: 450 } },
	                _react2.default.createElement(
	                  "div",
	                  null,
	                  "Bypass geographic restrictions when unlocking " + (mode === "pass_bucket" ? "virtual screenings" : "this screening")
	                ),
	                _react2.default.createElement(
	                  "div",
	                  {
	                    style: {
	                      fontSize: "0.9em",
	                      color: "rgba(0,0,0,0.6)",
	                      lineHeight: "1.2"
	                    }
	                  },
	                  "By enabling this option, targeted ",
	                  isMembership ? "members" : "passholders",
	                  " will be able to unlock",
	                  " ",
	                  mode === "pass_bucket" ? "the targeted virtual screenings" : "the screening",
	                  " ",
	                  "even if they are not within the set geographic restrictions."
	                )
	              ),
	              onCheck: this.onChange.bind(null, "restrictions.bypass_geographic_restrictions"),
	              disabled: !_UserStore2.default.hasPermission("edit_pass_bucket")
	            })
	          ) : null,
	          mode === "pass_bucket" ? _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(
	              "h3",
	              { style: styles.header },
	              "Global rule"
	            ),
	            _react2.default.createElement(_materialUi.Checkbox, {
	              checked: !!(0, _get2.default)(this.state.values, "global_target", false),
	              label: "Make this " + (isMembership ? "membership" : "pass") + " rule global (apply to other event buckets)",
	              onCheck: function onCheck(e, checked) {
	                return _this2.onChangeValue("global_target", !_this2.state.values.global_target ? "*" : undefined);
	              },
	              disabled: !_UserStore2.default.hasPermission("edit_pass_bucket")
	            }),
	            (0, _get2.default)(this.state.values, "global_target") ? _react2.default.createElement(_injectedSelect2.default, {
	              style: { marginBottom: 10 },
	              value: (0, _get2.default)(this.state.values, "global_target.event_bucket.id", []),
	              types: ["event_buckets"],
	              multi: true,
	              eventBucketId: this.props.eventBucketId,
	              label: "Target event buckets",
	              labelFormatter: function labelFormatter(b) {
	                return "" + b.name;
	              },
	              onChange: function onChange(selected) {
	                if (selected.length === 0) {
	                  _this2.onChangeValue("global_target", "*");
	                } else {
	                  _this2.onChangeValue("global_target.event_bucket.id", selected);
	                }
	              },
	              placeholderText: "Default: apply to all event buckets"
	            }) : null
	          ) : null
	        ),
	        _UserStore2.default.hasPermission("edit_pass_bucket") ? _react2.default.createElement(
	          "div",
	          { style: styles.actions },
	          _react2.default.createElement(_materialUi.RaisedButton, {
	            label: "Close",
	            onClick: this.toggleEditMode,
	            style: { marginRight: 7 }
	          }),
	          mode === "pass_bucket" ? [_react2.default.createElement(_materialUi.RaisedButton, {
	            label: this.state.dirty ? "Save" : "No changes to save",
	            key: "save",
	            primary: true,
	            disabled: !this.state.dirty,
	            onClick: this.save
	          }), _react2.default.createElement(_materialUi.RaisedButton, {
	            label: "Delete",
	            key: "delete",
	            onClick: this.delete,
	            style: { marginLeft: 7 }
	          }), _react2.default.createElement(_materialUi.RaisedButton, {
	            label: "\u25B2",
	            key: "shiftUp-edit",
	            style: { minWidth: 30, marginLeft: 7 },
	            disabled: !this.props.canShiftUp,
	            onTouchTap: function onTouchTap() {
	              return _this2.props.shiftPosition(-1);
	            }
	          }), _react2.default.createElement(_materialUi.RaisedButton, {
	            label: "\u25BC",
	            key: "shiftDown-edit",
	            style: { minWidth: 30, marginLeft: 7 },
	            disabled: !this.props.canShiftDown,
	            onTouchTap: function onTouchTap() {
	              return _this2.props.shiftPosition(1);
	            }
	          })] : _react2.default.createElement(_materialUi.RaisedButton, { label: "Remove", onClick: this.delete, style: {} })
	        ) : null
	      );
	    }
	  }], [{
	    key: "getStores",
	    value: function getStores() {
	      return [_UserStore2.default];
	    }
	  }, {
	    key: "getPropsFromStores",
	    value: function getPropsFromStores() {
	      return {};
	    }
	  }]);
	
	  return PassRuleEditor;
	}(_react2.default.Component);
	
	exports.default = (0, _connectToStores2.default)(PassRuleEditor);
	module.exports = exports["default"];

/***/ }),
/* 2735 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _connectToStores = __webpack_require__(1226);
	
	var _connectToStores2 = _interopRequireDefault(_connectToStores);
	
	var _EventActions = __webpack_require__(2031);
	
	var _EventActions2 = _interopRequireDefault(_EventActions);
	
	var _EventStore = __webpack_require__(2032);
	
	var _EventStore2 = _interopRequireDefault(_EventStore);
	
	var _workingIndicator = __webpack_require__(1664);
	
	var _workingIndicator2 = _interopRequireDefault(_workingIndicator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var NewEvent = function (_React$Component) {
	  _inherits(NewEvent, _React$Component);
	
	  function NewEvent(props) {
	    _classCallCheck(this, NewEvent);
	
	    return _possibleConstructorReturn(this, Object.getPrototypeOf(NewEvent).call(this, props));
	  }
	
	  _createClass(NewEvent, [{
	    key: "componentWillMount",
	    value: function componentWillMount() {
	      if (this.props.location.query.duplicate) {
	        return;
	      }
	
	      var isVirtual = !!this.props.location.query.virtual;
	
	      _EventActions2.default.create({
	        name: isVirtual ? "Unnamed Virtual Screening" : "Unnamed Event",
	        is_virtual: isVirtual,
	        event_bucket: this.props.params.eventBucketId,
	        is_dated: !isVirtual
	      });
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(props) {
	      if (props.newEventId) {
	        this.context.router.replace("/event_buckets/" + props.params.eventBucketId + (props.location.query.virtual ? "/virtual_festival" : "") + "/events/" + props.newEventId + "/edit");
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement(_workingIndicator2.default, { fullPage: true });
	    }
	  }], [{
	    key: "getStores",
	    value: function getStores() {
	      return [_EventStore2.default];
	    }
	  }, {
	    key: "getPropsFromStores",
	    value: function getPropsFromStores() {
	      return {
	        newEventId: _EventStore2.default.getState().newEventId
	      };
	    }
	  }, {
	    key: "contextTypes",
	    get: function get() {
	      return {
	        router: _react2.default.PropTypes.object
	      };
	    }
	  }]);
	
	  return NewEvent;
	}(_react2.default.Component);
	
	exports.default = (0, _connectToStores2.default)(NewEvent);
	module.exports = exports["default"];

/***/ }),
/* 2736 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDropzone = __webpack_require__(1780);
	
	var _reactDropzone2 = _interopRequireDefault(_reactDropzone);
	
	var _materialUi = __webpack_require__(576);
	
	var _reactable = __webpack_require__(1688);
	
	var _moment = __webpack_require__(1021);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _twix = __webpack_require__(2312);
	
	var _twix2 = _interopRequireDefault(_twix);
	
	var _striptags = __webpack_require__(1592);
	
	var _striptags2 = _interopRequireDefault(_striptags);
	
	var _connectToStores = __webpack_require__(1226);
	
	var _connectToStores2 = _interopRequireDefault(_connectToStores);
	
	var _BulkImportActions = __webpack_require__(2688);
	
	var _BulkImportActions2 = _interopRequireDefault(_BulkImportActions);
	
	var _BulkImportStore = __webpack_require__(2689);
	
	var _BulkImportStore2 = _interopRequireDefault(_BulkImportStore);
	
	var _infoNotice = __webpack_require__(1599);
	
	var _infoNotice2 = _interopRequireDefault(_infoNotice);
	
	var _checkCircle = __webpack_require__(877);
	
	var _checkCircle2 = _interopRequireDefault(_checkCircle);
	
	var _error = __webpack_require__(948);
	
	var _error2 = _interopRequireDefault(_error);
	
	var _config = __webpack_require__(1173);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _injectedSelect = __webpack_require__(1874);
	
	var _injectedSelect2 = _interopRequireDefault(_injectedSelect);
	
	var _label = __webpack_require__(1682);
	
	var _label2 = _interopRequireDefault(_label);
	
	var _quillEditor = __webpack_require__(2169);
	
	var _quillEditor2 = _interopRequireDefault(_quillEditor);
	
	var _linkLike = __webpack_require__(973);
	
	var _linkLike2 = _interopRequireDefault(_linkLike);
	
	var _util = __webpack_require__(1183);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TABLE_COLUMNS = [{ key: "name", label: "Name" }, { key: "venue_name", label: "Venue" }, { key: "date", label: "Date" }, { key: "description", label: "Description" }, { key: "short_description", label: "Short" }, { key: "tag_names", label: "Tags" }, { key: "ticket_bucket", label: "Ticket bucket" }];
	
	var BulkImportPasses = function (_React$Component) {
	  _inherits(BulkImportPasses, _React$Component);
	
	  function BulkImportPasses(props) {
	    _classCallCheck(this, BulkImportPasses);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(BulkImportPasses).call(this, props));
	
	    _this.state = {
	      csvFile: null,
	      userReadyToImport: false,
	      virtual: false
	    };
	
	    _this.reset = _this.reset.bind(_this);
	    _this.onDrop = _this.onDrop.bind(_this);
	    _this.import = _this.import.bind(_this);
	    return _this;
	  }
	
	  _createClass(BulkImportPasses, [{
	    key: "getStyles",
	    value: function getStyles() {
	      var _dropzone;
	
	      return {
	        progressContainer: {
	          margin: "0 auto",
	          textAlign: "center",
	          padding: 10
	        },
	        icon: {
	          width: 80,
	          height: "auto",
	          color: "rgb(2, 136, 209)"
	        },
	        message: {
	          marginTop: 10
	        },
	        dropzone: (_dropzone = {
	          padding: 20,
	          lineHeight: "1.25"
	        }, _defineProperty(_dropzone, "padding", 10), _defineProperty(_dropzone, "border", "1px dashed #ccc"), _defineProperty(_dropzone, "cursor", "pointer"), _dropzone),
	        actions: {
	          marginTop: 10
	        },
	        previewExtraMessage: {
	          padding: 20,
	          border: "1px dashed #ccc"
	        }
	      };
	    }
	  }, {
	    key: "componentWillMount",
	    value: function componentWillMount() {
	      this.reset();
	    }
	  }, {
	    key: "reset",
	    value: function reset() {
	      this.setState({
	        csvFile: null,
	        userReadyToImport: false,
	        virtual: this.props.location.pathname.includes("virtual_festival")
	      });
	      _BulkImportActions2.default.reset.defer();
	    }
	  }, {
	    key: "onDrop",
	    value: function onDrop(files) {
	      if (!files.length) {
	        return;
	      }
	      this.setState({
	        csvFile: files[0]
	      });
	    }
	  }, {
	    key: "import",
	    value: function _import() {
	      _BulkImportActions2.default.importEvents({
	        eventBucket: this.props.params.eventBucketId,
	        csvFile: this.state.csvFile,
	        preview: !this.state.userReadyToImport,
	        virtual: this.state.virtual
	      });
	      window.scrollTo(0, 0);
	    }
	  }, {
	    key: "_makeCsvLink",
	    value: function _makeCsvLink() {
	      var link = _config2.default.endpoint + "bulk_import/example/events";
	      if (this.state.virtual) {
	        link += "?virtual=true";
	      }
	      return link;
	    }
	  }, {
	    key: "_getTableColumns",
	    value: function _getTableColumns() {
	      var columns = TABLE_COLUMNS;
	      if (this.state.virtual) {
	        return columns.filter(function (_ref) {
	          var key = _ref.key;
	          return key !== "venue_name";
	        });
	      }
	      return columns;
	    }
	  }, {
	    key: "_makeTable",
	    value: function _makeTable(events) {
	      return _react2.default.createElement(_reactable.Table, {
	        className: "bordered striped responsive-table",
	        columns: this._getTableColumns(),
	        data: events.map(function (e) {
	          return Object.assign({}, e, {
	            short_description: e.short_description && _react2.default.createElement(
	              "span",
	              { title: e.short_description },
	              e.short_description.substring(0, 10).trim() + "..."
	            ),
	            description: e.description && _react2.default.createElement(
	              "span",
	              { title: (0, _striptags2.default)(e.description) },
	              (0, _striptags2.default)(e.description).substring(0, 10).trim() + "..."
	            ),
	            date: (0, _moment2.default)(e.start_time).twix(e.end_time).format({
	              showDate: true,
	              implicitMinutes: false,
	              groupMeridiems: false,
	              implicitYear: false
	            }),
	            tag_names: e.new_tags.map(function (t) {
	              return t.name;
	            }).join(", "),
	            venue_name: e.venue && e.venue.name,
	            ticket_bucket: e.ticket_buckets.length && e.ticket_buckets[0].name + " (" + (e.ticket_buckets[0].unlimited ? "unlimited" : e.ticket_buckets[0].quantity + "x") + ", " + (0, _util.formatPrice)(e.ticket_buckets[0].price) + ")"
	          });
	        })
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props;
	      var isImporting = _props.isImporting;
	      var importCompleted = _props.importCompleted;
	      var importSuccessful = _props.importSuccessful;
	      var importMessage = _props.importMessage;
	      var previewData = _props.previewData;
	      var styles = this.getStyles();
	
	      var termToUse = this.state.virtual ? "screening" : "event";
	
	      if (isImporting || importCompleted && !previewData) {
	        return _react2.default.createElement(
	          "div",
	          { style: styles.progressContainer },
	          isImporting ? _react2.default.createElement(_materialUi.CircularProgress, { size: 1.5, mode: "indeterminate" }) : importSuccessful ? _react2.default.createElement(_checkCircle2.default, { style: styles.icon }) : _react2.default.createElement(_error2.default, { style: styles.icon }),
	          _react2.default.createElement(
	            "div",
	            { style: styles.message },
	            isImporting ? _react2.default.createElement(
	              "div",
	              null,
	              this.state.userReadyToImport ? "Importing" : "Previewing",
	              " ",
	              termToUse,
	              "s...",
	              _react2.default.createElement("br", null),
	              "This may take a little while."
	            ) : importMessage,
	            !isImporting ? _react2.default.createElement(
	              "div",
	              null,
	              importSuccessful && _react2.default.createElement(
	                "span",
	                null,
	                _react2.default.createElement(
	                  _linkLike2.default,
	                  {
	                    onTouchTap: function onTouchTap() {
	                      return _this2.context.router.push("/event_buckets/" + _this2.props.params.eventBucketId + "/" + (_this2.state.virtual ? "virtual_festival" : "events"));
	                    }
	                  },
	                  "view ",
	                  termToUse,
	                  " list"
	                ),
	                " ",
	                "|",
	                " "
	              ),
	              _react2.default.createElement(
	                _linkLike2.default,
	                { onTouchTap: this.reset },
	                "restart"
	              )
	            ) : null
	          )
	        );
	      }
	
	      if (previewData && this.state.csvFile) {
	        return _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement(
	            "p",
	            null,
	            "We detected ",
	            previewData.events.length,
	            " ",
	            termToUse,
	            previewData.events.length !== 1 ? "s" : "",
	            " in your uploaded data",
	            previewData.duplicates_skipped ? " (" + previewData.duplicates_skipped + " duplicate" + (previewData.duplicates_skipped === 1 ? "" : "s") + " skipped)" : "",
	            ". Have a look:"
	          ),
	          this._makeTable(previewData.events),
	          previewData.venues && previewData.venues.length ? _react2.default.createElement(
	            "p",
	            null,
	            "We detected ",
	            previewData.venues.length,
	            " new venue",
	            previewData.venues.length !== 1 ? "s" : "",
	            " in your data, so",
	            " ",
	            previewData.venues.length !== 1 ? "they" : "it",
	            " will automatically be created when importing.",
	            _react2.default.createElement("br", null),
	            _react2.default.createElement(
	              "i",
	              null,
	              "You can edit venue descriptions, addresses, and more after importing (in the Venues section)."
	            ),
	            _react2.default.createElement(
	              "ul",
	              null,
	              previewData.venues.map(function (v) {
	                return _react2.default.createElement(
	                  "li",
	                  { key: v.name },
	                  v.name
	                );
	              })
	            )
	          ) : null,
	          previewData.tags.length ? _react2.default.createElement(
	            "p",
	            null,
	            "We ",
	            previewData.venues && previewData.venues.length ? "also" : "",
	            " ",
	            "detected ",
	            previewData.tags.length,
	            " new tag",
	            previewData.tags.length !== 1 ? "s" : "",
	            " in your data, so",
	            " ",
	            previewData.tags.length !== 1 ? "they" : "it",
	            " will automatically be created when importing.",
	            _react2.default.createElement("br", null),
	            _react2.default.createElement(
	              "i",
	              null,
	              "You can edit tag colors, names, and more after importing (in the Tags section)."
	            ),
	            _react2.default.createElement(
	              "ul",
	              null,
	              previewData.tags.map(function (t) {
	                return _react2.default.createElement(
	                  "li",
	                  { key: t.name },
	                  t.name
	                );
	              })
	            )
	          ) : null,
	          _react2.default.createElement(
	            "p",
	            null,
	            "If everything looks all right, confirm & start the import. Otherwise,",
	            " ",
	            _react2.default.createElement(
	              _linkLike2.default,
	              { onTouchTap: this.reset },
	              "edit settings"
	            ),
	            "."
	          ),
	          _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(_materialUi.Checkbox, {
	              label: "Yes, I'm ready to import " + previewData.events.length + " " + termToUse + (previewData.events.length !== 1 ? "s" : "") + ".",
	              checked: this.state.userReadyToImport,
	              onCheck: function onCheck() {
	                return _this2.setState({
	                  userReadyToImport: !_this2.state.userReadyToImport
	                });
	              }
	            })
	          ),
	          _react2.default.createElement(
	            "div",
	            { style: styles.actions },
	            _react2.default.createElement(_materialUi.RaisedButton, {
	              label: "Start import",
	              primary: true,
	              disabled: !this.state.userReadyToImport,
	              onTouchTap: this.import
	            })
	          )
	        );
	      }
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          "h1",
	          null,
	          "Bulk import ",
	          termToUse,
	          "s"
	        ),
	        _react2.default.createElement(
	          _infoNotice2.default,
	          { style: { marginTop: 20 } },
	          "Check out our",
	          " ",
	          _react2.default.createElement(
	            "a",
	            {
	              href: "https://help.eventive.org/events-and-tickets/bulk-import-events",
	              target: "_blank"
	            },
	            "guide to importing ",
	            termToUse,
	            "s"
	          ),
	          "."
	        ),
	        _react2.default.createElement(
	          "p",
	          null,
	          "Use this wizard to create ",
	          termToUse,
	          "s in bulk. Just download the Excel template, fill in your data, and upload.",
	          _react2.default.createElement("br", null),
	          _react2.default.createElement(
	            "i",
	            null,
	            "Detailed explanations of what to include in each column are included in our",
	            " ",
	            _react2.default.createElement(
	              "a",
	              {
	                href: "https://help.eventive.org/events-and-tickets/bulk-import-events",
	                target: "_blank"
	              },
	              "guide to importing ",
	              termToUse,
	              "s"
	            ),
	            "."
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement(
	            _label2.default,
	            null,
	            "Add spreadsheet (",
	            _react2.default.createElement(
	              "a",
	              { target: "_blank", href: this._makeCsvLink() },
	              "download template"
	            ),
	            ")"
	          ),
	          _react2.default.createElement(
	            _reactDropzone2.default,
	            {
	              style: styles.dropzone,
	              multiple: false,
	              onDrop: this.onDrop
	            },
	            function (_ref2) {
	              var isDragActive = _ref2.isDragActive;
	              var isDragReject = _ref2.isDragReject;
	              var acceptedFiles = _ref2.acceptedFiles;
	              var rejectedFiles = _ref2.rejectedFiles;
	
	              return isDragActive ? "Release to select." : acceptedFiles.length ? _react2.default.createElement(
	                "span",
	                null,
	                "One spreadsheet ",
	                _react2.default.createElement(
	                  "i",
	                  null,
	                  "(",
	                  acceptedFiles[0].name,
	                  ")"
	                ),
	                " ready to import."
	              ) : "Drop spreadsheet here, or click to select.";
	            }
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { style: styles.actions },
	          _react2.default.createElement(_materialUi.RaisedButton, {
	            label: "Preview import...",
	            primary: true,
	            disabled: !this.state.csvFile,
	            onTouchTap: this.import
	          })
	        )
	      );
	    }
	  }], [{
	    key: "getStores",
	    value: function getStores() {
	      return [_BulkImportStore2.default];
	    }
	  }, {
	    key: "getPropsFromStores",
	    value: function getPropsFromStores() {
	      return _BulkImportStore2.default.getState();
	    }
	  }, {
	    key: "contextTypes",
	    get: function get() {
	      return {
	        router: _react2.default.PropTypes.object
	      };
	    }
	  }]);
	
	  return BulkImportPasses;
	}(_react2.default.Component);
	
	exports.default = (0, _connectToStores2.default)(BulkImportPasses);
	module.exports = exports["default"];

/***/ }),
/* 2737 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _config = __webpack_require__(1173);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _materialUi = __webpack_require__(576);
	
	var _qs = __webpack_require__(1206);
	
	var _qs2 = _interopRequireDefault(_qs);
	
	var _passTable = __webpack_require__(2738);
	
	var _passTable2 = _interopRequireDefault(_passTable);
	
	var _backButton = __webpack_require__(1872);
	
	var _backButton2 = _interopRequireDefault(_backButton);
	
	var _connectToStores = __webpack_require__(1226);
	
	var _connectToStores2 = _interopRequireDefault(_connectToStores);
	
	var _PassBucketActions = __webpack_require__(1869);
	
	var _PassBucketActions2 = _interopRequireDefault(_PassBucketActions);
	
	var _PassBucketStore = __webpack_require__(1867);
	
	var _PassBucketStore2 = _interopRequireDefault(_PassBucketStore);
	
	var _PassActions = __webpack_require__(2047);
	
	var _PassActions2 = _interopRequireDefault(_PassActions);
	
	var _PassStore = __webpack_require__(2048);
	
	var _PassStore2 = _interopRequireDefault(_PassStore);
	
	var _UserStore = __webpack_require__(974);
	
	var _UserStore2 = _interopRequireDefault(_UserStore);
	
	var _EventBucketStore = __webpack_require__(1593);
	
	var _EventBucketStore2 = _interopRequireDefault(_EventBucketStore);
	
	var _downloadPassBucketCsvButton = __webpack_require__(2742);
	
	var _downloadPassBucketCsvButton2 = _interopRequireDefault(_downloadPassBucketCsvButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PassBucket = function (_React$Component) {
	  _inherits(PassBucket, _React$Component);
	
	  function PassBucket(props) {
	    _classCallCheck(this, PassBucket);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(PassBucket).call(this, props));
	
	    _this.state = {
	      isFetchingPassBucket: false,
	      fetchedPassBucket: null
	    };
	
	    _this._makeDirectSalesLink = _this._makeDirectSalesLink.bind(_this);
	    return _this;
	  }
	
	  _createClass(PassBucket, [{
	    key: "_makeDirectSalesLink",
	    value: function _makeDirectSalesLink() {
	      var eventBucket = this.props.getEventBucketById(this.props.params.eventBucketId),
	          passBucket = this.props.getPassBucketById(this.props.params.passBucketId);
	
	      return eventBucket && passBucket && eventBucket.urls.buy_passes + "/" + passBucket.code;
	    }
	  }, {
	    key: "getStyles",
	    value: function getStyles() {
	      return {};
	    }
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.componentWillReceiveProps(this.props);
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(newProps) {
	      var passBucket = newProps.getPassBucketById(newProps.params.passBucketId);
	
	      if (!this.state.isFetchingPassBucket && this.state.fetchedPassBucket !== newProps.params.passBucketId) {
	        _PassBucketActions2.default.fetchOne(newProps.params.passBucketId);
	        _PassActions2.default.fetchAllForPassBucket(newProps.params.passBucketId);
	        this.setState({ isFetchingPassBucket: true });
	      } else if (passBucket) {
	        this.setState({
	          isFetchingPassBucket: false,
	          fetchedPassBucket: passBucket.id
	        });
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var passBucket = this.props.getPassBucketById(this.props.params.passBucketId);
	      var passes = this.props.getPassesForPassBucket(this.props.params.passBucketId);
	
	      if (!passBucket) {
	        setTimeout(function () {
	          return _this2.context.router.replace("/welcome");
	        }, 0);
	        return null;
	      }
	      // Since the word "membership" might not be in the URL, we have to check for membership
	      // differently than our standard way. Also, we need to accommodate for a record that has
	      // no key of is_membership.
	      var isMembership = passBucket && passBucket.is_membership;
	
	      var availableString = isMembership ? "memberships available" : "passes available";
	      var issuedString = isMembership ? "membership" + (passes.length === 1 ? "" : "s") + " issued" : "pass" + (passes.length === 1 ? "" : "es") + " issued";
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          "h1",
	          null,
	          passBucket.name,
	          " ",
	          _react2.default.createElement(
	            "span",
	            { style: { fontWeight: "normal", fontSize: "0.6em" } },
	            passes.length,
	            " ",
	            issuedString
	          ),
	          " ",
	          passes.some(function (p) {
	            return p.pass_subscription;
	          }) ? _react2.default.createElement(
	            "span",
	            { style: { fontWeight: "normal", fontSize: "0.6em" } },
	            "|",
	            " ",
	            passes.filter(function (p) {
	              return p.pass_subscription && p.pass_subscription.status === "active";
	            }).length,
	            " ",
	            "currently active",
	            " "
	          ) : null,
	          _react2.default.createElement(
	            "span",
	            { style: { fontWeight: "normal", fontSize: "0.6em" } },
	            "|",
	            " ",
	            passBucket.unlimited ? "unlimited " + availableString : passBucket.quantity - passBucket.quantity_sold + " " + availableString
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { style: { margin: "10px 0 20px" } },
	          _react2.default.createElement(_backButton2.default, {
	            label: isMembership ? "memberships" : "pass buckets",
	            style: { marginRight: 7, verticalAlign: "middle" },
	            onTouchTap: function onTouchTap() {
	              return _this2.props.location.state && _this2.props.location.state.fromListing ? _this2.context.router.goBack() : _this2.context.router.push("/event_buckets/" + _this2.props.params.eventBucketId + "/" + (isMembership ? "memberships" : "pass_buckets"));
	            }
	          }),
	          _UserStore2.default.hasPermission("edit_pass_bucket") ? _react2.default.createElement(_materialUi.RaisedButton, {
	            style: { marginRight: 7, verticalAlign: "middle" },
	            label: "Settings",
	            onTouchTap: function onTouchTap() {
	              return _this2.context.router.push("/event_buckets/" + _this2.props.params.eventBucketId + "/" + (isMembership ? "memberships" : "pass_buckets") + "/" + _this2.props.params.passBucketId + "/edit");
	            }
	          }) : null,
	          _react2.default.createElement(_downloadPassBucketCsvButton2.default, {
	            style: { marginRight: 7, verticalAlign: "middle" },
	            label: "More \u25BE",
	            passBucketId: passBucket.id,
	            downloadType: isMembership ? "memberships" : "passes",
	            additionalOptions: [{
	              href: this._makeDirectSalesLink(),
	              label: "Direct customer sales link"
	            }]
	          })
	        ),
	        _react2.default.createElement(_passTable2.default, {
	          passes: passes,
	          eventBucket: this.props.params.eventBucketId,
	          hidePassBucket: true,
	          location: this.props.location,
	          isMemberships: isMembership
	        })
	      );
	    }
	  }], [{
	    key: "getStores",
	    value: function getStores() {
	      return [_PassBucketStore2.default, _PassStore2.default, _UserStore2.default];
	    }
	  }, {
	    key: "getPropsFromStores",
	    value: function getPropsFromStores() {
	      return {
	        getPassBucketById: _PassBucketStore2.default.getPassBucketById,
	        getPassesForPassBucket: _PassStore2.default.getPassesForPassBucket,
	        apiKey: _UserStore2.default.getState().apiKey,
	        getEventBucketById: _EventBucketStore2.default.getEventBucketById
	      };
	    }
	  }, {
	    key: "contextTypes",
	    get: function get() {
	      return {
	        router: _react2.default.PropTypes.object
	      };
	    }
	  }]);
	
	  return PassBucket;
	}(_react2.default.Component);
	
	exports.default = (0, _connectToStores2.default)(PassBucket);
	module.exports = exports["default"];

/***/ }),
/* 2738 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _moment = __webpack_require__(1021);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _reactRouter = __webpack_require__(486);
	
	var _materialUi = __webpack_require__(576);
	
	var _reactable = __webpack_require__(1688);
	
	var _checkCircle = __webpack_require__(877);
	
	var _checkCircle2 = _interopRequireDefault(_checkCircle);
	
	var _transferOverlay = __webpack_require__(2699);
	
	var _transferOverlay2 = _interopRequireDefault(_transferOverlay);
	
	var _printPassesModal = __webpack_require__(2268);
	
	var _printPassesModal2 = _interopRequireDefault(_printPassesModal);
	
	var _supplementaryDataModal = __webpack_require__(2269);
	
	var _supplementaryDataModal2 = _interopRequireDefault(_supplementaryDataModal);
	
	var _passSubscriptionModal = __webpack_require__(2739);
	
	var _passSubscriptionModal2 = _interopRequireDefault(_passSubscriptionModal);
	
	var _passNameEditor = __webpack_require__(2740);
	
	var _passNameEditor2 = _interopRequireDefault(_passNameEditor);
	
	var _passPassBucketEditor = __webpack_require__(2741);
	
	var _passPassBucketEditor2 = _interopRequireDefault(_passPassBucketEditor);
	
	var _inlineLinkIconButton = __webpack_require__(1704);
	
	var _inlineLinkIconButton2 = _interopRequireDefault(_inlineLinkIconButton);
	
	var _linkLike = __webpack_require__(973);
	
	var _linkLike2 = _interopRequireDefault(_linkLike);
	
	var _connectToStores = __webpack_require__(1226);
	
	var _connectToStores2 = _interopRequireDefault(_connectToStores);
	
	var _UserStore = __webpack_require__(974);
	
	var _UserStore2 = _interopRequireDefault(_UserStore);
	
	var _PassStore = __webpack_require__(2048);
	
	var _PassStore2 = _interopRequireDefault(_PassStore);
	
	var _PassBucketStore = __webpack_require__(1867);
	
	var _PassBucketStore2 = _interopRequireDefault(_PassBucketStore);
	
	var _PassBucketActions = __webpack_require__(1869);
	
	var _PassBucketActions2 = _interopRequireDefault(_PassBucketActions);
	
	var _PassActions = __webpack_require__(2047);
	
	var _PassActions2 = _interopRequireDefault(_PassActions);
	
	var _bulkDeleteOverlay = __webpack_require__(2701);
	
	var _bulkDeleteOverlay2 = _interopRequireDefault(_bulkDeleteOverlay);
	
	var _OrderUtil = __webpack_require__(2051);
	
	var _OrderUtil2 = _interopRequireDefault(_OrderUtil);
	
	var _refund = __webpack_require__(2703);
	
	var _refund2 = _interopRequireDefault(_refund);
	
	var _loading = __webpack_require__(2704);
	
	var _loading2 = _interopRequireDefault(_loading);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PAGE_SIZE = 20;
	
	var DELETED_ROW_STYLE = { textDecoration: "line-through", color: "#ccc" };
	var HIGHLIGHTED_ROW_STYLE = {
	  backgroundColor: "#fff176",
	  boxShadow: "1px 1px 10px rgba(0,0,0,0.2)"
	};
	
	var PassTable = function (_React$Component) {
	  _inherits(PassTable, _React$Component);
	
	  function PassTable(props) {
	    _classCallCheck(this, PassTable);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(PassTable).call(this, props));
	
	    _this.state = {
	      isEditing: false,
	      fetchedBucket: null,
	      selectedPasses: {},
	      passesToDelete: null,
	      passesToTransfer: null,
	      currentlyPrinting: null,
	      currentlyTransferring: null,
	      highlightedRow: null,
	      lastPassSubscription: null,
	      currentPage: 0
	    };
	
	    _this._makeRowForPass = _this._makeRowForPass.bind(_this);
	    _this._onEditCheck = _this._onEditCheck.bind(_this);
	    _this._onCheckAll = _this._onCheckAll.bind(_this);
	    _this._onCheck = _this._onCheck.bind(_this);
	
	    _this._closePrintModal = _this._closePrintModal.bind(_this);
	    _this._closeSupplementaryData = _this._closeSupplementaryData.bind(_this);
	
	    _this._closeTransferModal = _this._closeTransferModal.bind(_this);
	    _this._submitTransfer = _this._submitTransfer.bind(_this);
	
	    _this._showDeleteModal = _this._showDeleteModal.bind(_this);
	    _this._closeDeleteModal = _this._closeDeleteModal.bind(_this);
	    _this._onDeletePasses = _this._onDeletePasses.bind(_this);
	
	    _this._showRefundModal = _this._showRefundModal.bind(_this);
	    _this._closeRefundModal = _this._closeRefundModal.bind(_this);
	    _this._onRefundPasses = _this._onRefundPasses.bind(_this);
	    _this._closeRefundStatusModal = _this._closeRefundStatusModal.bind(_this);
	
	    _this._showBulkTransferModal = _this._showBulkTransferModal.bind(_this);
	    _this._submitBulkTransfer = _this._submitBulkTransfer.bind(_this);
	
	    _this._manageSubscription = _this._manageSubscription.bind(_this);
	    _this._closeSubscription = _this._closeSubscription.bind(_this);
	    return _this;
	  }
	
	  _createClass(PassTable, [{
	    key: "_delete",
	    value: function _delete(id, name, e) {
	      e.preventDefault();
	      e.stopPropagation();
	
	      if (window.confirm("Are you sure you want to delete " + (this.props.isMemberships ? "membership" : "pass") + " \"" + (name || id) + "\"? There is no going back.")) {
	        _PassActions2.default.delete(id);
	        this.setState(this.state);
	      }
	    }
	  }, {
	    key: "_print",
	    value: function _print(id, e) {
	      e.preventDefault();
	      e.stopPropagation();
	      this.setState({ currentlyPrinting: id });
	    }
	  }, {
	    key: "_closePrintModal",
	    value: function _closePrintModal() {
	      this.setState({ currentlyPrinting: null });
	    }
	  }, {
	    key: "_reserve",
	    value: function _reserve(id, eventBucket, e) {
	      e.preventDefault();
	      e.stopPropagation();
	
	      this.context.router.push("/event_buckets/" + eventBucket + "/box_office?pass=" + id);
	    }
	  }, {
	    key: "_viewHistory",
	    value: function _viewHistory(id, eventBucket, e) {
	      e.preventDefault();
	      e.stopPropagation();
	      this.context.router.push("/event_buckets/" + eventBucket + "/passes/" + id + "/history");
	    }
	  }, {
	    key: "_onCheckAll",
	    value: function _onCheckAll() {
	      if (Object.keys(this.state.selectedPasses).length === this.props.passes.length) {
	        this.setState({ selectedPasses: {} });
	      } else {
	        this.setState({
	          selectedPasses: this.props.passes.reduce(function (d, t) {
	            d[t.id] = true;
	            return d;
	          }, {})
	        });
	      }
	    }
	  }, {
	    key: "_onCheck",
	    value: function _onCheck(pass) {
	      if (!this.state.selectedPasses[pass.id]) {
	        this.state.selectedPasses[pass.id] = true;
	      } else {
	        delete this.state.selectedPasses[pass.id];
	      }
	      this.setState({ selectedPasses: this.state.selectedPasses });
	    }
	  }, {
	    key: "_transfer",
	    value: function _transfer(id, e) {
	      e.preventDefault();
	      e.stopPropagation();
	      this.setState({ currentlyTransferring: id });
	    }
	  }, {
	    key: "_submitTransfer",
	    value: function _submitTransfer(recipient) {
	      _PassActions2.default.transfer(this.state.currentlyTransferring, recipient);
	      this._closeTransferModal();
	    }
	  }, {
	    key: "_cancelTransfer",
	    value: function _cancelTransfer(id, e) {
	      e.preventDefault();
	      e.stopPropagation();
	      if (window.confirm("Are you sure you wish to cancel this pass transfer? The original transfer link will no longer work.")) {
	        _PassActions2.default.cancelTransfer(id);
	      }
	    }
	  }, {
	    key: "_bulkCancelTransfer",
	    value: function _bulkCancelTransfer(passes) {
	      this.setState({
	        bulkActionsPopoverOpen: false
	      });
	      var plurality = passes.length == 1 ? "" : "s";
	
	      if (window.confirm("Are you sure you wish to cancel " + passes.length + " pass transfer" + plurality + "? The original transfer link" + plurality + " will no longer work.")) {
	        var passIds = passes.map(function (p) {
	          return p.id;
	        });
	        _PassActions2.default.bulkCancelPassTransfers(passIds);
	      }
	    }
	  }, {
	    key: "_closeTransferModal",
	    value: function _closeTransferModal() {
	      this.setState({ currentlyTransferring: null, passesToTransfer: null });
	    }
	  }, {
	    key: "_showBulkTransferModal",
	    value: function _showBulkTransferModal() {
	      this.setState({
	        bulkActionsPopoverOpen: false
	      });
	      var passesToTransfer = this.passesEligibleForTransfer(this.state.selectedPasses);
	
	      this.setState({
	        passesToTransfer: passesToTransfer
	      });
	    }
	  }, {
	    key: "_submitBulkTransfer",
	    value: function _submitBulkTransfer(recipient) {
	      var transfer = {
	        destination_email: recipient,
	        pass_ids: this.state.passesToTransfer.map(function (p) {
	          return p.id;
	        })
	      };
	      _PassActions2.default.bulkTransferPasses(transfer);
	
	      this._closeTransferModal();
	      this.setState({
	        selectedPasses: {}
	      });
	    }
	  }, {
	    key: "_showDeleteModal",
	    value: function _showDeleteModal(passId) {
	      var _this2 = this;
	
	      this.setState({
	        bulkActionsPopoverOpen: false
	      });
	      var passesToDelete = passId ? [passId] : Object.keys(this.state.selectedPasses);
	
	      this.setState({
	        passesToDelete: passesToDelete.map(function (id) {
	          return _this2.props.passes.find(function (t) {
	            return t.id === id;
	          });
	        })
	      });
	    }
	  }, {
	    key: "_closeDeleteModal",
	    value: function _closeDeleteModal() {
	      this.setState({ passesToDelete: null });
	    }
	  }, {
	    key: "_onDeletePasses",
	    value: function _onDeletePasses() {
	      var passIds = this.state.passesToDelete.map(function (t) {
	        return t.id;
	      });
	      _PassActions2.default.deletePasses({
	        pass_ids: passIds
	      });
	
	      this._closeDeleteModal();
	      this.setState({
	        selectedPasses: {}
	      });
	    }
	  }, {
	    key: "_showRefundModal",
	    value: function () {
	      var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee2() {
	        var _this3 = this;
	
	        var passIdsToRefund, passesToRefund, ordersToRefund, apiKey, refundOptions, mergedRefundOptions, filteredRefundOpts;
	        return regeneratorRuntime.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                this.setState({ bulkActionsPopoverOpen: false });
	                passIdsToRefund = Object.keys(this.state.selectedPasses);
	                passesToRefund = passIdsToRefund.map(function (id) {
	                  return _this3.props.passes.find(function (p) {
	                    return p.id === id;
	                  });
	                });
	
	                // deduplicate the orders list
	
	                ordersToRefund = Array.from(new Set(passesToRefund.map(function (p) {
	                  return p.order || _this3.props.order;
	                })));
	                apiKey = _UserStore2.default.getState().apiKey;
	
	                // get the refund options for all of the orders
	
	                _context2.next = 7;
	                return Promise.all(ordersToRefund.map(function () {
	                  var _ref2 = _asyncToGenerator(regeneratorRuntime.mark(function _callee(orderId) {
	                    return regeneratorRuntime.wrap(function _callee$(_context) {
	                      while (1) {
	                        switch (_context.prev = _context.next) {
	                          case 0:
	                            _context.prev = 0;
	                            _context.next = 3;
	                            return _OrderUtil2.default.generateRefundOptions(apiKey, orderId);
	
	                          case 3:
	                            return _context.abrupt("return", _context.sent);
	
	                          case 6:
	                            _context.prev = 6;
	                            _context.t0 = _context["catch"](0);
	                            return _context.abrupt("return", { error: _context.t0 });
	
	                          case 9:
	                          case "end":
	                            return _context.stop();
	                        }
	                      }
	                    }, _callee, _this3, [[0, 6]]);
	                  }));
	
	                  return function (_x) {
	                    return _ref2.apply(this, arguments);
	                  };
	                }()));
	
	              case 7:
	                refundOptions = _context2.sent;
	
	
	                // merge the options into one array
	                mergedRefundOptions = refundOptions.reduce(function (result, obj) {
	                  return result.concat(obj.options);
	                }, []);
	
	                // filter out only the relevant refund options to the passes selected
	
	                filteredRefundOpts = mergedRefundOptions.filter(function (option) {
	                  if (!option || option.item.ref_type !== "Pass") return false;
	
	                  return passIdsToRefund.includes(option.item.ref_id);
	                });
	
	
	                this.setState({
	                  passesToRefund: passesToRefund,
	                  refundOptions: filteredRefundOpts
	                });
	
	              case 11:
	              case "end":
	                return _context2.stop();
	            }
	          }
	        }, _callee2, this);
	      }));
	
	      function _showRefundModal() {
	        return _ref.apply(this, arguments);
	      }
	
	      return _showRefundModal;
	    }()
	  }, {
	    key: "_onRefundPasses",
	    value: function () {
	      var _ref3 = _asyncToGenerator(regeneratorRuntime.mark(function _callee3(options) {
	        var _this4 = this;
	
	        var optionsByOrder, _loop, key, progress, orderId;
	
	        return regeneratorRuntime.wrap(function _callee3$(_context3) {
	          while (1) {
	            switch (_context3.prev = _context3.next) {
	              case 0:
	                optionsByOrder = {};
	
	                _loop = function _loop(key) {
	                  var keySplit = key.split("-");
	                  var item = options.refunds[key];
	                  var id = keySplit[1];
	
	                  var pass = _this4.props.passes.find(function (t) {
	                    return t.id === id;
	                  });
	                  var order = pass.order || _this4.props.order;
	
	                  if (!optionsByOrder[order]) {
	                    optionsByOrder[order] = {};
	                  }
	
	                  optionsByOrder[order][key] = item;
	                };
	
	                for (key in options.refunds) {
	                  _loop(key);
	                }
	
	                this.setState({
	                  passesToRefund: null,
	                  refundOptions: null,
	                  bulkRefunding: true,
	                  bulkRefundingOrderCount: Object.keys(optionsByOrder).length,
	                  bulkRefundingProgress: 0
	                });
	
	                progress = 0;
	
	                for (orderId in optionsByOrder) {
	                  try {
	                    progress += 1;
	
	                    this.setState({
	                      bulkRefundingProgress: progress
	                    });
	
	                    _PassActions2.default.refundPass({ orderId: orderId, options: optionsByOrder[orderId] });
	                  } catch (err) {
	                    console.error(err);
	                    console.error("refund on order " + orderId + " failed");
	                  }
	                }
	
	                this.setState({
	                  bulkRefundingComplete: true
	                });
	
	              case 7:
	              case "end":
	                return _context3.stop();
	            }
	          }
	        }, _callee3, this);
	      }));
	
	      function _onRefundPasses(_x2) {
	        return _ref3.apply(this, arguments);
	      }
	
	      return _onRefundPasses;
	    }()
	  }, {
	    key: "_closeRefundModal",
	    value: function _closeRefundModal() {
	      this.setState({
	        passesToRefund: null,
	        refundOptions: null
	      });
	    }
	  }, {
	    key: "_closeRefundStatusModal",
	    value: function _closeRefundStatusModal() {
	      this.setState({
	        passesToRefund: null,
	        refundOptions: null,
	        bulkRefunding: false,
	        bulkRefundingOrderCount: 0,
	        bulkRefundingProgress: 0
	      });
	    }
	  }, {
	    key: "_changeAutorenewalStatus",
	    value: function _changeAutorenewalStatus(id, shouldAutorenew) {
	      _PassActions2.default.editPassSubscription(id, {
	        should_autorenew: shouldAutorenew,
	        silent: true
	      });
	    }
	  }, {
	    key: "_manageSubscription",
	    value: function _manageSubscription(id) {
	      this.context.router.push({
	        pathname: this.props.location.pathname,
	        query: { pass_subscription: id },
	        state: { ignoreScrollBehavior: true }
	      });
	    }
	  }, {
	    key: "_closeSubscription",
	    value: function _closeSubscription() {
	      this.context.router.goBack();
	    }
	  }, {
	    key: "_onEditCheck",
	    value: function _onEditCheck(e) {
	      this.setState({ isEditing: !this.state.isEditing });
	    }
	  }, {
	    key: "_showSupplementaryData",
	    value: function _showSupplementaryData(pass, e) {
	      e.preventDefault();
	      e.stopPropagation();
	      this.context.router.push({
	        pathname: this.props.location.pathname,
	        query: { pass: pass.id },
	        state: { ignoreScrollBehavior: true }
	      });
	    }
	  }, {
	    key: "_closeSupplementaryData",
	    value: function _closeSupplementaryData() {
	      this.context.router.goBack();
	    }
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.componentWillReceiveProps(this.props);
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(props) {
	      if (props.location && props.location.query.highlight_pass && this.table && this.table.data.length) {
	        var rowLocation = this.table.data.findIndex(function (p) {
	          return p.data["Id"].value === props.location.query.highlight_pass;
	        }),
	            neededPage = Math.floor(rowLocation / PAGE_SIZE);
	
	        this.setState({
	          highlightedId: props.location.query.highlight_pass,
	          currentPage: neededPage
	        });
	      }
	
	      if (props.eventBucket && props.eventBucket !== this.state.fetchedBucket) {
	        this.setState({
	          fetchedBucket: props.eventBucket
	        }, function () {
	          _PassBucketActions2.default.fetchAllForEventBucket.defer(props.eventBucket);
	        });
	      }
	
	      if (props.location.query.pass_subscription && props.location.query.pass_subscription !== this.state.lastPassSubscription) {
	        _PassActions2.default.fetchPassSubscription.defer(props.location.query.pass_subscription);
	        this.setState({
	          lastPassSubscription: props.location.query.pass_subscription
	        });
	      }
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate() {
	      var _this5 = this;
	
	      if (this.highlightedRow && this.state.highlightedRow !== this.highlightedRow) {
	        this.setState({
	          highlightedRow: this.highlightedRow
	        }, function () {
	          setTimeout(function () {
	            if (_this5.highlightedRow && _this5.highlightedRow.scrollIntoViewIfNeeded) {
	              // chrome only
	              _this5.highlightedRow.scrollIntoViewIfNeeded();
	            } else if (_this5.highlightedRow) {
	              _this5.highlightedRow.scrollIntoView();
	            }
	          }, 0);
	        });
	      }
	    }
	  }, {
	    key: "_makeRowForPass",
	    value: function _makeRowForPass(passBuckets, eventBucketId, showTransferHistory, pass) {
	      var _this6 = this;
	
	      var isDeleted = _PassStore2.default.getState().deletedPasses[pass.id],
	          isSelected = this.state.selectedPasses && this.state.selectedPasses[pass.id],
	          shouldHighlight = this.state.highlightedId === pass.id;
	      var onCheck = this._onCheck.bind(this, pass);
	
	      // Inject person if needed
	      if ((!pass.person || !pass.person.email) && this.props.person) {
	        pass.person = this.props.person;
	      }
	
	      var passEventBucketId = _typeof(pass.event_bucket) === "object" ? pass.event_bucket.id : pass.event_bucket;
	
	      return _react2.default.createElement(
	        _reactable.Tr,
	        {
	          style: Object.assign({}, isDeleted && DELETED_ROW_STYLE, shouldHighlight && HIGHLIGHTED_ROW_STYLE),
	          key: pass.id
	        },
	        _react2.default.createElement(
	          _reactable.Td,
	          { column: " ", value: pass.id },
	          _react2.default.createElement(
	            "div",
	            { onClick: onCheck },
	            _react2.default.createElement(_materialUi.Checkbox, { label: " ", checked: isSelected })
	          )
	        ),
	        _react2.default.createElement(
	          _reactable.Td,
	          { column: "Id" },
	          pass.id
	        ),
	        _react2.default.createElement(
	          _reactable.Td,
	          { column: "Check-In", value: pass.checked_in_at },
	          _react2.default.createElement(
	            "span",
	            {
	              onTouchTap: function onTouchTap() {
	                return _this6.context.router.push({
	                  pathname: "/event_buckets/" + passEventBucketId + "/check_in",
	                  state: { selectedPassId: pass.id }
	                });
	              },
	              title: pass.checked_in_at ? "Checked in " + (0, _moment2.default)(pass.checked_in_at).format("lll") : "Not yet checked in",
	              style: { marginLeft: 0, marginRight: 0, cursor: "pointer" }
	            },
	            _react2.default.createElement(_checkCircle2.default, {
	              style: {
	                color: pass.checked_in_at ? "#4caf50" : "rgba(0,0,0,0.1)",
	                width: 20,
	                height: 20,
	                verticalAlign: -6
	              }
	            })
	          )
	        ),
	        _react2.default.createElement(
	          _reactable.Td,
	          {
	            column: "Person",
	            value: pass.person ? pass.person.name || pass.person.email : "Unknown Person"
	          },
	          pass.person ? _react2.default.createElement(
	            "div",
	            null,
	            pass.person.name || pass.person.email,
	            _react2.default.createElement(_inlineLinkIconButton2.default, {
	              onTouchTap: function onTouchTap() {
	                _this6.context.router.push("/event_buckets/" + eventBucketId + "/people/" + pass.person.id);
	              },
	              tooltip: "View person"
	            })
	          ) : "Unknown Person"
	        ),
	        _react2.default.createElement(
	          _reactable.Td,
	          { column: "Name", value: pass.name },
	          _react2.default.createElement(_passNameEditor2.default, { pass: pass, showEditButton: this.state.isEditing, isMembership: this.props.isMemberships })
	        ),
	        _react2.default.createElement(
	          _reactable.Td,
	          { column: "Pass Bucket" },
	          _react2.default.createElement(_passPassBucketEditor2.default, {
	            linkStyle: isDeleted && { color: "#ccc" },
	            pass: pass,
	            passBuckets: passBuckets,
	            showEditButton: this.state.isEditing
	          })
	        ),
	        _react2.default.createElement(
	          _reactable.Td,
	          { column: "Uses" },
	          pass.uses.length + (pass.uses_passes ? pass.uses_passes.length : 0)
	        ),
	        _react2.default.createElement(
	          _reactable.Td,
	          { column: "Order Date", value: pass.created_at },
	          _react2.default.createElement(
	            "div",
	            null,
	            (0, _moment2.default)(pass.created_at).format("lll"),
	            this.props.order || pass.order ? _react2.default.createElement(_inlineLinkIconButton2.default, {
	              onTouchTap: function onTouchTap() {
	                _this6.context.router.push("/event_buckets/" + eventBucketId + "/orders/" + (_this6.props.order || pass.order));
	              },
	              tooltip: "View order"
	            }) : null
	          )
	        ),
	        pass.pass_subscription ? _react2.default.createElement(
	          _reactable.Td,
	          {
	            column: "Renewal Date",
	            value: pass.pass_subscription.renewal_date,
	            style: pass.pass_subscription.status !== "active" ? { textDecoration: "line-through" } : {}
	          },
	          (0, _moment2.default)(pass.pass_subscription.renewal_date).format("ll")
	        ) : null,
	        pass.pass_subscription ? _react2.default.createElement(
	          _reactable.Td,
	          { column: "Autorenewal Status" },
	          _react2.default.createElement(
	            "span",
	            null,
	            pass.pass_subscription.status === "active" ? pass.pass_subscription.should_autorenew ? "Enabled" : "Disabled" : pass.pass_subscription.expired_date || pass.pass_subscription.status === "expired" ? "Expired" : "Canceled",
	            "\xA0",
	            _UserStore2.default.hasPermission("edit_pass") ? _react2.default.createElement(
	              "div",
	              null,
	              "(",
	              _react2.default.createElement(
	                _linkLike2.default,
	                {
	                  onTouchTap: function onTouchTap() {
	                    return _this6._manageSubscription(pass.pass_subscription.id);
	                  }
	                },
	                "manage"
	              ),
	              ")"
	            ) : null
	          )
	        ) : null,
	        pass.pass_bucket && pass.pass_bucket.supplementary_data && _UserStore2.default.hasPermission("edit_pass") ? _react2.default.createElement(
	          _reactable.Td,
	          { column: "Data" },
	          _react2.default.createElement(
	            "a",
	            { href: "#", onClick: this._showSupplementaryData.bind(this, pass) },
	            "View & edit"
	          )
	        ) : null,
	        _react2.default.createElement(
	          _reactable.Td,
	          { column: "Actions" },
	          _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement("div", {
	              ref: function ref(r) {
	                if (shouldHighlight) {
	                  _this6.highlightedRow = r;
	                }
	              }
	            }),
	            pass.pending_transfer_recipient && _UserStore2.default.hasPermission("manage_orders") ? _react2.default.createElement(
	              "span",
	              null,
	              _react2.default.createElement(
	                "i",
	                {
	                  title: "Pending transfer to " + pass.pending_transfer_recipient
	                },
	                "Pending\xA0",
	                _react2.default.createElement(
	                  "small",
	                  null,
	                  "[",
	                  _react2.default.createElement(
	                    "a",
	                    {
	                      style: isDeleted && { color: "#ccc" },
	                      href: "#",
	                      onClick: this._cancelTransfer.bind(this, pass.id)
	                    },
	                    "Cancel"
	                  ),
	                  "]"
	                )
	              )
	            ) : _UserStore2.default.hasPermission("manage_orders") ? _react2.default.createElement(
	              "a",
	              {
	                style: isDeleted && { color: "#ccc" },
	                href: "#",
	                onClick: this._transfer.bind(this, pass.id)
	              },
	              "Transfer"
	            ) : null,
	            "\xA0",
	            _UserStore2.default.hasPermission("manage_orders") ? _react2.default.createElement(
	              "a",
	              {
	                style: isDeleted && { color: "#ccc" },
	                href: "#",
	                onClick: this._print.bind(this, pass.id)
	              },
	              "Print"
	            ) : null,
	            "\xA0",
	            _react2.default.createElement(
	              "a",
	              {
	                title: "New passholder reservation",
	                style: isDeleted && { color: "#ccc" },
	                href: "#",
	                onClick: this._reserve.bind(this, pass.id, passEventBucketId)
	              },
	              "Use"
	            ),
	            "\xA0",
	            _UserStore2.default.hasPermission("manage_orders") && _react2.default.createElement(
	              "a",
	              {
	                style: isDeleted && { color: "#ccc" },
	                href: "#",
	                onClick: this._delete.bind(this, pass.id, pass.name)
	              },
	              "Delete"
	            ),
	            "\xA0",
	            _UserStore2.default.isGod() || showTransferHistory ? _react2.default.createElement(
	              "a",
	              {
	                style: isDeleted && { color: "#ccc" },
	                href: "#",
	                onClick: this._viewHistory.bind(this, pass.id, this.props.eventBucket)
	              },
	              "View History"
	            ) : null,
	            "\xA0"
	          )
	        )
	      );
	    }
	  }, {
	    key: "passIndexToArray",
	    value: function passIndexToArray(passesIndex) {
	      var _this7 = this;
	
	      return Object.keys(passesIndex).map(function (id) {
	        return _this7.props.passes.find(function (t) {
	          return t.id === id;
	        });
	      });
	    }
	  }, {
	    key: "passesEligibleForTransfer",
	    value: function passesEligibleForTransfer(passesIndex) {
	      var passes = this.passIndexToArray(passesIndex);
	
	      var passesEligible = passes.filter(function (p) {
	        return !p.pending_transfer_recipient;
	      });
	
	      return passesEligible;
	    }
	  }, {
	    key: "passesEligibleForTransferCancel",
	    value: function passesEligibleForTransferCancel(passesIndex) {
	      var passes = this.passIndexToArray(passesIndex);
	
	      var passesEligible = passes.filter(function (p) {
	        return !!p.pending_transfer_recipient;
	      });
	
	      return passesEligible;
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this8 = this;
	
	      var isSundance = this.props.isSundance;
	      var showTransferHistory = this.props.showTransferHistory;
	
	      var passBuckets = _PassBucketStore2.default.getPassBucketsForEventBucket(this.props.eventBucket),
	          hasSubscriptions = this.props.passes.some(function (p) {
	        return p.pass_subscription;
	      }),
	          hasSupplementaryData = this.props.passes.some(function (p) {
	        return p.pass_bucket && p.pass_bucket.supplementary_data;
	      }),
	          hasCheckIns = this.props.passes.some(function (p) {
	        return p.checked_in_at;
	      }),
	          hasInactivePasses = this.props.passes.some(function (p) {
	        return p.is_active === false;
	      }),
	          rows = this.props.passes.map(this._makeRowForPass.bind(this, passBuckets, this.props.eventBucket, isSundance || showTransferHistory)),
	          styles = {
	        config: {
	          borderBottom: "1px solid #ccc",
	          marginTop: 10,
	          paddingBottom: 10,
	          marginBottom: 10
	        }
	      },
	          openedSupplementaryDataPass = this.props.location.query.pass && this.props.passes.find(function (p) {
	        return p.id === _this8.props.location.query.pass;
	      });
	
	      var selectedPassCount = Object.keys(this.state.selectedPasses).length;
	      var _state = this.state;
	      var passesToDelete = _state.passesToDelete;
	      var passesToTransfer = _state.passesToTransfer;
	      var passesToRefund = _state.passesToRefund;
	      var refundOptions = _state.refundOptions;
	      var _props = this.props;
	      var passes = _props.passes;
	      var eventBucket = _props.eventBucket;
	
	
	      var selectedPassesEligibleForTransfer = this.passesEligibleForTransfer(this.state.selectedPasses);
	      var selectedPassesEligibleForTransferCancel = this.passesEligibleForTransferCancel(this.state.selectedPasses);
	      var passPluralized = "pass" + (selectedPassCount === 1 ? "" : "es");
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        !!passesToRefund ? _react2.default.createElement(_refund2.default, {
	          options: refundOptions,
	          onRefund: this._onRefundPasses,
	          refundErrorMessage: this.state.refundErrorMessage,
	          onRequestClose: this._closeRefundModal
	        }) : null,
	        this.state.bulkRefunding ? _react2.default.createElement(_loading2.default, {
	          onRequestClose: this._closeRefundStatusModal,
	          message: this.state.bulkRefundingComplete ? "Refunds complete!" : "Refunding " + this.state.bulkRefundingProgress + "/" + this.state.bulkRefundingOrderCount + " orders",
	          complete: this.state.bulkRefundingComplete
	        }) : null,
	        !!passesToDelete ? _react2.default.createElement(_bulkDeleteOverlay2.default, {
	          submitting: this.props.isFetching,
	          items: passesToDelete,
	          itemName: "pass" + (passesToDelete.length !== 1 ? "es" : ""),
	          eventBucketId: eventBucket || (passes[0] ? passes[0].event.event_bucket : ""),
	          onClose: this._closeDeleteModal,
	          onDelete: this._onDeletePasses
	        }) : null,
	        this.state.currentlyTransferring ? _react2.default.createElement(_transferOverlay2.default, {
	          onRequestClose: this._closeTransferModal,
	          onTransfer: this._submitTransfer,
	          type: "pass",
	          typeName: this.props.isMemberships ? "membership" + (selectedPassesEligibleForTransfer.length !== 1 ? "s" : "") : "pass" + (selectedPassesEligibleForTransfer.length !== 1 ? "es" : "")
	        }) : null,
	        !!passesToTransfer ? _react2.default.createElement(_transferOverlay2.default, {
	          onRequestClose: this._closeTransferModal,
	          onTransfer: this._submitBulkTransfer,
	          bulkCount: selectedPassesEligibleForTransfer.length,
	          typeName: this.props.isMemberships ? "membership" + (selectedPassesEligibleForTransfer.length !== 1 ? "s" : "") : "pass" + (selectedPassesEligibleForTransfer.length !== 1 ? "es" : ""),
	          type: "pass"
	        }) : null,
	        this.state.currentlyPrinting ? _react2.default.createElement(_printPassesModal2.default, {
	          id: this.state.currentlyPrinting,
	          eventBucket: this.props.eventBucket,
	          requestClose: this._closePrintModal,
	          isMembership: this.props.isMemberships
	        }) : null,
	        openedSupplementaryDataPass ? _react2.default.createElement(_supplementaryDataModal2.default, {
	          pass: openedSupplementaryDataPass,
	          person: this.props.person,
	          requestClose: this._closeSupplementaryData
	        }) : null,
	        this.props.location.query.pass_subscription ? _react2.default.createElement(_passSubscriptionModal2.default, {
	          passSubscription: this.props.getPassSubscriptionById(this.props.location.query.pass_subscription),
	          person: this.props.person,
	          requestClose: this._closeSubscription
	        }) : null,
	        hasInactivePasses ? _react2.default.createElement(
	          "div",
	          { style: { fontStyle: "italic" } },
	          "Note: Passes marked as",
	          " ",
	          _react2.default.createElement(
	            "span",
	            {
	              style: {
	                backgroundColor: "red",
	                borderRadius: 5,
	                padding: "2px 4px",
	                color: "white"
	              }
	            },
	            "Deactivated"
	          ),
	          " ",
	          "are not allowed to place new orders."
	        ) : null,
	        _UserStore2.default.hasPermission("edit_pass") ? _react2.default.createElement(
	          "div",
	          { style: styles.config },
	          _react2.default.createElement(_materialUi.Checkbox, {
	            checked: this.state.isEditing,
	            label: "Enter edit mode",
	            onCheck: this._onEditCheck
	          })
	        ) : null,
	        _react2.default.createElement(
	          "div",
	          {
	            style: this.props.order || this.props.person ? { float: "right", marginBottom: -36, marginRight: "-1em" } : { position: "absolute", right: 40, marginTop: 18 }
	          },
	          rows.length && selectedPassCount > 0 ? _react2.default.createElement(
	            "div",
	            { style: { display: "inline-block" } },
	            _react2.default.createElement(_materialUi.RaisedButton, {
	              label: "Bulk Actions (" + selectedPassCount + ")",
	              style: { marginRight: "1em" },
	              onTouchTap: function onTouchTap(e) {
	                e.preventDefault();
	                _this8.setState({
	                  bulkActionsPopoverOpen: true,
	                  bulkActionsPopoverAnchorEl: e.currentTarget
	                });
	              }
	            }),
	            _react2.default.createElement(
	              _materialUi.Popover,
	              {
	                open: this.state.bulkActionsPopoverOpen,
	                anchorEl: this.state.bulkActionsPopoverAnchorEl,
	                onRequestClose: function onRequestClose() {
	                  return _this8.setState({ bulkActionsPopoverOpen: false });
	                }
	              },
	              _react2.default.createElement(
	                _materialUi.Menu,
	                { desktop: true },
	                _react2.default.createElement(_materialUi.MenuItem, {
	                  disabled: selectedPassesEligibleForTransferCancel.length === 0,
	                  primaryText: "Cancel " + selectedPassesEligibleForTransferCancel.length + " pass transfer" + (selectedPassesEligibleForTransferCancel.length === 1 ? "" : "s"),
	                  onTouchTap: function onTouchTap() {
	                    return _this8._bulkCancelTransfer(selectedPassesEligibleForTransferCancel);
	                  },
	                  style: { marginRight: "1em" }
	                }),
	                _react2.default.createElement(_materialUi.MenuItem, {
	                  disabled: selectedPassCount === 0,
	                  primaryText: "Refund " + selectedPassCount + " " + passPluralized,
	                  onTouchTap: function onTouchTap() {
	                    return _this8._showRefundModal();
	                  },
	                  style: { marginRight: "1em" }
	                }),
	                _react2.default.createElement(_materialUi.MenuItem, {
	                  disabled: selectedPassesEligibleForTransfer.length === 0,
	                  primaryText: "Transfer " + selectedPassesEligibleForTransfer.length + " pass" + (selectedPassesEligibleForTransfer.length === 1 ? "" : "es"),
	                  onTouchTap: function onTouchTap() {
	                    return _this8._showBulkTransferModal();
	                  },
	                  style: { marginRight: "1em" }
	                }),
	                _react2.default.createElement(_materialUi.MenuItem, {
	                  primaryText: "Delete " + selectedPassCount + " pass" + (selectedPassCount === 1 ? "" : "es"),
	                  onTouchTap: function onTouchTap() {
	                    return _this8._showDeleteModal();
	                  },
	                  style: { marginRight: "1em" }
	                })
	              )
	            )
	          ) : null,
	          this.props.order || this.props.person ? _react2.default.createElement(_materialUi.RaisedButton, {
	            style: { marginRight: "1em" },
	            onTouchTap: this._print.bind(this, this.props.passes.map(function (p) {
	              return p.id;
	            })),
	            label: "Print all"
	          }) : null
	        ),
	        _react2.default.createElement(
	          _reactable.Table,
	          {
	            ref: function ref(r) {
	              _this8.table = r;
	            },
	            className: "bordered striped responsive-table pass-table " + (this.state.isEditing ? "editing" : "not-editing"),
	            sortable: [{ column: "Order Date", sortFunction: _reactable.Sort.Date }, { column: "Name", sortFunction: _reactable.Sort.CaseInsensitive }, { column: "Person", sortFunction: _reactable.Sort.CaseInsensitive }, "Pass Bucket", "Uses", "Renewal Date"],
	            defaultSort: { column: "Order Date", direction: "desc" },
	            columns: (rows.length ? [{
	              key: " ",
	              label: _react2.default.createElement(_materialUi.Checkbox, {
	                iconStyle: { fill: "#fff" },
	                checked: selectedPassCount === rows.length,
	                onCheck: this._onCheckAll
	              })
	            }] : []).concat(hasCheckIns ? [{
	              key: "Check-In",
	              label: _react2.default.createElement(_checkCircle2.default, {
	                style: {
	                  color: "#fff",
	                  width: 20,
	                  height: 20,
	                  verticalAlign: -6
	                }
	              })
	            }] : []).concat(["Name"]).concat(this.props.isSinglePerson ? [] : ["Person"]).concat(this.props.hidePassBucket && !this.state.isEditing ? [] : [{ key: "Pass Bucket", label: this.props.isMemberships ? "Membership Bucket" : "Pass Bucket" }]).concat(["Uses", "Order Date"]).concat(hasSubscriptions ? ["Renewal Date", "Autorenewal Status"] : []).concat(hasSupplementaryData && _UserStore2.default.hasPermission("edit_pass_bucket") ? ["Data"] : []).concat(["Actions"]),
	            filterable: ["Name", "Person", "Pass Bucket"],
	            filterPlaceholder: "Type to filter...",
	            itemsPerPage: rows.length > PAGE_SIZE ? PAGE_SIZE : undefined,
	            currentPage: this.state.currentPage,
	            onPageChange: function onPageChange(p) {
	              return _this8.setState({ currentPage: p });
	            }
	          },
	          rows
	        ),
	        rows.length === 0 && !this.props.hideNoPassesMessage ? _react2.default.createElement(
	          "div",
	          { className: "empty-table-message" },
	          "No ",
	          this.props.isMemberships ? "memberships" : "passes",
	          " yet."
	        ) : null
	      );
	    }
	  }], [{
	    key: "getStores",
	    value: function getStores() {
	      return [_PassBucketStore2.default, _PassStore2.default];
	    }
	  }, {
	    key: "getPropsFromStores",
	    value: function getPropsFromStores() {
	      var state = _PassBucketStore2.default.getState();
	      state.getPassSubscriptionById = _PassStore2.default.getPassSubscriptionById;
	      return state;
	    }
	  }, {
	    key: "contextTypes",
	    get: function get() {
	      return {
	        router: _react2.default.PropTypes.object
	      };
	    }
	  }]);
	
	  return PassTable;
	}(_react2.default.Component);
	
	exports.default = (0, _connectToStores2.default)(PassTable);
	module.exports = exports["default"];

/***/ }),
/* 2739 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _materialUi = __webpack_require__(576);
	
	var _moment = __webpack_require__(1021);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _util = __webpack_require__(1183);
	
	var _PassActions = __webpack_require__(2047);
	
	var _PassActions2 = _interopRequireDefault(_PassActions);
	
	var _PassStore = __webpack_require__(2048);
	
	var _PassStore2 = _interopRequireDefault(_PassStore);
	
	var _base = __webpack_require__(1755);
	
	var _base2 = _interopRequireDefault(_base);
	
	var _linkLike = __webpack_require__(973);
	
	var _linkLike2 = _interopRequireDefault(_linkLike);
	
	var _workingIndicator = __webpack_require__(1664);
	
	var _workingIndicator2 = _interopRequireDefault(_workingIndicator);
	
	var _datepicker = __webpack_require__(2272);
	
	var _datepicker2 = _interopRequireDefault(_datepicker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PassSubscriptionModal = function (_React$Component) {
	  _inherits(PassSubscriptionModal, _React$Component);
	
	  function PassSubscriptionModal(props) {
	    _classCallCheck(this, PassSubscriptionModal);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(PassSubscriptionModal).call(this, props));
	
	    _this.state = {
	      dirty: false,
	      values: {},
	      editingRenewalDate: false
	    };
	
	    _this.onChangeValue = _this.onChangeValue.bind(_this);
	    _this.cancel = _this.cancel.bind(_this);
	    _this.submit = _this.submit.bind(_this);
	    _this.cancelSubscription = _this.cancelSubscription.bind(_this);
	    return _this;
	  }
	
	  _createClass(PassSubscriptionModal, [{
	    key: "getStyles",
	    value: function getStyles() {
	      return {
	        actions: {
	          marginTop: 15
	        },
	        dialogTitle: {
	          borderBottom: "none"
	        },
	        dialogActionsContainer: {
	          borderTop: "none"
	        },
	        debug: {
	          fontSize: "0.5em",
	          fontFamily: "monospace",
	          wordWrap: "break-word",
	          lineHeight: 1,
	          marginTop: "2em",
	          marginBottom: "-2em",
	          height: 30,
	          overflow: "scroll"
	        }
	      };
	    }
	  }, {
	    key: "onChangeValue",
	    value: function onChangeValue(id, value, cb) {
	      this.state.dirty = true;
	      this.state.values[id] = value;
	      this.setState(this.state, cb);
	    }
	  }, {
	    key: "cancel",
	    value: function cancel() {
	      this.props.requestClose();
	    }
	  }, {
	    key: "submit",
	    value: function submit() {
	      if (this.props.onSubmit) {
	        this.props.onSubmit(this.state.values);
	        return;
	      }
	
	      this.setState({ editingRenewalDate: false });
	      _PassActions2.default.editPassSubscription(this.props.passSubscription.id, this.state.values);
	
	      // Don't close - show updates reflected
	      // this.props.requestClose();
	    }
	  }, {
	    key: "cancelSubscription",
	    value: function cancelSubscription() {
	      var _this2 = this;
	
	      if (window.confirm("Are you sure? Cancellation is immediate and ends all pass privileges.")) {
	        this.setState({
	          values: {
	            cancel: true
	          }
	        }, function () {
	          _this2.submit();
	        });
	      }
	    }
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.componentWillReceiveProps(this.props);
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(newProps) {
	      if (newProps.passSubscription) {
	        this.setState({
	          dirty: false,
	          values: {
	            silent: true,
	            should_autorenew: newProps.passSubscription.should_autorenew,
	            renewal_date: newProps.passSubscription.renewal_date
	          }
	        });
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this3 = this;
	
	      var styles = this.getStyles();
	      var passSubscription = this.props.passSubscription;
	
	
	      return _react2.default.createElement(
	        _base2.default,
	        {
	          title: "Manage subscription",
	          titleStyle: styles.dialogTitle,
	          actionsContainerStyle: styles.dialogActionsContainer,
	          useMuiDefaultStyle: true,
	          openImmediately: true,
	          actions: [_react2.default.createElement(_materialUi.FlatButton, { label: "Close", onTouchTap: this.cancel }), _react2.default.createElement(_materialUi.FlatButton, {
	            disabled: !this.state.dirty,
	            primary: true,
	            label: "Update subscription",
	            onTouchTap: this.submit
	          })],
	          modal: true,
	          open: true,
	          onRequestClose: this.cancel
	        },
	        passSubscription && !_PassStore2.default.getState().isEditing ? _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement(
	            "div",
	            null,
	            "Customer:",
	            " ",
	            _react2.default.createElement(
	              "strong",
	              null,
	              passSubscription.person.name || passSubscription.person.email
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            null,
	            "Subscription:",
	            " ",
	            _react2.default.createElement(
	              "strong",
	              null,
	              passSubscription.quantity,
	              "x ",
	              passSubscription.pass_bucket.name
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            null,
	            "Status: ",
	            _react2.default.createElement(
	              "strong",
	              null,
	              (0, _util.capitalize)(passSubscription.status)
	            )
	          ),
	          passSubscription.status === "active" ? _react2.default.createElement(
	            "div",
	            { style: { marginTop: "1em" } },
	            _react2.default.createElement(
	              "div",
	              null,
	              this.state.values.should_autorenew ? "Renewal" : "Expiration",
	              " ",
	              "date:",
	              " ",
	              _react2.default.createElement(
	                "strong",
	                null,
	                (0, _moment2.default)(this.state.values.renewal_date).format("LL")
	              )
	            ),
	            _react2.default.createElement(_materialUi.Toggle, {
	              toggled: this.state.values.should_autorenew,
	              onToggle: function onToggle(e, checked) {
	                _this3.onChangeValue("should_autorenew", checked);
	              },
	              label: this.state.values.should_autorenew ? "Autorenewal enabled" : "Autorenewal disabled",
	              style: { width: "auto" },
	              labelStyle: { color: "auto" },
	              labelPosition: "right"
	            })
	          ) : _react2.default.createElement(
	            "div",
	            { style: { marginTop: "1em" } },
	            _react2.default.createElement(
	              "div",
	              null,
	              "Scheduled renewal date:",
	              " ",
	              _react2.default.createElement(
	                "strong",
	                null,
	                _react2.default.createElement(
	                  "del",
	                  null,
	                  (0, _moment2.default)(passSubscription.renewal_date).format("LL")
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              null,
	              passSubscription.status === "canceled" ? "Cancellation" : "Expiration",
	              " ",
	              "date:",
	              " ",
	              _react2.default.createElement(
	                "strong",
	                null,
	                (0, _moment2.default)(passSubscription.expired_date || passSubscription.renewal_date).format("LL")
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { style: { marginTop: "1em" } },
	            passSubscription.status !== "active" ? _react2.default.createElement(
	              "div",
	              null,
	              "This subscription has",
	              " ",
	              passSubscription.status === "canceled" ? _react2.default.createElement(
	                "span",
	                null,
	                "been ",
	                _react2.default.createElement(
	                  "strong",
	                  null,
	                  "canceled"
	                )
	              ) : _react2.default.createElement(
	                "strong",
	                null,
	                "expired"
	              ),
	              ". You can",
	              this.state.reopeningSubscription ? _react2.default.createElement(
	                "span",
	                null,
	                " ",
	                "use the below options to reopen the subscription and then click \"Update Subscription\" to submit, or",
	                " ",
	                _react2.default.createElement(
	                  _linkLike2.default,
	                  {
	                    onTouchTap: function onTouchTap() {
	                      return _this3.setState({ reopeningSubscription: false });
	                    }
	                  },
	                  "undo changes"
	                )
	              ) : ":",
	              !this.state.reopeningSubscription ? _react2.default.createElement(
	                "div",
	                { style: { marginTop: "0.5em" } },
	                _react2.default.createElement(_materialUi.RaisedButton, {
	                  label: "Reopen subscription...",
	                  primary: true,
	                  onTouchTap: function onTouchTap() {
	                    _this3.setState({ reopeningSubscription: true }, function () {
	                      _this3.onChangeValue("new_renewal_charge_now", true, function () {
	                        _this3.onChangeValue("new_renewal_date", (0, _moment2.default)().add(passSubscription.pass_bucket.recurrence_count || 1, passSubscription.pass_bucket.recurrence_interval || "year").toISOString());
	                      });
	                    });
	                  }
	                })
	              ) : _react2.default.createElement(
	                "div",
	                null,
	                _react2.default.createElement(
	                  "div",
	                  null,
	                  _react2.default.createElement(_datepicker2.default, {
	                    style: { display: "inline-block" },
	                    value: this.state.values.new_renewal_date,
	                    label: "Next renewal date",
	                    returnFormat: null // date object
	                    , onChange: function onChange(v) {
	                      return _this3.onChangeValue("new_renewal_date", v.toISOString());
	                    },
	                    errorText: (0, _moment2.default)().isAfter((0, _moment2.default)(this.state.values.new_renewal_date)) && "Next renewal date must be in the future"
	                  })
	                ),
	                _react2.default.createElement(
	                  _materialUi.RadioButtonGroup,
	                  {
	                    style: { marginTop: "0.5em" },
	                    name: "new-charge",
	                    valueSelected: this.state.values.new_renewal_charge_now,
	                    onChange: function onChange(e, value) {
	                      return _this3.onChangeValue("new_renewal_charge_now", value);
	                    }
	                  },
	                  _react2.default.createElement(_materialUi.RadioButton, {
	                    value: true,
	                    label: "Charge customer immediately, then charge again on above renewal date (" + (0, _moment2.default)(this.state.values.new_renewal_date).format("LL") + ")"
	                  }),
	                  _react2.default.createElement(_materialUi.RadioButton, {
	                    value: false,
	                    label: "Do not charge the customer until above renewal date (" + (0, _moment2.default)(this.state.values.new_renewal_date).format("LL") + ")"
	                  })
	                )
	              )
	            ) : _react2.default.createElement(
	              "div",
	              null,
	              this.state.editingRenewalDate ? _react2.default.createElement(
	                "div",
	                null,
	                _react2.default.createElement(
	                  "div",
	                  null,
	                  "Enter a new",
	                  " ",
	                  this.state.values.should_autorenew ? "renewal" : "expiration",
	                  " ",
	                  "date sometime in the future & click \"Update Subscription\" to modify the subscription, or",
	                  " ",
	                  _react2.default.createElement(
	                    _linkLike2.default,
	                    {
	                      onTouchTap: function onTouchTap() {
	                        return _this3.setState({ editingRenewalDate: false }, function () {
	                          return _this3.onChangeValue("renewal_date", passSubscription.renewal_date);
	                        });
	                      }
	                    },
	                    "undo changes"
	                  )
	                ),
	                _react2.default.createElement(_datepicker2.default, {
	                  style: { display: "inline-block" },
	                  value: this.state.values.renewal_date,
	                  label: "Renewal date",
	                  returnFormat: null // date object
	                  , onChange: function onChange(v) {
	                    return _this3.onChangeValue("renewal_date", v.toISOString());
	                  },
	                  errorText: (0, _moment2.default)().isAfter((0, _moment2.default)(this.state.values.renewal_date)) && "Renewal date must be in the future"
	                })
	              ) : _react2.default.createElement(
	                "div",
	                null,
	                _react2.default.createElement(
	                  "div",
	                  null,
	                  "This subscription is currently active and will",
	                  " ",
	                  this.state.values.should_autorenew ? "renew" : "expire",
	                  " ",
	                  (0, _moment2.default)(passSubscription.renewal_date).fromNow(),
	                  ".",
	                  " ",
	                  _react2.default.createElement(
	                    _linkLike2.default,
	                    {
	                      onTouchTap: function onTouchTap() {
	                        return _this3.setState({ editingRenewalDate: true });
	                      }
	                    },
	                    "Edit",
	                    " ",
	                    this.state.values.should_autorenew ? "renewal" : "expiration",
	                    " ",
	                    "date"
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { style: { marginTop: "1em", fontSize: "0.8em" } },
	                  "You can also",
	                  " ",
	                  _react2.default.createElement(
	                    _linkLike2.default,
	                    { onTouchTap: function onTouchTap() {
	                        return _this3.cancelSubscription();
	                      } },
	                    "immediately cancel this subscription"
	                  ),
	                  ".",
	                  " ",
	                  _react2.default.createElement(
	                    "small",
	                    null,
	                    "(All passes will stop working. No refund will be issued.)"
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { style: styles.debug },
	            _react2.default.createElement(
	              "strong",
	              null,
	              "TROUBLESHOOTING INFORMATION:"
	            ),
	            " ",
	            JSON.stringify(passSubscription)
	          )
	        ) : _react2.default.createElement(_workingIndicator2.default, { centered: true })
	      );
	    }
	  }]);
	
	  return PassSubscriptionModal;
	}(_react2.default.Component);
	
	exports.default = PassSubscriptionModal;
	module.exports = exports["default"];

/***/ }),
/* 2740 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _materialUi = __webpack_require__(576);
	
	var _util = __webpack_require__(1183);
	
	var util = _interopRequireWildcard(_util);
	
	var _assign = __webpack_require__(920);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _inlineLinkIconButton = __webpack_require__(1704);
	
	var _inlineLinkIconButton2 = _interopRequireDefault(_inlineLinkIconButton);
	
	var _PassActions = __webpack_require__(2047);
	
	var _PassActions2 = _interopRequireDefault(_PassActions);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PassNameEditor = function (_React$Component) {
	  _inherits(PassNameEditor, _React$Component);
	
	  function PassNameEditor(props) {
	    _classCallCheck(this, PassNameEditor);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(PassNameEditor).call(this, props));
	
	    _this.state = {
	      isEditing: false,
	      isSaving: false,
	      isUpdatingActiveState: false,
	      _lastUpdatedAt: null,
	      updatedName: ""
	    };
	
	    _this._save = _this._save.bind(_this);
	    _this._startEditing = _this._startEditing.bind(_this);
	    _this._toggleActive = _this._toggleActive.bind(_this);
	    return _this;
	  }
	
	  _createClass(PassNameEditor, [{
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(newProps) {
	      if (newProps.pass.updated_at !== this.state._lastUpdatedAt) {
	        this.setState({
	          isSaving: false,
	          isEditing: false
	        });
	      }
	
	      if (this.state.isUpdatingActiveState && newProps.pass.is_active !== this.props.pass.is_active) {
	        this.setState({ isUpdatingActiveState: false });
	      }
	    }
	  }, {
	    key: "_save",
	    value: function _save() {
	      var _this2 = this;
	
	      this.setState({
	        isSaving: true,
	        _lastUpdatedAt: this.props.pass.updated_at
	      }, function () {
	        _PassActions2.default.edit(_this2.props.pass.id, {
	          name: _this2.state.updatedName
	        });
	      });
	    }
	  }, {
	    key: "_toggleActive",
	    value: function _toggleActive(e) {
	      var _this3 = this;
	
	      e.preventDefault();
	      this.setState({
	        isUpdatingActiveState: true,
	        _lastUpdatedAt: this.props.pass.updated_at
	      }, function () {
	        _PassActions2.default.edit(_this3.props.pass.id, {
	          is_active: !_this3.props.pass.is_active
	        });
	      });
	    }
	  }, {
	    key: "_startEditing",
	    value: function _startEditing(e) {
	      e.preventDefault();
	      this.setState({
	        isEditing: true,
	        updatedName: this.props.pass.name
	      });
	    }
	  }, {
	    key: "getStyles",
	    value: function getStyles() {
	      return {
	        editor: {
	          marginTop: -13,
	          marginBottom: -12,
	          minWidth: 264
	        },
	        editButton: {
	          marginLeft: 12,
	          height: 28
	        },
	        editButtonLabel: {
	          lineHeight: "28px"
	        },
	        textField: {
	          lineHeight: "16px",
	          height: 40,
	          width: "60%",
	          maxWidth: 250
	        }
	      };
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this4 = this;
	
	      var _props = this.props;
	      var pass = _props.pass;
	      var isMembership = _props.isMembership;
	      var styles = this.getStyles();
	
	      return this.state.isEditing ? _react2.default.createElement(
	        "div",
	        { style: styles.editor },
	        _react2.default.createElement(_materialUi.TextField, {
	          disabled: this.state.isSaving,
	          style: styles.textField,
	          onKeyDown: function onKeyDown(e) {
	            return e.keyCode === 13 && _this4._save();
	          },
	          placeholder: "Name",
	          value: this.state.updatedName,
	          onChange: function onChange(e) {
	            return _this4.setState((0, _assign2.default)({}, _this4.state, { updatedName: e.target.value }));
	          }
	        }),
	        "\xA0",
	        _react2.default.createElement(_materialUi.RaisedButton, {
	          label: this.state.isSaving ? "Saving..." : "Save",
	          primary: true,
	          disabled: this.state.isSaving,
	          style: styles.editButton,
	          labelStyle: styles.editButtonLabel,
	          onTouchTap: this._save
	        })
	      ) : _react2.default.createElement(
	        "div",
	        { style: { whiteSpace: "nowrap" } },
	        pass.is_active === false ? _react2.default.createElement(
	          "span",
	          { style: { whiteSpace: "normal" } },
	          _react2.default.createElement(
	            "span",
	            { style: { textDecoration: "line-through" } },
	            pass.name
	          ),
	          " ",
	          _react2.default.createElement(
	            "span",
	            {
	              style: {
	                fontStyle: "italic",
	                backgroundColor: "red",
	                borderRadius: 5,
	                padding: "2px 4px",
	                color: "white",
	                fontSize: 10,
	                verticalAlign: 1
	              }
	            },
	            "Deactivated"
	          )
	        ) : pass.name,
	        this.props.showEditButton ? _react2.default.createElement(
	          "span",
	          null,
	          " "
	        ) : _react2.default.createElement(_inlineLinkIconButton2.default, {
	          onTouchTap: function onTouchTap() {
	            _this4.context.router.push({
	              pathname: "/event_buckets/" + (pass.event_bucket.id || pass.event_bucket) + "/people/" + pass.person.id,
	              query: { highlight_pass: pass.id },
	              state: { ignoreScrollBehavior: true }
	            });
	          },
	          tooltip: isMembership ? "View membership" : "View pass"
	        }),
	        this.props.showEditButton && (this.state.isUpdatingActiveState ? "(updating...)" : _react2.default.createElement(
	          "span",
	          null,
	          "(",
	          _react2.default.createElement(
	            "a",
	            {
	              style: this.props.linkStyle,
	              href: "#",
	              onClick: this._startEditing
	            },
	            "edit"
	          ),
	          " ",
	          "\xB7",
	          " ",
	          _react2.default.createElement(
	            "a",
	            {
	              style: this.props.linkStyle,
	              href: "#",
	              onClick: this._toggleActive
	            },
	            pass.is_active === false ? "activate" : "deactivate"
	          ),
	          ")"
	        ))
	      );
	    }
	  }]);
	
	  return PassNameEditor;
	}(_react2.default.Component);
	
	PassNameEditor.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	exports.default = PassNameEditor;
	module.exports = exports["default"];

/***/ }),
/* 2741 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _materialUi = __webpack_require__(576);
	
	var _inlineLinkIconButton = __webpack_require__(1704);
	
	var _inlineLinkIconButton2 = _interopRequireDefault(_inlineLinkIconButton);
	
	var _PassActions = __webpack_require__(2047);
	
	var _PassActions2 = _interopRequireDefault(_PassActions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PassSubtitleEditor = function (_React$Component) {
	  _inherits(PassSubtitleEditor, _React$Component);
	
	  function PassSubtitleEditor(props) {
	    _classCallCheck(this, PassSubtitleEditor);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(PassSubtitleEditor).call(this, props));
	
	    _this.state = {
	      isEditing: false,
	      isSaving: false,
	      _lastUpdatedAt: null,
	      updatedBucket: null
	    };
	
	    _this._save = _this._save.bind(_this);
	    _this._onChange = _this._onChange.bind(_this);
	    _this._startEditing = _this._startEditing.bind(_this);
	    return _this;
	  }
	
	  _createClass(PassSubtitleEditor, [{
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(newProps) {
	      if (newProps.pass.updated_at !== this.state._lastUpdatedAt) {
	        this.setState({
	          isSaving: false,
	          isEditing: false
	        });
	      }
	    }
	  }, {
	    key: "_save",
	    value: function _save() {
	      var _this2 = this;
	
	      if (!this.state.updatedBucket) {
	        this.setState({
	          isEditing: false,
	          updatedBucket: null
	        });
	        return;
	      }
	
	      this.setState({
	        isSaving: true,
	        _lastUpdatedAt: this.props.pass.updated_at
	      }, function () {
	        _PassActions2.default.edit(_this2.props.pass.id, {
	          pass_bucket: _this2.state.updatedBucket
	        });
	      });
	    }
	  }, {
	    key: "_startEditing",
	    value: function _startEditing(e) {
	      e.preventDefault();
	      this.setState({
	        isEditing: true
	      });
	    }
	  }, {
	    key: "_onChange",
	    value: function _onChange(e, index, value) {
	      this.setState({
	        updatedBucket: value
	      });
	    }
	  }, {
	    key: "getStyles",
	    value: function getStyles() {
	      return {
	        editor: {
	          marginTop: -13,
	          marginBottom: 4
	        },
	        editButton: {
	          height: 28
	        },
	        editButtonLabel: {
	          lineHeight: "28px"
	        },
	        textField: {
	          lineHeight: "16px",
	          height: 40,
	          width: "60%",
	          maxWidth: 250
	        }
	      };
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this3 = this;
	
	      var _props = this.props;
	      var pass = _props.pass;
	      var passBuckets = _props.passBuckets;
	      var styles = this.getStyles();
	
	      var menuItems = passBuckets.map(function (b, i) {
	        return _react2.default.createElement(_materialUi.MenuItem, {
	          key: i,
	          primaryText: b.name,
	          value: b.id,
	          style: { cursor: "pointer" }
	        });
	      });
	
	      return this.state.isEditing ? _react2.default.createElement(
	        "div",
	        { style: styles.editor },
	        _react2.default.createElement(
	          _materialUi.DropDownMenu,
	          {
	            style: { marginLeft: -24 },
	            value: this.state.updatedBucket || pass.pass_bucket.id,
	            onChange: this._onChange
	          },
	          menuItems
	        ),
	        _react2.default.createElement(
	          "div",
	          { style: { marginTop: 5 } },
	          _react2.default.createElement(_materialUi.RaisedButton, {
	            label: this.state.isSaving ? "Saving..." : "Save",
	            primary: true,
	            disabled: this.state.isSaving,
	            style: styles.editButton,
	            labelStyle: styles.editButtonLabel,
	            onTouchTap: this._save
	          })
	        )
	      ) : _react2.default.createElement(
	        "div",
	        { style: { whiteSpace: "nowrap" } },
	        pass.pass_bucket.name,
	        this.props.showEditButton ? _react2.default.createElement(
	          "span",
	          null,
	          " "
	        ) : _react2.default.createElement(_inlineLinkIconButton2.default, {
	          onTouchTap: function onTouchTap() {
	            _this3.context.router.push("/event_buckets/" + (pass.event_bucket.id || pass.event_bucket) + "/" + (pass.pass_bucket.is_membership ? "memberships" : "pass_buckets") + "/" + pass.pass_bucket.id);
	          },
	          tooltip: "View " + (pass.pass_bucket.is_membership ? "membership" : "pass bucket")
	        }),
	        this.props.showEditButton && _react2.default.createElement(
	          "span",
	          null,
	          "(",
	          _react2.default.createElement(
	            "a",
	            { href: "#", onClick: this._startEditing },
	            "edit"
	          ),
	          ")"
	        )
	      );
	    }
	  }]);
	
	  return PassSubtitleEditor;
	}(_react2.default.Component);
	
	PassSubtitleEditor.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	exports.default = PassSubtitleEditor;
	module.exports = exports["default"];

/***/ }),
/* 2742 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _materialUi = __webpack_require__(576);
	
	var _qs = __webpack_require__(1206);
	
	var _qs2 = _interopRequireDefault(_qs);
	
	var _UserStore = __webpack_require__(974);
	
	var _UserStore2 = _interopRequireDefault(_UserStore);
	
	var _config = __webpack_require__(1173);
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DownloadPassBucketCsvButton = function (_React$Component) {
	  _inherits(DownloadPassBucketCsvButton, _React$Component);
	
	  function DownloadPassBucketCsvButton(props) {
	    _classCallCheck(this, DownloadPassBucketCsvButton);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(DownloadPassBucketCsvButton).call(this, props));
	
	    _this.state = {
	      open: false,
	      anchorEl: null
	    };
	
	    _this._onClick = _this._onClick.bind(_this);
	    _this._onClose = _this._onClose.bind(_this);
	    _this.download = _this.download.bind(_this);
	    return _this;
	  }
	
	  _createClass(DownloadPassBucketCsvButton, [{
	    key: "_onClick",
	    value: function _onClick(e) {
	      e.preventDefault();
	
	      this.setState({
	        open: true,
	        anchorEl: e.currentTarget
	      });
	    }
	  }, {
	    key: "_onClose",
	    value: function _onClose() {
	      this.setState({ open: false });
	    }
	  }, {
	    key: "download",
	    value: function download(includeTickets) {
	      var _props$downloadType = this.props.downloadType;
	      var downloadType = _props$downloadType === undefined ? "all" : _props$downloadType;
	
	
	      var query = {
	        include_tickets: includeTickets,
	        type: downloadType
	      };
	
	      window.open("" + _config2.default.endpoint + (this.props.passBucketId ? "pass_buckets/" + this.props.passBucketId : "event_buckets/" + this.props.eventBucketId) + "/passes.csv?" + _UserStore2.default.makeApiKeyQueryString() + "&" + _qs2.default.stringify(query), "_blank");
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props;
	      var style = _props.style;
	      var label = _props.label;
	      var downloadType = _props.downloadType;
	
	
	      return _react2.default.createElement(
	        "div",
	        { style: Object.assign({ display: "inline-block" }, style) },
	        _react2.default.createElement(_materialUi.RaisedButton, { label: label, onTouchTap: this._onClick }),
	        _react2.default.createElement(
	          _materialUi.Popover,
	          {
	            open: this.state.open,
	            anchorEl: this.state.anchorEl,
	            onRequestClose: this._onClose
	          },
	          _react2.default.createElement(
	            _materialUi.Menu,
	            { desktop: true },
	            _react2.default.createElement(_materialUi.MenuItem, {
	              primaryText: downloadType === "memberships" ? "Download memberships (.csv)" : "Download passes (.csv)",
	              onTouchTap: function onTouchTap() {
	                return _this2.download(false);
	              }
	            }),
	            _react2.default.createElement(_materialUi.MenuItem, {
	              primaryText: downloadType === "memberships" ? "Download memberships + tickets ordered (.csv)" : "Download passes + tickets ordered (.csv)",
	              onTouchTap: function onTouchTap() {
	                return _this2.download(true);
	              }
	            }),
	            (this.props.additionalOptions || []).map(function (option) {
	              return _react2.default.createElement(_materialUi.MenuItem, {
	                key: option.label,
	                primaryText: option.label,
	                href: option.href,
	                target: "_blank"
	              });
	            })
	          )
	        )
	      );
	    }
	  }]);
	
	  return DownloadPassBucketCsvButton;
	}(_react2.default.Component);
	
	exports.default = DownloadPassBucketCsvButton;
	module.exports = exports["default"];

/***/ }),
/* 2743 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _get = __webpack_require__(1004);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _assign = __webpack_require__(920);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _materialUi = __webpack_require__(576);
	
	var _reactSelect = __webpack_require__(953);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	var _reactRouter = __webpack_require__(486);
	
	var _contentCopy = __webpack_require__(1225);
	
	var _contentCopy2 = _interopRequireDefault(_contentCopy);
	
	var _util = __webpack_require__(1183);
	
	var _config = __webpack_require__(1173);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _infoNotice = __webpack_require__(1599);
	
	var _infoNotice2 = _interopRequireDefault(_infoNotice);
	
	var _backButton = __webpack_require__(1872);
	
	var _backButton2 = _interopRequireDefault(_backButton);
	
	var _workingIndicator = __webpack_require__(1664);
	
	var _workingIndicator2 = _interopRequireDefault(_workingIndicator);
	
	var _label = __webpack_require__(1682);
	
	var _label2 = _interopRequireDefault(_label);
	
	var _datetimeField = __webpack_require__(2061);
	
	var _datetimeField2 = _interopRequireDefault(_datetimeField);
	
	var _currencyField = __webpack_require__(1747);
	
	var _currencyField2 = _interopRequireDefault(_currencyField);
	
	var _durationField = __webpack_require__(2054);
	
	var _durationField2 = _interopRequireDefault(_durationField);
	
	var _recurrenceField = __webpack_require__(2744);
	
	var _recurrenceField2 = _interopRequireDefault(_recurrenceField);
	
	var _basicHtmlField = __webpack_require__(2674);
	
	var _basicHtmlField2 = _interopRequireDefault(_basicHtmlField);
	
	var _passRulesEditor = __webpack_require__(2745);
	
	var _passRulesEditor2 = _interopRequireDefault(_passRulesEditor);
	
	var _supplementaryDataEditor = __webpack_require__(2746);
	
	var _supplementaryDataEditor2 = _interopRequireDefault(_supplementaryDataEditor);
	
	var _quantityEditor = __webpack_require__(2191);
	
	var _quantityEditor2 = _interopRequireDefault(_quantityEditor);
	
	var _linkLike = __webpack_require__(973);
	
	var _linkLike2 = _interopRequireDefault(_linkLike);
	
	var _inlineNoticeLabel = __webpack_require__(1222);
	
	var _inlineNoticeLabel2 = _interopRequireDefault(_inlineNoticeLabel);
	
	var _connectToStores = __webpack_require__(1226);
	
	var _connectToStores2 = _interopRequireDefault(_connectToStores);
	
	var _PassBucketActions = __webpack_require__(1869);
	
	var _PassBucketActions2 = _interopRequireDefault(_PassBucketActions);
	
	var _PassBucketStore = __webpack_require__(1867);
	
	var _PassBucketStore2 = _interopRequireDefault(_PassBucketStore);
	
	var _EventBucketStore = __webpack_require__(1593);
	
	var _EventBucketStore2 = _interopRequireDefault(_EventBucketStore);
	
	var _UserStore = __webpack_require__(974);
	
	var _UserStore2 = _interopRequireDefault(_UserStore);
	
	var _eventivalBanner = __webpack_require__(2675);
	
	var _eventivalBanner2 = _interopRequireDefault(_eventivalBanner);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PassBucketEditor = function (_React$Component) {
	  _inherits(PassBucketEditor, _React$Component);
	
	  function PassBucketEditor(props) {
	    _classCallCheck(this, PassBucketEditor);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(PassBucketEditor).call(this, props));
	
	    _this.state = {
	      passBucket: {},
	      tab: "core",
	      dirty: false,
	      isSaving: false,
	      lastUpdatedAt: false,
	      hasEditedCode: false,
	      showTermsEditor: false,
	      showPriceBreakEditor: false,
	      showSalePriceEditor: false,
	      showAdvancedSettings: false,
	      showMaxQuantityEditor: false,
	      values: {}
	    };
	
	    _this.onChangeValue = _this.onChangeValue.bind(_this);
	    _this.onChangeTab = _this.onChangeTab.bind(_this);
	    _this.save = _this.save.bind(_this);
	    _this.delete = _this.delete.bind(_this);
	    _this._makeDirectSalesLink = _this._makeDirectSalesLink.bind(_this);
	    _this._makeCoreEditor = _this._makeCoreEditor.bind(_this);
	    _this._makeMessagesEditor = _this._makeMessagesEditor.bind(_this);
	    _this.duplicate = _this.duplicate.bind(_this);
	    _this.migrateToMembership = _this.migrateToMembership.bind(_this);
	    return _this;
	  }
	
	  _createClass(PassBucketEditor, [{
	    key: "getStyles",
	    value: function getStyles() {
	      return {
	        actions: {
	          marginTop: 20
	        },
	        editor: {
	          marginTop: 60,
	          paddingTop: 40,
	          borderTop: "1px solid rgb(224, 224, 224)"
	        },
	        dropzone: {
	          width: 200,
	          padding: 20,
	          border: "1px dashed #ccc",
	          marginBottom: 40,
	          cursor: "pointer"
	        },
	        progress: {
	          marginBottom: 50
	        },
	        h3: {
	          margin: "15px 0 10px"
	        },
	        h2: {
	          margin: "30px 0 0"
	        }
	      };
	    }
	  }, {
	    key: "onChangeTab",
	    value: function onChangeTab(tab) {
	      if (typeof tab !== "string") {
	        return;
	      } // propagation's a bitch
	      this.context.router.replace("/event_buckets/" + this.props.params.eventBucketId + "/" + (this.props.location.pathname.includes('membership') ? "memberships" : "pass_buckets") + "/" + this.props.params.passBucketId + "/edit" + (tab === "core" ? "" : "/" + tab));
	    }
	  }, {
	    key: "onChangeValue",
	    value: function onChangeValue(id, value) {
	      this.state.dirty = true;
	      this.state.values[id] = value;
	      this.setState(this.state);
	    }
	  }, {
	    key: "save",
	    value: function save() {
	      var values = (0, _assign2.default)({}, this.state.values);
	      this.setState({
	        isSaving: true,
	        lastUpdatedAt: this.state.passBucket.updated_at
	      });
	      _PassBucketActions2.default.edit.defer(this.props.params.passBucketId, values);
	    }
	  }, {
	    key: "migrateToMembership",
	    value: function migrateToMembership() {
	      var _this2 = this;
	
	      if (window.confirm("Are you sure you want to convert the pass bucket \"" + this.state.passBucket.name + "\" to a membership?")) {
	        var newValues = (0, _assign2.default)({}, this.state.values, { is_membership: true });
	        this.setState({ dirty: true, values: newValues }, _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
	          return regeneratorRuntime.wrap(function _callee$(_context) {
	            while (1) {
	              switch (_context.prev = _context.next) {
	                case 0:
	                  _context.next = 2;
	                  return _this2.save();
	
	                case 2:
	                  _this2.setState({ dirty: false }, function () {
	                    _this2.context.router.push("/event_buckets/" + _this2.props.params.eventBucketId + "/memberships/" + _this2.props.params.passBucketId);
	                  });
	
	                case 3:
	                case "end":
	                  return _context.stop();
	              }
	            }
	          }, _callee, _this2);
	        })));
	      }
	    }
	  }, {
	    key: "delete",
	    value: function _delete() {
	      var bucket = this.state.passBucket.event_bucket;
	      var isMembership = this.props.location.pathname.includes('membership');
	      if (window.confirm("Are you sure? This could potentially be very bad and result in angry " + (isMembership ? "members" : "passholders") + ".")) {
	        _PassBucketActions2.default.delete(this.props.params.passBucketId);
	        this.context.router.push("/event_buckets/" + bucket + "/" + (isMembership ? "memberships" : "pass_buckets"));
	      }
	    }
	  }, {
	    key: "_makeDirectSalesLink",
	    value: function _makeDirectSalesLink() {
	      var eventBucket = this.props.getEventBucketById(this.props.params.eventBucketId),
	          passBucket = this.props.getPassBucketById(this.props.params.passBucketId);
	
	      return eventBucket && passBucket && (passBucket.is_membership ? eventBucket.urls.root + "memberships/buy" : eventBucket.urls.buy_passes) + "/" + (this.state.values.code || "<code-goes-here>");
	    }
	  }, {
	    key: "duplicate",
	    value: function duplicate() {
	      if (window.confirm("Are you sure you want to duplicate \"" + this.state.passBucket.name + "\"?")) {
	        _PassBucketActions2.default.duplicate(this.props.params.passBucketId);
	        this.context.router.push("/event_buckets/" + this.props.params.eventBucketId + "/" + (this.props.location.pathname.includes('membership') ? "memberships" : "pass_buckets") + "/new?duplicate=true");
	      }
	    }
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var _this3 = this;
	
	      this.context.router.setRouteLeaveHook(this.props.route, function () {
	        if (_this3.state.dirty) {
	          return "Are you sure you wish to leave the " + (_this3.props.location.pathname.includes('membership') ? "membership bucket" : "pass bucket") + " editor? Your changes will not be saved.";
	        }
	      });
	
	      this.componentWillReceiveProps(this.props);
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(newProps) {
	      var passBucket = newProps.getPassBucketById(newProps.params.passBucketId);
	
	      if (!this.state.isFetchingPassBucket && !passBucket) {
	        _PassBucketActions2.default.fetchOne(newProps.params.passBucketId);
	        this.setState({ isFetchingPassBucket: true });
	      } else if (passBucket) {
	        this.setState({ isFetchingPassBucket: false });
	      }
	
	      var isSuppDataUpdated = this.state.passBucket && this.state.passBucket.supplementary_data ? this.state.passBucket.supplementary_data.length !== passBucket.supplementary_data.length : false;
	
	      if (Object.keys(this.state.values).length === 0 || this.state.passBucket.id !== newProps.params.passBucketId || passBucket.updated_at !== this.state.lastUpdatedAt || isSuppDataUpdated) {
	        this.setState({
	          passBucket: passBucket,
	          dirty: false,
	          isSaving: false,
	          values: passBucket ? {
	            name: passBucket.name || "",
	            code: passBucket.code || "",
	            price: passBucket.price || "",
	            sale_price: passBucket.sale_price || "",
	            unlimited: passBucket.unlimited || false,
	            quantity: passBucket.quantity,
	            max_quantity_per_person: passBucket.max_quantity_per_person,
	            cancellation_allowed: passBucket.cancellation_allowed,
	            cancellation_window: passBucket.cancellation_window,
	            ticket_transfer_allowed: passBucket.ticket_transfer_allowed,
	            gift_allowed: passBucket.gift_allowed,
	            volume_price_enabled: passBucket.volume_price_enabled || false,
	            volume_price: passBucket.volume_price || [],
	            multicurrency_price_enabled: passBucket.multicurrency_price_enabled || false,
	            multicurrency_price: passBucket.multicurrency_price || [],
	            sales_disabled_unless_coupon: passBucket.sales_disabled_unless_coupon || false,
	            sales_disabled_unless_pass_rule: passBucket.sales_disabled_unless_pass_rule || false,
	            order_message: passBucket.order_message,
	            tickets_enabled: passBucket.tickets_enabled,
	            visible_in_box_office: passBucket.visible_in_box_office,
	            hide_barcode_from_users: passBucket.hide_barcode_from_users,
	            payment_method_required_before_purchase: passBucket.payment_method_required_before_purchase,
	            tickets_disabled_error_message: passBucket.tickets_disabled_error_message,
	            confirmation_email_message: passBucket.confirmation_email_message,
	            supplementary_data_required_before_purchase: passBucket.supplementary_data_required_before_purchase || false,
	            custom_renewal_warning_email_message: passBucket.custom_renewal_warning_email_message,
	            early_warning_email_interval: passBucket.early_warning_email_interval,
	            terms_at_checkout: passBucket.terms_at_checkout,
	            recurrence_enabled: passBucket.recurrence_enabled,
	            recurrence_interval: passBucket.recurrence_interval || "year",
	            recurrence_count: passBucket.recurrence_count || 1,
	            recurrence_fixed_renewal_date: passBucket.recurrence_fixed_renewal_date,
	            recurrence_renewal_price: passBucket.recurrence_renewal_price,
	            block_physical_scan_until_checked_in: passBucket.block_physical_scan_until_checked_in,
	            passholder_ticket_required: passBucket.passholder_ticket_required,
	            is_membership: passBucket.is_membership
	          } : {}
	        });
	      }
	
	      var eventBucket = newProps.getEventBucketById(newProps.params.eventBucketId);
	      if (eventBucket) {
	        this.setState({
	          passSalesUrl: eventBucket.urls.buy_passes,
	          termForPasses: eventBucket.frontend_config.display_passes
	        });
	      }
	
	      // Set tab; default to "core"
	      this.setState({ tab: newProps.params.tab || "core" });
	    }
	  }, {
	    key: "_makeCoreEditor",
	    value: function _makeCoreEditor() {
	      var _this4 = this;
	
	      var styles = this.getStyles();
	      var directSalesLink = this._makeDirectSalesLink();
	
	      var isMembership = this.props.location.pathname.includes('membership');
	
	      var eventBucket = this.props.getEventBucketById(this.props.params.eventBucketId);
	      var userCurrency = (_UserStore2.default.getUser() || { currency: "usd" }).currency;
	      var offerMulticurrency = eventBucket && eventBucket.frontend_config.virtual_festival_show_pass_sales;
	
	      var offerQuantityRestrictionPerPerson = eventBucket && (eventBucket.frontend_config.sundance_login || eventBucket.frontend_config.enable_pass_quantity_restriction_per_person);
	
	      if (!this.state.passBucket) {
	        return _react2.default.createElement(_workingIndicator2.default, { fullPage: true });
	      }
	
	      var MigrateMemberships = function MigrateMemberships() {
	        // Migrate Pass Bucket to Membership
	        //
	        // Show button only if Memberships are enabled in Event Bucket.
	        // Enable button only if 1. there are no pending changes and 2. recurrence is enabled.
	
	        if (eventBucket.frontend_config.memberships_enabled && !_this4.state.values.is_membership) {
	          var notReadyToMigrate = _this4.state.dirty || // There are changes pending
	          !_this4.state.values.recurrence_enabled || // Recurrence is not enabled
	          _this4.state.values.recurrence_fixed_renewal_date // Fixed Renewal Date is set
	          ? true : false;
	
	          var promptMessage = '* ';
	          if (_this4.state.dirty) {
	            promptMessage += "Pending changes must be saved. ";
	          }
	          if (!_this4.state.values.recurrence_enabled) {
	            promptMessage += "Recurrence must be enabled. ";
	          }
	          if (_this4.state.values.recurrence_fixed_renewal_date) {
	            promptMessage += "Fixed Renewal prevents the ability to migrate. ";
	          }
	
	          return _react2.default.createElement(
	            "div",
	            { style: { marginTop: 15, marginBottom: 10 } },
	            _react2.default.createElement(_materialUi.RaisedButton, { label: "Migrate Pass Bucket to Membership",
	              disabled: notReadyToMigrate,
	              onTouchTap: _this4.migrateToMembership
	            }),
	            notReadyToMigrate ? _react2.default.createElement(
	              "div",
	              null,
	              _react2.default.createElement(
	                "em",
	                null,
	                promptMessage
	              )
	            ) : null
	          );
	        } else return null;
	      };
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          "p",
	          { style: { marginBottom: 0 } },
	          "Edit general ",
	          isMembership ? "membership" : "pass bucket",
	          " settings.",
	          _react2.default.createElement(
	            _infoNotice2.default,
	            { style: { marginTop: 5 } },
	            "Check out our",
	            " ",
	            _react2.default.createElement(
	              "a",
	              {
	                href: "http://help.eventive.org/passes/create-pass-buckets",
	                target: "_blank"
	              },
	              "guide to creating ",
	              isMembership ? "memberships" : "pass buckets"
	            ),
	            "."
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { style: { maxWidth: 517 } },
	          _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(_materialUi.TextField, {
	              value: (0, _get2.default)(this.state, "values.name", ""),
	              floatingLabelText: "Name",
	              onChange: function onChange(e) {
	                _this4.onChangeValue("name", e.target.value);
	                if (!_this4.state.hasEditedCode) {
	                  // Automatically generate a url code if they haven't entered one
	                  _this4.onChangeValue("code", (0, _util.snakeCase)(e.target.value));
	                }
	              }
	            })
	          ),
	          _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(_materialUi.TextField, {
	              value: (0, _get2.default)(this.state, "values.code", ""),
	              floatingLabelText: "URL code",
	              floatingLabelFixed: true,
	              onChange: function onChange(e) {
	                _this4.state.hasEditedCode = true;
	                _this4.onChangeValue("code", e.target.value);
	              }
	            }),
	            _react2.default.createElement(
	              "div",
	              null,
	              "Displayed in the URL to the ",
	              isMembership ? "membership sales" : "pass sales",
	              ", i.e.",
	              _react2.default.createElement("br", null),
	              _react2.default.createElement(
	                "span",
	                { style: { fontStyle: "italic" } },
	                directSalesLink
	              ),
	              "."
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(_currencyField2.default, {
	              value: (0, _get2.default)(this.state, "values.price", ""),
	              floatingLabelText: "Price",
	              floatingLabelFixed: true,
	              placeholder: "$0.00"
	              // disabled={
	              //   this.state.passBucket &&
	              //   this.state.passBucket.recurrence_interval
	              // }
	              , onChange: function onChange(e) {
	                return _this4.onChangeValue("price", e.target.value);
	              }
	            })
	          ),
	          _react2.default.createElement(
	            "h3",
	            { style: styles.h3 },
	            "Quantity"
	          ),
	          this.state.passBucket.quantity_sold ? _react2.default.createElement(
	            "div",
	            { style: { marginTop: -10 } },
	            this.state.passBucket.quantity_sold,
	            " ",
	            isMembership ? "memberships" : "passes",
	            " sold currently"
	          ) : null,
	          _react2.default.createElement(
	            "div",
	            { style: { marginTop: 10 } },
	            _react2.default.createElement(_materialUi.Checkbox, {
	              label: "Unlimited quantity for sale",
	              checked: (0, _get2.default)(this.state, "values.unlimited", false),
	              onCheck: function onCheck(e, checked) {
	                return _this4.onChangeValue("unlimited", !_this4.state.values.unlimited);
	              }
	            })
	          ),
	          !this.state.values.unlimited ? _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(_materialUi.TextField, {
	              value: (0, _get2.default)(this.state, "values.quantity", "0"),
	              floatingLabelText: "Quantity available",
	              type: "number",
	              disabled: this.state.values.unlimited,
	              onChange: function onChange(e) {
	                return _this4.onChangeValue("quantity", e.target.value);
	              }
	            })
	          ) : null,
	          offerQuantityRestrictionPerPerson ? _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(_materialUi.Checkbox, {
	              label: "Restrict maximum quantity of " + (isMembership ? "memberships" : "passes") + " purchased per customer",
	              checked: this.state.values.max_quantity_per_person || this.state.showMaxQuantityEditor,
	              onCheck: function onCheck(e, checked) {
	                _this4.setState({ showMaxQuantityEditor: checked }, function () {
	                  _this4.onChangeValue("max_quantity_per_person", checked ? 4 : null);
	                });
	              }
	            }),
	            this.state.showMaxQuantityEditor || this.state.values.max_quantity_per_person ? _react2.default.createElement(
	              "div",
	              { style: { margin: "-0.5em 3em 0.5em" } },
	              _react2.default.createElement(
	                _label2.default,
	                null,
	                "Max quantity per customer"
	              ),
	              _react2.default.createElement(_quantityEditor2.default, {
	                style: { marginTop: -14, marginLeft: -17 },
	                quantity: this.state.values.max_quantity_per_person,
	                min: 1,
	                updateQuantity: function updateQuantity(q) {
	                  return _this4.setState({ showMaxQuantityEditor: true }, function () {
	                    return _this4.onChangeValue("max_quantity_per_person", q);
	                  });
	                }
	              })
	            ) : null
	          ) : null,
	          _react2.default.createElement(
	            "h3",
	            { style: styles.h3 },
	            "Recurrence"
	          ),
	          !isMembership && _react2.default.createElement(
	            "div",
	            { style: { marginTop: 10 } },
	            _react2.default.createElement(_materialUi.Checkbox, {
	              label: "Recurrence enabled",
	              checked: (0, _get2.default)(this.state, "values.recurrence_enabled", false),
	              onCheck: function onCheck(e, checked) {
	                return _this4.onChangeValue("recurrence_enabled", !_this4.state.values.recurrence_enabled);
	              }
	            })
	          ),
	          this.state.values.recurrence_enabled ? _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(
	              "div",
	              { style: { marginTop: 10 } },
	              (isMembership ? "Members" : "When recurrence is enabled, passholders") + " will automatically be\n                billed once every recurrence interval until their " + (isMembership ? "membership" : "pass") + " is\n                canceled."
	            ),
	            _react2.default.createElement(_recurrenceField2.default, {
	              value: [this.state.values.recurrence_count, this.state.values.recurrence_interval],
	              label: "Renew every"
	              // style={
	              //   this.state.passBucket &&
	              //   this.state.passBucket.recurrence_interval
	              //     ? { opacity: 0.5, pointerEvents: "none" }
	              //     : {}
	              // }
	              , onChange: function onChange(_ref2) {
	                var _ref3 = _slicedToArray(_ref2, 2);
	
	                var count = _ref3[0];
	                var interval = _ref3[1];
	
	                _this4.onChangeValue("recurrence_count", count);
	                _this4.onChangeValue("recurrence_interval", interval);
	              }
	            }),
	            _react2.default.createElement(
	              "div",
	              null,
	              _react2.default.createElement(
	                "div",
	                { style: { marginTop: 10 } },
	                _react2.default.createElement(_materialUi.Checkbox, {
	                  label: "Enable custom manual renewal price",
	                  checked: this.state.values.recurrence_renewal_price || this.state.showRenewalPriceEditor,
	                  onCheck: function onCheck(e, checked) {
	                    _this4.setState({
	                      showRenewalPriceEditor: !(_this4.state.values.recurrence_renewal_price || _this4.state.showRenewalPriceEditor)
	                    }, function () {
	                      return _this4.onChangeValue("recurrence_renewal_price", null);
	                    });
	                  }
	                })
	              ),
	              this.state.showRenewalPriceEditor || this.state.values.recurrence_renewal_price ? _react2.default.createElement(
	                "div",
	                null,
	                _react2.default.createElement(
	                  "div",
	                  { style: { marginTop: 10, marginBottom: -10 } },
	                  (isMembership ? "Members" : "Passholders") + " manually renewing their " + (isMembership ? "memberships" : "passes") + " in advance of its\n                      expiration (via their Subscriptions page) will be offered\n                      this discounted price."
	                ),
	                _react2.default.createElement(_currencyField2.default, {
	                  value: (0, _get2.default)(this.state, "values.recurrence_renewal_price", ""),
	                  floatingLabelText: "Manual renewal price",
	                  floatingLabelFixed: true,
	                  placeholder: "$0.00",
	                  onChange: function onChange(e) {
	                    return _this4.onChangeValue("recurrence_renewal_price", e.target.value);
	                  }
	                })
	              ) : null,
	              _react2.default.createElement(
	                "div",
	                { style: { marginTop: 10 } },
	                _react2.default.createElement(_materialUi.Checkbox, {
	                  label: "Enable fixed renewal date [advanced, not recommended]",
	                  checked: this.state.values.recurrence_fixed_renewal_date || this.state.showFixedRenewalEditor,
	                  onCheck: function onCheck(e, checked) {
	                    _this4.setState({
	                      showFixedRenewalEditor: !(_this4.state.values.recurrence_fixed_renewal_date || _this4.state.showFixedRenewalEditor)
	                    }, function () {
	                      return _this4.onChangeValue("recurrence_fixed_renewal_date", null);
	                    });
	                  }
	                })
	              ),
	              this.state.showFixedRenewalEditor || this.state.values.recurrence_fixed_renewal_date ? _react2.default.createElement(
	                "div",
	                null,
	                _react2.default.createElement(
	                  "div",
	                  { style: { marginTop: 10 } },
	                  "All " + (isMembership ? "memberships" : "passes") + " purchased will automatically have the following\n                      date set as their renewal date (e.g. for calendar-year\n                      subscriptions)."
	                ),
	                _react2.default.createElement(_datetimeField2.default, {
	                  label: "Recurrence fixed renewal date",
	                  value: this.state.values.recurrence_fixed_renewal_date,
	                  hideTime: true,
	                  onChange: function onChange(_, date) {
	                    return _this4.onChangeValue("recurrence_fixed_renewal_date", date);
	                  }
	                })
	              ) : null
	            )
	          ) : null,
	          _react2.default.createElement(
	            "h3",
	            { style: styles.h3 },
	            "Cancellation"
	          ),
	          _react2.default.createElement(
	            "div",
	            { style: { marginTop: 10 } },
	            _react2.default.createElement(_materialUi.Checkbox, {
	              label: "Ticket cancellation allowed",
	              checked: (0, _get2.default)(this.state, "values.cancellation_allowed", false),
	              onCheck: function onCheck(e, checked) {
	                return _this4.onChangeValue("cancellation_allowed", !_this4.state.values.cancellation_allowed);
	              }
	            })
	          ),
	          this.state.values.cancellation_allowed ? _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(
	              "div",
	              { style: { marginTop: 10 } },
	              "When ticket cancellation is enabled, " + (isMembership ? "members" : "passholders") + " who use their\n                passes to redeem free (i.e. 100% off) tickets will be able to\n                cancel those orders up to the time you set below before the\n                event for which each ticket was purchased."
	            ),
	            _react2.default.createElement(_durationField2.default, {
	              value: (0, _get2.default)(this.state, "values.cancellation_window", 0),
	              floatingLabelText: 'Cancellation cutoff before event (e.g. "2 hours")',
	              floatingLabelStyle: { width: 400 },
	              onChange: function onChange(e) {
	                return _this4.onChangeValue("cancellation_window", e.target.value);
	              }
	            })
	          ) : null,
	          _react2.default.createElement(
	            "h3",
	            { style: styles.h3 },
	            "Ticket transfer"
	          ),
	          _react2.default.createElement(
	            "div",
	            { style: { marginTop: 10 } },
	            _react2.default.createElement(_materialUi.Checkbox, {
	              label: "Allow " + (isMembership ? "members" : "passholders") + " to transfer tickets ordered with " + (isMembership ? "membership" : "pass"),
	              checked: this.state.values.ticket_transfer_allowed,
	              onCheck: function onCheck(e, checked) {
	                return _this4.onChangeValue("ticket_transfer_allowed", !_this4.state.values.ticket_transfer_allowed);
	              }
	            })
	          ),
	          _react2.default.createElement(
	            "h3",
	            { style: styles.h3 },
	            "Quantity price breaks"
	          ),
	          _react2.default.createElement(
	            "div",
	            { style: { marginTop: 10 } },
	            _react2.default.createElement(_materialUi.Checkbox, {
	              label: "Enable quantity-based price breaks",
	              checked: this.state.values.volume_price_enabled,
	              onCheck: function onCheck(e, checked) {
	                if (!_this4.state.values.volume_price_enabled && _this4.state.values.volume_price.length === 0) {
	                  _this4.onChangeValue("volume_price", [{ minimum_quantity: 2, price: "" }]);
	                }
	                _this4.onChangeValue("volume_price_enabled", !_this4.state.values.volume_price_enabled);
	              }
	            })
	          ),
	          this.state.values.volume_price_enabled ? _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(
	              "div",
	              { style: { marginTop: 10 } },
	              "For each desired price break, specify a minimum quantity and the\n                new per-" + (isMembership ? "membership" : "pass") + " price."
	            ),
	            _react2.default.createElement(
	              "div",
	              { style: { marginTop: 5 } },
	              this.state.values.volume_price.map(function (_ref4, i) {
	                var minimum_quantity = _ref4.minimum_quantity;
	                var price = _ref4.price;
	
	                return _react2.default.createElement(
	                  "div",
	                  { key: i, style: { marginTop: -10 } },
	                  _react2.default.createElement(_materialUi.TextField, {
	                    value: minimum_quantity,
	                    floatingLabelText: "Min qty",
	                    floatingLabelFixed: true,
	                    type: "number",
	                    style: { width: 75 },
	                    onChange: function onChange(e) {
	                      _this4.state.values.volume_price[i].minimum_quantity = e.target.value;
	                      _this4.onChangeValue("volume_price", _this4.state.values.volume_price);
	                    }
	                  }),
	                  _react2.default.createElement(_currencyField2.default, {
	                    value: price,
	                    floatingLabelText: isMembership ? "Membership price" : "Pass price",
	                    floatingLabelFixed: true,
	                    placeholder: "$0.00",
	                    style: { marginLeft: 7, width: 100 },
	                    onChange: function onChange(e) {
	                      _this4.state.values.volume_price[i].price = e.target.value;
	                      _this4.onChangeValue("volume_price", _this4.state.values.volume_price);
	                    }
	                  }),
	                  i !== 0 && _react2.default.createElement(_materialUi.FlatButton, {
	                    style: { minWidth: 20 },
	                    label: "\xD7",
	                    onTouchTap: function onTouchTap() {
	                      _this4.state.values.volume_price.splice(i, 1);
	                      _this4.onChangeValue("volume_price", _this4.state.values.volume_price);
	                    }
	                  })
	                );
	              })
	            ),
	            _react2.default.createElement(_materialUi.RaisedButton, {
	              style: { marginTop: 10 },
	              label: "Add another price break",
	              onTouchTap: function onTouchTap() {
	                _this4.onChangeValue("volume_price", _this4.state.values.volume_price.concat([{}]));
	              }
	            })
	          ) : null,
	          !isMembership ? _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(
	              "h3",
	              { style: styles.h3 },
	              "Sale price"
	            ),
	            _react2.default.createElement(
	              "div",
	              { style: { marginTop: 10 } },
	              _react2.default.createElement(_materialUi.Checkbox, {
	                label: "Enable custom sale price",
	                checked: this.state.values.sale_price || this.state.showSalePriceEditor,
	                onCheck: function onCheck(e, checked) {
	                  _this4.setState({
	                    showSalePriceEditor: !(_this4.state.values.sale_price || _this4.state.showSalePriceEditor)
	                  }, function () {
	                    return _this4.onChangeValue("sale_price", null);
	                  });
	                }
	              })
	            ),
	            this.state.showSalePriceEditor || this.state.values.sale_price ? _react2.default.createElement(
	              "div",
	              null,
	              _react2.default.createElement(
	                "div",
	                { style: { marginTop: 10 } },
	                "Discount will be highlighted as a sale on ",
	                isMembership ? "membership" : "pass",
	                " sales page (compared to regular price of",
	                " ",
	                (0, _util.formatPrice)(this.state.values.price, true),
	                " \u2013 editable above)."
	              ),
	              _react2.default.createElement(_currencyField2.default, {
	                value: (0, _get2.default)(this.state, "values.sale_price", ""),
	                floatingLabelText: "Sale price",
	                floatingLabelFixed: true,
	                placeholder: "$0.00",
	                disabled: this.state.passBucket && this.state.passBucket.recurrence_interval,
	                onChange: function onChange(e) {
	                  return _this4.onChangeValue("sale_price", e.target.value);
	                }
	              })
	            ) : null
	          ) : null,
	          offerMulticurrency ? _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(
	              "h3",
	              { style: styles.h3 },
	              "Virtual catalog multi-currency pricing"
	            ),
	            _react2.default.createElement(
	              "div",
	              { style: { marginTop: 10 } },
	              _react2.default.createElement(_materialUi.Checkbox, {
	                label: "Enable multi-currency pricing for virtual catalog sales of this " + (isMembership ? "membership" : "pass bucket"),
	                checked: this.state.values.multicurrency_price_enabled,
	                onCheck: function onCheck(e, checked) {
	                  if (!_this4.state.values.multicurrency_price_enabled && _this4.state.values.multicurrency_price.length === 0) {
	                    _this4.onChangeValue("multicurrency_price", [{ currency: "", price: "" }]);
	                  }
	                  _this4.onChangeValue("multicurrency_price_enabled", !_this4.state.values.multicurrency_price_enabled);
	                }
	              })
	            ),
	            this.state.values.multicurrency_price_enabled ? _react2.default.createElement(
	              "div",
	              null,
	              _react2.default.createElement(
	                "div",
	                { style: { marginTop: 10 } },
	                _react2.default.createElement(
	                  "strong",
	                  null,
	                  "Multi-currency pricing"
	                ),
	                ": Add each additional currency that you would like to offer in the virtual catalog. Users will be recommended prices in their local currency, if available. They can also select another currency. Payments will be instantly converted to your default currency (",
	                userCurrency.toUpperCase(),
	                ") at the time of sale using Stripe's current mid-market exchange rate."
	              ),
	              _react2.default.createElement(
	                "div",
	                { style: { marginTop: 5 } },
	                this.state.values.multicurrency_price.map(function (_ref5, i) {
	                  var currency = _ref5.currency;
	                  var price = _ref5.price;
	
	                  return _react2.default.createElement(
	                    "div",
	                    {
	                      key: i,
	                      style: {
	                        marginTop: -10,
	                        display: "flex",
	                        alignItems: "center"
	                      }
	                    },
	                    _react2.default.createElement(
	                      "div",
	                      {
	                        style: {
	                          width: 100,
	                          marginRight: 12,
	                          marginTop: 1
	                        }
	                      },
	                      _react2.default.createElement(
	                        _label2.default,
	                        null,
	                        "Currency"
	                      ),
	                      _react2.default.createElement(_reactSelect2.default, {
	                        style: { marginTop: -7 },
	                        clearable: false,
	                        value: currency,
	                        options: _config2.default.fee.supported_currencies.filter(function (k) {
	                          return k.toLowerCase() !== userCurrency.toLowerCase();
	                        }).map(function (k) {
	                          return {
	                            label: k.toUpperCase(),
	                            value: k
	                          };
	                        }),
	                        onChange: function onChange(v) {
	                          _this4.state.values.multicurrency_price[i].currency = v.value;
	                          _this4.onChangeValue("multicurrency_price", _this4.state.values.multicurrency_price);
	                        }
	                      })
	                    ),
	                    _react2.default.createElement(_currencyField2.default, {
	                      value: price,
	                      floatingLabelText: isMembership ? "Membership price" : "Pass price",
	                      floatingLabelFixed: true,
	                      placeholder: "$0.00",
	                      currency: currency,
	                      style: { marginLeft: 7, width: 100 },
	                      onChange: function onChange(e) {
	                        _this4.state.values.multicurrency_price[i].price = e.target.value;
	                        _this4.onChangeValue("multicurrency_price", _this4.state.values.multicurrency_price);
	                      }
	                    }),
	                    i !== 0 && _react2.default.createElement(_materialUi.FlatButton, {
	                      style: { minWidth: 20, marginTop: 20 },
	                      label: "\xD7",
	                      onClick: function onClick() {
	                        _this4.state.values.multicurrency_price.splice(i, 1);
	                        _this4.onChangeValue("multicurrency_price", _this4.state.values.multicurrency_price);
	                      }
	                    })
	                  );
	                })
	              ),
	              _react2.default.createElement(_materialUi.RaisedButton, {
	                style: { marginTop: 15, marginBottom: 5 },
	                label: "Add another currency",
	                onClick: function onClick() {
	                  _this4.onChangeValue("multicurrency_price", _this4.state.values.multicurrency_price.concat([{}]));
	                }
	              })
	            ) : null
	          ) : null,
	          _react2.default.createElement(
	            "h3",
	            { style: styles.h3 },
	            "Gift purchases"
	          ),
	          _react2.default.createElement(
	            "div",
	            { style: { marginTop: 10 } },
	            _react2.default.createElement(_materialUi.Checkbox, {
	              label: "Allow " + (isMembership ? "membership" : "pass") + " to be purchased as a gift",
	              checked: this.state.values.gift_allowed,
	              onCheck: function onCheck(e, checked) {
	                return _this4.onChangeValue("gift_allowed", !_this4.state.values.gift_allowed);
	              }
	            })
	          ),
	          _react2.default.createElement(
	            "h3",
	            { style: styles.h3 },
	            "Advance reservations"
	          ),
	          _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(_materialUi.Checkbox, {
	              label: "Use default event bucket setting",
	              checked: this.state.values.passholder_ticket_required === "default",
	              onCheck: function onCheck(e, checked) {
	                return _this4.onChangeValue("passholder_ticket_required", checked ? "default" : "");
	              }
	            }),
	            this.state.values.passholder_ticket_required !== "default" ? _react2.default.createElement(
	              _materialUi.RadioButtonGroup,
	              {
	                name: "passholder_ticket_required",
	                valueSelected: (typeof this.state.values.passholder_ticket_required !== "undefined" ? this.state.values.passholder_ticket_required : "").toString(),
	                onChange: function onChange(e, v) {
	                  return _this4.onChangeValue("passholder_ticket_required", v);
	                }
	              },
	              _react2.default.createElement(_materialUi.RadioButton, {
	                value: "true",
	                label: "Require " + (isMembership ? "member" : "passholder") + " ticket reservation in advance (\"RSVP required\"; overridable on a per-event basis)",
	                disabled: this.state.values.passholder_ticket_required === "default"
	              }),
	              _react2.default.createElement(_materialUi.RadioButton, {
	                value: "false",
	                label: "Do not require advance reservation; allow " + (isMembership ? "member" : "passholder") + " walk-ups",
	                disabled: this.state.values.passholder_ticket_required === "default"
	              })
	            ) : null
	          ),
	          _react2.default.createElement(
	            "h3",
	            { style: styles.h3 },
	            "Status"
	          ),
	          _react2.default.createElement(
	            "div",
	            { style: { marginTop: 10 } },
	            _react2.default.createElement(_materialUi.Checkbox, {
	              label: "Enable ticket orders (allow " + (isMembership ? "members" : "passholders") + " to reserve tickets with " + (isMembership ? "membership" : "pass") + ")",
	              checked: (0, _get2.default)(this.state, "values.tickets_enabled", false),
	              onCheck: function onCheck(e) {
	                return _this4.onChangeValue("tickets_enabled", !_this4.state.values.tickets_enabled);
	              }
	            })
	          ),
	          _react2.default.createElement(
	            "h3",
	            { style: styles.h3 },
	            "Advanced"
	          ),
	          _react2.default.createElement(
	            "div",
	            { style: { marginTop: -5 } },
	            _react2.default.createElement(
	              _linkLike2.default,
	              {
	                onTouchTap: function onTouchTap() {
	                  _this4.setState({
	                    showAdvancedSettings: !_this4.state.showAdvancedSettings
	                  });
	                }
	              },
	              this.state.showAdvancedSettings ? "Hide advanced settings" : "Show advanced settings"
	            )
	          ),
	          this.state.showAdvancedSettings ? _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(
	              "div",
	              { style: { marginTop: 10 } },
	              _react2.default.createElement(_materialUi.Checkbox, {
	                label: "Sales locked: Require a valid discount code in order to purchase",
	                checked: (0, _get2.default)(this.state, "values.sales_disabled_unless_coupon", false),
	                onCheck: function onCheck(e) {
	                  return _this4.onChangeValue("sales_disabled_unless_coupon", !_this4.state.values.sales_disabled_unless_coupon);
	                }
	              })
	            ),
	            _react2.default.createElement(
	              "div",
	              { style: { marginTop: 5 } },
	              _react2.default.createElement(_materialUi.Checkbox, {
	                label: "Sales " + (isMembership ? "membership" : "pass") + "-locked: Require a valid " + (isMembership ? "membership" : "pass") + " rule from another " + (isMembership ? "membership" : "pass") + " in order to buy this " + (isMembership ? "membership" : "pass") + " (disable standalone sales)",
	                checked: (0, _get2.default)(this.state, "values.sales_disabled_unless_pass_rule", false),
	                onCheck: function onCheck(e) {
	                  return _this4.onChangeValue("sales_disabled_unless_pass_rule", !_this4.state.values.sales_disabled_unless_pass_rule);
	                }
	              })
	            ),
	            _react2.default.createElement(
	              "div",
	              { style: { marginTop: 5 } },
	              _react2.default.createElement(_materialUi.Checkbox, {
	                label: "Allow users to access scannable barcode from their \"My " + (isMembership ? "Memberships" : (0, _util.capitalize)(this.state.termForPasses || "passes")) + "\" page",
	                checked: !(0, _get2.default)(this.state, "values.hide_barcode_from_users", false),
	                onCheck: function onCheck(e) {
	                  return _this4.onChangeValue("hide_barcode_from_users", !_this4.state.values.hide_barcode_from_users);
	                }
	              })
	            ),
	            _react2.default.createElement(
	              "div",
	              { style: { marginTop: 5 } },
	              _react2.default.createElement(_materialUi.Checkbox, {
	                label: _react2.default.createElement(
	                  "span",
	                  null,
	                  _react2.default.createElement(
	                    "i",
	                    null,
	                    "(Physical events only)"
	                  ),
	                  " Require ",
	                  isMembership ? "memberships" : "passes",
	                  " to be checked in using Eventive Check-In before they can be scanned at physical events"
	                ),
	                checked: (0, _get2.default)(this.state, "values.block_physical_scan_until_checked_in", false),
	                onCheck: function onCheck(e) {
	                  return _this4.onChangeValue("block_physical_scan_until_checked_in", !_this4.state.values.block_physical_scan_until_checked_in);
	                }
	              })
	            ),
	            _react2.default.createElement(
	              "div",
	              { style: { marginTop: 5 } },
	              _react2.default.createElement(_materialUi.Checkbox, {
	                label: "Visible for sale in Box Office",
	                checked: (0, _get2.default)(this.state, "values.visible_in_box_office", false),
	                onCheck: function onCheck(e) {
	                  return _this4.onChangeValue("visible_in_box_office", !_this4.state.values.visible_in_box_office);
	                }
	              })
	            ),
	            _UserStore2.default.isGod() && !this.state.values.price ? _react2.default.createElement(
	              "div",
	              { style: { marginTop: 5 } },
	              _react2.default.createElement(_materialUi.Checkbox, {
	                label: "[GOD ONLY] Collect payment method for $0 " + (isMembership ? "membership" : "pass") + " sale (e.g. for rush line)",
	                checked: (0, _get2.default)(this.state, "values.payment_method_required_before_purchase", false),
	                onCheck: function onCheck(e) {
	                  return _this4.onChangeValue("payment_method_required_before_purchase", !_this4.state.values.payment_method_required_before_purchase);
	                }
	              })
	            ) : null,
	            _react2.default.createElement(MigrateMemberships, null)
	          ) : null
	        ),
	        _react2.default.createElement(
	          "div",
	          { style: styles.actions },
	          _react2.default.createElement(_materialUi.RaisedButton, {
	            label: this.state.dirty ? "Save changes" : "No changes to save",
	            primary: true,
	            disabled: !this.state.dirty,
	            onTouchTap: this.save
	          }),
	          _react2.default.createElement(_materialUi.RaisedButton, {
	            label: "Delete " + (isMembership ? "membership bucket" : "pass bucket"),
	            onTouchTap: this.delete,
	            style: { marginLeft: 7 }
	          })
	        )
	      );
	    }
	  }, {
	    key: "_makeMessagesEditor",
	    value: function _makeMessagesEditor() {
	      var _this5 = this;
	
	      var styles = this.getStyles(),
	          showTermsEditor = !!this.state.values.terms_at_checkout || this.state.showTermsEditor,
	          showConfirmationEmailEditor = !!this.state.values.confirmation_email_message || this.state.showConfirmationEmailEditor,
	          showEarlyWarningEmailDropdown = !!this.state.values.early_warning_email_interval || this.state.showEarlyWarningEmailDropdown,
	          showCustomRenewalWarningEditor = !!this.state.values.custom_renewal_warning_email_message || this.state.showCustomRenewalWarningEditor;
	
	      var isSupplementaryDataEmptyAndNotActive = (typeof this.state.passBucket === "undefined" || typeof this.state.passBucket.supplementary_data === "undefined" || this.state.passBucket.supplementary_data.length === 0) && !(0, _get2.default)(this.state, "values.supplementary_data_required_before_purchase", false);
	
	      var isMembership = this.props.location.pathname.includes('membership');
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          "p",
	          { style: { marginBottom: -5 } },
	          "Configure messages displayed to users related to this ",
	          isMembership ? "membership" : "pass bucket",
	          ".",
	          _react2.default.createElement(
	            _infoNotice2.default,
	            { style: { marginTop: 5 } },
	            "Check out our",
	            " ",
	            _react2.default.createElement(
	              "a",
	              {
	                href: "http://help.eventive.org/passes/customize-pass-bucket-messages",
	                target: "_blank"
	              },
	              "guide to ",
	              isMembership ? "membership" : "pass bucket",
	              " messages"
	            ),
	            "."
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement(
	            "h2",
	            { style: styles.h2 },
	            "Ordering"
	          ),
	          _react2.default.createElement(
	            "div",
	            { style: { marginTop: 10 } },
	            _react2.default.createElement(_materialUi.Checkbox, {
	              label: "Require agreement to a waiver/terms of use before placing order",
	              checked: showTermsEditor,
	              onCheck: function onCheck(e, checked) {
	                _this5.setState({ showTermsEditor: checked }, function () {
	                  if (!_this5.state.showTermsEditor) {
	                    _this5.onChangeValue("terms_at_checkout", "");
	                  }
	                });
	              }
	            })
	          ),
	          showTermsEditor ? _react2.default.createElement(_basicHtmlField2.default, {
	            label: "Waiver message to display",
	            value: (0, _get2.default)(this.state, "values.terms_at_checkout", ""),
	            onChange: function onChange(v) {
	              return _this5.onChangeValue("terms_at_checkout", v);
	            }
	          }) : null,
	          _react2.default.createElement(
	            "div",
	            { style: { marginTop: 10 } },
	            _react2.default.createElement(_materialUi.Checkbox, {
	              label: _react2.default.createElement(
	                "span",
	                null,
	                "Custom confirmation email message (overrides default set in",
	                " ",
	                _react2.default.createElement(
	                  _reactRouter.Link,
	                  {
	                    to: "/event_buckets/" + this.props.params.eventBucketId + "/configurator/" + (isMembership ? "memberships" : "passes")
	                  },
	                  "Configurator"
	                ),
	                ")"
	              ),
	              checked: showConfirmationEmailEditor,
	              onCheck: function onCheck(e, checked) {
	                _this5.setState({ showConfirmationEmailEditor: checked }, function () {
	                  if (!_this5.state.showConfirmationEmailEditor) {
	                    _this5.onChangeValue("confirmation_email_message", "");
	                  }
	                });
	              }
	            })
	          ),
	          showConfirmationEmailEditor ? _react2.default.createElement(_basicHtmlField2.default, {
	            label: "Confirmation email message",
	            value: (0, _get2.default)(this.state, "values.confirmation_email_message", ""),
	            onChange: function onChange(v) {
	              return _this5.onChangeValue("confirmation_email_message", v);
	            }
	          }) : null,
	          _react2.default.createElement(
	            "div",
	            { style: { marginTop: 10 } },
	            _react2.default.createElement(_materialUi.Checkbox, {
	              label: "Require supplementary data to be completed before purchase" + (isSupplementaryDataEmptyAndNotActive ? " (Please add field(s) in the Supplementary Data tab before activating this feature)" : ""),
	              checked: (0, _get2.default)(this.state, "values.supplementary_data_required_before_purchase", false),
	              onCheck: function onCheck(e, checked) {
	                _this5.onChangeValue("supplementary_data_required_before_purchase", !_this5.state.values.supplementary_data_required_before_purchase);
	              },
	              disabled: isSupplementaryDataEmptyAndNotActive
	            })
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement(
	            "h2",
	            { style: styles.h2 },
	            "Using"
	          ),
	          _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(_materialUi.TextField, {
	              value: (0, _get2.default)(this.state, "values.order_message", ""),
	              floatingLabelText: "Order message",
	              fullWidth: true,
	              onChange: function onChange(e) {
	                return _this5.onChangeValue("order_message", e.target.value);
	              }
	            }),
	            _react2.default.createElement(
	              "div",
	              { style: {} },
	              "When this " + (isMembership ? "membership" : "pass bucket") + " is enabled for ticket orders, " + (isMembership ? "members" : "passholders") + "\n              will see the above message in the \"Order tickets\" dropdown."
	            ),
	            _react2.default.createElement(
	              "div",
	              { style: { fontSize: "0.85em" } },
	              "Available insertables: ",
	              _react2.default.createElement(
	                "strong",
	                null,
	                "{{quantity}}"
	              ),
	              " = quick order quantity, ",
	              _react2.default.createElement(
	                "strong",
	                null,
	                "{{tickets}}"
	              ),
	              " = either \"tickets\" or \"ticket\" (quantity-dependent), ",
	              _react2.default.createElement(
	                "strong",
	                null,
	                isMembership ? "{{membership}}" : "{{pass}}"
	              ),
	              " = name on ",
	              isMembership ? "membership" : "pass",
	              ",",
	              " ",
	              _react2.default.createElement(
	                "strong",
	                null,
	                "{{price}}"
	              ),
	              " = adjusted ticket price for ",
	              isMembership ? "membership" : "pass"
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(_materialUi.TextField, {
	              value: (0, _get2.default)(this.state, "values.tickets_disabled_error_message", 0),
	              floatingLabelText: "Ticket order error message",
	              fullWidth: true,
	              onChange: function onChange(e) {
	                return _this5.onChangeValue("tickets_disabled_error_message", e.target.value);
	              }
	            }),
	            _react2.default.createElement(
	              "div",
	              { style: {} },
	              "When this " + (isMembership ? "membership" : "pass bucket") + " isn't enabled for ticket orders, " + (isMembership ? "members" : "passholders") + "\n              will see the above error message next to the " + (isMembership ? "membership" : "pass") + " in the dropdown\n              instead."
	            )
	          )
	        ),
	        (0, _get2.default)(this.state, "values.recurrence_enabled", "") ? _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement(
	            "h2",
	            { style: styles.h2 },
	            "Recurrence"
	          ),
	          _react2.default.createElement(
	            "div",
	            { style: { marginTop: 10 } },
	            _react2.default.createElement(_materialUi.Checkbox, {
	              label: "Send warning email message 7 days before renewal",
	              checked: true,
	              disabled: true
	            })
	          ),
	          _react2.default.createElement(
	            "div",
	            { style: { marginTop: 10 } },
	            _react2.default.createElement(_materialUi.Checkbox, {
	              label: "Send optional early warning email",
	              checked: showEarlyWarningEmailDropdown,
	              onCheck: function onCheck(e, checked) {
	                _this5.setState({ showEarlyWarningEmailDropdown: checked }, function () {
	                  if (!_this5.state.showEarlyWarningEmailDropdown) {
	                    _this5.onChangeValue("early_warning_email_interval", "");
	                  }
	                });
	              }
	            })
	          ),
	          showEarlyWarningEmailDropdown ? _react2.default.createElement(
	            "div",
	            { style: { marginTop: 10, width: 250 } },
	            _react2.default.createElement(
	              "div",
	              {
	                style: {
	                  color: "rgba(33, 33, 33, 0.5)",
	                  fontSize: 12,
	                  paddingBottom: 8
	                }
	              },
	              "Early warning email interval"
	            ),
	            _react2.default.createElement(
	              "div",
	              { style: { paddingBottom: "5px" } },
	              _react2.default.createElement(_reactSelect2.default, {
	                multi: false,
	                clearable: false,
	                value: (0, _get2.default)(this.state.values, "early_warning_email_interval", ""),
	                options: [{ value: 7, label: "14 days before renewal" }, { value: 14, label: "21 days before renewal" }, { value: 45, label: "52 days before renewal" }],
	                onChange: function onChange(v) {
	                  _this5.onChangeValue("early_warning_email_interval", v.value);
	                }
	              })
	            )
	          ) : null,
	          _react2.default.createElement(
	            "div",
	            { style: { marginTop: 10 } },
	            _react2.default.createElement(_materialUi.Checkbox, {
	              label: "Custom renewal warning email message",
	              checked: showCustomRenewalWarningEditor,
	              onCheck: function onCheck(e, checked) {
	                _this5.setState({ showCustomRenewalWarningEditor: checked }, function () {
	                  if (!_this5.state.showCustomRenewalWarningEditor) {
	                    _this5.onChangeValue("custom_renewal_warning_email_message", "");
	                  }
	                });
	              }
	            })
	          ),
	          showCustomRenewalWarningEditor ? _react2.default.createElement(_basicHtmlField2.default, {
	            value: (0, _get2.default)(this.state, "values.custom_renewal_warning_email_message", ""),
	            onChange: function onChange(v) {
	              return _this5.onChangeValue("custom_renewal_warning_email_message", v);
	            },
	            style: { paddingTop: 10 }
	          }) : null
	        ) : null,
	        _react2.default.createElement(
	          "div",
	          { style: styles.actions },
	          _react2.default.createElement(_materialUi.RaisedButton, {
	            label: this.state.dirty ? "Save changes" : "No changes to save",
	            primary: true,
	            disabled: !this.state.dirty,
	            onTouchTap: this.save
	          })
	        )
	      );
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this6 = this;
	
	      var isMembership = this.props.location.pathname.includes('membership');
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          "div",
	          { style: { position: "relative", paddingTop: 1, paddingBottom: 8 } },
	          _react2.default.createElement(
	            "div",
	            {
	              style: {
	                display: "flex",
	                justifyContent: "space-between",
	                alignItems: "center"
	              }
	            },
	            _react2.default.createElement(_backButton2.default, {
	              label: isMembership ? "memberships" : "pass buckets",
	              onTouchTap: function onTouchTap() {
	                return _this6.props.location.state && _this6.props.location.state.fromListing ? _this6.context.router.goBack() : _this6.context.router.push("/event_buckets/" + _this6.props.params.eventBucketId + "/" + (isMembership ? "memberships" : "pass_buckets"));
	              }
	            }),
	            _react2.default.createElement(
	              "h2",
	              { style: { flex: 1, textAlign: "center", fontSize: "2em" } },
	              this.state.values.name || "..."
	            ),
	            _react2.default.createElement(
	              _materialUi.IconButton,
	              {
	                tooltip: this.state.dirty ? "Please save before duplicating" : "Duplicate pass bucket",
	                onTouchTap: this.duplicate,
	                disabled: this.state.dirty
	              },
	              _react2.default.createElement(_contentCopy2.default, null)
	            )
	          ),
	          this.state.passBucket && this.state.passBucket.eventival_id && _react2.default.createElement(_eventivalBanner2.default, {
	            type: "pass bucket",
	            style: { marginTop: 15, marginBottom: 5 }
	          })
	        ),
	        _react2.default.createElement(
	          _materialUi.Tabs,
	          {
	            value: this.state.tab,
	            onChange: this.onChangeTab,
	            style: { clear: "both" }
	          },
	          _UserStore2.default.hasPermission("edit_pass_bucket") ? _react2.default.createElement(
	            _materialUi.Tab,
	            { label: "General", value: "core" },
	            this._makeCoreEditor()
	          ) : null,
	          _UserStore2.default.hasPermission("edit_pass_bucket") ? _react2.default.createElement(
	            _materialUi.Tab,
	            { label: "Messages", value: "messages" },
	            this._makeMessagesEditor()
	          ) : null,
	          _UserStore2.default.hasPermission("edit_pass_bucket") ? _react2.default.createElement(
	            _materialUi.Tab,
	            { label: "Supplementary data", value: "supplementary_data" },
	            _react2.default.createElement(_supplementaryDataEditor2.default, {
	              showHeader: false,
	              passBucketId: this.props.params.passBucketId,
	              eventBucketId: this.props.params.eventBucketId,
	              requiredFieldsToPurchase: (0, _get2.default)(this.state, "values.supplementary_data_required_before_purchase", false),
	              isMembership: isMembership
	            })
	          ) : null,
	          _UserStore2.default.hasPermission("edit_pass_bucket") || _UserStore2.default.hasPermission("view_pass_bucket_rules") ? _react2.default.createElement(
	            _materialUi.Tab,
	            { label: isMembership ? "Membership rules" : "Pass rules", value: "pass_rules" },
	            _react2.default.createElement(_passRulesEditor2.default, {
	              showHeader: false,
	              mode: "pass_bucket",
	              parentId: this.props.params.passBucketId,
	              eventBucketId: this.props.params.eventBucketId,
	              isMembership: isMembership
	            })
	          ) : null
	        )
	      );
	    }
	  }], [{
	    key: "getStores",
	    value: function getStores() {
	      return [_PassBucketStore2.default, _EventBucketStore2.default];
	    }
	  }, {
	    key: "getPropsFromStores",
	    value: function getPropsFromStores() {
	      return {
	        getPassBucketById: _PassBucketStore2.default.getPassBucketById,
	        getEventBucketById: _EventBucketStore2.default.getEventBucketById
	      };
	    }
	  }, {
	    key: "contextTypes",
	    get: function get() {
	      return {
	        router: _react2.default.PropTypes.object
	      };
	    }
	  }]);
	
	  return PassBucketEditor;
	}(_react2.default.Component);
	
	exports.default = (0, _connectToStores2.default)(PassBucketEditor);
	module.exports = exports["default"];

/***/ }),
/* 2744 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _materialUi = __webpack_require__(576);
	
	var _label = __webpack_require__(1682);
	
	var _label2 = _interopRequireDefault(_label);
	
	var _quantityEditor = __webpack_require__(2191);
	
	var _quantityEditor2 = _interopRequireDefault(_quantityEditor);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var INTERVALS = ["day", "week", "month", "year"];
	
	var RecurrenceField = function (_React$Component) {
	  _inherits(RecurrenceField, _React$Component);
	
	  function RecurrenceField(props) {
	    _classCallCheck(this, RecurrenceField);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(RecurrenceField).call(this, props));
	
	    _this._makeIntervalItems = _this._makeIntervalItems.bind(_this);
	    return _this;
	  }
	
	  _createClass(RecurrenceField, [{
	    key: "_makeIntervalItems",
	    value: function _makeIntervalItems() {
	      var count = this.props.value[0];
	      return INTERVALS.map(function (item, i) {
	        return _react2.default.createElement(_materialUi.MenuItem, {
	          key: i,
	          primaryText: "" + item + (count !== 1 ? "s" : ""),
	          value: item,
	          style: { cursor: "pointer" }
	        });
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props;
	      var value = _props.value;
	      var label = _props.label;
	      var props = _objectWithoutProperties(_props, ["value", "label"]);
	
	      var _value = _slicedToArray(value, 2);
	
	      var count = _value[0];
	      var interval = _value[1];
	
	
	      return _react2.default.createElement(
	        "div",
	        props,
	        label || "Repeat every",
	        _react2.default.createElement(_quantityEditor2.default, {
	          min: 1,
	          style: { display: "inline-block" },
	          quantity: count,
	          updateQuantity: function updateQuantity(q) {
	            return _this2.props.onChange([q, interval]);
	          }
	        }),
	        _react2.default.createElement(
	          _materialUi.DropDownMenu,
	          {
	            value: interval,
	            onChange: function onChange(e, index, value) {
	              return _this2.props.onChange([count, value]);
	            }
	          },
	          this._makeIntervalItems()
	        )
	      );
	    }
	  }]);
	
	  return RecurrenceField;
	}(_react2.default.Component);
	
	exports.default = RecurrenceField;
	module.exports = exports["default"];

/***/ }),
/* 2745 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _materialUi = __webpack_require__(576);
	
	var _reactRouter = __webpack_require__(486);
	
	var _passRuleEditor = __webpack_require__(2734);
	
	var _passRuleEditor2 = _interopRequireDefault(_passRuleEditor);
	
	var _infoNotice = __webpack_require__(1599);
	
	var _infoNotice2 = _interopRequireDefault(_infoNotice);
	
	var _connectToStores = __webpack_require__(1226);
	
	var _connectToStores2 = _interopRequireDefault(_connectToStores);
	
	var _EventActions = __webpack_require__(2031);
	
	var _EventActions2 = _interopRequireDefault(_EventActions);
	
	var _EventStore = __webpack_require__(2032);
	
	var _EventStore2 = _interopRequireDefault(_EventStore);
	
	var _PassBucketActions = __webpack_require__(1869);
	
	var _PassBucketActions2 = _interopRequireDefault(_PassBucketActions);
	
	var _PassBucketStore = __webpack_require__(1867);
	
	var _PassBucketStore2 = _interopRequireDefault(_PassBucketStore);
	
	var _EventBucketStore = __webpack_require__(1593);
	
	var _EventBucketStore2 = _interopRequireDefault(_EventBucketStore);
	
	var _passRulesEditorNonatomic = __webpack_require__(2733);
	
	var _passRulesEditorNonatomic2 = _interopRequireDefault(_passRulesEditorNonatomic);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PassRulesEditor = function (_React$Component) {
	  _inherits(PassRulesEditor, _React$Component);
	
	  function PassRulesEditor(props) {
	    _classCallCheck(this, PassRulesEditor);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(PassRulesEditor).call(this, props));
	
	    _this.state = {
	      isFetchingRules: false,
	      rules: [],
	      orderKey: 0 // Used to force re-rendering of the list
	    };
	
	    _this.addNew = _this.addNew.bind(_this);
	    return _this;
	  }
	
	  _createClass(PassRulesEditor, [{
	    key: "onRuleShiftPosition",
	    value: function onRuleShiftPosition(index, direction) {
	      var arr = this.state.rules;
	      arr.splice(index + direction, 0, arr.splice(index, 1)[0]);
	      this.setState({
	        rules: arr,
	        orderKey: this.state.orderKey + 1
	      }, function () {
	        _PassBucketActions2.default.edit(this.props.parentId, {
	          rules: this.state.rules
	        });
	      });
	    }
	  }, {
	    key: "addNew",
	    value: function addNew(item) {
	      var isPassBucket = this.props.mode === "pass_bucket";
	
	      this.state.rules.push(item);
	
	      (isPassBucket ? _PassBucketActions2.default : _EventActions2.default).edit(this.props.parentId, {
	        rules: this.state.rules
	      });
	    }
	  }, {
	    key: "saveRule",
	    value: function saveRule(index, rule) {
	      var isPassBucket = this.props.mode === "pass_bucket";
	
	      if (rule === null) {
	        // delete rule
	        this.state.rules.splice(index, 1);
	      } else {
	        this.state.rules[index] = rule;
	      }
	
	      _PassBucketActions2.default.edit(this.props.parentId, {
	        rules: this.state.rules
	      });
	    }
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.componentWillReceiveProps(this.props);
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(newProps) {
	      var isPassBucket = this.props.mode === "pass_bucket";
	      var parent = (isPassBucket ? _PassBucketStore2.default.getPassBucketById : _EventStore2.default.getEventById)(newProps.parentId);
	      var rules = parent ? parent.rules || [] : null;
	
	      if (!rules && !this.state.isFetchingRules) {
	        (isPassBucket ? _PassBucketActions2.default : _EventActions2.default).fetchOne(newProps.parentId);
	        this.setState({ isFetchingRules: true, rules: [] });
	      } else if (rules) {
	        if (parent && parent.updated_at && this.state.lastUpdatedAt && parent.updated_at === this.state.lastUpdatedAt) {
	          // Ignore update if it's the same as the last one, to avoid flickering
	          // of the old rules while a save is in progress.
	          return;
	        }
	
	        this.setState({
	          isFetchingRules: false,
	          lastUpdatedAt: parent && parent.updated_at,
	          rules: rules
	        });
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement(_passRulesEditorNonatomic2.default, _extends({}, this.props, {
	        passRules: this.state.rules,
	        onDelete: function onDelete(i) {
	          return _this2.saveRule(i, null);
	        },
	        onChange: function onChange(i, e) {
	          return _this2.saveRule(i, e);
	        },
	        onAdd: function onAdd(e) {
	          return _this2.addNew(e);
	        },
	        onShiftPosition: function onShiftPosition(index, direction) {
	          return _this2.onRuleShiftPosition(index, direction);
	        },
	        orderKey: this.state.orderKey,
	        isMembership: this.props.isMembership
	      }));
	    }
	  }], [{
	    key: "getStores",
	    value: function getStores() {
	      return [_EventStore2.default, _PassBucketStore2.default, _EventBucketStore2.default];
	    }
	  }, {
	    key: "getPropsFromStores",
	    value: function getPropsFromStores() {
	      return {
	        getEventById: _EventStore2.default.getEventById,
	        getPassBucketById: _PassBucketStore2.default.getPassBucketById,
	        getEventBucketById: _EventBucketStore2.default.getEventBucketById,
	        getEventBuckets: _EventBucketStore2.default.getEventBuckets
	      };
	    }
	  }, {
	    key: "contextTypes",
	    get: function get() {
	      return {
	        router: _react2.default.PropTypes.object
	      };
	    }
	  }]);
	
	  return PassRulesEditor;
	}(_react2.default.Component);
	
	exports.default = (0, _connectToStores2.default)(PassRulesEditor);
	module.exports = exports["default"];

/***/ }),
/* 2746 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _materialUi = __webpack_require__(576);
	
	var _uniqueId = __webpack_require__(2747);
	
	var _uniqueId2 = _interopRequireDefault(_uniqueId);
	
	var _supplementaryDataEditorField = __webpack_require__(2748);
	
	var _supplementaryDataEditorField2 = _interopRequireDefault(_supplementaryDataEditorField);
	
	var _infoNotice = __webpack_require__(1599);
	
	var _infoNotice2 = _interopRequireDefault(_infoNotice);
	
	var _connectToStores = __webpack_require__(1226);
	
	var _connectToStores2 = _interopRequireDefault(_connectToStores);
	
	var _PassBucketActions = __webpack_require__(1869);
	
	var _PassBucketActions2 = _interopRequireDefault(_PassBucketActions);
	
	var _PassBucketStore = __webpack_require__(1867);
	
	var _PassBucketStore2 = _interopRequireDefault(_PassBucketStore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SupplementaryDataEditor = function (_React$Component) {
	  _inherits(SupplementaryDataEditor, _React$Component);
	
	  function SupplementaryDataEditor(props) {
	    _classCallCheck(this, SupplementaryDataEditor);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(SupplementaryDataEditor).call(this, props));
	
	    _this.state = {
	      isFetchingFields: false,
	      isEdited: false,
	      lastUpdatedAt: null,
	      invalidFieldTexts: [],
	      fields: []
	    };
	
	    _this.addField = _this.addField.bind(_this);
	    _this.save = _this.save.bind(_this);
	    return _this;
	  }
	
	  _createClass(SupplementaryDataEditor, [{
	    key: "getStyles",
	    value: function getStyles() {
	      return {
	        actions: {
	          marginTop: 10
	        }
	      };
	    }
	  }, {
	    key: "save",
	    value: function save() {
	      var fields = this.state.fields.map(function (f) {
	        return Object.assign({}, f);
	      });
	      fields.forEach(function (f) {
	        delete f._temp_id;
	      });
	      _PassBucketActions2.default.edit(this.props.passBucketId, {
	        supplementary_data: fields
	      });
	    }
	  }, {
	    key: "addField",
	    value: function addField() {
	      var fields = this.state.fields;
	      fields.push({
	        type: "string",
	        key: "data_" + Date.now(),
	        _temp_id: (0, _uniqueId2.default)("supplementarydatafield_")
	      });
	      this.validateFields(fields);
	      this.setState({ fields: fields });
	    }
	  }, {
	    key: "updateField",
	    value: function updateField(index, field) {
	      var fields = this.state.fields;
	
	      if (field === null) {
	        // delete rule
	        fields.splice(index, 1);
	      } else {
	        fields[index] = field;
	      }
	
	      this.validateFields(fields);
	
	      this.setState({ fields: fields, isEdited: true });
	      if (this.props.onEdited) {
	        this.props.onEdited(field);
	      }
	    }
	  }, {
	    key: "validateField",
	    value: function validateField(field) {
	      var index = arguments.length <= 1 || arguments[1] === undefined ? 0 : arguments[1];
	
	      var invalidText = "";
	
	      var currentIndex = index + 1;
	
	      if (field.type === 'select') {
	        invalidText = typeof field.options !== "undefined" && field.options.length > 0 ? "" : "You have an invalid field! Field #" + currentIndex + " does not have any options! Please add an option to the field.";
	      }
	
	      if (field.type === "checkbox") {
	        invalidText = typeof field.checkbox_label !== "undefined" && field.checkbox_label !== "" ? "" : "You have an invalid field! Field #" + currentIndex + " does not have a checkbox label! Please add the checkbox label to the field.";
	      }
	
	      return typeof field.label === "undefined" || field.label === "" ? "You have an invalid field! Field #" + currentIndex + " has a blank label. Make sure all fields have labels." : invalidText;
	    }
	  }, {
	    key: "validateFields",
	    value: function validateFields(fields) {
	      var _this2 = this;
	
	      var requiredFieldsToPurchase = this.props.requiredFieldsToPurchase;
	
	
	      var invalidFieldTexts = [];
	
	      fields.forEach(function (field, i) {
	        var invalidText = _this2.validateField(field, i);
	        if (invalidText !== "") {
	          invalidFieldTexts.push(invalidText);
	        }
	      });
	
	      if (requiredFieldsToPurchase && fields.length <= 0) {
	        invalidFieldTexts.push("There needs to be at least 1 field present while supplementary data is required before purchase. Please change the setting in the Messages tab if you do not want supplementary fields anymore.");
	      }
	
	      this.setState({ invalidFieldTexts: invalidFieldTexts });
	    }
	  }, {
	    key: "shiftPosition",
	    value: function shiftPosition(index, direction) {
	      var fields = this.state.fields;
	      fields.splice(index + direction, 0, fields.splice(index, 1)[0]);
	      this.setState({ fields: fields, isEdited: true });
	      this.validateFields(fields);
	    }
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.componentWillReceiveProps(this.props);
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(newProps) {
	      var passBucket = _PassBucketStore2.default.getPassBucketById(newProps.passBucketId),
	          fields = passBucket ? passBucket.supplementary_data || [] : null;
	
	      if (!fields && !this.state.isFetchingFields) {
	        _PassBucketActions2.default.fetchOne(newProps.passBucketId);
	        this.setState({ isFetchingFields: true, fields: [] });
	      } else if (fields && this.state.lastUpdatedAt !== passBucket.updated_at) {
	        fields.forEach(function (f) {
	          f._temp_id = (0, _uniqueId2.default)("supplementarydatafield_");
	        });
	        this.setState({
	          isFetchingFields: false,
	          fields: fields,
	          isEdited: false,
	          lastUpdatedAt: passBucket.updated_at
	        });
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this3 = this;
	
	      var styles = this.getStyles();
	      var isMembership = this.props.isMembership;
	
	      var fieldComponents = this.state.fields.map(function (f, i) {
	        return _react2.default.createElement(_supplementaryDataEditorField2.default, {
	          key: "field-" + f._temp_id,
	          field: f,
	          shiftPosition: _this3.shiftPosition.bind(_this3, i),
	          canShiftUp: i > 0,
	          canShiftDown: i < _this3.state.fields.length - 1,
	          update: _this3.updateField.bind(_this3, i),
	          index: i + 1
	        });
	      });
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        this.props.showHeader ? _react2.default.createElement(
	          "h2",
	          null,
	          "Supplementary data"
	        ) : null,
	        _react2.default.createElement(
	          "p",
	          null,
	          "Use these fields to collect more than just a name from " + (isMembership ? "members" : "passholders") + ".",
	          _react2.default.createElement(
	            _infoNotice2.default,
	            { style: { marginTop: 5 } },
	            "Check out our",
	            " ",
	            _react2.default.createElement(
	              "a",
	              {
	                href: "http://help.eventive.org/passes/collect-supplementary-data",
	                target: "_blank"
	              },
	              "guide to collecting supplementary data"
	            ),
	            "."
	          )
	        ),
	        fieldComponents,
	        _react2.default.createElement(
	          "ul",
	          null,
	          this.state.invalidFieldTexts.length > 0 && this.state.invalidFieldTexts.map(function (text) {
	            return _react2.default.createElement(
	              "li",
	              { style: { color: "red" } },
	              text
	            );
	          })
	        ),
	        _react2.default.createElement(
	          "div",
	          { style: styles.actions },
	          _react2.default.createElement(_materialUi.RaisedButton, {
	            label: "Save fields",
	            onTouchTap: this.save,
	            primary: true,
	            disabled: !this.state.isEdited || this.state.invalidFieldTexts.length > 0,
	            style: { marginRight: 7 }
	          }),
	          _react2.default.createElement(_materialUi.RaisedButton, { label: "Add new field", onTouchTap: this.addField })
	        )
	      );
	    }
	  }], [{
	    key: "getStores",
	    value: function getStores() {
	      return [_PassBucketStore2.default];
	    }
	  }, {
	    key: "getPropsFromStores",
	    value: function getPropsFromStores() {
	      return {
	        getPassBucketById: _PassBucketStore2.default.getPassBucketById
	      };
	    }
	  }, {
	    key: "contextTypes",
	    get: function get() {
	      return {
	        router: _react2.default.PropTypes.object
	      };
	    }
	  }]);
	
	  return SupplementaryDataEditor;
	}(_react2.default.Component);
	
	exports.default = (0, _connectToStores2.default)(SupplementaryDataEditor);
	module.exports = exports["default"];

/***/ }),
/* 2747 */
/***/ (function(module, exports, __webpack_require__) {

	var toString = __webpack_require__(1011);
	
	/** Used to generate unique IDs. */
	var idCounter = 0;
	
	/**
	 * Generates a unique ID. If `prefix` is given, the ID is appended to it.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Util
	 * @param {string} [prefix=''] The value to prefix the ID with.
	 * @returns {string} Returns the unique ID.
	 * @example
	 *
	 * _.uniqueId('contact_');
	 * // => 'contact_104'
	 *
	 * _.uniqueId();
	 * // => '105'
	 */
	function uniqueId(prefix) {
	  var id = ++idCounter;
	  return toString(prefix) + id;
	}
	
	module.exports = uniqueId;


/***/ }),
/* 2748 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _materialUi = __webpack_require__(576);
	
	var _orderableTextFieldList = __webpack_require__(2749);
	
	var _orderableTextFieldList2 = _interopRequireDefault(_orderableTextFieldList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FIELD_TYPES = [["string", "Text"], ["address", "Mailing address"], ["phone", "Phone number"], ["date", "Date"], ["select", "Dropdown select"], ["checkbox", "Checkbox"], ["state", "State (US)"], ["image", "Image upload"]];
	
	var SupplementaryDataEditorField = function (_React$Component) {
	  _inherits(SupplementaryDataEditorField, _React$Component);
	
	  function SupplementaryDataEditorField(props) {
	    _classCallCheck(this, SupplementaryDataEditorField);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(SupplementaryDataEditorField).call(this, props));
	
	    _this.update = _this.update.bind(_this);
	    _this.delete = _this.delete.bind(_this);
	    _this.shift = _this.shift.bind(_this);
	    _this._makeCheckbox = _this._makeCheckbox.bind(_this);
	    _this._makeTextField = _this._makeTextField.bind(_this);
	    return _this;
	  }
	
	  _createClass(SupplementaryDataEditorField, [{
	    key: "getStyles",
	    value: function getStyles() {
	      return {
	        container: {
	          border: "1px solid #ccc",
	          padding: "0 20px 20px",
	          marginBottom: 10
	        },
	        actionsContainer: {
	          float: "right",
	          marginTop: 16,
	          display: "flex",
	          alignItems: "center"
	          // marginTop: 10
	        }
	      };
	    }
	  }, {
	    key: "changeType",
	    value: function changeType(type) {
	      this.update({
	        type: type,
	        label: this.props.field.label || FIELD_TYPES.find(function (f) {
	          return f[0] === type;
	        })[1] // inject label if none set already
	      });
	    }
	  }, {
	    key: "update",
	    value: function update(data) {
	      // Extend, don't overwrite
	      this.props.update(Object.assign({}, this.props.field, data));
	    }
	  }, {
	    key: "delete",
	    value: function _delete() {
	      if (window.confirm("Are you sure? Any existing responses to this question will be deleted.")) {
	        this.props.update(null);
	      }
	    }
	  }, {
	    key: "shift",
	    value: function shift(dir) {
	      this.props.shiftPosition(dir);
	    }
	  }, {
	    key: "_makeCheckbox",
	    value: function _makeCheckbox(label, fieldKey, opts) {
	      var _this2 = this;
	
	      var field = this.props.field;
	
	
	      return _react2.default.createElement(
	        "div",
	        { key: "checkbox-" + fieldKey, style: { width: 400 } },
	        _react2.default.createElement(_materialUi.Checkbox, _extends({
	          label: label,
	          checked: field[fieldKey],
	          onCheck: function onCheck(e) {
	            return _this2.update(_defineProperty({}, fieldKey, !field[fieldKey]));
	          }
	        }, opts))
	      );
	    }
	  }, {
	    key: "_makeTextField",
	    value: function _makeTextField(label, fieldKey, opts) {
	      var _this3 = this;
	
	      var field = this.props.field;
	
	
	      return _react2.default.createElement(
	        "div",
	        { key: "textfield-" + fieldKey },
	        _react2.default.createElement(_materialUi.TextField, _extends({
	          floatingLabelText: label,
	          floatingLabelFixed: true,
	          value: field[fieldKey],
	          fullWidth: true,
	          onChange: function onChange(e) {
	            return _this3.update(_defineProperty({}, fieldKey, e.target.value));
	          }
	        }, opts))
	      );
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this4 = this;
	
	      var styles = this.getStyles();
	      var field = this.props.field;
	
	
	      var additional = [];
	
	      if (field.type === "string") {
	        additional.push(this._makeCheckbox("Multiline", "multiline"));
	      }
	
	      if (field.type === "checkbox") {
	        additional.push(this._makeTextField("Checkbox label (displayed directly next to the ☑)", "checkbox_label"));
	      }
	
	      if (field.type === "state") {
	        additional.push(this._makeCheckbox('Show "I don\'t live in the United States" option', "show_none_option"));
	        if (field.show_none_option) {
	          field.none_option_text = field.none_option_text || "I don't live in the United States";
	          additional.push(this._makeTextField("Alternative text for non-US option", "none_option_text"));
	        }
	      }
	
	      if (field.type === "select") {
	        additional.push(this._makeCheckbox("Allow multiple selections", "multiple"));
	        additional.push(_react2.default.createElement(_orderableTextFieldList2.default, {
	          label: "Options",
	          addLabel: "Add option",
	          fields: field.options,
	          onChange: function onChange(values) {
	            return _this4.update({ options: values });
	          }
	        }));
	      }
	
	      if (field.type === "image") {
	        additional.push(this._makeCheckbox("Square (1:1 aspect ratio)", "square"));
	      }
	
	      return _react2.default.createElement(
	        "div",
	        { style: styles.container },
	        _react2.default.createElement(
	          "div",
	          { style: styles.actionsContainer },
	          _react2.default.createElement(
	            "h3",
	            { style: { marginRight: 7 } },
	            "Field #" + this.props.index
	          ),
	          _react2.default.createElement(_materialUi.RaisedButton, { label: "Delete", onTouchTap: this.delete }),
	          _react2.default.createElement(_materialUi.RaisedButton, {
	            label: "\u25B2",
	            style: { minWidth: 30, marginLeft: 7 },
	            disabled: !this.props.canShiftUp,
	            onTouchTap: function onTouchTap() {
	              return _this4.shift(-1);
	            }
	          }),
	          _react2.default.createElement(_materialUi.RaisedButton, {
	            label: "\u25BC",
	            style: { minWidth: 30, marginLeft: 7 },
	            disabled: !this.props.canShiftDown,
	            onTouchTap: function onTouchTap() {
	              return _this4.shift(1);
	            }
	          })
	        ),
	        _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement(
	            _materialUi.SelectField,
	            {
	              value: field.type,
	              floatingLabelText: "Type",
	              onChange: function onChange(e, key, value) {
	                return _this4.changeType(value);
	              }
	            },
	            FIELD_TYPES.map(function (t) {
	              return _react2.default.createElement(_materialUi.MenuItem, { value: t[0], primaryText: t[1] });
	            })
	          )
	        ),
	        this._makeTextField("Label", "label"),
	        this._makeTextField("Description", "description", {
	          multiLine: true,
	          style: { marginBottom: 10 }
	        }),
	        this._makeCheckbox("Required", "required"),
	        this._makeCheckbox("Hidden from customer", "hidden"),
	        additional
	      );
	    }
	  }]);
	
	  return SupplementaryDataEditorField;
	}(_react2.default.Component);
	
	exports.default = SupplementaryDataEditorField;
	module.exports = exports["default"];

/***/ }),
/* 2749 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _materialUi = __webpack_require__(576);
	
	var _label = __webpack_require__(1682);
	
	var _label2 = _interopRequireDefault(_label);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var OrderableTextFieldList = function (_React$Component) {
	  _inherits(OrderableTextFieldList, _React$Component);
	
	  function OrderableTextFieldList(props) {
	    _classCallCheck(this, OrderableTextFieldList);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(OrderableTextFieldList).call(this, props));
	
	    _this.addNew = _this.addNew.bind(_this);
	    _this.update = _this.update.bind(_this);
	    _this.shiftPosition = _this.shiftPosition.bind(_this);
	    return _this;
	  }
	
	  _createClass(OrderableTextFieldList, [{
	    key: "addNew",
	    value: function addNew() {
	      var fields = this.props.fields;
	      fields.push("");
	      this.props.onChange(fields);
	    }
	  }, {
	    key: "update",
	    value: function update(i, value) {
	      var fields = this.props.fields;
	      fields[i] = value;
	      this.props.onChange(fields);
	    }
	  }, {
	    key: "delete",
	    value: function _delete(i) {
	      var fields = this.props.fields;
	      fields.splice(i, 1);
	      this.props.onChange(fields);
	    }
	  }, {
	    key: "shiftPosition",
	    value: function shiftPosition(index, direction) {
	      var fields = this.props.fields;
	      fields.splice(index + direction, 0, fields.splice(index, 1)[0]);
	      this.props.onChange(fields);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props;
	      var label = _props.label;
	      var addLabel = _props.addLabel;
	      var fields = _props.fields;
	
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        label ? _react2.default.createElement(
	          _label2.default,
	          { style: { marginTop: 20, marginBottom: -10 } },
	          label
	        ) : null,
	        _react2.default.createElement(
	          "ul",
	          { style: { paddingLeft: 30 } },
	          fields.map(function (f, i) {
	            return _react2.default.createElement(
	              "li",
	              { key: i },
	              _react2.default.createElement(_materialUi.TextField, {
	                name: label + "_" + i + "-textfield",
	                value: f,
	                onChange: function onChange(e) {
	                  return _this2.update(i, e.target.value);
	                }
	              }),
	              _react2.default.createElement(_materialUi.FlatButton, {
	                label: "\u25B2",
	                style: { minWidth: 30, marginLeft: 7 },
	                labelStyle: { padding: 0 },
	                disabled: i === 0,
	                onTouchTap: function onTouchTap() {
	                  return _this2.shiftPosition(i, -1);
	                }
	              }),
	              _react2.default.createElement(_materialUi.FlatButton, {
	                label: "\u25BC",
	                style: { minWidth: 30 },
	                labelStyle: { padding: 0 },
	                disabled: i === fields.length - 1,
	                onTouchTap: function onTouchTap() {
	                  return _this2.shiftPosition(i, 1);
	                }
	              }),
	              _react2.default.createElement(_materialUi.FlatButton, {
	                label: "\xD7",
	                style: { minWidth: 30 },
	                labelStyle: { padding: 0 },
	                onTouchTap: function onTouchTap() {
	                  return _this2.delete(i);
	                }
	              })
	            );
	          })
	        ),
	        _react2.default.createElement(_materialUi.RaisedButton, {
	          label: addLabel || "Add",
	          style: { marginLeft: "1em" },
	          onTouchTap: this.addNew
	        })
	      );
	    }
	  }], [{
	    key: "defaultProps",
	    get: function get() {
	      return {
	        fields: []
	      };
	    }
	  }]);
	
	  return OrderableTextFieldList;
	}(_react2.default.Component);
	
	exports.default = OrderableTextFieldList;
	module.exports = exports["default"];

/***/ }),
/* 2750 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _connectToStores = __webpack_require__(1226);
	
	var _connectToStores2 = _interopRequireDefault(_connectToStores);
	
	var _PassBucketActions = __webpack_require__(1869);
	
	var _PassBucketActions2 = _interopRequireDefault(_PassBucketActions);
	
	var _PassBucketStore = __webpack_require__(1867);
	
	var _PassBucketStore2 = _interopRequireDefault(_PassBucketStore);
	
	var _workingIndicator = __webpack_require__(1664);
	
	var _workingIndicator2 = _interopRequireDefault(_workingIndicator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var NewPassBucket = function (_React$Component) {
	  _inherits(NewPassBucket, _React$Component);
	
	  function NewPassBucket(props) {
	    _classCallCheck(this, NewPassBucket);
	
	    return _possibleConstructorReturn(this, Object.getPrototypeOf(NewPassBucket).call(this, props));
	  }
	
	  _createClass(NewPassBucket, [{
	    key: "componentWillMount",
	    value: function componentWillMount() {
	      if (this.props.location.query.duplicate) {
	        return;
	      }
	
	      _PassBucketActions2.default.create({
	        name: this.props.location.pathname.includes('membership') ? "Unnamed Membership" : "Unnamed Pass Bucket",
	        event_bucket: this.props.params.eventBucketId,
	        is_membership: this.props.location.pathname.includes('membership'),
	        recurrence_enabled: this.props.location.pathname.includes('membership'),
	        recurrence_interval: "year",
	        recurrence_count: 1
	      });
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(props) {
	      if (props.newPassBucketId) {
	        this.context.router.replace("/event_buckets/" + props.params.eventBucketId + "/" + (this.props.location.pathname.includes('membership') ? "memberships" : "pass_buckets") + "/" + props.newPassBucketId + "/edit");
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement(_workingIndicator2.default, { fullPage: true });
	    }
	  }], [{
	    key: "getStores",
	    value: function getStores() {
	      return [_PassBucketStore2.default];
	    }
	  }, {
	    key: "getPropsFromStores",
	    value: function getPropsFromStores() {
	      return {
	        newPassBucketId: _PassBucketStore2.default.getState().newPassBucketId
	      };
	    }
	  }, {
	    key: "contextTypes",
	    get: function get() {
	      return {
	        router: _react2.default.PropTypes.object
	      };
	    }
	  }]);
	
	  return NewPassBucket;
	}(_react2.default.Component);
	
	exports.default = (0, _connectToStores2.default)(NewPassBucket);
	module.exports = exports["default"];

/***/ }),
/* 2751 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _materialUi = __webpack_require__(576);
	
	var _reactSelect = __webpack_require__(953);
	
	var _moment = __webpack_require__(1021);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _qs = __webpack_require__(1206);
	
	var _qs2 = _interopRequireDefault(_qs);
	
	var _uniq = __webpack_require__(2188);
	
	var _uniq2 = _interopRequireDefault(_uniq);
	
	var _config = __webpack_require__(1173);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _connectToStores = __webpack_require__(1226);
	
	var _connectToStores2 = _interopRequireDefault(_connectToStores);
	
	var _PassBucketActions = __webpack_require__(1869);
	
	var _PassBucketActions2 = _interopRequireDefault(_PassBucketActions);
	
	var _PassBucketStore = __webpack_require__(1867);
	
	var _PassBucketStore2 = _interopRequireDefault(_PassBucketStore);
	
	var _PassStore = __webpack_require__(2048);
	
	var _PassStore2 = _interopRequireDefault(_PassStore);
	
	var _PassActions = __webpack_require__(2047);
	
	var _PassActions2 = _interopRequireDefault(_PassActions);
	
	var _UserStore = __webpack_require__(974);
	
	var _UserStore2 = _interopRequireDefault(_UserStore);
	
	var _EventBucketStore = __webpack_require__(1593);
	
	var _EventBucketStore2 = _interopRequireDefault(_EventBucketStore);
	
	var _EventBucketActions = __webpack_require__(1218);
	
	var _EventBucketActions2 = _interopRequireDefault(_EventBucketActions);
	
	var _infoNotice = __webpack_require__(1599);
	
	var _infoNotice2 = _interopRequireDefault(_infoNotice);
	
	var _injectedSelect = __webpack_require__(1874);
	
	var _injectedSelect2 = _interopRequireDefault(_injectedSelect);
	
	var _label = __webpack_require__(1682);
	
	var _label2 = _interopRequireDefault(_label);
	
	var _linkLike = __webpack_require__(973);
	
	var _linkLike2 = _interopRequireDefault(_linkLike);
	
	var _datetimeField = __webpack_require__(2061);
	
	var _datetimeField2 = _interopRequireDefault(_datetimeField);
	
	var _selectField = __webpack_require__(1683);
	
	var _selectField2 = _interopRequireDefault(_selectField);
	
	var _quantityEditor = __webpack_require__(2191);
	
	var _quantityEditor2 = _interopRequireDefault(_quantityEditor);
	
	var _workingIndicator = __webpack_require__(1664);
	
	var _workingIndicator2 = _interopRequireDefault(_workingIndicator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DEFAULT_FIELDS = [{ value: "name", label: "Name" }];
	
	var CUSTOM_TEXT_PREFIX = "custom|";
	
	var PassLabelPrinter = function (_React$Component) {
	  _inherits(PassLabelPrinter, _React$Component);
	
	  function PassLabelPrinter(props) {
	    _classCallCheck(this, PassLabelPrinter);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(PassLabelPrinter).call(this, props));
	
	    _this.state = {
	      selectedPasses: null,
	      skip: null,
	      selectedPassBuckets: [],
	      selectedMemberships: [],
	      passBucketConfiguration: {},
	      shownConfigs: {},
	      hasInjectedSavedSettings: false,
	      settings: {},
	      printAllTime: true,
	      startTime: (0, _moment2.default)().startOf("day").toDate(),
	      endTime: null,
	
	      printing: false,
	      showPrintSuccess: false,
	      completedPrint: null,
	      isMembership: null
	    };
	
	    _this.setPassBuckets = _this.setPassBuckets.bind(_this);
	    _this.updateConfig = _this.updateConfig.bind(_this);
	    _this.getPDFUrl = _this.getPDFUrl.bind(_this);
	    _this.print = _this.print.bind(_this);
	    _this.closePrint = _this.closePrint.bind(_this);
	    return _this;
	  }
	
	  _createClass(PassLabelPrinter, [{
	    key: "setPassBuckets",
	    value: function setPassBuckets(items) {
	      var _this2 = this;
	
	      var persist = arguments.length <= 1 || arguments[1] === undefined ? true : arguments[1];
	
	      var filteredItems = items.filter(function (i) {
	        return i.is_membership === _this2.state.isMembership;
	      });
	      var config = {};
	
	      filteredItems.forEach(function (b) {
	        config[b.id] = b.label_printer_config || {};
	        if (!config[b.id].rows || !config[b.id].rows.length) {
	          config[b.id].rows = [{ fields: ["name"] }];
	        }
	      });
	
	      this.setState({
	        selectedPassBuckets: this.state.isMembership ? [] : filteredItems,
	        selectedMemberships: this.state.isMembership ? filteredItems : [],
	        passBucketConfiguration: config
	      });
	
	      // Persist
	      if (persist) {
	        this.updateSetting("selected_pass_buckets", filteredItems.map(function (b) {
	          return b.id;
	        }));
	      }
	    }
	  }, {
	    key: "updateConfig",
	    value: function updateConfig(id, config) {
	      var passBucketConfiguration = Object.assign({}, this.state.passBucketConfiguration);
	      passBucketConfiguration[id] = config;
	      this.setState({ passBucketConfiguration: passBucketConfiguration });
	
	      // Persist
	      _PassBucketActions2.default.edit(id, {
	        label_printer_config: config
	      });
	    }
	  }, {
	    key: "updateSetting",
	    value: function updateSetting(key, value) {
	      var settings = Object.assign({}, this.state.settings);
	      settings[key] = value;
	      this.setState({ settings: settings });
	
	      // Persist
	      _EventBucketActions2.default.edit(this.props.params.eventBucketId, {
	        label_printer_config: settings
	      });
	    }
	  }, {
	    key: "getPDFUrl",
	    value: function getPDFUrl() {
	      var opts = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	      var apiKey = this.props.apiKey;
	
	
	      if (opts.id && !Array.isArray(opts.id)) {
	        opts.id = [opts.id];
	      }
	
	      var items = this.state.isMembership ? this.state.selectedMemberships : this.state.selectedPassBuckets;
	
	      var conditions = {
	        _id: (Array.isArray(opts.id) ? { $in: opts.id } : null) || this.state.selectedPasses && {
	          $in: this.state.selectedPasses.map(function (p) {
	            return p.id;
	          })
	        } || undefined,
	        pass_bucket: !this.state.selectedPasses && items.length ? items.map(function (b) {
	          return b.id;
	        }) : undefined,
	        updated_at: !this.state.printAllTime && (this.state.startTime || this.state.endTime) ? {
	          $gte: this.state.startTime ? this.state.startTime.toISOString() : undefined,
	          $lte: this.state.endTime ? this.state.endTime.toISOString() : undefined
	        } : undefined
	      },
	          query = {
	        api_key: apiKey,
	        god_become_user: _UserStore2.default.isGod() ? _UserStore2.default.getGodCredentials().activeUser : undefined,
	        conditions: JSON.stringify(conditions),
	        skip: opts.skip || this.state.skip || undefined
	      };
	
	      return _config2.default.endpoint + "passes/labels" + (opts.directPdf ? ".pdf" : "") + "?" + _qs2.default.stringify(query);
	    }
	  }, {
	    key: "print",
	    value: function print() {
	      var _this3 = this;
	
	      this.setState({ printing: true });
	      fetch(this.getPDFUrl()).then(function (r) {
	        return r.json();
	      }).then(function (d) {
	        if (d.error || !d.temporary_export) {
	          _this3.setState({
	            printing: false,
	            showPrintSuccess: true,
	            completedPrint: {
	              error: d.error ? d.error.message : "An unknown error occurred"
	            }
	          });
	        } else {
	          _this3._checkInterval = setInterval(function () {
	            fetch(_config2.default.endpoint + "temporary_exports/" + d.temporary_export + "?" + _UserStore2.default.makeApiKeyQueryString()).then(function (r) {
	              return r.json();
	            }).then(function (e) {
	              if (e.completed_at) {
	                clearInterval(_this3._checkInterval);
	                _this3.setState({
	                  printing: false,
	                  showPrintSuccess: true,
	                  completedPrint: e
	                });
	                if (e.download_url) {
	                  window.open(e.download_url);
	                }
	              }
	            });
	          }, 1000);
	        }
	      });
	    }
	  }, {
	    key: "closePrint",
	    value: function closePrint() {
	      this.setState({
	        printing: false,
	        showPrintSuccess: false,
	        completedPrint: null
	      });
	      clearInterval(this._checkInterval);
	    }
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var isMembership = this.props.location.pathname.includes("membership");
	      this.setState({ isMembership: isMembership });
	
	      if (this.props.location.query.quick) {
	        var win = window.open(this.getPDFUrl({
	          id: this.props.location.query.pass,
	          skip: this.props.location.query.skip,
	          directPdf: true
	        }), "eventive-quick-labels");
	        // Disabled: see intercom https://app.intercom.io/a/apps/oj5vkp3b/inbox/inbox/all/conversations/21510974050
	        // if (win) { win.print(); }
	        this.context.router.goBack();
	        return;
	      }
	
	      if (this.props.location.query.pass) {
	        var passes = this.props.location.query.pass;
	        if (!Array.isArray(passes)) {
	          passes = [passes];
	        }
	        passes.forEach(function (p) {
	          return _PassActions2.default.fetchOne(p);
	        });
	      }
	
	      _PassBucketActions2.default.fetchAllForEventBucket(this.props.params.eventBucketId);
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(newProps) {
	      var _this4 = this;
	
	      var bucket = _EventBucketStore2.default.getEventBucketById(newProps.params.eventBucketId),
	          passIds = newProps.location.query.pass && (Array.isArray(newProps.location.query.pass) ? newProps.location.query.pass : [newProps.location.query.pass]),
	          readyToInject = !!bucket && (!bucket.label_printer_config.selected_pass_buckets.length || Object.keys(newProps.passBuckets).length) && (!newProps.location.query.pass || passIds.every(function (id) {
	        return _PassStore2.default.getPassById(id);
	      }));
	
	      if (readyToInject && !this.state.hasInjectedSavedSettings) {
	        this.setState({
	          hasInjectedSavedSettings: true,
	          settings: bucket.label_printer_config
	        }, function () {
	          setTimeout(function () {
	            if (passIds) {
	              var selectedPasses = passIds.map(function (p) {
	                return _PassStore2.default.getPassById(p);
	              });
	              _this4.setState({
	                selectedPasses: selectedPasses,
	                skip: _this4.props.location.query.skip
	              });
	              var passBucketIds = (0, _uniq2.default)(selectedPasses.map(function (p) {
	                return p.pass_bucket.id;
	              }));
	              _this4.setPassBuckets(passBucketIds.map(function (id) {
	                return _PassBucketStore2.default.getPassBucketById(id);
	              }),
	              /* persist */false);
	            } else if (!_this4.state.selectedPassBuckets.length && !_this4.state.selectedMemberships.length) {
	              _this4.setPassBuckets(bucket.label_printer_config.selected_pass_buckets.map(function (id) {
	                return _PassBucketStore2.default.getPassBucketById(id);
	              }),
	              /* persist */false);
	            }
	          }, 0);
	        });
	      }
	    }
	  }, {
	    key: "getStyles",
	    value: function getStyles() {
	      return {
	        selectedPass: {
	          border: "1px solid #ccc",
	          padding: 10
	        },
	        h2: {
	          marginTop: "1em",
	          marginBottom: 0
	        },
	        passHeader: {
	          marginTop: "1em"
	        },
	        delete: {
	          textDecoration: "underline",
	          cursor: "pointer"
	        },
	        labelSizeInputsContainer: {
	          marginTop: -15
	        },
	        labelSizeTextfield: {
	          width: 24
	        },
	        labelSizeCross: {
	          margin: "0 5px"
	        },
	        labelSizeUnits: {
	          marginLeft: 5
	        },
	        anotherSizeNote: {
	          marginTop: 5,
	          fontSize: "0.9em",
	          fontStyle: "italic"
	        }
	      };
	    }
	  }, {
	    key: "_makeCustomLabelOption",
	    value: function _makeCustomLabelOption(value) {
	      // Unprefix if prefixed for display purposes
	      if (value.startsWith(CUSTOM_TEXT_PREFIX)) {
	        value = value.slice(CUSTOM_TEXT_PREFIX.length);
	      }
	
	      return {
	        label: "Custom text: \"" + value + "\"",
	        value: "" + CUSTOM_TEXT_PREFIX + value
	      };
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this5 = this;
	
	      var styles = this.getStyles();
	      var bucket = _EventBucketStore2.default.getEventBucketById(this.props.params.eventBucketId);
	      var allPassBuckets = this.state.isMembership ? _PassBucketStore2.default.getMembershipsForEventBucket(this.props.params.eventBucketId) : _PassBucketStore2.default.getPassBucketsForEventBucket(this.props.params.eventBucketId);
	      var items = this.state.isMembership ? this.state.selectedMemberships : this.state.selectedPassBuckets;
	      var showItems = items && items.length > 0;
	
	      if (!this.state.hasInjectedSavedSettings) {
	        return _react2.default.createElement(_workingIndicator2.default, { fullPage: true });
	      }
	
	      var singular = this.state.isMembership ? "membership" : "pass";
	      var plural = this.state.isMembership ? "memberships" : "passes";
	      var capitalize = function capitalize(str) {
	        return str.substring(0, 1).toLocaleUpperCase() + str.substring(1);
	      };
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          _materialUi.Dialog,
	          {
	            title: capitalize(singular) + " label printer",
	            actions: [_react2.default.createElement(_materialUi.FlatButton, {
	              label: this.state.completedPrint ? "Close" : "Cancel",
	              onTouchTap: this.closePrint
	            })],
	            autoDetectWindowHeight: false,
	            autoScrollBodyContent: false,
	            bodyStyle: { overflowY: "visible" },
	            open: this.state.printing || this.state.showPrintSuccess
	          },
	          _react2.default.createElement(
	            "div",
	            null,
	            this.state.printing ? _react2.default.createElement(
	              "div",
	              null,
	              _react2.default.createElement(_workingIndicator2.default, { centered: true }),
	              _react2.default.createElement(
	                "div",
	                { style: { marginTop: "1em", textAlign: "center" } },
	                "Your ",
	                plural,
	                " are being generated!",
	                _react2.default.createElement("br", null),
	                "They will automatically open as soon as they are ready for printing."
	              )
	            ) : this.state.completedPrint ? this.state.completedPrint.error ? _react2.default.createElement(
	              "div",
	              null,
	              _react2.default.createElement(
	                "div",
	                null,
	                "Unfortunately, we ran into an error printing your ",
	                plural,
	                ".",
	                _react2.default.createElement("br", null),
	                "Please try again, or contact us if the problem persists."
	              ),
	              _react2.default.createElement(
	                "div",
	                { style: { marginTop: "1em" } },
	                _react2.default.createElement(
	                  "i",
	                  null,
	                  "Error: ",
	                  _react2.default.createElement(
	                    "strong",
	                    null,
	                    this.state.completedPrint.error
	                  )
	                )
	              )
	            ) : _react2.default.createElement(
	              "div",
	              null,
	              "Your ",
	              plural,
	              " should have begun downloading. If they did not,",
	              " ",
	              _react2.default.createElement(
	                "a",
	                {
	                  target: "_blank",
	                  href: this.state.completedPrint.download_url
	                },
	                "click here to download"
	              ),
	              "."
	            ) : null
	          )
	        ),
	        _react2.default.createElement(
	          "h1",
	          null,
	          capitalize(singular),
	          " label printer"
	        ),
	        _react2.default.createElement(
	          _infoNotice2.default,
	          { style: { marginTop: 20 } },
	          "Check out our",
	          " ",
	          _react2.default.createElement(
	            "a",
	            {
	              href: "https://help.eventive.org/en/articles/914882-print-pass-and-membership-labels",
	              target: "_blank"
	            },
	            "guide to printing ",
	            singular,
	            " labels"
	          ),
	          "."
	        ),
	        _react2.default.createElement(
	          "p",
	          null,
	          "Use this wizard to print labels for your ",
	          plural,
	          ". The settings you choose here are automatically saved for future printings."
	        ),
	        this.state.selectedPasses ? _react2.default.createElement(
	          "div",
	          { style: styles.selectedPass },
	          _react2.default.createElement(
	            "div",
	            null,
	            "Selected ",
	            this.state.selectedPasses.length > 0 ? "" + plural : "" + singular,
	            _react2.default.createElement(
	              "strong",
	              null,
	              this.state.selectedPasses.map(function (p) {
	                return p.name;
	              }).join(", ")
	            )
	          ),
	          this.state.settings.label_type === "sheet" ? _react2.default.createElement(
	            "div",
	            null,
	            "Labels to skip:",
	            _react2.default.createElement(_quantityEditor2.default, {
	              style: { display: "inline-block" },
	              min: 0,
	              quantity: this.state.skip,
	              updateQuantity: function updateQuantity(q) {
	                return _this5.setState({ skip: q });
	              }
	            })
	          ) : null,
	          _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(
	              _linkLike2.default,
	              {
	                onTouchTap: function onTouchTap() {
	                  return _this5.setState({ selectedPasses: null });
	                }
	              },
	              "Reset"
	            )
	          )
	        ) : _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(_injectedSelect2.default, {
	              value: items.map(function (b) {
	                return b.id;
	              }),
	              types: this.state.isMembership ? ["memberships"] : ["pass_buckets"],
	              skipFetch: true,
	              label: (this.state.isMembership ? "Memberships" : "Pass buckets") + " to print",
	              multi: true,
	              labelFormatter: function labelFormatter(b) {
	                return b.name;
	              },
	              eventBucketId: this.props.params.eventBucketId,
	              changeValueFunction: function changeValueFunction(o) {
	                return o;
	              },
	              onChange: function onChange(selected) {
	                return _this5.setPassBuckets(selected);
	              }
	            })
	          ),
	          _react2.default.createElement(
	            "div",
	            { style: { marginTop: 8 } },
	            _react2.default.createElement(_materialUi.Checkbox, {
	              label: "Print all " + (this.state.isMembership ? "memberships" : "pass buckets"),
	              checked: items.length === allPassBuckets.length,
	              onCheck: function onCheck(e, checked) {
	                return _this5.setPassBuckets(checked ? allPassBuckets : []);
	              }
	            })
	          )
	        ),
	        showItems ? _react2.default.createElement(
	          "div",
	          null,
	          this.state.settings.label_type !== "sundance" ? _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(
	              "h2",
	              { style: styles.h2 },
	              this.state.isMembership ? "Membership" : "Pass bucket",
	              " setup"
	            ),
	            items.map(function (b) {
	              var config = _this5.state.passBucketConfiguration[b.id],
	                  allOptions = DEFAULT_FIELDS.concat((b.supplementary_data || []).map(function (d) {
	                return { value: d.key, label: d.label, type: d.type };
	              })),
	                  availableImages = allOptions.filter(function (o) {
	                return o.type === "image";
	              }),
	                  options = allOptions.filter(function (o) {
	                return o.type !== "image";
	              });
	
	              return _react2.default.createElement(
	                "div",
	                { key: b.id },
	                _react2.default.createElement(
	                  "h3",
	                  { style: styles.passHeader },
	                  "\"",
	                  b.name,
	                  "\" label configuration (",
	                  _react2.default.createElement(
	                    _linkLike2.default,
	                    {
	                      onTouchTap: function onTouchTap() {
	                        var shownConfigs = Object.assign(_this5.state.shownConfigs, _defineProperty({}, b.id, !_this5.state.shownConfigs[b.id]));
	                        _this5.setState({ shownConfigs: shownConfigs });
	                      }
	                    },
	                    _this5.state.shownConfigs[b.id] ? "hide" : "show"
	                  ),
	                  ")"
	                ),
	                _this5.state.shownConfigs[b.id] ? _react2.default.createElement(
	                  "div",
	                  null,
	                  config.rows.map(function (r, i) {
	                    var rowOptions = options.concat((r.fields || []).filter(function (f) {
	                      return f.startsWith(CUSTOM_TEXT_PREFIX);
	                    }).map(function (v) {
	                      return _this5._makeCustomLabelOption(v);
	                    }));
	
	                    return _react2.default.createElement(
	                      "div",
	                      null,
	                      _react2.default.createElement(
	                        _label2.default,
	                        null,
	                        "Row ",
	                        i + 1,
	                        " ",
	                        i !== 0 && _react2.default.createElement(
	                          "span",
	                          {
	                            style: styles.delete,
	                            onClick: function onClick() {
	                              config.rows.splice(i, 1);
	                              _this5.updateConfig(b.id, config);
	                            }
	                          },
	                          "[delete]"
	                        )
	                      ),
	                      _react2.default.createElement(_reactSelect.Creatable, {
	                        autosize: true,
	                        multi: true,
	                        placeholder: "Select fields to print, or type for custom text (If you select multiple fields, the first one that is not empty will be printed.)",
	                        promptTextCreator: function promptTextCreator(label) {
	                          return label;
	                        },
	                        newOptionCreator: function newOptionCreator(_ref) {
	                          var label = _ref.label;
	                          var labelKey = _ref.labelKey;
	                          var valueKey = _ref.valueKey;
	
	                          return _this5._makeCustomLabelOption(label);
	                        },
	                        value: r.fields || [],
	                        options: rowOptions,
	                        isOptionUnique: function isOptionUnique() {
	                          return true;
	                        },
	                        shouldKeyDownEventCreateNewOption: function shouldKeyDownEventCreateNewOption(_ref2) {
	                          var keyCode = _ref2.keyCode;
	
	                          switch (keyCode) {
	                            case 9: // TAB
	                            case 13:
	                              // ENTER
	                              return true;
	                          }
	                          return false;
	                        },
	                        onChange: function onChange(selected) {
	                          r.fields = selected.map(function (s) {
	                            return s.value;
	                          });
	                          _this5.updateConfig(b.id, config);
	                        }
	                      })
	                    );
	                  }),
	                  config.image ? _react2.default.createElement(_selectField2.default, {
	                    label: "Image to print",
	                    options: availableImages,
	                    placeholder: "Select an image field to print",
	                    value: config.image,
	                    onChange: function onChange(selected) {
	                      config.image = selected ? selected.value : null;
	                      _this5.updateConfig(b.id, config);
	                    }
	                  }) : null,
	                  _react2.default.createElement(
	                    "div",
	                    { style: { marginTop: "1em" } },
	                    _react2.default.createElement(_materialUi.RaisedButton, {
	                      label: "Add row",
	                      onClick: function onClick() {
	                        config.rows.push({});
	                        _this5.updateConfig(b.id, config);
	                      }
	                    }),
	                    !config.image && availableImages.length ? _react2.default.createElement(_materialUi.RaisedButton, {
	                      style: { marginLeft: 7 },
	                      label: "Add image",
	                      onClick: function onClick() {
	                        config.image = availableImages[0].value;
	                        _this5.updateConfig(b.id, config);
	                      }
	                    }) : null
	                  )
	                ) : null
	              );
	            })
	          ) : null,
	          _react2.default.createElement(
	            "h2",
	            { style: styles.h2 },
	            "Label setup"
	          ),
	          _react2.default.createElement(
	            _label2.default,
	            null,
	            "Label type"
	          ),
	          _react2.default.createElement(
	            _materialUi.RadioButtonGroup,
	            {
	              name: "label_type",
	              valueSelected: this.state.settings.label_type,
	              style: { maxWidth: 500 },
	              onChange: function onChange(e, v) {
	                return _this5.updateSetting("label_type", v);
	              }
	            },
	            _react2.default.createElement(_materialUi.RadioButton, {
	              value: "individual",
	              label: _react2.default.createElement(
	                "span",
	                null,
	                _react2.default.createElement(
	                  "strong",
	                  null,
	                  "Individual"
	                ),
	                ": For use with a dedicated label printer."
	              )
	            }),
	            _react2.default.createElement(_materialUi.RadioButton, {
	              value: "sheet",
	              label: _react2.default.createElement(
	                "span",
	                null,
	                _react2.default.createElement(
	                  "strong",
	                  null,
	                  "Sheet"
	                ),
	                ": For printing via a standard printer."
	              )
	            }),
	            _react2.default.createElement(_materialUi.RadioButton, {
	              value: "individual_padded",
	              label: _react2.default.createElement(
	                "span",
	                null,
	                _react2.default.createElement(
	                  "strong",
	                  null,
	                  "Individual padded"
	                ),
	                ": For printing via any printer, with labels taking up only some of the page (e.g. to print labels on pre-printed ",
	                plural,
	                ")."
	              )
	            }),
	            _react2.default.createElement(_materialUi.RadioButton, {
	              value: "sundance",
	              label: _react2.default.createElement(
	                "span",
	                null,
	                _react2.default.createElement(
	                  "strong",
	                  null,
	                  "Sundance"
	                ),
	                ": For printing the full page Sundance label on a standard 8.5\" x 11\" page in landscape format."
	              ),
	              style: {
	                display: bucket.frontend_config.sundance_login ? "block" : "none"
	              }
	            })
	          ),
	          this.state.settings.label_type === "individual_padded" ? _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(
	              _label2.default,
	              null,
	              "Page size"
	            ),
	            _react2.default.createElement(
	              "div",
	              { style: styles.labelSizeInputsContainer },
	              _react2.default.createElement(_materialUi.TextField, {
	                style: styles.labelSizeTextfield,
	                name: "width",
	                placeholder: "W",
	                onChange: function onChange(e) {
	                  return _this5.updateSetting("individual_page_width", e.target.value);
	                },
	                value: this.state.settings.individual_page_width
	              }),
	              _react2.default.createElement(
	                "span",
	                { style: styles.labelSizeCross },
	                "\xD7"
	              ),
	              _react2.default.createElement(_materialUi.TextField, {
	                style: styles.labelSizeTextfield,
	                name: "height",
	                placeholder: "H",
	                onChange: function onChange(e) {
	                  return _this5.updateSetting("individual_page_height", e.target.value);
	                },
	                value: this.state.settings.individual_page_height
	              }),
	              _react2.default.createElement(
	                "span",
	                { style: styles.labelSizeUnits },
	                "inches"
	              )
	            ),
	            _react2.default.createElement(
	              _label2.default,
	              null,
	              "Page margin"
	            ),
	            _react2.default.createElement(
	              "div",
	              { style: styles.labelSizeInputsContainer },
	              _react2.default.createElement(
	                "span",
	                { style: { marginRight: 5 } },
	                "Top"
	              ),
	              _react2.default.createElement(_materialUi.TextField, {
	                style: styles.labelSizeTextfield,
	                name: "width",
	                placeholder: "T",
	                onChange: function onChange(e) {
	                  return _this5.updateSetting("individual_top_margin", e.target.value);
	                },
	                value: this.state.settings.individual_top_margin
	              }),
	              _react2.default.createElement(
	                "span",
	                { style: styles.labelSizeCross },
	                "\xD7 Left"
	              ),
	              _react2.default.createElement(_materialUi.TextField, {
	                style: styles.labelSizeTextfield,
	                name: "height",
	                placeholder: "L",
	                onChange: function onChange(e) {
	                  return _this5.updateSetting("individual_left_margin", e.target.value);
	                },
	                value: this.state.settings.individual_left_margin
	              }),
	              _react2.default.createElement(
	                "span",
	                { style: styles.labelSizeUnits },
	                "inches"
	              )
	            )
	          ) : null,
	          this.state.settings.label_type === "individual" || this.state.settings.label_type === "individual_padded" ? _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(
	              _label2.default,
	              null,
	              "Label size"
	            ),
	            _react2.default.createElement(
	              "div",
	              { style: styles.labelSizeInputsContainer },
	              _react2.default.createElement(_materialUi.TextField, {
	                style: styles.labelSizeTextfield,
	                name: "width",
	                placeholder: "W",
	                onChange: function onChange(e) {
	                  return _this5.updateSetting("individual_label_width", e.target.value);
	                },
	                value: this.state.settings.individual_label_width
	              }),
	              _react2.default.createElement(
	                "span",
	                { style: styles.labelSizeCross },
	                "\xD7"
	              ),
	              _react2.default.createElement(_materialUi.TextField, {
	                style: styles.labelSizeTextfield,
	                name: "height",
	                placeholder: "H",
	                onChange: function onChange(e) {
	                  return _this5.updateSetting("individual_label_height", e.target.value);
	                },
	                value: this.state.settings.individual_label_height
	              }),
	              _react2.default.createElement(
	                "span",
	                { style: styles.labelSizeUnits },
	                "inches"
	              )
	            )
	          ) : null,
	          this.state.settings.label_type === "sheet" ? _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(
	              _label2.default,
	              null,
	              "Sheet format"
	            ),
	            _react2.default.createElement(
	              _materialUi.RadioButtonGroup,
	              {
	                name: "sheet_label_format",
	                valueSelected: this.state.settings.sheet_label_format,
	                onChange: function onChange(e, v) {
	                  return _this5.updateSetting("sheet_label_format", v);
	                }
	              },
	              _react2.default.createElement(_materialUi.RadioButton, { value: "avery5160", label: "Avery 5160/5260: 1\" x 2-5/8\" (30 per sheet)" }),
	              _react2.default.createElement(_materialUi.RadioButton, { value: "avery5360", label: "Avery 5360: 1-1/2\" x 2-13/16\" (21 per sheet)" }),
	              _react2.default.createElement(_materialUi.RadioButton, { value: "avery5390", label: "Avery 5390: 2-1/4\" x 3-1/3\" (8 per sheet)" }),
	              _react2.default.createElement(_materialUi.RadioButton, { value: "avery5395", label: "Avery 5395: 2-1/3\" x 3-3/8\" (8 per sheet)" }),
	              _react2.default.createElement(_materialUi.RadioButton, { value: "avery5161", label: "Avery 5161: 1\" x 4\" (20 per sheet)" }),
	              _react2.default.createElement(_materialUi.RadioButton, { value: "avery5162", label: "Avery 5162: 1-1/3\" x 4\" (14 per sheet)" }),
	              _react2.default.createElement(_materialUi.RadioButton, { value: "avery5163", label: "Avery 5163: 2\" x 4\" (10 per sheet)" }),
	              _react2.default.createElement(_materialUi.RadioButton, { value: "averyL7120", label: "Avery L7120-25: 35mm x 35mm (35 per sheet)" }),
	              _react2.default.createElement(_materialUi.RadioButton, { value: "avery94220", label: "Avery 94220: 1\" x 2\" (24 per sheet)" })
	            ),
	            _react2.default.createElement(
	              "div",
	              { style: styles.anotherSizeNote },
	              "Looking for another size?",
	              " ",
	              _react2.default.createElement(
	                _linkLike2.default,
	                {
	                  onTouchTap: function onTouchTap() {
	                    return Intercom("showNewMessage", "New requested label format: ");
	                  }
	                },
	                "Just ask!"
	              )
	            )
	          ) : null,
	          !this.state.selectedPasses ? _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(
	              _label2.default,
	              null,
	              "Sorting"
	            ),
	            this.state.settings.label_type !== "sundance" ? _react2.default.createElement(_materialUi.Checkbox, {
	              label: "Sort labels by second row on label (e.g. to group by supplementary data)",
	              checked: this.state.settings.sort_by_row_2,
	              onCheck: function onCheck(e, checked) {
	                return _this5.updateSetting("sort_by_row_2", checked);
	              }
	            }) : null,
	            _react2.default.createElement(_materialUi.Checkbox, {
	              label: this.state.settings.sort_by_row_2 ? "After sorting by second row, sort labels by last name" : "Sort labels by last name",
	              checked: this.state.settings.sort_by_last_name,
	              onCheck: function onCheck(e, checked) {
	                return _this5.updateSetting("sort_by_last_name", checked);
	              }
	            })
	          ) : null,
	          this.state.settings.label_type !== "sundance" ? _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(
	              _label2.default,
	              null,
	              "Additional options"
	            ),
	            this.state.settings.label_type !== "sheet" ? _react2.default.createElement(_materialUi.Checkbox, {
	              label: _react2.default.createElement(
	                "span",
	                null,
	                "Duplex printing (i.e. print two copies of each ",
	                singular,
	                ", for front & back printing)"
	              ),
	              checked: this.state.settings.duplex,
	              onCheck: function onCheck(e, checked) {
	                return _this5.updateSetting("duplex", checked);
	              }
	            }) : null,
	            _react2.default.createElement(_materialUi.Checkbox, {
	              label: _react2.default.createElement(
	                "span",
	                null,
	                _react2.default.createElement(
	                  "em",
	                  null,
	                  "Not recommended:"
	                ),
	                " Hide QR code on printed ",
	                singular,
	                " (scanning will no longer be possible!)"
	              ),
	              checked: this.state.settings.omit_qr_code,
	              onCheck: function onCheck(e, checked) {
	                return _this5.updateSetting("omit_qr_code", checked);
	              }
	            }),
	            Object.entries(this.state.passBucketConfiguration).some(function (_ref3) {
	              var _ref4 = _slicedToArray(_ref3, 2);
	
	              var k = _ref4[0];
	              var c = _ref4[1];
	              return items.some(function (b) {
	                return b.id === k;
	              }) !== -1 && c.image;
	            }) ? _react2.default.createElement(
	              "div",
	              null,
	              _react2.default.createElement(_materialUi.Checkbox, {
	                label: _react2.default.createElement(
	                  "span",
	                  null,
	                  "Filter by image: only print ",
	                  plural,
	                  " that have an image specified"
	                ),
	                checked: this.state.settings.filter_by_image,
	                onCheck: function onCheck(e, checked) {
	                  return _this5.updateSetting("filter_by_image", checked);
	                }
	              }),
	              _react2.default.createElement(_materialUi.Checkbox, {
	                label: _react2.default.createElement(
	                  "span",
	                  null,
	                  "Place image next to QR code beneath main text"
	                ),
	                checked: this.state.settings.image_qr_code_alt_display,
	                onCheck: function onCheck(e, checked) {
	                  return _this5.updateSetting("image_qr_code_alt_display", checked);
	                }
	              })
	            ) : null,
	            _react2.default.createElement(_materialUi.Checkbox, {
	              label: _react2.default.createElement(
	                "span",
	                null,
	                "Use a custom font for label text"
	              ),
	              checked: this.state.customFont || this.state.settings.font_family !== "Open Sans",
	              onCheck: function onCheck(e, checked) {
	                return checked ? _this5.setState({ customFont: true }) : _this5.setState({ customFont: false }, function () {
	                  return _this5.updateSetting("font_family", "Open Sans");
	                });
	              }
	            }),
	            this.state.customFont || this.state.settings.font_family !== "Open Sans" ? _react2.default.createElement(
	              "div",
	              { style: { marginLeft: "3em", marginTop: 3 } },
	              _react2.default.createElement(
	                _materialUi.RadioButtonGroup,
	                {
	                  name: "font_famly",
	                  valueSelected: this.state.settings.font_family,
	                  onChange: function onChange(e, v) {
	                    return _this5.updateSetting("font_family", v);
	                  }
	                },
	                _react2.default.createElement(_materialUi.RadioButton, {
	                  value: "Open Sans",
	                  label: "Open Sans (default)"
	                }),
	                _react2.default.createElement(_materialUi.RadioButton, {
	                  value: "Gotham Narrow",
	                  label: "Gotham Narrow"
	                }),
	                _react2.default.createElement(_materialUi.RadioButton, {
	                  value: "Trixie-Plain",
	                  label: "Trixie Plain"
	                }),
	                _react2.default.createElement(_materialUi.RadioButton, {
	                  value: "Armin Grotesk",
	                  label: "Armin Grotesk"
	                }),
	                _react2.default.createElement(_materialUi.RadioButton, { value: "borneo", label: "Borneo" })
	              ),
	              _react2.default.createElement(
	                "div",
	                {
	                  style: Object.assign({}, styles.anotherSizeNote, {
	                    marginBottom: 5
	                  })
	                },
	                "Looking for a different custom font?",
	                " ",
	                _react2.default.createElement(
	                  _linkLike2.default,
	                  {
	                    onTouchTap: function onTouchTap() {
	                      return Intercom("showNewMessage", "Requested custom label font: ");
	                    }
	                  },
	                  "Let us know!"
	                )
	              )
	            ) : null,
	            this.state.settings.label_type !== "sheet" ? _react2.default.createElement(
	              "div",
	              null,
	              _react2.default.createElement(_materialUi.Checkbox, {
	                label: _react2.default.createElement(
	                  "span",
	                  null,
	                  "Adjust label text size"
	                ),
	                checked: this.state.customFontSize || this.state.settings.font_scale_factor !== 1,
	                onCheck: function onCheck(e, checked) {
	                  return checked ? _this5.setState({ customFontSize: true }) : _this5.setState({ customFontSize: false }, function () {
	                    return _this5.updateSetting("font_scale_factor", 1);
	                  });
	                }
	              }),
	              this.state.customFontSize || this.state.settings.font_scale_factor !== 1 ? _react2.default.createElement(
	                "div",
	                { style: { marginLeft: "3em", marginTop: 3 } },
	                _react2.default.createElement(
	                  _materialUi.RadioButtonGroup,
	                  {
	                    name: "font_scale_factor",
	                    valueSelected: this.state.settings.font_scale_factor,
	                    onChange: function onChange(e, v) {
	                      return _this5.updateSetting("font_scale_factor", v);
	                    }
	                  },
	                  _react2.default.createElement(_materialUi.RadioButton, { value: 0.95, label: "Smaller" }),
	                  _react2.default.createElement(_materialUi.RadioButton, { value: 1, label: "Default" }),
	                  _react2.default.createElement(_materialUi.RadioButton, { value: 1.05, label: "Larger" }),
	                  _react2.default.createElement(_materialUi.RadioButton, { value: 1.1, label: "Even larger" })
	                )
	              ) : null
	            ) : null
	          ) : null,
	          !this.state.selectedPasses ? _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(
	              "h2",
	              { style: { margin: "0.75em 0 0.5em" } },
	              "Print range"
	            ),
	            _react2.default.createElement(
	              _materialUi.RadioButtonGroup,
	              {
	                name: "print_range",
	                valueSelected: this.state.printAllTime ? "all_time" : "interval",
	                onChange: function onChange(e, v) {
	                  return _this5.setState({ printAllTime: v === "all_time" });
	                }
	              },
	              _react2.default.createElement(_materialUi.RadioButton, {
	                value: "all_time",
	                label: _react2.default.createElement(
	                  "span",
	                  null,
	                  _react2.default.createElement(
	                    "strong",
	                    null,
	                    "All time"
	                  ),
	                  ": Print all ",
	                  plural,
	                  "."
	                )
	              }),
	              _react2.default.createElement(_materialUi.RadioButton, {
	                value: "interval",
	                label: _react2.default.createElement(
	                  "span",
	                  null,
	                  _react2.default.createElement(
	                    "strong",
	                    null,
	                    "Time interval"
	                  ),
	                  ": Print only ",
	                  plural,
	                  " updated within a specified interval."
	                )
	              })
	            ),
	            !this.state.printAllTime ? _react2.default.createElement(
	              "div",
	              null,
	              _react2.default.createElement(_datetimeField2.default, {
	                name: "startTime",
	                label: capitalize(plural) + " must have been updated after",
	                value: this.state.startTime,
	                onChange: function onChange(_, startTime) {
	                  return _this5.setState({ startTime: startTime });
	                }
	              }),
	              _react2.default.createElement(_datetimeField2.default, {
	                name: "endTime",
	                label: capitalize(plural) + " must have been updated before",
	                placeholder: "Right now",
	                value: this.state.endTime,
	                onChange: function onChange(_, endTime) {
	                  return _this5.setState({ endTime: endTime });
	                }
	              })
	            ) : null
	          ) : null,
	          _react2.default.createElement(_materialUi.RaisedButton, {
	            primary: true,
	            style: { marginTop: "1em" },
	            label: this.state.selectedPasses && this.state.selectedPasses.length === 1 ? "Print " + singular : "Print " + plural,
	            onTouchTap: this.print
	          })
	        ) : null
	      );
	    }
	  }], [{
	    key: "getStores",
	    value: function getStores() {
	      return [_PassBucketStore2.default, _PassStore2.default, _EventBucketStore2.default, _UserStore2.default];
	    }
	  }, {
	    key: "getPropsFromStores",
	    value: function getPropsFromStores() {
	      var state = _PassBucketStore2.default.getState();
	      state.apiKey = _UserStore2.default.getState().apiKey;
	      return state;
	    }
	  }, {
	    key: "contextTypes",
	    get: function get() {
	      return {
	        router: _react2.default.PropTypes.object
	      };
	    }
	  }]);
	
	  return PassLabelPrinter;
	}(_react2.default.Component);
	
	exports.default = (0, _connectToStores2.default)(PassLabelPrinter);
	module.exports = exports["default"];

/***/ }),
/* 2752 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDropzone = __webpack_require__(1780);
	
	var _reactDropzone2 = _interopRequireDefault(_reactDropzone);
	
	var _materialUi = __webpack_require__(576);
	
	var _reactable = __webpack_require__(1688);
	
	var _connectToStores = __webpack_require__(1226);
	
	var _connectToStores2 = _interopRequireDefault(_connectToStores);
	
	var _BulkImportActions = __webpack_require__(2688);
	
	var _BulkImportActions2 = _interopRequireDefault(_BulkImportActions);
	
	var _BulkImportStore = __webpack_require__(2689);
	
	var _BulkImportStore2 = _interopRequireDefault(_BulkImportStore);
	
	var _UserStore = __webpack_require__(974);
	
	var _UserStore2 = _interopRequireDefault(_UserStore);
	
	var _infoNotice = __webpack_require__(1599);
	
	var _infoNotice2 = _interopRequireDefault(_infoNotice);
	
	var _checkCircle = __webpack_require__(877);
	
	var _checkCircle2 = _interopRequireDefault(_checkCircle);
	
	var _error = __webpack_require__(948);
	
	var _error2 = _interopRequireDefault(_error);
	
	var _config = __webpack_require__(1173);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _injectedSelect = __webpack_require__(1874);
	
	var _injectedSelect2 = _interopRequireDefault(_injectedSelect);
	
	var _label = __webpack_require__(1682);
	
	var _label2 = _interopRequireDefault(_label);
	
	var _quillEditor = __webpack_require__(2169);
	
	var _quillEditor2 = _interopRequireDefault(_quillEditor);
	
	var _linkLike = __webpack_require__(973);
	
	var _linkLike2 = _interopRequireDefault(_linkLike);
	
	var _BulkImportUtil = __webpack_require__(2690);
	
	var _BulkImportUtil2 = _interopRequireDefault(_BulkImportUtil);
	
	var _util = __webpack_require__(1183);
	
	var _GlobalNotificationActions = __webpack_require__(1182);
	
	var _GlobalNotificationActions2 = _interopRequireDefault(_GlobalNotificationActions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BulkImportPasses = function (_React$Component) {
	  _inherits(BulkImportPasses, _React$Component);
	
	  function BulkImportPasses(props) {
	    _classCallCheck(this, BulkImportPasses);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(BulkImportPasses).call(this, props));
	
	    _this.state = {
	      selectedPassBucket: null,
	      extraMessage: "",
	      csvFile: null,
	      noEmail: false,
	      userReadyToImport: false,
	      currentImportStatus: {},
	      isMembership: null
	    };
	
	    _this.reset = _this.reset.bind(_this);
	    _this.onDrop = _this.onDrop.bind(_this);
	    _this.import = _this.import.bind(_this);
	    _this._makeImportMessage = _this._makeImportMessage.bind(_this);
	    _this.onErrorCsvClick = _this.onErrorCsvClick.bind(_this);
	    return _this;
	  }
	
	  _createClass(BulkImportPasses, [{
	    key: "getStyles",
	    value: function getStyles() {
	      return {
	        progressContainer: {
	          margin: "0 auto",
	          textAlign: "center",
	          padding: 10
	        },
	        restartLink: {
	          textDecoration: "underline",
	          cursor: "pointer",
	          paddingLeft: 2
	        },
	        icon: {
	          width: 80,
	          height: "auto",
	          color: "rgb(2, 136, 209)"
	        },
	        message: {
	          marginTop: 10
	        },
	        dropzone: {
	          lineHeight: "1.25",
	          padding: 10,
	          border: "1px dashed #ccc",
	          cursor: "pointer"
	        },
	        actions: {
	          marginTop: 10
	        },
	        previewExtraMessage: {
	          padding: 20,
	          border: "1px dashed #ccc"
	        },
	        section: {
	          marginTop: 20
	        }
	      };
	    }
	  }, {
	    key: "componentWillMount",
	    value: function componentWillMount() {
	      this.reset();
	    }
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var isMembership = this.props.location.pathname.includes("membership");
	      this.setState({ isMembership: isMembership });
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      clearInterval(this._statusChecker);
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(props) {
	      var _this2 = this;
	
	      if (props.importOrder && this.state.userReadyToImport && !this._statusChecker) {
	        // Start fetching order status
	        this._statusChecker = setInterval(function () {
	          fetch(_this2._makeFetchUrl(props.importOrder)).then(function (r) {
	            return r.json();
	          }).then(function (currentImportStatus) {
	            _this2.setState({ currentImportStatus: currentImportStatus });
	            if (currentImportStatus.finished) {
	              clearInterval(_this2._statusChecker);
	              _this2._statusChecker = null;
	            }
	          });
	        }, 2000);
	      }
	    }
	  }, {
	    key: "_makeFetchUrl",
	    value: function _makeFetchUrl(id) {
	      return _config2.default.endpoint + "bulk_import/passes/status?id=" + id + "&" + _UserStore2.default.makeApiKeyQueryString();
	    }
	  }, {
	    key: "_makeImportMessage",
	    value: function _makeImportMessage() {
	      var _state$currentImportS = this.state.currentImportStatus;
	      var completed = _state$currentImportS.completed;
	      var succeeded = _state$currentImportS.succeeded;
	      var failed = _state$currentImportS.failed;
	      var total = _state$currentImportS.total;
	      var error_message = _state$currentImportS.error_message;
	
	      var singular = this.state.isMembership ? "membership" : "pass";
	      var plural = this.state.isMembership ? "memberships" : "passes";
	
	      var errors = error_message ? error_message.split("; ") : [];
	
	      var nonCompleteText = _react2.default.createElement(
	        "text",
	        null,
	        "Warming up... getting ready to import..."
	      );
	
	      var completeElement = _react2.default.createElement(
	        "div",
	        { style: { display: "flex", flexDirection: "column", alignContent: "center", alignItems: "center" } },
	        _react2.default.createElement(
	          "text",
	          null,
	          (succeeded || 0) + " / " + (total || 0) + " " + (0, _util.formatBasedOnQuantity)(total || 0, singular, plural) + " imported " + (completed === total ? "successfully!" : "so far...")
	        ),
	        errors.length > 0 && _react2.default.createElement(
	          "text",
	          { style: { marginTop: 8 } },
	          "There were ",
	          failed,
	          " errors in this import:"
	        ),
	        errors.length > 0 && _react2.default.createElement(
	          "div",
	          { style: { display: "flex", flexDirection: "column", marginTop: 4, marginBottom: 8, textAlign: "left" } },
	          errors.map(function (error, index) {
	            return _react2.default.createElement(
	              "text",
	              null,
	              index + 1 + ".",
	              " ",
	              error
	            );
	          })
	        )
	      );
	
	      return !completed ? nonCompleteText : completeElement;
	    }
	  }, {
	    key: "onErrorCsvClick",
	    value: function () {
	      var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
	        var _userStore$getState, apiKey, previewData, csv, href, link;
	
	        return regeneratorRuntime.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                _userStore$getState = _UserStore2.default.getState();
	                apiKey = _userStore$getState.apiKey;
	                previewData = this.props.previewData;
	
	                //Since we're potentially passing a big object to make this CSV, let's pass it in the JSON body, which sadly means we can't just link them to the API call as usual
	
	                _context.next = 5;
	                return _BulkImportUtil2.default.fetchPassErrorsCsv(apiKey, previewData.errors_encountered, this.state.selectedPassBucket.id);
	
	              case 5:
	                csv = _context.sent;
	                href = "data:text/csv;charset=utf-8," + encodeURIComponent(csv);
	                link = document.createElement("a");
	
	                link.href = href;
	                link.download = this.state.isMembership ? "bulk-import-memberships-errors.csv" : "bulk-import-passes-errors.csv";
	                link.click();
	                link.remove();
	
	              case 12:
	              case "end":
	                return _context.stop();
	            }
	          }
	        }, _callee, this);
	      }));
	
	      function onErrorCsvClick() {
	        return _ref.apply(this, arguments);
	      }
	
	      return onErrorCsvClick;
	    }()
	  }, {
	    key: "reset",
	    value: function reset() {
	      this.setState({
	        csvFile: null,
	        userReadyToImport: false
	      });
	      _BulkImportActions2.default.reset.defer();
	    }
	  }, {
	    key: "onDrop",
	    value: function onDrop(files, rejected) {
	      if (rejected.length > 0) {
	        _GlobalNotificationActions2.default.notify("Only .xlsx, .xls, and .csv files are accepted");
	
	        return;
	      }
	
	      if (!files.length) {
	        return;
	      }
	      this.setState({
	        csvFile: files[0]
	      });
	    }
	  }, {
	    key: "import",
	    value: function _import() {
	      _BulkImportActions2.default.importPasses({
	        eventBucket: this.props.params.eventBucketId,
	        passBucket: this.state.selectedPassBucket.id,
	        extraMessage: this.state.extraMessage,
	        csvFile: this.state.csvFile,
	        preview: !this.state.userReadyToImport,
	        noEmail: this.state.noEmail,
	        isMembership: this.state.isMembership
	      });
	      window.scrollTo(0, 0);
	    }
	  }, {
	    key: "_makeCsvLink",
	    value: function _makeCsvLink() {
	      return _config2.default.endpoint + "bulk_import/example/passes";
	    }
	  }, {
	    key: "_makeCsvLinkForMemberships",
	    value: function _makeCsvLinkForMemberships() {
	      return _config2.default.endpoint + "bulk_import/example/memberships";
	    }
	  }, {
	    key: "_makeTable",
	    value: function _makeTable(passBucket, passes) {
	      var options = arguments.length <= 2 || arguments[2] === undefined ? {} : arguments[2];
	      var isErrorTable = options.isErrorTable;
	      var style = options.style;
	
	
	      var fieldColumns = passBucket.supplementary_data ? passBucket.supplementary_data.map(function (d) {
	        return { key: d.key, label: d.label };
	      }) : [];
	
	      var selectedColumns = !isErrorTable ? [{ key: "name", label: "Name" }, { key: "email", label: "Email" }].concat(passBucket.recurrence_enabled ? [{ key: "renewal_date", label: "Renewal date" }] : []).concat(fieldColumns) : [{ key: "row_number", label: "Row Number" }, { key: "email", label: "Email" }, { key: "error", label: "Error Message" }, { key: "name", label: "Name" }].concat(fieldColumns).concat(passBucket.recurrence_enabled ? [{ key: "renewal_date", label: "Renewal date" }] : []);
	
	      return _react2.default.createElement(_reactable.Table, {
	        className: "bordered striped responsive-table",
	        columns: selectedColumns,
	        data: passes.map(function (p) {
	          return Object.assign({}, p, p.supplementary_data);
	        }),
	        style: style
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this3 = this;
	
	      var _props = this.props;
	      var isImporting = _props.isImporting;
	      var importCompleted = _props.importCompleted;
	      var importSuccessful = _props.importSuccessful;
	      var importMessage = _props.importMessage;
	      var importOrder = _props.importOrder;
	      var previewData = _props.previewData;
	      var currentImportStatus = this.state.currentImportStatus;
	
	      var styles = this.getStyles();
	
	      // const isMembership = this.props.location.pathname.includes("membership");
	      var singular = this.state.isMembership ? "membership" : "pass";
	      var plural = this.state.isMembership ? "memberships" : "passes";
	
	      if (isImporting || importCompleted && !previewData) {
	        return _react2.default.createElement(
	          "div",
	          { style: styles.progressContainer },
	          isImporting || importOrder && !currentImportStatus.finished ? _react2.default.createElement(_materialUi.CircularProgress, { size: 1.5, mode: "indeterminate" }) : currentImportStatus.success ? _react2.default.createElement(_checkCircle2.default, { style: styles.icon }) : _react2.default.createElement(_error2.default, { style: styles.icon }),
	          _react2.default.createElement(
	            "div",
	            { style: styles.message },
	            isImporting ? _react2.default.createElement(
	              "div",
	              null,
	              this.state.userReadyToImport ? "Importing" : "Previewing",
	              " ",
	              plural,
	              "...",
	              _react2.default.createElement("br", null),
	              "This may take a little while."
	            ) : importMessage || this._makeImportMessage(),
	            "\xA0",
	            importOrder && currentImportStatus.success || importSuccessful ? _react2.default.createElement(
	              "a",
	              {
	                style: styles.restartLink,
	                onTouchTap: function onTouchTap() {
	                  return _this3.context.router.push("/orders" + (importOrder ? "/" + importOrder : ""));
	                }
	              },
	              "(view ",
	              importOrder ? "order" : "orders",
	              ")"
	            ) : null,
	            "\xA0",
	            !isImporting || currentImportStatus.finished ? _react2.default.createElement(
	              "a",
	              { style: styles.restartLink, onTouchTap: this.reset },
	              "(restart)"
	            ) : null
	          )
	        );
	      }
	
	      if (previewData && this.state.selectedPassBucket) {
	        return _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement(
	            "p",
	            null,
	            "We detected ",
	            previewData.passes.length,
	            " valid ",
	            (0, _util.formatBasedOnQuantity)(previewData.passes.length, singular, plural),
	            " in your uploaded data. Have a look:"
	          ),
	          this._makeTable(this.state.selectedPassBucket, previewData.passes),
	          _react2.default.createElement(
	            "p",
	            null,
	            "Unless you choose not to send them, each individual in the above list will receive an email that in addition to instructions about logging in also contains the following content:"
	          ),
	          _react2.default.createElement("div", {
	            className: "tenant-injected-html",
	            style: styles.previewExtraMessage,
	            dangerouslySetInnerHTML: {
	              __html: this.state.extraMessage || "<i>[No additional message will be attached]</i>"
	            }
	          }),
	          previewData.errors_encountered.length > 0 ? _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(
	              "p",
	              null,
	              "We also detected ",
	              previewData.errors_encountered.length,
	              " ",
	              (0, _util.formatBasedOnQuantity)(previewData.errors_encountered.length, "error", "errors"),
	              " in your uploaded data. You may continue with the import, but ",
	              (0, _util.formatBasedOnQuantity)(previewData.errors_encountered.length, "this item", "these items"),
	              " will be processed as ",
	              (0, _util.formatBasedOnQuantity)(previewData.errors_encountered.length, "an error", "errors"),
	              ":"
	            ),
	            this._makeTable(this.state.selectedPassBucket, previewData.errors_encountered.map(function (error) {
	              return _extends({ error: error.message }, error.originalData);
	            }), {
	              isErrorTable: true,
	              style: {
	                marginTop: 16
	              }
	            }),
	            _react2.default.createElement(_materialUi.FlatButton, {
	              label: "Download Error CSV",
	              style: { marginTop: 8, marginBottom: 16 },
	              onClick: this.onErrorCsvClick
	            })
	          ) : null,
	          _react2.default.createElement(
	            "p",
	            null,
	            "If everything looks all right, confirm & start the import. Otherwise,",
	            " ",
	            _react2.default.createElement(
	              _linkLike2.default,
	              { onTouchTap: this.reset },
	              "edit settings"
	            ),
	            "."
	          ),
	          _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(_materialUi.Checkbox, {
	              label: "Yes, I'm ready to import " + previewData.passes.length + " valid " + (0, _util.formatBasedOnQuantity)(previewData.passes.length, singular, plural) + " " + (previewData.will_email ? "& send associated emails" : "without sending any emails") + ".",
	              checked: this.state.userReadyToImport,
	              onCheck: function onCheck() {
	                return _this3.setState({
	                  userReadyToImport: !_this3.state.userReadyToImport
	                });
	              }
	            })
	          ),
	          _react2.default.createElement(
	            "div",
	            { style: styles.actions },
	            _react2.default.createElement(_materialUi.RaisedButton, {
	              label: "Start import",
	              primary: true,
	              disabled: !this.state.userReadyToImport,
	              onTouchTap: this.import
	            })
	          )
	        );
	      }
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          "h1",
	          null,
	          "Bulk import ",
	          plural
	        ),
	        _react2.default.createElement(
	          _infoNotice2.default,
	          { style: { marginTop: 20 } },
	          "Check out our",
	          " ",
	          _react2.default.createElement(
	            "a",
	            {
	              href: "" + (this.state.isMembership ? "https://help.eventive.org/en/articles/3116617-bulk-import-memberships-and-recurring-passes" : "https://help.eventive.org/passes/bulk-import-passes"),
	              target: "_blank"
	            },
	            "guide to importing ",
	            plural
	          ),
	          "."
	        ),
	        _react2.default.createElement(
	          "p",
	          null,
	          "Use this wizard to create ",
	          plural,
	          " in bulk. Just select a ",
	          singular,
	          " bucket, download the Excel template, fill in your data, and upload."
	        ),
	        _react2.default.createElement(
	          "p",
	          null,
	          "If a user already has an account, the ",
	          singular,
	          " will be added to their existing account. If not, a new account will be generated. In either case, every user will receive an email notifying them about their new",
	          singular,
	          "\u2014you can use the \"additional note\" field to explain why they're receiving it."
	        ),
	        _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement(_injectedSelect2.default, {
	            value: this.state.selectedPassBucket && this.state.selectedPassBucket.id,
	            types: this.state.isMembership ? ["memberships"] : ["pass_buckets"],
	            label: this.state.isMembership ? "Memberships" : "Pass bucket",
	            labelFormatter: function labelFormatter(b) {
	              return b.name;
	            },
	            eventBucketId: this.props.params.eventBucketId,
	            changeValueFunction: function changeValueFunction(o) {
	              return o;
	            },
	            onChange: function onChange(selected) {
	              return _this3.setState({ selectedPassBucket: selected });
	            }
	          })
	        ),
	        _react2.default.createElement(
	          "div",
	          { style: styles.section },
	          _react2.default.createElement(
	            _label2.default,
	            null,
	            "Add spreadsheet (",
	            _react2.default.createElement(
	              "a",
	              { target: "_blank", href: this.state.isMembership ? this._makeCsvLinkForMemberships() : this._makeCsvLink() },
	              "download template"
	            ),
	            ")"
	          ),
	          _react2.default.createElement(
	            _reactDropzone2.default,
	            {
	              style: styles.dropzone,
	              multiple: false,
	              onDrop: this.onDrop,
	              accept: ["text/csv", "application/vnd.ms-excel", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"]
	            },
	            function (_ref2) {
	              var isDragActive = _ref2.isDragActive;
	              var isDragReject = _ref2.isDragReject;
	              var acceptedFiles = _ref2.acceptedFiles;
	              var rejectedFiles = _ref2.rejectedFiles;
	
	              return isDragActive ? "Release to select." : acceptedFiles.length ? _react2.default.createElement(
	                "span",
	                null,
	                "One spreadsheet ",
	                _react2.default.createElement(
	                  "i",
	                  null,
	                  "(",
	                  acceptedFiles[0].name,
	                  ")"
	                ),
	                " ready to import."
	              ) : "Drop spreadsheet here, or click to select.";
	            }
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { style: styles.section },
	          _react2.default.createElement(
	            _label2.default,
	            null,
	            "Additional note (appended to notification email)"
	          ),
	          _react2.default.createElement(_quillEditor2.default, {
	            value: this.state.extraMessage,
	            onChange: function onChange(v) {
	              return _this3.setState({ extraMessage: v });
	            },
	            basic: true
	          })
	        ),
	        _react2.default.createElement(
	          "div",
	          { style: styles.section },
	          _react2.default.createElement(
	            _label2.default,
	            { style: { marginBottom: 0 } },
	            "Advanced options"
	          ),
	          _react2.default.createElement(
	            _linkLike2.default,
	            {
	              onTouchTap: function onTouchTap() {
	                return _this3.setState({ showAdvanced: !_this3.state.showAdvanced });
	              }
	            },
	            this.state.showAdvanced ? "Hide" : "Show",
	            " advanced options"
	          ),
	          this.state.showAdvanced ? _react2.default.createElement(
	            "div",
	            { style: { marginTop: 5 } },
	            _react2.default.createElement(_materialUi.Checkbox, {
	              label: _react2.default.createElement(
	                "span",
	                null,
	                "Do not send emails",
	                " ",
	                _react2.default.createElement(
	                  "strong",
	                  null,
	                  "(Danger: importees will be unable to access their ",
	                  plural,
	                  " online!)"
	                )
	              ),
	              checked: this.state.noEmail,
	              onCheck: function onCheck() {
	                return _this3.setState({ noEmail: !_this3.state.noEmail });
	              }
	            })
	          ) : null
	        ),
	        _react2.default.createElement(
	          "div",
	          { style: Object.assign({}, styles.actions, { marginTop: 20 }) },
	          _react2.default.createElement(_materialUi.RaisedButton, {
	            label: "Preview import...",
	            primary: true,
	            disabled: !(this.state.selectedPassBucket && this.state.csvFile),
	            onTouchTap: this.import
	          })
	        )
	      );
	    }
	  }], [{
	    key: "getStores",
	    value: function getStores() {
	      return [_BulkImportStore2.default, _UserStore2.default];
	    }
	  }, {
	    key: "getPropsFromStores",
	    value: function getPropsFromStores() {
	      return _BulkImportStore2.default.getState();
	    }
	  }, {
	    key: "contextTypes",
	    get: function get() {
	      return {
	        router: _react2.default.PropTypes.object
	      };
	    }
	  }]);
	
	  return BulkImportPasses;
	}(_react2.default.Component);
	
	exports.default = (0, _connectToStores2.default)(BulkImportPasses);
	module.exports = exports["default"];

/***/ }),
/* 2753 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(486);
	
	var _reactable = __webpack_require__(1688);
	
	var _materialUi = __webpack_require__(576);
	
	var _util = __webpack_require__(1183);
	
	var _qs = __webpack_require__(1206);
	
	var _qs2 = _interopRequireDefault(_qs);
	
	var _config = __webpack_require__(1173);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _connectToStores = __webpack_require__(1226);
	
	var _connectToStores2 = _interopRequireDefault(_connectToStores);
	
	var _PassBucketActions = __webpack_require__(1869);
	
	var _PassBucketActions2 = _interopRequireDefault(_PassBucketActions);
	
	var _PassBucketStore = __webpack_require__(1867);
	
	var _PassBucketStore2 = _interopRequireDefault(_PassBucketStore);
	
	var _UserStore = __webpack_require__(974);
	
	var _UserStore2 = _interopRequireDefault(_UserStore);
	
	var _downloadPassBucketCsvButton = __webpack_require__(2742);
	
	var _downloadPassBucketCsvButton2 = _interopRequireDefault(_downloadPassBucketCsvButton);
	
	var _workingIndicator = __webpack_require__(1664);
	
	var _workingIndicator2 = _interopRequireDefault(_workingIndicator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PassBuckets = function (_React$Component) {
	  _inherits(PassBuckets, _React$Component);
	
	  function PassBuckets(props) {
	    _classCallCheck(this, PassBuckets);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(PassBuckets).call(this, props));
	
	    _this._makeRowForPassBucket = _this._makeRowForPassBucket.bind(_this);
	    return _this;
	  }
	
	  _createClass(PassBuckets, [{
	    key: "getStyles",
	    value: function getStyles() {
	      return {};
	    }
	  }, {
	    key: "_makeRowForPassBucket",
	    value: function _makeRowForPassBucket(passBucket) {
	      var isMembershipRoute = this.props.location.pathname.includes('membership');
	      var currentRoute = isMembershipRoute ? "memberships" : "pass_buckets";
	
	      return _react2.default.createElement(
	        _reactable.Tr,
	        { key: passBucket.id },
	        _react2.default.createElement(
	          _reactable.Td,
	          { column: "Name", value: passBucket.name },
	          passBucket.name
	        ),
	        _react2.default.createElement(
	          _reactable.Td,
	          { column: "Code", value: passBucket.code },
	          passBucket.code
	        ),
	        _react2.default.createElement(
	          _reactable.Td,
	          { column: "Price", value: passBucket.price },
	          (0, _util.formatPrice)(passBucket.price || 0)
	        ),
	        _react2.default.createElement(
	          _reactable.Td,
	          { column: isMembershipRoute ? "Memberships Issued" : "Passes Issued", value: passBucket.price },
	          passBucket.unlimited ? passBucket.quantity_sold + "/\u221E" : passBucket.quantity_sold + "/" + passBucket.quantity
	        ),
	        _UserStore2.default.hasPermission("view_pass_bucket") || _UserStore2.default.hasPermission("edit_pass_bucket") ? _react2.default.createElement(
	          _reactable.Td,
	          { column: "Actions" },
	          _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(
	              _reactRouter.Link,
	              {
	                to: {
	                  pathname: "/event_buckets/" + this.props.params.eventBucketId + "/" + currentRoute + "/" + passBucket.id,
	                  state: { fromListing: true }
	                }
	              },
	              _UserStore2.default.hasPermission("edit_pass_bucket") ? "View" : "View Uses"
	            ),
	            "\xA0",
	            _UserStore2.default.hasPermission("edit_pass_bucket") || _UserStore2.default.hasPermission("view_pass_bucket_rules") ? _react2.default.createElement(
	              _reactRouter.Link,
	              {
	                to: {
	                  pathname: _UserStore2.default.hasPermission("edit_pass_bucket") ? "/event_buckets/" + this.props.params.eventBucketId + "/" + currentRoute + "/" + passBucket.id + "/edit" : "/event_buckets/" + this.props.params.eventBucketId + "/" + currentRoute + "/" + passBucket.id + "/edit/pass_rules",
	                  state: { fromListing: true }
	                }
	              },
	              _UserStore2.default.hasPermission("edit_pass_bucket") ? "Edit" : "View Rules"
	            ) : null
	          )
	        ) : null
	      );
	    }
	  }, {
	    key: "componentWillMount",
	    value: function componentWillMount() {
	      _PassBucketActions2.default.fetchAllForEventBucket(this.props.params.eventBucketId);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var isMembershipRoute = this.props.location.pathname.includes('membership');
	
	      var styles = this.getStyles(),
	          passBuckets = isMembershipRoute ? this.props.getMembershipsForEventBucket(this.props.params.eventBucketId) : this.props.getPassBucketsForEventBucket(this.props.params.eventBucketId),
	          rows = passBuckets.map(this._makeRowForPassBucket);
	
	      if (passBuckets.length === 0 && _PassBucketStore2.default.getState().isFetching) {
	        return _react2.default.createElement(_workingIndicator2.default, { fullPage: true });
	      }
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          "h1",
	          { className: "page-title" },
	          isMembershipRoute ? "Memberships" : "Pass Buckets"
	        ),
	        _react2.default.createElement(
	          _reactable.Table,
	          {
	            className: "bordered striped responsive-table",
	            sortable: [{ column: "Name", sortFunction: _reactable.Sort.CaseInsensitive }, "Code", "Price"],
	            defaultSort: { column: "Name", direction: "asc" },
	            columns: ["Name", "Code", "Price", isMembershipRoute ? "Memberships Issued" : "Passes Issued"].concat(_UserStore2.default.hasPermission("view_pass_bucket") || _UserStore2.default.hasPermission("edit_pass_bucket") ? ["Actions"] : []),
	            filterable: ["Name", "Code"],
	            filterPlaceholder: "Type to filter..."
	          },
	          rows
	        ),
	        rows.length === 0 && _UserStore2.default.hasPermission("edit_pass_bucket") ? _react2.default.createElement(
	          "div",
	          { className: "empty-table-message" },
	          "No pass buckets yet.",
	          " ",
	          _react2.default.createElement(
	            _reactRouter.Link,
	            {
	              to: "/event_buckets/" + this.props.params.eventBucketId + "/pass_buckets/new"
	            },
	            isMembershipRoute ? "Create a new membership." : "Create a new pass bucket."
	          )
	        ) : null,
	        _UserStore2.default.hasPermission("edit_pass_bucket") ? _react2.default.createElement(
	          "div",
	          { style: { marginTop: 20 } },
	          _react2.default.createElement(_materialUi.RaisedButton, {
	            label: isMembershipRoute ? "Create a new membership" : "Create new pass bucket",
	            primary: true,
	            onTouchTap: function onTouchTap() {
	              return _this2.context.router.push("/event_buckets/" + _this2.props.params.eventBucketId + "/" + (isMembershipRoute ? "memberships" : "pass_buckets") + "/new");
	            }
	          }),
	          _react2.default.createElement(_downloadPassBucketCsvButton2.default, {
	            style: { marginLeft: 7, verticalAlign: "top" },
	            label: isMembershipRoute ? "Download all memberships" : "Download all passes (.csv)",
	            eventBucketId: this.props.params.eventBucketId,
	            downloadType: isMembershipRoute ? "memberships" : "passes"
	          })
	        ) : null
	      );
	    }
	  }], [{
	    key: "getStores",
	    value: function getStores() {
	      return [_PassBucketStore2.default, _UserStore2.default];
	    }
	  }, {
	    key: "getPropsFromStores",
	    value: function getPropsFromStores() {
	      return {
	        getPassBucketsForEventBucket: _PassBucketStore2.default.getPassBucketsForEventBucket,
	        getMembershipsForEventBucket: _PassBucketStore2.default.getMembershipsForEventBucket,
	        isFetching: _PassBucketStore2.default.getState().isFetching,
	        apiKey: _UserStore2.default.getState().apiKey
	      };
	    }
	  }, {
	    key: "contextTypes",
	    get: function get() {
	      return {
	        router: _react2.default.PropTypes.object
	      };
	    }
	  }]);
	
	  return PassBuckets;
	}(_react2.default.Component);
	
	exports.default = (0, _connectToStores2.default)(PassBuckets);
	module.exports = exports["default"];

/***/ }),
/* 2754 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _config = __webpack_require__(1173);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _materialUi = __webpack_require__(576);
	
	var _qs = __webpack_require__(1206);
	
	var _qs2 = _interopRequireDefault(_qs);
	
	var _itemTable = __webpack_require__(2755);
	
	var _itemTable2 = _interopRequireDefault(_itemTable);
	
	var _backButton = __webpack_require__(1872);
	
	var _backButton2 = _interopRequireDefault(_backButton);
	
	var _connectToStores = __webpack_require__(1226);
	
	var _connectToStores2 = _interopRequireDefault(_connectToStores);
	
	var _ItemBucketActions = __webpack_require__(2044);
	
	var _ItemBucketActions2 = _interopRequireDefault(_ItemBucketActions);
	
	var _ItemBucketStore = __webpack_require__(2045);
	
	var _ItemBucketStore2 = _interopRequireDefault(_ItemBucketStore);
	
	var _ItemActions = __webpack_require__(2756);
	
	var _ItemActions2 = _interopRequireDefault(_ItemActions);
	
	var _ItemStore = __webpack_require__(2757);
	
	var _ItemStore2 = _interopRequireDefault(_ItemStore);
	
	var _UserStore = __webpack_require__(974);
	
	var _UserStore2 = _interopRequireDefault(_UserStore);
	
	var _EventBucketStore = __webpack_require__(1593);
	
	var _EventBucketStore2 = _interopRequireDefault(_EventBucketStore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ItemBucket = function (_React$Component) {
	  _inherits(ItemBucket, _React$Component);
	
	  function ItemBucket(props) {
	    _classCallCheck(this, ItemBucket);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(ItemBucket).call(this, props));
	
	    _this.state = {
	      isFetchingItemBucket: false,
	      fetchedItemBucket: null
	    };
	
	    _this._makeCsvLink = _this._makeCsvLink.bind(_this);
	    return _this;
	  }
	
	  _createClass(ItemBucket, [{
	    key: "_makeCsvLink",
	    value: function _makeCsvLink() {
	      var query = {
	        god_become_user: _UserStore2.default.isGod() ? _UserStore2.default.getGodCredentials().activeUser : undefined,
	        api_key: this.props.apiKey
	      };
	
	      return _config2.default.endpoint + "item_buckets/" + this.props.params.itemBucketId + "/items.csv?" + _qs2.default.stringify(query);
	    }
	  }, {
	    key: "getStyles",
	    value: function getStyles() {
	      return {};
	    }
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.componentWillReceiveProps(this.props);
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(newProps) {
	      var itemBucket = newProps.getItemBucketById(newProps.params.itemBucketId);
	
	      if (!this.state.isFetchingItemBucket && this.state.fetchedItemBucket !== newProps.params.itemBucketId) {
	        _ItemBucketActions2.default.fetchOne(newProps.params.itemBucketId);
	        _ItemActions2.default.fetchAllForItemBucket(newProps.params.itemBucketId);
	        this.setState({ isFetchingItemBucket: true });
	      } else if (itemBucket) {
	        this.setState({
	          isFetchingItemBucket: false,
	          fetchedItemBucket: itemBucket.id
	        });
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var styles = this.getStyles(),
	          itemBucket = this.props.getItemBucketById(this.props.params.itemBucketId),
	          items = this.props.getItemsForItemBucket(this.props.params.itemBucketId);
	
	      if (!itemBucket) {
	        return null;
	      }
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          "h1",
	          null,
	          itemBucket.name
	        ),
	        _react2.default.createElement(
	          "div",
	          { style: { margin: "10px 0 20px" } },
	          _react2.default.createElement(_backButton2.default, {
	            label: "item buckets",
	            style: { marginRight: 7 },
	            arrowStyle: {
	              display: "inline-block",
	              transform: "scale(1.25) translateY(-1px)"
	            },
	            onTouchTap: function onTouchTap() {
	              return _this2.props.location.state && _this2.props.location.state.fromListing ? _this2.context.router.goBack() : _this2.context.router.push("/event_buckets/" + _this2.props.params.eventBucketId + "/item_buckets");
	            }
	          }),
	          _react2.default.createElement(_materialUi.RaisedButton, {
	            style: { marginRight: 7 },
	            label: "Settings",
	            onTouchTap: function onTouchTap() {
	              return _this2.context.router.push("/event_buckets/" + _this2.props.params.eventBucketId + "/item_buckets/" + _this2.props.params.itemBucketId + "/edit");
	            }
	          }),
	          _react2.default.createElement(_materialUi.RaisedButton, {
	            style: { verticalAlign: "top" },
	            href: this._makeCsvLink(),
	            target: "_blank",
	            label: "Download (.csv)"
	          })
	        ),
	        _react2.default.createElement(_itemTable2.default, {
	          items: items,
	          eventBucket: this.props.params.eventBucketId,
	          hideItemBucket: true,
	          showPerson: true,
	          location: this.props.location
	        })
	      );
	    }
	  }], [{
	    key: "getStores",
	    value: function getStores() {
	      return [_ItemBucketStore2.default, _ItemStore2.default, _UserStore2.default];
	    }
	  }, {
	    key: "getPropsFromStores",
	    value: function getPropsFromStores() {
	      return {
	        getItemBucketById: _ItemBucketStore2.default.getItemBucketById,
	        getItemsForItemBucket: _ItemStore2.default.getItemsForItemBucket,
	        apiKey: _UserStore2.default.getState().apiKey,
	        getEventBucketById: _EventBucketStore2.default.getEventBucketById
	      };
	    }
	  }, {
	    key: "contextTypes",
	    get: function get() {
	      return {
	        router: _react2.default.PropTypes.object
	      };
	    }
	  }]);
	
	  return ItemBucket;
	}(_react2.default.Component);
	
	exports.default = (0, _connectToStores2.default)(ItemBucket);
	module.exports = exports["default"];

/***/ }),
/* 2755 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _moment = __webpack_require__(1021);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _reactRouter = __webpack_require__(486);
	
	var _reactable = __webpack_require__(1688);
	
	var _materialUi = __webpack_require__(576);
	
	var _statsBlock = __webpack_require__(1741);
	
	var _statsBlock2 = _interopRequireDefault(_statsBlock);
	
	var _tableRefreshIndicator = __webpack_require__(1686);
	
	var _tableRefreshIndicator2 = _interopRequireDefault(_tableRefreshIndicator);
	
	var _inlineLinkIconButton = __webpack_require__(1704);
	
	var _inlineLinkIconButton2 = _interopRequireDefault(_inlineLinkIconButton);
	
	var _UserStore = __webpack_require__(974);
	
	var _UserStore2 = _interopRequireDefault(_UserStore);
	
	var _ItemActions = __webpack_require__(2756);
	
	var _ItemActions2 = _interopRequireDefault(_ItemActions);
	
	var _OrderActions = __webpack_require__(1220);
	
	var _OrderActions2 = _interopRequireDefault(_OrderActions);
	
	var _util = __webpack_require__(1183);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PAGE_SIZE = 20;
	
	var DELETED_ROW_STYLE = { textDecoration: "line-through", color: "#ccc" };
	var HIGHLIGHTED_ROW_STYLE = {
	  backgroundColor: "#fff176",
	  boxShadow: "1px 1px 10px rgba(0,0,0,0.2)"
	};
	
	var ItemTable = function (_React$Component) {
	  _inherits(ItemTable, _React$Component);
	
	  function ItemTable(props) {
	    _classCallCheck(this, ItemTable);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(ItemTable).call(this, props));
	
	    _this.state = {
	      deletedItems: {},
	      highlightedRow: null,
	      currentPage: 0
	    };
	
	    _this._makeRowForItem = _this._makeRowForItem.bind(_this);
	    _this._refresh = _this._refresh.bind(_this);
	    _this._viewDonationReceipt = _this._viewDonationReceipt.bind(_this);
	    return _this;
	  }
	
	  _createClass(ItemTable, [{
	    key: "_delete",
	    value: function _delete(id, e) {
	      e.preventDefault();
	      e.stopPropagation();
	
	      if (window.confirm("Are you sure you want to delete item #" + id + "? There is no going back.")) {
	        _ItemActions2.default.delete(id);
	        this.state.deletedItems[id] = true;
	        this.setState(this.state);
	      }
	    }
	  }, {
	    key: "_refresh",
	    value: function _refresh(e) {
	      e.preventDefault();
	      e.stopPropagation();
	
	      _ItemActions2.default.fetchAllForItemBucket(this.props.itemBucket);
	    }
	  }, {
	    key: "_viewDonationReceipt",
	    value: function _viewDonationReceipt(item) {
	      _OrderActions2.default.downloadDonationReceipt(this.props.order || item.order.id || item.order);
	    }
	  }, {
	    key: "_makeRowForItem",
	    value: function _makeRowForItem(item) {
	      var _this2 = this;
	
	      var isDeleted = this.state.deletedItems[item.id],
	          shouldHighlight = this.state.highlightedId === item.id;
	
	      var noWrapTdStyle = { whiteSpace: "nowrap" };
	
	      return _react2.default.createElement(
	        _reactable.Tr,
	        {
	          style: Object.assign({}, isDeleted && DELETED_ROW_STYLE, shouldHighlight && HIGHLIGHTED_ROW_STYLE),
	          key: item.id
	        },
	        _react2.default.createElement(
	          _reactable.Td,
	          { column: "Id" },
	          item.id
	        ),
	        _react2.default.createElement(
	          _reactable.Td,
	          {
	            column: "Person",
	            value: item.person ? item.person.name || item.person.email : "Unknown Person",
	            style: noWrapTdStyle
	          },
	          item.person ? _react2.default.createElement(
	            "div",
	            null,
	            item.person.name || item.person.email,
	            _react2.default.createElement(_inlineLinkIconButton2.default, {
	              onTouchTap: function onTouchTap() {
	                _this2.context.router.push("/event_buckets/" + (_this2.props.eventBucket || item.event.event_bucket) + "/people/" + item.person.id);
	              },
	              tooltip: "View person"
	            })
	          ) : "Unknown Person"
	        ),
	        _react2.default.createElement(
	          _reactable.Td,
	          { column: "Item Bucket", value: item.item_bucket.name },
	          _react2.default.createElement(
	            "div",
	            null,
	            item.item_bucket.name,
	            _react2.default.createElement(_inlineLinkIconButton2.default, {
	              onTouchTap: function onTouchTap() {
	                _this2.context.router.push("/event_buckets/" + (_this2.props.eventBucket || item.event_bucket) + "/item_buckets/" + item.item_bucket.id);
	              },
	              tooltip: "View item bucket"
	            })
	          )
	        ),
	        _react2.default.createElement(
	          _reactable.Td,
	          { column: "Variant", style: noWrapTdStyle },
	          (item.variant.name || "") + " " + (item.price ? (0, _util.formatPrice)(item.price) : "")
	        ),
	        _react2.default.createElement(
	          _reactable.Td,
	          { column: "Order Date", value: item.created_at, style: noWrapTdStyle },
	          _react2.default.createElement(
	            "div",
	            null,
	            (0, _moment2.default)(item.created_at).format("lll"),
	            _react2.default.createElement(_inlineLinkIconButton2.default, {
	              onTouchTap: function onTouchTap() {
	                _this2.context.router.push("/event_buckets/" + (_this2.props.eventBucket || item.event.event_bucket) + "/orders/" + (_this2.props.order || item.order));
	              },
	              tooltip: "View order"
	            })
	          )
	        ),
	        _react2.default.createElement(
	          _reactable.Td,
	          { column: "Actions", style: noWrapTdStyle },
	          _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement("div", {
	              ref: function ref(r) {
	                if (shouldHighlight) {
	                  _this2.highlightedRow = r;
	                }
	              }
	            }),
	            item.item_bucket.code === "donation" && _react2.default.createElement(
	              "span",
	              null,
	              _react2.default.createElement(
	                "a",
	                {
	                  href: "#",
	                  onClick: this._viewDonationReceipt.bind(this, item)
	                },
	                "Donation receipt"
	              )
	            ),
	            !isDeleted && _UserStore2.default.hasPermission("manage_orders") && _react2.default.createElement(
	              "span",
	              null,
	              "\xA0",
	              _react2.default.createElement(
	                "a",
	                { href: "#", onClick: this._delete.bind(this, item.id) },
	                "Delete"
	              )
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(props) {
	      if (props.location && props.location.query.item && this.table && this.table.data.length) {
	        var rowLocation = this.table.data.findIndex(function (p) {
	          return p.data["Id"].value === props.location.query.item;
	        }),
	            neededPage = Math.floor(rowLocation / PAGE_SIZE);
	
	        this.setState({
	          highlightedId: props.location.query.item,
	          currentPage: neededPage
	        });
	      }
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate() {
	      var _this3 = this;
	
	      if (this.highlightedRow && this.state.highlightedRow !== this.highlightedRow) {
	        this.setState({
	          highlightedRow: this.highlightedRow
	        }, function () {
	          setTimeout(function () {
	            if (_this3.highlightedRow && _this3.highlightedRow.scrollIntoViewIfNeeded) {
	              // chrome only
	              _this3.highlightedRow.scrollIntoViewIfNeeded();
	            } else if (_this3.highlightedRow) {
	              _this3.highlightedRow.scrollIntoView();
	            }
	          }, 0);
	        });
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this4 = this;
	
	      var rows = this.props.items.map(this._makeRowForItem),
	          itemCount = this.props.items.length;
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        this.props.itemBucket ? _react2.default.createElement(_tableRefreshIndicator2.default, {
	          isRefreshing: this.props.isFetching,
	          onRefresh: this._refresh,
	          style: { marginTop: 15 }
	        }) : null,
	        _react2.default.createElement(
	          _reactable.Table,
	          {
	            ref: function ref(r) {
	              _this4.table = r;
	            },
	            className: "bordered striped responsive-table",
	            sortable: [{ column: "Order Date", sortFunction: _reactable.Sort.Date }, { column: "Item Bucket", sortFunction: _reactable.Sort.CaseInsensitive }, { column: "Variant", sortFunction: _reactable.Sort.CaseInsensitive }, { column: "Person", sortFunction: _reactable.Sort.CaseInsensitive }],
	            defaultSort: { column: "Event Date", direction: "asc" },
	            columns: (this.props.showItemBucket ? ["Item Bucket"] : []).concat(this.props.showPerson ? ["Person"] : []).concat(["Variant"]).concat(["Order Date", "Actions"]),
	            filterable: ["Person", "Item Bucket", "Variant"],
	            filterPlaceholder: "Type to filter...",
	            itemsPerPage: itemCount > PAGE_SIZE ? PAGE_SIZE : undefined,
	            currentPage: this.state.currentPage,
	            onPageChange: function onPageChange(p) {
	              return _this4.setState({ currentPage: p });
	            }
	          },
	          rows
	        ),
	        rows.length === 0 && !this.props.hideNoItemsMessage ? _react2.default.createElement(
	          "div",
	          { className: "empty-table-message" },
	          "No items yet."
	        ) : null
	      );
	    }
	  }], [{
	    key: "contextTypes",
	    get: function get() {
	      return {
	        router: _react2.default.PropTypes.object
	      };
	    }
	  }]);
	
	  return ItemTable;
	}(_react2.default.Component);
	
	exports.default = ItemTable;
	module.exports = exports["default"];

/***/ }),
/* 2756 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _alt = __webpack_require__(975);
	
	var _alt2 = _interopRequireDefault(_alt);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ItemActions = function () {
	  function ItemActions() {
	    _classCallCheck(this, ItemActions);
	
	    this.generateActions("updateItems", "fetchAllForPerson", "fetchAllForItemBucket", "fetchOne", "fetchFailed", "delete");
	  }
	
	  _createClass(ItemActions, [{
	    key: "updateItem",
	    value: function updateItem(id, item) {
	      return { id: id, item: item };
	    }
	  }]);
	
	  return ItemActions;
	}();
	
	exports.default = _alt2.default.createActions(ItemActions);
	module.exports = exports["default"];

/***/ }),
/* 2757 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _alt = __webpack_require__(975);
	
	var _alt2 = _interopRequireDefault(_alt);
	
	var _keyBy = __webpack_require__(990);
	
	var _keyBy2 = _interopRequireDefault(_keyBy);
	
	var _extend = __webpack_require__(1212);
	
	var _extend2 = _interopRequireDefault(_extend);
	
	var _values = __webpack_require__(1214);
	
	var _values2 = _interopRequireDefault(_values);
	
	var _ItemUtil = __webpack_require__(2758);
	
	var _ItemUtil2 = _interopRequireDefault(_ItemUtil);
	
	var _ItemActions = __webpack_require__(2756);
	
	var _ItemActions2 = _interopRequireDefault(_ItemActions);
	
	var _UserStore = __webpack_require__(974);
	
	var _UserStore2 = _interopRequireDefault(_UserStore);
	
	var _GlobalNotificationActions = __webpack_require__(1182);
	
	var _GlobalNotificationActions2 = _interopRequireDefault(_GlobalNotificationActions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ItemStore = function () {
	  function ItemStore() {
	    _classCallCheck(this, ItemStore);
	
	    this.bindActions(_ItemActions2.default);
	
	    this.state = {
	      items: {},
	      isFetching: false
	    };
	
	    this.exportPublicMethods({
	      getItemById: this.getItemById.bind(this),
	      getItemsForPerson: this.getItemsForPerson.bind(this),
	      getItemsForItemBucket: this.getItemsForItemBucket.bind(this)
	    });
	  }
	
	  _createClass(ItemStore, [{
	    key: "getItemById",
	    value: function getItemById(id) {
	      return this.state.items[id];
	    }
	  }, {
	    key: "getItemsForPerson",
	    value: function getItemsForPerson(id, eventBucket) {
	      return (0, _values2.default)(this.state.items).filter(function (i) {
	        if (eventBucket && i.event_bucket !== eventBucket) {
	          return false;
	        }
	        return i.person && i.person.id === id;
	      });
	    }
	  }, {
	    key: "getItemsForItemBucket",
	    value: function getItemsForItemBucket(id) {
	      return (0, _values2.default)(this.state.items).filter(function (i) {
	        return i.item_bucket.id === id;
	      });
	    }
	  }, {
	    key: "onFetchAllForItemBucket",
	    value: function onFetchAllForItemBucket(itemBucketId) {
	      var _this = this;
	
	      this.setState({ isFetching: true });
	      _ItemUtil2.default.fetchAllForItemBucket(_UserStore2.default.getState().apiKey, itemBucketId).then(function (data) {
	        _this.setState({ isFetching: false });
	        _ItemActions2.default.updateItems((0, _keyBy2.default)(data, "id"));
	      }).catch(_ItemActions2.default.fetchFailed);
	    }
	  }, {
	    key: "onFetchAllForPerson",
	    value: function onFetchAllForPerson(personId) {
	      var _this2 = this;
	
	      this.setState({ isFetching: true });
	      _ItemUtil2.default.fetchAllForPerson(_UserStore2.default.getState().apiKey, personId).then(function (data) {
	        _this2.setState({ isFetching: false });
	        _ItemActions2.default.updateItems((0, _keyBy2.default)(data, "id"));
	      }).catch(_ItemActions2.default.fetchFailed);
	    }
	  }, {
	    key: "onFetchOne",
	    value: function onFetchOne(id) {
	      var _this3 = this;
	
	      this.setState({ isFetching: true });
	      _ItemUtil2.default.fetchOne(_UserStore2.default.getState().apiKey, id).then(function (data) {
	        _this3.setState({ isFetching: false });
	        _ItemActions2.default.updateItem(id, data);
	      }).catch(_ItemActions2.default.fetchFailed);
	    }
	  }, {
	    key: "onDelete",
	    value: function onDelete(id) {
	      var _this4 = this;
	
	      _ItemUtil2.default.delete(_UserStore2.default.getState().apiKey, id).then(function (data) {
	        delete _this4.state.items[id];
	        _this4.setState(_this4.state);
	      });
	    }
	  }, {
	    key: "onUpdateItem",
	    value: function onUpdateItem(data) {
	      this.state.items[data.id] = data.item;
	      this.setState(this.state);
	    }
	  }, {
	    key: "onUpdateItems",
	    value: function onUpdateItems(items) {
	      (0, _extend2.default)(this.state.items, items);
	      this.setState(this.state);
	    }
	  }, {
	    key: "onFetchFailed",
	    value: function onFetchFailed(e) {
	      this.setState({ isFetching: false });
	      console.error("Fetching item failed:", e);
	      _GlobalNotificationActions2.default.notify.defer("Fetching item failed: " + e.message);
	      throw e;
	    }
	  }]);
	
	  return ItemStore;
	}();
	
	exports.default = _alt2.default.createStore(ItemStore, "ItemStore");
	module.exports = exports["default"];

/***/ }),
/* 2758 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _merge = __webpack_require__(732);
	
	var _merge2 = _interopRequireDefault(_merge);
	
	var _api = __webpack_require__(1160);
	
	var _api2 = _interopRequireDefault(_api);
	
	var _config = __webpack_require__(1173);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _qs = __webpack_require__(1206);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  fetchAllForItemBucket: function fetchAllForItemBucket(apiKey, itemBucket) {
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "GET",
	        endpoint: "item_buckets/" + itemBucket + "/items",
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response.items);
	      });
	    });
	  },
	  fetchAllForPerson: function fetchAllForPerson(apiKey, person) {
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "GET",
	        endpoint: "people/" + person + "/items",
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response.items);
	      });
	    });
	  },
	  fetchOne: function fetchOne(apiKey, item) {
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "GET",
	        endpoint: "items/" + item,
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response);
	      });
	    });
	  },
	  delete: function _delete(apiKey, item) {
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "DELETE",
	        endpoint: "items/" + item,
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response);
	      });
	    });
	  }
	};
	module.exports = exports["default"];

/***/ }),
/* 2759 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _get = __webpack_require__(1004);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _assign = __webpack_require__(920);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _reactRouter = __webpack_require__(486);
	
	var _materialUi = __webpack_require__(576);
	
	var _util = __webpack_require__(1183);
	
	var _infoNotice = __webpack_require__(1599);
	
	var _infoNotice2 = _interopRequireDefault(_infoNotice);
	
	var _backButton = __webpack_require__(1872);
	
	var _backButton2 = _interopRequireDefault(_backButton);
	
	var _workingIndicator = __webpack_require__(1664);
	
	var _workingIndicator2 = _interopRequireDefault(_workingIndicator);
	
	var _currencyField = __webpack_require__(1747);
	
	var _currencyField2 = _interopRequireDefault(_currencyField);
	
	var _basicHtmlField = __webpack_require__(2674);
	
	var _basicHtmlField2 = _interopRequireDefault(_basicHtmlField);
	
	var _connectToStores = __webpack_require__(1226);
	
	var _connectToStores2 = _interopRequireDefault(_connectToStores);
	
	var _ItemBucketActions = __webpack_require__(2044);
	
	var _ItemBucketActions2 = _interopRequireDefault(_ItemBucketActions);
	
	var _ItemBucketStore = __webpack_require__(2045);
	
	var _ItemBucketStore2 = _interopRequireDefault(_ItemBucketStore);
	
	var _EventBucketStore = __webpack_require__(1593);
	
	var _EventBucketStore2 = _interopRequireDefault(_EventBucketStore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ItemBucketEditor = function (_React$Component) {
	  _inherits(ItemBucketEditor, _React$Component);
	
	  function ItemBucketEditor(props) {
	    _classCallCheck(this, ItemBucketEditor);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(ItemBucketEditor).call(this, props));
	
	    _this.state = {
	      itemBucket: null,
	      dirty: false,
	      isSaving: false,
	      lastUpdatedAt: false,
	      values: {}
	    };
	
	    _this.onChangeValue = _this.onChangeValue.bind(_this);
	    _this.save = _this.save.bind(_this);
	    _this.delete = _this.delete.bind(_this);
	    return _this;
	  }
	
	  _createClass(ItemBucketEditor, [{
	    key: "getStyles",
	    value: function getStyles() {
	      return {
	        actions: {
	          marginTop: 20
	        },
	        editor: {
	          marginTop: 60,
	          paddingTop: 40,
	          borderTop: "1px solid rgb(224, 224, 224)"
	        }
	      };
	    }
	  }, {
	    key: "onChangeValue",
	    value: function onChangeValue(id, value) {
	      this.state.dirty = true;
	      this.state.values[id] = value;
	      this.setState(this.state);
	    }
	  }, {
	    key: "save",
	    value: function save() {
	      var values = (0, _assign2.default)({}, this.state.values);
	      this.setState({
	        isSaving: true,
	        lastUpdatedAt: this.state.itemBucket.updated_at
	      });
	      _ItemBucketActions2.default.edit.defer(this.props.params.itemBucketId, values);
	    }
	  }, {
	    key: "delete",
	    value: function _delete() {
	      var bucket = this.state.itemBucket.event_bucket;
	      if (window.confirm("Are you sure? This will delete all variants & all purchased items.")) {
	        _ItemBucketActions2.default.delete(this.props.params.itemBucketId);
	        this.context.router.push("/event_buckets/" + bucket + "/item_buckets");
	      }
	    }
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      this.context.router.setRouteLeaveHook(this.props.route, function () {
	        if (_this2.state.dirty) {
	          return "Are you sure you wish to leave the item bucket editor? Your changes will not be saved.";
	        }
	      });
	
	      this.componentWillReceiveProps(this.props);
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(newProps) {
	      var itemBucket = newProps.getItemBucketById(newProps.params.itemBucketId);
	
	      if (!this.state.isFetchingItemBucket && !itemBucket) {
	        _ItemBucketActions2.default.fetchOne(newProps.params.itemBucketId);
	        this.setState({ isFetchingItemBucket: true });
	      } else if (itemBucket) {
	        this.setState({ isFetchingItemBucket: false });
	      }
	
	      if (Object.keys(this.state.values).length === 0 || this.state.itemBucket.id !== newProps.params.itemBucketId || this.state.isSaving && itemBucket.updated_at !== this.state.lastUpdatedAt) {
	        this.setState({
	          itemBucket: itemBucket,
	          dirty: false,
	          isSaving: false,
	          values: itemBucket ? {
	            name: itemBucket.name || "",
	            variants: (itemBucket.variants.length ? itemBucket.variants : [{ name: "Default", unlimited: true }]).map(function (v) {
	              return {
	                id: v.id,
	                name: v.name,
	                price: v.price,
	                variable_price: v.variable_price,
	                variable_price_presets: v.variable_price_presets,
	                variable_price_allow_custom: v.variable_price_allow_custom,
	                quantity: v.quantity,
	                unlimited: v.unlimited,
	                active: v.active
	              };
	            })
	          } : {}
	        });
	      }
	    }
	  }, {
	    key: "_makeCoreEditor",
	    value: function _makeCoreEditor() {
	      var _this3 = this;
	
	      var styles = this.getStyles();
	
	      if (this.state.itemBucket && this.state.itemBucket.code === "donation") {
	        return _react2.default.createElement(
	          "div",
	          { style: { marginTop: 15 } },
	          "You cannot edit the donation item bucket; it is created automatically by the system.",
	          _react2.default.createElement("br", null),
	          "(You may enable/disable donations via",
	          " ",
	          _react2.default.createElement(
	            _reactRouter.Link,
	            {
	              to: "/event_buckets/" + this.state.itemBucket.event_bucket + "/settings"
	            },
	            "Settings"
	          ),
	          ".)"
	        );
	      }
	
	      if (this.state.itemBucket && this.state.itemBucket.code === "service_fee") {
	        return _react2.default.createElement(
	          "div",
	          { style: { marginTop: 15 } },
	          "You cannot edit the box office service fee item bucket; it is created automatically by the system.",
	          _react2.default.createElement("br", null),
	          "(You may enable/disable the box office service fee via",
	          " ",
	          _react2.default.createElement(
	            _reactRouter.Link,
	            {
	              to: "/event_buckets/" + this.state.itemBucket.event_bucket + "/settings"
	            },
	            "Settings"
	          ),
	          ".)"
	        );
	      }
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          "p",
	          { style: { marginBottom: 0 } },
	          _react2.default.createElement(
	            _infoNotice2.default,
	            { style: { marginTop: 5 } },
	            "Check out our",
	            " ",
	            _react2.default.createElement(
	              "a",
	              {
	                href: "https://help.eventive.org/item-sales-and-donations/create-item-buckets",
	                target: "_blank"
	              },
	              "guide to creating item buckets"
	            ),
	            "."
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(_materialUi.TextField, {
	              value: (0, _get2.default)(this.state, "values.name", ""),
	              floatingLabelText: "Name",
	              onChange: function onChange(e) {
	                _this3.onChangeValue("name", e.target.value);
	                // No codes pls
	                // if (!this.state.hasEditedCode) {
	                //   // Automatically generate a url code if they haven't entered one
	                //   this.onChangeValue('code', snakeCase(e.target.value));
	                // }
	              }
	            })
	          )
	        ),
	        _react2.default.createElement(
	          "h2",
	          { style: { marginTop: "1em" } },
	          "Variants"
	        ),
	        _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement(
	            "div",
	            { style: { marginTop: 5 } },
	            "Specify one or more variants of the item bucket (e.g. sizes)."
	          ),
	          _react2.default.createElement(
	            "div",
	            { style: { marginTop: 5 } },
	            this.state.values.variants.map(function (variant, i) {
	              return _react2.default.createElement(
	                "div",
	                {
	                  key: i,
	                  style: {
	                    border: "1px solid #ccc",
	                    padding: "0 10px 10px",
	                    position: "relative",
	                    marginBottom: 10
	                  }
	                },
	                _react2.default.createElement(_materialUi.TextField, {
	                  value: variant.name,
	                  floatingLabelText: "Variant name",
	                  floatingLabelFixed: true,
	                  onChange: function onChange(e) {
	                    _this3.state.values.variants[i].name = e.target.value;
	                    _this3.onChangeValue("variants", _this3.state.values.variants);
	                  }
	                }),
	                !variant.variable_price_allow_custom ? _react2.default.createElement(_currencyField2.default, {
	                  value: variant.price,
	                  floatingLabelText: "Price",
	                  floatingLabelFixed: true,
	                  placeholder: "$0.00",
	                  style: { marginLeft: 10, width: 100 },
	                  onChange: function onChange(e) {
	                    _this3.state.values.variants[i].price = e.target.value;
	                    _this3.onChangeValue("variants", _this3.state.values.variants);
	                  }
	                }) : null,
	                _react2.default.createElement(_materialUi.Checkbox, {
	                  label: "Variable price (prompt custom entry)",
	                  checked: variant.variable_price_allow_custom || false,
	                  style: { marginTop: "0.5em", display: "block", width: 300 },
	                  onCheck: function onCheck(e, checked) {
	                    _this3.state.values.variants[i].variable_price = checked;
	                    _this3.state.values.variants[i].variable_price_allow_custom = checked;
	                    _this3.onChangeValue("variants", _this3.state.values.variants);
	                  }
	                }),
	                _react2.default.createElement(_materialUi.Checkbox, {
	                  label: "Unlimited quantity",
	                  checked: variant.unlimited || false,
	                  style: { marginTop: "0.5em", display: "block", width: 200 },
	                  onCheck: function onCheck(e, checked) {
	                    _this3.state.values.variants[i].unlimited = !variant.unlimited;
	                    _this3.onChangeValue("variants", _this3.state.values.variants);
	                  }
	                }),
	                !variant.unlimited ? _react2.default.createElement(_materialUi.TextField, {
	                  value: variant.quantity,
	                  floatingLabelText: "Quantity",
	                  floatingLabelFixed: true,
	                  type: "number",
	                  style: { width: 75, display: "block" },
	                  onChange: function onChange(e) {
	                    _this3.state.values.variants[i].quantity = e.target.value;
	                    _this3.onChangeValue("variants", _this3.state.values.variants);
	                  }
	                }) : null,
	                i !== 0 && _react2.default.createElement(
	                  "div",
	                  { style: { position: "absolute", top: 0, right: 0 } },
	                  _react2.default.createElement(_materialUi.FlatButton, {
	                    style: { minWidth: 10 },
	                    label: "\xD7",
	                    onTouchTap: function onTouchTap() {
	                      _this3.state.values.variants.splice(i, 1);
	                      _this3.onChangeValue("variants", _this3.state.values.variants);
	                    }
	                  })
	                )
	              );
	            })
	          ),
	          _react2.default.createElement(_materialUi.RaisedButton, {
	            label: "Add another variant",
	            onTouchTap: function onTouchTap() {
	              _this3.onChangeValue("variants", _this3.state.values.variants.concat([{ unlimited: true }]));
	            }
	          })
	        )
	      );
	    }
	  }, {
	    key: "_makeVariantsEditor",
	    value: function _makeVariantsEditor() {
	      var styles = this.getStyles();
	
	      return _react2.default.createElement("div", null);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this4 = this;
	
	      var styles = this.getStyles();
	
	      if (!this.state.itemBucket) {
	        return _react2.default.createElement(_workingIndicator2.default, { fullPage: true });
	      }
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(_backButton2.default, {
	          label: this.props.location.state && this.props.location.state.fromListing ? "item buckets" : "item bucket",
	          style: { marginRight: 7 },
	          onTouchTap: function onTouchTap() {
	            return _this4.props.location.state && _this4.props.location.state.fromListing ? _this4.context.router.goBack() : _this4.context.router.push("/event_buckets/" + _this4.props.params.eventBucketId + "/item_buckets/" + _this4.props.params.itemBucketId);
	          }
	        }),
	        this._makeCoreEditor(),
	        this._makeVariantsEditor(),
	        _react2.default.createElement(
	          "div",
	          { style: styles.actions },
	          _react2.default.createElement(_materialUi.RaisedButton, {
	            label: this.state.dirty ? "Save changes" : "No changes to save",
	            primary: true,
	            disabled: !this.state.dirty,
	            onTouchTap: this.save
	          }),
	          _react2.default.createElement(_materialUi.RaisedButton, {
	            label: "Delete item bucket",
	            onTouchTap: this.delete,
	            disabled: this.state.itemBucket && ["donation", "service_fee"].indexOf(this.state.itemBucket.code) !== -1,
	            style: { marginLeft: 7 }
	          })
	        )
	      );
	    }
	  }], [{
	    key: "getStores",
	    value: function getStores() {
	      return [_ItemBucketStore2.default, _EventBucketStore2.default];
	    }
	  }, {
	    key: "getPropsFromStores",
	    value: function getPropsFromStores() {
	      return {
	        getItemBucketById: _ItemBucketStore2.default.getItemBucketById,
	        getEventBucketById: _EventBucketStore2.default.getEventBucketById
	      };
	    }
	  }, {
	    key: "contextTypes",
	    get: function get() {
	      return {
	        router: _react2.default.PropTypes.object
	      };
	    }
	  }]);
	
	  return ItemBucketEditor;
	}(_react2.default.Component);
	
	exports.default = (0, _connectToStores2.default)(ItemBucketEditor);
	module.exports = exports["default"];

/***/ }),
/* 2760 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _connectToStores = __webpack_require__(1226);
	
	var _connectToStores2 = _interopRequireDefault(_connectToStores);
	
	var _ItemBucketActions = __webpack_require__(2044);
	
	var _ItemBucketActions2 = _interopRequireDefault(_ItemBucketActions);
	
	var _ItemBucketStore = __webpack_require__(2045);
	
	var _ItemBucketStore2 = _interopRequireDefault(_ItemBucketStore);
	
	var _workingIndicator = __webpack_require__(1664);
	
	var _workingIndicator2 = _interopRequireDefault(_workingIndicator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var NewItemBucket = function (_React$Component) {
	  _inherits(NewItemBucket, _React$Component);
	
	  function NewItemBucket(props) {
	    _classCallCheck(this, NewItemBucket);
	
	    return _possibleConstructorReturn(this, Object.getPrototypeOf(NewItemBucket).call(this, props));
	  }
	
	  _createClass(NewItemBucket, [{
	    key: "componentWillMount",
	    value: function componentWillMount() {
	      _ItemBucketActions2.default.create({
	        name: "Unnamed Item Bucket",
	        event_bucket: this.props.params.eventBucketId
	      });
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(props) {
	      if (props.newItemBucketId) {
	        this.context.router.replace("/event_buckets/" + props.params.eventBucketId + "/item_buckets/" + props.newItemBucketId + "/edit");
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement(_workingIndicator2.default, { fullPage: true });
	    }
	  }], [{
	    key: "getStores",
	    value: function getStores() {
	      return [_ItemBucketStore2.default];
	    }
	  }, {
	    key: "getPropsFromStores",
	    value: function getPropsFromStores() {
	      return {
	        newItemBucketId: _ItemBucketStore2.default.getState().newItemBucketId
	      };
	    }
	  }, {
	    key: "contextTypes",
	    get: function get() {
	      return {
	        router: _react2.default.PropTypes.object
	      };
	    }
	  }]);
	
	  return NewItemBucket;
	}(_react2.default.Component);
	
	exports.default = (0, _connectToStores2.default)(NewItemBucket);
	module.exports = exports["default"];

/***/ }),
/* 2761 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(486);
	
	var _reactable = __webpack_require__(1688);
	
	var _materialUi = __webpack_require__(576);
	
	var _util = __webpack_require__(1183);
	
	var _qs = __webpack_require__(1206);
	
	var _qs2 = _interopRequireDefault(_qs);
	
	var _config = __webpack_require__(1173);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _connectToStores = __webpack_require__(1226);
	
	var _connectToStores2 = _interopRequireDefault(_connectToStores);
	
	var _ItemBucketActions = __webpack_require__(2044);
	
	var _ItemBucketActions2 = _interopRequireDefault(_ItemBucketActions);
	
	var _ItemBucketStore = __webpack_require__(2045);
	
	var _ItemBucketStore2 = _interopRequireDefault(_ItemBucketStore);
	
	var _UserStore = __webpack_require__(974);
	
	var _UserStore2 = _interopRequireDefault(_UserStore);
	
	var _workingIndicator = __webpack_require__(1664);
	
	var _workingIndicator2 = _interopRequireDefault(_workingIndicator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ItemBuckets = function (_React$Component) {
	  _inherits(ItemBuckets, _React$Component);
	
	  function ItemBuckets(props) {
	    _classCallCheck(this, ItemBuckets);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(ItemBuckets).call(this, props));
	
	    _this._makeRowForItemBucket = _this._makeRowForItemBucket.bind(_this);
	    return _this;
	  }
	
	  _createClass(ItemBuckets, [{
	    key: "getStyles",
	    value: function getStyles() {
	      return {};
	    }
	  }, {
	    key: "_makeCsvLink",
	    value: function _makeCsvLink() {
	      var query = {
	        god_become_user: _UserStore2.default.isGod() ? _UserStore2.default.getGodCredentials().activeUser : undefined,
	        api_key: this.props.apiKey
	      };
	
	      return _config2.default.endpoint + "event_buckets/" + this.props.params.eventBucketId + "/items.csv?" + _qs2.default.stringify(query);
	    }
	  }, {
	    key: "_makeRowForItemBucket",
	    value: function _makeRowForItemBucket(itemBucket) {
	      return _react2.default.createElement(
	        _reactable.Tr,
	        { key: itemBucket.id },
	        _react2.default.createElement(
	          _reactable.Td,
	          { column: "Name", value: itemBucket.name },
	          itemBucket.name
	        ),
	        _react2.default.createElement(
	          _reactable.Td,
	          {
	            column: "Variants",
	            value: itemBucket.variants.map(function (v) {
	              return v.name;
	            }).join(", ")
	          },
	          itemBucket.variants.map(function (v) {
	            return v.name;
	          }).join(", ") || "n/a"
	        ),
	        _react2.default.createElement(
	          _reactable.Td,
	          { column: "Actions" },
	          _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(
	              _reactRouter.Link,
	              {
	                to: {
	                  pathname: "/event_buckets/" + this.props.params.eventBucketId + "/item_buckets/" + itemBucket.id,
	                  state: { fromListing: true }
	                }
	              },
	              "View"
	            ),
	            "\xA0",
	            _react2.default.createElement(
	              _reactRouter.Link,
	              {
	                to: {
	                  pathname: "/event_buckets/" + this.props.params.eventBucketId + "/item_buckets/" + itemBucket.id + "/edit",
	                  state: { fromListing: true }
	                }
	              },
	              "Settings"
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: "componentWillMount",
	    value: function componentWillMount() {
	      _ItemBucketActions2.default.fetchAllForEventBucket(this.props.params.eventBucketId);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var styles = this.getStyles(),
	          itemBuckets = this.props.getItemBucketsForEventBucket(this.props.params.eventBucketId),
	          rows = itemBuckets.map(this._makeRowForItemBucket);
	
	      if (itemBuckets.length === 0 && _ItemBucketStore2.default.getState().isFetching) {
	        return _react2.default.createElement(_workingIndicator2.default, { fullPage: true });
	      }
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          "h1",
	          { className: "page-title" },
	          "Item Buckets"
	        ),
	        _react2.default.createElement(
	          _reactable.Table,
	          {
	            className: "bordered striped responsive-table",
	            sortable: [{ column: "Name", sortFunction: _reactable.Sort.CaseInsensitive }, "Variants"],
	            defaultSort: { column: "Name", direction: "asc" },
	            columns: ["Name", "Variants", "Actions"],
	            filterable: ["Name", "Variants"],
	            filterPlaceholder: "Type to filter..."
	          },
	          rows
	        ),
	        rows.length === 0 ? _react2.default.createElement(
	          "div",
	          { className: "empty-table-message" },
	          "No item buckets yet.",
	          " ",
	          _react2.default.createElement(
	            _reactRouter.Link,
	            {
	              to: "/event_buckets/" + this.props.params.eventBucketId + "/item_buckets/new"
	            },
	            "Create a new item bucket."
	          )
	        ) : null,
	        _react2.default.createElement(
	          "div",
	          { style: { marginTop: 20 } },
	          _react2.default.createElement(_materialUi.RaisedButton, {
	            label: "Create new item bucket",
	            primary: true,
	            onTouchTap: function onTouchTap() {
	              return _this2.context.router.push("/event_buckets/" + _this2.props.params.eventBucketId + "/item_buckets/new");
	            }
	          })
	        )
	      );
	    }
	  }], [{
	    key: "getStores",
	    value: function getStores() {
	      return [_ItemBucketStore2.default, _UserStore2.default];
	    }
	  }, {
	    key: "getPropsFromStores",
	    value: function getPropsFromStores() {
	      return {
	        getItemBucketsForEventBucket: _ItemBucketStore2.default.getItemBucketsForEventBucket,
	        isFetching: _ItemBucketStore2.default.getState().isFetching,
	        apiKey: _UserStore2.default.getState().apiKey
	      };
	    }
	  }, {
	    key: "contextTypes",
	    get: function get() {
	      return {
	        router: _react2.default.PropTypes.object
	      };
	    }
	  }]);
	
	  return ItemBuckets;
	}(_react2.default.Component);
	
	exports.default = (0, _connectToStores2.default)(ItemBuckets);
	module.exports = exports["default"];

/***/ }),
/* 2762 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _values = __webpack_require__(1214);
	
	var _values2 = _interopRequireDefault(_values);
	
	var _pickBy = __webpack_require__(1163);
	
	var _pickBy2 = _interopRequireDefault(_pickBy);
	
	var _reactRouter = __webpack_require__(486);
	
	var _materialUi = __webpack_require__(576);
	
	var _reactable = __webpack_require__(1688);
	
	var _connectToStores = __webpack_require__(1226);
	
	var _connectToStores2 = _interopRequireDefault(_connectToStores);
	
	var _CouponActions = __webpack_require__(2041);
	
	var _CouponActions2 = _interopRequireDefault(_CouponActions);
	
	var _CouponStore = __webpack_require__(2042);
	
	var _CouponStore2 = _interopRequireDefault(_CouponStore);
	
	var _UserStore = __webpack_require__(974);
	
	var _UserStore2 = _interopRequireDefault(_UserStore);
	
	var _workingIndicator = __webpack_require__(1664);
	
	var _workingIndicator2 = _interopRequireDefault(_workingIndicator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Coupons = function (_React$Component) {
	  _inherits(Coupons, _React$Component);
	
	  function Coupons(props) {
	    _classCallCheck(this, Coupons);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(Coupons).call(this, props));
	
	    _this._makeRowForCoupon = _this._makeRowForCoupon.bind(_this);
	    return _this;
	  }
	
	  _createClass(Coupons, [{
	    key: "getStyles",
	    value: function getStyles() {
	      return {};
	    }
	  }, {
	    key: "_makeRowForCoupon",
	    value: function _makeRowForCoupon(coupon) {
	      return {
	        Name: coupon.name,
	        Code: coupon.multicode ? "(multiple codes)" : coupon.code,
	        Active: coupon.active ? "Active" : "Inactive",
	        Uses: coupon.uses,
	        Actions: _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement(
	            _reactRouter.Link,
	            {
	              to: {
	                pathname: "/event_buckets/" + this.props.params.eventBucketId + "/coupons/" + coupon.id,
	                state: { fromListing: true }
	              }
	            },
	            _UserStore2.default.hasPermission("edit_coupon") ? "View" : "View Uses"
	          ),
	          "\xA0",
	          _react2.default.createElement(
	            _reactRouter.Link,
	            {
	              to: {
	                pathname: "/event_buckets/" + this.props.params.eventBucketId + "/coupons/" + coupon.id + "/edit",
	                state: { fromListing: true }
	              }
	            },
	            _UserStore2.default.hasPermission("edit_coupon") ? "Edit" : "View Details"
	          )
	        )
	      };
	    }
	  }, {
	    key: "componentWillMount",
	    value: function componentWillMount() {
	      _CouponActions2.default.fetchAllForBucket(this.props.params.eventBucketId);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var styles = this.getStyles(),
	          bucket = this.props.params.eventBucketId,
	          coupons = (0, _values2.default)((0, _pickBy2.default)(this.props.coupons, function (c) {
	        return c.event_bucket === bucket;
	      })),
	          rows = coupons.map(this._makeRowForCoupon);
	
	      if (coupons.length === 0 && _CouponStore2.default.getState().isFetching) {
	        return _react2.default.createElement(_workingIndicator2.default, { fullPage: true });
	      }
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          "h1",
	          { className: "page-title" },
	          "Discounts"
	        ),
	        _react2.default.createElement(_reactable.Table, {
	          className: "bordered striped responsive-table",
	          data: rows,
	          sortable: [{ column: "Name", sortFunction: _reactable.Sort.CaseInsensitive }, "Code", "Active", "Uses"],
	          defaultSort: { column: "Name", direction: "asc" },
	          columns: ["Name", "Code", "Active", "Uses", "Actions"],
	          filterable: ["Name", "Code"],
	          filterPlaceholder: "Type to filter..."
	        }),
	        rows.length === 0 ? _react2.default.createElement(
	          "div",
	          { className: "empty-table-message" },
	          "No discounts yet.",
	          " ",
	          _react2.default.createElement(
	            _reactRouter.Link,
	            { to: "/event_buckets/" + bucket + "/coupons/new" },
	            "Create a new discount."
	          )
	        ) : null,
	        _UserStore2.default.hasPermission("edit_coupon") ? _react2.default.createElement(
	          "div",
	          { style: { marginTop: 20 } },
	          _react2.default.createElement(_materialUi.RaisedButton, {
	            label: "Create new discount",
	            primary: true,
	            onTouchTap: function onTouchTap() {
	              return _this2.context.router.push("/event_buckets/" + _this2.props.params.eventBucketId + "/coupons/new");
	            }
	          })
	        ) : null
	      );
	    }
	  }], [{
	    key: "getStores",
	    value: function getStores() {
	      return [_CouponStore2.default, _UserStore2.default];
	    }
	  }, {
	    key: "getPropsFromStores",
	    value: function getPropsFromStores() {
	      return _CouponStore2.default.getState();
	    }
	  }, {
	    key: "contextTypes",
	    get: function get() {
	      return {
	        router: _react2.default.PropTypes.object
	      };
	    }
	  }]);
	
	  return Coupons;
	}(_react2.default.Component);
	
	exports.default = (0, _connectToStores2.default)(Coupons);
	module.exports = exports["default"];

/***/ }),
/* 2763 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _materialUi = __webpack_require__(576);
	
	var _orderTable = __webpack_require__(2764);
	
	var _orderTable2 = _interopRequireDefault(_orderTable);
	
	var _workingIndicator = __webpack_require__(1664);
	
	var _workingIndicator2 = _interopRequireDefault(_workingIndicator);
	
	var _backButton = __webpack_require__(1872);
	
	var _backButton2 = _interopRequireDefault(_backButton);
	
	var _connectToStores = __webpack_require__(1226);
	
	var _connectToStores2 = _interopRequireDefault(_connectToStores);
	
	var _CouponActions = __webpack_require__(2041);
	
	var _CouponActions2 = _interopRequireDefault(_CouponActions);
	
	var _CouponStore = __webpack_require__(2042);
	
	var _CouponStore2 = _interopRequireDefault(_CouponStore);
	
	var _UserStore = __webpack_require__(974);
	
	var _UserStore2 = _interopRequireDefault(_UserStore);
	
	var _util = __webpack_require__(1183);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Coupon = function (_React$Component) {
	  _inherits(Coupon, _React$Component);
	
	  function Coupon(props) {
	    _classCallCheck(this, Coupon);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(Coupon).call(this, props));
	
	    _this.state = {
	      coupon: null,
	      uses: [],
	      isFetchingCoupon: false,
	      fetchedCoupon: null
	    };
	    return _this;
	  }
	
	  _createClass(Coupon, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.componentWillReceiveProps(this.props);
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(newProps) {
	      var coupon = newProps.getCouponById(newProps.params.couponId),
	          uses = newProps.getCouponUsesById(newProps.params.couponId);
	
	      if (!this.state.isFetchingCoupon && this.state.fetchedCoupon !== newProps.params.couponId) {
	        setTimeout(function () {
	          _CouponActions2.default.fetchOne(newProps.params.couponId);
	          _CouponActions2.default.fetchUses(newProps.params.couponId);
	        }, 0);
	        this.setState({ isFetchingCoupon: true });
	      } else if (coupon && uses.length) {
	        this.setState({ isFetchingCoupon: false, fetchedCoupon: coupon.id });
	      }
	
	      this.setState({ coupon: coupon, uses: uses });
	    }
	  }, {
	    key: "getStyles",
	    value: function getStyles() {
	      return {
	        button: {
	          marginLeft: 7
	        },
	        h2: {
	          marginTop: 20
	        }
	      };
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var styles = this.getStyles();
	
	      if (!this.state.coupon) {
	        return _react2.default.createElement(_workingIndicator2.default, { fullPage: true });
	      }
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          "div",
	          { style: { marginBottom: 20 } },
	          _react2.default.createElement(_backButton2.default, {
	            label: "discounts",
	            onTouchTap: function onTouchTap() {
	              return _this2.props.location.state && _this2.props.location.state.fromListing ? _this2.context.router.goBack() : _this2.context.router.push("/event_buckets/" + _this2.props.params.eventBucketId + "/coupons");
	            }
	          }),
	          _UserStore2.default.hasPermission("edit_coupon") ? _react2.default.createElement(_materialUi.RaisedButton, {
	            label: "Edit discount",
	            onTouchTap: function onTouchTap() {
	              return _this2.context.router.push("/event_buckets/" + _this2.props.params.eventBucketId + "/coupons/" + _this2.props.params.couponId + "/edit");
	            },
	            style: styles.button
	          }) : null
	        ),
	        _react2.default.createElement(
	          "h1",
	          null,
	          this.state.coupon.name
	        ),
	        _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement(
	            "strong",
	            null,
	            this.state.coupon.active ? "Currently active" : "Currently inactive"
	          ),
	          _react2.default.createElement("br", null),
	          this.state.coupon.multicode ? "Multiple codes" : "Code: " + this.state.coupon.code,
	          " ",
	          "| Total uses: ",
	          this.state.uses.length
	        ),
	        _react2.default.createElement(
	          "h2",
	          { style: styles.h2 },
	          "Discount uses"
	        ),
	        _react2.default.createElement(_orderTable2.default, {
	          orders: this.state.uses,
	          showCouponCode: this.state.coupon.multicode,
	          hideNoOrdersMessage: this.props.isFetchingUses,
	          showDownloadButton: true,
	          downloadCsvFileLabel: "coupon-uses-" + (0, _util.snakeCase)(this.state.coupon.name)
	        })
	      );
	    }
	  }], [{
	    key: "getStores",
	    value: function getStores() {
	      return [_CouponStore2.default, _UserStore2.default];
	    }
	  }, {
	    key: "getPropsFromStores",
	    value: function getPropsFromStores() {
	      return {
	        getCouponById: _CouponStore2.default.getCouponById,
	        getCouponUsesById: _CouponStore2.default.getCouponUsesById,
	        isFetchingUses: _CouponStore2.default.getState().isFetchingUses
	      };
	    }
	  }, {
	    key: "contextTypes",
	    get: function get() {
	      return {
	        router: _react2.default.PropTypes.object
	      };
	    }
	  }]);
	
	  return Coupon;
	}(_react2.default.Component);
	
	exports.default = (0, _connectToStores2.default)(Coupon);
	module.exports = exports["default"];

/***/ }),
/* 2764 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _moment = __webpack_require__(1021);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _materialUi = __webpack_require__(576);
	
	var _reactRouter = __webpack_require__(486);
	
	var _reactable = __webpack_require__(1688);
	
	var _util = __webpack_require__(1183);
	
	var _inlineLinkIconButton = __webpack_require__(1704);
	
	var _inlineLinkIconButton2 = _interopRequireDefault(_inlineLinkIconButton);
	
	var _debounce = __webpack_require__(642);
	
	var _debounce2 = _interopRequireDefault(_debounce);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var OrderTable = function (_React$Component) {
	  _inherits(OrderTable, _React$Component);
	
	  function OrderTable(props) {
	    _classCallCheck(this, OrderTable);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(OrderTable).call(this, props));
	
	    _this.onClick = _this.onClick.bind(_this);
	    _this.downloadCsv = _this.downloadCsv.bind(_this);
	    return _this;
	  }
	
	  _createClass(OrderTable, [{
	    key: "onClick",
	    value: function onClick(order) {
	      if (this.props.onClick) {
	        this.props.onClick(order);
	      }
	    }
	  }, {
	    key: "downloadCsv",
	    value: function downloadCsv() {
	      (0, _util.clientSideDownload)("eventive-" + this.props.downloadCsvFileLabel + "-" + Date.now() + ".csv", "text/csv", (0, _util.makeCsv)(this.props.orders.map(function (order) {
	        return {
	          Date: order.created_at,
	          Type: order.type,
	          "Customer name": order.person ? order.person.details.name : "Unknown Person",
	          "Customer email": order.person ? order.person.details.email : "",
	          Net: (0, _util.formatPrice)(order.net_price || 0, {
	            currency: order.currency
	          }),
	          Gross: (0, _util.formatPrice)(order.purchase_price || 0, {
	            currency: order.currency
	          }),
	          Summary: order.summary,
	          "Discount code": order.coupon && order.coupon.code
	        };
	      })));
	    }
	  }, {
	    key: "_makeRowForOrder",
	    value: function _makeRowForOrder(eventBucket, order) {
	      var _this2 = this;
	
	      var personName = order.person ? order.person.details.name || order.person.details.email : order.type === "box_office" ? "Box Office (" + order.subtype + ")" : order.type === "kiosk" ? order.kiosk.name : order.type === "rush_line" ? "Rush Line (" + order.subtype + ")" : order.type === "bulk" ? "Bulk import" : order.type === "web" && order.box_office_email ? "Online Guest" : "Unknown person";
	      var noWrapTdStyle = { whiteSpace: "nowrap" };
	
	      // Fallback event bucket
	      eventBucket = eventBucket || order.event_bucket.id;
	
	      return _react2.default.createElement(
	        _reactable.Tr,
	        { key: order.id },
	        _react2.default.createElement(
	          _reactable.Td,
	          { column: "Event Bucket", value: order.event_bucket.name },
	          order.event_bucket.name
	        ),
	        _react2.default.createElement(
	          _reactable.Td,
	          { column: "Date", value: order.created_at, style: noWrapTdStyle },
	          (0, _moment2.default)(order.created_at).format("lll")
	        ),
	        _react2.default.createElement(
	          _reactable.Td,
	          {
	            column: "Person",
	            style: noWrapTdStyle,
	            value: "" + personName + (order.type === "rush_line" ? " (via Rush Line)" : "") + (order.type === "autorenewal" ? " (autorenewal)" : "") + (order.type === "admin_adjustment" ? " (Admin Adjustment)" : "") + (order.type === "instant_ticket" ? " (Instant Ticket)" : "")
	          },
	          order.person ? _react2.default.createElement(
	            "span",
	            null,
	            order.person.details.name || order.person.details.email,
	            order.type === "rush_line" && _react2.default.createElement(
	              "i",
	              null,
	              " (via Rush Line)"
	            ),
	            order.type === "autorenewal" && _react2.default.createElement(
	              "i",
	              null,
	              " (autorenewal)"
	            ),
	            order.type === "admin_adjustment" && _react2.default.createElement(
	              "i",
	              null,
	              " (Admin Adjustment)"
	            ),
	            order.type === "instant_ticket" && _react2.default.createElement(
	              "i",
	              null,
	              " (Instant Ticket)"
	            ),
	            _react2.default.createElement(_inlineLinkIconButton2.default, {
	              onTouchTap: function onTouchTap() {
	                _this2.onClick(order);
	                _this2.context.router.push((eventBucket ? "/event_buckets/" + eventBucket : "") + "/people/" + order.person.id);
	              },
	              tooltip: "View person"
	            })
	          ) : personName
	        ),
	        _react2.default.createElement(
	          _reactable.Td,
	          { column: "Amount", style: noWrapTdStyle, value: order.net_price },
	          (0, _util.formatPrice)(order.net_price || 0, {
	            currency: order.platform_managed ? "usd" : order.currency
	          }) + " (" + (0, _util.formatPrice)(order.purchase_price || order.original_price || 0, { currency: order.currency }) + ")"
	        ),
	        _react2.default.createElement(
	          _reactable.Td,
	          { column: "Summary", value: order.summary },
	          order.summary
	        ),
	        _react2.default.createElement(
	          _reactable.Td,
	          { column: "Discount code", value: order.coupon && order.coupon.code },
	          order.coupon && order.coupon.code
	        ),
	        _react2.default.createElement(
	          _reactable.Td,
	          { column: "Actions", style: noWrapTdStyle },
	          _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(
	              _reactRouter.Link,
	              {
	                onClick: function onClick() {
	                  _this2.onClick(order);
	                },
	                to: (eventBucket ? "/event_buckets/" + eventBucket : "") + "/orders/" + order.id
	              },
	              "View order"
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this3 = this;
	
	      var _props = this.props;
	      var orders = _props.orders;
	      var eventBucket = _props.eventBucket;
	      var noSort = _props.noSort;
	      var hideNoOrdersMessage = _props.hideNoOrdersMessage;
	      var rows = orders.map(this._makeRowForOrder.bind(this, eventBucket));
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          _reactable.Table,
	          {
	            className: "bordered striped responsive-table",
	            sortable: noSort ? false : [{ column: "Date", sortFunction: _reactable.Sort.Date }, "Person", "Amount"],
	            defaultSort: { column: "Date", direction: "desc" },
	            columns: (this.props.showEventBucket ? ["Event Bucket"] : []).concat(["Date"]).concat(this.props.isSinglePerson ? [] : ["Person"]).concat([{ key: "Amount", label: "Amount (net/paid)" }, "Summary"]).concat(this.props.showCouponCode ? ["Discount code"] : []).concat(["Actions"]),
	            filterable: ["Event Bucket", "Date", "Person", "Discount code", "Summary"],
	            filterPlaceholder: "Type to filter...",
	            filterBy: this.props.location && this.props.location.query.order_filter,
	            onFilter: this.props.location && (0, _debounce2.default)(function (f) {
	              return _this3.context.router.push(Object.assign({}, _this3.props.location, {
	                query: Object.assign(_this3.props.location.query, {
	                  order_filter: f || undefined
	                })
	              }));
	            }, 250)
	          },
	          rows
	        ),
	        rows.length === 0 && !hideNoOrdersMessage ? _react2.default.createElement(
	          "div",
	          { className: "empty-table-message" },
	          "No orders yet."
	        ) : null,
	        this.props.showDownloadButton ? _react2.default.createElement(_materialUi.RaisedButton, {
	          style: { marginTop: 10 },
	          label: "Download (.csv)",
	          onTouchTap: this.downloadCsv
	        }) : null
	      );
	    }
	  }], [{
	    key: "contextTypes",
	    get: function get() {
	      return {
	        router: _react2.default.PropTypes.object
	      };
	    }
	  }]);
	
	  return OrderTable;
	}(_react2.default.Component);
	
	exports.default = OrderTable;
	module.exports = exports["default"];

/***/ }),
/* 2765 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _assign = __webpack_require__(920);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _get = __webpack_require__(1004);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _set = __webpack_require__(1188);
	
	var _set2 = _interopRequireDefault(_set);
	
	var _just = __webpack_require__(2766);
	
	var _just2 = _interopRequireDefault(_just);
	
	var _materialUi = __webpack_require__(576);
	
	var _styles = __webpack_require__(917);
	
	var _linkLike = __webpack_require__(973);
	
	var _linkLike2 = _interopRequireDefault(_linkLike);
	
	var _currencyField = __webpack_require__(1747);
	
	var _currencyField2 = _interopRequireDefault(_currencyField);
	
	var _injectedSelect = __webpack_require__(1874);
	
	var _injectedSelect2 = _interopRequireDefault(_injectedSelect);
	
	var _selectField = __webpack_require__(1683);
	
	var _selectField2 = _interopRequireDefault(_selectField);
	
	var _label = __webpack_require__(1682);
	
	var _label2 = _interopRequireDefault(_label);
	
	var _infoNotice = __webpack_require__(1599);
	
	var _infoNotice2 = _interopRequireDefault(_infoNotice);
	
	var _backButton = __webpack_require__(1872);
	
	var _backButton2 = _interopRequireDefault(_backButton);
	
	var _workingIndicator = __webpack_require__(1664);
	
	var _workingIndicator2 = _interopRequireDefault(_workingIndicator);
	
	var _datetimeField = __webpack_require__(2061);
	
	var _datetimeField2 = _interopRequireDefault(_datetimeField);
	
	var _connectToStores = __webpack_require__(1226);
	
	var _connectToStores2 = _interopRequireDefault(_connectToStores);
	
	var _CouponActions = __webpack_require__(2041);
	
	var _CouponActions2 = _interopRequireDefault(_CouponActions);
	
	var _CouponStore = __webpack_require__(2042);
	
	var _CouponStore2 = _interopRequireDefault(_CouponStore);
	
	var _EventBucketStore = __webpack_require__(1593);
	
	var _EventBucketStore2 = _interopRequireDefault(_EventBucketStore);
	
	var _UserStore = __webpack_require__(974);
	
	var _UserStore2 = _interopRequireDefault(_UserStore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Coupon = function (_React$Component) {
	  _inherits(Coupon, _React$Component);
	
	  function Coupon(props) {
	    _classCallCheck(this, Coupon);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(Coupon).call(this, props));
	
	    _this.state = {
	      coupon: null,
	      dirty: false,
	      showExpiration: false,
	      values: {}
	    };
	
	    _this.onChange = _this.onChange.bind(_this);
	    _this.onChangeValue = _this.onChangeValue.bind(_this);
	    _this.makeNewRandomCode = _this.makeNewRandomCode.bind(_this);
	    _this.makeMultiRandomCodes = _this.makeMultiRandomCodes.bind(_this);
	    _this.save = _this.save.bind(_this);
	    _this.delete = _this.delete.bind(_this);
	    return _this;
	  }
	
	  _createClass(Coupon, [{
	    key: "getStyles",
	    value: function getStyles() {
	      return {
	        checkboxWrapper: {
	          margin: "20px 0"
	        },
	        actions: {
	          marginTop: 40
	        },
	        codeWrapper: {
	          position: "relative",
	          marginBottom: 30
	        },
	        controlsWrapper: {
	          position: "absolute",
	          bottom: -15
	        },
	        h3: {
	          marginTop: 30,
	          marginBottom: 10
	        }
	      };
	    }
	  }, {
	    key: "onChange",
	    value: function onChange(id, e, checked) {
	      this.onChangeValue(id, typeof checked !== "undefined" ? !(0, _get2.default)(this.state.values, id) : e.target.value);
	    }
	  }, {
	    key: "onChangeValue",
	    value: function onChangeValue(id, value) {
	      this.state.dirty = true;
	      (0, _set2.default)(this.state.values, id, value);
	      this.setState(this.state);
	    }
	  }, {
	    key: "_makeCode",
	    value: function _makeCode() {
	      return (0, _just2.default)(15, "numbers_uppercases");
	    }
	  }, {
	    key: "makeNewRandomCode",
	    value: function makeNewRandomCode() {
	      this.state.dirty = true;
	      this.state.values.code = this._makeCode();
	      this.setState(this.state);
	    }
	  }, {
	    key: "makeMultiRandomCodes",
	    value: function makeMultiRandomCodes() {
	      var count = window.prompt("How many codes would you like to generate?"),
	          newValues = Array.apply(null, Array(+count)).map(this._makeCode);
	
	      this.state.dirty = true;
	      this.state.values.codes = this.state.values.codes.filter(function (c) {
	        return !!c;
	      }).concat(newValues);
	      this.setState(this.state);
	    }
	  }, {
	    key: "save",
	    value: function save() {
	      var values = (0, _assign2.default)({}, this.state.values);
	      values.codes = values.codes.filter(function (c) {
	        return !!c;
	      }); // strip empty codes
	      _CouponActions2.default.edit(this.props.params.couponId, values);
	    }
	  }, {
	    key: "delete",
	    value: function _delete() {
	      var bucket = this.state.coupon.event_bucket;
	      if (window.confirm("Are you sure?")) {
	        _CouponActions2.default.delete(this.props.params.couponId);
	        this.context.router.push("/event_buckets/" + bucket + "/coupons");
	      }
	    }
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.componentWillReceiveProps(this.props);
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(newProps) {
	      var coupon = newProps.getCouponById(newProps.params.couponId);
	
	      if (!this.state.isFetchingCoupon && !coupon) {
	        _CouponActions2.default.fetchOne(newProps.params.couponId);
	        this.setState({ isFetchingCoupon: true });
	      } else if (coupon) {
	        this.setState({ isFetchingCoupon: false });
	      }
	
	      this.setState({
	        coupon: coupon,
	        dirty: false,
	        showExpiration: coupon ? coupon.expiration ? true : false : false,
	        values: coupon ? {
	          name: coupon.name || "",
	          multicode: coupon.multicode || false,
	          code: coupon.code || "",
	          codes: coupon.codes || [],
	          active: coupon.active || false,
	          expiration: coupon.expiration || null,
	          target: {
	            all: (0, _get2.default)(coupon, "target.all", false),
	            all_tickets: (0, _get2.default)(coupon, "target.all_tickets", false),
	            all_passes: (0, _get2.default)(coupon, "target.all_passes", false),
	            all_items: (0, _get2.default)(coupon, "target.all_items", false),
	            ids: (0, _get2.default)(coupon, "target.ids", []),
	            exclude_ids: (0, _get2.default)(coupon, "target.exclude_ids", [])
	          },
	          result: {
	            price: {
	              percent_off: (0, _get2.default)(coupon, "result.price.percent_off", null),
	              cents_off: (0, _get2.default)(coupon, "result.price.cents_off", null),
	              set_price: (0, _get2.default)(coupon, "result.price.set_price", null),
	              cents_off_item: (0, _get2.default)(coupon, "result.price.cents_off_item", null)
	            },
	            ticket_message: (0, _get2.default)(coupon, "result.ticket_message", null)
	          },
	          restrictions: {
	            uses: {
	              total: (0, _get2.default)(coupon, "restrictions.uses.total", null),
	              per_person: (0, _get2.default)(coupon, "restrictions.uses.per_person", null),
	              total_items: (0, _get2.default)(coupon, "restrictions.uses.total_items", null),
	              per_code: (0, _get2.default)(coupon, "restrictions.uses.per_code", null),
	              per_person_per_event: (0, _get2.default)(coupon, "restrictions.uses.per_person_per_event", null)
	            },
	            recurrence_duration: (0, _get2.default)(coupon, "restrictions.recurrence_duration", null)
	          }
	        } : {}
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var styles = this.getStyles();
	
	      if (!this.state.coupon) {
	        return _react2.default.createElement(_workingIndicator2.default, { fullPage: true });
	      }
	
	      var eventBucket = _EventBucketStore2.default.getEventBucketById(this.props.params.eventBucketId) || {};
	
	      var saveButton = _react2.default.createElement(_materialUi.RaisedButton, {
	        label: this.state.dirty ? "Save changes" : "No changes to save",
	        primary: true,
	        disabled: !this.state.dirty,
	        onClick: this.save
	      });
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement(_backButton2.default, {
	            label: this.props.location.state && this.props.location.state.fromListing ? "discounts" : "discount",
	            style: { marginRight: 7 },
	            onTouchTap: function onTouchTap() {
	              return _this2.props.location.state && _this2.props.location.state.fromListing ? _this2.context.router.goBack() : _this2.context.router.push("/event_buckets/" + _this2.props.params.eventBucketId + "/coupons/" + _this2.props.params.couponId);
	            }
	          }),
	          _UserStore2.default.hasPermission("edit_coupon") ? saveButton : null
	        ),
	        _UserStore2.default.hasPermission("edit_coupon") ? _react2.default.createElement(
	          _infoNotice2.default,
	          { style: { marginTop: 20 } },
	          "Check out our",
	          " ",
	          _react2.default.createElement(
	            "a",
	            {
	              href: "http://help.eventive.org/discounts/create-discounts",
	              target: "_blank"
	            },
	            "guide to creating discounts"
	          ),
	          "."
	        ) : null,
	        _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(_materialUi.TextField, {
	              value: (0, _get2.default)(this.state, "values.name", "") || "",
	              floatingLabelText: "Name",
	              floatingLabelFixed: true,
	              onChange: function onChange(e) {
	                return _this2.onChangeValue("name", e.target.value);
	              },
	              disabled: !_UserStore2.default.hasPermission("edit_coupon")
	            })
	          ),
	          this.state.values.multicode ? _react2.default.createElement(
	            "div",
	            { style: styles.codeWrapper },
	            _react2.default.createElement(_materialUi.TextField, {
	              value: (0, _get2.default)(this.state, "values.codes", []).join("\n") || "",
	              multiLine: true,
	              rows: 2,
	              rowsMax: 10,
	              floatingLabelText: "Codes (count: " + this.state.values.codes.length + ")",
	              floatingLabelFixed: true,
	              onChange: function onChange(e) {
	                return _this2.onChangeValue("codes", e.target.value.split(/[\r\n]+/g));
	              },
	              disabled: !_UserStore2.default.hasPermission("edit_coupon")
	            }),
	            _UserStore2.default.hasPermission("edit_coupon") ? _react2.default.createElement(
	              "div",
	              { style: styles.controlsWrapper },
	              _react2.default.createElement(
	                _linkLike2.default,
	                { onTouchTap: this.makeMultiRandomCodes },
	                "Generate random codes"
	              ),
	              "\xA0",
	              _react2.default.createElement(
	                _linkLike2.default,
	                {
	                  onTouchTap: function onTouchTap() {
	                    return _this2.onChangeValue("multicode", false);
	                  }
	                },
	                "Switch to single code"
	              )
	            ) : null
	          ) : _react2.default.createElement(
	            "div",
	            { style: styles.codeWrapper },
	            _react2.default.createElement(_materialUi.TextField, {
	              value: (0, _get2.default)(this.state, "values.code", "") || "",
	              floatingLabelText: "Code",
	              floatingLabelFixed: true,
	              onChange: function onChange(e) {
	                return _this2.onChangeValue("code", e.target.value);
	              },
	              disabled: !_UserStore2.default.hasPermission("edit_coupon")
	            }),
	            _UserStore2.default.hasPermission("edit_coupon") ? _react2.default.createElement(
	              "div",
	              { style: styles.controlsWrapper },
	              _react2.default.createElement(
	                _linkLike2.default,
	                { onTouchTap: this.makeNewRandomCode },
	                "Generate a new random code"
	              ),
	              "\xA0",
	              _react2.default.createElement(
	                _linkLike2.default,
	                {
	                  style: styles.a,
	                  onTouchTap: function onTouchTap() {
	                    return _this2.onChangeValue("multicode", true);
	                  }
	                },
	                "Switch to multicode"
	              )
	            ) : null
	          ),
	          _react2.default.createElement(
	            "div",
	            { style: styles.checkboxWrapper },
	            _react2.default.createElement(
	              _label2.default,
	              null,
	              "Status"
	            ),
	            _react2.default.createElement(_materialUi.Checkbox, {
	              label: "Active (allow customers to use)",
	              checked: this.state.values.active,
	              onCheck: this.onChange.bind(null, "active"),
	              disabled: !_UserStore2.default.hasPermission("edit_coupon")
	            })
	          ),
	          _react2.default.createElement(
	            "div",
	            { style: styles.checkboxWrapper },
	            _react2.default.createElement(
	              _label2.default,
	              null,
	              "Limit availability"
	            ),
	            _react2.default.createElement(_materialUi.Checkbox, {
	              label: "Include an expiration date for this discount",
	              checked: this.state.showExpiration ? true : false,
	              onClick: function onClick(e) {
	                _this2.setState({ showExpiration: !_this2.state.showExpiration }, function () {
	                  if (!this.state.showExpiration) {
	                    this.onChangeValue("expiration", null);
	                  }
	                });
	              },
	              disabled: !_UserStore2.default.hasPermission("edit_coupon")
	            }),
	            this.state.showExpiration ? _react2.default.createElement(_datetimeField2.default, {
	              value: (0, _get2.default)(this.state, "values.expiration", "") || "",
	              label: "Expiration date",
	              useMoment: true,
	              unclearable: true,
	              timezone: eventBucket.timezone,
	              onChange: function onChange(e, v) {
	                _this2.onChangeValue("expiration", v);
	              },
	              style: { display: "inline-block", marginRight: 24 }
	            }) : null
	          ),
	          _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(
	              "h3",
	              { style: styles.h3 },
	              "Target"
	            ),
	            _react2.default.createElement(
	              "p",
	              null,
	              "Rules to select the orders that can use this discount code."
	            ),
	            _react2.default.createElement(
	              "div",
	              null,
	              _react2.default.createElement(_materialUi.Checkbox, {
	                label: "Apply to all orders",
	                checked: this.state.values.target.all,
	                onCheck: this.onChange.bind(null, "target.all"),
	                disabled: !_UserStore2.default.hasPermission("edit_coupon")
	              })
	            ),
	            _react2.default.createElement(
	              "div",
	              null,
	              _react2.default.createElement(_materialUi.Checkbox, {
	                label: "Apply to all ticket orders",
	                checked: this.state.values.target.all_tickets,
	                onCheck: this.onChange.bind(null, "target.all_tickets"),
	                disabled: !_UserStore2.default.hasPermission("edit_coupon")
	              })
	            ),
	            _react2.default.createElement(
	              "div",
	              null,
	              _react2.default.createElement(_materialUi.Checkbox, {
	                label: "Apply to all pass orders",
	                checked: this.state.values.target.all_passes,
	                onCheck: this.onChange.bind(null, "target.all_passes"),
	                disabled: !_UserStore2.default.hasPermission("edit_coupon")
	              })
	            ),
	            _react2.default.createElement(
	              "div",
	              null,
	              _react2.default.createElement(_materialUi.Checkbox, {
	                label: "Apply to all item orders",
	                checked: this.state.values.target.all_items,
	                onCheck: this.onChange.bind(null, "target.all_items"),
	                disabled: !_UserStore2.default.hasPermission("edit_coupon")
	              })
	            ),
	            !this.state.values.target.all && _react2.default.createElement(
	              "div",
	              null,
	              _react2.default.createElement(_injectedSelect2.default, {
	                value: (0, _get2.default)(this.state.values, "target.ids", []),
	                types: ["ticket_buckets", "pass_buckets", "item_buckets", "tags"],
	                multi: true,
	                label: function () {
	                  var additionalItems = [_this2.state.values.target.all_tickets && "tickets", _this2.state.values.target.all_passes && "passes", _this2.state.values.target.all_items && "items"].filter(function (x) {
	                    return !!x;
	                  });
	                  return "Items to apply to " + (additionalItems.length ? "(in addition to all " + additionalItems.join(" & ") + ")" : "");
	                }(),
	                labelFormatter: {
	                  pass_buckets: function pass_buckets(b) {
	                    return "" + b.name;
	                  },
	                  ticket_buckets: function ticket_buckets(b) {
	                    return b.event.name + " \u2013 " + b.name;
	                  },
	                  item_buckets: function item_buckets(b) {
	                    return "" + b.name;
	                  },
	                  tags: function tags(b) {
	                    return "" + b.name;
	                  }
	                },
	                eventBucketId: this.props.params.eventBucketId,
	                onChange: function onChange(selected) {
	                  return _this2.onChangeValue("target.ids", selected);
	                },
	                disabled: !_UserStore2.default.hasPermission("edit_coupon")
	              })
	            ),
	            _react2.default.createElement(
	              "div",
	              null,
	              _react2.default.createElement(_injectedSelect2.default, {
	                value: (0, _get2.default)(this.state.values, "target.exclude_ids", []),
	                types: ["ticket_buckets", "pass_buckets", "item_buckets", "tags"],
	                multi: true,
	                label: "Items to exclude",
	                labelFormatter: {
	                  pass_buckets: function pass_buckets(b) {
	                    return "" + b.name;
	                  },
	                  ticket_buckets: function ticket_buckets(b) {
	                    return b.event.name + " \u2013 " + b.name;
	                  },
	                  item_buckets: function item_buckets(b) {
	                    return "" + b.name;
	                  },
	                  tags: function tags(b) {
	                    return "" + b.name;
	                  }
	                },
	                eventBucketId: this.props.params.eventBucketId,
	                onChange: function onChange(selected) {
	                  return _this2.onChangeValue("target.exclude_ids", selected);
	                },
	                disabled: !_UserStore2.default.hasPermission("edit_coupon")
	              })
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(
	              "h3",
	              { style: styles.h3 },
	              "Result"
	            ),
	            _react2.default.createElement(
	              "p",
	              null,
	              "Rules to determine the effects of this discount code."
	            ),
	            _react2.default.createElement(
	              "div",
	              null,
	              _react2.default.createElement(_materialUi.TextField, {
	                value: (0, _get2.default)(this.state, "values.result.price.percent_off", "") || "",
	                floatingLabelText: "% off order (0-100)",
	                floatingLabelFixed: true,
	                placeholder: "0",
	                onChange: function onChange(e) {
	                  return _this2.onChangeValue("result.price.percent_off", e.target.value);
	                },
	                disabled: !_UserStore2.default.hasPermission("edit_coupon")
	              })
	            ),
	            _react2.default.createElement(
	              "div",
	              null,
	              _react2.default.createElement(_currencyField2.default, {
	                value: (0, _get2.default)(this.state, "values.result.price.cents_off", "") || "",
	                floatingLabelText: "Dollars off order",
	                floatingLabelFixed: true,
	                placeholder: "$0.00",
	                onChange: function onChange(e) {
	                  return _this2.onChangeValue("result.price.cents_off", e.target.value);
	                },
	                disabled: !_UserStore2.default.hasPermission("edit_coupon")
	              })
	            ),
	            _react2.default.createElement(
	              "div",
	              null,
	              _react2.default.createElement(_currencyField2.default, {
	                value: (0, _get2.default)(this.state, "values.result.price.set_price", "") || "",
	                floatingLabelText: "Set price per item",
	                floatingLabelFixed: true,
	                placeholder: "None",
	                onChange: function onChange(e) {
	                  return _this2.onChangeValue("result.price.set_price", e.target.value);
	                },
	                disabled: !_UserStore2.default.hasPermission("edit_coupon")
	              })
	            ),
	            _react2.default.createElement(
	              "div",
	              null,
	              _react2.default.createElement(_currencyField2.default, {
	                value: (0, _get2.default)(this.state, "values.result.price.cents_off_item", "") || "",
	                floatingLabelText: "Dollars off per item",
	                floatingLabelFixed: true,
	                placeholder: "$0.00",
	                onChange: function onChange(e) {
	                  return _this2.onChangeValue("result.price.cents_off_item", e.target.value);
	                },
	                disabled: !_UserStore2.default.hasPermission("edit_coupon")
	              })
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(
	              "h3",
	              { style: styles.h3 },
	              "Restrictions"
	            ),
	            _react2.default.createElement(
	              "p",
	              null,
	              "Restrictions that govern the use of this discount code."
	            ),
	            _react2.default.createElement(
	              "div",
	              null,
	              _react2.default.createElement(_materialUi.TextField, {
	                value: (0, _get2.default)(this.state, "values.restrictions.uses.total", "") || "",
	                floatingLabelText: "Total number of orders (globally)",
	                floatingLabelFixed: true,
	                placeholder: "Unlimited",
	                onChange: function onChange(e) {
	                  return _this2.onChangeValue("restrictions.uses.total", e.target.value);
	                },
	                disabled: !_UserStore2.default.hasPermission("edit_coupon")
	              })
	            ),
	            _react2.default.createElement(
	              "div",
	              null,
	              _react2.default.createElement(_materialUi.TextField, {
	                value: (0, _get2.default)(this.state, "values.restrictions.uses.total_items", "") || "",
	                floatingLabelText: "Total number of items (globally)",
	                floatingLabelFixed: true,
	                placeholder: "Unlimited",
	                onChange: function onChange(e) {
	                  return _this2.onChangeValue("restrictions.uses.total_items", e.target.value);
	                },
	                disabled: !_UserStore2.default.hasPermission("edit_coupon")
	              })
	            ),
	            _react2.default.createElement(
	              "div",
	              null,
	              _react2.default.createElement(_materialUi.TextField, {
	                value: (0, _get2.default)(this.state, "values.restrictions.uses.per_person", "") || "",
	                floatingLabelText: "Total number of items per person",
	                floatingLabelFixed: true,
	                placeholder: "Unlimited",
	                onChange: function onChange(e) {
	                  return _this2.onChangeValue("restrictions.uses.per_person", e.target.value);
	                },
	                disabled: !_UserStore2.default.hasPermission("edit_coupon")
	              })
	            ),
	            _react2.default.createElement(
	              "div",
	              null,
	              _react2.default.createElement(_materialUi.TextField, {
	                value: (0, _get2.default)(this.state, "values.restrictions.uses.per_person_per_event", "") || "",
	                floatingLabelText: "Total number of tickets per event per person",
	                floatingLabelFixed: true,
	                floatingLabelStyle: { whiteSpace: "nowrap" },
	                placeholder: "Unlimited",
	                onChange: function onChange(e) {
	                  return _this2.onChangeValue("restrictions.uses.per_person_per_event", e.target.value);
	                },
	                disabled: !_UserStore2.default.hasPermission("edit_coupon")
	              })
	            ),
	            _react2.default.createElement(
	              "div",
	              null,
	              _react2.default.createElement(_selectField2.default, {
	                value: (0, _get2.default)(this.state, "values.restrictions.recurrence_duration", "") || "once",
	                label: "For recurring orders, duration to apply discount",
	                style: { maxWidth: 300 },
	                options: [{ label: "Once (only apply to first order)", value: "once" }, {
	                  label: "Forever (apply to first order & renewals)",
	                  value: "forever"
	                }],
	                onChange: function onChange(selected) {
	                  return _this2.onChangeValue("restrictions.recurrence_duration", selected.value);
	                },
	                disabled: !_UserStore2.default.hasPermission("edit_coupon")
	              })
	            )
	          ),
	          this.state.values.multicode ? _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(
	              "h3",
	              { style: styles.h3 },
	              "Per-code restrictions"
	            ),
	            _react2.default.createElement(
	              "p",
	              null,
	              "Since this discount has multiple codes, you can also restrict uses by code."
	            ),
	            _react2.default.createElement(
	              "div",
	              null,
	              _react2.default.createElement(_materialUi.TextField, {
	                value: (0, _get2.default)(this.state, "values.restrictions.uses.per_code", "") || "",
	                floatingLabelText: "Total number of items per code",
	                floatingLabelFixed: true,
	                placeholder: "Unlimited",
	                onChange: function onChange(e) {
	                  return _this2.onChangeValue("restrictions.uses.per_code", e.target.value);
	                }
	              })
	            )
	          ) : null,
	          _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(
	              "h3",
	              { style: styles.h3 },
	              "Advanced options"
	            ),
	            _react2.default.createElement(_materialUi.Checkbox, {
	              label: "Show a custom message on tickets purchased with discount",
	              checked: this.state.showTicketMessageEditor || this.state.values.result.ticket_message,
	              onCheck: function onCheck(e, checked) {
	                return _this2.setState({ showTicketMessageEditor: checked }, function () {
	                  return _this2.onChangeValue("result.ticket_message", null);
	                });
	              },
	              disabled: !_UserStore2.default.hasPermission("edit_coupon")
	            }),
	            this.state.showTicketMessageEditor || this.state.values.result.ticket_message ? _react2.default.createElement(_materialUi.TextField, {
	              value: (0, _get2.default)(this.state, "values.result.ticket_message", ""),
	              placeholder: "Custom message",
	              style: { marginLeft: "2.5em" },
	              onChange: function onChange(e) {
	                var v = e.target.value;
	                _this2.setState({ showTicketMessageEditor: true }, function () {
	                  return _this2.onChangeValue("result.ticket_message", v);
	                });
	              }
	            }) : null
	          )
	        ),
	        _UserStore2.default.hasPermission("edit_coupon") ? _react2.default.createElement(
	          "div",
	          { style: styles.actions },
	          saveButton,
	          _react2.default.createElement(_materialUi.RaisedButton, {
	            label: "Delete discount",
	            onClick: this.delete,
	            style: { marginLeft: 7 }
	          })
	        ) : null
	      );
	    }
	  }], [{
	    key: "getStores",
	    value: function getStores() {
	      return [_CouponStore2.default, _EventBucketStore2.default, _UserStore2.default];
	    }
	  }, {
	    key: "getPropsFromStores",
	    value: function getPropsFromStores() {
	      return {
	        getCouponById: _CouponStore2.default.getCouponById
	      };
	    }
	  }, {
	    key: "contextTypes",
	    get: function get() {
	      return {
	        router: _react2.default.PropTypes.object
	      };
	    }
	  }]);
	
	  return Coupon;
	}(_react2.default.Component);
	
	exports.default = (0, _connectToStores2.default)(Coupon);
	module.exports = exports["default"];

/***/ }),
/* 2766 */
/***/ (function(module, exports) {

	/**
	 * just namespace
	 * @type {[type]}
	 */
	var just = just || {};
	
	/**
	 * Random string generator
	 *
	 * can be used on node.js or client side
	 *
	 * type can be numbers, uppercases, lowercases or combination
	 * of those separated with _
	 *
	 * examples:
	 * var rs = randomstring(); // returns "ElZOtlOSLn49GeKLev2O"
	 * var rs = randomstring(20, 'numbers'); // returns "78394850802905961074"
	 * var rs = randomstring(15, 'numbers_uppercases'); // returns "PXL3AE2USI7ZDQ2"
	 * 
	 * @param  {int} len length of generated string
	 * @param  {string} type type of charachters in string
	 * @return {string}
	 */
	just.randomstring = function (len, type) {
	
	    len = len || 20;
	    type = type || 'numbers_uppercases_lowercases';
	
	    var strings = {
	            numbers: '0123456789',
	            uppercases: 'ABCDEFGHIJKLMNOPQRSTUVWXYZ',
	            lowercases: 'abcdefghiklmnopqrstuvwxyz'
	        },
	        choise = '',
	        ret = '',
	        types = type.split('_'),
	        i;
	
	    for (i = 0; i < types.length; i++) {
	        if (strings[types[i]]) {
	            choise += strings[types[i]];
	        }
	    }
	
	    if (!choise) {
	        choise = strings.numbers + strings.lowercases + strings.uppercases;
	    }
	
	    for (i = 0; i < len; i++) {
	        ret +=  choise[Math.floor(Math.random() * choise.length)];
	    }
	
	    return ret;
	
	};
	
	/**
	 * Return array of random strings
	 *
	 * first param is length of array, other params are the 
	 * same as for randomstring(len, type)
	 * 
	 * @param  {int} arrayLen
	 * @param  {int} len
	 * @param  {string} type
	 * @return {array}
	 */
	just.randomstring.array = function (arrayLen, len, type) {
	
	    arrayLen = arrayLen || 5;
	
	    var ret = [],
	        i;
	
	    for (i = 0; i < arrayLen; i++) {
	        ret.push(this(len, type));
	    }
	
	    return ret;
	
	};
	
	if (typeof module !== 'undefined' && module.exports) {
	    module.exports = just.randomstring;
	}

/***/ }),
/* 2767 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _connectToStores = __webpack_require__(1226);
	
	var _connectToStores2 = _interopRequireDefault(_connectToStores);
	
	var _CouponActions = __webpack_require__(2041);
	
	var _CouponActions2 = _interopRequireDefault(_CouponActions);
	
	var _CouponStore = __webpack_require__(2042);
	
	var _CouponStore2 = _interopRequireDefault(_CouponStore);
	
	var _workingIndicator = __webpack_require__(1664);
	
	var _workingIndicator2 = _interopRequireDefault(_workingIndicator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var NewCoupon = function (_React$Component) {
	  _inherits(NewCoupon, _React$Component);
	
	  function NewCoupon(props) {
	    _classCallCheck(this, NewCoupon);
	
	    return _possibleConstructorReturn(this, Object.getPrototypeOf(NewCoupon).call(this, props));
	  }
	
	  _createClass(NewCoupon, [{
	    key: "componentWillMount",
	    value: function componentWillMount() {
	      _CouponActions2.default.create({
	        name: "Unnamed Discount",
	        event_bucket: this.props.params.eventBucketId
	      });
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(props) {
	      if (props.newCouponId) {
	        this.context.router.replace("/event_buckets/" + props.params.eventBucketId + "/coupons/" + props.newCouponId + "/edit");
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement(_workingIndicator2.default, { fullPage: true });
	    }
	  }], [{
	    key: "getStores",
	    value: function getStores() {
	      return [_CouponStore2.default];
	    }
	  }, {
	    key: "getPropsFromStores",
	    value: function getPropsFromStores() {
	      return {
	        newCouponId: _CouponStore2.default.getState().newCouponId
	      };
	    }
	  }, {
	    key: "contextTypes",
	    get: function get() {
	      return {
	        router: _react2.default.PropTypes.object
	      };
	    }
	  }]);
	
	  return NewCoupon;
	}(_react2.default.Component);
	
	exports.default = (0, _connectToStores2.default)(NewCoupon);
	module.exports = exports["default"];

/***/ }),
/* 2768 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _values = __webpack_require__(1214);
	
	var _values2 = _interopRequireDefault(_values);
	
	var _pickBy = __webpack_require__(1163);
	
	var _pickBy2 = _interopRequireDefault(_pickBy);
	
	var _reactRouter = __webpack_require__(486);
	
	var _materialUi = __webpack_require__(576);
	
	var _reactable = __webpack_require__(1688);
	
	var _connectToStores = __webpack_require__(1226);
	
	var _connectToStores2 = _interopRequireDefault(_connectToStores);
	
	var _VenueActions = __webpack_require__(2035);
	
	var _VenueActions2 = _interopRequireDefault(_VenueActions);
	
	var _VenueStore = __webpack_require__(2036);
	
	var _VenueStore2 = _interopRequireDefault(_VenueStore);
	
	var _workingIndicator = __webpack_require__(1664);
	
	var _workingIndicator2 = _interopRequireDefault(_workingIndicator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Venues = function (_React$Component) {
	  _inherits(Venues, _React$Component);
	
	  function Venues(props) {
	    _classCallCheck(this, Venues);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(Venues).call(this, props));
	
	    _this._makeRowForVenue = _this._makeRowForVenue.bind(_this);
	    return _this;
	  }
	
	  _createClass(Venues, [{
	    key: "getStyles",
	    value: function getStyles() {
	      return {};
	    }
	  }, {
	    key: "_makeRowForVenue",
	    value: function _makeRowForVenue(venue) {
	      return {
	        Name: venue.name,
	        "Tag Color": venue.color && _react2.default.createElement("div", { style: { width: 12, height: 12, backgroundColor: venue.color } }),
	        Actions: _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement(
	            _reactRouter.Link,
	            {
	              to: {
	                pathname: "/event_buckets/" + this.props.params.eventBucketId + "/venues/" + venue.id,
	                state: { fromListing: true }
	              }
	            },
	            "View"
	          ),
	          "\xA0",
	          _react2.default.createElement(
	            _reactRouter.Link,
	            {
	              to: {
	                pathname: "/event_buckets/" + this.props.params.eventBucketId + "/venues/" + venue.id + "/edit",
	                state: { fromListing: true }
	              }
	            },
	            "Edit"
	          )
	        )
	      };
	    }
	  }, {
	    key: "componentWillMount",
	    value: function componentWillMount() {
	      _VenueActions2.default.fetchAllForBucket(this.props.params.eventBucketId);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var styles = this.getStyles(),
	          bucket = this.props.params.eventBucketId,
	          venues = (0, _values2.default)((0, _pickBy2.default)(this.props.venues, function (c) {
	        return c.event_bucket === bucket;
	      })),
	          rows = venues.map(this._makeRowForVenue);
	
	      if (venues.length === 0 && _VenueStore2.default.getState().isFetching) {
	        return _react2.default.createElement(_workingIndicator2.default, { fullPage: true });
	      }
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          "h1",
	          { className: "page-title" },
	          "Venues"
	        ),
	        _react2.default.createElement(_reactable.Table, {
	          className: "bordered striped responsive-table",
	          data: rows,
	          sortable: [{ column: "Name", sortFunction: _reactable.Sort.CaseInsensitive }],
	          defaultSort: { column: "Name", direction: "asc" },
	          columns: ["Name", "Tag Color", "Actions"],
	          filterable: ["Name"],
	          filterPlaceholder: "Type to filter..."
	        }),
	        rows.length === 0 ? _react2.default.createElement(
	          "div",
	          { className: "empty-table-message" },
	          "No venues yet.",
	          " ",
	          _react2.default.createElement(
	            _reactRouter.Link,
	            { to: "/event_buckets/" + bucket + "/venues/new" },
	            "Create a new venue."
	          )
	        ) : null,
	        _react2.default.createElement(
	          "div",
	          { style: { marginTop: 20 } },
	          _react2.default.createElement(_materialUi.RaisedButton, {
	            label: "Create new venue",
	            primary: true,
	            onTouchTap: function onTouchTap() {
	              return _this2.context.router.push("/event_buckets/" + _this2.props.params.eventBucketId + "/venues/new");
	            }
	          })
	        )
	      );
	    }
	  }], [{
	    key: "getStores",
	    value: function getStores() {
	      return [_VenueStore2.default];
	    }
	  }, {
	    key: "getPropsFromStores",
	    value: function getPropsFromStores() {
	      return _VenueStore2.default.getState();
	    }
	  }, {
	    key: "contextTypes",
	    get: function get() {
	      return {
	        router: _react2.default.PropTypes.object
	      };
	    }
	  }]);
	
	  return Venues;
	}(_react2.default.Component);
	
	exports.default = (0, _connectToStores2.default)(Venues);
	module.exports = exports["default"];

/***/ }),
/* 2769 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _materialUi = __webpack_require__(576);
	
	var _eventTable = __webpack_require__(2680);
	
	var _eventTable2 = _interopRequireDefault(_eventTable);
	
	var _tagPreview = __webpack_require__(2770);
	
	var _tagPreview2 = _interopRequireDefault(_tagPreview);
	
	var _workingIndicator = __webpack_require__(1664);
	
	var _workingIndicator2 = _interopRequireDefault(_workingIndicator);
	
	var _backButton = __webpack_require__(1872);
	
	var _backButton2 = _interopRequireDefault(_backButton);
	
	var _connectToStores = __webpack_require__(1226);
	
	var _connectToStores2 = _interopRequireDefault(_connectToStores);
	
	var _VenueActions = __webpack_require__(2035);
	
	var _VenueActions2 = _interopRequireDefault(_VenueActions);
	
	var _VenueStore = __webpack_require__(2036);
	
	var _VenueStore2 = _interopRequireDefault(_VenueStore);
	
	var _EventActions = __webpack_require__(2031);
	
	var _EventActions2 = _interopRequireDefault(_EventActions);
	
	var _EventStore = __webpack_require__(2032);
	
	var _EventStore2 = _interopRequireDefault(_EventStore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Venue = function (_React$Component) {
	  _inherits(Venue, _React$Component);
	
	  function Venue(props) {
	    _classCallCheck(this, Venue);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(Venue).call(this, props));
	
	    _this.state = {
	      venue: null,
	      events: [],
	      isFetchingVenue: false,
	      fetchedVenue: null,
	      showScanCounts: false
	    };
	
	    _this._onShowScanCountsCheck = _this._onShowScanCountsCheck.bind(_this);
	    _this._onRefresh = _this._onRefresh.bind(_this);
	    return _this;
	  }
	
	  _createClass(Venue, [{
	    key: "_onShowScanCountsCheck",
	    value: function _onShowScanCountsCheck(checked) {
	      this.setState({ showScanCounts: checked });
	      _EventActions2.default.fetchAllForVenueInBucket(this.props.params.venueId, this.props.params.eventBucketId,
	      /* includeScanCounts */checked);
	    }
	  }, {
	    key: "_onRefresh",
	    value: function _onRefresh() {
	      _EventActions2.default.fetchAllForVenueInBucket(this.props.params.venueId, this.props.params.eventBucketId,
	      /* includeScanCounts */this.state.showScanCounts);
	    }
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.componentWillReceiveProps(this.props);
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(newProps) {
	      var _this2 = this;
	
	      var venue = newProps.getVenueById(newProps.params.venueId),
	          events = newProps.getEventsForVenue(newProps.params.venueId);
	
	      if (!this.state.isFetchingVenue && this.state.fetchedVenue !== newProps.params.venueId) {
	        setTimeout(function () {
	          _VenueActions2.default.fetchOne(newProps.params.venueId);
	          _EventActions2.default.fetchAllForVenueInBucket(newProps.params.venueId, newProps.params.eventBucketId,
	          /* includeScanCounts */_this2.state.showScanCounts);
	        }, 0);
	        this.setState({ isFetchingVenue: true });
	      } else if (venue && events) {
	        this.setState({ isFetchingVenue: false, fetchedVenue: venue.id });
	      }
	
	      this.setState({ venue: venue, events: events });
	    }
	  }, {
	    key: "getStyles",
	    value: function getStyles() {
	      return {
	        button: {
	          marginLeft: 7
	        },
	        h2: {
	          marginTop: 20,
	          marginBottom: 10
	        }
	      };
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this3 = this;
	
	      var styles = this.getStyles();
	
	      if (!this.state.venue) {
	        return _react2.default.createElement(_workingIndicator2.default, { fullPage: true });
	      }
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          "div",
	          { style: { marginBottom: 20 } },
	          _react2.default.createElement(_backButton2.default, {
	            label: "venues",
	            onTouchTap: function onTouchTap() {
	              return _this3.props.location.state && _this3.props.location.state.fromListing ? _this3.context.router.goBack() : _this3.context.router.push("/event_buckets/" + _this3.props.params.eventBucketId + "/venues");
	            }
	          }),
	          _react2.default.createElement(_materialUi.RaisedButton, {
	            label: "Edit venue",
	            onTouchTap: function onTouchTap() {
	              return _this3.context.router.push("/event_buckets/" + _this3.props.params.eventBucketId + "/venues/" + _this3.props.params.venueId + "/edit");
	            },
	            style: styles.button
	          })
	        ),
	        _react2.default.createElement(
	          "h1",
	          null,
	          this.state.venue.name
	        ),
	        _react2.default.createElement(
	          "div",
	          null,
	          this.state.venue.description ? _react2.default.createElement(
	            "div",
	            null,
	            this.state.venue.description
	          ) : null,
	          this.state.venue.address ? _react2.default.createElement(
	            "div",
	            null,
	            this.state.venue.address
	          ) : null,
	          this.state.venue.default_capacity ? _react2.default.createElement(
	            "div",
	            null,
	            "Default capacity: ",
	            this.state.venue.default_capacity
	          ) : null,
	          this.state.venue.use_reserved_seating ? _react2.default.createElement(
	            "div",
	            null,
	            "Reserved seating mode"
	          ) : null,
	          this.state.venue.color ? _react2.default.createElement(
	            "span",
	            null,
	            "Tag preview:",
	            " ",
	            _react2.default.createElement(_tagPreview2.default, {
	              label: this.state.venue.short_name || this.state.venue.name,
	              color: this.state.venue.color
	            })
	          ) : null
	        ),
	        _react2.default.createElement(
	          "h2",
	          { style: styles.h2 },
	          "Events at venue"
	        ),
	        _react2.default.createElement(_eventTable2.default, {
	          eventBucket: this.props.params.eventBucketId,
	          events: this.state.events,
	          onShowScanCountsCheck: this._onShowScanCountsCheck,
	          onRefresh: this._onRefresh,
	          isRefreshing: this.props.isFetchingEvents,
	          headerStyle: { textAlign: "left" }
	        })
	      );
	    }
	  }], [{
	    key: "getStores",
	    value: function getStores() {
	      return [_VenueStore2.default, _EventStore2.default];
	    }
	  }, {
	    key: "getPropsFromStores",
	    value: function getPropsFromStores() {
	      return {
	        getVenueById: _VenueStore2.default.getVenueById,
	        getEventsForVenue: _EventStore2.default.getEventsForVenue,
	        isFetchingEvents: _EventStore2.default.getState().isFetching
	      };
	    }
	  }, {
	    key: "contextTypes",
	    get: function get() {
	      return {
	        router: _react2.default.PropTypes.object
	      };
	    }
	  }]);
	
	  return Venue;
	}(_react2.default.Component);
	
	exports.default = (0, _connectToStores2.default)(Venue);
	module.exports = exports["default"];

/***/ }),
/* 2770 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var TAG_STYLE = {
	  fontSize: 12,
	  lineHeight: "1.4",
	  background: "#ccc",
	  display: "inline-block",
	  color: "#000",
	  position: "relative",
	  padding: "3px 6px",
	  marginRight: 7,
	  textDecoration: "none"
	};
	
	var TagPreview = function TagPreview(_ref) {
	  var label = _ref.label;
	  var color = _ref.color;
	
	  return React.createElement(
	    "div",
	    { style: Object.assign({}, TAG_STYLE, { backgroundColor: color }) },
	    label
	  );
	};
	
	exports.default = TagPreview;
	module.exports = exports["default"];

/***/ }),
/* 2771 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _assign = __webpack_require__(920);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _get = __webpack_require__(1004);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _set = __webpack_require__(1188);
	
	var _set2 = _interopRequireDefault(_set);
	
	var _materialUi = __webpack_require__(576);
	
	var _connectToStores = __webpack_require__(1226);
	
	var _connectToStores2 = _interopRequireDefault(_connectToStores);
	
	var _VenueActions = __webpack_require__(2035);
	
	var _VenueActions2 = _interopRequireDefault(_VenueActions);
	
	var _VenueStore = __webpack_require__(2036);
	
	var _VenueStore2 = _interopRequireDefault(_VenueStore);
	
	var _infoNotice = __webpack_require__(1599);
	
	var _infoNotice2 = _interopRequireDefault(_infoNotice);
	
	var _workingIndicator = __webpack_require__(1664);
	
	var _workingIndicator2 = _interopRequireDefault(_workingIndicator);
	
	var _backButton = __webpack_require__(1872);
	
	var _backButton2 = _interopRequireDefault(_backButton);
	
	var _label = __webpack_require__(1682);
	
	var _label2 = _interopRequireDefault(_label);
	
	var _TagActions = __webpack_require__(2038);
	
	var _TagActions2 = _interopRequireDefault(_TagActions);
	
	var _TagStore = __webpack_require__(2039);
	
	var _TagStore2 = _interopRequireDefault(_TagStore);
	
	var _reactColor = __webpack_require__(2772);
	
	var _tagPreview = __webpack_require__(2770);
	
	var _tagPreview2 = _interopRequireDefault(_tagPreview);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Used for tag colors
	
	
	var Venue = function (_React$Component) {
	  _inherits(Venue, _React$Component);
	
	  function Venue(props) {
	    _classCallCheck(this, Venue);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(Venue).call(this, props));
	
	    _this.state = {
	      venue: null,
	      dirty: false,
	      isFetchingVenue: false,
	      values: {}
	    };
	
	    _this.openSeatmapEditor = _this.openSeatmapEditor.bind(_this);
	    _this.onChange = _this.onChange.bind(_this);
	    _this.onChangeValue = _this.onChangeValue.bind(_this);
	    _this.save = _this.save.bind(_this);
	    _this.delete = _this.delete.bind(_this);
	    return _this;
	  }
	
	  _createClass(Venue, [{
	    key: "openSeatmapEditor",
	    value: function openSeatmapEditor() {
	      // Stage edit
	      var values = (0, _assign2.default)({}, this.state.values);
	      _VenueActions2.default.edit(this.props.params.venueId, values, /* stage */true);
	
	      this.context.router.push("/event_buckets/" + this.props.params.eventBucketId + "/venues/" + this.props.params.venueId + "/edit/seatmap");
	    }
	  }, {
	    key: "getStyles",
	    value: function getStyles() {
	      return {
	        checkboxWrapper: {
	          margin: "20px 0"
	        },
	        actions: {
	          marginTop: 40
	        },
	        h3: {
	          marginTop: 30,
	          marginBottom: 10
	        }
	      };
	    }
	  }, {
	    key: "onChange",
	    value: function onChange(id, e, checked) {
	      this.onChangeValue(id, typeof checked !== "undefined" ? !(0, _get2.default)(this.state.values, id) : e.target.value);
	    }
	  }, {
	    key: "onChangeValue",
	    value: function onChangeValue(id, value) {
	      this.state.dirty = true;
	      (0, _set2.default)(this.state.values, id, value);
	      this.setState(this.state);
	    }
	  }, {
	    key: "save",
	    value: function save() {
	      var values = (0, _assign2.default)({}, this.state.values);
	      _VenueActions2.default.edit(this.props.params.venueId, values);
	      window.scrollTo(0, 0);
	    }
	  }, {
	    key: "delete",
	    value: function _delete() {
	      var bucket = this.state.venue.event_bucket;
	      if (window.confirm("Are you sure?")) {
	        _VenueActions2.default.delete(this.props.params.venueId);
	        this.context.router.push("/event_buckets/" + bucket + "/venues");
	      }
	    }
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      this.context.router.setRouteLeaveHook(this.props.route, function () {
	        if (_this2.state.dirty) {
	          return "Are you sure you wish to leave the venue editor? Your changes will not be saved.";
	        }
	      });
	
	      _TagActions2.default.fetchPresetColors(); // used in colorpicker
	      this.componentWillReceiveProps(this.props);
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(newProps) {
	      // Scroll to top on save to show loader
	      if (newProps.isSaving) {
	        window.scrollTo(0, 0);
	      }
	
	      var venue = newProps.getVenueById(newProps.params.venueId);
	
	      if (!this.state.isFetchingVenue && !venue) {
	        _VenueActions2.default.fetchOne(newProps.params.venueId);
	        this.setState({ isFetchingVenue: true });
	      } else if (venue) {
	        this.setState({ isFetchingVenue: false });
	      }
	
	      this.setState({
	        venue: venue,
	        dirty: false,
	        values: venue ? {
	          name: venue.name || "",
	          short_name: venue.short_name || "",
	          description: venue.description || "",
	          address: venue.address || "",
	          default_capacity: venue.default_capacity || "",
	          color: venue.color || "",
	          use_reserved_seating: venue.use_reserved_seating,
	          seatmap_id: venue.seatmap_id
	        } : {}
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this3 = this;
	
	      var styles = this.getStyles();
	
	      if (!this.state.venue || this.props.isSaving) {
	        return _react2.default.createElement(_workingIndicator2.default, { fullPage: true });
	      }
	
	      var saveButton = _react2.default.createElement(_materialUi.RaisedButton, {
	        label: this.state.dirty ? "Save changes" : "No changes to save",
	        primary: true,
	        disabled: !this.state.dirty,
	        onTouchTap: this.save
	      });
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        this.props.children /* for seatmap modal */,
	        _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement(_backButton2.default, {
	            label: this.props.location.state && this.props.location.state.fromListing ? "venues" : "venue",
	            style: { marginRight: 7 },
	            onTouchTap: function onTouchTap() {
	              return _this3.props.location.state && _this3.props.location.state.fromListing ? _this3.context.router.goBack() : _this3.context.router.push("/event_buckets/" + _this3.props.params.eventBucketId + "/venues/" + _this3.props.params.venueId);
	            }
	          }),
	          saveButton
	        ),
	        _react2.default.createElement(
	          _infoNotice2.default,
	          { style: { marginTop: 20 } },
	          "Check out our",
	          " ",
	          _react2.default.createElement(
	            "a",
	            {
	              href: "http://help.eventive.org/events-and-tickets/create-venues",
	              target: "_blank"
	            },
	            "guide to creating venues"
	          ),
	          "."
	        ),
	        _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(_materialUi.TextField, {
	              value: (0, _get2.default)(this.state, "values.name", ""),
	              floatingLabelText: "Name",
	              floatingLabelFixed: true,
	              onChange: function onChange(e) {
	                return _this3.onChangeValue("name", e.target.value);
	              }
	            })
	          ),
	          _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(_materialUi.TextField, {
	              value: (0, _get2.default)(this.state, "values.short_name", ""),
	              floatingLabelText: "Short name (used in tags/filters)",
	              floatingLabelFixed: true,
	              onChange: function onChange(e) {
	                return _this3.onChangeValue("short_name", e.target.value);
	              }
	            })
	          ),
	          _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(_materialUi.TextField, {
	              multiLine: true,
	              value: (0, _get2.default)(this.state, "values.description", ""),
	              floatingLabelText: "Description",
	              floatingLabelFixed: true,
	              onChange: function onChange(e) {
	                return _this3.onChangeValue("description", e.target.value);
	              }
	            })
	          ),
	          _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(_materialUi.TextField, {
	              multiLine: true,
	              rows: 2,
	              value: (0, _get2.default)(this.state, "values.address", ""),
	              floatingLabelText: "Address",
	              floatingLabelFixed: true,
	              onChange: function onChange(e) {
	                return _this3.onChangeValue("address", e.target.value);
	              }
	            })
	          ),
	          _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(
	              _label2.default,
	              null,
	              "Seating"
	            ),
	            _react2.default.createElement(
	              _materialUi.RadioButtonGroup,
	              {
	                name: "venue_type",
	                valueSelected: this.state.values.use_reserved_seating,
	                onChange: function onChange(e, v) {
	                  return _this3.onChangeValue("use_reserved_seating", v);
	                }
	              },
	              _react2.default.createElement(_materialUi.RadioButton, { value: false, label: "Open seating" }),
	              _react2.default.createElement(_materialUi.RadioButton, { value: true, label: "Reserved seating" })
	            ),
	            this.state.values.use_reserved_seating ? this.state.values.seatmap_id ? _react2.default.createElement(
	              "div",
	              { style: { marginTop: 10 } },
	              _react2.default.createElement("img", {
	                src: this.state.venue.seatmap_preview_image + "?_=" + Date.now(),
	                style: {
	                  display: "block",
	                  width: 175,
	                  border: "1px solid #ccc",
	                  padding: 5,
	                  marginBottom: "1em"
	                }
	              }),
	              _react2.default.createElement(_materialUi.RaisedButton, {
	                label: "Edit seatmap",
	                onTouchTap: function onTouchTap() {
	                  return _this3.openSeatmapEditor();
	                },
	                style: { marginRight: 7 }
	              }),
	              _react2.default.createElement(_materialUi.FlatButton, {
	                label: "Reset",
	                onTouchTap: function onTouchTap() {
	                  if (window.confirm("Are you sure? This will delete your current seatmap permanently. All reservations will be lost. Are you sure you don't just want to make a new venue instead?")) {
	                    _this3.onChangeValue("seatmap_id", null);
	                    _this3.save();
	                  }
	                }
	              })
	            ) : _react2.default.createElement(
	              "div",
	              { style: { marginTop: 10 } },
	              _react2.default.createElement(_materialUi.RaisedButton, {
	                label: "Create seatmap",
	                primary: true,
	                style: { marginRight: 7 },
	                onTouchTap: function onTouchTap() {
	                  return _this3.openSeatmapEditor();
	                }
	              })
	            ) : _react2.default.createElement(_materialUi.TextField, {
	              value: (0, _get2.default)(this.state, "values.default_capacity", ""),
	              floatingLabelText: "Default capacity",
	              floatingLabelFixed: true,
	              placeholder: "0",
	              onChange: function onChange(e) {
	                return _this3.onChangeValue("default_capacity", e.target.value);
	              }
	            })
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { style: { marginTop: 20 } },
	          _react2.default.createElement(
	            _label2.default,
	            null,
	            "Tag color"
	          ),
	          _react2.default.createElement(_tagPreview2.default, {
	            label: this.state.values.short_name || this.state.values.name,
	            color: this.state.values.color
	          }),
	          _react2.default.createElement(
	            "div",
	            { style: { marginTop: 10 } },
	            _react2.default.createElement(_reactColor.SketchPicker, {
	              color: this.state.values.color,
	              presetColors: this.props.presetColors,
	              disableAlpha: true,
	              onChange: function onChange(color) {
	                return _this3.onChangeValue("color", color.hex);
	              }
	            })
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { style: styles.actions },
	          saveButton,
	          _react2.default.createElement(_materialUi.RaisedButton, {
	            label: "Delete venue",
	            onTouchTap: this.delete,
	            style: { marginLeft: 7 }
	          })
	        )
	      );
	    }
	  }], [{
	    key: "getStores",
	    value: function getStores() {
	      return [_VenueStore2.default, _TagStore2.default];
	    }
	  }, {
	    key: "getPropsFromStores",
	    value: function getPropsFromStores() {
	      return {
	        getVenueById: _VenueStore2.default.getVenueById,
	        isSaving: _VenueStore2.default.getState().isSaving,
	        presetColors: _TagStore2.default.getState().presetColors
	      };
	    }
	  }, {
	    key: "contextTypes",
	    get: function get() {
	      return {
	        router: _react2.default.PropTypes.object
	      };
	    }
	  }]);
	
	  return Venue;
	}(_react2.default.Component);
	
	exports.default = (0, _connectToStores2.default)(Venue);
	module.exports = exports["default"];

/***/ }),
/* 2772 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.CustomPicker = exports.SwatchesPicker = exports.SliderPicker = exports.SketchPicker = exports.PhotoshopPicker = exports.MaterialPicker = exports.CompactPicker = exports.ChromePicker = undefined;
	
	var _Chrome = __webpack_require__(2773);
	
	Object.defineProperty(exports, 'ChromePicker', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Chrome).default;
	  }
	});
	
	var _Compact = __webpack_require__(2801);
	
	Object.defineProperty(exports, 'CompactPicker', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Compact).default;
	  }
	});
	
	var _Material = __webpack_require__(2810);
	
	Object.defineProperty(exports, 'MaterialPicker', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Material).default;
	  }
	});
	
	var _Photoshop = __webpack_require__(2811);
	
	Object.defineProperty(exports, 'PhotoshopPicker', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Photoshop).default;
	  }
	});
	
	var _Sketch = __webpack_require__(2815);
	
	Object.defineProperty(exports, 'SketchPicker', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Sketch).default;
	  }
	});
	
	var _Slider = __webpack_require__(2818);
	
	Object.defineProperty(exports, 'SliderPicker', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Slider).default;
	  }
	});
	
	var _Swatches = __webpack_require__(2822);
	
	Object.defineProperty(exports, 'SwatchesPicker', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Swatches).default;
	  }
	});
	
	var _ColorWrap = __webpack_require__(2795);
	
	Object.defineProperty(exports, 'CustomPicker', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ColorWrap).default;
	  }
	});
	
	var _Chrome2 = _interopRequireDefault(_Chrome);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Chrome2.default;

/***/ }),
/* 2773 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Chrome = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(2774);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _common = __webpack_require__(2789);
	
	var _ChromeFields = __webpack_require__(2798);
	
	var _ChromeFields2 = _interopRequireDefault(_ChromeFields);
	
	var _ChromePointer = __webpack_require__(2799);
	
	var _ChromePointer2 = _interopRequireDefault(_ChromePointer);
	
	var _ChromePointerCircle = __webpack_require__(2800);
	
	var _ChromePointerCircle2 = _interopRequireDefault(_ChromePointerCircle);
	
	var _reactAddonsShallowCompare = __webpack_require__(1321);
	
	var _reactAddonsShallowCompare2 = _interopRequireDefault(_reactAddonsShallowCompare);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Chrome = exports.Chrome = function (_React$Component) {
	  _inherits(Chrome, _React$Component);
	
	  function Chrome() {
	    var _Object$getPrototypeO;
	
	    var _temp, _this, _ret;
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _classCallCheck(this, Chrome);
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_Object$getPrototypeO = Object.getPrototypeOf(Chrome)).call.apply(_Object$getPrototypeO, [this].concat(args))), _this), _this.shouldComponentUpdate = _reactAddonsShallowCompare2.default.bind(_this, _this, arguments[0], arguments[1]), _this.handleChange = function (data) {
	      _this.props.onChange(data);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Chrome, [{
	    key: 'render',
	    value: function render() {
	
	      var styles = (0, _reactcss2.default)({
	        'default': {
	          picker: {
	            background: '#fff',
	            borderRadius: '2px',
	            boxShadow: '0 0 2px rgba(0,0,0,.3), 0 4px 8px rgba(0,0,0,.3)',
	            boxSizing: 'initial',
	            width: '225px',
	            fontFamily: 'Menlo'
	          },
	          saturation: {
	            width: '100%',
	            paddingBottom: '55%',
	            position: 'relative',
	            borderRadius: '2px 2px 0 0',
	            overflow: 'hidden'
	          },
	          Saturation: {
	            radius: '2px 2px 0 0'
	          },
	          body: {
	            padding: '16px 16px 12px'
	          },
	          controls: {
	            display: 'flex'
	          },
	          color: {
	            width: '32px'
	          },
	          swatch: {
	            marginTop: '6px',
	            width: '16px',
	            height: '16px',
	            borderRadius: '8px',
	            position: 'relative',
	            overflow: 'hidden'
	          },
	          active: {
	            absolute: '0px 0px 0px 0px',
	            borderRadius: '8px',
	            boxShadow: 'inset 0 0 0 1px rgba(0,0,0,.1)',
	            background: 'rgba(' + this.props.rgb.r + ', ' + this.props.rgb.g + ', ' + this.props.rgb.b + ', ' + this.props.rgb.a + ')',
	            zIndex: '2'
	          },
	          toggles: {
	            flex: '1'
	          },
	          hue: {
	            height: '10px',
	            position: 'relative',
	            marginBottom: '8px'
	          },
	          Hue: {
	            radius: '2px'
	          },
	          alpha: {
	            height: '10px',
	            position: 'relative'
	          },
	          Alpha: {
	            radius: '2px'
	          }
	        },
	        'disableAlpha': {
	          color: {
	            width: '22px'
	          },
	          alpha: {
	            display: 'none'
	          },
	          hue: {
	            marginBottom: '0px'
	          },
	          swatch: {
	            width: '10px',
	            height: '10px',
	            marginTop: '0px'
	          }
	        }
	      }, this.props);
	
	      return _react2.default.createElement(
	        'div',
	        { style: styles.picker },
	        _react2.default.createElement(
	          'div',
	          { style: styles.saturation },
	          _react2.default.createElement(_common.Saturation, _extends({ style: styles.Saturation }, this.props, { pointer: _ChromePointerCircle2.default, onChange: this.handleChange }))
	        ),
	        _react2.default.createElement(
	          'div',
	          { style: styles.body },
	          _react2.default.createElement(
	            'div',
	            { style: styles.controls, className: 'flexbox-fix' },
	            _react2.default.createElement(
	              'div',
	              { style: styles.color },
	              _react2.default.createElement(
	                'div',
	                { style: styles.swatch },
	                _react2.default.createElement('div', { style: styles.active }),
	                _react2.default.createElement(_common.Checkboard, null)
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { style: styles.toggles },
	              _react2.default.createElement(
	                'div',
	                { style: styles.hue },
	                _react2.default.createElement(_common.Hue, _extends({ style: styles.Hue }, this.props, { pointer: _ChromePointer2.default, onChange: this.handleChange }))
	              ),
	              _react2.default.createElement(
	                'div',
	                { style: styles.alpha },
	                _react2.default.createElement(_common.Alpha, _extends({ style: styles.Alpha }, this.props, { pointer: _ChromePointer2.default, onChange: this.handleChange }))
	              )
	            )
	          ),
	          _react2.default.createElement(_ChromeFields2.default, _extends({}, this.props, { onChange: this.handleChange, disableAlpha: this.props.disableAlpha }))
	        )
	      );
	    }
	  }]);
	
	  return Chrome;
	}(_react2.default.Component);
	
	exports.default = (0, _common.ColorWrap)(Chrome);

/***/ }),
/* 2774 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";function _interopRequireDefault(e){return e&&e.__esModule?e:{"default":e}}Object.defineProperty(exports,"__esModule",{value:!0}),exports.ReactCSS=exports.loop=exports.hover=exports.Component=void 0;var _objectAssign=__webpack_require__(302),_objectAssign2=_interopRequireDefault(_objectAssign),_flattenNames=__webpack_require__(2775),_flattenNames2=_interopRequireDefault(_flattenNames),_mergeClasses=__webpack_require__(2776),_mergeClasses2=_interopRequireDefault(_mergeClasses),_autoprefix=__webpack_require__(2777),_autoprefix2=_interopRequireDefault(_autoprefix),_Component2=__webpack_require__(2778),_Component3=_interopRequireDefault(_Component2),_hover2=__webpack_require__(2787),_hover3=_interopRequireDefault(_hover2),_loop2=__webpack_require__(2788),_loop3=_interopRequireDefault(_loop2);exports.Component=_Component3["default"],exports.hover=_hover3["default"],exports.loop=_loop3["default"];var ReactCSS=exports.ReactCSS=function(e){for(var t=arguments.length,o=Array(t>1?t-1:0),r=1;r<t;r++)o[r-1]=arguments[r];var a=(0,_flattenNames2["default"])(o),s=(0,_mergeClasses2["default"])(e,a);return(0,_autoprefix2["default"])(s)};ReactCSS.m=_objectAssign2["default"],exports["default"]=ReactCSS;

/***/ }),
/* 2775 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";function _interopRequireDefault(e){return e&&e.__esModule?e:{"default":e}}Object.defineProperty(exports,"__esModule",{value:!0}),exports.flattenNames=void 0;var _map=__webpack_require__(1377),_map2=_interopRequireDefault(_map),_isPlainObject=__webpack_require__(795),_isPlainObject2=_interopRequireDefault(_isPlainObject),_isString=__webpack_require__(1399),_isString2=_interopRequireDefault(_isString),flattenNames=exports.flattenNames=function e(t){var i=[];return t.map(function(t){return Array.isArray(t)&&e(t).map(function(e){return i.push(e)}),(0,_isPlainObject2["default"])(t)&&(0,_map2["default"])(t,function(e,t){e===!0&&i.push(t),i.push(t+"-"+e)}),(0,_isString2["default"])(t)&&i.push(t),t}),i};exports["default"]=flattenNames;

/***/ }),
/* 2776 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";function _interopRequireDefault(e){return e&&e.__esModule?e:{"default":e}}Object.defineProperty(exports,"__esModule",{value:!0}),exports.mergeClasses=void 0;var _map=__webpack_require__(1377),_map2=_interopRequireDefault(_map),_objectAssign=__webpack_require__(302),_objectAssign2=_interopRequireDefault(_objectAssign),mergeClasses=exports.mergeClasses=function(e){var t=arguments.length<=1||void 0===arguments[1]?[]:arguments[1],s=e["default"]&&(0,_objectAssign2["default"])({},e["default"])||{};return t.map(function(t){var r=e[t];return r&&(0,_map2["default"])(r,function(e,t){s[t]||(s[t]={}),(0,_objectAssign2["default"])(s[t],r[t])}),t}),s};exports["default"]=mergeClasses;

/***/ }),
/* 2777 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";function _interopRequireDefault(e){return e&&e.__esModule?e:{"default":e}}Object.defineProperty(exports,"__esModule",{value:!0}),exports.autoprefix=void 0;var _map=__webpack_require__(1377),_map2=_interopRequireDefault(_map),_objectAssign=__webpack_require__(302),_objectAssign2=_interopRequireDefault(_objectAssign),transforms={borderRadius:function(e){return{msBorderRadius:e,MozBorderRadius:e,OBorderRadius:e,WebkitBorderRadius:e,borderRadius:e}},boxShadow:function(e){return{msBoxShadow:e,MozBoxShadow:e,OBoxShadow:e,WebkitBoxShadow:e,boxShadow:e}},userSelect:function(e){return{WebkitTouchCallout:e,KhtmlUserSelect:e,MozUserSelect:e,msUserSelect:e,WebkitUserSelect:e,userSelect:e}},flex:function(e){return{WebkitBoxFlex:e,MozBoxFlex:e,WebkitFlex:e,msFlex:e,flex:e}},flexBasis:function(e){return{WebkitFlexBasis:e,flexBasis:e}},justifyContent:function(e){return{WebkitJustifyContent:e,justifyContent:e}},transition:function(e){return{msTransition:e,MozTransition:e,OTransition:e,WebkitTransition:e,transition:e}},transform:function(e){return{msTransform:e,MozTransform:e,OTransform:e,WebkitTransform:e,transform:e}},absolute:function(e){var t=e&&e.split(" ");return{position:"absolute",top:t&&t[0],right:t&&t[1],bottom:t&&t[2],left:t&&t[3]}},extend:function(e,t){var r=t[e];return r?r:{extend:e}}},autoprefix=exports.autoprefix=function(e){var t={};return(0,_map2["default"])(e,function(e,r){var o={};(0,_map2["default"])(e,function(e,t){var r=transforms[t];r?(0,_objectAssign2["default"])(o,r(e)):o[t]=e}),t[r]=o}),t};exports["default"]=autoprefix;

/***/ }),
/* 2778 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";function _interopRequireDefault(e){return e&&e.__esModule?e:{"default":e}}function _classCallCheck(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function _possibleConstructorReturn(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function _inherits(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(exports,"__esModule",{value:!0}),exports.ReactCSSComponent=void 0;var _createClass=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),_react=__webpack_require__(300),_react2=_interopRequireDefault(_react),_inline=__webpack_require__(2779),_inline2=_interopRequireDefault(_inline),_once=__webpack_require__(2785),_once2=_interopRequireDefault(_once),warning=(0,_once2["default"])(function(){return console.warn("Extending ReactCSS.Component\n  is deprecated in ReactCSS 1.0.0")}),ReactCSSComponent=exports.ReactCSSComponent=function(e){function t(){return _classCallCheck(this,t),_possibleConstructorReturn(this,Object.getPrototypeOf(t).apply(this,arguments))}return _inherits(t,e),_createClass(t,[{key:"css",value:function(e){return warning(),_inline2["default"].call(this,e)}},{key:"styles",value:function(){return this.css()}}]),t}(_react2["default"].Component);ReactCSSComponent.contextTypes={mixins:_react2["default"].PropTypes.object},exports["default"]=ReactCSSComponent;

/***/ }),
/* 2779 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";function _interopRequireDefault(e){return e&&e.__esModule?e:{"default":e}}var _isObject=__webpack_require__(643),_isObject2=_interopRequireDefault(_isObject),_checkClassStructure=__webpack_require__(2780),_checkClassStructure2=_interopRequireDefault(_checkClassStructure),_combine=__webpack_require__(2781),_combine2=_interopRequireDefault(_combine);module.exports=function(e){var s=this,t=[];if(!this.classes)throw console.warn("Define this.classes on `"+this.constructor.name+"`");(0,_checkClassStructure2["default"])(this.classes());var r=function(e,r){s.classes()[e]?t.push(s.classes()[e]):e&&r&&r.warn===!0&&console.warn("The `"+e+"` css class does not exist on `"+s.constructor.name+"`")};r("default");for(var i in this.props){var c=this.props[i];(0,_isObject2["default"])(c)||(c===!0?(r(i),r(i+"-true")):r(c?i+"-"+c:i+"-false"))}if(this.props&&this.props.activeBounds)for(var o=0;o<this.props.activeBounds.length;o++){var n=this.props.activeBounds[o];r(n)}for(var a in e){var u=e[a];u===!0&&r(a,{warn:!0})}var l={};return this.context&&this.context.mixins&&(l=this.context.mixins),(0,_combine2["default"])(t,l)};

/***/ }),
/* 2780 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";function _interopRequireDefault(e){return e&&e.__esModule?e:{"default":e}}Object.defineProperty(exports,"__esModule",{value:!0}),exports.checkClassStructure=void 0;var _map=__webpack_require__(1377),_map2=_interopRequireDefault(_map),_isObject=__webpack_require__(643),_isObject2=_interopRequireDefault(_isObject),checkClassStructure=exports.checkClassStructure=function(e){(0,_map2["default"])(e,function(t,s){e.hasOwnProperty(s)&&((0,_isObject2["default"])(t)?(0,_map2["default"])(t,function(e,u){t.hasOwnProperty(u)&&((0,_isObject2["default"])(e)||console.warn("Make sure the value of the element `"+s+"`\n                is an object of css. You passed it `"+t+"`"))}):console.warn("Make sure the value of `"+s+"` is an object of\n          html elements. You passed it `"+t+"`"))})};exports["default"]=checkClassStructure;

/***/ }),
/* 2781 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";function _interopRequireDefault(e){return e&&e.__esModule?e:{"default":e}}Object.defineProperty(exports,"__esModule",{value:!0}),exports.combine=void 0;var _merge=__webpack_require__(2782),_merge2=_interopRequireDefault(_merge),_transformMixins=__webpack_require__(2784),_transformMixins2=_interopRequireDefault(_transformMixins),combine=exports.combine=function(e,r){var i=(0,_merge2["default"])(e);return(0,_transformMixins2["default"])(i,r)};exports["default"]=combine;

/***/ }),
/* 2782 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";function _interopRequireDefault(e){return e&&e.__esModule?e:{"default":e}}Object.defineProperty(exports,"__esModule",{value:!0});var _merge=__webpack_require__(2783),_merge2=_interopRequireDefault(_merge),_isObject=__webpack_require__(643),_isObject2=_interopRequireDefault(_isObject),merge=function(e){return(0,_isObject2["default"])(e)&&!Array.isArray(e)?e:1===e.length?e[0]:_merge2["default"].recursive.apply(void 0,e)};exports["default"]=merge;

/***/ }),
/* 2783 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {/*!
	 * @name JavaScript/NodeJS Merge v1.2.1
	 * @author yeikos
	 * @repository https://github.com/yeikos/js.merge
	
	 * Copyright 2014 yeikos - MIT license
	 * https://raw.github.com/yeikos/js.merge/master/LICENSE
	 */
	
	;(function(isNode) {
	
		/**
		 * Merge one or more objects 
		 * @param bool? clone
		 * @param mixed,... arguments
		 * @return object
		 */
	
		var Public = function(clone) {
	
			return merge(clone === true, false, arguments);
	
		}, publicName = 'merge';
	
		/**
		 * Merge two or more objects recursively 
		 * @param bool? clone
		 * @param mixed,... arguments
		 * @return object
		 */
	
		Public.recursive = function(clone) {
	
			return merge(clone === true, true, arguments);
	
		};
	
		/**
		 * Clone the input removing any reference
		 * @param mixed input
		 * @return mixed
		 */
	
		Public.clone = function(input) {
	
			var output = input,
				type = typeOf(input),
				index, size;
	
			if (type === 'array') {
	
				output = [];
				size = input.length;
	
				for (index=0;index<size;++index)
	
					output[index] = Public.clone(input[index]);
	
			} else if (type === 'object') {
	
				output = {};
	
				for (index in input)
	
					output[index] = Public.clone(input[index]);
	
			}
	
			return output;
	
		};
	
		/**
		 * Merge two objects recursively
		 * @param mixed input
		 * @param mixed extend
		 * @return mixed
		 */
	
		function merge_recursive(base, extend) {
	
			if (typeOf(base) !== 'object')
	
				return extend;
	
			for (var key in extend) {
	
				if (typeOf(base[key]) === 'object' && typeOf(extend[key]) === 'object') {
	
					base[key] = merge_recursive(base[key], extend[key]);
	
				} else {
	
					base[key] = extend[key];
	
				}
	
			}
	
			return base;
	
		}
	
		/**
		 * Merge two or more objects
		 * @param bool clone
		 * @param bool recursive
		 * @param array argv
		 * @return object
		 */
	
		function merge(clone, recursive, argv) {
	
			var result = argv[0],
				size = argv.length;
	
			if (clone || typeOf(result) !== 'object')
	
				result = {};
	
			for (var index=0;index<size;++index) {
	
				var item = argv[index],
	
					type = typeOf(item);
	
				if (type !== 'object') continue;
	
				for (var key in item) {
	
					if (key === '__proto__') continue;
	
					var sitem = clone ? Public.clone(item[key]) : item[key];
	
					if (recursive) {
	
						result[key] = merge_recursive(result[key], sitem);
	
					} else {
	
						result[key] = sitem;
	
					}
	
				}
	
			}
	
			return result;
	
		}
	
		/**
		 * Get type of variable
		 * @param mixed input
		 * @return string
		 *
		 * @see http://jsperf.com/typeofvar
		 */
	
		function typeOf(input) {
	
			return ({}).toString.call(input).slice(8, -1).toLowerCase();
	
		}
	
		if (isNode) {
	
			module.exports = Public;
	
		} else {
	
			window[publicName] = Public;
	
		}
	
	})(typeof module === 'object' && module && typeof module.exports === 'object' && module.exports);
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(485)(module)))

/***/ }),
/* 2784 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";function _interopRequireDefault(e){return e&&e.__esModule?e:{"default":e}}var _isObject=__webpack_require__(643),_isObject2=_interopRequireDefault(_isObject),_merge=__webpack_require__(2783),_merge2=_interopRequireDefault(_merge),localProps={borderRadius:function(e){if(null!==e)return{msBorderRadius:e,MozBorderRadius:e,OBorderRadius:e,WebkitBorderRadius:e,borderRadius:e}},boxShadow:function(e){if(null!==e)return{msBoxShadow:e,MozBoxShadow:e,OBoxShadow:e,WebkitBoxShadow:e,boxShadow:e}},userSelect:function(e){if(null!==e)return{WebkitTouchCallout:e,KhtmlUserSelect:e,MozUserSelect:e,msUserSelect:e,WebkitUserSelect:e,userSelect:e}},flex:function(e){if(null!==e)return{WebkitBoxFlex:e,MozBoxFlex:e,WebkitFlex:e,msFlex:e,flex:e}},flexBasis:function(e){if(null!==e)return{WebkitFlexBasis:e,flexBasis:e}},justifyContent:function(e){if(null!==e)return{WebkitJustifyContent:e,justifyContent:e}},transition:function(e){if(null!==e)return{msTransition:e,MozTransition:e,OTransition:e,WebkitTransition:e,transition:e}},transform:function(e){if(null!==e)return{msTransform:e,MozTransform:e,OTransform:e,WebkitTransform:e,transform:e}},Absolute:function(e){if(null!==e){var r=e.split(" ");return{position:"absolute",top:r[0],right:r[1],bottom:r[2],left:r[3]}}},Extend:function(e,r){var t=r[e];if(t)return t}},transform=function e(r,t,n){var i=(0,_merge2["default"])(t,localProps),o={};for(var u in r){var s=r[u];if((0,_isObject2["default"])(s)&&!Array.isArray(s))o[u]=e(s,t,r);else if(i[u]){var l=i[u](s,n);for(var a in l){var f=l[a];o[a]=f}}else o[u]=s}return o};module.exports=function(e,r,t){return transform(e,r,t)};

/***/ }),
/* 2785 */
/***/ (function(module, exports, __webpack_require__) {

	var before = __webpack_require__(2786);
	
	/**
	 * Creates a function that is restricted to invoking `func` once. Repeat calls
	 * to the function return the value of the first invocation. The `func` is
	 * invoked with the `this` binding and arguments of the created function.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to restrict.
	 * @returns {Function} Returns the new restricted function.
	 * @example
	 *
	 * var initialize = _.once(createApplication);
	 * initialize();
	 * initialize();
	 * // => `createApplication` is invoked once
	 */
	function once(func) {
	  return before(2, func);
	}
	
	module.exports = once;


/***/ }),
/* 2786 */
/***/ (function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(1393);
	
	/** Error message constants. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/**
	 * Creates a function that invokes `func`, with the `this` binding and arguments
	 * of the created function, while it's called less than `n` times. Subsequent
	 * calls to the created function return the result of the last `func` invocation.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Function
	 * @param {number} n The number of calls at which `func` is no longer invoked.
	 * @param {Function} func The function to restrict.
	 * @returns {Function} Returns the new restricted function.
	 * @example
	 *
	 * jQuery(element).on('click', _.before(5, addContactToList));
	 * // => Allows adding up to 4 contacts to the list.
	 */
	function before(n, func) {
	  var result;
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  n = toInteger(n);
	  return function() {
	    if (--n > 0) {
	      result = func.apply(this, arguments);
	    }
	    if (n <= 1) {
	      func = undefined;
	    }
	    return result;
	  };
	}
	
	module.exports = before;


/***/ }),
/* 2787 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";function _interopRequireDefault(e){return e&&e.__esModule?e:{"default":e}}function _classCallCheck(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function _possibleConstructorReturn(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function _inherits(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(exports,"__esModule",{value:!0}),exports.hover=void 0;var _extends=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var r=arguments[t];for(var n in r)Object.prototype.hasOwnProperty.call(r,n)&&(e[n]=r[n])}return e},_createClass=function(){function e(e,t){for(var r=0;r<t.length;r++){var n=t[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(e,n.key,n)}}return function(t,r,n){return r&&e(t.prototype,r),n&&e(t,n),t}}(),_react=__webpack_require__(300),_react2=_interopRequireDefault(_react),hover=exports.hover=function(e){return function(t){function r(){_classCallCheck(this,r);var e=_possibleConstructorReturn(this,Object.getPrototypeOf(r).call(this));return e.handleMouseOver=function(){e.setState({hover:!0})},e.handleMouseOut=function(){e.setState({hover:!1})},e.state={hover:!1},e}return _inherits(r,t),_createClass(r,[{key:"render",value:function(){return _react2["default"].createElement("div",{onMouseOver:this.handleMouseOver,onMouseOut:this.handleMouseOut},_react2["default"].createElement(e,_extends({},this.props,this.state)))}}]),r}(_react2["default"].Component)};exports["default"]=hover;

/***/ }),
/* 2788 */
/***/ (function(module, exports) {

	"use strict";Object.defineProperty(exports,"__esModule",{value:!0});var loopable=function(e,t){var l={},o=function(e){var t=arguments.length<=1||void 0===arguments[1]||arguments[1];l[e]=t};return 0===e&&o("first-child"),e===t-1&&o("last-child"),(0===e||e%2===0)&&o("even"),1===Math.abs(e%2)&&o("odd"),o("nth-child",e),l};exports["default"]=loopable;

/***/ }),
/* 2789 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Alpha = __webpack_require__(2790);
	
	Object.defineProperty(exports, 'Alpha', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Alpha).default;
	  }
	});
	
	var _Checkboard = __webpack_require__(2791);
	
	Object.defineProperty(exports, 'Checkboard', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Checkboard).default;
	  }
	});
	
	var _EditableInput = __webpack_require__(2792);
	
	Object.defineProperty(exports, 'EditableInput', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_EditableInput).default;
	  }
	});
	
	var _Hue = __webpack_require__(2793);
	
	Object.defineProperty(exports, 'Hue', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Hue).default;
	  }
	});
	
	var _Saturation = __webpack_require__(2794);
	
	Object.defineProperty(exports, 'Saturation', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Saturation).default;
	  }
	});
	
	var _ColorWrap = __webpack_require__(2795);
	
	Object.defineProperty(exports, 'ColorWrap', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ColorWrap).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 2790 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Alpha = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(2774);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _reactAddonsShallowCompare = __webpack_require__(1321);
	
	var _reactAddonsShallowCompare2 = _interopRequireDefault(_reactAddonsShallowCompare);
	
	var _Checkboard = __webpack_require__(2791);
	
	var _Checkboard2 = _interopRequireDefault(_Checkboard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Alpha = exports.Alpha = function (_React$Component) {
	  _inherits(Alpha, _React$Component);
	
	  function Alpha() {
	    var _Object$getPrototypeO;
	
	    var _temp, _this, _ret;
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _classCallCheck(this, Alpha);
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_Object$getPrototypeO = Object.getPrototypeOf(Alpha)).call.apply(_Object$getPrototypeO, [this].concat(args))), _this), _this.shouldComponentUpdate = _reactAddonsShallowCompare2.default.bind(_this, _this, arguments[0], arguments[1]), _this.handleChange = function (e, skip) {
	      !skip && e.preventDefault();
	      var container = _this.refs.container;
	      var containerWidth = container.clientWidth;
	      var x = typeof e.pageX === 'number' ? e.pageX : e.touches[0].pageX;
	      var inIFrame = window.self !== window.top || window.document !== container.ownerDocument;
	      var left = x - (container.getBoundingClientRect().left + (inIFrame ? 0 : window.pageXOffset));
	
	      var a;
	      if (left < 0) {
	        a = 0;
	      } else if (left > containerWidth) {
	        a = 1;
	      } else {
	        a = Math.round(left * 100 / containerWidth) / 100;
	      }
	
	      if (_this.props.a !== a) {
	        _this.props.onChange({
	          h: _this.props.hsl.h,
	          s: _this.props.hsl.s,
	          l: _this.props.hsl.l,
	          a: a,
	          source: 'rgb'
	        });
	      }
	    }, _this.handleMouseDown = function (e) {
	      _this.handleChange(e, true);
	      window.addEventListener('mousemove', _this.handleChange);
	      window.addEventListener('mouseup', _this.handleMouseUp);
	    }, _this.handleMouseUp = function () {
	      _this.unbindEventListeners();
	    }, _this.unbindEventListeners = function () {
	      window.removeEventListener('mousemove', _this.handleChange);
	      window.removeEventListener('mouseup', _this.handleMouseUp);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Alpha, [{
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.unbindEventListeners();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	
	      var styles = (0, _reactcss2.default)({
	        'default': {
	          alpha: {
	            absolute: '0px 0px 0px 0px',
	            borderRadius: this.props.radius
	          },
	          checkboard: {
	            absolute: '0px 0px 0px 0px',
	            overflow: 'hidden'
	          },
	          gradient: {
	            absolute: '0px 0px 0px 0px',
	            background: 'linear-gradient(to right, rgba(' + this.props.rgb.r + ', ' + this.props.rgb.g + ', ' + this.props.rgb.b + ', 0) 0%, rgba(' + this.props.rgb.r + ', ' + this.props.rgb.g + ', ' + this.props.rgb.b + ', 1) 100%)',
	            boxShadow: this.props.shadow,
	            borderRadius: this.props.radius
	          },
	          container: {
	            position: 'relative',
	            height: '100%',
	            margin: '0 3px'
	          },
	          pointer: {
	            position: 'absolute',
	            left: this.props.rgb.a * 100 + '%'
	          },
	          slider: {
	            width: '4px',
	            borderRadius: '1px',
	            height: '8px',
	            boxShadow: '0 0 2px rgba(0, 0, 0, .6)',
	            background: '#fff',
	            marginTop: '1px',
	            transform: 'translateX(-2px)'
	          }
	        }
	      });
	
	      var pointer = _react2.default.createElement('div', { style: styles.slider });
	
	      if (this.props.pointer) {
	        pointer = _react2.default.createElement(this.props.pointer, this.props);
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { style: styles.alpha },
	        _react2.default.createElement(
	          'div',
	          { style: styles.checkboard },
	          _react2.default.createElement(_Checkboard2.default, null)
	        ),
	        _react2.default.createElement('div', { style: styles.gradient }),
	        _react2.default.createElement(
	          'div',
	          { style: styles.container, ref: 'container', onMouseDown: this.handleMouseDown,
	            onTouchMove: this.handleChange,
	            onTouchStart: this.handleChange },
	          _react2.default.createElement(
	            'div',
	            { style: styles.pointer, ref: 'pointer' },
	            pointer
	          )
	        )
	      );
	    }
	  }]);
	
	  return Alpha;
	}(_react2.default.Component);
	
	exports.default = Alpha;

/***/ }),
/* 2791 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Checkboard = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(2774);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _reactAddonsShallowCompare = __webpack_require__(1321);
	
	var _reactAddonsShallowCompare2 = _interopRequireDefault(_reactAddonsShallowCompare);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _checkboardCache = {};
	
	function renderCheckboard(c1, c2, size) {
	  if (typeof document == 'undefined') return null; // Dont Render On Server
	  var canvas = document.createElement('canvas');
	  canvas.width = canvas.height = size * 2;
	  var ctx = canvas.getContext('2d');
	  if (!ctx) return null; // If no context can be found, return early.
	  ctx.fillStyle = c1;
	  ctx.fillRect(0, 0, canvas.width, canvas.height);
	  ctx.fillStyle = c2;
	  ctx.fillRect(0, 0, size, size);
	  ctx.translate(size, size);
	  ctx.fillRect(0, 0, size, size);
	  return canvas.toDataURL();
	}
	
	function getCheckboard(c1, c2, size) {
	  var key = c1 + ',' + c2 + ',' + size;
	
	  if (_checkboardCache[key]) {
	    return _checkboardCache[key];
	  } else {
	    var checkboard = renderCheckboard(c1, c2, size);
	    _checkboardCache[key] = checkboard;
	    return checkboard;
	  }
	}
	
	var Checkboard = exports.Checkboard = function (_React$Component) {
	  _inherits(Checkboard, _React$Component);
	
	  function Checkboard() {
	    var _Object$getPrototypeO;
	
	    var _temp, _this, _ret;
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _classCallCheck(this, Checkboard);
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_Object$getPrototypeO = Object.getPrototypeOf(Checkboard)).call.apply(_Object$getPrototypeO, [this].concat(args))), _this), _this.shouldComponentUpdate = _reactAddonsShallowCompare2.default.bind(_this, _this, arguments[0], arguments[1]), _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Checkboard, [{
	    key: 'render',
	    value: function render() {
	
	      var styles = (0, _reactcss2.default)({
	        'default': {
	          grid: {
	            absolute: '0px 0px 0px 0px',
	            background: 'url(' + getCheckboard(this.props.white, this.props.grey, this.props.size) + ') center left'
	          }
	        }
	      });
	
	      return _react2.default.createElement('div', { style: styles.grid, ref: 'grid' });
	    }
	  }]);
	
	  return Checkboard;
	}(_react2.default.Component);
	
	Checkboard.defaultProps = {
	  size: 8,
	  white: '#fff',
	  grey: '#e6e6e6'
	};
	
	exports.default = Checkboard;

/***/ }),
/* 2792 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.EditableInput = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(2774);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _reactAddonsShallowCompare = __webpack_require__(1321);
	
	var _reactAddonsShallowCompare2 = _interopRequireDefault(_reactAddonsShallowCompare);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var EditableInput = exports.EditableInput = function (_React$Component) {
	  _inherits(EditableInput, _React$Component);
	
	  function EditableInput(props) {
	    _classCallCheck(this, EditableInput);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(EditableInput).call(this));
	
	    _this.shouldComponentUpdate = _reactAddonsShallowCompare2.default.bind(_this, _this, arguments[0], arguments[1]);
	
	    _this.handleBlur = function () {
	      if (_this.state.blurValue) {
	        _this.setState({ value: _this.state.blurValue, blurValue: null });
	      }
	    };
	
	    _this.handleChange = function (e) {
	      if (_this.props.label !== null) {
	        var obj = {};
	        obj[_this.props.label] = e.target.value;
	        _this.props.onChange(obj);
	      } else {
	        _this.props.onChange(e.target.value);
	      }
	
	      _this.setState({ value: e.target.value });
	    };
	
	    _this.handleKeyDown = function (e) {
	      var number = Number(e.target.value);
	      if (number) {
	        var amount = _this.props.arrowOffset || 1;
	
	        // Up
	        if (e.keyCode === 38) {
	          if (_this.props.label !== null) {
	            var obj = {};
	            obj[_this.props.label] = number + amount;
	            _this.props.onChange(obj);
	          } else {
	            _this.props.onChange(number + amount);
	          }
	
	          _this.setState({ value: number + amount });
	        }
	
	        // Down
	        if (e.keyCode === 40) {
	          if (_this.props.label !== null) {
	            var obj = {};
	            obj[_this.props.label] = number - amount;
	            _this.props.onChange(obj);
	          } else {
	            _this.props.onChange(number - amount);
	          }
	
	          _this.setState({ value: number - amount });
	        }
	      }
	    };
	
	    _this.handleDrag = function (e) {
	      if (_this.props.dragLabel) {
	        var newValue = Math.round(_this.props.value + e.movementX);
	        if (newValue >= 0 && newValue <= _this.props.dragMax) {
	          var obj = {};
	          obj[_this.props.label] = newValue;
	          _this.props.onChange(obj);
	        }
	      }
	    };
	
	    _this.handleMouseDown = function (e) {
	      if (_this.props.dragLabel) {
	        e.preventDefault();
	        _this.handleDrag(e);
	        window.addEventListener('mousemove', _this.handleDrag);
	        window.addEventListener('mouseup', _this.handleMouseUp);
	      }
	    };
	
	    _this.handleMouseUp = function () {
	      _this.unbindEventListeners();
	    };
	
	    _this.unbindEventListeners = function () {
	      window.removeEventListener('mousemove', _this.handleChange);
	      window.removeEventListener('mouseup', _this.handleMouseUp);
	    };
	
	    _this.state = {
	      value: String(props.value).toUpperCase(),
	      blurValue: String(props.value).toUpperCase()
	    };
	    return _this;
	  }
	
	  _createClass(EditableInput, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var input = this.refs.input;
	      if (nextProps.value !== this.state.value) {
	        if (input === document.activeElement) {
	          this.setState({ blurValue: String(nextProps.value).toUpperCase() });
	        } else {
	          this.setState({ value: String(nextProps.value).toUpperCase() });
	        }
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.unbindEventListeners();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	
	      var styles = (0, _reactcss2.default)({
	        'user-override': {
	          wrap: this.props.style && this.props.style.wrap ? this.props.style.wrap : {},
	          input: this.props.style && this.props.style.input ? this.props.style.input : {},
	          label: this.props.style && this.props.style.label ? this.props.style.label : {}
	        },
	        'dragLabel-true': {
	          label: {
	            cursor: 'ew-resize'
	          }
	        }
	      }, {
	        'user-override': true
	      }, this.props);
	
	      var label;
	      if (this.props.label) {
	        label = _react2.default.createElement(
	          'span',
	          { style: styles.label, ref: 'label', onMouseDown: this.handleMouseDown },
	          this.props.label
	        );
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { style: styles.wrap, ref: 'container' },
	        _react2.default.createElement('input', { style: styles.input, ref: 'input', value: this.state.value, onKeyDown: this.handleKeyDown, onChange: this.handleChange, onBlur: this.handleBlur }),
	        label
	      );
	    }
	  }]);
	
	  return EditableInput;
	}(_react2.default.Component);
	
	exports.default = EditableInput;

/***/ }),
/* 2793 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Hue = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(2774);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _reactAddonsShallowCompare = __webpack_require__(1321);
	
	var _reactAddonsShallowCompare2 = _interopRequireDefault(_reactAddonsShallowCompare);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Hue = exports.Hue = function (_React$Component) {
	  _inherits(Hue, _React$Component);
	
	  function Hue() {
	    var _Object$getPrototypeO;
	
	    var _temp, _this, _ret;
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _classCallCheck(this, Hue);
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_Object$getPrototypeO = Object.getPrototypeOf(Hue)).call.apply(_Object$getPrototypeO, [this].concat(args))), _this), _this.shouldComponentUpdate = _reactAddonsShallowCompare2.default.bind(_this, _this, arguments[0], arguments[1]), _this.handleChange = function (e, skip) {
	      !skip && e.preventDefault();
	      var container = _this.refs.container;
	      var containerWidth = container.clientWidth;
	      var containerHeight = container.clientHeight;
	      var x = typeof e.pageX === 'number' ? e.pageX : e.touches[0].pageX;
	      var y = typeof e.pageY === 'number' ? e.pageY : e.touches[0].pageY;
	      var inIFrame = window.self !== window.top || window.document !== container.ownerDocument;
	      var left = x - (container.getBoundingClientRect().left + (inIFrame ? 0 : window.pageXOffset));
	      var top = y - (container.getBoundingClientRect().top + (inIFrame ? 0 : window.pageYOffset));
	
	      if (_this.props.direction === 'vertical') {
	        var h;
	        if (top < 0) {
	          h = 359;
	        } else if (top > containerHeight) {
	          h = 0;
	        } else {
	          var percent = -(top * 100 / containerHeight) + 100;
	          h = 360 * percent / 100;
	        }
	
	        if (_this.props.hsl.h !== h) {
	          _this.props.onChange({
	            h: h,
	            s: _this.props.hsl.s,
	            l: _this.props.hsl.l,
	            a: _this.props.hsl.a,
	            source: 'rgb'
	          });
	        }
	      } else {
	        var h;
	        if (left < 0) {
	          h = 0;
	        } else if (left > containerWidth) {
	          h = 359;
	        } else {
	          var percent = left * 100 / containerWidth;
	          h = 360 * percent / 100;
	        }
	
	        if (_this.props.hsl.h !== h) {
	          _this.props.onChange({
	            h: h,
	            s: _this.props.hsl.s,
	            l: _this.props.hsl.l,
	            a: _this.props.hsl.a,
	            source: 'rgb'
	          });
	        }
	      }
	    }, _this.handleMouseDown = function (e) {
	      _this.handleChange(e, true);
	      window.addEventListener('mousemove', _this.handleChange);
	      window.addEventListener('mouseup', _this.handleMouseUp);
	    }, _this.handleMouseUp = function () {
	      _this.unbindEventListeners();
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Hue, [{
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.unbindEventListeners();
	    }
	  }, {
	    key: 'unbindEventListeners',
	    value: function unbindEventListeners() {
	      window.removeEventListener('mousemove', this.handleChange);
	      window.removeEventListener('mouseup', this.handleMouseUp);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	
	      var styles = (0, _reactcss2.default)({
	        'default': {
	          hue: {
	            absolute: '0px 0px 0px 0px',
	            background: 'linear-gradient(to right, #f00 0%, #ff0 17%, #0f0 33%, #0ff 50%, #00f 67%, #f0f 83%, #f00 100%)',
	            borderRadius: this.props.radius,
	            boxShadow: this.props.shadow
	          },
	          container: {
	            margin: '0 2px',
	            position: 'relative',
	            height: '100%'
	          },
	          pointer: {
	            position: 'absolute',
	            left: this.props.hsl.h * 100 / 360 + '%'
	          },
	          slider: {
	            marginTop: '1px',
	            width: '4px',
	            borderRadius: '1px',
	            height: '8px',
	            boxShadow: '0 0 2px rgba(0, 0, 0, .6)',
	            background: '#fff',
	            transform: 'translateX(-2px)'
	          }
	        },
	        'direction-vertical': {
	          hue: {
	            background: 'linear-gradient(to top, #f00 0%, #ff0 17%, #0f0 33%, #0ff 50%, #00f 67%, #f0f 83%, #f00 100%)'
	          },
	          pointer: {
	            left: '0px',
	            top: -(this.props.hsl.h * 100 / 360) + 100 + '%'
	          }
	        }
	      }, this.props);
	
	      var pointer = _react2.default.createElement('div', { style: styles.slider });
	
	      if (this.props.pointer) {
	        pointer = _react2.default.createElement(this.props.pointer, this.props);
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { style: styles.hue },
	        _react2.default.createElement(
	          'div',
	          { style: styles.container, ref: 'container', onMouseDown: this.handleMouseDown,
	            onTouchMove: this.handleChange,
	            onTouchStart: this.handleChange },
	          _react2.default.createElement(
	            'div',
	            { style: styles.pointer, ref: 'pointer' },
	            pointer
	          )
	        )
	      );
	    }
	  }]);
	
	  return Hue;
	}(_react2.default.Component);
	
	exports.default = Hue;

/***/ }),
/* 2794 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Saturation = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(2774);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _throttle = __webpack_require__(641);
	
	var _throttle2 = _interopRequireDefault(_throttle);
	
	var _reactAddonsShallowCompare = __webpack_require__(1321);
	
	var _reactAddonsShallowCompare2 = _interopRequireDefault(_reactAddonsShallowCompare);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Saturation = exports.Saturation = function (_React$Component) {
	  _inherits(Saturation, _React$Component);
	
	  function Saturation(props) {
	    _classCallCheck(this, Saturation);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(Saturation).call(this));
	
	    _this.shouldComponentUpdate = _reactAddonsShallowCompare2.default.bind(_this, _this, arguments[0], arguments[1]);
	
	    _this.handleChange = function (e, skip) {
	      !skip && e.preventDefault();
	      var container = _this.refs.container;
	      var containerWidth = container.clientWidth;
	      var containerHeight = container.clientHeight;
	      var x = typeof e.pageX === 'number' ? e.pageX : e.touches[0].pageX;
	      var y = typeof e.pageY === 'number' ? e.pageY : e.touches[0].pageY;
	      var inIFrame = window.self !== window.top || window.document !== container.ownerDocument;
	      var left = x - (container.getBoundingClientRect().left + (inIFrame ? 0 : window.pageXOffset));
	      var top = y - (container.getBoundingClientRect().top + (inIFrame ? 0 : window.pageYOffset));
	
	      if (left < 0) {
	        left = 0;
	      } else if (left > containerWidth) {
	        left = containerWidth;
	      } else if (top < 0) {
	        top = 0;
	      } else if (top > containerHeight) {
	        top = containerHeight;
	      }
	
	      var saturation = left * 100 / containerWidth;
	      var bright = -(top * 100 / containerHeight) + 100;
	
	      _this.throttle(_this.props.onChange, {
	        h: _this.props.hsl.h,
	        s: saturation,
	        v: bright,
	        a: _this.props.hsl.a,
	        source: 'rgb'
	      });
	    };
	
	    _this.handleMouseDown = function (e) {
	      _this.handleChange(e, true);
	      window.addEventListener('mousemove', _this.handleChange);
	      window.addEventListener('mouseup', _this.handleMouseUp);
	    };
	
	    _this.handleMouseUp = function () {
	      _this.unbindEventListeners();
	    };
	
	    _this.throttle = (0, _throttle2.default)(function (fn, data) {
	      fn(data);
	    }, 50);
	    return _this;
	  }
	
	  _createClass(Saturation, [{
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.unbindEventListeners();
	    }
	  }, {
	    key: 'unbindEventListeners',
	    value: function unbindEventListeners() {
	      window.removeEventListener('mousemove', this.handleChange);
	      window.removeEventListener('mouseup', this.handleMouseUp);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	
	      var styles = (0, _reactcss2.default)({
	        'default': {
	          color: {
	            absolute: '0px 0px 0px 0px',
	            background: 'hsl(' + this.props.hsl.h + ',100%, 50%)',
	            borderRadius: this.props.radius
	          },
	          white: {
	            absolute: '0px 0px 0px 0px',
	            background: 'linear-gradient(to right, #fff, rgba(255,255,255,0))'
	          },
	          black: {
	            absolute: '0px 0px 0px 0px',
	            background: 'linear-gradient(to top, #000, rgba(0,0,0,0))',
	            boxShadow: this.props.shadow
	          },
	          pointer: {
	            position: 'absolute',
	            top: -(this.props.hsv.v * 100) + 100 + '%',
	            left: this.props.hsv.s * 100 + '%',
	            cursor: 'default'
	          },
	          circle: {
	            width: '4px',
	            height: '4px',
	            boxShadow: '0 0 0 1.5px #fff, inset 0 0 1px 1px rgba(0,0,0,.3), 0 0 1px 2px rgba(0,0,0,.4)',
	            borderRadius: '50%',
	            cursor: 'hand',
	            transform: 'translate(-2px, -2px)'
	          }
	        }
	      });
	
	      var pointer = _react2.default.createElement('div', { style: styles.circle });
	
	      if (this.props.pointer) {
	        pointer = _react2.default.createElement(this.props.pointer, this.props);
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { style: styles.color, ref: 'container', onMouseDown: this.handleMouseDown,
	          onTouchMove: this.handleChange,
	          onTouchStart: this.handleChange },
	        _react2.default.createElement(
	          'div',
	          { style: styles.white },
	          _react2.default.createElement('div', { style: styles.black }),
	          _react2.default.createElement(
	            'div',
	            { style: styles.pointer, ref: 'pointer' },
	            pointer
	          )
	        )
	      );
	    }
	  }]);
	
	  return Saturation;
	}(_react2.default.Component);
	
	exports.default = Saturation;

/***/ }),
/* 2795 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ColorWrap = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _merge = __webpack_require__(2783);
	
	var _merge2 = _interopRequireDefault(_merge);
	
	var _isPlainObject = __webpack_require__(795);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _debounce = __webpack_require__(642);
	
	var _debounce2 = _interopRequireDefault(_debounce);
	
	var _color = __webpack_require__(2796);
	
	var _color2 = _interopRequireDefault(_color);
	
	var _reactAddonsShallowCompare = __webpack_require__(1321);
	
	var _reactAddonsShallowCompare2 = _interopRequireDefault(_reactAddonsShallowCompare);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ColorWrap = exports.ColorWrap = function ColorWrap(Picker) {
	  var ColorPicker = function (_React$Component) {
	    _inherits(ColorPicker, _React$Component);
	
	    function ColorPicker(props) {
	      _classCallCheck(this, ColorPicker);
	
	      var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(ColorPicker).call(this));
	
	      _this.shouldComponentUpdate = _reactAddonsShallowCompare2.default.bind(_this, _this, arguments[0], arguments[1]);
	
	      _this.handleChange = function (data) {
	        data = _color2.default.simpleCheckForValidColor(data);
	        if (data) {
	          var colors = _color2.default.toState(data, data.h || _this.state.oldHue);
	          _this.setState(colors);
	          _this.props.onChangeComplete && _this.debounce(_this.props.onChangeComplete, colors);
	          _this.props.onChange && _this.props.onChange(colors);
	        }
	      };
	
	      _this.state = (0, _merge2.default)(_color2.default.toState(props.color, 0), {
	        visible: props.display
	      });
	
	      _this.debounce = (0, _debounce2.default)(function (fn, data) {
	        fn(data);
	      }, 100);
	      return _this;
	    }
	
	    _createClass(ColorPicker, [{
	      key: 'componentWillReceiveProps',
	      value: function componentWillReceiveProps(nextProps) {
	        this.setState((0, _merge2.default)(_color2.default.toState(nextProps.color, this.state.oldHue), {
	          visible: nextProps.display
	        }));
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        return _react2.default.createElement(Picker, _extends({}, this.props, this.state, { onChange: this.handleChange }));
	      }
	    }]);
	
	    return ColorPicker;
	  }(_react2.default.Component);
	
	  ColorPicker.defaultProps = {
	    color: {
	      h: 250,
	      s: .50,
	      l: .20,
	      a: 1
	    }
	  };
	
	  return ColorPicker;
	};
	
	exports.default = ColorWrap;

/***/ }),
/* 2796 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _tinycolor = __webpack_require__(2797);
	
	var _tinycolor2 = _interopRequireDefault(_tinycolor);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	
	  simpleCheckForValidColor: function simpleCheckForValidColor(data) {
	    var keysToCheck = ['r', 'g', 'b', 'a', 'h', 's', 'a', 'v'];
	    var checked = 0;
	    var passed = 0;
	    for (var i = 0; i < keysToCheck.length; i++) {
	      var letter = keysToCheck[i];
	      if (data[letter]) {
	        checked++;
	        if (!isNaN(data[letter])) {
	          passed++;
	        }
	      }
	    }
	
	    if (checked === passed) {
	      return data;
	    }
	  },
	
	  toState: function toState(data, oldHue) {
	    var color = data.hex ? (0, _tinycolor2.default)(data.hex) : (0, _tinycolor2.default)(data);
	    var hsl = color.toHsl();
	    var hsv = color.toHsv();
	    if (hsl.s === 0) {
	      hsl.h = oldHue || 0;
	      hsv.h = oldHue || 0;
	    }
	
	    return {
	      hsl: hsl,
	      hex: '#' + color.toHex(),
	      rgb: color.toRgb(),
	      hsv: hsv,
	      oldHue: data.h || oldHue || hsl.h,
	      source: data.source
	    };
	  },
	
	  isValidHex: function isValidHex(hex) {
	    return (0, _tinycolor2.default)(hex).isValid();
	  }
	
	};

/***/ }),
/* 2797 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;// jscs: disable
	
	// TinyColor v1.1.2
	// https://github.com/bgrins/TinyColor
	// Brian Grinstead, MIT License
	
	(function() {
	
	var trimLeft = /^[\s,#]+/;
	var trimRight = /\s+$/;
	var tinyCounter = 0;
	var math = Math;
	var mathRound = math.round;
	var mathMin = math.min;
	var mathMax = math.max;
	var mathRandom = math.random;
	
	function tinycolor(color, opts) {
	
			color = (color) ? color : '';
			opts = opts || { };
	
			// If input is already a tinycolor, return itself
			if (color instanceof tinycolor) {
				 return color;
			}
			// If we are called as a function, call using new instead
			if (!(this instanceof tinycolor)) {
					return new tinycolor(color, opts);
			}
	
			var rgb = inputToRGB(color);
			this._originalInput = color,
			this._r = rgb.r,
			this._g = rgb.g,
			this._b = rgb.b,
			this._a = rgb.a,
			this._roundA = mathRound(100*this._a) / 100,
			this._format = opts.format || rgb.format;
			this._gradientType = opts.gradientType;
	
			// Don't let the range of [0,255] come back in [0,1].
			// Potentially lose a little bit of precision here, but will fix issues where
			// .5 gets interpreted as half of the total, instead of half of 1
			// If it was supposed to be 128, this was already taken care of by `inputToRgb`
			if (this._r < 1) { this._r = mathRound(this._r); }
			if (this._g < 1) { this._g = mathRound(this._g); }
			if (this._b < 1) { this._b = mathRound(this._b); }
	
			this._ok = rgb.ok;
			this._tc_id = tinyCounter++;
	}
	
	tinycolor.prototype = {
			isDark: function() {
					return this.getBrightness() < 128;
			},
			isLight: function() {
					return !this.isDark();
			},
			isValid: function() {
					return this._ok;
			},
			getOriginalInput: function() {
				return this._originalInput;
			},
			getFormat: function() {
					return this._format;
			},
			getAlpha: function() {
					return this._a;
			},
			getBrightness: function() {
					//http://www.w3.org/TR/AERT#color-contrast
					var rgb = this.toRgb();
					return (rgb.r * 299 + rgb.g * 587 + rgb.b * 114) / 1000;
			},
			getLuminance: function() {
					//http://www.w3.org/TR/2008/REC-WCAG20-20081211/#relativeluminancedef
					var rgb = this.toRgb();
					var RsRGB, GsRGB, BsRGB, R, G, B;
					RsRGB = rgb.r/255;
					GsRGB = rgb.g/255;
					BsRGB = rgb.b/255;
	
					if (RsRGB <= 0.03928) {R = RsRGB / 12.92;} else {R = Math.pow(((RsRGB + 0.055) / 1.055), 2.4);}
					if (GsRGB <= 0.03928) {G = GsRGB / 12.92;} else {G = Math.pow(((GsRGB + 0.055) / 1.055), 2.4);}
					if (BsRGB <= 0.03928) {B = BsRGB / 12.92;} else {B = Math.pow(((BsRGB + 0.055) / 1.055), 2.4);}
					return (0.2126 * R) + (0.7152 * G) + (0.0722 * B);
			},
			setAlpha: function(value) {
					this._a = boundAlpha(value);
					this._roundA = mathRound(100*this._a) / 100;
					return this;
			},
			toHsv: function() {
					var hsv = rgbToHsv(this._r, this._g, this._b);
					return { h: hsv.h * 360, s: hsv.s, v: hsv.v, a: this._a };
			},
			toHsvString: function() {
					var hsv = rgbToHsv(this._r, this._g, this._b);
					var h = mathRound(hsv.h * 360), s = mathRound(hsv.s * 100), v = mathRound(hsv.v * 100);
					return (this._a == 1) ?
						"hsv("	+ h + ", " + s + "%, " + v + "%)" :
						"hsva(" + h + ", " + s + "%, " + v + "%, "+ this._roundA + ")";
			},
			toHsl: function() {
					var hsl = rgbToHsl(this._r, this._g, this._b);
					return { h: hsl.h * 360, s: hsl.s, l: hsl.l, a: this._a };
			},
			toHslString: function() {
					var hsl = rgbToHsl(this._r, this._g, this._b);
					var h = mathRound(hsl.h * 360), s = mathRound(hsl.s * 100), l = mathRound(hsl.l * 100);
					return (this._a == 1) ?
						"hsl("	+ h + ", " + s + "%, " + l + "%)" :
						"hsla(" + h + ", " + s + "%, " + l + "%, "+ this._roundA + ")";
			},
			toHex: function(allow3Char) {
					return rgbToHex(this._r, this._g, this._b, allow3Char);
			},
			toHexString: function(allow3Char) {
					return '#' + this.toHex(allow3Char);
			},
			toHex8: function() {
					return rgbaToHex(this._r, this._g, this._b, this._a);
			},
			toHex8String: function() {
					return '#' + this.toHex8();
			},
			toRgb: function() {
					return { r: mathRound(this._r), g: mathRound(this._g), b: mathRound(this._b), a: this._a };
			},
			toRgbString: function() {
					return (this._a == 1) ?
						"rgb("	+ mathRound(this._r) + ", " + mathRound(this._g) + ", " + mathRound(this._b) + ")" :
						"rgba(" + mathRound(this._r) + ", " + mathRound(this._g) + ", " + mathRound(this._b) + ", " + this._roundA + ")";
			},
			toPercentageRgb: function() {
					return { r: mathRound(bound01(this._r, 255) * 100) + "%", g: mathRound(bound01(this._g, 255) * 100) + "%", b: mathRound(bound01(this._b, 255) * 100) + "%", a: this._a };
			},
			toPercentageRgbString: function() {
					return (this._a == 1) ?
						"rgb("	+ mathRound(bound01(this._r, 255) * 100) + "%, " + mathRound(bound01(this._g, 255) * 100) + "%, " + mathRound(bound01(this._b, 255) * 100) + "%)" :
						"rgba(" + mathRound(bound01(this._r, 255) * 100) + "%, " + mathRound(bound01(this._g, 255) * 100) + "%, " + mathRound(bound01(this._b, 255) * 100) + "%, " + this._roundA + ")";
			},
			toName: function() {
					if (this._a === 0) {
							return "transparent";
					}
	
					if (this._a < 1) {
							return false;
					}
	
					return hexNames[rgbToHex(this._r, this._g, this._b, true)] || false;
			},
			toFilter: function(secondColor) {
					var hex8String = '#' + rgbaToHex(this._r, this._g, this._b, this._a);
					var secondHex8String = hex8String;
					var gradientType = this._gradientType ? "GradientType = 1, " : "";
	
					if (secondColor) {
							var s = tinycolor(secondColor);
							secondHex8String = s.toHex8String();
					}
	
					return "progid:DXImageTransform.Microsoft.gradient("+gradientType+"startColorstr="+hex8String+",endColorstr="+secondHex8String+")";
			},
			toString: function(format) {
					var formatSet = !!format;
					format = format || this._format;
	
					var formattedString = false;
					var hasAlpha = this._a < 1 && this._a >= 0;
					var needsAlphaFormat = !formatSet && hasAlpha && (format === "hex" || format === "hex6" || format === "hex3" || format === "name");
	
					if (needsAlphaFormat) {
							// Special case for "transparent", all other non-alpha formats
							// will return rgba when there is transparency.
							if (format === "name" && this._a === 0) {
									return this.toName();
							}
							return this.toRgbString();
					}
					if (format === "rgb") {
							formattedString = this.toRgbString();
					}
					if (format === "prgb") {
							formattedString = this.toPercentageRgbString();
					}
					if (format === "hex" || format === "hex6") {
							formattedString = this.toHexString();
					}
					if (format === "hex3") {
							formattedString = this.toHexString(true);
					}
					if (format === "hex8") {
							formattedString = this.toHex8String();
					}
					if (format === "name") {
							formattedString = this.toName();
					}
					if (format === "hsl") {
							formattedString = this.toHslString();
					}
					if (format === "hsv") {
							formattedString = this.toHsvString();
					}
	
					return formattedString || this.toHexString();
			},
	
			_applyModification: function(fn, args) {
					var color = fn.apply(null, [this].concat([].slice.call(args)));
					this._r = color._r;
					this._g = color._g;
					this._b = color._b;
					this.setAlpha(color._a);
					return this;
			},
			lighten: function() {
					return this._applyModification(lighten, arguments);
			},
			brighten: function() {
					return this._applyModification(brighten, arguments);
			},
			darken: function() {
					return this._applyModification(darken, arguments);
			},
			desaturate: function() {
					return this._applyModification(desaturate, arguments);
			},
			saturate: function() {
					return this._applyModification(saturate, arguments);
			},
			greyscale: function() {
					return this._applyModification(greyscale, arguments);
			},
			spin: function() {
					return this._applyModification(spin, arguments);
			},
	
			_applyCombination: function(fn, args) {
					return fn.apply(null, [this].concat([].slice.call(args)));
			},
			analogous: function() {
					return this._applyCombination(analogous, arguments);
			},
			complement: function() {
					return this._applyCombination(complement, arguments);
			},
			monochromatic: function() {
					return this._applyCombination(monochromatic, arguments);
			},
			splitcomplement: function() {
					return this._applyCombination(splitcomplement, arguments);
			},
			triad: function() {
					return this._applyCombination(triad, arguments);
			},
			tetrad: function() {
					return this._applyCombination(tetrad, arguments);
			}
	};
	
	// If input is an object, force 1 into "1.0" to handle ratios properly
	// String input requires "1.0" as input, so 1 will be treated as 1
	tinycolor.fromRatio = function(color, opts) {
			if (typeof color == "object") {
					var newColor = {};
					for (var i in color) {
							if (color.hasOwnProperty(i)) {
									if (i === "a") {
											newColor[i] = color[i];
									}
									else {
											newColor[i] = convertToPercentage(color[i]);
									}
							}
					}
					color = newColor;
			}
	
			return tinycolor(color, opts);
	};
	
	// Given a string or object, convert that input to RGB
	// Possible string inputs:
	//
	//		 "red"
	//		 "#f00" or "f00"
	//		 "#ff0000" or "ff0000"
	//		 "#ff000000" or "ff000000"
	//		 "rgb 255 0 0" or "rgb (255, 0, 0)"
	//		 "rgb 1.0 0 0" or "rgb (1, 0, 0)"
	//		 "rgba (255, 0, 0, 1)" or "rgba 255, 0, 0, 1"
	//		 "rgba (1.0, 0, 0, 1)" or "rgba 1.0, 0, 0, 1"
	//		 "hsl(0, 100%, 50%)" or "hsl 0 100% 50%"
	//		 "hsla(0, 100%, 50%, 1)" or "hsla 0 100% 50%, 1"
	//		 "hsv(0, 100%, 100%)" or "hsv 0 100% 100%"
	//
	function inputToRGB(color) {
	
			var rgb = { r: 0, g: 0, b: 0 };
			var a = 1;
			var ok = false;
			var format = false;
	
			if (typeof color == "string") {
					color = stringInputToObject(color);
			}
	
			if (typeof color == "object") {
					if (color.hasOwnProperty("r") && color.hasOwnProperty("g") && color.hasOwnProperty("b")) {
							rgb = rgbToRgb(color.r, color.g, color.b);
							ok = true;
							format = String(color.r).substr(-1) === "%" ? "prgb" : "rgb";
					}
					else if (color.hasOwnProperty("h") && color.hasOwnProperty("s") && color.hasOwnProperty("v")) {
							color.s = convertToPercentage(color.s, 1);
							color.v = convertToPercentage(color.v, 1);
							rgb = hsvToRgb(color.h, color.s, color.v);
							ok = true;
							format = "hsv";
					}
					else if (color.hasOwnProperty("h") && color.hasOwnProperty("s") && color.hasOwnProperty("l")) {
							color.s = convertToPercentage(color.s);
							color.l = convertToPercentage(color.l);
							rgb = hslToRgb(color.h, color.s, color.l);
							ok = true;
							format = "hsl";
					}
	
					if (color.hasOwnProperty("a")) {
							a = color.a;
					}
			}
	
			a = boundAlpha(a);
	
			return {
					ok: ok,
					format: color.format || format,
					r: mathMin(255, mathMax(rgb.r, 0)),
					g: mathMin(255, mathMax(rgb.g, 0)),
					b: mathMin(255, mathMax(rgb.b, 0)),
					a: a
			};
	}
	
	
	// Conversion Functions
	// --------------------
	
	// `rgbToHsl`, `rgbToHsv`, `hslToRgb`, `hsvToRgb` modified from:
	// <http://mjijackson.com/2008/02/rgb-to-hsl-and-rgb-to-hsv-color-model-conversion-algorithms-in-javascript>
	
	// `rgbToRgb`
	// Handle bounds / percentage checking to conform to CSS color spec
	// <http://www.w3.org/TR/css3-color/>
	// *Assumes:* r, g, b in [0, 255] or [0, 1]
	// *Returns:* { r, g, b } in [0, 255]
	function rgbToRgb(r, g, b){
			return {
					r: bound01(r, 255) * 255,
					g: bound01(g, 255) * 255,
					b: bound01(b, 255) * 255
			};
	}
	
	// `rgbToHsl`
	// Converts an RGB color value to HSL.
	// *Assumes:* r, g, and b are contained in [0, 255] or [0, 1]
	// *Returns:* { h, s, l } in [0,1]
	function rgbToHsl(r, g, b) {
	
			r = bound01(r, 255);
			g = bound01(g, 255);
			b = bound01(b, 255);
	
			var max = mathMax(r, g, b), min = mathMin(r, g, b);
			var h, s, l = (max + min) / 2;
	
			if(max == min) {
					h = s = 0; // achromatic
			}
			else {
					var d = max - min;
					s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
					switch(max) {
							case r: h = (g - b) / d + (g < b ? 6 : 0); break;
							case g: h = (b - r) / d + 2; break;
							case b: h = (r - g) / d + 4; break;
					}
	
					h /= 6;
			}
	
			return { h: h, s: s, l: l };
	}
	
	// `hslToRgb`
	// Converts an HSL color value to RGB.
	// *Assumes:* h is contained in [0, 1] or [0, 360] and s and l are contained [0, 1] or [0, 100]
	// *Returns:* { r, g, b } in the set [0, 255]
	function hslToRgb(h, s, l) {
			var r, g, b;
	
			h = bound01(h, 360);
			s = bound01(s, 100);
			l = bound01(l, 100);
	
			function hue2rgb(p, q, t) {
					if(t < 0) t += 1;
					if(t > 1) t -= 1;
					if(t < 1/6) return p + (q - p) * 6 * t;
					if(t < 1/2) return q;
					if(t < 2/3) return p + (q - p) * (2/3 - t) * 6;
					return p;
			}
	
			if(s === 0) {
					r = g = b = l; // achromatic
			}
			else {
					var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
					var p = 2 * l - q;
					r = hue2rgb(p, q, h + 1/3);
					g = hue2rgb(p, q, h);
					b = hue2rgb(p, q, h - 1/3);
			}
	
			return { r: r * 255, g: g * 255, b: b * 255 };
	}
	
	// `rgbToHsv`
	// Converts an RGB color value to HSV
	// *Assumes:* r, g, and b are contained in the set [0, 255] or [0, 1]
	// *Returns:* { h, s, v } in [0,1]
	function rgbToHsv(r, g, b) {
	
			r = bound01(r, 255);
			g = bound01(g, 255);
			b = bound01(b, 255);
	
			var max = mathMax(r, g, b), min = mathMin(r, g, b);
			var h, s, v = max;
	
			var d = max - min;
			s = max === 0 ? 0 : d / max;
	
			if(max == min) {
					h = 0; // achromatic
			}
			else {
					switch(max) {
							case r: h = (g - b) / d + (g < b ? 6 : 0); break;
							case g: h = (b - r) / d + 2; break;
							case b: h = (r - g) / d + 4; break;
					}
					h /= 6;
			}
			return { h: h, s: s, v: v };
	}
	
	// `hsvToRgb`
	// Converts an HSV color value to RGB.
	// *Assumes:* h is contained in [0, 1] or [0, 360] and s and v are contained in [0, 1] or [0, 100]
	// *Returns:* { r, g, b } in the set [0, 255]
	 function hsvToRgb(h, s, v) {
	
			h = bound01(h, 360) * 6;
			s = bound01(s, 100);
			v = bound01(v, 100);
	
			var i = math.floor(h),
					f = h - i,
					p = v * (1 - s),
					q = v * (1 - f * s),
					t = v * (1 - (1 - f) * s),
					mod = i % 6,
					r = [v, q, p, p, t, v][mod],
					g = [t, v, v, q, p, p][mod],
					b = [p, p, t, v, v, q][mod];
	
			return { r: r * 255, g: g * 255, b: b * 255 };
	}
	
	// `rgbToHex`
	// Converts an RGB color to hex
	// Assumes r, g, and b are contained in the set [0, 255]
	// Returns a 3 or 6 character hex
	function rgbToHex(r, g, b, allow3Char) {
	
			var hex = [
					pad2(mathRound(r).toString(16)),
					pad2(mathRound(g).toString(16)),
					pad2(mathRound(b).toString(16))
			];
	
			// Return a 3 character hex if possible
			if (allow3Char && hex[0].charAt(0) == hex[0].charAt(1) && hex[1].charAt(0) == hex[1].charAt(1) && hex[2].charAt(0) == hex[2].charAt(1)) {
					return hex[0].charAt(0) + hex[1].charAt(0) + hex[2].charAt(0);
			}
	
			return hex.join("");
	}
			// `rgbaToHex`
			// Converts an RGBA color plus alpha transparency to hex
			// Assumes r, g, b and a are contained in the set [0, 255]
			// Returns an 8 character hex
			function rgbaToHex(r, g, b, a) {
	
					var hex = [
							pad2(convertDecimalToHex(a)),
							pad2(mathRound(r).toString(16)),
							pad2(mathRound(g).toString(16)),
							pad2(mathRound(b).toString(16))
					];
	
					return hex.join("");
			}
	
	// `equals`
	// Can be called with any tinycolor input
	tinycolor.equals = function (color1, color2) {
			if (!color1 || !color2) { return false; }
			return tinycolor(color1).toRgbString() == tinycolor(color2).toRgbString();
	};
	tinycolor.random = function() {
			return tinycolor.fromRatio({
					r: mathRandom(),
					g: mathRandom(),
					b: mathRandom()
			});
	};
	
	
	// Modification Functions
	// ----------------------
	// Thanks to less.js for some of the basics here
	// <https://github.com/cloudhead/less.js/blob/master/lib/less/functions.js>
	
	function desaturate(color, amount) {
			amount = (amount === 0) ? 0 : (amount || 10);
			var hsl = tinycolor(color).toHsl();
			hsl.s -= amount / 100;
			hsl.s = clamp01(hsl.s);
			return tinycolor(hsl);
	}
	
	function saturate(color, amount) {
			amount = (amount === 0) ? 0 : (amount || 10);
			var hsl = tinycolor(color).toHsl();
			hsl.s += amount / 100;
			hsl.s = clamp01(hsl.s);
			return tinycolor(hsl);
	}
	
	function greyscale(color) {
			return tinycolor(color).desaturate(100);
	}
	
	function lighten (color, amount) {
			amount = (amount === 0) ? 0 : (amount || 10);
			var hsl = tinycolor(color).toHsl();
			hsl.l += amount / 100;
			hsl.l = clamp01(hsl.l);
			return tinycolor(hsl);
	}
	
	function brighten(color, amount) {
			amount = (amount === 0) ? 0 : (amount || 10);
			var rgb = tinycolor(color).toRgb();
			rgb.r = mathMax(0, mathMin(255, rgb.r - mathRound(255 * - (amount / 100))));
			rgb.g = mathMax(0, mathMin(255, rgb.g - mathRound(255 * - (amount / 100))));
			rgb.b = mathMax(0, mathMin(255, rgb.b - mathRound(255 * - (amount / 100))));
			return tinycolor(rgb);
	}
	
	function darken (color, amount) {
			amount = (amount === 0) ? 0 : (amount || 10);
			var hsl = tinycolor(color).toHsl();
			hsl.l -= amount / 100;
			hsl.l = clamp01(hsl.l);
			return tinycolor(hsl);
	}
	
	// Spin takes a positive or negative amount within [-360, 360] indicating the change of hue.
	// Values outside of this range will be wrapped into this range.
	function spin(color, amount) {
			var hsl = tinycolor(color).toHsl();
			var hue = (mathRound(hsl.h) + amount) % 360;
			hsl.h = hue < 0 ? 360 + hue : hue;
			return tinycolor(hsl);
	}
	
	// Combination Functions
	// ---------------------
	// Thanks to jQuery xColor for some of the ideas behind these
	// <https://github.com/infusion/jQuery-xcolor/blob/master/jquery.xcolor.js>
	
	function complement(color) {
			var hsl = tinycolor(color).toHsl();
			hsl.h = (hsl.h + 180) % 360;
			return tinycolor(hsl);
	}
	
	function triad(color) {
			var hsl = tinycolor(color).toHsl();
			var h = hsl.h;
			return [
					tinycolor(color),
					tinycolor({ h: (h + 120) % 360, s: hsl.s, l: hsl.l }),
					tinycolor({ h: (h + 240) % 360, s: hsl.s, l: hsl.l })
			];
	}
	
	function tetrad(color) {
			var hsl = tinycolor(color).toHsl();
			var h = hsl.h;
			return [
					tinycolor(color),
					tinycolor({ h: (h + 90) % 360, s: hsl.s, l: hsl.l }),
					tinycolor({ h: (h + 180) % 360, s: hsl.s, l: hsl.l }),
					tinycolor({ h: (h + 270) % 360, s: hsl.s, l: hsl.l })
			];
	}
	
	function splitcomplement(color) {
			var hsl = tinycolor(color).toHsl();
			var h = hsl.h;
			return [
					tinycolor(color),
					tinycolor({ h: (h + 72) % 360, s: hsl.s, l: hsl.l}),
					tinycolor({ h: (h + 216) % 360, s: hsl.s, l: hsl.l})
			];
	}
	
	function analogous(color, results, slices) {
			results = results || 6;
			slices = slices || 30;
	
			var hsl = tinycolor(color).toHsl();
			var part = 360 / slices;
			var ret = [tinycolor(color)];
	
			for (hsl.h = ((hsl.h - (part * results >> 1)) + 720) % 360; --results; ) {
					hsl.h = (hsl.h + part) % 360;
					ret.push(tinycolor(hsl));
			}
			return ret;
	}
	
	function monochromatic(color, results) {
			results = results || 6;
			var hsv = tinycolor(color).toHsv();
			var h = hsv.h, s = hsv.s, v = hsv.v;
			var ret = [];
			var modification = 1 / results;
	
			while (results--) {
					ret.push(tinycolor({ h: h, s: s, v: v}));
					v = (v + modification) % 1;
			}
	
			return ret;
	}
	
	// Utility Functions
	// ---------------------
	
	tinycolor.mix = function(color1, color2, amount) {
			amount = (amount === 0) ? 0 : (amount || 50);
	
			var rgb1 = tinycolor(color1).toRgb();
			var rgb2 = tinycolor(color2).toRgb();
	
			var p = amount / 100;
			var w = p * 2 - 1;
			var a = rgb2.a - rgb1.a;
	
			var w1;
	
			if (w * a == -1) {
					w1 = w;
			} else {
					w1 = (w + a) / (1 + w * a);
			}
	
			w1 = (w1 + 1) / 2;
	
			var w2 = 1 - w1;
	
			var rgba = {
					r: rgb2.r * w1 + rgb1.r * w2,
					g: rgb2.g * w1 + rgb1.g * w2,
					b: rgb2.b * w1 + rgb1.b * w2,
					a: rgb2.a * p	+ rgb1.a * (1 - p)
			};
	
			return tinycolor(rgba);
	};
	
	
	// Readability Functions
	// ---------------------
	// <http://www.w3.org/TR/2008/REC-WCAG20-20081211/#contrast-ratiodef (WCAG Version 2)
	
	// `contrast`
	// Analyze the 2 colors and returns the color contrast defined by (WCAG Version 2)
	tinycolor.readability = function(color1, color2) {
			var c1 = tinycolor(color1);
			var c2 = tinycolor(color2);
			return (Math.max(c1.getLuminance(),c2.getLuminance())+0.05) / (Math.min(c1.getLuminance(),c2.getLuminance())+0.05);
	};
	
	// `isReadable`
	// Ensure that foreground and background color combinations meet WCAG2 guidelines.
	// The third argument is an optional Object.
	//			the 'level' property states 'AA' or 'AAA' - if missing or invalid, it defaults to 'AA';
	//			the 'size' property states 'large' or 'small' - if missing or invalid, it defaults to 'small'.
	// If the entire object is absent, isReadable defaults to {level:"AA",size:"small"}.
	
	// *Example*
	//		tinycolor.isReadable("#000", "#111") => false
	//		tinycolor.isReadable("#000", "#111",{level:"AA",size:"large"}) => false
	
	tinycolor.isReadable = function(color1, color2, wcag2) {
			var readability = tinycolor.readability(color1, color2);
			var wcag2Parms, out;
	
			out = false;
	
			wcag2Parms = validateWCAG2Parms(wcag2);
			switch (wcag2Parms.level + wcag2Parms.size) {
					case "AAsmall":
					case "AAAlarge":
							out = readability >= 4.5;
							break;
					case "AAlarge":
							out = readability >= 3;
							break;
					case "AAAsmall":
							out = readability >= 7;
							break;
			}
			return out;
	
	};
	
	// `mostReadable`
	// Given a base color and a list of possible foreground or background
	// colors for that base, returns the most readable color.
	// Optionally returns Black or White if the most readable color is unreadable.
	// *Example*
	//		tinycolor.mostReadable(tinycolor.mostReadable("#123", ["#124", "#125"],{includeFallbackColors:false}).toHexString(); // "#112255"
	//		tinycolor.mostReadable(tinycolor.mostReadable("#123", ["#124", "#125"],{includeFallbackColors:true}).toHexString();	// "#ffffff"
	//		tinycolor.mostReadable("#a8015a", ["#faf3f3"],{includeFallbackColors:true,level:"AAA",size:"large"}).toHexString(); // "#faf3f3"
	//		tinycolor.mostReadable("#a8015a", ["#faf3f3"],{includeFallbackColors:true,level:"AAA",size:"small"}).toHexString(); // "#ffffff"
	
	
	tinycolor.mostReadable = function(baseColor, colorList, args) {
			var bestColor = null;
			var bestScore = 0;
			var readability;
			var includeFallbackColors, level, size ;
			args = args || {};
			includeFallbackColors = args.includeFallbackColors ;
			level = args.level;
			size = args.size;
	
			for (var i= 0; i < colorList.length ; i++) {
					readability = tinycolor.readability(baseColor, colorList[i]);
					if (readability > bestScore) {
							bestScore = readability;
							bestColor = tinycolor(colorList[i]);
					}
			}
	
			if (tinycolor.isReadable(baseColor, bestColor, {"level":level,"size":size}) || !includeFallbackColors) {
					return bestColor;
			}
			else {
					args.includeFallbackColors=false;
					return tinycolor.mostReadable(baseColor,["#fff", "#000"],args);
			}
	};
	
	
	// Big List of Colors
	// ------------------
	// <http://www.w3.org/TR/css3-color/#svg-color>
	var names = tinycolor.names = {
			aliceblue: "f0f8ff",
			antiquewhite: "faebd7",
			aqua: "0ff",
			aquamarine: "7fffd4",
			azure: "f0ffff",
			beige: "f5f5dc",
			bisque: "ffe4c4",
			black: "000",
			blanchedalmond: "ffebcd",
			blue: "00f",
			blueviolet: "8a2be2",
			brown: "a52a2a",
			burlywood: "deb887",
			burntsienna: "ea7e5d",
			cadetblue: "5f9ea0",
			chartreuse: "7fff00",
			chocolate: "d2691e",
			coral: "ff7f50",
			cornflowerblue: "6495ed",
			cornsilk: "fff8dc",
			crimson: "dc143c",
			cyan: "0ff",
			darkblue: "00008b",
			darkcyan: "008b8b",
			darkgoldenrod: "b8860b",
			darkgray: "a9a9a9",
			darkgreen: "006400",
			darkgrey: "a9a9a9",
			darkkhaki: "bdb76b",
			darkmagenta: "8b008b",
			darkolivegreen: "556b2f",
			darkorange: "ff8c00",
			darkorchid: "9932cc",
			darkred: "8b0000",
			darksalmon: "e9967a",
			darkseagreen: "8fbc8f",
			darkslateblue: "483d8b",
			darkslategray: "2f4f4f",
			darkslategrey: "2f4f4f",
			darkturquoise: "00ced1",
			darkviolet: "9400d3",
			deeppink: "ff1493",
			deepskyblue: "00bfff",
			dimgray: "696969",
			dimgrey: "696969",
			dodgerblue: "1e90ff",
			firebrick: "b22222",
			floralwhite: "fffaf0",
			forestgreen: "228b22",
			fuchsia: "f0f",
			gainsboro: "dcdcdc",
			ghostwhite: "f8f8ff",
			gold: "ffd700",
			goldenrod: "daa520",
			gray: "808080",
			green: "008000",
			greenyellow: "adff2f",
			grey: "808080",
			honeydew: "f0fff0",
			hotpink: "ff69b4",
			indianred: "cd5c5c",
			indigo: "4b0082",
			ivory: "fffff0",
			khaki: "f0e68c",
			lavender: "e6e6fa",
			lavenderblush: "fff0f5",
			lawngreen: "7cfc00",
			lemonchiffon: "fffacd",
			lightblue: "add8e6",
			lightcoral: "f08080",
			lightcyan: "e0ffff",
			lightgoldenrodyellow: "fafad2",
			lightgray: "d3d3d3",
			lightgreen: "90ee90",
			lightgrey: "d3d3d3",
			lightpink: "ffb6c1",
			lightsalmon: "ffa07a",
			lightseagreen: "20b2aa",
			lightskyblue: "87cefa",
			lightslategray: "789",
			lightslategrey: "789",
			lightsteelblue: "b0c4de",
			lightyellow: "ffffe0",
			lime: "0f0",
			limegreen: "32cd32",
			linen: "faf0e6",
			magenta: "f0f",
			maroon: "800000",
			mediumaquamarine: "66cdaa",
			mediumblue: "0000cd",
			mediumorchid: "ba55d3",
			mediumpurple: "9370db",
			mediumseagreen: "3cb371",
			mediumslateblue: "7b68ee",
			mediumspringgreen: "00fa9a",
			mediumturquoise: "48d1cc",
			mediumvioletred: "c71585",
			midnightblue: "191970",
			mintcream: "f5fffa",
			mistyrose: "ffe4e1",
			moccasin: "ffe4b5",
			navajowhite: "ffdead",
			navy: "000080",
			oldlace: "fdf5e6",
			olive: "808000",
			olivedrab: "6b8e23",
			orange: "ffa500",
			orangered: "ff4500",
			orchid: "da70d6",
			palegoldenrod: "eee8aa",
			palegreen: "98fb98",
			paleturquoise: "afeeee",
			palevioletred: "db7093",
			papayawhip: "ffefd5",
			peachpuff: "ffdab9",
			peru: "cd853f",
			pink: "ffc0cb",
			plum: "dda0dd",
			powderblue: "b0e0e6",
			purple: "800080",
			rebeccapurple: "663399",
			red: "f00",
			rosybrown: "bc8f8f",
			royalblue: "4169e1",
			saddlebrown: "8b4513",
			salmon: "fa8072",
			sandybrown: "f4a460",
			seagreen: "2e8b57",
			seashell: "fff5ee",
			sienna: "a0522d",
			silver: "c0c0c0",
			skyblue: "87ceeb",
			slateblue: "6a5acd",
			slategray: "708090",
			slategrey: "708090",
			snow: "fffafa",
			springgreen: "00ff7f",
			steelblue: "4682b4",
			tan: "d2b48c",
			teal: "008080",
			thistle: "d8bfd8",
			tomato: "ff6347",
			turquoise: "40e0d0",
			violet: "ee82ee",
			wheat: "f5deb3",
			white: "fff",
			whitesmoke: "f5f5f5",
			yellow: "ff0",
			yellowgreen: "9acd32"
	};
	
	// Make it easy to access colors via `hexNames[hex]`
	var hexNames = tinycolor.hexNames = flip(names);
	
	
	// Utilities
	// ---------
	
	// `{ 'name1': 'val1' }` becomes `{ 'val1': 'name1' }`
	function flip(o) {
			var flipped = { };
			for (var i in o) {
					if (o.hasOwnProperty(i)) {
							flipped[o[i]] = i;
					}
			}
			return flipped;
	}
	
	// Return a valid alpha value [0,1] with all invalid values being set to 1
	function boundAlpha(a) {
			a = parseFloat(a);
	
			if (isNaN(a) || a < 0 || a > 1) {
					a = 1;
			}
	
			return a;
	}
	
	// Take input from [0, n] and return it as [0, 1]
	function bound01(n, max) {
			if (isOnePointZero(n)) { n = "100%"; }
	
			var processPercent = isPercentage(n);
			n = mathMin(max, mathMax(0, parseFloat(n)));
	
			// Automatically convert percentage into number
			if (processPercent) {
					n = parseInt(n * max, 10) / 100;
			}
	
			// Handle floating point rounding errors
			if ((math.abs(n - max) < 0.000001)) {
					return 1;
			}
	
			// Convert into [0, 1] range if it isn't already
			return (n % max) / parseFloat(max);
	}
	
	// Force a number between 0 and 1
	function clamp01(val) {
			return mathMin(1, mathMax(0, val));
	}
	
	// Parse a base-16 hex value into a base-10 integer
	function parseIntFromHex(val) {
			return parseInt(val, 16);
	}
	
	// Need to handle 1.0 as 100%, since once it is a number, there is no difference between it and 1
	// <http://stackoverflow.com/questions/7422072/javascript-how-to-detect-number-as-a-decimal-including-1-0>
	function isOnePointZero(n) {
			return typeof n == "string" && n.indexOf('.') != -1 && parseFloat(n) === 1;
	}
	
	// Check to see if string passed in is a percentage
	function isPercentage(n) {
			return typeof n === "string" && n.indexOf('%') != -1;
	}
	
	// Force a hex value to have 2 characters
	function pad2(c) {
			return c.length == 1 ? '0' + c : '' + c;
	}
	
	// Replace a decimal with it's percentage value
	function convertToPercentage(n, multiplier) {
			multiplier = multiplier || 100;
			if (n <= 1) {
					n = (n * multiplier) + "%";
			}
	
			return n;
	}
	
	// Converts a decimal to a hex value
	function convertDecimalToHex(d) {
			return Math.round(parseFloat(d) * 255).toString(16);
	}
	// Converts a hex value to a decimal
	function convertHexToDecimal(h) {
			return (parseIntFromHex(h) / 255);
	}
	
	var matchers = (function() {
	
			// <http://www.w3.org/TR/css3-values/#integers>
			var CSS_INTEGER = "[-\\+]?\\d+%?";
	
			// <http://www.w3.org/TR/css3-values/#number-value>
			var CSS_NUMBER = "[-\\+]?\\d*\\.\\d+%?";
	
			// Allow positive/negative integer/number.	Don't capture the either/or, just the entire outcome.
			var CSS_UNIT = "(?:" + CSS_NUMBER + ")|(?:" + CSS_INTEGER + ")";
	
			// Actual matching.
			// Parentheses and commas are optional, but not required.
			// Whitespace can take the place of commas or opening paren
			var PERMISSIVE_MATCH3 = "[\\s|\\(]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")\\s*\\)?";
			var PERMISSIVE_MATCH4 = "[\\s|\\(]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")\\s*\\)?";
	
			return {
					rgb: new RegExp("rgb" + PERMISSIVE_MATCH3),
					rgba: new RegExp("rgba" + PERMISSIVE_MATCH4),
					hsl: new RegExp("hsl" + PERMISSIVE_MATCH3),
					hsla: new RegExp("hsla" + PERMISSIVE_MATCH4),
					hsv: new RegExp("hsv" + PERMISSIVE_MATCH3),
					hsva: new RegExp("hsva" + PERMISSIVE_MATCH4),
					hex3: /^([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
					hex6: /^([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
					hex8: /^([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/
			};
	})();
	
	// `stringInputToObject`
	// Permissive string parsing.	Take in a number of formats, and output an object
	// based on detected format.	Returns `{ r, g, b }` or `{ h, s, l }` or `{ h, s, v}`
	function stringInputToObject(color) {
	
			color = color.replace(trimLeft,'').replace(trimRight, '').toLowerCase();
			var named = false;
			if (names[color]) {
					color = names[color];
					named = true;
			}
			else if (color == 'transparent') {
					return { r: 0, g: 0, b: 0, a: 0, format: "name" };
			}
	
			// Try to match string input using regular expressions.
			// Keep most of the number bounding out of this function - don't worry about [0,1] or [0,100] or [0,360]
			// Just return an object and let the conversion functions handle that.
			// This way the result will be the same whether the tinycolor is initialized with string or object.
			var match;
			if ((match = matchers.rgb.exec(color))) {
					return { r: match[1], g: match[2], b: match[3] };
			}
			if ((match = matchers.rgba.exec(color))) {
					return { r: match[1], g: match[2], b: match[3], a: match[4] };
			}
			if ((match = matchers.hsl.exec(color))) {
					return { h: match[1], s: match[2], l: match[3] };
			}
			if ((match = matchers.hsla.exec(color))) {
					return { h: match[1], s: match[2], l: match[3], a: match[4] };
			}
			if ((match = matchers.hsv.exec(color))) {
					return { h: match[1], s: match[2], v: match[3] };
			}
			if ((match = matchers.hsva.exec(color))) {
					return { h: match[1], s: match[2], v: match[3], a: match[4] };
			}
			if ((match = matchers.hex8.exec(color))) {
					return {
							a: convertHexToDecimal(match[1]),
							r: parseIntFromHex(match[2]),
							g: parseIntFromHex(match[3]),
							b: parseIntFromHex(match[4]),
							format: named ? "name" : "hex8"
					};
			}
			if ((match = matchers.hex6.exec(color))) {
					return {
							r: parseIntFromHex(match[1]),
							g: parseIntFromHex(match[2]),
							b: parseIntFromHex(match[3]),
							format: named ? "name" : "hex"
					};
			}
			if ((match = matchers.hex3.exec(color))) {
					return {
							r: parseIntFromHex(match[1] + '' + match[1]),
							g: parseIntFromHex(match[2] + '' + match[2]),
							b: parseIntFromHex(match[3] + '' + match[3]),
							format: named ? "name" : "hex"
					};
			}
	
			return false;
	}
	
	function validateWCAG2Parms(parms) {
			// return valid WCAG2 parms for isReadable.
			// If input parms are invalid, return {"level":"AA", "size":"small"}
			var level, size;
			parms = parms || {"level":"AA", "size":"small"};
			level = (parms.level || "AA").toUpperCase();
			size = (parms.size || "small").toLowerCase();
			if (level !== "AA" && level !== "AAA") {
					level = "AA";
			}
			if (size !== "small" && size !== "large") {
					size = "small";
			}
			return {"level":level, "size":size};
	}
	// Node: Export function
	if (typeof module !== "undefined" && module.exports) {
			module.exports = tinycolor;
	}
	// AMD/requirejs: Define the module
	else if (true) {
			!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {return tinycolor;}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	}
	// Browser: Expose to window
	else {
			window.tinycolor = tinycolor;
	}
	
	})();


/***/ }),
/* 2798 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ChromeFields = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(2774);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _color = __webpack_require__(2796);
	
	var _color2 = _interopRequireDefault(_color);
	
	var _reactAddonsShallowCompare = __webpack_require__(1321);
	
	var _reactAddonsShallowCompare2 = _interopRequireDefault(_reactAddonsShallowCompare);
	
	var _common = __webpack_require__(2789);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ChromeFields = exports.ChromeFields = function (_React$Component) {
	  _inherits(ChromeFields, _React$Component);
	
	  function ChromeFields() {
	    var _Object$getPrototypeO;
	
	    var _temp, _this, _ret;
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _classCallCheck(this, ChromeFields);
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_Object$getPrototypeO = Object.getPrototypeOf(ChromeFields)).call.apply(_Object$getPrototypeO, [this].concat(args))), _this), _this.shouldComponentUpdate = _reactAddonsShallowCompare2.default.bind(_this, _this, arguments[0], arguments[1]), _this.state = {
	      view: ''
	    }, _this.handleChange = function (data) {
	      _this.props.onChange(data);
	    }, _this.toggleViews = function () {
	      if (_this.state.view === 'hex') {
	        _this.setState({ view: 'rgb' });
	      } else if (_this.state.view === 'rgb') {
	        _this.setState({ view: 'hsl' });
	      } else if (_this.state.view === 'hsl') {
	        if (_this.props.hsl.a === 1) {
	          _this.setState({ view: 'hex' });
	        } else {
	          _this.setState({ view: 'rgb' });
	        }
	      }
	    }, _this.handleChange = function (data) {
	      if (data.hex) {
	        _color2.default.isValidHex(data.hex) && _this.props.onChange({
	          hex: data.hex,
	          source: 'hex'
	        });
	      } else if (data.r || data.g || data.b) {
	        _this.props.onChange({
	          r: data.r || _this.props.rgb.r,
	          g: data.g || _this.props.rgb.g,
	          b: data.b || _this.props.rgb.b,
	          source: 'rgb'
	        });
	      } else if (data.a) {
	        if (data.a < 0) {
	          data.a = 0;
	        } else if (data.a > 1) {
	          data.a = 1;
	        }
	
	        _this.props.onChange({
	          h: _this.props.hsl.h,
	          s: _this.props.hsl.s,
	          l: _this.props.hsl.l,
	          a: Math.round(data.a * 100) / 100,
	          source: 'rgb'
	        });
	      } else if (data.h || data.s || data.l) {
	
	        _this.props.onChange({
	          h: data.h || _this.props.hsl.h,
	          s: data.s && data.s.replace('%', '') || _this.props.hsl.s,
	          l: data.l && data.l.replace('%', '') || _this.props.hsl.l,
	          source: 'hsl'
	        });
	      }
	    }, _this.showHighlight = function (e) {
	      e.target.style.background = "#eee";
	    }, _this.hideHighlight = function (e) {
	      e.target.style.background = "transparent";
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(ChromeFields, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (this.props.hsl.a === 1 && this.state.view !== 'hex') {
	        this.setState({ view: 'hex' });
	      } else if (this.state.view !== 'rgb' && this.state.view !== 'hsl') {
	        this.setState({ view: 'rgb' });
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.hsl.a !== 1 && this.state.view === 'hex') {
	        this.setState({ view: 'rgb' });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	
	      var styles = (0, _reactcss2.default)({
	        'default': {
	          wrap: {
	            paddingTop: '16px',
	            display: 'flex'
	          },
	          fields: {
	            flex: '1',
	            display: 'flex',
	            marginLeft: '-6px'
	          },
	          field: {
	            paddingLeft: '6px',
	            width: '100%'
	          },
	          alpha: {
	            paddingLeft: '6px',
	            width: '100%'
	          },
	          toggle: {
	            width: '32px',
	            textAlign: 'right',
	            position: 'relative'
	          },
	          icon: {
	            marginRight: '-4px',
	            marginTop: '12px',
	            cursor: 'pointer',
	            position: 'relative'
	          },
	          iconHighlight: {
	            position: 'absolute',
	            width: '24px',
	            height: '28px',
	            background: '#eee',
	            borderRadius: '4px',
	            top: '10px',
	            left: '12px',
	            display: 'none'
	          },
	          input: {
	            fontSize: '11px',
	            color: '#333',
	            width: '100%',
	            borderRadius: '2px',
	            border: 'none',
	            boxShadow: 'inset 0 0 0 1px #dadada',
	            height: '21px',
	            textAlign: 'center'
	          },
	          label: {
	            textTransform: 'uppercase',
	            fontSize: '11px',
	            lineHeight: '11px',
	            color: '#969696',
	            textAlign: 'center',
	            display: 'block',
	            marginTop: '12px'
	          }
	        },
	        'disableAlpha': {
	          alpha: {
	            display: 'none'
	          }
	        }
	      }, this.props, this.state);
	
	      var fields;
	      if (this.state.view === 'hex') {
	        fields = _react2.default.createElement(
	          'div',
	          { style: styles.fields, className: 'flexbox-fix' },
	          _react2.default.createElement(
	            'div',
	            { style: styles.field },
	            _react2.default.createElement(_common.EditableInput, { style: { input: styles.input, label: styles.label }, label: 'hex', value: this.props.hex, onChange: this.handleChange })
	          )
	        );
	      } else if (this.state.view === 'rgb') {
	        fields = _react2.default.createElement(
	          'div',
	          { style: styles.fields, className: 'flexbox-fix' },
	          _react2.default.createElement(
	            'div',
	            { style: styles.field },
	            _react2.default.createElement(_common.EditableInput, { style: { input: styles.input, label: styles.label }, label: 'r', value: this.props.rgb.r, onChange: this.handleChange })
	          ),
	          _react2.default.createElement(
	            'div',
	            { style: styles.field },
	            _react2.default.createElement(_common.EditableInput, { style: { input: styles.input, label: styles.label }, label: 'g', value: this.props.rgb.g, onChange: this.handleChange })
	          ),
	          _react2.default.createElement(
	            'div',
	            { style: styles.field },
	            _react2.default.createElement(_common.EditableInput, { style: { input: styles.input, label: styles.label }, label: 'b', value: this.props.rgb.b, onChange: this.handleChange })
	          ),
	          _react2.default.createElement(
	            'div',
	            { style: styles.alpha },
	            _react2.default.createElement(_common.EditableInput, { style: { input: styles.input, label: styles.label }, label: 'a', value: this.props.rgb.a, arrowOffset: .01, onChange: this.handleChange })
	          )
	        );
	      } else if (this.state.view === 'hsl') {
	        fields = _react2.default.createElement(
	          'div',
	          { style: styles.fields, className: 'flexbox-fix' },
	          _react2.default.createElement(
	            'div',
	            { style: styles.field },
	            _react2.default.createElement(_common.EditableInput, { style: { input: styles.input, label: styles.label }, label: 'h', value: Math.round(this.props.hsl.h), onChange: this.handleChange })
	          ),
	          _react2.default.createElement(
	            'div',
	            { style: styles.field },
	            _react2.default.createElement(_common.EditableInput, { style: { input: styles.input, label: styles.label }, label: 's', value: Math.round(this.props.hsl.s * 100) + '%', onChange: this.handleChange })
	          ),
	          _react2.default.createElement(
	            'div',
	            { style: styles.field },
	            _react2.default.createElement(_common.EditableInput, { style: { input: styles.input, label: styles.label }, label: 'l', value: Math.round(this.props.hsl.l * 100) + '%', onChange: this.handleChange })
	          ),
	          _react2.default.createElement(
	            'div',
	            { style: styles.alpha },
	            _react2.default.createElement(_common.EditableInput, { style: { input: styles.input, label: styles.label }, label: 'a', value: this.props.hsl.a, arrowOffset: .01, onChange: this.handleChange })
	          )
	        );
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { style: styles.wrap, className: 'flexbox-fix' },
	        fields,
	        _react2.default.createElement(
	          'div',
	          { style: styles.toggle },
	          _react2.default.createElement(
	            'div',
	            { style: styles.icon, onClick: this.toggleViews, ref: 'icon' },
	            _react2.default.createElement(
	              'svg',
	              { style: { width: '24px', height: '24px', border: '1px transparent solid', borderRadius: '5px' },
	                viewBox: '0 0 24 24',
	                onMouseOver: this.showHighlight,
	                onMouseEnter: this.showHighlight,
	                onMouseOut: this.hideHighlight },
	              _react2.default.createElement('path', { ref: 'iconUp', fill: '#333', d: 'M12,5.83L15.17,9L16.58,7.59L12,3L7.41,7.59L8.83,9L12,5.83Z' }),
	              _react2.default.createElement('path', { ref: 'iconDown', fill: '#333', d: 'M12,18.17L8.83,15L7.42,16.41L12,21L16.59,16.41L15.17,15Z' })
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return ChromeFields;
	}(_react2.default.Component);
	
	exports.default = ChromeFields;

/***/ }),
/* 2799 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ChromePointer = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(2774);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _reactAddonsShallowCompare = __webpack_require__(1321);
	
	var _reactAddonsShallowCompare2 = _interopRequireDefault(_reactAddonsShallowCompare);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ChromePointer = exports.ChromePointer = function (_React$Component) {
	  _inherits(ChromePointer, _React$Component);
	
	  function ChromePointer() {
	    var _Object$getPrototypeO;
	
	    var _temp, _this, _ret;
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _classCallCheck(this, ChromePointer);
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_Object$getPrototypeO = Object.getPrototypeOf(ChromePointer)).call.apply(_Object$getPrototypeO, [this].concat(args))), _this), _this.shouldComponentUpdate = _reactAddonsShallowCompare2.default.bind(_this, _this, arguments[0], arguments[1]), _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(ChromePointer, [{
	    key: 'render',
	    value: function render() {
	
	      var styles = (0, _reactcss2.default)({
	        'default': {
	          picker: {
	            width: '12px',
	            height: '12px',
	            borderRadius: '6px',
	            transform: 'translate(-6px, -1px)',
	            backgroundColor: 'rgb(248, 248, 248)',
	            boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.37)'
	          }
	        }
	      });
	
	      return _react2.default.createElement('div', { style: styles.picker });
	    }
	  }]);
	
	  return ChromePointer;
	}(_react2.default.Component);
	
	exports.default = ChromePointer;

/***/ }),
/* 2800 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ChromePointerCircle = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(2774);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _reactAddonsShallowCompare = __webpack_require__(1321);
	
	var _reactAddonsShallowCompare2 = _interopRequireDefault(_reactAddonsShallowCompare);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ChromePointerCircle = exports.ChromePointerCircle = function (_React$Component) {
	  _inherits(ChromePointerCircle, _React$Component);
	
	  function ChromePointerCircle() {
	    var _Object$getPrototypeO;
	
	    var _temp, _this, _ret;
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _classCallCheck(this, ChromePointerCircle);
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_Object$getPrototypeO = Object.getPrototypeOf(ChromePointerCircle)).call.apply(_Object$getPrototypeO, [this].concat(args))), _this), _this.shouldComponentUpdate = _reactAddonsShallowCompare2.default.bind(_this, _this, arguments[0], arguments[1]), _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(ChromePointerCircle, [{
	    key: 'render',
	    value: function render() {
	
	      var styles = (0, _reactcss2.default)({
	        'default': {
	          picker: {
	            width: '12px',
	            height: '12px',
	            borderRadius: '6px',
	            boxShadow: 'inset 0 0 0 1px #fff',
	            transform: 'translate(-6px, -6px)'
	          }
	        }
	      });
	
	      return _react2.default.createElement('div', { style: styles.picker });
	    }
	  }]);
	
	  return ChromePointerCircle;
	}(_react2.default.Component);
	
	exports.default = ChromePointerCircle;

/***/ }),
/* 2801 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Compact = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(2774);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _color = __webpack_require__(2796);
	
	var _color2 = _interopRequireDefault(_color);
	
	var _reactAddonsShallowCompare = __webpack_require__(1321);
	
	var _reactAddonsShallowCompare2 = _interopRequireDefault(_reactAddonsShallowCompare);
	
	var _reactMaterialDesign = __webpack_require__(2802);
	
	var _common = __webpack_require__(2789);
	
	var _CompactColor = __webpack_require__(2808);
	
	var _CompactColor2 = _interopRequireDefault(_CompactColor);
	
	var _CompactFields = __webpack_require__(2809);
	
	var _CompactFields2 = _interopRequireDefault(_CompactFields);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Compact = exports.Compact = function (_React$Component) {
	  _inherits(Compact, _React$Component);
	
	  function Compact() {
	    var _Object$getPrototypeO;
	
	    var _temp, _this, _ret;
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _classCallCheck(this, Compact);
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_Object$getPrototypeO = Object.getPrototypeOf(Compact)).call.apply(_Object$getPrototypeO, [this].concat(args))), _this), _this.shouldComponentUpdate = _reactAddonsShallowCompare2.default.bind(_this, _this, arguments[0], arguments[1]), _this.handleChange = function (data) {
	      if (data.hex) {
	        _color2.default.isValidHex(data.hex) && _this.props.onChange({
	          hex: data.hex,
	          source: 'hex'
	        });
	      } else {
	        _this.props.onChange(data);
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Compact, [{
	    key: 'render',
	    value: function render() {
	
	      var styles = (0, _reactcss2.default)({
	        'default': {
	          Compact: {
	            background: '#f6f6f6',
	            radius: '4px'
	          },
	          compact: {
	            paddingTop: '5px',
	            paddingLeft: '5px',
	            boxSizing: 'initial',
	            width: '240px'
	          },
	
	          clear: {
	            clear: 'both'
	          }
	        }
	      });
	
	      var colors = [];
	      if (this.props.colors) {
	        for (var i = 0; i < this.props.colors.length; i++) {
	          var color = this.props.colors[i];
	          colors.push(_react2.default.createElement(_CompactColor2.default, { key: color, color: color, active: color.toLowerCase() == this.props.hex, onClick: this.handleChange }));
	        }
	      }
	
	      return _react2.default.createElement(
	        _reactMaterialDesign.Raised,
	        { style: styles.Compact },
	        _react2.default.createElement(
	          'div',
	          { style: styles.compact },
	          _react2.default.createElement(
	            'div',
	            { ref: 'colors' },
	            colors,
	            _react2.default.createElement('div', { style: styles.clear })
	          ),
	          _react2.default.createElement(_CompactFields2.default, _extends({}, this.props, { onChange: this.handleChange }))
	        )
	      );
	    }
	  }]);
	
	  return Compact;
	}(_react2.default.Component);
	
	Compact.defaultProps = {
	  colors: ['#4D4D4D', '#999999', '#FFFFFF', '#F44E3B', '#FE9200', '#FCDC00', '#DBDF00', '#A4DD00', '#68CCCA', '#73D8FF', '#AEA1FF', '#FDA1FF', '#333333', '#808080', '#cccccc', '#D33115', '#E27300', '#FCC400', '#B0BC00', '#68BC00', '#16A5A5', '#009CE0', '#7B64FF', '#FA28FF', '#000000', '#666666', '#B3B3B3', '#9F0500', '#C45100', '#FB9E00', '#808900', '#194D33', '#0C797D', '#0062B1', '#653294', '#AB149E']
	};
	
	exports.default = (0, _common.ColorWrap)(Compact);

/***/ }),
/* 2802 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true,
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _libComponentsRaised = __webpack_require__(2803);
	
	var _libComponentsRaised2 = _interopRequireDefault(_libComponentsRaised);
	
	var _libComponentsTile = __webpack_require__(2804);
	
	var _libComponentsTile2 = _interopRequireDefault(_libComponentsTile);
	
	var _libComponentsTabs = __webpack_require__(2805);
	
	var _libComponentsTabs2 = _interopRequireDefault(_libComponentsTabs);
	
	exports.Raised = _libComponentsRaised2['default'];
	exports.Tile = _libComponentsTile2['default'];
	exports.Tabs = _libComponentsTabs2['default'];


/***/ }),
/* 2803 */
/***/ (function(module, exports, __webpack_require__) {

	/* jshint node: true, esnext: true */
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(2774);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Raised = function (_React$Component) {
	  _inherits(Raised, _React$Component);
	
	  function Raised() {
	    _classCallCheck(this, Raised);
	
	    return _possibleConstructorReturn(this, Object.getPrototypeOf(Raised).apply(this, arguments));
	  }
	
	  _createClass(Raised, [{
	    key: 'render',
	    value: function render() {
	
	      var styles = (0, _reactcss2.default)({
	        'default': {
	          wrap: {
	            position: 'relative'
	          },
	          content: {
	            position: 'relative'
	          },
	          bg: {
	            absolute: '0px 0px 0px 0px',
	            boxShadow: '0 ${ this.props.zDepth }px ${ this.props.zDepth * 4 }px rgba(0,0,0,.24)',
	            borderRadius: this.props.radius,
	            background: this.props.background
	          }
	        },
	        'zDepth-0': {
	          bg: {
	            boxShadow: 'none'
	          }
	        },
	
	        'zDepth-1': {
	          bg: {
	            boxShadow: '0 2px 10px rgba(0,0,0,.12), 0 2px 5px rgba(0,0,0,.16)'
	          }
	        },
	        'zDepth-2': {
	          bg: {
	            boxShadow: '0 6px 20px rgba(0,0,0,.19), 0 8px 17px rgba(0,0,0,.2)'
	          }
	        },
	        'zDepth-3': {
	          bg: {
	            boxShadow: '0 17px 50px rgba(0,0,0,.19), 0 12px 15px rgba(0,0,0,.24)'
	          }
	        },
	        'zDepth-4': {
	          bg: {
	            boxShadow: '0 25px 55px rgba(0,0,0,.21), 0 16px 28px rgba(0,0,0,.22)'
	          }
	        },
	        'zDepth-5': {
	          bg: {
	            boxShadow: '0 40px 77px rgba(0,0,0,.22), 0 27px 24px rgba(0,0,0,.2)'
	          }
	        },
	        'square': {
	          bg: {
	            borderRadius: '0'
	          }
	        },
	        'circle': {
	          bg: {
	            borderRadius: '50%'
	          }
	        }
	      }, this.props);
	
	      return _react2.default.createElement(
	        'div',
	        { style: styles.wrap },
	        _react2.default.createElement('div', { style: styles.bg }),
	        _react2.default.createElement(
	          'div',
	          { style: styles.content },
	          this.props.children
	        )
	      );
	    }
	  }]);
	
	  return Raised;
	}(_react2.default.Component);
	
	Raised.propTypes = {
	  background: _react2.default.PropTypes.string,
	  zDepth: _react2.default.PropTypes.oneOf(['0', '1', '2', '3', '4', '5', 0, 1, 2, 3, 4, 5]),
	  radius: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.string, _react2.default.PropTypes.number])
	};
	
	Raised.defaultProps = {
	  background: '#fff',
	  zDepth: '1',
	  radius: '2px'
	};
	
	exports.default = Raised;

/***/ }),
/* 2804 */
/***/ (function(module, exports, __webpack_require__) {

	/* jshint node: true, esnext: true */
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(2774);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Tile = function (_React$Component) {
	  _inherits(Tile, _React$Component);
	
	  function Tile() {
	    _classCallCheck(this, Tile);
	
	    return _possibleConstructorReturn(this, Object.getPrototypeOf(Tile).apply(this, arguments));
	  }
	
	  _createClass(Tile, [{
	    key: 'render',
	    value: function render() {
	
	      var styles = (0, _reactcss2.default)({
	        'default': {
	          tile: {
	            fontSize: '16px',
	            padding: '16px',
	            display: 'flex',
	            justifyContent: 'space-between',
	            color: this.props.color
	          },
	          primary: {
	            display: 'flex',
	            width: '100%'
	          },
	          sidebar: {
	            minWidth: '56px',
	            maxWidth: '56px',
	            flexBasis: '56px' },
	          content: {
	            background: 'none',
	            flex: '1',
	            overflow: 'scroll'
	          },
	          secondary: {
	            flexBasis: '42',
	            textAlign: 'center'
	          },
	          sidebarIcon: {
	            marginTop: '-12px',
	            marginLeft: '-12px',
	            marginBottom: '-12px'
	          }
	        },
	        'divider': {
	          tile: {
	            boxShadow: 'inset 0 -1px 0 rgba(0,0,0,.12)'
	          }
	        },
	        'condensed': {
	          tile: {
	            paddingBottom: '0px',
	            paddingTop: '0px'
	          },
	          sidebar: {
	            minWidth: '28px',
	            maxWidth: '28px',
	            flexBasis: '28px'
	          }
	        }
	      }, {
	        'clickable': this.props.onClick
	      }, this.props);
	
	      var _props$children = _slicedToArray(this.props.children, 2);
	
	      var sidebar = _props$children[0];
	      var content = _props$children[1];
	
	
	      return _react2.default.createElement(
	        'div',
	        { style: styles.tile, className: 'flexbox-fix' },
	        _react2.default.createElement(
	          'div',
	          { style: styles.primary, className: 'flexbox-fix' },
	          _react2.default.createElement(
	            'div',
	            { style: styles.sidebar, key: "sidebar-#{ sidebar }" },
	            sidebar
	          ),
	          _react2.default.createElement(
	            'div',
	            { style: styles.content, key: "content-#{ content }" },
	            content
	          )
	        )
	      );
	    }
	  }]);
	
	  return Tile;
	}(_react2.default.Component);
	
	;
	
	exports.default = Tile;

/***/ }),
/* 2805 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(2774);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _isString = __webpack_require__(1399);
	
	var _isString2 = _interopRequireDefault(_isString);
	
	var _Tab = __webpack_require__(2806);
	
	var _Tab2 = _interopRequireDefault(_Tab);
	
	var _Link = __webpack_require__(2807);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// var Ink = require('./Ink');
	
	// var context = {
	//   primaryColor: '#2196F3',
	//   accentColor: '#E91E63',
	//   theme: 'light'
	// }
	
	var Tabs = function (_React$Component) {
	  _inherits(Tabs, _React$Component);
	
	  function Tabs(props) {
	    _classCallCheck(this, Tabs);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(Tabs).call(this));
	
	    var selectedTab;
	    if (props.selectedTab < (props.tabs && props.tabs.length)) {
	      selectedTab = props.selectedTab;
	    } else {
	      selectedTab = 0;
	    }
	
	    _this.state = {
	      selectedTab: selectedTab
	    };
	
	    _this.handleClick = _this.handleClick.bind(_this);
	    _this.slide = _this.slide.bind(_this);
	    return _this;
	  }
	
	  _createClass(Tabs, [{
	    key: 'handleClick',
	    value: function handleClick(tab) {
	      if (this.props.onChange) {
	        this.props.onChange(tab);
	      }
	
	      this.setState({
	        selectedTab: tab
	      });
	    }
	  }, {
	    key: 'slide',
	    value: function slide() {
	      if (this.props.tabs.length) {
	        var containerNode = this.refs.tabs.getDOMNode();
	        var containerLeft = containerNode.scrollLeft;
	        var containerRight = containerNode.offsetWidth + containerNode.scrollLeft;
	
	        var selectedNode = this.refs['tab-' + this.state.selectedTab] && this.refs['tab-' + this.state.selectedTab].getDOMNode();
	        var selectedLeft = selectedNode && selectedNode.getBoundingClientRect().left - containerNode.getBoundingClientRect().left + containerNode.scrollLeft;
	        var selectedRight = selectedNode && selectedLeft + selectedNode.offsetWidth;
	
	        // scroll right if tab is off screen
	        if (selectedRight > containerRight) {
	          containerNode.scrollLeft += selectedRight - containerRight;
	        }
	
	        // scroll left if tab is off screen
	        if (selectedLeft < containerLeft) {
	          containerNode.scrollLeft -= containerLeft - selectedLeft;
	        }
	
	        // slide the indicator
	        var indicator = this.refs.indicator;
	        indicator.style.left = selectedLeft + 'px';
	        indicator.style.width = selectedNode.offsetWidth + 'px';
	        indicator.style.height = '2px';
	      }
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.slide();
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.selectedTab !== this.state.selectedTab) {
	        this.setState({ selectedTab: nextProps.selectedTab });
	      }
	    }
	  }, {
	    key: 'componentWillUpdate',
	    value: function componentWillUpdate(nextProps, nextState) {
	      if (nextState.selectedTab >= (nextProps.tabs && nextProps.tabs.length)) {
	        nextState.selectedTab = nextProps.tabs.length - 1;
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this.slide();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	
	      var styles = (0, _reactcss2.default)({
	        'default': {
	          tabs: {
	            position: 'relative',
	            background: this.props.background
	          },
	          tabWrap: {
	            display: 'flex'
	          },
	          tab: {
	            justifyContent: 'flex-start',
	            minWidth: '68px',
	            maxWidth: '240px'
	          },
	          Tab: {
	            color: this.props.color,
	            inactive: this.props.inactive,
	            capitalize: this.props.capitalize
	          },
	          indicator: {
	            height: '0',
	            position: 'absolute',
	            bottom: '0',
	            left: '0',
	            background: this.props.color,
	            transition: 'all 200ms linear'
	          }
	        },
	        'scrollable': {
	          tabs: {
	            overflowX: 'scroll'
	          },
	          tabWrap: {
	            paddingLeft: '60px',
	            justifyContent: 'flex-start',
	            width: '400%'
	          },
	          tab: {
	            width: 'auto'
	          }
	        },
	        'align-justify': {
	          tabWrap: {
	            justifyContent: 'space-between'
	          },
	          tab: {
	            width: 100 / this.props.tabs.length + '%'
	          }
	        },
	        'align-left': {
	          tabWrap: {
	            paddingLeft: '60px',
	            justifyContent: 'flex-start'
	          },
	          tab: {
	            width: 'auto'
	          }
	        },
	        'align-center': {
	          tabWrap: {
	            justifyContent: 'center'
	          },
	          tab: {
	            width: 'auto'
	          }
	        }
	      }, {
	        'scrollable': this.props.width / this.props.tabs.length < 72
	      }, this.props, this.state);
	
	      var tabs = [];
	      for (var i = 0; i < this.props.tabs.length; i++) {
	        var tab = this.props.tabs[i];
	
	        var label;
	        var callback;
	        var callbackValue;
	        var newTab;
	        if ((0, _isString2.default)(tab)) {
	          label = tab;
	          callback = null;
	        } else {
	          label = tab.label;
	          callback = tab.onClick;
	          callbackValue = tab.callbackValue;
	          newTab = tab.newTab;
	        }
	
	        tabs.push(_react2.default.createElement(
	          'div',
	          { style: styles.tab, ref: 'tab-' + i, key: i },
	          _react2.default.createElement(
	            _Link2.default,
	            { onClick: callback, callbackValue: callbackValue, newTab: newTab },
	            _react2.default.createElement(
	              _Tab2.default,
	              { style: styles.Tab, tab: i, selected: this.state.selectedTab === i, selectable: tab.selectable, onClick: this.handleClick },
	              label
	            )
	          )
	        ));
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { style: styles.tabs, ref: 'tabs' },
	        _react2.default.createElement(
	          'div',
	          { style: styles.tabWrap, className: 'flexbox-fix' },
	          tabs
	        ),
	        _react2.default.createElement('div', { style: styles.indicator, ref: 'indicator' })
	      );
	    }
	  }]);
	
	  return Tabs;
	}(_react2.default.Component);
	
	Tabs.defaultProps = {
	  selectedTab: 0,
	  background: 'transparent',
	  color: '#fff'
	};
	
	exports.default = Tabs;

/***/ }),
/* 2806 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(2774);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Tab = function (_React$Component) {
	  _inherits(Tab, _React$Component);
	
	  function Tab() {
	    _classCallCheck(this, Tab);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(Tab).call(this));
	
	    _this.handleClick = _this.handleClick.bind(_this);
	    return _this;
	  }
	
	  _createClass(Tab, [{
	    key: 'handleClick',
	    value: function handleClick() {
	      if (this.props.selectable !== false) {
	        this.props.onClick(this.props.tab);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	
	      var styles = (0, _reactcss2.default)({
	        'default': {
	          tab: {
	            color: this.props.inactive || this.props.color,
	            cursor: 'pointer',
	            paddingLeft: '12px',
	            paddingRight: '12px',
	            height: '48px',
	            lineHeight: '48px',
	            textAlign: 'center',
	            fontSize: '14px',
	            textTransform: this.props.capitalize === false ? '' : 'uppercase',
	            fontWeight: '500',
	            whiteSpace: 'nowrap',
	            opacity: '.47',
	            transition: 'opacity 100ms linear'
	          }
	        },
	        'selected': {
	          tab: {
	            color: this.props.color,
	            opacity: '.87'
	          }
	        }
	      }, this.props);
	
	      return _react2.default.createElement(
	        'div',
	        { style: styles.tab, onClick: this.handleClick },
	        this.props.children
	      );
	    }
	  }]);
	
	  return Tab;
	}(_react2.default.Component);
	
	Tab.propTypes = {
	  selected: _react2.default.PropTypes.bool
	};
	
	Tab.defaultProps = {
	  selected: false,
	  color: '#fff'
	};
	
	exports.default = Tab;

/***/ }),
/* 2807 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _isString = __webpack_require__(1399);
	
	var _isString2 = _interopRequireDefault(_isString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Link = function (_React$Component) {
	  _inherits(Link, _React$Component);
	
	  function Link() {
	    _classCallCheck(this, Link);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(Link).call(this));
	
	    _this.handleClick = _this.handleClick.bind(_this);
	    return _this;
	  }
	
	  _createClass(Link, [{
	    key: 'handleClick',
	    value: function handleClick(e) {
	      if (this.props.onClick) {
	        this.props.onClick(e, this.props.callbackValue);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	
	      var a;
	      if ((0, _isString2.default)(this.props.onClick)) {
	        a = _react2.default.createElement(
	          'a',
	          { style: { textDecoration: 'none' }, href: this.props.onClick, target: this.props.newTab && '_blank' },
	          this.props.children
	        );
	      } else {
	        a = _react2.default.createElement(
	          'a',
	          { style: { textDecoration: 'none' }, onClick: this.handleClick },
	          this.props.children
	        );
	      }
	
	      return a;
	    }
	  }]);
	
	  return Link;
	}(_react2.default.Component);
	
	// Link.propTypes =
	//   onClick: React.PropTypes.oneOfType(
	//     React.PropTypes.string,
	//     React.PropTypes.func
	//   );
	
	Link.defaultProps = {
	  newTab: false
	};
	
	exports.default = Link;

/***/ }),
/* 2808 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CompactColor = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(2774);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _reactAddonsShallowCompare = __webpack_require__(1321);
	
	var _reactAddonsShallowCompare2 = _interopRequireDefault(_reactAddonsShallowCompare);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CompactColor = exports.CompactColor = function (_React$Component) {
	  _inherits(CompactColor, _React$Component);
	
	  function CompactColor() {
	    var _Object$getPrototypeO;
	
	    var _temp, _this, _ret;
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _classCallCheck(this, CompactColor);
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_Object$getPrototypeO = Object.getPrototypeOf(CompactColor)).call.apply(_Object$getPrototypeO, [this].concat(args))), _this), _this.shouldComponentUpdate = _reactAddonsShallowCompare2.default.bind(_this, _this, arguments[0], arguments[1]), _this.handleClick = function () {
	      _this.props.onClick({ hex: _this.props.color });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(CompactColor, [{
	    key: 'render',
	    value: function render() {
	
	      var styles = (0, _reactcss2.default)({
	        'default': {
	          color: {
	            background: this.props.color,
	            width: '15px',
	            height: '15px',
	            float: 'left',
	            marginRight: '5px',
	            marginBottom: '5px',
	            position: 'relative',
	            cursor: 'pointer'
	          },
	          dot: {
	            absolute: '5px 5px 5px 5px',
	            background: '#fff',
	            borderRadius: '50%',
	            opacity: '0'
	          }
	        },
	        'active': {
	          dot: {
	            opacity: '1'
	          }
	        },
	        'color-#FFFFFF': {
	          color: {
	            boxShadow: 'inset 0 0 0 1px #ddd'
	          },
	          dot: {
	            background: '#000'
	          }
	        }
	      }, this.props);
	
	      return _react2.default.createElement(
	        'div',
	        { style: styles.color, ref: 'color', onClick: this.handleClick },
	        _react2.default.createElement('div', { style: styles.dot })
	      );
	    }
	  }]);
	
	  return CompactColor;
	}(_react2.default.Component);
	
	exports.default = CompactColor;

/***/ }),
/* 2809 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CompactColor = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(2774);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _reactAddonsShallowCompare = __webpack_require__(1321);
	
	var _reactAddonsShallowCompare2 = _interopRequireDefault(_reactAddonsShallowCompare);
	
	var _common = __webpack_require__(2789);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CompactColor = exports.CompactColor = function (_React$Component) {
	  _inherits(CompactColor, _React$Component);
	
	  function CompactColor() {
	    var _Object$getPrototypeO;
	
	    var _temp, _this, _ret;
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _classCallCheck(this, CompactColor);
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_Object$getPrototypeO = Object.getPrototypeOf(CompactColor)).call.apply(_Object$getPrototypeO, [this].concat(args))), _this), _this.shouldComponentUpdate = _reactAddonsShallowCompare2.default.bind(_this, _this, arguments[0], arguments[1]), _this.handleChange = function (data) {
	      if (data.r || data.g || data.b) {
	        _this.props.onChange({
	          r: data.r || _this.props.rgb.r,
	          g: data.g || _this.props.rgb.g,
	          b: data.b || _this.props.rgb.b,
	          source: 'rgb'
	        });
	      } else {
	        _this.props.onChange({
	          hex: data,
	          source: 'hex'
	        });
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(CompactColor, [{
	    key: 'render',
	    value: function render() {
	
	      var styles = (0, _reactcss2.default)({
	        'default': {
	          fields: {
	            display: 'flex',
	            paddingBottom: '6px',
	            paddingRight: '5px',
	            position: 'relative'
	          },
	          active: {
	            position: 'absolute',
	            top: '6px',
	            left: '5px',
	            height: '9px',
	            width: '9px',
	            background: '#' + this.props.hex
	          },
	          HEXwrap: {
	            flex: '6',
	            position: 'relative'
	          },
	          HEXinput: {
	            width: '80%',
	            padding: '0px',
	            paddingLeft: '20%',
	            border: 'none',
	            outline: 'none',
	            background: 'none',
	            fontSize: '12px',
	            color: '#333',
	            height: '16px'
	          },
	          HEXlabel: {
	            display: 'none'
	          },
	          RGBwrap: {
	            flex: '3',
	            position: 'relative'
	          },
	          RGBinput: {
	            width: '70%',
	            padding: '0px',
	            paddingLeft: '30%',
	            border: 'none',
	            outline: 'none',
	            background: 'none',
	            fontSize: '12px',
	            color: '#333',
	            height: '16px'
	          },
	          RGBlabel: {
	            position: 'absolute',
	            top: '3px',
	            left: '0px',
	            lineHeight: '16px',
	            textTransform: 'uppercase',
	            fontSize: '12px',
	            color: '#999'
	          }
	        }
	      });
	
	      return _react2.default.createElement(
	        'div',
	        { style: styles.fields, className: 'flexbox-fix' },
	        _react2.default.createElement('div', { style: styles.active }),
	        _react2.default.createElement(_common.EditableInput, { style: { wrap: styles.HEXwrap, input: styles.HEXinput, label: styles.HEXlabel }, label: 'hex', value: this.props.hex, onChange: this.handleChange }),
	        _react2.default.createElement(_common.EditableInput, { style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel }, label: 'r', value: this.props.rgb.r, onChange: this.handleChange }),
	        _react2.default.createElement(_common.EditableInput, { style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel }, label: 'g', value: this.props.rgb.g, onChange: this.handleChange }),
	        _react2.default.createElement(_common.EditableInput, { style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel }, label: 'b', value: this.props.rgb.b, onChange: this.handleChange })
	      );
	    }
	  }]);
	
	  return CompactColor;
	}(_react2.default.Component);
	
	exports.default = CompactColor;

/***/ }),
/* 2810 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Material = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(2774);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _color = __webpack_require__(2796);
	
	var _color2 = _interopRequireDefault(_color);
	
	var _reactAddonsShallowCompare = __webpack_require__(1321);
	
	var _reactAddonsShallowCompare2 = _interopRequireDefault(_reactAddonsShallowCompare);
	
	var _reactMaterialDesign = __webpack_require__(2802);
	
	var _common = __webpack_require__(2789);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Material = exports.Material = function (_React$Component) {
	  _inherits(Material, _React$Component);
	
	  function Material() {
	    var _Object$getPrototypeO;
	
	    var _temp, _this, _ret;
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _classCallCheck(this, Material);
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_Object$getPrototypeO = Object.getPrototypeOf(Material)).call.apply(_Object$getPrototypeO, [this].concat(args))), _this), _this.shouldComponentUpdate = _reactAddonsShallowCompare2.default.bind(_this, _this, arguments[0], arguments[1]), _this.handleChange = function (data) {
	      if (data.hex) {
	        _color2.default.isValidHex(data.hex) && _this.props.onChange({
	          hex: data.hex,
	          source: 'hex'
	        });
	      } else if (data.r || data.g || data.b) {
	        _this.props.onChange({
	          r: data.r || _this.props.rgb.r,
	          g: data.g || _this.props.rgb.g,
	          b: data.b || _this.props.rgb.b,
	          source: 'rgb'
	        });
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Material, [{
	    key: 'render',
	    value: function render() {
	
	      var styles = (0, _reactcss2.default)({
	        'default': {
	          material: {
	            width: '98px',
	            height: '98px',
	            padding: '16px',
	            fontFamily: 'Roboto'
	          },
	          HEXwrap: {
	            position: 'relative'
	          },
	          HEXinput: {
	            width: '100%',
	            marginTop: '12px',
	            fontSize: '15px',
	            color: '#333',
	            padding: '0px',
	            border: '0px',
	            borderBottom: '2px solid ' + this.props.hex,
	            outline: 'none',
	            height: '30px'
	          },
	          HEXlabel: {
	            position: 'absolute',
	            top: '0px',
	            left: '0px',
	            fontSize: '11px',
	            color: '#999999',
	            textTransform: 'capitalize'
	          },
	          Hex: {
	            style: {}
	          },
	          RGBwrap: {
	            position: 'relative'
	          },
	          RGBinput: {
	            width: '100%',
	            marginTop: '12px',
	            fontSize: '15px',
	            color: '#333',
	            padding: '0px',
	            border: '0px',
	            borderBottom: '1px solid #eee',
	            outline: 'none',
	            height: '30px'
	          },
	          RGBlabel: {
	            position: 'absolute',
	            top: '0px',
	            left: '0px',
	            fontSize: '11px',
	            color: '#999999',
	            textTransform: 'capitalize'
	          },
	          split: {
	            display: 'flex',
	            marginRight: '-10px',
	            paddingTop: '11px'
	          },
	          third: {
	            flex: '1',
	            paddingRight: '10px'
	          }
	        }
	      });
	
	      return _react2.default.createElement(
	        _reactMaterialDesign.Raised,
	        null,
	        _react2.default.createElement(
	          'div',
	          { style: styles.material },
	          _react2.default.createElement(_common.EditableInput, { style: { wrap: styles.HEXwrap, input: styles.HEXinput, label: styles.HEXlabel }, label: 'hex', value: this.props.hex, onChange: this.handleChange }),
	          _react2.default.createElement(
	            'div',
	            { style: styles.split, className: 'flexbox-fix' },
	            _react2.default.createElement(
	              'div',
	              { style: styles.third },
	              _react2.default.createElement(_common.EditableInput, { style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel }, label: 'r', value: this.props.rgb.r, onChange: this.handleChange })
	            ),
	            _react2.default.createElement(
	              'div',
	              { style: styles.third },
	              _react2.default.createElement(_common.EditableInput, { style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel }, label: 'g', value: this.props.rgb.g, onChange: this.handleChange })
	            ),
	            _react2.default.createElement(
	              'div',
	              { style: styles.third },
	              _react2.default.createElement(_common.EditableInput, { style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel }, label: 'b', value: this.props.rgb.b, onChange: this.handleChange })
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Material;
	}(_react2.default.Component);
	
	exports.default = (0, _common.ColorWrap)(Material);

/***/ }),
/* 2811 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Photoshop = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(2774);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _reactAddonsShallowCompare = __webpack_require__(1321);
	
	var _reactAddonsShallowCompare2 = _interopRequireDefault(_reactAddonsShallowCompare);
	
	var _common = __webpack_require__(2789);
	
	var _PhotoshopFields = __webpack_require__(2812);
	
	var _PhotoshopFields2 = _interopRequireDefault(_PhotoshopFields);
	
	var _PhotoshopPointerCircle = __webpack_require__(2813);
	
	var _PhotoshopPointerCircle2 = _interopRequireDefault(_PhotoshopPointerCircle);
	
	var _PhotoshopPointer = __webpack_require__(2814);
	
	var _PhotoshopPointer2 = _interopRequireDefault(_PhotoshopPointer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Photoshop = exports.Photoshop = function (_React$Component) {
	  _inherits(Photoshop, _React$Component);
	
	  function Photoshop(props) {
	    _classCallCheck(this, Photoshop);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(Photoshop).call(this));
	
	    _this.shouldComponentUpdate = _reactAddonsShallowCompare2.default.bind(_this, _this, arguments[0], arguments[1]);
	
	    _this.handleChange = function (data) {
	      _this.props.onChange(data);
	    };
	
	    _this.handleAccept = function () {
	      _this.props.onAccept && _this.props.onAccept();
	    };
	
	    _this.handleCancel = function () {
	      _this.props.onCancel && _this.props.onCancel();
	    };
	
	    _this.state = {
	      currentColor: props.hex
	    };
	    return _this;
	  }
	
	  _createClass(Photoshop, [{
	    key: 'render',
	    value: function render() {
	
	      var styles = (0, _reactcss2.default)({
	        'default': {
	          picker: {
	            background: '#DCDCDC',
	            borderRadius: '4px',
	            boxShadow: '0 0 0 1px rgba(0,0,0,.25), 0 8px 16px rgba(0,0,0,.15)',
	            boxSizing: 'initial',
	            width: '513px'
	          },
	          head: {
	            backgroundImage: 'linear-gradient(-180deg, #F0F0F0 0%, #D4D4D4 100%)',
	            borderBottom: '1px solid #B1B1B1',
	            boxShadow: 'inset 0 1px 0 0 rgba(255,255,255,.2), inset 0 -1px 0 0 rgba(0,0,0,.02)',
	            height: '23px',
	            lineHeight: '24px',
	            borderRadius: '4px 4px 0 0',
	            fontSize: '13px',
	            color: '#4D4D4D',
	            textAlign: 'center'
	          },
	          body: {
	            padding: '15px 15px 0',
	            display: 'flex'
	          },
	          saturation: {
	            width: '256px',
	            height: '256px',
	            position: 'relative',
	            border: '2px solid #B3B3B3',
	            borderBottom: '2px solid #F0F0F0',
	            overflow: 'hidden'
	          },
	          hue: {
	            position: 'relative',
	            height: '256px',
	            width: '19px',
	            marginLeft: '10px',
	            border: '2px solid #B3B3B3',
	            borderBottom: '2px solid #F0F0F0'
	          },
	          Hue: {
	            direction: 'vertical'
	          },
	          controls: {
	            width: '180px',
	            marginLeft: '10px'
	          },
	
	          top: {
	            display: 'flex'
	          },
	          previews: {
	            width: '60px'
	          },
	          swatches: {
	            border: '1px solid #B3B3B3',
	            borderBottom: '1px solid #F0F0F0',
	            marginBottom: '2px',
	            marginTop: '1px'
	          },
	          new: {
	            height: '34px',
	            background: 'rgb(' + this.props.rgb.r + ', ' + this.props.rgb.g + ', ' + this.props.rgb.b + ')',
	            boxShadow: 'inset 1px 0 0 #000, inset -1px 0 0 #000, inset 0 1px 0 #000'
	          },
	          current: {
	            height: '34px',
	            background: '#' + this.state.currentColor,
	            boxShadow: 'inset 1px 0 0 #000, inset -1px 0 0 #000, inset 0 -1px 0 #000'
	          },
	          label: {
	            fontSize: '14px',
	            color: '#000',
	            textAlign: 'center'
	          },
	          actions: {
	            flex: '1',
	            marginLeft: '20px'
	          },
	          button: {
	            backgroundImage: 'linear-gradient(-180deg, #FFFFFF 0%, #E6E6E6 100%)',
	            border: '1px solid #878787',
	            borderRadius: '2px',
	            height: '20px',
	            boxShadow: '0 1px 0 0 #EAEAEA',
	            fontSize: '14px',
	            color: '#000',
	            lineHeight: '20px',
	            textAlign: 'center',
	            marginBottom: '10px'
	          },
	          acceptButton: _defineProperty({
	            backgroundImage: 'linear-gradient(-180deg, #FFFFFF 0%, #E6E6E6 100%)',
	            border: '1px solid #878787',
	            borderRadius: '2px',
	            height: '20px',
	            boxShadow: '0 1px 0 0 #EAEAEA',
	            fontSize: '14px',
	            color: '#000',
	            lineHeight: '20px',
	            textAlign: 'center',
	            marginBottom: '10px'
	          }, 'boxShadow', '0 0 0 1px #878787')
	        }
	      });
	
	      var header;
	
	      if (this.props.header) {
	        header = _react2.default.createElement(
	          'div',
	          { style: styles.head },
	          this.props.header
	        );
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { style: styles.picker },
	        header,
	        _react2.default.createElement(
	          'div',
	          { style: styles.body, className: 'flexbox-fix' },
	          _react2.default.createElement(
	            'div',
	            { style: styles.saturation },
	            _react2.default.createElement(_common.Saturation, _extends({ style: styles.Saturation }, this.props, { pointer: _PhotoshopPointerCircle2.default, onChange: this.handleChange }))
	          ),
	          _react2.default.createElement(
	            'div',
	            { style: styles.hue },
	            _react2.default.createElement(_common.Hue, _extends({}, styles.Hue, this.props, { pointer: _PhotoshopPointer2.default, onChange: this.handleChange }))
	          ),
	          _react2.default.createElement(
	            'div',
	            { style: styles.controls },
	            _react2.default.createElement(
	              'div',
	              { style: styles.top, className: 'flexbox-fix' },
	              _react2.default.createElement(
	                'div',
	                { style: styles.previews },
	                _react2.default.createElement(
	                  'div',
	                  { style: styles.label },
	                  'new'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { style: styles.swatches },
	                  _react2.default.createElement('div', { style: styles.new }),
	                  _react2.default.createElement('div', { style: styles.current })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { style: styles.label },
	                  'current'
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { style: styles.actions },
	                _react2.default.createElement(
	                  'div',
	                  { style: styles.acceptButton, ref: 'accept', onClick: this.handleAccept },
	                  'OK'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { style: styles.button, ref: 'cancel', onClick: this.handleCancel },
	                  'Cancel'
	                ),
	                _react2.default.createElement(_PhotoshopFields2.default, this.props)
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Photoshop;
	}(_react2.default.Component);
	
	Photoshop.defaultProps = {
	  header: 'Color Picker'
	};
	
	exports.default = (0, _common.ColorWrap)(Photoshop);

/***/ }),
/* 2812 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PhotoshopPicker = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(2774);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _color = __webpack_require__(2796);
	
	var _color2 = _interopRequireDefault(_color);
	
	var _reactAddonsShallowCompare = __webpack_require__(1321);
	
	var _reactAddonsShallowCompare2 = _interopRequireDefault(_reactAddonsShallowCompare);
	
	var _common = __webpack_require__(2789);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PhotoshopPicker = exports.PhotoshopPicker = function (_React$Component) {
	  _inherits(PhotoshopPicker, _React$Component);
	
	  function PhotoshopPicker() {
	    var _Object$getPrototypeO;
	
	    var _temp, _this, _ret;
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _classCallCheck(this, PhotoshopPicker);
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_Object$getPrototypeO = Object.getPrototypeOf(PhotoshopPicker)).call.apply(_Object$getPrototypeO, [this].concat(args))), _this), _this.shouldComponentUpdate = _reactAddonsShallowCompare2.default.bind(_this, _this, arguments[0], arguments[1]), _this.handleChange = function (data) {
	      if (data['#']) {
	        _color2.default.isValidHex(data['#']) && _this.props.onChange({
	          hex: data['#'],
	          source: 'hex'
	        });
	      } else if (data.r || data.g || data.b) {
	        _this.props.onChange({
	          r: data.r || _this.props.rgb.r,
	          g: data.g || _this.props.rgb.g,
	          b: data.b || _this.props.rgb.b,
	          source: 'rgb'
	        });
	      } else if (data.h || data.s || data.v) {
	        _this.props.onChange({
	          h: data.h || _this.props.hsv.h,
	          s: data.s || _this.props.hsv.s,
	          v: data.v || _this.props.hsv.v,
	          source: 'hsv'
	        });
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(PhotoshopPicker, [{
	    key: 'render',
	    value: function render() {
	
	      var styles = (0, _reactcss2.default)({
	        'default': {
	          fields: {
	            paddingTop: '5px',
	            paddingBottom: '9px',
	            width: '80px',
	            position: 'relative'
	          },
	          divider: {
	            height: '5px'
	          },
	          RGBwrap: {
	            position: 'relative'
	          },
	          RGBinput: {
	            marginLeft: '40%',
	            width: '40%',
	            height: '18px',
	            border: '1px solid #888888',
	            boxShadow: 'inset 0 1px 1px rgba(0,0,0,.1), 0 1px 0 0 #ECECEC',
	            marginBottom: '5px',
	            fontSize: '13px',
	            paddingLeft: '3px',
	            marginRight: '10px'
	          },
	          RGBlabel: {
	            left: '0px',
	            width: '34px',
	            textTransform: 'uppercase',
	            fontSize: '13px',
	            height: '18px',
	            lineHeight: '22px',
	            position: 'absolute'
	          },
	          HEXwrap: {
	            position: 'relative'
	          },
	          HEXinput: {
	            marginLeft: '20%',
	            width: '80%',
	            height: '18px',
	            border: '1px solid #888888',
	            boxShadow: 'inset 0 1px 1px rgba(0,0,0,.1), 0 1px 0 0 #ECECEC',
	            marginBottom: '6px',
	            fontSize: '13px',
	            paddingLeft: '3px'
	          },
	          HEXlabel: {
	            position: 'absolute',
	            top: '0px',
	            left: '0px',
	            width: '14px',
	            textTransform: 'uppercase',
	            fontSize: '13px',
	            height: '18px',
	            lineHeight: '22px'
	          },
	          fieldSymbols: {
	            position: 'absolute',
	            top: '5px',
	            right: '-7px',
	            fontSize: '13px'
	          },
	          symbol: {
	            height: '20px',
	            lineHeight: '22px',
	            paddingBottom: '7px'
	          }
	        }
	      });
	
	      return _react2.default.createElement(
	        'div',
	        { style: styles.fields },
	        _react2.default.createElement(_common.EditableInput, { style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel }, label: 'h', value: Math.round(this.props.hsv.h), onChange: this.handleChange }),
	        _react2.default.createElement(_common.EditableInput, { style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel }, label: 's', value: Math.round(this.props.hsv.s * 100), onChange: this.handleChange }),
	        _react2.default.createElement(_common.EditableInput, { style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel }, label: 'v', value: Math.round(this.props.hsv.v * 100), onChange: this.handleChange }),
	        _react2.default.createElement('div', { style: styles.divider }),
	        _react2.default.createElement(_common.EditableInput, { style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel }, label: 'r', value: this.props.rgb.r, onChange: this.handleChange }),
	        _react2.default.createElement(_common.EditableInput, { style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel }, label: 'g', value: this.props.rgb.g, onChange: this.handleChange }),
	        _react2.default.createElement(_common.EditableInput, { style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel }, label: 'b', value: this.props.rgb.b, onChange: this.handleChange }),
	        _react2.default.createElement('div', { style: styles.divider }),
	        _react2.default.createElement(_common.EditableInput, { style: { wrap: styles.HEXwrap, input: styles.HEXinput, label: styles.HEXlabel }, label: '#', value: this.props.hex.replace('#', ''), onChange: this.handleChange }),
	        _react2.default.createElement(
	          'div',
	          { style: styles.fieldSymbols },
	          _react2.default.createElement(
	            'div',
	            { style: styles.symbol },
	            '°'
	          ),
	          _react2.default.createElement(
	            'div',
	            { style: styles.symbol },
	            '%'
	          ),
	          _react2.default.createElement(
	            'div',
	            { style: styles.symbol },
	            '%'
	          )
	        )
	      );
	    }
	  }]);
	
	  return PhotoshopPicker;
	}(_react2.default.Component);
	
	exports.default = PhotoshopPicker;

/***/ }),
/* 2813 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PhotoshopPointerCircle = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(2774);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _reactAddonsShallowCompare = __webpack_require__(1321);
	
	var _reactAddonsShallowCompare2 = _interopRequireDefault(_reactAddonsShallowCompare);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PhotoshopPointerCircle = exports.PhotoshopPointerCircle = function (_React$Component) {
	  _inherits(PhotoshopPointerCircle, _React$Component);
	
	  function PhotoshopPointerCircle() {
	    var _Object$getPrototypeO;
	
	    var _temp, _this, _ret;
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _classCallCheck(this, PhotoshopPointerCircle);
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_Object$getPrototypeO = Object.getPrototypeOf(PhotoshopPointerCircle)).call.apply(_Object$getPrototypeO, [this].concat(args))), _this), _this.shouldComponentUpdate = _reactAddonsShallowCompare2.default.bind(_this, _this, arguments[0], arguments[1]), _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(PhotoshopPointerCircle, [{
	    key: 'render',
	    value: function render() {
	
	      var styles = (0, _reactcss2.default)({
	        'default': {
	          picker: {
	            width: '12px',
	            height: '12px',
	            borderRadius: '6px',
	            boxShadow: 'inset 0 0 0 1px #fff',
	            transform: 'translate(-6px, -6px)'
	          }
	        },
	        'black-outline': {
	          picker: {
	            boxShadow: 'inset 0 0 0 1px #000'
	          }
	        }
	      }, {
	        'black-outline': this.props.hsl.l > .5
	      });
	
	      return _react2.default.createElement('div', { style: styles.picker });
	    }
	  }]);
	
	  return PhotoshopPointerCircle;
	}(_react2.default.Component);
	
	exports.default = PhotoshopPointerCircle;

/***/ }),
/* 2814 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PhotoshopPointerCircle = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(2774);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _reactAddonsShallowCompare = __webpack_require__(1321);
	
	var _reactAddonsShallowCompare2 = _interopRequireDefault(_reactAddonsShallowCompare);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PhotoshopPointerCircle = exports.PhotoshopPointerCircle = function (_React$Component) {
	  _inherits(PhotoshopPointerCircle, _React$Component);
	
	  function PhotoshopPointerCircle() {
	    var _Object$getPrototypeO;
	
	    var _temp, _this, _ret;
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _classCallCheck(this, PhotoshopPointerCircle);
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_Object$getPrototypeO = Object.getPrototypeOf(PhotoshopPointerCircle)).call.apply(_Object$getPrototypeO, [this].concat(args))), _this), _this.shouldComponentUpdate = _reactAddonsShallowCompare2.default.bind(_this, _this, arguments[0], arguments[1]), _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(PhotoshopPointerCircle, [{
	    key: 'render',
	    value: function render() {
	
	      var styles = (0, _reactcss2.default)({
	        'default': {
	          triangle: {
	            width: 0,
	            height: 0,
	            borderStyle: 'solid',
	            borderWidth: '4px 0 4px 6px',
	            borderColor: 'transparent transparent transparent #fff',
	            position: 'absolute',
	            top: '1px',
	            left: '1px'
	          },
	          triangleBorder: {
	            width: 0,
	            height: 0,
	            borderStyle: 'solid',
	            borderWidth: '5px 0 5px 8px',
	            borderColor: 'transparent transparent transparent #555'
	          },
	
	          left: {
	            Extend: 'triangleBorder',
	            transform: 'translate(-13px, -4px)'
	          },
	          leftInside: {
	            Extend: 'triangle',
	            transform: 'translate(-8px, -5px)'
	          },
	
	          right: {
	            Extend: 'triangleBorder',
	            transform: 'translate(20px, -14px) rotate(180deg)'
	          },
	          rightInside: {
	            Extend: 'triangle',
	            transform: 'translate(-8px, -5px)'
	          }
	        }
	      });
	
	      return _react2.default.createElement(
	        'div',
	        { style: styles.pointer },
	        _react2.default.createElement(
	          'div',
	          { style: styles.left },
	          _react2.default.createElement('div', { style: styles.leftInside })
	        ),
	        _react2.default.createElement(
	          'div',
	          { style: styles.right },
	          _react2.default.createElement('div', { style: styles.rightInside })
	        )
	      );
	    }
	  }]);
	
	  return PhotoshopPointerCircle;
	}(_react2.default.Component);
	
	exports.default = PhotoshopPointerCircle;

/***/ }),
/* 2815 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Sketch = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(2774);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _reactAddonsShallowCompare = __webpack_require__(1321);
	
	var _reactAddonsShallowCompare2 = _interopRequireDefault(_reactAddonsShallowCompare);
	
	var _common = __webpack_require__(2789);
	
	var _SketchFields = __webpack_require__(2816);
	
	var _SketchFields2 = _interopRequireDefault(_SketchFields);
	
	var _SketchPresetColors = __webpack_require__(2817);
	
	var _SketchPresetColors2 = _interopRequireDefault(_SketchPresetColors);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Sketch = exports.Sketch = function (_React$Component) {
	  _inherits(Sketch, _React$Component);
	
	  function Sketch() {
	    var _Object$getPrototypeO;
	
	    var _temp, _this, _ret;
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _classCallCheck(this, Sketch);
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_Object$getPrototypeO = Object.getPrototypeOf(Sketch)).call.apply(_Object$getPrototypeO, [this].concat(args))), _this), _this.shouldComponentUpdate = _reactAddonsShallowCompare2.default.bind(_this, _this, arguments[0], arguments[1]), _this.handleChange = function (data) {
	      _this.props.onChange(data);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Sketch, [{
	    key: 'render',
	    value: function render() {
	
	      var styles = (0, _reactcss2.default)({
	        'default': {
	          picker: {
	            width: this.props.width,
	            padding: '10px 10px 0',
	            boxSizing: 'initial',
	            background: '#fff',
	            borderRadius: '4px',
	            boxShadow: '0 0 0 1px rgba(0,0,0,.15), 0 8px 16px rgba(0,0,0,.15)'
	          },
	          saturation: {
	            width: '100%',
	            paddingBottom: '75%',
	            position: 'relative',
	            overflow: 'hidden'
	          },
	          Saturation: {
	            radius: '3px',
	            shadow: 'inset 0 0 0 1px rgba(0,0,0,.15), inset 0 0 4px rgba(0,0,0,.25)'
	          },
	          controls: {
	            display: 'flex'
	          },
	          sliders: {
	            padding: '4px 0',
	            flex: '1'
	          },
	          color: {
	            width: '24px',
	            height: '24px',
	            position: 'relative',
	            marginTop: '4px',
	            marginLeft: '4px',
	            borderRadius: '3px'
	          },
	          activeColor: {
	            absolute: '0px 0px 0px 0px',
	            borderRadius: '2px',
	            background: 'rgba(' + this.props.rgb.r + ', ' + this.props.rgb.g + ', ' + this.props.rgb.b + ', ' + this.props.rgb.a + ')',
	            boxShadow: 'inset 0 0 0 1px rgba(0,0,0,.15), inset 0 0 4px rgba(0,0,0,.25)'
	          },
	          hue: {
	            position: 'relative',
	            height: '10px',
	            overflow: 'hidden'
	          },
	          Hue: {
	            radius: '2px',
	            shadow: 'inset 0 0 0 1px rgba(0,0,0,.15), inset 0 0 4px rgba(0,0,0,.25)'
	          },
	
	          alpha: {
	            position: 'relative',
	            height: '10px',
	            marginTop: '4px',
	            overflow: 'hidden'
	          },
	          Alpha: {
	            radius: '2px',
	            shadow: 'inset 0 0 0 1px rgba(0,0,0,.15), inset 0 0 4px rgba(0,0,0,.25)'
	          }
	        },
	        'disableAlpha': {
	          color: {
	            height: '10px'
	          },
	          hue: {
	            height: '10px'
	          },
	          alpha: {
	            display: 'none'
	          }
	        }
	      }, this.props);
	
	      return _react2.default.createElement(
	        'div',
	        { style: styles.picker },
	        _react2.default.createElement(
	          'div',
	          { style: styles.saturation },
	          _react2.default.createElement(_common.Saturation, _extends({ style: styles.Saturation }, this.props, { onChange: this.handleChange }))
	        ),
	        _react2.default.createElement(
	          'div',
	          { style: styles.controls, className: 'flexbox-fix' },
	          _react2.default.createElement(
	            'div',
	            { style: styles.sliders },
	            _react2.default.createElement(
	              'div',
	              { style: styles.hue },
	              _react2.default.createElement(_common.Hue, _extends({ style: styles.Hue }, this.props, { onChange: this.handleChange }))
	            ),
	            _react2.default.createElement(
	              'div',
	              { style: styles.alpha },
	              _react2.default.createElement(_common.Alpha, _extends({ style: styles.Alpha }, this.props, { onChange: this.handleChange }))
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { style: styles.color },
	            _react2.default.createElement(_common.Checkboard, null),
	            _react2.default.createElement('div', { style: styles.activeColor })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { style: styles.fields },
	          _react2.default.createElement(_SketchFields2.default, _extends({}, this.props, { onChange: this.handleChange, disableAlpha: this.props.disableAlpha }))
	        ),
	        _react2.default.createElement(
	          'div',
	          { style: styles.presets },
	          _react2.default.createElement(_SketchPresetColors2.default, { colors: this.props.presetColors, onClick: this.handleChange })
	        )
	      );
	    }
	  }]);
	
	  return Sketch;
	}(_react2.default.Component);
	
	Sketch.defaultProps = {
	  presetColors: ['#D0021B', '#F5A623', '#F8E71C', '#8B572A', '#7ED321', '#417505', '#BD10E0', '#9013FE', '#4A90E2', '#50E3C2', '#B8E986', '#000000', '#4A4A4A', '#9B9B9B', '#FFFFFF'],
	  width: 200
	};
	
	exports.default = (0, _common.ColorWrap)(Sketch);

/***/ }),
/* 2816 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ShetchFields = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(2774);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _color = __webpack_require__(2796);
	
	var _color2 = _interopRequireDefault(_color);
	
	var _reactAddonsShallowCompare = __webpack_require__(1321);
	
	var _reactAddonsShallowCompare2 = _interopRequireDefault(_reactAddonsShallowCompare);
	
	var _common = __webpack_require__(2789);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ShetchFields = exports.ShetchFields = function (_React$Component) {
	  _inherits(ShetchFields, _React$Component);
	
	  function ShetchFields() {
	    var _Object$getPrototypeO;
	
	    var _temp, _this, _ret;
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _classCallCheck(this, ShetchFields);
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_Object$getPrototypeO = Object.getPrototypeOf(ShetchFields)).call.apply(_Object$getPrototypeO, [this].concat(args))), _this), _this.shouldComponentUpdate = _reactAddonsShallowCompare2.default.bind(_this, _this, arguments[0], arguments[1]), _this.handleChange = function (data) {
	      if (data.hex) {
	        _color2.default.isValidHex(data.hex) && _this.props.onChange({
	          hex: data.hex,
	          source: 'hex'
	        });
	      } else if (data.r || data.g || data.b) {
	        _this.props.onChange({
	          r: data.r || _this.props.rgb.r,
	          g: data.g || _this.props.rgb.g,
	          b: data.b || _this.props.rgb.b,
	          a: _this.props.rgb.a,
	          source: 'rgb'
	        });
	      } else if (data.a) {
	        if (data.a < 0) {
	          data.a = 0;
	        } else if (data.a > 100) {
	          data.a = 100;
	        }
	
	        data.a = data.a / 100;
	        _this.props.onChange({
	          h: _this.props.hsl.h,
	          s: _this.props.hsl.s,
	          l: _this.props.hsl.l,
	          a: data.a,
	          source: 'rgb'
	        });
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(ShetchFields, [{
	    key: 'render',
	    value: function render() {
	
	      var styles = (0, _reactcss2.default)({
	        'default': {
	          fields: {
	            display: 'flex',
	            paddingTop: '4px'
	          },
	          single: {
	            flex: '1',
	            paddingLeft: '6px'
	          },
	          alpha: {
	            flex: '1',
	            paddingLeft: '6px'
	          },
	          double: {
	            flex: '2'
	          },
	          input: {
	            width: '80%',
	            padding: '4px 10% 3px',
	            border: 'none',
	            boxShadow: 'inset 0 0 0 1px #ccc',
	            fontSize: '11px'
	          },
	          label: {
	            display: 'block',
	            textAlign: 'center',
	            fontSize: '11px',
	            color: '#222',
	            paddingTop: '3px',
	            paddingBottom: '4px',
	            textTransform: 'capitalize'
	          }
	        },
	        'disableAlpha': {
	          alpha: {
	            display: 'none'
	          }
	        }
	      }, this.props);
	
	      return _react2.default.createElement(
	        'div',
	        { style: styles.fields, className: 'flexbox-fix' },
	        _react2.default.createElement(
	          'div',
	          { style: styles.double },
	          _react2.default.createElement(_common.EditableInput, { style: { input: styles.input, label: styles.label }, label: 'hex', value: this.props.hex.replace('#', ''), onChange: this.handleChange })
	        ),
	        _react2.default.createElement(
	          'div',
	          { style: styles.single },
	          _react2.default.createElement(_common.EditableInput, { style: { input: styles.input, label: styles.label }, label: 'r', value: this.props.rgb.r, onChange: this.handleChange, dragLabel: 'true', dragMax: '255' })
	        ),
	        _react2.default.createElement(
	          'div',
	          { style: styles.single },
	          _react2.default.createElement(_common.EditableInput, { style: { input: styles.input, label: styles.label }, label: 'g', value: this.props.rgb.g, onChange: this.handleChange, dragLabel: 'true', dragMax: '255' })
	        ),
	        _react2.default.createElement(
	          'div',
	          { style: styles.single },
	          _react2.default.createElement(_common.EditableInput, { style: { input: styles.input, label: styles.label }, label: 'b', value: this.props.rgb.b, onChange: this.handleChange, dragLabel: 'true', dragMax: '255' })
	        ),
	        _react2.default.createElement(
	          'div',
	          { style: styles.alpha },
	          _react2.default.createElement(_common.EditableInput, { style: { input: styles.input, label: styles.label }, label: 'a', value: Math.round(this.props.rgb.a * 100), onChange: this.handleChange, dragLabel: 'true', dragMax: '100' })
	        )
	      );
	    }
	  }]);
	
	  return ShetchFields;
	}(_react2.default.Component);
	
	exports.default = ShetchFields;

/***/ }),
/* 2817 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SketchPresetColors = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(2774);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _reactAddonsShallowCompare = __webpack_require__(1321);
	
	var _reactAddonsShallowCompare2 = _interopRequireDefault(_reactAddonsShallowCompare);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SketchPresetColors = exports.SketchPresetColors = function (_React$Component) {
	  _inherits(SketchPresetColors, _React$Component);
	
	  function SketchPresetColors() {
	    var _Object$getPrototypeO;
	
	    var _temp, _this, _ret;
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _classCallCheck(this, SketchPresetColors);
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_Object$getPrototypeO = Object.getPrototypeOf(SketchPresetColors)).call.apply(_Object$getPrototypeO, [this].concat(args))), _this), _this.shouldComponentUpdate = _reactAddonsShallowCompare2.default.bind(_this, _this, arguments[0], arguments[1]), _this.handleClick = function (hex) {
	      _this.props.onClick({
	        hex: hex,
	        source: 'hex'
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(SketchPresetColors, [{
	    key: 'render',
	    value: function render() {
	
	      var styles = (0, _reactcss2.default)({
	        'default': {
	          colors: {
	            marginRight: '-10px',
	            marginLeft: '-10px',
	            paddingLeft: '10px',
	            paddingTop: '10px',
	            borderTop: '1px solid #eee'
	          },
	          li: {
	            borderRadius: '3px',
	            overflow: 'hidden',
	            position: 'relative',
	            display: 'inline-block',
	            margin: '0 10px 10px 0',
	            verticalAlign: 'top',
	            cursor: 'pointer'
	          },
	          square: {
	            borderRadius: '3px',
	            width: '16px',
	            height: '16px',
	            boxShadow: 'inset 0 0 0 1px rgba(0,0,0,.15)'
	          }
	        },
	        'no-presets': {
	          colors: {
	            display: 'none'
	          }
	        }
	      }, {
	        'no-presets': !this.props.colors || !this.props.colors.length
	      });
	
	      var colors = [];
	      if (this.props.colors) {
	        for (var i = 0; i < this.props.colors.length; i++) {
	          var color = this.props.colors[i];
	          colors.push(_react2.default.createElement(
	            'div',
	            { key: color, style: styles.li, ref: color, onClick: this.handleClick.bind(null, color) },
	            _react2.default.createElement(
	              'div',
	              { style: { background: color } },
	              ' ',
	              _react2.default.createElement('div', { style: styles.square }),
	              ' '
	            )
	          ));
	        }
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { style: styles.colors },
	        colors
	      );
	    }
	  }]);
	
	  return SketchPresetColors;
	}(_react2.default.Component);
	
	exports.default = SketchPresetColors;

/***/ }),
/* 2818 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Slider = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(2774);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _reactAddonsShallowCompare = __webpack_require__(1321);
	
	var _reactAddonsShallowCompare2 = _interopRequireDefault(_reactAddonsShallowCompare);
	
	var _common = __webpack_require__(2789);
	
	var _SliderSwatches = __webpack_require__(2819);
	
	var _SliderSwatches2 = _interopRequireDefault(_SliderSwatches);
	
	var _SliderPointer = __webpack_require__(2821);
	
	var _SliderPointer2 = _interopRequireDefault(_SliderPointer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Slider = exports.Slider = function (_React$Component) {
	  _inherits(Slider, _React$Component);
	
	  function Slider() {
	    var _Object$getPrototypeO;
	
	    var _temp, _this, _ret;
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _classCallCheck(this, Slider);
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_Object$getPrototypeO = Object.getPrototypeOf(Slider)).call.apply(_Object$getPrototypeO, [this].concat(args))), _this), _this.shouldComponentUpdate = _reactAddonsShallowCompare2.default.bind(_this, _this, arguments[0], arguments[1]), _this.handleChange = function (data) {
	      _this.props.onChange(data);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Slider, [{
	    key: 'render',
	    value: function render() {
	
	      var styles = (0, _reactcss2.default)({
	        'default': {
	          slider: {},
	          hue: {
	            height: '12px',
	            position: 'relative'
	          },
	          Hue: {
	            radius: '2px'
	          }
	        }
	      });
	
	      return _react2.default.createElement(
	        'div',
	        { style: styles.slider },
	        _react2.default.createElement(
	          'div',
	          { style: styles.hue },
	          _react2.default.createElement(_common.Hue, _extends({ style: styles.Hue }, this.props, { pointer: _SliderPointer2.default, onChange: this.handleChange }))
	        ),
	        _react2.default.createElement(
	          'div',
	          { style: styles.swatches },
	          _react2.default.createElement(_SliderSwatches2.default, _extends({}, this.props, { onClick: this.handleChange }))
	        )
	      );
	    }
	  }]);
	
	  return Slider;
	}(_react2.default.Component);
	
	exports.default = (0, _common.ColorWrap)(Slider);

/***/ }),
/* 2819 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SliderSwatches = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(2774);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _reactAddonsShallowCompare = __webpack_require__(1321);
	
	var _reactAddonsShallowCompare2 = _interopRequireDefault(_reactAddonsShallowCompare);
	
	var _SliderSwatch = __webpack_require__(2820);
	
	var _SliderSwatch2 = _interopRequireDefault(_SliderSwatch);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SliderSwatches = exports.SliderSwatches = function (_React$Component) {
	  _inherits(SliderSwatches, _React$Component);
	
	  function SliderSwatches() {
	    var _Object$getPrototypeO;
	
	    var _temp, _this, _ret;
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _classCallCheck(this, SliderSwatches);
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_Object$getPrototypeO = Object.getPrototypeOf(SliderSwatches)).call.apply(_Object$getPrototypeO, [this].concat(args))), _this), _this.shouldComponentUpdate = _reactAddonsShallowCompare2.default.bind(_this, _this, arguments[0], arguments[1]), _this.handleClick = function (data) {
	      _this.props.onClick(data);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(SliderSwatches, [{
	    key: 'render',
	    value: function render() {
	
	      var styles = (0, _reactcss2.default)({
	        'default': {
	          swatches: {
	            marginTop: '20px'
	          },
	          swatch: {
	            boxSizing: 'border-box',
	            width: '20%',
	            paddingRight: '1px',
	            float: 'left'
	          },
	          clear: {
	            clear: 'both'
	          }
	        }
	      });
	
	      return _react2.default.createElement(
	        'div',
	        { style: styles.swatches },
	        _react2.default.createElement(
	          'div',
	          { style: styles.swatch },
	          _react2.default.createElement(_SliderSwatch2.default, _extends({}, this.props, { offset: '.80', active: Math.round(this.props.hsl.l * 100) / 100 == .80 && Math.round(this.props.hsl.s * 100) / 100 == .50, onClick: this.handleClick, first: true }))
	        ),
	        _react2.default.createElement(
	          'div',
	          { style: styles.swatch },
	          _react2.default.createElement(_SliderSwatch2.default, _extends({}, this.props, { offset: '.65', active: Math.round(this.props.hsl.l * 100) / 100 == .65 && Math.round(this.props.hsl.s * 100) / 100 == .50, onClick: this.handleClick }))
	        ),
	        _react2.default.createElement(
	          'div',
	          { style: styles.swatch },
	          _react2.default.createElement(_SliderSwatch2.default, _extends({}, this.props, { offset: '.50', active: Math.round(this.props.hsl.l * 100) / 100 == .50 && Math.round(this.props.hsl.s * 100) / 100 == .50, onClick: this.handleClick }))
	        ),
	        _react2.default.createElement(
	          'div',
	          { style: styles.swatch },
	          _react2.default.createElement(_SliderSwatch2.default, _extends({}, this.props, { offset: '.35', active: Math.round(this.props.hsl.l * 100) / 100 == .35 && Math.round(this.props.hsl.s * 100) / 100 == .50, onClick: this.handleClick }))
	        ),
	        _react2.default.createElement(
	          'div',
	          { style: styles.swatch },
	          _react2.default.createElement(_SliderSwatch2.default, _extends({}, this.props, { offset: '.20', active: Math.round(this.props.hsl.l * 100) / 100 == .20 && Math.round(this.props.hsl.s * 100) / 100 == .50, onClick: this.handleClick, last: true }))
	        ),
	        _react2.default.createElement('div', { style: styles.clear })
	      );
	    }
	  }]);
	
	  return SliderSwatches;
	}(_react2.default.Component);
	
	exports.default = SliderSwatches;

/***/ }),
/* 2820 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SliderSwatch = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(2774);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _reactAddonsShallowCompare = __webpack_require__(1321);
	
	var _reactAddonsShallowCompare2 = _interopRequireDefault(_reactAddonsShallowCompare);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SliderSwatch = exports.SliderSwatch = function (_React$Component) {
	  _inherits(SliderSwatch, _React$Component);
	
	  function SliderSwatch() {
	    var _Object$getPrototypeO;
	
	    var _temp, _this, _ret;
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _classCallCheck(this, SliderSwatch);
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_Object$getPrototypeO = Object.getPrototypeOf(SliderSwatch)).call.apply(_Object$getPrototypeO, [this].concat(args))), _this), _this.shouldComponentUpdate = _reactAddonsShallowCompare2.default.bind(_this, _this, arguments[0], arguments[1]), _this.handleClick = function () {
	      _this.props.onClick({
	        h: _this.props.hsl.h,
	        s: .5,
	        l: _this.props.offset,
	        source: 'hsl'
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(SliderSwatch, [{
	    key: 'render',
	    value: function render() {
	
	      var styles = (0, _reactcss2.default)({
	        'default': {
	          swatch: {
	            height: '12px',
	            background: 'hsl(' + this.props.hsl.h + ', 50%, ' + this.props.offset * 100 + '%)',
	            cursor: 'pointer'
	          }
	        },
	        'first': {
	          swatch: {
	            borderRadius: '2px 0 0 2px'
	          }
	        },
	        'last': {
	          swatch: {
	            borderRadius: '0 2px 2px 0'
	          }
	        },
	        active: {
	          swatch: {
	            transform: 'scaleY(1.8)',
	            borderRadius: '3.6px/2px'
	          }
	        }
	      });
	
	      return _react2.default.createElement('div', { style: styles.swatch, ref: 'swatch', onClick: this.handleClick });
	    }
	  }]);
	
	  return SliderSwatch;
	}(_react2.default.Component);
	
	exports.default = SliderSwatch;

/***/ }),
/* 2821 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SliderPointer = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(2774);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _reactAddonsShallowCompare = __webpack_require__(1321);
	
	var _reactAddonsShallowCompare2 = _interopRequireDefault(_reactAddonsShallowCompare);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SliderPointer = exports.SliderPointer = function (_React$Component) {
	  _inherits(SliderPointer, _React$Component);
	
	  function SliderPointer() {
	    var _Object$getPrototypeO;
	
	    var _temp, _this, _ret;
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _classCallCheck(this, SliderPointer);
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_Object$getPrototypeO = Object.getPrototypeOf(SliderPointer)).call.apply(_Object$getPrototypeO, [this].concat(args))), _this), _this.shouldComponentUpdate = _reactAddonsShallowCompare2.default.bind(_this, _this, arguments[0], arguments[1]), _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(SliderPointer, [{
	    key: 'render',
	    value: function render() {
	
	      var styles = (0, _reactcss2.default)({
	        'default': {
	          picker: {
	            width: '14px',
	            height: '14px',
	            borderRadius: '6px',
	            transform: 'translate(-7px, -1px)',
	            backgroundColor: 'rgb(248, 248, 248)',
	            boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.37)'
	          }
	        }
	      });
	
	      return _react2.default.createElement('div', { style: styles.picker });
	    }
	  }]);
	
	  return SliderPointer;
	}(_react2.default.Component);
	
	exports.default = SliderPointer;

/***/ }),
/* 2822 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Swatches = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(2774);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _color = __webpack_require__(2796);
	
	var _color2 = _interopRequireDefault(_color);
	
	var _materialColors = __webpack_require__(2823);
	
	var _materialColors2 = _interopRequireDefault(_materialColors);
	
	var _reactAddonsShallowCompare = __webpack_require__(1321);
	
	var _reactAddonsShallowCompare2 = _interopRequireDefault(_reactAddonsShallowCompare);
	
	var _common = __webpack_require__(2789);
	
	var _reactMaterialDesign = __webpack_require__(2802);
	
	var _SwatchesGroup = __webpack_require__(2824);
	
	var _SwatchesGroup2 = _interopRequireDefault(_SwatchesGroup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Swatches = exports.Swatches = function (_React$Component) {
	  _inherits(Swatches, _React$Component);
	
	  function Swatches() {
	    var _Object$getPrototypeO;
	
	    var _temp, _this, _ret;
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _classCallCheck(this, Swatches);
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_Object$getPrototypeO = Object.getPrototypeOf(Swatches)).call.apply(_Object$getPrototypeO, [this].concat(args))), _this), _this.shouldComponentUpdate = _reactAddonsShallowCompare2.default.bind(_this, _this, arguments[0], arguments[1]), _this.handleChange = function (data) {
	      _color2.default.isValidHex(data) && _this.props.onChange({
	        hex: data,
	        source: 'hex'
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Swatches, [{
	    key: 'render',
	    value: function render() {
	
	      var styles = (0, _reactcss2.default)({
	        'default': {
	          picker: {
	            width: this.props.width,
	            height: this.props.height
	          },
	          overflow: {
	            height: this.props.height,
	            overflowY: 'scroll'
	          },
	          body: {
	            padding: '16px 0 6px 16px'
	          },
	
	          clear: {
	            clear: 'both'
	          }
	        }
	      });
	
	      var groups = [];
	      if (this.props.colors) {
	        for (var i = 0; i < this.props.colors.length; i++) {
	          var group = this.props.colors[i];
	          groups.push(_react2.default.createElement(_SwatchesGroup2.default, { key: group.toString(), group: group, active: this.props.hex, onClick: this.handleChange }));
	        }
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { style: styles.picker },
	        _react2.default.createElement(
	          _reactMaterialDesign.Raised,
	          null,
	          _react2.default.createElement(
	            'div',
	            { style: styles.overflow },
	            _react2.default.createElement(
	              'div',
	              { style: styles.body, ref: 'body' },
	              groups,
	              _react2.default.createElement('div', { style: styles.clear })
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Swatches;
	}(_react2.default.Component);
	
	Swatches.defaultProps = {
	  width: 320,
	  height: 240,
	  colors: [[_materialColors2.default.red['900'], _materialColors2.default.red['700'], _materialColors2.default.red['500'], _materialColors2.default.red['300'], _materialColors2.default.red['100']], [_materialColors2.default.pink['900'], _materialColors2.default.pink['700'], _materialColors2.default.pink['500'], _materialColors2.default.pink['300'], _materialColors2.default.pink['100']], [_materialColors2.default.purple['900'], _materialColors2.default.purple['700'], _materialColors2.default.purple['500'], _materialColors2.default.purple['300'], _materialColors2.default.purple['100']], [_materialColors2.default.deepPurple['900'], _materialColors2.default.deepPurple['700'], _materialColors2.default.deepPurple['500'], _materialColors2.default.deepPurple['300'], _materialColors2.default.deepPurple['100']], [_materialColors2.default.indigo['900'], _materialColors2.default.indigo['700'], _materialColors2.default.indigo['500'], _materialColors2.default.indigo['300'], _materialColors2.default.indigo['100']], [_materialColors2.default.blue['900'], _materialColors2.default.blue['700'], _materialColors2.default.blue['500'], _materialColors2.default.blue['300'], _materialColors2.default.blue['100']], [_materialColors2.default.lightBlue['900'], _materialColors2.default.lightBlue['700'], _materialColors2.default.lightBlue['500'], _materialColors2.default.lightBlue['300'], _materialColors2.default.lightBlue['100']], [_materialColors2.default.cyan['900'], _materialColors2.default.cyan['700'], _materialColors2.default.cyan['500'], _materialColors2.default.cyan['300'], _materialColors2.default.cyan['100']], [_materialColors2.default.teal['900'], _materialColors2.default.teal['700'], _materialColors2.default.teal['500'], _materialColors2.default.teal['300'], _materialColors2.default.teal['100']], ['#194D33', _materialColors2.default.green['700'], _materialColors2.default.green['500'], _materialColors2.default.green['300'], _materialColors2.default.green['100']], [_materialColors2.default.lightGreen['900'], _materialColors2.default.lightGreen['700'], _materialColors2.default.lightGreen['500'], _materialColors2.default.lightGreen['300'], _materialColors2.default.lightGreen['100']], [_materialColors2.default.lime['900'], _materialColors2.default.lime['700'], _materialColors2.default.lime['500'], _materialColors2.default.lime['300'], _materialColors2.default.lime['100']], [_materialColors2.default.yellow['900'], _materialColors2.default.yellow['700'], _materialColors2.default.yellow['500'], _materialColors2.default.yellow['300'], _materialColors2.default.yellow['100']], [_materialColors2.default.amber['900'], _materialColors2.default.amber['700'], _materialColors2.default.amber['500'], _materialColors2.default.amber['300'], _materialColors2.default.amber['100']], [_materialColors2.default.orange['900'], _materialColors2.default.orange['700'], _materialColors2.default.orange['500'], _materialColors2.default.orange['300'], _materialColors2.default.orange['100']], [_materialColors2.default.deepOrange['900'], _materialColors2.default.deepOrange['700'], _materialColors2.default.deepOrange['500'], _materialColors2.default.deepOrange['300'], _materialColors2.default.deepOrange['100']], [_materialColors2.default.brown['900'], _materialColors2.default.brown['700'], _materialColors2.default.brown['500'], _materialColors2.default.brown['300'], _materialColors2.default.brown['100']], [_materialColors2.default.blueGrey['900'], _materialColors2.default.blueGrey['700'], _materialColors2.default.blueGrey['500'], _materialColors2.default.blueGrey['300'], _materialColors2.default.blueGrey['100']], ['#000000', '#525252', '#969696', '#D9D9D9', '#FFFFFF']]
	};
	
	exports.default = (0, _common.ColorWrap)(Swatches);

/***/ }),
/* 2823 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(root, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports === 'object') {
	    module.exports = factory();
	  } else {
	    root.materialColors = factory();
	  }
	})(this, function() {
	  return {"red":{"50":"#ffebee","100":"#ffcdd2","200":"#ef9a9a","300":"#e57373","400":"#ef5350","500":"#f44336","600":"#e53935","700":"#d32f2f","800":"#c62828","900":"#b71c1c","a100":"#ff8a80","a200":"#ff5252","a400":"#ff1744","a700":"#d50000"},"pink":{"50":"#fce4ec","100":"#f8bbd0","200":"#f48fb1","300":"#f06292","400":"#ec407a","500":"#e91e63","600":"#d81b60","700":"#c2185b","800":"#ad1457","900":"#880e4f","a100":"#ff80ab","a200":"#ff4081","a400":"#f50057","a700":"#c51162"},"purple":{"50":"#f3e5f5","100":"#e1bee7","200":"#ce93d8","300":"#ba68c8","400":"#ab47bc","500":"#9c27b0","600":"#8e24aa","700":"#7b1fa2","800":"#6a1b9a","900":"#4a148c","a100":"#ea80fc","a200":"#e040fb","a400":"#d500f9","a700":"#aa00ff"},"deepPurple":{"50":"#ede7f6","100":"#d1c4e9","200":"#b39ddb","300":"#9575cd","400":"#7e57c2","500":"#673ab7","600":"#5e35b1","700":"#512da8","800":"#4527a0","900":"#311b92","a100":"#b388ff","a200":"#7c4dff","a400":"#651fff","a700":"#6200ea"},"indigo":{"50":"#e8eaf6","100":"#c5cae9","200":"#9fa8da","300":"#7986cb","400":"#5c6bc0","500":"#3f51b5","600":"#3949ab","700":"#303f9f","800":"#283593","900":"#1a237e","a100":"#8c9eff","a200":"#536dfe","a400":"#3d5afe","a700":"#304ffe"},"blue":{"50":"#e3f2fd","100":"#bbdefb","200":"#90caf9","300":"#64b5f6","400":"#42a5f5","500":"#2196f3","600":"#1e88e5","700":"#1976d2","800":"#1565c0","900":"#0d47a1","a100":"#82b1ff","a200":"#448aff","a400":"#2979ff","a700":"#2962ff"},"lightBlue":{"50":"#e1f5fe","100":"#b3e5fc","200":"#81d4fa","300":"#4fc3f7","400":"#29b6f6","500":"#03a9f4","600":"#039be5","700":"#0288d1","800":"#0277bd","900":"#01579b","a100":"#80d8ff","a200":"#40c4ff","a400":"#00b0ff","a700":"#0091ea"},"cyan":{"50":"#e0f7fa","100":"#b2ebf2","200":"#80deea","300":"#4dd0e1","400":"#26c6da","500":"#00bcd4","600":"#00acc1","700":"#0097a7","800":"#00838f","900":"#006064","a100":"#84ffff","a200":"#18ffff","a400":"#00e5ff","a700":"#00b8d4"},"teal":{"50":"#e0f2f1","100":"#b2dfdb","200":"#80cbc4","300":"#4db6ac","400":"#26a69a","500":"#009688","600":"#00897b","700":"#00796b","800":"#00695c","900":"#004d40","a100":"#a7ffeb","a200":"#64ffda","a400":"#1de9b6","a700":"#00bfa5"},"green":{"50":"#e8f5e9","100":"#c8e6c9","200":"#a5d6a7","300":"#81c784","400":"#66bb6a","500":"#4caf50","600":"#43a047","700":"#388e3c","800":"#2e7d32","900":"#1b5e20","a100":"#b9f6ca","a200":"#69f0ae","a400":"#00e676","a700":"#00c853"},"lightGreen":{"50":"#f1f8e9","100":"#dcedc8","200":"#c5e1a5","300":"#aed581","400":"#9ccc65","500":"#8bc34a","600":"#7cb342","700":"#689f38","800":"#558b2f","900":"#33691e","a100":"#ccff90","a200":"#b2ff59","a400":"#76ff03","a700":"#64dd17"},"lime":{"50":"#f9fbe7","100":"#f0f4c3","200":"#e6ee9c","300":"#dce775","400":"#d4e157","500":"#cddc39","600":"#c0ca33","700":"#afb42b","800":"#9e9d24","900":"#827717","a100":"#f4ff81","a200":"#eeff41","a400":"#c6ff00","a700":"#aeea00"},"yellow":{"50":"#fffde7","100":"#fff9c4","200":"#fff59d","300":"#fff176","400":"#ffee58","500":"#ffeb3b","600":"#fdd835","700":"#fbc02d","800":"#f9a825","900":"#f57f17","a100":"#ffff8d","a200":"#ffff00","a400":"#ffea00","a700":"#ffd600"},"amber":{"50":"#fff8e1","100":"#ffecb3","200":"#ffe082","300":"#ffd54f","400":"#ffca28","500":"#ffc107","600":"#ffb300","700":"#ffa000","800":"#ff8f00","900":"#ff6f00","a100":"#ffe57f","a200":"#ffd740","a400":"#ffc400","a700":"#ffab00"},"orange":{"50":"#fff3e0","100":"#ffe0b2","200":"#ffcc80","300":"#ffb74d","400":"#ffa726","500":"#ff9800","600":"#fb8c00","700":"#f57c00","800":"#ef6c00","900":"#e65100","a100":"#ffd180","a200":"#ffab40","a400":"#ff9100","a700":"#ff6d00"},"deepOrange":{"50":"#fbe9e7","100":"#ffccbc","200":"#ffab91","300":"#ff8a65","400":"#ff7043","500":"#ff5722","600":"#f4511e","700":"#e64a19","800":"#d84315","900":"#bf360c","a100":"#ff9e80","a200":"#ff6e40","a400":"#ff3d00","a700":"#dd2c00"},"brown":{"50":"#efebe9","100":"#d7ccc8","200":"#bcaaa4","300":"#a1887f","400":"#8d6e63","500":"#795548","600":"#6d4c41","700":"#5d4037","800":"#4e342e","900":"#3e2723"},"grey":{"50":"#fafafa","100":"#f5f5f5","200":"#eeeeee","300":"#e0e0e0","400":"#bdbdbd","500":"#9e9e9e","600":"#757575","700":"#616161","800":"#424242","900":"#212121"},"blueGrey":{"50":"#eceff1","100":"#cfd8dc","200":"#b0bec5","300":"#90a4ae","400":"#78909c","500":"#607d8b","600":"#546e7a","700":"#455a64","800":"#37474f","900":"#263238"},"white":"#ffffff","black":"#000000"};
	});


/***/ }),
/* 2824 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SwatchesGroup = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(2774);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _reactAddonsShallowCompare = __webpack_require__(1321);
	
	var _reactAddonsShallowCompare2 = _interopRequireDefault(_reactAddonsShallowCompare);
	
	var _SwatchesColor = __webpack_require__(2825);
	
	var _SwatchesColor2 = _interopRequireDefault(_SwatchesColor);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SwatchesGroup = exports.SwatchesGroup = function (_React$Component) {
	  _inherits(SwatchesGroup, _React$Component);
	
	  function SwatchesGroup() {
	    var _Object$getPrototypeO;
	
	    var _temp, _this, _ret;
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _classCallCheck(this, SwatchesGroup);
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_Object$getPrototypeO = Object.getPrototypeOf(SwatchesGroup)).call.apply(_Object$getPrototypeO, [this].concat(args))), _this), _this.shouldComponentUpdate = _reactAddonsShallowCompare2.default.bind(_this, _this, arguments[0], arguments[1]), _this.handleClick = function (data) {
	      _this.props.onClick(data);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(SwatchesGroup, [{
	    key: 'render',
	    value: function render() {
	
	      var styles = (0, _reactcss2.default)({
	        'default': {
	          group: {
	            paddingBottom: '10px',
	            width: '40px',
	            float: 'left',
	            marginRight: '10px'
	          }
	        }
	      });
	
	      var colors = [];
	      for (var i = 0; i < this.props.group.length; i++) {
	        var color = this.props.group[i];
	
	        colors.push(_react2.default.createElement(_SwatchesColor2.default, { key: color, color: color, active: color.toLowerCase() === this.props.active, first: i === 0, last: i === this.props.group.length - 1, onClick: this.handleClick }));
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { style: styles.group, ref: 'group' },
	        colors
	      );
	    }
	  }]);
	
	  return SwatchesGroup;
	}(_react2.default.Component);
	
	exports.default = SwatchesGroup;

/***/ }),
/* 2825 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SwatchesColor = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(2774);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _reactAddonsShallowCompare = __webpack_require__(1321);
	
	var _reactAddonsShallowCompare2 = _interopRequireDefault(_reactAddonsShallowCompare);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SwatchesColor = exports.SwatchesColor = function (_React$Component) {
	  _inherits(SwatchesColor, _React$Component);
	
	  function SwatchesColor() {
	    var _Object$getPrototypeO;
	
	    var _temp, _this, _ret;
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _classCallCheck(this, SwatchesColor);
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_Object$getPrototypeO = Object.getPrototypeOf(SwatchesColor)).call.apply(_Object$getPrototypeO, [this].concat(args))), _this), _this.shouldComponentUpdate = _reactAddonsShallowCompare2.default.bind(_this, _this, arguments[0], arguments[1]), _this.handleClick = function () {
	      _this.props.onClick(_this.props.color);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(SwatchesColor, [{
	    key: 'render',
	    value: function render() {
	
	      var styles = (0, _reactcss2.default)({
	        'default': {
	          color: {
	            width: '40px',
	            height: '24px',
	            cursor: 'pointer',
	            background: this.props.color,
	            marginBottom: '1px'
	          },
	          check: {
	            fill: '#fff',
	            marginLeft: '8px',
	            display: 'none'
	          }
	        },
	        'first': {
	          color: {
	            overflow: 'hidden',
	            borderRadius: '2px 2px 0 0'
	          }
	        },
	        'last': {
	          color: {
	            overflow: 'hidden',
	            borderRadius: '0 0 2px 2px'
	          }
	        },
	        active: {
	          check: {
	            display: 'block'
	          }
	        }
	      }, this.props);
	
	      return _react2.default.createElement(
	        'div',
	        { style: styles.color, ref: 'color', onClick: this.handleClick },
	        _react2.default.createElement(
	          'div',
	          { style: styles.check },
	          _react2.default.createElement(
	            'svg',
	            { style: { width: '24px', height: '24px' }, viewBox: '0 0 24 24' },
	            _react2.default.createElement('path', { d: 'M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z' })
	          )
	        )
	      );
	    }
	  }]);
	
	  return SwatchesColor;
	}(_react2.default.Component);
	
	exports.default = SwatchesColor;

/***/ }),
/* 2826 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _materialUi = __webpack_require__(576);
	
	var _connectToStores = __webpack_require__(1226);
	
	var _connectToStores2 = _interopRequireDefault(_connectToStores);
	
	var _VenueActions = __webpack_require__(2035);
	
	var _VenueActions2 = _interopRequireDefault(_VenueActions);
	
	var _VenueStore = __webpack_require__(2036);
	
	var _VenueStore2 = _interopRequireDefault(_VenueStore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SEATS_IO_SCRIPT_URL = "https://cdn.seatsio.net/chart.js";
	
	var VenueSeatmapEditor = function (_React$Component) {
	  _inherits(VenueSeatmapEditor, _React$Component);
	
	  function VenueSeatmapEditor(props) {
	    _classCallCheck(this, VenueSeatmapEditor);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(VenueSeatmapEditor).call(this, props));
	
	    _this.state = {
	      renderedChartId: null,
	      editorInstance: null
	    };
	
	    _this.close = _this.close.bind(_this);
	    _this.createInstance = _this.createInstance.bind(_this);
	    _this.destroyInstance = _this.destroyInstance.bind(_this);
	    return _this;
	  }
	
	  _createClass(VenueSeatmapEditor, [{
	    key: "close",
	    value: function close() {
	      this.context.router.goBack();
	    }
	  }, {
	    key: "createInstance",
	    value: function createInstance() {
	      var _this2 = this;
	
	      var venue = this.props.getVenueById(this.props.params.venueId);
	
	      if (!window.seatsio || !venue) {
	        return;
	      }
	
	      if (this.state.editorInstance && this.state.renderedChartId === venue.seatmap_id) {
	        // Already rendered chart
	        return;
	      } else if (this.state.editorInstance) {
	        // This means new chart, time to destroy old before creating new
	        this.destroyInstance();
	      }
	
	      var instance = new window.seatsio.SeatingChartDesigner({
	        divId: "seatioInject",
	        designerKey: ("daee994c-5d2d-4077-a5e7-677c6cb1aa44"),
	        chartKey: venue.seatmap_id,
	        features: {
	          disabled: ["backgroundImage"],
	          readOnly: ["chartName"]
	        },
	        baseColor: "#0288d1",
	        onChartCreated: function onChartCreated(key) {
	          _VenueActions2.default.edit(_this2.props.params.venueId, {
	            seatmap_id: key
	          });
	        },
	        onExitRequested: function onExitRequested() {
	          _this2.close();
	        }
	      });
	
	      this.setState({
	        renderedChartId: venue.seatmap_id,
	        editorInstance: instance
	      });
	
	      instance.render();
	    }
	  }, {
	    key: "destroyInstance",
	    value: function destroyInstance() {
	      document.getElementById("seatioInject").innerHTML = "";
	      window.seatsio.removeFromArray(this.state.editorInstance, window.seatsio.charts);
	    }
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      if (!document.querySelector("script[src=\"" + SEATS_IO_SCRIPT_URL + "\"]")) {
	        var script = document.createElement("script");
	        script.type = "text/javascript";
	        script.src = SEATS_IO_SCRIPT_URL;
	        script.onload = this.createInstance;
	        document.body.appendChild(script);
	      }
	
	      // If we already have a seatmap id on first load, go ahead and create the instance
	      this.componentWillReceiveProps();
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(props) {
	      var venue = this.props.getVenueById(this.props.params.venueId);
	      if (venue) {
	        this.createInstance();
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      if (this.state.editorInstance) {
	        // dispatch edit action to force refresh
	        _VenueActions2.default.edit.defer(this.props.params.venueId, {});
	        this.destroyInstance();
	      }
	    }
	  }, {
	    key: "getStyles",
	    value: function getStyles() {
	      return {
	        dialog: {
	          width: "95%",
	          maxWidth: "none",
	          overflow: "hidden"
	        },
	        body: {
	          minHeight: "80vh"
	        },
	        inner: {
	          height: "76vh"
	        }
	      };
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var styles = this.getStyles();
	
	      return _react2.default.createElement(
	        _materialUi.Dialog,
	        { open: true, contentStyle: styles.dialog, bodyStyle: styles.body },
	        _react2.default.createElement("div", { id: "seatioInject", style: styles.inner })
	      );
	    }
	  }], [{
	    key: "getStores",
	    value: function getStores() {
	      return [_VenueStore2.default];
	    }
	  }, {
	    key: "getPropsFromStores",
	    value: function getPropsFromStores() {
	      return {
	        getVenueById: _VenueStore2.default.getVenueById
	      };
	    }
	  }, {
	    key: "contextTypes",
	    get: function get() {
	      return {
	        router: _react2.default.PropTypes.object
	      };
	    }
	  }]);
	
	  return VenueSeatmapEditor;
	}(_react2.default.Component);
	
	exports.default = (0, _connectToStores2.default)(VenueSeatmapEditor);
	module.exports = exports["default"];

/***/ }),
/* 2827 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _connectToStores = __webpack_require__(1226);
	
	var _connectToStores2 = _interopRequireDefault(_connectToStores);
	
	var _VenueActions = __webpack_require__(2035);
	
	var _VenueActions2 = _interopRequireDefault(_VenueActions);
	
	var _VenueStore = __webpack_require__(2036);
	
	var _VenueStore2 = _interopRequireDefault(_VenueStore);
	
	var _workingIndicator = __webpack_require__(1664);
	
	var _workingIndicator2 = _interopRequireDefault(_workingIndicator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var NewVenue = function (_React$Component) {
	  _inherits(NewVenue, _React$Component);
	
	  function NewVenue(props) {
	    _classCallCheck(this, NewVenue);
	
	    return _possibleConstructorReturn(this, Object.getPrototypeOf(NewVenue).call(this, props));
	  }
	
	  _createClass(NewVenue, [{
	    key: "componentWillMount",
	    value: function componentWillMount() {
	      _VenueActions2.default.create({
	        name: "Unnamed Venue",
	        color: "SMART_ASSIGN_COLOR",
	        event_bucket: this.props.params.eventBucketId
	      });
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(props) {
	      if (props.newVenueId) {
	        this.context.router.replace("/event_buckets/" + props.params.eventBucketId + "/venues/" + props.newVenueId + "/edit");
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement(_workingIndicator2.default, { fullPage: true });
	    }
	  }], [{
	    key: "getStores",
	    value: function getStores() {
	      return [_VenueStore2.default];
	    }
	  }, {
	    key: "getPropsFromStores",
	    value: function getPropsFromStores() {
	      return {
	        newVenueId: _VenueStore2.default.getState().newVenueId
	      };
	    }
	  }, {
	    key: "contextTypes",
	    get: function get() {
	      return {
	        router: _react2.default.PropTypes.object
	      };
	    }
	  }]);
	
	  return NewVenue;
	}(_react2.default.Component);
	
	exports.default = (0, _connectToStores2.default)(NewVenue);
	module.exports = exports["default"];

/***/ }),
/* 2828 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _values = __webpack_require__(1214);
	
	var _values2 = _interopRequireDefault(_values);
	
	var _pickBy = __webpack_require__(1163);
	
	var _pickBy2 = _interopRequireDefault(_pickBy);
	
	var _reactRouter = __webpack_require__(486);
	
	var _materialUi = __webpack_require__(576);
	
	var _reactable = __webpack_require__(1688);
	
	var _connectToStores = __webpack_require__(1226);
	
	var _connectToStores2 = _interopRequireDefault(_connectToStores);
	
	var _TagActions = __webpack_require__(2038);
	
	var _TagActions2 = _interopRequireDefault(_TagActions);
	
	var _TagStore = __webpack_require__(2039);
	
	var _TagStore2 = _interopRequireDefault(_TagStore);
	
	var _workingIndicator = __webpack_require__(1664);
	
	var _workingIndicator2 = _interopRequireDefault(_workingIndicator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Tags = function (_React$Component) {
	  _inherits(Tags, _React$Component);
	
	  function Tags(props) {
	    _classCallCheck(this, Tags);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(Tags).call(this, props));
	
	    _this._makeRowForTag = _this._makeRowForTag.bind(_this);
	    return _this;
	  }
	
	  _createClass(Tags, [{
	    key: "getStyles",
	    value: function getStyles() {
	      return {};
	    }
	  }, {
	    key: "_makeRowForTag",
	    value: function _makeRowForTag(tag) {
	      return {
	        Name: tag.name,
	        Color: tag.color && _react2.default.createElement("div", { style: { width: 12, height: 12, backgroundColor: tag.color } }),
	        Hidden: tag.visible ? "No" : "Yes",
	        Actions: _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement(
	            _reactRouter.Link,
	            {
	              to: {
	                pathname: "/event_buckets/" + this.props.params.eventBucketId + "/tags/" + tag.id
	              }
	            },
	            "View"
	          ),
	          "\xA0",
	          _react2.default.createElement(
	            _reactRouter.Link,
	            {
	              to: {
	                pathname: "/event_buckets/" + this.props.params.eventBucketId + "/tags/" + tag.id + "/edit",
	                state: { fromListing: true }
	              }
	            },
	            "Edit"
	          )
	        )
	      };
	    }
	  }, {
	    key: "componentWillMount",
	    value: function componentWillMount() {
	      _TagActions2.default.fetchAllForBucket(this.props.params.eventBucketId);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var styles = this.getStyles(),
	          bucket = this.props.params.eventBucketId,
	          tags = (0, _values2.default)((0, _pickBy2.default)(this.props.tags, function (c) {
	        return c.event_bucket === bucket;
	      })),
	          rows = tags.map(this._makeRowForTag);
	
	      if (tags.length === 0 && _TagStore2.default.getState().isFetching) {
	        return _react2.default.createElement(_workingIndicator2.default, { fullPage: true });
	      }
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          "h1",
	          { className: "page-title" },
	          "Tags"
	        ),
	        _react2.default.createElement(_reactable.Table, {
	          className: "bordered striped responsive-table",
	          data: rows,
	          sortable: [{ column: "Name", sortFunction: _reactable.Sort.CaseInsensitive }],
	          defaultSort: { column: "Name", direction: "asc" },
	          columns: ["Name", "Color", "Hidden", "Actions"],
	          filterable: ["Name"],
	          filterPlaceholder: "Type to filter..."
	        }),
	        rows.length === 0 ? _react2.default.createElement(
	          "div",
	          { className: "empty-table-message" },
	          "No tags yet.",
	          " ",
	          _react2.default.createElement(
	            _reactRouter.Link,
	            { to: "/event_buckets/" + bucket + "/tags/new" },
	            "Create a new tag."
	          )
	        ) : null,
	        _react2.default.createElement(
	          "div",
	          { style: { marginTop: 20 } },
	          _react2.default.createElement(_materialUi.RaisedButton, {
	            label: "Create new tag",
	            primary: true,
	            onTouchTap: function onTouchTap() {
	              return _this2.context.router.push("/event_buckets/" + _this2.props.params.eventBucketId + "/tags/new");
	            }
	          })
	        )
	      );
	    }
	  }], [{
	    key: "getStores",
	    value: function getStores() {
	      return [_TagStore2.default];
	    }
	  }, {
	    key: "getPropsFromStores",
	    value: function getPropsFromStores() {
	      return _TagStore2.default.getState();
	    }
	  }, {
	    key: "contextTypes",
	    get: function get() {
	      return {
	        router: _react2.default.PropTypes.object
	      };
	    }
	  }]);
	
	  return Tags;
	}(_react2.default.Component);
	
	exports.default = (0, _connectToStores2.default)(Tags);
	module.exports = exports["default"];

/***/ }),
/* 2829 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _assign = __webpack_require__(920);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _get = __webpack_require__(1004);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _set = __webpack_require__(1188);
	
	var _set2 = _interopRequireDefault(_set);
	
	var _materialUi = __webpack_require__(576);
	
	var _reactColor = __webpack_require__(2772);
	
	var _infoNotice = __webpack_require__(1599);
	
	var _infoNotice2 = _interopRequireDefault(_infoNotice);
	
	var _workingIndicator = __webpack_require__(1664);
	
	var _workingIndicator2 = _interopRequireDefault(_workingIndicator);
	
	var _backButton = __webpack_require__(1872);
	
	var _backButton2 = _interopRequireDefault(_backButton);
	
	var _connectToStores = __webpack_require__(1226);
	
	var _connectToStores2 = _interopRequireDefault(_connectToStores);
	
	var _TagActions = __webpack_require__(2038);
	
	var _TagActions2 = _interopRequireDefault(_TagActions);
	
	var _TagStore = __webpack_require__(2039);
	
	var _TagStore2 = _interopRequireDefault(_TagStore);
	
	var _EventBucketStore = __webpack_require__(1593);
	
	var _EventBucketStore2 = _interopRequireDefault(_EventBucketStore);
	
	var _tagPreview = __webpack_require__(2770);
	
	var _tagPreview2 = _interopRequireDefault(_tagPreview);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Tag = function (_React$Component) {
	  _inherits(Tag, _React$Component);
	
	  function Tag(props) {
	    _classCallCheck(this, Tag);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(Tag).call(this, props));
	
	    _this.state = {
	      tag: null,
	      dirty: false,
	      isFetchingTag: false,
	      values: {}
	    };
	
	    _this.onChangeValue = _this.onChangeValue.bind(_this);
	    _this.save = _this.save.bind(_this);
	    _this.delete = _this.delete.bind(_this);
	    return _this;
	  }
	
	  _createClass(Tag, [{
	    key: "getStyles",
	    value: function getStyles() {
	      return {
	        actions: {
	          marginTop: 40
	        },
	        h3: {
	          marginTop: 10,
	          marginBottom: 10
	        }
	      };
	    }
	  }, {
	    key: "onChangeValue",
	    value: function onChangeValue(id, value) {
	      this.state.dirty = true;
	      (0, _set2.default)(this.state.values, id, value);
	      this.setState(this.state);
	    }
	  }, {
	    key: "save",
	    value: function save() {
	      var values = (0, _assign2.default)({}, this.state.values);
	      _TagActions2.default.edit(this.props.params.tagId, values);
	    }
	  }, {
	    key: "delete",
	    value: function _delete() {
	      var bucket = this.state.tag.event_bucket;
	      if (window.confirm("Are you sure?")) {
	        _TagActions2.default.delete(this.props.params.tagId);
	        this.context.router.push("/event_buckets/" + bucket + "/tags");
	      }
	    }
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      _TagActions2.default.fetchPresetColors(); // used in colorpicker
	      this.componentWillReceiveProps(this.props);
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(newProps) {
	      var tag = newProps.getTagById(newProps.params.tagId);
	
	      this.setState({
	        tag: tag,
	        dirty: false,
	        values: tag ? {
	          name: tag.name || "",
	          color: tag.color || "",
	          virtual_festival_display_mode: tag.virtual_festival_display_mode || "",
	          visible: typeof tag.visible === "undefined" ? true : tag.visible
	        } : {}
	      });
	
	      if (!this.state.isFetchingTag && !tag) {
	        _TagActions2.default.fetchOne(newProps.params.tagId);
	        this.setState({ isFetchingTag: true });
	      } else if (this.state.isFetchingTag && tag) {
	        this.setState({ isFetchingTag: false });
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var styles = this.getStyles(),
	          showVirtualFestivalConfig = (_EventBucketStore2.default.getEventBucketById(this.props.params.eventBucketId) || {}).enable_virtual_festival;
	
	      if (!this.state.tag || this.props.isSaving) {
	        return _react2.default.createElement(_workingIndicator2.default, { fullPage: true });
	      }
	
	      var saveButton = _react2.default.createElement(_materialUi.RaisedButton, {
	        label: this.state.dirty ? "Save changes" : "No changes to save",
	        primary: true,
	        disabled: !this.state.dirty,
	        onTouchTap: this.save
	      });
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement(_backButton2.default, {
	            label: "tags",
	            style: { marginRight: 7 },
	            onTouchTap: function onTouchTap() {
	              return _this2.props.location.state && _this2.props.location.state.fromListing ? _this2.context.router.goBack() : _this2.context.router.push("/event_buckets/" + _this2.props.params.eventBucketId + "/tags");
	            }
	          }),
	          saveButton
	        ),
	        _react2.default.createElement(
	          _infoNotice2.default,
	          { style: { marginTop: 20 } },
	          "Check out our",
	          " ",
	          _react2.default.createElement(
	            "a",
	            {
	              href: "http://help.eventive.org/events-and-tickets/create-tags",
	              target: "_blank"
	            },
	            "guide to creating tags"
	          ),
	          "."
	        ),
	        _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(_materialUi.TextField, {
	              value: (0, _get2.default)(this.state, "values.name", ""),
	              floatingLabelText: "Name",
	              floatingLabelFixed: true,
	              autoFocus: true,
	              onChange: function onChange(e) {
	                return _this2.onChangeValue("name", e.target.value);
	              }
	            })
	          ),
	          _react2.default.createElement(
	            "div",
	            { style: { margin: "1.5em 0" } },
	            _react2.default.createElement(_materialUi.Checkbox, {
	              label: "Hide tag from public views",
	              onCheck: function onCheck(e) {
	                return _this2.onChangeValue("visible", !e.target.checked);
	              },
	              checked: !(0, _get2.default)(this.state, "values.visible", true)
	            })
	          ),
	          showVirtualFestivalConfig ? _react2.default.createElement(
	            "div",
	            { style: { margin: "1.5em 0" } },
	            _react2.default.createElement(
	              "h3",
	              { style: styles.h3 },
	              "Virtual Catalog display mode"
	            ),
	            _react2.default.createElement(
	              _materialUi.RadioButtonGroup,
	              {
	                valueSelected: this.state.values.virtual_festival_display_mode,
	                onChange: function onChange(e, v) {
	                  return _this2.onChangeValue("virtual_festival_display_mode", v);
	                }
	              },
	              _react2.default.createElement(_materialUi.RadioButton, { value: "default", label: "Default" }),
	              _react2.default.createElement(_materialUi.RadioButton, { value: "poster", label: "Poster" }),
	              _react2.default.createElement(_materialUi.RadioButton, {
	                value: "big_poster",
	                label: "Big poster with title"
	              }),
	              _react2.default.createElement(_materialUi.RadioButton, {
	                value: "giant_slider",
	                label: "Full-width large slider with still, title and description"
	              }),
	              _react2.default.createElement(_materialUi.RadioButton, { value: "cover", label: "Full-width cover image" }),
	              _react2.default.createElement(_materialUi.RadioButton, {
	                value: "default_grid",
	                label: "Default, as grid (no slider)"
	              })
	            )
	          ) : null,
	          _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(
	              "h3",
	              { style: styles.h3 },
	              "Color"
	            ),
	            _react2.default.createElement(_tagPreview2.default, {
	              label: this.state.values.short_name || this.state.values.name,
	              color: this.state.values.color
	            }),
	            _react2.default.createElement(
	              "div",
	              { style: { marginTop: 10 } },
	              _react2.default.createElement(_reactColor.SketchPicker, {
	                color: this.state.values.color,
	                presetColors: this.props.presetColors,
	                disableAlpha: true,
	                onChange: function onChange(color) {
	                  return _this2.onChangeValue("color", color.hex);
	                }
	              })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { style: styles.actions },
	          saveButton,
	          _react2.default.createElement(_materialUi.RaisedButton, {
	            label: "Delete tag",
	            onTouchTap: this.delete,
	            style: { marginLeft: 7 }
	          })
	        )
	      );
	    }
	  }], [{
	    key: "getStores",
	    value: function getStores() {
	      return [_TagStore2.default, _EventBucketStore2.default];
	    }
	  }, {
	    key: "getPropsFromStores",
	    value: function getPropsFromStores() {
	      return {
	        getTagById: _TagStore2.default.getTagById,
	        presetColors: _TagStore2.default.getState().presetColors,
	        isSaving: _TagStore2.default.getState().isSaving
	      };
	    }
	  }, {
	    key: "contextTypes",
	    get: function get() {
	      return {
	        router: _react2.default.PropTypes.object
	      };
	    }
	  }]);
	
	  return Tag;
	}(_react2.default.Component);
	
	exports.default = (0, _connectToStores2.default)(Tag);
	module.exports = exports["default"];

/***/ }),
/* 2830 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _connectToStores = __webpack_require__(1226);
	
	var _connectToStores2 = _interopRequireDefault(_connectToStores);
	
	var _TagActions = __webpack_require__(2038);
	
	var _TagActions2 = _interopRequireDefault(_TagActions);
	
	var _TagStore = __webpack_require__(2039);
	
	var _TagStore2 = _interopRequireDefault(_TagStore);
	
	var _workingIndicator = __webpack_require__(1664);
	
	var _workingIndicator2 = _interopRequireDefault(_workingIndicator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var NewTag = function (_React$Component) {
	  _inherits(NewTag, _React$Component);
	
	  function NewTag(props) {
	    _classCallCheck(this, NewTag);
	
	    return _possibleConstructorReturn(this, Object.getPrototypeOf(NewTag).call(this, props));
	  }
	
	  _createClass(NewTag, [{
	    key: "componentWillMount",
	    value: function componentWillMount() {
	      _TagActions2.default.create({
	        name: "",
	        color: "SMART_ASSIGN_COLOR",
	        event_bucket: this.props.params.eventBucketId
	      });
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(props) {
	      if (props.newTagId) {
	        this.context.router.replace("/event_buckets/" + props.params.eventBucketId + "/tags/" + props.newTagId + "/edit");
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement(_workingIndicator2.default, { fullPage: true });
	    }
	  }], [{
	    key: "getStores",
	    value: function getStores() {
	      return [_TagStore2.default];
	    }
	  }, {
	    key: "getPropsFromStores",
	    value: function getPropsFromStores() {
	      return {
	        newTagId: _TagStore2.default.getState().newTagId
	      };
	    }
	  }, {
	    key: "contextTypes",
	    get: function get() {
	      return {
	        router: _react2.default.PropTypes.object
	      };
	    }
	  }]);
	
	  return NewTag;
	}(_react2.default.Component);
	
	exports.default = (0, _connectToStores2.default)(NewTag);
	module.exports = exports["default"];

/***/ }),
/* 2831 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _values = __webpack_require__(1214);
	
	var _values2 = _interopRequireDefault(_values);
	
	var _pickBy = __webpack_require__(1163);
	
	var _pickBy2 = _interopRequireDefault(_pickBy);
	
	var _reactRouter = __webpack_require__(486);
	
	var _materialUi = __webpack_require__(576);
	
	var _reactable = __webpack_require__(1688);
	
	var _connectToStores = __webpack_require__(1226);
	
	var _connectToStores2 = _interopRequireDefault(_connectToStores);
	
	var _KioskActions = __webpack_require__(2832);
	
	var _KioskActions2 = _interopRequireDefault(_KioskActions);
	
	var _KioskStore = __webpack_require__(2833);
	
	var _KioskStore2 = _interopRequireDefault(_KioskStore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Kiosks = function (_React$Component) {
	  _inherits(Kiosks, _React$Component);
	
	  function Kiosks(props) {
	    _classCallCheck(this, Kiosks);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(Kiosks).call(this, props));
	
	    _this._makeRowForKiosk = _this._makeRowForKiosk.bind(_this);
	    return _this;
	  }
	
	  _createClass(Kiosks, [{
	    key: "getStyles",
	    value: function getStyles() {
	      return {};
	    }
	  }, {
	    key: "_makeRowForKiosk",
	    value: function _makeRowForKiosk(kiosk) {
	      return {
	        Name: kiosk.name,
	        Code: kiosk.code,
	        Printer: kiosk.printer,
	        Actions: _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement(
	            _reactRouter.Link,
	            {
	              to: "/event_buckets/" + this.props.params.eventBucketId + "/kiosks/" + kiosk.id
	            },
	            "Edit kiosk"
	          )
	        )
	      };
	    }
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      _KioskActions2.default.fetchAllForBucket(this.props.params.eventBucketId);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var styles = this.getStyles(),
	          bucket = this.props.params.eventBucketId,
	          kiosks = (0, _values2.default)((0, _pickBy2.default)(this.props.kiosks, function (c) {
	        return c.event_bucket === bucket;
	      })),
	          rows = kiosks.map(this._makeRowForKiosk);
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(_reactable.Table, {
	          className: "bordered striped responsive-table",
	          data: rows,
	          sortable: true,
	          columns: ["Name", "Code", "Printer", "Actions"],
	          filterable: ["Name", "Code"],
	          filterPlaceholder: "Type to filter..."
	        }),
	        _react2.default.createElement(
	          "div",
	          { style: { marginTop: 20 } },
	          _react2.default.createElement(_materialUi.RaisedButton, {
	            label: "Create new kiosk",
	            primary: true,
	            onTouchTap: function onTouchTap() {
	              return _this2.context.router.push("/event_buckets/" + _this2.props.params.eventBucketId + "/kiosks/new");
	            }
	          })
	        )
	      );
	    }
	  }], [{
	    key: "getStores",
	    value: function getStores() {
	      return [_KioskStore2.default];
	    }
	  }, {
	    key: "getPropsFromStores",
	    value: function getPropsFromStores() {
	      return {
	        kiosks: _KioskStore2.default.getState().kiosks
	      };
	    }
	  }, {
	    key: "contextTypes",
	    get: function get() {
	      return {
	        router: _react2.default.PropTypes.object
	      };
	    }
	  }]);
	
	  return Kiosks;
	}(_react2.default.Component);
	
	exports.default = (0, _connectToStores2.default)(Kiosks);
	module.exports = exports["default"];

/***/ }),
/* 2832 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _alt = __webpack_require__(975);
	
	var _alt2 = _interopRequireDefault(_alt);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var KioskActions = function () {
	  function KioskActions() {
	    _classCallCheck(this, KioskActions);
	
	    this.generateActions("create", "delete", "updateKiosks", "fetchOne", "fetchAllForBucket", "fetchFailed", "editFailed");
	  }
	
	  _createClass(KioskActions, [{
	    key: "updateKiosk",
	    value: function updateKiosk(id, kiosk) {
	      return { id: id, kiosk: kiosk };
	    }
	  }, {
	    key: "edit",
	    value: function edit(id, values) {
	      return { id: id, values: values };
	    }
	  }]);
	
	  return KioskActions;
	}();
	
	exports.default = _alt2.default.createActions(KioskActions);
	module.exports = exports["default"];

/***/ }),
/* 2833 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _alt = __webpack_require__(975);
	
	var _alt2 = _interopRequireDefault(_alt);
	
	var _keyBy = __webpack_require__(990);
	
	var _keyBy2 = _interopRequireDefault(_keyBy);
	
	var _extend = __webpack_require__(1212);
	
	var _extend2 = _interopRequireDefault(_extend);
	
	var _KioskUtil = __webpack_require__(2834);
	
	var _KioskUtil2 = _interopRequireDefault(_KioskUtil);
	
	var _KioskActions = __webpack_require__(2832);
	
	var _KioskActions2 = _interopRequireDefault(_KioskActions);
	
	var _EventBucketActions = __webpack_require__(1218);
	
	var _EventBucketActions2 = _interopRequireDefault(_EventBucketActions);
	
	var _UserStore = __webpack_require__(974);
	
	var _UserStore2 = _interopRequireDefault(_UserStore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var KioskStore = function () {
	  function KioskStore() {
	    _classCallCheck(this, KioskStore);
	
	    this.bindActions(_KioskActions2.default);
	
	    this.state = {
	      kiosks: {},
	      newKioskId: null
	    };
	
	    this.exportPublicMethods({
	      getKioskById: this.getKioskById.bind(this)
	    });
	  }
	
	  _createClass(KioskStore, [{
	    key: "getKioskById",
	    value: function getKioskById(id) {
	      return this.state.kiosks[id];
	    }
	  }, {
	    key: "onFetchOne",
	    value: function onFetchOne(id) {
	      _KioskUtil2.default.fetchOne(_UserStore2.default.getState().apiKey, id).then(function (data) {
	        _KioskActions2.default.updateKiosk(id, data);
	      }).catch(_KioskActions2.default.fetchFailed);
	    }
	  }, {
	    key: "onFetchAllForBucket",
	    value: function onFetchAllForBucket(eventBucket) {
	      _KioskUtil2.default.fetchAllForBucket(_UserStore2.default.getState().apiKey, eventBucket).then(function (data) {
	        _KioskActions2.default.updateKiosks((0, _keyBy2.default)(data, "id"));
	      }).catch(_KioskActions2.default.fetchFailed);
	    }
	  }, {
	    key: "onEdit",
	    value: function onEdit(newData) {
	      _KioskUtil2.default.edit(_UserStore2.default.getState().apiKey, newData.id, newData.values).then(function (data) {
	        _KioskActions2.default.updateKiosk(newData.id, data);
	        _EventBucketActions2.default.fetchOne(data.event_bucket);
	      }).catch(_KioskActions2.default.editFailed);
	    }
	  }, {
	    key: "onDelete",
	    value: function onDelete(id) {
	      var _this = this;
	
	      _KioskUtil2.default.delete(_UserStore2.default.getState().apiKey, id).then(function (data) {
	        _EventBucketActions2.default.fetchOne(_this.state.kiosks[id].event_bucket);
	        _KioskActions2.default.updateKiosk(id, undefined);
	      }).catch(_KioskActions2.default.editFailed);
	    }
	  }, {
	    key: "onCreate",
	    value: function onCreate(newData) {
	      var _this2 = this;
	
	      this.setState({
	        newKioskId: null
	      });
	
	      _KioskUtil2.default.create(_UserStore2.default.getState().apiKey, newData).then(function (data) {
	        _KioskActions2.default.updateKiosk(data.id, data);
	        _EventBucketActions2.default.fetchOne(data.event_bucket);
	        _this2.setState({
	          newKioskId: data.id
	        });
	      }).catch(_KioskActions2.default.editFailed);
	    }
	  }, {
	    key: "onUpdateKiosk",
	    value: function onUpdateKiosk(data) {
	      if (!data.kiosk) {
	        delete this.state.kiosks[data.id];
	      } else {
	        this.state.kiosks[data.id] = data.kiosk;
	      }
	      this.state.newKioskId = null;
	      this.setState(this.state);
	    }
	  }, {
	    key: "onUpdateKiosks",
	    value: function onUpdateKiosks(kiosks) {
	      (0, _extend2.default)(this.state.kiosks, kiosks);
	      this.setState(this.state);
	    }
	  }, {
	    key: "onFetchFailed",
	    value: function onFetchFailed(e) {
	      alert("Fetching kiosk failed: " + e.message);
	      throw e;
	    }
	  }, {
	    key: "onEditFailed",
	    value: function onEditFailed(e) {
	      alert("Edit failed: " + e.message);
	      throw e;
	    }
	  }]);
	
	  return KioskStore;
	}();
	
	exports.default = _alt2.default.createStore(KioskStore, "KioskStore");
	module.exports = exports["default"];

/***/ }),
/* 2834 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _merge = __webpack_require__(732);
	
	var _merge2 = _interopRequireDefault(_merge);
	
	var _api = __webpack_require__(1160);
	
	var _api2 = _interopRequireDefault(_api);
	
	var _config = __webpack_require__(1173);
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  fetchOne: function fetchOne(apiKey, kiosk) {
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "GET",
	        endpoint: "kiosks/" + kiosk,
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response);
	      });
	    });
	  },
	  fetchAllForBucket: function fetchAllForBucket(apiKey, bucket) {
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "GET",
	        endpoint: "event_buckets/" + bucket + "/kiosks",
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response.kiosks);
	      });
	    });
	  },
	  edit: function edit(apiKey, kiosk, values) {
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "POST",
	        endpoint: "kiosks/" + kiosk,
	        json: values,
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response);
	      });
	    });
	  },
	  delete: function _delete(apiKey, kiosk) {
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "DELETE",
	        endpoint: "kiosks/" + kiosk,
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response);
	      });
	    });
	  },
	  create: function create(apiKey, values) {
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "POST",
	        endpoint: "kiosks",
	        json: values,
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response);
	      });
	    });
	  }
	};
	module.exports = exports["default"];

/***/ }),
/* 2835 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _assign = __webpack_require__(920);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _set = __webpack_require__(1188);
	
	var _set2 = _interopRequireDefault(_set);
	
	var _get = __webpack_require__(1004);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _just = __webpack_require__(2766);
	
	var _just2 = _interopRequireDefault(_just);
	
	var _materialUi = __webpack_require__(576);
	
	var _styles = __webpack_require__(917);
	
	var _workingIndicator = __webpack_require__(1664);
	
	var _workingIndicator2 = _interopRequireDefault(_workingIndicator);
	
	var _connectToStores = __webpack_require__(1226);
	
	var _connectToStores2 = _interopRequireDefault(_connectToStores);
	
	var _KioskActions = __webpack_require__(2832);
	
	var _KioskActions2 = _interopRequireDefault(_KioskActions);
	
	var _KioskStore = __webpack_require__(2833);
	
	var _KioskStore2 = _interopRequireDefault(_KioskStore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Kiosk = function (_React$Component) {
	  _inherits(Kiosk, _React$Component);
	
	  function Kiosk(props) {
	    _classCallCheck(this, Kiosk);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(Kiosk).call(this, props));
	
	    _this.state = {
	      kiosk: null,
	      dirty: false,
	      values: {}
	    };
	
	    _this.onChange = _this.onChange.bind(_this);
	    _this.onChangeValue = _this.onChangeValue.bind(_this);
	    _this.makeNewRandomCode = _this.makeNewRandomCode.bind(_this);
	    _this.save = _this.save.bind(_this);
	    _this.delete = _this.delete.bind(_this);
	    return _this;
	  }
	
	  _createClass(Kiosk, [{
	    key: "getStyles",
	    value: function getStyles() {
	      return {
	        actions: {
	          marginTop: 40
	        },
	        a: {
	          color: _styles.colors.lightBlue700,
	          textDecoration: "underline",
	          cursor: "pointer"
	        },
	        h3: {
	          marginTop: 30,
	          marginBottom: 10
	        }
	      };
	    }
	  }, {
	    key: "onChange",
	    value: function onChange(id, e, checked) {
	      this.onChangeValue(id, typeof checked !== "undefined" ? !this.state.values[id] : e.target.value);
	    }
	  }, {
	    key: "onChangeValue",
	    value: function onChangeValue(id, value) {
	      this.state.dirty = true;
	      (0, _set2.default)(this.state.values, id, value);
	      this.setState(this.state);
	    }
	  }, {
	    key: "makeNewRandomCode",
	    value: function makeNewRandomCode() {
	      this.state.dirty = true;
	      this.state.values.code = (0, _just2.default)(15, "numbers_uppercases");
	      this.setState(this.state);
	    }
	  }, {
	    key: "save",
	    value: function save() {
	      var values = (0, _assign2.default)({}, this.state.values);
	
	      if (values.target && values.target.ids) {
	        values.target.ids = values.target.ids.split(/\s*,\s*/g);
	      }
	
	      _KioskActions2.default.edit(this.props.params.kioskId, values);
	    }
	  }, {
	    key: "delete",
	    value: function _delete() {
	      var bucket = this.state.kiosk.event_bucket;
	      if (window.confirm("Are you sure?")) {
	        _KioskActions2.default.delete(this.props.params.kioskId);
	        this.context.router.push("/event_buckets/" + bucket + "/kiosks");
	      }
	    }
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.componentWillReceiveProps(this.props);
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(newProps) {
	      var kiosk = newProps.getKioskById(newProps.params.kioskId);
	
	      if (!this.state.isFetchingKiosk && !kiosk) {
	        _KioskActions2.default.fetchOne(newProps.params.kioskId);
	        this.setState({ isFetchingKiosk: true });
	      } else if (kiosk) {
	        this.setState({ isFetchingKiosk: false });
	      }
	
	      this.setState({
	        kiosk: kiosk,
	        dirty: false,
	        values: kiosk ? {
	          name: kiosk.name || "",
	          code: kiosk.code || "",
	          printer: kiosk.printer || ""
	        } : {}
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var styles = this.getStyles();
	
	      if (!this.state.kiosk) {
	        return _react2.default.createElement(_workingIndicator2.default, { fullPage: true });
	      }
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(_materialUi.TextField, {
	              value: (0, _get2.default)(this.state, "values.name", ""),
	              floatingLabelText: "Name",
	              onChange: function onChange(e) {
	                return _this2.onChangeValue("name", e.target.value);
	              }
	            })
	          ),
	          _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(_materialUi.TextField, {
	              value: (0, _get2.default)(this.state, "values.code", ""),
	              floatingLabelText: "Code",
	              onChange: function onChange(e) {
	                return _this2.onChangeValue("code", e.target.value);
	              }
	            }),
	            _react2.default.createElement(
	              "div",
	              null,
	              _react2.default.createElement(
	                "a",
	                { style: styles.a, onTouchTap: this.makeNewRandomCode },
	                "Generate a new random code"
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(_materialUi.TextField, {
	              value: (0, _get2.default)(this.state, "values.printer", ""),
	              floatingLabelText: "Printer",
	              onChange: function onChange(e) {
	                return _this2.onChangeValue("printer", e.target.value);
	              }
	            })
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { style: styles.actions },
	          _react2.default.createElement(_materialUi.RaisedButton, {
	            label: this.state.dirty ? "Save changes" : "No changes to save",
	            primary: true,
	            disabled: !this.state.dirty,
	            onTouchTap: this.save
	          }),
	          _react2.default.createElement(_materialUi.RaisedButton, {
	            label: "Delete kiosk",
	            onTouchTap: this.delete,
	            style: { marginLeft: 7 }
	          })
	        )
	      );
	    }
	  }], [{
	    key: "getStores",
	    value: function getStores() {
	      return [_KioskStore2.default];
	    }
	  }, {
	    key: "getPropsFromStores",
	    value: function getPropsFromStores() {
	      return {
	        getKioskById: _KioskStore2.default.getKioskById
	      };
	    }
	  }, {
	    key: "contextTypes",
	    get: function get() {
	      return {
	        router: _react2.default.PropTypes.object
	      };
	    }
	  }]);
	
	  return Kiosk;
	}(_react2.default.Component);
	
	exports.default = (0, _connectToStores2.default)(Kiosk);
	module.exports = exports["default"];

/***/ }),
/* 2836 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _connectToStores = __webpack_require__(1226);
	
	var _connectToStores2 = _interopRequireDefault(_connectToStores);
	
	var _KioskActions = __webpack_require__(2832);
	
	var _KioskActions2 = _interopRequireDefault(_KioskActions);
	
	var _KioskStore = __webpack_require__(2833);
	
	var _KioskStore2 = _interopRequireDefault(_KioskStore);
	
	var _workingIndicator = __webpack_require__(1664);
	
	var _workingIndicator2 = _interopRequireDefault(_workingIndicator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var NewKiosk = function (_React$Component) {
	  _inherits(NewKiosk, _React$Component);
	
	  function NewKiosk(props) {
	    _classCallCheck(this, NewKiosk);
	
	    return _possibleConstructorReturn(this, Object.getPrototypeOf(NewKiosk).call(this, props));
	  }
	
	  _createClass(NewKiosk, [{
	    key: "componentWillMount",
	    value: function componentWillMount() {
	      _KioskActions2.default.create({
	        name: "Unnamed Kiosk",
	        event_bucket: this.props.params.eventBucketId
	      });
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(props) {
	      if (props.newKioskId) {
	        this.context.router.replace("/event_buckets/" + props.params.eventBucketId + "/kiosks/" + props.newKioskId);
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement(_workingIndicator2.default, { fullPage: true });
	    }
	  }], [{
	    key: "getStores",
	    value: function getStores() {
	      return [_KioskStore2.default];
	    }
	  }, {
	    key: "getPropsFromStores",
	    value: function getPropsFromStores() {
	      return {
	        newKioskId: _KioskStore2.default.getState().newKioskId
	      };
	    }
	  }, {
	    key: "contextTypes",
	    get: function get() {
	      return {
	        router: _react2.default.PropTypes.object
	      };
	    }
	  }]);
	
	  return NewKiosk;
	}(_react2.default.Component);
	
	exports.default = (0, _connectToStores2.default)(NewKiosk);
	module.exports = exports["default"];

/***/ }),
/* 2837 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _values = __webpack_require__(1214);
	
	var _values2 = _interopRequireDefault(_values);
	
	var _pickBy = __webpack_require__(1163);
	
	var _pickBy2 = _interopRequireDefault(_pickBy);
	
	var _moment = __webpack_require__(1021);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _reactRouter = __webpack_require__(486);
	
	var _materialUi = __webpack_require__(576);
	
	var _reactable = __webpack_require__(1688);
	
	var _connectToStores = __webpack_require__(1226);
	
	var _connectToStores2 = _interopRequireDefault(_connectToStores);
	
	var _MailingActions = __webpack_require__(2838);
	
	var _MailingActions2 = _interopRequireDefault(_MailingActions);
	
	var _MailingStore = __webpack_require__(2839);
	
	var _MailingStore2 = _interopRequireDefault(_MailingStore);
	
	var _workingIndicator = __webpack_require__(1664);
	
	var _workingIndicator2 = _interopRequireDefault(_workingIndicator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Mailings = function (_React$Component) {
	  _inherits(Mailings, _React$Component);
	
	  function Mailings(props) {
	    _classCallCheck(this, Mailings);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(Mailings).call(this, props));
	
	    _this._makeRowForMailing = _this._makeRowForMailing.bind(_this);
	    return _this;
	  }
	
	  _createClass(Mailings, [{
	    key: "getStyles",
	    value: function getStyles() {
	      return {};
	    }
	  }, {
	    key: "_makeRowForMailing",
	    value: function _makeRowForMailing(mailing) {
	      return _react2.default.createElement(
	        _reactable.Tr,
	        null,
	        _react2.default.createElement(
	          _reactable.Td,
	          { column: "Subject", value: mailing.subject },
	          mailing.subject
	        ),
	        _react2.default.createElement(
	          _reactable.Td,
	          { column: "Creation Date", value: mailing.created_at },
	          (0, _moment2.default)(mailing.created_at).format("lll")
	        ),
	        _react2.default.createElement(
	          _reactable.Td,
	          { column: "Send Date", value: mailing.sent_at },
	          mailing.sent_at ? (0, _moment2.default)(mailing.sent_at).format("lll") : "not sent"
	        ),
	        _react2.default.createElement(
	          _reactable.Td,
	          { column: "Actions" },
	          _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(
	              _reactRouter.Link,
	              {
	                to: "/event_buckets/" + this.props.params.eventBucketId + "/mailings/" + mailing.id
	              },
	              mailing.sent_at ? "View" : "Edit"
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: "componentWillMount",
	    value: function componentWillMount() {
	      _MailingActions2.default.fetchAllForBucket(this.props.params.eventBucketId);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var styles = this.getStyles(),
	          bucket = this.props.params.eventBucketId,
	          mailings = (0, _values2.default)((0, _pickBy2.default)(this.props.mailings, function (c) {
	        return c.event_bucket === bucket;
	      })),
	          rows = mailings.map(this._makeRowForMailing);
	
	      // TODO: Discuss the potential issue here with Theo, might be a non-issue
	      if (mailings.length === 0 && _MailingStore2.default.getState().isFetching) {
	        return _react2.default.createElement(_workingIndicator2.default, { fullPage: true });
	      }
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          "h1",
	          { className: "page-title" },
	          "Mailings"
	        ),
	        _react2.default.createElement(
	          _reactable.Table,
	          {
	            className: "bordered striped responsive-table",
	            sortable: [{ column: "Subject", sortFunction: _reactable.Sort.CaseInsensitive }, "Creation Date", "Send Date"],
	            defaultSort: { column: "Creation Date", direction: "desc" },
	            columns: ["Subject", "Creation Date", "Send Date", "Actions"],
	            filterable: ["Subject"],
	            filterPlaceholder: "Type to filter..."
	          },
	          rows
	        ),
	        rows.length === 0 ? _react2.default.createElement(
	          "div",
	          { className: "empty-table-message" },
	          "No mailings yet.",
	          " ",
	          _react2.default.createElement(
	            _reactRouter.Link,
	            { to: "/event_buckets/" + bucket + "/mailings/new" },
	            "Create a new mailing."
	          )
	        ) : null,
	        _react2.default.createElement(
	          "div",
	          { style: { marginTop: 20 } },
	          _react2.default.createElement(_materialUi.RaisedButton, {
	            label: "Create new mailing",
	            primary: true,
	            onTouchTap: function onTouchTap() {
	              return _this2.context.router.push("/event_buckets/" + _this2.props.params.eventBucketId + "/mailings/new");
	            }
	          })
	        )
	      );
	    }
	  }], [{
	    key: "getStores",
	    value: function getStores() {
	      return [_MailingStore2.default];
	    }
	  }, {
	    key: "getPropsFromStores",
	    value: function getPropsFromStores() {
	      return {
	        mailings: _MailingStore2.default.getState().mailings
	      };
	    }
	  }, {
	    key: "contextTypes",
	    get: function get() {
	      return {
	        router: _react2.default.PropTypes.object
	      };
	    }
	  }]);
	
	  return Mailings;
	}(_react2.default.Component);
	
	exports.default = (0, _connectToStores2.default)(Mailings);
	module.exports = exports["default"];

/***/ }),
/* 2838 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _alt = __webpack_require__(975);
	
	var _alt2 = _interopRequireDefault(_alt);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var MailingActions = function () {
	  function MailingActions() {
	    _classCallCheck(this, MailingActions);
	
	    this.generateActions("create", "send", "delete", "updateMailings", "clone", "fetchOne", "fetchAllForBucket", "fetchFailed", "editFailed", "clearErrors");
	  }
	
	  _createClass(MailingActions, [{
	    key: "updateMailing",
	    value: function updateMailing(id, mailing) {
	      return { id: id, mailing: mailing };
	    }
	  }, {
	    key: "edit",
	    value: function edit(id, values) {
	      return { id: id, values: values };
	    }
	  }]);
	
	  return MailingActions;
	}();
	
	exports.default = _alt2.default.createActions(MailingActions);
	module.exports = exports["default"];

/***/ }),
/* 2839 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _alt = __webpack_require__(975);
	
	var _alt2 = _interopRequireDefault(_alt);
	
	var _keyBy = __webpack_require__(990);
	
	var _keyBy2 = _interopRequireDefault(_keyBy);
	
	var _extend = __webpack_require__(1212);
	
	var _extend2 = _interopRequireDefault(_extend);
	
	var _MailingUtil = __webpack_require__(2840);
	
	var _MailingUtil2 = _interopRequireDefault(_MailingUtil);
	
	var _MailingActions = __webpack_require__(2838);
	
	var _MailingActions2 = _interopRequireDefault(_MailingActions);
	
	var _EventBucketActions = __webpack_require__(1218);
	
	var _EventBucketActions2 = _interopRequireDefault(_EventBucketActions);
	
	var _UserStore = __webpack_require__(974);
	
	var _UserStore2 = _interopRequireDefault(_UserStore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var MailingStore = function () {
	  function MailingStore() {
	    _classCallCheck(this, MailingStore);
	
	    this.bindActions(_MailingActions2.default);
	
	    this.state = {
	      mailings: {},
	      newMailingId: null,
	      isEditing: false,
	      errorMessage: "",
	      isFetching: false
	    };
	
	    this.exportPublicMethods({
	      getMailingById: this.getMailingById.bind(this)
	    });
	  }
	
	  _createClass(MailingStore, [{
	    key: "getMailingById",
	    value: function getMailingById(id) {
	      return this.state.mailings[id];
	    }
	  }, {
	    key: "onClearErrors",
	    value: function onClearErrors() {
	      this.setState({
	        errorMessage: ""
	      });
	    }
	  }, {
	    key: "onFetchOne",
	    value: function onFetchOne(id) {
	      var _this = this;
	
	      this.setState({ isFetching: true });
	      _MailingUtil2.default.fetchOne(_UserStore2.default.getState().apiKey, id).then(function (data) {
	        _MailingActions2.default.updateMailing(id, data);
	        _this.setState({ isFetching: false });
	      }).catch(_MailingActions2.default.fetchFailed);
	    }
	  }, {
	    key: "onFetchAllForBucket",
	    value: function onFetchAllForBucket(eventBucket) {
	      var _this2 = this;
	
	      this.setState({ isFetching: true });
	      _MailingUtil2.default.fetchAllForBucket(_UserStore2.default.getState().apiKey, eventBucket).then(function (data) {
	        _MailingActions2.default.updateMailings((0, _keyBy2.default)(data, "id"));
	        _this2.setState({ isFetching: false });
	      }).catch(_MailingActions2.default.fetchFailed);
	    }
	  }, {
	    key: "onEdit",
	    value: function onEdit(newData) {
	      this.setState({ errorMessage: "", isEditing: true });
	      _MailingUtil2.default.edit(_UserStore2.default.getState().apiKey, newData.id, newData.values).then(function (data) {
	        _MailingActions2.default.updateMailing(newData.id, data);
	        _EventBucketActions2.default.fetchOne(data.event_bucket);
	      }).catch(_MailingActions2.default.editFailed);
	    }
	  }, {
	    key: "onDelete",
	    value: function onDelete(id) {
	      var _this3 = this;
	
	      _MailingUtil2.default.delete(_UserStore2.default.getState().apiKey, id).then(function (data) {
	        _EventBucketActions2.default.fetchOne(_this3.state.mailings[id].event_bucket);
	        _MailingActions2.default.updateMailing(id, undefined);
	      }).catch(_MailingActions2.default.editFailed);
	    }
	  }, {
	    key: "onSend",
	    value: function onSend(id) {
	      var _this4 = this;
	
	      this.setState({ errorMessage: "", isEditing: true });
	      _MailingUtil2.default.send(_UserStore2.default.getState().apiKey, id).then(function (data) {
	        _MailingActions2.default.updateMailing(id, data);
	        _EventBucketActions2.default.fetchOne(_this4.state.mailings[id].event_bucket);
	      }).catch(_MailingActions2.default.editFailed);
	    }
	  }, {
	    key: "onCreate",
	    value: function onCreate(newData) {
	      var _this5 = this;
	
	      this.setState({
	        newMailingId: null
	      });
	
	      _MailingUtil2.default.create(_UserStore2.default.getState().apiKey, newData).then(function (data) {
	        window.Intercom("trackEvent", "create-mailing");
	
	        _MailingActions2.default.updateMailing(data.id, data);
	        _EventBucketActions2.default.fetchOne(data.event_bucket);
	        _this5.setState({
	          newMailingId: data.id
	        });
	      }).catch(_MailingActions2.default.editFailed);
	    }
	  }, {
	    key: "onClone",
	    value: function onClone(newData) {
	      var _this6 = this;
	
	      this.setState({
	        newMailingId: null
	      });
	
	      _MailingUtil2.default.clone(_UserStore2.default.getState().apiKey, newData).then(function (data) {
	        //window.Intercom("trackEvent", "create-mailing");
	
	        _MailingActions2.default.updateMailing(data.id, data);
	        _EventBucketActions2.default.fetchOne(data.event_bucket);
	        _this6.setState({
	          newMailingId: data.id
	        });
	      }).catch(_MailingActions2.default.editFailed);
	    }
	  }, {
	    key: "onUpdateMailing",
	    value: function onUpdateMailing(data) {
	      if (!data.mailing) {
	        delete this.state.mailings[data.id];
	      } else {
	        this.state.mailings[data.id] = data.mailing;
	      }
	      this.state.isEditing = false;
	      this.state.newMailingId = null;
	      this.setState(this.state);
	    }
	  }, {
	    key: "onUpdateMailings",
	    value: function onUpdateMailings(mailings) {
	      (0, _extend2.default)(this.state.mailings, mailings);
	      this.setState(this.state);
	    }
	  }, {
	    key: "onFetchFailed",
	    value: function onFetchFailed(e) {
	      alert("Fetching mailing failed: " + e.message);
	      throw e;
	    }
	  }, {
	    key: "onEditFailed",
	    value: function onEditFailed(e) {
	      this.setState({
	        errorMessage: e.message,
	        isEditing: false
	      });
	    }
	  }]);
	
	  return MailingStore;
	}();
	
	exports.default = _alt2.default.createStore(MailingStore, "MailingStore");
	module.exports = exports["default"];

/***/ }),
/* 2840 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _merge = __webpack_require__(732);
	
	var _merge2 = _interopRequireDefault(_merge);
	
	var _api = __webpack_require__(1160);
	
	var _api2 = _interopRequireDefault(_api);
	
	var _config = __webpack_require__(1173);
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  fetchOne: function fetchOne(apiKey, mailing) {
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "GET",
	        endpoint: "mailings/" + mailing,
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response);
	      });
	    });
	  },
	  fetchAllForBucket: function fetchAllForBucket(apiKey, bucket) {
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "GET",
	        endpoint: "event_buckets/" + bucket + "/mailings?no_recipients=true",
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response.mailings);
	      });
	    });
	  },
	  edit: function edit(apiKey, mailing, values) {
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "POST",
	        endpoint: "mailings/" + mailing,
	        json: values,
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response);
	      });
	    });
	  },
	  send: function send(apiKey, mailing) {
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "POST",
	        endpoint: "mailings/" + mailing + "/send",
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response);
	      });
	    });
	  },
	  delete: function _delete(apiKey, mailing) {
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "DELETE",
	        endpoint: "mailings/" + mailing,
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response);
	      });
	    });
	  },
	  create: function create(apiKey, values) {
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "POST",
	        endpoint: "mailings",
	        json: values,
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response);
	      });
	    });
	  },
	  clone: function clone(apiKey, values) {
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "POST",
	        endpoint: "mailings/clone",
	        json: values,
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response);
	      });
	    });
	  }
	};
	module.exports = exports["default"];

/***/ }),
/* 2841 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _assign = __webpack_require__(920);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _get = __webpack_require__(1004);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _set = __webpack_require__(1188);
	
	var _set2 = _interopRequireDefault(_set);
	
	var _marked = __webpack_require__(2842);
	
	var _marked2 = _interopRequireDefault(_marked);
	
	var _moment = __webpack_require__(1021);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _reactSelect = __webpack_require__(953);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	var _materialUi = __webpack_require__(576);
	
	var _styles = __webpack_require__(917);
	
	var _workingIndicator = __webpack_require__(1664);
	
	var _workingIndicator2 = _interopRequireDefault(_workingIndicator);
	
	var _label = __webpack_require__(1682);
	
	var _label2 = _interopRequireDefault(_label);
	
	var _basicHtmlField = __webpack_require__(2674);
	
	var _basicHtmlField2 = _interopRequireDefault(_basicHtmlField);
	
	var _linkLike = __webpack_require__(973);
	
	var _linkLike2 = _interopRequireDefault(_linkLike);
	
	var _backButton = __webpack_require__(1872);
	
	var _backButton2 = _interopRequireDefault(_backButton);
	
	var _util = __webpack_require__(1183);
	
	var util = _interopRequireWildcard(_util);
	
	var _infoNotice = __webpack_require__(1599);
	
	var _infoNotice2 = _interopRequireDefault(_infoNotice);
	
	var _listTargetBuilder = __webpack_require__(2843);
	
	var _listTargetBuilder2 = _interopRequireDefault(_listTargetBuilder);
	
	var _connectToStores = __webpack_require__(1226);
	
	var _connectToStores2 = _interopRequireDefault(_connectToStores);
	
	var _MailingActions = __webpack_require__(2838);
	
	var _MailingActions2 = _interopRequireDefault(_MailingActions);
	
	var _MailingStore = __webpack_require__(2839);
	
	var _MailingStore2 = _interopRequireDefault(_MailingStore);
	
	var _EventActions = __webpack_require__(2031);
	
	var _EventActions2 = _interopRequireDefault(_EventActions);
	
	var _EventBucketStore = __webpack_require__(1593);
	
	var _EventBucketStore2 = _interopRequireDefault(_EventBucketStore);
	
	var _EventStore = __webpack_require__(2032);
	
	var _EventStore2 = _interopRequireDefault(_EventStore);
	
	var _PassBucketActions = __webpack_require__(1869);
	
	var _PassBucketActions2 = _interopRequireDefault(_PassBucketActions);
	
	var _PassBucketStore = __webpack_require__(1867);
	
	var _PassBucketStore2 = _interopRequireDefault(_PassBucketStore);
	
	var _CouponActions = __webpack_require__(2041);
	
	var _CouponActions2 = _interopRequireDefault(_CouponActions);
	
	var _CouponStore = __webpack_require__(2042);
	
	var _CouponStore2 = _interopRequireDefault(_CouponStore);
	
	var _TagActions = __webpack_require__(2038);
	
	var _TagActions2 = _interopRequireDefault(_TagActions);
	
	var _TagStore = __webpack_require__(2039);
	
	var _TagStore2 = _interopRequireDefault(_TagStore);
	
	var _reactRouter = __webpack_require__(486);
	
	var _config = __webpack_require__(1173);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _UserStore = __webpack_require__(974);
	
	var _UserStore2 = _interopRequireDefault(_UserStore);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Mailing = function (_React$Component) {
	  _inherits(Mailing, _React$Component);
	
	  function Mailing(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, Mailing);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(Mailing).call(this, props));
	
	    _this.sendTestMail = _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
	      return regeneratorRuntime.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              _context.prev = 0;
	              _context.next = 3;
	              return fetch(_config2.default.endpoint + "mailings/" + _this.props.params.mailingId + "/sendTestMailing?" + _UserStore2.default.makeApiKeyQueryString(), {
	                method: "POST",
	                body: JSON.stringify({
	                  testRecipient: _this.state.testEmailRecipient
	                }),
	                headers: {
	                  "Content-Type": "application/json"
	                }
	              });
	
	            case 3:
	              window.alert("We sent a test email to " + _this.state.testEmailRecipient);
	              _this.setState({ testEmailRecipient: "" });
	              _context.next = 10;
	              break;
	
	            case 7:
	              _context.prev = 7;
	              _context.t0 = _context["catch"](0);
	
	              window.alert("Failed to send a test email: " + _context.t0);
	
	            case 10:
	            case "end":
	              return _context.stop();
	          }
	        }
	      }, _callee, _this2, [[0, 7]]);
	    }));
	
	    _this.state = {
	      mailing: null,
	      dirty: false,
	      isWorking: false,
	      isFetchingMailing: false,
	      values: {},
	      lastUpdated: null,
	      previewRecipients: false,
	      testEmailRecipient: ""
	    };
	
	    _this.onChange = _this.onChange.bind(_this);
	    _this.onChangeValue = _this.onChangeValue.bind(_this);
	    _this.onChangeDropdown = _this.onChangeDropdown.bind(_this);
	    _this.save = _this.save.bind(_this);
	    _this.delete = _this.delete.bind(_this);
	    _this.send = _this.send.bind(_this);
	    _this.clone = _this.clone.bind(_this);
	    _this.previewRecipients = _this.previewRecipients.bind(_this);
	    _this.downloadRecipients = _this.downloadRecipients.bind(_this);
	    _this.testSend = _this.testSend.bind(_this);
	    _this.onChangeTestEmail = _this.onChangeTestEmail.bind(_this);
	    return _this;
	  }
	
	  _createClass(Mailing, [{
	    key: "getStyles",
	    value: function getStyles() {
	      return {
	        sentNotice: {
	          margin: "0 auto",
	          width: 295,
	          backgroundColor: "rgba(255, 0, 0, 0.54)",
	          opacity: 1,
	          padding: 13,
	          fontSize: 20,
	          textAlign: "center",
	          position: "absolute",
	          left: 0,
	          right: 0,
	          top: 150
	        },
	        actions: {
	          marginTop: 10
	        },
	        a: {
	          color: _styles.colors.lightBlue700,
	          textDecoration: "underline",
	          cursor: "pointer"
	        },
	        h3: {
	          marginTop: 30,
	          marginBottom: 10
	        },
	        label: {
	          fontSize: 13,
	          color: "rgba(33,33,33,0.5)",
	          marginTop: 11,
	          marginBottom: -12,
	          fontWeight: "initial"
	        },
	        sentLabel: {
	          fontSize: 13,
	          color: "rgba(33,33,33,0.5)",
	          marginTop: 11,
	          marginBottom: -3
	        },
	        sentContent: {
	          border: "1px solid #ccc",
	          padding: 5,
	          overflow: "auto"
	        },
	        error: {
	          color: "red",
	          marginTop: 10
	        },
	        readyToSend: {
	          marginTop: 20,
	          marginBottom: 20
	        },
	        previewSection: {
	          display: "flex",
	          flexDirection: "column"
	        }
	      };
	    }
	  }, {
	    key: "onChange",
	    value: function onChange(id, e, checked) {
	      this.onChangeValue(id, typeof checked !== "undefined" ? !this.state.values[id] : e.target.value);
	    }
	  }, {
	    key: "onChangeDropdown",
	    value: function onChangeDropdown(id, e, index, item) {
	      this.onChangeValue(id, item.payload);
	    }
	  }, {
	    key: "onChangeValue",
	    value: function onChangeValue(id, value) {
	      // Persist promotional state when resetting query
	      if (id === "query") {
	        value.promotional = this.state.values.query.promotional;
	      }
	
	      this.state.dirty = true;
	      (0, _set2.default)(this.state.values, id, value);
	      this.setState(this.state);
	    }
	  }, {
	    key: "onChangeTestEmail",
	    value: function onChangeTestEmail(value) {
	      this.setState({ testEmailRecipient: value });
	    }
	  }, {
	    key: "save",
	    value: function save() {
	      var values = (0, _assign2.default)({}, this.state.values);
	      this.setState({
	        isWorking: true,
	        lastUpdated: this.state.mailing.updated_at
	      });
	      _MailingActions2.default.edit(this.props.params.mailingId, values);
	    }
	  }, {
	    key: "clone",
	    value: function clone() {
	      this.context.router.replace("/event_buckets/" + this.props.params.eventBucketId + "/mailings/clone/" + this.props.params.mailingId);
	    }
	  }, {
	    key: "send",
	    value: function send() {
	      var bucket = this.state.mailing.event_bucket;
	      if (window.confirm("Are you sure? This message, with the subject \"" + (this.state.mailing.subject + "\", will be sent immediately ") + ("to " + this.state.mailing.recipients.length + " recipients."))) {
	        this.setState({
	          isWorking: true,
	          lastUpdated: this.state.mailing.updated_at
	        });
	        _MailingActions2.default.send(this.props.params.mailingId);
	      }
	    }
	  }, {
	    key: "testSend",
	    value: function testSend() {
	      this.sendTestMail();
	    }
	  }, {
	    key: "delete",
	    value: function _delete() {
	      var bucket = this.state.mailing.event_bucket;
	      if (window.confirm("Are you sure?")) {
	        _MailingActions2.default.delete(this.props.params.mailingId);
	        this.context.router.push("/event_buckets/" + bucket + "/mailings");
	      }
	    }
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var _this3 = this;
	
	      this.setState({ isFetchingMailing: true }, function () {
	        _MailingActions2.default.fetchOne.defer(_this3.props.params.mailingId);
	        _this3.componentWillReceiveProps(_this3.props);
	      });
	
	      _PassBucketActions2.default.fetchAllForEventBucket(this.props.params.eventBucketId);
	      _EventActions2.default.fetchAllForBucket(this.props.params.eventBucketId);
	      _CouponActions2.default.fetchAllForBucket(this.props.params.eventBucketId);
	      _TagActions2.default.fetchAllForBucket(this.props.params.eventBucketId);
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(newProps) {
	      var mailing = newProps.getMailingById(newProps.params.mailingId);
	
	      if (!this.state.isFetchingMailing && (!mailing || !mailing.recipients)) {
	        _MailingActions2.default.clearErrors();
	        _MailingActions2.default.fetchOne.defer(newProps.params.mailingId);
	        this.setState({ isFetchingMailing: true });
	      } else if (mailing && mailing.recipients) {
	        this.setState({ isFetchingMailing: false, mailing: mailing });
	      }
	
	      if (this.state.isWorking && !newProps.isEditing) {
	        this.setState({ isWorking: false });
	      }
	
	      if (Object.keys(this.state.values).length === 0 || this.state.mailing.id !== newProps.params.mailingId || this.state.isWorking && mailing.updated_at !== this.state.lastUpdated) {
	        this.setState({
	          mailing: mailing,
	          isWorking: false,
	          dirty: false,
	          values: mailing ? {
	            subject: mailing.subject || "",
	            content: mailing.content || "",
	            query: {
	              all_attendees: (0, _get2.default)(mailing, "query.all_attendees", false),
	              all_standalone_tickets_only: (0, _get2.default)(mailing, "query.all_standalone_tickets_only", false),
	              event: (0, _get2.default)(mailing, "query.event", []),
	              pass_bucket: (0, _get2.default)(mailing, "query.pass_bucket", []),
	              coupon: (0, _get2.default)(mailing, "query.coupon", []),
	              tag: (0, _get2.default)(mailing, "query.tag", []),
	              promotional: (0, _get2.default)(mailing, "query.promotional", false)
	            }
	          } : {}
	        });
	      }
	    }
	  }, {
	    key: "previewRecipients",
	    value: function previewRecipients() {
	      this.setState({ previewRecipients: !this.state.previewRecipients });
	    }
	  }, {
	    key: "downloadRecipients",
	    value: function downloadRecipients() {
	      util.clientSideDownload("mailing-" + this.state.mailing.id + "-" + util.snakeCase(this.state.mailing.subject) + ".csv", "text/csv", util.makeCsv(this.state.mailing.recipients.map(function (r) {
	        return [r.name, r.email];
	      })));
	    }
	  }, {
	    key: "_makeRecipientsList",
	    value: function _makeRecipientsList(recipients) {
	      return recipients.map(function (r) {
	        return r.name ? r.name + " <" + r.email + ">" : r.email;
	      }).join(", ");
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this4 = this;
	
	      var styles = this.getStyles();
	
	      var eventBucket = this.props.getEventBucketById(this.props.params.eventBucketId);
	
	      if (!this.state.mailing || !this.state.mailing.recipients || this.state.isFetchingMailing || _MailingStore2.default.getState().isFetching || this.state.isWorking) {
	        return _react2.default.createElement(_workingIndicator2.default, { fullPage: true });
	      }
	
	      var okayToSend = !this.state.dirty && this.state.mailing.recipients && this.state.mailing.recipients.length;
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement(_backButton2.default, {
	            label: "Mailings",
	            style: { marginBottom: 10 },
	            location: "/event_buckets/" + this.props.params.eventBucketId + "/mailings"
	          })
	        ),
	        this.state.mailing.sent_at ? _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement(
	            "div",
	            { style: { color: "green" } },
	            "This mailing has been sent. It cannot be modified. The following is preserved as a record of the mailing."
	          ),
	          _react2.default.createElement(
	            "h2",
	            { style: styles.sentLabel },
	            "Send date"
	          ),
	          (0, _moment2.default)(this.state.mailing.sent_at).format("LLLL"),
	          _react2.default.createElement(
	            "h2",
	            { style: styles.sentLabel },
	            "Recipients",
	            " ",
	            _react2.default.createElement(
	              _linkLike2.default,
	              {
	                style: { fontWeight: "normal" },
	                onTouchTap: this.previewRecipients
	              },
	              this.state.previewRecipients ? "hide list" : "show list"
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            null,
	            _listTargetBuilder2.default._makeRecipientDescription(this.state.mailing.query, this.props.eventBucketId, {
	              PassBucketStore: _PassBucketStore2.default,
	              EventStore: _EventStore2.default,
	              CouponStore: _CouponStore2.default,
	              EventBucketStore: _EventBucketStore2.default,
	              TagStore: _TagStore2.default
	            })
	          ),
	          this.state.previewRecipients && _react2.default.createElement(
	            "div",
	            null,
	            this._makeRecipientsList(this.state.mailing.recipients),
	            _react2.default.createElement(
	              "div",
	              null,
	              _react2.default.createElement(
	                _linkLike2.default,
	                { onTouchTap: this.downloadRecipients },
	                "Download as CSV"
	              ),
	              " ",
	              "(",
	              this.state.mailing.recipients.length,
	              " total)"
	            )
	          ),
	          _react2.default.createElement(
	            "h2",
	            { style: styles.sentLabel },
	            "Subject"
	          ),
	          this.state.mailing.subject,
	          _react2.default.createElement(
	            "h2",
	            { style: styles.sentLabel },
	            "Content"
	          ),
	          _react2.default.createElement("div", {
	            style: styles.sentContent,
	            className: "tenant-injected-html",
	            dangerouslySetInnerHTML: { __html: this.state.mailing.content }
	          })
	        ) : _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement(
	            _infoNotice2.default,
	            { style: { marginTop: 10 } },
	            "Check out our",
	            " ",
	            _react2.default.createElement(
	              "a",
	              {
	                href: "http://help.eventive.org/mailings/create-mailings",
	                target: "_blank"
	              },
	              "guide to creating mailings"
	            ),
	            "."
	          ),
	          _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(
	              "div",
	              null,
	              _react2.default.createElement(_materialUi.TextField, {
	                value: (0, _get2.default)(this.state, "values.subject", ""),
	                floatingLabelText: "Subject",
	                style: { width: 400 },
	                onChange: function onChange(e) {
	                  return _this4.onChangeValue("subject", e.target.value);
	                }
	              })
	            ),
	            _react2.default.createElement(_listTargetBuilder2.default, {
	              label: "Audience",
	              eventBucketId: this.props.params.eventBucketId,
	              stores: {
	                EventStore: _EventStore2.default,
	                CouponStore: _CouponStore2.default,
	                PassBucketStore: _PassBucketStore2.default,
	                EventBucketStore: _EventBucketStore2.default,
	                TagStore: _TagStore2.default
	              },
	              query: (0, _get2.default)(this.state, "values.query"),
	              onChange: this.onChangeValue
	            }),
	            _react2.default.createElement(
	              _label2.default,
	              null,
	              "Mailing type"
	            ),
	            _react2.default.createElement(
	              _materialUi.RadioButtonGroup,
	              {
	                name: "mailing_type",
	                valueSelected: (0, _get2.default)(this.state.values, "query.promotional") ? "promotional" : "transactional",
	                onChange: function onChange(e, v) {
	                  return _this4.onChangeValue("query.promotional", v === "promotional" ? true : false);
	                }
	              },
	              _react2.default.createElement(_materialUi.RadioButton, {
	                value: "transactional",
	                label: _react2.default.createElement(
	                  "span",
	                  null,
	                  "Transactional",
	                  " ",
	                  _react2.default.createElement(
	                    "i",
	                    null,
	                    "(for essential updates, instructions, and event changes; sent to all matching recipients)"
	                  )
	                )
	              }),
	              _react2.default.createElement(_materialUi.RadioButton, {
	                value: "promotional",
	                label: _react2.default.createElement(
	                  "span",
	                  null,
	                  "Promotional",
	                  " ",
	                  _react2.default.createElement(
	                    "i",
	                    null,
	                    "(for nonessential messages; skips recipients who have unsubscribed from promotions)"
	                  )
	                )
	              })
	            ),
	            _react2.default.createElement(
	              "div",
	              null,
	              _react2.default.createElement(_basicHtmlField2.default, {
	                value: (0, _get2.default)(this.state, "values.content", ""),
	                label: "Message",
	                onChange: function onChange(v) {
	                  return _this4.onChangeValue("content", v);
	                },
	                withImages: true
	              })
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            null,
	            !this.state.dirty ? _react2.default.createElement(
	              "div",
	              { style: styles.previewSection },
	              _react2.default.createElement(
	                _label2.default,
	                null,
	                "Previews"
	              ),
	              _react2.default.createElement(
	                "div",
	                null,
	                _react2.default.createElement(_materialUi.TextField, {
	                  floatingLabelText: "Test Email Recipient",
	                  type: "email",
	                  onChange: function onChange(e) {
	                    return _this4.onChangeTestEmail(e.target.value);
	                  },
	                  style: { marginRight: "8px", marginTop: "-40px" },
	                  value: this.state.testEmailRecipient
	                }),
	                _react2.default.createElement(_materialUi.RaisedButton, {
	                  label: "Send Test Email",
	                  onClick: this.testSend,
	                  style: { width: "fit-content" },
	                  disabled: this.state.testEmailRecipient === ""
	                })
	              ),
	              _react2.default.createElement(
	                "text",
	                { style: { marginTop: "8px" } },
	                "Preview mailing",
	                " ",
	                _react2.default.createElement(
	                  _reactRouter.Link,
	                  {
	                    to: "/event_buckets/" + this.props.params.eventBucketId + "/mailings/" + this.props.params.mailingId + "/preview"
	                  },
	                  "here"
	                )
	              )
	            ) : "Save changes before you can view a preview of your mailing"
	          ),
	          _react2.default.createElement(
	            "div",
	            { style: styles.readyToSend },
	            _react2.default.createElement(
	              "div",
	              null,
	              okayToSend ? _react2.default.createElement(
	                "span",
	                null,
	                "Ready to send to ",
	                this.state.mailing.recipients.length,
	                " ",
	                "recipients (",
	                _react2.default.createElement(
	                  _linkLike2.default,
	                  { onTouchTap: this.previewRecipients },
	                  this.state.previewRecipients ? "hide list" : "show list"
	                ),
	                ")."
	              ) : this.state.dirty || !this.state.mailing.recipients || this.state.mailing.recipients.length ? "Please save before sending." : "Cannot send: 0 recipients targeted."
	            ),
	            okayToSend && this.state.previewRecipients ? _react2.default.createElement(
	              "div",
	              null,
	              _react2.default.createElement(
	                "div",
	                null,
	                this._makeRecipientsList(this.state.mailing.recipients)
	              ),
	              _react2.default.createElement(
	                "div",
	                null,
	                _react2.default.createElement(
	                  _linkLike2.default,
	                  { onTouchTap: this.downloadRecipients },
	                  "Download as CSV"
	                )
	              )
	            ) : null
	          ),
	          this.props.errorMessage ? _react2.default.createElement(
	            "div",
	            { style: styles.error },
	            this.props.errorMessage
	          ) : null,
	          _react2.default.createElement(
	            "div",
	            { style: styles.actions },
	            _react2.default.createElement(_materialUi.RaisedButton, {
	              label: this.state.dirty ? "Save changes" : "No changes to save",
	              primary: true,
	              disabled: !this.state.dirty,
	              onTouchTap: this.save
	            }),
	            _react2.default.createElement(_materialUi.RaisedButton, {
	              label: "Delete mailing",
	              onTouchTap: this.delete,
	              style: { marginLeft: 7 }
	            }),
	            _react2.default.createElement(_materialUi.RaisedButton, {
	              label: "Send mailing",
	              disabled: !okayToSend,
	              onTouchTap: this.send,
	              style: { marginLeft: 7 }
	            })
	          )
	        )
	      );
	    }
	  }], [{
	    key: "getStores",
	    value: function getStores() {
	      return [_MailingStore2.default, _EventStore2.default, _PassBucketStore2.default, _CouponStore2.default, _EventBucketStore2.default];
	    }
	  }, {
	    key: "getPropsFromStores",
	    value: function getPropsFromStores() {
	      return {
	        getMailingById: _MailingStore2.default.getMailingById,
	        errorMessage: _MailingStore2.default.getState().errorMessage,
	        isEditing: _MailingStore2.default.getState().isEditing,
	        getEventBucketById: _EventBucketStore2.default.getEventBucketById
	      };
	    }
	  }, {
	    key: "contextTypes",
	    get: function get() {
	      return {
	        router: _react2.default.PropTypes.object
	      };
	    }
	  }]);
	
	  return Mailing;
	}(_react2.default.Component);
	
	exports.default = (0, _connectToStores2.default)(Mailing);
	module.exports = exports["default"];

/***/ }),
/* 2842 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * marked - a markdown parser
	 * Copyright (c) 2011-2014, Christopher Jeffrey. (MIT Licensed)
	 * https://github.com/markedjs/marked
	 */
	
	;(function(root) {
	'use strict';
	
	/**
	 * Block-Level Grammar
	 */
	
	var block = {
	  newline: /^\n+/,
	  code: /^( {4}[^\n]+\n*)+/,
	  fences: noop,
	  hr: /^ {0,3}((?:- *){3,}|(?:_ *){3,}|(?:\* *){3,})(?:\n+|$)/,
	  heading: /^ *(#{1,6}) *([^\n]+?) *#* *(?:\n+|$)/,
	  nptable: noop,
	  blockquote: /^( {0,3}> ?(paragraph|[^\n]*)(?:\n|$))+/,
	  list: /^( *)(bull) [\s\S]+?(?:hr|def|\n{2,}(?! )(?!\1bull )\n*|\s*$)/,
	  html: /^ *(?:comment *(?:\n|\s*$)|closed *(?:\n{2,}|\s*$)|closing *(?:\n{2,}|\s*$))/,
	  def: /^ {0,3}\[(label)\]: *\n? *<?([^\s>]+)>?(?:(?: +\n? *| *\n *)(title))? *(?:\n+|$)/,
	  table: noop,
	  lheading: /^([^\n]+)\n *(=|-){2,} *(?:\n+|$)/,
	  paragraph: /^([^\n]+(?:\n?(?!hr|heading|lheading| {0,3}>|tag)[^\n]+)+)/,
	  text: /^[^\n]+/
	};
	
	block._label = /(?:\\[\[\]]|[^\[\]])+/;
	block._title = /(?:"(?:\\"|[^"]|"[^"\n]*")*"|'\n?(?:[^'\n]+\n?)*'|\([^()]*\))/;
	block.def = edit(block.def)
	  .replace('label', block._label)
	  .replace('title', block._title)
	  .getRegex();
	
	block.bullet = /(?:[*+-]|\d+\.)/;
	block.item = /^( *)(bull) [^\n]*(?:\n(?!\1bull )[^\n]*)*/;
	block.item = edit(block.item, 'gm')
	  .replace(/bull/g, block.bullet)
	  .getRegex();
	
	block.list = edit(block.list)
	  .replace(/bull/g, block.bullet)
	  .replace('hr', '\\n+(?=\\1?(?:(?:- *){3,}|(?:_ *){3,}|(?:\\* *){3,})(?:\\n+|$))')
	  .replace('def', '\\n+(?=' + block.def.source + ')')
	  .getRegex();
	
	block._tag = '(?!(?:'
	  + 'a|em|strong|small|s|cite|q|dfn|abbr|data|time|code'
	  + '|var|samp|kbd|sub|sup|i|b|u|mark|ruby|rt|rp|bdi|bdo'
	  + '|span|br|wbr|ins|del|img)\\b)\\w+(?!:|[^\\w\\s@]*@)\\b';
	
	block.html = edit(block.html)
	  .replace('comment', /<!--[\s\S]*?-->/)
	  .replace('closed', /<(tag)[\s\S]+?<\/\1>/)
	  .replace('closing', /<tag(?:"[^"]*"|'[^']*'|\s[^'"\/>\s]*)*?\/?>/)
	  .replace(/tag/g, block._tag)
	  .getRegex();
	
	block.paragraph = edit(block.paragraph)
	  .replace('hr', block.hr)
	  .replace('heading', block.heading)
	  .replace('lheading', block.lheading)
	  .replace('tag', '<' + block._tag)
	  .getRegex();
	
	block.blockquote = edit(block.blockquote)
	  .replace('paragraph', block.paragraph)
	  .getRegex();
	
	/**
	 * Normal Block Grammar
	 */
	
	block.normal = merge({}, block);
	
	/**
	 * GFM Block Grammar
	 */
	
	block.gfm = merge({}, block.normal, {
	  fences: /^ *(`{3,}|~{3,})[ \.]*(\S+)? *\n([\s\S]*?)\n? *\1 *(?:\n+|$)/,
	  paragraph: /^/,
	  heading: /^ *(#{1,6}) +([^\n]+?) *#* *(?:\n+|$)/
	});
	
	block.gfm.paragraph = edit(block.paragraph)
	  .replace('(?!', '(?!'
	    + block.gfm.fences.source.replace('\\1', '\\2') + '|'
	    + block.list.source.replace('\\1', '\\3') + '|')
	  .getRegex();
	
	/**
	 * GFM + Tables Block Grammar
	 */
	
	block.tables = merge({}, block.gfm, {
	  nptable: /^ *(\S.*\|.*)\n *([-:]+ *\|[-| :]*)\n((?:.*\|.*(?:\n|$))*)\n*/,
	  table: /^ *\|(.+)\n *\|( *[-:]+[-| :]*)\n((?: *\|.*(?:\n|$))*)\n*/
	});
	
	/**
	 * Block Lexer
	 */
	
	function Lexer(options) {
	  this.tokens = [];
	  this.tokens.links = {};
	  this.options = options || marked.defaults;
	  this.rules = block.normal;
	
	  if (this.options.gfm) {
	    if (this.options.tables) {
	      this.rules = block.tables;
	    } else {
	      this.rules = block.gfm;
	    }
	  }
	}
	
	/**
	 * Expose Block Rules
	 */
	
	Lexer.rules = block;
	
	/**
	 * Static Lex Method
	 */
	
	Lexer.lex = function(src, options) {
	  var lexer = new Lexer(options);
	  return lexer.lex(src);
	};
	
	/**
	 * Preprocessing
	 */
	
	Lexer.prototype.lex = function(src) {
	  src = src
	    .replace(/\r\n|\r/g, '\n')
	    .replace(/\t/g, '    ')
	    .replace(/\u00a0/g, ' ')
	    .replace(/\u2424/g, '\n');
	
	  return this.token(src, true);
	};
	
	/**
	 * Lexing
	 */
	
	Lexer.prototype.token = function(src, top) {
	  src = src.replace(/^ +$/gm, '');
	  var next,
	      loose,
	      cap,
	      bull,
	      b,
	      item,
	      space,
	      i,
	      tag,
	      l,
	      isordered;
	
	  while (src) {
	    // newline
	    if (cap = this.rules.newline.exec(src)) {
	      src = src.substring(cap[0].length);
	      if (cap[0].length > 1) {
	        this.tokens.push({
	          type: 'space'
	        });
	      }
	    }
	
	    // code
	    if (cap = this.rules.code.exec(src)) {
	      src = src.substring(cap[0].length);
	      cap = cap[0].replace(/^ {4}/gm, '');
	      this.tokens.push({
	        type: 'code',
	        text: !this.options.pedantic
	          ? cap.replace(/\n+$/, '')
	          : cap
	      });
	      continue;
	    }
	
	    // fences (gfm)
	    if (cap = this.rules.fences.exec(src)) {
	      src = src.substring(cap[0].length);
	      this.tokens.push({
	        type: 'code',
	        lang: cap[2],
	        text: cap[3] || ''
	      });
	      continue;
	    }
	
	    // heading
	    if (cap = this.rules.heading.exec(src)) {
	      src = src.substring(cap[0].length);
	      this.tokens.push({
	        type: 'heading',
	        depth: cap[1].length,
	        text: cap[2]
	      });
	      continue;
	    }
	
	    // table no leading pipe (gfm)
	    if (top && (cap = this.rules.nptable.exec(src))) {
	      src = src.substring(cap[0].length);
	
	      item = {
	        type: 'table',
	        header: cap[1].replace(/^ *| *\| *$/g, '').split(/ *\| */),
	        align: cap[2].replace(/^ *|\| *$/g, '').split(/ *\| */),
	        cells: cap[3].replace(/\n$/, '').split('\n')
	      };
	
	      for (i = 0; i < item.align.length; i++) {
	        if (/^ *-+: *$/.test(item.align[i])) {
	          item.align[i] = 'right';
	        } else if (/^ *:-+: *$/.test(item.align[i])) {
	          item.align[i] = 'center';
	        } else if (/^ *:-+ *$/.test(item.align[i])) {
	          item.align[i] = 'left';
	        } else {
	          item.align[i] = null;
	        }
	      }
	
	      for (i = 0; i < item.cells.length; i++) {
	        item.cells[i] = item.cells[i].split(/ *\| */);
	      }
	
	      this.tokens.push(item);
	
	      continue;
	    }
	
	    // hr
	    if (cap = this.rules.hr.exec(src)) {
	      src = src.substring(cap[0].length);
	      this.tokens.push({
	        type: 'hr'
	      });
	      continue;
	    }
	
	    // blockquote
	    if (cap = this.rules.blockquote.exec(src)) {
	      src = src.substring(cap[0].length);
	
	      this.tokens.push({
	        type: 'blockquote_start'
	      });
	
	      cap = cap[0].replace(/^ *> ?/gm, '');
	
	      // Pass `top` to keep the current
	      // "toplevel" state. This is exactly
	      // how markdown.pl works.
	      this.token(cap, top);
	
	      this.tokens.push({
	        type: 'blockquote_end'
	      });
	
	      continue;
	    }
	
	    // list
	    if (cap = this.rules.list.exec(src)) {
	      src = src.substring(cap[0].length);
	      bull = cap[2];
	      isordered = bull.length > 1;
	
	      this.tokens.push({
	        type: 'list_start',
	        ordered: isordered,
	        start: isordered ? +bull : ''
	      });
	
	      // Get each top-level item.
	      cap = cap[0].match(this.rules.item);
	
	      next = false;
	      l = cap.length;
	      i = 0;
	
	      for (; i < l; i++) {
	        item = cap[i];
	
	        // Remove the list item's bullet
	        // so it is seen as the next token.
	        space = item.length;
	        item = item.replace(/^ *([*+-]|\d+\.) +/, '');
	
	        // Outdent whatever the
	        // list item contains. Hacky.
	        if (~item.indexOf('\n ')) {
	          space -= item.length;
	          item = !this.options.pedantic
	            ? item.replace(new RegExp('^ {1,' + space + '}', 'gm'), '')
	            : item.replace(/^ {1,4}/gm, '');
	        }
	
	        // Determine whether the next list item belongs here.
	        // Backpedal if it does not belong in this list.
	        if (this.options.smartLists && i !== l - 1) {
	          b = block.bullet.exec(cap[i + 1])[0];
	          if (bull !== b && !(bull.length > 1 && b.length > 1)) {
	            src = cap.slice(i + 1).join('\n') + src;
	            i = l - 1;
	          }
	        }
	
	        // Determine whether item is loose or not.
	        // Use: /(^|\n)(?! )[^\n]+\n\n(?!\s*$)/
	        // for discount behavior.
	        loose = next || /\n\n(?!\s*$)/.test(item);
	        if (i !== l - 1) {
	          next = item.charAt(item.length - 1) === '\n';
	          if (!loose) loose = next;
	        }
	
	        this.tokens.push({
	          type: loose
	            ? 'loose_item_start'
	            : 'list_item_start'
	        });
	
	        // Recurse.
	        this.token(item, false);
	
	        this.tokens.push({
	          type: 'list_item_end'
	        });
	      }
	
	      this.tokens.push({
	        type: 'list_end'
	      });
	
	      continue;
	    }
	
	    // html
	    if (cap = this.rules.html.exec(src)) {
	      src = src.substring(cap[0].length);
	      this.tokens.push({
	        type: this.options.sanitize
	          ? 'paragraph'
	          : 'html',
	        pre: !this.options.sanitizer
	          && (cap[1] === 'pre' || cap[1] === 'script' || cap[1] === 'style'),
	        text: cap[0]
	      });
	      continue;
	    }
	
	    // def
	    if (top && (cap = this.rules.def.exec(src))) {
	      src = src.substring(cap[0].length);
	      if (cap[3]) cap[3] = cap[3].substring(1, cap[3].length - 1);
	      tag = cap[1].toLowerCase();
	      if (!this.tokens.links[tag]) {
	        this.tokens.links[tag] = {
	          href: cap[2],
	          title: cap[3]
	        };
	      }
	      continue;
	    }
	
	    // table (gfm)
	    if (top && (cap = this.rules.table.exec(src))) {
	      src = src.substring(cap[0].length);
	
	      item = {
	        type: 'table',
	        header: cap[1].replace(/^ *| *\| *$/g, '').split(/ *\| */),
	        align: cap[2].replace(/^ *|\| *$/g, '').split(/ *\| */),
	        cells: cap[3].replace(/(?: *\| *)?\n$/, '').split('\n')
	      };
	
	      for (i = 0; i < item.align.length; i++) {
	        if (/^ *-+: *$/.test(item.align[i])) {
	          item.align[i] = 'right';
	        } else if (/^ *:-+: *$/.test(item.align[i])) {
	          item.align[i] = 'center';
	        } else if (/^ *:-+ *$/.test(item.align[i])) {
	          item.align[i] = 'left';
	        } else {
	          item.align[i] = null;
	        }
	      }
	
	      for (i = 0; i < item.cells.length; i++) {
	        item.cells[i] = item.cells[i]
	          .replace(/^ *\| *| *\| *$/g, '')
	          .split(/ *\| */);
	      }
	
	      this.tokens.push(item);
	
	      continue;
	    }
	
	    // lheading
	    if (cap = this.rules.lheading.exec(src)) {
	      src = src.substring(cap[0].length);
	      this.tokens.push({
	        type: 'heading',
	        depth: cap[2] === '=' ? 1 : 2,
	        text: cap[1]
	      });
	      continue;
	    }
	
	    // top-level paragraph
	    if (top && (cap = this.rules.paragraph.exec(src))) {
	      src = src.substring(cap[0].length);
	      this.tokens.push({
	        type: 'paragraph',
	        text: cap[1].charAt(cap[1].length - 1) === '\n'
	          ? cap[1].slice(0, -1)
	          : cap[1]
	      });
	      continue;
	    }
	
	    // text
	    if (cap = this.rules.text.exec(src)) {
	      // Top-level should never reach here.
	      src = src.substring(cap[0].length);
	      this.tokens.push({
	        type: 'text',
	        text: cap[0]
	      });
	      continue;
	    }
	
	    if (src) {
	      throw new Error('Infinite loop on byte: ' + src.charCodeAt(0));
	    }
	  }
	
	  return this.tokens;
	};
	
	/**
	 * Inline-Level Grammar
	 */
	
	var inline = {
	  escape: /^\\([\\`*{}\[\]()#+\-.!_>])/,
	  autolink: /^<(scheme:[^\s\x00-\x1f<>]*|email)>/,
	  url: noop,
	  tag: /^<!--[\s\S]*?-->|^<\/?[a-zA-Z0-9\-]+(?:"[^"]*"|'[^']*'|\s[^<'">\/\s]*)*?\/?>/,
	  link: /^!?\[(inside)\]\(href\)/,
	  reflink: /^!?\[(inside)\]\s*\[([^\]]*)\]/,
	  nolink: /^!?\[((?:\[[^\[\]]*\]|\\[\[\]]|[^\[\]])*)\]/,
	  strong: /^__([\s\S]+?)__(?!_)|^\*\*([\s\S]+?)\*\*(?!\*)/,
	  em: /^_([^\s_](?:[^_]|__)+?[^\s_])_\b|^\*((?:\*\*|[^*])+?)\*(?!\*)/,
	  code: /^(`+)\s*([\s\S]*?[^`]?)\s*\1(?!`)/,
	  br: /^ {2,}\n(?!\s*$)/,
	  del: noop,
	  text: /^[\s\S]+?(?=[\\<!\[`*]|\b_| {2,}\n|$)/
	};
	
	inline._scheme = /[a-zA-Z][a-zA-Z0-9+.-]{1,31}/;
	inline._email = /[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+(@)[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+(?![-_])/;
	
	inline.autolink = edit(inline.autolink)
	  .replace('scheme', inline._scheme)
	  .replace('email', inline._email)
	  .getRegex()
	
	inline._inside = /(?:\[[^\[\]]*\]|\\[\[\]]|[^\[\]]|\](?=[^\[]*\]))*/;
	inline._href = /\s*<?([\s\S]*?)>?(?:\s+['"]([\s\S]*?)['"])?\s*/;
	
	inline.link = edit(inline.link)
	  .replace('inside', inline._inside)
	  .replace('href', inline._href)
	  .getRegex();
	
	inline.reflink = edit(inline.reflink)
	  .replace('inside', inline._inside)
	  .getRegex();
	
	/**
	 * Normal Inline Grammar
	 */
	
	inline.normal = merge({}, inline);
	
	/**
	 * Pedantic Inline Grammar
	 */
	
	inline.pedantic = merge({}, inline.normal, {
	  strong: /^__(?=\S)([\s\S]*?\S)__(?!_)|^\*\*(?=\S)([\s\S]*?\S)\*\*(?!\*)/,
	  em: /^_(?=\S)([\s\S]*?\S)_(?!_)|^\*(?=\S)([\s\S]*?\S)\*(?!\*)/
	});
	
	/**
	 * GFM Inline Grammar
	 */
	
	inline.gfm = merge({}, inline.normal, {
	  escape: edit(inline.escape).replace('])', '~|])').getRegex(),
	  url: edit(/^((?:ftp|https?):\/\/|www\.)(?:[a-zA-Z0-9\-]+\.?)+[^\s<]*|^email/)
	    .replace('email', inline._email)
	    .getRegex(),
	  _backpedal: /(?:[^?!.,:;*_~()&]+|\([^)]*\)|&(?![a-zA-Z0-9]+;$)|[?!.,:;*_~)]+(?!$))+/,
	  del: /^~~(?=\S)([\s\S]*?\S)~~/,
	  text: edit(inline.text)
	    .replace(']|', '~]|')
	    .replace('|', '|https?://|ftp://|www\\.|[a-zA-Z0-9.!#$%&\'*+/=?^_`{\\|}~-]+@|')
	    .getRegex()
	});
	
	/**
	 * GFM + Line Breaks Inline Grammar
	 */
	
	inline.breaks = merge({}, inline.gfm, {
	  br: edit(inline.br).replace('{2,}', '*').getRegex(),
	  text: edit(inline.gfm.text).replace('{2,}', '*').getRegex()
	});
	
	/**
	 * Inline Lexer & Compiler
	 */
	
	function InlineLexer(links, options) {
	  this.options = options || marked.defaults;
	  this.links = links;
	  this.rules = inline.normal;
	  this.renderer = this.options.renderer || new Renderer();
	  this.renderer.options = this.options;
	
	  if (!this.links) {
	    throw new Error('Tokens array requires a `links` property.');
	  }
	
	  if (this.options.gfm) {
	    if (this.options.breaks) {
	      this.rules = inline.breaks;
	    } else {
	      this.rules = inline.gfm;
	    }
	  } else if (this.options.pedantic) {
	    this.rules = inline.pedantic;
	  }
	}
	
	/**
	 * Expose Inline Rules
	 */
	
	InlineLexer.rules = inline;
	
	/**
	 * Static Lexing/Compiling Method
	 */
	
	InlineLexer.output = function(src, links, options) {
	  var inline = new InlineLexer(links, options);
	  return inline.output(src);
	};
	
	/**
	 * Lexing/Compiling
	 */
	
	InlineLexer.prototype.output = function(src) {
	  var out = '',
	      link,
	      text,
	      href,
	      cap;
	
	  while (src) {
	    // escape
	    if (cap = this.rules.escape.exec(src)) {
	      src = src.substring(cap[0].length);
	      out += cap[1];
	      continue;
	    }
	
	    // autolink
	    if (cap = this.rules.autolink.exec(src)) {
	      src = src.substring(cap[0].length);
	      if (cap[2] === '@') {
	        text = escape(this.mangle(cap[1]));
	        href = 'mailto:' + text;
	      } else {
	        text = escape(cap[1]);
	        href = text;
	      }
	      out += this.renderer.link(href, null, text);
	      continue;
	    }
	
	    // url (gfm)
	    if (!this.inLink && (cap = this.rules.url.exec(src))) {
	      cap[0] = this.rules._backpedal.exec(cap[0])[0];
	      src = src.substring(cap[0].length);
	      if (cap[2] === '@') {
	        text = escape(cap[0]);
	        href = 'mailto:' + text;
	      } else {
	        text = escape(cap[0]);
	        if (cap[1] === 'www.') {
	          href = 'http://' + text;
	        } else {
	          href = text;
	        }
	      }
	      out += this.renderer.link(href, null, text);
	      continue;
	    }
	
	    // tag
	    if (cap = this.rules.tag.exec(src)) {
	      if (!this.inLink && /^<a /i.test(cap[0])) {
	        this.inLink = true;
	      } else if (this.inLink && /^<\/a>/i.test(cap[0])) {
	        this.inLink = false;
	      }
	      src = src.substring(cap[0].length);
	      out += this.options.sanitize
	        ? this.options.sanitizer
	          ? this.options.sanitizer(cap[0])
	          : escape(cap[0])
	        : cap[0]
	      continue;
	    }
	
	    // link
	    if (cap = this.rules.link.exec(src)) {
	      src = src.substring(cap[0].length);
	      this.inLink = true;
	      out += this.outputLink(cap, {
	        href: cap[2],
	        title: cap[3]
	      });
	      this.inLink = false;
	      continue;
	    }
	
	    // reflink, nolink
	    if ((cap = this.rules.reflink.exec(src))
	        || (cap = this.rules.nolink.exec(src))) {
	      src = src.substring(cap[0].length);
	      link = (cap[2] || cap[1]).replace(/\s+/g, ' ');
	      link = this.links[link.toLowerCase()];
	      if (!link || !link.href) {
	        out += cap[0].charAt(0);
	        src = cap[0].substring(1) + src;
	        continue;
	      }
	      this.inLink = true;
	      out += this.outputLink(cap, link);
	      this.inLink = false;
	      continue;
	    }
	
	    // strong
	    if (cap = this.rules.strong.exec(src)) {
	      src = src.substring(cap[0].length);
	      out += this.renderer.strong(this.output(cap[2] || cap[1]));
	      continue;
	    }
	
	    // em
	    if (cap = this.rules.em.exec(src)) {
	      src = src.substring(cap[0].length);
	      out += this.renderer.em(this.output(cap[2] || cap[1]));
	      continue;
	    }
	
	    // code
	    if (cap = this.rules.code.exec(src)) {
	      src = src.substring(cap[0].length);
	      out += this.renderer.codespan(escape(cap[2].trim(), true));
	      continue;
	    }
	
	    // br
	    if (cap = this.rules.br.exec(src)) {
	      src = src.substring(cap[0].length);
	      out += this.renderer.br();
	      continue;
	    }
	
	    // del (gfm)
	    if (cap = this.rules.del.exec(src)) {
	      src = src.substring(cap[0].length);
	      out += this.renderer.del(this.output(cap[1]));
	      continue;
	    }
	
	    // text
	    if (cap = this.rules.text.exec(src)) {
	      src = src.substring(cap[0].length);
	      out += this.renderer.text(escape(this.smartypants(cap[0])));
	      continue;
	    }
	
	    if (src) {
	      throw new Error('Infinite loop on byte: ' + src.charCodeAt(0));
	    }
	  }
	
	  return out;
	};
	
	/**
	 * Compile Link
	 */
	
	InlineLexer.prototype.outputLink = function(cap, link) {
	  var href = escape(link.href),
	      title = link.title ? escape(link.title) : null;
	
	  return cap[0].charAt(0) !== '!'
	    ? this.renderer.link(href, title, this.output(cap[1]))
	    : this.renderer.image(href, title, escape(cap[1]));
	};
	
	/**
	 * Smartypants Transformations
	 */
	
	InlineLexer.prototype.smartypants = function(text) {
	  if (!this.options.smartypants) return text;
	  return text
	    // em-dashes
	    .replace(/---/g, '\u2014')
	    // en-dashes
	    .replace(/--/g, '\u2013')
	    // opening singles
	    .replace(/(^|[-\u2014/(\[{"\s])'/g, '$1\u2018')
	    // closing singles & apostrophes
	    .replace(/'/g, '\u2019')
	    // opening doubles
	    .replace(/(^|[-\u2014/(\[{\u2018\s])"/g, '$1\u201c')
	    // closing doubles
	    .replace(/"/g, '\u201d')
	    // ellipses
	    .replace(/\.{3}/g, '\u2026');
	};
	
	/**
	 * Mangle Links
	 */
	
	InlineLexer.prototype.mangle = function(text) {
	  if (!this.options.mangle) return text;
	  var out = '',
	      l = text.length,
	      i = 0,
	      ch;
	
	  for (; i < l; i++) {
	    ch = text.charCodeAt(i);
	    if (Math.random() > 0.5) {
	      ch = 'x' + ch.toString(16);
	    }
	    out += '&#' + ch + ';';
	  }
	
	  return out;
	};
	
	/**
	 * Renderer
	 */
	
	function Renderer(options) {
	  this.options = options || {};
	}
	
	Renderer.prototype.code = function(code, lang, escaped) {
	  if (this.options.highlight) {
	    var out = this.options.highlight(code, lang);
	    if (out != null && out !== code) {
	      escaped = true;
	      code = out;
	    }
	  }
	
	  if (!lang) {
	    return '<pre><code>'
	      + (escaped ? code : escape(code, true))
	      + '\n</code></pre>';
	  }
	
	  return '<pre><code class="'
	    + this.options.langPrefix
	    + escape(lang, true)
	    + '">'
	    + (escaped ? code : escape(code, true))
	    + '\n</code></pre>\n';
	};
	
	Renderer.prototype.blockquote = function(quote) {
	  return '<blockquote>\n' + quote + '</blockquote>\n';
	};
	
	Renderer.prototype.html = function(html) {
	  return html;
	};
	
	Renderer.prototype.heading = function(text, level, raw) {
	  return '<h'
	    + level
	    + ' id="'
	    + this.options.headerPrefix
	    + raw.toLowerCase().replace(/[^\w]+/g, '-')
	    + '">'
	    + text
	    + '</h'
	    + level
	    + '>\n';
	};
	
	Renderer.prototype.hr = function() {
	  return this.options.xhtml ? '<hr/>\n' : '<hr>\n';
	};
	
	Renderer.prototype.list = function(body, ordered, start) {
	  var type = ordered ? 'ol' : 'ul',
	      startatt = (ordered && start !== 1) ? (' start="' + start + '"') : '';
	  return '<' + type + startatt + '>\n' + body + '</' + type + '>\n';
	};
	
	Renderer.prototype.listitem = function(text) {
	  return '<li>' + text + '</li>\n';
	};
	
	Renderer.prototype.paragraph = function(text) {
	  return '<p>' + text + '</p>\n';
	};
	
	Renderer.prototype.table = function(header, body) {
	  return '<table>\n'
	    + '<thead>\n'
	    + header
	    + '</thead>\n'
	    + '<tbody>\n'
	    + body
	    + '</tbody>\n'
	    + '</table>\n';
	};
	
	Renderer.prototype.tablerow = function(content) {
	  return '<tr>\n' + content + '</tr>\n';
	};
	
	Renderer.prototype.tablecell = function(content, flags) {
	  var type = flags.header ? 'th' : 'td';
	  var tag = flags.align
	    ? '<' + type + ' style="text-align:' + flags.align + '">'
	    : '<' + type + '>';
	  return tag + content + '</' + type + '>\n';
	};
	
	// span level renderer
	Renderer.prototype.strong = function(text) {
	  return '<strong>' + text + '</strong>';
	};
	
	Renderer.prototype.em = function(text) {
	  return '<em>' + text + '</em>';
	};
	
	Renderer.prototype.codespan = function(text) {
	  return '<code>' + text + '</code>';
	};
	
	Renderer.prototype.br = function() {
	  return this.options.xhtml ? '<br/>' : '<br>';
	};
	
	Renderer.prototype.del = function(text) {
	  return '<del>' + text + '</del>';
	};
	
	Renderer.prototype.link = function(href, title, text) {
	  if (this.options.sanitize) {
	    try {
	      var prot = decodeURIComponent(unescape(href))
	        .replace(/[^\w:]/g, '')
	        .toLowerCase();
	    } catch (e) {
	      return text;
	    }
	    if (prot.indexOf('javascript:') === 0 || prot.indexOf('vbscript:') === 0 || prot.indexOf('data:') === 0) {
	      return text;
	    }
	  }
	  if (this.options.baseUrl && !originIndependentUrl.test(href)) {
	    href = resolveUrl(this.options.baseUrl, href);
	  }
	  var out = '<a href="' + href + '"';
	  if (title) {
	    out += ' title="' + title + '"';
	  }
	  out += '>' + text + '</a>';
	  return out;
	};
	
	Renderer.prototype.image = function(href, title, text) {
	  if (this.options.baseUrl && !originIndependentUrl.test(href)) {
	    href = resolveUrl(this.options.baseUrl, href);
	  }
	  var out = '<img src="' + href + '" alt="' + text + '"';
	  if (title) {
	    out += ' title="' + title + '"';
	  }
	  out += this.options.xhtml ? '/>' : '>';
	  return out;
	};
	
	Renderer.prototype.text = function(text) {
	  return text;
	};
	
	/**
	 * TextRenderer
	 * returns only the textual part of the token
	 */
	
	function TextRenderer() {}
	
	// no need for block level renderers
	
	TextRenderer.prototype.strong =
	TextRenderer.prototype.em =
	TextRenderer.prototype.codespan =
	TextRenderer.prototype.del =
	TextRenderer.prototype.text = function (text) {
	  return text;
	}
	
	TextRenderer.prototype.link =
	TextRenderer.prototype.image = function(href, title, text) {
	  return '' + text;
	}
	
	TextRenderer.prototype.br = function() {
	  return '';
	}
	
	/**
	 * Parsing & Compiling
	 */
	
	function Parser(options) {
	  this.tokens = [];
	  this.token = null;
	  this.options = options || marked.defaults;
	  this.options.renderer = this.options.renderer || new Renderer();
	  this.renderer = this.options.renderer;
	  this.renderer.options = this.options;
	}
	
	/**
	 * Static Parse Method
	 */
	
	Parser.parse = function(src, options) {
	  var parser = new Parser(options);
	  return parser.parse(src);
	};
	
	/**
	 * Parse Loop
	 */
	
	Parser.prototype.parse = function(src) {
	  this.inline = new InlineLexer(src.links, this.options);
	  // use an InlineLexer with a TextRenderer to extract pure text
	  this.inlineText = new InlineLexer(
	    src.links,
	    merge({}, this.options, {renderer: new TextRenderer()})
	  );
	  this.tokens = src.reverse();
	
	  var out = '';
	  while (this.next()) {
	    out += this.tok();
	  }
	
	  return out;
	};
	
	/**
	 * Next Token
	 */
	
	Parser.prototype.next = function() {
	  return this.token = this.tokens.pop();
	};
	
	/**
	 * Preview Next Token
	 */
	
	Parser.prototype.peek = function() {
	  return this.tokens[this.tokens.length - 1] || 0;
	};
	
	/**
	 * Parse Text Tokens
	 */
	
	Parser.prototype.parseText = function() {
	  var body = this.token.text;
	
	  while (this.peek().type === 'text') {
	    body += '\n' + this.next().text;
	  }
	
	  return this.inline.output(body);
	};
	
	/**
	 * Parse Current Token
	 */
	
	Parser.prototype.tok = function() {
	  switch (this.token.type) {
	    case 'space': {
	      return '';
	    }
	    case 'hr': {
	      return this.renderer.hr();
	    }
	    case 'heading': {
	      return this.renderer.heading(
	        this.inline.output(this.token.text),
	        this.token.depth,
	        unescape(this.inlineText.output(this.token.text)));
	    }
	    case 'code': {
	      return this.renderer.code(this.token.text,
	        this.token.lang,
	        this.token.escaped);
	    }
	    case 'table': {
	      var header = '',
	          body = '',
	          i,
	          row,
	          cell,
	          j;
	
	      // header
	      cell = '';
	      for (i = 0; i < this.token.header.length; i++) {
	        cell += this.renderer.tablecell(
	          this.inline.output(this.token.header[i]),
	          { header: true, align: this.token.align[i] }
	        );
	      }
	      header += this.renderer.tablerow(cell);
	
	      for (i = 0; i < this.token.cells.length; i++) {
	        row = this.token.cells[i];
	
	        cell = '';
	        for (j = 0; j < row.length; j++) {
	          cell += this.renderer.tablecell(
	            this.inline.output(row[j]),
	            { header: false, align: this.token.align[j] }
	          );
	        }
	
	        body += this.renderer.tablerow(cell);
	      }
	      return this.renderer.table(header, body);
	    }
	    case 'blockquote_start': {
	      body = '';
	
	      while (this.next().type !== 'blockquote_end') {
	        body += this.tok();
	      }
	
	      return this.renderer.blockquote(body);
	    }
	    case 'list_start': {
	      body = '';
	      var ordered = this.token.ordered,
	          start = this.token.start;
	
	      while (this.next().type !== 'list_end') {
	        body += this.tok();
	      }
	
	      return this.renderer.list(body, ordered, start);
	    }
	    case 'list_item_start': {
	      body = '';
	
	      while (this.next().type !== 'list_item_end') {
	        body += this.token.type === 'text'
	          ? this.parseText()
	          : this.tok();
	      }
	
	      return this.renderer.listitem(body);
	    }
	    case 'loose_item_start': {
	      body = '';
	
	      while (this.next().type !== 'list_item_end') {
	        body += this.tok();
	      }
	
	      return this.renderer.listitem(body);
	    }
	    case 'html': {
	      var html = !this.token.pre && !this.options.pedantic
	        ? this.inline.output(this.token.text)
	        : this.token.text;
	      return this.renderer.html(html);
	    }
	    case 'paragraph': {
	      return this.renderer.paragraph(this.inline.output(this.token.text));
	    }
	    case 'text': {
	      return this.renderer.paragraph(this.parseText());
	    }
	  }
	};
	
	/**
	 * Helpers
	 */
	
	function escape(html, encode) {
	  return html
	    .replace(!encode ? /&(?!#?\w+;)/g : /&/g, '&amp;')
	    .replace(/</g, '&lt;')
	    .replace(/>/g, '&gt;')
	    .replace(/"/g, '&quot;')
	    .replace(/'/g, '&#39;');
	}
	
	function unescape(html) {
	  // explicitly match decimal, hex, and named HTML entities
	  return html.replace(/&(#(?:\d+)|(?:#x[0-9A-Fa-f]+)|(?:\w+));?/ig, function(_, n) {
	    n = n.toLowerCase();
	    if (n === 'colon') return ':';
	    if (n.charAt(0) === '#') {
	      return n.charAt(1) === 'x'
	        ? String.fromCharCode(parseInt(n.substring(2), 16))
	        : String.fromCharCode(+n.substring(1));
	    }
	    return '';
	  });
	}
	
	function edit(regex, opt) {
	  regex = regex.source;
	  opt = opt || '';
	  return {
	    replace: function(name, val) {
	      val = val.source || val;
	      val = val.replace(/(^|[^\[])\^/g, '$1');
	      regex = regex.replace(name, val);
	      return this;
	    },
	    getRegex: function() {
	      return new RegExp(regex, opt);
	    }
	  };
	}
	
	function resolveUrl(base, href) {
	  if (!baseUrls[' ' + base]) {
	    // we can ignore everything in base after the last slash of its path component,
	    // but we might need to add _that_
	    // https://tools.ietf.org/html/rfc3986#section-3
	    if (/^[^:]+:\/*[^/]*$/.test(base)) {
	      baseUrls[' ' + base] = base + '/';
	    } else {
	      baseUrls[' ' + base] = base.replace(/[^/]*$/, '');
	    }
	  }
	  base = baseUrls[' ' + base];
	
	  if (href.slice(0, 2) === '//') {
	    return base.replace(/:[\s\S]*/, ':') + href;
	  } else if (href.charAt(0) === '/') {
	    return base.replace(/(:\/*[^/]*)[\s\S]*/, '$1') + href;
	  } else {
	    return base + href;
	  }
	}
	var baseUrls = {};
	var originIndependentUrl = /^$|^[a-z][a-z0-9+.-]*:|^[?#]/i;
	
	function noop() {}
	noop.exec = noop;
	
	function merge(obj) {
	  var i = 1,
	      target,
	      key;
	
	  for (; i < arguments.length; i++) {
	    target = arguments[i];
	    for (key in target) {
	      if (Object.prototype.hasOwnProperty.call(target, key)) {
	        obj[key] = target[key];
	      }
	    }
	  }
	
	  return obj;
	}
	
	/**
	 * Marked
	 */
	
	function marked(src, opt, callback) {
	  // throw error in case of non string input
	  if (typeof src === 'undefined' || src === null) {
	    throw new Error('marked(): input parameter is undefined or null');
	  }
	  if (typeof src !== 'string') {
	    throw new Error('marked(): input parameter is of type '
	      + Object.prototype.toString.call(src) + ', string expected');
	  }
	
	  if (callback || typeof opt === 'function') {
	    if (!callback) {
	      callback = opt;
	      opt = null;
	    }
	
	    opt = merge({}, marked.defaults, opt || {});
	
	    var highlight = opt.highlight,
	        tokens,
	        pending,
	        i = 0;
	
	    try {
	      tokens = Lexer.lex(src, opt)
	    } catch (e) {
	      return callback(e);
	    }
	
	    pending = tokens.length;
	
	    var done = function(err) {
	      if (err) {
	        opt.highlight = highlight;
	        return callback(err);
	      }
	
	      var out;
	
	      try {
	        out = Parser.parse(tokens, opt);
	      } catch (e) {
	        err = e;
	      }
	
	      opt.highlight = highlight;
	
	      return err
	        ? callback(err)
	        : callback(null, out);
	    };
	
	    if (!highlight || highlight.length < 3) {
	      return done();
	    }
	
	    delete opt.highlight;
	
	    if (!pending) return done();
	
	    for (; i < tokens.length; i++) {
	      (function(token) {
	        if (token.type !== 'code') {
	          return --pending || done();
	        }
	        return highlight(token.text, token.lang, function(err, code) {
	          if (err) return done(err);
	          if (code == null || code === token.text) {
	            return --pending || done();
	          }
	          token.text = code;
	          token.escaped = true;
	          --pending || done();
	        });
	      })(tokens[i]);
	    }
	
	    return;
	  }
	  try {
	    if (opt) opt = merge({}, marked.defaults, opt);
	    return Parser.parse(Lexer.lex(src, opt), opt);
	  } catch (e) {
	    e.message += '\nPlease report this to https://github.com/markedjs/marked.';
	    if ((opt || marked.defaults).silent) {
	      return '<p>An error occurred:</p><pre>'
	        + escape(e.message + '', true)
	        + '</pre>';
	    }
	    throw e;
	  }
	}
	
	/**
	 * Options
	 */
	
	marked.options =
	marked.setOptions = function(opt) {
	  merge(marked.defaults, opt);
	  return marked;
	};
	
	marked.defaults = {
	  gfm: true,
	  tables: true,
	  breaks: false,
	  pedantic: false,
	  sanitize: false,
	  sanitizer: null,
	  mangle: true,
	  smartLists: false,
	  silent: false,
	  highlight: null,
	  langPrefix: 'lang-',
	  smartypants: false,
	  headerPrefix: '',
	  renderer: new Renderer(),
	  xhtml: false,
	  baseUrl: null
	};
	
	/**
	 * Expose
	 */
	
	marked.Parser = Parser;
	marked.parser = Parser.parse;
	
	marked.Renderer = Renderer;
	marked.TextRenderer = TextRenderer;
	
	marked.Lexer = Lexer;
	marked.lexer = Lexer.lex;
	
	marked.InlineLexer = InlineLexer;
	marked.inlineLexer = InlineLexer.output;
	
	marked.parse = marked;
	
	if (true) {
	  module.exports = marked;
	} else if (typeof define === 'function' && define.amd) {
	  define(function() { return marked; });
	} else {
	  root.marked = marked;
	}
	})(this || (typeof window !== 'undefined' ? window : global));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 2843 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reactSelect = __webpack_require__(953);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	var _moment = __webpack_require__(1021);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _materialUi = __webpack_require__(576);
	
	var _label = __webpack_require__(1682);
	
	var _label2 = _interopRequireDefault(_label);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = {
	  selectContainer: {
	    margin: -5
	  },
	  selectBlock: {
	    display: "inline-block",
	    verticalAlign: "top",
	    width: "calc(25% - 10px)",
	    minWidth: 175,
	    padding: 5
	  }
	};
	
	function _makeRecipientDescription(query, eventBucketId, _ref) {
	  var PassBucketStore = _ref.PassBucketStore;
	  var EventStore = _ref.EventStore;
	  var CouponStore = _ref.CouponStore;
	  var EventBucketStore = _ref.EventBucketStore;
	  var TagStore = _ref.TagStore;
	
	  var currentPassBuckets = (query.pass_bucket || []).map(function (b) {
	    return PassBucketStore.getPassBucketById(b);
	  }).filter(function (o) {
	    return !!o;
	  }),
	      currentEvents = (query.event || []).map(function (e) {
	    return EventStore.getEventById(e);
	  }).filter(function (o) {
	    return !!o;
	  }),
	      currentCoupons = (query.coupon || []).map(function (c) {
	    return CouponStore.getCouponById(c);
	  }).filter(function (o) {
	    return !!o;
	  }),
	      currentTags = (query.tag || []).map(function (e) {
	    return TagStore.getTagById(e);
	  }).filter(function (o) {
	    return !!o;
	  });
	
	  var description = "";
	
	  if (query.all_attendees) {
	    return "All " + (EventBucketStore.getEventBucketById(eventBucketId) || { name: "" }).name + " attendees";
	  } else if (query.all_standalone_tickets_only) {
	    return "All " + (EventBucketStore.getEventBucketById(eventBucketId) || { name: "" }).name + " standalone ticketholders (excluding passholders)";
	  }
	
	  function _groupMembers(group) {
	    var joiner = arguments.length <= 1 || arguments[1] === undefined ? "and" : arguments[1];
	
	    var labels = group.map(function (o) {
	      return "\"" + o.name + "\"";
	    });
	
	    if (labels.length === 1) {
	      return labels[0];
	    }
	
	    var result = labels.slice(0, -1).join(", ");
	    result += (labels.length > 2 ? "," : "") + " " + joiner + " " + labels[labels.length - 1];
	
	    return result;
	  }
	
	  if (currentPassBuckets.length) {
	    description += _groupMembers(currentPassBuckets) + " passholders";
	  } else if (currentEvents.length || currentTags.length) {
	    description += "Attendees to";
	  } else if (currentCoupons.length) {
	    description += "Customers";
	  }
	
	  if (currentPassBuckets.length && (currentEvents.length || currentTags.length)) {
	    description += " who attended";
	  }
	
	  if (currentEvents.length) {
	    description += " " + _groupMembers(currentEvents, "or");
	  }
	
	  if (currentTags.length) {
	    if (currentEvents.length) {
	      description += " or";
	    }
	    description += " events tagged";
	    description += " " + _groupMembers(currentTags, "or");
	  }
	
	  if (currentCoupons.length) {
	    if (!currentEvents.length || !currentPassBuckets.length) {
	      description += " who";
	    } else {
	      description += " and";
	    }
	
	    description += " used the " + _groupMembers(currentCoupons, "or") + " discount";
	  }
	
	  return description;
	}
	
	var ListTargetBuilder = function ListTargetBuilder(_ref2) {
	  var label = _ref2.label;
	  var query = _ref2.query;
	  var eventBucketId = _ref2.eventBucketId;
	  var allLabel = _ref2.allLabel;
	  var standaloneLabel = _ref2.standaloneLabel;
	  var stores = _ref2.stores;
	  var _onChange = _ref2.onChange;
	
	  var buckets = stores.PassBucketStore.getPassBucketsForEventBucket(eventBucketId),
	      events = stores.EventStore.getEventsForEventBucket(eventBucketId),
	      coupons = stores.CouponStore.getCouponsForEventBucket(eventBucketId),
	      tags = stores.TagStore.getTagsForEventBucket(eventBucketId);
	
	  var passBucketMenuItems = buckets.sort(function (a, b) {
	    return a.name.localeCompare(b.name);
	  }).map(function (b, i) {
	    return { value: b.id, label: b.name };
	  }),
	      eventMenuItems = events.sort(function (a, b) {
	    return a.name.localeCompare(b.name);
	  }).map(function (e, i) {
	    return {
	      value: e.id,
	      label: e.name + " (" + (0, _moment2.default)(e.start_time).format("llll") + ")"
	    };
	  }),
	      couponMenuItems = coupons.sort(function (a, b) {
	    return a.name.localeCompare(b.name);
	  }).map(function (c, i) {
	    return { value: c.id, label: c.name };
	  }),
	      tagMenuItems = tags.sort(function (a, b) {
	    return a.name.localeCompare(b.name);
	  }).map(function (t, i) {
	    return { value: t.id, label: t.name };
	  });
	
	  return React.createElement(
	    "div",
	    null,
	    React.createElement(
	      _label2.default,
	      null,
	      label
	    ),
	    React.createElement(
	      "div",
	      { style: { marginBottom: 5 } },
	      "Selected audience:",
	      " ",
	      _makeRecipientDescription(query, eventBucketId, stores) || React.createElement(
	        "span",
	        null,
	        "None yet. ",
	        React.createElement(
	          "em",
	          null,
	          "Combine selectors for powerful targeting."
	        )
	      )
	    ),
	    query.all_attendees || query.all_standalone_tickets_only ? null : React.createElement(
	      "div",
	      { style: styles.selectContainer },
	      React.createElement(
	        "div",
	        { style: styles.selectBlock },
	        React.createElement(_reactSelect2.default, {
	          autosize: false,
	          multi: true,
	          placeholder: "No pass buckets selected",
	          value: query.pass_bucket,
	          options: passBucketMenuItems,
	          onChange: function onChange(value) {
	            _onChange("query.pass_bucket", value && value.map(function (o) {
	              return o.value;
	            }));
	          }
	        })
	      ),
	      React.createElement(
	        "div",
	        { style: styles.selectBlock },
	        React.createElement(_reactSelect2.default, {
	          autosize: false,
	          multi: true,
	          placeholder: "No events selected",
	          value: query.event,
	          options: eventMenuItems,
	          onChange: function onChange(value) {
	            _onChange("query.event", value && value.map(function (o) {
	              return o.value;
	            }));
	          }
	        })
	      ),
	      React.createElement(
	        "div",
	        { style: styles.selectBlock },
	        React.createElement(_reactSelect2.default, {
	          autosize: false,
	          multi: true,
	          placeholder: "No tags selected",
	          value: query.tag,
	          options: tagMenuItems,
	          onChange: function onChange(value) {
	            _onChange("query.tag", value && value.map(function (o) {
	              return o.value;
	            }));
	          }
	        })
	      ),
	      React.createElement(
	        "div",
	        { style: styles.selectBlock },
	        React.createElement(_reactSelect2.default, {
	          autosize: false,
	          multi: true,
	          placeholder: "No discounts selected",
	          value: query.coupon,
	          options: couponMenuItems,
	          onChange: function onChange(value) {
	            _onChange("query.coupon", value && value.map(function (o) {
	              return o.value;
	            }));
	          }
	        })
	      )
	    ),
	    React.createElement(
	      "div",
	      { style: { marginTop: "0.5em" } },
	      !query.all_standalone_tickets_only ? React.createElement(_materialUi.Checkbox, {
	        label: allLabel || "Send to all attendees (pass & ticket holders)",
	        checked: query.all_attendees,
	        onCheck: function onCheck() {
	          return _onChange("query", { all_attendees: !query.all_attendees });
	        }
	      }) : null,
	      !query.all_attendees ? React.createElement(_materialUi.Checkbox, {
	        label: standaloneLabel || "Send to all standalone ticketholders (excluding passholders)",
	        checked: query.all_standalone_tickets_only,
	        onCheck: function onCheck() {
	          return _onChange("query", {
	            all_attendees: false,
	            all_standalone_tickets_only: !query.all_standalone_tickets_only
	          });
	        }
	      }) : null
	    )
	  );
	};
	
	ListTargetBuilder._makeRecipientDescription = _makeRecipientDescription;
	
	exports.default = ListTargetBuilder;
	module.exports = exports["default"];

/***/ }),
/* 2844 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _connectToStores = __webpack_require__(1226);
	
	var _connectToStores2 = _interopRequireDefault(_connectToStores);
	
	var _backButton = __webpack_require__(1872);
	
	var _backButton2 = _interopRequireDefault(_backButton);
	
	var _UserStore = __webpack_require__(974);
	
	var _UserStore2 = _interopRequireDefault(_UserStore);
	
	var _config = __webpack_require__(1173);
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MailingPreview = function (_React$Component) {
	  _inherits(MailingPreview, _React$Component);
	
	  function MailingPreview(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, MailingPreview);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(MailingPreview).call(this, props));
	
	    _this.fetchEmailPreview = _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
	      var response, html;
	      return regeneratorRuntime.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              _context.prev = 0;
	              _context.next = 3;
	              return fetch(_config2.default.endpoint + "mailings/" + _this.props.params.mailingId + "/preview?" + _UserStore2.default.makeApiKeyQueryString());
	
	            case 3:
	              response = _context.sent;
	              _context.next = 6;
	              return response.json();
	
	            case 6:
	              html = _context.sent;
	
	              _this.setState({ loading: false, previewHtml: html });
	              _context.next = 13;
	              break;
	
	            case 10:
	              _context.prev = 10;
	              _context.t0 = _context["catch"](0);
	
	              alert("Error fetching preview data: " + _context.t0);
	
	            case 13:
	              _context.prev = 13;
	
	              _this.setState({ loading: false });
	              return _context.finish(13);
	
	            case 16:
	            case "end":
	              return _context.stop();
	          }
	        }
	      }, _callee, _this2, [[0, 10, 13, 16]]);
	    }));
	
	
	    _this.state = {
	      previewHtml: "",
	      loading: true
	    };
	    return _this;
	  }
	
	  _createClass(MailingPreview, [{
	    key: "getStyles",
	    value: function getStyles() {
	      return {
	        "preview-frame": {
	          height: "500px",
	          width: "100%"
	        }
	      };
	    }
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.fetchEmailPreview();
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var styles = this.getStyles();
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(_backButton2.default, {
	          label: "Back",
	          location: "/event_buckets/" + this.props.params.eventBucketId + "/mailings/" + this.props.params.mailingId,
	          style: { marginBottom: 10 }
	        }),
	        this.state.loading ? _react2.default.createElement(
	          "div",
	          null,
	          "loading..."
	        ) : _react2.default.createElement("iframe", {
	          style: styles["preview-frame"],
	          srcDoc: this.state.previewHtml,
	          sandbox: true
	        })
	      );
	    }
	  }], [{
	    key: "contextTypes",
	    get: function get() {
	      return {
	        router: _react2.default.PropTypes.object
	      };
	    }
	  }]);
	
	  return MailingPreview;
	}(_react2.default.Component);
	
	exports.default = MailingPreview;
	module.exports = exports["default"];

/***/ }),
/* 2845 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _connectToStores = __webpack_require__(1226);
	
	var _connectToStores2 = _interopRequireDefault(_connectToStores);
	
	var _MailingActions = __webpack_require__(2838);
	
	var _MailingActions2 = _interopRequireDefault(_MailingActions);
	
	var _MailingStore = __webpack_require__(2839);
	
	var _MailingStore2 = _interopRequireDefault(_MailingStore);
	
	var _workingIndicator = __webpack_require__(1664);
	
	var _workingIndicator2 = _interopRequireDefault(_workingIndicator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var NewMailing = function (_React$Component) {
	  _inherits(NewMailing, _React$Component);
	
	  function NewMailing(props) {
	    _classCallCheck(this, NewMailing);
	
	    return _possibleConstructorReturn(this, Object.getPrototypeOf(NewMailing).call(this, props));
	  }
	
	  _createClass(NewMailing, [{
	    key: "componentWillMount",
	    value: function componentWillMount() {
	      _MailingActions2.default.create({
	        subject: "Untitled Mailing",
	        event_bucket: this.props.params.eventBucketId
	      });
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(props) {
	      if (props.newMailingId) {
	        this.context.router.replace("/event_buckets/" + props.params.eventBucketId + "/mailings/" + props.newMailingId);
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement(_workingIndicator2.default, { fullPage: true });
	    }
	  }], [{
	    key: "getStores",
	    value: function getStores() {
	      return [_MailingStore2.default];
	    }
	  }, {
	    key: "getPropsFromStores",
	    value: function getPropsFromStores() {
	      return {
	        newMailingId: _MailingStore2.default.getState().newMailingId
	      };
	    }
	  }, {
	    key: "contextTypes",
	    get: function get() {
	      return {
	        router: _react2.default.PropTypes.object
	      };
	    }
	  }]);
	
	  return NewMailing;
	}(_react2.default.Component);
	
	exports.default = (0, _connectToStores2.default)(NewMailing);
	module.exports = exports["default"];

/***/ }),
/* 2846 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _values = __webpack_require__(1214);
	
	var _values2 = _interopRequireDefault(_values);
	
	var _pickBy = __webpack_require__(1163);
	
	var _pickBy2 = _interopRequireDefault(_pickBy);
	
	var _moment = __webpack_require__(1021);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _reactRouter = __webpack_require__(486);
	
	var _materialUi = __webpack_require__(576);
	
	var _reactable = __webpack_require__(1688);
	
	var _styles = __webpack_require__(917);
	
	var _connectToStores = __webpack_require__(1226);
	
	var _connectToStores2 = _interopRequireDefault(_connectToStores);
	
	var _ExternalSyncActions = __webpack_require__(2847);
	
	var _ExternalSyncActions2 = _interopRequireDefault(_ExternalSyncActions);
	
	var _ExternalSyncStore = __webpack_require__(2848);
	
	var _ExternalSyncStore2 = _interopRequireDefault(_ExternalSyncStore);
	
	var _workingIndicator = __webpack_require__(1664);
	
	var _workingIndicator2 = _interopRequireDefault(_workingIndicator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ExternalSyncs = function (_React$Component) {
	  _inherits(ExternalSyncs, _React$Component);
	
	  function ExternalSyncs(props) {
	    _classCallCheck(this, ExternalSyncs);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(ExternalSyncs).call(this, props));
	
	    _this._makeRowForExternalSync = _this._makeRowForExternalSync.bind(_this);
	    return _this;
	  }
	
	  _createClass(ExternalSyncs, [{
	    key: "getStyles",
	    value: function getStyles() {
	      return {};
	    }
	  }, {
	    key: "_makeRowForExternalSync",
	    value: function _makeRowForExternalSync(externalSync) {
	      return _react2.default.createElement(
	        _reactable.Tr,
	        null,
	        _react2.default.createElement(
	          _reactable.Td,
	          { column: "Label", value: externalSync.label, style: { maxWidth: 300 } },
	          externalSync.label
	        ),
	        _react2.default.createElement(
	          _reactable.Td,
	          {
	            column: "Description",
	            value: externalSync.description,
	            style: { maxWidth: 300 }
	          },
	          externalSync.description
	        ),
	        _react2.default.createElement(
	          _reactable.Td,
	          { column: "Last Synced", value: externalSync.last_synced_at },
	          externalSync.last_synced_at ? "" + (0, _moment2.default)(externalSync.last_synced_at).format("lll") : "Waiting for first sync"
	        ),
	        _react2.default.createElement(
	          _reactable.Td,
	          { column: "Last Sync Details" },
	          externalSync.last_sync_details.error_message ? _react2.default.createElement(
	            "span",
	            { style: { color: _styles.colors.red600 } },
	            "Failed: ",
	            externalSync.last_sync_details.error_message
	          ) : externalSync.last_sync_details.message ? _react2.default.createElement(
	            "span",
	            { style: { color: "#4CAF50" } },
	            externalSync.last_sync_details.message
	          ) : "—"
	        ),
	        _react2.default.createElement(
	          _reactable.Td,
	          { column: "Actions" },
	          _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(
	              _reactRouter.Link,
	              {
	                to: "/event_buckets/" + this.props.params.eventBucketId + "/external_syncs/" + externalSync.id
	              },
	              "Manage sync"
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: "componentWillMount",
	    value: function componentWillMount() {
	      _ExternalSyncActions2.default.fetchAllForBucket(this.props.params.eventBucketId);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var styles = this.getStyles(),
	          bucket = this.props.params.eventBucketId,
	          externalSyncs = (0, _values2.default)((0, _pickBy2.default)(this.props.externalSyncs, function (e) {
	        return e.event_bucket === bucket;
	      })),
	          rows = externalSyncs.map(this._makeRowForExternalSync);
	
	      if (externalSyncs.length === 0 && _ExternalSyncStore2.default.getState().isFetching) {
	        return _react2.default.createElement(_workingIndicator2.default, { fullPage: true });
	      }
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          "h1",
	          { className: "page-title" },
	          "External Syncs"
	        ),
	        _react2.default.createElement(
	          _reactable.Table,
	          {
	            className: "bordered striped responsive-table",
	            sortable: [{ column: "Label", sortFunction: _reactable.Sort.CaseInsensitive }, { column: "Description", sortFunction: _reactable.Sort.CaseInsensitive }, "Last Synced", "Last Sync Details"],
	            defaultSort: { column: "Description", direction: "asc" },
	            columns: ["Label", "Description", "Last Synced", "Last Sync Details", "Actions"],
	            filterable: ["Description", "Label"],
	            filterPlaceholder: "Type to filter..."
	          },
	          rows
	        ),
	        rows.length === 0 ? _react2.default.createElement(
	          "div",
	          { className: "empty-table-message" },
	          "No external syncs yet.",
	          " ",
	          _react2.default.createElement(
	            _reactRouter.Link,
	            { to: "/event_buckets/" + bucket + "/external_syncs/new" },
	            "Create a new external sync."
	          )
	        ) : null,
	        _react2.default.createElement(
	          "div",
	          { style: { marginTop: 20 } },
	          _react2.default.createElement(_materialUi.RaisedButton, {
	            label: "Create new external sync",
	            primary: true,
	            onTouchTap: function onTouchTap() {
	              return _this2.context.router.push("/event_buckets/" + _this2.props.params.eventBucketId + "/external_syncs/new");
	            }
	          })
	        )
	      );
	    }
	  }], [{
	    key: "getStores",
	    value: function getStores() {
	      return [_ExternalSyncStore2.default];
	    }
	  }, {
	    key: "getPropsFromStores",
	    value: function getPropsFromStores() {
	      return {
	        externalSyncs: _ExternalSyncStore2.default.getState().externalSyncs
	      };
	    }
	  }, {
	    key: "contextTypes",
	    get: function get() {
	      return {
	        router: _react2.default.PropTypes.object
	      };
	    }
	  }]);
	
	  return ExternalSyncs;
	}(_react2.default.Component);
	
	exports.default = (0, _connectToStores2.default)(ExternalSyncs);
	module.exports = exports["default"];

/***/ }),
/* 2847 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _alt = __webpack_require__(975);
	
	var _alt2 = _interopRequireDefault(_alt);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ExternalSyncActions = function () {
	  function ExternalSyncActions() {
	    _classCallCheck(this, ExternalSyncActions);
	
	    this.generateActions("create", "forceSync", "delete", "updateExternalSyncs", "fetchOne", "fetchAllForBucket", "fetchFailed", "editFailed", "clearErrors", "fetchProviderStatus", "fetchMailchimpSegments");
	  }
	
	  _createClass(ExternalSyncActions, [{
	    key: "updateExternalSync",
	    value: function updateExternalSync(id, externalSync) {
	      return { id: id, externalSync: externalSync };
	    }
	  }, {
	    key: "edit",
	    value: function edit(id, values) {
	      return { id: id, values: values };
	    }
	  }]);
	
	  return ExternalSyncActions;
	}();
	
	exports.default = _alt2.default.createActions(ExternalSyncActions);
	module.exports = exports["default"];

/***/ }),
/* 2848 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _alt = __webpack_require__(975);
	
	var _alt2 = _interopRequireDefault(_alt);
	
	var _keyBy = __webpack_require__(990);
	
	var _keyBy2 = _interopRequireDefault(_keyBy);
	
	var _extend = __webpack_require__(1212);
	
	var _extend2 = _interopRequireDefault(_extend);
	
	var _ExternalSyncUtil = __webpack_require__(2849);
	
	var _ExternalSyncUtil2 = _interopRequireDefault(_ExternalSyncUtil);
	
	var _ExternalSyncActions = __webpack_require__(2847);
	
	var _ExternalSyncActions2 = _interopRequireDefault(_ExternalSyncActions);
	
	var _EventBucketActions = __webpack_require__(1218);
	
	var _EventBucketActions2 = _interopRequireDefault(_EventBucketActions);
	
	var _UserStore = __webpack_require__(974);
	
	var _UserStore2 = _interopRequireDefault(_UserStore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ExternalSyncStore = function () {
	  function ExternalSyncStore() {
	    _classCallCheck(this, ExternalSyncStore);
	
	    this.bindActions(_ExternalSyncActions2.default);
	
	    this.state = {
	      providerStatus: {},
	      externalSyncs: {},
	      mailchimpSegments: {},
	      newExternalSyncId: null,
	      isEditing: false,
	      errorMessage: "",
	      isFetching: false,
	      isFetchingProviderStatus: false,
	      hasFetchedProviderStatus: false
	    };
	
	    this.exportPublicMethods({
	      getExternalSyncById: this.getExternalSyncById.bind(this)
	    });
	  }
	
	  _createClass(ExternalSyncStore, [{
	    key: "getExternalSyncById",
	    value: function getExternalSyncById(id) {
	      return this.state.externalSyncs[id];
	    }
	  }, {
	    key: "onClearErrors",
	    value: function onClearErrors() {
	      this.setState({
	        errorMessage: ""
	      });
	    }
	  }, {
	    key: "onFetchProviderStatus",
	    value: function onFetchProviderStatus() {
	      var _this = this;
	
	      this.setState({ isFetchingProviderStatus: true });
	      _ExternalSyncUtil2.default.getProviderStatus(_UserStore2.default.getState().apiKey).then(function (data) {
	        _this.setState({
	          hasFetchedProviderStatus: true,
	          isFetchingProviderStatus: false,
	          providerStatus: data
	        });
	      }).catch(_ExternalSyncActions2.default.fetchFailed);
	    }
	  }, {
	    key: "onFetchMailchimpSegments",
	    value: function onFetchMailchimpSegments(list) {
	      var _this2 = this;
	
	      _ExternalSyncUtil2.default.getMailchimpSegmentsForList(_UserStore2.default.getState().apiKey, list).then(function (data) {
	        var mailchimpSegments = Object.assign({}, _this2.state.mailchimpSegments, _defineProperty({}, list, data.segments));
	        _this2.setState({ mailchimpSegments: mailchimpSegments });
	      }).catch(_ExternalSyncActions2.default.fetchFailed);
	    }
	  }, {
	    key: "onFetchOne",
	    value: function onFetchOne(id) {
	      _ExternalSyncUtil2.default.fetchOne(_UserStore2.default.getState().apiKey, id).then(function (data) {
	        _ExternalSyncActions2.default.updateExternalSync(id, data);
	      }).catch(_ExternalSyncActions2.default.fetchFailed);
	    }
	  }, {
	    key: "onFetchAllForBucket",
	    value: function onFetchAllForBucket(eventBucket) {
	      var _this3 = this;
	
	      this.setState({ isFetching: true });
	      _ExternalSyncUtil2.default.fetchAllForBucket(_UserStore2.default.getState().apiKey, eventBucket).then(function (data) {
	        _ExternalSyncActions2.default.updateExternalSyncs((0, _keyBy2.default)(data, "id"));
	        _this3.setState({ isFetching: false });
	      }).catch(_ExternalSyncActions2.default.fetchFailed);
	    }
	  }, {
	    key: "onEdit",
	    value: function onEdit(newData) {
	      this.setState({ errorMessage: "", isEditing: true });
	      _ExternalSyncUtil2.default.edit(_UserStore2.default.getState().apiKey, newData.id, newData.values).then(function (data) {
	        _ExternalSyncActions2.default.updateExternalSync(newData.id, data);
	        _EventBucketActions2.default.fetchOne(data.event_bucket);
	      }).catch(_ExternalSyncActions2.default.editFailed);
	    }
	  }, {
	    key: "onDelete",
	    value: function onDelete(id) {
	      var _this4 = this;
	
	      _ExternalSyncUtil2.default.delete(_UserStore2.default.getState().apiKey, id).then(function (data) {
	        _EventBucketActions2.default.fetchOne(_this4.state.externalSyncs[id].event_bucket);
	        _ExternalSyncActions2.default.updateExternalSync(id, undefined);
	      }).catch(_ExternalSyncActions2.default.editFailed);
	    }
	  }, {
	    key: "onForceSync",
	    value: function onForceSync(id) {
	      this.setState({ errorMessage: "", isEditing: true });
	      _ExternalSyncUtil2.default.forceSync(_UserStore2.default.getState().apiKey, id).then(function (data) {
	        _ExternalSyncActions2.default.updateExternalSync(id, data);
	      }).catch(_ExternalSyncActions2.default.editFailed);
	    }
	  }, {
	    key: "onCreate",
	    value: function onCreate(newData) {
	      var _this5 = this;
	
	      this.setState({
	        newExternalSyncId: null
	      });
	
	      _ExternalSyncUtil2.default.create(_UserStore2.default.getState().apiKey, newData).then(function (data) {
	        window.Intercom("trackEvent", "create-externalsync");
	
	        _ExternalSyncActions2.default.updateExternalSync(data.id, data);
	        _EventBucketActions2.default.fetchOne(data.event_bucket);
	        _this5.setState({
	          newExternalSyncId: data.id
	        });
	      }).catch(_ExternalSyncActions2.default.fetchFailed);
	    }
	  }, {
	    key: "onUpdateExternalSync",
	    value: function onUpdateExternalSync(data) {
	      if (!data.externalSync) {
	        delete this.state.externalSyncs[data.id];
	      } else {
	        this.state.externalSyncs[data.id] = data.externalSync;
	      }
	      this.state.isEditing = false;
	      this.state.newExternalSyncId = null;
	      this.setState(this.state);
	    }
	  }, {
	    key: "onUpdateExternalSyncs",
	    value: function onUpdateExternalSyncs(externalSyncs) {
	      (0, _extend2.default)(this.state.externalSyncs, externalSyncs);
	      this.setState(this.state);
	    }
	  }, {
	    key: "onFetchFailed",
	    value: function onFetchFailed(e) {
	      alert("Fetching external sync failed: " + e.message);
	      throw e;
	    }
	  }, {
	    key: "onEditFailed",
	    value: function onEditFailed(e) {
	      this.setState({
	        errorMessage: e.message,
	        isEditing: false
	      });
	    }
	  }]);
	
	  return ExternalSyncStore;
	}();
	
	exports.default = _alt2.default.createStore(ExternalSyncStore, "ExternalSyncStore");
	module.exports = exports["default"];

/***/ }),
/* 2849 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _merge = __webpack_require__(732);
	
	var _merge2 = _interopRequireDefault(_merge);
	
	var _api = __webpack_require__(1160);
	
	var _api2 = _interopRequireDefault(_api);
	
	var _config = __webpack_require__(1173);
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  fetchOne: function fetchOne(apiKey, externalSync) {
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "GET",
	        endpoint: "external_syncs/" + externalSync,
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response);
	      });
	    });
	  },
	  fetchAllForBucket: function fetchAllForBucket(apiKey, bucket) {
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "GET",
	        endpoint: "event_buckets/" + bucket + "/external_syncs",
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response.external_syncs);
	      });
	    });
	  },
	  edit: function edit(apiKey, externalSync, values) {
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "POST",
	        endpoint: "external_syncs/" + externalSync,
	        json: values,
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response);
	      });
	    });
	  },
	  forceSync: function forceSync(apiKey, externalSync) {
	    var debug = false;
	
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "POST",
	        endpoint: "external_syncs/" + externalSync + "/force_sync",
	        json: { debug: debug },
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response);
	      });
	    });
	  },
	  delete: function _delete(apiKey, externalSync) {
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "DELETE",
	        endpoint: "external_syncs/" + externalSync,
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response);
	      });
	    });
	  },
	  create: function create(apiKey, values) {
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "POST",
	        endpoint: "external_syncs",
	        json: values,
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response);
	      });
	    });
	  },
	  getProviderStatus: function getProviderStatus(apiKey) {
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "GET",
	        endpoint: "external_syncs/provider_status",
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response);
	      });
	    });
	  },
	  getMailchimpSegmentsForList: function getMailchimpSegmentsForList(apiKey, list) {
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "GET",
	        endpoint: "external_syncs/provider_status/mailchimp_segments",
	        qs: { list: list },
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response);
	      });
	    });
	  }
	};
	module.exports = exports["default"];

/***/ }),
/* 2850 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _assign = __webpack_require__(920);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _get = __webpack_require__(1004);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _set = __webpack_require__(1188);
	
	var _set2 = _interopRequireDefault(_set);
	
	var _marked = __webpack_require__(2842);
	
	var _marked2 = _interopRequireDefault(_marked);
	
	var _moment = __webpack_require__(1021);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _reactSelect = __webpack_require__(953);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	var _materialUi = __webpack_require__(576);
	
	var _styles = __webpack_require__(917);
	
	var _reactRouter = __webpack_require__(486);
	
	var _config = __webpack_require__(1173);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _UserStore = __webpack_require__(974);
	
	var _UserStore2 = _interopRequireDefault(_UserStore);
	
	var _workingIndicator = __webpack_require__(1664);
	
	var _workingIndicator2 = _interopRequireDefault(_workingIndicator);
	
	var _label = __webpack_require__(1682);
	
	var _label2 = _interopRequireDefault(_label);
	
	var _linkLike = __webpack_require__(973);
	
	var _linkLike2 = _interopRequireDefault(_linkLike);
	
	var _backButton = __webpack_require__(1872);
	
	var _backButton2 = _interopRequireDefault(_backButton);
	
	var _selectField = __webpack_require__(1683);
	
	var _selectField2 = _interopRequireDefault(_selectField);
	
	var _util = __webpack_require__(1183);
	
	var util = _interopRequireWildcard(_util);
	
	var _infoNotice = __webpack_require__(1599);
	
	var _infoNotice2 = _interopRequireDefault(_infoNotice);
	
	var _selectWells = __webpack_require__(1676);
	
	var _selectWells2 = _interopRequireDefault(_selectWells);
	
	var _listTargetBuilder = __webpack_require__(2843);
	
	var _listTargetBuilder2 = _interopRequireDefault(_listTargetBuilder);
	
	var _connectToStores = __webpack_require__(1226);
	
	var _connectToStores2 = _interopRequireDefault(_connectToStores);
	
	var _ExternalSyncActions = __webpack_require__(2847);
	
	var _ExternalSyncActions2 = _interopRequireDefault(_ExternalSyncActions);
	
	var _ExternalSyncStore = __webpack_require__(2848);
	
	var _ExternalSyncStore2 = _interopRequireDefault(_ExternalSyncStore);
	
	var _EventActions = __webpack_require__(2031);
	
	var _EventActions2 = _interopRequireDefault(_EventActions);
	
	var _EventBucketStore = __webpack_require__(1593);
	
	var _EventBucketStore2 = _interopRequireDefault(_EventBucketStore);
	
	var _EventStore = __webpack_require__(2032);
	
	var _EventStore2 = _interopRequireDefault(_EventStore);
	
	var _PassBucketActions = __webpack_require__(1869);
	
	var _PassBucketActions2 = _interopRequireDefault(_PassBucketActions);
	
	var _PassBucketStore = __webpack_require__(1867);
	
	var _PassBucketStore2 = _interopRequireDefault(_PassBucketStore);
	
	var _CouponActions = __webpack_require__(2041);
	
	var _CouponActions2 = _interopRequireDefault(_CouponActions);
	
	var _CouponStore = __webpack_require__(2042);
	
	var _CouponStore2 = _interopRequireDefault(_CouponStore);
	
	var _TagActions = __webpack_require__(2038);
	
	var _TagActions2 = _interopRequireDefault(_TagActions);
	
	var _TagStore = __webpack_require__(2039);
	
	var _TagStore2 = _interopRequireDefault(_TagStore);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PROVIDERS = {
	  mailchimp: { display_name: "MailChimp" },
	  eventival: { display_name: "Eventival" }
	};
	
	var ExternalSync = function (_React$Component) {
	  _inherits(ExternalSync, _React$Component);
	
	  function ExternalSync(props) {
	    _classCallCheck(this, ExternalSync);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(ExternalSync).call(this, props));
	
	    _this.state = {
	      externalSync: null,
	      dirty: false,
	      isWorking: false,
	      values: {},
	      lastUpdated: null
	    };
	
	    _this.onChangeValue = _this.onChangeValue.bind(_this);
	    _this.save = _this.save.bind(_this);
	    _this.delete = _this.delete.bind(_this);
	    _this.forceSync = _this.forceSync.bind(_this);
	    _this.onConnectClick = _this.onConnectClick.bind(_this);
	    return _this;
	  }
	
	  _createClass(ExternalSync, [{
	    key: "onChangeValue",
	    value: function onChangeValue(id, value) {
	      // If nothing is actually changed, don't do anything
	      if ((0, _get2.default)(this.state.values, id) === value) {
	        return;
	      }
	
	      // Update mailchimp segments proactively
	      if (this.state.values.provider === "mailchimp" && id === "result.list") {
	        _ExternalSyncActions2.default.fetchMailchimpSegments.defer(value);
	      }
	
	      this.state.dirty = true;
	      (0, _set2.default)(this.state.values, id, value);
	      this.setState(this.state);
	    }
	  }, {
	    key: "save",
	    value: function save() {
	      var values = (0, _assign2.default)({}, this.state.values);
	      this.setState({
	        isWorking: true,
	        lastUpdated: this.state.externalSync.updated_at
	      });
	
	      if (values.provider === "mailchimp" && values.result && values.result.list) {
	        values.description = "MailChimp " + (values.result.mode ? values.result.mode + " " : "") + "sync to \"" + (this.props.providerStatus.providers.mailchimp.lists.find(function (l) {
	          return l.id === values.result.list;
	        }) || { name: "Unknown list" }).name + "\"";
	      }
	
	      if (values.provider === "eventival" && values.result && values.result.project) {
	        var selected = this.props.providerStatus.providers.eventival.projects.find(function (p) {
	          return p.id === values.result.project;
	        }) || { name: "Unknown Project" };
	        values.description = "Eventival sync from \"" + selected.name + "\"" + (values.result.edition ? ", " + values.result.edition + " edition" : "");
	      }
	
	      _ExternalSyncActions2.default.edit(this.props.params.externalSyncId, values);
	    }
	  }, {
	    key: "forceSync",
	    value: function forceSync() {
	      window.scrollTo(0, 0);
	      var bucket = this.state.externalSync.event_bucket;
	      this.setState({
	        isWorking: true,
	        lastUpdated: this.state.externalSync.updated_at
	      });
	      _ExternalSyncActions2.default.forceSync(this.props.params.externalSyncId);
	    }
	  }, {
	    key: "onConnectClick",
	    value: function onConnectClick(e) {
	      if (this.state.values.provider === "eventival") {
	        e.preventDefault();
	        Intercom("showNewMessage", "I'm ready to connect my Eventival account. My Eventival organization name is: ");
	      }
	    }
	  }, {
	    key: "delete",
	    value: function _delete() {
	      var bucket = this.state.externalSync.event_bucket;
	      if (window.confirm("Are you sure? No further syncs will be performed. (Note: By deleting the external sync, existing external records will not be removed.)")) {
	        _ExternalSyncActions2.default.delete(this.props.params.externalSyncId);
	        this.context.router.push("/event_buckets/" + bucket + "/external_syncs");
	      }
	    }
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.componentWillReceiveProps(this.props);
	      _ExternalSyncActions2.default.fetchProviderStatus();
	      _PassBucketActions2.default.fetchAllForEventBucket(this.props.params.eventBucketId);
	      _EventActions2.default.fetchAllForBucket(this.props.params.eventBucketId);
	      _CouponActions2.default.fetchAllForBucket(this.props.params.eventBucketId);
	      _TagActions2.default.fetchAllForBucket(this.props.params.eventBucketId);
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(newProps) {
	      var externalSync = newProps.getExternalSyncById(newProps.params.externalSyncId);
	
	      if (!this.state.isFetchingExternalSync && !externalSync) {
	        _ExternalSyncActions2.default.clearErrors();
	        _ExternalSyncActions2.default.fetchOne(newProps.params.externalSyncId);
	        this.setState({ isFetchingExternalSync: true });
	      } else if (externalSync) {
	        this.setState({ isFetchingExternalSync: false });
	      }
	
	      if (this.state.isWorking && !newProps.isEditing) {
	        this.setState({ isWorking: false });
	      }
	
	      if (Object.keys(this.state.values).length === 0 || this.state.externalSync.id !== newProps.params.externalSyncId || this.state.isWorking && externalSync.updated_at !== this.state.lastUpdated) {
	        if (externalSync && externalSync.provider === "mailchimp" && externalSync.result.list) {
	          _ExternalSyncActions2.default.fetchMailchimpSegments.defer(externalSync.result.list);
	        }
	
	        this.setState({
	          externalSync: externalSync,
	          isWorking: false,
	          dirty: false,
	          values: externalSync ? {
	            label: externalSync.label,
	            provider: externalSync.provider,
	            query: externalSync.query,
	            result: externalSync.result
	          } : {}
	        });
	      }
	    }
	  }, {
	    key: "getStyles",
	    value: function getStyles() {
	      return {
	        actions: {
	          marginTop: 20
	        },
	        error: {
	          color: "red",
	          marginTop: 10
	        }
	      };
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var styles = this.getStyles(),
	          externalSync = this.props.getExternalSyncById(this.props.params.externalSyncId);
	
	      if (!externalSync || !this.state.externalSync || this.state.isFetchingExternalSync || this.state.isWorking || !this.props.hasFetchedProviderStatus) {
	        return _react2.default.createElement(_workingIndicator2.default, { fullPage: true });
	      }
	
	      var okayToForceSync = !this.state.dirty;
	
	      var selectedMailchimpSegment = (0, _get2.default)(this.state, "values.result.segment");
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement(_backButton2.default, {
	            label: "External syncs",
	            style: { marginBottom: 10 },
	            location: "/event_buckets/" + this.props.params.eventBucketId + "/external_syncs"
	          })
	        ),
	        _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement(
	            _infoNotice2.default,
	            { style: { marginTop: 10 } },
	            "Check out our",
	            " ",
	            _react2.default.createElement(
	              "a",
	              {
	                href: "https://help.eventive.org/integrations/create-external-syncs",
	                target: "_blank"
	              },
	              "guide to external syncs"
	            ),
	            "."
	          ),
	          _react2.default.createElement(
	            "div",
	            { style: { marginTop: "1em" } },
	            _react2.default.createElement(_materialUi.TextField, {
	              value: (0, _get2.default)(this.state, "values.label", ""),
	              floatingLabelText: "Label",
	              floatingLabelFixed: true,
	              style: { marginTop: -12, marginBottom: -6, width: "100%" },
	              onChange: function onChange(e) {
	                return _this2.onChangeValue("label", e.target.value);
	              }
	            })
	          ),
	          _react2.default.createElement(
	            "div",
	            { style: { marginTop: "1em" } },
	            _react2.default.createElement(
	              _label2.default,
	              null,
	              "External provider"
	            ),
	            _react2.default.createElement(_selectWells2.default, {
	              style: { maxWidth: 450 },
	              options: [{
	                value: "mailchimp",
	                icon: function icon() {
	                  return _react2.default.createElement("img", {
	                    src: "https://storage.googleapis.com/eventive-co/mailchimp-logo.svg",
	                    style: { width: "80%", marginBottom: -8 }
	                  });
	                }
	              }, {
	                value: "eventival",
	                icon: function icon() {
	                  return _react2.default.createElement("img", {
	                    src: "https://storage.googleapis.com/eventive-co/eventival-dark.png",
	                    style: { width: "60%", verticalAlign: "middle" }
	                  });
	                }
	              }],
	              onChange: function onChange(v) {
	                return _this2.onChangeValue("provider", v);
	              },
	              value: this.state.values.provider
	            })
	          ),
	          _react2.default.createElement(
	            "div",
	            { style: { marginTop: 10 } },
	            this.props.providerStatus.providers[this.state.values.provider] ? _react2.default.createElement(
	              "div",
	              {
	                style: {
	                  display: "inline-block",
	                  borderRadius: 8,
	                  padding: "7px 12px",
	                  backgroundColor: "#4CAF50",
	                  color: "#fff"
	                }
	              },
	              PROVIDERS[this.state.values.provider].display_name,
	              " account connected & ready for sync."
	            ) : _react2.default.createElement(
	              "div",
	              {
	                style: {
	                  display: "inline-block",
	                  borderRadius: 8,
	                  padding: "7px 12px",
	                  backgroundColor: _styles.colors.red600,
	                  color: "#fff"
	                }
	              },
	              "No ",
	              PROVIDERS[this.state.values.provider].display_name,
	              " account connected.",
	              " ",
	              _react2.default.createElement(
	                "a",
	                {
	                  onClick: this.onConnectClick,
	                  href: _config2.default.endpoint + ("auth/" + this.state.values.provider + "?" + _UserStore2.default.makeApiKeyQueryString() + "&redirect=" + encodeURIComponent(window.location.href)),
	                  style: { color: "#fff", textDecoration: "underline" }
	                },
	                "Connect one to continue."
	              )
	            )
	          ),
	          this.state.values.provider === "mailchimp" && _react2.default.createElement(
	            "div",
	            { style: { marginTop: 20 } },
	            _react2.default.createElement(_listTargetBuilder2.default, {
	              label: "Target customers to sync",
	              eventBucketId: this.props.params.eventBucketId,
	              stores: {
	                EventStore: _EventStore2.default,
	                CouponStore: _CouponStore2.default,
	                PassBucketStore: _PassBucketStore2.default,
	                EventBucketStore: _EventBucketStore2.default,
	                TagStore: _TagStore2.default
	              },
	              query: (0, _get2.default)(this.state, "values.query", {}),
	              onChange: this.onChangeValue,
	              allLabel: "Sync all attendees (pass & ticket holders)",
	              standaloneLabel: "Sync all standalone ticketholders (excluding passholders)"
	            })
	          ),
	          this.state.values.provider === "eventival" && _react2.default.createElement(
	            "div",
	            { style: { marginTop: 20 } },
	            _react2.default.createElement(
	              _label2.default,
	              null,
	              "Eventival sync information"
	            ),
	            _react2.default.createElement(
	              "div",
	              { style: { maxWidth: 500 } },
	              "When you synchronize with an Eventival project, we'll automatically copy events, films, and/or passes from your Eventival database. Existing events/films/passes will not be affected."
	            ),
	            _react2.default.createElement(
	              "div",
	              {
	                style: this.props.providerStatus.providers.eventival ? {} : { pointerEvents: "none", opacity: 0.5 }
	              },
	              _react2.default.createElement(_selectField2.default, {
	                value: (0, _get2.default)(this.state, "values.result.project", null),
	                label: "Eventival source project",
	                placeholder: "Select a project...",
	                style: { marginTop: 20, maxWidth: 300 },
	                options: this.props.providerStatus.providers.eventival ? this.props.providerStatus.providers.eventival.projects.map(function (l) {
	                  return { label: l.name, value: l.id };
	                }) : [],
	                onChange: function onChange(selected) {
	                  return _this2.onChangeValue("result.project", selected ? selected.value : null);
	                }
	              }),
	              _react2.default.createElement(_selectField2.default, {
	                value: (0, _get2.default)(this.state, "values.result.edition", null),
	                label: "Eventival source edition",
	                placeholder: "Select an edition...",
	                style: { marginTop: 20, maxWidth: 300 },
	                options: this.props.providerStatus.providers.eventival ? (this.props.providerStatus.providers.eventival.projects.find(function (p) {
	                  return p.id === (0, _get2.default)(_this2.state, "values.result.project", null);
	                }) || { editions: [] }).editions.map(function (e) {
	                  return { label: e, value: e };
	                }) : [],
	                onChange: function onChange(selected) {
	                  return _this2.onChangeValue("result.edition", selected ? selected.value : null);
	                }
	              }),
	              _react2.default.createElement(
	                "div",
	                null,
	                _react2.default.createElement(
	                  _label2.default,
	                  { style: { marginTop: 20 } },
	                  "Eventival sync options"
	                ),
	                _react2.default.createElement(_materialUi.Checkbox, {
	                  label: "Sync films from Eventival",
	                  style: { width: 300 },
	                  checked: (0, _get2.default)(this.state, "values.result.films"),
	                  onCheck: function onCheck(e, checked) {
	                    _this2.onChangeValue("result.films", !(0, _get2.default)(_this2.state, "values.result.films"));
	                  }
	                }),
	                _react2.default.createElement(_materialUi.Checkbox, {
	                  label: "Sync screenings from Eventival",
	                  style: { width: 300 },
	                  checked: (0, _get2.default)(this.state, "values.result.screenings"),
	                  onCheck: function onCheck(e, checked) {
	                    _this2.onChangeValue("result.screenings", !(0, _get2.default)(_this2.state, "values.result.screenings"));
	                  }
	                }),
	                _react2.default.createElement(_materialUi.Checkbox, {
	                  label: "Sync other events from Eventival",
	                  style: { width: 300 },
	                  checked: (0, _get2.default)(this.state, "values.result.events"),
	                  onCheck: function onCheck(e, checked) {
	                    _this2.onChangeValue("result.events", !(0, _get2.default)(_this2.state, "values.result.events"));
	                  }
	                }),
	                _react2.default.createElement(_materialUi.Checkbox, {
	                  label: "Sync passes from Eventival",
	                  style: { width: 300 },
	                  checked: (0, _get2.default)(this.state, "values.result.passes"),
	                  onCheck: function onCheck(e, checked) {
	                    _this2.onChangeValue("result.passes", !(0, _get2.default)(_this2.state, "values.result.passes"));
	                  }
	                }),
	                _react2.default.createElement(_materialUi.Checkbox, {
	                  label: "Push Eventive pass orders to Eventival",
	                  style: { width: 300 },
	                  checked: (0, _get2.default)(this.state, "values.result.passes_push"),
	                  onCheck: function onCheck(e, checked) {
	                    _this2.onChangeValue("result.passes_push", !(0, _get2.default)(_this2.state, "values.result.passes_push"));
	                  }
	                }),
	                (0, _get2.default)(this.state, "values.result.passes_push") ? _react2.default.createElement(
	                  "p",
	                  null,
	                  "Note: pass push sync requires an",
	                  " ",
	                  _react2.default.createElement(
	                    "strong",
	                    null,
	                    "exact match"
	                  ),
	                  " between Eventive pass bucket name and Eventival badge type. If there is not an Eventival badge type with the name matching exactly, no Eventival badge will be created.",
	                  " ",
	                  _react2.default.createElement(
	                    "i",
	                    null,
	                    "Eventival only allows one badge per person. If someone purchases multiple Eventive passes, they will receive only one account with one badge."
	                  )
	                ) : null
	              )
	            )
	          ),
	          this.state.values.provider === "mailchimp" ? _react2.default.createElement(
	            "div",
	            {
	              style: this.props.providerStatus.providers.mailchimp ? {} : { pointerEvents: "none", opacity: 0.5 }
	            },
	            _react2.default.createElement(
	              "div",
	              { style: { marginTop: 20 } },
	              _react2.default.createElement(
	                "div",
	                null,
	                _react2.default.createElement(_selectField2.default, {
	                  value: (0, _get2.default)(this.state, "values.result.list", null),
	                  label: "MailChimp destination list",
	                  placeholder: "Select a list...",
	                  style: { maxWidth: 300 },
	                  options: this.props.providerStatus.providers.mailchimp ? this.props.providerStatus.providers.mailchimp.lists.map(function (l) {
	                    return { label: l.name, value: l.id };
	                  }) : [],
	                  onChange: function onChange(selected) {
	                    return _this2.onChangeValue("result.list", selected ? selected.value : null);
	                  }
	                })
	              ),
	              _react2.default.createElement(
	                "div",
	                { style: { marginTop: 5 } },
	                "Or",
	                " ",
	                _react2.default.createElement(
	                  "a",
	                  {
	                    target: "_blank",
	                    href: this.props.providerStatus.providers.mailchimp && this.props.providerStatus.providers.mailchimp.new_list_url
	                  },
	                  "create a new list"
	                ),
	                ", and then",
	                " ",
	                _react2.default.createElement(
	                  _linkLike2.default,
	                  {
	                    onTouchTap: function onTouchTap() {
	                      return _ExternalSyncActions2.default.fetchProviderStatus();
	                    }
	                  },
	                  "refresh options"
	                )
	              )
	            ),
	            (0, _get2.default)(this.state, "values.result.list") ? _react2.default.createElement(
	              "div",
	              { style: { marginTop: 15 } },
	              _react2.default.createElement(_materialUi.Checkbox, {
	                label: "Update static list segment",
	                style: { width: 250 },
	                checked: this.state.showSegmentEditor || (0, _get2.default)(this.state, "values.result.segment"),
	                onCheck: function onCheck(e, checked) {
	                  if (!_this2.state.showSegmentEditor && !(0, _get2.default)(_this2.state, "values.result.segment")) {
	                    _this2.setState({ showSegmentEditor: true });
	                  } else {
	                    _this2.setState({ showSegmentEditor: false }, function () {
	                      _this2.onChangeValue("result.segment", null);
	                    });
	                  }
	                }
	              }),
	              this.state.showSegmentEditor || (0, _get2.default)(this.state, "values.result.segment") ? _react2.default.createElement(
	                "div",
	                { style: { maxWidth: 300, marginTop: 10 } },
	                _react2.default.createElement(_reactSelect.Creatable, {
	                  value: (0, _get2.default)(this.state, "values.result.segment", null),
	                  label: "MailChimp destination segment",
	                  placeholder: "Select or type to create a segment...",
	                  options: (this.props.mailchimpSegments[this.state.values.result.list] || []).map(function (s) {
	                    return { label: s.name, value: s.id };
	                  }).concat(!(this.props.mailchimpSegments[this.state.values.result.list] || []).find(function (s) {
	                    return s.id === selectedMailchimpSegment;
	                  }) && selectedMailchimpSegment ? [{
	                    label: selectedMailchimpSegment + " [will be created on sync]",
	                    value: selectedMailchimpSegment
	                  }] : []),
	                  promptTextCreator: function promptTextCreator(s) {
	                    return "Create new segment \"" + s + "\"";
	                  },
	                  onChange: function onChange(selected) {
	                    return _this2.onChangeValue("result.segment", selected ? selected.value : null);
	                  }
	                })
	              ) : null
	            ) : null,
	            _react2.default.createElement(
	              "div",
	              { style: { marginTop: 20 } },
	              _react2.default.createElement(
	                _label2.default,
	                null,
	                "MailChimp sync mode"
	              ),
	              _react2.default.createElement(
	                _materialUi.RadioButtonGroup,
	                {
	                  name: "mailchimp_sync_mode",
	                  valueSelected: (0, _get2.default)(this.state, "values.result.mode", null),
	                  onChange: function onChange(e, v) {
	                    return _this2.onChangeValue("result.mode", v);
	                  }
	                },
	                _react2.default.createElement(_materialUi.RadioButton, {
	                  value: "push",
	                  label: "Push (automatically add all targeted Eventive customers, but never remove subscribers from MailChimp list)"
	                }),
	                _react2.default.createElement(_materialUi.RadioButton, {
	                  value: "active",
	                  label: "Active sync (automatically add all targeted Eventive customers, and actively remove non-matching subscribers from MailChimp list)"
	                })
	              )
	            )
	          ) : null,
	          _react2.default.createElement(
	            "div",
	            { style: { marginTop: 20 } },
	            _react2.default.createElement(
	              _label2.default,
	              null,
	              "Sync status"
	            ),
	            _react2.default.createElement(
	              "div",
	              null,
	              _react2.default.createElement(
	                "strong",
	                null,
	                !externalSync.last_synced_at ? "Not yet synced. Syncs run hourly." : "Last synced " + (0, _moment2.default)(externalSync.last_synced_at).format("lll"),
	                " ",
	                externalSync.last_sync_details.error_message ? _react2.default.createElement(
	                  "span",
	                  { style: { color: _styles.colors.red600 } },
	                  "Failed: ",
	                  externalSync.last_sync_details.error_message
	                ) : _react2.default.createElement(
	                  "span",
	                  { style: { color: "#4CAF50" } },
	                  externalSync.last_sync_details.message
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              null,
	              !okayToForceSync ? "To force an immediate sync, first save changes." : "Force sync immediately using the button below."
	            )
	          ),
	          this.props.errorMessage ? _react2.default.createElement(
	            "div",
	            { style: styles.error },
	            this.props.errorMessage
	          ) : null,
	          _react2.default.createElement(
	            "div",
	            { style: styles.actions },
	            _react2.default.createElement(_materialUi.RaisedButton, {
	              label: this.state.dirty ? "Save changes" : "No changes to save",
	              primary: true,
	              disabled: !this.state.dirty,
	              onClick: this.save
	            }),
	            _react2.default.createElement(_materialUi.RaisedButton, {
	              label: "Delete external sync",
	              onClick: this.delete,
	              style: { marginLeft: 7 }
	            }),
	            _react2.default.createElement(_materialUi.RaisedButton, {
	              label: "Force sync",
	              disabled: !okayToForceSync,
	              onClick: this.forceSync,
	              style: { marginLeft: 7 }
	            })
	          )
	        )
	      );
	    }
	  }], [{
	    key: "getStores",
	    value: function getStores() {
	      return [_ExternalSyncStore2.default, _EventStore2.default, _PassBucketStore2.default, _CouponStore2.default, _TagStore2.default];
	    }
	  }, {
	    key: "getPropsFromStores",
	    value: function getPropsFromStores() {
	      var state = _ExternalSyncStore2.default.getState();
	      return _extends({
	        getExternalSyncById: _ExternalSyncStore2.default.getExternalSyncById
	      }, state);
	    }
	  }, {
	    key: "contextTypes",
	    get: function get() {
	      return {
	        router: _react2.default.PropTypes.object
	      };
	    }
	  }]);
	
	  return ExternalSync;
	}(_react2.default.Component);
	
	exports.default = (0, _connectToStores2.default)(ExternalSync);
	module.exports = exports["default"];

/***/ }),
/* 2851 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _connectToStores = __webpack_require__(1226);
	
	var _connectToStores2 = _interopRequireDefault(_connectToStores);
	
	var _ExternalSyncActions = __webpack_require__(2847);
	
	var _ExternalSyncActions2 = _interopRequireDefault(_ExternalSyncActions);
	
	var _ExternalSyncStore = __webpack_require__(2848);
	
	var _ExternalSyncStore2 = _interopRequireDefault(_ExternalSyncStore);
	
	var _workingIndicator = __webpack_require__(1664);
	
	var _workingIndicator2 = _interopRequireDefault(_workingIndicator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var NewExternalSync = function (_React$Component) {
	  _inherits(NewExternalSync, _React$Component);
	
	  function NewExternalSync(props) {
	    _classCallCheck(this, NewExternalSync);
	
	    return _possibleConstructorReturn(this, Object.getPrototypeOf(NewExternalSync).call(this, props));
	  }
	
	  _createClass(NewExternalSync, [{
	    key: "componentWillMount",
	    value: function componentWillMount() {
	      _ExternalSyncActions2.default.create({
	        event_bucket: this.props.params.eventBucketId
	      });
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(props) {
	      if (props.newExternalSyncId) {
	        this.context.router.replace("/event_buckets/" + props.params.eventBucketId + "/external_syncs/" + props.newExternalSyncId);
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement(_workingIndicator2.default, { fullPage: true });
	    }
	  }], [{
	    key: "getStores",
	    value: function getStores() {
	      return [_ExternalSyncStore2.default];
	    }
	  }, {
	    key: "getPropsFromStores",
	    value: function getPropsFromStores() {
	      return {
	        newExternalSyncId: _ExternalSyncStore2.default.getState().newExternalSyncId
	      };
	    }
	  }, {
	    key: "contextTypes",
	    get: function get() {
	      return {
	        router: _react2.default.PropTypes.object
	      };
	    }
	  }]);
	
	  return NewExternalSync;
	}(_react2.default.Component);
	
	exports.default = (0, _connectToStores2.default)(NewExternalSync);
	module.exports = exports["default"];

/***/ }),
/* 2852 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _values = __webpack_require__(1214);
	
	var _values2 = _interopRequireDefault(_values);
	
	var _reactRouter = __webpack_require__(486);
	
	var _materialUi = __webpack_require__(576);
	
	var _reactable = __webpack_require__(1688);
	
	var _util = __webpack_require__(1183);
	
	var util = _interopRequireWildcard(_util);
	
	var _connectToStores = __webpack_require__(1226);
	
	var _connectToStores2 = _interopRequireDefault(_connectToStores);
	
	var _PersonActions = __webpack_require__(2658);
	
	var _PersonActions2 = _interopRequireDefault(_PersonActions);
	
	var _PersonStore = __webpack_require__(2656);
	
	var _PersonStore2 = _interopRequireDefault(_PersonStore);
	
	var _UserStore = __webpack_require__(974);
	
	var _UserStore2 = _interopRequireDefault(_UserStore);
	
	var _workingIndicator = __webpack_require__(1664);
	
	var _workingIndicator2 = _interopRequireDefault(_workingIndicator);
	
	var _editPerson = __webpack_require__(2853);
	
	var _editPerson2 = _interopRequireDefault(_editPerson);
	
	var _EventBucketStore = __webpack_require__(1593);
	
	var _EventBucketStore2 = _interopRequireDefault(_EventBucketStore);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var People = function (_React$Component) {
	  _inherits(People, _React$Component);
	
	  function People(props) {
	    _classCallCheck(this, People);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(People).call(this, props));
	
	    _this.downloadCsv = _this.downloadCsv.bind(_this);
	    _this.state = {
	      page: 0
	    };
	    return _this;
	  }
	
	  _createClass(People, [{
	    key: "getStyles",
	    value: function getStyles() {
	      return {
	        actions: {
	          paddingTop: 20,
	          marginTop: 20,
	          borderTop: "1px solid #ccc"
	        }
	      };
	    }
	  }, {
	    key: "_makeRowForPerson",
	    value: function _makeRowForPerson(eventBucket, person) {
	      return {
	        Person: person.details.name ? person.details.name + " (" + person.details.email + ")" : person.details.email,
	        "Payment Method": person.details.payment_method_summary || "Not set",
	        Actions: _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement(
	            _reactRouter.Link,
	            {
	              to: eventBucket ? "/event_buckets/" + eventBucket + "/people/" + person.id : "/people/" + person.id
	            },
	            "View"
	          )
	        )
	      };
	    }
	  }, {
	    key: "downloadCsv",
	    value: function downloadCsv() {
	      var people = (0, _values2.default)(this.props.people),
	          eventBucket = this.props.params.eventBucketId;
	
	      if (eventBucket) {
	        people = people.filter(function (p) {
	          return p.event_buckets.some(function (b) {
	            return b === eventBucket;
	          });
	        });
	      }
	
	      var keys = ["id", "name", "email", "phone_number", "mailing_address", "facebook_user_id", "do_not_email", "payment_method_summary"],
	          peopleRows = people.map(function (p) {
	        return keys.map(function (k) {
	          return k === "id" ? p.id : p.details[k];
	        });
	      }),
	          csvRows = [keys].concat(peopleRows);
	
	      util.clientSideDownload("people" + (eventBucket ? "-" + eventBucket : "") + ".csv", "text/csv", util.makeCsv(csvRows));
	    }
	  }, {
	    key: "changePage",
	    value: function changePage(page) {
	      this.setState({ page: page });
	    }
	  }, {
	    key: "componentWillMount",
	    value: function componentWillMount() {
	      _PersonActions2.default.fetchAll();
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var styles = this.getStyles(),
	          people = (0, _values2.default)(this.props.people),
	          eventBucketId = this.props.params.eventBucketId,
	          eventBucket = _EventBucketStore2.default.getEventBucketById(eventBucketId); // restrict to a single event bucket
	
	      if (people.length === 0 && _PersonStore2.default.getState().isFetching) {
	        return _react2.default.createElement(_workingIndicator2.default, { fullPage: true });
	      }
	
	      if (eventBucketId) {
	        people = people.filter(function (p) {
	          return p.event_buckets.some(function (b) {
	            return b === eventBucketId;
	          });
	        });
	      }
	
	      var isSundance = _UserStore2.default.getUserId() === "632796a787711400538e66da" || _UserStore2.default.getUserId() === "5dae0d7c41443700308287c5" || eventBucket && eventBucket.frontend_config && eventBucket.frontend_config.sundance_login;
	
	      var rows = people.map(this._makeRowForPerson.bind(this, eventBucketId));
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          "h1",
	          { className: "page-title" },
	          "People"
	        ),
	        this.state.isCreating ? _react2.default.createElement(_editPerson2.default, {
	          onRequestClose: function onRequestClose() {
	            return _this2.setState({ isCreating: false });
	          },
	          isNew: true,
	          onEdit: function onEdit(data, opts) {
	            if (opts && opts.existingId) {
	              _PersonActions2.default.edit(opts.existingId, data);
	            } else {
	              _PersonActions2.default.create(Object.assign(data, eventBucketId && { event_bucket: eventBucketId }));
	            }
	            _this2.setState({ isCreating: false });
	          }
	        }) : null,
	        _UserStore2.default.hasPermission("manage_people") && !isSundance ? _react2.default.createElement(
	          "div",
	          { style: { float: "right", marginBottom: -36 } },
	          _react2.default.createElement(_materialUi.RaisedButton, {
	            label: "Create new person",
	            onTouchTap: function onTouchTap() {
	              return _this2.setState({ isCreating: true });
	            }
	          })
	        ) : null,
	        _react2.default.createElement(_reactable.Table, {
	          className: "bordered striped responsive-table",
	          data: rows,
	          sortable: [{ column: "Person", sortFunction: _reactable.Sort.CaseInsensitive }, "Payment Method"],
	          defaultSort: { column: "Person", direction: "asc" },
	          columns: ["Person", "Payment Method", "Actions"],
	          filterable: ["Person"],
	          filterPlaceholder: "Type to filter...",
	          itemsPerPage: rows.length && 50,
	          currentPage: this.state.page,
	          onPageChange: function onPageChange(p) {
	            return _this2.changePage(p);
	          }
	        }),
	        rows.length === 0 ? _react2.default.createElement(
	          "div",
	          { className: "empty-table-message" },
	          "No people yet. People will automatically appear here once they place an order."
	        ) : null,
	        _UserStore2.default.hasPermission("manage_people") ? _react2.default.createElement(
	          "div",
	          { style: styles.actions },
	          _react2.default.createElement(_materialUi.RaisedButton, { onTouchTap: this.downloadCsv, label: "Export CSV" }),
	          " ",
	          _react2.default.createElement(_materialUi.RaisedButton, {
	            style: { marginLeft: 7 },
	            onTouchTap: function onTouchTap() {
	              return _this2.context.router.push("/bulk_import_people");
	            },
	            label: "Bulk import people"
	          }),
	          _react2.default.createElement(
	            "p",
	            null,
	            "The exported CSV will contain all people",
	            eventBucketId ? " who have placed an order in this event bucket" : "",
	            "."
	          )
	        ) : null
	      );
	    }
	  }], [{
	    key: "getStores",
	    value: function getStores() {
	      return [_PersonStore2.default, _UserStore2.default, _EventBucketStore2.default];
	    }
	  }, {
	    key: "getPropsFromStores",
	    value: function getPropsFromStores() {
	      return _PersonStore2.default.getState();
	    }
	  }, {
	    key: "contextTypes",
	    get: function get() {
	      return {
	        router: _react2.default.PropTypes.object
	      };
	    }
	  }]);
	
	  return People;
	}(_react2.default.Component);
	
	exports.default = (0, _connectToStores2.default)(People);
	module.exports = exports["default"];

/***/ }),
/* 2853 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _materialUi = __webpack_require__(576);
	
	var _base = __webpack_require__(1755);
	
	var _base2 = _interopRequireDefault(_base);
	
	var _creditCardEntry = __webpack_require__(1713);
	
	var _creditCardEntry2 = _interopRequireDefault(_creditCardEntry);
	
	var _workingIndicator = __webpack_require__(1664);
	
	var _workingIndicator2 = _interopRequireDefault(_workingIndicator);
	
	var _linkLike = __webpack_require__(973);
	
	var _linkLike2 = _interopRequireDefault(_linkLike);
	
	var _connectToStores = __webpack_require__(1226);
	
	var _connectToStores2 = _interopRequireDefault(_connectToStores);
	
	var _PersonStore = __webpack_require__(2656);
	
	var _PersonStore2 = _interopRequireDefault(_PersonStore);
	
	var _PersonActions = __webpack_require__(2658);
	
	var _PersonActions2 = _interopRequireDefault(_PersonActions);
	
	var _UserStore = __webpack_require__(974);
	
	var _UserStore2 = _interopRequireDefault(_UserStore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var EditPersonOverlay = function (_React$Component) {
	  _inherits(EditPersonOverlay, _React$Component);
	
	  function EditPersonOverlay(props) {
	    _classCallCheck(this, EditPersonOverlay);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(EditPersonOverlay).call(this, props));
	
	    _this.state = {
	      name: "",
	      email: "",
	      phone_number: "",
	      mailing_address: "",
	      do_not_email: false,
	      payments_token: null,
	      isEditingPayment: false,
	      isSubmittingPayment: false
	    };
	
	    _this.edit = _this.edit.bind(_this);
	    _this.submitPayment = _this.submitPayment.bind(_this);
	    _this.clearPayment = _this.clearPayment.bind(_this);
	    _this.onAutocompleteInput = _this.onAutocompleteInput.bind(_this);
	    return _this;
	  }
	
	  _createClass(EditPersonOverlay, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      if (this.props.isNew) {
	        _PersonActions2.default.fetchAll.defer();
	      }
	      this.componentWillReceiveProps(this.props);
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(props) {
	      if (props.details) {
	        this.setState({
	          name: props.details.name,
	          email: props.details.email,
	          phone_number: props.details.phone_number,
	          mailing_address: props.details.mailing_address,
	          do_not_email: props.details.do_not_email,
	          payments_token: null,
	          payment_method_summary: props.details.payment_method_summary,
	          isEditingPayment: false,
	          isSubmittingPayment: false,
	          paymentErrorMessage: null
	        });
	      }
	
	      if (props.isNew) {
	        this.setState({
	          autocompletePeople: props.getPeople().map(function (p) {
	            return {
	              value: p,
	              text: "" + p.details.email + (p.details.name ? " (" + p.details.name + ")" : "")
	            };
	          })
	        });
	      }
	    }
	  }, {
	    key: "submitPayment",
	    value: function submitPayment() {
	      var _this2 = this;
	
	      this.setState({
	        isSubmittingPayment: true
	      });
	      Stripe.card.createToken(this.refs.cardEntry.getPaymentDetails(), function (status, response) {
	        if (response.error) {
	          _this2.setState({
	            isSubmittingPayment: false,
	            paymentErrorMessage: response.error.message
	          });
	        } else {
	          if (_this2.props.isNew) {
	            _this2.setState({
	              payments_token: response.id,
	              isEditingPayment: false,
	              isSubmittingPayment: false,
	              payment_method_summary: "Ready to save"
	            });
	          } else {
	            _this2.props.onEdit({
	              payments_token: response.id
	            }, { doNotClose: true });
	          }
	        }
	      });
	    }
	  }, {
	    key: "clearPayment",
	    value: function clearPayment() {
	      this.props.onEdit({
	        clear_payments_info: true
	      }, { doNotClose: true });
	    }
	  }, {
	    key: "edit",
	    value: function edit() {
	      var _state = this.state;
	      var name = _state.name;
	      var email = _state.email;
	      var phone_number = _state.phone_number;
	      var mailing_address = _state.mailing_address;
	      var do_not_email = _state.do_not_email;
	      var payments_token = _state.payments_token;
	
	      this.props.onEdit({
	        name: name,
	        email: email,
	        phone_number: phone_number,
	        mailing_address: mailing_address,
	        do_not_email: do_not_email,
	        payments_token: payments_token
	      }, { existingId: this.state.existingPerson && this.state.existingPerson.id });
	    }
	  }, {
	    key: "onAutocompleteInput",
	    value: function onAutocompleteInput(raw) {
	      if (raw && raw.value) {
	        this.selectPerson(raw.value);
	      } else {
	        this.setState({ email: raw });
	      }
	    }
	  }, {
	    key: "selectPerson",
	    value: function selectPerson(person) {
	      this.setState({
	        existingPerson: person,
	        name: person.details.name,
	        email: person.details.email,
	        phone_number: person.details.phone_number,
	        mailing_address: person.details.mailing_address,
	        do_not_email: person.details.do_not_email,
	        payment_method_summary: person.details.payment_method_summary
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this3 = this;
	
	      var _props = this.props;
	      var onRequestClose = _props.onRequestClose;
	      var isNew = _props.isNew;
	      var details = _props.details;
	      var _state2 = this.state;
	      var name = _state2.name;
	      var email = _state2.email;
	      var do_not_email = _state2.do_not_email;
	      var payment_method_summary = _state2.payment_method_summary;
	      var existingPerson = _state2.existingPerson;
	
	
	      return _react2.default.createElement(
	        _base2.default,
	        {
	          onRequestClose: onRequestClose,
	          useMuiDefaultStyle: true,
	          actions: [_react2.default.createElement(_materialUi.FlatButton, { label: "Cancel", onTouchTap: onRequestClose }), _react2.default.createElement(_materialUi.FlatButton, {
	            primary: true,
	            label: isNew && !existingPerson ? "Create person" : "Save changes",
	            onTouchTap: this.edit
	          })]
	        },
	        !isNew || existingPerson ? _react2.default.createElement(
	          "div",
	          null,
	          "Your changes will affect the customer's entire account.",
	          " ",
	          isNew ? _react2.default.createElement(
	            _linkLike2.default,
	            {
	              onTouchTap: function onTouchTap() {
	                _this3.setState({
	                  existingPerson: null,
	                  name: "",
	                  email: "",
	                  mailing_address: "",
	                  payments_token: null,
	                  payment_method_summary: null
	                });
	              }
	            },
	            "Reset"
	          ) : null
	        ) : _react2.default.createElement(
	          "div",
	          null,
	          "After creation, the new customer will receive an email with a link to set their password."
	        ),
	        details && details.sundance_user_id && !_UserStore2.default.isGod() ? _react2.default.createElement("div", { style: { marginTop: "1em" } }) : _react2.default.createElement(
	          "div",
	          { style: { marginTop: "1em" } },
	          isNew ? _react2.default.createElement(_materialUi.AutoComplete, {
	            floatingLabelText: "Customer email address*",
	            floatingLabelFixed: true,
	            dataSource: this.state.autocompletePeople || [],
	            searchText: this.state.email,
	            filter: function filter(searchText, key) {
	              return searchText && key.toLowerCase().indexOf(searchText.toLowerCase()) !== -1;
	            },
	            maxSearchResults: 5,
	            menuProps: { desktop: true, autoWidth: true, width: "auto" },
	            style: { width: 256, display: "inline-block" },
	            textFieldStyle: { width: 256 },
	            fullWidth: true,
	            onNewRequest: this.onAutocompleteInput,
	            onUpdateInput: this.onAutocompleteInput
	          }) : _react2.default.createElement(_materialUi.TextField, {
	            value: this.state.email,
	            floatingLabelText: "Customer email address",
	            floatingLabelFixed: true,
	            onChange: function onChange(e) {
	              return _this3.setState({ email: e.target.value });
	            }
	          }),
	          _react2.default.createElement(_materialUi.TextField, {
	            value: this.state.name,
	            floatingLabelText: "Customer name",
	            floatingLabelFixed: true,
	            style: { marginLeft: "1em" },
	            onChange: function onChange(e) {
	              return _this3.setState({ name: e.target.value });
	            }
	          })
	        ),
	        _react2.default.createElement(
	          "div",
	          {
	            style: {
	              marginTop: "-0.5em",
	              marginBottom: (this.state.mailing_address || "").indexOf("\n") !== -1 ? "2em" : 0
	            }
	          },
	          _react2.default.createElement(_materialUi.TextField, {
	            value: this.state.phone_number,
	            floatingLabelText: "Customer phone number",
	            floatingLabelFixed: true,
	            onChange: function onChange(e) {
	              return _this3.setState({ phone_number: e.target.value });
	            }
	          }),
	          _react2.default.createElement(
	            "div",
	            {
	              style: {
	                marginLeft: "1em",
	                display: "inline-block",
	                position: "absolute"
	              }
	            },
	            _react2.default.createElement(_materialUi.TextField, {
	              style: { textAlign: "left" },
	              floatingLabelText: "Customer mailing address",
	              floatingLabelFixed: true,
	              rowsMax: 2,
	              multiLine: true,
	              value: this.state.mailing_address,
	              onChange: function onChange(e) {
	                return _this3.setState({ mailing_address: e.target.value });
	              }
	            })
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { style: { marginTop: "1em" } },
	          _react2.default.createElement(_materialUi.Checkbox, {
	            label: "Unsubscribe from promotional emails",
	            checked: this.state.do_not_email,
	            onCheck: function onCheck() {
	              return _this3.setState({ do_not_email: !_this3.state.do_not_email });
	            }
	          })
	        ),
	        _react2.default.createElement(
	          "div",
	          { style: { marginTop: "1em" } },
	          this.state.isEditingPayment ? _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(_creditCardEntry2.default, {
	              style: { maxWidth: 620, marginTop: -20, marginBottom: 12 },
	              ref: "cardEntry"
	            }),
	            this.state.paymentErrorMessage ? _react2.default.createElement(
	              "div",
	              {
	                style: {
	                  color: "red",
	                  fontSize: "0.75em",
	                  marginBottom: "0.5em"
	                }
	              },
	              this.state.paymentErrorMessage
	            ) : null,
	            _react2.default.createElement(_materialUi.RaisedButton, {
	              primary: true,
	              label: this.state.isSubmittingPayment ? "Updating payment method" : "Update payment method",
	              disabled: this.state.isSubmittingPayment,
	              onTouchTap: function onTouchTap() {
	                return _this3.submitPayment();
	              }
	            }),
	            payment_method_summary ? _react2.default.createElement(_materialUi.RaisedButton, {
	              style: { marginLeft: 7 },
	              label: "Delete saved payment method",
	              onTouchTap: function onTouchTap() {
	                return _this3.clearPayment();
	              }
	            }) : null,
	            _react2.default.createElement(_materialUi.RaisedButton, {
	              style: { marginLeft: 7 },
	              label: "Cancel",
	              onTouchTap: function onTouchTap() {
	                return _this3.setState({ isEditingPayment: false });
	              }
	            })
	          ) : _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(
	              "div",
	              { style: { marginBottom: 5 } },
	              "Current payment method:",
	              " ",
	              _react2.default.createElement(
	                "strong",
	                null,
	                payment_method_summary || "None specified"
	              )
	            ),
	            _react2.default.createElement(_materialUi.RaisedButton, {
	              label: "Edit payment method",
	              onTouchTap: function onTouchTap() {
	                return _this3.setState({ isEditingPayment: true });
	              }
	            })
	          )
	        )
	      );
	    }
	  }], [{
	    key: "getStores",
	    value: function getStores() {
	      return [_PersonStore2.default];
	    }
	  }, {
	    key: "getPropsFromStores",
	    value: function getPropsFromStores() {
	      return {
	        getPeople: _PersonStore2.default.getPeople
	      };
	    }
	  }]);
	
	  return EditPersonOverlay;
	}(_react2.default.Component);
	
	exports.default = (0, _connectToStores2.default)(EditPersonOverlay);
	module.exports = exports["default"];

/***/ }),
/* 2854 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDropzone = __webpack_require__(1780);
	
	var _reactDropzone2 = _interopRequireDefault(_reactDropzone);
	
	var _materialUi = __webpack_require__(576);
	
	var _reactable = __webpack_require__(1688);
	
	var _connectToStores = __webpack_require__(1226);
	
	var _connectToStores2 = _interopRequireDefault(_connectToStores);
	
	var _BulkImportActions = __webpack_require__(2688);
	
	var _BulkImportActions2 = _interopRequireDefault(_BulkImportActions);
	
	var _BulkImportStore = __webpack_require__(2689);
	
	var _BulkImportStore2 = _interopRequireDefault(_BulkImportStore);
	
	var _infoNotice = __webpack_require__(1599);
	
	var _infoNotice2 = _interopRequireDefault(_infoNotice);
	
	var _checkCircle = __webpack_require__(877);
	
	var _checkCircle2 = _interopRequireDefault(_checkCircle);
	
	var _error = __webpack_require__(948);
	
	var _error2 = _interopRequireDefault(_error);
	
	var _config = __webpack_require__(1173);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _injectedSelect = __webpack_require__(1874);
	
	var _injectedSelect2 = _interopRequireDefault(_injectedSelect);
	
	var _label = __webpack_require__(1682);
	
	var _label2 = _interopRequireDefault(_label);
	
	var _quillEditor = __webpack_require__(2169);
	
	var _quillEditor2 = _interopRequireDefault(_quillEditor);
	
	var _linkLike = __webpack_require__(973);
	
	var _linkLike2 = _interopRequireDefault(_linkLike);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BulkImportPeople = function (_React$Component) {
	  _inherits(BulkImportPeople, _React$Component);
	
	  function BulkImportPeople(props) {
	    _classCallCheck(this, BulkImportPeople);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(BulkImportPeople).call(this, props));
	
	    _this.state = {
	      selectedEventBucket: null,
	      subjectLine: "",
	      introMessage: "",
	      extraMessage: "",
	      skipExisting: false,
	      csvFile: null,
	      userReadyToImport: false
	    };
	
	    _this.reset = _this.reset.bind(_this);
	    _this.onDrop = _this.onDrop.bind(_this);
	    _this.import = _this.import.bind(_this);
	    return _this;
	  }
	
	  _createClass(BulkImportPeople, [{
	    key: "getStyles",
	    value: function getStyles() {
	      var _dropzone;
	
	      return {
	        progressContainer: {
	          margin: "0 auto",
	          textAlign: "center",
	          padding: 10
	        },
	        restartLink: {
	          textDecoration: "underline",
	          cursor: "pointer",
	          paddingLeft: 2
	        },
	        icon: {
	          width: 80,
	          height: "auto",
	          color: "rgb(2, 136, 209)"
	        },
	        message: {
	          marginTop: 10
	        },
	        dropzone: (_dropzone = {
	          padding: 20,
	          lineHeight: "1.25"
	        }, _defineProperty(_dropzone, "padding", 10), _defineProperty(_dropzone, "border", "1px dashed #ccc"), _defineProperty(_dropzone, "cursor", "pointer"), _dropzone),
	        actions: {
	          marginTop: 10
	        },
	        previewExtraMessage: {
	          padding: 20,
	          border: "1px dashed #ccc"
	        }
	      };
	    }
	  }, {
	    key: "componentWillMount",
	    value: function componentWillMount() {
	      this.reset();
	    }
	  }, {
	    key: "reset",
	    value: function reset() {
	      this.setState({
	        userReadyToImport: false
	      });
	      _BulkImportActions2.default.reset.defer();
	    }
	  }, {
	    key: "onDrop",
	    value: function onDrop(files) {
	      if (!files.length) {
	        return;
	      }
	      this.setState({
	        csvFile: files[0]
	      });
	    }
	  }, {
	    key: "import",
	    value: function _import() {
	      _BulkImportActions2.default.importPeople({
	        eventBucket: this.state.selectedEventBucket.id,
	        subjectLine: this.state.subjectLine,
	        introMessage: this.state.introMessage,
	        extraMessage: this.state.extraMessage,
	        skipExisting: this.state.skipExisting,
	        csvFile: this.state.csvFile,
	        preview: !this.state.userReadyToImport
	      });
	      window.scrollTo(0, 0);
	    }
	  }, {
	    key: "_makeCsvLink",
	    value: function _makeCsvLink() {
	      return _config2.default.endpoint + "bulk_import/example/people";
	    }
	  }, {
	    key: "_makeTable",
	    value: function _makeTable(people) {
	      return _react2.default.createElement(_reactable.Table, {
	        className: "bordered striped responsive-table",
	        columns: [{ key: "name", label: "Name" }, { key: "email", label: "Email" }, { key: "phone_number", label: "Phone number" }, { key: "mailing_address", label: "Mailing address" }, { key: "images", label: "Supplementary data images" }, { key: "notes", label: "Notes" }, { key: "errors", label: "Errors" }],
	        data: people.map(function (p) {
	          return {
	            name: p.person.name,
	            email: p.person.email,
	            phone_number: p.person.phone_number,
	            mailing_address: p.person.mailing_address,
	            images: _react2.default.createElement(
	              "div",
	              null,
	              p.person.supplementary_data_images.map(function (url) {
	                return _react2.default.createElement(
	                  "a",
	                  { href: url, target: "_blank" },
	                  _react2.default.createElement("img", { src: url, style: { height: 20 } })
	                );
	              })
	            ),
	            notes: _react2.default.createElement("div", {
	              dangerouslySetInnerHTML: { __html: p.person._note },
	              className: "tenant-injected-html"
	            }),
	            errors: p.errors.join(", ")
	          };
	        })
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props;
	      var isImporting = _props.isImporting;
	      var importCompleted = _props.importCompleted;
	      var importSuccessful = _props.importSuccessful;
	      var importMessage = _props.importMessage;
	      var importOrder = _props.importOrder;
	      var previewData = _props.previewData;
	      var styles = this.getStyles();
	
	      if (isImporting || importCompleted && !previewData) {
	        return _react2.default.createElement(
	          "div",
	          { style: styles.progressContainer },
	          isImporting ? _react2.default.createElement(_materialUi.CircularProgress, { size: 1.5, mode: "indeterminate" }) : importSuccessful ? _react2.default.createElement(_checkCircle2.default, { style: styles.icon }) : _react2.default.createElement(_error2.default, { style: styles.icon }),
	          _react2.default.createElement(
	            "div",
	            { style: styles.message },
	            isImporting ? _react2.default.createElement(
	              "div",
	              null,
	              this.state.userReadyToImport ? "Importing" : "Previewing",
	              " ",
	              "people...",
	              _react2.default.createElement("br", null),
	              "This may take a little while."
	            ) : importMessage,
	            !isImporting ? _react2.default.createElement(
	              "a",
	              { style: styles.restartLink, onTouchTap: this.reset },
	              "(restart)"
	            ) : null
	          )
	        );
	      }
	
	      if (previewData && this.state.selectedEventBucket) {
	        return _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement(
	            "p",
	            null,
	            "We detected ",
	            previewData.people.length,
	            " people in your uploaded data. Have a look:"
	          ),
	          this._makeTable(previewData.people),
	          _react2.default.createElement(
	            "p",
	            null,
	            "Each individual in the above list will receive an email with the subject \"",
	            _react2.default.createElement(
	              "b",
	              null,
	              previewData.subject
	            ),
	            "\" that in addition to instructions about logging in also contains the following content:"
	          ),
	          _react2.default.createElement("div", {
	            className: "tenant-injected-html",
	            style: styles.previewExtraMessage,
	            dangerouslySetInnerHTML: {
	              __html: previewData.body || "<i>[No additional message will be attached]</i>"
	            }
	          }),
	          _react2.default.createElement(
	            "p",
	            null,
	            "If everything looks all right, confirm & start the import. Otherwise,",
	            " ",
	            _react2.default.createElement(
	              _linkLike2.default,
	              { onTouchTap: this.reset },
	              "edit settings"
	            ),
	            "."
	          ),
	          _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(_materialUi.Checkbox, {
	              label: "Yes, I'm ready to import " + previewData.people.length + " people & send associated emails.",
	              checked: this.state.userReadyToImport,
	              onCheck: function onCheck() {
	                return _this2.setState({
	                  userReadyToImport: !_this2.state.userReadyToImport
	                });
	              }
	            })
	          ),
	          _react2.default.createElement(
	            "div",
	            { style: styles.actions },
	            _react2.default.createElement(_materialUi.RaisedButton, {
	              label: "Start import",
	              primary: true,
	              disabled: !this.state.userReadyToImport,
	              onTouchTap: this.import
	            })
	          )
	        );
	      }
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          "h1",
	          null,
	          "Bulk import people"
	        ),
	        _react2.default.createElement(
	          _infoNotice2.default,
	          { style: { marginTop: 20 } },
	          "Check out our",
	          " ",
	          _react2.default.createElement(
	            "a",
	            {
	              href: "https://help.eventive.org/people/bulk-import-people",
	              target: "_blank"
	            },
	            "guide to importing people"
	          ),
	          "."
	        ),
	        _react2.default.createElement(
	          "p",
	          null,
	          "Use this wizard to import people in bulk. Just download the Excel template, fill in your data, and upload. Every user will receive an email notifying them about their new account\u2014you can use the \"additional note\" field to explain why they're receiving it."
	        ),
	        _react2.default.createElement(
	          "p",
	          null,
	          _react2.default.createElement(
	            "i",
	            null,
	            "Note: If you're trying to import passholders (e.g. everyone being imported receives a free pass), use our",
	            " ",
	            _react2.default.createElement(
	              "a",
	              {
	                href: "https://help.eventive.org/passes/bulk-import-passes",
	                target: "_blank"
	              },
	              "bulk pass import"
	            ),
	            " ",
	            "tool instead."
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement(_injectedSelect2.default, {
	            value: this.state.selectedEventBucket && this.state.selectedEventBucket.id,
	            types: ["event_buckets"],
	            label: "Event bucket to use in link to activate account",
	            labelFormatter: function labelFormatter(b) {
	              return b.name;
	            },
	            changeValueFunction: function changeValueFunction(o) {
	              return o;
	            },
	            onChange: function onChange(selected) {
	              return _this2.setState({ selectedEventBucket: selected });
	            }
	          })
	        ),
	        _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement(
	            _label2.default,
	            null,
	            "Add spreadsheet (",
	            _react2.default.createElement(
	              "a",
	              { target: "_blank", href: this._makeCsvLink() },
	              "download template"
	            ),
	            ")"
	          ),
	          _react2.default.createElement(
	            _reactDropzone2.default,
	            {
	              style: styles.dropzone,
	              multiple: false,
	              onDrop: this.onDrop
	            },
	            function (_ref) {
	              var isDragActive = _ref.isDragActive;
	              var isDragReject = _ref.isDragReject;
	              var acceptedFiles = _ref.acceptedFiles;
	              var rejectedFiles = _ref.rejectedFiles;
	
	              return isDragActive ? "Release to select." : acceptedFiles.length ? _react2.default.createElement(
	                "span",
	                null,
	                "One spreadsheet ",
	                _react2.default.createElement(
	                  "i",
	                  null,
	                  "(",
	                  acceptedFiles[0].name,
	                  ")"
	                ),
	                " ready to import."
	              ) : "Drop spreadsheet here, or click to select.";
	            }
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement(_materialUi.TextField, {
	            value: this.state.subjectLine,
	            floatingLabelText: "Subject line",
	            floatingLabelFixed: true,
	            fullWidth: true,
	            onChange: function onChange(e) {
	              return _this2.setState({ subjectLine: e.target.value });
	            }
	          })
	        ),
	        _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement(
	            _label2.default,
	            null,
	            "Email notification introduction"
	          ),
	          _react2.default.createElement(_quillEditor2.default, {
	            value: this.state.introMessage,
	            onChange: function onChange(v) {
	              return _this2.setState({ introMessage: v });
	            },
	            basic: true
	          })
	        ),
	        _react2.default.createElement(
	          "p",
	          null,
	          _react2.default.createElement(
	            "i",
	            null,
	            "[\"Click here to activate your account\" link will be inserted between introduction & additional content]"
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement(
	            _label2.default,
	            null,
	            "Additional email content"
	          ),
	          _react2.default.createElement(_quillEditor2.default, {
	            value: this.state.extraMessage,
	            onChange: function onChange(v) {
	              return _this2.setState({ extraMessage: v });
	            },
	            basic: true
	          })
	        ),
	        _react2.default.createElement(
	          "div",
	          { style: { margin: "2em 0" } },
	          _react2.default.createElement(_materialUi.Checkbox, {
	            label: "Do not email existing customers",
	            checked: this.state.skipExisting,
	            onCheck: function onCheck() {
	              return _this2.setState({ skipExisting: !_this2.state.skipExisting });
	            }
	          })
	        ),
	        _react2.default.createElement(
	          "div",
	          { style: styles.actions },
	          _react2.default.createElement(_materialUi.RaisedButton, {
	            label: "Preview import...",
	            primary: true,
	            disabled: !(this.state.selectedEventBucket && this.state.csvFile),
	            onTouchTap: this.import
	          })
	        )
	      );
	    }
	  }], [{
	    key: "getStores",
	    value: function getStores() {
	      return [_BulkImportStore2.default];
	    }
	  }, {
	    key: "getPropsFromStores",
	    value: function getPropsFromStores() {
	      return _BulkImportStore2.default.getState();
	    }
	  }, {
	    key: "contextTypes",
	    get: function get() {
	      return {
	        router: _react2.default.PropTypes.object
	      };
	    }
	  }]);
	
	  return BulkImportPeople;
	}(_react2.default.Component);
	
	exports.default = (0, _connectToStores2.default)(BulkImportPeople);
	module.exports = exports["default"];

/***/ }),
/* 2855 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _radium = __webpack_require__(1600);
	
	var _radium2 = _interopRequireDefault(_radium);
	
	var _reactRouter = __webpack_require__(486);
	
	var _materialUi = __webpack_require__(576);
	
	var _reactAvatar = __webpack_require__(2856);
	
	var _reactAvatar2 = _interopRequireDefault(_reactAvatar);
	
	var _util = __webpack_require__(1183);
	
	var util = _interopRequireWildcard(_util);
	
	var _workingIndicator = __webpack_require__(1664);
	
	var _workingIndicator2 = _interopRequireDefault(_workingIndicator);
	
	var _notes = __webpack_require__(2884);
	
	var _notes2 = _interopRequireDefault(_notes);
	
	var _passTable = __webpack_require__(2738);
	
	var _passTable2 = _interopRequireDefault(_passTable);
	
	var _ticketTable = __webpack_require__(2694);
	
	var _ticketTable2 = _interopRequireDefault(_ticketTable);
	
	var _orderTable = __webpack_require__(2764);
	
	var _orderTable2 = _interopRequireDefault(_orderTable);
	
	var _linkLike = __webpack_require__(973);
	
	var _linkLike2 = _interopRequireDefault(_linkLike);
	
	var _editPerson = __webpack_require__(2853);
	
	var _editPerson2 = _interopRequireDefault(_editPerson);
	
	var _personLatestInfo = __webpack_require__(2890);
	
	var _personLatestInfo2 = _interopRequireDefault(_personLatestInfo);
	
	var _creditsWidget = __webpack_require__(2893);
	
	var _creditsWidget2 = _interopRequireDefault(_creditsWidget);
	
	var _connectToStores = __webpack_require__(1226);
	
	var _connectToStores2 = _interopRequireDefault(_connectToStores);
	
	var _PersonActions = __webpack_require__(2658);
	
	var _PersonActions2 = _interopRequireDefault(_PersonActions);
	
	var _PersonStore = __webpack_require__(2656);
	
	var _PersonStore2 = _interopRequireDefault(_PersonStore);
	
	var _PassActions = __webpack_require__(2047);
	
	var _PassActions2 = _interopRequireDefault(_PassActions);
	
	var _PassStore = __webpack_require__(2048);
	
	var _PassStore2 = _interopRequireDefault(_PassStore);
	
	var _TicketActions = __webpack_require__(2697);
	
	var _TicketActions2 = _interopRequireDefault(_TicketActions);
	
	var _TicketStore = __webpack_require__(2706);
	
	var _TicketStore2 = _interopRequireDefault(_TicketStore);
	
	var _OrderActions = __webpack_require__(1220);
	
	var _OrderActions2 = _interopRequireDefault(_OrderActions);
	
	var _OrderStore = __webpack_require__(2050);
	
	var _OrderStore2 = _interopRequireDefault(_OrderStore);
	
	var _EventBucketStore = __webpack_require__(1593);
	
	var _EventBucketStore2 = _interopRequireDefault(_EventBucketStore);
	
	var _UserStore = __webpack_require__(974);
	
	var _UserStore2 = _interopRequireDefault(_UserStore);
	
	var _GodActions = __webpack_require__(1748);
	
	var _GodActions2 = _interopRequireDefault(_GodActions);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BUCKET_VIEW_ALL = "view_all";
	
	var Person = function (_React$Component) {
	  _inherits(Person, _React$Component);
	
	  function Person(props) {
	    _classCallCheck(this, Person);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(Person).call(this, props));
	
	    _this.state = {
	      isFetchingPerson: false,
	      fetchedPerson: null,
	      showEditor: false
	    };
	    return _this;
	  }
	
	  _createClass(Person, [{
	    key: "getStyles",
	    value: function getStyles() {
	      return {
	        content: {
	          display: "flex"
	        },
	        sidebar: {
	          minWidth: 336,
	          maxWidth: 336,
	          padding: "0 2px",
	          marginRight: 22
	        },
	        sidebarInner: {
	          paddingBottom: "1em"
	        },
	        main: {
	          flex: 1
	        }
	      };
	    }
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.componentWillReceiveProps(this.props);
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(newProps) {
	      var person = newProps.getPersonById(newProps.params.personId);
	
	      if (!this.state.isFetchingPerson && this.state.fetchedPerson !== newProps.params.personId) {
	        this.setState({ isFetchingPerson: true });
	        _PersonActions2.default.fetchOne(newProps.params.personId);
	        _PassActions2.default.fetchAllForPerson(newProps.params.personId);
	        _TicketActions2.default.fetchAllForPerson(newProps.params.personId);
	        _OrderActions2.default.fetchAllForPerson(newProps.params.personId);
	      } else if (person) {
	        this.setState({ isFetchingPerson: false, fetchedPerson: person.id });
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this,
	          _ref;
	
	      var styles = this.getStyles(),
	          currentEventBucket = this.props.params.eventBucketId,
	          // restrict to a single event bucket
	      person = this.props.getPersonById(this.props.params.personId),
	          passes = this.props.getPassesForPerson(this.props.params.personId, currentEventBucket),
	          tickets = this.props.getTicketsForPerson(this.props.params.personId, currentEventBucket),
	          orders = this.props.getOrdersForPerson(this.props.params.personId, currentEventBucket);
	
	      if (!person || this.state.isFetchingPerson) {
	        return _react2.default.createElement(_workingIndicator2.default, { fullPage: true });
	      }
	
	      var bucketOptions = [BUCKET_VIEW_ALL].concat(person.event_buckets),
	          selectedBucketOption = currentEventBucket || BUCKET_VIEW_ALL;
	
	      // In case someone logs in but never orders - fallback event bucket to place their
	      // "New Box Office Order" from
	      var fallbackEventBucketId = void 0;
	      if (!this.props.params.eventBucketId) {
	        var allBuckets = _EventBucketStore2.default.getEventBuckets();
	        fallbackEventBucketId = allBuckets.length ? allBuckets[0].id : undefined;
	      }
	
	      var eventBucketIdForSidebar = this.props.params.eventBucketId || person.event_buckets[person.event_buckets.length - 1] || fallbackEventBucketId;
	
	      var showCredits = currentEventBucket && (_EventBucketStore2.default.getEventBucketById(currentEventBucket) || {}).credits_enabled;
	
	      // Needed for isSundance check
	      var fullEventBucket = _EventBucketStore2.default.getEventBucketById(currentEventBucket);
	
	      var isMembership = false;
	      if (fullEventBucket) {
	        isMembership = fullEventBucket.frontend_config.memberships_enabled;
	      }
	
	      return _react2.default.createElement(
	        "div",
	        { style: styles.content },
	        this.state.showEditor ? _react2.default.createElement(_editPerson2.default, {
	          onRequestClose: function onRequestClose() {
	            return _this2.setState({ showEditor: false });
	          },
	          details: person.details,
	          onEdit: function onEdit(data, opts) {
	            _PersonActions2.default.edit(person.id, data);
	            if (!opts || !opts.doNotClose) {
	              _this2.setState({ showEditor: false });
	            }
	          }
	        }) : null,
	        _react2.default.createElement(
	          "div",
	          { style: styles.sidebar },
	          _react2.default.createElement(
	            "div",
	            { style: styles.sidebarInner },
	            _react2.default.createElement(_reactAvatar2.default, {
	              style: { margin: "0 auto", display: "block" },
	              name: person.details.name || person.details.email,
	              facebookId: person.details.facebook_user_id,
	              size: 100,
	              round: true
	            }),
	            _react2.default.createElement(
	              "h1",
	              {
	                style: {
	                  lineHeight: 1,
	                  textAlign: "center",
	                  overflowWrap: "break-word"
	                }
	              },
	              person.details.name ? person.details.name : person.details.email
	            ),
	            _react2.default.createElement(
	              "div",
	              null,
	              _react2.default.createElement(
	                "div",
	                null,
	                _react2.default.createElement(
	                  "strong",
	                  null,
	                  "Name:"
	                ),
	                " ",
	                person.details.name || "None provided"
	              ),
	              _react2.default.createElement(
	                "div",
	                null,
	                _react2.default.createElement(
	                  "strong",
	                  null,
	                  "Email:"
	                ),
	                " ",
	                _react2.default.createElement(
	                  "a",
	                  { href: "mailto:" + person.details.email },
	                  person.details.email
	                )
	              ),
	              person.details.sundance_user_id ? _react2.default.createElement(
	                "div",
	                null,
	                person.details.sundance_user_id === "__SHADOW__" ? _react2.default.createElement(
	                  "div",
	                  {
	                    style: (_ref = {
	                      background: "red",
	                      padding: "0 2px",
	                      color: "#fff",
	                      lineHeight: "1.25em"
	                    }, _defineProperty(_ref, "padding", 5), _defineProperty(_ref, "borderRadius", "0.25em"), _defineProperty(_ref, "margin", "5px 0"), _ref)
	                  },
	                  _react2.default.createElement(
	                    "strong",
	                    null,
	                    "User has not yet logged in:"
	                  ),
	                  " Not yet connected to a Sundance SSO account. User must login with the above email to claim access."
	                ) : _react2.default.createElement(
	                  "div",
	                  null,
	                  _react2.default.createElement(
	                    "strong",
	                    null,
	                    "Sundance user ID:"
	                  ),
	                  " ",
	                  person.details.sundance_user_id || "None provided"
	                ),
	                _react2.default.createElement(
	                  "div",
	                  null,
	                  _react2.default.createElement(
	                    "strong",
	                    null,
	                    "Password:"
	                  ),
	                  " No password \u2013 login with Sundance"
	                )
	              ) : person.details.cannes_accreditation_id ? _react2.default.createElement(
	                "div",
	                null,
	                _react2.default.createElement(
	                  "div",
	                  null,
	                  _react2.default.createElement(
	                    "strong",
	                    null,
	                    "Cannes accreditation ID:"
	                  ),
	                  " ",
	                  person.details.cannes_accreditation_id || "None provided"
	                ),
	                _react2.default.createElement(
	                  "div",
	                  null,
	                  _react2.default.createElement(
	                    "strong",
	                    null,
	                    "Password:"
	                  ),
	                  " No password \u2013 login with Cannes"
	                )
	              ) : person.details.eventival_person_id ? _react2.default.createElement(
	                "div",
	                null,
	                _react2.default.createElement(
	                  "div",
	                  null,
	                  _react2.default.createElement(
	                    "strong",
	                    null,
	                    "Eventival person ID:"
	                  ),
	                  " ",
	                  person.details.eventival_person_id || "None provided"
	                ),
	                _react2.default.createElement(
	                  "div",
	                  null,
	                  _react2.default.createElement(
	                    "strong",
	                    null,
	                    "Password:"
	                  ),
	                  " No password \u2013 login with Eventival"
	                )
	              ) : person.details.ida_user_id ? _react2.default.createElement(
	                "div",
	                null,
	                _react2.default.createElement(
	                  "div",
	                  null,
	                  _react2.default.createElement(
	                    "strong",
	                    null,
	                    "MyIDA account ID:"
	                  ),
	                  " ",
	                  person.details.ida_user_id || "None provided"
	                ),
	                _react2.default.createElement(
	                  "div",
	                  null,
	                  _react2.default.createElement(
	                    "strong",
	                    null,
	                    "Password:"
	                  ),
	                  " No password \u2013 login with IDA"
	                )
	              ) : person.details.whitelabel_user_id ? _react2.default.createElement(
	                "div",
	                null,
	                _react2.default.createElement(
	                  "strong",
	                  null,
	                  "Password:"
	                ),
	                " No password \u2013 whitelabel integration"
	              ) : person.details.aarp_user_id ? _react2.default.createElement(
	                "div",
	                null,
	                _react2.default.createElement(
	                  "strong",
	                  null,
	                  "Password:"
	                ),
	                " No password \u2013 login with AARP"
	              ) : _react2.default.createElement(
	                "div",
	                null,
	                _react2.default.createElement(
	                  "strong",
	                  null,
	                  "Password:"
	                ),
	                " \u2022\u2022\u2022\u2022\u2022\u2022 (",
	                _react2.default.createElement(
	                  _linkLike2.default,
	                  {
	                    onTouchTap: function onTouchTap() {
	                      return window.confirm("Are you sure you would like to send a password reset link to \"" + person.details.email + "\"?") && _PersonActions2.default.forgotPassword({
	                        id: person.id,
	                        event_bucket: eventBucketIdForSidebar
	                      });
	                    }
	                  },
	                  "email password reset link"
	                ),
	                ")"
	              ),
	              _react2.default.createElement(
	                "div",
	                null,
	                _react2.default.createElement(
	                  "strong",
	                  null,
	                  "Payment method:"
	                ),
	                " ",
	                person.details.payment_method_summary || "None set"
	              ),
	              _react2.default.createElement(
	                "div",
	                { style: { marginTop: "0.5em", whiteSpace: "nowrap" } },
	                _react2.default.createElement(_materialUi.FlatButton, {
	                  primary: true,
	                  onTouchTap: function onTouchTap() {
	                    return _this2.setState({ showEditor: true });
	                  },
	                  label: "Edit details",
	                  style: {
	                    border: "1px solid",
	                    verticalAlign: -1,
	                    marginRight: 7
	                  },
	                  labelStyle: { verticalAlign: "0px" }
	                }),
	                _react2.default.createElement(_materialUi.RaisedButton, {
	                  label: "New box office order",
	                  primary: true,
	                  onTouchTap: function onTouchTap() {
	                    return _this2.context.router.push({
	                      pathname: "/event_buckets/" + eventBucketIdForSidebar + "/box_office",
	                      query: { person: person.id }
	                    });
	                  }
	                })
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              null,
	              _react2.default.createElement(
	                _materialUi.Paper,
	                {
	                  zDepth: 1,
	                  style: {
	                    marginTop: "1em",
	                    marginBottom: "1em",
	                    padding: 10,
	                    textAlign: "left"
	                  }
	                },
	                _react2.default.createElement(_personLatestInfo2.default, { personId: person.id })
	              )
	            ),
	            _react2.default.createElement(
	              "h2",
	              null,
	              "Notes"
	            ),
	            _react2.default.createElement(_notes2.default, { person: person.id })
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { style: styles.main },
	          person.event_buckets.length ? _react2.default.createElement(
	            "div",
	            null,
	            bucketOptions.map(function (b) {
	              var bucket = _this2.props.getEventBucketById(b) || {},
	                  name = b === BUCKET_VIEW_ALL ? "View all" : bucket.name || "Deleted event bucket";
	
	              return selectedBucketOption === b ? _react2.default.createElement(_materialUi.FlatButton, {
	                style: {
	                  border: "1px solid #ccc",
	                  backgroundColor: "#ccc",
	                  color: "#fff",
	                  marginRight: 5,
	                  marginTop: "5px"
	                },
	                labelStyle: { verticalAlign: 0 },
	                label: name,
	                disabled: true
	              }) : _react2.default.createElement(
	                _reactRouter.Link,
	                {
	                  to: b === BUCKET_VIEW_ALL ? "/people/" + person.id : "/event_buckets/" + b + "/people/" + person.id
	                },
	                _react2.default.createElement(_materialUi.FlatButton, {
	                  label: name,
	                  style: {
	                    border: "1px solid",
	                    marginTop: "5px",
	                    marginRight: 5
	                  },
	                  labelStyle: { verticalAlign: 0 }
	                })
	              );
	            })
	          ) : null,
	          showCredits ? _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(_creditsWidget2.default, {
	              showHeader: true,
	              headerStyle: { marginTop: 25 },
	              person: person.id,
	              eventBucket: currentEventBucket
	            })
	          ) : null,
	          _react2.default.createElement(
	            "h2",
	            { style: { marginTop: 25 } },
	            "Passes"
	          ),
	          _react2.default.createElement(_passTable2.default, {
	            passes: passes.filter(function (pass) {
	              return !pass.pass_bucket.is_membership;
	            }),
	            person: person.details,
	            isSinglePerson: true,
	            eventBucket: passes.length && passes[0].event_bucket,
	            isSundance: fullEventBucket && fullEventBucket.frontend_config ? fullEventBucket.frontend_config.sundance_login : false,
	            showTransferHistory: fullEventBucket && fullEventBucket.frontend_config ? fullEventBucket.frontend_config.enable_transfer_history : false,
	            location: this.props.location
	          }),
	          isMembership && _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(
	              "h2",
	              { style: { marginTop: 25 } },
	              "Memberships"
	            ),
	            _react2.default.createElement(_passTable2.default, {
	              passes: passes.filter(function (pass) {
	                return pass.pass_bucket.is_membership;
	              }),
	              person: person.details,
	              isSinglePerson: true,
	              eventBucket: passes.length && passes[0].event_bucket,
	              isSundance: fullEventBucket && fullEventBucket.frontend_config ? fullEventBucket.frontend_config.sundance_login : false,
	              location: this.props.location,
	              isMemberships: true
	            })
	          ),
	          _react2.default.createElement(
	            "h2",
	            { style: { marginTop: 25 } },
	            "Tickets"
	          ),
	          _react2.default.createElement(_ticketTable2.default, {
	            tickets: tickets,
	            eventBucket: this.props.params.eventBucketId,
	            isSundance: fullEventBucket && fullEventBucket.frontend_config ? fullEventBucket.frontend_config.sundance_login : false,
	            showTransferHistory: fullEventBucket && fullEventBucket.frontend_config ? fullEventBucket.frontend_config.enable_transfer_history : false,
	            person: person.id,
	            showEvent: true,
	            location: this.props.location
	          }),
	          _react2.default.createElement(
	            "h2",
	            { style: { marginTop: 25 } },
	            "Orders"
	          ),
	          _react2.default.createElement(_orderTable2.default, {
	            orders: orders,
	            eventBucket: this.props.params.eventBucketId,
	            isSinglePerson: true
	          })
	        ),
	        _UserStore2.default.isGod() ? _react2.default.createElement(
	          "div",
	          { style: { position: "absolute", right: 0, top: 0 } },
	          _react2.default.createElement(
	            _linkLike2.default,
	            {
	              style: { color: "#fff" },
	              onTouchTap: function onTouchTap() {
	                return _GodActions2.default.becomePerson(person.id);
	              }
	            },
	            "[1]"
	          )
	        ) : null
	      );
	    }
	  }], [{
	    key: "getStores",
	    value: function getStores() {
	      return [_PersonStore2.default, _PassStore2.default, _TicketStore2.default, _OrderStore2.default, _EventBucketStore2.default];
	    }
	  }, {
	    key: "getPropsFromStores",
	    value: function getPropsFromStores() {
	      return {
	        getPersonById: _PersonStore2.default.getPersonById,
	        getPassesForPerson: _PassStore2.default.getPassesForPerson,
	        getTicketsForPerson: _TicketStore2.default.getTicketsForPerson,
	        getOrdersForPerson: _OrderStore2.default.getOrdersForPerson,
	        getEventBucketById: _EventBucketStore2.default.getEventBucketById
	      };
	    }
	  }, {
	    key: "contextTypes",
	    get: function get() {
	      return {
	        router: _react2.default.PropTypes.object
	      };
	    }
	  }]);
	
	  return Person;
	}(_react2.default.Component);
	
	exports.default = (0, _radium2.default)((0, _connectToStores2.default)(Person));
	module.exports = exports["default"];

/***/ }),
/* 2856 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(2857);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _keys = __webpack_require__(2858);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _getPrototypeOf = __webpack_require__(1231);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(1257);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(1258);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(1262);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(1309);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(956);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactAddonsShallowCompare = __webpack_require__(1321);
	
	var _reactAddonsShallowCompare2 = _interopRequireDefault(_reactAddonsShallowCompare);
	
	var _utils = __webpack_require__(2859);
	
	var _Gravatar = __webpack_require__(2870);
	
	var _Gravatar2 = _interopRequireDefault(_Gravatar);
	
	var _Facebook = __webpack_require__(2876);
	
	var _Facebook2 = _interopRequireDefault(_Facebook);
	
	var _Vkontakte = __webpack_require__(2877);
	
	var _Vkontakte2 = _interopRequireDefault(_Vkontakte);
	
	var _Twitter = __webpack_require__(2878);
	
	var _Twitter2 = _interopRequireDefault(_Twitter);
	
	var _Google = __webpack_require__(2879);
	
	var _Google2 = _interopRequireDefault(_Google);
	
	var _Skype = __webpack_require__(2880);
	
	var _Skype2 = _interopRequireDefault(_Skype);
	
	var _Value = __webpack_require__(2881);
	
	var _Value2 = _interopRequireDefault(_Value);
	
	var _Src = __webpack_require__(2882);
	
	var _Src2 = _interopRequireDefault(_Src);
	
	var _Icon = __webpack_require__(2883);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SOURCES = [_Facebook2.default, _Google2.default, _Twitter2.default, _Vkontakte2.default, _Skype2.default, _Gravatar2.default, _Src2.default, _Value2.default, _Icon2.default];
	
	var Avatar = function (_React$Component) {
	    (0, _inherits3.default)(Avatar, _React$Component);
	
	    function Avatar(props) {
	        (0, _classCallCheck3.default)(this, Avatar);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (Avatar.__proto__ || (0, _getPrototypeOf2.default)(Avatar)).call(this, props));
	
	        _this.tryNextsource = function (Source, next) {
	
	            var instance = new Source(_this.props);
	
	            if (!instance.isCompatible(_this.props)) return next();
	
	            instance.get(function (state) {
	                var failedBefore = state && state.hasOwnProperty('src') && (0, _utils.hasSourceFailedBefore)(state.src);
	
	                if (!failedBefore && state) {
	                    // console.log(state);
	                    _this.setState(state);
	                } else {
	                    next();
	                }
	            });
	        };
	
	        _this.fetch = function (event) {
	            // If fetch was triggered by img onError
	            // then set state src back to null so render will
	            // automatically switch a text avatar if there is no
	            // other social ID available to try
	            if (event && event.type === 'error') {
	                (0, _utils.cacheFailingSource)(_this.state.src);
	                _this.setState({ src: null });
	            }
	
	            // console.log('## fetch');
	
	            var id = _this._fetchId = _this._fetchId ? _this._fetchId + 1 : 1;
	
	            var tryFetch = function tryFetch() {
	                if (SOURCES.length === _this.state._internal.sourcePointer) return;
	
	                var source = SOURCES[_this.state._internal.sourcePointer];
	
	                var internal = _this.state._internal;
	                internal.sourcePointer++;
	
	                // console.log('## try fetch', id, this._fetchId, internal.sourcePointer-1);
	                _this.setState({
	                    _internal: internal
	                }, function () {
	                    _this.tryNextsource(source, function () {
	                        // console.log('-- next', id, this._fetchId);
	                        if (id === _this._fetchId) {
	                            tryFetch();
	                        }
	                    });
	                });
	            };
	
	            tryFetch();
	        };
	
	        _this.state = {
	            _internal: {
	                sourcePointer: 0
	            },
	            src: props.src,
	            value: null,
	            color: props.color
	        };
	        return _this;
	    }
	
	    (0, _createClass3.default)(Avatar, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            this.fetch();
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(newProps) {
	            var nextState = {};
	            if (newProps.src !== this.props.src) nextState.src = newProps.src;
	
	            if (newProps.name !== this.props.name) nextState.name = newProps.name;
	
	            if (newProps.value !== this.props.value) nextState.value = newProps.value;
	
	            if (newProps.email !== this.props.email) nextState.email = newProps.email;
	
	            if (newProps.md5Email !== this.props.md5Email) nextState.md5Email = newProps.md5Email;
	
	            if (newProps.facebookId !== this.props.facebookId) nextState.facebookId = newProps.facebookId;
	
	            if (newProps.googleId !== this.props.googleId) nextState.googleId = newProps.googleId;
	
	            if (newProps.twitterHandle !== this.props.twitterHandle) nextState.twitterHandle = newProps.twitterHandle;
	
	            if (newProps.vkontakteId !== this.props.vkontakteId) nextState.vkontakteId = newProps.vkontakteId;
	
	            if (newProps.skypeId !== this.props.skypeId) nextState.skypeId = newProps.skypeId;
	
	            if ((0, _keys2.default)(nextState) !== 0) {
	                nextState._internal = this.state._internal;
	                nextState._internal.sourcePointer = 0;
	                this.setState(nextState, this.fetch);
	            }
	        }
	    }, {
	        key: 'shouldComponentUpdate',
	        value: function shouldComponentUpdate(nextProps, nextState) {
	            return (0, _reactAddonsShallowCompare2.default)(this, nextProps, nextState);
	        }
	    }, {
	        key: '_renderAsImage',
	        value: function _renderAsImage() {
	            var size = this.props.size;
	            var round = this.props.round;
	            var alt = this.props.name || this.props.value;
	            var imageStyle = this.props.unstyled ? null : {
	                maxWidth: '100%',
	                width: size,
	                height: size,
	                borderRadius: round ? 500 : 0
	            };
	            return _react2.default.createElement('img', { width: this.props.size,
	                height: this.props.size,
	                style: imageStyle,
	                src: this.state.src,
	                alt: alt,
	                onError: this.fetch });
	        }
	    }, {
	        key: '_renderAsText',
	        value: function _renderAsText() {
	            var size = this.props.size;
	            var textSizeRatio = this.props.textSizeRatio;
	            var round = this.props.round;
	            var initialsStyle = this.props.unstyled ? null : {
	                width: size,
	                height: size,
	                font: Math.floor(size / textSizeRatio) + 'px Helvetica, Arial, sans-serif',
	                lineHeight: size + 'px', // yes, px suffix is needed on lineHeight
	                textAlign: 'center',
	                textTransform: 'uppercase',
	                color: this.props.fgColor,
	                background: this.state.color,
	                borderRadius: round ? '100%' : 0
	            };
	            return _react2.default.createElement(
	                'div',
	                { style: initialsStyle },
	                this.state.value
	            );
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var size = this.props.size;
	            var hostStyle = this.props.unstyled ? null : (0, _extends3.default)({
	                display: 'inline-block',
	                width: size,
	                height: size,
	                borderRadius: this.props.round ? 500 : 0
	            }, this.props.style);
	            return _react2.default.createElement(
	                'div',
	                { className: this.props.className,
	                    style: hostStyle },
	                this.state.src ? this._renderAsImage() : this._renderAsText()
	            );
	        }
	    }]);
	    return Avatar;
	}(_react2.default.Component);
	
	Avatar.displayName = 'Avatar';
	Avatar.propTypes = {
	    className: _propTypes2.default.string,
	    fgColor: _propTypes2.default.string,
	    color: _propTypes2.default.string,
	    colors: _propTypes2.default.array,
	    name: _propTypes2.default.string,
	    value: _propTypes2.default.string,
	    email: _propTypes2.default.string,
	    md5Email: _propTypes2.default.string,
	    src: _propTypes2.default.string,
	    facebookId: _propTypes2.default.string,
	    googleId: _propTypes2.default.string,
	    twitterHandle: _propTypes2.default.string,
	    vkontakteId: _propTypes2.default.string,
	    skypeId: _propTypes2.default.string,
	    round: _propTypes2.default.bool,
	    style: _propTypes2.default.object,
	    size: _propTypes2.default.number,
	    textSizeRatio: _propTypes2.default.number,
	    unstyled: _propTypes2.default.bool
	};
	Avatar.defaultProps = {
	    className: 'sb-avatar',
	    fgColor: '#FFF',
	    color: null,
	    name: null,
	    value: null,
	    email: null,
	    md5Email: null,
	    facebookId: null,
	    googleId: null,
	    twitterHandle: null,
	    vkontakteId: null,
	    skypeId: null,
	    round: false,
	    size: 100,
	    style: null,
	    textSizeRatio: 3,
	    unstyled: false
	};
	exports.default = Avatar;
	module.exports = exports['default'];

/***/ }),
/* 2857 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _assign = __webpack_require__(1317);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _assign2.default || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	
	  return target;
	};

/***/ }),
/* 2858 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1899), __esModule: true };

/***/ }),
/* 2859 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(2860);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	exports.fetch = fetch;
	exports.fetchJSONP = fetchJSONP;
	exports.getRandomColor = getRandomColor;
	exports.cacheFailingSource = cacheFailingSource;
	exports.hasSourceFailedBefore = hasSourceFailedBefore;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function fetch(url, successCb, errorCb) {
	    var request = new XMLHttpRequest();
	    request.onreadystatechange = function () {
	        if (request.readyState === 4) {
	            if (request.status === 200) {
	                var data = JSON.parse(request.responseText);
	                successCb(data);
	            } else {
	                errorCb(request.status);
	            }
	        }
	    };
	    request.open('GET', url, true);
	    request.send();
	}
	
	function fetchJSONP(url, successCb, errorCb) {
	    var callbackName = 'jsonp_cb_' + Math.round(100000 * Math.random());
	
	    var script = document.createElement('script');
	    script.src = url + (url.indexOf('?') >= 0 ? '&' : '?') + 'callback=' + callbackName;
	    document.body.appendChild(script);
	
	    script.onerror = function () {
	        errorCb();
	    };
	
	    window[callbackName] = function (data) {
	        delete window[callbackName];
	        document.body.removeChild(script);
	        successCb(data);
	    };
	}
	
	var defaultColors = ['#d73d32', '#7e3794', '#4285f4', '#67ae3f', '#d61a7f', '#ff4080'];
	
	function _stringAsciiCodeSum(value) {
	    return [].concat((0, _toConsumableArray3.default)(value)).map(function (letter) {
	        return letter.charCodeAt(0);
	    }).reduce(function (current, previous) {
	        return previous + current;
	    });
	}
	
	function getRandomColor(value) {
	    var colors = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultColors;
	
	    // if no value is passed, always return transparent color otherwise
	    // a rerender would show a new color which would will
	    // give strange effects when an interface is loading
	    // and gets rerendered a few consequent times
	    if (!value) return 'transparent';
	
	    // value based random color index
	    // the reason we don't just use a random number is to make sure that
	    // a certain value will always get the same color assigned given
	    // a fixed set of colors
	    var sum = _stringAsciiCodeSum(value);
	    var colorIndex = sum % colors.length;
	    return colors[colorIndex];
	}
	
	function _hasLocalStorage() {
	    return typeof Storage !== 'undefined';
	}
	
	var CACHE_KEY = 'react-avatar';
	
	function cacheFailingSource(source) {
	    // cache not available
	    if (!_hasLocalStorage) return;
	
	    var cache = localStorage.getItem(CACHE_KEY) || '';
	
	    // already in cache
	    if (cache.indexOf(source) > -1) return;
	
	    var cacheList = cache.split(';');
	    cacheList.push(source);
	
	    // only keep the last 20 results so we don't fill up local storage
	    cacheList = cacheList.slice(-20);
	
	    try {
	        localStorage.setItem(CACHE_KEY, cacheList.join(';'));
	    } catch (e) {
	        // failsafe for mobile Safari private mode
	        console.error(e);
	    }
	}
	
	function hasSourceFailedBefore(source) {
	    var cache = localStorage.getItem(CACHE_KEY) || '';
	    return cache.indexOf(source) > -1;
	}

/***/ }),
/* 2860 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _from = __webpack_require__(2861);
	
	var _from2 = _interopRequireDefault(_from);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (arr) {
	  if (Array.isArray(arr)) {
	    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
	      arr2[i] = arr[i];
	    }
	
	    return arr2;
	  } else {
	    return (0, _from2.default)(arr);
	  }
	};

/***/ }),
/* 2861 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(2862), __esModule: true };

/***/ }),
/* 2862 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1266);
	__webpack_require__(2863);
	module.exports = __webpack_require__(1244).Array.from;

/***/ }),
/* 2863 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var ctx            = __webpack_require__(1245)
	  , $export        = __webpack_require__(1243)
	  , toObject       = __webpack_require__(1234)
	  , call           = __webpack_require__(2864)
	  , isArrayIter    = __webpack_require__(2865)
	  , toLength       = __webpack_require__(1282)
	  , createProperty = __webpack_require__(2866)
	  , getIterFn      = __webpack_require__(2867);
	
	$export($export.S + $export.F * !__webpack_require__(2869)(function(iter){ Array.from(iter); }), 'Array', {
	  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
	  from: function from(arrayLike/*, mapfn = undefined, thisArg = undefined*/){
	    var O       = toObject(arrayLike)
	      , C       = typeof this == 'function' ? this : Array
	      , aLen    = arguments.length
	      , mapfn   = aLen > 1 ? arguments[1] : undefined
	      , mapping = mapfn !== undefined
	      , index   = 0
	      , iterFn  = getIterFn(O)
	      , length, result, step, iterator;
	    if(mapping)mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
	    // if object isn't iterable or it's array with default iterator - use simple case
	    if(iterFn != undefined && !(C == Array && isArrayIter(iterFn))){
	      for(iterator = iterFn.call(O), result = new C; !(step = iterator.next()).done; index++){
	        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
	      }
	    } else {
	      length = toLength(O.length);
	      for(result = new C(length); length > index; index++){
	        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
	      }
	    }
	    result.length = index;
	    return result;
	  }
	});


/***/ }),
/* 2864 */
/***/ (function(module, exports, __webpack_require__) {

	// call something on iterator step with safe closing on error
	var anObject = __webpack_require__(1249);
	module.exports = function(iterator, fn, value, entries){
	  try {
	    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
	  // 7.4.6 IteratorClose(iterator, completion)
	  } catch(e){
	    var ret = iterator['return'];
	    if(ret !== undefined)anObject(ret.call(iterator));
	    throw e;
	  }
	};

/***/ }),
/* 2865 */
/***/ (function(module, exports, __webpack_require__) {

	// check on default Array iterator
	var Iterators  = __webpack_require__(1272)
	  , ITERATOR   = __webpack_require__(1287)('iterator')
	  , ArrayProto = Array.prototype;
	
	module.exports = function(it){
	  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
	};

/***/ }),
/* 2866 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $defineProperty = __webpack_require__(1248)
	  , createDesc      = __webpack_require__(1256);
	
	module.exports = function(object, index, value){
	  if(index in object)$defineProperty.f(object, index, createDesc(0, value));
	  else object[index] = value;
	};

/***/ }),
/* 2867 */
/***/ (function(module, exports, __webpack_require__) {

	var classof   = __webpack_require__(2868)
	  , ITERATOR  = __webpack_require__(1287)('iterator')
	  , Iterators = __webpack_require__(1272);
	module.exports = __webpack_require__(1244).getIteratorMethod = function(it){
	  if(it != undefined)return it[ITERATOR]
	    || it['@@iterator']
	    || Iterators[classof(it)];
	};

/***/ }),
/* 2868 */
/***/ (function(module, exports, __webpack_require__) {

	// getting tag from 19.1.3.6 Object.prototype.toString()
	var cof = __webpack_require__(1280)
	  , TAG = __webpack_require__(1287)('toStringTag')
	  // ES3 wrong here
	  , ARG = cof(function(){ return arguments; }()) == 'Arguments';
	
	// fallback for IE11 Script Access Denied error
	var tryGet = function(it, key){
	  try {
	    return it[key];
	  } catch(e){ /* empty */ }
	};
	
	module.exports = function(it){
	  var O, T, B;
	  return it === undefined ? 'Undefined' : it === null ? 'Null'
	    // @@toStringTag case
	    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
	    // builtinTag case
	    : ARG ? cof(O)
	    // ES3 arguments fallback
	    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
	};

/***/ }),
/* 2869 */
/***/ (function(module, exports, __webpack_require__) {

	var ITERATOR     = __webpack_require__(1287)('iterator')
	  , SAFE_CLOSING = false;
	
	try {
	  var riter = [7][ITERATOR]();
	  riter['return'] = function(){ SAFE_CLOSING = true; };
	  Array.from(riter, function(){ throw 2; });
	} catch(e){ /* empty */ }
	
	module.exports = function(exec, skipClosing){
	  if(!skipClosing && !SAFE_CLOSING)return false;
	  var safe = false;
	  try {
	    var arr  = [7]
	      , iter = arr[ITERATOR]();
	    iter.next = function(){ return {done: safe = true}; };
	    arr[ITERATOR] = function(){ return iter; };
	    exec(arr);
	  } catch(e){ /* empty */ }
	  return safe;
	};

/***/ }),
/* 2870 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _classCallCheck2 = __webpack_require__(1257);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _isRetina = __webpack_require__(2871);
	
	var _isRetina2 = _interopRequireDefault(_isRetina);
	
	var _md = __webpack_require__(2872);
	
	var _md2 = _interopRequireDefault(_md);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var IS_RETINA = (0, _isRetina2.default)();
	
	var GravatarSource = function GravatarSource(props) {
	    (0, _classCallCheck3.default)(this, GravatarSource);
	
	    _initialiseProps.call(this);
	
	    this.props = props;
	};
	
	var _initialiseProps = function _initialiseProps() {
	    var _this = this;
	
	    this.props = null;
	
	    this.isCompatible = function () {
	        return !!_this.props.email || !!_this.props.md5Email;
	    };
	
	    this.get = function (setState) {
	        var props = _this.props;
	
	        var email = props.md5Email || (0, _md2.default)(props.email);
	        var size = IS_RETINA ? props.size * 2 : props.size;
	        var url = 'https://secure.gravatar.com/avatar/' + email + '?s=' + size + '&d=404';
	
	        setState({ src: url });
	    };
	};
	
	exports.default = GravatarSource;
	module.exports = exports['default'];

/***/ }),
/* 2871 */
/***/ (function(module, exports) {

	module.exports = function() {
	  var mediaQuery;
	  if (typeof window !== "undefined" && window !== null) {
	    mediaQuery = "(-webkit-min-device-pixel-ratio: 1.25), (min--moz-device-pixel-ratio: 1.25), (-o-min-device-pixel-ratio: 5/4), (min-resolution: 1.25dppx)";
	    if (window.devicePixelRatio > 1.25) {
	      return true;
	    }
	    if (window.matchMedia && window.matchMedia(mediaQuery).matches) {
	      return true;
	    }
	  }
	  return false;
	};


/***/ }),
/* 2872 */
/***/ (function(module, exports, __webpack_require__) {

	(function(){
	  var crypt = __webpack_require__(2873),
	      utf8 = __webpack_require__(2874).utf8,
	      isBuffer = __webpack_require__(2875),
	      bin = __webpack_require__(2874).bin,
	
	  // The core
	  md5 = function (message, options) {
	    // Convert to byte array
	    if (message.constructor == String)
	      if (options && options.encoding === 'binary')
	        message = bin.stringToBytes(message);
	      else
	        message = utf8.stringToBytes(message);
	    else if (isBuffer(message))
	      message = Array.prototype.slice.call(message, 0);
	    else if (!Array.isArray(message))
	      message = message.toString();
	    // else, assume byte array already
	
	    var m = crypt.bytesToWords(message),
	        l = message.length * 8,
	        a =  1732584193,
	        b = -271733879,
	        c = -1732584194,
	        d =  271733878;
	
	    // Swap endian
	    for (var i = 0; i < m.length; i++) {
	      m[i] = ((m[i] <<  8) | (m[i] >>> 24)) & 0x00FF00FF |
	             ((m[i] << 24) | (m[i] >>>  8)) & 0xFF00FF00;
	    }
	
	    // Padding
	    m[l >>> 5] |= 0x80 << (l % 32);
	    m[(((l + 64) >>> 9) << 4) + 14] = l;
	
	    // Method shortcuts
	    var FF = md5._ff,
	        GG = md5._gg,
	        HH = md5._hh,
	        II = md5._ii;
	
	    for (var i = 0; i < m.length; i += 16) {
	
	      var aa = a,
	          bb = b,
	          cc = c,
	          dd = d;
	
	      a = FF(a, b, c, d, m[i+ 0],  7, -680876936);
	      d = FF(d, a, b, c, m[i+ 1], 12, -389564586);
	      c = FF(c, d, a, b, m[i+ 2], 17,  606105819);
	      b = FF(b, c, d, a, m[i+ 3], 22, -1044525330);
	      a = FF(a, b, c, d, m[i+ 4],  7, -176418897);
	      d = FF(d, a, b, c, m[i+ 5], 12,  1200080426);
	      c = FF(c, d, a, b, m[i+ 6], 17, -1473231341);
	      b = FF(b, c, d, a, m[i+ 7], 22, -45705983);
	      a = FF(a, b, c, d, m[i+ 8],  7,  1770035416);
	      d = FF(d, a, b, c, m[i+ 9], 12, -1958414417);
	      c = FF(c, d, a, b, m[i+10], 17, -42063);
	      b = FF(b, c, d, a, m[i+11], 22, -1990404162);
	      a = FF(a, b, c, d, m[i+12],  7,  1804603682);
	      d = FF(d, a, b, c, m[i+13], 12, -40341101);
	      c = FF(c, d, a, b, m[i+14], 17, -1502002290);
	      b = FF(b, c, d, a, m[i+15], 22,  1236535329);
	
	      a = GG(a, b, c, d, m[i+ 1],  5, -165796510);
	      d = GG(d, a, b, c, m[i+ 6],  9, -1069501632);
	      c = GG(c, d, a, b, m[i+11], 14,  643717713);
	      b = GG(b, c, d, a, m[i+ 0], 20, -373897302);
	      a = GG(a, b, c, d, m[i+ 5],  5, -701558691);
	      d = GG(d, a, b, c, m[i+10],  9,  38016083);
	      c = GG(c, d, a, b, m[i+15], 14, -660478335);
	      b = GG(b, c, d, a, m[i+ 4], 20, -405537848);
	      a = GG(a, b, c, d, m[i+ 9],  5,  568446438);
	      d = GG(d, a, b, c, m[i+14],  9, -1019803690);
	      c = GG(c, d, a, b, m[i+ 3], 14, -187363961);
	      b = GG(b, c, d, a, m[i+ 8], 20,  1163531501);
	      a = GG(a, b, c, d, m[i+13],  5, -1444681467);
	      d = GG(d, a, b, c, m[i+ 2],  9, -51403784);
	      c = GG(c, d, a, b, m[i+ 7], 14,  1735328473);
	      b = GG(b, c, d, a, m[i+12], 20, -1926607734);
	
	      a = HH(a, b, c, d, m[i+ 5],  4, -378558);
	      d = HH(d, a, b, c, m[i+ 8], 11, -2022574463);
	      c = HH(c, d, a, b, m[i+11], 16,  1839030562);
	      b = HH(b, c, d, a, m[i+14], 23, -35309556);
	      a = HH(a, b, c, d, m[i+ 1],  4, -1530992060);
	      d = HH(d, a, b, c, m[i+ 4], 11,  1272893353);
	      c = HH(c, d, a, b, m[i+ 7], 16, -155497632);
	      b = HH(b, c, d, a, m[i+10], 23, -1094730640);
	      a = HH(a, b, c, d, m[i+13],  4,  681279174);
	      d = HH(d, a, b, c, m[i+ 0], 11, -358537222);
	      c = HH(c, d, a, b, m[i+ 3], 16, -722521979);
	      b = HH(b, c, d, a, m[i+ 6], 23,  76029189);
	      a = HH(a, b, c, d, m[i+ 9],  4, -640364487);
	      d = HH(d, a, b, c, m[i+12], 11, -421815835);
	      c = HH(c, d, a, b, m[i+15], 16,  530742520);
	      b = HH(b, c, d, a, m[i+ 2], 23, -995338651);
	
	      a = II(a, b, c, d, m[i+ 0],  6, -198630844);
	      d = II(d, a, b, c, m[i+ 7], 10,  1126891415);
	      c = II(c, d, a, b, m[i+14], 15, -1416354905);
	      b = II(b, c, d, a, m[i+ 5], 21, -57434055);
	      a = II(a, b, c, d, m[i+12],  6,  1700485571);
	      d = II(d, a, b, c, m[i+ 3], 10, -1894986606);
	      c = II(c, d, a, b, m[i+10], 15, -1051523);
	      b = II(b, c, d, a, m[i+ 1], 21, -2054922799);
	      a = II(a, b, c, d, m[i+ 8],  6,  1873313359);
	      d = II(d, a, b, c, m[i+15], 10, -30611744);
	      c = II(c, d, a, b, m[i+ 6], 15, -1560198380);
	      b = II(b, c, d, a, m[i+13], 21,  1309151649);
	      a = II(a, b, c, d, m[i+ 4],  6, -145523070);
	      d = II(d, a, b, c, m[i+11], 10, -1120210379);
	      c = II(c, d, a, b, m[i+ 2], 15,  718787259);
	      b = II(b, c, d, a, m[i+ 9], 21, -343485551);
	
	      a = (a + aa) >>> 0;
	      b = (b + bb) >>> 0;
	      c = (c + cc) >>> 0;
	      d = (d + dd) >>> 0;
	    }
	
	    return crypt.endian([a, b, c, d]);
	  };
	
	  // Auxiliary functions
	  md5._ff  = function (a, b, c, d, x, s, t) {
	    var n = a + (b & c | ~b & d) + (x >>> 0) + t;
	    return ((n << s) | (n >>> (32 - s))) + b;
	  };
	  md5._gg  = function (a, b, c, d, x, s, t) {
	    var n = a + (b & d | c & ~d) + (x >>> 0) + t;
	    return ((n << s) | (n >>> (32 - s))) + b;
	  };
	  md5._hh  = function (a, b, c, d, x, s, t) {
	    var n = a + (b ^ c ^ d) + (x >>> 0) + t;
	    return ((n << s) | (n >>> (32 - s))) + b;
	  };
	  md5._ii  = function (a, b, c, d, x, s, t) {
	    var n = a + (c ^ (b | ~d)) + (x >>> 0) + t;
	    return ((n << s) | (n >>> (32 - s))) + b;
	  };
	
	  // Package private blocksize
	  md5._blocksize = 16;
	  md5._digestsize = 16;
	
	  module.exports = function (message, options) {
	    if (message === undefined || message === null)
	      throw new Error('Illegal argument ' + message);
	
	    var digestbytes = crypt.wordsToBytes(md5(message, options));
	    return options && options.asBytes ? digestbytes :
	        options && options.asString ? bin.bytesToString(digestbytes) :
	        crypt.bytesToHex(digestbytes);
	  };
	
	})();


/***/ }),
/* 2873 */
/***/ (function(module, exports) {

	(function() {
	  var base64map
	      = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/',
	
	  crypt = {
	    // Bit-wise rotation left
	    rotl: function(n, b) {
	      return (n << b) | (n >>> (32 - b));
	    },
	
	    // Bit-wise rotation right
	    rotr: function(n, b) {
	      return (n << (32 - b)) | (n >>> b);
	    },
	
	    // Swap big-endian to little-endian and vice versa
	    endian: function(n) {
	      // If number given, swap endian
	      if (n.constructor == Number) {
	        return crypt.rotl(n, 8) & 0x00FF00FF | crypt.rotl(n, 24) & 0xFF00FF00;
	      }
	
	      // Else, assume array and swap all items
	      for (var i = 0; i < n.length; i++)
	        n[i] = crypt.endian(n[i]);
	      return n;
	    },
	
	    // Generate an array of any length of random bytes
	    randomBytes: function(n) {
	      for (var bytes = []; n > 0; n--)
	        bytes.push(Math.floor(Math.random() * 256));
	      return bytes;
	    },
	
	    // Convert a byte array to big-endian 32-bit words
	    bytesToWords: function(bytes) {
	      for (var words = [], i = 0, b = 0; i < bytes.length; i++, b += 8)
	        words[b >>> 5] |= bytes[i] << (24 - b % 32);
	      return words;
	    },
	
	    // Convert big-endian 32-bit words to a byte array
	    wordsToBytes: function(words) {
	      for (var bytes = [], b = 0; b < words.length * 32; b += 8)
	        bytes.push((words[b >>> 5] >>> (24 - b % 32)) & 0xFF);
	      return bytes;
	    },
	
	    // Convert a byte array to a hex string
	    bytesToHex: function(bytes) {
	      for (var hex = [], i = 0; i < bytes.length; i++) {
	        hex.push((bytes[i] >>> 4).toString(16));
	        hex.push((bytes[i] & 0xF).toString(16));
	      }
	      return hex.join('');
	    },
	
	    // Convert a hex string to a byte array
	    hexToBytes: function(hex) {
	      for (var bytes = [], c = 0; c < hex.length; c += 2)
	        bytes.push(parseInt(hex.substr(c, 2), 16));
	      return bytes;
	    },
	
	    // Convert a byte array to a base-64 string
	    bytesToBase64: function(bytes) {
	      for (var base64 = [], i = 0; i < bytes.length; i += 3) {
	        var triplet = (bytes[i] << 16) | (bytes[i + 1] << 8) | bytes[i + 2];
	        for (var j = 0; j < 4; j++)
	          if (i * 8 + j * 6 <= bytes.length * 8)
	            base64.push(base64map.charAt((triplet >>> 6 * (3 - j)) & 0x3F));
	          else
	            base64.push('=');
	      }
	      return base64.join('');
	    },
	
	    // Convert a base-64 string to a byte array
	    base64ToBytes: function(base64) {
	      // Remove non-base-64 characters
	      base64 = base64.replace(/[^A-Z0-9+\/]/ig, '');
	
	      for (var bytes = [], i = 0, imod4 = 0; i < base64.length;
	          imod4 = ++i % 4) {
	        if (imod4 == 0) continue;
	        bytes.push(((base64map.indexOf(base64.charAt(i - 1))
	            & (Math.pow(2, -2 * imod4 + 8) - 1)) << (imod4 * 2))
	            | (base64map.indexOf(base64.charAt(i)) >>> (6 - imod4 * 2)));
	      }
	      return bytes;
	    }
	  };
	
	  module.exports = crypt;
	})();


/***/ }),
/* 2874 */
/***/ (function(module, exports) {

	var charenc = {
	  // UTF-8 encoding
	  utf8: {
	    // Convert a string to a byte array
	    stringToBytes: function(str) {
	      return charenc.bin.stringToBytes(unescape(encodeURIComponent(str)));
	    },
	
	    // Convert a byte array to a string
	    bytesToString: function(bytes) {
	      return decodeURIComponent(escape(charenc.bin.bytesToString(bytes)));
	    }
	  },
	
	  // Binary encoding
	  bin: {
	    // Convert a string to a byte array
	    stringToBytes: function(str) {
	      for (var bytes = [], i = 0; i < str.length; i++)
	        bytes.push(str.charCodeAt(i) & 0xFF);
	      return bytes;
	    },
	
	    // Convert a byte array to a string
	    bytesToString: function(bytes) {
	      for (var str = [], i = 0; i < bytes.length; i++)
	        str.push(String.fromCharCode(bytes[i]));
	      return str.join('');
	    }
	  }
	};
	
	module.exports = charenc;


/***/ }),
/* 2875 */
/***/ (function(module, exports) {

	/**
	 * Determine if an object is Buffer
	 *
	 * Author:   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
	 * License:  MIT
	 *
	 * `npm install is-buffer`
	 */
	
	module.exports = function (obj) {
	  return !!(obj != null &&
	    (obj._isBuffer || // For Safari 5-7 (missing Object.prototype.constructor)
	      (obj.constructor &&
	      typeof obj.constructor.isBuffer === 'function' &&
	      obj.constructor.isBuffer(obj))
	    ))
	}


/***/ }),
/* 2876 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _classCallCheck2 = __webpack_require__(1257);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FacebookSource = function FacebookSource(props) {
	    var _this = this;
	
	    (0, _classCallCheck3.default)(this, FacebookSource);
	    this.props = null;
	
	    this.isCompatible = function () {
	        return !!_this.props.facebookId;
	    };
	
	    this.get = function (setState) {
	        var _props = _this.props;
	        var size = _props.size;
	        var facebookId = _props.facebookId;
	
	        var url = 'https://graph.facebook.com/' + (facebookId + '/picture?width=' + size + '&height=' + size);
	
	        setState({ src: url });
	    };
	
	    this.props = props;
	};
	
	exports.default = FacebookSource;
	module.exports = exports['default'];

/***/ }),
/* 2877 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _classCallCheck2 = __webpack_require__(1257);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(1258);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _utils = __webpack_require__(2859);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var GoogleSource = function () {
	    function GoogleSource(props) {
	        var _this = this;
	
	        (0, _classCallCheck3.default)(this, GoogleSource);
	        this.props = null;
	
	        this.isCompatible = function () {
	            return !!_this.props.vkontakteId;
	        };
	
	        this.get = function (setState) {
	            var vkontakteId = _this.props.vkontakteId;
	
	            var size = _this.getImageSize();
	            var url = 'https://api.vk.com/method/users.get?user_id=' + vkontakteId + '&v=5.8&fields=' + size;
	
	            (0, _utils.fetchJSONP)(url, function (data) {
	                var src = data.response[0][size];
	                setState({
	                    src: src
	                });
	            }, function () {
	                // on error
	                setState(null);
	            });
	        };
	
	        this.props = props;
	    }
	
	    (0, _createClass3.default)(GoogleSource, [{
	        key: 'getImageSize',
	        value: function getImageSize() {
	            var size = this.props.size;
	
	
	            if (size <= 50) return 'photo_50';
	
	            if (size <= 100) return 'photo_100';
	
	            if (size <= 200) return 'photo_200';
	
	            return 'photo_max';
	        }
	    }]);
	    return GoogleSource;
	}();
	
	exports.default = GoogleSource;
	module.exports = exports['default'];

/***/ }),
/* 2878 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _classCallCheck2 = __webpack_require__(1257);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(1258);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TwitterSource = function () {
	    function TwitterSource(props) {
	        var _this = this;
	
	        (0, _classCallCheck3.default)(this, TwitterSource);
	        this.props = null;
	
	        this.isCompatible = function () {
	            return !!_this.props.twitterHandle;
	        };
	
	        this.get = function (setState) {
	            var twitterHandle = _this.props.twitterHandle;
	
	            var size = _this.getImageSize();
	
	            var url = 'https://twitter.com/' + twitterHandle + '/profile_image?size=' + size;
	
	            setState({ src: url });
	        };
	
	        this.props = props;
	    }
	
	    (0, _createClass3.default)(TwitterSource, [{
	        key: 'getImageSize',
	        value: function getImageSize() {
	            var size = this.props.size;
	
	
	            if (size <= 24) return 'mini';
	
	            if (size <= 48) return 'normal';
	
	            if (size <= 73) return 'bigger';
	
	            return 'original';
	        }
	    }]);
	    return TwitterSource;
	}();
	
	exports.default = TwitterSource;
	module.exports = exports['default'];

/***/ }),
/* 2879 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _classCallCheck2 = __webpack_require__(1257);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _utils = __webpack_require__(2859);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var GoogleSource = function GoogleSource(props) {
	    var _this = this;
	
	    (0, _classCallCheck3.default)(this, GoogleSource);
	    this.props = null;
	
	    this.isCompatible = function () {
	        return !!_this.props.googleId;
	    };
	
	    this.get = function (setState) {
	        var _props = _this.props;
	        var size = _props.size;
	        var googleId = _props.googleId;
	
	        var url = 'https://picasaweb.google.com/data/entry/api/user/' + googleId + '?alt=json';
	
	        if ((0, _utils.hasSourceFailedBefore)(url)) {
	            setState(null);
	            return;
	        }
	
	        (0, _utils.fetch)(url, function (data) {
	            var src = data.entry.gphoto$thumbnail.$t;
	            var srcWithCorrectSize = src.replace('s64', 's' + size);
	            setState({
	                src: srcWithCorrectSize
	            });
	        }, function () {
	            // on error
	            (0, _utils.cacheFailingSource)(url);
	            setState(null);
	        });
	    };
	
	    this.props = props;
	};
	
	exports.default = GoogleSource;
	module.exports = exports['default'];

/***/ }),
/* 2880 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _classCallCheck2 = __webpack_require__(1257);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SkypeSource = function SkypeSource(props) {
	    var _this = this;
	
	    (0, _classCallCheck3.default)(this, SkypeSource);
	    this.props = null;
	
	    this.isCompatible = function () {
	        return !!_this.props.skypeId;
	    };
	
	    this.get = function (setState) {
	        var skypeId = _this.props.skypeId;
	
	        var url = 'https://api.skype.com/users/' + skypeId + '/profile/avatar';
	
	        setState({ src: url });
	    };
	
	    this.props = props;
	};
	
	exports.default = SkypeSource;
	module.exports = exports['default'];

/***/ }),
/* 2881 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _classCallCheck2 = __webpack_require__(1257);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(1258);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _utils = __webpack_require__(2859);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ValueSource = function () {
	    function ValueSource(props) {
	        var _this = this;
	
	        (0, _classCallCheck3.default)(this, ValueSource);
	        this.props = null;
	
	        this.isCompatible = function () {
	            return !!_this.props.name || !!_this.props.value;
	        };
	
	        this.get = function (setState) {
	            var value = _this.getValue();
	            var state = value ? {
	                value: value,
	                color: _this.getColor(value)
	            } : null;
	            setState(state);
	        };
	
	        this.props = props;
	    }
	
	    (0, _createClass3.default)(ValueSource, [{
	        key: 'getInitials',
	        value: function getInitials() {
	            var name = this.props.name;
	            var parts = name.split(' ');
	            var initials = '';
	            for (var i = 0; i < parts.length; i++) {
	                initials += parts[i].substr(0, 1).toUpperCase();
	            }
	            return initials;
	        }
	    }, {
	        key: 'getValue',
	        value: function getValue() {
	            if (this.props.name) return this.getInitials();
	
	            if (this.props.value) return this.props.value;
	
	            return null;
	        }
	    }, {
	        key: 'getColor',
	        value: function getColor(value) {
	            var _props = this.props;
	            var color = _props.color;
	            var colors = _props.colors;
	
	            return color || (0, _utils.getRandomColor)(value, colors);
	        }
	    }]);
	    return ValueSource;
	}();
	
	exports.default = ValueSource;
	module.exports = exports['default'];

/***/ }),
/* 2882 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _classCallCheck2 = __webpack_require__(1257);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SrcSource = function SrcSource(props) {
	    var _this = this;
	
	    (0, _classCallCheck3.default)(this, SrcSource);
	    this.props = null;
	
	    this.isCompatible = function () {
	        return !!_this.props.src;
	    };
	
	    this.get = function (setState) {
	        setState({
	            src: _this.props.src
	        });
	    };
	
	    this.props = props;
	};
	
	exports.default = SrcSource;
	module.exports = exports['default'];

/***/ }),
/* 2883 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _classCallCheck2 = __webpack_require__(1257);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _utils = __webpack_require__(2859);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var IconSource = function IconSource(props) {
	    var _this = this;
	
	    (0, _classCallCheck3.default)(this, IconSource);
	    this.props = null;
	    this.icon = '✷';
	
	    this.isCompatible = function () {
	        return true;
	    };
	
	    this.get = function (setState) {
	        setState({
	            value: _this.icon,
	            color: (0, _utils.getRandomColor)(_this.icon, _this.props.colors)
	        });
	    };
	
	    this.props = props;
	};
	
	exports.default = IconSource;
	module.exports = exports['default'];

/***/ }),
/* 2884 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Paper = __webpack_require__(617);
	
	var _Paper2 = _interopRequireDefault(_Paper);
	
	var _connectToStores = __webpack_require__(1226);
	
	var _connectToStores2 = _interopRequireDefault(_connectToStores);
	
	var _NoteActions = __webpack_require__(2885);
	
	var _NoteActions2 = _interopRequireDefault(_NoteActions);
	
	var _NoteStore = __webpack_require__(2886);
	
	var _NoteStore2 = _interopRequireDefault(_NoteStore);
	
	var _workingIndicator = __webpack_require__(1664);
	
	var _workingIndicator2 = _interopRequireDefault(_workingIndicator);
	
	var _note = __webpack_require__(2888);
	
	var _note2 = _interopRequireDefault(_note);
	
	var _addNote = __webpack_require__(2889);
	
	var _addNote2 = _interopRequireDefault(_addNote);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Notes = function (_React$Component) {
	  _inherits(Notes, _React$Component);
	
	  function Notes(props) {
	    _classCallCheck(this, Notes);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(Notes).call(this, props));
	
	    _this.state = {
	      isMounting: true
	    };
	    return _this;
	  }
	
	  _createClass(Notes, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      setTimeout(function () {
	        if (_this2.props.order) {
	          _NoteActions2.default.fetchAllForOrder(_this2.props.order);
	        } else if (_this2.props.person) {
	          _NoteActions2.default.fetchAllForPerson(_this2.props.person);
	        }
	        _this2.setState({ isMounting: false });
	      }, 0);
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(newProps) {
	      if (newProps.person !== this.props.person) {
	        _NoteActions2.default.fetchAllForPerson.defer(newProps.person);
	      }
	
	      if (newProps.order !== this.props.order) {
	        _NoteActions2.default.fetchAllforOrder.defer(newProps.order);
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this3 = this;
	
	      if (this.props.isFetching || this.state.isMounting) {
	        return _react2.default.createElement(_workingIndicator2.default, { centered: true });
	      }
	
	      var personNotes = this.props.getNotesForPerson(this.props.person).sort(function (a, b) {
	        return a.updated_at < b.updated_at;
	      });
	
	      var orderNotes = this.props.getNotesForOrder(this.props.order).sort(function (a, b) {
	        return a.updated_at < b.updated_at;
	      });
	
	      var notes = [].concat(_toConsumableArray(personNotes), _toConsumableArray(orderNotes));
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(_addNote2.default, {
	          person: this.props.person,
	          isCreating: this.props.isCreating,
	          order: this.props.order
	        }),
	        notes.map(function (note) {
	          return _react2.default.createElement(_note2.default, {
	            key: note.id,
	            note: note,
	            person: _this3.props.person,
	            isSaving: note.id === _this3.props.isEditing,
	            order: _this3.props.order
	          });
	        })
	      );
	    }
	  }], [{
	    key: "getStores",
	    value: function getStores() {
	      return [_NoteStore2.default];
	    }
	  }, {
	    key: "getPropsFromStores",
	    value: function getPropsFromStores() {
	      var _NoteStore$getState = _NoteStore2.default.getState();
	
	      var isFetching = _NoteStore$getState.isFetching;
	      var isEditing = _NoteStore$getState.isEditing;
	      var isCreating = _NoteStore$getState.isCreating;
	
	      return {
	        getNotesForPerson: _NoteStore2.default.getNotesForPerson,
	        getNotesForOrder: _NoteStore2.default.getNotesForOrder,
	        isFetching: isFetching,
	        isEditing: isEditing,
	        isCreating: isCreating
	      };
	    }
	  }]);
	
	  return Notes;
	}(_react2.default.Component);
	
	exports.default = (0, _connectToStores2.default)(Notes);
	module.exports = exports["default"];

/***/ }),
/* 2885 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _alt = __webpack_require__(975);
	
	var _alt2 = _interopRequireDefault(_alt);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var NoteActions = function () {
	  function NoteActions() {
	    _classCallCheck(this, NoteActions);
	
	    this.generateActions("create", "delete", "updateNotes", "fetchAllForPerson", "fetchAllForOrder", "fetchOne", "fetchFailed", "editFailed");
	  }
	
	  _createClass(NoteActions, [{
	    key: "edit",
	    value: function edit(id, values) {
	      return { id: id, values: values };
	    }
	  }, {
	    key: "updateNote",
	    value: function updateNote(id, note) {
	      return { id: id, note: note };
	    }
	  }]);
	
	  return NoteActions;
	}();
	
	exports.default = _alt2.default.createActions(NoteActions);
	module.exports = exports["default"];

/***/ }),
/* 2886 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _alt = __webpack_require__(975);
	
	var _alt2 = _interopRequireDefault(_alt);
	
	var _keyBy = __webpack_require__(990);
	
	var _keyBy2 = _interopRequireDefault(_keyBy);
	
	var _values = __webpack_require__(1214);
	
	var _values2 = _interopRequireDefault(_values);
	
	var _NoteUtil = __webpack_require__(2887);
	
	var _NoteUtil2 = _interopRequireDefault(_NoteUtil);
	
	var _NoteActions = __webpack_require__(2885);
	
	var _NoteActions2 = _interopRequireDefault(_NoteActions);
	
	var _UserStore = __webpack_require__(974);
	
	var _UserStore2 = _interopRequireDefault(_UserStore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var NoteStore = function () {
	  function NoteStore() {
	    _classCallCheck(this, NoteStore);
	
	    this.bindActions(_NoteActions2.default);
	
	    this.state = {
	      notes: {},
	      isFetching: false,
	      isEditing: null
	    };
	
	    this.exportPublicMethods({
	      getNoteById: this.getNoteById.bind(this),
	      getNotesForPerson: this.getNotesForPerson.bind(this),
	      getNotesForOrder: this.getNotesForOrder.bind(this)
	    });
	  }
	
	  _createClass(NoteStore, [{
	    key: "getNoteById",
	    value: function getNoteById(id) {
	      return this.state.notes[id];
	    }
	  }, {
	    key: "getNotesForPerson",
	    value: function getNotesForPerson(id) {
	      return (0, _values2.default)(this.state.notes).filter(function (n) {
	        return n.person === id;
	      });
	    }
	  }, {
	    key: "getNotesForOrder",
	    value: function getNotesForOrder(id) {
	      return (0, _values2.default)(this.state.notes).filter(function (n) {
	        return n.order === id;
	      });
	    }
	  }, {
	    key: "onFetchAllForPerson",
	    value: function onFetchAllForPerson(person) {
	      var _this = this;
	
	      this.setState({ isFetching: true });
	      _NoteUtil2.default.fetchAllForPerson(_UserStore2.default.getState().apiKey, person).then(function (data) {
	        _NoteActions2.default.updateNotes((0, _keyBy2.default)(data, "id"));
	        _this.setState({ isFetching: false });
	      }).catch(_NoteActions2.default.fetchFailed);
	    }
	  }, {
	    key: "onFetchAllForOrder",
	    value: function onFetchAllForOrder(order) {
	      var _this2 = this;
	
	      this.setState({ isFetching: true });
	      _NoteUtil2.default.fetchAllForOrder(_UserStore2.default.getState().apiKey, order).then(function (data) {
	        _NoteActions2.default.updateNotes((0, _keyBy2.default)(data, "id"));
	        _this2.setState({ isFetching: false });
	      }).catch(_NoteActions2.default.fetchFailed);
	    }
	  }, {
	    key: "onFetchOne",
	    value: function onFetchOne(id) {
	      _NoteUtil2.default.fetchOne(_UserStore2.default.getState().apiKey, id).then(function (data) {
	        _NoteActions2.default.updateNote(id, data);
	      }).catch(_NoteActions2.default.fetchFailed);
	    }
	  }, {
	    key: "onEdit",
	    value: function onEdit(newData) {
	      var _this3 = this;
	
	      this.setState({ isEditing: newData.id });
	      _NoteUtil2.default.edit(_UserStore2.default.getState().apiKey, newData.id, newData.values).then(function (data) {
	        window.Intercom("trackEvent", "edit-note");
	
	        _NoteActions2.default.updateNote(newData.id, data);
	        _this3.setState({ isEditing: null });
	      }).catch(_NoteActions2.default.editFailed);
	    }
	  }, {
	    key: "onDelete",
	    value: function onDelete(id) {
	      _NoteUtil2.default.delete(_UserStore2.default.getState().apiKey, id).then(function (data) {
	        _NoteActions2.default.updateNote(id, undefined);
	      }).catch(_NoteActions2.default.editFailed);
	    }
	  }, {
	    key: "onCreate",
	    value: function onCreate(newData) {
	      var _this4 = this;
	
	      this.setState({ isCreating: true });
	
	      _NoteUtil2.default.create(_UserStore2.default.getState().apiKey, newData).then(function (data) {
	        _NoteActions2.default.updateNote(data.id, data);
	        _this4.setState({ isCreating: false });
	      }).catch(_NoteActions2.default.editFailed);
	    }
	  }, {
	    key: "onUpdateNotes",
	    value: function onUpdateNotes(notes) {
	      this.setState({ notes: notes });
	    }
	  }, {
	    key: "onUpdateNote",
	    value: function onUpdateNote(data) {
	      if (!data.note) {
	        delete this.state.notes[data.id];
	      } else {
	        this.state.notes[data.id] = data.note;
	      }
	      this.state.newNoteId = null;
	      this.setState(this.state);
	    }
	  }, {
	    key: "onFetchFailed",
	    value: function onFetchFailed(e) {
	      alert("Fetching notes failed: " + e.message);
	      throw e;
	    }
	  }, {
	    key: "onEditFailed",
	    value: function onEditFailed(e) {
	      alert("Edit failed: " + e.message);
	      this.setState({ isCreating: false, isEditing: false });
	    }
	  }]);
	
	  return NoteStore;
	}();
	
	exports.default = _alt2.default.createStore(NoteStore, "NoteStore");
	module.exports = exports["default"];

/***/ }),
/* 2887 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _api = __webpack_require__(1160);
	
	var _api2 = _interopRequireDefault(_api);
	
	var _config = __webpack_require__(1173);
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  fetchAllForPerson: function fetchAllForPerson(apiKey, person) {
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "GET",
	        endpoint: "people/" + person + "/notes",
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response.notes);
	      });
	    });
	  },
	  fetchAllForOrder: function fetchAllForOrder(apiKey, order) {
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "GET",
	        endpoint: "orders/" + order + "/notes",
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response.notes);
	      });
	    });
	  },
	  fetchOne: function fetchOne(apiKey, note) {
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "GET",
	        endpoint: "notes/" + note,
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response);
	      });
	    });
	  },
	  edit: function edit(apiKey, note, values) {
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "POST",
	        endpoint: "notes/" + note,
	        json: values,
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response);
	      });
	    });
	  },
	  delete: function _delete(apiKey, note) {
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "DELETE",
	        endpoint: "notes/" + note,
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response);
	      });
	    });
	  },
	  create: function create(apiKey, values) {
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "POST",
	        endpoint: "notes",
	        json: values,
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response);
	      });
	    });
	  }
	};
	module.exports = exports["default"];

/***/ }),
/* 2888 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _materialUi = __webpack_require__(576);
	
	var _moment = __webpack_require__(1021);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _util = __webpack_require__(1183);
	
	var _basicHtmlField = __webpack_require__(2674);
	
	var _basicHtmlField2 = _interopRequireDefault(_basicHtmlField);
	
	var _NoteActions = __webpack_require__(2885);
	
	var _NoteActions2 = _interopRequireDefault(_NoteActions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var STYLES = {
	  note: {
	    padding: "1em",
	    marginBottom: "1em"
	  },
	  noteEditor: {
	    marginBottom: "1em"
	  },
	  footer: {
	    color: "rgb(132, 132, 132)"
	  },
	  footerLink: {
	    color: "rgb(132, 132, 132)",
	    textDecoration: "underline",
	    cursor: "pointer"
	  },
	  actions: {
	    padding: "1em",
	    paddingTop: 0
	  }
	};
	
	var Note = function (_React$Component) {
	  _inherits(Note, _React$Component);
	
	  function Note(props) {
	    _classCallCheck(this, Note);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(Note).call(this, props));
	
	    _this.state = {
	      content: "",
	      isEditing: false,
	      hasFocused: false
	    };
	
	    _this.edit = _this.edit.bind(_this);
	    _this.save = _this.save.bind(_this);
	    _this.delete = _this.delete.bind(_this);
	    return _this;
	  }
	
	  _createClass(Note, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.componentWillReceiveProps(this.props);
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(newProps) {
	      if (!this.state.isEditing && newProps.note) {
	        this.setState({
	          content: newProps.note.content
	        });
	      }
	    }
	  }, {
	    key: "edit",
	    value: function edit() {
	      this.setState({
	        isEditing: true
	      });
	    }
	  }, {
	    key: "save",
	    value: function save() {
	      var values = {
	        person: this.props.person,
	        content: this.state.content,
	        order: this.props.order
	      };
	
	      if (this.props.isNew) {
	        _NoteActions2.default.create(values);
	        if (this.props.onCreate) {
	          this.props.onCreate();
	        }
	      } else {
	        _NoteActions2.default.edit(this.props.note.id, values);
	        this.setState({ isEditing: false });
	      }
	    }
	  }, {
	    key: "delete",
	    value: function _delete() {
	      if (window.confirm("Are you sure you would like to delete this note?")) {
	        _NoteActions2.default.delete(this.props.note.id);
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var isEditing = this.state.isEditing || this.props.isNew;
	      var _props = this.props;
	      var note = _props.note;
	      var isSaving = _props.isSaving;
	
	
	      return _react2.default.createElement(
	        _materialUi.Paper,
	        { zDepth: 1 },
	        isEditing ? _react2.default.createElement(
	          "div",
	          { style: STYLES.noteEditor },
	          _react2.default.createElement(_basicHtmlField2.default, {
	            naked: true,
	            value: this.state.content,
	            onChange: function onChange(content) {
	              return _this2.setState({ content: content });
	            }
	          }),
	          _react2.default.createElement(
	            "div",
	            { style: STYLES.actions },
	            _react2.default.createElement(_materialUi.RaisedButton, {
	              primary: true,
	              disabled: isSaving,
	              label: isSaving ? "Saving..." : "Save",
	              style: { marginRight: 7 },
	              onTouchTap: this.save
	            }),
	            this.props.onCancel ? _react2.default.createElement(_materialUi.RaisedButton, { label: "Cancel", onTouchTap: this.props.onCancel }) : _react2.default.createElement(_materialUi.RaisedButton, { label: "Delete", onTouchTap: this.delete })
	          )
	        ) : _react2.default.createElement(
	          "div",
	          { style: STYLES.note },
	          _react2.default.createElement("div", {
	            className: "tenant-injected-html",
	            dangerouslySetInnerHTML: { __html: this.state.content }
	          }),
	          _react2.default.createElement(
	            "div",
	            { style: STYLES.footer },
	            (0, _util.capitalize)((0, _moment2.default)(note.updated_at).fromNow()),
	            " by",
	            " ",
	            note.user_account.name,
	            " |",
	            " ",
	            _react2.default.createElement(
	              "span",
	              { style: STYLES.footerLink, onTouchTap: this.edit },
	              "Edit"
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Note;
	}(_react2.default.Component);
	
	exports.default = Note;
	module.exports = exports["default"];

/***/ }),
/* 2889 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _materialUi = __webpack_require__(576);
	
	var _note = __webpack_require__(2888);
	
	var _note2 = _interopRequireDefault(_note);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AddNote = function (_React$Component) {
	  _inherits(AddNote, _React$Component);
	
	  function AddNote(props) {
	    _classCallCheck(this, AddNote);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(AddNote).call(this, props));
	
	    _this.state = {
	      inCreateMode: false
	    };
	    return _this;
	  }
	
	  _createClass(AddNote, [{
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      if (this.state.inCreateMode || this.props.isCreating) {
	        return _react2.default.createElement(_note2.default, {
	          isNew: true,
	          isSaving: this.props.isCreating,
	          person: this.props.person,
	          order: this.props.order,
	          onCreate: function onCreate() {
	            return _this2.setState({ inCreateMode: false });
	          },
	          onCancel: function onCancel() {
	            return _this2.setState({ inCreateMode: false });
	          }
	        });
	      }
	
	      return _react2.default.createElement(_materialUi.RaisedButton, {
	        style: { marginBottom: "1em" },
	        primary: true,
	        label: "Add new note",
	        onTouchTap: function onTouchTap() {
	          return _this2.setState({ inCreateMode: true });
	        }
	      });
	    }
	  }]);
	
	  return AddNote;
	}(_react2.default.Component);
	
	exports.default = AddNote;
	module.exports = exports["default"];

/***/ }),
/* 2890 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _moment = __webpack_require__(1021);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _keen = __webpack_require__(2891);
	
	var _util = __webpack_require__(1183);
	
	var _workingIndicator = __webpack_require__(1664);
	
	var _workingIndicator2 = _interopRequireDefault(_workingIndicator);
	
	var _inlineLinkIconButton = __webpack_require__(1704);
	
	var _inlineLinkIconButton2 = _interopRequireDefault(_inlineLinkIconButton);
	
	var _keenChart = __webpack_require__(2892);
	
	var _keenChart2 = _interopRequireDefault(_keenChart);
	
	var _connectToStores = __webpack_require__(1226);
	
	var _connectToStores2 = _interopRequireDefault(_connectToStores);
	
	var _TicketStore = __webpack_require__(2706);
	
	var _TicketStore2 = _interopRequireDefault(_TicketStore);
	
	var _PersonStore = __webpack_require__(2656);
	
	var _PersonStore2 = _interopRequireDefault(_PersonStore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var STATES = {
	  Alabama: "AL",
	  Alaska: "AK",
	  AmericanSamoa: "AS",
	  Arizona: "AZ",
	  Arkansas: "AR",
	  California: "CA",
	  Colorado: "CO",
	  Connecticut: "CT",
	  Delaware: "DE",
	  DistrictOfColumbia: "DC",
	  FederatedStatesOfMicronesia: "FM",
	  Florida: "FL",
	  Georgia: "GA",
	  Guam: "GU",
	  Hawaii: "HI",
	  Idaho: "ID",
	  Illinois: "IL",
	  Indiana: "IN",
	  Iowa: "IA",
	  Kansas: "KS",
	  Kentucky: "KY",
	  Louisiana: "LA",
	  Maine: "ME",
	  MarshallIslands: "MH",
	  Maryland: "MD",
	  Massachusetts: "MA",
	  Michigan: "MI",
	  Minnesota: "MN",
	  Mississippi: "MS",
	  Missouri: "MO",
	  Montana: "MT",
	  Nebraska: "NE",
	  Nevada: "NV",
	  NewHampshire: "NH",
	  NewJersey: "NJ",
	  NewMexico: "NM",
	  NewYork: "NY",
	  NorthCarolina: "NC",
	  NorthDakota: "ND",
	  NorthernMarianaIslands: "MP",
	  Ohio: "OH",
	  Oklahoma: "OK",
	  Oregon: "OR",
	  Palau: "PW",
	  Pennsylvania: "PA",
	  PuertoRico: "PR",
	  RhodeIsland: "RI",
	  SouthCarolina: "SC",
	  SouthDakota: "SD",
	  Tennessee: "TN",
	  Texas: "TX",
	  Utah: "UT",
	  Vermont: "VT",
	  VirginIslands: "VI",
	  Virginia: "VA",
	  Washington: "WA",
	  WestVirginia: "WV",
	  Wisconsin: "WI",
	  Wyoming: "WY"
	};
	
	var STYLES = {
	  entry: {
	    marginTop: 5,
	    lineHeight: 1.1
	  },
	  entryLabel: {
	    color: "#848484",
	    display: "block"
	  },
	  event_name: {
	    fontWeight: "bold",
	    fontSize: "1.1em"
	  },
	  event_time: {
	    fontStyle: "italic"
	  }
	};
	
	var PersonLatestInfo = function (_React$Component) {
	  _inherits(PersonLatestInfo, _React$Component);
	
	  function PersonLatestInfo(props) {
	    _classCallCheck(this, PersonLatestInfo);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(PersonLatestInfo).call(this, props));
	
	    _this.state = {
	      fetchedPageviewPerson: null,
	      soonestUpcoming: null,
	      lastAttended: null
	    };
	    return _this;
	  }
	
	  _createClass(PersonLatestInfo, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.componentWillReceiveProps(this.props);
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(newProps) {
	      // Keen integration disabled
	      // if (this.state.fetchedPageviewPerson !== newProps.personId) {
	      //   this.setState({ fetchedPageviewPerson: newProps.personId });
	      //   client.query('extraction', {
	      //     event_collection: 'pageviews',
	      //     filters: [{'operator':'eq','property_name':'person','property_value':newProps.personId}],
	      //     timeframe: 'this_30_days',
	      //     latest: 2
	      //   }).then(res => {
	      //     this.setState({ lastPageviewData: res.result });
	      //   });
	      // }
	
	      var now = new Date().toISOString(),
	          tickets = _TicketStore2.default.getTicketsForPerson(newProps.personId),
	          soonestUpcoming = tickets.some(function (t) {
	        return t.event.start_time > now;
	      }) && tickets.filter(function (t) {
	        return t.event.start_time > now;
	      }).reduce(function (a, b) {
	        return a.event.start_time < b.event.start_time ? a : b;
	      }),
	          lastAttended = tickets.some(function (t) {
	        return t.used_at;
	      }) && tickets.filter(function (t) {
	        return t.used_at;
	      }).reduce(function (a, b) {
	        return a.used_at > b.used_at ? a : b;
	      });
	
	      this.setState({
	        soonestUpcoming: soonestUpcoming,
	        lastAttended: lastAttended
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var _state = this.state;
	      var soonestUpcoming = _state.soonestUpcoming;
	      var lastAttended = _state.lastAttended;
	      var _props = this.props;
	      var isFetchingTickets = _props.isFetchingTickets;
	      var personId = _props.personId;
	      var style = _props.style;
	      var person = _PersonStore2.default.getPersonById(personId);
	
	      if (!person || isFetchingTickets) {
	        return _react2.default.createElement(
	          "div",
	          { style: style },
	          _react2.default.createElement(_workingIndicator2.default, { centered: true })
	        );
	      }
	
	      return _react2.default.createElement(
	        "div",
	        { style: style },
	        _react2.default.createElement(
	          "div",
	          { style: STYLES.entry },
	          _react2.default.createElement(
	            "span",
	            { style: STYLES.entryLabel },
	            "Last seen online"
	          ),
	          _react2.default.createElement(
	            _keenChart2.default,
	            {
	              query: "extraction",
	              options: {
	                event_collection: "pageviews",
	                filters: [{
	                  operator: "eq",
	                  property_name: "person",
	                  property_value: this.props.personId
	                }],
	                timeframe: "this_30_days",
	                latest: 1
	              }
	            },
	            function (_ref) {
	              var data = _ref.data;
	              var message = _ref.message;
	
	              if (data) {
	                if (data.result.length) {
	                  var result = data.result[0],
	                      lastSeen = (0, _moment2.default)(result.keen.timestamp);
	
	                  return _react2.default.createElement(
	                    "div",
	                    null,
	                    _react2.default.createElement(
	                      "div",
	                      null,
	                      _react2.default.createElement(
	                        "span",
	                        { title: lastSeen.format("LLLL") },
	                        (0, _util.capitalize)(lastSeen.fromNow())
	                      ),
	                      " ",
	                      "near",
	                      " ",
	                      _react2.default.createElement(
	                        "a",
	                        {
	                          href: "https://www.google.com/maps/?q=" + result.geo.info.coordinates[1] + "," + result.geo.info.coordinates[0],
	                          target: "_blank"
	                        },
	                        result.geo.info.city || result.geo.info.country,
	                        result.geo.info.province && ", " + (STATES[result.geo.info.province] || result.geo.info.province)
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      null,
	                      "Viewed \"",
	                      _react2.default.createElement(
	                        "a",
	                        { href: result.page.url, target: "_blank" },
	                        result.page.title.split("|")[0].trim()
	                      ),
	                      "\" on ",
	                      result.tech.info.os.family
	                    )
	                  );
	                } else {
	                  return _react2.default.createElement(
	                    "div",
	                    null,
	                    "Not seen in the last 180 days"
	                  );
	                }
	              } else {
	                return _react2.default.createElement(
	                  "div",
	                  null,
	                  "Loading..."
	                );
	              }
	            }
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { style: STYLES.entry },
	          _react2.default.createElement(
	            "span",
	            { style: STYLES.entryLabel },
	            "Next upcoming event"
	          ),
	          soonestUpcoming ? _react2.default.createElement(
	            "span",
	            null,
	            _react2.default.createElement(
	              "span",
	              { style: STYLES.event_name },
	              soonestUpcoming.event.name
	            ),
	            "\xA0",
	            _react2.default.createElement(
	              "span",
	              { style: STYLES.event_time },
	              (0, _moment2.default)(soonestUpcoming.event.start_time).fromNow()
	            ),
	            _react2.default.createElement(_inlineLinkIconButton2.default, {
	              tooltip: "View event",
	              onTouchTap: function onTouchTap() {
	                return _this2.context.router.push("/event_buckets/" + soonestUpcoming.event_bucket + "/events/" + soonestUpcoming.event.id);
	              }
	            })
	          ) : _react2.default.createElement(
	            "span",
	            { style: STYLES.event_time },
	            "No upcoming events"
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { style: STYLES.entry },
	          _react2.default.createElement(
	            "span",
	            { style: STYLES.entryLabel },
	            "Last event attended"
	          ),
	          lastAttended ? _react2.default.createElement(
	            "span",
	            null,
	            _react2.default.createElement(
	              "span",
	              { style: STYLES.event_name },
	              lastAttended.event.name
	            ),
	            "\xA0",
	            _react2.default.createElement(
	              "span",
	              { style: STYLES.event_time },
	              (0, _moment2.default)(lastAttended.event.start_time).fromNow()
	            ),
	            _react2.default.createElement(_inlineLinkIconButton2.default, {
	              tooltip: "View event",
	              onTouchTap: function onTouchTap() {
	                return _this2.context.router.push("/event_buckets/" + lastAttended.event_bucket + "/events/" + lastAttended.event.id);
	              }
	            })
	          ) : _react2.default.createElement(
	            "span",
	            { style: STYLES.event_time },
	            "No events attended yet"
	          )
	        )
	      );
	    }
	  }], [{
	    key: "getStores",
	    value: function getStores() {
	      return [_TicketStore2.default, _PersonStore2.default];
	    }
	  }, {
	    key: "getPropsFromStores",
	    value: function getPropsFromStores() {
	      return {
	        isFetchingTickets: _TicketStore2.default.getState().isFetching
	      };
	    }
	  }]);
	
	  return PersonLatestInfo;
	}(_react2.default.Component);
	
	PersonLatestInfo.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	exports.default = (0, _connectToStores2.default)(PersonLatestInfo);
	module.exports = exports["default"];

/***/ }),
/* 2891 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.client = undefined;
	
	var _keenJs = __webpack_require__(1786);
	
	var _keenJs2 = _interopRequireDefault(_keenJs);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var client = exports.client = new _keenJs2.default({
	  projectId: ("59cb808dc9e77c00015e7d7e"),
	  readKey: ("6B86CA37027BF7E06F77CE41CFC4F728235A73F39BB8EABC5956A773664D41EA6D907DBFE4CBD4207B8587A8788EF2EDA769BF6D7D4BD6506A8DC3D1148998561D924B697E253D9DDCBC57F934D3F9FE9C9E2DCB6AAB7F049FE8DECF63705537")
	});

/***/ }),
/* 2892 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _isEqual = __webpack_require__(924);
	
	var _isEqual2 = _interopRequireDefault(_isEqual);
	
	var _keen = __webpack_require__(2891);
	
	var _chart = __webpack_require__(1785);
	
	var _chart2 = _interopRequireDefault(_chart);
	
	var _UserStore = __webpack_require__(974);
	
	var _UserStore2 = _interopRequireDefault(_UserStore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var KeenChart = function (_React$Component) {
	  _inherits(KeenChart, _React$Component);
	
	  function KeenChart(props) {
	    _classCallCheck(this, KeenChart);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(KeenChart).call(this, props));
	
	    _this.state = {
	      message: null,
	      data: null,
	      lastQuery: null,
	      lastOptions: null
	    };
	    return _this;
	  }
	
	  _createClass(KeenChart, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.componentWillReceiveProps(this.props);
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(newProps) {
	      var _this2 = this;
	
	      var query = newProps.query;
	      var options = newProps.options;
	      var forceGlobal = newProps.forceGlobal;
	      var processData = newProps.processData;
	
	
	      if (!forceGlobal) {
	        options.filters = options.filters || [];
	        options.filters.push({
	          operator: "eq",
	          property_name: "tenant.owner",
	          property_value: _UserStore2.default.getUserId()
	        });
	      }
	
	      // Don't run same query multiple times
	      if (query === this.state.lastQuery && (0, _isEqual2.default)(options, this.state.lastOptions)) {
	        return;
	      }
	
	      this.setState({ lastQuery: query, lastOptions: options });
	
	      _keen.client.query(query, options).then(function (data) {
	        if (processData) {
	          data = processData(data);
	        }
	
	        _this2.setState({ data: data });
	      }).catch(function (err) {
	        _this2.setState({ message: err.message });
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _props = this.props;
	      var query = _props.query;
	      var options = _props.options;
	      var forceGlobal = _props.forceGlobal;
	      var processData = _props.processData;
	      var children = _props.children;
	      var rest = _objectWithoutProperties(_props, ["query", "options", "forceGlobal", "processData", "children"]);
	      var _state = this.state;
	      var message = _state.message;
	      var data = _state.data;
	
	
	      if (children) {
	        return this.props.children({ message: message, data: data });
	      }
	
	      return _react2.default.createElement(_chart2.default, _extends({ data: data, message: message }, rest));
	    }
	  }]);
	
	  return KeenChart;
	}(_react2.default.Component);
	
	exports.default = KeenChart;
	module.exports = exports["default"];

/***/ }),
/* 2893 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _moment = __webpack_require__(1021);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _reactRouter = __webpack_require__(486);
	
	var _reactable = __webpack_require__(1688);
	
	var _materialUi = __webpack_require__(576);
	
	var _connectToStores = __webpack_require__(1226);
	
	var _connectToStores2 = _interopRequireDefault(_connectToStores);
	
	var _CreditStore = __webpack_require__(2894);
	
	var _CreditStore2 = _interopRequireDefault(_CreditStore);
	
	var _CreditActions = __webpack_require__(2895);
	
	var _CreditActions2 = _interopRequireDefault(_CreditActions);
	
	var _quantityEditor = __webpack_require__(2191);
	
	var _quantityEditor2 = _interopRequireDefault(_quantityEditor);
	
	var _label = __webpack_require__(1682);
	
	var _label2 = _interopRequireDefault(_label);
	
	var _linkLike = __webpack_require__(973);
	
	var _linkLike2 = _interopRequireDefault(_linkLike);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PAGE_SIZE = 5;
	
	var CreditsWidget = function (_React$Component) {
	  _inherits(CreditsWidget, _React$Component);
	
	  function CreditsWidget(props) {
	    _classCallCheck(this, CreditsWidget);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(CreditsWidget).call(this, props));
	
	    _this.state = {
	      currentPage: 0,
	      newChangeOpen: false,
	      newChangeQuantity: 0,
	      newChangeDescription: "Credit adjustment"
	    };
	
	    _this.showNewChange = _this.showNewChange.bind(_this);
	    _this.save = _this.save.bind(_this);
	    _this.hideNewChange = _this.hideNewChange.bind(_this);
	    return _this;
	  }
	
	  _createClass(CreditsWidget, [{
	    key: "componentWillMount",
	    value: function componentWillMount() {
	      this.componentWillReceiveProps(this.props);
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(props) {
	      var key = "" + props.person + props.eventBucket;
	      if (!this.state.fetched || this.state.fetched !== key) {
	        this.setState({ fetched: key }, function () {
	          _CreditActions2.default.fetchCreditRecordForPerson.defer({
	            person: props.person,
	            event_bucket: props.eventBucket
	          });
	        });
	      }
	    }
	  }, {
	    key: "showNewChange",
	    value: function showNewChange() {
	      this.setState({ newChangeOpen: true });
	    }
	  }, {
	    key: "save",
	    value: function save() {
	      _CreditActions2.default.addCreditRecordEvent({
	        person: this.props.person,
	        event_bucket: this.props.eventBucket,
	        credits_change: this.state.newChangeQuantity,
	        description: this.state.newChangeDescription
	      });
	      this.hideNewChange();
	    }
	  }, {
	    key: "hideNewChange",
	    value: function hideNewChange() {
	      this.setState({ newChangeOpen: false });
	    }
	  }, {
	    key: "_makeRowForEvent",
	    value: function _makeRowForEvent(event) {
	      return _react2.default.createElement(
	        _reactable.Tr,
	        { key: event.created_at },
	        _react2.default.createElement(
	          _reactable.Td,
	          { column: "Date" },
	          (0, _moment2.default)(event.created_at).format("lll")
	        ),
	        _react2.default.createElement(
	          _reactable.Td,
	          { column: "Change" },
	          "" + (event.credits_change > 0 ? "+" : "") + event.credits_change
	        ),
	        _react2.default.createElement(
	          _reactable.Td,
	          { column: "Description" },
	          event.description
	        )
	      );
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var record = this.props.getCreditRecordByPerson({
	        person: this.props.person,
	        event_bucket: this.props.eventBucket
	      });
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          _materialUi.Dialog,
	          {
	            title: "Credit adjustment",
	            openImmediately: true,
	            contentStyle: { maxWidth: 400 },
	            actions: [_react2.default.createElement(_materialUi.FlatButton, { label: "Cancel", onTouchTap: this.hideNewChange }), _react2.default.createElement(_materialUi.FlatButton, { primary: true, label: "Save", onTouchTap: this.save })],
	            modal: true,
	            open: this.state.newChangeOpen,
	            onRequestClose: this.hideNewChange
	          },
	          _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(
	              _label2.default,
	              null,
	              "Credit change (+/-)"
	            ),
	            _react2.default.createElement(_quantityEditor2.default, {
	              style: { marginTop: -14, marginLeft: -17 },
	              quantity: this.state.newChangeQuantity,
	              updateQuantity: function updateQuantity(q) {
	                return _this2.setState({ newChangeQuantity: q });
	              }
	            })
	          ),
	          _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(_materialUi.TextField, {
	              value: this.state.newChangeDescription,
	              floatingLabelText: "Description (customer-visible)",
	              floatingLabelFixed: true,
	              onChange: function onChange(e) {
	                return _this2.setState({ newChangeDescription: e.target.value });
	              }
	            })
	          ),
	          _react2.default.createElement(
	            "div",
	            {
	              style: { marginTop: "1em", marginBottom: "-0.75em", fontSize: 12 }
	            },
	            "When you click save, the customer will receive an email."
	          )
	        ),
	        this.props.showHeader ? _react2.default.createElement(
	          "h2",
	          { style: Object.assign({ height: 25 }, this.props.headerStyle) },
	          "Credits (",
	          record ? record.credits : 0,
	          " available)"
	        ) : null,
	        _react2.default.createElement(
	          "div",
	          { style: { float: "right", marginTop: -46 } },
	          _react2.default.createElement(_materialUi.RaisedButton, {
	            onClick: function onClick() {
	              return _this2.showNewChange();
	            },
	            label: "Manually adjust credits"
	          })
	        ),
	        _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement(
	            _reactable.Table,
	            {
	              className: "bordered striped responsive-table",
	              columns: ["Date", "Change", "Description"],
	              itemsPerPage: record && record.events.length > PAGE_SIZE ? PAGE_SIZE : undefined,
	              currentPage: this.state.currentPage,
	              onPageChange: function onPageChange(p) {
	                return _this2.setState({ currentPage: p });
	              }
	            },
	            record ? record.events.sort(function (a, b) {
	              return b.created_at.localeCompare(a.created_at) || b.description.localeCompare(a.description);
	            }).map(this._makeRowForEvent) : []
	          )
	        ),
	        !record || record.events.length === 0 ? _react2.default.createElement(
	          "div",
	          { className: "empty-table-message" },
	          "No credits issued yet.",
	          " ",
	          _react2.default.createElement(
	            _linkLike2.default,
	            { onTouchTap: function onTouchTap() {
	                return _this2.showNewChange();
	              } },
	            "Manually issue credits."
	          )
	        ) : null
	      );
	    }
	  }], [{
	    key: "getStores",
	    value: function getStores() {
	      return [_CreditStore2.default];
	    }
	  }, {
	    key: "getPropsFromStores",
	    value: function getPropsFromStores() {
	      return {
	        getCreditRecordByPerson: _CreditStore2.default.getCreditRecordByPerson
	      };
	    }
	  }]);
	
	  return CreditsWidget;
	}(_react2.default.Component);
	
	exports.default = (0, _connectToStores2.default)(CreditsWidget);
	module.exports = exports["default"];

/***/ }),
/* 2894 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _alt = __webpack_require__(975);
	
	var _alt2 = _interopRequireDefault(_alt);
	
	var _keyBy = __webpack_require__(990);
	
	var _keyBy2 = _interopRequireDefault(_keyBy);
	
	var _extend = __webpack_require__(1212);
	
	var _extend2 = _interopRequireDefault(_extend);
	
	var _values = __webpack_require__(1214);
	
	var _values2 = _interopRequireDefault(_values);
	
	var _CreditActions = __webpack_require__(2895);
	
	var _CreditActions2 = _interopRequireDefault(_CreditActions);
	
	var _CreditUtil = __webpack_require__(2896);
	
	var _CreditUtil2 = _interopRequireDefault(_CreditUtil);
	
	var _UserStore = __webpack_require__(974);
	
	var _UserStore2 = _interopRequireDefault(_UserStore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var CreditStore = function () {
	  function CreditStore() {
	    _classCallCheck(this, CreditStore);
	
	    this.bindActions(_CreditActions2.default);
	
	    this.state = {
	      creditRecords: {}
	    };
	
	    this.exportPublicMethods({
	      getCreditRecordByPerson: this.getCreditRecordByPerson.bind(this)
	    });
	  }
	
	  _createClass(CreditStore, [{
	    key: "getCreditRecordByPerson",
	    value: function getCreditRecordByPerson(_ref) {
	      var person = _ref.person;
	      var event_bucket = _ref.event_bucket;
	
	      return this.state.creditRecords[person + "--" + event_bucket];
	    }
	  }, {
	    key: "onFetchCreditRecordForPerson",
	    value: function onFetchCreditRecordForPerson(_ref2) {
	      var _this = this;
	
	      var person = _ref2.person;
	      var event_bucket = _ref2.event_bucket;
	
	      this.setState({ isFetching: true });
	      _CreditUtil2.default.fetchCreditsForPerson(_UserStore2.default.getState().apiKey, person, event_bucket).then(function (data) {
	        var records = Object.assign(_this.state.creditRecords, _defineProperty({}, person + "--" + event_bucket, data));
	        _this.setState({
	          isFetching: false,
	          creditRecords: records
	        });
	      }).catch(_CreditActions2.default.fetchFailed);
	    }
	  }, {
	    key: "onAddCreditRecordEvent",
	    value: function onAddCreditRecordEvent(opts) {
	      var _this2 = this;
	
	      this.setState({ isEditing: true });
	      var person = opts.person;
	
	      var rest = _objectWithoutProperties(opts, ["person"]);
	
	      _CreditUtil2.default.addCreditRecordEvent(_UserStore2.default.getState().apiKey, person, rest).then(function (data) {
	        var records = Object.assign(_this2.state.creditRecords, _defineProperty({}, person + "--" + rest.event_bucket, data));
	        _this2.setState({
	          isEditing: false,
	          creditRecords: records
	        });
	      }).catch(_CreditActions2.default.editFailed);
	    }
	  }, {
	    key: "onFetchFailed",
	    value: function onFetchFailed(e) {
	      window.alert("Fetching credits failed: " + e.message);
	    }
	  }, {
	    key: "onEditFailed",
	    value: function onEditFailed(e) {
	      window.alert("Updating credits failed: " + e.message);
	    }
	  }]);
	
	  return CreditStore;
	}();
	
	exports.default = _alt2.default.createStore(CreditStore, "CreditStore");
	module.exports = exports["default"];

/***/ }),
/* 2895 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _alt = __webpack_require__(975);
	
	var _alt2 = _interopRequireDefault(_alt);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var CreditActions = function CreditActions() {
	  _classCallCheck(this, CreditActions);
	
	  this.generateActions("fetchCreditRecordForPerson", "fetchFailed", "addCreditRecordEvent", "editFailed");
	};
	
	exports.default = _alt2.default.createActions(CreditActions);
	module.exports = exports["default"];

/***/ }),
/* 2896 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _api = __webpack_require__(1160);
	
	var _api2 = _interopRequireDefault(_api);
	
	var _config = __webpack_require__(1173);
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  fetchCreditsForPerson: function fetchCreditsForPerson(apiKey, id, event_bucket) {
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "GET",
	        endpoint: "people/" + id + "/credits?event_bucket=" + event_bucket,
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response);
	      });
	    });
	  },
	  addCreditRecordEvent: function addCreditRecordEvent(apiKey, personId, body) {
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "POST",
	        endpoint: "people/" + personId + "/credits/add",
	        json: body,
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response);
	      });
	    });
	  }
	};
	module.exports = exports["default"];

/***/ }),
/* 2897 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _values = __webpack_require__(1214);
	
	var _values2 = _interopRequireDefault(_values);
	
	var _materialUi = __webpack_require__(576);
	
	var _reactable = __webpack_require__(1688);
	
	var _reactRouter = __webpack_require__(486);
	
	var _config = __webpack_require__(1173);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _orderTable = __webpack_require__(2764);
	
	var _orderTable2 = _interopRequireDefault(_orderTable);
	
	var _tableRefreshIndicator = __webpack_require__(1686);
	
	var _tableRefreshIndicator2 = _interopRequireDefault(_tableRefreshIndicator);
	
	var _connectToStores = __webpack_require__(1226);
	
	var _connectToStores2 = _interopRequireDefault(_connectToStores);
	
	var _OrderActions = __webpack_require__(1220);
	
	var _OrderActions2 = _interopRequireDefault(_OrderActions);
	
	var _OrderStore = __webpack_require__(2050);
	
	var _OrderStore2 = _interopRequireDefault(_OrderStore);
	
	var _UserStore = __webpack_require__(974);
	
	var _UserStore2 = _interopRequireDefault(_UserStore);
	
	var _UserActions = __webpack_require__(1158);
	
	var _UserActions2 = _interopRequireDefault(_UserActions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Order = function (_React$Component) {
	  _inherits(Order, _React$Component);
	
	  function Order(props) {
	    _classCallCheck(this, Order);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(Order).call(this, props));
	
	    _this.state = {
	      showZeroOrders: true,
	      isGodView: false
	    };
	
	    _this._makeCsvLink = _this._makeCsvLink.bind(_this);
	    _this._onShowZeroOrderCheck = _this._onShowZeroOrderCheck.bind(_this);
	    _this._refresh = _this._refresh.bind(_this);
	    _this._onFetchMore = _this._onFetchMore.bind(_this);
	    _this._onFetchALotMore = _this._onFetchALotMore.bind(_this);
	    return _this;
	  }
	
	  _createClass(Order, [{
	    key: "getStyles",
	    value: function getStyles() {
	      return {
	        actions: {
	          paddingTop: 20,
	          marginTop: 20,
	          borderTop: "1px solid #ccc"
	        },
	        config: {
	          // borderBottom: '1px solid #ccc',
	          paddingBottom: 10,
	          marginBottom: 10
	        },
	        fetchMoreContainer: {
	          marginTop: 20,
	          textAlign: "center"
	        },
	        fetchMoreButton: {
	          paddingLeft: 16,
	          paddingRight: 16,
	          fontSize: "14px",
	          fontWeight: "500",
	          textTransform: "uppercase"
	        }
	      };
	    }
	  }, {
	    key: "_onShowZeroOrderCheck",
	    value: function _onShowZeroOrderCheck(e, checked) {
	      this.setState({ showZeroOrders: checked });
	    }
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      _OrderActions2.default.fetchMore.defer({
	        top: true,
	        eventBucket: this.props.params.eventBucketId,
	        godOrders: this.props.route.name === "god-orders"
	      });
	      this.setState({
	        isGodView: this.props.route.name === "god-orders"
	      });
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(newProps) {
	      this.setState({
	        isGodView: newProps.route.name === "god-orders"
	      });
	    }
	  }, {
	    key: "_makeCsvLink",
	    value: function _makeCsvLink() {
	      var bucket = this.props.params.eventBucketId;
	
	      return _config2.default.endpoint + "orders.csv?" + _UserStore2.default.makeApiKeyQueryString() + (bucket ? "&conditions=" + JSON.stringify({ event_bucket: bucket }) : "");
	    }
	  }, {
	    key: "_refresh",
	    value: function _refresh() {
	      _OrderActions2.default.fetchMore({
	        top: true,
	        eventBucket: this.props.params.eventBucketId,
	        godOrders: this.state.isGodView
	      });
	    }
	  }, {
	    key: "_onFetchMore",
	    value: function _onFetchMore() {
	      _OrderActions2.default.fetchMore({
	        eventBucket: this.props.params.eventBucketId,
	        godOrders: this.state.isGodView
	      });
	    }
	  }, {
	    key: "_onFetchALotMore",
	    value: function _onFetchALotMore() {
	      _OrderActions2.default.fetchMore({
	        limit: 300,
	        eventBucket: this.props.params.eventBucketId,
	        godOrders: this.state.isGodView
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var orders = void 0,
	          styles = this.getStyles(),
	          eventBucket = this.props.params.eventBucketId;
	
	      if (eventBucket) {
	        orders = this.props.getOrdersForEventBucket(eventBucket);
	      } else {
	        orders = (0, _values2.default)(this.props.orders);
	        if (!this.state.isGodView && this.props.activeGodUser) {
	          orders = orders.filter(function (o) {
	            return o.owner === _this2.props.activeGodUser;
	          });
	        }
	      }
	
	      if (!this.state.showZeroOrders) {
	        orders = orders.filter(function (o) {
	          return o.purchase_price;
	        });
	      }
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          "h1",
	          { className: "page-title" },
	          "Orders"
	        ),
	        this.state.isGodView ? _react2.default.createElement(
	          "h1",
	          null,
	          "God Orders"
	        ) : null,
	        _react2.default.createElement(
	          "div",
	          { style: styles.config },
	          _react2.default.createElement(_materialUi.Checkbox, {
	            defaultChecked: true,
	            label: "Show $0.00 orders",
	            style: { float: "left", width: 200 },
	            onCheck: this._onShowZeroOrderCheck
	          }),
	          _react2.default.createElement(_tableRefreshIndicator2.default, {
	            isRefreshing: this.props.isFetchingMore,
	            onRefresh: this._refresh
	          })
	        ),
	        _react2.default.createElement(_orderTable2.default, {
	          orders: orders,
	          eventBucket: eventBucket,
	          location: this.props.location,
	          noSort: true,
	          hideNoOrdersMessage: this.props.isFetchingMore,
	          showEventBucket: this.state.isGodView,
	          onClick: function onClick(order) {
	            if (_this2.state.isGodView) {
	              _UserActions2.default.setGodUser(order.owner);
	            }
	          }
	        }),
	        _react2.default.createElement(
	          "div",
	          { style: styles.fetchMoreContainer },
	          _react2.default.createElement(
	            _materialUi.FlatButton,
	            {
	              style: styles.fetchMoreButton,
	              onTouchTap: this._onFetchMore,
	              disabled: this.props.haveFetchedAll || this.props.isFetchingMore
	            },
	            this.props.isFetchingMore ? "Loading..." : this.props.haveFetchedAll ? "All orders loaded" : "Load 50 earlier orders"
	          ),
	          !this.props.haveFetchedAll && !this.props.isFetchingMore ? _react2.default.createElement(
	            _materialUi.FlatButton,
	            {
	              style: styles.fetchMoreButton,
	              onTouchTap: this._onFetchALotMore
	            },
	            "Load 300"
	          ) : null
	        ),
	        _react2.default.createElement(
	          "div",
	          { style: styles.actions },
	          _react2.default.createElement(
	            "p",
	            null,
	            "To download a CSV of these or all orders, use",
	            " ",
	            _react2.default.createElement(
	              _reactRouter.Link,
	              { to: "/reports" },
	              "Reports"
	            ),
	            "."
	          )
	        )
	      );
	    }
	  }], [{
	    key: "getStores",
	    value: function getStores() {
	      return [_OrderStore2.default, _UserStore2.default];
	    }
	  }, {
	    key: "getPropsFromStores",
	    value: function getPropsFromStores() {
	      var state = _OrderStore2.default.getState();
	      state.getOrdersForEventBucket = _OrderStore2.default.getOrdersForEventBucket;
	      state.apiKey = _UserStore2.default.getState().apiKey;
	      state.activeGodUser = _UserStore2.default.getState().activeGodUser;
	      return state;
	    }
	  }, {
	    key: "contextTypes",
	    get: function get() {
	      return {
	        router: _react2.default.PropTypes.object
	      };
	    }
	  }]);
	
	  return Order;
	}(_react2.default.Component);
	
	exports.default = (0, _connectToStores2.default)(Order);
	module.exports = exports["default"];

/***/ }),
/* 2898 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _moment = __webpack_require__(1021);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _materialUi = __webpack_require__(576);
	
	var _util = __webpack_require__(1183);
	
	var _passTable = __webpack_require__(2738);
	
	var _passTable2 = _interopRequireDefault(_passTable);
	
	var _ticketTable = __webpack_require__(2694);
	
	var _ticketTable2 = _interopRequireDefault(_ticketTable);
	
	var _itemTable = __webpack_require__(2755);
	
	var _itemTable2 = _interopRequireDefault(_itemTable);
	
	var _ledgerTable = __webpack_require__(2899);
	
	var _ledgerTable2 = _interopRequireDefault(_ledgerTable);
	
	var _label = __webpack_require__(1682);
	
	var _label2 = _interopRequireDefault(_label);
	
	var _linkLike = __webpack_require__(973);
	
	var _linkLike2 = _interopRequireDefault(_linkLike);
	
	var _quillEditor = __webpack_require__(2169);
	
	var _quillEditor2 = _interopRequireDefault(_quillEditor);
	
	var _connectToStores = __webpack_require__(1226);
	
	var _connectToStores2 = _interopRequireDefault(_connectToStores);
	
	var _OrderActions = __webpack_require__(1220);
	
	var _OrderActions2 = _interopRequireDefault(_OrderActions);
	
	var _OrderStore = __webpack_require__(2050);
	
	var _OrderStore2 = _interopRequireDefault(_OrderStore);
	
	var _UserStore = __webpack_require__(974);
	
	var _UserStore2 = _interopRequireDefault(_UserStore);
	
	var _PersonStore = __webpack_require__(2656);
	
	var _PersonStore2 = _interopRequireDefault(_PersonStore);
	
	var _PersonActions = __webpack_require__(2658);
	
	var _PersonActions2 = _interopRequireDefault(_PersonActions);
	
	var _EventBucketStore = __webpack_require__(1593);
	
	var _EventBucketStore2 = _interopRequireDefault(_EventBucketStore);
	
	var _GlobalNotificationActions = __webpack_require__(1182);
	
	var _GlobalNotificationActions2 = _interopRequireDefault(_GlobalNotificationActions);
	
	var _refund = __webpack_require__(2703);
	
	var _refund2 = _interopRequireDefault(_refund);
	
	var _workingIndicator = __webpack_require__(1664);
	
	var _workingIndicator2 = _interopRequireDefault(_workingIndicator);
	
	var _notes = __webpack_require__(2884);
	
	var _notes2 = _interopRequireDefault(_notes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Order = function (_React$Component) {
	  _inherits(Order, _React$Component);
	
	  function Order(props) {
	    _classCallCheck(this, Order);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(Order).call(this, props));
	
	    _this.state = {
	      refunding: false,
	      isResendingBulk: false,
	      bulkCurrentlyResending: null,
	      showBulkImportEditor: false,
	      bulkImportMessage: ""
	    };
	
	    _this.resend = _this.resend.bind(_this);
	    _this.downloadReceipt = _this.downloadReceipt.bind(_this);
	    _this.refund = _this.refund.bind(_this);
	    _this.addEmail = _this.addEmail.bind(_this);
	
	    _this.bulkImportLoadDetails = _this.bulkImportLoadDetails.bind(_this);
	    _this.bulkImportResend = _this.bulkImportResend.bind(_this);
	    return _this;
	  }
	
	  _createClass(Order, [{
	    key: "getStyles",
	    value: function getStyles() {
	      return {
	        topBarButton: {
	          whiteSpace: "nowrap",
	          overflowX: "hidden",
	          marginLeft: 5,
	          marginRight: 5
	        },
	        details: {
	          marginTop: 20,
	          marginBottom: 20,
	          border: "1px solid #ccc",
	          padding: 15,
	          paddingTop: 25
	        },
	        price: {
	          fontSize: 29,
	          fontWeight: "bold",
	          marginBottom: 3
	        },
	        netPrice: {
	          fontSize: 18,
	          color: "rgb(140, 140, 140)"
	        },
	        subtitle: {
	          fontSize: 16
	        },
	        chips: {
	          marginLeft: -4,
	          display: "flex",
	          flexWrap: "wrap"
	        },
	        chip: {
	          margin: 4
	        },
	        section: {
	          border: "1px solid #ccc",
	          padding: 15,
	          marginBottom: 20
	        },
	        personMain: {
	          fontSize: 20,
	          fontWeight: "bold"
	        },
	        personSub: {
	          fontSize: 15
	        },
	        notesHeader: {
	          fontSize: 20,
	          fontWeight: "bold"
	        },
	        bulkInfo: {
	          fontSize: 16
	        }
	      };
	    }
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      _OrderActions2.default.fetchOne(this.props.params.orderId);
	    }
	  }, {
	    key: "resend",
	    value: function resend() {
	      var opts = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	      this.setState({ isResending: true });
	      _GlobalNotificationActions2.default.notify.defer("Resending confirmation email...");
	      _OrderActions2.default.resendConfirmation(Object.assign({ id: this.props.params.orderId }, opts.refund && { refund_confirmation: true }));
	    }
	  }, {
	    key: "resendGift",
	    value: function resendGift() {
	      var opts = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	      this.setState({ isResending: true });
	      _GlobalNotificationActions2.default.notify.defer("Resending confirmation email...");
	      _OrderActions2.default.resendGiftNotification(this.props.params.orderId);
	    }
	  }, {
	    key: "downloadReceipt",
	    value: function downloadReceipt() {
	      _OrderActions2.default.downloadReceipt(this.props.params.orderId);
	    }
	  }, {
	    key: "refund",
	    value: function refund(amount) {
	      this.setState({ refunding: false, isRefunding: true });
	      _GlobalNotificationActions2.default.notify.defer("Refunding order...");
	      _OrderActions2.default.refund(this.props.params.orderId, amount);
	    }
	  }, {
	    key: "addEmail",
	    value: function addEmail() {
	      var email = window.prompt("Please enter the email address to connect to the order.");
	
	      if (!email) {
	        return;
	      }
	
	      _OrderActions2.default.edit(this.props.params.orderId, {
	        box_office_email: email
	      });
	    }
	  }, {
	    key: "bulkImportLoadDetails",
	    value: function bulkImportLoadDetails() {
	      var bulkInfo = this.props.orders[this.props.params.orderId]._bulk_import,
	          message = Object.values(bulkInfo)[0].extra_message;
	
	      _PersonActions2.default.fetchAll({
	        conditions: { _from_bulk_order: this.props.params.orderId }
	      });
	      delete this.props.orders[this.props.params.orderId].bulkResent;
	      _OrderActions2.default.updateOrder(this.props.orders[this.props.params.orderId]);
	      this.setState({
	        isResendingBulk: true,
	        showBulkImportEditor: !!message,
	        bulkImportMessage: message
	      });
	    }
	  }, {
	    key: "bulkImportResend",
	    value: function () {
	      var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(person, order) {
	        var _this2 = this;
	
	        var persons, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, p;
	
	        return regeneratorRuntime.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                if (!(person === "all")) {
	                  _context.next = 31;
	                  break;
	                }
	
	                if (!window.confirm("Are you sure? All confirmations will be resent immediately.")) {
	                  _context.next = 30;
	                  break;
	                }
	
	                persons = Object.keys(order._bulk_import).map(function (k) {
	                  return {
	                    person: _this2.props.people[k],
	                    data: order._bulk_import[k]
	                  };
	                }).sort(function (a, b) {
	                  return (a.person.details.name || a.person.details.email).localeCompare(b.person.details.name || b.person.details.email);
	                });
	                _iteratorNormalCompletion = true;
	                _didIteratorError = false;
	                _iteratorError = undefined;
	                _context.prev = 6;
	                _iterator = persons[Symbol.iterator]();
	
	              case 8:
	                if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
	                  _context.next = 16;
	                  break;
	                }
	
	                p = _step.value;
	
	                this.bulkImportResend(p.person.id);
	                _context.next = 13;
	                return new Promise(function (resolve) {
	                  return setTimeout(function () {
	                    return resolve();
	                  }, 750);
	                });
	
	              case 13:
	                _iteratorNormalCompletion = true;
	                _context.next = 8;
	                break;
	
	              case 16:
	                _context.next = 22;
	                break;
	
	              case 18:
	                _context.prev = 18;
	                _context.t0 = _context["catch"](6);
	                _didIteratorError = true;
	                _iteratorError = _context.t0;
	
	              case 22:
	                _context.prev = 22;
	                _context.prev = 23;
	
	                if (!_iteratorNormalCompletion && _iterator.return) {
	                  _iterator.return();
	                }
	
	              case 25:
	                _context.prev = 25;
	
	                if (!_didIteratorError) {
	                  _context.next = 28;
	                  break;
	                }
	
	                throw _iteratorError;
	
	              case 28:
	                return _context.finish(25);
	
	              case 29:
	                return _context.finish(22);
	
	              case 30:
	                return _context.abrupt("return");
	
	              case 31:
	
	                _OrderActions2.default.resendConfirmation({
	                  id: this.props.params.orderId,
	                  bulk_person: person,
	                  extra_message: this.state.bulkImportMessage
	                });
	                this.setState({ bulkCurrentlyResending: person });
	
	              case 33:
	              case "end":
	                return _context.stop();
	            }
	          }
	        }, _callee, this, [[6, 18, 22, 30], [23,, 25, 29]]);
	      }));
	
	      function bulkImportResend(_x3, _x4) {
	        return _ref.apply(this, arguments);
	      }
	
	      return bulkImportResend;
	    }()
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(newProps) {
	      var order = newProps.orders[this.props.params.orderId];
	
	      if (this.state.isRefunding && order.refunded_at && newProps.refundSuccess) {
	        this.setState({ isRefunding: false });
	        _GlobalNotificationActions2.default.notify.defer("Order refunded successfully.");
	        _OrderActions2.default.clearErrors.defer();
	      }
	
	      if (this.state.isResending && order.confirmationResent) {
	        this.setState({ isResending: false });
	        _GlobalNotificationActions2.default.notify.defer("Confirmation resent successfully.");
	        _OrderActions2.default.clearErrors.defer();
	      }
	
	      if (this.state.bulkCurrentlyResending && order.bulkResent) {
	        this.setState({ bulkCurrentlyResending: null });
	        _GlobalNotificationActions2.default.notify.defer("Activation email resent successfully.");
	        _OrderActions2.default.clearErrors.defer();
	      }
	
	      if (newProps.resendConfirmationErrorMessage) {
	        _GlobalNotificationActions2.default.notify.defer("Error resending confirmation: " + newProps.resendConfirmationErrorMessage);
	        _OrderActions2.default.clearErrors.defer();
	      }
	
	      if (newProps.refundErrorMessage) {
	        this.setState({
	          refunding: true,
	          refundErrorMessage: newProps.refundErrorMessage
	        });
	        _OrderActions2.default.clearErrors.defer();
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this3 = this;
	
	      var person = void 0,
	          styles = this.getStyles(),
	          currentEventBucket = this.props.params.eventBucketId,
	          order = this.props.orders[this.props.params.orderId];
	
	      if (!currentEventBucket) {
	        currentEventBucket = order && order.event_bucket && order.event_bucket.id ? order.event_bucket.id : "";
	      }
	
	      if (!order) {
	        return _react2.default.createElement(_workingIndicator2.default, { fullPage: true });
	      }
	
	      if (order.person) {
	        person = order.person.details;
	        person.id = order.person.id;
	      }
	
	      // Handle legacy full refunds
	      if (order.refunded_at && !order.original_price) {
	        order.original_price = order.purchase_price;
	        order.purchase_price = 0;
	      }
	
	      var fullEventBucket = this.props.getEventBucketById(currentEventBucket);
	
	      var isSundance = fullEventBucket && fullEventBucket.frontend_config ? fullEventBucket.frontend_config.sundance_login : false;
	      var showTransferHistory = fullEventBucket && fullEventBucket.frontend_config ? fullEventBucket.frontend_config.enable_transfer_history : false;
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        this.state.refunding ? _react2.default.createElement(_refund2.default, {
	          order: order,
	          onRefund: this.refund,
	          refundErrorMessage: this.state.refundErrorMessage,
	          onRequestClose: function onRequestClose() {
	            return _this3.setState({ refunding: false, refundErrorMessage: null });
	          }
	        }) : null,
	        _react2.default.createElement(
	          _materialUi.Toolbar,
	          null,
	          _react2.default.createElement(
	            _materialUi.ToolbarGroup,
	            { style: { minWidth: 0 } },
	            _react2.default.createElement(_materialUi.ToolbarTitle, {
	              style: { paddingRight: 0 },
	              text: "Order #" + order.id
	            })
	          ),
	          _react2.default.createElement(
	            _materialUi.ToolbarGroup,
	            {
	              style: order.refunded_at ? { minWidth: 730 } : { minWidth: 300 }
	            },
	            [_react2.default.createElement(_materialUi.RaisedButton, {
	              label: "Resend confirmation",
	              primary: false,
	              style: styles.topBarButton,
	              onTouchTap: function onTouchTap() {
	                return _this3.resend();
	              }
	            })].concat(order.gift_cards && order.gift_cards.length > 0 ? [_react2.default.createElement(_materialUi.RaisedButton, {
	              label: "Resend gift notification",
	              primary: false,
	              style: styles.topBarButton,
	              onTouchTap: function onTouchTap() {
	                return _this3.resendGift();
	              }
	            })] : []).concat(order.refunded_at ? [_react2.default.createElement(_materialUi.RaisedButton, {
	              label: "Resend refund confirmation",
	              primary: false,
	              style: styles.topBarButton,
	              onTouchTap: function onTouchTap() {
	                return _this3.resend({ refund: true });
	              }
	            })] : []).concat([_react2.default.createElement(_materialUi.RaisedButton, {
	              label: "Download receipt",
	              primary: false,
	              style: styles.topBarButton,
	              onTouchTap: this.downloadReceipt
	            })]).concat(order.refunded_at && order.purchase_price === 0 ? [_react2.default.createElement(_materialUi.RaisedButton, {
	              label: "Refunded",
	              primary: false,
	              style: Object.assign({}, styles.topBarButton, {
	                marginRight: 0
	              }),
	              disabled: true
	            })] : [_react2.default.createElement(_materialUi.RaisedButton, {
	              label: "Refund",
	              disabled: !_UserStore2.default.hasPermission("manage_orders"),
	              primary: false,
	              style: Object.assign({}, styles.topBarButton, {
	                marginRight: 0
	              }),
	              onTouchTap: function onTouchTap() {
	                return _this3.setState({
	                  refunding: true,
	                  refundErrorMessage: null
	                });
	              }
	            })])
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { style: styles.details },
	          _react2.default.createElement(
	            "div",
	            { style: styles.price },
	            (0, _util.formatPrice)(order.purchase_price || 0),
	            " ",
	            _react2.default.createElement(
	              "span",
	              { style: styles.netPrice },
	              (0, _util.formatPrice)(order.net_price || 0, order.platform_managed && { currency: "usd" }),
	              " ",
	              "net",
	              order.tax_collected ? " (" + (!order.platform_managed ? "+" : "incl.") + " " + (0, _util.formatPrice)(order.tax_collected) + " tax)" : "",
	              order.refunded_at ? " (refunded from " + (0, _util.formatPrice)(order.original_price || order.purchase_price) + ")" : ""
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { style: styles.subtitle },
	            _react2.default.createElement(
	              "div",
	              null,
	              order.summary
	            ),
	            order.gift_cards && order.gift_cards.length > 0 ? _react2.default.createElement(
	              "div",
	              null,
	              order.gift_cards[0].code
	            ) : null,
	            _react2.default.createElement(
	              "div",
	              null,
	              (0, _moment2.default)(order.created_at).format("LLLL")
	            ),
	            order.refunded_at ? _react2.default.createElement(
	              "div",
	              null,
	              _react2.default.createElement(
	                "strong",
	                null,
	                "Refunded ",
	                (0, _moment2.default)(order.refunded_at).format("LLLL")
	              )
	            ) : null,
	            order.origin_location && order.origin_location.ip ? order.origin_location.city ? _react2.default.createElement(
	              "div",
	              null,
	              "Placed from",
	              " ",
	              _react2.default.createElement(
	                "span",
	                {
	                  title: "(" + order.origin_location.latitude + ", " + order.origin_location.longitude + ")"
	                },
	                order.origin_location.city,
	                ", ",
	                order.origin_location.region,
	                " ",
	                order.origin_location.postal ? "(" + order.origin_location.postal + ")" : ""
	              )
	            ) : _react2.default.createElement(
	              "div",
	              null,
	              "Placed from IP address ",
	              order.origin_location.ip
	            ) : null,
	            order.additional_message ? _react2.default.createElement(
	              "div",
	              null,
	              "Additional message: ",
	              _react2.default.createElement(
	                "em",
	                null,
	                order.additional_message
	              )
	            ) : null
	          ),
	          _react2.default.createElement(
	            "div",
	            { style: styles.chips },
	            order.type === "kiosk" ? _react2.default.createElement(
	              _materialUi.Chip,
	              {
	                style: styles.chip,
	                onTouchTap: function onTouchTap() {
	                  return _this3.context.router.push("/event_buckets/" + order.event_bucket.id + "/kiosks/" + order.kiosk.id);
	                }
	              },
	              "Kiosk used: ",
	              order.kiosk.name
	            ) : null,
	            order.type === "box_office" ? _react2.default.createElement(
	              _materialUi.Chip,
	              { style: styles.chip },
	              "Box Office (",
	              order.subtype,
	              ")"
	            ) : null,
	            order.type === "check_in" ? _react2.default.createElement(
	              _materialUi.Chip,
	              { style: styles.chip },
	              "Created at Check-In"
	            ) : null,
	            order.type === "admin_adjustment" ? _react2.default.createElement(
	              _materialUi.Chip,
	              { style: styles.chip },
	              "Admin Adjustment"
	            ) : null,
	            order.type === "rush_line" ? _react2.default.createElement(
	              _materialUi.Chip,
	              { style: styles.chip },
	              "Rush Line (",
	              order.subtype,
	              ")"
	            ) : null,
	            order.type === "autorenewal" ? _react2.default.createElement(
	              _materialUi.Chip,
	              { style: styles.chip },
	              "Autorenewal"
	            ) : null,
	            order.type === "bulk" ? _react2.default.createElement(
	              _materialUi.Chip,
	              { style: styles.chip },
	              "Bulk order"
	            ) : null,
	            order.type === "instant_ticket" ? _react2.default.createElement(
	              _materialUi.Chip,
	              { style: styles.chip },
	              "Instant Ticket"
	            ) : null,
	            order.coupon ? _react2.default.createElement(
	              _materialUi.Chip,
	              {
	                style: styles.chip,
	                onTouchTap: function onTouchTap() {
	                  return _this3.context.router.push("/event_buckets/" + order.event_bucket.id + "/coupons/" + order.coupon.id);
	                }
	              },
	              "Discount used: ",
	              order.coupon.name,
	              " ",
	              order.coupon.code && "(" + order.coupon.code + ")"
	            ) : null,
	            order.subtype === "check" ? _react2.default.createElement(
	              _materialUi.Chip,
	              { style: styles.chip },
	              "Check # ",
	              order.check_number || "not entered"
	            ) : null,
	            order.sold_by_user_account ? _react2.default.createElement(
	              _materialUi.Chip,
	              { style: styles.chip },
	              "Sold by ",
	              order.sold_by_user_account.name
	            ) : null,
	            order.presentment_currency ? _react2.default.createElement(
	              _materialUi.Chip,
	              { style: styles.chip },
	              "Sold as",
	              " ",
	              (0, _util.formatPrice)(order.presentment_purchase_price, {
	                currency: order.presentment_currency
	              }),
	              " ",
	              "(",
	              order.presentment_currency.toUpperCase(),
	              ")"
	            ) : null,
	            order.tracking_data ? Object.keys(order.tracking_data).map(function (key) {
	              return _react2.default.createElement(
	                _materialUi.Chip,
	                { key: key, style: styles.chip },
	                "Tracking ",
	                key,
	                ": ",
	                order.tracking_data[key]
	              );
	            }) : null
	          )
	        ),
	        order.box_office_email ? _react2.default.createElement(
	          "div",
	          { style: styles.section },
	          _react2.default.createElement(
	            "div",
	            { style: styles.personMain },
	            order.box_office_email
	          ),
	          _react2.default.createElement(
	            "div",
	            { style: styles.personSub },
	            "Via ",
	            order.type === "web" ? "guest checkout" : "box office"
	          )
	        ) : null,
	        order.type === "bulk" && order._bulk_import ? _react2.default.createElement(
	          "div",
	          { style: styles.section },
	          _react2.default.createElement(
	            "h2",
	            null,
	            "Bulk import info"
	          ),
	          order.passes.some(function (p) {
	            return p.pass_bucket.is_membership;
	          }) ? _react2.default.createElement(
	            "div",
	            { style: styles.bulkInfo },
	            order.passes.length,
	            " ",
	            order.passes.length === 1 ? "membership was" : "memberships were",
	            " imported and ",
	            order.passes.length === 1 ? "was" : "were",
	            " associated with",
	            " ",
	            Object.keys(order._bulk_import).length,
	            " unique account",
	            Object.keys(order._bulk_import).length === 1 ? "" : "s",
	            "."
	          ) : _react2.default.createElement(
	            "div",
	            { style: styles.bulkInfo },
	            order.passes.length,
	            " ",
	            order.passes.length === 1 ? "pass was" : "passes were",
	            " imported and ",
	            order.passes.length === 1 ? "was" : "were",
	            " associated with",
	            " ",
	            Object.keys(order._bulk_import).length,
	            " unique account",
	            Object.keys(order._bulk_import).length === 1 ? "" : "s",
	            "."
	          ),
	          this.state.isResendingBulk && this.props.isFetchingPeople ? _react2.default.createElement(
	            "div",
	            { style: styles.bulkInfo },
	            "Loading available recipients...",
	            " ",
	            _react2.default.createElement(
	              _linkLike2.default,
	              {
	                onTouchTap: function onTouchTap() {
	                  return _this3.setState({ isResendingBulk: false });
	                }
	              },
	              "Cancel"
	            )
	          ) : this.state.isResendingBulk ? _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(
	              "div",
	              { style: styles.bulkInfo },
	              "Select a person to resend their activation email & link.",
	              " ",
	              _react2.default.createElement(
	                _linkLike2.default,
	                {
	                  onTouchTap: function onTouchTap() {
	                    return _this3.setState({ isResendingBulk: false });
	                  }
	                },
	                "Cancel"
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { style: styles.bulkInfo },
	              "You can also",
	              " ",
	              _react2.default.createElement(
	                _linkLike2.default,
	                {
	                  style: { fontWeight: "bold" },
	                  onTouchTap: function onTouchTap() {
	                    return _this3.bulkImportResend("all", order);
	                  }
	                },
	                "resend all ",
	                Object.keys(order._bulk_import).length,
	                " email",
	                Object.keys(order._bulk_import).length === 1 ? "" : "s",
	                " at once"
	              ),
	              "."
	            ),
	            _react2.default.createElement(
	              "div",
	              { style: { marginLeft: "1.5em", marginBottom: "1em" } },
	              _react2.default.createElement(
	                _label2.default,
	                null,
	                "Additional note (appended to notification email)"
	              ),
	              this.state.showBulkImportEditor ? _react2.default.createElement(_quillEditor2.default, {
	                value: this.state.bulkImportMessage,
	                onChange: function onChange(v) {
	                  return _this3.setState({ bulkImportMessage: v });
	                },
	                basic: true
	              }) : _react2.default.createElement(
	                "div",
	                { style: { marginTop: -5 } },
	                "None set \u2013",
	                " ",
	                _react2.default.createElement(
	                  _linkLike2.default,
	                  {
	                    onTouchTap: function onTouchTap() {
	                      return _this3.setState({ showBulkImportEditor: true });
	                    }
	                  },
	                  "Add additional note"
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "ul",
	              { style: { margin: 0 } },
	              Object.keys(order._bulk_import).map(function (k) {
	                return {
	                  person: _this3.props.people[k],
	                  data: order._bulk_import[k]
	                };
	              }).sort(function (a, b) {
	                return (a.person.details.name || a.person.details.email).localeCompare(b.person.details.name || b.person.details.email);
	              }).map(function (_ref2) {
	                var person = _ref2.person;
	                var data = _ref2.data;
	
	                return _react2.default.createElement(
	                  "li",
	                  null,
	                  person.details.name ? _react2.default.createElement(
	                    "span",
	                    null,
	                    person.details.name,
	                    " (",
	                    person.details.email,
	                    ")"
	                  ) : person.details.email,
	                  "\xA0\u2013\xA0",
	                  order.passes.some(function (pass) {
	                    return pass.pass_bucket.is_membership;
	                  }) ? _react2.default.createElement(
	                    "text",
	                    null,
	                    data.passes.length,
	                    " membership",
	                    data.passes.length === 1 ? "" : "s"
	                  ) : _react2.default.createElement(
	                    "text",
	                    null,
	                    data.passes.length,
	                    " pass",
	                    data.passes.length === 1 ? "" : "es"
	                  ),
	                  "\xA0\u2013\xA0",
	                  order.bulkResent === person.id ? "resent successfully" : _this3.state.bulkCurrentlyResending === person.id ? "resending..." : _react2.default.createElement(
	                    "span",
	                    {
	                      title: data.email_sent ? "Last sent " + (0, _moment2.default)(data.email_sent).format("lll") : "Never sent"
	                    },
	                    _react2.default.createElement(
	                      _linkLike2.default,
	                      {
	                        onTouchTap: _this3.bulkImportResend.bind(_this3, person.id)
	                      },
	                      "resend",
	                      " ",
	                      !data.email_sent ? _react2.default.createElement(
	                        "span",
	                        {
	                          style: {
	                            padding: "0 2px",
	                            backgroundColor: "red",
	                            color: "#fff"
	                          }
	                        },
	                        "never sent"
	                      ) : null
	                    )
	                  )
	                );
	              })
	            )
	          ) : _react2.default.createElement(
	            "div",
	            { style: styles.bulkInfo },
	            Object.values(order._bulk_import).filter(function (v) {
	              return v.email_sent;
	            }).length,
	            " ",
	            "/ ",
	            Object.values(order._bulk_import).length,
	            " activation emails sent.",
	            " ",
	            _react2.default.createElement(
	              _linkLike2.default,
	              { onTouchTap: this.bulkImportLoadDetails },
	              "Resend activation emails..."
	            )
	          )
	        ) : null,
	        person ? _react2.default.createElement(
	          "div",
	          { style: styles.section },
	          person.name ? _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(
	              "div",
	              { style: styles.personMain },
	              person.name
	            ),
	            _react2.default.createElement(
	              "div",
	              { style: styles.personSub },
	              person.email
	            )
	          ) : _react2.default.createElement(
	            "div",
	            { style: styles.personMain },
	            person.email
	          ),
	          _react2.default.createElement(_materialUi.RaisedButton, {
	            label: "View person",
	            style: { marginTop: 5 },
	            primary: true,
	            onTouchTap: function onTouchTap() {
	              return _this3.context.router.push((currentEventBucket ? "/event_buckets/" + currentEventBucket : "") + "/people/" + order.person.id);
	            }
	          })
	        ) : null,
	        isSundance && _react2.default.createElement(
	          "div",
	          { style: styles.section },
	          _react2.default.createElement(
	            "h4",
	            { style: styles.notesHeader },
	            "Notes"
	          ),
	          _react2.default.createElement(_notes2.default, { order: order.id })
	        ),
	        !order.box_office_email && !person && order.type !== "bulk" ? _react2.default.createElement(
	          "div",
	          { style: styles.section },
	          _react2.default.createElement(
	            "div",
	            { style: styles.personSub },
	            "No email address connected."
	          ),
	          _react2.default.createElement(_materialUi.RaisedButton, {
	            label: "Add email address",
	            style: { marginTop: 5 },
	            primary: true,
	            onTouchTap: this.addEmail
	          })
	        ) : null,
	        order.tickets.length ? _react2.default.createElement(
	          "div",
	          { style: styles.section },
	          _react2.default.createElement(
	            "h2",
	            null,
	            "Tickets"
	          ),
	          _react2.default.createElement(_ticketTable2.default, {
	            tickets: order.tickets,
	            person: order.person && order.person.id,
	            eventBucket: order.event_bucket.id,
	            isSundance: isSundance,
	            showTransferHistory: showTransferHistory,
	            order: order.id,
	            showEvent: true,
	            location: this.props.location
	          })
	        ) : null,
	        order.passes.filter(function (pass) {
	          return !pass.pass_bucket.is_membership;
	        }).length ? _react2.default.createElement(
	          "div",
	          { style: styles.section },
	          _react2.default.createElement(
	            "h2",
	            null,
	            "Passes"
	          ),
	          _react2.default.createElement(_passTable2.default, {
	            passes: order.passes,
	            person: order.person && order.person.details,
	            order: order.id,
	            eventBucket: order.event_bucket.id,
	            isSundance: isSundance,
	            showTransferHistory: showTransferHistory,
	            isSinglePerson: !!person,
	            location: this.props.location
	          })
	        ) : null,
	        fullEventBucket && fullEventBucket.frontend_config.memberships_enabled && order.passes.filter(function (pass) {
	          return pass.pass_bucket.is_membership;
	        }).length ? _react2.default.createElement(
	          "div",
	          { style: styles.section },
	          _react2.default.createElement(
	            "h2",
	            null,
	            "Memberships"
	          ),
	          _react2.default.createElement(_passTable2.default, {
	            passes: order.passes,
	            person: order.person && order.person.details,
	            order: order.id,
	            eventBucket: order.event_bucket.id,
	            isSundance: fullEventBucket && fullEventBucket.frontend_config ? fullEventBucket.frontend_config.sundance_login : false,
	            isSinglePerson: !!person,
	            location: this.props.location,
	            isMemberships: true
	          })
	        ) : null,
	        order.items.length ? _react2.default.createElement(
	          "div",
	          { style: styles.section },
	          _react2.default.createElement(
	            "h2",
	            null,
	            "Items"
	          ),
	          _react2.default.createElement(_itemTable2.default, {
	            items: order.items,
	            person: order.person && order.person.details,
	            order: order.id,
	            eventBucket: order.event_bucket.id,
	            showItemBucket: true,
	            isSinglePerson: !!person,
	            location: this.props.location
	          })
	        ) : null,
	        order.in_ledger ? _react2.default.createElement(
	          "div",
	          { style: styles.section },
	          _react2.default.createElement(
	            "h2",
	            { style: { marginBottom: "0.5em" } },
	            "Ledger transactions "
	          ),
	          _react2.default.createElement(_ledgerTable2.default, { orderId: order.id })
	        ) : null
	      );
	    }
	  }], [{
	    key: "getStores",
	    value: function getStores() {
	      return [_EventBucketStore2.default, _OrderStore2.default, _PersonStore2.default];
	    }
	  }, {
	    key: "getPropsFromStores",
	    value: function getPropsFromStores() {
	      var _OrderStore$getState = _OrderStore2.default.getState();
	
	      var orders = _OrderStore$getState.orders;
	      var resendConfirmationErrorMessage = _OrderStore$getState.resendConfirmationErrorMessage;
	      var refundErrorMessage = _OrderStore$getState.refundErrorMessage;
	      var refundSuccess = _OrderStore$getState.refundSuccess;
	
	      var _PersonStore$getState = _PersonStore2.default.getState();
	
	      var isFetching = _PersonStore$getState.isFetching;
	      var people = _PersonStore$getState.people;
	
	      return {
	        orders: orders,
	        resendConfirmationErrorMessage: resendConfirmationErrorMessage,
	        refundErrorMessage: refundErrorMessage,
	        refundSuccess: refundSuccess,
	        isFetchingPeople: isFetching,
	        people: people,
	        getEventBucketById: _EventBucketStore2.default.getEventBucketById
	      };
	    }
	  }, {
	    key: "contextTypes",
	    get: function get() {
	      return {
	        router: _react2.default.PropTypes.object
	      };
	    }
	  }]);
	
	  return Order;
	}(_react2.default.Component);
	
	exports.default = (0, _connectToStores2.default)(Order);
	module.exports = exports["default"];

/***/ }),
/* 2899 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _moment = __webpack_require__(1021);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _reactRouter = __webpack_require__(486);
	
	var _connectToStores = __webpack_require__(1226);
	
	var _connectToStores2 = _interopRequireDefault(_connectToStores);
	
	var _LedgerActions = __webpack_require__(2052);
	
	var _LedgerActions2 = _interopRequireDefault(_LedgerActions);
	
	var _LedgerStore = __webpack_require__(2315);
	
	var _LedgerStore2 = _interopRequireDefault(_LedgerStore);
	
	var _util = __webpack_require__(1183);
	
	var _genericAnalyticsTable = __webpack_require__(1687);
	
	var _genericAnalyticsTable2 = _interopRequireDefault(_genericAnalyticsTable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LedgerTable = function (_React$Component) {
	  _inherits(LedgerTable, _React$Component);
	
	  function LedgerTable(props) {
	    _classCallCheck(this, LedgerTable);
	
	    return _possibleConstructorReturn(this, Object.getPrototypeOf(LedgerTable).call(this, props));
	  }
	
	  _createClass(LedgerTable, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      if (this.props.orderId) {
	        _LedgerActions2.default.fetchLedgerTransactionsForOrder.defer(this.props.orderId);
	      }
	    }
	  }, {
	    key: "getStyles",
	    value: function getStyles() {
	      return {};
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var styles = this.getStyles();
	
	      var transactions = this.props.orderId ? this.props.getLedgerTransactionsForOrder(this.props.orderId) : [];
	
	      return _react2.default.createElement(_genericAnalyticsTable2.default, {
	        csvLabel: "ledger-activity",
	        csvLabelDetail: this.props.orderId + "-" + Date.now()
	        // noSort
	        // noDownload
	        // loading={this.props.loading}
	        // loadingStyle={{ padding: 10 }}
	        , data: transactions.map(function (transaction) {
	          return {
	            date: {
	              value: transaction.date,
	              label: _react2.default.createElement(
	                "span",
	                { style: { whiteSpace: "nowrap" } },
	                (0, _moment2.default)(transaction.date).format("lll")
	              )
	            },
	            account: (0, _util.capitalize)((0, _util.unSnakeCase)(transaction.balance_account.type)),
	            currency: transaction.currency,
	            type: {
	              value: transaction.type,
	              label: _react2.default.createElement(
	                "span",
	                { style: { whiteSpace: "nowrap" } },
	                (0, _util.capitalize)((0, _util.unSnakeCase)(transaction.type))
	              )
	            },
	            reason: transaction.reason === "revenue_sharing" ? "Revenue sharing with " + transaction.revenue_share_affiliate.ref_label : transaction.reason === "revenue_sharing_refund" ? "Revenue sharing refund with " + transaction.revenue_share_affiliate.ref_label : (0, _util.capitalize)((0, _util.unSnakeCase)(transaction.reason)),
	            class: (0, _util.capitalize)((0, _util.unSnakeCase)(transaction.class)),
	            category: transaction.category ? transaction.category.ref_label : undefined,
	            subcategory: transaction.subcategory ? transaction.subcategory.ref_label : undefined,
	            variant: transaction.variant ? transaction.variant.ref_label : undefined,
	            gross: {
	              value: transaction.gross,
	              label: (0, _util.formatPrice)(transaction.gross, {
	                currency: transaction.currency,
	                accounting: true
	              })
	            },
	            fee: {
	              value: -transaction.fee,
	              label: (0, _util.formatPrice)(-transaction.fee, {
	                currency: transaction.currency,
	                accounting: true
	              })
	            },
	            net: {
	              value: transaction.net,
	              csv_label: (0, _util.formatPrice)(transaction.net, {
	                currency: transaction.currency,
	                accounting: true
	              }),
	              label: _react2.default.createElement(
	                "span",
	                { style: { fontWeight: "bold" } },
	                (0, _util.formatPrice)(transaction.net, {
	                  currency: transaction.currency,
	                  accounting: true
	                })
	              )
	            },
	            actions: {
	              value: 1,
	              label: _react2.default.createElement(
	                "span",
	                { style: { whiteSpace: "nowrap" } },
	                transaction.order ? _react2.default.createElement(
	                  _reactRouter.Link,
	                  { to: "/orders/" + transaction.order, target: "_blank" },
	                  "View order"
	                ) : null
	              )
	            }
	          };
	        }),
	        columns: [{ label: "Date", value: "date" }, { label: "Account", value: "account" }, { label: "Type", value: "type" }, { label: "Reason", value: "reason" }, { label: "Class", value: "class" }, { label: "Category", value: "category" }, { label: "Subcategory", value: "subcategory" }, transactions.some(function (t) {
	          return !!t.variant;
	        }) && {
	          label: "Variant",
	          value: "variant"
	        }, { label: "Gross", value: "gross" }, { label: "Fee", value: "fee" }, { label: "Net", value: "net" }, !this.props.orderId && { label: "Actions", value: "actions" }].filter(function (x) {
	          return !!x;
	        })
	      });
	    }
	  }], [{
	    key: "getStores",
	    value: function getStores() {
	      return [_LedgerStore2.default];
	    }
	  }, {
	    key: "getPropsFromStores",
	    value: function getPropsFromStores() {
	      return {
	        getLedgerTransactionsForOrder: _LedgerStore2.default.getLedgerTransactionsForOrder
	      };
	    }
	  }, {
	    key: "contextTypes",
	    get: function get() {
	      return {
	        router: _react2.default.PropTypes.object
	      };
	    }
	  }]);
	
	  return LedgerTable;
	}(_react2.default.Component);
	
	exports.default = (0, _connectToStores2.default)(LedgerTable);
	module.exports = exports["default"];

/***/ }),
/* 2900 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _moment = __webpack_require__(1021);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _values = __webpack_require__(1214);
	
	var _values2 = _interopRequireDefault(_values);
	
	var _pickBy = __webpack_require__(1163);
	
	var _pickBy2 = _interopRequireDefault(_pickBy);
	
	var _reactRouter = __webpack_require__(486);
	
	var _materialUi = __webpack_require__(576);
	
	var _reactable = __webpack_require__(1688);
	
	var _connectToStores = __webpack_require__(1226);
	
	var _connectToStores2 = _interopRequireDefault(_connectToStores);
	
	var _GiftCardActions = __webpack_require__(2901);
	
	var _GiftCardActions2 = _interopRequireDefault(_GiftCardActions);
	
	var _GiftCardStore = __webpack_require__(2902);
	
	var _GiftCardStore2 = _interopRequireDefault(_GiftCardStore);
	
	var _workingIndicator = __webpack_require__(1664);
	
	var _workingIndicator2 = _interopRequireDefault(_workingIndicator);
	
	var _currencyField = __webpack_require__(1747);
	
	var _currencyField2 = _interopRequireDefault(_currencyField);
	
	var _linkLike = __webpack_require__(973);
	
	var _linkLike2 = _interopRequireDefault(_linkLike);
	
	var _base = __webpack_require__(1755);
	
	var _base2 = _interopRequireDefault(_base);
	
	var _util = __webpack_require__(1183);
	
	var _GiftCardUtil = __webpack_require__(2053);
	
	var _GiftCardUtil2 = _interopRequireDefault(_GiftCardUtil);
	
	var _UserStore = __webpack_require__(974);
	
	var _UserStore2 = _interopRequireDefault(_UserStore);
	
	var _datepicker = __webpack_require__(2272);
	
	var _datepicker2 = _interopRequireDefault(_datepicker);
	
	var _injectedSelect = __webpack_require__(1874);
	
	var _injectedSelect2 = _interopRequireDefault(_injectedSelect);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var GiftCards = function (_React$Component) {
	  _inherits(GiftCards, _React$Component);
	
	  function GiftCards(props) {
	    _classCallCheck(this, GiftCards);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(GiftCards).call(this, props));
	
	    _this.state = {
	      isIssuingNewGiftCard: false,
	      isAdjustingGiftCard: false,
	      giftCardId: "",
	      recipientEmail: "",
	      recipientName: "",
	      giftScheduledSend: new Date(),
	      amount: "",
	      code: "",
	      eventBucket: undefined
	    };
	
	    _this._makeRowForGiftCard = _this._makeRowForGiftCard.bind(_this);
	
	    _this.showIssueGiftCardModal = _this.showIssueGiftCardModal.bind(_this);
	    _this.hideIssueGiftCardModal = _this.hideIssueGiftCardModal.bind(_this);
	    _this.showAdjustGiftCardModal = _this.showAdjustGiftCardModal.bind(_this);
	    _this.hideAdjustGiftCardModal = _this.hideAdjustGiftCardModal.bind(_this);
	    _this.handleGiftCardAdjustment = _this.handleGiftCardAdjustment.bind(_this);
	    _this.handleGiftCardScheduledSendChange = _this.handleGiftCardScheduledSendChange.bind(_this);
	    _this.handleAmountChange = _this.handleAmountChange.bind(_this);
	    _this.handleCodeChange = _this.handleCodeChange.bind(_this);
	    _this.issueGiftCard = _this.issueGiftCard.bind(_this);
	    return _this;
	  }
	
	  _createClass(GiftCards, [{
	    key: "getStyles",
	    value: function getStyles() {
	      return {};
	    }
	  }, {
	    key: "_makeRowForGiftCard",
	    value: function _makeRowForGiftCard(giftCard) {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        _reactable.Tr,
	        {
	          style: this.props.location.query.gift_card_id === giftCard.id ? {
	            backgroundColor: "#fff176",
	            boxShadow: "1px 1px 10px rgba(0,0,0,0.2)"
	          } : {}
	        },
	        _react2.default.createElement(
	          _reactable.Td,
	          { column: "Code" },
	          giftCard.code
	        ),
	        _react2.default.createElement(
	          _reactable.Td,
	          { column: "Balance" },
	          (0, _util.formatPrice)(giftCard.balance, { currency: giftCard.currency })
	        ),
	        _react2.default.createElement(
	          _reactable.Td,
	          { column: "Balance Events" },
	          _react2.default.createElement(
	            "div",
	            null,
	            giftCard.balance_events.map(function (e) {
	              return _react2.default.createElement(
	                "div",
	                null,
	                _react2.default.createElement(
	                  "span",
	                  { style: { fontVariantNumeric: "tabular-nums" } },
	                  "" + (e.balance_change > 0 ? "+" : "−") + (0, _util.formatPrice)(Math.abs(e.balance_change), { currency: giftCard.currency })
	                ),
	                " ",
	                "(",
	                e.description + " @ " + (0, _moment2.default)(e.created_at).format("lll"),
	                e.order ? _react2.default.createElement(
	                  "span",
	                  null,
	                  " ",
	                  "\xB7",
	                  " ",
	                  _react2.default.createElement(
	                    "a",
	                    { href: "/orders/" + e.order, target: "_blank" },
	                    "view"
	                  )
	                ) : null,
	                ")"
	              );
	            })
	          )
	        ),
	        _react2.default.createElement(
	          _reactable.Td,
	          { column: "Actions" },
	          _react2.default.createElement(
	            "div",
	            { style: { display: "flex", gap: 4 } },
	            _react2.default.createElement(
	              _linkLike2.default,
	              {
	                onTouchTap: function onTouchTap() {
	                  _this2.showAdjustGiftCardModal(giftCard);
	                }
	              },
	              "Adjust"
	            ),
	            _react2.default.createElement(
	              _linkLike2.default,
	              {
	                onTouchTap: function onTouchTap() {
	                  if (window.confirm("Are you sure you would like to delete this gift card?")) {
	                    _GiftCardActions2.default.delete(giftCard.id);
	                  }
	                }
	              },
	              "Delete"
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: "showIssueGiftCardModal",
	    value: function showIssueGiftCardModal() {
	      this.setState({ isIssuingNewGiftCard: true });
	    }
	  }, {
	    key: "hideIssueGiftCardModal",
	    value: function hideIssueGiftCardModal() {
	      this.setState({ isIssuingNewGiftCard: false, amount: "", code: "" });
	    }
	  }, {
	    key: "showAdjustGiftCardModal",
	    value: function showAdjustGiftCardModal(giftCard) {
	      this.setState({
	        isAdjustingGiftCard: true,
	        giftCardId: giftCard.id,
	        recipientEmail: giftCard.recipientEmail,
	        recipientName: giftCard.recipientName,
	        giftScheduledSend: giftCard.giftScheduledSend
	      });
	    }
	  }, {
	    key: "hideAdjustGiftCardModal",
	    value: function hideAdjustGiftCardModal() {
	      this.setState({
	        isAdjustingGiftCard: false,
	        giftCardId: "",
	        recipientEmail: "",
	        recipientName: "",
	        giftScheduledSend: new Date()
	      });
	    }
	  }, {
	    key: "handleAmountChange",
	    value: function handleAmountChange(e) {
	      this.setState({ amount: e.target.value });
	    }
	  }, {
	    key: "handleCodeChange",
	    value: function handleCodeChange(e) {
	      this.setState({ code: e.target.value.toUpperCase(0) });
	    }
	  }, {
	    key: "handleGiftCardAdjustment",
	    value: function handleGiftCardAdjustment(e) {
	      this.setState(_defineProperty({}, e.target.name, e.target.value));
	    }
	  }, {
	    key: "handleGiftCardScheduledSendChange",
	    value: function handleGiftCardScheduledSendChange(value) {
	      this.setState({
	        giftScheduledSend: value
	      });
	    }
	  }, {
	    key: "fetchGiftCardCSV",
	    value: function () {
	      var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
	        var results;
	        return regeneratorRuntime.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                _context.next = 2;
	                return _GiftCardUtil2.default.fetchCSV(_UserStore2.default.getState().apiKey);
	
	              case 2:
	                results = _context.sent;
	
	
	                (0, _util.clientSideDownload)("gift_cards.csv", "text/csv", results);
	
	              case 4:
	              case "end":
	                return _context.stop();
	            }
	          }
	        }, _callee, this);
	      }));
	
	      function fetchGiftCardCSV() {
	        return _ref.apply(this, arguments);
	      }
	
	      return fetchGiftCardCSV;
	    }()
	  }, {
	    key: "adjustGiftCard",
	    value: function adjustGiftCard(sendEmail) {
	      _GiftCardActions2.default.adjustGiftCard({
	        giftCard: {
	          id: this.state.giftCardId,
	          amount: this.state.amount,
	          recipientEmail: this.state.recipientEmail,
	          recipientName: this.state.recipientName,
	          giftScheduledSend: this.state.giftScheduledSend
	        },
	        options: {
	          sendEmail: sendEmail
	        }
	      });
	      this.hideAdjustGiftCardModal();
	    }
	  }, {
	    key: "issueGiftCard",
	    value: function issueGiftCard() {
	      _GiftCardActions2.default.create({
	        initial_balance: this.state.amount,
	        code: this.state.code,
	        event_bucket: this.state.eventBucket
	      });
	      this.hideIssueGiftCardModal();
	    }
	  }, {
	    key: "componentWillMount",
	    value: function componentWillMount() {
	      _GiftCardActions2.default.fetchAll();
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this3 = this;
	
	      var styles = this.getStyles(),
	          giftCards = (0, _values2.default)(this.props.giftCards),
	          rows = giftCards.map(this._makeRowForGiftCard);
	
	      if (giftCards.length === 0 && _GiftCardStore2.default.getState().isFetching) {
	        return _react2.default.createElement(_workingIndicator2.default, { fullPage: true });
	      }
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          _base2.default,
	          {
	            title: "Issue new gift card",
	            useMuiDefaultStyle: true,
	            actions: [_react2.default.createElement(_materialUi.FlatButton, {
	              label: "Close",
	              onTouchTap: this.hideIssueGiftCardModal
	            }), _react2.default.createElement(_materialUi.FlatButton, {
	              disabled: !this.state.amount || !this.state.eventBucket,
	              primary: true,
	              label: "Issue new gift card",
	              onTouchTap: this.issueGiftCard
	            })],
	            modal: true,
	            open: this.state.isIssuingNewGiftCard,
	            onRequestClose: this.hideIssueGiftCardModal
	          },
	          _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(_materialUi.TextField, {
	              floatingLabelText: "Code",
	              floatingLabelFixed: true,
	              placeholder: "Autogenerated if left blank",
	              value: this.state.code,
	              onChange: this.handleCodeChange
	            })
	          ),
	          _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(_currencyField2.default, {
	              floatingLabelText: "Initial balance",
	              floatingLabelFixed: true,
	              placeholder: "$0.00",
	              value: this.state.amount,
	              onChange: this.handleAmountChange
	            })
	          ),
	          _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(_injectedSelect2.default, {
	              value: this.state.eventBucket,
	              label: "Event Bucket",
	              labelFormatter: function labelFormatter(e) {
	                return e.name;
	              },
	              type: "event_buckets",
	              onChange: function onChange(e) {
	                return _this3.setState({ eventBucket: e });
	              }
	            })
	          )
	        ),
	        _react2.default.createElement(
	          _base2.default,
	          {
	            title: "Adjust Gift Card",
	            useMuiDefaultStyle: true,
	            actions: [_react2.default.createElement(_materialUi.FlatButton, {
	              label: "Close",
	              onTouchTap: this.hideAdjustGiftCardModal
	            }), _react2.default.createElement(_materialUi.FlatButton, {
	              label: "Adjust",
	              onTouchTap: function onTouchTap() {
	                return _this3.adjustGiftCard(false);
	              }
	            }), _react2.default.createElement(_materialUi.FlatButton, {
	              label: "Adjust and Resend Notification",
	              onTouchTap: function onTouchTap() {
	                return _this3.adjustGiftCard(true);
	              }
	            })],
	            open: this.state.isAdjustingGiftCard,
	            modal: true,
	            onRequestClose: this.hideAdjustGiftCardModal
	          },
	          _react2.default.createElement(
	            "div",
	            {
	              style: {
	                display: "flex",
	                flexDirection: "column",
	                justifyContent: "center",
	                padding: "20px"
	              }
	            },
	            _react2.default.createElement(_materialUi.TextField, {
	              floatingLabelText: "Recipient Email",
	              floatingLabelFixed: true,
	              value: this.state.recipientEmail,
	              onChange: this.handleGiftCardAdjustment,
	              name: "recipientEmail"
	            }),
	            _react2.default.createElement(_materialUi.TextField, {
	              floatingLabelText: "Recipient Name",
	              floatingLabelFixed: true,
	              value: this.state.recipientName,
	              onChange: this.handleGiftCardAdjustment,
	              name: "recipientName"
	            }),
	            _react2.default.createElement(_datepicker2.default, {
	              label: "Schedule Send Date",
	              floatingLabelFixed: true,
	              value: this.state.giftScheduledSend,
	              onChange: this.handleGiftCardScheduledSendChange,
	              name: "giftScheduledSend",
	              minDate: new Date()
	            })
	          )
	        ),
	        _react2.default.createElement(_materialUi.RaisedButton, { label: "Download CSV", onTouchTap: this.fetchGiftCardCSV }),
	        _react2.default.createElement(
	          _reactable.Table,
	          {
	            className: "bordered striped responsive-table",
	            sortable: [{ column: "Code", sortFunction: _reactable.Sort.CaseInsensitive }],
	            defaultSort: { column: "Code", direction: "asc" },
	            columns: ["Code", "Balance", "Balance Events", "Actions"],
	            filterable: ["Code"],
	            filterPlaceholder: "Type to filter..."
	          },
	          rows
	        ),
	        rows.length === 0 ? _react2.default.createElement(
	          "div",
	          { className: "empty-table-message" },
	          "No gift cards yet.",
	          " ",
	          _UserStore2.default.getUserId() === "65c4bbc05cac700026c08f6e" ? _react2.default.createElement(
	            _linkLike2.default,
	            { onTouchTap: this.showIssueGiftCardModal },
	            "Manually issue a new gift card."
	          ) : null
	        ) : null,
	        _react2.default.createElement(
	          "div",
	          {
	            style: {
	              marginTop: 20,
	              display: "flex",
	              justifyContent: "space-between"
	            }
	          },
	          _UserStore2.default.getUserId() === "65c4bbc05cac700026c08f6e" || _UserStore2.default.getUserId() === "63922914aa56a7004570d9c8" || _UserStore2.default.getUserId() === "6086c26f92857b003011dbd1" || _UserStore2.default.getUserId() === "5eb1e2d3dd5658002f70a5dc" || _UserStore2.default.getUserId() === "5eb033f1e514ca0029210402" ? _react2.default.createElement(_materialUi.RaisedButton, {
	            label: "Manually issue new gift card",
	            primary: true,
	            onTouchTap: this.showIssueGiftCardModal
	          }) : null,
	          _react2.default.createElement(_materialUi.RaisedButton, {
	            label: "Download CSV",
	            onTouchTap: this.fetchGiftCardCSV
	          })
	        )
	      );
	    }
	  }], [{
	    key: "getStores",
	    value: function getStores() {
	      return [_GiftCardStore2.default, _UserStore2.default];
	    }
	  }, {
	    key: "getPropsFromStores",
	    value: function getPropsFromStores() {
	      return _GiftCardStore2.default.getState();
	    }
	  }, {
	    key: "contextTypes",
	    get: function get() {
	      return {
	        router: _react2.default.PropTypes.object
	      };
	    }
	  }]);
	
	  return GiftCards;
	}(_react2.default.Component);
	
	exports.default = (0, _connectToStores2.default)(GiftCards);
	module.exports = exports["default"];

/***/ }),
/* 2901 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _alt = __webpack_require__(975);
	
	var _alt2 = _interopRequireDefault(_alt);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var GiftCardActions = function GiftCardActions() {
	  _classCallCheck(this, GiftCardActions);
	
	  this.generateActions("fetchAll", "fetchFailed", "create", "delete", "editFailed", "adjustGiftCard");
	};
	
	exports.default = _alt2.default.createActions(GiftCardActions);
	module.exports = exports["default"];

/***/ }),
/* 2902 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _alt = __webpack_require__(975);
	
	var _alt2 = _interopRequireDefault(_alt);
	
	var _keyBy = __webpack_require__(990);
	
	var _keyBy2 = _interopRequireDefault(_keyBy);
	
	var _extend3 = __webpack_require__(1212);
	
	var _extend4 = _interopRequireDefault(_extend3);
	
	var _values = __webpack_require__(1214);
	
	var _values2 = _interopRequireDefault(_values);
	
	var _GiftCardActions = __webpack_require__(2901);
	
	var _GiftCardActions2 = _interopRequireDefault(_GiftCardActions);
	
	var _GiftCardUtil = __webpack_require__(2053);
	
	var _GiftCardUtil2 = _interopRequireDefault(_GiftCardUtil);
	
	var _UserStore = __webpack_require__(974);
	
	var _UserStore2 = _interopRequireDefault(_UserStore);
	
	var _GlobalNotificationActions = __webpack_require__(1182);
	
	var _GlobalNotificationActions2 = _interopRequireDefault(_GlobalNotificationActions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var GiftCardStore = function () {
	  function GiftCardStore() {
	    _classCallCheck(this, GiftCardStore);
	
	    this.bindActions(_GiftCardActions2.default);
	
	    this.state = {
	      giftCards: {}
	    };
	  }
	
	  _createClass(GiftCardStore, [{
	    key: "onFetchAll",
	    value: function onFetchAll() {
	      var _this = this;
	
	      this.setState({ isFetching: true });
	      _GiftCardUtil2.default.fetchAll(_UserStore2.default.getState().apiKey).then(function (data) {
	        _this.setState({
	          isFetching: false,
	          giftCards: (0, _keyBy2.default)(data, "id")
	        });
	      }).catch(_GiftCardActions2.default.fetchFailed);
	    }
	  }, {
	    key: "onCreate",
	    value: function onCreate(giftCard) {
	      var _this2 = this;
	
	      this.setState({ isCreating: true });
	      _GiftCardUtil2.default.create(_UserStore2.default.getState().apiKey, giftCard).then(function (data) {
	        _this2.setState({
	          isCreating: false,
	          giftCards: (0, _extend4.default)({}, _this2.state.giftCards, _defineProperty({}, data.id, data))
	        });
	      }).catch(_GiftCardActions2.default.editFailed);
	    }
	  }, {
	    key: "onDelete",
	    value: function onDelete(id) {
	      var _this3 = this;
	
	      this.setState({ isDeleting: true });
	      _GiftCardUtil2.default.delete(_UserStore2.default.getState().apiKey, id).then(function () {
	        var giftCards = _this3.state.giftCards;
	        delete giftCards[id];
	        _this3.setState({
	          isDeleting: false,
	          giftCards: giftCards
	        });
	      }).catch(_GiftCardActions2.default.editFailed);
	    }
	  }, {
	    key: "onAdjustGiftCard",
	    value: function onAdjustGiftCard(request) {
	      var _this4 = this;
	
	      this.setState({ isAdjusting: true });
	      _GiftCardUtil2.default.adjustGiftCard(_UserStore2.default.getState().apiKey, request).then(function (data) {
	        _this4.setState({
	          isAdjusting: false,
	          giftCards: (0, _extend4.default)({}, _this4.state.giftCards, _defineProperty({}, data.gift_card.id, data.gift_card))
	        });
	
	        _GlobalNotificationActions2.default.notify("Gift card adjusted successfully!");
	      }).catch(_GiftCardActions2.default.editFailed);
	    }
	  }, {
	    key: "onFetchFailed",
	    value: function onFetchFailed(e) {
	      window.alert("Fetching gift cards failed: " + e.message);
	    }
	  }, {
	    key: "onEditFailed",
	    value: function onEditFailed(e) {
	      window.alert("Updating gift card failed: " + e.message);
	    }
	  }]);
	
	  return GiftCardStore;
	}();
	
	exports.default = _alt2.default.createStore(GiftCardStore, "GiftCardStore");
	module.exports = exports["default"];

/***/ }),
/* 2903 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _moment = __webpack_require__(1021);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _momentTimezone = __webpack_require__(1185);
	
	var _momentTimezone2 = _interopRequireDefault(_momentTimezone);
	
	var _qs = __webpack_require__(1206);
	
	var _qs2 = _interopRequireDefault(_qs);
	
	var _reactRouter = __webpack_require__(486);
	
	var _materialUi = __webpack_require__(576);
	
	var _config = __webpack_require__(1173);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _inlineNoticeLabel = __webpack_require__(1222);
	
	var _inlineNoticeLabel2 = _interopRequireDefault(_inlineNoticeLabel);
	
	var _linkLike = __webpack_require__(973);
	
	var _linkLike2 = _interopRequireDefault(_linkLike);
	
	var _injectedSelect = __webpack_require__(1874);
	
	var _injectedSelect2 = _interopRequireDefault(_injectedSelect);
	
	var _datepicker = __webpack_require__(2272);
	
	var _datepicker2 = _interopRequireDefault(_datepicker);
	
	var _workingIndicator = __webpack_require__(1664);
	
	var _workingIndicator2 = _interopRequireDefault(_workingIndicator);
	
	var _label = __webpack_require__(1682);
	
	var _label2 = _interopRequireDefault(_label);
	
	var _selectField = __webpack_require__(1683);
	
	var _selectField2 = _interopRequireDefault(_selectField);
	
	var _connectToStores = __webpack_require__(1226);
	
	var _connectToStores2 = _interopRequireDefault(_connectToStores);
	
	var _UserActions = __webpack_require__(1158);
	
	var _UserActions2 = _interopRequireDefault(_UserActions);
	
	var _UserStore = __webpack_require__(974);
	
	var _UserStore2 = _interopRequireDefault(_UserStore);
	
	var _EventBucketStore = __webpack_require__(1593);
	
	var _EventBucketStore2 = _interopRequireDefault(_EventBucketStore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ONE_DAY_IN_MS = 24 * 60 * 60 * 1000;
	
	var REPORT_OPTIONS = {
	  Select: function Select(options, intermediateValue, value, _onChange, onChangeIntermediate) {
	    return _react2.default.createElement(_selectField2.default, {
	      label: options.label,
	      placeholder: "Select an option",
	      value: value,
	      autosize: true,
	      clearable: false,
	      options: options.options,
	      onChange: function onChange(option) {
	        return _onChange(option ? option.value : undefined);
	      }
	    });
	  },
	  Boolean: function Boolean(options, intermediateValue, value, onChange, onChangeIntermediate) {
	    return _react2.default.createElement(
	      "div",
	      { style: { marginTop: "1em" } },
	      _react2.default.createElement(
	        _label2.default,
	        null,
	        options.label
	      ),
	      _react2.default.createElement(_materialUi.Checkbox, {
	        label: options.checkbox_label,
	        checked: !!value,
	        onCheck: function onCheck(e) {
	          return onChange(e.target.checked);
	        }
	      })
	    );
	  },
	  Date: function Date(options, intermediateValue, value, _onChange2, onChangeIntermediate) {
	    return _react2.default.createElement(_datepicker2.default, {
	      value: (value + (options.endOfDay ? -ONE_DAY_IN_MS : 0)).toString(),
	      label: options.label,
	      returnFormat: "x" // unix timestamp (ms)
	      , onChange: function onChange(v) {
	        return _onChange2(options.endOfDay ? +v + ONE_DAY_IN_MS : +v);
	      }
	    });
	  },
	  EventBucket: function EventBucket(options, intermediateValue, value, onChange, onChangeIntermediate) {
	    return _react2.default.createElement(_injectedSelect2.default, _extends({
	      value: value,
	      label: options.label,
	      labelFormatter: function labelFormatter(e) {
	        return e.name;
	      },
	      type: "event_buckets",
	      onChange: onChange
	    }, options.props));
	  },
	  Event: function Event(options, intermediateValue, value, onChange, onChangeIntermediate) {
	    return _react2.default.createElement(
	      "div",
	      null,
	      _react2.default.createElement(_injectedSelect2.default, _extends({
	        value: intermediateValue,
	        label: "Event bucket",
	        labelFormatter: function labelFormatter(e) {
	          return e.name;
	        },
	        type: "event_buckets",
	        onChange: onChangeIntermediate
	      }, options.props)),
	      intermediateValue ? _react2.default.createElement(_injectedSelect2.default, _extends({
	        value: value,
	        label: options.label,
	        labelFormatter: function labelFormatter(e) {
	          return e.name;
	        },
	        type: "events",
	        eventBucketId: intermediateValue,
	        onChange: onChange
	      }, options.props)) : _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          _label2.default,
	          null,
	          "Event"
	        ),
	        _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement(
	            "i",
	            null,
	            "Select an event bucket above"
	          )
	        )
	      )
	    );
	  }
	};
	
	var Reports = function (_React$Component) {
	  _inherits(Reports, _React$Component);
	
	  function Reports(props) {
	    _classCallCheck(this, Reports);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(Reports).call(this, props));
	
	    _this.state = {
	      reportToShowModal: null,
	      processingReport: false,
	      showTemporaryExportSuccess: false,
	      completedExport: null,
	      selectedOptions: {},
	      showLegacyReports: false,
	      currentMoment: (0, _momentTimezone2.default)()
	    };
	
	    _this._url = _this._url.bind(_this);
	    _this.openModal = _this.openModal.bind(_this);
	    _this.cancelModal = _this.cancelModal.bind(_this);
	    _this.submitModal = _this.submitModal.bind(_this);
	    _this._checkTemporaryExport = _this._checkTemporaryExport.bind(_this);
	    return _this;
	  }
	
	  _createClass(Reports, [{
	    key: "getStyles",
	    value: function getStyles() {
	      return {
	        subhead: {
	          marginTop: "1em"
	        },
	        innerDialog: {
	          maxWidth: 250,
	          margin: "0 auto"
	        }
	      };
	    }
	  }, {
	    key: "_url",
	    value: function _url(path, query) {
	      // Add auth to query
	      if (!query) {
	        query = {};
	      }
	      query.api_key = this.props.apiKey;
	      if (_UserStore2.default.isGodInAnyForm()) {
	        query.god_become_user = _UserStore2.default.getGodCredentials().activeUser;
	      }
	
	      return "" + _config2.default.endpoint + path + (path.indexOf("?") === -1 ? "?" : "&") + _qs2.default.stringify(query);
	    }
	  }, {
	    key: "openModal",
	    value: function openModal(r) {
	      var defaults = {};
	
	      Object.entries(r.query).forEach(function (_ref) {
	        var _ref2 = _slicedToArray(_ref, 2);
	
	        var k = _ref2[0];
	        var v = _ref2[1];
	
	        if (v.default) {
	          defaults[k] = v.default;
	        }
	      });
	
	      this.setState({
	        reportToShowModal: r,
	        selectedOptions: defaults
	      });
	    }
	  }, {
	    key: "cancelModal",
	    value: function cancelModal() {
	      this.setState({
	        reportToShowModal: null,
	        showTemporaryExportSuccess: false,
	        completedExport: null
	      });
	    }
	  }, {
	    key: "_checkTemporaryExport",
	    value: function _checkTemporaryExport(id, wait) {
	      var _this2 = this;
	
	      setTimeout(function () {
	        fetch(_this2._url("temporary_exports/" + id)).then(function (r) {
	          return r.json();
	        }).then(function (e) {
	          if (e.completed_at) {
	            _this2.setState({ completedExport: e });
	          } else {
	            _this2._checkTemporaryExport(id, Math.min(4000, wait * 2)); // backoff: 500ms, 1s, 2s, 4s max wait
	          }
	        });
	      }, wait);
	    }
	  }, {
	    key: "submitModal",
	    value: function submitModal() {
	      var _this3 = this;
	
	      var r = this.state.reportToShowModal,
	          query = Object.assign({}, r.query);
	
	      // Inject selected options
	      Object.keys(query).forEach(function (k) {
	        if (query[k] && query[k].type) {
	          var intermediateKey = query[k].intermediate_value_key;
	          query[k] = _this3.state.selectedOptions[k];
	          if (intermediateKey) {
	            query[intermediateKey] = _this3.state.selectedOptions[intermediateKey];
	          }
	        }
	      });
	
	      var url = this._url(r.url, Object.assign({}, r.nestQuery ? _defineProperty({}, r.nestQuery, JSON.stringify(query)) : query, { tz: _moment2.default.tz.guess() }));
	
	      if (r.temporary_export) {
	        this.setState({
	          processingReport: false,
	          showTemporaryExportSuccess: true
	        });
	        fetch(url).then(function (r) {
	          return r.json();
	        }).then(function (d) {
	          if (d.error || !d.temporary_export) {
	            _this3.setState({
	              processingReport: false,
	              showTemporaryExportSuccess: true,
	              completedExport: {
	                error: d.error ? d.error.message : "An unknown error occurred"
	              }
	            });
	          } else {
	            _this3.setState({
	              processingReport: false,
	              showTemporaryExportSuccess: true
	            });
	            _this3._checkTemporaryExport(d.temporary_export, 500);
	          }
	        });
	      } else {
	        window.open(url);
	      }
	    }
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      _UserActions2.default.fetch();
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      clearInterval(this._checkInterval);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this4 = this;
	
	      var styles = this.getStyles();
	
	      var oneMonthAgo = +(0, _moment2.default)().startOf("day").subtract(1, "month").format("x");
	      var oneWeekAgo = +(0, _moment2.default)().startOf("day").subtract(1, "week").format("x");
	      var tomorrow = +(0, _moment2.default)().startOf("day").add(1, "day").format("x");
	
	      var RECONCILIATION_QUERY = {
	        start: {
	          type: "Date",
	          label: "Start date",
	          default: oneWeekAgo
	        },
	        end: {
	          type: "Date",
	          endOfDay: true,
	          label: "End date",
	          default: tomorrow
	        },
	        tz_for_output: {
	          type: "Select",
	          label: "Timezone",
	          options: _momentTimezone2.default.tz.names().map(function (n) {
	            return {
	              label: n + " (" + _this4.state.currentMoment.tz(n).format("LT") + ")",
	              value: n
	            };
	          }),
	          default: "GMT-0"
	        },
	        group_by: {
	          type: "Select",
	          label: "Group by",
	          options: [{
	            label: "Individual transaction",
	            value: "none"
	          }, {
	            label: "Category (columns by category)",
	            value: "category"
	          }, {
	            label: "Hybrid (face price based, columns by smart category)",
	            value: "hybrid"
	          }],
	          default: "none"
	        },
	        expand_person: {
	          type: "Boolean",
	          label: "Purchaser details",
	          checkbox_label: "Include purchaser name, email, postal code"
	        },
	        expand_metadata: {
	          type: "Boolean",
	          label: "Eventive platform metadata",
	          checkbox_label: "Include Eventive system order ID, item ID, etc."
	        }
	      };
	
	      var reports = [{
	        title: "Financials",
	        visible: true,
	        reports: [{
	          title: "Bank transfer reconciliation by transfer date (unified)",
	          url: "reports/ledger/bank_transfer_reconciliation",
	          temporary_export: true,
	          description: _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(
	              "p",
	              null,
	              "This new ledger-based wizard is in beta and will eventually replace the other bank transfer reconciliation reports. As an early-access tester, please",
	              " ",
	              _react2.default.createElement(
	                "a",
	                { href: "mailto:ledgerfeedback@eventive.org" },
	                "let us know"
	              ),
	              " ",
	              "what report functionality would be most useful to you or if you run into any issues!"
	            )
	          ),
	          query: _extends({}, RECONCILIATION_QUERY)
	        }, {
	          title: "Order reconciliation ledger (unified)",
	          url: "reports/ledger/bank_transfer_reconciliation?report_mode=order",
	          temporary_export: true,
	          description: _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(
	              "p",
	              null,
	              "This new ledger-based wizard is in beta. As an early-access tester, please",
	              " ",
	              _react2.default.createElement(
	                "a",
	                { href: "mailto:ledgerfeedback@eventive.org" },
	                "let us know"
	              ),
	              " ",
	              "what report functionality would be most useful to you or if you run into any issues!"
	            )
	          ),
	          query: _extends({}, RECONCILIATION_QUERY)
	        }, {
	          title: "Sales summary report (gross/net/fees)",
	          url: "reports/financials/total_sales_report",
	          temporary_export: true,
	          query: {
	            event_bucket: {
	              type: "EventBucket",
	              label: "Event bucket",
	              props: { placeholderText: "All event buckets" }
	            },
	            start: {
	              type: "Date",
	              label: "Start date",
	              default: oneMonthAgo
	            },
	            end: {
	              type: "Date",
	              endOfDay: true,
	              label: "End date",
	              default: tomorrow
	            }
	          }
	        }, {
	          title: "Sales detail report (gross/net/fees by level/bucket)",
	          url: "reports/financials/total_sales_report",
	          temporary_export: true,
	          query: {
	            detail: true,
	            event_bucket: {
	              type: "EventBucket",
	              label: "Event bucket",
	              props: { placeholderText: "All event buckets" }
	            },
	            start: {
	              type: "Date",
	              label: "Start date",
	              default: oneMonthAgo
	            },
	            end: {
	              type: "Date",
	              endOfDay: true,
	              label: "End date",
	              default: tomorrow
	            }
	          }
	        }, {
	          title: "Fee reconciliation report (physical events only)",
	          url: "reports/financials/fee_reconciliation_report",
	          temporary_export: true,
	          query: {
	            event_bucket: {
	              type: "EventBucket",
	              label: "Event bucket",
	              props: { placeholderText: "All event buckets" }
	            },
	            start: {
	              type: "Date",
	              label: "Start date",
	              default: oneMonthAgo
	            },
	            end: {
	              type: "Date",
	              endOfDay: true,
	              label: "End date",
	              default: tomorrow
	            }
	          }
	        }, {
	          title: "Venue sales log (daily net by event date; physical events only)",
	          url: "reports/financials/venue_sales_log",
	          temporary_export: true,
	          query: {
	            event_bucket: { type: "EventBucket", label: "Event bucket" }
	          }
	        }, {
	          title: "Daily cash log",
	          url: "reports/financials/cash_log",
	          query: {
	            event_bucket: {
	              type: "EventBucket",
	              label: "Event bucket",
	              props: { placeholderText: "All event buckets" }
	            }
	          }
	        }, {
	          title: "Daily sales by box office account",
	          url: "reports/financials/box_office_account_log",
	          query: {
	            event_bucket: {
	              type: "EventBucket",
	              label: "Event bucket",
	              props: { placeholderText: "All event buckets" }
	            }
	          }
	        }, {
	          title: "Box office shift report  (physical events only)",
	          url: "reports/financials/shift_report",
	          temporary_export: true,
	          query: {
	            start: {
	              type: "Date",
	              label: "Start date",
	              default: oneMonthAgo
	            },
	            end: {
	              type: "Date",
	              endOfDay: true,
	              label: "End date",
	              default: tomorrow
	            }
	          }
	        }, {
	          title: "Donations grouped by associated event",
	          url: "reports/financials/total_sales_report",
	          temporary_export: true,
	          query: {
	            detail: true,
	            donations_by_event: true,
	            event_bucket: {
	              type: "EventBucket",
	              label: "Event bucket",
	              props: { placeholderText: "All event buckets" }
	            },
	            start: {
	              type: "Date",
	              label: "Start date",
	              default: oneMonthAgo
	            },
	            end: {
	              type: "Date",
	              endOfDay: true,
	              label: "End date",
	              default: tomorrow
	            }
	          }
	        }, {
	          title: "All orders",
	          url: "orders.csv?temporary_export=true",
	          nestQuery: "conditions",
	          temporary_export: true,
	          query: {
	            event_bucket: {
	              type: "EventBucket",
	              label: "Event bucket",
	              props: { placeholderText: "All event buckets" }
	            },
	            start: {
	              type: "Date",
	              label: "Start date",
	              default: oneMonthAgo
	            },
	            end: {
	              type: "Date",
	              endOfDay: true,
	              label: "End date",
	              default: tomorrow
	            }
	          }
	        }]
	      }, {
	        title: "Attendees",
	        visible: true,
	        reports: [{
	          title: "Single ticket buyers who are not passholders",
	          url: "reports/single_ticket_buyers_not_passholders",
	          query: {
	            event_bucket: { type: "EventBucket", label: "Event bucket" }
	          }
	        }, {
	          title: "Tickets by person (will call)",
	          url: "reports/tickets_by_person",
	          query: {
	            event_bucket: { type: "EventBucket", label: "Event bucket" }
	          }
	        }, {
	          title: "Attendees ranked by number of events attended",
	          url: "reports/attendees_ranked",
	          query: {
	            event_bucket: { type: "EventBucket", label: "Event bucket" }
	          }
	        }, {
	          title: "Person notes report",
	          url: "reports/person_notes",
	          query: {}
	        }]
	      }, {
	        title: "Miscellaneous",
	        visible: true,
	        reports: [{
	          title: "Distributor splits (with passes)",
	          url: "reports/financials/distributor_splits",
	          temporary_export: true,
	          query: {
	            event_bucket: { type: "EventBucket", label: "Event bucket" }
	          }
	        }, {
	          title: "Streaming analytics report",
	          url: "reports/streams",
	          temporary_export: true,
	          query: {
	            event_bucket: { type: "EventBucket", label: "Event bucket" },
	            start: {
	              type: "Date",
	              label: "Start date",
	              default: oneMonthAgo
	            },
	            end: {
	              type: "Date",
	              endOfDay: true,
	              label: "End date",
	              default: tomorrow
	            }
	          }
	        }, {
	          title: "Mailing list opt-in by event bucket or event",
	          url: "reports/mailing_opt_ins",
	          temporary_export: true,
	          query: {
	            event: {
	              type: "Event",
	              intermediate_value_key: "event_bucket",
	              label: "Event (optional)"
	            }
	          }
	        }, {
	          show: _UserStore2.default.isGod() || ["5e34ae2cc39cec003138f598", // AARP
	          "5eb9ae8bbd869b0071708e19" // IDA
	          ].indexOf((_UserStore2.default.getUser() || {}).id) !== -1,
	          title: "Virtual screening user supplementary data",
	          badge: "Limited Beta",
	          url: "reports/user_person_supplementary_data",
	          temporary_export: true,
	          query: {
	            event: {
	              type: "Event",
	              intermediate_value_key: "event_bucket",
	              label: "Event (optional)"
	            }
	          }
	        }].filter(function (r) {
	          return typeof r.show === "undefined" || r.show;
	        })
	      }];
	
	      var legacyReports = [{
	        title: "Legacy Reports",
	        visible: true,
	        reports: [{
	          title: "Bank transfer log",
	          url: "reports/financials/transfer_log",
	          temporary_export: true,
	          query: {
	            format: "csv",
	            start: {
	              type: "Date",
	              label: "Start date",
	              default: oneMonthAgo
	            },
	            end: {
	              type: "Date",
	              endOfDay: true,
	              label: "End date",
	              default: tomorrow
	            }
	          }
	        }, {
	          title: "Bank transfer log (+ gross sales/fees)",
	          url: "reports/financials/transfer_log",
	          temporary_export: true,
	          query: {
	            gross_and_fees: true,
	            format: "csv",
	            start: {
	              type: "Date",
	              label: "Start date",
	              default: oneMonthAgo
	            },
	            end: {
	              type: "Date",
	              endOfDay: true,
	              label: "End date",
	              default: tomorrow
	            }
	          }
	        }, {
	          title: "Detailed bank transfer log (by level/bucket)",
	          url: "reports/financials/transfer_log",
	          temporary_export: true,
	          query: {
	            detail: true,
	            format: "csv",
	            start: {
	              type: "Date",
	              label: "Start date",
	              default: oneMonthAgo
	            },
	            end: {
	              type: "Date",
	              endOfDay: true,
	              label: "End date",
	              default: tomorrow
	            }
	          }
	        }, {
	          title: "Bank transfer reconciliation by screening",
	          url: "reports/financials/transfer_reconciliation",
	          temporary_export: true,
	          query: {
	            start: {
	              type: "Date",
	              label: "Start date",
	              default: oneMonthAgo
	            },
	            end: {
	              type: "Date",
	              endOfDay: true,
	              label: "End date",
	              default: tomorrow
	            }
	          }
	        }, {
	          title: "Bank transfer reconciliation by individual purchase",
	          url: "reports/financials/transfer_reconciliation",
	          temporary_export: true,
	          query: {
	            by_individual_purchase: true,
	            start: {
	              type: "Date",
	              label: "Start date",
	              default: oneMonthAgo
	            },
	            end: {
	              type: "Date",
	              endOfDay: true,
	              label: "End date",
	              default: tomorrow
	            }
	          }
	        }]
	      }];
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          _materialUi.Dialog,
	          {
	            title: this.state.reportToShowModal && this.state.reportToShowModal.title,
	            actions: [_react2.default.createElement(_materialUi.FlatButton, {
	              label: this.state.showTemporaryExportSuccess ? "Close" : "Cancel",
	              onTouchTap: this.cancelModal
	            })].concat(!this.state.showTemporaryExportSuccess ? [_react2.default.createElement(_materialUi.FlatButton, {
	              label: this.state.reportToShowModal && this.state.reportToShowModal.generate_label || "Generate report",
	              onTouchTap: this.submitModal,
	              primary: true
	            })] : []),
	            autoDetectWindowHeight: false,
	            autoScrollBodyContent: false,
	            bodyStyle: { overflowY: "visible" },
	            open: !!this.state.reportToShowModal
	          },
	          _react2.default.createElement(
	            "div",
	            null,
	            this.state.reportToShowModal ? this.state.processingReport ? _react2.default.createElement(_workingIndicator2.default, { centered: true }) : this.state.showTemporaryExportSuccess ? this.state.completedExport ? this.state.completedExport.error ? _react2.default.createElement(
	              "div",
	              null,
	              _react2.default.createElement(
	                "p",
	                null,
	                "Unfortunately, we ran into an error preparing your report. Please try again, or contact us if the problem persists."
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                _react2.default.createElement(
	                  "i",
	                  null,
	                  "Error:",
	                  " ",
	                  _react2.default.createElement(
	                    "strong",
	                    null,
	                    this.state.completedExport.error
	                  )
	                )
	              )
	            ) : _react2.default.createElement(
	              "div",
	              null,
	              _react2.default.createElement(
	                "p",
	                null,
	                "Great news, your report is ready!"
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                _react2.default.createElement(
	                  "strong",
	                  null,
	                  this.state.completedExport.description
	                ),
	                _react2.default.createElement("br", null),
	                _react2.default.createElement(
	                  "a",
	                  {
	                    target: "_blank",
	                    href: this.state.completedExport.download_url
	                  },
	                  _react2.default.createElement(
	                    "strong",
	                    null,
	                    "Click here to download."
	                  )
	                )
	              )
	            ) : _react2.default.createElement(
	              "div",
	              null,
	              _react2.default.createElement(_workingIndicator2.default, { centered: true }),
	              _react2.default.createElement(
	                "p",
	                null,
	                "Your report is now being generated! This may take anywhere from a few seconds to a few minutes. Keep this page open and it will automatically update when your report is ready."
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                "Feel free to close this page. You will receive an email with a download link as soon as your report has been generated."
	              )
	            ) : function () {
	              var options = Object.entries(_this4.state.reportToShowModal.query).filter(function (_ref4) {
	                var _ref5 = _slicedToArray(_ref4, 2);
	
	                var k = _ref5[0];
	                var v = _ref5[1];
	                return v && v.type;
	              });
	
	              if (!options.length) {
	                return _react2.default.createElement(
	                  "div",
	                  null,
	                  "There are no available options to configure for this report."
	                );
	              }
	
	              return _react2.default.createElement(
	                "div",
	                null,
	                _this4.state.reportToShowModal.description ? _react2.default.createElement(
	                  "div",
	                  { style: { marginTop: "-1em" } },
	                  _this4.state.reportToShowModal.description
	                ) : null,
	                _react2.default.createElement(
	                  "div",
	                  { style: styles.innerDialog },
	                  options.map(function (_ref6) {
	                    var _ref7 = _slicedToArray(_ref6, 2);
	
	                    var key = _ref7[0];
	                    var options = _ref7[1];
	
	                    return REPORT_OPTIONS[options.type](options, _this4.state.selectedOptions[options.intermediate_value_key || key + "--intermediate"], _this4.state.selectedOptions[key], function (value) {
	                      var selected = Object.assign({}, _this4.state.selectedOptions);
	                      selected[key] = value;
	                      _this4.setState({ selectedOptions: selected });
	                    }, function (intermediateValue) {
	                      var selected = Object.assign({}, _this4.state.selectedOptions);
	                      selected[options.intermediate_value_key || key + "--intermediate"] = intermediateValue;
	                      _this4.setState({ selectedOptions: selected });
	                    });
	                  })
	                )
	              );
	            }() : null
	          )
	        ),
	        _react2.default.createElement(
	          "h1",
	          null,
	          "Reports"
	        ),
	        _react2.default.createElement(
	          "p",
	          null,
	          "Export reports for further analysis (available in CSV / XLSX format)."
	        ),
	        reports.filter(function (r) {
	          return r.visible;
	        }).map(function (r, i) {
	          return _react2.default.createElement(
	            "div",
	            { key: i },
	            _react2.default.createElement(
	              "h2",
	              { style: styles.subhead },
	              r.title
	            ),
	            r.reports.map(function (r, i) {
	              return _react2.default.createElement(
	                "li",
	                { key: i },
	                r.badge ? _react2.default.createElement(_inlineNoticeLabel2.default, {
	                  style: { marginRight: 5, fontWeight: "bold" },
	                  label: r.badge
	                }) : null,
	                r.title,
	                " \u2013",
	                " ",
	                _react2.default.createElement(
	                  _linkLike2.default,
	                  { onTouchTap: function onTouchTap() {
	                      return _this4.openModal(r);
	                    } },
	                  r.generate_label || "generate report"
	                )
	              );
	            })
	          );
	        }),
	        _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement(
	            "h2",
	            { style: styles.subhead },
	            "Ledger Beta Reports"
	          ),
	          _react2.default.createElement(
	            "li",
	            null,
	            _react2.default.createElement(_inlineNoticeLabel2.default, {
	              style: { marginRight: 5, fontWeight: "bold" },
	              label: "Beta"
	            }),
	            "Custom ledger report \u2013",
	            " ",
	            _react2.default.createElement(
	              _reactRouter.Link,
	              { to: "/analytics/ledger" },
	              "build report"
	            )
	          ),
	          _react2.default.createElement(
	            "li",
	            null,
	            _react2.default.createElement(_inlineNoticeLabel2.default, {
	              style: { marginRight: 5, fontWeight: "bold" },
	              label: "Beta"
	            }),
	            "Scheduled ledger reports \u2013",
	            " ",
	            _react2.default.createElement(
	              _reactRouter.Link,
	              { to: "/scheduled_reports" },
	              "schedule reports"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "h2",
	          { style: styles.subhead },
	          "Cross-Event-Bucket Comparison"
	        ),
	        _react2.default.createElement(
	          "li",
	          null,
	          "Daily total sales comparison between event buckets \u2013",
	          " ",
	          _react2.default.createElement(
	            _reactRouter.Link,
	            { to: "reports/cross_event_bucket" },
	            "generate graphs"
	          )
	        ),
	        legacyReports.filter(function (r) {
	          return r.visible;
	        }).map(function (r, i) {
	          return _react2.default.createElement(
	            "div",
	            { key: i },
	            _react2.default.createElement(
	              "div",
	              {
	                style: { cursor: "pointer" },
	                onClick: function onClick() {
	                  _this4.setState({ showLegacyReports: !_this4.state.showLegacyReports });
	                } },
	              _react2.default.createElement(
	                "h2",
	                { style: styles.subhead },
	                _this4.state.showLegacyReports ? "▾" : "▸",
	                " ",
	                r.title
	              )
	            ),
	            _this4.state.showLegacyReports ? r.reports.map(function (r, i) {
	              return _react2.default.createElement(
	                "li",
	                { key: i },
	                r.badge ? _react2.default.createElement(_inlineNoticeLabel2.default, {
	                  style: { marginRight: 5, fontWeight: "bold" },
	                  label: r.badge
	                }) : null,
	                r.title,
	                " \u2013",
	                " ",
	                _react2.default.createElement(
	                  _linkLike2.default,
	                  { onTouchTap: function onTouchTap() {
	                      return _this4.openModal(r);
	                    } },
	                  r.generate_label || "generate report"
	                )
	              );
	            }) : null
	          );
	        })
	      );
	    }
	  }], [{
	    key: "getStores",
	    value: function getStores() {
	      return [_UserStore2.default, _EventBucketStore2.default];
	    }
	  }, {
	    key: "getPropsFromStores",
	    value: function getPropsFromStores() {
	      return _UserStore2.default.getState();
	    }
	  }, {
	    key: "contextTypes",
	    get: function get() {
	      return {
	        router: _react2.default.PropTypes.object
	      };
	    }
	  }]);
	
	  return Reports;
	}(_react2.default.Component);
	
	exports.default = (0, _connectToStores2.default)(Reports);
	module.exports = exports["default"];

/***/ }),
/* 2904 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _scheduleTable = __webpack_require__(2905);
	
	var _scheduleTable2 = _interopRequireDefault(_scheduleTable);
	
	var _workingIndicator = __webpack_require__(1664);
	
	var _workingIndicator2 = _interopRequireDefault(_workingIndicator);
	
	var _inlineNoticeLabel = __webpack_require__(1222);
	
	var _inlineNoticeLabel2 = _interopRequireDefault(_inlineNoticeLabel);
	
	var _connectToStores = __webpack_require__(1226);
	
	var _connectToStores2 = _interopRequireDefault(_connectToStores);
	
	var _EventBucketStore = __webpack_require__(1593);
	
	var _EventBucketStore2 = _interopRequireDefault(_EventBucketStore);
	
	var _EventBucketActions = __webpack_require__(1218);
	
	var _EventBucketActions2 = _interopRequireDefault(_EventBucketActions);
	
	var _FilmActions = __webpack_require__(1764);
	
	var _FilmActions2 = _interopRequireDefault(_FilmActions);
	
	var _FilmStore = __webpack_require__(1765);
	
	var _FilmStore2 = _interopRequireDefault(_FilmStore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ReportScheduler = function (_React$Component) {
	  _inherits(ReportScheduler, _React$Component);
	
	  function ReportScheduler(props) {
	    _classCallCheck(this, ReportScheduler);
	
	    return _possibleConstructorReturn(this, Object.getPrototypeOf(ReportScheduler).call(this, props));
	  }
	
	  _createClass(ReportScheduler, [{
	    key: "getStyles",
	    value: function getStyles() {
	      return {};
	    }
	  }, {
	    key: "componentWillMount",
	    value: function componentWillMount() {
	      _EventBucketActions2.default.fetchAll();
	      _FilmActions2.default.fetchAllForUser();
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var styles = this.getStyles();
	
	      var eventBuckets = this.props.getEventBuckets();
	      var films = this.props.getAllUserFilms();
	
	      if (eventBuckets.length === 0) {
	        return _react2.default.createElement(_workingIndicator2.default, { fullPage: true });
	      }
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          "h1",
	          { style: { lineHeight: 1.2 } },
	          "Scheduled Reports",
	          " ",
	          _react2.default.createElement(_inlineNoticeLabel2.default, {
	            label: "Limited beta",
	            style: { marginLeft: 10, verticalAlign: "middle" }
	          })
	        ),
	        _react2.default.createElement(
	          "p",
	          { style: { fontStyle: "italic" } },
	          "You have been invited to the early-access Eventive Ledger Preview. Eventive Ledger powers the next generation of Eventive financial reporting tools and will be launching soon. Some features are not yet fully supported \u2013 as an early-access tester, please",
	          " ",
	          _react2.default.createElement(
	            "a",
	            { href: "mailto:ledgerfeedback@eventive.org" },
	            "let us know"
	          ),
	          " what reporting functionality would be most useful to you or if you run into any issues!"
	        ),
	        _react2.default.createElement(_scheduleTable2.default, { buckets: eventBuckets, films: films })
	      );
	    }
	  }], [{
	    key: "getStores",
	    value: function getStores() {
	      return [_EventBucketStore2.default, _FilmStore2.default];
	    }
	  }, {
	    key: "getPropsFromStores",
	    value: function getPropsFromStores() {
	      return {
	        getEventBuckets: _EventBucketStore2.default.getEventBuckets,
	        getEventBucketById: _EventBucketStore2.default.getEventBucketById,
	        getAllUserFilms: _FilmStore2.default.getAllUserFilms
	      };
	    }
	  }, {
	    key: "contextTypes",
	    get: function get() {
	      return {
	        router: _react2.default.PropTypes.object
	      };
	    }
	  }]);
	
	  return ReportScheduler;
	}(_react2.default.Component);
	
	exports.default = (0, _connectToStores2.default)(ReportScheduler);
	module.exports = exports["default"];

/***/ }),
/* 2905 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _moment = __webpack_require__(1021);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _materialUi = __webpack_require__(576);
	
	var _scheduleWidget = __webpack_require__(2906);
	
	var _scheduleWidget2 = _interopRequireDefault(_scheduleWidget);
	
	var _linkLike = __webpack_require__(973);
	
	var _linkLike2 = _interopRequireDefault(_linkLike);
	
	var _workingIndicator = __webpack_require__(1664);
	
	var _workingIndicator2 = _interopRequireDefault(_workingIndicator);
	
	var _DateTimeUtil = __webpack_require__(2907);
	
	var _DateTimeUtil2 = _interopRequireDefault(_DateTimeUtil);
	
	var _connectToStores = __webpack_require__(1226);
	
	var _connectToStores2 = _interopRequireDefault(_connectToStores);
	
	var _ReportScheduleStore = __webpack_require__(2913);
	
	var _ReportScheduleStore2 = _interopRequireDefault(_ReportScheduleStore);
	
	var _ReportScheduleActions = __webpack_require__(2915);
	
	var _ReportScheduleActions2 = _interopRequireDefault(_ReportScheduleActions);
	
	var _EventStore = __webpack_require__(2032);
	
	var _EventStore2 = _interopRequireDefault(_EventStore);
	
	var _EventActions = __webpack_require__(2031);
	
	var _EventActions2 = _interopRequireDefault(_EventActions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ScheduleTable = function (_React$Component) {
	  _inherits(ScheduleTable, _React$Component);
	
	  function ScheduleTable(props) {
	    _classCallCheck(this, ScheduleTable);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(ScheduleTable).call(this, props));
	
	    _this.state = {
	      showNewEditor: false,
	      showDeleteItem: null,
	      selectedItem: null,
	      reportTypes: {
	        box_office_report: "Box Office Report by Film",
	        custom_ledger_report: "Ledger Transaction Report",
	        recurring_pass_renewal_report: "Recurring Pass Renewal Report",
	        expired_pass_report: "Expired Pass Report",
	        new_subscription_report: "New Subscription Report"
	      },
	      timeLabels: _DateTimeUtil2.default.getTimeListAsObject()
	    };
	
	    _this.buildTimeLabel = _this.buildTimeLabel.bind(_this);
	    _this.makeRowForScheduleItem = _this.makeRowForScheduleItem.bind(_this);
	    _this.makeSelectedRow = _this.makeSelectedRow.bind(_this);
	    _this.buildReportName = _this.buildReportName.bind(_this);
	    _this.handleUpdate = _this.handleUpdate.bind(_this);
	    _this.handleClose = _this.handleClose.bind(_this);
	    _this.handlePauseResume = _this.handlePauseResume.bind(_this);
	    _this.handleDeleteConfirm = _this.handleDeleteConfirm.bind(_this);
	    _this.handleDeleteCancel = _this.handleDeleteCancel.bind(_this);
	    _this.updateEventList = _this.updateEventList.bind(_this);
	    _this.processEvents = _this.processEvents.bind(_this);
	    return _this;
	  }
	
	  _createClass(ScheduleTable, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      _ReportScheduleActions2.default.fetchAllForUser.defer();
	    }
	  }, {
	    key: "updateEventList",
	    value: function updateEventList(bucketId) {
	      this.setState({ selectedBucket: bucketId }, function () {
	        _EventActions2.default.fetchAllForBucket(bucketId);
	      });
	    }
	  }, {
	    key: "getStyles",
	    value: function getStyles() {
	      return {
	        scheduleTable: {},
	        gridHeader: {
	          backgroundColor: "#1c94d6",
	          color: "#fff",
	          fontWeight: "bold"
	        },
	        actionColumn: {
	          whiteSpace: "nowrap",
	          overflowX: "visible"
	        },
	        actionLink: {
	          float: "left",
	          marginRight: "15px"
	        }
	      };
	    }
	  }, {
	    key: "capitalize",
	    value: function capitalize(value) {
	      if (typeof value !== "string") return "";
	      return value.charAt(0).toUpperCase() + value.slice(1);
	    }
	  }, {
	    key: "buildTimeLabel",
	    value: function buildTimeLabel(item) {
	      var bucket = void 0;
	      if (item.event_bucket && item.event_bucket.length) {
	        bucket = this.props.buckets.find(function (element) {
	          return element.id === item.event_bucket[0]._id;
	        });
	      }
	      if (bucket) {
	        var hourNum = item.time.substring(0, item.time.indexOf(":"));
	        var selectedTime = (0, _moment2.default)().utc().set("hour", parseInt(hourNum, 10)).tz(bucket.timezone).format("HH:00");
	        return this.state.timeLabels[selectedTime] + " " + _moment2.default.tz(bucket.timezone).format("z");
	      } else {
	        return "";
	      }
	    }
	  }, {
	    key: "handlePauseResume",
	    value: function handlePauseResume(item) {
	      item.active = !item.active;
	      item.event_bucket = item.event_bucket.map(function (e) {
	        if (e._id) {
	          return e._id;
	        } else {
	          return e;
	        }
	      });
	      item.films = item.films ? item.films : item.film ? [item.film] : [];
	      _ReportScheduleActions2.default.update(item);
	    }
	  }, {
	    key: "handleClose",
	    value: function handleClose() {
	      this.setState({ selectedItem: null, showNewEditor: false });
	    }
	  }, {
	    key: "handleUpdate",
	    value: function handleUpdate(values) {
	      var updatedItem = {
	        report_name: values.report_name,
	        event_bucket: values.event_bucket,
	        films: values.films ? values.films : [],
	        conditions: values.conditions ? values.conditions : {},
	        nickname: values.nickname ? values.nickname : "",
	        time: values.time.value,
	        day_of_week: values.day_of_week ? values.day_of_week.value : null,
	        frequency: values.frequency.value,
	        recipient_emails: values.recipient_emails
	      };
	
	      if (this.state.showNewEditor) {
	        this.setState({ selectedItem: null, showNewEditor: false });
	        _ReportScheduleActions2.default.create(updatedItem);
	      } else {
	        this.setState({ selectedItem: null });
	        updatedItem.id = values.id;
	        _ReportScheduleActions2.default.update(updatedItem);
	      }
	    }
	  }, {
	    key: "handleDeleteConfirm",
	    value: function handleDeleteConfirm() {
	      _ReportScheduleActions2.default.delete(this.state.showDeleteItem);
	      this.setState({ selectedItem: null, showDeleteItem: null });
	    }
	  }, {
	    key: "handleDeleteCancel",
	    value: function handleDeleteCancel() {
	      this.setState({ selectedItem: null, showDeleteItem: null });
	    }
	  }, {
	    key: "processEvents",
	    value: function processEvents() {
	      var events = null;
	      var unprocessedEvents = this.props.getEventsForEventBucket(this.state.selectedBucket);
	      events = unprocessedEvents.map(function (e) {
	        return {
	          label: e.name,
	          value: e.id,
	          id: e.id
	        };
	      });
	      return events;
	    }
	  }, {
	    key: "makeSelectedRow",
	    value: function makeSelectedRow(item) {
	      var styles = this.getStyles();
	      var reportName = this.buildReportName(item);
	      var events = this.processEvents();
	
	      return [_react2.default.createElement(
	        "tr",
	        { key: item.id },
	        _react2.default.createElement(
	          "td",
	          null,
	          reportName
	        ),
	        _react2.default.createElement(
	          "td",
	          { width: "100" },
	          this.capitalize(item.frequency)
	        ),
	        _react2.default.createElement(
	          "td",
	          { width: "120" },
	          this.buildTimeLabel(item)
	        ),
	        _react2.default.createElement(
	          "td",
	          { width: "100" },
	          item.last_sent_status ? this.capitalize(item.last_sent_status) : "Scheduled"
	        ),
	        _react2.default.createElement("td", { width: "160", style: styles.actionColumn })
	      ), _react2.default.createElement(
	        "tr",
	        { key: item.id + "_edit" },
	        _react2.default.createElement(
	          "td",
	          { colSpan: 5 },
	          _react2.default.createElement(_scheduleWidget2.default, {
	            item: item,
	            update: this.handleUpdate,
	            close: this.handleClose,
	            buckets: this.props.buckets,
	            films: this.props.films,
	            events: events,
	            updateEvents: this.updateEventList
	          })
	        )
	      )];
	    }
	  }, {
	    key: "makeRowForDeleteItem",
	    value: function makeRowForDeleteItem(item) {
	      var styles = this.getStyles();
	      var reportName = this.buildReportName(item);
	      return [_react2.default.createElement(
	        "tr",
	        { key: item.id, style: { backgroundColor: "#ffcccb" } },
	        _react2.default.createElement(
	          "td",
	          { style: { paddingTop: "15px" } },
	          reportName
	        ),
	        _react2.default.createElement(
	          "td",
	          { width: "100" },
	          this.capitalize(item.frequency)
	        ),
	        _react2.default.createElement(
	          "td",
	          { width: "120" },
	          this.buildTimeLabel(item)
	        ),
	        _react2.default.createElement(
	          "td",
	          { width: "100" },
	          item.last_sent_status ? this.capitalize(item.last_sent_status) : "Scheduled"
	        ),
	        _react2.default.createElement("td", { width: "160", style: styles.actionColumn })
	      ), _react2.default.createElement(
	        "tr",
	        { key: item.id + "_delete" },
	        _react2.default.createElement(
	          "td",
	          {
	            colSpan: 5,
	            style: {
	              textAlign: "right",
	              fontWeight: "bold",
	              paddingBottom: "20px",
	              backgroundColor: "#ffcccb"
	            }
	          },
	          _react2.default.createElement(
	            "div",
	            { style: { paddingBottom: "5px" } },
	            "Are you sure you want to delete this schedule?"
	          ),
	          _react2.default.createElement(_materialUi.RaisedButton, {
	            label: "Delete",
	            backgroundColor: "#f00",
	            labelColor: "#fff",
	            onTouchTap: this.handleDeleteConfirm
	          }),
	          _react2.default.createElement(_materialUi.RaisedButton, {
	            label: "Never Mind",
	            primary: false,
	            style: { marginLeft: "15px" },
	            onTouchTap: this.handleDeleteCancel
	          })
	        )
	      )];
	    }
	  }, {
	    key: "makeRowForScheduleItem",
	    value: function makeRowForScheduleItem(item) {
	      var _this2 = this;
	
	      var styles = this.getStyles();
	      var reportName = this.buildReportName(item);
	      return [_react2.default.createElement(
	        "tr",
	        {
	          key: item.id,
	          className: "schedule-report-row",
	          style: item.active ? {} : { color: "#bbb" }
	        },
	        _react2.default.createElement(
	          "td",
	          null,
	          reportName
	        ),
	        _react2.default.createElement(
	          "td",
	          { width: "100" },
	          this.capitalize(item.frequency)
	        ),
	        _react2.default.createElement(
	          "td",
	          { width: "120" },
	          this.buildTimeLabel(item)
	        ),
	        _react2.default.createElement(
	          "td",
	          { width: "100" },
	          item.last_sent_status ? this.capitalize(item.last_sent_status) : "Scheduled"
	        ),
	        _react2.default.createElement(
	          "td",
	          { width: "160", style: styles.actionColumn },
	          _react2.default.createElement(
	            _linkLike2.default,
	            {
	              style: styles.actionLink,
	              onTouchTap: function onTouchTap(e) {
	                _this2.handlePauseResume(item);
	              }
	            },
	            item.active ? "Pause" : "Resume"
	          ),
	          _react2.default.createElement(
	            _linkLike2.default,
	            {
	              style: styles.actionLink,
	              onTouchTap: function onTouchTap(e) {
	                _this2.setState({ showNewEditor: false, selectedItem: item.id });
	              }
	            },
	            "Edit"
	          ),
	          _react2.default.createElement(
	            _linkLike2.default,
	            {
	              style: styles.actionLink,
	              onTouchTap: function onTouchTap(e) {
	                _this2.setState({
	                  showNewEditor: false,
	                  selectedItem: item.id,
	                  showDeleteItem: item.id
	                });
	              }
	            },
	            "Delete"
	          )
	        )
	      )];
	    }
	  }, {
	    key: "buildReportName",
	    value: function buildReportName(item) {
	      var reportName = this.state.reportTypes[item.report_name];
	      var hasSingleFilm = typeof item.film !== "undefined";
	      var multipleFilmsName = item.films && item.films.length === 1 ? item.films[0].name : "Films";
	      var singleFilmName = !item.film ? "Unnamed Film" : item.film.name;
	      if (item.report_name === "box_office_report") {
	        reportName = reportName + " - " + (hasSingleFilm ? singleFilmName : multipleFilmsName);
	        //} else if (item.report_name === "memberbership_renewal_report") {
	        //    reportName = reportName;
	      } else if (item.nickname && item.nickname !== "") {
	        reportName = reportName + " - " + item.nickname;
	      }
	      return reportName;
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this3 = this;
	
	      var styles = this.getStyles();
	
	      var items = this.props.getAllUserReportSchedules();
	
	      if (this.props.isFetching && items.length === 0) {
	        return _react2.default.createElement(_workingIndicator2.default, { fullPage: true });
	      }
	
	      var events = this.processEvents();
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          "div",
	          { style: { paddingTop: "10px" } },
	          _react2.default.createElement(
	            "table",
	            null,
	            _react2.default.createElement(
	              "thead",
	              { style: styles.gridHeader },
	              _react2.default.createElement(
	                "td",
	                null,
	                "Name"
	              ),
	              _react2.default.createElement(
	                "td",
	                null,
	                "Frequency"
	              ),
	              _react2.default.createElement(
	                "td",
	                null,
	                "Time"
	              ),
	              _react2.default.createElement(
	                "td",
	                null,
	                "Status"
	              ),
	              _react2.default.createElement(
	                "td",
	                null,
	                "Actions"
	              )
	            ),
	            _react2.default.createElement(
	              "tbody",
	              null,
	              items ? items.map(function (item) {
	                return _this3.state.selectedItem === item.id ? _this3.state.showDeleteItem === item.id ? _this3.makeRowForDeleteItem(item) : _this3.makeSelectedRow(item) : _this3.makeRowForScheduleItem(item);
	              }) : null
	            )
	          )
	        ),
	        items.length === 0 ? _react2.default.createElement(
	          "div",
	          { className: "empty-table-message" },
	          "No scheduled reports yet.",
	          " ",
	          _react2.default.createElement(
	            _linkLike2.default,
	            {
	              onTouchTap: function onTouchTap() {
	                return _this3.setState({
	                  selectedItem: null,
	                  showNewEditor: true
	                });
	              }
	            },
	            "Schedule an automated report."
	          )
	        ) : null,
	        this.state.showNewEditor ? null : _react2.default.createElement(
	          "div",
	          { style: { marginTop: "1em" } },
	          _react2.default.createElement(_materialUi.RaisedButton, {
	            label: "Create new Scheduled Report",
	            primary: true,
	            onClick: function onClick() {
	              return _this3.setState({ selectedItem: null, showNewEditor: true });
	            }
	          })
	        ),
	        this.state.showNewEditor ? _react2.default.createElement(
	          "div",
	          { style: { paddingTop: 10 } },
	          _react2.default.createElement(_scheduleWidget2.default, {
	            item: {},
	            update: this.handleUpdate,
	            close: this.handleClose,
	            buckets: this.props.buckets,
	            films: this.props.films,
	            events: events,
	            updateEvents: this.updateEventList,
	            isNew: true
	          })
	        ) : null
	      );
	    }
	  }], [{
	    key: "getStores",
	    value: function getStores() {
	      return [_ReportScheduleStore2.default, _EventStore2.default];
	    }
	  }, {
	    key: "getPropsFromStores",
	    value: function getPropsFromStores() {
	      return {
	        getEventsForEventBucket: _EventStore2.default.getEventsForEventBucket,
	        getReportScheduleById: _ReportScheduleStore2.default.getReportScheduleById,
	        getAllUserReportSchedules: _ReportScheduleStore2.default.getAllUserReportSchedules,
	        isFetching: _ReportScheduleStore2.default.getState().isFetching
	      };
	    }
	  }]);
	
	  return ScheduleTable;
	}(_react2.default.Component);
	
	exports.default = (0, _connectToStores2.default)(ScheduleTable);
	module.exports = exports["default"];

/***/ }),
/* 2906 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactSelect = __webpack_require__(953);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	var _materialUi = __webpack_require__(576);
	
	var _cloneDeep = __webpack_require__(1189);
	
	var _cloneDeep2 = _interopRequireDefault(_cloneDeep);
	
	var _moment = __webpack_require__(1021);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _DateTimeUtil = __webpack_require__(2907);
	
	var _DateTimeUtil2 = _interopRequireDefault(_DateTimeUtil);
	
	var _boxOfficeScheduleView = __webpack_require__(2908);
	
	var _boxOfficeScheduleView2 = _interopRequireDefault(_boxOfficeScheduleView);
	
	var _customLedgerScheduleView = __webpack_require__(2909);
	
	var _customLedgerScheduleView2 = _interopRequireDefault(_customLedgerScheduleView);
	
	var _recurringPassRenewalScheduleView = __webpack_require__(2910);
	
	var _recurringPassRenewalScheduleView2 = _interopRequireDefault(_recurringPassRenewalScheduleView);
	
	var _expiredPassScheduleView = __webpack_require__(2911);
	
	var _expiredPassScheduleView2 = _interopRequireDefault(_expiredPassScheduleView);
	
	var _newSubscriptionScheduleView = __webpack_require__(2912);
	
	var _newSubscriptionScheduleView2 = _interopRequireDefault(_newSubscriptionScheduleView);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ScheduleWidget = function (_React$Component) {
	  _inherits(ScheduleWidget, _React$Component);
	
	  function ScheduleWidget(props) {
	    _classCallCheck(this, ScheduleWidget);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(ScheduleWidget).call(this, props));
	
	    _this.state = {
	      selectedItem: null,
	      selectedReport: null,
	      selectedBuckets: [],
	      selectedFilm: [],
	      selectedFrequency: null,
	      selectedTime: null,
	      selectedDayOfWeek: null,
	      recipientEmails: "",
	      conditions: {},
	      nickname: "",
	      frequencyList: [{ label: "Daily", value: "daily" }, { label: "Weekdays (M-F)", value: "weekdays" }, { label: "Weekly", value: "weekly" }, { label: "Monthly", value: "monthly" }],
	      timeList: _DateTimeUtil2.default.getTimeList(),
	      dayOfWeekList: _DateTimeUtil2.default.getDayOfWeekList(),
	      childIsComplete: false
	    };
	
	    _this.handleUpdateClick = _this.handleUpdateClick.bind(_this);
	    _this.handleCloseClick = _this.handleCloseClick.bind(_this);
	    _this.displayReportRangeInfo = _this.displayReportRangeInfo.bind(_this);
	    _this.handleScheduleViewChange = _this.handleScheduleViewChange.bind(_this);
	    _this.checkUpdateButtonIsDisabled = _this.checkUpdateButtonIsDisabled.bind(_this);
	    _this.makeScheduleWidgetView = _this.makeScheduleWidgetView.bind(_this);
	    _this.handleUpdateEvents = _this.handleUpdateEvents.bind(_this);
	    return _this;
	  }
	
	  _createClass(ScheduleWidget, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var item = this.props.item;
	      //TODO: Handle "film" property
	      this.setState({
	        selectedItem: item.id,
	        selectedReport: item.report_name,
	        selectedFrequency: { value: item.frequency },
	        selectedTime: { value: item.time },
	        selectedDayOfWeek: item.day_of_week,
	        recipientEmails: this.convertEmailsToString(item.recipient_emails),
	        selectedBuckets: [item.event_bucket && item.event_bucket.length > 0 ? item.event_bucket[0]._id : null],
	        selectedFilm: item.films ? item.films.map(function (film) {
	          return { value: film._id, label: film.name };
	        }) : item.film ? [{ value: item.film._id, label: item.film.name }] : [],
	        conditions: item.conditions ? item.conditions : null
	      });
	      // if editing an existing schedule, the item is assumed complete
	      // at load time
	      if (item.id) {
	        this.setState({ childIsComplete: true });
	      }
	    }
	  }, {
	    key: "handleUpdateEvents",
	    value: function handleUpdateEvents(bucketId) {
	      this.props.updateEvents(bucketId);
	    }
	  }, {
	    key: "handleCloseClick",
	    value: function handleCloseClick() {
	      this.props.close();
	    }
	  }, {
	    key: "handleUpdateClick",
	    value: function handleUpdateClick() {
	      this.props.update({
	        id: this.state.selectedItem,
	        report_name: this.state.selectedReport,
	        event_bucket: Array.isArray(this.state.selectedBuckets) ? this.state.selectedBuckets : [this.state.selectedBuckets],
	        films: this.state.selectedFilm ? this.state.selectedFilm.map(function (film) {
	          return {
	            name: film.label,
	            id: film.value
	          };
	        }) : [],
	        conditions: this.state.conditions ? this.state.conditions : {},
	        nickname: this.state.nickname ? this.state.nickname : "",
	        frequency: this.state.selectedFrequency,
	        time: this.state.selectedTime,
	        day_of_week: this.state.selectedDayOfWeek,
	        recipient_emails: this.convertEmailsToArray(this.state.recipientEmails)
	      });
	    }
	  }, {
	    key: "handleScheduleViewChange",
	    value: function handleScheduleViewChange(updatedState, isComplete) {
	      this.setState(updatedState);
	      // Child Schedule View must return isComplete status in order for
	      // ScheduleWidget to know if the Submit/Update button can be enabled
	      this.setState({ childIsComplete: isComplete });
	    }
	  }, {
	    key: "checkUpdateButtonIsDisabled",
	    value: function checkUpdateButtonIsDisabled() {
	      if (this.state.childIsComplete === false || this.state.selectedFrequency.value == null || this.state.selectedTime.value == null || this.state.recipientEmails === null || this.state.recipientEmails.trim() === "") {
	        return true;
	      }
	
	      if (this.state.selectedFrequency === "weekly" && this.state.selectedDayOfWeek === null) {
	        return true;
	      }
	
	      return false;
	    }
	  }, {
	    key: "displayReportRangeInfo",
	    value: function displayReportRangeInfo() {
	      var info = "";
	      switch (this.state.selectedFrequency.value) {
	        case "daily":
	          info = "Delivers report data from 12:00 AM to 11:59 PM of the previous day.";
	          break;
	        case "weekdays":
	          info = "Delivers report data from 12:00 AM to 11:50 PM of the previous day. On Mondays, delivers data from Friday to Sunday.";
	          break;
	        case "weekly":
	          var now = (0, _moment2.default)();
	          if (this.state.selectedDayOfWeek) {
	            now.day(this.state.selectedDayOfWeek.value);
	          }
	          var lastDay = now.subtract(1, "days").format("ddd");
	          var firstDay = now.subtract(6, "days").format("ddd");
	          info = "Delivers report data from the previous 7 days (" + firstDay + " - " + lastDay + ").";
	          break;
	        case "monthly":
	          info = "Delivers report data from the previous month on the 1st of the next month.";
	          break;
	        default:
	          break;
	      }
	      return info;
	    }
	  }, {
	    key: "convertEmailsToArray",
	    value: function convertEmailsToArray(value) {
	      if (typeof value !== "string") {
	        return [];
	      } else {
	        return this.state.recipientEmails.split(",").map(function (item) {
	          return item.trim();
	        });
	      }
	    }
	  }, {
	    key: "convertEmailsToString",
	    value: function convertEmailsToString(values) {
	      return (values || []).join(", ");
	    }
	  }, {
	    key: "getStyles",
	    value: function getStyles() {
	      return {
	        widgetWrapper: {
	          backgroundColor: "#eee",
	          boxSizing: "border-box",
	          padding: "30px",
	          width: "100%",
	          borderRadius: "1em"
	        },
	        widgetTitle: {
	          float: "left",
	          overflow: "visible",
	          fontWeight: "bold",
	          fontSize: "15px"
	        },
	        reportTypeWrapper: {
	          clear: "both",
	          float: "left",
	          marginTop: "-5px"
	        },
	        emailInput: {
	          backgroundColor: "#fff",
	          border: "1px solid #ccc",
	          borderRadius: "3px",
	          height: "20px",
	          width: "60%",
	          minWidth: "400px",
	          fontSize: "13px",
	          padding: "8px"
	        },
	        fieldLabel: {
	          color: "#737373",
	          fontWeight: "bold",
	          marginBottom: 2
	        }
	      };
	    }
	  }, {
	    key: "makeScheduleWidgetView",
	    value: function makeScheduleWidgetView(eventBucketList, filmList) {
	      switch (this.state.selectedReport) {
	        case "box_office_report":
	          return _react2.default.createElement(_boxOfficeScheduleView2.default, {
	            item: this.props.item,
	            eventBuckets: eventBucketList,
	            films: filmList,
	            update: this.handleScheduleViewChange
	          });
	
	        case "custom_ledger_report":
	          return _react2.default.createElement(_customLedgerScheduleView2.default, {
	            item: this.props.item,
	            eventBuckets: eventBucketList,
	            update: this.handleScheduleViewChange,
	            events: this.props.events,
	            updateEvents: this.handleUpdateEvents
	          });
	
	        case "recurring_pass_renewal_report":
	          return _react2.default.createElement(_recurringPassRenewalScheduleView2.default, {
	            item: this.props.item,
	            eventBuckets: eventBucketList,
	            update: this.handleScheduleViewChange
	          });
	
	        case "expired_pass_report":
	          return _react2.default.createElement(_expiredPassScheduleView2.default, {
	            item: this.props.item,
	            eventBuckets: eventBucketList,
	            update: this.handleScheduleViewChange
	          });
	
	        case "new_subscription_report":
	          return _react2.default.createElement(_newSubscriptionScheduleView2.default, {
	            item: this.props.item,
	            eventBuckets: eventBucketList,
	            update: this.handleScheduleViewChange
	          });
	
	        default:
	          return null;
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props;
	      var value = _props.value;
	      var onChange = _props.onChange;
	      var onBlur = _props.onBlur;
	      var placeholder = _props.placeholder;
	
	      var props = _objectWithoutProperties(_props, ["value", "onChange", "onBlur", "placeholder"]);
	
	      var styles = this.getStyles();
	
	      var timeList = this.state.timeList;
	      var selectedTime = this.state.selectedTime && this.state.selectedTime.value ? this.state.selectedTime.value : null;
	
	      var eventBuckets = this.props.buckets;
	      var eventBucketList = [];
	      if (eventBuckets) {
	        eventBucketList = eventBuckets.map(function (e) {
	          return { label: e.name, value: e.id };
	        });
	      }
	
	      var filmList = [];
	      if (this.state.selectedBuckets && this.state.selectedBuckets.length > 0) {
	        (function () {
	          var films = _this2.props.films;
	          // filter "accident" unnamed films out
	          films = films.filter(function (f) {
	            return f.name;
	          });
	          films = films.reduce(function (result, item) {
	            if (item.event_bucket === _this2.state.selectedBuckets[0]) {
	              result.push(item);
	            }
	            return result;
	          }, []);
	
	          filmList = films.map(function (f) {
	            return { label: f.name, value: f.id };
	          });
	
	          var bucket = _this2.props.buckets.find(function (element) {
	            return element.id === _this2.state.selectedBuckets[0];
	          });
	
	          var timezone = bucket ? bucket.timezone : "America/Los_Angeles"; //Intl.DateTimeFormat().resolvedOptions().timeZone;
	
	          timeList = _this2.state.timeList.map(function (item) {
	            var newItem = (0, _cloneDeep2.default)(item);
	            newItem.label = newItem.label + " " + _moment2.default.tz(timezone).format("z");
	            return newItem;
	          });
	
	          if (selectedTime) {
	            var hourNum = selectedTime.substring(0, selectedTime.indexOf(":"));
	            selectedTime = (0, _moment2.default)().utc().set("hour", parseInt(hourNum, 10)).tz(timezone).format("HH:00");
	          }
	        })();
	      }
	
	      return _react2.default.createElement(
	        "div",
	        { style: styles.widgetWrapper },
	        _react2.default.createElement(
	          "div",
	          { style: styles.widgetTitle },
	          this.props.isNew ? "Schedule Automated Report" : "Edit Automated Report"
	        ),
	        _react2.default.createElement(
	          "div",
	          {
	            style: {
	              float: "right"
	            }
	          },
	          _react2.default.createElement(_materialUi.RaisedButton, { label: "X", onTouchTap: this.handleCloseClick })
	        ),
	        _react2.default.createElement(
	          "div",
	          { style: styles.reportTypeWrapper },
	          _react2.default.createElement(
	            "div",
	            { style: styles.fieldLabel },
	            "Report Type"
	          ),
	          _react2.default.createElement(_reactSelect2.default, {
	            clearable: false,
	            autosize: false,
	            multi: false,
	            value: this.state.selectedReport,
	            placeholder: "Select a report...",
	            options: [{ label: "Box Office Report by Film", value: "box_office_report" }, { label: "Ledger Transaction Report", value: "custom_ledger_report" }, {
	              label: "Recurring Pass Renewal Report",
	              value: "recurring_pass_renewal_report"
	            }, { label: "Expired Pass Report", value: "expired_pass_report" }, {
	              label: "New Subscription Report",
	              value: "new_subscription_report"
	            }],
	            onChange: function onChange(e) {
	              _this2.setState({ selectedReport: e.value });
	            }
	          })
	        ),
	        this.state.selectedReport ? _react2.default.createElement(
	          "div",
	          { style: { clear: "both", paddingTop: "10px" } },
	          _react2.default.createElement(
	            "div",
	            { style: styles.fieldLabel },
	            "Recipient Emails (separated by commas)"
	          ),
	          _react2.default.createElement("input", {
	            value: this.state.recipientEmails,
	            style: styles.emailInput,
	            onChange: function onChange(e) {
	              _this2.setState({ recipientEmails: e.target.value });
	            }
	          })
	        ) : null,
	        this.makeScheduleWidgetView(eventBucketList, filmList),
	        this.state.selectedReport ? _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement(
	            "div",
	            {
	              className: "pull-left clear-both",
	              style: {
	                width: "200px",
	                paddingTop: "10px"
	              }
	            },
	            _react2.default.createElement(
	              "div",
	              { style: styles.fieldLabel },
	              "Frequency"
	            ),
	            _react2.default.createElement(_reactSelect2.default, {
	              clearable: false,
	              autosize: false,
	              multi: false,
	              placeholder: "No frequency selected",
	              value: this.state.selectedFrequency ? this.state.selectedFrequency.value : null,
	              options: this.state.frequencyList,
	              onChange: function onChange(value) {
	                _this2.setState({
	                  selectedFrequency: value,
	                  selectedDayOfWeek: null
	                });
	              }
	            })
	          ),
	          this.state.selectedFrequency ? this.state.selectedFrequency.value === "weekly" ? _react2.default.createElement(
	            "div",
	            {
	              className: "pull-left",
	              style: {
	                width: "200px",
	                paddingTop: "10px",
	                marginLeft: "25px"
	              }
	            },
	            _react2.default.createElement(
	              "div",
	              { style: styles.fieldLabel },
	              "Day of Week"
	            ),
	            _react2.default.createElement(_reactSelect2.default, {
	              clearable: false,
	              autosize: false,
	              multi: false,
	              placeholder: "No day of week selected",
	              value: this.state.selectedDayOfWeek,
	              options: this.state.dayOfWeekList,
	              onChange: function onChange(value) {
	                _this2.setState({ selectedDayOfWeek: value });
	              }
	            })
	          ) : null : null,
	          _react2.default.createElement(
	            "div",
	            {
	              className: "pull-left",
	              style: {
	                width: "150px",
	                paddingTop: "10px",
	                marginLeft: "25px"
	              }
	            },
	            _react2.default.createElement(
	              "div",
	              { style: styles.fieldLabel },
	              "Delivery Time"
	            ),
	            _react2.default.createElement(_reactSelect2.default, {
	              clearable: false,
	              autosize: false,
	              multi: false,
	              placeholder: "No time selected",
	              value: selectedTime,
	              options: timeList,
	              onChange: function onChange(value) {
	                var bucket = void 0;
	                if (_this2.state.selectedBuckets && _this2.state.selectedBuckets.length > 0) {
	                  bucket = _this2.props.buckets.find(function (element) {
	                    return element.id === _this2.state.selectedBuckets[0];
	                  });
	                }
	                var timezone = bucket ? bucket.timezone : "America/Los_Angeles"; //Intl.DateTimeFormat().resolvedOptions().timeZone;
	
	                var hourNum = value.value.substring(0, value.value.indexOf(":"));
	                _this2.setState({
	                  selectedTime: {
	                    value: (0, _moment2.default)().set("hour", parseInt(hourNum, 10)).tz(timezone).utc().format("HH:00")
	                  }
	                });
	              }
	            })
	          ),
	          this.state.selectedFrequency ? _react2.default.createElement(
	            "div",
	            {
	              style: {
	                clear: "both",
	                paddingTop: "10px",
	                color: "#555",
	                fontStyle: "italic"
	              }
	            },
	            this.displayReportRangeInfo()
	          ) : null
	        ) : null,
	        _react2.default.createElement(
	          "div",
	          { style: { clear: "both", paddingTop: "20px" } },
	          _react2.default.createElement(_materialUi.RaisedButton, {
	            label: "Schedule",
	            onClick: this.handleUpdateClick,
	            disabled: this.checkUpdateButtonIsDisabled()
	          })
	        )
	      );
	    }
	  }]);
	
	  return ScheduleWidget;
	}(_react2.default.Component);
	
	exports.default = ScheduleWidget;
	module.exports = exports["default"];

/***/ }),
/* 2907 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  getTimeList: function getTimeList() {
	    return [{ label: "Midnight", value: "00:00" }, { label: "1:00 AM", value: "01:00" }, { label: "2:00 AM", value: "02:00" }, { label: "3:00 AM", value: "03:00" }, { label: "4:00 AM", value: "04:00" }, { label: "5:00 AM", value: "05:00" }, { label: "6:00 AM", value: "06:00" }, { label: "7:00 AM", value: "07:00" }, { label: "8:00 AM", value: "08:00" }, { label: "9:00 AM", value: "09:00" }, { label: "10:00 AM", value: "10:00" }, { label: "11:00 AM", value: "11:00" }, { label: "Noon", value: "12:00" }, { label: "1:00 PM", value: "13:00" }, { label: "2:00 PM", value: "14:00" }, { label: "3:00 PM", value: "15:00" }, { label: "4:00 PM", value: "16:00" }, { label: "5:00 PM", value: "17:00" }, { label: "6:00 PM", value: "18:00" }, { label: "7:00 PM", value: "19:00" }, { label: "8:00 PM", value: "20:00" }, { label: "9:00 PM", value: "21:00" }, { label: "10:00 PM", value: "22:00" }, { label: "11:00 PM", value: "23:00" }];
	  },
	  getTimeListAsObject: function getTimeListAsObject() {
	    var timeList = {};
	    this.getTimeList().map(function (item) {
	      timeList[item.value] = item.label;
	    });
	    return timeList;
	  },
	  getDayOfWeekList: function getDayOfWeekList() {
	    return [{ label: "Sunday", value: 0 }, { label: "Monday", value: 1 }, { label: "Tuesday", value: 2 }, { label: "Wednesday", value: 3 }, { label: "Thursday", value: 4 }, { label: "Friday", value: 5 }, { label: "Saturday", value: 6 }];
	  }
	};
	module.exports = exports["default"];

/***/ }),
/* 2908 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactSelect = __webpack_require__(953);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	var _materialUi = __webpack_require__(576);
	
	var _cloneDeep = __webpack_require__(1189);
	
	var _cloneDeep2 = _interopRequireDefault(_cloneDeep);
	
	var _moment = __webpack_require__(1021);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _DateTimeUtil = __webpack_require__(2907);
	
	var _DateTimeUtil2 = _interopRequireDefault(_DateTimeUtil);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BoxOfficeScheduleView = function (_React$Component) {
	  _inherits(BoxOfficeScheduleView, _React$Component);
	
	  function BoxOfficeScheduleView(props) {
	    _classCallCheck(this, BoxOfficeScheduleView);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(BoxOfficeScheduleView).call(this, props));
	
	    _this.state = {
	      selectedBucket: null,
	      selectedFilm: []
	    };
	
	    _this.handleParentStateUpdate = _this.handleParentStateUpdate.bind(_this);
	    _this.handleCloseClick = _this.handleCloseClick.bind(_this);
	    return _this;
	  }
	
	  _createClass(BoxOfficeScheduleView, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var item = this.props.item;
	      //TODO: Handle "film" property
	      this.setState({
	        selectedBucket: {
	          value: item.event_bucket && item.event_bucket.length > 0 ? item.event_bucket[0]._id : null
	        },
	        selectedFilm: item.films && item.films.length > 0 ? item.films.map(function (film) {
	          return { value: film._id, label: film.name };
	        }) : item.film ? [{ value: item.film._id, label: item.film.name }] : []
	      });
	    }
	  }, {
	    key: "handleCloseClick",
	    value: function handleCloseClick() {
	      this.props.close();
	    }
	  }, {
	    key: "handleParentStateUpdate",
	    value: function handleParentStateUpdate() {
	      var parentState = {};
	      if (this.state.selectedBucket) {
	        parentState.selectedBuckets = [this.state.selectedBucket.value];
	      }
	      if (this.state.selectedFilm) {
	        parentState.selectedFilm = this.state.selectedFilm;
	      }
	      var isComplete = this.state.selectedBucket !== null && this.state.selectedFilm.length !== 0;
	      this.props.update(parentState, isComplete);
	    }
	  }, {
	    key: "getStyles",
	    value: function getStyles() {
	      return {
	        widgetWrapper: {
	          backgroundColor: "#eee",
	          boxSizing: "border-box",
	          padding: "30px",
	          width: "100%",
	          borderRadius: "1em"
	        },
	        widgetTitle: {
	          float: "left",
	          overflow: "visible",
	          fontWeight: "bold",
	          fontSize: "15px"
	        },
	        reportTypeWrapper: {
	          clear: "both",
	          float: "left",
	          marginTop: "-5px"
	        },
	        emailInput: {
	          backgroundColor: "#fff",
	          border: "1px solid #ccc",
	          borderRadius: "3px",
	          height: "20px",
	          width: "60%",
	          minWidth: "400px",
	          fontSize: "13px",
	          padding: "8px"
	        },
	        fieldLabel: {
	          color: "#737373",
	          fontWeight: "bold",
	          marginBottom: 2
	        }
	      };
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var styles = this.getStyles();
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          "div",
	          {
	            style: {
	              clear: "both",
	              float: "left",
	              paddingTop: "10px",
	              marginRight: "25px"
	            }
	          },
	          _react2.default.createElement(
	            "div",
	            { style: styles.fieldLabel },
	            "Event Bucket"
	          ),
	          _react2.default.createElement(_reactSelect2.default, {
	            style: { width: "400px" },
	            clearable: false,
	            autosize: false,
	            multi: false,
	            placeholder: "No event bucket selected",
	            value: this.state.selectedBucket ? this.state.selectedBucket.value : null,
	            options: this.props.eventBuckets,
	            onChange: function onChange(value) {
	              _this2.setState({ selectedBucket: value, selectedFilm: [] }, _this2.handleParentStateUpdate);
	            }
	          })
	        ),
	        _react2.default.createElement(
	          "div",
	          { style: { float: "left", paddingTop: "10px" } },
	          _react2.default.createElement(
	            "div",
	            { style: styles.fieldLabel },
	            "Film"
	          ),
	          _react2.default.createElement(_reactSelect2.default, {
	            style: { width: "400px" },
	            clearable: false,
	            autosize: false,
	            multi: true,
	            placeholder: "No film selected",
	            value: this.state.selectedFilm,
	            options: this.props.films,
	            onChange: function onChange(value) {
	              _this2.setState({ selectedFilm: value }, _this2.handleParentStateUpdate);
	            }
	          })
	        )
	      );
	    }
	  }]);
	
	  return BoxOfficeScheduleView;
	}(_react2.default.Component);
	
	exports.default = BoxOfficeScheduleView;
	module.exports = exports["default"];

/***/ }),
/* 2909 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactSelect = __webpack_require__(953);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	var _cloneDeep = __webpack_require__(1189);
	
	var _cloneDeep2 = _interopRequireDefault(_cloneDeep);
	
	var _moment = __webpack_require__(1021);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _DateTimeUtil = __webpack_require__(2907);
	
	var _DateTimeUtil2 = _interopRequireDefault(_DateTimeUtil);
	
	var _injectedSelect = __webpack_require__(1874);
	
	var _injectedSelect2 = _interopRequireDefault(_injectedSelect);
	
	var _materialUi = __webpack_require__(576);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var transactionLogGroups = [{ value: "WEEKLY", label: "Weekly > Category" }, { value: "MONTHLY", label: "Monthly > Category" }, { value: "STANDARD WEEKLY", label: "Category > Weekly" }, { value: "STANDARD MONTHLY", label: "Category > Monthly" }, { value: "NO GROUPING", label: "No Grouping" }];
	
	var CustomLedgerScheduleView = function (_React$Component) {
	  _inherits(CustomLedgerScheduleView, _React$Component);
	
	  function CustomLedgerScheduleView(props) {
	    _classCallCheck(this, CustomLedgerScheduleView);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(CustomLedgerScheduleView).call(this, props));
	
	    _this.state = {
	      selectedBuckets: null,
	      nickname: "",
	      grouping: "NO GROUPING",
	      tClass: null,
	      tType: null,
	      includeNameAndEmail: false,
	      showEventFilter: false
	    };
	
	    _this.handleParentStateUpdate = _this.handleParentStateUpdate.bind(_this);
	    _this.handleCloseClick = _this.handleCloseClick.bind(_this);
	    return _this;
	  }
	
	  _createClass(CustomLedgerScheduleView, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var item = this.props.item;
	      var eventBuckets = [];
	      if (item.event_bucket && item.event_bucket.length > 0) {
	        eventBuckets = item.event_bucket.map(function (e) {
	          if (e._id) {
	            return e._id;
	          } else {
	            return e;
	          }
	        });
	      }
	      this.setState({
	        selectedBuckets: item.conditions && item.conditions.selectedEvent ? eventBuckets[0] : eventBuckets,
	        nickname: item.nickname,
	        grouping: item.conditions ? item.conditions.timePeriod : null,
	        tClass: item.conditions ? item.conditions.tClass : null,
	        tType: item.conditions ? item.conditions.tType : null,
	        includeNameAndEmail: item.conditions ? item.conditions.includeNameAndEmail : null,
	        selectedEvent: item.conditions ? { id: item.conditions.selectedEvent } : null,
	        showEventFilter: item.conditions && item.conditions.selectedEvent ? true : false
	      });
	      if (item.conditions && item.conditions.selectedEvent) {
	        this.props.updateEvents(eventBuckets[0]);
	      }
	    }
	  }, {
	    key: "handleCloseClick",
	    value: function handleCloseClick() {
	      this.props.close();
	    }
	  }, {
	    key: "handleParentStateUpdate",
	    value: function handleParentStateUpdate() {
	      var parentState = {};
	      if (this.state.selectedBuckets) {
	        parentState.selectedBuckets = this.state.selectedBuckets;
	      }
	      var conditions = {};
	      conditions.timePeriod = this.state.grouping;
	      if (this.state.tType) {
	        conditions.tType = this.state.tType;
	      }
	      if (this.state.tClass) {
	        conditions.tClass = this.state.tClass;
	      }
	      if (this.state.showEventFilter) {
	        conditions.selectedEvent = this.state.selectedEvent.id;
	      }
	      conditions.includeNameAndEmail = this.state.includeNameAndEmail;
	      parentState.conditions = conditions;
	      parentState.nickname = this.state.nickname;
	      var isComplete = this.state.selectedBuckets && this.state.selectedBuckets.length > 0;
	      this.props.update(parentState, isComplete);
	    }
	  }, {
	    key: "getStyles",
	    value: function getStyles() {
	      return {
	        widgetWrapper: {
	          backgroundColor: "#eee",
	          boxSizing: "border-box",
	          padding: "30px",
	          width: "100%",
	          borderRadius: "1em"
	        },
	        widgetTitle: {
	          float: "left",
	          overflow: "visible",
	          fontWeight: "bold",
	          fontSize: "15px"
	        },
	        reportTypeWrapper: {
	          clear: "both",
	          float: "left",
	          marginTop: "-5px"
	        },
	        textInput: {
	          backgroundColor: "#fff",
	          border: "1px solid #ccc",
	          borderRadius: "3px",
	          height: "20px",
	          width: "60%",
	          minWidth: "400px",
	          fontSize: "13px",
	          padding: "8px"
	        },
	        fieldLabel: {
	          color: "#737373",
	          fontWeight: "bold",
	          marginBottom: 2
	        }
	      };
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var styles = this.getStyles();
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          "div",
	          { style: { width: "100%", paddingTop: "10px" } },
	          _react2.default.createElement(
	            "div",
	            { style: styles.fieldLabel },
	            "Report Name"
	          ),
	          _react2.default.createElement(
	            "div",
	            {
	              style: {
	                width: "100%",
	                display: "flex",
	                flexDirection: "row",
	                justifyContent: "start"
	              }
	            },
	            _react2.default.createElement("input", {
	              value: this.state.nickname,
	              style: styles.textInput,
	              onChange: function onChange(e) {
	                _this2.setState({ nickname: e.target.value }, _this2.handleParentStateUpdate);
	              }
	            })
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { style: { width: "100%", paddingTop: "10px" } },
	          _react2.default.createElement(
	            "div",
	            { style: styles.fieldLabel },
	            "Event Bucket"
	          ),
	          _react2.default.createElement(
	            "div",
	            {
	              style: {
	                width: "100%",
	                display: "flex",
	                flexDirection: "row",
	                justifyContent: "start"
	              }
	            },
	            _react2.default.createElement(_injectedSelect2.default, {
	              style: { minWidth: "400px" },
	              placeholder: this.state.showEventFilter === true ? "Select event bucket..." : "Select event bucket(s)...",
	              clearable: false,
	              value: this.state.showEventFilter === true && this.state.selectedBuckets.length === 0 ? null : this.state.selectedBuckets,
	              types: ["event_buckets"],
	              multi: this.state.showEventFilter === true ? false : true,
	              labelFormatter: function labelFormatter(b) {
	                return b.name;
	              },
	              onChange: function onChange(e) {
	                _this2.setState({
	                  selectedBuckets: e,
	                  selectedEvent: null
	                }, function () {
	                  if (_this2.state.showEventFilter === true) {
	                    _this2.props.updateEvents(e);
	                  }
	                  _this2.handleParentStateUpdate();
	                });
	              }
	            })
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { style: { width: "100%", paddingTop: "10px" } },
	          _react2.default.createElement(
	            "div",
	            { style: styles.fieldLabel },
	            "Grouping"
	          ),
	          _react2.default.createElement(
	            "div",
	            {
	              style: {
	                width: "100%",
	                display: "flex",
	                flexDirection: "row",
	                justifyContent: "start"
	              }
	            },
	            _react2.default.createElement(
	              _materialUi.RadioButtonGroup,
	              {
	                name: "groupingRadioGroup",
	                valueSelected: this.state.grouping,
	                onChange: function onChange(e, v) {
	                  _this2.setState({ grouping: v, showEventFilter: false, selectedEvent: null }, _this2.handleParentStateUpdate);
	                }
	              },
	              transactionLogGroups.map(function (item) {
	                return _react2.default.createElement(_materialUi.RadioButton, {
	                  style: { display: "inline-block", width: 200 },
	                  value: item.value,
	                  label: item.label
	                });
	              })
	            )
	          )
	        ),
	        this.state.grouping === "NO GROUPING" ? _react2.default.createElement(
	          "div",
	          {
	            style: {
	              width: "100%",
	              display: "flex",
	              flexDirection: "row",
	              justifyContent: "start",
	              paddingTop: "10px",
	              paddingBottom: "5px"
	            }
	          },
	          _react2.default.createElement(_materialUi.Checkbox, {
	            label: "Filter by a single event",
	            checked: this.state.showEventFilter,
	            onClick: function onClick(e) {
	              //adjust existing event bucket selection values
	              var selectedBuckets = [];
	              if (e.target.checked) {
	                if (_this2.state.selectedBuckets.length > 0) {
	                  selectedBuckets = _this2.state.selectedBuckets[0];
	                } else {
	                  selectedBuckets = null;
	                }
	              } else {
	                selectedBuckets = [_this2.state.selectedBuckets];
	                _this2.setState({
	                  selectedEvent: null
	                });
	              }
	              _this2.setState({
	                showEventFilter: e.target.checked,
	                selectedBuckets: selectedBuckets
	              }, function () {
	                _this2.props.updateEvents(selectedBuckets);
	                _this2.handleParentStateUpdate();
	              });
	            }
	          })
	        ) : null,
	        this.state.grouping === "NO GROUPING" && this.state.showEventFilter ? _react2.default.createElement(
	          "div",
	          { style: { paddingTop: 10 } },
	          _react2.default.createElement(
	            "div",
	            { style: styles.fieldLabel },
	            "Filter by Event"
	          ),
	          _react2.default.createElement(
	            "div",
	            {
	              style: {
	                width: "100%",
	                display: "flex",
	                flexDirection: "row",
	                justifyContent: "start"
	              }
	            },
	            _react2.default.createElement(_reactSelect2.default, {
	              multi: false,
	              clearable: false,
	              value: this.state.selectedEvent ? this.state.selectedEvent.id : null,
	              style: { width: 450 },
	              delimeter: ",",
	              onChange: function onChange(item) {
	                _this2.setState({ selectedEvent: item }, _this2.handleParentStateUpdate);
	              },
	              options: this.props.events
	            })
	          )
	        ) : null,
	        _react2.default.createElement(
	          "div",
	          { style: { width: "100%", paddingTop: "10px" } },
	          _react2.default.createElement(
	            "div",
	            { className: "pull-left" },
	            _react2.default.createElement(
	              "div",
	              { style: styles.fieldLabel },
	              "Filter by Transaction Type"
	            ),
	            _react2.default.createElement(
	              "div",
	              {
	                style: {
	                  width: "100%",
	                  display: "flex",
	                  flexDirection: "row",
	                  justifyContent: "start",
	                  paddingBottom: "10px"
	                }
	              },
	              _react2.default.createElement(_reactSelect2.default, {
	                multi: true,
	                clearable: false,
	                value: this.state.tType,
	                style: { width: 280 },
	                delimeter: ",",
	                onChange: function onChange(item) {
	                  _this2.setState({ tType: item }, _this2.handleParentStateUpdate);
	                },
	                options: [{ value: "PAYMENT", label: "Payment" }, { value: "ADJUSTMENT", label: "Adjustment" }, { value: "REFUND", label: "Refund" }]
	              })
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "pull-left", style: { paddingLeft: 25 } },
	            _react2.default.createElement(
	              "div",
	              { style: styles.fieldLabel },
	              "Filter by Transaction Class"
	            ),
	            _react2.default.createElement(
	              "div",
	              {
	                style: {
	                  width: "100%",
	                  display: "flex",
	                  flexDirection: "row",
	                  justifyContent: "start"
	                }
	              },
	              _react2.default.createElement(_reactSelect2.default, {
	                multi: true,
	                clearable: false,
	                value: this.state.tClass,
	                style: { width: 280 },
	                delimeter: ",",
	                onChange: function onChange(item) {
	                  _this2.setState({ tClass: item }, _this2.handleParentStateUpdate);
	                },
	                options: [{ value: "TICKET", label: "Ticket" }, { value: "INGEST", label: "Ingest" }, { value: "PASS", label: "Pass" }, { value: "ITEM", label: "Item" }, { value: "TAX", label: "Tax" }]
	              })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          {
	            style: {
	              width: "100%",
	              display: "flex",
	              flexDirection: "row",
	              justifyContent: "start",
	              paddingTop: "10px",
	              paddingBottom: "10px"
	            }
	          },
	          _react2.default.createElement(_materialUi.Checkbox, {
	            label: "Include purchaser name and email columns",
	            checked: this.state.includeNameAndEmail,
	            onClick: function onClick(e) {
	              _this2.setState({
	                includeNameAndEmail: e.target.checked
	              }, _this2.handleParentStateUpdate);
	            }
	          })
	        )
	      );
	    }
	  }]);
	
	  return CustomLedgerScheduleView;
	}(_react2.default.Component);
	
	exports.default = CustomLedgerScheduleView;
	module.exports = exports["default"];

/***/ }),
/* 2910 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactSelect = __webpack_require__(953);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	var _materialUi = __webpack_require__(576);
	
	var _cloneDeep = __webpack_require__(1189);
	
	var _cloneDeep2 = _interopRequireDefault(_cloneDeep);
	
	var _moment = __webpack_require__(1021);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _DateTimeUtil = __webpack_require__(2907);
	
	var _DateTimeUtil2 = _interopRequireDefault(_DateTimeUtil);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RecurringPassRenewalScheduleView = function (_React$Component) {
	  _inherits(RecurringPassRenewalScheduleView, _React$Component);
	
	  function RecurringPassRenewalScheduleView(props) {
	    _classCallCheck(this, RecurringPassRenewalScheduleView);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(RecurringPassRenewalScheduleView).call(this, props));
	
	    _this.state = {
	      selectedBucket: null,
	      renewalWarningPeriod: 14
	    };
	
	    _this.handleParentStateUpdate = _this.handleParentStateUpdate.bind(_this);
	    return _this;
	  }
	
	  _createClass(RecurringPassRenewalScheduleView, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var item = this.props.item;
	      this.setState({
	        selectedBucket: {
	          value: item.event_bucket && item.event_bucket.length > 0 ? item.event_bucket[0]._id : null
	        },
	        renewalWarningPeriod: item.conditions && item.conditions.renewalWarningPeriod ? item.conditions.renewalWarningPeriod : null
	      });
	    }
	  }, {
	    key: "handleParentStateUpdate",
	    value: function handleParentStateUpdate() {
	      var parentState = {
	        conditions: {}
	      };
	      if (this.state.selectedBucket) {
	        parentState.selectedBuckets = [this.state.selectedBucket.value];
	      }
	      if (this.state.renewalWarningPeriod) {
	        parentState.conditions.renewalWarningPeriod = this.state.renewalWarningPeriod;
	      }
	      var isComplete = this.state.selectedBucket !== null && this.state.renewalWarningPeriod !== null;
	
	      this.props.update(parentState, isComplete);
	    }
	  }, {
	    key: "getStyles",
	    value: function getStyles() {
	      return {
	        fieldLabel: {
	          color: "#737373",
	          fontWeight: "bold",
	          marginBottom: 2
	        }
	      };
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var styles = this.getStyles();
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          "div",
	          {
	            style: {
	              clear: "both",
	              float: "left",
	              paddingTop: "10px",
	              marginRight: "25px"
	            }
	          },
	          _react2.default.createElement(
	            "div",
	            { style: styles.fieldLabel },
	            "Event Bucket"
	          ),
	          _react2.default.createElement(_reactSelect2.default, {
	            style: { width: "400px" },
	            clearable: false,
	            autosize: false,
	            multi: false,
	            placeholder: "No event bucket selected",
	            value: this.state.selectedBucket ? this.state.selectedBucket.value : null,
	            options: this.props.eventBuckets,
	            onChange: function onChange(value) {
	              _this2.setState({ selectedBucket: value }, _this2.handleParentStateUpdate);
	            }
	          })
	        ),
	        _react2.default.createElement(
	          "div",
	          { style: { float: "left", paddingTop: "10px" } },
	          _react2.default.createElement(
	            "div",
	            { style: styles.fieldLabel },
	            "Recurring passes renewing or expiring in the next",
	            " "
	          ),
	          _react2.default.createElement(_reactSelect2.default, {
	            style: { width: "300px" },
	            clearable: false,
	            autosize: false,
	            multi: false,
	            value: this.state.renewalWarningPeriod,
	            options: [{ label: "14 days", value: 14 }, { label: "30 days", value: 30 }, { label: "60 days", value: 60 }, { label: "90 days", value: 90 }],
	            onChange: function onChange(e) {
	              _this2.setState({ renewalWarningPeriod: e.value }, function () {
	                _this2.handleParentStateUpdate();
	              });
	            }
	          })
	        )
	      );
	    }
	  }]);
	
	  return RecurringPassRenewalScheduleView;
	}(_react2.default.Component);
	
	exports.default = RecurringPassRenewalScheduleView;
	module.exports = exports["default"];

/***/ }),
/* 2911 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactSelect = __webpack_require__(953);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	var _materialUi = __webpack_require__(576);
	
	var _cloneDeep = __webpack_require__(1189);
	
	var _cloneDeep2 = _interopRequireDefault(_cloneDeep);
	
	var _moment = __webpack_require__(1021);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _DateTimeUtil = __webpack_require__(2907);
	
	var _DateTimeUtil2 = _interopRequireDefault(_DateTimeUtil);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ExpiredPassScheduleView = function (_React$Component) {
	  _inherits(ExpiredPassScheduleView, _React$Component);
	
	  function ExpiredPassScheduleView(props) {
	    _classCallCheck(this, ExpiredPassScheduleView);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(ExpiredPassScheduleView).call(this, props));
	
	    _this.state = {
	      selectedBucket: null,
	      expiredPassTimePeriod: 14
	    };
	
	    _this.handleParentStateUpdate = _this.handleParentStateUpdate.bind(_this);
	    return _this;
	  }
	
	  _createClass(ExpiredPassScheduleView, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var item = this.props.item;
	      this.setState({
	        selectedBucket: {
	          value: item.event_bucket && item.event_bucket.length > 0 ? item.event_bucket[0]._id : null
	        },
	        expiredPassTimePeriod: item.conditions && item.conditions.expiredPassTimePeriod ? item.conditions.expiredPassTimePeriod : null
	      });
	    }
	  }, {
	    key: "handleParentStateUpdate",
	    value: function handleParentStateUpdate() {
	      var parentState = {
	        conditions: {}
	      };
	      if (this.state.selectedBucket) {
	        parentState.selectedBuckets = [this.state.selectedBucket.value];
	      }
	      if (this.state.expiredPassTimePeriod) {
	        parentState.conditions.expiredPassTimePeriod = this.state.expiredPassTimePeriod;
	      }
	      var isComplete = this.state.selectedBucket !== null && this.state.expiredPassTimePeriod !== null;
	
	      this.props.update(parentState, isComplete);
	    }
	  }, {
	    key: "getStyles",
	    value: function getStyles() {
	      return {
	        fieldLabel: {
	          color: "#737373",
	          fontWeight: "bold",
	          marginBottom: 2
	        }
	      };
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var styles = this.getStyles();
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          "div",
	          {
	            style: {
	              clear: "both",
	              float: "left",
	              paddingTop: "10px",
	              marginRight: "25px"
	            }
	          },
	          _react2.default.createElement(
	            "div",
	            { style: styles.fieldLabel },
	            "Event Bucket"
	          ),
	          _react2.default.createElement(_reactSelect2.default, {
	            style: { width: "400px" },
	            clearable: false,
	            autosize: false,
	            multi: false,
	            placeholder: "No event bucket selected",
	            value: this.state.selectedBucket ? this.state.selectedBucket.value : null,
	            options: this.props.eventBuckets,
	            onChange: function onChange(value) {
	              _this2.setState({ selectedBucket: value }, _this2.handleParentStateUpdate);
	            }
	          })
	        ),
	        _react2.default.createElement(
	          "div",
	          { style: { float: "left", paddingTop: "10px" } },
	          _react2.default.createElement(
	            "div",
	            { style: styles.fieldLabel },
	            "Expired passes in the past"
	          ),
	          _react2.default.createElement(_reactSelect2.default, {
	            style: { width: "300px" },
	            clearable: false,
	            autosize: false,
	            multi: false,
	            value: this.state.expiredPassTimePeriod,
	            options: [{ label: "90 days", value: 90 }, { label: "1 year", value: 365 }, { label: "2 years", value: 730 }, { label: "3 years", value: 1095 }],
	            onChange: function onChange(e) {
	              _this2.setState({ expiredPassTimePeriod: e.value }, function () {
	                _this2.handleParentStateUpdate();
	              });
	            }
	          })
	        )
	      );
	    }
	  }]);
	
	  return ExpiredPassScheduleView;
	}(_react2.default.Component);
	
	exports.default = ExpiredPassScheduleView;
	module.exports = exports["default"];

/***/ }),
/* 2912 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactSelect = __webpack_require__(953);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	var _materialUi = __webpack_require__(576);
	
	var _cloneDeep = __webpack_require__(1189);
	
	var _cloneDeep2 = _interopRequireDefault(_cloneDeep);
	
	var _moment = __webpack_require__(1021);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _DateTimeUtil = __webpack_require__(2907);
	
	var _DateTimeUtil2 = _interopRequireDefault(_DateTimeUtil);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var NewSubscriptionScheduleView = function (_React$Component) {
	  _inherits(NewSubscriptionScheduleView, _React$Component);
	
	  function NewSubscriptionScheduleView(props) {
	    _classCallCheck(this, NewSubscriptionScheduleView);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(NewSubscriptionScheduleView).call(this, props));
	
	    _this.state = {
	      selectedBucket: null,
	      newSubscriptionTimePeriod: 14
	    };
	
	    _this.handleParentStateUpdate = _this.handleParentStateUpdate.bind(_this);
	    return _this;
	  }
	
	  _createClass(NewSubscriptionScheduleView, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var item = this.props.item;
	      this.setState({
	        selectedBucket: {
	          value: item.event_bucket && item.event_bucket.length > 0 ? item.event_bucket[0]._id : null
	        },
	        newSubscriptionTimePeriod: item.conditions && item.conditions.newSubscriptionTimePeriod ? item.conditions.newSubscriptionTimePeriod : null
	      });
	    }
	  }, {
	    key: "handleParentStateUpdate",
	    value: function handleParentStateUpdate() {
	      var parentState = {
	        conditions: {}
	      };
	      if (this.state.selectedBucket) {
	        parentState.selectedBuckets = [this.state.selectedBucket.value];
	      }
	      if (this.state.newSubscriptionTimePeriod) {
	        parentState.conditions.newSubscriptionTimePeriod = this.state.newSubscriptionTimePeriod;
	      }
	      var isComplete = this.state.selectedBucket !== null && this.state.newSubscriptionTimePeriod !== null;
	
	      this.props.update(parentState, isComplete);
	    }
	  }, {
	    key: "getStyles",
	    value: function getStyles() {
	      return {
	        fieldLabel: {
	          color: "#737373",
	          fontWeight: "bold",
	          marginBottom: 2
	        }
	      };
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var styles = this.getStyles();
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          "div",
	          {
	            style: {
	              clear: "both",
	              float: "left",
	              paddingTop: "10px",
	              marginRight: "25px"
	            }
	          },
	          _react2.default.createElement(
	            "div",
	            { style: styles.fieldLabel },
	            "Event Bucket"
	          ),
	          _react2.default.createElement(_reactSelect2.default, {
	            style: { width: "400px" },
	            clearable: false,
	            autosize: false,
	            multi: false,
	            placeholder: "No event bucket selected",
	            value: this.state.selectedBucket ? this.state.selectedBucket.value : null,
	            options: this.props.eventBuckets,
	            onChange: function onChange(value) {
	              _this2.setState({ selectedBucket: value }, _this2.handleParentStateUpdate);
	            }
	          })
	        ),
	        _react2.default.createElement(
	          "div",
	          { style: { float: "left", paddingTop: "10px" } },
	          _react2.default.createElement(
	            "div",
	            { style: styles.fieldLabel },
	            "New subscriptions in the past "
	          ),
	          _react2.default.createElement(_reactSelect2.default, {
	            style: { width: "300px" },
	            clearable: false,
	            autosize: false,
	            multi: false,
	            value: this.state.newSubscriptionTimePeriod,
	            options: [{ label: "90 days", value: 90 }, { label: "1 year", value: 365 }, { label: "2 years", value: 730 }, { label: "3 years", value: 1095 }],
	            onChange: function onChange(e) {
	              _this2.setState({ newSubscriptionTimePeriod: e.value }, function () {
	                _this2.handleParentStateUpdate();
	              });
	            }
	          })
	        )
	      );
	    }
	  }]);
	
	  return NewSubscriptionScheduleView;
	}(_react2.default.Component);
	
	exports.default = NewSubscriptionScheduleView;
	module.exports = exports["default"];

/***/ }),
/* 2913 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _alt = __webpack_require__(975);
	
	var _alt2 = _interopRequireDefault(_alt);
	
	var _keyBy = __webpack_require__(990);
	
	var _keyBy2 = _interopRequireDefault(_keyBy);
	
	var _values = __webpack_require__(1214);
	
	var _values2 = _interopRequireDefault(_values);
	
	var _ReportScheduleUtil = __webpack_require__(2914);
	
	var _ReportScheduleUtil2 = _interopRequireDefault(_ReportScheduleUtil);
	
	var _ReportScheduleActions = __webpack_require__(2915);
	
	var _ReportScheduleActions2 = _interopRequireDefault(_ReportScheduleActions);
	
	var _UserStore = __webpack_require__(974);
	
	var _UserStore2 = _interopRequireDefault(_UserStore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ReportScheduleStore = function () {
	  function ReportScheduleStore() {
	    _classCallCheck(this, ReportScheduleStore);
	
	    this.bindActions(_ReportScheduleActions2.default);
	
	    this.state = {
	      isFetching: false,
	      reportSchedules: {}
	    };
	
	    this.exportPublicMethods({
	      getReportScheduleById: this.getReportScheduleById.bind(this),
	      getAllUserReportSchedules: this.getAllUserReportSchedules.bind(this)
	    });
	  }
	
	  _createClass(ReportScheduleStore, [{
	    key: "getReportScheduleById",
	    value: function getReportScheduleById(id) {
	      return this.state.reportSchedules[id];
	    }
	  }, {
	    key: "getAllUserReportSchedules",
	    value: function getAllUserReportSchedules() {
	      var reportSchedulesArray = [];
	      var reportSchedulesList = Object.keys(this.state.reportSchedules);
	      for (var rs = 0; rs < reportSchedulesList.length; rs++) {
	        reportSchedulesArray = reportSchedulesArray.concat([this.state.reportSchedules[reportSchedulesList[rs]]]);
	      }
	      return reportSchedulesArray;
	    }
	  }, {
	    key: "onFetchAllForUser",
	    value: function onFetchAllForUser() {
	      var _this = this;
	
	      this.setState({ isFetching: true });
	      _ReportScheduleUtil2.default.fetchAllForUser(_UserStore2.default.getState().apiKey).then(function (data) {
	        var reportSchedules = data.reduce(function (result, item) {
	          result[item.id] = item;
	          return result;
	        }, {});
	        _this.setState({ isFetching: false, reportSchedules: reportSchedules });
	      }).catch(_ReportScheduleActions2.default.fetchFailed);
	    }
	  }, {
	    key: "onFetchOne",
	    value: function onFetchOne(id) {
	      var _this2 = this;
	
	      this.setState({ isFetching: true });
	      _ReportScheduleUtil2.default.fetchOne(_UserStore2.default.getState().apiKey, id).then(function (data) {
	        var reportSchedules = _this2.state.reportSchedules;
	        reportSchedules[data.id] = data;
	        _this2.setState({ isFetching: false, reportSchdules: reportSchedules });
	      }).catch(_ReportScheduleActions2.default.fetchFailed);
	    }
	  }, {
	    key: "onDelete",
	    value: function onDelete(id) {
	      this.setState({ isDeleting: true });
	      _ReportScheduleUtil2.default.delete(_UserStore2.default.getState().apiKey, id).then(function (data) {
	        _ReportScheduleActions2.default.fetchAllForUser();
	      }).catch(_ReportScheduleActions2.default.editFailed);
	    }
	  }, {
	    key: "onCreate",
	    value: function onCreate(newData) {
	      var _this3 = this;
	
	      this.setState({ isCreating: true, newScheduleId: null });
	
	      _ReportScheduleUtil2.default.create(_UserStore2.default.getState().apiKey, newData).then(function (data) {
	        var reportSchedules = _this3.state.reportSchedules;
	        reportSchedules[data.id] = data;
	        _this3.setState({
	          isCreating: false,
	          reportSchedules: reportSchedules,
	          newScheduleId: data.id
	        });
	      }).catch(_ReportScheduleActions2.default.editFailed);
	    }
	  }, {
	    key: "onUpdate",
	    value: function onUpdate(newData) {
	      var _this4 = this;
	
	      this.setState({ isUpdating: true });
	      _ReportScheduleUtil2.default.edit(_UserStore2.default.getState().apiKey, newData.id, newData).then(function (data) {
	        var reportSchedules = _this4.state.reportSchedules;
	        reportSchedules[data.id] = data;
	        _this4.setState({ isUpdating: false, reportSchedules: reportSchedules });
	      }).catch(_ReportScheduleActions2.default.editFailed);
	    }
	  }, {
	    key: "onFetchFailed",
	    value: function onFetchFailed(e) {
	      alert("Fetching report schedules failed: " + e.message);
	      throw e;
	    }
	  }, {
	    key: "onEditFailed",
	    value: function onEditFailed(e) {
	      alert("Edit failed: " + e.message);
	      this.setState({ isCreating: false, isEditing: false });
	    }
	  }]);
	
	  return ReportScheduleStore;
	}();
	
	exports.default = _alt2.default.createStore(ReportScheduleStore, "ReportScheduleStore");
	module.exports = exports["default"];

/***/ }),
/* 2914 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _api = __webpack_require__(1160);
	
	var _api2 = _interopRequireDefault(_api);
	
	var _config = __webpack_require__(1173);
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  fetchAllForUser: function fetchAllForUser(apiKey) {
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "GET",
	        endpoint: "report-schedule",
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response.reportSchedules);
	      });
	    });
	  },
	  fetchOne: function fetchOne(apiKey, schedule_id) {
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "GET",
	        endpoint: "report-schedule/" + schedule_id,
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response);
	      });
	    });
	  },
	  edit: function edit(apiKey, schedule_id, values) {
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "POST",
	        endpoint: "report-schedule/" + schedule_id,
	        json: values,
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response);
	      });
	    });
	  },
	  delete: function _delete(apiKey, schedule_id) {
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "DELETE",
	        endpoint: "report-schedule/" + schedule_id,
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response);
	      });
	    });
	  },
	  create: function create(apiKey, values) {
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "POST",
	        endpoint: "report-schedule",
	        json: values,
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response);
	      });
	    });
	  }
	};
	module.exports = exports["default"];

/***/ }),
/* 2915 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _alt = __webpack_require__(975);
	
	var _alt2 = _interopRequireDefault(_alt);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ReportScheduleActions = function ReportScheduleActions() {
	  _classCallCheck(this, ReportScheduleActions);
	
	  this.generateActions("create", "delete", "update", "fetchAllForUser", "fetchOne", "fetchFailed", "editFailed");
	};
	
	exports.default = _alt2.default.createActions(ReportScheduleActions);
	module.exports = exports["default"];

/***/ }),
/* 2916 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _moment = __webpack_require__(1021);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _materialUi = __webpack_require__(576);
	
	var _util = __webpack_require__(1183);
	
	var _workingIndicator = __webpack_require__(1664);
	
	var _workingIndicator2 = _interopRequireDefault(_workingIndicator);
	
	var _chart = __webpack_require__(1785);
	
	var _chart2 = _interopRequireDefault(_chart);
	
	var _injectedSelect = __webpack_require__(1874);
	
	var _injectedSelect2 = _interopRequireDefault(_injectedSelect);
	
	var _datepicker = __webpack_require__(2272);
	
	var _datepicker2 = _interopRequireDefault(_datepicker);
	
	var _quantityEditor = __webpack_require__(2191);
	
	var _quantityEditor2 = _interopRequireDefault(_quantityEditor);
	
	var _label = __webpack_require__(1682);
	
	var _label2 = _interopRequireDefault(_label);
	
	var _connectToStores = __webpack_require__(1226);
	
	var _connectToStores2 = _interopRequireDefault(_connectToStores);
	
	var _EventBucketActions = __webpack_require__(1218);
	
	var _EventBucketActions2 = _interopRequireDefault(_EventBucketActions);
	
	var _EventBucketStore = __webpack_require__(1593);
	
	var _EventBucketStore2 = _interopRequireDefault(_EventBucketStore);
	
	var _AnalyticsStore = __webpack_require__(1861);
	
	var _AnalyticsStore2 = _interopRequireDefault(_AnalyticsStore);
	
	var _AnalyticsActions = __webpack_require__(1863);
	
	var _AnalyticsActions2 = _interopRequireDefault(_AnalyticsActions);
	
	var _UserStore = __webpack_require__(974);
	
	var _UserStore2 = _interopRequireDefault(_UserStore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LOCALSTORAGE_KEY = "eventive-CrossEventBucketReports";
	var MS_IN_DAY = 1000 * 60 * 60 * 24;
	
	var CrossEventBucketReports = function (_React$Component) {
	  _inherits(CrossEventBucketReports, _React$Component);
	
	  function CrossEventBucketReports(props) {
	    _classCallCheck(this, CrossEventBucketReports);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(CrossEventBucketReports).call(this, props));
	
	    _this.state = {
	      startDates: {},
	      selectedBuckets: [],
	      endAfter: 10
	    };
	
	    _this.setBuckets = _this.setBuckets.bind(_this);
	    return _this;
	  }
	
	  _createClass(CrossEventBucketReports, [{
	    key: "getStyles",
	    value: function getStyles() {
	      return {};
	    }
	  }, {
	    key: "setBuckets",
	    value: function setBuckets(buckets) {
	      var _this2 = this;
	
	      var startDates = this.state.startDates;
	
	
	      buckets.filter(function (b) {
	        return _this2.state.selectedBuckets.indexOf(b) === -1;
	      }).map(function (id) {
	        var bucket = _EventBucketStore2.default.getEventBucketById(id),
	            oldStart = bucket && bucket.start_date;
	        startDates[id] = startDates[id] || oldStart && oldStart.slice(0, "YYYY-MM-DD".length);
	        _AnalyticsActions2.default.fetchEventBucketSales.defer(id);
	      });
	
	      this.setState({
	        selectedBuckets: buckets,
	        startDates: startDates
	      });
	
	      try {
	        if (window.localStorage) {
	          window.localStorage[LOCALSTORAGE_KEY + _UserStore2.default.getUserId()] = JSON.stringify(buckets);
	        }
	      } catch (e) {}
	    }
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.componentWillReceiveProps(this.props);
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(newProps) {
	      if (this.state.selectedBuckets.length === 0 && newProps.getEventBuckets().length) {
	        try {
	          if (window.localStorage && window.localStorage[LOCALSTORAGE_KEY + _UserStore2.default.getUserId()]) {
	            this.setBuckets(JSON.parse(window.localStorage[LOCALSTORAGE_KEY + _UserStore2.default.getUserId()]));
	          }
	        } catch (e) {}
	      }
	    }
	  }, {
	    key: "setStartDate",
	    value: function setStartDate(id, d) {
	      var startDates = this.state.startDates;
	
	
	      if (d) {
	        _EventBucketActions2.default.edit(id, {
	          start_date: d
	        });
	      }
	
	      startDates[id] = d;
	      this.setState({ startDates: startDates });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this3 = this;
	
	      var styles = this.getStyles();
	      var _props = this.props;
	      var getEventBucketById = _props.getEventBucketById;
	      var getEventBucketSalesById = _props.getEventBucketSalesById;
	
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          "h1",
	          null,
	          "Cross-event-bucket comparison"
	        ),
	        _react2.default.createElement(_injectedSelect2.default, {
	          value: this.state.selectedBuckets,
	          types: ["event_buckets"],
	          multi: true,
	          label: "Event buckets to compare",
	          labelFormatter: function labelFormatter(b) {
	            return b.name;
	          },
	          onChange: this.setBuckets
	        }),
	        _react2.default.createElement(
	          "div",
	          null,
	          this.state.selectedBuckets.map(function (id) {
	            var b = getEventBucketById(id);
	            return _react2.default.createElement(_datepicker2.default, {
	              style: {
	                width: 256,
	                display: "inline-block",
	                marginRight: "1em"
	              },
	              value: _this3.state.startDates[id],
	              label: b.name + " start date",
	              onChange: function onChange(v) {
	                return _this3.setStartDate(b.id, v);
	              }
	            });
	          }),
	          this.state.selectedBuckets.length ? _react2.default.createElement(
	            "div",
	            { style: { display: "inline-block" } },
	            _react2.default.createElement(
	              _label2.default,
	              null,
	              "Days after start date to end graph"
	            ),
	            _react2.default.createElement(_quantityEditor2.default, {
	              style: { marginTop: -14, marginLeft: -17 },
	              quantity: this.state.endAfter,
	              updateQuantity: function updateQuantity(q) {
	                return _this3.setState({ endAfter: q });
	              }
	            })
	          ) : null
	        ),
	        _react2.default.createElement(
	          "div",
	          null,
	          this.state.selectedBuckets.length > 1 && this.state.selectedBuckets.every(function (id) {
	            return !!_this3.state.startDates[id];
	          }) ? function () {
	            var sales = _this3.state.selectedBuckets.map(function (id) {
	              return getEventBucketSalesById(id);
	            });
	            if (!sales.every(function (b) {
	              return !!b;
	            })) {
	              return _react2.default.createElement(_workingIndicator2.default, null);
	            }
	
	            var data = {};
	
	            sales.forEach(function (s, i) {
	              var id = _this3.state.selectedBuckets[i],
	                  startDate = (0, _moment2.default)(_this3.state.startDates[id], "YYYY-MM-DD");
	
	              s.forEach(function (next) {
	                var diff = -startDate.diff(new Date(next.date.year, next.date.month - 1, next.date.day), "days");
	                if (diff > _this3.state.endAfter) {
	                  return;
	                }
	                if (!data[diff]) {
	                  data[diff] = {};
	                }
	                data[diff][id] = next.running_net / 100;
	              });
	            });
	
	            var offsets = Object.keys(data).sort(function (a, b) {
	              return a - b;
	            }),
	                firstDate = new Date(offsets[0] * -1 * MS_IN_DAY);
	
	            var names = _this3.state.selectedBuckets.map(function (id) {
	              return getEventBucketById(id).name;
	            });
	            var rows = [];
	            offsets.forEach(function (k, i) {
	              // if (i === 53) { debugger; }
	              var value = _this3.state.selectedBuckets.map(function (id, bucketIndex) {
	                return {
	                  type: names[bucketIndex],
	                  result: data[k][id] || i > 1 && rows[i - 1].value[bucketIndex].result || 0
	                };
	              });
	              rows.push({
	                timeframe: { end: new Date((k - offsets[0]) * MS_IN_DAY) }, // start at date 0
	                value: value
	              });
	            });
	
	            var filledRows = (0, _util.fillMissingDaysNew)(rows, "timeframe.end", {}, { cloneAll: true });
	            filledRows = filledRows.map(function (r) {
	              r.timeframe.end = r.timeframe.end.toISOString();
	              return r;
	            });
	
	            var chartOptions = {
	              axis: {
	                y: {
	                  tick: {
	                    format: function format(p) {
	                      return (0, _util.formatPrice)(p * 100, /* short */true);
	                    }
	                  }
	                },
	                x: {
	                  tick: {
	                    format: function format(d) {
	                      var o = (d - firstDate) / MS_IN_DAY;
	                      return (o > 0 ? "+" : "") + o.toFixed(0);
	                    }
	                  }
	                }
	              },
	              point: { show: false },
	              tooltip: {
	                format: {
	                  value: function value(_value, ratio, id, index) {
	                    var bucketIndex = filledRows[index].value.findIndex(function (v) {
	                      return v.type === id;
	                    }),
	                        bucketId = _this3.state.selectedBuckets[bucketIndex],
	                        date = (0, _moment2.default)(_this3.state.startDates[bucketId], "YYYY-MM-DD").add((new Date(filledRows[index].timeframe.end) - firstDate) / MS_IN_DAY, "days");
	                    return (0, _util.formatPrice)(_value * 100) + " (" + date.format("M/D/YY") + ")";
	                  },
	                  title: function title(d) {
	                    var o = (d - firstDate) / MS_IN_DAY;
	                    return Math.abs(o).toFixed(0) + " day" + (Math.abs(o) === 1 ? "" : "s") + " " + (o > 0 ? "after" : "before") + " the start date";
	                  }
	                }
	              }
	            };
	
	            return _react2.default.createElement(_chart2.default, {
	              title: "Total net sales",
	              type: "area",
	              indexBy: "timeframe.end",
	              dateFormat: "%b %e",
	              chartOptions: chartOptions,
	              data: { result: filledRows },
	              height: 500
	            });
	          }() : _react2.default.createElement(_chart2.default, {
	            title: "",
	            placeholder: "Select two or more event buckets & start dates to begin.",
	            height: 200
	          })
	        )
	      );
	    }
	  }], [{
	    key: "getStores",
	    value: function getStores() {
	      return [_EventBucketStore2.default, _AnalyticsStore2.default];
	    }
	  }, {
	    key: "getPropsFromStores",
	    value: function getPropsFromStores() {
	      return {
	        getEventBuckets: _EventBucketStore2.default.getEventBuckets,
	        getEventBucketById: _EventBucketStore2.default.getEventBucketById,
	        getEventBucketSalesById: _AnalyticsStore2.default.getEventBucketSalesById
	      };
	    }
	  }, {
	    key: "contextTypes",
	    get: function get() {
	      return {
	        router: _react2.default.PropTypes.object
	      };
	    }
	  }]);
	
	  return CrossEventBucketReports;
	}(_react2.default.Component);
	
	exports.default = (0, _connectToStores2.default)(CrossEventBucketReports);
	module.exports = exports["default"];

/***/ }),
/* 2917 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _workingIndicator = __webpack_require__(1664);
	
	var _workingIndicator2 = _interopRequireDefault(_workingIndicator);
	
	var _connectToStores = __webpack_require__(1226);
	
	var _connectToStores2 = _interopRequireDefault(_connectToStores);
	
	var _TicketActions = __webpack_require__(2697);
	
	var _TicketActions2 = _interopRequireDefault(_TicketActions);
	
	var _TicketStore = __webpack_require__(2706);
	
	var _TicketStore2 = _interopRequireDefault(_TicketStore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Ticket = function (_React$Component) {
	  _inherits(Ticket, _React$Component);
	
	  function Ticket(props) {
	    _classCallCheck(this, Ticket);
	
	    return _possibleConstructorReturn(this, Object.getPrototypeOf(Ticket).call(this, props));
	  }
	
	  _createClass(Ticket, [{
	    key: "componentWillMount",
	    value: function componentWillMount() {
	      _TicketActions2.default.fetchOne(this.props.params.ticketId.toLowerCase());
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(props) {
	      var _this2 = this;
	
	      var ticket = _TicketStore2.default.getTicketById(props.params.ticketId.toLowerCase());
	      if (ticket) {
	        (function () {
	          var prefix = props.params.eventBucketId ? "/event_buckets/" + props.params.eventBucketId : "";
	          if (ticket.order) {
	            setTimeout(function () {
	              return _this2.context.router.replace({
	                pathname: prefix + "/orders/" + ticket.order,
	                query: { ticket: ticket.id }
	              });
	            }, 0);
	          } else if (ticket.person && ticket.person.id) {
	            setTimeout(function () {
	              return _this2.context.router.replace({
	                pathname: prefix + "/people/" + ticket.person.id,
	                query: { ticket: ticket.id }
	              });
	            }, 0);
	          } else if (ticket.event && ticket.event.id) {
	            setTimeout(function () {
	              return _this2.context.router.replace({
	                pathname: prefix + "/events/" + ticket.event.id,
	                query: { ticket: ticket.id }
	              });
	            }, 0);
	          } else {
	            setTimeout(function () {
	              return _this2.context.router.replace("/welcome");
	            }, 0);
	          }
	        })();
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement(_workingIndicator2.default, { fullPage: true });
	    }
	  }], [{
	    key: "getStores",
	    value: function getStores() {
	      return [_TicketStore2.default];
	    }
	  }, {
	    key: "getPropsFromStores",
	    value: function getPropsFromStores() {
	      return {
	        tickets: _TicketStore2.default.getState().tickets
	      };
	    }
	  }, {
	    key: "contextTypes",
	    get: function get() {
	      return {
	        router: _react2.default.PropTypes.object
	      };
	    }
	  }]);
	
	  return Ticket;
	}(_react2.default.Component);
	
	exports.default = (0, _connectToStores2.default)(Ticket);
	module.exports = exports["default"];

/***/ }),
/* 2918 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _workingIndicator = __webpack_require__(1664);
	
	var _workingIndicator2 = _interopRequireDefault(_workingIndicator);
	
	var _connectToStores = __webpack_require__(1226);
	
	var _connectToStores2 = _interopRequireDefault(_connectToStores);
	
	var _PassActions = __webpack_require__(2047);
	
	var _PassActions2 = _interopRequireDefault(_PassActions);
	
	var _PassStore = __webpack_require__(2048);
	
	var _PassStore2 = _interopRequireDefault(_PassStore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Pass = function (_React$Component) {
	  _inherits(Pass, _React$Component);
	
	  function Pass(props) {
	    _classCallCheck(this, Pass);
	
	    return _possibleConstructorReturn(this, Object.getPrototypeOf(Pass).call(this, props));
	  }
	
	  _createClass(Pass, [{
	    key: "componentWillMount",
	    value: function componentWillMount() {
	      _PassActions2.default.fetchOne(this.props.params.passId.toLowerCase());
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(props) {
	      var _this2 = this;
	
	      var pass = _PassStore2.default.getPassById(props.params.passId.toLowerCase());
	      if (pass) {
	        (function () {
	          var prefix = props.params.eventBucketId ? "/event_buckets/" + props.params.eventBucketId : "";
	          if (pass.person && pass.person.id) {
	            setTimeout(function () {
	              return _this2.context.router.replace({
	                pathname: prefix + "/people/" + pass.person.id,
	                query: { highlight_pass: pass.id }
	              });
	            }, 0);
	          } else if (pass.pass_bucket && pass.pass_bucket.id) {
	            setTimeout(function () {
	              return _this2.context.router.replace({
	                pathname: prefix + "/pass_buckets/" + pass.pass_bucket.id,
	                query: { highlight_pass: pass.id }
	              });
	            }, 0);
	          } else {
	            setTimeout(function () {
	              return _this2.context.router.replace("/welcome");
	            }, 0);
	          }
	        })();
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement(_workingIndicator2.default, { fullPage: true });
	    }
	  }], [{
	    key: "getStores",
	    value: function getStores() {
	      return [_PassStore2.default];
	    }
	  }, {
	    key: "getPropsFromStores",
	    value: function getPropsFromStores() {
	      return {
	        passes: _PassStore2.default.getState().passes
	      };
	    }
	  }, {
	    key: "contextTypes",
	    get: function get() {
	      return {
	        router: _react2.default.PropTypes.object
	      };
	    }
	  }]);
	
	  return Pass;
	}(_react2.default.Component);
	
	exports.default = (0, _connectToStores2.default)(Pass);
	module.exports = exports["default"];

/***/ }),
/* 2919 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactTableV = __webpack_require__(2920);
	
	var _reactTableV2 = _interopRequireDefault(_reactTableV);
	
	__webpack_require__(2927);
	
	var _moment = __webpack_require__(1021);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _config = __webpack_require__(1173);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _api = __webpack_require__(1160);
	
	var _api2 = _interopRequireDefault(_api);
	
	var _workingIndicator = __webpack_require__(1664);
	
	var _workingIndicator2 = _interopRequireDefault(_workingIndicator);
	
	var _transferHistoryTable = __webpack_require__(2929);
	
	var _transferHistoryTable2 = _interopRequireDefault(_transferHistoryTable);
	
	var _auditLogTable = __webpack_require__(2930);
	
	var _auditLogTable2 = _interopRequireDefault(_auditLogTable);
	
	var _connectToStores = __webpack_require__(1226);
	
	var _connectToStores2 = _interopRequireDefault(_connectToStores);
	
	var _PassActions = __webpack_require__(2047);
	
	var _PassActions2 = _interopRequireDefault(_PassActions);
	
	var _PassStore = __webpack_require__(2048);
	
	var _PassStore2 = _interopRequireDefault(_PassStore);
	
	var _UserStore = __webpack_require__(974);
	
	var _UserStore2 = _interopRequireDefault(_UserStore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PAGESIZE = 10;
	
	var PassHistory = function (_React$Component) {
	  _inherits(PassHistory, _React$Component);
	
	  function PassHistory(props) {
	    _classCallCheck(this, PassHistory);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(PassHistory).call(this, props));
	
	    _this.state = {
	      pass: null,
	      passTransferHistory: null,
	      pageData: [],
	      pageNum: 0,
	      isLoading: false
	    };
	
	    _this.cleanSundanceEmail = _this.cleanSundanceEmail.bind(_this);
	    return _this;
	  }
	
	  _createClass(PassHistory, [{
	    key: "componentWillMount",
	    value: function componentWillMount() {
	      _PassActions2.default.fetchPassTransferHistory.defer(this.props.params.passId, this.props.params.eventBucketId);
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(newProps) {
	      var passTransferHistory = _PassStore2.default.getPassTransferHistory();
	      var passTransferHistorySinglePass = _PassStore2.default.getPassTransferHistorySinglePass();
	
	      if (passTransferHistory && passTransferHistory.length >= 0) {
	        this.setState({ passTransferHistory: passTransferHistory, pass: passTransferHistorySinglePass });
	      }
	
	      if (passTransferHistorySinglePass) {
	        this.fetchPage();
	      }
	    }
	  }, {
	    key: "cleanSundanceEmail",
	    value: function cleanSundanceEmail(email) {
	      if (typeof email !== "string") {
	        return "";
	      }
	      if (email.indexOf("%%%sundance-") !== -1) {
	        return email.substring(0, email.indexOf("%%%sundance-"));
	      } else {
	        return email;
	      }
	    }
	  }, {
	    key: "fetchPage",
	    value: function fetchPage() {
	      this.setState({ isLoading: true });
	      _api2.default.request({
	        method: "GET",
	        endpoint: "audit_log/page",
	        qs: {
	          //eventBucket: this.props.params.eventBucketId,
	          objectId: this.props.params.passId,
	          pageSize: PAGESIZE,
	          pageNum: this.state.pageNum
	        },
	        api_key: _UserStore2.default.getState().apiKey
	      }, function (err, response) {
	        if (err) {
	          console.log(err);
	          alert(err);
	          this.setState({ isLoading: false });
	        } else {
	          var pageData = response.data.map(function (r, i) {
	            return {
	              key: i,
	              event_bucket: r.event_bucket,
	              object_id: r.object,
	              user: r.user.name,
	              action: r.action,
	              created_at: r.created_at,
	              user_account: r.user_account && r.user_account.name ? r.user_account.name : "Unknown / External API Call",
	              //person: r.person[0] || "Not available",
	              changes: r.changes
	            };
	          });
	
	          var pageCount = Math.ceil(response.totalRecords / PAGESIZE);
	          this.setState({ pageData: pageData, pageCount: pageCount, isLoading: false });
	        }
	      }.bind(this));
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      if (this.props.isFetching || this.state.passTransferHistory === null || this.state.pass === null) {
	        return _react2.default.createElement(_workingIndicator2.default, { fullPage: true });
	      }
	
	      if (this.state.passTransferHistory.length === 0) {
	        return _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(
	              "span",
	              { style: { fontWeight: "bold", fontSize: "16px" } },
	              "Pass Transfer History"
	            ),
	            _react2.default.createElement("br", null),
	            this.props.params.passId,
	            _react2.default.createElement("br", null),
	            _react2.default.createElement("br", null)
	          ),
	          _react2.default.createElement(
	            "div",
	            null,
	            "There is no transfer history for this pass."
	          )
	        );
	      } else {
	        return _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement(
	            "div",
	            { style: { paddingBottom: 25 } },
	            _react2.default.createElement(
	              "span",
	              { style: { fontWeight: "bold", fontSize: "18px" } },
	              "Pass History - ",
	              this.props.params.passId
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(
	              "span",
	              { style: { fontWeight: "bold", fontSize: "16px" } },
	              "Order Details"
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { style: { paddingBottom: 25 } },
	            _react2.default.createElement(_reactTableV2.default, {
	              columns: [{
	                id: "date",
	                Header: "Date/Time",
	                Cell: function Cell(data) {
	                  return (0, _moment2.default)(data.original.date).format("lll");
	                }
	              }, {
	                id: "order_id",
	                Header: "Order ID",
	                Cell: function Cell(data) {
	                  return _react2.default.createElement(
	                    "div",
	                    null,
	                    _react2.default.createElement(
	                      "a",
	                      { href: "/event_buckets/" + data.original.order.event_bucket + "/orders/" + data.original.order._id },
	                      data.original.order._id
	                    )
	                  );
	                }
	              }, {
	                id: "ordered_by",
	                Header: "Ordered by",
	                Cell: function Cell(data) {
	                  return _react2.default.createElement(
	                    "div",
	                    null,
	                    _react2.default.createElement(
	                      "a",
	                      { href: "/people/" + data.original.person.id },
	                      data.original.person.name
	                    ),
	                    _react2.default.createElement("br", null),
	                    data.original.person.email
	                  );
	                }
	              }],
	              data: [{
	                date: this.state.pass.order.created_at,
	                order: this.state.pass.order,
	                person: {
	                  id: this.state.pass.order.person._id,
	                  name: this.state.pass.order.person.name,
	                  email: this.cleanSundanceEmail(this.state.pass.order.person.email)
	                }
	              }],
	              loading: this.state.isLoading ? "Loading..." : null,
	              manual: true,
	              pageSize: 1,
	              showPagination: false,
	              showPageSizeOptions: false,
	              sortable: false
	            })
	          ),
	          _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(
	              "span",
	              { style: { fontWeight: "bold", fontSize: "16px" } },
	              "Pass Transfer History"
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(_transferHistoryTable2.default, {
	              records: this.state.passTransferHistory,
	              loading: this.state.isLoading ? "Loading..." : null,
	              isPass: true
	            })
	          ),
	          _react2.default.createElement(
	            "div",
	            { style: { paddingTop: 25 } },
	            _react2.default.createElement(
	              "span",
	              { style: { fontWeight: "bold", fontSize: "16px" } },
	              "Pass Audit Log History"
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(_auditLogTable2.default, {
	              logRecords: this.state.pageData,
	              pageSize: this.state.pageData.length > PAGESIZE ? PAGESIZE : this.state.pageData.length,
	              pages: this.state.pageCount || 1,
	              loading: this.state.isLoading ? "Loading..." : null,
	              onFetchData: function onFetchData(page, sorted, searchTerm) {
	                _this2.setState({
	                  pageNum: page
	                  //sorted,
	                  //searchTerm
	                }, function () {
	                  this.fetchPage();
	                });
	              }
	            })
	          )
	        );
	      }
	    }
	  }], [{
	    key: "getStores",
	    value: function getStores() {
	      return [_PassStore2.default, _UserStore2.default];
	    }
	  }, {
	    key: "getPropsFromStores",
	    value: function getPropsFromStores() {
	      return {
	        isFetching: _PassStore2.default.getState().isFetching
	      };
	    }
	  }, {
	    key: "contextTypes",
	    get: function get() {
	      return {
	        router: _react2.default.PropTypes.object
	      };
	    }
	  }]);
	
	  return PassHistory;
	}(_react2.default.Component);
	
	exports.default = (0, _connectToStores2.default)(PassHistory);
	module.exports = exports["default"];

/***/ }),
/* 2920 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ReactTableDefaults = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(958);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _utils = __webpack_require__(2921);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	var _lifecycle = __webpack_require__(2922);
	
	var _lifecycle2 = _interopRequireDefault(_lifecycle);
	
	var _methods = __webpack_require__(2923);
	
	var _methods2 = _interopRequireDefault(_methods);
	
	var _defaultProps = __webpack_require__(2924);
	
	var _defaultProps2 = _interopRequireDefault(_defaultProps);
	
	var _propTypes = __webpack_require__(2926);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	//
	
	
	var ReactTableDefaults = exports.ReactTableDefaults = _defaultProps2.default;
	
	var ReactTable = function (_Methods) {
	  _inherits(ReactTable, _Methods);
	
	  function ReactTable(props) {
	    _classCallCheck(this, ReactTable);
	
	    var _this = _possibleConstructorReturn(this, (ReactTable.__proto__ || Object.getPrototypeOf(ReactTable)).call(this));
	
	    _this.getResolvedState = _this.getResolvedState.bind(_this);
	    _this.getDataModel = _this.getDataModel.bind(_this);
	    _this.getSortedData = _this.getSortedData.bind(_this);
	    _this.fireFetchData = _this.fireFetchData.bind(_this);
	    _this.getPropOrState = _this.getPropOrState.bind(_this);
	    _this.getStateOrProp = _this.getStateOrProp.bind(_this);
	    _this.filterData = _this.filterData.bind(_this);
	    _this.sortData = _this.sortData.bind(_this);
	    _this.getMinRows = _this.getMinRows.bind(_this);
	    _this.onPageChange = _this.onPageChange.bind(_this);
	    _this.onPageSizeChange = _this.onPageSizeChange.bind(_this);
	    _this.sortColumn = _this.sortColumn.bind(_this);
	    _this.filterColumn = _this.filterColumn.bind(_this);
	    _this.resizeColumnStart = _this.resizeColumnStart.bind(_this);
	    _this.resizeColumnEnd = _this.resizeColumnEnd.bind(_this);
	    _this.resizeColumnMoving = _this.resizeColumnMoving.bind(_this);
	
	    _this.state = {
	      page: 0,
	      pageSize: props.defaultPageSize,
	      sorted: props.defaultSorted,
	      expanded: props.defaultExpanded,
	      filtered: props.defaultFiltered,
	      resized: props.defaultResized,
	      currentlyResizing: false,
	      skipNextSort: false
	    };
	    return _this;
	  }
	
	  _createClass(ReactTable, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var resolvedState = this.getResolvedState();
	      var children = resolvedState.children,
	          className = resolvedState.className,
	          style = resolvedState.style,
	          getProps = resolvedState.getProps,
	          getTableProps = resolvedState.getTableProps,
	          getTheadGroupProps = resolvedState.getTheadGroupProps,
	          getTheadGroupTrProps = resolvedState.getTheadGroupTrProps,
	          getTheadGroupThProps = resolvedState.getTheadGroupThProps,
	          getTheadProps = resolvedState.getTheadProps,
	          getTheadTrProps = resolvedState.getTheadTrProps,
	          getTheadThProps = resolvedState.getTheadThProps,
	          getTheadFilterProps = resolvedState.getTheadFilterProps,
	          getTheadFilterTrProps = resolvedState.getTheadFilterTrProps,
	          getTheadFilterThProps = resolvedState.getTheadFilterThProps,
	          getTbodyProps = resolvedState.getTbodyProps,
	          getTrGroupProps = resolvedState.getTrGroupProps,
	          getTrProps = resolvedState.getTrProps,
	          getTdProps = resolvedState.getTdProps,
	          getTfootProps = resolvedState.getTfootProps,
	          getTfootTrProps = resolvedState.getTfootTrProps,
	          getTfootTdProps = resolvedState.getTfootTdProps,
	          getPaginationProps = resolvedState.getPaginationProps,
	          getLoadingProps = resolvedState.getLoadingProps,
	          getNoDataProps = resolvedState.getNoDataProps,
	          getResizerProps = resolvedState.getResizerProps,
	          showPagination = resolvedState.showPagination,
	          showPaginationTop = resolvedState.showPaginationTop,
	          showPaginationBottom = resolvedState.showPaginationBottom,
	          manual = resolvedState.manual,
	          loadingText = resolvedState.loadingText,
	          noDataText = resolvedState.noDataText,
	          sortable = resolvedState.sortable,
	          multiSort = resolvedState.multiSort,
	          resizable = resolvedState.resizable,
	          filterable = resolvedState.filterable,
	          pivotIDKey = resolvedState.pivotIDKey,
	          pivotValKey = resolvedState.pivotValKey,
	          pivotBy = resolvedState.pivotBy,
	          subRowsKey = resolvedState.subRowsKey,
	          aggregatedKey = resolvedState.aggregatedKey,
	          originalKey = resolvedState.originalKey,
	          indexKey = resolvedState.indexKey,
	          groupedByPivotKey = resolvedState.groupedByPivotKey,
	          loading = resolvedState.loading,
	          pageSize = resolvedState.pageSize,
	          page = resolvedState.page,
	          sorted = resolvedState.sorted,
	          filtered = resolvedState.filtered,
	          resized = resolvedState.resized,
	          expanded = resolvedState.expanded,
	          pages = resolvedState.pages,
	          onExpandedChange = resolvedState.onExpandedChange,
	          TableComponent = resolvedState.TableComponent,
	          TheadComponent = resolvedState.TheadComponent,
	          TbodyComponent = resolvedState.TbodyComponent,
	          TrGroupComponent = resolvedState.TrGroupComponent,
	          TrComponent = resolvedState.TrComponent,
	          ThComponent = resolvedState.ThComponent,
	          TdComponent = resolvedState.TdComponent,
	          TfootComponent = resolvedState.TfootComponent,
	          PaginationComponent = resolvedState.PaginationComponent,
	          LoadingComponent = resolvedState.LoadingComponent,
	          SubComponent = resolvedState.SubComponent,
	          NoDataComponent = resolvedState.NoDataComponent,
	          ResizerComponent = resolvedState.ResizerComponent,
	          ExpanderComponent = resolvedState.ExpanderComponent,
	          PivotValueComponent = resolvedState.PivotValueComponent,
	          PivotComponent = resolvedState.PivotComponent,
	          AggregatedComponent = resolvedState.AggregatedComponent,
	          FilterComponent = resolvedState.FilterComponent,
	          PadRowComponent = resolvedState.PadRowComponent,
	          resolvedData = resolvedState.resolvedData,
	          allVisibleColumns = resolvedState.allVisibleColumns,
	          headerGroups = resolvedState.headerGroups,
	          hasHeaderGroups = resolvedState.hasHeaderGroups,
	          sortedData = resolvedState.sortedData,
	          currentlyResizing = resolvedState.currentlyResizing;
	
	      // Pagination
	
	      var startRow = pageSize * page;
	      var endRow = startRow + pageSize;
	      var pageRows = manual ? resolvedData : sortedData.slice(startRow, endRow);
	      var minRows = this.getMinRows();
	      var padRows = _utils2.default.range(Math.max(minRows - pageRows.length, 0));
	
	      var hasColumnFooter = allVisibleColumns.some(function (d) {
	        return d.Footer;
	      });
	      var hasFilters = filterable || allVisibleColumns.some(function (d) {
	        return d.filterable;
	      });
	
	      var recurseRowsViewIndex = function recurseRowsViewIndex(rows) {
	        var path = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	        var index = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : -1;
	        return [rows.map(function (row, i) {
	          index += 1;
	          var rowWithViewIndex = _extends({}, row, {
	            _viewIndex: index
	          });
	          var newPath = path.concat([i]);
	          if (rowWithViewIndex[subRowsKey] && _utils2.default.get(expanded, newPath)) {
	            var _recurseRowsViewIndex = recurseRowsViewIndex(rowWithViewIndex[subRowsKey], newPath, index);
	
	            var _recurseRowsViewIndex2 = _slicedToArray(_recurseRowsViewIndex, 2);
	
	            rowWithViewIndex[subRowsKey] = _recurseRowsViewIndex2[0];
	            index = _recurseRowsViewIndex2[1];
	          }
	          return rowWithViewIndex;
	        }), index];
	      };
	
	      var _recurseRowsViewIndex3 = recurseRowsViewIndex(pageRows);
	
	      var _recurseRowsViewIndex4 = _slicedToArray(_recurseRowsViewIndex3, 1);
	
	      pageRows = _recurseRowsViewIndex4[0];
	
	
	      var canPrevious = page > 0;
	      var canNext = page + 1 < pages;
	
	      var rowMinWidth = _utils2.default.sum(allVisibleColumns.map(function (d) {
	        var resizedColumn = resized.find(function (x) {
	          return x.id === d.id;
	        }) || {};
	        return _utils2.default.getFirstDefined(resizedColumn.value, d.width, d.minWidth);
	      }));
	
	      var rowIndex = -1;
	
	      var finalState = _extends({}, resolvedState, {
	        startRow: startRow,
	        endRow: endRow,
	        pageRows: pageRows,
	        minRows: minRows,
	        padRows: padRows,
	        hasColumnFooter: hasColumnFooter,
	        canPrevious: canPrevious,
	        canNext: canNext,
	        rowMinWidth: rowMinWidth
	      });
	
	      var rootProps = _utils2.default.splitProps(getProps(finalState, undefined, undefined, this));
	      var tableProps = _utils2.default.splitProps(getTableProps(finalState, undefined, undefined, this));
	      var tBodyProps = _utils2.default.splitProps(getTbodyProps(finalState, undefined, undefined, this));
	      var loadingProps = getLoadingProps(finalState, undefined, undefined, this);
	      var noDataProps = getNoDataProps(finalState, undefined, undefined, this);
	
	      // Visual Components
	
	      var makeHeaderGroup = function makeHeaderGroup(column, i) {
	        var resizedValue = function resizedValue(col) {
	          return (resized.find(function (x) {
	            return x.id === col.id;
	          }) || {}).value;
	        };
	        var flex = _utils2.default.sum(column.columns.map(function (col) {
	          return col.width || resizedValue(col) ? 0 : col.minWidth;
	        }));
	        var width = _utils2.default.sum(column.columns.map(function (col) {
	          return _utils2.default.getFirstDefined(resizedValue(col), col.width, col.minWidth);
	        }));
	        var maxWidth = _utils2.default.sum(column.columns.map(function (col) {
	          return _utils2.default.getFirstDefined(resizedValue(col), col.width, col.maxWidth);
	        }));
	
	        var theadGroupThProps = _utils2.default.splitProps(getTheadGroupThProps(finalState, undefined, column, _this2));
	        var columnHeaderProps = _utils2.default.splitProps(column.getHeaderProps(finalState, undefined, column, _this2));
	
	        var classes = [column.headerClassName, theadGroupThProps.className, columnHeaderProps.className];
	
	        var styles = _extends({}, column.headerStyle, theadGroupThProps.style, columnHeaderProps.style);
	
	        var rest = _extends({}, theadGroupThProps.rest, columnHeaderProps.rest);
	
	        var flexStyles = {
	          flex: flex + ' 0 auto',
	          width: _utils2.default.asPx(width),
	          maxWidth: _utils2.default.asPx(maxWidth)
	        };
	
	        return _react2.default.createElement(
	          ThComponent,
	          _extends({
	            key: i + '-' + column.id,
	            className: (0, _classnames2.default)(classes),
	            style: _extends({}, styles, flexStyles)
	          }, rest),
	          _utils2.default.normalizeComponent(column.Header, {
	            data: sortedData,
	            column: column
	          })
	        );
	      };
	
	      var makeHeaderGroups = function makeHeaderGroups() {
	        var theadGroupProps = _utils2.default.splitProps(getTheadGroupProps(finalState, undefined, undefined, _this2));
	        var theadGroupTrProps = _utils2.default.splitProps(getTheadGroupTrProps(finalState, undefined, undefined, _this2));
	        return _react2.default.createElement(
	          TheadComponent,
	          _extends({
	            className: (0, _classnames2.default)('-headerGroups', theadGroupProps.className),
	            style: _extends({}, theadGroupProps.style, {
	              minWidth: rowMinWidth + 'px'
	            })
	          }, theadGroupProps.rest),
	          _react2.default.createElement(
	            TrComponent,
	            _extends({
	              className: theadGroupTrProps.className,
	              style: theadGroupTrProps.style
	            }, theadGroupTrProps.rest),
	            headerGroups.map(makeHeaderGroup)
	          )
	        );
	      };
	
	      var makeHeader = function makeHeader(column, i) {
	        var resizedCol = resized.find(function (x) {
	          return x.id === column.id;
	        }) || {};
	        var sort = sorted.find(function (d) {
	          return d.id === column.id;
	        });
	        var show = typeof column.show === 'function' ? column.show() : column.show;
	        var width = _utils2.default.getFirstDefined(resizedCol.value, column.width, column.minWidth);
	        var maxWidth = _utils2.default.getFirstDefined(resizedCol.value, column.width, column.maxWidth);
	        var theadThProps = _utils2.default.splitProps(getTheadThProps(finalState, undefined, column, _this2));
	        var columnHeaderProps = _utils2.default.splitProps(column.getHeaderProps(finalState, undefined, column, _this2));
	
	        var classes = [column.headerClassName, theadThProps.className, columnHeaderProps.className];
	
	        var styles = _extends({}, column.headerStyle, theadThProps.style, columnHeaderProps.style);
	
	        var rest = _extends({}, theadThProps.rest, columnHeaderProps.rest);
	
	        var isResizable = _utils2.default.getFirstDefined(column.resizable, resizable, false);
	        var resizer = isResizable ? _react2.default.createElement(ResizerComponent, _extends({
	          onMouseDown: function onMouseDown(e) {
	            return _this2.resizeColumnStart(e, column, false);
	          },
	          onTouchStart: function onTouchStart(e) {
	            return _this2.resizeColumnStart(e, column, true);
	          }
	        }, getResizerProps('finalState', undefined, column, _this2))) : null;
	
	        var isSortable = _utils2.default.getFirstDefined(column.sortable, sortable, false);
	
	        return _react2.default.createElement(
	          ThComponent,
	          _extends({
	            key: i + '-' + column.id,
	            className: (0, _classnames2.default)(classes, isResizable && 'rt-resizable-header', sort ? sort.desc ? '-sort-desc' : '-sort-asc' : '', isSortable && '-cursor-pointer', !show && '-hidden', pivotBy && pivotBy.slice(0, -1).includes(column.id) && 'rt-header-pivot'),
	            style: _extends({}, styles, {
	              flex: width + ' 0 auto',
	              width: _utils2.default.asPx(width),
	              maxWidth: _utils2.default.asPx(maxWidth)
	            }),
	            toggleSort: function toggleSort(e) {
	              if (isSortable) _this2.sortColumn(column, multiSort ? e.shiftKey : false);
	            }
	          }, rest),
	          _react2.default.createElement(
	            'div',
	            { className: (0, _classnames2.default)(isResizable && 'rt-resizable-header-content') },
	            _utils2.default.normalizeComponent(column.Header, {
	              data: sortedData,
	              column: column
	            })
	          ),
	          resizer
	        );
	      };
	
	      var makeHeaders = function makeHeaders() {
	        var theadProps = _utils2.default.splitProps(getTheadProps(finalState, undefined, undefined, _this2));
	        var theadTrProps = _utils2.default.splitProps(getTheadTrProps(finalState, undefined, undefined, _this2));
	        return _react2.default.createElement(
	          TheadComponent,
	          _extends({
	            className: (0, _classnames2.default)('-header', theadProps.className),
	            style: _extends({}, theadProps.style, {
	              minWidth: rowMinWidth + 'px'
	            })
	          }, theadProps.rest),
	          _react2.default.createElement(
	            TrComponent,
	            _extends({
	              className: theadTrProps.className,
	              style: theadTrProps.style
	            }, theadTrProps.rest),
	            allVisibleColumns.map(makeHeader)
	          )
	        );
	      };
	
	      var makeFilter = function makeFilter(column, i) {
	        var resizedCol = resized.find(function (x) {
	          return x.id === column.id;
	        }) || {};
	        var width = _utils2.default.getFirstDefined(resizedCol.value, column.width, column.minWidth);
	        var maxWidth = _utils2.default.getFirstDefined(resizedCol.value, column.width, column.maxWidth);
	        var theadFilterThProps = _utils2.default.splitProps(getTheadFilterThProps(finalState, undefined, column, _this2));
	        var columnHeaderProps = _utils2.default.splitProps(column.getHeaderProps(finalState, undefined, column, _this2));
	
	        var classes = [column.headerClassName, theadFilterThProps.className, columnHeaderProps.className];
	
	        var styles = _extends({}, column.headerStyle, theadFilterThProps.style, columnHeaderProps.style);
	
	        var rest = _extends({}, theadFilterThProps.rest, columnHeaderProps.rest);
	
	        var filter = filtered.find(function (filter) {
	          return filter.id === column.id;
	        });
	
	        var ResolvedFilterComponent = column.Filter || FilterComponent;
	
	        var isFilterable = _utils2.default.getFirstDefined(column.filterable, filterable, false);
	
	        return _react2.default.createElement(
	          ThComponent,
	          _extends({
	            key: i + '-' + column.id,
	            className: (0, _classnames2.default)(classes),
	            style: _extends({}, styles, {
	              flex: width + ' 0 auto',
	              width: _utils2.default.asPx(width),
	              maxWidth: _utils2.default.asPx(maxWidth)
	            })
	          }, rest),
	          isFilterable ? _utils2.default.normalizeComponent(ResolvedFilterComponent, {
	            column: column,
	            filter: filter,
	            onChange: function onChange(value) {
	              return _this2.filterColumn(column, value);
	            }
	          }, _defaultProps2.default.column.Filter) : null
	        );
	      };
	
	      var makeFilters = function makeFilters() {
	        var theadFilterProps = _utils2.default.splitProps(getTheadFilterProps(finalState, undefined, undefined, _this2));
	        var theadFilterTrProps = _utils2.default.splitProps(getTheadFilterTrProps(finalState, undefined, undefined, _this2));
	        return _react2.default.createElement(
	          TheadComponent,
	          _extends({
	            className: (0, _classnames2.default)('-filters', theadFilterProps.className),
	            style: _extends({}, theadFilterProps.style, {
	              minWidth: rowMinWidth + 'px'
	            })
	          }, theadFilterProps.rest),
	          _react2.default.createElement(
	            TrComponent,
	            _extends({
	              className: theadFilterTrProps.className,
	              style: theadFilterTrProps.style
	            }, theadFilterTrProps.rest),
	            allVisibleColumns.map(makeFilter)
	          )
	        );
	      };
	
	      var makePageRow = function makePageRow(row, i) {
	        var path = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
	
	        var rowInfo = {
	          original: row[originalKey],
	          row: row,
	          index: row[indexKey],
	          viewIndex: rowIndex += 1,
	          pageSize: pageSize,
	          page: page,
	          level: path.length,
	          nestingPath: path.concat([i]),
	          aggregated: row[aggregatedKey],
	          groupedByPivot: row[groupedByPivotKey],
	          subRows: row[subRowsKey]
	        };
	        var isExpanded = _utils2.default.get(expanded, rowInfo.nestingPath);
	        var trGroupProps = getTrGroupProps(finalState, rowInfo, undefined, _this2);
	        var trProps = _utils2.default.splitProps(getTrProps(finalState, rowInfo, undefined, _this2));
	        return _react2.default.createElement(
	          TrGroupComponent,
	          _extends({ key: rowInfo.nestingPath.join('_') }, trGroupProps),
	          _react2.default.createElement(
	            TrComponent,
	            _extends({
	              className: (0, _classnames2.default)(trProps.className, row._viewIndex % 2 ? '-even' : '-odd'),
	              style: trProps.style
	            }, trProps.rest),
	            allVisibleColumns.map(function (column, i2) {
	              var resizedCol = resized.find(function (x) {
	                return x.id === column.id;
	              }) || {};
	              var show = typeof column.show === 'function' ? column.show() : column.show;
	              var width = _utils2.default.getFirstDefined(resizedCol.value, column.width, column.minWidth);
	              var maxWidth = _utils2.default.getFirstDefined(resizedCol.value, column.width, column.maxWidth);
	              var tdProps = _utils2.default.splitProps(getTdProps(finalState, rowInfo, column, _this2));
	              var columnProps = _utils2.default.splitProps(column.getProps(finalState, rowInfo, column, _this2));
	
	              var classes = [tdProps.className, column.className, columnProps.className];
	
	              var styles = _extends({}, tdProps.style, column.style, columnProps.style);
	
	              var cellInfo = _extends({}, rowInfo, {
	                isExpanded: isExpanded,
	                column: _extends({}, column),
	                value: rowInfo.row[column.id],
	                pivoted: column.pivoted,
	                expander: column.expander,
	                resized: resized,
	                show: show,
	                width: width,
	                maxWidth: maxWidth,
	                tdProps: tdProps,
	                columnProps: columnProps,
	                classes: classes,
	                styles: styles
	              });
	
	              var value = cellInfo.value;
	
	              var useOnExpanderClick = void 0;
	              var isBranch = void 0;
	              var isPreview = void 0;
	
	              var onExpanderClick = function onExpanderClick(e) {
	                var newExpanded = _utils2.default.clone(expanded);
	                if (isExpanded) {
	                  newExpanded = _utils2.default.set(newExpanded, cellInfo.nestingPath, false);
	                } else {
	                  newExpanded = _utils2.default.set(newExpanded, cellInfo.nestingPath, {});
	                }
	
	                return _this2.setStateWithData({
	                  expanded: newExpanded
	                }, function () {
	                  return onExpandedChange && onExpandedChange(newExpanded, cellInfo.nestingPath, e);
	                });
	              };
	
	              // Default to a standard cell
	              var resolvedCell = _utils2.default.normalizeComponent(column.Cell, cellInfo, value);
	
	              // Resolve Renderers
	              var ResolvedAggregatedComponent = column.Aggregated || (!column.aggregate ? AggregatedComponent : column.Cell);
	              var ResolvedExpanderComponent = column.Expander || ExpanderComponent;
	              var ResolvedPivotValueComponent = column.PivotValue || PivotValueComponent;
	              var DefaultResolvedPivotComponent = PivotComponent || function (props) {
	                return _react2.default.createElement(
	                  'div',
	                  null,
	                  _react2.default.createElement(ResolvedExpanderComponent, props),
	                  _react2.default.createElement(ResolvedPivotValueComponent, props)
	                );
	              };
	              var ResolvedPivotComponent = column.Pivot || DefaultResolvedPivotComponent;
	
	              // Is this cell expandable?
	              if (cellInfo.pivoted || cellInfo.expander) {
	                // Make it expandable by defualt
	                cellInfo.expandable = true;
	                useOnExpanderClick = true;
	                // If pivoted, has no subRows, and does not have a subComponent,
	                // do not make expandable
	                if (cellInfo.pivoted && !cellInfo.subRows && !SubComponent) {
	                  cellInfo.expandable = false;
	                }
	              }
	
	              if (cellInfo.pivoted) {
	                // Is this column a branch?
	                isBranch = rowInfo.row[pivotIDKey] === column.id && cellInfo.subRows;
	                // Should this column be blank?
	                isPreview = pivotBy.indexOf(column.id) > pivotBy.indexOf(rowInfo.row[pivotIDKey]) && cellInfo.subRows;
	                // Pivot Cell Render Override
	                if (isBranch) {
	                  // isPivot
	                  resolvedCell = _utils2.default.normalizeComponent(ResolvedPivotComponent, _extends({}, cellInfo, {
	                    value: row[pivotValKey]
	                  }), row[pivotValKey]);
	                } else if (isPreview) {
	                  // Show the pivot preview
	                  resolvedCell = _utils2.default.normalizeComponent(ResolvedAggregatedComponent, cellInfo, value);
	                } else {
	                  resolvedCell = null;
	                }
	              } else if (cellInfo.aggregated) {
	                resolvedCell = _utils2.default.normalizeComponent(ResolvedAggregatedComponent, cellInfo, value);
	              }
	
	              if (cellInfo.expander) {
	                resolvedCell = _utils2.default.normalizeComponent(ResolvedExpanderComponent, cellInfo, row[pivotValKey]);
	                if (pivotBy) {
	                  if (cellInfo.groupedByPivot) {
	                    resolvedCell = null;
	                  }
	                  if (!cellInfo.subRows && !SubComponent) {
	                    resolvedCell = null;
	                  }
	                }
	              }
	
	              var resolvedOnExpanderClick = useOnExpanderClick ? onExpanderClick : function () {};
	
	              // If there are multiple onClick events, make sure they don't
	              // override eachother. This should maybe be expanded to handle all
	              // function attributes
	              var interactionProps = {
	                onClick: resolvedOnExpanderClick
	              };
	
	              if (tdProps.rest.onClick) {
	                interactionProps.onClick = function (e) {
	                  tdProps.rest.onClick(e, function () {
	                    return resolvedOnExpanderClick(e);
	                  });
	                };
	              }
	
	              if (columnProps.rest.onClick) {
	                interactionProps.onClick = function (e) {
	                  columnProps.rest.onClick(e, function () {
	                    return resolvedOnExpanderClick(e);
	                  });
	                };
	              }
	
	              // Return the cell
	              return _react2.default.createElement(
	                TdComponent
	                // eslint-disable-next-line react/no-array-index-key
	                ,
	                _extends({ key: i2 + '-' + column.id,
	                  className: (0, _classnames2.default)(classes, !show && 'hidden', cellInfo.expandable && 'rt-expandable', (isBranch || isPreview) && 'rt-pivot'),
	                  style: _extends({}, styles, {
	                    flex: width + ' 0 auto',
	                    width: _utils2.default.asPx(width),
	                    maxWidth: _utils2.default.asPx(maxWidth)
	                  })
	                }, tdProps.rest, columnProps.rest, interactionProps),
	                resolvedCell
	              );
	            })
	          ),
	          rowInfo.subRows && isExpanded && rowInfo.subRows.map(function (d, i) {
	            return makePageRow(d, i, rowInfo.nestingPath);
	          }),
	          SubComponent && !rowInfo.subRows && isExpanded && SubComponent(rowInfo)
	        );
	      };
	
	      var makePadColumn = function makePadColumn(column, i) {
	        var resizedCol = resized.find(function (x) {
	          return x.id === column.id;
	        }) || {};
	        var show = typeof column.show === 'function' ? column.show() : column.show;
	        var width = _utils2.default.getFirstDefined(resizedCol.value, column.width, column.minWidth);
	        var flex = width;
	        var maxWidth = _utils2.default.getFirstDefined(resizedCol.value, column.width, column.maxWidth);
	        var tdProps = _utils2.default.splitProps(getTdProps(finalState, undefined, column, _this2));
	        var columnProps = _utils2.default.splitProps(column.getProps(finalState, undefined, column, _this2));
	
	        var classes = [tdProps.className, column.className, columnProps.className];
	
	        var styles = _extends({}, tdProps.style, column.style, columnProps.style);
	
	        return _react2.default.createElement(
	          TdComponent,
	          _extends({
	            key: i + '-' + column.id,
	            className: (0, _classnames2.default)(classes, !show && 'hidden'),
	            style: _extends({}, styles, {
	              flex: flex + ' 0 auto',
	              width: _utils2.default.asPx(width),
	              maxWidth: _utils2.default.asPx(maxWidth)
	            })
	          }, tdProps.rest),
	          _utils2.default.normalizeComponent(PadRowComponent)
	        );
	      };
	
	      var makePadRow = function makePadRow(row, i) {
	        var trGroupProps = getTrGroupProps(finalState, undefined, undefined, _this2);
	        var trProps = _utils2.default.splitProps(getTrProps(finalState, undefined, undefined, _this2));
	        return _react2.default.createElement(
	          TrGroupComponent,
	          _extends({ key: i }, trGroupProps),
	          _react2.default.createElement(
	            TrComponent,
	            {
	              className: (0, _classnames2.default)('-padRow', (pageRows.length + i) % 2 ? '-even' : '-odd', trProps.className),
	              style: trProps.style || {}
	            },
	            allVisibleColumns.map(makePadColumn)
	          )
	        );
	      };
	
	      var makeColumnFooter = function makeColumnFooter(column, i) {
	        var resizedCol = resized.find(function (x) {
	          return x.id === column.id;
	        }) || {};
	        var show = typeof column.show === 'function' ? column.show() : column.show;
	        var width = _utils2.default.getFirstDefined(resizedCol.value, column.width, column.minWidth);
	        var maxWidth = _utils2.default.getFirstDefined(resizedCol.value, column.width, column.maxWidth);
	        var tFootTdProps = _utils2.default.splitProps(getTfootTdProps(finalState, undefined, undefined, _this2));
	        var columnProps = _utils2.default.splitProps(column.getProps(finalState, undefined, column, _this2));
	        var columnFooterProps = _utils2.default.splitProps(column.getFooterProps(finalState, undefined, column, _this2));
	
	        var classes = [tFootTdProps.className, column.className, columnProps.className, columnFooterProps.className];
	
	        var styles = _extends({}, tFootTdProps.style, column.style, columnProps.style, columnFooterProps.style);
	
	        return _react2.default.createElement(
	          TdComponent,
	          _extends({
	            key: i + '-' + column.id,
	            className: (0, _classnames2.default)(classes, !show && 'hidden'),
	            style: _extends({}, styles, {
	              flex: width + ' 0 auto',
	              width: _utils2.default.asPx(width),
	              maxWidth: _utils2.default.asPx(maxWidth)
	            })
	          }, columnProps.rest, tFootTdProps.rest, columnFooterProps.rest),
	          _utils2.default.normalizeComponent(column.Footer, {
	            data: sortedData,
	            column: column
	          })
	        );
	      };
	
	      var makeColumnFooters = function makeColumnFooters() {
	        var tFootProps = getTfootProps(finalState, undefined, undefined, _this2);
	        var tFootTrProps = _utils2.default.splitProps(getTfootTrProps(finalState, undefined, undefined, _this2));
	        return _react2.default.createElement(
	          TfootComponent,
	          _extends({
	            className: tFootProps.className,
	            style: _extends({}, tFootProps.style, {
	              minWidth: rowMinWidth + 'px'
	            })
	          }, tFootProps.rest),
	          _react2.default.createElement(
	            TrComponent,
	            _extends({
	              className: (0, _classnames2.default)(tFootTrProps.className),
	              style: tFootTrProps.style
	            }, tFootTrProps.rest),
	            allVisibleColumns.map(makeColumnFooter)
	          )
	        );
	      };
	
	      var makePagination = function makePagination() {
	        var paginationProps = _utils2.default.splitProps(getPaginationProps(finalState, undefined, undefined, _this2));
	        return _react2.default.createElement(PaginationComponent, _extends({}, resolvedState, {
	          pages: pages,
	          canPrevious: canPrevious,
	          canNext: canNext,
	          onPageChange: _this2.onPageChange,
	          onPageSizeChange: _this2.onPageSizeChange,
	          className: paginationProps.className,
	          style: paginationProps.style
	        }, paginationProps.rest));
	      };
	
	      var makeTable = function makeTable() {
	        var pagination = makePagination();
	        return _react2.default.createElement(
	          'div',
	          _extends({
	            className: (0, _classnames2.default)('ReactTable', className, rootProps.className),
	            style: _extends({}, style, rootProps.style)
	          }, rootProps.rest),
	          showPagination && showPaginationTop ? _react2.default.createElement(
	            'div',
	            { className: 'pagination-top' },
	            pagination
	          ) : null,
	          _react2.default.createElement(
	            TableComponent,
	            _extends({
	              className: (0, _classnames2.default)(tableProps.className, currentlyResizing ? 'rt-resizing' : ''),
	              style: tableProps.style
	            }, tableProps.rest),
	            hasHeaderGroups ? makeHeaderGroups() : null,
	            makeHeaders(),
	            hasFilters ? makeFilters() : null,
	            _react2.default.createElement(
	              TbodyComponent,
	              _extends({
	                className: (0, _classnames2.default)(tBodyProps.className),
	                style: _extends({}, tBodyProps.style, {
	                  minWidth: rowMinWidth + 'px'
	                })
	              }, tBodyProps.rest),
	              pageRows.map(function (d, i) {
	                return makePageRow(d, i);
	              }),
	              padRows.map(makePadRow)
	            ),
	            hasColumnFooter ? makeColumnFooters() : null
	          ),
	          showPagination && showPaginationBottom ? _react2.default.createElement(
	            'div',
	            { className: 'pagination-bottom' },
	            pagination
	          ) : null,
	          !pageRows.length && _react2.default.createElement(
	            NoDataComponent,
	            noDataProps,
	            _utils2.default.normalizeComponent(noDataText)
	          ),
	          _react2.default.createElement(LoadingComponent, _extends({ loading: loading, loadingText: loadingText }, loadingProps))
	        );
	      };
	
	      // childProps are optionally passed to a function-as-a-child
	      return children ? children(finalState, makeTable, this) : makeTable();
	    }
	  }]);
	
	  return ReactTable;
	}((0, _methods2.default)((0, _lifecycle2.default)(_react.Component)));
	
	ReactTable.propTypes = _propTypes2.default;
	ReactTable.defaultProps = _defaultProps2.default;
	exports.default = ReactTable;
	//# sourceMappingURL=data:application/json;base64,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

/***/ }),
/* 2921 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(958);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	//
	exports.default = {
	  get: get,
	  set: set,
	  takeRight: takeRight,
	  last: last,
	  orderBy: orderBy,
	  range: range,
	  remove: remove,
	  clone: clone,
	  getFirstDefined: getFirstDefined,
	  sum: sum,
	  makeTemplateComponent: makeTemplateComponent,
	  groupBy: groupBy,
	  isArray: isArray,
	  splitProps: splitProps,
	  compactObject: compactObject,
	  isSortingDesc: isSortingDesc,
	  normalizeComponent: normalizeComponent,
	  asPx: asPx
	};
	
	
	function get(obj, path, def) {
	  if (!path) {
	    return obj;
	  }
	  var pathObj = makePathArray(path);
	  var val = void 0;
	  try {
	    val = pathObj.reduce(function (current, pathPart) {
	      return current[pathPart];
	    }, obj);
	  } catch (e) {
	    // continue regardless of error
	  }
	  return typeof val !== 'undefined' ? val : def;
	}
	
	function set() {
	  var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var path = arguments[1];
	  var value = arguments[2];
	
	  var keys = makePathArray(path);
	  var keyPart = void 0;
	  var cursor = obj;
	  while ((keyPart = keys.shift()) && keys.length) {
	    if (!cursor[keyPart]) {
	      cursor[keyPart] = {};
	    }
	    cursor = cursor[keyPart];
	  }
	  cursor[keyPart] = value;
	  return obj;
	}
	
	function takeRight(arr, n) {
	  var start = n > arr.length ? 0 : arr.length - n;
	  return arr.slice(start);
	}
	
	function last(arr) {
	  return arr[arr.length - 1];
	}
	
	function range(n) {
	  var arr = [];
	  for (var i = 0; i < n; i += 1) {
	    arr.push(n);
	  }
	  return arr;
	}
	
	function orderBy(arr, funcs, dirs, indexKey) {
	  return arr.sort(function (rowA, rowB) {
	    for (var i = 0; i < funcs.length; i += 1) {
	      var comp = funcs[i];
	      var desc = dirs[i] === false || dirs[i] === 'desc';
	      var sortInt = comp(rowA, rowB);
	      if (sortInt) {
	        return desc ? -sortInt : sortInt;
	      }
	    }
	    // Use the row index for tie breakers
	    return dirs[0] ? rowA[indexKey] - rowB[indexKey] : rowB[indexKey] - rowA[indexKey];
	  });
	}
	
	function remove(a, b) {
	  return a.filter(function (o, i) {
	    var r = b(o);
	    if (r) {
	      a.splice(i, 1);
	      return true;
	    }
	    return false;
	  });
	}
	
	function clone(a) {
	  try {
	    return JSON.parse(JSON.stringify(a, function (key, value) {
	      if (typeof value === 'function') {
	        return value.toString();
	      }
	      return value;
	    }));
	  } catch (e) {
	    return a;
	  }
	}
	
	function getFirstDefined() {
	  for (var i = 0; i < arguments.length; i += 1) {
	    if (typeof (arguments.length <= i ? undefined : arguments[i]) !== 'undefined') {
	      return arguments.length <= i ? undefined : arguments[i];
	    }
	  }
	}
	
	function sum(arr) {
	  return arr.reduce(function (a, b) {
	    return a + b;
	  }, 0);
	}
	
	function makeTemplateComponent(compClass, displayName) {
	  if (!displayName) {
	    throw new Error('No displayName found for template component:', compClass);
	  }
	  var cmp = function cmp(_ref) {
	    var children = _ref.children,
	        className = _ref.className,
	        rest = _objectWithoutProperties(_ref, ['children', 'className']);
	
	    return _react2.default.createElement(
	      'div',
	      _extends({ className: (0, _classnames2.default)(compClass, className) }, rest),
	      children
	    );
	  };
	  cmp.displayName = displayName;
	  return cmp;
	}
	
	function groupBy(xs, key) {
	  return xs.reduce(function (rv, x, i) {
	    var resKey = typeof key === 'function' ? key(x, i) : x[key];
	    rv[resKey] = isArray(rv[resKey]) ? rv[resKey] : [];
	    rv[resKey].push(x);
	    return rv;
	  }, {});
	}
	
	function asPx(value) {
	  value = Number(value);
	  return Number.isNaN(value) ? null : value + 'px';
	}
	
	function isArray(a) {
	  return Array.isArray(a);
	}
	
	// ########################################################################
	// Non-exported Helpers
	// ########################################################################
	
	function makePathArray(obj) {
	  return flattenDeep(obj).join('.').replace(/\[/g, '.').replace(/\]/g, '').split('.');
	}
	
	function flattenDeep(arr) {
	  var newArr = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	
	  if (!isArray(arr)) {
	    newArr.push(arr);
	  } else {
	    for (var i = 0; i < arr.length; i += 1) {
	      flattenDeep(arr[i], newArr);
	    }
	  }
	  return newArr;
	}
	
	function splitProps(_ref2) {
	  var className = _ref2.className,
	      style = _ref2.style,
	      rest = _objectWithoutProperties(_ref2, ['className', 'style']);
	
	  return {
	    className: className,
	    style: style,
	    rest: rest || {}
	  };
	}
	
	function compactObject(obj) {
	  var newObj = {};
	  if (obj) {
	    Object.keys(obj).map(function (key) {
	      if (Object.prototype.hasOwnProperty.call(obj, key) && obj[key] !== undefined && typeof obj[key] !== 'undefined') {
	        newObj[key] = obj[key];
	      }
	      return true;
	    });
	  }
	  return newObj;
	}
	
	function isSortingDesc(d) {
	  return !!(d.sort === 'desc' || d.desc === true || d.asc === false);
	}
	
	function normalizeComponent(Comp) {
	  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  var fallback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : Comp;
	
	  return typeof Comp === 'function' ? Object.getPrototypeOf(Comp).isReactComponent ? _react2.default.createElement(Comp, params) : Comp(params) : fallback;
	}
	//# sourceMappingURL=data:application/json;base64,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

/***/ }),
/* 2922 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	exports.default = function (Base) {
	  return function (_Base) {
	    _inherits(_class, _Base);
	
	    function _class() {
	      _classCallCheck(this, _class);
	
	      return _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));
	    }
	
	    _createClass(_class, [{
	      key: 'componentWillMount',
	      value: function componentWillMount() {
	        this.setStateWithData(this.getDataModel(this.getResolvedState(), true));
	      }
	    }, {
	      key: 'componentDidMount',
	      value: function componentDidMount() {
	        this.fireFetchData();
	      }
	    }, {
	      key: 'componentWillReceiveProps',
	      value: function componentWillReceiveProps(nextProps, nextState) {
	        var oldState = this.getResolvedState();
	        var newState = this.getResolvedState(nextProps, nextState);
	
	        // Do a deep compare of new and old `defaultOption` and
	        // if they are different reset `option = defaultOption`
	        var defaultableOptions = ['sorted', 'filtered', 'resized', 'expanded'];
	        defaultableOptions.forEach(function (x) {
	          var defaultName = 'default' + (x.charAt(0).toUpperCase() + x.slice(1));
	          if (JSON.stringify(oldState[defaultName]) !== JSON.stringify(newState[defaultName])) {
	            newState[x] = newState[defaultName];
	          }
	        });
	
	        // If they change these table options, we need to reset defaults
	        // or else we could get into a state where the user has changed the UI
	        // and then disabled the ability to change it back.
	        // e.g. If `filterable` has changed, set `filtered = defaultFiltered`
	        var resettableOptions = ['sortable', 'filterable', 'resizable'];
	        resettableOptions.forEach(function (x) {
	          if (oldState[x] !== newState[x]) {
	            var baseName = x.replace('able', '');
	            var optionName = baseName + 'ed';
	            var defaultName = 'default' + (optionName.charAt(0).toUpperCase() + optionName.slice(1));
	            newState[optionName] = newState[defaultName];
	          }
	        });
	
	        // Props that trigger a data update
	        if (oldState.data !== newState.data || oldState.columns !== newState.columns || oldState.pivotBy !== newState.pivotBy || oldState.sorted !== newState.sorted || oldState.filtered !== newState.filtered) {
	          this.setStateWithData(this.getDataModel(newState, oldState.data !== newState.data));
	        }
	      }
	    }, {
	      key: 'setStateWithData',
	      value: function setStateWithData(newState, cb) {
	        var _this2 = this;
	
	        var oldState = this.getResolvedState();
	        var newResolvedState = this.getResolvedState({}, newState);
	        var freezeWhenExpanded = newResolvedState.freezeWhenExpanded;
	
	        // Default to unfrozen state
	
	        newResolvedState.frozen = false;
	
	        // If freezeWhenExpanded is set, check for frozen conditions
	        if (freezeWhenExpanded) {
	          // if any rows are expanded, freeze the existing data and sorting
	          var keys = Object.keys(newResolvedState.expanded);
	          for (var i = 0; i < keys.length; i += 1) {
	            if (newResolvedState.expanded[keys[i]]) {
	              newResolvedState.frozen = true;
	              break;
	            }
	          }
	        }
	
	        // If the data isn't frozen and either the data or
	        // sorting model has changed, update the data
	        if (oldState.frozen && !newResolvedState.frozen || oldState.sorted !== newResolvedState.sorted || oldState.filtered !== newResolvedState.filtered || oldState.showFilters !== newResolvedState.showFilters || !newResolvedState.frozen && oldState.resolvedData !== newResolvedState.resolvedData) {
	          // Handle collapseOnsortedChange & collapseOnDataChange
	          if (oldState.sorted !== newResolvedState.sorted && this.props.collapseOnSortingChange || oldState.filtered !== newResolvedState.filtered || oldState.showFilters !== newResolvedState.showFilters || oldState.sortedData && !newResolvedState.frozen && oldState.resolvedData !== newResolvedState.resolvedData && this.props.collapseOnDataChange) {
	            newResolvedState.expanded = {};
	          }
	
	          Object.assign(newResolvedState, this.getSortedData(newResolvedState));
	        }
	
	        // Set page to 0 if filters change
	        if (oldState.filtered !== newResolvedState.filtered) {
	          newResolvedState.page = 0;
	        }
	
	        // Calculate pageSize all the time
	        if (newResolvedState.sortedData) {
	          newResolvedState.pages = newResolvedState.manual ? newResolvedState.pages : Math.ceil(newResolvedState.sortedData.length / newResolvedState.pageSize);
	          newResolvedState.page = Math.max(newResolvedState.page >= newResolvedState.pages ? newResolvedState.pages - 1 : newResolvedState.page, 0);
	        }
	
	        return this.setState(newResolvedState, function () {
	          if (cb) {
	            cb();
	          }
	          if (oldState.page !== newResolvedState.page || oldState.pageSize !== newResolvedState.pageSize || oldState.sorted !== newResolvedState.sorted || oldState.filtered !== newResolvedState.filtered) {
	            _this2.fireFetchData();
	          }
	        });
	      }
	    }]);
	
	    return _class;
	  }(Base);
	};
	//# sourceMappingURL=data:application/json;base64,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

/***/ }),
/* 2923 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utils = __webpack_require__(2921);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	exports.default = function (Base) {
	  return function (_Base) {
	    _inherits(_class, _Base);
	
	    function _class() {
	      _classCallCheck(this, _class);
	
	      return _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));
	    }
	
	    _createClass(_class, [{
	      key: 'getResolvedState',
	      value: function getResolvedState(props, state) {
	        var resolvedState = _extends({}, _utils2.default.compactObject(this.state), _utils2.default.compactObject(this.props), _utils2.default.compactObject(state), _utils2.default.compactObject(props));
	        return resolvedState;
	      }
	    }, {
	      key: 'getDataModel',
	      value: function getDataModel(newState, dataChanged) {
	        var _this2 = this;
	
	        var columns = newState.columns,
	            _newState$pivotBy = newState.pivotBy,
	            pivotBy = _newState$pivotBy === undefined ? [] : _newState$pivotBy,
	            data = newState.data,
	            resolveData = newState.resolveData,
	            pivotIDKey = newState.pivotIDKey,
	            pivotValKey = newState.pivotValKey,
	            subRowsKey = newState.subRowsKey,
	            aggregatedKey = newState.aggregatedKey,
	            nestingLevelKey = newState.nestingLevelKey,
	            originalKey = newState.originalKey,
	            indexKey = newState.indexKey,
	            groupedByPivotKey = newState.groupedByPivotKey,
	            SubComponent = newState.SubComponent;
	
	        // Determine Header Groups
	
	        var hasHeaderGroups = false;
	        columns.forEach(function (column) {
	          if (column.columns) {
	            hasHeaderGroups = true;
	          }
	        });
	
	        var columnsWithExpander = [].concat(_toConsumableArray(columns));
	
	        var expanderColumn = columns.find(function (col) {
	          return col.expander || col.columns && col.columns.some(function (col2) {
	            return col2.expander;
	          });
	        });
	        // The actual expander might be in the columns field of a group column
	        if (expanderColumn && !expanderColumn.expander) {
	          expanderColumn = expanderColumn.columns.find(function (col) {
	            return col.expander;
	          });
	        }
	
	        // If we have SubComponent's we need to make sure we have an expander column
	        if (SubComponent && !expanderColumn) {
	          expanderColumn = { expander: true };
	          columnsWithExpander = [expanderColumn].concat(_toConsumableArray(columnsWithExpander));
	        }
	
	        var makeDecoratedColumn = function makeDecoratedColumn(column, parentColumn) {
	          var dcol = void 0;
	          if (column.expander) {
	            dcol = _extends({}, _this2.props.column, _this2.props.expanderDefaults, column);
	          } else {
	            dcol = _extends({}, _this2.props.column, column);
	          }
	
	          // Ensure minWidth is not greater than maxWidth if set
	          if (dcol.maxWidth < dcol.minWidth) {
	            dcol.minWidth = dcol.maxWidth;
	          }
	
	          if (parentColumn) {
	            dcol.parentColumn = parentColumn;
	          }
	
	          // First check for string accessor
	          if (typeof dcol.accessor === 'string') {
	            dcol.id = dcol.id || dcol.accessor;
	            var accessorString = dcol.accessor;
	            dcol.accessor = function (row) {
	              return _utils2.default.get(row, accessorString);
	            };
	            return dcol;
	          }
	
	          // Fall back to functional accessor (but require an ID)
	          if (dcol.accessor && !dcol.id) {
	            console.warn(dcol);
	            throw new Error('A column id is required if using a non-string accessor for column above.');
	          }
	
	          // Fall back to an undefined accessor
	          if (!dcol.accessor) {
	            dcol.accessor = function () {
	              return undefined;
	            };
	          }
	
	          return dcol;
	        };
	
	        var allDecoratedColumns = [];
	
	        // Decorate the columns
	        var decorateAndAddToAll = function decorateAndAddToAll(column, parentColumn) {
	          var decoratedColumn = makeDecoratedColumn(column, parentColumn);
	          allDecoratedColumns.push(decoratedColumn);
	          return decoratedColumn;
	        };
	
	        var decoratedColumns = columnsWithExpander.map(function (column) {
	          if (column.columns) {
	            return _extends({}, column, {
	              columns: column.columns.map(function (d) {
	                return decorateAndAddToAll(d, column);
	              })
	            });
	          }
	          return decorateAndAddToAll(column);
	        });
	
	        // Build the visible columns, headers and flat column list
	        var visibleColumns = decoratedColumns.slice();
	        var allVisibleColumns = [];
	
	        visibleColumns = visibleColumns.map(function (column) {
	          if (column.columns) {
	            var visibleSubColumns = column.columns.filter(function (d) {
	              return pivotBy.indexOf(d.id) > -1 ? false : _utils2.default.getFirstDefined(d.show, true);
	            });
	            return _extends({}, column, {
	              columns: visibleSubColumns
	            });
	          }
	          return column;
	        });
	
	        visibleColumns = visibleColumns.filter(function (column) {
	          return column.columns ? column.columns.length : pivotBy.indexOf(column.id) > -1 ? false : _utils2.default.getFirstDefined(column.show, true);
	        });
	
	        // Find any custom pivot location
	        var pivotIndex = visibleColumns.findIndex(function (col) {
	          return col.pivot;
	        });
	
	        // Handle Pivot Columns
	        if (pivotBy.length) {
	          // Retrieve the pivot columns in the correct pivot order
	          var pivotColumns = [];
	          pivotBy.forEach(function (pivotID) {
	            var found = allDecoratedColumns.find(function (d) {
	              return d.id === pivotID;
	            });
	            if (found) {
	              pivotColumns.push(found);
	            }
	          });
	
	          var PivotParentColumn = pivotColumns.reduce(function (prev, current) {
	            return prev && prev === current.parentColumn && current.parentColumn;
	          }, pivotColumns[0].parentColumn);
	
	          var PivotGroupHeader = hasHeaderGroups && PivotParentColumn.Header;
	          PivotGroupHeader = PivotGroupHeader || function () {
	            return _react2.default.createElement(
	              'strong',
	              null,
	              'Pivoted'
	            );
	          };
	
	          var pivotColumnGroup = {
	            Header: PivotGroupHeader,
	            columns: pivotColumns.map(function (col) {
	              return _extends({}, _this2.props.pivotDefaults, col, {
	                pivoted: true
	              });
	            })
	
	            // Place the pivotColumns back into the visibleColumns
	          };if (pivotIndex >= 0) {
	            pivotColumnGroup = _extends({}, visibleColumns[pivotIndex], pivotColumnGroup);
	            visibleColumns.splice(pivotIndex, 1, pivotColumnGroup);
	          } else {
	            visibleColumns.unshift(pivotColumnGroup);
	          }
	        }
	
	        // Build Header Groups
	        var headerGroups = [];
	        var currentSpan = [];
	
	        // A convenience function to add a header and reset the currentSpan
	        var addHeader = function addHeader(columns, column) {
	          headerGroups.push(_extends({}, _this2.props.column, column, {
	            columns: columns
	          }));
	          currentSpan = [];
	        };
	
	        // Build flast list of allVisibleColumns and HeaderGroups
	        visibleColumns.forEach(function (column) {
	          if (column.columns) {
	            allVisibleColumns = allVisibleColumns.concat(column.columns);
	            if (currentSpan.length > 0) {
	              addHeader(currentSpan);
	            }
	            addHeader(column.columns, column);
	            return;
	          }
	          allVisibleColumns.push(column);
	          currentSpan.push(column);
	        });
	        if (hasHeaderGroups && currentSpan.length > 0) {
	          addHeader(currentSpan);
	        }
	
	        // Access the data
	        var accessRow = function accessRow(d, i) {
	          var _row;
	
	          var level = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
	
	          var row = (_row = {}, _defineProperty(_row, originalKey, d), _defineProperty(_row, indexKey, i), _defineProperty(_row, subRowsKey, d[subRowsKey]), _defineProperty(_row, nestingLevelKey, level), _row);
	          allDecoratedColumns.forEach(function (column) {
	            if (column.expander) return;
	            row[column.id] = column.accessor(d);
	          });
	          if (row[subRowsKey]) {
	            row[subRowsKey] = row[subRowsKey].map(function (d, i) {
	              return accessRow(d, i, level + 1);
	            });
	          }
	          return row;
	        };
	
	        // // If the data hasn't changed, just use the cached data
	        var resolvedData = this.resolvedData;
	        // If the data has changed, run the data resolver and cache the result
	        if (!this.resolvedData || dataChanged) {
	          resolvedData = resolveData(data);
	          this.resolvedData = resolvedData;
	        }
	        // Use the resolved data
	        resolvedData = resolvedData.map(function (d, i) {
	          return accessRow(d, i);
	        });
	
	        // TODO: Make it possible to fabricate nested rows without pivoting
	        var aggregatingColumns = allVisibleColumns.filter(function (d) {
	          return !d.expander && d.aggregate;
	        });
	
	        // If pivoting, recursively group the data
	        var aggregate = function aggregate(rows) {
	          var aggregationValues = {};
	          aggregatingColumns.forEach(function (column) {
	            var values = rows.map(function (d) {
	              return d[column.id];
	            });
	            aggregationValues[column.id] = column.aggregate(values, rows);
	          });
	          return aggregationValues;
	        };
	        if (pivotBy.length) {
	          var groupRecursively = function groupRecursively(rows, keys) {
	            var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
	
	            // This is the last level, just return the rows
	            if (i === keys.length) {
	              return rows;
	            }
	            // Group the rows together for this level
	            var groupedRows = Object.entries(_utils2.default.groupBy(rows, keys[i])).map(function (_ref) {
	              var _ref3;
	
	              var _ref2 = _slicedToArray(_ref, 2),
	                  key = _ref2[0],
	                  value = _ref2[1];
	
	              return _ref3 = {}, _defineProperty(_ref3, pivotIDKey, keys[i]), _defineProperty(_ref3, pivotValKey, key), _defineProperty(_ref3, keys[i], key), _defineProperty(_ref3, subRowsKey, value), _defineProperty(_ref3, nestingLevelKey, i), _defineProperty(_ref3, groupedByPivotKey, true), _ref3;
	            });
	            // Recurse into the subRows
	            groupedRows = groupedRows.map(function (rowGroup) {
	              var _extends2;
	
	              var subRows = groupRecursively(rowGroup[subRowsKey], keys, i + 1);
	              return _extends({}, rowGroup, (_extends2 = {}, _defineProperty(_extends2, subRowsKey, subRows), _defineProperty(_extends2, aggregatedKey, true), _extends2), aggregate(subRows));
	            });
	            return groupedRows;
	          };
	          resolvedData = groupRecursively(resolvedData, pivotBy);
	        }
	
	        return _extends({}, newState, {
	          resolvedData: resolvedData,
	          allVisibleColumns: allVisibleColumns,
	          headerGroups: headerGroups,
	          allDecoratedColumns: allDecoratedColumns,
	          hasHeaderGroups: hasHeaderGroups
	        });
	      }
	    }, {
	      key: 'getSortedData',
	      value: function getSortedData(resolvedState) {
	        var manual = resolvedState.manual,
	            sorted = resolvedState.sorted,
	            filtered = resolvedState.filtered,
	            defaultFilterMethod = resolvedState.defaultFilterMethod,
	            resolvedData = resolvedState.resolvedData,
	            allVisibleColumns = resolvedState.allVisibleColumns,
	            allDecoratedColumns = resolvedState.allDecoratedColumns;
	
	
	        var sortMethodsByColumnID = {};
	
	        allDecoratedColumns.filter(function (col) {
	          return col.sortMethod;
	        }).forEach(function (col) {
	          sortMethodsByColumnID[col.id] = col.sortMethod;
	        });
	
	        // Resolve the data from either manual data or sorted data
	        return {
	          sortedData: manual ? resolvedData : this.sortData(this.filterData(resolvedData, filtered, defaultFilterMethod, allVisibleColumns), sorted, sortMethodsByColumnID)
	        };
	      }
	    }, {
	      key: 'fireFetchData',
	      value: function fireFetchData() {
	        this.props.onFetchData(this.getResolvedState(), this);
	      }
	    }, {
	      key: 'getPropOrState',
	      value: function getPropOrState(key) {
	        return _utils2.default.getFirstDefined(this.props[key], this.state[key]);
	      }
	    }, {
	      key: 'getStateOrProp',
	      value: function getStateOrProp(key) {
	        return _utils2.default.getFirstDefined(this.state[key], this.props[key]);
	      }
	    }, {
	      key: 'filterData',
	      value: function filterData(data, filtered, defaultFilterMethod, allVisibleColumns) {
	        var _this3 = this;
	
	        var filteredData = data;
	
	        if (filtered.length) {
	          filteredData = filtered.reduce(function (filteredSoFar, nextFilter) {
	            var column = allVisibleColumns.find(function (x) {
	              return x.id === nextFilter.id;
	            });
	
	            // Don't filter hidden columns or columns that have had their filters disabled
	            if (!column || column.filterable === false) {
	              return filteredSoFar;
	            }
	
	            var filterMethod = column.filterMethod || defaultFilterMethod;
	
	            // If 'filterAll' is set to true, pass the entire dataset to the filter method
	            if (column.filterAll) {
	              return filterMethod(nextFilter, filteredSoFar, column);
	            }
	            return filteredSoFar.filter(function (row) {
	              return filterMethod(nextFilter, row, column);
	            });
	          }, filteredData);
	
	          // Apply the filter to the subrows if we are pivoting, and then
	          // filter any rows without subcolumns because it would be strange to show
	          filteredData = filteredData.map(function (row) {
	            if (!row[_this3.props.subRowsKey]) {
	              return row;
	            }
	            return _extends({}, row, _defineProperty({}, _this3.props.subRowsKey, _this3.filterData(row[_this3.props.subRowsKey], filtered, defaultFilterMethod, allVisibleColumns)));
	          }).filter(function (row) {
	            if (!row[_this3.props.subRowsKey]) {
	              return true;
	            }
	            return row[_this3.props.subRowsKey].length > 0;
	          });
	        }
	
	        return filteredData;
	      }
	    }, {
	      key: 'sortData',
	      value: function sortData(data, sorted) {
	        var _this4 = this;
	
	        var sortMethodsByColumnID = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	        if (!sorted.length) {
	          return data;
	        }
	
	        var sortedData = (this.props.orderByMethod || _utils2.default.orderBy)(data, sorted.map(function (sort) {
	          // Support custom sorting methods for each column
	          if (sortMethodsByColumnID[sort.id]) {
	            return function (a, b) {
	              return sortMethodsByColumnID[sort.id](a[sort.id], b[sort.id], sort.desc);
	            };
	          }
	          return function (a, b) {
	            return _this4.props.defaultSortMethod(a[sort.id], b[sort.id], sort.desc);
	          };
	        }), sorted.map(function (d) {
	          return !d.desc;
	        }), this.props.indexKey);
	
	        sortedData.forEach(function (row) {
	          if (!row[_this4.props.subRowsKey]) {
	            return;
	          }
	          row[_this4.props.subRowsKey] = _this4.sortData(row[_this4.props.subRowsKey], sorted, sortMethodsByColumnID);
	        });
	
	        return sortedData;
	      }
	    }, {
	      key: 'getMinRows',
	      value: function getMinRows() {
	        return _utils2.default.getFirstDefined(this.props.minRows, this.getStateOrProp('pageSize'));
	      }
	
	      // User actions
	
	    }, {
	      key: 'onPageChange',
	      value: function onPageChange(page) {
	        var _props = this.props,
	            onPageChange = _props.onPageChange,
	            collapseOnPageChange = _props.collapseOnPageChange;
	
	
	        var newState = { page: page };
	        if (collapseOnPageChange) {
	          newState.expanded = {};
	        }
	        this.setStateWithData(newState, function () {
	          return onPageChange && onPageChange(page);
	        });
	      }
	    }, {
	      key: 'onPageSizeChange',
	      value: function onPageSizeChange(newPageSize) {
	        var onPageSizeChange = this.props.onPageSizeChange;
	
	        var _getResolvedState = this.getResolvedState(),
	            pageSize = _getResolvedState.pageSize,
	            page = _getResolvedState.page;
	
	        // Normalize the page to display
	
	
	        var currentRow = pageSize * page;
	        var newPage = Math.floor(currentRow / newPageSize);
	
	        this.setStateWithData({
	          pageSize: newPageSize,
	          page: newPage
	        }, function () {
	          return onPageSizeChange && onPageSizeChange(newPageSize, newPage);
	        });
	      }
	    }, {
	      key: 'sortColumn',
	      value: function sortColumn(column, additive) {
	        var _getResolvedState2 = this.getResolvedState(),
	            sorted = _getResolvedState2.sorted,
	            skipNextSort = _getResolvedState2.skipNextSort,
	            defaultSortDesc = _getResolvedState2.defaultSortDesc;
	
	        var firstSortDirection = Object.prototype.hasOwnProperty.call(column, 'defaultSortDesc') ? column.defaultSortDesc : defaultSortDesc;
	        var secondSortDirection = !firstSortDirection;
	
	        // we can't stop event propagation from the column resize move handlers
	        // attached to the document because of react's synthetic events
	        // so we have to prevent the sort function from actually sorting
	        // if we click on the column resize element within a header.
	        if (skipNextSort) {
	          this.setStateWithData({
	            skipNextSort: false
	          });
	          return;
	        }
	
	        var onSortedChange = this.props.onSortedChange;
	
	
	        var newSorted = _utils2.default.clone(sorted || []).map(function (d) {
	          d.desc = _utils2.default.isSortingDesc(d);
	          return d;
	        });
	        if (!_utils2.default.isArray(column)) {
	          // Single-Sort
	          var existingIndex = newSorted.findIndex(function (d) {
	            return d.id === column.id;
	          });
	          if (existingIndex > -1) {
	            var existing = newSorted[existingIndex];
	            if (existing.desc === secondSortDirection) {
	              if (additive) {
	                newSorted.splice(existingIndex, 1);
	              } else {
	                existing.desc = firstSortDirection;
	                newSorted = [existing];
	              }
	            } else {
	              existing.desc = secondSortDirection;
	              if (!additive) {
	                newSorted = [existing];
	              }
	            }
	          } else if (additive) {
	            newSorted.push({
	              id: column.id,
	              desc: firstSortDirection
	            });
	          } else {
	            newSorted = [{
	              id: column.id,
	              desc: firstSortDirection
	            }];
	          }
	        } else {
	          // Multi-Sort
	          var _existingIndex = newSorted.findIndex(function (d) {
	            return d.id === column[0].id;
	          });
	          // Existing Sorted Column
	          if (_existingIndex > -1) {
	            var _existing = newSorted[_existingIndex];
	            if (_existing.desc === secondSortDirection) {
	              if (additive) {
	                newSorted.splice(_existingIndex, column.length);
	              } else {
	                column.forEach(function (d, i) {
	                  newSorted[_existingIndex + i].desc = firstSortDirection;
	                });
	              }
	            } else {
	              column.forEach(function (d, i) {
	                newSorted[_existingIndex + i].desc = secondSortDirection;
	              });
	            }
	            if (!additive) {
	              newSorted = newSorted.slice(_existingIndex, column.length);
	            }
	            // New Sort Column
	          } else if (additive) {
	            newSorted = newSorted.concat(column.map(function (d) {
	              return {
	                id: d.id,
	                desc: firstSortDirection
	              };
	            }));
	          } else {
	            newSorted = column.map(function (d) {
	              return {
	                id: d.id,
	                desc: firstSortDirection
	              };
	            });
	          }
	        }
	
	        this.setStateWithData({
	          page: !sorted.length && newSorted.length || !additive ? 0 : this.state.page,
	          sorted: newSorted
	        }, function () {
	          return onSortedChange && onSortedChange(newSorted, column, additive);
	        });
	      }
	    }, {
	      key: 'filterColumn',
	      value: function filterColumn(column, value) {
	        var _getResolvedState3 = this.getResolvedState(),
	            filtered = _getResolvedState3.filtered;
	
	        var onFilteredChange = this.props.onFilteredChange;
	
	        // Remove old filter first if it exists
	
	        var newFiltering = (filtered || []).filter(function (x) {
	          return x.id !== column.id;
	        });
	
	        if (value !== '') {
	          newFiltering.push({
	            id: column.id,
	            value: value
	          });
	        }
	
	        this.setStateWithData({
	          filtered: newFiltering
	        }, function () {
	          return onFilteredChange && onFilteredChange(newFiltering, column, value);
	        });
	      }
	    }, {
	      key: 'resizeColumnStart',
	      value: function resizeColumnStart(event, column, isTouch) {
	        var _this5 = this;
	
	        event.stopPropagation();
	        var parentWidth = event.target.parentElement.getBoundingClientRect().width;
	
	        var pageX = void 0;
	        if (isTouch) {
	          pageX = event.changedTouches[0].pageX;
	        } else {
	          pageX = event.pageX;
	        }
	
	        this.trapEvents = true;
	        this.setStateWithData({
	          currentlyResizing: {
	            id: column.id,
	            startX: pageX,
	            parentWidth: parentWidth
	          }
	        }, function () {
	          if (isTouch) {
	            document.addEventListener('touchmove', _this5.resizeColumnMoving);
	            document.addEventListener('touchcancel', _this5.resizeColumnEnd);
	            document.addEventListener('touchend', _this5.resizeColumnEnd);
	          } else {
	            document.addEventListener('mousemove', _this5.resizeColumnMoving);
	            document.addEventListener('mouseup', _this5.resizeColumnEnd);
	            document.addEventListener('mouseleave', _this5.resizeColumnEnd);
	          }
	        });
	      }
	    }, {
	      key: 'resizeColumnMoving',
	      value: function resizeColumnMoving(event) {
	        event.stopPropagation();
	        var onResizedChange = this.props.onResizedChange;
	
	        var _getResolvedState4 = this.getResolvedState(),
	            resized = _getResolvedState4.resized,
	            currentlyResizing = _getResolvedState4.currentlyResizing;
	
	        // Delete old value
	
	
	        var newResized = resized.filter(function (x) {
	          return x.id !== currentlyResizing.id;
	        });
	
	        var pageX = void 0;
	
	        if (event.type === 'touchmove') {
	          pageX = event.changedTouches[0].pageX;
	        } else if (event.type === 'mousemove') {
	          pageX = event.pageX;
	        }
	
	        // Set the min size to 10 to account for margin and border or else the
	        // group headers don't line up correctly
	        var newWidth = Math.max(currentlyResizing.parentWidth + pageX - currentlyResizing.startX, 11);
	
	        newResized.push({
	          id: currentlyResizing.id,
	          value: newWidth
	        });
	
	        this.setStateWithData({
	          resized: newResized
	        }, function () {
	          return onResizedChange && onResizedChange(newResized, event);
	        });
	      }
	    }, {
	      key: 'resizeColumnEnd',
	      value: function resizeColumnEnd(event) {
	        event.stopPropagation();
	        var isTouch = event.type === 'touchend' || event.type === 'touchcancel';
	
	        if (isTouch) {
	          document.removeEventListener('touchmove', this.resizeColumnMoving);
	          document.removeEventListener('touchcancel', this.resizeColumnEnd);
	          document.removeEventListener('touchend', this.resizeColumnEnd);
	        }
	
	        // If its a touch event clear the mouse one's as well because sometimes
	        // the mouseDown event gets called as well, but the mouseUp event doesn't
	        document.removeEventListener('mousemove', this.resizeColumnMoving);
	        document.removeEventListener('mouseup', this.resizeColumnEnd);
	        document.removeEventListener('mouseleave', this.resizeColumnEnd);
	
	        // The touch events don't propagate up to the sorting's onMouseDown event so
	        // no need to prevent it from happening or else the first click after a touch
	        // event resize will not sort the column.
	        if (!isTouch) {
	          this.setStateWithData({
	            skipNextSort: true,
	            currentlyResizing: false
	          });
	        }
	      }
	    }]);
	
	    return _class;
	  }(Base);
	};
	//# sourceMappingURL=data:application/json;base64,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

/***/ }),
/* 2924 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(958);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _utils = __webpack_require__(2921);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	var _pagination = __webpack_require__(2925);
	
	var _pagination2 = _interopRequireDefault(_pagination);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	//
	
	
	var emptyObj = function emptyObj() {
	  return {};
	};
	
	exports.default = {
	  // General
	  data: [],
	  resolveData: function resolveData(data) {
	    return data;
	  },
	  loading: false,
	  showPagination: true,
	  showPaginationTop: false,
	  showPaginationBottom: true,
	  showPageSizeOptions: true,
	  pageSizeOptions: [5, 10, 20, 25, 50, 100],
	  defaultPageSize: 20,
	  showPageJump: true,
	  collapseOnSortingChange: true,
	  collapseOnPageChange: true,
	  collapseOnDataChange: true,
	  freezeWhenExpanded: false,
	  sortable: true,
	  multiSort: true,
	  resizable: true,
	  filterable: false,
	  defaultSortDesc: false,
	  defaultSorted: [],
	  defaultFiltered: [],
	  defaultResized: [],
	  defaultExpanded: {},
	  // eslint-disable-next-line no-unused-vars
	  defaultFilterMethod: function defaultFilterMethod(filter, row, column) {
	    var id = filter.pivotId || filter.id;
	    return row[id] !== undefined ? String(row[id]).startsWith(filter.value) : true;
	  },
	  // eslint-disable-next-line no-unused-vars
	  defaultSortMethod: function defaultSortMethod(a, b, desc) {
	    // force null and undefined to the bottom
	    a = a === null || a === undefined ? '' : a;
	    b = b === null || b === undefined ? '' : b;
	    // force any string values to lowercase
	    a = typeof a === 'string' ? a.toLowerCase() : a;
	    b = typeof b === 'string' ? b.toLowerCase() : b;
	    // Return either 1 or -1 to indicate a sort priority
	    if (a > b) {
	      return 1;
	    }
	    if (a < b) {
	      return -1;
	    }
	    // returning 0, undefined or any falsey value will use subsequent sorts or
	    // the index as a tiebreaker
	    return 0;
	  },
	
	  // Controlled State Props
	  // page: undefined,
	  // pageSize: undefined,
	  // sorted: [],
	  // filtered: [],
	  // resized: [],
	  // expanded: {},
	
	  // Controlled State Callbacks
	  onPageChange: undefined,
	  onPageSizeChange: undefined,
	  onSortedChange: undefined,
	  onFilteredChange: undefined,
	  onResizedChange: undefined,
	  onExpandedChange: undefined,
	
	  // Pivoting
	  pivotBy: undefined,
	
	  // Key Constants
	  pivotValKey: '_pivotVal',
	  pivotIDKey: '_pivotID',
	  subRowsKey: '_subRows',
	  aggregatedKey: '_aggregated',
	  nestingLevelKey: '_nestingLevel',
	  originalKey: '_original',
	  indexKey: '_index',
	  groupedByPivotKey: '_groupedByPivot',
	
	  // Server-side Callbacks
	  onFetchData: function onFetchData() {
	    return null;
	  },
	
	  // Classes
	  className: '',
	  style: {},
	
	  // Component decorators
	  getProps: emptyObj,
	  getTableProps: emptyObj,
	  getTheadGroupProps: emptyObj,
	  getTheadGroupTrProps: emptyObj,
	  getTheadGroupThProps: emptyObj,
	  getTheadProps: emptyObj,
	  getTheadTrProps: emptyObj,
	  getTheadThProps: emptyObj,
	  getTheadFilterProps: emptyObj,
	  getTheadFilterTrProps: emptyObj,
	  getTheadFilterThProps: emptyObj,
	  getTbodyProps: emptyObj,
	  getTrGroupProps: emptyObj,
	  getTrProps: emptyObj,
	  getTdProps: emptyObj,
	  getTfootProps: emptyObj,
	  getTfootTrProps: emptyObj,
	  getTfootTdProps: emptyObj,
	  getPaginationProps: emptyObj,
	  getLoadingProps: emptyObj,
	  getNoDataProps: emptyObj,
	  getResizerProps: emptyObj,
	
	  // Global Column Defaults
	  column: {
	    // Renderers
	    Cell: undefined,
	    Header: undefined,
	    Footer: undefined,
	    Aggregated: undefined,
	    Pivot: undefined,
	    PivotValue: undefined,
	    Expander: undefined,
	    Filter: undefined,
	    // All Columns
	    sortable: undefined, // use table default
	    resizable: undefined, // use table default
	    filterable: undefined, // use table default
	    show: true,
	    minWidth: 100,
	    // Cells only
	    className: '',
	    style: {},
	    getProps: emptyObj,
	    // Pivot only
	    aggregate: undefined,
	    // Headers only
	    headerClassName: '',
	    headerStyle: {},
	    getHeaderProps: emptyObj,
	    // Footers only
	    footerClassName: '',
	    footerStyle: {},
	    getFooterProps: emptyObj,
	    filterMethod: undefined,
	    filterAll: false,
	    sortMethod: undefined
	  },
	
	  // Global Expander Column Defaults
	  expanderDefaults: {
	    sortable: false,
	    resizable: false,
	    filterable: false,
	    width: 35
	  },
	
	  pivotDefaults: {
	    // extend the defaults for pivoted columns here
	  },
	
	  // Text
	  previousText: 'Previous',
	  nextText: 'Next',
	  loadingText: 'Loading...',
	  noDataText: 'No rows found',
	  pageText: 'Page',
	  ofText: 'of',
	  rowsText: 'rows',
	
	  // Components
	  TableComponent: function TableComponent(_ref) {
	    var children = _ref.children,
	        className = _ref.className,
	        rest = _objectWithoutProperties(_ref, ['children', 'className']);
	
	    return _react2.default.createElement(
	      'div',
	      _extends({
	        className: (0, _classnames2.default)('rt-table', className),
	        role: 'grid'
	        // tabIndex='0'
	      }, rest),
	      children
	    );
	  },
	  TheadComponent: _utils2.default.makeTemplateComponent('rt-thead', 'Thead'),
	  TbodyComponent: _utils2.default.makeTemplateComponent('rt-tbody', 'Tbody'),
	  TrGroupComponent: function TrGroupComponent(_ref2) {
	    var children = _ref2.children,
	        className = _ref2.className,
	        rest = _objectWithoutProperties(_ref2, ['children', 'className']);
	
	    return _react2.default.createElement(
	      'div',
	      _extends({ className: (0, _classnames2.default)('rt-tr-group', className), role: 'rowgroup' }, rest),
	      children
	    );
	  },
	  TrComponent: function TrComponent(_ref3) {
	    var children = _ref3.children,
	        className = _ref3.className,
	        rest = _objectWithoutProperties(_ref3, ['children', 'className']);
	
	    return _react2.default.createElement(
	      'div',
	      _extends({ className: (0, _classnames2.default)('rt-tr', className), role: 'row' }, rest),
	      children
	    );
	  },
	  ThComponent: function ThComponent(_ref4) {
	    var toggleSort = _ref4.toggleSort,
	        className = _ref4.className,
	        children = _ref4.children,
	        rest = _objectWithoutProperties(_ref4, ['toggleSort', 'className', 'children']);
	
	    return (
	      // eslint-disable-next-line jsx-a11y/click-events-have-key-events
	      _react2.default.createElement(
	        'div',
	        _extends({
	          className: (0, _classnames2.default)('rt-th', className),
	          onClick: function onClick(e) {
	            return toggleSort && toggleSort(e);
	          },
	          role: 'columnheader',
	          tabIndex: '-1' // Resolves eslint issues without implementing keyboard navigation incorrectly
	        }, rest),
	        children
	      )
	    );
	  },
	  TdComponent: function TdComponent(_ref5) {
	    var toggleSort = _ref5.toggleSort,
	        className = _ref5.className,
	        children = _ref5.children,
	        rest = _objectWithoutProperties(_ref5, ['toggleSort', 'className', 'children']);
	
	    return _react2.default.createElement(
	      'div',
	      _extends({ className: (0, _classnames2.default)('rt-td', className), role: 'gridcell' }, rest),
	      children
	    );
	  },
	  TfootComponent: _utils2.default.makeTemplateComponent('rt-tfoot', 'Tfoot'),
	  FilterComponent: function FilterComponent(_ref6) {
	    var filter = _ref6.filter,
	        _onChange = _ref6.onChange;
	    return _react2.default.createElement('input', {
	      type: 'text',
	      style: {
	        width: '100%'
	      },
	      value: filter ? filter.value : '',
	      onChange: function onChange(event) {
	        return _onChange(event.target.value);
	      }
	    });
	  },
	  ExpanderComponent: function ExpanderComponent(_ref7) {
	    var isExpanded = _ref7.isExpanded;
	    return _react2.default.createElement(
	      'div',
	      { className: (0, _classnames2.default)('rt-expander', isExpanded && '-open') },
	      '\u2022'
	    );
	  },
	  PivotValueComponent: function PivotValueComponent(_ref8) {
	    var subRows = _ref8.subRows,
	        value = _ref8.value;
	    return _react2.default.createElement(
	      'span',
	      null,
	      value,
	      ' ',
	      subRows && '(' + subRows.length + ')'
	    );
	  },
	  AggregatedComponent: function AggregatedComponent(_ref9) {
	    var subRows = _ref9.subRows,
	        column = _ref9.column;
	
	    var previewValues = subRows.filter(function (d) {
	      return typeof d[column.id] !== 'undefined';
	    }).map(function (row, i) {
	      return (
	        // eslint-disable-next-line react/no-array-index-key
	        _react2.default.createElement(
	          'span',
	          { key: i },
	          row[column.id],
	          i < subRows.length - 1 ? ', ' : ''
	        )
	      );
	    });
	    return _react2.default.createElement(
	      'span',
	      null,
	      previewValues
	    );
	  },
	  PivotComponent: undefined, // this is a computed default generated using
	  // the ExpanderComponent and PivotValueComponent at run-time in methods.js
	  PaginationComponent: _pagination2.default,
	  PreviousComponent: undefined,
	  NextComponent: undefined,
	  LoadingComponent: function LoadingComponent(_ref10) {
	    var className = _ref10.className,
	        loading = _ref10.loading,
	        loadingText = _ref10.loadingText,
	        rest = _objectWithoutProperties(_ref10, ['className', 'loading', 'loadingText']);
	
	    return _react2.default.createElement(
	      'div',
	      _extends({ className: (0, _classnames2.default)('-loading', { '-active': loading }, className) }, rest),
	      _react2.default.createElement(
	        'div',
	        { className: '-loading-inner' },
	        loadingText
	      )
	    );
	  },
	  NoDataComponent: _utils2.default.makeTemplateComponent('rt-noData', 'NoData'),
	  ResizerComponent: _utils2.default.makeTemplateComponent('rt-resizer', 'Resizer'),
	  PadRowComponent: function PadRowComponent() {
	    return _react2.default.createElement(
	      'span',
	      null,
	      '\xA0'
	    );
	  }
	};
	//# sourceMappingURL=data:application/json;base64,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

/***/ }),
/* 2925 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(958);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	//
	// import _ from './utils'
	
	var defaultButton = function defaultButton(props) {
	  return _react2.default.createElement(
	    'button',
	    _extends({ type: 'button' }, props, { className: '-btn' }),
	    props.children
	  );
	};
	
	var ReactTablePagination = function (_Component) {
	  _inherits(ReactTablePagination, _Component);
	
	  function ReactTablePagination(props) {
	    _classCallCheck(this, ReactTablePagination);
	
	    var _this = _possibleConstructorReturn(this, (ReactTablePagination.__proto__ || Object.getPrototypeOf(ReactTablePagination)).call(this));
	
	    _this.getSafePage = _this.getSafePage.bind(_this);
	    _this.changePage = _this.changePage.bind(_this);
	    _this.applyPage = _this.applyPage.bind(_this);
	
	    _this.state = {
	      page: props.page
	    };
	    return _this;
	  }
	
	  _createClass(ReactTablePagination, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      this.setState({ page: nextProps.page });
	    }
	  }, {
	    key: 'getSafePage',
	    value: function getSafePage(page) {
	      if (Number.isNaN(page)) {
	        page = this.props.page;
	      }
	      return Math.min(Math.max(page, 0), this.props.pages - 1);
	    }
	  }, {
	    key: 'changePage',
	    value: function changePage(page) {
	      page = this.getSafePage(page);
	      this.setState({ page: page });
	      if (this.props.page !== page) {
	        this.props.onPageChange(page);
	      }
	    }
	  }, {
	    key: 'applyPage',
	    value: function applyPage(e) {
	      if (e) {
	        e.preventDefault();
	      }
	      var page = this.state.page;
	      this.changePage(page === '' ? this.props.page : page);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          pages = _props.pages,
	          page = _props.page,
	          showPageSizeOptions = _props.showPageSizeOptions,
	          pageSizeOptions = _props.pageSizeOptions,
	          pageSize = _props.pageSize,
	          showPageJump = _props.showPageJump,
	          canPrevious = _props.canPrevious,
	          canNext = _props.canNext,
	          onPageSizeChange = _props.onPageSizeChange,
	          className = _props.className,
	          _props$PreviousCompon = _props.PreviousComponent,
	          PreviousComponent = _props$PreviousCompon === undefined ? defaultButton : _props$PreviousCompon,
	          _props$NextComponent = _props.NextComponent,
	          NextComponent = _props$NextComponent === undefined ? defaultButton : _props$NextComponent;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)(className, '-pagination'), style: this.props.style },
	        _react2.default.createElement(
	          'div',
	          { className: '-previous' },
	          _react2.default.createElement(
	            PreviousComponent,
	            {
	              onClick: function onClick() {
	                if (!canPrevious) return;
	                _this2.changePage(page - 1);
	              },
	              disabled: !canPrevious
	            },
	            this.props.previousText
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: '-center' },
	          _react2.default.createElement(
	            'span',
	            { className: '-pageInfo' },
	            this.props.pageText,
	            ' ',
	            showPageJump ? _react2.default.createElement(
	              'div',
	              { className: '-pageJump' },
	              _react2.default.createElement('input', {
	                type: this.state.page === '' ? 'text' : 'number',
	                onChange: function onChange(e) {
	                  var val = e.target.value;
	                  var page = val - 1;
	                  if (val === '') {
	                    return _this2.setState({ page: val });
	                  }
	                  _this2.setState({ page: _this2.getSafePage(page) });
	                },
	                value: this.state.page === '' ? '' : this.state.page + 1,
	                onBlur: this.applyPage,
	                onKeyPress: function onKeyPress(e) {
	                  if (e.which === 13 || e.keyCode === 13) {
	                    _this2.applyPage();
	                  }
	                }
	              })
	            ) : _react2.default.createElement(
	              'span',
	              { className: '-currentPage' },
	              page + 1
	            ),
	            ' ',
	            this.props.ofText,
	            ' ',
	            _react2.default.createElement(
	              'span',
	              { className: '-totalPages' },
	              pages || 1
	            )
	          ),
	          showPageSizeOptions && _react2.default.createElement(
	            'span',
	            { className: 'select-wrap -pageSizeOptions' },
	            _react2.default.createElement(
	              'select',
	              { onChange: function onChange(e) {
	                  return onPageSizeChange(Number(e.target.value));
	                }, value: pageSize },
	              pageSizeOptions.map(function (option, i) {
	                return (
	                  // eslint-disable-next-line react/no-array-index-key
	                  _react2.default.createElement(
	                    'option',
	                    { key: i, value: option },
	                    option,
	                    ' ',
	                    _this2.props.rowsText
	                  )
	                );
	              })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: '-next' },
	          _react2.default.createElement(
	            NextComponent,
	            {
	              onClick: function onClick() {
	                if (!canNext) return;
	                _this2.changePage(page + 1);
	              },
	              disabled: !canNext
	            },
	            this.props.nextText
	          )
	        )
	      );
	    }
	  }]);
	
	  return ReactTablePagination;
	}(_react.Component);
	
	exports.default = ReactTablePagination;
	//# sourceMappingURL=data:application/json;base64,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

/***/ }),
/* 2926 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _propTypes = __webpack_require__(956);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  // General
	  data: _propTypes2.default.any,
	  loading: _propTypes2.default.bool,
	  showPagination: _propTypes2.default.bool,
	  showPaginationTop: _propTypes2.default.bool,
	  showPaginationBottom: _propTypes2.default.bool,
	  showPageSizeOptions: _propTypes2.default.bool,
	  pageSizeOptions: _propTypes2.default.array,
	  defaultPageSize: _propTypes2.default.number,
	  showPageJump: _propTypes2.default.bool,
	  collapseOnSortingChange: _propTypes2.default.bool,
	  collapseOnPageChange: _propTypes2.default.bool,
	  collapseOnDataChange: _propTypes2.default.bool,
	  freezeWhenExpanded: _propTypes2.default.bool,
	  sortable: _propTypes2.default.bool,
	  resizable: _propTypes2.default.bool,
	  filterable: _propTypes2.default.bool,
	  defaultSortDesc: _propTypes2.default.bool,
	  defaultSorted: _propTypes2.default.array,
	  defaultFiltered: _propTypes2.default.array,
	  defaultResized: _propTypes2.default.array,
	  defaultExpanded: _propTypes2.default.object,
	  defaultFilterMethod: _propTypes2.default.func,
	  defaultSortMethod: _propTypes2.default.func,
	
	  // Controlled State Callbacks
	  onPageChange: _propTypes2.default.func,
	  onPageSizeChange: _propTypes2.default.func,
	  onSortedChange: _propTypes2.default.func,
	  onFilteredChange: _propTypes2.default.func,
	  onResizedChange: _propTypes2.default.func,
	  onExpandedChange: _propTypes2.default.func,
	
	  // Pivoting
	  pivotBy: _propTypes2.default.array,
	
	  // Key Constants
	  pivotValKey: _propTypes2.default.string,
	  pivotIDKey: _propTypes2.default.string,
	  subRowsKey: _propTypes2.default.string,
	  aggregatedKey: _propTypes2.default.string,
	  nestingLevelKey: _propTypes2.default.string,
	  originalKey: _propTypes2.default.string,
	  indexKey: _propTypes2.default.string,
	  groupedByPivotKey: _propTypes2.default.string,
	
	  // Server-side Callbacks
	  onFetchData: _propTypes2.default.func,
	
	  // Classes
	  className: _propTypes2.default.string,
	  style: _propTypes2.default.object,
	
	  // Component decorators
	  getProps: _propTypes2.default.func,
	  getTableProps: _propTypes2.default.func,
	  getTheadGroupProps: _propTypes2.default.func,
	  getTheadGroupTrProps: _propTypes2.default.func,
	  getTheadGroupThProps: _propTypes2.default.func,
	  getTheadProps: _propTypes2.default.func,
	  getTheadTrProps: _propTypes2.default.func,
	  getTheadThProps: _propTypes2.default.func,
	  getTheadFilterProps: _propTypes2.default.func,
	  getTheadFilterTrProps: _propTypes2.default.func,
	  getTheadFilterThProps: _propTypes2.default.func,
	  getTbodyProps: _propTypes2.default.func,
	  getTrGroupProps: _propTypes2.default.func,
	  getTrProps: _propTypes2.default.func,
	  getTdProps: _propTypes2.default.func,
	  getTfootProps: _propTypes2.default.func,
	  getTfootTrProps: _propTypes2.default.func,
	  getTfootTdProps: _propTypes2.default.func,
	  getPaginationProps: _propTypes2.default.func,
	  getLoadingProps: _propTypes2.default.func,
	  getNoDataProps: _propTypes2.default.func,
	  getResizerProps: _propTypes2.default.func,
	
	  // Global Column Defaults
	  columns: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	    // Renderers
	    Cell: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.string, _propTypes2.default.func]),
	    Header: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.string, _propTypes2.default.func]),
	    Footer: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.string, _propTypes2.default.func]),
	    Aggregated: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.string, _propTypes2.default.func]),
	    Pivot: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.string, _propTypes2.default.func]),
	    PivotValue: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.string, _propTypes2.default.func]),
	    Expander: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.string, _propTypes2.default.func]),
	    Filter: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.func]),
	
	    // All Columns
	    sortable: _propTypes2.default.bool, // use table default
	    resizable: _propTypes2.default.bool, // use table default
	    filterable: _propTypes2.default.bool, // use table default
	    show: _propTypes2.default.bool,
	    minWidth: _propTypes2.default.number,
	
	    // Cells only
	    className: _propTypes2.default.string,
	    style: _propTypes2.default.object,
	    getProps: _propTypes2.default.func,
	
	    // Pivot only
	    aggregate: _propTypes2.default.func,
	
	    // Headers only
	    headerClassName: _propTypes2.default.string,
	    headerStyle: _propTypes2.default.object,
	    getHeaderProps: _propTypes2.default.func,
	
	    // Footers only
	    footerClassName: _propTypes2.default.string,
	    footerStyle: _propTypes2.default.object,
	    getFooterProps: _propTypes2.default.object,
	    filterMethod: _propTypes2.default.func,
	    filterAll: _propTypes2.default.bool,
	    sortMethod: _propTypes2.default.func
	  })),
	
	  // Global Expander Column Defaults
	  expanderDefaults: _propTypes2.default.shape({
	    sortable: _propTypes2.default.bool,
	    resizable: _propTypes2.default.bool,
	    filterable: _propTypes2.default.bool,
	    width: _propTypes2.default.number
	  }),
	
	  pivotDefaults: _propTypes2.default.object,
	
	  // Text
	  previousText: _propTypes2.default.node,
	  nextText: _propTypes2.default.node,
	  loadingText: _propTypes2.default.node,
	  noDataText: _propTypes2.default.node,
	  pageText: _propTypes2.default.node,
	  ofText: _propTypes2.default.node,
	  rowsText: _propTypes2.default.node,
	
	  // Components
	  TableComponent: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.element]),
	  TheadComponent: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.element]),
	  TbodyComponent: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.element]),
	  TrGroupComponent: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.element]),
	  TrComponent: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.element]),
	  ThComponent: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.element]),
	  TdComponent: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.element]),
	  TfootComponent: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.element]),
	  FilterComponent: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.element]),
	  ExpanderComponent: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.element]),
	  PivotValueComponent: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.element]),
	  AggregatedComponent: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.element]),
	  // this is a computed default generated using
	  PivotComponent: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.element]),
	  // the ExpanderComponent and PivotValueComponent at run-time in methods.js
	  PaginationComponent: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.element]),
	  PreviousComponent: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.element]),
	  NextComponent: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.element]),
	  LoadingComponent: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.element]),
	  NoDataComponent: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.element]),
	  ResizerComponent: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.element]),
	  PadRowComponent: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.element])
	};
	//# sourceMappingURL=data:application/json;base64,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

/***/ }),
/* 2927 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(2928);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(1718)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../css-loader/index.js!./react-table.css", function() {
				var newContent = require("!!./../css-loader/index.js!./react-table.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2928 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1717)();
	// imports
	
	
	// module
	exports.push([module.id, ".ReactTable{position:relative;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;border:1px solid rgba(0,0,0,.1)}.ReactTable *{box-sizing:border-box}.ReactTable .rt-table{-ms-flex:auto 1;flex:auto 1;-ms-flex-direction:column;flex-direction:column;-webkit-box-align:stretch;-ms-flex-align:stretch;align-items:stretch;width:100%;border-collapse:collapse;overflow:auto}.ReactTable .rt-table,.ReactTable .rt-thead{-webkit-box-flex:1;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal}.ReactTable .rt-thead{-ms-flex:1 0 auto;flex:1 0 auto;-ms-flex-direction:column;flex-direction:column;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.ReactTable .rt-thead.-headerGroups{background:rgba(0,0,0,.03)}.ReactTable .rt-thead.-filters,.ReactTable .rt-thead.-headerGroups{border-bottom:1px solid rgba(0,0,0,.05)}.ReactTable .rt-thead.-filters input,.ReactTable .rt-thead.-filters select{border:1px solid rgba(0,0,0,.1);background:#fff;padding:5px 7px;font-size:inherit;border-radius:3px;font-weight:400;outline:none}.ReactTable .rt-thead.-filters .rt-th{border-right:1px solid rgba(0,0,0,.02)}.ReactTable .rt-thead.-header{box-shadow:0 2px 15px 0 rgba(0,0,0,.15)}.ReactTable .rt-thead .rt-tr{text-align:center}.ReactTable .rt-thead .rt-td,.ReactTable .rt-thead .rt-th{padding:5px;line-height:normal;position:relative;border-right:1px solid rgba(0,0,0,.05);transition:box-shadow .3s cubic-bezier(.175,.885,.32,1.275);box-shadow:inset 0 0 0 0 transparent}.ReactTable .rt-thead .rt-td.-sort-asc,.ReactTable .rt-thead .rt-th.-sort-asc{box-shadow:inset 0 3px 0 0 rgba(0,0,0,.6)}.ReactTable .rt-thead .rt-td.-sort-desc,.ReactTable .rt-thead .rt-th.-sort-desc{box-shadow:inset 0 -3px 0 0 rgba(0,0,0,.6)}.ReactTable .rt-thead .rt-td.-cursor-pointer,.ReactTable .rt-thead .rt-th.-cursor-pointer{cursor:pointer}.ReactTable .rt-thead .rt-td:last-child,.ReactTable .rt-thead .rt-th:last-child{border-right:0}.ReactTable .rt-thead .rt-resizable-header{overflow:visible}.ReactTable .rt-thead .rt-resizable-header:last-child{overflow:hidden}.ReactTable .rt-thead .rt-resizable-header-content{overflow:hidden;text-overflow:ellipsis}.ReactTable .rt-thead .rt-header-pivot{border-right-color:#f7f7f7}.ReactTable .rt-thead .rt-header-pivot:after,.ReactTable .rt-thead .rt-header-pivot:before{left:100%;top:50%;border:solid transparent;content:\" \";height:0;width:0;position:absolute;pointer-events:none}.ReactTable .rt-thead .rt-header-pivot:after{border-color:hsla(0,0%,100%,0);border-left-color:#fff;border-width:8px;margin-top:-8px}.ReactTable .rt-thead .rt-header-pivot:before{border-color:hsla(0,0%,40%,0);border-left-color:#f7f7f7;border-width:10px;margin-top:-10px}.ReactTable .rt-tbody{-webkit-box-flex:99999;-ms-flex:99999 1 auto;flex:99999 1 auto;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;overflow:auto}.ReactTable .rt-tbody .rt-tr-group{border-bottom:1px solid rgba(0,0,0,.05)}.ReactTable .rt-tbody .rt-tr-group:last-child{border-bottom:0}.ReactTable .rt-tbody .rt-td{border-right:1px solid rgba(0,0,0,.02)}.ReactTable .rt-tbody .rt-td:last-child{border-right:0}.ReactTable .rt-tbody .rt-expandable{cursor:pointer;text-overflow:clip}.ReactTable .rt-tr-group{-webkit-box-flex:1;-ms-flex:1 0 auto;flex:1 0 auto;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-align:stretch;-ms-flex-align:stretch;align-items:stretch}.ReactTable .rt-tr{-webkit-box-flex:1;-ms-flex:1 0 auto;flex:1 0 auto;display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex}.ReactTable .rt-td,.ReactTable .rt-th{-webkit-box-flex:1;-ms-flex:1 0 0px;flex:1 0 0;white-space:nowrap;text-overflow:ellipsis;padding:7px 5px;overflow:hidden;transition:.3s ease;transition-property:width,min-width,padding,opacity}.ReactTable .rt-td.-hidden,.ReactTable .rt-th.-hidden{width:0!important;min-width:0!important;padding:0!important;border:0!important;opacity:0!important}.ReactTable .rt-expander{display:inline-block;position:relative;margin:0;color:transparent;margin:0 10px}.ReactTable .rt-expander:after{content:'';position:absolute;width:0;height:0;top:50%;left:50%;-webkit-transform:translate(-50%,-50%) rotate(-90deg);transform:translate(-50%,-50%) rotate(-90deg);border-left:5.04px solid transparent;border-right:5.04px solid transparent;border-top:7px solid rgba(0,0,0,.8);transition:all .3s cubic-bezier(.175,.885,.32,1.275);cursor:pointer}.ReactTable .rt-expander.-open:after{-webkit-transform:translate(-50%,-50%) rotate(0);transform:translate(-50%,-50%) rotate(0)}.ReactTable .rt-resizer{display:inline-block;position:absolute;width:36px;top:0;bottom:0;right:-18px;cursor:col-resize;z-index:10}.ReactTable .rt-tfoot{-webkit-box-flex:1;-ms-flex:1 0 auto;flex:1 0 auto;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;box-shadow:0 0 15px 0 rgba(0,0,0,.15)}.ReactTable .rt-tfoot .rt-td{border-right:1px solid rgba(0,0,0,.05)}.ReactTable .rt-tfoot .rt-td:last-child{border-right:0}.ReactTable.-striped .rt-tr.-odd{background:rgba(0,0,0,.03)}.ReactTable.-highlight .rt-tbody .rt-tr:not(.-padRow):hover{background:rgba(0,0,0,.05)}.ReactTable .-pagination{z-index:1;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;-webkit-box-align:stretch;-ms-flex-align:stretch;align-items:stretch;-ms-flex-wrap:wrap;flex-wrap:wrap;padding:3px;box-shadow:0 0 15px 0 rgba(0,0,0,.1);border-top:2px solid rgba(0,0,0,.1)}.ReactTable .-pagination input,.ReactTable .-pagination select{border:1px solid rgba(0,0,0,.1);background:#fff;padding:5px 7px;font-size:inherit;border-radius:3px;font-weight:400;outline:none}.ReactTable .-pagination .-btn{-webkit-appearance:none;-moz-appearance:none;appearance:none;display:block;width:100%;height:100%;border:0;border-radius:3px;padding:6px;font-size:1em;color:rgba(0,0,0,.6);background:rgba(0,0,0,.1);transition:all .1s ease;cursor:pointer;outline:none}.ReactTable .-pagination .-btn[disabled]{opacity:.5;cursor:default}.ReactTable .-pagination .-btn:not([disabled]):hover{background:rgba(0,0,0,.3);color:#fff}.ReactTable .-pagination .-next,.ReactTable .-pagination .-previous{-webkit-box-flex:1;-ms-flex:1;flex:1;text-align:center}.ReactTable .-pagination .-center{-webkit-box-flex:1.5;-ms-flex:1.5;flex:1.5;text-align:center;margin-bottom:0;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-ms-flex-wrap:wrap;flex-wrap:wrap;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-ms-flex-pack:distribute;justify-content:space-around}.ReactTable .-pagination .-pageInfo{display:inline-block;margin:3px 10px;white-space:nowrap}.ReactTable .-pagination .-pageJump{display:inline-block}.ReactTable .-pagination .-pageJump input{width:70px;text-align:center}.ReactTable .-pagination .-pageSizeOptions{margin:3px 10px}.ReactTable .rt-noData{left:50%;top:50%;-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%);z-index:1;padding:20px;color:rgba(0,0,0,.5)}.ReactTable .-loading,.ReactTable .rt-noData{display:block;position:absolute;background:hsla(0,0%,100%,.8);transition:all .3s ease;pointer-events:none}.ReactTable .-loading{left:0;right:0;top:0;bottom:0;z-index:-1;opacity:0}.ReactTable .-loading>div{position:absolute;display:block;text-align:center;width:100%;top:50%;left:0;font-size:15px;color:rgba(0,0,0,.6);-webkit-transform:translateY(-52%);transform:translateY(-52%);transition:all .3s cubic-bezier(.25,.46,.45,.94)}.ReactTable .-loading.-active{opacity:1;z-index:2;pointer-events:all}.ReactTable .-loading.-active>div{-webkit-transform:translateY(50%);transform:translateY(50%)}.ReactTable .rt-resizing .rt-td,.ReactTable .rt-resizing .rt-th{transition:none!important;cursor:col-resize;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}", ""]);
	
	// exports


/***/ }),
/* 2929 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactTableV = __webpack_require__(2920);
	
	var _reactTableV2 = _interopRequireDefault(_reactTableV);
	
	__webpack_require__(2927);
	
	var _moment = __webpack_require__(1021);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _materialUi = __webpack_require__(576);
	
	var _lodash = __webpack_require__(2033);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var NEW_USER = "NEW";
	
	var TransferHistoryTable = function (_React$Component) {
	  _inherits(TransferHistoryTable, _React$Component);
	
	  function TransferHistoryTable(props) {
	    _classCallCheck(this, TransferHistoryTable);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(TransferHistoryTable).call(this, props));
	
	    _this.state = {
	      loading: false,
	      sorted: [],
	      page: -1,
	      selectedChange: "",
	      selectedIndex: null
	    };
	
	    _this.cleanSundanceEmail = _this.cleanSundanceEmail.bind(_this);
	    return _this;
	  }
	
	  _createClass(TransferHistoryTable, [{
	    key: "cleanSundanceEmail",
	    value: function cleanSundanceEmail(email) {
	      if (typeof email !== "string") {
	        return "";
	      }
	      if (email.indexOf("%%%sundance-") !== -1) {
	        return email.substring(0, email.indexOf("%%%sundance-"));
	      } else {
	        return email;
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props;
	      var loading = _props.loading;
	      var isPass = _props.isPass;
	      var isTicket = _props.isTicket;
	      var records = this.props.records;
	
	      // clean up sundance email addresses
	
	      records = records.map(function (r) {
	        if (r.from_person) {
	          r.from_person.email = _this2.cleanSundanceEmail(r.from_person.email);
	        }
	        if (r.to_person) {
	          r.to_person.email = _this2.cleanSundanceEmail(r.to_person.email);
	        }
	        if (r.to_email) {
	          r.to_email = _this2.cleanSundanceEmail(r.to_email);
	        }
	        return r;
	      });
	
	      var columns = [{
	        id: "created_at",
	        Header: "Date/Time",
	        Cell: function Cell(data) {
	          return (0, _moment2.default)(data.original.created_at).format("lll");
	        }
	      }];
	
	      if (isPass) {
	        columns = columns.concat([{
	          id: "pass_name",
	          Header: "Pass",
	          Cell: function Cell(data) {
	            return _react2.default.createElement(
	              "div",
	              null,
	              _react2.default.createElement(
	                "a",
	                { href: "/passes/" + data.original.passes[0]._id },
	                data.original.passes[0].name
	              )
	            );
	          }
	        }]);
	      }
	      /*else if (isTicket) {
	        columns = columns.concat([
	          {
	            id: "ticket_id",
	            Header: "Ticket",
	            Cell: function(data) {
	              return (<div>{data.original.tickets[0].name}</div>);
	            }
	          }
	        ]);
	      }*/
	
	      columns = columns.concat([{
	        id: "from_person",
	        Header: "Transferred From",
	        Cell: function Cell(data) {
	          return _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(
	              "a",
	              { href: "/people/" + data.original.from_person._id },
	              data.original.from_person.name
	            ),
	            _react2.default.createElement("br", null),
	            data.original.from_person.email
	          );
	        }
	      }, {
	        id: "to_person",
	        Header: "Transferred To",
	        Cell: function Cell(data) {
	          if (data.original.to_person) {
	            return _react2.default.createElement(
	              "div",
	              null,
	              _react2.default.createElement(
	                "a",
	                { href: "/people/" + data.original.to_person._id },
	                data.original.to_person.name
	              ),
	              _react2.default.createElement("br", null),
	              data.original.to_email
	            );
	          } else {
	            return _react2.default.createElement(
	              "div",
	              null,
	              data.original.to_email
	            );
	          }
	        }
	      }, {
	        id: "status",
	        Header: "Status",
	        width: 100,
	        Cell: function Cell(data) {
	          if (data.original.completed_at) {
	            return _react2.default.createElement(
	              "div",
	              { style: { paddingLeft: 4 } },
	              "Completed"
	            );
	          } else {
	            return _react2.default.createElement(
	              "div",
	              { style: { paddingLeft: 4 } },
	              "Pending"
	            );
	          }
	        }
	      }, {
	        id: "gift",
	        Header: "Gift",
	        width: 50,
	        Cell: function Cell(data) {
	          if (data.original.gift) {
	            return _react2.default.createElement(
	              "div",
	              { style: { paddingLeft: 4 } },
	              "Yes"
	            );
	          } else {
	            return _react2.default.createElement(
	              "div",
	              { style: { paddingLeft: 4 } },
	              "No"
	            );
	          }
	        }
	      }]);
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(_reactTableV2.default, {
	          columns: columns,
	          data: records,
	          loading: loading,
	          manual: true,
	          pageSize: records && records.length || 1,
	          showPagination: false,
	          showPageSizeOptions: false,
	          sortable: false
	        })
	      );
	    }
	  }]);
	
	  return TransferHistoryTable;
	}(_react2.default.Component);
	
	exports.default = TransferHistoryTable;
	module.exports = exports["default"];

/***/ }),
/* 2930 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactTableV = __webpack_require__(2920);
	
	var _reactTableV2 = _interopRequireDefault(_reactTableV);
	
	__webpack_require__(2927);
	
	var _materialUi = __webpack_require__(576);
	
	var _lodash = __webpack_require__(2033);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var NEW_USER = "NEW";
	
	var AuditLogTable = function (_React$Component) {
	  _inherits(AuditLogTable, _React$Component);
	
	  function AuditLogTable(props) {
	    var _this$state;
	
	    _classCallCheck(this, AuditLogTable);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(AuditLogTable).call(this, props));
	
	    _this.debouncedOnFetchData = (0, _lodash.debounce)(function (page, sorted, searchValue) {
	      return _this.props.onFetchData(page, sorted, searchValue);
	    }, 250);
	
	
	    _this.state = (_this$state = {
	      loading: false,
	      sorted: [],
	      page: -1,
	      selectedChange: ""
	    }, _defineProperty(_this$state, "selectedChange", ""), _defineProperty(_this$state, "selectedIndex", null), _this$state);
	
	    _this._onFetchData = _this._onFetchData.bind(_this);
	    _this.processChanges = _this.processChanges.bind(_this);
	    return _this;
	  }
	
	  _createClass(AuditLogTable, [{
	    key: "_onFetchData",
	    value: function _onFetchData(state, instance) {
	      this.props.onFetchData(state.page, state.sorted, this.state.searchValue);
	      this.setState({ page: state.page, sorted: state.sorted });
	    }
	  }, {
	    key: "processChanges",
	    value: function processChanges(action, changes) {
	      if (changes === "") {
	        return "";
	      }
	
	      var output = "";
	
	      var changesJSON = JSON.parse(changes);
	
	      if (action.indexOf("delete") !== -1) {
	        output = "Object deleted:\n\n";
	      } else if (action.indexOf("create") !== -1) {
	        output = "Object created:\n\n";
	      } else {
	        output = "Object changes:\n\n";
	      }
	
	      var keys = Object.keys(changesJSON);
	      keys.map(function (k) {
	        if (k === "__v") {
	          return;
	        }
	        if (k === "_id") {
	          return;
	        }
	        if (k === "_owner") {
	          return;
	        }
	        if (k === "created_at") {
	          return;
	        }
	        if (k === "updated_at") {
	          return;
	        }
	
	        if (typeof changesJSON[k] === "string") {
	          output = output + (k + ": " + changesJSON[k] + "\n");
	        } else if (Array.isArray(changesJSON[k])) {
	          if (changesJSON[k].length === 1) {
	            if (Array.isArray(changesJSON[k][0]) && changesJSON[k][0].length === 0) {
	              // fall through
	            } else {
	              if (Array.isArray(changesJSON[k][0])) {
	                output = output + (k + ": " + JSON.stringify(changesJSON[k][0], null, " ") + "\n");
	              } else {
	                if (typeof changesJSON[k][0] === "string") {
	                  output = output + (k + ": " + changesJSON[k][0] + "\n");
	                } else {
	                  output = output + (k + ": " + JSON.stringify(changesJSON[k][0], null, " ") + "\n");
	                }
	              }
	            }
	          } else if (changesJSON[k].length > 1) {
	            if (action.indexOf("delete") !== -1) {
	              output = output + (k + ": " + changesJSON[k][0] + "\n");
	            } else {
	              output = output + (k + ":\n  New Value: " + changesJSON[k][1] + "\n  Previous value: " + changesJSON[k][0] + "\n\n");
	            }
	          }
	        } else {
	          var objectString = JSON.stringify(changesJSON[k], null, " ");
	          output = output + (k + ": " + objectString + "\n");
	        }
	      });
	
	      if (changesJSON["created_at"]) {
	        output = output + ("\nCreated at: " + changesJSON["created_at"]);
	      }
	      if (changesJSON["updated_at"]) {
	        if (Array.isArray(changesJSON["updated_at"])) {
	          if (action.indexOf("delete") !== -1) {
	            output = output + ("\nUpdated at: " + changesJSON["updated_at"][0]);
	          } else {
	            output = output + ("\nUpdated at: " + changesJSON["updated_at"][changesJSON["updated_at"].length - 1]);
	          }
	        } else {
	          output = output + ("\nUpdated at: " + changesJSON["updated_at"]);
	        }
	      }
	      output = output + "\n\nRAW JSON:\n" + changes;
	      return output;
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props;
	      var logRecords = _props.logRecords;
	      var pages = _props.pages;
	      var pageSize = _props.pageSize;
	      var loading = _props.loading;
	
	
	      var columns = [{
	        id: "user_account",
	        Header: "User account",
	        accessor: "user_account",
	        mindWIdth: 200
	      },
	      //{
	      //  id: "person",
	      //  Header: "Person",
	      //  accessor: "person"
	      //},
	      {
	        id: "object_id",
	        Header: "Object ID",
	        Cell: function Cell(data) {
	          if (data.original.action && data.original.action.indexOf(".delete") !== -1) {
	            return data.original.object_id;
	          } else if (data.original.action && data.original.action.startsWith("event_bucket.")) {
	            return _react2.default.createElement(
	              "div",
	              null,
	              _react2.default.createElement(
	                "a",
	                { href: "event_buckets/" + data.original.object_id },
	                data.original.object_id
	              )
	            );
	          } else if (data.original.action && data.original.action.startsWith("coupon.")) {
	            return _react2.default.createElement(
	              "div",
	              null,
	              _react2.default.createElement(
	                "a",
	                { href: "event_buckets/" + data.original.event_bucket + "/coupons/" + data.original.object_id },
	                data.original.object_id
	              )
	            );
	          } else if (data.original.action && data.original.action.startsWith("film.")) {
	            return _react2.default.createElement(
	              "div",
	              null,
	              _react2.default.createElement(
	                "a",
	                { href: "event_buckets/" + data.original.event_bucket + "/events/" + data.original.object_id },
	                data.original.object_id
	              )
	            );
	          } else if (data.original.action && data.original.action.startsWith("event.")) {
	            return _react2.default.createElement(
	              "div",
	              null,
	              _react2.default.createElement(
	                "a",
	                { href: "event_buckets/" + data.original.event_bucket + "/events/" + data.original.object_id },
	                data.original.object_id
	              )
	            );
	          } else if (data.original.action && data.original.action.startsWith("mailing.")) {
	            return _react2.default.createElement(
	              "div",
	              null,
	              _react2.default.createElement(
	                "a",
	                { href: "event_buckets/" + data.original.event_bucket + "/mailings/" + data.original.object_id },
	                data.original.object_id
	              )
	            );
	          } else if (data.original.action && data.original.action.startsWith("order.")) {
	            return _react2.default.createElement(
	              "div",
	              null,
	              _react2.default.createElement(
	                "a",
	                { href: "orders/" + data.original.object_id },
	                data.original.object_id
	              )
	            );
	          } else if (data.original.action && data.original.action.startsWith("pass.")) {
	            return _react2.default.createElement(
	              "div",
	              null,
	              _react2.default.createElement(
	                "a",
	                { href: "passes/" + data.original.object_id },
	                data.original.object_id
	              )
	            );
	          } else if (data.original.action && data.original.action.startsWith("pass_bucket.")) {
	            return _react2.default.createElement(
	              "div",
	              null,
	              _react2.default.createElement(
	                "a",
	                { href: "event_buckets/" + data.original.event_bucket + "/pass_buckets/" + data.original.object_id },
	                data.original.object_id
	              )
	            );
	          } else if (data.original.action && data.original.action.startsWith("item_bucket.")) {
	            return _react2.default.createElement(
	              "div",
	              null,
	              _react2.default.createElement(
	                "a",
	                { href: "event_buckets/" + data.original.event_bucket + "/item_buckets/" + data.original.object_id },
	                data.original.object_id
	              )
	            );
	          } else if (data.original.action && data.original.action.startsWith("tag.")) {
	            return _react2.default.createElement(
	              "div",
	              null,
	              _react2.default.createElement(
	                "a",
	                { href: "event_buckets/" + data.original.event_bucket + "/tags/" + data.original.object_id },
	                data.original.object_id
	              )
	            );
	          } else if (data.original.action && data.original.action.startsWith("ticket.")) {
	            return _react2.default.createElement(
	              "div",
	              null,
	              _react2.default.createElement(
	                "a",
	                { href: "tickets/" + data.original.object_id },
	                data.original.object_id
	              )
	            );
	          } else if (data.original.action && data.original.action.startsWith("venue.")) {
	            return _react2.default.createElement(
	              "div",
	              null,
	              _react2.default.createElement(
	                "a",
	                { href: "event_buckets/" + data.original.event_bucket + "/venues/" + data.original.object_id },
	                data.original.object_id
	              )
	            );
	          } else if (data.original.action && data.original.action.startsWith("virtual_content.")) {
	            return _react2.default.createElement(
	              "div",
	              null,
	              _react2.default.createElement(
	                "a",
	                { href: "ecreator_hub/virtual_content/" + data.original.object_id },
	                data.original.object_id
	              )
	            );
	          } else {
	            return data.original.object_id;
	          }
	        }
	      }, {
	        id: "action",
	        Header: "Action",
	        accessor: "action"
	      }, {
	        id: "created_at",
	        Header: "Action occurred at",
	        accessor: "created_at"
	      }];
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(_reactTableV2.default, {
	          columns: columns,
	          data: logRecords,
	          loading: loading,
	          manual: true,
	          pages: pages,
	          pageSize: pageSize,
	          showPageSizeOptions: false,
	          onFetchData: this._onFetchData,
	          sortable: false,
	          getTrProps: function getTrProps(state, rowInfo) {
	            if (rowInfo && rowInfo.row) {
	              return {
	                onClick: function onClick(e) {
	                  _this2.setState({
	                    selectedChange: JSON.stringify(rowInfo.original.changes, undefined, 2),
	                    selectedAction: rowInfo.original.action,
	                    selectedIndex: rowInfo.index
	                  });
	                },
	                style: {
	                  background: rowInfo.index === _this2.state.selectedIndex ? '#00afec' : 'white',
	                  color: rowInfo.index === _this2.state.selectedIndex ? 'white' : 'black'
	                }
	              };
	            } else {
	              return {};
	            }
	          }
	        }),
	        _react2.default.createElement(
	          _materialUi.Paper,
	          { style: { padding: 25, marginTop: 20, minHeight: 150 }, zDepth: 2 },
	          _react2.default.createElement(
	            "pre",
	            { style: { whiteSpace: "pre-wrap" } },
	            this.processChanges(this.state.selectedAction, this.state.selectedChange)
	          )
	        ),
	        logRecords && logRecords.length && logRecords[this.state.selectedIndex] && logRecords[this.state.selectedIndex].user_account_details ? _react2.default.createElement(
	          "div",
	          { style: { paddingTop: 10 } },
	          _react2.default.createElement(
	            "i",
	            null,
	            "Record updated by:"
	          ),
	          _react2.default.createElement("br", null),
	          _react2.default.createElement(
	            "span",
	            null,
	            logRecords[this.state.selectedIndex].user_account_details.name
	          ),
	          _react2.default.createElement("br", null),
	          _react2.default.createElement(
	            "span",
	            null,
	            logRecords[this.state.selectedIndex].user_account_details.email
	          )
	        ) : null
	      );
	    }
	  }]);
	
	  return AuditLogTable;
	}(_react2.default.Component);
	
	exports.default = AuditLogTable;
	module.exports = exports["default"];

/***/ }),
/* 2931 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactTableV = __webpack_require__(2920);
	
	var _reactTableV2 = _interopRequireDefault(_reactTableV);
	
	__webpack_require__(2927);
	
	var _moment = __webpack_require__(1021);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _api = __webpack_require__(1160);
	
	var _api2 = _interopRequireDefault(_api);
	
	var _workingIndicator = __webpack_require__(1664);
	
	var _workingIndicator2 = _interopRequireDefault(_workingIndicator);
	
	var _transferHistoryTable = __webpack_require__(2929);
	
	var _transferHistoryTable2 = _interopRequireDefault(_transferHistoryTable);
	
	var _auditLogTable = __webpack_require__(2930);
	
	var _auditLogTable2 = _interopRequireDefault(_auditLogTable);
	
	var _connectToStores = __webpack_require__(1226);
	
	var _connectToStores2 = _interopRequireDefault(_connectToStores);
	
	var _TicketActions = __webpack_require__(2697);
	
	var _TicketActions2 = _interopRequireDefault(_TicketActions);
	
	var _TicketStore = __webpack_require__(2706);
	
	var _TicketStore2 = _interopRequireDefault(_TicketStore);
	
	var _UserStore = __webpack_require__(974);
	
	var _UserStore2 = _interopRequireDefault(_UserStore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PAGESIZE = 10;
	
	var TicketHistory = function (_React$Component) {
	  _inherits(TicketHistory, _React$Component);
	
	  function TicketHistory(props) {
	    _classCallCheck(this, TicketHistory);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(TicketHistory).call(this, props));
	
	    _this.state = {
	      ticket: null,
	      ticketTransferHistory: null,
	      pageData: [],
	      pageNum: 0,
	      isLoading: false
	    };
	
	    _this.cleanSundanceEmail = _this.cleanSundanceEmail.bind(_this);
	    return _this;
	  }
	
	  _createClass(TicketHistory, [{
	    key: "componentWillMount",
	    value: function componentWillMount() {
	      _TicketActions2.default.fetchTicketTransferHistory.defer(this.props.params.ticketId, this.props.params.eventBucketId);
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(props) {
	      var ticketTransferHistory = _TicketStore2.default.getTicketTransferHistory();
	      var ticketTransferHistorySingleTicket = _TicketStore2.default.getTicketTransferHistorySingleTicket();
	
	      if (ticketTransferHistory && ticketTransferHistory.length >= 0) {
	        this.setState({ ticketTransferHistory: ticketTransferHistory, ticket: ticketTransferHistorySingleTicket });
	      }
	
	      if (ticketTransferHistorySingleTicket) {
	        this.fetchPage();
	      }
	    }
	  }, {
	    key: "cleanSundanceEmail",
	    value: function cleanSundanceEmail(email) {
	      if (typeof email !== "string") {
	        return "";
	      }
	      if (email.indexOf("%%%sundance-") !== -1) {
	        return email.substring(0, email.indexOf("%%%sundance-"));
	      } else {
	        return email;
	      }
	    }
	  }, {
	    key: "fetchPage",
	    value: function fetchPage() {
	      this.setState({ isLoading: true });
	      _api2.default.request({
	        method: "GET",
	        endpoint: "audit_log/page",
	        qs: {
	          //eventBucket: this.props.params.eventBucketId,
	          objectId: this.props.params.ticketId,
	          pageSize: PAGESIZE,
	          pageNum: this.state.pageNum
	        },
	        api_key: _UserStore2.default.getState().apiKey
	      }, function (err, response) {
	        if (err) {
	          console.log(err);
	          alert(err);
	          this.setState({ isLoading: false });
	        } else {
	          var pageData = response.data.map(function (r, i) {
	            return {
	              key: i,
	              event_bucket: r.event_bucket,
	              object_id: r.object,
	              user: r.user.name,
	              action: r.action,
	              created_at: r.created_at,
	              user_account: r.user_account && r.user_account.name ? r.user_account.name : "Unknown / External API Call",
	              //person: r.person[0] || "Not available",
	              changes: r.changes
	            };
	          });
	
	          var pageCount = Math.ceil(response.totalRecords / PAGESIZE);
	          this.setState({ pageData: pageData, pageCount: pageCount, isLoading: false });
	        }
	      }.bind(this));
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      // Temporarily hide history
	      var showHistory = false;
	
	      if (this.props.isFetching || this.state.ticketTransferHistory === null || this.state.ticket === null) {
	        return _react2.default.createElement(_workingIndicator2.default, { fullPage: true });
	      }
	
	      if (this.state.ticketTransferHistory.length === 0) {
	        return _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(
	              "span",
	              { style: { fontWeight: "bold", fontSize: "16px" } },
	              "Ticket Transfer History"
	            ),
	            _react2.default.createElement("br", null),
	            this.props.params.ticketId,
	            _react2.default.createElement("br", null),
	            _react2.default.createElement("br", null)
	          ),
	          _react2.default.createElement(
	            "div",
	            null,
	            "There is no transfer history for this ticket."
	          )
	        );
	      } else {
	        return _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement(
	            "div",
	            { style: { paddingBottom: 25 } },
	            _react2.default.createElement(
	              "span",
	              { style: { fontWeight: "bold", fontSize: "18px" } },
	              "Ticket History - ",
	              this.props.params.ticketId
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(
	              "span",
	              { style: { fontWeight: "bold", fontSize: "16px" } },
	              "Order Details"
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { style: { paddingBottom: 25 } },
	            _react2.default.createElement(_reactTableV2.default, {
	              columns: [{
	                id: "date",
	                Header: "Date/Time",
	                Cell: function Cell(data) {
	                  return (0, _moment2.default)(data.original.date).format("lll");
	                }
	              }, {
	                id: "order_id",
	                Header: "Order ID",
	                Cell: function Cell(data) {
	                  return _react2.default.createElement(
	                    "div",
	                    null,
	                    _react2.default.createElement(
	                      "a",
	                      { href: "/event_buckets/" + data.original.order.event_bucket + "/orders/" + data.original.order._id },
	                      data.original.order._id
	                    )
	                  );
	                }
	              }, {
	                id: "ordered_by",
	                Header: "Ordered by",
	                Cell: function Cell(data) {
	                  return _react2.default.createElement(
	                    "div",
	                    null,
	                    _react2.default.createElement(
	                      "a",
	                      { href: "/people/" + data.original.person.id },
	                      data.original.person.name
	                    ),
	                    _react2.default.createElement("br", null),
	                    data.original.person.email
	                  );
	                }
	              }],
	              data: [{
	                date: this.state.ticket.order.created_at,
	                order: this.state.ticket.order,
	                person: {
	                  id: this.state.ticket.order.person._id,
	                  name: this.state.ticket.order.person.name,
	                  email: this.cleanSundanceEmail(this.state.ticket.order.person.email)
	                }
	              }],
	              loading: this.state.isLoading ? "Loading..." : null,
	              manual: true,
	              pageSize: 1,
	              showPagination: false,
	              showPageSizeOptions: false,
	              sortable: false
	            })
	          ),
	          _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(
	              "span",
	              { style: { fontWeight: "bold", fontSize: "16px" } },
	              "Ticket Transfer History"
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(_transferHistoryTable2.default, {
	              records: this.state.ticketTransferHistory,
	              loading: this.state.isLoading ? "Loading..." : null,
	              isTicket: true
	            })
	          ),
	          showHistory ? _react2.default.createElement(
	            "div",
	            { style: { paddingTop: 25 } },
	            _react2.default.createElement(
	              "span",
	              { style: { fontWeight: "bold", fontSize: "16px" } },
	              "Ticket Audit Log History"
	            )
	          ) : null,
	          showHistory ? _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(_auditLogTable2.default, {
	              logRecords: this.state.pageData,
	              pageSize: this.state.pageData.length > PAGESIZE ? PAGESIZE : this.state.pageData.length,
	              pages: this.state.pageCount || 1,
	              loading: this.state.isLoading ? "Loading..." : null,
	              onFetchData: function onFetchData(page, sorted, searchTerm) {
	                _this2.setState({
	                  pageNum: page
	                  //sorted,
	                  //searchTerm
	                }, function () {
	                  this.fetchPage();
	                });
	              }
	            })
	          ) : null
	        );
	      }
	    }
	  }], [{
	    key: "getStores",
	    value: function getStores() {
	      return [_TicketStore2.default];
	    }
	  }, {
	    key: "getPropsFromStores",
	    value: function getPropsFromStores() {
	      return {
	        isFetching: _TicketStore2.default.getState().isFetching
	      };
	    }
	  }, {
	    key: "contextTypes",
	    get: function get() {
	      return {
	        router: _react2.default.PropTypes.object
	      };
	    }
	  }]);
	
	  return TicketHistory;
	}(_react2.default.Component);
	
	exports.default = (0, _connectToStores2.default)(TicketHistory);
	module.exports = exports["default"];

/***/ }),
/* 2932 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _materialUi = __webpack_require__(576);
	
	var _chunk = __webpack_require__(2288);
	
	var _chunk2 = _interopRequireDefault(_chunk);
	
	var _pickBy = __webpack_require__(1163);
	
	var _pickBy2 = _interopRequireDefault(_pickBy);
	
	var _util = __webpack_require__(1183);
	
	var _config = __webpack_require__(1173);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _api = __webpack_require__(1160);
	
	var _api2 = _interopRequireDefault(_api);
	
	var _userTable = __webpack_require__(2933);
	
	var _userTable2 = _interopRequireDefault(_userTable);
	
	var _infoNotice = __webpack_require__(1599);
	
	var _infoNotice2 = _interopRequireDefault(_infoNotice);
	
	var _inlineNoticeLabel = __webpack_require__(1222);
	
	var _inlineNoticeLabel2 = _interopRequireDefault(_inlineNoticeLabel);
	
	var _workingIndicator = __webpack_require__(1664);
	
	var _workingIndicator2 = _interopRequireDefault(_workingIndicator);
	
	var _datetimeField = __webpack_require__(2061);
	
	var _datetimeField2 = _interopRequireDefault(_datetimeField);
	
	var _selectField = __webpack_require__(1683);
	
	var _selectField2 = _interopRequireDefault(_selectField);
	
	var _connectToStores = __webpack_require__(1226);
	
	var _connectToStores2 = _interopRequireDefault(_connectToStores);
	
	var _EventBucketStore = __webpack_require__(1593);
	
	var _EventBucketStore2 = _interopRequireDefault(_EventBucketStore);
	
	var _UserActions = __webpack_require__(1158);
	
	var _UserActions2 = _interopRequireDefault(_UserActions);
	
	var _UserStore = __webpack_require__(974);
	
	var _UserStore2 = _interopRequireDefault(_UserStore);
	
	var _auditLogTable = __webpack_require__(2930);
	
	var _auditLogTable2 = _interopRequireDefault(_auditLogTable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PAGESIZE = 10;
	
	var AuditLog = function (_React$Component) {
	  _inherits(AuditLog, _React$Component);
	
	  function AuditLog(props) {
	    _classCallCheck(this, AuditLog);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(AuditLog).call(this, props));
	
	    _this.state = {
	      eventBucket: null,
	      objectId: "",
	      action: null,
	      startDate: null,
	      endDate: null,
	      pageData: [],
	      actionList: [],
	      eventBucketList: [],
	      pageNum: 0,
	      isLoading: false
	    };
	
	    _this.fetchPage = _this.fetchPage.bind(_this);
	    return _this;
	  }
	
	  _createClass(AuditLog, [{
	    key: "getStyles",
	    value: function getStyles() {
	      return {
	        section: {
	          marginTop: 20
	        }
	      };
	    }
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.componentWillReceiveProps(this.props);
	      this.fetchAuditLogActions();
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(newProps) {
	      var eventBuckets = _EventBucketStore2.default.getEventBuckets();
	      if (eventBuckets && eventBuckets.length) {
	        var availableEventBuckets = eventBuckets.map(function (eb) {
	          return {
	            label: eb.mode !== "archived" ? eb.name : eb.name + " (Archived)",
	            value: eb.id,
	            mode: eb.mode
	          };
	        });
	        availableEventBuckets.sort(function (a, b) {
	          return a.label.localeCompare(b.label);
	        });
	        availableEventBuckets.sort(function (a, b) {
	          if (a.mode === "archived") {
	            return 1;
	          } else {
	            return -1;
	          }
	        });
	        this.setState({ eventBucketList: availableEventBuckets });
	      }
	    }
	  }, {
	    key: "fetchAuditLogActions",
	    value: function fetchAuditLogActions() {
	      _api2.default.request({
	        method: "GET",
	        endpoint: "/audit_log/actions",
	        api_key: _UserStore2.default.getState().apiKey
	      }, function (err, response) {
	        if (err) {
	          console.log(err);
	          alert(err);
	        }
	        this.setState({ actionList: response.data });
	      }.bind(this));
	    }
	  }, {
	    key: "fetchPage",
	    value: function fetchPage() {
	      this.setState({ isLoading: true });
	      _api2.default.request({
	        method: "GET",
	        endpoint: "audit_log/page",
	        qs: {
	          eventBucket: this.state.eventBucket || null,
	          objectId: this.state.objectId || null,
	          action: this.state.action || null,
	          pageSize: PAGESIZE,
	          pageNum: this.state.pageNum,
	          startDate: this.state.startDate ? this.state.startDate.format('YYYY-MM-DDT00:00:00') : null,
	          endDate: this.state.endDate ? this.state.endDate.format('YYYY-MM-DDT23:59:59') : null
	        },
	        api_key: _UserStore2.default.getState().apiKey
	      }, function (err, response) {
	        if (err) {
	          console.log(err);
	          alert(err);
	          this.setState({ isLoading: false });
	        } else {
	          var pageData = response.data.map(function (r, i) {
	            return {
	              key: i,
	              event_bucket: r.event_bucket,
	              object_id: r.object,
	              user: r.user.name,
	              action: r.action,
	              created_at: r.created_at,
	              user_account: r.user_account && r.user_account.name ? r.user_account.name : "Unknown / External API Call",
	              user_account_details: r.user_account_details ? r.user_account_details : null,
	              //person: r.person[0] || "Not available",
	              changes: r.changes
	            };
	          });
	
	          var pageCount = Math.ceil(response.totalRecords / PAGESIZE);
	          this.setState({ pageData: pageData, pageCount: pageCount, isLoading: false });
	        }
	      }.bind(this));
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var styles = this.getStyles();
	
	      var loadingUsers = this.props.loadingUsers;
	
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        this.props.children /* modal */,
	        _react2.default.createElement(
	          "h1",
	          null,
	          "Audit Log"
	        ),
	        _react2.default.createElement(
	          "div",
	          { style: styles.section },
	          _react2.default.createElement(
	            _infoNotice2.default,
	            { style: { marginTop: 20 } },
	            "Filter audit log entries by an Object Id (event, film, etc), Action, or Date Range"
	          ),
	          _react2.default.createElement(
	            "div",
	            { style: { paddingBottom: 1 } },
	            _react2.default.createElement(
	              "div",
	              { style: { display: "inline-block" } },
	              _react2.default.createElement(_materialUi.TextField, {
	                floatingLabelText: "Object Id",
	                floatingLabelFixed: true,
	                value: this.state.objectId,
	                onChange: function onChange(e) {
	                  _this2.setState({ objectId: e.target.value });
	                },
	                style: { display: "inline-block", marginRight: 24 }
	              })
	            ),
	            _react2.default.createElement(
	              "div",
	              { style: { width: 250, height: 30, display: "inline-block", marginRight: 24, marginTop: 10 } },
	              _react2.default.createElement(_selectField2.default, {
	                placeholder: "Select action...",
	                value: this.state.action,
	                options: this.state.actionList.map(function (i) {
	                  return { value: i, label: i };
	                }),
	                clearable: true,
	                onChange: function onChange(e) {
	                  if (e && e.value) {
	                    _this2.setState({ "action": e.value });
	                  } else {
	                    _this2.setState({ "action": null });
	                  }
	                }
	              })
	            ),
	            _react2.default.createElement(
	              "div",
	              { style: { width: 250, height: 30, display: "inline-block", marginRight: 24, marginTop: 10 } },
	              _react2.default.createElement(_selectField2.default, {
	                placeholder: "Select event bucket...",
	                value: this.state.eventBucket,
	                options: this.state.eventBucketList,
	                clearable: true,
	                onChange: function onChange(e) {
	                  if (e && e.value) {
	                    _this2.setState({ "eventBucket": e.value });
	                  } else {
	                    _this2.setState({ "eventBucket": null });
	                  }
	                }
	              })
	            ),
	            _react2.default.createElement(
	              "div",
	              { style: { display: "inline-block" } },
	              _react2.default.createElement(_datetimeField2.default, {
	                value: this.state.startDate,
	                label: "Start date",
	                useMoment: true,
	                unclearable: true,
	                hideTime: true,
	                onChange: function onChange(e, v) {
	                  _this2.setState({ startDate: v });
	                },
	                style: { display: "inline-block", marginRight: 24 }
	              }),
	              _react2.default.createElement(_datetimeField2.default, {
	                value: this.state.endDate,
	                label: "End Date",
	                useMoment: true,
	                unclearable: true,
	                hideTime: true,
	                onChange: function onChange(e, v) {
	                  _this2.setState({ endDate: v });
	                },
	                style: { display: "inline-block", marginRight: 24 }
	              })
	            ),
	            _react2.default.createElement(
	              "div",
	              { style: { display: "inline-block", height: 30 } },
	              _react2.default.createElement(_materialUi.RaisedButton, {
	                primary: true,
	                onTouchTap: function onTouchTap() {
	                  _this2.fetchPage();
	                },
	                label: "Search",
	                style: { display: "inline-block", marginRight: 10 }
	              }),
	              _react2.default.createElement(_materialUi.RaisedButton, {
	                onTouchTap: function onTouchTap() {
	                  _this2.setState({
	                    objectId: "",
	                    action: null,
	                    startDate: null,
	                    endDate: null,
	                    pageNum: 0
	                  }, function () {
	                    this.fetchPage();
	                  });
	                },
	                label: "Clear",
	                style: { display: "inline-block" }
	              })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { style: styles.section },
	          _react2.default.createElement(_auditLogTable2.default, {
	            logRecords: this.state.pageData,
	            pageSize: PAGESIZE,
	            pages: this.state.pageCount || 1,
	            loading: this.state.isLoading ? "Loading..." : null,
	            onFetchData: function onFetchData(page, sorted, searchTerm) {
	              _this2.setState({
	                pageNum: page
	                //sorted,
	                //searchTerm
	              }, function () {
	                this.fetchPage();
	              });
	            }
	          })
	        )
	      );
	    }
	  }], [{
	    key: "getStores",
	    value: function getStores() {
	      return [_EventBucketStore2.default, _UserStore2.default];
	    }
	  }, {
	    key: "getPropsFromStores",
	    value: function getPropsFromStores() {
	      var state = _UserStore2.default.getState();
	      return state;
	    }
	  }, {
	    key: "contextTypes",
	    get: function get() {
	      return {
	        router: _react2.default.PropTypes.object
	      };
	    }
	  }]);
	
	  return AuditLog;
	}(_react2.default.Component);
	
	exports.default = (0, _connectToStores2.default)(AuditLog);
	module.exports = exports["default"];

/***/ }),
/* 2933 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _moment = __webpack_require__(1021);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _reactRouter = __webpack_require__(486);
	
	var _reactable = __webpack_require__(1688);
	
	var _materialUi = __webpack_require__(576);
	
	var _userEditorModal = __webpack_require__(1750);
	
	var _userEditorModal2 = _interopRequireDefault(_userEditorModal);
	
	var _UserActions = __webpack_require__(1158);
	
	var _UserActions2 = _interopRequireDefault(_UserActions);
	
	var _GodActions = __webpack_require__(1748);
	
	var _GodActions2 = _interopRequireDefault(_GodActions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var NEW_USER = "NEW";
	
	var UserTable = function (_React$Component) {
	  _inherits(UserTable, _React$Component);
	
	  function UserTable(props) {
	    _classCallCheck(this, UserTable);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(UserTable).call(this, props));
	
	    _this.state = {
	      deletedUsers: {},
	      userIdBeingEdited: null
	    };
	
	    _this._edit = _this._edit.bind(_this);
	    _this._delete = _this._delete.bind(_this);
	    _this._saveUser = _this._saveUser.bind(_this);
	    _this._dismissUser = _this._dismissUser.bind(_this);
	    _this._fakeEventBucket = _this._fakeEventBucket.bind(_this);
	    _this._makeRowForUser = _this._makeRowForUser.bind(_this);
	    return _this;
	  }
	
	  _createClass(UserTable, [{
	    key: "_edit",
	    value: function _edit(id, e) {
	      e.preventDefault();
	      this.setState({ userIdBeingEdited: id });
	    }
	  }, {
	    key: "_delete",
	    value: function _delete(id, e) {
	      e.preventDefault();
	
	      if (window.confirm("Are you sure you want to delete \"" + this.props.users[id].organization + "\"? There is NOOOO going back.")) {
	        _UserActions2.default.godDeleteUser(id);
	        this.state.deletedUsers[id] = true;
	        this.setState(this.state);
	      }
	    }
	  }, {
	    key: "_become",
	    value: function _become(id, e) {
	      e.preventDefault();
	      _UserActions2.default.setGodUser(id);
	    }
	  }, {
	    key: "_saveUser",
	    value: function _saveUser(user) {
	      var id = this.state.userIdBeingEdited;
	
	      if (id === NEW_USER) {
	        _UserActions2.default.godCreateUser(user);
	      } else {
	        _UserActions2.default.godEditUser(id, user);
	      }
	
	      this._dismissUser();
	    }
	  }, {
	    key: "_dismissUser",
	    value: function _dismissUser() {
	      this.setState({ userIdBeingEdited: null });
	    }
	  }, {
	    key: "_fakeEventBucket",
	    value: function _fakeEventBucket() {
	      var _ref = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	      var name = _ref.name;
	      var timezone = _ref.timezone;
	
	      _GodActions2.default.createFakeEventBucket({
	        user: this.state.userIdBeingEdited,
	        name: name,
	        timezone: timezone
	      });
	      this._dismissUser();
	    }
	  }, {
	    key: "_makeRowForUser",
	    value: function _makeRowForUser(user) {
	      var isDeleted = this.state.deletedUsers[user.id],
	          isCurrentUser = this.props.currentUser === user.id;
	
	      return _react2.default.createElement(
	        _reactable.Tr,
	        {
	          style: isDeleted && { textDecoration: "line-through", color: "#ccc" },
	          key: user.id
	        },
	        _react2.default.createElement(
	          _reactable.Td,
	          { column: "Organization", value: user.organization },
	          _react2.default.createElement(
	            "div",
	            null,
	            isCurrentUser ? "👤" : _react2.default.createElement(
	              "a",
	              {
	                href: "#",
	                style: { textDecoration: "none", opacity: 0.25 },
	                onClick: this._become.bind(this, user.id)
	              },
	              "\uD83D\uDC64"
	            ),
	            "\xA0",
	            user.organization,
	            "\xA0",
	            _react2.default.createElement(
	              "span",
	              { style: { fontSize: "0.75em", color: "#ccc" } },
	              user.id
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _reactable.Td,
	          { column: "Type" },
	          user.type === "festival_organizer" ? "Festival" : user.type === "content_creator" ? "Content Creator" : user.type
	        ),
	        _react2.default.createElement(
	          _reactable.Td,
	          { column: "Status" },
	          user.is_demo ? "Demo" : "Standard"
	        ),
	        _react2.default.createElement(
	          _reactable.Td,
	          { column: "Virtual Status" },
	          user.virtual_festival_plan_status ? user.virtual_festival_plan + " \u2013 " + user.virtual_festival_plan_status : ""
	        ),
	        _react2.default.createElement(
	          _reactable.Td,
	          { column: "Fee Percent" },
	          user.fee_percent + "%"
	        ),
	        _react2.default.createElement(
	          _reactable.Td,
	          { column: "Currency" },
	          (user.currency || "UNK").toUpperCase()
	        ),
	        _react2.default.createElement(
	          _reactable.Td,
	          { column: "Actions" },
	          _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(
	              "a",
	              {
	                style: isDeleted && { color: "#ccc" },
	                href: "#",
	                onClick: this._edit.bind(this, user.id)
	              },
	              "Edit"
	            ),
	            !isDeleted && !isCurrentUser && _react2.default.createElement(
	              "span",
	              null,
	              "\xA0",
	              _react2.default.createElement(
	                "a",
	                { href: "#", onClick: this._delete.bind(this, user.id) },
	                "Delete"
	              )
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var rows = Object.values(this.props.users).map(this._makeRowForUser);
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        this.state.userIdBeingEdited ? _react2.default.createElement(_userEditorModal2.default, {
	          isNew: this.state.userIdBeingEdited === NEW_USER,
	          user: this.props.users[this.state.userIdBeingEdited],
	          roles: this.props.roles,
	          onSave: this._saveUser,
	          onCancel: this._dismissUser,
	          onFakeEventBucket: this._fakeEventBucket
	        }) : null,
	        _react2.default.createElement(
	          _reactable.Table,
	          {
	            className: "bordered striped responsive-table",
	            columns: ["Organization", "Type", "Currency", "Virtual Status", "Fee Percent", "Status", "Actions"],
	            sortable: true
	          },
	          rows
	        ),
	        !this.props.hideAddButton ? _react2.default.createElement(_materialUi.RaisedButton, {
	          label: "Add new organization",
	          primary: true,
	          style: { marginTop: 10 },
	          onTouchTap: this._edit.bind(this, NEW_USER)
	        }) : null
	      );
	    }
	  }]);
	
	  return UserTable;
	}(_react2.default.Component);
	
	exports.default = UserTable;
	module.exports = exports["default"];

/***/ }),
/* 2934 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _materialUi = __webpack_require__(576);
	
	var _chunk = __webpack_require__(2288);
	
	var _chunk2 = _interopRequireDefault(_chunk);
	
	var _pickBy = __webpack_require__(1163);
	
	var _pickBy2 = _interopRequireDefault(_pickBy);
	
	var _util = __webpack_require__(1183);
	
	var _config = __webpack_require__(1173);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _userTable = __webpack_require__(2933);
	
	var _userTable2 = _interopRequireDefault(_userTable);
	
	var _inlineNoticeLabel = __webpack_require__(1222);
	
	var _inlineNoticeLabel2 = _interopRequireDefault(_inlineNoticeLabel);
	
	var _workingIndicator = __webpack_require__(1664);
	
	var _workingIndicator2 = _interopRequireDefault(_workingIndicator);
	
	var _connectToStores = __webpack_require__(1226);
	
	var _connectToStores2 = _interopRequireDefault(_connectToStores);
	
	var _UserActions = __webpack_require__(1158);
	
	var _UserActions2 = _interopRequireDefault(_UserActions);
	
	var _UserStore = __webpack_require__(974);
	
	var _UserStore2 = _interopRequireDefault(_UserStore);
	
	var _newUserTable = __webpack_require__(2935);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Users = function (_React$Component) {
	  _inherits(Users, _React$Component);
	
	  function Users(props) {
	    _classCallCheck(this, Users);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(Users).call(this, props));
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(Users, [{
	    key: "getStyles",
	    value: function getStyles() {
	      return {
	        section: {
	          marginTop: 20
	        }
	      };
	    }
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.componentWillReceiveProps(this.props);
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(newProps) {}
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var styles = this.getStyles();
	
	      if (this.props.paginatedContentCreators.length === 0 || this.props.paginatedUsers.length === 0) {
	        return _react2.default.createElement(_workingIndicator2.default, { fullPage: true });
	      }
	
	      var _props = this.props;
	      var activeGodUser = _props.activeGodUser;
	      var paginatedUsers = _props.paginatedUsers;
	      var paginatedContentCreators = _props.paginatedContentCreators;
	      var loadingUsers = _props.loadingUsers;
	      var loadingContentCreators = _props.loadingContentCreators;
	
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        this.props.children /* modal */,
	        _react2.default.createElement(
	          "h1",
	          null,
	          "Master Plan ",
	          _react2.default.createElement(_inlineNoticeLabel2.default, { label: "For God's Eyes Only" })
	        ),
	        _react2.default.createElement(
	          "div",
	          { style: styles.section },
	          _react2.default.createElement(
	            "h2",
	            null,
	            "Quick actions"
	          ),
	          _react2.default.createElement(_materialUi.RaisedButton, {
	            primary: true,
	            onTouchTap: function onTouchTap() {
	              return _this2.context.router.push("/god/auto_create");
	            },
	            label: "Auto-create user"
	          })
	        ),
	        _react2.default.createElement(
	          "div",
	          { style: styles.section },
	          _react2.default.createElement(
	            "h2",
	            null,
	            "Organizations"
	          ),
	          _react2.default.createElement(_newUserTable.NewUserTable, {
	            users: paginatedUsers.users,
	            pages: paginatedUsers.pages,
	            currentUser: activeGodUser,
	            loading: loadingUsers,
	            onFetchData: function onFetchData(page, sorted, searchTerm) {
	              _UserActions2.default.fetchPaginatedUsers({
	                page: page,
	                isContentCreators: false,
	                sorted: sorted,
	                searchTerm: searchTerm
	              });
	            }
	          })
	        ),
	        _react2.default.createElement(
	          "div",
	          { style: styles.section },
	          _react2.default.createElement(
	            "h2",
	            null,
	            "Content Creators"
	          ),
	          _react2.default.createElement(_newUserTable.NewUserTable, {
	            users: paginatedContentCreators.users,
	            pages: paginatedContentCreators.pages,
	            currentUser: activeGodUser,
	            loading: loadingContentCreators,
	            onFetchData: function onFetchData(page, sorted, searchTerm) {
	              _UserActions2.default.fetchPaginatedUsers({
	                page: page,
	                isContentCreators: true,
	                sorted: sorted,
	                searchTerm: searchTerm
	              });
	            },
	            hideAddButton: true
	          })
	        )
	      );
	    }
	  }], [{
	    key: "getStores",
	    value: function getStores() {
	      return [_UserStore2.default];
	    }
	  }, {
	    key: "getPropsFromStores",
	    value: function getPropsFromStores() {
	      var state = _UserStore2.default.getState();
	      return state;
	    }
	  }, {
	    key: "contextTypes",
	    get: function get() {
	      return {
	        router: _react2.default.PropTypes.object
	      };
	    }
	  }]);
	
	  return Users;
	}(_react2.default.Component);
	
	exports.default = (0, _connectToStores2.default)(Users);
	module.exports = exports["default"];

/***/ }),
/* 2935 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.NewUserTable = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactTableV = __webpack_require__(2920);
	
	var _reactTableV2 = _interopRequireDefault(_reactTableV);
	
	__webpack_require__(2927);
	
	var _UserActions = __webpack_require__(1158);
	
	var _UserActions2 = _interopRequireDefault(_UserActions);
	
	var _materialUi = __webpack_require__(576);
	
	var _userEditorModal = __webpack_require__(1750);
	
	var _userEditorModal2 = _interopRequireDefault(_userEditorModal);
	
	var _lodash = __webpack_require__(2033);
	
	var _GodActions = __webpack_require__(1748);
	
	var _GodActions2 = _interopRequireDefault(_GodActions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var NEW_USER = "NEW";
	
	var NewUserTable = exports.NewUserTable = function (_React$Component) {
	  _inherits(NewUserTable, _React$Component);
	
	  function NewUserTable(props) {
	    _classCallCheck(this, NewUserTable);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(NewUserTable).call(this, props));
	
	    _this.debouncedOnFetchData = (0, _lodash.debounce)(function (page, sorted, searchValue) {
	      return _this.props.onFetchData(page, sorted, searchValue);
	    }, 250);
	
	
	    _this.state = {
	      loading: false,
	      userIdBeingEdited: null,
	      searchValue: "",
	      sorted: [],
	      page: -1
	    };
	
	    _this.onSearchChange = _this.onSearchChange.bind(_this);
	    _this._onFetchData = _this._onFetchData.bind(_this);
	    _this._saveUser = _this._saveUser.bind(_this);
	    _this._become = _this._become.bind(_this);
	    _this._edit = _this._edit.bind(_this);
	    _this._delete = _this._delete.bind(_this);
	    _this._dismissUser = _this._dismissUser.bind(_this);
	    _this._fakeEventBucket = _this._fakeEventBucket.bind(_this);
	    return _this;
	  }
	
	  _createClass(NewUserTable, [{
	    key: "onSearchChange",
	    value: function onSearchChange(e) {
	      this.setState({ searchValue: e.target.value });
	      this.debouncedOnFetchData(this.state.page, this.state.sorted, e.target.value);
	    }
	  }, {
	    key: "_onFetchData",
	    value: function _onFetchData(state, instance) {
	      this.props.onFetchData(state.page, state.sorted, this.state.searchValue);
	      this.setState({ page: state.page, sorted: state.sorted });
	    }
	  }, {
	    key: "_edit",
	    value: function _edit(id, e) {
	      e.preventDefault();
	      this.setState({ userIdBeingEdited: id });
	    }
	  }, {
	    key: "_saveUser",
	    value: function _saveUser(user) {
	      var id = this.state.userIdBeingEdited;
	
	      if (id === NEW_USER) {
	        _UserActions2.default.godCreateUser(user);
	      } else {
	        _UserActions2.default.godEditUser(id, user);
	      }
	
	      this._dismissUser();
	    }
	  }, {
	    key: "_dismissUser",
	    value: function _dismissUser() {
	      this.setState({ userIdBeingEdited: null });
	    }
	  }, {
	    key: "_fakeEventBucket",
	    value: function _fakeEventBucket() {
	      var _ref = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	      var name = _ref.name;
	      var timezone = _ref.timezone;
	
	      _GodActions2.default.createFakeEventBucket({
	        user: this.state.userIdBeingEdited,
	        name: name,
	        timezone: timezone
	      });
	      this._dismissUser();
	    }
	  }, {
	    key: "_delete",
	    value: function _delete(id, e) {
	      e.preventDefault();
	
	      if (window.confirm("Are you sure you want to delete \"" + this.props.users.find(function (user) {
	        return user.id === id;
	      }).organization + "\"? There is NOOOO going back.")) {
	        _UserActions2.default.godDeleteUser(id);
	        this.setState(this.state);
	      }
	    }
	  }, {
	    key: "_become",
	    value: function _become(id, e) {
	      e.preventDefault();
	      _UserActions2.default.setGodUser(id);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props;
	      var users = _props.users;
	      var pages = _props.pages;
	      var currentUser = _props.currentUser;
	      var loading = _props.loading;
	
	
	      var columns = [{
	        Header: "Organization",
	        accessor: "organization",
	        minWidth: 300,
	        Cell: function Cell(props) {
	          return _react2.default.createElement(
	            "div",
	            null,
	            currentUser === props.original.id ? "👤" : _react2.default.createElement(
	              "a",
	              {
	                href: "#",
	                style: { textDecoration: "none", opacity: 0.25 },
	                onClick: _this2._become.bind(_this2, props.original.id)
	              },
	              "\uD83D\uDC64"
	            ),
	            "\xA0",
	            props.original.organization,
	            "\xA0",
	            _react2.default.createElement(
	              "span",
	              { style: { fontSize: "0.75em", color: "#ccc" } },
	              props.original.id
	            )
	          );
	        }
	      }, {
	        id: "type",
	        Header: "Type",
	        accessor: function accessor(user) {
	          return user.type === "festival_organizer" ? "Festival" : user.type === "content_creator" ? "Content Creator" : user.type;
	        }
	      }, {
	        id: "currency",
	        Header: "Currency",
	        accessor: function accessor(user) {
	          return (user.currency || "UNK").toUpperCase();
	        }
	      }, {
	        id: "virtual_festival_plan",
	        Header: "Virtual Status",
	        accessor: function accessor(user) {
	          return user.virtual_festival_plan_status ? user.virtual_festival_plan + " \u2013 " + user.virtual_festival_plan_status : "";
	        }
	      }, {
	        id: "fee_percent",
	        Header: "Fee Percent",
	        accessor: function accessor(user) {
	          return user.fee_percent + "%";
	        }
	      }, {
	        id: "is_demo",
	        Header: "Status",
	        accessor: function accessor(user) {
	          return user.is_demo ? "Demo" : "Standard";
	        }
	      }, {
	        Header: "Actions",
	        sortable: false,
	        Cell: function Cell(props) {
	          return _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(
	              "a",
	              { href: "#", onClick: _this2._edit.bind(_this2, props.original.id) },
	              "Edit"
	            ),
	            currentUser !== props.original.id && _react2.default.createElement(
	              "span",
	              null,
	              "\xA0",
	              _react2.default.createElement(
	                "a",
	                {
	                  href: "#",
	                  onClick: _this2._delete.bind(_this2, props.original.id)
	                },
	                "Delete"
	              )
	            )
	          );
	        }
	      }];
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        this.state.userIdBeingEdited ? _react2.default.createElement(_userEditorModal2.default, {
	          isNew: this.state.userIdBeingEdited === NEW_USER,
	          user: this.props.users.find(function (user) {
	            return user.id === _this2.state.userIdBeingEdited;
	          }),
	          roles: this.props.roles,
	          onSave: this._saveUser,
	          onCancel: this._dismissUser,
	          onFakeEventBucket: this._fakeEventBucket
	        }) : null,
	        _react2.default.createElement(_materialUi.TextField, {
	          floatingLabelText: "Search Organization",
	          value: this.state.searchValue,
	          onChange: this.onSearchChange
	        }),
	        _react2.default.createElement(_reactTableV2.default, {
	          columns: columns,
	          data: users,
	          loading: loading,
	          manual: true,
	          pages: pages,
	          pageSize: 50,
	          showPageSizeOptions: false,
	          onFetchData: this._onFetchData,
	          defaultSorted: [{ id: "organization", desc: false }]
	        }),
	        !this.props.hideAddButton ? _react2.default.createElement(_materialUi.RaisedButton, {
	          label: "Add new organization",
	          primary: true,
	          style: { marginTop: 10 },
	          onTouchTap: this._edit.bind(this, NEW_USER)
	        }) : null
	      );
	    }
	  }]);
	
	  return NewUserTable;
	}(_react2.default.Component);

/***/ }),
/* 2936 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _materialUi = __webpack_require__(576);
	
	var _reactSelect = __webpack_require__(953);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	var _base = __webpack_require__(1755);
	
	var _base2 = _interopRequireDefault(_base);
	
	var _label = __webpack_require__(1682);
	
	var _label2 = _interopRequireDefault(_label);
	
	var _timezoneField = __webpack_require__(2937);
	
	var _timezoneField2 = _interopRequireDefault(_timezoneField);
	
	var _workingIndicator = __webpack_require__(1664);
	
	var _workingIndicator2 = _interopRequireDefault(_workingIndicator);
	
	var _config = __webpack_require__(1173);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _connectToStores = __webpack_require__(1226);
	
	var _connectToStores2 = _interopRequireDefault(_connectToStores);
	
	var _GodActions = __webpack_require__(1748);
	
	var _GodActions2 = _interopRequireDefault(_GodActions);
	
	var _GodStore = __webpack_require__(2938);
	
	var _GodStore2 = _interopRequireDefault(_GodStore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var GodAutoCreateUserModal = function (_React$Component) {
	  _inherits(GodAutoCreateUserModal, _React$Component);
	
	  function GodAutoCreateUserModal(props) {
	    _classCallCheck(this, GodAutoCreateUserModal);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(GodAutoCreateUserModal).call(this, props));
	
	    _this.state = {
	      values: {
	        currency: "usd",
	        fee_percent: 2,
	        stripe_customer_id: ""
	      }
	    };
	
	    _this.onRequestClose = _this.onRequestClose.bind(_this);
	    _this.onSave = _this.onSave.bind(_this);
	    _this.onChangeValue = _this.onChangeValue.bind(_this);
	    return _this;
	  }
	
	  _createClass(GodAutoCreateUserModal, [{
	    key: "getStyles",
	    value: function getStyles() {
	      return {
	        dialogTitle: {
	          borderBottom: "none"
	        },
	        dialogActionsContainer: {
	          borderTop: "none"
	        }
	      };
	    }
	  }, {
	    key: "onRequestClose",
	    value: function onRequestClose() {
	      this.context.router.goBack();
	    }
	  }, {
	    key: "onSave",
	    value: function onSave() {
	      _GodActions2.default.autoCreate(this.state.values);
	    }
	  }, {
	    key: "onChangeValue",
	    value: function onChangeValue(id, value) {
	      var values = this.state.values;
	
	      values[id] = value;
	      this.setState({ values: values });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var styles = this.getStyles();
	      var autoCreating = this.props.autoCreating;
	
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          _materialUi.Dialog,
	          _defineProperty({
	            title: "Auto-create new organization & user",
	            openImmediately: true,
	            hideTitleAndFooterBorders: true,
	            onRequestClose: this.onRequestClose,
	            actions: [_react2.default.createElement(_materialUi.FlatButton, {
	              label: "Cancel",
	              onTouchTap: this.onRequestClose,
	              disabled: autoCreating
	            }), _react2.default.createElement(_materialUi.FlatButton, {
	              primary: true,
	              label: "Auto-create!",
	              onTouchTap: this.onSave,
	              disabled: autoCreating
	            })],
	            titleStyle: styles.dialogTitle,
	            actionsContainerStyle: styles.dialogActionsContainer,
	            modal: true,
	            open: true,
	            autoDetectWindowHeight: false,
	            autoScrollBodyContent: false,
	            bodyStyle: { overflowY: "visible" }
	          }, "onRequestClose", this.onRequestClose),
	          autoCreating ? _react2.default.createElement(_workingIndicator2.default, { centered: true }) : _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(
	              "div",
	              null,
	              "Automatically create a new organization with an admin user and a fake event bucket. The Intercom record associated with the email address you enter will automatically be updated as",
	              " ",
	              _react2.default.createElement(
	                "strong",
	                null,
	                "\"organization approved\""
	              ),
	              ". The admin will",
	              " ",
	              _react2.default.createElement(
	                "i",
	                null,
	                "immediately"
	              ),
	              " receive an email with login information."
	            ),
	            _react2.default.createElement(
	              "form",
	              { autoComplete: "off", style: { width: 256, margin: "0 auto" } },
	              _react2.default.createElement(
	                "div",
	                null,
	                _react2.default.createElement(_materialUi.TextField, {
	                  value: this.state.values.organization,
	                  floatingLabelText: "Organization name",
	                  floatingLabelFixed: true,
	                  onChange: function onChange(e) {
	                    return _this2.onChangeValue("organization", e.target.value);
	                  }
	                })
	              ),
	              _react2.default.createElement(
	                "div",
	                null,
	                _react2.default.createElement(_materialUi.TextField, {
	                  value: this.state.values.name,
	                  floatingLabelText: "Admin full name",
	                  floatingLabelFixed: true,
	                  onChange: function onChange(e) {
	                    return _this2.onChangeValue("name", e.target.value);
	                  }
	                })
	              ),
	              _react2.default.createElement(
	                "div",
	                null,
	                _react2.default.createElement(_materialUi.TextField, {
	                  value: this.state.values.email,
	                  floatingLabelText: "Admin email",
	                  floatingLabelFixed: true,
	                  onChange: function onChange(e) {
	                    return _this2.onChangeValue("email", e.target.value);
	                  }
	                })
	              ),
	              _react2.default.createElement(
	                "div",
	                null,
	                _react2.default.createElement(_timezoneField2.default, {
	                  label: "Example event bucket timezone",
	                  value: this.state.values.timezone,
	                  onChange: function onChange(timezone) {
	                    return _this2.onChangeValue("timezone", timezone);
	                  }
	                })
	              ),
	              _react2.default.createElement(
	                "div",
	                null,
	                _react2.default.createElement(
	                  _label2.default,
	                  null,
	                  "Currency"
	                ),
	                _react2.default.createElement(_reactSelect2.default, {
	                  clearable: false,
	                  value: this.state.values.currency,
	                  options: _config2.default.fee.supported_currencies.map(function (k) {
	                    return {
	                      label: k.toUpperCase(),
	                      value: k
	                    };
	                  }),
	                  onChange: function onChange(e) {
	                    return _this2.onChangeValue("currency", e ? e.value : "");
	                  }
	                })
	              ),
	              _react2.default.createElement(
	                "div",
	                null,
	                _react2.default.createElement(
	                  _label2.default,
	                  null,
	                  "Fee percent"
	                ),
	                _react2.default.createElement(_reactSelect2.default, {
	                  clearable: false,
	                  value: this.state.values.fee_percent,
	                  options: [{ label: "2%", value: 2 }, { label: "4.5%", value: 4.5 }],
	                  onChange: function onChange(e) {
	                    return _this2.onChangeValue("fee_percent", e ? e.value : "");
	                  }
	                })
	              ),
	              _react2.default.createElement(
	                "div",
	                null,
	                _react2.default.createElement(_materialUi.TextField, {
	                  value: this.state.values.stripe_customer_id,
	                  floatingLabelText: "Set Stripe customer ID (optional)",
	                  placeholder: "(will create new Stripe customer)",
	                  floatingLabelFixed: true,
	                  onChange: function onChange(e) {
	                    return _this2.onChangeValue("stripe_customer_id", e.target.value);
	                  }
	                })
	              )
	            )
	          )
	        )
	      );
	    }
	  }], [{
	    key: "getStores",
	    value: function getStores() {
	      return [_GodStore2.default];
	    }
	  }, {
	    key: "getPropsFromStores",
	    value: function getPropsFromStores() {
	      return _GodStore2.default.getState();
	    }
	  }]);
	
	  return GodAutoCreateUserModal;
	}(_react2.default.Component);
	
	GodAutoCreateUserModal.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	exports.default = (0, _connectToStores2.default)(GodAutoCreateUserModal);
	module.exports = exports["default"];

/***/ }),
/* 2937 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactSelect = __webpack_require__(953);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	var _label = __webpack_require__(1682);
	
	var _label2 = _interopRequireDefault(_label);
	
	var _momentTimezone = __webpack_require__(1185);
	
	var _momentTimezone2 = _interopRequireDefault(_momentTimezone);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TimezoneField = function (_React$Component) {
	  _inherits(TimezoneField, _React$Component);
	
	  function TimezoneField(props) {
	    _classCallCheck(this, TimezoneField);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(TimezoneField).call(this, props));
	
	    _this.state = {
	      now: (0, _momentTimezone2.default)()
	    };
	
	    _this.updateTime = _this.updateTime.bind(_this);
	    return _this;
	  }
	
	  _createClass(TimezoneField, [{
	    key: "updateTime",
	    value: function updateTime() {
	      this.setState({
	        now: (0, _momentTimezone2.default)()
	      });
	    }
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.timezoneInterval = setInterval(this.updateTime, 1000);
	      this.updateTime();
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      clearInterval(this.timezoneInterval);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _props = this.props;
	      var label = _props.label;
	      var labelStyle = _props.labelStyle;
	      var style = _props.style;
	      var value = _props.value;
	      var _onChange = _props.onChange;
	      var now = this.state.now;
	
	
	      return _react2.default.createElement(
	        "div",
	        { style: style },
	        label && _react2.default.createElement(
	          _label2.default,
	          { style: labelStyle },
	          label
	        ),
	        _react2.default.createElement(_reactSelect2.default, {
	          placeholder: "No timezone selected",
	          value: value,
	          autosize: true,
	          options: _momentTimezone2.default.tz.names().map(function (n) {
	            return {
	              label: n + " (" + now.tz(n).format("LTS") + ")",
	              value: n
	            };
	          }),
	          onChange: function onChange(option) {
	            _onChange(option ? option.value : "");
	          }
	        })
	      );
	    }
	  }]);
	
	  return TimezoneField;
	}(_react2.default.Component);
	
	exports.default = TimezoneField;
	module.exports = exports["default"];

/***/ }),
/* 2938 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _alt = __webpack_require__(975);
	
	var _alt2 = _interopRequireDefault(_alt);
	
	var _UserStore = __webpack_require__(974);
	
	var _UserStore2 = _interopRequireDefault(_UserStore);
	
	var _GodActions = __webpack_require__(1748);
	
	var _GodActions2 = _interopRequireDefault(_GodActions);
	
	var _GodUtil = __webpack_require__(2939);
	
	var _GodUtil2 = _interopRequireDefault(_GodUtil);
	
	var _EventBucketActions = __webpack_require__(1218);
	
	var _EventBucketActions2 = _interopRequireDefault(_EventBucketActions);
	
	var _UserActions = __webpack_require__(1158);
	
	var _UserActions2 = _interopRequireDefault(_UserActions);
	
	var _util = __webpack_require__(1183);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var GodStore = function () {
	  function GodStore() {
	    _classCallCheck(this, GodStore);
	
	    this.bindActions(_GodActions2.default);
	
	    this.state = {
	      autoCreating: false,
	      stats: null,
	      revenue: null,
	      upcomingEvents: null
	    };
	  }
	
	  _createClass(GodStore, [{
	    key: "onCreateFakeEventBucket",
	    value: function onCreateFakeEventBucket(options) {
	      _GodUtil2.default.createFakeEventBucket(_UserStore2.default.getState().apiKey, options).then(function (data) {
	        _EventBucketActions2.default.fetchAll.defer();
	      }).catch(_GodActions2.default.godFailed);
	    }
	  }, {
	    key: "onAutoCreate",
	    value: function onAutoCreate(options) {
	      var _this = this;
	
	      this.setState({ autoCreating: true });
	
	      _GodUtil2.default.autoCreate(_UserStore2.default.getState().apiKey, options).then(function (data) {
	        _UserActions2.default.setGodUser(data.id);
	        _UserActions2.default.godAutoCreateUser(data.user);
	        _UserActions2.default.fetchCurrentPage(false);
	        _util.history.push("/god");
	        _this.setState({ autoCreating: false });
	      }).catch(_GodActions2.default.godFailed);
	    }
	  }, {
	    key: "onFetchStats",
	    value: function onFetchStats() {
	      var _this2 = this;
	
	      _GodUtil2.default.fetchStats(_UserStore2.default.getState().apiKey).then(function (data) {
	        _this2.setState({ stats: data.stats });
	      }).catch(_GodActions2.default.godFailed);
	    }
	  }, {
	    key: "onFetchRevenue",
	    value: function onFetchRevenue() {
	      var _this3 = this;
	
	      _GodUtil2.default.fetchRevenue(_UserStore2.default.getState().apiKey).then(function (data) {
	        _this3.setState({ revenue: data.revenue });
	      }).catch(_GodActions2.default.godFailed);
	    }
	  }, {
	    key: "onFetchUpcomingEvents",
	    value: function onFetchUpcomingEvents() {
	      var _this4 = this;
	
	      _GodUtil2.default.fetchUpcomingEvents(_UserStore2.default.getState().apiKey).then(function (data) {
	        _this4.setState({ upcomingEvents: data });
	      }).catch(_GodActions2.default.godFailed);
	    }
	  }, {
	    key: "onBecomePerson",
	    value: function onBecomePerson(person) {
	      _GodUtil2.default.becomePerson(_UserStore2.default.getState().apiKey, person).then(function (data) {
	        console.log("Congrats, God. You've become " + person + ". Use your power wisely.");
	        console.log(data.token);
	        console.log("document.cookie='eventive-token=" + data.token + "'");
	      }).catch(_GodActions2.default.godFailed);
	    }
	  }, {
	    key: "onGodFailed",
	    value: function onGodFailed(e) {
	      alert("God failed: " + e.message);
	      this.setState({ autoCreating: false });
	    }
	  }]);
	
	  return GodStore;
	}();
	
	exports.default = _alt2.default.createStore(GodStore, "GodStore");
	module.exports = exports["default"];

/***/ }),
/* 2939 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _api = __webpack_require__(1160);
	
	var _api2 = _interopRequireDefault(_api);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  createFakeEventBucket: function createFakeEventBucket(apiKey, options) {
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "POST",
	        endpoint: "god/create_fake_event_bucket",
	        json: options,
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response);
	      });
	    });
	  },
	  autoCreate: function autoCreate(apiKey, options) {
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "POST",
	        endpoint: "god/auto_create",
	        json: options,
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response);
	      });
	    });
	  },
	  fetchStats: function fetchStats(apiKey) {
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "GET",
	        endpoint: "god/stats",
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response);
	      });
	    });
	  },
	  fetchRevenue: function fetchRevenue(apiKey) {
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "GET",
	        endpoint: "god/revenue",
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response);
	      });
	    });
	  },
	  fetchUpcomingEvents: function fetchUpcomingEvents(apiKey) {
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "GET",
	        endpoint: "god/upcoming_events",
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response);
	      });
	    });
	  },
	  becomePerson: function becomePerson(apiKey, person) {
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "POST",
	        endpoint: "god/become_person",
	        json: { person: person },
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response);
	      });
	    });
	  }
	};
	module.exports = exports["default"];

/***/ }),
/* 2940 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _values = __webpack_require__(1214);
	
	var _values2 = _interopRequireDefault(_values);
	
	var _pickBy = __webpack_require__(1163);
	
	var _pickBy2 = _interopRequireDefault(_pickBy);
	
	var _moment = __webpack_require__(1021);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _reactRouter = __webpack_require__(486);
	
	var _materialUi = __webpack_require__(576);
	
	var _reactable = __webpack_require__(1688);
	
	var _styles = __webpack_require__(917);
	
	var _assignWith = __webpack_require__(2941);
	
	var _assignWith2 = _interopRequireDefault(_assignWith);
	
	var _util = __webpack_require__(1183);
	
	var _connectToStores = __webpack_require__(1226);
	
	var _connectToStores2 = _interopRequireDefault(_connectToStores);
	
	var _GodActions = __webpack_require__(1748);
	
	var _GodActions2 = _interopRequireDefault(_GodActions);
	
	var _GodStore = __webpack_require__(2938);
	
	var _GodStore2 = _interopRequireDefault(_GodStore);
	
	var _UserStore = __webpack_require__(974);
	
	var _UserStore2 = _interopRequireDefault(_UserStore);
	
	var _workingIndicator = __webpack_require__(1664);
	
	var _workingIndicator2 = _interopRequireDefault(_workingIndicator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var GodRevenue = function (_React$Component) {
	  _inherits(GodRevenue, _React$Component);
	
	  function GodRevenue(props) {
	    _classCallCheck(this, GodRevenue);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(GodRevenue).call(this, props));
	
	    _this.downloadCsv = _this.downloadCsv.bind(_this);
	    _this._makeRowData = _this._makeRowData.bind(_this);
	    _this._makeRowForRevenue = _this._makeRowForRevenue.bind(_this);
	    return _this;
	  }
	
	  _createClass(GodRevenue, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      _GodActions2.default.fetchRevenue.defer();
	    }
	  }, {
	    key: "getStyles",
	    value: function getStyles() {
	      return {};
	    }
	  }, {
	    key: "downloadCsv",
	    value: function downloadCsv() {
	      var _this2 = this;
	
	      (0, _util.clientSideDownload)("eventive-organizations-" + new Date().toISOString() + ".csv", "text/csv", (0, _util.makeCsv)(this._makeRowData().map(function (revenue) {
	        var user = _this2.props.condensedUsers.find(function (user) {
	          return user.id === revenue.organization;
	        }) || {
	          organization: revenue.organization || "TOTAL",
	          currency: "usd"
	        };
	        return {
	          "Organization ID": user.id,
	          Organization: user.organization,
	          "Organization LTV": (0, _util.formatPrice)(revenue.sigma.platform_fees.net + revenue.sigma.invoices.total, { currency: "usd" }),
	          "Organization 1y": (0, _util.formatPrice)(revenue.sigma.platform_fees_1y.net + revenue.sigma.invoices_1y.total, { currency: "usd" }),
	          "Platform fees": (0, _util.formatPrice)(revenue.sigma.platform_fees.net, {
	            currency: "usd"
	          }),
	          "Platform fees 1y": (0, _util.formatPrice)(revenue.sigma.platform_fees_1y.net, {
	            currency: "usd"
	          }),
	          "Payments net": (0, _util.formatPrice)(revenue.sigma.payments.net, {
	            currency: "usd"
	          }),
	          "Invoices total": (0, _util.formatPrice)(revenue.sigma.invoices.total, {
	            currency: "usd"
	          }),
	          "Invoices 1y": (0, _util.formatPrice)(revenue.sigma.invoices_1y.total, {
	            currency: "usd"
	          })
	        };
	      })));
	    }
	  }, {
	    key: "_makeRowData",
	    value: function _makeRowData() {
	      var totalRow = this.props.revenue.reduce(function (total, r) {
	        return {
	          gross_volume: total.gross_volume + r.gross_volume,
	          net_volume: total.net_volume + r.net_volume,
	          sigma: {
	            platform_fees: {
	              net: total.sigma.platform_fees.net + r.sigma.platform_fees.net
	            },
	            payments: {
	              total: total.sigma.payments.total + r.sigma.payments.total,
	              net: total.sigma.payments.net + r.sigma.payments.net
	            },
	            platform_fees_1y: {
	              net: total.sigma.platform_fees_1y.net + r.sigma.platform_fees_1y.net
	            },
	            payments_1y: {
	              total: total.sigma.payments_1y.total + r.sigma.payments_1y.total,
	              net: total.sigma.payments_1y.net + r.sigma.payments_1y.net
	            },
	            invoices: {
	              total: total.sigma.invoices.total + r.sigma.invoices.total
	            },
	            invoices_1y: {
	              total: total.sigma.invoices_1y.total + r.sigma.invoices_1y.total
	            }
	          }
	        };
	      }, {
	        gross_volume: 0,
	        net_volume: 0,
	        sigma: {
	          platform_fees: { net: 0 },
	          payments: { total: 0, net: 0 },
	          platform_fees_1y: { net: 0 },
	          payments_1y: { total: 0, net: 0 },
	          invoices: { total: 0 },
	          invoices_1y: { total: 0 }
	        }
	      });
	      return [totalRow].concat(this.props.revenue);
	    }
	  }, {
	    key: "_makeRowForRevenue",
	    value: function _makeRowForRevenue(revenue) {
	      var user = this.props.condensedUsers.find(function (user) {
	        return user.id === revenue.organization;
	      }) || {
	        organization: revenue.organization || "TOTAL",
	        currency: "usd"
	      },
	          isTotal = user.organization === "TOTAL";
	
	      return _react2.default.createElement(
	        _reactable.Tr,
	        { style: isTotal ? { fontWeight: "bold" } : {} },
	        _react2.default.createElement(
	          _reactable.Td,
	          { column: "Organization", value: user.organization },
	          isTotal ? "TOTAL" : _react2.default.createElement(
	            "a",
	            {
	              href: "/organization_health?_god_become_user=" + user.id,
	              target: "_blank"
	            },
	            user.organization
	          )
	        ),
	        _react2.default.createElement(
	          _reactable.Td,
	          {
	            column: "Organization LTV",
	            value: revenue.sigma.platform_fees.net + revenue.sigma.invoices.total || 0
	          },
	          (0, _util.formatPrice)(revenue.sigma.platform_fees.net + revenue.sigma.invoices.total, { currency: "usd" })
	        ),
	        _react2.default.createElement(
	          _reactable.Td,
	          {
	            column: "Organization LTV 1y",
	            value: revenue.sigma.platform_fees_1y.net + revenue.sigma.invoices_1y.total || 0
	          },
	          (0, _util.formatPrice)(revenue.sigma.platform_fees_1y.net + revenue.sigma.invoices_1y.total, { currency: "usd" })
	        ),
	        _react2.default.createElement(
	          _reactable.Td,
	          { column: "Fees", value: revenue.sigma.platform_fees.net || 0 },
	          (0, _util.formatPrice)(revenue.sigma.platform_fees.net, { currency: "usd" })
	        ),
	        _react2.default.createElement(
	          _reactable.Td,
	          { column: "Fees 1y", value: revenue.sigma.platform_fees_1y.net || 0 },
	          (0, _util.formatPrice)(revenue.sigma.platform_fees_1y.net, { currency: "usd" })
	        ),
	        _react2.default.createElement(
	          _reactable.Td,
	          { column: "Invoices", value: revenue.sigma.invoices.total || 0 },
	          (0, _util.formatPrice)(revenue.sigma.invoices.total, { currency: "usd" })
	        ),
	        _react2.default.createElement(
	          _reactable.Td,
	          { column: "Invoices 1y", value: revenue.sigma.invoices_1y.total || 0 },
	          (0, _util.formatPrice)(revenue.sigma.invoices_1y.total, { currency: "usd" })
	        )
	      );
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this3 = this;
	
	      var styles = this.getStyles();
	
	      if (!this.props.revenue || !this.props.condensedUsers) {
	        return _react2.default.createElement(_workingIndicator2.default, { fullPage: true });
	      }
	
	      var rows = this._makeRowData().map(this._makeRowForRevenue);
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          "h1",
	          null,
	          "God Revenue"
	        ),
	        _react2.default.createElement(
	          "div",
	          { style: { marginTop: 20, marginBottom: 20 } },
	          _react2.default.createElement(_materialUi.RaisedButton, {
	            onClick: function onClick() {
	              return _this3.downloadCsv();
	            },
	            label: "Download all data (.CSV)"
	          })
	        ),
	        _react2.default.createElement(
	          _reactable.Table,
	          {
	            className: "bordered striped responsive-table",
	            sortable: ["Organization", "Organization LTV", "Organization LTV 1y", "Fees", "Fees 1y", "Invoices", "Invoices 1y"],
	            defaultSort: { column: "Organization LTV 1y", direction: "desc" },
	            filterable: ["Organization"],
	            filterPlaceholder: "Type to filter..."
	          },
	          rows
	        ),
	        _react2.default.createElement(
	          "p",
	          null,
	          _react2.default.createElement(
	            "i",
	            null,
	            "Sigma data last fetched",
	            " ",
	            (0, _moment2.default)(this.props.revenue[0] ? this.props.revenue[0].sigma.updated_at : 0).format("lll"),
	            "."
	          )
	        )
	      );
	    }
	  }], [{
	    key: "getStores",
	    value: function getStores() {
	      return [_UserStore2.default, _GodStore2.default];
	    }
	  }, {
	    key: "getPropsFromStores",
	    value: function getPropsFromStores() {
	      return {
	        revenue: _GodStore2.default.getState().revenue,
	        condensedUsers: _UserStore2.default.getState().condensedUsers
	      };
	    }
	  }, {
	    key: "contextTypes",
	    get: function get() {
	      return {
	        router: _react2.default.PropTypes.object
	      };
	    }
	  }]);
	
	  return GodRevenue;
	}(_react2.default.Component);
	
	exports.default = (0, _connectToStores2.default)(GodRevenue);
	module.exports = exports["default"];

/***/ }),
/* 2941 */
/***/ (function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(802),
	    createAssigner = __webpack_require__(810),
	    keys = __webpack_require__(921);
	
	/**
	 * This method is like `_.assign` except that it accepts `customizer`
	 * which is invoked to produce the assigned values. If `customizer` returns
	 * `undefined`, assignment is handled by the method instead. The `customizer`
	 * is invoked with five arguments: (objValue, srcValue, key, object, source).
	 *
	 * **Note:** This method mutates `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Object
	 * @param {Object} object The destination object.
	 * @param {...Object} sources The source objects.
	 * @param {Function} [customizer] The function to customize assigned values.
	 * @returns {Object} Returns `object`.
	 * @see _.assignInWith
	 * @example
	 *
	 * function customizer(objValue, srcValue) {
	 *   return _.isUndefined(objValue) ? srcValue : objValue;
	 * }
	 *
	 * var defaults = _.partialRight(_.assignWith, customizer);
	 *
	 * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	 * // => { 'a': 1, 'b': 2 }
	 */
	var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
	  copyObject(source, keys(source), object, customizer);
	});
	
	module.exports = assignWith;


/***/ }),
/* 2942 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _values = __webpack_require__(1214);
	
	var _values2 = _interopRequireDefault(_values);
	
	var _pickBy = __webpack_require__(1163);
	
	var _pickBy2 = _interopRequireDefault(_pickBy);
	
	var _groupBy = __webpack_require__(2637);
	
	var _groupBy2 = _interopRequireDefault(_groupBy);
	
	var _momentTimezone = __webpack_require__(1185);
	
	var _momentTimezone2 = _interopRequireDefault(_momentTimezone);
	
	var _reactRouter = __webpack_require__(486);
	
	var _materialUi = __webpack_require__(576);
	
	var _reactable = __webpack_require__(1688);
	
	var _styles = __webpack_require__(917);
	
	var _assignWith = __webpack_require__(2941);
	
	var _assignWith2 = _interopRequireDefault(_assignWith);
	
	var _util = __webpack_require__(1183);
	
	var _connectToStores = __webpack_require__(1226);
	
	var _connectToStores2 = _interopRequireDefault(_connectToStores);
	
	var _GodActions = __webpack_require__(1748);
	
	var _GodActions2 = _interopRequireDefault(_GodActions);
	
	var _GodStore = __webpack_require__(2938);
	
	var _GodStore2 = _interopRequireDefault(_GodStore);
	
	var _UserStore = __webpack_require__(974);
	
	var _UserStore2 = _interopRequireDefault(_UserStore);
	
	var _workingIndicator = __webpack_require__(1664);
	
	var _workingIndicator2 = _interopRequireDefault(_workingIndicator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _color = function _color(count) {
	  return count === 0 ? "#ccc" : count > 1000 ? "#f44336" : count > 500 ? "#ff9800" : count > 100 ? "#8bc34a" : "#4caf50";
	};
	
	var GodUpcomingEvents = function (_React$Component) {
	  _inherits(GodUpcomingEvents, _React$Component);
	
	  function GodUpcomingEvents(props) {
	    _classCallCheck(this, GodUpcomingEvents);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(GodUpcomingEvents).call(this, props));
	
	    _this.state = {
	      includeEventsBeforeNow: false,
	      includePhysicalEvents: false,
	      groupByEventBucket: false
	    };
	    _this.downloadCsv = _this.downloadCsv.bind(_this);
	    _this._makeRowData = _this._makeRowData.bind(_this);
	    _this._makeRowForUpcomingEvent = _this._makeRowForUpcomingEvent.bind(_this);
	    return _this;
	  }
	
	  _createClass(GodUpcomingEvents, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      _GodActions2.default.fetchUpcomingEvents.defer();
	    }
	  }, {
	    key: "getStyles",
	    value: function getStyles() {
	      return {};
	    }
	  }, {
	    key: "downloadCsv",
	    value: function downloadCsv() {
	      var _this2 = this;
	
	      (0, _util.clientSideDownload)("eventive-upcoming-events-" + new Date().toISOString() + ".csv", "text/csv", (0, _util.makeCsv)(this._makeRowData().map(function (upcomingEvent) {
	        var user = _this2.props.condensedUsers.find(function (user) {
	          return user.id === upcomingEvent._owner;
	        }) || {
	          organization: "-"
	        };
	        return _extends({
	          "Organization ID": user.id,
	          Organization: user.organization,
	          "Event Bucket": upcomingEvent.event_bucket_name,
	          Event: upcomingEvent.name,
	          "Start Date": upcomingEvent.start_time,
	          "End Date": upcomingEvent.end_time,
	          Type: _this2.state.groupByEventBucket ? "Event Bucket" : upcomingEvent.is_virtual ? "Virtual" : "Physical",
	          "Tickets Issued": upcomingEvent.tickets_issued
	        }, _this2.state.groupByEventBucket ? {
	          "Passes Issued": upcomingEvent.passes_issued
	        } : null);
	      })));
	    }
	  }, {
	    key: "_makeRowData",
	    value: function _makeRowData() {
	      var _this3 = this;
	
	      var events = this.props.upcomingEvents.upcoming_events.filter(function (e) {
	        if (!_this3.state.includeEventsBeforeNow && Date.now() - new Date(e.start_time) > 1000 * 60 * 60 * 24 * 30) {
	          return false;
	        }
	        if (_this3.state.includePhysicalEvents) {
	          return true;
	        } else {
	          return !!e.is_virtual;
	        }
	      });
	
	      if (this.state.groupByEventBucket) {
	        var _ret = function () {
	          var eventsByEventBucket = (0, _groupBy2.default)(events, "event_bucket");
	          return {
	            v: Object.keys(eventsByEventBucket).map(function (eventBucketId) {
	              var events = eventsByEventBucket[eventBucketId];
	              var start_time = Number.MAX_VALUE,
	                  end_time = Number.MIN_VALUE,
	                  tickets_issued = 0;
	              var _iteratorNormalCompletion = true;
	              var _didIteratorError = false;
	              var _iteratorError = undefined;
	
	              try {
	                for (var _iterator = events[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                  var e = _step.value;
	
	                  if (new Date(e.start_time) < start_time) {
	                    start_time = e.start_time;
	                  }
	                  if (new Date(e.end_time) > end_time) {
	                    end_time = e.end_time;
	                  }
	                  tickets_issued += e.tickets_issued;
	                }
	              } catch (err) {
	                _didIteratorError = true;
	                _iteratorError = err;
	              } finally {
	                try {
	                  if (!_iteratorNormalCompletion && _iterator.return) {
	                    _iterator.return();
	                  }
	                } finally {
	                  if (_didIteratorError) {
	                    throw _iteratorError;
	                  }
	                }
	              }
	
	              return {
	                _owner: events[0]._owner,
	                event_bucket: events[0].event_bucket,
	                event_bucket_name: events[0].event_bucket_name,
	                start_time: start_time,
	                end_time: end_time,
	                tickets_issued: tickets_issued,
	                passes_issued: _this3.props.upcomingEvents.passes_issued_by_event_bucket[eventBucketId] || 0,
	                is_virtual: events.some(function (e) {
	                  return e.is_virtual;
	                }),
	                is_dated: true,
	                timezone: _momentTimezone2.default.tz.guess()
	              };
	            })
	          };
	        }();
	
	        if ((typeof _ret === "undefined" ? "undefined" : _typeof(_ret)) === "object") return _ret.v;
	      }
	
	      return events.map(function (e) {
	        return _extends({}, e, {
	          is_dated: true,
	          timezone: _momentTimezone2.default.tz.guess()
	        });
	      });
	    }
	  }, {
	    key: "_makeRowForUpcomingEvent",
	    value: function _makeRowForUpcomingEvent(upcomingEvent) {
	      var user = this.props.condensedUsers.find(function (user) {
	        return user.id === upcomingEvent._owner;
	      }) || {
	        organization: "-"
	      };
	
	      return _react2.default.createElement(
	        _reactable.Tr,
	        null,
	        _react2.default.createElement(
	          _reactable.Td,
	          { column: "Organization", value: user.organization },
	          _react2.default.createElement(
	            "a",
	            {
	              href: "/organization_health?_god_become_user=" + user.id,
	              target: "_blank"
	            },
	            user.organization
	          )
	        ),
	        _react2.default.createElement(
	          _reactable.Td,
	          { column: "Event Bucket", value: upcomingEvent.event_bucket_name },
	          _react2.default.createElement(
	            "span",
	            null,
	            _react2.default.createElement(
	              "a",
	              {
	                href: "/event_buckets/" + upcomingEvent.event_bucket + "?_god_become_user=" + user.id,
	                target: "_blank"
	              },
	              upcomingEvent.event_bucket_name
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _reactable.Td,
	          { column: "Event", value: upcomingEvent.name },
	          _react2.default.createElement(
	            "span",
	            null,
	            _react2.default.createElement(
	              "a",
	              {
	                href: "/event_buckets/" + upcomingEvent.event_bucket + "/events/" + upcomingEvent._id + "?_god_become_user=" + user.id,
	                target: "_blank"
	              },
	              upcomingEvent.name
	            ),
	            upcomingEvent.is_virtual ? "" : "*"
	          )
	        ),
	        _react2.default.createElement(
	          _reactable.Td,
	          { column: "Date", value: upcomingEvent.start_time || "-" },
	          _react2.default.createElement(
	            "span",
	            {
	              style: {
	                whiteSpace: "nowrap",
	                fontStyle: upcomingEvent.is_virtual ? "" : "italic"
	              }
	            },
	            (0, _util.makeEventDateRangeLabel)(_extends({}, upcomingEvent, { is_virtual: false }))
	          )
	        ),
	        _react2.default.createElement(
	          _reactable.Td,
	          {
	            column: "Tickets Issued",
	            value: upcomingEvent.tickets_issued,
	            style: {
	              backgroundColor: _color(upcomingEvent.tickets_issued),
	              color: "#fff",
	              borderBottom: "1px solid #fff",
	              fontStyle: upcomingEvent.is_virtual ? "" : "italic"
	            }
	          },
	          _react2.default.createElement(
	            "span",
	            null,
	            upcomingEvent.tickets_issued.toLocaleString(),
	            upcomingEvent.is_virtual ? "" : "*"
	          )
	        ),
	        _react2.default.createElement(
	          _reactable.Td,
	          {
	            column: "Passes Issued",
	            value: upcomingEvent.passes_issued,
	            style: {
	              backgroundColor: _color(upcomingEvent.passes_issued),
	              color: "#fff",
	              borderBottom: "1px solid #fff",
	              borderLeft: "1px solid #fff"
	            }
	          },
	          _react2.default.createElement(
	            "span",
	            null,
	            upcomingEvent.passes_issued && upcomingEvent.passes_issued.toLocaleString()
	          )
	        )
	      );
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this4 = this;
	
	      var styles = this.getStyles();
	
	      if (!this.props.upcomingEvents || !this.props.condensedUsers) {
	        return _react2.default.createElement(_workingIndicator2.default, { fullPage: true });
	      }
	
	      var rows = this._makeRowData().map(this._makeRowForUpcomingEvent);
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          "h1",
	          null,
	          "God Upcoming Events with >10 tickets issued"
	        ),
	        _react2.default.createElement(
	          "div",
	          { style: { marginTop: 20, marginBottom: 20 } },
	          _react2.default.createElement(_materialUi.RaisedButton, {
	            onClick: function onClick() {
	              return _this4.downloadCsv();
	            },
	            label: "Download all upcoming " + (this.state.groupByEventBucket ? "event buckets" : "events") + " (.CSV)"
	          })
	        ),
	        _react2.default.createElement(
	          "div",
	          { style: { marginBottom: 10 } },
	          _react2.default.createElement(_materialUi.Checkbox, {
	            label: "Include physical events" + (this.state.includePhysicalEvents ? " (marked with *)" : ""),
	            value: this.state.includePhysicalEvents,
	            style: { width: 310 },
	            onCheck: function onCheck(e) {
	              return _this4.setState({
	                includePhysicalEvents: !_this4.state.includePhysicalEvents
	              });
	            }
	          }),
	          _react2.default.createElement(_materialUi.Checkbox, {
	            label: "Group by event bucket",
	            value: this.state.groupByEventBucket,
	            style: { width: 310 },
	            onCheck: function onCheck(e) {
	              return _this4.setState({
	                groupByEventBucket: !_this4.state.groupByEventBucket
	              });
	            }
	          }),
	          _react2.default.createElement(_materialUi.Checkbox, {
	            label: "Include events that started over a month ago",
	            value: this.state.includeEventsBeforeNow,
	            style: { width: 340 },
	            onCheck: function onCheck(e) {
	              return _this4.setState({
	                includeEventsBeforeNow: !_this4.state.includeEventsBeforeNow
	              });
	            }
	          })
	        ),
	        _react2.default.createElement(
	          _reactable.Table,
	          {
	            className: "bordered striped responsive-table",
	            columns: ["Organization", "Event Bucket"].concat(this.state.groupByEventBucket ? [] : ["Event"]).concat([{ key: "Date", label: "Date (" + _momentTimezone2.default.tz.guess() + ")" }, "Tickets Issued"].concat(this.state.groupByEventBucket ? ["Passes Issued"] : [])),
	            sortable: ["Organization", "Event Bucket", "Event", "Date", "Tickets Issued", "Passes Issued"],
	            defaultSort: { column: "Date", direction: "asc" },
	            filterable: ["Organization", "Event Bucket", "Event", "Date"],
	            filterPlaceholder: "Type to filter..."
	          },
	          rows
	        )
	      );
	    }
	  }], [{
	    key: "getStores",
	    value: function getStores() {
	      return [_UserStore2.default, _GodStore2.default];
	    }
	  }, {
	    key: "getPropsFromStores",
	    value: function getPropsFromStores() {
	      return {
	        upcomingEvents: _GodStore2.default.getState().upcomingEvents,
	        condensedUsers: _UserStore2.default.getState().condensedUsers
	      };
	    }
	  }, {
	    key: "contextTypes",
	    get: function get() {
	      return {
	        router: _react2.default.PropTypes.object
	      };
	    }
	  }]);
	
	  return GodUpcomingEvents;
	}(_react2.default.Component);
	
	exports.default = (0, _connectToStores2.default)(GodUpcomingEvents);
	module.exports = exports["default"];

/***/ }),
/* 2943 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _UserStore = __webpack_require__(974);
	
	var _UserStore2 = _interopRequireDefault(_UserStore);
	
	var _reactIframeResizerSuper = __webpack_require__(2307);
	
	var _reactIframeResizerSuper2 = _interopRequireDefault(_reactIframeResizerSuper);
	
	var _connectToStores = __webpack_require__(1226);
	
	var _connectToStores2 = _interopRequireDefault(_connectToStores);
	
	var _workingIndicator = __webpack_require__(1664);
	
	var _workingIndicator2 = _interopRequireDefault(_workingIndicator);
	
	var _viewLiveVirtualButton = __webpack_require__(1865);
	
	var _viewLiveVirtualButton2 = _interopRequireDefault(_viewLiveVirtualButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var GodStreams = function (_React$Component) {
	  _inherits(GodStreams, _React$Component);
	
	  function GodStreams(props) {
	    _classCallCheck(this, GodStreams);
	
	    return _possibleConstructorReturn(this, Object.getPrototypeOf(GodStreams).call(this, props));
	  }
	
	  _createClass(GodStreams, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {}
	  }, {
	    key: "getStyles",
	    value: function getStyles() {
	      return {};
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var styles = this.getStyles();
	
	      if (!this.props.apiKey) {
	        return _react2.default.createElement(_workingIndicator2.default, { fullPage: true });
	      }
	
	      var destination = ("https://watch.eventive.org/") + "admin/analytics?data=" + btoa(JSON.stringify({
	        is_god_view: true,
	        api_key: this.props.apiKey
	      }));
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          "h1",
	          null,
	          "God Streams"
	        ),
	        _react2.default.createElement(_viewLiveVirtualButton2.default, {
	          href: ("https://watch.eventive.org/"),
	          label: "Watch on Eventive",
	          godMode: true,
	          primary: true,
	          style: { margin: "1em 0" }
	        }),
	        _react2.default.createElement(_reactIframeResizerSuper2.default, {
	          style: {
	            width: "1px",
	            minWidth: "100%",
	            marginTop: "1em",
	            border: "none"
	          },
	          src: destination
	        })
	      );
	    }
	  }], [{
	    key: "getStores",
	    value: function getStores() {
	      return [_UserStore2.default];
	    }
	  }, {
	    key: "getPropsFromStores",
	    value: function getPropsFromStores() {
	      return _UserStore2.default.getState();
	    }
	  }, {
	    key: "contextTypes",
	    get: function get() {
	      return {
	        router: _react2.default.PropTypes.object
	      };
	    }
	  }]);
	
	  return GodStreams;
	}(_react2.default.Component);
	
	exports.default = (0, _connectToStores2.default)(GodStreams);
	module.exports = exports["default"];

/***/ }),
/* 2944 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _UserStore = __webpack_require__(974);
	
	var _UserStore2 = _interopRequireDefault(_UserStore);
	
	var _connectToStores = __webpack_require__(1226);
	
	var _connectToStores2 = _interopRequireDefault(_connectToStores);
	
	var _globalSearch = __webpack_require__(1228);
	
	var _globalSearch2 = _interopRequireDefault(_globalSearch);
	
	var _workingIndicator = __webpack_require__(1664);
	
	var _workingIndicator2 = _interopRequireDefault(_workingIndicator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var GodLookup = function (_React$Component) {
	  _inherits(GodLookup, _React$Component);
	
	  function GodLookup(props) {
	    _classCallCheck(this, GodLookup);
	
	    return _possibleConstructorReturn(this, Object.getPrototypeOf(GodLookup).call(this, props));
	  }
	
	  _createClass(GodLookup, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {}
	  }, {
	    key: "getStyles",
	    value: function getStyles() {
	      return {};
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var styles = this.getStyles();
	
	      if (!this.props.apiKey) {
	        return _react2.default.createElement(_workingIndicator2.default, { fullPage: true });
	      }
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          "h1",
	          null,
	          "God Lookup"
	        ),
	        _react2.default.createElement(
	          "p",
	          null,
	          "Find anyone, anything, anywhere."
	        ),
	        _react2.default.createElement(_globalSearch2.default, { godMode: true })
	      );
	    }
	  }], [{
	    key: "getStores",
	    value: function getStores() {
	      return [_UserStore2.default];
	    }
	  }, {
	    key: "getPropsFromStores",
	    value: function getPropsFromStores() {
	      return _UserStore2.default.getState();
	    }
	  }, {
	    key: "contextTypes",
	    get: function get() {
	      return {
	        router: _react2.default.PropTypes.object
	      };
	    }
	  }]);
	
	  return GodLookup;
	}(_react2.default.Component);
	
	exports.default = (0, _connectToStores2.default)(GodLookup);
	module.exports = exports["default"];

/***/ }),
/* 2945 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _moment = __webpack_require__(1021);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _reactSelect = __webpack_require__(953);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	var _colors = __webpack_require__(821);
	
	var colors = _interopRequireWildcard(_colors);
	
	var _connectToStores = __webpack_require__(1226);
	
	var _connectToStores2 = _interopRequireDefault(_connectToStores);
	
	var _UserStore = __webpack_require__(974);
	
	var _UserStore2 = _interopRequireDefault(_UserStore);
	
	var _BillingUtil = __webpack_require__(1749);
	
	var _BillingUtil2 = _interopRequireDefault(_BillingUtil);
	
	var _util = __webpack_require__(1183);
	
	var _tableRefreshIndicator = __webpack_require__(1686);
	
	var _tableRefreshIndicator2 = _interopRequireDefault(_tableRefreshIndicator);
	
	var _genericAnalyticsTable = __webpack_require__(1687);
	
	var _genericAnalyticsTable2 = _interopRequireDefault(_genericAnalyticsTable);
	
	var _queryString = __webpack_require__(513);
	
	var _queryString2 = _interopRequireDefault(_queryString);
	
	var _workingIndicator = __webpack_require__(1664);
	
	var _workingIndicator2 = _interopRequireDefault(_workingIndicator);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var parsedQueryString = _queryString2.default.parse(window.location.search);
	
	var BILLING_TIMEZONE = "America/Chicago";
	
	var GodInvoicingHub = function (_React$Component) {
	  _inherits(GodInvoicingHub, _React$Component);
	
	  function GodInvoicingHub(props) {
	    _classCallCheck(this, GodInvoicingHub);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(GodInvoicingHub).call(this, props));
	
	    _this.state = {
	      hubData: null,
	      selectedMonth: parsedQueryString.month || (0, _moment2.default)().tz(BILLING_TIMEZONE).format("MM-YYYY")
	    };
	    return _this;
	  }
	
	  _createClass(GodInvoicingHub, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {}
	  }, {
	    key: "_generateMonths",
	    value: function _generateMonths() {
	      var curr = (0, _moment2.default)("02-2021", "MM-YYYY") // first month of ledger billing = Feb 2021
	      .tz(BILLING_TIMEZONE).startOf("month");
	      var end = (0, _moment2.default)().tz(BILLING_TIMEZONE).startOf("month");
	
	      var months = [];
	
	      while (curr) {
	        if (curr <= end) {
	          months.push({
	            value: curr.format("MM-YYYY"),
	            label: curr.diff(end) === 0 ? (0, _moment2.default)().tz(BILLING_TIMEZONE).format("MMMM [1]–D, YYYY") : curr.format("MMMM YYYY"),
	            _end: (0, _moment2.default)(curr).endOf("month")
	          });
	          curr.add(1, "month");
	        } else {
	          curr = null;
	        }
	      }
	
	      return months.reverse();
	    }
	  }, {
	    key: "_loadHub",
	    value: function _loadHub() {
	      var _this2 = this;
	
	      var _ref = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	      var quiet = _ref.quiet;
	
	      var selectingMonth = this.state.selectedMonth;
	
	      this.setState(Object.assign({ loading: true }, !quiet && { hubData: null }));
	
	      _BillingUtil2.default.fetchInvoicingHub(_UserStore2.default.getState().apiKey, {
	        month: selectingMonth
	      }).then(function (data) {
	        if (_this2.state.selectedMonth === selectingMonth) {
	          _this2.setState({
	            loading: false,
	            hubData: data
	          });
	        }
	      }).catch(function (e) {
	        return window.alert(e.message);
	      });
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(newProps) {
	      if (!this.state.loading && !this.state.hubData) {
	        this._loadHub();
	      }
	    }
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.componentWillReceiveProps(this.props);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this3 = this;
	
	      var months = this._generateMonths();
	
	      if (!this.props.apiKey) {
	        return _react2.default.createElement(_workingIndicator2.default, { fullPage: true });
	      }
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          "h2",
	          { style: { display: "flex", alignItems: "center" } },
	          _react2.default.createElement(
	            "span",
	            { style: { whiteSpace: "nowrap" } },
	            "God Invoicing Hub for"
	          ),
	          _react2.default.createElement(
	            "div",
	            {
	              style: {
	                display: "inline-block",
	                width: 250,
	                marginLeft: 10
	              }
	            },
	            _react2.default.createElement(_reactSelect2.default, {
	              clearable: false,
	              value: this.state.selectedMonth,
	              options: months,
	              onChange: function onChange(e) {
	                return _this3.setState({ selectedMonth: e.value }, function () {
	                  _this3.context.router.replace("/god/invoicing_hub?month=" + e.value);
	                  _this3._loadHub();
	                });
	              }
	            })
	          )
	        ),
	        this.state.hubData ? _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement(_tableRefreshIndicator2.default, {
	            isRefreshing: this.state.loading,
	            onRefresh: function onRefresh() {
	              return _this3._loadHub({ quiet: true });
	            },
	            style: { marginTop: -45 }
	          }),
	          _react2.default.createElement(_genericAnalyticsTable2.default, {
	            csvLabel: "eventive-invoice",
	            csvLabelDetail: this.state.selectedMonth,
	            noSort: true,
	            noDownload: true,
	            data: this.state.hubData.users.map(function (user, i) {
	              return {
	                index: i + 1,
	                organization: user.organization,
	                net: {
	                  value: user.net,
	                  label: (0, _util.formatPrice)(user.net, {
	                    currency: user.currency,
	                    accounting: true
	                  })
	                },
	                invoice: {
	                  value: "",
	                  label: user.invoice && user.invoice.stripe_invoice_id ? _react2.default.createElement(
	                    "a",
	                    {
	                      href: "https://dashboard.stripe.com/invoices/" + user.invoice.stripe_invoice_id + "/edit",
	                      target: "_blank",
	                      style: { color: "#fff" }
	                    },
	                    (0, _moment2.default)(user.invoice.finalized_at).format("MMM D h:mm a")
	                  ) : "NOT YET",
	                  itemStyle: {
	                    backgroundColor: user.invoice && user.invoice.stripe_invoice_id ? colors.green600 : colors.red800,
	                    color: "#fff",
	                    borderBottom: "1px solid #fff",
	                    fontWeight: "bold"
	                  }
	                },
	                actions: {
	                  value: "",
	                  label: _react2.default.createElement(
	                    "span",
	                    null,
	                    _react2.default.createElement(
	                      "a",
	                      {
	                        target: "_blank",
	                        href: "/billing?month=" + _this3.state.selectedMonth + "&_god_become_user=" + user.id
	                      },
	                      "View billing"
	                    )
	                  )
	                }
	              };
	            }),
	            columns: [{ label: "Rank", value: "index" }, { label: "Organization", value: "organization" }, { label: "Net", value: "net" }, { label: "Invoiced", value: "invoice" }, { label: "Actions", value: "actions" }]
	          })
	        ) : _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement(_workingIndicator2.default, { fullPage: true })
	        )
	      );
	    }
	  }], [{
	    key: "getStores",
	    value: function getStores() {
	      return [_UserStore2.default];
	    }
	  }, {
	    key: "getPropsFromStores",
	    value: function getPropsFromStores() {
	      return _UserStore2.default.getState();
	    }
	  }, {
	    key: "contextTypes",
	    get: function get() {
	      return {
	        router: _react2.default.PropTypes.object
	      };
	    }
	  }]);
	
	  return GodInvoicingHub;
	}(_react2.default.Component);
	
	exports.default = (0, _connectToStores2.default)(GodInvoicingHub);
	module.exports = exports["default"];

/***/ }),
/* 2946 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactSelect = __webpack_require__(953);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	var _connectToStores = __webpack_require__(1226);
	
	var _connectToStores2 = _interopRequireDefault(_connectToStores);
	
	var _UserStore = __webpack_require__(974);
	
	var _UserStore2 = _interopRequireDefault(_UserStore);
	
	var _UserActions = __webpack_require__(1158);
	
	var _UserActions2 = _interopRequireDefault(_UserActions);
	
	var _OrganizationHealthUtil = __webpack_require__(2947);
	
	var _OrganizationHealthUtil2 = _interopRequireDefault(_OrganizationHealthUtil);
	
	var _workingIndicator = __webpack_require__(1664);
	
	var _workingIndicator2 = _interopRequireDefault(_workingIndicator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CHARTS_BASE_URL = "https://charts.mongodb.com/charts-eventive-production-cchlr";
	var CHARTS_SCRIPT_URL = "https://unpkg.com/@mongodb-js/charts-embed-dom";
	
	var CHARTS = [{
	  id: "f0dc5c54-fbf1-4588-9212-4f9929b8a7aa",
	  name: "USD-Only Ledger Billings By Month",
	  getStyles: function getStyles() {
	    return {
	      gridColumn: "1 / span 2"
	    };
	  }
	}, {
	  id: "4b71466d-9b0e-4daf-9543-fbf8b02a9e92",
	  name: "USD-Only Ledger Billings By Year",
	  getStyles: function getStyles() {
	    return {
	      gridColumn: "1 / span 2"
	    };
	  }
	}, {
	  id: "c22b80df-4568-4336-89c5-b761c9260129",
	  name: "Non-USD Ledger Billings By Month",
	  filter: function filter(_ref) {
	    var user = _ref.user;
	    return user.currency !== "usd";
	  },
	  getStyles: function getStyles() {
	    return {
	      gridColumn: "1 / span 2"
	    };
	  }
	}, {
	  id: "fce03c03-0446-4f23-82d4-da3a52f2d530",
	  name: "Number of Unlock Fees Per Month"
	}, {
	  id: "2adac36d-957d-4cd0-8ed1-bd31455319a3",
	  name: "Number of Tickets Per Month"
	}];
	
	var OrganizationHealth = function (_React$Component) {
	  _inherits(OrganizationHealth, _React$Component);
	
	  function OrganizationHealth(props) {
	    _classCallCheck(this, OrganizationHealth);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(OrganizationHealth).call(this, props));
	
	    _this.state = {
	      data: null
	    };
	
	    _this.chartContainers = {};
	
	    _this.getChartSpecifications = _this.getChartSpecifications.bind(_this);
	    _this.renderCharts = _this.renderCharts.bind(_this);
	    _this.changeUser = _this.changeUser.bind(_this);
	    return _this;
	  }
	
	  _createClass(OrganizationHealth, [{
	    key: "getChartSpecifications",
	    value: function getChartSpecifications() {
	      return CHARTS.filter(function (chart) {
	        if (chart.filter) {
	          return chart.filter({ user: _UserStore2.default.getUser() });
	        }
	        return true;
	      });
	    }
	  }, {
	    key: "renderCharts",
	    value: function renderCharts() {
	      var _this2 = this;
	
	      if (!_UserStore2.default.getUser() || !window.ChartsEmbedSDK) {
	        setTimeout(function () {
	          return _this2.renderCharts();
	        }, 100);
	        return;
	      }
	
	      var _state$data = this.state.data;
	      var organization_id = _state$data.organization_id;
	      var chart_token = _state$data.chart_token;
	
	
	      var sdk = new window.ChartsEmbedSDK({
	        baseUrl: CHARTS_BASE_URL,
	        getUserToken: function getUserToken() {
	          return chart_token;
	        }
	      });
	
	      this.getChartSpecifications().forEach(function (_ref2) {
	        var id = _ref2.id;
	        var name = _ref2.name;
	
	        var chart = sdk.createChart({
	          chartId: id,
	          filter: {
	            _owner: { $eq: { $oid: organization_id } }
	          },
	          showAttribution: false
	        });
	
	        chart.render(_this2.chartContainers[id]);
	      });
	    }
	  }, {
	    key: "changeUser",
	    value: function changeUser(userId) {
	      _UserActions2.default.setGodUser(userId);
	      this.setState({ data: null, isFetching: false });
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps() {
	      var _this3 = this;
	
	      if (!this.state.data && !this.state.isFetching) {
	        this.setState({ isFetching: true });
	        _OrganizationHealthUtil2.default.fetchOrganizationHealth(_UserStore2.default.getState().apiKey).then(function (data) {
	          _this3.setState({ isFetching: false, data: data }, function () {
	            if (!document.querySelector("script[src=\"" + CHARTS_SCRIPT_URL + "\"]")) {
	              var script = document.createElement("script");
	              script.type = "text/javascript";
	              script.src = CHARTS_SCRIPT_URL;
	              script.onload = function () {
	                return setTimeout(_this3.renderCharts, 250);
	              };
	              document.body.appendChild(script);
	            } else {
	              _this3.renderCharts();
	            }
	          });
	        }).catch(function (e) {
	          return window.alert("Failed to load Organization Health: " + e.message);
	        });
	      }
	    }
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.componentWillReceiveProps();
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this4 = this;
	
	      var condensedUsers = this.props.condensedUsers;
	      var _state = this.state;
	      var data = _state.data;
	      var isFetching = _state.isFetching;
	
	
	      if (!data || isFetching) {
	        return _react2.default.createElement(_workingIndicator2.default, { fullPage: true, style: { margin: "10% auto" } });
	      }
	
	      return _react2.default.createElement(
	        "div",
	        { style: { fontSize: "12pt", margin: "10px auto 0" } },
	        _react2.default.createElement(
	          "h3",
	          { style: { display: "flex", alignItems: "center" } },
	          _react2.default.createElement(
	            "span",
	            { style: { whiteSpace: "nowrap" } },
	            "Health of"
	          ),
	          _react2.default.createElement(
	            "div",
	            {
	              style: {
	                display: "inline-block",
	                width: 350,
	                marginLeft: 10
	              }
	            },
	            _react2.default.createElement(_reactSelect2.default, {
	              clearable: false,
	              value: data.organization_id,
	              filterOption: function filterOption(o, f) {
	                return f.length > 2 && o.label.toLowerCase().indexOf((f || "").trim().toLowerCase()) !== -1;
	              },
	              options: condensedUsers.filter(function (u) {
	                return u.type !== "content_creator";
	              }).map(function (u) {
	                return {
	                  label: u.organization,
	                  value: u.id
	                };
	              }),
	              noResultsText: "Type to search...",
	              onChange: function onChange(e) {
	                return _this4.changeUser(e.value);
	              }
	            })
	          )
	        ),
	        _react2.default.createElement(
	          "p",
	          null,
	          "This is a God-only view of the health of this organization since January 2021."
	        ),
	        _react2.default.createElement(
	          "div",
	          {
	            style: {
	              display: "grid",
	              gridTemplateColumns: "repeat(2, 1fr)",
	              columnGap: "0em",
	              rowGap: "0em"
	            }
	          },
	          this.getChartSpecifications().map(function (_ref3) {
	            var id = _ref3.id;
	            var name = _ref3.name;
	            var getStyles = _ref3.getStyles;
	
	            return _react2.default.createElement("div", {
	              style: _extends({
	                height: 400
	              }, getStyles ? getStyles({ user: _UserStore2.default.getUser() }) : null),
	              ref: function ref(r) {
	                _this4.chartContainers[id] = r;
	              }
	            });
	          })
	        )
	      );
	    }
	  }], [{
	    key: "getStores",
	    value: function getStores() {
	      return [_UserStore2.default];
	    }
	  }, {
	    key: "getPropsFromStores",
	    value: function getPropsFromStores() {
	      return _UserStore2.default.getState();
	    }
	  }, {
	    key: "contextTypes",
	    get: function get() {
	      return {
	        router: _react2.default.PropTypes.object
	      };
	    }
	  }]);
	
	  return OrganizationHealth;
	}(_react2.default.Component);
	
	exports.default = (0, _connectToStores2.default)(OrganizationHealth);
	module.exports = exports["default"];

/***/ }),
/* 2947 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _api = __webpack_require__(1160);
	
	var _api2 = _interopRequireDefault(_api);
	
	var _config = __webpack_require__(1173);
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  fetchOrganizationHealth: function fetchOrganizationHealth(apiKey) {
	    return new Promise(function (resolve, reject) {
	      _api2.default.request({
	        method: "GET",
	        endpoint: "organization_health",
	        api_key: apiKey
	      }, function (err, response) {
	        if (err) {
	          return reject(err);
	        }
	        resolve(response);
	      });
	    });
	  }
	};
	module.exports = exports["default"];

/***/ }),
/* 2948 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(486);
	
	var _connectToStores = __webpack_require__(1226);
	
	var _connectToStores2 = _interopRequireDefault(_connectToStores);
	
	var _UserStore = __webpack_require__(974);
	
	var _UserStore2 = _interopRequireDefault(_UserStore);
	
	var _PassUtil = __webpack_require__(2049);
	
	var _PassUtil2 = _interopRequireDefault(_PassUtil);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SCANNER_SCRIPT_URL = "https://unpkg.com/html5-qrcode@2.3.4/html5-qrcode.min.js";
	
	var CheckPass = function (_React$Component) {
	  _inherits(CheckPass, _React$Component);
	
	  function CheckPass(props) {
	    _classCallCheck(this, CheckPass);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(CheckPass).call(this, props));
	
	    _this.state = {
	      foundPass: null
	    };
	
	    _this.renderScanner = _this.renderScanner.bind(_this);
	    _this.onScan = _this.onScan.bind(_this);
	    return _this;
	  }
	
	  _createClass(CheckPass, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      if (!document.querySelector("script[src=\"" + SCANNER_SCRIPT_URL + "\"]")) {
	        var script = document.createElement("script");
	        script.type = "text/javascript";
	        script.src = SCANNER_SCRIPT_URL;
	        script.onload = function () {
	          return setTimeout(_this2.renderScanner, 250);
	        };
	        document.body.appendChild(script);
	      } else {
	        this.renderScanner();
	      }
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(newProps) {}
	  }, {
	    key: "getStyles",
	    value: function getStyles() {
	      return {
	        container: {
	          padding: 10,
	          textAlign: "center"
	        },
	        intro: {
	          padding: 15,
	          fontSize: "12pt",
	          lineHeight: 1.5,
	          color: "rgba(0,0,0,0.54)"
	        }
	      };
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      if (this.html5QrcodeScanner) {
	        this.html5QrcodeScanner.stop();
	        this.html5QrcodeScanner = null;
	      }
	    }
	  }, {
	    key: "renderScanner",
	    value: function renderScanner() {
	      try {
	        if (this.html5QrcodeScanner) {
	          this.html5QrcodeScanner.stop();
	          this.html5QrcodeScanner = null;
	        }
	        this.html5QrcodeScanner = new window.Html5Qrcode("CheckPassReader");
	        var config = { fps: 10, qrbox: { width: 150, height: 150 } };
	        this.html5QrcodeScanner.start({ facingMode: "environment" }, config, this.onScan);
	      } catch (e) {
	        console.error(e);
	      }
	    }
	  }, {
	    key: "onScan",
	    value: function onScan(id) {
	      var _this3 = this;
	
	      if (id === this.state.id) return;
	
	      this.setState({
	        hasSearched: true,
	        isSearching: true,
	        id: id,
	        foundPass: null,
	        error: null
	      });
	
	      _PassUtil2.default.fetchOne(_UserStore2.default.getState().apiKey, id).then(function (pass) {
	        _this3.setState({ isSearching: false, foundPass: pass });
	      }).catch(function (e) {
	        _this3.setState({ isSearching: false, error: e.message });
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var styles = this.getStyles();
	
	      return _react2.default.createElement(
	        "div",
	        { className: "", style: styles.container },
	        _react2.default.createElement(
	          "h1",
	          null,
	          "Pass QR Code Lookup"
	        ),
	        _react2.default.createElement(
	          "div",
	          { style: { margin: "20px auto", fontSize: 16 } },
	          this.state.isSearching ? "Looking up pass..." : this.state.foundPass ? _react2.default.createElement(
	            "div",
	            null,
	            this.state.foundPass.name,
	            " (",
	            this.state.foundPass.pass_bucket.name,
	            ", owned by",
	            " ",
	            this.state.foundPass.person.name,
	            ") \xB7",
	            " ",
	            _react2.default.createElement(
	              _reactRouter.Link,
	              { target: "_blank", to: "/passes/" + this.state.foundPass.id },
	              "View pass"
	            )
	          ) : this.state.hasSearched ? "No pass found. Are you sure that's a pass QR code?" : "Scan a pass QR code to look it up..."
	        ),
	        this.state.id ? _react2.default.createElement(
	          "div",
	          { style: { margin: "-15px auto 20px", fontSize: 12 } },
	          "ID: ",
	          this.state.id
	        ) : "",
	        _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement("div", {
	            id: "CheckPassReader",
	            style: {
	              width: "90%",
	              maxWidth: 400,
	              margin: "0 auto"
	            }
	          })
	        )
	      );
	    }
	  }], [{
	    key: "getStores",
	    value: function getStores() {
	      return [_UserStore2.default];
	    }
	  }, {
	    key: "getPropsFromStores",
	    value: function getPropsFromStores() {
	      return {};
	    }
	  }, {
	    key: "contextTypes",
	    get: function get() {
	      return {};
	    }
	  }]);
	
	  return CheckPass;
	}(_react2.default.Component);
	
	exports.default = (0, _connectToStores2.default)(CheckPass);
	module.exports = exports["default"];

/***/ }),
/* 2949 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _TagActions = __webpack_require__(2038);
	
	var _TagActions2 = _interopRequireDefault(_TagActions);
	
	var _TagStore = __webpack_require__(2039);
	
	var _TagStore2 = _interopRequireDefault(_TagStore);
	
	var _connectToStores = __webpack_require__(1226);
	
	var _connectToStores2 = _interopRequireDefault(_connectToStores);
	
	var _tagFilmTable = __webpack_require__(2950);
	
	var _tagEventTable = __webpack_require__(2951);
	
	var _EventBucketStore = __webpack_require__(1593);
	
	var _EventBucketStore2 = _interopRequireDefault(_EventBucketStore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Tag = function (_Component) {
	  _inherits(Tag, _Component);
	
	  function Tag() {
	    _classCallCheck(this, Tag);
	
	    return _possibleConstructorReturn(this, Object.getPrototypeOf(Tag).apply(this, arguments));
	  }
	
	  _createClass(Tag, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      _TagActions2.default.fetchOne(this.props.params.tagId);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var tag = this.props.getTagById(this.props.params.tagId);
	      var eventBucket = this.props.getEventBucketById(this.props.params.eventBucketId);
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          "h1",
	          null,
	          tag ? tag.name : "Unnamed Tag"
	        ),
	        _react2.default.createElement(
	          "div",
	          { style: { display: "flex", flexDirection: "row" } },
	          _react2.default.createElement(
	            "div",
	            { style: { display: "flex", flexDirection: "column", justifyContent: "center" } },
	            _react2.default.createElement(
	              "h4",
	              null,
	              "Is this tag hidden?"
	            ),
	            _react2.default.createElement(
	              "text",
	              null,
	              tag && tag.visible ? "No" : "Yes"
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { style: {
	                display: "flex",
	                flexDirection: "column",
	                marginLeft: 12
	              } },
	            _react2.default.createElement(
	              "h4",
	              null,
	              "What color is this tag?"
	            ),
	            _react2.default.createElement("div", { style: {
	                width: 12,
	                height: 12,
	                backgroundColor: tag ? tag.color : "#FFF",
	                marginTop: 4
	              } })
	          )
	        ),
	        _react2.default.createElement(_tagFilmTable.TagFilmTable, {
	          eventBucketId: this.props.params.eventBucketId,
	          tagId: this.props.params.tagId
	        }),
	        _react2.default.createElement(_tagEventTable.TagEventTable, {
	          eventBucketId: this.props.params.eventBucketId,
	          tagId: this.props.params.tagId,
	          timezone: eventBucket ? eventBucket.timezone : "America/Kentucky/Monticello"
	        })
	      );
	    }
	  }], [{
	    key: "getStores",
	    value: function getStores() {
	      return [_TagStore2.default, _EventBucketStore2.default];
	    }
	  }, {
	    key: "getPropsFromStores",
	    value: function getPropsFromStores() {
	
	      return {
	        getTagById: _TagStore2.default.getTagById,
	        getEventBucketById: _EventBucketStore2.default.getEventBucketById
	      };
	    }
	  }]);
	
	  return Tag;
	}(_react.Component);
	
	exports.default = (0, _connectToStores2.default)(Tag);
	module.exports = exports["default"];

/***/ }),
/* 2950 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.TagFilmTable = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactTableV = __webpack_require__(2920);
	
	var _reactTableV2 = _interopRequireDefault(_reactTableV);
	
	var _FilmUtil = __webpack_require__(1766);
	
	var _FilmUtil2 = _interopRequireDefault(_FilmUtil);
	
	var _UserStore = __webpack_require__(974);
	
	var _UserStore2 = _interopRequireDefault(_UserStore);
	
	var _reactRouter = __webpack_require__(486);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TagFilmTable = exports.TagFilmTable = function (_React$Component) {
	  _inherits(TagFilmTable, _React$Component);
	
	  function TagFilmTable(props) {
	    _classCallCheck(this, TagFilmTable);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(TagFilmTable).call(this, props));
	
	    _this.state = {
	      data: [],
	      pages: 0,
	      loading: false
	    };
	
	    _this._onFetchData = _this._onFetchData.bind(_this);
	    return _this;
	  }
	
	  _createClass(TagFilmTable, [{
	    key: "_onFetchData",
	    value: function () {
	      var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(state, _) {
	        var _props, eventBucketId, tagId, apiKey, data;
	
	        return regeneratorRuntime.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                _props = this.props;
	                eventBucketId = _props.eventBucketId;
	                tagId = _props.tagId;
	
	
	                this.setState({ loading: true });
	
	                apiKey = _UserStore2.default.getState().apiKey;
	                _context.next = 7;
	                return _FilmUtil2.default.fetchAllByTag(apiKey, eventBucketId, tagId, { page: state.page, sorted: state.sorted });
	
	              case 7:
	                data = _context.sent;
	
	
	                this.setState({ data: data.films, pages: data.pages, loading: false });
	
	              case 9:
	              case "end":
	                return _context.stop();
	            }
	          }
	        }, _callee, this);
	      }));
	
	      function _onFetchData(_x, _x2) {
	        return _ref.apply(this, arguments);
	      }
	
	      return _onFetchData;
	    }()
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var columns = [{
	        Header: "Name",
	        accessor: "name"
	      }, {
	        Header: "Actions",
	        sortable: false,
	        Cell: function Cell(props) {
	          return _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(
	              _reactRouter.Link,
	              { to: "/event_buckets/" + _this2.props.eventBucketId + "/films/" + props.original.id, onlyActiveOnIndex: false },
	              "Edit"
	            )
	          );
	        }
	      }];
	
	      return _react2.default.createElement(
	        "div",
	        { style: { marginTop: 16 } },
	        _react2.default.createElement(
	          "h2",
	          null,
	          "Films with Tag"
	        ),
	        _react2.default.createElement(_reactTableV2.default, {
	          columns: columns,
	          data: this.state.data,
	          loading: this.state.loading,
	          manual: true,
	          showPageSizeOptions: false,
	          onFetchData: this._onFetchData,
	          pageSize: 10,
	          pages: this.state.pages,
	          defaultSorted: [{ id: "name", desc: false }]
	        })
	      );
	    }
	  }]);
	
	  return TagFilmTable;
	}(_react2.default.Component);

/***/ }),
/* 2951 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.TagEventTable = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactTableV = __webpack_require__(2920);
	
	var _reactTableV2 = _interopRequireDefault(_reactTableV);
	
	var _UserStore = __webpack_require__(974);
	
	var _UserStore2 = _interopRequireDefault(_UserStore);
	
	var _EventUtil = __webpack_require__(2034);
	
	var _EventUtil2 = _interopRequireDefault(_EventUtil);
	
	var _reactRouter = __webpack_require__(486);
	
	var _momentTimezone = __webpack_require__(1185);
	
	var _momentTimezone2 = _interopRequireDefault(_momentTimezone);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TagEventTable = exports.TagEventTable = function (_React$Component) {
	  _inherits(TagEventTable, _React$Component);
	
	  function TagEventTable(props) {
	    _classCallCheck(this, TagEventTable);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(TagEventTable).call(this, props));
	
	    _this.state = {
	      data: [],
	      pages: 0,
	      loading: false
	    };
	
	    _this._onFetchData = _this._onFetchData.bind(_this);
	    return _this;
	  }
	
	  _createClass(TagEventTable, [{
	    key: "_onFetchData",
	    value: function () {
	      var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(state, _) {
	        var _props, eventBucketId, tagId, apiKey, data;
	
	        return regeneratorRuntime.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                _props = this.props;
	                eventBucketId = _props.eventBucketId;
	                tagId = _props.tagId;
	
	
	                this.setState({ loading: true });
	
	                apiKey = _UserStore2.default.getState().apiKey;
	                _context.next = 7;
	                return _EventUtil2.default.fetchAllByTag(apiKey, eventBucketId, tagId, {
	                  page: state.page,
	                  sorted: state.sorted
	                });
	
	              case 7:
	                data = _context.sent;
	
	
	                this.setState({ data: data.events, pages: data.pages, loading: false });
	
	              case 9:
	              case "end":
	                return _context.stop();
	            }
	          }
	        }, _callee, this);
	      }));
	
	      function _onFetchData(_x, _x2) {
	        return _ref.apply(this, arguments);
	      }
	
	      return _onFetchData;
	    }()
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var timezone = this.props.timezone;
	
	
	      var columns = [{
	        Header: "Name",
	        accessor: "name"
	      }, {
	        id: "start_time",
	        Header: "Start Time",
	        accessor: function accessor(row) {
	          return (0, _momentTimezone2.default)(row.start_time).tz(timezone || "America/Kentucky/Monticello").format("MMMM D, YYYY h:mm A");
	        }
	      }, {
	        id: "end_time",
	        Header: "End Time",
	        accessor: function accessor(row) {
	          return (0, _momentTimezone2.default)(row.end_time).tz(timezone || "America/Kentucky/Monticello").format("MMMM D, YYYY h:mm A");
	        }
	      }, {
	        id: "type",
	        Header: "Type",
	        accessor: function accessor(row) {
	          return row.is_virtual ? "Virtual" : "Physical";
	        }
	      }, {
	        Header: "Actions",
	        sortable: false,
	        Cell: function Cell(props) {
	          return _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(
	              _reactRouter.Link,
	              {
	                to: "/event_buckets/" + _this2.props.eventBucketId + "/events/" + props.original.id,
	                onlyActiveOnIndex: false
	              },
	              "View"
	            ),
	            "\xA0",
	            _react2.default.createElement(
	              _reactRouter.Link,
	              {
	                to: "/event_buckets/" + _this2.props.eventBucketId + "/events/" + props.original.id + "/edit",
	                onlyActiveOnIndex: false
	              },
	              "Edit"
	            )
	          );
	        }
	      }];
	
	      return _react2.default.createElement(
	        "div",
	        { style: { marginTop: 16 } },
	        _react2.default.createElement(
	          "h2",
	          null,
	          "Events with Tag"
	        ),
	        _react2.default.createElement(_reactTableV2.default, {
	          columns: columns,
	          data: this.state.data,
	          loading: this.state.loading,
	          manual: true,
	          showPageSizeOptions: false,
	          onFetchData: this._onFetchData,
	          pageSize: 10,
	          pages: this.state.pages,
	          defaultSorted: [{ id: "name", desc: false }]
	        })
	      );
	    }
	  }]);
	
	  return TagEventTable;
	}(_react2.default.Component);

/***/ }),
/* 2952 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(2953);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(1718)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../node_modules/css-loader/index.js!./app.css", function() {
				var newContent = require("!!./../../node_modules/css-loader/index.js!./app.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2953 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1717)();
	// imports
	exports.i(__webpack_require__(2954), "");
	exports.i(__webpack_require__(2955), "");
	exports.i(__webpack_require__(2956), "");
	exports.i(__webpack_require__(2957), "");
	exports.i(__webpack_require__(2958), "");
	exports.i(__webpack_require__(2959), "");
	exports.i(__webpack_require__(2960), "");
	exports.i(__webpack_require__(2961), "");
	exports.i(__webpack_require__(2962), "");
	exports.i(__webpack_require__(2963), "");
	exports.i(__webpack_require__(2964), "");
	
	// module
	exports.push([module.id, "html{font-family:Inter,sans-serif}@supports (font-variation-settings:normal){html{font-family:Inter var,sans-serif}}body,html{width:100%;height:100%;margin:0}body{font-size:13px;line-height:20px}body.ReactModal__Body--open{position:fixed}#app{width:100%;height:100%}@media print{.no-print,.no-print *{display:none!important}.print-reset-content{margin-left:0!important}.print-reset-main{padding-top:0!important}}:root{--default-link-color:#0187d0;--admin-blue:#0288d1;--admin-blue-background:#0288d120;--admin-gray:#bbb}a{text-decoration:none}a,a:visited{color:#0187d0}a:active{color:#0060b3}a:hover{text-decoration:underline}h1,h2,h3,h4,h5,h6{font-weight:700;margin:.3em 0}hr{border:none;border-top:1px solid #ccc;margin:1em 0}.ReactModal__Overlay.ReactModal__Overlay--after-open{z-index:999;background-color:rgba(0,0,0,.75)}.react-tagsinput{background-color:#fff;border:1px solid #ccc;overflow:hidden;padding-left:5px;padding-top:5px}.react-tagsinput-tag{background-color:#cde69c;border-radius:2px;border:1px solid #a5d24a;color:#638421;float:left;font-family:sans-serif;font-size:13px;font-weight:400;margin-bottom:5px;margin-right:5px;padding:5px}.react-tagsinput-remove{cursor:pointer;font-weight:700}.react-tagsinput-remove:before{content:\" x\"}.react-tagsinput-input{background:transparent;border:0;color:#777;font-family:sans-serif;font-size:13px;font-weight:400;margin-bottom:6px;margin-top:3px;outline:none;padding:5px;width:350px}.react-tagsinput-invalid{background-color:#fbd8db;color:#90111a}.react-tagsinput-validating{background:#fffacd}.reactable-filterer td:first-child{padding-left:0}.reactable-filterer input{padding:8px;font-size:.9em;outline:0 none}.reactable-header-sortable{cursor:ns-resize}.reactable-column-header{text-align:left;background-color:var(--admin-blue);color:#fff}table,td,th{border:none;border-spacing:0}table{width:100%;display:table}table.bordered>tbody>tr,table.bordered>thead>tr{border-bottom:1px solid #d0d0d0}table.striped>tbody>tr:nth-child(odd){background-color:#f2f2f2}table.striped>tbody>tr>td{border-radius:0}table.hoverable>tbody>tr{-webkit-transition:background-color .25s ease;transition:background-color .25s ease}table.hoverable>tbody>tr:hover{background-color:#f2f2f2}table.centered tbody tr td,table.centered thead tr th{text-align:center}thead{border-bottom:1px solid #d0d0d0}td,th{padding:8px 5px;display:table-cell;text-align:left;vertical-align:middle}td:first-child,th:first-child{padding-left:20px}td:last-child,th:last-child{padding-right:20px}table>tbody.reactable-pagination>tr>td{background-color:#0288d1;color:#fff;text-align:center}table>tbody.reactable-pagination>tr>td a{color:#fff;text-decoration:none;padding:0 5px}table>tbody.reactable-pagination>tr>td a:hover{text-decoration:underline}a.reactable-page-button.reactable-current-page{font-weight:700;border:1px solid #fff;padding:2px 5px}a.reactable-page-button.reactable-current-page:hover{text-decoration:none;cursor:default}a.reactable-page-button{margin:0 3px;cursor:pointer}a.reactable-next-page,a.reactable-previous-page{display:none}.paginateTable a.reactable-next-page,.paginateTable a.reactable-previous-page{display:inline}th,th.reactable-header-sortable{position:relative;outline:0}th.reactable-header-sortable.reactable-header-sort-asc,th.reactable-header-sortable.reactable-header-sort-desc{background-color:hsla(0,0%,100%,.1)}th.reactable-header-sortable:after,th.reactable-header-sortable:before{border:4px solid transparent;content:\"\";display:block;height:0;right:10px;top:50%;position:absolute;width:0}th.reactable-header-sortable:not(.reactable-header-sort-asc):before{border-bottom-color:#fff;margin-top:-9px}th.reactable-header-sortable:not(.reactable-header-sort-desc):after{border-top-color:#fff;margin-top:1px}div.empty-table-message{padding:1em;text-align:center;background-color:#f2f2f2}.ReactTable .rt-thead .rt-th{background-color:#0288d1;color:#fff;text-align:left;font-weight:700;padding:8px}.ReactTable .rt-thead .rt-td.-sort-asc,.ReactTable .rt-thead .rt-th.-sort-asc{box-shadow:inset 0 3px 0 0 #ddd}.ReactTable .rt-thead .rt-td.-sort-desc,.ReactTable .rt-thead .rt-th.-sort-desc{box-shadow:inset 0 -3px 0 0 #ddd}.pass-table.not-editing td:nth-of-type(2){max-width:150px}.statsBlock{color:#0288d1}.statsBlock.hvr-bounce-to-bottom{cursor:pointer}.hvr-bounce-to-bottom{display:inline-block;vertical-align:middle;-webkit-transform:translateZ(0);transform:translateZ(0);box-shadow:0 0 1px transparent;-webkit-backface-visibility:hidden;backface-visibility:hidden;-moz-osx-font-smoothing:grayscale;position:relative;-webkit-transition-property:color;transition-property:color}.hvr-bounce-to-bottom,.hvr-bounce-to-bottom:before{-webkit-transition-duration:.5s;transition-duration:.5s}.hvr-bounce-to-bottom:before{content:\"\";position:absolute;z-index:-1;top:0;left:0;right:0;bottom:0;background:#0288d1;-webkit-transform:scaleY(0);transform:scaleY(0);-webkit-transform-origin:50% 0;transform-origin:50% 0;-webkit-transition-property:transform;transition-property:transform;-webkit-transition-timing-function:ease-out;transition-timing-function:ease-out}.hvr-bounce-to-bottom:active,.hvr-bounce-to-bottom:focus,.hvr-bounce-to-bottom:hover{color:#fff}.hvr-bounce-to-bottom:active:before,.hvr-bounce-to-bottom:focus:before,.hvr-bounce-to-bottom:hover:before{-webkit-transform:scaleY(1);transform:scaleY(1);-webkit-transition-timing-function:cubic-bezier(.52,1.64,.37,.66);transition-timing-function:cubic-bezier(.52,1.64,.37,.66)}.Select-menu-outer,.Select.is-open{z-index:9999999!important}.Select.is-open{position:relative}.rc-color-picker{z-index:9999999!important}.quill{display:flex;flex-direction:column}.quill .ql-toolbar{box-shadow:0 1px 10px rgba(0,0,0,.1)}.quill .ql-container{display:flex;flex:1}.quill .ql-container .ql-editor{flex:1;height:auto}.quill .ql-editor.ql-blank:before{color:rgba(0,0,0,.4);content:\"Click & start typing to add content...\";font-style:italic;pointer-events:none;position:absolute}.quill .ql-tooltip{z-index:999999}.naked-quill-editor .ql-container.ql-snow,.naked-quill-editor .ql-toolbar.ql-snow{border:0}#HW_frame_cont{z-index:99999999!important;margin-left:10px!important}#HW_badge_cont{display:inline!important}.GlobalSearchResults--hit em{background-color:#c6ebff;font-style:normal}.GlobalSearchResults--hit:hover{text-decoration:underline}.GlobalSearchResults--hit.selected{background-color:#e8e8e8}.tenant-injected-html p{margin:0;padding:0}.tenant-injected-html ul{padding-left:1em}.tenant-injected-html img{max-width:100%}.keen-dataviz{box-sizing:border-box;border-radius:10px;margin:1em 0;padding:1em 1em .5em;box-shadow:0 0 20px 0 #dedede}.keen-dataviz .keen-dataviz-title{color:#4d4d4d;font-family:inherit;font-size:16px;font-weight:600;line-height:32px;text-align:center}.Chart--has-placeholder .keen-dataviz{background-image:url(/img/placeholder-background.jpg);background-size:cover;opacity:.6}.Chart--has-placeholder .keen-dataviz .keen-dataviz-message{color:#fff;font-family:inherit;font-weight:700;padding:0 1em!important;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.Chart--has-placeholder .keen-dataviz .keen-dataviz-message span{width:100%;text-align:center}a.anchor--fixed_header_offset{display:block;position:relative;top:-64px;visibility:hidden}#eventive-event-editor-bar{margin-left:-50px;padding:19px 55px 15px 50px;margin-right:-55px;transition:box-shadow .2s ease-in-out;margin-bottom:0}.sticky-outer-wrapper.active #eventive-event-editor-bar{box-shadow:0 8px 15px 0 #dcdcdc}.eventive-datepicker__wrapper>div{display:inline-block}.eventive-datepicker__wrapper>div+div{margin-left:8px}ul.react-datepicker__time-list{padding:0}li.react-datepicker__time-list-item{padding:5px 0!important}.react-datepicker--time-only .react-datepicker__time,.react-datepicker--time-only .react-datepicker__time-box{border-radius:0 0 .3rem .3rem}.react-datepicker-popper{z-index:9999}.react-datepicker{font-family:inherit}.droppable-inactive .Select-control,.droppable .Select-control{overflow:visible}.droppable .Select,.droppable .Select-control,.droppable .Select-multi-value-wrapper{height:100%;overflow:hidden}.droppable .Select-value{background-color:#eef5ff;width:100%;margin:0}.droppable .Select-value,.droppable .Select-value-label{cursor:grab}.droppable .Select-multi-value-wrapper{display:flex!important;flex-direction:column;padding:2.5px}.droppable .Select-arrow-zone,.droppable .Select-multi-value-wrapper .Select-input{display:none!important}.Select.Select--short .Select-control{height:24px}.Select.Select--short .Select-input,.Select.Select--short .Select-value{height:22px;line-height:22px}.Select.Select--short .Select-input>input{height:5px}.Select.Select--short .Select-option{padding-top:3px;padding-bottom:3px}.Select.Select--dark:not(.is-open) .Select-control{background-color:rgba(0,0,0,.5);border-color:hsla(0,0%,100%,.5)}.Select.Select--dark:not(.is-open) .Select-value-label{color:#fff!important}.ag-row-group.ag-row-level-0{background-color:#e3e3e3!important;border-bottom:1px solid #000!important}.ag-row-group.ag-row-level-0.ag-row-group-expanded{background-color:#e3e3e3!important;border-bottom:0!important}.ag-row-group.ag-row-last{color:#fff;background-color:#0288d1!important}.ag-cell,.ag-header-cell{padding-left:12px!important;padding-right:12px!important}.pull-left{float:left}.pull-right{float:right}.clear-both{clear:both}#booqable-launcher{display:none}.BoxOffice--PosMode--SearchInput::placeholder{color:#aaa}.filter-widget-container{align-items:stretch;background:var(--admin-blue-background);border:.2rem solid var(--admin-blue);display:flex;flex-flow:row wrap;justify-content:flex-start;margin:0 0 1rem;min-width:630px;padding:.75rem 1.1rem .85rem;position:relative}.filter-widget-container .filter-widget-item{border-left:1px solid #ccc;padding:0 1.25rem 0 1.3rem}.filter-widget-container .first{border-left:0;padding-left:0}.segment-filter>div{display:flex;flex-flow:row wrap}.filter-widget-radio{position:relative;flex-grow:1}.filter-widget-radio input{position:relative}.filter-widget-container .item-date-filter{flex-grow:0}.filter-widget-container .filter-widget-item-title{color:#666;margin-bottom:.3rem}.analytics-element{margin:0 0 3rem}.segmentedFilterPopover{border:1px solid #ccc;padding:.5rem;width:auto}.statbox-label{color:var(--admin-blue);font-size:.9rem;font-weight:700;margin-bottom:-.25rem}table td.data-limit{max-width:15ch;text-overflow:ellipsis;overflow:hidden;white-space:nowrap}h1.page-title{margin-top:1rem}", ""]);
	
	// exports


/***/ }),
/* 2954 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1717)();
	// imports
	
	
	// module
	exports.push([module.id, ".Select{position:relative}.Select input::-webkit-contacts-auto-fill-button,.Select input::-webkit-credentials-auto-fill-button{display:none!important}.Select input::-ms-clear,.Select input::-ms-reveal{display:none!important}.Select,.Select div,.Select input,.Select span{box-sizing:border-box}.Select.is-disabled .Select-arrow-zone{cursor:default;pointer-events:none;opacity:.35}.Select.is-disabled>.Select-control{background-color:#f9f9f9}.Select.is-disabled>.Select-control:hover{box-shadow:none}.Select.is-open>.Select-control{border-bottom-right-radius:0;border-bottom-left-radius:0;background:#fff;border-color:#b3b3b3 #ccc #d9d9d9}.Select.is-open>.Select-control .Select-arrow{top:-2px;border-color:transparent transparent #999;border-width:0 5px 5px}.Select.is-searchable.is-focused:not(.is-open)>.Select-control,.Select.is-searchable.is-open>.Select-control{cursor:text}.Select.is-focused>.Select-control{background:#fff}.Select.is-focused:not(.is-open)>.Select-control{border-color:#007eff;box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 0 3px rgba(0,126,255,.1);background:#fff}.Select.has-value.is-clearable.Select--single>.Select-control .Select-value{padding-right:42px}.Select.has-value.is-pseudo-focused.Select--single>.Select-control .Select-value .Select-value-label,.Select.has-value.Select--single>.Select-control .Select-value .Select-value-label{color:#333}.Select.has-value.is-pseudo-focused.Select--single>.Select-control .Select-value a.Select-value-label,.Select.has-value.Select--single>.Select-control .Select-value a.Select-value-label{cursor:pointer;text-decoration:none}.Select.has-value.is-pseudo-focused.Select--single>.Select-control .Select-value a.Select-value-label:focus,.Select.has-value.is-pseudo-focused.Select--single>.Select-control .Select-value a.Select-value-label:hover,.Select.has-value.Select--single>.Select-control .Select-value a.Select-value-label:focus,.Select.has-value.Select--single>.Select-control .Select-value a.Select-value-label:hover{color:#007eff;outline:none;text-decoration:underline}.Select.has-value.is-pseudo-focused.Select--single>.Select-control .Select-value a.Select-value-label:focus,.Select.has-value.Select--single>.Select-control .Select-value a.Select-value-label:focus{background:#fff}.Select.has-value.is-pseudo-focused .Select-input{opacity:0}.Select.is-open .Select-arrow,.Select .Select-arrow-zone:hover>.Select-arrow{border-top-color:#666}.Select.Select--rtl{direction:rtl;text-align:right}.Select-control{background-color:#fff;border-color:#d9d9d9 #ccc #b3b3b3;border-radius:4px;border:1px solid #ccc;color:#333;cursor:default;display:table;border-spacing:0;border-collapse:separate;height:36px;outline:none;overflow:hidden;position:relative;width:100%}.Select-control:hover{box-shadow:0 1px 0 rgba(0,0,0,.06)}.Select-control .Select-input:focus{outline:none;background:#fff}.Select--single>.Select-control .Select-value,.Select-placeholder{bottom:0;color:#aaa;left:0;line-height:34px;padding-left:10px;padding-right:10px;position:absolute;right:0;top:0;max-width:100%;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.Select-input{height:34px;padding-left:10px;padding-right:10px;vertical-align:middle}.Select-input>input{width:100%;background:none transparent;border:0 none;box-shadow:none;cursor:default;display:inline-block;font-family:inherit;font-size:inherit;margin:0;outline:none;line-height:17px;padding:8px 0 12px;-webkit-appearance:none}.is-focused .Select-input>input{cursor:text}.has-value.is-pseudo-focused .Select-input{opacity:0}.Select-control:not(.is-searchable)>.Select-input{outline:none}.Select-loading-zone{cursor:pointer;display:table-cell;text-align:center}.Select-loading,.Select-loading-zone{position:relative;vertical-align:middle;width:16px}.Select-loading{-webkit-animation:Select-animation-spin .4s infinite linear;animation:Select-animation-spin .4s infinite linear;height:16px;box-sizing:border-box;border-radius:50%;border:2px solid #ccc;border-right-color:#333;display:inline-block}.Select-clear-zone{-webkit-animation:Select-animation-fadeIn .2s;animation:Select-animation-fadeIn .2s;color:#999;cursor:pointer;display:table-cell;position:relative;text-align:center;vertical-align:middle;width:17px}.Select-clear-zone:hover{color:#d0021b}.Select-clear{display:inline-block;font-size:18px;line-height:1}.Select--multi .Select-clear-zone{width:17px}.Select-arrow-zone{cursor:pointer;display:table-cell;position:relative;text-align:center;vertical-align:middle;width:25px;padding-right:5px}.Select--rtl .Select-arrow-zone{padding-right:0;padding-left:5px}.Select-arrow{border-color:#999 transparent transparent;border-style:solid;border-width:5px 5px 2.5px;display:inline-block;height:0;width:0;position:relative}.Select-control>:last-child{padding-right:5px}.Select--multi .Select-multi-value-wrapper{display:inline-block}.Select .Select-aria-only{position:absolute;display:inline-block;height:1px;width:1px;margin:-1px;clip:rect(0,0,0,0);overflow:hidden;float:left}@-webkit-keyframes Select-animation-fadeIn{0%{opacity:0}to{opacity:1}}@keyframes Select-animation-fadeIn{0%{opacity:0}to{opacity:1}}.Select-menu-outer{border-bottom-right-radius:4px;border-bottom-left-radius:4px;background-color:#fff;border:1px solid #ccc;border-top-color:#e6e6e6;box-shadow:0 1px 0 rgba(0,0,0,.06);box-sizing:border-box;margin-top:-1px;max-height:200px;position:absolute;left:0;top:100%;width:100%;z-index:1;-webkit-overflow-scrolling:touch}.Select-menu{max-height:198px;overflow-y:auto}.Select-option{box-sizing:border-box;background-color:#fff;color:#666;cursor:pointer;display:block;padding:8px 10px}.Select-option:last-child{border-bottom-right-radius:4px;border-bottom-left-radius:4px}.Select-option.is-selected{background-color:#f5faff;background-color:rgba(0,126,255,.04);color:#333}.Select-option.is-focused{background-color:#ebf5ff;background-color:rgba(0,126,255,.08);color:#333}.Select-option.is-disabled{color:#ccc;cursor:default}.Select-noresults{box-sizing:border-box;color:#999;cursor:default;display:block;padding:8px 10px}.Select--multi .Select-input{vertical-align:middle;margin-left:10px;padding:0}.Select--multi.Select--rtl .Select-input{margin-left:0;margin-right:10px}.Select--multi.has-value .Select-input{margin-left:5px}.Select--multi .Select-value{background-color:#ebf5ff;background-color:rgba(0,126,255,.08);border-radius:2px;border:1px solid #c2e0ff;border:1px solid rgba(0,126,255,.24);color:#007eff;display:inline-block;font-size:.9em;line-height:1.4;margin-left:5px;margin-top:5px;vertical-align:top}.Select--multi .Select-value-icon,.Select--multi .Select-value-label{display:inline-block;vertical-align:middle}.Select--multi .Select-value-label{border-bottom-right-radius:2px;border-top-right-radius:2px;cursor:default;padding:2px 5px}.Select--multi a.Select-value-label{color:#007eff;cursor:pointer;text-decoration:none}.Select--multi a.Select-value-label:hover{text-decoration:underline}.Select--multi .Select-value-icon{cursor:pointer;border-bottom-left-radius:2px;border-top-left-radius:2px;border-right:1px solid #c2e0ff;border-right:1px solid rgba(0,126,255,.24);padding:1px 5px 3px}.Select--multi .Select-value-icon:focus,.Select--multi .Select-value-icon:hover{background-color:#d8eafd;background-color:rgba(0,113,230,.08);color:#0071e6}.Select--multi .Select-value-icon:active{background-color:#c2e0ff;background-color:rgba(0,126,255,.24)}.Select--multi.Select--rtl .Select-value{margin-left:0;margin-right:5px}.Select--multi.Select--rtl .Select-value-icon{border-right:none;border-left:1px solid #c2e0ff;border-left:1px solid rgba(0,126,255,.24)}.Select--multi.is-disabled .Select-value{background-color:#fcfcfc;border:1px solid #e3e3e3;color:#333}.Select--multi.is-disabled .Select-value-icon{cursor:not-allowed;border-right:1px solid #e3e3e3}.Select--multi.is-disabled .Select-value-icon:active,.Select--multi.is-disabled .Select-value-icon:focus,.Select--multi.is-disabled .Select-value-icon:hover{background-color:#fcfcfc}@keyframes Select-animation-spin{to{transform:rotate(1turn)}}@-webkit-keyframes Select-animation-spin{to{-webkit-transform:rotate(1turn)}}", ""]);
	
	// exports


/***/ }),
/* 2955 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1717)();
	// imports
	
	
	// module
	exports.push([module.id, "/*!\n * Cropper.js v0.8.0\n * https://github.com/fengyuanchen/cropperjs\n *\n * Copyright (c) 2015-2016 Fengyuan Chen\n * Released under the MIT license\n *\n * Date: 2016-08-18T03:01:29.515Z\n */.cropper-container{font-size:0;line-height:0;position:relative;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;direction:ltr}.cropper-container img{display:block;min-width:0!important;max-width:none!important;min-height:0!important;max-height:none!important;width:100%;height:100%;image-orientation:0deg}.cropper-canvas,.cropper-crop-box,.cropper-drag-box,.cropper-modal,.cropper-wrap-box{position:absolute;top:0;right:0;bottom:0;left:0}.cropper-wrap-box{overflow:hidden}.cropper-drag-box{opacity:0;background-color:#fff}.cropper-modal{opacity:.5;background-color:#000}.cropper-view-box{display:block;overflow:hidden;width:100%;height:100%;outline:1px solid #39f;outline-color:rgba(51,153,255,.75)}.cropper-dashed{position:absolute;display:block;opacity:.5;border:0 dashed #eee}.cropper-dashed.dashed-h{top:33.33333333%;left:0;width:100%;height:33.33333333%;border-top-width:1px;border-bottom-width:1px}.cropper-dashed.dashed-v{top:0;left:33.33333333%;width:33.33333333%;height:100%;border-right-width:1px;border-left-width:1px}.cropper-center{position:absolute;top:50%;left:50%;display:block;width:0;height:0;opacity:.75}.cropper-center:after,.cropper-center:before{position:absolute;display:block;content:' ';background-color:#eee}.cropper-center:before{top:0;left:-3px;width:7px;height:1px}.cropper-center:after{top:-3px;left:0;width:1px;height:7px}.cropper-face,.cropper-line,.cropper-point{position:absolute;display:block;width:100%;height:100%;opacity:.1}.cropper-face{top:0;left:0;background-color:#fff}.cropper-line{background-color:#39f}.cropper-line.line-e{top:0;right:-3px;width:5px;cursor:e-resize}.cropper-line.line-n{top:-3px;left:0;height:5px;cursor:n-resize}.cropper-line.line-w{top:0;left:-3px;width:5px;cursor:w-resize}.cropper-line.line-s{bottom:-3px;left:0;height:5px;cursor:s-resize}.cropper-point{width:5px;height:5px;opacity:.75;background-color:#39f}.cropper-point.point-e{top:50%;right:-3px;margin-top:-3px;cursor:e-resize}.cropper-point.point-n{top:-3px;left:50%;margin-left:-3px;cursor:n-resize}.cropper-point.point-w{top:50%;left:-3px;margin-top:-3px;cursor:w-resize}.cropper-point.point-s{bottom:-3px;left:50%;margin-left:-3px;cursor:s-resize}.cropper-point.point-ne{top:-3px;right:-3px;cursor:ne-resize}.cropper-point.point-nw{top:-3px;left:-3px;cursor:nw-resize}.cropper-point.point-sw{bottom:-3px;left:-3px;cursor:sw-resize}.cropper-point.point-se{right:-3px;bottom:-3px;width:20px;height:20px;cursor:se-resize;opacity:1}.cropper-point.point-se:before{position:absolute;right:-50%;bottom:-50%;display:block;width:200%;height:200%;content:' ';opacity:0;background-color:#39f}@media (min-width:768px){.cropper-point.point-se{width:15px;height:15px}}@media (min-width:992px){.cropper-point.point-se{width:10px;height:10px}}@media (min-width:1200px){.cropper-point.point-se{width:5px;height:5px;opacity:.75}}.cropper-invisible{opacity:0}.cropper-bg{background-image:url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQAQMAAAAlPW0iAAAAA3NCSVQICAjb4U/gAAAABlBMVEXMzMz////TjRV2AAAACXBIWXMAAArrAAAK6wGCiw1aAAAAHHRFWHRTb2Z0d2FyZQBBZG9iZSBGaXJld29ya3MgQ1M26LyyjAAAABFJREFUCJlj+M/AgBVhF/0PAH6/D/HkDxOGAAAAAElFTkSuQmCC\")}.cropper-hide{position:absolute;display:block;width:0;height:0}.cropper-hidden{display:none!important}.cropper-move{cursor:move}.cropper-crop{cursor:crosshair}.cropper-disabled .cropper-drag-box,.cropper-disabled .cropper-face,.cropper-disabled .cropper-line,.cropper-disabled .cropper-point{cursor:not-allowed}", ""]);
	
	// exports


/***/ }),
/* 2956 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1717)();
	// imports
	
	
	// module
	exports.push([module.id, ".CodeMirror{font-family:monospace;height:300px;color:#000}.CodeMirror-lines{padding:4px 0}.CodeMirror pre{padding:0 4px}.CodeMirror-gutter-filler,.CodeMirror-scrollbar-filler{background-color:#fff}.CodeMirror-gutters{border-right:1px solid #ddd;background-color:#f7f7f7;white-space:nowrap}.CodeMirror-linenumber{padding:0 3px 0 5px;min-width:20px;text-align:right;color:#999;white-space:nowrap}.CodeMirror-guttermarker{color:#000}.CodeMirror-guttermarker-subtle{color:#999}.CodeMirror-cursor{border-left:1px solid #000;border-right:none;width:0}.CodeMirror div.CodeMirror-secondarycursor{border-left:1px solid silver}.cm-fat-cursor .CodeMirror-cursor{width:auto;border:0!important;background:#7e7}.cm-fat-cursor div.CodeMirror-cursors{z-index:1}.cm-animate-fat-cursor{width:auto;border:0;-webkit-animation:blink 1.06s steps(1) infinite;animation:blink 1.06s steps(1) infinite;background-color:#7e7}@-webkit-keyframes blink{50%{background-color:transparent}}@keyframes blink{50%{background-color:transparent}}.cm-tab{display:inline-block;text-decoration:inherit}.CodeMirror-rulers{position:absolute;left:0;right:0;top:-50px;bottom:-20px;overflow:hidden}.CodeMirror-ruler{border-left:1px solid #ccc;top:0;bottom:0;position:absolute}.cm-s-default .cm-header{color:blue}.cm-s-default .cm-quote{color:#090}.cm-negative{color:#d44}.cm-positive{color:#292}.cm-header,.cm-strong{font-weight:700}.cm-em{font-style:italic}.cm-link{text-decoration:underline}.cm-strikethrough{text-decoration:line-through}.cm-s-default .cm-keyword{color:#708}.cm-s-default .cm-atom{color:#219}.cm-s-default .cm-number{color:#164}.cm-s-default .cm-def{color:#00f}.cm-s-default .cm-variable-2{color:#05a}.cm-s-default .cm-variable-3{color:#085}.cm-s-default .cm-comment{color:#a50}.cm-s-default .cm-string{color:#a11}.cm-s-default .cm-string-2{color:#f50}.cm-s-default .cm-meta,.cm-s-default .cm-qualifier{color:#555}.cm-s-default .cm-builtin{color:#30a}.cm-s-default .cm-bracket{color:#997}.cm-s-default .cm-tag{color:#170}.cm-s-default .cm-attribute{color:#00c}.cm-s-default .cm-hr{color:#999}.cm-s-default .cm-link{color:#00c}.cm-invalidchar,.cm-s-default .cm-error{color:red}.CodeMirror-composing{border-bottom:2px solid}div.CodeMirror span.CodeMirror-matchingbracket{color:#0f0}div.CodeMirror span.CodeMirror-nonmatchingbracket{color:#f22}.CodeMirror-matchingtag{background:rgba(255,150,0,.3)}.CodeMirror-activeline-background{background:#e8f2ff}.CodeMirror{position:relative;overflow:hidden;background:#fff}.CodeMirror-scroll{overflow:scroll!important;margin-bottom:-30px;margin-right:-30px;padding-bottom:30px;height:100%;outline:none;position:relative}.CodeMirror-sizer{position:relative;border-right:30px solid transparent}.CodeMirror-gutter-filler,.CodeMirror-hscrollbar,.CodeMirror-scrollbar-filler,.CodeMirror-vscrollbar{position:absolute;z-index:6;display:none}.CodeMirror-vscrollbar{right:0;top:0;overflow-x:hidden;overflow-y:scroll}.CodeMirror-hscrollbar{bottom:0;left:0;overflow-y:hidden;overflow-x:scroll}.CodeMirror-scrollbar-filler{right:0;bottom:0}.CodeMirror-gutter-filler{left:0;bottom:0}.CodeMirror-gutters{position:absolute;left:0;top:0;min-height:100%;z-index:3}.CodeMirror-gutter{white-space:normal;height:100%;display:inline-block;vertical-align:top;margin-bottom:-30px;*zoom:1;*display:inline}.CodeMirror-gutter-wrapper{position:absolute;z-index:4;background:none!important;border:none!important}.CodeMirror-gutter-background{position:absolute;top:0;bottom:0;z-index:4}.CodeMirror-gutter-elt{position:absolute;cursor:default;z-index:4}.CodeMirror-gutter-wrapper{-webkit-user-select:none;-moz-user-select:none;user-select:none}.CodeMirror-lines{cursor:text;min-height:1px}.CodeMirror pre{border-radius:0;border-width:0;background:transparent;font-family:inherit;font-size:inherit;margin:0;white-space:pre;word-wrap:normal;line-height:inherit;color:inherit;z-index:2;position:relative;overflow:visible;-webkit-tap-highlight-color:transparent;-webkit-font-variant-ligatures:none;font-variant-ligatures:none}.CodeMirror-wrap pre{word-wrap:break-word;white-space:pre-wrap;word-break:normal}.CodeMirror-linebackground{position:absolute;left:0;right:0;top:0;bottom:0;z-index:0}.CodeMirror-linewidget{position:relative;z-index:2;overflow:auto}.CodeMirror-code{outline:none}.CodeMirror-gutter,.CodeMirror-gutters,.CodeMirror-linenumber,.CodeMirror-scroll,.CodeMirror-sizer{box-sizing:content-box}.CodeMirror-measure{position:absolute;width:100%;height:0;overflow:hidden;visibility:hidden}.CodeMirror-cursor{position:absolute;pointer-events:none}.CodeMirror-measure pre{position:static}div.CodeMirror-cursors{visibility:hidden;position:relative;z-index:3}.CodeMirror-focused div.CodeMirror-cursors,div.CodeMirror-dragcursors{visibility:visible}.CodeMirror-selected{background:#d9d9d9}.CodeMirror-focused .CodeMirror-selected{background:#d7d4f0}.CodeMirror-crosshair{cursor:crosshair}.CodeMirror-line::selection,.CodeMirror-line>span::selection,.CodeMirror-line>span>span::selection{background:#d7d4f0}.CodeMirror-line::-moz-selection,.CodeMirror-line>span::-moz-selection,.CodeMirror-line>span>span::-moz-selection{background:#d7d4f0}.cm-searching{background:#ffa;background:rgba(255,255,0,.4)}.CodeMirror span{*vertical-align:text-bottom}.cm-force-border{padding-right:.1px}@media print{.CodeMirror div.CodeMirror-cursors{visibility:hidden}}.cm-tab-wrap-hack:after{content:''}span.CodeMirror-selectedtext{background:none}", ""]);
	
	// exports


/***/ }),
/* 2957 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1717)();
	// imports
	
	
	// module
	exports.push([module.id, ".rc-color-picker-panel-inner{position:relative;border-radius:4px;box-shadow:0 1px 5px #ccc;border:1px solid #ccc;padding:8px}.rc-color-picker-panel-wrap{margin:5px 0 0;height:30px;width:100%;position:relative}.rc-color-picker-panel-wrap-preview{position:absolute;right:0}.rc-color-picker-panel-wrap-ribbon{position:absolute;left:0;top:0;right:35px;height:12.5px}.rc-color-picker-panel-wrap-alpha{position:absolute;left:0;right:35px;bottom:0;height:12.5px}.rc-color-picker-trigger{border:1px solid #999;display:inline-block;padding:2px;border-radius:2px;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;width:20px;height:20px;cursor:pointer;box-shadow:inset 0 0 0 2px #fff}.rc-color-picker-trigger-open{box-shadow:0 0 3px #999}.rc-color-picker-panel{width:218px;background-color:#fff;box-sizing:border-box;outline:none;z-index:9;-moz-user-select:none;-webkit-user-select:none;-ms-user-select:none;user-select:none}.rc-color-picker-panel *{box-sizing:border-box}.rc-color-picker-panel-open{display:block}.rc-color-picker-panel-close{display:none}.rc-color-picker-panel-preview{height:30px;width:30px;overflow:hidden;border-radius:2px;box-shadow:inset 0 0 2px gray;background-image:url('data:image/png;base64,R0lGODdhCgAKAPAAAOXl5f///ywAAAAACgAKAEACEIQdqXt9GxyETrI279OIgwIAOw==')}.rc-color-picker-panel-preview input[type=color],.rc-color-picker-panel-preview span{position:absolute;display:block;height:100%;width:30px;border-radius:2px}.rc-color-picker-panel-preview input[type=color]{opacity:0}.rc-color-picker-panel-board{position:relative;font-size:0;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.rc-color-picker-panel-board span{position:absolute;border-radius:10px;border:1px solid #fff;width:9px;height:9px;left:-999px;top:-999px;box-shadow:0 0 1px hsla(0,0%,47%,.7);z-index:2}.rc-color-picker-panel-board-hsv{width:200px;height:150px;position:relative;z-index:1;border-radius:2px}.rc-color-picker-panel-board-value{border-radius:2px;position:absolute;width:100%;height:100%;left:0;top:0;z-index:2;background-image:url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiA/PjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDAlIiB2aWV3Qm94PSIwIDAgMSAxIiBwcmVzZXJ2ZUFzcGVjdFJhdGlvPSJub25lIj48bGluZWFyR3JhZGllbnQgaWQ9Imxlc3NoYXQtZ2VuZXJhdGVkIiBncmFkaWVudFVuaXRzPSJ1c2VyU3BhY2VPblVzZSIgeDE9IjAlIiB5MT0iMCUiIHgyPSIwJSIgeTI9IjEwMCUiPjxzdG9wIG9mZnNldD0iMCUiIHN0b3AtY29sb3I9InJnYigwLDAsMCkiIHN0b3Atb3BhY2l0eT0iMCIvPjxzdG9wIG9mZnNldD0iMTAwJSIgc3RvcC1jb2xvcj0iIzAwMDAwMCIgc3RvcC1vcGFjaXR5PSIxIi8+PC9saW5lYXJHcmFkaWVudD48cmVjdCB4PSIwIiB5PSIwIiB3aWR0aD0iMSIgaGVpZ2h0PSIxIiBmaWxsPSJ1cmwoI2xlc3NoYXQtZ2VuZXJhdGVkKSIgLz48L3N2Zz4=);background-image:linear-gradient(180deg,transparent 0,#000)}.rc-color-picker-panel-board-saturation{border-radius:2px;position:absolute;width:100%;height:100%;left:0;top:0;z-index:1;background-image:url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiA/PjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDAlIiB2aWV3Qm94PSIwIDAgMSAxIiBwcmVzZXJ2ZUFzcGVjdFJhdGlvPSJub25lIj48bGluZWFyR3JhZGllbnQgaWQ9Imxlc3NoYXQtZ2VuZXJhdGVkIiBncmFkaWVudFVuaXRzPSJ1c2VyU3BhY2VPblVzZSIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMCUiPjxzdG9wIG9mZnNldD0iMCUiIHN0b3AtY29sb3I9IiNmZmZmZmYiIHN0b3Atb3BhY2l0eT0iMSIvPjxzdG9wIG9mZnNldD0iMTAwJSIgc3RvcC1jb2xvcj0icmdiKDAsMCwwKSIgc3RvcC1vcGFjaXR5PSIwIi8+PC9saW5lYXJHcmFkaWVudD48cmVjdCB4PSIwIiB5PSIwIiB3aWR0aD0iMSIgaGVpZ2h0PSIxIiBmaWxsPSJ1cmwoI2xlc3NoYXQtZ2VuZXJhdGVkKSIgLz48L3N2Zz4=);background-image:linear-gradient(90deg,#fff 0,transparent)}.rc-color-picker-panel-board-handler{box-shadow:inset 0 0 2px gray;border-radius:2px;cursor:crosshair;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;position:absolute;top:0;left:0;width:100%;height:100%;z-index:3}.rc-color-picker-panel-ribbon{position:relative;height:100%;border-radius:2px;box-shadow:inset 0 0 2px gray;background-image:url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiA/PjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDAlIiB2aWV3Qm94PSIwIDAgMSAxIiBwcmVzZXJ2ZUFzcGVjdFJhdGlvPSJub25lIj48bGluZWFyR3JhZGllbnQgaWQ9Imxlc3NoYXQtZ2VuZXJhdGVkIiBncmFkaWVudFVuaXRzPSJ1c2VyU3BhY2VPblVzZSIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMCUiPjxzdG9wIG9mZnNldD0iMCUiIHN0b3AtY29sb3I9IiNmZjAwMDAiIHN0b3Atb3BhY2l0eT0iMSIvPjxzdG9wIG9mZnNldD0iMTAlIiBzdG9wLWNvbG9yPSIjZmY5OTAwIiBzdG9wLW9wYWNpdHk9IjEiLz48c3RvcCBvZmZzZXQ9IjIwJSIgc3RvcC1jb2xvcj0iI2NkZmYwMCIgc3RvcC1vcGFjaXR5PSIxIi8+PHN0b3Agb2Zmc2V0PSIzMCUiIHN0b3AtY29sb3I9IiMzNWZmMDAiIHN0b3Atb3BhY2l0eT0iMSIvPjxzdG9wIG9mZnNldD0iNDAlIiBzdG9wLWNvbG9yPSIjMDBmZjY2IiBzdG9wLW9wYWNpdHk9IjEiLz48c3RvcCBvZmZzZXQ9IjUwJSIgc3RvcC1jb2xvcj0iIzAwZmZmZCIgc3RvcC1vcGFjaXR5PSIxIi8+PHN0b3Agb2Zmc2V0PSI2MCUiIHN0b3AtY29sb3I9IiMwMDY2ZmYiIHN0b3Atb3BhY2l0eT0iMSIvPjxzdG9wIG9mZnNldD0iNzAlIiBzdG9wLWNvbG9yPSIjMzIwMGZmIiBzdG9wLW9wYWNpdHk9IjEiLz48c3RvcCBvZmZzZXQ9IjgwJSIgc3RvcC1jb2xvcj0iI2NkMDBmZiIgc3RvcC1vcGFjaXR5PSIxIi8+PHN0b3Agb2Zmc2V0PSI5MCUiIHN0b3AtY29sb3I9IiNmZjAwOTkiIHN0b3Atb3BhY2l0eT0iMSIvPjxzdG9wIG9mZnNldD0iMTAwJSIgc3RvcC1jb2xvcj0iI2ZmMDAwMCIgc3RvcC1vcGFjaXR5PSIxIi8+PC9saW5lYXJHcmFkaWVudD48cmVjdCB4PSIwIiB5PSIwIiB3aWR0aD0iMSIgaGVpZ2h0PSIxIiBmaWxsPSJ1cmwoI2xlc3NoYXQtZ2VuZXJhdGVkKSIgLz48L3N2Zz4=);background-image:linear-gradient(90deg,red 0,#f90 10%,#cdff00 20%,#35ff00 30%,#0f6 40%,#00fffd 50%,#06f 60%,#3200ff 70%,#cd00ff 80%,#f09 90%,red)}.rc-color-picker-panel-ribbon span{position:absolute;top:0;height:100%;width:4px;border:1px solid #000;padding:1px 0;margin-left:-2px;background-color:#fff;border-radius:3px}.rc-color-picker-panel-ribbon-handler{position:absolute;width:104%;height:100%;left:-2%;cursor:pointer}.rc-color-picker-panel-alpha{position:relative;height:100%;width:100%;border-radius:2px;background-image:url('data:image/png;base64,R0lGODdhCgAKAPAAAOXl5f///ywAAAAACgAKAEACEIQdqXt9GxyETrI279OIgwIAOw==');background-repeat:repeat;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.rc-color-picker-panel-alpha-bg{position:absolute;width:100%;height:100%;border-radius:2px;box-shadow:inset 0 0 2px gray}.rc-color-picker-panel-alpha span{position:absolute;top:0;height:100%;width:4px;border:1px solid #000;padding:1px 0;margin-left:-2px;background-color:#fff;border-radius:3px}.rc-color-picker-panel-alpha-handler{position:absolute;width:104%;height:100%;left:-2%;cursor:pointer}.rc-color-picker-panel-params{font-size:12px}.rc-color-picker-panel-params-input{overflow:hidden;padding:2px 0}.rc-color-picker-panel-params input{-webkit-user-select:text;-moz-user-select:text;-ms-user-select:text;user-select:text;text-align:center;padding:1px;margin:0;float:left;border-radius:2px;border:1px solid #cacaca;font-family:Helvetica Neue,Helvetica,sans-serif}.rc-color-picker-panel-params-hex{width:52px}.rc-color-picker-panel-params input[type=number]{margin-left:5px;width:32px}.rc-color-picker-panel-params input[type=number]::-webkit-inner-spin-button{-webkit-appearance:none}.rc-color-picker-panel-params-lable{padding:2px 0;height:22px;line-height:18px;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.rc-color-picker-panel-params-lable label{float:left;text-align:center}.rc-color-picker-panel-params-lable-hex{width:52px}.rc-color-picker-panel-params-lable-alpha,.rc-color-picker-panel-params-lable-number{margin-left:5px;width:32px}.rc-color-picker-panel-params-lable-number:hover{border-radius:2px;background-color:#eee;box-shadow:inset 0 0 0 1px #ccc;cursor:pointer}.rc-color-picker{position:absolute;left:-9999px;top:-9999px;z-index:1000}.rc-color-picker-wrap{display:inline-block}.rc-color-picker-slide-up-appear,.rc-color-picker-slide-up-enter{-webkit-animation-duration:.3s;animation-duration:.3s;-webkit-animation-fill-mode:both;animation-fill-mode:both;-webkit-transform-origin:0 0;transform-origin:0 0;display:block!important;opacity:0;-webkit-animation-timing-function:cubic-bezier(.08,.82,.17,1);animation-timing-function:cubic-bezier(.08,.82,.17,1);-webkit-animation-play-state:paused;animation-play-state:paused}.rc-color-picker-slide-up-leave{-webkit-animation-duration:.3s;animation-duration:.3s;-webkit-animation-fill-mode:both;animation-fill-mode:both;-webkit-transform-origin:0 0;transform-origin:0 0;display:block!important;opacity:1;-webkit-animation-timing-function:cubic-bezier(.6,.04,.98,.34);animation-timing-function:cubic-bezier(.6,.04,.98,.34);-webkit-animation-play-state:paused;animation-play-state:paused}.rc-color-picker-slide-up-appear.rc-color-picker-slide-up-appear-active.rc-color-picker-placement-bottomLeft,.rc-color-picker-slide-up-appear.rc-color-picker-slide-up-appear-active.rc-color-picker-placement-bottomRight,.rc-color-picker-slide-up-enter.rc-color-picker-slide-up-enter-active.rc-color-picker-placement-bottomLeft,.rc-color-picker-slide-up-enter.rc-color-picker-slide-up-enter-active.rc-color-picker-placement-bottomRight{-webkit-animation-name:rcColorPickerSlideUpIn;animation-name:rcColorPickerSlideUpIn;-webkit-animation-play-state:running;animation-play-state:running}.rc-color-picker-slide-up-appear.rc-color-picker-slide-up-appear-active.rc-color-picker-placement-topLeft,.rc-color-picker-slide-up-appear.rc-color-picker-slide-up-appear-active.rc-color-picker-placement-topRight,.rc-color-picker-slide-up-enter.rc-color-picker-slide-up-enter-active.rc-color-picker-placement-topLeft,.rc-color-picker-slide-up-enter.rc-color-picker-slide-up-enter-active.rc-color-picker-placement-topRight{-webkit-animation-name:rcColorPickerSlideDownIn;animation-name:rcColorPickerSlideDownIn;-webkit-animation-play-state:running;animation-play-state:running}.rc-color-picker-slide-up-leave.rc-color-picker-slide-up-leave-active.rc-color-picker-placement-bottomLeft,.rc-color-picker-slide-up-leave.rc-color-picker-slide-up-leave-active.rc-color-picker-placement-bottomRight{-webkit-animation-name:rcColorPickerSlideUpOut;animation-name:rcColorPickerSlideUpOut;-webkit-animation-play-state:running;animation-play-state:running}.rc-color-picker-slide-up-leave.rc-color-picker-slide-up-leave-active.rc-color-picker-placement-topLeft,.rc-color-picker-slide-up-leave.rc-color-picker-slide-up-leave-active.rc-color-picker-placement-topRight{-webkit-animation-name:rcColorPickerSlideDownOut;animation-name:rcColorPickerSlideDownOut;-webkit-animation-play-state:running;animation-play-state:running}@-webkit-keyframes rcColorPickerSlideUpIn{0%{opacity:0;-webkit-transform-origin:0 0;transform-origin:0 0;-webkit-transform:scaleY(0);transform:scaleY(0)}to{opacity:1;-webkit-transform-origin:0 0;transform-origin:0 0;-webkit-transform:scaleY(1);transform:scaleY(1)}}@keyframes rcColorPickerSlideUpIn{0%{opacity:0;-webkit-transform-origin:0 0;transform-origin:0 0;-webkit-transform:scaleY(0);transform:scaleY(0)}to{opacity:1;-webkit-transform-origin:0 0;transform-origin:0 0;-webkit-transform:scaleY(1);transform:scaleY(1)}}@-webkit-keyframes rcColorPickerSlideUpOut{0%{opacity:1;-webkit-transform-origin:0 0;transform-origin:0 0;-webkit-transform:scaleY(1);transform:scaleY(1)}to{opacity:0;-webkit-transform-origin:0 0;transform-origin:0 0;-webkit-transform:scaleY(0);transform:scaleY(0)}}@keyframes rcColorPickerSlideUpOut{0%{opacity:1;-webkit-transform-origin:0 0;transform-origin:0 0;-webkit-transform:scaleY(1);transform:scaleY(1)}to{opacity:0;-webkit-transform-origin:0 0;transform-origin:0 0;-webkit-transform:scaleY(0);transform:scaleY(0)}}@-webkit-keyframes rcColorPickerSlideDownIn{0%{opacity:0;-webkit-transform-origin:100% 100%;transform-origin:100% 100%;-webkit-transform:scaleY(0);transform:scaleY(0)}to{opacity:1;-webkit-transform-origin:100% 100%;transform-origin:100% 100%;-webkit-transform:scaleY(1);transform:scaleY(1)}}@keyframes rcColorPickerSlideDownIn{0%{opacity:0;-webkit-transform-origin:100% 100%;transform-origin:100% 100%;-webkit-transform:scaleY(0);transform:scaleY(0)}to{opacity:1;-webkit-transform-origin:100% 100%;transform-origin:100% 100%;-webkit-transform:scaleY(1);transform:scaleY(1)}}@-webkit-keyframes rcColorPickerSlideDownOut{0%{opacity:1;-webkit-transform-origin:100% 100%;transform-origin:100% 100%;-webkit-transform:scaleY(1);transform:scaleY(1)}to{opacity:0;-webkit-transform-origin:100% 100%;transform-origin:100% 100%;-webkit-transform:scaleY(0);transform:scaleY(0)}}@keyframes rcColorPickerSlideDownOut{0%{opacity:1;-webkit-transform-origin:100% 100%;transform-origin:100% 100%;-webkit-transform:scaleY(1);transform:scaleY(1)}to{opacity:0;-webkit-transform-origin:100% 100%;transform-origin:100% 100%;-webkit-transform:scaleY(0);transform:scaleY(0)}}", ""]);
	
	// exports


/***/ }),
/* 2958 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1717)();
	// imports
	
	
	// module
	exports.push([module.id, "/*!\n * Quill Editor v1.3.7\n * https://quilljs.com/\n * Copyright (c) 2014, Jason Chen\n * Copyright (c) 2013, salesforce.com\n */.ql-container{box-sizing:border-box;font-family:Helvetica,Arial,sans-serif;font-size:13px;height:100%;margin:0;position:relative}.ql-container.ql-disabled .ql-tooltip{visibility:hidden}.ql-container.ql-disabled .ql-editor ul[data-checked]>li:before{pointer-events:none}.ql-clipboard{left:-100000px;height:1px;overflow-y:hidden;position:absolute;top:50%}.ql-clipboard p{margin:0;padding:0}.ql-editor{box-sizing:border-box;line-height:1.42;height:100%;outline:none;overflow-y:auto;padding:12px 15px;tab-size:4;-moz-tab-size:4;text-align:left;white-space:pre-wrap;word-wrap:break-word}.ql-editor>*{cursor:text}.ql-editor blockquote,.ql-editor h1,.ql-editor h2,.ql-editor h3,.ql-editor h4,.ql-editor h5,.ql-editor h6,.ql-editor ol,.ql-editor p,.ql-editor pre,.ql-editor ul{margin:0;padding:0;counter-reset:list-1 list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9}.ql-editor ol,.ql-editor ul{padding-left:1.5em}.ql-editor ol>li,.ql-editor ul>li{list-style-type:none}.ql-editor ul>li:before{content:'\\2022'}.ql-editor ul[data-checked=false],.ql-editor ul[data-checked=true]{pointer-events:none}.ql-editor ul[data-checked=false]>li *,.ql-editor ul[data-checked=true]>li *{pointer-events:all}.ql-editor ul[data-checked=false]>li:before,.ql-editor ul[data-checked=true]>li:before{color:#777;cursor:pointer;pointer-events:all}.ql-editor ul[data-checked=true]>li:before{content:'\\2611'}.ql-editor ul[data-checked=false]>li:before{content:'\\2610'}.ql-editor li:before{display:inline-block;white-space:nowrap;width:1.2em}.ql-editor li:not(.ql-direction-rtl):before{margin-left:-1.5em;margin-right:.3em;text-align:right}.ql-editor li.ql-direction-rtl:before{margin-left:.3em;margin-right:-1.5em}.ql-editor ol li:not(.ql-direction-rtl),.ql-editor ul li:not(.ql-direction-rtl){padding-left:1.5em}.ql-editor ol li.ql-direction-rtl,.ql-editor ul li.ql-direction-rtl{padding-right:1.5em}.ql-editor ol li{counter-reset:list-1 list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9;counter-increment:list-0}.ql-editor ol li:before{content:counter(list-0,decimal) '. '}.ql-editor ol li.ql-indent-1{counter-increment:list-1}.ql-editor ol li.ql-indent-1:before{content:counter(list-1,lower-alpha) '. '}.ql-editor ol li.ql-indent-1{counter-reset:list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9}.ql-editor ol li.ql-indent-2{counter-increment:list-2}.ql-editor ol li.ql-indent-2:before{content:counter(list-2,lower-roman) '. '}.ql-editor ol li.ql-indent-2{counter-reset:list-3 list-4 list-5 list-6 list-7 list-8 list-9}.ql-editor ol li.ql-indent-3{counter-increment:list-3}.ql-editor ol li.ql-indent-3:before{content:counter(list-3,decimal) '. '}.ql-editor ol li.ql-indent-3{counter-reset:list-4 list-5 list-6 list-7 list-8 list-9}.ql-editor ol li.ql-indent-4{counter-increment:list-4}.ql-editor ol li.ql-indent-4:before{content:counter(list-4,lower-alpha) '. '}.ql-editor ol li.ql-indent-4{counter-reset:list-5 list-6 list-7 list-8 list-9}.ql-editor ol li.ql-indent-5{counter-increment:list-5}.ql-editor ol li.ql-indent-5:before{content:counter(list-5,lower-roman) '. '}.ql-editor ol li.ql-indent-5{counter-reset:list-6 list-7 list-8 list-9}.ql-editor ol li.ql-indent-6{counter-increment:list-6}.ql-editor ol li.ql-indent-6:before{content:counter(list-6,decimal) '. '}.ql-editor ol li.ql-indent-6{counter-reset:list-7 list-8 list-9}.ql-editor ol li.ql-indent-7{counter-increment:list-7}.ql-editor ol li.ql-indent-7:before{content:counter(list-7,lower-alpha) '. '}.ql-editor ol li.ql-indent-7{counter-reset:list-8 list-9}.ql-editor ol li.ql-indent-8{counter-increment:list-8}.ql-editor ol li.ql-indent-8:before{content:counter(list-8,lower-roman) '. '}.ql-editor ol li.ql-indent-8{counter-reset:list-9}.ql-editor ol li.ql-indent-9{counter-increment:list-9}.ql-editor ol li.ql-indent-9:before{content:counter(list-9,decimal) '. '}.ql-editor .ql-indent-1:not(.ql-direction-rtl){padding-left:3em}.ql-editor li.ql-indent-1:not(.ql-direction-rtl){padding-left:4.5em}.ql-editor .ql-indent-1.ql-direction-rtl.ql-align-right{padding-right:3em}.ql-editor li.ql-indent-1.ql-direction-rtl.ql-align-right{padding-right:4.5em}.ql-editor .ql-indent-2:not(.ql-direction-rtl){padding-left:6em}.ql-editor li.ql-indent-2:not(.ql-direction-rtl){padding-left:7.5em}.ql-editor .ql-indent-2.ql-direction-rtl.ql-align-right{padding-right:6em}.ql-editor li.ql-indent-2.ql-direction-rtl.ql-align-right{padding-right:7.5em}.ql-editor .ql-indent-3:not(.ql-direction-rtl){padding-left:9em}.ql-editor li.ql-indent-3:not(.ql-direction-rtl){padding-left:10.5em}.ql-editor .ql-indent-3.ql-direction-rtl.ql-align-right{padding-right:9em}.ql-editor li.ql-indent-3.ql-direction-rtl.ql-align-right{padding-right:10.5em}.ql-editor .ql-indent-4:not(.ql-direction-rtl){padding-left:12em}.ql-editor li.ql-indent-4:not(.ql-direction-rtl){padding-left:13.5em}.ql-editor .ql-indent-4.ql-direction-rtl.ql-align-right{padding-right:12em}.ql-editor li.ql-indent-4.ql-direction-rtl.ql-align-right{padding-right:13.5em}.ql-editor .ql-indent-5:not(.ql-direction-rtl){padding-left:15em}.ql-editor li.ql-indent-5:not(.ql-direction-rtl){padding-left:16.5em}.ql-editor .ql-indent-5.ql-direction-rtl.ql-align-right{padding-right:15em}.ql-editor li.ql-indent-5.ql-direction-rtl.ql-align-right{padding-right:16.5em}.ql-editor .ql-indent-6:not(.ql-direction-rtl){padding-left:18em}.ql-editor li.ql-indent-6:not(.ql-direction-rtl){padding-left:19.5em}.ql-editor .ql-indent-6.ql-direction-rtl.ql-align-right{padding-right:18em}.ql-editor li.ql-indent-6.ql-direction-rtl.ql-align-right{padding-right:19.5em}.ql-editor .ql-indent-7:not(.ql-direction-rtl){padding-left:21em}.ql-editor li.ql-indent-7:not(.ql-direction-rtl){padding-left:22.5em}.ql-editor .ql-indent-7.ql-direction-rtl.ql-align-right{padding-right:21em}.ql-editor li.ql-indent-7.ql-direction-rtl.ql-align-right{padding-right:22.5em}.ql-editor .ql-indent-8:not(.ql-direction-rtl){padding-left:24em}.ql-editor li.ql-indent-8:not(.ql-direction-rtl){padding-left:25.5em}.ql-editor .ql-indent-8.ql-direction-rtl.ql-align-right{padding-right:24em}.ql-editor li.ql-indent-8.ql-direction-rtl.ql-align-right{padding-right:25.5em}.ql-editor .ql-indent-9:not(.ql-direction-rtl){padding-left:27em}.ql-editor li.ql-indent-9:not(.ql-direction-rtl){padding-left:28.5em}.ql-editor .ql-indent-9.ql-direction-rtl.ql-align-right{padding-right:27em}.ql-editor li.ql-indent-9.ql-direction-rtl.ql-align-right{padding-right:28.5em}.ql-editor .ql-video{display:block;max-width:100%}.ql-editor .ql-video.ql-align-center{margin:0 auto}.ql-editor .ql-video.ql-align-right{margin:0 0 0 auto}.ql-editor .ql-bg-black{background-color:#000}.ql-editor .ql-bg-red{background-color:#e60000}.ql-editor .ql-bg-orange{background-color:#f90}.ql-editor .ql-bg-yellow{background-color:#ff0}.ql-editor .ql-bg-green{background-color:#008a00}.ql-editor .ql-bg-blue{background-color:#06c}.ql-editor .ql-bg-purple{background-color:#93f}.ql-editor .ql-color-white{color:#fff}.ql-editor .ql-color-red{color:#e60000}.ql-editor .ql-color-orange{color:#f90}.ql-editor .ql-color-yellow{color:#ff0}.ql-editor .ql-color-green{color:#008a00}.ql-editor .ql-color-blue{color:#06c}.ql-editor .ql-color-purple{color:#93f}.ql-editor .ql-font-serif{font-family:Georgia,Times New Roman,serif}.ql-editor .ql-font-monospace{font-family:Monaco,Courier New,monospace}.ql-editor .ql-size-small{font-size:.75em}.ql-editor .ql-size-large{font-size:1.5em}.ql-editor .ql-size-huge{font-size:2.5em}.ql-editor .ql-direction-rtl{direction:rtl;text-align:inherit}.ql-editor .ql-align-center{text-align:center}.ql-editor .ql-align-justify{text-align:justify}.ql-editor .ql-align-right{text-align:right}.ql-editor.ql-blank:before{color:rgba(0,0,0,.6);content:attr(data-placeholder);font-style:italic;left:15px;pointer-events:none;position:absolute;right:15px}.ql-snow.ql-toolbar:after,.ql-snow .ql-toolbar:after{clear:both;content:'';display:table}.ql-snow.ql-toolbar button,.ql-snow .ql-toolbar button{background:none;border:none;cursor:pointer;display:inline-block;float:left;height:24px;padding:3px 5px;width:28px}.ql-snow.ql-toolbar button svg,.ql-snow .ql-toolbar button svg{float:left;height:100%}.ql-snow.ql-toolbar button:active:hover,.ql-snow .ql-toolbar button:active:hover{outline:none}.ql-snow.ql-toolbar input.ql-image[type=file],.ql-snow .ql-toolbar input.ql-image[type=file]{display:none}.ql-snow.ql-toolbar .ql-picker-item.ql-selected,.ql-snow .ql-toolbar .ql-picker-item.ql-selected,.ql-snow.ql-toolbar .ql-picker-item:hover,.ql-snow .ql-toolbar .ql-picker-item:hover,.ql-snow.ql-toolbar .ql-picker-label.ql-active,.ql-snow .ql-toolbar .ql-picker-label.ql-active,.ql-snow.ql-toolbar .ql-picker-label:hover,.ql-snow .ql-toolbar .ql-picker-label:hover,.ql-snow.ql-toolbar button.ql-active,.ql-snow .ql-toolbar button.ql-active,.ql-snow.ql-toolbar button:focus,.ql-snow .ql-toolbar button:focus,.ql-snow.ql-toolbar button:hover,.ql-snow .ql-toolbar button:hover{color:#06c}.ql-snow.ql-toolbar .ql-picker-item.ql-selected .ql-fill,.ql-snow .ql-toolbar .ql-picker-item.ql-selected .ql-fill,.ql-snow.ql-toolbar .ql-picker-item.ql-selected .ql-stroke.ql-fill,.ql-snow .ql-toolbar .ql-picker-item.ql-selected .ql-stroke.ql-fill,.ql-snow.ql-toolbar .ql-picker-item:hover .ql-fill,.ql-snow .ql-toolbar .ql-picker-item:hover .ql-fill,.ql-snow.ql-toolbar .ql-picker-item:hover .ql-stroke.ql-fill,.ql-snow .ql-toolbar .ql-picker-item:hover .ql-stroke.ql-fill,.ql-snow.ql-toolbar .ql-picker-label.ql-active .ql-fill,.ql-snow .ql-toolbar .ql-picker-label.ql-active .ql-fill,.ql-snow.ql-toolbar .ql-picker-label.ql-active .ql-stroke.ql-fill,.ql-snow .ql-toolbar .ql-picker-label.ql-active .ql-stroke.ql-fill,.ql-snow.ql-toolbar .ql-picker-label:hover .ql-fill,.ql-snow .ql-toolbar .ql-picker-label:hover .ql-fill,.ql-snow.ql-toolbar .ql-picker-label:hover .ql-stroke.ql-fill,.ql-snow .ql-toolbar .ql-picker-label:hover .ql-stroke.ql-fill,.ql-snow.ql-toolbar button.ql-active .ql-fill,.ql-snow .ql-toolbar button.ql-active .ql-fill,.ql-snow.ql-toolbar button.ql-active .ql-stroke.ql-fill,.ql-snow .ql-toolbar button.ql-active .ql-stroke.ql-fill,.ql-snow.ql-toolbar button:focus .ql-fill,.ql-snow .ql-toolbar button:focus .ql-fill,.ql-snow.ql-toolbar button:focus .ql-stroke.ql-fill,.ql-snow .ql-toolbar button:focus .ql-stroke.ql-fill,.ql-snow.ql-toolbar button:hover .ql-fill,.ql-snow .ql-toolbar button:hover .ql-fill,.ql-snow.ql-toolbar button:hover .ql-stroke.ql-fill,.ql-snow .ql-toolbar button:hover .ql-stroke.ql-fill{fill:#06c}.ql-snow.ql-toolbar .ql-picker-item.ql-selected .ql-stroke,.ql-snow .ql-toolbar .ql-picker-item.ql-selected .ql-stroke,.ql-snow.ql-toolbar .ql-picker-item.ql-selected .ql-stroke-miter,.ql-snow .ql-toolbar .ql-picker-item.ql-selected .ql-stroke-miter,.ql-snow.ql-toolbar .ql-picker-item:hover .ql-stroke,.ql-snow .ql-toolbar .ql-picker-item:hover .ql-stroke,.ql-snow.ql-toolbar .ql-picker-item:hover .ql-stroke-miter,.ql-snow .ql-toolbar .ql-picker-item:hover .ql-stroke-miter,.ql-snow.ql-toolbar .ql-picker-label.ql-active .ql-stroke,.ql-snow .ql-toolbar .ql-picker-label.ql-active .ql-stroke,.ql-snow.ql-toolbar .ql-picker-label.ql-active .ql-stroke-miter,.ql-snow .ql-toolbar .ql-picker-label.ql-active .ql-stroke-miter,.ql-snow.ql-toolbar .ql-picker-label:hover .ql-stroke,.ql-snow .ql-toolbar .ql-picker-label:hover .ql-stroke,.ql-snow.ql-toolbar .ql-picker-label:hover .ql-stroke-miter,.ql-snow .ql-toolbar .ql-picker-label:hover .ql-stroke-miter,.ql-snow.ql-toolbar button.ql-active .ql-stroke,.ql-snow .ql-toolbar button.ql-active .ql-stroke,.ql-snow.ql-toolbar button.ql-active .ql-stroke-miter,.ql-snow .ql-toolbar button.ql-active .ql-stroke-miter,.ql-snow.ql-toolbar button:focus .ql-stroke,.ql-snow .ql-toolbar button:focus .ql-stroke,.ql-snow.ql-toolbar button:focus .ql-stroke-miter,.ql-snow .ql-toolbar button:focus .ql-stroke-miter,.ql-snow.ql-toolbar button:hover .ql-stroke,.ql-snow .ql-toolbar button:hover .ql-stroke,.ql-snow.ql-toolbar button:hover .ql-stroke-miter,.ql-snow .ql-toolbar button:hover .ql-stroke-miter{stroke:#06c}@media (pointer:coarse){.ql-snow.ql-toolbar button:hover:not(.ql-active),.ql-snow .ql-toolbar button:hover:not(.ql-active){color:#444}.ql-snow.ql-toolbar button:hover:not(.ql-active) .ql-fill,.ql-snow .ql-toolbar button:hover:not(.ql-active) .ql-fill,.ql-snow.ql-toolbar button:hover:not(.ql-active) .ql-stroke.ql-fill,.ql-snow .ql-toolbar button:hover:not(.ql-active) .ql-stroke.ql-fill{fill:#444}.ql-snow.ql-toolbar button:hover:not(.ql-active) .ql-stroke,.ql-snow .ql-toolbar button:hover:not(.ql-active) .ql-stroke,.ql-snow.ql-toolbar button:hover:not(.ql-active) .ql-stroke-miter,.ql-snow .ql-toolbar button:hover:not(.ql-active) .ql-stroke-miter{stroke:#444}}.ql-snow,.ql-snow *{box-sizing:border-box}.ql-snow .ql-hidden{display:none}.ql-snow .ql-out-bottom,.ql-snow .ql-out-top{visibility:hidden}.ql-snow .ql-tooltip{position:absolute;transform:translateY(10px)}.ql-snow .ql-tooltip a{cursor:pointer;text-decoration:none}.ql-snow .ql-tooltip.ql-flip{transform:translateY(-10px)}.ql-snow .ql-formats{display:inline-block;vertical-align:middle}.ql-snow .ql-formats:after{clear:both;content:'';display:table}.ql-snow .ql-stroke{fill:none;stroke:#444;stroke-linecap:round;stroke-linejoin:round;stroke-width:2}.ql-snow .ql-stroke-miter{fill:none;stroke:#444;stroke-miterlimit:10;stroke-width:2}.ql-snow .ql-fill,.ql-snow .ql-stroke.ql-fill{fill:#444}.ql-snow .ql-empty{fill:none}.ql-snow .ql-even{fill-rule:evenodd}.ql-snow .ql-stroke.ql-thin,.ql-snow .ql-thin{stroke-width:1}.ql-snow .ql-transparent{opacity:.4}.ql-snow .ql-direction svg:last-child{display:none}.ql-snow .ql-direction.ql-active svg:last-child{display:inline}.ql-snow .ql-direction.ql-active svg:first-child{display:none}.ql-snow .ql-editor h1{font-size:2em}.ql-snow .ql-editor h2{font-size:1.5em}.ql-snow .ql-editor h3{font-size:1.17em}.ql-snow .ql-editor h4{font-size:1em}.ql-snow .ql-editor h5{font-size:.83em}.ql-snow .ql-editor h6{font-size:.67em}.ql-snow .ql-editor a{text-decoration:underline}.ql-snow .ql-editor blockquote{border-left:4px solid #ccc;margin-bottom:5px;margin-top:5px;padding-left:16px}.ql-snow .ql-editor code,.ql-snow .ql-editor pre{background-color:#f0f0f0;border-radius:3px}.ql-snow .ql-editor pre{white-space:pre-wrap;margin-bottom:5px;margin-top:5px;padding:5px 10px}.ql-snow .ql-editor code{font-size:85%;padding:2px 4px}.ql-snow .ql-editor pre.ql-syntax{background-color:#23241f;color:#f8f8f2;overflow:visible}.ql-snow .ql-editor img{max-width:100%}.ql-snow .ql-picker{color:#444;display:inline-block;float:left;font-size:14px;font-weight:500;height:24px;position:relative;vertical-align:middle}.ql-snow .ql-picker-label{cursor:pointer;display:inline-block;height:100%;padding-left:8px;padding-right:2px;position:relative;width:100%}.ql-snow .ql-picker-label:before{display:inline-block;line-height:22px}.ql-snow .ql-picker-options{background-color:#fff;display:none;min-width:100%;padding:4px 8px;position:absolute;white-space:nowrap}.ql-snow .ql-picker-options .ql-picker-item{cursor:pointer;display:block;padding-bottom:5px;padding-top:5px}.ql-snow .ql-picker.ql-expanded .ql-picker-label{color:#ccc;z-index:2}.ql-snow .ql-picker.ql-expanded .ql-picker-label .ql-fill{fill:#ccc}.ql-snow .ql-picker.ql-expanded .ql-picker-label .ql-stroke{stroke:#ccc}.ql-snow .ql-picker.ql-expanded .ql-picker-options{display:block;margin-top:-1px;top:100%;z-index:1}.ql-snow .ql-color-picker,.ql-snow .ql-icon-picker{width:28px}.ql-snow .ql-color-picker .ql-picker-label,.ql-snow .ql-icon-picker .ql-picker-label{padding:2px 4px}.ql-snow .ql-color-picker .ql-picker-label svg,.ql-snow .ql-icon-picker .ql-picker-label svg{right:4px}.ql-snow .ql-icon-picker .ql-picker-options{padding:4px 0}.ql-snow .ql-icon-picker .ql-picker-item{height:24px;width:24px;padding:2px 4px}.ql-snow .ql-color-picker .ql-picker-options{padding:3px 5px;width:152px}.ql-snow .ql-color-picker .ql-picker-item{border:1px solid transparent;float:left;height:16px;margin:2px;padding:0;width:16px}.ql-snow .ql-picker:not(.ql-color-picker):not(.ql-icon-picker) svg{position:absolute;margin-top:-9px;right:0;top:50%;width:18px}.ql-snow .ql-picker.ql-font .ql-picker-item[data-label]:not([data-label='']):before,.ql-snow .ql-picker.ql-font .ql-picker-label[data-label]:not([data-label='']):before,.ql-snow .ql-picker.ql-header .ql-picker-item[data-label]:not([data-label='']):before,.ql-snow .ql-picker.ql-header .ql-picker-label[data-label]:not([data-label='']):before,.ql-snow .ql-picker.ql-size .ql-picker-item[data-label]:not([data-label='']):before,.ql-snow .ql-picker.ql-size .ql-picker-label[data-label]:not([data-label='']):before{content:attr(data-label)}.ql-snow .ql-picker.ql-header{width:98px}.ql-snow .ql-picker.ql-header .ql-picker-item:before,.ql-snow .ql-picker.ql-header .ql-picker-label:before{content:'Normal'}.ql-snow .ql-picker.ql-header .ql-picker-item[data-value=\"1\"]:before,.ql-snow .ql-picker.ql-header .ql-picker-label[data-value=\"1\"]:before{content:'Heading 1'}.ql-snow .ql-picker.ql-header .ql-picker-item[data-value=\"2\"]:before,.ql-snow .ql-picker.ql-header .ql-picker-label[data-value=\"2\"]:before{content:'Heading 2'}.ql-snow .ql-picker.ql-header .ql-picker-item[data-value=\"3\"]:before,.ql-snow .ql-picker.ql-header .ql-picker-label[data-value=\"3\"]:before{content:'Heading 3'}.ql-snow .ql-picker.ql-header .ql-picker-item[data-value=\"4\"]:before,.ql-snow .ql-picker.ql-header .ql-picker-label[data-value=\"4\"]:before{content:'Heading 4'}.ql-snow .ql-picker.ql-header .ql-picker-item[data-value=\"5\"]:before,.ql-snow .ql-picker.ql-header .ql-picker-label[data-value=\"5\"]:before{content:'Heading 5'}.ql-snow .ql-picker.ql-header .ql-picker-item[data-value=\"6\"]:before,.ql-snow .ql-picker.ql-header .ql-picker-label[data-value=\"6\"]:before{content:'Heading 6'}.ql-snow .ql-picker.ql-header .ql-picker-item[data-value=\"1\"]:before{font-size:2em}.ql-snow .ql-picker.ql-header .ql-picker-item[data-value=\"2\"]:before{font-size:1.5em}.ql-snow .ql-picker.ql-header .ql-picker-item[data-value=\"3\"]:before{font-size:1.17em}.ql-snow .ql-picker.ql-header .ql-picker-item[data-value=\"4\"]:before{font-size:1em}.ql-snow .ql-picker.ql-header .ql-picker-item[data-value=\"5\"]:before{font-size:.83em}.ql-snow .ql-picker.ql-header .ql-picker-item[data-value=\"6\"]:before{font-size:.67em}.ql-snow .ql-picker.ql-font{width:108px}.ql-snow .ql-picker.ql-font .ql-picker-item:before,.ql-snow .ql-picker.ql-font .ql-picker-label:before{content:'Sans Serif'}.ql-snow .ql-picker.ql-font .ql-picker-item[data-value=serif]:before,.ql-snow .ql-picker.ql-font .ql-picker-label[data-value=serif]:before{content:'Serif'}.ql-snow .ql-picker.ql-font .ql-picker-item[data-value=monospace]:before,.ql-snow .ql-picker.ql-font .ql-picker-label[data-value=monospace]:before{content:'Monospace'}.ql-snow .ql-picker.ql-font .ql-picker-item[data-value=serif]:before{font-family:Georgia,Times New Roman,serif}.ql-snow .ql-picker.ql-font .ql-picker-item[data-value=monospace]:before{font-family:Monaco,Courier New,monospace}.ql-snow .ql-picker.ql-size{width:98px}.ql-snow .ql-picker.ql-size .ql-picker-item:before,.ql-snow .ql-picker.ql-size .ql-picker-label:before{content:'Normal'}.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=small]:before,.ql-snow .ql-picker.ql-size .ql-picker-label[data-value=small]:before{content:'Small'}.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=large]:before,.ql-snow .ql-picker.ql-size .ql-picker-label[data-value=large]:before{content:'Large'}.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=huge]:before,.ql-snow .ql-picker.ql-size .ql-picker-label[data-value=huge]:before{content:'Huge'}.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=small]:before{font-size:10px}.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=large]:before{font-size:18px}.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=huge]:before{font-size:32px}.ql-snow .ql-color-picker.ql-background .ql-picker-item{background-color:#fff}.ql-snow .ql-color-picker.ql-color .ql-picker-item{background-color:#000}.ql-toolbar.ql-snow{border:1px solid #ccc;box-sizing:border-box;font-family:Helvetica Neue,Helvetica,Arial,sans-serif;padding:8px}.ql-toolbar.ql-snow .ql-formats{margin-right:15px}.ql-toolbar.ql-snow .ql-picker-label{border:1px solid transparent}.ql-toolbar.ql-snow .ql-picker-options{border:1px solid transparent;box-shadow:0 2px 8px rgba(0,0,0,.2)}.ql-toolbar.ql-snow .ql-picker.ql-expanded .ql-picker-label,.ql-toolbar.ql-snow .ql-picker.ql-expanded .ql-picker-options{border-color:#ccc}.ql-toolbar.ql-snow .ql-color-picker .ql-picker-item.ql-selected,.ql-toolbar.ql-snow .ql-color-picker .ql-picker-item:hover{border-color:#000}.ql-toolbar.ql-snow+.ql-container.ql-snow{border-top:0}.ql-snow .ql-tooltip{background-color:#fff;border:1px solid #ccc;box-shadow:0 0 5px #ddd;color:#444;padding:5px 12px;white-space:nowrap}.ql-snow .ql-tooltip:before{content:\"Visit URL:\";line-height:26px;margin-right:8px}.ql-snow .ql-tooltip input[type=text]{display:none;border:1px solid #ccc;font-size:13px;height:26px;margin:0;padding:3px 5px;width:170px}.ql-snow .ql-tooltip a.ql-preview{display:inline-block;max-width:200px;overflow-x:hidden;text-overflow:ellipsis;vertical-align:top}.ql-snow .ql-tooltip a.ql-action:after{border-right:1px solid #ccc;content:'Edit';margin-left:16px;padding-right:8px}.ql-snow .ql-tooltip a.ql-remove:before{content:'Remove';margin-left:8px}.ql-snow .ql-tooltip a{line-height:26px}.ql-snow .ql-tooltip.ql-editing a.ql-preview,.ql-snow .ql-tooltip.ql-editing a.ql-remove{display:none}.ql-snow .ql-tooltip.ql-editing input[type=text]{display:inline-block}.ql-snow .ql-tooltip.ql-editing a.ql-action:after{border-right:0;content:'Save';padding-right:0}.ql-snow .ql-tooltip[data-mode=link]:before{content:\"Enter link:\"}.ql-snow .ql-tooltip[data-mode=formula]:before{content:\"Enter formula:\"}.ql-snow .ql-tooltip[data-mode=video]:before{content:\"Enter video:\"}.ql-snow a{color:#06c}.ql-container.ql-snow{border:1px solid #ccc}", ""]);
	
	// exports


/***/ }),
/* 2959 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1717)();
	// imports
	
	
	// module
	exports.push([module.id, ".c3 svg{font:10px sans-serif;-webkit-tap-highlight-color:transparent}.c3 line,.c3 path{fill:none;stroke:#000}.c3 text{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.c3-bars path,.c3-event-rect,.c3-legend-item-tile,.c3-xgrid-focus,.c3-ygrid{shape-rendering:crispEdges}.c3-chart-arc path{stroke:#fff}.c3-chart-arc text{fill:#fff;font-size:13px}.c3-grid line{stroke:#aaa}.c3-grid text{fill:#aaa}.c3-xgrid,.c3-ygrid{stroke-dasharray:3 3}.c3-text.c3-empty{fill:grey;font-size:2em}.c3-line{stroke-width:1px}.c3-circle._expanded_{stroke-width:1px;stroke:#fff}.c3-selected-circle{fill:#fff;stroke-width:2px}.c3-bar{stroke-width:0}.c3-bar._expanded_{fill-opacity:1;fill-opacity:.75}.c3-target.c3-focused{opacity:1}.c3-target.c3-focused path.c3-line,.c3-target.c3-focused path.c3-step{stroke-width:2px}.c3-target.c3-defocused{opacity:.3!important}.c3-region{fill:#4682b4;fill-opacity:.1}.c3-brush .extent{fill-opacity:.1}.c3-legend-item{font-size:12px}.c3-legend-item-hidden{opacity:.15}.c3-legend-background{opacity:.75;fill:#fff;stroke:#d3d3d3;stroke-width:1}.c3-title{font:14px sans-serif}.c3-tooltip-container{z-index:10}.c3-tooltip{border-collapse:collapse;border-spacing:0;background-color:#fff;empty-cells:show;box-shadow:7px 7px 12px -9px #777;opacity:.9}.c3-tooltip tr{border:1px solid #ccc}.c3-tooltip th{background-color:#aaa;font-size:14px;padding:2px 5px;text-align:left;color:#fff}.c3-tooltip td{font-size:13px;padding:3px 6px;background-color:#fff;border-left:1px dotted #999}.c3-tooltip td>span{display:inline-block;width:10px;height:10px;margin-right:6px}.c3-tooltip td.value{text-align:right}.c3-area{stroke-width:0;opacity:.2}.c3-chart-arcs-title{dominant-baseline:middle;font-size:1.3em}.c3-chart-arcs .c3-chart-arcs-background{fill:#e0e0e0;stroke:none}.c3-chart-arcs .c3-chart-arcs-gauge-unit{fill:#000;font-size:16px}.c3-chart-arcs .c3-chart-arcs-gauge-max,.c3-chart-arcs .c3-chart-arcs-gauge-min{fill:#777}.c3-chart-arc .c3-gauge-value{fill:#000}.c3-chart-arc.c3-target.c3-focused g path,.c3-chart-arc.c3-target g path{opacity:1}.keen-dataviz{box-sizing:border-box}.keen-dataviz .keen-dataviz-title{color:#4d4d4d;font-family:Gotham Rounded SSm A,Gotham Rounded SSm B,Helvetica Neue,Helvetica,Arial,sans-serif;font-size:14px;font-weight:200;line-height:32px}.keen-dataviz .keen-dataviz-stage{display:block}.keen-dataviz .keen-dataviz-notes{color:grey;display:block;font-family:Helvetica Neue,Helvetica,Arial,sans-serif;font-size:12px;line-height:32px}.keen-c3-legend-label-overlay,.keen-dataviz .c3 svg,.keen-dataviz .c3-tooltip-container,.keen-dataviz .keen-dataviz-message,.keen-dataviz .keen-dataviz-metric,.keen-dataviz .keen-dataviz-table table{font-family:Gotham Rounded SSm A,Gotham Rounded SSm B,Helvetica Neue,Helvetica,Arial,sans-serif}.keen-dataviz .keen-dataviz-message{color:grey;display:block;font-size:21px;font-weight:200;line-height:24px;text-align:center;box-sizing:border-box}.keen-dataviz .keen-dataviz-metric{border-radius:4px;color:#fff;text-align:center}.keen-dataviz .keen-dataviz-metric-value{display:block;font-size:72px;font-weight:700;line-height:72px}.keen-dataviz .keen-dataviz-metric-title{display:block;font-size:24px;font-weight:200;line-height:24px;padding-top:8px}.keen-dataviz .keen-dataviz-table{border-bottom:1px solid #e7e7e7;box-sizing:border-box;overflow:scroll;position:relative}.keen-dataviz .keen-dataviz-table table{background:#fff;border-collapse:collapse;margin:0;position:relative;width:100%}.keen-dataviz .keen-dataviz-table td,.keen-dataviz .keen-dataviz-table th{border-collapse:collapse;font-size:13px;padding:10px;text-align:left;white-space:nowrap}.keen-dataviz .keen-dataviz-table th{border-bottom:1px solid #e7e7e7;color:#4d4d4d}.keen-dataviz .keen-dataviz-table td{background-color:#fff;color:#4d4d4d;-webkit-transition:background-color .1s,color 50ms;transition:background-color .1s,color 50ms}.keen-dataviz .keen-dataviz-table tr:nth-child(even) td{background-color:#f3f5f6}.keen-dataviz .keen-dataviz-table tr:hover td{background-color:#e7e7e7;color:#4d4d4d}.keen-dataviz .keen-dataviz-table .keen-dataviz-table-dataset thead{visibility:hidden}.keen-dataviz .keen-dataviz-table .keen-dataviz-table-fixed-header{background:#fff;border-bottom:1px solid rgba(0,0,0,.15);position:absolute;top:0;-webkit-transition:top .1s;transition:top .1s}.keen-dataviz .keen-spinner-container{box-sizing:border-box;display:block;height:50px;margin:0 auto;position:relative;width:35px}.keen-dataviz .keen-spinner-indicator{border-radius:100%;border:3px solid rgba(0,0,0,.1);border-top-color:rgba(0,0,0,.45);box-sizing:border-box;height:35px;width:35px;-webkit-animation:spin .7s linear infinite;animation:spin .7s linear infinite}@-webkit-keyframes spin{to{-webkit-transform:rotate(1turn)}}@keyframes spin{to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}.keen-dataviz .c3-tooltip-container th{font-size:12px;max-width:280px;word-wrap:break-word}.keen-dataviz .c3-tooltip-container td{font-size:11px;max-width:280px;word-wrap:break-word}.keen-dataviz .c3-tooltip-container td.name span{border-radius:50%}.keen-dataviz .c3-chart-arc text{font-size:11px}.keen-c3-legend{position:absolute;top:0}.keen-c3-legend-label-overlay{background:hsla(0,0%,100%,.9);box-shadow:0 1px 1px rgba(26,26,26,.09999999999999998);font-size:11px;padding:10px;position:absolute;word-wrap:break-word;z-index:2}.keen-c3-legend-label-overlay-pointer{border-color:transparent transparent #fff;border-style:solid;border-width:0 10px 10px;height:0;position:absolute;right:90px;top:-10px;width:0}", ""]);
	
	// exports


/***/ }),
/* 2960 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1717)();
	// imports
	
	
	// module
	exports.push([module.id, "@font-face{font-family:icomoon;src:url(\"/fonts/icomoon.eot?chkzsg\");src:url(\"/fonts/icomoon.eot?chkzsg#iefix\") format(\"embedded-opentype\"),url(\"/fonts/icomoon.ttf?chkzsg\") format(\"truetype\"),url(\"/fonts/icomoon.woff?chkzsg\") format(\"woff\"),url(\"/fonts/icomoon.svg?chkzsg#icomoon\") format(\"svg\");font-weight:400;font-style:normal}[class*=\" icon-\"],[class^=icon-]{font-family:icomoon;speak:none;font-style:normal;font-weight:400;font-variant:normal;text-transform:none;line-height:1;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.icon-profile:before{content:\"\\E923\"}.icon-qrcode:before{content:\"\\E938\"}.icon-ticket:before{content:\"\\E939\"}.icon-calendar:before{content:\"\\E953\"}.icon-spinner11:before{content:\"\\E984\"}.icon-search:before{content:\"\\E986\"}.icon-cog:before{content:\"\\E994\"}.icon-gift:before{content:\"\\E99F\"}.icon-fire:before{content:\"\\E9A9\"}.icon-im-bird .path1:before{content:\"\\E32F\";color:#0e3656}.icon-im-bird .path2:before{content:\"\\E330\";margin-left:-1em;color:#7fa3be}.icon-im-bird .path3:before{content:\"\\E331\";margin-left:-1em;color:#fff}.icon-im-bird .path4:before{content:\"\\E332\";margin-left:-1em;color:#0e3656}.icon-im-bird .path5:before{content:\"\\E333\";margin-left:-1em;color:#fff}.icon-im-bird .path6:before{content:\"\\E334\";margin-left:-1em;color:#0e3656}.icon-im-ticket .path1:before{content:\"\\E335\";color:#7fa3be}.icon-im-ticket .path2:before{content:\"\\E336\";margin-left:-1em;color:#fff}.icon-im-ticket .path3:before{content:\"\\E337\";margin-left:-1em;color:#0e3656}.icon-im-ticket .path4:before{content:\"\\E338\";margin-left:-1em;color:#0e3656}.icon-im-crown .path1:before{content:\"\\E9F0\";color:#7fa3be}.icon-im-crown .path2:before{content:\"\\E9F1\";margin-left:-1em;color:#aadee8}.icon-im-crown .path3:before{content:\"\\E9F2\";margin-left:-1em;color:#aadee8}.icon-im-crown .path4:before{content:\"\\E9F3\";margin-left:-1em;color:#aadee8}.icon-plus:before{content:\"\\EA0A\"}.icon-minus:before{content:\"\\EA0B\"}.icon-info:before{content:\"\\EA0C\"}.icon-exit:before{content:\"\\EA14\"}.stripe-connect{display:inline-block;margin-bottom:1px;background-image:-webkit-linear-gradient(#28a0e5,#015e94);background-image:linear-gradient(#28a0e5,#015e94);-webkit-font-smoothing:antialiased;border:0;padding:1px;height:30px;text-decoration:none;border-radius:4px;box-shadow:0 1px 0 rgba(0,0,0,.2);cursor:pointer;-moz-user-select:none;-webkit-user-select:none;-ms-user-select:none;user-select:none}.stripe-connect span{display:block;position:relative;padding:0 12px 0 44px;height:30px;background:#1275ff;background-image:-webkit-linear-gradient(#7dc5ee,#008cdd 85%,#30a2e4);background-image:linear-gradient(#7dc5ee,#008cdd 85%,#30a2e4);font-size:14px;line-height:30px;color:#fff;font-weight:700;font-family:Helvetica Neue,Helvetica,Arial,sans-serif;text-shadow:0 -1px 0 rgba(0,0,0,.2);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.25);border-radius:3px}.stripe-connect span:before{content:\"\";display:block;position:absolute;left:11px;top:50%;width:23px;height:24px;margin-top:-12px;background-repeat:no-repeat;background-size:23px 24px}.stripe-connect:active{background:#005d93}.stripe-connect:active span{color:#eee;background:#008cdd;background-image:-webkit-linear-gradient(#008cdd,#008cdd 85%,#239adf);background-image:linear-gradient(#008cdd,#008cdd 85%,#239adf);box-shadow:inset 0 1px 0 rgba(0,0,0,.1)}.stripe-connect.light-blue{background:#b5c3d8;background-image:-webkit-linear-gradient(#b5c3d8,#9cabc2);background-image:linear-gradient(#b5c3d8,#9cabc2);box-shadow:0 1px 0 rgba(0,0,0,.1)}.stripe-connect.light-blue span{color:#556f88;text-shadow:0 1px hsla(0,0%,100%,.8);background:#f0f5fa;background-image:-webkit-linear-gradient(#f0f5fa,#e4ecf5 85%,#e7eef6);background-image:linear-gradient(#f0f5fa,#e4ecf5 85%,#e7eef6);box-shadow:inset 0 1px 0 #fff}.stripe-connect.light-blue:active{background:#9babc2}.stripe-connect.light-blue:active span{color:#556f88;text-shadow:0 1px hsla(0,0%,100%,.8);background:#d7dee8;background-image:-webkit-linear-gradient(#d7dee8,#e7eef6);background-image:linear-gradient(#d7dee8,#e7eef6);box-shadow:inset 0 1px 0 rgba(0,0,0,.05)}.stripe-connect.dark{background:#252525;background:rgba(0,0,0,.5)!important}.stripe-connect.blue span:before,.stripe-connect span:before{background-image:url(\"data:image/png;base64,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\")}.stripe-connect.light-blue span:before{background-image:url(\"data:image/png;base64,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\")}@media only screen and (-webkit-min-device-pixel-ratio:1.5),only screen and (min--moz-device-pixel-ratio:1.5),only screen and (min-device-pixel-ratio:1.5){.stripe-connect.blue span:before,.stripe-connect span:before{background-image:url(\"data:image/png;base64,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\")}.stripe-connect.light-blue span:before{background-image:url(\"data:image/png;base64,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\")}}", ""]);
	
	// exports


/***/ }),
/* 2961 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1717)();
	// imports
	
	
	// module
	exports.push([module.id, ".rdrCalendarWrapper{box-sizing:border-box;background:#fff;display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.rdrDateDisplay{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}.rdrDateDisplayItem{-webkit-box-flex:1;-ms-flex:1 1;flex:1 1;width:0;text-align:center;color:inherit}.rdrDateDisplayItem+.rdrDateDisplayItem{margin-left:.833em}.rdrDateDisplayItem input{text-align:inherit}.rdrDateDisplayItem input:disabled{cursor:default}.rdrMonthAndYearWrapper{box-sizing:inherit;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}.rdrMonthAndYearPickers,.rdrMonthAndYearWrapper{display:-webkit-box;display:-ms-flexbox;display:flex}.rdrMonthAndYearPickers{-webkit-box-flex:1;-ms-flex:1 1 auto;flex:1 1 auto;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.rdrNextPrevButton{box-sizing:inherit;cursor:pointer;outline:none}.rdrMonths{display:-webkit-box;display:-ms-flexbox;display:flex}.rdrMonthsVertical{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.rdrMonthsHorizontal>div>div>div{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row}.rdrMonth{width:27.667em}.rdrWeekDays{display:-webkit-box;display:-ms-flexbox;display:flex}.rdrWeekDay{-ms-flex-preferred-size:14.28571%;flex-basis:14.28571%;box-sizing:inherit;text-align:center}.rdrDays{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap}.rdrInfiniteMonths{overflow:auto}.rdrDateRangeWrapper{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.rdrDay{box-sizing:inherit;width:14.28571%;position:relative;font:inherit;cursor:pointer}.rdrDayNumber{display:block;position:relative}.rdrDayNumber span{color:#1d2429}.rdrDayDisabled{cursor:not-allowed}.rdrEndEdge,.rdrInRange,.rdrSelected,.rdrStartEdge{pointer-events:none}.rdrDayEndPreview,.rdrDayInPreview,.rdrDayStartPreview{pointer-events:none}.rdrDateRangePickerWrapper{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.rdrStaticRanges{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.rdrStaticRange{font-size:inherit}.rdrInputRange{display:-webkit-box;display:-ms-flexbox;display:flex}", ""]);
	
	// exports


/***/ }),
/* 2962 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1717)();
	// imports
	
	
	// module
	exports.push([module.id, ".rdrCalendarWrapper{color:#000;font-size:12px}.rdrDateDisplay{background-color:#eff2f7;padding:.833em}.rdrDateDisplayItem{border-radius:4px;background-color:#fff;box-shadow:0 1px 2px 0 rgba(35,57,66,.21);border:1px solid transparent}.rdrDateDisplayItem input{cursor:pointer;height:2.5em;line-height:2.5em;border:0;background:transparent;width:100%;color:#849095}.rdrDateDisplayItemActive{border-color:currentColor}.rdrDateDisplayItemActive input{color:#7d888d}.rdrMonthAndYearWrapper{-webkit-box-align:center;-ms-flex-align:center;align-items:center;height:60px;padding-top:10px}.rdrMonthAndYearPickers{font-weight:600}.rdrMonthAndYearPickers select{-moz-appearance:none;appearance:none;-webkit-appearance:none;border:0;background:transparent;padding:10px 30px 10px 10px;border-radius:4px;outline:0;color:#3e484f;background:url(\"data:image/svg+xml;utf8,<svg width='9px' height='6px' viewBox='0 0 9 6' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'><g id='Artboard' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd' transform='translate(-636.000000, -171.000000)' fill-opacity='0.368716033'><g id='input' transform='translate(172.000000, 37.000000)' fill='#0E242F' fill-rule='nonzero'><g id='Group-9' transform='translate(323.000000, 127.000000)'><path d='M142.280245,7.23952813 C141.987305,6.92353472 141.512432,6.92361662 141.219585,7.23971106 C140.926739,7.5558055 140.926815,8.06821394 141.219755,8.38420735 L145.498801,13 L149.780245,8.38162071 C150.073185,8.0656273 150.073261,7.55321886 149.780415,7.23712442 C149.487568,6.92102998 149.012695,6.92094808 148.719755,7.23694149 L145.498801,10.7113732 L142.280245,7.23952813 Z' id='arrow'></path></g></g></g></svg>\") no-repeat;background-position:right 8px center;cursor:pointer;text-align:center}.rdrMonthAndYearPickers select:hover{background-color:rgba(0,0,0,.07)}.rdrMonthPicker,.rdrYearPicker{margin:0 5px}.rdrNextPrevButton{display:block;width:24px;height:24px;margin:0 .833em;padding:0;border:0;border-radius:5px;background:#eff2f7}.rdrNextPrevButton:hover{background:#e1e7f0}.rdrNextPrevButton i{display:block;width:0;height:0;padding:0;text-align:center;border-style:solid;margin:auto}.rdrNextPrevButton i,.rdrPprevButton i{-webkit-transform:translate(-3px);transform:translate(-3px)}.rdrPprevButton i{border-width:4px 6px 4px 4px;border-color:transparent #34495e transparent transparent}.rdrNextButton i{margin:0 0 0 7px;border-width:4px 4px 4px 6px;border-color:transparent transparent transparent #34495e;-webkit-transform:translate(3px);transform:translate(3px)}.rdrWeekDays{padding:0 .833em}.rdrMonth{padding:0 .833em 1.666em}.rdrMonth .rdrWeekDays{padding:0}.rdrMonths.rdrMonthsVertical .rdrMonth:first-child .rdrMonthName{display:none}.rdrWeekDay{font-weight:400;line-height:2.667em;color:#849095}.rdrDay{background:transparent;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;border:0;padding:0;line-height:3em;height:3em;text-align:center;color:#1d2429}.rdrDay:focus{outline:0}.rdrDayNumber{outline:0;font-weight:300;position:absolute;left:0;right:0;top:0;bottom:0;top:5px;bottom:5px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.rdrDayToday .rdrDayNumber span{font-weight:500}.rdrDayToday .rdrDayNumber span:after{content:'';position:absolute;bottom:4px;left:50%;-webkit-transform:translate(-50%);transform:translate(-50%);width:18px;height:2px;border-radius:2px;background:#3d91ff}.rdrDayToday .rdrEndEdge~.rdrDayNumber span:after,.rdrDayToday .rdrInRange~.rdrDayNumber span:after,.rdrDayToday .rdrSelected~.rdrDayNumber span:after,.rdrDayToday .rdrStartEdge~.rdrDayNumber span:after{background:#fff}.rdrDay:not(.rdrDayPassive) .rdrEndEdge~.rdrDayNumber span,.rdrDay:not(.rdrDayPassive) .rdrInRange~.rdrDayNumber span,.rdrDay:not(.rdrDayPassive) .rdrSelected~.rdrDayNumber span,.rdrDay:not(.rdrDayPassive) .rdrStartEdge~.rdrDayNumber span{color:hsla(0,0%,100%,.85)}.rdrEndEdge,.rdrInRange,.rdrSelected,.rdrStartEdge{background:currentColor;position:absolute;top:5px;left:0;right:0;bottom:5px}.rdrSelected{left:2px;right:2px}.rdrStartEdge{border-top-left-radius:1.042em;border-bottom-left-radius:1.042em;left:2px}.rdrEndEdge{border-top-right-radius:1.042em;border-bottom-right-radius:1.042em;right:2px}.rdrSelected{border-radius:1.042em}.rdrDayStartOfMonth .rdrEndEdge,.rdrDayStartOfMonth .rdrInRange,.rdrDayStartOfWeek .rdrEndEdge,.rdrDayStartOfWeek .rdrInRange{border-top-left-radius:1.042em;border-bottom-left-radius:1.042em;left:2px}.rdrDayEndOfMonth .rdrInRange,.rdrDayEndOfMonth .rdrStartEdge,.rdrDayEndOfWeek .rdrInRange,.rdrDayEndOfWeek .rdrStartEdge{border-top-right-radius:1.042em;border-bottom-right-radius:1.042em;right:2px}.rdrDayStartOfMonth .rdrDayEndPreview,.rdrDayStartOfMonth .rdrDayInPreview,.rdrDayStartOfWeek .rdrDayEndPreview,.rdrDayStartOfWeek .rdrDayInPreview{border-top-left-radius:1.333em;border-bottom-left-radius:1.333em;border-left-width:1px;left:0}.rdrDayEndOfMonth .rdrDayInPreview,.rdrDayEndOfMonth .rdrDayStartPreview,.rdrDayEndOfWeek .rdrDayInPreview,.rdrDayEndOfWeek .rdrDayStartPreview{border-top-right-radius:1.333em;border-bottom-right-radius:1.333em;border-right-width:1px;right:0}.rdrDayEndPreview,.rdrDayInPreview,.rdrDayStartPreview{background:hsla(0,0%,100%,.09);position:absolute;top:3px;left:0;right:0;bottom:3px;pointer-events:none;border:0 solid currentColor;z-index:1}.rdrDayStartPreview{border-top-width:1px;border-left-width:1px;border-bottom-width:1px;border-top-left-radius:1.333em;border-bottom-left-radius:1.333em;left:0}.rdrDayEndPreview,.rdrDayInPreview{border-top-width:1px;border-bottom-width:1px}.rdrDayEndPreview{border-right-width:1px;border-top-right-radius:1.333em;border-bottom-right-radius:1.333em;right:2px;right:0}.rdrDefinedRangesWrapper{font-size:12px;width:226px;border-right:1px solid #eff2f7;background:#fff}.rdrDefinedRangesWrapper .rdrStaticRangeSelected{color:currentColor;font-weight:600}.rdrStaticRange{border:0;cursor:pointer;display:block;outline:0;border-bottom:1px solid #eff2f7;padding:0;background:#fff}.rdrStaticRange:focus .rdrStaticRangeLabel,.rdrStaticRange:hover .rdrStaticRangeLabel{background:#eff2f7}.rdrStaticRangeLabel{display:block;outline:0;line-height:18px;padding:10px 20px;text-align:left}.rdrInputRanges{padding:10px 0}.rdrInputRange{-webkit-box-align:center;-ms-flex-align:center;align-items:center;padding:5px 20px}.rdrInputRangeInput{width:30px;height:30px;line-height:30px;border-radius:4px;text-align:center;border:1px solid #dee7eb;margin-right:10px;color:#6c767a}.rdrInputRangeInput:focus,.rdrInputRangeInput:hover{border-color:#b4bfc4;outline:0;color:#333}.rdrCalendarWrapper:not(.rdrDateRangeWrapper) .rdrDayHovered .rdrDayNumber:after{content:'';border:1px solid currentColor;border-radius:1.333em;position:absolute;top:-2px;bottom:-2px;left:0;right:0;background:transparent}.rdrDayPassive{pointer-events:none}.rdrDayPassive .rdrDayNumber span{color:#d5dce0}.rdrDayPassive .rdrDayEndPreview,.rdrDayPassive .rdrDayInPreview,.rdrDayPassive .rdrDayStartPreview,.rdrDayPassive .rdrEndEdge,.rdrDayPassive .rdrInRange,.rdrDayPassive .rdrSelected,.rdrDayPassive .rdrStartEdge{display:none}.rdrDayDisabled{background-color:#f8f8f8}.rdrDayDisabled .rdrDayNumber span{color:#aeb9bf}.rdrDayDisabled .rdrDayEndPreview,.rdrDayDisabled .rdrDayInPreview,.rdrDayDisabled .rdrDayStartPreview,.rdrDayDisabled .rdrEndEdge,.rdrDayDisabled .rdrInRange,.rdrDayDisabled .rdrSelected,.rdrDayDisabled .rdrStartEdge{-webkit-filter:grayscale(100%) opacity(60%);filter:grayscale(100%) opacity(60%)}.rdrMonthName{text-align:left;font-weight:600;color:#849095;padding:.833em}", ""]);
	
	// exports


/***/ }),
/* 2963 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1717)();
	// imports
	
	
	// module
	exports.push([module.id, "ag-grid,ag-grid-angular,ag-grid-aurelia,ag-grid-ng2,ag-grid-polymer{display:block}.ag-hidden{display:none!important}.ag-invisible{visibility:hidden!important}.ag-faded{opacity:.3}.ag-width-half{display:inline-block;width:50%!important}.ag-unselectable{-webkit-user-select:none!important;-moz-user-select:none!important;-ms-user-select:none!important;user-select:none!important}.ag-selectable{-webkit-user-select:text!important;-moz-user-select:text!important;-ms-user-select:text!important;user-select:text!important}.ag-select-agg-func-popup{position:absolute}.ag-input-wrapper{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-flex:1;-ms-flex:1 1 auto;flex:1 1 auto;-webkit-box-align:center;-ms-flex-align:center;align-items:center;line-height:normal;position:relative;overflow:hidden}.ag-shake-left-to-right{-webkit-animation-direction:alternate;animation-direction:alternate;-webkit-animation-duration:.2s;animation-duration:.2s;-webkit-animation-iteration-count:infinite;animation-iteration-count:infinite;-webkit-animation-name:ag-shake-left-to-right;animation-name:ag-shake-left-to-right}@-webkit-keyframes ag-shake-left-to-right{0%{padding-left:6px;padding-right:2px}to{padding-left:2px;padding-right:6px}}@keyframes ag-shake-left-to-right{0%{padding-left:6px;padding-right:2px}to{padding-left:2px;padding-right:6px}}.ag-root-wrapper{position:relative;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;overflow:hidden}.ag-root-wrapper.ag-layout-normal{height:100%}.ag-root-wrapper .ag-watermark{position:absolute;bottom:10px;right:25px;opacity:.5;-webkit-transition:opacity 1s ease-out 3s;transition:opacity 1s ease-out 3s}.ag-root-wrapper .ag-watermark:before{content:'';background-image:url(data:image/svg+xml;base64,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);-webkit-filter:invert(50%);filter:invert(50%);background-repeat:no-repeat;background-size:110px 60px;display:block;height:60px;width:110px}.ag-root-wrapper .ag-watermark .ag-watermark-text{opacity:.5;font-weight:700;font-family:Impact;font-size:19px}.ag-root-wrapper-body{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row}.ag-root-wrapper-body.ag-layout-normal{-webkit-box-flex:1;-ms-flex:1 1 auto;flex:1 1 auto;height:0;min-height:0}.ag-root{cursor:default;position:relative;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.ag-root.ag-layout-auto-height,.ag-root.ag-layout-normal{overflow:hidden;-webkit-box-flex:1;-ms-flex:1 1 auto;flex:1 1 auto;width:0}.ag-root.ag-layout-normal{height:100%}.ag-body-horizontal-scroll-viewport,.ag-body-viewport,.ag-center-cols-viewport,.ag-floating-bottom-viewport,.ag-floating-top-viewport,.ag-header-viewport,.ag-pinned-left-cols-viewport,.ag-pinned-right-cols-viewport,.ag-virtual-list-viewport{position:relative;height:100%;min-width:0;overflow:hidden;-webkit-box-flex:1;-ms-flex:1 1 auto;flex:1 1 auto}.ag-body-viewport{display:-webkit-box;display:-ms-flexbox;display:flex}.ag-body-viewport.ag-layout-normal{overflow-y:auto;-webkit-overflow-scrolling:touch}.ag-body-viewport:not(.ag-layout-print).ag-force-vertical-scroll{overflow-y:scroll}.ag-pinned-left-cols-viewport,.ag-pinned-right-cols-viewport{-webkit-box-flex:1000;-ms-flex-positive:1000;flex-grow:1000}.ag-center-cols-viewport{width:100%;overflow-x:auto}.ag-body-horizontal-scroll-viewport{overflow-x:scroll}.ag-virtual-list-viewport{overflow:auto;width:100%}.ag-body-container,.ag-body-horizontal-scroll-container,.ag-center-cols-container,.ag-floating-bottom-container,.ag-floating-bottom-full-width-container,.ag-floating-top-container,.ag-full-width-container,.ag-header-container,.ag-pinned-left-cols-container,.ag-pinned-right-cols-container,.ag-virtual-list-container{position:relative}.ag-floating-bottom-container,.ag-floating-top-container,.ag-header-container{height:100%;white-space:nowrap}.ag-body-viewport .ag-center-cols-clipper{min-height:100%}.ag-body-viewport.ag-layout-auto-height .ag-center-cols-clipper,.ag-body-viewport.ag-layout-auto-height .ag-center-cols-container{min-height:50px}.ag-body-viewport .ag-center-cols-container{display:block}.ag-body-viewport.ag-layout-print{-webkit-box-flex:0;-ms-flex:none;flex:none}.ag-body-viewport.ag-layout-print .ag-center-cols-clipper{min-width:100%}.ag-pinned-right-cols-container{display:block}.ag-body-horizontal-scroll-container{height:100%}.ag-floating-bottom-full-width-container,.ag-floating-top-full-width-container,.ag-full-width-container{position:absolute;top:0;left:0;pointer-events:none}.ag-full-width-container{width:100%}.ag-floating-bottom-full-width-container,.ag-floating-top-full-width-container{display:inline-block;overflow:hidden;height:100%;width:100%}.ag-virtual-list-container{overflow:hidden}.ag-center-cols-clipper{-webkit-box-flex:1;-ms-flex:1;flex:1;min-width:0;overflow:hidden}.ag-body-horizontal-scroll{min-height:0;min-width:0;width:100%;display:-webkit-box;display:-ms-flexbox;display:flex;position:relative}.ag-layout-print .ag-body-horizontal-scroll{display:none}.ag-horizontal-left-spacer,.ag-horizontal-right-spacer{height:100%;min-width:0;-webkit-box-flex:1000;-ms-flex-positive:1000;flex-grow:1000;overflow-x:scroll}.ag-horizontal-left-spacer.ag-scroller-corner,.ag-horizontal-right-spacer.ag-scroller-corner{overflow-x:hidden}.ag-header,.ag-pinned-left-header,.ag-pinned-right-header{display:inline-block;overflow:hidden}.ag-header .ag-header-cell-sortable,.ag-pinned-left-header .ag-header-cell-sortable,.ag-pinned-right-header .ag-header-cell-sortable{cursor:pointer}.ag-header{width:100%;white-space:nowrap}.ag-header,.ag-header-icon{display:-webkit-box;display:-ms-flexbox;display:flex}.ag-pinned-left-header,.ag-pinned-right-header{height:100%}.ag-header-row{position:absolute;overflow:hidden}.ag-header-overlay{display:block;position:absolute}.ag-header-cell{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;position:absolute;height:100%;overflow:hidden}.ag-header-cell-label,.ag-header-group-cell-label{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-flex:1;-ms-flex:1 1 auto;flex:1 1 auto;overflow:hidden;-webkit-box-align:center;-ms-flex-align:center;align-items:center;text-overflow:ellipsis;-ms-flex-item-align:stretch;align-self:stretch}.ag-header-cell-label .ag-header-cell-text{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.ag-numeric-header .ag-header-cell-label{-webkit-box-orient:horizontal;-webkit-box-direction:reverse;-ms-flex-direction:row-reverse;flex-direction:row-reverse}.ag-header-group-text{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.ag-header-cell-resize{position:absolute;z-index:1;height:100%;width:4px}.ag-header-expand-icon{padding-left:4px}.ag-header-select-all{display:-webkit-box;display:-ms-flexbox;display:flex}.ag-column-moving .ag-cell,.ag-column-moving .ag-header-cell{-webkit-transition:left .2s;transition:left .2s}.ag-column-moving .ag-header-group-cell{-webkit-transition:left .2s,width .2s;transition:left .2s,width .2s}.ag-column-panel{-ms-flex-direction:column;flex-direction:column;-webkit-box-flex:1;-ms-flex:1 1 auto;flex:1 1 auto}.ag-column-panel,.ag-column-select-panel{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;overflow:hidden}.ag-column-select-panel{-ms-flex-direction:column;flex-direction:column;-webkit-box-flex:4;-ms-flex-positive:4;flex-grow:4;-ms-flex-negative:1;flex-shrink:1;-ms-flex-preferred-size:0;flex-basis:0}.ag-column-select-panel .ag-primary-cols-header-panel{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-flex:0;-ms-flex:none;flex:none}.ag-column-select-panel .ag-primary-cols-header-panel .ag-column-name-filter,.ag-column-select-panel .ag-primary-cols-header-panel .ag-primary-cols-filter-wrapper{-webkit-box-flex:1;-ms-flex:1 1 auto;flex:1 1 auto}.ag-column-select-panel .ag-primary-cols-header-panel .ag-primary-cols-filter-wrapper input{width:100%}.ag-column-select-panel .ag-primary-cols-list-panel{-webkit-box-flex:1;-ms-flex:1 1 auto;flex:1 1 auto;overflow:auto}.ag-column-drop{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;overflow:auto;width:100%}.ag-column-drop,.ag-column-drop .ag-column-drop-list{-webkit-box-align:center;-ms-flex-align:center;align-items:center}.ag-column-drop .ag-column-drop-list{display:-webkit-box;display:-ms-flexbox;display:flex}.ag-column-drop .ag-column-drop-list .ag-column-drop-cell{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.ag-column-drop .ag-column-drop-list .ag-column-drop-cell .ag-column-drop-cell-text{overflow:hidden;-webkit-box-flex:1;-ms-flex:1 1 auto;flex:1 1 auto;text-overflow:ellipsis;white-space:nowrap}.ag-column-drop.ag-column-drop-vertical{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;overflow:hidden;-webkit-box-flex:1;-ms-flex:1 1 0px;flex:1 1 0;-webkit-box-align:stretch;-ms-flex-align:stretch;align-items:stretch}.ag-column-drop.ag-column-drop-vertical>div{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.ag-column-drop.ag-column-drop-vertical .ag-column-drop-list{-webkit-box-align:stretch;-ms-flex-align:stretch;align-items:stretch;-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;overflow-x:auto}.ag-column-drop.ag-column-drop-vertical .ag-column-drop-empty-message{display:block}.ag-column-drop.ag-column-drop-horizontal{white-space:nowrap;overflow:hidden}.ag-row-animation .ag-row{-webkit-transition:top .4s,height .4s,background-color .1s,opacity .2s,-webkit-transform .4s;transition:top .4s,height .4s,background-color .1s,opacity .2s,-webkit-transform .4s;transition:transform .4s,top .4s,height .4s,background-color .1s,opacity .2s;transition:transform .4s,top .4s,height .4s,background-color .1s,opacity .2s,-webkit-transform .4s}.ag-row-no-animation .ag-row{-webkit-transition:background-color .1s;transition:background-color .1s}.ag-row{white-space:nowrap;width:100%}.ag-row-position-absolute{position:absolute}.ag-row-position-relative{position:relative}.ag-full-width-row{overflow:hidden;pointer-events:all}.ag-row-inline-editing{z-index:1}.ag-row-dragging{z-index:2}.ag-stub-cell{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.ag-cell{display:inline-block;overflow:hidden;position:absolute;text-overflow:ellipsis;white-space:nowrap}.ag-cell-wrapper{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;width:100%;height:100%}.ag-cell-wrapper.ag-row-group{-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start}.ag-cell-wrapper .ag-cell-value,.ag-cell-wrapper .ag-group-value{overflow:hidden;text-overflow:ellipsis}.ag-full-width-row.ag-row-group .ag-cell-wrapper{-webkit-box-align:center;-ms-flex-align:center;align-items:center}.ag-cell-with-height{height:100%}.ag-footer-cell-entire-row,.ag-group-cell-entire-row{display:inline-block;height:100%;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;width:100%}.ag-cell-inline-editing{z-index:1}.ag-cell-inline-editing .ag-cell-edit-input,.ag-cell-inline-editing .ag-input-wrapper{height:100%;width:100%;line-height:normal}.ag-set-filter-item{overflow:hidden;text-overflow:ellipsis;white-space:nowrap;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.ag-set-filter-item,.ag-set-filter-item>div,.ag-set-filter-item>span{display:-webkit-box;display:-ms-flexbox;display:flex}.ag-filter .ag-filter-checkbox{pointer-events:none}.ag-filter .ag-filter-body-wrapper{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.ag-filter .ag-filter-filter{-webkit-box-flex:1;-ms-flex:1 1 auto;flex:1 1 auto}.ag-floating-filter-body .ag-react-container,.ag-floating-filter-full-body .ag-react-container{height:100%}.ag-floating-filter-body{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-flex:1;-ms-flex:1 1 auto;flex:1 1 auto;height:100%}.ag-floating-filter-body input{margin:0;-webkit-box-flex:1;-ms-flex:1 1 auto;flex:1 1 auto;max-height:calc(100% - 1px)}.ag-floating-filter-full-body{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;height:100%;width:100%}.ag-floating-filter-full-body>div{-webkit-box-flex:1;-ms-flex:1 1 auto;flex:1 1 auto}.ag-floating-filter-full-body input{margin:0;width:100%}.ag-floating-filter-full-body input[type=range]{height:100%}.ag-floating-filter{display:inline-block;position:absolute}.ag-floating-filter-input{width:100%}.ag-floating-filter-input:-moz-read-only{background-color:#eee}.ag-floating-filter-input:read-only{background-color:#eee}.ag-floating-filter-menu{position:absolute;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.ag-floating-filter-button{-webkit-box-flex:0;-ms-flex:none;flex:none}.ag-dnd-ghost,.ag-floating-filter-button{display:-webkit-box;display:-ms-flexbox;display:flex}.ag-dnd-ghost{-webkit-box-align:center;-ms-flex-align:center;align-items:center;background:#e5e5e5;border:1px solid #000;cursor:move;font-family:Helvetica Neue,Helvetica,Arial,sans-serif;font-size:14px;overflow:hidden;padding:3px;position:absolute;text-overflow:ellipsis;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;z-index:10}.ag-dnd-ghost-icon{padding:2px}.ag-overlay{height:100%;left:0;pointer-events:none;position:absolute;top:0;width:100%}.ag-overlay-panel{pointer-events:none}.ag-overlay-panel,.ag-overlay-wrapper{display:-webkit-box;display:-ms-flexbox;display:flex;height:100%;width:100%}.ag-overlay-wrapper{-webkit-box-flex:0;-ms-flex:none;flex:none;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;text-align:center}.ag-overlay-wrapper.ag-overlay-loading-wrapper{pointer-events:all}.ag-overlay-no-rows-wrapper.ag-layout-auto-height{padding-top:30px}.ag-popup>div{z-index:5}.ag-popup-backdrop{height:100%;left:0;position:fixed;top:0;width:100%}.ag-popup-editor{position:absolute;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;z-index:1}.ag-virtual-list-item{position:absolute;width:100%}.ag-virtual-list-item span:empty:not(.ag-icon){border-left:1px solid transparent}.ag-floating-top{overflow:hidden;white-space:nowrap;width:100%;position:relative;display:-webkit-box;display:-ms-flexbox;display:flex}.ag-pinned-left-floating-top,.ag-pinned-right-floating-top{display:inline-block;overflow:hidden;position:relative;min-width:0;-webkit-box-flex:1000;-ms-flex-positive:1000;flex-grow:1000}.ag-floating-bottom{overflow:hidden;white-space:nowrap;width:100%;position:relative;display:-webkit-box;display:-ms-flexbox;display:flex}.ag-pinned-left-floating-bottom,.ag-pinned-right-floating-bottom{display:inline-block;overflow:hidden;position:relative;min-width:0;-webkit-box-flex:1000;-ms-flex-positive:1000;flex-grow:1000}.ag-dialog,.ag-panel{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;position:relative;overflow:hidden}.ag-dialog .ag-title-bar,.ag-panel .ag-title-bar{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-flex:0;-ms-flex:none;flex:none;-webkit-box-align:center;-ms-flex-align:center;align-items:center;cursor:default}.ag-dialog .ag-title-bar .ag-title-bar-title,.ag-panel .ag-title-bar .ag-title-bar-title{-webkit-box-flex:1;-ms-flex:1 1 auto;flex:1 1 auto}.ag-dialog .ag-title-bar .ag-title-bar-buttons,.ag-panel .ag-title-bar .ag-title-bar-buttons{display:-webkit-box;display:-ms-flexbox;display:flex}.ag-dialog .ag-title-bar .ag-title-bar-buttons .ag-button,.ag-panel .ag-title-bar .ag-title-bar-buttons .ag-button{cursor:pointer}.ag-dialog .ag-panel-content-wrapper,.ag-panel .ag-panel-content-wrapper{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-flex:1;-ms-flex:1 1 auto;flex:1 1 auto;position:relative;overflow:hidden}.ag-dialog .ag-panel-content-wrapper>div,.ag-panel .ag-panel-content-wrapper>div{width:100%;height:100%}.ag-dialog{position:absolute}.ag-dialog .ag-resizer{position:absolute;pointer-events:none;z-index:1}.ag-dialog .ag-resizer.ag-resizer-topLeft{top:0;left:0;height:5px;width:5px;cursor:nwse-resize}.ag-dialog .ag-resizer.ag-resizer-top{top:0;left:5px;right:5px;height:5px;cursor:ns-resize}.ag-dialog .ag-resizer.ag-resizer-topRight{top:0;right:0;height:5px;width:5px;cursor:nesw-resize}.ag-dialog .ag-resizer.ag-resizer-right{top:5px;right:0;bottom:5px;width:5px;cursor:ew-resize}.ag-dialog .ag-resizer.ag-resizer-bottomRight{bottom:0;right:0;height:5px;width:5px;cursor:nwse-resize}.ag-dialog .ag-resizer.ag-resizer-bottom{bottom:0;left:5px;right:5px;height:5px;cursor:ns-resize}.ag-dialog .ag-resizer.ag-resizer-bottomLeft{bottom:0;left:0;height:5px;width:5px;cursor:nesw-resize}.ag-dialog .ag-resizer.ag-resizer-left{left:0;top:5px;bottom:5px;width:5px;cursor:ew-resize}.ag-dialog .ag-message-box{width:100%;height:100%;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.ag-dialog .ag-message-box .ag-message-box-content{-webkit-box-flex:1;-ms-flex:1 1 auto;flex:1 1 auto;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.ag-dialog .ag-message-box .ag-message-box-button-bar,.ag-dialog .ag-message-box .ag-message-box-content{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.ag-chart-tooltip,.ag-tooltip{position:absolute;pointer-events:none;z-index:99999}.ag-chart-tooltip{display:table;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;white-space:nowrap;font:12px Verdana,sans-serif;color:#000;background:#f4f4f4;border-radius:5px;box-shadow:0 0 1px rgba(3,3,3,.7),.5vh .5vh 1vh rgba(3,3,3,.25);opacity:0;-webkit-transform:scale(.9);transform:scale(.9);-webkit-transition:.3s cubic-bezier(.19,1,.22,1);transition:.3s cubic-bezier(.19,1,.22,1);-webkit-transition-property:opacity,-webkit-transform;transition-property:opacity,-webkit-transform;transition-property:opacity,transform;transition-property:opacity,transform,-webkit-transform}.ag-chart-tooltip.visible{opacity:1;-webkit-transform:scale(1);transform:scale(1)}.ag-chart-tooltip .title{font-weight:700;padding:7px;border-top-left-radius:5px;border-top-right-radius:5px;color:#fff;background-color:#888}.ag-chart-tooltip .content{padding:7px;line-height:1.7em}.ag-value-slide-out{margin-right:5px;opacity:1;-webkit-transition:opacity 3s,margin-right 3s;transition:opacity 3s,margin-right 3s;-webkit-transition-timing-function:linear;transition-timing-function:linear}.ag-value-slide-out-end{margin-right:10px;opacity:0}.ag-opacity-zero{opacity:0!important}.ag-menu{max-height:100%;overflow-y:auto;position:absolute;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.ag-menu-column-select-wrapper{height:265px;overflow:auto;width:200px}.ag-menu-list{display:table}.ag-menu-option,.ag-menu-separator{display:table-row}.ag-menu-option>span,.ag-menu-separator>span{display:table-cell;vertical-align:middle}.ag-menu-option-text{white-space:nowrap}.ag-menu-column-select-wrapper .ag-column-select-panel{height:100%}.ag-rich-select{cursor:default;outline:none}.ag-rich-select .ag-rich-select-value{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.ag-rich-select .ag-rich-select-value>span{-webkit-box-flex:1;-ms-flex:1 1 auto;flex:1 1 auto}.ag-rich-select .ag-rich-select-value>span.ag-icon{-webkit-box-ordinal-group:2;-ms-flex-order:1;order:1;-webkit-box-flex:0;-ms-flex:none;flex:none}.ag-rich-select .ag-rich-select-list .ag-virtual-list-item{display:-webkit-box;display:-ms-flexbox;display:flex}.ag-rich-select .ag-rich-select-list .ag-virtual-list-item .ag-rich-select-row{-webkit-box-flex:1;-ms-flex:1 1 auto;flex:1 1 auto;white-space:nowrap}.ag-paging-panel,.ag-rich-select .ag-rich-select-list .ag-virtual-list-item .ag-rich-select-row{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.ag-paging-panel{-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end}.ag-paging-panel .ag-paging-row-summary-panel{display:-webkit-box;display:-ms-flexbox;display:flex}.ag-paging-panel .ag-paging-row-summary-panel span{margin:0 3px}.ag-paging-page-summary-panel{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.ag-paging-page-summary-panel .ag-disabled{pointer-events:none}.ag-paging-page-summary-panel .ag-paging-button{position:relative;overflow:hidden}.ag-paging-page-summary-panel .ag-paging-button button{position:absolute}.ag-tool-panel-wrapper{display:-webkit-box;display:-ms-flexbox;display:flex;overflow-y:auto;cursor:default;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;width:200px}.ag-tool-panel-wrapper .ag-filter-toolpanel-header{line-height:1.5;cursor:pointer}.ag-column-tool-panel-column,.ag-column-tool-panel-column-group{-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-ms-flex-wrap:nowrap;flex-wrap:nowrap;text-overflow:ellipsis;white-space:nowrap}.ag-column-tool-panel-column-group .ag-column-tool-panel-column,.ag-column-tool-panel-column-group .ag-column-tool-panel-column-group,.ag-column-tool-panel-column .ag-column-tool-panel-column,.ag-column-tool-panel-column .ag-column-tool-panel-column-group{-webkit-box-flex:1;-ms-flex:1 1 auto;flex:1 1 auto;overflow:hidden;text-overflow:ellipsis}.ag-column-select-checkbox{display:-webkit-box;display:-ms-flexbox;display:flex}.ag-tool-panel-horizontal-resize{cursor:col-resize;height:100%;position:absolute;top:0;width:5px;z-index:1}.ag-rtl .ag-tool-panel-horizontal-resize{-webkit-transform:translateX(3px);transform:translateX(3px)}.ag-ltr .ag-tool-panel-horizontal-resize{-webkit-transform:translateX(-3px);transform:translateX(-3px)}.loading-filter{background-color:#e6e6e6;padding:5px;position:absolute;top:34px;z-index:1}.ag-details-grid,.ag-details-row,.loading-filter{height:100%;width:100%}.ag-header-group-cell{height:100%;overflow:hidden;position:absolute;text-overflow:ellipsis}.ag-cell-label-container,.ag-header-group-cell{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.ag-cell-label-container{-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;-webkit-box-orient:horizontal;-webkit-box-direction:reverse;-ms-flex-direction:row-reverse;flex-direction:row-reverse;width:100%}.ag-numeric-header .ag-cell-label-container{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row}.ag-side-bar{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:reverse;-ms-flex-direction:row-reverse;flex-direction:row-reverse}.ag-side-bar .ag-side-buttons div button{display:block;white-space:nowrap;outline:none;cursor:pointer}.ag-side-bar .ag-side-buttons div button span:not(.ag-icon){-webkit-writing-mode:tb;-ms-writing-mode:tb;writing-mode:tb;-webkit-writing-mode:vertical-lr;-ms-writing-mode:tb-lr;writing-mode:vertical-lr}.ag-side-bar .panel-container{width:180px}.ag-side-bar.full-width .panel-container{width:200px}.ag-rtl .ag-side-bar .ag-side-buttons button span:not(.ag-icon){-webkit-writing-mode:tb-rl;writing-mode:tb-rl;-webkit-writing-mode:vertical-rl;-ms-writing-mode:tb-rl;writing-mode:vertical-rl}.ag-status-bar{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;overflow:hidden}.ag-status-bar-center,.ag-status-bar-left,.ag-status-bar-right,.ag-status-bar .ag-status-panel{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex}.ag-group-component{position:relative;-webkit-box-flex:1;-ms-flex:1 1 100%;flex:1 1 100%}.ag-group-component .ag-group-component-title-bar,.ag-group-component .ag-group-component-toolbar{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.ag-group-component .ag-group-component-container{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.ag-group-component .ag-group-component-container .ag-group-subgroup{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-item-align:stretch;align-self:stretch}.ag-group-component .ag-group-item{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-flex:1;-ms-flex:1 1 auto;flex:1 1 auto;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.ag-group-component.ag-disabled .ag-group-component-container{pointer-events:none}.ag-group-component.ag-collapsed .ag-group-component-container,.ag-group-component.ag-collapsed .ag-group-component-toolbar{display:none}.ag-toggle-button .ag-input-wrapper .ag-icon{-webkit-transition:right .3s;transition:right .3s;position:absolute;top:-1px}.ag-input-field{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.ag-input-field input,.ag-input-field select,.ag-input-field textarea{-webkit-box-flex:1;-ms-flex:1 1 auto;flex:1 1 auto;width:100%;min-width:0}.ag-range-field{-webkit-box-align:center;-ms-flex-align:center;align-items:center}.ag-angle-select>.ag-wrapper,.ag-picker-field>.ag-wrapper,.ag-range-field,.ag-slider>.ag-wrapper{display:-webkit-box;display:-ms-flexbox;display:flex}.ag-angle-select>.ag-wrapper>div,.ag-picker-field>.ag-wrapper>div,.ag-slider>.ag-wrapper>div{-webkit-box-flex:1;-ms-flex:1 1 auto;flex:1 1 auto}.ag-angle-select{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.ag-angle-select .ag-angle-select-field .ag-parent-circle{display:block;position:relative}.ag-angle-select .ag-angle-select-field .ag-child-circle{position:absolute}.ag-picker-field{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.ag-picker-field>.ag-wrapper>button{display:-webkit-box;display:-ms-flexbox;display:flex;border:0;padding:0;margin:0}.ag-color-picker>.ag-wrapper{-webkit-box-align:stretch;-ms-flex-align:stretch;align-items:stretch;overflow:hidden}.ag-color-picker button{cursor:pointer}.ag-labeled.ag-label-align-right label{-webkit-box-ordinal-group:2;-ms-flex-order:1;order:1}.ag-labeled.ag-label-align-right>div{-webkit-box-flex:0;-ms-flex:none;flex:none}.ag-labeled.ag-label-align-top{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start}.ag-labeled.ag-label-align-top>div{-ms-flex-item-align:stretch;align-self:stretch}.ag-color-panel{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;text-align:center}.ag-color-panel .ag-spectrum-color{-webkit-box-flex:1;-ms-flex:1 1 auto;flex:1 1 auto;position:relative;overflow:hidden;cursor:default}.ag-color-panel .ag-fill{position:absolute;top:0;left:0;right:0;bottom:0}.ag-color-panel .ag-spectrum-val{cursor:pointer}.ag-color-panel .ag-spectrum-dragger{position:absolute;pointer-events:none;cursor:pointer}.ag-color-panel .ag-spectrum-hue{cursor:default;background:-webkit-gradient(linear,right top,left top,color-stop(3%,red),color-stop(17%,#ff0),color-stop(33%,#0f0),color-stop(50%,#0ff),color-stop(67%,#00f),color-stop(83%,#f0f),to(red));background:linear-gradient(270deg,red 3%,#ff0 17%,#0f0 33%,#0ff 50%,#00f 67%,#f0f 83%,red)}.ag-color-panel .ag-spectrum-alpha{cursor:default}.ag-color-panel .ag-spectrum-hue-background{width:100%;height:100%}.ag-color-panel .ag-spectrum-alpha-background{background-image:-webkit-gradient(linear,left top,right top,from(transparent),to(#000));background-image:linear-gradient(90deg,transparent,#000);width:100%;height:100%}.ag-color-panel .ag-hue-alpha{cursor:pointer}.ag-color-panel .ag-spectrum-slider{position:absolute;pointer-events:none}.ag-color-panel .ag-spectrum-text-value{display:inline-block;text-align:center;overflow:hidden;white-space:nowrap}.ag-color-panel .ag-spectrum-text-value:focus{outline:none;outline-offset:0}.ag-color-panel .ag-recent-colors{display:-webkit-box;display:-ms-flexbox;display:flex}.ag-color-panel .ag-recent-colors>div{cursor:pointer}.ag-ltr .ag-toolpanel-indent-1{padding-left:10px}.ag-rtl .ag-toolpanel-indent-1{padding-right:10px}.ag-ltr .ag-row-group-indent-1{padding-left:10px}.ag-rtl .ag-row-group-indent-1{padding-right:10px}.ag-ltr .ag-toolpanel-indent-2{padding-left:20px}.ag-rtl .ag-toolpanel-indent-2{padding-right:20px}.ag-ltr .ag-row-group-indent-2{padding-left:20px}.ag-rtl .ag-row-group-indent-2{padding-right:20px}.ag-ltr .ag-toolpanel-indent-3{padding-left:30px}.ag-rtl .ag-toolpanel-indent-3{padding-right:30px}.ag-ltr .ag-row-group-indent-3{padding-left:30px}.ag-rtl .ag-row-group-indent-3{padding-right:30px}.ag-ltr .ag-toolpanel-indent-4{padding-left:40px}.ag-rtl .ag-toolpanel-indent-4{padding-right:40px}.ag-ltr .ag-row-group-indent-4{padding-left:40px}.ag-rtl .ag-row-group-indent-4{padding-right:40px}.ag-ltr .ag-toolpanel-indent-5{padding-left:50px}.ag-rtl .ag-toolpanel-indent-5{padding-right:50px}.ag-ltr .ag-row-group-indent-5{padding-left:50px}.ag-rtl .ag-row-group-indent-5{padding-right:50px}.ag-ltr .ag-toolpanel-indent-6{padding-left:60px}.ag-rtl .ag-toolpanel-indent-6{padding-right:60px}.ag-ltr .ag-row-group-indent-6{padding-left:60px}.ag-rtl .ag-row-group-indent-6{padding-right:60px}.ag-ltr .ag-toolpanel-indent-7{padding-left:70px}.ag-rtl .ag-toolpanel-indent-7{padding-right:70px}.ag-ltr .ag-row-group-indent-7{padding-left:70px}.ag-rtl .ag-row-group-indent-7{padding-right:70px}.ag-ltr .ag-toolpanel-indent-8{padding-left:80px}.ag-rtl .ag-toolpanel-indent-8{padding-right:80px}.ag-ltr .ag-row-group-indent-8{padding-left:80px}.ag-rtl .ag-row-group-indent-8{padding-right:80px}.ag-ltr .ag-toolpanel-indent-9{padding-left:90px}.ag-rtl .ag-toolpanel-indent-9{padding-right:90px}.ag-ltr .ag-row-group-indent-9{padding-left:90px}.ag-rtl .ag-row-group-indent-9{padding-right:90px}.ag-ltr .ag-toolpanel-indent-10{padding-left:100px}.ag-rtl .ag-toolpanel-indent-10{padding-right:100px}.ag-ltr .ag-row-group-indent-10{padding-left:100px}.ag-rtl .ag-row-group-indent-10{padding-right:100px}.ag-ltr .ag-toolpanel-indent-11{padding-left:110px}.ag-rtl .ag-toolpanel-indent-11{padding-right:110px}.ag-ltr .ag-row-group-indent-11{padding-left:110px}.ag-rtl .ag-row-group-indent-11{padding-right:110px}.ag-ltr .ag-toolpanel-indent-12{padding-left:120px}.ag-rtl .ag-toolpanel-indent-12{padding-right:120px}.ag-ltr .ag-row-group-indent-12{padding-left:120px}.ag-rtl .ag-row-group-indent-12{padding-right:120px}.ag-ltr .ag-toolpanel-indent-13{padding-left:130px}.ag-rtl .ag-toolpanel-indent-13{padding-right:130px}.ag-ltr .ag-row-group-indent-13{padding-left:130px}.ag-rtl .ag-row-group-indent-13{padding-right:130px}.ag-ltr .ag-toolpanel-indent-14{padding-left:140px}.ag-rtl .ag-toolpanel-indent-14{padding-right:140px}.ag-ltr .ag-row-group-indent-14{padding-left:140px}.ag-rtl .ag-row-group-indent-14{padding-right:140px}.ag-ltr .ag-toolpanel-indent-15{padding-left:150px}.ag-rtl .ag-toolpanel-indent-15{padding-right:150px}.ag-ltr .ag-row-group-indent-15{padding-left:150px}.ag-rtl .ag-row-group-indent-15{padding-right:150px}.ag-ltr .ag-toolpanel-indent-16{padding-left:160px}.ag-rtl .ag-toolpanel-indent-16{padding-right:160px}.ag-ltr .ag-row-group-indent-16{padding-left:160px}.ag-rtl .ag-row-group-indent-16{padding-right:160px}.ag-ltr .ag-toolpanel-indent-17{padding-left:170px}.ag-rtl .ag-toolpanel-indent-17{padding-right:170px}.ag-ltr .ag-row-group-indent-17{padding-left:170px}.ag-rtl .ag-row-group-indent-17{padding-right:170px}.ag-ltr .ag-toolpanel-indent-18{padding-left:180px}.ag-rtl .ag-toolpanel-indent-18{padding-right:180px}.ag-ltr .ag-row-group-indent-18{padding-left:180px}.ag-rtl .ag-row-group-indent-18{padding-right:180px}.ag-ltr .ag-toolpanel-indent-19{padding-left:190px}.ag-rtl .ag-toolpanel-indent-19{padding-right:190px}.ag-ltr .ag-row-group-indent-19{padding-left:190px}.ag-rtl .ag-row-group-indent-19{padding-right:190px}.ag-ltr .ag-toolpanel-indent-20{padding-left:200px}.ag-rtl .ag-toolpanel-indent-20{padding-right:200px}.ag-ltr .ag-row-group-indent-20{padding-left:200px}.ag-rtl .ag-row-group-indent-20{padding-right:200px}.ag-ltr .ag-toolpanel-indent-21{padding-left:210px}.ag-rtl .ag-toolpanel-indent-21{padding-right:210px}.ag-ltr .ag-row-group-indent-21{padding-left:210px}.ag-rtl .ag-row-group-indent-21{padding-right:210px}.ag-ltr .ag-toolpanel-indent-22{padding-left:220px}.ag-rtl .ag-toolpanel-indent-22{padding-right:220px}.ag-ltr .ag-row-group-indent-22{padding-left:220px}.ag-rtl .ag-row-group-indent-22{padding-right:220px}.ag-ltr .ag-toolpanel-indent-23{padding-left:230px}.ag-rtl .ag-toolpanel-indent-23{padding-right:230px}.ag-ltr .ag-row-group-indent-23{padding-left:230px}.ag-rtl .ag-row-group-indent-23{padding-right:230px}.ag-ltr .ag-toolpanel-indent-24{padding-left:240px}.ag-rtl .ag-toolpanel-indent-24{padding-right:240px}.ag-ltr .ag-row-group-indent-24{padding-left:240px}.ag-rtl .ag-row-group-indent-24{padding-right:240px}.ag-ltr .ag-toolpanel-indent-25{padding-left:250px}.ag-rtl .ag-toolpanel-indent-25{padding-right:250px}.ag-ltr .ag-row-group-indent-25{padding-left:250px}.ag-rtl .ag-row-group-indent-25{padding-right:250px}.ag-ltr .ag-toolpanel-indent-26{padding-left:260px}.ag-rtl .ag-toolpanel-indent-26{padding-right:260px}.ag-ltr .ag-row-group-indent-26{padding-left:260px}.ag-rtl .ag-row-group-indent-26{padding-right:260px}.ag-ltr .ag-toolpanel-indent-27{padding-left:270px}.ag-rtl .ag-toolpanel-indent-27{padding-right:270px}.ag-ltr .ag-row-group-indent-27{padding-left:270px}.ag-rtl .ag-row-group-indent-27{padding-right:270px}.ag-ltr .ag-toolpanel-indent-28{padding-left:280px}.ag-rtl .ag-toolpanel-indent-28{padding-right:280px}.ag-ltr .ag-row-group-indent-28{padding-left:280px}.ag-rtl .ag-row-group-indent-28{padding-right:280px}.ag-ltr .ag-toolpanel-indent-29{padding-left:290px}.ag-rtl .ag-toolpanel-indent-29{padding-right:290px}.ag-ltr .ag-row-group-indent-29{padding-left:290px}.ag-rtl .ag-row-group-indent-29{padding-right:290px}.ag-ltr .ag-toolpanel-indent-30{padding-left:300px}.ag-rtl .ag-toolpanel-indent-30{padding-right:300px}.ag-ltr .ag-row-group-indent-30{padding-left:300px}.ag-rtl .ag-row-group-indent-30{padding-right:300px}.ag-ltr .ag-toolpanel-indent-31{padding-left:310px}.ag-rtl .ag-toolpanel-indent-31{padding-right:310px}.ag-ltr .ag-row-group-indent-31{padding-left:310px}.ag-rtl .ag-row-group-indent-31{padding-right:310px}.ag-ltr .ag-toolpanel-indent-32{padding-left:320px}.ag-rtl .ag-toolpanel-indent-32{padding-right:320px}.ag-ltr .ag-row-group-indent-32{padding-left:320px}.ag-rtl .ag-row-group-indent-32{padding-right:320px}.ag-ltr .ag-toolpanel-indent-33{padding-left:330px}.ag-rtl .ag-toolpanel-indent-33{padding-right:330px}.ag-ltr .ag-row-group-indent-33{padding-left:330px}.ag-rtl .ag-row-group-indent-33{padding-right:330px}.ag-ltr .ag-toolpanel-indent-34{padding-left:340px}.ag-rtl .ag-toolpanel-indent-34{padding-right:340px}.ag-ltr .ag-row-group-indent-34{padding-left:340px}.ag-rtl .ag-row-group-indent-34{padding-right:340px}.ag-ltr .ag-toolpanel-indent-35{padding-left:350px}.ag-rtl .ag-toolpanel-indent-35{padding-right:350px}.ag-ltr .ag-row-group-indent-35{padding-left:350px}.ag-rtl .ag-row-group-indent-35{padding-right:350px}.ag-ltr .ag-toolpanel-indent-36{padding-left:360px}.ag-rtl .ag-toolpanel-indent-36{padding-right:360px}.ag-ltr .ag-row-group-indent-36{padding-left:360px}.ag-rtl .ag-row-group-indent-36{padding-right:360px}.ag-ltr .ag-toolpanel-indent-37{padding-left:370px}.ag-rtl .ag-toolpanel-indent-37{padding-right:370px}.ag-ltr .ag-row-group-indent-37{padding-left:370px}.ag-rtl .ag-row-group-indent-37{padding-right:370px}.ag-ltr .ag-toolpanel-indent-38{padding-left:380px}.ag-rtl .ag-toolpanel-indent-38{padding-right:380px}.ag-ltr .ag-row-group-indent-38{padding-left:380px}.ag-rtl .ag-row-group-indent-38{padding-right:380px}.ag-ltr .ag-toolpanel-indent-39{padding-left:390px}.ag-rtl .ag-toolpanel-indent-39{padding-right:390px}.ag-ltr .ag-row-group-indent-39{padding-left:390px}.ag-rtl .ag-row-group-indent-39{padding-right:390px}.ag-ltr .ag-toolpanel-indent-40{padding-left:400px}.ag-rtl .ag-toolpanel-indent-40{padding-right:400px}.ag-ltr .ag-row-group-indent-40{padding-left:400px}.ag-rtl .ag-row-group-indent-40{padding-right:400px}.ag-ltr .ag-toolpanel-indent-41{padding-left:410px}.ag-rtl .ag-toolpanel-indent-41{padding-right:410px}.ag-ltr .ag-row-group-indent-41{padding-left:410px}.ag-rtl .ag-row-group-indent-41{padding-right:410px}.ag-ltr .ag-toolpanel-indent-42{padding-left:420px}.ag-rtl .ag-toolpanel-indent-42{padding-right:420px}.ag-ltr .ag-row-group-indent-42{padding-left:420px}.ag-rtl .ag-row-group-indent-42{padding-right:420px}.ag-ltr .ag-toolpanel-indent-43{padding-left:430px}.ag-rtl .ag-toolpanel-indent-43{padding-right:430px}.ag-ltr .ag-row-group-indent-43{padding-left:430px}.ag-rtl .ag-row-group-indent-43{padding-right:430px}.ag-ltr .ag-toolpanel-indent-44{padding-left:440px}.ag-rtl .ag-toolpanel-indent-44{padding-right:440px}.ag-ltr .ag-row-group-indent-44{padding-left:440px}.ag-rtl .ag-row-group-indent-44{padding-right:440px}.ag-ltr .ag-toolpanel-indent-45{padding-left:450px}.ag-rtl .ag-toolpanel-indent-45{padding-right:450px}.ag-ltr .ag-row-group-indent-45{padding-left:450px}.ag-rtl .ag-row-group-indent-45{padding-right:450px}.ag-ltr .ag-toolpanel-indent-46{padding-left:460px}.ag-rtl .ag-toolpanel-indent-46{padding-right:460px}.ag-ltr .ag-row-group-indent-46{padding-left:460px}.ag-rtl .ag-row-group-indent-46{padding-right:460px}.ag-ltr .ag-toolpanel-indent-47{padding-left:470px}.ag-rtl .ag-toolpanel-indent-47{padding-right:470px}.ag-ltr .ag-row-group-indent-47{padding-left:470px}.ag-rtl .ag-row-group-indent-47{padding-right:470px}.ag-ltr .ag-toolpanel-indent-48{padding-left:480px}.ag-rtl .ag-toolpanel-indent-48{padding-right:480px}.ag-ltr .ag-row-group-indent-48{padding-left:480px}.ag-rtl .ag-row-group-indent-48{padding-right:480px}.ag-ltr .ag-toolpanel-indent-49{padding-left:490px}.ag-rtl .ag-toolpanel-indent-49{padding-right:490px}.ag-ltr .ag-row-group-indent-49{padding-left:490px}.ag-rtl .ag-row-group-indent-49{padding-right:490px}.ag-ltr{direction:ltr}.ag-ltr .ag-body,.ag-ltr .ag-body-horizontal-scroll,.ag-ltr .ag-body-viewport,.ag-ltr .ag-floating-bottom,.ag-ltr .ag-floating-top,.ag-ltr .ag-header{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row}.ag-ltr .ag-header-cell-resize{right:-4px}.ag-ltr .ag-pinned-right-header .ag-header-cell-resize{left:-4px}.ag-rtl{direction:rtl}.ag-rtl .ag-body,.ag-rtl .ag-body-horizontal-scroll,.ag-rtl .ag-body-viewport,.ag-rtl .ag-floating-bottom,.ag-rtl .ag-floating-top,.ag-rtl .ag-header{-webkit-box-orient:horizontal;-webkit-box-direction:reverse;-ms-flex-direction:row-reverse;flex-direction:row-reverse}.ag-rtl .ag-header-cell-resize{left:-4px}.ag-rtl .ag-pinned-left-header .ag-header-cell-resize{right:-4px}@media print{.ag-body-viewport{display:block}.ag-row{page-break-inside:avoid}}.ag-body .ag-body-viewport,.ag-body .ag-pinned-left-cols-viewport,.ag-body .ag-pinned-right-cols-viewport{-webkit-overflow-scrolling:touch}.ag-chart{position:relative;display:flex;overflow:hidden;width:100%;height:100%}.ag-chart .ag-chart-components-wrapper{display:flex}.ag-chart .ag-chart-components-wrapper,.ag-chart .ag-chart-components-wrapper .ag-chart-canvas-wrapper{position:relative;flex:1 1 auto;overflow:hidden}.ag-chart .ag-chart-components-wrapper .ag-chart-canvas-wrapper canvas{display:block}.ag-chart .ag-chart-components-wrapper .ag-chart-menu{position:absolute;top:10px;right:20px;width:24px;overflow:hidden;display:flex;flex-direction:column}.ag-chart:not(.ag-has-menu):hover .ag-chart-menu{opacity:1;pointer-events:all}.ag-chart .ag-chart-docked-container{position:relative;width:0;min-width:0;transition:min-width .4s}.ag-chart .ag-chart-docked-container .ag-panel{border-width:0 0 0 1px}.ag-chart-tabbed-menu>div{width:100%;height:100%;display:flex;flex-direction:column;overflow:hidden}.ag-chart-tabbed-menu .ag-tab-header{flex:none;user-select:none;cursor:default}.ag-chart-tabbed-menu .ag-tab-body{display:flex;flex:1 1 auto;align-items:stretch;overflow:hidden}.ag-chart-tabbed-menu .ag-tab-body>div{width:100%;overflow:hidden;overflow-y:auto}.ag-chart-tabbed-menu .ag-chart-settings{overflow-x:hidden}.ag-chart-tabbed-menu .ag-chart-settings .ag-chart-settings-wrapper{position:relative;flex-direction:column;width:100%;height:100%;display:flex;overflow:hidden}.ag-chart-tabbed-menu .ag-chart-settings .ag-chart-settings-wrapper .ag-chart-settings-nav-bar{width:100%;display:flex;height:30px;align-items:center}.ag-chart-tabbed-menu .ag-chart-settings .ag-chart-settings-wrapper .ag-chart-settings-nav-bar .ag-nav-card-selector{display:flex;align-items:center;justify-content:space-around;flex:1 1 auto;height:100%}.ag-chart-tabbed-menu .ag-chart-settings .ag-chart-settings-wrapper .ag-chart-settings-nav-bar .ag-nav-card-selector .ag-nav-card-item{opacity:.2}.ag-chart-tabbed-menu .ag-chart-settings .ag-chart-settings-wrapper .ag-chart-settings-nav-bar .ag-nav-card-selector .ag-nav-card-item.ag-selected{opacity:1}.ag-chart-tabbed-menu .ag-chart-settings .ag-chart-settings-wrapper .ag-chart-settings-nav-bar .ag-chart-settings-next-btn,.ag-chart-tabbed-menu .ag-chart-settings .ag-chart-settings-wrapper .ag-chart-settings-nav-bar .ag-chart-settings-prev-btn{position:relative;flex:none}.ag-chart-tabbed-menu .ag-chart-settings .ag-chart-settings-wrapper .ag-chart-settings-nav-bar .ag-chart-settings-next-btn button,.ag-chart-tabbed-menu .ag-chart-settings .ag-chart-settings-wrapper .ag-chart-settings-nav-bar .ag-chart-settings-prev-btn button{position:absolute;top:0;left:0;width:100%;height:100%;cursor:pointer;opacity:0}.ag-chart-tabbed-menu .ag-chart-settings .ag-chart-settings-wrapper .ag-chart-settings-mini-charts-container{position:relative;flex:1 1 auto;overflow-x:hidden;overflow-y:auto}.ag-chart-tabbed-menu .ag-chart-settings .ag-chart-settings-wrapper .ag-chart-settings-mini-charts-container .ag-chart-settings-mini-wrapper{position:absolute;top:0;left:0;display:flex;flex-direction:column;width:100%;min-height:100%;overflow:hidden}.ag-chart-tabbed-menu .ag-chart-settings .ag-chart-settings-wrapper .ag-chart-settings-mini-charts-container .ag-chart-settings-mini-wrapper .ag-group-component{flex:none}.ag-chart-tabbed-menu .ag-chart-settings .ag-chart-settings-wrapper .ag-chart-settings-mini-charts-container .ag-chart-settings-mini-wrapper .ag-group-component-container{flex-direction:row;flex-wrap:wrap}.ag-chart-tabbed-menu .ag-chart-settings .ag-chart-settings-wrapper .ag-chart-settings-mini-charts-container .ag-chart-settings-mini-wrapper .ag-group-component-container .ag-chart-mini-thumbnail{flex:none}.ag-chart-tabbed-menu .ag-chart-settings .ag-chart-settings-wrapper .ag-chart-settings-mini-charts-container .ag-chart-settings-mini-wrapper.ag-animating{transition:left .3s;transition-timing-function:ease-in-out}.ag-chart-tabbed-menu .ag-chart-settings .ag-chart-settings-wrapper .ag-chart-settings-mini-charts-container .ag-chart-settings-mini-wrapper .ag-chart-mini-thumbnail{cursor:pointer}.ag-chart-tabbed-menu .ag-chart-settings .ag-chart-settings-wrapper .ag-chart-settings-mini-charts-container .ag-chart-settings-mini-wrapper .ag-chart-mini-thumbnail canvas{display:block}.ag-chart-tabbed-menu .ag-chart-data-wrapper,.ag-chart-tabbed-menu .ag-chart-format-wrapper{display:flex;flex-direction:column;position:relative;user-select:none}.ag-chart-tabbed-menu .ag-chart-data-wrapper>div,.ag-chart-tabbed-menu .ag-chart-format-wrapper>div{display:flex;margin:0;padding-bottom:2px}.ag-chart-tabbed-menu .ag-chart-data-wrapper>div:not(:first-child),.ag-chart-tabbed-menu .ag-chart-format-wrapper>div:not(:first-child){margin-top:0}.ag-chart-tabbed-menu .ag-chart-format-wrapper{overflow-x:hidden}.ag-chart-tabbed-menu .ag-chart-format-wrapper .ag-group-component .ag-group-subgroup{justify-content:space-between}.ag-chart .ag-chart-canvas-wrapper.ag-chart-empty>canvas{visibility:hidden}.ag-chart .ag-chart-canvas-wrapper.ag-chart-empty .ag-chart-empty-text{display:flex}.ag-chart .ag-chart-empty-text{display:none;position:absolute;top:0;width:100%;height:100%;align-items:center;justify-content:center}.ag-chart .ag-chart-menu{opacity:0;pointer-events:none}.ag-chart .ag-chart-menu>span{opacity:.5;line-height:24px;font-size:24px;width:24px;height:24px;margin:2px 0;cursor:pointer}.ag-chart .ag-chart-menu>span:hover{border-radius:5px}.ag-chart .ag-chart-docked-container{min-width:0;width:0}.ag-chart-tabbed-menu .ag-tab-body{padding:0}.ag-chart-tabbed-menu .ag-chart-settings .ag-chart-settings-nav-bar{padding:0 10px;user-select:none}.ag-chart-tabbed-menu .ag-chart-settings .ag-chart-settings-nav-bar .ag-nav-card-selector{padding:0 10px}.ag-chart-tabbed-menu .ag-chart-settings .ag-chart-settings-nav-bar .ag-nav-card-selector .ag-nav-card-item{cursor:pointer}", ""]);
	
	// exports


/***/ }),
/* 2964 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1717)();
	// imports
	
	
	// module
	exports.push([module.id, "@font-face{font-family:agGridMaterial;src:url(\"data:application/x-font-ttf;charset=utf-8;base64,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\") format(\"truetype\");font-weight:400;font-style:normal}.ag-theme-material{-webkit-font-smoothing:antialiased;background-color:#fff;color:rgba(0,0,0,.87);font-family:Roboto,sans-serif;font-weight:400;font-size:13px;line-height:normal}.ag-theme-material .ag-tab-header .ag-tab.ag-tab-selected{border-bottom:2px solid #3f51b5}.ag-theme-material label{margin-bottom:0}.ag-theme-material *{box-sizing:border-box}.ag-theme-material * :after,.ag-theme-material * :before,.ag-theme-material :focus{outline:none;box-sizing:border-box}.ag-theme-material .ag-tab{box-sizing:content-box}.ag-theme-material .ag-ltr .ag-toolpanel-indent-1{padding-left:26px}.ag-theme-material .ag-rtl .ag-toolpanel-indent-1{padding-right:26px}.ag-theme-material .ag-ltr .ag-row-group-indent-1{padding-left:42px}.ag-theme-material .ag-rtl .ag-row-group-indent-1{padding-right:42px}.ag-theme-material .ag-ltr .ag-toolpanel-indent-2{padding-left:52px}.ag-theme-material .ag-rtl .ag-toolpanel-indent-2{padding-right:52px}.ag-theme-material .ag-ltr .ag-row-group-indent-2{padding-left:84px}.ag-theme-material .ag-rtl .ag-row-group-indent-2{padding-right:84px}.ag-theme-material .ag-ltr .ag-toolpanel-indent-3{padding-left:78px}.ag-theme-material .ag-rtl .ag-toolpanel-indent-3{padding-right:78px}.ag-theme-material .ag-ltr .ag-row-group-indent-3{padding-left:126px}.ag-theme-material .ag-rtl .ag-row-group-indent-3{padding-right:126px}.ag-theme-material .ag-ltr .ag-toolpanel-indent-4{padding-left:104px}.ag-theme-material .ag-rtl .ag-toolpanel-indent-4{padding-right:104px}.ag-theme-material .ag-ltr .ag-row-group-indent-4{padding-left:168px}.ag-theme-material .ag-rtl .ag-row-group-indent-4{padding-right:168px}.ag-theme-material .ag-ltr .ag-toolpanel-indent-5{padding-left:130px}.ag-theme-material .ag-rtl .ag-toolpanel-indent-5{padding-right:130px}.ag-theme-material .ag-ltr .ag-row-group-indent-5{padding-left:210px}.ag-theme-material .ag-rtl .ag-row-group-indent-5{padding-right:210px}.ag-theme-material .ag-ltr .ag-toolpanel-indent-6{padding-left:156px}.ag-theme-material .ag-rtl .ag-toolpanel-indent-6{padding-right:156px}.ag-theme-material .ag-ltr .ag-row-group-indent-6{padding-left:252px}.ag-theme-material .ag-rtl .ag-row-group-indent-6{padding-right:252px}.ag-theme-material .ag-ltr .ag-toolpanel-indent-7{padding-left:182px}.ag-theme-material .ag-rtl .ag-toolpanel-indent-7{padding-right:182px}.ag-theme-material .ag-ltr .ag-row-group-indent-7{padding-left:294px}.ag-theme-material .ag-rtl .ag-row-group-indent-7{padding-right:294px}.ag-theme-material .ag-ltr .ag-toolpanel-indent-8{padding-left:208px}.ag-theme-material .ag-rtl .ag-toolpanel-indent-8{padding-right:208px}.ag-theme-material .ag-ltr .ag-row-group-indent-8{padding-left:336px}.ag-theme-material .ag-rtl .ag-row-group-indent-8{padding-right:336px}.ag-theme-material .ag-ltr .ag-toolpanel-indent-9{padding-left:234px}.ag-theme-material .ag-rtl .ag-toolpanel-indent-9{padding-right:234px}.ag-theme-material .ag-ltr .ag-row-group-indent-9{padding-left:378px}.ag-theme-material .ag-rtl .ag-row-group-indent-9{padding-right:378px}.ag-theme-material .ag-ltr .ag-toolpanel-indent-10{padding-left:260px}.ag-theme-material .ag-rtl .ag-toolpanel-indent-10{padding-right:260px}.ag-theme-material .ag-ltr .ag-row-group-indent-10{padding-left:420px}.ag-theme-material .ag-rtl .ag-row-group-indent-10{padding-right:420px}.ag-theme-material .ag-ltr .ag-toolpanel-indent-11{padding-left:286px}.ag-theme-material .ag-rtl .ag-toolpanel-indent-11{padding-right:286px}.ag-theme-material .ag-ltr .ag-row-group-indent-11{padding-left:462px}.ag-theme-material .ag-rtl .ag-row-group-indent-11{padding-right:462px}.ag-theme-material .ag-ltr .ag-toolpanel-indent-12{padding-left:312px}.ag-theme-material .ag-rtl .ag-toolpanel-indent-12{padding-right:312px}.ag-theme-material .ag-ltr .ag-row-group-indent-12{padding-left:504px}.ag-theme-material .ag-rtl .ag-row-group-indent-12{padding-right:504px}.ag-theme-material .ag-ltr .ag-toolpanel-indent-13{padding-left:338px}.ag-theme-material .ag-rtl .ag-toolpanel-indent-13{padding-right:338px}.ag-theme-material .ag-ltr .ag-row-group-indent-13{padding-left:546px}.ag-theme-material .ag-rtl .ag-row-group-indent-13{padding-right:546px}.ag-theme-material .ag-ltr .ag-toolpanel-indent-14{padding-left:364px}.ag-theme-material .ag-rtl .ag-toolpanel-indent-14{padding-right:364px}.ag-theme-material .ag-ltr .ag-row-group-indent-14{padding-left:588px}.ag-theme-material .ag-rtl .ag-row-group-indent-14{padding-right:588px}.ag-theme-material .ag-ltr .ag-toolpanel-indent-15{padding-left:390px}.ag-theme-material .ag-rtl .ag-toolpanel-indent-15{padding-right:390px}.ag-theme-material .ag-ltr .ag-row-group-indent-15{padding-left:630px}.ag-theme-material .ag-rtl .ag-row-group-indent-15{padding-right:630px}.ag-theme-material .ag-ltr .ag-toolpanel-indent-16{padding-left:416px}.ag-theme-material .ag-rtl .ag-toolpanel-indent-16{padding-right:416px}.ag-theme-material .ag-ltr .ag-row-group-indent-16{padding-left:672px}.ag-theme-material .ag-rtl .ag-row-group-indent-16{padding-right:672px}.ag-theme-material .ag-ltr .ag-toolpanel-indent-17{padding-left:442px}.ag-theme-material .ag-rtl .ag-toolpanel-indent-17{padding-right:442px}.ag-theme-material .ag-ltr .ag-row-group-indent-17{padding-left:714px}.ag-theme-material .ag-rtl .ag-row-group-indent-17{padding-right:714px}.ag-theme-material .ag-ltr .ag-toolpanel-indent-18{padding-left:468px}.ag-theme-material .ag-rtl .ag-toolpanel-indent-18{padding-right:468px}.ag-theme-material .ag-ltr .ag-row-group-indent-18{padding-left:756px}.ag-theme-material .ag-rtl .ag-row-group-indent-18{padding-right:756px}.ag-theme-material .ag-ltr .ag-toolpanel-indent-19{padding-left:494px}.ag-theme-material .ag-rtl .ag-toolpanel-indent-19{padding-right:494px}.ag-theme-material .ag-ltr .ag-row-group-indent-19{padding-left:798px}.ag-theme-material .ag-rtl .ag-row-group-indent-19{padding-right:798px}.ag-theme-material .ag-ltr .ag-toolpanel-indent-20{padding-left:520px}.ag-theme-material .ag-rtl .ag-toolpanel-indent-20{padding-right:520px}.ag-theme-material .ag-ltr .ag-row-group-indent-20{padding-left:840px}.ag-theme-material .ag-rtl .ag-row-group-indent-20{padding-right:840px}.ag-theme-material .ag-ltr .ag-toolpanel-indent-21{padding-left:546px}.ag-theme-material .ag-rtl .ag-toolpanel-indent-21{padding-right:546px}.ag-theme-material .ag-ltr .ag-row-group-indent-21{padding-left:882px}.ag-theme-material .ag-rtl .ag-row-group-indent-21{padding-right:882px}.ag-theme-material .ag-ltr .ag-toolpanel-indent-22{padding-left:572px}.ag-theme-material .ag-rtl .ag-toolpanel-indent-22{padding-right:572px}.ag-theme-material .ag-ltr .ag-row-group-indent-22{padding-left:924px}.ag-theme-material .ag-rtl .ag-row-group-indent-22{padding-right:924px}.ag-theme-material .ag-ltr .ag-toolpanel-indent-23{padding-left:598px}.ag-theme-material .ag-rtl .ag-toolpanel-indent-23{padding-right:598px}.ag-theme-material .ag-ltr .ag-row-group-indent-23{padding-left:966px}.ag-theme-material .ag-rtl .ag-row-group-indent-23{padding-right:966px}.ag-theme-material .ag-ltr .ag-toolpanel-indent-24{padding-left:624px}.ag-theme-material .ag-rtl .ag-toolpanel-indent-24{padding-right:624px}.ag-theme-material .ag-ltr .ag-row-group-indent-24{padding-left:1008px}.ag-theme-material .ag-rtl .ag-row-group-indent-24{padding-right:1008px}.ag-theme-material .ag-ltr .ag-toolpanel-indent-25{padding-left:650px}.ag-theme-material .ag-rtl .ag-toolpanel-indent-25{padding-right:650px}.ag-theme-material .ag-ltr .ag-row-group-indent-25{padding-left:1050px}.ag-theme-material .ag-rtl .ag-row-group-indent-25{padding-right:1050px}.ag-theme-material .ag-ltr .ag-toolpanel-indent-26{padding-left:676px}.ag-theme-material .ag-rtl .ag-toolpanel-indent-26{padding-right:676px}.ag-theme-material .ag-ltr .ag-row-group-indent-26{padding-left:1092px}.ag-theme-material .ag-rtl .ag-row-group-indent-26{padding-right:1092px}.ag-theme-material .ag-ltr .ag-toolpanel-indent-27{padding-left:702px}.ag-theme-material .ag-rtl .ag-toolpanel-indent-27{padding-right:702px}.ag-theme-material .ag-ltr .ag-row-group-indent-27{padding-left:1134px}.ag-theme-material .ag-rtl .ag-row-group-indent-27{padding-right:1134px}.ag-theme-material .ag-ltr .ag-toolpanel-indent-28{padding-left:728px}.ag-theme-material .ag-rtl .ag-toolpanel-indent-28{padding-right:728px}.ag-theme-material .ag-ltr .ag-row-group-indent-28{padding-left:1176px}.ag-theme-material .ag-rtl .ag-row-group-indent-28{padding-right:1176px}.ag-theme-material .ag-ltr .ag-toolpanel-indent-29{padding-left:754px}.ag-theme-material .ag-rtl .ag-toolpanel-indent-29{padding-right:754px}.ag-theme-material .ag-ltr .ag-row-group-indent-29{padding-left:1218px}.ag-theme-material .ag-rtl .ag-row-group-indent-29{padding-right:1218px}.ag-theme-material .ag-ltr .ag-toolpanel-indent-30{padding-left:780px}.ag-theme-material .ag-rtl .ag-toolpanel-indent-30{padding-right:780px}.ag-theme-material .ag-ltr .ag-row-group-indent-30{padding-left:1260px}.ag-theme-material .ag-rtl .ag-row-group-indent-30{padding-right:1260px}.ag-theme-material .ag-ltr .ag-toolpanel-indent-31{padding-left:806px}.ag-theme-material .ag-rtl .ag-toolpanel-indent-31{padding-right:806px}.ag-theme-material .ag-ltr .ag-row-group-indent-31{padding-left:1302px}.ag-theme-material .ag-rtl .ag-row-group-indent-31{padding-right:1302px}.ag-theme-material .ag-ltr .ag-toolpanel-indent-32{padding-left:832px}.ag-theme-material .ag-rtl .ag-toolpanel-indent-32{padding-right:832px}.ag-theme-material .ag-ltr .ag-row-group-indent-32{padding-left:1344px}.ag-theme-material .ag-rtl .ag-row-group-indent-32{padding-right:1344px}.ag-theme-material .ag-ltr .ag-toolpanel-indent-33{padding-left:858px}.ag-theme-material .ag-rtl .ag-toolpanel-indent-33{padding-right:858px}.ag-theme-material .ag-ltr .ag-row-group-indent-33{padding-left:1386px}.ag-theme-material .ag-rtl .ag-row-group-indent-33{padding-right:1386px}.ag-theme-material .ag-ltr .ag-toolpanel-indent-34{padding-left:884px}.ag-theme-material .ag-rtl .ag-toolpanel-indent-34{padding-right:884px}.ag-theme-material .ag-ltr .ag-row-group-indent-34{padding-left:1428px}.ag-theme-material .ag-rtl .ag-row-group-indent-34{padding-right:1428px}.ag-theme-material .ag-ltr .ag-toolpanel-indent-35{padding-left:910px}.ag-theme-material .ag-rtl .ag-toolpanel-indent-35{padding-right:910px}.ag-theme-material .ag-ltr .ag-row-group-indent-35{padding-left:1470px}.ag-theme-material .ag-rtl .ag-row-group-indent-35{padding-right:1470px}.ag-theme-material .ag-ltr .ag-toolpanel-indent-36{padding-left:936px}.ag-theme-material .ag-rtl .ag-toolpanel-indent-36{padding-right:936px}.ag-theme-material .ag-ltr .ag-row-group-indent-36{padding-left:1512px}.ag-theme-material .ag-rtl .ag-row-group-indent-36{padding-right:1512px}.ag-theme-material .ag-ltr .ag-toolpanel-indent-37{padding-left:962px}.ag-theme-material .ag-rtl .ag-toolpanel-indent-37{padding-right:962px}.ag-theme-material .ag-ltr .ag-row-group-indent-37{padding-left:1554px}.ag-theme-material .ag-rtl .ag-row-group-indent-37{padding-right:1554px}.ag-theme-material .ag-ltr .ag-toolpanel-indent-38{padding-left:988px}.ag-theme-material .ag-rtl .ag-toolpanel-indent-38{padding-right:988px}.ag-theme-material .ag-ltr .ag-row-group-indent-38{padding-left:1596px}.ag-theme-material .ag-rtl .ag-row-group-indent-38{padding-right:1596px}.ag-theme-material .ag-ltr .ag-toolpanel-indent-39{padding-left:1014px}.ag-theme-material .ag-rtl .ag-toolpanel-indent-39{padding-right:1014px}.ag-theme-material .ag-ltr .ag-row-group-indent-39{padding-left:1638px}.ag-theme-material .ag-rtl .ag-row-group-indent-39{padding-right:1638px}.ag-theme-material .ag-ltr .ag-toolpanel-indent-40{padding-left:1040px}.ag-theme-material .ag-rtl .ag-toolpanel-indent-40{padding-right:1040px}.ag-theme-material .ag-ltr .ag-row-group-indent-40{padding-left:1680px}.ag-theme-material .ag-rtl .ag-row-group-indent-40{padding-right:1680px}.ag-theme-material .ag-ltr .ag-toolpanel-indent-41{padding-left:1066px}.ag-theme-material .ag-rtl .ag-toolpanel-indent-41{padding-right:1066px}.ag-theme-material .ag-ltr .ag-row-group-indent-41{padding-left:1722px}.ag-theme-material .ag-rtl .ag-row-group-indent-41{padding-right:1722px}.ag-theme-material .ag-ltr .ag-toolpanel-indent-42{padding-left:1092px}.ag-theme-material .ag-rtl .ag-toolpanel-indent-42{padding-right:1092px}.ag-theme-material .ag-ltr .ag-row-group-indent-42{padding-left:1764px}.ag-theme-material .ag-rtl .ag-row-group-indent-42{padding-right:1764px}.ag-theme-material .ag-ltr .ag-toolpanel-indent-43{padding-left:1118px}.ag-theme-material .ag-rtl .ag-toolpanel-indent-43{padding-right:1118px}.ag-theme-material .ag-ltr .ag-row-group-indent-43{padding-left:1806px}.ag-theme-material .ag-rtl .ag-row-group-indent-43{padding-right:1806px}.ag-theme-material .ag-ltr .ag-toolpanel-indent-44{padding-left:1144px}.ag-theme-material .ag-rtl .ag-toolpanel-indent-44{padding-right:1144px}.ag-theme-material .ag-ltr .ag-row-group-indent-44{padding-left:1848px}.ag-theme-material .ag-rtl .ag-row-group-indent-44{padding-right:1848px}.ag-theme-material .ag-ltr .ag-toolpanel-indent-45{padding-left:1170px}.ag-theme-material .ag-rtl .ag-toolpanel-indent-45{padding-right:1170px}.ag-theme-material .ag-ltr .ag-row-group-indent-45{padding-left:1890px}.ag-theme-material .ag-rtl .ag-row-group-indent-45{padding-right:1890px}.ag-theme-material .ag-ltr .ag-toolpanel-indent-46{padding-left:1196px}.ag-theme-material .ag-rtl .ag-toolpanel-indent-46{padding-right:1196px}.ag-theme-material .ag-ltr .ag-row-group-indent-46{padding-left:1932px}.ag-theme-material .ag-rtl .ag-row-group-indent-46{padding-right:1932px}.ag-theme-material .ag-ltr .ag-toolpanel-indent-47{padding-left:1222px}.ag-theme-material .ag-rtl .ag-toolpanel-indent-47{padding-right:1222px}.ag-theme-material .ag-ltr .ag-row-group-indent-47{padding-left:1974px}.ag-theme-material .ag-rtl .ag-row-group-indent-47{padding-right:1974px}.ag-theme-material .ag-ltr .ag-toolpanel-indent-48{padding-left:1248px}.ag-theme-material .ag-rtl .ag-toolpanel-indent-48{padding-right:1248px}.ag-theme-material .ag-ltr .ag-row-group-indent-48{padding-left:2016px}.ag-theme-material .ag-rtl .ag-row-group-indent-48{padding-right:2016px}.ag-theme-material .ag-ltr .ag-toolpanel-indent-49{padding-left:1274px}.ag-theme-material .ag-rtl .ag-toolpanel-indent-49{padding-right:1274px}.ag-theme-material .ag-ltr .ag-row-group-indent-49{padding-left:2058px}.ag-theme-material .ag-rtl .ag-row-group-indent-49{padding-right:2058px}.ag-theme-material .ag-cell .ag-icon{display:inline-block;vertical-align:middle}.ag-theme-material .ag-checkbox,.ag-theme-material .ag-radio-button,.ag-theme-material .ag-toggle-button{display:flex;align-items:center;cursor:default}.ag-theme-material .ag-checkbox label,.ag-theme-material .ag-radio-button label,.ag-theme-material .ag-toggle-button label{cursor:default}.ag-theme-material .ag-checkbox label:empty,.ag-theme-material .ag-radio-button label:empty,.ag-theme-material .ag-toggle-button label:empty{margin:0}.ag-theme-material .ag-checkbox:not(.ag-label-align-left) label,.ag-theme-material .ag-radio-button:not(.ag-label-align-left) label,.ag-theme-material .ag-toggle-button:not(.ag-label-align-left) label{margin-left:8px}.ag-theme-material .ag-cell{-webkit-font-smoothing:subpixel-antialiased}.ag-theme-material .ag-ltr .ag-row-group-leaf-indent{margin-left:42px}.ag-theme-material .ag-ltr .ag-cell{border-right:1px solid transparent}.ag-theme-material .ag-ltr .ag-cell.ag-cell-range-selected:not(.ag-cell-range-single-cell).ag-cell-first-right-pinned:not(.ag-cell-range-left),.ag-theme-material .ag-ltr .ag-cell:not(.ag-cell-focus).ag-cell-first-right-pinned:not(.ag-cell-range-left),.ag-theme-material .ag-ltr .ag-root:not(.ag-has-focus) .ag-cell.ag-cell-first-right-pinned:not(.ag-cell-range-left){border-left:1px solid #e2e2e2}.ag-theme-material .ag-ltr .ag-cell.ag-cell-range-selected:not(.ag-cell-range-single-cell).ag-cell-last-left-pinned:not(.ag-cell-range-right),.ag-theme-material .ag-ltr .ag-cell:not(.ag-cell-focus).ag-cell-last-left-pinned:not(.ag-cell-range-right),.ag-theme-material .ag-ltr .ag-root:not(.ag-has-focus) .ag-cell.ag-cell-last-left-pinned:not(.ag-cell-range-right){border-right:1px solid #e2e2e2}.ag-theme-material .ag-rtl .ag-row-group-leaf-indent{margin-right:42px}.ag-theme-material .ag-rtl .ag-cell{border-left:1px solid transparent}.ag-theme-material .ag-rtl .ag-cell.ag-cell-range-selected:not(.ag-cell-range-single-cell).ag-cell-first-right-pinned:not(.ag-cell-range-left),.ag-theme-material .ag-rtl .ag-cell:not(.ag-cell-focus).ag-cell-first-right-pinned:not(.ag-cell-range-left),.ag-theme-material .ag-rtl .ag-root:not(.ag-has-focus) .ag-cell.ag-cell-first-right-pinned:not(.ag-cell-range-left){border-left:1px solid #e2e2e2}.ag-theme-material .ag-rtl .ag-cell.ag-cell-range-selected:not(.ag-cell-range-single-cell).ag-cell-last-left-pinned:not(.ag-cell-range-right),.ag-theme-material .ag-rtl .ag-cell:not(.ag-cell-focus).ag-cell-last-left-pinned:not(.ag-cell-range-right),.ag-theme-material .ag-rtl .ag-root:not(.ag-has-focus) .ag-cell.ag-cell-last-left-pinned:not(.ag-cell-range-right){border-right:1px solid #e2e2e2}.ag-theme-material .ag-value-change-delta{padding-right:2px}.ag-theme-material .ag-value-change-delta-up{color:#43a047}.ag-theme-material .ag-value-change-delta-down{color:#e53935}.ag-theme-material .ag-value-change-value{background-color:transparent;border-radius:1px;padding-left:1px;padding-right:1px;transition:background-color 1s}.ag-theme-material .ag-value-change-value-highlight{background-color:#00acc1;transition:background-color .1s}.ag-theme-material .ag-input-wrapper input:not([type]),.ag-theme-material .ag-input-wrapper input[type=date],.ag-theme-material .ag-input-wrapper input[type=datetime-local],.ag-theme-material .ag-input-wrapper input[type=number],.ag-theme-material .ag-input-wrapper input[type=tel],.ag-theme-material .ag-input-wrapper input[type=text]{background:transparent;color:rgba(0,0,0,.87);font-family:inherit;font-size:inherit;height:40px;padding-bottom:8px;border-width:0;border-bottom:2px solid #e2e2e2}.ag-theme-material .ag-input-wrapper input:not([type]):focus,.ag-theme-material .ag-input-wrapper input[type=date]:focus,.ag-theme-material .ag-input-wrapper input[type=datetime-local]:focus,.ag-theme-material .ag-input-wrapper input[type=number]:focus,.ag-theme-material .ag-input-wrapper input[type=tel]:focus,.ag-theme-material .ag-input-wrapper input[type=text]:focus{border-bottom:2px solid #3f51b5;outline:none}.ag-theme-material .ag-input-wrapper input:not([type])::placeholder,.ag-theme-material .ag-input-wrapper input[type=date]::placeholder,.ag-theme-material .ag-input-wrapper input[type=datetime-local]::placeholder,.ag-theme-material .ag-input-wrapper input[type=number]::placeholder,.ag-theme-material .ag-input-wrapper input[type=tel]::placeholder,.ag-theme-material .ag-input-wrapper input[type=text]::placeholder{color:rgba(0,0,0,.38)}.ag-theme-material .ag-input-wrapper input:not([type]):disabled,.ag-theme-material .ag-input-wrapper input[type=date]:disabled,.ag-theme-material .ag-input-wrapper input[type=datetime-local]:disabled,.ag-theme-material .ag-input-wrapper input[type=number]:disabled,.ag-theme-material .ag-input-wrapper input[type=tel]:disabled,.ag-theme-material .ag-input-wrapper input[type=text]:disabled{border-bottom:1px solid #e2e2e2;color:rgba(0,0,0,.38)}.ag-theme-material .ag-input-wrapper input[type=date]{flex:1 1 auto}.ag-theme-material .ag-input-wrapper input[type=range]{padding:0}.ag-theme-material .ag-input-wrapper textarea{background:transparent;color:rgba(0,0,0,.87);font-family:inherit;font-size:inherit;height:40px;padding-bottom:8px;border-width:0;border-bottom:2px solid #e2e2e2}.ag-theme-material .ag-input-wrapper textarea:focus{border-bottom:2px solid #3f51b5;outline:none}.ag-theme-material .ag-input-wrapper textarea::placeholder{color:rgba(0,0,0,.38)}.ag-theme-material .ag-input-wrapper textarea:disabled{border-bottom:1px solid #e2e2e2;color:rgba(0,0,0,.38)}.ag-theme-material .ag-header{background-color:#fff;color:rgba(0,0,0,.54);font-weight:700;font-size:12px;font-family:Roboto,sans-serif;border-bottom:1px solid #e2e2e2}.ag-theme-material .ag-pinned-right-header{border-left:1px solid #e2e2e2}.ag-theme-material .ag-pinned-left-header{border-right:1px solid #e2e2e2}.ag-theme-material .ag-header-row{border:none;height:56px}.ag-theme-material .ag-row{border:0 solid #e2e2e2;height:48px}.ag-theme-material .ag-row:not(.ag-row-first){border-width:1px 0 0}.ag-theme-material .ag-row.ag-row-last{border-bottom-width:1px}.ag-theme-material .ag-horizontal-left-spacer{border-right:1px solid #e2e2e2}.ag-theme-material .ag-horizontal-left-spacer.ag-scroller-corner{border-right:none}.ag-theme-material .ag-horizontal-right-spacer{border-left:1px solid #e2e2e2}.ag-theme-material .ag-horizontal-right-spacer.ag-scroller-corner{border-left:none}.ag-theme-material .ag-row-hover{background-color:#fafafa}.ag-theme-material .ag-numeric-cell{text-align:right}.ag-theme-material .ag-header-cell-label .ag-header-icon{margin-left:8px;opacity:.87}.ag-theme-material .ag-header-cell,.ag-theme-material .ag-header-group-cell{border:0 solid #e2e2e2;padding-left:24px;padding-right:24px}.ag-theme-material .ag-header-cell.ag-header-cell-moving,.ag-theme-material .ag-header-group-cell.ag-header-cell-moving{background-color:#f2f2f2}.ag-theme-material .ag-header-cell:not(.ag-header-group-cell-no-group),.ag-theme-material .ag-header-group-cell:not(.ag-header-group-cell-no-group){border-top-width:1px}.ag-theme-material .ag-header-row:first-child .ag-header-cell,.ag-theme-material .ag-header-row:first-child .ag-header-group-cell{border-top-width:0}.ag-theme-material .ag-header-cell:first-of-type.ag-column-resizing,.ag-theme-material .ag-header-cell:first-of-type:hover,.ag-theme-material .ag-header-cell:not(.ag-column-resizing)+.ag-header-cell.ag-column-resizing,.ag-theme-material .ag-header-cell:not(.ag-column-resizing)+.ag-header-cell:hover,.ag-theme-material .ag-header-group-cell:first-of-type.ag-column-resizing,.ag-theme-material .ag-header-group-cell:first-of-type:hover,.ag-theme-material .ag-header-group-cell:not(.ag-column-resizing)+.ag-header-group-cell.ag-column-resizing,.ag-theme-material .ag-header-group-cell:not(.ag-column-resizing)+.ag-header-group-cell:hover{background-color:#f2f2f2}.ag-theme-material .ag-header-cell-resize{cursor:col-resize}.ag-theme-material .ag-header-select-all{margin-right:24px}.ag-theme-material .ag-cell{line-height:46px;padding-left:24px;padding-right:24px;border:1px solid transparent;padding-left:23px;padding-right:23px}.ag-theme-material .ag-row-drag{cursor:move;cursor:grab;min-width:42px}.ag-theme-material .ag-row-dragging,.ag-theme-material .ag-row-dragging .ag-row-drag{cursor:move}.ag-theme-material .ag-column-drag{cursor:move;cursor:grab}.ag-theme-material .ag-row-dragging{opacity:.5}.ag-theme-material .ag-ltr .ag-cell-focus.ag-cell-range-single-cell.ag-cell-range-handle,.ag-theme-material .ag-ltr .ag-has-focus .ag-cell-focus.ag-cell-range-single-cell,.ag-theme-material .ag-ltr .ag-has-focus .ag-cell-focus:not(.ag-cell-range-selected),.ag-theme-material .ag-rtl .ag-cell-focus.ag-cell-range-single-cell.ag-cell-range-handle,.ag-theme-material .ag-rtl .ag-has-focus .ag-cell-focus.ag-cell-range-single-cell,.ag-theme-material .ag-rtl .ag-has-focus .ag-cell-focus:not(.ag-cell-range-selected){border:1px solid #3f51b5;outline:initial}.ag-theme-material .ag-header-cell-resize{width:16px}.ag-theme-material .ag-menu{background:#fff;border-radius:2px;box-shadow:0 3px 1px -2px rgba(0,0,0,.2),0 2px 2px 0 rgba(0,0,0,.14),0 1px 5px 0 rgba(0,0,0,.12);padding:8px;padding:0}.ag-theme-material .ag-menu .ag-menu-list{cursor:default;margin-bottom:8px;margin-top:8px;width:100%}.ag-theme-material .ag-menu .ag-menu-option-active{background-color:#fafafa}.ag-theme-material .ag-menu .ag-menu-option-disabled{opacity:.5}.ag-theme-material .ag-menu .ag-menu-option-text{margin-left:8px}.ag-theme-material .ag-menu .ag-menu-option-icon{padding-left:8px;padding-right:8px;min-width:34px}.ag-theme-material .ag-menu .ag-menu-option-shortcut{padding-left:16px}.ag-theme-material .ag-menu .ag-menu-separator{height:16px}.ag-theme-material .ag-menu .ag-menu-separator>span{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg width='1' height='16' viewBox='0 0 1 16px' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath stroke='%23E2E2E2' d='M0 8h1'/%3E%3C/svg%3E\")}.ag-theme-material .ag-menu .ag-menu-option-popup-pointer{width:34px;text-align:center}.ag-theme-material.ag-dnd-ghost{background:#fff;border-radius:2px;box-shadow:0 3px 1px -2px rgba(0,0,0,.2),0 2px 2px 0 rgba(0,0,0,.14),0 1px 5px 0 rgba(0,0,0,.12);padding:8px;border:1px solid #e2e2e2;color:rgba(0,0,0,.54);font-weight:700;font-size:12px;font-family:Roboto,sans-serif;height:56px!important;line-height:56px;margin:0;padding:0 16px;transform:translateY(16px)}.ag-theme-material.ag-dnd-ghost div,.ag-theme-material.ag-dnd-ghost span{height:100%;margin:0;padding:0}.ag-theme-material.ag-dnd-ghost .ag-dnd-ghost-icon{margin-right:8px;opacity:.87}.ag-theme-material .ag-tab-header{background:#eee;min-width:220px;width:100%;display:flex}.ag-theme-material .ag-tab-header .ag-tab{display:flex;border-bottom:2px solid transparent;height:32px;flex:none;align-items:center;justify-content:center;flex:1 1 auto}.ag-theme-material .ag-tab-body{padding:4px 0}.ag-theme-material .ag-tab-body .ag-menu-list{margin-bottom:0;margin-top:0}.ag-theme-material .ag-tab-body .ag-menu-list>div:first-child>span{padding-top:0}.ag-theme-material .ag-tab-body .ag-menu-list>div:last-child>span{padding-bottom:0}.ag-theme-material .ag-tab-body .ag-menu-list>div:last-child>.ag-menu-option-popup-pointer{background-position-y:0}.ag-theme-material .ag-filter .ag-filter-body,.ag-theme-material .ag-filter .ag-filter-select{margin-bottom:8px}.ag-theme-material .ag-filter .ag-filter-body{margin-top:0}.ag-theme-material .ag-filter .ag-filter-filter{margin-left:8px;margin-right:8px}.ag-theme-material .ag-filter .ag-filter-select{margin:8px}.ag-theme-material .ag-filter input[type=radio]{margin:0 3px 0 6px;width:12px;height:17px;vertical-align:top}.ag-theme-material .ag-filter input[type=date],.ag-theme-material .ag-filter input[type=text]{padding-left:8px}.ag-theme-material .ag-filter .ag-set-filter-list{height:240px}.ag-theme-material .ag-filter .ag-set-filter-item{height:40px}.ag-theme-material .ag-filter .ag-set-filter-item>div,.ag-theme-material .ag-filter .ag-set-filter-item>span{margin-left:5px}.ag-theme-material .ag-filter .ag-filter-header-container{border-bottom:1px solid #e2e2e2;padding-bottom:4px}.ag-theme-material .ag-filter .ag-filter-apply-panel{display:flex;justify-content:flex-end;padding:8px;padding-top:16px}.ag-theme-material .ag-filter .ag-filter-apply-panel button{line-height:1.5;appearance:none;background-color:transparent;border:0;color:#3f51b5;font-family:inherit;font-size:inherit;margin:0;padding:0;text-transform:uppercase}.ag-theme-material .ag-filter .ag-filter-apply-panel button+button{margin-left:16px}.ag-theme-material .ag-column-select-panel .ag-column-tool-panel-column,.ag-theme-material .ag-column-select-panel .ag-column-tool-panel-column-group{height:32px}.ag-theme-material .ag-column-select-panel .ag-column-tool-panel-column-group .ag-column-group-icons,.ag-theme-material .ag-column-select-panel .ag-column-tool-panel-column-group .ag-column-select-checkbox,.ag-theme-material .ag-column-select-panel .ag-column-tool-panel-column-group .ag-column-tool-panel-column-label,.ag-theme-material .ag-column-select-panel .ag-column-tool-panel-column .ag-column-group-icons,.ag-theme-material .ag-column-select-panel .ag-column-tool-panel-column .ag-column-select-checkbox,.ag-theme-material .ag-column-select-panel .ag-column-tool-panel-column .ag-column-tool-panel-column-label{margin-left:8px;margin-right:8px}.ag-theme-material .ag-column-select-panel .ag-primary-cols-list-panel{border-top:1px solid #e2e2e2;padding-top:8px}.ag-theme-material .ag-column-select-panel .ag-primary-cols-list-panel>div{cursor:pointer}.ag-theme-material .ag-column-select-panel .ag-column-tool-panel-column.ag-toolpanel-add-group-indent{margin-left:34px}.ag-theme-material .ag-primary-cols-header-panel{border-top:1px solid #e2e2e2;height:56px;align-items:center}.ag-theme-material .ag-primary-cols-header-panel>div{cursor:pointer;margin:0 8px}.ag-theme-material .ag-primary-cols-header-panel .ag-filter-body{margin-left:8px;margin-right:8px}.ag-theme-material .ag-tool-panel-wrapper{border-right:0}.ag-theme-material .ag-tool-panel-wrapper .ag-filter-panel{width:100%}.ag-theme-material .ag-tool-panel-wrapper .ag-filter-panel .ag-filter-toolpanel-instance{color:rgba(0,0,0,.54);font-weight:600;flex:auto;flex-direction:column;flex-wrap:nowrap;display:flex;flex-flow:column}.ag-theme-material .ag-tool-panel-wrapper .ag-filter-panel .ag-filter-toolpanel-instance .ag-filter-toolpanel-header{padding:0 5px}.ag-theme-material .ag-tool-panel-wrapper .ag-filter-panel .ag-filter-toolpanel-instance .ag-filter-toolpanel-header>div{margin:auto 0}.ag-theme-material .ag-tool-panel-wrapper .ag-filter-panel .ag-filter-body-wrapper{padding-top:5px}.ag-theme-material .ag-tool-panel-wrapper .ag-filter-panel .ag-filter-air{border:1px solid #e2e2e2;border-left:0;border-right:0;padding:8px 0}.ag-theme-material .ag-tool-panel-wrapper .ag-pivot-mode-panel{height:56px;display:flex;flex:none}.ag-theme-material .ag-tool-panel-wrapper .ag-pivot-mode-panel .ag-pivot-mode-select{display:flex;align-items:center;margin-left:8px}.ag-theme-material .ag-tool-panel-wrapper .ag-column-select-panel{border-bottom:1px solid #e2e2e2;padding-bottom:7px;padding-top:0}.ag-theme-material .ag-tool-panel-wrapper .ag-column-drop{border-bottom:1px solid #e2e2e2;padding:8px 0;padding-bottom:16px}.ag-theme-material .ag-tool-panel-wrapper .ag-column-drop .ag-column-drop-empty-message{color:rgba(0,0,0,.38);font-weight:700;font-size:12px;font-family:Roboto,sans-serif;padding-left:34px;padding-right:8px;margin-top:8px}.ag-theme-material .ag-tool-panel-wrapper .ag-column-drop .ag-column-drop-list{cursor:default;margin-top:8px}.ag-theme-material .ag-tool-panel-wrapper .ag-column-drop>div:first-child>span:first-child{margin-left:8px;margin-right:8px}.ag-theme-material .ag-tool-panel-wrapper .ag-column-drop:last-child{border-bottom:0}.ag-theme-material .ag-numeric-header .ag-header-cell-label .ag-header-icon{margin-left:0;margin-right:8px}.ag-theme-material .ag-paging-panel{border-top:1px solid #e2e2e2;color:rgba(0,0,0,.54);height:56px;padding:0 24px}.ag-theme-material .ag-paging-panel>span{margin-left:32px}.ag-theme-material .ag-paging-page-summary-panel .ag-icon{width:18px;height:18px}.ag-theme-material .ag-paging-page-summary-panel .ag-paging-button button{cursor:pointer;opacity:0;top:0;right:0;bottom:0;left:0;padding:0}.ag-theme-material .ag-paging-page-summary-panel .ag-paging-button.ag-disabled .ag-icon{color:rgba(0,0,0,.38);opacity:.38}.ag-theme-material .ag-paging-page-summary-panel .ag-paging-button.ag-disabled button{cursor:default}.ag-theme-material .ag-paging-page-summary-panel span{margin:0 8px}.ag-theme-material .ag-row-selected{background-color:#eee}.ag-theme-material .ag-ltr .ag-cell.ag-cell-range-selected:not(.ag-cell-range-single-cell),.ag-theme-material .ag-rtl .ag-cell.ag-cell-range-selected:not(.ag-cell-range-single-cell){border:1px solid transparent}.ag-theme-material .ag-ltr .ag-cell.ag-cell-range-selected:not(.ag-cell-range-single-cell).ag-cell-range-top,.ag-theme-material .ag-rtl .ag-cell.ag-cell-range-selected:not(.ag-cell-range-single-cell).ag-cell-range-top{border-top-color:#3f51b5}.ag-theme-material .ag-ltr .ag-cell.ag-cell-range-selected:not(.ag-cell-range-single-cell).ag-cell-range-right,.ag-theme-material .ag-rtl .ag-cell.ag-cell-range-selected:not(.ag-cell-range-single-cell).ag-cell-range-right{border-right-color:#3f51b5}.ag-theme-material .ag-ltr .ag-cell.ag-cell-range-selected:not(.ag-cell-range-single-cell).ag-cell-range-bottom,.ag-theme-material .ag-rtl .ag-cell.ag-cell-range-selected:not(.ag-cell-range-single-cell).ag-cell-range-bottom{border-bottom-color:#3f51b5}.ag-theme-material .ag-ltr .ag-cell.ag-cell-range-selected:not(.ag-cell-range-single-cell).ag-cell-range-left,.ag-theme-material .ag-rtl .ag-cell.ag-cell-range-selected:not(.ag-cell-range-single-cell).ag-cell-range-left{border-left-color:#3f51b5}.ag-theme-material .ag-cell-range-selected:not(.ag-cell-focus){background-color:rgba(122,134,203,.1)}.ag-theme-material .ag-cell-range-selected:not(.ag-cell-focus).ag-cell-range-chart{background-color:rgba(0,88,255,.1)}.ag-theme-material .ag-cell-range-selected:not(.ag-cell-focus).ag-cell-range-chart.ag-cell-range-chart-category{background-color:rgba(0,255,132,.1)}.ag-theme-material .ag-cell-range-selected-1:not(.ag-cell-focus){background-color:rgba(122,134,203,.2)}.ag-theme-material .ag-cell-range-selected-2:not(.ag-cell-focus){background-color:rgba(122,134,203,.3)}.ag-theme-material .ag-cell-range-selected-3:not(.ag-cell-focus){background-color:rgba(122,134,203,.4)}.ag-theme-material .ag-cell-range-selected-4:not(.ag-cell-focus){background-color:rgba(122,134,203,.5)}.ag-theme-material .ag-ltr .ag-selection-fill-top,.ag-theme-material .ag-rtl .ag-selection-fill-top{border-top:1px dashed #3f51b5}.ag-theme-material .ag-ltr .ag-selection-fill-top.ag-cell.ag-cell-range-selected,.ag-theme-material .ag-rtl .ag-selection-fill-top.ag-cell.ag-cell-range-selected{border-top:1px dashed #afafaf}.ag-theme-material .ag-ltr .ag-selection-fill-right,.ag-theme-material .ag-rtl .ag-selection-fill-right{border-right:1px dashed #3f51b5}.ag-theme-material .ag-ltr .ag-selection-fill-right.ag-cell.ag-cell-range-selected,.ag-theme-material .ag-rtl .ag-selection-fill-right.ag-cell.ag-cell-range-selected{border-right:1px dashed #afafaf}.ag-theme-material .ag-ltr .ag-selection-fill-bottom,.ag-theme-material .ag-rtl .ag-selection-fill-bottom{border-bottom:1px dashed #3f51b5}.ag-theme-material .ag-ltr .ag-selection-fill-bottom.ag-cell.ag-cell-range-selected,.ag-theme-material .ag-rtl .ag-selection-fill-bottom.ag-cell.ag-cell-range-selected{border-bottom:1px dashed #afafaf}.ag-theme-material .ag-ltr .ag-selection-fill-left,.ag-theme-material .ag-rtl .ag-selection-fill-left{border-left:1px dashed #3f51b5}.ag-theme-material .ag-ltr .ag-selection-fill-left.ag-cell.ag-cell-range-selected,.ag-theme-material .ag-rtl .ag-selection-fill-left.ag-cell.ag-cell-range-selected{border-left:1px dashed #afafaf}.ag-theme-material .ag-fill-handle,.ag-theme-material .ag-range-handle{position:absolute;width:6px;height:6px;bottom:-1px;right:-1px;background-color:#3f51b5}.ag-theme-material .ag-fill-handle{cursor:cell}.ag-theme-material .ag-range-handle{cursor:nwse-resize}.ag-theme-material .ag-cell.ag-cell-inline-editing{padding:24px;height:72px;padding:8px}.ag-theme-material .ag-cell.ag-cell-inline-editing,.ag-theme-material .ag-popup-editor{background:#fff;border-radius:2px;box-shadow:0 3px 1px -2px rgba(0,0,0,.2),0 2px 2px 0 rgba(0,0,0,.14),0 1px 5px 0 rgba(0,0,0,.12);background-color:#fafafa}.ag-theme-material .ag-popup-editor{padding:8px;padding:0}.ag-theme-material .ag-popup-editor .ag-large-textarea textarea{height:auto;padding:24px}.ag-theme-material .ag-virtual-list-container .ag-virtual-list-item{height:40px}.ag-theme-material .ag-rich-select{background-color:#fafafa}.ag-theme-material .ag-rich-select .ag-rich-select-list{width:200px;height:312px}.ag-theme-material .ag-rich-select .ag-rich-select-value{padding:0 8px 0 24px;height:48px}.ag-theme-material .ag-rich-select .ag-virtual-list-item{cursor:default;height:48px}.ag-theme-material .ag-rich-select .ag-virtual-list-item:hover{background-color:#fafafa}.ag-theme-material .ag-rich-select .ag-rich-select-row{padding-left:24px}.ag-theme-material .ag-rich-select .ag-rich-select-row-selected{background-color:#eee}.ag-theme-material .ag-ltr .ag-floating-filter-button{margin-left:24px}.ag-theme-material .ag-floating-filter-button button{appearance:none;background:transparent;border:0;height:18px;padding:0;width:18px}.ag-theme-material .ag-group-checkbox:not(.ag-invisible)+.ag-group-value:not(:empty),.ag-theme-material .ag-group-checkbox:not(.ag-invisible)~.ag-cell-value:not(:empty),.ag-theme-material .ag-group-checkbox:not(.ag-invisible)~.ag-group-checkbox,.ag-theme-material .ag-group-contracted:not(.ag-hidden)+.ag-group-value:not(:empty),.ag-theme-material .ag-group-contracted:not(.ag-hidden)~.ag-cell-value:not(:empty),.ag-theme-material .ag-group-contracted:not(.ag-hidden)~.ag-group-checkbox,.ag-theme-material .ag-group-expanded:not(.ag-hidden)+.ag-group-value:not(:empty),.ag-theme-material .ag-group-expanded:not(.ag-hidden)~.ag-cell-value:not(:empty),.ag-theme-material .ag-group-expanded:not(.ag-hidden)~.ag-group-checkbox,.ag-theme-material .ag-selection-checkbox:not(.ag-hidden)+.ag-group-value:not(:empty),.ag-theme-material .ag-selection-checkbox:not(.ag-hidden)~.ag-cell-value:not(:empty),.ag-theme-material .ag-selection-checkbox:not(.ag-hidden)~.ag-group-checkbox{margin-left:24px}.ag-theme-material .ag-group-child-count{margin-left:2px}.ag-theme-material .ag-selection-checkbox span{position:relative}.ag-theme-material .ag-column-drop-horizontal{background-color:#eee;height:48px;padding-left:24px}.ag-theme-material .ag-column-drop-horizontal .ag-icon-group,.ag-theme-material .ag-column-drop-horizontal .ag-icon-pivot{margin-right:24px}.ag-theme-material .ag-column-drop-horizontal .ag-icon-small-left,.ag-theme-material .ag-column-drop-horizontal .ag-icon-small-right{margin:0 8px;opacity:.54}.ag-theme-material .ag-column-drop-horizontal .ag-column-drop-empty-message{opacity:.38}.ag-theme-material .ag-column-drop-cell{background:#e2e2e2;border-radius:32px;min-height:32px;padding:0 4px}.ag-theme-material .ag-column-drop-cell .ag-column-drop-cell-text{margin:0 8px}.ag-theme-material .ag-column-drop-cell .ag-column-drop-cell-button{min-width:32px;margin:0 4px;opacity:.54}.ag-theme-material .ag-column-drop-cell .ag-column-drop-cell-button:hover{opacity:.87}.ag-theme-material .ag-column-drop-cell .ag-column-drag{margin-left:16px}.ag-theme-material .ag-column-drop-vertical .ag-column-drop-cell{margin-top:8px}.ag-theme-material .ag-select-agg-func-popup{border-radius:2px;box-shadow:0 3px 1px -2px rgba(0,0,0,.2),0 2px 2px 0 rgba(0,0,0,.14),0 1px 5px 0 rgba(0,0,0,.12);padding:8px;background:#fff;height:140px;padding:0}.ag-theme-material .ag-select-agg-func-popup .ag-virtual-list-item{cursor:default;line-height:40px;padding-left:16px}.ag-theme-material .ag-menu-column-select-wrapper,.ag-theme-material .ag-set-filter-list{width:auto}.ag-theme-material .ag-column-drop-vertical>.ag-column-drop-cell{margin-left:8px;margin-top:0}.ag-theme-material .ag-cell-data-changed{background-color:#00acc1!important}.ag-theme-material .ag-cell-data-changed-animation{background-color:transparent;transition:background-color 1s}.ag-theme-material .ag-stub-cell{padding-left:24px;padding-top:8px}.ag-theme-material .ag-stub-cell .ag-loading-icon{animation-name:spin;animation-duration:1s;animation-iteration-count:infinite;animation-timing-function:linear}@keyframes spin{0%{transform:rotate(0deg)}to{transform:rotate(1turn)}}.ag-theme-material .ag-stub-cell .ag-loading-text{margin-left:8px;margin-top:8px}.ag-theme-material .ag-floating-top{border-bottom:1px solid #e2e2e2}.ag-theme-material .ag-floating-bottom{border-top:1px solid #e2e2e2}.ag-theme-material .ag-status-bar{background:#fff;border:1px solid #e2e2e2;border-top-width:0;color:rgba(0,0,0,.38);font-weight:700;font-size:12px;font-family:Roboto,sans-serif;padding-right:32px;padding-left:32px;line-height:1.5}.ag-theme-material .ag-name-value-value{color:rgba(0,0,0,.87)}.ag-theme-material .ag-status-bar-center{text-align:center}.ag-theme-material .ag-name-value{margin-left:8px;margin-right:8px;padding-top:16px;padding-bottom:16px}.ag-theme-material .ag-details-row{padding:40px}.ag-theme-material .ag-overlay-loading-wrapper{background-color:hsla(0,0%,100%,.5)}.ag-theme-material .ag-overlay-loading-center{background:#fff;border-radius:2px;box-shadow:0 3px 1px -2px rgba(0,0,0,.2),0 2px 2px 0 rgba(0,0,0,.14),0 1px 5px 0 rgba(0,0,0,.12);padding:8px}.ag-theme-material .ag-side-bar{background-color:#fafafa;border:1px solid #e2e2e2;border-left-width:0;position:relative}.ag-theme-material .ag-side-bar .ag-side-buttons{padding-top:32px;background:#fff;width:22px;position:relative}.ag-theme-material .ag-side-bar .ag-side-buttons .ag-side-button button{background:transparent;border:0;color:rgba(0,0,0,.87);padding:16px 0;width:100%;margin:0;min-height:144px;border-width:1px 0;border-style:solid;border-color:transparent;background-position-y:center;background-position-x:center;background-repeat:no-repeat}.ag-theme-material .ag-side-bar .ag-side-buttons .ag-selected button{background-color:#fafafa;margin-left:-1px;padding-left:1px;border-color:#e2e2e2}.ag-theme-material .ag-side-bar .ag-panel-container{border-right:1px solid #e2e2e2}.ag-theme-material .ag-side-bar.full-width .ag-panel-container{border-right:0}.ag-theme-material .ag-side-bar .ag-column-drop{min-height:50px}.ag-theme-material .ag-primary-cols-filter-wrapper{margin-left:8px;margin-right:8px}.ag-theme-material .ag-group-component{background-color:#fdfdfd;padding:0;border:0 solid #efefef;border-top-width:1px}.ag-theme-material .ag-group-component.ag-disabled>.ag-group-component-container,.ag-theme-material .ag-group-component.ag-disabled>.ag-group-component-label .ag-group-component-title{opacity:.5}.ag-theme-material .ag-group-component .ag-group-component-title-bar{background-color:#f0f0f0;height:18px;font-size:13px;font-family:Roboto,sans-serif;height:26px}.ag-theme-material .ag-group-component:not(.ag-collapsible)>div{margin-left:0}.ag-theme-material .ag-group-component:not(.ag-collapsible)>.ag-group-component-title-bar{margin-left:0;padding:8px}.ag-theme-material .ag-group-component:not(.ag-collapsible)>.ag-group-component-title-bar .ag-column-group-icons{display:none}.ag-theme-material .ag-group-component .ag-group-component-toolbar{background-color:#f7f7f7;padding:8px;border:0 solid #e2e2e2}.ag-theme-material .ag-group-component>.ag-group-component-container{margin-left:16px;padding:8px}.ag-theme-material .ag-group-component .ag-group-item{margin:4px 0}.ag-theme-material .ag-group-component .ag-group-item .ag-group-component-title-bar{height:18px}.ag-theme-material .ag-labeled label{margin-right:8px;white-space:nowrap}.ag-theme-material .ag-labeled.ag-label-align-top label{margin-bottom:4px}.ag-theme-material .ag-angle-select>.ag-wrapper>div:not(:first-of-type),.ag-theme-material .ag-slider>.ag-wrapper>div:not(:first-of-type){margin-left:16px}.ag-theme-material .ag-angle-select .ag-angle-select-field .ag-parent-circle{width:24px;height:24px;border-radius:12px;box-shadow:0 0 2px rgba(0,0,0,.9);background-color:#fff}.ag-theme-material .ag-angle-select .ag-angle-select-field .ag-child-circle{top:4px;left:12px;width:6px;height:6px;margin-left:-3px;margin-top:-4px;border-radius:3px;background-color:#4c4c4c}.ag-theme-material .ag-toggle-button .ag-input-wrapper{height:18px;width:40px;background-color:#fff;border:1px solid #333;border-radius:500rem}.ag-theme-material .ag-toggle-button .ag-input-wrapper .ag-icon{width:18px;height:18px;border:1px solid #333;border-radius:500rem;right:calc(100% - 18px)}.ag-theme-material .ag-toggle-button.ag-selected .ag-input-wrapper{background-color:#ff4081}.ag-theme-material .ag-toggle-button.ag-selected .ag-input-wrapper .ag-icon{background:#fff;right:-1px}.ag-theme-material .ag-color-picker>.ag-wrapper{border:1px solid #e2e2e2;border-radius:5px}.ag-theme-material .ag-color-picker>.ag-wrapper>div{width:18px;height:18px}.ag-theme-material .ag-color-picker>.ag-wrapper button{background-color:#fff}.ag-theme-material .ag-color-picker>.ag-wrapper button:hover{background-color:#fafafa}.ag-theme-material .ag-dialog.ag-color-dialog{border-radius:5px}.ag-theme-material .ag-color-panel{padding:8px}.ag-theme-material .ag-color-panel .ag-spectrum-color{background-color:red;border-radius:2px}.ag-theme-material .ag-color-panel .ag-spectrum-tools{padding:10px}.ag-theme-material .ag-color-panel .ag-spectrum-sat{background-image:linear-gradient(90deg,#fff,hsla(20,42%,65%,0))}.ag-theme-material .ag-color-panel .ag-spectrum-val{background-image:linear-gradient(0deg,#000,hsla(20,42%,65%,0))}.ag-theme-material .ag-color-panel .ag-spectrum-dragger{border-radius:12px;height:12px;width:12px;border:1px solid #fff;background:#000;box-shadow:0 0 2px 0 rgba(0,0,0,.24)}.ag-theme-material .ag-color-panel .ag-spectrum-alpha-background,.ag-theme-material .ag-color-panel .ag-spectrum-hue-background{border-radius:2px}.ag-theme-material .ag-color-panel .ag-hue-alpha{margin-bottom:10px;height:11px;border-radius:2px}.ag-theme-material .ag-color-panel .ag-spectrum-slider{margin-top:-12px;width:13px;height:13px;border-radius:13px;background-color:#f8f8f8;box-shadow:0 1px 4px 0 rgba(0,0,0,.37)}.ag-theme-material .ag-color-panel .ag-spectrum-text-value{font-weight:700;line-height:20px;color:#333}.ag-theme-material .ag-color-panel .ag-spectrum-text-value:focus{border:1px solid #0d77e4;padding:2px}.ag-theme-material .ag-color-panel .ag-recent-colors>div{margin:0 3px}.ag-theme-material .ag-color-panel .ag-recent-colors>div:first-child{margin-left:0}.ag-theme-material .ag-color-panel .ag-recent-colors>div:last-child{margin-right:0}.ag-theme-material.ag-popup>div:not(.ag-tooltip-custom){box-shadow:5px 5px 10px rgba(0,0,0,.3)}.ag-theme-material .ag-panel{background-color:#fff;border:1px solid #e2e2e2}.ag-dragging-fill-handle .ag-theme-material .ag-panel.ag-dialog,.ag-dragging-range-handle .ag-theme-material .ag-panel.ag-dialog{opacity:.7;pointer-events:none}.ag-theme-material .ag-panel .ag-title-bar{background-color:#fff;border-bottom:1px solid #fcfcfc;color:rgba(0,0,0,.54);height:56px;font-size:12px;font-weight:700;font-family:Roboto,sans-serif;padding-left:24px;padding:5px 10px}.ag-theme-material .ag-panel .ag-title-bar .ag-title-bar-buttons .ag-button{height:20px;width:20px;border-radius:5px}.ag-theme-material .ag-panel .ag-title-bar .ag-title-bar-buttons .ag-button .ag-icon{line-height:20px;font-size:20px}.ag-theme-material .ag-panel .ag-title-bar .ag-title-bar-buttons .ag-button.ag-has-popup,.ag-theme-material .ag-panel .ag-title-bar .ag-title-bar-buttons .ag-button:hover{background-color:#e6e6e6}.ag-theme-material .ag-panel .ag-title-bar .ag-title-bar-buttons .ag-button:not(:last-child){margin-right:5px}.ag-theme-material .ag-panel .ag-message-box .ag-message-box-button-bar{height:30px;background-color:#fff;padding:2px}.ag-theme-material .ag-panel .ag-message-box .ag-message-box-button-bar button{border-radius:2px}.ag-theme-material .ag-tooltip{background-color:#535353;color:rgba(0,0,0,.87);border-radius:2px;padding:5px;border:1px solid #ebebeb;transition:opacity 1s}.ag-theme-material .ag-tooltip.ag-tooltip-hiding{opacity:0}.ag-theme-material .ag-chart .ag-chart-menu{border-radius:5px;background:#fff}.ag-theme-material .ag-chart .ag-chart-menu>span:hover{background-color:#e6e6e6}.ag-theme-material .ag-chart-tabbed-menu .ag-chart-settings .ag-chart-settings-mini-wrapper .ag-group-component-container{margin-left:0}.ag-theme-material .ag-chart-tabbed-menu .ag-chart-settings .ag-chart-settings-mini-wrapper .ag-chart-mini-thumbnail{border:1px solid #e2e2e2;border-radius:5px;margin:5px}.ag-theme-material .ag-chart-tabbed-menu .ag-chart-settings .ag-chart-settings-mini-wrapper .ag-chart-mini-thumbnail:nth-child(2n+2):not(:last-child){margin-left:auto;margin-right:auto}.ag-theme-material .ag-chart-tabbed-menu .ag-chart-settings .ag-chart-settings-mini-wrapper .ag-chart-mini-thumbnail:nth-child(3n+1){margin-left:2px}.ag-theme-material .ag-chart-tabbed-menu .ag-chart-settings .ag-chart-settings-mini-wrapper .ag-chart-mini-thumbnail:nth-child(3n){margin-right:2px}.ag-theme-material .ag-chart-tabbed-menu .ag-chart-settings .ag-chart-settings-mini-wrapper .ag-chart-mini-thumbnail.ag-selected{border-color:#3f51b5}.ag-theme-material .ag-chart-tabbed-menu .ag-chart-settings .ag-chart-settings-nav-bar .ag-nav-card-selector .ag-nav-card-item{color:rgba(0,0,0,.87);font-size:11px}.ag-theme-material .ag-chart-tabbed-menu .ag-chart-settings .ag-chart-settings-nav-bar .ag-nav-card-selector .ag-nav-card-item.ag-selected{color:#3f51b5}.ag-theme-material .ag-chart-tabbed-menu .ag-chart-format .ag-chart-format-wrapper .ag-group-item{margin:9.6px 0}.ag-theme-material .ag-icon{font-family:agGridMaterial;speak:none;font-size:18px;color:#333;font-style:normal;font-weight:400;font-variant:normal;text-transform:none;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.ag-theme-material .ag-icon-aggregation:before{content:\"\\E900\"}.ag-theme-material .ag-icon-arrows:before{content:\"\\E901\"}.ag-theme-material .ag-icon-asc:before{content:\"\\E902\"}.ag-theme-material .ag-icon-cancel:before{content:\"\\E903\"}.ag-theme-material .ag-icon-chart:before{content:\"\\E904\"}.ag-theme-material .ag-icon-checkbox-checked:before{content:\"\\E905\"}.ag-theme-material .ag-icon-checkbox-indeterminate:before{content:\"\\E906\"}.ag-theme-material .ag-icon-checkbox-unchecked:before{content:\"\\E907\"}.ag-theme-material .ag-icon-color-picker:before{content:\"\\E908\"}.ag-theme-material .ag-icon-column:before{content:\"\\E909\"}.ag-theme-material .ag-icon-columns:before{content:\"\\E90A\"}.ag-theme-material .ag-icon-contracted:before{content:\"\\E90B\"}.ag-theme-material .ag-icon-copy:before{content:\"\\E90C\"}.ag-theme-material .ag-icon-cross:before{content:\"\\E90D\"}.ag-theme-material .ag-icon-cut:before{content:\"\\E90E\"}.ag-theme-material .ag-icon-data:before{content:\"\\E90F\"}.ag-theme-material .ag-icon-desc:before{content:\"\\E910\"}.ag-theme-material .ag-icon-expanded:before{content:\"\\E911\"}.ag-theme-material .ag-icon-eye-slash:before{content:\"\\E912\"}.ag-theme-material .ag-icon-eye:before{content:\"\\E913\"}.ag-theme-material .ag-icon-filter:before{content:\"\\E914\"}.ag-theme-material .ag-icon-first:before{content:\"\\E915\"}.ag-theme-material .ag-icon-grip:before{content:\"\\E916\"}.ag-theme-material .ag-icon-group:before{content:\"\\E917\"}.ag-theme-material .ag-icon-indeterminate:before{content:\"\\E918\"}.ag-theme-material .ag-icon-last:before{content:\"\\E919\"}.ag-theme-material .ag-icon-left:before{content:\"\\E91A\"}.ag-theme-material .ag-icon-linked:before{content:\"\\E934\"}.ag-theme-material .ag-icon-loading:before{content:\"\\E91B\"}.ag-theme-material .ag-icon-maximize:before{content:\"\\E91C\"}.ag-theme-material .ag-icon-menu:before{content:\"\\E91D\"}.ag-theme-material .ag-icon-minimize:before{content:\"\\E91E\"}.ag-theme-material .ag-icon-minus:before{content:\"\\E91F\"}.ag-theme-material .ag-icon-next:before{content:\"\\E920\"}.ag-theme-material .ag-icon-none:before{content:\"\\E921\"}.ag-theme-material .ag-icon-not-allowed:before{content:\"\\E922\"}.ag-theme-material .ag-icon-paste:before{content:\"\\E923\"}.ag-theme-material .ag-icon-pin:before{content:\"\\E924\"}.ag-theme-material .ag-icon-pivot:before{content:\"\\E925\"}.ag-theme-material .ag-icon-plus:before{content:\"\\E926\"}.ag-theme-material .ag-icon-previous:before{content:\"\\E927\"}.ag-theme-material .ag-icon-radio-button-off:before{content:\"\\E928\"}.ag-theme-material .ag-icon-radio-button-on:before{content:\"\\E929\"}.ag-theme-material .ag-icon-right:before{content:\"\\E92A\"}.ag-theme-material .ag-icon-save:before{content:\"\\E92B\"}.ag-theme-material .ag-icon-small-down:before{content:\"\\E92C\"}.ag-theme-material .ag-icon-small-left:before{content:\"\\E92D\"}.ag-theme-material .ag-icon-small-right:before{content:\"\\E92E\"}.ag-theme-material .ag-icon-small-up:before{content:\"\\E92F\"}.ag-theme-material .ag-icon-tick:before{content:\"\\E930\"}.ag-theme-material .ag-icon-tree-closed:before{content:\"\\E931\"}.ag-theme-material .ag-icon-tree-indeterminate:before{content:\"\\E932\"}.ag-theme-material .ag-icon-tree-open:before{content:\"\\E933\"}.ag-theme-material .ag-icon-unlinked:before{content:\"\\E935\"}.ag-theme-material .ag-icon-checkbox-checked,.ag-theme-material .ag-icon-checkbox-indeterminate,.ag-theme-material .ag-icon-checkbox-unchecked{background-color:transparent;line-height:18px;border-radius:3px}.ag-theme-material .ag-icon-checkbox-checked-readonly,.ag-theme-material .ag-icon-checkbox-indeterminate-readonly,.ag-theme-material .ag-icon-checkbox-unchecked-readonly{cursor:default;opacity:.38}.ag-theme-material .ag-icon-checkbox-checked{color:#ff4081}.ag-theme-material .ag-icon-checkbox-checked-readonly:before{content:\"\\E905\"}.ag-theme-material .ag-icon-checkbox-indeterminate-readonly:before{content:\"\\E906\"}.ag-theme-material .ag-icon-checkbox-unchecked-readonly:before{content:\"\\E907\"}.ag-theme-material .ag-icon-row-drag:before{content:\"\\E916\"}.ag-theme-material .ag-right-arrow:before{content:\"\\E91A\"}.ag-theme-material .ag-icon-radio-button-on{color:#ff4081}.ag-theme-material .ag-right-arrow:before{content:\"\\E92A\"}.ag-theme-material .ag-rtl{text-align:right}.ag-theme-material .ag-rtl .ag-numeric-cell{text-align:left}.ag-theme-material .ag-rtl .ag-checkbox:not(.ag-label-align-left) label,.ag-theme-material .ag-rtl .ag-radio-button:not(.ag-label-align-left) label,.ag-theme-material .ag-rtl .ag-toggle-button:not(.ag-label-align-left) label{margin-right:8px;margin-left:0}.ag-theme-material .ag-rtl .ag-tool-panel-wrapper .ag-pivot-mode-panel .ag-pivot-mode-select{margin-right:8px}.ag-theme-material .ag-rtl .ag-tool-panel-wrapper .ag-column-drop .ag-column-drop-empty-message{padding-left:8px;padding-right:32px}.ag-theme-material .ag-rtl .ag-column-select-panel .ag-column-tool-panel-column-group .ag-column-group-icons,.ag-theme-material .ag-rtl .ag-column-select-panel .ag-column-tool-panel-column-group .ag-column-select-checkbox,.ag-theme-material .ag-rtl .ag-column-select-panel .ag-column-tool-panel-column .ag-column-group-icons,.ag-theme-material .ag-rtl .ag-column-select-panel .ag-column-tool-panel-column .ag-column-select-checkbox{margin-left:8px;margin-right:8px}.ag-theme-material .ag-rtl .ag-column-select-panel .ag-column-tool-panel-column.ag-toolpanel-add-group-indent{margin-left:0;margin-right:34px}.ag-theme-material .ag-rtl .ag-header-select-all{margin-left:24px;margin-right:0}.ag-theme-material .ag-rtl .ag-group-checkbox,.ag-theme-material .ag-rtl .ag-group-contracted,.ag-theme-material .ag-rtl .ag-group-expanded,.ag-theme-material .ag-rtl .ag-selection-checkbox{display:inline-flex}.ag-theme-material .ag-rtl .ag-group-checkbox+.ag-cell-value:not(:empty),.ag-theme-material .ag-rtl .ag-group-checkbox+.ag-group-checkbox,.ag-theme-material .ag-rtl .ag-group-checkbox+.ag-group-value:not(:empty),.ag-theme-material .ag-rtl .ag-group-contracted+.ag-cell-value:not(:empty),.ag-theme-material .ag-rtl .ag-group-contracted+.ag-group-checkbox,.ag-theme-material .ag-rtl .ag-group-contracted+.ag-group-value:not(:empty),.ag-theme-material .ag-rtl .ag-group-expanded+.ag-cell-value:not(:empty),.ag-theme-material .ag-rtl .ag-group-expanded+.ag-group-checkbox,.ag-theme-material .ag-rtl .ag-group-expanded+.ag-group-value:not(:empty),.ag-theme-material .ag-rtl .ag-selection-checkbox+.ag-cell-value:not(:empty),.ag-theme-material .ag-rtl .ag-selection-checkbox+.ag-group-checkbox,.ag-theme-material .ag-rtl .ag-selection-checkbox+.ag-group-value:not(:empty){margin-right:24px;margin-left:0}.ag-theme-material .ag-rtl .ag-group-child-count{margin-left:unset;margin-right:2px}.ag-theme-material .ag-rtl .ag-column-drop-horizontal{padding-right:24px}.ag-theme-material .ag-rtl .ag-column-drop-horizontal .ag-icon-group,.ag-theme-material .ag-rtl .ag-column-drop-horizontal .ag-icon-pivot{margin-left:24px;margin-right:0}.ag-theme-material .ag-rtl .ag-floating-filter-button{margin-right:24px}.ag-theme-material .ag-rtl .ag-set-filter-item>div,.ag-theme-material .ag-rtl .ag-set-filter-item>span{margin-left:0;margin-right:5px}.ag-theme-material .ag-rtl .ag-header .ag-header-cell-resize:after,.ag-theme-material .ag-rtl .ag-side-bar .ag-panel-container{border-left:1px solid #e2e2e2;border-right:0}.ag-theme-material .ag-rtl .ag-side-bar.full-width .ag-panel-container{border-left:0}.ag-theme-material .sass-variables:after{content:'{ \"autoSizePadding\": \"24px\", \"headerHeight\": \"56px\", \"groupPaddingSize\": \"42px\", \"footerPaddingAddition\": \"32px\", \"virtualItemHeight\": \"40px\", \"aggFuncPopupHeight\": \"140px\", \"checkboxIndentWidth\": \"26px\", \"leafNodePadding\": \"24px\", \"rowHeight\": \"48px\", \"gridSize\": \"8px\", \"iconSize\": \"18px\" }';display:none}.ag-theme-material .ag-icon-checkbox-checked,.ag-theme-material .ag-icon-checkbox-checked-readonly,.ag-theme-material .ag-icon-checkbox-indeterminate,.ag-theme-material .ag-icon-checkbox-indeterminate-readonly,.ag-theme-material .ag-icon-checkbox-unchecked,.ag-theme-material .ag-icon-checkbox-unchecked-readonly,.ag-theme-material .ag-icon-radio-button-off,.ag-theme-material .ag-icon-radio-button-on{height:24px;width:24px;font-size:24px;line-height:24px}.ag-theme-material .ag-header-cell,.ag-theme-material .ag-header-group-cell{-webkit-transition:background-color .5s;transition:background-color .5s}.ag-theme-material .ag-cell-highlight{background-color:#fce4ec!important}.ag-theme-material .ag-cell-highlight-animation{-webkit-transition:background-color 1s;transition:background-color 1s}.ag-theme-material .ag-menu-option{height:38px}.ag-theme-material .ag-side-bar{border-bottom:0;border-right:0;border-top:0}.ag-theme-material .ag-side-bar .ag-side-buttons button{border:0;color:rgba(0,0,0,.54);font-family:Roboto,sans-serif;font-size:12px;font-weight:700;background:transparent}.ag-theme-material .ag-side-bar .ag-side-buttons .ag-side-button button{background-color:transparent;border-width:0}.ag-theme-material .ag-side-bar .ag-side-buttons .ag-selected button{border-left:2px solid #3f51b5;background-color:#fafafa;margin-left:-2px;padding-left:1px}.ag-theme-material .ag-side-bar .ag-filter-toolpanel-body{background-color:#fff}.ag-theme-material .ag-status-bar{border-top-width:1px}.ag-theme-material .ag-rtl .ag-side-bar .ag-side-buttons .ag-selected button{border-left:0;margin-left:0;padding-left:0;border-right:2px solid #3f51b5;margin-right:-2px;padding-right:1px}.ag-theme-material .ag-group-expanded .ag-icon-contracted:empty:before{content:\"\\E933\"}", ""]);
	
	// exports


/***/ }),
/* 2965 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(2966), __esModule: true };

/***/ }),
/* 2966 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1306);
	__webpack_require__(1266);
	__webpack_require__(1288);
	__webpack_require__(2967);
	module.exports = __webpack_require__(1244).Promise;

/***/ }),
/* 2967 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY            = __webpack_require__(1270)
	  , global             = __webpack_require__(1240)
	  , ctx                = __webpack_require__(1245)
	  , classof            = __webpack_require__(2868)
	  , $export            = __webpack_require__(1243)
	  , isObject           = __webpack_require__(1250)
	  , aFunction          = __webpack_require__(1246)
	  , anInstance         = __webpack_require__(2968)
	  , forOf              = __webpack_require__(2969)
	  , speciesConstructor = __webpack_require__(2970)
	  , task               = __webpack_require__(2971).set
	  , microtask          = __webpack_require__(2973)()
	  , PROMISE            = 'Promise'
	  , TypeError          = global.TypeError
	  , process            = global.process
	  , $Promise           = global[PROMISE]
	  , process            = global.process
	  , isNode             = classof(process) == 'process'
	  , empty              = function(){ /* empty */ }
	  , Internal, GenericPromiseCapability, Wrapper;
	
	var USE_NATIVE = !!function(){
	  try {
	    // correct subclassing with @@species support
	    var promise     = $Promise.resolve(1)
	      , FakePromise = (promise.constructor = {})[__webpack_require__(1287)('species')] = function(exec){ exec(empty, empty); };
	    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
	    return (isNode || typeof PromiseRejectionEvent == 'function') && promise.then(empty) instanceof FakePromise;
	  } catch(e){ /* empty */ }
	}();
	
	// helpers
	var sameConstructor = function(a, b){
	  // with library wrapper special case
	  return a === b || a === $Promise && b === Wrapper;
	};
	var isThenable = function(it){
	  var then;
	  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
	};
	var newPromiseCapability = function(C){
	  return sameConstructor($Promise, C)
	    ? new PromiseCapability(C)
	    : new GenericPromiseCapability(C);
	};
	var PromiseCapability = GenericPromiseCapability = function(C){
	  var resolve, reject;
	  this.promise = new C(function($$resolve, $$reject){
	    if(resolve !== undefined || reject !== undefined)throw TypeError('Bad Promise constructor');
	    resolve = $$resolve;
	    reject  = $$reject;
	  });
	  this.resolve = aFunction(resolve);
	  this.reject  = aFunction(reject);
	};
	var perform = function(exec){
	  try {
	    exec();
	  } catch(e){
	    return {error: e};
	  }
	};
	var notify = function(promise, isReject){
	  if(promise._n)return;
	  promise._n = true;
	  var chain = promise._c;
	  microtask(function(){
	    var value = promise._v
	      , ok    = promise._s == 1
	      , i     = 0;
	    var run = function(reaction){
	      var handler = ok ? reaction.ok : reaction.fail
	        , resolve = reaction.resolve
	        , reject  = reaction.reject
	        , domain  = reaction.domain
	        , result, then;
	      try {
	        if(handler){
	          if(!ok){
	            if(promise._h == 2)onHandleUnhandled(promise);
	            promise._h = 1;
	          }
	          if(handler === true)result = value;
	          else {
	            if(domain)domain.enter();
	            result = handler(value);
	            if(domain)domain.exit();
	          }
	          if(result === reaction.promise){
	            reject(TypeError('Promise-chain cycle'));
	          } else if(then = isThenable(result)){
	            then.call(result, resolve, reject);
	          } else resolve(result);
	        } else reject(value);
	      } catch(e){
	        reject(e);
	      }
	    };
	    while(chain.length > i)run(chain[i++]); // variable length - can't use forEach
	    promise._c = [];
	    promise._n = false;
	    if(isReject && !promise._h)onUnhandled(promise);
	  });
	};
	var onUnhandled = function(promise){
	  task.call(global, function(){
	    var value = promise._v
	      , abrupt, handler, console;
	    if(isUnhandled(promise)){
	      abrupt = perform(function(){
	        if(isNode){
	          process.emit('unhandledRejection', value, promise);
	        } else if(handler = global.onunhandledrejection){
	          handler({promise: promise, reason: value});
	        } else if((console = global.console) && console.error){
	          console.error('Unhandled promise rejection', value);
	        }
	      });
	      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
	      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
	    } promise._a = undefined;
	    if(abrupt)throw abrupt.error;
	  });
	};
	var isUnhandled = function(promise){
	  if(promise._h == 1)return false;
	  var chain = promise._a || promise._c
	    , i     = 0
	    , reaction;
	  while(chain.length > i){
	    reaction = chain[i++];
	    if(reaction.fail || !isUnhandled(reaction.promise))return false;
	  } return true;
	};
	var onHandleUnhandled = function(promise){
	  task.call(global, function(){
	    var handler;
	    if(isNode){
	      process.emit('rejectionHandled', promise);
	    } else if(handler = global.onrejectionhandled){
	      handler({promise: promise, reason: promise._v});
	    }
	  });
	};
	var $reject = function(value){
	  var promise = this;
	  if(promise._d)return;
	  promise._d = true;
	  promise = promise._w || promise; // unwrap
	  promise._v = value;
	  promise._s = 2;
	  if(!promise._a)promise._a = promise._c.slice();
	  notify(promise, true);
	};
	var $resolve = function(value){
	  var promise = this
	    , then;
	  if(promise._d)return;
	  promise._d = true;
	  promise = promise._w || promise; // unwrap
	  try {
	    if(promise === value)throw TypeError("Promise can't be resolved itself");
	    if(then = isThenable(value)){
	      microtask(function(){
	        var wrapper = {_w: promise, _d: false}; // wrap
	        try {
	          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
	        } catch(e){
	          $reject.call(wrapper, e);
	        }
	      });
	    } else {
	      promise._v = value;
	      promise._s = 1;
	      notify(promise, false);
	    }
	  } catch(e){
	    $reject.call({_w: promise, _d: false}, e); // wrap
	  }
	};
	
	// constructor polyfill
	if(!USE_NATIVE){
	  // 25.4.3.1 Promise(executor)
	  $Promise = function Promise(executor){
	    anInstance(this, $Promise, PROMISE, '_h');
	    aFunction(executor);
	    Internal.call(this);
	    try {
	      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
	    } catch(err){
	      $reject.call(this, err);
	    }
	  };
	  Internal = function Promise(executor){
	    this._c = [];             // <- awaiting reactions
	    this._a = undefined;      // <- checked in isUnhandled reactions
	    this._s = 0;              // <- state
	    this._d = false;          // <- done
	    this._v = undefined;      // <- value
	    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
	    this._n = false;          // <- notify
	  };
	  Internal.prototype = __webpack_require__(2974)($Promise.prototype, {
	    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
	    then: function then(onFulfilled, onRejected){
	      var reaction    = newPromiseCapability(speciesConstructor(this, $Promise));
	      reaction.ok     = typeof onFulfilled == 'function' ? onFulfilled : true;
	      reaction.fail   = typeof onRejected == 'function' && onRejected;
	      reaction.domain = isNode ? process.domain : undefined;
	      this._c.push(reaction);
	      if(this._a)this._a.push(reaction);
	      if(this._s)notify(this, false);
	      return reaction.promise;
	    },
	    // 25.4.5.1 Promise.prototype.catch(onRejected)
	    'catch': function(onRejected){
	      return this.then(undefined, onRejected);
	    }
	  });
	  PromiseCapability = function(){
	    var promise  = new Internal;
	    this.promise = promise;
	    this.resolve = ctx($resolve, promise, 1);
	    this.reject  = ctx($reject, promise, 1);
	  };
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, {Promise: $Promise});
	__webpack_require__(1286)($Promise, PROMISE);
	__webpack_require__(2975)(PROMISE);
	Wrapper = __webpack_require__(1244)[PROMISE];
	
	// statics
	$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
	  // 25.4.4.5 Promise.reject(r)
	  reject: function reject(r){
	    var capability = newPromiseCapability(this)
	      , $$reject   = capability.reject;
	    $$reject(r);
	    return capability.promise;
	  }
	});
	$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
	  // 25.4.4.6 Promise.resolve(x)
	  resolve: function resolve(x){
	    // instanceof instead of internal slot check because we should fix it without replacement native Promise core
	    if(x instanceof $Promise && sameConstructor(x.constructor, this))return x;
	    var capability = newPromiseCapability(this)
	      , $$resolve  = capability.resolve;
	    $$resolve(x);
	    return capability.promise;
	  }
	});
	$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(2869)(function(iter){
	  $Promise.all(iter)['catch'](empty);
	})), PROMISE, {
	  // 25.4.4.1 Promise.all(iterable)
	  all: function all(iterable){
	    var C          = this
	      , capability = newPromiseCapability(C)
	      , resolve    = capability.resolve
	      , reject     = capability.reject;
	    var abrupt = perform(function(){
	      var values    = []
	        , index     = 0
	        , remaining = 1;
	      forOf(iterable, false, function(promise){
	        var $index        = index++
	          , alreadyCalled = false;
	        values.push(undefined);
	        remaining++;
	        C.resolve(promise).then(function(value){
	          if(alreadyCalled)return;
	          alreadyCalled  = true;
	          values[$index] = value;
	          --remaining || resolve(values);
	        }, reject);
	      });
	      --remaining || resolve(values);
	    });
	    if(abrupt)reject(abrupt.error);
	    return capability.promise;
	  },
	  // 25.4.4.4 Promise.race(iterable)
	  race: function race(iterable){
	    var C          = this
	      , capability = newPromiseCapability(C)
	      , reject     = capability.reject;
	    var abrupt = perform(function(){
	      forOf(iterable, false, function(promise){
	        C.resolve(promise).then(capability.resolve, reject);
	      });
	    });
	    if(abrupt)reject(abrupt.error);
	    return capability.promise;
	  }
	});

/***/ }),
/* 2968 */
/***/ (function(module, exports) {

	module.exports = function(it, Constructor, name, forbiddenField){
	  if(!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)){
	    throw TypeError(name + ': incorrect invocation!');
	  } return it;
	};

/***/ }),
/* 2969 */
/***/ (function(module, exports, __webpack_require__) {

	var ctx         = __webpack_require__(1245)
	  , call        = __webpack_require__(2864)
	  , isArrayIter = __webpack_require__(2865)
	  , anObject    = __webpack_require__(1249)
	  , toLength    = __webpack_require__(1282)
	  , getIterFn   = __webpack_require__(2867)
	  , BREAK       = {}
	  , RETURN      = {};
	var exports = module.exports = function(iterable, entries, fn, that, ITERATOR){
	  var iterFn = ITERATOR ? function(){ return iterable; } : getIterFn(iterable)
	    , f      = ctx(fn, that, entries ? 2 : 1)
	    , index  = 0
	    , length, step, iterator, result;
	  if(typeof iterFn != 'function')throw TypeError(iterable + ' is not iterable!');
	  // fast case for arrays with default iterator
	  if(isArrayIter(iterFn))for(length = toLength(iterable.length); length > index; index++){
	    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
	    if(result === BREAK || result === RETURN)return result;
	  } else for(iterator = iterFn.call(iterable); !(step = iterator.next()).done; ){
	    result = call(iterator, f, step.value, entries);
	    if(result === BREAK || result === RETURN)return result;
	  }
	};
	exports.BREAK  = BREAK;
	exports.RETURN = RETURN;

/***/ }),
/* 2970 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.3.20 SpeciesConstructor(O, defaultConstructor)
	var anObject  = __webpack_require__(1249)
	  , aFunction = __webpack_require__(1246)
	  , SPECIES   = __webpack_require__(1287)('species');
	module.exports = function(O, D){
	  var C = anObject(O).constructor, S;
	  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
	};

/***/ }),
/* 2971 */
/***/ (function(module, exports, __webpack_require__) {

	var ctx                = __webpack_require__(1245)
	  , invoke             = __webpack_require__(2972)
	  , html               = __webpack_require__(1285)
	  , cel                = __webpack_require__(1254)
	  , global             = __webpack_require__(1240)
	  , process            = global.process
	  , setTask            = global.setImmediate
	  , clearTask          = global.clearImmediate
	  , MessageChannel     = global.MessageChannel
	  , counter            = 0
	  , queue              = {}
	  , ONREADYSTATECHANGE = 'onreadystatechange'
	  , defer, channel, port;
	var run = function(){
	  var id = +this;
	  if(queue.hasOwnProperty(id)){
	    var fn = queue[id];
	    delete queue[id];
	    fn();
	  }
	};
	var listener = function(event){
	  run.call(event.data);
	};
	// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
	if(!setTask || !clearTask){
	  setTask = function setImmediate(fn){
	    var args = [], i = 1;
	    while(arguments.length > i)args.push(arguments[i++]);
	    queue[++counter] = function(){
	      invoke(typeof fn == 'function' ? fn : Function(fn), args);
	    };
	    defer(counter);
	    return counter;
	  };
	  clearTask = function clearImmediate(id){
	    delete queue[id];
	  };
	  // Node.js 0.8-
	  if(__webpack_require__(1280)(process) == 'process'){
	    defer = function(id){
	      process.nextTick(ctx(run, id, 1));
	    };
	  // Browsers with MessageChannel, includes WebWorkers
	  } else if(MessageChannel){
	    channel = new MessageChannel;
	    port    = channel.port2;
	    channel.port1.onmessage = listener;
	    defer = ctx(port.postMessage, port, 1);
	  // Browsers with postMessage, skip WebWorkers
	  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
	  } else if(global.addEventListener && typeof postMessage == 'function' && !global.importScripts){
	    defer = function(id){
	      global.postMessage(id + '', '*');
	    };
	    global.addEventListener('message', listener, false);
	  // IE8-
	  } else if(ONREADYSTATECHANGE in cel('script')){
	    defer = function(id){
	      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function(){
	        html.removeChild(this);
	        run.call(id);
	      };
	    };
	  // Rest old browsers
	  } else {
	    defer = function(id){
	      setTimeout(ctx(run, id, 1), 0);
	    };
	  }
	}
	module.exports = {
	  set:   setTask,
	  clear: clearTask
	};

/***/ }),
/* 2972 */
/***/ (function(module, exports) {

	// fast apply, http://jsperf.lnkit.com/fast-apply/5
	module.exports = function(fn, args, that){
	  var un = that === undefined;
	  switch(args.length){
	    case 0: return un ? fn()
	                      : fn.call(that);
	    case 1: return un ? fn(args[0])
	                      : fn.call(that, args[0]);
	    case 2: return un ? fn(args[0], args[1])
	                      : fn.call(that, args[0], args[1]);
	    case 3: return un ? fn(args[0], args[1], args[2])
	                      : fn.call(that, args[0], args[1], args[2]);
	    case 4: return un ? fn(args[0], args[1], args[2], args[3])
	                      : fn.call(that, args[0], args[1], args[2], args[3]);
	  } return              fn.apply(that, args);
	};

/***/ }),
/* 2973 */
/***/ (function(module, exports, __webpack_require__) {

	var global    = __webpack_require__(1240)
	  , macrotask = __webpack_require__(2971).set
	  , Observer  = global.MutationObserver || global.WebKitMutationObserver
	  , process   = global.process
	  , Promise   = global.Promise
	  , isNode    = __webpack_require__(1280)(process) == 'process';
	
	module.exports = function(){
	  var head, last, notify;
	
	  var flush = function(){
	    var parent, fn;
	    if(isNode && (parent = process.domain))parent.exit();
	    while(head){
	      fn   = head.fn;
	      head = head.next;
	      try {
	        fn();
	      } catch(e){
	        if(head)notify();
	        else last = undefined;
	        throw e;
	      }
	    } last = undefined;
	    if(parent)parent.enter();
	  };
	
	  // Node.js
	  if(isNode){
	    notify = function(){
	      process.nextTick(flush);
	    };
	  // browsers with MutationObserver
	  } else if(Observer){
	    var toggle = true
	      , node   = document.createTextNode('');
	    new Observer(flush).observe(node, {characterData: true}); // eslint-disable-line no-new
	    notify = function(){
	      node.data = toggle = !toggle;
	    };
	  // environments with maybe non-completely correct, but existent Promise
	  } else if(Promise && Promise.resolve){
	    var promise = Promise.resolve();
	    notify = function(){
	      promise.then(flush);
	    };
	  // for other environments - macrotask based on:
	  // - setImmediate
	  // - MessageChannel
	  // - window.postMessag
	  // - onreadystatechange
	  // - setTimeout
	  } else {
	    notify = function(){
	      // strange IE + webpack dev server bug - use .call(global)
	      macrotask.call(global, flush);
	    };
	  }
	
	  return function(fn){
	    var task = {fn: fn, next: undefined};
	    if(last)last.next = task;
	    if(!head){
	      head = task;
	      notify();
	    } last = task;
	  };
	};

/***/ }),
/* 2974 */
/***/ (function(module, exports, __webpack_require__) {

	var hide = __webpack_require__(1247);
	module.exports = function(target, src, safe){
	  for(var key in src){
	    if(safe && target[key])target[key] = src[key];
	    else hide(target, key, src[key]);
	  } return target;
	};

/***/ }),
/* 2975 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var global      = __webpack_require__(1240)
	  , core        = __webpack_require__(1244)
	  , dP          = __webpack_require__(1248)
	  , DESCRIPTORS = __webpack_require__(1252)
	  , SPECIES     = __webpack_require__(1287)('species');
	
	module.exports = function(KEY){
	  var C = typeof core[KEY] == 'function' ? core[KEY] : global[KEY];
	  if(DESCRIPTORS && C && !C[SPECIES])dP.f(C, SPECIES, {
	    configurable: true,
	    get: function(){ return this; }
	  });
	};

/***/ }),
/* 2976 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process, global, setImmediate) {/* @preserve
	 * The MIT License (MIT)
	 * 
	 * Copyright (c) 2013-2015 Petka Antonov
	 * 
	 * Permission is hereby granted, free of charge, to any person obtaining a copy
	 * of this software and associated documentation files (the "Software"), to deal
	 * in the Software without restriction, including without limitation the rights
	 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	 * copies of the Software, and to permit persons to whom the Software is
	 * furnished to do so, subject to the following conditions:
	 * 
	 * The above copyright notice and this permission notice shall be included in
	 * all copies or substantial portions of the Software.
	 * 
	 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.  IN NO EVENT SHALL THE
	 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	 * THE SOFTWARE.
	 * 
	 */
	/**
	 * bluebird build version 3.4.1
	 * Features enabled: core, race, call_get, generators, map, nodeify, promisify, props, reduce, settle, some, using, timers, filter, any, each
	*/
	!function(e){if(true)module.exports=e();else if("function"==typeof define&&define.amd)define([],e);else{var f;"undefined"!=typeof window?f=window:"undefined"!=typeof global?f=global:"undefined"!=typeof self&&(f=self),f.Promise=e()}}(function(){var define,module,exports;return (function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof _dereq_=="function"&&_dereq_;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof _dereq_=="function"&&_dereq_;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(_dereq_,module,exports){
	"use strict";
	module.exports = function(Promise) {
	var SomePromiseArray = Promise._SomePromiseArray;
	function any(promises) {
	    var ret = new SomePromiseArray(promises);
	    var promise = ret.promise();
	    ret.setHowMany(1);
	    ret.setUnwrap();
	    ret.init();
	    return promise;
	}
	
	Promise.any = function (promises) {
	    return any(promises);
	};
	
	Promise.prototype.any = function () {
	    return any(this);
	};
	
	};
	
	},{}],2:[function(_dereq_,module,exports){
	"use strict";
	var firstLineError;
	try {throw new Error(); } catch (e) {firstLineError = e;}
	var schedule = _dereq_("./schedule");
	var Queue = _dereq_("./queue");
	var util = _dereq_("./util");
	
	function Async() {
	    this._customScheduler = false;
	    this._isTickUsed = false;
	    this._lateQueue = new Queue(16);
	    this._normalQueue = new Queue(16);
	    this._haveDrainedQueues = false;
	    this._trampolineEnabled = true;
	    var self = this;
	    this.drainQueues = function () {
	        self._drainQueues();
	    };
	    this._schedule = schedule;
	}
	
	Async.prototype.setScheduler = function(fn) {
	    var prev = this._schedule;
	    this._schedule = fn;
	    this._customScheduler = true;
	    return prev;
	};
	
	Async.prototype.hasCustomScheduler = function() {
	    return this._customScheduler;
	};
	
	Async.prototype.enableTrampoline = function() {
	    this._trampolineEnabled = true;
	};
	
	Async.prototype.disableTrampolineIfNecessary = function() {
	    if (util.hasDevTools) {
	        this._trampolineEnabled = false;
	    }
	};
	
	Async.prototype.haveItemsQueued = function () {
	    return this._isTickUsed || this._haveDrainedQueues;
	};
	
	
	Async.prototype.fatalError = function(e, isNode) {
	    if (isNode) {
	        process.stderr.write("Fatal " + (e instanceof Error ? e.stack : e) +
	            "\n");
	        process.exit(2);
	    } else {
	        this.throwLater(e);
	    }
	};
	
	Async.prototype.throwLater = function(fn, arg) {
	    if (arguments.length === 1) {
	        arg = fn;
	        fn = function () { throw arg; };
	    }
	    if (typeof setTimeout !== "undefined") {
	        setTimeout(function() {
	            fn(arg);
	        }, 0);
	    } else try {
	        this._schedule(function() {
	            fn(arg);
	        });
	    } catch (e) {
	        throw new Error("No async scheduler available\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
	    }
	};
	
	function AsyncInvokeLater(fn, receiver, arg) {
	    this._lateQueue.push(fn, receiver, arg);
	    this._queueTick();
	}
	
	function AsyncInvoke(fn, receiver, arg) {
	    this._normalQueue.push(fn, receiver, arg);
	    this._queueTick();
	}
	
	function AsyncSettlePromises(promise) {
	    this._normalQueue._pushOne(promise);
	    this._queueTick();
	}
	
	if (!util.hasDevTools) {
	    Async.prototype.invokeLater = AsyncInvokeLater;
	    Async.prototype.invoke = AsyncInvoke;
	    Async.prototype.settlePromises = AsyncSettlePromises;
	} else {
	    Async.prototype.invokeLater = function (fn, receiver, arg) {
	        if (this._trampolineEnabled) {
	            AsyncInvokeLater.call(this, fn, receiver, arg);
	        } else {
	            this._schedule(function() {
	                setTimeout(function() {
	                    fn.call(receiver, arg);
	                }, 100);
	            });
	        }
	    };
	
	    Async.prototype.invoke = function (fn, receiver, arg) {
	        if (this._trampolineEnabled) {
	            AsyncInvoke.call(this, fn, receiver, arg);
	        } else {
	            this._schedule(function() {
	                fn.call(receiver, arg);
	            });
	        }
	    };
	
	    Async.prototype.settlePromises = function(promise) {
	        if (this._trampolineEnabled) {
	            AsyncSettlePromises.call(this, promise);
	        } else {
	            this._schedule(function() {
	                promise._settlePromises();
	            });
	        }
	    };
	}
	
	Async.prototype.invokeFirst = function (fn, receiver, arg) {
	    this._normalQueue.unshift(fn, receiver, arg);
	    this._queueTick();
	};
	
	Async.prototype._drainQueue = function(queue) {
	    while (queue.length() > 0) {
	        var fn = queue.shift();
	        if (typeof fn !== "function") {
	            fn._settlePromises();
	            continue;
	        }
	        var receiver = queue.shift();
	        var arg = queue.shift();
	        fn.call(receiver, arg);
	    }
	};
	
	Async.prototype._drainQueues = function () {
	    this._drainQueue(this._normalQueue);
	    this._reset();
	    this._haveDrainedQueues = true;
	    this._drainQueue(this._lateQueue);
	};
	
	Async.prototype._queueTick = function () {
	    if (!this._isTickUsed) {
	        this._isTickUsed = true;
	        this._schedule(this.drainQueues);
	    }
	};
	
	Async.prototype._reset = function () {
	    this._isTickUsed = false;
	};
	
	module.exports = Async;
	module.exports.firstLineError = firstLineError;
	
	},{"./queue":26,"./schedule":29,"./util":36}],3:[function(_dereq_,module,exports){
	"use strict";
	module.exports = function(Promise, INTERNAL, tryConvertToPromise, debug) {
	var calledBind = false;
	var rejectThis = function(_, e) {
	    this._reject(e);
	};
	
	var targetRejected = function(e, context) {
	    context.promiseRejectionQueued = true;
	    context.bindingPromise._then(rejectThis, rejectThis, null, this, e);
	};
	
	var bindingResolved = function(thisArg, context) {
	    if (((this._bitField & 50397184) === 0)) {
	        this._resolveCallback(context.target);
	    }
	};
	
	var bindingRejected = function(e, context) {
	    if (!context.promiseRejectionQueued) this._reject(e);
	};
	
	Promise.prototype.bind = function (thisArg) {
	    if (!calledBind) {
	        calledBind = true;
	        Promise.prototype._propagateFrom = debug.propagateFromFunction();
	        Promise.prototype._boundValue = debug.boundValueFunction();
	    }
	    var maybePromise = tryConvertToPromise(thisArg);
	    var ret = new Promise(INTERNAL);
	    ret._propagateFrom(this, 1);
	    var target = this._target();
	    ret._setBoundTo(maybePromise);
	    if (maybePromise instanceof Promise) {
	        var context = {
	            promiseRejectionQueued: false,
	            promise: ret,
	            target: target,
	            bindingPromise: maybePromise
	        };
	        target._then(INTERNAL, targetRejected, undefined, ret, context);
	        maybePromise._then(
	            bindingResolved, bindingRejected, undefined, ret, context);
	        ret._setOnCancel(maybePromise);
	    } else {
	        ret._resolveCallback(target);
	    }
	    return ret;
	};
	
	Promise.prototype._setBoundTo = function (obj) {
	    if (obj !== undefined) {
	        this._bitField = this._bitField | 2097152;
	        this._boundTo = obj;
	    } else {
	        this._bitField = this._bitField & (~2097152);
	    }
	};
	
	Promise.prototype._isBound = function () {
	    return (this._bitField & 2097152) === 2097152;
	};
	
	Promise.bind = function (thisArg, value) {
	    return Promise.resolve(value).bind(thisArg);
	};
	};
	
	},{}],4:[function(_dereq_,module,exports){
	"use strict";
	var old;
	if (typeof Promise !== "undefined") old = Promise;
	function noConflict() {
	    try { if (Promise === bluebird) Promise = old; }
	    catch (e) {}
	    return bluebird;
	}
	var bluebird = _dereq_("./promise")();
	bluebird.noConflict = noConflict;
	module.exports = bluebird;
	
	},{"./promise":22}],5:[function(_dereq_,module,exports){
	"use strict";
	var cr = Object.create;
	if (cr) {
	    var callerCache = cr(null);
	    var getterCache = cr(null);
	    callerCache[" size"] = getterCache[" size"] = 0;
	}
	
	module.exports = function(Promise) {
	var util = _dereq_("./util");
	var canEvaluate = util.canEvaluate;
	var isIdentifier = util.isIdentifier;
	
	var getMethodCaller;
	var getGetter;
	if (false) {
	var makeMethodCaller = function (methodName) {
	    return new Function("ensureMethod", "                                    \n\
	        return function(obj) {                                               \n\
	            'use strict'                                                     \n\
	            var len = this.length;                                           \n\
	            ensureMethod(obj, 'methodName');                                 \n\
	            switch(len) {                                                    \n\
	                case 1: return obj.methodName(this[0]);                      \n\
	                case 2: return obj.methodName(this[0], this[1]);             \n\
	                case 3: return obj.methodName(this[0], this[1], this[2]);    \n\
	                case 0: return obj.methodName();                             \n\
	                default:                                                     \n\
	                    return obj.methodName.apply(obj, this);                  \n\
	            }                                                                \n\
	        };                                                                   \n\
	        ".replace(/methodName/g, methodName))(ensureMethod);
	};
	
	var makeGetter = function (propertyName) {
	    return new Function("obj", "                                             \n\
	        'use strict';                                                        \n\
	        return obj.propertyName;                                             \n\
	        ".replace("propertyName", propertyName));
	};
	
	var getCompiled = function(name, compiler, cache) {
	    var ret = cache[name];
	    if (typeof ret !== "function") {
	        if (!isIdentifier(name)) {
	            return null;
	        }
	        ret = compiler(name);
	        cache[name] = ret;
	        cache[" size"]++;
	        if (cache[" size"] > 512) {
	            var keys = Object.keys(cache);
	            for (var i = 0; i < 256; ++i) delete cache[keys[i]];
	            cache[" size"] = keys.length - 256;
	        }
	    }
	    return ret;
	};
	
	getMethodCaller = function(name) {
	    return getCompiled(name, makeMethodCaller, callerCache);
	};
	
	getGetter = function(name) {
	    return getCompiled(name, makeGetter, getterCache);
	};
	}
	
	function ensureMethod(obj, methodName) {
	    var fn;
	    if (obj != null) fn = obj[methodName];
	    if (typeof fn !== "function") {
	        var message = "Object " + util.classString(obj) + " has no method '" +
	            util.toString(methodName) + "'";
	        throw new Promise.TypeError(message);
	    }
	    return fn;
	}
	
	function caller(obj) {
	    var methodName = this.pop();
	    var fn = ensureMethod(obj, methodName);
	    return fn.apply(obj, this);
	}
	Promise.prototype.call = function (methodName) {
	    var args = [].slice.call(arguments, 1);;
	    if (false) {
	        if (canEvaluate) {
	            var maybeCaller = getMethodCaller(methodName);
	            if (maybeCaller !== null) {
	                return this._then(
	                    maybeCaller, undefined, undefined, args, undefined);
	            }
	        }
	    }
	    args.push(methodName);
	    return this._then(caller, undefined, undefined, args, undefined);
	};
	
	function namedGetter(obj) {
	    return obj[this];
	}
	function indexedGetter(obj) {
	    var index = +this;
	    if (index < 0) index = Math.max(0, index + obj.length);
	    return obj[index];
	}
	Promise.prototype.get = function (propertyName) {
	    var isIndex = (typeof propertyName === "number");
	    var getter;
	    if (!isIndex) {
	        if (canEvaluate) {
	            var maybeGetter = getGetter(propertyName);
	            getter = maybeGetter !== null ? maybeGetter : namedGetter;
	        } else {
	            getter = namedGetter;
	        }
	    } else {
	        getter = indexedGetter;
	    }
	    return this._then(getter, undefined, undefined, propertyName, undefined);
	};
	};
	
	},{"./util":36}],6:[function(_dereq_,module,exports){
	"use strict";
	module.exports = function(Promise, PromiseArray, apiRejection, debug) {
	var util = _dereq_("./util");
	var tryCatch = util.tryCatch;
	var errorObj = util.errorObj;
	var async = Promise._async;
	
	Promise.prototype["break"] = Promise.prototype.cancel = function() {
	    if (!debug.cancellation()) return this._warn("cancellation is disabled");
	
	    var promise = this;
	    var child = promise;
	    while (promise.isCancellable()) {
	        if (!promise._cancelBy(child)) {
	            if (child._isFollowing()) {
	                child._followee().cancel();
	            } else {
	                child._cancelBranched();
	            }
	            break;
	        }
	
	        var parent = promise._cancellationParent;
	        if (parent == null || !parent.isCancellable()) {
	            if (promise._isFollowing()) {
	                promise._followee().cancel();
	            } else {
	                promise._cancelBranched();
	            }
	            break;
	        } else {
	            if (promise._isFollowing()) promise._followee().cancel();
	            child = promise;
	            promise = parent;
	        }
	    }
	};
	
	Promise.prototype._branchHasCancelled = function() {
	    this._branchesRemainingToCancel--;
	};
	
	Promise.prototype._enoughBranchesHaveCancelled = function() {
	    return this._branchesRemainingToCancel === undefined ||
	           this._branchesRemainingToCancel <= 0;
	};
	
	Promise.prototype._cancelBy = function(canceller) {
	    if (canceller === this) {
	        this._branchesRemainingToCancel = 0;
	        this._invokeOnCancel();
	        return true;
	    } else {
	        this._branchHasCancelled();
	        if (this._enoughBranchesHaveCancelled()) {
	            this._invokeOnCancel();
	            return true;
	        }
	    }
	    return false;
	};
	
	Promise.prototype._cancelBranched = function() {
	    if (this._enoughBranchesHaveCancelled()) {
	        this._cancel();
	    }
	};
	
	Promise.prototype._cancel = function() {
	    if (!this.isCancellable()) return;
	
	    this._setCancelled();
	    async.invoke(this._cancelPromises, this, undefined);
	};
	
	Promise.prototype._cancelPromises = function() {
	    if (this._length() > 0) this._settlePromises();
	};
	
	Promise.prototype._unsetOnCancel = function() {
	    this._onCancelField = undefined;
	};
	
	Promise.prototype.isCancellable = function() {
	    return this.isPending() && !this.isCancelled();
	};
	
	Promise.prototype._doInvokeOnCancel = function(onCancelCallback, internalOnly) {
	    if (util.isArray(onCancelCallback)) {
	        for (var i = 0; i < onCancelCallback.length; ++i) {
	            this._doInvokeOnCancel(onCancelCallback[i], internalOnly);
	        }
	    } else if (onCancelCallback !== undefined) {
	        if (typeof onCancelCallback === "function") {
	            if (!internalOnly) {
	                var e = tryCatch(onCancelCallback).call(this._boundValue());
	                if (e === errorObj) {
	                    this._attachExtraTrace(e.e);
	                    async.throwLater(e.e);
	                }
	            }
	        } else {
	            onCancelCallback._resultCancelled(this);
	        }
	    }
	};
	
	Promise.prototype._invokeOnCancel = function() {
	    var onCancelCallback = this._onCancel();
	    this._unsetOnCancel();
	    async.invoke(this._doInvokeOnCancel, this, onCancelCallback);
	};
	
	Promise.prototype._invokeInternalOnCancel = function() {
	    if (this.isCancellable()) {
	        this._doInvokeOnCancel(this._onCancel(), true);
	        this._unsetOnCancel();
	    }
	};
	
	Promise.prototype._resultCancelled = function() {
	    this.cancel();
	};
	
	};
	
	},{"./util":36}],7:[function(_dereq_,module,exports){
	"use strict";
	module.exports = function(NEXT_FILTER) {
	var util = _dereq_("./util");
	var getKeys = _dereq_("./es5").keys;
	var tryCatch = util.tryCatch;
	var errorObj = util.errorObj;
	
	function catchFilter(instances, cb, promise) {
	    return function(e) {
	        var boundTo = promise._boundValue();
	        predicateLoop: for (var i = 0; i < instances.length; ++i) {
	            var item = instances[i];
	
	            if (item === Error ||
	                (item != null && item.prototype instanceof Error)) {
	                if (e instanceof item) {
	                    return tryCatch(cb).call(boundTo, e);
	                }
	            } else if (typeof item === "function") {
	                var matchesPredicate = tryCatch(item).call(boundTo, e);
	                if (matchesPredicate === errorObj) {
	                    return matchesPredicate;
	                } else if (matchesPredicate) {
	                    return tryCatch(cb).call(boundTo, e);
	                }
	            } else if (util.isObject(e)) {
	                var keys = getKeys(item);
	                for (var j = 0; j < keys.length; ++j) {
	                    var key = keys[j];
	                    if (item[key] != e[key]) {
	                        continue predicateLoop;
	                    }
	                }
	                return tryCatch(cb).call(boundTo, e);
	            }
	        }
	        return NEXT_FILTER;
	    };
	}
	
	return catchFilter;
	};
	
	},{"./es5":13,"./util":36}],8:[function(_dereq_,module,exports){
	"use strict";
	module.exports = function(Promise) {
	var longStackTraces = false;
	var contextStack = [];
	
	Promise.prototype._promiseCreated = function() {};
	Promise.prototype._pushContext = function() {};
	Promise.prototype._popContext = function() {return null;};
	Promise._peekContext = Promise.prototype._peekContext = function() {};
	
	function Context() {
	    this._trace = new Context.CapturedTrace(peekContext());
	}
	Context.prototype._pushContext = function () {
	    if (this._trace !== undefined) {
	        this._trace._promiseCreated = null;
	        contextStack.push(this._trace);
	    }
	};
	
	Context.prototype._popContext = function () {
	    if (this._trace !== undefined) {
	        var trace = contextStack.pop();
	        var ret = trace._promiseCreated;
	        trace._promiseCreated = null;
	        return ret;
	    }
	    return null;
	};
	
	function createContext() {
	    if (longStackTraces) return new Context();
	}
	
	function peekContext() {
	    var lastIndex = contextStack.length - 1;
	    if (lastIndex >= 0) {
	        return contextStack[lastIndex];
	    }
	    return undefined;
	}
	Context.CapturedTrace = null;
	Context.create = createContext;
	Context.deactivateLongStackTraces = function() {};
	Context.activateLongStackTraces = function() {
	    var Promise_pushContext = Promise.prototype._pushContext;
	    var Promise_popContext = Promise.prototype._popContext;
	    var Promise_PeekContext = Promise._peekContext;
	    var Promise_peekContext = Promise.prototype._peekContext;
	    var Promise_promiseCreated = Promise.prototype._promiseCreated;
	    Context.deactivateLongStackTraces = function() {
	        Promise.prototype._pushContext = Promise_pushContext;
	        Promise.prototype._popContext = Promise_popContext;
	        Promise._peekContext = Promise_PeekContext;
	        Promise.prototype._peekContext = Promise_peekContext;
	        Promise.prototype._promiseCreated = Promise_promiseCreated;
	        longStackTraces = false;
	    };
	    longStackTraces = true;
	    Promise.prototype._pushContext = Context.prototype._pushContext;
	    Promise.prototype._popContext = Context.prototype._popContext;
	    Promise._peekContext = Promise.prototype._peekContext = peekContext;
	    Promise.prototype._promiseCreated = function() {
	        var ctx = this._peekContext();
	        if (ctx && ctx._promiseCreated == null) ctx._promiseCreated = this;
	    };
	};
	return Context;
	};
	
	},{}],9:[function(_dereq_,module,exports){
	"use strict";
	module.exports = function(Promise, Context) {
	var getDomain = Promise._getDomain;
	var async = Promise._async;
	var Warning = _dereq_("./errors").Warning;
	var util = _dereq_("./util");
	var canAttachTrace = util.canAttachTrace;
	var unhandledRejectionHandled;
	var possiblyUnhandledRejection;
	var bluebirdFramePattern =
	    /[\\\/]bluebird[\\\/]js[\\\/](release|debug|instrumented)/;
	var stackFramePattern = null;
	var formatStack = null;
	var indentStackFrames = false;
	var printWarning;
	var debugging = !!(util.env("BLUEBIRD_DEBUG") != 0 &&
	                        (true ||
	                         util.env("BLUEBIRD_DEBUG") ||
	                         util.env("NODE_ENV") === "development"));
	
	var warnings = !!(util.env("BLUEBIRD_WARNINGS") != 0 &&
	    (debugging || util.env("BLUEBIRD_WARNINGS")));
	
	var longStackTraces = !!(util.env("BLUEBIRD_LONG_STACK_TRACES") != 0 &&
	    (debugging || util.env("BLUEBIRD_LONG_STACK_TRACES")));
	
	var wForgottenReturn = util.env("BLUEBIRD_W_FORGOTTEN_RETURN") != 0 &&
	    (warnings || !!util.env("BLUEBIRD_W_FORGOTTEN_RETURN"));
	
	Promise.prototype.suppressUnhandledRejections = function() {
	    var target = this._target();
	    target._bitField = ((target._bitField & (~1048576)) |
	                      524288);
	};
	
	Promise.prototype._ensurePossibleRejectionHandled = function () {
	    if ((this._bitField & 524288) !== 0) return;
	    this._setRejectionIsUnhandled();
	    async.invokeLater(this._notifyUnhandledRejection, this, undefined);
	};
	
	Promise.prototype._notifyUnhandledRejectionIsHandled = function () {
	    fireRejectionEvent("rejectionHandled",
	                                  unhandledRejectionHandled, undefined, this);
	};
	
	Promise.prototype._setReturnedNonUndefined = function() {
	    this._bitField = this._bitField | 268435456;
	};
	
	Promise.prototype._returnedNonUndefined = function() {
	    return (this._bitField & 268435456) !== 0;
	};
	
	Promise.prototype._notifyUnhandledRejection = function () {
	    if (this._isRejectionUnhandled()) {
	        var reason = this._settledValue();
	        this._setUnhandledRejectionIsNotified();
	        fireRejectionEvent("unhandledRejection",
	                                      possiblyUnhandledRejection, reason, this);
	    }
	};
	
	Promise.prototype._setUnhandledRejectionIsNotified = function () {
	    this._bitField = this._bitField | 262144;
	};
	
	Promise.prototype._unsetUnhandledRejectionIsNotified = function () {
	    this._bitField = this._bitField & (~262144);
	};
	
	Promise.prototype._isUnhandledRejectionNotified = function () {
	    return (this._bitField & 262144) > 0;
	};
	
	Promise.prototype._setRejectionIsUnhandled = function () {
	    this._bitField = this._bitField | 1048576;
	};
	
	Promise.prototype._unsetRejectionIsUnhandled = function () {
	    this._bitField = this._bitField & (~1048576);
	    if (this._isUnhandledRejectionNotified()) {
	        this._unsetUnhandledRejectionIsNotified();
	        this._notifyUnhandledRejectionIsHandled();
	    }
	};
	
	Promise.prototype._isRejectionUnhandled = function () {
	    return (this._bitField & 1048576) > 0;
	};
	
	Promise.prototype._warn = function(message, shouldUseOwnTrace, promise) {
	    return warn(message, shouldUseOwnTrace, promise || this);
	};
	
	Promise.onPossiblyUnhandledRejection = function (fn) {
	    var domain = getDomain();
	    possiblyUnhandledRejection =
	        typeof fn === "function" ? (domain === null ? fn : domain.bind(fn))
	                                 : undefined;
	};
	
	Promise.onUnhandledRejectionHandled = function (fn) {
	    var domain = getDomain();
	    unhandledRejectionHandled =
	        typeof fn === "function" ? (domain === null ? fn : domain.bind(fn))
	                                 : undefined;
	};
	
	var disableLongStackTraces = function() {};
	Promise.longStackTraces = function () {
	    if (async.haveItemsQueued() && !config.longStackTraces) {
	        throw new Error("cannot enable long stack traces after promises have been created\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
	    }
	    if (!config.longStackTraces && longStackTracesIsSupported()) {
	        var Promise_captureStackTrace = Promise.prototype._captureStackTrace;
	        var Promise_attachExtraTrace = Promise.prototype._attachExtraTrace;
	        config.longStackTraces = true;
	        disableLongStackTraces = function() {
	            if (async.haveItemsQueued() && !config.longStackTraces) {
	                throw new Error("cannot enable long stack traces after promises have been created\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
	            }
	            Promise.prototype._captureStackTrace = Promise_captureStackTrace;
	            Promise.prototype._attachExtraTrace = Promise_attachExtraTrace;
	            Context.deactivateLongStackTraces();
	            async.enableTrampoline();
	            config.longStackTraces = false;
	        };
	        Promise.prototype._captureStackTrace = longStackTracesCaptureStackTrace;
	        Promise.prototype._attachExtraTrace = longStackTracesAttachExtraTrace;
	        Context.activateLongStackTraces();
	        async.disableTrampolineIfNecessary();
	    }
	};
	
	Promise.hasLongStackTraces = function () {
	    return config.longStackTraces && longStackTracesIsSupported();
	};
	
	var fireDomEvent = (function() {
	    try {
	        var event = document.createEvent("CustomEvent");
	        event.initCustomEvent("testingtheevent", false, true, {});
	        util.global.dispatchEvent(event);
	        return function(name, event) {
	            var domEvent = document.createEvent("CustomEvent");
	            domEvent.initCustomEvent(name.toLowerCase(), false, true, event);
	            return !util.global.dispatchEvent(domEvent);
	        };
	    } catch (e) {}
	    return function() {
	        return false;
	    };
	})();
	
	var fireGlobalEvent = (function() {
	    if (util.isNode) {
	        return function() {
	            return process.emit.apply(process, arguments);
	        };
	    } else {
	        if (!util.global) {
	            return function() {
	                return false;
	            };
	        }
	        return function(name) {
	            var methodName = "on" + name.toLowerCase();
	            var method = util.global[methodName];
	            if (!method) return false;
	            method.apply(util.global, [].slice.call(arguments, 1));
	            return true;
	        };
	    }
	})();
	
	function generatePromiseLifecycleEventObject(name, promise) {
	    return {promise: promise};
	}
	
	var eventToObjectGenerator = {
	    promiseCreated: generatePromiseLifecycleEventObject,
	    promiseFulfilled: generatePromiseLifecycleEventObject,
	    promiseRejected: generatePromiseLifecycleEventObject,
	    promiseResolved: generatePromiseLifecycleEventObject,
	    promiseCancelled: generatePromiseLifecycleEventObject,
	    promiseChained: function(name, promise, child) {
	        return {promise: promise, child: child};
	    },
	    warning: function(name, warning) {
	        return {warning: warning};
	    },
	    unhandledRejection: function (name, reason, promise) {
	        return {reason: reason, promise: promise};
	    },
	    rejectionHandled: generatePromiseLifecycleEventObject
	};
	
	var activeFireEvent = function (name) {
	    var globalEventFired = false;
	    try {
	        globalEventFired = fireGlobalEvent.apply(null, arguments);
	    } catch (e) {
	        async.throwLater(e);
	        globalEventFired = true;
	    }
	
	    var domEventFired = false;
	    try {
	        domEventFired = fireDomEvent(name,
	                    eventToObjectGenerator[name].apply(null, arguments));
	    } catch (e) {
	        async.throwLater(e);
	        domEventFired = true;
	    }
	
	    return domEventFired || globalEventFired;
	};
	
	Promise.config = function(opts) {
	    opts = Object(opts);
	    if ("longStackTraces" in opts) {
	        if (opts.longStackTraces) {
	            Promise.longStackTraces();
	        } else if (!opts.longStackTraces && Promise.hasLongStackTraces()) {
	            disableLongStackTraces();
	        }
	    }
	    if ("warnings" in opts) {
	        var warningsOption = opts.warnings;
	        config.warnings = !!warningsOption;
	        wForgottenReturn = config.warnings;
	
	        if (util.isObject(warningsOption)) {
	            if ("wForgottenReturn" in warningsOption) {
	                wForgottenReturn = !!warningsOption.wForgottenReturn;
	            }
	        }
	    }
	    if ("cancellation" in opts && opts.cancellation && !config.cancellation) {
	        if (async.haveItemsQueued()) {
	            throw new Error(
	                "cannot enable cancellation after promises are in use");
	        }
	        Promise.prototype._clearCancellationData =
	            cancellationClearCancellationData;
	        Promise.prototype._propagateFrom = cancellationPropagateFrom;
	        Promise.prototype._onCancel = cancellationOnCancel;
	        Promise.prototype._setOnCancel = cancellationSetOnCancel;
	        Promise.prototype._attachCancellationCallback =
	            cancellationAttachCancellationCallback;
	        Promise.prototype._execute = cancellationExecute;
	        propagateFromFunction = cancellationPropagateFrom;
	        config.cancellation = true;
	    }
	    if ("monitoring" in opts) {
	        if (opts.monitoring && !config.monitoring) {
	            config.monitoring = true;
	            Promise.prototype._fireEvent = activeFireEvent;
	        } else if (!opts.monitoring && config.monitoring) {
	            config.monitoring = false;
	            Promise.prototype._fireEvent = defaultFireEvent;
	        }
	    }
	};
	
	function defaultFireEvent() { return false; }
	
	Promise.prototype._fireEvent = defaultFireEvent;
	Promise.prototype._execute = function(executor, resolve, reject) {
	    try {
	        executor(resolve, reject);
	    } catch (e) {
	        return e;
	    }
	};
	Promise.prototype._onCancel = function () {};
	Promise.prototype._setOnCancel = function (handler) { ; };
	Promise.prototype._attachCancellationCallback = function(onCancel) {
	    ;
	};
	Promise.prototype._captureStackTrace = function () {};
	Promise.prototype._attachExtraTrace = function () {};
	Promise.prototype._clearCancellationData = function() {};
	Promise.prototype._propagateFrom = function (parent, flags) {
	    ;
	    ;
	};
	
	function cancellationExecute(executor, resolve, reject) {
	    var promise = this;
	    try {
	        executor(resolve, reject, function(onCancel) {
	            if (typeof onCancel !== "function") {
	                throw new TypeError("onCancel must be a function, got: " +
	                                    util.toString(onCancel));
	            }
	            promise._attachCancellationCallback(onCancel);
	        });
	    } catch (e) {
	        return e;
	    }
	}
	
	function cancellationAttachCancellationCallback(onCancel) {
	    if (!this.isCancellable()) return this;
	
	    var previousOnCancel = this._onCancel();
	    if (previousOnCancel !== undefined) {
	        if (util.isArray(previousOnCancel)) {
	            previousOnCancel.push(onCancel);
	        } else {
	            this._setOnCancel([previousOnCancel, onCancel]);
	        }
	    } else {
	        this._setOnCancel(onCancel);
	    }
	}
	
	function cancellationOnCancel() {
	    return this._onCancelField;
	}
	
	function cancellationSetOnCancel(onCancel) {
	    this._onCancelField = onCancel;
	}
	
	function cancellationClearCancellationData() {
	    this._cancellationParent = undefined;
	    this._onCancelField = undefined;
	}
	
	function cancellationPropagateFrom(parent, flags) {
	    if ((flags & 1) !== 0) {
	        this._cancellationParent = parent;
	        var branchesRemainingToCancel = parent._branchesRemainingToCancel;
	        if (branchesRemainingToCancel === undefined) {
	            branchesRemainingToCancel = 0;
	        }
	        parent._branchesRemainingToCancel = branchesRemainingToCancel + 1;
	    }
	    if ((flags & 2) !== 0 && parent._isBound()) {
	        this._setBoundTo(parent._boundTo);
	    }
	}
	
	function bindingPropagateFrom(parent, flags) {
	    if ((flags & 2) !== 0 && parent._isBound()) {
	        this._setBoundTo(parent._boundTo);
	    }
	}
	var propagateFromFunction = bindingPropagateFrom;
	
	function boundValueFunction() {
	    var ret = this._boundTo;
	    if (ret !== undefined) {
	        if (ret instanceof Promise) {
	            if (ret.isFulfilled()) {
	                return ret.value();
	            } else {
	                return undefined;
	            }
	        }
	    }
	    return ret;
	}
	
	function longStackTracesCaptureStackTrace() {
	    this._trace = new CapturedTrace(this._peekContext());
	}
	
	function longStackTracesAttachExtraTrace(error, ignoreSelf) {
	    if (canAttachTrace(error)) {
	        var trace = this._trace;
	        if (trace !== undefined) {
	            if (ignoreSelf) trace = trace._parent;
	        }
	        if (trace !== undefined) {
	            trace.attachExtraTrace(error);
	        } else if (!error.__stackCleaned__) {
	            var parsed = parseStackAndMessage(error);
	            util.notEnumerableProp(error, "stack",
	                parsed.message + "\n" + parsed.stack.join("\n"));
	            util.notEnumerableProp(error, "__stackCleaned__", true);
	        }
	    }
	}
	
	function checkForgottenReturns(returnValue, promiseCreated, name, promise,
	                               parent) {
	    if (returnValue === undefined && promiseCreated !== null &&
	        wForgottenReturn) {
	        if (parent !== undefined && parent._returnedNonUndefined()) return;
	        if ((promise._bitField & 65535) === 0) return;
	
	        if (name) name = name + " ";
	        var msg = "a promise was created in a " + name +
	            "handler but was not returned from it";
	        promise._warn(msg, true, promiseCreated);
	    }
	}
	
	function deprecated(name, replacement) {
	    var message = name +
	        " is deprecated and will be removed in a future version.";
	    if (replacement) message += " Use " + replacement + " instead.";
	    return warn(message);
	}
	
	function warn(message, shouldUseOwnTrace, promise) {
	    if (!config.warnings) return;
	    var warning = new Warning(message);
	    var ctx;
	    if (shouldUseOwnTrace) {
	        promise._attachExtraTrace(warning);
	    } else if (config.longStackTraces && (ctx = Promise._peekContext())) {
	        ctx.attachExtraTrace(warning);
	    } else {
	        var parsed = parseStackAndMessage(warning);
	        warning.stack = parsed.message + "\n" + parsed.stack.join("\n");
	    }
	
	    if (!activeFireEvent("warning", warning)) {
	        formatAndLogError(warning, "", true);
	    }
	}
	
	function reconstructStack(message, stacks) {
	    for (var i = 0; i < stacks.length - 1; ++i) {
	        stacks[i].push("From previous event:");
	        stacks[i] = stacks[i].join("\n");
	    }
	    if (i < stacks.length) {
	        stacks[i] = stacks[i].join("\n");
	    }
	    return message + "\n" + stacks.join("\n");
	}
	
	function removeDuplicateOrEmptyJumps(stacks) {
	    for (var i = 0; i < stacks.length; ++i) {
	        if (stacks[i].length === 0 ||
	            ((i + 1 < stacks.length) && stacks[i][0] === stacks[i+1][0])) {
	            stacks.splice(i, 1);
	            i--;
	        }
	    }
	}
	
	function removeCommonRoots(stacks) {
	    var current = stacks[0];
	    for (var i = 1; i < stacks.length; ++i) {
	        var prev = stacks[i];
	        var currentLastIndex = current.length - 1;
	        var currentLastLine = current[currentLastIndex];
	        var commonRootMeetPoint = -1;
	
	        for (var j = prev.length - 1; j >= 0; --j) {
	            if (prev[j] === currentLastLine) {
	                commonRootMeetPoint = j;
	                break;
	            }
	        }
	
	        for (var j = commonRootMeetPoint; j >= 0; --j) {
	            var line = prev[j];
	            if (current[currentLastIndex] === line) {
	                current.pop();
	                currentLastIndex--;
	            } else {
	                break;
	            }
	        }
	        current = prev;
	    }
	}
	
	function cleanStack(stack) {
	    var ret = [];
	    for (var i = 0; i < stack.length; ++i) {
	        var line = stack[i];
	        var isTraceLine = "    (No stack trace)" === line ||
	            stackFramePattern.test(line);
	        var isInternalFrame = isTraceLine && shouldIgnore(line);
	        if (isTraceLine && !isInternalFrame) {
	            if (indentStackFrames && line.charAt(0) !== " ") {
	                line = "    " + line;
	            }
	            ret.push(line);
	        }
	    }
	    return ret;
	}
	
	function stackFramesAsArray(error) {
	    var stack = error.stack.replace(/\s+$/g, "").split("\n");
	    for (var i = 0; i < stack.length; ++i) {
	        var line = stack[i];
	        if ("    (No stack trace)" === line || stackFramePattern.test(line)) {
	            break;
	        }
	    }
	    if (i > 0) {
	        stack = stack.slice(i);
	    }
	    return stack;
	}
	
	function parseStackAndMessage(error) {
	    var stack = error.stack;
	    var message = error.toString();
	    stack = typeof stack === "string" && stack.length > 0
	                ? stackFramesAsArray(error) : ["    (No stack trace)"];
	    return {
	        message: message,
	        stack: cleanStack(stack)
	    };
	}
	
	function formatAndLogError(error, title, isSoft) {
	    if (typeof console !== "undefined") {
	        var message;
	        if (util.isObject(error)) {
	            var stack = error.stack;
	            message = title + formatStack(stack, error);
	        } else {
	            message = title + String(error);
	        }
	        if (typeof printWarning === "function") {
	            printWarning(message, isSoft);
	        } else if (typeof console.log === "function" ||
	            typeof console.log === "object") {
	            console.log(message);
	        }
	    }
	}
	
	function fireRejectionEvent(name, localHandler, reason, promise) {
	    var localEventFired = false;
	    try {
	        if (typeof localHandler === "function") {
	            localEventFired = true;
	            if (name === "rejectionHandled") {
	                localHandler(promise);
	            } else {
	                localHandler(reason, promise);
	            }
	        }
	    } catch (e) {
	        async.throwLater(e);
	    }
	
	    if (name === "unhandledRejection") {
	        if (!activeFireEvent(name, reason, promise) && !localEventFired) {
	            formatAndLogError(reason, "Unhandled rejection ");
	        }
	    } else {
	        activeFireEvent(name, promise);
	    }
	}
	
	function formatNonError(obj) {
	    var str;
	    if (typeof obj === "function") {
	        str = "[function " +
	            (obj.name || "anonymous") +
	            "]";
	    } else {
	        str = obj && typeof obj.toString === "function"
	            ? obj.toString() : util.toString(obj);
	        var ruselessToString = /\[object [a-zA-Z0-9$_]+\]/;
	        if (ruselessToString.test(str)) {
	            try {
	                var newStr = JSON.stringify(obj);
	                str = newStr;
	            }
	            catch(e) {
	
	            }
	        }
	        if (str.length === 0) {
	            str = "(empty array)";
	        }
	    }
	    return ("(<" + snip(str) + ">, no stack trace)");
	}
	
	function snip(str) {
	    var maxChars = 41;
	    if (str.length < maxChars) {
	        return str;
	    }
	    return str.substr(0, maxChars - 3) + "...";
	}
	
	function longStackTracesIsSupported() {
	    return typeof captureStackTrace === "function";
	}
	
	var shouldIgnore = function() { return false; };
	var parseLineInfoRegex = /[\/<\(]([^:\/]+):(\d+):(?:\d+)\)?\s*$/;
	function parseLineInfo(line) {
	    var matches = line.match(parseLineInfoRegex);
	    if (matches) {
	        return {
	            fileName: matches[1],
	            line: parseInt(matches[2], 10)
	        };
	    }
	}
	
	function setBounds(firstLineError, lastLineError) {
	    if (!longStackTracesIsSupported()) return;
	    var firstStackLines = firstLineError.stack.split("\n");
	    var lastStackLines = lastLineError.stack.split("\n");
	    var firstIndex = -1;
	    var lastIndex = -1;
	    var firstFileName;
	    var lastFileName;
	    for (var i = 0; i < firstStackLines.length; ++i) {
	        var result = parseLineInfo(firstStackLines[i]);
	        if (result) {
	            firstFileName = result.fileName;
	            firstIndex = result.line;
	            break;
	        }
	    }
	    for (var i = 0; i < lastStackLines.length; ++i) {
	        var result = parseLineInfo(lastStackLines[i]);
	        if (result) {
	            lastFileName = result.fileName;
	            lastIndex = result.line;
	            break;
	        }
	    }
	    if (firstIndex < 0 || lastIndex < 0 || !firstFileName || !lastFileName ||
	        firstFileName !== lastFileName || firstIndex >= lastIndex) {
	        return;
	    }
	
	    shouldIgnore = function(line) {
	        if (bluebirdFramePattern.test(line)) return true;
	        var info = parseLineInfo(line);
	        if (info) {
	            if (info.fileName === firstFileName &&
	                (firstIndex <= info.line && info.line <= lastIndex)) {
	                return true;
	            }
	        }
	        return false;
	    };
	}
	
	function CapturedTrace(parent) {
	    this._parent = parent;
	    this._promisesCreated = 0;
	    var length = this._length = 1 + (parent === undefined ? 0 : parent._length);
	    captureStackTrace(this, CapturedTrace);
	    if (length > 32) this.uncycle();
	}
	util.inherits(CapturedTrace, Error);
	Context.CapturedTrace = CapturedTrace;
	
	CapturedTrace.prototype.uncycle = function() {
	    var length = this._length;
	    if (length < 2) return;
	    var nodes = [];
	    var stackToIndex = {};
	
	    for (var i = 0, node = this; node !== undefined; ++i) {
	        nodes.push(node);
	        node = node._parent;
	    }
	    length = this._length = i;
	    for (var i = length - 1; i >= 0; --i) {
	        var stack = nodes[i].stack;
	        if (stackToIndex[stack] === undefined) {
	            stackToIndex[stack] = i;
	        }
	    }
	    for (var i = 0; i < length; ++i) {
	        var currentStack = nodes[i].stack;
	        var index = stackToIndex[currentStack];
	        if (index !== undefined && index !== i) {
	            if (index > 0) {
	                nodes[index - 1]._parent = undefined;
	                nodes[index - 1]._length = 1;
	            }
	            nodes[i]._parent = undefined;
	            nodes[i]._length = 1;
	            var cycleEdgeNode = i > 0 ? nodes[i - 1] : this;
	
	            if (index < length - 1) {
	                cycleEdgeNode._parent = nodes[index + 1];
	                cycleEdgeNode._parent.uncycle();
	                cycleEdgeNode._length =
	                    cycleEdgeNode._parent._length + 1;
	            } else {
	                cycleEdgeNode._parent = undefined;
	                cycleEdgeNode._length = 1;
	            }
	            var currentChildLength = cycleEdgeNode._length + 1;
	            for (var j = i - 2; j >= 0; --j) {
	                nodes[j]._length = currentChildLength;
	                currentChildLength++;
	            }
	            return;
	        }
	    }
	};
	
	CapturedTrace.prototype.attachExtraTrace = function(error) {
	    if (error.__stackCleaned__) return;
	    this.uncycle();
	    var parsed = parseStackAndMessage(error);
	    var message = parsed.message;
	    var stacks = [parsed.stack];
	
	    var trace = this;
	    while (trace !== undefined) {
	        stacks.push(cleanStack(trace.stack.split("\n")));
	        trace = trace._parent;
	    }
	    removeCommonRoots(stacks);
	    removeDuplicateOrEmptyJumps(stacks);
	    util.notEnumerableProp(error, "stack", reconstructStack(message, stacks));
	    util.notEnumerableProp(error, "__stackCleaned__", true);
	};
	
	var captureStackTrace = (function stackDetection() {
	    var v8stackFramePattern = /^\s*at\s*/;
	    var v8stackFormatter = function(stack, error) {
	        if (typeof stack === "string") return stack;
	
	        if (error.name !== undefined &&
	            error.message !== undefined) {
	            return error.toString();
	        }
	        return formatNonError(error);
	    };
	
	    if (typeof Error.stackTraceLimit === "number" &&
	        typeof Error.captureStackTrace === "function") {
	        Error.stackTraceLimit += 6;
	        stackFramePattern = v8stackFramePattern;
	        formatStack = v8stackFormatter;
	        var captureStackTrace = Error.captureStackTrace;
	
	        shouldIgnore = function(line) {
	            return bluebirdFramePattern.test(line);
	        };
	        return function(receiver, ignoreUntil) {
	            Error.stackTraceLimit += 6;
	            captureStackTrace(receiver, ignoreUntil);
	            Error.stackTraceLimit -= 6;
	        };
	    }
	    var err = new Error();
	
	    if (typeof err.stack === "string" &&
	        err.stack.split("\n")[0].indexOf("stackDetection@") >= 0) {
	        stackFramePattern = /@/;
	        formatStack = v8stackFormatter;
	        indentStackFrames = true;
	        return function captureStackTrace(o) {
	            o.stack = new Error().stack;
	        };
	    }
	
	    var hasStackAfterThrow;
	    try { throw new Error(); }
	    catch(e) {
	        hasStackAfterThrow = ("stack" in e);
	    }
	    if (!("stack" in err) && hasStackAfterThrow &&
	        typeof Error.stackTraceLimit === "number") {
	        stackFramePattern = v8stackFramePattern;
	        formatStack = v8stackFormatter;
	        return function captureStackTrace(o) {
	            Error.stackTraceLimit += 6;
	            try { throw new Error(); }
	            catch(e) { o.stack = e.stack; }
	            Error.stackTraceLimit -= 6;
	        };
	    }
	
	    formatStack = function(stack, error) {
	        if (typeof stack === "string") return stack;
	
	        if ((typeof error === "object" ||
	            typeof error === "function") &&
	            error.name !== undefined &&
	            error.message !== undefined) {
	            return error.toString();
	        }
	        return formatNonError(error);
	    };
	
	    return null;
	
	})([]);
	
	if (typeof console !== "undefined" && typeof console.warn !== "undefined") {
	    printWarning = function (message) {
	        console.warn(message);
	    };
	    if (util.isNode && process.stderr.isTTY) {
	        printWarning = function(message, isSoft) {
	            var color = isSoft ? "\u001b[33m" : "\u001b[31m";
	            console.warn(color + message + "\u001b[0m\n");
	        };
	    } else if (!util.isNode && typeof (new Error().stack) === "string") {
	        printWarning = function(message, isSoft) {
	            console.warn("%c" + message,
	                        isSoft ? "color: darkorange" : "color: red");
	        };
	    }
	}
	
	var config = {
	    warnings: warnings,
	    longStackTraces: false,
	    cancellation: false,
	    monitoring: false
	};
	
	if (longStackTraces) Promise.longStackTraces();
	
	return {
	    longStackTraces: function() {
	        return config.longStackTraces;
	    },
	    warnings: function() {
	        return config.warnings;
	    },
	    cancellation: function() {
	        return config.cancellation;
	    },
	    monitoring: function() {
	        return config.monitoring;
	    },
	    propagateFromFunction: function() {
	        return propagateFromFunction;
	    },
	    boundValueFunction: function() {
	        return boundValueFunction;
	    },
	    checkForgottenReturns: checkForgottenReturns,
	    setBounds: setBounds,
	    warn: warn,
	    deprecated: deprecated,
	    CapturedTrace: CapturedTrace,
	    fireDomEvent: fireDomEvent,
	    fireGlobalEvent: fireGlobalEvent
	};
	};
	
	},{"./errors":12,"./util":36}],10:[function(_dereq_,module,exports){
	"use strict";
	module.exports = function(Promise) {
	function returner() {
	    return this.value;
	}
	function thrower() {
	    throw this.reason;
	}
	
	Promise.prototype["return"] =
	Promise.prototype.thenReturn = function (value) {
	    if (value instanceof Promise) value.suppressUnhandledRejections();
	    return this._then(
	        returner, undefined, undefined, {value: value}, undefined);
	};
	
	Promise.prototype["throw"] =
	Promise.prototype.thenThrow = function (reason) {
	    return this._then(
	        thrower, undefined, undefined, {reason: reason}, undefined);
	};
	
	Promise.prototype.catchThrow = function (reason) {
	    if (arguments.length <= 1) {
	        return this._then(
	            undefined, thrower, undefined, {reason: reason}, undefined);
	    } else {
	        var _reason = arguments[1];
	        var handler = function() {throw _reason;};
	        return this.caught(reason, handler);
	    }
	};
	
	Promise.prototype.catchReturn = function (value) {
	    if (arguments.length <= 1) {
	        if (value instanceof Promise) value.suppressUnhandledRejections();
	        return this._then(
	            undefined, returner, undefined, {value: value}, undefined);
	    } else {
	        var _value = arguments[1];
	        if (_value instanceof Promise) _value.suppressUnhandledRejections();
	        var handler = function() {return _value;};
	        return this.caught(value, handler);
	    }
	};
	};
	
	},{}],11:[function(_dereq_,module,exports){
	"use strict";
	module.exports = function(Promise, INTERNAL) {
	var PromiseReduce = Promise.reduce;
	var PromiseAll = Promise.all;
	
	function promiseAllThis() {
	    return PromiseAll(this);
	}
	
	function PromiseMapSeries(promises, fn) {
	    return PromiseReduce(promises, fn, INTERNAL, INTERNAL);
	}
	
	Promise.prototype.each = function (fn) {
	    return this.mapSeries(fn)
	            ._then(promiseAllThis, undefined, undefined, this, undefined);
	};
	
	Promise.prototype.mapSeries = function (fn) {
	    return PromiseReduce(this, fn, INTERNAL, INTERNAL);
	};
	
	Promise.each = function (promises, fn) {
	    return PromiseMapSeries(promises, fn)
	            ._then(promiseAllThis, undefined, undefined, promises, undefined);
	};
	
	Promise.mapSeries = PromiseMapSeries;
	};
	
	},{}],12:[function(_dereq_,module,exports){
	"use strict";
	var es5 = _dereq_("./es5");
	var Objectfreeze = es5.freeze;
	var util = _dereq_("./util");
	var inherits = util.inherits;
	var notEnumerableProp = util.notEnumerableProp;
	
	function subError(nameProperty, defaultMessage) {
	    function SubError(message) {
	        if (!(this instanceof SubError)) return new SubError(message);
	        notEnumerableProp(this, "message",
	            typeof message === "string" ? message : defaultMessage);
	        notEnumerableProp(this, "name", nameProperty);
	        if (Error.captureStackTrace) {
	            Error.captureStackTrace(this, this.constructor);
	        } else {
	            Error.call(this);
	        }
	    }
	    inherits(SubError, Error);
	    return SubError;
	}
	
	var _TypeError, _RangeError;
	var Warning = subError("Warning", "warning");
	var CancellationError = subError("CancellationError", "cancellation error");
	var TimeoutError = subError("TimeoutError", "timeout error");
	var AggregateError = subError("AggregateError", "aggregate error");
	try {
	    _TypeError = TypeError;
	    _RangeError = RangeError;
	} catch(e) {
	    _TypeError = subError("TypeError", "type error");
	    _RangeError = subError("RangeError", "range error");
	}
	
	var methods = ("join pop push shift unshift slice filter forEach some " +
	    "every map indexOf lastIndexOf reduce reduceRight sort reverse").split(" ");
	
	for (var i = 0; i < methods.length; ++i) {
	    if (typeof Array.prototype[methods[i]] === "function") {
	        AggregateError.prototype[methods[i]] = Array.prototype[methods[i]];
	    }
	}
	
	es5.defineProperty(AggregateError.prototype, "length", {
	    value: 0,
	    configurable: false,
	    writable: true,
	    enumerable: true
	});
	AggregateError.prototype["isOperational"] = true;
	var level = 0;
	AggregateError.prototype.toString = function() {
	    var indent = Array(level * 4 + 1).join(" ");
	    var ret = "\n" + indent + "AggregateError of:" + "\n";
	    level++;
	    indent = Array(level * 4 + 1).join(" ");
	    for (var i = 0; i < this.length; ++i) {
	        var str = this[i] === this ? "[Circular AggregateError]" : this[i] + "";
	        var lines = str.split("\n");
	        for (var j = 0; j < lines.length; ++j) {
	            lines[j] = indent + lines[j];
	        }
	        str = lines.join("\n");
	        ret += str + "\n";
	    }
	    level--;
	    return ret;
	};
	
	function OperationalError(message) {
	    if (!(this instanceof OperationalError))
	        return new OperationalError(message);
	    notEnumerableProp(this, "name", "OperationalError");
	    notEnumerableProp(this, "message", message);
	    this.cause = message;
	    this["isOperational"] = true;
	
	    if (message instanceof Error) {
	        notEnumerableProp(this, "message", message.message);
	        notEnumerableProp(this, "stack", message.stack);
	    } else if (Error.captureStackTrace) {
	        Error.captureStackTrace(this, this.constructor);
	    }
	
	}
	inherits(OperationalError, Error);
	
	var errorTypes = Error["__BluebirdErrorTypes__"];
	if (!errorTypes) {
	    errorTypes = Objectfreeze({
	        CancellationError: CancellationError,
	        TimeoutError: TimeoutError,
	        OperationalError: OperationalError,
	        RejectionError: OperationalError,
	        AggregateError: AggregateError
	    });
	    es5.defineProperty(Error, "__BluebirdErrorTypes__", {
	        value: errorTypes,
	        writable: false,
	        enumerable: false,
	        configurable: false
	    });
	}
	
	module.exports = {
	    Error: Error,
	    TypeError: _TypeError,
	    RangeError: _RangeError,
	    CancellationError: errorTypes.CancellationError,
	    OperationalError: errorTypes.OperationalError,
	    TimeoutError: errorTypes.TimeoutError,
	    AggregateError: errorTypes.AggregateError,
	    Warning: Warning
	};
	
	},{"./es5":13,"./util":36}],13:[function(_dereq_,module,exports){
	var isES5 = (function(){
	    "use strict";
	    return this === undefined;
	})();
	
	if (isES5) {
	    module.exports = {
	        freeze: Object.freeze,
	        defineProperty: Object.defineProperty,
	        getDescriptor: Object.getOwnPropertyDescriptor,
	        keys: Object.keys,
	        names: Object.getOwnPropertyNames,
	        getPrototypeOf: Object.getPrototypeOf,
	        isArray: Array.isArray,
	        isES5: isES5,
	        propertyIsWritable: function(obj, prop) {
	            var descriptor = Object.getOwnPropertyDescriptor(obj, prop);
	            return !!(!descriptor || descriptor.writable || descriptor.set);
	        }
	    };
	} else {
	    var has = {}.hasOwnProperty;
	    var str = {}.toString;
	    var proto = {}.constructor.prototype;
	
	    var ObjectKeys = function (o) {
	        var ret = [];
	        for (var key in o) {
	            if (has.call(o, key)) {
	                ret.push(key);
	            }
	        }
	        return ret;
	    };
	
	    var ObjectGetDescriptor = function(o, key) {
	        return {value: o[key]};
	    };
	
	    var ObjectDefineProperty = function (o, key, desc) {
	        o[key] = desc.value;
	        return o;
	    };
	
	    var ObjectFreeze = function (obj) {
	        return obj;
	    };
	
	    var ObjectGetPrototypeOf = function (obj) {
	        try {
	            return Object(obj).constructor.prototype;
	        }
	        catch (e) {
	            return proto;
	        }
	    };
	
	    var ArrayIsArray = function (obj) {
	        try {
	            return str.call(obj) === "[object Array]";
	        }
	        catch(e) {
	            return false;
	        }
	    };
	
	    module.exports = {
	        isArray: ArrayIsArray,
	        keys: ObjectKeys,
	        names: ObjectKeys,
	        defineProperty: ObjectDefineProperty,
	        getDescriptor: ObjectGetDescriptor,
	        freeze: ObjectFreeze,
	        getPrototypeOf: ObjectGetPrototypeOf,
	        isES5: isES5,
	        propertyIsWritable: function() {
	            return true;
	        }
	    };
	}
	
	},{}],14:[function(_dereq_,module,exports){
	"use strict";
	module.exports = function(Promise, INTERNAL) {
	var PromiseMap = Promise.map;
	
	Promise.prototype.filter = function (fn, options) {
	    return PromiseMap(this, fn, options, INTERNAL);
	};
	
	Promise.filter = function (promises, fn, options) {
	    return PromiseMap(promises, fn, options, INTERNAL);
	};
	};
	
	},{}],15:[function(_dereq_,module,exports){
	"use strict";
	module.exports = function(Promise, tryConvertToPromise) {
	var util = _dereq_("./util");
	var CancellationError = Promise.CancellationError;
	var errorObj = util.errorObj;
	
	function PassThroughHandlerContext(promise, type, handler) {
	    this.promise = promise;
	    this.type = type;
	    this.handler = handler;
	    this.called = false;
	    this.cancelPromise = null;
	}
	
	PassThroughHandlerContext.prototype.isFinallyHandler = function() {
	    return this.type === 0;
	};
	
	function FinallyHandlerCancelReaction(finallyHandler) {
	    this.finallyHandler = finallyHandler;
	}
	
	FinallyHandlerCancelReaction.prototype._resultCancelled = function() {
	    checkCancel(this.finallyHandler);
	};
	
	function checkCancel(ctx, reason) {
	    if (ctx.cancelPromise != null) {
	        if (arguments.length > 1) {
	            ctx.cancelPromise._reject(reason);
	        } else {
	            ctx.cancelPromise._cancel();
	        }
	        ctx.cancelPromise = null;
	        return true;
	    }
	    return false;
	}
	
	function succeed() {
	    return finallyHandler.call(this, this.promise._target()._settledValue());
	}
	function fail(reason) {
	    if (checkCancel(this, reason)) return;
	    errorObj.e = reason;
	    return errorObj;
	}
	function finallyHandler(reasonOrValue) {
	    var promise = this.promise;
	    var handler = this.handler;
	
	    if (!this.called) {
	        this.called = true;
	        var ret = this.isFinallyHandler()
	            ? handler.call(promise._boundValue())
	            : handler.call(promise._boundValue(), reasonOrValue);
	        if (ret !== undefined) {
	            promise._setReturnedNonUndefined();
	            var maybePromise = tryConvertToPromise(ret, promise);
	            if (maybePromise instanceof Promise) {
	                if (this.cancelPromise != null) {
	                    if (maybePromise.isCancelled()) {
	                        var reason =
	                            new CancellationError("late cancellation observer");
	                        promise._attachExtraTrace(reason);
	                        errorObj.e = reason;
	                        return errorObj;
	                    } else if (maybePromise.isPending()) {
	                        maybePromise._attachCancellationCallback(
	                            new FinallyHandlerCancelReaction(this));
	                    }
	                }
	                return maybePromise._then(
	                    succeed, fail, undefined, this, undefined);
	            }
	        }
	    }
	
	    if (promise.isRejected()) {
	        checkCancel(this);
	        errorObj.e = reasonOrValue;
	        return errorObj;
	    } else {
	        checkCancel(this);
	        return reasonOrValue;
	    }
	}
	
	Promise.prototype._passThrough = function(handler, type, success, fail) {
	    if (typeof handler !== "function") return this.then();
	    return this._then(success,
	                      fail,
	                      undefined,
	                      new PassThroughHandlerContext(this, type, handler),
	                      undefined);
	};
	
	Promise.prototype.lastly =
	Promise.prototype["finally"] = function (handler) {
	    return this._passThrough(handler,
	                             0,
	                             finallyHandler,
	                             finallyHandler);
	};
	
	Promise.prototype.tap = function (handler) {
	    return this._passThrough(handler, 1, finallyHandler);
	};
	
	return PassThroughHandlerContext;
	};
	
	},{"./util":36}],16:[function(_dereq_,module,exports){
	"use strict";
	module.exports = function(Promise,
	                          apiRejection,
	                          INTERNAL,
	                          tryConvertToPromise,
	                          Proxyable,
	                          debug) {
	var errors = _dereq_("./errors");
	var TypeError = errors.TypeError;
	var util = _dereq_("./util");
	var errorObj = util.errorObj;
	var tryCatch = util.tryCatch;
	var yieldHandlers = [];
	
	function promiseFromYieldHandler(value, yieldHandlers, traceParent) {
	    for (var i = 0; i < yieldHandlers.length; ++i) {
	        traceParent._pushContext();
	        var result = tryCatch(yieldHandlers[i])(value);
	        traceParent._popContext();
	        if (result === errorObj) {
	            traceParent._pushContext();
	            var ret = Promise.reject(errorObj.e);
	            traceParent._popContext();
	            return ret;
	        }
	        var maybePromise = tryConvertToPromise(result, traceParent);
	        if (maybePromise instanceof Promise) return maybePromise;
	    }
	    return null;
	}
	
	function PromiseSpawn(generatorFunction, receiver, yieldHandler, stack) {
	    if (debug.cancellation()) {
	        var internal = new Promise(INTERNAL);
	        var _finallyPromise = this._finallyPromise = new Promise(INTERNAL);
	        this._promise = internal.lastly(function() {
	            return _finallyPromise;
	        });
	        internal._captureStackTrace();
	        internal._setOnCancel(this);
	    } else {
	        var promise = this._promise = new Promise(INTERNAL);
	        promise._captureStackTrace();
	    }
	    this._stack = stack;
	    this._generatorFunction = generatorFunction;
	    this._receiver = receiver;
	    this._generator = undefined;
	    this._yieldHandlers = typeof yieldHandler === "function"
	        ? [yieldHandler].concat(yieldHandlers)
	        : yieldHandlers;
	    this._yieldedPromise = null;
	    this._cancellationPhase = false;
	}
	util.inherits(PromiseSpawn, Proxyable);
	
	PromiseSpawn.prototype._isResolved = function() {
	    return this._promise === null;
	};
	
	PromiseSpawn.prototype._cleanup = function() {
	    this._promise = this._generator = null;
	    if (debug.cancellation() && this._finallyPromise !== null) {
	        this._finallyPromise._fulfill();
	        this._finallyPromise = null;
	    }
	};
	
	PromiseSpawn.prototype._promiseCancelled = function() {
	    if (this._isResolved()) return;
	    var implementsReturn = typeof this._generator["return"] !== "undefined";
	
	    var result;
	    if (!implementsReturn) {
	        var reason = new Promise.CancellationError(
	            "generator .return() sentinel");
	        Promise.coroutine.returnSentinel = reason;
	        this._promise._attachExtraTrace(reason);
	        this._promise._pushContext();
	        result = tryCatch(this._generator["throw"]).call(this._generator,
	                                                         reason);
	        this._promise._popContext();
	    } else {
	        this._promise._pushContext();
	        result = tryCatch(this._generator["return"]).call(this._generator,
	                                                          undefined);
	        this._promise._popContext();
	    }
	    this._cancellationPhase = true;
	    this._yieldedPromise = null;
	    this._continue(result);
	};
	
	PromiseSpawn.prototype._promiseFulfilled = function(value) {
	    this._yieldedPromise = null;
	    this._promise._pushContext();
	    var result = tryCatch(this._generator.next).call(this._generator, value);
	    this._promise._popContext();
	    this._continue(result);
	};
	
	PromiseSpawn.prototype._promiseRejected = function(reason) {
	    this._yieldedPromise = null;
	    this._promise._attachExtraTrace(reason);
	    this._promise._pushContext();
	    var result = tryCatch(this._generator["throw"])
	        .call(this._generator, reason);
	    this._promise._popContext();
	    this._continue(result);
	};
	
	PromiseSpawn.prototype._resultCancelled = function() {
	    if (this._yieldedPromise instanceof Promise) {
	        var promise = this._yieldedPromise;
	        this._yieldedPromise = null;
	        promise.cancel();
	    }
	};
	
	PromiseSpawn.prototype.promise = function () {
	    return this._promise;
	};
	
	PromiseSpawn.prototype._run = function () {
	    this._generator = this._generatorFunction.call(this._receiver);
	    this._receiver =
	        this._generatorFunction = undefined;
	    this._promiseFulfilled(undefined);
	};
	
	PromiseSpawn.prototype._continue = function (result) {
	    var promise = this._promise;
	    if (result === errorObj) {
	        this._cleanup();
	        if (this._cancellationPhase) {
	            return promise.cancel();
	        } else {
	            return promise._rejectCallback(result.e, false);
	        }
	    }
	
	    var value = result.value;
	    if (result.done === true) {
	        this._cleanup();
	        if (this._cancellationPhase) {
	            return promise.cancel();
	        } else {
	            return promise._resolveCallback(value);
	        }
	    } else {
	        var maybePromise = tryConvertToPromise(value, this._promise);
	        if (!(maybePromise instanceof Promise)) {
	            maybePromise =
	                promiseFromYieldHandler(maybePromise,
	                                        this._yieldHandlers,
	                                        this._promise);
	            if (maybePromise === null) {
	                this._promiseRejected(
	                    new TypeError(
	                        "A value %s was yielded that could not be treated as a promise\u000a\u000a    See http://goo.gl/MqrFmX\u000a\u000a".replace("%s", value) +
	                        "From coroutine:\u000a" +
	                        this._stack.split("\n").slice(1, -7).join("\n")
	                    )
	                );
	                return;
	            }
	        }
	        maybePromise = maybePromise._target();
	        var bitField = maybePromise._bitField;
	        ;
	        if (((bitField & 50397184) === 0)) {
	            this._yieldedPromise = maybePromise;
	            maybePromise._proxy(this, null);
	        } else if (((bitField & 33554432) !== 0)) {
	            this._promiseFulfilled(maybePromise._value());
	        } else if (((bitField & 16777216) !== 0)) {
	            this._promiseRejected(maybePromise._reason());
	        } else {
	            this._promiseCancelled();
	        }
	    }
	};
	
	Promise.coroutine = function (generatorFunction, options) {
	    if (typeof generatorFunction !== "function") {
	        throw new TypeError("generatorFunction must be a function\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
	    }
	    var yieldHandler = Object(options).yieldHandler;
	    var PromiseSpawn$ = PromiseSpawn;
	    var stack = new Error().stack;
	    return function () {
	        var generator = generatorFunction.apply(this, arguments);
	        var spawn = new PromiseSpawn$(undefined, undefined, yieldHandler,
	                                      stack);
	        var ret = spawn.promise();
	        spawn._generator = generator;
	        spawn._promiseFulfilled(undefined);
	        return ret;
	    };
	};
	
	Promise.coroutine.addYieldHandler = function(fn) {
	    if (typeof fn !== "function") {
	        throw new TypeError("expecting a function but got " + util.classString(fn));
	    }
	    yieldHandlers.push(fn);
	};
	
	Promise.spawn = function (generatorFunction) {
	    debug.deprecated("Promise.spawn()", "Promise.coroutine()");
	    if (typeof generatorFunction !== "function") {
	        return apiRejection("generatorFunction must be a function\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
	    }
	    var spawn = new PromiseSpawn(generatorFunction, this);
	    var ret = spawn.promise();
	    spawn._run(Promise.spawn);
	    return ret;
	};
	};
	
	},{"./errors":12,"./util":36}],17:[function(_dereq_,module,exports){
	"use strict";
	module.exports =
	function(Promise, PromiseArray, tryConvertToPromise, INTERNAL) {
	var util = _dereq_("./util");
	var canEvaluate = util.canEvaluate;
	var tryCatch = util.tryCatch;
	var errorObj = util.errorObj;
	var reject;
	
	if (false) {
	if (canEvaluate) {
	    var thenCallback = function(i) {
	        return new Function("value", "holder", "                             \n\
	            'use strict';                                                    \n\
	            holder.pIndex = value;                                           \n\
	            holder.checkFulfillment(this);                                   \n\
	            ".replace(/Index/g, i));
	    };
	
	    var promiseSetter = function(i) {
	        return new Function("promise", "holder", "                           \n\
	            'use strict';                                                    \n\
	            holder.pIndex = promise;                                         \n\
	            ".replace(/Index/g, i));
	    };
	
	    var generateHolderClass = function(total) {
	        var props = new Array(total);
	        for (var i = 0; i < props.length; ++i) {
	            props[i] = "this.p" + (i+1);
	        }
	        var assignment = props.join(" = ") + " = null;";
	        var cancellationCode= "var promise;\n" + props.map(function(prop) {
	            return "                                                         \n\
	                promise = " + prop + ";                                      \n\
	                if (promise instanceof Promise) {                            \n\
	                    promise.cancel();                                        \n\
	                }                                                            \n\
	            ";
	        }).join("\n");
	        var passedArguments = props.join(", ");
	        var name = "Holder$" + total;
	
	
	        var code = "return function(tryCatch, errorObj, Promise) {           \n\
	            'use strict';                                                    \n\
	            function [TheName](fn) {                                         \n\
	                [TheProperties]                                              \n\
	                this.fn = fn;                                                \n\
	                this.now = 0;                                                \n\
	            }                                                                \n\
	            [TheName].prototype.checkFulfillment = function(promise) {       \n\
	                var now = ++this.now;                                        \n\
	                if (now === [TheTotal]) {                                    \n\
	                    promise._pushContext();                                  \n\
	                    var callback = this.fn;                                  \n\
	                    var ret = tryCatch(callback)([ThePassedArguments]);      \n\
	                    promise._popContext();                                   \n\
	                    if (ret === errorObj) {                                  \n\
	                        promise._rejectCallback(ret.e, false);               \n\
	                    } else {                                                 \n\
	                        promise._resolveCallback(ret);                       \n\
	                    }                                                        \n\
	                }                                                            \n\
	            };                                                               \n\
	                                                                             \n\
	            [TheName].prototype._resultCancelled = function() {              \n\
	                [CancellationCode]                                           \n\
	            };                                                               \n\
	                                                                             \n\
	            return [TheName];                                                \n\
	        }(tryCatch, errorObj, Promise);                                      \n\
	        ";
	
	        code = code.replace(/\[TheName\]/g, name)
	            .replace(/\[TheTotal\]/g, total)
	            .replace(/\[ThePassedArguments\]/g, passedArguments)
	            .replace(/\[TheProperties\]/g, assignment)
	            .replace(/\[CancellationCode\]/g, cancellationCode);
	
	        return new Function("tryCatch", "errorObj", "Promise", code)
	                           (tryCatch, errorObj, Promise);
	    };
	
	    var holderClasses = [];
	    var thenCallbacks = [];
	    var promiseSetters = [];
	
	    for (var i = 0; i < 8; ++i) {
	        holderClasses.push(generateHolderClass(i + 1));
	        thenCallbacks.push(thenCallback(i + 1));
	        promiseSetters.push(promiseSetter(i + 1));
	    }
	
	    reject = function (reason) {
	        this._reject(reason);
	    };
	}}
	
	Promise.join = function () {
	    var last = arguments.length - 1;
	    var fn;
	    if (last > 0 && typeof arguments[last] === "function") {
	        fn = arguments[last];
	        if (false) {
	            if (last <= 8 && canEvaluate) {
	                var ret = new Promise(INTERNAL);
	                ret._captureStackTrace();
	                var HolderClass = holderClasses[last - 1];
	                var holder = new HolderClass(fn);
	                var callbacks = thenCallbacks;
	
	                for (var i = 0; i < last; ++i) {
	                    var maybePromise = tryConvertToPromise(arguments[i], ret);
	                    if (maybePromise instanceof Promise) {
	                        maybePromise = maybePromise._target();
	                        var bitField = maybePromise._bitField;
	                        ;
	                        if (((bitField & 50397184) === 0)) {
	                            maybePromise._then(callbacks[i], reject,
	                                               undefined, ret, holder);
	                            promiseSetters[i](maybePromise, holder);
	                        } else if (((bitField & 33554432) !== 0)) {
	                            callbacks[i].call(ret,
	                                              maybePromise._value(), holder);
	                        } else if (((bitField & 16777216) !== 0)) {
	                            ret._reject(maybePromise._reason());
	                        } else {
	                            ret._cancel();
	                        }
	                    } else {
	                        callbacks[i].call(ret, maybePromise, holder);
	                    }
	                }
	                if (!ret._isFateSealed()) {
	                    ret._setAsyncGuaranteed();
	                    ret._setOnCancel(holder);
	                }
	                return ret;
	            }
	        }
	    }
	    var args = [].slice.call(arguments);;
	    if (fn) args.pop();
	    var ret = new PromiseArray(args).promise();
	    return fn !== undefined ? ret.spread(fn) : ret;
	};
	
	};
	
	},{"./util":36}],18:[function(_dereq_,module,exports){
	"use strict";
	module.exports = function(Promise,
	                          PromiseArray,
	                          apiRejection,
	                          tryConvertToPromise,
	                          INTERNAL,
	                          debug) {
	var getDomain = Promise._getDomain;
	var util = _dereq_("./util");
	var tryCatch = util.tryCatch;
	var errorObj = util.errorObj;
	var EMPTY_ARRAY = [];
	
	function MappingPromiseArray(promises, fn, limit, _filter) {
	    this.constructor$(promises);
	    this._promise._captureStackTrace();
	    var domain = getDomain();
	    this._callback = domain === null ? fn : domain.bind(fn);
	    this._preservedValues = _filter === INTERNAL
	        ? new Array(this.length())
	        : null;
	    this._limit = limit;
	    this._inFlight = 0;
	    this._queue = limit >= 1 ? [] : EMPTY_ARRAY;
	    this._init$(undefined, -2);
	}
	util.inherits(MappingPromiseArray, PromiseArray);
	
	MappingPromiseArray.prototype._init = function () {};
	
	MappingPromiseArray.prototype._promiseFulfilled = function (value, index) {
	    var values = this._values;
	    var length = this.length();
	    var preservedValues = this._preservedValues;
	    var limit = this._limit;
	
	    if (index < 0) {
	        index = (index * -1) - 1;
	        values[index] = value;
	        if (limit >= 1) {
	            this._inFlight--;
	            this._drainQueue();
	            if (this._isResolved()) return true;
	        }
	    } else {
	        if (limit >= 1 && this._inFlight >= limit) {
	            values[index] = value;
	            this._queue.push(index);
	            return false;
	        }
	        if (preservedValues !== null) preservedValues[index] = value;
	
	        var promise = this._promise;
	        var callback = this._callback;
	        var receiver = promise._boundValue();
	        promise._pushContext();
	        var ret = tryCatch(callback).call(receiver, value, index, length);
	        var promiseCreated = promise._popContext();
	        debug.checkForgottenReturns(
	            ret,
	            promiseCreated,
	            preservedValues !== null ? "Promise.filter" : "Promise.map",
	            promise
	        );
	        if (ret === errorObj) {
	            this._reject(ret.e);
	            return true;
	        }
	
	        var maybePromise = tryConvertToPromise(ret, this._promise);
	        if (maybePromise instanceof Promise) {
	            maybePromise = maybePromise._target();
	            var bitField = maybePromise._bitField;
	            ;
	            if (((bitField & 50397184) === 0)) {
	                if (limit >= 1) this._inFlight++;
	                values[index] = maybePromise;
	                maybePromise._proxy(this, (index + 1) * -1);
	                return false;
	            } else if (((bitField & 33554432) !== 0)) {
	                ret = maybePromise._value();
	            } else if (((bitField & 16777216) !== 0)) {
	                this._reject(maybePromise._reason());
	                return true;
	            } else {
	                this._cancel();
	                return true;
	            }
	        }
	        values[index] = ret;
	    }
	    var totalResolved = ++this._totalResolved;
	    if (totalResolved >= length) {
	        if (preservedValues !== null) {
	            this._filter(values, preservedValues);
	        } else {
	            this._resolve(values);
	        }
	        return true;
	    }
	    return false;
	};
	
	MappingPromiseArray.prototype._drainQueue = function () {
	    var queue = this._queue;
	    var limit = this._limit;
	    var values = this._values;
	    while (queue.length > 0 && this._inFlight < limit) {
	        if (this._isResolved()) return;
	        var index = queue.pop();
	        this._promiseFulfilled(values[index], index);
	    }
	};
	
	MappingPromiseArray.prototype._filter = function (booleans, values) {
	    var len = values.length;
	    var ret = new Array(len);
	    var j = 0;
	    for (var i = 0; i < len; ++i) {
	        if (booleans[i]) ret[j++] = values[i];
	    }
	    ret.length = j;
	    this._resolve(ret);
	};
	
	MappingPromiseArray.prototype.preservedValues = function () {
	    return this._preservedValues;
	};
	
	function map(promises, fn, options, _filter) {
	    if (typeof fn !== "function") {
	        return apiRejection("expecting a function but got " + util.classString(fn));
	    }
	
	    var limit = 0;
	    if (options !== undefined) {
	        if (typeof options === "object" && options !== null) {
	            if (typeof options.concurrency !== "number") {
	                return Promise.reject(
	                    new TypeError("'concurrency' must be a number but it is " +
	                                    util.classString(options.concurrency)));
	            }
	            limit = options.concurrency;
	        } else {
	            return Promise.reject(new TypeError(
	                            "options argument must be an object but it is " +
	                             util.classString(options)));
	        }
	    }
	    limit = typeof limit === "number" &&
	        isFinite(limit) && limit >= 1 ? limit : 0;
	    return new MappingPromiseArray(promises, fn, limit, _filter).promise();
	}
	
	Promise.prototype.map = function (fn, options) {
	    return map(this, fn, options, null);
	};
	
	Promise.map = function (promises, fn, options, _filter) {
	    return map(promises, fn, options, _filter);
	};
	
	
	};
	
	},{"./util":36}],19:[function(_dereq_,module,exports){
	"use strict";
	module.exports =
	function(Promise, INTERNAL, tryConvertToPromise, apiRejection, debug) {
	var util = _dereq_("./util");
	var tryCatch = util.tryCatch;
	
	Promise.method = function (fn) {
	    if (typeof fn !== "function") {
	        throw new Promise.TypeError("expecting a function but got " + util.classString(fn));
	    }
	    return function () {
	        var ret = new Promise(INTERNAL);
	        ret._captureStackTrace();
	        ret._pushContext();
	        var value = tryCatch(fn).apply(this, arguments);
	        var promiseCreated = ret._popContext();
	        debug.checkForgottenReturns(
	            value, promiseCreated, "Promise.method", ret);
	        ret._resolveFromSyncValue(value);
	        return ret;
	    };
	};
	
	Promise.attempt = Promise["try"] = function (fn) {
	    if (typeof fn !== "function") {
	        return apiRejection("expecting a function but got " + util.classString(fn));
	    }
	    var ret = new Promise(INTERNAL);
	    ret._captureStackTrace();
	    ret._pushContext();
	    var value;
	    if (arguments.length > 1) {
	        debug.deprecated("calling Promise.try with more than 1 argument");
	        var arg = arguments[1];
	        var ctx = arguments[2];
	        value = util.isArray(arg) ? tryCatch(fn).apply(ctx, arg)
	                                  : tryCatch(fn).call(ctx, arg);
	    } else {
	        value = tryCatch(fn)();
	    }
	    var promiseCreated = ret._popContext();
	    debug.checkForgottenReturns(
	        value, promiseCreated, "Promise.try", ret);
	    ret._resolveFromSyncValue(value);
	    return ret;
	};
	
	Promise.prototype._resolveFromSyncValue = function (value) {
	    if (value === util.errorObj) {
	        this._rejectCallback(value.e, false);
	    } else {
	        this._resolveCallback(value, true);
	    }
	};
	};
	
	},{"./util":36}],20:[function(_dereq_,module,exports){
	"use strict";
	var util = _dereq_("./util");
	var maybeWrapAsError = util.maybeWrapAsError;
	var errors = _dereq_("./errors");
	var OperationalError = errors.OperationalError;
	var es5 = _dereq_("./es5");
	
	function isUntypedError(obj) {
	    return obj instanceof Error &&
	        es5.getPrototypeOf(obj) === Error.prototype;
	}
	
	var rErrorKey = /^(?:name|message|stack|cause)$/;
	function wrapAsOperationalError(obj) {
	    var ret;
	    if (isUntypedError(obj)) {
	        ret = new OperationalError(obj);
	        ret.name = obj.name;
	        ret.message = obj.message;
	        ret.stack = obj.stack;
	        var keys = es5.keys(obj);
	        for (var i = 0; i < keys.length; ++i) {
	            var key = keys[i];
	            if (!rErrorKey.test(key)) {
	                ret[key] = obj[key];
	            }
	        }
	        return ret;
	    }
	    util.markAsOriginatingFromRejection(obj);
	    return obj;
	}
	
	function nodebackForPromise(promise, multiArgs) {
	    return function(err, value) {
	        if (promise === null) return;
	        if (err) {
	            var wrapped = wrapAsOperationalError(maybeWrapAsError(err));
	            promise._attachExtraTrace(wrapped);
	            promise._reject(wrapped);
	        } else if (!multiArgs) {
	            promise._fulfill(value);
	        } else {
	            var args = [].slice.call(arguments, 1);;
	            promise._fulfill(args);
	        }
	        promise = null;
	    };
	}
	
	module.exports = nodebackForPromise;
	
	},{"./errors":12,"./es5":13,"./util":36}],21:[function(_dereq_,module,exports){
	"use strict";
	module.exports = function(Promise) {
	var util = _dereq_("./util");
	var async = Promise._async;
	var tryCatch = util.tryCatch;
	var errorObj = util.errorObj;
	
	function spreadAdapter(val, nodeback) {
	    var promise = this;
	    if (!util.isArray(val)) return successAdapter.call(promise, val, nodeback);
	    var ret =
	        tryCatch(nodeback).apply(promise._boundValue(), [null].concat(val));
	    if (ret === errorObj) {
	        async.throwLater(ret.e);
	    }
	}
	
	function successAdapter(val, nodeback) {
	    var promise = this;
	    var receiver = promise._boundValue();
	    var ret = val === undefined
	        ? tryCatch(nodeback).call(receiver, null)
	        : tryCatch(nodeback).call(receiver, null, val);
	    if (ret === errorObj) {
	        async.throwLater(ret.e);
	    }
	}
	function errorAdapter(reason, nodeback) {
	    var promise = this;
	    if (!reason) {
	        var newReason = new Error(reason + "");
	        newReason.cause = reason;
	        reason = newReason;
	    }
	    var ret = tryCatch(nodeback).call(promise._boundValue(), reason);
	    if (ret === errorObj) {
	        async.throwLater(ret.e);
	    }
	}
	
	Promise.prototype.asCallback = Promise.prototype.nodeify = function (nodeback,
	                                                                     options) {
	    if (typeof nodeback == "function") {
	        var adapter = successAdapter;
	        if (options !== undefined && Object(options).spread) {
	            adapter = spreadAdapter;
	        }
	        this._then(
	            adapter,
	            errorAdapter,
	            undefined,
	            this,
	            nodeback
	        );
	    }
	    return this;
	};
	};
	
	},{"./util":36}],22:[function(_dereq_,module,exports){
	"use strict";
	module.exports = function() {
	var makeSelfResolutionError = function () {
	    return new TypeError("circular promise resolution chain\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
	};
	var reflectHandler = function() {
	    return new Promise.PromiseInspection(this._target());
	};
	var apiRejection = function(msg) {
	    return Promise.reject(new TypeError(msg));
	};
	function Proxyable() {}
	var UNDEFINED_BINDING = {};
	var util = _dereq_("./util");
	
	var getDomain;
	if (util.isNode) {
	    getDomain = function() {
	        var ret = process.domain;
	        if (ret === undefined) ret = null;
	        return ret;
	    };
	} else {
	    getDomain = function() {
	        return null;
	    };
	}
	util.notEnumerableProp(Promise, "_getDomain", getDomain);
	
	var es5 = _dereq_("./es5");
	var Async = _dereq_("./async");
	var async = new Async();
	es5.defineProperty(Promise, "_async", {value: async});
	var errors = _dereq_("./errors");
	var TypeError = Promise.TypeError = errors.TypeError;
	Promise.RangeError = errors.RangeError;
	var CancellationError = Promise.CancellationError = errors.CancellationError;
	Promise.TimeoutError = errors.TimeoutError;
	Promise.OperationalError = errors.OperationalError;
	Promise.RejectionError = errors.OperationalError;
	Promise.AggregateError = errors.AggregateError;
	var INTERNAL = function(){};
	var APPLY = {};
	var NEXT_FILTER = {};
	var tryConvertToPromise = _dereq_("./thenables")(Promise, INTERNAL);
	var PromiseArray =
	    _dereq_("./promise_array")(Promise, INTERNAL,
	                               tryConvertToPromise, apiRejection, Proxyable);
	var Context = _dereq_("./context")(Promise);
	 /*jshint unused:false*/
	var createContext = Context.create;
	var debug = _dereq_("./debuggability")(Promise, Context);
	var CapturedTrace = debug.CapturedTrace;
	var PassThroughHandlerContext =
	    _dereq_("./finally")(Promise, tryConvertToPromise);
	var catchFilter = _dereq_("./catch_filter")(NEXT_FILTER);
	var nodebackForPromise = _dereq_("./nodeback");
	var errorObj = util.errorObj;
	var tryCatch = util.tryCatch;
	function check(self, executor) {
	    if (typeof executor !== "function") {
	        throw new TypeError("expecting a function but got " + util.classString(executor));
	    }
	    if (self.constructor !== Promise) {
	        throw new TypeError("the promise constructor cannot be invoked directly\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
	    }
	}
	
	function Promise(executor) {
	    this._bitField = 0;
	    this._fulfillmentHandler0 = undefined;
	    this._rejectionHandler0 = undefined;
	    this._promise0 = undefined;
	    this._receiver0 = undefined;
	    if (executor !== INTERNAL) {
	        check(this, executor);
	        this._resolveFromExecutor(executor);
	    }
	    this._promiseCreated();
	    this._fireEvent("promiseCreated", this);
	}
	
	Promise.prototype.toString = function () {
	    return "[object Promise]";
	};
	
	Promise.prototype.caught = Promise.prototype["catch"] = function (fn) {
	    var len = arguments.length;
	    if (len > 1) {
	        var catchInstances = new Array(len - 1),
	            j = 0, i;
	        for (i = 0; i < len - 1; ++i) {
	            var item = arguments[i];
	            if (util.isObject(item)) {
	                catchInstances[j++] = item;
	            } else {
	                return apiRejection("expecting an object but got " + util.classString(item));
	            }
	        }
	        catchInstances.length = j;
	        fn = arguments[i];
	        return this.then(undefined, catchFilter(catchInstances, fn, this));
	    }
	    return this.then(undefined, fn);
	};
	
	Promise.prototype.reflect = function () {
	    return this._then(reflectHandler,
	        reflectHandler, undefined, this, undefined);
	};
	
	Promise.prototype.then = function (didFulfill, didReject) {
	    if (debug.warnings() && arguments.length > 0 &&
	        typeof didFulfill !== "function" &&
	        typeof didReject !== "function") {
	        var msg = ".then() only accepts functions but was passed: " +
	                util.classString(didFulfill);
	        if (arguments.length > 1) {
	            msg += ", " + util.classString(didReject);
	        }
	        this._warn(msg);
	    }
	    return this._then(didFulfill, didReject, undefined, undefined, undefined);
	};
	
	Promise.prototype.done = function (didFulfill, didReject) {
	    var promise =
	        this._then(didFulfill, didReject, undefined, undefined, undefined);
	    promise._setIsFinal();
	};
	
	Promise.prototype.spread = function (fn) {
	    if (typeof fn !== "function") {
	        return apiRejection("expecting a function but got " + util.classString(fn));
	    }
	    return this.all()._then(fn, undefined, undefined, APPLY, undefined);
	};
	
	Promise.prototype.toJSON = function () {
	    var ret = {
	        isFulfilled: false,
	        isRejected: false,
	        fulfillmentValue: undefined,
	        rejectionReason: undefined
	    };
	    if (this.isFulfilled()) {
	        ret.fulfillmentValue = this.value();
	        ret.isFulfilled = true;
	    } else if (this.isRejected()) {
	        ret.rejectionReason = this.reason();
	        ret.isRejected = true;
	    }
	    return ret;
	};
	
	Promise.prototype.all = function () {
	    if (arguments.length > 0) {
	        this._warn(".all() was passed arguments but it does not take any");
	    }
	    return new PromiseArray(this).promise();
	};
	
	Promise.prototype.error = function (fn) {
	    return this.caught(util.originatesFromRejection, fn);
	};
	
	Promise.getNewLibraryCopy = module.exports;
	
	Promise.is = function (val) {
	    return val instanceof Promise;
	};
	
	Promise.fromNode = Promise.fromCallback = function(fn) {
	    var ret = new Promise(INTERNAL);
	    ret._captureStackTrace();
	    var multiArgs = arguments.length > 1 ? !!Object(arguments[1]).multiArgs
	                                         : false;
	    var result = tryCatch(fn)(nodebackForPromise(ret, multiArgs));
	    if (result === errorObj) {
	        ret._rejectCallback(result.e, true);
	    }
	    if (!ret._isFateSealed()) ret._setAsyncGuaranteed();
	    return ret;
	};
	
	Promise.all = function (promises) {
	    return new PromiseArray(promises).promise();
	};
	
	Promise.cast = function (obj) {
	    var ret = tryConvertToPromise(obj);
	    if (!(ret instanceof Promise)) {
	        ret = new Promise(INTERNAL);
	        ret._captureStackTrace();
	        ret._setFulfilled();
	        ret._rejectionHandler0 = obj;
	    }
	    return ret;
	};
	
	Promise.resolve = Promise.fulfilled = Promise.cast;
	
	Promise.reject = Promise.rejected = function (reason) {
	    var ret = new Promise(INTERNAL);
	    ret._captureStackTrace();
	    ret._rejectCallback(reason, true);
	    return ret;
	};
	
	Promise.setScheduler = function(fn) {
	    if (typeof fn !== "function") {
	        throw new TypeError("expecting a function but got " + util.classString(fn));
	    }
	    return async.setScheduler(fn);
	};
	
	Promise.prototype._then = function (
	    didFulfill,
	    didReject,
	    _,    receiver,
	    internalData
	) {
	    var haveInternalData = internalData !== undefined;
	    var promise = haveInternalData ? internalData : new Promise(INTERNAL);
	    var target = this._target();
	    var bitField = target._bitField;
	
	    if (!haveInternalData) {
	        promise._propagateFrom(this, 3);
	        promise._captureStackTrace();
	        if (receiver === undefined &&
	            ((this._bitField & 2097152) !== 0)) {
	            if (!((bitField & 50397184) === 0)) {
	                receiver = this._boundValue();
	            } else {
	                receiver = target === this ? undefined : this._boundTo;
	            }
	        }
	        this._fireEvent("promiseChained", this, promise);
	    }
	
	    var domain = getDomain();
	    if (!((bitField & 50397184) === 0)) {
	        var handler, value, settler = target._settlePromiseCtx;
	        if (((bitField & 33554432) !== 0)) {
	            value = target._rejectionHandler0;
	            handler = didFulfill;
	        } else if (((bitField & 16777216) !== 0)) {
	            value = target._fulfillmentHandler0;
	            handler = didReject;
	            target._unsetRejectionIsUnhandled();
	        } else {
	            settler = target._settlePromiseLateCancellationObserver;
	            value = new CancellationError("late cancellation observer");
	            target._attachExtraTrace(value);
	            handler = didReject;
	        }
	
	        async.invoke(settler, target, {
	            handler: domain === null ? handler
	                : (typeof handler === "function" && domain.bind(handler)),
	            promise: promise,
	            receiver: receiver,
	            value: value
	        });
	    } else {
	        target._addCallbacks(didFulfill, didReject, promise, receiver, domain);
	    }
	
	    return promise;
	};
	
	Promise.prototype._length = function () {
	    return this._bitField & 65535;
	};
	
	Promise.prototype._isFateSealed = function () {
	    return (this._bitField & 117506048) !== 0;
	};
	
	Promise.prototype._isFollowing = function () {
	    return (this._bitField & 67108864) === 67108864;
	};
	
	Promise.prototype._setLength = function (len) {
	    this._bitField = (this._bitField & -65536) |
	        (len & 65535);
	};
	
	Promise.prototype._setFulfilled = function () {
	    this._bitField = this._bitField | 33554432;
	    this._fireEvent("promiseFulfilled", this);
	};
	
	Promise.prototype._setRejected = function () {
	    this._bitField = this._bitField | 16777216;
	    this._fireEvent("promiseRejected", this);
	};
	
	Promise.prototype._setFollowing = function () {
	    this._bitField = this._bitField | 67108864;
	    this._fireEvent("promiseResolved", this);
	};
	
	Promise.prototype._setIsFinal = function () {
	    this._bitField = this._bitField | 4194304;
	};
	
	Promise.prototype._isFinal = function () {
	    return (this._bitField & 4194304) > 0;
	};
	
	Promise.prototype._unsetCancelled = function() {
	    this._bitField = this._bitField & (~65536);
	};
	
	Promise.prototype._setCancelled = function() {
	    this._bitField = this._bitField | 65536;
	    this._fireEvent("promiseCancelled", this);
	};
	
	Promise.prototype._setAsyncGuaranteed = function() {
	    if (async.hasCustomScheduler()) return;
	    this._bitField = this._bitField | 134217728;
	};
	
	Promise.prototype._receiverAt = function (index) {
	    var ret = index === 0 ? this._receiver0 : this[
	            index * 4 - 4 + 3];
	    if (ret === UNDEFINED_BINDING) {
	        return undefined;
	    } else if (ret === undefined && this._isBound()) {
	        return this._boundValue();
	    }
	    return ret;
	};
	
	Promise.prototype._promiseAt = function (index) {
	    return this[
	            index * 4 - 4 + 2];
	};
	
	Promise.prototype._fulfillmentHandlerAt = function (index) {
	    return this[
	            index * 4 - 4 + 0];
	};
	
	Promise.prototype._rejectionHandlerAt = function (index) {
	    return this[
	            index * 4 - 4 + 1];
	};
	
	Promise.prototype._boundValue = function() {};
	
	Promise.prototype._migrateCallback0 = function (follower) {
	    var bitField = follower._bitField;
	    var fulfill = follower._fulfillmentHandler0;
	    var reject = follower._rejectionHandler0;
	    var promise = follower._promise0;
	    var receiver = follower._receiverAt(0);
	    if (receiver === undefined) receiver = UNDEFINED_BINDING;
	    this._addCallbacks(fulfill, reject, promise, receiver, null);
	};
	
	Promise.prototype._migrateCallbackAt = function (follower, index) {
	    var fulfill = follower._fulfillmentHandlerAt(index);
	    var reject = follower._rejectionHandlerAt(index);
	    var promise = follower._promiseAt(index);
	    var receiver = follower._receiverAt(index);
	    if (receiver === undefined) receiver = UNDEFINED_BINDING;
	    this._addCallbacks(fulfill, reject, promise, receiver, null);
	};
	
	Promise.prototype._addCallbacks = function (
	    fulfill,
	    reject,
	    promise,
	    receiver,
	    domain
	) {
	    var index = this._length();
	
	    if (index >= 65535 - 4) {
	        index = 0;
	        this._setLength(0);
	    }
	
	    if (index === 0) {
	        this._promise0 = promise;
	        this._receiver0 = receiver;
	        if (typeof fulfill === "function") {
	            this._fulfillmentHandler0 =
	                domain === null ? fulfill : domain.bind(fulfill);
	        }
	        if (typeof reject === "function") {
	            this._rejectionHandler0 =
	                domain === null ? reject : domain.bind(reject);
	        }
	    } else {
	        var base = index * 4 - 4;
	        this[base + 2] = promise;
	        this[base + 3] = receiver;
	        if (typeof fulfill === "function") {
	            this[base + 0] =
	                domain === null ? fulfill : domain.bind(fulfill);
	        }
	        if (typeof reject === "function") {
	            this[base + 1] =
	                domain === null ? reject : domain.bind(reject);
	        }
	    }
	    this._setLength(index + 1);
	    return index;
	};
	
	Promise.prototype._proxy = function (proxyable, arg) {
	    this._addCallbacks(undefined, undefined, arg, proxyable, null);
	};
	
	Promise.prototype._resolveCallback = function(value, shouldBind) {
	    if (((this._bitField & 117506048) !== 0)) return;
	    if (value === this)
	        return this._rejectCallback(makeSelfResolutionError(), false);
	    var maybePromise = tryConvertToPromise(value, this);
	    if (!(maybePromise instanceof Promise)) return this._fulfill(value);
	
	    if (shouldBind) this._propagateFrom(maybePromise, 2);
	
	    var promise = maybePromise._target();
	
	    if (promise === this) {
	        this._reject(makeSelfResolutionError());
	        return;
	    }
	
	    var bitField = promise._bitField;
	    if (((bitField & 50397184) === 0)) {
	        var len = this._length();
	        if (len > 0) promise._migrateCallback0(this);
	        for (var i = 1; i < len; ++i) {
	            promise._migrateCallbackAt(this, i);
	        }
	        this._setFollowing();
	        this._setLength(0);
	        this._setFollowee(promise);
	    } else if (((bitField & 33554432) !== 0)) {
	        this._fulfill(promise._value());
	    } else if (((bitField & 16777216) !== 0)) {
	        this._reject(promise._reason());
	    } else {
	        var reason = new CancellationError("late cancellation observer");
	        promise._attachExtraTrace(reason);
	        this._reject(reason);
	    }
	};
	
	Promise.prototype._rejectCallback =
	function(reason, synchronous, ignoreNonErrorWarnings) {
	    var trace = util.ensureErrorObject(reason);
	    var hasStack = trace === reason;
	    if (!hasStack && !ignoreNonErrorWarnings && debug.warnings()) {
	        var message = "a promise was rejected with a non-error: " +
	            util.classString(reason);
	        this._warn(message, true);
	    }
	    this._attachExtraTrace(trace, synchronous ? hasStack : false);
	    this._reject(reason);
	};
	
	Promise.prototype._resolveFromExecutor = function (executor) {
	    var promise = this;
	    this._captureStackTrace();
	    this._pushContext();
	    var synchronous = true;
	    var r = this._execute(executor, function(value) {
	        promise._resolveCallback(value);
	    }, function (reason) {
	        promise._rejectCallback(reason, synchronous);
	    });
	    synchronous = false;
	    this._popContext();
	
	    if (r !== undefined) {
	        promise._rejectCallback(r, true);
	    }
	};
	
	Promise.prototype._settlePromiseFromHandler = function (
	    handler, receiver, value, promise
	) {
	    var bitField = promise._bitField;
	    if (((bitField & 65536) !== 0)) return;
	    promise._pushContext();
	    var x;
	    if (receiver === APPLY) {
	        if (!value || typeof value.length !== "number") {
	            x = errorObj;
	            x.e = new TypeError("cannot .spread() a non-array: " +
	                                    util.classString(value));
	        } else {
	            x = tryCatch(handler).apply(this._boundValue(), value);
	        }
	    } else {
	        x = tryCatch(handler).call(receiver, value);
	    }
	    var promiseCreated = promise._popContext();
	    bitField = promise._bitField;
	    if (((bitField & 65536) !== 0)) return;
	
	    if (x === NEXT_FILTER) {
	        promise._reject(value);
	    } else if (x === errorObj) {
	        promise._rejectCallback(x.e, false);
	    } else {
	        debug.checkForgottenReturns(x, promiseCreated, "",  promise, this);
	        promise._resolveCallback(x);
	    }
	};
	
	Promise.prototype._target = function() {
	    var ret = this;
	    while (ret._isFollowing()) ret = ret._followee();
	    return ret;
	};
	
	Promise.prototype._followee = function() {
	    return this._rejectionHandler0;
	};
	
	Promise.prototype._setFollowee = function(promise) {
	    this._rejectionHandler0 = promise;
	};
	
	Promise.prototype._settlePromise = function(promise, handler, receiver, value) {
	    var isPromise = promise instanceof Promise;
	    var bitField = this._bitField;
	    var asyncGuaranteed = ((bitField & 134217728) !== 0);
	    if (((bitField & 65536) !== 0)) {
	        if (isPromise) promise._invokeInternalOnCancel();
	
	        if (receiver instanceof PassThroughHandlerContext &&
	            receiver.isFinallyHandler()) {
	            receiver.cancelPromise = promise;
	            if (tryCatch(handler).call(receiver, value) === errorObj) {
	                promise._reject(errorObj.e);
	            }
	        } else if (handler === reflectHandler) {
	            promise._fulfill(reflectHandler.call(receiver));
	        } else if (receiver instanceof Proxyable) {
	            receiver._promiseCancelled(promise);
	        } else if (isPromise || promise instanceof PromiseArray) {
	            promise._cancel();
	        } else {
	            receiver.cancel();
	        }
	    } else if (typeof handler === "function") {
	        if (!isPromise) {
	            handler.call(receiver, value, promise);
	        } else {
	            if (asyncGuaranteed) promise._setAsyncGuaranteed();
	            this._settlePromiseFromHandler(handler, receiver, value, promise);
	        }
	    } else if (receiver instanceof Proxyable) {
	        if (!receiver._isResolved()) {
	            if (((bitField & 33554432) !== 0)) {
	                receiver._promiseFulfilled(value, promise);
	            } else {
	                receiver._promiseRejected(value, promise);
	            }
	        }
	    } else if (isPromise) {
	        if (asyncGuaranteed) promise._setAsyncGuaranteed();
	        if (((bitField & 33554432) !== 0)) {
	            promise._fulfill(value);
	        } else {
	            promise._reject(value);
	        }
	    }
	};
	
	Promise.prototype._settlePromiseLateCancellationObserver = function(ctx) {
	    var handler = ctx.handler;
	    var promise = ctx.promise;
	    var receiver = ctx.receiver;
	    var value = ctx.value;
	    if (typeof handler === "function") {
	        if (!(promise instanceof Promise)) {
	            handler.call(receiver, value, promise);
	        } else {
	            this._settlePromiseFromHandler(handler, receiver, value, promise);
	        }
	    } else if (promise instanceof Promise) {
	        promise._reject(value);
	    }
	};
	
	Promise.prototype._settlePromiseCtx = function(ctx) {
	    this._settlePromise(ctx.promise, ctx.handler, ctx.receiver, ctx.value);
	};
	
	Promise.prototype._settlePromise0 = function(handler, value, bitField) {
	    var promise = this._promise0;
	    var receiver = this._receiverAt(0);
	    this._promise0 = undefined;
	    this._receiver0 = undefined;
	    this._settlePromise(promise, handler, receiver, value);
	};
	
	Promise.prototype._clearCallbackDataAtIndex = function(index) {
	    var base = index * 4 - 4;
	    this[base + 2] =
	    this[base + 3] =
	    this[base + 0] =
	    this[base + 1] = undefined;
	};
	
	Promise.prototype._fulfill = function (value) {
	    var bitField = this._bitField;
	    if (((bitField & 117506048) >>> 16)) return;
	    if (value === this) {
	        var err = makeSelfResolutionError();
	        this._attachExtraTrace(err);
	        return this._reject(err);
	    }
	    this._setFulfilled();
	    this._rejectionHandler0 = value;
	
	    if ((bitField & 65535) > 0) {
	        if (((bitField & 134217728) !== 0)) {
	            this._settlePromises();
	        } else {
	            async.settlePromises(this);
	        }
	    }
	};
	
	Promise.prototype._reject = function (reason) {
	    var bitField = this._bitField;
	    if (((bitField & 117506048) >>> 16)) return;
	    this._setRejected();
	    this._fulfillmentHandler0 = reason;
	
	    if (this._isFinal()) {
	        return async.fatalError(reason, util.isNode);
	    }
	
	    if ((bitField & 65535) > 0) {
	        async.settlePromises(this);
	    } else {
	        this._ensurePossibleRejectionHandled();
	    }
	};
	
	Promise.prototype._fulfillPromises = function (len, value) {
	    for (var i = 1; i < len; i++) {
	        var handler = this._fulfillmentHandlerAt(i);
	        var promise = this._promiseAt(i);
	        var receiver = this._receiverAt(i);
	        this._clearCallbackDataAtIndex(i);
	        this._settlePromise(promise, handler, receiver, value);
	    }
	};
	
	Promise.prototype._rejectPromises = function (len, reason) {
	    for (var i = 1; i < len; i++) {
	        var handler = this._rejectionHandlerAt(i);
	        var promise = this._promiseAt(i);
	        var receiver = this._receiverAt(i);
	        this._clearCallbackDataAtIndex(i);
	        this._settlePromise(promise, handler, receiver, reason);
	    }
	};
	
	Promise.prototype._settlePromises = function () {
	    var bitField = this._bitField;
	    var len = (bitField & 65535);
	
	    if (len > 0) {
	        if (((bitField & 16842752) !== 0)) {
	            var reason = this._fulfillmentHandler0;
	            this._settlePromise0(this._rejectionHandler0, reason, bitField);
	            this._rejectPromises(len, reason);
	        } else {
	            var value = this._rejectionHandler0;
	            this._settlePromise0(this._fulfillmentHandler0, value, bitField);
	            this._fulfillPromises(len, value);
	        }
	        this._setLength(0);
	    }
	    this._clearCancellationData();
	};
	
	Promise.prototype._settledValue = function() {
	    var bitField = this._bitField;
	    if (((bitField & 33554432) !== 0)) {
	        return this._rejectionHandler0;
	    } else if (((bitField & 16777216) !== 0)) {
	        return this._fulfillmentHandler0;
	    }
	};
	
	function deferResolve(v) {this.promise._resolveCallback(v);}
	function deferReject(v) {this.promise._rejectCallback(v, false);}
	
	Promise.defer = Promise.pending = function() {
	    debug.deprecated("Promise.defer", "new Promise");
	    var promise = new Promise(INTERNAL);
	    return {
	        promise: promise,
	        resolve: deferResolve,
	        reject: deferReject
	    };
	};
	
	util.notEnumerableProp(Promise,
	                       "_makeSelfResolutionError",
	                       makeSelfResolutionError);
	
	_dereq_("./method")(Promise, INTERNAL, tryConvertToPromise, apiRejection,
	    debug);
	_dereq_("./bind")(Promise, INTERNAL, tryConvertToPromise, debug);
	_dereq_("./cancel")(Promise, PromiseArray, apiRejection, debug);
	_dereq_("./direct_resolve")(Promise);
	_dereq_("./synchronous_inspection")(Promise);
	_dereq_("./join")(
	    Promise, PromiseArray, tryConvertToPromise, INTERNAL, debug);
	Promise.Promise = Promise;
	Promise.version = "3.4.0";
	_dereq_('./map.js')(Promise, PromiseArray, apiRejection, tryConvertToPromise, INTERNAL, debug);
	_dereq_('./call_get.js')(Promise);
	_dereq_('./using.js')(Promise, apiRejection, tryConvertToPromise, createContext, INTERNAL, debug);
	_dereq_('./timers.js')(Promise, INTERNAL, debug);
	_dereq_('./generators.js')(Promise, apiRejection, INTERNAL, tryConvertToPromise, Proxyable, debug);
	_dereq_('./nodeify.js')(Promise);
	_dereq_('./promisify.js')(Promise, INTERNAL);
	_dereq_('./props.js')(Promise, PromiseArray, tryConvertToPromise, apiRejection);
	_dereq_('./race.js')(Promise, INTERNAL, tryConvertToPromise, apiRejection);
	_dereq_('./reduce.js')(Promise, PromiseArray, apiRejection, tryConvertToPromise, INTERNAL, debug);
	_dereq_('./settle.js')(Promise, PromiseArray, debug);
	_dereq_('./some.js')(Promise, PromiseArray, apiRejection);
	_dereq_('./filter.js')(Promise, INTERNAL);
	_dereq_('./each.js')(Promise, INTERNAL);
	_dereq_('./any.js')(Promise);
	                                                         
	    util.toFastProperties(Promise);                                          
	    util.toFastProperties(Promise.prototype);                                
	    function fillTypes(value) {                                              
	        var p = new Promise(INTERNAL);                                       
	        p._fulfillmentHandler0 = value;                                      
	        p._rejectionHandler0 = value;                                        
	        p._promise0 = value;                                                 
	        p._receiver0 = value;                                                
	    }                                                                        
	    // Complete slack tracking, opt out of field-type tracking and           
	    // stabilize map                                                         
	    fillTypes({a: 1});                                                       
	    fillTypes({b: 2});                                                       
	    fillTypes({c: 3});                                                       
	    fillTypes(1);                                                            
	    fillTypes(function(){});                                                 
	    fillTypes(undefined);                                                    
	    fillTypes(false);                                                        
	    fillTypes(new Promise(INTERNAL));                                        
	    debug.setBounds(Async.firstLineError, util.lastLineError);               
	    return Promise;                                                          
	
	};
	
	},{"./any.js":1,"./async":2,"./bind":3,"./call_get.js":5,"./cancel":6,"./catch_filter":7,"./context":8,"./debuggability":9,"./direct_resolve":10,"./each.js":11,"./errors":12,"./es5":13,"./filter.js":14,"./finally":15,"./generators.js":16,"./join":17,"./map.js":18,"./method":19,"./nodeback":20,"./nodeify.js":21,"./promise_array":23,"./promisify.js":24,"./props.js":25,"./race.js":27,"./reduce.js":28,"./settle.js":30,"./some.js":31,"./synchronous_inspection":32,"./thenables":33,"./timers.js":34,"./using.js":35,"./util":36}],23:[function(_dereq_,module,exports){
	"use strict";
	module.exports = function(Promise, INTERNAL, tryConvertToPromise,
	    apiRejection, Proxyable) {
	var util = _dereq_("./util");
	var isArray = util.isArray;
	
	function toResolutionValue(val) {
	    switch(val) {
	    case -2: return [];
	    case -3: return {};
	    }
	}
	
	function PromiseArray(values) {
	    var promise = this._promise = new Promise(INTERNAL);
	    if (values instanceof Promise) {
	        promise._propagateFrom(values, 3);
	    }
	    promise._setOnCancel(this);
	    this._values = values;
	    this._length = 0;
	    this._totalResolved = 0;
	    this._init(undefined, -2);
	}
	util.inherits(PromiseArray, Proxyable);
	
	PromiseArray.prototype.length = function () {
	    return this._length;
	};
	
	PromiseArray.prototype.promise = function () {
	    return this._promise;
	};
	
	PromiseArray.prototype._init = function init(_, resolveValueIfEmpty) {
	    var values = tryConvertToPromise(this._values, this._promise);
	    if (values instanceof Promise) {
	        values = values._target();
	        var bitField = values._bitField;
	        ;
	        this._values = values;
	
	        if (((bitField & 50397184) === 0)) {
	            this._promise._setAsyncGuaranteed();
	            return values._then(
	                init,
	                this._reject,
	                undefined,
	                this,
	                resolveValueIfEmpty
	           );
	        } else if (((bitField & 33554432) !== 0)) {
	            values = values._value();
	        } else if (((bitField & 16777216) !== 0)) {
	            return this._reject(values._reason());
	        } else {
	            return this._cancel();
	        }
	    }
	    values = util.asArray(values);
	    if (values === null) {
	        var err = apiRejection(
	            "expecting an array or an iterable object but got " + util.classString(values)).reason();
	        this._promise._rejectCallback(err, false);
	        return;
	    }
	
	    if (values.length === 0) {
	        if (resolveValueIfEmpty === -5) {
	            this._resolveEmptyArray();
	        }
	        else {
	            this._resolve(toResolutionValue(resolveValueIfEmpty));
	        }
	        return;
	    }
	    this._iterate(values);
	};
	
	PromiseArray.prototype._iterate = function(values) {
	    var len = this.getActualLength(values.length);
	    this._length = len;
	    this._values = this.shouldCopyValues() ? new Array(len) : this._values;
	    var result = this._promise;
	    var isResolved = false;
	    var bitField = null;
	    for (var i = 0; i < len; ++i) {
	        var maybePromise = tryConvertToPromise(values[i], result);
	
	        if (maybePromise instanceof Promise) {
	            maybePromise = maybePromise._target();
	            bitField = maybePromise._bitField;
	        } else {
	            bitField = null;
	        }
	
	        if (isResolved) {
	            if (bitField !== null) {
	                maybePromise.suppressUnhandledRejections();
	            }
	        } else if (bitField !== null) {
	            if (((bitField & 50397184) === 0)) {
	                maybePromise._proxy(this, i);
	                this._values[i] = maybePromise;
	            } else if (((bitField & 33554432) !== 0)) {
	                isResolved = this._promiseFulfilled(maybePromise._value(), i);
	            } else if (((bitField & 16777216) !== 0)) {
	                isResolved = this._promiseRejected(maybePromise._reason(), i);
	            } else {
	                isResolved = this._promiseCancelled(i);
	            }
	        } else {
	            isResolved = this._promiseFulfilled(maybePromise, i);
	        }
	    }
	    if (!isResolved) result._setAsyncGuaranteed();
	};
	
	PromiseArray.prototype._isResolved = function () {
	    return this._values === null;
	};
	
	PromiseArray.prototype._resolve = function (value) {
	    this._values = null;
	    this._promise._fulfill(value);
	};
	
	PromiseArray.prototype._cancel = function() {
	    if (this._isResolved() || !this._promise.isCancellable()) return;
	    this._values = null;
	    this._promise._cancel();
	};
	
	PromiseArray.prototype._reject = function (reason) {
	    this._values = null;
	    this._promise._rejectCallback(reason, false);
	};
	
	PromiseArray.prototype._promiseFulfilled = function (value, index) {
	    this._values[index] = value;
	    var totalResolved = ++this._totalResolved;
	    if (totalResolved >= this._length) {
	        this._resolve(this._values);
	        return true;
	    }
	    return false;
	};
	
	PromiseArray.prototype._promiseCancelled = function() {
	    this._cancel();
	    return true;
	};
	
	PromiseArray.prototype._promiseRejected = function (reason) {
	    this._totalResolved++;
	    this._reject(reason);
	    return true;
	};
	
	PromiseArray.prototype._resultCancelled = function() {
	    if (this._isResolved()) return;
	    var values = this._values;
	    this._cancel();
	    if (values instanceof Promise) {
	        values.cancel();
	    } else {
	        for (var i = 0; i < values.length; ++i) {
	            if (values[i] instanceof Promise) {
	                values[i].cancel();
	            }
	        }
	    }
	};
	
	PromiseArray.prototype.shouldCopyValues = function () {
	    return true;
	};
	
	PromiseArray.prototype.getActualLength = function (len) {
	    return len;
	};
	
	return PromiseArray;
	};
	
	},{"./util":36}],24:[function(_dereq_,module,exports){
	"use strict";
	module.exports = function(Promise, INTERNAL) {
	var THIS = {};
	var util = _dereq_("./util");
	var nodebackForPromise = _dereq_("./nodeback");
	var withAppended = util.withAppended;
	var maybeWrapAsError = util.maybeWrapAsError;
	var canEvaluate = util.canEvaluate;
	var TypeError = _dereq_("./errors").TypeError;
	var defaultSuffix = "Async";
	var defaultPromisified = {__isPromisified__: true};
	var noCopyProps = [
	    "arity",    "length",
	    "name",
	    "arguments",
	    "caller",
	    "callee",
	    "prototype",
	    "__isPromisified__"
	];
	var noCopyPropsPattern = new RegExp("^(?:" + noCopyProps.join("|") + ")$");
	
	var defaultFilter = function(name) {
	    return util.isIdentifier(name) &&
	        name.charAt(0) !== "_" &&
	        name !== "constructor";
	};
	
	function propsFilter(key) {
	    return !noCopyPropsPattern.test(key);
	}
	
	function isPromisified(fn) {
	    try {
	        return fn.__isPromisified__ === true;
	    }
	    catch (e) {
	        return false;
	    }
	}
	
	function hasPromisified(obj, key, suffix) {
	    var val = util.getDataPropertyOrDefault(obj, key + suffix,
	                                            defaultPromisified);
	    return val ? isPromisified(val) : false;
	}
	function checkValid(ret, suffix, suffixRegexp) {
	    for (var i = 0; i < ret.length; i += 2) {
	        var key = ret[i];
	        if (suffixRegexp.test(key)) {
	            var keyWithoutAsyncSuffix = key.replace(suffixRegexp, "");
	            for (var j = 0; j < ret.length; j += 2) {
	                if (ret[j] === keyWithoutAsyncSuffix) {
	                    throw new TypeError("Cannot promisify an API that has normal methods with '%s'-suffix\u000a\u000a    See http://goo.gl/MqrFmX\u000a"
	                        .replace("%s", suffix));
	                }
	            }
	        }
	    }
	}
	
	function promisifiableMethods(obj, suffix, suffixRegexp, filter) {
	    var keys = util.inheritedDataKeys(obj);
	    var ret = [];
	    for (var i = 0; i < keys.length; ++i) {
	        var key = keys[i];
	        var value = obj[key];
	        var passesDefaultFilter = filter === defaultFilter
	            ? true : defaultFilter(key, value, obj);
	        if (typeof value === "function" &&
	            !isPromisified(value) &&
	            !hasPromisified(obj, key, suffix) &&
	            filter(key, value, obj, passesDefaultFilter)) {
	            ret.push(key, value);
	        }
	    }
	    checkValid(ret, suffix, suffixRegexp);
	    return ret;
	}
	
	var escapeIdentRegex = function(str) {
	    return str.replace(/([$])/, "\\$");
	};
	
	var makeNodePromisifiedEval;
	if (false) {
	var switchCaseArgumentOrder = function(likelyArgumentCount) {
	    var ret = [likelyArgumentCount];
	    var min = Math.max(0, likelyArgumentCount - 1 - 3);
	    for(var i = likelyArgumentCount - 1; i >= min; --i) {
	        ret.push(i);
	    }
	    for(var i = likelyArgumentCount + 1; i <= 3; ++i) {
	        ret.push(i);
	    }
	    return ret;
	};
	
	var argumentSequence = function(argumentCount) {
	    return util.filledRange(argumentCount, "_arg", "");
	};
	
	var parameterDeclaration = function(parameterCount) {
	    return util.filledRange(
	        Math.max(parameterCount, 3), "_arg", "");
	};
	
	var parameterCount = function(fn) {
	    if (typeof fn.length === "number") {
	        return Math.max(Math.min(fn.length, 1023 + 1), 0);
	    }
	    return 0;
	};
	
	makeNodePromisifiedEval =
	function(callback, receiver, originalName, fn, _, multiArgs) {
	    var newParameterCount = Math.max(0, parameterCount(fn) - 1);
	    var argumentOrder = switchCaseArgumentOrder(newParameterCount);
	    var shouldProxyThis = typeof callback === "string" || receiver === THIS;
	
	    function generateCallForArgumentCount(count) {
	        var args = argumentSequence(count).join(", ");
	        var comma = count > 0 ? ", " : "";
	        var ret;
	        if (shouldProxyThis) {
	            ret = "ret = callback.call(this, {{args}}, nodeback); break;\n";
	        } else {
	            ret = receiver === undefined
	                ? "ret = callback({{args}}, nodeback); break;\n"
	                : "ret = callback.call(receiver, {{args}}, nodeback); break;\n";
	        }
	        return ret.replace("{{args}}", args).replace(", ", comma);
	    }
	
	    function generateArgumentSwitchCase() {
	        var ret = "";
	        for (var i = 0; i < argumentOrder.length; ++i) {
	            ret += "case " + argumentOrder[i] +":" +
	                generateCallForArgumentCount(argumentOrder[i]);
	        }
	
	        ret += "                                                             \n\
	        default:                                                             \n\
	            var args = new Array(len + 1);                                   \n\
	            var i = 0;                                                       \n\
	            for (var i = 0; i < len; ++i) {                                  \n\
	               args[i] = arguments[i];                                       \n\
	            }                                                                \n\
	            args[i] = nodeback;                                              \n\
	            [CodeForCall]                                                    \n\
	            break;                                                           \n\
	        ".replace("[CodeForCall]", (shouldProxyThis
	                                ? "ret = callback.apply(this, args);\n"
	                                : "ret = callback.apply(receiver, args);\n"));
	        return ret;
	    }
	
	    var getFunctionCode = typeof callback === "string"
	                                ? ("this != null ? this['"+callback+"'] : fn")
	                                : "fn";
	    var body = "'use strict';                                                \n\
	        var ret = function (Parameters) {                                    \n\
	            'use strict';                                                    \n\
	            var len = arguments.length;                                      \n\
	            var promise = new Promise(INTERNAL);                             \n\
	            promise._captureStackTrace();                                    \n\
	            var nodeback = nodebackForPromise(promise, " + multiArgs + ");   \n\
	            var ret;                                                         \n\
	            var callback = tryCatch([GetFunctionCode]);                      \n\
	            switch(len) {                                                    \n\
	                [CodeForSwitchCase]                                          \n\
	            }                                                                \n\
	            if (ret === errorObj) {                                          \n\
	                promise._rejectCallback(maybeWrapAsError(ret.e), true, true);\n\
	            }                                                                \n\
	            if (!promise._isFateSealed()) promise._setAsyncGuaranteed();     \n\
	            return promise;                                                  \n\
	        };                                                                   \n\
	        notEnumerableProp(ret, '__isPromisified__', true);                   \n\
	        return ret;                                                          \n\
	    ".replace("[CodeForSwitchCase]", generateArgumentSwitchCase())
	        .replace("[GetFunctionCode]", getFunctionCode);
	    body = body.replace("Parameters", parameterDeclaration(newParameterCount));
	    return new Function("Promise",
	                        "fn",
	                        "receiver",
	                        "withAppended",
	                        "maybeWrapAsError",
	                        "nodebackForPromise",
	                        "tryCatch",
	                        "errorObj",
	                        "notEnumerableProp",
	                        "INTERNAL",
	                        body)(
	                    Promise,
	                    fn,
	                    receiver,
	                    withAppended,
	                    maybeWrapAsError,
	                    nodebackForPromise,
	                    util.tryCatch,
	                    util.errorObj,
	                    util.notEnumerableProp,
	                    INTERNAL);
	};
	}
	
	function makeNodePromisifiedClosure(callback, receiver, _, fn, __, multiArgs) {
	    var defaultThis = (function() {return this;})();
	    var method = callback;
	    if (typeof method === "string") {
	        callback = fn;
	    }
	    function promisified() {
	        var _receiver = receiver;
	        if (receiver === THIS) _receiver = this;
	        var promise = new Promise(INTERNAL);
	        promise._captureStackTrace();
	        var cb = typeof method === "string" && this !== defaultThis
	            ? this[method] : callback;
	        var fn = nodebackForPromise(promise, multiArgs);
	        try {
	            cb.apply(_receiver, withAppended(arguments, fn));
	        } catch(e) {
	            promise._rejectCallback(maybeWrapAsError(e), true, true);
	        }
	        if (!promise._isFateSealed()) promise._setAsyncGuaranteed();
	        return promise;
	    }
	    util.notEnumerableProp(promisified, "__isPromisified__", true);
	    return promisified;
	}
	
	var makeNodePromisified = canEvaluate
	    ? makeNodePromisifiedEval
	    : makeNodePromisifiedClosure;
	
	function promisifyAll(obj, suffix, filter, promisifier, multiArgs) {
	    var suffixRegexp = new RegExp(escapeIdentRegex(suffix) + "$");
	    var methods =
	        promisifiableMethods(obj, suffix, suffixRegexp, filter);
	
	    for (var i = 0, len = methods.length; i < len; i+= 2) {
	        var key = methods[i];
	        var fn = methods[i+1];
	        var promisifiedKey = key + suffix;
	        if (promisifier === makeNodePromisified) {
	            obj[promisifiedKey] =
	                makeNodePromisified(key, THIS, key, fn, suffix, multiArgs);
	        } else {
	            var promisified = promisifier(fn, function() {
	                return makeNodePromisified(key, THIS, key,
	                                           fn, suffix, multiArgs);
	            });
	            util.notEnumerableProp(promisified, "__isPromisified__", true);
	            obj[promisifiedKey] = promisified;
	        }
	    }
	    util.toFastProperties(obj);
	    return obj;
	}
	
	function promisify(callback, receiver, multiArgs) {
	    return makeNodePromisified(callback, receiver, undefined,
	                                callback, null, multiArgs);
	}
	
	Promise.promisify = function (fn, options) {
	    if (typeof fn !== "function") {
	        throw new TypeError("expecting a function but got " + util.classString(fn));
	    }
	    if (isPromisified(fn)) {
	        return fn;
	    }
	    options = Object(options);
	    var receiver = options.context === undefined ? THIS : options.context;
	    var multiArgs = !!options.multiArgs;
	    var ret = promisify(fn, receiver, multiArgs);
	    util.copyDescriptors(fn, ret, propsFilter);
	    return ret;
	};
	
	Promise.promisifyAll = function (target, options) {
	    if (typeof target !== "function" && typeof target !== "object") {
	        throw new TypeError("the target of promisifyAll must be an object or a function\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
	    }
	    options = Object(options);
	    var multiArgs = !!options.multiArgs;
	    var suffix = options.suffix;
	    if (typeof suffix !== "string") suffix = defaultSuffix;
	    var filter = options.filter;
	    if (typeof filter !== "function") filter = defaultFilter;
	    var promisifier = options.promisifier;
	    if (typeof promisifier !== "function") promisifier = makeNodePromisified;
	
	    if (!util.isIdentifier(suffix)) {
	        throw new RangeError("suffix must be a valid identifier\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
	    }
	
	    var keys = util.inheritedDataKeys(target);
	    for (var i = 0; i < keys.length; ++i) {
	        var value = target[keys[i]];
	        if (keys[i] !== "constructor" &&
	            util.isClass(value)) {
	            promisifyAll(value.prototype, suffix, filter, promisifier,
	                multiArgs);
	            promisifyAll(value, suffix, filter, promisifier, multiArgs);
	        }
	    }
	
	    return promisifyAll(target, suffix, filter, promisifier, multiArgs);
	};
	};
	
	
	},{"./errors":12,"./nodeback":20,"./util":36}],25:[function(_dereq_,module,exports){
	"use strict";
	module.exports = function(
	    Promise, PromiseArray, tryConvertToPromise, apiRejection) {
	var util = _dereq_("./util");
	var isObject = util.isObject;
	var es5 = _dereq_("./es5");
	var Es6Map;
	if (typeof Map === "function") Es6Map = Map;
	
	var mapToEntries = (function() {
	    var index = 0;
	    var size = 0;
	
	    function extractEntry(value, key) {
	        this[index] = value;
	        this[index + size] = key;
	        index++;
	    }
	
	    return function mapToEntries(map) {
	        size = map.size;
	        index = 0;
	        var ret = new Array(map.size * 2);
	        map.forEach(extractEntry, ret);
	        return ret;
	    };
	})();
	
	var entriesToMap = function(entries) {
	    var ret = new Es6Map();
	    var length = entries.length / 2 | 0;
	    for (var i = 0; i < length; ++i) {
	        var key = entries[length + i];
	        var value = entries[i];
	        ret.set(key, value);
	    }
	    return ret;
	};
	
	function PropertiesPromiseArray(obj) {
	    var isMap = false;
	    var entries;
	    if (Es6Map !== undefined && obj instanceof Es6Map) {
	        entries = mapToEntries(obj);
	        isMap = true;
	    } else {
	        var keys = es5.keys(obj);
	        var len = keys.length;
	        entries = new Array(len * 2);
	        for (var i = 0; i < len; ++i) {
	            var key = keys[i];
	            entries[i] = obj[key];
	            entries[i + len] = key;
	        }
	    }
	    this.constructor$(entries);
	    this._isMap = isMap;
	    this._init$(undefined, -3);
	}
	util.inherits(PropertiesPromiseArray, PromiseArray);
	
	PropertiesPromiseArray.prototype._init = function () {};
	
	PropertiesPromiseArray.prototype._promiseFulfilled = function (value, index) {
	    this._values[index] = value;
	    var totalResolved = ++this._totalResolved;
	    if (totalResolved >= this._length) {
	        var val;
	        if (this._isMap) {
	            val = entriesToMap(this._values);
	        } else {
	            val = {};
	            var keyOffset = this.length();
	            for (var i = 0, len = this.length(); i < len; ++i) {
	                val[this._values[i + keyOffset]] = this._values[i];
	            }
	        }
	        this._resolve(val);
	        return true;
	    }
	    return false;
	};
	
	PropertiesPromiseArray.prototype.shouldCopyValues = function () {
	    return false;
	};
	
	PropertiesPromiseArray.prototype.getActualLength = function (len) {
	    return len >> 1;
	};
	
	function props(promises) {
	    var ret;
	    var castValue = tryConvertToPromise(promises);
	
	    if (!isObject(castValue)) {
	        return apiRejection("cannot await properties of a non-object\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
	    } else if (castValue instanceof Promise) {
	        ret = castValue._then(
	            Promise.props, undefined, undefined, undefined, undefined);
	    } else {
	        ret = new PropertiesPromiseArray(castValue).promise();
	    }
	
	    if (castValue instanceof Promise) {
	        ret._propagateFrom(castValue, 2);
	    }
	    return ret;
	}
	
	Promise.prototype.props = function () {
	    return props(this);
	};
	
	Promise.props = function (promises) {
	    return props(promises);
	};
	};
	
	},{"./es5":13,"./util":36}],26:[function(_dereq_,module,exports){
	"use strict";
	function arrayMove(src, srcIndex, dst, dstIndex, len) {
	    for (var j = 0; j < len; ++j) {
	        dst[j + dstIndex] = src[j + srcIndex];
	        src[j + srcIndex] = void 0;
	    }
	}
	
	function Queue(capacity) {
	    this._capacity = capacity;
	    this._length = 0;
	    this._front = 0;
	}
	
	Queue.prototype._willBeOverCapacity = function (size) {
	    return this._capacity < size;
	};
	
	Queue.prototype._pushOne = function (arg) {
	    var length = this.length();
	    this._checkCapacity(length + 1);
	    var i = (this._front + length) & (this._capacity - 1);
	    this[i] = arg;
	    this._length = length + 1;
	};
	
	Queue.prototype._unshiftOne = function(value) {
	    var capacity = this._capacity;
	    this._checkCapacity(this.length() + 1);
	    var front = this._front;
	    var i = (((( front - 1 ) &
	                    ( capacity - 1) ) ^ capacity ) - capacity );
	    this[i] = value;
	    this._front = i;
	    this._length = this.length() + 1;
	};
	
	Queue.prototype.unshift = function(fn, receiver, arg) {
	    this._unshiftOne(arg);
	    this._unshiftOne(receiver);
	    this._unshiftOne(fn);
	};
	
	Queue.prototype.push = function (fn, receiver, arg) {
	    var length = this.length() + 3;
	    if (this._willBeOverCapacity(length)) {
	        this._pushOne(fn);
	        this._pushOne(receiver);
	        this._pushOne(arg);
	        return;
	    }
	    var j = this._front + length - 3;
	    this._checkCapacity(length);
	    var wrapMask = this._capacity - 1;
	    this[(j + 0) & wrapMask] = fn;
	    this[(j + 1) & wrapMask] = receiver;
	    this[(j + 2) & wrapMask] = arg;
	    this._length = length;
	};
	
	Queue.prototype.shift = function () {
	    var front = this._front,
	        ret = this[front];
	
	    this[front] = undefined;
	    this._front = (front + 1) & (this._capacity - 1);
	    this._length--;
	    return ret;
	};
	
	Queue.prototype.length = function () {
	    return this._length;
	};
	
	Queue.prototype._checkCapacity = function (size) {
	    if (this._capacity < size) {
	        this._resizeTo(this._capacity << 1);
	    }
	};
	
	Queue.prototype._resizeTo = function (capacity) {
	    var oldCapacity = this._capacity;
	    this._capacity = capacity;
	    var front = this._front;
	    var length = this._length;
	    var moveItemsCount = (front + length) & (oldCapacity - 1);
	    arrayMove(this, 0, this, oldCapacity, moveItemsCount);
	};
	
	module.exports = Queue;
	
	},{}],27:[function(_dereq_,module,exports){
	"use strict";
	module.exports = function(
	    Promise, INTERNAL, tryConvertToPromise, apiRejection) {
	var util = _dereq_("./util");
	
	var raceLater = function (promise) {
	    return promise.then(function(array) {
	        return race(array, promise);
	    });
	};
	
	function race(promises, parent) {
	    var maybePromise = tryConvertToPromise(promises);
	
	    if (maybePromise instanceof Promise) {
	        return raceLater(maybePromise);
	    } else {
	        promises = util.asArray(promises);
	        if (promises === null)
	            return apiRejection("expecting an array or an iterable object but got " + util.classString(promises));
	    }
	
	    var ret = new Promise(INTERNAL);
	    if (parent !== undefined) {
	        ret._propagateFrom(parent, 3);
	    }
	    var fulfill = ret._fulfill;
	    var reject = ret._reject;
	    for (var i = 0, len = promises.length; i < len; ++i) {
	        var val = promises[i];
	
	        if (val === undefined && !(i in promises)) {
	            continue;
	        }
	
	        Promise.cast(val)._then(fulfill, reject, undefined, ret, null);
	    }
	    return ret;
	}
	
	Promise.race = function (promises) {
	    return race(promises, undefined);
	};
	
	Promise.prototype.race = function () {
	    return race(this, undefined);
	};
	
	};
	
	},{"./util":36}],28:[function(_dereq_,module,exports){
	"use strict";
	module.exports = function(Promise,
	                          PromiseArray,
	                          apiRejection,
	                          tryConvertToPromise,
	                          INTERNAL,
	                          debug) {
	var getDomain = Promise._getDomain;
	var util = _dereq_("./util");
	var tryCatch = util.tryCatch;
	
	function ReductionPromiseArray(promises, fn, initialValue, _each) {
	    this.constructor$(promises);
	    var domain = getDomain();
	    this._fn = domain === null ? fn : domain.bind(fn);
	    if (initialValue !== undefined) {
	        initialValue = Promise.resolve(initialValue);
	        initialValue._attachCancellationCallback(this);
	    }
	    this._initialValue = initialValue;
	    this._currentCancellable = null;
	    this._eachValues = _each === INTERNAL ? [] : undefined;
	    this._promise._captureStackTrace();
	    this._init$(undefined, -5);
	}
	util.inherits(ReductionPromiseArray, PromiseArray);
	
	ReductionPromiseArray.prototype._gotAccum = function(accum) {
	    if (this._eachValues !== undefined && accum !== INTERNAL) {
	        this._eachValues.push(accum);
	    }
	};
	
	ReductionPromiseArray.prototype._eachComplete = function(value) {
	    this._eachValues.push(value);
	    return this._eachValues;
	};
	
	ReductionPromiseArray.prototype._init = function() {};
	
	ReductionPromiseArray.prototype._resolveEmptyArray = function() {
	    this._resolve(this._eachValues !== undefined ? this._eachValues
	                                                 : this._initialValue);
	};
	
	ReductionPromiseArray.prototype.shouldCopyValues = function () {
	    return false;
	};
	
	ReductionPromiseArray.prototype._resolve = function(value) {
	    this._promise._resolveCallback(value);
	    this._values = null;
	};
	
	ReductionPromiseArray.prototype._resultCancelled = function(sender) {
	    if (sender === this._initialValue) return this._cancel();
	    if (this._isResolved()) return;
	    this._resultCancelled$();
	    if (this._currentCancellable instanceof Promise) {
	        this._currentCancellable.cancel();
	    }
	    if (this._initialValue instanceof Promise) {
	        this._initialValue.cancel();
	    }
	};
	
	ReductionPromiseArray.prototype._iterate = function (values) {
	    this._values = values;
	    var value;
	    var i;
	    var length = values.length;
	    if (this._initialValue !== undefined) {
	        value = this._initialValue;
	        i = 0;
	    } else {
	        value = Promise.resolve(values[0]);
	        i = 1;
	    }
	
	    this._currentCancellable = value;
	
	    if (!value.isRejected()) {
	        for (; i < length; ++i) {
	            var ctx = {
	                accum: null,
	                value: values[i],
	                index: i,
	                length: length,
	                array: this
	            };
	            value = value._then(gotAccum, undefined, undefined, ctx, undefined);
	        }
	    }
	
	    if (this._eachValues !== undefined) {
	        value = value
	            ._then(this._eachComplete, undefined, undefined, this, undefined);
	    }
	    value._then(completed, completed, undefined, value, this);
	};
	
	Promise.prototype.reduce = function (fn, initialValue) {
	    return reduce(this, fn, initialValue, null);
	};
	
	Promise.reduce = function (promises, fn, initialValue, _each) {
	    return reduce(promises, fn, initialValue, _each);
	};
	
	function completed(valueOrReason, array) {
	    if (this.isFulfilled()) {
	        array._resolve(valueOrReason);
	    } else {
	        array._reject(valueOrReason);
	    }
	}
	
	function reduce(promises, fn, initialValue, _each) {
	    if (typeof fn !== "function") {
	        return apiRejection("expecting a function but got " + util.classString(fn));
	    }
	    var array = new ReductionPromiseArray(promises, fn, initialValue, _each);
	    return array.promise();
	}
	
	function gotAccum(accum) {
	    this.accum = accum;
	    this.array._gotAccum(accum);
	    var value = tryConvertToPromise(this.value, this.array._promise);
	    if (value instanceof Promise) {
	        this.array._currentCancellable = value;
	        return value._then(gotValue, undefined, undefined, this, undefined);
	    } else {
	        return gotValue.call(this, value);
	    }
	}
	
	function gotValue(value) {
	    var array = this.array;
	    var promise = array._promise;
	    var fn = tryCatch(array._fn);
	    promise._pushContext();
	    var ret;
	    if (array._eachValues !== undefined) {
	        ret = fn.call(promise._boundValue(), value, this.index, this.length);
	    } else {
	        ret = fn.call(promise._boundValue(),
	                              this.accum, value, this.index, this.length);
	    }
	    if (ret instanceof Promise) {
	        array._currentCancellable = ret;
	    }
	    var promiseCreated = promise._popContext();
	    debug.checkForgottenReturns(
	        ret,
	        promiseCreated,
	        array._eachValues !== undefined ? "Promise.each" : "Promise.reduce",
	        promise
	    );
	    return ret;
	}
	};
	
	},{"./util":36}],29:[function(_dereq_,module,exports){
	"use strict";
	var util = _dereq_("./util");
	var schedule;
	var noAsyncScheduler = function() {
	    throw new Error("No async scheduler available\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
	};
	var NativePromise = util.getNativePromise();
	if (util.isNode && typeof MutationObserver === "undefined") {
	    var GlobalSetImmediate = global.setImmediate;
	    var ProcessNextTick = process.nextTick;
	    schedule = util.isRecentNode
	                ? function(fn) { GlobalSetImmediate.call(global, fn); }
	                : function(fn) { ProcessNextTick.call(process, fn); };
	} else if (typeof NativePromise === "function") {
	    var nativePromise = NativePromise.resolve();
	    schedule = function(fn) {
	        nativePromise.then(fn);
	    };
	} else if ((typeof MutationObserver !== "undefined") &&
	          !(typeof window !== "undefined" &&
	            window.navigator &&
	            window.navigator.standalone)) {
	    schedule = (function() {
	        var div = document.createElement("div");
	        var opts = {attributes: true};
	        var toggleScheduled = false;
	        var div2 = document.createElement("div");
	        var o2 = new MutationObserver(function() {
	            div.classList.toggle("foo");
	            toggleScheduled = false;
	        });
	        o2.observe(div2, opts);
	
	        var scheduleToggle = function() {
	            if (toggleScheduled) return;
	                toggleScheduled = true;
	                div2.classList.toggle("foo");
	            };
	
	            return function schedule(fn) {
	            var o = new MutationObserver(function() {
	                o.disconnect();
	                fn();
	            });
	            o.observe(div, opts);
	            scheduleToggle();
	        };
	    })();
	} else if (typeof setImmediate !== "undefined") {
	    schedule = function (fn) {
	        setImmediate(fn);
	    };
	} else if (typeof setTimeout !== "undefined") {
	    schedule = function (fn) {
	        setTimeout(fn, 0);
	    };
	} else {
	    schedule = noAsyncScheduler;
	}
	module.exports = schedule;
	
	},{"./util":36}],30:[function(_dereq_,module,exports){
	"use strict";
	module.exports =
	    function(Promise, PromiseArray, debug) {
	var PromiseInspection = Promise.PromiseInspection;
	var util = _dereq_("./util");
	
	function SettledPromiseArray(values) {
	    this.constructor$(values);
	}
	util.inherits(SettledPromiseArray, PromiseArray);
	
	SettledPromiseArray.prototype._promiseResolved = function (index, inspection) {
	    this._values[index] = inspection;
	    var totalResolved = ++this._totalResolved;
	    if (totalResolved >= this._length) {
	        this._resolve(this._values);
	        return true;
	    }
	    return false;
	};
	
	SettledPromiseArray.prototype._promiseFulfilled = function (value, index) {
	    var ret = new PromiseInspection();
	    ret._bitField = 33554432;
	    ret._settledValueField = value;
	    return this._promiseResolved(index, ret);
	};
	SettledPromiseArray.prototype._promiseRejected = function (reason, index) {
	    var ret = new PromiseInspection();
	    ret._bitField = 16777216;
	    ret._settledValueField = reason;
	    return this._promiseResolved(index, ret);
	};
	
	Promise.settle = function (promises) {
	    debug.deprecated(".settle()", ".reflect()");
	    return new SettledPromiseArray(promises).promise();
	};
	
	Promise.prototype.settle = function () {
	    return Promise.settle(this);
	};
	};
	
	},{"./util":36}],31:[function(_dereq_,module,exports){
	"use strict";
	module.exports =
	function(Promise, PromiseArray, apiRejection) {
	var util = _dereq_("./util");
	var RangeError = _dereq_("./errors").RangeError;
	var AggregateError = _dereq_("./errors").AggregateError;
	var isArray = util.isArray;
	var CANCELLATION = {};
	
	
	function SomePromiseArray(values) {
	    this.constructor$(values);
	    this._howMany = 0;
	    this._unwrap = false;
	    this._initialized = false;
	}
	util.inherits(SomePromiseArray, PromiseArray);
	
	SomePromiseArray.prototype._init = function () {
	    if (!this._initialized) {
	        return;
	    }
	    if (this._howMany === 0) {
	        this._resolve([]);
	        return;
	    }
	    this._init$(undefined, -5);
	    var isArrayResolved = isArray(this._values);
	    if (!this._isResolved() &&
	        isArrayResolved &&
	        this._howMany > this._canPossiblyFulfill()) {
	        this._reject(this._getRangeError(this.length()));
	    }
	};
	
	SomePromiseArray.prototype.init = function () {
	    this._initialized = true;
	    this._init();
	};
	
	SomePromiseArray.prototype.setUnwrap = function () {
	    this._unwrap = true;
	};
	
	SomePromiseArray.prototype.howMany = function () {
	    return this._howMany;
	};
	
	SomePromiseArray.prototype.setHowMany = function (count) {
	    this._howMany = count;
	};
	
	SomePromiseArray.prototype._promiseFulfilled = function (value) {
	    this._addFulfilled(value);
	    if (this._fulfilled() === this.howMany()) {
	        this._values.length = this.howMany();
	        if (this.howMany() === 1 && this._unwrap) {
	            this._resolve(this._values[0]);
	        } else {
	            this._resolve(this._values);
	        }
	        return true;
	    }
	    return false;
	
	};
	SomePromiseArray.prototype._promiseRejected = function (reason) {
	    this._addRejected(reason);
	    return this._checkOutcome();
	};
	
	SomePromiseArray.prototype._promiseCancelled = function () {
	    if (this._values instanceof Promise || this._values == null) {
	        return this._cancel();
	    }
	    this._addRejected(CANCELLATION);
	    return this._checkOutcome();
	};
	
	SomePromiseArray.prototype._checkOutcome = function() {
	    if (this.howMany() > this._canPossiblyFulfill()) {
	        var e = new AggregateError();
	        for (var i = this.length(); i < this._values.length; ++i) {
	            if (this._values[i] !== CANCELLATION) {
	                e.push(this._values[i]);
	            }
	        }
	        if (e.length > 0) {
	            this._reject(e);
	        } else {
	            this._cancel();
	        }
	        return true;
	    }
	    return false;
	};
	
	SomePromiseArray.prototype._fulfilled = function () {
	    return this._totalResolved;
	};
	
	SomePromiseArray.prototype._rejected = function () {
	    return this._values.length - this.length();
	};
	
	SomePromiseArray.prototype._addRejected = function (reason) {
	    this._values.push(reason);
	};
	
	SomePromiseArray.prototype._addFulfilled = function (value) {
	    this._values[this._totalResolved++] = value;
	};
	
	SomePromiseArray.prototype._canPossiblyFulfill = function () {
	    return this.length() - this._rejected();
	};
	
	SomePromiseArray.prototype._getRangeError = function (count) {
	    var message = "Input array must contain at least " +
	            this._howMany + " items but contains only " + count + " items";
	    return new RangeError(message);
	};
	
	SomePromiseArray.prototype._resolveEmptyArray = function () {
	    this._reject(this._getRangeError(0));
	};
	
	function some(promises, howMany) {
	    if ((howMany | 0) !== howMany || howMany < 0) {
	        return apiRejection("expecting a positive integer\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
	    }
	    var ret = new SomePromiseArray(promises);
	    var promise = ret.promise();
	    ret.setHowMany(howMany);
	    ret.init();
	    return promise;
	}
	
	Promise.some = function (promises, howMany) {
	    return some(promises, howMany);
	};
	
	Promise.prototype.some = function (howMany) {
	    return some(this, howMany);
	};
	
	Promise._SomePromiseArray = SomePromiseArray;
	};
	
	},{"./errors":12,"./util":36}],32:[function(_dereq_,module,exports){
	"use strict";
	module.exports = function(Promise) {
	function PromiseInspection(promise) {
	    if (promise !== undefined) {
	        promise = promise._target();
	        this._bitField = promise._bitField;
	        this._settledValueField = promise._isFateSealed()
	            ? promise._settledValue() : undefined;
	    }
	    else {
	        this._bitField = 0;
	        this._settledValueField = undefined;
	    }
	}
	
	PromiseInspection.prototype._settledValue = function() {
	    return this._settledValueField;
	};
	
	var value = PromiseInspection.prototype.value = function () {
	    if (!this.isFulfilled()) {
	        throw new TypeError("cannot get fulfillment value of a non-fulfilled promise\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
	    }
	    return this._settledValue();
	};
	
	var reason = PromiseInspection.prototype.error =
	PromiseInspection.prototype.reason = function () {
	    if (!this.isRejected()) {
	        throw new TypeError("cannot get rejection reason of a non-rejected promise\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
	    }
	    return this._settledValue();
	};
	
	var isFulfilled = PromiseInspection.prototype.isFulfilled = function() {
	    return (this._bitField & 33554432) !== 0;
	};
	
	var isRejected = PromiseInspection.prototype.isRejected = function () {
	    return (this._bitField & 16777216) !== 0;
	};
	
	var isPending = PromiseInspection.prototype.isPending = function () {
	    return (this._bitField & 50397184) === 0;
	};
	
	var isResolved = PromiseInspection.prototype.isResolved = function () {
	    return (this._bitField & 50331648) !== 0;
	};
	
	PromiseInspection.prototype.isCancelled =
	Promise.prototype._isCancelled = function() {
	    return (this._bitField & 65536) === 65536;
	};
	
	Promise.prototype.isCancelled = function() {
	    return this._target()._isCancelled();
	};
	
	Promise.prototype.isPending = function() {
	    return isPending.call(this._target());
	};
	
	Promise.prototype.isRejected = function() {
	    return isRejected.call(this._target());
	};
	
	Promise.prototype.isFulfilled = function() {
	    return isFulfilled.call(this._target());
	};
	
	Promise.prototype.isResolved = function() {
	    return isResolved.call(this._target());
	};
	
	Promise.prototype.value = function() {
	    return value.call(this._target());
	};
	
	Promise.prototype.reason = function() {
	    var target = this._target();
	    target._unsetRejectionIsUnhandled();
	    return reason.call(target);
	};
	
	Promise.prototype._value = function() {
	    return this._settledValue();
	};
	
	Promise.prototype._reason = function() {
	    this._unsetRejectionIsUnhandled();
	    return this._settledValue();
	};
	
	Promise.PromiseInspection = PromiseInspection;
	};
	
	},{}],33:[function(_dereq_,module,exports){
	"use strict";
	module.exports = function(Promise, INTERNAL) {
	var util = _dereq_("./util");
	var errorObj = util.errorObj;
	var isObject = util.isObject;
	
	function tryConvertToPromise(obj, context) {
	    if (isObject(obj)) {
	        if (obj instanceof Promise) return obj;
	        var then = getThen(obj);
	        if (then === errorObj) {
	            if (context) context._pushContext();
	            var ret = Promise.reject(then.e);
	            if (context) context._popContext();
	            return ret;
	        } else if (typeof then === "function") {
	            if (isAnyBluebirdPromise(obj)) {
	                var ret = new Promise(INTERNAL);
	                obj._then(
	                    ret._fulfill,
	                    ret._reject,
	                    undefined,
	                    ret,
	                    null
	                );
	                return ret;
	            }
	            return doThenable(obj, then, context);
	        }
	    }
	    return obj;
	}
	
	function doGetThen(obj) {
	    return obj.then;
	}
	
	function getThen(obj) {
	    try {
	        return doGetThen(obj);
	    } catch (e) {
	        errorObj.e = e;
	        return errorObj;
	    }
	}
	
	var hasProp = {}.hasOwnProperty;
	function isAnyBluebirdPromise(obj) {
	    try {
	        return hasProp.call(obj, "_promise0");
	    } catch (e) {
	        return false;
	    }
	}
	
	function doThenable(x, then, context) {
	    var promise = new Promise(INTERNAL);
	    var ret = promise;
	    if (context) context._pushContext();
	    promise._captureStackTrace();
	    if (context) context._popContext();
	    var synchronous = true;
	    var result = util.tryCatch(then).call(x, resolve, reject);
	    synchronous = false;
	
	    if (promise && result === errorObj) {
	        promise._rejectCallback(result.e, true, true);
	        promise = null;
	    }
	
	    function resolve(value) {
	        if (!promise) return;
	        promise._resolveCallback(value);
	        promise = null;
	    }
	
	    function reject(reason) {
	        if (!promise) return;
	        promise._rejectCallback(reason, synchronous, true);
	        promise = null;
	    }
	    return ret;
	}
	
	return tryConvertToPromise;
	};
	
	},{"./util":36}],34:[function(_dereq_,module,exports){
	"use strict";
	module.exports = function(Promise, INTERNAL, debug) {
	var util = _dereq_("./util");
	var TimeoutError = Promise.TimeoutError;
	
	function HandleWrapper(handle)  {
	    this.handle = handle;
	}
	
	HandleWrapper.prototype._resultCancelled = function() {
	    clearTimeout(this.handle);
	};
	
	var afterValue = function(value) { return delay(+this).thenReturn(value); };
	var delay = Promise.delay = function (ms, value) {
	    var ret;
	    var handle;
	    if (value !== undefined) {
	        ret = Promise.resolve(value)
	                ._then(afterValue, null, null, ms, undefined);
	        if (debug.cancellation() && value instanceof Promise) {
	            ret._setOnCancel(value);
	        }
	    } else {
	        ret = new Promise(INTERNAL);
	        handle = setTimeout(function() { ret._fulfill(); }, +ms);
	        if (debug.cancellation()) {
	            ret._setOnCancel(new HandleWrapper(handle));
	        }
	    }
	    ret._setAsyncGuaranteed();
	    return ret;
	};
	
	Promise.prototype.delay = function (ms) {
	    return delay(ms, this);
	};
	
	var afterTimeout = function (promise, message, parent) {
	    var err;
	    if (typeof message !== "string") {
	        if (message instanceof Error) {
	            err = message;
	        } else {
	            err = new TimeoutError("operation timed out");
	        }
	    } else {
	        err = new TimeoutError(message);
	    }
	    util.markAsOriginatingFromRejection(err);
	    promise._attachExtraTrace(err);
	    promise._reject(err);
	
	    if (parent != null) {
	        parent.cancel();
	    }
	};
	
	function successClear(value) {
	    clearTimeout(this.handle);
	    return value;
	}
	
	function failureClear(reason) {
	    clearTimeout(this.handle);
	    throw reason;
	}
	
	Promise.prototype.timeout = function (ms, message) {
	    ms = +ms;
	    var ret, parent;
	
	    var handleWrapper = new HandleWrapper(setTimeout(function timeoutTimeout() {
	        if (ret.isPending()) {
	            afterTimeout(ret, message, parent);
	        }
	    }, ms));
	
	    if (debug.cancellation()) {
	        parent = this.then();
	        ret = parent._then(successClear, failureClear,
	                            undefined, handleWrapper, undefined);
	        ret._setOnCancel(handleWrapper);
	    } else {
	        ret = this._then(successClear, failureClear,
	                            undefined, handleWrapper, undefined);
	    }
	
	    return ret;
	};
	
	};
	
	},{"./util":36}],35:[function(_dereq_,module,exports){
	"use strict";
	module.exports = function (Promise, apiRejection, tryConvertToPromise,
	    createContext, INTERNAL, debug) {
	    var util = _dereq_("./util");
	    var TypeError = _dereq_("./errors").TypeError;
	    var inherits = _dereq_("./util").inherits;
	    var errorObj = util.errorObj;
	    var tryCatch = util.tryCatch;
	    var NULL = {};
	
	    function thrower(e) {
	        setTimeout(function(){throw e;}, 0);
	    }
	
	    function castPreservingDisposable(thenable) {
	        var maybePromise = tryConvertToPromise(thenable);
	        if (maybePromise !== thenable &&
	            typeof thenable._isDisposable === "function" &&
	            typeof thenable._getDisposer === "function" &&
	            thenable._isDisposable()) {
	            maybePromise._setDisposable(thenable._getDisposer());
	        }
	        return maybePromise;
	    }
	    function dispose(resources, inspection) {
	        var i = 0;
	        var len = resources.length;
	        var ret = new Promise(INTERNAL);
	        function iterator() {
	            if (i >= len) return ret._fulfill();
	            var maybePromise = castPreservingDisposable(resources[i++]);
	            if (maybePromise instanceof Promise &&
	                maybePromise._isDisposable()) {
	                try {
	                    maybePromise = tryConvertToPromise(
	                        maybePromise._getDisposer().tryDispose(inspection),
	                        resources.promise);
	                } catch (e) {
	                    return thrower(e);
	                }
	                if (maybePromise instanceof Promise) {
	                    return maybePromise._then(iterator, thrower,
	                                              null, null, null);
	                }
	            }
	            iterator();
	        }
	        iterator();
	        return ret;
	    }
	
	    function Disposer(data, promise, context) {
	        this._data = data;
	        this._promise = promise;
	        this._context = context;
	    }
	
	    Disposer.prototype.data = function () {
	        return this._data;
	    };
	
	    Disposer.prototype.promise = function () {
	        return this._promise;
	    };
	
	    Disposer.prototype.resource = function () {
	        if (this.promise().isFulfilled()) {
	            return this.promise().value();
	        }
	        return NULL;
	    };
	
	    Disposer.prototype.tryDispose = function(inspection) {
	        var resource = this.resource();
	        var context = this._context;
	        if (context !== undefined) context._pushContext();
	        var ret = resource !== NULL
	            ? this.doDispose(resource, inspection) : null;
	        if (context !== undefined) context._popContext();
	        this._promise._unsetDisposable();
	        this._data = null;
	        return ret;
	    };
	
	    Disposer.isDisposer = function (d) {
	        return (d != null &&
	                typeof d.resource === "function" &&
	                typeof d.tryDispose === "function");
	    };
	
	    function FunctionDisposer(fn, promise, context) {
	        this.constructor$(fn, promise, context);
	    }
	    inherits(FunctionDisposer, Disposer);
	
	    FunctionDisposer.prototype.doDispose = function (resource, inspection) {
	        var fn = this.data();
	        return fn.call(resource, resource, inspection);
	    };
	
	    function maybeUnwrapDisposer(value) {
	        if (Disposer.isDisposer(value)) {
	            this.resources[this.index]._setDisposable(value);
	            return value.promise();
	        }
	        return value;
	    }
	
	    function ResourceList(length) {
	        this.length = length;
	        this.promise = null;
	        this[length-1] = null;
	    }
	
	    ResourceList.prototype._resultCancelled = function() {
	        var len = this.length;
	        for (var i = 0; i < len; ++i) {
	            var item = this[i];
	            if (item instanceof Promise) {
	                item.cancel();
	            }
	        }
	    };
	
	    Promise.using = function () {
	        var len = arguments.length;
	        if (len < 2) return apiRejection(
	                        "you must pass at least 2 arguments to Promise.using");
	        var fn = arguments[len - 1];
	        if (typeof fn !== "function") {
	            return apiRejection("expecting a function but got " + util.classString(fn));
	        }
	        var input;
	        var spreadArgs = true;
	        if (len === 2 && Array.isArray(arguments[0])) {
	            input = arguments[0];
	            len = input.length;
	            spreadArgs = false;
	        } else {
	            input = arguments;
	            len--;
	        }
	        var resources = new ResourceList(len);
	        for (var i = 0; i < len; ++i) {
	            var resource = input[i];
	            if (Disposer.isDisposer(resource)) {
	                var disposer = resource;
	                resource = resource.promise();
	                resource._setDisposable(disposer);
	            } else {
	                var maybePromise = tryConvertToPromise(resource);
	                if (maybePromise instanceof Promise) {
	                    resource =
	                        maybePromise._then(maybeUnwrapDisposer, null, null, {
	                            resources: resources,
	                            index: i
	                    }, undefined);
	                }
	            }
	            resources[i] = resource;
	        }
	
	        var reflectedResources = new Array(resources.length);
	        for (var i = 0; i < reflectedResources.length; ++i) {
	            reflectedResources[i] = Promise.resolve(resources[i]).reflect();
	        }
	
	        var resultPromise = Promise.all(reflectedResources)
	            .then(function(inspections) {
	                for (var i = 0; i < inspections.length; ++i) {
	                    var inspection = inspections[i];
	                    if (inspection.isRejected()) {
	                        errorObj.e = inspection.error();
	                        return errorObj;
	                    } else if (!inspection.isFulfilled()) {
	                        resultPromise.cancel();
	                        return;
	                    }
	                    inspections[i] = inspection.value();
	                }
	                promise._pushContext();
	
	                fn = tryCatch(fn);
	                var ret = spreadArgs
	                    ? fn.apply(undefined, inspections) : fn(inspections);
	                var promiseCreated = promise._popContext();
	                debug.checkForgottenReturns(
	                    ret, promiseCreated, "Promise.using", promise);
	                return ret;
	            });
	
	        var promise = resultPromise.lastly(function() {
	            var inspection = new Promise.PromiseInspection(resultPromise);
	            return dispose(resources, inspection);
	        });
	        resources.promise = promise;
	        promise._setOnCancel(resources);
	        return promise;
	    };
	
	    Promise.prototype._setDisposable = function (disposer) {
	        this._bitField = this._bitField | 131072;
	        this._disposer = disposer;
	    };
	
	    Promise.prototype._isDisposable = function () {
	        return (this._bitField & 131072) > 0;
	    };
	
	    Promise.prototype._getDisposer = function () {
	        return this._disposer;
	    };
	
	    Promise.prototype._unsetDisposable = function () {
	        this._bitField = this._bitField & (~131072);
	        this._disposer = undefined;
	    };
	
	    Promise.prototype.disposer = function (fn) {
	        if (typeof fn === "function") {
	            return new FunctionDisposer(fn, this, createContext());
	        }
	        throw new TypeError();
	    };
	
	};
	
	},{"./errors":12,"./util":36}],36:[function(_dereq_,module,exports){
	"use strict";
	var es5 = _dereq_("./es5");
	var canEvaluate = typeof navigator == "undefined";
	
	var errorObj = {e: {}};
	var tryCatchTarget;
	var globalObject = typeof self !== "undefined" ? self :
	    typeof window !== "undefined" ? window :
	    typeof global !== "undefined" ? global :
	    this !== undefined ? this : null;
	
	function tryCatcher() {
	    try {
	        var target = tryCatchTarget;
	        tryCatchTarget = null;
	        return target.apply(this, arguments);
	    } catch (e) {
	        errorObj.e = e;
	        return errorObj;
	    }
	}
	function tryCatch(fn) {
	    tryCatchTarget = fn;
	    return tryCatcher;
	}
	
	var inherits = function(Child, Parent) {
	    var hasProp = {}.hasOwnProperty;
	
	    function T() {
	        this.constructor = Child;
	        this.constructor$ = Parent;
	        for (var propertyName in Parent.prototype) {
	            if (hasProp.call(Parent.prototype, propertyName) &&
	                propertyName.charAt(propertyName.length-1) !== "$"
	           ) {
	                this[propertyName + "$"] = Parent.prototype[propertyName];
	            }
	        }
	    }
	    T.prototype = Parent.prototype;
	    Child.prototype = new T();
	    return Child.prototype;
	};
	
	
	function isPrimitive(val) {
	    return val == null || val === true || val === false ||
	        typeof val === "string" || typeof val === "number";
	
	}
	
	function isObject(value) {
	    return typeof value === "function" ||
	           typeof value === "object" && value !== null;
	}
	
	function maybeWrapAsError(maybeError) {
	    if (!isPrimitive(maybeError)) return maybeError;
	
	    return new Error(safeToString(maybeError));
	}
	
	function withAppended(target, appendee) {
	    var len = target.length;
	    var ret = new Array(len + 1);
	    var i;
	    for (i = 0; i < len; ++i) {
	        ret[i] = target[i];
	    }
	    ret[i] = appendee;
	    return ret;
	}
	
	function getDataPropertyOrDefault(obj, key, defaultValue) {
	    if (es5.isES5) {
	        var desc = Object.getOwnPropertyDescriptor(obj, key);
	
	        if (desc != null) {
	            return desc.get == null && desc.set == null
	                    ? desc.value
	                    : defaultValue;
	        }
	    } else {
	        return {}.hasOwnProperty.call(obj, key) ? obj[key] : undefined;
	    }
	}
	
	function notEnumerableProp(obj, name, value) {
	    if (isPrimitive(obj)) return obj;
	    var descriptor = {
	        value: value,
	        configurable: true,
	        enumerable: false,
	        writable: true
	    };
	    es5.defineProperty(obj, name, descriptor);
	    return obj;
	}
	
	function thrower(r) {
	    throw r;
	}
	
	var inheritedDataKeys = (function() {
	    var excludedPrototypes = [
	        Array.prototype,
	        Object.prototype,
	        Function.prototype
	    ];
	
	    var isExcludedProto = function(val) {
	        for (var i = 0; i < excludedPrototypes.length; ++i) {
	            if (excludedPrototypes[i] === val) {
	                return true;
	            }
	        }
	        return false;
	    };
	
	    if (es5.isES5) {
	        var getKeys = Object.getOwnPropertyNames;
	        return function(obj) {
	            var ret = [];
	            var visitedKeys = Object.create(null);
	            while (obj != null && !isExcludedProto(obj)) {
	                var keys;
	                try {
	                    keys = getKeys(obj);
	                } catch (e) {
	                    return ret;
	                }
	                for (var i = 0; i < keys.length; ++i) {
	                    var key = keys[i];
	                    if (visitedKeys[key]) continue;
	                    visitedKeys[key] = true;
	                    var desc = Object.getOwnPropertyDescriptor(obj, key);
	                    if (desc != null && desc.get == null && desc.set == null) {
	                        ret.push(key);
	                    }
	                }
	                obj = es5.getPrototypeOf(obj);
	            }
	            return ret;
	        };
	    } else {
	        var hasProp = {}.hasOwnProperty;
	        return function(obj) {
	            if (isExcludedProto(obj)) return [];
	            var ret = [];
	
	            /*jshint forin:false */
	            enumeration: for (var key in obj) {
	                if (hasProp.call(obj, key)) {
	                    ret.push(key);
	                } else {
	                    for (var i = 0; i < excludedPrototypes.length; ++i) {
	                        if (hasProp.call(excludedPrototypes[i], key)) {
	                            continue enumeration;
	                        }
	                    }
	                    ret.push(key);
	                }
	            }
	            return ret;
	        };
	    }
	
	})();
	
	var thisAssignmentPattern = /this\s*\.\s*\S+\s*=/;
	function isClass(fn) {
	    try {
	        if (typeof fn === "function") {
	            var keys = es5.names(fn.prototype);
	
	            var hasMethods = es5.isES5 && keys.length > 1;
	            var hasMethodsOtherThanConstructor = keys.length > 0 &&
	                !(keys.length === 1 && keys[0] === "constructor");
	            var hasThisAssignmentAndStaticMethods =
	                thisAssignmentPattern.test(fn + "") && es5.names(fn).length > 0;
	
	            if (hasMethods || hasMethodsOtherThanConstructor ||
	                hasThisAssignmentAndStaticMethods) {
	                return true;
	            }
	        }
	        return false;
	    } catch (e) {
	        return false;
	    }
	}
	
	function toFastProperties(obj) {
	    /*jshint -W027,-W055,-W031*/
	    function FakeConstructor() {}
	    FakeConstructor.prototype = obj;
	    var l = 8;
	    while (l--) new FakeConstructor();
	    return obj;
	    eval(obj);
	}
	
	var rident = /^[a-z$_][a-z$_0-9]*$/i;
	function isIdentifier(str) {
	    return rident.test(str);
	}
	
	function filledRange(count, prefix, suffix) {
	    var ret = new Array(count);
	    for(var i = 0; i < count; ++i) {
	        ret[i] = prefix + i + suffix;
	    }
	    return ret;
	}
	
	function safeToString(obj) {
	    try {
	        return obj + "";
	    } catch (e) {
	        return "[no string representation]";
	    }
	}
	
	function isError(obj) {
	    return obj !== null &&
	           typeof obj === "object" &&
	           typeof obj.message === "string" &&
	           typeof obj.name === "string";
	}
	
	function markAsOriginatingFromRejection(e) {
	    try {
	        notEnumerableProp(e, "isOperational", true);
	    }
	    catch(ignore) {}
	}
	
	function originatesFromRejection(e) {
	    if (e == null) return false;
	    return ((e instanceof Error["__BluebirdErrorTypes__"].OperationalError) ||
	        e["isOperational"] === true);
	}
	
	function canAttachTrace(obj) {
	    return isError(obj) && es5.propertyIsWritable(obj, "stack");
	}
	
	var ensureErrorObject = (function() {
	    if (!("stack" in new Error())) {
	        return function(value) {
	            if (canAttachTrace(value)) return value;
	            try {throw new Error(safeToString(value));}
	            catch(err) {return err;}
	        };
	    } else {
	        return function(value) {
	            if (canAttachTrace(value)) return value;
	            return new Error(safeToString(value));
	        };
	    }
	})();
	
	function classString(obj) {
	    return {}.toString.call(obj);
	}
	
	function copyDescriptors(from, to, filter) {
	    var keys = es5.names(from);
	    for (var i = 0; i < keys.length; ++i) {
	        var key = keys[i];
	        if (filter(key)) {
	            try {
	                es5.defineProperty(to, key, es5.getDescriptor(from, key));
	            } catch (ignore) {}
	        }
	    }
	}
	
	var asArray = function(v) {
	    if (es5.isArray(v)) {
	        return v;
	    }
	    return null;
	};
	
	if (typeof Symbol !== "undefined" && Symbol.iterator) {
	    var ArrayFrom = typeof Array.from === "function" ? function(v) {
	        return Array.from(v);
	    } : function(v) {
	        var ret = [];
	        var it = v[Symbol.iterator]();
	        var itResult;
	        while (!((itResult = it.next()).done)) {
	            ret.push(itResult.value);
	        }
	        return ret;
	    };
	
	    asArray = function(v) {
	        if (es5.isArray(v)) {
	            return v;
	        } else if (v != null && typeof v[Symbol.iterator] === "function") {
	            return ArrayFrom(v);
	        }
	        return null;
	    };
	}
	
	var isNode = typeof process !== "undefined" &&
	        classString(process).toLowerCase() === "[object process]";
	
	function env(key, def) {
	    return isNode ? process.env[key] : def;
	}
	
	function getNativePromise() {
	    if (typeof Promise === "function") {
	        try {
	            var promise = new Promise(function(){});
	            if ({}.toString.call(promise) === "[object Promise]") {
	                return Promise;
	            }
	        } catch (e) {}
	    }
	}
	
	var ret = {
	    isClass: isClass,
	    isIdentifier: isIdentifier,
	    inheritedDataKeys: inheritedDataKeys,
	    getDataPropertyOrDefault: getDataPropertyOrDefault,
	    thrower: thrower,
	    isArray: es5.isArray,
	    asArray: asArray,
	    notEnumerableProp: notEnumerableProp,
	    isPrimitive: isPrimitive,
	    isObject: isObject,
	    isError: isError,
	    canEvaluate: canEvaluate,
	    errorObj: errorObj,
	    tryCatch: tryCatch,
	    inherits: inherits,
	    withAppended: withAppended,
	    maybeWrapAsError: maybeWrapAsError,
	    toFastProperties: toFastProperties,
	    filledRange: filledRange,
	    toString: safeToString,
	    canAttachTrace: canAttachTrace,
	    ensureErrorObject: ensureErrorObject,
	    originatesFromRejection: originatesFromRejection,
	    markAsOriginatingFromRejection: markAsOriginatingFromRejection,
	    classString: classString,
	    copyDescriptors: copyDescriptors,
	    hasDevTools: typeof chrome !== "undefined" && chrome &&
	                 typeof chrome.loadTimes === "function",
	    isNode: isNode,
	    env: env,
	    global: globalObject,
	    getNativePromise: getNativePromise
	};
	ret.isRecentNode = ret.isNode && (function() {
	    var version = process.versions.node.split(".").map(Number);
	    return (version[0] === 0 && version[1] > 10) || (version[0] > 0);
	})();
	
	if (ret.isNode) ret.toFastProperties(process);
	
	try {throw new Error(); } catch (e) {ret.lastLineError = e;}
	module.exports = ret;
	
	},{"./es5":13}]},{},[4])(4)
	});                    ;if (typeof window !== 'undefined' && window !== null) {                               window.P = window.Promise;                                                     } else if (typeof self !== 'undefined' && self !== null) {                             self.P = self.Promise;                                                         }
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(294), (function() { return this; }()), __webpack_require__(1826).setImmediate))

/***/ }),
/* 2977 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var bind = __webpack_require__(1727);
	var define = __webpack_require__(2978);
	
	var implementation = __webpack_require__(2982);
	var getPolyfill = __webpack_require__(3009);
	var shim = __webpack_require__(3010);
	
	var bound = bind.call(Function.call, getPolyfill());
	
	define(bound, {
		getPolyfill: getPolyfill,
		implementation: implementation,
		shim: shim
	});
	
	module.exports = bound;


/***/ }),
/* 2978 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var keys = __webpack_require__(2979);
	var hasSymbols = typeof Symbol === 'function' && typeof Symbol('foo') === 'symbol';
	
	var toStr = Object.prototype.toString;
	var concat = Array.prototype.concat;
	var origDefineProperty = Object.defineProperty;
	
	var isFunction = function (fn) {
		return typeof fn === 'function' && toStr.call(fn) === '[object Function]';
	};
	
	var arePropertyDescriptorsSupported = function () {
		var obj = {};
		try {
			origDefineProperty(obj, 'x', { enumerable: false, value: obj });
			// eslint-disable-next-line no-unused-vars, no-restricted-syntax
			for (var _ in obj) { // jscs:ignore disallowUnusedVariables
				return false;
			}
			return obj.x === obj;
		} catch (e) { /* this is IE 8. */
			return false;
		}
	};
	var supportsDescriptors = origDefineProperty && arePropertyDescriptorsSupported();
	
	var defineProperty = function (object, name, value, predicate) {
		if (name in object && (!isFunction(predicate) || !predicate())) {
			return;
		}
		if (supportsDescriptors) {
			origDefineProperty(object, name, {
				configurable: true,
				enumerable: false,
				value: value,
				writable: true
			});
		} else {
			object[name] = value;
		}
	};
	
	var defineProperties = function (object, map) {
		var predicates = arguments.length > 2 ? arguments[2] : {};
		var props = keys(map);
		if (hasSymbols) {
			props = concat.call(props, Object.getOwnPropertySymbols(map));
		}
		for (var i = 0; i < props.length; i += 1) {
			defineProperty(object, props[i], map[props[i]], predicates[props[i]]);
		}
	};
	
	defineProperties.supportsDescriptors = !!supportsDescriptors;
	
	module.exports = defineProperties;


/***/ }),
/* 2979 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var slice = Array.prototype.slice;
	var isArgs = __webpack_require__(2980);
	
	var origKeys = Object.keys;
	var keysShim = origKeys ? function keys(o) { return origKeys(o); } : __webpack_require__(2981);
	
	var originalKeys = Object.keys;
	
	keysShim.shim = function shimObjectKeys() {
		if (Object.keys) {
			var keysWorksWithArguments = (function () {
				// Safari 5.0 bug
				var args = Object.keys(arguments);
				return args && args.length === arguments.length;
			}(1, 2));
			if (!keysWorksWithArguments) {
				Object.keys = function keys(object) { // eslint-disable-line func-name-matching
					if (isArgs(object)) {
						return originalKeys(slice.call(object));
					}
					return originalKeys(object);
				};
			}
		} else {
			Object.keys = keysShim;
		}
		return Object.keys || keysShim;
	};
	
	module.exports = keysShim;


/***/ }),
/* 2980 */
/***/ (function(module, exports) {

	'use strict';
	
	var toStr = Object.prototype.toString;
	
	module.exports = function isArguments(value) {
		var str = toStr.call(value);
		var isArgs = str === '[object Arguments]';
		if (!isArgs) {
			isArgs = str !== '[object Array]' &&
				value !== null &&
				typeof value === 'object' &&
				typeof value.length === 'number' &&
				value.length >= 0 &&
				toStr.call(value.callee) === '[object Function]';
		}
		return isArgs;
	};


/***/ }),
/* 2981 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var keysShim;
	if (!Object.keys) {
		// modified from https://github.com/es-shims/es5-shim
		var has = Object.prototype.hasOwnProperty;
		var toStr = Object.prototype.toString;
		var isArgs = __webpack_require__(2980); // eslint-disable-line global-require
		var isEnumerable = Object.prototype.propertyIsEnumerable;
		var hasDontEnumBug = !isEnumerable.call({ toString: null }, 'toString');
		var hasProtoEnumBug = isEnumerable.call(function () {}, 'prototype');
		var dontEnums = [
			'toString',
			'toLocaleString',
			'valueOf',
			'hasOwnProperty',
			'isPrototypeOf',
			'propertyIsEnumerable',
			'constructor'
		];
		var equalsConstructorPrototype = function (o) {
			var ctor = o.constructor;
			return ctor && ctor.prototype === o;
		};
		var excludedKeys = {
			$applicationCache: true,
			$console: true,
			$external: true,
			$frame: true,
			$frameElement: true,
			$frames: true,
			$innerHeight: true,
			$innerWidth: true,
			$outerHeight: true,
			$outerWidth: true,
			$pageXOffset: true,
			$pageYOffset: true,
			$parent: true,
			$scrollLeft: true,
			$scrollTop: true,
			$scrollX: true,
			$scrollY: true,
			$self: true,
			$webkitIndexedDB: true,
			$webkitStorageInfo: true,
			$window: true
		};
		var hasAutomationEqualityBug = (function () {
			/* global window */
			if (typeof window === 'undefined') { return false; }
			for (var k in window) {
				try {
					if (!excludedKeys['$' + k] && has.call(window, k) && window[k] !== null && typeof window[k] === 'object') {
						try {
							equalsConstructorPrototype(window[k]);
						} catch (e) {
							return true;
						}
					}
				} catch (e) {
					return true;
				}
			}
			return false;
		}());
		var equalsConstructorPrototypeIfNotBuggy = function (o) {
			/* global window */
			if (typeof window === 'undefined' || !hasAutomationEqualityBug) {
				return equalsConstructorPrototype(o);
			}
			try {
				return equalsConstructorPrototype(o);
			} catch (e) {
				return false;
			}
		};
	
		keysShim = function keys(object) {
			var isObject = object !== null && typeof object === 'object';
			var isFunction = toStr.call(object) === '[object Function]';
			var isArguments = isArgs(object);
			var isString = isObject && toStr.call(object) === '[object String]';
			var theKeys = [];
	
			if (!isObject && !isFunction && !isArguments) {
				throw new TypeError('Object.keys called on a non-object');
			}
	
			var skipProto = hasProtoEnumBug && isFunction;
			if (isString && object.length > 0 && !has.call(object, 0)) {
				for (var i = 0; i < object.length; ++i) {
					theKeys.push(String(i));
				}
			}
	
			if (isArguments && object.length > 0) {
				for (var j = 0; j < object.length; ++j) {
					theKeys.push(String(j));
				}
			} else {
				for (var name in object) {
					if (!(skipProto && name === 'prototype') && has.call(object, name)) {
						theKeys.push(String(name));
					}
				}
			}
	
			if (hasDontEnumBug) {
				var skipConstructor = equalsConstructorPrototypeIfNotBuggy(object);
	
				for (var k = 0; k < dontEnums.length; ++k) {
					if (!(skipConstructor && dontEnums[k] === 'constructor') && has.call(object, dontEnums[k])) {
						theKeys.push(dontEnums[k]);
					}
				}
			}
			return theKeys;
		};
	}
	module.exports = keysShim;


/***/ }),
/* 2982 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var requirePromise = __webpack_require__(2983);
	
	requirePromise();
	
	var ES = __webpack_require__(2984);
	var bind = __webpack_require__(1727);
	
	var promiseResolve = function PromiseResolve(C, value) {
		return new C(function (resolve) {
			resolve(value);
		});
	};
	
	var OriginalPromise = Promise;
	
	var createThenFinally = function CreateThenFinally(C, onFinally) {
		return function (value) {
			var result = onFinally();
			var promise = promiseResolve(C, result);
			var valueThunk = function () {
				return value;
			};
			return promise.then(valueThunk);
		};
	};
	
	var createCatchFinally = function CreateCatchFinally(C, onFinally) {
		return function (reason) {
			var result = onFinally();
			var promise = promiseResolve(C, result);
			var thrower = function () {
				throw reason;
			};
			return promise.then(thrower);
		};
	};
	
	var then = bind.call(Function.call, OriginalPromise.prototype.then);
	
	var promiseFinally = function finally_(onFinally) {
		/* eslint no-invalid-this: 0 */
	
		var promise = this;
	
		then(promise, null, function () {}); // throw if IsPromise(this) is false; catch() to avoid unhandled rejection warnings
	
		var C = ES.SpeciesConstructor(promise, OriginalPromise); // may throw
	
		var thenFinally = onFinally;
		var catchFinally = onFinally;
		if (ES.IsCallable(onFinally)) {
			thenFinally = createThenFinally(C, onFinally);
			catchFinally = createCatchFinally(C, onFinally);
		}
	
		return promise.then(thenFinally, catchFinally);
	};
	
	if (Object.getOwnPropertyDescriptor) {
		var descriptor = Object.getOwnPropertyDescriptor(promiseFinally, 'name');
		if (descriptor && descriptor.configurable) {
			Object.defineProperty(promiseFinally, 'name', { configurable: true, value: 'finally' });
		}
	}
	
	module.exports = promiseFinally;


/***/ }),
/* 2983 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function requirePromise() {
		if (typeof Promise !== 'function') {
			throw new TypeError('`Promise.prototype.finally` requires a global `Promise` be available.');
		}
	};


/***/ }),
/* 2984 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(2985);


/***/ }),
/* 2985 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var ES2015 = __webpack_require__(2986);
	var assign = __webpack_require__(3002);
	
	var ES2016 = assign(assign({}, ES2015), {
		// https://github.com/tc39/ecma262/pull/60
		SameValueNonNumber: function SameValueNonNumber(x, y) {
			if (typeof x === 'number' || typeof x !== typeof y) {
				throw new TypeError('SameValueNonNumber requires two non-number values of the same type.');
			}
			return this.SameValue(x, y);
		}
	});
	
	module.exports = ES2016;


/***/ }),
/* 2986 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var has = __webpack_require__(1726);
	var toPrimitive = __webpack_require__(2987);
	var keys = __webpack_require__(2995);
	
	var GetIntrinsic = __webpack_require__(2998);
	
	var $TypeError = GetIntrinsic('%TypeError%');
	var $SyntaxError = GetIntrinsic('%SyntaxError%');
	var $Array = GetIntrinsic('%Array%');
	var $String = GetIntrinsic('%String%');
	var $Object = GetIntrinsic('%Object%');
	var $Number = GetIntrinsic('%Number%');
	var $Symbol = GetIntrinsic('%Symbol%', true);
	var $RegExp = GetIntrinsic('%RegExp%');
	
	var hasSymbols = !!$Symbol;
	
	var assertRecord = __webpack_require__(2999);
	var $isNaN = __webpack_require__(3000);
	var $isFinite = __webpack_require__(3001);
	var MAX_SAFE_INTEGER = $Number.MAX_SAFE_INTEGER || Math.pow(2, 53) - 1;
	
	var assign = __webpack_require__(3002);
	var sign = __webpack_require__(3003);
	var mod = __webpack_require__(3004);
	var isPrimitive = __webpack_require__(3005);
	var parseInteger = parseInt;
	var bind = __webpack_require__(1727);
	var arraySlice = bind.call(Function.call, $Array.prototype.slice);
	var strSlice = bind.call(Function.call, $String.prototype.slice);
	var isBinary = bind.call(Function.call, $RegExp.prototype.test, /^0b[01]+$/i);
	var isOctal = bind.call(Function.call, $RegExp.prototype.test, /^0o[0-7]+$/i);
	var regexExec = bind.call(Function.call, $RegExp.prototype.exec);
	var nonWS = ['\u0085', '\u200b', '\ufffe'].join('');
	var nonWSregex = new $RegExp('[' + nonWS + ']', 'g');
	var hasNonWS = bind.call(Function.call, $RegExp.prototype.test, nonWSregex);
	var invalidHexLiteral = /^[-+]0x[0-9a-f]+$/i;
	var isInvalidHexLiteral = bind.call(Function.call, $RegExp.prototype.test, invalidHexLiteral);
	var $charCodeAt = bind.call(Function.call, $String.prototype.charCodeAt);
	
	var toStr = bind.call(Function.call, Object.prototype.toString);
	
	var $NumberValueOf = bind.call(Function.call, GetIntrinsic('%NumberPrototype%').valueOf);
	var $BooleanValueOf = bind.call(Function.call, GetIntrinsic('%BooleanPrototype%').valueOf);
	var $StringValueOf = bind.call(Function.call, GetIntrinsic('%StringPrototype%').valueOf);
	var $DateValueOf = bind.call(Function.call, GetIntrinsic('%DatePrototype%').valueOf);
	
	var $floor = Math.floor;
	var $abs = Math.abs;
	
	var $ObjectCreate = Object.create;
	var $gOPD = $Object.getOwnPropertyDescriptor;
	
	var $isExtensible = $Object.isExtensible;
	
	var $defineProperty = $Object.defineProperty;
	
	// whitespace from: http://es5.github.io/#x15.5.4.20
	// implementation from https://github.com/es-shims/es5-shim/blob/v3.4.0/es5-shim.js#L1304-L1324
	var ws = [
		'\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003',
		'\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028',
		'\u2029\uFEFF'
	].join('');
	var trimRegex = new RegExp('(^[' + ws + ']+)|([' + ws + ']+$)', 'g');
	var replace = bind.call(Function.call, $String.prototype.replace);
	var trim = function (value) {
		return replace(value, trimRegex, '');
	};
	
	var ES5 = __webpack_require__(3006);
	
	var hasRegExpMatcher = __webpack_require__(3008);
	
	// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-abstract-operations
	var ES6 = assign(assign({}, ES5), {
	
		// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-call-f-v-args
		Call: function Call(F, V) {
			var args = arguments.length > 2 ? arguments[2] : [];
			if (!this.IsCallable(F)) {
				throw new $TypeError(F + ' is not a function');
			}
			return F.apply(V, args);
		},
	
		// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-toprimitive
		ToPrimitive: toPrimitive,
	
		// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-toboolean
		// ToBoolean: ES5.ToBoolean,
	
		// https://ecma-international.org/ecma-262/6.0/#sec-tonumber
		ToNumber: function ToNumber(argument) {
			var value = isPrimitive(argument) ? argument : toPrimitive(argument, $Number);
			if (typeof value === 'symbol') {
				throw new $TypeError('Cannot convert a Symbol value to a number');
			}
			if (typeof value === 'string') {
				if (isBinary(value)) {
					return this.ToNumber(parseInteger(strSlice(value, 2), 2));
				} else if (isOctal(value)) {
					return this.ToNumber(parseInteger(strSlice(value, 2), 8));
				} else if (hasNonWS(value) || isInvalidHexLiteral(value)) {
					return NaN;
				} else {
					var trimmed = trim(value);
					if (trimmed !== value) {
						return this.ToNumber(trimmed);
					}
				}
			}
			return $Number(value);
		},
	
		// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-tointeger
		// ToInteger: ES5.ToNumber,
	
		// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-toint32
		// ToInt32: ES5.ToInt32,
	
		// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-touint32
		// ToUint32: ES5.ToUint32,
	
		// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-toint16
		ToInt16: function ToInt16(argument) {
			var int16bit = this.ToUint16(argument);
			return int16bit >= 0x8000 ? int16bit - 0x10000 : int16bit;
		},
	
		// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-touint16
		// ToUint16: ES5.ToUint16,
	
		// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-toint8
		ToInt8: function ToInt8(argument) {
			var int8bit = this.ToUint8(argument);
			return int8bit >= 0x80 ? int8bit - 0x100 : int8bit;
		},
	
		// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-touint8
		ToUint8: function ToUint8(argument) {
			var number = this.ToNumber(argument);
			if ($isNaN(number) || number === 0 || !$isFinite(number)) { return 0; }
			var posInt = sign(number) * $floor($abs(number));
			return mod(posInt, 0x100);
		},
	
		// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-touint8clamp
		ToUint8Clamp: function ToUint8Clamp(argument) {
			var number = this.ToNumber(argument);
			if ($isNaN(number) || number <= 0) { return 0; }
			if (number >= 0xFF) { return 0xFF; }
			var f = $floor(argument);
			if (f + 0.5 < number) { return f + 1; }
			if (number < f + 0.5) { return f; }
			if (f % 2 !== 0) { return f + 1; }
			return f;
		},
	
		// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-tostring
		ToString: function ToString(argument) {
			if (typeof argument === 'symbol') {
				throw new $TypeError('Cannot convert a Symbol value to a string');
			}
			return $String(argument);
		},
	
		// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-toobject
		ToObject: function ToObject(value) {
			this.RequireObjectCoercible(value);
			return $Object(value);
		},
	
		// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-topropertykey
		ToPropertyKey: function ToPropertyKey(argument) {
			var key = this.ToPrimitive(argument, $String);
			return typeof key === 'symbol' ? key : this.ToString(key);
		},
	
		// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-tolength
		ToLength: function ToLength(argument) {
			var len = this.ToInteger(argument);
			if (len <= 0) { return 0; } // includes converting -0 to +0
			if (len > MAX_SAFE_INTEGER) { return MAX_SAFE_INTEGER; }
			return len;
		},
	
		// https://ecma-international.org/ecma-262/6.0/#sec-canonicalnumericindexstring
		CanonicalNumericIndexString: function CanonicalNumericIndexString(argument) {
			if (toStr(argument) !== '[object String]') {
				throw new $TypeError('must be a string');
			}
			if (argument === '-0') { return -0; }
			var n = this.ToNumber(argument);
			if (this.SameValue(this.ToString(n), argument)) { return n; }
			return void 0;
		},
	
		// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-requireobjectcoercible
		RequireObjectCoercible: ES5.CheckObjectCoercible,
	
		// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-isarray
		IsArray: $Array.isArray || function IsArray(argument) {
			return toStr(argument) === '[object Array]';
		},
	
		// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-iscallable
		// IsCallable: ES5.IsCallable,
	
		// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-isconstructor
		IsConstructor: function IsConstructor(argument) {
			return typeof argument === 'function' && !!argument.prototype; // unfortunately there's no way to truly check this without try/catch `new argument`
		},
	
		// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-isextensible-o
		IsExtensible: Object.preventExtensions
			? function IsExtensible(obj) {
				if (isPrimitive(obj)) {
					return false;
				}
				return $isExtensible(obj);
			}
			: function isExtensible(obj) { return true; }, // eslint-disable-line no-unused-vars
	
		// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-isinteger
		IsInteger: function IsInteger(argument) {
			if (typeof argument !== 'number' || $isNaN(argument) || !$isFinite(argument)) {
				return false;
			}
			var abs = $abs(argument);
			return $floor(abs) === abs;
		},
	
		// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-ispropertykey
		IsPropertyKey: function IsPropertyKey(argument) {
			return typeof argument === 'string' || typeof argument === 'symbol';
		},
	
		// https://ecma-international.org/ecma-262/6.0/#sec-isregexp
		IsRegExp: function IsRegExp(argument) {
			if (!argument || typeof argument !== 'object') {
				return false;
			}
			if (hasSymbols) {
				var isRegExp = argument[$Symbol.match];
				if (typeof isRegExp !== 'undefined') {
					return ES5.ToBoolean(isRegExp);
				}
			}
			return hasRegExpMatcher(argument);
		},
	
		// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-samevalue
		// SameValue: ES5.SameValue,
	
		// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-samevaluezero
		SameValueZero: function SameValueZero(x, y) {
			return (x === y) || ($isNaN(x) && $isNaN(y));
		},
	
		/**
		 * 7.3.2 GetV (V, P)
		 * 1. Assert: IsPropertyKey(P) is true.
		 * 2. Let O be ToObject(V).
		 * 3. ReturnIfAbrupt(O).
		 * 4. Return O.[[Get]](P, V).
		 */
		GetV: function GetV(V, P) {
			// 7.3.2.1
			if (!this.IsPropertyKey(P)) {
				throw new $TypeError('Assertion failed: IsPropertyKey(P) is not true');
			}
	
			// 7.3.2.2-3
			var O = this.ToObject(V);
	
			// 7.3.2.4
			return O[P];
		},
	
		/**
		 * 7.3.9 - https://ecma-international.org/ecma-262/6.0/#sec-getmethod
		 * 1. Assert: IsPropertyKey(P) is true.
		 * 2. Let func be GetV(O, P).
		 * 3. ReturnIfAbrupt(func).
		 * 4. If func is either undefined or null, return undefined.
		 * 5. If IsCallable(func) is false, throw a TypeError exception.
		 * 6. Return func.
		 */
		GetMethod: function GetMethod(O, P) {
			// 7.3.9.1
			if (!this.IsPropertyKey(P)) {
				throw new $TypeError('Assertion failed: IsPropertyKey(P) is not true');
			}
	
			// 7.3.9.2
			var func = this.GetV(O, P);
	
			// 7.3.9.4
			if (func == null) {
				return void 0;
			}
	
			// 7.3.9.5
			if (!this.IsCallable(func)) {
				throw new $TypeError(P + 'is not a function');
			}
	
			// 7.3.9.6
			return func;
		},
	
		/**
		 * 7.3.1 Get (O, P) - https://ecma-international.org/ecma-262/6.0/#sec-get-o-p
		 * 1. Assert: Type(O) is Object.
		 * 2. Assert: IsPropertyKey(P) is true.
		 * 3. Return O.[[Get]](P, O).
		 */
		Get: function Get(O, P) {
			// 7.3.1.1
			if (this.Type(O) !== 'Object') {
				throw new $TypeError('Assertion failed: Type(O) is not Object');
			}
			// 7.3.1.2
			if (!this.IsPropertyKey(P)) {
				throw new $TypeError('Assertion failed: IsPropertyKey(P) is not true');
			}
			// 7.3.1.3
			return O[P];
		},
	
		Type: function Type(x) {
			if (typeof x === 'symbol') {
				return 'Symbol';
			}
			return ES5.Type(x);
		},
	
		// https://ecma-international.org/ecma-262/6.0/#sec-speciesconstructor
		SpeciesConstructor: function SpeciesConstructor(O, defaultConstructor) {
			if (this.Type(O) !== 'Object') {
				throw new $TypeError('Assertion failed: Type(O) is not Object');
			}
			var C = O.constructor;
			if (typeof C === 'undefined') {
				return defaultConstructor;
			}
			if (this.Type(C) !== 'Object') {
				throw new $TypeError('O.constructor is not an Object');
			}
			var S = hasSymbols && $Symbol.species ? C[$Symbol.species] : void 0;
			if (S == null) {
				return defaultConstructor;
			}
			if (this.IsConstructor(S)) {
				return S;
			}
			throw new $TypeError('no constructor found');
		},
	
		// https://ecma-international.org/ecma-262/6.0/#sec-completepropertydescriptor
		CompletePropertyDescriptor: function CompletePropertyDescriptor(Desc) {
			assertRecord(this, 'Property Descriptor', 'Desc', Desc);
	
			if (this.IsGenericDescriptor(Desc) || this.IsDataDescriptor(Desc)) {
				if (!has(Desc, '[[Value]]')) {
					Desc['[[Value]]'] = void 0;
				}
				if (!has(Desc, '[[Writable]]')) {
					Desc['[[Writable]]'] = false;
				}
			} else {
				if (!has(Desc, '[[Get]]')) {
					Desc['[[Get]]'] = void 0;
				}
				if (!has(Desc, '[[Set]]')) {
					Desc['[[Set]]'] = void 0;
				}
			}
			if (!has(Desc, '[[Enumerable]]')) {
				Desc['[[Enumerable]]'] = false;
			}
			if (!has(Desc, '[[Configurable]]')) {
				Desc['[[Configurable]]'] = false;
			}
			return Desc;
		},
	
		// https://ecma-international.org/ecma-262/6.0/#sec-set-o-p-v-throw
		Set: function Set(O, P, V, Throw) {
			if (this.Type(O) !== 'Object') {
				throw new $TypeError('O must be an Object');
			}
			if (!this.IsPropertyKey(P)) {
				throw new $TypeError('P must be a Property Key');
			}
			if (this.Type(Throw) !== 'Boolean') {
				throw new $TypeError('Throw must be a Boolean');
			}
			if (Throw) {
				O[P] = V;
				return true;
			} else {
				try {
					O[P] = V;
				} catch (e) {
					return false;
				}
			}
		},
	
		// https://ecma-international.org/ecma-262/6.0/#sec-hasownproperty
		HasOwnProperty: function HasOwnProperty(O, P) {
			if (this.Type(O) !== 'Object') {
				throw new $TypeError('O must be an Object');
			}
			if (!this.IsPropertyKey(P)) {
				throw new $TypeError('P must be a Property Key');
			}
			return has(O, P);
		},
	
		// https://ecma-international.org/ecma-262/6.0/#sec-hasproperty
		HasProperty: function HasProperty(O, P) {
			if (this.Type(O) !== 'Object') {
				throw new $TypeError('O must be an Object');
			}
			if (!this.IsPropertyKey(P)) {
				throw new $TypeError('P must be a Property Key');
			}
			return P in O;
		},
	
		// https://ecma-international.org/ecma-262/6.0/#sec-isconcatspreadable
		IsConcatSpreadable: function IsConcatSpreadable(O) {
			if (this.Type(O) !== 'Object') {
				return false;
			}
			if (hasSymbols && typeof $Symbol.isConcatSpreadable === 'symbol') {
				var spreadable = this.Get(O, Symbol.isConcatSpreadable);
				if (typeof spreadable !== 'undefined') {
					return this.ToBoolean(spreadable);
				}
			}
			return this.IsArray(O);
		},
	
		// https://ecma-international.org/ecma-262/6.0/#sec-invoke
		Invoke: function Invoke(O, P) {
			if (!this.IsPropertyKey(P)) {
				throw new $TypeError('P must be a Property Key');
			}
			var argumentsList = arraySlice(arguments, 2);
			var func = this.GetV(O, P);
			return this.Call(func, O, argumentsList);
		},
	
		// https://ecma-international.org/ecma-262/6.0/#sec-getiterator
		GetIterator: function GetIterator(obj, method) {
			if (!hasSymbols) {
				throw new SyntaxError('ES.GetIterator depends on native iterator support.');
			}
	
			var actualMethod = method;
			if (arguments.length < 2) {
				actualMethod = this.GetMethod(obj, $Symbol.iterator);
			}
			var iterator = this.Call(actualMethod, obj);
			if (this.Type(iterator) !== 'Object') {
				throw new $TypeError('iterator must return an object');
			}
	
			return iterator;
		},
	
		// https://ecma-international.org/ecma-262/6.0/#sec-iteratornext
		IteratorNext: function IteratorNext(iterator, value) {
			var result = this.Invoke(iterator, 'next', arguments.length < 2 ? [] : [value]);
			if (this.Type(result) !== 'Object') {
				throw new $TypeError('iterator next must return an object');
			}
			return result;
		},
	
		// https://ecma-international.org/ecma-262/6.0/#sec-iteratorcomplete
		IteratorComplete: function IteratorComplete(iterResult) {
			if (this.Type(iterResult) !== 'Object') {
				throw new $TypeError('Assertion failed: Type(iterResult) is not Object');
			}
			return this.ToBoolean(this.Get(iterResult, 'done'));
		},
	
		// https://ecma-international.org/ecma-262/6.0/#sec-iteratorvalue
		IteratorValue: function IteratorValue(iterResult) {
			if (this.Type(iterResult) !== 'Object') {
				throw new $TypeError('Assertion failed: Type(iterResult) is not Object');
			}
			return this.Get(iterResult, 'value');
		},
	
		// https://ecma-international.org/ecma-262/6.0/#sec-iteratorstep
		IteratorStep: function IteratorStep(iterator) {
			var result = this.IteratorNext(iterator);
			var done = this.IteratorComplete(result);
			return done === true ? false : result;
		},
	
		// https://ecma-international.org/ecma-262/6.0/#sec-iteratorclose
		IteratorClose: function IteratorClose(iterator, completion) {
			if (this.Type(iterator) !== 'Object') {
				throw new $TypeError('Assertion failed: Type(iterator) is not Object');
			}
			if (!this.IsCallable(completion)) {
				throw new $TypeError('Assertion failed: completion is not a thunk for a Completion Record');
			}
			var completionThunk = completion;
	
			var iteratorReturn = this.GetMethod(iterator, 'return');
	
			if (typeof iteratorReturn === 'undefined') {
				return completionThunk();
			}
	
			var completionRecord;
			try {
				var innerResult = this.Call(iteratorReturn, iterator, []);
			} catch (e) {
				// if we hit here, then "e" is the innerResult completion that needs re-throwing
	
				// if the completion is of type "throw", this will throw.
				completionRecord = completionThunk();
				completionThunk = null; // ensure it's not called twice.
	
				// if not, then return the innerResult completion
				throw e;
			}
			completionRecord = completionThunk(); // if innerResult worked, then throw if the completion does
			completionThunk = null; // ensure it's not called twice.
	
			if (this.Type(innerResult) !== 'Object') {
				throw new $TypeError('iterator .return must return an object');
			}
	
			return completionRecord;
		},
	
		// https://ecma-international.org/ecma-262/6.0/#sec-createiterresultobject
		CreateIterResultObject: function CreateIterResultObject(value, done) {
			if (this.Type(done) !== 'Boolean') {
				throw new $TypeError('Assertion failed: Type(done) is not Boolean');
			}
			return {
				value: value,
				done: done
			};
		},
	
		// https://ecma-international.org/ecma-262/6.0/#sec-regexpexec
		RegExpExec: function RegExpExec(R, S) {
			if (this.Type(R) !== 'Object') {
				throw new $TypeError('R must be an Object');
			}
			if (this.Type(S) !== 'String') {
				throw new $TypeError('S must be a String');
			}
			var exec = this.Get(R, 'exec');
			if (this.IsCallable(exec)) {
				var result = this.Call(exec, R, [S]);
				if (result === null || this.Type(result) === 'Object') {
					return result;
				}
				throw new $TypeError('"exec" method must return `null` or an Object');
			}
			return regexExec(R, S);
		},
	
		// https://ecma-international.org/ecma-262/6.0/#sec-arrayspeciescreate
		ArraySpeciesCreate: function ArraySpeciesCreate(originalArray, length) {
			if (!this.IsInteger(length) || length < 0) {
				throw new $TypeError('Assertion failed: length must be an integer >= 0');
			}
			var len = length === 0 ? 0 : length;
			var C;
			var isArray = this.IsArray(originalArray);
			if (isArray) {
				C = this.Get(originalArray, 'constructor');
				// TODO: figure out how to make a cross-realm normal Array, a same-realm Array
				// if (this.IsConstructor(C)) {
				// 	if C is another realm's Array, C = undefined
				// 	Object.getPrototypeOf(Object.getPrototypeOf(Object.getPrototypeOf(Array))) === null ?
				// }
				if (this.Type(C) === 'Object' && hasSymbols && $Symbol.species) {
					C = this.Get(C, $Symbol.species);
					if (C === null) {
						C = void 0;
					}
				}
			}
			if (typeof C === 'undefined') {
				return $Array(len);
			}
			if (!this.IsConstructor(C)) {
				throw new $TypeError('C must be a constructor');
			}
			return new C(len); // this.Construct(C, len);
		},
	
		CreateDataProperty: function CreateDataProperty(O, P, V) {
			if (this.Type(O) !== 'Object') {
				throw new $TypeError('Assertion failed: Type(O) is not Object');
			}
			if (!this.IsPropertyKey(P)) {
				throw new $TypeError('Assertion failed: IsPropertyKey(P) is not true');
			}
			var oldDesc = $gOPD(O, P);
			var extensible = oldDesc || (typeof $isExtensible !== 'function' || $isExtensible(O));
			var immutable = oldDesc && (!oldDesc.writable || !oldDesc.configurable);
			if (immutable || !extensible) {
				return false;
			}
			var newDesc = {
				configurable: true,
				enumerable: true,
				value: V,
				writable: true
			};
			$defineProperty(O, P, newDesc);
			return true;
		},
	
		// https://ecma-international.org/ecma-262/6.0/#sec-createdatapropertyorthrow
		CreateDataPropertyOrThrow: function CreateDataPropertyOrThrow(O, P, V) {
			if (this.Type(O) !== 'Object') {
				throw new $TypeError('Assertion failed: Type(O) is not Object');
			}
			if (!this.IsPropertyKey(P)) {
				throw new $TypeError('Assertion failed: IsPropertyKey(P) is not true');
			}
			var success = this.CreateDataProperty(O, P, V);
			if (!success) {
				throw new $TypeError('unable to create data property');
			}
			return success;
		},
	
		// https://www.ecma-international.org/ecma-262/6.0/#sec-objectcreate
		ObjectCreate: function ObjectCreate(proto, internalSlotsList) {
			if (proto !== null && this.Type(proto) !== 'Object') {
				throw new $TypeError('Assertion failed: proto must be null or an object');
			}
			var slots = arguments.length < 2 ? [] : internalSlotsList;
			if (slots.length > 0) {
				throw new $SyntaxError('es-abstract does not yet support internal slots');
			}
	
			if (proto === null && !$ObjectCreate) {
				throw new $SyntaxError('native Object.create support is required to create null objects');
			}
	
			return $ObjectCreate(proto);
		},
	
		// https://ecma-international.org/ecma-262/6.0/#sec-advancestringindex
		AdvanceStringIndex: function AdvanceStringIndex(S, index, unicode) {
			if (this.Type(S) !== 'String') {
				throw new $TypeError('S must be a String');
			}
			if (!this.IsInteger(index) || index < 0 || index > MAX_SAFE_INTEGER) {
				throw new $TypeError('Assertion failed: length must be an integer >= 0 and <= 2**53');
			}
			if (this.Type(unicode) !== 'Boolean') {
				throw new $TypeError('Assertion failed: unicode must be a Boolean');
			}
			if (!unicode) {
				return index + 1;
			}
			var length = S.length;
			if ((index + 1) >= length) {
				return index + 1;
			}
	
			var first = $charCodeAt(S, index);
			if (first < 0xD800 || first > 0xDBFF) {
				return index + 1;
			}
	
			var second = $charCodeAt(S, index + 1);
			if (second < 0xDC00 || second > 0xDFFF) {
				return index + 1;
			}
	
			return index + 2;
		},
	
		// https://www.ecma-international.org/ecma-262/6.0/#sec-createmethodproperty
		CreateMethodProperty: function CreateMethodProperty(O, P, V) {
			if (this.Type(O) !== 'Object') {
				throw new $TypeError('Assertion failed: Type(O) is not Object');
			}
	
			if (!this.IsPropertyKey(P)) {
				throw new $TypeError('Assertion failed: IsPropertyKey(P) is not true');
			}
	
			var newDesc = {
				configurable: true,
				enumerable: false,
				value: V,
				writable: true
			};
			return !!$defineProperty(O, P, newDesc);
		},
	
		// https://www.ecma-international.org/ecma-262/6.0/#sec-definepropertyorthrow
		DefinePropertyOrThrow: function DefinePropertyOrThrow(O, P, desc) {
			if (this.Type(O) !== 'Object') {
				throw new $TypeError('Assertion failed: Type(O) is not Object');
			}
	
			if (!this.IsPropertyKey(P)) {
				throw new $TypeError('Assertion failed: IsPropertyKey(P) is not true');
			}
	
			return !!$defineProperty(O, P, desc);
		},
	
		// https://www.ecma-international.org/ecma-262/6.0/#sec-deletepropertyorthrow
		DeletePropertyOrThrow: function DeletePropertyOrThrow(O, P) {
			if (this.Type(O) !== 'Object') {
				throw new $TypeError('Assertion failed: Type(O) is not Object');
			}
	
			if (!this.IsPropertyKey(P)) {
				throw new $TypeError('Assertion failed: IsPropertyKey(P) is not true');
			}
	
			var success = delete O[P];
			if (!success) {
				throw new TypeError('Attempt to delete property failed.');
			}
			return success;
		},
	
		// https://www.ecma-international.org/ecma-262/6.0/#sec-enumerableownnames
		EnumerableOwnNames: function EnumerableOwnNames(O) {
			if (this.Type(O) !== 'Object') {
				throw new $TypeError('Assertion failed: Type(O) is not Object');
			}
	
			return keys(O);
		},
	
		// https://ecma-international.org/ecma-262/6.0/#sec-properties-of-the-number-prototype-object
		thisNumberValue: function thisNumberValue(value) {
			if (this.Type(value) === 'Number') {
				return value;
			}
	
			return $NumberValueOf(value);
		},
	
		// https://ecma-international.org/ecma-262/6.0/#sec-properties-of-the-boolean-prototype-object
		thisBooleanValue: function thisBooleanValue(value) {
			if (this.Type(value) === 'Boolean') {
				return value;
			}
	
			return $BooleanValueOf(value);
		},
	
		// https://ecma-international.org/ecma-262/6.0/#sec-properties-of-the-string-prototype-object
		thisStringValue: function thisStringValue(value) {
			if (this.Type(value) === 'String') {
				return value;
			}
	
			return $StringValueOf(value);
		},
	
		// https://ecma-international.org/ecma-262/6.0/#sec-properties-of-the-date-prototype-object
		thisTimeValue: function thisTimeValue(value) {
			return $DateValueOf(value);
		}
	});
	
	delete ES6.CheckObjectCoercible; // renamed in ES6 to RequireObjectCoercible
	
	module.exports = ES6;


/***/ }),
/* 2987 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(2988);


/***/ }),
/* 2988 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var hasSymbols = typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol';
	
	var isPrimitive = __webpack_require__(2989);
	var isCallable = __webpack_require__(2990);
	var isDate = __webpack_require__(2991);
	var isSymbol = __webpack_require__(2992);
	
	var ordinaryToPrimitive = function OrdinaryToPrimitive(O, hint) {
		if (typeof O === 'undefined' || O === null) {
			throw new TypeError('Cannot call method on ' + O);
		}
		if (typeof hint !== 'string' || (hint !== 'number' && hint !== 'string')) {
			throw new TypeError('hint must be "string" or "number"');
		}
		var methodNames = hint === 'string' ? ['toString', 'valueOf'] : ['valueOf', 'toString'];
		var method, result, i;
		for (i = 0; i < methodNames.length; ++i) {
			method = O[methodNames[i]];
			if (isCallable(method)) {
				result = method.call(O);
				if (isPrimitive(result)) {
					return result;
				}
			}
		}
		throw new TypeError('No default value');
	};
	
	var GetMethod = function GetMethod(O, P) {
		var func = O[P];
		if (func !== null && typeof func !== 'undefined') {
			if (!isCallable(func)) {
				throw new TypeError(func + ' returned for property ' + P + ' of object ' + O + ' is not a function');
			}
			return func;
		}
		return void 0;
	};
	
	// http://www.ecma-international.org/ecma-262/6.0/#sec-toprimitive
	module.exports = function ToPrimitive(input) {
		if (isPrimitive(input)) {
			return input;
		}
		var hint = 'default';
		if (arguments.length > 1) {
			if (arguments[1] === String) {
				hint = 'string';
			} else if (arguments[1] === Number) {
				hint = 'number';
			}
		}
	
		var exoticToPrim;
		if (hasSymbols) {
			if (Symbol.toPrimitive) {
				exoticToPrim = GetMethod(input, Symbol.toPrimitive);
			} else if (isSymbol(input)) {
				exoticToPrim = Symbol.prototype.valueOf;
			}
		}
		if (typeof exoticToPrim !== 'undefined') {
			var result = exoticToPrim.call(input, hint);
			if (isPrimitive(result)) {
				return result;
			}
			throw new TypeError('unable to convert exotic object to primitive');
		}
		if (hint === 'default' && (isDate(input) || isSymbol(input))) {
			hint = 'string';
		}
		return ordinaryToPrimitive(input, hint === 'default' ? 'number' : hint);
	};


/***/ }),
/* 2989 */
/***/ (function(module, exports) {

	module.exports = function isPrimitive(value) {
		return value === null || (typeof value !== 'function' && typeof value !== 'object');
	};


/***/ }),
/* 2990 */
/***/ (function(module, exports) {

	'use strict';
	
	var fnToStr = Function.prototype.toString;
	
	var constructorRegex = /^\s*class\b/;
	var isES6ClassFn = function isES6ClassFunction(value) {
		try {
			var fnStr = fnToStr.call(value);
			return constructorRegex.test(fnStr);
		} catch (e) {
			return false; // not a function
		}
	};
	
	var tryFunctionObject = function tryFunctionToStr(value) {
		try {
			if (isES6ClassFn(value)) { return false; }
			fnToStr.call(value);
			return true;
		} catch (e) {
			return false;
		}
	};
	var toStr = Object.prototype.toString;
	var fnClass = '[object Function]';
	var genClass = '[object GeneratorFunction]';
	var hasToStringTag = typeof Symbol === 'function' && typeof Symbol.toStringTag === 'symbol';
	
	module.exports = function isCallable(value) {
		if (!value) { return false; }
		if (typeof value !== 'function' && typeof value !== 'object') { return false; }
		if (typeof value === 'function' && !value.prototype) { return true; }
		if (hasToStringTag) { return tryFunctionObject(value); }
		if (isES6ClassFn(value)) { return false; }
		var strClass = toStr.call(value);
		return strClass === fnClass || strClass === genClass;
	};


/***/ }),
/* 2991 */
/***/ (function(module, exports) {

	'use strict';
	
	var getDay = Date.prototype.getDay;
	var tryDateObject = function tryDateObject(value) {
		try {
			getDay.call(value);
			return true;
		} catch (e) {
			return false;
		}
	};
	
	var toStr = Object.prototype.toString;
	var dateClass = '[object Date]';
	var hasToStringTag = typeof Symbol === 'function' && typeof Symbol.toStringTag === 'symbol';
	
	module.exports = function isDateObject(value) {
		if (typeof value !== 'object' || value === null) { return false; }
		return hasToStringTag ? tryDateObject(value) : toStr.call(value) === dateClass;
	};


/***/ }),
/* 2992 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var toStr = Object.prototype.toString;
	var hasSymbols = __webpack_require__(2993)();
	
	if (hasSymbols) {
		var symToStr = Symbol.prototype.toString;
		var symStringRegex = /^Symbol\(.*\)$/;
		var isSymbolObject = function isRealSymbolObject(value) {
			if (typeof value.valueOf() !== 'symbol') {
				return false;
			}
			return symStringRegex.test(symToStr.call(value));
		};
	
		module.exports = function isSymbol(value) {
			if (typeof value === 'symbol') {
				return true;
			}
			if (toStr.call(value) !== '[object Symbol]') {
				return false;
			}
			try {
				return isSymbolObject(value);
			} catch (e) {
				return false;
			}
		};
	} else {
	
		module.exports = function isSymbol(value) {
			// this environment does not support Symbols.
			return false && value;
		};
	}


/***/ }),
/* 2993 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	var origSymbol = global.Symbol;
	var hasSymbolSham = __webpack_require__(2994);
	
	module.exports = function hasNativeSymbols() {
		if (typeof origSymbol !== 'function') { return false; }
		if (typeof Symbol !== 'function') { return false; }
		if (typeof origSymbol('foo') !== 'symbol') { return false; }
		if (typeof Symbol('bar') !== 'symbol') { return false; }
	
		return hasSymbolSham();
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 2994 */
/***/ (function(module, exports) {

	'use strict';
	
	/* eslint complexity: [2, 17], max-statements: [2, 33] */
	module.exports = function hasSymbols() {
		if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') { return false; }
		if (typeof Symbol.iterator === 'symbol') { return true; }
	
		var obj = {};
		var sym = Symbol('test');
		var symObj = Object(sym);
		if (typeof sym === 'string') { return false; }
	
		if (Object.prototype.toString.call(sym) !== '[object Symbol]') { return false; }
		if (Object.prototype.toString.call(symObj) !== '[object Symbol]') { return false; }
	
		// temp disabled per https://github.com/ljharb/object.assign/issues/17
		// if (sym instanceof Symbol) { return false; }
		// temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
		// if (!(symObj instanceof Symbol)) { return false; }
	
		// if (typeof Symbol.prototype.toString !== 'function') { return false; }
		// if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }
	
		var symVal = 42;
		obj[sym] = symVal;
		for (sym in obj) { return false; } // eslint-disable-line no-restricted-syntax
		if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) { return false; }
	
		if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) { return false; }
	
		var syms = Object.getOwnPropertySymbols(obj);
		if (syms.length !== 1 || syms[0] !== sym) { return false; }
	
		if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) { return false; }
	
		if (typeof Object.getOwnPropertyDescriptor === 'function') {
			var descriptor = Object.getOwnPropertyDescriptor(obj, sym);
			if (descriptor.value !== symVal || descriptor.enumerable !== true) { return false; }
		}
	
		return true;
	};


/***/ }),
/* 2995 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var slice = Array.prototype.slice;
	var isArgs = __webpack_require__(2996);
	
	var origKeys = Object.keys;
	var keysShim = origKeys ? function keys(o) { return origKeys(o); } : __webpack_require__(2997);
	
	var originalKeys = Object.keys;
	
	keysShim.shim = function shimObjectKeys() {
		if (Object.keys) {
			var keysWorksWithArguments = (function () {
				// Safari 5.0 bug
				var args = Object.keys(arguments);
				return args && args.length === arguments.length;
			}(1, 2));
			if (!keysWorksWithArguments) {
				Object.keys = function keys(object) { // eslint-disable-line func-name-matching
					if (isArgs(object)) {
						return originalKeys(slice.call(object));
					}
					return originalKeys(object);
				};
			}
		} else {
			Object.keys = keysShim;
		}
		return Object.keys || keysShim;
	};
	
	module.exports = keysShim;


/***/ }),
/* 2996 */
/***/ (function(module, exports) {

	'use strict';
	
	var toStr = Object.prototype.toString;
	
	module.exports = function isArguments(value) {
		var str = toStr.call(value);
		var isArgs = str === '[object Arguments]';
		if (!isArgs) {
			isArgs = str !== '[object Array]' &&
				value !== null &&
				typeof value === 'object' &&
				typeof value.length === 'number' &&
				value.length >= 0 &&
				toStr.call(value.callee) === '[object Function]';
		}
		return isArgs;
	};


/***/ }),
/* 2997 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var keysShim;
	if (!Object.keys) {
		// modified from https://github.com/es-shims/es5-shim
		var has = Object.prototype.hasOwnProperty;
		var toStr = Object.prototype.toString;
		var isArgs = __webpack_require__(2996); // eslint-disable-line global-require
		var isEnumerable = Object.prototype.propertyIsEnumerable;
		var hasDontEnumBug = !isEnumerable.call({ toString: null }, 'toString');
		var hasProtoEnumBug = isEnumerable.call(function () {}, 'prototype');
		var dontEnums = [
			'toString',
			'toLocaleString',
			'valueOf',
			'hasOwnProperty',
			'isPrototypeOf',
			'propertyIsEnumerable',
			'constructor'
		];
		var equalsConstructorPrototype = function (o) {
			var ctor = o.constructor;
			return ctor && ctor.prototype === o;
		};
		var excludedKeys = {
			$applicationCache: true,
			$console: true,
			$external: true,
			$frame: true,
			$frameElement: true,
			$frames: true,
			$innerHeight: true,
			$innerWidth: true,
			$outerHeight: true,
			$outerWidth: true,
			$pageXOffset: true,
			$pageYOffset: true,
			$parent: true,
			$scrollLeft: true,
			$scrollTop: true,
			$scrollX: true,
			$scrollY: true,
			$self: true,
			$webkitIndexedDB: true,
			$webkitStorageInfo: true,
			$window: true
		};
		var hasAutomationEqualityBug = (function () {
			/* global window */
			if (typeof window === 'undefined') { return false; }
			for (var k in window) {
				try {
					if (!excludedKeys['$' + k] && has.call(window, k) && window[k] !== null && typeof window[k] === 'object') {
						try {
							equalsConstructorPrototype(window[k]);
						} catch (e) {
							return true;
						}
					}
				} catch (e) {
					return true;
				}
			}
			return false;
		}());
		var equalsConstructorPrototypeIfNotBuggy = function (o) {
			/* global window */
			if (typeof window === 'undefined' || !hasAutomationEqualityBug) {
				return equalsConstructorPrototype(o);
			}
			try {
				return equalsConstructorPrototype(o);
			} catch (e) {
				return false;
			}
		};
	
		keysShim = function keys(object) {
			var isObject = object !== null && typeof object === 'object';
			var isFunction = toStr.call(object) === '[object Function]';
			var isArguments = isArgs(object);
			var isString = isObject && toStr.call(object) === '[object String]';
			var theKeys = [];
	
			if (!isObject && !isFunction && !isArguments) {
				throw new TypeError('Object.keys called on a non-object');
			}
	
			var skipProto = hasProtoEnumBug && isFunction;
			if (isString && object.length > 0 && !has.call(object, 0)) {
				for (var i = 0; i < object.length; ++i) {
					theKeys.push(String(i));
				}
			}
	
			if (isArguments && object.length > 0) {
				for (var j = 0; j < object.length; ++j) {
					theKeys.push(String(j));
				}
			} else {
				for (var name in object) {
					if (!(skipProto && name === 'prototype') && has.call(object, name)) {
						theKeys.push(String(name));
					}
				}
			}
	
			if (hasDontEnumBug) {
				var skipConstructor = equalsConstructorPrototypeIfNotBuggy(object);
	
				for (var k = 0; k < dontEnums.length; ++k) {
					if (!(skipConstructor && dontEnums[k] === 'constructor') && has.call(object, dontEnums[k])) {
						theKeys.push(dontEnums[k]);
					}
				}
			}
			return theKeys;
		};
	}
	module.exports = keysShim;


/***/ }),
/* 2998 */
/***/ (function(module, exports) {

	'use strict';
	
	/* globals
		Set,
		Map,
		WeakSet,
		WeakMap,
	
		Promise,
	
		Symbol,
		Proxy,
	
		Atomics,
		SharedArrayBuffer,
	
		ArrayBuffer,
		DataView,
		Uint8Array,
		Float32Array,
		Float64Array,
		Int8Array,
		Int16Array,
		Int32Array,
		Uint8ClampedArray,
		Uint16Array,
		Uint32Array,
	*/
	
	var undefined; // eslint-disable-line no-shadow-restricted-names
	
	var ThrowTypeError = Object.getOwnPropertyDescriptor
		? (function () { return Object.getOwnPropertyDescriptor(arguments, 'callee').get; }())
		: function () { throw new TypeError(); };
	
	var hasSymbols = typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol';
	
	var getProto = Object.getPrototypeOf || function (x) { return x.__proto__; }; // eslint-disable-line no-proto
	
	var generator; // = function * () {};
	var generatorFunction = generator ? getProto(generator) : undefined;
	var asyncFn; // async function() {};
	var asyncFunction = asyncFn ? asyncFn.constructor : undefined;
	var asyncGen; // async function * () {};
	var asyncGenFunction = asyncGen ? getProto(asyncGen) : undefined;
	var asyncGenIterator = asyncGen ? asyncGen() : undefined;
	
	var TypedArray = typeof Uint8Array === 'undefined' ? undefined : getProto(Uint8Array);
	
	var INTRINSICS = {
		'$ %Array%': Array,
		'$ %ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer,
		'$ %ArrayBufferPrototype%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer.prototype,
		'$ %ArrayIteratorPrototype%': hasSymbols ? getProto([][Symbol.iterator]()) : undefined,
		'$ %ArrayPrototype%': Array.prototype,
		'$ %ArrayProto_entries%': Array.prototype.entries,
		'$ %ArrayProto_forEach%': Array.prototype.forEach,
		'$ %ArrayProto_keys%': Array.prototype.keys,
		'$ %ArrayProto_values%': Array.prototype.values,
		'$ %AsyncFromSyncIteratorPrototype%': undefined,
		'$ %AsyncFunction%': asyncFunction,
		'$ %AsyncFunctionPrototype%': asyncFunction ? asyncFunction.prototype : undefined,
		'$ %AsyncGenerator%': asyncGen ? getProto(asyncGenIterator) : undefined,
		'$ %AsyncGeneratorFunction%': asyncGenFunction,
		'$ %AsyncGeneratorPrototype%': asyncGenFunction ? asyncGenFunction.prototype : undefined,
		'$ %AsyncIteratorPrototype%': asyncGenIterator && hasSymbols && Symbol.asyncIterator ? asyncGenIterator[Symbol.asyncIterator]() : undefined,
		'$ %Atomics%': typeof Atomics === 'undefined' ? undefined : Atomics,
		'$ %Boolean%': Boolean,
		'$ %BooleanPrototype%': Boolean.prototype,
		'$ %DataView%': typeof DataView === 'undefined' ? undefined : DataView,
		'$ %DataViewPrototype%': typeof DataView === 'undefined' ? undefined : DataView.prototype,
		'$ %Date%': Date,
		'$ %DatePrototype%': Date.prototype,
		'$ %decodeURI%': decodeURI,
		'$ %decodeURIComponent%': decodeURIComponent,
		'$ %encodeURI%': encodeURI,
		'$ %encodeURIComponent%': encodeURIComponent,
		'$ %Error%': Error,
		'$ %ErrorPrototype%': Error.prototype,
		'$ %eval%': eval, // eslint-disable-line no-eval
		'$ %EvalError%': EvalError,
		'$ %EvalErrorPrototype%': EvalError.prototype,
		'$ %Float32Array%': typeof Float32Array === 'undefined' ? undefined : Float32Array,
		'$ %Float32ArrayPrototype%': typeof Float32Array === 'undefined' ? undefined : Float32Array.prototype,
		'$ %Float64Array%': typeof Float64Array === 'undefined' ? undefined : Float64Array,
		'$ %Float64ArrayPrototype%': typeof Float64Array === 'undefined' ? undefined : Float64Array.prototype,
		'$ %Function%': Function,
		'$ %FunctionPrototype%': Function.prototype,
		'$ %Generator%': generator ? getProto(generator()) : undefined,
		'$ %GeneratorFunction%': generatorFunction,
		'$ %GeneratorPrototype%': generatorFunction ? generatorFunction.prototype : undefined,
		'$ %Int8Array%': typeof Int8Array === 'undefined' ? undefined : Int8Array,
		'$ %Int8ArrayPrototype%': typeof Int8Array === 'undefined' ? undefined : Int8Array.prototype,
		'$ %Int16Array%': typeof Int16Array === 'undefined' ? undefined : Int16Array,
		'$ %Int16ArrayPrototype%': typeof Int16Array === 'undefined' ? undefined : Int8Array.prototype,
		'$ %Int32Array%': typeof Int32Array === 'undefined' ? undefined : Int32Array,
		'$ %Int32ArrayPrototype%': typeof Int32Array === 'undefined' ? undefined : Int32Array.prototype,
		'$ %isFinite%': isFinite,
		'$ %isNaN%': isNaN,
		'$ %IteratorPrototype%': hasSymbols ? getProto(getProto([][Symbol.iterator]())) : undefined,
		'$ %JSON%': JSON,
		'$ %JSONParse%': JSON.parse,
		'$ %Map%': typeof Map === 'undefined' ? undefined : Map,
		'$ %MapIteratorPrototype%': typeof Map === 'undefined' || !hasSymbols ? undefined : getProto(new Map()[Symbol.iterator]()),
		'$ %MapPrototype%': typeof Map === 'undefined' ? undefined : Map.prototype,
		'$ %Math%': Math,
		'$ %Number%': Number,
		'$ %NumberPrototype%': Number.prototype,
		'$ %Object%': Object,
		'$ %ObjectPrototype%': Object.prototype,
		'$ %ObjProto_toString%': Object.prototype.toString,
		'$ %ObjProto_valueOf%': Object.prototype.valueOf,
		'$ %parseFloat%': parseFloat,
		'$ %parseInt%': parseInt,
		'$ %Promise%': typeof Promise === 'undefined' ? undefined : Promise,
		'$ %PromisePrototype%': typeof Promise === 'undefined' ? undefined : Promise.prototype,
		'$ %PromiseProto_then%': typeof Promise === 'undefined' ? undefined : Promise.prototype.then,
		'$ %Promise_all%': typeof Promise === 'undefined' ? undefined : Promise.all,
		'$ %Promise_reject%': typeof Promise === 'undefined' ? undefined : Promise.reject,
		'$ %Promise_resolve%': typeof Promise === 'undefined' ? undefined : Promise.resolve,
		'$ %Proxy%': typeof Proxy === 'undefined' ? undefined : Proxy,
		'$ %RangeError%': RangeError,
		'$ %RangeErrorPrototype%': RangeError.prototype,
		'$ %ReferenceError%': ReferenceError,
		'$ %ReferenceErrorPrototype%': ReferenceError.prototype,
		'$ %Reflect%': typeof Reflect === 'undefined' ? undefined : Reflect,
		'$ %RegExp%': RegExp,
		'$ %RegExpPrototype%': RegExp.prototype,
		'$ %Set%': typeof Set === 'undefined' ? undefined : Set,
		'$ %SetIteratorPrototype%': typeof Set === 'undefined' || !hasSymbols ? undefined : getProto(new Set()[Symbol.iterator]()),
		'$ %SetPrototype%': typeof Set === 'undefined' ? undefined : Set.prototype,
		'$ %SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer,
		'$ %SharedArrayBufferPrototype%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer.prototype,
		'$ %String%': String,
		'$ %StringIteratorPrototype%': hasSymbols ? getProto(''[Symbol.iterator]()) : undefined,
		'$ %StringPrototype%': String.prototype,
		'$ %Symbol%': hasSymbols ? Symbol : undefined,
		'$ %SymbolPrototype%': hasSymbols ? Symbol.prototype : undefined,
		'$ %SyntaxError%': SyntaxError,
		'$ %SyntaxErrorPrototype%': SyntaxError.prototype,
		'$ %ThrowTypeError%': ThrowTypeError,
		'$ %TypedArray%': TypedArray,
		'$ %TypedArrayPrototype%': TypedArray ? TypedArray.prototype : undefined,
		'$ %TypeError%': TypeError,
		'$ %TypeErrorPrototype%': TypeError.prototype,
		'$ %Uint8Array%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array,
		'$ %Uint8ArrayPrototype%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array.prototype,
		'$ %Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray,
		'$ %Uint8ClampedArrayPrototype%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray.prototype,
		'$ %Uint16Array%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array,
		'$ %Uint16ArrayPrototype%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array.prototype,
		'$ %Uint32Array%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array,
		'$ %Uint32ArrayPrototype%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array.prototype,
		'$ %URIError%': URIError,
		'$ %URIErrorPrototype%': URIError.prototype,
		'$ %WeakMap%': typeof WeakMap === 'undefined' ? undefined : WeakMap,
		'$ %WeakMapPrototype%': typeof WeakMap === 'undefined' ? undefined : WeakMap.prototype,
		'$ %WeakSet%': typeof WeakSet === 'undefined' ? undefined : WeakSet,
		'$ %WeakSetPrototype%': typeof WeakSet === 'undefined' ? undefined : WeakSet.prototype
	};
	
	module.exports = function GetIntrinsic(name, allowMissing) {
		if (arguments.length > 1 && typeof allowMissing !== 'boolean') {
			throw new TypeError('"allowMissing" argument must be a boolean');
		}
	
		var key = '$ ' + name;
		if (!(key in INTRINSICS)) {
			throw new SyntaxError('intrinsic ' + name + ' does not exist!');
		}
	
		// istanbul ignore if // hopefully this is impossible to test :-)
		if (typeof INTRINSICS[key] === 'undefined' && !allowMissing) {
			throw new TypeError('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
		}
		return INTRINSICS[key];
	};


/***/ }),
/* 2999 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var GetIntrinsic = __webpack_require__(2998);
	
	var $TypeError = GetIntrinsic('%TypeError%');
	var $SyntaxError = GetIntrinsic('%SyntaxError%');
	
	var has = __webpack_require__(1726);
	
	var predicates = {
	  // https://ecma-international.org/ecma-262/6.0/#sec-property-descriptor-specification-type
	  'Property Descriptor': function isPropertyDescriptor(ES, Desc) {
	    if (ES.Type(Desc) !== 'Object') {
	      return false;
	    }
	    var allowed = {
	      '[[Configurable]]': true,
	      '[[Enumerable]]': true,
	      '[[Get]]': true,
	      '[[Set]]': true,
	      '[[Value]]': true,
	      '[[Writable]]': true
	    };
	
	    for (var key in Desc) { // eslint-disable-line
	      if (has(Desc, key) && !allowed[key]) {
	        return false;
	      }
	    }
	
	    var isData = has(Desc, '[[Value]]');
	    var IsAccessor = has(Desc, '[[Get]]') || has(Desc, '[[Set]]');
	    if (isData && IsAccessor) {
	      throw new $TypeError('Property Descriptors may not be both accessor and data descriptors');
	    }
	    return true;
	  }
	};
	
	module.exports = function assertRecord(ES, recordType, argumentName, value) {
	  var predicate = predicates[recordType];
	  if (typeof predicate !== 'function') {
	    throw new $SyntaxError('unknown record type: ' + recordType);
	  }
	  if (!predicate(ES, value)) {
	    throw new $TypeError(argumentName + ' must be a ' + recordType);
	  }
	  console.log(predicate(ES, value), value);
	};


/***/ }),
/* 3000 */
/***/ (function(module, exports) {

	module.exports = Number.isNaN || function isNaN(a) {
		return a !== a;
	};


/***/ }),
/* 3001 */
/***/ (function(module, exports) {

	var $isNaN = Number.isNaN || function (a) { return a !== a; };
	
	module.exports = Number.isFinite || function (x) { return typeof x === 'number' && !$isNaN(x) && x !== Infinity && x !== -Infinity; };


/***/ }),
/* 3002 */
/***/ (function(module, exports, __webpack_require__) {

	var bind = __webpack_require__(1727);
	var has = bind.call(Function.call, Object.prototype.hasOwnProperty);
	
	var $assign = Object.assign;
	
	module.exports = function assign(target, source) {
		if ($assign) {
			return $assign(target, source);
		}
	
		for (var key in source) {
			if (has(source, key)) {
				target[key] = source[key];
			}
		}
		return target;
	};


/***/ }),
/* 3003 */
/***/ (function(module, exports) {

	module.exports = function sign(number) {
		return number >= 0 ? 1 : -1;
	};


/***/ }),
/* 3004 */
/***/ (function(module, exports) {

	module.exports = function mod(number, modulo) {
		var remain = number % modulo;
		return Math.floor(remain >= 0 ? remain : remain + modulo);
	};


/***/ }),
/* 3005 */
/***/ (function(module, exports) {

	module.exports = function isPrimitive(value) {
		return value === null || (typeof value !== 'function' && typeof value !== 'object');
	};


/***/ }),
/* 3006 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var GetIntrinsic = __webpack_require__(2998);
	
	var $Object = GetIntrinsic('%Object%');
	var $TypeError = GetIntrinsic('%TypeError%');
	var $String = GetIntrinsic('%String%');
	
	var assertRecord = __webpack_require__(2999);
	var $isNaN = __webpack_require__(3000);
	var $isFinite = __webpack_require__(3001);
	
	var sign = __webpack_require__(3003);
	var mod = __webpack_require__(3004);
	
	var IsCallable = __webpack_require__(2990);
	var toPrimitive = __webpack_require__(3007);
	
	var has = __webpack_require__(1726);
	
	// https://es5.github.io/#x9
	var ES5 = {
		ToPrimitive: toPrimitive,
	
		ToBoolean: function ToBoolean(value) {
			return !!value;
		},
		ToNumber: function ToNumber(value) {
			return +value; // eslint-disable-line no-implicit-coercion
		},
		ToInteger: function ToInteger(value) {
			var number = this.ToNumber(value);
			if ($isNaN(number)) { return 0; }
			if (number === 0 || !$isFinite(number)) { return number; }
			return sign(number) * Math.floor(Math.abs(number));
		},
		ToInt32: function ToInt32(x) {
			return this.ToNumber(x) >> 0;
		},
		ToUint32: function ToUint32(x) {
			return this.ToNumber(x) >>> 0;
		},
		ToUint16: function ToUint16(value) {
			var number = this.ToNumber(value);
			if ($isNaN(number) || number === 0 || !$isFinite(number)) { return 0; }
			var posInt = sign(number) * Math.floor(Math.abs(number));
			return mod(posInt, 0x10000);
		},
		ToString: function ToString(value) {
			return $String(value);
		},
		ToObject: function ToObject(value) {
			this.CheckObjectCoercible(value);
			return $Object(value);
		},
		CheckObjectCoercible: function CheckObjectCoercible(value, optMessage) {
			/* jshint eqnull:true */
			if (value == null) {
				throw new $TypeError(optMessage || 'Cannot call method on ' + value);
			}
			return value;
		},
		IsCallable: IsCallable,
		SameValue: function SameValue(x, y) {
			if (x === y) { // 0 === -0, but they are not identical.
				if (x === 0) { return 1 / x === 1 / y; }
				return true;
			}
			return $isNaN(x) && $isNaN(y);
		},
	
		// https://www.ecma-international.org/ecma-262/5.1/#sec-8
		Type: function Type(x) {
			if (x === null) {
				return 'Null';
			}
			if (typeof x === 'undefined') {
				return 'Undefined';
			}
			if (typeof x === 'function' || typeof x === 'object') {
				return 'Object';
			}
			if (typeof x === 'number') {
				return 'Number';
			}
			if (typeof x === 'boolean') {
				return 'Boolean';
			}
			if (typeof x === 'string') {
				return 'String';
			}
		},
	
		// https://ecma-international.org/ecma-262/6.0/#sec-property-descriptor-specification-type
		IsPropertyDescriptor: function IsPropertyDescriptor(Desc) {
			if (this.Type(Desc) !== 'Object') {
				return false;
			}
			var allowed = {
				'[[Configurable]]': true,
				'[[Enumerable]]': true,
				'[[Get]]': true,
				'[[Set]]': true,
				'[[Value]]': true,
				'[[Writable]]': true
			};
	
			for (var key in Desc) { // eslint-disable-line
				if (has(Desc, key) && !allowed[key]) {
					return false;
				}
			}
	
			var isData = has(Desc, '[[Value]]');
			var IsAccessor = has(Desc, '[[Get]]') || has(Desc, '[[Set]]');
			if (isData && IsAccessor) {
				throw new $TypeError('Property Descriptors may not be both accessor and data descriptors');
			}
			return true;
		},
	
		// https://ecma-international.org/ecma-262/5.1/#sec-8.10.1
		IsAccessorDescriptor: function IsAccessorDescriptor(Desc) {
			if (typeof Desc === 'undefined') {
				return false;
			}
	
			assertRecord(this, 'Property Descriptor', 'Desc', Desc);
	
			if (!has(Desc, '[[Get]]') && !has(Desc, '[[Set]]')) {
				return false;
			}
	
			return true;
		},
	
		// https://ecma-international.org/ecma-262/5.1/#sec-8.10.2
		IsDataDescriptor: function IsDataDescriptor(Desc) {
			if (typeof Desc === 'undefined') {
				return false;
			}
	
			assertRecord(this, 'Property Descriptor', 'Desc', Desc);
	
			if (!has(Desc, '[[Value]]') && !has(Desc, '[[Writable]]')) {
				return false;
			}
	
			return true;
		},
	
		// https://ecma-international.org/ecma-262/5.1/#sec-8.10.3
		IsGenericDescriptor: function IsGenericDescriptor(Desc) {
			if (typeof Desc === 'undefined') {
				return false;
			}
	
			assertRecord(this, 'Property Descriptor', 'Desc', Desc);
	
			if (!this.IsAccessorDescriptor(Desc) && !this.IsDataDescriptor(Desc)) {
				return true;
			}
	
			return false;
		},
	
		// https://ecma-international.org/ecma-262/5.1/#sec-8.10.4
		FromPropertyDescriptor: function FromPropertyDescriptor(Desc) {
			if (typeof Desc === 'undefined') {
				return Desc;
			}
	
			assertRecord(this, 'Property Descriptor', 'Desc', Desc);
	
			if (this.IsDataDescriptor(Desc)) {
				return {
					value: Desc['[[Value]]'],
					writable: !!Desc['[[Writable]]'],
					enumerable: !!Desc['[[Enumerable]]'],
					configurable: !!Desc['[[Configurable]]']
				};
			} else if (this.IsAccessorDescriptor(Desc)) {
				return {
					get: Desc['[[Get]]'],
					set: Desc['[[Set]]'],
					enumerable: !!Desc['[[Enumerable]]'],
					configurable: !!Desc['[[Configurable]]']
				};
			} else {
				throw new $TypeError('FromPropertyDescriptor must be called with a fully populated Property Descriptor');
			}
		},
	
		// https://ecma-international.org/ecma-262/5.1/#sec-8.10.5
		ToPropertyDescriptor: function ToPropertyDescriptor(Obj) {
			if (this.Type(Obj) !== 'Object') {
				throw new $TypeError('ToPropertyDescriptor requires an object');
			}
	
			var desc = {};
			if (has(Obj, 'enumerable')) {
				desc['[[Enumerable]]'] = this.ToBoolean(Obj.enumerable);
			}
			if (has(Obj, 'configurable')) {
				desc['[[Configurable]]'] = this.ToBoolean(Obj.configurable);
			}
			if (has(Obj, 'value')) {
				desc['[[Value]]'] = Obj.value;
			}
			if (has(Obj, 'writable')) {
				desc['[[Writable]]'] = this.ToBoolean(Obj.writable);
			}
			if (has(Obj, 'get')) {
				var getter = Obj.get;
				if (typeof getter !== 'undefined' && !this.IsCallable(getter)) {
					throw new TypeError('getter must be a function');
				}
				desc['[[Get]]'] = getter;
			}
			if (has(Obj, 'set')) {
				var setter = Obj.set;
				if (typeof setter !== 'undefined' && !this.IsCallable(setter)) {
					throw new $TypeError('setter must be a function');
				}
				desc['[[Set]]'] = setter;
			}
	
			if ((has(desc, '[[Get]]') || has(desc, '[[Set]]')) && (has(desc, '[[Value]]') || has(desc, '[[Writable]]'))) {
				throw new $TypeError('Invalid property descriptor. Cannot both specify accessors and a value or writable attribute');
			}
			return desc;
		}
	};
	
	module.exports = ES5;


/***/ }),
/* 3007 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var toStr = Object.prototype.toString;
	
	var isPrimitive = __webpack_require__(2989);
	
	var isCallable = __webpack_require__(2990);
	
	// http://ecma-international.org/ecma-262/5.1/#sec-8.12.8
	var ES5internalSlots = {
		'[[DefaultValue]]': function (O) {
			var actualHint;
			if (arguments.length > 1) {
				actualHint = arguments[1];
			} else {
				actualHint = toStr.call(O) === '[object Date]' ? String : Number;
			}
	
			if (actualHint === String || actualHint === Number) {
				var methods = actualHint === String ? ['toString', 'valueOf'] : ['valueOf', 'toString'];
				var value, i;
				for (i = 0; i < methods.length; ++i) {
					if (isCallable(O[methods[i]])) {
						value = O[methods[i]]();
						if (isPrimitive(value)) {
							return value;
						}
					}
				}
				throw new TypeError('No default value');
			}
			throw new TypeError('invalid [[DefaultValue]] hint supplied');
		}
	};
	
	// http://ecma-international.org/ecma-262/5.1/#sec-9.1
	module.exports = function ToPrimitive(input) {
		if (isPrimitive(input)) {
			return input;
		}
		if (arguments.length > 1) {
			return ES5internalSlots['[[DefaultValue]]'](input, arguments[1]);
		}
		return ES5internalSlots['[[DefaultValue]]'](input);
	};


/***/ }),
/* 3008 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var has = __webpack_require__(1726);
	var regexExec = RegExp.prototype.exec;
	var gOPD = Object.getOwnPropertyDescriptor;
	
	var tryRegexExecCall = function tryRegexExec(value) {
		try {
			var lastIndex = value.lastIndex;
			value.lastIndex = 0;
	
			regexExec.call(value);
			return true;
		} catch (e) {
			return false;
		} finally {
			value.lastIndex = lastIndex;
		}
	};
	var toStr = Object.prototype.toString;
	var regexClass = '[object RegExp]';
	var hasToStringTag = typeof Symbol === 'function' && typeof Symbol.toStringTag === 'symbol';
	
	module.exports = function isRegex(value) {
		if (!value || typeof value !== 'object') {
			return false;
		}
		if (!hasToStringTag) {
			return toStr.call(value) === regexClass;
		}
	
		var descriptor = gOPD(value, 'lastIndex');
		var hasLastIndexDataProperty = descriptor && has(descriptor, 'value');
		if (!hasLastIndexDataProperty) {
			return false;
		}
	
		return tryRegexExecCall(value);
	};


/***/ }),
/* 3009 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var requirePromise = __webpack_require__(2983);
	
	var implementation = __webpack_require__(2982);
	
	module.exports = function getPolyfill() {
		requirePromise();
		return typeof Promise.prototype['finally'] === 'function' ? Promise.prototype['finally'] : implementation;
	};


/***/ }),
/* 3010 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var requirePromise = __webpack_require__(2983);
	
	var getPolyfill = __webpack_require__(3009);
	var define = __webpack_require__(2978);
	
	module.exports = function shimPromiseFinally() {
		requirePromise();
	
		var polyfill = getPolyfill();
		define(Promise.prototype, { 'finally': polyfill }, {
			'finally': function testFinally() {
				return Promise.prototype['finally'] !== polyfill;
			}
		});
		return polyfill;
	};


/***/ })
/******/ ]);


// WEBPACK FOOTER //
// global.05e4cc9a8d0bf1db4b93.js